(function () {

  'use strict';

  angular.isUndefinedOrNull = angular.isUndefinedOrNull || function (val) {
      return angular.isUndefined(val) || val === null;
    };

  angular.stringContains = angular.stringContains || function (string, val) {
      return string.indexOf(val) !== -1;
    };

})();
////////////////////////////
////////////////////////////
////////////////////////////
////////////////////////////
// UTE-UI JQuery extension
////////////////////////////
(function () {

  'use strict';

  if (typeof $.prototype.hasAttr === 'undefined') {
    $.prototype.hasAttr = function (attrName) {
      return this.attr(attrName) !== null && this.attr(attrName) !== undefined;
    };
  }

})();
////////////////////////////
////////////////////////////
////////////////////////////
////////////////////////////
// UTE-UI JQuery extension
////////////////////////////
(function () {

  'use strict';

  String.prototype.toCamelCase = function () {
    return this.replace(/^([A-Z])|\s(\w)/g, function (match, p1, p2, offset) {
      if (p2) return p2.toUpperCase();
      return p1.toLowerCase();
    });
  };

})();
////////////////////////////
////////////////////////////
////////////////////////////
(function () {

  /**
   * @name ute-ui
   * @version 0.7.13
   * @namespace ute-ui
   */

  'use strict';

  angular.module('ute.ui.content', ['pascalprecht.translate', 'ngCookies']);

  angular.module('ute.ui.core', [
    'ute.ui.content',
    'tmh.dynamicLocale'
  ]).constant('moment', moment);

})();

(function () {

  'use strict';

  /**
   * @author Ronald Nicholls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui.content')

  /**
   * @class ute-ui.content.uteContentInjector
   */
    .directive('uteContentInjector',
      ['$rootScope',
        '$templateCache',
        'uteContentLoader',
        '$cookies',
        'uteLocale',
        function ($rootScope, $templateCache, uteContentLoader, $cookies, uteLocale) {

          return {
            scope: {
              localContentId: '@',
              contentId: '@',
              compile: '=',
              province: '@',
              language: '@'
            },
            replace: true,
            restrict: 'EA',
            controller: ['$scope', '$element', function ($scope, $element) {

              /**
               * @description toggle for showing meta data for developer purposes
               * @name metaShown
               * @memberOf ute-ui.content.uteContentInjector
               */
              var metaShown = false;

              /**
               * @description toggle hidden dev divs and displays metadata after user clicks hidden cms-metadata-toggle div
               * @name displayMetadata
               * @memberOf ute-ui.content.uteContentInjector
               */
              var displayMetadata = function () {

                metaShown = !metaShown;
                var settings = {
                  scope: $scope,
                  element: $element,
                  method: 'GET',
                  dataType: 'json',
                  fileType: '.json',
                  contentId: $scope.contentId,
                  compile: angular.isDefined($scope.compile) && $scope.compile || false,
                  language: $scope.language || uteLocale.language(),
                  province: $scope.province || uteLocale.province(),
                  localContentId: $scope.localContentId
                };

                metaShown ? uteContentLoader.makeRequest(settings) : $element.children().children()[0].remove();

              };

              /**
               * @description add and removed active from cms-metadata div
               * @name metadataActive
               * @memberOf ute-ui.content.uteContentInjector
               */
              var metadataActive = function () {
                $(this).toggleClass('active');
              };

              /**
               * @description inits the directive
               * @name init
               * @memberOf ute-ui.content.uteContentInjector
               */
              var init = function () {

                $('ins').off().on('click', '.cms-metadata', metadataActive);

                $element.addClass('preloader loading');

                if (!$rootScope.ute) {
                  $rootScope.ute = {
                    language: 'en',
                    province: 'on'
                  };
                }

                makeRequest();

                //TODO - change .bind to .on method
                angular.element(document.getElementById('cms-metadata-toggle')).bind('click', displayMetadata);

              };

              /**
               * @description makes http request, also called by watcher
               * @name makeRequest
               * @memberOf ute-ui.content.uteContentInjector
               */
              var makeRequest = function () {

                var settings = {
                  scope: $scope,
                  element: $element,
                  method: 'GET',
                  dataType: 'html',
                  fileType: '.html',
                  contentId: $scope.contentId,
                  compile: angular.isDefined($scope.compile) && $scope.compile || false,
                  language: $scope.language || uteLocale.language(),
                  province: $scope.province || uteLocale.province() || $cookies.get('province') || 'on',
                  localContentId: $scope.localContentId
                };

                uteContentLoader.makeRequest(settings);

              };

              /**
               * @description checks to see if new values are different from the old values then makes an http request again
               * @name metaShown
               * @param oldValue
               * @param newValue
               * @memberOf ute-ui.content.uteContentInjector
               */
              var update = function (oldValue, newValue) {
                if ((angular.isUndefinedOrNull(newValue)) || oldValue !== newValue) {
                  makeRequest();
                }
              };

              init();

              $scope.$watch('language', update);
              $scope.$watch('province', update);
              $scope.$watch('contentId', update);


            }]

          };

        }]);

})();

(function () {

  'use strict';

  /**
   * @author Ronald Nicolls | Chester Rivas
   * @class ute-ui.content
   * @memberOf ute-ui
   */
  angular.module('ute.ui.content')

  /**
   * @class ute-ui.content.uteContentLoader
   */
    .factory('uteContentLoader', ['$http', 'uteEndpoint', '$compile', 'moment', function ($http, uteEndpoint, $compile, moment) {

      /**
       * @name uteContentLoader
       * @type {object}
       * @memberOf ute-ui.content
       */
      var uteContentLoader = {};

      /**
       * @property uteContentLoader.contentObjects
       * @type {array}
       * @memberOf ute-ui.content.uteContentLoader
       * @description holds each instance of the directive that calls the makeRequest method, using to loop through and match after loading content
       */
      uteContentLoader.contentObjects = [];

      /**
       * @property uteContentLoader.localizedUrl
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description returns a string with the language and province appended
       * @param config - object containing language and province
       * @returns {string}
       */
      uteContentLoader.localizedUrl = function (config) {
        var contentId = config.localContentId || config.contentId;
        var seperator = contentId.indexOf('intergration') === -1 ? '_' : '-';
        return contentId + seperator + config.language + seperator + config.province;
      };

      /**
       * @property uteContentLoader.unescapeHTML
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description converts ascii/html characters to < > characters, also replaces ampersands and a specific pattenr of double quotes
       * @param escapedHTML - string to convert
       * @returns {string}
       */
      uteContentLoader.unescapeHTML = function (escapedHTML) {
        return escapedHTML.replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/\\"/g, '"');
      };

      /**
       * @name onCMSLoadSuccess
       * @property uteContentLoader.onCMSLoadSuccess
       * @type {function}
       * @memberOf ute-ui.content.uteContentLoader
       * @description callback for CMS loading success
       * @param {object} currentContentObj - config object
       * @param {object} result - data containing html markup
       */
      uteContentLoader.onCMSLoadSuccess = function (currentContentObj, result) {

        var convertedHTML,
          matchedContent = null;

        // loop through contents object array and find the matching content and it's config object
        _.some(uteContentLoader.contentObjects, function (eachContent) {

          return currentContentObj.rid === eachContent.rid && currentContentObj.element === eachContent.element && (matchedContent = currentContentObj);

        });

        if (matchedContent === null) throw new Error('uteContentLoader error "matchedContent" was not defined');

        // if attribute option compile is set to true then compile the markup
        if (matchedContent.compile) {

          // convert the markup into valid HTML
          //convertedHTML = matchedContent.element.html(result.data).text();

          // populate that markup into the html
          matchedContent.element.html(result.data);

          // compile only the inner markup so there's no recursive loop
          //$compile($element.children().first())($scope.$parent);
          $compile(matchedContent.element.contents())(matchedContent.scope.$parent);

        } else if (matchedContent.fileType === '.json') {

          /*jshint camelcase: false */
          matchedContent.element.children().prepend('<div class="cms-metadata"><span class="content-url">' + uteContentLoader.path.replace('.json', '.html') +
            '</span><span class="edit-date">' + moment().format('MMMM Do YYYY, h:mm:ss a', result.data.editDate) + '</span><span class="version">' +
            result.data.version + '</span><span class="is-published">' + result.data.is_active + '</span><span class="content-edit-url"><a href="' +
            result.data.cmsContentURL + '" target="_blank">Edit</a></span></div>');

        } else {

          convertedHTML = uteContentLoader.unescapeHTML(result.data);
          matchedContent.element.html(convertedHTML);

        }

        matchedContent.element.removeClass('preloader loading');

      };

      /**
       * @property uteContentLoader.onCMSLoadError
       * @type function
       * @description callback for CMS loading error error
       * @memberOf ute-ui.content.uteContentLoader
       * @param {HTMLElement} currentContentObj - config object
       */
      uteContentLoader.onCMSLoadError = function (currentContentObj) {
        var placeholder = '<div class="col-xs-12 cms-content" style="background-color: #f5f5f5; text-align:center; margin-bottom:25px; margin-top:25px; border:1px dashed #ccc; padding:10px;"><span id="cms-header" style="text-align:center; color:#999;">' + uteContentLoader.localizedUrl(currentContentObj) + currentContentObj.fileType + '</span></div>';
        currentContentObj.element.removeClass('preloader loading');
        currentContentObj.element.html(placeholder);
      };

      /**
       * @property uteContentLoader.setOptions
       * @type {function}
       * @description sets all the default options before making the $http request
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} config - config object
       * @property {object} config.scope - scope of the directive
       * @property {string} config.contentId - the id/path to a CMS view from teamsite
       * @property {boolean} config.compile - to compile html string as angular binded markup
       * @property {string} config.language - language en or fr
       * @property {string} config.province - a province
       * @property {string} config.localContentId - the id/path to a local view, used for dev purposes
       */
      uteContentLoader.setOptions = function (config) {

        config.rid = Math.round(Math.random() * 1000);
        config.localContentId = angular.isDefined(config.localContentId) ? uteContentLoader.localizedUrl(config) + '.html' : undefined;

        // push processed object into array
        uteContentLoader.contentObjects.push(config);

        return config;

      };

      /**
       * @property uteContentLoader.makeRequest
       * @type {function}
       * @description make $http request to retrieve content of either html or json file
       * @memberOf ute-ui.content.uteContentLoader
       * @param {object} configObj - object which contains all the data associated with request
       */
      uteContentLoader.makeRequest = function (configObj) {

        // save current config object and push to array
        // returns object with rid defined
        var config = uteContentLoader.setOptions(configObj);

        config.fileType = config.contentId.indexOf('intergration') === -1 ? config.fileType : '.xml';

        //Take parts of configObj.contentId and remove trailing content id after final /
        var parts = config.contentId.split('/'),
          removedContentId = config.contentId.replace(parts[parts.length - 1], '');

        // Use full config.contentId if dateType is html, if dataType is json reform the $scope.contentId to have json subfolder added to it
        config.contentId = config.dataType === 'json' ? removedContentId + '/json/' + parts[parts.length - 1] : config.contentId;

        uteContentLoader.path = uteContentLoader.localizedUrl(config) + config.fileType;

        $http({
          method: config.method,
          dataType: config.dataType,
          url: config.localContentId || uteEndpoint(uteContentLoader.path, 'cms')
        }).then(uteContentLoader.onCMSLoadSuccess.bind(uteContentLoader, config), uteContentLoader.onCMSLoadError.bind(uteContentLoader, config));

      };

      return uteContentLoader;

    }]);

})();

(function () {

  'use strict';

  /**
   * @author - Ronald Nicholls
   * @class ute-ui.core
   * @memberOf ute-ui
   */
  angular.module('ute.ui.core')

  /**
   * factory for unifying the logic for getting language and province based on $rootScope object rui or ute or cookies
   */
    .factory('uteLocale', ['$rootScope', '$cookies', function ($rootScope, $cookies) {

      var ute = {},
        language,
        province;

      ute.language = function () {

        if (typeof $rootScope.rui !== 'undefined' && typeof $rootScope.rui.language !== 'undefined') {
          language = $rootScope.rui.language;
        } else if (typeof $rootScope.ute !== 'undefined' && typeof $rootScope.ute.language !== 'undefined') {
          language = $rootScope.ute.language;
        } else if (typeof $cookies !== 'undefined' && typeof $cookies.get('language') !== 'undefined') {
          language = $cookies.get('language');
        } else {
          language = 'en';
        }

        return language;


      };

      ute.province = function () {
        if (typeof $rootScope.rui !== 'undefined' && typeof $rootScope.rui.province !== 'undefined') {
          province = $rootScope.rui.province;
        } else if (typeof $rootScope.ute !== 'undefined' && typeof $rootScope.ute.province !== 'undefined') {
          province = $rootScope.ute.province;
        } else if (typeof $cookies !== 'undefined' && typeof $cookies.get('province') !== 'undefined') {
          province = $cookies.get('province');
        } else {
          province = 'on';
        }

        return province;

      };

      return ute;
    }]);

})();

(function () {

  /**
   * @ngdoc service
   * @name uteEndpoint
   * @param key Endpoint key name to generate a complete url
   * @description
   *   Returns endpoint url for http(s) services
   *
   * Requirements;
   *
   *   Input/Configuration/Parameter;
   *
   *     . MUST be able to configure `baseUrl`
   *     . MUST be able to configure `basePath`
   *     . MUST be able to configure keys to override the default behaviour
   *
   *   Output
   *
   *     . MUST return complete url starting from http, https, or //
   *
   * @example
   * <script>
   *   app.config(function(uteEndpointProvider) {
 *     uteEndpointProvider.setBaseUrl("http://base.url.com");
 *     uteEndpointProvider.setBasePath("/base/path");
 *     uteEndpointProvider.setEndpoints({
 *       'custom1': "http://custom.com/foo",
 *       'custom2': "/foo/bar",
 *       'custom3': "bar",
 *     });
 *     uteEndpointProvider.set('custom4', "http://custom.com/bar");
 *   });
   *
   *  app.controller('MyCtrl', function($scope, uteEndpoint) {
 *    uteEndpoint("foo");     // http://base.url.com/base/path/foo
 *    uteEndpoint("bar");     // http://base.url.com/base/path/bar
 *    uteEndpoint("/foo");    // http://base.url.com/foo
 *    uteEndpoint("custom1"); // http://custom.com/foo
 *    uteEndpoint("custom2"); // http://base.url.com/foo/bar
 *    uteEndpoint("custom3"); // http://base.url.com/base/path/bar
 *    uteEndpoint("custom4"); // http://custom.com/bar
 *  });
   * </script>
   */

  'use strict';

  /**
   * @ngdoc provider
   * @name uteEndpointProvider
   * @description  uteEndpoint configuration object
   */
  angular.module('ute.ui.core')

    .provider('uteEndpoint', function () {
      this.baseUrl = '';
      this.basePath = '';
      this.cmsContentURL = '';
      this.endpoints = {};

      /**
       * set cms content url
       */
      this.setCMSContentURL = function (url) {
        this.cmsContentURL = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set all options
       * @param {Object} options
       * @example
       *   uteEndpointProvider.configure({baseUrl:"http://foo.com", basePath: "/bar"});
       */
      this.configure = function (options) {
        this.baseUrl = options.baseUrl;
        this.basePath = options.basePath;
        this.endpoints = options.endpoints;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set base url
       * @param {String} url
       * @example
       *   uteEndpointProvider.setBaseUrl("http://foo.com");
       */
      this.setBaseUrl = function (url) {
        this.baseUrl = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set base path
       * @param {String} path
       * @example
       *   uteEndpointProvider.setBasePath("/bar");
       */
      this.setBasePath = function (path) {
        this.basePath = path;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set all custom endpoints to override the default behaviour
       * @param {Object}  endpoints object with key/value
       * @example
       *   uteEndpointProvider.setEndpoints({foo:"/foo", bar: "https://foo.com/bar"});
       */
      this.setEndpoints = function (endpoints) {
        this.endpoints = endpoints;
      };

      // set cms content url
      this.setCMSContentURL = function (url) {
        this.cmsContentURL = url;
      };

      /**
       * @memberof uteEndpointProvider
       * @description set a single custom endpoint to override the default behaviour
       * @param key key of endpoint, i.e. 'myurl"
       * @param url url, i.e. 'https://my.custom.com/url/endpoint"
       * @example
       *   uteEndpointProvider.set("foo", "https://foo.com/bar");
       */
      this.set = function (key, url) {
        this.endpoints[key] = url;
      };

      this.$get = function () {
        var _this = this;
        return function (key, typeOfEndpoint) {

          // if it's a cms call
          if (typeOfEndpoint && typeOfEndpoint === 'cms') {
            if (!_this.cmsContentURL) {
              _this.cmsContentURL = _this.baseUrl;
            }
            return _this.cmsContentURL + key;
          }

          // not a cms call
          if (_this.endpoints[key]) {
            var url = _this.endpoints[key];
            if (url.match(/^http/)) {
              return url;
            } else if (url.match(/^\//)) {
              return _this.baseUrl + url;
            } else {
              return _this.baseUrl + _this.basePath + '/' + url;
            }
          } else if (key.match(/^\//)) {
            return _this.baseUrl + key;
          } else {
            return _this.baseUrl + _this.basePath + '/' + key;
          }
        };
      };
    });
})();

(function () {
  'use strict';

  angular.module('ute.active.treatments', [
      'ute.blocks.language.switcher',
  ]);

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('ute.common.component.directives', [
    'mdo-angular-cryptography',
    'ute.blocks.language.switcher',
    'ute.datalayer.common',
    'ute.blocks.router'
  ]);
})();


(function () {
  'use strict';

  angular.module('ute.semafone', [
    'ute.semafone.component',
    'ute.semafone.service',
    'ute.semafone.creditcard',
    'ngSanitize'
  ]);
})();

(function() {
  'use strict';

  angular.module('ute.modules.contentExpand', []);
})();

(function () {
  'use strict';

  angular.module('ute.common.oneview.footer', [
    'pascalprecht.translate',
    'ute.blocks.messages.bus',
    'ute.blocks.language.switcher',
    'ngSanitize',
    'adaptv.adaptStrap',
    'ute.common.permissions',
    'ute.common.utils',
    'ute.rogers.account.overview.service',
    'ute.blocks.province',
    'ute.datalayer.common'
  ]);
})();

(function () {
    'use strict';

    angular.module('ute.common.oneview.header', [
        'pascalprecht.translate',
        'ute.common.permissions',
        'ute.common.user',
        'ute.blocks.messages.bus',
        'ute.blocks.language.switcher',
        'ute.blocks.persistent.storage',
        'ute.common.core',
        'ute.data.manager',
        'ute.common.subscriptionBadge',
        'ute.rogers.eclipse.remote.api',
        'ute.dtm.service',
        'ute.active.treatments',
        'ute.bfa.ppc',
        'ute.common.runtime.translate',
        'ute.transferOfResponsibility',
        'ute.common.customer.credit.management',
        'ute.brite.bill.service',
        'ute.capture.dealer.code',
        'ute.rogers.account.overview.service',
        'ute.common.second.level.navigation',
        'ute.common.security',
        'ute.oneview.interaction.notes',
        'ngDialog',
    ]);

})();

(function () {
    'use strict';

    angular.module('ute.common.oneview.rep.feedback', [
        'ute.blocks.language.switcher',
        'ngSanitize',
        'ute.common.utils',
    ]);

})();

(function () {
  'use strict';
  angular.module('ute.payment.helper.view', ['ute.common.component.directives']);
})();

(function () {
  'use strict';

  angular.module('ute.common.permissions', [
    'ute.blocks.exception',
    'ute.common.user',
    'ute.common.security'
  ]);
})();

(function () {
  'use strict';

  angular.module('ute.usage.dial', [
    'ute.blocks.router',
    'ui.bootstrap',
    'pascalprecht.translate',
    'duScroll',
    'ute.common.filter',
    'ute.common.permissions']);
})();

(function () {
  'use strict';
  angular.module('ute.brite.bill.service',
    ['pascalprecht.translate',
      'ute.rogers.account.overview.service',
      'ute.common.runtime.translate',
      'ute.common.core.brtswitch',
      'ute.blocks.messages.bus',
      'ute.common.user'
    ]);
})();

(function () {
  'use strict';

  angular.module('ute.data.manager.service',
    ['ute.common.encryption',
      'ute.common.user',
      'pascalprecht.translate',
      'ute.rogers.account.overview.service',
      'ute.common.runtime.translate',
      'ute.common.security',
      'ute.common.permissions',
      'ute.common.core'
    ]);
})();

(function () {
  'use strict';

  angular.module('ute.app.banner', [
    'ui.bootstrap',
    'pascalprecht.translate',
    'ngMaterial'
  ]);
})();

/* global angular */
(function () {
  'use strict';

  angular.module('ute.discovery.page.service', []);
})();

(function () {
  'use strict';
  angular.module('ute.semafone.creditcard', ['ute.semafone.component', 'pascalprecht.translate', 'ngMessages']);

})();

(function () {
    'use strict';
    angular.module('ute.semafone.component', ['ute.semafone.service']);

})();
(function () {
  'use strict';
  angular.module('ute.semafone.service', ['pascalprecht.translate']);

})();

(function () {
  'use strict';

  angular.module('ute.common.simcard.change.form', ['ngMessages', 'ute.common.simcard.change.service']);
})();

(function () {
  'use strict';

  angular.module('ute.common.simcard.change.confirmation', ['ngMessages', 'ute.common.simcard.change.service']);
})();

(function () {
  'use strict';

  angular.module('ute.common.simcard.change.success', []);
})();

'use strict';

/**
 * @name totesApp
 * @description
 * # totesApp
 *
 * Main module of the application.
 */

angular.module('totesApp', [
  'selfServe',
  'ngCookies',
  'ngSanitize',
  'ngTouch',
  'ngMessages',
  'ngAnimate',
  'ngBiscuit',
  'ui.bootstrap',
  'ui.router',
  'ui.router.tabs',
  'ngDialog',
  'ute.ui.core',
  'myr.modules.httpDecorator',
  'myr.modules.commonUtilities',
  'myr.modules.notificationBanner',
  'myr.modules.rgcl',
  'myr.modules.authHttp',
  'myr.modules.profile',
  'myr.modules.securityQuestion',
  'myr.modules.linkAccount',
  'myr.modules.viewBill',
  'myr.modules.briteBill',
  'myr.modules.paymentTopBar',
  'myr.modules.accountBalanceData',
  'myr.modules.contentExpand',
  'myr.modules.utilities',
  'ute.common.component.directives',
  'ute.semafone',
  'ute.common.simcard.change',
  'ute.common.voicemail.resetPassword',
  'ute.common.suspend.ctn',
  'ute.common.reactivate.ctn',
  'ute.blocks.messages.bus',
  'ute.data.manager',
  'ute.usage.dial',
  'ute.brite.bill.service',
  'angularMoment',
  'translations',
  'ute.discovery.page',
  'ute.blocks.language.switcher',
  'ute.common.permissions',
  'timer',
  'duScroll',
  'ute.common.decorator.directives',
  'dibari.angular-ellipsis',
  'angular.filter',
  'ute.rogers.second.level.navigation',
  'ute.rogers.setpassword',
  'ute.common.profile.edit',
  'ute.rogers.user.registration',
  'ute.common.core.brtswitch',
  'ute.common.core.browser',
  'ute.oneview.interaction.notes',
  'ute.rogers.revolution.data.service',
  'ute.blocks.environment',
  'myr.modules.accountPreferences',
  'ute.rogers.eclipse.remote.api',
  'ute.common.subscriptionBadge',
  'ute.common.pending.order',
  'ute.rogers.account.selection.overlay',
  'pascalprecht.translate',
  'ute.dtm.service',
  'ute.semafone.service',
  'ute.payment.ui',
  'ute.common.selection.modal',
  'ute.transferOfResponsibility',
  'ute.common.customer.credit.management',
  'ute.wireless.product.discount.details',
  'ute.nova.content',
  'ute.common.oneview.footer',
  'ute.common.oneview.rep.feedback',
  'ute.common.oneview.header',
  'ute.promise.to.pay',
  'ute.change.ctn.callerId',
  'ute.common.user',
  'ute.goPaperless',
  'ute.payment.method',
  'ute.anti.spam.legislation',
  'ute.sm.to.genesis.auth.service',
  'ute.capture.dealer.code',
  'ute.common.utils',
  'ute.easy.login.registration',
  'ute.sms.recovery.rogers',
  'ute.datalayer.common',
  'ute.actions.offers',
  'ute.historical.usage',
  'ute.rogers.bpo.integration.service',
  'ute.rogers.siteminder.signin',
  'onboarding',
  'ute.fraud.logging',
  'ute.purchase.data'
]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('selfServe', []);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.accountPreferences', []);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.authHttp', ['ute.rogers.interceptors.auth']);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.commonUtilities', []);

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.httpDecorator', ['ng']);
})();
(function() {
  'use strict';

  angular.module('myr.modules.accountBalanceData', []);
})();

(function () {
  'use strict';

  angular.module('myr.modules.briteBill', ['ute.brite.bill.service']);
})();

(function() {
  'use strict';

  angular.module('myr.modules.contentExpand', []);
})();

(function() {
  'use strict';

  angular.module('myr.modules.linkAccount', ['totesApp', 'ui.router']);
})();

(function() {
  'use strict';

  angular.module('myr.modules.paymentTopBar', [
    'myr.modules.accountBalanceData',
    'ute.brite.bill.service',
    'ute.save.bill'
  ]);
})();

(function() {
  'use strict';

  angular.module('myr.modules.securityQuestion', ['totesApp', 'ui.router']);
})();

(function() {
  'use strict';

  angular.module('myr.modules.viewBill', ['ui.router']);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner', []);
})();

angular
  .module('onboarding', []);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.rgcl', []);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.utilities', []);
})();

/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 * Built with: material-tools
 * Includes modules: button, core, animate, layout, interaction, gestures, theming, palette, meta, checkbox, content, divider, menu, backdrop, menuBar, icon, radioButton, select, slider, subheader, sticky, switch, tabs, tooltip, panel, toolbar, bottomSheet, list
 * 
 * Copyright 2017 Google Inc. All Rights Reserved.
 * Use of this source code is governed by an MIT-style license that can be found in the LICENSE file at http://material.angularjs.org/LICENSE.
 */

(function() {
  "use strict";
  angular.module('ngMaterial', ['ng', 'ngAnimate', 'ngAria', 'material.components.button', 'material.core', 'material.core.animate', 'material.core.layout', 'material.core.interaction', 'material.core.gestures', 'material.core.theming', 'material.core.theming.palette', 'material.core.meta', 'material.components.checkbox', 'material.components.content', 'material.components.divider', 'material.components.menu', 'material.components.backdrop', 'material.components.menuBar', 'material.components.icon', 'material.components.radioButton', 'material.components.select', 'material.components.slider', 'material.components.subheader', 'material.components.sticky', 'material.components.switch', 'material.components.tabs', 'material.components.tooltip', 'material.components.panel', 'material.components.toolbar', 'material.components.bottomSheet', 'material.components.list']);
})();

/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/*
 * @ngdoc module
 * @name material.components.backdrop
 * @description Backdrop
 */

/**
 * @ngdoc directive
 * @name mdBackdrop
 * @module material.components.backdrop
 *
 * @restrict E
 *
 * @description
 * `<md-backdrop>` is a backdrop element used by other components, such as dialog and bottom sheet.
 * Apply class `opaque` to make the backdrop use the theme backdrop color.
 *
 */

angular
  .module('material.components.backdrop', ['material.core'])
  .directive('mdBackdrop', ["$mdTheming", "$mdUtil", "$animate", "$rootElement", "$window", "$log", "$$rAF", "$document", function BackdropDirective($mdTheming, $mdUtil, $animate, $rootElement, $window, $log, $$rAF, $document) {
    var ERROR_CSS_POSITION = '<md-backdrop> may not work properly in a scrolled, static-positioned parent container.';

    return {
      restrict: 'E',
      link: postLink
    };

    function postLink(scope, element, attrs) {
      // backdrop may be outside the $rootElement, tell ngAnimate to animate regardless
      if ($animate.pin) $animate.pin(element, $rootElement);

      var bodyStyles;

      $$rAF(function() {
        // If body scrolling has been disabled using mdUtil.disableBodyScroll(),
        // adjust the 'backdrop' height to account for the fixed 'body' top offset.
        // Note that this can be pretty expensive and is better done inside the $$rAF.
        bodyStyles = $window.getComputedStyle($document[0].body);

        if (bodyStyles.position === 'fixed') {
          var resizeHandler = $mdUtil.debounce(function(){
            bodyStyles = $window.getComputedStyle($document[0].body);
            resize();
          }, 60, null, false);

          resize();
          angular.element($window).on('resize', resizeHandler);

          scope.$on('$destroy', function() {
            angular.element($window).off('resize', resizeHandler);
          });
        }

        // Often $animate.enter() is used to append the backDrop element
        // so let's wait until $animate is done...
        var parent = element.parent();

        if (parent.length) {
          if (parent[0].nodeName === 'BODY') {
            element.css('position', 'fixed');
          }

          var styles = $window.getComputedStyle(parent[0]);

          if (styles.position === 'static') {
            // backdrop uses position:absolute and will not work properly with parent position:static (default)
            $log.warn(ERROR_CSS_POSITION);
          }

          // Only inherit the parent if the backdrop has a parent.
          $mdTheming.inherit(element, parent);
        }
      });

      function resize() {
        var viewportHeight = parseInt(bodyStyles.height, 10) + Math.abs(parseInt(bodyStyles.top, 10));
        element.css('height', viewportHeight + 'px');
      }
    }

  }]);

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.bottomSheet
 * @description
 * BottomSheet
 */
MdBottomSheetDirective['$inject'] = ["$mdBottomSheet"];
MdBottomSheetProvider['$inject'] = ["$$interimElementProvider"];
angular
  .module('material.components.bottomSheet', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdBottomSheet', MdBottomSheetDirective)
  .provider('$mdBottomSheet', MdBottomSheetProvider);

/* ngInject */
function MdBottomSheetDirective($mdBottomSheet) {
  return {
    restrict: 'E',
    link : function postLink(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      // When navigation force destroys an interimElement, then
      // listen and $destroy() that interim instance...
      scope.$on('$destroy', function() {
        $mdBottomSheet.destroy();
      });
    }
  };
}


/**
 * @ngdoc service
 * @name $mdBottomSheet
 * @module material.components.bottomSheet
 *
 * @description
 * `$mdBottomSheet` opens a bottom sheet over the app and provides a simple promise API.
 *
 * ## Restrictions
 *
 * - The bottom sheet's template must have an outer `<md-bottom-sheet>` element.
 * - Add the `md-grid` class to the bottom sheet for a grid layout.
 * - Add the `md-list` class to the bottom sheet for a list layout.
 *
 * @usage
 * <hljs lang="html">
 * <div ng-controller="MyController">
 *   <md-button ng-click="openBottomSheet()">
 *     Open a Bottom Sheet!
 *   </md-button>
 * </div>
 * </hljs>
 * <hljs lang="js">
 * var app = angular.module('app', ['ngMaterial']);
 * app.controller('MyController', function($scope, $mdBottomSheet) {
 *   $scope.openBottomSheet = function() {
 *     $mdBottomSheet.show({
 *       template: '<md-bottom-sheet>Hello!</md-bottom-sheet>'
 *     });
 *   };
 * });
 * </hljs>
 */

 /**
 * @ngdoc method
 * @name $mdBottomSheet#show
 *
 * @description
 * Show a bottom sheet with the specified options.
 *
 * @param {object} options An options object, with the following properties:
 *
 *   - `templateUrl` - `{string=}`: The url of an html template file that will
 *   be used as the content of the bottom sheet. Restrictions: the template must
 *   have an outer `md-bottom-sheet` element.
 *   - `template` - `{string=}`: Same as templateUrl, except this is an actual
 *   template string.
 *   - `scope` - `{object=}`: the scope to link the template / controller to. If none is specified, it will create a new child scope.
 *     This scope will be destroyed when the bottom sheet is removed unless `preserveScope` is set to true.
 *   - `preserveScope` - `{boolean=}`: whether to preserve the scope when the element is removed. Default is false
 *   - `controller` - `{string=}`: The controller to associate with this bottom sheet.
 *   - `locals` - `{string=}`: An object containing key/value pairs. The keys will
 *   be used as names of values to inject into the controller. For example,
 *   `locals: {three: 3}` would inject `three` into the controller with the value
 *   of 3.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click outside the bottom sheet to
 *     close it. Default true.
 *   - `bindToController` - `{boolean=}`: When set to true, the locals will be bound to the controller instance.
 *   - `disableBackdrop` - `{boolean=}`: When set to true, the bottomsheet will not show a backdrop.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to close the bottom sheet.
 *     Default true.
 *   - `resolve` - `{object=}`: Similar to locals, except it takes promises as values
 *   and the bottom sheet will not open until the promises resolve.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on the scope.
 *   - `parent` - `{element=}`: The element to append the bottom sheet to. The `parent` may be a `function`, `string`,
 *   `object`, or null. Defaults to appending to the body of the root element (or the root element) of the application.
 *   e.g. angular.element(document.getElementById('content')) or "#content"
 *   - `disableParentScroll` - `{boolean=}`: Whether to disable scrolling while the bottom sheet is open.
 *     Default true.
 *
 * @returns {promise} A promise that can be resolved with `$mdBottomSheet.hide()` or
 * rejected with `$mdBottomSheet.cancel()`.
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#hide
 *
 * @description
 * Hide the existing bottom sheet and resolve the promise returned from
 * `$mdBottomSheet.show()`. This call will close the most recently opened/current bottomsheet (if any).
 *
 * @param {*=} response An argument for the resolved promise.
 *
 */

/**
 * @ngdoc method
 * @name $mdBottomSheet#cancel
 *
 * @description
 * Hide the existing bottom sheet and reject the promise returned from
 * `$mdBottomSheet.show()`.
 *
 * @param {*=} response An argument for the rejected promise.
 *
 */

function MdBottomSheetProvider($$interimElementProvider) {
  // how fast we need to flick down to close the sheet, pixels/ms
  bottomSheetDefaults['$inject'] = ["$animate", "$mdConstant", "$mdUtil", "$mdTheming", "$mdBottomSheet", "$rootElement", "$mdGesture", "$log"];
  var CLOSING_VELOCITY = 0.5;
  var PADDING = 80; // same as css

  return $$interimElementProvider('$mdBottomSheet')
    .setDefaults({
      methods: ['disableParentScroll', 'escapeToClose', 'clickOutsideToClose'],
      options: bottomSheetDefaults
    });

  /* ngInject */
  function bottomSheetDefaults($animate, $mdConstant, $mdUtil, $mdTheming, $mdBottomSheet, $rootElement,
                               $mdGesture, $log) {
    var backdrop;

    return {
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      disableBackdrop: false,
      escapeToClose: true,
      clickOutsideToClose: true,
      disableParentScroll: true
    };


    function onShow(scope, element, options, controller) {

      element = $mdUtil.extractElementByName(element, 'md-bottom-sheet');

      // prevent tab focus or click focus on the bottom-sheet container
      element.attr('tabindex',"-1");

      // Once the md-bottom-sheet has `ng-cloak` applied on his template the opening animation will not work properly.
      // This is a very common problem, so we have to notify the developer about this.
      if (element.hasClass('ng-cloak')) {
        var message = '$mdBottomSheet: using `<md-bottom-sheet ng-cloak >` will affect the bottom-sheet opening animations.';
        $log.warn( message, element[0] );
      }

      if (!options.disableBackdrop) {
        // Add a backdrop that will close on click
        backdrop = $mdUtil.createBackdrop(scope, "md-bottom-sheet-backdrop md-opaque");

        // Prevent mouse focus on backdrop; ONLY programatic focus allowed.
        // This allows clicks on backdrop to propogate to the $rootElement and
        // ESC key events to be detected properly.
        
        backdrop[0].tabIndex = -1;

        if (options.clickOutsideToClose) {
          backdrop.on('click', function() {
            $mdUtil.nextTick($mdBottomSheet.cancel,true);
          });
        }

        $mdTheming.inherit(backdrop, options.parent);

        $animate.enter(backdrop, options.parent, null);
      }

      var bottomSheet = new BottomSheet(element, options.parent);
      options.bottomSheet = bottomSheet;

      $mdTheming.inherit(bottomSheet.element, options.parent);

      if (options.disableParentScroll) {
        options.restoreScroll = $mdUtil.disableScrollAround(bottomSheet.element, options.parent);
      }

      return $animate.enter(bottomSheet.element, options.parent, backdrop)
        .then(function() {
          var focusable = $mdUtil.findFocusTarget(element) || angular.element(
            element[0].querySelector('button') ||
            element[0].querySelector('a') ||
            element[0].querySelector($mdUtil.prefixer('ng-click', true))
          ) || backdrop;

          if (options.escapeToClose) {
            options.rootElementKeyupCallback = function(e) {
              if (e.keyCode === $mdConstant.KEY_CODE.ESCAPE) {
                $mdUtil.nextTick($mdBottomSheet.cancel,true);
              }
            };

            $rootElement.on('keyup', options.rootElementKeyupCallback);
            focusable && focusable.focus();
          }
        });

    }

    function onRemove(scope, element, options) {

      var bottomSheet = options.bottomSheet;

      if (!options.disableBackdrop) $animate.leave(backdrop);
      return $animate.leave(bottomSheet.element).then(function() {
        if (options.disableParentScroll) {
          options.restoreScroll();
          delete options.restoreScroll;
        }

        bottomSheet.cleanup();
      });
    }

    /**
     * BottomSheet class to apply bottom-sheet behavior to an element
     */
    function BottomSheet(element, parent) {
      var deregister = $mdGesture.register(parent, 'drag', { horizontal: false });
      parent.on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      return {
        element: element,
        cleanup: function cleanup() {
          deregister();
          parent.off('$md.dragstart', onDragStart);
          parent.off('$md.drag', onDrag);
          parent.off('$md.dragend', onDragEnd);
        }
      };

      function onDragStart(ev) {
        // Disable transitions on transform so that it feels fast
        element.css($mdConstant.CSS.TRANSITION_DURATION, '0ms');
      }

      function onDrag(ev) {
        var transform = ev.pointer.distanceY;
        if (transform < 5) {
          // Slow down drag when trying to drag up, and stop after PADDING
          transform = Math.max(-PADDING, transform / 2);
        }
        element.css($mdConstant.CSS.TRANSFORM, 'translate3d(0,' + (PADDING + transform) + 'px,0)');
      }

      function onDragEnd(ev) {
        if (ev.pointer.distanceY > 0 &&
            (ev.pointer.distanceY > 20 || Math.abs(ev.pointer.velocityY) > CLOSING_VELOCITY)) {
          var distanceRemaining = element.prop('offsetHeight') - ev.pointer.distanceY;
          var transitionDuration = Math.min(distanceRemaining / ev.pointer.velocityY * 0.75, 500);
          element.css($mdConstant.CSS.TRANSITION_DURATION, transitionDuration + 'ms');
          $mdUtil.nextTick($mdBottomSheet.cancel,true);
        } else {
          element.css($mdConstant.CSS.TRANSITION_DURATION, '');
          element.css($mdConstant.CSS.TRANSFORM, '');
        }
      }
    }

  }

}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.button
 * @description
 *
 * Button
 */
MdButtonDirective['$inject'] = ["$mdButtonInkRipple", "$mdTheming", "$mdAria", "$mdInteraction"];
MdAnchorDirective['$inject'] = ["$mdTheming"];
angular
    .module('material.components.button', [ 'material.core' ])
    .directive('mdButton', MdButtonDirective)
    .directive('a', MdAnchorDirective);


/**
 * @private
 * @restrict E
 *
 * @description
 * `a` is an anchor directive used to inherit theme colors for md-primary, md-accent, etc.
 *
 * @usage
 *
 * <hljs lang="html">
 *  <md-content md-theme="myTheme">
 *    <a href="#chapter1" class="md-accent"></a>
 *  </md-content>
 * </hljs>
 */
function MdAnchorDirective($mdTheming) {
  return {
    restrict : 'E',
    link : function postLink(scope, element) {
      // Make sure to inherit theme so stand-alone anchors
      // support theme colors for md-primary, md-accent, etc.
      $mdTheming(element);
    }
  };
}


/**
 * @ngdoc directive
 * @name mdButton
 * @module material.components.button
 *
 * @restrict E
 *
 * @description
 * `<md-button>` is a button directive with optional ink ripples (default enabled).
 *
 * If you supply a `href` or `ng-href` attribute, it will become an `<a>` element. Otherwise, it
 * will become a `<button>` element. As per the
 * [Material Design specifications](https://material.google.com/style/color.html#color-color-palette)
 * the FAB button background is filled with the accent color [by default]. The primary color palette
 * may be used with the `md-primary` class.
 *
 * Developers can also change the color palette of the button, by using the following classes
 * - `md-primary`
 * - `md-accent`
 * - `md-warn`
 *
 * See for example
 *
 * <hljs lang="html">
 *   <md-button class="md-primary">Primary Button</md-button>
 * </hljs>
 *
 * Button can be also raised, which means that they will use the current color palette to fill the button.
 *
 * <hljs lang="html">
 *   <md-button class="md-accent md-raised">Raised and Accent Button</md-button>
 * </hljs>
 *
 * It is also possible to disable the focus effect on the button, by using the following markup.
 *
 * <hljs lang="html">
 *   <md-button class="md-no-focus">No Focus Style</md-button>
 * </hljs>
 *
 * @param {boolean=} md-no-ink If present, disable ripple ink effects.
 * @param {expression=} ng-disabled En/Disable based on the expression
 * @param {string=} md-ripple-size Overrides the default ripple size logic. Options: `full`, `partial`, `auto`
 * @param {string=} aria-label Adds alternative text to button for accessibility, useful for icon buttons.
 * If no default text is found, a warning will be logged.
 *
 * @usage
 *
 * Regular buttons:
 *
 * <hljs lang="html">
 *  <md-button> Flat Button </md-button>
 *  <md-button href="http://google.com"> Flat link </md-button>
 *  <md-button class="md-raised"> Raised Button </md-button>
 *  <md-button ng-disabled="true"> Disabled Button </md-button>
 *  <md-button>
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *    Register Now
 *  </md-button>
 * </hljs>
 *
 * FAB buttons:
 *
 * <hljs lang="html">
 *  <md-button class="md-fab" aria-label="FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- mini-FAB -->
 *  <md-button class="md-fab md-mini" aria-label="Mini FAB">
 *    <md-icon md-svg-src="your/icon.svg"></md-icon>
 *  </md-button>
 *  <!-- Button with SVG Icon -->
 *  <md-button class="md-icon-button" aria-label="Custom Icon Button">
 *    <md-icon md-svg-icon="path/to/your.svg"></md-icon>
 *  </md-button>
 * </hljs>
 */
function MdButtonDirective($mdButtonInkRipple, $mdTheming, $mdAria, $mdInteraction) {

  return {
    restrict: 'EA',
    replace: true,
    transclude: true,
    template: getTemplate,
    link: postLink
  };

  function isAnchor(attr) {
    return angular.isDefined(attr.href) || angular.isDefined(attr.ngHref) || angular.isDefined(attr.ngLink) || angular.isDefined(attr.uiSref);
  }

  function getTemplate(element, attr) {
    if (isAnchor(attr)) {
      return '<a class="md-button" ng-transclude></a>';
    } else {
      //If buttons don't have type="button", they will submit forms automatically.
      var btnType = (typeof attr.type === 'undefined') ? 'button' : attr.type;
      return '<button class="md-button" type="' + btnType + '" ng-transclude></button>';
    }
  }

  function postLink(scope, element, attr) {
    $mdTheming(element);
    $mdButtonInkRipple.attach(scope, element);

    // Use async expect to support possible bindings in the button label
    $mdAria.expectWithoutText(element, 'aria-label');

    // For anchor elements, we have to set tabindex manually when the
    // element is disabled
    if (isAnchor(attr) && angular.isDefined(attr.ngDisabled) ) {
      scope.$watch(attr.ngDisabled, function(isDisabled) {
        element.attr('tabindex', isDisabled ? -1 : 0);
      });
    }

    // disabling click event when disabled is true
    element.on('click', function(e){
      if (attr.disabled === true) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    });

    if (!element.hasClass('md-no-focus')) {

      element.on('focus', function() {

        // Only show the focus effect when being focused through keyboard interaction or programmatically
        if (!$mdInteraction.isUserInvoked() || $mdInteraction.getLastInteractionType() === 'keyboard') {
          element.addClass('md-focused');
        }

      });

      element.on('blur', function() {
        element.removeClass('md-focused');
      });
    }

  }

}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.checkbox
 * @description Checkbox module!
 */
MdCheckboxDirective['$inject'] = ["inputDirective", "$mdAria", "$mdConstant", "$mdTheming", "$mdUtil", "$mdInteraction"];
angular
  .module('material.components.checkbox', ['material.core'])
  .directive('mdCheckbox', MdCheckboxDirective);

/**
 * @ngdoc directive
 * @name mdCheckbox
 * @module material.components.checkbox
 * @restrict E
 *
 * @description
 * The checkbox directive is used like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-color-schemes)
 * the checkbox is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
 * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects
 * @param {string=} aria-label Adds label to checkbox for accessibility.
 *     Defaults to checkbox's text. If no default text is found, a warning will be logged.
 * @param {expression=} md-indeterminate This determines when the checkbox should be rendered as 'indeterminate'.
 *     If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state.
 *     If falsy expression is passed in it just looks like a normal unchecked checkbox.
 *     The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time.
 *     Adding the 'md-indeterminate' attribute overrides any checked/unchecked rendering logic.
 *     When using the 'md-indeterminate' attribute use 'ng-checked' to define rendering logic instead of using 'ng-model'.
 * @param {expression=} ng-checked If this expression evaluates as truthy, the 'md-checked' css class is added to the checkbox and it
 *     will appear checked.
 *
 * @usage
 * <hljs lang="html">
 * <md-checkbox ng-model="isChecked" aria-label="Finished?">
 *   Finished ?
 * </md-checkbox>
 *
 * <md-checkbox md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-checkbox>
 *
 * <md-checkbox ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-checkbox>
 *
 * </hljs>
 *
 */
function MdCheckboxDirective(inputDirective, $mdAria, $mdConstant, $mdTheming, $mdUtil, $mdInteraction) {
  inputDirective = inputDirective[0];

  return {
    restrict: 'E',
    transclude: true,
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    template:
      '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
        '<div class="md-icon"></div>' +
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    tAttrs.$set('tabindex', tAttrs.tabindex || '0');
    tAttrs.$set('type', 'checkbox');
    tAttrs.$set('role', tAttrs.type);

    return  {
      pre: function(scope, element) {
        // Attach a click handler during preLink, in order to immediately stop propagation
        // (especially for ng-click) when the checkbox is disabled.
        element.on('click', function(e) {
          if (this.hasAttribute('disabled')) {
            e.stopImmediatePropagation();
          }
        });
      },
      post: postLink
    };

    function postLink(scope, element, attr, ctrls) {
      var isIndeterminate;
      var containerCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        containerCtrl.input = element;

        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      $mdTheming(element);

      // Redirect focus events to the root element, because IE11 is always focusing the container element instead
      // of the md-checkbox element. This causes issues when using ngModelOptions: `updateOnBlur`
      element.children().on('focus', function() {
        element.focus();
      });

      if ($mdUtil.parseAttributeBoolean(attr.mdIndeterminate)) {
        setIndeterminateState();
        scope.$watch(attr.mdIndeterminate, setIndeterminateState);
      }

      if (attr.ngChecked) {
        scope.$watch(scope.$eval.bind(scope, attr.ngChecked), function(value) {
          ngModelCtrl.$setViewValue(value);
          ngModelCtrl.$render();
        });
      }

      $$watchExpr('ngDisabled', 'tabindex', {
        true: '-1',
        false: attr.tabindex
      });

      $mdAria.expectWithText(element, 'aria-label');

      // Reuse the original input[type=checkbox] directive from Angular core.
      // This is a bit hacky as we need our own event listener and own render
      // function.
      inputDirective.link.pre(scope, {
        on: angular.noop,
        0: {}
      }, attr, [ngModelCtrl]);

      element.on('click', listener)
        .on('keypress', keypressHandler)
        .on('focus', function() {
          if ($mdInteraction.getLastInteractionType() === 'keyboard') {
            element.addClass('md-focused');
          }
        })
        .on('blur', function() {
          element.removeClass('md-focused');
        });

      ngModelCtrl.$render = render;

      function $$watchExpr(expr, htmlAttr, valueOpts) {
        if (attr[expr]) {
          scope.$watch(attr[expr], function(val) {
            if (valueOpts[val]) {
              element.attr(htmlAttr, valueOpts[val]);
            }
          });
        }
      }

      function keypressHandler(ev) {
        var keyCode = ev.which || ev.keyCode;
        if (keyCode === $mdConstant.KEY_CODE.SPACE || keyCode === $mdConstant.KEY_CODE.ENTER) {
          ev.preventDefault();
          element.addClass('md-focused');
          listener(ev);
        }
      }

      function listener(ev) {
        // skipToggle boolean is used by the switch directive to prevent the click event
        // when releasing the drag. There will be always a click if releasing the drag over the checkbox
        if (element[0].hasAttribute('disabled') || scope.skipToggle) {
          return;
        }

        scope.$apply(function() {
          // Toggle the checkbox value...
          var viewValue = attr.ngChecked ? attr.checked : !ngModelCtrl.$viewValue;

          ngModelCtrl.$setViewValue(viewValue, ev && ev.type);
          ngModelCtrl.$render();
        });
      }

      function render() {
        // Cast the $viewValue to a boolean since it could be undefined
        element.toggleClass('md-checked', !!ngModelCtrl.$viewValue && !isIndeterminate);
      }

      function setIndeterminateState(newValue) {
        isIndeterminate = newValue !== false;
        if (isIndeterminate) {
          element.attr('aria-checked', 'mixed');
        }
        element.toggleClass('md-indeterminate', isIndeterminate);
      }
    }
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.content
 *
 * @description
 * Scrollable content
 */
mdContentDirective['$inject'] = ["$mdTheming"];
angular.module('material.components.content', [
  'material.core'
])
  .directive('mdContent', mdContentDirective);

/**
 * @ngdoc directive
 * @name mdContent
 * @module material.components.content
 *
 * @restrict E
 *
 * @description
 *
 * The `<md-content>` directive is a container element useful for scrollable content. It achieves
 * this by setting the CSS `overflow` property to `auto` so that content can properly scroll.
 *
 * In general, `<md-content>` components are not designed to be nested inside one another. If
 * possible, it is better to make them siblings. This often results in a better user experience as
 * having nested scrollbars may confuse the user.
 *
 * ## Troubleshooting
 *
 * In some cases, you may wish to apply the `md-no-momentum` class to ensure that Safari's
 * momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling
 * SVG icons and some other components.
 *
 * Additionally, we now also offer the `md-no-flicker` class which can be applied to any element
 * and uses a Webkit-specific filter of `blur(0px)` that forces GPU rendering of all elements
 * inside (which eliminates the flicker on iOS devices).
 *
 * _<b>Note:</b> Forcing an element to render on the GPU can have unintended side-effects, especially
 * related to the z-index of elements. Please use with caution and only on the elements needed._
 *
 * @usage
 *
 * Add the `[layout-padding]` attribute to make the content padded.
 *
 * <hljs lang="html">
 *  <md-content layout-padding>
 *      Lorem ipsum dolor sit amet, ne quod novum mei.
 *  </md-content>
 * </hljs>
 */

function mdContentDirective($mdTheming) {
  return {
    restrict: 'E',
    controller: ['$scope', '$element', ContentController],
    link: function(scope, element) {
      element.addClass('_md');     // private md component indicator for styling

      $mdTheming(element);
      scope.$broadcast('$mdContentLoaded', element);

      iosScrollFix(element[0]);
    }
  };

  function ContentController($scope, $element) {
    this.$scope = $scope;
    this.$element = $element;
  }
}

function iosScrollFix(node) {
  // IOS FIX:
  // If we scroll where there is no more room for the webview to scroll,
  // by default the webview itself will scroll up and down, this looks really
  // bad.  So if we are scrolling to the very top or bottom, add/subtract one
  angular.element(node).on('$md.pressdown', function(ev) {
    // Only touch events
    if (ev.pointer.type !== 't') return;
    // Don't let a child content's touchstart ruin it for us.
    if (ev.$materialScrollFixed) return;
    ev.$materialScrollFixed = true;

    if (node.scrollTop === 0) {
      node.scrollTop = 1;
    } else if (node.scrollHeight === node.scrollTop + node.offsetHeight) {
      node.scrollTop -= 1;
    }
  });
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * Initialization function that validates environment
 * requirements.
 */
DetectNgTouch['$inject'] = ["$log", "$injector"];
MdCoreConfigure['$inject'] = ["$provide", "$mdThemingProvider"];
rAFDecorator['$inject'] = ["$delegate"];
qDecorator['$inject'] = ["$delegate"];
angular
  .module('material.core', [
    'ngAnimate',
    'material.core.animate',
    'material.core.layout',
    'material.core.interaction',
    'material.core.gestures',
    'material.core.theming'
  ])
  .config(MdCoreConfigure)
  .run(DetectNgTouch);


/**
 * Detect if the ng-Touch module is also being used.
 * Warn if detected.
 * ngInject
 */
function DetectNgTouch($log, $injector) {
  if ( $injector.has('$swipe') ) {
    var msg = "" +
      "You are using the ngTouch module. \n" +
      "Angular Material already has mobile click, tap, and swipe support... \n" +
      "ngTouch is not supported with Angular Material!";
    $log.warn(msg);
  }
}

/**
 * ngInject
 */
function MdCoreConfigure($provide, $mdThemingProvider) {

  $provide.decorator('$$rAF', ['$delegate', rAFDecorator]);
  $provide.decorator('$q', ['$delegate', qDecorator]);

  $mdThemingProvider.theme('default')
    .primaryPalette('indigo')
    .accentPalette('pink')
    .warnPalette('deep-orange')
    .backgroundPalette('grey');
}

/**
 * ngInject
 */
function rAFDecorator($delegate) {
  /**
   * Use this to throttle events that come in often.
   * The throttled function will always use the *last* invocation before the
   * coming frame.
   *
   * For example, window resize events that fire many times a second:
   * If we set to use an raf-throttled callback on window resize, then
   * our callback will only be fired once per frame, with the last resize
   * event that happened before that frame.
   *
   * @param {function} callback function to debounce
   */
  $delegate.throttle = function(cb) {
    var queuedArgs, alreadyQueued, queueCb, context;
    return function debounced() {
      queuedArgs = arguments;
      context = this;
      queueCb = cb;
      if (!alreadyQueued) {
        alreadyQueued = true;
        $delegate(function() {
          queueCb.apply(context, Array.prototype.slice.call(queuedArgs));
          alreadyQueued = false;
        });
      }
    };
  };
  return $delegate;
}

/**
 * ngInject
 */
function qDecorator($delegate) {
  /**
   * Adds a shim for $q.resolve for Angular version that don't have it,
   * so we don't have to think about it.
   *
   * via https://github.com/angular/angular.js/pull/11987
   */

  // TODO(crisbeto): this won't be necessary once we drop Angular 1.3
  if (!$delegate.resolve) {
    $delegate.resolve = $delegate.when;
  }
  return $delegate;
}


MdAutofocusDirective['$inject'] = ["$parse"];angular.module('material.core')
  .directive('mdAutofocus', MdAutofocusDirective)

  // Support the deprecated md-auto-focus and md-sidenav-focus as well
  .directive('mdAutoFocus', MdAutofocusDirective)
  .directive('mdSidenavFocus', MdAutofocusDirective);

/**
 * @ngdoc directive
 * @name mdAutofocus
 * @module material.core.util
 *
 * @description
 *
 * `[md-autofocus]` provides an optional way to identify the focused element when a `$mdDialog`,
 * `$mdBottomSheet`, `$mdMenu` or `$mdSidenav` opens or upon page load for input-like elements.
 *
 * When one of these opens, it will find the first nested element with the `[md-autofocus]`
 * attribute directive and optional expression. An expression may be specified as the directive
 * value to enable conditional activation of the autofocus.
 *
 * @usage
 *
 * ### Dialog
 * <hljs lang="html">
 * <md-dialog>
 *   <form>
 *     <md-input-container>
 *       <label for="testInput">Label</label>
 *       <input id="testInput" type="text" md-autofocus>
 *     </md-input-container>
 *   </form>
 * </md-dialog>
 * </hljs>
 *
 * ### Bottomsheet
 * <hljs lang="html">
 * <md-bottom-sheet class="md-list md-has-header">
 *  <md-subheader>Comment Actions</md-subheader>
 *  <md-list>
 *    <md-list-item ng-repeat="item in items">
 *
 *      <md-button md-autofocus="$index == 2">
 *        <md-icon md-svg-src="{{item.icon}}"></md-icon>
 *        <span class="md-inline-list-icon-label">{{ item.name }}</span>
 *      </md-button>
 *
 *    </md-list-item>
 *  </md-list>
 * </md-bottom-sheet>
 * </hljs>
 *
 * ### Autocomplete
 * <hljs lang="html">
 *   <md-autocomplete
 *       md-autofocus
 *       md-selected-item="selectedItem"
 *       md-search-text="searchText"
 *       md-items="item in getMatches(searchText)"
 *       md-item-text="item.display">
 *     <span md-highlight-text="searchText">{{item.display}}</span>
 *   </md-autocomplete>
 * </hljs>
 *
 * ### Sidenav
 * <hljs lang="html">
 * <div layout="row" ng-controller="MyController">
 *   <md-sidenav md-component-id="left" class="md-sidenav-left">
 *     Left Nav!
 *   </md-sidenav>
 *
 *   <md-content>
 *     Center Content
 *     <md-button ng-click="openLeftMenu()">
 *       Open Left Menu
 *     </md-button>
 *   </md-content>
 *
 *   <md-sidenav md-component-id="right"
 *     md-is-locked-open="$mdMedia('min-width: 333px')"
 *     class="md-sidenav-right">
 *     <form>
 *       <md-input-container>
 *         <label for="testInput">Test input</label>
 *         <input id="testInput" type="text"
 *                ng-model="data" md-autofocus>
 *       </md-input-container>
 *     </form>
 *   </md-sidenav>
 * </div>
 * </hljs>
 **/
function MdAutofocusDirective($parse) {
  return {
    restrict: 'A',
    link: {
      pre: preLink
    }
  };

  function preLink(scope, element, attr) {
    var attrExp = attr.mdAutoFocus || attr.mdAutofocus || attr.mdSidenavFocus;

    // Initially update the expression by manually parsing the expression as per $watch source.
    updateExpression($parse(attrExp)(scope));

    // Only watch the expression if it is not empty.
    if (attrExp) {
      scope.$watch(attrExp, updateExpression);
    }

    /**
     * Updates the autofocus class which is used to determine whether the attribute
     * expression evaluates to true or false.
     * @param {string|boolean} value Attribute Value
     */
    function updateExpression(value) {

      // Rather than passing undefined to the jqLite toggle class function we explicitly set the
      // value to true. Otherwise the class will be just toggled instead of being forced.
      if (angular.isUndefined(value)) {
        value = true;
      }

      element.toggleClass('md-autofocus', !!value);
    }
  }

}

/**
 * @ngdoc module
 * @name material.core.colorUtil
 * @description
 * Color Util
 */
angular
  .module('material.core')
  .factory('$mdColorUtil', ColorUtilFactory);

function ColorUtilFactory() {
  /**
   * Converts hex value to RGBA string
   * @param color {string}
   * @returns {string}
   */
  function hexToRgba (color) {
    var hex   = color[ 0 ] === '#' ? color.substr(1) : color,
      dig   = hex.length / 3,
      red   = hex.substr(0, dig),
      green = hex.substr(dig, dig),
      blue  = hex.substr(dig * 2);
    if (dig === 1) {
      red += red;
      green += green;
      blue += blue;
    }
    return 'rgba(' + parseInt(red, 16) + ',' + parseInt(green, 16) + ',' + parseInt(blue, 16) + ',0.1)';
  }

  /**
   * Converts rgba value to hex string
   * @param color {string}
   * @returns {string}
   */
  function rgbaToHex(color) {
    color = color.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);

    var hex = (color && color.length === 4) ? "#" +
    ("0" + parseInt(color[1],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[2],10).toString(16)).slice(-2) +
    ("0" + parseInt(color[3],10).toString(16)).slice(-2) : '';

    return hex.toUpperCase();
  }

  /**
   * Converts an RGB color to RGBA
   * @param color {string}
   * @returns {string}
   */
  function rgbToRgba (color) {
    return color.replace(')', ', 0.1)').replace('(', 'a(');
  }

  /**
   * Converts an RGBA color to RGB
   * @param color {string}
   * @returns {string}
   */
  function rgbaToRgb (color) {
    return color
      ? color.replace('rgba', 'rgb').replace(/,[^\),]+\)/, ')')
      : 'rgb(0,0,0)';
  }

  return {
    rgbaToHex: rgbaToHex,
    hexToRgba: hexToRgba,
    rgbToRgba: rgbToRgba,
    rgbaToRgb: rgbaToRgb
  };
}

angular.module('material.core')
.factory('$mdConstant', MdConstantFactory);

/**
 * Factory function that creates the grab-bag $mdConstant service.
 * ngInject
 */
function MdConstantFactory() {

  var prefixTestEl = document.createElement('div');
  var vendorPrefix = getVendorPrefix(prefixTestEl);
  var isWebkit = /webkit/i.test(vendorPrefix);
  var SPECIAL_CHARS_REGEXP = /([:\-_]+(.))/g;

  function vendorProperty(name) {
    // Add a dash between the prefix and name, to be able to transform the string into camelcase.
    var prefixedName = vendorPrefix + '-' + name;
    var ucPrefix = camelCase(prefixedName);
    var lcPrefix = ucPrefix.charAt(0).toLowerCase() + ucPrefix.substring(1);

    return hasStyleProperty(prefixTestEl, name)     ? name     :       // The current browser supports the un-prefixed property
           hasStyleProperty(prefixTestEl, ucPrefix) ? ucPrefix :       // The current browser only supports the prefixed property.
           hasStyleProperty(prefixTestEl, lcPrefix) ? lcPrefix : name; // Some browsers are only supporting the prefix in lowercase.
  }

  function hasStyleProperty(testElement, property) {
    return angular.isDefined(testElement.style[property]);
  }

  function camelCase(input) {
    return input.replace(SPECIAL_CHARS_REGEXP, function(matches, separator, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
  }

  function getVendorPrefix(testElement) {
    var prop, match;
    var vendorRegex = /^(Moz|webkit|ms)(?=[A-Z])/;

    for (prop in testElement.style) {
      if (match = vendorRegex.exec(prop)) {
        return match[0];
      }
    }
  }

  var self = {
    isInputKey : function(e) { return (e.keyCode >= 31 && e.keyCode <= 90); },
    isNumPadKey : function (e){ return (3 === e.location && e.keyCode >= 97 && e.keyCode <= 105); },
    isNavigationKey : function(e) {
      var kc = self.KEY_CODE, NAVIGATION_KEYS =  [kc.SPACE, kc.ENTER, kc.UP_ARROW, kc.DOWN_ARROW];
      return (NAVIGATION_KEYS.indexOf(e.keyCode) != -1);
    },

    /**
     * Maximum size, in pixels, that can be explicitly set to an element. The actual value varies
     * between browsers, but IE11 has the very lowest size at a mere 1,533,917px. Ideally we could
     * compute this value, but Firefox always reports an element to have a size of zero if it
     * goes over the max, meaning that we'd have to binary search for the value.
     */
    ELEMENT_MAX_PIXELS: 1533917,

    /**
     * Priority for a directive that should run before the directives from ngAria.
     */
    BEFORE_NG_ARIA: 210,

    /**
     * Common Keyboard actions and their associated keycode.
     */
    KEY_CODE: {
      COMMA: 188,
      SEMICOLON : 186,
      ENTER: 13,
      ESCAPE: 27,
      SPACE: 32,
      PAGE_UP: 33,
      PAGE_DOWN: 34,
      END: 35,
      HOME: 36,
      LEFT_ARROW : 37,
      UP_ARROW : 38,
      RIGHT_ARROW : 39,
      DOWN_ARROW : 40,
      TAB : 9,
      BACKSPACE: 8,
      DELETE: 46
    },

    /**
     * Vendor prefixed CSS properties to be used to support the given functionality in older browsers
     * as well.
     */
    CSS: {
      /* Constants */
      TRANSITIONEND: 'transitionend' + (isWebkit ? ' webkitTransitionEnd' : ''),
      ANIMATIONEND: 'animationend' + (isWebkit ? ' webkitAnimationEnd' : ''),

      TRANSFORM: vendorProperty('transform'),
      TRANSFORM_ORIGIN: vendorProperty('transformOrigin'),
      TRANSITION: vendorProperty('transition'),
      TRANSITION_DURATION: vendorProperty('transitionDuration'),
      ANIMATION_PLAY_STATE: vendorProperty('animationPlayState'),
      ANIMATION_DURATION: vendorProperty('animationDuration'),
      ANIMATION_NAME: vendorProperty('animationName'),
      ANIMATION_TIMING: vendorProperty('animationTimingFunction'),
      ANIMATION_DIRECTION: vendorProperty('animationDirection')
    },

    /**
     * As defined in core/style/variables.scss
     *
     * $layout-breakpoint-xs:     600px !default;
     * $layout-breakpoint-sm:     960px !default;
     * $layout-breakpoint-md:     1280px !default;
     * $layout-breakpoint-lg:     1920px !default;
     *
     */
    MEDIA: {
      'xs'        : '(max-width: 599px)'                         ,
      'gt-xs'     : '(min-width: 600px)'                         ,
      'sm'        : '(min-width: 600px) and (max-width: 959px)'  ,
      'gt-sm'     : '(min-width: 960px)'                         ,
      'md'        : '(min-width: 960px) and (max-width: 1279px)' ,
      'gt-md'     : '(min-width: 1280px)'                        ,
      'lg'        : '(min-width: 1280px) and (max-width: 1919px)',
      'gt-lg'     : '(min-width: 1920px)'                        ,
      'xl'        : '(min-width: 1920px)'                        ,
      'landscape' : '(orientation: landscape)'                   ,
      'portrait'  : '(orientation: portrait)'                    ,
      'print' : 'print'
    },

    MEDIA_PRIORITY: [
      'xl',
      'gt-lg',
      'lg',
      'gt-md',
      'md',
      'gt-sm',
      'sm',
      'gt-xs',
      'xs',
      'landscape',
      'portrait',
      'print'
    ]
  };

  return self;
}

  angular
    .module('material.core')
    .config( ["$provide", function($provide){
       $provide.decorator('$mdUtil', ['$delegate', function ($delegate){
           /**
            * Inject the iterator facade to easily support iteration and accessors
            * @see iterator below
            */
           $delegate.iterator = MdIterator;

           return $delegate;
         }
       ]);
     }]);

  /**
   * iterator is a list facade to easily support iteration and accessors
   *
   * @param items Array list which this iterator will enumerate
   * @param reloop Boolean enables iterator to consider the list as an endless reloop
   */
  function MdIterator(items, reloop) {
    var trueFn = function() { return true; };

    if (items && !angular.isArray(items)) {
      items = Array.prototype.slice.call(items);
    }

    reloop = !!reloop;
    var _items = items || [ ];

    // Published API
    return {
      items: getItems,
      count: count,

      inRange: inRange,
      contains: contains,
      indexOf: indexOf,
      itemAt: itemAt,

      findBy: findBy,

      add: add,
      remove: remove,

      first: first,
      last: last,
      next: angular.bind(null, findSubsequentItem, false),
      previous: angular.bind(null, findSubsequentItem, true),

      hasPrevious: hasPrevious,
      hasNext: hasNext

    };

    /**
     * Publish copy of the enumerable set
     * @returns {Array|*}
     */
    function getItems() {
      return [].concat(_items);
    }

    /**
     * Determine length of the list
     * @returns {Array.length|*|number}
     */
    function count() {
      return _items.length;
    }

    /**
     * Is the index specified valid
     * @param index
     * @returns {Array.length|*|number|boolean}
     */
    function inRange(index) {
      return _items.length && ( index > -1 ) && (index < _items.length );
    }

    /**
     * Can the iterator proceed to the next item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasNext(item) {
      return item ? inRange(indexOf(item) + 1) : false;
    }

    /**
     * Can the iterator proceed to the previous item in the list; relative to
     * the specified item.
     *
     * @param item
     * @returns {Array.length|*|number|boolean}
     */
    function hasPrevious(item) {
      return item ? inRange(indexOf(item) - 1) : false;
    }

    /**
     * Get item at specified index/position
     * @param index
     * @returns {*}
     */
    function itemAt(index) {
      return inRange(index) ? _items[index] : null;
    }

    /**
     * Find all elements matching the key/value pair
     * otherwise return null
     *
     * @param val
     * @param key
     *
     * @return array
     */
    function findBy(key, val) {
      return _items.filter(function(item) {
        return item[key] === val;
      });
    }

    /**
     * Add item to list
     * @param item
     * @param index
     * @returns {*}
     */
    function add(item, index) {
      if ( !item ) return -1;

      if (!angular.isNumber(index)) {
        index = _items.length;
      }

      _items.splice(index, 0, item);

      return indexOf(item);
    }

    /**
     * Remove item from list...
     * @param item
     */
    function remove(item) {
      if ( contains(item) ){
        _items.splice(indexOf(item), 1);
      }
    }

    /**
     * Get the zero-based index of the target item
     * @param item
     * @returns {*}
     */
    function indexOf(item) {
      return _items.indexOf(item);
    }

    /**
     * Boolean existence check
     * @param item
     * @returns {boolean}
     */
    function contains(item) {
      return item && (indexOf(item) > -1);
    }

    /**
     * Return first item in the list
     * @returns {*}
     */
    function first() {
      return _items.length ? _items[0] : null;
    }

    /**
     * Return last item in the list...
     * @returns {*}
     */
    function last() {
      return _items.length ? _items[_items.length - 1] : null;
    }

    /**
     * Find the next item. If reloop is true and at the end of the list, it will go back to the
     * first item. If given, the `validate` callback will be used to determine whether the next item
     * is valid. If not valid, it will try to find the next item again.
     *
     * @param {boolean} backwards Specifies the direction of searching (forwards/backwards)
     * @param {*} item The item whose subsequent item we are looking for
     * @param {Function=} validate The `validate` function
     * @param {integer=} limit The recursion limit
     *
     * @returns {*} The subsequent item or null
     */
    function findSubsequentItem(backwards, item, validate, limit) {
      validate = validate || trueFn;

      var curIndex = indexOf(item);
      while (true) {
        if (!inRange(curIndex)) return null;

        var nextIndex = curIndex + (backwards ? -1 : 1);
        var foundItem = null;
        if (inRange(nextIndex)) {
          foundItem = _items[nextIndex];
        } else if (reloop) {
          foundItem = backwards ? last() : first();
          nextIndex = indexOf(foundItem);
        }

        if ((foundItem === null) || (nextIndex === limit)) return null;
        if (validate(foundItem)) return foundItem;

        if (angular.isUndefined(limit)) limit = nextIndex;

        curIndex = nextIndex;
      }
    }
  }



mdMediaFactory['$inject'] = ["$mdConstant", "$rootScope", "$window"];angular.module('material.core')
.factory('$mdMedia', mdMediaFactory);

/**
 * @ngdoc service
 * @name $mdMedia
 * @module material.core
 *
 * @description
 * `$mdMedia` is used to evaluate whether a given media query is true or false given the
 * current device's screen / window size. The media query will be re-evaluated on resize, allowing
 * you to register a watch.
 *
 * `$mdMedia` also has pre-programmed support for media queries that match the layout breakpoints:
 *
 *  <table class="md-api-table">
 *    <thead>
 *    <tr>
 *      <th>Breakpoint</th>
 *      <th>mediaQuery</th>
 *    </tr>
 *    </thead>
 *    <tbody>
 *    <tr>
 *      <td>xs</td>
 *      <td>(max-width: 599px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-xs</td>
 *      <td>(min-width: 600px)</td>
 *    </tr>
 *    <tr>
 *      <td>sm</td>
 *      <td>(min-width: 600px) and (max-width: 959px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-sm</td>
 *      <td>(min-width: 960px)</td>
 *    </tr>
 *    <tr>
 *      <td>md</td>
 *      <td>(min-width: 960px) and (max-width: 1279px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-md</td>
 *      <td>(min-width: 1280px)</td>
 *    </tr>
 *    <tr>
 *      <td>lg</td>
 *      <td>(min-width: 1280px) and (max-width: 1919px)</td>
 *    </tr>
 *    <tr>
 *      <td>gt-lg</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>xl</td>
 *      <td>(min-width: 1920px)</td>
 *    </tr>
 *    <tr>
 *      <td>landscape</td>
 *      <td>landscape</td>
 *    </tr>
 *    <tr>
 *      <td>portrait</td>
 *      <td>portrait</td>
 *    </tr>
 *    <tr>
 *      <td>print</td>
 *      <td>print</td>
 *    </tr>
 *    </tbody>
 *  </table>
 *
 *  See Material Design's <a href="https://material.google.com/layout/responsive-ui.html">Layout - Adaptive UI</a> for more details.
 *
 *  <a href="https://www.google.com/design/spec/layout/adaptive-ui.html">
 *  <img src="https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png" width="100%" height="100%"></img>
 *  </a>
 *
 * @returns {boolean} a boolean representing whether or not the given media query is true or false.
 *
 * @usage
 * <hljs lang="js">
 * app.controller('MyController', function($mdMedia, $scope) {
 *   $scope.$watch(function() { return $mdMedia('lg'); }, function(big) {
 *     $scope.bigScreen = big;
 *   });
 *
 *   $scope.screenIsSmall = $mdMedia('sm');
 *   $scope.customQuery = $mdMedia('(min-width: 1234px)');
 *   $scope.anotherCustom = $mdMedia('max-width: 300px');
 * });
 * </hljs>
 */

/* ngInject */
function mdMediaFactory($mdConstant, $rootScope, $window) {
  var queries = {};
  var mqls = {};
  var results = {};
  var normalizeCache = {};

  $mdMedia.getResponsiveAttribute = getResponsiveAttribute;
  $mdMedia.getQuery = getQuery;
  $mdMedia.watchResponsiveAttributes = watchResponsiveAttributes;

  return $mdMedia;

  function $mdMedia(query) {
    var validated = queries[query];
    if (angular.isUndefined(validated)) {
      validated = queries[query] = validate(query);
    }

    var result = results[validated];
    if (angular.isUndefined(result)) {
      result = add(validated);
    }

    return result;
  }

  function validate(query) {
    return $mdConstant.MEDIA[query] ||
           ((query.charAt(0) !== '(') ? ('(' + query + ')') : query);
  }

  function add(query) {
    var result = mqls[query];
    if ( !result ) {
      result = mqls[query] = $window.matchMedia(query);
    }

    result.addListener(onQueryChange);
    return (results[result.media] = !!result.matches);
  }

  function onQueryChange(query) {
    $rootScope.$evalAsync(function() {
      results[query.media] = !!query.matches;
    });
  }

  function getQuery(name) {
    return mqls[name];
  }

  function getResponsiveAttribute(attrs, attrName) {
    for (var i = 0; i < $mdConstant.MEDIA_PRIORITY.length; i++) {
      var mediaName = $mdConstant.MEDIA_PRIORITY[i];
      if (!mqls[queries[mediaName]].matches) {
        continue;
      }

      var normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
      if (attrs[normalizedName]) {
        return attrs[normalizedName];
      }
    }

    // fallback on unprefixed
    return attrs[getNormalizedName(attrs, attrName)];
  }

  function watchResponsiveAttributes(attrNames, attrs, watchFn) {
    var unwatchFns = [];
    attrNames.forEach(function(attrName) {
      var normalizedName = getNormalizedName(attrs, attrName);
      if (angular.isDefined(attrs[normalizedName])) {
        unwatchFns.push(
            attrs.$observe(normalizedName, angular.bind(void 0, watchFn, null)));
      }

      for (var mediaName in $mdConstant.MEDIA) {
        normalizedName = getNormalizedName(attrs, attrName + '-' + mediaName);
        if (angular.isDefined(attrs[normalizedName])) {
          unwatchFns.push(
              attrs.$observe(normalizedName, angular.bind(void 0, watchFn, mediaName)));
        }
      }
    });

    return function unwatch() {
      unwatchFns.forEach(function(fn) { fn(); });
    };
  }

  // Improves performance dramatically
  function getNormalizedName(attrs, attrName) {
    return normalizeCache[attrName] ||
        (normalizeCache[attrName] = attrs.$normalize(attrName));
  }
}

angular
  .module('material.core')
  .config( ["$provide", function($provide) {
    $provide.decorator('$mdUtil', ['$delegate', function ($delegate) {

      // Inject the prefixer into our original $mdUtil service.
      $delegate.prefixer = MdPrefixer;

      return $delegate;
    }]);
  }]);

function MdPrefixer(initialAttributes, buildSelector) {
  var PREFIXES = ['data', 'x'];

  if (initialAttributes) {
    // The prefixer also accepts attributes as a parameter, and immediately builds a list or selector for
    // the specified attributes.
    return buildSelector ? _buildSelector(initialAttributes) : _buildList(initialAttributes);
  }

  return {
    buildList: _buildList,
    buildSelector: _buildSelector,
    hasAttribute: _hasAttribute,
    removeAttribute: _removeAttribute
  };

  function _buildList(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    attributes.forEach(function(item) {
      PREFIXES.forEach(function(prefix) {
        attributes.push(prefix + '-' + item);
      });
    });

    return attributes;
  }

  function _buildSelector(attributes) {
    attributes = angular.isArray(attributes) ? attributes : [attributes];

    return _buildList(attributes)
      .map(function(item) {
        return '[' + item + ']';
      })
      .join(',');
  }

  function _hasAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return false;
    }

    var prefixedAttrs = _buildList(attribute);

    for (var i = 0; i < prefixedAttrs.length; i++) {
      if (element.hasAttribute(prefixedAttrs[i])) {
        return true;
      }
    }

    return false;
  }

  function _removeAttribute(element, attribute) {
    element = _getNativeElement(element);

    if (!element) {
      return;
    }

    _buildList(attribute).forEach(function(prefixedAttribute) {
      element.removeAttribute(prefixedAttribute);
    });
  }

  /**
   * Transforms a jqLite or DOM element into a HTML element.
   * This is useful when supporting jqLite elements and DOM elements at
   * same time.
   * @param element {JQLite|Element} Element to be parsed
   * @returns {HTMLElement} Parsed HTMLElement
   */
  function _getNativeElement(element) {
    element =  element[0] || element;

    if (element.nodeType) {
      return element;
    }
  }

}

/*
 * This var has to be outside the angular factory, otherwise when
 * there are multiple material apps on the same page, each app
 * will create its own instance of this array and the app's IDs
 * will not be unique.
 */
UtilFactory['$inject'] = ["$document", "$timeout", "$compile", "$rootScope", "$$mdAnimate", "$interpolate", "$log", "$rootElement", "$window", "$$rAF"];
var nextUniqueId = 0;

/**
 * @ngdoc module
 * @name material.core.util
 * @description
 * Util
 */
angular
  .module('material.core')
  .factory('$mdUtil', UtilFactory);

/**
 * ngInject
 */
function UtilFactory($document, $timeout, $compile, $rootScope, $$mdAnimate, $interpolate, $log, $rootElement, $window, $$rAF) {
  // Setup some core variables for the processTemplate method
  var startSymbol = $interpolate.startSymbol(),
    endSymbol = $interpolate.endSymbol(),
    usesStandardSymbols = ((startSymbol === '{{') && (endSymbol === '}}'));

  /**
   * Checks if the target element has the requested style by key
   * @param {DOMElement|JQLite} target Target element
   * @param {string} key Style key
   * @param {string=} expectedVal Optional expected value
   * @returns {boolean} Whether the target element has the style or not
   */
  var hasComputedStyle = function (target, key, expectedVal) {
    var hasValue = false;

    if ( target && target.length  ) {
      var computedStyles = $window.getComputedStyle(target[0]);
      hasValue = angular.isDefined(computedStyles[key]) && (expectedVal ? computedStyles[key] == expectedVal : true);
    }

    return hasValue;
  };

  function validateCssValue(value) {
    return !value       ? '0'   :
      hasPx(value) || hasPercent(value) ? value : value + 'px';
  }

  function hasPx(value) {
    return String(value).indexOf('px') > -1;
  }

  function hasPercent(value) {
    return String(value).indexOf('%') > -1;

  }

  var $mdUtil = {
    dom: {},
    now: window.performance && window.performance.now ?
      angular.bind(window.performance, window.performance.now) : Date.now || function() {
      return new Date().getTime();
    },

    /**
     * Cross-version compatibility method to retrieve an option of a ngModel controller,
     * which supports the breaking changes in the AngularJS snapshot (SHA 87a2ff76af5d0a9268d8eb84db5755077d27c84c).
     * @param {!angular.ngModelCtrl} ngModelCtrl
     * @param {!string} optionName
     * @returns {Object|undefined}
     */
    getModelOption: function (ngModelCtrl, optionName) {
      if (!ngModelCtrl.$options) {
        return;
      }

      var $options = ngModelCtrl.$options;

      // The newer versions of Angular introduced a `getOption function and made the option values no longer
      // visible on the $options object.
      return $options.getOption ? $options.getOption(optionName) : $options[optionName]
    },

    /**
     * Bi-directional accessor/mutator used to easily update an element's
     * property based on the current 'dir'ectional value.
     */
    bidi : function(element, property, lValue, rValue) {
      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');

      // If accessor
      if ( arguments.length == 0 ) return ltr ? 'ltr' : 'rtl';

      // If mutator
      var elem = angular.element(element);

      if ( ltr && angular.isDefined(lValue)) {
        elem.css(property, validateCssValue(lValue));
      }
      else if ( !ltr && angular.isDefined(rValue)) {
        elem.css(property, validateCssValue(rValue) );
      }
    },

    bidiProperty: function (element, lProperty, rProperty, value) {
      var ltr = !($document[0].dir == 'rtl' || $document[0].body.dir == 'rtl');

      var elem = angular.element(element);

      if ( ltr && angular.isDefined(lProperty)) {
        elem.css(lProperty, validateCssValue(value));
        elem.css(rProperty, '');
      }
      else if ( !ltr && angular.isDefined(rProperty)) {
        elem.css(rProperty, validateCssValue(value) );
        elem.css(lProperty, '');
      }
    },

    clientRect: function(element, offsetParent, isOffsetRect) {
      var node = getNode(element);
      offsetParent = getNode(offsetParent || node.offsetParent || document.body);
      var nodeRect = node.getBoundingClientRect();

      // The user can ask for an offsetRect: a rect relative to the offsetParent,
      // or a clientRect: a rect relative to the page
      var offsetRect = isOffsetRect ?
        offsetParent.getBoundingClientRect() :
      {left: 0, top: 0, width: 0, height: 0};
      return {
        left: nodeRect.left - offsetRect.left,
        top: nodeRect.top - offsetRect.top,
        width: nodeRect.width,
        height: nodeRect.height
      };
    },
    offsetRect: function(element, offsetParent) {
      return $mdUtil.clientRect(element, offsetParent, true);
    },

    // Annoying method to copy nodes to an array, thanks to IE
    nodesToArray: function(nodes) {
      nodes = nodes || [];

      var results = [];
      for (var i = 0; i < nodes.length; ++i) {
        results.push(nodes.item(i));
      }
      return results;
    },

    /**
     * Determines the absolute position of the viewport.
     * Useful when making client rectangles absolute.
     * @returns {number}
     */
    getViewportTop: function() {
      return window.scrollY || window.pageYOffset || 0;
    },

    /**
     * Finds the proper focus target by searching the DOM.
     *
     * @param containerEl
     * @param attributeVal
     * @returns {*}
     */
    findFocusTarget: function(containerEl, attributeVal) {
      var AUTO_FOCUS = this.prefixer('md-autofocus', true);
      var elToFocus;

      elToFocus = scanForFocusable(containerEl, attributeVal || AUTO_FOCUS);

      if ( !elToFocus && attributeVal != AUTO_FOCUS) {
        // Scan for deprecated attribute
        elToFocus = scanForFocusable(containerEl, this.prefixer('md-auto-focus', true));

        if ( !elToFocus ) {
          // Scan for fallback to 'universal' API
          elToFocus = scanForFocusable(containerEl, AUTO_FOCUS);
        }
      }

      return elToFocus;

      /**
       * Can target and nested children for specified Selector (attribute)
       * whose value may be an expression that evaluates to True/False.
       */
      function scanForFocusable(target, selector) {
        var elFound, items = target[0].querySelectorAll(selector);

        // Find the last child element with the focus attribute
        if ( items && items.length ){
          items.length && angular.forEach(items, function(it) {
            it = angular.element(it);

            // Check the element for the md-autofocus class to ensure any associated expression
            // evaluated to true.
            var isFocusable = it.hasClass('md-autofocus');
            if (isFocusable) elFound = it;
          });
        }
        return elFound;
      }
    },

    /**
     * Disables scroll around the passed parent element.
     * @param element Unused
     * @param {!Element|!angular.JQLite} parent Element to disable scrolling within.
     *   Defaults to body if none supplied.
     * @param options Object of options to modify functionality
     *   - disableScrollMask Boolean of whether or not to create a scroll mask element or
     *     use the passed parent element.
     */
    disableScrollAround: function(element, parent, options) {
      options = options || {};

      $mdUtil.disableScrollAround._count = Math.max(0, $mdUtil.disableScrollAround._count || 0);
      $mdUtil.disableScrollAround._count++;

      if ($mdUtil.disableScrollAround._restoreScroll) {
        return $mdUtil.disableScrollAround._restoreScroll;
      }

      var body = $document[0].body;
      var restoreBody = disableBodyScroll();
      var restoreElement = disableElementScroll(parent);

      return $mdUtil.disableScrollAround._restoreScroll = function() {
        if (--$mdUtil.disableScrollAround._count <= 0) {
          restoreBody();
          restoreElement();
          delete $mdUtil.disableScrollAround._restoreScroll;
        }
      };

      /**
       * Creates a virtual scrolling mask to prevent touchmove, keyboard, scrollbar clicking,
       * and wheel events
       */
      function disableElementScroll(element) {
        element = angular.element(element || body);

        var scrollMask;

        if (options.disableScrollMask) {
          scrollMask = element;
        } else {
          scrollMask = angular.element(
            '<div class="md-scroll-mask">' +
            '  <div class="md-scroll-mask-bar"></div>' +
            '</div>');
          element.append(scrollMask);
        }

        scrollMask.on('wheel', preventDefault);
        scrollMask.on('touchmove', preventDefault);

        return function restoreElementScroll() {
          scrollMask.off('wheel');
          scrollMask.off('touchmove');

          if (!options.disableScrollMask) {
            scrollMask[0].parentNode.removeChild(scrollMask[0]);
          }
        };

        function preventDefault(e) {
          e.preventDefault();
        }
      }

      // Converts the body to a position fixed block and translate it to the proper scroll position
      function disableBodyScroll() {
        var documentElement = $document[0].documentElement;

        var prevDocumentStyle = documentElement.style.cssText || '';
        var prevBodyStyle = body.style.cssText || '';

        var viewportTop = $mdUtil.getViewportTop();
        var clientWidth = body.clientWidth;
        var hasVerticalScrollbar = body.scrollHeight > body.clientHeight + 1;

        if (hasVerticalScrollbar) {
          angular.element(body).css({
            position: 'fixed',
            width: '100%',
            top: -viewportTop + 'px'
          });
        }

        if (body.clientWidth < clientWidth) {
          body.style.overflow = 'hidden';
        }

        // This should be applied after the manipulation to the body, because
        // adding a scrollbar can potentially resize it, causing the measurement
        // to change.
        if (hasVerticalScrollbar) {
          documentElement.style.overflowY = 'scroll';
        }

        return function restoreScroll() {
          // Reset the inline style CSS to the previous.
          body.style.cssText = prevBodyStyle;
          documentElement.style.cssText = prevDocumentStyle;

          // The body loses its scroll position while being fixed.
          body.scrollTop = viewportTop;
        };
      }

    },

    enableScrolling: function() {
      var restoreFn = this.disableScrollAround._restoreScroll;
      restoreFn && restoreFn();
    },

    floatingScrollbars: function() {
      if (this.floatingScrollbars.cached === undefined) {
        var tempNode = angular.element('<div><div></div></div>').css({
          width: '100%',
          'z-index': -1,
          position: 'absolute',
          height: '35px',
          'overflow-y': 'scroll'
        });
        tempNode.children().css('height', '60px');

        $document[0].body.appendChild(tempNode[0]);
        this.floatingScrollbars.cached = (tempNode[0].offsetWidth == tempNode[0].childNodes[0].offsetWidth);
        tempNode.remove();
      }
      return this.floatingScrollbars.cached;
    },

    // Mobile safari only allows you to set focus in click event listeners...
    forceFocus: function(element) {
      var node = element[0] || element;

      document.addEventListener('click', function focusOnClick(ev) {
        if (ev.target === node && ev.$focus) {
          node.focus();
          ev.stopImmediatePropagation();
          ev.preventDefault();
          node.removeEventListener('click', focusOnClick);
        }
      }, true);

      var newEvent = document.createEvent('MouseEvents');
      newEvent.initMouseEvent('click', false, true, window, {}, 0, 0, 0, 0,
        false, false, false, false, 0, null);
      newEvent.$material = true;
      newEvent.$focus = true;
      node.dispatchEvent(newEvent);
    },

    /**
     * facade to build md-backdrop element with desired styles
     * NOTE: Use $compile to trigger backdrop postLink function
     */
    createBackdrop: function(scope, addClass) {
      return $compile($mdUtil.supplant('<md-backdrop class="{0}">', [addClass]))(scope);
    },

    /**
     * supplant() method from Crockford's `Remedial Javascript`
     * Equivalent to use of $interpolate; without dependency on
     * interpolation symbols and scope. Note: the '{<token>}' can
     * be property names, property chains, or array indices.
     */
    supplant: function(template, values, pattern) {
      pattern = pattern || /\{([^\{\}]*)\}/g;
      return template.replace(pattern, function(a, b) {
        var p = b.split('.'),
          r = values;
        try {
          for (var s in p) {
            if (p.hasOwnProperty(s) ) {
              r = r[p[s]];
            }
          }
        } catch (e) {
          r = a;
        }
        return (typeof r === 'string' || typeof r === 'number') ? r : a;
      });
    },

    fakeNgModel: function() {
      return {
        $fake: true,
        $setTouched: angular.noop,
        $setViewValue: function(value) {
          this.$viewValue = value;
          this.$render(value);
          this.$viewChangeListeners.forEach(function(cb) {
            cb();
          });
        },
        $isEmpty: function(value) {
          return ('' + value).length === 0;
        },
        $parsers: [],
        $formatters: [],
        $viewChangeListeners: [],
        $render: angular.noop
      };
    },

    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds.
    // @param wait Integer value of msecs to delay (since last debounce reset); default value 10 msecs
    // @param invokeApply should the $timeout trigger $digest() dirty checking
    debounce: function(func, wait, scope, invokeApply) {
      var timer;

      return function debounced() {
        var context = scope,
          args = Array.prototype.slice.call(arguments);

        $timeout.cancel(timer);
        timer = $timeout(function() {

          timer = undefined;
          func.apply(context, args);

        }, wait || 10, invokeApply);
      };
    },

    // Returns a function that can only be triggered every `delay` milliseconds.
    // In other words, the function will not be called unless it has been more
    // than `delay` milliseconds since the last call.
    throttle: function throttle(func, delay) {
      var recent;
      return function throttled() {
        var context = this;
        var args = arguments;
        var now = $mdUtil.now();

        if (!recent || (now - recent > delay)) {
          func.apply(context, args);
          recent = now;
        }
      };
    },

    /**
     * Measures the number of milliseconds taken to run the provided callback
     * function. Uses a high-precision timer if available.
     */
    time: function time(cb) {
      var start = $mdUtil.now();
      cb();
      return $mdUtil.now() - start;
    },

    /**
     * Create an implicit getter that caches its `getter()`
     * lookup value
     */
    valueOnUse : function (scope, key, getter) {
      var value = null, args = Array.prototype.slice.call(arguments);
      var params = (args.length > 3) ? args.slice(3) : [ ];

      Object.defineProperty(scope, key, {
        get: function () {
          if (value === null) value = getter.apply(scope, params);
          return value;
        }
      });
    },

    /**
     * Get a unique ID.
     *
     * @returns {string} an unique numeric string
     */
    nextUid: function() {
      return '' + nextUniqueId++;
    },

    // Stop watchers and events from firing on a scope without destroying it,
    // by disconnecting it from its parent and its siblings' linked lists.
    disconnectScope: function disconnectScope(scope) {
      if (!scope) return;

      // we can't destroy the root scope or a scope that has been already destroyed
      if (scope.$root === scope) return;
      if (scope.$$destroyed) return;

      var parent = scope.$parent;
      scope.$$disconnected = true;

      // See Scope.$destroy
      if (parent.$$childHead === scope) parent.$$childHead = scope.$$nextSibling;
      if (parent.$$childTail === scope) parent.$$childTail = scope.$$prevSibling;
      if (scope.$$prevSibling) scope.$$prevSibling.$$nextSibling = scope.$$nextSibling;
      if (scope.$$nextSibling) scope.$$nextSibling.$$prevSibling = scope.$$prevSibling;

      scope.$$nextSibling = scope.$$prevSibling = null;

    },

    // Undo the effects of disconnectScope above.
    reconnectScope: function reconnectScope(scope) {
      if (!scope) return;

      // we can't disconnect the root node or scope already disconnected
      if (scope.$root === scope) return;
      if (!scope.$$disconnected) return;

      var child = scope;

      var parent = child.$parent;
      child.$$disconnected = false;
      // See Scope.$new for this logic...
      child.$$prevSibling = parent.$$childTail;
      if (parent.$$childHead) {
        parent.$$childTail.$$nextSibling = child;
        parent.$$childTail = child;
      } else {
        parent.$$childHead = parent.$$childTail = child;
      }
    },

    /*
     * getClosest replicates jQuery.closest() to walk up the DOM tree until it finds a matching nodeName
     *
     * @param el Element to start walking the DOM from
     * @param check Either a string or a function. If a string is passed, it will be evaluated against
     * each of the parent nodes' tag name. If a function is passed, the loop will call it with each of
     * the parents and will use the return value to determine whether the node is a match.
     * @param onlyParent Only start checking from the parent element, not `el`.
     */
    getClosest: function getClosest(el, validateWith, onlyParent) {
      if ( angular.isString(validateWith) ) {
        var tagName = validateWith.toUpperCase();
        validateWith = function(el) {
          return el.nodeName.toUpperCase() === tagName;
        };
      }

      if (el instanceof angular.element) el = el[0];
      if (onlyParent) el = el.parentNode;
      if (!el) return null;

      do {
        if (validateWith(el)) {
          return el;
        }
      } while (el = el.parentNode);

      return null;
    },

    /**
     * Build polyfill for the Node.contains feature (if needed)
     */
    elementContains: function(node, child) {
      var hasContains = (window.Node && window.Node.prototype && Node.prototype.contains);
      var findFn = hasContains ? angular.bind(node, node.contains) : angular.bind(node, function(arg) {
        // compares the positions of two nodes and returns a bitmask
        return (node === child) || !!(this.compareDocumentPosition(arg) & 16)
      });

      return findFn(child);
    },

    /**
     * Functional equivalent for $element.filter(‘md-bottom-sheet’)
     * useful with interimElements where the element and its container are important...
     *
     * @param {[]} elements to scan
     * @param {string} name of node to find (e.g. 'md-dialog')
     * @param {boolean=} optional flag to allow deep scans; defaults to 'false'.
     * @param {boolean=} optional flag to enable log warnings; defaults to false
     */
    extractElementByName: function(element, nodeName, scanDeep, warnNotFound) {
      var found = scanTree(element);
      if (!found && !!warnNotFound) {
        $log.warn( $mdUtil.supplant("Unable to find node '{0}' in element '{1}'.",[nodeName, element[0].outerHTML]) );
      }

      return angular.element(found || element);

      /**
       * Breadth-First tree scan for element with matching `nodeName`
       */
      function scanTree(element) {
        return scanLevel(element) || (!!scanDeep ? scanChildren(element) : null);
      }

      /**
       * Case-insensitive scan of current elements only (do not descend).
       */
      function scanLevel(element) {
        if ( element ) {
          for (var i = 0, len = element.length; i < len; i++) {
            if (element[i].nodeName.toLowerCase() === nodeName) {
              return element[i];
            }
          }
        }
        return null;
      }

      /**
       * Scan children of specified node
       */
      function scanChildren(element) {
        var found;
        if ( element ) {
          for (var i = 0, len = element.length; i < len; i++) {
            var target = element[i];
            if ( !found ) {
              for (var j = 0, numChild = target.childNodes.length; j < numChild; j++) {
                found = found || scanTree([target.childNodes[j]]);
              }
            }
          }
        }
        return found;
      }

    },

    /**
     * Give optional properties with no value a boolean true if attr provided or false otherwise
     */
    initOptionalProperties: function(scope, attr, defaults) {
      defaults = defaults || {};
      angular.forEach(scope.$$isolateBindings, function(binding, key) {
        if (binding.optional && angular.isUndefined(scope[key])) {
          var attrIsDefined = angular.isDefined(attr[binding.attrName]);
          scope[key] = angular.isDefined(defaults[key]) ? defaults[key] : attrIsDefined;
        }
      });
    },

    /**
     * Alternative to $timeout calls with 0 delay.
     * nextTick() coalesces all calls within a single frame
     * to minimize $digest thrashing
     *
     * @param callback
     * @param digest
     * @returns {*}
     */
    nextTick: function(callback, digest, scope) {
      //-- grab function reference for storing state details
      var nextTick = $mdUtil.nextTick;
      var timeout = nextTick.timeout;
      var queue = nextTick.queue || [];

      //-- add callback to the queue
      queue.push({scope: scope, callback: callback});

      //-- set default value for digest
      if (digest == null) digest = true;

      //-- store updated digest/queue values
      nextTick.digest = nextTick.digest || digest;
      nextTick.queue = queue;

      //-- either return existing timeout or create a new one
      return timeout || (nextTick.timeout = $timeout(processQueue, 0, false));

      /**
       * Grab a copy of the current queue
       * Clear the queue for future use
       * Process the existing queue
       * Trigger digest if necessary
       */
      function processQueue() {
        var queue = nextTick.queue;
        var digest = nextTick.digest;

        nextTick.queue = [];
        nextTick.timeout = null;
        nextTick.digest = false;

        queue.forEach(function(queueItem) {
          var skip = queueItem.scope && queueItem.scope.$$destroyed;
          if (!skip) {
            queueItem.callback();
          }
        });

        if (digest) $rootScope.$digest();
      }
    },

    /**
     * Processes a template and replaces the start/end symbols if the application has
     * overriden them.
     *
     * @param template The template to process whose start/end tags may be replaced.
     * @returns {*}
     */
    processTemplate: function(template) {
      if (usesStandardSymbols) {
        return template;
      } else {
        if (!template || !angular.isString(template)) return template;
        return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
      }
    },

    /**
     * Scan up dom hierarchy for enabled parent;
     */
    getParentWithPointerEvents: function (element) {
      var parent = element.parent();

      // jqLite might return a non-null, but still empty, parent; so check for parent and length
      while (hasComputedStyle(parent, 'pointer-events', 'none')) {
        parent = parent.parent();
      }

      return parent;
    },

    getNearestContentElement: function (element) {
      var current = element.parent()[0];
      // Look for the nearest parent md-content, stopping at the rootElement.
      while (current && current !== $rootElement[0] && current !== document.body && current.nodeName.toUpperCase() !== 'MD-CONTENT') {
        current = current.parentNode;
      }
      return current;
    },

    /**
     * Checks if the current browser is natively supporting the `sticky` position.
     * @returns {string} supported sticky property name
     */
    checkStickySupport: function() {
      var stickyProp;
      var testEl = angular.element('<div>');
      $document[0].body.appendChild(testEl[0]);

      var stickyProps = ['sticky', '-webkit-sticky'];
      for (var i = 0; i < stickyProps.length; ++i) {
        testEl.css({
          position: stickyProps[i],
          top: 0,
          'z-index': 2
        });

        if (testEl.css('position') == stickyProps[i]) {
          stickyProp = stickyProps[i];
          break;
        }
      }

      testEl.remove();

      return stickyProp;
    },

    /**
     * Parses an attribute value, mostly a string.
     * By default checks for negated values and returns `false´ if present.
     * Negated values are: (native falsy) and negative strings like:
     * `false` or `0`.
     * @param value Attribute value which should be parsed.
     * @param negatedCheck When set to false, won't check for negated values.
     * @returns {boolean}
     */
    parseAttributeBoolean: function(value, negatedCheck) {
      return value === '' || !!value && (negatedCheck === false || value !== 'false' && value !== '0');
    },

    hasComputedStyle: hasComputedStyle,

    /**
     * Returns true if the parent form of the element has been submitted.
     *
     * @param element An Angular or HTML5 element.
     *
     * @returns {boolean}
     */
    isParentFormSubmitted: function(element) {
      var parent = $mdUtil.getClosest(element, 'form');
      var form = parent ? angular.element(parent).controller('form') : null;

      return form ? form.$submitted : false;
    },

    /**
     * Animate the requested element's scrollTop to the requested scrollPosition with basic easing.
     *
     * @param {!HTMLElement} element The element to scroll.
     * @param {number} scrollEnd The new/final scroll position.
     * @param {number=} duration Duration of the scroll. Default is 1000ms.
     */
    animateScrollTo: function(element, scrollEnd, duration) {
      var scrollStart = element.scrollTop;
      var scrollChange = scrollEnd - scrollStart;
      var scrollingDown = scrollStart < scrollEnd;
      var startTime = $mdUtil.now();

      $$rAF(scrollChunk);

      function scrollChunk() {
        var newPosition = calculateNewPosition();

        element.scrollTop = newPosition;

        if (scrollingDown ? newPosition < scrollEnd : newPosition > scrollEnd) {
          $$rAF(scrollChunk);
        }
      }

      function calculateNewPosition() {
        var easeDuration = duration || 1000;
        var currentTime = $mdUtil.now() - startTime;

        return ease(currentTime, scrollStart, scrollChange, easeDuration);
      }

      function ease(currentTime, start, change, duration) {
        // If the duration has passed (which can occur if our app loses focus due to $$rAF), jump
        // straight to the proper position
        if (currentTime > duration) {
          return start + change;
        }

        var ts = (currentTime /= duration) * currentTime;
        var tc = ts * currentTime;

        return start + change * (-2 * tc + 3 * ts);
      }
    },

    /**
     * Provides an easy mechanism for removing duplicates from an array.
     *
     *    var myArray = [1, 2, 2, 3, 3, 3, 4, 4, 4, 4];
     *
     *    $mdUtil.uniq(myArray) => [1, 2, 3, 4]
     *
     * @param {array} array The array whose unique values should be returned.
     *
     * @returns {array} A copy of the array containing only unique values.
     */
    uniq: function(array) {
      if (!array) { return; }

      return array.filter(function(value, index, self) {
        return self.indexOf(value) === index;
      });
    }
  };


// Instantiate other namespace utility methods

  $mdUtil.dom.animator = $$mdAnimate($mdUtil);

  return $mdUtil;

  function getNode(el) {
    return el[0] || el;
  }

}

/*
 * Since removing jQuery from the demos, some code that uses `element.focus()` is broken.
 * We need to add `element.focus()`, because it's testable unlike `element[0].focus`.
 */

angular.element.prototype.focus = angular.element.prototype.focus || function() {
    if (this.length) {
      this[0].focus();
    }
    return this;
  };
angular.element.prototype.blur = angular.element.prototype.blur || function() {
    if (this.length) {
      this[0].blur();
    }
    return this;
  };

/**
 * @ngdoc module
 * @name material.core.aria
 * @description
 * Aria Expectations for ngMaterial components.
 */
MdAriaService['$inject'] = ["$$rAF", "$log", "$window", "$interpolate"];
angular
  .module('material.core')
  .provider('$mdAria', MdAriaProvider);

/**
 * @ngdoc service
 * @name $mdAriaProvider
 * @module material.core.aria
 *
 * @description
 *
 * Modify options of the `$mdAria` service, which will be used by most of the Angular Material
 * components.
 *
 * You are able to disable `$mdAria` warnings, by using the following markup.
 *
 * <hljs lang="js">
 *   app.config(function($mdAriaProvider) {
 *     // Globally disables all ARIA warnings.
 *     $mdAriaProvider.disableWarnings();
 *   });
 * </hljs>
 *
 */
function MdAriaProvider() {

  var config = {
    /** Whether we should show ARIA warnings in the console if labels are missing on the element */
    showWarnings: true
  };

  return {
    disableWarnings: disableWarnings,
    $get: ["$$rAF", "$log", "$window", "$interpolate", function($$rAF, $log, $window, $interpolate) {
      return MdAriaService.apply(config, arguments);
    }]
  };

  /**
   * @ngdoc method
   * @name $mdAriaProvider#disableWarnings
   * @description Disables all ARIA warnings generated by Angular Material.
   */
  function disableWarnings() {
    config.showWarnings = false;
  }
}

/*
 * ngInject
 */
function MdAriaService($$rAF, $log, $window, $interpolate) {

  // Load the showWarnings option from the current context and store it inside of a scope variable,
  // because the context will be probably lost in some function calls.
  var showWarnings = this.showWarnings;

  return {
    expect: expect,
    expectAsync: expectAsync,
    expectWithText: expectWithText,
    expectWithoutText: expectWithoutText,
    getText: getText
  };

  /**
   * Check if expected attribute has been specified on the target element or child
   * @param element
   * @param attrName
   * @param {optional} defaultValue What to set the attr to if no value is found
   */
  function expect(element, attrName, defaultValue) {

    var node = angular.element(element)[0] || element;

    // if node exists and neither it nor its children have the attribute
    if (node &&
       ((!node.hasAttribute(attrName) ||
        node.getAttribute(attrName).length === 0) &&
        !childHasAttribute(node, attrName))) {

      defaultValue = angular.isString(defaultValue) ? defaultValue.trim() : '';
      if (defaultValue.length) {
        element.attr(attrName, defaultValue);
      } else if (showWarnings) {
        $log.warn('ARIA: Attribute "', attrName, '", required for accessibility, is missing on node:', node);
      }

    }
  }

  function expectAsync(element, attrName, defaultValueGetter) {
    // Problem: when retrieving the element's contents synchronously to find the label,
    // the text may not be defined yet in the case of a binding.
    // There is a higher chance that a binding will be defined if we wait one frame.
    $$rAF(function() {
        expect(element, attrName, defaultValueGetter());
    });
  }

  function expectWithText(element, attrName) {
    var content = getText(element) || "";
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if (hasBinding) {
      expectAsync(element, attrName, function() {
        return getText(element);
      });
    } else {
      expect(element, attrName, content);
    }
  }

  function expectWithoutText(element, attrName) {
    var content = getText(element);
    var hasBinding = content.indexOf($interpolate.startSymbol()) > -1;

    if ( !hasBinding && !content) {
      expect(element, attrName, content);
    }
  }

  function getText(element) {
    element = element[0] || element;
    var walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null, false);
    var text = '';

    var node;
    while (node = walker.nextNode()) {
      if (!isAriaHiddenNode(node)) {
        text += node.textContent;
      }
    }

    return text.trim() || '';

    function isAriaHiddenNode(node) {
      while (node.parentNode && (node = node.parentNode) !== element) {
        if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
          return true;
        }
      }
    }
  }

  function childHasAttribute(node, attrName) {
    var hasChildren = node.hasChildNodes(),
        hasAttr = false;

    function isHidden(el) {
      var style = el.currentStyle ? el.currentStyle : $window.getComputedStyle(el);
      return (style.display === 'none');
    }

    if (hasChildren) {
      var children = node.childNodes;
      for (var i=0; i < children.length; i++) {
        var child = children[i];
        if (child.nodeType === 1 && child.hasAttribute(attrName)) {
          if (!isHidden(child)) {
            hasAttr = true;
          }
        }
      }
    }

    return hasAttr;
  }
}

/**
 * @ngdoc module
 * @name material.core.compiler
 * @description
 * Angular Material template and element compiler.
 */
MdCompilerService['$inject'] = ["$q", "$templateRequest", "$injector", "$compile", "$controller"];
angular
  .module('material.core')
  .service('$mdCompiler', MdCompilerService);

/**
 * @ngdoc service
 * @name $mdCompiler
 * @module material.core.compiler
 * @description
 * The $mdCompiler service is an abstraction of Angular's compiler, that allows developers
 * to easily compile an element with options like in a Directive Definition Object.
 *
 * > The compiler powers a lot of components inside of Angular Material.
 * > Like the `$mdPanel` or `$mdDialog`.
 *
 * @usage
 *
 * Basic Usage with a template
 *
 * <hljs lang="js">
 *   $mdCompiler.compile({
 *     templateUrl: 'modal.html',
 *     controller: 'ModalCtrl',
 *     locals: {
 *       modal: myModalInstance;
 *     }
 *   }).then(function (compileData) {
 *     compileData.element; // Compiled DOM element
 *     compileData.link(myScope); // Instantiate controller and link element to scope.
 *   });
 * </hljs>
 *
 * Example with a content element
 *
 * <hljs lang="js">
 *
 *   // Create a virtual element and link it manually.
 *   // The compiler doesn't need to recompile the element each time.
 *   var myElement = $compile('<span>Test</span>')(myScope);
 *
 *   $mdCompiler.compile({
 *     contentElement: myElement
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 * > Content Element is a significant performance improvement when the developer already knows that the
 * > compiled element will be always the same and the scope will not change either.
 *
 * The `contentElement` option also supports DOM elements which will be temporary removed and restored
 * at its old position.
 *
 * <hljs lang="js">
 *   var domElement = document.querySelector('#myElement');
 *
 *   $mdCompiler.compile({
 *     contentElement: myElement
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 * The `$mdCompiler` can also query for the element in the DOM itself.
 *
 * <hljs lang="js">
 *   $mdCompiler.compile({
 *     contentElement: '#myElement'
 *   }).then(function (compileData) {
 *     compileData.element // Content Element (same as above)
 *     compileData.link // This does nothing when using a contentElement.
 *   });
 * </hljs>
 *
 */
function MdCompilerService($q, $templateRequest, $injector, $compile, $controller) {
  /** @private @const {!angular.$q} */
  this.$q = $q;

  /** @private @const {!angular.$templateRequest} */
  this.$templateRequest = $templateRequest;

  /** @private @const {!angular.$injector} */
  this.$injector = $injector;

  /** @private @const {!angular.$compile} */
  this.$compile = $compile;

  /** @private @const {!angular.$controller} */
  this.$controller = $controller;
}

/**
 * @ngdoc method
 * @name $mdCompiler#compile
 * @description
 *
 * A method to compile a HTML template with the Angular compiler.
 * The `$mdCompiler` is wrapper around the Angular compiler and provides extra functionality
 * like controller instantiation or async resolves.
 *
 * @param {!Object} options An options object, with the following properties:
 *
 *    - `controller` - `{string|Function}` Controller fn that should be associated with
 *         newly created scope or the name of a registered controller if passed as a string.
 *    - `controllerAs` - `{string=}` A controller alias name. If present the controller will be
 *         published to scope under the `controllerAs` name.
 *    - `contentElement` - `{string|Element}`: Instead of using a template, which will be
 *         compiled each time, you can also use a DOM element.<br/>
 *    - `template` - `{string=}` An html template as a string.
 *    - `templateUrl` - `{string=}` A path to an html template.
 *    - `transformTemplate` - `{function(template)=}` A function which transforms the template after
 *        it is loaded. It will be given the template string as a parameter, and should
 *        return a a new string representing the transformed template.
 *    - `resolve` - `{Object.<string, function>=}` - An optional map of dependencies which should
 *        be injected into the controller. If any of these dependencies are promises, the compiler
 *        will wait for them all to be resolved, or if one is rejected before the controller is
 *        instantiated `compile()` will fail..
 *      * `key` - `{string}`: a name of a dependency to be injected into the controller.
 *      * `factory` - `{string|function}`: If `string` then it is an alias for a service.
 *        Otherwise if function, then it is injected and the return value is treated as the
 *        dependency. If the result is a promise, it is resolved before its value is
 *        injected into the controller.
 *
 * @returns {Object} promise A promise, which will be resolved with a `compileData` object.
 * `compileData` has the following properties:
 *
 *   - `element` - `{element}`: an uncompiled element matching the provided template.
 *   - `link` - `{function(scope)}`: A link function, which, when called, will compile
 *     the element and instantiate the provided controller (if given).
 *   - `locals` - `{object}`: The locals which will be passed into the controller once `link` is
 *     called. If `bindToController` is true, they will be coppied to the ctrl instead
 *
 */
MdCompilerService.prototype.compile = function(options) {

  if (options.contentElement) {
    return this._prepareContentElement(options);
  } else {
    return this._compileTemplate(options);
  }

};

/**
 * Instead of compiling any template, the compiler just fetches an existing HTML element from the DOM and
 * provides a restore function to put the element back it old DOM position.
 * @param {!Object} options Options to be used for the compiler.
 * @private
 */
MdCompilerService.prototype._prepareContentElement = function(options) {

  var contentElement = this._fetchContentElement(options);

  return this.$q.resolve({
    element: contentElement.element,
    cleanup: contentElement.restore,
    locals: {},
    link: function() {
      return contentElement.element;
    }
  });

};

/**
 * Compiles a template by considering all options and waiting for all resolves to be ready.
 * @param {!Object} options Compile options
 * @returns {!Object} Compile data with link function.
 * @private
 */
MdCompilerService.prototype._compileTemplate = function(options) {

  var self = this;
  var templateUrl = options.templateUrl;
  var template = options.template || '';
  var resolve = angular.extend({}, options.resolve);
  var locals = angular.extend({}, options.locals);
  var transformTemplate = options.transformTemplate || angular.identity;

  // Take resolve values and invoke them.
  // Resolves can either be a string (value: 'MyRegisteredAngularConst'),
  // or an invokable 'factory' of sorts: (value: function ValueGetter($dependency) {})
  angular.forEach(resolve, function(value, key) {
    if (angular.isString(value)) {
      resolve[key] = self.$injector.get(value);
    } else {
      resolve[key] = self.$injector.invoke(value);
    }
  });

  // Add the locals, which are just straight values to inject
  // eg locals: { three: 3 }, will inject three into the controller
  angular.extend(resolve, locals);

  if (templateUrl) {
    resolve.$$ngTemplate = this.$templateRequest(templateUrl);
  } else {
    resolve.$$ngTemplate = this.$q.when(template);
  }


  // Wait for all the resolves to finish if they are promises
  return this.$q.all(resolve).then(function(locals) {

    var template = transformTemplate(locals.$$ngTemplate, options);
    var element = options.element || angular.element('<div>').html(template.trim()).contents();

    return self._compileElement(locals, element, options);
  });

};

/**
 * Method to compile an element with the given options.
 * @param {!Object} locals Locals to be injected to the controller if present
 * @param {!JQLite} element Element to be compiled and linked
 * @param {!Object} options Options to be used for linking.
 * @returns {!Object} Compile data with link function.
 * @private
 */
MdCompilerService.prototype._compileElement = function(locals, element, options) {
  var self = this;
  var ngLinkFn = this.$compile(element);

  var compileData = {
    element: element,
    cleanup: element.remove.bind(element),
    locals: locals,
    link: linkFn
  };

  function linkFn(scope) {
    locals.$scope = scope;

    // Instantiate controller if the developer provided one.
    if (options.controller) {

      var injectLocals = angular.extend(locals, {
        $element: element
      });

      var invokeCtrl = self.$controller(options.controller, injectLocals, true, options.controllerAs);

      if (options.bindToController) {
        angular.extend(invokeCtrl.instance, locals);
      }

      var ctrl = invokeCtrl();

      // Unique identifier for Angular Route ngView controllers.
      element.data('$ngControllerController', ctrl);
      element.children().data('$ngControllerController', ctrl);

      // Expose the instantiated controller to the compile data
      compileData.controller = ctrl;
    }

    // Invoke the Angular $compile link function.
    return ngLinkFn(scope);
  }

  return compileData;

};

/**
 * Fetches an element removing it from the DOM and using it temporary for the compiler.
 * Elements which were fetched will be restored after use.
 * @param {!Object} options Options to be used for the compilation.
 * @returns {{element: !JQLite, restore: !Function}}
 * @private
 */
MdCompilerService.prototype._fetchContentElement = function(options) {

  var contentEl = options.contentElement;
  var restoreFn = null;

  if (angular.isString(contentEl)) {
    contentEl = document.querySelector(contentEl);
    restoreFn = createRestoreFn(contentEl);
  } else {
    contentEl = contentEl[0] || contentEl;

    // When the element is visible in the DOM, then we restore it at close of the dialog.
    // Otherwise it will be removed from the DOM after close.
    if (document.contains(contentEl)) {
      restoreFn = createRestoreFn(contentEl);
    } else {
      restoreFn = function() {
        if (contentEl.parentNode) {
          contentEl.parentNode.removeChild(contentEl);
        }
      }
    }
  }

  return {
    element: angular.element(contentEl),
    restore: restoreFn
  };

  function createRestoreFn(element) {
    var parent = element.parentNode;
    var nextSibling = element.nextElementSibling;

    return function() {
      if (!nextSibling) {
        // When the element didn't had any sibling, then it can be simply appended to the
        // parent, because it plays no role, which index it had before.
        parent.appendChild(element);
      } else {
        // When the element had a sibling, which marks the previous position of the element
        // in the DOM, we insert it correctly before the sibling, to have the same index as
        // before.
        parent.insertBefore(element, nextSibling);
      }
    }
  }
};



MdGesture['$inject'] = ["$$MdGestureHandler", "$$rAF", "$timeout"];
attachToDocument['$inject'] = ["$mdGesture", "$$MdGestureHandler"];var HANDLERS = {};

/* The state of the current 'pointer'
 * The pointer represents the state of the current touch.
 * It contains normalized x and y coordinates from DOM events,
 * as well as other information abstracted from the DOM.
 */

var pointer, lastPointer, forceSkipClickHijack = false;

/**
 * The position of the most recent click if that click was on a label element.
 * @type {{x: number, y: number}?}
 */
var lastLabelClickPos = null;

// Used to attach event listeners once when multiple ng-apps are running.
var isInitialized = false;

angular
  .module('material.core.gestures', [ ])
  .provider('$mdGesture', MdGestureProvider)
  .factory('$$MdGestureHandler', MdGestureHandler)
  .run( attachToDocument );

/**
   * @ngdoc service
   * @name $mdGestureProvider
   * @module material.core.gestures
   *
   * @description
   * In some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked.
   * `$mdGestureProvider` is used to configure the Gesture module to ignore or skip click hijacking on mobile
   * devices.
   *
   * <hljs lang="js">
   *   app.config(function($mdGestureProvider) {
   *
   *     // For mobile devices without jQuery loaded, do not
   *     // intercept click events during the capture phase.
   *     $mdGestureProvider.skipClickHijack();
   *
   *   });
   * </hljs>
   *
   */
function MdGestureProvider() { }

MdGestureProvider.prototype = {

  // Publish access to setter to configure a variable  BEFORE the
  // $mdGesture service is instantiated...
  skipClickHijack: function() {
    return forceSkipClickHijack = true;
  },

  /**
   * $get is used to build an instance of $mdGesture
   * ngInject
   */
  $get : ["$$MdGestureHandler", "$$rAF", "$timeout", function($$MdGestureHandler, $$rAF, $timeout) {
       return new MdGesture($$MdGestureHandler, $$rAF, $timeout);
  }]
};



/**
 * MdGesture factory construction function
 * ngInject
 */
function MdGesture($$MdGestureHandler, $$rAF, $timeout) {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isIos = userAgent.match(/ipad|iphone|ipod/i);
  var isAndroid = userAgent.match(/android/i);
  var touchActionProperty = getTouchAction();
  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  var self = {
    handler: addHandler,
    register: register,
    // On mobile w/out jQuery, we normally intercept clicks. Should we skip that?
    isHijackingClicks: (isIos || isAndroid) && !hasJQuery && !forceSkipClickHijack
  };

  if (self.isHijackingClicks) {
    var maxClickDistance = 6;
    self.handler('click', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('click')
    });

    self.handler('focus', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: function(ev, pointer) {
        if (pointer.distance < this.state.options.maxDistance) {
          if (canFocus(ev.target)) {
            this.dispatchEvent(ev, 'focus', pointer);
            ev.target.focus();
          }
        }

        function canFocus(element) {
          var focusableElements = ['INPUT', 'SELECT', 'BUTTON', 'TEXTAREA', 'VIDEO', 'AUDIO'];

          return (element.getAttribute('tabindex') != '-1') &&
              !element.hasAttribute('DISABLED') &&
              (element.hasAttribute('tabindex') || element.hasAttribute('href') || element.isContentEditable ||
              (focusableElements.indexOf(element.nodeName) != -1));
        }
      }
    });

    self.handler('mouseup', {
      options: {
        maxDistance: maxClickDistance
      },
      onEnd: checkDistanceAndEmit('mouseup')
    });

    self.handler('mousedown', {
      onStart: function(ev) {
        this.dispatchEvent(ev, 'mousedown');
      }
    });
  }

  function checkDistanceAndEmit(eventName) {
    return function(ev, pointer) {
      if (pointer.distance < this.state.options.maxDistance) {
        this.dispatchEvent(ev, eventName, pointer);
      }
    };
  }

  /*
   * Register an element to listen for a handler.
   * This allows an element to override the default options for a handler.
   * Additionally, some handlers like drag and hold only dispatch events if
   * the domEvent happens inside an element that's registered to listen for these events.
   *
   * @see GestureHandler for how overriding of default options works.
   * @example $mdGesture.register(myElement, 'drag', { minDistance: 20, horziontal: false })
   */
  function register(element, handlerName, options) {
    var handler = HANDLERS[handlerName.replace(/^\$md./, '')];
    if (!handler) {
      throw new Error('Failed to register element with handler ' + handlerName + '. ' +
      'Available handlers: ' + Object.keys(HANDLERS).join(', '));
    }
    return handler.registerElement(element, options);
  }

  /*
   * add a handler to $mdGesture. see below.
   */
  function addHandler(name, definition) {
    var handler = new $$MdGestureHandler(name);
    angular.extend(handler, definition);
    HANDLERS[name] = handler;

    return self;
  }

  /*
   * Register handlers. These listen to touch/start/move events, interpret them,
   * and dispatch gesture events depending on options & conditions. These are all
   * instances of GestureHandler.
   * @see GestureHandler
   */
  return self
    /*
     * The press handler dispatches an event on touchdown/touchend.
     * It's a simple abstraction of touch/mouse/pointer start and end.
     */
    .handler('press', {
      onStart: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressdown');
      },
      onEnd: function (ev, pointer) {
        this.dispatchEvent(ev, '$md.pressup');
      }
    })

    /*
     * The hold handler dispatches an event if the user keeps their finger within
     * the same <maxDistance> area for <delay> ms.
     * The hold handler will only run if a parent of the touch target is registered
     * to listen for hold events through $mdGesture.register()
     */
    .handler('hold', {
      options: {
        maxDistance: 6,
        delay: 500
      },
      onCancel: function () {
        $timeout.cancel(this.state.timeout);
      },
      onStart: function (ev, pointer) {
        // For hold, require a parent to be registered with $mdGesture.register()
        // Because we prevent scroll events, this is necessary.
        if (!this.state.registeredParent) return this.cancel();

        this.state.pos = {x: pointer.x, y: pointer.y};
        this.state.timeout = $timeout(angular.bind(this, function holdDelayFn() {
          this.dispatchEvent(ev, '$md.hold');
          this.cancel(); //we're done!
        }), this.state.options.delay, false);
      },
      onMove: function (ev, pointer) {
        // Don't scroll while waiting for hold.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        // If the user moves greater than <maxDistance> pixels, stop the hold timer
        // set in onStart
        var dx = this.state.pos.x - pointer.x;
        var dy = this.state.pos.y - pointer.y;
        if (Math.sqrt(dx * dx + dy * dy) > this.options.maxDistance) {
          this.cancel();
        }
      },
      onEnd: function () {
        this.onCancel();
      }
    })

    /*
     * The drag handler dispatches a drag event if the user holds and moves his finger greater than
     * <minDistance> px in the x or y direction, depending on options.horizontal.
     * The drag will be cancelled if the user moves his finger greater than <minDistance>*<cancelMultiplier> in
     * the perpendicular direction. Eg if the drag is horizontal and the user moves his finger <minDistance>*<cancelMultiplier>
     * pixels vertically, this handler won't consider the move part of a drag.
     */
    .handler('drag', {
      options: {
        minDistance: 6,
        horizontal: true,
        cancelMultiplier: 1.5
      },
      onSetup: function(element, options) {
        if (touchActionProperty) {
          // We check for horizontal to be false, because otherwise we would overwrite the default opts.
          this.oldTouchAction = element[0].style[touchActionProperty];
          element[0].style[touchActionProperty] = options.horizontal ? 'pan-y' : 'pan-x';
        }
      },
      onCleanup: function(element) {
        if (this.oldTouchAction) {
          element[0].style[touchActionProperty] = this.oldTouchAction;
        }
      },
      onStart: function (ev) {
        // For drag, require a parent to be registered with $mdGesture.register()
        if (!this.state.registeredParent) this.cancel();
      },
      onMove: function (ev, pointer) {
        var shouldStartDrag, shouldCancel;
        // Don't scroll while deciding if this touchmove qualifies as a drag event.
        // If we don't preventDefault touchmove events here, Android will assume we don't
        // want to listen to anymore touch events. It will start scrolling and stop sending
        // touchmove events.
        if (!touchActionProperty && ev.type === 'touchmove') ev.preventDefault();

        if (!this.state.dragPointer) {
          if (this.state.options.horizontal) {
            shouldStartDrag = Math.abs(pointer.distanceX) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceY) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          } else {
            shouldStartDrag = Math.abs(pointer.distanceY) > this.state.options.minDistance;
            shouldCancel = Math.abs(pointer.distanceX) > this.state.options.minDistance * this.state.options.cancelMultiplier;
          }

          if (shouldStartDrag) {
            // Create a new pointer representing this drag, starting at this point where the drag started.
            this.state.dragPointer = makeStartPointer(ev);
            updatePointerState(ev, this.state.dragPointer);
            this.dispatchEvent(ev, '$md.dragstart', this.state.dragPointer);

          } else if (shouldCancel) {
            this.cancel();
          }
        } else {
          this.dispatchDragMove(ev);
        }
      },
      // Only dispatch dragmove events every frame; any more is unnecessary
      dispatchDragMove: $$rAF.throttle(function (ev) {
        // Make sure the drag didn't stop while waiting for the next frame
        if (this.state.isRunning) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.drag', this.state.dragPointer);
        }
      }),
      onEnd: function (ev, pointer) {
        if (this.state.dragPointer) {
          updatePointerState(ev, this.state.dragPointer);
          this.dispatchEvent(ev, '$md.dragend', this.state.dragPointer);
        }
      }
    })

    /*
     * The swipe handler will dispatch a swipe event if, on the end of a touch,
     * the velocity and distance were high enough.
     */
    .handler('swipe', {
      options: {
        minVelocity: 0.65,
        minDistance: 10
      },
      onEnd: function (ev, pointer) {
        var eventType;

        if (Math.abs(pointer.velocityX) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceX) > this.state.options.minDistance) {
          eventType = pointer.directionX == 'left' ? '$md.swipeleft' : '$md.swiperight';
          this.dispatchEvent(ev, eventType);
        }
        else if (Math.abs(pointer.velocityY) > this.state.options.minVelocity &&
          Math.abs(pointer.distanceY) > this.state.options.minDistance) {
          eventType = pointer.directionY == 'up' ? '$md.swipeup' : '$md.swipedown';
          this.dispatchEvent(ev, eventType);
        }
      }
    });

  function getTouchAction() {
    var testEl = document.createElement('div');
    var vendorPrefixes = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];

    for (var i = 0; i < vendorPrefixes.length; i++) {
      var prefix = vendorPrefixes[i];
      var property = prefix ? prefix + 'TouchAction' : 'touchAction';
      if (angular.isDefined(testEl.style[property])) {
        return property;
      }
    }
  }

}

/**
 * MdGestureHandler
 * A GestureHandler is an object which is able to dispatch custom dom events
 * based on native dom {touch,pointer,mouse}{start,move,end} events.
 *
 * A gesture will manage its lifecycle through the start,move,end, and cancel
 * functions, which are called by native dom events.
 *
 * A gesture has the concept of 'options' (eg a swipe's required velocity), which can be
 * overridden by elements registering through $mdGesture.register()
 */
function GestureHandler (name) {
  this.name = name;
  this.state = {};
}

function MdGestureHandler() {
  var hasJQuery =  (typeof window.jQuery !== 'undefined') && (angular.element === window.jQuery);

  GestureHandler.prototype = {
    options: {},
    // jQuery listeners don't work with custom DOMEvents, so we have to dispatch events
    // differently when jQuery is loaded
    dispatchEvent: hasJQuery ?  jQueryDispatchEvent : nativeDispatchEvent,

    // These are overridden by the registered handler
    onSetup: angular.noop,
    onCleanup: angular.noop,
    onStart: angular.noop,
    onMove: angular.noop,
    onEnd: angular.noop,
    onCancel: angular.noop,

    // onStart sets up a new state for the handler, which includes options from the
    // nearest registered parent element of ev.target.
    start: function (ev, pointer) {
      if (this.state.isRunning) return;
      var parentTarget = this.getNearestParent(ev.target);
      // Get the options from the nearest registered parent
      var parentTargetOptions = parentTarget && parentTarget.$mdGesture[this.name] || {};

      this.state = {
        isRunning: true,
        // Override the default options with the nearest registered parent's options
        options: angular.extend({}, this.options, parentTargetOptions),
        // Pass in the registered parent node to the state so the onStart listener can use
        registeredParent: parentTarget
      };
      this.onStart(ev, pointer);
    },
    move: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.onMove(ev, pointer);
    },
    end: function (ev, pointer) {
      if (!this.state.isRunning) return;
      this.onEnd(ev, pointer);
      this.state.isRunning = false;
    },
    cancel: function (ev, pointer) {
      this.onCancel(ev, pointer);
      this.state = {};
    },

    // Find and return the nearest parent element that has been registered to
    // listen for this handler via $mdGesture.register(element, 'handlerName').
    getNearestParent: function (node) {
      var current = node;
      while (current) {
        if ((current.$mdGesture || {})[this.name]) {
          return current;
        }
        current = current.parentNode;
      }
      return null;
    },

    // Called from $mdGesture.register when an element registers itself with a handler.
    // Store the options the user gave on the DOMElement itself. These options will
    // be retrieved with getNearestParent when the handler starts.
    registerElement: function (element, options) {
      var self = this;
      element[0].$mdGesture = element[0].$mdGesture || {};
      element[0].$mdGesture[this.name] = options || {};
      element.on('$destroy', onDestroy);

      self.onSetup(element, options || {});

      return onDestroy;

      function onDestroy() {
        delete element[0].$mdGesture[self.name];
        element.off('$destroy', onDestroy);

        self.onCleanup(element, options || {});
      }
    }
  };

  return GestureHandler;

  /*
   * Dispatch an event with jQuery
   * TODO: Make sure this sends bubbling events
   *
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function jQueryDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj = new angular.element.Event(eventType);

    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;

    angular.extend(eventObj, {
      clientX: eventPointer.x,
      clientY: eventPointer.y,
      screenX: eventPointer.x,
      screenY: eventPointer.y,
      pageX: eventPointer.x,
      pageY: eventPointer.y,
      ctrlKey: srcEvent.ctrlKey,
      altKey: srcEvent.altKey,
      shiftKey: srcEvent.shiftKey,
      metaKey: srcEvent.metaKey
    });
    angular.element(eventPointer.target).trigger(eventObj);
  }

  /*
   * NOTE: nativeDispatchEvent is very performance sensitive.
   * @param srcEvent the original DOM touch event that started this.
   * @param eventType the name of the custom event to send (eg 'click' or '$md.drag')
   * @param eventPointer the pointer object that matches this event.
   */
  function nativeDispatchEvent(srcEvent, eventType, eventPointer) {
    eventPointer = eventPointer || pointer;
    var eventObj;

    if (eventType === 'click' || eventType == 'mouseup' || eventType == 'mousedown' ) {
      eventObj = document.createEvent('MouseEvents');
      eventObj.initMouseEvent(
        eventType, true, true, window, srcEvent.detail,
        eventPointer.x, eventPointer.y, eventPointer.x, eventPointer.y,
        srcEvent.ctrlKey, srcEvent.altKey, srcEvent.shiftKey, srcEvent.metaKey,
        srcEvent.button, srcEvent.relatedTarget || null
      );

    } else {
      eventObj = document.createEvent('CustomEvent');
      eventObj.initCustomEvent(eventType, true, true, {});
    }
    eventObj.$material = true;
    eventObj.pointer = eventPointer;
    eventObj.srcEvent = srcEvent;
    eventPointer.target.dispatchEvent(eventObj);
  }

}

/**
 * Attach Gestures: hook document and check shouldHijack clicks
 * ngInject
 */
function attachToDocument( $mdGesture, $$MdGestureHandler ) {

  // Polyfill document.contains for IE11.
  // TODO: move to util
  document.contains || (document.contains = function (node) {
    return document.body.contains(node);
  });

  if (!isInitialized && $mdGesture.isHijackingClicks ) {
    /*
     * If hijack clicks is true, we preventDefault any click that wasn't
     * sent by ngMaterial. This is because on older Android & iOS, a false, or 'ghost',
     * click event will be sent ~400ms after a touchend event happens.
     * The only way to know if this click is real is to prevent any normal
     * click events, and add a flag to events sent by material so we know not to prevent those.
     *
     * Two exceptions to click events that should be prevented are:
     *  - click events sent by the keyboard (eg form submit)
     *  - events that originate from an Ionic app
     */
    document.addEventListener('click'    , clickHijacker     , true);
    document.addEventListener('mouseup'  , mouseInputHijacker, true);
    document.addEventListener('mousedown', mouseInputHijacker, true);
    document.addEventListener('focus'    , mouseInputHijacker, true);

    isInitialized = true;
  }

  function mouseInputHijacker(ev) {
    var isKeyClick = !ev.clientX && !ev.clientY;
    if (!isKeyClick && !ev.$material && !ev.isIonicTap
      && !isInputEventFromLabelClick(ev)) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  }

  function clickHijacker(ev) {
    var isKeyClick = ev.clientX === 0 && ev.clientY === 0;
    if (!isKeyClick && !ev.$material && !ev.isIonicTap
      && !isInputEventFromLabelClick(ev)) {
      ev.preventDefault();
      ev.stopPropagation();
      lastLabelClickPos = null;
    } else {
      lastLabelClickPos = null;
      if (ev.target.tagName.toLowerCase() == 'label') {
        lastLabelClickPos = {x: ev.x, y: ev.y};
      }
    }
  }


  // Listen to all events to cover all platforms.
  var START_EVENTS = 'mousedown touchstart pointerdown';
  var MOVE_EVENTS = 'mousemove touchmove pointermove';
  var END_EVENTS = 'mouseup mouseleave touchend touchcancel pointerup pointercancel';

  angular.element(document)
    .on(START_EVENTS, gestureStart)
    .on(MOVE_EVENTS, gestureMove)
    .on(END_EVENTS, gestureEnd)
    // For testing
    .on('$$mdGestureReset', function gestureClearCache () {
      lastPointer = pointer = null;
    });

  /*
   * When a DOM event happens, run all registered gesture handlers' lifecycle
   * methods which match the DOM event.
   * Eg when a 'touchstart' event happens, runHandlers('start') will call and
   * run `handler.cancel()` and `handler.start()` on all registered handlers.
   */
  function runHandlers(handlerEvent, event) {
    var handler;
    for (var name in HANDLERS) {
      handler = HANDLERS[name];
      if( handler instanceof $$MdGestureHandler ) {

        if (handlerEvent === 'start') {
          // Run cancel to reset any handlers' state
          handler.cancel();
        }
        handler[handlerEvent](event, pointer);

      }
    }
  }

  /*
   * gestureStart vets if a start event is legitimate (and not part of a 'ghost click' from iOS/Android)
   * If it is legitimate, we initiate the pointer state and mark the current pointer's type
   * For example, for a touchstart event, mark the current pointer as a 'touch' pointer, so mouse events
   * won't effect it.
   */
  function gestureStart(ev) {
    // If we're already touched down, abort
    if (pointer) return;

    var now = +Date.now();

    // iOS & old android bug: after a touch event, a click event is sent 350 ms later.
    // If <400ms have passed, don't allow an event of a different type than the previous event
    if (lastPointer && !typesMatch(ev, lastPointer) && (now - lastPointer.endTime < 1500)) {
      return;
    }

    pointer = makeStartPointer(ev);

    runHandlers('start', ev);
  }
  /*
   * If a move event happens of the right type, update the pointer and run all the move handlers.
   * "of the right type": if a mousemove happens but our pointer started with a touch event, do nothing.
   */
  function gestureMove(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    runHandlers('move', ev);
  }
  /*
   * If an end event happens of the right type, update the pointer, run endHandlers, and save the pointer as 'lastPointer'
   */
  function gestureEnd(ev) {
    if (!pointer || !typesMatch(ev, pointer)) return;

    updatePointerState(ev, pointer);
    pointer.endTime = +Date.now();

    runHandlers('end', ev);

    lastPointer = pointer;
    pointer = null;
  }

}

// ********************
// Module Functions
// ********************

/*
 * Initiate the pointer. x, y, and the pointer's type.
 */
function makeStartPointer(ev) {
  var point = getEventPoint(ev);
  var startPointer = {
    startTime: +Date.now(),
    target: ev.target,
    // 'p' for pointer events, 'm' for mouse, 't' for touch
    type: ev.type.charAt(0)
  };
  startPointer.startX = startPointer.x = point.pageX;
  startPointer.startY = startPointer.y = point.pageY;
  return startPointer;
}

/*
 * return whether the pointer's type matches the event's type.
 * Eg if a touch event happens but the pointer has a mouse type, return false.
 */
function typesMatch(ev, pointer) {
  return ev && pointer && ev.type.charAt(0) === pointer.type;
}

/**
 * Gets whether the given event is an input event that was caused by clicking on an
 * associated label element.
 *
 * This is necessary because the browser will, upon clicking on a label element, fire an
 * *extra* click event on its associated input (if any). mdGesture is able to flag the label
 * click as with `$material` correctly, but not the second input click.
 *
 * In order to determine whether an input event is from a label click, we compare the (x, y) for
 * the event to the (x, y) for the most recent label click (which is cleared whenever a non-label
 * click occurs). Unfortunately, there are no event properties that tie the input and the label
 * together (such as relatedTarget).
 *
 * @param {MouseEvent} event
 * @returns {boolean}
 */
function isInputEventFromLabelClick(event) {
  return lastLabelClickPos
      && lastLabelClickPos.x == event.x
      && lastLabelClickPos.y == event.y;
}

/*
 * Update the given pointer based upon the given DOMEvent.
 * Distance, velocity, direction, duration, etc
 */
function updatePointerState(ev, pointer) {
  var point = getEventPoint(ev);
  var x = pointer.x = point.pageX;
  var y = pointer.y = point.pageY;

  pointer.distanceX = x - pointer.startX;
  pointer.distanceY = y - pointer.startY;
  pointer.distance = Math.sqrt(
    pointer.distanceX * pointer.distanceX + pointer.distanceY * pointer.distanceY
  );

  pointer.directionX = pointer.distanceX > 0 ? 'right' : pointer.distanceX < 0 ? 'left' : '';
  pointer.directionY = pointer.distanceY > 0 ? 'down' : pointer.distanceY < 0 ? 'up' : '';

  pointer.duration = +Date.now() - pointer.startTime;
  pointer.velocityX = pointer.distanceX / pointer.duration;
  pointer.velocityY = pointer.distanceY / pointer.duration;
}

/*
 * Normalize the point where the DOM event happened whether it's touch or mouse.
 * @returns point event obj with pageX and pageY on it.
 */
function getEventPoint(ev) {
  ev = ev.originalEvent || ev; // support jQuery events
  return (ev.touches && ev.touches[0]) ||
    (ev.changedTouches && ev.changedTouches[0]) ||
    ev;
}

/**
 * @ngdoc module
 * @name material.core.interaction
 * @description
 * User interaction detection to provide proper accessibility.
 */
MdInteractionService['$inject'] = ["$timeout", "$mdUtil"];
angular
  .module('material.core.interaction', [])
  .service('$mdInteraction', MdInteractionService);


/**
 * @ngdoc service
 * @name $mdInteraction
 * @module material.core.interaction
 *
 * @description
 *
 * Service which keeps track of the last interaction type and validates them for several browsers.
 * The service hooks into the document's body and listens for touch, mouse and keyboard events.
 *
 * The most recent interaction type can be retrieved by calling the `getLastInteractionType` method.
 *
 * Here is an example markup for using the interaction service.
 *
 * <hljs lang="js">
 *   var lastType = $mdInteraction.getLastInteractionType();
 *
 *   if (lastType === 'keyboard') {
 *     // We only restore the focus for keyboard users.
 *     restoreFocus();
 *   }
 * </hljs>
 *
 */
function MdInteractionService($timeout, $mdUtil) {
  this.$timeout = $timeout;
  this.$mdUtil = $mdUtil;

  this.bodyElement = angular.element(document.body);
  this.isBuffering = false;
  this.bufferTimeout = null;
  this.lastInteractionType = null;
  this.lastInteractionTime = null;

  // Type Mappings for the different events
  // There will be three three interaction types
  // `keyboard`, `mouse` and `touch`
  // type `pointer` will be evaluated in `pointerMap` for IE Browser events
  this.inputEventMap = {
    'keydown': 'keyboard',
    'mousedown': 'mouse',
    'mouseenter': 'mouse',
    'touchstart': 'touch',
    'pointerdown': 'pointer',
    'MSPointerDown': 'pointer'
  };

  // IE PointerDown events will be validated in `touch` or `mouse`
  // Index numbers referenced here: https://msdn.microsoft.com/library/windows/apps/hh466130.aspx
  this.iePointerMap = {
    2: 'touch',
    3: 'touch',
    4: 'mouse'
  };

  this.initializeEvents();
}

/**
 * Initializes the interaction service, by registering all interaction events to the
 * body element.
 */
MdInteractionService.prototype.initializeEvents = function() {
  // IE browsers can also trigger pointer events, which also leads to an interaction.
  var pointerEvent = 'MSPointerEvent' in window ? 'MSPointerDown' : 'PointerEvent' in window ? 'pointerdown' : null;

  this.bodyElement.on('keydown mousedown', this.onInputEvent.bind(this));

  if ('ontouchstart' in document.documentElement) {
    this.bodyElement.on('touchstart', this.onBufferInputEvent.bind(this));
  }

  if (pointerEvent) {
    this.bodyElement.on(pointerEvent, this.onInputEvent.bind(this));
  }

};

/**
 * Event listener for normal interaction events, which should be tracked.
 * @param event {MouseEvent|KeyboardEvent|PointerEvent|TouchEvent}
 */
MdInteractionService.prototype.onInputEvent = function(event) {
  if (this.isBuffering) {
    return;
  }

  var type = this.inputEventMap[event.type];

  if (type === 'pointer') {
    type = this.iePointerMap[event.pointerType] || event.pointerType;
  }

  this.lastInteractionType = type;
  this.lastInteractionTime = this.$mdUtil.now();
};

/**
 * Event listener for interaction events which should be buffered (touch events).
 * @param event {TouchEvent}
 */
MdInteractionService.prototype.onBufferInputEvent = function(event) {
  this.$timeout.cancel(this.bufferTimeout);

  this.onInputEvent(event);
  this.isBuffering = true;

  // The timeout of 650ms is needed to delay the touchstart, because otherwise the touch will call
  // the `onInput` function multiple times.
  this.bufferTimeout = this.$timeout(function() {
    this.isBuffering = false;
  }.bind(this), 650, false);

};

/**
 * @ngdoc method
 * @name $mdInteraction#getLastInteractionType
 * @description Retrieves the last interaction type triggered in body.
 * @returns {string|null} Last interaction type.
 */
MdInteractionService.prototype.getLastInteractionType = function() {
  return this.lastInteractionType;
};

/**
 * @ngdoc method
 * @name $mdInteraction#isUserInvoked
 * @description Method to detect whether any interaction happened recently or not.
 * @param {number=} checkDelay Time to check for any interaction to have been triggered.
 * @returns {boolean} Whether there was any interaction or not.
 */
MdInteractionService.prototype.isUserInvoked = function(checkDelay) {
  var delay = angular.isNumber(checkDelay) ? checkDelay : 15;

  // Check for any interaction to be within the specified check time.
  return this.lastInteractionTime >= this.$mdUtil.now() - delay;
};

angular.module('material.core')
  .provider('$$interimElement', InterimElementProvider);

/*
 * @ngdoc service
 * @name $$interimElement
 * @module material.core
 *
 * @description
 *
 * Factory that contructs `$$interimElement.$service` services.
 * Used internally in material design for elements that appear on screen temporarily.
 * The service provides a promise-like API for interacting with the temporary
 * elements.
 *
 * ```js
 * app.service('$mdToast', function($$interimElement) {
 *   var $mdToast = $$interimElement(toastDefaultOptions);
 *   return $mdToast;
 * });
 * ```
 * @param {object=} defaultOptions Options used by default for the `show` method on the service.
 *
 * @returns {$$interimElement.$service}
 *
 */

function InterimElementProvider() {
  InterimElementFactory['$inject'] = ["$document", "$q", "$rootScope", "$timeout", "$rootElement", "$animate", "$mdUtil", "$mdCompiler", "$mdTheming", "$injector", "$exceptionHandler"];
  createInterimElementProvider.$get = InterimElementFactory;
  return createInterimElementProvider;

  /**
   * Returns a new provider which allows configuration of a new interimElement
   * service. Allows configuration of default options & methods for options,
   * as well as configuration of 'preset' methods (eg dialog.basic(): basic is a preset method)
   */
  function createInterimElementProvider(interimFactoryName) {
    factory['$inject'] = ["$$interimElement", "$injector"];
    var EXPOSED_METHODS = ['onHide', 'onShow', 'onRemove'];

    var customMethods = {};
    var providerConfig = {
      presets: {}
    };

    var provider = {
      setDefaults: setDefaults,
      addPreset: addPreset,
      addMethod: addMethod,
      $get: factory
    };

    /**
     * all interim elements will come with the 'build' preset
     */
    provider.addPreset('build', {
      methods: ['controller', 'controllerAs', 'resolve', 'multiple',
        'template', 'templateUrl', 'themable', 'transformTemplate', 'parent', 'contentElement']
    });

    return provider;

    /**
     * Save the configured defaults to be used when the factory is instantiated
     */
    function setDefaults(definition) {
      providerConfig.optionsFactory = definition.options;
      providerConfig.methods = (definition.methods || []).concat(EXPOSED_METHODS);
      return provider;
    }

    /**
     * Add a method to the factory that isn't specific to any interim element operations
     */

    function addMethod(name, fn) {
      customMethods[name] = fn;
      return provider;
    }

    /**
     * Save the configured preset to be used when the factory is instantiated
     */
    function addPreset(name, definition) {
      definition = definition || {};
      definition.methods = definition.methods || [];
      definition.options = definition.options || function() { return {}; };

      if (/^cancel|hide|show$/.test(name)) {
        throw new Error("Preset '" + name + "' in " + interimFactoryName + " is reserved!");
      }
      if (definition.methods.indexOf('_options') > -1) {
        throw new Error("Method '_options' in " + interimFactoryName + " is reserved!");
      }
      providerConfig.presets[name] = {
        methods: definition.methods.concat(EXPOSED_METHODS),
        optionsFactory: definition.options,
        argOption: definition.argOption
      };
      return provider;
    }

    function addPresetMethod(presetName, methodName, method) {
      providerConfig.presets[presetName][methodName] = method;
    }

    /**
     * Create a factory that has the given methods & defaults implementing interimElement
     */
    /* ngInject */
    function factory($$interimElement, $injector) {
      var defaultMethods;
      var defaultOptions;
      var interimElementService = $$interimElement();

      /*
       * publicService is what the developer will be using.
       * It has methods hide(), cancel(), show(), build(), and any other
       * presets which were set during the config phase.
       */
      var publicService = {
        hide: interimElementService.hide,
        cancel: interimElementService.cancel,
        show: showInterimElement,

        // Special internal method to destroy an interim element without animations
        // used when navigation changes causes a $scope.$destroy() action
        destroy : destroyInterimElement
      };


      defaultMethods = providerConfig.methods || [];
      // This must be invoked after the publicService is initialized
      defaultOptions = invokeFactory(providerConfig.optionsFactory, {});

      // Copy over the simple custom methods
      angular.forEach(customMethods, function(fn, name) {
        publicService[name] = fn;
      });

      angular.forEach(providerConfig.presets, function(definition, name) {
        var presetDefaults = invokeFactory(definition.optionsFactory, {});
        var presetMethods = (definition.methods || []).concat(defaultMethods);

        // Every interimElement built with a preset has a field called `$type`,
        // which matches the name of the preset.
        // Eg in preset 'confirm', options.$type === 'confirm'
        angular.extend(presetDefaults, { $type: name });

        // This creates a preset class which has setter methods for every
        // method given in the `.addPreset()` function, as well as every
        // method given in the `.setDefaults()` function.
        //
        // @example
        // .setDefaults({
        //   methods: ['hasBackdrop', 'clickOutsideToClose', 'escapeToClose', 'targetEvent'],
        //   options: dialogDefaultOptions
        // })
        // .addPreset('alert', {
        //   methods: ['title', 'ok'],
        //   options: alertDialogOptions
        // })
        //
        // Set values will be passed to the options when interimElement.show() is called.
        function Preset(opts) {
          this._options = angular.extend({}, presetDefaults, opts);
        }
        angular.forEach(presetMethods, function(name) {
          Preset.prototype[name] = function(value) {
            this._options[name] = value;
            return this;
          };
        });

        // Create shortcut method for one-linear methods
        if (definition.argOption) {
          var methodName = 'show' + name.charAt(0).toUpperCase() + name.slice(1);
          publicService[methodName] = function(arg) {
            var config = publicService[name](arg);
            return publicService.show(config);
          };
        }

        // eg $mdDialog.alert() will return a new alert preset
        publicService[name] = function(arg) {
          // If argOption is supplied, eg `argOption: 'content'`, then we assume
          // if the argument is not an options object then it is the `argOption` option.
          //
          // @example `$mdToast.simple('hello')` // sets options.content to hello
          //                                     // because argOption === 'content'
          if (arguments.length && definition.argOption &&
              !angular.isObject(arg) && !angular.isArray(arg))  {

            return (new Preset())[definition.argOption](arg);

          } else {
            return new Preset(arg);
          }

        };
      });

      return publicService;

      /**
       *
       */
      function showInterimElement(opts) {
        // opts is either a preset which stores its options on an _options field,
        // or just an object made up of options
        opts = opts || { };
        if (opts._options) opts = opts._options;

        return interimElementService.show(
          angular.extend({}, defaultOptions, opts)
        );
      }

      /**
       *  Special method to hide and destroy an interimElement WITHOUT
       *  any 'leave` or hide animations ( an immediate force hide/remove )
       *
       *  NOTE: This calls the onRemove() subclass method for each component...
       *  which must have code to respond to `options.$destroy == true`
       */
      function destroyInterimElement(opts) {
          return interimElementService.destroy(opts);
      }

      /**
       * Helper to call $injector.invoke with a local of the factory name for
       * this provider.
       * If an $mdDialog is providing options for a dialog and tries to inject
       * $mdDialog, a circular dependency error will happen.
       * We get around that by manually injecting $mdDialog as a local.
       */
      function invokeFactory(factory, defaultVal) {
        var locals = {};
        locals[interimFactoryName] = publicService;
        return $injector.invoke(factory || function() { return defaultVal; }, {}, locals);
      }

    }

  }

  /* ngInject */
  function InterimElementFactory($document, $q, $rootScope, $timeout, $rootElement, $animate,
                                 $mdUtil, $mdCompiler, $mdTheming, $injector, $exceptionHandler) {
    return function createInterimElementService() {
      var SHOW_CANCELLED = false;

      /*
       * @ngdoc service
       * @name $$interimElement.$service
       *
       * @description
       * A service used to control inserting and removing an element into the DOM.
       *
       */

      var service;

      var showPromises = []; // Promises for the interim's which are currently opening.
      var hidePromises = []; // Promises for the interim's which are currently hiding.
      var showingInterims = []; // Interim elements which are currently showing up.

      // Publish instance $$interimElement service;
      // ... used as $mdDialog, $mdToast, $mdMenu, and $mdSelect

      return service = {
        show: show,
        hide: waitForInterim(hide),
        cancel: waitForInterim(cancel),
        destroy : destroy,
        $injector_: $injector
      };

      /*
       * @ngdoc method
       * @name $$interimElement.$service#show
       * @kind function
       *
       * @description
       * Adds the `$interimElement` to the DOM and returns a special promise that will be resolved or rejected
       * with hide or cancel, respectively. To external cancel/hide, developers should use the
       *
       * @param {*} options is hashMap of settings
       * @returns a Promise
       *
       */
      function show(options) {
        options = options || {};
        var interimElement = new InterimElement(options || {});

        // When an interim element is currently showing, we have to cancel it.
        // Just hiding it, will resolve the InterimElement's promise, the promise should be
        // rejected instead.
        var hideAction = options.multiple ? $q.resolve() : $q.all(showPromises);

        if (!options.multiple) {
          // Wait for all opening interim's to finish their transition.
          hideAction = hideAction.then(function() {
            // Wait for all closing and showing interim's to be completely closed.
            var promiseArray = hidePromises.concat(showingInterims.map(service.cancel));
            return $q.all(promiseArray);
          });
        }

        var showAction = hideAction.then(function() {

          return interimElement
            .show()
            .catch(function(reason) { return reason; })
            .finally(function() {
              showPromises.splice(showPromises.indexOf(showAction), 1);
              showingInterims.push(interimElement);
            });

        });

        showPromises.push(showAction);

        // In Angular 1.6+, exceptions inside promises will cause a rejection. We need to handle
        // the rejection and only log it if it's an error.
        interimElement.deferred.promise.catch(function(fault) {
          if (fault instanceof Error) {
            $exceptionHandler(fault);
          }

          return fault;
        });

        // Return a promise that will be resolved when the interim
        // element is hidden or cancelled...
        return interimElement.deferred.promise;
      }

      /*
       * @ngdoc method
       * @name $$interimElement.$service#hide
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and resolves the promise returned from `show`
       *
       * @param {*} resolveParam Data to resolve the promise with
       * @returns a Promise that will be resolved after the element has been removed.
       *
       */
      function hide(reason, options) {
        options = options || {};

        if (options.closeAll) {
          // We have to make a shallow copy of the array, because otherwise the map will break.
          return $q.all(showingInterims.slice().reverse().map(closeElement));
        } else if (options.closeTo !== undefined) {
          return $q.all(showingInterims.slice(options.closeTo).map(closeElement));
        }

        // Hide the latest showing interim element.
        return closeElement(showingInterims[showingInterims.length - 1]);

        function closeElement(interim) {

          var hideAction = interim
            .remove(reason, false, options || { })
            .catch(function(reason) { return reason; })
            .finally(function() {
              hidePromises.splice(hidePromises.indexOf(hideAction), 1);
            });

          showingInterims.splice(showingInterims.indexOf(interim), 1);
          hidePromises.push(hideAction);

          return interim.deferred.promise;
        }
      }

      /*
       * @ngdoc method
       * @name $$interimElement.$service#cancel
       * @kind function
       *
       * @description
       * Removes the `$interimElement` from the DOM and rejects the promise returned from `show`
       *
       * @param {*} reason Data to reject the promise with
       * @returns Promise that will be resolved after the element has been removed.
       *
       */
      function cancel(reason, options) {
        var interim = showingInterims.pop();
        if (!interim) {
          return $q.when(reason);
        }

        var cancelAction = interim
          .remove(reason, true, options || {})
          .catch(function(reason) { return reason; })
          .finally(function() {
            hidePromises.splice(hidePromises.indexOf(cancelAction), 1);
          });

        hidePromises.push(cancelAction);

        // Since Angular 1.6.7, promises will be logged to $exceptionHandler when the promise
        // is not handling the rejection. We create a pseudo catch handler, which will prevent the
        // promise from being logged to the $exceptionHandler.
        return interim.deferred.promise.catch(angular.noop);
      }

      /**
       * Creates a function to wait for at least one interim element to be available.
       * @param callbackFn Function to be used as callback
       * @returns {Function}
       */
      function waitForInterim(callbackFn) {
        return function() {
          var fnArguments = arguments;

          if (!showingInterims.length) {
            // When there are still interim's opening, then wait for the first interim element to
            // finish its open animation.
            if (showPromises.length) {
              return showPromises[0].finally(function () {
                return callbackFn.apply(service, fnArguments);
              });
            }

            return $q.when("No interim elements currently showing up.");
          }

          return callbackFn.apply(service, fnArguments);
        };
      }

      /*
       * Special method to quick-remove the interim element without animations
       * Note: interim elements are in "interim containers"
       */
      function destroy(targetEl) {
        var interim = !targetEl ? showingInterims.shift() : null;

        var parentEl = angular.element(targetEl).length && angular.element(targetEl)[0].parentNode;

        if (parentEl) {
          // Try to find the interim in the stack which corresponds to the supplied DOM element.
          var filtered = showingInterims.filter(function(entry) {
            return entry.options.element[0] === parentEl;
          });

          // Note: This function might be called when the element already has been removed,
          // in which case we won't find any matches.
          if (filtered.length) {
            interim = filtered[0];
            showingInterims.splice(showingInterims.indexOf(interim), 1);
          }
        }

        return interim ? interim.remove(SHOW_CANCELLED, false, { '$destroy': true }) :
                         $q.when(SHOW_CANCELLED);
      }

      /*
       * Internal Interim Element Object
       * Used internally to manage the DOM element and related data
       */
      function InterimElement(options) {
        var self, element, showAction = $q.when(true);

        options = configureScopeAndTransitions(options);

        return self = {
          options : options,
          deferred: $q.defer(),
          show    : createAndTransitionIn,
          remove  : transitionOutAndRemove
        };

        /**
         * Compile, link, and show this interim element
         * Use optional autoHided and transition-in effects
         */
        function createAndTransitionIn() {
          return $q(function(resolve, reject) {

            // Trigger onCompiling callback before the compilation starts.
            // This is useful, when modifying options, which can be influenced by developers.
            options.onCompiling && options.onCompiling(options);

            compileElement(options)
              .then(function( compiledData ) {
                element = linkElement( compiledData, options );

                // Expose the cleanup function from the compiler.
                options.cleanupElement = compiledData.cleanup;

                showAction = showElement(element, options, compiledData.controller)
                  .then(resolve, rejectAll);
              }).catch(rejectAll);

            function rejectAll(fault) {
              // Force the '$md<xxx>.show()' promise to reject
              self.deferred.reject(fault);

              // Continue rejection propagation
              reject(fault);
            }
          });
        }

        /**
         * After the show process has finished/rejected:
         * - announce 'removing',
         * - perform the transition-out, and
         * - perform optional clean up scope.
         */
        function transitionOutAndRemove(response, isCancelled, opts) {

          // abort if the show() and compile failed
          if ( !element ) return $q.when(false);

          options = angular.extend(options || {}, opts || {});
          options.cancelAutoHide && options.cancelAutoHide();
          options.element.triggerHandler('$mdInterimElementRemove');

          if ( options.$destroy === true ) {

            return hideElement(options.element, options).then(function(){
              (isCancelled && rejectAll(response)) || resolveAll(response);
            });

          } else {
            $q.when(showAction).finally(function() {
              hideElement(options.element, options).then(function() {
                isCancelled ? rejectAll(response) : resolveAll(response);
              }, rejectAll);
            });

            return self.deferred.promise;
          }


          /**
           * The `show()` returns a promise that will be resolved when the interim
           * element is hidden or cancelled...
           */
          function resolveAll(response) {
            self.deferred.resolve(response);
          }

          /**
           * Force the '$md<xxx>.show()' promise to reject
           */
          function rejectAll(fault) {
            self.deferred.reject(fault);
          }
        }

        /**
         * Prepare optional isolated scope and prepare $animate with default enter and leave
         * transitions for the new element instance.
         */
        function configureScopeAndTransitions(options) {
          options = options || { };
          if ( options.template ) {
            options.template = $mdUtil.processTemplate(options.template);
          }

          return angular.extend({
            preserveScope: false,
            cancelAutoHide : angular.noop,
            scope: options.scope || $rootScope.$new(options.isolateScope),

            /**
             * Default usage to enable $animate to transition-in; can be easily overridden via 'options'
             */
            onShow: function transitionIn(scope, element, options) {
              return $animate.enter(element, options.parent);
            },

            /**
             * Default usage to enable $animate to transition-out; can be easily overridden via 'options'
             */
            onRemove: function transitionOut(scope, element) {
              // Element could be undefined if a new element is shown before
              // the old one finishes compiling.
              return element && $animate.leave(element) || $q.when();
            }
          }, options );

        }

        /**
         * Compile an element with a templateUrl, controller, and locals
         */
        function compileElement(options) {

          var compiled = !options.skipCompile ? $mdCompiler.compile(options) : null;

          return compiled || $q(function (resolve) {
              resolve({
                locals: {},
                link: function () {
                  return options.element;
                }
              });
            });
        }

        /**
         *  Link an element with compiled configuration
         */
        function linkElement(compileData, options){
          angular.extend(compileData.locals, options);

          var element = compileData.link(options.scope);

          // Search for parent at insertion time, if not specified
          options.element = element;
          options.parent = findParent(element, options);
          if (options.themable) $mdTheming(element);

          return element;
        }

        /**
         * Search for parent at insertion time, if not specified
         */
        function findParent(element, options) {
          var parent = options.parent;

          // Search for parent at insertion time, if not specified
          if (angular.isFunction(parent)) {
            parent = parent(options.scope, element, options);
          } else if (angular.isString(parent)) {
            parent = angular.element($document[0].querySelector(parent));
          } else {
            parent = angular.element(parent);
          }

          // If parent querySelector/getter function fails, or it's just null,
          // find a default.
          if (!(parent || {}).length) {
            var el;
            if ($rootElement[0] && $rootElement[0].querySelector) {
              el = $rootElement[0].querySelector(':not(svg) > body');
            }
            if (!el) el = $rootElement[0];
            if (el.nodeName == '#comment') {
              el = $document[0].body;
            }
            return angular.element(el);
          }

          return parent;
        }

        /**
         * If auto-hide is enabled, start timer and prepare cancel function
         */
        function startAutoHide() {
          var autoHideTimer, cancelAutoHide = angular.noop;

          if (options.hideDelay) {
            autoHideTimer = $timeout(service.hide, options.hideDelay) ;
            cancelAutoHide = function() {
              $timeout.cancel(autoHideTimer);
            };
          }

          // Cache for subsequent use
          options.cancelAutoHide = function() {
            cancelAutoHide();
            options.cancelAutoHide = undefined;
          };
        }

        /**
         * Show the element ( with transitions), notify complete and start
         * optional auto-Hide
         */
        function showElement(element, options, controller) {
          // Trigger onShowing callback before the `show()` starts
          var notifyShowing = options.onShowing || angular.noop;
          // Trigger onComplete callback when the `show()` finishes
          var notifyComplete = options.onComplete || angular.noop;

          // Necessary for consistency between Angular 1.5 and 1.6.
          try {
            notifyShowing(options.scope, element, options, controller);
          } catch (e) {
            return $q.reject(e);
          }

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              $q.when(options.onShow(options.scope, element, options, controller))
                .then(function () {
                  notifyComplete(options.scope, element, options);
                  startAutoHide();

                  resolve(element);
                }, reject);

            } catch (e) {
              reject(e.message);
            }
          });
        }

        function hideElement(element, options) {
          var announceRemoving = options.onRemoving || angular.noop;

          return $q(function (resolve, reject) {
            try {
              // Start transitionIn
              var action = $q.when( options.onRemove(options.scope, element, options) || true );

              // Trigger callback *before* the remove operation starts
              announceRemoving(element, action);

              if (options.$destroy) {
                // For $destroy, onRemove should be synchronous
                resolve(element);

                if (!options.preserveScope && options.scope ) {
                  // scope destroy should still be be done after the current digest is done
                  action.then( function() { options.scope.$destroy(); });
                }
              } else {
                // Wait until transition-out is done
                action.then(function () {
                  if (!options.preserveScope && options.scope ) {
                    options.scope.$destroy();
                  }

                  resolve(element);
                }, reject);
              }
            } catch (e) {
              reject(e.message);
            }
          });
        }

      }
    };

  }

}

(function() {
  'use strict';

  var $mdUtil, $interpolate, $log;

  var SUFFIXES = /(-gt)?-(sm|md|lg|print)/g;
  var WHITESPACE = /\s+/g;

  var FLEX_OPTIONS = ['grow', 'initial', 'auto', 'none', 'noshrink', 'nogrow' ];
  var LAYOUT_OPTIONS = ['row', 'column'];
  var ALIGNMENT_MAIN_AXIS= [ "", "start", "center", "end", "stretch", "space-around", "space-between" ];
  var ALIGNMENT_CROSS_AXIS= [ "", "start", "center", "end", "stretch" ];

  var config = {
    /**
     * Enable directive attribute-to-class conversions
     * Developers can use `<body md-layout-css />` to quickly
     * disable the Layout directives and prohibit the injection of Layout classNames
     */
    enabled: true,

    /**
     * List of mediaQuery breakpoints and associated suffixes
     *
     *   [
     *    { suffix: "sm", mediaQuery: "screen and (max-width: 599px)" },
     *    { suffix: "md", mediaQuery: "screen and (min-width: 600px) and (max-width: 959px)" }
     *   ]
     */
    breakpoints: []
  };

  registerLayoutAPI( angular.module('material.core.layout', ['ng']) );

  /**
   *   registerLayoutAPI()
   *
   *   The original ngMaterial Layout solution used attribute selectors and CSS.
   *
   *  ```html
   *  <div layout="column"> My Content </div>
   *  ```
   *
   *  ```css
   *  [layout] {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  [layout=column] {
   *    flex-direction : column
   *  }
   *  ```
   *
   *  Use of attribute selectors creates significant performance impacts in some
   *  browsers... mainly IE.
   *
   *  This module registers directives that allow the same layout attributes to be
   *  interpreted and converted to class selectors. The directive will add equivalent classes to each element that
   *  contains a Layout directive.
   *
   * ```html
   *   <div layout="column" class="layout layout-column"> My Content </div>
   *```
   *
   *  ```css
   *  .layout {
   *    box-sizing: border-box;
   *    display:flex;
   *  }
   *  .layout-column {
   *    flex-direction : column
   *  }
   *  ```
   */
  function registerLayoutAPI(module){
    var PREFIX_REGEXP = /^((?:x|data)[\:\-_])/i;
    var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;

    // NOTE: these are also defined in constants::MEDIA_PRIORITY and constants::MEDIA
    var BREAKPOINTS     = [ "", "xs", "gt-xs", "sm", "gt-sm", "md", "gt-md", "lg", "gt-lg", "xl", "print" ];
    var API_WITH_VALUES = [ "layout", "flex", "flex-order", "flex-offset", "layout-align" ];
    var API_NO_VALUES   = [ "show", "hide", "layout-padding", "layout-margin" ];


    // Build directive registration functions for the standard Layout API... for all breakpoints.
    angular.forEach(BREAKPOINTS, function(mqb) {

      // Attribute directives with expected, observable value(s)
      angular.forEach( API_WITH_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive( directiveNormalize(fullName), attributeWithObserve(fullName));
      });

      // Attribute directives with no expected value(s)
      angular.forEach( API_NO_VALUES, function(name){
        var fullName = mqb ? name + "-" + mqb : name;
        module.directive( directiveNormalize(fullName), attributeWithoutValue(fullName));
      });

    });

    // Register other, special directive functions for the Layout features:
    module

      .provider('$$mdLayout'     , function() {
        // Publish internal service for Layouts
        return {
          $get : angular.noop,
          validateAttributeValue : validateAttributeValue,
          validateAttributeUsage : validateAttributeUsage,
          /**
           * Easy way to disable/enable the Layout API.
           * When disabled, this stops all attribute-to-classname generations
           */
          disableLayouts  : function(isDisabled) {
            config.enabled =  (isDisabled !== true);
          }
        };
      })

      .directive('mdLayoutCss'        , disableLayoutDirective )
      .directive('ngCloak'            , buildCloakInterceptor('ng-cloak'))

      .directive('layoutWrap'   , attributeWithoutValue('layout-wrap'))
      .directive('layoutNowrap' , attributeWithoutValue('layout-nowrap'))
      .directive('layoutNoWrap' , attributeWithoutValue('layout-no-wrap'))
      .directive('layoutFill'   , attributeWithoutValue('layout-fill'))

      // !! Deprecated attributes: use the `-lt` (aka less-than) notations

      .directive('layoutLtMd'     , warnAttrNotSupported('layout-lt-md', true))
      .directive('layoutLtLg'     , warnAttrNotSupported('layout-lt-lg', true))
      .directive('flexLtMd'       , warnAttrNotSupported('flex-lt-md', true))
      .directive('flexLtLg'       , warnAttrNotSupported('flex-lt-lg', true))

      .directive('layoutAlignLtMd', warnAttrNotSupported('layout-align-lt-md'))
      .directive('layoutAlignLtLg', warnAttrNotSupported('layout-align-lt-lg'))
      .directive('flexOrderLtMd'  , warnAttrNotSupported('flex-order-lt-md'))
      .directive('flexOrderLtLg'  , warnAttrNotSupported('flex-order-lt-lg'))
      .directive('offsetLtMd'     , warnAttrNotSupported('flex-offset-lt-md'))
      .directive('offsetLtLg'     , warnAttrNotSupported('flex-offset-lt-lg'))

      .directive('hideLtMd'       , warnAttrNotSupported('hide-lt-md'))
      .directive('hideLtLg'       , warnAttrNotSupported('hide-lt-lg'))
      .directive('showLtMd'       , warnAttrNotSupported('show-lt-md'))
      .directive('showLtLg'       , warnAttrNotSupported('show-lt-lg'))

      // Determine if
      .config( detectDisabledLayouts );

    /**
     * Converts snake_case to camelCase.
     * Also there is special case for Moz prefix starting with upper case letter.
     * @param name Name to normalize
     */
    function directiveNormalize(name) {
      return name
        .replace(PREFIX_REGEXP, '')
        .replace(SPECIAL_CHARS_REGEXP, function(_, separator, letter, offset) {
          return offset ? letter.toUpperCase() : letter;
        });
    }

  }


  /**
    * Detect if any of the HTML tags has a [md-layouts-disabled] attribute;
    * If yes, then immediately disable all layout API features
    *
    * Note: this attribute should be specified on either the HTML or BODY tags
    */
   /**
    * ngInject
    */
   function detectDisabledLayouts() {
     var isDisabled = !!document.querySelector('[md-layouts-disabled]');
     config.enabled = !isDisabled;
   }

  /**
   * Special directive that will disable ALL Layout conversions of layout
   * attribute(s) to classname(s).
   *
   * <link rel="stylesheet" href="angular-material.min.css">
   * <link rel="stylesheet" href="angular-material.layout.css">
   *
   * <body md-layout-css>
   *  ...
   * </body>
   *
   * Note: Using md-layout-css directive requires the developer to load the Material
   * Layout Attribute stylesheet (which only uses attribute selectors):
   *
   *       `angular-material.layout.css`
   *
   * Another option is to use the LayoutProvider to configure and disable the attribute
   * conversions; this would obviate the use of the `md-layout-css` directive
   *
   */
  function disableLayoutDirective() {
    // Return a 1x-only, first-match attribute directive
    config.enabled = false;

    return {
      restrict : 'A',
      priority : '900'
    };
  }

  /**
   * Tail-hook ngCloak to delay the uncloaking while Layout transformers
   * finish processing. Eliminates flicker with Material.Layouts
   */
  function buildCloakInterceptor(className) {
    return [ '$timeout', function($timeout){
      return {
        restrict : 'A',
        priority : -10,   // run after normal ng-cloak
        compile  : function( element ) {
          if (!config.enabled) return angular.noop;

          // Re-add the cloak
          element.addClass(className);

          return function( scope, element ) {
            // Wait while layout injectors configure, then uncloak
            // NOTE: $rAF does not delay enough... and this is a 1x-only event,
            //       $timeout is acceptable.
            $timeout( function(){
              element.removeClass(className);
            }, 10, false);
          };
        }
      };
    }];
  }


  // *********************************************************************************
  //
  // These functions create registration functions for ngMaterial Layout attribute directives
  // This provides easy translation to switch ngMaterial attribute selectors to
  // CLASS selectors and directives; which has huge performance implications
  // for IE Browsers
  //
  // *********************************************************************************

  /**
   * Creates a directive registration function where a possible dynamic attribute
   * value will be observed/watched.
   * @param {string} className attribute name; eg `layout-gt-md` with value ="row"
   */
  function attributeWithObserve(className) {

    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeUsage(className, attr, element, $log);

            validateAttributeValue( className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            linkFn = translateWithValueToCssClass;
          }

          // Use for postLink to account for transforms after ng-transclude.
          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Add as transformed class selector(s), then
     * remove the deprecated attribute selector
     */
    function translateWithValueToCssClass(scope, element, attrs) {
      var updateFn = updateClassWithValue(element, className, attrs);
      var unwatch = attrs.$observe(attrs.$normalize(className), updateFn);

      updateFn(getNormalizedAttrValue(className, attrs, ""));
      scope.$on("$destroy", function() { unwatch(); });
    }
  }

  /**
   * Creates a registration function for ngMaterial Layout attribute directive.
   * This is a `simple` transpose of attribute usage to class usage; where we ignore
   * any attribute value
   */
  function attributeWithoutValue(className) {
    return ['$mdUtil', '$interpolate', "$log", function(_$mdUtil_, _$interpolate_, _$log_) {
      $mdUtil = _$mdUtil_;
      $interpolate = _$interpolate_;
      $log = _$log_;

      return {
        restrict: 'A',
        compile: function(element, attr) {
          var linkFn;
          if (config.enabled) {
            // immediately replace static (non-interpolated) invalid values...

            validateAttributeValue( className,
              getNormalizedAttrValue(className, attr, ""),
              buildUpdateFn(element, className, attr)
            );

            translateToCssClass(null, element);

            // Use for postLink to account for transforms after ng-transclude.
            linkFn = translateToCssClass;
          }

          return linkFn || angular.noop;
        }
      };
    }];

    /**
     * Add as transformed class selector, then
     * remove the deprecated attribute selector
     */
    function translateToCssClass(scope, element) {
      element.addClass(className);
    }
  }



  /**
   * After link-phase, do NOT remove deprecated layout attribute selector.
   * Instead watch the attribute so interpolated data-bindings to layout
   * selectors will continue to be supported.
   *
   * $observe() the className and update with new class (after removing the last one)
   *
   * e.g. `layout="{{layoutDemo.direction}}"` will update...
   *
   * NOTE: The value must match one of the specified styles in the CSS.
   * For example `flex-gt-md="{{size}}`  where `scope.size == 47` will NOT work since
   * only breakpoints for 0, 5, 10, 15... 100, 33, 34, 66, 67 are defined.
   *
   */
  function updateClassWithValue(element, className) {
    var lastClass;

    return function updateClassFn(newValue) {
      var value = validateAttributeValue(className, newValue || "");
      if ( angular.isDefined(value) ) {
        if (lastClass) element.removeClass(lastClass);
        lastClass = !value ? className : className + "-" + value.replace(WHITESPACE, "-");
        element.addClass(lastClass);
      }
    };
  }

  /**
   * Provide console warning that this layout attribute has been deprecated
   *
   */
  function warnAttrNotSupported(className) {
    var parts = className.split("-");
    return ["$log", function($log) {
      $log.warn(className + "has been deprecated. Please use a `" + parts[0] + "-gt-<xxx>` variant.");
      return angular.noop;
    }];
  }

  /**
   * Centralize warnings for known flexbox issues (especially IE-related issues)
   */
  function validateAttributeUsage(className, attr, element, $log){
    var message, usage, url;
    var nodeName = element[0].nodeName.toLowerCase();

    switch(className.replace(SUFFIXES,"")) {
      case "flex":
        if ((nodeName == "md-button") || (nodeName == "fieldset")){
          // @see https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers
          // Use <div flex> wrapper inside (preferred) or outside

          usage = "<" + nodeName + " " + className + "></" + nodeName + ">";
          url = "https://github.com/philipwalton/flexbugs#9-some-html-elements-cant-be-flex-containers";
          message = "Markup '{0}' may not work as expected in IE Browsers. Consult '{1}' for details.";

          $log.warn( $mdUtil.supplant(message, [usage, url]) );
        }
    }

  }


  /**
   * For the Layout attribute value, validate or replace with default
   * fallback value
   */
  function validateAttributeValue(className, value, updateFn) {
    var origValue = value;

    if (!needsInterpolation(value)) {
      switch (className.replace(SUFFIXES,"")) {
        case 'layout'        :
          if ( !findIn(value, LAYOUT_OPTIONS) ) {
            value = LAYOUT_OPTIONS[0];    // 'row';
          }
          break;

        case 'flex'          :
          if (!findIn(value, FLEX_OPTIONS)) {
            if (isNaN(value)) {
              value = '';
            }
          }
          break;

        case 'flex-offset' :
        case 'flex-order'    :
          if (!value || isNaN(+value)) {
            value = '0';
          }
          break;

        case 'layout-align'  :
          var axis = extractAlignAxis(value);
          value = $mdUtil.supplant("{main}-{cross}",axis);
          break;

        case 'layout-padding' :
        case 'layout-margin'  :
        case 'layout-fill'    :
        case 'layout-wrap'    :
        case 'layout-nowrap'  :
        case 'layout-nowrap' :
          value = '';
          break;
      }

      if (value != origValue) {
        (updateFn || angular.noop)(value);
      }
    }

    return value;
  }

  /**
   * Replace current attribute value with fallback value
   */
  function buildUpdateFn(element, className, attrs) {
    return function updateAttrValue(fallback) {
      if (!needsInterpolation(fallback)) {
        // Do not modify the element's attribute value; so
        // uses '<ui-layout layout="/api/sidebar.html" />' will not
        // be affected. Just update the attrs value.
        attrs[attrs.$normalize(className)] = fallback;
      }
    };
  }

  /**
   * See if the original value has interpolation symbols:
   * e.g.  flex-gt-md="{{triggerPoint}}"
   */
  function needsInterpolation(value) {
    return (value || "").indexOf($interpolate.startSymbol()) > -1;
  }

  function getNormalizedAttrValue(className, attrs, defaultVal) {
    var normalizedAttr = attrs.$normalize(className);
    return attrs[normalizedAttr] ? attrs[normalizedAttr].replace(WHITESPACE, "-") : defaultVal || null;
  }

  function findIn(item, list, replaceWith) {
    item = replaceWith && item ? item.replace(WHITESPACE, replaceWith) : item;

    var found = false;
    if (item) {
      list.forEach(function(it) {
        it = replaceWith ? it.replace(WHITESPACE, replaceWith) : it;
        found = found || (it === item);
      });
    }
    return found;
  }

  function extractAlignAxis(attrValue) {
    var axis = {
      main : "start",
      cross: "stretch"
    }, values;

    attrValue = (attrValue || "");

    if ( attrValue.indexOf("-") === 0 || attrValue.indexOf(" ") === 0) {
      // For missing main-axis values
      attrValue = "none" + attrValue;
    }

    values = attrValue.toLowerCase().trim().replace(WHITESPACE, "-").split("-");
    if ( values.length && (values[0] === "space") ) {
      // for main-axis values of "space-around" or "space-between"
      values = [ values[0]+"-"+values[1],values[2] ];
    }

    if ( values.length > 0 ) axis.main  = values[0] || axis.main;
    if ( values.length > 1 ) axis.cross = values[1] || axis.cross;

    if ( ALIGNMENT_MAIN_AXIS.indexOf(axis.main) < 0 )   axis.main = "start";
    if ( ALIGNMENT_CROSS_AXIS.indexOf(axis.cross) < 0 ) axis.cross = "stretch";

    return axis;
  }


})();

/**
 * @ngdoc module
 * @name material.core.liveannouncer
 * @description
 * Angular Material Live Announcer to provide accessibility for Voice Readers.
 */
MdLiveAnnouncer['$inject'] = ["$timeout"];
angular
  .module('material.core')
  .service('$mdLiveAnnouncer', MdLiveAnnouncer);

/**
 * @ngdoc service
 * @name $mdLiveAnnouncer
 * @module material.core.liveannouncer
 *
 * @description
 *
 * Service to announce messages to supported screenreaders.
 *
 * > The `$mdLiveAnnouncer` service is internally used for components to provide proper accessibility.
 *
 * <hljs lang="js">
 *   module.controller('AppCtrl', function($mdLiveAnnouncer) {
 *     // Basic announcement (Polite Mode)
 *     $mdLiveAnnouncer.announce('Hey Google');
 *
 *     // Custom announcement (Assertive Mode)
 *     $mdLiveAnnouncer.announce('Hey Google', 'assertive');
 *   });
 * </hljs>
 *
 */
function MdLiveAnnouncer($timeout) {
  /** @private @const @type {!angular.$timeout} */
  this._$timeout = $timeout;

  /** @private @const @type {!HTMLElement} */
  this._liveElement = this._createLiveElement();

  /** @private @const @type {!number} */
  this._announceTimeout = 100;
}

/**
 * @ngdoc method
 * @name $mdLiveAnnouncer#announce
 * @description Announces messages to supported screenreaders.
 * @param {string} message Message to be announced to the screenreader
 * @param {'off'|'polite'|'assertive'} politeness The politeness of the announcer element.
 */
MdLiveAnnouncer.prototype.announce = function(message, politeness) {
  if (!politeness) {
    politeness = 'polite';
  }

  var self = this;

  self._liveElement.textContent = '';
  self._liveElement.setAttribute('aria-live', politeness);

  // This 100ms timeout is necessary for some browser + screen-reader combinations:
  // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
  // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
  //   second time without clearing and then using a non-zero delay.
  // (using JAWS 17 at time of this writing).
  self._$timeout(function() {
    self._liveElement.textContent = message;
  }, self._announceTimeout, false);
};

/**
 * Creates a live announcer element, which listens for DOM changes and announces them
 * to the screenreaders.
 * @returns {!HTMLElement}
 * @private
 */
MdLiveAnnouncer.prototype._createLiveElement = function() {
  var liveEl = document.createElement('div');

  liveEl.classList.add('md-visually-hidden');
  liveEl.setAttribute('role', 'status');
  liveEl.setAttribute('aria-atomic', 'true');
  liveEl.setAttribute('aria-live', 'polite');

  document.body.appendChild(liveEl);

  return liveEl;
};

/**
 * @ngdoc service
 * @name $$mdMeta
 * @module material.core.meta
 *
 * @description
 *
 * A provider and a service that simplifies meta tags access
 *
 * Note: This is intended only for use with dynamic meta tags such as browser color and title.
 * Tags that are only processed when the page is rendered (such as `charset`, and `http-equiv`)
 * will not work since `$$mdMeta` adds the tags after the page has already been loaded.
 *
 * ```js
 * app.config(function($$mdMetaProvider) {
 *   var removeMeta = $$mdMetaProvider.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMetaProvider.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 *
 * app.controller('myController', function($$mdMeta) {
 *   var removeMeta = $$mdMeta.setMeta('meta-name', 'content');
 *   var metaValue  = $$mdMeta.getMeta('meta-name'); // -> 'content'
 *
 *   removeMeta();
 * });
 * ```
 *
 * @returns {$$mdMeta.$service}
 *
 */
angular.module('material.core.meta', [])
  .provider('$$mdMeta', function () {
    var head = angular.element(document.head);
    var metaElements = {};

    /**
     * Checks if the requested element was written manually and maps it
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {boolean} returns true if there is an element with the requested name
     */
    function mapExistingElement(name) {
      if (metaElements[name]) {
        return true;
      }

      var element = document.getElementsByName(name)[0];

      if (!element) {
        return false;
      }

      metaElements[name] = angular.element(element);

      return true;
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#setMeta
     *
     * @description
     * Creates meta element with the 'name' and 'content' attributes,
     * if the meta tag is already created than we replace the 'content' value
     *
     * @param {string} name meta tag 'name' attribute value
     * @param {string} content meta tag 'content' attribute value
     * @returns {function} remove function
     *
     */
    function setMeta(name, content) {
      mapExistingElement(name);

      if (!metaElements[name]) {
        var newMeta = angular.element('<meta name="' + name + '" content="' + content + '"/>');
        head.append(newMeta);
        metaElements[name] = newMeta;
      }
      else {
        metaElements[name].attr('content', content);
      }

      return function () {
        metaElements[name].attr('content', '');
        metaElements[name].remove();
        delete metaElements[name];
      };
    }

    /**
     * @ngdoc method
     * @name $$mdMeta#getMeta
     *
     * @description
     * Gets the 'content' attribute value of the wanted meta element
     *
     * @param {string} name meta tag 'name' attribute value
     * @returns {string} content attribute value
     */
    function getMeta(name) {
      if (!mapExistingElement(name)) {
        throw Error('$$mdMeta: could not find a meta tag with the name \'' + name + '\'');
      }

      return metaElements[name].attr('content');
    }

    var module = {
      setMeta: setMeta,
      getMeta: getMeta
    };

    return angular.extend({}, module, {
      $get: function () {
        return module;
      }
    });
  });
  /**
   * @ngdoc module
   * @name material.core.componentRegistry
   *
   * @description
   * A component instance registration service.
   * Note: currently this as a private service in the SideNav component.
   */
  ComponentRegistry['$inject'] = ["$log", "$q"];
  angular.module('material.core')
    .factory('$mdComponentRegistry', ComponentRegistry);

  /*
   * @private
   * @ngdoc factory
   * @name ComponentRegistry
   * @module material.core.componentRegistry
   *
   */
  function ComponentRegistry($log, $q) {

    var self;
    var instances = [ ];
    var pendings = { };

    return self = {
      /**
       * Used to print an error when an instance for a handle isn't found.
       */
      notFoundError: function(handle, msgContext) {
        $log.error( (msgContext || "") + 'No instance found for handle', handle);
      },
      /**
       * Return all registered instances as an array.
       */
      getInstances: function() {
        return instances;
      },

      /**
       * Get a registered instance.
       * @param handle the String handle to look up for a registered instance.
       */
      get: function(handle) {
        if ( !isValidID(handle) ) return null;

        var i, j, instance;
        for(i = 0, j = instances.length; i < j; i++) {
          instance = instances[i];
          if(instance.$$mdHandle === handle) {
            return instance;
          }
        }
        return null;
      },

      /**
       * Register an instance.
       * @param instance the instance to register
       * @param handle the handle to identify the instance under.
       */
      register: function(instance, handle) {
        if ( !handle ) return angular.noop;

        instance.$$mdHandle = handle;
        instances.push(instance);
        resolveWhen();

        return deregister;

        /**
         * Remove registration for an instance
         */
        function deregister() {
          var index = instances.indexOf(instance);
          if (index !== -1) {
            instances.splice(index, 1);
          }
        }

        /**
         * Resolve any pending promises for this instance
         */
        function resolveWhen() {
          var dfd = pendings[handle];
          if ( dfd ) {
            dfd.forEach(function (promise) {
              promise.resolve(instance);
            });
            delete pendings[handle];
          }
        }
      },

      /**
       * Async accessor to registered component instance
       * If not available then a promise is created to notify
       * all listeners when the instance is registered.
       */
      when : function(handle) {
        if ( isValidID(handle) ) {
          var deferred = $q.defer();
          var instance = self.get(handle);

          if ( instance )  {
            deferred.resolve( instance );
          } else {
            if (pendings[handle] === undefined) {
              pendings[handle] = [];
            }
            pendings[handle].push(deferred);
          }

          return deferred.promise;
        }
        return $q.reject("Invalid `md-component-id` value.");
      }

    };

    function isValidID(handle){
      return handle && (handle !== "");
    }

  }

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdButtonInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-button.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the default ripple configuration
   */

  MdButtonInkRipple['$inject'] = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdButtonInkRipple', MdButtonInkRipple);

  function MdButtonInkRipple($mdInkRipple) {
    return {
      attach: function attachRipple(scope, element, options) {
        options = angular.extend(optionsForElement(element), options);

        return $mdInkRipple.attach(scope, element, options);
      }
    };

    function optionsForElement(element) {
      if (element.hasClass('md-icon-button')) {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          fitRipple: true,
          center: true
        };
      } else {
        return {
          isMenuItem: element.hasClass('md-menu-item'),
          dimBackground: true
        };
      }
    }
  }
})();

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdCheckboxInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-checkbox.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdCheckboxInkRipple['$inject'] = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdCheckboxInkRipple', MdCheckboxInkRipple);

  function MdCheckboxInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: true,
        dimBackground: false,
        fitRipple: true
      }, options));
    }
  }
})();

(function() {
  'use strict';

  /**
   * @ngdoc service
   * @name $mdListInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-list.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdListInkRipple['$inject'] = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdListInkRipple', MdListInkRipple);

  function MdListInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

/**
 * @ngdoc module
 * @name material.core.ripple
 * @description
 * Ripple
 */
InkRippleCtrl['$inject'] = ["$scope", "$element", "rippleOptions", "$window", "$timeout", "$mdUtil", "$mdColorUtil"];
InkRippleDirective['$inject'] = ["$mdButtonInkRipple", "$mdCheckboxInkRipple"];
angular.module('material.core')
    .provider('$mdInkRipple', InkRippleProvider)
    .directive('mdInkRipple', InkRippleDirective)
    .directive('mdNoInk', attrNoDirective)
    .directive('mdNoBar', attrNoDirective)
    .directive('mdNoStretch', attrNoDirective);

var DURATION = 450;

/**
 * @ngdoc directive
 * @name mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * The `md-ink-ripple` directive allows you to specify the ripple color or id a ripple is allowed.
 *
 * @param {string|boolean} md-ink-ripple A color string `#FF0000` or boolean (`false` or `0`) for preventing ripple
 *
 * @usage
 * ### String values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="#FF0000">
 *     Ripples in red
 *   </ANY>
 *
 *   <ANY md-ink-ripple="false">
 *     Not rippling
 *   </ANY>
 * </hljs>
 *
 * ### Interpolated values
 * <hljs lang="html">
 *   <ANY md-ink-ripple="{{ randomColor() }}">
 *     Ripples with the return value of 'randomColor' function
 *   </ANY>
 *
 *   <ANY md-ink-ripple="{{ canRipple() }}">
 *     Ripples if 'canRipple' function return value is not 'false' or '0'
 *   </ANY>
 * </hljs>
 */
function InkRippleDirective ($mdButtonInkRipple, $mdCheckboxInkRipple) {
  return {
    controller: angular.noop,
    link:       function (scope, element, attr) {
      attr.hasOwnProperty('mdInkRippleCheckbox')
          ? $mdCheckboxInkRipple.attach(scope, element)
          : $mdButtonInkRipple.attach(scope, element);
    }
  };
}

/**
 * @ngdoc service
 * @name $mdInkRipple
 * @module material.core.ripple
 *
 * @description
 * `$mdInkRipple` is a service for adding ripples to any element
 *
 * @usage
 * <hljs lang="js">
 * app.factory('$myElementInkRipple', function($mdInkRipple) {
 *   return {
 *     attach: function (scope, element, options) {
 *       return $mdInkRipple.attach(scope, element, angular.extend({
 *         center: false,
 *         dimBackground: true
 *       }, options));
 *     }
 *   };
 * });
 *
 * app.controller('myController', function ($scope, $element, $myElementInkRipple) {
 *   $scope.onClick = function (ev) {
 *     $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true });
 *   }
 * });
 * </hljs>
 *
 * ### Disabling ripples globally
 * If you want to disable ink ripples globally, for all components, you can call the
 * `disableInkRipple` method in your app's config.
 *
 * <hljs lang="js">
 * app.config(function ($mdInkRippleProvider) {
 *   $mdInkRippleProvider.disableInkRipple();
 * });
 */

function InkRippleProvider () {
  var isDisabledGlobally = false;

  return {
    disableInkRipple: disableInkRipple,
    $get: ["$injector", function($injector) {
      return { attach: attach };

      /**
       * @ngdoc method
       * @name $mdInkRipple#attach
       *
       * @description
       * Attaching given scope, element and options to inkRipple controller
       *
       * @param {object=} scope Scope within the current context
       * @param {object=} element The element the ripple effect should be applied to
       * @param {object=} options (Optional) Configuration options to override the defaultRipple configuration
       * * `center` -  Whether the ripple should start from the center of the container element
       * * `dimBackground` - Whether the background should be dimmed with the ripple color
       * * `colorElement` - The element the ripple should take its color from, defined by css property `color`
       * * `fitRipple` - Whether the ripple should fill the element
       */
      function attach (scope, element, options) {
        if (isDisabledGlobally || element.controller('mdNoInk')) return angular.noop;
        return $injector.instantiate(InkRippleCtrl, {
          $scope:        scope,
          $element:      element,
          rippleOptions: options
        });
      }
    }]
  };

  /**
   * @ngdoc method
   * @name $mdInkRipple#disableInkRipple
   *
   * @description
   * A config-time method that, when called, disables ripples globally.
   */
  function disableInkRipple () {
    isDisabledGlobally = true;
  }
}

/**
 * Controller used by the ripple service in order to apply ripples
 * ngInject
 */
function InkRippleCtrl ($scope, $element, rippleOptions, $window, $timeout, $mdUtil, $mdColorUtil) {
  this.$window    = $window;
  this.$timeout   = $timeout;
  this.$mdUtil    = $mdUtil;
  this.$mdColorUtil    = $mdColorUtil;
  this.$scope     = $scope;
  this.$element   = $element;
  this.options    = rippleOptions;
  this.mousedown  = false;
  this.ripples    = [];
  this.timeout    = null; // Stores a reference to the most-recent ripple timeout
  this.lastRipple = null;

  $mdUtil.valueOnUse(this, 'container', this.createContainer);

  this.$element.addClass('md-ink-ripple');

  // attach method for unit tests
  ($element.controller('mdInkRipple') || {}).createRipple = angular.bind(this, this.createRipple);
  ($element.controller('mdInkRipple') || {}).setColor = angular.bind(this, this.color);

  this.bindEvents();
}


/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup or mouseleave event)
 */
function autoCleanup (self, cleanupFn) {

  if ( self.mousedown || self.lastRipple ) {
    self.mousedown = false;
    self.$mdUtil.nextTick( angular.bind(self, cleanupFn), false);
  }

}


/**
 * Returns the color that the ripple should be (either based on CSS or hard-coded)
 * @returns {string}
 */
InkRippleCtrl.prototype.color = function (value) {
  var self = this;

  // If assigning a color value, apply it to background and the ripple color
  if (angular.isDefined(value)) {
    self._color = self._parseColor(value);
  }

  // If color lookup, use assigned, defined, or inherited
  return self._color || self._parseColor( self.inkRipple() ) || self._parseColor( getElementColor() );

  /**
   * Finds the color element and returns its text color for use as default ripple color
   * @returns {string}
   */
  function getElementColor () {
    var items = self.options && self.options.colorElement ? self.options.colorElement : [];
    var elem =  items.length ? items[ 0 ] : self.$element[ 0 ];

    return elem ? self.$window.getComputedStyle(elem).color : 'rgb(0,0,0)';
  }
};

/**
 * Updating the ripple colors based on the current inkRipple value
 * or the element's computed style color
 */
InkRippleCtrl.prototype.calculateColor = function () {
  return this.color();
};


/**
 * Takes a string color and converts it to RGBA format
 * @param color {string}
 * @param [multiplier] {int}
 * @returns {string}
 */

InkRippleCtrl.prototype._parseColor = function parseColor (color, multiplier) {
  multiplier = multiplier || 1;
  var colorUtil = this.$mdColorUtil;

  if (!color) return;
  if (color.indexOf('rgba') === 0) return color.replace(/\d?\.?\d*\s*\)\s*$/, (0.1 * multiplier).toString() + ')');
  if (color.indexOf('rgb') === 0) return colorUtil.rgbToRgba(color);
  if (color.indexOf('#') === 0) return colorUtil.hexToRgba(color);

};

/**
 * Binds events to the root element for
 */
InkRippleCtrl.prototype.bindEvents = function () {
  this.$element.on('mousedown', angular.bind(this, this.handleMousedown));
  this.$element.on('mouseup touchend', angular.bind(this, this.handleMouseup));
  this.$element.on('mouseleave', angular.bind(this, this.handleMouseup));
  this.$element.on('touchmove', angular.bind(this, this.handleTouchmove));
};

/**
 * Create a new ripple on every mousedown event from the root element
 * @param event {MouseEvent}
 */
InkRippleCtrl.prototype.handleMousedown = function (event) {
  if ( this.mousedown ) return;

  // When jQuery is loaded, we have to get the original event
  if (event.hasOwnProperty('originalEvent')) event = event.originalEvent;
  this.mousedown = true;
  if (this.options.center) {
    this.createRipple(this.container.prop('clientWidth') / 2, this.container.prop('clientWidth') / 2);
  } else {

    // We need to calculate the relative coordinates if the target is a sublayer of the ripple element
    if (event.srcElement !== this.$element[0]) {
      var layerRect = this.$element[0].getBoundingClientRect();
      var layerX = event.clientX - layerRect.left;
      var layerY = event.clientY - layerRect.top;

      this.createRipple(layerX, layerY);
    } else {
      this.createRipple(event.offsetX, event.offsetY);
    }
  }
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (either by
 * mouseup, touchend or mouseleave event)
 */
InkRippleCtrl.prototype.handleMouseup = function () {
  autoCleanup(this, this.clearRipples);
};

/**
 * Either remove or unlock any remaining ripples when the user mouses off of the element (by
 * touchmove)
 */
InkRippleCtrl.prototype.handleTouchmove = function () {
  autoCleanup(this, this.deleteRipples);
};

/**
 * Cycles through all ripples and attempts to remove them.
 */
InkRippleCtrl.prototype.deleteRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.ripples[ i ].remove();
  }
};

/**
 * Cycles through all ripples and attempts to remove them with fade.
 * Depending on logic within `fadeInComplete`, some removals will be postponed.
 */
InkRippleCtrl.prototype.clearRipples = function () {
  for (var i = 0; i < this.ripples.length; i++) {
    this.fadeInComplete(this.ripples[ i ]);
  }
};

/**
 * Creates the ripple container element
 * @returns {*}
 */
InkRippleCtrl.prototype.createContainer = function () {
  var container = angular.element('<div class="md-ripple-container"></div>');
  this.$element.append(container);
  return container;
};

InkRippleCtrl.prototype.clearTimeout = function () {
  if (this.timeout) {
    this.$timeout.cancel(this.timeout);
    this.timeout = null;
  }
};

InkRippleCtrl.prototype.isRippleAllowed = function () {
  var element = this.$element[0];
  do {
    if (!element.tagName || element.tagName === 'BODY') break;

    if (element && angular.isFunction(element.hasAttribute)) {
      if (element.hasAttribute('disabled')) return false;
      if (this.inkRipple() === 'false' || this.inkRipple() === '0') return false;
    }

  } while (element = element.parentNode);
  return true;
};

/**
 * The attribute `md-ink-ripple` may be a static or interpolated
 * color value OR a boolean indicator (used to disable ripples)
 */
InkRippleCtrl.prototype.inkRipple = function () {
  return this.$element.attr('md-ink-ripple');
};

/**
 * Creates a new ripple and adds it to the container.  Also tracks ripple in `this.ripples`.
 * @param left
 * @param top
 */
InkRippleCtrl.prototype.createRipple = function (left, top) {
  if (!this.isRippleAllowed()) return;

  var ctrl        = this;
  var colorUtil   = ctrl.$mdColorUtil;
  var ripple      = angular.element('<div class="md-ripple"></div>');
  var width       = this.$element.prop('clientWidth');
  var height      = this.$element.prop('clientHeight');
  var x           = Math.max(Math.abs(width - left), left) * 2;
  var y           = Math.max(Math.abs(height - top), top) * 2;
  var size        = getSize(this.options.fitRipple, x, y);
  var color       = this.calculateColor();

  ripple.css({
    left:            left + 'px',
    top:             top + 'px',
    background:      'black',
    width:           size + 'px',
    height:          size + 'px',
    backgroundColor: colorUtil.rgbaToRgb(color),
    borderColor:     colorUtil.rgbaToRgb(color)
  });
  this.lastRipple = ripple;

  // we only want one timeout to be running at a time
  this.clearTimeout();
  this.timeout    = this.$timeout(function () {
    ctrl.clearTimeout();
    if (!ctrl.mousedown) ctrl.fadeInComplete(ripple);
  }, DURATION * 0.35, false);

  if (this.options.dimBackground) this.container.css({ backgroundColor: color });
  this.container.append(ripple);
  this.ripples.push(ripple);
  ripple.addClass('md-ripple-placed');

  this.$mdUtil.nextTick(function () {

    ripple.addClass('md-ripple-scaled md-ripple-active');
    ctrl.$timeout(function () {
      ctrl.clearRipples();
    }, DURATION, false);

  }, false);

  function getSize (fit, x, y) {
    return fit
        ? Math.max(x, y)
        : Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
  }
};



/**
 * After fadeIn finishes, either kicks off the fade-out animation or queues the element for removal on mouseup
 * @param ripple
 */
InkRippleCtrl.prototype.fadeInComplete = function (ripple) {
  if (this.lastRipple === ripple) {
    if (!this.timeout && !this.mousedown) {
      this.removeRipple(ripple);
    }
  } else {
    this.removeRipple(ripple);
  }
};

/**
 * Kicks off the animation for removing a ripple
 * @param ripple {Element}
 */
InkRippleCtrl.prototype.removeRipple = function (ripple) {
  var ctrl  = this;
  var index = this.ripples.indexOf(ripple);
  if (index < 0) return;
  this.ripples.splice(this.ripples.indexOf(ripple), 1);
  ripple.removeClass('md-ripple-active');
  ripple.addClass('md-ripple-remove');
  if (this.ripples.length === 0) this.container.css({ backgroundColor: '' });
  // use a 2-second timeout in order to allow for the animation to finish
  // we don't actually care how long the animation takes
  this.$timeout(function () {
    ctrl.fadeOutComplete(ripple);
  }, DURATION, false);
};

/**
 * Removes the provided ripple from the DOM
 * @param ripple
 */
InkRippleCtrl.prototype.fadeOutComplete = function (ripple) {
  ripple.remove();
  this.lastRipple = null;
};

/**
 * Used to create an empty directive.  This is used to track flag-directives whose children may have
 * functionality based on them.
 *
 * Example: `md-no-ink` will potentially be used by all child directives.
 */
function attrNoDirective () {
  return { controller: angular.noop };
}

(function() {
  'use strict';

    /**
   * @ngdoc service
   * @name $mdTabInkRipple
   * @module material.core
   *
   * @description
   * Provides ripple effects for md-tabs.  See $mdInkRipple service for all possible configuration options.
   *
   * @param {object=} scope Scope within the current context
   * @param {object=} element The element the ripple effect should be applied to
   * @param {object=} options (Optional) Configuration options to override the defaultripple configuration
   */

  MdTabInkRipple['$inject'] = ["$mdInkRipple"];
  angular.module('material.core')
    .factory('$mdTabInkRipple', MdTabInkRipple);

  function MdTabInkRipple($mdInkRipple) {
    return {
      attach: attach
    };

    function attach(scope, element, options) {
      return $mdInkRipple.attach(scope, element, angular.extend({
        center: false,
        dimBackground: true,
        outline: false,
        rippleSize: 'full'
      }, options));
    }
  }
})();

angular.module('material.core.theming.palette', [])
.constant('$mdColorPalette', {
  'red': {
    '50': '#ffebee',
    '100': '#ffcdd2',
    '200': '#ef9a9a',
    '300': '#e57373',
    '400': '#ef5350',
    '500': '#f44336',
    '600': '#e53935',
    '700': '#d32f2f',
    '800': '#c62828',
    '900': '#b71c1c',
    'A100': '#ff8a80',
    'A200': '#ff5252',
    'A400': '#ff1744',
    'A700': '#d50000',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100',
    'contrastStrongLightColors': '400 500 600 700 A200 A400 A700'
  },
  'pink': {
    '50': '#fce4ec',
    '100': '#f8bbd0',
    '200': '#f48fb1',
    '300': '#f06292',
    '400': '#ec407a',
    '500': '#e91e63',
    '600': '#d81b60',
    '700': '#c2185b',
    '800': '#ad1457',
    '900': '#880e4f',
    'A100': '#ff80ab',
    'A200': '#ff4081',
    'A400': '#f50057',
    'A700': '#c51162',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '500 600 A200 A400 A700'
  },
  'purple': {
    '50': '#f3e5f5',
    '100': '#e1bee7',
    '200': '#ce93d8',
    '300': '#ba68c8',
    '400': '#ab47bc',
    '500': '#9c27b0',
    '600': '#8e24aa',
    '700': '#7b1fa2',
    '800': '#6a1b9a',
    '900': '#4a148c',
    'A100': '#ea80fc',
    'A200': '#e040fb',
    'A400': '#d500f9',
    'A700': '#aa00ff',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200 A400 A700'
  },
  'deep-purple': {
    '50': '#ede7f6',
    '100': '#d1c4e9',
    '200': '#b39ddb',
    '300': '#9575cd',
    '400': '#7e57c2',
    '500': '#673ab7',
    '600': '#5e35b1',
    '700': '#512da8',
    '800': '#4527a0',
    '900': '#311b92',
    'A100': '#b388ff',
    'A200': '#7c4dff',
    'A400': '#651fff',
    'A700': '#6200ea',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200'
  },
  'indigo': {
    '50': '#e8eaf6',
    '100': '#c5cae9',
    '200': '#9fa8da',
    '300': '#7986cb',
    '400': '#5c6bc0',
    '500': '#3f51b5',
    '600': '#3949ab',
    '700': '#303f9f',
    '800': '#283593',
    '900': '#1a237e',
    'A100': '#8c9eff',
    'A200': '#536dfe',
    'A400': '#3d5afe',
    'A700': '#304ffe',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100',
    'contrastStrongLightColors': '300 400 A200 A400'
  },
  'blue': {
    '50': '#e3f2fd',
    '100': '#bbdefb',
    '200': '#90caf9',
    '300': '#64b5f6',
    '400': '#42a5f5',
    '500': '#2196f3',
    '600': '#1e88e5',
    '700': '#1976d2',
    '800': '#1565c0',
    '900': '#0d47a1',
    'A100': '#82b1ff',
    'A200': '#448aff',
    'A400': '#2979ff',
    'A700': '#2962ff',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100',
    'contrastStrongLightColors': '500 600 700 A200 A400 A700'
  },
  'light-blue': {
    '50': '#e1f5fe',
    '100': '#b3e5fc',
    '200': '#81d4fa',
    '300': '#4fc3f7',
    '400': '#29b6f6',
    '500': '#03a9f4',
    '600': '#039be5',
    '700': '#0288d1',
    '800': '#0277bd',
    '900': '#01579b',
    'A100': '#80d8ff',
    'A200': '#40c4ff',
    'A400': '#00b0ff',
    'A700': '#0091ea',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '600 700 800 900 A700',
    'contrastStrongLightColors': '600 700 800 A700'
  },
  'cyan': {
    '50': '#e0f7fa',
    '100': '#b2ebf2',
    '200': '#80deea',
    '300': '#4dd0e1',
    '400': '#26c6da',
    '500': '#00bcd4',
    '600': '#00acc1',
    '700': '#0097a7',
    '800': '#00838f',
    '900': '#006064',
    'A100': '#84ffff',
    'A200': '#18ffff',
    'A400': '#00e5ff',
    'A700': '#00b8d4',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '700 800 900',
    'contrastStrongLightColors': '700 800 900'
  },
  'teal': {
    '50': '#e0f2f1',
    '100': '#b2dfdb',
    '200': '#80cbc4',
    '300': '#4db6ac',
    '400': '#26a69a',
    '500': '#009688',
    '600': '#00897b',
    '700': '#00796b',
    '800': '#00695c',
    '900': '#004d40',
    'A100': '#a7ffeb',
    'A200': '#64ffda',
    'A400': '#1de9b6',
    'A700': '#00bfa5',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '500 600 700 800 900',
    'contrastStrongLightColors': '500 600 700'
  },
  'green': {
    '50': '#e8f5e9',
    '100': '#c8e6c9',
    '200': '#a5d6a7',
    '300': '#81c784',
    '400': '#66bb6a',
    '500': '#4caf50',
    '600': '#43a047',
    '700': '#388e3c',
    '800': '#2e7d32',
    '900': '#1b5e20',
    'A100': '#b9f6ca',
    'A200': '#69f0ae',
    'A400': '#00e676',
    'A700': '#00c853',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '500 600 700 800 900',
    'contrastStrongLightColors': '500 600 700'
  },
  'light-green': {
    '50': '#f1f8e9',
    '100': '#dcedc8',
    '200': '#c5e1a5',
    '300': '#aed581',
    '400': '#9ccc65',
    '500': '#8bc34a',
    '600': '#7cb342',
    '700': '#689f38',
    '800': '#558b2f',
    '900': '#33691e',
    'A100': '#ccff90',
    'A200': '#b2ff59',
    'A400': '#76ff03',
    'A700': '#64dd17',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '700 800 900',
    'contrastStrongLightColors': '700 800 900'
  },
  'lime': {
    '50': '#f9fbe7',
    '100': '#f0f4c3',
    '200': '#e6ee9c',
    '300': '#dce775',
    '400': '#d4e157',
    '500': '#cddc39',
    '600': '#c0ca33',
    '700': '#afb42b',
    '800': '#9e9d24',
    '900': '#827717',
    'A100': '#f4ff81',
    'A200': '#eeff41',
    'A400': '#c6ff00',
    'A700': '#aeea00',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '900',
    'contrastStrongLightColors': '900'
  },
  'yellow': {
    '50': '#fffde7',
    '100': '#fff9c4',
    '200': '#fff59d',
    '300': '#fff176',
    '400': '#ffee58',
    '500': '#ffeb3b',
    '600': '#fdd835',
    '700': '#fbc02d',
    '800': '#f9a825',
    '900': '#f57f17',
    'A100': '#ffff8d',
    'A200': '#ffff00',
    'A400': '#ffea00',
    'A700': '#ffd600',
    'contrastDefaultColor': 'dark'
  },
  'amber': {
    '50': '#fff8e1',
    '100': '#ffecb3',
    '200': '#ffe082',
    '300': '#ffd54f',
    '400': '#ffca28',
    '500': '#ffc107',
    '600': '#ffb300',
    '700': '#ffa000',
    '800': '#ff8f00',
    '900': '#ff6f00',
    'A100': '#ffe57f',
    'A200': '#ffd740',
    'A400': '#ffc400',
    'A700': '#ffab00',
    'contrastDefaultColor': 'dark'
  },
  'orange': {
    '50': '#fff3e0',
    '100': '#ffe0b2',
    '200': '#ffcc80',
    '300': '#ffb74d',
    '400': '#ffa726',
    '500': '#ff9800',
    '600': '#fb8c00',
    '700': '#f57c00',
    '800': '#ef6c00',
    '900': '#e65100',
    'A100': '#ffd180',
    'A200': '#ffab40',
    'A400': '#ff9100',
    'A700': '#ff6d00',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '800 900',
    'contrastStrongLightColors': '800 900'
  },
  'deep-orange': {
    '50': '#fbe9e7',
    '100': '#ffccbc',
    '200': '#ffab91',
    '300': '#ff8a65',
    '400': '#ff7043',
    '500': '#ff5722',
    '600': '#f4511e',
    '700': '#e64a19',
    '800': '#d84315',
    '900': '#bf360c',
    'A100': '#ff9e80',
    'A200': '#ff6e40',
    'A400': '#ff3d00',
    'A700': '#dd2c00',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 400 A100 A200',
    'contrastStrongLightColors': '500 600 700 800 900 A400 A700'
  },
  'brown': {
    '50': '#efebe9',
    '100': '#d7ccc8',
    '200': '#bcaaa4',
    '300': '#a1887f',
    '400': '#8d6e63',
    '500': '#795548',
    '600': '#6d4c41',
    '700': '#5d4037',
    '800': '#4e342e',
    '900': '#3e2723',
    'A100': '#d7ccc8',
    'A200': '#bcaaa4',
    'A400': '#8d6e63',
    'A700': '#5d4037',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 A100 A200',
    'contrastStrongLightColors': '300 400'
  },
  'grey': {
    '50': '#fafafa',
    '100': '#f5f5f5',
    '200': '#eeeeee',
    '300': '#e0e0e0',
    '400': '#bdbdbd',
    '500': '#9e9e9e',
    '600': '#757575',
    '700': '#616161',
    '800': '#424242',
    '900': '#212121',
    'A100': '#ffffff',
    'A200': '#000000',
    'A400': '#303030',
    'A700': '#616161',
    'contrastDefaultColor': 'dark',
    'contrastLightColors': '600 700 800 900 A200 A400 A700'
  },
  'blue-grey': {
    '50': '#eceff1',
    '100': '#cfd8dc',
    '200': '#b0bec5',
    '300': '#90a4ae',
    '400': '#78909c',
    '500': '#607d8b',
    '600': '#546e7a',
    '700': '#455a64',
    '800': '#37474f',
    '900': '#263238',
    'A100': '#cfd8dc',
    'A200': '#b0bec5',
    'A400': '#78909c',
    'A700': '#455a64',
    'contrastDefaultColor': 'light',
    'contrastDarkColors': '50 100 200 300 A100 A200',
    'contrastStrongLightColors': '400 500 700'
  }
});

(function(angular) {
  'use strict';
/**
 * @ngdoc module
 * @name material.core.theming
 * @description
 * Theming
 */
detectDisabledThemes['$inject'] = ["$mdThemingProvider"];
ThemingDirective['$inject'] = ["$mdTheming", "$interpolate", "$parse", "$mdUtil", "$q", "$log"];
ThemableDirective['$inject'] = ["$mdTheming"];
ThemingProvider['$inject'] = ["$mdColorPalette", "$$mdMetaProvider"];
generateAllThemes['$inject'] = ["$injector", "$mdTheming"];
angular.module('material.core.theming', ['material.core.theming.palette', 'material.core.meta'])
  .directive('mdTheme', ThemingDirective)
  .directive('mdThemable', ThemableDirective)
  .directive('mdThemesDisabled', disableThemesDirective )
  .provider('$mdTheming', ThemingProvider)
  .config( detectDisabledThemes )
  .run(generateAllThemes);

/**
 * Detect if the HTML or the BODY tags has a [md-themes-disabled] attribute
 * If yes, then immediately disable all theme stylesheet generation and DOM injection
 */
/**
 * ngInject
 */
function detectDisabledThemes($mdThemingProvider) {
  var isDisabled = !!document.querySelector('[md-themes-disabled]');
  $mdThemingProvider.disableTheming(isDisabled);
}

/**
 * @ngdoc service
 * @name $mdThemingProvider
 * @module material.core.theming
 *
 * @description Provider to configure the `$mdTheming` service.
 *
 * ### Default Theme
 * The `$mdThemingProvider` uses by default the following theme configuration:
 *
 * - Primary Palette: `Blue`
 * - Accent Palette: `Pink`
 * - Warn Palette: `Deep-Orange`
 * - Background Palette: `Grey`
 *
 * If you don't want to use the `md-theme` directive on the elements itself, you may want to overwrite
 * the default theme.<br/>
 * This can be done by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     $mdThemingProvider
 *       .theme('default')
 *       .primaryPalette('blue')
 *       .accentPalette('teal')
 *       .warnPalette('red')
 *       .backgroundPalette('grey');
 *   });
 * </hljs>
 *

 * ### Dynamic Themes
 *
 * By default, if you change a theme at runtime, the `$mdTheming` service will not detect those changes.<br/>
 * If you have an application, which changes its theme on runtime, you have to enable theme watching.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable theme watching.
 *     $mdThemingProvider.alwaysWatchTheme(true);
 *   });
 * </hljs>
 *
 * ### Custom Theme Styles
 *
 * Sometimes you may want to use your own theme styles for some custom components.<br/>
 * You are able to register your own styles by using the following markup.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register our custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(STYLESHEET);
 *   });
 * </hljs>
 *
 * The `registerStyles` method only accepts strings as value, so you're actually not able to load an external
 * stylesheet file into the `$mdThemingProvider`.
 *
 * If it's necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content,
 * like [raw-loader](https://github.com/webpack/raw-loader) for `webpack`.
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Register your custom stylesheet into the theming provider.
 *     $mdThemingProvider.registerStyles(require('../styles/my-component.theme.css'));
 *   });
 * </hljs>
 *
 * ### Browser color
 *
 * Enables browser header coloring
 * for more info please visit:
 * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
 *
 * Options parameter: <br/>
 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
 * `hue`     - The hue from the selected palette. Default is `800`<br/>
 *
 * <hljs lang="js">
 *   myAppModule.config(function($mdThemingProvider) {
 *     // Enable browser color
 *     $mdThemingProvider.enableBrowserColor({
 *       theme: 'myTheme', // Default is 'default'
 *       palette: 'accent', // Default is 'primary', any basic material palette and extended palettes are available
 *       hue: '200' // Default is '800'
 *     });
 *   });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#registerStyles
 * @param {string} styles The styles to be appended to Angular Material's built in theme css.
 */
/**
 * @ngdoc method
 * @name $mdThemingProvider#setNonce
 * @param {string} nonceValue The nonce to be added as an attribute to the theme style tags.
 * Setting a value allows the use of CSP policy without using the unsafe-inline directive.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#setDefaultTheme
 * @param {string} themeName Default theme name to be applied to elements. Default value is `default`.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#alwaysWatchTheme
 * @param {boolean} watch Whether or not to always watch themes for changes and re-apply
 * classes when they change. Default is `false`. Enabling can reduce performance.
 */

/**
 * @ngdoc method
 * @name $mdThemingProvider#enableBrowserColor
 * @param {Object=} options Options object for the browser color<br/>
 * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme. <br/>
 * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
 *             'accent', 'background' and 'warn'. Default is `primary`. <br/>
 * `hue`     - The hue from the selected palette. Default is `800`<br/>
 * @returns {Function} remove function of the browser color
 */

/* Some Example Valid Theming Expressions
 * =======================================
 *
 * Intention group expansion: (valid for primary, accent, warn, background)
 *
 * {{primary-100}} - grab shade 100 from the primary palette
 * {{primary-100-0.7}} - grab shade 100, apply opacity of 0.7
 * {{primary-100-contrast}} - grab shade 100's contrast color
 * {{primary-hue-1}} - grab the shade assigned to hue-1 from the primary palette
 * {{primary-hue-1-0.7}} - apply 0.7 opacity to primary-hue-1
 * {{primary-color}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured shades set for each hue
 * {{primary-color-0.7}} - Apply 0.7 opacity to each of the above rules
 * {{primary-contrast}} - Generates .md-hue-1, .md-hue-2, .md-hue-3 with configured contrast (ie. text) color shades set for each hue
 * {{primary-contrast-0.7}} - Apply 0.7 opacity to each of the above rules
 *
 * Foreground expansion: Applies rgba to black/white foreground text
 *
 * {{foreground-1}} - used for primary text
 * {{foreground-2}} - used for secondary text/divider
 * {{foreground-3}} - used for disabled text
 * {{foreground-4}} - used for dividers
 *
 */

// In memory generated CSS rules; registered by theme.name
var GENERATED = { };

// In memory storage of defined themes and color palettes (both loaded by CSS, and user specified)
var PALETTES;

// Text Colors on light and dark backgrounds
// @see https://www.google.com/design/spec/style/color.html#color-text-background-colors
var DARK_FOREGROUND = {
  name: 'dark',
  '1': 'rgba(0,0,0,0.87)',
  '2': 'rgba(0,0,0,0.54)',
  '3': 'rgba(0,0,0,0.38)',
  '4': 'rgba(0,0,0,0.12)'
};
var LIGHT_FOREGROUND = {
  name: 'light',
  '1': 'rgba(255,255,255,1.0)',
  '2': 'rgba(255,255,255,0.7)',
  '3': 'rgba(255,255,255,0.5)',
  '4': 'rgba(255,255,255,0.12)'
};

var DARK_SHADOW = '1px 1px 0px rgba(0,0,0,0.4), -1px -1px 0px rgba(0,0,0,0.4)';
var LIGHT_SHADOW = '';

var DARK_CONTRAST_COLOR = colorToRgbaArray('rgba(0,0,0,0.87)');
var LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgba(255,255,255,0.87)');
var STRONG_LIGHT_CONTRAST_COLOR = colorToRgbaArray('rgb(255,255,255)');

var THEME_COLOR_TYPES = ['primary', 'accent', 'warn', 'background'];
var DEFAULT_COLOR_TYPE = 'primary';

// A color in a theme will use these hues by default, if not specified by user.
var LIGHT_DEFAULT_HUES = {
  'accent': {
    'default': 'A200',
    'hue-1': 'A100',
    'hue-2': 'A400',
    'hue-3': 'A700'
  },
  'background': {
    'default': '50',
    'hue-1': 'A100',
    'hue-2': '100',
    'hue-3': '300'
  }
};

var DARK_DEFAULT_HUES = {
  'background': {
    'default': 'A400',
    'hue-1': '800',
    'hue-2': '900',
    'hue-3': 'A200'
  }
};
THEME_COLOR_TYPES.forEach(function(colorType) {
  // Color types with unspecified default hues will use these default hue values
  var defaultDefaultHues = {
    'default': '500',
    'hue-1': '300',
    'hue-2': '800',
    'hue-3': 'A100'
  };
  if (!LIGHT_DEFAULT_HUES[colorType]) LIGHT_DEFAULT_HUES[colorType] = defaultDefaultHues;
  if (!DARK_DEFAULT_HUES[colorType]) DARK_DEFAULT_HUES[colorType] = defaultDefaultHues;
});

var VALID_HUE_VALUES = [
  '50', '100', '200', '300', '400', '500', '600',
  '700', '800', '900', 'A100', 'A200', 'A400', 'A700'
];

var themeConfig = {
  disableTheming : false,   // Generate our themes at run time; also disable stylesheet DOM injection
  generateOnDemand : false, // Whether or not themes are to be generated on-demand (vs. eagerly).
  registeredStyles : [],    // Custom styles registered to be used in the theming of custom components.
  nonce : null              // Nonce to be added as an attribute to the generated themes style tags.
};

/**
 *
 */
function ThemingProvider($mdColorPalette, $$mdMetaProvider) {
  ThemingService['$inject'] = ["$rootScope", "$mdUtil", "$q", "$log"];
  PALETTES = { };
  var THEMES = { };

  var themingProvider;

  var alwaysWatchTheme = false;
  var defaultTheme = 'default';

  // Load JS Defined Palettes
  angular.extend(PALETTES, $mdColorPalette);

  // Default theme defined in core.js

  /**
   * Adds `theme-color` and `msapplication-navbutton-color` meta tags with the color parameter
   * @param {string} color Hex value of the wanted browser color
   * @returns {Function} Remove function of the meta tags
   */
  var setBrowserColor = function (color) {
    // Chrome, Firefox OS and Opera
    var removeChrome = $$mdMetaProvider.setMeta('theme-color', color);
    // Windows Phone
    var removeWindows = $$mdMetaProvider.setMeta('msapplication-navbutton-color', color);

    return function () {
      removeChrome();
      removeWindows();
    };
  };

  /**
   * Enables browser header coloring
   * for more info please visit:
   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
   *
   * The default color is `800` from `primary` palette of the `default` theme
   *
   * options are:
   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme
   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
   *             'accent', 'background' and 'warn'. Default is `primary`
   * `hue`     - The hue from the selected palette. Default is `800`
   *
   * @param {Object=} options Options object for the browser color
   * @returns {Function} remove function of the browser color
   */
  var enableBrowserColor = function (options) {
    options = angular.isObject(options) ? options : {};

    var theme = options.theme || 'default';
    var hue = options.hue || '800';

    var palette = PALETTES[options.palette] ||
      PALETTES[THEMES[theme].colors[options.palette || 'primary'].name];

    var color = angular.isObject(palette[hue]) ? palette[hue].hex : palette[hue];

    return setBrowserColor(color);
  };

  return themingProvider = {
    definePalette: definePalette,
    extendPalette: extendPalette,
    theme: registerTheme,

    /**
     * return a read-only clone of the current theme configuration
     */
    configuration : function() {
      return angular.extend( { }, themeConfig, {
        defaultTheme : defaultTheme,
        alwaysWatchTheme : alwaysWatchTheme,
        registeredStyles : [].concat(themeConfig.registeredStyles)
      });
    },

    /**
     * Easy way to disable theming without having to use
     * `.constant("$MD_THEME_CSS","");` This disables
     * all dynamic theme style sheet generations and injections...
     */
    disableTheming: function(isDisabled) {
      themeConfig.disableTheming = angular.isUndefined(isDisabled) || !!isDisabled;
    },

    registerStyles: function(styles) {
      themeConfig.registeredStyles.push(styles);
    },

    setNonce: function(nonceValue) {
      themeConfig.nonce = nonceValue;
    },

    generateThemesOnDemand: function(onDemand) {
      themeConfig.generateOnDemand = onDemand;
    },

    setDefaultTheme: function(theme) {
      defaultTheme = theme;
    },

    alwaysWatchTheme: function(alwaysWatch) {
      alwaysWatchTheme = alwaysWatch;
    },

    enableBrowserColor: enableBrowserColor,

    $get: ThemingService,
    _LIGHT_DEFAULT_HUES: LIGHT_DEFAULT_HUES,
    _DARK_DEFAULT_HUES: DARK_DEFAULT_HUES,
    _PALETTES: PALETTES,
    _THEMES: THEMES,
    _parseRules: parseRules,
    _rgba: rgba
  };

  // Example: $mdThemingProvider.definePalette('neonRed', { 50: '#f5fafa', ... });
  function definePalette(name, map) {
    map = map || {};
    PALETTES[name] = checkPaletteValid(name, map);
    return themingProvider;
  }

  // Returns an new object which is a copy of a given palette `name` with variables from
  // `map` overwritten
  // Example: var neonRedMap = $mdThemingProvider.extendPalette('red', { 50: '#f5fafafa' });
  function extendPalette(name, map) {
    return checkPaletteValid(name,  angular.extend({}, PALETTES[name] || {}, map) );
  }

  // Make sure that palette has all required hues
  function checkPaletteValid(name, map) {
    var missingColors = VALID_HUE_VALUES.filter(function(field) {
      return !map[field];
    });
    if (missingColors.length) {
      throw new Error("Missing colors %1 in palette %2!"
                      .replace('%1', missingColors.join(', '))
                      .replace('%2', name));
    }

    return map;
  }

  // Register a theme (which is a collection of color palettes to use with various states
  // ie. warn, accent, primary )
  // Optionally inherit from an existing theme
  // $mdThemingProvider.theme('custom-theme').primaryPalette('red');
  function registerTheme(name, inheritFrom) {
    if (THEMES[name]) return THEMES[name];

    inheritFrom = inheritFrom || 'default';

    var parentTheme = typeof inheritFrom === 'string' ? THEMES[inheritFrom] : inheritFrom;
    var theme = new Theme(name);

    if (parentTheme) {
      angular.forEach(parentTheme.colors, function(color, colorType) {
        theme.colors[colorType] = {
          name: color.name,
          // Make sure a COPY of the hues is given to the child color,
          // not the same reference.
          hues: angular.extend({}, color.hues)
        };
      });
    }
    THEMES[name] = theme;

    return theme;
  }

  function Theme(name) {
    var self = this;
    self.name = name;
    self.colors = {};

    self.dark = setDark;
    setDark(false);

    function setDark(isDark) {
      isDark = arguments.length === 0 ? true : !!isDark;

      // If no change, abort
      if (isDark === self.isDark) return;

      self.isDark = isDark;

      self.foregroundPalette = self.isDark ? LIGHT_FOREGROUND : DARK_FOREGROUND;
      self.foregroundShadow = self.isDark ? DARK_SHADOW : LIGHT_SHADOW;

      // Light and dark themes have different default hues.
      // Go through each existing color type for this theme, and for every
      // hue value that is still the default hue value from the previous light/dark setting,
      // set it to the default hue value from the new light/dark setting.
      var newDefaultHues = self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES;
      var oldDefaultHues = self.isDark ? LIGHT_DEFAULT_HUES : DARK_DEFAULT_HUES;
      angular.forEach(newDefaultHues, function(newDefaults, colorType) {
        var color = self.colors[colorType];
        var oldDefaults = oldDefaultHues[colorType];
        if (color) {
          for (var hueName in color.hues) {
            if (color.hues[hueName] === oldDefaults[hueName]) {
              color.hues[hueName] = newDefaults[hueName];
            }
          }
        }
      });

      return self;
    }

    THEME_COLOR_TYPES.forEach(function(colorType) {
      var defaultHues = (self.isDark ? DARK_DEFAULT_HUES : LIGHT_DEFAULT_HUES)[colorType];
      self[colorType + 'Palette'] = function setPaletteType(paletteName, hues) {
        var color = self.colors[colorType] = {
          name: paletteName,
          hues: angular.extend({}, defaultHues, hues)
        };

        Object.keys(color.hues).forEach(function(name) {
          if (!defaultHues[name]) {
            throw new Error("Invalid hue name '%1' in theme %2's %3 color %4. Available hue names: %4"
              .replace('%1', name)
              .replace('%2', self.name)
              .replace('%3', paletteName)
              .replace('%4', Object.keys(defaultHues).join(', '))
            );
          }
        });
        Object.keys(color.hues).map(function(key) {
          return color.hues[key];
        }).forEach(function(hueValue) {
          if (VALID_HUE_VALUES.indexOf(hueValue) == -1) {
            throw new Error("Invalid hue value '%1' in theme %2's %3 color %4. Available hue values: %5"
              .replace('%1', hueValue)
              .replace('%2', self.name)
              .replace('%3', colorType)
              .replace('%4', paletteName)
              .replace('%5', VALID_HUE_VALUES.join(', '))
            );
          }
        });
        return self;
      };

      self[colorType + 'Color'] = function() {
        var args = Array.prototype.slice.call(arguments);
        console.warn('$mdThemingProviderTheme.' + colorType + 'Color() has been deprecated. ' +
                     'Use $mdThemingProviderTheme.' + colorType + 'Palette() instead.');
        return self[colorType + 'Palette'].apply(self, args);
      };
    });
  }

  /**
   * @ngdoc service
   * @name $mdTheming
   * @module material.core.theming
   *
   * @description
   *
   * Service that makes an element apply theming related <b>classes</b> to itself.
   *
   * <hljs lang="js">
   * app.directive('myFancyDirective', function($mdTheming) {
   *   return {
   *     restrict: 'e',
   *     link: function(scope, el, attrs) {
   *       $mdTheming(el);
   *     }
   *   };
   * });
   * </hljs>
   * @param {element=} element to apply theming to
   */

  /**
   * @ngdoc property
   * @name $mdTheming#THEMES
   * @description
   * Property to get all the themes defined
   * @returns {Object} All the themes defined with their properties
   */

  /**
   * @ngdoc property
   * @name $mdTheming#PALETTES
   * @description
   * Property to get all the palettes defined
   * @returns {Object} All the palettes defined with their colors
   */

  /**
   * @ngdoc method
   * @name $mdTheming#registered
   * @description
   * Determine is specified theme name is a valid, registered theme
   * @param {string} themeName the theme to check if registered
   * @returns {boolean} whether the theme is registered or not
   */

  /**
   * @ngdoc method
   * @name $mdTheming#defaultTheme
   * @description
   * Returns the default theme
   * @returns {string} The default theme
   */

  /**
   * @ngdoc method
   * @name $mdTheming#generateTheme
   * @description
   * Lazy generate themes - by default, every theme is generated when defined.
   * You can disable this in the configuration section using the
   * `$mdThemingProvider.generateThemesOnDemand(true);`
   *
   * The theme name that is passed in must match the name of the theme that was defined as part of the configuration block.
   *
   * @param name {string} theme name to generate
   */

  /**
   * @ngdoc method
   * @name $mdTheming#setBrowserColor
   * @description
   * Sets browser header coloring
   * for more info please visit:
   * https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color
   *
   * The default color is `800` from `primary` palette of the `default` theme
   *
   * options are:<br/>
   * `theme`   - A defined theme via `$mdThemeProvider` to use the palettes from. Default is `default` theme.<br/>
   * `palette` - Can be any one of the basic material design palettes, extended defined palettes and 'primary',
   *             'accent', 'background' and 'warn'. Default is `primary`<br/>
   * `hue`     - The hue from the selected palette. Default is `800`
   *
   * @param {Object} options Options object for the browser color
   * @returns {Function} remove function of the browser color
   */

  /* ngInject */
  function ThemingService($rootScope, $mdUtil, $q, $log) {
        // Allow us to be invoked via a linking function signature.
    var applyTheme = function (scope, el) {
          if (el === undefined) { el = scope; scope = undefined; }
          if (scope === undefined) { scope = $rootScope; }
          applyTheme.inherit(el, el);
        };

    Object.defineProperty(applyTheme, 'THEMES', {
      get: function () {
        return angular.extend({}, THEMES);
      }
    });
    Object.defineProperty(applyTheme, 'PALETTES', {
      get: function () {
        return angular.extend({}, PALETTES);
      }
    });
    Object.defineProperty(applyTheme, 'ALWAYS_WATCH', {
      get: function () {
        return alwaysWatchTheme;
      }
    });
    applyTheme.inherit = inheritTheme;
    applyTheme.registered = registered;
    applyTheme.defaultTheme = function() { return defaultTheme; };
    applyTheme.generateTheme = function(name) { generateTheme(THEMES[name], name, themeConfig.nonce); };
    applyTheme.defineTheme = function(name, options) {
      options = options || {};

      var theme = registerTheme(name);

      if (options.primary) {
        theme.primaryPalette(options.primary);
      }
      if (options.accent) {
        theme.accentPalette(options.accent);
      }
      if (options.warn) {
        theme.warnPalette(options.warn);
      }
      if (options.background) {
        theme.backgroundPalette(options.background);
      }
      if (options.dark){
        theme.dark();
      }

      this.generateTheme(name);

      return $q.resolve(name);
    };
    applyTheme.setBrowserColor = enableBrowserColor;

    return applyTheme;

    /**
     * Determine is specified theme name is a valid, registered theme
     */
    function registered(themeName) {
      if (themeName === undefined || themeName === '') return true;
      return applyTheme.THEMES[themeName] !== undefined;
    }

    /**
     * Get theme name for the element, then update with Theme CSS class
     */
    function inheritTheme (el, parent) {
      var ctrl = parent.controller('mdTheme') || el.data('$mdThemeController');

      updateThemeClass(lookupThemeName());

      if (ctrl) {
        var watchTheme = alwaysWatchTheme ||
                         ctrl.$shouldWatch ||
                         $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch'));

        var unwatch = ctrl.registerChanges(function (name) {
          updateThemeClass(name);

          if (!watchTheme) {
            unwatch();
          }
          else {
            el.on('$destroy', unwatch);
          }
        });
      }

      /**
       * Find the theme name from the parent controller or element data
       */
      function lookupThemeName() {
        // As a few components (dialog) add their controllers later, we should also watch for a controller init.
        return ctrl && ctrl.$mdTheme || (defaultTheme == 'default' ? '' : defaultTheme);
      }

      /**
       * Remove old theme class and apply a new one
       * NOTE: if not a valid theme name, then the current name is not changed
       */
      function updateThemeClass(theme) {
        if (!theme) return;
        if (!registered(theme)) {
          $log.warn('Attempted to use unregistered theme \'' + theme + '\'. ' +
                    'Register it with $mdThemingProvider.theme().');
        }

        var oldTheme = el.data('$mdThemeName');
        if (oldTheme) el.removeClass('md-' + oldTheme +'-theme');
        el.addClass('md-' + theme + '-theme');
        el.data('$mdThemeName', theme);
        if (ctrl) {
          el.data('$mdThemeController', ctrl);
        }
      }
    }

  }
}

function ThemingDirective($mdTheming, $interpolate, $parse, $mdUtil, $q, $log) {
  return {
    priority: 101, // has to be more than 100 to be before interpolation (issue on IE)
    link: {
      pre: function(scope, el, attrs) {
        var registeredCallbacks = [];

        var startSymbol = $interpolate.startSymbol();
        var endSymbol = $interpolate.endSymbol();

        var theme = attrs.mdTheme.trim();

        var hasInterpolation =
          theme.substr(0, startSymbol.length) === startSymbol &&
          theme.lastIndexOf(endSymbol) === theme.length - endSymbol.length;

        var oneTimeOperator = '::';
        var oneTimeBind = attrs.mdTheme
            .split(startSymbol).join('')
            .split(endSymbol).join('')
            .trim()
            .substr(0, oneTimeOperator.length) === oneTimeOperator;

        var ctrl = {
          registerChanges: function (cb, context) {
            if (context) {
              cb = angular.bind(context, cb);
            }

            registeredCallbacks.push(cb);

            return function () {
              var index = registeredCallbacks.indexOf(cb);

              if (index > -1) {
                registeredCallbacks.splice(index, 1);
              }
            };
          },
          $setTheme: function (theme) {
            if (!$mdTheming.registered(theme)) {
              $log.warn('attempted to use unregistered theme \'' + theme + '\'');
            }

            ctrl.$mdTheme = theme;

            // Iterating backwards to support unregistering during iteration
            // http://stackoverflow.com/a/9882349/890293
            // we don't use `reverse()` of array because it mutates the array and we don't want it to get re-indexed
            for (var i = registeredCallbacks.length; i--;) {
              registeredCallbacks[i](theme);
            }
          },
          $shouldWatch: $mdUtil.parseAttributeBoolean(el.attr('md-theme-watch')) ||
                        $mdTheming.ALWAYS_WATCH ||
                        (hasInterpolation && !oneTimeBind)
        };

        el.data('$mdThemeController', ctrl);

        var getTheme = function () {
          var interpolation = $interpolate(attrs.mdTheme)(scope);
          return $parse(interpolation)(scope) || interpolation;
        };

        var setParsedTheme = function (theme) {
          if (typeof theme === 'string') {
            return ctrl.$setTheme(theme);
          }

          $q.when( angular.isFunction(theme) ?  theme() : theme )
            .then(function(name){
              ctrl.$setTheme(name);
            });
        };

        setParsedTheme(getTheme());

        var unwatch = scope.$watch(getTheme, function(theme) {
          if (theme) {
            setParsedTheme(theme);

            if (!ctrl.$shouldWatch) {
              unwatch();
            }
          }
        });
      }
    }
  };
}

/**
 * Special directive that will disable ALL runtime Theme style generation and DOM injection
 *
 * <link rel="stylesheet" href="angular-material.min.css">
 * <link rel="stylesheet" href="angular-material.themes.css">
 *
 * <body md-themes-disabled>
 *  ...
 * </body>
 *
 * Note: Using md-themes-css directive requires the developer to load external
 * theme stylesheets; e.g. custom themes from Material-Tools:
 *
 *       `angular-material.themes.css`
 *
 * Another option is to use the ThemingProvider to configure and disable the attribute
 * conversions; this would obviate the use of the `md-themes-css` directive
 *
 */
function disableThemesDirective() {
  themeConfig.disableTheming = true;

  // Return a 1x-only, first-match attribute directive
  return {
    restrict : 'A',
    priority : '900'
  };
}

function ThemableDirective($mdTheming) {
  return $mdTheming;
}

function parseRules(theme, colorType, rules) {
  checkValidPalette(theme, colorType);

  rules = rules.replace(/THEME_NAME/g, theme.name);
  var generatedRules = [];
  var color = theme.colors[colorType];

  var themeNameRegex = new RegExp('\\.md-' + theme.name + '-theme', 'g');
  // Matches '{{ primary-color }}', etc
  var hueRegex = new RegExp('(\'|")?{{\\s*(' + colorType + ')-(color|contrast)-?(\\d\\.?\\d*)?\\s*}}(\"|\')?','g');
  var simpleVariableRegex = /'?"?\{\{\s*([a-zA-Z]+)-(A?\d+|hue\-[0-3]|shadow|default)-?(\d\.?\d*)?(contrast)?\s*\}\}'?"?/g;
  var palette = PALETTES[color.name];

  // find and replace simple variables where we use a specific hue, not an entire palette
  // eg. "{{primary-100}}"
  //\(' + THEME_COLOR_TYPES.join('\|') + '\)'
  rules = rules.replace(simpleVariableRegex, function(match, colorType, hue, opacity, contrast) {
    if (colorType === 'foreground') {
      if (hue == 'shadow') {
        return theme.foregroundShadow;
      } else {
        return theme.foregroundPalette[hue] || theme.foregroundPalette['1'];
      }
    }

    // `default` is also accepted as a hue-value, because the background palettes are
    // using it as a name for the default hue.
    if (hue.indexOf('hue') === 0 || hue === 'default') {
      hue = theme.colors[colorType].hues[hue];
    }

    return rgba( (PALETTES[ theme.colors[colorType].name ][hue] || '')[contrast ? 'contrast' : 'value'], opacity );
  });

  // For each type, generate rules for each hue (ie. default, md-hue-1, md-hue-2, md-hue-3)
  angular.forEach(color.hues, function(hueValue, hueName) {
    var newRule = rules
      .replace(hueRegex, function(match, _, colorType, hueType, opacity) {
        return rgba(palette[hueValue][hueType === 'color' ? 'value' : 'contrast'], opacity);
      });
    if (hueName !== 'default') {
      newRule = newRule.replace(themeNameRegex, '.md-' + theme.name + '-theme.md-' + hueName);
    }

    // Don't apply a selector rule to the default theme, making it easier to override
    // styles of the base-component
    if (theme.name == 'default') {
      var themeRuleRegex = /((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)\.md-default-theme((?:\s|>|\.|\w|-|:|\(|\)|\[|\]|"|'|=)*)/g;

      newRule = newRule.replace(themeRuleRegex, function(match, start, end) {
        return match + ', ' + start + end;
      });
    }
    generatedRules.push(newRule);
  });

  return generatedRules;
}

var rulesByType = {};

// Generate our themes at run time given the state of THEMES and PALETTES
function generateAllThemes($injector, $mdTheming) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;
  var themeCss = !themeConfig.disableTheming && $injector.has('$MD_THEME_CSS') ? $injector.get('$MD_THEME_CSS') : '';

  // Append our custom registered styles to the theme stylesheet.
  themeCss += themeConfig.registeredStyles.join('');

  if ( !firstChild ) return;
  if (themeCss.length === 0) return; // no rules, so no point in running this expensive task

  // Expose contrast colors for palettes to ensure that text is always readable
  angular.forEach(PALETTES, sanitizePalette);

  // MD_THEME_CSS is a string generated by the build process that includes all the themable
  // components as templates

  // Break the CSS into individual rules
  var rules = themeCss
                  .split(/\}(?!(\}|'|"|;))/)
                  .filter(function(rule) { return rule && rule.trim().length; })
                  .map(function(rule) { return rule.trim() + '}'; });


  var ruleMatchRegex = new RegExp('md-(' + THEME_COLOR_TYPES.join('|') + ')', 'g');

  THEME_COLOR_TYPES.forEach(function(type) {
    rulesByType[type] = '';
  });


  // Sort the rules based on type, allowing us to do color substitution on a per-type basis
  rules.forEach(function(rule) {
    var match = rule.match(ruleMatchRegex);
    // First: test that if the rule has '.md-accent', it goes into the accent set of rules
    for (var i = 0, type; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf('.md-' + type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // If no eg 'md-accent' class is found, try to just find 'accent' in the rule and guess from
    // there
    for (i = 0; type = THEME_COLOR_TYPES[i]; i++) {
      if (rule.indexOf(type) > -1) {
        return rulesByType[type] += rule;
      }
    }

    // Default to the primary array
    return rulesByType[DEFAULT_COLOR_TYPE] += rule;
  });

  // If themes are being generated on-demand, quit here. The user will later manually
  // call generateTheme to do this on a theme-by-theme basis.
  if (themeConfig.generateOnDemand) return;

  angular.forEach($mdTheming.THEMES, function(theme) {
    if (!GENERATED[theme.name] && !($mdTheming.defaultTheme() !== 'default' && theme.name === 'default')) {
      generateTheme(theme, theme.name, themeConfig.nonce);
    }
  });


  // *************************
  // Internal functions
  // *************************

  // The user specifies a 'default' contrast color as either light or dark,
  // then explicitly lists which hues are the opposite contrast (eg. A100 has dark, A200 has light)
  function sanitizePalette(palette, name) {
    var defaultContrast = palette.contrastDefaultColor;
    var lightColors = palette.contrastLightColors || [];
    var strongLightColors = palette.contrastStrongLightColors || [];
    var darkColors = palette.contrastDarkColors || [];

    // These colors are provided as space-separated lists
    if (typeof lightColors === 'string') lightColors = lightColors.split(' ');
    if (typeof strongLightColors === 'string') strongLightColors = strongLightColors.split(' ');
    if (typeof darkColors === 'string') darkColors = darkColors.split(' ');

    // Cleanup after ourselves
    delete palette.contrastDefaultColor;
    delete palette.contrastLightColors;
    delete palette.contrastStrongLightColors;
    delete palette.contrastDarkColors;

    // Change { 'A100': '#fffeee' } to { 'A100': { value: '#fffeee', contrast:DARK_CONTRAST_COLOR }
    angular.forEach(palette, function(hueValue, hueName) {
      if (angular.isObject(hueValue)) return; // Already converted
      // Map everything to rgb colors
      var rgbValue = colorToRgbaArray(hueValue);
      if (!rgbValue) {
        throw new Error("Color %1, in palette %2's hue %3, is invalid. Hex or rgb(a) color expected."
                        .replace('%1', hueValue)
                        .replace('%2', palette.name)
                        .replace('%3', hueName));
      }

      palette[hueName] = {
        hex: palette[hueName],
        value: rgbValue,
        contrast: getContrastColor()
      };
      function getContrastColor() {
        if (defaultContrast === 'light') {
          if (darkColors.indexOf(hueName) > -1) {
            return DARK_CONTRAST_COLOR;
          } else {
            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
              : LIGHT_CONTRAST_COLOR;
          }
        } else {
          if (lightColors.indexOf(hueName) > -1) {
            return strongLightColors.indexOf(hueName) > -1 ? STRONG_LIGHT_CONTRAST_COLOR
              : LIGHT_CONTRAST_COLOR;
          } else {
            return DARK_CONTRAST_COLOR;
          }
        }
      }
    });
  }
}

function generateTheme(theme, name, nonce) {
  var head = document.head;
  var firstChild = head ? head.firstElementChild : null;

  if (!GENERATED[name]) {
    // For each theme, use the color palettes specified for
    // `primary`, `warn` and `accent` to generate CSS rules.
    THEME_COLOR_TYPES.forEach(function(colorType) {
      var styleStrings = parseRules(theme, colorType, rulesByType[colorType]);
      while (styleStrings.length) {
        var styleContent = styleStrings.shift();
        if (styleContent) {
          var style = document.createElement('style');
          style.setAttribute('md-theme-style', '');
          if (nonce) {
            style.setAttribute('nonce', nonce);
          }
          style.appendChild(document.createTextNode(styleContent));
          head.insertBefore(style, firstChild);
        }
      }
    });

    GENERATED[theme.name] = true;
  }

}


function checkValidPalette(theme, colorType) {
  // If theme attempts to use a palette that doesnt exist, throw error
  if (!PALETTES[ (theme.colors[colorType] || {}).name ]) {
    throw new Error(
      "You supplied an invalid color palette for theme %1's %2 palette. Available palettes: %3"
                    .replace('%1', theme.name)
                    .replace('%2', colorType)
                    .replace('%3', Object.keys(PALETTES).join(', '))
    );
  }
}

function colorToRgbaArray(clr) {
  if (angular.isArray(clr) && clr.length == 3) return clr;
  if (/^rgb/.test(clr)) {
    return clr.replace(/(^\s*rgba?\(|\)\s*$)/g, '').split(',').map(function(value, i) {
      return i == 3 ? parseFloat(value, 10) : parseInt(value, 10);
    });
  }
  if (clr.charAt(0) == '#') clr = clr.substring(1);
  if (!/^([a-fA-F0-9]{3}){1,2}$/g.test(clr)) return;

  var dig = clr.length / 3;
  var red = clr.substr(0, dig);
  var grn = clr.substr(dig, dig);
  var blu = clr.substr(dig * 2);
  if (dig === 1) {
    red += red;
    grn += grn;
    blu += blu;
  }
  return [parseInt(red, 16), parseInt(grn, 16), parseInt(blu, 16)];
}

function rgba(rgbArray, opacity) {
  if ( !rgbArray ) return "rgb('0,0,0')";

  if (rgbArray.length == 4) {
    rgbArray = angular.copy(rgbArray);
    opacity ? rgbArray.pop() : opacity = rgbArray.pop();
  }
  return opacity && (typeof opacity == 'number' || (typeof opacity == 'string' && opacity.length)) ?
    'rgba(' + rgbArray.join(',') + ',' + opacity + ')' :
    'rgb(' + rgbArray.join(',') + ')';
}


})(window.angular);

// Polyfill angular < 1.4 (provide $animateCss)
angular
  .module('material.core')
  .factory('$$mdAnimate', ["$q", "$timeout", "$mdConstant", "$animateCss", function($q, $timeout, $mdConstant, $animateCss){

     // Since $$mdAnimate is injected into $mdUtil... use a wrapper function
     // to subsequently inject $mdUtil as an argument to the AnimateDomUtils

     return function($mdUtil) {
       return AnimateDomUtils( $mdUtil, $q, $timeout, $mdConstant, $animateCss);
     };
   }]);

/**
 * Factory function that requires special injections
 */
function AnimateDomUtils($mdUtil, $q, $timeout, $mdConstant, $animateCss) {
  var self;
  return self = {
    /**
     *
     */
    translate3d : function( target, from, to, options ) {
      return $animateCss(target, {
        from: from,
        to: to,
        addClass: options.transitionInClass,
        removeClass: options.transitionOutClass,
        duration: options.duration
      })
      .start()
      .then(function(){
          // Resolve with reverser function...
          return reverseTranslate;
      });

      /**
       * Specific reversal of the request translate animation above...
       */
      function reverseTranslate (newFrom) {
        return $animateCss(target, {
           to: newFrom || from,
           addClass: options.transitionOutClass,
           removeClass: options.transitionInClass,
           duration: options.duration
        }).start();

      }
    },

    /**
     * Listen for transitionEnd event (with optional timeout)
     * Announce completion or failure via promise handlers
     */
    waitTransitionEnd: function (element, opts) {
      var TIMEOUT = 3000; // fallback is 3 secs

      return $q(function(resolve, reject){
        opts = opts || { };

        // If there is no transition is found, resolve immediately
        //
        // NOTE: using $mdUtil.nextTick() causes delays/issues
        if (noTransitionFound(opts.cachedTransitionStyles)) {
          TIMEOUT = 0;
        }

        var timer = $timeout(finished, opts.timeout || TIMEOUT);
        element.on($mdConstant.CSS.TRANSITIONEND, finished);

        /**
         * Upon timeout or transitionEnd, reject or resolve (respectively) this promise.
         * NOTE: Make sure this transitionEnd didn't bubble up from a child
         */
        function finished(ev) {
          if ( ev && ev.target !== element[0]) return;

          if ( ev  ) $timeout.cancel(timer);
          element.off($mdConstant.CSS.TRANSITIONEND, finished);

          // Never reject since ngAnimate may cause timeouts due missed transitionEnd events
          resolve();

        }

        /**
         * Checks whether or not there is a transition.
         *
         * @param styles The cached styles to use for the calculation. If null, getComputedStyle()
         * will be used.
         *
         * @returns {boolean} True if there is no transition/duration; false otherwise.
         */
        function noTransitionFound(styles) {
          styles = styles || window.getComputedStyle(element[0]);

          return styles.transitionDuration == '0s' || (!styles.transition && !styles.transitionProperty);
        }

      });
    },

    calculateTransformValues: function (element, originator) {
      var origin = originator.element;
      var bounds = originator.bounds;

      if (origin || bounds) {
        var originBnds = origin ? self.clientRect(origin) || currentBounds() : self.copyRect(bounds);
        var dialogRect = self.copyRect(element[0].getBoundingClientRect());
        var dialogCenterPt = self.centerPointFor(dialogRect);
        var originCenterPt = self.centerPointFor(originBnds);

        return {
          centerX: originCenterPt.x - dialogCenterPt.x,
          centerY: originCenterPt.y - dialogCenterPt.y,
          scaleX: Math.round(100 * Math.min(0.5, originBnds.width / dialogRect.width)) / 100,
          scaleY: Math.round(100 * Math.min(0.5, originBnds.height / dialogRect.height)) / 100
        };
      }
      return {centerX: 0, centerY: 0, scaleX: 0.5, scaleY: 0.5};

      /**
       * This is a fallback if the origin information is no longer valid, then the
       * origin bounds simply becomes the current bounds for the dialogContainer's parent
       */
      function currentBounds() {
        var cntr = element ? element.parent() : null;
        var parent = cntr ? cntr.parent() : null;

        return parent ? self.clientRect(parent) : null;
      }
    },

    /**
     * Calculate the zoom transform from dialog to origin.
     *
     * We use this to set the dialog position immediately;
     * then the md-transition-in actually translates back to
     * `translate3d(0,0,0) scale(1.0)`...
     *
     * NOTE: all values are rounded to the nearest integer
     */
    calculateZoomToOrigin: function (element, originator) {
      var zoomTemplate = "translate3d( {centerX}px, {centerY}px, 0 ) scale( {scaleX}, {scaleY} )";
      var buildZoom = angular.bind(null, $mdUtil.supplant, zoomTemplate);

      return buildZoom(self.calculateTransformValues(element, originator));
    },

    /**
     * Calculate the slide transform from panel to origin.
     * NOTE: all values are rounded to the nearest integer
     */
    calculateSlideToOrigin: function (element, originator) {
      var slideTemplate = "translate3d( {centerX}px, {centerY}px, 0 )";
      var buildSlide = angular.bind(null, $mdUtil.supplant, slideTemplate);

      return buildSlide(self.calculateTransformValues(element, originator));
    },

    /**
     * Enhance raw values to represent valid css stylings...
     */
    toCss : function( raw ) {
      var css = { };
      var lookups = 'left top right bottom width height x y min-width min-height max-width max-height';

      angular.forEach(raw, function(value,key) {
        if ( angular.isUndefined(value) ) return;

        if ( lookups.indexOf(key) >= 0 ) {
          css[key] = value + 'px';
        } else {
          switch (key) {
            case 'transition':
              convertToVendor(key, $mdConstant.CSS.TRANSITION, value);
              break;
            case 'transform':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM, value);
              break;
            case 'transformOrigin':
              convertToVendor(key, $mdConstant.CSS.TRANSFORM_ORIGIN, value);
              break;
            case 'font-size':
              css['font-size'] = value; // font sizes aren't always in px
              break;
          }
        }
      });

      return css;

      function convertToVendor(key, vendor, value) {
        angular.forEach(vendor.split(' '), function (key) {
          css[key] = value;
        });
      }
    },

    /**
     * Convert the translate CSS value to key/value pair(s).
     */
    toTransformCss: function (transform, addTransition, transition) {
      var css = {};
      angular.forEach($mdConstant.CSS.TRANSFORM.split(' '), function (key) {
        css[key] = transform;
      });

      if (addTransition) {
        transition = transition || "all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1) !important";
        css.transition = transition;
      }

      return css;
    },

    /**
     *  Clone the Rect and calculate the height/width if needed
     */
    copyRect: function (source, destination) {
      if (!source) return null;

      destination = destination || {};

      angular.forEach('left top right bottom width height'.split(' '), function (key) {
        destination[key] = Math.round(source[key]);
      });

      destination.width = destination.width || (destination.right - destination.left);
      destination.height = destination.height || (destination.bottom - destination.top);

      return destination;
    },

    /**
     * Calculate ClientRect of element; return null if hidden or zero size
     */
    clientRect: function (element) {
      var bounds = angular.element(element)[0].getBoundingClientRect();
      var isPositiveSizeClientRect = function (rect) {
        return rect && (rect.width > 0) && (rect.height > 0);
      };

      // If the event origin element has zero size, it has probably been hidden.
      return isPositiveSizeClientRect(bounds) ? self.copyRect(bounds) : null;
    },

    /**
     *  Calculate 'rounded' center point of Rect
     */
    centerPointFor: function (targetRect) {
      return targetRect ? {
        x: Math.round(targetRect.left + (targetRect.width / 2)),
        y: Math.round(targetRect.top + (targetRect.height / 2))
      } : { x : 0, y : 0 };
    }

  };
}


if (angular.version.minor >= 4) {
  angular.module('material.core.animate', []);
} else {
(function() {
  "use strict";

  var forEach = angular.forEach;

  var WEBKIT = angular.isDefined(document.documentElement.style.WebkitAppearance);
  var TRANSITION_PROP = WEBKIT ? 'WebkitTransition' : 'transition';
  var ANIMATION_PROP = WEBKIT ? 'WebkitAnimation' : 'animation';
  var PREFIX = WEBKIT ? '-webkit-' : '';

  var TRANSITION_EVENTS = (WEBKIT ? 'webkitTransitionEnd ' : '') + 'transitionend';
  var ANIMATION_EVENTS = (WEBKIT ? 'webkitAnimationEnd ' : '') + 'animationend';

  var $$ForceReflowFactory = ['$document', function($document) {
    return function() {
      return $document[0].body.clientWidth + 1;
    };
  }];

  var $$rAFMutexFactory = ['$$rAF', function($$rAF) {
    return function() {
      var passed = false;
      $$rAF(function() {
        passed = true;
      });
      return function(fn) {
        passed ? fn() : $$rAF(fn);
      };
    };
  }];

  var $$AnimateRunnerFactory = ['$q', '$$rAFMutex', function($q, $$rAFMutex) {
    var INITIAL_STATE = 0;
    var DONE_PENDING_STATE = 1;
    var DONE_COMPLETE_STATE = 2;

    function AnimateRunner(host) {
      this.setHost(host);

      this._doneCallbacks = [];
      this._runInAnimationFrame = $$rAFMutex();
      this._state = 0;
    }

    AnimateRunner.prototype = {
      setHost: function(host) {
        this.host = host || {};
      },

      done: function(fn) {
        if (this._state === DONE_COMPLETE_STATE) {
          fn();
        } else {
          this._doneCallbacks.push(fn);
        }
      },

      progress: angular.noop,

      getPromise: function() {
        if (!this.promise) {
          var self = this;
          this.promise = $q(function(resolve, reject) {
            self.done(function(status) {
              status === false ? reject() : resolve();
            });
          });
        }
        return this.promise;
      },

      then: function(resolveHandler, rejectHandler) {
        return this.getPromise().then(resolveHandler, rejectHandler);
      },

      'catch': function(handler) {
        return this.getPromise()['catch'](handler);
      },

      'finally': function(handler) {
        return this.getPromise()['finally'](handler);
      },

      pause: function() {
        if (this.host.pause) {
          this.host.pause();
        }
      },

      resume: function() {
        if (this.host.resume) {
          this.host.resume();
        }
      },

      end: function() {
        if (this.host.end) {
          this.host.end();
        }
        this._resolve(true);
      },

      cancel: function() {
        if (this.host.cancel) {
          this.host.cancel();
        }
        this._resolve(false);
      },

      complete: function(response) {
        var self = this;
        if (self._state === INITIAL_STATE) {
          self._state = DONE_PENDING_STATE;
          self._runInAnimationFrame(function() {
            self._resolve(response);
          });
        }
      },

      _resolve: function(response) {
        if (this._state !== DONE_COMPLETE_STATE) {
          forEach(this._doneCallbacks, function(fn) {
            fn(response);
          });
          this._doneCallbacks.length = 0;
          this._state = DONE_COMPLETE_STATE;
        }
      }
    };

    // Polyfill AnimateRunner.all which is used by input animations
    AnimateRunner.all = function(runners, callback) {
      var count = 0;
      var status = true;
      forEach(runners, function(runner) {
        runner.done(onProgress);
      });

      function onProgress(response) {
        status = status && response;
        if (++count === runners.length) {
          callback(status);
        }
      }
    };

    return AnimateRunner;
  }];

  angular
    .module('material.core.animate', [])
    .factory('$$forceReflow', $$ForceReflowFactory)
    .factory('$$AnimateRunner', $$AnimateRunnerFactory)
    .factory('$$rAFMutex', $$rAFMutexFactory)
    .factory('$animateCss', ['$window', '$$rAF', '$$AnimateRunner', '$$forceReflow', '$$jqLite', '$timeout', '$animate',
                     function($window,   $$rAF,   $$AnimateRunner,   $$forceReflow,   $$jqLite,   $timeout, $animate) {

      function init(element, options) {

        var temporaryStyles = [];
        var node = getDomNode(element);
        var areAnimationsAllowed = node && $animate.enabled();

        var hasCompleteStyles = false;
        var hasCompleteClasses = false;

        if (areAnimationsAllowed) {
          if (options.transitionStyle) {
            temporaryStyles.push([PREFIX + 'transition', options.transitionStyle]);
          }

          if (options.keyframeStyle) {
            temporaryStyles.push([PREFIX + 'animation', options.keyframeStyle]);
          }

          if (options.delay) {
            temporaryStyles.push([PREFIX + 'transition-delay', options.delay + 's']);
          }

          if (options.duration) {
            temporaryStyles.push([PREFIX + 'transition-duration', options.duration + 's']);
          }

          hasCompleteStyles = options.keyframeStyle ||
              (options.to && (options.duration > 0 || options.transitionStyle));
          hasCompleteClasses = !!options.addClass || !!options.removeClass;

          blockTransition(element, true);
        }

        var hasCompleteAnimation = areAnimationsAllowed && (hasCompleteStyles || hasCompleteClasses);

        applyAnimationFromStyles(element, options);

        var animationClosed = false;
        var events, eventFn;

        return {
          close: $window.close,
          start: function() {
            var runner = new $$AnimateRunner();
            waitUntilQuiet(function() {
              blockTransition(element, false);
              if (!hasCompleteAnimation) {
                return close();
              }

              forEach(temporaryStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
              });

              applyClasses(element, options);

              var timings = computeTimings(element);
              if (timings.duration === 0) {
                return close();
              }

              var moreStyles = [];

              if (options.easing) {
                if (timings.transitionDuration) {
                  moreStyles.push([PREFIX + 'transition-timing-function', options.easing]);
                }
                if (timings.animationDuration) {
                  moreStyles.push([PREFIX + 'animation-timing-function', options.easing]);
                }
              }

              if (options.delay && timings.animationDelay) {
                moreStyles.push([PREFIX + 'animation-delay', options.delay + 's']);
              }

              if (options.duration && timings.animationDuration) {
                moreStyles.push([PREFIX + 'animation-duration', options.duration + 's']);
              }

              forEach(moreStyles, function(entry) {
                var key = entry[0];
                var value = entry[1];
                node.style[camelCase(key)] = value;
                temporaryStyles.push(entry);
              });

              var maxDelay = timings.delay;
              var maxDelayTime = maxDelay * 1000;
              var maxDuration = timings.duration;
              var maxDurationTime = maxDuration * 1000;
              var startTime = Date.now();

              events = [];
              if (timings.transitionDuration) {
                events.push(TRANSITION_EVENTS);
              }
              if (timings.animationDuration) {
                events.push(ANIMATION_EVENTS);
              }
              events = events.join(' ');
              eventFn = function(event) {
                event.stopPropagation();
                var ev = event.originalEvent || event;
                var timeStamp = ev.timeStamp || Date.now();
                var elapsedTime = parseFloat(ev.elapsedTime.toFixed(3));
                if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
                  close();
                }
              };
              element.on(events, eventFn);

              applyAnimationToStyles(element, options);

              $timeout(close, maxDelayTime + maxDurationTime * 1.5, false);
            });

            return runner;

            function close() {
              if (animationClosed) return;
              animationClosed = true;

              if (events && eventFn) {
                element.off(events, eventFn);
              }
              applyClasses(element, options);
              applyAnimationStyles(element, options);
              forEach(temporaryStyles, function(entry) {
                node.style[camelCase(entry[0])] = '';
              });
              runner.complete(true);
              return runner;
            }
          }
        };
      }

      function applyClasses(element, options) {
        if (options.addClass) {
          $$jqLite.addClass(element, options.addClass);
          options.addClass = null;
        }
        if (options.removeClass) {
          $$jqLite.removeClass(element, options.removeClass);
          options.removeClass = null;
        }
      }

      function computeTimings(element) {
        var node = getDomNode(element);
        var cs = $window.getComputedStyle(node);
        var tdr = parseMaxTime(cs[prop('transitionDuration')]);
        var adr = parseMaxTime(cs[prop('animationDuration')]);
        var tdy = parseMaxTime(cs[prop('transitionDelay')]);
        var ady = parseMaxTime(cs[prop('animationDelay')]);

        adr *= (parseInt(cs[prop('animationIterationCount')], 10) || 1);
        var duration = Math.max(adr, tdr);
        var delay = Math.max(ady, tdy);

        return {
          duration: duration,
          delay: delay,
          animationDuration: adr,
          transitionDuration: tdr,
          animationDelay: ady,
          transitionDelay: tdy
        };

        function prop(key) {
          return WEBKIT ? 'Webkit' + key.charAt(0).toUpperCase() + key.substr(1)
                        : key;
        }
      }

      function parseMaxTime(str) {
        var maxValue = 0;
        var values = (str || "").split(/\s*,\s*/);
        forEach(values, function(value) {
          // it's always safe to consider only second values and omit `ms` values since
          // getComputedStyle will always handle the conversion for us
          if (value.charAt(value.length - 1) == 's') {
            value = value.substring(0, value.length - 1);
          }
          value = parseFloat(value) || 0;
          maxValue = maxValue ? Math.max(value, maxValue) : value;
        });
        return maxValue;
      }

      var cancelLastRAFRequest;
      var rafWaitQueue = [];
      function waitUntilQuiet(callback) {
        if (cancelLastRAFRequest) {
          cancelLastRAFRequest(); //cancels the request
        }
        rafWaitQueue.push(callback);
        cancelLastRAFRequest = $$rAF(function() {
          cancelLastRAFRequest = null;

          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
          var pageWidth = $$forceReflow();

          // we use a for loop to ensure that if the queue is changed
          // during this looping then it will consider new requests
          for (var i = 0; i < rafWaitQueue.length; i++) {
            rafWaitQueue[i](pageWidth);
          }
          rafWaitQueue.length = 0;
        });
      }

      function applyAnimationStyles(element, options) {
        applyAnimationFromStyles(element, options);
        applyAnimationToStyles(element, options);
      }

      function applyAnimationFromStyles(element, options) {
        if (options.from) {
          element.css(options.from);
          options.from = null;
        }
      }

      function applyAnimationToStyles(element, options) {
        if (options.to) {
          element.css(options.to);
          options.to = null;
        }
      }

      function getDomNode(element) {
        for (var i = 0; i < element.length; i++) {
          if (element[i].nodeType === 1) return element[i];
        }
      }

      function blockTransition(element, bool) {
        var node = getDomNode(element);
        var key = camelCase(PREFIX + 'transition-delay');
        node.style[key] = bool ? '-9999s' : '';
      }

      return init;
    }]);

  /**
   * Older browsers [FF31] expect camelCase
   * property keys.
   * e.g.
   *  animation-duration --> animationDuration
   */
  function camelCase(str) {
    return str.replace(/-[a-z]/g, function(str) {
      return str.charAt(1).toUpperCase();
    });
  }

})();

}

(function(){ 
angular.module("material.core").constant("$MD_THEME_CSS", "md-autocomplete.md-THEME_NAME-theme{background:\"{{background-A100}}\"}md-autocomplete.md-THEME_NAME-theme[disabled]:not([md-floating-label]){background:\"{{background-100}}\"}md-autocomplete.md-THEME_NAME-theme button md-icon path{fill:\"{{background-600}}\"}md-autocomplete.md-THEME_NAME-theme button:after{background:\"{{background-600-0.3}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme{background:\"{{background-A100}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li{color:\"{{background-900}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li .highlight{color:\"{{background-600}}\"}.md-autocomplete-suggestions-container.md-THEME_NAME-theme li.selected,.md-autocomplete-suggestions-container.md-THEME_NAME-theme li:hover{background:\"{{background-200}}\"}md-backdrop{background-color:\"{{background-900-0.0}}\"}md-backdrop.md-opaque.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-bottom-sheet.md-THEME_NAME-theme{background-color:\"{{background-50}}\";border-top-color:\"{{background-300}}\"}md-bottom-sheet.md-THEME_NAME-theme.md-list md-list-item{color:\"{{foreground-1}}\"}md-bottom-sheet.md-THEME_NAME-theme .md-subheader{background-color:\"{{background-50}}\";color:\"{{foreground-1}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme:not([disabled]):hover{background-color:\"{{background-500-0.2}}\"}.md-button.md-THEME_NAME-theme:not([disabled]).md-icon-button:hover{background-color:transparent}.md-button.md-THEME_NAME-theme.md-fab md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab,.md-button.md-THEME_NAME-theme.md-primary.md-raised{color:\"{{primary-contrast}}\";background-color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]) md-icon{color:\"{{primary-contrast}}\"}.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-primary.md-raised:not([disabled]):hover{background-color:\"{{primary-600}}\"}.md-button.md-THEME_NAME-theme.md-primary:not([disabled]) md-icon{color:\"{{primary-color}}\"}.md-button.md-THEME_NAME-theme.md-fab{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]) .md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-fab:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-raised{color:\"{{background-900}}\";background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]) md-icon{color:\"{{background-900}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]):hover{background-color:\"{{background-50}}\"}.md-button.md-THEME_NAME-theme.md-raised:not([disabled]).md-focused{background-color:\"{{background-200}}\"}.md-button.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab,.md-button.md-THEME_NAME-theme.md-warn.md-raised{color:\"{{warn-contrast}}\";background-color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]) md-icon{color:\"{{warn-contrast}}\"}.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-warn.md-raised:not([disabled]):hover{background-color:\"{{warn-600}}\"}.md-button.md-THEME_NAME-theme.md-warn:not([disabled]) md-icon{color:\"{{warn-color}}\"}.md-button.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab,.md-button.md-THEME_NAME-theme.md-accent.md-raised{color:\"{{accent-contrast}}\";background-color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]) md-icon,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]) md-icon{color:\"{{accent-contrast}}\"}.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-fab:not([disabled]):hover,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]).md-focused,.md-button.md-THEME_NAME-theme.md-accent.md-raised:not([disabled]):hover{background-color:\"{{accent-A700}}\"}.md-button.md-THEME_NAME-theme.md-accent:not([disabled]) md-icon{color:\"{{accent-color}}\"}.md-button.md-THEME_NAME-theme.md-accent[disabled],.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled],.md-button.md-THEME_NAME-theme.md-warn[disabled],.md-button.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\";cursor:default}.md-button.md-THEME_NAME-theme.md-accent[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-fab[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-raised[disabled] md-icon,.md-button.md-THEME_NAME-theme.md-warn[disabled] md-icon,.md-button.md-THEME_NAME-theme[disabled] md-icon{color:\"{{foreground-3}}\"}.md-button.md-THEME_NAME-theme.md-fab[disabled],.md-button.md-THEME_NAME-theme.md-raised[disabled]{background-color:\"{{foreground-4}}\"}.md-button.md-THEME_NAME-theme[disabled]{background-color:transparent}._md a.md-THEME_NAME-theme:not(.md-button).md-primary{color:\"{{primary-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-primary:hover{color:\"{{primary-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent{color:\"{{accent-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-accent:hover{color:\"{{accent-A700}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn{color:\"{{warn-color}}\"}._md a.md-THEME_NAME-theme:not(.md-button).md-warn:hover{color:\"{{warn-700}}\"}md-card.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-hue-1}}\";border-radius:2px}md-card.md-THEME_NAME-theme .md-card-image{border-radius:2px 2px 0 0}md-card.md-THEME_NAME-theme md-card-header md-card-avatar md-icon{color:\"{{background-color}}\";background-color:\"{{foreground-3}}\"}md-card.md-THEME_NAME-theme md-card-header md-card-header-text .md-subhead,md-card.md-THEME_NAME-theme md-card-title md-card-title-text:not(:only-child) .md-subhead{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme .md-ripple{color:\"{{accent-A700}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme.md-checked.md-focused .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon{background-color:\"{{accent-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme.md-checked .md-icon:after{border-color:\"{{accent-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ripple{color:\"{{primary-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ripple{color:\"{{background-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon{background-color:\"{{primary-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked.md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-primary .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ripple{color:\"{{warn-600}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn .md-ink-ripple{color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon{background-color:\"{{warn-color-0.87}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked.md-focused:not([disabled]) .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-checkbox.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled]:not(.md-checked) .md-icon{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon{background-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled].md-checked .md-icon:after{border-color:\"{{background-200}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-icon:after{border-color:\"{{foreground-3}}\"}md-checkbox.md-THEME_NAME-theme[disabled] .md-label{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips{box-shadow:0 1px \"{{foreground-4}}\"}md-chips.md-THEME_NAME-theme .md-chips.md-focused{box-shadow:0 2px \"{{primary-color}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input{color:\"{{foreground-1}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-moz-placeholder,md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-moz-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme .md-chips .md-chip-input-container input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-chips.md-THEME_NAME-theme md-chip{background:\"{{background-300}}\";color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip md-icon{color:\"{{background-700}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused{background:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip.md-focused md-icon{color:\"{{primary-contrast}}\"}md-chips.md-THEME_NAME-theme md-chip._md-chip-editing{background:transparent;color:\"{{background-800}}\"}md-chips.md-THEME_NAME-theme md-chip-remove .md-button md-icon path{fill:\"{{background-500}}\"}.md-contact-suggestion span.md-contact-email{color:\"{{background-400}}\"}md-content.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-default}}\"}.md-calendar.md-THEME_NAME-theme{background:\"{{background-A100}}\";color:\"{{background-A200-0.87}}\"}.md-calendar.md-THEME_NAME-theme tr:last-child td{border-bottom-color:\"{{background-200}}\"}.md-THEME_NAME-theme .md-calendar-day-header{background:\"{{background-300}}\";color:\"{{background-A200-0.87}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today .md-calendar-date-selection-indicator{border:1px solid \"{{primary-500}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-date-today.md-calendar-date-disabled{color:\"{{primary-500-0.6}}\"}.md-calendar-date.md-focus .md-THEME_NAME-theme .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date-selection-indicator:hover{background:\"{{background-300}}\"}.md-THEME_NAME-theme .md-calendar-date.md-calendar-selected-date .md-calendar-date-selection-indicator,.md-THEME_NAME-theme .md-calendar-date.md-focus.md-calendar-selected-date .md-calendar-date-selection-indicator{background:\"{{primary-500}}\";color:\"{{primary-500-contrast}}\";border-color:transparent}.md-THEME_NAME-theme .md-calendar-date-disabled,.md-THEME_NAME-theme .md-calendar-month-label-disabled{color:\"{{background-A200-0.435}}\"}.md-THEME_NAME-theme .md-datepicker-input{color:\"{{foreground-1}}\"}.md-THEME_NAME-theme .md-datepicker-input:-moz-placeholder,.md-THEME_NAME-theme .md-datepicker-input::-moz-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}.md-THEME_NAME-theme .md-datepicker-input-container{border-bottom-color:\"{{foreground-4}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-invalid,.md-warn .md-THEME_NAME-theme .md-datepicker-input-container.md-datepicker-focused{border-bottom-color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar-pane{border-color:\"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-triangle-button .md-datepicker-expand-triangle{border-top-color:\"{{foreground-2}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{primary-color}}\"}.md-accent .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon,.md-THEME_NAME-theme .md-datepicker-open.md-accent .md-datepicker-calendar-icon{color:\"{{accent-color}}\"}.md-THEME_NAME-theme .md-datepicker-open.md-warn .md-datepicker-calendar-icon,.md-warn .md-THEME_NAME-theme .md-datepicker-open .md-datepicker-calendar-icon{color:\"{{warn-A700}}\"}.md-THEME_NAME-theme .md-datepicker-calendar{background:\"{{background-A100}}\"}.md-THEME_NAME-theme .md-datepicker-input-mask-opaque{box-shadow:0 0 0 9999px \"{{background-hue-1}}\"}.md-THEME_NAME-theme .md-datepicker-open .md-datepicker-input-container{background:\"{{background-hue-1}}\"}md-dialog.md-THEME_NAME-theme{border-radius:4px;background-color:\"{{background-hue-1}}\";color:\"{{foreground-1}}\"}md-dialog.md-THEME_NAME-theme.md-content-overflow .md-actions,md-dialog.md-THEME_NAME-theme.md-content-overflow md-dialog-actions,md-divider.md-THEME_NAME-theme{border-top-color:\"{{foreground-4}}\"}.layout-gt-lg-row>md-divider.md-THEME_NAME-theme,.layout-gt-md-row>md-divider.md-THEME_NAME-theme,.layout-gt-sm-row>md-divider.md-THEME_NAME-theme,.layout-gt-xs-row>md-divider.md-THEME_NAME-theme,.layout-lg-row>md-divider.md-THEME_NAME-theme,.layout-md-row>md-divider.md-THEME_NAME-theme,.layout-row>md-divider.md-THEME_NAME-theme,.layout-sm-row>md-divider.md-THEME_NAME-theme,.layout-xl-row>md-divider.md-THEME_NAME-theme,.layout-xs-row>md-divider.md-THEME_NAME-theme{border-right-color:\"{{foreground-4}}\"}md-icon.md-THEME_NAME-theme{color:\"{{foreground-2}}\"}md-icon.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}md-icon.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}md-icon.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-input-container.md-THEME_NAME-theme .md-input{color:\"{{foreground-1}}\";border-color:\"{{foreground-4}}\"}md-input-container.md-THEME_NAME-theme .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme .md-input::-moz-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input:-ms-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme .md-input::-webkit-input-placeholder{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme>md-icon{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme .md-placeholder,md-input-container.md-THEME_NAME-theme label{color:\"{{foreground-3}}\"}md-input-container.md-THEME_NAME-theme label.md-required:after{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-focused):not(.md-input-invalid) label.md-required:after{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation,md-input-container.md-THEME_NAME-theme .md-input-messages-animation{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme .md-input-message-animation .md-char-counter,md-input-container.md-THEME_NAME-theme .md-input-messages-animation .md-char-counter{color:\"{{foreground-1}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-moz-placeholder,md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-moz-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input:-ms-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme.md-input-focused .md-input::-webkit-input-placeholder{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-has-value label{color:\"{{foreground-2}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused .md-input,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-resized .md-input{border-color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused md-icon{color:\"{{primary-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent .md-input{border-color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-accent md-icon{color:\"{{accent-color}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn label,md-input-container.md-THEME_NAME-theme:not(.md-input-invalid).md-input-focused.md-warn md-icon{color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input{border-color:\"{{warn-A700}}\"}md-input-container.md-THEME_NAME-theme.md-input-invalid .md-char-counter,md-input-container.md-THEME_NAME-theme.md-input-invalid .md-input-message-animation,md-input-container.md-THEME_NAME-theme.md-input-invalid label{color:\"{{warn-A700}}\"}[disabled] md-input-container.md-THEME_NAME-theme .md-input,md-input-container.md-THEME_NAME-theme .md-input[disabled]{border-bottom-color:transparent;color:\"{{foreground-3}}\";background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text h4,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h3,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text h4{color:\"{{foreground-1}}\"}md-list.md-THEME_NAME-theme md-list-item.md-2-line .md-list-item-text p,md-list.md-THEME_NAME-theme md-list-item.md-3-line .md-list-item-text p{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme .md-proxy-focus.md-focused div.md-no-style{background-color:\"{{background-100}}\"}md-list.md-THEME_NAME-theme md-list-item .md-avatar-icon{background-color:\"{{foreground-3}}\";color:\"{{background-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon{color:\"{{foreground-2}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight{color:\"{{primary-color}}\"}md-list.md-THEME_NAME-theme md-list-item>md-icon.md-highlight.md-accent{color:\"{{accent-color}}\"}md-menu-content.md-THEME_NAME-theme{background-color:\"{{background-A100}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item{color:\"{{background-A200-0.87}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item md-icon{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled],md-menu-content.md-THEME_NAME-theme md-menu-item .md-button[disabled] md-icon{color:\"{{background-A200-0.25}}\"}md-menu-content.md-THEME_NAME-theme md-menu-divider{background-color:\"{{background-A200-0.11}}\"}md-menu-bar.md-THEME_NAME-theme>button.md-button{color:\"{{foreground-2}}\";border-radius:2px}md-menu-bar.md-THEME_NAME-theme md-menu.md-open>button,md-menu-bar.md-THEME_NAME-theme md-menu>button:focus{outline:none;background:\"{{background-200}}\"}md-menu-bar.md-THEME_NAME-theme.md-open:not(.md-keyboard-mode) md-menu:hover>button{background-color:\"{{ background-500-0.2}}\"}md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:focus,md-menu-bar.md-THEME_NAME-theme:not(.md-keyboard-mode):not(.md-open) md-menu button:hover{background:transparent}md-menu-content.md-THEME_NAME-theme .md-menu>.md-button:after{color:\"{{background-A200-0.54}}\"}md-menu-content.md-THEME_NAME-theme .md-menu.md-open>.md-button{background-color:\"{{ background-500-0.2}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar{background-color:\"{{background-A100}}\";color:\"{{background-A200}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler{background-color:\"{{primary-color}}\";color:\"{{background-A100-0.87}}\"}md-toolbar.md-THEME_NAME-theme.md-menu-toolbar md-toolbar-filler md-icon{color:\"{{background-A100-0.87}}\"}md-nav-bar.md-THEME_NAME-theme .md-nav-bar{background-color:transparent;border-color:\"{{foreground-4}}\"}md-nav-bar.md-THEME_NAME-theme .md-button._md-nav-button.md-unselected{color:\"{{foreground-2}}\"}md-nav-bar.md-THEME_NAME-theme md-nav-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}._md-panel-backdrop.md-THEME_NAME-theme{background-color:\"{{background-900-1.0}}\"}md-progress-circular.md-THEME_NAME-theme path{stroke:\"{{primary-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-warn path{stroke:\"{{warn-color}}\"}md-progress-circular.md-THEME_NAME-theme.md-accent path{stroke:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme .md-container{background-color:\"{{primary-100}}\"}md-progress-linear.md-THEME_NAME-theme .md-bar{background-color:\"{{primary-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-container{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-warn .md-bar{background-color:\"{{warn-color}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-container{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme.md-accent .md-bar{background-color:\"{{accent-color}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-bar1{background-color:\"{{warn-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-warn .md-dashed:before{background:radial-gradient(\"{{warn-100}}\" 0,\"{{warn-100}}\" 16%,transparent 42%)}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-bar1{background-color:\"{{accent-100}}\"}md-progress-linear.md-THEME_NAME-theme[md-mode=buffer].md-accent .md-dashed:before{background:radial-gradient(\"{{accent-100}}\" 0,\"{{accent-100}}\" 16%,transparent 42%)}md-radio-button.md-THEME_NAME-theme .md-off{border-color:\"{{foreground-2}}\"}md-radio-button.md-THEME_NAME-theme .md-on{background-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-off{border-color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme .md-container .md-ripple{color:\"{{accent-A700}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-on{background-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-off{border-color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-checked .md-ink-ripple{color:\"{{primary-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-primary .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-primary .md-container .md-ripple{color:\"{{primary-600}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-on,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-on{background-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-off,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-off{border-color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn.md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-checked .md-ink-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-checked .md-ink-ripple{color:\"{{warn-color-0.87}}\"}md-radio-button.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-button.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]).md-warn .md-container .md-ripple,md-radio-group.md-THEME_NAME-theme:not([disabled]) .md-warn .md-container .md-ripple{color:\"{{warn-600}}\"}md-radio-button.md-THEME_NAME-theme[disabled],md-radio-group.md-THEME_NAME-theme[disabled]{color:\"{{foreground-3}}\"}md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-button.md-THEME_NAME-theme[disabled] .md-container .md-on,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-off,md-radio-group.md-THEME_NAME-theme[disabled] .md-container .md-on{border-color:\"{{foreground-3}}\"}md-radio-group.md-THEME_NAME-theme .md-checked .md-ink-ripple{color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked:not([disabled]).md-primary .md-ink-ripple,md-radio-group.md-THEME_NAME-theme.md-primary .md-checked:not([disabled]) .md-ink-ripple{color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme .md-checked.md-primary .md-ink-ripple{color:\"{{warn-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked .md-container:before{background-color:\"{{accent-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-primary .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-primary .md-checked .md-container:before{background-color:\"{{primary-color-0.26}}\"}md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty) .md-checked.md-warn .md-container:before,md-radio-group.md-THEME_NAME-theme.md-focused:not(:empty).md-warn .md-checked .md-container:before{background-color:\"{{warn-color-0.26}}\"}md-input-container md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-input-container:not(.md-input-focused):not(.md-input-invalid) md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{foreground-3}}\"}md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value,md-input-container.md-input-focused:not(.md-input-has-value) md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{primary-color}}\"}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-input-container.md-input-invalid md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme[disabled] .md-select-value{border-bottom-color:transparent;background-image:linear-gradient(90deg,\"{{foreground-3}}\" 0,\"{{foreground-3}}\" 33%,transparent 0);background-image:-ms-linear-gradient(left,transparent 0,\"{{foreground-3}}\" 100%)}md-select.md-THEME_NAME-theme .md-select-value{border-bottom-color:\"{{foreground-4}}\"}md-select.md-THEME_NAME-theme .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-value span:first-child:after{color:\"{{warn-A700}}\"}md-select.md-THEME_NAME-theme.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched .md-select-value{color:\"{{warn-A700}}\"!important;border-bottom-color:\"{{warn-A700}}\"!important}md-select.md-THEME_NAME-theme.ng-invalid.ng-touched.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value{border-bottom-color:\"{{primary-color}}\";color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus .md-select-value.md-select-placeholder{color:\"{{ foreground-1 }}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-no-underline .md-select-value{border-bottom-color:transparent!important}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-accent .md-select-value{border-bottom-color:\"{{accent-color}}\"}md-select.md-THEME_NAME-theme:not([disabled]):focus.md-warn .md-select-value{border-bottom-color:\"{{warn-color}}\"}md-select.md-THEME_NAME-theme[disabled] .md-select-icon,md-select.md-THEME_NAME-theme[disabled] .md-select-value,md-select.md-THEME_NAME-theme[disabled] .md-select-value.md-select-placeholder{color:\"{{foreground-3}}\"}md-select.md-THEME_NAME-theme .md-select-icon{color:\"{{foreground-2}}\"}md-select-menu.md-THEME_NAME-theme md-content{background:\"{{background-A100}}\"}md-select-menu.md-THEME_NAME-theme md-content md-optgroup{color:\"{{background-600-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option{color:\"{{background-900-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[disabled] .md-text{color:\"{{background-400-0.87}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):focus,md-select-menu.md-THEME_NAME-theme md-content md-option:not([disabled]):hover{background:\"{{background-200}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]{color:\"{{primary-500}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected]:focus{color:\"{{primary-600}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent{color:\"{{accent-color}}\"}md-select-menu.md-THEME_NAME-theme md-content md-option[selected].md-accent:focus{color:\"{{accent-A700}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ripple{color:\"{{primary-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ripple{color:\"{{background-600}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-ink-ripple{color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-ink-ripple{color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme:not(.md-checked) .md-icon{border-color:\"{{foreground-2}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon{background-color:\"{{primary-color-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected].md-focused .md-container:before{background-color:\"{{primary-color-0.26}}\"}.md-checkbox-enabled.md-THEME_NAME-theme[selected] .md-icon:after{border-color:\"{{primary-contrast-0.87}}\"}.md-checkbox-enabled.md-THEME_NAME-theme .md-indeterminate[disabled] .md-container{color:\"{{foreground-3}}\"}.md-checkbox-enabled.md-THEME_NAME-theme md-option .md-text{color:\"{{background-900-0.87}}\"}md-sidenav.md-THEME_NAME-theme,md-sidenav.md-THEME_NAME-theme md-content{background-color:\"{{background-hue-1}}\"}md-slider.md-THEME_NAME-theme .md-track{background-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme .md-track-ticks{color:\"{{background-contrast}}\"}md-slider.md-THEME_NAME-theme .md-focus-ring{background-color:\"{{accent-A200-0.2}}\"}md-slider.md-THEME_NAME-theme .md-disabled-thumb{border-color:\"{{background-color}}\";background-color:\"{{background-color}}\"}md-slider.md-THEME_NAME-theme.md-min .md-thumb:after{background-color:\"{{background-color}}\";border-color:\"{{foreground-3}}\"}md-slider.md-THEME_NAME-theme.md-min .md-focus-ring{background-color:\"{{foreground-3-0.38}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-thumb:after{background-color:\"{{background-contrast}}\";border-color:transparent}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme.md-min[md-discrete][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme .md-track.md-track-fill{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb:after{border-color:\"{{accent-color}}\";background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign{background-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-sign:after{border-top-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{accent-color}}\"}md-slider.md-THEME_NAME-theme .md-thumb-text{color:\"{{accent-contrast}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-focus-ring{background-color:\"{{warn-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-track.md-track-fill{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb:after{border-color:\"{{warn-color}}\";background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign{background-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-sign:after{border-top-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{warn-color}}\"}md-slider.md-THEME_NAME-theme.md-warn .md-thumb-text{color:\"{{warn-contrast}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-focus-ring{background-color:\"{{primary-200-0.38}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-track.md-track-fill{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb:after{border-color:\"{{primary-color}}\";background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign{background-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-sign:after{border-top-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary[md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{primary-color}}\"}md-slider.md-THEME_NAME-theme.md-primary .md-thumb-text{color:\"{{primary-contrast}}\"}md-slider.md-THEME_NAME-theme[disabled] .md-thumb:after{border-color:transparent}md-slider.md-THEME_NAME-theme[disabled]:not(.md-min) .md-thumb:after,md-slider.md-THEME_NAME-theme[disabled][md-discrete] .md-thumb:after{background-color:\"{{foreground-3}}\";border-color:transparent}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign{background-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-sign:after{border-top-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly][md-vertical] .md-sign:after{border-top-color:transparent;border-left-color:\"{{background-400}}\"}md-slider.md-THEME_NAME-theme[disabled][readonly] .md-disabled-thumb{border-color:transparent;background-color:transparent}md-slider-container[disabled]>:first-child:not(md-slider),md-slider-container[disabled]>:last-child:not(md-slider){color:\"{{foreground-3}}\"}.md-subheader.md-THEME_NAME-theme{color:\"{{ foreground-2-0.23 }}\";background-color:\"{{background-default}}\"}.md-subheader.md-THEME_NAME-theme.md-primary{color:\"{{primary-color}}\"}.md-subheader.md-THEME_NAME-theme.md-accent{color:\"{{accent-color}}\"}.md-subheader.md-THEME_NAME-theme.md-warn{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme .md-ink-ripple{color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme .md-thumb{background-color:\"{{background-50}}\"}md-switch.md-THEME_NAME-theme .md-bar{background-color:\"{{background-500}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-ink-ripple{color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-thumb{background-color:\"{{accent-color}}\"}md-switch.md-THEME_NAME-theme.md-checked .md-bar{background-color:\"{{accent-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-focused .md-thumb:before{background-color:\"{{accent-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-ink-ripple{color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-thumb{background-color:\"{{primary-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary .md-bar{background-color:\"{{primary-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-primary.md-focused .md-thumb:before{background-color:\"{{primary-color-0.26}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-ink-ripple{color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-thumb{background-color:\"{{warn-color}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn .md-bar{background-color:\"{{warn-color-0.5}}\"}md-switch.md-THEME_NAME-theme.md-checked.md-warn.md-focused .md-thumb:before{background-color:\"{{warn-color-0.26}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-thumb{background-color:\"{{background-400}}\"}md-switch.md-THEME_NAME-theme[disabled] .md-bar{background-color:\"{{foreground-4}}\"}md-toast.md-THEME_NAME-theme .md-toast-content{background-color:#323232;color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button{color:\"{{background-50}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight{color:\"{{accent-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-primary{color:\"{{primary-color}}\"}md-toast.md-THEME_NAME-theme .md-toast-content .md-button.md-highlight.md-warn{color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme md-tabs-wrapper{background-color:transparent;border-color:\"{{foreground-4}}\"}md-tabs.md-THEME_NAME-theme .md-paginator md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme md-ink-bar{color:\"{{accent-color}}\";background:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab{color:\"{{foreground-2}}\"}md-tabs.md-THEME_NAME-theme .md-tab[disabled],md-tabs.md-THEME_NAME-theme .md-tab[disabled] md-icon{color:\"{{foreground-3}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-active,md-tabs.md-THEME_NAME-theme .md-tab.md-active md-icon,md-tabs.md-THEME_NAME-theme .md-tab.md-focused,md-tabs.md-THEME_NAME-theme .md-tab.md-focused md-icon{color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme .md-tab.md-focused{background:\"{{primary-color-0.1}}\"}md-tabs.md-THEME_NAME-theme .md-tab .md-ripple-container{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-accent>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-primary>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-tabs.md-THEME_NAME-theme.md-warn>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{primary-color}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{primary-100}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{primary-contrast}}\"}md-toolbar>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{primary-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{accent-color}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{accent-A100}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{accent-contrast}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{accent-contrast-0.1}}\"}md-toolbar.md-accent>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-ink-bar{color:\"{{primary-600-1}}\";background:\"{{primary-600-1}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper{background-color:\"{{warn-color}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]),md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]) md-icon{color:\"{{warn-100}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-active md-icon,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused,md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused md-icon{color:\"{{warn-contrast}}\"}md-toolbar.md-warn>md-tabs.md-THEME_NAME-theme>md-tabs-wrapper>md-tabs-canvas>md-pagination-wrapper>md-tab-item:not([disabled]).md-focused{background:\"{{warn-contrast-0.1}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar){background-color:\"{{primary-color}}\";color:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) md-icon{color:\"{{primary-contrast}}\";fill:\"{{primary-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar) .md-button[disabled] md-icon{color:\"{{primary-contrast-0.26}}\";fill:\"{{primary-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent{background-color:\"{{accent-color}}\";color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-ink-ripple{color:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent md-icon{color:\"{{accent-contrast}}\";fill:\"{{accent-contrast}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-accent .md-button[disabled] md-icon{color:\"{{accent-contrast-0.26}}\";fill:\"{{accent-contrast-0.26}}\"}md-toolbar.md-THEME_NAME-theme:not(.md-menu-toolbar).md-warn{background-color:\"{{warn-color}}\";color:\"{{warn-contrast}}\"}.md-panel.md-tooltip.md-THEME_NAME-theme{color:\"{{background-700-contrast}}\";background-color:\"{{background-700}}\"}body.md-THEME_NAME-theme,html.md-THEME_NAME-theme{color:\"{{foreground-1}}\";background-color:\"{{background-color}}\"}"); 
})();


})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.divider
 * @description Divider module!
 */
MdDividerDirective['$inject'] = ["$mdTheming"];
angular.module('material.components.divider', [
  'material.core'
])
  .directive('mdDivider', MdDividerDirective);

/**
 * @ngdoc directive
 * @name mdDivider
 * @module material.components.divider
 * @restrict E
 *
 * @description
 * Dividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.
 *
 * @param {boolean=} md-inset Add this attribute to activate the inset divider style.
 * @usage
 * <hljs lang="html">
 * <md-divider></md-divider>
 *
 * <md-divider md-inset></md-divider>
 * </hljs>
 *
 */
function MdDividerDirective($mdTheming) {
  return {
    restrict: 'E',
    link: $mdTheming
  };
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.icon
 * @description
 * Icon
 */
angular.module('material.components.icon', ['material.core']);

angular
  .module('material.components.icon')
  .directive('mdIcon', ['$mdIcon', '$mdTheming', '$mdAria', '$sce', mdIconDirective]);

/**
 * @ngdoc directive
 * @name mdIcon
 * @module material.components.icon
 *
 * @restrict E
 *
 * @description
 * The `md-icon` directive makes it easier to use vector-based icons in your app (as opposed to
 * raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.
 *
 * Icons should be considered view-only elements that should not be used directly as buttons; instead nest a `<md-icon>`
 * inside a `md-button` to add hover and click features.
 *
 * ### Icon fonts
 * Icon fonts are a technique in which you use a font where the glyphs in the font are
 * your icons instead of text. Benefits include a straightforward way to bundle everything into a
 * single HTTP request, simple scaling, easy color changing, and more.
 *
 * `md-icon` lets you consume an icon font by letting you reference specific icons in that font
 * by name rather than character code.
 *
 * ### SVG
 * For SVGs, the problem with using `<img>` or a CSS `background-image` is that you can't take
 * advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG
 * animation.
 *
 * `md-icon` makes it easier to use SVG icons by *inlining* the SVG into an `<svg>` element in the
 * document. The most straightforward way of referencing an SVG icon is via URL, just like a
 * traditional `<img>`. `$mdIconProvider`, as a convenience, lets you _name_ an icon so you can
 * reference it by name instead of URL throughout your templates.
 *
 * Additionally, you may not want to make separate HTTP requests for every icon, so you can bundle
 * your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can
 * also be given a name, which acts as a namespace for individual icons, so you can reference them
 * like `"social:cake"`.
 *
 * When using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be
 * easily loaded and used. When using font-icons, developers must follow three (3) simple steps:
 *
 * <ol>
 * <li>Load the font library. e.g.<br/>
 *    `<link href="https://fonts.googleapis.com/icon?family=Material+Icons"
 *    rel="stylesheet">`
 * </li>
 * <li>
 *   Use either (a) font-icon class names or (b) a fontset and a font ligature to render the font glyph by
 *   using its textual name _or_ numerical character reference. Note that `material-icons` is the default fontset when
 *   none is specified.
 * </li>
 * <li> Use any of the following templates: <br/>
 *   <ul>
 *     <li>`<md-icon md-font-icon="classname"></md-icon>`</li>
 *     <li>`<md-icon md-font-set="font library classname or alias">textual_name</md-icon>`</li>
 *     <li>`<md-icon> numerical_character_reference </md-icon>`</li>
 *     <li>`<md-icon ng_bind="'textual_name'"></md-icon>`</li>
 *     <li>`<md-icon ng-bind="scopeVariable"></md-icon>`</li>
 *   </ul>
 * </li>
 * </ol>
 *
 * Full details for these steps can be found:
 *
 * <ul>
 * <li>http://google.github.io/material-design-icons/</li>
 * <li>http://google.github.io/material-design-icons/#icon-font-for-the-web</li>
 * </ul>
 *
 * The Material Design icon style <code>.material-icons</code> and the icon font references are published in
 * Material Design Icons:
 *
 * <ul>
 * <li>https://design.google.com/icons/</li>
 * <li>https://design.google.com/icons/#ic_accessibility</li>
 * </ul>
 *
 * ### Localization
 *
 * Because an `md-icon` element's text content is not intended to translated, it is recommended to declare the text
 * content for an `md-icon` element in its start tag. Instead of using the HTML text content, consider using `ng-bind`
 * with a scope variable or literal string.
 *
 * Examples:
 *
 * <ul>
 *   <li>`<md-icon ng-bind="myIconVariable"></md-icon>`</li>
 *   <li>`<md-icon ng-bind="'menu'"></md-icon>`
 * </ul>
 *
 * <h2 id="material_design_icons">Material Design Icons</h2>
 * Using the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and
 * determine its textual name and character reference code. Click on any icon to see the slide-up information
 * panel with details regarding a SVG download or information on the font-icon usage.
 *
 * <a href="https://www.google.com/design/icons/#ic_accessibility" target="_blank" style="border-bottom:none;">
 * <img src="https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png"
 *      aria-label="Material Design Icon-Selector" style="max-width:75%;padding-left:10%">
 * </a>
 *
 * <span class="image_caption">
 *  Click on the image above to link to the
 *  <a href="https://design.google.com/icons/#ic_accessibility" target="_blank">Material Design Icon-Selector</a>.
 * </span>
 *
 * @param {string} md-font-icon String name of CSS icon associated with the font-face will be used
 * to render the icon. Requires the fonts and the named CSS styles to be preloaded.
 * @param {string} md-font-set CSS style name associated with the font library; which will be assigned as
 * the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname;
 * internally use `$mdIconProvider.fontSet(<alias>)` to determine the style name.
 * @param {string} md-svg-src String URL (or expression) used to load, cache, and display an
 *     external SVG.
 * @param {string} md-svg-icon md-svg-icon String name used for lookup of the icon from the internal cache;
 *     interpolated strings or expressions may also be used. Specific set names can be used with
 *     the syntax `<set name>:<icon name>`.<br/><br/>
 * To use icon sets, developers are required to pre-register the sets using the `$mdIconProvider` service.
 * @param {string=} aria-label Labels icon for accessibility. If an empty string is provided, icon
 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no aria-label on the icon
 * nor a label on the parent element, a warning will be logged to the console.
 * @param {string=} alt Labels icon for accessibility. If an empty string is provided, icon
 * will be hidden from accessibility layer with `aria-hidden="true"`. If there's no alt on the icon
 * nor a label on the parent element, a warning will be logged to the console.
 *
 * @usage
 * When using SVGs:
 * <hljs lang="html">
 *
 *  <!-- Icon ID; may contain optional icon set prefix; icons must registered using $mdIconProvider -->
 *  <md-icon md-svg-icon="social:android"    aria-label="android " ></md-icon>
 *
 *  <!-- Icon urls; may be preloaded in templateCache -->
 *  <md-icon md-svg-src="/android.svg"       aria-label="android " ></md-icon>
 *  <md-icon md-svg-src="{{ getAndroid() }}" aria-label="android " ></md-icon>
 *
 * </hljs>
 *
 * Use the <code>$mdIconProvider</code> to configure your application with
 * svg iconsets.
 *
 * <hljs lang="js">
 *  angular.module('appSvgIconSets', ['ngMaterial'])
 *    .controller('DemoCtrl', function($scope) {})
 *    .config(function($mdIconProvider) {
 *      $mdIconProvider
 *         .iconSet('social', 'img/icons/sets/social-icons.svg', 24)
 *         .defaultIconSet('img/icons/sets/core-icons.svg', 24);
 *     });
 * </hljs>
 *
 *
 * When using Font Icons with classnames:
 * <hljs lang="html">
 *
 *  <md-icon md-font-icon="android" aria-label="android" ></md-icon>
 *  <md-icon class="icon_home"      aria-label="Home"    ></md-icon>
 *
 * </hljs>
 *
 * When using Material Font Icons with ligatures:
 * <hljs lang="html">
 *  <!--
 *  For Material Design Icons
 *  The class '.material-icons' is auto-added if a style has NOT been specified
 *  since `material-icons` is the default fontset. So your markup:
 *  -->
 *  <md-icon> face </md-icon>
 *  <!-- becomes this at runtime: -->
 *  <md-icon md-font-set="material-icons"> face </md-icon>
 *  <!-- If the fontset does not support ligature names, then we need to use the ligature unicode.-->
 *  <md-icon> &#xE87C; </md-icon>
 *  <!-- The class '.material-icons' must be manually added if other styles are also specified-->
 *  <md-icon class="material-icons md-light md-48"> face </md-icon>
 * </hljs>
 *
 * When using other Font-Icon libraries:
 *
 * <hljs lang="js">
 *  // Specify a font-icon style alias
 *  angular.config(function($mdIconProvider) {
 *    $mdIconProvider.fontSet('md', 'material-icons');
 *  });
 * </hljs>
 *
 * <hljs lang="html">
 *  <md-icon md-font-set="md">favorite</md-icon>
 * </hljs>
 *
 */
function mdIconDirective($mdIcon, $mdTheming, $mdAria, $sce) {

  return {
    restrict: 'E',
    link : postLink
  };


  /**
   * Directive postLink
   * Supports embedded SVGs, font-icons, & external SVGs
   */
  function postLink(scope, element, attr) {
    $mdTheming(element);
    var lastFontIcon = attr.mdFontIcon;
    var lastFontSet = $mdIcon.fontSet(attr.mdFontSet);

    prepareForFontIcon();

    attr.$observe('mdFontIcon', fontIconChanged);
    attr.$observe('mdFontSet', fontIconChanged);

    // Keep track of the content of the svg src so we can compare against it later to see if the
    // attribute is static (and thus safe).
    var originalSvgSrc = element[0].getAttribute(attr.$attr.mdSvgSrc);

    // If using a font-icon, then the textual name of the icon itself
    // provides the aria-label.

    var label = attr.alt || attr.mdFontIcon || attr.mdSvgIcon || element.text();
    var attrName = attr.$normalize(attr.$attr.mdSvgIcon || attr.$attr.mdSvgSrc || '');

    if ( !attr['aria-label'] ) {

      if (label !== '' && !parentsHaveText() ) {

        $mdAria.expect(element, 'aria-label', label);
        $mdAria.expect(element, 'role', 'img');

      } else if ( !element.text() ) {
        // If not a font-icon with ligature, then
        // hide from the accessibility layer.

        $mdAria.expect(element, 'aria-hidden', 'true');
      }
    }

    if (attrName) {
      // Use either pre-configured SVG or URL source, respectively.
      attr.$observe(attrName, function(attrVal) {
        element.empty();
        if (attrVal) {
          $mdIcon(attrVal)
            .then(function(svg) {
            element.empty();
            element.append(svg);
          });
        }

      });
    }

    function parentsHaveText() {
      var parent = element.parent();
      if (parent.attr('aria-label') || parent.text()) {
        return true;
      }
      else if(parent.parent().attr('aria-label') || parent.parent().text()) {
        return true;
      }
      return false;
    }

    function prepareForFontIcon() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.addClass('md-font ' + attr.mdFontIcon);
        }

        element.addClass(lastFontSet);
      }
    }

    function fontIconChanged() {
      if (!attr.mdSvgIcon && !attr.mdSvgSrc) {
        if (attr.mdFontIcon) {
          element.removeClass(lastFontIcon);
          element.addClass(attr.mdFontIcon);

          lastFontIcon = attr.mdFontIcon;
        }

        var fontSet = $mdIcon.fontSet(attr.mdFontSet);

        if (lastFontSet !== fontSet) {
          element.removeClass(lastFontSet);
          element.addClass(fontSet);

          lastFontSet = fontSet;
        }
      }
    }
  }
}

  
MdIconService['$inject'] = ["config", "$templateRequest", "$q", "$log", "$mdUtil", "$sce"];angular
    .module('material.components.icon')
    .constant('$$mdSvgRegistry', {
        'mdTabsArrow':   'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwb2x5Z29uIHBvaW50cz0iMTUuNCw3LjQgMTQsNiA4LDEyIDE0LDE4IDE1LjQsMTYuNiAxMC44LDEyICIvPjwvZz48L3N2Zz4=',
        'mdClose':       'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=',
        'mdCancel':      'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xMiAyYy01LjUzIDAtMTAgNC40Ny0xMCAxMHM0LjQ3IDEwIDEwIDEwIDEwLTQuNDcgMTAtMTAtNC40Ny0xMC0xMC0xMHptNSAxMy41OWwtMS40MSAxLjQxLTMuNTktMy41OS0zLjU5IDMuNTktMS40MS0xLjQxIDMuNTktMy41OS0zLjU5LTMuNTkgMS40MS0xLjQxIDMuNTkgMy41OSAzLjU5LTMuNTkgMS40MSAxLjQxLTMuNTkgMy41OSAzLjU5IDMuNTl6Ii8+PC9nPjwvc3ZnPg==',
        'mdMenu':        'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGQ9Ik0zLDZIMjFWOEgzVjZNMywxMUgyMVYxM0gzVjExTTMsMTZIMjFWMThIM1YxNloiIC8+PC9zdmc+',
        'mdToggleArrow': 'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDggNDgiPjxwYXRoIGQ9Ik0yNCAxNmwtMTIgMTIgMi44MyAyLjgzIDkuMTctOS4xNyA5LjE3IDkuMTcgMi44My0yLjgzeiIvPjxwYXRoIGQ9Ik0wIDBoNDh2NDhoLTQ4eiIgZmlsbD0ibm9uZSIvPjwvc3ZnPg==',
        'mdCalendar':    'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMTkgM2gtMVYxaC0ydjJIOFYxSDZ2Mkg1Yy0xLjExIDAtMS45OS45LTEuOTkgMkwzIDE5YzAgMS4xLjg5IDIgMiAyaDE0YzEuMSAwIDItLjkgMi0yVjVjMC0xLjEtLjktMi0yLTJ6bTAgMTZINVY4aDE0djExek03IDEwaDV2NUg3eiIvPjwvc3ZnPg==',
        'mdChecked':     'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik05IDE2LjE3TDQuODMgMTJsLTEuNDIgMS40MUw5IDE5IDIxIDdsLTEuNDEtMS40MXoiLz48L2c+PC9zdmc+'
    })
    .provider('$mdIcon', MdIconProvider);

/**
 * @ngdoc service
 * @name $mdIconProvider
 * @module material.components.icon
 *
 * @description
 * `$mdIconProvider` is used only to register icon IDs with URLs. These configuration features allow
 * icons and icon sets to be pre-registered and associated with source URLs **before** the `<md-icon />`
 * directives are compiled.
 *
 * If using font-icons, the developer is responsible for loading the fonts.
 *
 * If using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded
 * internally by the `$mdIcon` service using the `$templateRequest` service. When an SVG is
 * requested by name/ID, the `$mdIcon` service searches its registry for the associated source URL;
 * that URL is used to on-demand load and parse the SVG dynamically.
 *
 * The `$templateRequest` service expects the icons source to be loaded over trusted URLs.<br/>
 * This means, when loading icons from an external URL, you have to trust the URL in the `$sceDelegateProvider`.
 *
 * <hljs lang="js">
 *   app.config(function($sceDelegateProvider) {
 *     $sceDelegateProvider.resourceUrlWhitelist([
 *       // Adding 'self' to the whitelist, will allow requests from the current origin.
 *       'self',
 *       // Using double asterisks here, will allow all URLs to load.
 *       // We recommend to only specify the given domain you want to allow.
 *       '**'
 *     ]);
 *   });
 * </hljs>
 *
 * Read more about the [$sceDelegateProvider](https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider).
 *
 * **Notice:** Most font-icons libraries do not support ligatures (for example `fontawesome`).<br/>
 *  In such cases you are not able to use the icon's ligature name - Like so:
 *
 *  <hljs lang="html">
 *    <md-icon md-font-set="fa">fa-bell</md-icon>
 *  </hljs>
 *
 * You should instead use the given unicode, instead of the ligature name.
 *
 * <p ng-hide="true"> ##// Notice we can't use a hljs element here, because the characters will be escaped.</p>
 *  ```html
 *    <md-icon md-font-set="fa">&#xf0f3</md-icon>
 *  ```
 *
 * All unicode ligatures are prefixed with the `&#x` string.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultFontSet( 'fa' )                   // This sets our default fontset className.
    *          .defaultIconSet('my/app/icons.svg')       // Register a default set of SVG icons
    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set of SVGs
    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
    *   });
 * </hljs>
 *
 * SVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime
 * **startup** process (shown below):
 *
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Register a default set of SVG icon definitions
    *     $mdIconProvider.defaultIconSet('my/app/icons.svg')
    *
    *   })
 *   .run(function($templateRequest){
    *
    *     // Pre-fetch icons sources by URL and cache in the $templateCache...
    *     // subsequent $templateRequest calls will look there first.
    *
    *     var urls = [ 'imy/app/icons.svg', 'img/icons/android.svg'];
    *
    *     angular.forEach(urls, function(url) {
    *       $templateRequest(url);
    *     });
    *
    *   });
 *
 * </hljs>
 *
 * > <b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#icon
 *
 * @description
 * Register a source URL for a specific icon name; the name may include optional 'icon set' name prefix.
 * These icons  will later be retrieved from the cache using `$mdIcon( <icon name> )`
 *
 * @param {string} id Icon name/id used to register the icon
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height the icon's viewBox.
 * It is ignored for icons with an existing viewBox. Default size is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .icon('android', 'my/app/android.svg')    // Register a specific icon (by name)
    *          .icon('work:chair', 'my/app/chair.svg');  // Register icon in a specific set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#iconSet
 *
 * @description
 * Register a source URL for a 'named' set of icons; group of SVG definitions where each definition
 * has an icon id. Individual icons can be subsequently retrieved from this cached set using
 * `$mdIcon(<icon set name>:<icon name>)`
 *
 * @param {string} id Icon name/id used to register the iconset
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
 * Default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .iconSet('social', 'my/app/social.svg')   // Register a named icon set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#defaultIconSet
 *
 * @description
 * Register a source URL for the default 'named' set of icons. Unless explicitly registered,
 * subsequent lookups of icons will failover to search this 'default' icon set.
 * Icon can be retrieved from this cached, default set using `$mdIcon(<name>)`
 *
 * @param {string} url specifies the external location for the data file. Used internally by
 * `$templateRequest` to load the data or as part of the lookup in `$templateCache` if pre-loading
 * was configured.
 * @param {number=} viewBoxSize Sets the width and height of the viewBox of all icons in the set.
 * It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size.
 * Default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultIconSet( 'my/app/social.svg' )   // Register a default icon set
    *   });
 * </hljs>
 *
 */
/**
 * @ngdoc method
 * @name $mdIconProvider#defaultFontSet
 *
 * @description
 * When using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically
 * configures the default font-set == 'material-icons'. Note that the font-set references the font-icon library
 * class style that should be applied to the `<md-icon>`.
 *
 * Configuring the default means that the attributes
 * `md-font-set="material-icons"` or `class="material-icons"` do not need to be explicitly declared on the
 * `<md-icon>` markup. For example:
 *
 *  `<md-icon> face </md-icon>`
 *  will render as
 *  `<span class="material-icons"> face </span>`, and
 *
 *  `<md-icon md-font-set="fa"> face </md-icon>`
 *  will render as
 *  `<span class="fa"> face </span>`
 *
 * @param {string} name of the font-library style that should be applied to the md-icon DOM element
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
   *     $mdIconProvider.defaultFontSet( 'fa' );
   *   });
 * </hljs>
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#fontSet
 *
 * @description
 * When using a font set for `<md-icon>` you must specify the correct font classname in the `md-font-set`
 * attribute. If the fonset className is really long, your markup may become cluttered... an easy
 * solution is to define an `alias` for your fontset:
 *
 * @param {string} alias of the specified fontset.
 * @param {string} className of the fontset.
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
   *     // In this case, we set an alias for the `material-icons` fontset.
   *     $mdIconProvider.fontSet('md', 'material-icons');
   *   });
 * </hljs>
 *
 */

/**
 * @ngdoc method
 * @name $mdIconProvider#defaultViewBoxSize
 *
 * @description
 * While `<md-icon />` markup can also be style with sizing CSS, this method configures
 * the default width **and** height used for all icons; unless overridden by specific CSS.
 * The default sizing is (24px, 24px).
 * @param {number=} viewBoxSize Sets the width and height of the viewBox for an icon or an icon set.
 * All icons in a set should be the same size. The default value is 24.
 *
 * @returns {obj} an `$mdIconProvider` reference; used to support method call chains for the API
 *
 * @usage
 * <hljs lang="js">
 *   app.config(function($mdIconProvider) {
    *
    *     // Configure URLs for icons specified by [set:]id.
    *
    *     $mdIconProvider
    *          .defaultViewBoxSize(36)   // Register a default icon size (width == height)
    *   });
 * </hljs>
 *
 */

var config = {
  defaultViewBoxSize: 24,
  defaultFontSet: 'material-icons',
  fontSets: []
};

function MdIconProvider() {
}

MdIconProvider.prototype = {
  icon: function(id, url, viewBoxSize) {
    if (id.indexOf(':') == -1) id = '$default:' + id;

    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  iconSet: function(id, url, viewBoxSize) {
    config[id] = new ConfigurationItem(url, viewBoxSize);
    return this;
  },

  defaultIconSet: function(url, viewBoxSize) {
    var setName = '$default';

    if (!config[setName]) {
      config[setName] = new ConfigurationItem(url, viewBoxSize);
    }

    config[setName].viewBoxSize = viewBoxSize || config.defaultViewBoxSize;

    return this;
  },

  defaultViewBoxSize: function(viewBoxSize) {
    config.defaultViewBoxSize = viewBoxSize;
    return this;
  },

  /**
   * Register an alias name associated with a font-icon library style ;
   */
  fontSet: function fontSet(alias, className) {
    config.fontSets.push({
      alias: alias,
      fontSet: className || alias
    });
    return this;
  },

  /**
   * Specify a default style name associated with a font-icon library
   * fallback to Material Icons.
   *
   */
  defaultFontSet: function defaultFontSet(className) {
    config.defaultFontSet = !className ? '' : className;
    return this;
  },

  defaultIconSize: function defaultIconSize(iconSize) {
    config.defaultIconSize = iconSize;
    return this;
  },

  $get: ['$templateRequest', '$q', '$log', '$mdUtil', '$sce', function($templateRequest, $q, $log, $mdUtil, $sce) {
    return MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce);
  }]
};

/**
 *  Configuration item stored in the Icon registry; used for lookups
 *  to load if not already cached in the `loaded` cache
 */
function ConfigurationItem(url, viewBoxSize) {
  this.url = url;
  this.viewBoxSize = viewBoxSize || config.defaultViewBoxSize;
}

/**
 * @ngdoc service
 * @name $mdIcon
 * @module material.components.icon
 *
 * @description
 * The `$mdIcon` service is a function used to lookup SVG icons.
 *
 * @param {string} id Query value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element
 * from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is
 * performed. The Id may be a unique icon ID or may include an iconSet ID prefix.
 *
 * For the **id** query to work properly, this means that all id-to-URL mappings must have been previously configured
 * using the `$mdIconProvider`.
 *
 * @returns {angular.$q.Promise} A promise that gets resolved to a clone of the initial SVG DOM element; which was
 * created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise
 * will get rejected.
 *
 * @usage
 * <hljs lang="js">
 * function SomeDirective($mdIcon) {
  *
  *   // See if the icon has already been loaded, if not
  *   // then lookup the icon from the registry cache, load and cache
  *   // it for future requests.
  *   // NOTE: ID queries require configuration with $mdIconProvider
  *
  *   $mdIcon('android').then(function(iconEl)    { element.append(iconEl); });
  *   $mdIcon('work:chair').then(function(iconEl) { element.append(iconEl); });
  *
  *   // Load and cache the external SVG using a URL
  *
  *   $mdIcon('img/icons/android.svg').then(function(iconEl) {
  *     element.append(iconEl);
  *   });
  * };
 * </hljs>
 *
 * > <b>Note:</b> The `<md-icon>` directive internally uses the `$mdIcon` service to query, loaded,
 *   and instantiate SVG DOM elements.
 */

/* ngInject */
function MdIconService(config, $templateRequest, $q, $log, $mdUtil, $sce) {
  var iconCache = {};
  var svgCache = {};
  var urlRegex = /[-\w@:%\+.~#?&//=]{2,}\.[a-z]{2,4}\b(\/[-\w@:%\+.~#?&//=]*)?/i;
  var dataUrlRegex = /^data:image\/svg\+xml[\s*;\w\-\=]*?(base64)?,(.*)$/i;

  Icon.prototype = {clone: cloneSVG, prepare: prepareAndStyle};
  getIcon.fontSet = findRegisteredFontSet;

  // Publish service...
  return getIcon;

  /**
   * Actual $mdIcon service is essentially a lookup function
   */
  function getIcon(id) {
    id = id || '';

    // If the "id" provided is not a string, the only other valid value is a $sce trust wrapper
    // over a URL string. If the value is not trusted, this will intentionally throw an error
    // because the user is attempted to use an unsafe URL, potentially opening themselves up
    // to an XSS attack.
    if (!angular.isString(id)) {
      id = $sce.getTrustedUrl(id);
    }

    // If already loaded and cached, use a clone of the cached icon.
    // Otherwise either load by URL, or lookup in the registry and then load by URL, and cache.

    if (iconCache[id]) {
      return $q.when(transformClone(iconCache[id]));
    }

    if (urlRegex.test(id) || dataUrlRegex.test(id)) {
      return loadByURL(id).then(cacheIcon(id));
    }

    if (id.indexOf(':') == -1) {
      id = '$default:' + id;
    }

    var load = config[id] ? loadByID : loadFromIconSet;
    return load(id)
      .then(cacheIcon(id));
  }

  /**
   * Lookup registered fontSet style using its alias...
   * If not found,
   */
  function findRegisteredFontSet(alias) {
    var useDefault = angular.isUndefined(alias) || !(alias && alias.length);
    if (useDefault) return config.defaultFontSet;

    var result = alias;
    angular.forEach(config.fontSets, function(it) {
      if (it.alias == alias) result = it.fontSet || result;
    });

    return result;
  }

  function transformClone(cacheElement) {
    var clone = cacheElement.clone();
    var cacheSuffix = '_cache' + $mdUtil.nextUid();

    // We need to modify for each cached icon the id attributes.
    // This is needed because SVG id's are treated as normal DOM ids
    // and should not have a duplicated id.
    if (clone.id) clone.id += cacheSuffix;
    angular.forEach(clone.querySelectorAll('[id]'), function(item) {
      item.id += cacheSuffix;
    });

    return clone;
  }

  /**
   * Prepare and cache the loaded icon for the specified `id`
   */
  function cacheIcon(id) {

    return function updateCache(icon) {
      iconCache[id] = isIcon(icon) ? icon : new Icon(icon, config[id]);

      return iconCache[id].clone();
    };
  }

  /**
   * Lookup the configuration in the registry, if !registered throw an error
   * otherwise load the icon [on-demand] using the registered URL.
   *
   */
  function loadByID(id) {
    var iconConfig = config[id];
    return loadByURL(iconConfig.url).then(function(icon) {
      return new Icon(icon, iconConfig);
    });
  }

  /**
   *    Loads the file as XML and uses querySelector( <id> ) to find
   *    the desired node...
   */
  function loadFromIconSet(id) {
    var setName = id.substring(0, id.lastIndexOf(':')) || '$default';
    var iconSetConfig = config[setName];

    return !iconSetConfig ? announceIdNotFound(id) : loadByURL(iconSetConfig.url).then(extractFromSet);

    function extractFromSet(set) {
      var iconName = id.slice(id.lastIndexOf(':') + 1);
      var icon = set.querySelector('#' + iconName);
      return icon ? new Icon(icon, iconSetConfig) : announceIdNotFound(id);
    }

    function announceIdNotFound(id) {
      var msg = 'icon ' + id + ' not found';
      $log.warn(msg);

      return $q.reject(msg || id);
    }
  }

  /**
   * Load the icon by URL (may use the $templateCache).
   * Extract the data for later conversion to Icon
   */
  function loadByURL(url) {
    /* Load the icon from embedded data URL. */
    function loadByDataUrl(url) {
      var results = dataUrlRegex.exec(url);
      var isBase64 = /base64/i.test(url);
      var data = isBase64 ? window.atob(results[2]) : results[2];

      return $q.when(angular.element(data)[0]);
    }

    /* Load the icon by URL using HTTP. */
    function loadByHttpUrl(url) {
      return $q(function(resolve, reject) {
        // Catch HTTP or generic errors not related to incorrect icon IDs.
        var announceAndReject = function(err) {
            var msg = angular.isString(err) ? err : (err.message || err.data || err.statusText);
            $log.warn(msg);
            reject(err);
          },
          extractSvg = function(response) {
            if (!svgCache[url]) {
              svgCache[url] = angular.element('<div>').append(response)[0].querySelector('svg');
            }
            resolve(svgCache[url]);
          };

        $templateRequest(url, true).then(extractSvg, announceAndReject);
      });
    }

    return dataUrlRegex.test(url)
      ? loadByDataUrl(url)
      : loadByHttpUrl(url);
  }

  /**
   * Check target signature to see if it is an Icon instance.
   */
  function isIcon(target) {
    return angular.isDefined(target.element) && angular.isDefined(target.config);
  }

  /**
   *  Define the Icon class
   */
  function Icon(el, config) {
    if (el && el.tagName != 'svg') {
      el = angular.element('<svg xmlns="http://www.w3.org/2000/svg">').append(el.cloneNode(true))[0];
    }

    // Inject the namespace if not available...
    if (!el.getAttribute('xmlns')) {
      el.setAttribute('xmlns', "http://www.w3.org/2000/svg");
    }

    this.element = el;
    this.config = config;
    this.prepare();
  }

  /**
   *  Prepare the DOM element that will be cached in the
   *  loaded iconCache store.
   */
  function prepareAndStyle() {
    var viewBoxSize = this.config ? this.config.viewBoxSize : config.defaultViewBoxSize;
    angular.forEach({
      'fit': '',
      'height': '100%',
      'width': '100%',
      'preserveAspectRatio': 'xMidYMid meet',
      'viewBox': this.element.getAttribute('viewBox') || ('0 0 ' + viewBoxSize + ' ' + viewBoxSize),
      'focusable': false // Disable IE11s default behavior to make SVGs focusable
    }, function(val, attr) {
      this.element.setAttribute(attr, val);
    }, this);
  }

  /**
   * Clone the Icon DOM element.
   */
  function cloneSVG() {
    // If the element or any of its children have a style attribute, then a CSP policy without
    // 'unsafe-inline' in the style-src directive, will result in a violation.
    return this.element.cloneNode(true);
  }

}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.list
 * @description
 * List module
 */
MdListController['$inject'] = ["$scope", "$element", "$mdListInkRipple"];
mdListDirective['$inject'] = ["$mdTheming"];
mdListItemDirective['$inject'] = ["$mdAria", "$mdConstant", "$mdUtil", "$timeout"];
angular.module('material.components.list', [
  'material.core'
])
  .controller('MdListController', MdListController)
  .directive('mdList', mdListDirective)
  .directive('mdListItem', mdListItemDirective);

/**
 * @ngdoc directive
 * @name mdList
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * The `<md-list>` directive is a list container for 1..n `<md-list-item>` tags.
 *
 * @usage
 * <hljs lang="html">
 * <md-list>
 *   <md-list-item class="md-2-line" ng-repeat="item in todos">
 *     <md-checkbox ng-model="item.done"></md-checkbox>
 *     <div class="md-list-item-text">
 *       <h3>{{item.title}}</h3>
 *       <p>{{item.description}}</p>
 *     </div>
 *   </md-list-item>
 * </md-list>
 * </hljs>
 */

function mdListDirective($mdTheming) {
  return {
    restrict: 'E',
    compile: function(tEl) {
      tEl[0].setAttribute('role', 'list');
      return $mdTheming;
    }
  };
}
/**
 * @ngdoc directive
 * @name mdListItem
 * @module material.components.list
 *
 * @restrict E
 *
 * @description
 * A `md-list-item` element can be used to represent some information in a row.<br/>
 *
 * @usage
 * ### Single Row Item
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### Multiple Lines
 * By using the following markup, you will be able to have two lines inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-2-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * It is also possible to have three lines inside of one list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-3-line">
 *     <div class="md-list-item-text" layout="column">
 *       <p>First Line</p>
 *       <p>Second Line</p>
 *       <p>Third Line</p>
 *     </div>
 *   </md-list-item>
 * </hljs>
 *
 * ### Secondary Items
 * Secondary items are elements which will be aligned at the end of the `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">
 *       Secondary Button
 *     </md-button>
 *   </md-list-item>
 * </hljs>
 *
 * It also possible to have multiple secondary items inside of one `md-list-item`.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>Single Row Item</span>
 *     <md-button class="md-secondary">First Button</md-button>
 *     <md-button class="md-secondary">Second Button</md-button>
 *   </md-list-item>
 * </hljs>
 *
 * ### Proxy Item
 * Proxies are elements, which will execute their specific action on click<br/>
 * Currently supported proxy items are
 * - `md-checkbox` (Toggle)
 * - `md-switch` (Toggle)
 * - `md-menu` (Open)
 *
 * This means, when using a supported proxy item inside of `md-list-item`, the list item will
 * automatically become clickable and executes the associated action of the proxy element on click.
 *
 * It is possible to disable this behavior by applying the `md-no-proxy` class to the list item.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-no-proxy">
 *     <span>No Proxy List</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * Here are a few examples of proxy elements inside of a list item.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-checkbox class="md-secondary"></md-checkbox>
 *   </md-list-item>
 * </hljs>
 *
 * The `md-checkbox` element will be automatically detected as a proxy element and will toggle on click.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <span>First Line</span>
 *     <md-switch class="md-secondary"></md-switch>
 *   </md-list-item>
 * </hljs>
 *
 * The recognized `md-switch` will toggle its state, when the user clicks on the `md-list-item`.
 *
 * It is also possible to have a `md-menu` inside of a `md-list-item`.
 * <hljs lang="html">
 *   <md-list-item>
 *     <p>Click anywhere to fire the secondary action</p>
 *     <md-menu class="md-secondary">
 *       <md-button class="md-icon-button">
 *         <md-icon md-svg-icon="communication:message"></md-icon>
 *       </md-button>
 *       <md-menu-content width="4">
 *         <md-menu-item>
 *           <md-button>
 *             Redial
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-item>
 *           <md-button>
 *             Check voicemail
 *           </md-button>
 *         </md-menu-item>
 *         <md-menu-divider></md-menu-divider>
 *         <md-menu-item>
 *           <md-button>
 *             Notifications
 *           </md-button>
 *         </md-menu-item>
 *       </md-menu-content>
 *     </md-menu>
 *   </md-list-item>
 * </hljs>
 *
 * The menu will automatically open, when the users clicks on the `md-list-item`.<br/>
 *
 * If the developer didn't specify any position mode on the menu, the `md-list-item` will automatically detect the
 * position mode and applies it to the `md-menu`.
 *
 * ### Avatars
 * Sometimes you may want to have some avatars inside of the `md-list-item `.<br/>
 * You are able to create a optimized icon for the list item, by applying the `.md-avatar` class on the `<img>` element.
 *
 * <hljs lang="html">
 *   <md-list-item>
 *     <img src="my-avatar.png" class="md-avatar">
 *     <span>Alan Turing</span>
 * </hljs>
 *
 * When using `<md-icon>` for an avatar, you have to use the `.md-avatar-icon` class.
 * <hljs lang="html">
 *   <md-list-item>
 *     <md-icon class="md-avatar-icon" md-svg-icon="avatars:timothy"></md-icon>
 *     <span>Timothy Kopra</span>
 *   </md-list-item>
 * </hljs>
 *
 * In cases, you have a `md-list-item`, which doesn't have any avatar,
 * but you want to align it with the other avatar items, you have to use the `.md-offset` class.
 *
 * <hljs lang="html">
 *   <md-list-item class="md-offset">
 *     <span>Jon Doe</span>
 *   </md-list-item>
 * </hljs>
 *
 * ### DOM modification
 * The `md-list-item` component automatically detects if the list item should be clickable.
 *
 * ---
 * If the `md-list-item` is clickable, we wrap all content inside of a `<div>` and create
 * an overlaying button, which will will execute the given actions (like `ng-href`, `ng-click`)
 *
 * We create an overlaying button, instead of wrapping all content inside of the button,
 * because otherwise some elements may not be clickable inside of the button.
 *
 * ---
 * When using a secondary item inside of your list item, the `md-list-item` component will automatically create
 * a secondary container at the end of the `md-list-item`, which contains all secondary items.
 *
 * The secondary item container is not static, because otherwise the overflow will not work properly on the
 * list item.
 *
 */
function mdListItemDirective($mdAria, $mdConstant, $mdUtil, $timeout) {
  var proxiedTypes = ['md-checkbox', 'md-switch', 'md-menu'];
  return {
    restrict: 'E',
    controller: 'MdListController',
    compile: function(tEl, tAttrs) {

      // Check for proxy controls (no ng-click on parent, and a control inside)
      var secondaryItems = tEl[0].querySelectorAll('.md-secondary');
      var hasProxiedElement;
      var proxyElement;
      var itemContainer = tEl;

      tEl[0].setAttribute('role', 'listitem');

      if (tAttrs.ngClick || tAttrs.ngDblclick ||  tAttrs.ngHref || tAttrs.href || tAttrs.uiSref || tAttrs.ngAttrUiSref) {
        wrapIn('button');
      } else if (!tEl.hasClass('md-no-proxy')) {

        for (var i = 0, type; type = proxiedTypes[i]; ++i) {
          if (proxyElement = tEl[0].querySelector(type)) {
            hasProxiedElement = true;
            break;
          }
        }

        if (hasProxiedElement) {
          wrapIn('div');
        } else {
          tEl.addClass('md-no-proxy');
        }

      }

      wrapSecondaryItems();
      setupToggleAria();

      if (hasProxiedElement && proxyElement.nodeName === "MD-MENU") {
        setupProxiedMenu();
      }

      function setupToggleAria() {
        var toggleTypes = ['md-switch', 'md-checkbox'];
        var toggle;

        for (var i = 0, toggleType; toggleType = toggleTypes[i]; ++i) {
          if (toggle = tEl.find(toggleType)[0]) {
            if (!toggle.hasAttribute('aria-label')) {
              var p = tEl.find('p')[0];
              if (!p) return;
              toggle.setAttribute('aria-label', 'Toggle ' + p.textContent);
            }
          }
        }
      }

      function setupProxiedMenu() {
        var menuEl = angular.element(proxyElement);

        var isEndAligned = menuEl.parent().hasClass('md-secondary-container') ||
                           proxyElement.parentNode.firstElementChild !== proxyElement;

        var xAxisPosition = 'left';

        if (isEndAligned) {
          // When the proxy item is aligned at the end of the list, we have to set the origin to the end.
          xAxisPosition = 'right';
        }

        // Set the position mode / origin of the proxied menu.
        if (!menuEl.attr('md-position-mode')) {
          menuEl.attr('md-position-mode', xAxisPosition + ' target');
        }

        // Apply menu open binding to menu button
        var menuOpenButton = menuEl.children().eq(0);
        if (!hasClickEvent(menuOpenButton[0])) {
          menuOpenButton.attr('ng-click', '$mdMenu.open($event)');
        }

        if (!menuOpenButton.attr('aria-label')) {
          menuOpenButton.attr('aria-label', 'Open List Menu');
        }
      }

      function wrapIn(type) {
        if (type == 'div') {
          itemContainer = angular.element('<div class="md-no-style md-list-item-inner">');
          itemContainer.append(tEl.contents());
          tEl.addClass('md-proxy-focus');
        } else {
          // Element which holds the default list-item content.
          itemContainer = angular.element(
            '<div class="md-button md-no-style">'+
            '   <div class="md-list-item-inner"></div>'+
            '</div>'
          );

          // Button which shows ripple and executes primary action.
          var buttonWrap = angular.element(
            '<md-button class="md-no-style"></md-button>'
          );

          copyAttributes(tEl[0], buttonWrap[0]);

          // If there is no aria-label set on the button (previously copied over if present)
          // we determine the label from the content and copy it to the button.
          if (!buttonWrap.attr('aria-label')) {
            buttonWrap.attr('aria-label', $mdAria.getText(tEl));
          }

          // We allow developers to specify the `md-no-focus` class, to disable the focus style
          // on the button executor. Once more classes should be forwarded, we should probably make the
          // class forward more generic.
          if (tEl.hasClass('md-no-focus')) {
            buttonWrap.addClass('md-no-focus');
          }

          // Append the button wrap before our list-item content, because it will overlay in relative.
          itemContainer.prepend(buttonWrap);
          itemContainer.children().eq(1).append(tEl.contents());

          tEl.addClass('_md-button-wrap');
        }

        tEl[0].setAttribute('tabindex', '-1');
        tEl.append(itemContainer);
      }

      function wrapSecondaryItems() {
        var secondaryItemsWrapper = angular.element('<div class="md-secondary-container">');

        angular.forEach(secondaryItems, function(secondaryItem) {
          wrapSecondaryItem(secondaryItem, secondaryItemsWrapper);
        });

        itemContainer.append(secondaryItemsWrapper);
      }

      function wrapSecondaryItem(secondaryItem, container) {
        // If the current secondary item is not a button, but contains a ng-click attribute,
        // the secondary item will be automatically wrapped inside of a button.
        if (secondaryItem && !isButton(secondaryItem) && secondaryItem.hasAttribute('ng-click')) {

          $mdAria.expect(secondaryItem, 'aria-label');
          var buttonWrapper = angular.element('<md-button class="md-secondary md-icon-button">');

          // Copy the attributes from the secondary item to the generated button.
          // We also support some additional attributes from the secondary item,
          // because some developers may use a ngIf, ngHide, ngShow on their item.
          copyAttributes(secondaryItem, buttonWrapper[0], ['ng-if', 'ng-hide', 'ng-show']);

          secondaryItem.setAttribute('tabindex', '-1');
          buttonWrapper.append(secondaryItem);

          secondaryItem = buttonWrapper[0];
        }

        if (secondaryItem && (!hasClickEvent(secondaryItem) || (!tAttrs.ngClick && isProxiedElement(secondaryItem)))) {
          // In this case we remove the secondary class, so we can identify it later, when we searching for the
          // proxy items.
          angular.element(secondaryItem).removeClass('md-secondary');
        }

        tEl.addClass('md-with-secondary');
        container.append(secondaryItem);
      }

      /**
       * Copies attributes from a source element to the destination element
       * By default the function will copy the most necessary attributes, supported
       * by the button executor for clickable list items.
       * @param source Element with the specified attributes
       * @param destination Element which will retrieve the attributes
       * @param extraAttrs Additional attributes, which will be copied over.
       */
      function copyAttributes(source, destination, extraAttrs) {
        var copiedAttrs = $mdUtil.prefixer([
          'ng-if', 'ng-click', 'ng-dblclick', 'aria-label', 'ng-disabled', 'ui-sref',
          'href', 'ng-href', 'target', 'ng-attr-ui-sref', 'ui-sref-opts'
        ]);

        if (extraAttrs) {
          copiedAttrs = copiedAttrs.concat($mdUtil.prefixer(extraAttrs));
        }

        angular.forEach(copiedAttrs, function(attr) {
          if (source.hasAttribute(attr)) {
            destination.setAttribute(attr, source.getAttribute(attr));
            source.removeAttribute(attr);
          }
        });
      }

      function isProxiedElement(el) {
        return proxiedTypes.indexOf(el.nodeName.toLowerCase()) != -1;
      }

      function isButton(el) {
        var nodeName = el.nodeName.toUpperCase();

        return nodeName == "MD-BUTTON" || nodeName == "BUTTON";
      }

      function hasClickEvent (element) {
        var attr = element.attributes;
        for (var i = 0; i < attr.length; i++) {
          if (tAttrs.$normalize(attr[i].name) === 'ngClick') return true;
        }
        return false;
      }

      return postLink;

      function postLink($scope, $element, $attr, ctrl) {
        $element.addClass('_md');     // private md component indicator for styling

        var proxies       = [],
            firstElement  = $element[0].firstElementChild,
            isButtonWrap  = $element.hasClass('_md-button-wrap'),
            clickChild    = isButtonWrap ? firstElement.firstElementChild : firstElement,
            hasClick      = clickChild && hasClickEvent(clickChild),
            noProxies     = $element.hasClass('md-no-proxy');

        computeProxies();
        computeClickable();

        if (proxies.length) {
          angular.forEach(proxies, function(proxy) {
            proxy = angular.element(proxy);

            $scope.mouseActive = false;
            proxy.on('mousedown', function() {
              $scope.mouseActive = true;
              $timeout(function(){
                $scope.mouseActive = false;
              }, 100);
            })
            .on('focus', function() {
              if ($scope.mouseActive === false) { $element.addClass('md-focused'); }
              proxy.on('blur', function proxyOnBlur() {
                $element.removeClass('md-focused');
                proxy.off('blur', proxyOnBlur);
              });
            });
          });
        }


        function computeProxies() {

          if (firstElement && firstElement.children && !hasClick && !noProxies) {

            angular.forEach(proxiedTypes, function(type) {

              // All elements which are not capable for being used a proxy have the .md-secondary class
              // applied. These items had been sorted out in the secondary wrap function.
              angular.forEach(firstElement.querySelectorAll(type + ':not(.md-secondary)'), function(child) {
                proxies.push(child);
              });
            });

          }
        }

        function computeClickable() {
          if (proxies.length == 1 || hasClick) {
            $element.addClass('md-clickable');

            if (!hasClick) {
              ctrl.attachRipple($scope, angular.element($element[0].querySelector('.md-no-style')));
            }
          }
        }

        function isEventFromControl(event) {
          var forbiddenControls = ['md-slider'];

          // If there is no path property in the event, then we can assume that the event was not bubbled.
          if (!event.path) {
            return forbiddenControls.indexOf(event.target.tagName.toLowerCase()) !== -1;
          }

          // We iterate the event path up and check for a possible component.
          // Our maximum index to search, is the list item root.
          var maxPath = event.path.indexOf($element.children()[0]);

          for (var i = 0; i < maxPath; i++) {
            if (forbiddenControls.indexOf(event.path[i].tagName.toLowerCase()) !== -1) {
              return true;
            }
          }
        }

        var clickChildKeypressListener = function(e) {
          if (e.target.nodeName != 'INPUT' && e.target.nodeName != 'TEXTAREA' && !e.target.isContentEditable) {
            var keyCode = e.which || e.keyCode;
            if (keyCode == $mdConstant.KEY_CODE.SPACE) {
              if (clickChild) {
                clickChild.click();
                e.preventDefault();
                e.stopPropagation();
              }
            }
          }
        };

        if (!hasClick && !proxies.length) {
          clickChild && clickChild.addEventListener('keypress', clickChildKeypressListener);
        }

        $element.off('click');
        $element.off('keypress');

        if (proxies.length == 1 && clickChild) {
          $element.children().eq(0).on('click', function(e) {
            // When the event is coming from an control and it should not trigger the proxied element
            // then we are skipping.
            if (isEventFromControl(e)) return;

            var parentButton = $mdUtil.getClosest(e.target, 'BUTTON');
            if (!parentButton && clickChild.contains(e.target)) {
              angular.forEach(proxies, function(proxy) {
                if (e.target !== proxy && !proxy.contains(e.target)) {
                  if (proxy.nodeName === 'MD-MENU') {
                    proxy = proxy.children[0];
                  }
                  angular.element(proxy).triggerHandler('click');
                }
              });
            }
          });
        }

        $scope.$on('$destroy', function () {
          clickChild && clickChild.removeEventListener('keypress', clickChildKeypressListener);
        });
      }
    }
  };
}

/*
 * @private
 * @ngdoc controller
 * @name MdListController
 * @module material.components.list
 *
 */
function MdListController($scope, $element, $mdListInkRipple) {
  var ctrl = this;
  ctrl.attachRipple = attachRipple;

  function attachRipple (scope, element) {
    var options = {};
    $mdListInkRipple.attach(scope, element, options);
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menu
 */

angular.module('material.components.menu', [
  'material.core',
  'material.components.backdrop'
]);



MenuController['$inject'] = ["$mdMenu", "$attrs", "$element", "$scope", "$mdUtil", "$timeout", "$rootScope", "$q", "$log"];
angular
    .module('material.components.menu')
    .controller('mdMenuCtrl', MenuController);

/**
 * ngInject
 */
function MenuController($mdMenu, $attrs, $element, $scope, $mdUtil, $timeout, $rootScope, $q, $log) {

  var prefixer = $mdUtil.prefixer();
  var menuContainer;
  var self = this;
  var triggerElement;

  this.nestLevel = parseInt($attrs.mdNestLevel, 10) || 0;

  /**
   * Called by our linking fn to provide access to the menu-content
   * element removed during link
   */
  this.init = function init(setMenuContainer, opts) {
    opts = opts || {};
    menuContainer = setMenuContainer;

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerElement = $element[0].querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter']));
    triggerElement.setAttribute('aria-expanded', 'false');

    this.isInMenuBar = opts.isInMenuBar;
    this.nestedMenus = $mdUtil.nodesToArray(menuContainer[0].querySelectorAll('.md-nested-menu'));

    menuContainer.on('$mdInterimElementRemove', function() {
      self.isOpen = false;
      $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    });
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var menuContainerId = 'menu_container_' + $mdUtil.nextUid();
    menuContainer.attr('id', menuContainerId);
    angular.element(triggerElement).attr({
      'aria-owns': menuContainerId,
      'aria-haspopup': 'true'
    });

    $scope.$on('$destroy', angular.bind(this, function() {
      this.disableHoverListener();
      $mdMenu.destroy();
    }));

    menuContainer.on('$destroy', function() {
      $mdMenu.destroy();
    });
  };

  var openMenuTimeout, menuItems, deregisterScopeListeners = [];
  this.enableHoverListener = function() {
    deregisterScopeListeners.push($rootScope.$on('$mdMenuOpen', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = el.controller('mdMenu');
        self.isAlreadyOpening = false;
        self.currentlyOpenMenu.registerContainerProxy(self.triggerContainerProxy.bind(self));
      }
    }));
    deregisterScopeListeners.push($rootScope.$on('$mdMenuClose', function(event, el) {
      if (menuContainer[0].contains(el[0])) {
        self.currentlyOpenMenu = undefined;
      }
    }));
    menuItems = angular.element($mdUtil.nodesToArray(menuContainer[0].children[0].children));
    menuItems.on('mouseenter', self.handleMenuItemHover);
    menuItems.on('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.disableHoverListener = function() {
    while (deregisterScopeListeners.length) {
      deregisterScopeListeners.shift()();
    }
    menuItems && menuItems.off('mouseenter', self.handleMenuItemHover);
    menuItems && menuItems.off('mouseleave', self.handleMenuItemMouseLeave);
  };

  this.handleMenuItemHover = function(event) {
    if (self.isAlreadyOpening) return;
    var nestedMenu = (
      event.target.querySelector('md-menu')
        || $mdUtil.getClosest(event.target, 'MD-MENU')
    );
    openMenuTimeout = $timeout(function() {
      if (nestedMenu) {
        nestedMenu = angular.element(nestedMenu).controller('mdMenu');
      }

      if (self.currentlyOpenMenu && self.currentlyOpenMenu != nestedMenu) {
        var closeTo = self.nestLevel + 1;
        self.currentlyOpenMenu.close(true, { closeTo: closeTo });
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      } else if (nestedMenu && !nestedMenu.isOpen && nestedMenu.open) {
        self.isAlreadyOpening = !!nestedMenu;
        nestedMenu && nestedMenu.open();
      }
    }, nestedMenu ? 100 : 250);
    var focusableTarget = event.currentTarget.querySelector('.md-button:not([disabled])');
    focusableTarget && focusableTarget.focus();
  };

  this.handleMenuItemMouseLeave = function() {
    if (openMenuTimeout) {
      $timeout.cancel(openMenuTimeout);
      openMenuTimeout = undefined;
    }
  };


  /**
   * Uses the $mdMenu interim element service to open the menu contents
   */
  this.open = function openMenu(ev) {
    ev && ev.stopPropagation();
    ev && ev.preventDefault();
    if (self.isOpen) return;
    self.enableHoverListener();
    self.isOpen = true;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});
    triggerElement = triggerElement || (ev ? ev.target : $element[0]);
    triggerElement.setAttribute('aria-expanded', 'true');
    $scope.$emit('$mdMenuOpen', $element);
    $mdMenu.show({
      scope: $scope,
      mdMenuCtrl: self,
      nestLevel: self.nestLevel,
      element: menuContainer,
      target: triggerElement,
      preserveElement: true,
      parent: 'body'
    }).finally(function() {
      triggerElement.setAttribute('aria-expanded', 'false');
      self.disableHoverListener();
    });
  };

  this.onIsOpenChanged = function(isOpen) {
    if (isOpen) {
      menuContainer.attr('aria-hidden', 'false');
      $element[0].classList.add('md-open');
      angular.forEach(self.nestedMenus, function(el) {
        el.classList.remove('md-open');
      });
    } else {
      menuContainer.attr('aria-hidden', 'true');
      $element[0].classList.remove('md-open');
    }
    $scope.$mdMenuIsOpen = self.isOpen;
  };

  this.focusMenuContainer = function focusMenuContainer() {
    var focusTarget = menuContainer[0]
      .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

    if (!focusTarget) focusTarget = menuContainer[0].querySelector('.md-button:not([disabled])');
    focusTarget.focus();
  };

  this.registerContainerProxy = function registerContainerProxy(handler) {
    this.containerProxy = handler;
  };

  this.triggerContainerProxy = function triggerContainerProxy(ev) {
    this.containerProxy && this.containerProxy(ev);
  };

  this.destroy = function() {
    return self.isOpen ? $mdMenu.destroy() : $q.when(false);
  };

  // Use the $mdMenu interim element service to close the menu contents
  this.close = function closeMenu(skipFocus, closeOpts) {
    if ( !self.isOpen ) return;
    self.isOpen = false;
    $mdUtil.nextTick(function(){ self.onIsOpenChanged(self.isOpen);});

    var eventDetails = angular.extend({}, closeOpts, { skipFocus: skipFocus });
    $scope.$emit('$mdMenuClose', $element, eventDetails);
    $mdMenu.hide(null, closeOpts);

    if (!skipFocus) {
      var el = self.restoreFocusTo || $element.find('button')[0];
      if (el instanceof angular.element) el = el[0];
      if (el) el.focus();
    }
  };

  /**
   * Build a nice object out of our string attribute which specifies the
   * target mode for left and top positioning
   */
  this.positionMode = function positionMode() {
    var attachment = ($attrs.mdPositionMode || 'target').split(' ');

    // If attachment is a single item, duplicate it for our second value.
    // ie. 'target' -> 'target target'
    if (attachment.length == 1) {
      attachment.push(attachment[0]);
    }

    return {
      left: attachment[0],
      top: attachment[1]
    };
  };

  /**
   * Build a nice object out of our string attribute which specifies
   * the offset of top and left in pixels.
   */
  this.offsets = function offsets() {
    var position = ($attrs.mdOffset || '0 0').split(' ').map(parseFloat);
    if (position.length == 2) {
      return {
        left: position[0],
        top: position[1]
      };
    } else if (position.length == 1) {
      return {
        top: position[0],
        left: position[0]
      };
    } else {
      throw Error('Invalid offsets specified. Please follow format <x, y> or <n>');
    }
  };

  // Functionality that is exposed in the view.
  $scope.$mdMenu = {
    open: this.open,
    close: this.close
  };

  // Deprecated APIs
  $scope.$mdOpenMenu = angular.bind(this, function() {
    $log.warn('mdMenu: The $mdOpenMenu method is deprecated. Please use `$mdMenu.open`.');
    return this.open.apply(this, arguments);
  });
}

/**
 * @ngdoc directive
 * @name mdMenu
 * @module material.components.menu
 * @restrict E
 * @description
 *
 * Menus are elements that open when clicked. They are useful for displaying
 * additional options within the context of an action.
 *
 * Every `md-menu` must specify exactly two child elements. The first element is what is
 * left in the DOM and is used to open the menu. This element is called the trigger element.
 * The trigger element's scope has access to `$mdMenu.open($event)`
 * which it may call to open the menu. By passing $event as argument, the
 * corresponding event is stopped from propagating up the DOM-tree. Similarly, `$mdMenu.close()`
 * can be used to close the menu.
 *
 * The second element is the `md-menu-content` element which represents the
 * contents of the menu when it is open. Typically this will contain `md-menu-item`s,
 * but you can do custom content as well.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <!-- Trigger element is a md-button with an icon -->
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open sample menu">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>

 * ## Sizing Menus
 *
 * The width of the menu when it is open may be specified by specifying a `width`
 * attribute on the `md-menu-content` element.
 * See the [Material Design Spec](https://material.google.com/components/menus.html#menus-simple-menus)
 * for more information.
 *
 *
 * ## Aligning Menus
 *
 * When a menu opens, it is important that the content aligns with the trigger element.
 * Failure to align menus can result in jarring experiences for users as content
 * suddenly shifts. To help with this, `md-menu` provides serveral APIs to help
 * with alignment.
 *
 * ### Target Mode
 *
 * By default, `md-menu` will attempt to align the `md-menu-content` by aligning
 * designated child elements in both the trigger and the menu content.
 *
 * To specify the alignment element in the `trigger` you can use the `md-menu-origin`
 * attribute on a child element. If no `md-menu-origin` is specified, the `md-menu`
 * will be used as the origin element.
 *
 * Similarly, the `md-menu-content` may specify a `md-menu-align-target` for a
 * `md-menu-item` to specify the node that it should try and align with.
 *
 * In this example code, we specify an icon to be our origin element, and an
 * icon in our menu content to be our alignment target. This ensures that both
 * icons are aligned when the menu opens.
 *
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button" aria-label="Open some menu">
 *    <md-icon md-menu-origin md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item>
 *      <md-button ng-click="doSomething()" aria-label="Do something">
 *        <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *        Do Something
 *      </md-button>
 *    </md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * Sometimes we want to specify alignment on the right side of an element, for example
 * if we have a menu on the right side a toolbar, we want to right align our menu content.
 *
 * We can specify the origin by using the `md-position-mode` attribute on both
 * the `x` and `y` axis. Right now only the `x-axis` has more than one option.
 * You may specify the default mode of `target target` or
 * `target-right target` to specify a right-oriented alignment target. See the
 * position section of the demos for more examples.
 *
 * ### Menu Offsets
 *
 * It is sometimes unavoidable to need to have a deeper level of control for
 * the positioning of a menu to ensure perfect alignment. `md-menu` provides
 * the `md-offset` attribute to allow pixel level specificty of adjusting the
 * exact positioning.
 *
 * This offset is provided in the format of `x y` or `n` where `n` will be used
 * in both the `x` and `y` axis.
 *
 * For example, to move a menu by `2px` down from the top, we can use:
 * <hljs lang="html">
 * <md-menu md-offset="0 2">
 *   <!-- menu-content -->
 * </md-menu>
 * </hljs>
 *
 * ### Auto Focus
 * By default, when a menu opens, `md-menu` focuses the first button in the menu content.
 *
 * But sometimes you would like to focus another specific menu item instead of the first.<br/>
 * This can be done by applying the `md-autofocus` directive on the given element.
 *
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-button md-autofocus ng-click="doSomething()">
 *     Auto Focus
 *   </md-button>
 * </md-menu-item>
 * </hljs>
 *
 *
 * ### Preventing close
 *
 * Sometimes you would like to be able to click on a menu item without having the menu
 * close. To do this, ngMaterial exposes the `md-prevent-menu-close` attribute which
 * can be added to a button inside a menu to stop the menu from automatically closing.
 * You can then close the menu either by using `$mdMenu.close()` in the template,
 * or programatically by injecting `$mdMenu` and calling `$mdMenu.hide()`.
 *
 * <hljs lang="html">
 * <md-menu-content ng-mouseleave="$mdMenu.close()">
 *   <md-menu-item>
 *     <md-button ng-click="doSomething()" aria-label="Do something" md-prevent-menu-close="md-prevent-menu-close">
 *       <md-icon md-menu-align-target md-svg-icon="call:phone"></md-icon>
 *       Do Something
 *     </md-button>
 *   </md-menu-item>
 * </md-menu-content>
 * </hljs>
 *
 * @usage
 * <hljs lang="html">
 * <md-menu>
 *  <md-button ng-click="$mdMenu.open($event)" class="md-icon-button">
 *    <md-icon md-svg-icon="call:phone"></md-icon>
 *  </md-button>
 *  <md-menu-content>
 *    <md-menu-item><md-button ng-click="doSomething()">Do Something</md-button></md-menu-item>
 *  </md-menu-content>
 * </md-menu>
 * </hljs>
 *
 * @param {string} md-position-mode The position mode in the form of
 *           `x`, `y`. Default value is `target`,`target`. Right now the `x` axis
 *           also supports `target-right`.
 * @param {string} md-offset An offset to apply to the dropdown after positioning
 *           `x`, `y`. Default value is `0`,`0`.
 *
 */

MenuDirective['$inject'] = ["$mdUtil"];
angular
    .module('material.components.menu')
    .directive('mdMenu', MenuDirective);

/**
 * ngInject
 */
function MenuDirective($mdUtil) {
  var INVALID_PREFIX = 'Invalid HTML for md-menu: ';
  return {
    restrict: 'E',
    require: ['mdMenu', '?^mdMenuBar'],
    controller: 'mdMenuCtrl', // empty function to be built by link
    scope: true,
    compile: compile
  };

  function compile(templateElement) {
    templateElement.addClass('md-menu');

    var triggerEl = templateElement.children()[0];
    var contentEl = templateElement.children()[1];

    var prefixer = $mdUtil.prefixer();

    if (!prefixer.hasAttribute(triggerEl, 'ng-click')) {
      triggerEl = triggerEl
          .querySelector(prefixer.buildSelector(['ng-click', 'ng-mouseenter'])) || triggerEl;
    }

    var isButtonTrigger = triggerEl.nodeName === 'MD-BUTTON' || triggerEl.nodeName === 'BUTTON';

    if (triggerEl && isButtonTrigger && !triggerEl.hasAttribute('type')) {
      triggerEl.setAttribute('type', 'button');
    }

    if (!triggerEl) {
      throw Error(INVALID_PREFIX + 'Expected the menu to have a trigger element.');
    }

    if (!contentEl || contentEl.nodeName !== 'MD-MENU-CONTENT') {
      throw Error(INVALID_PREFIX + 'Expected the menu to contain a `md-menu-content` element.');
    }

    // Default element for ARIA attributes has the ngClick or ngMouseenter expression
    triggerEl && triggerEl.setAttribute('aria-haspopup', 'true');

    var nestedMenus = templateElement[0].querySelectorAll('md-menu');
    var nestingDepth = parseInt(templateElement[0].getAttribute('md-nest-level'), 10) || 0;
    if (nestedMenus) {
      angular.forEach($mdUtil.nodesToArray(nestedMenus), function(menuEl) {
        if (!menuEl.hasAttribute('md-position-mode')) {
          menuEl.setAttribute('md-position-mode', 'cascade');
        }
        menuEl.classList.add('_md-nested-menu');
        menuEl.setAttribute('md-nest-level', nestingDepth + 1);
      });
    }
    return link;
  }

  function link(scope, element, attr, ctrls) {
    var mdMenuCtrl = ctrls[0];
    var isInMenuBar = !!ctrls[1];
    // Move everything into a md-menu-container and pass it to the controller
    var menuContainer = angular.element( '<div class="_md md-open-menu-container md-whiteframe-z2"></div>');
    var menuContents = element.children()[1];

    element.addClass('_md');     // private md component indicator for styling

    if (!menuContents.hasAttribute('role')) {
      menuContents.setAttribute('role', 'menu');
    }
    menuContainer.append(menuContents);

    element.on('$destroy', function() {
      menuContainer.remove();
    });

    element.append(menuContainer);
    menuContainer[0].style.display = 'none';
    mdMenuCtrl.init(menuContainer, { isInMenuBar: isInMenuBar });

  }
}


MenuProvider['$inject'] = ["$$interimElementProvider"];angular
  .module('material.components.menu')
  .provider('$mdMenu', MenuProvider);

/*
 * Interim element provider for the menu.
 * Handles behavior for a menu while it is open, including:
 *    - handling animating the menu opening/closing
 *    - handling key/mouse events on the menu element
 *    - handling enabling/disabling scroll while the menu is open
 *    - handling redrawing during resizes and orientation changes
 *
 */

function MenuProvider($$interimElementProvider) {
  menuDefaultOptions['$inject'] = ["$mdUtil", "$mdTheming", "$mdConstant", "$document", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$log"];
  var MENU_EDGE_MARGIN = 8;

  return $$interimElementProvider('$mdMenu')
    .setDefaults({
      methods: ['target'],
      options: menuDefaultOptions
    });

  /* ngInject */
  function menuDefaultOptions($mdUtil, $mdTheming, $mdConstant, $document, $window, $q, $$rAF,
                              $animateCss, $animate, $log) {

    var prefixer = $mdUtil.prefixer();
    var animator = $mdUtil.dom.animator;

    return {
      parent: 'body',
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true,
      skipCompile: true,
      preserveScope: true,
      multiple: true,
      themable: true
    };

    /**
     * Show modal backdrop element...
     * @returns {function(): void} A function that removes this backdrop
     */
    function showBackdrop(scope, element, options) {
      if (options.nestLevel) return angular.noop;

      // If we are not within a dialog...
      if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
        // !! DO this before creating the backdrop; since disableScrollAround()
        //    configures the scroll offset; which is used by mdBackDrop postLink()
        options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
      } else {
        options.disableParentScroll = false;
      }

      if (options.hasBackdrop) {
        options.backdrop = $mdUtil.createBackdrop(scope, "md-menu-backdrop md-click-catcher");

        $animate.enter(options.backdrop, $document[0].body);
      }

      /**
       * Hide and destroys the backdrop created by showBackdrop()
       */
      return function hideBackdrop() {
        if (options.backdrop) options.backdrop.remove();
        if (options.disableParentScroll) options.restoreScroll();
      };
    }

    /**
     * Removing the menu element from the DOM and remove all associated event listeners
     * and backdrop
     */
    function onRemove(scope, element, opts) {
      opts.cleanupInteraction();
      opts.cleanupBackdrop();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // Before the menu is closing remove the clickable class.
      element.removeClass('md-clickable');

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal

      return (opts.$destroy === true) ? detachAndClean() : animateRemoval().then( detachAndClean );

      /**
       * For normal closes, animate the removal.
       * For forced closes (like $destroy events), skip the animations
       */
      function animateRemoval() {
        return $animateCss(element, {addClass: 'md-leave'}).start();
      }

      /**
       * Detach the element
       */
      function detachAndClean() {
        element.removeClass('md-active');
        detachElement(element, opts);
        opts.alreadyOpen = false;
      }

    }

    /**
     * Inserts and configures the staged Menu element into the DOM, positioning it,
     * and wiring up various interaction events
     */
    function onShow(scope, element, opts) {
      sanitizeAndConfigure(opts);

      if (opts.menuContentEl[0]) {
        // Inherit the theme from the target element.
        $mdTheming.inherit(opts.menuContentEl, opts.target);
      } else {
        $log.warn(
          '$mdMenu: Menu elements should always contain a `md-menu-content` element,' +
          'otherwise interactivity features will not work properly.',
          element
        );
      }
      
      // Register various listeners to move menu on resize/orientation change
      opts.cleanupResizing = startRepositioningOnResize();
      opts.hideBackdrop = showBackdrop(scope, element, opts);

      // Return the promise for when our menu is done animating in
      return showMenu()
        .then(function(response) {
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupBackdrop = setupBackdrop();

          // Since the menu finished its animation, mark the menu as clickable.
          element.addClass('md-clickable');

          return response;
        });

      /**
       * Place the menu into the DOM and call positioning related functions
       */
      function showMenu() {
        opts.parent.append(element);
        element[0].style.display = '';

        return $q(function(resolve) {
          var position = calculateMenuPosition(element, opts);

          element.removeClass('md-leave');

          // Animate the menu scaling, and opacity [from its position origin (default == top-left)]
          // to normal scale.
          $animateCss(element, {
            addClass: 'md-active',
            from: animator.toCss(position),
            to: animator.toCss({transform: ''})
          })
          .start()
          .then(resolve);

        });
      }

      /**
       * Check for valid opts and set some sane defaults
       */
      function sanitizeAndConfigure() {
        if (!opts.target) {
          throw Error(
            '$mdMenu.show() expected a target to animate from in options.target'
          );
        }
        angular.extend(opts, {
          alreadyOpen: false,
          isRemoved: false,
          target: angular.element(opts.target), //make sure it's not a naked dom node
          parent: angular.element(opts.parent),
          menuContentEl: angular.element(element[0].querySelector('md-menu-content'))
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function startRepositioningOnResize() {

        var repositionMenu = (function(target, options) {
          return $$rAF.throttle(function() {
            if (opts.isRemoved) return;
            var position = calculateMenuPosition(target, options);

            target.css(animator.toCss(position));
          });
        })(element, opts);

        $window.addEventListener('resize', repositionMenu);
        $window.addEventListener('orientationchange', repositionMenu);

        return function stopRepositioningOnResize() {

          // Disable resizing handlers
          $window.removeEventListener('resize', repositionMenu);
          $window.removeEventListener('orientationchange', repositionMenu);

        };
      }

      /**
       * Sets up the backdrop and listens for click elements.
       * Once the backdrop will be clicked, the menu will automatically close.
       * @returns {!Function} Function to remove the backdrop.
       */
      function setupBackdrop() {
        if (!opts.backdrop) return angular.noop;

        opts.backdrop.on('click', onBackdropClick);

        return function() {
          opts.backdrop.off('click', onBackdropClick);
        }
      }

      /**
       * Function to be called whenever the backdrop is clicked.
       * @param {!MouseEvent} event
       */
      function onBackdropClick(event) {
        event.preventDefault();
        event.stopPropagation();

        scope.$apply(function() {
          opts.mdMenuCtrl.close(true, { closeAll: true });
        });
      }

      /**
       * Activate interaction on the menu. Resolves the focus target and closes the menu on
       * escape or option click.
       * @returns {!Function} Function to deactivate the interaction listeners.
       */
      function activateInteraction() {
        if (!opts.menuContentEl[0]) return angular.noop;

        // Wire up keyboard listeners.
        // - Close on escape,
        // - focus next item on down arrow,
        // - focus prev item on up
        opts.menuContentEl.on('keydown', onMenuKeyDown);
        opts.menuContentEl[0].addEventListener('click', captureClickListener, true);

        // kick off initial focus in the menu on the first enabled element
        var focusTarget = opts.menuContentEl[0]
          .querySelector(prefixer.buildSelector(['md-menu-focus-target', 'md-autofocus']));

        if ( !focusTarget ) {
          var childrenLen = opts.menuContentEl[0].children.length;
          for(var childIndex = 0; childIndex < childrenLen; childIndex++) {
            var child = opts.menuContentEl[0].children[childIndex];
            focusTarget = child.querySelector('.md-button:not([disabled])');
            if (focusTarget) {
              break;
            }
            if (child.firstElementChild && !child.firstElementChild.disabled) {
              focusTarget = child.firstElementChild;
              break;
            }
          }
        }

        focusTarget && focusTarget.focus();

        return function cleanupInteraction() {
          opts.menuContentEl.off('keydown', onMenuKeyDown);
          opts.menuContentEl[0].removeEventListener('click', captureClickListener, true);
        };

        // ************************************
        // internal functions
        // ************************************

        function onMenuKeyDown(ev) {
          var handled;
          switch (ev.keyCode) {
            case $mdConstant.KEY_CODE.ESCAPE:
              opts.mdMenuCtrl.close(false, { closeAll: true });
              handled = true;
              break;
            case $mdConstant.KEY_CODE.UP_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, -1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.DOWN_ARROW:
              if (!focusMenuItem(ev, opts.menuContentEl, opts, 1) && !opts.nestLevel) {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.LEFT_ARROW:
              if (opts.nestLevel) {
                opts.mdMenuCtrl.close();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
            case $mdConstant.KEY_CODE.RIGHT_ARROW:
              var parentMenu = $mdUtil.getClosest(ev.target, 'MD-MENU');
              if (parentMenu && parentMenu != opts.parent[0]) {
                ev.target.click();
              } else {
                opts.mdMenuCtrl.triggerContainerProxy(ev);
              }
              handled = true;
              break;
          }
          if (handled) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
          }
        }

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          scope.$apply(function() {
            opts.mdMenuCtrl.close(true, { closeAll: true });
          });
        }

        // Close menu on menu item click, if said menu-item is not disabled
        function captureClickListener(e) {
          var target = e.target;
          // Traverse up the event until we get to the menuContentEl to see if
          // there is an ng-click and that the ng-click is not disabled
          do {
            if (target == opts.menuContentEl[0]) return;
            if ((hasAnyAttribute(target, ['ng-click', 'ng-href', 'ui-sref']) ||
                target.nodeName == 'BUTTON' || target.nodeName == 'MD-BUTTON') && !hasAnyAttribute(target, ['md-prevent-menu-close'])) {
              var closestMenu = $mdUtil.getClosest(target, 'MD-MENU');
              if (!target.hasAttribute('disabled') && (!closestMenu || closestMenu == opts.parent[0])) {
                close();
              }
              break;
            }
          } while (target = target.parentNode);

          function close() {
            scope.$apply(function() {
              opts.mdMenuCtrl.close(true, { closeAll: true });
            });
          }

          function hasAnyAttribute(target, attrs) {
            if (!target) return false;

            for (var i = 0, attr; attr = attrs[i]; ++i) {
              if (prefixer.hasAttribute(target, attr)) {
                return true;
              }
            }

            return false;
          }
        }

      }
    }

    /**
     * Takes a keypress event and focuses the next/previous menu
     * item from the emitting element
     * @param {event} e - The origin keypress event
     * @param {angular.element} menuEl - The menu element
     * @param {object} opts - The interim element options for the mdMenu
     * @param {number} direction - The direction to move in (+1 = next, -1 = prev)
     */
    function focusMenuItem(e, menuEl, opts, direction) {
      var currentItem = $mdUtil.getClosest(e.target, 'MD-MENU-ITEM');

      var items = $mdUtil.nodesToArray(menuEl[0].children);
      var currentIndex = items.indexOf(currentItem);

      // Traverse through our elements in the specified direction (+/-1) and try to
      // focus them until we find one that accepts focus
      var didFocus;
      for (var i = currentIndex + direction; i >= 0 && i < items.length; i = i + direction) {
        var focusTarget = items[i].querySelector('.md-button');
        didFocus = attemptFocus(focusTarget);
        if (didFocus) {
          break;
        }
      }
      return didFocus;
    }

    /**
     * Attempts to focus an element. Checks whether that element is the currently
     * focused element after attempting.
     * @param {HTMLElement} el - the element to attempt focus on
     * @returns {bool} - whether the element was successfully focused
     */
    function attemptFocus(el) {
      if (el && el.getAttribute('tabindex') != -1) {
        el.focus();
        return ($document[0].activeElement == el);
      }
    }

    /**
     * Use browser to remove this element without triggering a $destroy event
     */
    function detachElement(element, opts) {
      if (!opts.preserveElement) {
        if (toNode(element).parentNode === toNode(opts.parent)) {
          toNode(opts.parent).removeChild(toNode(element));
        }
      } else {
        toNode(element).style.display = 'none';
      }
    }

    /**
     * Computes menu position and sets the style on the menu container
     * @param {HTMLElement} el - the menu container element
     * @param {object} opts - the interim element options object
     */
    function calculateMenuPosition(el, opts) {

      var containerNode = el[0],
        openMenuNode = el[0].firstElementChild,
        openMenuNodeRect = openMenuNode.getBoundingClientRect(),
        boundryNode = $document[0].body,
        boundryNodeRect = boundryNode.getBoundingClientRect();

      var menuStyle = $window.getComputedStyle(openMenuNode);

      var originNode = opts.target[0].querySelector(prefixer.buildSelector('md-menu-origin')) || opts.target[0],
        originNodeRect = originNode.getBoundingClientRect();

      var bounds = {
        left: boundryNodeRect.left + MENU_EDGE_MARGIN,
        top: Math.max(boundryNodeRect.top, 0) + MENU_EDGE_MARGIN,
        bottom: Math.max(boundryNodeRect.bottom, Math.max(boundryNodeRect.top, 0) + boundryNodeRect.height) - MENU_EDGE_MARGIN,
        right: boundryNodeRect.right - MENU_EDGE_MARGIN
      };

      var alignTarget, alignTargetRect = { top:0, left : 0, right:0, bottom:0 }, existingOffsets  = { top:0, left : 0, right:0, bottom:0  };
      var positionMode = opts.mdMenuCtrl.positionMode();

      if (positionMode.top == 'target' || positionMode.left == 'target' || positionMode.left == 'target-right') {
        alignTarget = firstVisibleChild();
        if ( alignTarget ) {
          // TODO: Allow centering on an arbitrary node, for now center on first menu-item's child
          alignTarget = alignTarget.firstElementChild || alignTarget;
          alignTarget = alignTarget.querySelector(prefixer.buildSelector('md-menu-align-target')) || alignTarget;
          alignTargetRect = alignTarget.getBoundingClientRect();

          existingOffsets = {
            top: parseFloat(containerNode.style.top || 0),
            left: parseFloat(containerNode.style.left || 0)
          };
        }
      }

      var position = {};
      var transformOrigin = 'top ';

      switch (positionMode.top) {
        case 'target':
          position.top = existingOffsets.top + originNodeRect.top - alignTargetRect.top;
          break;
        case 'cascade':
          position.top = originNodeRect.top - parseFloat(menuStyle.paddingTop) - originNode.style.top;
          break;
        case 'bottom':
          position.top = originNodeRect.top + originNodeRect.height;
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.top + '" specified for md-menu on Y axis.');
      }

      var rtl = ($mdUtil.bidi() == 'rtl');

      switch (positionMode.left) {
        case 'target':
          position.left = existingOffsets.left + originNodeRect.left - alignTargetRect.left;
          transformOrigin += rtl ? 'right'  : 'left';
          break;
        case 'target-left':
          position.left = originNodeRect.left;
          transformOrigin += 'left';
          break;
        case 'target-right':
          position.left = originNodeRect.right - openMenuNodeRect.width + (openMenuNodeRect.right - alignTargetRect.right);
          transformOrigin += 'right';
          break;
        case 'cascade':
          var willFitRight = rtl ? (originNodeRect.left - openMenuNodeRect.width) < bounds.left : (originNodeRect.right + openMenuNodeRect.width) < bounds.right;
          position.left = willFitRight ? originNodeRect.right - originNode.style.left : originNodeRect.left - originNode.style.left - openMenuNodeRect.width;
          transformOrigin += willFitRight ? 'left' : 'right';
          break;
        case 'right':
          if (rtl) {
            position.left = originNodeRect.right - originNodeRect.width;
            transformOrigin += 'left';
          } else {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          }
          break;
        case 'left':
          if (rtl) {
            position.left = originNodeRect.right - openMenuNodeRect.width;
            transformOrigin += 'right';
          } else {
            position.left = originNodeRect.left;
            transformOrigin += 'left';
          }
          break;
        default:
          throw new Error('Invalid target mode "' + positionMode.left + '" specified for md-menu on X axis.');
      }

      var offsets = opts.mdMenuCtrl.offsets();
      position.top += offsets.top;
      position.left += offsets.left;

      clamp(position);

      var scaleX = Math.round(100 * Math.min(originNodeRect.width / containerNode.offsetWidth, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(originNodeRect.height / containerNode.offsetHeight, 1.0)) / 100;

      return {
        top: Math.round(position.top),
        left: Math.round(position.left),
        // Animate a scale out if we aren't just repositioning
        transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : undefined,
        transformOrigin: transformOrigin
      };

      /**
       * Clamps the repositioning of the menu within the confines of
       * bounding element (often the screen/body)
       */
      function clamp(pos) {
        pos.top = Math.max(Math.min(pos.top, bounds.bottom - containerNode.offsetHeight), bounds.top);
        pos.left = Math.max(Math.min(pos.left, bounds.right - containerNode.offsetWidth), bounds.left);
      }

      /**
       * Gets the first visible child in the openMenuNode
       * Necessary incase menu nodes are being dynamically hidden
       */
      function firstVisibleChild() {
        for (var i = 0; i < openMenuNode.children.length; ++i) {
          if ($window.getComputedStyle(openMenuNode.children[i]).display != 'none') {
            return openMenuNode.children[i];
          }
        }
      }
    }
  }
  function toNode(el) {
    if (el instanceof angular.element) {
      el = el[0];
    }
    return el;
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.menuBar
 */

angular.module('material.components.menuBar', [
  'material.core',
  'material.components.icon',
  'material.components.menu'
]);


MenuBarController['$inject'] = ["$scope", "$rootScope", "$element", "$attrs", "$mdConstant", "$document", "$mdUtil", "$timeout"];
angular
  .module('material.components.menuBar')
  .controller('MenuBarController', MenuBarController);

var BOUND_MENU_METHODS = ['handleKeyDown', 'handleMenuHover', 'scheduleOpenHoveredMenu', 'cancelScheduledOpen'];

/**
 * ngInject
 */
function MenuBarController($scope, $rootScope, $element, $attrs, $mdConstant, $document, $mdUtil, $timeout) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$mdConstant = $mdConstant;
  this.$mdUtil = $mdUtil;
  this.$document = $document;
  this.$scope = $scope;
  this.$rootScope = $rootScope;
  this.$timeout = $timeout;

  var self = this;
  angular.forEach(BOUND_MENU_METHODS, function(methodName) {
    self[methodName] = angular.bind(self, self[methodName]);
  });
}

MenuBarController.prototype.init = function() {
  var $element = this.$element;
  var $mdUtil = this.$mdUtil;
  var $scope = this.$scope;

  var self = this;
  var deregisterFns = [];
  $element.on('keydown', this.handleKeyDown);
  this.parentToolbar = $mdUtil.getClosest($element, 'MD-TOOLBAR');

  deregisterFns.push(this.$rootScope.$on('$mdMenuOpen', function(event, el) {
    if (self.getMenus().indexOf(el[0]) != -1) {
      $element[0].classList.add('md-open');
      el[0].classList.add('md-open');
      self.currentlyOpenMenu = el.controller('mdMenu');
      self.currentlyOpenMenu.registerContainerProxy(self.handleKeyDown);
      self.enableOpenOnHover();
    }
  }));

  deregisterFns.push(this.$rootScope.$on('$mdMenuClose', function(event, el, opts) {
    var rootMenus = self.getMenus();
    if (rootMenus.indexOf(el[0]) != -1) {
      $element[0].classList.remove('md-open');
      el[0].classList.remove('md-open');
    }

    if ($element[0].contains(el[0])) {
      var parentMenu = el[0];
      while (parentMenu && rootMenus.indexOf(parentMenu) == -1) {
        parentMenu = $mdUtil.getClosest(parentMenu, 'MD-MENU', true);
      }
      if (parentMenu) {
        if (!opts.skipFocus) parentMenu.querySelector('button:not([disabled])').focus();
        self.currentlyOpenMenu = undefined;
        self.disableOpenOnHover();
        self.setKeyboardMode(true);
      }
    }
  }));

  $scope.$on('$destroy', function() {
    self.disableOpenOnHover();
    while (deregisterFns.length) {
      deregisterFns.shift()();
    }
  });


  this.setKeyboardMode(true);
};

MenuBarController.prototype.setKeyboardMode = function(enabled) {
  if (enabled) this.$element[0].classList.add('md-keyboard-mode');
  else this.$element[0].classList.remove('md-keyboard-mode');
};

MenuBarController.prototype.enableOpenOnHover = function() {
  if (this.openOnHoverEnabled) return;

  var self = this;

  self.openOnHoverEnabled = true;

  if (self.parentToolbar) {
    self.parentToolbar.classList.add('md-has-open-menu');

    // Needs to be on the next tick so it doesn't close immediately.
    self.$mdUtil.nextTick(function() {
      angular.element(self.parentToolbar).on('click', self.handleParentClick);
    }, false);
  }

  angular
    .element(self.getMenus())
    .on('mouseenter', self.handleMenuHover);
};

MenuBarController.prototype.handleMenuHover = function(e) {
  this.setKeyboardMode(false);
  if (this.openOnHoverEnabled) {
    this.scheduleOpenHoveredMenu(e);
  }
};

MenuBarController.prototype.disableOpenOnHover = function() {
  if (!this.openOnHoverEnabled) return;

  this.openOnHoverEnabled = false;

  if (this.parentToolbar) {
    this.parentToolbar.classList.remove('md-has-open-menu');
    angular.element(this.parentToolbar).off('click', this.handleParentClick);
  }

  angular
    .element(this.getMenus())
    .off('mouseenter', this.handleMenuHover);
};

MenuBarController.prototype.scheduleOpenHoveredMenu = function(e) {
  var menuEl = angular.element(e.currentTarget);
  var menuCtrl = menuEl.controller('mdMenu');
  this.setKeyboardMode(false);
  this.scheduleOpenMenu(menuCtrl);
};

MenuBarController.prototype.scheduleOpenMenu = function(menuCtrl) {
  var self = this;
  var $timeout = this.$timeout;
  if (menuCtrl != self.currentlyOpenMenu) {
    $timeout.cancel(self.pendingMenuOpen);
    self.pendingMenuOpen = $timeout(function() {
      self.pendingMenuOpen = undefined;
      if (self.currentlyOpenMenu) {
        self.currentlyOpenMenu.close(true, { closeAll: true });
      }
      menuCtrl.open();
    }, 200, false);
  }
};

MenuBarController.prototype.handleKeyDown = function(e) {
  var keyCodes = this.$mdConstant.KEY_CODE;
  var currentMenu = this.currentlyOpenMenu;
  var wasOpen = currentMenu && currentMenu.isOpen;
  this.setKeyboardMode(true);
  var handled, newMenu, newMenuCtrl;
  switch (e.keyCode) {
    case keyCodes.DOWN_ARROW:
      if (currentMenu) {
        currentMenu.focusMenuContainer();
      } else {
        this.openFocusedMenu();
      }
      handled = true;
      break;
    case keyCodes.UP_ARROW:
      currentMenu && currentMenu.close();
      handled = true;
      break;
    case keyCodes.LEFT_ARROW:
      newMenu = this.focusMenu(-1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
    case keyCodes.RIGHT_ARROW:
      newMenu = this.focusMenu(+1);
      if (wasOpen) {
        newMenuCtrl = angular.element(newMenu).controller('mdMenu');
        this.scheduleOpenMenu(newMenuCtrl);
      }
      handled = true;
      break;
  }
  if (handled) {
    e && e.preventDefault && e.preventDefault();
    e && e.stopImmediatePropagation && e.stopImmediatePropagation();
  }
};

MenuBarController.prototype.focusMenu = function(direction) {
  var menus = this.getMenus();
  var focusedIndex = this.getFocusedMenuIndex();

  if (focusedIndex == -1) { focusedIndex = this.getOpenMenuIndex(); }

  var changed = false;

  if (focusedIndex == -1) { focusedIndex = 0; changed = true; }
  else if (
    direction < 0 && focusedIndex > 0 ||
    direction > 0 && focusedIndex < menus.length - direction
  ) {
    focusedIndex += direction;
    changed = true;
  }
  if (changed) {
    menus[focusedIndex].querySelector('button').focus();
    return menus[focusedIndex];
  }
};

MenuBarController.prototype.openFocusedMenu = function() {
  var menu = this.getFocusedMenu();
  menu && angular.element(menu).controller('mdMenu').open();
};

MenuBarController.prototype.getMenus = function() {
  var $element = this.$element;
  return this.$mdUtil.nodesToArray($element[0].children)
    .filter(function(el) { return el.nodeName == 'MD-MENU'; });
};

MenuBarController.prototype.getFocusedMenu = function() {
  return this.getMenus()[this.getFocusedMenuIndex()];
};

MenuBarController.prototype.getFocusedMenuIndex = function() {
  var $mdUtil = this.$mdUtil;
  var focusedEl = $mdUtil.getClosest(
    this.$document[0].activeElement,
    'MD-MENU'
  );
  if (!focusedEl) return -1;

  var focusedIndex = this.getMenus().indexOf(focusedEl);
  return focusedIndex;
};

MenuBarController.prototype.getOpenMenuIndex = function() {
  var menus = this.getMenus();
  for (var i = 0; i < menus.length; ++i) {
    if (menus[i].classList.contains('md-open')) return i;
  }
  return -1;
};

MenuBarController.prototype.handleParentClick = function(event) {
  var openMenu = this.querySelector('md-menu.md-open');

  if (openMenu && !openMenu.contains(event.target)) {
    angular.element(openMenu).controller('mdMenu').close(true, {
      closeAll: true
    });
  }
};

/**
 * @ngdoc directive
 * @name mdMenuBar
 * @module material.components.menuBar
 * @restrict E
 * @description
 *
 * Menu bars are containers that hold multiple menus. They change the behavior and appearence
 * of the `md-menu` directive to behave similar to an operating system provided menu.
 *
 * @usage
 * <hljs lang="html">
 * <md-menu-bar>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">
 *       File
 *     </button>
 *     <md-menu-content>
 *       <md-menu-item>
 *         <md-button ng-click="ctrl.sampleAction('share', $event)">
 *           Share...
 *         </md-button>
 *       </md-menu-item>
 *       <md-menu-divider></md-menu-divider>
 *       <md-menu-item>
 *       <md-menu-item>
 *         <md-menu>
 *           <md-button ng-click="$mdMenu.open()">New</md-button>
 *           <md-menu-content>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *             <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *           </md-menu-content>
 *         </md-menu>
 *       </md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 * ## Menu Bar Controls
 *
 * You may place `md-menu-items` that function as controls within menu bars.
 * There are two modes that are exposed via the `type` attribute of the `md-menu-item`.
 * `type="checkbox"` will function as a boolean control for the `ng-model` attribute of the
 * `md-menu-item`. `type="radio"` will function like a radio button, setting the `ngModel`
 * to the `string` value of the `value` attribute. If you need non-string values, you can use
 * `ng-value` to provide an expression (this is similar to how angular's native `input[type=radio]` works.
 *
 * <hljs lang="html">
 * <md-menu-bar>
 *  <md-menu>
 *    <button ng-click="$mdMenu.open()">
 *      Sample Menu
 *    </button>
 *    <md-menu-content>
 *      <md-menu-item type="checkbox" ng-model="settings.allowChanges">Allow changes</md-menu-item>
 *      <md-menu-divider></md-menu-divider>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 1</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 2</md-menu-item>
 *      <md-menu-item type="radio" ng-model="settings.mode" ng-value="1">Mode 3</md-menu-item>
 *    </md-menu-content>
 *  </md-menu>
 * </md-menu-bar>
 * </hljs>
 *
 *
 * ### Nesting Menus
 *
 * Menus may be nested within menu bars. This is commonly called cascading menus.
 * To nest a menu place the nested menu inside the content of the `md-menu-item`.
 * <hljs lang="html">
 * <md-menu-item>
 *   <md-menu>
 *     <button ng-click="$mdMenu.open()">New</md-button>
 *     <md-menu-content>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Document', $event)">Document</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Spreadsheet', $event)">Spreadsheet</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Presentation', $event)">Presentation</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Form', $event)">Form</md-button></md-menu-item>
 *       <md-menu-item><md-button ng-click="ctrl.sampleAction('New Drawing', $event)">Drawing</md-button></md-menu-item>
 *     </md-menu-content>
 *   </md-menu>
 * </md-menu-item>
 * </hljs>
 *
 */

MenuBarDirective['$inject'] = ["$mdUtil", "$mdTheming"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuBar', MenuBarDirective);

/* ngInject */
function MenuBarDirective($mdUtil, $mdTheming) {
  return {
    restrict: 'E',
    require: 'mdMenuBar',
    controller: 'MenuBarController',

    compile: function compile(templateEl, templateAttrs) {
      if (!templateAttrs.ariaRole) {
        templateEl[0].setAttribute('role', 'menubar');
      }
      angular.forEach(templateEl[0].children, function(menuEl) {
        if (menuEl.nodeName == 'MD-MENU') {
          if (!menuEl.hasAttribute('md-position-mode')) {
            menuEl.setAttribute('md-position-mode', 'left bottom');

            // Since we're in the compile function and actual `md-buttons` are not compiled yet,
            // we need to query for possible `md-buttons` as well.
            menuEl.querySelector('button, a, md-button').setAttribute('role', 'menuitem');
          }
          var contentEls = $mdUtil.nodesToArray(menuEl.querySelectorAll('md-menu-content'));
          angular.forEach(contentEls, function(contentEl) {
            contentEl.classList.add('md-menu-bar-menu');
            contentEl.classList.add('md-dense');
            if (!contentEl.hasAttribute('width')) {
              contentEl.setAttribute('width', 5);
            }
          });
        }
      });

      // Mark the child menu items that they're inside a menu bar. This is necessary,
      // because mnMenuItem has special behaviour during compilation, depending on
      // whether it is inside a mdMenuBar. We can usually figure this out via the DOM,
      // however if a directive that uses documentFragment is applied to the child (e.g. ngRepeat),
      // the element won't have a parent and won't compile properly.
      templateEl.find('md-menu-item').addClass('md-in-menu-bar');

      return function postLink(scope, el, attr, ctrl) {
        el.addClass('_md');     // private md component indicator for styling
        $mdTheming(scope, el);
        ctrl.init();
      };
    }
  };

}


angular
  .module('material.components.menuBar')
  .directive('mdMenuDivider', MenuDividerDirective);


function MenuDividerDirective() {
  return {
    restrict: 'E',
    compile: function(templateEl, templateAttrs) {
      if (!templateAttrs.role) {
        templateEl[0].setAttribute('role', 'separator');
      }
    }
  };
}


MenuItemController['$inject'] = ["$scope", "$element", "$attrs"];
angular
  .module('material.components.menuBar')
  .controller('MenuItemController', MenuItemController);


/**
 * ngInject
 */
function MenuItemController($scope, $element, $attrs) {
  this.$element = $element;
  this.$attrs = $attrs;
  this.$scope = $scope;
}

MenuItemController.prototype.init = function(ngModel) {
  var $element = this.$element;
  var $attrs = this.$attrs;

  this.ngModel = ngModel;
  if ($attrs.type == 'checkbox' || $attrs.type == 'radio') {
    this.mode  = $attrs.type;
    this.iconEl = $element[0].children[0];
    this.buttonEl = $element[0].children[1];
    if (ngModel) {
      // Clear ngAria set attributes
      this.initClickListeners();
    }
  }
};

// ngAria auto sets attributes on a menu-item with a ngModel.
// We don't want this because our content (buttons) get the focus
// and set their own aria attributes appropritately. Having both
// breaks NVDA / JAWS. This undeoes ngAria's attrs.
MenuItemController.prototype.clearNgAria = function() {
  var el = this.$element[0];
  var clearAttrs = ['role', 'tabindex', 'aria-invalid', 'aria-checked'];
  angular.forEach(clearAttrs, function(attr) {
    el.removeAttribute(attr);
  });
};

MenuItemController.prototype.initClickListeners = function() {
  var self = this;
  var ngModel = this.ngModel;
  var $scope = this.$scope;
  var $attrs = this.$attrs;
  var $element = this.$element;
  var mode = this.mode;

  this.handleClick = angular.bind(this, this.handleClick);

  var icon = this.iconEl;
  var button = angular.element(this.buttonEl);
  var handleClick = this.handleClick;

  $attrs.$observe('disabled', setDisabled);
  setDisabled($attrs.disabled);

  ngModel.$render = function render() {
    self.clearNgAria();
    if (isSelected()) {
      icon.style.display = '';
      button.attr('aria-checked', 'true');
    } else {
      icon.style.display = 'none';
      button.attr('aria-checked', 'false');
    }
  };

  $scope.$$postDigest(ngModel.$render);

  function isSelected() {
    if (mode == 'radio') {
      var val = $attrs.ngValue ? $scope.$eval($attrs.ngValue) : $attrs.value;
      return ngModel.$modelValue == val;
    } else {
      return ngModel.$modelValue;
    }
  }

  function setDisabled(disabled) {
    if (disabled) {
      button.off('click', handleClick);
    } else {
      button.on('click', handleClick);
    }
  }
};

MenuItemController.prototype.handleClick = function(e) {
  var mode = this.mode;
  var ngModel = this.ngModel;
  var $attrs = this.$attrs;
  var newVal;
  if (mode == 'checkbox') {
    newVal = !ngModel.$modelValue;
  } else if (mode == 'radio') {
    newVal = $attrs.ngValue ? this.$scope.$eval($attrs.ngValue) : $attrs.value;
  }
  ngModel.$setViewValue(newVal);
  ngModel.$render();
};


MenuItemDirective['$inject'] = ["$mdUtil", "$mdConstant", "$$mdSvgRegistry"];
angular
  .module('material.components.menuBar')
  .directive('mdMenuItem', MenuItemDirective);

 /* ngInject */
function MenuItemDirective($mdUtil, $mdConstant, $$mdSvgRegistry) {
  return {
    controller: 'MenuItemController',
    require: ['mdMenuItem', '?ngModel'],
    priority: $mdConstant.BEFORE_NG_ARIA,
    compile: function(templateEl, templateAttrs) {
      var type = templateAttrs.type;
      var inMenuBarClass = 'md-in-menu-bar';

      // Note: This allows us to show the `check` icon for the md-menu-bar items.
      // The `md-in-menu-bar` class is set by the mdMenuBar directive.
      if ((type == 'checkbox' || type == 'radio') && templateEl.hasClass(inMenuBarClass)) {
        var text = templateEl[0].textContent;
        var buttonEl = angular.element('<md-button type="button"></md-button>');
        var iconTemplate = '<md-icon md-svg-src="' + $$mdSvgRegistry.mdChecked + '"></md-icon>';

        buttonEl.html(text);
        buttonEl.attr('tabindex', '0');

        templateEl.html('');
        templateEl.append(angular.element(iconTemplate));
        templateEl.append(buttonEl);
        templateEl.addClass('md-indent').removeClass(inMenuBarClass);

        setDefault('role', type == 'checkbox' ? 'menuitemcheckbox' : 'menuitemradio', buttonEl);
        moveAttrToButton('ng-disabled');

      } else {
        setDefault('role', 'menuitem', templateEl[0].querySelector('md-button, button, a'));
      }


      return function(scope, el, attrs, ctrls) {
        var ctrl = ctrls[0];
        var ngModel = ctrls[1];
        ctrl.init(ngModel);
      };

      function setDefault(attr, val, el) {
        el = el || templateEl;
        if (el instanceof angular.element) {
          el = el[0];
        }
        if (!el.hasAttribute(attr)) {
          el.setAttribute(attr, val);
        }
      }

      function moveAttrToButton(attribute) {
        var attributes = $mdUtil.prefixer(attribute);

        angular.forEach(attributes, function(attr) {
          if (templateEl[0].hasAttribute(attr)) {
            var val = templateEl[0].getAttribute(attr);
            buttonEl[0].setAttribute(attr, val);
            templateEl[0].removeAttribute(attr);
          }
        });
      }
    }
  };
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.panel
 */
MdPanelService['$inject'] = ["presets", "$rootElement", "$rootScope", "$injector", "$window"];
angular
  .module('material.components.panel', [
    'material.core',
    'material.components.backdrop'
  ])
  .provider('$mdPanel', MdPanelProvider);


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanelProvider
 * @module material.components.panel
 *
 * @description
 * `$mdPanelProvider` allows users to create configuration presets that will be
 * stored within a cached presets object. When the configuration is needed, the
 * user can request the preset by passing it as the first parameter in the
 * `$mdPanel.create` or `$mdPanel.open` methods.
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .config(DemoConfig)
 *       .controller('DemoCtrl', DemoCtrl)
 *       .controller('DemoMenuCtrl', DemoMenuCtrl);
 *
 *   function DemoConfig($mdPanelProvider) {
 *     $mdPanelProvider.definePreset('demoPreset', {
 *       attachTo: angular.element(document.body),
 *       controller: DemoMenuCtrl,
 *       controllerAs: 'ctrl',
 *       template: '' +
 *           '<div class="menu-panel" md-whiteframe="4">' +
 *           '  <div class="menu-content">' +
 *           '    <div class="menu-item" ng-repeat="item in ctrl.items">' +
 *           '      <button class="md-button">' +
 *           '        <span>{{item}}</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '    <md-divider></md-divider>' +
 *           '    <div class="menu-item">' +
 *           '      <button class="md-button" ng-click="ctrl.closeMenu()">' +
 *           '        <span>Close Menu</span>' +
 *           '      </button>' +
 *           '    </div>' +
 *           '  </div>' +
 *           '</div>',
 *       panelClass: 'menu-panel-container',
 *       focusOnOpen: false,
 *       zIndex: 100,
 *       propagateContainerEvents: true,
 *       groupName: 'menus'
 *     });
 *   }
 *
 *   function PanelProviderCtrl($mdPanel) {
 *     this.navigation = {
 *       name: 'navigation',
 *       items: [
 *         'Home',
 *         'About',
 *         'Contact'
 *       ]
 *     };
 *     this.favorites = {
 *       name: 'favorites',
 *       items: [
 *         'Add to Favorites'
 *       ]
 *     };
 *     this.more = {
 *       name: 'more',
 *       items: [
 *         'Account',
 *         'Sign Out'
 *       ]
 *     };
 *
 *     $mdPanel.newPanelGroup('menus', {
 *       maxOpen: 2
 *     });
 *
 *     this.showMenu = function($event, menu) {
 *       $mdPanel.open('demoPreset', {
 *         id: 'menu_' + menu.name,
 *         position: $mdPanel.newPanelPosition()
 *             .relativeTo($event.srcElement)
 *             .addPanelPosition(
 *               $mdPanel.xPosition.ALIGN_START,
 *               $mdPanel.yPosition.BELOW
 *             ),
 *         locals: {
 *           items: menu.items
 *         },
 *         openFrom: $event
 *       });
 *     };
 *   }
 *
 *   function PanelMenuCtrl(mdPanelRef) {
 *     this.closeMenu = function() {
 *       mdPanelRef && mdPanelRef.close();
 *     };
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanelProvider#definePreset
 * @description
 * Takes the passed in preset name and preset configuration object and adds it
 * to the `_presets` object of the provider. This `_presets` object is then
 * passed along to the `$mdPanel` service.
 *
 * @param {string} name Preset name.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters avaialble within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */


/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * @ngdoc service
 * @name $mdPanel
 * @module material.components.panel
 *
 * @description
 * `$mdPanel` is a robust, low-level service for creating floating panels on
 * the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.
 *
 * @usage
 * <hljs lang="js">
 * (function(angular, undefined) {
 *   'use strict';
 *
 *   angular
 *       .module('demoApp', ['ngMaterial'])
 *       .controller('DemoDialogController', DialogController);
 *
 *   var panelRef;
 *
 *   function showPanel($event) {
 *     var panelPosition = $mdPanel.newPanelPosition()
 *         .absolute()
 *         .top('50%')
 *         .left('50%');
 *
 *     var panelAnimation = $mdPanel.newPanelAnimation()
 *         .targetEvent($event)
 *         .defaultAnimation('md-panel-animate-fly')
 *         .closeTo('.show-button');
 *
 *     var config = {
 *       attachTo: angular.element(document.body),
 *       controller: DialogController,
 *       controllerAs: 'ctrl',
 *       position: panelPosition,
 *       animation: panelAnimation,
 *       targetEvent: $event,
 *       templateUrl: 'dialog-template.html',
 *       clickOutsideToClose: true,
 *       escapeToClose: true,
 *       focusOnOpen: true
 *     }
 *
 *     $mdPanel.open(config)
 *         .then(function(result) {
 *           panelRef = result;
 *         });
 *   }
 *
 *   function DialogController(MdPanelRef) {
 *     function closeDialog() {
 *       if (MdPanelRef) MdPanelRef.close();
 *     }
 *   }
 * })(angular);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name $mdPanel#create
 * @description
 * Creates a panel with the specified options.
 *
 * @param config {!Object=} Specific configuration object that may contain the
 *     following properties:
 *
 *   - `id` - `{string=}`: An ID to track the panel by. When an ID is provided,
 *     the created panel is added to a tracked panels object. Any subsequent
 *     requests made to create a panel with that ID are ignored. This is useful
 *     in having the panel service not open multiple panels from the same user
 *     interaction when there is no backdrop and events are propagated. Defaults
 *     to an arbitrary string that is not tracked.
 *   - `template` - `{string=}`: HTML template to show in the panel. This
 *     **must** be trusted HTML with respect to Angular’s
 *     [$sce service](https://docs.angularjs.org/api/ng/service/$sce).
 *   - `templateUrl` - `{string=}`: The URL that will be used as the content of
 *     the panel.
 *   - `contentElement` - `{(string|!angular.JQLite|!Element)=}`: Pre-compiled
 *     element to be used as the panel's content.
 *   - `controller` - `{(function|string)=}`: The controller to associate with
 *     the panel. The controller can inject a reference to the returned
 *     panelRef, which allows the panel to be closed, hidden, and shown. Any
 *     fields passed in through locals or resolve will be bound to the
 *     controller.
 *   - `controllerAs` - `{string=}`: An alias to assign the controller to on
 *     the scope.
 *   - `bindToController` - `{boolean=}`: Binds locals to the controller
 *     instead of passing them in. Defaults to true, as this is a best
 *     practice.
 *   - `locals` - `{Object=}`: An object containing key/value pairs. The keys
 *     will be used as names of values to inject into the controller. For
 *     example, `locals: {three: 3}` would inject `three` into the controller,
 *     with the value 3.
 *   - `resolve` - `{Object=}`: Similar to locals, except it takes promises as
 *     values. The panel will not open until all of the promises resolve.
 *   - `attachTo` - `{(string|!angular.JQLite|!Element)=}`: The element to
 *     attach the panel to. Defaults to appending to the root element of the
 *     application.
 *   - `propagateContainerEvents` - `{boolean=}`: Whether pointer or touch
 *     events should be allowed to propagate 'go through' the container, aka the
 *     wrapper, of the panel. Defaults to false.
 *   - `panelClass` - `{string=}`: A css class to apply to the panel element.
 *     This class should define any borders, box-shadow, etc. for the panel.
 *   - `zIndex` - `{number=}`: The z-index to place the panel at.
 *     Defaults to 80.
 *   - `position` - `{MdPanelPosition=}`: An MdPanelPosition object that
 *     specifies the alignment of the panel. For more information, see
 *     `MdPanelPosition`.
 *   - `clickOutsideToClose` - `{boolean=}`: Whether the user can click
 *     outside the panel to close it. Defaults to false.
 *   - `escapeToClose` - `{boolean=}`: Whether the user can press escape to
 *     close the panel. Defaults to false.
 *   - `onCloseSuccess` - `{function(!panelRef, string)=}`: Function that is
 *     called after the close successfully finishes. The first parameter passed
 *     into this function is the current panelRef and the 2nd is an optional
 *     string explaining the close reason. The currently supported closeReasons
 *     can be found in the MdPanelRef.closeReasons enum. These are by default
 *     passed along by the panel.
 *   - `trapFocus` - `{boolean=}`: Whether focus should be trapped within the
 *     panel. If `trapFocus` is true, the user will not be able to interact
 *     with the rest of the page until the panel is dismissed. Defaults to
 *     false.
 *   - `focusOnOpen` - `{boolean=}`: An option to override focus behavior on
 *     open. Only disable if focusing some other way, as focus management is
 *     required for panels to be accessible. Defaults to true.
 *   - `fullscreen` - `{boolean=}`: Whether the panel should be full screen.
 *     Applies the class `._md-panel-fullscreen` to the panel on open. Defaults
 *     to false.
 *   - `animation` - `{MdPanelAnimation=}`: An MdPanelAnimation object that
 *     specifies the animation of the panel. For more information, see
 *     `MdPanelAnimation`.
 *   - `hasBackdrop` - `{boolean=}`: Whether there should be an opaque backdrop
 *     behind the panel. Defaults to false.
 *   - `disableParentScroll` - `{boolean=}`: Whether the user can scroll the
 *     page behind the panel. Defaults to false.
 *   - `onDomAdded` - `{function=}`: Callback function used to announce when
 *     the panel is added to the DOM.
 *   - `onOpenComplete` - `{function=}`: Callback function used to announce
 *     when the open() action is finished.
 *   - `onRemoving` - `{function=}`: Callback function used to announce the
 *     close/hide() action is starting.
 *   - `onDomRemoved` - `{function=}`: Callback function used to announce when
 *     the panel is removed from the DOM.
 *   - `origin` - `{(string|!angular.JQLite|!Element)=}`: The element to focus
 *     on when the panel closes. This is commonly the element which triggered
 *     the opening of the panel. If you do not use `origin`, you need to control
 *     the focus manually.
 *   - `groupName` - `{(string|!Array<string>)=}`: A group name or an array of
 *     group names. The group name is used for creating a group of panels. The
 *     group is used for configuring the number of open panels and identifying
 *     specific behaviors for groups. For instance, all tooltips could be
 *     identified using the same groupName.
 *
 * @returns {!MdPanelRef} panelRef
 */

/**
 * @ngdoc method
 * @name $mdPanel#open
 * @description
 * Calls the create method above, then opens the panel. This is a shortcut for
 * creating and then calling open manually. If custom methods need to be
 * called when the panel is added to the DOM or opened, do not use this method.
 * Instead create the panel, chain promises on the domAdded and openComplete
 * methods, and call open from the returned panelRef.
 *
 * @param {!Object=} config Specific configuration object that may contain
 *     the properties defined in `$mdPanel.create`.
 * @returns {!angular.$q.Promise<!MdPanelRef>} panelRef A promise that resolves
 *     to an instance of the panel.
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelPosition
 * @description
 * Returns a new instance of the MdPanelPosition object. Use this to create
 * the position config object.
 *
 * @returns {!MdPanelPosition} panelPosition
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelAnimation
 * @description
 * Returns a new instance of the MdPanelAnimation object. Use this to create
 * the animation config object.
 *
 * @returns {!MdPanelAnimation} panelAnimation
 */

/**
 * @ngdoc method
 * @name $mdPanel#newPanelGroup
 * @description
 * Creates a panel group and adds it to a tracked list of panel groups.
 *
 * @param {string} groupName Name of the group to create.
 * @param {!Object=} config Specific configuration object that may contain the
 *     following properties:
 *
 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed to
 *     be open within a defined panel group.
 *
 * @returns {!Object<string,
 *     {panels: !Array<!MdPanelRef>,
 *     openPanels: !Array<!MdPanelRef>,
 *     maxOpen: number}>} panelGroup
 */

/**
 * @ngdoc method
 * @name $mdPanel#setGroupMaxOpen
 * @description
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 *
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelRef
 * @module material.components.panel
 * @description
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with the following properties:
 *
 *   - `id` - `{string}`: The unique id for the panel. This id is used to track
 *     when a panel was interacted with.
 *   - `config` - `{!Object=}`: The entire config object that was used in
 *     create.
 *   - `isAttached` - `{boolean}`: Whether the panel is attached to the DOM.
 *     Visibility to the user does not factor into isAttached.
 *   - `panelContainer` - `{angular.JQLite}`: The wrapper element containing the
 *     panel. This property is added in order to have access to the `addClass`,
 *     `removeClass`, `toggleClass`, etc methods.
 *   - `panelEl` - `{angular.JQLite}`: The panel element. This property is added
 *     in order to have access to the `addClass`, `removeClass`, `toggleClass`,
 *     etc methods.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#open
 * @description
 * Attaches and shows the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     opened.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#close
 * @description
 * Hides and detaches the panel. Note that this will **not** destroy the panel.
 * If you don't intend on using the panel again, call the {@link #destroy
 * destroy} method afterwards.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     closed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#attach
 * @description
 * Create the panel elements and attach them to the DOM. The panel will be
 * hidden by default.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     attached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#detach
 * @description
 * Removes the panel from the DOM. This will NOT hide the panel before removing
 * it.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     detached.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#show
 * @description
 * Shows the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     shown and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#hide
 * @description
 * Hides the panel.
 *
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     hidden and animations are completed.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#destroy
 * @description
 * Destroys the panel. The panel cannot be opened again after this is called.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#addClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Adds a class to the panel. DO NOT use this hide/show the panel.
 *
 * @param {string} newClass class to be added.
 * @param {boolean} toElement Whether or not to add the class to the panel
 *     element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Removes a class from the panel. DO NOT use this to hide/show the panel.
 *
 * @param {string} oldClass Class to be removed.
 * @param {boolean} fromElement Whether or not to remove the class from the
 *     panel element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#toggleClass
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 * @description
 * Toggles a class on the panel. DO NOT use this to hide/show the panel.
 *
 * @param {string} toggleClass Class to be toggled.
 * @param {boolean} onElement Whether or not to remove the class from the panel
 *     element instead of the container.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updatePosition
 * @description
 * Updates the position configuration of a panel. Use this to update the
 * position of a panel that is open, without having to close and re-open the
 * panel.
 *
 * @param {!MdPanelPosition} position
 */

/**
 * @ngdoc method
 * @name MdPanelRef#addToGroup
 * @description
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 *
 * @param {string} groupName The name of the group to add the panel to.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeFromGroup
 * @description
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 *
 * @param {string} groupName The name of the group.
 */

/**
 * @ngdoc method
 * @name MdPanelRef#registerInterceptor
 * @description
 * Registers an interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected. The interceptors are called sequentially
 * and it reverse order. `type` must be one of the following
 * values available on `$mdPanel.interceptorTypes`:
 * * `CLOSE` - Gets called before the panel begins closing.
 *
 * @param {string} type Type of interceptor.
 * @param {!angular.$q.Promise<any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeInterceptor
 * @description
 * Removes a registered interceptor.
 *
 * @param {string} type Type of interceptor to be removed.
 * @param {function(): !angular.$q.Promise<any>} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#removeAllInterceptors
 * @description
 * Removes all interceptors. If a type is supplied, only the
 * interceptors of that type will be cleared.
 *
 * @param {string=} type Type of interceptors to be removed.
 * @returns {!MdPanelRef}
 */

/**
 * @ngdoc method
 * @name MdPanelRef#updateAnimation
 * @description
 * Updates the animation configuration for a panel. You can use this to change
 * the panel's animation without having to re-create it.
 *
 * @param {!MdPanelAnimation} animation
 */


/*****************************************************************************
 *                               MdPanelPosition                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelPosition
 * @module material.components.panel
 * @description
 *
 * Object for configuring the position of the panel.
 *
 * @usage
 *
 * #### Centering the panel
 *
 * <hljs lang="js">
 * new MdPanelPosition().absolute().center();
 * </hljs>
 *
 * #### Overlapping the panel with an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.ALIGN_START,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 * </hljs>
 *
 * #### Aligning the panel with the bottom of an element
 *
 * <hljs lang="js">
 * new MdPanelPosition()
 *     .relativeTo(someElement)
 *     .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#absolute
 * @description
 * Positions the panel absolutely relative to the parent element. If the parent
 * is document.body, this is equivalent to positioning the panel absolutely
 * within the viewport.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#relativeTo
 * @description
 * Positions the panel relative to a specific element.
 *
 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
 *     or angular element to position the panel with respect to.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#top
 * @description
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#bottom
 * @description
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 *
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#start
 * @description
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 *
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#end
 * @description
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 *
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#left
 * @description
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#right
 * @description
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 *
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerHorizontally
 * @description
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#centerVertically
 * @description
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#center
 * @description
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 *
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#addPanelPosition
 * @description
 * Sets the x and y position for the panel relative to another element. Can be
 * called multiple times to specify an ordered list of panel positions. The
 * first position which allows the panel to be completely on-screen will be
 * chosen; the last position will be chose whether it is on-screen or not.
 *
 * xPosition must be one of the following values available on
 * $mdPanel.xPosition:
 *
 *
 * CENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END
 *
 * <pre>
 *    *************
 *    *           *
 *    *   PANEL   *
 *    *           *
 *    *************
 *   A B    C    D E
 *
 * A: OFFSET_START (for LTR displays)
 * B: ALIGN_START (for LTR displays)
 * C: CENTER
 * D: ALIGN_END (for LTR displays)
 * E: OFFSET_END (for LTR displays)
 * </pre>
 *
 * yPosition must be one of the following values available on
 * $mdPanel.yPosition:
 *
 * CENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW
 *
 * <pre>
 *   F
 *   G *************
 *     *           *
 *   H *   PANEL   *
 *     *           *
 *   I *************
 *   J
 *
 * F: BELOW
 * G: ALIGN_TOPS
 * H: CENTER
 * I: ALIGN_BOTTOMS
 * J: ABOVE
 * </pre>
 *
 * @param {string} xPosition
 * @param {string} yPosition
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetX
 * @description
 * Sets the value of the offset in the x-direction.
 *
 * @param {string} offsetX
 * @returns {!MdPanelPosition}
 */

/**
 * @ngdoc method
 * @name MdPanelPosition#withOffsetY
 * @description
 * Sets the value of the offset in the y-direction.
 *
 * @param {string} offsetY
 * @returns {!MdPanelPosition}
 */


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * @ngdoc type
 * @name MdPanelAnimation
 * @module material.components.panel
 * @description
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * @usage
 *
 * <hljs lang="js">
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .duration(1337)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 * </hljs>
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#openFrom
 * @description
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 *
 * @param {string|!Element|!Event|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#closeTo
 * @description
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 *
 * @param {string|!Element|{top: number, left: number}}
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#withAnimation
 * @description
 * Specifies the animation class.
 *
 * There are several default animations that can be used:
 * ($mdPanel.animation)
 *   SLIDE: The panel slides in and out from the specified
 *       elements. It will not fade in or out.
 *   SCALE: The panel scales in and out. Slide and fade are
 *       included in this animation.
 *   FADE: The panel fades in and out.
 *
 * Custom classes will by default fade in and out unless
 * "transition: opacity 1ms" is added to the to custom class.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */

/**
 * @ngdoc method
 * @name MdPanelAnimation#duration
 * @description
 * Specifies the duration of the animation in milliseconds. The `duration`
 * method accepts either a number or an object with separate open and close
 * durations.
 *
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */


/*****************************************************************************
 *                            PUBLIC DOCUMENTATION                           *
 *****************************************************************************/


var MD_PANEL_Z_INDEX = 80;
var MD_PANEL_HIDDEN = '_md-panel-hidden';
var FOCUS_TRAP_TEMPLATE = angular.element(
    '<div class="_md-panel-focus-trap" tabindex="0"></div>');

var _presets = {};


/**
 * A provider that is used for creating presets for the panel API.
 * @final @constructor ngInject
 */
function MdPanelProvider() {
  return {
    'definePreset': definePreset,
    'getAllPresets': getAllPresets,
    'clearPresets': clearPresets,
    '$get': $getProvider()
  };
}


/**
 * Takes the passed in panel configuration object and adds it to the `_presets`
 * object at the specified name.
 * @param {string} name Name of the preset to set.
 * @param {!Object} preset Specific configuration object that can contain any
 *     and all of the parameters avaialble within the `$mdPanel.create` method.
 *     However, parameters that pertain to id, position, animation, and user
 *     interaction are not allowed and will be removed from the preset
 *     configuration.
 */
function definePreset(name, preset) {
  if (!name || !preset) {
    throw new Error('mdPanelProvider: The panel preset definition is ' +
        'malformed. The name and preset object are required.');
  } else if (_presets.hasOwnProperty(name)) {
    throw new Error('mdPanelProvider: The panel preset you have requested ' +
        'has already been defined.');
  }

  // Delete any property on the preset that is not allowed.
  delete preset.id;
  delete preset.position;
  delete preset.animation;

  _presets[name] = preset;
}


/**
 * Gets a clone of the `_presets`.
 * @return {!Object}
 */
function getAllPresets() {
  return angular.copy(_presets);
}


/**
 * Clears all of the stored presets.
 */
function clearPresets() {
  _presets = {};
}


/**
 * Represents the `$get` method of the Angular provider. From here, a new
 * reference to the MdPanelService is returned where the needed arguments are
 * passed in including the MdPanelProvider `_presets`.
 * @param {!Object} _presets
 * @param {!angular.JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!angular.$injector} $injector
 * @param {!angular.$window} $window
 */
function $getProvider() {
  return [
    '$rootElement', '$rootScope', '$injector', '$window',
    function($rootElement, $rootScope, $injector, $window) {
      return new MdPanelService(_presets, $rootElement, $rootScope,
          $injector, $window);
    }
  ];
}


/*****************************************************************************
 *                               MdPanel Service                             *
 *****************************************************************************/


/**
 * A service that is used for controlling/displaying panels on the screen.
 * @param {!Object} presets
 * @param {!angular.JQLite} $rootElement
 * @param {!angular.Scope} $rootScope
 * @param {!angular.$injector} $injector
 * @param {!angular.$window} $window
 * @final @constructor ngInject
 */
function MdPanelService(presets, $rootElement, $rootScope, $injector, $window) {
  /**
   * Default config options for the panel.
   * Anything angular related needs to be done later. Therefore
   *     scope: $rootScope.$new(true),
   *     attachTo: $rootElement,
   * are added later.
   * @private {!Object}
   */
  this._defaultConfigOptions = {
    bindToController: true,
    clickOutsideToClose: false,
    disableParentScroll: false,
    escapeToClose: false,
    focusOnOpen: true,
    fullscreen: false,
    hasBackdrop: false,
    propagateContainerEvents: false,
    transformTemplate: angular.bind(this, this._wrapTemplate),
    trapFocus: false,
    zIndex: MD_PANEL_Z_INDEX
  };

  /** @private {!Object} */
  this._config = {};

  /** @private {!Object} */
  this._presets = presets;

  /** @private @const */
  this._$rootElement = $rootElement;

  /** @private @const */
  this._$rootScope = $rootScope;

  /** @private @const */
  this._$injector = $injector;

  /** @private @const */
  this._$window = $window;

  /** @private @const */
  this._$mdUtil = this._$injector.get('$mdUtil');

  /** @private {!Object<string, !MdPanelRef>} */
  this._trackedPanels = {};

  /**
   * @private {!Object<string,
   *     {panels: !Array<!MdPanelRef>,
   *     openPanels: !Array<!MdPanelRef>,
   *     maxOpen: number}>}
   */
  this._groups = Object.create(null);

  /**
   * Default animations that can be used within the panel.
   * @type {enum}
   */
  this.animation = MdPanelAnimation.animation;

  /**
   * Possible values of xPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.xPosition = MdPanelPosition.xPosition;

  /**
   * Possible values of yPosition for positioning the panel relative to
   * another element.
   * @type {enum}
   */
  this.yPosition = MdPanelPosition.yPosition;

  /**
   * Possible values for the interceptors that can be registered on a panel.
   * @type {enum}
   */
  this.interceptorTypes = MdPanelRef.interceptorTypes;

  /**
   * Possible values for closing of a panel.
   * @type {enum}
   */
  this.closeReasons = MdPanelRef.closeReasons;

  /**
   * Possible values of absolute position.
   * @type {enum}
   */
  this.absPosition = MdPanelPosition.absPosition;
}


/**
 * Creates a panel with the specified options.
 * @param {string=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!MdPanelRef}
 */
MdPanelService.prototype.create = function(preset, config) {
  if (typeof preset === 'string') {
    preset = this._getPresetByName(preset);
  } else if (typeof preset === 'object' &&
      (angular.isUndefined(config) || !config)) {
    config = preset;
    preset = {};
  }

  preset = preset || {};
  config = config || {};

  // If the passed-in config contains an ID and the ID is within _trackedPanels,
  // return the tracked panel after updating its config with the passed-in
  // config.
  if (angular.isDefined(config.id) && this._trackedPanels[config.id]) {
    var trackedPanel = this._trackedPanels[config.id];
    angular.extend(trackedPanel.config, config);
    return trackedPanel;
  }

  // Combine the passed-in config, the _defaultConfigOptions, and the preset
  // configuration into the `_config`.
  this._config = angular.extend({
    // If no ID is set within the passed-in config, then create an arbitrary ID.
    id: config.id || 'panel_' + this._$mdUtil.nextUid(),
    scope: this._$rootScope.$new(true),
    attachTo: this._$rootElement
  }, this._defaultConfigOptions, config, preset);

  // Create the panelRef and add it to the `_trackedPanels` object.
  var panelRef = new MdPanelRef(this._config, this._$injector);
  this._trackedPanels[config.id] = panelRef;

  // Add the panel to each of its requested groups.
  if (this._config.groupName) {
    if (angular.isString(this._config.groupName)) {
      this._config.groupName = [this._config.groupName];
    }
    angular.forEach(this._config.groupName, function(group) {
      panelRef.addToGroup(group);
    });
  }

  this._config.scope.$on('$destroy', angular.bind(panelRef, panelRef.detach));

  return panelRef;
};


/**
 * Creates and opens a panel with the specified options.
 * @param {string=} preset Name of a preset configuration that can be used to
 *     extend the panel configuration.
 * @param {!Object=} config Configuration object for the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} The panel created from create.
 */
MdPanelService.prototype.open = function(preset, config) {
  var panelRef = this.create(preset, config);
  return panelRef.open().then(function() {
    return panelRef;
  });
};


/**
 * Gets a specific preset configuration object saved within `_presets`.
 * @param {string} preset Name of the preset to search for.
 * @returns {!Object} The preset configuration object.
 */
MdPanelService.prototype._getPresetByName = function(preset) {
  if (!this._presets[preset]) {
    throw new Error('mdPanel: The panel preset configuration that you ' +
        'requested does not exist. Use the $mdPanelProvider to create a ' +
        'preset before requesting one.');
  }
  return this._presets[preset];
};


/**
 * Returns a new instance of the MdPanelPosition. Use this to create the
 * positioning object.
 * @returns {!MdPanelPosition}
 */
MdPanelService.prototype.newPanelPosition = function() {
  return new MdPanelPosition(this._$injector);
};


/**
 * Returns a new instance of the MdPanelAnimation. Use this to create the
 * animation object.
 * @returns {!MdPanelAnimation}
 */
MdPanelService.prototype.newPanelAnimation = function() {
  return new MdPanelAnimation(this._$injector);
};


/**
 * Creates a panel group and adds it to a tracked list of panel groups.
 * @param groupName {string} Name of the group to create.
 * @param config {!Object=} Specific configuration object that may contain the
 *     following properties:
 *
 *   - `maxOpen` - `{number=}`: The maximum number of panels that are allowed
 *     open within a defined panel group.
 *
 * @returns {!Object<string,
 *     {panels: !Array<!MdPanelRef>,
 *     openPanels: !Array<!MdPanelRef>,
 *     maxOpen: number}>} panelGroup
 */
MdPanelService.prototype.newPanelGroup = function(groupName, config) {
  if (!this._groups[groupName]) {
    config = config || {};
    var group = {
      panels: [],
      openPanels: [],
      maxOpen: config.maxOpen > 0 ? config.maxOpen : Infinity
    };
    this._groups[groupName] = group;
  }
  return this._groups[groupName];
};


/**
 * Sets the maximum number of panels in a group that can be opened at a given
 * time.
 * @param {string} groupName The name of the group to configure.
 * @param {number} maxOpen The maximum number of panels that can be
 *     opened. Infinity can be passed in to remove the maxOpen limit.
 */
MdPanelService.prototype.setGroupMaxOpen = function(groupName, maxOpen) {
  if (this._groups[groupName]) {
    this._groups[groupName].maxOpen = maxOpen;
  } else {
    throw new Error('mdPanel: Group does not exist yet. Call newPanelGroup().');
  }
};


/**
 * Determines if the current number of open panels within a group exceeds the
 * limit of allowed open panels.
 * @param {string} groupName The name of the group to check.
 * @returns {boolean} true if open count does exceed maxOpen and false if not.
 * @private
 */
MdPanelService.prototype._openCountExceedsMaxOpen = function(groupName) {
  if (this._groups[groupName]) {
    var group = this._groups[groupName];
    return group.maxOpen > 0 && group.openPanels.length > group.maxOpen;
  }
  return false;
};


/**
 * Closes the first open panel within a specific group.
 * @param {string} groupName The name of the group.
 * @private
 */
MdPanelService.prototype._closeFirstOpenedPanel = function(groupName) {
  this._groups[groupName].openPanels[0].close();
};


/**
 * Wraps the users template in two elements, md-panel-outer-wrapper, which
 * covers the entire attachTo element, and md-panel, which contains only the
 * template. This allows the panel control over positioning, animations,
 * and similar properties.
 * @param {string} origTemplate The original template.
 * @returns {string} The wrapped template.
 * @private
 */
MdPanelService.prototype._wrapTemplate = function(origTemplate) {
  var template = origTemplate || '';

  // The panel should be initially rendered offscreen so we can calculate
  // height and width for positioning.
  return '' +
      '<div class="md-panel-outer-wrapper">' +
      '  <div class="md-panel" style="left: -9999px;">' + template + '</div>' +
      '</div>';
};


/**
 * Wraps a content element in a md-panel-outer wrapper and
 * positions it off-screen. Allows for proper control over positoning
 * and animations.
 * @param {!angular.JQLite} contentElement Element to be wrapped.
 * @return {!angular.JQLite} Wrapper element.
 * @private
 */
MdPanelService.prototype._wrapContentElement = function(contentElement) {
  var wrapper = angular.element('<div class="md-panel-outer-wrapper">');

  contentElement.addClass('md-panel').css('left', '-9999px');
  wrapper.append(contentElement);

  return wrapper;
};


/*****************************************************************************
 *                                 MdPanelRef                                *
 *****************************************************************************/


/**
 * A reference to a created panel. This reference contains a unique id for the
 * panel, along with properties/functions used to control the panel.
 * @param {!Object} config
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelRef(config, $injector) {
  // Injected variables.
  /** @private @const {!angular.$q} */
  this._$q = $injector.get('$q');

  /** @private @const {!angular.$mdCompiler} */
  this._$mdCompiler = $injector.get('$mdCompiler');

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /** @private @const {!angular.$mdTheming} */
  this._$mdTheming = $injector.get('$mdTheming');

  /** @private @const {!angular.Scope} */
  this._$rootScope = $injector.get('$rootScope');

  /** @private @const {!angular.$animate} */
  this._$animate = $injector.get('$animate');

  /** @private @const {!MdPanelRef} */
  this._$mdPanel = $injector.get('$mdPanel');

  /** @private @const {!angular.$log} */
  this._$log = $injector.get('$log');

  /** @private @const {!angular.$window} */
  this._$window = $injector.get('$window');

  /** @private @const {!Function} */
  this._$$rAF = $injector.get('$$rAF');

  // Public variables.
  /**
   * Unique id for the panelRef.
   * @type {string}
   */
  this.id = config.id;

  /** @type {!Object} */
  this.config = config;

  /** @type {!angular.JQLite|undefined} */
  this.panelContainer;

  /** @type {!angular.JQLite|undefined} */
  this.panelEl;

  /**
   * Whether the panel is attached. This is synchronous. When attach is called,
   * isAttached is set to true. When detach is called, isAttached is set to
   * false.
   * @type {boolean}
   */
  this.isAttached = false;

  // Private variables.
  /** @private {Array<function()>} */
  this._removeListeners = [];

  /** @private {!angular.JQLite|undefined} */
  this._topFocusTrap;

  /** @private {!angular.JQLite|undefined} */
  this._bottomFocusTrap;

  /** @private {!$mdPanel|undefined} */
  this._backdropRef;

  /** @private {Function?} */
  this._restoreScroll = null;

  /**
   * Keeps track of all the panel interceptors.
   * @private {!Object}
   */
  this._interceptors = Object.create(null);

  /**
   * Cleanup function, provided by `$mdCompiler` and assigned after the element
   * has been compiled. When `contentElement` is used, the function is used to
   * restore the element to it's proper place in the DOM.
   * @private {!Function}
   */
  this._compilerCleanup = null;

  /**
   * Cache for saving and restoring element inline styles, CSS classes etc.
   * @type {{styles: string, classes: string}}
   */
  this._restoreCache = {
    styles: '',
    classes: ''
  };
}


MdPanelRef.interceptorTypes = {
  CLOSE: 'onClose'
};


/**
 * Opens an already created and configured panel. If the panel is already
 * visible, does nothing.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is opened and animations finish.
 */
MdPanelRef.prototype.open = function() {
  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var show = self._simpleBind(self.show, self);
    var checkGroupMaxOpen = function() {
      if (self.config.groupName) {
        angular.forEach(self.config.groupName, function(group) {
          if (self._$mdPanel._openCountExceedsMaxOpen(group)) {
            self._$mdPanel._closeFirstOpenedPanel(group);
          }
        });
      }
    };

    self.attach()
        .then(show)
        .then(checkGroupMaxOpen)
        .then(done)
        .catch(reject);
  });
};


/**
 * Closes the panel.
 * @param {string} closeReason The event type that triggered the close.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is closed and animations finish.
 */
MdPanelRef.prototype.close = function(closeReason) {
  var self = this;

  return this._$q(function(resolve, reject) {
    self._callInterceptors(MdPanelRef.interceptorTypes.CLOSE).then(function() {
      var done = self._done(resolve, self);
      var detach = self._simpleBind(self.detach, self);
      var onCloseSuccess = self.config['onCloseSuccess'] || angular.noop;
      onCloseSuccess = angular.bind(self, onCloseSuccess, self, closeReason);

      self.hide()
          .then(detach)
          .then(done)
          .then(onCloseSuccess)
          .catch(reject);
    }, reject);
  });
};


/**
 * Attaches the panel. The panel will be hidden afterwards.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is attached.
 */
MdPanelRef.prototype.attach = function() {
  if (this.isAttached && this.panelEl) {
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onDomAdded = self.config['onDomAdded'] || angular.noop;
    var addListeners = function(response) {
      self.isAttached = true;
      self._addEventListeners();
      return response;
    };

    self._$q.all([
        self._createBackdrop(),
        self._createPanel()
            .then(addListeners)
            .catch(reject)
    ]).then(onDomAdded)
      .then(done)
      .catch(reject);
  });
};


/**
 * Only detaches the panel. Will NOT hide the panel first.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel is detached.
 */
MdPanelRef.prototype.detach = function() {
  if (!this.isAttached) {
    return this._$q.when(this);
  }

  var self = this;
  var onDomRemoved = self.config['onDomRemoved'] || angular.noop;

  var detachFn = function() {
    self._removeEventListeners();

    // Remove the focus traps that we added earlier for keeping focus within
    // the panel.
    if (self._topFocusTrap && self._topFocusTrap.parentNode) {
      self._topFocusTrap.parentNode.removeChild(self._topFocusTrap);
    }

    if (self._bottomFocusTrap && self._bottomFocusTrap.parentNode) {
      self._bottomFocusTrap.parentNode.removeChild(self._bottomFocusTrap);
    }

    if (self._restoreCache.classes) {
      self.panelEl[0].className = self._restoreCache.classes;
    }

    // Either restore the saved styles or clear the ones set by mdPanel.
    self.panelEl[0].style.cssText = self._restoreCache.styles || '';

    self._compilerCleanup();
    self.panelContainer.remove();
    self.isAttached = false;
    return self._$q.when(self);
  };

  if (this._restoreScroll) {
    this._restoreScroll();
    this._restoreScroll = null;
  }

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);

    self._$q.all([
      detachFn(),
      self._backdropRef ? self._backdropRef.detach() : true
    ]).then(onDomRemoved)
      .then(done)
      .catch(reject);
  });
};


/**
 * Destroys the panel. The Panel cannot be opened again after this.
 */
MdPanelRef.prototype.destroy = function() {
  var self = this;
  if (this.config.groupName) {
    angular.forEach(this.config.groupName, function(group) {
      self.removeFromGroup(group);
    });
  }
  this.config.scope.$destroy();
  this.config.locals = null;
  this._interceptors = null;
};


/**
 * Shows the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel has shown and animations finish.
 */
MdPanelRef.prototype.show = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (!this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;
  var animatePromise = function() {
    self.panelContainer.removeClass(MD_PANEL_HIDDEN);
    return self._animateOpen();
  };

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onOpenComplete = self.config['onOpenComplete'] || angular.noop;
    var addToGroupOpen = function() {
      if (self.config.groupName) {
        angular.forEach(self.config.groupName, function(group) {
          self._$mdPanel._groups[group].openPanels.push(self);
        });
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.show() : self,
      animatePromise().then(function() { self._focusOnOpen(); }, reject)
    ]).then(onOpenComplete)
      .then(addToGroupOpen)
      .then(done)
      .catch(reject);
  });
};


/**
 * Hides the panel.
 * @returns {!angular.$q.Promise<!MdPanelRef>} A promise that is resolved when
 *     the panel has hidden and animations finish.
 */
MdPanelRef.prototype.hide = function() {
  if (!this.panelContainer) {
    return this._$q(function(resolve, reject) {
      reject('mdPanel: Panel does not exist yet. Call open() or attach().');
    });
  }

  if (this.panelContainer.hasClass(MD_PANEL_HIDDEN)) {
    return this._$q.when(this);
  }

  var self = this;

  return this._$q(function(resolve, reject) {
    var done = self._done(resolve, self);
    var onRemoving = self.config['onRemoving'] || angular.noop;
    var hidePanel = function() {
      self.panelContainer.addClass(MD_PANEL_HIDDEN);
    };
    var removeFromGroupOpen = function() {
      if (self.config.groupName) {
        var group, index;
        angular.forEach(self.config.groupName, function(group) {
          group = self._$mdPanel._groups[group];
          index = group.openPanels.indexOf(self);
          if (index > -1) {
            group.openPanels.splice(index, 1);
          }
        });
      }
    };
    var focusOnOrigin = function() {
      var origin = self.config['origin'];
      if (origin) {
        getElement(origin).focus();
      }
    };

    self._$q.all([
      self._backdropRef ? self._backdropRef.hide() : self,
      self._animateClose()
          .then(onRemoving)
          .then(hidePanel)
          .then(removeFromGroupOpen)
          .then(focusOnOrigin)
          .catch(reject)
    ]).then(done, reject);
  });
};


/**
 * Add a class to the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} newClass Class to be added.
 * @param {boolean} toElement Whether or not to add the class to the panel
 *     element instead of the container.
 */
MdPanelRef.prototype.addClass = function(newClass, toElement) {
  this._$log.warn(
      'mdPanel: The addClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!toElement && !this.panelContainer.hasClass(newClass)) {
    this.panelContainer.addClass(newClass);
  } else if (toElement && !this.panelEl.hasClass(newClass)) {
    this.panelEl.addClass(newClass);
  }
};


/**
 * Remove a class from the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} oldClass Class to be removed.
 * @param {boolean} fromElement Whether or not to remove the class from the
 *     panel element instead of the container.
 */
MdPanelRef.prototype.removeClass = function(oldClass, fromElement) {
  this._$log.warn(
      'mdPanel: The removeClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!fromElement && this.panelContainer.hasClass(oldClass)) {
    this.panelContainer.removeClass(oldClass);
  } else if (fromElement && this.panelEl.hasClass(oldClass)) {
    this.panelEl.removeClass(oldClass);
  }
};


/**
 * Toggle a class on the panel. DO NOT use this to hide/show the panel.
 * @deprecated
 * This method is in the process of being deprecated in favor of using the panel
 * and container JQLite elements that are referenced in the MdPanelRef object.
 * Full deprecation is scheduled for material 1.2.
 *
 * @param {string} toggleClass The class to toggle.
 * @param {boolean} onElement Whether or not to toggle the class on the panel
 *     element instead of the container.
 */
MdPanelRef.prototype.toggleClass = function(toggleClass, onElement) {
  this._$log.warn(
      'mdPanel: The toggleClass method is in the process of being deprecated. ' +
      'Full deprecation is scheduled for the Angular Material 1.2 release. ' +
      'To achieve the same results, use the panelContainer or panelEl ' +
      'JQLite elements that are referenced in MdPanelRef.');

  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  if (!onElement) {
    this.panelContainer.toggleClass(toggleClass);
  } else {
    this.panelEl.toggleClass(toggleClass);
  }
};


/**
 * Compiles the panel, according to the passed in config and appends it to
 * the DOM. Helps normalize differences in the compilation process between
 * using a string template and a content element.
 * @returns {!angular.$q.Promise<!MdPanelRef>} Promise that is resolved when
 *     the element has been compiled and added to the DOM.
 * @private
 */
MdPanelRef.prototype._compile = function() {
  var self = this;

  // Compile the element via $mdCompiler. Note that when using a
  // contentElement, the element isn't actually being compiled, rather the
  // compiler saves it's place in the DOM and provides a way of restoring it.
  return self._$mdCompiler.compile(self.config).then(function(compileData) {
    var config = self.config;

    if (config.contentElement) {
      var panelEl = compileData.element;

      // Since mdPanel modifies the inline styles and CSS classes, we need
      // to save them in order to be able to restore on close.
      self._restoreCache.styles = panelEl[0].style.cssText;
      self._restoreCache.classes = panelEl[0].className;

      self.panelContainer = self._$mdPanel._wrapContentElement(panelEl);
      self.panelEl = panelEl;
    } else {
      self.panelContainer = compileData.link(config['scope']);
      self.panelEl = angular.element(
        self.panelContainer[0].querySelector('.md-panel')
      );
    }

    // Save a reference to the cleanup function from the compiler.
    self._compilerCleanup = compileData.cleanup;

    // Attach the panel to the proper place in the DOM.
    getElement(self.config['attachTo']).append(self.panelContainer);

    return self;
  });
};


/**
 * Creates a panel and adds it to the dom.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel is
 *     created.
 * @private
 */
MdPanelRef.prototype._createPanel = function() {
  var self = this;

  return this._$q(function(resolve, reject) {
    if (!self.config.locals) {
      self.config.locals = {};
    }

    self.config.locals.mdPanelRef = self;

    self._compile().then(function() {
      if (self.config['disableParentScroll']) {
        self._restoreScroll = self._$mdUtil.disableScrollAround(
          null,
          self.panelContainer,
          { disableScrollMask: true }
        );
      }

      // Add a custom CSS class to the panel element.
      if (self.config['panelClass']) {
        self.panelEl.addClass(self.config['panelClass']);
      }

      // Handle click and touch events for the panel container.
      if (self.config['propagateContainerEvents']) {
        self.panelContainer.css('pointer-events', 'none');
      }

      // Panel may be outside the $rootElement, tell ngAnimate to animate
      // regardless.
      if (self._$animate.pin) {
        self._$animate.pin(
          self.panelContainer,
          getElement(self.config['attachTo'])
        );
      }

      self._configureTrapFocus();
      self._addStyles().then(function() {
        resolve(self);
      }, reject);
    }, reject);

  });
};


/**
 * Adds the styles for the panel, such as positioning and z-index. Also,
 * themes the panel element and panel container using `$mdTheming`.
 * @returns {!angular.$q.Promise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._addStyles = function() {
  var self = this;
  return this._$q(function(resolve) {
    self.panelContainer.css('z-index', self.config['zIndex']);
    self.panelEl.css('z-index', self.config['zIndex'] + 1);

    var hideAndResolve = function() {
      // Theme the element and container.
      self._setTheming();

      // Remove left: -9999px and add hidden class.
      self.panelEl.css('left', '');
      self.panelContainer.addClass(MD_PANEL_HIDDEN);

      resolve(self);
    };

    if (self.config['fullscreen']) {
      self.panelEl.addClass('_md-panel-fullscreen');
      hideAndResolve();
      return; // Don't setup positioning.
    }

    var positionConfig = self.config['position'];
    if (!positionConfig) {
      hideAndResolve();
      return; // Don't setup positioning.
    }

    // Wait for angular to finish processing the template
    self._$rootScope['$$postDigest'](function() {
      // Position it correctly. This is necessary so that the panel will have a
      // defined height and width.
      self._updatePosition(true);

      // Theme the element and container.
      self._setTheming();

      resolve(self);
    });
  });
};


/**
 * Sets the `$mdTheming` classes on the `panelContainer` and `panelEl`.
 * @private
 */
MdPanelRef.prototype._setTheming = function() {
  this._$mdTheming(this.panelEl);
  this._$mdTheming(this.panelContainer);
};


/**
 * Updates the position configuration of a panel
 * @param {!MdPanelPosition} position
 */
MdPanelRef.prototype.updatePosition = function(position) {
  if (!this.panelContainer) {
    throw new Error(
        'mdPanel: Panel does not exist yet. Call open() or attach().');
  }

  this.config['position'] = position;
  this._updatePosition();
};


/**
 * Calculates and updates the position of the panel.
 * @param {boolean=} init
 * @private
 */
MdPanelRef.prototype._updatePosition = function(init) {
  var positionConfig = this.config['position'];

  if (positionConfig) {
    positionConfig._setPanelPosition(this.panelEl);

    // Hide the panel now that position is known.
    if (init) {
      this.panelContainer.addClass(MD_PANEL_HIDDEN);
    }

    this.panelEl.css(
      MdPanelPosition.absPosition.TOP,
      positionConfig.getTop()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.BOTTOM,
      positionConfig.getBottom()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.LEFT,
      positionConfig.getLeft()
    );
    this.panelEl.css(
      MdPanelPosition.absPosition.RIGHT,
      positionConfig.getRight()
    );
  }
};


/**
 * Focuses on the panel or the first focus target.
 * @private
 */
MdPanelRef.prototype._focusOnOpen = function() {
  if (this.config['focusOnOpen']) {
    // Wait for the template to finish rendering to guarantee md-autofocus has
    // finished adding the class md-autofocus, otherwise the focusable element
    // isn't available to focus.
    var self = this;
    this._$rootScope['$$postDigest'](function() {
      var target = self._$mdUtil.findFocusTarget(self.panelEl) ||
          self.panelEl;
      target.focus();
    });
  }
};


/**
 * Shows the backdrop.
 * @returns {!angular.$q.Promise} A promise that is resolved when the backdrop
 *     is created and attached.
 * @private
 */
MdPanelRef.prototype._createBackdrop = function() {
  if (this.config.hasBackdrop) {
    if (!this._backdropRef) {
      var backdropAnimation = this._$mdPanel.newPanelAnimation()
          .openFrom(this.config.attachTo)
          .withAnimation({
            open: '_md-opaque-enter',
            close: '_md-opaque-leave'
          });

      if (this.config.animation) {
        backdropAnimation.duration(this.config.animation._rawDuration);
      }

      var backdropConfig = {
        animation: backdropAnimation,
        attachTo: this.config.attachTo,
        focusOnOpen: false,
        panelClass: '_md-panel-backdrop',
        zIndex: this.config.zIndex - 1
      };

      this._backdropRef = this._$mdPanel.create(backdropConfig);
    }
    if (!this._backdropRef.isAttached) {
      return this._backdropRef.attach();
    }
  }
};


/**
 * Listen for escape keys and outside clicks to auto close.
 * @private
 */
MdPanelRef.prototype._addEventListeners = function() {
  this._configureEscapeToClose();
  this._configureClickOutsideToClose();
  this._configureScrollListener();
};


/**
 * Remove event listeners added in _addEventListeners.
 * @private
 */
MdPanelRef.prototype._removeEventListeners = function() {
  this._removeListeners && this._removeListeners.forEach(function(removeFn) {
    removeFn();
  });
  this._removeListeners = [];
};


/**
 * Setup the escapeToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureEscapeToClose = function() {
  if (this.config['escapeToClose']) {
    var parentTarget = getElement(this.config['attachTo']);
    var self = this;

    var keyHandlerFn = function(ev) {
      if (ev.keyCode === self._$mdConstant.KEY_CODE.ESCAPE) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.ESCAPE);
      }
    };

    // Add keydown listeners
    this.panelContainer.on('keydown', keyHandlerFn);
    parentTarget.on('keydown', keyHandlerFn);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      self.panelContainer.off('keydown', keyHandlerFn);
      parentTarget.off('keydown', keyHandlerFn);
    });
  }
};


/**
 * Setup the clickOutsideToClose event listeners.
 * @private
 */
MdPanelRef.prototype._configureClickOutsideToClose = function() {
  if (this.config['clickOutsideToClose']) {
    var target = this.config['propagateContainerEvents'] ?
        angular.element(document.body) :
        this.panelContainer;
    var sourceEl;

    // Keep track of the element on which the mouse originally went down
    // so that we can only close the backdrop when the 'click' started on it.
    // A simple 'click' handler does not work, it sets the target object as the
    // element the mouse went down on.
    var mousedownHandler = function(ev) {
      sourceEl = ev.target;
    };

    // We check if our original element and the target is the backdrop
    // because if the original was the backdrop and the target was inside the
    // panel we don't want to panel to close.
    var self = this;
    var mouseupHandler = function(ev) {
      if (self.config['propagateContainerEvents']) {

        // We check if the sourceEl of the event is the panel element or one
        // of it's children. If it is not, then close the panel.
        if (sourceEl !== self.panelEl[0] && !self.panelEl[0].contains(sourceEl)) {
          self.close();
        }

      } else if (sourceEl === target[0] && ev.target === target[0]) {
        ev.stopPropagation();
        ev.preventDefault();

        self.close(MdPanelRef.closeReasons.CLICK_OUTSIDE);
      }
    };

    // Add listeners
    target.on('mousedown', mousedownHandler);
    target.on('mouseup', mouseupHandler);

    // Queue remove listeners function
    this._removeListeners.push(function() {
      target.off('mousedown', mousedownHandler);
      target.off('mouseup', mouseupHandler);
    });
  }
};


/**
 * Configures the listeners for updating the panel position on scroll.
 * @private
*/
MdPanelRef.prototype._configureScrollListener = function() {
  // No need to bind the event if scrolling is disabled.
  if (!this.config['disableParentScroll']) {
    var updatePosition = angular.bind(this, this._updatePosition);
    var debouncedUpdatePosition = this._$$rAF.throttle(updatePosition);
    var self = this;

    var onScroll = function() {
      debouncedUpdatePosition();
    };

    // Add listeners.
    this._$window.addEventListener('scroll', onScroll, true);

    // Queue remove listeners function.
    this._removeListeners.push(function() {
      self._$window.removeEventListener('scroll', onScroll, true);
    });
  }
};


/**
 * Setup the focus traps. These traps will wrap focus when tabbing past the
 * panel. When shift-tabbing, the focus will stick in place.
 * @private
 */
MdPanelRef.prototype._configureTrapFocus = function() {
  // Focus doesn't remain inside of the panel without this.
  this.panelEl.attr('tabIndex', '-1');
  if (this.config['trapFocus']) {
    var element = this.panelEl;
    // Set up elements before and after the panel to capture focus and
    // redirect back into the panel.
    this._topFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];
    this._bottomFocusTrap = FOCUS_TRAP_TEMPLATE.clone()[0];

    // When focus is about to move out of the panel, we want to intercept it
    // and redirect it back to the panel element.
    var focusHandler = function() {
      element.focus();
    };
    this._topFocusTrap.addEventListener('focus', focusHandler);
    this._bottomFocusTrap.addEventListener('focus', focusHandler);

    // Queue remove listeners function
    this._removeListeners.push(this._simpleBind(function() {
      this._topFocusTrap.removeEventListener('focus', focusHandler);
      this._bottomFocusTrap.removeEventListener('focus', focusHandler);
    }, this));

    // The top focus trap inserted immediately before the md-panel element (as
    // a sibling). The bottom focus trap inserted immediately after the
    // md-panel element (as a sibling).
    element[0].parentNode.insertBefore(this._topFocusTrap, element[0]);
    element.after(this._bottomFocusTrap);
  }
};


/**
 * Updates the animation of a panel.
 * @param {!MdPanelAnimation} animation
 */
MdPanelRef.prototype.updateAnimation = function(animation) {
  this.config['animation'] = animation;

  if (this._backdropRef) {
    this._backdropRef.config.animation.duration(animation._rawDuration);
  }
};


/**
 * Animate the panel opening.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     animated open.
 * @private
 */
MdPanelRef.prototype._animateOpen = function() {
  this.panelContainer.addClass('md-panel-is-showing');
  var animationConfig = this.config['animation'];
  if (!animationConfig) {
    // Promise is in progress, return it.
    this.panelContainer.addClass('_md-panel-shown');
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve) {
    var done = self._done(resolve, self);
    var warnAndOpen = function() {
      self._$log.warn(
          'mdPanel: MdPanel Animations failed. ' +
          'Showing panel without animating.');
      done();
    };

    animationConfig.animateOpen(self.panelEl)
        .then(done, warnAndOpen);
  });
};


/**
 * Animate the panel closing.
 * @returns {!angular.$q.Promise} A promise that is resolved when the panel has
 *     animated closed.
 * @private
 */
MdPanelRef.prototype._animateClose = function() {
  var animationConfig = this.config['animation'];
  if (!animationConfig) {
    this.panelContainer.removeClass('md-panel-is-showing');
    this.panelContainer.removeClass('_md-panel-shown');
    return this._$q.when(this);
  }

  var self = this;
  return this._$q(function(resolve) {
    var done = function() {
      self.panelContainer.removeClass('md-panel-is-showing');
      resolve(self);
    };
    var warnAndClose = function() {
      self._$log.warn(
          'mdPanel: MdPanel Animations failed. ' +
          'Hiding panel without animating.');
      done();
    };

    animationConfig.animateClose(self.panelEl)
        .then(done, warnAndClose);
  });
};


/**
 * Registers a interceptor with the panel. The callback should return a promise,
 * which will allow the action to continue when it gets resolved, or will
 * prevent an action if it is rejected.
 * @param {string} type Type of interceptor.
 * @param {!angular.$q.Promise<!any>} callback Callback to be registered.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.registerInterceptor = function(type, callback) {
  var error = null;

  if (!angular.isString(type)) {
    error = 'Interceptor type must be a string, instead got ' + typeof type;
  } else if (!angular.isFunction(callback)) {
    error = 'Interceptor callback must be a function, instead got ' + typeof callback;
  }

  if (error) {
    throw new Error('MdPanel: ' + error);
  }

  var interceptors = this._interceptors[type] = this._interceptors[type] || [];

  if (interceptors.indexOf(callback) === -1) {
    interceptors.push(callback);
  }

  return this;
};


/**
 * Removes a registered interceptor.
 * @param {string} type Type of interceptor to be removed.
 * @param {Function} callback Interceptor to be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeInterceptor = function(type, callback) {
  var index = this._interceptors[type] ?
    this._interceptors[type].indexOf(callback) : -1;

  if (index > -1) {
    this._interceptors[type].splice(index, 1);
  }

  return this;
};


/**
 * Removes all interceptors.
 * @param {string=} type Type of interceptors to be removed.
 *     If ommited, all interceptors types will be removed.
 * @returns {!MdPanelRef}
 */
MdPanelRef.prototype.removeAllInterceptors = function(type) {
  if (type) {
    this._interceptors[type] = [];
  } else {
    this._interceptors = Object.create(null);
  }

  return this;
};


/**
 * Invokes all the interceptors of a certain type sequantially in
 *     reverse order. Works in a similar way to `$q.all`, except it
 *     respects the order of the functions.
 * @param {string} type Type of interceptors to be invoked.
 * @returns {!angular.$q.Promise<!MdPanelRef>}
 * @private
 */
MdPanelRef.prototype._callInterceptors = function(type) {
  var self = this;
  var $q = self._$q;
  var interceptors = self._interceptors && self._interceptors[type] || [];

  return interceptors.reduceRight(function(promise, interceptor) {
    var isPromiseLike = interceptor && angular.isFunction(interceptor.then);
    var response = isPromiseLike ? interceptor : null;

    /**
    * For interceptors to reject/cancel subsequent portions of the chain, simply
    * return a `$q.reject(<value>)`
    */
    return promise.then(function() {
      if (!response) {
        try {
          response = interceptor(self);
        } catch(e) {
          response = $q.reject(e);
        }
      }

     return response;
    });
  }, $q.resolve(self));
};


/**
 * Faster, more basic than angular.bind
 * http://jsperf.com/angular-bind-vs-custom-vs-native
 * @param {function} callback
 * @param {!Object} self
 * @return {function} Callback function with a bound self.
 */
MdPanelRef.prototype._simpleBind = function(callback, self) {
  return function(value) {
    return callback.apply(self, value);
  };
};


/**
 * @param {function} callback
 * @param {!Object} self
 * @return {function} Callback function with a self param.
 */
MdPanelRef.prototype._done = function(callback, self) {
  return function() {
    callback(self);
  };
};


/**
 * Adds a panel to a group if the panel does not exist within the group already.
 * A panel can only exist within a single group.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.addToGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    this._$mdPanel.newPanelGroup(groupName);
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index < 0) {
    group.panels.push(this);
  }
};


/**
 * Removes a panel from a group if the panel exists within that group. The group
 * must be created ahead of time.
 * @param {string} groupName The name of the group.
 */
MdPanelRef.prototype.removeFromGroup = function(groupName) {
  if (!this._$mdPanel._groups[groupName]) {
    throw new Error('mdPanel: The group ' + groupName + ' does not exist.');
  }

  var group = this._$mdPanel._groups[groupName];
  var index = group.panels.indexOf(this);

  if (index > -1) {
    group.panels.splice(index, 1);
  }
};


/**
 * Possible default closeReasons for the close function.
 * @enum {string}
 */
MdPanelRef.closeReasons = {
  CLICK_OUTSIDE: 'clickOutsideToClose',
  ESCAPE: 'escapeToClose',
};


/*****************************************************************************
 *                               MdPanelPosition                             *
 *****************************************************************************/


/**
 * Position configuration object. To use, create an MdPanelPosition with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelPosition = new MdPanelPosition()
 *     .relativeTo(myButtonEl)
 *     .addPanelPosition(
 *       $mdPanel.xPosition.CENTER,
 *       $mdPanel.yPosition.ALIGN_TOPS
 *     );
 *
 * $mdPanel.create({
 *   position: panelPosition
 * });
 *
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelPosition($injector) {
  /** @private @const {!angular.$window} */
  this._$window = $injector.get('$window');

  /** @private {boolean} */
  this._isRTL = $injector.get('$mdUtil').bidi() === 'rtl';

  /** @private @const {!angular.$mdConstant} */
  this._$mdConstant = $injector.get('$mdConstant');

  /** @private {boolean} */
  this._absolute = false;

  /** @private {!angular.JQLite} */
  this._relativeToEl;

  /** @private {string} */
  this._top = '';

  /** @private {string} */
  this._bottom = '';

  /** @private {string} */
  this._left = '';

  /** @private {string} */
  this._right = '';

  /** @private {!Array<string>} */
  this._translateX = [];

  /** @private {!Array<string>} */
  this._translateY = [];

  /** @private {!Array<{x:string, y:string}>} */
  this._positions = [];

  /** @private {?{x:string, y:string}} */
  this._actualPosition;
}


/**
 * Possible values of xPosition.
 * @enum {string}
 */
MdPanelPosition.xPosition = {
  CENTER: 'center',
  ALIGN_START: 'align-start',
  ALIGN_END: 'align-end',
  OFFSET_START: 'offset-start',
  OFFSET_END: 'offset-end'
};


/**
 * Possible values of yPosition.
 * @enum {string}
 */
MdPanelPosition.yPosition = {
  CENTER: 'center',
  ALIGN_TOPS: 'align-tops',
  ALIGN_BOTTOMS: 'align-bottoms',
  ABOVE: 'above',
  BELOW: 'below'
};


/**
 * Possible values of absolute position.
 * @enum {string}
 */
MdPanelPosition.absPosition = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left'
};

/**
 * Margin between the edges of a panel and the viewport.
 * @const {number}
 */
MdPanelPosition.viewportMargin = 8;


/**
 * Sets absolute positioning for the panel.
 * @return {!MdPanelPosition}
 */
MdPanelPosition.prototype.absolute = function() {
  this._absolute = true;
  return this;
};


/**
 * Sets the value of a position for the panel. Clears any previously set
 * position.
 * @param {string} position Position to set
 * @param {string=} value Value of the position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 * @private
 */
MdPanelPosition.prototype._setPosition = function(position, value) {
  if (position === MdPanelPosition.absPosition.RIGHT ||
      position === MdPanelPosition.absPosition.LEFT) {
    this._left = this._right = '';
  } else if (
      position === MdPanelPosition.absPosition.BOTTOM ||
      position === MdPanelPosition.absPosition.TOP) {
    this._top = this._bottom = '';
  } else {
    var positions = Object.keys(MdPanelPosition.absPosition).join()
        .toLowerCase();

    throw new Error('mdPanel: Position must be one of ' + positions + '.');
  }

  this['_' +  position] = angular.isString(value) ? value : '0';

  return this;
};


/**
 * Sets the value of `top` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} top Value of `top`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.top = function(top) {
  return this._setPosition(MdPanelPosition.absPosition.TOP, top);
};


/**
 * Sets the value of `bottom` for the panel. Clears any previously set vertical
 * position.
 * @param {string=} bottom Value of `bottom`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.bottom = function(bottom) {
  return this._setPosition(MdPanelPosition.absPosition.BOTTOM, bottom);
};


/**
 * Sets the panel to the start of the page - `left` if `ltr` or `right` for
 * `rtl`. Clears any previously set horizontal position.
 * @param {string=} start Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.start = function(start) {
  var position = this._isRTL ? MdPanelPosition.absPosition.RIGHT : MdPanelPosition.absPosition.LEFT;
  return this._setPosition(position, start);
};


/**
 * Sets the panel to the end of the page - `right` if `ltr` or `left` for `rtl`.
 * Clears any previously set horizontal position.
 * @param {string=} end Value of position. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.end = function(end) {
  var position = this._isRTL ? MdPanelPosition.absPosition.LEFT : MdPanelPosition.absPosition.RIGHT;
  return this._setPosition(position, end);
};


/**
 * Sets the value of `left` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} left Value of `left`. Defaults to '0'.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.left = function(left) {
  return this._setPosition(MdPanelPosition.absPosition.LEFT, left);
};


/**
 * Sets the value of `right` for the panel. Clears any previously set
 * horizontal position.
 * @param {string=} right Value of `right`. Defaults to '0'.
 * @returns {!MdPanelPosition}
*/
MdPanelPosition.prototype.right = function(right) {
  return this._setPosition(MdPanelPosition.absPosition.RIGHT, right);
};


/**
 * Centers the panel horizontally in the viewport. Clears any previously set
 * horizontal position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerHorizontally = function() {
  this._left = '50%';
  this._right = '';
  this._translateX = ['-50%'];
  return this;
};


/**
 * Centers the panel vertically in the viewport. Clears any previously set
 * vertical position.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.centerVertically = function() {
  this._top = '50%';
  this._bottom = '';
  this._translateY = ['-50%'];
  return this;
};


/**
 * Centers the panel horizontally and vertically in the viewport. This is
 * equivalent to calling both `centerHorizontally` and `centerVertically`.
 * Clears any previously set horizontal and vertical positions.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.center = function() {
  return this.centerHorizontally().centerVertically();
};


/**
 * Sets element for relative positioning.
 * @param {string|!Element|!angular.JQLite} element Query selector, DOM element,
 *     or angular element to set the panel relative to.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.relativeTo = function(element) {
  this._absolute = false;
  this._relativeToEl = getElement(element);
  return this;
};


/**
 * Sets the x and y positions for the panel relative to another element.
 * @param {string} xPosition must be one of the MdPanelPosition.xPosition
 *     values.
 * @param {string} yPosition must be one of the MdPanelPosition.yPosition
 *     values.
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.addPanelPosition = function(xPosition, yPosition) {
  if (!this._relativeToEl) {
    throw new Error('mdPanel: addPanelPosition can only be used with ' +
        'relative positioning. Set relativeTo first.');
  }

  this._validateXPosition(xPosition);
  this._validateYPosition(yPosition);

  this._positions.push({
      x: xPosition,
      y: yPosition,
  });
  return this;
};


/**
 * Ensures that yPosition is a valid position name. Throw an exception if not.
 * @param {string} yPosition
 */
MdPanelPosition.prototype._validateYPosition = function(yPosition) {
  // empty is ok
  if (yPosition == null) {
      return;
  }

  var positionKeys = Object.keys(MdPanelPosition.yPosition);
  var positionValues = [];
  for (var key, i = 0; key = positionKeys[i]; i++) {
    var position = MdPanelPosition.yPosition[key];
    positionValues.push(position);

    if (position === yPosition) {
      return;
    }
  }

  throw new Error('mdPanel: Panel y position only accepts the following ' +
      'values:\n' + positionValues.join(' | '));
};


/**
 * Ensures that xPosition is a valid position name. Throw an exception if not.
 * @param {string} xPosition
 */
MdPanelPosition.prototype._validateXPosition = function(xPosition) {
  // empty is ok
  if (xPosition == null) {
      return;
  }

  var positionKeys = Object.keys(MdPanelPosition.xPosition);
  var positionValues = [];
  for (var key, i = 0; key = positionKeys[i]; i++) {
    var position = MdPanelPosition.xPosition[key];
    positionValues.push(position);
    if (position === xPosition) {
      return;
    }
  }

  throw new Error('mdPanel: Panel x Position only accepts the following ' +
      'values:\n' + positionValues.join(' | '));
};


/**
 * Sets the value of the offset in the x-direction. This will add to any
 * previously set offsets.
 * @param {string|function(MdPanelPosition): string} offsetX
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetX = function(offsetX) {
  this._translateX.push(offsetX);
  return this;
};


/**
 * Sets the value of the offset in the y-direction. This will add to any
 * previously set offsets.
 * @param {string|function(MdPanelPosition): string} offsetY
 * @returns {!MdPanelPosition}
 */
MdPanelPosition.prototype.withOffsetY = function(offsetY) {
  this._translateY.push(offsetY);
  return this;
};


/**
 * Gets the value of `top` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getTop = function() {
  return this._top;
};


/**
 * Gets the value of `bottom` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getBottom = function() {
  return this._bottom;
};


/**
 * Gets the value of `left` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getLeft = function() {
  return this._left;
};


/**
 * Gets the value of `right` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getRight = function() {
  return this._right;
};


/**
 * Gets the value of `transform` for the panel.
 * @returns {string}
 */
MdPanelPosition.prototype.getTransform = function() {
  var translateX = this._reduceTranslateValues('translateX', this._translateX);
  var translateY = this._reduceTranslateValues('translateY', this._translateY);

  // It's important to trim the result, because the browser will ignore the set
  // operation if the string contains only whitespace.
  return (translateX + ' ' + translateY).trim();
};


/**
 * Sets the `transform` value for a panel element.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.JQLite}
 * @private
 */
MdPanelPosition.prototype._setTransform = function(panelEl) {
  return panelEl.css(this._$mdConstant.CSS.TRANSFORM, this.getTransform());
};


/**
 * True if the panel is completely on-screen with this positioning; false
 * otherwise.
 * @param {!angular.JQLite} panelEl
 * @return {boolean}
 * @private
 */
MdPanelPosition.prototype._isOnscreen = function(panelEl) {
  // this works because we always use fixed positioning for the panel,
  // which is relative to the viewport.
  var left = parseInt(this.getLeft());
  var top = parseInt(this.getTop());

  if (this._translateX.length || this._translateY.length) {
    var prefixedTransform = this._$mdConstant.CSS.TRANSFORM;
    var offsets = getComputedTranslations(panelEl, prefixedTransform);
    left += offsets.x;
    top += offsets.y;
  }

  var right = left + panelEl[0].offsetWidth;
  var bottom = top + panelEl[0].offsetHeight;

  return (left >= 0) &&
    (top >= 0) &&
    (bottom <= this._$window.innerHeight) &&
    (right <= this._$window.innerWidth);
};


/**
 * Gets the first x/y position that can fit on-screen.
 * @returns {{x: string, y: string}}
 */
MdPanelPosition.prototype.getActualPosition = function() {
  return this._actualPosition;
};


/**
 * Reduces a list of translate values to a string that can be used within
 * transform.
 * @param {string} translateFn
 * @param {!Array<string>} values
 * @returns {string}
 * @private
 */
MdPanelPosition.prototype._reduceTranslateValues =
    function(translateFn, values) {
      return values.map(function(translation) {
        // TODO(crisbeto): this should add the units after #9609 is merged.
        var translationValue = angular.isFunction(translation) ?
            translation(this) : translation;
        return translateFn + '(' + translationValue + ')';
      }, this).join(' ');
    };


/**
 * Sets the panel position based on the created panel element and best x/y
 * positioning.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelPosition.prototype._setPanelPosition = function(panelEl) {
  // Remove the "position adjusted" class in case it has been added before.
  panelEl.removeClass('_md-panel-position-adjusted');

  // Only calculate the position if necessary.
  if (this._absolute) {
    this._setTransform(panelEl);
    return;
  }

  if (this._actualPosition) {
    this._calculatePanelPosition(panelEl, this._actualPosition);
    this._setTransform(panelEl);
    this._constrainToViewport(panelEl);
    return;
  }

  for (var i = 0; i < this._positions.length; i++) {
    this._actualPosition = this._positions[i];
    this._calculatePanelPosition(panelEl, this._actualPosition);
    this._setTransform(panelEl);

    if (this._isOnscreen(panelEl)) {
      return;
    }
  }

  this._constrainToViewport(panelEl);
};


/**
 * Constrains a panel's position to the viewport.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelPosition.prototype._constrainToViewport = function(panelEl) {
  var margin = MdPanelPosition.viewportMargin;
  var initialTop = this._top;
  var initialLeft = this._left;

  if (this.getTop()) {
    var top = parseInt(this.getTop());
    var bottom = panelEl[0].offsetHeight + top;
    var viewportHeight = this._$window.innerHeight;

    if (top < margin) {
      this._top = margin + 'px';
    } else if (bottom > viewportHeight) {
      this._top = top - (bottom - viewportHeight + margin) + 'px';
    }
  }

  if (this.getLeft()) {
    var left = parseInt(this.getLeft());
    var right = panelEl[0].offsetWidth + left;
    var viewportWidth = this._$window.innerWidth;

    if (left < margin) {
      this._left = margin + 'px';
    } else if (right > viewportWidth) {
      this._left = left - (right - viewportWidth + margin) + 'px';
    }
  }

  // Class that can be used to re-style the panel if it was repositioned.
  panelEl.toggleClass(
    '_md-panel-position-adjusted',
    this._top !== initialTop || this._left !== initialLeft
  );
};


/**
 * Switches between 'start' and 'end'.
 * @param {string} position Horizontal position of the panel
 * @returns {string} Reversed position
 * @private
 */
MdPanelPosition.prototype._reverseXPosition = function(position) {
  if (position === MdPanelPosition.xPosition.CENTER) {
    return;
  }

  var start = 'start';
  var end = 'end';

  return position.indexOf(start) > -1 ? position.replace(start, end) : position.replace(end, start);
};


/**
 * Handles horizontal positioning in rtl or ltr environments.
 * @param {string} position Horizontal position of the panel
 * @returns {string} The correct position according the page direction
 * @private
 */
MdPanelPosition.prototype._bidi = function(position) {
  return this._isRTL ? this._reverseXPosition(position) : position;
};


/**
 * Calculates the panel position based on the created panel element and the
 * provided positioning.
 * @param {!angular.JQLite} panelEl
 * @param {!{x:string, y:string}} position
 * @private
 */
MdPanelPosition.prototype._calculatePanelPosition = function(panelEl, position) {

  var panelBounds = panelEl[0].getBoundingClientRect();
  var panelWidth = panelBounds.width;
  var panelHeight = panelBounds.height;

  var targetBounds = this._relativeToEl[0].getBoundingClientRect();

  var targetLeft = targetBounds.left;
  var targetRight = targetBounds.right;
  var targetWidth = targetBounds.width;

  switch (this._bidi(position.x)) {
    case MdPanelPosition.xPosition.OFFSET_START:
      this._left = targetLeft - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_END:
      this._left = targetRight - panelWidth + 'px';
      break;
    case MdPanelPosition.xPosition.CENTER:
      var left = targetLeft + (0.5 * targetWidth) - (0.5 * panelWidth);
      this._left = left + 'px';
      break;
    case MdPanelPosition.xPosition.ALIGN_START:
      this._left = targetLeft + 'px';
      break;
    case MdPanelPosition.xPosition.OFFSET_END:
      this._left = targetRight + 'px';
      break;
  }

  var targetTop = targetBounds.top;
  var targetBottom = targetBounds.bottom;
  var targetHeight = targetBounds.height;

  switch (position.y) {
    case MdPanelPosition.yPosition.ABOVE:
      this._top = targetTop - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_BOTTOMS:
      this._top = targetBottom - panelHeight + 'px';
      break;
    case MdPanelPosition.yPosition.CENTER:
      var top = targetTop + (0.5 * targetHeight) - (0.5 * panelHeight);
      this._top = top + 'px';
      break;
    case MdPanelPosition.yPosition.ALIGN_TOPS:
      this._top = targetTop + 'px';
      break;
    case MdPanelPosition.yPosition.BELOW:
      this._top = targetBottom + 'px';
      break;
  }
};


/*****************************************************************************
 *                               MdPanelAnimation                            *
 *****************************************************************************/


/**
 * Animation configuration object. To use, create an MdPanelAnimation with the
 * desired properties, then pass the object as part of $mdPanel creation.
 *
 * Example:
 *
 * var panelAnimation = new MdPanelAnimation()
 *     .openFrom(myButtonEl)
 *     .closeTo('.my-button')
 *     .withAnimation($mdPanel.animation.SCALE);
 *
 * $mdPanel.create({
 *   animation: panelAnimation
 * });
 *
 * @param {!angular.$injector} $injector
 * @final @constructor
 */
function MdPanelAnimation($injector) {
  /** @private @const {!angular.$mdUtil} */
  this._$mdUtil = $injector.get('$mdUtil');

  /**
   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._openFrom;

  /**
   * @private {{element: !angular.JQLite|undefined, bounds: !DOMRect}|
   *     undefined}
   */
  this._closeTo;

  /** @private {string|{open: string, close: string}} */
  this._animationClass = '';

  /** @private {number} */
  this._openDuration;

  /** @private {number} */
  this._closeDuration;

  /** @private {number|{open: number, close: number}} */
  this._rawDuration;
}


/**
 * Possible default animations.
 * @enum {string}
 */
MdPanelAnimation.animation = {
  SLIDE: 'md-panel-animate-slide',
  SCALE: 'md-panel-animate-scale',
  FADE: 'md-panel-animate-fade'
};


/**
 * Specifies where to start the open animation. `openFrom` accepts a
 * click event object, query selector, DOM element, or a Rect object that
 * is used to determine the bounds. When passed a click event, the location
 * of the click will be used as the position to start the animation.
 * @param {string|!Element|!Event|{top: number, left: number}} openFrom
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.openFrom = function(openFrom) {
  // Check if 'openFrom' is an Event.
  openFrom = openFrom.target ? openFrom.target : openFrom;

  this._openFrom = this._getPanelAnimationTarget(openFrom);

  if (!this._closeTo) {
    this._closeTo = this._openFrom;
  }
  return this;
};


/**
 * Specifies where to animate the panel close. `closeTo` accepts a
 * query selector, DOM element, or a Rect object that is used to determine
 * the bounds.
 * @param {string|!Element|{top: number, left: number}} closeTo
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.closeTo = function(closeTo) {
  this._closeTo = this._getPanelAnimationTarget(closeTo);
  return this;
};


/**
 * Specifies the duration of the animation in milliseconds.
 * @param {number|{open: number, close: number}} duration
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.duration = function(duration) {
  if (duration) {
    if (angular.isNumber(duration)) {
      this._openDuration = this._closeDuration = toSeconds(duration);
    } else if (angular.isObject(duration)) {
      this._openDuration = toSeconds(duration.open);
      this._closeDuration = toSeconds(duration.close);
    }
  }

  // Save the original value so it can be passed to the backdrop.
  this._rawDuration = duration;

  return this;

  function toSeconds(value) {
    if (angular.isNumber(value)) return value / 1000;
  }
};


/**
 * Returns the element and bounds for the animation target.
 * @param {string|!Element|{top: number, left: number}} location
 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getPanelAnimationTarget = function(location) {
  if (angular.isDefined(location.top) || angular.isDefined(location.left)) {
    return {
      element: undefined,
      bounds: {
        top: location.top || 0,
        left: location.left || 0
      }
    };
  } else {
    return this._getBoundingClientRect(getElement(location));
  }
};


/**
 * Specifies the animation class.
 *
 * There are several default animations that can be used:
 * (MdPanelAnimation.animation)
 *   SLIDE: The panel slides in and out from the specified
 *        elements.
 *   SCALE: The panel scales in and out.
 *   FADE: The panel fades in and out.
 *
 * @param {string|{open: string, close: string}} cssClass
 * @returns {!MdPanelAnimation}
 */
MdPanelAnimation.prototype.withAnimation = function(cssClass) {
  this._animationClass = cssClass;
  return this;
};


/**
 * Animate the panel open.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.$q.Promise} A promise that is resolved when the open
 *     animation is complete.
 */
MdPanelAnimation.prototype.animateOpen = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;

  this._fixBounds(panelEl);
  var animationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var openFrom = animator.toTransformCss(panelTransform);
  var openTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');

      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };

      var openSlide = animator.calculateSlideToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(openSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };

      var openScale = animator.calculateZoomToOrigin(
              panelEl, this._openFrom) || '';
      openFrom = animator.toTransformCss(openScale + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.FADE:
      animationOptions = {
        transitionInClass: '_md-panel-animate-enter'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        animationOptions = {
          transitionInClass: this._animationClass
        };
      } else {
        animationOptions = {
          transitionInClass: this._animationClass['open'],
          transitionOutClass: this._animationClass['close'],
        };
      }
  }

  animationOptions.duration = this._openDuration;

  return animator
      .translate3d(panelEl, openFrom, openTo, animationOptions);
};


/**
 * Animate the panel close.
 * @param {!angular.JQLite} panelEl
 * @returns {!angular.$q.Promise} A promise that resolves when the close
 *     animation is complete.
 */
MdPanelAnimation.prototype.animateClose = function(panelEl) {
  var animator = this._$mdUtil.dom.animator;
  var reverseAnimationOptions = {};

  // Include the panel transformations when calculating the animations.
  var panelTransform = panelEl[0].style.transform || '';

  var closeFrom = animator.toTransformCss(panelTransform);
  var closeTo = animator.toTransformCss(panelTransform);

  switch (this._animationClass) {
    case MdPanelAnimation.animation.SLIDE:
      // Slide should start with opacity: 1.
      panelEl.css('opacity', '1');
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-leave'
      };

      var closeSlide = animator.calculateSlideToOrigin(
              panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(closeSlide + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.SCALE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-scale-out _md-panel-animate-leave'
      };

      var closeScale = animator.calculateZoomToOrigin(
              panelEl, this._closeTo) || '';
      closeTo = animator.toTransformCss(closeScale + ' ' + panelTransform);
      break;

    case MdPanelAnimation.animation.FADE:
      reverseAnimationOptions = {
        transitionInClass: '_md-panel-animate-fade-out _md-panel-animate-leave'
      };
      break;

    default:
      if (angular.isString(this._animationClass)) {
        reverseAnimationOptions = {
          transitionOutClass: this._animationClass
        };
      } else {
        reverseAnimationOptions = {
          transitionInClass: this._animationClass['close'],
          transitionOutClass: this._animationClass['open']
        };
      }
  }

  reverseAnimationOptions.duration = this._closeDuration;

  return animator
      .translate3d(panelEl, closeFrom, closeTo, reverseAnimationOptions);
};


/**
 * Set the height and width to match the panel if not provided.
 * @param {!angular.JQLite} panelEl
 * @private
 */
MdPanelAnimation.prototype._fixBounds = function(panelEl) {
  var panelWidth = panelEl[0].offsetWidth;
  var panelHeight = panelEl[0].offsetHeight;

  if (this._openFrom && this._openFrom.bounds.height == null) {
    this._openFrom.bounds.height = panelHeight;
  }
  if (this._openFrom && this._openFrom.bounds.width == null) {
    this._openFrom.bounds.width = panelWidth;
  }
  if (this._closeTo && this._closeTo.bounds.height == null) {
    this._closeTo.bounds.height = panelHeight;
  }
  if (this._closeTo && this._closeTo.bounds.width == null) {
    this._closeTo.bounds.width = panelWidth;
  }
};


/**
 * Identify the bounding RECT for the target element.
 * @param {!angular.JQLite} element
 * @returns {{element: !angular.JQLite|undefined, bounds: !DOMRect}}
 * @private
 */
MdPanelAnimation.prototype._getBoundingClientRect = function(element) {
  if (element instanceof angular.element) {
    return {
      element: element,
      bounds: element[0].getBoundingClientRect()
    };
  }
};


/*****************************************************************************
 *                                Util Methods                               *
 *****************************************************************************/


/**
 * Returns the angular element associated with a css selector or element.
 * @param el {string|!angular.JQLite|!Element}
 * @returns {!angular.JQLite}
 */
function getElement(el) {
  var queryResult = angular.isString(el) ?
      document.querySelector(el) : el;
  return angular.element(queryResult);
}


/**
 * Gets the computed values for an element's translateX and translateY in px.
 * @param {!angular.JQLite|!Element} el
 * @param {string} property
 * @return {{x: number, y: number}}
 */
function getComputedTranslations(el, property) {
  // The transform being returned by `getComputedStyle` is in the format:
  // `matrix(a, b, c, d, translateX, translateY)` if defined and `none`
  // if the element doesn't have a transform.
  var transform = getComputedStyle(el[0] || el)[property];
  var openIndex = transform.indexOf('(');
  var closeIndex = transform.lastIndexOf(')');
  var output = { x: 0, y: 0 };

  if (openIndex > -1 && closeIndex > -1) {
    var parsedValues = transform
      .substring(openIndex + 1, closeIndex)
      .split(', ')
      .slice(-2);

    output.x = parseInt(parsedValues[0]);
    output.y = parseInt(parsedValues[1]);
  }

  return output;
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.radioButton
 * @description radioButton module!
 */
mdRadioGroupDirective['$inject'] = ["$mdUtil", "$mdConstant", "$mdTheming", "$timeout"];
mdRadioButtonDirective['$inject'] = ["$mdAria", "$mdUtil", "$mdTheming"];
angular.module('material.components.radioButton', [
  'material.core'
])
  .directive('mdRadioGroup', mdRadioGroupDirective)
  .directive('mdRadioButton', mdRadioButtonDirective);

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioGroup
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-group>` directive identifies a grouping
 * container for the 1..n grouped radio buttons; specified using nested
 * `<md-radio-button>` tags.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the radio button is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * Note: `<md-radio-group>` and `<md-radio-button>` handle tabindex differently
 * than the native `<input type='radio'>` controls. Whereas the native controls
 * force the user to tab through all the radio buttons, `<md-radio-group>`
 * is focusable, and by default the `<md-radio-button>`s are not.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {boolean=} md-no-ink Use of attribute indicates flag to disable ink ripple effects.
 *
 * @usage
 * <hljs lang="html">
 * <md-radio-group ng-model="selected">
 *
 *   <md-radio-button
 *        ng-repeat="d in colorOptions"
 *        ng-value="d.value" aria-label="{{ d.label }}">
 *
 *          {{ d.label }}
 *
 *   </md-radio-button>
 *
 * </md-radio-group>
 * </hljs>
 *
 */
function mdRadioGroupDirective($mdUtil, $mdConstant, $mdTheming, $timeout) {
  RadioGroupController.prototype = createRadioGroupControllerProto();

  return {
    restrict: 'E',
    controller: ['$element', RadioGroupController],
    require: ['mdRadioGroup', '?ngModel'],
    link: { pre: linkRadioGroup }
  };

  function linkRadioGroup(scope, element, attr, ctrls) {
    element.addClass('_md');     // private md component indicator for styling
    $mdTheming(element);

    var rgCtrl = ctrls[0];
    var ngModelCtrl = ctrls[1] || $mdUtil.fakeNgModel();

    rgCtrl.init(ngModelCtrl);

    scope.mouseActive = false;

    element
      .attr({
        'role': 'radiogroup',
        'tabIndex': element.attr('tabindex') || '0'
      })
      .on('keydown', keydownListener)
      .on('mousedown', function(event) {
        scope.mouseActive = true;
        $timeout(function() {
          scope.mouseActive = false;
        }, 100);
      })
      .on('focus', function() {
        if(scope.mouseActive === false) {
          rgCtrl.$element.addClass('md-focused');
        }
      })
      .on('blur', function() {
        rgCtrl.$element.removeClass('md-focused');
      });

    /**
     *
     */
    function setFocus() {
      if (!element.hasClass('md-focused')) { element.addClass('md-focused'); }
    }

    /**
     *
     */
    function keydownListener(ev) {
      var keyCode = ev.which || ev.keyCode;

      // Only listen to events that we originated ourselves
      // so that we don't trigger on things like arrow keys in
      // inputs.

      if (keyCode != $mdConstant.KEY_CODE.ENTER &&
          ev.currentTarget != ev.target) {
        return;
      }

      switch (keyCode) {
        case $mdConstant.KEY_CODE.LEFT_ARROW:
        case $mdConstant.KEY_CODE.UP_ARROW:
          ev.preventDefault();
          rgCtrl.selectPrevious();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.RIGHT_ARROW:
        case $mdConstant.KEY_CODE.DOWN_ARROW:
          ev.preventDefault();
          rgCtrl.selectNext();
          setFocus();
          break;

        case $mdConstant.KEY_CODE.ENTER:
          var form = angular.element($mdUtil.getClosest(element[0], 'form'));
          if (form.length > 0) {
            form.triggerHandler('submit');
          }
          break;
      }

    }
  }

  function RadioGroupController($element) {
    this._radioButtonRenderFns = [];
    this.$element = $element;
  }

  function createRadioGroupControllerProto() {
    return {
      init: function(ngModelCtrl) {
        this._ngModelCtrl = ngModelCtrl;
        this._ngModelCtrl.$render = angular.bind(this, this.render);
      },
      add: function(rbRender) {
        this._radioButtonRenderFns.push(rbRender);
      },
      remove: function(rbRender) {
        var index = this._radioButtonRenderFns.indexOf(rbRender);
        if (index !== -1) {
          this._radioButtonRenderFns.splice(index, 1);
        }
      },
      render: function() {
        this._radioButtonRenderFns.forEach(function(rbRender) {
          rbRender();
        });
      },
      setViewValue: function(value, eventType) {
        this._ngModelCtrl.$setViewValue(value, eventType);
        // update the other radio buttons as well
        this.render();
      },
      getViewValue: function() {
        return this._ngModelCtrl.$viewValue;
      },
      selectNext: function() {
        return changeSelectedButton(this.$element, 1);
      },
      selectPrevious: function() {
        return changeSelectedButton(this.$element, -1);
      },
      setActiveDescendant: function (radioId) {
        this.$element.attr('aria-activedescendant', radioId);
      },
      isDisabled: function() {
        return this.$element[0].hasAttribute('disabled');
      }
    };
  }
  /**
   * Change the radio group's selected button by a given increment.
   * If no button is selected, select the first button.
   */
  function changeSelectedButton(parent, increment) {
    // Coerce all child radio buttons into an array, then wrap then in an iterator
    var buttons = $mdUtil.iterator(parent[0].querySelectorAll('md-radio-button'), true);

    if (buttons.count()) {
      var validate = function (button) {
        // If disabled, then NOT valid
        return !angular.element(button).attr("disabled");
      };

      var selected = parent[0].querySelector('md-radio-button.md-checked');
      var target = buttons[increment < 0 ? 'previous' : 'next'](selected, validate) || buttons.first();

      // Activate radioButton's click listener (triggerHandler won't create a real click event)
      angular.element(target).triggerHandler('click');
    }
  }

}

/**
 * @ngdoc directive
 * @module material.components.radioButton
 * @name mdRadioButton
 *
 * @restrict E
 *
 * @description
 * The `<md-radio-button>`directive is the child directive required to be used within `<md-radio-group>` elements.
 *
 * While similar to the `<input type="radio" ng-model="" value="">` directive,
 * the `<md-radio-button>` directive provides ink effects, ARIA support, and
 * supports use within named radio groups.
 *
 * @param {string} ngModel Assignable angular expression to data-bind to.
 * @param {string=} ngChange Angular expression to be executed when input changes due to user
 *    interaction with the input element.
 * @param {string} ngValue Angular expression which sets the value to which the expression should
 *    be set when selected.
 * @param {string} value The value to which the expression should be set when selected.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {string=} aria-label Adds label to radio button for accessibility.
 * Defaults to radio button's text. If no text content is available, a warning will be logged.
 *
 * @usage
 * <hljs lang="html">
 *
 * <md-radio-button value="1" aria-label="Label 1">
 *   Label 1
 * </md-radio-button>
 *
 * <md-radio-button ng-model="color" ng-value="specialValue" aria-label="Green">
 *   Green
 * </md-radio-button>
 *
 * </hljs>
 *
 */
function mdRadioButtonDirective($mdAria, $mdUtil, $mdTheming) {

  var CHECKED_CSS = 'md-checked';

  return {
    restrict: 'E',
    require: '^mdRadioGroup',
    transclude: true,
    template: '<div class="md-container" md-ink-ripple md-ink-ripple-checkbox>' +
                '<div class="md-off"></div>' +
                '<div class="md-on"></div>' +
              '</div>' +
              '<div ng-transclude class="md-label"></div>',
    link: link
  };

  function link(scope, element, attr, rgCtrl) {
    var lastChecked;

    $mdTheming(element);
    configureAria(element, scope);

    // ngAria overwrites the aria-checked inside a $watch for ngValue.
    // We should defer the initialization until all the watches have fired.
    // This can also be fixed by removing the `lastChecked` check, but that'll
    // cause more DOM manipulation on each digest.
    if (attr.ngValue) {
      $mdUtil.nextTick(initialize, false);
    } else {
      initialize();
    }

    /**
     * Initializes the component.
     */
    function initialize() {
      if (!rgCtrl) {
        throw 'RadioButton: No RadioGroupController could be found.';
      }

      rgCtrl.add(render);
      attr.$observe('value', render);

      element
        .on('click', listener)
        .on('$destroy', function() {
          rgCtrl.remove(render);
        });
    }

    /**
     * On click functionality.
     */
    function listener(ev) {
      if (element[0].hasAttribute('disabled') || rgCtrl.isDisabled()) return;

      scope.$apply(function() {
        rgCtrl.setViewValue(attr.value, ev && ev.type);
      });
    }

    /**
     *  Add or remove the `.md-checked` class from the RadioButton (and conditionally its parent).
     *  Update the `aria-activedescendant` attribute.
     */
    function render() {
      var checked = rgCtrl.getViewValue() == attr.value;

      if (checked === lastChecked) return;

      if (element[0].parentNode.nodeName.toLowerCase() !== 'md-radio-group') {
        // If the radioButton is inside a div, then add class so highlighting will work
        element.parent().toggleClass(CHECKED_CSS, checked);
      }

      if (checked) {
        rgCtrl.setActiveDescendant(element.attr('id'));
      }

      lastChecked = checked;

      element
        .attr('aria-checked', checked)
        .toggleClass(CHECKED_CSS, checked);
    }

    /**
     * Inject ARIA-specific attributes appropriate for each radio button
     */
    function configureAria(element, scope){
      element.attr({
        id: attr.id || 'radio_' + $mdUtil.nextUid(),
        role: 'radio',
        'aria-checked': 'false'
      });

      $mdAria.expectWithText(element, 'aria-label');
    }
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.select
 */

/***************************************************

 ### TODO - POST RC1 ###
 - [ ] Abstract placement logic in $mdSelect service to $mdMenu service

 ***************************************************/

SelectDirective['$inject'] = ["$mdSelect", "$mdUtil", "$mdConstant", "$mdTheming", "$mdAria", "$parse", "$sce", "$injector"];
SelectMenuDirective['$inject'] = ["$parse", "$mdUtil", "$mdConstant", "$mdTheming"];
OptionDirective['$inject'] = ["$mdButtonInkRipple", "$mdUtil"];
SelectProvider['$inject'] = ["$$interimElementProvider"];
var SELECT_EDGE_MARGIN = 8;
var selectNextId = 0;
var CHECKBOX_SELECTION_INDICATOR =
  angular.element('<div class="md-container"><div class="md-icon"></div></div>');

angular.module('material.components.select', [
    'material.core',
    'material.components.backdrop'
  ])
  .directive('mdSelect', SelectDirective)
  .directive('mdSelectMenu', SelectMenuDirective)
  .directive('mdOption', OptionDirective)
  .directive('mdOptgroup', OptgroupDirective)
  .directive('mdSelectHeader', SelectHeaderDirective)
  .provider('$mdSelect', SelectProvider);

/**
 * @ngdoc directive
 * @name mdSelect
 * @restrict E
 * @module material.components.select
 *
 * @description Displays a select box, bound to an ng-model.
 *
 * When the select is required and uses a floating label, then the label will automatically contain
 * an asterisk (`*`). This behavior can be disabled by using the `md-no-asterisk` attribute.
 *
 * By default, the select will display with an underline to match other form elements. This can be
 * disabled by applying the `md-no-underline` CSS class.
 *
 * ### Option Params
 *
 * When applied, `md-option-empty` will mark the option as "empty" allowing the option to  clear the
 * select and put it back in it's default state. You may supply this attribute on any option you
 * wish, however, it is automatically applied to an option whose `value` or `ng-value` are not
 * defined.
 *
 * **Automatically Applied**
 *
 *  - `<md-option>`
 *  - `<md-option value>`
 *  - `<md-option value="">`
 *  - `<md-option ng-value>`
 *  - `<md-option ng-value="">`
 *
 * **NOT Automatically Applied**
 *
 *  - `<md-option ng-value="1">`
 *  - `<md-option ng-value="''">`
 *  - `<md-option ng-value="undefined">`
 *  - `<md-option value="undefined">` (this evaluates to the string `"undefined"`)
 *  - <code ng-non-bindable>&lt;md-option ng-value="{{someValueThatMightBeUndefined}}"&gt;</code>
 *
 * **Note:** A value of `undefined` ***is considered a valid value*** (and does not auto-apply this
 * attribute) since you may wish this to be your "Not Available" or "None" option.
 *
 * **Note:** Using the `value` attribute (as opposed to `ng-value`) always evaluates to a string, so
 * `value="null"` will require the test `ng-if="myValue != 'null'"` rather than `ng-if="!myValue"`.
 *
 * @param {expression} ng-model The model!
 * @param {boolean=} multiple When set to true, allows for more than one option to be selected. The model is an array with the selected choices.
 * @param {expression=} md-on-close Expression to be evaluated when the select is closed.
 * @param {expression=} md-on-open Expression to be evaluated when opening the select.
 * Will hide the select options and show a spinner until the evaluated promise resolves.
 * @param {expression=} md-selected-text Expression to be evaluated that will return a string
 * to be displayed as a placeholder in the select input box when it is closed. The value
 * will be treated as *text* (not html).
 * @param {expression=} md-selected-html Expression to be evaluated that will return a string
 * to be displayed as a placeholder in the select input box when it is closed. The value
 * will be treated as *html*. The value must either be explicitly marked as trustedHtml or
 * the ngSanitize module must be loaded.
 * @param {string=} placeholder Placeholder hint text.
 * @param md-no-asterisk {boolean=} When set to true, an asterisk will not be appended to the
 * floating label. **Note:** This attribute is only evaluated once; it is not watched.
 * @param {string=} aria-label Optional label for accessibility. Only necessary if no placeholder or
 * explicit label is present.
 * @param {string=} md-container-class Class list to get applied to the `.md-select-menu-container`
 * element (for custom styling).
 *
 * @usage
 * With a placeholder (label and aria-label are added dynamically)
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select
 *       ng-model="someModel"
 *       placeholder="Select a state">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * With an explicit label
 * <hljs lang="html">
 *   <md-input-container>
 *     <label>State</label>
 *     <md-select
 *       ng-model="someModel">
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * With a select-header
 *
 * When a developer needs to put more than just a text label in the
 * md-select-menu, they should use the md-select-header.
 * The user can put custom HTML inside of the header and style it to their liking.
 * One common use case of this would be a sticky search bar.
 *
 * When using the md-select-header the labels that would previously be added to the
 * OptGroupDirective are ignored.
 *
 * <hljs lang="html">
 *   <md-input-container>
 *     <md-select ng-model="someModel">
 *       <md-select-header>
 *         <span> Neighborhoods - </span>
 *       </md-select-header>
 *       <md-option ng-value="opt" ng-repeat="opt in neighborhoods2">{{ opt }}</md-option>
 *     </md-select>
 *   </md-input-container>
 * </hljs>
 *
 * ## Selects and object equality
 * When using a `md-select` to pick from a list of objects, it is important to realize how javascript handles
 * equality. Consider the following example:
 * <hljs lang="js">
 * angular.controller('MyCtrl', function($scope) {
 *   $scope.users = [
 *     { id: 1, name: 'Bob' },
 *     { id: 2, name: 'Alice' },
 *     { id: 3, name: 'Steve' }
 *   ];
 *   $scope.selectedUser = { id: 1, name: 'Bob' };
 * });
 * </hljs>
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 *
 * At first one might expect that the select should be populated with "Bob" as the selected user. However,
 * this is not true. To determine whether something is selected,
 * `ngModelController` is looking at whether `$scope.selectedUser == (any user in $scope.users);`;
 *
 * Javascript's `==` operator does not check for deep equality (ie. that all properties
 * on the object are the same), but instead whether the objects are *the same object in memory*.
 * In this case, we have two instances of identical objects, but they exist in memory as unique
 * entities. Because of this, the select will have no value populated for a selected user.
 *
 * To get around this, `ngModelController` provides a `track by` option that allows us to specify a different
 * expression which will be used for the equality operator. As such, we can update our `html` to
 * make use of this by specifying the `ng-model-options="{trackBy: '$value.id'}"` on the `md-select`
 * element. This converts our equality expression to be
 * `$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));`
 * which results in Bob being selected as desired.
 *
 * Working HTML:
 * <hljs lang="html">
 * <div ng-controller="MyCtrl">
 *   <md-select ng-model="selectedUser" ng-model-options="{trackBy: '$value.id'}">
 *     <md-option ng-value="user" ng-repeat="user in users">{{ user.name }}</md-option>
 *   </md-select>
 * </div>
 * </hljs>
 */
function SelectDirective($mdSelect, $mdUtil, $mdConstant, $mdTheming, $mdAria, $parse, $sce,
    $injector) {
  var keyCodes = $mdConstant.KEY_CODE;
  var NAVIGATION_KEYS = [keyCodes.SPACE, keyCodes.ENTER, keyCodes.UP_ARROW, keyCodes.DOWN_ARROW];

  return {
    restrict: 'E',
    require: ['^?mdInputContainer', 'mdSelect', 'ngModel', '?^form'],
    compile: compile,
    controller: function() {
    } // empty placeholder controller to be initialized in link
  };

  function compile(element, attr) {
    // add the select value that will hold our placeholder or selected option value
    var valueEl = angular.element('<md-select-value><span></span></md-select-value>');
    valueEl.append('<span class="md-select-icon" aria-hidden="true"></span>');
    valueEl.addClass('md-select-value');
    if (!valueEl[0].hasAttribute('id')) {
      valueEl.attr('id', 'select_value_label_' + $mdUtil.nextUid());
    }

    // There's got to be an md-content inside. If there's not one, let's add it.
    if (!element.find('md-content').length) {
      element.append(angular.element('<md-content>').append(element.contents()));
    }


    // Add progress spinner for md-options-loading
    if (attr.mdOnOpen) {

      // Show progress indicator while loading async
      // Use ng-hide for `display:none` so the indicator does not interfere with the options list
      element
        .find('md-content')
        .prepend(angular.element(
          '<div>' +
          ' <md-progress-circular md-mode="indeterminate" ng-if="$$loadingAsyncDone === false" md-diameter="25px"></md-progress-circular>' +
          '</div>'
        ));

      // Hide list [of item options] while loading async
      element
        .find('md-option')
        .attr('ng-show', '$$loadingAsyncDone');
    }

    if (attr.name) {
      var autofillClone = angular.element('<select class="md-visually-hidden">');
      autofillClone.attr({
        'name': attr.name,
        'aria-hidden': 'true',
        'tabindex': '-1'
      });
      var opts = element.find('md-option');
      angular.forEach(opts, function(el) {
        var newEl = angular.element('<option>' + el.innerHTML + '</option>');
        if (el.hasAttribute('ng-value')) newEl.attr('ng-value', el.getAttribute('ng-value'));
        else if (el.hasAttribute('value')) newEl.attr('value', el.getAttribute('value'));
        autofillClone.append(newEl);
      });

      // Adds an extra option that will hold the selected value for the
      // cases where the select is a part of a non-angular form. This can be done with a ng-model,
      // however if the `md-option` is being `ng-repeat`-ed, Angular seems to insert a similar
      // `option` node, but with a value of `? string: <value> ?` which would then get submitted.
      // This also goes around having to prepend a dot to the name attribute.
      autofillClone.append(
        '<option ng-value="' + attr.ngModel + '" selected></option>'
      );

      element.parent().append(autofillClone);
    }

    var isMultiple = $mdUtil.parseAttributeBoolean(attr.multiple);

    // Use everything that's left inside element.contents() as the contents of the menu
    var multipleContent = isMultiple ? 'multiple' : '';
    var selectTemplate = '' +
      '<div class="md-select-menu-container" aria-hidden="true">' +
      '<md-select-menu {0}>{1}</md-select-menu>' +
      '</div>';

    selectTemplate = $mdUtil.supplant(selectTemplate, [multipleContent, element.html()]);
    element.empty().append(valueEl);
    element.append(selectTemplate);

    if(!attr.tabindex){
      attr.$set('tabindex', 0);
    }

    return function postLink(scope, element, attr, ctrls) {
      var untouched = true;
      var isDisabled, ariaLabelBase;

      var containerCtrl = ctrls[0];
      var mdSelectCtrl = ctrls[1];
      var ngModelCtrl = ctrls[2];
      var formCtrl = ctrls[3];
      // grab a reference to the select menu value label
      var valueEl = element.find('md-select-value');
      var isReadonly = angular.isDefined(attr.readonly);
      var disableAsterisk = $mdUtil.parseAttributeBoolean(attr.mdNoAsterisk);

      if (disableAsterisk) {
        element.addClass('md-no-asterisk');
      }

      if (containerCtrl) {
        var isErrorGetter = containerCtrl.isErrorGetter || function() {
          return ngModelCtrl.$invalid && (ngModelCtrl.$touched || (formCtrl && formCtrl.$submitted));
        };

        if (containerCtrl.input) {
          // We ignore inputs that are in the md-select-header (one
          // case where this might be useful would be adding as searchbox)
          if (element.find('md-select-header').find('input')[0] !== containerCtrl.input[0]) {
            throw new Error("<md-input-container> can only have *one* child <input>, <textarea> or <select> element!");
          }
        }

        containerCtrl.input = element;
        if (!containerCtrl.label) {
          $mdAria.expect(element, 'aria-label', element.attr('placeholder'));
        }

        scope.$watch(isErrorGetter, containerCtrl.setInvalid);
      }

      var selectContainer, selectScope, selectMenuCtrl;

      findSelectContainer();
      $mdTheming(element);

      if (formCtrl && angular.isDefined(attr.multiple)) {
        $mdUtil.nextTick(function() {
          var hasModelValue = ngModelCtrl.$modelValue || ngModelCtrl.$viewValue;
          if (hasModelValue) {
            formCtrl.$setPristine();
          }
        });
      }

      var originalRender = ngModelCtrl.$render;
      ngModelCtrl.$render = function() {
        originalRender();
        syncLabelText();
        syncAriaLabel();
        inputCheckValue();
      };

      attr.$observe('placeholder', ngModelCtrl.$render);

      if (containerCtrl && containerCtrl.label) {
        attr.$observe('required', function (value) {
          // Toggle the md-required class on the input containers label, because the input container is automatically
          // applying the asterisk indicator on the label.
          containerCtrl.label.toggleClass('md-required', value && !disableAsterisk);
        });
      }

      mdSelectCtrl.setLabelText = function(text) {
        mdSelectCtrl.setIsPlaceholder(!text);

        // Whether the select label has been given via user content rather than the internal
        // template of <md-option>
        var isSelectLabelFromUser = false;

        if (attr.mdSelectedText && attr.mdSelectedHtml) {
          throw Error('md-select cannot have both `md-selected-text` and `md-selected-html`');
        }

        if (attr.mdSelectedText || attr.mdSelectedHtml) {
          text = $parse(attr.mdSelectedText || attr.mdSelectedHtml)(scope);
          isSelectLabelFromUser = true;
        } else if (!text) {
          // Use placeholder attribute, otherwise fallback to the md-input-container label
          var tmpPlaceholder = attr.placeholder ||
              (containerCtrl && containerCtrl.label ? containerCtrl.label.text() : '');

          text = tmpPlaceholder || '';
          isSelectLabelFromUser = true;
        }

        var target = valueEl.children().eq(0);

        if (attr.mdSelectedHtml) {
            // Using getTrustedHtml will run the content through $sanitize if it is not already
            // explicitly trusted. If the ngSanitize module is not loaded, this will
            // *correctly* throw an sce error.
            target.html($sce.getTrustedHtml(text));
        } else if (isSelectLabelFromUser) {
          target.text(text);
        } else {
          // If we've reached this point, the text is not user-provided.
          target.html(text);
        }
      };

      mdSelectCtrl.setIsPlaceholder = function(isPlaceholder) {
        if (isPlaceholder) {
          valueEl.addClass('md-select-placeholder');
          if (containerCtrl && containerCtrl.label) {
            containerCtrl.label.addClass('md-placeholder');
          }
        } else {
          valueEl.removeClass('md-select-placeholder');
          if (containerCtrl && containerCtrl.label) {
            containerCtrl.label.removeClass('md-placeholder');
          }
        }
      };

      if (!isReadonly) {
        element
          .on('focus', function(ev) {
            // Always focus the container (if we have one) so floating labels and other styles are
            // applied properly
            containerCtrl && containerCtrl.setFocused(true);
          });

        // Attach before ngModel's blur listener to stop propagation of blur event
        // to prevent from setting $touched.
        element.on('blur', function(event) {
          if (untouched) {
            untouched = false;
            if (selectScope._mdSelectIsOpen) {
              event.stopImmediatePropagation();
            }
          }

          if (selectScope._mdSelectIsOpen) return;
          containerCtrl && containerCtrl.setFocused(false);
          inputCheckValue();
        });
      }

      mdSelectCtrl.triggerClose = function() {
        $parse(attr.mdOnClose)(scope);
      };

      scope.$$postDigest(function() {
        initAriaLabel();
        syncLabelText();
        syncAriaLabel();
      });

      function initAriaLabel() {
        var labelText = element.attr('aria-label') || element.attr('placeholder');
        if (!labelText && containerCtrl && containerCtrl.label) {
          labelText = containerCtrl.label.text();
        }
        ariaLabelBase = labelText;
        $mdAria.expect(element, 'aria-label', labelText);
      }

      scope.$watch(function() {
        return selectMenuCtrl.selectedLabels();
      }, syncLabelText);

      function syncLabelText() {
        if (selectContainer) {
          selectMenuCtrl = selectMenuCtrl || selectContainer.find('md-select-menu').controller('mdSelectMenu');
          mdSelectCtrl.setLabelText(selectMenuCtrl.selectedLabels());
        }
      }

      function syncAriaLabel() {
        if (!ariaLabelBase) return;
        var ariaLabels = selectMenuCtrl.selectedLabels({mode: 'aria'});
        element.attr('aria-label', ariaLabels.length ? ariaLabelBase + ': ' + ariaLabels : ariaLabelBase);
      }

      var deregisterWatcher;
      attr.$observe('ngMultiple', function(val) {
        if (deregisterWatcher) deregisterWatcher();
        var parser = $parse(val);
        deregisterWatcher = scope.$watch(function() {
          return parser(scope);
        }, function(multiple, prevVal) {
          if (multiple === undefined && prevVal === undefined) return; // assume compiler did a good job
          if (multiple) {
            element.attr('multiple', 'multiple');
          } else {
            element.removeAttr('multiple');
          }
          element.attr('aria-multiselectable', multiple ? 'true' : 'false');
          if (selectContainer) {
            selectMenuCtrl.setMultiple(multiple);
            originalRender = ngModelCtrl.$render;
            ngModelCtrl.$render = function() {
              originalRender();
              syncLabelText();
              syncAriaLabel();
              inputCheckValue();
            };
            ngModelCtrl.$render();
          }
        });
      });

      attr.$observe('disabled', function(disabled) {
        if (angular.isString(disabled)) {
          disabled = true;
        }
        // Prevent click event being registered twice
        if (isDisabled !== undefined && isDisabled === disabled) {
          return;
        }
        isDisabled = disabled;
        if (disabled) {
          element
            .attr({'aria-disabled': 'true'})
            .removeAttr('tabindex')
            .off('click', openSelect)
            .off('keydown', handleKeypress);
        } else {
          element
            .attr({'tabindex': attr.tabindex, 'aria-disabled': 'false'})
            .on('click', openSelect)
            .on('keydown', handleKeypress);
        }
      });

      if (!attr.hasOwnProperty('disabled') && !attr.hasOwnProperty('ngDisabled')) {
        element.attr({'aria-disabled': 'false'});
        element.on('click', openSelect);
        element.on('keydown', handleKeypress);
      }

      var ariaAttrs = {
        role: 'listbox',
        'aria-expanded': 'false',
        'aria-multiselectable': isMultiple && !attr.ngMultiple ? 'true' : 'false'
      };

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_' + $mdUtil.nextUid();
      }

      var containerId = 'select_container_' + $mdUtil.nextUid();
      selectContainer.attr('id', containerId);
      ariaAttrs['aria-owns'] = containerId;
      element.attr(ariaAttrs);

      scope.$on('$destroy', function() {
        $mdSelect
          .destroy()
          .finally(function() {
            if (containerCtrl) {
              containerCtrl.setFocused(false);
              containerCtrl.setHasValue(false);
              containerCtrl.input = null;
            }
            ngModelCtrl.$setTouched();
          });
      });



      function inputCheckValue() {
        // The select counts as having a value if one or more options are selected,
        // or if the input's validity state says it has bad input (eg string in a number input)
        containerCtrl && containerCtrl.setHasValue(selectMenuCtrl.selectedLabels().length > 0 || (element[0].validity || {}).badInput);
      }

      function findSelectContainer() {
        selectContainer = angular.element(
          element[0].querySelector('.md-select-menu-container')
        );
        selectScope = scope;
        if (attr.mdContainerClass) {
          var value = selectContainer[0].getAttribute('class') + ' ' + attr.mdContainerClass;
          selectContainer[0].setAttribute('class', value);
        }
        selectMenuCtrl = selectContainer.find('md-select-menu').controller('mdSelectMenu');
        selectMenuCtrl.init(ngModelCtrl, attr.ngModel);
        element.on('$destroy', function() {
          selectContainer.remove();
        });
      }

      function handleKeypress(e) {
        if ($mdConstant.isNavigationKey(e)) {
          // prevent page scrolling on interaction
          e.preventDefault();
          openSelect(e);
        } else {
          if ($mdConstant.isInputKey(e) || $mdConstant.isNumPadKey(e)) {
            e.preventDefault();

            var node = selectMenuCtrl.optNodeForKeyboardSearch(e);
            if (!node || node.hasAttribute('disabled')) return;
            var optionCtrl = angular.element(node).controller('mdOption');
            if (!selectMenuCtrl.isMultiple) {
              selectMenuCtrl.deselect(Object.keys(selectMenuCtrl.selected)[0]);
            }
            selectMenuCtrl.select(optionCtrl.hashKey, optionCtrl.value);
            selectMenuCtrl.refreshViewValue();
          }
        }
      }

      function openSelect() {
        selectScope._mdSelectIsOpen = true;
        element.attr('aria-expanded', 'true');

        $mdSelect.show({
          scope: selectScope,
          preserveScope: true,
          skipCompile: true,
          element: selectContainer,
          target: element[0],
          selectCtrl: mdSelectCtrl,
          preserveElement: true,
          hasBackdrop: true,
          loadingAsync: attr.mdOnOpen ? scope.$eval(attr.mdOnOpen) || true : false
        }).finally(function() {
          selectScope._mdSelectIsOpen = false;
          element.focus();
          element.attr('aria-expanded', 'false');
          ngModelCtrl.$setTouched();
        });
      }

    };
  }
}

function SelectMenuDirective($parse, $mdUtil, $mdConstant, $mdTheming) {
  // We want the scope to be set to 'false' so an isolated scope is not created
  // which would interfere with the md-select-header's access to the
  // parent scope.
  SelectMenuController['$inject'] = ["$scope", "$attrs", "$element"];
  return {
    restrict: 'E',
    require: ['mdSelectMenu'],
    scope: false,
    controller: SelectMenuController,
    link: {pre: preLink}
  };

  // We use preLink instead of postLink to ensure that the select is initialized before
  // its child options run postLink.
  function preLink(scope, element, attr, ctrls) {
    var selectCtrl = ctrls[0];

    element.addClass('_md');     // private md component indicator for styling

    $mdTheming(element);
    element.on('click', clickListener);
    element.on('keypress', keyListener);

    function keyListener(e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        clickListener(e);
      }
    }

    function clickListener(ev) {
      var option = $mdUtil.getClosest(ev.target, 'md-option');
      var optionCtrl = option && angular.element(option).data('$mdOptionController');
      if (!option || !optionCtrl) return;
      if (option.hasAttribute('disabled')) {
        ev.stopImmediatePropagation();
        return false;
      }

      var optionHashKey = selectCtrl.hashGetter(optionCtrl.value);
      var isSelected = angular.isDefined(selectCtrl.selected[optionHashKey]);

      scope.$apply(function() {
        if (selectCtrl.isMultiple) {
          if (isSelected) {
            selectCtrl.deselect(optionHashKey);
          } else {
            selectCtrl.select(optionHashKey, optionCtrl.value);
          }
        } else {
          if (!isSelected) {
            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
            selectCtrl.select(optionHashKey, optionCtrl.value);
          }
        }
        selectCtrl.refreshViewValue();
      });
    }
  }

  function SelectMenuController($scope, $attrs, $element) {
    var self = this;
    self.isMultiple = angular.isDefined($attrs.multiple);
    // selected is an object with keys matching all of the selected options' hashed values
    self.selected = {};
    // options is an object with keys matching every option's hash value,
    // and values matching every option's controller.
    self.options = {};

    $scope.$watchCollection(function() {
      return self.options;
    }, function() {
      self.ngModel.$render();
    });

    var deregisterCollectionWatch;
    var defaultIsEmpty;
    self.setMultiple = function(isMultiple) {
      var ngModel = self.ngModel;
      defaultIsEmpty = defaultIsEmpty || ngModel.$isEmpty;

      self.isMultiple = isMultiple;
      if (deregisterCollectionWatch) deregisterCollectionWatch();

      if (self.isMultiple) {
        ngModel.$validators['md-multiple'] = validateArray;
        ngModel.$render = renderMultiple;

        // watchCollection on the model because by default ngModel only watches the model's
        // reference. This allowed the developer to also push and pop from their array.
        $scope.$watchCollection(self.modelBinding, function(value) {
          if (validateArray(value)) renderMultiple(value);
          self.ngModel.$setPristine();
        });

        ngModel.$isEmpty = function(value) {
          return !value || value.length === 0;
        };
      } else {
        delete ngModel.$validators['md-multiple'];
        ngModel.$render = renderSingular;
      }

      function validateArray(modelValue, viewValue) {
        // If a value is truthy but not an array, reject it.
        // If value is undefined/falsy, accept that it's an empty array.
        return angular.isArray(modelValue || viewValue || []);
      }
    };

    var searchStr = '';
    var clearSearchTimeout, optNodes, optText;
    var CLEAR_SEARCH_AFTER = 300;

    self.optNodeForKeyboardSearch = function(e) {
      clearSearchTimeout && clearTimeout(clearSearchTimeout);
      clearSearchTimeout = setTimeout(function() {
        clearSearchTimeout = undefined;
        searchStr = '';
        optText = undefined;
        optNodes = undefined;
      }, CLEAR_SEARCH_AFTER);

      // Support 1-9 on numpad
      var keyCode = e.keyCode - ($mdConstant.isNumPadKey(e) ? 48 : 0);

      searchStr += String.fromCharCode(keyCode);
      var search = new RegExp('^' + searchStr, 'i');
      if (!optNodes) {
        optNodes = $element.find('md-option');
        optText = new Array(optNodes.length);
        angular.forEach(optNodes, function(el, i) {
          optText[i] = el.textContent.trim();
        });
      }
      for (var i = 0; i < optText.length; ++i) {
        if (search.test(optText[i])) {
          return optNodes[i];
        }
      }
    };

    self.init = function(ngModel, binding) {
      self.ngModel = ngModel;
      self.modelBinding = binding;

      // Setup a more robust version of isEmpty to ensure value is a valid option
      self.ngModel.$isEmpty = function($viewValue) {
        // We have to transform the viewValue into the hashKey, because otherwise the
        // OptionCtrl may not exist. Developers may have specified a trackBy function.
        return !self.options[self.hashGetter($viewValue)];
      };

      // Allow users to provide `ng-model="foo" ng-model-options="{trackBy: 'foo.id'}"` so
      // that we can properly compare objects set on the model to the available options
      var trackByOption = $mdUtil.getModelOption(ngModel, 'trackBy');

      if (trackByOption) {
        var trackByLocals = {};
        var trackByParsed = $parse(trackByOption);
        self.hashGetter = function(value, valueScope) {
          trackByLocals.$value = value;
          return trackByParsed(valueScope || $scope, trackByLocals);
        };
        // If the user doesn't provide a trackBy, we automatically generate an id for every
        // value passed in
      } else {
        self.hashGetter = function getHashValue(value) {
          if (angular.isObject(value)) {
            return 'object_' + (value.$$mdSelectId || (value.$$mdSelectId = ++selectNextId));
          }
          return value;
        };
      }
      self.setMultiple(self.isMultiple);
    };

    self.selectedLabels = function(opts) {
      opts = opts || {};
      var mode = opts.mode || 'html';
      var selectedOptionEls = $mdUtil.nodesToArray($element[0].querySelectorAll('md-option[selected]'));
      if (selectedOptionEls.length) {
        var mapFn;

        if (mode == 'html') {
          // Map the given element to its innerHTML string. If the element has a child ripple
          // container remove it from the HTML string, before returning the string.
          mapFn = function(el) {
            // If we do not have a `value` or `ng-value`, assume it is an empty option which clears the select
            if (el.hasAttribute('md-option-empty')) {
              return '';
            }

            var html = el.innerHTML;

            // Remove the ripple container from the selected option, copying it would cause a CSP violation.
            var rippleContainer = el.querySelector('.md-ripple-container');
            if (rippleContainer) {
              html = html.replace(rippleContainer.outerHTML, '');
            }

            // Remove the checkbox container, because it will cause the label to wrap inside of the placeholder.
            // It should be not displayed inside of the label element.
            var checkboxContainer = el.querySelector('.md-container');
            if (checkboxContainer) {
              html = html.replace(checkboxContainer.outerHTML, '');
            }

            return html;
          };
        } else if (mode == 'aria') {
          mapFn = function(el) { return el.hasAttribute('aria-label') ? el.getAttribute('aria-label') : el.textContent; };
        }

        // Ensure there are no duplicates; see https://github.com/angular/material/issues/9442
        return $mdUtil.uniq(selectedOptionEls.map(mapFn)).join(', ');
      } else {
        return '';
      }
    };

    self.select = function(hashKey, hashedValue) {
      var option = self.options[hashKey];
      option && option.setSelected(true);
      self.selected[hashKey] = hashedValue;
    };
    self.deselect = function(hashKey) {
      var option = self.options[hashKey];
      option && option.setSelected(false);
      delete self.selected[hashKey];
    };

    self.addOption = function(hashKey, optionCtrl) {
      if (angular.isDefined(self.options[hashKey])) {
        throw new Error('Duplicate md-option values are not allowed in a select. ' +
          'Duplicate value "' + optionCtrl.value + '" found.');
      }

      self.options[hashKey] = optionCtrl;

      // If this option's value was already in our ngModel, go ahead and select it.
      if (angular.isDefined(self.selected[hashKey])) {
        self.select(hashKey, optionCtrl.value);

        // When the current $modelValue of the ngModel Controller is using the same hash as
        // the current option, which will be added, then we can be sure, that the validation
        // of the option has occurred before the option was added properly.
        // This means, that we have to manually trigger a new validation of the current option.
        if (angular.isDefined(self.ngModel.$modelValue) && self.hashGetter(self.ngModel.$modelValue) === hashKey) {
          self.ngModel.$validate();
        }

        self.refreshViewValue();
      }
    };
    self.removeOption = function(hashKey) {
      delete self.options[hashKey];
      // Don't deselect an option when it's removed - the user's ngModel should be allowed
      // to have values that do not match a currently available option.
    };

    self.refreshViewValue = function() {
      var values = [];
      var option;
      for (var hashKey in self.selected) {
        // If this hashKey has an associated option, push that option's value to the model.
        if ((option = self.options[hashKey])) {
          values.push(option.value);
        } else {
          // Otherwise, the given hashKey has no associated option, and we got it
          // from an ngModel value at an earlier time. Push the unhashed value of
          // this hashKey to the model.
          // This allows the developer to put a value in the model that doesn't yet have
          // an associated option.
          values.push(self.selected[hashKey]);
        }
      }
      var usingTrackBy = $mdUtil.getModelOption(self.ngModel, 'trackBy');

      var newVal = self.isMultiple ? values : values[0];
      var prevVal = self.ngModel.$modelValue;

      if (usingTrackBy ? !angular.equals(prevVal, newVal) : (prevVal + '') !== newVal) {
        self.ngModel.$setViewValue(newVal);
        self.ngModel.$render();
      }
    };

    function renderMultiple() {
      var newSelectedValues = self.ngModel.$modelValue || self.ngModel.$viewValue || [];
      if (!angular.isArray(newSelectedValues)) return;

      var oldSelected = Object.keys(self.selected);

      var newSelectedHashes = newSelectedValues.map(self.hashGetter);
      var deselected = oldSelected.filter(function(hash) {
        return newSelectedHashes.indexOf(hash) === -1;
      });

      deselected.forEach(self.deselect);
      newSelectedHashes.forEach(function(hashKey, i) {
        self.select(hashKey, newSelectedValues[i]);
      });
    }

    function renderSingular() {
      var value = self.ngModel.$viewValue || self.ngModel.$modelValue;
      Object.keys(self.selected).forEach(self.deselect);
      self.select(self.hashGetter(value), value);
    }
  }

}

function OptionDirective($mdButtonInkRipple, $mdUtil) {

  OptionController['$inject'] = ["$element"];
  return {
    restrict: 'E',
    require: ['mdOption', '^^mdSelectMenu'],
    controller: OptionController,
    compile: compile
  };

  function compile(element, attr) {
    // Manual transclusion to avoid the extra inner <span> that ng-transclude generates
    element.append(angular.element('<div class="md-text">').append(element.contents()));

    element.attr('tabindex', attr.tabindex || '0');

    if (!hasDefinedValue(attr)) {
      element.attr('md-option-empty', '');
    }

    return postLink;
  }

  function hasDefinedValue(attr) {
    var value = attr.value;
    var ngValue = attr.ngValue;

    return value || ngValue;
  }

  function postLink(scope, element, attr, ctrls) {
    var optionCtrl = ctrls[0];
    var selectCtrl = ctrls[1];

    if (selectCtrl.isMultiple) {
      element.addClass('md-checkbox-enabled');
      element.prepend(CHECKBOX_SELECTION_INDICATOR.clone());
    }

    if (angular.isDefined(attr.ngValue)) {
      scope.$watch(attr.ngValue, setOptionValue);
    } else if (angular.isDefined(attr.value)) {
      setOptionValue(attr.value);
    } else {
      scope.$watch(function() {
        return element.text().trim();
      }, setOptionValue);
    }

    attr.$observe('disabled', function(disabled) {
      if (disabled) {
        element.attr('tabindex', '-1');
      } else {
        element.attr('tabindex', '0');
      }
    });

    scope.$$postDigest(function() {
      attr.$observe('selected', function(selected) {
        if (!angular.isDefined(selected)) return;
        if (typeof selected == 'string') selected = true;
        if (selected) {
          if (!selectCtrl.isMultiple) {
            selectCtrl.deselect(Object.keys(selectCtrl.selected)[0]);
          }
          selectCtrl.select(optionCtrl.hashKey, optionCtrl.value);
        } else {
          selectCtrl.deselect(optionCtrl.hashKey);
        }
        selectCtrl.refreshViewValue();
      });
    });

    $mdButtonInkRipple.attach(scope, element);
    configureAria();

    function setOptionValue(newValue, oldValue, prevAttempt) {
      if (!selectCtrl.hashGetter) {
        if (!prevAttempt) {
          scope.$$postDigest(function() {
            setOptionValue(newValue, oldValue, true);
          });
        }
        return;
      }
      var oldHashKey = selectCtrl.hashGetter(oldValue, scope);
      var newHashKey = selectCtrl.hashGetter(newValue, scope);

      optionCtrl.hashKey = newHashKey;
      optionCtrl.value = newValue;

      selectCtrl.removeOption(oldHashKey, optionCtrl);
      selectCtrl.addOption(newHashKey, optionCtrl);
    }

    scope.$on('$destroy', function() {
      selectCtrl.removeOption(optionCtrl.hashKey, optionCtrl);
    });

    function configureAria() {
      var ariaAttrs = {
        'role': 'option',
        'aria-selected': 'false'
      };

      if (!element[0].hasAttribute('id')) {
        ariaAttrs.id = 'select_option_' + $mdUtil.nextUid();
      }
      element.attr(ariaAttrs);
    }
  }

  function OptionController($element) {
    this.selected = false;
    this.setSelected = function(isSelected) {
      if (isSelected && !this.selected) {
        $element.attr({
          'selected': 'selected',
          'aria-selected': 'true'
        });
      } else if (!isSelected && this.selected) {
        $element.removeAttr('selected');
        $element.attr('aria-selected', 'false');
      }
      this.selected = isSelected;
    };
  }

}

function OptgroupDirective() {
  return {
    restrict: 'E',
    compile: compile
  };
  function compile(el, attrs) {
    // If we have a select header element, we don't want to add the normal label
    // header.
    if (!hasSelectHeader()) {
      setupLabelElement();
    }

    function hasSelectHeader() {
      return el.parent().find('md-select-header').length;
    }

    function setupLabelElement() {
      var labelElement = el.find('label');
      if (!labelElement.length) {
        labelElement = angular.element('<label>');
        el.prepend(labelElement);
      }
      labelElement.addClass('md-container-ignore');
      if (attrs.label) labelElement.text(attrs.label);
    }
  }
}

function SelectHeaderDirective() {
  return {
    restrict: 'E',
  };
}

function SelectProvider($$interimElementProvider) {
  selectDefaultOptions['$inject'] = ["$mdSelect", "$mdConstant", "$mdUtil", "$window", "$q", "$$rAF", "$animateCss", "$animate", "$document"];
  return $$interimElementProvider('$mdSelect')
    .setDefaults({
      methods: ['target'],
      options: selectDefaultOptions
    });

  /* ngInject */
  function selectDefaultOptions($mdSelect, $mdConstant, $mdUtil, $window, $q, $$rAF, $animateCss, $animate, $document) {
    var ERROR_TARGET_EXPECTED = "$mdSelect.show() expected a target element in options.target but got '{0}'!";
    var animator = $mdUtil.dom.animator;
    var keyCodes = $mdConstant.KEY_CODE;

    return {
      parent: 'body',
      themable: true,
      onShow: onShow,
      onRemove: onRemove,
      hasBackdrop: true,
      disableParentScroll: true
    };

    /**
     * Interim-element onRemove logic....
     */
    function onRemove(scope, element, opts) {
      opts = opts || { };
      opts.cleanupInteraction();
      opts.cleanupResizing();
      opts.hideBackdrop();

      // For navigation $destroy events, do a quick, non-animated removal,
      // but for normal closes (from clicks, etc) animate the removal

      return  (opts.$destroy === true) ? cleanElement() : animateRemoval().then( cleanElement );

      /**
       * For normal closes (eg clicks), animate the removal.
       * For forced closes (like $destroy events from navigation),
       * skip the animations
       */
      function animateRemoval() {
        return $animateCss(element, {addClass: 'md-leave'}).start();
      }

      /**
       * Restore the element to a closed state
       */
      function cleanElement() {

        element.removeClass('md-active');
        element.attr('aria-hidden', 'true');
        element[0].style.display = 'none';

        announceClosed(opts);

        if (!opts.$destroy && opts.restoreFocus) {
          opts.target.focus();
        }
      }

    }

    /**
     * Interim-element onShow logic....
     */
    function onShow(scope, element, opts) {

      watchAsyncLoad();
      sanitizeAndConfigure(scope, opts);

      opts.hideBackdrop = showBackdrop(scope, element, opts);

      return showDropDown(scope, element, opts)
        .then(function(response) {
          element.attr('aria-hidden', 'false');
          opts.alreadyOpen = true;
          opts.cleanupInteraction = activateInteraction();
          opts.cleanupResizing = activateResizing();

          return response;
        }, opts.hideBackdrop);

      // ************************************
      // Closure Functions
      // ************************************

      /**
       *  Attach the select DOM element(s) and animate to the correct positions
       *  and scalings...
       */
      function showDropDown(scope, element, opts) {
        opts.parent.append(element);

        return $q(function(resolve, reject) {

          try {

            $animateCss(element, {removeClass: 'md-leave', duration: 0})
              .start()
              .then(positionAndFocusMenu)
              .then(resolve);

          } catch (e) {
            reject(e);
          }

        });
      }

      /**
       * Initialize container and dropDown menu positions/scale, then animate
       * to show... and autoFocus.
       */
      function positionAndFocusMenu() {
        return $q(function(resolve) {
          if (opts.isRemoved) return $q.reject(false);

          var info = calculateMenuPositions(scope, element, opts);

          info.container.element.css(animator.toCss(info.container.styles));
          info.dropDown.element.css(animator.toCss(info.dropDown.styles));

          $$rAF(function() {
            element.addClass('md-active');
            info.dropDown.element.css(animator.toCss({transform: ''}));

            autoFocus(opts.focusedNode);
            resolve();
          });

        });
      }

      /**
       * Show modal backdrop element...
       */
      function showBackdrop(scope, element, options) {

        // If we are not within a dialog...
        if (options.disableParentScroll && !$mdUtil.getClosest(options.target, 'MD-DIALOG')) {
          // !! DO this before creating the backdrop; since disableScrollAround()
          //    configures the scroll offset; which is used by mdBackDrop postLink()
          options.restoreScroll = $mdUtil.disableScrollAround(options.element, options.parent);
        } else {
          options.disableParentScroll = false;
        }

        if (options.hasBackdrop) {
          // Override duration to immediately show invisible backdrop
          options.backdrop = $mdUtil.createBackdrop(scope, "md-select-backdrop md-click-catcher");
          $animate.enter(options.backdrop, $document[0].body, null, {duration: 0});
        }

        /**
         * Hide modal backdrop element...
         */
        return function hideBackdrop() {
          if (options.backdrop) options.backdrop.remove();
          if (options.disableParentScroll) options.restoreScroll();

          delete options.restoreScroll;
        };
      }

      /**
       *
       */
      function autoFocus(focusedNode) {
        if (focusedNode && !focusedNode.hasAttribute('disabled')) {
          focusedNode.focus();
        }
      }

      /**
       * Check for valid opts and set some sane defaults
       */
      function sanitizeAndConfigure(scope, options) {
        var selectEl = element.find('md-select-menu');

        if (!options.target) {
          throw new Error($mdUtil.supplant(ERROR_TARGET_EXPECTED, [options.target]));
        }

        angular.extend(options, {
          isRemoved: false,
          target: angular.element(options.target), //make sure it's not a naked dom node
          parent: angular.element(options.parent),
          selectEl: selectEl,
          contentEl: element.find('md-content'),
          optionNodes: selectEl[0].getElementsByTagName('md-option')
        });
      }

      /**
       * Configure various resize listeners for screen changes
       */
      function activateResizing() {
        var debouncedOnResize = (function(scope, target, options) {

          return function() {
            if (options.isRemoved) return;

            var updates = calculateMenuPositions(scope, target, options);
            var container = updates.container;
            var dropDown = updates.dropDown;

            container.element.css(animator.toCss(container.styles));
            dropDown.element.css(animator.toCss(dropDown.styles));
          };

        })(scope, element, opts);

        var window = angular.element($window);
        window.on('resize', debouncedOnResize);
        window.on('orientationchange', debouncedOnResize);

        // Publish deactivation closure...
        return function deactivateResizing() {

          // Disable resizing handlers
          window.off('resize', debouncedOnResize);
          window.off('orientationchange', debouncedOnResize);
        };
      }

      /**
       *  If asynchronously loading, watch and update internal
       *  '$$loadingAsyncDone' flag
       */
      function watchAsyncLoad() {
        if (opts.loadingAsync && !opts.isRemoved) {
          scope.$$loadingAsyncDone = false;

          $q.when(opts.loadingAsync)
            .then(function() {
              scope.$$loadingAsyncDone = true;
              delete opts.loadingAsync;
            }).then(function() {
              $$rAF(positionAndFocusMenu);
            });
        }
      }

      /**
       *
       */
      function activateInteraction() {
        if (opts.isRemoved) return;

        var dropDown = opts.selectEl;
        var selectCtrl = dropDown.controller('mdSelectMenu') || {};

        element.addClass('md-clickable');

        // Close on backdrop click
        opts.backdrop && opts.backdrop.on('click', onBackdropClick);

        // Escape to close
        // Cycling of options, and closing on enter
        dropDown.on('keydown', onMenuKeyDown);
        dropDown.on('click', checkCloseMenu);

        return function cleanupInteraction() {
          opts.backdrop && opts.backdrop.off('click', onBackdropClick);
          dropDown.off('keydown', onMenuKeyDown);
          dropDown.off('click', checkCloseMenu);

          element.removeClass('md-clickable');
          opts.isRemoved = true;
        };

        // ************************************
        // Closure Functions
        // ************************************

        function onBackdropClick(e) {
          e.preventDefault();
          e.stopPropagation();
          opts.restoreFocus = false;
          $mdUtil.nextTick($mdSelect.hide, true);
        }

        function onMenuKeyDown(ev) {
          ev.preventDefault();
          ev.stopPropagation();

          switch (ev.keyCode) {
            case keyCodes.UP_ARROW:
              return focusPrevOption();
            case keyCodes.DOWN_ARROW:
              return focusNextOption();
            case keyCodes.SPACE:
            case keyCodes.ENTER:
              var option = $mdUtil.getClosest(ev.target, 'md-option');
              if (option) {
                dropDown.triggerHandler({
                  type: 'click',
                  target: option
                });
                ev.preventDefault();
              }
              checkCloseMenu(ev);
              break;
            case keyCodes.TAB:
            case keyCodes.ESCAPE:
              ev.stopPropagation();
              ev.preventDefault();
              opts.restoreFocus = true;
              $mdUtil.nextTick($mdSelect.hide, true);
              break;
            default:
              if ($mdConstant.isInputKey(ev) || $mdConstant.isNumPadKey(ev)) {
                var optNode = dropDown.controller('mdSelectMenu').optNodeForKeyboardSearch(ev);
                opts.focusedNode = optNode || opts.focusedNode;
                optNode && optNode.focus();
              }
          }
        }

        function focusOption(direction) {
          var optionsArray = $mdUtil.nodesToArray(opts.optionNodes);
          var index = optionsArray.indexOf(opts.focusedNode);

          var newOption;

          do {
            if (index === -1) {
              // We lost the previously focused element, reset to first option
              index = 0;
            } else if (direction === 'next' && index < optionsArray.length - 1) {
              index++;
            } else if (direction === 'prev' && index > 0) {
              index--;
            }
            newOption = optionsArray[index];
            if (newOption.hasAttribute('disabled')) newOption = undefined;
          } while (!newOption && index < optionsArray.length - 1 && index > 0);

          newOption && newOption.focus();
          opts.focusedNode = newOption;
        }

        function focusNextOption() {
          focusOption('next');
        }

        function focusPrevOption() {
          focusOption('prev');
        }

        function checkCloseMenu(ev) {
          if (ev && ( ev.type == 'click') && (ev.currentTarget != dropDown[0])) return;
          if ( mouseOnScrollbar() ) return;

          var option = $mdUtil.getClosest(ev.target, 'md-option');
          if (option && option.hasAttribute && !option.hasAttribute('disabled')) {
            ev.preventDefault();
            ev.stopPropagation();
            if (!selectCtrl.isMultiple) {
              opts.restoreFocus = true;

              $mdUtil.nextTick(function () {
                $mdSelect.hide(selectCtrl.ngModel.$viewValue);
              }, true);
            }
          }
          /**
           * check if the mouseup event was on a scrollbar
           */
          function mouseOnScrollbar() {
            var clickOnScrollbar = false;
            if (ev && (ev.currentTarget.children.length > 0)) {
              var child = ev.currentTarget.children[0];
              var hasScrollbar = child.scrollHeight > child.clientHeight;
              if (hasScrollbar && child.children.length > 0) {
                var relPosX = ev.pageX - ev.currentTarget.getBoundingClientRect().left;
                if (relPosX > child.querySelector('md-option').offsetWidth)
                  clickOnScrollbar = true;
              }
            }
            return clickOnScrollbar;
          }
        }
      }

    }

    /**
     * To notify listeners that the Select menu has closed,
     * trigger the [optional] user-defined expression
     */
    function announceClosed(opts) {
      var mdSelect = opts.selectCtrl;
      if (mdSelect) {
        var menuController = opts.selectEl.controller('mdSelectMenu');
        mdSelect.setLabelText(menuController ? menuController.selectedLabels() : '');
        mdSelect.triggerClose();
      }
    }


    /**
     * Calculate the
     */
    function calculateMenuPositions(scope, element, opts) {
      var
        containerNode = element[0],
        targetNode = opts.target[0].children[0], // target the label
        parentNode = $document[0].body,
        selectNode = opts.selectEl[0],
        contentNode = opts.contentEl[0],
        parentRect = parentNode.getBoundingClientRect(),
        targetRect = targetNode.getBoundingClientRect(),
        shouldOpenAroundTarget = false,
        bounds = {
          left: parentRect.left + SELECT_EDGE_MARGIN,
          top: SELECT_EDGE_MARGIN,
          bottom: parentRect.height - SELECT_EDGE_MARGIN,
          right: parentRect.width - SELECT_EDGE_MARGIN - ($mdUtil.floatingScrollbars() ? 16 : 0)
        },
        spaceAvailable = {
          top: targetRect.top - bounds.top,
          left: targetRect.left - bounds.left,
          right: bounds.right - (targetRect.left + targetRect.width),
          bottom: bounds.bottom - (targetRect.top + targetRect.height)
        },
        maxWidth = parentRect.width - SELECT_EDGE_MARGIN * 2,
        selectedNode = selectNode.querySelector('md-option[selected]'),
        optionNodes = selectNode.getElementsByTagName('md-option'),
        optgroupNodes = selectNode.getElementsByTagName('md-optgroup'),
        isScrollable = calculateScrollable(element, contentNode),
        centeredNode;

      var loading = isPromiseLike(opts.loadingAsync);
      if (!loading) {
        // If a selected node, center around that
        if (selectedNode) {
          centeredNode = selectedNode;
          // If there are option groups, center around the first option group
        } else if (optgroupNodes.length) {
          centeredNode = optgroupNodes[0];
          // Otherwise - if we are not loading async - center around the first optionNode
        } else if (optionNodes.length) {
          centeredNode = optionNodes[0];
          // In case there are no options, center on whatever's in there... (eg progress indicator)
        } else {
          centeredNode = contentNode.firstElementChild || contentNode;
        }
      } else {
        // If loading, center on progress indicator
        centeredNode = contentNode.firstElementChild || contentNode;
      }

      if (contentNode.offsetWidth > maxWidth) {
        contentNode.style['max-width'] = maxWidth + 'px';
      } else {
        contentNode.style.maxWidth = null;
      }
      if (shouldOpenAroundTarget) {
        contentNode.style['min-width'] = targetRect.width + 'px';
      }

      // Remove padding before we compute the position of the menu
      if (isScrollable) {
        selectNode.classList.add('md-overflow');
      }

      var focusedNode = centeredNode;
      if ((focusedNode.tagName || '').toUpperCase() === 'MD-OPTGROUP') {
        focusedNode = optionNodes[0] || contentNode.firstElementChild || contentNode;
        centeredNode = focusedNode;
      }
      // Cache for autoFocus()
      opts.focusedNode = focusedNode;

      // Get the selectMenuRect *after* max-width is possibly set above
      containerNode.style.display = 'block';
      var selectMenuRect = selectNode.getBoundingClientRect();
      var centeredRect = getOffsetRect(centeredNode);

      if (centeredNode) {
        var centeredStyle = $window.getComputedStyle(centeredNode);
        centeredRect.paddingLeft = parseInt(centeredStyle.paddingLeft, 10) || 0;
        centeredRect.paddingRight = parseInt(centeredStyle.paddingRight, 10) || 0;
      }

      if (isScrollable) {
        var scrollBuffer = contentNode.offsetHeight / 2;
        contentNode.scrollTop = centeredRect.top + centeredRect.height / 2 - scrollBuffer;

        if (spaceAvailable.top < scrollBuffer) {
          contentNode.scrollTop = Math.min(
            centeredRect.top,
            contentNode.scrollTop + scrollBuffer - spaceAvailable.top
          );
        } else if (spaceAvailable.bottom < scrollBuffer) {
          contentNode.scrollTop = Math.max(
            centeredRect.top + centeredRect.height - selectMenuRect.height,
            contentNode.scrollTop - scrollBuffer + spaceAvailable.bottom
          );
        }
      }

      var left, top, transformOrigin, minWidth, fontSize;
      if (shouldOpenAroundTarget) {
        left = targetRect.left;
        top = targetRect.top + targetRect.height;
        transformOrigin = '50% 0';
        if (top + selectMenuRect.height > bounds.bottom) {
          top = targetRect.top - selectMenuRect.height;
          transformOrigin = '50% 100%';
        }
      } else {
        left = (targetRect.left + centeredRect.left - centeredRect.paddingLeft) + 2;
        top = Math.floor(targetRect.top + targetRect.height / 2 - centeredRect.height / 2 -
            centeredRect.top + contentNode.scrollTop) + 2;

        transformOrigin = (centeredRect.left + targetRect.width / 2) + 'px ' +
          (centeredRect.top + centeredRect.height / 2 - contentNode.scrollTop) + 'px 0px';

        minWidth = Math.min(targetRect.width + centeredRect.paddingLeft + centeredRect.paddingRight, maxWidth);

        fontSize = window.getComputedStyle(targetNode)['font-size'];
      }

      // Keep left and top within the window
      var containerRect = containerNode.getBoundingClientRect();
      var scaleX = Math.round(100 * Math.min(targetRect.width / selectMenuRect.width, 1.0)) / 100;
      var scaleY = Math.round(100 * Math.min(targetRect.height / selectMenuRect.height, 1.0)) / 100;

      return {
        container: {
          element: angular.element(containerNode),
          styles: {
            left: Math.floor(clamp(bounds.left, left, bounds.right - containerRect.width)),
            top: Math.floor(clamp(bounds.top, top, bounds.bottom - containerRect.height)),
            'min-width': minWidth,
            'font-size': fontSize
          }
        },
        dropDown: {
          element: angular.element(selectNode),
          styles: {
            transformOrigin: transformOrigin,
            transform: !opts.alreadyOpen ? $mdUtil.supplant('scale({0},{1})', [scaleX, scaleY]) : ""
          }
        }
      };

    }

  }

  function isPromiseLike(obj) {
    return obj && angular.isFunction(obj.then);
  }

  function clamp(min, n, max) {
    return Math.max(min, Math.min(n, max));
  }

  function getOffsetRect(node) {
    return node ? {
      left: node.offsetLeft,
      top: node.offsetTop,
      width: node.offsetWidth,
      height: node.offsetHeight
    } : {left: 0, top: 0, width: 0, height: 0};
  }

  function calculateScrollable(element, contentNode) {
    var isScrollable = false;

    try {
      var oldDisplay = element[0].style.display;

      // Set the element's display to block so that this calculation is correct
      element[0].style.display = 'block';

      isScrollable = contentNode.scrollHeight > contentNode.offsetHeight;

      // Reset it back afterwards
      element[0].style.display = oldDisplay;
    } finally {
      // Nothing to do
    }
    return isScrollable;
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

  /**
   * @ngdoc module
   * @name material.components.slider
   */
SliderDirective['$inject'] = ["$$rAF", "$window", "$mdAria", "$mdUtil", "$mdConstant", "$mdTheming", "$mdGesture", "$parse", "$log", "$timeout"];
  angular.module('material.components.slider', [
    'material.core'
  ])
  .directive('mdSlider', SliderDirective)
  .directive('mdSliderContainer', SliderContainerDirective);

/**
 * @ngdoc directive
 * @name mdSliderContainer
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider-container>` contains slider with two other elements.
 *
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * </hljs>
 */
function SliderContainerDirective() {
  return {
    controller: function () {},
    compile: function (elem) {
      var slider = elem.find('md-slider');

      if (!slider) {
        return;
      }

      var vertical = slider.attr('md-vertical');

      if (vertical !== undefined) {
        elem.attr('md-vertical', '');
      }

      if(!slider.attr('flex')) {
        slider.attr('flex', '');
      }

      return function postLink(scope, element, attr, ctrl) {
        element.addClass('_md');     // private md component indicator for styling

        // We have to manually stop the $watch on ngDisabled because it exists
        // on the parent scope, and won't be automatically destroyed when
        // the component is destroyed.
        function setDisable(value) {
          element.children().attr('disabled', value);
          element.find('input').attr('disabled', value);
        }

        var stopDisabledWatch = angular.noop;

        if (attr.disabled) {
          setDisable(true);
        }
        else if (attr.ngDisabled) {
          stopDisabledWatch = scope.$watch(attr.ngDisabled, function (value) {
            setDisable(value);
          });
        }

        scope.$on('$destroy', function () {
          stopDisabledWatch();
        });

        var initialMaxWidth;

        ctrl.fitInputWidthToTextLength = function (length) {
          var input = element[0].querySelector('md-input-container');

          if (input) {
            var computedStyle = getComputedStyle(input);
            var minWidth = parseInt(computedStyle.minWidth);
            var padding = parseInt(computedStyle.padding) * 2;

            initialMaxWidth = initialMaxWidth || parseInt(computedStyle.maxWidth);
            var newMaxWidth = Math.max(initialMaxWidth, minWidth + padding + (minWidth / 2 * length));

            input.style.maxWidth = newMaxWidth + 'px';
          }
        };
      };
    }
  };
}

/**
 * @ngdoc directive
 * @name mdSlider
 * @module material.components.slider
 * @restrict E
 * @description
 * The `<md-slider>` component allows the user to choose from a range of
 * values.
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the slider is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * It has two modes: 'normal' mode, where the user slides between a wide range
 * of values, and 'discrete' mode, where the user slides between only a few
 * select values.
 *
 * To enable discrete mode, add the `md-discrete` attribute to a slider,
 * and use the `step` attribute to change the distance between
 * values the user is allowed to pick.
 *
 * @usage
 * <h4>Normal Mode</h4>
 * <hljs lang="html">
 * <md-slider ng-model="myValue" min="5" max="500">
 * </md-slider>
 * </hljs>
 * <h4>Discrete Mode</h4>
 * <hljs lang="html">
 * <md-slider md-discrete ng-model="myDiscreteValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 * <h4>Invert Mode</h4>
 * <hljs lang="html">
 * <md-slider md-invert ng-model="myValue" step="10" min="10" max="130">
 * </md-slider>
 * </hljs>
 *
 * @param {boolean=} md-discrete Whether to enable discrete mode.
 * @param {boolean=} md-invert Whether to enable invert mode.
 * @param {number=} step The distance between values the user is allowed to pick. Default 1.
 * @param {number=} min The minimum value the user is allowed to pick. Default 0.
 * @param {number=} max The maximum value the user is allowed to pick. Default 100.
 * @param {number=} round The amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.
 */
function SliderDirective($$rAF, $window, $mdAria, $mdUtil, $mdConstant, $mdTheming, $mdGesture, $parse, $log, $timeout) {
  return {
    scope: {},
    require: ['?ngModel', '?^mdSliderContainer'],
    template:
      '<div class="md-slider-wrapper">' +
        '<div class="md-slider-content">' +
          '<div class="md-track-container">' +
            '<div class="md-track"></div>' +
            '<div class="md-track md-track-fill"></div>' +
            '<div class="md-track-ticks"></div>' +
          '</div>' +
          '<div class="md-thumb-container">' +
            '<div class="md-thumb"></div>' +
            '<div class="md-focus-thumb"></div>' +
            '<div class="md-focus-ring"></div>' +
            '<div class="md-sign">' +
              '<span class="md-thumb-text"></span>' +
            '</div>' +
            '<div class="md-disabled-thumb"></div>' +
          '</div>' +
        '</div>' +
      '</div>',
    compile: compile
  };

  // **********************************************************
  // Private Methods
  // **********************************************************

  function compile (tElement, tAttrs) {
    var wrapper = angular.element(tElement[0].getElementsByClassName('md-slider-wrapper'));

    var tabIndex = tAttrs.tabindex || 0;
    wrapper.attr('tabindex', tabIndex);

    if (tAttrs.disabled || tAttrs.ngDisabled) wrapper.attr('tabindex', -1);

    wrapper.attr('role', 'slider');

    $mdAria.expect(tElement, 'aria-label');

    return postLink;
  }

  function postLink(scope, element, attr, ctrls) {
    $mdTheming(element);
    var ngModelCtrl = ctrls[0] || {
      // Mock ngModelController if it doesn't exist to give us
      // the minimum functionality needed
      $setViewValue: function(val) {
        this.$viewValue = val;
        this.$viewChangeListeners.forEach(function(cb) { cb(); });
      },
      $parsers: [],
      $formatters: [],
      $viewChangeListeners: []
    };

    var containerCtrl = ctrls[1];
    var container = angular.element($mdUtil.getClosest(element, '_md-slider-container', true));
    var isDisabled = attr.ngDisabled ? angular.bind(null, $parse(attr.ngDisabled), scope.$parent) : function () {
          return element[0].hasAttribute('disabled');
        };

    var thumb = angular.element(element[0].querySelector('.md-thumb'));
    var thumbText = angular.element(element[0].querySelector('.md-thumb-text'));
    var thumbContainer = thumb.parent();
    var trackContainer = angular.element(element[0].querySelector('.md-track-container'));
    var activeTrack = angular.element(element[0].querySelector('.md-track-fill'));
    var tickContainer = angular.element(element[0].querySelector('.md-track-ticks'));
    var wrapper = angular.element(element[0].getElementsByClassName('md-slider-wrapper'));
    var content = angular.element(element[0].getElementsByClassName('md-slider-content'));
    var throttledRefreshDimensions = $mdUtil.throttle(refreshSliderDimensions, 5000);

    // Default values, overridable by attrs
    var DEFAULT_ROUND = 3;
    var vertical = angular.isDefined(attr.mdVertical);
    var discrete = angular.isDefined(attr.mdDiscrete);
    var invert = angular.isDefined(attr.mdInvert);
    angular.isDefined(attr.min) ? attr.$observe('min', updateMin) : updateMin(0);
    angular.isDefined(attr.max) ? attr.$observe('max', updateMax) : updateMax(100);
    angular.isDefined(attr.step)? attr.$observe('step', updateStep) : updateStep(1);
    angular.isDefined(attr.round)? attr.$observe('round', updateRound) : updateRound(DEFAULT_ROUND);

    // We have to manually stop the $watch on ngDisabled because it exists
    // on the parent scope, and won't be automatically destroyed when
    // the component is destroyed.
    var stopDisabledWatch = angular.noop;
    if (attr.ngDisabled) {
      stopDisabledWatch = scope.$parent.$watch(attr.ngDisabled, updateAriaDisabled);
    }

    $mdGesture.register(wrapper, 'drag', { horizontal: !vertical });

    scope.mouseActive = false;

    wrapper
      .on('keydown', keydownListener)
      .on('mousedown', mouseDownListener)
      .on('focus', focusListener)
      .on('blur', blurListener)
      .on('$md.pressdown', onPressDown)
      .on('$md.pressup', onPressUp)
      .on('$md.dragstart', onDragStart)
      .on('$md.drag', onDrag)
      .on('$md.dragend', onDragEnd);

    // On resize, recalculate the slider's dimensions and re-render
    function updateAll() {
      refreshSliderDimensions();
      ngModelRender();
    }
    setTimeout(updateAll, 0);

    var debouncedUpdateAll = $$rAF.throttle(updateAll);
    angular.element($window).on('resize', debouncedUpdateAll);

    scope.$on('$destroy', function() {
      angular.element($window).off('resize', debouncedUpdateAll);
    });

    ngModelCtrl.$render = ngModelRender;
    ngModelCtrl.$viewChangeListeners.push(ngModelRender);
    ngModelCtrl.$formatters.push(minMaxValidator);
    ngModelCtrl.$formatters.push(stepValidator);

    /**
     * Attributes
     */
    var min;
    var max;
    var step;
    var round;
    function updateMin(value) {
      min = parseFloat(value);
      element.attr('aria-valuemin', value);
      updateAll();
    }
    function updateMax(value) {
      max = parseFloat(value);
      element.attr('aria-valuemax', value);
      updateAll();
    }
    function updateStep(value) {
      step = parseFloat(value);
    }
    function updateRound(value) {
      // Set max round digits to 6, after 6 the input uses scientific notation
      round = minMaxValidator(parseInt(value), 0, 6);
    }
    function updateAriaDisabled() {
      element.attr('aria-disabled', !!isDisabled());
    }

    // Draw the ticks with canvas.
    // The alternative to drawing ticks with canvas is to draw one element for each tick,
    // which could quickly become a performance bottleneck.
    var tickCanvas, tickCtx;
    function redrawTicks() {
      if (!discrete || isDisabled()) return;
      if ( angular.isUndefined(step) )         return;

      if ( step <= 0 ) {
        var msg = 'Slider step value must be greater than zero when in discrete mode';
        $log.error(msg);
        throw new Error(msg);
      }

      var numSteps = Math.floor( (max - min) / step );
      if (!tickCanvas) {
        tickCanvas = angular.element('<canvas>').css('position', 'absolute');
        tickContainer.append(tickCanvas);

        tickCtx = tickCanvas[0].getContext('2d');
      }

      var dimensions = getSliderDimensions();

      // If `dimensions` doesn't have height and width it might be the first attempt so we will refresh dimensions
      if (dimensions && !dimensions.height && !dimensions.width) {
        refreshSliderDimensions();
        dimensions = sliderDimensions;
      }

      tickCanvas[0].width = dimensions.width;
      tickCanvas[0].height = dimensions.height;

      var distance;
      for (var i = 0; i <= numSteps; i++) {
        var trackTicksStyle = $window.getComputedStyle(tickContainer[0]);
        tickCtx.fillStyle = trackTicksStyle.color || 'black';

        distance = Math.floor((vertical ? dimensions.height : dimensions.width) * (i / numSteps));

        tickCtx.fillRect(vertical ? 0 : distance - 1,
          vertical ? distance - 1 : 0,
          vertical ? dimensions.width : 2,
          vertical ? 2 : dimensions.height);
      }
    }

    function clearTicks() {
      if(tickCanvas && tickCtx) {
        var dimensions = getSliderDimensions();
        tickCtx.clearRect(0, 0, dimensions.width, dimensions.height);
      }
    }

    /**
     * Refreshing Dimensions
     */
    var sliderDimensions = {};
    refreshSliderDimensions();
    function refreshSliderDimensions() {
      sliderDimensions = trackContainer[0].getBoundingClientRect();
    }
    function getSliderDimensions() {
      throttledRefreshDimensions();
      return sliderDimensions;
    }

    /**
     * left/right/up/down arrow listener
     */
    function keydownListener(ev) {
      if (isDisabled()) return;

      var changeAmount;
      if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.DOWN_ARROW : ev.keyCode === $mdConstant.KEY_CODE.LEFT_ARROW) {
        changeAmount = -step;
      } else if (vertical ? ev.keyCode === $mdConstant.KEY_CODE.UP_ARROW : ev.keyCode === $mdConstant.KEY_CODE.RIGHT_ARROW) {
        changeAmount = step;
      }
      changeAmount = invert ? -changeAmount : changeAmount;
      if (changeAmount) {
        if (ev.metaKey || ev.ctrlKey || ev.altKey) {
          changeAmount *= 4;
        }
        ev.preventDefault();
        ev.stopPropagation();
        scope.$evalAsync(function() {
          setModelValue(ngModelCtrl.$viewValue + changeAmount);
        });
      }
    }

    function mouseDownListener() {
      redrawTicks();

      scope.mouseActive = true;
      wrapper.removeClass('md-focused');

      $timeout(function() {
        scope.mouseActive = false;
      }, 100);
    }

    function focusListener() {
      if (scope.mouseActive === false) {
        wrapper.addClass('md-focused');
      }
    }

    function blurListener() {
      wrapper.removeClass('md-focused');
      element.removeClass('md-active');
      clearTicks();
    }

    /**
     * ngModel setters and validators
     */
    function setModelValue(value) {
      ngModelCtrl.$setViewValue( minMaxValidator(stepValidator(value)) );
    }
    function ngModelRender() {
      if (isNaN(ngModelCtrl.$viewValue)) {
        ngModelCtrl.$viewValue = ngModelCtrl.$modelValue;
      }

      ngModelCtrl.$viewValue = minMaxValidator(ngModelCtrl.$viewValue);

      var percent = valueToPercent(ngModelCtrl.$viewValue);
      scope.modelValue = ngModelCtrl.$viewValue;
      element.attr('aria-valuenow', ngModelCtrl.$viewValue);
      setSliderPercent(percent);
      thumbText.text( ngModelCtrl.$viewValue );
    }

    function minMaxValidator(value, minValue, maxValue) {
      if (angular.isNumber(value)) {
        minValue = angular.isNumber(minValue) ? minValue : min;
        maxValue = angular.isNumber(maxValue) ? maxValue : max;

        return Math.max(minValue, Math.min(maxValue, value));
      }
    }

    function stepValidator(value) {
      if (angular.isNumber(value)) {
        var formattedValue = (Math.round((value - min) / step) * step + min);
        formattedValue = (Math.round(formattedValue * Math.pow(10, round)) / Math.pow(10, round));

        if (containerCtrl && containerCtrl.fitInputWidthToTextLength){
          $mdUtil.debounce(function () {
            containerCtrl.fitInputWidthToTextLength(formattedValue.toString().length);
          }, 100)();
        }

        return formattedValue;
      }
    }

    /**
     * @param percent 0-1
     */
    function setSliderPercent(percent) {

      percent = clamp(percent);

      var thumbPosition = (percent * 100) + '%';
      var activeTrackPercent = invert ? (1 - percent) * 100 + '%' : thumbPosition;

      if (vertical) {
        thumbContainer.css('bottom', thumbPosition);
      }
      else {
        $mdUtil.bidiProperty(thumbContainer, 'left', 'right', thumbPosition);
      }

      
      activeTrack.css(vertical ? 'height' : 'width', activeTrackPercent);

      element.toggleClass((invert ? 'md-max' : 'md-min'), percent === 0);
      element.toggleClass((invert ? 'md-min' : 'md-max'), percent === 1);
    }

    /**
     * Slide listeners
     */
    var isDragging = false;

    function onPressDown(ev) {
      if (isDisabled()) return;

      element.addClass('md-active');
      element[0].focus();
      refreshSliderDimensions();

      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      scope.$apply(function() {
        setModelValue( closestVal );
        setSliderPercent( valueToPercent(closestVal));
      });
    }
    function onPressUp(ev) {
      if (isDisabled()) return;

      element.removeClass('md-dragging');

      var exactVal = percentToValue( positionToPercent( vertical ? ev.pointer.y : ev.pointer.x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      scope.$apply(function() {
        setModelValue(closestVal);
        ngModelRender();
      });
    }
    function onDragStart(ev) {
      if (isDisabled()) return;
      isDragging = true;

      ev.stopPropagation();

      element.addClass('md-dragging');
      setSliderFromEvent(ev);
    }
    function onDrag(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      setSliderFromEvent(ev);
    }
    function onDragEnd(ev) {
      if (!isDragging) return;
      ev.stopPropagation();
      isDragging = false;
    }

    function setSliderFromEvent(ev) {
      // While panning discrete, update only the
      // visual positioning but not the model value.
      if ( discrete ) adjustThumbPosition( vertical ? ev.pointer.y : ev.pointer.x );
      else            doSlide( vertical ? ev.pointer.y : ev.pointer.x );
    }

    /**
     * Slide the UI by changing the model value
     * @param x
     */
    function doSlide( x ) {
      scope.$evalAsync( function() {
        setModelValue( percentToValue( positionToPercent(x) ));
      });
    }

    /**
     * Slide the UI without changing the model (while dragging/panning)
     * @param x
     */
    function adjustThumbPosition( x ) {
      var exactVal = percentToValue( positionToPercent( x ));
      var closestVal = minMaxValidator( stepValidator(exactVal) );
      setSliderPercent( positionToPercent(x) );
      thumbText.text( closestVal );
    }

    /**
    * Clamps the value to be between 0 and 1.
    * @param {number} value The value to clamp.
    * @returns {number}
    */
    function clamp(value) {
      return Math.max(0, Math.min(value || 0, 1));
    }

    /**
     * Convert position on slider to percentage value of offset from beginning...
     * @param position
     * @returns {number}
     */
    function positionToPercent( position ) {
      var offset = vertical ? sliderDimensions.top : sliderDimensions.left;
      var size = vertical ? sliderDimensions.height : sliderDimensions.width;
      var calc = (position - offset) / size;

      if (!vertical && $mdUtil.bidi() === 'rtl') {
        calc = 1 - calc;
      }

      return Math.max(0, Math.min(1, vertical ? 1 - calc : calc));
    }

    /**
     * Convert percentage offset on slide to equivalent model value
     * @param percent
     * @returns {*}
     */
    function percentToValue( percent ) {
      var adjustedPercent = invert ? (1 - percent) : percent;
      return (min + adjustedPercent * (max - min));
    }

    function valueToPercent( val ) {
      var percent = (val - min) / (max - min);
      return invert ? (1 - percent) : percent;
    }
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.sticky
 * @description
 * Sticky effects for md
 *
 */
MdSticky['$inject'] = ["$mdConstant", "$$rAF", "$mdUtil", "$compile"];
angular
  .module('material.components.sticky', [
    'material.core',
    'material.components.content'
  ])
  .factory('$mdSticky', MdSticky);

/**
 * @ngdoc service
 * @name $mdSticky
 * @module material.components.sticky
 *
 * @description
 * The `$mdSticky`service provides a mixin to make elements sticky.
 *
 * Whenever the current browser supports stickiness natively, the `$mdSticky` service will just
 * use the native browser stickiness.
 *
 * By default the `$mdSticky` service compiles the cloned element, when not specified through the `elementClone`
 * parameter, in the same scope as the actual element lives.
 *
 *
 * <h3>Notes</h3>
 * When using an element which is containing a compiled directive, which changed its DOM structure during compilation,
 * you should compile the clone yourself using the plain template.<br/><br/>
 * See the right usage below:
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickySelect', function($mdSticky, $compile) {
 *       var SELECT_TEMPLATE =
 *         '<md-select ng-model="selected">' +
 *           '<md-option>Option 1</md-option>' +
 *         '</md-select>';
 *
 *       return {
 *         restrict: 'E',
 *         replace: true,
 *         template: SELECT_TEMPLATE,
 *         link: function(scope,element) {
 *           $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope));
 *         }
 *       };
 *     });
 * </hljs>
 *
 * @usage
 * <hljs lang="js">
 *   angular.module('myModule')
 *     .directive('stickyText', function($mdSticky, $compile) {
 *       return {
 *         restrict: 'E',
 *         template: '<span>Sticky Text</span>',
 *         link: function(scope,element) {
 *           $mdSticky(scope, element);
 *         }
 *       };
 *     });
 * </hljs>
 *
 * @returns A `$mdSticky` function that takes three arguments:
 *   - `scope`
 *   - `element`: The element that will be 'sticky'
 *   - `elementClone`: A clone of the element, that will be shown
 *     when the user starts scrolling past the original element.
 *     If not provided, it will use the result of `element.clone()` and compiles it in the given scope.
 */
function MdSticky($mdConstant, $$rAF, $mdUtil, $compile) {

  var browserStickySupport = $mdUtil.checkStickySupport();

  /**
   * Registers an element as sticky, used internally by directives to register themselves
   */
  return function registerStickyElement(scope, element, stickyClone) {
    var contentCtrl = element.controller('mdContent');
    if (!contentCtrl) return;

    if (browserStickySupport) {
      element.css({
        position: browserStickySupport,
        top: 0,
        'z-index': 2
      });
    } else {
      var $$sticky = contentCtrl.$element.data('$$sticky');
      if (!$$sticky) {
        $$sticky = setupSticky(contentCtrl);
        contentCtrl.$element.data('$$sticky', $$sticky);
      }

      // Compile our cloned element, when cloned in this service, into the given scope.
      var cloneElement = stickyClone || $compile(element.clone())(scope);

      var deregister = $$sticky.add(element, cloneElement);
      scope.$on('$destroy', deregister);
    }
  };

  function setupSticky(contentCtrl) {
    var contentEl = contentCtrl.$element;

    // Refresh elements is very expensive, so we use the debounced
    // version when possible.
    var debouncedRefreshElements = $$rAF.throttle(refreshElements);

    // setupAugmentedScrollEvents gives us `$scrollstart` and `$scroll`,
    // more reliable than `scroll` on android.
    setupAugmentedScrollEvents(contentEl);
    contentEl.on('$scrollstart', debouncedRefreshElements);
    contentEl.on('$scroll', onScroll);

    var self;
    return self = {
      prev: null,
      current: null, //the currently stickied item
      next: null,
      items: [],
      add: add,
      refreshElements: refreshElements
    };

    /***************
     * Public
     ***************/
    // Add an element and its sticky clone to this content's sticky collection
    function add(element, stickyClone) {
      stickyClone.addClass('md-sticky-clone');

      var item = {
        element: element,
        clone: stickyClone
      };
      self.items.push(item);

      $mdUtil.nextTick(function() {
        contentEl.prepend(item.clone);
      });

      debouncedRefreshElements();

      return function remove() {
        self.items.forEach(function(item, index) {
          if (item.element[0] === element[0]) {
            self.items.splice(index, 1);
            item.clone.remove();
          }
        });
        debouncedRefreshElements();
      };
    }

    function refreshElements() {
      // Sort our collection of elements by their current position in the DOM.
      // We need to do this because our elements' order of being added may not
      // be the same as their order of display.
      self.items.forEach(refreshPosition);
      self.items = self.items.sort(function(a, b) {
        return a.top < b.top ? -1 : 1;
      });

      // Find which item in the list should be active, 
      // based upon the content's current scroll position
      var item;
      var currentScrollTop = contentEl.prop('scrollTop');
      for (var i = self.items.length - 1; i >= 0; i--) {
        if (currentScrollTop > self.items[i].top) {
          item = self.items[i];
          break;
        }
      }
      setCurrentItem(item);
    }

    /***************
     * Private
     ***************/

    // Find the `top` of an item relative to the content element,
    // and also the height.
    function refreshPosition(item) {
      // Find the top of an item by adding to the offsetHeight until we reach the 
      // content element.
      var current = item.element[0];
      item.top = 0;
      item.left = 0;
      item.right = 0;
      while (current && current !== contentEl[0]) {
        item.top += current.offsetTop;
        item.left += current.offsetLeft;
        if ( current.offsetParent ){
          item.right += current.offsetParent.offsetWidth - current.offsetWidth - current.offsetLeft; //Compute offsetRight
        }
        current = current.offsetParent;
      }
      item.height = item.element.prop('offsetHeight');

      var defaultVal = $mdUtil.floatingScrollbars() ? '0' : undefined;
      $mdUtil.bidi(item.clone, 'margin-left', item.left, defaultVal);
      $mdUtil.bidi(item.clone, 'margin-right', defaultVal, item.right);
    }

    // As we scroll, push in and select the correct sticky element.
    function onScroll() {
      var scrollTop = contentEl.prop('scrollTop');
      var isScrollingDown = scrollTop > (onScroll.prevScrollTop || 0);

      // Store the previous scroll so we know which direction we are scrolling
      onScroll.prevScrollTop = scrollTop;

      //
      // AT TOP (not scrolling)
      //
      if (scrollTop === 0) {
        // If we're at the top, just clear the current item and return
        setCurrentItem(null);
        return;
      }

      //
      // SCROLLING DOWN (going towards the next item)
      //
      if (isScrollingDown) {

        // If we've scrolled down past the next item's position, sticky it and return
        if (self.next && self.next.top <= scrollTop) {
          setCurrentItem(self.next);
          return;
        }

        // If the next item is close to the current one, push the current one up out of the way
        if (self.current && self.next && self.next.top - scrollTop <= self.next.height) {
          translate(self.current, scrollTop + (self.next.top - self.next.height - scrollTop));
          return;
        }
      }

      //
      // SCROLLING UP (not at the top & not scrolling down; must be scrolling up)
      //
      if (!isScrollingDown) {

        // If we've scrolled up past the previous item's position, sticky it and return
        if (self.current && self.prev && scrollTop < self.current.top) {
          setCurrentItem(self.prev);
          return;
        }

        // If the next item is close to the current one, pull the current one down into view
        if (self.next && self.current && (scrollTop >= (self.next.top - self.current.height))) {
          translate(self.current, scrollTop + (self.next.top - scrollTop - self.current.height));
          return;
        }
      }

      //
      // Otherwise, just move the current item to the proper place (scrolling up or down)
      //
      if (self.current) {
        translate(self.current, scrollTop);
      }
    }

    function setCurrentItem(item) {
      if (self.current === item) return;
      // Deactivate currently active item
      if (self.current) {
        translate(self.current, null);
        setStickyState(self.current, null);
      }

      // Activate new item if given
      if (item) {
        setStickyState(item, 'active');
      }

      self.current = item;
      var index = self.items.indexOf(item);
      // If index === -1, index + 1 = 0. It works out.
      self.next = self.items[index + 1];
      self.prev = self.items[index - 1];
      setStickyState(self.next, 'next');
      setStickyState(self.prev, 'prev');
    }

    function setStickyState(item, state) {
      if (!item || item.state === state) return;
      if (item.state) {
        item.clone.attr('sticky-prev-state', item.state);
        item.element.attr('sticky-prev-state', item.state);
      }
      item.clone.attr('sticky-state', state);
      item.element.attr('sticky-state', state);
      item.state = state;
    }

    function translate(item, amount) {
      if (!item) return;
      if (amount === null || amount === undefined) {
        if (item.translateY) {
          item.translateY = null;
          item.clone.css($mdConstant.CSS.TRANSFORM, '');
        }
      } else {
        item.translateY = amount;

        $mdUtil.bidi( item.clone, $mdConstant.CSS.TRANSFORM,
          'translate3d(' + item.left + 'px,' + amount + 'px,0)',
          'translateY(' + amount + 'px)'
        );
      }
    }
  }


  // Android 4.4 don't accurately give scroll events.
  // To fix this problem, we setup a fake scroll event. We say:
  // > If a scroll or touchmove event has happened in the last DELAY milliseconds, 
  //   then send a `$scroll` event every animationFrame.
  // Additionally, we add $scrollstart and $scrollend events.
  function setupAugmentedScrollEvents(element) {
    var SCROLL_END_DELAY = 200;
    var isScrolling;
    var lastScrollTime;
    element.on('scroll touchmove', function() {
      if (!isScrolling) {
        isScrolling = true;
        $$rAF.throttle(loopScrollEvent);
        element.triggerHandler('$scrollstart');
      }
      element.triggerHandler('$scroll');
      lastScrollTime = +$mdUtil.now();
    });

    function loopScrollEvent() {
      if (+$mdUtil.now() - lastScrollTime > SCROLL_END_DELAY) {
        isScrolling = false;
        element.triggerHandler('$scrollend');
      } else {
        element.triggerHandler('$scroll');
        $$rAF.throttle(loopScrollEvent);
      }
    }
  }

}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.subheader
 * @description
 * SubHeader module
 *
 *  Subheaders are special list tiles that delineate distinct sections of a
 *  list or grid list and are typically related to the current filtering or
 *  sorting criteria. Subheader tiles are either displayed inline with tiles or
 *  can be associated with content, for example, in an adjacent column.
 *
 *  Upon scrolling, subheaders remain pinned to the top of the screen and remain
 *  pinned until pushed on or off screen by the next subheader. @see [Material
 *  Design Specifications](https://www.google.com/design/spec/components/subheaders.html)
 *
 *  > To improve the visual grouping of content, use the system color for your subheaders.
 *
 */
MdSubheaderDirective['$inject'] = ["$mdSticky", "$compile", "$mdTheming", "$mdUtil", "$mdAria"];
angular
  .module('material.components.subheader', [
    'material.core',
    'material.components.sticky'
  ])
  .directive('mdSubheader', MdSubheaderDirective);

/**
 * @ngdoc directive
 * @name mdSubheader
 * @module material.components.subheader
 *
 * @restrict E
 *
 * @description
 * The `md-subheader` directive creates a sticky subheader for a section.
 *
 * Developers are able to disable the stickiness of the subheader by using the following markup
 *
 * <hljs lang="html">
 *   <md-subheader class="md-no-sticky">Not Sticky</md-subheader>
 * </hljs>
 *
 * ### Notes
 * - The `md-subheader` directive uses the <a ng-href="api/service/$mdSticky">$mdSticky</a> service
 * to make the subheader sticky.
 *
 * > Whenever the current browser doesn't support stickiness natively, the subheader
 * will be compiled twice to create a sticky clone of the subheader.
 *
 * @usage
 * <hljs lang="html">
 * <md-subheader>Online Friends</md-subheader>
 * </hljs>
 */

function MdSubheaderDirective($mdSticky, $compile, $mdTheming, $mdUtil, $mdAria) {
  return {
    restrict: 'E',
    replace: true,
    transclude: true,
    template: (
    '<div class="md-subheader _md">' +
    '  <div class="md-subheader-inner">' +
    '    <div class="md-subheader-content"></div>' +
    '  </div>' +
    '</div>'
    ),
    link: function postLink(scope, element, attr, controllers, transclude) {
      $mdTheming(element);
      element.addClass('_md');

      // Remove the ngRepeat attribute from the root element, because we don't want to compile
      // the ngRepeat for the sticky clone again.
      $mdUtil.prefixer().removeAttribute(element, 'ng-repeat');

      var outerHTML = element[0].outerHTML;

      function getContent(el) {
        return angular.element(el[0].querySelector('.md-subheader-content'));
      }

      // Set the ARIA attributes on the original element since it keeps it's original place in
      // the DOM, whereas the clones are in reverse order. Should be done after the outerHTML,
      // in order to avoid having multiple element be marked as headers.
      attr.$set('role', 'heading');
      $mdAria.expect(element, 'aria-level', '2');

      // Transclude the user-given contents of the subheader
      // the conventional way.
      transclude(scope, function(clone) {
        getContent(element).append(clone);
      });

      // Create another clone, that uses the outer and inner contents
      // of the element, that will be 'stickied' as the user scrolls.
      if (!element.hasClass('md-no-sticky')) {
        transclude(scope, function(clone) {
          // If the user adds an ng-if or ng-repeat directly to the md-subheader element, the
          // compiled clone below will only be a comment tag (since they replace their elements with
          // a comment) which cannot be properly passed to the $mdSticky; so we wrap it in our own
          // DIV to ensure we have something $mdSticky can use
          var wrapper = $compile('<div class="md-subheader-wrapper" aria-hidden="true">' + outerHTML + '</div>')(scope);

          // Delay initialization until after any `ng-if`/`ng-repeat`/etc has finished before
          // attempting to create the clone
          $mdUtil.nextTick(function() {
            // Append our transcluded clone into the wrapper.
            // We don't have to recompile the element again, because the clone is already
            // compiled in it's transclusion scope. If we recompile the outerHTML of the new clone, we would lose
            // our ngIf's and other previous registered bindings / properties.
            getContent(wrapper).append(clone);
          });

          // Make the element sticky and provide the stickyClone our self, to avoid recompilation of the subheader
          // element.
          $mdSticky(scope, element, wrapper);
        });
      }
    }
  };
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.switch
 */

MdSwitch['$inject'] = ["mdCheckboxDirective", "$mdUtil", "$mdConstant", "$parse", "$$rAF", "$mdGesture", "$timeout"];
angular.module('material.components.switch', [
  'material.core',
  'material.components.checkbox'
])
  .directive('mdSwitch', MdSwitch);

/**
 * @ngdoc directive
 * @module material.components.switch
 * @name mdSwitch
 * @restrict E
 *
 * The switch directive is used very much like the normal [angular checkbox](https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D).
 *
 * As per the [material design spec](http://www.google.com/design/spec/style/color.html#color-ui-color-application)
 * the switch is in the accent color by default. The primary color palette may be used with
 * the `md-primary` class.
 *
 * @param {string} ng-model Assignable angular expression to data-bind to.
 * @param {string=} name Property name of the form under which the control is published.
 * @param {expression=} ng-true-value The value to which the expression should be set when selected.
 * @param {expression=} ng-false-value The value to which the expression should be set when not selected.
 * @param {string=} ng-change Angular expression to be executed when input changes due to user interaction with the input element.
 * @param {expression=} ng-disabled En/Disable based on the expression.
 * @param {boolean=} md-no-ink Use of attribute indicates use of ripple ink effects.
 * @param {string=} aria-label Publish the button label used by screen-readers for accessibility. Defaults to the switch's text.
 * @param {boolean=} md-invert When set to true, the switch will be inverted.
 *
 * @usage
 * <hljs lang="html">
 * <md-switch ng-model="isActive" aria-label="Finished?">
 *   Finished ?
 * </md-switch>
 *
 * <md-switch md-no-ink ng-model="hasInk" aria-label="No Ink Effects">
 *   No Ink Effects
 * </md-switch>
 *
 * <md-switch ng-disabled="true" ng-model="isDisabled" aria-label="Disabled">
 *   Disabled
 * </md-switch>
 *
 * </hljs>
 */
function MdSwitch(mdCheckboxDirective, $mdUtil, $mdConstant, $parse, $$rAF, $mdGesture, $timeout) {
  var checkboxDirective = mdCheckboxDirective[0];

  return {
    restrict: 'E',
    priority: $mdConstant.BEFORE_NG_ARIA,
    transclude: true,
    template:
      '<div class="md-container">' +
        '<div class="md-bar"></div>' +
        '<div class="md-thumb-container">' +
          '<div class="md-thumb" md-ink-ripple md-ink-ripple-checkbox></div>' +
        '</div>'+
      '</div>' +
      '<div ng-transclude class="md-label"></div>',
    require: ['^?mdInputContainer', '?ngModel', '?^form'],
    compile: mdSwitchCompile
  };

  function mdSwitchCompile(element, attr) {
    var checkboxLink = checkboxDirective.compile(element, attr).post;
    // No transition on initial load.
    element.addClass('md-dragging');

    return function (scope, element, attr, ctrls) {
      var containerCtrl = ctrls[0];
      var ngModel = ctrls[1] || $mdUtil.fakeNgModel();
      var formCtrl = ctrls[2];

      var disabledGetter = null;
      if (attr.disabled != null) {
        disabledGetter = function() { return true; };
      } else if (attr.ngDisabled) {
        disabledGetter = $parse(attr.ngDisabled);
      }

      var thumbContainer = angular.element(element[0].querySelector('.md-thumb-container'));
      var switchContainer = angular.element(element[0].querySelector('.md-container'));
      var labelContainer = angular.element(element[0].querySelector('.md-label'));

      // no transition on initial load
      $$rAF(function() {
        element.removeClass('md-dragging');
      });

      checkboxLink(scope, element, attr, ctrls);

      if (disabledGetter) {
        scope.$watch(disabledGetter, function(isDisabled) {
          element.attr('tabindex', isDisabled ? -1 : 0);
        });
      }

      attr.$observe('mdInvert', function(newValue) {
        var isInverted = $mdUtil.parseAttributeBoolean(newValue);

        isInverted ? element.prepend(labelContainer) : element.prepend(switchContainer);

        // Toggle a CSS class to update the margin.
        element.toggleClass('md-inverted', isInverted);
      });

      // These events are triggered by setup drag
      $mdGesture.register(switchContainer, 'drag');
      switchContainer
        .on('$md.dragstart', onDragStart)
        .on('$md.drag', onDrag)
        .on('$md.dragend', onDragEnd);

      var drag;
      function onDragStart(ev) {
        // Don't go if the switch is disabled.
        if (disabledGetter && disabledGetter(scope)) return;
        ev.stopPropagation();

        element.addClass('md-dragging');
        drag = {width: thumbContainer.prop('offsetWidth')};
      }

      function onDrag(ev) {
        if (!drag) return;
        ev.stopPropagation();
        ev.srcEvent && ev.srcEvent.preventDefault();

        var percent = ev.pointer.distanceX / drag.width;

        //if checked, start from right. else, start from left
        var translate = ngModel.$viewValue ?  1 + percent : percent;
        // Make sure the switch stays inside its bounds, 0-1%
        translate = Math.max(0, Math.min(1, translate));

        thumbContainer.css($mdConstant.CSS.TRANSFORM, 'translate3d(' + (100*translate) + '%,0,0)');
        drag.translate = translate;
      }

      function onDragEnd(ev) {
        if (!drag) return;
        ev.stopPropagation();

        element.removeClass('md-dragging');
        thumbContainer.css($mdConstant.CSS.TRANSFORM, '');

        // We changed if there is no distance (this is a click a click),
        // or if the drag distance is >50% of the total.
        var isChanged = ngModel.$viewValue ? drag.translate < 0.5 : drag.translate > 0.5;
        if (isChanged) {
          applyModelValue(!ngModel.$viewValue);
        }
        drag = null;

        // Wait for incoming mouse click
        scope.skipToggle = true;
        $timeout(function() {
          scope.skipToggle = false;
        }, 1);
      }

      function applyModelValue(newValue) {
        scope.$apply(function() {
          ngModel.$setViewValue(newValue);
          ngModel.$render();
        });
      }

    };
  }


}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tabs
 * @description
 *
 *  Tabs, created with the `<md-tabs>` directive provide *tabbed* navigation with different styles.
 *  The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.
 *
 *  Features include support for:
 *
 *  - static or dynamic tabs,
 *  - responsive designs,
 *  - accessibility support (ARIA),
 *  - tab pagination,
 *  - external or internal tab content,
 *  - focus indicators and arrow-key navigations,
 *  - programmatic lookup and access to tab controllers, and
 *  - dynamic transitions through different tab contents.
 *
 */
/*
 * @see js folder for tabs implementation
 */
angular.module('material.components.tabs', [
  'material.core',
  'material.components.icon'
]);

/**
 * @ngdoc directive
 * @name mdTab
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * Use the `<md-tab>` a nested directive used within `<md-tabs>` to specify a tab with a **label** and optional *view content*.
 *
 * If the `label` attribute is not specified, then an optional `<md-tab-label>` tag can be used to specify more
 * complex tab header markup. If neither the **label** nor the **md-tab-label** are specified, then the nested
 * markup of the `<md-tab>` is used as the tab header markup.
 *
 * Please note that if you use `<md-tab-label>`, your content **MUST** be wrapped in the `<md-tab-body>` tag.  This
 * is to define a clear separation between the tab content and the tab label.
 *
 * This container is used by the TabsController to show/hide the active tab's content view. This synchronization is
 * automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can
 * be initiated via data binding changes, programmatic invocation, or user gestures.
 *
 * @param {string=} label Optional attribute to specify a simple string as the tab label
 * @param {boolean=} ng-disabled If present and expression evaluates to truthy, disabled tab selection.
 * @param {expression=} md-on-deselect Expression to be evaluated after the tab has been de-selected.
 * @param {expression=} md-on-select Expression to be evaluated after the tab has been selected.
 * @param {boolean=} md-active When true, sets the active tab.  Note: There can only be one active tab at a time.
 *
 *
 * @usage
 *
 * <hljs lang="html">
 * <md-tab label="" ng-disabled md-on-select="" md-on-deselect="" >
 *   <h3>My Tab content</h3>
 * </md-tab>
 *
 * <md-tab >
 *   <md-tab-label>
 *     <h3>My Tab content</h3>
 *   </md-tab-label>
 *   <md-tab-body>
 *     <p>
 *       Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium,
 *       totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae
 *       dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit,
 *       sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.
 *     </p>
 *   </md-tab-body>
 * </md-tab>
 * </hljs>
 *
 */
angular
    .module('material.components.tabs')
    .directive('mdTab', MdTab);

function MdTab () {
  return {
    require:  '^?mdTabs',
    terminal: true,
    compile:  function (element, attr) {
      var label = firstChild(element, 'md-tab-label'),
          body  = firstChild(element, 'md-tab-body');

      if (label.length === 0) {
        label = angular.element('<md-tab-label></md-tab-label>');
        if (attr.label) label.text(attr.label);
        else label.append(element.contents());

        if (body.length === 0) {
          var contents = element.contents().detach();
          body         = angular.element('<md-tab-body></md-tab-body>');
          body.append(contents);
        }
      }

      element.append(label);
      if (body.html()) element.append(body);

      return postLink;
    },
    scope:    {
      active:   '=?mdActive',
      disabled: '=?ngDisabled',
      select:   '&?mdOnSelect',
      deselect: '&?mdOnDeselect'
    }
  };

  function postLink (scope, element, attr, ctrl) {
    if (!ctrl) return;
    var index = ctrl.getTabElementIndex(element),
        body  = firstChild(element, 'md-tab-body').remove(),
        label = firstChild(element, 'md-tab-label').remove(),
        data  = ctrl.insertTab({
          scope:    scope,
          parent:   scope.$parent,
          index:    index,
          element:  element,
          template: body.html(),
          label:    label.html()
        }, index);

    scope.select   = scope.select || angular.noop;
    scope.deselect = scope.deselect || angular.noop;

    scope.$watch('active', function (active) { if (active) ctrl.select(data.getIndex(), true); });
    scope.$watch('disabled', function () { ctrl.refreshIndex(); });
    scope.$watch(
        function () {
          return ctrl.getTabElementIndex(element);
        },
        function (newIndex) {
          data.index = newIndex;
          ctrl.updateTabOrder();
        }
    );
    scope.$on('$destroy', function () { ctrl.removeTab(data); });
  }

  function firstChild (element, tagName) {
    var children = element[0].children;
    for (var i = 0, len = children.length; i < len; i++) {
      var child = children[i];
      if (child.tagName === tagName.toUpperCase()) return angular.element(child);
    }
    return angular.element();
  }
}

angular
    .module('material.components.tabs')
    .directive('mdTabItem', MdTabItem);

function MdTabItem () {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;
      ctrl.attachRipple(scope, element);
    }
  };
}

angular
    .module('material.components.tabs')
    .directive('mdTabLabel', MdTabLabel);

function MdTabLabel () {
  return { terminal: true };
}



MdTabScroll['$inject'] = ["$parse"];angular.module('material.components.tabs')
    .directive('mdTabScroll', MdTabScroll);

function MdTabScroll ($parse) {
  return {
    restrict: 'A',
    compile: function ($element, attr) {
      var fn = $parse(attr.mdTabScroll, null, true);
      return function ngEventHandler (scope, element) {
        element.on('mousewheel', function (event) {
          scope.$apply(function () { fn(scope, { $event: event }); });
        });
      };
    }
  };
}


MdTabsController['$inject'] = ["$scope", "$element", "$window", "$mdConstant", "$mdTabInkRipple", "$mdUtil", "$animateCss", "$attrs", "$compile", "$mdTheming", "$mdInteraction"];angular
    .module('material.components.tabs')
    .controller('MdTabsController', MdTabsController);

/**
 * ngInject
 */
function MdTabsController ($scope, $element, $window, $mdConstant, $mdTabInkRipple, $mdUtil,
                           $animateCss, $attrs, $compile, $mdTheming, $mdInteraction) {
  // define private properties
  var ctrl      = this,
      locked    = false,
      elements  = getElements(),
      queue     = [],
      destroyed = false,
      loaded    = false;


  // Define public methods
  ctrl.$onInit            = $onInit;
  ctrl.updatePagination   = $mdUtil.debounce(updatePagination, 100);
  ctrl.redirectFocus      = redirectFocus;
  ctrl.attachRipple       = attachRipple;
  ctrl.insertTab          = insertTab;
  ctrl.removeTab          = removeTab;
  ctrl.select             = select;
  ctrl.scroll             = scroll;
  ctrl.nextPage           = nextPage;
  ctrl.previousPage       = previousPage;
  ctrl.keydown            = keydown;
  ctrl.canPageForward     = canPageForward;
  ctrl.canPageBack        = canPageBack;
  ctrl.refreshIndex       = refreshIndex;
  ctrl.incrementIndex     = incrementIndex;
  ctrl.getTabElementIndex = getTabElementIndex;
  ctrl.updateInkBarStyles = $mdUtil.debounce(updateInkBarStyles, 100);
  ctrl.updateTabOrder     = $mdUtil.debounce(updateTabOrder, 100);
  ctrl.getFocusedTabId    = getFocusedTabId;

  // For Angular 1.4 and older, where there are no lifecycle hooks but bindings are pre-assigned,
  // manually call the $onInit hook.
  if (angular.version.major === 1 && angular.version.minor <= 4) {
    this.$onInit();
  }

  /**
   * Angular Lifecycle hook for newer Angular versions.
   * Bindings are not guaranteed to have been assigned in the controller, but they are in the $onInit hook.
   */
  function $onInit() {
    // Define one-way bindings
    defineOneWayBinding('stretchTabs', handleStretchTabs);

    // Define public properties with change handlers
    defineProperty('focusIndex', handleFocusIndexChange, ctrl.selectedIndex || 0);
    defineProperty('offsetLeft', handleOffsetChange, 0);
    defineProperty('hasContent', handleHasContent, false);
    defineProperty('maxTabWidth', handleMaxTabWidth, getMaxTabWidth());
    defineProperty('shouldPaginate', handleShouldPaginate, false);

    // Define boolean attributes
    defineBooleanAttribute('noInkBar', handleInkBar);
    defineBooleanAttribute('dynamicHeight', handleDynamicHeight);
    defineBooleanAttribute('noPagination');
    defineBooleanAttribute('swipeContent');
    defineBooleanAttribute('noDisconnect');
    defineBooleanAttribute('autoselect');
    defineBooleanAttribute('noSelectClick');
    defineBooleanAttribute('centerTabs', handleCenterTabs, false);
    defineBooleanAttribute('enableDisconnect');

    // Define public properties
    ctrl.scope             = $scope;
    ctrl.parent            = $scope.$parent;
    ctrl.tabs              = [];
    ctrl.lastSelectedIndex = null;
    ctrl.hasFocus          = false;
    ctrl.styleTabItemFocus = false;
    ctrl.shouldCenterTabs  = shouldCenterTabs();
    ctrl.tabContentPrefix  = 'tab-content-';

    // Setup the tabs controller after all bindings are available.
    setupTabsController();
  }

  /**
   * Perform setup for the controller, setup events and watcher(s)
   */
  function setupTabsController () {
    ctrl.selectedIndex = ctrl.selectedIndex || 0;
    compileTemplate();
    configureWatchers();
    bindEvents();
    $mdTheming($element);
    $mdUtil.nextTick(function () {
      // Note that the element references need to be updated, because certain "browsers"
      // (IE/Edge) lose them and start throwing "Invalid calling object" errors, when we
      // compile the element contents down in `compileElement`.
      elements = getElements();
      updateHeightFromContent();
      adjustOffset();
      updateInkBarStyles();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
      loaded = true;
      updatePagination();
    });
  }

  /**
   * Compiles the template provided by the user.  This is passed as an attribute from the tabs
   * directive's template function.
   */
  function compileTemplate () {
    var template = $attrs.$mdTabsTemplate,
        element  = angular.element($element[0].querySelector('md-tab-data'));

    element.html(template);
    $compile(element.contents())(ctrl.parent);
    delete $attrs.$mdTabsTemplate;
  }

  /**
   * Binds events used by the tabs component.
   */
  function bindEvents () {
    angular.element($window).on('resize', handleWindowResize);
    $scope.$on('$destroy', cleanup);
  }

  /**
   * Configure watcher(s) used by Tabs
   */
  function configureWatchers () {
    $scope.$watch('$mdTabsCtrl.selectedIndex', handleSelectedIndexChange);
  }

  /**
   * Creates a one-way binding manually rather than relying on Angular's isolated scope
   * @param key
   * @param handler
   */
  function defineOneWayBinding (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    $attrs.$observe(attr, function (newValue) { ctrl[ key ] = newValue; });
  }

  /**
   * Defines boolean attributes with default value set to true.  (ie. md-stretch-tabs with no value
   * will be treated as being truthy)
   * @param key
   * @param handler
   */
  function defineBooleanAttribute (key, handler) {
    var attr = $attrs.$normalize('md-' + key);
    if (handler) defineProperty(key, handler);
    if ($attrs.hasOwnProperty(attr)) updateValue($attrs[attr]);
    $attrs.$observe(attr, updateValue);
    function updateValue (newValue) {
      ctrl[ key ] = newValue !== 'false';
    }
  }

  /**
   * Remove any events defined by this controller
   */
  function cleanup () {
    destroyed = true;
    angular.element($window).off('resize', handleWindowResize);
  }

  // Change handlers

  /**
   * Toggles stretch tabs class and updates inkbar when tab stretching changes
   * @param stretchTabs
   */
  function handleStretchTabs (stretchTabs) {
    var elements = getElements();
    angular.element(elements.wrapper).toggleClass('md-stretch-tabs', shouldStretchTabs());
    updateInkBarStyles();
  }

  function handleCenterTabs (newValue) {
    ctrl.shouldCenterTabs = shouldCenterTabs();
  }

  function handleMaxTabWidth (newWidth, oldWidth) {
    if (newWidth !== oldWidth) {
      var elements = getElements();

      angular.forEach(elements.tabs, function(tab) {
        tab.style.maxWidth = newWidth + 'px';
      });
      $mdUtil.nextTick(ctrl.updateInkBarStyles);
    }
  }

  function handleShouldPaginate (newValue, oldValue) {
    if (newValue !== oldValue) {
      ctrl.maxTabWidth      = getMaxTabWidth();
      ctrl.shouldCenterTabs = shouldCenterTabs();
      $mdUtil.nextTick(function () {
        ctrl.maxTabWidth = getMaxTabWidth();
        adjustOffset(ctrl.selectedIndex);
      });
    }
  }

  /**
   * Add/remove the `md-no-tab-content` class depending on `ctrl.hasContent`
   * @param hasContent
   */
  function handleHasContent (hasContent) {
    $element[ hasContent ? 'removeClass' : 'addClass' ]('md-no-tab-content');
  }

  /**
   * Apply ctrl.offsetLeft to the paging element when it changes
   * @param left
   */
  function handleOffsetChange (left) {
    var elements = getElements();
    var newValue = ctrl.shouldCenterTabs ? '' : '-' + left + 'px';

    angular.element(elements.paging).css($mdConstant.CSS.TRANSFORM, 'translate3d(' + newValue + ', 0, 0)');
    $scope.$broadcast('$mdTabsPaginationChanged');
  }

  /**
   * Update the UI whenever `ctrl.focusIndex` is updated
   * @param newIndex
   * @param oldIndex
   */
  function handleFocusIndexChange (newIndex, oldIndex) {
    if (newIndex === oldIndex) return;
    if (!getElements().tabs[ newIndex ]) return;
    adjustOffset();
    redirectFocus();
  }

  /**
   * Update the UI whenever the selected index changes. Calls user-defined select/deselect methods.
   * @param newValue
   * @param oldValue
   */
  function handleSelectedIndexChange (newValue, oldValue) {
    if (newValue === oldValue) return;

    ctrl.selectedIndex     = getNearestSafeIndex(newValue);
    ctrl.lastSelectedIndex = oldValue;
    ctrl.updateInkBarStyles();
    updateHeightFromContent();
    adjustOffset(newValue);
    $scope.$broadcast('$mdTabsChanged');
    ctrl.tabs[ oldValue ] && ctrl.tabs[ oldValue ].scope.deselect();
    ctrl.tabs[ newValue ] && ctrl.tabs[ newValue ].scope.select();
  }

  function getTabElementIndex(tabEl){
    var tabs = $element[0].getElementsByTagName('md-tab');
    return Array.prototype.indexOf.call(tabs, tabEl[0]);
  }

  /**
   * Queues up a call to `handleWindowResize` when a resize occurs while the tabs component is
   * hidden.
   */
  function handleResizeWhenVisible () {
    // if there is already a watcher waiting for resize, do nothing
    if (handleResizeWhenVisible.watcher) return;
    // otherwise, we will abuse the $watch function to check for visible
    handleResizeWhenVisible.watcher = $scope.$watch(function () {
      // since we are checking for DOM size, we use $mdUtil.nextTick() to wait for after the DOM updates
      $mdUtil.nextTick(function () {
        // if the watcher has already run (ie. multiple digests in one cycle), do nothing
        if (!handleResizeWhenVisible.watcher) return;

        if ($element.prop('offsetParent')) {
          handleResizeWhenVisible.watcher();
          handleResizeWhenVisible.watcher = null;

          handleWindowResize();
        }
      }, false);
    });
  }

  // Event handlers / actions

  /**
   * Handle user keyboard interactions
   * @param event
   */
  function keydown (event) {
    switch (event.keyCode) {
      case $mdConstant.KEY_CODE.LEFT_ARROW:
        event.preventDefault();
        incrementIndex(-1, true);
        break;
      case $mdConstant.KEY_CODE.RIGHT_ARROW:
        event.preventDefault();
        incrementIndex(1, true);
        break;
      case $mdConstant.KEY_CODE.SPACE:
      case $mdConstant.KEY_CODE.ENTER:
        event.preventDefault();
        if (!locked) select(ctrl.focusIndex);
        break;
    }
  }

  /**
   * Update the selected index. Triggers a click event on the original `md-tab` element in order
   * to fire user-added click events if canSkipClick or `md-no-select-click` are false.
   * @param index
   * @param canSkipClick Optionally allow not firing the click event if `md-no-select-click` is also true.
   */
  function select (index, canSkipClick) {
    if (!locked) ctrl.focusIndex = ctrl.selectedIndex = index;
    // skip the click event if noSelectClick is enabled
    if (canSkipClick && ctrl.noSelectClick) return;
    // nextTick is required to prevent errors in user-defined click events
    $mdUtil.nextTick(function () {
      ctrl.tabs[ index ].element.triggerHandler('click');
    }, false);
  }

  /**
   * When pagination is on, this makes sure the selected index is in view.
   * @param event
   */
  function scroll (event) {
    if (!ctrl.shouldPaginate) return;
    event.preventDefault();
    ctrl.offsetLeft = fixOffset(ctrl.offsetLeft - event.wheelDelta);
  }

  /**
   * Slides the tabs over approximately one page forward.
   */
  function nextPage () {
    var elements = getElements();
    var viewportWidth = elements.canvas.clientWidth,
        totalWidth    = viewportWidth + ctrl.offsetLeft,
        i, tab;
    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[ i ];
      if (tab.offsetLeft + tab.offsetWidth > totalWidth) break;
    }

    if (viewportWidth > tab.offsetWidth) {
      //Canvas width *greater* than tab width: usual positioning
      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
    } else {
      /**
       * Canvas width *smaller* than tab width: positioning at the *end* of current tab to let
       * pagination "for loop" to proceed correctly on next tab when nextPage() is called again
       */
      ctrl.offsetLeft = fixOffset(tab.offsetLeft + (tab.offsetWidth - viewportWidth + 1));
    }
  }

  /**
   * Slides the tabs over approximately one page backward.
   */
  function previousPage () {
    var i, tab, elements = getElements();

    for (i = 0; i < elements.tabs.length; i++) {
      tab = elements.tabs[ i ];
      if (tab.offsetLeft + tab.offsetWidth >= ctrl.offsetLeft) break;
    }

    if (elements.canvas.clientWidth > tab.offsetWidth) {
      //Canvas width *greater* than tab width: usual positioning
      ctrl.offsetLeft = fixOffset(tab.offsetLeft + tab.offsetWidth - elements.canvas.clientWidth);
    } else {
      /**
       * Canvas width *smaller* than tab width: positioning at the *beginning* of current tab to let
       * pagination "for loop" to break correctly on previous tab when previousPage() is called again
       */
      ctrl.offsetLeft = fixOffset(tab.offsetLeft);
    }
  }

  /**
   * Update size calculations when the window is resized.
   */
  function handleWindowResize () {
    ctrl.lastSelectedIndex = ctrl.selectedIndex;
    ctrl.offsetLeft        = fixOffset(ctrl.offsetLeft);
    $mdUtil.nextTick(function () {
      ctrl.updateInkBarStyles();
      updatePagination();
    });
  }

  function handleInkBar (hide) {
    angular.element(getElements().inkBar).toggleClass('ng-hide', hide);
  }

  /**
   * Toggle dynamic height class when value changes
   * @param value
   */
  function handleDynamicHeight (value) {
    $element.toggleClass('md-dynamic-height', value);
  }

  /**
   * Remove a tab from the data and select the nearest valid tab.
   * @param tabData
   */
  function removeTab (tabData) {
    if (destroyed) return;
    var selectedIndex = ctrl.selectedIndex,
        tab           = ctrl.tabs.splice(tabData.getIndex(), 1)[ 0 ];
    refreshIndex();
    // when removing a tab, if the selected index did not change, we have to manually trigger the
    //   tab select/deselect events
    if (ctrl.selectedIndex === selectedIndex) {
      tab.scope.deselect();
      ctrl.tabs[ ctrl.selectedIndex ] && ctrl.tabs[ ctrl.selectedIndex ].scope.select();
    }
    $mdUtil.nextTick(function () {
      updatePagination();
      ctrl.offsetLeft = fixOffset(ctrl.offsetLeft);
    });
  }

  /**
   * Create an entry in the tabs array for a new tab at the specified index.
   * @param tabData
   * @param index
   * @returns {*}
   */
  function insertTab (tabData, index) {
    var hasLoaded = loaded;
    var proto     = {
          getIndex:     function () { return ctrl.tabs.indexOf(tab); },
          isActive:     function () { return this.getIndex() === ctrl.selectedIndex; },
          isLeft:       function () { return this.getIndex() < ctrl.selectedIndex; },
          isRight:      function () { return this.getIndex() > ctrl.selectedIndex; },
          shouldRender: function () { return !ctrl.noDisconnect || this.isActive(); },
          hasFocus:     function () {
            return ctrl.styleTabItemFocus
                && ctrl.hasFocus && this.getIndex() === ctrl.focusIndex;
          },
          id:           $mdUtil.nextUid(),
          hasContent: !!(tabData.template && tabData.template.trim())
        },
        tab       = angular.extend(proto, tabData);
    if (angular.isDefined(index)) {
      ctrl.tabs.splice(index, 0, tab);
    } else {
      ctrl.tabs.push(tab);
    }

    processQueue();
    updateHasContent();
    $mdUtil.nextTick(function () {
      updatePagination();
      setAriaControls(tab);

      // if autoselect is enabled, select the newly added tab
      if (hasLoaded && ctrl.autoselect) $mdUtil.nextTick(function () {
        $mdUtil.nextTick(function () { select(ctrl.tabs.indexOf(tab)); });
      });
    });
    return tab;
  }

  // Getter methods

  /**
   * Gathers references to all of the DOM elements used by this controller.
   * @returns {{}}
   */
  function getElements () {
    var elements = {};
    var node = $element[0];

    // gather tab bar elements
    elements.wrapper = node.querySelector('md-tabs-wrapper');
    elements.canvas  = elements.wrapper.querySelector('md-tabs-canvas');
    elements.paging  = elements.canvas.querySelector('md-pagination-wrapper');
    elements.inkBar  = elements.paging.querySelector('md-ink-bar');

    elements.contents = node.querySelectorAll('md-tabs-content-wrapper > md-tab-content');
    elements.tabs    = elements.paging.querySelectorAll('md-tab-item');
    elements.dummies = elements.canvas.querySelectorAll('md-dummy-tab');

    return elements;
  }

  /**
   * Determines whether or not the left pagination arrow should be enabled.
   * @returns {boolean}
   */
  function canPageBack () {
    return ctrl.offsetLeft > 0;
  }

  /**
   * Determines whether or not the right pagination arrow should be enabled.
   * @returns {*|boolean}
   */
  function canPageForward () {
    var elements = getElements();
    var lastTab = elements.tabs[ elements.tabs.length - 1 ];
    return lastTab && lastTab.offsetLeft + lastTab.offsetWidth > elements.canvas.clientWidth +
        ctrl.offsetLeft;
  }

  /**
   * Returns currently focused tab item's element ID
   */
  function getFocusedTabId() {
    var focusedTab = ctrl.tabs[ctrl.focusIndex];
    if (!focusedTab || !focusedTab.id) {
      return null;
    }
    return 'tab-item-' + focusedTab.id;
  }

  /**
   * Determines if the UI should stretch the tabs to fill the available space.
   * @returns {*}
   */
  function shouldStretchTabs () {
    switch (ctrl.stretchTabs) {
      case 'always':
        return true;
      case 'never':
        return false;
      default:
        return !ctrl.shouldPaginate
            && $window.matchMedia('(max-width: 600px)').matches;
    }
  }

  /**
   * Determines if the tabs should appear centered.
   * @returns {string|boolean}
   */
  function shouldCenterTabs () {
    return ctrl.centerTabs && !ctrl.shouldPaginate;
  }

  /**
   * Determines if pagination is necessary to display the tabs within the available space.
   * @returns {boolean}
   */
  function shouldPaginate () {
    if (ctrl.noPagination || !loaded) return false;
    var canvasWidth = $element.prop('clientWidth');

    angular.forEach(getElements().dummies, function (tab) {
      canvasWidth -= tab.offsetWidth;
    });

    return canvasWidth < 0;
  }

  /**
   * Finds the nearest tab index that is available.  This is primarily used for when the active
   * tab is removed.
   * @param newIndex
   * @returns {*}
   */
  function getNearestSafeIndex (newIndex) {
    if (newIndex === -1) return -1;
    var maxOffset = Math.max(ctrl.tabs.length - newIndex, newIndex),
        i, tab;
    for (i = 0; i <= maxOffset; i++) {
      tab = ctrl.tabs[ newIndex + i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
      tab = ctrl.tabs[ newIndex - i ];
      if (tab && (tab.scope.disabled !== true)) return tab.getIndex();
    }
    return newIndex;
  }

  // Utility methods

  /**
   * Defines a property using a getter and setter in order to trigger a change handler without
   * using `$watch` to observe changes.
   * @param key
   * @param handler
   * @param value
   */
  function defineProperty (key, handler, value) {
    Object.defineProperty(ctrl, key, {
      get: function () { return value; },
      set: function (newValue) {
        var oldValue = value;
        value        = newValue;
        handler && handler(newValue, oldValue);
      }
    });
  }

  /**
   * Updates whether or not pagination should be displayed.
   */
  function updatePagination () {
    ctrl.maxTabWidth = getMaxTabWidth();
    ctrl.shouldPaginate = shouldPaginate();
  }

  /**
   * Calculates the width of the pagination wrapper by summing the widths of the dummy tabs.
   * @returns {number}
   */
  function calcPagingWidth () {
    return calcTabsWidth(getElements().dummies);
  }

  function calcTabsWidth(tabs) {
    var width = 0;

    angular.forEach(tabs, function (tab) {
      //-- Uses the larger value between `getBoundingClientRect().width` and `offsetWidth`.  This
      //   prevents `offsetWidth` value from being rounded down and causing wrapping issues, but
      //   also handles scenarios where `getBoundingClientRect()` is inaccurate (ie. tabs inside
      //   of a dialog)
      width += Math.max(tab.offsetWidth, tab.getBoundingClientRect().width);
    });

    return Math.ceil(width);
  }

  function getMaxTabWidth () {
    return $element.prop('clientWidth');
  }

  /**
   * Re-orders the tabs and updates the selected and focus indexes to their new positions.
   * This is triggered by `tabDirective.js` when the user's tabs have been re-ordered.
   */
  function updateTabOrder () {
    var selectedItem   = ctrl.tabs[ ctrl.selectedIndex ],
        focusItem      = ctrl.tabs[ ctrl.focusIndex ];
    ctrl.tabs          = ctrl.tabs.sort(function (a, b) {
      return a.index - b.index;
    });
    ctrl.selectedIndex = ctrl.tabs.indexOf(selectedItem);
    ctrl.focusIndex    = ctrl.tabs.indexOf(focusItem);
  }

  /**
   * This moves the selected or focus index left or right.  This is used by the keydown handler.
   * @param inc
   */
  function incrementIndex (inc, focus) {
    var newIndex,
        key   = focus ? 'focusIndex' : 'selectedIndex',
        index = ctrl[ key ];
    for (newIndex = index + inc;
         ctrl.tabs[ newIndex ] && ctrl.tabs[ newIndex ].scope.disabled;
         newIndex += inc) {}
    if (ctrl.tabs[ newIndex ]) {
      ctrl[ key ] = newIndex;
    }
  }

  /**
   * This is used to forward focus to dummy elements.  This method is necessary to avoid animation
   * issues when attempting to focus an item that is out of view.
   */
  function redirectFocus () {
    ctrl.styleTabItemFocus = ($mdInteraction.getLastInteractionType() === 'keyboard');
    getElements().dummies[ ctrl.focusIndex ].focus();
  }

  /**
   * Forces the pagination to move the focused tab into view.
   */
  function adjustOffset (index) {
    var elements = getElements();

    if (!angular.isNumber(index)) index = ctrl.focusIndex;
    if (!elements.tabs[ index ]) return;
    if (ctrl.shouldCenterTabs) return;
    var tab         = elements.tabs[ index ],
        left        = tab.offsetLeft,
        right       = tab.offsetWidth + left;
    ctrl.offsetLeft = Math.max(ctrl.offsetLeft, fixOffset(right - elements.canvas.clientWidth + 32 * 2));
    ctrl.offsetLeft = Math.min(ctrl.offsetLeft, fixOffset(left));
  }

  /**
   * Iterates through all queued functions and clears the queue.  This is used for functions that
   * are called before the UI is ready, such as size calculations.
   */
  function processQueue () {
    queue.forEach(function (func) { $mdUtil.nextTick(func); });
    queue = [];
  }

  /**
   * Determines if the tab content area is needed.
   */
  function updateHasContent () {
    var hasContent  = false;

    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].hasContent) {
        hasContent = true;
        break;
      }
    }

    ctrl.hasContent = hasContent;
  }

  /**
   * Moves the indexes to their nearest valid values.
   */
  function refreshIndex () {
    ctrl.selectedIndex = getNearestSafeIndex(ctrl.selectedIndex);
    ctrl.focusIndex    = getNearestSafeIndex(ctrl.focusIndex);
  }

  /**
   * Calculates the content height of the current tab.
   * @returns {*}
   */
  function updateHeightFromContent () {
    if (!ctrl.dynamicHeight) return $element.css('height', '');
    if (!ctrl.tabs.length) return queue.push(updateHeightFromContent);

    var elements = getElements();

    var tabContent    = elements.contents[ ctrl.selectedIndex ],
        contentHeight = tabContent ? tabContent.offsetHeight : 0,
        tabsHeight    = elements.wrapper.offsetHeight,
        newHeight     = contentHeight + tabsHeight,
        currentHeight = $element.prop('clientHeight');

    if (currentHeight === newHeight) return;

    // Adjusts calculations for when the buttons are bottom-aligned since this relies on absolute
    // positioning.  This should probably be cleaned up if a cleaner solution is possible.
    if ($element.attr('md-align-tabs') === 'bottom') {
      currentHeight -= tabsHeight;
      newHeight -= tabsHeight;
      // Need to include bottom border in these calculations
      if ($element.attr('md-border-bottom') !== undefined) ++currentHeight;
    }

    // Lock during animation so the user can't change tabs
    locked = true;

    var fromHeight = { height: currentHeight + 'px' },
        toHeight = { height: newHeight + 'px' };

    // Set the height to the current, specific pixel height to fix a bug on iOS where the height
    // first animates to 0, then back to the proper height causing a visual glitch
    $element.css(fromHeight);

    // Animate the height from the old to the new
    $animateCss($element, {
      from: fromHeight,
      to: toHeight,
      easing: 'cubic-bezier(0.35, 0, 0.25, 1)',
      duration: 0.5
    }).start().done(function () {
      // Then (to fix the same iOS issue as above), disable transitions and remove the specific
      // pixel height so the height can size with browser width/content changes, etc.
      $element.css({
        transition: 'none',
        height: ''
      });

      // In the next tick, re-allow transitions (if we do it all at once, $element.css is "smart"
      // enough to batch it for us instead of doing it immediately, which undoes the original
      // transition: none)
      $mdUtil.nextTick(function() {
        $element.css('transition', '');
      });

      // And unlock so tab changes can occur
      locked = false;
    });
  }

  /**
   * Repositions the ink bar to the selected tab.
   * @returns {*}
   */
  function updateInkBarStyles () {
    var elements = getElements();

    if (!elements.tabs[ ctrl.selectedIndex ]) {
      angular.element(elements.inkBar).css({ left: 'auto', right: 'auto' });
      return;
    }

    if (!ctrl.tabs.length) return queue.push(ctrl.updateInkBarStyles);
    // if the element is not visible, we will not be able to calculate sizes until it is
    // we should treat that as a resize event rather than just updating the ink bar
    if (!$element.prop('offsetParent')) return handleResizeWhenVisible();

    var index      = ctrl.selectedIndex,
        totalWidth = elements.paging.offsetWidth,
        tab        = elements.tabs[ index ],
        left       = tab.offsetLeft,
        right      = totalWidth - left - tab.offsetWidth;

    if (ctrl.shouldCenterTabs) {
      // We need to use the same calculate process as in the pagination wrapper, to avoid rounding deviations.
      var tabWidth = calcTabsWidth(elements.tabs);

      if (totalWidth > tabWidth) {
        $mdUtil.nextTick(updateInkBarStyles, false);
      }
    }
    updateInkBarClassName();
    angular.element(elements.inkBar).css({ left: left + 'px', right: right + 'px' });
  }

  /**
   * Adds left/right classes so that the ink bar will animate properly.
   */
  function updateInkBarClassName () {
    var elements = getElements();
    var newIndex = ctrl.selectedIndex,
        oldIndex = ctrl.lastSelectedIndex,
        ink      = angular.element(elements.inkBar);
    if (!angular.isNumber(oldIndex)) return;
    ink
        .toggleClass('md-left', newIndex < oldIndex)
        .toggleClass('md-right', newIndex > oldIndex);
  }

  /**
   * Takes an offset value and makes sure that it is within the min/max allowed values.
   * @param value
   * @returns {*}
   */
  function fixOffset (value) {
    var elements = getElements();

    if (!elements.tabs.length || !ctrl.shouldPaginate) return 0;
    var lastTab    = elements.tabs[ elements.tabs.length - 1 ],
        totalWidth = lastTab.offsetLeft + lastTab.offsetWidth;
    value          = Math.max(0, value);
    value          = Math.min(totalWidth - elements.canvas.clientWidth, value);
    return value;
  }

  /**
   * Attaches a ripple to the tab item element.
   * @param scope
   * @param element
   */
  function attachRipple (scope, element) {
    var elements = getElements();
    var options = { colorElement: angular.element(elements.inkBar) };
    $mdTabInkRipple.attach(scope, element, options);
  }

  /**
   * Sets the `aria-controls` attribute to the elements that
   * correspond to the passed-in tab.
   * @param tab
   */
  function setAriaControls (tab) {
    if (tab.hasContent) {
      var nodes = $element[0].querySelectorAll('[md-tab-id="' + tab.id + '"]');
      angular.element(nodes).attr('aria-controls', ctrl.tabContentPrefix + tab.id);
    }
  }
}

/**
 * @ngdoc directive
 * @name mdTabs
 * @module material.components.tabs
 *
 * @restrict E
 *
 * @description
 * The `<md-tabs>` directive serves as the container for 1..n `<md-tab>` child directives to
 * produces a Tabs components. In turn, the nested `<md-tab>` directive is used to specify a tab
 * label for the **header button** and a [optional] tab view content that will be associated with
 * each tab button.
 *
 * Below is the markup for its simplest usage:
 *
 *  <hljs lang="html">
 *  <md-tabs>
 *    <md-tab label="Tab #1"></md-tab>
 *    <md-tab label="Tab #2"></md-tab>
 *    <md-tab label="Tab #3"></md-tab>
 *  </md-tabs>
 *  </hljs>
 *
 * Tabs supports three (3) usage scenarios:
 *
 *  1. Tabs (buttons only)
 *  2. Tabs with internal view content
 *  3. Tabs with external view content
 *
 * **Tab-only** support is useful when tab buttons are used for custom navigation regardless of any
 * other components, content, or views.
 *
 * <i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look
 * at the <a ng-href="./api/directive/mdNavBar">NavBar component</a> instead as it can handle this
 * case a bit more natively.</i>
 *
 * **Tabs with internal views** are the traditional usages where each tab has associated view
 * content and the view switching is managed internally by the Tabs component.
 *
 * **Tabs with external view content** is often useful when content associated with each tab is
 * independently managed and data-binding notifications announce tab selection changes.
 *
 * Additional features also include:
 *
 * *  Content can include any markup.
 * *  If a tab is disabled while active/selected, then the next tab will be auto-selected.
 *
 * ### Explanation of tab stretching
 *
 * Initially, tabs will have an inherent size.  This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS.  Calculations will be based on this size.
 *
 * On mobile devices, tabs will be expanded to fill the available horizontal space.  When this happens, all tabs will become the same size.
 *
 * On desktops, by default, stretching will never occur.
 *
 * This default behavior can be overridden through the `md-stretch-tabs` attribute.  Here is a table showing when stretching will occur:
 *
 * `md-stretch-tabs` | mobile    | desktop
 * ------------------|-----------|--------
 * `auto`            | stretched | ---
 * `always`          | stretched | stretched
 * `never`           | ---       | ---
 *
 * @param {integer=} md-selected Index of the active/selected tab
 * @param {boolean=} md-no-ink If present, disables ink ripple effects.
 * @param {boolean=} md-no-ink-bar If present, disables the selection ink bar.
 * @param {string=}  md-align-tabs Attribute to indicate position of tab buttons: `bottom` or `top`; default is `top`
 * @param {string=} md-stretch-tabs Attribute to indicate whether or not to stretch tabs: `auto`, `always`, or `never`; default is `auto`
 * @param {boolean=} md-dynamic-height When enabled, the tab wrapper will resize based on the contents of the selected tab
 * @param {boolean=} md-border-bottom If present, shows a solid `1px` border between the tabs and their content
 * @param {boolean=} md-center-tabs When enabled, tabs will be centered provided there is no need for pagination
 * @param {boolean=} md-no-pagination When enabled, pagination will remain off
 * @param {boolean=} md-swipe-content When enabled, swipe gestures will be enabled for the content area to jump between tabs
 * @param {boolean=} md-enable-disconnect When enabled, scopes will be disconnected for tabs that are not being displayed.  This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.
 * @param {boolean=} md-autoselect When present, any tabs added after the initial load will be automatically selected
 * @param {boolean=} md-no-select-click When enabled, click events will not be fired when selecting tabs
 *
 * @usage
 * <hljs lang="html">
 * <md-tabs md-selected="selectedIndex" >
 *   <img ng-src="img/angular.png" class="centered">
 *   <md-tab
 *       ng-repeat="tab in tabs | orderBy:predicate:reversed"
 *       md-on-select="onTabSelected(tab)"
 *       md-on-deselect="announceDeselected(tab)"
 *       ng-disabled="tab.disabled">
 *     <md-tab-label>
 *       {{tab.title}}
 *       <img src="img/removeTab.png" ng-click="removeTab(tab)" class="delete">
 *     </md-tab-label>
 *     <md-tab-body>
 *       {{tab.content}}
 *     </md-tab-body>
 *   </md-tab>
 * </md-tabs>
 * </hljs>
 *
 */
MdTabs['$inject'] = ["$$mdSvgRegistry"];
angular
    .module('material.components.tabs')
    .directive('mdTabs', MdTabs);

function MdTabs ($$mdSvgRegistry) {
  return {
    scope:            {
      selectedIndex: '=?mdSelected'
    },
    template:         function (element, attr) {
      attr.$mdTabsTemplate = element.html();
      return '' +
        '<md-tabs-wrapper> ' +
          '<md-tab-data></md-tab-data> ' +
          '<md-prev-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Previous Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageBack()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageBack() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.previousPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-prev-button> ' +
          '<md-next-button ' +
              'tabindex="-1" ' +
              'role="button" ' +
              'aria-label="Next Page" ' +
              'aria-disabled="{{!$mdTabsCtrl.canPageForward()}}" ' +
              'ng-class="{ \'md-disabled\': !$mdTabsCtrl.canPageForward() }" ' +
              'ng-if="$mdTabsCtrl.shouldPaginate" ' +
              'ng-click="$mdTabsCtrl.nextPage()"> ' +
            '<md-icon md-svg-src="'+ $$mdSvgRegistry.mdTabsArrow +'"></md-icon> ' +
          '</md-next-button> ' +
          '<md-tabs-canvas ' +
              'tabindex="{{ $mdTabsCtrl.hasFocus ? -1 : 0 }}" ' +
              'aria-activedescendant="{{$mdTabsCtrl.getFocusedTabId()}}" ' +
              'ng-focus="$mdTabsCtrl.redirectFocus()" ' +
              'ng-class="{ ' +
                  '\'md-paginated\': $mdTabsCtrl.shouldPaginate, ' +
                  '\'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs ' +
              '}" ' +
              'ng-keydown="$mdTabsCtrl.keydown($event)" ' +
              'role="tablist"> ' +
            '<md-pagination-wrapper ' +
                'ng-class="{ \'md-center-tabs\': $mdTabsCtrl.shouldCenterTabs }" ' +
                'md-tab-scroll="$mdTabsCtrl.scroll($event)"> ' +
              '<md-tab-item ' +
                  'tabindex="-1" ' +
                  'class="md-tab" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'role="tab" ' +
                  'md-tab-id="{{::tab.id}}"' +
                  'aria-selected="{{tab.isActive()}}" ' +
                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                  'ng-click="$mdTabsCtrl.select(tab.getIndex())" ' +
                  'ng-class="{ ' +
                      '\'md-active\':    tab.isActive(), ' +
                      '\'md-focused\':   tab.hasFocus(), ' +
                      '\'md-disabled\':  tab.scope.disabled ' +
                  '}" ' +
                  'ng-disabled="tab.scope.disabled" ' +
                  'md-swipe-left="$mdTabsCtrl.nextPage()" ' +
                  'md-swipe-right="$mdTabsCtrl.previousPage()" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-tab-item> ' +
              '<md-ink-bar></md-ink-bar> ' +
            '</md-pagination-wrapper> ' +
            '<md-tabs-dummy-wrapper class="md-visually-hidden md-dummy-wrapper"> ' +
              '<md-dummy-tab ' +
                  'class="md-tab" ' +
                  'tabindex="-1" ' +
                  'id="tab-item-{{::tab.id}}" ' +
                  'md-tab-id="{{::tab.id}}"' +
                  'aria-selected="{{tab.isActive()}}" ' +
                  'aria-disabled="{{tab.scope.disabled || \'false\'}}" ' +
                  'ng-focus="$mdTabsCtrl.hasFocus = true" ' +
                  'ng-blur="$mdTabsCtrl.hasFocus = false" ' +
                  'ng-repeat="tab in $mdTabsCtrl.tabs" ' +
                  'md-tabs-template="::tab.label" ' +
                  'md-scope="::tab.parent"></md-dummy-tab> ' +
            '</md-tabs-dummy-wrapper> ' +
          '</md-tabs-canvas> ' +
        '</md-tabs-wrapper> ' +
        '<md-tabs-content-wrapper ng-show="$mdTabsCtrl.hasContent && $mdTabsCtrl.selectedIndex >= 0" class="_md"> ' +
          '<md-tab-content ' +
              'id="{{:: $mdTabsCtrl.tabContentPrefix + tab.id}}" ' +
              'class="_md" ' +
              'role="tabpanel" ' +
              'aria-labelledby="tab-item-{{::tab.id}}" ' +
              'md-swipe-left="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(1)" ' +
              'md-swipe-right="$mdTabsCtrl.swipeContent && $mdTabsCtrl.incrementIndex(-1)" ' +
              'ng-if="tab.hasContent" ' +
              'ng-repeat="(index, tab) in $mdTabsCtrl.tabs" ' +
              'ng-class="{ ' +
                '\'md-no-transition\': $mdTabsCtrl.lastSelectedIndex == null, ' +
                '\'md-active\':        tab.isActive(), ' +
                '\'md-left\':          tab.isLeft(), ' +
                '\'md-right\':         tab.isRight(), ' +
                '\'md-no-scroll\':     $mdTabsCtrl.dynamicHeight ' +
              '}"> ' +
            '<div ' +
                'md-tabs-template="::tab.template" ' +
                'md-connected-if="tab.isActive()" ' +
                'md-scope="::tab.parent" ' +
                'ng-if="$mdTabsCtrl.enableDisconnect || tab.shouldRender()"></div> ' +
          '</md-tab-content> ' +
        '</md-tabs-content-wrapper>';
    },
    controller:       'MdTabsController',
    controllerAs:     '$mdTabsCtrl',
    bindToController: true
  };
}


MdTabsDummyWrapper['$inject'] = ["$mdUtil", "$window"];angular
  .module('material.components.tabs')
  .directive('mdTabsDummyWrapper', MdTabsDummyWrapper);

/**
 * @private
 *
 * @param $mdUtil
 * @param $window
 * @returns {{require: string, link: link}}
 * @constructor
 *
 * ngInject
 */
function MdTabsDummyWrapper ($mdUtil, $window) {
  return {
    require: '^?mdTabs',
    link:    function link (scope, element, attr, ctrl) {
      if (!ctrl) return;

      var observer;
      var disconnect;

      var mutationCallback = function() {
        ctrl.updatePagination();
        ctrl.updateInkBarStyles();
      };

      if('MutationObserver' in $window) {
        var config = {
          childList: true,
          subtree: true,
          // Per https://bugzilla.mozilla.org/show_bug.cgi?id=1138368, browsers will not fire
          // the childList mutation, once a <span> element's innerText changes.
          // The characterData of the <span> element will change.
          characterData: true
        };

        observer = new MutationObserver(mutationCallback);
        observer.observe(element[0], config);
        disconnect = observer.disconnect.bind(observer);
      } else {
        var debounced = $mdUtil.debounce(mutationCallback, 15, null, false);
        
        element.on('DOMSubtreeModified', debounced);
        disconnect = element.off.bind(element, 'DOMSubtreeModified', debounced);
      }

      // Disconnect the observer
      scope.$on('$destroy', function() {
        disconnect();
      });
    }
  };
}


MdTabsTemplate['$inject'] = ["$compile", "$mdUtil"];angular
    .module('material.components.tabs')
    .directive('mdTabsTemplate', MdTabsTemplate);

function MdTabsTemplate ($compile, $mdUtil) {
  return {
    restrict: 'A',
    link:     link,
    scope:    {
      template:     '=mdTabsTemplate',
      connected:    '=?mdConnectedIf',
      compileScope: '=mdScope'
    },
    require:  '^?mdTabs'
  };
  function link (scope, element, attr, ctrl) {
    if (!ctrl) return;

    var compileScope = ctrl.enableDisconnect ? scope.compileScope.$new() : scope.compileScope;

    element.html(scope.template);
    $compile(element.contents())(compileScope);

    return $mdUtil.nextTick(handleScope);

    function handleScope () {
      scope.$watch('connected', function (value) { value === false ? disconnect() : reconnect(); });
      scope.$on('$destroy', reconnect);
    }

    function disconnect () {
      if (ctrl.enableDisconnect) $mdUtil.disconnectScope(compileScope);
    }

    function reconnect () {
      if (ctrl.enableDisconnect) $mdUtil.reconnectScope(compileScope);
    }
  }
}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.toolbar
 */
mdToolbarDirective['$inject'] = ["$$rAF", "$mdConstant", "$mdUtil", "$mdTheming", "$animate"];
angular.module('material.components.toolbar', [
  'material.core',
  'material.components.content'
])
  .directive('mdToolbar', mdToolbarDirective);

/**
 * @ngdoc directive
 * @name mdToolbar
 * @module material.components.toolbar
 * @restrict E
 * @description
 * `md-toolbar` is used to place a toolbar in your app.
 *
 * Toolbars are usually used above a content area to display the title of the
 * current page, and show relevant action buttons for that page.
 *
 * You can change the height of the toolbar by adding either the
 * `md-medium-tall` or `md-tall` class to the toolbar.
 *
 * @usage
 * <hljs lang="html">
 * <div layout="column" layout-fill>
 *   <md-toolbar>
 *
 *     <div class="md-toolbar-tools">
 *       <h2 md-truncate flex>My App's Title</h2>
 *
 *       <md-button>
 *         Right Bar Button
 *       </md-button>
 *     </div>
 *
 *   </md-toolbar>
 *   <md-content>
 *     Hello!
 *   </md-content>
 * </div>
 * </hljs>
 *
 * <i><b>Note:</b> The code above shows usage with the `md-truncate` component which provides an
 * ellipsis if the title is longer than the width of the Toolbar.</i>
 *
 * ## CSS & Styles
 *
 * The `<md-toolbar>` provides a few custom CSS classes that you may use to enhance the
 * functionality of your toolbar.
 *
 * <div>
 * <docs-css-api-table>
 *
 *   <docs-css-selector code="md-toolbar .md-toolbar-tools">
 *     The `md-toolbar-tools` class provides quite a bit of automatic styling for your toolbar
 *     buttons and text. When applied, it will center the buttons and text vertically for you.
 *   </docs-css-selector>
 *
 * </docs-css-api-table>
 * </div>
 *
 * ### Private Classes
 *
 * Currently, the only private class is the `md-toolbar-transitions` class. All other classes are
 * considered public.
 *
 * @param {boolean=} md-scroll-shrink Whether the header should shrink away as
 * the user scrolls down, and reveal itself as the user scrolls up.
 *
 * _**Note (1):** for scrollShrink to work, the toolbar must be a sibling of a
 * `md-content` element, placed before it. See the scroll shrink demo._
 *
 * _**Note (2):** The `md-scroll-shrink` attribute is only parsed on component
 * initialization, it does not watch for scope changes._
 *
 *
 * @param {number=} md-shrink-speed-factor How much to change the speed of the toolbar's
 * shrinking by. For example, if 0.25 is given then the toolbar will shrink
 * at one fourth the rate at which the user scrolls down. Default 0.5.
 *
 */

function mdToolbarDirective($$rAF, $mdConstant, $mdUtil, $mdTheming, $animate) {
  var translateY = angular.bind(null, $mdUtil.supplant, 'translate3d(0,{0}px,0)');

  return {
    template: '',
    restrict: 'E',

    link: function(scope, element, attr) {

      element.addClass('_md');     // private md component indicator for styling
      $mdTheming(element);

      $mdUtil.nextTick(function () {
        element.addClass('_md-toolbar-transitions');     // adding toolbar transitions after digest
      }, false);

      if (angular.isDefined(attr.mdScrollShrink)) {
        setupScrollShrink();
      }

      function setupScrollShrink() {

        var toolbarHeight;
        var contentElement;
        var disableScrollShrink = angular.noop;

        // Current "y" position of scroll
        // Store the last scroll top position
        var y = 0;
        var prevScrollTop = 0;
        var shrinkSpeedFactor = attr.mdShrinkSpeedFactor || 0.5;

        var debouncedContentScroll = $$rAF.throttle(onContentScroll);
        var debouncedUpdateHeight = $mdUtil.debounce(updateToolbarHeight, 5 * 1000);

        // Wait for $mdContentLoaded event from mdContent directive.
        // If the mdContent element is a sibling of our toolbar, hook it up
        // to scroll events.

        scope.$on('$mdContentLoaded', onMdContentLoad);

        // If the toolbar is used inside an ng-if statement, we may miss the
        // $mdContentLoaded event, so we attempt to fake it if we have a
        // md-content close enough.

        attr.$observe('mdScrollShrink', onChangeScrollShrink);

        // If the toolbar has ngShow or ngHide we need to update height immediately as it changed
        // and not wait for $mdUtil.debounce to happen

        if (attr.ngShow) { scope.$watch(attr.ngShow, updateToolbarHeight); }
        if (attr.ngHide) { scope.$watch(attr.ngHide, updateToolbarHeight); }

        // If the scope is destroyed (which could happen with ng-if), make sure
        // to disable scroll shrinking again

        scope.$on('$destroy', disableScrollShrink);

        /**
         *
         */
        function onChangeScrollShrink(shrinkWithScroll) {
          var closestContent = element.parent().find('md-content');

          // If we have a content element, fake the call; this might still fail
          // if the content element isn't a sibling of the toolbar

          if (!contentElement && closestContent.length) {
            onMdContentLoad(null, closestContent);
          }

          // Evaluate the expression
          shrinkWithScroll = scope.$eval(shrinkWithScroll);

          // Disable only if the attribute's expression evaluates to false
          if (shrinkWithScroll === false) {
            disableScrollShrink();
          } else {
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         *
         */
        function onMdContentLoad($event, newContentEl) {
          // Toolbar and content must be siblings
          if (newContentEl && element.parent()[0] === newContentEl.parent()[0]) {
            // unhook old content event listener if exists
            if (contentElement) {
              contentElement.off('scroll', debouncedContentScroll);
            }

            contentElement = newContentEl;
            disableScrollShrink = enableScrollShrink();
          }
        }

        /**
         *
         */
        function onContentScroll(e) {
          var scrollTop = e ? e.target.scrollTop : prevScrollTop;

          debouncedUpdateHeight();

          y = Math.min(
            toolbarHeight / shrinkSpeedFactor,
            Math.max(0, y + scrollTop - prevScrollTop)
          );

          element.css($mdConstant.CSS.TRANSFORM, translateY([-y * shrinkSpeedFactor]));
          contentElement.css($mdConstant.CSS.TRANSFORM, translateY([(toolbarHeight - y) * shrinkSpeedFactor]));

          prevScrollTop = scrollTop;

          $mdUtil.nextTick(function() {
            var hasWhiteFrame = element.hasClass('md-whiteframe-z1');

            if (hasWhiteFrame && !y) {
              $animate.removeClass(element, 'md-whiteframe-z1');
            } else if (!hasWhiteFrame && y) {
              $animate.addClass(element, 'md-whiteframe-z1');
            }
          });

        }

        /**
         *
         */
        function enableScrollShrink() {
          if (!contentElement)     return angular.noop;           // no md-content

          contentElement.on('scroll', debouncedContentScroll);
          contentElement.attr('scroll-shrink', 'true');

          $mdUtil.nextTick(updateToolbarHeight, false);

          return function disableScrollShrink() {
            contentElement.off('scroll', debouncedContentScroll);
            contentElement.attr('scroll-shrink', 'false');

            updateToolbarHeight();
          };
        }

        /**
         *
         */
        function updateToolbarHeight() {
          toolbarHeight = element.prop('offsetHeight');
          // Add a negative margin-top the size of the toolbar to the content el.
          // The content will start transformed down the toolbarHeight amount,
          // so everything looks normal.
          //
          // As the user scrolls down, the content will be transformed up slowly
          // to put the content underneath where the toolbar was.
          var margin = (-toolbarHeight * shrinkSpeedFactor) + 'px';

          contentElement.css({
            "margin-top": margin,
            "margin-bottom": margin
          });

          onContentScroll();
        }

      }

    }
  };

}

})(window, window.angular);
/*!
 * Angular Material Design
 * https://github.com/angular/material
 * @license MIT
 * v1.1.3
 */
(function( window, angular, undefined ){
"use strict";

/**
 * @ngdoc module
 * @name material.components.tooltip
 */
MdTooltipDirective['$inject'] = ["$timeout", "$window", "$$rAF", "$document", "$interpolate", "$mdUtil", "$mdPanel", "$$mdTooltipRegistry"];
angular
    .module('material.components.tooltip', [
      'material.core',
      'material.components.panel'
    ])
    .directive('mdTooltip', MdTooltipDirective)
    .service('$$mdTooltipRegistry', MdTooltipRegistry);


/**
 * @ngdoc directive
 * @name mdTooltip
 * @module material.components.tooltip
 * @description
 * Tooltips are used to describe elements that are interactive and primarily
 * graphical (not textual).
 *
 * Place a `<md-tooltip>` as a child of the element it describes.
 *
 * A tooltip will activate when the user hovers over, focuses, or touches the
 * parent element.
 *
 * @usage
 * <hljs lang="html">
 *   <md-button class="md-fab md-accent" aria-label="Play">
 *     <md-tooltip>Play Music</md-tooltip>
 *     <md-icon md-svg-src="img/icons/ic_play_arrow_24px.svg"></md-icon>
 *   </md-button>
 * </hljs>
 *
 * @param {number=} md-z-index The visual level that the tooltip will appear
 *     in comparison with the rest of the elements of the application.
 * @param {expression=} md-visible Boolean bound to whether the tooltip is
 *     currently visible.
 * @param {number=} md-delay How many milliseconds to wait to show the tooltip
 *     after the user hovers over, focuses, or touches the parent element.
 *     Defaults to 0ms on non-touch devices and 75ms on touch.
 * @param {boolean=} md-autohide If present or provided with a boolean value,
 *     the tooltip will hide on mouse leave, regardless of focus.
 * @param {string=} md-direction The direction that the tooltip is shown,
 *     relative to the parent element. Supports top, right, bottom, and left.
 *     Defaults to bottom.
 */
function MdTooltipDirective($timeout, $window, $$rAF, $document, $interpolate,
    $mdUtil, $mdPanel, $$mdTooltipRegistry) {

  var ENTER_EVENTS = 'focus touchstart mouseenter';
  var LEAVE_EVENTS = 'blur touchcancel mouseleave';
  var TOOLTIP_DEFAULT_Z_INDEX = 100;
  var TOOLTIP_DEFAULT_SHOW_DELAY = 0;
  var TOOLTIP_DEFAULT_DIRECTION = 'bottom';
  var TOOLTIP_DIRECTIONS = {
    top: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.ABOVE },
    right: { x: $mdPanel.xPosition.OFFSET_END, y: $mdPanel.yPosition.CENTER },
    bottom: { x: $mdPanel.xPosition.CENTER, y: $mdPanel.yPosition.BELOW },
    left: { x: $mdPanel.xPosition.OFFSET_START, y: $mdPanel.yPosition.CENTER }
  };

  return {
    restrict: 'E',
    priority: 210, // Before ngAria
    scope: {
      mdZIndex: '=?mdZIndex',
      mdDelay: '=?mdDelay',
      mdVisible: '=?mdVisible',
      mdAutohide: '=?mdAutohide',
      mdDirection: '@?mdDirection' // Do not expect expressions.
    },
    link: linkFunc
  };

  function linkFunc(scope, element, attr) {
    // Set constants.
    var parent = $mdUtil.getParentWithPointerEvents(element);
    var debouncedOnResize = $$rAF.throttle(updatePosition);
    var mouseActive = false;
    var origin, position, panelPosition, panelRef, autohide, showTimeout,
        elementFocusedOnWindowBlur = null;

    // Set defaults
    setDefaults();

    // Set parent aria-label.
    addAriaLabel();

    // Remove the element from its current DOM position.
    element.detach();

    updatePosition();
    bindEvents();
    configureWatchers();

    function setDefaults() {
      scope.mdZIndex = scope.mdZIndex || TOOLTIP_DEFAULT_Z_INDEX;
      scope.mdDelay = scope.mdDelay || TOOLTIP_DEFAULT_SHOW_DELAY;
      if (!TOOLTIP_DIRECTIONS[scope.mdDirection]) {
        scope.mdDirection = TOOLTIP_DEFAULT_DIRECTION;
      }
    }

    function addAriaLabel(override) {
      if (override || !parent.attr('aria-label')) {
        // Only interpolate the text from the HTML element because otherwise the custom text
        // could be interpolated twice and cause XSS violations.
        var interpolatedText = override || $interpolate(element.text().trim())(scope.$parent);
        parent.attr('aria-label', interpolatedText);
      }
    }

    function updatePosition() {
      setDefaults();

      // If the panel has already been created, remove the current origin
      // class from the panel element.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.removeClass(origin);
      }

      // Set the panel element origin class based off of the current
      // mdDirection.
      origin = 'md-origin-' + scope.mdDirection;

      // Create the position of the panel based off of the mdDirection.
      position = TOOLTIP_DIRECTIONS[scope.mdDirection];

      // Using the newly created position object, use the MdPanel
      // panelPosition API to build the panel's position.
      panelPosition = $mdPanel.newPanelPosition()
          .relativeTo(parent)
          .addPanelPosition(position.x, position.y);

      // If the panel has already been created, add the new origin class to
      // the panel element and update it's position with the panelPosition.
      if (panelRef && panelRef.panelEl) {
        panelRef.panelEl.addClass(origin);
        panelRef.updatePosition(panelPosition);
      }
    }

    function bindEvents() {
      // Add a mutationObserver where there is support for it and the need
      // for it in the form of viable host(parent[0]).
      if (parent[0] && 'MutationObserver' in $window) {
        // Use a mutationObserver to tackle #2602.
        var attributeObserver = new MutationObserver(function(mutations) {
          if (isDisabledMutation(mutations)) {
            $mdUtil.nextTick(function() {
              setVisible(false);
            });
          }
        });

        attributeObserver.observe(parent[0], {
          attributes: true
        });
      }

      elementFocusedOnWindowBlur = false;

      $$mdTooltipRegistry.register('scroll', windowScrollEventHandler, true);
      $$mdTooltipRegistry.register('blur', windowBlurEventHandler);
      $$mdTooltipRegistry.register('resize', debouncedOnResize);

      scope.$on('$destroy', onDestroy);

      // To avoid 'synthetic clicks', we listen to mousedown instead of
      // 'click'.
      parent.on('mousedown', mousedownEventHandler);
      parent.on(ENTER_EVENTS, enterEventHandler);

      function isDisabledMutation(mutations) {
        mutations.some(function(mutation) {
          return mutation.attributeName === 'disabled' && parent[0].disabled;
        });
        return false;
      }

      function windowScrollEventHandler() {
        setVisible(false);
      }

      function windowBlurEventHandler() {
        elementFocusedOnWindowBlur = document.activeElement === parent[0];
      }

      function enterEventHandler($event) {
        // Prevent the tooltip from showing when the window is receiving
        // focus.
        if ($event.type === 'focus' && elementFocusedOnWindowBlur) {
          elementFocusedOnWindowBlur = false;
        } else if (!scope.mdVisible) {
          parent.on(LEAVE_EVENTS, leaveEventHandler);
          setVisible(true);

          // If the user is on a touch device, we should bind the tap away
          // after the 'touched' in order to prevent the tooltip being
          // removed immediately.
          if ($event.type === 'touchstart') {
            parent.one('touchend', function() {
              $mdUtil.nextTick(function() {
                $document.one('touchend', leaveEventHandler);
              }, false);
            });
          }
        }
      }

      function leaveEventHandler() {
        autohide = scope.hasOwnProperty('mdAutohide') ?
            scope.mdAutohide :
            attr.hasOwnProperty('mdAutohide');

        if (autohide || mouseActive ||
            $document[0].activeElement !== parent[0]) {
          // When a show timeout is currently in progress, then we have
          // to cancel it, otherwise the tooltip will remain showing
          // without focus or hover.
          if (showTimeout) {
            $timeout.cancel(showTimeout);
            setVisible.queued = false;
            showTimeout = null;
          }

          parent.off(LEAVE_EVENTS, leaveEventHandler);
          parent.triggerHandler('blur');
          setVisible(false);
        }
        mouseActive = false;
      }

      function mousedownEventHandler() {
        mouseActive = true;
      }

      function onDestroy() {
        $$mdTooltipRegistry.deregister('scroll', windowScrollEventHandler, true);
        $$mdTooltipRegistry.deregister('blur', windowBlurEventHandler);
        $$mdTooltipRegistry.deregister('resize', debouncedOnResize);

        parent
            .off(ENTER_EVENTS, enterEventHandler)
            .off(LEAVE_EVENTS, leaveEventHandler)
            .off('mousedown', mousedownEventHandler);

        // Trigger the handler in case any of the tooltips are
        // still visible.
        leaveEventHandler();
        attributeObserver && attributeObserver.disconnect();
      }
    }

    function configureWatchers() {
      if (element[0] && 'MutationObserver' in $window) {
        var attributeObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === 'md-visible' &&
                !scope.visibleWatcher ) {
              scope.visibleWatcher = scope.$watch('mdVisible',
                  onVisibleChanged);
            }
          });
        });

        attributeObserver.observe(element[0], {
          attributes: true
        });

        // Build watcher only if mdVisible is being used.
        if (attr.hasOwnProperty('mdVisible')) {
          scope.visibleWatcher = scope.$watch('mdVisible',
              onVisibleChanged);
        }
      } else {
        // MutationObserver not supported
        scope.visibleWatcher = scope.$watch('mdVisible', onVisibleChanged);
      }

      // Direction watcher
      scope.$watch('mdDirection', updatePosition);

      // Clean up if the element or parent was removed via jqLite's .remove.
      // A couple of notes:
      //   - In these cases the scope might not have been destroyed, which
      //     is why we destroy it manually. An example of this can be having
      //     `md-visible="false"` and adding tooltips while they're
      //     invisible. If `md-visible` becomes true, at some point, you'd
      //     usually get a lot of tooltips.
      //   - We use `.one`, not `.on`, because this only needs to fire once.
      //     If we were using `.on`, it would get thrown into an infinite
      //     loop.
      //   - This kicks off the scope's `$destroy` event which finishes the
      //     cleanup.
      element.one('$destroy', onElementDestroy);
      parent.one('$destroy', onElementDestroy);
      scope.$on('$destroy', function() {
        setVisible(false);
        panelRef && panelRef.destroy();
        attributeObserver && attributeObserver.disconnect();
        element.remove();
      });

      // Updates the aria-label when the element text changes. This watch
      // doesn't need to be set up if the element doesn't have any data
      // bindings.
      if (element.text().indexOf($interpolate.startSymbol()) > -1) {
        scope.$watch(function() {
          return element.text().trim();
        }, addAriaLabel);
      }

      function onElementDestroy() {
        scope.$destroy();
      }
    }

    function setVisible(value) {
      // Break if passed value is already in queue or there is no queue and
      // passed value is current in the controller.
      if (setVisible.queued && setVisible.value === !!value ||
          !setVisible.queued && scope.mdVisible === !!value) {
        return;
      }
      setVisible.value = !!value;

      if (!setVisible.queued) {
        if (value) {
          setVisible.queued = true;
          showTimeout = $timeout(function() {
            scope.mdVisible = setVisible.value;
            setVisible.queued = false;
            showTimeout = null;
            if (!scope.visibleWatcher) {
              onVisibleChanged(scope.mdVisible);
            }
          }, scope.mdDelay);
        } else {
          $mdUtil.nextTick(function() {
            scope.mdVisible = false;
            if (!scope.visibleWatcher) {
              onVisibleChanged(false);
            }
          });
        }
      }
    }

    function onVisibleChanged(isVisible) {
      isVisible ? showTooltip() : hideTooltip();
    }

    function showTooltip() {
      // Do not show the tooltip if the text is empty.
      if (!element[0].textContent.trim()) {
        throw new Error('Text for the tooltip has not been provided. ' +
            'Please include text within the mdTooltip element.');
      }

      if (!panelRef) {
        var id = 'tooltip-' + $mdUtil.nextUid();
        var attachTo = angular.element(document.body);
        var panelAnimation = $mdPanel.newPanelAnimation()
            .openFrom(parent)
            .closeTo(parent)
            .withAnimation({
              open: 'md-show',
              close: 'md-hide'
            });

        var panelConfig = {
          id: id,
          attachTo: attachTo,
          contentElement: element,
          propagateContainerEvents: true,
          panelClass: 'md-tooltip ' + origin,
          animation: panelAnimation,
          position: panelPosition,
          zIndex: scope.mdZIndex,
          focusOnOpen: false
        };

        panelRef = $mdPanel.create(panelConfig);
      }

      panelRef.open().then(function() {
        panelRef.panelEl.attr('role', 'tooltip');
      });
    }

    function hideTooltip() {
      panelRef && panelRef.close();
    }
  }

}


/**
 * Service that is used to reduce the amount of listeners that are being
 * registered on the `window` by the tooltip component. Works by collecting
 * the individual event handlers and dispatching them from a global handler.
 *
 * ngInject
 */
function MdTooltipRegistry() {
  var listeners = {};
  var ngWindow = angular.element(window);

  return {
    register: register,
    deregister: deregister
  };

  /**
   * Global event handler that dispatches the registered handlers in the
   * service.
   * @param {!Event} event Event object passed in by the browser
   */
  function globalEventHandler(event) {
    if (listeners[event.type]) {
      listeners[event.type].forEach(function(currentHandler) {
        currentHandler.call(this, event);
      }, this);
    }
  }

  /**
   * Registers a new handler with the service.
   * @param {string} type Type of event to be registered.
   * @param {!Function} handler Event handler.
   * @param {boolean} useCapture Whether to use event capturing.
   */
  function register(type, handler, useCapture) {
    var handlers = listeners[type] = listeners[type] || [];

    if (!handlers.length) {
      useCapture ? window.addEventListener(type, globalEventHandler, true) :
          ngWindow.on(type, globalEventHandler);
    }

    if (handlers.indexOf(handler) === -1) {
      handlers.push(handler);
    }
  }

  /**
   * Removes an event handler from the service.
   * @param {string} type Type of event handler.
   * @param {!Function} handler The event handler itself.
   * @param {boolean} useCapture Whether the event handler used event capturing.
   */
  function deregister(type, handler, useCapture) {
    var handlers = listeners[type];
    var index = handlers ? handlers.indexOf(handler) : -1;

    if (index > -1) {
      handlers.splice(index, 1);

      if (handlers.length === 0) {
        useCapture ? window.removeEventListener(type, globalEventHandler, true) :
            ngWindow.off(type, globalEventHandler);
      }
    }
  }
}

})(window, window.angular);
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 0.13.4 - 2015-10-17
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls",
  "ui.bootstrap.collapse",
  "ui.bootstrap.modal",
  "ui.bootstrap.dropdown",
  "ui.bootstrap.position",
  "ui.bootstrap.datepicker",
  "ui.bootstrap.dateparser",
  "ui.bootstrap.accordion",
  "ui.bootstrap.alert",
  "ui.bootstrap.bindHtml",
  "ui.bootstrap.carousel",
  "ui.bootstrap.pagination",
  "ui.bootstrap.tooltip",
  "ui.bootstrap.popover",
  "ui.bootstrap.typeahead",
  "ui.bootstrap.tabs"]);

angular.module("ui.bootstrap.tpls", ["template/modal/backdrop.html",
  "template/modal/window.html",
  "template/datepicker/datepicker.html",
  "template/datepicker/day.html",
  "template/datepicker/month.html",
  "template/datepicker/popup.html",
  "template/datepicker/year.html",
  "template/accordion/accordion-group.html",
  "template/accordion/accordion.html",
  "template/alert/alert.html",
  "template/carousel/carousel.html",
  "template/carousel/slide.html",
  "template/pagination/pager.html",
  "template/pagination/pagination.html",
  "template/typeahead/typeahead-match.html",
  "template/typeahead/typeahead-popup.html",
  "template/tabs/tab.html",
  "template/tabs/tabset.html",
  "template/tooltip/tooltip-html-popup.html",
  "template/tooltip/tooltip-html-unsafe-popup.html",
  "template/tooltip/tooltip-popup.html",
  "template/tooltip/tooltip-template-popup.html",
  "template/popover/popover-html.html",
  "template/popover/popover-template.html",
  "template/popover/popover.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('collapse', ['$animate', function($animate) {
    return {
      link: function(scope, element, attrs) {
        function expand() {
          element.removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false);

          $animate.addClass(element, 'in', {
            to: { height: element[0].scrollHeight + 'px' }
          }).then(expandDone);
        }

        function expandDone() {
          element.removeClass('collapsing');
          element.css({height: 'auto'});
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          element
            // IMPORTANT: The height must be set before adding "collapsing" class.
            // Otherwise, the browser attempts to animate from height 0 (in
            // collapsing class) to the given height here.
            .css({height: element[0].scrollHeight + 'px'})
            // initially all panel collapse have the collapse class, this removal
            // prevents the animation from jumping to collapsed state
            .removeClass('collapse')
            .addClass('collapsing')
            .attr('aria-expanded', false)
            .attr('aria-hidden', true);

          $animate.removeClass(element, 'in', {
            to: {height: '0'}
          }).then(collapseDone);
        }

        function collapseDone() {
          element.css({height: '0'}); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing');
          element.addClass('collapse');
        }

        scope.$watch(attrs.collapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.modal', [])

/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key == stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  })

/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('modalBackdrop', [
           '$animate', '$injector', '$modalStack',
  function($animate ,  $injector,   $modalStack) {
    var $animateCss = null;

    if ($injector.has('$animateCss')) {
      $animateCss = $injector.get('$animateCss');
    }

    return {
      restrict: 'EA',
      replace: true,
      templateUrl: 'template/modal/backdrop.html',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        if ($animateCss) {
          $animateCss(element, {
            addClass: attrs.modalInClass
          }).start();
        } else {
          $animate.addClass(element, attrs.modalInClass);
        }

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if ($animateCss) {
            $animateCss(element, {
              removeClass: attrs.modalInClass
            }).start().then(done);
          } else {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          }
        });
      }
    }
  }])

  .directive('modalWindow', [
           '$modalStack', '$q', '$animate', '$injector',
  function($modalStack ,  $q ,  $animate,   $injector) {
    var $animateCss = null;

    if ($injector.has('$animateCss')) {
      $animateCss = $injector.get('$animateCss');
    }

    return {
      restrict: 'EA',
      scope: {
        index: '@'
      },
      replace: true,
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && (evt.target === evt.currentTarget)) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is render.
        var modalRenderDeferObj = $q.defer();
        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
        attrs.$observe('modalRender', function(value) {
          if (value == 'true') {
            modalRenderDeferObj.resolve();
          }
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            if ($animateCss) {
              animationPromise = $animateCss(element, {
                addClass: attrs.modalInClass
              }).start();
            } else {
              animationPromise = $animate.addClass(element, attrs.modalInClass);
            }

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              if ($animateCss) {
                $animateCss(element, {
                  removeClass: attrs.modalInClass
                }).start().then(done);
              } else {
                $animate.removeClass(element, attrs.modalInClass).then(done);
              }
            });
          }


          $q.when(animationPromise).then(function() {
            var inputsWithAutofocus = element[0].querySelectorAll('[autofocus]');
            /**
             * Auto-focusing of a freshly-opened modal element causes any child elements
             * with the autofocus attribute to lose focus. This is an issue on touch
             * based devices which will show and then hide the onscreen keyboard.
             * Attempts to refocus the autofocus element via JavaScript will not reopen
             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
             * the modal element if the modal does not contain an autofocus element.
             */
            if (inputsWithAutofocus.length) {
              inputsWithAutofocus[0].focus();
            } else {
              element[0].focus();
            }
          });

          // Notify {@link $modalStack} that modal is rendered.
          var modal = $modalStack.getTop();
          if (modal) {
            $modalStack.modalRendered(modal.key);
          }
        });
      }
    };
  }])

  .directive('modalAnimationClass', [
    function () {
      return {
        compile: function(tElement, tAttrs) {
          if (tAttrs.modalAnimation) {
            tElement.addClass(tAttrs.modalAnimationClass);
          }
        }
      };
    }])

  .directive('modalTransclude', function() {
    return {
      link: function($scope, $element, $attrs, controller, $transclude) {
        $transclude($scope.$parent, function(clone) {
          $element.empty();
          $element.append(clone);
        });
      }
    };
  })

  .factory('$modalStack', [
             '$animate', '$timeout', '$document', '$compile', '$rootScope',
             '$q',
             '$injector',
             '$$multiMap',
             '$$stackedMap',
    function($animate ,  $timeout ,  $document ,  $compile ,  $rootScope ,
              $q,
              $injector,
              $$multiMap,
              $$stackedMap) {
      var $animateCss = null;

      if ($injector.has('$animateCss')) {
        $animateCss = $injector.get('$animateCss');
      }

      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };

      //Modal focus behavior
      var focusableElementList;
      var focusIndex = 0;
      var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' +
        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
        'iframe, object, embed, *[tabindex], *[contenteditable=true]';

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var body = $document.find('body').eq(0);
        var modalWindow = openedWindows.get(modalInstance).value;

        //clean up the stack
        openedWindows.remove(modalInstance);

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          body.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
        });
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else {
          body.focus();
        }
      }

      function checkRemoveBackdrop() {
          //remove backdrop if no longer needed
          if (backdropDomEl && backdropIndex() == -1) {
            var backdropScopeRef = backdropScope;
            removeAfterAnimate(backdropDomEl, backdropScope, function() {
              backdropScopeRef = null;
            });
            backdropDomEl = undefined;
            backdropScope = undefined;
          }
      }

      function removeAfterAnimate(domEl, scope, done) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          if ($animateCss) {
            $animateCss(domEl, {
              event: 'leave'
            }).start().then(function() {
              domEl.remove();
            });
          } else {
            $animate.leave(domEl);
          }
          scope.$destroy();
          if (done) {
            done();
          }
        }
      }

      $document.bind('keydown', function(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal && modal.value.keyboard) {
          switch (evt.which){
            case 27: {
              evt.preventDefault();
              $rootScope.$apply(function() {
                $modalStack.dismiss(modal.key, 'escape key press');
              });
              break;
            }
            case 9: {
              $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt)) {
                  focusChanged = $modalStack.focusLastFocusableElement();
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt)) {
                  focusChanged = $modalStack.focusFirstFocusableElement();
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }
              break;
            }
          }
        }
      });

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var body = $document.find('body').eq(0),
            currBackdropIndex = backdropIndex();

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.index = currBackdropIndex;
          var angularBackgroundDomEl = angular.element('<div modal-backdrop="modal-backdrop"></div>');
          angularBackgroundDomEl.attr('backdrop-class', modal.backdropClass);
          if (modal.animation) {
            angularBackgroundDomEl.attr('modal-animation', 'true');
          }
          backdropDomEl = $compile(angularBackgroundDomEl)(backdropScope);
          body.append(backdropDomEl);
        }

        var angularDomEl = angular.element('<div modal-window="modal-window"></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'size': modal.size,
          'index': openedWindows.length() - 1,
          'animate': 'animate'
        }).html(modal.content);
        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        var modalDomEl = $compile(angularDomEl)(modal.scope);
        openedWindows.top().value.modalDomEl = modalDomEl;
        openedWindows.top().value.modalOpener = modalOpener;
        body.append(modalDomEl);
        body.addClass(modalBodyClass);

        $modalStack.clearFocusListCache();
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
          return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function() {
        if (focusableElementList.length > 0) {
          focusableElementList[0].focus();
          return true;
        }
        return false;
      };
      $modalStack.focusLastFocusableElement = function() {
        if (focusableElementList.length > 0) {
          focusableElementList[focusableElementList.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) == focusableElementList[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt) {
        if (focusableElementList.length > 0) {
          return (evt.target || evt.srcElement) == focusableElementList[focusableElementList.length - 1];
        }
        return false;
      };

      $modalStack.clearFocusListCache = function() {
        focusableElementList = [];
        focusIndex = 0;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (focusableElementList === undefined || !focusableElementList.length0) {
          if (modalWindow) {
            var modalDomE1 = modalWindow.value.modalDomEl;
            if (modalDomE1 && modalDomE1.length) {
              focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
            }
          }
        }
      };

      return $modalStack;
    }])

  .provider('$modal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$injector', '$rootScope', '$q', '$templateRequest', '$controller', '$modalStack',
        function ($injector, $rootScope, $q, $templateRequest, $controller, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ? (options.templateUrl)() : options.templateUrl);
          }

          function getResolvePromises(resolves) {
            var promisesArr = [];
            angular.forEach(resolves, function(value) {
              if (angular.isFunction(value) || angular.isArray(value)) {
                promisesArr.push($q.when($injector.invoke(value)));
              } else if (angular.isString(value)) {
                promisesArr.push($q.when($injector.get(value)));
              } else {
                promisesArr.push($q.when(value));
              }
            });
            return promisesArr;
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function (modalOptions) {

            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions)].concat(getResolvePromises(modalOptions.resolve)));

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(function() { return templateAndResolvePromise; }, function() { return templateAndResolvePromise; })
              .then(function resolveSuccess(tplAndVars) {

                var modalScope = (modalOptions.scope || $rootScope).$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var ctrlInstance, ctrlLocals = {};
                var resolveIter = 1;

                //controllers
                if (modalOptions.controller) {
                  ctrlLocals.$scope = modalScope;
                  ctrlLocals.$modalInstance = modalInstance;
                  angular.forEach(modalOptions.resolve, function(value, key) {
                    ctrlLocals[key] = tplAndVars[resolveIter++];
                  });

                  ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
                  if (modalOptions.controllerAs) {
                    if (modalOptions.bindToController) {
                      angular.extend(ctrlInstance, modalScope);
                    }

                    modalScope[modalOptions.controllerAs] = ctrlInstance;
                  }
                }

                $modalStack.open(modalInstance, {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  content: tplAndVars[0],
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass
                });
                modalOpenedDeferred.resolve(true);

            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })
            .finally(function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

.constant('dropdownConfig', {
  openClass: 'open'
})

.service('dropdownService', ['$document', '$rootScope', function($document, $rootScope) {
  var openScope = null;

  this.open = function(dropdownScope) {
    if (!openScope) {
      $document.bind('click', closeDropdown);
      $document.bind('keydown', keybindFilter);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function(dropdownScope) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.unbind('click', closeDropdown);
      $document.unbind('keydown', keybindFilter);
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) { return; }

    if (evt && openScope.getAutoClose() === 'disabled')  { return ; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  var keybindFilter = function(evt) {
    if (evt.which === 27) {
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && /(38|40)/.test(evt.which) && openScope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('DropdownController', ['$scope', '$attrs', '$parse', 'dropdownConfig', 'dropdownService', '$animate', '$position', '$document', '$compile', '$templateRequest', function($scope, $attrs, $parse, dropdownConfig, dropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    appendToBody = false,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  this.init = function(element) {
    self.$element = element;

    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);

    if (appendToBody && self.dropdownMenu) {
      body.append(self.dropdownMenu);
      body.addClass('dropdown');
      element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function(open) {
    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return self.$element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      (angular.element(self.dropdownMenu).find('a')) :
      (angular.element(self.$element).find('ul').eq(0).find('a'));

    switch (keyCode) {
      case (40): {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = (self.selectedOption === elems.length -1 ?
            self.selectedOption :
            self.selectedOption + 1);
        }
        break;
      }
      case (38): {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    if (appendToBody && self.dropdownMenu) {
      var pos = $position.positionElements(self.$element, self.dropdownMenu, 'bottom-left', true);
      var css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      var rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        css.right = (window.innerWidth - (pos.left + self.$element.prop('offsetWidth'))) + 'px';
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendToBody ? body : self.$element;

    $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, openClass).then(function() {
      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
        toggleInvoker($scope, { open: !!isOpen });
      }
    });

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
          });
        });
      }

      scope.focusToggleElement();
      dropdownService.open(scope);
    } else {
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      dropdownService.close(scope);
      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });

  $scope.$on('$locationChangeSuccess', function() {
    if (scope.getAutoClose() !== 'disabled') {
      scope.isOpen = false;
    }
  });

  var offDestroy = $scope.$on('$destroy', function() {
    scope.$destroy();
  });
  scope.$on('$destroy', offDestroy);
}])

.directive('dropdown', function() {
  return {
    controller: 'DropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init( element );
      element.addClass('dropdown');
    }
  };
})

.directive('dropdownMenu', function() {
  return {
    restrict: 'AC',
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }
      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }
      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('keyboardNav', function() {
  return {
    restrict: 'A',
    require: '?^dropdown',
    link: function (scope, element, attrs, dropdownCtrl) {

      element.bind('keydown', function(e) {
        if ([38, 40].indexOf(e.which) !== -1) {
          e.preventDefault();
          e.stopPropagation();

          var elems = dropdownCtrl.dropdownMenu.find('a');

          switch (e.which) {
            case (40): { // Down
              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
                dropdownCtrl.selectedOption = 0;
              } else {
                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === elems.length -1 ?
                  dropdownCtrl.selectedOption : dropdownCtrl.selectedOption + 1;
              }
              break;
            }
            case (38): { // Up
              if (!angular.isNumber(dropdownCtrl.selectedOption)) {
                dropdownCtrl.selectedOption = elems.length - 1;
              } else {
                dropdownCtrl.selectedOption = dropdownCtrl.selectedOption === 0 ?
                  0 : dropdownCtrl.selectedOption - 1;
              }
              break;
            }
          }
          elems[dropdownCtrl.selectedOption].focus();
        }
      });
    }
  };
})

.directive('dropdownToggle', function() {
  return {
    require: '?^dropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function( isOpen ) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function($document, $window) {
    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function(element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function(element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function(element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function(hostEl, targetEl, positionStr, appendToBody) {
        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function() {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function() {
            return hostElPos.left;
          },
          right: function() {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function() {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function() {
            return hostElPos.top;
          },
          bottom: function() {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);

angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.position'])

.value('$datepickerSuppressError', false)

.constant('datepickerConfig', {
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  datepickerMode: 'day',
  minMode: 'day',
  maxMode: 'year',
  showWeeks: true,
  startingDay: 0,
  yearRange: 20,
  minDate: null,
  maxDate: null,
  shortcutPropagation: false
})

.controller('DatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$log', 'dateFilter', 'datepickerConfig', '$datepickerSuppressError', function($scope, $attrs, $parse, $interpolate, $log, dateFilter, datepickerConfig, $datepickerSuppressError) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl;

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  // Configuration attributes
  angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle',
                   'showWeeks', 'startingDay', 'yearRange', 'shortcutPropagation'], function(key, index) {
    self[key] = angular.isDefined($attrs[key]) ? (index < 6 ? $interpolate($attrs[key])($scope.$parent) : $scope.$parent.$eval($attrs[key])) : datepickerConfig[key];
  });

  // Watchable date attributes
  angular.forEach(['minDate', 'maxDate'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = value ? new Date(value) : null;
        self.refreshView();
      });
    } else {
      self[key] = datepickerConfig[key] ? new Date(datepickerConfig[key]) : null;
    }
  });

  angular.forEach(['minMode', 'maxMode'], function(key) {
    if ($attrs[key]) {
      $scope.$parent.$watch($parse($attrs[key]), function(value) {
        self[key] = angular.isDefined(value) ? value : $attrs[key];
        $scope[key] = self[key];
        if ((key == 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key])) || (key == 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key]))) {
          $scope.datepickerMode = self[key];
        }
      });
    } else {
      self[key] = datepickerConfig[key] || null;
      $scope[key] = self[key];
    }
  });

  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  if (angular.isDefined($attrs.initDate)) {
    this.activeDate = $scope.$parent.$eval($attrs.initDate) || new Date();
    $scope.$parent.$watch($attrs.initDate, function(initDate) {
      if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
        self.activeDate = initDate;
        self.refreshView();
      }
    });
  } else {
    this.activeDate = new Date();
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = date;
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      this._refreshView();

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      ngModelCtrl.$setValidity('dateDisabled', !date || (this.element && !this.isDisabled(date)));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    return {
      date: date,
      label: dateFilter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date)
    };
  };

  this.isDisabled = function(date) {
    return ((this.minDate && this.compare(date, this.minDate) < 0) || (this.maxDate && this.compare(date, this.maxDate) > 0) || ($attrs.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode})));
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  // Fix a hard-reprodusible bug with timezones
  // The bug depends on OS, browser, current timezone and current date
  // i.e.
  // var date = new Date(2014, 0, 1);
  // console.log(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours());
  // can result in "2013 11 31 23" because of the bug.
  this.fixTimeZone = function(date) {
    var hours = date.getHours();
    date.setHours(hours === 23 ? hours + 2 : 0);
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if (($scope.datepickerMode === self.maxMode && direction === 1) || ($scope.datepickerMode === self.minMode && direction === -1)) {
      return;
    }

    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
      focusElement();
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
      focusElement();
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
}])

.directive('datepicker', function() {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/datepicker.html';
    },
    scope: {
      datepickerMode: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['datepicker', '^ngModel'],
    controller: 'DatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('daypicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/day.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      scope.showWeeks = ctrl.showWeeks;

      ctrl.step = { months: 1 };
      ctrl.element = element;

      var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
      function getDaysInMonth(year, month) {
        return ((month === 1) && (year % 4 === 0) && ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
      }

      function getDates(startDate, n) {
        var dates = new Array(n), current = new Date(startDate), i = 0, date;
        while (i < n) {
          date = new Date(current);
          ctrl.fixTimeZone(date);
          dates[i++] = date;
          current.setDate(current.getDate() + 1);
        }
        return dates;
      }

      ctrl._refreshView = function() {
        var year = ctrl.activeDate.getFullYear(),
          month = ctrl.activeDate.getMonth(),
          firstDayOfMonth = new Date(year, month, 1),
          difference = ctrl.startingDay - firstDayOfMonth.getDay(),
          numDisplayedFromPreviousMonth = (difference > 0) ? 7 - difference : - difference,
          firstDate = new Date(firstDayOfMonth);

        if (numDisplayedFromPreviousMonth > 0) {
          firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
        }

        // 42 is the number of days on a six-month calendar
        var days = getDates(firstDate, 42);
        for (var i = 0; i < 42; i ++) {
          days[i] = angular.extend(ctrl.createDateObject(days[i], ctrl.formatDay), {
            secondary: days[i].getMonth() !== month,
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.labels = new Array(7);
        for (var j = 0; j < 7; j++) {
          scope.labels[j] = {
            abbr: dateFilter(days[j].date, ctrl.formatDayHeader),
            full: dateFilter(days[j].date, 'EEEE')
          };
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatDayTitle);
        scope.rows = ctrl.split(days, 7);

        if (scope.showWeeks) {
          scope.weekNumbers = [];
          var thursdayIndex = (4 + 7 - ctrl.startingDay) % 7,
              numWeeks = scope.rows.length;
          for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
            scope.weekNumbers.push(
              getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
          }
        }
      };

      ctrl.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      function getISO8601WeekNumber(date) {
        var checkDate = new Date(date);
        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
        var time = checkDate.getTime();
        checkDate.setMonth(0); // Compare with Jan 1
        checkDate.setDate(1);
        return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
      }

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getDate();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 7;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 7;
        } else if (key === 'pageup' || key === 'pagedown') {
          var month = ctrl.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setMonth(month, 1);
          date = Math.min(getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth()), date);
        } else if (key === 'home') {
          date = 1;
        } else if (key === 'end') {
          date = getDaysInMonth(ctrl.activeDate.getFullYear(), ctrl.activeDate.getMonth());
        }
        ctrl.activeDate.setDate(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('monthpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/month.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      ctrl.step = { years: 1 };
      ctrl.element = element;

      ctrl._refreshView = function() {
        var months = new Array(12),
            year = ctrl.activeDate.getFullYear(),
            date;

        for (var i = 0; i < 12; i++) {
          date = new Date(year, i, 1);
          ctrl.fixTimeZone(date);
          months[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatMonth), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = dateFilter(ctrl.activeDate, ctrl.formatMonthTitle);
        scope.rows = ctrl.split(months, 3);
      };

      ctrl.compare = function(date1, date2) {
        return new Date(date1.getFullYear(), date1.getMonth()) - new Date(date2.getFullYear(), date2.getMonth());
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getMonth();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 3;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 3;
        } else if (key === 'pageup' || key === 'pagedown') {
          var year = ctrl.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
          ctrl.activeDate.setFullYear(year);
        } else if (key === 'home') {
          date = 0;
        } else if (key === 'end') {
          date = 11;
        }
        ctrl.activeDate.setMonth(date);
      };

      ctrl.refreshView();
    }
  };
}])

.directive('yearpicker', ['dateFilter', function(dateFilter) {
  return {
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/datepicker/year.html',
    require: '^datepicker',
    link: function(scope, element, attrs, ctrl) {
      var range = ctrl.yearRange;

      ctrl.step = { years: range };
      ctrl.element = element;

      function getStartingYear( year ) {
        return parseInt((year - 1) / range, 10) * range + 1;
      }

      ctrl._refreshView = function() {
        var years = new Array(range), date;

        for (var i = 0, start = getStartingYear(ctrl.activeDate.getFullYear()); i < range; i++) {
          date = new Date(start + i, 0, 1);
          ctrl.fixTimeZone(date);
          years[i] = angular.extend(ctrl.createDateObject(date, ctrl.formatYear), {
            uid: scope.uniqueId + '-' + i
          });
        }

        scope.title = [years[0].label, years[range - 1].label].join(' - ');
        scope.rows = ctrl.split(years, 5);
      };

      ctrl.compare = function(date1, date2) {
        return date1.getFullYear() - date2.getFullYear();
      };

      ctrl.handleKeyDown = function(key, evt) {
        var date = ctrl.activeDate.getFullYear();

        if (key === 'left') {
          date = date - 1;   // up
        } else if (key === 'up') {
          date = date - 5;   // down
        } else if (key === 'right') {
          date = date + 1;   // down
        } else if (key === 'down') {
          date = date + 5;
        } else if (key === 'pageup' || key === 'pagedown') {
          date += (key === 'pageup' ? - 1 : 1) * ctrl.step.years;
        } else if (key === 'home') {
          date = getStartingYear(ctrl.activeDate.getFullYear());
        } else if (key === 'end') {
          date = getStartingYear(ctrl.activeDate.getFullYear()) + range - 1;
        }
        ctrl.activeDate.setFullYear(date);
      };

      ctrl.refreshView();
    }
  };
}])

.constant('datepickerPopupConfig', {
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'template/datepicker/popup.html',
  datepickerTemplateUrl: 'template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  currentText: 'Today',
  clearText: 'Clear',
  closeText: 'Done',
  closeOnDateSelection: true,
  appendToBody: false,
  showButtonBar: true,
  onOpenFocus: true
})

.directive('datepickerPopup', ['$compile', '$parse', '$document', '$rootScope', '$position', 'dateFilter', 'dateParser', 'datepickerPopupConfig', '$timeout',
function($compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout) {
  return {
    restrict: 'EA',
    require: 'ngModel',
    scope: {
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function(scope, element, attrs, ngModel) {
      var dateFormat,
          closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection,
          appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody,
          onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus,
          datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl,
          datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl,
          cache = {};

      scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;

      scope.getText = function(key) {
        return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
      };

      scope.isDisabled = function(date) {
        if (date === 'today') {
          date = new Date();
        }

        return ((scope.watchData.minDate && scope.compare(date, cache.minDate) < 0) ||
          (scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0));
      };

      scope.compare = function(date1, date2) {
        return (new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate()));
      };

      var isHtml5DateInput = false;
      if (datepickerPopupConfig.html5Types[attrs.type]) {
        dateFormat = datepickerPopupConfig.html5Types[attrs.type];
        isHtml5DateInput = true;
      } else {
        dateFormat = attrs.datepickerPopup || datepickerPopupConfig.datepickerPopup;
        attrs.$observe('datepickerPopup', function(value, oldValue) {
            var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
            // Invalidate the $modelValue to ensure that formatters re-run
            // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
            if (newDateFormat !== dateFormat) {
              dateFormat = newDateFormat;
              ngModel.$modelValue = null;

              if (!dateFormat) {
                throw new Error('datepickerPopup must have a date format specified.');
              }
            }
        });
      }

      if (!dateFormat) {
        throw new Error('datepickerPopup must have a date format specified.');
      }

      if (isHtml5DateInput && attrs.datepickerPopup) {
        throw new Error('HTML5 date input types do not support custom formats.');
      }

      // popup element used to display calendar
      var popupEl = angular.element('<div datepicker-popup-wrap><div datepicker></div></div>');
      popupEl.attr({
        'ng-model': 'date',
        'ng-change': 'dateSelection(date)',
        'template-url': datepickerPopupTemplateUrl
      });

      function cameltoDash(string) {
        return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
      }

      // datepicker element
      var datepickerEl = angular.element(popupEl.children()[0]);
      datepickerEl.attr('template-url', datepickerTemplateUrl);

      if (isHtml5DateInput) {
        if (attrs.type === 'month') {
          datepickerEl.attr('datepicker-mode', '"month"');
          datepickerEl.attr('min-mode', 'month');
        }
      }

      if (attrs.datepickerOptions) {
        var options = scope.$parent.$eval(attrs.datepickerOptions);
        if (options && options.initDate) {
          scope.initDate = options.initDate;
          datepickerEl.attr('init-date', 'initDate');
          delete options.initDate;
        }
        angular.forEach(options, function(value, option) {
          datepickerEl.attr( cameltoDash(option), value );
        });
      }

      scope.watchData = {};
      angular.forEach(['minMode', 'maxMode', 'minDate', 'maxDate', 'datepickerMode', 'initDate', 'shortcutPropagation'], function(key) {
        if (attrs[key]) {
          var getAttribute = $parse(attrs[key]);
          scope.$parent.$watch(getAttribute, function(value) {
            scope.watchData[key] = value;
            if (key === 'minDate' || key === 'maxDate') {
              cache[key] = new Date(value);
            }
          });
          datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

          // Propagate changes from datepicker to outside
          if (key === 'datepickerMode') {
            var setAttribute = getAttribute.assign;
            scope.$watch('watchData.' + key, function(value, oldvalue) {
              if (angular.isFunction(setAttribute) && value !== oldvalue) {
                setAttribute(scope.$parent, value);
              }
            });
          }
        }
      });
      if (attrs.dateDisabled) {
        datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
      }

      if (attrs.showWeeks) {
        datepickerEl.attr('show-weeks', attrs.showWeeks);
      }

      if (attrs.customClass) {
        datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
      }

      function parseDate(viewValue) {
        if (angular.isNumber(viewValue)) {
          // presumably timestamp to date object
          viewValue = new Date(viewValue);
        }

        if (!viewValue) {
          return null;
        } else if (angular.isDate(viewValue) && !isNaN(viewValue)) {
          return viewValue;
        } else if (angular.isString(viewValue)) {
          var date = dateParser.parse(viewValue, dateFormat, scope.date);
          if (isNaN(date)) {
            return undefined;
          } else {
            return date;
          }
        } else {
          return undefined;
        }
      }

      function validator(modelValue, viewValue) {
        var value = modelValue || viewValue;

        if (!attrs.ngRequired && !value) {
          return true;
        }

        if (angular.isNumber(value)) {
          value = new Date(value);
        }
        if (!value) {
          return true;
        } else if (angular.isDate(value) && !isNaN(value)) {
          return true;
        } else if (angular.isString(value)) {
          var date = dateParser.parse(value, dateFormat);
          return !isNaN(date);
        } else {
          return false;
        }
      }

      if (!isHtml5DateInput) {
        // Internal API to maintain the correct ng-invalid-[key] class
        ngModel.$$parserName = 'date';
        ngModel.$validators.date = validator;
        ngModel.$parsers.unshift(parseDate);
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return ngModel.$isEmpty(value) ? value : dateFilter(value, dateFormat);
        });
      } else {
        ngModel.$formatters.push(function(value) {
          scope.date = value;
          return value;
        });
      }

      // Inner change
      scope.dateSelection = function(dt) {
        if (angular.isDefined(dt)) {
          scope.date = dt;
        }
        var date = scope.date ? dateFilter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
        element.val(date);
        ngModel.$setViewValue(date);

        if (closeOnDateSelection) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      // Detect changes in the view from the text box
      ngModel.$viewChangeListeners.push(function() {
        scope.date = dateParser.parse(ngModel.$viewValue, dateFormat, scope.date);
      });

      var documentClickBind = function(event) {
        if (scope.isOpen && !(element[0].contains(event.target) || popupEl[0].contains(event.target))) {
          scope.$apply(function() {
            scope.isOpen = false;
          });
        }
      };

      var inputKeydownBind = function(evt) {
        if (evt.which === 27 && scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = false;
          });
          element[0].focus();
        } else if (evt.which === 40 && !scope.isOpen) {
          evt.preventDefault();
          evt.stopPropagation();
          scope.$apply(function() {
            scope.isOpen = true;
          });
        }
      };
      element.bind('keydown', inputKeydownBind);

      scope.keydown = function(evt) {
        if (evt.which === 27) {
          scope.isOpen = false;
          element[0].focus();
        }
      };

      scope.$watch('isOpen', function(value) {
        if (value) {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top = scope.position.top + element.prop('offsetHeight');

          $timeout(function() {
            if (onOpenFocus) {
              scope.$broadcast('datepicker.focus');
            }
            $document.bind('click', documentClickBind);
          }, 0, false);
        } else {
          $document.unbind('click', documentClickBind);
        }
      });

      scope.select = function(date) {
        if (date === 'today') {
          var today = new Date();
          if (angular.isDate(scope.date)) {
            date = new Date(scope.date);
            date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
          } else {
            date = new Date(today.setHours(0, 0, 0, 0));
          }
        }
        scope.dateSelection(date);
      };

      scope.close = function() {
        scope.isOpen = false;
        element[0].focus();
      };

      var $popup = $compile(popupEl)(scope);
      // Prevent jQuery cache memory leak (template is now redundant after linking)
      popupEl.remove();

      if (appendToBody) {
        $document.find('body').append($popup);
      } else {
        element.after($popup);
      }

      scope.$on('$destroy', function() {
        if (scope.isOpen === true) {
          if (!$rootScope.$$phase) {
            scope.$apply(function() {
              scope.isOpen = false;
            });
          }
        }

        $popup.remove();
        element.unbind('keydown', inputKeydownBind);
        $document.unbind('click', documentClickBind);
      });
    }
  };
}])

.directive('datepickerPopupWrap', function() {
  return {
    restrict:'EA',
    replace: true,
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/datepicker/popup.html';
    }
  };
});

angular.module('ui.bootstrap.dateparser', [])

.service('dateParser', ['$log', '$locale', 'orderByFilter', function($log, $locale, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  this.parsers = {};

  var formatCodeToRegex = {
    'yyyy': {
      regex: '\\d{4}',
      apply: function(value) { this.year = +value; }
    },
    'yy': {
      regex: '\\d{2}',
      apply: function(value) { this.year = +value + 2000; }
    },
    'y': {
      regex: '\\d{1,4}',
      apply: function(value) { this.year = +value; }
    },
    'MMMM': {
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); }
    },
    'MMM': {
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); }
    },
    'MM': {
      regex: '0[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'M': {
      regex: '[1-9]|1[0-2]',
      apply: function(value) { this.month = value - 1; }
    },
    'dd': {
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'd': {
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function(value) { this.date = +value; }
    },
    'EEEE': {
      regex: $locale.DATETIME_FORMATS.DAY.join('|')
    },
    'EEE': {
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|')
    },
    'HH': {
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'hh': {
      regex: '0[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'H': {
      regex: '1?[0-9]|2[0-3]',
      apply: function(value) { this.hours = +value; }
    },
    'h': {
      regex: '[0-9]|1[0-2]',
      apply: function(value) { this.hours = +value; }
    },
    'mm': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'm': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.minutes = +value; }
    },
    'sss': {
      regex: '[0-9][0-9][0-9]',
      apply: function(value) { this.milliseconds = +value; }
    },
    'ss': {
      regex: '[0-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    's': {
      regex: '[0-9]|[1-5][0-9]',
      apply: function(value) { this.seconds = +value; }
    },
    'a': {
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }

        if (value === 'PM') {
          this.hours += 12;
        }
      }
    }
  };

  function createParser(format) {
    var map = [], regex = format.split('');

    angular.forEach(formatCodeToRegex, function(data, code) {
      var index = format.indexOf(code);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + code.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({ index: index, apply: data.apply });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format);
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex);

    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i-1];
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      if (isValid(fields.year, fields.month, fields.date)) {
        dt = new Date(fields.year, fields.month, fields.date,
          fields.hours, fields.minutes, fields.seconds,
          fields.milliseconds || 0);
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }
}]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

.constant('accordionConfig', {
  closeOthers: true
})

.controller('AccordionController', ['$scope', '$attrs', 'accordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };

}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('accordion', function() {
  return {
    restrict: 'EA',
    controller: 'AccordionController',
    controllerAs: 'accordion',
    transclude: true,
    replace: false,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('accordionGroup', function() {
  return {
    require: '^accordion',         // We need this directive to be inside an accordion
    restrict: 'EA',
    transclude: true,              // It transcludes the contents of the directive into the template
    replace: true,                // The element containing the directive will be replaced with the template
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass;
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
// <accordion-group>
//   <accordion-heading>Heading containing HTML - <img src="..."></accordion-heading>
// </accordion-group>
.directive('accordionHeading', function() {
  return {
    restrict: 'EA',
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^accordionGroup',
    link: function(scope, element, attr, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
// <div class="accordion-group">
//   <div class="accordion-heading" ><a ... accordion-transclude="heading">...</a></div>
//   ...
// </div>
.directive('accordionTransclude', function() {
  return {
    require: '^accordionGroup',
    link: function(scope, element, attr, controller) {
      scope.$watch(function() { return controller[attr.accordionTransclude]; }, function(heading) {
        if (heading) {
          element.find('span').html('');
          element.find('span').append(heading);
        }
      });
    }
  };
})

;

angular.module('ui.bootstrap.alert', [])

.controller('AlertController', ['$scope', '$attrs', function($scope, $attrs) {
  $scope.closeable = !!$attrs.close;
  this.close = $scope.close;
}])

.directive('alert', function() {
  return {
    controller: 'AlertController',
    controllerAs: 'alert',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/alert/alert.html';
    },
    transclude: true,
    replace: true,
    scope: {
      type: '@',
      close: '&'
    }
  };
})

.directive('dismissOnTimeout', ['$timeout', function($timeout) {
  return {
    require: 'alert',
    link: function(scope, element, attrs, alertCtrl) {
      $timeout(function() {
        alertCtrl.close();
      }, parseInt(attrs.dismissOnTimeout, 10));
    }
  };
}]);

/**
* @ngdoc overview
* @name ui.bootstrap.carousel
*
* @description
* AngularJS version of an image carousel.
*
*/
angular.module('ui.bootstrap.carousel', [])
.controller('CarouselController', ['$scope', '$element', '$interval', '$animate', function ($scope, $element, $interval, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    NEW_ANIMATE = angular.version.minor >= 4,
    NO_TRANSITION = 'uib-noTransition',
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = -1,
    currentInterval, isPlaying;
  self.currentSlide = null;

  var destroyed = false;
  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = $scope.indexOfSlide(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
      goNext(nextSlide, nextIndex, direction);
    }
  };

  function goNext(slide, index, direction) {
    // Scope has been destroyed, stop here.
    if (destroyed) { return; }

    angular.extend(slide, {direction: direction, active: true});
    angular.extend(self.currentSlide || {}, {direction: direction, active: false});
    if ($animate.enabled() && !$scope.noTransition && !$scope.$currentTransition &&
      slide.$element && self.slides.length > 1) {
      slide.$element.data(SLIDE_DIRECTION, slide.direction);
      if (self.currentSlide && self.currentSlide.$element) {
        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      if (NEW_ANIMATE) {
        $animate.on('addClass', slide.$element, function (element, phase) {
          if (phase === 'close') {
            $scope.$currentTransition = null;
            $animate.off('addClass', element);
          }
        });
      } else {
        slide.$element.one('$animate:close', function closeFn() {
          $scope.$currentTransition = null;
        });
      }
    }

    self.currentSlide = slide;
    currentIndex = index;

    //every time you change slides, reset the timer
    restartTimer();
  }

  $scope.$on('$destroy', function () {
    destroyed = true;
  });

  function getSlideByIndex(index) {
    if (angular.isUndefined(slides[index].index)) {
      return slides[index];
    }
    var i, len = slides.length;
    for (i = 0; i < slides.length; ++i) {
      if (slides[i].index == index) {
        return slides[i];
      }
    }
  }

  self.getCurrentIndex = function() {
    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
      return +self.currentSlide.index;
    }
    return currentIndex;
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
  };

  $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'next');
  };

  $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1){
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'prev');
  };

  $scope.isActive = function(slide) {
     return self.currentSlide === slide;
  };

  $scope.$watch('interval', restartTimer);
  $scope.$on('$destroy', resetTimer);

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  self.addSlide = function(slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if(slides.length === 1 || slide.active) {
      self.select(slides[slides.length-1]);
      if (slides.length == 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };

  self.removeSlide = function(slide) {
    if (angular.isDefined(slide.index)) {
      slides.sort(function(a, b) {
        return +a.index > +b.index;
      });
    }
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    if (slides.length > 0 && slide.active) {
      if (index >= slides.length) {
        self.select(slides[index-1]);
      } else {
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
    }

    //clean the currentSlide when no more slide
    if (slides.length === 0) {
      self.currentSlide = null;
    }
  };

  $scope.$watch('noTransition', function(noTransition) {
    $element.data(NO_TRANSITION, noTransition);
  });

}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:carousel
 * @restrict EA
 *
 * @description
 * Carousel is the outer container for a set of image 'slides' to showcase.
 *
 * @param {number=} interval The time, in milliseconds, that it will take the carousel to go to the next slide.
 * @param {boolean=} noTransition Whether to disable transitions on the carousel.
 * @param {boolean=} noPause Whether to disable pausing on the carousel (by default, the carousel interval pauses on hover).
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <carousel>
      <slide>
        <img src="http://placekitten.com/150/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>Beautiful!</p>
        </div>
      </slide>
      <slide>
        <img src="http://placekitten.com/100/150" style="margin:auto;">
        <div class="carousel-caption">
          <p>D'aww!</p>
        </div>
      </slide>
    </carousel>
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
 */
.directive('carousel', [function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    controller: 'CarouselController',
    controllerAs: 'carousel',
    require: 'carousel',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/carousel/carousel.html';
    },
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.carousel.directive:slide
 * @restrict EA
 *
 * @description
 * Creates a slide inside a {@link ui.bootstrap.carousel.directive:carousel carousel}.  Must be placed as a child of a carousel element.
 *
 * @param {boolean=} active Model binding, whether or not this slide is currently active.
 * @param {number=} index The index of the slide. The slides will be sorted by this parameter.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
<div ng-controller="CarouselDemoCtrl">
  <carousel>
    <slide ng-repeat="slide in slides" active="slide.active" index="$index">
      <img ng-src="{{slide.image}}" style="margin:auto;">
      <div class="carousel-caption">
        <h4>Slide {{$index}}</h4>
        <p>{{slide.text}}</p>
      </div>
    </slide>
  </carousel>
  Interval, in milliseconds: <input type="number" ng-model="myInterval">
  <br />Enter a negative number to stop the interval.
</div>
  </file>
  <file name="script.js">
function CarouselDemoCtrl($scope) {
  $scope.myInterval = 5000;
}
  </file>
  <file name="demo.css">
    .carousel-indicators {
      top: auto;
      bottom: 15px;
    }
  </file>
</example>
*/

.directive('slide', function() {
  return {
    require: '^carousel',
    restrict: 'EA',
    transclude: true,
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/carousel/slide.html';
    },
    scope: {
      active: '=?',
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function(active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
})

.animation('.item', [
         '$injector', '$animate',
function ($injector, $animate) {
  var NO_TRANSITION = 'uib-noTransition',
    SLIDE_DIRECTION = 'uib-slideDirection',
    $animateCss = null;

  if ($injector.has('$animateCss')) {
    $animateCss = $injector.get('$animateCss');
  }

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function (element, className, done) {
      // Due to transclusion, noTransition property is on parent's scope
      if (className == 'active' && element.parent() &&
          !element.parent().data(NO_TRANSITION)) {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction == 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        if ($animateCss) {
          $animateCss(element, {addClass: directionClass})
            .start()
            .done(removeClassFn);
        } else {
          $animate.addClass(element, directionClass).then(function () {
            if (!stopped) {
              removeClassFn();
            }
            done();
          });
        }

        return function () {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      // Due to transclusion, noTransition property is on parent's scope
      if (className === 'active' && element.parent() &&
          !element.parent().data(NO_TRANSITION)) {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction == 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        if ($animateCss) {
          $animateCss(element, {addClass: directionClass})
            .start()
            .done(removeClassFn);
        } else {
          $animate.addClass(element, directionClass).then(function () {
            if (!stopped) {
              removeClassFn();
            }
            done();
          });
        }
        return function () {
          stopped = true;
        };
      }
      done();
    }
  };

}])


;

angular.module('ui.bootstrap.pagination', [])
.controller('PaginationController', ['$scope', '$attrs', '$parse', function($scope, $attrs, $parse) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
      setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;

  this.init = function(ngModelCtrl_, config) {
    ngModelCtrl = ngModelCtrl_;
    this.config = config;

    ngModelCtrl.$render = function() {
      self.render();
    };

    if ($attrs.itemsPerPage) {
      $scope.$parent.$watch($parse($attrs.itemsPerPage), function(value) {
        self.itemsPerPage = parseInt(value, 10);
        $scope.totalPages = self.calculateTotalPages();
      });
    } else {
      this.itemsPerPage = config.itemsPerPage;
    }

    $scope.$watch('totalItems', function() {
      $scope.totalPages = self.calculateTotalPages();
    });

    $scope.$watch('totalPages', function(value) {
      setNumPages($scope.$parent, value); // Readonly variable

      if ( $scope.page > value ) {
        $scope.selectPage(value);
      } else {
        ngModelCtrl.$render();
      }
    });
  };

  this.calculateTotalPages = function() {
    var totalPages = this.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / this.itemsPerPage);
    return Math.max(totalPages || 0, 1);
  };

  this.render = function() {
    $scope.page = parseInt(ngModelCtrl.$viewValue, 10) || 1;
  };

  $scope.selectPage = function(page, evt) {
    if (evt) {
      evt.preventDefault();
    }

    var clickAllowed = !$scope.ngDisabled || !evt;
    if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
      if (evt && evt.target) {
        evt.target.blur();
      }
      ngModelCtrl.$setViewValue(page);
      ngModelCtrl.$render();
    }
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || self.config[key + 'Text'];
  };

  $scope.noPrevious = function() {
    return $scope.page === 1;
  };

  $scope.noNext = function() {
    return $scope.page === $scope.totalPages;
  };
}])

.constant('paginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true
})

.directive('pagination', ['$parse', 'paginationConfig', function($parse, paginationConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['pagination', '?ngModel'],
    controller: 'PaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/pagination/pagination.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      // Setup configuration parameters
      var maxSize = angular.isDefined(attrs.maxSize) ? scope.$parent.$eval(attrs.maxSize) : paginationConfig.maxSize,
          rotate = angular.isDefined(attrs.rotate) ? scope.$parent.$eval(attrs.rotate) : paginationConfig.rotate;
      scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : paginationConfig.boundaryLinks;
      scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : paginationConfig.directionLinks;

      paginationCtrl.init(ngModelCtrl, paginationConfig);

      if (attrs.maxSize) {
        scope.$parent.$watch($parse(attrs.maxSize), function(value) {
          maxSize = parseInt(value, 10);
          paginationCtrl.render();
        });
      }

      // Create page object used in template
      function makePage(number, text, isActive) {
        return {
          number: number,
          text: text,
          active: isActive
        };
      }

      function getPages(currentPage, totalPages) {
        var pages = [];

        // Default page limits
        var startPage = 1, endPage = totalPages;
        var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

        // recompute if maxSize
        if (isMaxSized) {
          if (rotate) {
            // Current page is displayed in the middle of the visible ones
            startPage = Math.max(currentPage - Math.floor(maxSize/2), 1);
            endPage   = startPage + maxSize - 1;

            // Adjust if limit is exceeded
            if (endPage > totalPages) {
              endPage   = totalPages;
              startPage = endPage - maxSize + 1;
            }
          } else {
            // Visible pages are paginated with maxSize
            startPage = ((Math.ceil(currentPage / maxSize) - 1) * maxSize) + 1;

            // Adjust last page if limit is exceeded
            endPage = Math.min(startPage + maxSize - 1, totalPages);
          }
        }

        // Add page number links
        for (var number = startPage; number <= endPage; number++) {
          var page = makePage(number, number, number === currentPage);
          pages.push(page);
        }

        // Add links to move between page sets
        if (isMaxSized && ! rotate) {
          if (startPage > 1) {
            var previousPageSet = makePage(startPage - 1, '...', false);
            pages.unshift(previousPageSet);
          }

          if (endPage < totalPages) {
            var nextPageSet = makePage(endPage + 1, '...', false);
            pages.push(nextPageSet);
          }
        }

        return pages;
      }

      var originalRender = paginationCtrl.render;
      paginationCtrl.render = function() {
        originalRender();
        if (scope.page > 0 && scope.page <= scope.totalPages) {
          scope.pages = getPages(scope.page, scope.totalPages);
        }
      };
    }
  };
}])

.constant('pagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('pager', ['pagerConfig', function(pagerConfig) {
  return {
    restrict: 'EA',
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['pager', '?ngModel'],
    controller: 'PaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'template/pagination/pager.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      scope.align = angular.isDefined(attrs.align) ? scope.$parent.$eval(attrs.align) : pagerConfig.align;
      paginationCtrl.init(ngModelCtrl, pagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('typeaheadParser', ['$parse', function($parse) {

  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;

  return {
    parse: function(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error(
          'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
            ' but got "' + input + '".');
      }

      return {
        itemName:match[3],
        source:$parse(match[4]),
        viewMapper:$parse(match[2] || match[1]),
        modelMapper:$parse(match[1])
      };
    }
  };
}])

  .directive('typeahead', ['$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$position', 'typeaheadParser',
    function($compile, $parse, $q, $timeout, $document, $window, $rootScope, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;

    return {
      require: ['ngModel', '^?ngModelOptions'],
      link: function(originalScope, element, attrs, ctrls) {
        var modelCtrl = ctrls[0];
        var ngModelOptions = ctrls[1];
        //SUPPORTED ATTRIBUTES (OPTIONS)

        //minimal no of characters that needs to be entered before typeahead kicks-in
        var minLength = originalScope.$eval(attrs.typeaheadMinLength);
        if (!minLength && minLength !== 0) {
          minLength = 1;
        }

        //minimal wait time after last character typed before typeahead kicks-in
        var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

        //should it restrict model values to the ones selected from the popup only?
        var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;

        //binding to a variable that indicates if matches are being retrieved asynchronously
        var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

        //a callback executed when a match is selected
        var onSelectCallback = $parse(attrs.typeaheadOnSelect);

        //should it select highlighted popup value when losing focus?
        var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

        //binding to a variable that indicates if there were no results after the query is completed
        var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

        var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

        var appendToBody =  attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

        var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

        //If input matches an item of the list exactly, select it automatically
        var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

        //INTERNAL VARIABLES

        //model setter executed upon match selection
        var parsedModel = $parse(attrs.ngModel);
        var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
        var $setModelValue = function(scope, newValue) {
          if (angular.isFunction(parsedModel(originalScope)) &&
            ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
            return invokeModelSetter(scope, {$$$p: newValue});
          } else {
            return parsedModel.assign(scope, newValue);
          }
        };

        //expressions used by typeahead
        var parserResult = typeaheadParser.parse(attrs.typeahead);

        var hasFocus;

        //Used to avoid bug in iOS webview where iOS keyboard does not fire
        //mousedown & mouseup events
        //Issue #3699
        var selected;

        //create a child scope for the typeahead directive so we are not polluting original scope
        //with typeahead-specific data (matches, query etc.)
        var scope = originalScope.$new();
        var offDestroy = originalScope.$on('$destroy', function() {
			    scope.$destroy();
        });
        scope.$on('$destroy', offDestroy);

        // WAI-ARIA
        var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
        element.attr({
          'aria-autocomplete': 'list',
          'aria-expanded': false,
          'aria-owns': popupId
        });

        //pop-up element used to display matches
        var popUpEl = angular.element('<div typeahead-popup></div>');
        popUpEl.attr({
          id: popupId,
          matches: 'matches',
          active: 'activeIdx',
          select: 'select(activeIdx)',
          'move-in-progress': 'moveInProgress',
          query: 'query',
          position: 'position'
        });
        //custom item template
        if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
          popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
        }

        if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
          popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
        }

        var resetMatches = function() {
          scope.matches = [];
          scope.activeIdx = -1;
          element.attr('aria-expanded', false);
        };

        var getMatchId = function(index) {
          return popupId + '-option-' + index;
        };

        // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
        // This attribute is added or removed automatically when the `activeIdx` changes.
        scope.$watch('activeIdx', function(index) {
          if (index < 0) {
            element.removeAttr('aria-activedescendant');
          } else {
            element.attr('aria-activedescendant', getMatchId(index));
          }
        });

        var inputIsExactMatch = function(inputValue, index) {
          if (scope.matches.length > index && inputValue) {
            return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
          }

          return false;
        };

        var getMatchesAsync = function(inputValue) {
          var locals = {$viewValue: inputValue};
          isLoadingSetter(originalScope, true);
          isNoResultsSetter(originalScope, false);
          $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
            //it might happen that several async queries were in progress if a user were typing fast
            //but we are interested only in responses that correspond to the current view value
            var onCurrentRequest = (inputValue === modelCtrl.$viewValue);
            if (onCurrentRequest && hasFocus) {
              if (matches && matches.length > 0) {

                scope.activeIdx = focusFirst ? 0 : -1;
                isNoResultsSetter(originalScope, false);
                scope.matches.length = 0;

                //transform labels
                for (var i = 0; i < matches.length; i++) {
                  locals[parserResult.itemName] = matches[i];
                  scope.matches.push({
                    id: getMatchId(i),
                    label: parserResult.viewMapper(scope, locals),
                    model: matches[i]
                  });
                }

                scope.query = inputValue;
                //position pop-up with matches - we need to re-calculate its position each time we are opening a window
                //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
                //due to other elements being rendered
                recalculatePosition();

                element.attr('aria-expanded', true);

                //Select the single remaining option if user input matches
                if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
                  scope.select(0);
                }
              } else {
                resetMatches();
                isNoResultsSetter(originalScope, true);
              }
            }
            if (onCurrentRequest) {
              isLoadingSetter(originalScope, false);
            }
          }, function() {
            resetMatches();
            isLoadingSetter(originalScope, false);
            isNoResultsSetter(originalScope, true);
          });
        };

        // bind events only if appendToBody params exist - performance feature
        if (appendToBody) {
          angular.element($window).bind('resize', fireRecalculating);
          $document.find('body').bind('scroll', fireRecalculating);
        }

        // Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutEventPromise;

        // Default progress type
        scope.moveInProgress = false;

        function fireRecalculating() {
          if (!scope.moveInProgress) {
            scope.moveInProgress = true;
            scope.$digest();
          }

          // Cancel previous timeout
          if (timeoutEventPromise) {
            $timeout.cancel(timeoutEventPromise);
          }

          // Debounced executing recalculate after events fired
          timeoutEventPromise = $timeout(function() {
            // if popup is visible
            if (scope.matches.length) {
              recalculatePosition();
            }

            scope.moveInProgress = false;
            scope.$digest();
          }, eventDebounceTime);
        }

        // recalculate actual position and set new values to scope
        // after digest loop is popup in right position
        function recalculatePosition() {
          scope.position = appendToBody ? $position.offset(element) : $position.position(element);
          scope.position.top += element.prop('offsetHeight');
        }

        resetMatches();

        //we need to propagate user's query so we can higlight matches
        scope.query = undefined;

        //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
        var timeoutPromise;

        var scheduleSearchWithTimeout = function(inputValue) {
          timeoutPromise = $timeout(function() {
            getMatchesAsync(inputValue);
          }, waitTime);
        };

        var cancelPreviousTimeout = function() {
          if (timeoutPromise) {
            $timeout.cancel(timeoutPromise);
          }
        };

        //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
        //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
        modelCtrl.$parsers.unshift(function(inputValue) {
          hasFocus = true;

          if (minLength === 0 || inputValue && inputValue.length >= minLength) {
            if (waitTime > 0) {
              cancelPreviousTimeout();
              scheduleSearchWithTimeout(inputValue);
            } else {
              getMatchesAsync(inputValue);
            }
          } else {
            isLoadingSetter(originalScope, false);
            cancelPreviousTimeout();
            resetMatches();
          }

          if (isEditable) {
            return inputValue;
          } else {
            if (!inputValue) {
              // Reset in case user had typed something previously.
              modelCtrl.$setValidity('editable', true);
              return null;
            } else {
              modelCtrl.$setValidity('editable', false);
              return undefined;
            }
          }
        });

        modelCtrl.$formatters.push(function(modelValue) {
          var candidateViewValue, emptyViewValue;
          var locals = {};

          // The validity may be set to false via $parsers (see above) if
          // the model is restricted to selected values. If the model
          // is set manually it is considered to be valid.
          if (!isEditable) {
            modelCtrl.$setValidity('editable', true);
          }

          if (inputFormatter) {
            locals.$model = modelValue;
            return inputFormatter(originalScope, locals);
          } else {
            //it might happen that we don't have enough info to properly render input value
            //we need to check for this situation and simply return model value if we can't apply custom formatting
            locals[parserResult.itemName] = modelValue;
            candidateViewValue = parserResult.viewMapper(originalScope, locals);
            locals[parserResult.itemName] = undefined;
            emptyViewValue = parserResult.viewMapper(originalScope, locals);

            return candidateViewValue!== emptyViewValue ? candidateViewValue : modelValue;
          }
        });

        scope.select = function(activeIdx) {
          //called from within the $digest() cycle
          var locals = {};
          var model, item;

          selected = true;
          locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
          model = parserResult.modelMapper(originalScope, locals);
          $setModelValue(originalScope, model);
          modelCtrl.$setValidity('editable', true);
          modelCtrl.$setValidity('parse', true);

          onSelectCallback(originalScope, {
            $item: item,
            $model: model,
            $label: parserResult.viewMapper(originalScope, locals)
          });

          resetMatches();

          //return focus to the input element if a match was selected via a mouse click event
          // use timeout to avoid $rootScope:inprog error
          if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
            $timeout(function() { element[0].focus(); }, 0, false);
          }
        };

        //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
        element.bind('keydown', function(evt) {
          //typeahead is open and an "interesting" key was pressed
          if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
            return;
          }

          // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
          if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
            resetMatches();
            scope.$digest();
            return;
          }

          evt.preventDefault();

          if (evt.which === 40) {
            scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
            scope.$digest();

          } else if (evt.which === 38) {
            scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
            scope.$digest();

          } else if (evt.which === 13 || evt.which === 9) {
            scope.$apply(function () {
              scope.select(scope.activeIdx);
            });

          } else if (evt.which === 27) {
            evt.stopPropagation();

            resetMatches();
            scope.$digest();
          }
        });

        element.bind('blur', function() {
          if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
            selected = true;
            scope.$apply(function() {
              scope.select(scope.activeIdx);
            });
          }
          hasFocus = false;
          selected = false;
        });

        // Keep reference to click handler to unbind it.
        var dismissClickHandler = function(evt) {
          // Issue #3973
          // Firefox treats right click as a click on document
          if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
            resetMatches();
            if (!$rootScope.$$phase) {
              scope.$digest();
            }
          }
        };

        $document.bind('click', dismissClickHandler);

        originalScope.$on('$destroy', function() {
          $document.unbind('click', dismissClickHandler);
          if (appendToBody) {
            $popup.remove();
          }
          // Prevent jQuery cache memory leak
          popUpEl.remove();
        });

        var $popup = $compile(popUpEl)(scope);

        if (appendToBody) {
          $document.find('body').append($popup);
        } else {
          element.after($popup);
        }
      }
    };

  }])

  .directive('typeaheadPopup', function() {
    return {
      restrict: 'EA',
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          return scope.matches.length > 0;
        };

        scope.isActive = function(matchIdx) {
          return scope.active == matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx) {
          scope.select({activeIdx:activeIdx});
        };
      }
    };
  })

  .directive('typeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      restrict: 'EA',
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link:function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          $compile(tplContent.trim())(scope, function(clonedElement) {
            element.replaceWith(clonedElement);
          });
        });
      }
    };
  }])

  .filter('typeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);


/**
 * @ngdoc overview
 * @name ui.bootstrap.tabs
 *
 * @description
 * AngularJS version of the tabs directive.
 */

angular.module('ui.bootstrap.tabs', [])

.controller('TabsetController', ['$scope', function TabsetCtrl($scope) {
  var ctrl = this,
      tabs = ctrl.tabs = $scope.tabs = [];

  ctrl.select = function(selectedTab) {
    angular.forEach(tabs, function(tab) {
      if (tab.active && tab !== selectedTab) {
        tab.active = false;
        tab.onDeselect();
        selectedTab.selectCalled = false;
      }
    });
    selectedTab.active = true;
    // only call select if it has not already been called
    if (!selectedTab.selectCalled) {
      selectedTab.onSelect();
      selectedTab.selectCalled = true;
    }
  };

  ctrl.addTab = function addTab(tab) {
    tabs.push(tab);
    // we can't run the select function on the first tab
    // since that would select it twice
    if (tabs.length === 1 && tab.active !== false) {
      tab.active = true;
    } else if (tab.active) {
      ctrl.select(tab);
    } else {
      tab.active = false;
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index = tabs.indexOf(tab);
    //Select a new tab if the tab to be removed is selected and not destroyed
    if (tab.active && tabs.length > 1 && !destroyed) {
      //If this is the last tab, select the previous tab. else, the next tab.
      var newActiveIndex = index == tabs.length - 1 ? index - 1 : index + 1;
      ctrl.select(tabs[newActiveIndex]);
    }
    tabs.splice(index, 1);
  };

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });
}])

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabset
 * @restrict EA
 *
 * @description
 * Tabset is the outer container for the tabs directive
 *
 * @param {boolean=} vertical Whether or not to use vertical styling for the tabs.
 * @param {boolean=} justified Whether or not to use justified styling for the tabs.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab heading="Tab 1"><b>First</b> Content!</tab>
      <tab heading="Tab 2"><i>Second</i> Content!</tab>
    </tabset>
    <hr />
    <tabset vertical="true">
      <tab heading="Vertical Tab 1"><b>First</b> Vertical Content!</tab>
      <tab heading="Vertical Tab 2"><i>Second</i> Vertical Content!</tab>
    </tabset>
    <tabset justified="true">
      <tab heading="Justified Tab 1"><b>First</b> Justified Content!</tab>
      <tab heading="Justified Tab 2"><i>Second</i> Justified Content!</tab>
    </tabset>
  </file>
</example>
 */
.directive('tabset', function() {
  return {
    restrict: 'EA',
    transclude: true,
    replace: true,
    scope: {
      type: '@'
    },
    controller: 'TabsetController',
    templateUrl: 'template/tabs/tabset.html',
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
    }
  };
})

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tab
 * @restrict EA
 *
 * @param {string=} heading The visible heading, or title, of the tab. Set HTML headings with {@link ui.bootstrap.tabs.directive:tabHeading tabHeading}.
 * @param {string=} select An expression to evaluate when the tab is selected.
 * @param {boolean=} active A binding, telling whether or not this tab is selected.
 * @param {boolean=} disabled A binding, telling whether or not this tab is disabled.
 *
 * @description
 * Creates a tab with a heading and content. Must be placed within a {@link ui.bootstrap.tabs.directive:tabset tabset}.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <div ng-controller="TabsDemoCtrl">
      <button class="btn btn-small" ng-click="items[0].active = true">
        Select item 1, using active binding
      </button>
      <button class="btn btn-small" ng-click="items[1].disabled = !items[1].disabled">
        Enable/disable item 2, using disabled binding
      </button>
      <br />
      <tabset>
        <tab heading="Tab 1">First Tab</tab>
        <tab select="alertMe()">
          <tab-heading><i class="icon-bell"></i> Alert me!</tab-heading>
          Second Tab, with alert callback and html heading!
        </tab>
        <tab ng-repeat="item in items"
          heading="{{item.title}}"
          disabled="item.disabled"
          active="item.active">
          {{item.content}}
        </tab>
      </tabset>
    </div>
  </file>
  <file name="script.js">
    function TabsDemoCtrl($scope) {
      $scope.items = [
        { title:"Dynamic Title 1", content:"Dynamic Item 0" },
        { title:"Dynamic Title 2", content:"Dynamic Item 1", disabled: true }
      ];

      $scope.alertMe = function() {
        setTimeout(function() {
          alert("You've selected the alert tab!");
        });
      };
    };
  </file>
</example>
 */

/**
 * @ngdoc directive
 * @name ui.bootstrap.tabs.directive:tabHeading
 * @restrict EA
 *
 * @description
 * Creates an HTML heading for a {@link ui.bootstrap.tabs.directive:tab tab}. Must be placed as a child of a tab element.
 *
 * @example
<example module="ui.bootstrap">
  <file name="index.html">
    <tabset>
      <tab>
        <tab-heading><b>HTML</b> in my titles?!</tab-heading>
        And some content, too!
      </tab>
      <tab>
        <tab-heading><i class="icon-heart"></i> Icon heading?!?</tab-heading>
        That's right.
      </tab>
    </tabset>
  </file>
</example>
 */
.directive('tab', ['$parse', '$log', function($parse, $log) {
  return {
    require: '^tabset',
    restrict: 'EA',
    replace: true,
    templateUrl: 'template/tabs/tab.html',
    transclude: true,
    scope: {
      active: '=?',
      heading: '@',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.$watch('active', function(active) {
        if (active) {
          tabsetCtrl.select(scope);
        }
      });

      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      // Deprecation support of "disabled" parameter
      // fix(tab): IE9 disabled attr renders grey text on enabled tab #2677
      // This code is duplicated from the lines above to make it easy to remove once
      // the feature has been completely deprecated
      if (attrs.disabled) {
        $log.warn('Use of "disabled" attribute has been deprecated, please use "disable"');
        scope.$parent.$watch($parse(attrs.disabled), function(value) {
          scope.disabled = !! value;
        });
      }

      scope.select = function() {
        if (!scope.disabled) {
          scope.active = true;
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('tabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^tab',
    link: function(scope, elm, attrs, tabCtrl) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('tabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^tabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.tabContentTransclude);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('tab-heading') ||
      node.hasAttribute('data-tab-heading') ||
      node.hasAttribute('x-tab-heading') ||
      node.tagName.toLowerCase() === 'tab-heading' ||
      node.tagName.toLowerCase() === 'data-tab-heading' ||
      node.tagName.toLowerCase() === 'x-tab-heading'
    );
  }
});

angular.module('ui.bootstrap.bindHtml', [])

  .value('$bindHtmlUnsafeSuppressDeprecated', false)

  .directive('bindHtmlUnsafe', ['$log', '$bindHtmlUnsafeSuppressDeprecated', function ($log, $bindHtmlUnsafeSuppressDeprecated) {
    return function (scope, element, attr) {
      if (!$bindHtmlUnsafeSuppressDeprecated) {
        $log.warn('bindHtmlUnsafe is now deprecated. Use ngBindHtml instead');
      }
      element.addClass('ng-binding').data('$binding', attr.bindHtmlUnsafe);
      scope.$watch(attr.bindHtmlUnsafe, function bindHtmlUnsafeWatchAction(value) {
        element.html(value || '');
      });
    };
  }]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.bindHtml'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
  .provider('$tooltip', function() {
    // The default options tooltip and popover.
    var defaultOptions = {
      placement: 'top',
      animation: true,
      popupDelay: 0,
      useContentExp: false
    };

    // Default hide triggers for each show trigger
    var triggerMap = {
      'mouseenter': 'mouseleave',
      'click': 'click',
      'focus': 'blur',
      'none': ''
    };

    // The options specified to the provider globally.
    var globalOptions = {};

    /**
     * `options({})` allows global configuration of all tooltips in the
     * application.
     *
     *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
     */
    this.options = function(value) {
      angular.extend(globalOptions, value);
    };

    /**
     * This allows you to extend the set of trigger mappings available. E.g.:
     *
     *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
     */
    this.setTriggers = function setTriggers(triggers) {
      angular.extend(triggerMap, triggers);
    };

    /**
     * This is a helper function for translating camel-case to snake-case.
     */
    function snake_case(name) {
      var regexp = /[A-Z]/g;
      var separator = '-';
      return name.replace(regexp, function(letter, pos) {
        return (pos ? separator : '') + letter.toLowerCase();
      });
    }

    /**
     * Returns the actual instance of the $tooltip service.
     * TODO support multiple triggers
     */
    this.$get = ['$window', '$compile', '$timeout', '$document', '$position', '$interpolate', '$rootScope', '$parse', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse) {
      return function $tooltip(type, prefix, defaultTriggerShow, options) {
        options = angular.extend({}, defaultOptions, globalOptions, options);

        /**
         * Returns an object of show and hide triggers.
         *
         * If a trigger is supplied,
         * it is used to show the tooltip; otherwise, it will use the `trigger`
         * option passed to the `$tooltipProvider.options` method; else it will
         * default to the trigger supplied to this directive factory.
         *
         * The hide trigger is based on the show trigger. If the `trigger` option
         * was passed to the `$tooltipProvider.options` method, it will use the
         * mapped trigger from `triggerMap` or the passed trigger if the map is
         * undefined; otherwise, it uses the `triggerMap` value of the show
         * trigger; else it will just use the show trigger.
         */
        function getTriggers(trigger) {
          var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
          var hide = show.map(function(trigger) {
            return triggerMap[trigger] || trigger;
          });
          return {
            show: show,
            hide: hide
          };
        }

        var directiveName = snake_case(type);

        var startSym = $interpolate.startSymbol();
        var endSym = $interpolate.endSymbol();
        var template =
          '<div '+ directiveName +'-popup '+
          'title="'+startSym+'title'+endSym+'" '+
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="'+startSym+'content'+endSym+'" ') +
          'placement="'+startSym+'placement'+endSym+'" '+
          'popup-class="'+startSym+'popupClass'+endSym+'" '+
          'animation="animation" '+
          'is-open="isOpen"'+
          'origin-scope="origScope" '+
          '>'+
          '</div>';

        return {
          restrict: 'EA',
          compile: function(tElem, tAttrs) {
            var tooltipLinker = $compile( template );

            return function link(scope, element, attrs, tooltipCtrl) {
              var tooltip;
              var tooltipLinkedScope;
              var transitionTimeout;
              var popupTimeout;
              var positionTimeout;
              var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
              var triggers = getTriggers(undefined);
              var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
              var ttScope = scope.$new(true);
              var repositionScheduled = false;
              var isOpenExp = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;

              var positionTooltip = function() {
                if (!tooltip) { return; }

                if (!positionTimeout) {
                  positionTimeout = $timeout(function() {
                    // Reset the positioning and box size for correct width and height values.
                    tooltip.css({ top: 0, left: 0, width: 'auto', height: 'auto' });

                    var ttBox = $position.position(tooltip);
                    var ttCss = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                    ttCss.top += 'px';
                    ttCss.left += 'px';

                    ttCss.width = ttBox.width + 'px';
                    ttCss.height = ttBox.height + 'px';

                    // Now set the calculated positioning and size.
                    tooltip.css(ttCss);

                    positionTimeout = null;

                  }, 0, false);
                }
              };

              // Set up the correct scope to allow transclusion later
              ttScope.origScope = scope;

              // By default, the tooltip is not open.
              // TODO add ability to start tooltip opened
              ttScope.isOpen = false;

              function toggleTooltipBind() {
                if (!ttScope.isOpen) {
                  showTooltipBind();
                } else {
                  hideTooltipBind();
                }
              }

              // Show the tooltip with delay if specified, otherwise show it immediately
              function showTooltipBind() {
                if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                  return;
                }

                prepareTooltip();

                if (ttScope.popupDelay) {
                  // Do nothing if the tooltip was already scheduled to pop-up.
                  // This happens if show is triggered multiple times before any hide is triggered.
                  if (!popupTimeout) {
                    popupTimeout = $timeout(show, ttScope.popupDelay, false);
                  }
                } else {
                  show();
                }
              }

              function hideTooltipBind () {
                hide();
                if (!$rootScope.$$phase) {
                  $rootScope.$digest();
                }
              }

              // Show the tooltip popup element.
              function show() {
                popupTimeout = null;

                // If there is a pending remove transition, we must cancel it, lest the
                // tooltip be mysteriously removed.
                if (transitionTimeout) {
                  $timeout.cancel(transitionTimeout);
                  transitionTimeout = null;
                }

                // Don't show empty tooltips.
                if (!(options.useContentExp ? ttScope.contentExp() : ttScope.content)) {
                  return angular.noop;
                }

                createTooltip();

                // And show the tooltip.
                ttScope.isOpen = true;
                if (isOpenExp) {
                  isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
                }

                if (!$rootScope.$$phase) {
                  ttScope.$apply(); // digest required as $apply is not called
                }

                tooltip.css({ display: 'block' });

                positionTooltip();
              }

              // Hide the tooltip popup element.
              function hide() {
                // First things first: we don't show it anymore.
                ttScope.isOpen = false;
                if (isOpenExp) {
                  isOpenExp.assign(ttScope.origScope, ttScope.isOpen);
                }

                //if tooltip is going to be shown after delay, we must cancel this
                $timeout.cancel(popupTimeout);
                popupTimeout = null;

                $timeout.cancel(positionTimeout);
                positionTimeout = null;

                // And now we remove it from the DOM. However, if we have animation, we
                // need to wait for it to expire beforehand.
                // FIXME: this is a placeholder for a port of the transitions library.
                if (ttScope.animation) {
                  if (!transitionTimeout) {
                    transitionTimeout = $timeout(removeTooltip, 500);
                  }
                } else {
                  removeTooltip();
                }
              }

              function createTooltip() {
                // There can only be one tooltip element per directive shown at once.
                if (tooltip) {
                  removeTooltip();
                }
                tooltipLinkedScope = ttScope.$new();
                tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                  if (appendToBody) {
                    $document.find('body').append(tooltip);
                  } else {
                    element.after(tooltip);
                  }
                });

                if (options.useContentExp) {
                  tooltipLinkedScope.$watch('contentExp()', function(val) {
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  });

                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  });

                }
              }

              function removeTooltip() {
                transitionTimeout = null;
                if (tooltip) {
                  tooltip.remove();
                  tooltip = null;
                }
                if (tooltipLinkedScope) {
                  tooltipLinkedScope.$destroy();
                  tooltipLinkedScope = null;
                }
              }

              function prepareTooltip() {
                prepPopupClass();
                prepPlacement();
                prepPopupDelay();
              }

              ttScope.contentExp = function() {
                return scope.$eval(attrs[type]);
              };

              /**
               * Observe the relevant attributes.
               */
              if (!options.useContentExp) {
                attrs.$observe(type, function(val) {
                  ttScope.content = val;

                  if (!val && ttScope.isOpen) {
                    hide();
                  } else {
                    positionTooltip();
                  }
                });
              }

              attrs.$observe('disabled', function(val) {
                if (popupTimeout && val) {
                  $timeout.cancel(popupTimeout);
                  popupTimeout = null;
                }

                if (val && ttScope.isOpen) {
                  hide();
                }
              });

              attrs.$observe(prefix + 'Title', function(val) {
                ttScope.title = val;
                positionTooltip();
              });

              attrs.$observe(prefix + 'Placement', function() {
                if (ttScope.isOpen) {
                  prepPlacement();
                  positionTooltip();
                }
              });

              if (isOpenExp) {
                scope.$watch(isOpenExp, function(val) {
                  if (val !== ttScope.isOpen) {
                    toggleTooltipBind();
                  }
                });
              }

              function prepPopupClass() {
                ttScope.popupClass = attrs[prefix + 'Class'];
              }

              function prepPlacement() {
                var val = attrs[prefix + 'Placement'];
                ttScope.placement = angular.isDefined(val) ? val : options.placement;
              }

              function prepPopupDelay() {
                var val = attrs[prefix + 'PopupDelay'];
                var delay = parseInt(val, 10);
                ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              }

              var unregisterTriggers = function() {
                triggers.show.forEach(function(trigger) {
                  element.unbind(trigger, showTooltipBind);
                });
                triggers.hide.forEach(function(trigger) {
                  element.unbind(trigger, hideTooltipBind);
                });
              };

              function prepTriggers() {
                var val = attrs[prefix + 'Trigger'];
                unregisterTriggers();

                triggers = getTriggers(val);

                if (triggers.show !== 'none') {
                  triggers.show.forEach(function(trigger, idx) {
                    // Using raw addEventListener due to jqLite/jQuery bug - #4060
                    if (trigger === triggers.hide[idx]) {
                      element[0].addEventListener(trigger, toggleTooltipBind);
                    } else if (trigger) {
                      element[0].addEventListener(trigger, showTooltipBind);
                      element[0].addEventListener(triggers.hide[idx], hideTooltipBind);
                    }
                  });
                }
              }
              prepTriggers();

              var animation = scope.$eval(attrs[prefix + 'Animation']);
              ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

              var appendToBodyVal = scope.$eval(attrs[prefix + 'AppendToBody']);
              appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

              // if a tooltip is attached to <body> we need to remove it on
              // location change as its parent scope will probably not be destroyed
              // by the change.
              if (appendToBody) {
                scope.$on('$locationChangeSuccess', function closeTooltipOnLocationChangeSuccess() {
                  if (ttScope.isOpen) {
                    hide();
                  }
                });
              }

              // Make sure tooltip is destroyed and removed.
              scope.$on('$destroy', function onDestroyTooltip() {
                $timeout.cancel(transitionTimeout);
                $timeout.cancel(popupTimeout);
                $timeout.cancel(positionTimeout);
                unregisterTriggers();
                removeTooltip();
                ttScope = null;
              });
            };
          }
        };
      };
    }];
  })

  // This is mostly ngInclude code but with a custom scope
  .directive('tooltipTemplateTransclude', [
    '$animate', '$sce', '$compile', '$templateRequest',
    function ($animate ,  $sce ,  $compile ,  $templateRequest) {
      return {
        link: function(scope, elem, attrs) {
          var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

          var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;

          var cleanupLastIncludeContent = function() {
            if (previousElement) {
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).then(function() {
                previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };

          scope.$watch($sce.parseAsResourceUrl(attrs.tooltipTemplateTransclude), function(src) {
            var thisChangeId = ++changeCounter;

            if (src) {
              //set the 2nd param to true to ignore the template request error so that the inner
              //contents and scope can be cleaned up.
              $templateRequest(src, true).then(function(response) {
                if (thisChangeId !== changeCounter) { return; }
                var newScope = origScope.$new();
                var template = response;

                var clone = $compile(template)(newScope, function(clone) {
                  cleanupLastIncludeContent();
                  $animate.enter(clone, elem);
                });

                currentScope = newScope;
                currentElement = clone;

                currentScope.$emit('$includeContentLoaded', src);
              }, function() {
                if (thisChangeId === changeCounter) {
                  cleanupLastIncludeContent();
                  scope.$emit('$includeContentError', src);
                }
              });
              scope.$emit('$includeContentRequested', src);
            } else {
              cleanupLastIncludeContent();
            }
          });

          scope.$on('$destroy', cleanupLastIncludeContent);
        }
      };
    }])

  /**
   * Note that it's intentional that these classes are *not* applied through $animate.
   * They must not be animated as they're expected to be present on the tooltip on
   * initialization.
   */
  .directive('tooltipClasses', function() {
    return {
      restrict: 'A',
      link: function(scope, element, attrs) {
        if (scope.placement) {
          element.addClass(scope.placement);
        }
        if (scope.popupClass) {
          element.addClass(scope.popupClass);
        }
        if (scope.animation()) {
          element.addClass(attrs.tooltipAnimationClass);
        }
      }
    };
  })

  .directive('tooltipPopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
      templateUrl: 'template/tooltip/tooltip-popup.html'
    };
  })

  .directive('tooltip', [ '$tooltip', function($tooltip) {
    return $tooltip('tooltip', 'tooltip', 'mouseenter');
  }])

  .directive('tooltipTemplatePopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
        originScope: '&' },
      templateUrl: 'template/tooltip/tooltip-template-popup.html'
    };
  })

  .directive('tooltipTemplate', ['$tooltip', function($tooltip) {
    return $tooltip('tooltipTemplate', 'tooltip', 'mouseenter', {
      useContentExp: true
    });
  }])

  .directive('tooltipHtmlPopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
      templateUrl: 'template/tooltip/tooltip-html-popup.html'
    };
  })

  .directive('tooltipHtml', ['$tooltip', function($tooltip) {
    return $tooltip('tooltipHtml', 'tooltip', 'mouseenter', {
      useContentExp: true
    });
  }])

  /*
  Deprecated
  */
  .directive('tooltipHtmlUnsafePopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
      templateUrl: 'template/tooltip/tooltip-html-unsafe-popup.html'
    };
  })

  .value('tooltipHtmlUnsafeSuppressDeprecated', false)
  .directive('tooltipHtmlUnsafe', [
    '$tooltip', 'tooltipHtmlUnsafeSuppressDeprecated', '$log',
    function($tooltip ,  tooltipHtmlUnsafeSuppressDeprecated ,  $log) {
      if (!tooltipHtmlUnsafeSuppressDeprecated) {
        $log.warn('tooltip-html-unsafe is now deprecated. Use tooltip-html or tooltip-template instead.');
      }
      return $tooltip('tooltipHtmlUnsafe', 'tooltip', 'mouseenter');
    }]);


/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module( 'ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

  .directive('popoverTemplatePopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { title: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
        originScope: '&' },
      templateUrl: 'template/popover/popover-template.html'
    };
  })

  .directive('popoverTemplate', ['$tooltip', function($tooltip) {
    return $tooltip('popoverTemplate', 'popover', 'click', {
      useContentExp: true
    });
  }])

  .directive('popoverHtmlPopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { contentExp: '&', title: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
      templateUrl: 'template/popover/popover-html.html'
    };
  })

  .directive('popoverHtml', ['$tooltip', function($tooltip) {
    return $tooltip( 'popoverHtml', 'popover', 'click', {
      useContentExp: true
    });
  }])

  .directive('popoverPopup', function() {
    return {
      restrict: 'EA',
      replace: true,
      scope: { title: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
      templateUrl: 'template/popover/popover.html'
    };
  })

  .directive('popover', ['$tooltip', function($tooltip) {
    return $tooltip( 'popover', 'popover', 'click' );
  }]);

angular.module("template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/modal/window.html",
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
    "    modal-animation-class=\"fade\"\n" +
    "    modal-in-class=\"in\"\n" +
    "	ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\" ng-click=\"close($event)\">\n" +
    "    <div class=\"modal-dialog\" ng-class=\"size ? 'modal-' + size : ''\"><div class=\"modal-content\" modal-transclude></div></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/datepicker.html",
    "<div ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <daypicker ng-switch-when=\"day\" tabindex=\"0\"></daypicker>\n" +
    "  <monthpicker ng-switch-when=\"month\" tabindex=\"0\"></monthpicker>\n" +
    "  <yearpicker ng-switch-when=\"year\" tabindex=\"0\"></yearpicker>\n" +
    "</div>");
}]);

angular.module("template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/day.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/month.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/datepicker/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/popup.html",
    "<ul class=\"dropdown-menu\" ng-if=\"isOpen\" style=\"display: block\" ng-style=\"{top: position.top+'px', left: position.left+'px'}\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "	<li ng-transclude></li>\n" +
    "	<li ng-if=\"showButtonBar\" style=\"padding:10px 9px 2px\">\n" +
    "		<span class=\"btn-group pull-left\">\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-info\" ng-click=\"select('today')\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "			<button type=\"button\" class=\"btn btn-sm btn-danger\" ng-click=\"select(null)\">{{ getText('clear') }}</button>\n" +
    "		</span>\n" +
    "		<button type=\"button\" class=\"btn btn-sm btn-success pull-right\" ng-click=\"close()\">{{ getText('close') }}</button>\n" +
    "	</li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/datepicker/year.html",
    "<table role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\">\n" +
    "        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{'btn-info': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/accordion/accordion-group.html",
    "<div class=\"panel {{panelClass || 'panel-default'}}\">\n" +
    "  <div class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "    <h4 class=\"panel-title\">\n" +
    "      <a href tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" accordion-transclude=\"heading\"><span ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "  <div class=\"panel-collapse collapse\" collapse=\"!isOpen\">\n" +
    "	  <div class=\"panel-body\" ng-transclude></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/accordion/accordion.html",
    "<div class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/alert/alert.html",
    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close($event)\">\n" +
    "        <span aria-hidden=\"true\">&times;</span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
    "    <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "        <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{active: isActive(slide)}\" ng-click=\"select(slide)\"></li>\n" +
    "    </ol>\n" +
    "    <div class=\"carousel-inner\" ng-transclude></div>\n" +
    "    <a class=\"left carousel-control\" ng-click=\"prev()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-left\"></span></a>\n" +
    "    <a class=\"right carousel-control\" ng-click=\"next()\" ng-show=\"slides.length > 1\"><span class=\"glyphicon glyphicon-chevron-right\"></span></a>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/carousel/slide.html",
    "<div ng-class=\"{\n" +
    "    'active': active\n" +
    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("template/pagination/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/pagination/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/pagination/pagination.html",
    "<ul class=\"pagination\">\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/typeahead/typeahead-match.html",
    "<a href tabindex=\"-1\" ng-bind-html=\"match.label | typeaheadHighlight:query\"></a>\n" +
    "");
}]);

angular.module("template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" style=\"display: block;\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/tab.html",
    "<li ng-class=\"{active: active, disabled: disabled}\">\n" +
    "  <a href ng-click=\"select()\" tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\" \n" +
    "         ng-repeat=\"tab in tabs\" \n" +
    "         ng-class=\"{active: tab.active}\"\n" +
    "         tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-html-unsafe-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-html-unsafe-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" bind-html-unsafe=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\"\n" +
    "    tooltip-template-transclude=\"contentExp()\"\n" +
    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover-html.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover-template.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\"\n" +
    "        tooltip-template-transclude=\"contentExp()\"\n" +
    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/popover/popover.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"title\" ng-if=\"title\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

!angular.$$csp() && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');

(function () {
    'use strict';
    angular.module('ute.active.treatments').factory('ute.active.treatments.service', ['$http', 'ute.blocks.persistent.storage.service', 'ute.common.security.service', 'ute.blocks.language.switcher', '$q', 
    function ($http, persistentStorage, securityService, languageService, $q) {
        var isEnCallInProgress = false;
        var isFrCallInProgress = false;
        var enFinalResponse = {};
        var frFinalResponse = {};
        var enActualDeferredPromise = $q.defer();
        var frActualDeferredPromise = $q.defer();
        var currentLang = languageService.getCurrentLanguage();

        function checkExistingResponses(lang) {
            if (lang === 'en' && Object.keys(enFinalResponse).length > 0) {
                //isEnCallInProgress = false;
                return true;
            }

            if (lang === 'fr' && Object.keys(frFinalResponse).length > 0) {
                //isFrCallInProgress = false;
                return true;
            }
            return false;
        }

        function returnExistingResponses(lang) {
            if(lang === 'en') {
                isEnCallInProgress = false;
                enActualDeferredPromise.resolve(enFinalResponse);
                return enActualDeferredPromise.promise;
            }

            if(lang === 'fr') {
                isFrCallInProgress = false;
                frActualDeferredPromise.resolve(frFinalResponse);
                return frActualDeferredPromise.promise;
            }

        }

        function callActiveTreatments() {
            if (languageService.getCurrentLanguage() !== currentLang) {
                var lang = languageService.getCurrentLanguage();
                currentLang = lang;
                if (checkExistingResponses(lang)) {
                    return returnExistingResponses(lang);
                }
                else {
                    return  getActiveTreatments(lang);
                }
            } else {
                if ((currentLang === 'en' && isEnCallInProgress) || (currentLang === 'fr' && isFrCallInProgress)) {
                    var newdefer = $q.defer();
                    if (currentLang === 'en') {
                        enActualDeferredPromise.promise.then(function (response) {
                            newdefer.resolve(response);
                        }, function (error) {
                            newdefer.reject(error);
                        });
                    } else {
                        frActualDeferredPromise.promise.then(function (response) {
                            newdefer.resolve(response);
                        }, function (error) {
                            newdefer.reject(error);
                        });
                    }
                    return newdefer.promise;
                } else {
                    if (checkExistingResponses(currentLang)) {
                        return returnExistingResponses(currentLang);
                    }
                    else {
                        return getActiveTreatments(currentLang);
                    }
                }
            }
        }
        function getActiveTreatments(lang) {
            var getActiveTreatmentsApiUrl = 'v1/cmt/getActiveTreatments';
            var accountNumber = persistentStorage.getFromSession('accountNumber');
            var requestObject = {
                accountNumber: accountNumber,
                lang: lang
            };
            $http.post(securityService.getBackendUrl(getActiveTreatmentsApiUrl), requestObject).then(function (response) {
                if (lang === 'en') {
                    isEnCallInProgress = false;
                    enFinalResponse = angular.copy(response);
                    enActualDeferredPromise.resolve(enFinalResponse);
                }
                else {
                    isFrCallInProgress = false;
                    frFinalResponse = angular.copy(response);
                    frActualDeferredPromise.resolve(frFinalResponse);
                }
            }, function (errorResponse) {
                if (lang === 'en') {
                    isEnCallInProgress = false;
                    enFinalResponse = angular.copy(errorResponse);
                    enActualDeferredPromise.reject(errorResponse);
                }
                else {
                    isFrCallInProgress = false;
                    frFinalResponse = angular.copy(errorResponse);
                    frActualDeferredPromise.reject(errorResponse);
                }
            });
            if (lang === 'en') {
                isEnCallInProgress = true;
                return enActualDeferredPromise.promise;
            }
            else {
                isFrCallInProgress = true;
                return frActualDeferredPromise.promise;
            }
        }
        return {
            callActiveTreatments: callActiveTreatments
        };
    }]);
})();
/* jshint -W101, -W109, -W033, -W117, -W106 */
function invokeChat(con, source) {
  $.ajax({
    url: "/web/SSOChatEncodeServlet",
    timeout: 50000,
    dataType: 'json',
    async: false,
    type: "POST",
    data: {
      con: con,
      sourceId: source
    },

    success: function (data) {

      window.open(data.url, 'new_window', 'resizable=1,scrollbars=yes,width=500,height=400,top=800,left=800');

    },
    error: function (xmlHttpRequest, textStatus, errorThrown) {
      return false;
    }
  })
}
//Added for S36688- resize the chat-window

function invokeChat_custom(con, source, width, height, top, left) {
  $.ajax({
    url: "/web/SSOChatEncodeServlet",
    timeout: 50000,
    dataType: 'json',
    async: false,
    type: "POST",
    data: {
      con: con,
      sourceId: source
    },

    success: function (data) {

      window.open(data.url, 'new_window', 'resizable=1,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + '');

    },
    error: function (xmlHttpRequest, textStatus, errorThrown) {
      return false;
    }
  })
}

// new custom url invoke chat method : added for Story S38290

function invokeChat_custom_url(url, queryString, width, height, top, left) {
  $.ajax({
    url: "/web/SSOChatEncodeServlet",
    timeout: 50000,
    dataType: 'json',
    async: false,
    type: "POST",
    data: {
      url: url,
      queryString: queryString,
      con: 'NA',
      sourceId: 'NA'
    },

    success: function (data) {

      window.open(data.url, 'new_window', 'resizable=1,scrollbars=yes,width=' + width + ',height=' + height + ',top=' + top + ',left=' + left + '');

    },
    error: function (xmlHttpRequest, textStatus, errorThrown) {
      return false;
    }
  })

}

// This is for IE8 fix given for S36995 Pre authorized chequing page.
function invokeChatIE8Fix() {
  invokeChat_custom('true', '202', '800', '800', '100', '100');
}

function invokeChatIE8FixFR() {
  invokeChat_custom('true', '252', '800', '800', '100', '100');
}

//// As Is no comments :)
//
//function getBDId(buttonId) {
//  switch (buttonId) {
//    case 'S_Shop_Wireless_PlnBldr1':
//      return "8169041807613897395";
//      break;
//
//    case 'S_Shop_Wireless_PlnBldr2':
//      return "2806752654927984588";
//      break;
//
//    case 'S_Shop_Wireless_PlnBldr3':
//      return "2694660086530699445";
//      break;
//
//    case 'S_Shop_Wireless_Androids':
//      return "3104080293003574467";
//      break;
//
//    case 'S_Shop_Wireless_Windows_Phones':
//      return "2361654046616009459";
//      break;
//
//    case 'S_Shop_Wireless_Blackberry':
//      return "3639647123512281022";
//      break;
//
//    case 'S_Shop_Internet_Premium_Sup':
//      return "7108461132806489551";
//      break;
//
//    case 'S_Shop_Wireless_Mobile_Int':
//      return "3234036450933919716";
//      break;
//
//    case 'S_Shop_TV_Channels':
//      return "2730490750174311397";
//      break;
//
//    case 'S_Shop_TV_Theme_Packs':
//      return "8569499828814297832";
//      break;
//
//    case 'S_Shop_SHM_Solutions_Price1':
//      return "5840194391998867821";
//      break;
//
//    case 'S_Shop_SHM_Solutions_Price2':
//      return "4194367065911716640";
//      break;
//
//    case 'F_Shop_SHM':
//      return "2201507837503649474";
//      break;
//
//    case 'Shop_Wireless_Internet':
//      return "1111843959802048717";
//      break;
//
//    case 'Shop_Internet_Buy_Flow':
//      return "7330813972192450862";
//      break;
//
//    case 'S_Shop_TV_Landing_Package':
//      return "856567323618428323";
//      break;
//
//    case 'Shop_TV_Buy_Flow':
//      return "1788410156060754061";
//      break;
//
//    case 'Shop_HP_Buy_Flow_Bundle':
//      return "301179669690869894";
//      break;
//
//    case 'Shop_Bundles_Bundle_Builder':
//      return "6796132488332618351";
//      break;
//
//    case 'S_Shop_Wireless_Device_Catalogue_AAL':
//      return "8396530394401574297";
//      break;
//
//    case 'S_Shop_Wireless_Pnbldr_SMPhone':
//      return "3694078442194894933";
//      break;
//
//
//
////static button ids 2nd set
//
//    case 'S_TechSupp_Wireless':
//      return "1477170511306860658";
//      break;
//
//    case 'S_TechSupp_Wireless_Fr':
//      return "6148971745740490047";
//      break;
//
//    case 'S_TechSupp_Internet':
//      return "3754904012858588714";
//      break;
//
//    case 'S_TechSupp_Internet_Fr':
//      return "5576764636396720127";
//      break;
//
//    case 'S_TechSupp_TV':
//      return "3753841357611956992";
//      break;
//
//    case 'S_TechSupp_TV_Fr':
//      return "4194880448908017487";
//      break;
//
//    case 'S_TechSupp_HP':
//      return "5405890188445170089";
//      break;
//
//    case 'S_TechSupp_HP_Fr':
//      return "3191307514913261380";
//      break;
//
//    case 'S_TechSupp_NHL':
//      return "3584700375115272140";
//      break;
//
//    case 'S_TechSupp_NHL_Fr':
//      return "4670814200731912807";
//      break;
//
//    case 'S_CntcUs_PS_Wireless':
//      return "3801569005883079871";
//      break;
//
//    case 'S_CntcUs_PS_Wireless_Fr':
//      return "3822406823033273255";
//      break;
//
//    case 'S_CntcUs_PS_WirelessEmp':
//      return "7130389321285121997";
//      break;
//
//    case 'S_CntcUs_PS_WirelessEmp_Fr':
//      return "1144468366813245110";
//      break;
//
//    case 'S_CntcUs_PS_Internet':
//      return "2156078613061013110";
//      break;
//
//    case 'S_CntcUs_PS_Internet_Fr':
//      return "1193703059412975067";
//      break;
//
//    case 'S_CntcUs_PS_InternetEmp':
//      return "8953373620796929474";
//      break;
//
//    case 'S_CntcUs_PS_InternetEmp_Fr':
//      return "8649562154630917383";
//      break;
//
//    case 'S_CntcUs_PS_TV':
//      return "1318620913233397996";
//      break;
//
//    case 'S_CntcUs_PS_TV_Fr':
//      return "8408507292058769473";
//      break;
//
//    case 'S_CntcUs_PS_TVEmp':
//      return "979207159770694939";
//      break;
//
//    case 'S_CntcUs_PS_TVEmp_Fr':
//      return "1601343713476358202";
//      break;
//
//    case 'S_CntcUs_PS_HP':
//      return "6011424174940066469";
//      break;
//
//    case 'S_CntcUs_PS_HP_Fr':
//      return "7870835312834982664";
//      break;
//
//    case 'S_CntcUs_PS_HPEmp':
//      return "1045169286821860725";
//      break;
//
//    case 'S_CntcUs_PS_HPEmp_Fr':
//      return "741292883460108677";
//      break;
//
//    case 'S_CntcUs_PS_AddS_NHL':
//      return "8648269455424510337";
//      break;
//
//    case 'S_CntcUs_PS_AddS_NHL_Fr':
//      return "8763639113138592937";
//      break;
//
//    case 'S_CntcUs_PS_AddS_Shomi':
//      return "1624147444816678043";
//      break;
//
//    case 'S_CntcUs_PS_AddS_Shomi_Fr':
//      return "363803962613734620";
//      break;
//
//    case 'S_CntcUs_BilAcc_Wireless_Bill':
//      return "1873164024487527606";
//      break;
//
//    case 'S_CntcUs_BilAcc_Wireless_Bill_Fr':
//      return "138222616261692926";
//      break;
//
//    case 'S_CntcUs_BilAcc_Wless_BillEmp':
//      return "7047855332780829328";
//      break;
//
//    case 'S_CntcUs_BilAcc_WlessBilEmp_Fr':
//      return "1188089455782632981";
//      break;
//
//    case 'S_CntcUs_BilAcc_IntTvHP_Bill':
//      return "5013481551209628364";
//      break;
//
//    case 'S_CntcUs_BilAcc_IntTvHPBill_Fr':
//      return "3370562316937153879";
//      break;
//
//    case 'S_CntcUs_BilAcc_IntTvHP_BilEmp':
//      return "4337916732966199633";
//      break;
//
//    case 'S_CntcUsBilAccIntTvHPBilEmp_Fr':
//      return "3301169890868209348";
//      break;
//
//    case 'S_CntcUs_BilAcc_Payment_Emp':
//      return "6037651043877426032";
//      break;
//
//    case 'S_CntcUs_BilAcc_Payment_Emp_Fr':
//      return "4728669162409737009";
//      break;
//
//    case 'S_CntcUs_BilAcc_HmMntrBill_Emp':
//      return "5972707688453277373";
//      break;
//
//    case 'S_CntcUs_BilAcc_HmMntrBilEmp_Fr':
//      return "603364043310207967";
//      break;
//
//    case 'S_CntcUs_BilAcc_AccMyRogers':
//      return "5399991815794377863";
//      break;
//
//    case 'S_CntcUs_BilAcc_AccMyRogers_Fr':
//      return "5945102685081370989";
//      break;
//
//    case 'S_CntcUs_BilAcc_MyRog_PssReset':
//      return "8876247618836546584";
//      break;
//
//    case 'S_CntcUs_BilAcc_MyRogPssRst_Fr':
//      return "9106066518575754811";
//      break;
//
//    case 'S_CntcUs_BilAcc_AccMyRogersEmp':
//      return "7984465600136385280";
//      break;
//
//    case 'S_CntcUs_BilAcc_AccMyRogEmp_Fr':
//      return "2979596121111347766";
//      break;
//
//    case 'S_CntcUs_BilAcc_AccMyRogersNHL':
//      return "6116936857585851785";
//      break;
//
//    case 'S_CntcUs_BilAccMyRogersNHL_Fr':
//      return "4404249665335242887";
//      break;
//
//    case 'S_MRog_Wless_ChngeWlessNum':
//      return "8251508524517584025";
//      break;
//
//    case 'S_MRog_Wless_ChngeWlessNum_Fr':
//      return "6972899541556028612";
//      break;
//
//    case 'S_MRog_Wless_ChngeWlessPln':
//      return "962628647549976923";
//      break;
//
//    case 'S_MRog_Wless_ChngeWlessPln_Fr':
//      return "5251011568633294101";
//      break;
//
//    case 'S_MRog_Wless_MngeAddOns':
//      return "8316015276722236261";
//      break;
//
//    case 'S_MRog_Wless_MngeAddOns_Fr':
//      return "6620724583008669878";
//      break;
//
//    case 'S_MRog_Wless_DeviceBalance':
//      return "3561448384483070281";
//      break;
//
//    case 'S_MRog_Wless_DeviceBalance_Fr':
//      return "1010276458461763387";
//      break;
//
//    case 'S_MRog_Wless_Abandon':
//      return "2530287557791514352";
//      break;
//
//    case 'S_MRog_Wless_Abandon_Fr':
//      return "4663075453219159263";
//      break;
//
//    case 'S_MRog_HP_ChngPlan_MngFhrs':
//      return "2703368099468244474";
//      break;
//
//    case 'S_MRog_HP_ChngPlan_MngFhrs_Fr':
//      return "4651541516756588337";
//      break;
//
//    case 'S_MRog_Inet_ChngModem':
//      return "3667015499192944585";
//      break;
//
//    case 'S_MRog_Inet_ChngModem_Fr':
//      return "772103079919310258";
//      break;
//
//    case 'S_MRog_Bill':
//      return "4528950811991094020";
//      break;
//
//    case 'S_MRog_Bill_Wireless_Dtls':
//      return "4586667184790302225";
//      break;
//
//    case 'S_MRog_Bill_Wireless_Dtls_Fr':
//      return "2248541290750049100";
//      break;
//
//    case 'S_MRog_Bill_Internet_Dtls':
//      return "1253585851869852792";
//      break;
//
//    case 'S_MRog_Bill_Internet_Dtls_Fr':
//      return "1547767808348187396";
//      break;
//
//    case 'S_MRog_Bill_TV_Dtls':
//      return "6279240212232817068";
//      break;
//
//    case 'S_MRog_Bill_TV_Dtls_Fr':
//      return "7890396200422553182";
//      break;
//
//    case 'S_MRog_Bill_HP_Dtls':
//      return "3427119948344897372";
//      break;
//
//    case 'S_MRog_Bill_HP_Dtls_Fr':
//      return "6005269858225677967";
//      break;
//
//    case 'S_MRog_Payment':
//      return "665184061551117368";
//      break;
//
//    case 'S_MRog_Payment_Fr':
//      return "2583238065497468288";
//      break;
//
//    case 'S_MRog_ChangeMthdPayment':
//      return "6111361863257405927";
//      break;
//
//    case 'S_MRog_ChangeMthdPayment_Fr':
//      return "671266053404953609";
//      break;
//
//    case 'S_Login':
//      return "4955115678252034675";
//      break;
//
//    case 'S_Login_Fr':
//      return "6977903328363873662";
//      break;
//
//    case 'S_ForgotUNamePass':
//      return "1980653395874932257";
//      break;
//
//    case 'S_ForgotUNamePassRegIssues_Fr':
//      return "7216878723649272124";
//      break;
//
//    case 'S_RegistrationIssues':
//      return "6404235957168908537";
//      break;
//
//    case 'S_RegistrationIssues_Fr':
//      return "5024179705330489307";
//      break;
//
//    case 'S_Shomi':
//      return "2523137463999057497";
//      break;
//
//    case 'S_Shomi_Register':
//      return "4165278287947040812";
//      break;
//
//    case 'S_Shomi_Register_Fr':
//      return "2154915186126606424";
//      break;
//
//    case 'S_Shomi_Signin':
//      return "3040312142259657015";
//      break;
//
//    case 'S_Shomi_Signin_Fr':
//      return "8755774774888018008";
//      break;
//
//    case 'S_Shomi_Fr':
//      return "4106739710779425105";
//      break;
//
//    case 'S_Rewards':
//      return "773978601849316994";
//      break;
//
//    case 'S_Rewards_Fr':
//      return "1594767690239617782";
//      break;
//
//    case 'S_GameCentreLive':
//      return "72671795779610022";
//      break;
//
//    case 'S_GameCentreLive_Fr':
//      return "4554408542084795679";
//      break;
//
//    case 'S_RogersOneNumber':
//      return "862552668694335087";
//      break;
//
//    case 'S_RogersOneNumber_Fr':
//      return "4894878169532002508";
//      break;
//
//    case 'S_CntcUs_BilAcc_HmMntrMoving':
//      return "6236750630446345963";
//      break;
//
//    case 'S_CntcUs_BilAccPayPassDue':
//      return "5013697481432342420";
//      break;
//
//    case 'S_CntcUs_BilAccPayPassDue_Fr':
//      return "7177267514618002952";
//      break;
//
//    case 'S_TechSupp_AddS_GameCtr':
//      return "4087774117795298143";
//      break;
//
//    case 'S_TechSupp_AddS_GameCtr_FR':
//      return "3010807345891119135";
//      break;
//
//    case 'S_TechSupp_AddS_Shomi':
//      return "4011707845566981985";
//      break;
//
//    case 'S_TechSupp_AddS_Shomi_Fr':
//      return "5363849917388921286";
//      break;
//
//    case 'S_MyRog_DU_NeedHelp':
//      return "44317674469100111";
//      break;
//
//    case 'S_MyRog_DU_NeedHelp_Fr':
//      return "4458918666694077583";
//      break;
//
//    case 'S_MyRog_DU_OrderSumm':
//      return "794025814726147935";
//      break;
//
//    case 'S_MyRog_DU_OrderSumm_Fr':
//      return "6875635062704963121";
//      break;
//
//    case 'S_MyRog_DU_OWayTBuy':
//      return "6344985087914101285";
//      break;
//
//    case 'S_MyRog_DU_OWayTBuy_Fr':
//      return "5000747709561616443";
//      break;
//
//    case 'S_Shop_AddOnPhn_Travel':
//      return "1745558961540732128";
//      break;
//
//    case 'S_Shop_AddOnPhn_Travel_Fr':
//      return "3048055132012479026";
//      break;
//
//    case 'S_Shop_AddOnPhn_ValuePacks':
//      return "14011024926426051";
//      break;
//
//    case 'S_Shop_AddOnPhn_ValuePacks_Fr':
//      return "4778305021228505990";
//      break;
//
//    case 'S_Shop_AddOnPhn_LngDist':
//      return "5139622034447538798";
//      break;
//
//    case 'S_Shop_AddOnPhn_LngDist_Fr':
//      return "4537220284323447679";
//      break;
//
//    case 'S_Shop_AddOnPhn_LngDist_ContactUs':
//      return "5958055962619059071";
//      break;
//
//    case 'S_MyRog_DU_ChatWithUs':
//      return "7450724813319350634";
//      break;
//
//    case 'S_MyRog_DU_ChatWithUs_Fr':
//      return "7557639262318080384";
//      break;
//
//    case 'S_Rog_FAQ':
//      return "4436349636589009529";
//      break;
//
//    case 'S_Rog_FAQ_Fr':
//      return "904276293238758522";
//      break;
//
//    case 'S_RegistrationLinkAcc':
//      return "7711140152690543536";
//      break;
//
//    case 'S_RegistrationLinkAcc_Fr':
//      return "3695186184019028146";
//      break;
//
//    case 'S_BillPay_ChngMethdInv':
//      return "2351641826281581391";
//      break;
//
//    case 'S_BillPay_ChngMethdInv_Fr':
//      return "2019101189923874755";
//      break;
//
//    case 'S_MyRog_SuspAcc':
//      return "6936296296747044182";
//      break;
//
//    case 'S_MRog_Wless_ChngePlnPpc':
//      return "4087774117795298143";
//      break;
//
//    case 'S_MRog_Wless_ChngePlnPpc_Fr':
//      return "1045169286821860725";
//      break;
//
//    case 'S_RogAccessibility':
//      return "7984465600136385280";
//      break;
//
//    case 'S_RogAccessibility_Fr':
//      return "2979596121111347766";
//      break;
//
//    case 'S_RogAcc_CntctViaRog':
//      return "8953373620796929474";
//      break;
//
//    case 'S_RogAcc_CntctViaRog_Fr':
//      return "8649562154630917383";
//      break;
//
//    case 'S_RogAccessibilityTextMsg':
//      return "4194880448908017487";
//      break;
//
//    case 'S_Shop_Wireless_PlnBldrExitCx':
//      return "4062312069031467099";
//      break;
//
//
//// Dummy Bdids
//    case 'S_Shop_Wireless_PlnBldr1_Fr':
//      return "8169041807613897395";
//      break;
//
//    case 'S_Shop_Wireless_PlnBldr3_Fr':
//      return "2694660086530699445";
//      break;
//
//    case 'S_Shop_Wireless_PlnBldrExitCx_Fr':
//      return "4062312069031467099";
//      break;
//
//    case 'S_Shop_Wireless_Device_Catalogue_AAL_Fr':
//      return "8396530394401574297";
//      break;
//
//
//
//
////floating chat button
//
//    case 'F_Shop_Wireless_iPad':
//      return "7363801668475377006";
//      break;
//
//    case 'F_Shop_Wireless_Mobile_Int':
//      return "4888321989022180968";
//      break;
//
//    case 'F_Shop_Wireless_Accessories':
//      return "6741175951778429975";
//      break;
//
//    case 'F_Shop_Wireless_Handset_Protect':
//      return "5949136864557003812";
//      break;
//
//    case 'F_Shop_Wireless_Network_Coverage':
//      return "2575889983138109961";
//      break;
//
//    case 'F_Shop_Wireless_iPhones':
//      return "175745308438066808";
//      break;
//
//    case 'F_Shop_Wireless_Androids':
//      return "7458449283024857079";
//      break;
//
//    case 'F_Shop_Wireless_Windows_Phones':
//      return "8140662307593694134";
//      break;
//
//    case 'F_Shop_Wireless_Blackberry':
//      return "2184031719165856284";
//      break;
//
//    case 'F_Shop_Internet_Premium_Sup':
//      return "6599168198146598889";
//      break;
//
//    case 'F_Shop_TV_Landing':
//      return "1572115511622229472";
//      break;
//
//    case 'F_Shop_TV_Channels':
//      return "4887079811422773731";
//      break;
//
//    case 'F_Shop_TV_Theme_Packs':
//      return "3600915913255314022";
//      break;
//
//    case 'F_Shop_TV_Hardware':
//      return "5195368372516649063";
//      break;
//
//    case 'F_Shop_TV_On_Demand':
//      return "3098088513753114490";
//      break;
//
//    case 'F_Shop_TV_PPV':
//      return "7390910286865003161";
//      break;
//
//    case 'F_Shop_HP_Features':
//      return "616585721327248464";
//      break;
//
//    case 'F_Shop_HP_Long_Distance':
//      return "3909718640455807349";
//      break;
//
//    case 'F_Shop_Bundles_Cart':
//      return "3671376214442456558";
//      break;
//
//    case 'F_Shop_Wireless_Device_Catalogue':
//      return "8234245246972710832";
//      break;
//
//    case 'F_Shop_AddOnPhn':
//      return "2549540590052295310";
//      break;
//
//    case 'F_Shop_AddOnPhn_Fr':
//      return "8941639429810403644";
//      break;
//
//  }
//}
//
//
//

/* jshint -W117 */

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * Example: <bold-chat-static-button data-cbid="{{'ute.rogers.myrPaymentHelper.boldChatButtonId' | translate}}"
   data-dynamic-div="{{'ute.rogers.myrPaymentHelper.boldChatButtonDiv' | translate}}"
   data-chat-button="{{'ute.rogers.myrPaymentHelper.boldChatButton' | translate}}"></bold-chat-static-button>
   */
  angular.module('ute.common.component.directives').directive('boldChatStaticButton', BoldChatStaticButton);

  BoldChatStaticButton.$inject = ['$interpolate'];

  function BoldChatStaticButton($interpolate) {

    return {
      templateUrl: 'module/boldChat/boldChatStaticButton.html',
      replace: true,
      restrict: 'EA',
      scope: {
        //cbid: '=',
        //boldChatDiv: '=dynamicDiv',
        //chatButton: '=',
        //errorMessage: '=errorMessage'
        altText: '='
      },
      link: function (scope, element, attrs) {
        scope.isChatReady = false;

        if (attrs.cbid) {
          scope.cbid = scope.$eval($interpolate(attrs.cbid));
        }
        if (attrs.dynamicDiv) {
          scope.boldChatDiv = scope.$eval($interpolate(attrs.dynamicDiv));
        }
        if (attrs.chatButton) {
          scope.chatButton = scope.$eval($interpolate(attrs.chatButton));
        }
        if (attrs.errorMessage) {
          scope.errorMessage = scope.$eval($interpolate(attrs.errorMessage));
        }
        var watcher = scope.$watch(function () {
            return document.getElementById(scope.boldChatDiv);
          }, function (newValue, oldValue) {
            if (null != newValue) {
              var chatButtonOld = null;
              try {

                //var bdid = getBDId(scope.cbid);
                staticLiveChatButtonUTE(getBoldChatButtonId(scope.cbid), scope.boldChatDiv, scope.chatButton, chatButtonOld, scope.errorMessage, scope.altText);
              } catch (e) {
              }
            }
            watcher();
          }
        );

        attrs.$observe('cbid', function (value) {
          /**
           * Run the following code only when the chat markup is ready
           */
          if (scope.isChatReady) {
            staticLiveChatButtonUTE(getBoldChatButtonId(value), scope.boldChatDiv, scope.boldChatDiv, scope.chatButton, scope.errorMessage, scope.altText);
          }
        });

        scope.$watch('chatButton', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            staticLiveChatButtonUTE(getBoldChatButtonId(scope.cbid), scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage, scope.altText);
          }
          scope.isChatReady = true;
        }, true);

        function getBoldChatButtonId(cbid) {
          return /^\d+$/.test(cbid) ? cbid : getBDId(cbid);
        }
      }
    };
  }
})();

/* jshint -W101, -W109, -W033, -W117, -W106, -W014, -W116, -W004 */
// As Is no comments :)

var CxErrorMessage = "";
var aam_uuid = getCookie('aam_uuid');
var marketingCloudID = getCookie('_sdsat_MCID');
var hashedBANCTN = getCookie('aam_dpid942');
var custTrackingid = 'au:' + aam_uuid
  + '||mc:' + marketingCloudID
  + '||hb:' + hashedBANCTN;
var language = getCookie('language');
var VisitorName = "";
var VisitorEmail = "";
var userLogin = "";
var visitorPhone = "";
var selectedAcctNumber = "";
var isLoggedin = false;

function customParams(callbackFunction) {
  var smsession = getCookie('SMSESSION');
  var authorization = getCookie('Authorization');
  isLoggedin = !!authorization || (!!smsession && smsession !== 'LOGGEDOFF');
  if (isLoggedin) {
    if (window.localStorage.accountNumber !== undefined) {
      selectedAcctNumber = window.localStorage.accountNumber;
    }
    if (window.localStorage.fullName !== undefined) {
      VisitorName = window.localStorage.fullName;
    }
    //userLogin = getCookie('pageUserName');
    //console.log("Visitor Name"+VisitorName);
    VisitorEmail = getEmailId();
    if (VisitorEmail === undefined) {
      VisitorEmail = '';
    }
    //start for CTN number
    var ctnNumber = window.localStorage.firstCTN;
    if (ctnNumber !== undefined) {
      visitorPhone = ctnNumber;
    }
    //console.log("CTN number" + visitorPhone);
    //end for CTN number
  }

  callbackFunction();
}

var delStatus = '';

function generateToken(callback) {
  getDelinquentStatus(selectedAcctNumber);
  $.ajax({

    url: '/web/RogersServices.portal/totes/api/v1/getSSOChatDetails',
    //url: "/web/SSOChatEncodeServlet",
    timeout: 50000,
    dataType: 'json',
    type: 'GET',
    success: function (data) {
      var url = data.url;
      var sep = data.sep;
      var sch = data.sch;
      var sck = data.sck;
      getSSO_Token(callback, sep, sch, sck);
    },
    error: function (xhr, err, e) {
      var error = "sso token error"
      callback(error);
    }
  });
}

function getDelinquentStatus(selectedAcctNumber) {
  $.ajax({
    url: '/web/RogersServices.portal/totes/api/v1/delinquentStatus',
    timeout: 50000,
    dataType: 'json',
    type: 'POST',
    data: {
      applicationId: 'Rogers.com',
      accountNumber: selectedAcctNumber
    },
    success: function (data) {
      //console.log("sucess" + data.status);
      delStatus = data.status;
    },
    error: function (xhr, err, e) {
      //console.log("error " + e + err);
      delStatus = "NA";
    }
  });
}

function getQueryVariable(variable, url) {
  var vars = url.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return (false);
}

function getSSO_Token(callback, sep, sch, sck) {
  //var url = "https://safesend.rogers.com/submit-mr_test.php?jsoncallback=?"
  var url = "https://safesend.rogers.com/submit-mr.php?jsoncallback=?"
    + "&sep=" + sep
    + "&sch=" + sch
    + "&sck=" + sck;
  var stk = '';
  $.getJSON(url,
    {
      //tags: "jquery",
      //tagmode: "any",
      //format: "json"
    },
    function (data) {
      ssoToken = data.stk;
      //console.log("Safesend Token :: " + ssoToken);
      callback(ssoToken, delStatus);
    });

}

function getCookie(myCookieName) {
  var allcookies = unescape(document.cookie);
  var cookieArray = allcookies.split(';');
  var cookievalue = '';
  var smCount = 0;

  //to findout of SMSESSION cookie Key count -to handle duplicate  values
  if (myCookieName == "SMSESSION") {
    for (i = 0; i < cookieArray.length; i++) {
      var cookie = cookieArray[i].split('=');
      var name = cookie[0].replace(/\W/g, '');

      if (name == "SMSESSION") {
        smCount++;
      }
    }
  }
  // parse through all cookies and find out if the one requested exists
  for (i = 0; i < cookieArray.length; i++) {
    var cookie = cookieArray[i].split('=');

    var name = cookie[0].replace(/\W/g, '');
    var value = cookie[1];

    if (smCount > 1) {
      if (name == myCookieName && value == "LOGGEDOFF") {
        cookievalue = value;
        break;

      }
    } else {

      if (name == myCookieName) {
        cookievalue = value;
        break;
      }
    }
  }

  return cookievalue;
}

function getEmailId() {
  var encryptedEmailId = getCookie('cbid');
  if (encryptedEmailId) {
    var decryptedEmailId = CryptoJS.AES.decrypt(encryptedEmailId, "BoldChatSecret");
    decryptedEmailId = decryptedEmailId.toString(CryptoJS.enc.Utf8);
    return decryptedEmailId;
  }
}

function checkLoggedin() {
  var smsession = getCookie('SMSESSION');
  if (!!smsession && smsession !== 'LOGGEDOFF') {
    return true;
  } else {
    return false;
  }
}

function secureParams(callback, type) {

  customParams(function () {
    if (window.pageViewer && pageViewer.load) {
      //console.log("custom params if");
      window.pageViewer.setParameter("VisitName", VisitorName);
      window.pageViewer.setParameter("VisitPhone", visitorPhone);
      window.pageViewer.setParameter("VisitEmail", VisitorEmail);
      window.pageViewer.setParameter("VisitRef", language);

    } else {
      //console.log("custom params else");
      _bcvma.push(["setParameter", "VisitName", VisitorName]);
      _bcvma.push(["setParameter", "VisitPhone", visitorPhone]);
      _bcvma.push(["setParameter", "VisitEmail", VisitorEmail]);
      _bcvma.push(["setParameter", "VisitRef", language]);
    }
  });
  // _bcvma.push(["setParameter", "WindowParameters", "customField_CxPageTitle=" + encodeURIComponent(document.title) + "&customField_custtrackingid=" + encodeURIComponent(custTrackingid)]);
  //var customFieldPassThrough = "customField_CxPageTitle&customField_custtrackingid";
  var allVariablesToPassThrough = "Unsecured=" + encodeURIComponent("url&referrer&vn&vr&vi&ve&vp&curl&vicon&oicon&ln&vn&eq&cr&ci&ca&lc&cbdid&cwdid&rdid&roid&ccid&idid&");
  if (type == 'visit' || !isLoggedin) {
    callback(allVariablesToPassThrough + "customField_CxPageTitle=" + encodeURIComponent(document.title) + "&customField_custtrackingid=" + encodeURIComponent(custTrackingid));
  } else {
    generateToken(function (ssoToken, delStatus) {
      callback(allVariablesToPassThrough + "&customField_ssoToken=" + encodeURIComponent(ssoToken) + "&customField_CxLogin=" + userLogin + "&customField_CxAccnt=" + selectedAcctNumber +
        "&customField_CxErrorMessage=" + encodeURIComponent(CxErrorMessage) + "&customField_CxPageTitle=" + encodeURIComponent(document.title) + "&customField_custtrackingid=" + encodeURIComponent(custTrackingid)
        + "&vi=" + delStatus);
    });
  }
}

function setupPageViewer() {
  if (window.pageViewer && pageViewer.load) {
    //console.log("setupPageViewer if ");
    window.pageViewer.check(1, 2);
    window.pageViewer = window._bcvm.getPageViewer();
    window.pageViewer.setAccountID("369303105785976989");
    window.pageViewer.setParameter("WebsiteID", "236757985006933441");
    window.pageViewer.setParameter("SecureParameters", secureParams);
    window.pageViewer.setParameter("VisitName", VisitorName);
    window.pageViewer.setParameter("VisitPhone", visitorPhone);
    window.pageViewer.setParameter("VisitEmail", VisitorEmail);

  } else {
    //console.log("setupPageViewer else");
    _bcvma.push(["setAccountID", "369303105785976989"]);
    _bcvma.push(["setParameter", "WebsiteID", "236757985006933441"]);
    _bcvma.push(["setParameter", "SecureParameters", secureParams]);
    _bcvma.push(["setParameter", "CustomUrl", ""]);
    _bcvma.push(["setParameter", "VisitName", VisitorName]);
    _bcvma.push(["setParameter", "VisitPhone", visitorPhone]);
    _bcvma.push(["setParameter", "VisitEmail", VisitorEmail]);
    _bcvma.push(["setParameter", "VisitRef", language]);

  }
}

function liveChatAltTextUTE(altText, bdidVal, dynamicDiv, chatButton, chatButtonOld, errorDesc) {
  staticLiveChatButtonUTE(bdidVal, dynamicDiv, chatButton, chatButtonOld, errorDesc, altText);
  addAltText(altText, chatButton);
}

function staticLiveChatButtonUTE(bdidVal, dynamicDiv, chatButton, chatButtonOld, errorDesc, altText) {
  removeChatButtons(chatButton);
  removeChatButtons(chatButtonOld);

  var bccbId = Math.random();
  var bdDivVar = document.getElementById(dynamicDiv);
  var childVar = document.createElement("div");
  if (errorDesc !== undefined) {
    CxErrorMessage = errorDesc;
  }
  //console.log("errorDesc="+errorDesc);

  childVar.setAttribute("id", bccbId);
  childVar.setAttribute("class", chatButton);
  if (bdDivVar) {
    bdDivVar.appendChild(childVar);
  }
  setupPageViewer();
  //"5332487309809420106" use this floating bdid for dev testing
  // bdidVal = "1477170511306860658";
  if (window.pageViewer) {
    window.pageViewer.addStatic({type: "chat", bdid: bdidVal, id: bccbId});
    window.pageViewer.pageViewed();
  } else {
    _bcvma.push(["addStatic", {type: "chat", bdid: bdidVal, id: bccbId}]);
  }
  if (altText !== null && altText !== undefined) {
    addAltText(altText, chatButton);
  }
}

function floatingLiveChatButtonUTE(bdidVal, dynamicDiv, chatButton) {
  removeChatButtons('bcFloat');
  setupPageViewer();
  if (window.pageViewer) {
    window.pageViewer.addFloat({type: "chat", id: bdidVal});
    window.pageViewer.pageViewed();
  } else {
    _bcvma.push(["addFloat", {type: "chat", id: bdidVal}]);
  }
}

function removeChatButtons(chatButton) {
  var elements = document.getElementsByClassName(chatButton);
  for (var i = 0; i < elements.length; i++) {
    elements[i].parentElement.removeChild(elements[i]);
  }
}

//Code to place outside the method as fix for SPA page issue
window._bcvma = window._bcvma || [];
_bcvma.push(["setAccountID", "369303105785976989"]);
_bcvma.push(["setParameter", "WebsiteID", "236757985006933441"]);
_bcvma.push(["setParameter", "CustomUrl", ""]);
_bcvma.push(["setParameter", "VisitName", VisitorName]);
_bcvma.push(["setParameter", "VisitPhone", visitorPhone]);
_bcvma.push(["setParameter", "VisitEmail", VisitorEmail]);
_bcvma.push(["setParameter", "VisitRef", language]);
//_bcvma.push(["setParameter", "WindowParameters", "customField_CxPageTitle=" + encodeURIComponent(document.title) + "&customField_custtrackingid=" + encodeURIComponent(custTrackingid)]);
_bcvma.push(["pageViewed"]);


function addAltText(altText, className) {
  var elementName = document.getElementsByClassName(className);
  setTimeout(function () {
    if (elementName != null) {
      for (var i = 0; i < elementName.length; i++) {
        var imageTag = elementName[i].getElementsByTagName('img');
        imageTag[0].setAttribute('alt', altText);
      }
    }
  }, 9000);
}


var bcLoad = function () {
  if (window.bcLoaded) {
    return;
  }
  window.bcLoaded = true;
  var vms = document.createElement("script");
  vms.type = "text/javascript";
  vms.async = true;
  vms.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + "vmss.boldchat.com/aid/369303105785976989/bc.vms4/vms.js";
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(vms, s);
};

if (window.pageViewer && pageViewer.load) {
  pageViewer.load();
} else if (document.readyState == "complete") {
  bcLoad();
} else if (window.addEventListener) {
  window.addEventListener('load', bcLoad, false);
} else {
  window.attachEvent('onload', bcLoad);
}




(function () {
  'use strict';

  angular.module('ute.modules.contentExpand')
    .controller('ContentExpandController', ContentExpandController);

  ContentExpandController.$inject = ['$scope'];

  /* @ngInject */
  function ContentExpandController($scope) {

    var vm = this;

    vm.getBorderBehaviour = getBorder;
    vm.getContentBehaviour = getContentBehaviour;

    function getBorder(){
      return ($scope.isOpen ? 'fadeIn' : 'fadeOut') + ' ' + $scope.borderType;
    }

    function getContentBehaviour(){
      return $scope.isOpen ? 'fadeInDelay' : 'fadeOut';
    }

  }
})();

(function () {
  'use strict';

  angular.module('ute.modules.contentExpand').directive('uteContentExpand', ContentExpand);

  ContentExpand.$inject = [];

  //isOpen accepts boolean
  //borderType accepts strings 'infoBorder' 'warningBorder' 'errorBorder' and none

  /* @ngInject */
  function ContentExpand() {
    return {
      restrict: 'E',
      transclude:true,
      scope:{'isOpen':'=','borderType':'@'},
      templateUrl:'module/contentExpand/contentExpand.template.html',
      controller:'ContentExpandController',
      controllerAs:'ce',
      link: function (scope, element, attr, ngModelCtrl) {}
    };
  }
})();

'use strict';
angular.module('ute.common.oneview.header').directive('cartMenu', cartMenu);
cartMenu.$inject = [];

function cartMenu() {
  return {
    scope: {},
    templateUrl: 'module/cartMenu/cartMenu.html',
    restrict: 'EA',
    controller: 'cartMenuController',
    link: function (scope, element, attrs) {
    }
  };
}

//controller
angular.module('ute.common.oneview.header').controller('cartMenuController', cartMenuController);
cartMenuController.$inject = ['$scope', 'cartMenuService', 'ajax', 'bfappcWirelessDashboardService', 'ute.rogers.account.overview.factory', 'ute.common.permissions.service', '$q', 'ute.common.user.service', 'ute.blocks.persistent.storage.service'];

function cartMenuController($scope, cartMenuService, ajax, bfappcWirelessDashboardService, newAccountOverviewFactory, permissionsService, $q, userService, persistentStorageService) {
  $scope.isDealer = userService.isDealer();
  $scope.isCare = userService.isCare();
  $scope.isConsumer = userService.isConsumer();
  $scope.isRepView = userService.isRepView();
  // No longer used $scope.isRepView = $rootScope.isRepView === 'true';
  if ($scope.isCare || $scope.isDealer) {
    $scope.interactionBRTSwitchName = $scope.isCare ? 'ONEVIEW_INTERACTION_NOTES_CARE' : 'ONEVIEW_INTERACTION_NOTES_DEALER';
  }
  /* OneView no longer has toggle between dealer/care view and customer view
  var watcher = $rootScope.$watch('isRepView', function () {
    $scope.isRepView = $rootScope.isRepView === 'true';
  });
  */
  $scope.loadingImg = false;
  var request = {};
  $scope.permittedShopping = false;
  $scope.consumerCart = true;

  $scope.checkCartIcon = function () {
    if ($scope.isCare || $scope.isDealer) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ShoppingCart, ute.common.permissions.service.RamActionCodes.start).then(function (hasShoppingAccess) {
        $scope.permittedShopping = !!hasShoppingAccess;
      }, function (error) {
      });
    }
  };


  $scope.checkPermission = function () {
    var permissionChecks = [];
    if ($scope.isCare || $scope.isDealer) {
      permissionChecks.push(permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PPCBuyFlow, ute.common.permissions.service.RamActionCodes.start));
      permissionChecks.push(permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.HUPBuyFlow, ute.common.permissions.service.RamActionCodes.start));
      $scope.callPermissionAPI(permissionChecks);
    }
    else {
      $scope.callPermissionAPI();
    }
  };

  $scope.callPermissionAPI = function (permissionChecks) {
    if(permissionChecks) {
      $q.all(permissionChecks).then(function (isPermitted) {
        if (isPermitted.indexOf(true) >= 0) {
          var accountNumber = '';
          if ($scope.isCare) {
            accountNumber = persistentStorageService.getFromSession('accountNumber');
            if (accountNumber) {
              request['ban'] = accountNumber;
              $scope.fetchOrder();
            }
          } else {
              newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewHandler, 'cartMenuController');
              getAccountOverviewData();
           }
        }
      });
    } else {
       newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewHandler, 'cartMenuController');
       getAccountOverviewData();
    }
  };

  function accountOverviewHandler(accountOverview) {
    if (accountOverview) {
      var selectedAccount = accountOverview.getSelectedAccount();
      var selector = {accountNumber: String(selectedAccount.accountNumber)};
      if (selector.accountNumber && (selector.accountNumber != request['ban'])) {
        request['ban'] = selector.accountNumber;
        $scope.fetchOrder();
      }
    }
    return null;
  }

  function getAccountOverviewData() {
    return newAccountOverviewFactory().getAccountOverview().then(accountOverviewHandler)['catch'](function (reason) {
      return console.log('cartMenuController->getAccountOverview->catch:', reason),
        null
    })
  }

  $scope.fetchOrder = function () {
    $scope.loadingImg = true;
    cartMenuService.setFetchCalled(true);
    $scope.content = null;
    bfappcWirelessDashboardService.fetchOrder(request).then(
      function (response) {
        if (response && response.success) {
          $scope.content = response;
          $scope.loadingImg = false;
          bfappcWirelessDashboardService.fetchOrderCompleted = true;
          bfappcWirelessDashboardService.fetchOrderFullResponse = response;
          cartMenuService.setFetchResponse(response);
        } else {
          $scope.loadingImg = false;
        }
      },
      function (error) {
        $scope.loadingImg = false;
      }
    );
  };
  $scope.checkCartIcon();
  $scope.checkPermission();

  // Remove any $rootscope watchers
  /* No more watchers as it is no longer possible to toggle between customer and care/dealer view
  $scope.$on('$destroy', function () {
    watcher();
  });
  */
}

(function(){
 'use strict';
 angular.module('ute.common.oneview.header').service('cartMenuService',cartMenuService);
 cartMenuService.$inject = ['ajax'];

 function cartMenuService(ajax) {
   var self = {
     fetchOrderCalled : false,
     fetchOrderResponse : ''
   };
   self.fetchOrder = function(postData) {
     return ajax.fetchCartOrder(postData);
   }
   self.saveState = function(postData) {
     return ajax.saveState(postData);
   }
   self.fetchValidatedCart = function(postData) {
     return ajax.fetchValidatedCart(postData);
   }
   self.validateOrder = function() {
     return ajax.validateOrder();
   }
   self.isFetchOrderCalled = function () {
     return self.fetchOrderCalled;
   };
   self.setFetchResponse = function(response) {
     self.fetchOrderResponse = response;
   }
   self.getFetchResponse = function() {
     return self.fetchOrderResponse;
   }
   self.setFetchCalled = function(value) {
     self.fetchOrderCalled = value;
   }
   self.agentInfo = function() {
     return ajax.agentInfo();
   }
   return {
     'fetchOrder': self.fetchOrder,
     'saveState': self.saveState,
     'fetchValidatedCart': self.fetchValidatedCart,
     'validateOrder': self.validateOrder,
     'isFetchOrderCalled': self.isFetchOrderCalled,
     'setFetchResponse' : self.setFetchResponse,
     'getFetchResponse' : self.getFetchResponse,
     'setFetchCalled': self.setFetchCalled,
     'agentInfo':self.agentInfo
   };
 }
})
();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
'use strict';
 angular.module('ute.common.oneview.header').directive('consumerCartMenu', consumerCartMenu);
 consumerCartMenu.$inject = [];

  /* @ngInject */
  function consumerCartMenu() {
    return {
      scope: {
       'content' : '='
      },
      templateUrl: 'module/cartMenu/consumerCartMenu.html',
      restrict: 'EA',
      controller: 'consumerCartMenuController'
    };
  }

 //controller
 angular.module('ute.common.oneview.header').controller('consumerCartMenuController', consumerCartMenuController);
 consumerCartMenuController.$inject = ['$scope',
    'cartMenuService',
    '$location',
    '$rootScope',
    'localStorage',
    'sessionStorage',
    'settingsHeader',
    'backToSSPService',
    'bfappcWirelessDashboardService',
    '$state',
    'ngDialog',
    'ajax',
    '$modal',
    '$window',
    '$translate',
    'ute.common.user.service',
    'ute.common.permissions.service',
    'ute.blocks.persistent.storage.service',
    'ute.dtm.service'
  ];

  /* @ngInject */
  function consumerCartMenuController($scope, // jshint ignore:line
                                      cartMenuService,
                                      $location,
                                      $rootScope,
                                      localStorage,
                                      sessionStorage,
                                      settings,
                                      backToSSPService,
                                      bfappcWirelessDashboardService,
                                      $state,
                                      ngDialog,
                                      ajax,
                                      $modal,
                                      $window,
                                      $translate,
                                      userService,
                                      permissionsService,
                                      utePersistentStorageService,
                                      dtmService) {

   $scope.orders = [];
   $scope.quotes = [];
   $scope.isDealer = $rootScope.isDealer;
   $scope.isCare = $rootScope.isCare;
   $scope.isConsumer = $rootScope.isConsumer;
   $scope.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;
   $scope.permissionsObj = {};
   $scope.isHupFlowProcessSaved = false;
   $scope.isFetchOrderCompleted = bfappcWirelessDashboardService.isFetchOrderCompleted;
   $scope.clickedOrder = '';
   var wirelessDashPopup = {
       template: 'module/views/directives/hup/deviceBalance/wirelessDashPopup.html',
       scope: $scope,
       className: 'ngdialog-theme-default',
       showClose: true,
       appendTo: 'div[ui-view]',
       closeByDocument: true
   };
   ajax.getPermissions().then(function (data) {
     $scope.permissionsObj = data;
   });
   var scopewatch1 = $scope.$watchGroup(['isFetchOrderCompleted()', 'permissionsObj'], function (newValue, oldValue) {
       $scope.isHupFlowProcessSaved = !!(newValue !== oldValue && !_.isEmpty($scope.permissionsObj) &&
       newValue[0] && !_.isUndefined(bfappcWirelessDashboardService.getFetchOrderFullResponse().hup) &&
       bfappcWirelessDashboardService.getFetchOrderFullResponse().hup.length > 0 && isCtnHasSavedCart());
   });

   var ctn = '';
   var ban = '';
   var accountTypeNo = '';

  // ban = localStorage.getLocalStorageValue('accountNumber');

   function init() {
     $scope.ordersArray = _.flattenDeep(_.filter($scope.content, function (key, value) {
       return value === 'ppc' || value === 'hup' || value === 'nac';
     }));
   }

   function processJSON(){
     //console.log("in process" + JSON.stringify($scope.content))
     $scope.totalOrders = _.size($scope.ordersArray);
     $scope.orders = _.filter($scope.ordersArray,function(key,value){
        return !key.quotation;
     });
     $scope.quotes = _.filter($scope.ordersArray,function(key,value){
        return key.quotation === true;
     });
   }
   //on click of any quote or order
   $scope.redirectToPage = function(activityType,orderId,orderType,contactNo, order){
        localStorage.setLocalStorageValue('phoneNumber',contactNo);
        ctn = localStorage.getLocalStorageValue('phoneNumber');
        ban = localStorage.getLocalStorageValue('accountNumber');
        accountTypeNo = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber');
        utePersistentStorageService.putToSession('order', order ); // BCR-693 Analytics: Send the order data to analytics mainly who saved the quote/order (orderSavedByAgent) like cx or rep
        var saveStatePassJSON = {
          'ctn' : ctn,
          'ban' : ban,
          'activityTypeKey' : activityType,
          'accountTypeNumber' : accountTypeNo
        };
        var fetchValidatedCartPassJSON = {
           'ban' : ban,
           'ctn' : ctn,
           'orderId' : orderId,
           'activityTypeKey' : activityType
        };
        var NFDBrequest = {
                'refresh': false,
                'accountNumber': ban,
                'phoneNumber': ctn,
                'nfdbCaching': true,
                'activityType': activityType
              };
      if (orderType === 'quote') {
           $scope.clickedOrder = orderId;
           cartMenuService.saveState(saveStatePassJSON).then(
             function(response){
                if(response && response.success){
                  cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
                    function(res){
                      if(res && res.success){
                        cartMenuService.validateOrder().then(
                          function(vres){
                            if(vres && vres.success){
                              $scope.clickedOrder = '';
                                if (activityType.toLowerCase() === 'ppc') {
                                $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                              }
                                else if (activityType.toLowerCase() === 'hup') {
                                $window.location.href = '/web/totes/upgrade/#/checkout/review';
                              }
                            }
                          },
                          function(verr){
                            //error in validate Order
                          }
                        );
                      }
                    },
                    function(err){
                      //error in fetchValidatedCart
                    }
                  );
                }
             },
             function(error){
              //error in saveState
             }

           );
        }
        else{
        if (activityType.toLowerCase() === 'ppc') {
            $scope.clickedOrder = orderId;
            openPPC();
        }
        else if(activityType.toLowerCase() === 'ignite'){
            $scope.clickedOrder = orderId;
            dtmService.track('cart-abandonment-ignite-bundle', 'pasv', null);
            $window.location.href = '/web/consumer/ignite-bundles/get-iptv';
        }
        else if (activityType.toLowerCase() === 'hup') {
           $scope.clickedOrder = orderId;
           var hupOrders = bfappcWirelessDashboardService.getHuporderForCtn(ctn);
              var hupActiveOrder = hupOrders[0];
              if(hupActiveOrder && hupActiveOrder.orderSavedStep && hupActiveOrder.orderSavedStep == "orderReview"){
               cartMenuService.saveState(saveStatePassJSON).then(
                    function(response){
                       if(response && response.success){
                         cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
                           function(res){
                             if(res && res.success){
                                var hupOrder = res.hup;
                                var currentHupOrder =getCurrentHupOrder(hupOrder,hupActiveOrder.orderId);
                                var isDeviceValid = true;
                                var isPlanValid = true;
                                var isAddOnValid = true;
                                _.forEach(currentHupOrder[0].cartItems, function (item) {
                                  if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && !item.valid){
                                  isDeviceValid=false;
                                  }
                                  if(item.activityType == 'HUP' && item.itemType == 'planCommerceItem' && !item.valid){
                                    isPlanValid=false;
                                  }
                                  if(item.activityType == 'HUP' && item.itemType == 'addonCommerceItem' && !item.valid){
                                    isAddOnValid=false;
                                  }
                                });
                                if(!isDeviceValid || !isPlanValid || !isAddOnValid){
                                   if(!isPlanValid || !isAddOnValid){
                                     var popupObj = {};
                                     var saveRequest = {
                                      'orderSavedStep' : ''
                                     };
                                     ajax.saveOrder(saveRequest);
                                   }
                                   popupObj.preCloseCallback = function () {
                                     $scope.showChatCallIcon = false;
                                     $scope.showButtons = false;
                                     if(!isDeviceValid){
                                       $window.location.href = '/web/totes/upgrade/#/choose-phone';
                                     }
                                     else{
                                      $window.location.href = '/web/totes/upgrade/#/build-plan';
                                     }
                                   };
                                   $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                                   $scope.showChatCallIcon = true;
                                   $scope.showButtons = true;
                                   openGenericErrorPopup(popupObj);
                                }
                                else{
                               ajax.isNFDBCheck(NFDBrequest).then(
                                 function(nres){
                                 if(!nres.isNFDBExistInd){
                                  cartMenuService.validateOrder().then(
                                   function(vres){
                                     if(vres && vres.success){
                                        if (hupActiveOrder.activityType.toLowerCase() === 'ppc') {
                                         $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                                       }
                                         else if (hupActiveOrder.activityType.toLowerCase() === 'hup') {
                                         $window.location.href = '/web/totes/upgrade/#/checkout/review';
                                       }
                                     }
                                     else{
                                      var popupObj = {};
                                      $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                      $scope.showChatCallIcon = true;
                                      $scope.showButtons = true;
                                      openGenericErrorPopup(popupObj);
                                     }
                                   },
                                   function(verr){
                                      var popupObj = {};
                                      $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                      $scope.showChatCallIcon = true;
                                      $scope.showButtons = true;
                                      openGenericErrorPopup(popupObj);

                                   }
                                 );
                             }
                             else{
                               dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                               notEligibleDeviceUpgrade('NFDB');

                             }
                           },
                           function(nerr){
                             dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                             notEligibleDeviceUpgrade('NFDB');

                           }
                         );
                       }
                       }
                       else{
                         popupObj = {};
                         var hupOrder = res.hup;
                         var currentHupOrder = getCurrentHupOrder(hupOrder,orderId);
                         var isDeviceValid = false;
                         _.forEach(currentHupOrder[0].cartItems, function (item) {
                           if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && item.valid){
                             isDeviceValid=true;
                           }
                         });
                           popupObj.preCloseCallback = function () {
                             $scope.showChatCallIcon = false;
                             $scope.showButtons = false;
                             if(!isDeviceValid){
                               $window.location.href = '/web/totes/upgrade/#/choose-phone';
                              }
                              else{
                              $window.location.href = '/web/totes/upgrade/#/build-plan';
                              }
                           };
                         $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                         $scope.showChatCallIcon = true;
                         $scope.showButtons = true;
                         openGenericErrorPopup(popupObj);
                       }
                    },
                    function(err){
                     var popupObj = {};
                     $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                     $scope.showChatCallIcon = true;
                     $scope.showButtons = true;
                     openGenericErrorPopup(popupObj);
                    }

                  );
               }
               },
               function(error){
                 var popupObj = {};
                 $scope.errorMessage = $translate.instant('generic_error_message');
                 $scope.showChatCallIcon = true;
                 $scope.showButtons = true;
                 openGenericErrorPopup(popupObj);
               }
             );
                 }
                 else{
               openHUP();
               }
           }
        else if (activityType.toLowerCase() === 'nac') {
               $scope.clickedOrder = orderId;
               openNAC(activityType,orderId,orderType,contactNo, order);
           }
        }

    };
    function getCurrentHupOrder (hupOrders,currentOrderID){
      if(hupOrders.length > 0){
        return _.filter(hupOrders, function (order) {
        return order.orderId === currentOrderID;
        });
      }
    }
   //navigate to PPC
    function openPPC() {
      if ($scope.isDealer) {
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
        $scope.deepLinkingModal();
      }
      else {
        //$scope.changeBtnLoading(true);
        var appStateForPPC = {
          ban: '',
          ctn: '',
          accountTypeNumber: '',
          flow: 'PPC',
          eligibilityChecked: 'false',
          availableCreditAmount: 0,
          ctnList: []
        };

        bfappcWirelessDashboardService.gotoBFAPPC(appStateForPPC).then(
          function () {
            //$scope.changeBtnLoading(false);
            $scope.clickedOrder = '';
          },
          function (q2ppcBrtSwitch) {
            // BFA-PPC BRT switch is off
            if (q2ppcBrtSwitch) {
              //if q2PPC itself is on BRT we should only display a msg
              $scope.openChangePlanModal();
            } else {
              $state.go('wireless-plan-change');
            }
            //$scope.changeBtnLoading(false);
            $scope.clickedOrder = '';
          }
        );
      }
    }
   //navigate to HUP
  function openHUP(){
     /* if (!$scope.restoreCartloadingIndicator) {
       $scope.upgradeDeviceObjloadingIndicator = true;
     }
    */
    if (!userService.isSigned()) {
      $location.path('/signin');
      return;
    }
    if ($scope.isDealer) {
      if ($scope.permissionsObj && $scope.permissionsObj.permissions &&
        $scope.permissionsObj.permissions.length !== 0 &&
          _.find($scope.permissionsObj.permissions, {'permission': 'ONEVIEW_HUP'})) {  //todo need refactoring to use permissionsService
        $rootScope.targetFlow = settings.deepLinkStatusCodes.upgradeDevice;
        $scope.deepLinkingModal();
        return;
      }
    }
    if ($scope.isConsumer) {
      var request = {
        refresh: false,
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        phoneNumber: localStorage.getLocalStorageValue('phoneNumber'),
        nfdbCaching: true,
        activityType: 'HUP'
      };
      ajax.isNFDBCheck(request).then(NFDBCheckResolve, NFDBError);
    }
  }

    //navigate to NAC
    ///this is for SEE project
    $scope.nacFlowURL = "/web/totes/wireless/#/choose-phone";
    $scope.nacFlowResumeURL = "/web/totes/wireless/#/checkout/cart-summary";

    function openNAC(activityType,orderId,orderType,contactNo, order) {
      //$window.location.href = '/web/totes/new-wireless-line/#/choose-phone';
      //Redirected to cart-summary page according to story BFA-6968
      // IF SEE_UTE true check for permission else redirect to cart-summary page
      if(order && !order.ban){
        bfappcWirelessDashboardService.openSomethingWentWrongPopup();
        return;
      }
      localStorage.setLocalStorageValue('accountNumber', order.ban);
      var checkForNACSavedCartRequest = {
        ban: order.ban,
        ctn: order.assemblyIds ? order.assemblyIds.join(',') : "",
        orderId: orderId,
        activityTypeKey: 'NAC',
        existingLinesCount: ""
      };
      /*ajax.getBrtSwitches().then(function(data){
        var isBrtOn = !!_.find(data, function (item) {return item.id === 'SEE_UTE' && item.switchIsOn === true;});
        if(isBrtOn){
          permissionsService.getUserPermission('SEE_UTE_PAGE_VIEW').then(function (isPermitted) {
            if(isPermitted){
              checkForNACSavedCart(checkForNACSavedCartRequest);
            }else{
              $window.location.href = '/web/totes/new-wireless-line/#/choose-phone';
            }
          });
        }else{
           checkForNACSavedCart(checkForNACSavedCartRequest);
         }
      });*/
      checkForNACSavedCart(checkForNACSavedCartRequest);
    }

    function checkForNACSavedCart(checkForNACSavedCartRequest){
      var nacOrder =  bfappcWirelessDashboardService.getFetchOrderFullResponse().nac;
      if(!_.isUndefined(nacOrder) && nacOrder.length){
        cartMenuService.fetchValidatedCart(checkForNACSavedCartRequest).then(function(cartResponse){
          if(cartResponse){
            if(cartResponse.errorCode == "50006"){//Main line invalid
              showNacInvalidCartPopup();
            }else if(cartResponse.errorCode == "50007"){//additional Line Invalid
              showNacInvalidCartPopup(cartResponse.errorCode);
            }else if(cartResponse.success && !!_.find(cartResponse.nac,{'orderId': checkForNACSavedCartRequest.orderId})){//cart valid
              //below line is to prevent resume flow block for individual line AAl
              ajax.nacSaveState({key: 'NEW_WRLS_INFO',clearSession:true,});//fire and forget

              ajax.nacSaveState({
                key: 'NEW_MULTI_WRLS_INFO',
                isDeeplink: false,
                isIndividual: false,
                clearSession:true,
                nacSessionList: []
              }).then(function(){
                $window.location.href = $scope.nacFlowResumeURL;
              }).catch(function(){
                $window.location.href = $scope.nacFlowResumeURL;
              });
            }else{
              showNacInvalidCartPopup();
            }
          }else{
            showNacInvalidCartPopup();
          }
        },function(){
          showNacInvalidCartPopup();
        })
      }else{
        showNacInvalidCartPopup();
      }
    }

    function showNacInvalidCartPopup(errorCode){
      var popupObj = {};
      $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
      $scope.showChatCallIcon = true;
      $scope.showButtons = true;
      $scope.nacSaveStateRequest = {
        key: 'NEW_MULTI_WRLS_INFO',
        isDeeplink: errorCode && errorCode == "5007" ? false : true,
        isIndividual: false,
        clearSession:true,
        nacSessionList: []
      };
      popupObj.preCloseCallback = function () {
        $scope.showChatCallIcon = false;
        $scope.showButtons = false;
        ajax.nacSaveState($scope.nacSaveStateRequest).then(function(){
           if($scope.nacSaveStateRequest.isDeeplink == true){
            $window.location.href = $scope.nacFlowURL;
           }else{
            $window.location.href = $scope.nacFlowResumeURL;
           }
        }).catch(function(){
          if($scope.nacSaveStateRequest.isDeeplink == true){
            $window.location.href = $scope.nacFlowURL;
          }else{
            $window.location.href = $scope.nacFlowResumeURL;
          }
        });
      };
      openGenericErrorPopup(popupObj);
    }

    function NFDBError(error) {
      notEligibleDeviceUpgrade();
   }
   function NFDBCheckResolve(data) {
      if (angular.isDefined(data) && data.isNFDBExistInd) {
       notEligibleDeviceUpgrade();
       return;
     }
     var request = {
       refresh: false,
       accountNumber: localStorage.getLocalStorageValue('accountNumber'),
       phoneNumber: localStorage.getLocalStorageValue('phoneNumber'),
       nfdbCaching: true,
       activityType: 'HUP'
     };
     ajax.checkHupEligibility(request).then(checkHupEligibilityResolve, checkHupEligibilityError);
   }

   function notEligibleDeviceUpgrade(errorCode) {
     $scope.hupDetails = {};
     $scope.hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
     if ($scope.isCare || $scope.isDealer) {
      $scope.hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message_care');
     }
     $scope.hupDetails.contactNumber = $translate.instant('toll-free-number');
     //$scope.upgradeDeviceObjloadingIndicator = false;
     $scope.clickedOrder = '';
     $scope.restoreCartloadingIndicator = false;
      if (errorCode && errorCode === 'HNA') {
       $scope.hupDetails.errorMessage = $translate.instant('hna_error_message');
       $scope.hupDetails.contactNumber = $translate.instant('hna_contact_number');
     }
     wirelessDashPopup.scope = $scope;
     ngDialog.open(wirelessDashPopup);
   }

   function checkHupEligibilityResolve(data) {
      if (data == null || data.isHupEligibilityError || (data.hupErrorCode && data.hupErrorCode === 'HNA')) {
       notEligibleDeviceUpgrade(data.hupErrorCode);
       return;
     }
     if ($scope.isHupFlowProcessSaved) {
       checkForSavedCart();
     } else {
       hupSaveState(function (data) {
         $window.location.href = '/web/totes/upgrade/#/choose-phone';
       });
     }
   }

   function checkHupEligibilityError(error) {
     notEligibleDeviceUpgrade();
   }

   function isCtnHasSavedCart() {
     var savedCartObj = bfappcWirelessDashboardService.getFetchOrderFullResponse().hup;
     var ctnHasSavedCart = false;
     if (savedCartObj && savedCartObj.length > 0) {
       angular.forEach(savedCartObj, function (value, index) {
         if (_.contains(value.assemblyIds, localStorage.getLocalStorageValue('phoneNumber'))) {
           ctnHasSavedCart = true;
         }
       });
     } else {
       ctnHasSavedCart = false;
     }
     return ctnHasSavedCart;
   }

   $scope.wirelessDashPopupclose = function () {
      ngDialog.close();
   };

   function checkForSavedCart() {
     var request = {
       'key': 'cartDetails',
       'context': {
         'ctn': localStorage.getLocalStorageValue('phoneNumber'),
         'ban': localStorage.getLocalStorageValue('accountNumber')
       }
     };
     var popupObj = {};
     ajax.hupGetState(request).then(function (data) {
       if (data && data.success && !data.errorMessage) {
         if ((data.phone && !data.phone.valid) || (data.plan && !data.plan.valid) || (data.addons && !data.addons.valid)) {
           popupObj = {};
           $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
           $scope.showChatCallIcon = true;
           $scope.showButtons = true;
           popupObj.preCloseCallback = function () {
             $scope.showChatCallIcon = false;
             $scope.showButtons = false;
             hupSaveState(function (data) {
               if (data.phone && data.phone.valid) {
                 $window.location.href = '/web/totes/upgrade/#/build-plan';
               } else {
                 $window.location.href = '/web/totes/upgrade/#/choose-phone';
               }
             });
           };
           openGenericErrorPopup(popupObj);
         } else if (data.phone && data.phone.valid) {
           hupSaveState(function () {
             $window.location.href = '/web/totes/upgrade/#/build-plan';
           });
         } else {
           hupSaveState(function () {
             $window.location.href = '/web/totes/upgrade/#/choose-phone';
           });
         }
       } else {
         popupObj = {};
         $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
         $scope.showChatCallIcon = true;
         $scope.showButtons = true;
         popupObj.preCloseCallback = function () {
           $scope.showChatCallIcon = false;
           $scope.showButtons = false;
           hupSaveState(function (data) {
             if (data.phone && data.phone.valid) {
               $window.location.href = '/web/totes/upgrade/#/build-plan';
             } else {
               $window.location.href = '/web/totes/upgrade/#/choose-phone';
             }
           });
         };
         openGenericErrorPopup(popupObj);
       }
     }, function (error) {
       showGenericErrorMessage(true);
     });
   }

   function openGenericErrorPopup(obj) {
     var genericErrorPopup = {
       template: (obj.template) ? obj.template : 'module/views/genericErrorPopup.html',
       scope: (obj.scope) ? obj.scope : $scope,
       className: (obj.className) ? obj.className : 'generic-error-theme ngdialog-theme-default',
       showClose: (obj.showClose) ? obj.showClose : true,
         appendTo: (obj.appendTo) ? obj.appendTo : 'div[ui-view]',
         closeByDocument: (obj.closeByDocument) ? obj.closeByDocument : false,
         preCloseCallback: (obj.preCloseCallback) ? obj.preCloseCallback : function () {

         }
     };
       $scope.restoreCartloadingIndicator = false;
       ngDialog.open(genericErrorPopup);
   }

      $scope.closeGenericErrorPopup = function () {
          ngDialog.close();
      };

      function showGenericErrorMessage(redirecToDeviceCatalog) {
          var popupObj = {};
          $scope.errorMessage = $translate.instant('generic_error_message');
          if (redirecToDeviceCatalog) {
              popupObj.preCloseCallback = function () {
                  hupSaveState(function (data) {
                      $window.location.href = '/web/totes/upgrade/#/choose-phone';
                  });
              };
     }
     openGenericErrorPopup(popupObj);
   }
   function hupSaveState(successCallback, errorCallback) {
     var request = {
       'key': 'hupState',
       'context': {
         'ctn': localStorage.getLocalStorageValue('phoneNumber'),
         'ban': localStorage.getLocalStorageValue('accountNumber')
       }
     };
     ajax.hupSaveState(request).then(function (data) {
       if (successCallback) {
         successCallback(data);
       }
     }, function (error) {
       if (errorCallback) {
         errorCallback(error);
       } else if (successCallback) {
         successCallback(error);
       }
     });
   }

   $scope.deepLinkingModal = function (size) {
     var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
     ajax.getUserPreference(userId).then(
         function (data) {
             if (data && Object.keys(data).length > 0 && _.some(data.userPreference, {"name": "displayMovingToSSPPopUp"})) {
                var userPreferenceObject  = _.find(data.userPreference, function(obj) {
                         return obj.name === 'displayMovingToSSPPopUp';
                });
                if (!userPreferenceObject.value) {
                 backToSSPService.backToSSP();
                } else {
                 $scope.showDeepLinkPopUp(size);
                }
             } else {
             $scope.showDeepLinkPopUp(size);
           }
         }, function (error) {
           $scope.showDeepLinkPopUp(size);
         });
   };
   $scope.showDeepLinkPopUp = function (size) {
     $modal.open({
       templateUrl: 'module/views/modals/deepLinkModal.html',
       controller: 'deepLinkModalCtrl',
       controllerAs: 'vm',
       size: size,
       backdrop: false,
       resolve: {}
     });
   };
   $scope.openChangePlanModal = function (size) {
     $modal.open({
       templateUrl: 'module/views/modals/wirelessRemovePlan.html',
       controller: 'wirelessRemoveModalCtrl',
       size: size,
       backdrop: false,
       resolve: {}
     });
   };

   //filter orders based on the selected ctn
   $rootScope.$on('$stateChangeStart', function (evt, toState) {
      processJSON(); // to update deleted item in $scope.orders and $scope.quotes variable
      if (toState.name === 'wireless') {
        ctn = localStorage.getLocalStorageValue('phoneNumber');
        processJSONForSelectedCTN(ctn);
      }
   });

   function processJSONForSelectedCTN(selectedCtn){
      $scope.orders = _.filter($scope.orders,function(key,value){
          return _.indexOf(key.assemblyIds,selectedCtn) >= 0;
      });
      $scope.quotes = _.filter($scope.quotes,function(key,value){
          return _.indexOf(key.assemblyIds,selectedCtn) >= 0;
      });
      $scope.totalOrders = _.size($scope.orders) + _.size($scope.quotes);
   }

   $scope.cancelOrder = function(event, id) {
      event.stopPropagation();
      $scope.clickedOrder = id;
      var postData = {
        "currentOrderId": id
      };
      ajax.cancelOrder(postData).then(function() {
        $scope.ordersArray = _.filter($scope.ordersArray, function(value, key) {
            return value.orderId !== id;
        });
        $state.reload();
      });
   };

   init();
   processJSON();

    //n Remove any watchers
  $scope.$on('$destroy', function () {
    scopewatch1();
  });

 }
}());

'use strict';
 angular.module('ute.common.oneview.header').directive('repCartMenu', repCartMenu);
  repCartMenu.$inject = [];
  function repCartMenu() {
    return {
      scope: {
       'content' : '='
      },
      templateUrl: 'module/cartMenu/repCartMenu.html',
      restrict: 'EA',
      controller: 'repCartMenuController'
    };
  }

 //controller
 angular.module('ute.common.oneview.header').controller('repCartMenuController', repCartMenuController);
 repCartMenuController.$inject = ['$q','$scope','cartMenuService','$location','localStorage','sessionStorage','$window','ute.capture.dealer.code.service','$modal','bfappcWirelessDashboardService','ute.common.permissions.service', 'ajax', '$state', 'ute.blocks.persistent.storage.service','ute.common.user.service'];

 function repCartMenuController($q,$scope,cartMenuService,$location,localStorage,sessionStorage,$window,captureDealerCodeService,$modal,bfappcWirelessDashboardService,permissionsService, ajax, $state, utePersistentStorageService,userService) {

   $scope.orders = [];
   $scope.quotes = [];
   var ctn = '';
   var ban = '';
   var accountTypeNo = '';
   $scope.hasDCAccess = false;
   $scope.clickedOrder = '';
   $scope.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;

   if (userService.isCare()) {
       ban = utePersistentStorageService.getFromSession('accountNumber');
   } else {
       ctn = localStorage.getLocalStorageValue('phoneNumber');
       ban = localStorage.getLocalStorageValue('accountNumber');
   }

   if (userService.isCare()) {
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
        if (isPermitted) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
            .then(function (agentPermission) {
              $scope.hasDCAccess = agentPermission;
            });
        }
      });
   }
   function processJSON(){
     $scope.ordersArray = _.flattenDeep( _.filter($scope.content,function(key,value){return  value=='ppc' || value=='hup' || value=='nac'}));
     $scope.totalOrders = _.size($scope.ordersArray);
     $scope.orders = _.filter($scope.ordersArray,function(key,value){
        return !key.quotation;
     });
     $scope.quotes = _.filter($scope.ordersArray,function(key,value){
        return key.quotation==true;
     });
   }

   $scope.validatedRedirect = function (activityType, orderId, orderType, contactNo, order) {
     if (userService.isCare()) {
       sessionStorage.setSessionStorageValue('phoneNumber', contactNo);
       ctn = utePersistentStorageService.getFromSession('phoneNumber');
       accountTypeNo = utePersistentStorageService.getFromSession('accountTypeNumber');
     }
     else {
       localStorage.setLocalStorageValue('phoneNumber', contactNo);
       ctn = localStorage.getLocalStorageValue('phoneNumber');
       accountTypeNo = localStorage.getLocalStorageValue('accountTypeNumber');
     }
      utePersistentStorageService.putToSession('order', order ); // BCR-693 Analytics: Send the order data to analytics mainly who saved the quote/order(orderSavedByAgent) like cx or rep
     var saveStatePassJSON = {
       'ctn': ctn,
       'activityTypeKey': activityType,
       'accountTypeNumber': accountTypeNo
     };
     var fetchValidatedCartPassJSON = {
       'ban': ban,
       'ctn': ctn,
       'orderId': orderId,
       'activityTypeKey': activityType
     };
     if (orderType == 'order') {
       saveStatePassJSON['ban'] = ban;
     }
     $scope.clickedOrder = orderId;
     cartMenuService.saveState(saveStatePassJSON).then(
       function (response) {
         if (response && response.success) {
           cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
             function (res) {
                if (activityType.toLowerCase() == 'ppc') {
                   utePersistentStorageService.putToSession('flowType', 'ppc' );
                }
                else if (activityType.toLowerCase() == 'hup') {
                   utePersistentStorageService.putToSession('flowType', 'hup' );
                }
               if (res && res.success) {
                 cartMenuService.validateOrder().then(
                   function (vres) {
                     if (vres && vres.success) {
                       $scope.clickedOrder = '';
                       if (activityType.toLowerCase() == 'ppc') {
                         $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                       }
                       else if (activityType.toLowerCase() == 'hup') {
                         $window.location.href = '/web/totes/upgrade/#/checkout/review';
                       }
                     }
                     else {
                      if (userService.isCare() && vres &&  vres.concurrentUpdate &&  vres.concurrentUpdate == true && (activityType.toLowerCase() == 'ppc' || activityType.toLowerCase() == 'hup' )){
                         $modal.open({
                           templateUrl: 'views/modals/concurrentUpdateModalPopup.html',
                           windowClass: 'ngdialog-theme-default ngdialog-concurrentUpdate-theme',
                           controller: 'genericWirelessModalCtrl',
                           controllerAs: 'vm',
                           backdrop: false
                         });
                      } else{

                      showValidateOrderPopUp();
                      }
                     }
                   },
                   function (verr) {

                   }
                 );
               }
               else {
                if (userService.isCare() && res &&  res.concurrentUpdate &&  res.concurrentUpdate == true && (activityType.toLowerCase() == 'ppc' || activityType.toLowerCase() == 'hup' )){
                   $modal.open({
                     templateUrl: 'views/modals/concurrentUpdateModalPopup.html',
                     windowClass: 'ngdialog-theme-default ngdialog-concurrentUpdate-theme',
                     controller: 'genericWirelessModalCtrl',
                     controllerAs: 'vm',
                     backdrop: false
                   });
                }

               }
             },
             function (err) {
               //error in fetchValidatedCart
             }
           );
         }
         else {
           //error in saveState
         }
       },
       function (error) {
         //error in saveState
       }

     );
   }
   //on click of any quote or order
   $scope.redirectToPage = function (activityType, orderId, orderType, contactNo, order) {

     var deferred = $q.defer();

     cartMenuService.agentInfo().then(
       function (response) {
         if (response.dealerCode != "" || (!$scope.hasDCAccess && userService.isCare())) {
           $scope.validatedRedirect(activityType, orderId, orderType, contactNo, order);
         } else {
           captureDealerCodeService.showProceedWithoutDealerCodeModal().then (
              function(result) {
                 if(result !== false) {
                   $scope.validatedRedirect(activityType, orderId, orderType, contactNo, order);
                 } else {
                   $scope.changeBtnLoading(false);
                 }
              }, function(error) {
                 $scope.changeBtnLoading(false);
           });
         }
       },
       function (error) {
         deferred.reject(error);
       });
   }

   $scope.cancelOrder = function(event, id) {
      event.stopPropagation();
      $scope.clickedOrder = id;
      var postData = {
        "currentOrderId": id
      };
      ajax.cancelOrder(postData).then(function(res) {
        if (userService.isCare() && res &&  res == 'concurrent update'){
             $modal.open({
               templateUrl: 'views/modals/concurrentUpdateModalPopup.html',
               windowClass: 'ngdialog-theme-default ngdialog-concurrentUpdate-theme',
               controller: 'genericWirelessModalCtrl',
               controllerAs: 'vm',
               backdrop: false
             });
        }else{
            $scope.orders = _.filter($scope.orders, function(value, key) {
                return value.orderId !== id;
            });
            $scope.quotes = _.filter($scope.quotes, function(value, key) {
                return value.orderId !== id;
            });
            $scope.totalOrders = _.size($scope.orders) + _.size($scope.quotes);
            $state.reload();
        }
      });
   };

   processJSON();
   
   function showValidateOrderPopUp() {
    var modalInstance = $modal.open({
      templateUrl: 'views/modals/validateOrderPopUp.html',
      size: 'validate-order-false',
      controller: ['$scope', '$translate', function ($scope, $translate) {
        $scope.close = function () {
          modalInstance.close();
        };
      }]
    });
   }
 }

/* jshint -W106 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
  * @name ute.common.oneview.header.controller:consumerDetailsController
  * @description
  * # consumerDetailsController
  * Controller of the ute.common.oneview.header
  */
  angular.module('ute.common.oneview.header').controller('MyrConsumerDetailsController', consumerDetailsController);
  function daysInMonth (month, year) {
    return new Date(year, month, 0).getDate();
  }
  consumerDetailsController.$inject = ['$scope',
  '$rootScope',
  '$modal',
  '$log',
  '$http',
  'myrCustomerInfoService',
  '$translate',
  '$window',
  'ute.common.permissions.service',
  'ute.common.user.service',
  'ute.blocks.language.switcher',
  'maintenanceService',
  'ute.rogers.account.overview.factory',
  'myrAccountUnlockService',
  'ute.common.oneview.header.util',
  'myrAccountListService',
  'ute.common.agent.info.factory',
  'ute.oneview.header.service',
  'ute.blocks.persistent.storage.service',
  'ute.active.treatments.service'];

  /* @ngInject */
  function consumerDetailsController($scope, // jshint ignore:line
    $rootScope,
    $modal,
    $log,
    $http,
    myrCustomerInfoService,
    $translate,
    $window,
    permissionsService,
    userService,
    languageSwitcher,
    maintenanceService,
    accountOverviewFactory,
    myrAccountUnlockService,
    util,
    myrAccountListService,
    agentInfoFactory,
    oneViewHeaderService,
    persistentStorageService,
    actionsOffersService) {
      var vm = this; // jshint ignore:line
      var ps = userService.getPersistentService();
      var accountOverviewService = accountOverviewFactory({
        refresh: false,
        applicationId: 'Rogers.com',
        acctNbr: ps.get('accountNumber')
      });
      vm.als = myrAccountListService;
      $scope.$extend({});
      $scope.aus = myrAccountUnlockService;
      vm.loadingDataIndicator = true;
      vm.isConsumerBriefInfoReady = false;
      vm.customerInfo = null;
      vm.accountLockStatus = false;
      vm.accountLocked = false;
      vm.cis = myrCustomerInfoService;
      vm.duration = null;
      vm.isOpen = false;
      vm.toggleIsOpen = function() {
        vm.isOpen = !vm.isOpen;
      }
      vm.expandIDVDetails = false; //ove-711
      vm.isIDVAccount = false; //ove-711
      vm.unknownIDVStatus = false; //ove-711
      vm.statusIDVLoading = true; //ove-711
      vm.displayIDVStatus; //ove-711
      vm.showValidateIDVButton = false; //ove-711
      vm.isConfirmedIDV = false;
      vm.idvDetails = {}; //ove-711;
      vm.enableIDVAccountButton = false //ove-711
      vm.idvStatusCheck = false;
      vm.lang = languageSwitcher.getCurrentLanguage();
      vm.passcodeError = false;

      vm.customerDuration = customerDuration;
      vm.isARPAPermitted = false;
      vm.arpa = {
        arpaValue: '-',
        arpaError: false
      }
      vm.getARPAValue = getARPAValue;


    function getARPAValue() {
      if (vm.als.selectedAccount.accountStatus === "Cancelled" || vm.als.selectedAccount.accountStatus === "Suspended") {
        vm.arpa.arpaError = true;
        return;
      }
      actionsOffersService.callActiveTreatments().then(function (res) {
        if (res.data.ARPAValue || !res.data.ARPAValue === ""){
          vm.arpa.arpaValue = res.data.ARPAValue;
        }
        else{
          if (res.data && res.data.errorCode === "123" && res.data.arpaValue && res.data.arpaValue.length != 0){
            vm.arpa.arpaValue = res.data.arpaValue;
          }
          else {
            vm.arpa.arpaError = true;
          }
        }
      }).catch(function (errorResponse) {
        //should check fot ARPA if the errorcode of getActiveTreatments is 123
        if (errorResponse.data && errorResponse.data.errorCode === "123" && errorResponse.data.arpaValue && errorResponse.data.arpaValue.length != 0)
          vm.arpa.arpaValue = errorResponse.data.arpaValue;
        else {
          vm.arpa.arpaError = true;
        }
      });
    }

    function customerDuration() {
      var monthSpan = 0;
      var yearSpan = 0;
      if (vm.loadingDataIndicator || vm.customerInfoFailure || !vm.customerInfo) {
        return '';
      }
      if (!vm.customerInfo.accountEffectiveDate) {
        return $translate('ute.common.oneview.header.consumerDetails.customer_duration', { years: yearSpan, months: monthSpan });
      }
      var startDay = parseInt(vm.customerInfo.accountEffectiveDate.substring(8, 10));
      var startMonth = parseInt(vm.customerInfo.accountEffectiveDate.substring(5, 7)) - 1;
      var startYear = parseInt(vm.customerInfo.accountEffectiveDate.substring(0, 4));
      var today = new Date();
      var currentDay = today.getDate();
      var currentYear = today.getFullYear();
      var currentMonth = today.getMonth();
      // var startDaysInMonth = daysInMonth(startMonth, startYear);
      // var currentDaysInMonth = daysInMonth(currentMonth, today.getFullYear());

      monthSpan = currentMonth - startMonth + (12 * (currentYear - startYear));
      if (currentDay <= startDay) {
        monthSpan = monthSpan - 1;
      }
      if (monthSpan < 0) {
        monthSpan = 0;
      }
      yearSpan = parseInt(monthSpan / 12);
      monthSpan = monthSpan % 12;
      return $translate('ute.common.oneview.header.consumerDetails.customer_duration', { years: yearSpan, months: monthSpan });
    }
          vm.lng = languageSwitcher;

          if (userService.isSigned()) {
            getAccountList();
            //ram permission for ARPA
            permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ARPA, ute.common.permissions.service.RamActionCodes.grant)
            .then(function (agentPermission) {
              vm.isARPAPermitted = agentPermission;
          });
          }

          function updateAccountLockStatus() {
            $scope.aus.selectedAccount = vm.selectedAccount;
            $scope.aus.isAccountLocked(vm.selectedAccount).then(function(data){
              vm.accountLocked = data;
            });
          }

          function getAccountList() {
            var accountListResponse = function (_tmp) { // jshint ignore:line
              var accountListRaw = null;
              if (_tmp) {
                if (_tmp.cachedResultInfo) {
                  if (_tmp.cachedResultInfo.expired) {
                    if (_tmp.accountList.length > 0) {
                      // var dataToProcess = JSON.parse(JSON.stringify(_tmp));
                      processGetAccountList(_tmp);
                      accountListRaw = _.clone(_tmp);
                    }
                    //vm.loadingDataIndicator = true;
                    //accountOverviewService.getAccountOverviewRawData().then(accountListResponse, accountListError);
                    vm.als.getAccountList(request, accountListResponse, accountListError);
                  }
                }
                if (_tmp && _tmp.accountList && _tmp.accountList.length) {
                  if(!vm.selectedAccount) {
                    vm.accountType = _tmp.accountList[0].accountType; //ove-711
                    vm.accountSubType = _tmp.accountList[0].accountSubType; //ove-711
                    vm.getIDVDetails(); //ove-711
                    vm.getARPAValue();
                  }
                  vm.selectedAccount = _tmp.accountList[0].accountNumber;
                }

                updateAccountLockStatus();

                updateConsumerDetails(_tmp);
                getWeatherInformation(_tmp);
                getCustomerInfo();

                if (accountListRaw) {
                  accountListRaw.cachedResultInfo = {};
                }
                _tmp.cachedResultInfo = {};
                if (!accountListRaw || (accountListRaw && (!_.isEqual(_tmp, accountListRaw)))) {
                  processGetAccountList(_tmp);
                }
              }
            };
            var accountListError = function () {
              //vm.loadingDataIndicator = false;
            };
            //accountOverviewService.getAccountOverviewRawData().then(accountListResponse, accountListError);
            var request = {
              refresh: false,
              applicationId: 'Rogers.com'
            };
            vm.als.getAccountList(request, accountListResponse, accountListError);
          }

          function processGetAccountList(_tmp) { // jshint ignore:line
            if (_tmp.result === 'success') {
              // all these are not needed
              // for (var i = 0; i < _tmp.accountList.length; i++) {
              //   var tmp = {};
              //   tmp = _tmp.accountList[i];
              //   _tmp.accountList[i].accountStatusSimple = vm.als.getAccountStatus(tmp).accountStatusSimple;
              //   _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
              //   _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
              //
              //   _tmp.accountList[i].comboDisplay = (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) ? (_tmp.accountList[i].nickName ||
              //   _tmp.accountList[i].nickName) + ' - ' + _tmp.accountList[i].accountNumber : _tmp.accountList[i].accountNumber;
              //
              //   _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
              // }
              //display the linked success banner for the very first account
              //vm.als.accountTypes = _tmp.accountList;

              var reqIndex = 0;
              var accLocalSelected;

              /* accountTypes.length is always 1 in OneView. This Component is only used in OneView
              if (vm.als.accountTypes.length > 1 && ($rootScope.ao.accountActiveIndex === null || $rootScope.ao.accountActiveIndex === undefined)) {
                // Check local storage if account was selected in past
                accLocalSelected = vm.localStorage.getLocalStorageValue('accountNumber');
                if ($rootScope.isCare) {
                  accLocalSelected = vm.sessionStorage.getSessionStorageValue('accountNumber');
                }
                if (accLocalSelected) {
                  // Update selected index
                  vm.appState.aoUpdateActiveObjects(accLocalSelected);
                  reqIndex = $rootScope.ao.accountActiveIndex;

                  if (vm.deeplink.data.direction !== 'out') {
                    // Show the popup / first time entry
                    if (vm.appState.isFirstLoad) {
                      vm.appState.tagging(['_trackLink', {event35: ''}]);
                      $rootScope.firstLoad = 1;
                      $rootScope.popUpOpened = true;
                      $rootScope.popUpOpenedAndClosed = false;

                      //openSelectAccount('');
                      vm.appState.isFirstLoad = false;

                    }
                  }
                }
              } else if (vm.als.accountTypes.length > 1) {
                accLocalSelected = vm.localStorage.getLocalStorageValue('accountNumber');
                if ($rootScope.isCare) {
                  accLocalSelected = vm.sessionStorage.getSessionStorageValue('accountNumber');
                }
                if (accLocalSelected) {
                  // Part of MYR-1123 fix, this directly returns the index from appState and updates vm.als object / service
                  var actIndex = vm.appState.aoUpdateActiveObjects(accLocalSelected);
                  vm.als.updateSelectedAccount(actIndex);
                  reqIndex = vm.als.selectedIndex;
                } else {
                  reqIndex = vm.als.selectedIndex;
                }
              }*/

              /* Old datalayer tagging, will be replaced by new datalayerService, talk to Kenny Wong for details
              if (vm.als.accountTypes.length === 1) {
                if (vm.appState.isFirstLoad) {
                  $rootScope.firstLoad = 1;
                  vm.appState.isFirstLoad = false;
                  vm.appState.tagging(['_trackLink', {event35: ''}]);
                }
              }
              */

              // Update selection and store it into a cookie
              // In OneView the selected account cannot change. vm.als.updateSelectedAccount is called before it is called here. So no point in calling it again.
              /*
              vm.als.updateSelectedAccount(reqIndex);
              $rootScope.ao.accountActive = vm.als.selectedAccount;
              */

              /* old analytics. Will be replaced by new dataLayerService
              try {
                vm.appState.tagging(['_trackLink', {event17: ''}]);
              } catch (e) {
                $log.error('Exception catch during tagging on vm.als.selectedAccount.accountNumber with message:', e.message);
              }
              */
              /* assigned but never used
              vm.als.btnSettings = vm.btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
              vm.als.btnStatus = $window.btnStatus;
              */
              //TODO move to settings.js
              persistentStorageService.putToLocal('accountNumber', vm.als.selectedAccount.accountNumber);
              persistentStorageService.putToLocal('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
              if (userService.isCare()) {
                persistentStorageService.putToSession('accountNumber', vm.als.selectedAccount.accountNumber);
                persistentStorageService.putToSession('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
              }
              // TODO move to settings.js vm.appState.aoUpdateIndexes(vm.als.selectedAccount.accountNumber);

              // load default profile
              var modalSelected = persistentStorageService.getFromLocal('accountNumber');
              if (userService.isCare()) {
                modalSelected = persistentStorageService.getFromSession('accountNumber');
              }
              //TODO move to settings.js vm.appState.aoUpdateActiveObjects(modalSelected);

              // From updated rootScope proceed to update of the page
              vm.als.selectedAccount = vm.als.accountTypes[reqIndex];

              updateConsumerDetails(_tmp);

              return vm.als.accountTypes;

            } else {
              if (_tmp.result === 'redirect') {
                // vm.appState.noLinking = false;
                maintenanceService.noLinking = false;
                /* oneView is only for care/dealer
                if ($rootScope.isConsumer) {
                  maintenanceService.switchView('guestoverview');
                } else {
                  */
                  maintenanceService.switchView('/oneViewInterface');
                  // }
                }
              }
            }

            //ove 711 IDV - start
            // to ocnditionally change the show/hide details text
            vm.expandAndCollapseDetails = function() {
              if(vm.expandIDVDetails) {
                vm.expandCollapseText = 'ute.common.oneview.header.idvDetails.hide_details';
              } else {
                vm.expandCollapseText = 'ute.common.oneview.header.idvDetails.show_details';
              }
              vm.expandIDVDetails = !vm.expandIDVDetails;
            }

            //to conditionally change the idv status
            function idvStatus() {
              if(!vm.statusIDVLoading) {
                if(!vm.unknownIDVStatus) {
                  if(vm.isIDVAccount) {
                    if(vm.showValidateIDVButton) {
                      vm.idvAccountButtonText = 'ute.common.oneview.header.idvDetails.validate_idv_status';
                    }
                  } else {
                    if(vm.enableIDVAccountButton) {
                      vm.idvAccountButtonText = 'ute.common.oneview.header.idvDetails.enable_idv_account';
                    }
                  }
                }
              }
            }

            function idvStatusCheck() {
              if(!vm.statusIDVLoading){
                if(!vm.unknownIDVStatus){
                  if(vm.isIDVAccount){
                    return true;
                  }
                  else{
                    return false;
                  }
                }
              }
            }

            //get idv details - api call
            vm.getIDVDetails = function() {
              var request = {
                accountNumber: persistentStorageService.getFromSession('accountNumber').toString(),
                accountType: vm.accountType,
                accountSubType: vm.accountSubType,
                userID: persistentStorageService.getFromSession('dealerInfo')['userId'],
                operatorID: persistentStorageService.getFromSession('operatorId').toString(),
                franchise: 'ROGERS',
                applicationId: 'UTERogersCare'
              };
              vm.cis.getIDVDetails(request, processIDVDetails, errorIDVDetails)
            }

            //while doing these changes for the solaris appln header (if OV team is doing it), we require their help for setting userId and
            //operatorId in session storage so that we can pick it up from there.

            //working with the response received form idv api.
            function processIDVDetails(response) {
              if(!angular.equals(response,{})) {
                vm.idvDetails = response;
                vm.statusIDVLoading = false;
                if(response["idvStatus"] === "I" || (response["idvStatus"] === "V")) {
                  vm.isIDVAccount = true;
                  vm.isConfirmedIDV = true;
                  vm.displayIDVStatus = 'ute.common.oneview.header.idvDetails.idv_account';
                  vm.expandAndCollapseDetails();
                  vm.idvStatusCheck = idvStatusCheck();
                  //to store migration fee, if available
                  if(response.idvMigInfoVOList){
                    persistentStorageService.putToSession('migFee',response.idvMigInfoVOList[0].migFee);
                    persistentStorageService.putToSession('daysForZeroFee',response.idvMigInfoVOList[0].daysForZeroFee);
                  }
                  //to display validate idv button
                  if(response["idvStatus"] === "I") {
                    if(response["discountFallOffDate"]) {
                      vm.showValidateIDVButton = true;
                      vm.isConfirmedIDV = true;
                    }
                  } else {
                    if(new Date(response["lastValidationValidDate"]) < new Date()) {
                      vm.showValidateIDVButton = true;
                      vm.isConfirmedIDV = false;
                    } else {
                      vm.showValidateIDVButton = false;
                    }
                  }
                } else {
                  vm.statusIDVLoading = false;
                  vm.isIDVAccount = false;
                  vm.displayIDVStatus = 'ute.common.oneview.header.idvDetails.non_idv_account';
                  vm.enableIDVAccountButton = true;
                }
              } else {
                // to decide.
              }
              idvStatus();
            }

            function errorIDVDetails() {
              vm.statusIDVLoading = false;
              vm.unknownIDVStatus = true;
              vm.displayIDVStatus = 'ute.common.oneview.header.idvDetails.unknown_idv_status';
              idvStatus();
            }
            //ove 711 IDV end

            function displayIDVFeeWarning(fee) {
              vm.cis.setmigFee(fee);
              var modalInst = $modal.open({
                templateUrl : 'module/views/modals/confirmFee.html',
                controller: 'enableIDVController'
              });

              modalInst.result.then(function() {
                vm.applyPasscode(fee);
              });
            };

            function displayIDVError(url) {
              var modalInst = $modal.open({
                templateUrl : url ,
                controller: 'enableIDVController'
              });

              modalInst.result.then(function(){
                $scope.showEnableIDV();
              });
            };

            function displayIDVSuccess(url) {
              var modalInst = $modal.open({
                templateUrl : url
              });
            };

            vm.applyPasscode = function(fee) {
              var request = {
                accountNumber: persistentStorageService.getFromSession('accountNumber').toString(),
                franchise: 'ROGERS',
                applicationID: 'UTERogersCare',
                phoneNumber: persistentStorageService.getFromLocal('phoneNumber').toString(),
                passcode: vm.cis.getPasscode()
              };

              if(fee !== null) {
                request.fee = fee.toFixed(2);
              }
              vm.cis.applyPasscode(request, handleIDVSuccess, handleIDVError);
            }

            var handleIDVSuccess = function(response,fees) {
              var isSuccess = response.respResponse.responseHeader.status === "Success";
              var isMigFeeZero = response.respResponse.migFee == "0";
              var migFeeResp = response.respResponse.migFee;
              var successDiscountUrl='module/views/modals/successDiscount.html';
              var successPasscodeUrl = 'module/views/modals/successPasscode.html';
              var isineligiblePPC = response.errorCode ==="CS01";
              var CS07error = response.errorCode ==="CS07";

              if(isSuccess) {
                if(!vm.isConfirmedIDV || isMigFeeZero) {
                  if(isineligiblePPC){
                  displayIDVSuccess(successPasscodeUrl);
                  } else if(CS07error){
                    displayIDVFeeWarning(parseInt(migFeeResp));
                  } else{
                  displayIDVSuccess(successDiscountUrl);
                  }
                } else if ((vm.isConfirmedIDV || !vm.isIDVAccount)&& !isMigFeeZero) {
                  if(fees == null) {
                    displayIDVFeeWarning(parseInt(migFeeResp));
                  }
                  else {
                    if(isineligiblePPC){
                      displayIDVSuccess(successPasscodeUrl);
                      } else{
                      displayIDVSuccess(successDiscountUrl);
                      }
                  }
                }
              }
            }

            var handleIDVError = function(data) {
              var templateUrl;
              var errorcode = data.data.data.errorCode;
              var status = data.data.data.status;
              var errorMessage= data.data.data.errorMessage;
              var genericError = (status==="Failure" && ((errorcode!="CS01")||(errorcode!="CS07")))|| errorcode===50000;
              if((errorcode===50000 && errorMessage==="The passcode is invalid"))
              {
                templateUrl = 'module/views/modals/invalidPasscode.html';
              }else if(genericError){
                templateUrl = 'module/views/modals/systemError.html';
              }
              displayIDVError(templateUrl);
            }

            $scope.showEnableIDV = function() {
              var modalInst= $modal.open({
                templateUrl: 'module/views/modals/enableIDV.html',
                controller: 'enableIDVController'
              });
              var VStatuscheck = !vm.isConfirmedIDV;
              var feesm = persistentStorageService.getFromSession('migFee');
              var fee = null;
              var fees = null;
              if(feesm != null) {
                fee = feesm;
                }

              modalInst.result.then(function() {
                if(VStatuscheck) {
                  if(fee > 0) {
                    displayIDVFeeWarning(fee);
                  } else {
                    vm.applyPasscode(fee);
                  }
                }
                else {
                  vm.applyPasscode(fees);
                }
              });
            }

            function getCustomerInfo() {
              var request = {
                accountNumber: vm.selectedAccount
              };
              if (userService.isCare()) {
                request.accountNumber = ps.get('accountNumber');
              }
              var customerInfoResponse = function (data) {
                vm.customerInfo = data;
                getResourceFile();
                vm.isC_LimitDisplay = !((vm.customerInfo.creditLimit === '0.0') || (typeof vm.customerInfo.creditLimit === 'undefined'));// jscs:ignore
              };
              var customerInfoError = function () {
                vm.loadingDataIndicator = false;
                vm.customerInfoFailure = true;
              };

              $http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/interaction/interactionHistoryConfig.json', {cache: false}).then(function (response) {
                $scope.isInteractionHistorySwitchEnabled = response.data.isInteractionHistorySwitchEnabled;
                if ($scope.isInteractionHistorySwitchEnabled) {
                  vm.cis.getCustomerInfo(request, customerInfoResponse, customerInfoError);
                } else {
                  vm.loadingDataIndicator = false;
                  vm.customerInfoFailure = true;
                }
              },
              function (error) {
                vm.cis.getCustomerInfo(request, customerInfoResponse, customerInfoError);
              });
            }

            function getResourceFile() {
              updateConsumerOverLayDetails();
            }

            function updateCustomerType(account) {
              // maintain the global accountType as it is overridden by accountTypeNumber
              // Need to review why accountType is getting overridden with accountTypeNumber
              /*
              if ($rootScope.ao.allAccounts) {
                if ($rootScope.accountType === undefined || $rootScope.accountType === '') {
                  $rootScope.accountType = $rootScope.ao.allAccounts[0].accountType;
                }
                if ($rootScope.ao.allAccounts[0].accountTypeNumber === 9) {
                  $rootScope.accountType = $translate.instant('one_view_pay_as_you_go');
                }
              }
              */

              getResourceString('accType', account.accountType).then(function(translation) {
                vm.accountType = translation;
              });

            }

            function getResourceString(prefix, key) {
              var modifiedKey;
              if (key) {
                modifiedKey = key.toLowerCase();
                modifiedKey = modifiedKey.replace(/\s+/g, '-');
              }
              var keyWithPrefix = 'ute.common.oneview.header.consumerDetails.' + prefix + '_' + modifiedKey;

              return $translate(keyWithPrefix);
            }


            function updateConsumerDetails(_tmp) {
              if (_tmp && _tmp.accountList && _tmp.accountList.length) {
                vm.isConsumerBriefInfoReady = true;
                vm.accountDetails = _tmp.accountList[0];
                updateCustomerType(_tmp.accountList[0]);
                vm.fullName = vm.accountDetails.accountName.firstName + ' ' + vm.accountDetails.accountName.lastName;
                vm.isCable = vm.accountDetails.accountNumber.length === 12;
                // oneview is never for consumer
                // if (!$rootScope.isConsumer) {
                $window.document.title = vm.accountDetails.accountNumber + ' - ' + vm.fullName;
                // }
              }
            }

            function updateConsumerOverLayDetails() {
              if (vm.customerInfo) {
                vm.loadingDataIndicator = false;
                //vm.accountType = getResourceString('accType',$rootScope.accountType);

                getResourceString('accSubType', vm.customerInfo.accountSubType).then(function(translation) {
                  vm.accountSubType = translation;
                });

                getResourceString('accStatus', vm.customerInfo.accountStatus).then(function(translation) {
                  vm.accountStatus = translation;
                });

                var date = moment(vm.customerInfo.accountEffectiveDate); // jshint ignore:line

                util.getMonthsNames().then(function(result) {
                  var monthsNames = _.values(result);
                  var month = monthsNames[date.month()];

                  vm.accountEffectiveDate = util.getDateByDate(vm.customerInfo.accountEffectiveDate, month);
                });

                vm.customerDuration().then(function(translation){
                  vm.duration = translation;
                });

                if (vm.customerInfo.creditClass) {
                  vm.isCreditClass = vm.customerInfo.creditClass.length > 0;
                }
              }
            }

            languageSwitcher.registerOnDataChangeHandler(function (lang) {
              vm.lang = lang;
              getResourceFile();
              accountOverviewService.getSelectedAccount().then(updateCustomerType);
            }, 'consumerDetailsControllerLangSub');

            $scope.$on('$destroy', function () {
              languageSwitcher.unregisterOnDataChangeHandler('consumerDetailsControllerLangSub');
            });

            function getWeatherInformation(_tmp) {
              oneViewHeaderService.getSummaryWorker().then(function(worker) {
                worker.getAccountOverviewSummaryRawData().then(function(data) {
                  // var data = _tmp.accountList[0].accountDetails;
                  if (data && data.billingAddress) {
                    $scope.addressUnavailable = false;
                    vm.customerAddress = {
                      'streetAddress': (data.billingAddress.unit ? data.billingAddress.unit + '-' : '') + data.billingAddress.streetNumber + ' ' + data.billingAddress.streetName,
                      'province': data.billingAddress.province,
                      'city': data.billingAddress.city,
                      'postalCode': data.billingAddress.postalCode
                    };
                    vm.customerAddressOneLine = (vm.customerAddress.streetAddress + ' ' + vm.customerAddress.city + ' - ').toLowerCase() + vm.customerAddress.province + ' ' + vm.customerAddress.postalCode;
                  }
                })
              });

            }
            /* not needed accountdetails is only loaded once in oneview
            $rootScope.$watch('ao.accountDetails', function (newVal, oldVal) {
              if ($rootScope.isCare || $rootScope.isDealer) {
                if (newVal) {
                  if (!oldVal) {
                    getWeatherInformation();
                  } else if (oldVal && newVal.billingAddress.city !== oldVal.billingAddress.city) {
                    getWeatherInformation();
                  }
                }
              }
            });
            */

          }
        })();

(function () {
  'use strict';

  angular.module('ute.common.oneview.header').directive('consumerDetails', consumerDetails);

  consumerDetails.$inject = ['$window'];

  /* @ngInject */
  function consumerDetails($window) {
    return {
      scope: {},
      templateUrl: 'module/consumerDetails/consumerDetails.html',
      restrict: 'EA',
      controller: 'MyrConsumerDetailsController',
      controllerAs: 'al',
      bindToController: true,
      link: linkFunc
    };
    function linkFunc(scope, element, attrs) {
      var mq = '(max-width:767px)';
      /*$('body').on('click', '.page-one-view-dashboard', function(e) {
       if(element.find('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
       element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
       // $('.consumer-details-collapsible').removeClass('show');
       //consumer-details-collapsible-expanded
       element.find('.consumer-details-collapsible').hide();
       }
       });*/
      element=$(element);
      $('html').click(function () {
        if (element.find('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
          element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
          // $('.consumer-details-collapsible').removeClass('show');
          //consumer-details-collapsible-expanded
          element.find('.consumer-details-collapsible').hide();
        }
      });
      /*scope.$watch(function () {
        if ($window.matchMedia(mq).matches) {

        } else {
*//*          element.find('.directive-oneview-consumer-details').mouseenter(function () {

            //scope.getConsumerDetails(); commented for CSS hover implemntation
          });*//*
          element.find('.directive-oneview-consumer-details').click(function (e) {
            e.stopPropagation();
            scope.getConsumerDetails();
          });
*//*          element.find('.directive-oneview-consumer-details').mouseleave(function () {
            //scope.closeConsumerDetails(); commented for CSS hover implemntation
          });*//*
        }
      });*/

      /*
      scope.getConsumerDetails = function () {
        if (!$('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
          $('.directive-oneview-consumer-details').addClass('consumer-details-expanded');
          //$('.consumer-details-collapsible').addClass('show');
          $('.consumer-details-collapsible').show();
        }
        if (!$window.matchMedia(mq).matches) {
          $('body').on('click', 'body', function (e) {
            if ($('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
              $('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
              // $('.consumer-details-collapsible').removeClass('show');
              //consumer-details-collapsible-expanded
              $('.consumer-details-collapsible').hide();
            }
          });
        }
      };
      scope.closeConsumerDetails = function () {
        element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
        // element.find('.consumer-details-collapsible').removeClass('show');
        element.find('.consumer-details-collapsible').hide();
        if ($window.matchMedia(mq).matches) {
          //element.find('.show-more-container').removeClass('hide');
          element.find('.show-more-container').show();
          element.find('.show-more-container').addClass('visible-xs');
          element.find('.show-less-container').hide();
        }
      };
      scope.getConsumerDetailsForMobile = function () {
        //element.find('.consumer-details-collapsible').addClass('show');
        element.find('.consumer-details-collapsible').show();
        if ($window.matchMedia(mq).matches) {
          //element.find('.show-more-container').addClass('hide');
          element.find('.show-more-container').hide();
          element.find('.show-more-container').removeClass('visible-xs');
          element.find('.show-less-container').show();
        }
      };
      */
    }
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name ute.common.oneview.header.module:myrCustomerInfoService
   * @description
   * # myrCustomerInfoService
   */
  angular.module('ute.common.oneview.header').factory('myrCustomerInfoService', customerInfoService);

  customerInfoService.$inject = ['ajax','ajaxHeader'];

  function customerInfoService(ajax, ajaxHeader) {
    this.tempPasscode = "";
    var tempData={};

    var service = {
      customerInfo:null,
      getCustomerInfo:getCustomerInfo,
      getIDVDetails:getIDVDetails,
      applyPasscode:applyPasscode,
      setPasscode: setPasscode,
      getPasscode: getPasscode,
      getmigFee: getmigFee,
      setmigFee: setmigFee
    };

    return service;

    //ove711
    function getIDVDetails(request, successCallback, errorCallback) {
      ajaxHeader.getIDVDetails(request).then( function(response) {
        successCallback(response);
      }, function() {
        errorCallback();
      })
    }
    
    function applyPasscode(request, successCallback, errorCallback) {
      ajaxHeader.applyPasscode(request).then( 
        function(response) {
        return successCallback(response,request.fee);
      }, function(error) {
        return errorCallback(error);
      });
    }
    
    function getCustomerInfo (request, successCallback, errorCallback) {
      try {
        /*var postData = {
        accountNumber: $rootScope.ao.accountActive.accountNumber
        };*/
        ajax.getCustomerInfo(request).then(
        function (data) {
          return successCallback(data);
        },
        function (error) {
          return errorCallback();
        }
        );
      }catch (err) {

      }
      //return vm.customerInfo;
    }

    function setPasscode(p){
       this.tempPasscode = p;
    }
    
    function getPasscode(){
      return this.tempPasscode;
    }

   function setmigFee(migFee){
    tempData.migFee = migFee;
   }
 
  function getmigFee(){
    return tempData;
   }
}

}());

'use strict';

angular
  .module('ute.common.oneview.header')
  .filter('currenciesHeader', ['currenciesConfigHeader', function (currenciesConfigHeader) {
    return function (input, lang, prefixOverride, deci) {

      var defaultInput = 0;
      var defaultDeci = 2;
      var defaultLang = 'en';

      input = (typeof input === 'undefined') ? defaultInput : input;
      deci = (typeof deci === 'undefined') ? defaultDeci : deci;
      lang = (typeof lang === 'undefined') ? defaultLang : lang;

      var prefix = (lang === 'en' && prefixOverride) ? prefixOverride : null;

      if (isNaN(input * 1)) {
        return currenciesConfigHeader.format(lang, input, prefix);
      } else {

        var pow = Math.pow(10, deci);
        var amt = parseFloat(Math.round(input * pow) / pow).toFixed(deci);

        return currenciesConfigHeader.format(lang, amt, prefix);
      }

    };
  }]);

'use strict';

angular
        .module('ute.common.oneview.header')
		.factory('currenciesConfigHeader', function () {

			var currenciesConfig = {
				'currencies': [],
				'addCurrency': function (lang, pref, thou, dec, suf) {
					var obj = {
						'prefix': pref,
						'thousandsDelimiter': thou,
						'decimalDelimiter': dec,
						'suffix': suf
					};
					this.currencies[lang] = obj;
				},
				'getCurrency': function (lang) {
					return this.currencies[lang];
				},
				'getProperty': function (lang, prop) {
					return this.currencies[lang][prop];
				},
				'format': function (lang, val, prefixOverride) {
					var objCurr = this.currencies[lang];
					var prefix = prefixOverride || objCurr.prefix;
          val = val?val:0;
					// ????? Seriously! Does this look right to you? -- NO! we should be using localization and angular's built in
					return (prefix + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(',', objCurr.thousandsDelimiter).replace('.', objCurr.decimalDelimiter) + objCurr.suffix);
				}
			};

			//ADDS 2 DEFAULT CURRENCIES EN and FR to be used immediately by the currencies filter
			currenciesConfig.addCurrency('en', '$', ',', '.', '');
			currenciesConfig.addCurrency('fr', '', ' ', ',', ' $');

			return currenciesConfig;
		});

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name ute.common.oneview.header.module:myrCustomerInfoService
   * @description
   * # myrCustomerInfoService
   */
  angular.module('ute.common.oneview.header').service('maintenanceService', maintenanceService);

  maintenanceService.$inject = ['$location', '$window', '$timeout'];

  function maintenanceService($location, $window, $timeout) {
    var service = {
        showMaintenance: showMaintenance,
        noAccountList: false,
        switchView: switchView,
        tagging: tagging
    };

    return service;
    function tagging(options) {
        try {
            $window.addOmnp(options);
        } catch (e) {
            $log.error('Exception catch during $window.addOmnp with message:', e.message);
        }
    };

     function showMaintenance() {
        if (!service.noAccountList) {
            service.noAccountList = true;
            $location.path('/underMaintenance');
            $window.location.href = $window.location.origin + '/#/underMaintenance';
            $timeout(function () {
                $window.location.reload();
            }, 1000);

        }
    };

    function switchView(viewName) {
        var _targetView = viewName.charAt(0) !== '/' ? '/' : '';
        _targetView += viewName;
        $location.path(_targetView);
    };
  }

}());

/*
appState.showMaintenance = function () {
    if (!$rootScope.noAccountList) {

        $rootScope.noAccountList = true;
        $location.path('/underMaintenance');
        $window.location.href = $window.location.origin + '/#/underMaintenance';
        var underMaintenanceTimeout = setTimeout(function () {
        $window.location.reload();
        clearTimeout(underMaintenanceTimeout);
        }, 1000);

    }
};
*/
(function(){

	'use strict';
	angular.module('ute.common.oneview.header').factory('myrAccountUnlockService', myrAccountUnlockService);

	myrAccountUnlockService.$inject = ['ajax', 'sessionStorage', 'ute.blocks.persistent.storage.service', 'ute.common.user.service'];

	function myrAccountUnlockService(ajax, sessionStorage, persistentStorageService, userService) {
		var service = {
			accountLockStatus: false,
			unlockClicked: false,
			selectedAccount: null,
			unlockClick: unlockClick,
			isAccountLocked: isAccountLocked,
      getAccountLockStatus: getAccountLockStatus,
			accountUnlock: accountUnlock
		};
		return service;

    function getAccountLockStatus(){
      return service.accountLockStatus;
    }

    function unlockClick(){
      service.unlockClicked = true;
      return true;
    }

		function isAccountLocked(accountNumber){
		  if (userService.isCare()) {
        accountNumber = persistentStorageService.getFromLocal('accountNumber');
      }
      return ajax.getAccountStatus({accountNumber: accountNumber}).then(function (responseData) {
       if(responseData && responseData.locked && responseData.locked.toLowerCase() === 'true' ){
        service.accountLockStatus = true;
        return service.accountLockStatus;
        } else{
          service.accountLockStatus = false;
          return service.accountLockStatus;
        }
        },
        function (error) {
          service.accountLockStatus = false;
          return service.accountLockStatus;
        });
      }

	  function accountUnlock(){
      var accountNumber = '';
      var accountUnlocked = false;
      if (userService.isCare()) {
        accountNumber = persistentStorageService.getFromSession('accountNumber');

      } else if(userService.isDealer()) {
         accountNumber = service.selectedAccount;
       }
      return ajax.unlockAccount({accountNumber: accountNumber}).then( function (responseData) {
        if(responseData && responseData.unlocked && responseData.unlocked.toLowerCase() === 'true') {
          service.accountLockStatus = false;
          accountUnlocked = true;
          return accountUnlocked;
        } else {
            service.accountLockStatus = true;
            accountUnlocked = false;
            return accountUnlocked;
        }},
        function (error) {
         service.accountLockStatus = true;
         accountUnlocked = false;
         return accountUnlocked;
        });

	 }

	}
})();

'use strict';

//document can be found at
// http://projects.rogersnpd.com:8090/display/TOT/API+Documentation

angular
  .module('ute.common.oneview.header')
  .factory('ajaxHeader', [
    'backend',
    '$cookies',
    'ute.oneview.header.service',
    '$http',
    '$log',
    'ute.rogers.account.overview.factory',
    'ute.rogers.account.overview.summary.factory',
    '$window',
    '$q',
    'ute.common.permissions.service',
    'ute.rogers.account.billing.detail.factory',
    'ute.common.user.service',
    'ute.blocks.persistent.storage.service',
    function (backend,
              $cookies,
              oneViewHeaderService,
              $http,
              $log,
              newAccountOverviewFactory,
              accountOverviewSummaryFactory,
              $window,
              $q,
              permissionsService,
              billingDetailFactory,
              userService,
              persistentStorageService) {
      // Initiate Object
      var settings = oneViewHeaderService.getConfig().settings;
      var ajax = {};
      var killSwitchTrigger = 10;

      ajax.discardAllSmCookiesKillSwitch = 0;
      ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
      ajax.discardLoginSmCookiesKillSwitch = 0;

      return {
        updateNickName: function (accountNumber, accountTypeNumber, nickName) {
          return backend.post('ebu/nickname', {
            accNum: accountNumber,
            accType: accountTypeNumber,
            nickName: nickName
          });
        },
        resetKillSwitches: function () {
          ajax.discardAllSmCookiesKillSwitch = 0;
          ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
          ajax.discardLoginSmCookiesKillSwitch = 0;
        },
        disassociateAccount: function (data) {
          return backend.post('SelfServeAutomation/disassociateAccount', data, true);
        },
        disassociateAccountJanrain: function (data) {
          return backend.post('account/disassociate', data, true);
        },
        updatePinEmail: function (data) {
          //return backend.post('SelfServeAutomation/updatePinEmail', data, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateBillingType: function (data) {
          if (userService.isCare()) {
            data.accountTypeNumber = persistentStorageService.getFromSession('accountTypeNumber');
          }
          return backend.post('SelfServeAutomation/updateBillingType', data, true);
        },
        updateBillingTypeV2: function (data) {
          if (userService.isCare()) {
            data.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateBillingType', data, true);
        },
        updateUserInfo: function (data) {
          return backend.post('SelfServeAutomation/manageMyOnlineProfile', data, true);
        },
        updateContactInformation: function (data) {
          //return backend.post('SelfServeAutomation/updateContactInformation', {}, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateServiceAddress: function () {
          return backend.post('SelfServeAutomation/updateServiceAddress', {}, true);
        },
        updateBillingAddress: function () {
          return backend.post('SelfServeAutomation/updateBillingAddress', {}, true);
        },
        updateBillingAddressV2: function (obj) {
          if (userService.isCare()) {
            obj.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateBillingAddress', obj, true);
        },
        updateMarketingPermissions: function (mktPermObj) {
          return backend.post('SelfServeAutomation/updateMarketingPermissions', mktPermObj, true);
        },
        updateCredentials: function () {
          return backend.post('SelfServeAutomation/updateCredentials', {}, true);
        },
        getUserInfo: function () {
          var ban;
          if (userService.isCare()) {
            ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/manageMyOnlineProfileQuery', {ban: ban}, false);
        },
        setAddressContLang: function (obj) {
          return backend.post('SelfServeAutomation/setAddrContLang', obj, true);
        },
        updateContactInfo: function (obj) {
          if (userService.isCare()) {
            obj.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateContactInfo', obj, true);
        },
        getMarketingPermissions: function (obj) {
          return backend.post('SelfServeAutomation/getMarketingPermissions', obj, true);
        },
        getProfilePageInfo: function () {
          return backend.post('check.html', {
            'ban': '453532863',
            'ctn': '6043511037',
            'accountNumber': '453532863'
          }, true);
        },

        getAuthorizedLocally: function (userName, password) {
          return backend.post('testlogin', {
            email: userName,
            password: password
          });

        },
        registrationSwitch: function (regObj) {
          return backend.post('registrationSwitch', regObj);
        },
        registerNoEmailVerify: function (regObj) {
          return backend.post('register', regObj);
        },
        agentInfo: function () {
          var acctNbr;
          if (userService.isCare()) {
            acctNbr = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('agentInfo', {
            'acctNbr': acctNbr
          });
        },
        getIDVDetails: function(postData) { //ove-711
          return backend.post('idv/details', postData);
        },
        applyPasscode: function(postData) {
          return backend.post('idv/apply', postData);
        },
        signin: function (userName, password) {
          var requestObj = {
            USER: userName,
            password: password,
            SMAUTHREASON: '0',
            target: settings.postSigninUrl
          };
          return backend.postFormData('signin', requestObj);
        },
        pagePermission: function (url) {
          return backend.post('', {
            pageURL: url
          });
        },
        getMaintenanceSettings: function (postData) {
          return backend.post('maintenanceSettings', postData);
        },
        getBillingDetail: function (postData) {
          /* Forecefully remove the CachedData of BillingDetails
          *  Incase we are navigating away from oneviewdashboard 
          */
          var cacheBurst = false;
          if (postData.accounTypeNumber != 9) {
            delete postData.indx;
            delete postData.pinNumber;
            delete postData.phoneNumber;
          }
          var route = persistentStorageService.getFromSession('toStateName');
          route = route ? route.toLowerCase() : route
          if (!route) {
            var loc = window.location;
            var hashRegex = /#\/([^\?]+)/ig;
            var matches = hashRegex.exec(loc);
            route = (matches) ? matches[1].toLowerCase() : null;
          }

          if (route !== 'oneviewdashboard') {
            cacheBurst = true;
          }
          // cacheBurst =postData.refresh? postData.refresh:false;
          cacheBurst = true;
          return billingDetailFactory(postData).getBillingDetail(cacheBurst).then(function (data) {
            return normalizedBillingDetails(data);
          });
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          // var data = backend.post('accountoverview/billingDetails', postData);
          // return data;
        },
        getBalance: function (postData) {
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          var data = backend.post('accountoverview/balance', postData);
          return data;
        },
        getAccountList: function (postData) {
          var param;

          if (userService.isCare() || postData.acctNbr) {
            if (!postData.acctNbr) {
              postData.acctNbr = persistentStorageService.getFromSession('accountNumber');
            }
            param = {acctNbr: Number(postData.acctNbr)};
          }

          return newAccountOverviewFactory(param).getAccountOverviewRawData().catch(function (error) {
            if (error.status === 555 && error.data.errorCode === 10490) {
              $window.location.href = error.data.errorMessage;
              // $window.location.href = '/business/ss/smb/redesign/dashboard/overview';

              new $q(function (resolve, reject) { // jshint ignore:line
                return reject('redirected');
              });
              // throw new Error('redirected');
            }
          });
        },
        getAccountDetail: function (postData) {
          var request = {
            accountNumber: Number(postData.accountNumber),
            accountTypeNumber: postData.accountTypeNumber,
            language: postData.language
          };
          return accountOverviewSummaryFactory(request).getAccountOverviewSummaryRawData();
        },
        getAccountDetailPrepaid: function (postData) {
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          //var data = backend.post('accounts/detail', postData);
          return backend.post('accounts/detail', postData);
        },
        getSecureQuestion: function (email) {
          return backend.post('profile/question', {
            username: email
          });

        },
        getRegisteredUserName: function (email) {
          return backend.post('forgot/username', {
            email: email
          });
        },
        forgetPassword: function (selectedAnswer, fn, cToken, email, attemts) {
          if (attemts > 1) {

            return backend.post('forgot/password/resubmit', {
              username: email,
              answer: selectedAnswer
            });
          }

          return backend.post('forgot/password', {
            answer: selectedAnswer,
            fn: fn,
            cToken: cToken
          });
        },
        linkPostPaidAccount: function (postPaidAccount) {
          // return newAccountOverviewFactory().linkAccount(Number(postPaidAccount.accountNumber), postPaidAccount.billType, postPaidAccount.postalCode);
          return backend.post('account/associate', postPaidAccount);
          // return backend.post('linkAccount/postpaid', postPaidAccount);
        },
        linkPrepaidAccount: function (prepaidAccount) {
          return backend.post('linkAccount/prepaid', prepaidAccount);
        },
        getSegmentationForRGCL: function (postData) {
          var data;
          data = backend.post('accountoverview/getSegmentationForRGCL', postData);
          return data;
        },
        usernameMigration: function () {
          return backend.post('usernameMigration/check', {});
        },
        getEmail: function () {
          return backend.post('usernameMigration/getEmail', {
            username: $cookies.userName
          });
        },
        updateUsername: function (email) {
          return backend.post('usernameMigration/updateUsername', {
            username: $cookies.userName,
            email: email
          });
        },
        changeUsername: function (newUsername) {
          return backend.post('profile/changeUsername', {
            newEmail: newUsername
          });
        },
        getContactInfo: function (accountNumber) {
          var ban;
          if (userService.isCare()) {
            ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/getContactInfo', {
            accountNumber: accountNumber,
            ban: ban
          });
        },
        //PPC Check Eligibility Calls
        singleLineIdentity: function (accountNumber, ctn) {
          return backend.post('wirelessPricePlanChange/SingleLineIdentity',
            {
              accountNumber: accountNumber,
              ctn: ctn
            }
          );
        },

        hupEligibility: function (accountNumber, ctn, loyaltyStatus) {
          return backend.post('wirelessPricePlanChange/HupEligibility',
            {
              accountNumber: accountNumber,
              ctn: ctn,
              loyaltyStatus: loyaltyStatus
            });
        },

        //make a payment
        /*make a payment with a credit card*/
        getSignature: function (accountNumber) {
          return backend.post('signature', {accountNumber: accountNumber});
          //return backend.post('signature', { });
        },
        getToken: function (paymentServerUrl) {
          return backend.jsonp(paymentServerUrl);
        },
        decryptToken: function (accountNumber, token, iin, rc, ccType) {
          var requestObj = {
            accountNumber: accountNumber,
            encryptedToken: token,
            bin: iin,
            result: rc,
            creditCardType: ccType
          };
          return backend.post('payment/decrypt', requestObj);
        },
        payNow: function (creditPaymentObj, accountNumber, accountTypeNumber, subNumber, isConsolidated) {
          $log.debug(creditPaymentObj);
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            accountTypeNumber: accountTypeNumber,
            amount: creditPaymentObj.paymentAmount,
            paymentMethod: 'CreditCard',
            subNumber: subNumber,
            consolidated: isConsolidated,
            'creditCardInfo.ccNumber': creditPaymentObj.creditCardNo,
            'creditCardInfo.ccType': creditPaymentObj.creditCardType,
            'creditCardInfo.ccExpiryMonth': creditPaymentObj.expireDate.month,
            'creditCardInfo.ccExpiryYear': creditPaymentObj.expireDate.year,
            'creditCardInfo.securityCode': creditPaymentObj.securityCode
          };

          return backend.post('makePayment', passJson);
        },
        /*make a payment with interac*/
        interacConfirm: function (accountNumber) {
          var requestObj = {
            accountNumber: accountNumber
          };
          return backend.post('interac/confirmationData', requestObj);
        },
        /*make a payment with interac*/
        getSHMlink: function (accountNumber, url) {
          var requestObj = {
            serviceNumber: accountNumber
          };
          return backend.post('shmDashBoard/accessWebControl', requestObj);
        },
        //call this method with the response from interacEligibility directly.
        interacMakePayment: function (requestObj) {
          return backend.post('interac', requestObj);
        },
        billHistory: function (accountNumber, accountTypeNumber, index, pageSize) {

          var passJson = {
            accountId: accountNumber, //accountNo,
            accountType: accountTypeNumber,
            index: index,
            pageSize: pageSize
          };

          return backend.post('payment/history', passJson);
        },
        /**
         * change payment method
         * requestObj - required to complete the payment operation
         */

        setPaymentMethod: function (requestObj) {
          /*
           var requestObj= {
           accountNumber: accountNumber,
           accountTypeNumber: accountTypeNumber,
           mopType: methodType,
           'creditCardInfo.ccNumber': creditPaymentObj.creditCardNo,
           'creditCardInfo.ccType': creditPaymentObj.creditCardType.name,
           'creditCardInfo.ccExpiryMonth': creditPaymentObj.expireDate.month,
           'creditCardInfo.ccExpiryYear': creditPaymentObj.expireDate.year,
           'creditCardInfo.securityCode': creditPaymentObj.securityCode,
           'chequingInfo.bankNumber': debitPaymentObj.bankCode,
           'chequingInfo.transitNumber': debitPaymentObj.transitNo,
           'chequingInfo.accountNumber': debitPaymentObj.accountNo,
           'phoneNumber':cableAccount.phoneNumber,
           'oldMopType':cableAccount.oldPaymentMethod,
           'email':cableAccount.email
           };
           */
          return backend.post('payment/updatePaymentMethod', requestObj);
        },
        // Wireless Dashboard

        /* required params
         * ban	Account Number	716942875(Wireless)
         * ctn	Phone Number 4162780218
         */
        wirelessDashBoard: function (postData) {
          // postData.ban = 716942875;
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard', postData);
        },
        /* required params
         * ban	Account Number	716936547(Wireless)
         * ctn	Phone Number 4168145924
         */
        wirelessPostpaid: function (postData) {
          // postData.ban = 716936547;
          // postData.ctn = '4168145000';
          return backend.post('wirelessDashBoard/postPaidDetails', postData);
        },
        /* required params
         * ban	Account Number	716936547(Wireless)
         * ctn	Phone Number 4168145924
         */
        wirelessPostpaidV2: function (postData) {
          //return backend.post('wirelessDashBoard/postPaidDetailsV2', postData);
          var deferred = $q.defer();
          $http.post(userService.getBackendUrl('v2/wirelessDashBoard/postPaidDetails'), postData).then(
           function (response){
             deferred.resolve(response.data);
           }, function (errorResponse) {
             deferred.reject(errorResponse);
          });
          return deferred.promise;
        },
        interacEligibility: function (accountNumber, accountType, amountDue, amount) {
          var requestObj = {
            language: 'EN',
            accountNumber: accountNumber,
            accountTypeNumber: accountType,
            amountDue: amountDue,
            amount: amount
          };
          return backend.post('interac/getEligibility', requestObj);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        wirelessPrepaid: function (postData) {
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard/prepaidDetails', postData);
        },
        wirelessTravelPackageStaticContent: function (postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/staticContent', postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        wirelessTravelPackage: function (postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/getDetails', postData);
        },
        wirelessTravelPackageAddOnSummary: function (postData) {
          // postData.ban
          return backend.post('wirelessDashBoard/planAddOnSummary', postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        setwirelessTravelPackage: function (postData) {
          // postData.ban
          // postData.ctn
          // updateOptInOutFlag
          if (userService.isCare()) {
            postData.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }

          if (postData.evolutionOptInOutFlag) {
            return backend.post('wirelessDashBoard/rlh/setDetails', postData);
          } else {
            return backend.post('wirelessDashBoard/rlh/unEnroll', postData);
          }
        },
        /**
         * required params
         * ctn Phone Number 4162780218
         * ban	Account Number	716936547(Wireless)
         * type Service Type Wireless
         * 
         */
        adjustmentHistory: function (postData) {
          return backend.post('getAdjustmentHistory', postData);
        },
        /**
         * required params
         * ban	Account Number	716936547(Wireless)
         * 
         */
        applyAdjustment: function (url, accountNumber, postData) {
          return backend.post('account/' + accountNumber + '/adjustments' + url, postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        internetDashboard: function (accountNumber, language, ban) {
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            language: language,
            ban: ban
          };
          if (userService.isCare() && !passJson.ban) {
            passJson.ban = persistentStorageService.getFromSession('accountNumber');
          }
          return backend.post('internetDashBoard', passJson, 'internetdash');
        },
        internetDashboardUsage: function (accountNumber) {
          var passJson = {
            accountNumber: accountNumber,
            applicationId: 'Rogers.com'
          };
          if (userService.isCare() && !passJson.ban) {
            passJson.ban = persistentStorageService.getFromSession('accountNumber');
          }
          return backend.post('internetDashBoard/usage', passJson, 'internetdash');
        },
        internetDashboardProduct: function (accountNumber, refresh, language) {
          accountNumber = (accountNumber === undefined) ? 0 : accountNumber;
          refresh = (refresh === undefined) ? false : refresh;
          var passJson = {
            accountNumber: accountNumber,
            applicationId: 'Rogers.com',
            language: language,
            refresh: refresh
          };
          if (userService.isCare() && !passJson.ban) {
            passJson.ban = persistentStorageService.getFromSession('accountNumber');
          }
          return backend.post('internetDashBoard/productDetails', passJson, 'internetdash');
        },
        tvDashboard: function (accountNumber, language, ban, refresh) {
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            language: language.toLowerCase(),
            ban: ban,
            refresh: refresh
          };

          return backend.post('tvLanding', passJson);
        },
        tvFeed: function () {
          return backend.post('tv-feed/contents', {});
        },
        /*
         * Data Eviction Notificaton calls
         */
        notifyServerPreredeem: function (postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('maestro/preredeem', postData);
        },
        notifyServerLOBchange: function (postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('accounts/lobprechange', postData);
        },
        notifyServerDeviceStatuschange: function (postData) {
          return backend.post('wirelessDashBoard/deviceStatusChange', postData);
        },
        notifyServerLoggedIn: function () {
          return backend.post('loggedIn', {});
        },
        notifyServerLogout: function () {
          //return;
          if (ajax.discardAllSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardAllSmCookiesKillSwitch++;
            return backend.post('discardAllSmCookies', {});
          }
        },
        //Added to invoke UCS logout call just before signout
        /* notifyUcsLogout: function () {
         return backend.post('buy/cart/exit', {});
         },*/
        // notifyLegacyLogout: function () {
        //   //return;
        //   return backend.post('web/totesSignOut', {}, 'legacySignout');
        //   // Removed after consultation with Prasanth
        // },
        notifyServerDiscardSMCookies: function () {
          if (ajax.notifyServerDiscardSMCookiesKillSwitch < killSwitchTrigger) {
            ajax.notifyServerDiscardSMCookiesKillSwitch++;
            return backend.post('discardAllSmCookies', {});
          }
        },
        notifyServerDiscardLoginSMCookies: function () {
          if (ajax.discardLoginSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardLoginSmCookiesKillSwitch++;
            return backend.post('discardLoginSmCookies', {});

          }
        },
        /* required params
         * currentAccNumber 123456789
         */
        // getBriteBill: function (postData) {
        //   // postData.currentAccNumber
        //   return backend.post('encryptBritebill', postData);
        // },
        // getBriteBillListOfBills: function (postData, headerData) {
        //   return backend.post('briteBillList', postData, null, headerData);
        // },
        // briteBillDownload: function (url, postData, headerData) {
        //   return backend.post(url, postData, 'pdfDownload', headerData);
        // },
        getPermissions: function () {
          return permissionsService.getUserPermissions();
          // return backend.post('permissions');
        },
        getBrtSwitches: function () {
          return backend.post('brtSwitches');
        },
        abort: function () {
          return backend.abort();
        },
        verifyAddress: function (data) {
          return backend.post('SelfServeAutomation/verifyAddress', data);
        },
        verifyAddressV2: function (data) {
          if (userService.isCare()) {
            data.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/verifyAddressV2', data);
        },
        serverLog: function (data) {
          data.logLevel = 'INFO';
          return backend.post('log', data);
        },
        backToSSP: function (postData) {
          return backend.post('backToSSP', postData);
        },
        getInteraction: function (selectedAccount, lang) {
          var ban;
          if (userService.isCare()) {
            ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          var passJson = {
            lang: lang,
            ban: ban,
            accountNumber: selectedAccount
          };
          return backend.post('interactionDetails', passJson);
        },
        getEncryptNRSData: function (postData) {
          return backend.post('nrs/getPayload', postData);
        },
        getUsageData: function () {
          return backend.post('wirelessPricePlanChange/getUsageData');
        },
        checkEligibility: function (postData) {
          return backend.post('ppc/priceplans/eligibility', postData);
        },
        checkBOTEligibility: function (postData) {
          return backend.post('getCases', postData);
        },
        closeCase: function (postData) {
          return backend.post('closeCase', postData);
        },
        setState: function (postData) {
          //return backend.post('spa/state', postData, null, {'Content-Type': 'application/x-www-form-urlencoded'});
          return backend.post('spa/state', postData);
        },
        fetchOrder: function () {
          return backend.post('buy/cart/fetch');
        },
        getDeviceBalance: function (postData) {
          return backend.post('currentSubsidy', postData);
        },
        checkHupEligibility: function (postData) {
          return backend.post('checkHupEligibility', postData);
        },
        isNFDBCheck: function (postData) {
          return backend.post('checkNfdb', postData);
        },
        hupSaveState: function (postData) {
          return backend.post('hup/spa/saveState', postData);
        },
        hupGetState: function (postData) {
          return backend.post('hup/spa/getState', postData);
        },
        subscribers: function (postData) {
          return backend.post('ppc/subscribers', postData);
        },
        getCustomerInfo: function (postData) {
          if (userService.isCare()) {
            postData.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('customerInformation', postData);
        },
        updateUserPreference: function (userId, userType, userPreferenceName, userPreferenceValue) {
          var passJson = {
            userId: userId,
            userType: userType,
            userPreferenceName: userPreferenceName,
            userPreferenceValue: userPreferenceValue
          };
          return backend.post('userPreferenceUpdate', passJson);
        },
        getUserPreference: function (userId) {
          var passJson = {
            userId: userId
          };
          return backend.post('userPreferenceRetrieval', passJson);
        },
        getUserPreferenceByKey: function (userId, key) {
          return backend.post('userPreferenceRetrieval', {userId: userId}).then(function (data) {
            return data && data.userPreference ? data.userPreference : null;
          });
        },
        checkWinOnline: function (postData) {
          return backend.post('view/bill', postData);
        },
        resetPassword: function () {
          return backend.post('SelfServeAutomation/resetPassword');
        },
        getAccountStatus: function (postData) {
          if (userService.isCare()) {
            postData.ban = persistentStorageService.getFromSession('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/checkAccountStatus', postData);
        },
        unlockAccount: function (postData) {
          return backend.post('SelfServeAutomation/unlockAccount', postData);
        },
        getWcocJwtToken: function (postData) {
          return backend.post('wcoc/createjwttoken', postData);
        },
        decryptWcocJwtToken: function(postData) {
          return backend.post('wcoc/decryptjwttoken', postData);
        },
        //},
        /* required params
         * currentAccNumber 123456789
         */
        /* getBriteBill: function (postData) {
         // postData.currentAccNumber
         return backend.post('encryptBritebill', postData);
         },
         getBriteBillListOfBills: function (postData, headerData) {
         return backend.post('briteBillList', postData, null, headerData);
         },
         getPermissions: function () {
         return backend.post('permissions');
         },
         getBrtSwitches: function () {
         return backend.post('brtSwitches');
         },
         abort: function () {
         return backend.abort();
         },
         verifyAddress: function (data) {
         return backend.post('SelfServeAutomation/verifyAddress', data);
         },
         serverLog: function(data){
         data.logLevel = 'INFO';
         return backend.post('log',data);
         },
         backToSSP: function (postData) {
         return backend.post('backToSSP', postData);
         },
         getInteraction: function(selectedAccount, lang){
         var passJson = {
         lang: lang,
         accountNumber: selectedAccount
         };
         return backend.post('interactionDetails', passJson);
         },
         getEncryptNRSData: function(postData) {
         return backend.post('nrs/getPayload' ,postData);
         },
         getUsageData: function() {
         return backend.post('wirelessPricePlanChange/getUsageData');
         },
         checkEligibility: function (postData) {
         return backend.post('ppc/priceplans/eligibility', postData);
         },
         setState: function (postData) {
         //return backend.post('spa/state', postData, null, {'Content-Type': 'application/x-www-form-urlencoded'});
         return backend.post('spa/state', postData);
         },
         fetchOrder: function (){
         return backend.post('buy/cart/fetch');
         },
         getDeviceBalance: function (postData) {
         return backend.post('currentSubsidy', postData);
         },
         checkHupEligibility: function (postData) {
         return backend.post('checkHupEligibility', postData);
         },
         isNFDBCheck: function (postData) {
         return backend.post('checkNfdb', postData);
         },
         hupSaveState: function (postData) {
         return backend.post('hup/spa/saveState', postData);
         },
         hupGetState: function (postData) {
         return backend.post('hup/spa/getState', postData);
         },
         subscribers: function (postData) {
         return backend.post('ppc/subscribers', postData);
         },
         getCustomerInfo: function (postData) {
         return backend.post('customerInformation', postData);
         },
         updateUserPreference: function(userId, userType, userPreferenceName, userPreferenceValue){
         var passJson = {
         userId: userId,
         userType: userType,
         userPreferenceName: userPreferenceName,
         userPreferenceValue: userPreferenceValue
         };
         return backend.post('userPreferenceUpdate', passJson);
         },
         getUserPreference: function(userId){
         var passJson = {
         userId: userId
         };
         return backend.post('userPreferenceRetrieval', passJson);
         },
         resetPassword: function(){
         return backend.post('SelfServeAutomation/resetPassword');
         },*/
        getOneViewNews: function (request) {
          return backend.postExternalAPI(request);
        },
        getOneViewWeather: function (request) {
          return backend.postExternalAPI(request);
        },
        saveState: function (postData) {
          return backend.post('cart/save-state', postData);
        },
        fetchValidatedCart: function (postData) {
          return backend.post('buy/cart/fetch-validated-cart', postData);
        },
        validateOrder: function (postData) {
          return backend.post('checkout/validate-order', postData);
        },
        fetchCartOrder: function (postData) {
          return backend.post('cart/fetch', postData);
        },
        cancelOrder: function(postData) {
          return backend.post('cart/cancelOrder', postData);
        },
        getDiscoveryPageContent: function (postData) {
          return backend.post('discovery-page/get-content', postData);
        },
        getAgentPermission: function () {
          return backend.post('ram/permissions/all');
        },
        keepAlive: function () {
          return backend.post('session/keepalive');
        },
        getDealerProfile: function (dealerCodeValue) {
          var requestObj = {
            dealerID: dealerCodeValue
          };
          return backend.post('oneView/dealerProfile', requestObj);
        },
        saveDealerCode: function (dealerCodeValue) {
          var acctNbr = persistentStorageService.getFromSession('requestedAccountNumber');
          var requestObj = {
            acctNbr: acctNbr,
            dealerCode: dealerCodeValue
          };
          return backend.post('oneView/saveDealerCode', requestObj);
        },
        // inject and use ute.common.core.caching.CacheableDataFactory to implement simple caching of data for 1 minute
        // getCurrentPlan: function (postData) {
        //   return backend.post('ppc/priceplans/current', postData);
        // },
        nacSaveState: function (postData) {
          return backend.post('nac/saveState', postData);
        }
      };

      //Needed to bridge the gap between direct call to billing detail from rogers-client and calling the billing detail api through account overview service module
      function normalizedBillingDetails(data) {
        var normalizedData = _.cloneDeep(data);
        if (normalizedData.balanceAmount || normalizedData.balanceAmount === 0) {
          normalizedData.balanceAmount = normalizedData.balanceAmount.toString();
          if (normalizedData.balanceAmount.indexOf('.') === -1) {
            normalizedData.balanceAmount = normalizedData.balanceAmount = normalizedData.balanceAmount + '.00';
          }
        }
        if (normalizedData.methodOfPayment && normalizedData.methodOfPayment.mopType >= 0) {
          normalizedData.methodOfPayment.mopType = ute.rogers.account.overview.billing.detail.PaymentMethodType[normalizedData.methodOfPayment.mopType];
        }
        if (_.get(normalizedData, 'methodOfPayment.creditCardDetails.ccType') !== undefined && normalizedData.methodOfPayment.creditCardDetails.ccType >= 0) {
          normalizedData.methodOfPayment.creditCardDetails.ccType = ute.rogers.account.overview.billing.detail.CreditCardType[normalizedData.methodOfPayment.creditCardDetails.ccType];
        }

        normalizedData.usedCLM =  normalizedData.creditLimit - normalizedData.availableCreditAmount;
        normalizedData.usedCLMpercentage = ((normalizedData.usedCLM / normalizedData.creditLimit) * 100);

        return normalizedData;
      }
    }]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('ute.common.oneview.header').service('backToSSPService', backToSSPService);

  backToSSPService.$inject = ['$cookies', 'ajax', 'ute.oneview.header.service', 'ute.blocks.persistent.storage.service', 'ute.common.user.service'];

  /* @ngInject */
  function backToSSPService($cookies, ajax, oneViewHeaderService, persistentStorageService, userService) {
    var settings = oneViewHeaderService.getConfig().settings;
    var service = {
      targetFlow: null,
      backToSSP: function () {
        console.log('back to ssp service method');
        var language = $cookies.language;
        var province = $cookies.province;
        var phoneNumber = persistentStorageService.getFromLocal('phoneNumber');
        var accountNum = persistentStorageService.getFromLocal('accountNumber');
        var toStateName = persistentStorageService.getFromLocal('toStateName');
        if (userService.isCare()) {
          phoneNumber = persistentStorageService.getFromSession('phoneNumber');
          accountNum = persistentStorageService.getFromSession('accountNumber');
        }
        var postData = {
          ctn: phoneNumber,
          accountNumber: accountNum,
          lang: language,
          prov: province,
          targetFlow: service.targetFlow
        };
        if (toStateName != 'wireless') {
          postData.ctn = '';
        }
        ajax.backToSSP(postData).then(
            function (data) {
              if (data.isCableOnly) {
                console.log('back to ssp ajax success is cable');
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                $('#formToSSP').submit();
              } else {
                console.log('back to ssp ajax success not cable');
                $('#formToSSP').find('#sharedKey').val(data.sharedKey);
                $('#formToSSP').find('#signature').val(data.signature);
                $('#formToSSP').find('#content').val(data.content);
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.sspDashboardURL);
                $('#formToSSP').submit();
              }
            },
            function (error) {
              console.log('back to ssp ajax error', error);
              $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
              $('#formToSSP').submit();
            }
        );
      }
    };
    return service;

  }
})();

'use strict';

angular.module('ute.common.oneview.header')

    .factory('backend', ['ute.oneview.header.service', '$http', '$q', '$translate', 'userOptions', 'maintenanceService', '$location', '$rootScope', 'ute.blocks.persistent.storage.service', 'miscService',
      function (oneViewHeaderService, $http, $q, $translate, userOptions, maintenanceService, $location, $rootScope, persistentStorageService, miscService) {
        var settings = oneViewHeaderService.getConfig().settings;
        var protectedUrlPrefix = settings.protectedUrlPrefix;
        var unprotectedUrlPrefix = settings.unProtectedUrlPrefix;
        //		$rootScope.abortList = [];

        function absUrl(relativeUrl, useProtectedPrefix) {
          if (useProtectedPrefix) {
            return protectedUrlPrefix + relativeUrl;
          } else {
            return unprotectedUrlPrefix + relativeUrl;
          }
        }

        /*
         function removeCanceller(cancelObj) {
         for (var i=0; i < $rootScope.abortList.length; i++) {
         if (cancelObj === $rootScope.abortList[i]) {
         delete $rootScope.abortList[i];
         $rootScope.abortList.splice(i,1);
         }
         }
         }
         //*/
        function addParameterToURL(url, param) {
          var _url = url;
          _url += (_url.split('?')[1] ? '&' : '?') + param;
          return _url;
        }

        function handleError(response, override503ErrorHandling) {
          // look for error code and pick action based on that
          var statusCode = response.status;
          var statusText = response.statusText;
          var statusMessage = statusCode + ' - ' + statusText;
          var error = response.data;

          // Compile more informative error message
          var message = '';

          /*
           * Error brackets
           */

          // 0 - 199
          if (statusCode >= 0 && statusCode < 200) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 300 - 399
          if (statusCode >= 300 && statusCode < 400) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 400 - 499
          if (statusCode >= 400 && statusCode < 500) {
            // Session expired or user is trying to access data without proper credentials
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }

            // Special treatment
            if (statusCode === 401) {
              // Analyze requester - if this comes from login page -> pass the response back to the controller
              var sourceURL = response.config.url;
              var sourceArray = sourceURL.split('/');
              var sourceLength = sourceArray.length;
              var action = sourceArray[(sourceLength - 1)];

              if (action === 'testlogin' || action === 'signin') {
                // Failed credentials
                return $q.reject({$handled: false, originalError: statusMessage, data: response, action: 'invalidCredentials'});

              } else {
                // Most likely session expired and server is returning 401s
                return $q.reject({$handled: true, originalError: statusMessage, data: response, action: 'userLogout'});
              }
            } else {
              return $q.reject({$handled: false, originalError: statusMessage, data: response});
            }

          } else
          // 500 - 554

          if (statusCode === 503 && !override503ErrorHandling) {
            persistentStorageService.putToLocal('maintPage', 'siteMaint');
            if ($rootScope.isCare) {
              persistentStorageService.putToSession('maintPage', 'siteMaint');
            }
            maintenanceService.switchView('/underMaintenance');
          }
          if (statusCode >= 500 && statusCode < 555) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              //userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 555 - Special case
          if (statusCode === 555) {

            // This section HAS TO pass the error through to the controller fo further processing
            // ALSO to have a way for caller functions to deal with the response.

            var retObj = {};
            var resourceId = null;

            if (error === '') {
              // empty / no message
              // Additional logic goes here to treat the error locally

            } else if (angular.isString(error) && error.search(/<html.*>/i) >= 0) {
              // HTML response
              // Additional logic goes here to treat the error locally

            } else {
              // likely JSON response

              /**
               * The following code is for the new backend Processing Wrapper
               * with different error handling for errorCode and errorMessage
               */
              if (angular.isUndefined(error.errorCode) && _.has(error, 'status.code')) {
                error.errorCode = error.status.code;
              }
              if (angular.isUndefined(error.errorMessage) && _.has(error, 'status.codeName')) {
                error.errorMessage = error.status.codeName;
              }
              try {
                if (error.errorCode >= 10000 && error.errorCode < 11000) {
                  // Event range (ususally in step of 100)
                  resourceId = error.errorCode;

                } else if (error.errorCode >= 11000 && error.errorCode < 12000) {
                  // Event range (ususally in step of 100)
                  resourceId = error.errorCode;

                } else if (error.errorCode >= 12000 && error.errorCode < 12100) {
                  // Loyalty special messages
                  if (error.errorMessage === 'A') {
                    // active - do not trigger error message

                  } else if (error.errorMessage === 'S') {
                    // Suspended - trigger error message but show widget
                    resourceId = error.errorCode + '-' + error.errorMessage;

                  } else {
                    // Do not show the widget and do not show the error
                    resourceId = error.errorCode + '-' + error.errorMessage;
                  }

                } else if (error.errorCode >= 50000 && error.errorCode < 51000) {
                  // Server important
                  resourceId = error.errorCode;

                } else {
                  resourceId = '50000';
                }

              } catch (err) {
                resourceId = '50000';
              }

              // map 50000 unknown error message to generic maintainence message
              if (resourceId === 50000) {
                resourceId = 'maintenance_info';
              }

              // Pass the message
              // message += '<small>For customers:</small><br/>';
              message += $translate.instant('' + resourceId);
            }

            //				message = response.statusText? response.statusText: $translate.instant('50000');
            if (settings.showErrorPopup) {
              //userOptions.alert(message);
            }

            // Reject the value back to caller - For local handling
            retObj.errorCode = error.errorCode;
            retObj.errorMessage = error.errorMessage;
            retObj.message = message;
            retObj.statusCode = 555;

            return $q.reject({$handled: false, originalError: statusMessage, data: response, error: retObj});

          } else {
            // Every other status code and some that don't exist
            if (settings.showErrorPopup) {
              //userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});
          }
        }

        return {
          postUsingAbsoluteUrl: function (absoluteUrl, data, isFormData, headerData, method, enableCaching, override503ErrorHandling) {
            if (!data) {
              data = {};
            }

            var canceller = $q.defer();
            var _method = 'POST';
            if (method) {
              _method = method;
            }
            // $rootScope.abortList.push(canceller);
            var httpRequest;
            var _url = absoluteUrl;
            if (method === 'GET') {
              for (var key in data) {
                _url = addParameterToURL(_url, key + '=' + data[key]);
              }
            }
            if (isFormData) {
              httpRequest = $http.post(
                  _url,
                  $.param(data),
                  {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
              );
            } else {
              if (method === 'GET') {
                if (typeof (enableCaching) === 'boolean') {
                  httpRequest = $http({
                    method: _method,
                    url: _url,
                    data: data,
                    headers: headerData,
                    transformResponse: undefined,
                    cache: enableCaching
                  });
                } else {
                  httpRequest = $http({
                    method: _method,
                    url: _url,
                    data: data,
                    headers: headerData,
                    transformResponse: undefined
                  });
                }
              } else {
                httpRequest = $http({
                  method: _method,
                  url: _url,
                  data: data,
                  headers: headerData
                });
              }
            }

            //fix for discardAllSmCookies loop
            var isLogoff = absoluteUrl.indexOf('discardAllSmCookies') >= 0;

            var req = httpRequest.then(
                //response is like {config:xx,data:{}, headers: function () {}, status:200, statusText }
                //response.data is what server return to client
                function (response) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    miscService.kickOutExpired();
                  }

                  if (response.status > 199 && response.status < 300) {
                    // Something is right
                    var _json = null;
                    _json = response.data;

                    if (!_json || (angular.isString(_json) && _json.search(/<html.*>/i) >= 0)) {
                      // Response is HTML but it is a pass from server. Strip out HTML -> return null instead
                      _json = null;
                    }
                    return _json;

                  } else {
                    // Something is wrong
                    return handleError(response);
                  }

                }, function (errorData) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    miscService.kickOutExpired();
                  }

                  return handleError(errorData, override503ErrorHandling);
                }
            );
            return req;
          },

          pathResolver: function (relativeUrl) {
            var returnPath = '';

            // 1) settings
            var defaultLevel = settings.secureCallDefault;
            //var currentModule = $route.current.params.module;

            //Change for ui-router migration - Commented out on Feb 19th 2015 - due to timing issue comming from local storage
            // var toStateName = localStorage.getLocalStorageValue('toStateName');
            // var currentModule = (toStateName) ? toStateName : $state.current.name;
            var currentModule = $location.path(); //$state.current.name
            if (currentModule.charAt(0) === '/') {
              currentModule = currentModule.substr(1);
            }

            //var currentModule2 = $location.path();

            // 2) is page UNsecure call listed?
            var moduleListed = settings.secureCallPages;
            var pID = moduleListed.indexOf(currentModule);
            if (pID >= 0) {
              defaultLevel = false;				// item found in the array  ->  UNsecure call
            } else {
              // index = -1 -> not found, keep the level
            }

            // 3) is the call UNsecure listed
            var callListed = settings.unprotectedCalls;
            var cID = callListed.indexOf(relativeUrl);
            if (cID >= 0) {
              defaultLevel = false;				// item found in the array  ->  UNsecure call
            } else {
              // index = -1 -> not found, keep the level
            }

            // Localhost hack!!!! FIX the real cause!!!!!!!

            if (relativeUrl == 'teamsite/list' && !window.location.hash.match('sidh')) {
              defaultLevel = false;
            }
            if (window.location.hash.match('sidh')) {
              settings.protectedUrlPrefix = '/v1/';
              settings.unProtectedUrlPrefix = '/v1/';
            }
            // End of hack

            var protectedCallListed = settings.protectedCalls;
            var pcID = protectedCallListed.indexOf(relativeUrl);
            if (pcID >= 0) {
              defaultLevel = true;       // item found in the array  ->  secure call
            }

            // 4) switch from true/false for string -> secure / unsecure URL
            if (defaultLevel) {
              // Secure path
              returnPath = settings.protectedUrlPrefix + relativeUrl;
            } else {
              // Unsecure path
              returnPath = settings.unProtectedUrlPrefix + relativeUrl;
            }

            // EXCEPTIONS
            // 5) Special URLs provided for specific modules - custom path overide
            var pageExceptions = settings.moduleCallException;
            if (pageExceptions[currentModule]) {
              returnPath = pageExceptions[currentModule];
            }

            // 6) Special URLs provided for specific calls - custom path overide
            var callExceptions = settings.ajaxCallException;
            if (callExceptions[relativeUrl]) {
              returnPath = callExceptions[relativeUrl];
            }

            // The backend call should not append RogersServices.portal for dealer or care
            // As the authentication is taken care in server side through SSO
            if ($rootScope.isDealer || $rootScope.isCare) {
              returnPath = settings.unProtectedUrlPrefix + relativeUrl;
            }
            return returnPath;
          },

          getFromLocal: function (relativeUrl) {
            // $rootScope.abortList.push(canceller);
            var httpRequest;

            var absoluteUrl = (relativeUrl.indexOf('/') > -1) ? 'api/' + relativeUrl.substr(relativeUrl.lastIndexOf('/'), relativeUrl.length) : 'api/' + relativeUrl;
            var _method = 'GET';
            var data = '';

            httpRequest = $http({
              method: _method,
              url: absoluteUrl,
              data: data
            });

            //fix for discardAllSmCookies loop
            var isLogoff = absoluteUrl.indexOf('discardAllSmCookies') >= 0;

            var req = httpRequest.then(
                //response is like {config:xx,data:{}, headers: function () {}, status:200, statusText }
                //response.data is what server return to client
                function (response) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    miscService.kickOutExpired();
                  }

                  if (response.status > 199 && response.status < 300) {
                    // Something is right
                    var _json = null;
                    _json = response.data;

                    if (!_json || (angular.isString(_json) && _json.search(/<html.*>/i) >= 0)) {
                      // Response is HTML but it is a pass from server. Strip out HTML -> return null instead
                      _json = null;
                    }
                    return _json;

                  } else {
                    // Something is wrong
                    return handleError(response);
                  }

                }, function (errorData) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    miscService.kickOutExpired();
                  }

                  return handleError(errorData);
                }
            );
            return req;

          },

          post: function (relativeUrl, data, moduleName, headerData) {

            if (settings.useLocalAPI) {
              this.getFromLocal(relativeUrl);
            } else {

              var method = '', enableCaching, override503ErrorHandling = false;
              var fullPath = this.pathResolver(relativeUrl);

              //if(relativeUrl === "maintenanceSettings") fullPath = 'http://10.73.115.75:32263/v1/settings'; 
              
              // Ticket TOT-1201 hack
              if (relativeUrl === 'wirelessDashBoard/rlh/staticContent') {
                fullPath = '/cms/page-specific/addons/content/travel/union-pricing.js';
              } else if (relativeUrl === 'briteBillList') { // Ticket TOT-1128
                fullPath = '/rogers_rest/rogers/documents/activatedUserSummary';
                method = 'GET';
                enableCaching = false; //caching should be disabled for brite bill calls.
                override503ErrorHandling = true;
                // } else if (relativeUrl === 'briteBillDownload') { // Ticket PUB2016-22
                //   fullPath = '/rogers_rest/' + data.link + '.pdf';
                //   data = null;
                //   method = 'GET';
              } else if (relativeUrl === 'news') {
                fullPath = settings.oneViewExternalAPIs.news + moduleName;
              } else if (relativeUrl === 'weather') {
                method = 'GET';
                fullPath = settings.oneViewExternalAPIs.weather + moduleName;
              } else if (moduleName === 'pdfDownload') {
                method = 'GET';
                fullPath = relativeUrl;
              } else if (relativeUrl === 'account/session/keepalive') {
                method = 'POST';
                enableCaching = false;
              }

              /* if(relativeUrl === "buy/cart/exit"){
               method = 'GET';
               }*/

              return this.postUsingAbsoluteUrl(fullPath, data, false, headerData, method, enableCaching, override503ErrorHandling);
            }
          },

          postFormData: function (relativeUrl, data, moduleName, headerData) {
            var fullPath = this.pathResolver(relativeUrl);
            return this.postUsingAbsoluteUrl(fullPath, data, true);
          },

          postToNonAPIlocation: function (fullPath, data) {
            return this.postUsingAbsoluteUrl(fullPath, data, true);
          },

          jsonp: function (absUrl) {
            if (!absUrl) {
              return false;
            }

            return $http.jsonp(absUrl).then(
                function (response) {
                  return response.data;

                }, function (response) {
                  handleError(response);
                }
            );
          },
          abort: function () {
            /*
             for (var i=0; i < $rootScope.abortList.length; i++) {
             $rootScope.abortList[i].resolve();
             }
             return;
             //*/
          },
          getOffers: function (request) {
            var deferred = $q.defer();
            var consumerUrl = settings.revolutionGetOffersPrefix + settings.revolutionGetOffers,
                oneViewUrl = settings.oneViewRevolutionGetOffersPrefix + settings.revolutionGetOffers,
                URL = $rootScope.isConsumer === true ? consumerUrl : oneViewUrl;
            $http({
              //url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
              url: URL, //'http://10.10.94.138:9000/selfserve/v1/offer-status',
              //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
              method: 'POST',
              params: request,

              cache: false
            }).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          },
          getRevPermissions: function (request) {
            var deferred = $q.defer();

            $http({
              // url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
              url: 'http://10.10.94.153:9000/v1/permissions',
              //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
              method: 'POST',
              params: request,
              cache: false
            }).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          },
          postExternalAPI: function (request) {
            var deferred = $q.defer();

            /* $http( {
             url: request.url+request.moduleName,
             method: request.method,
             headers: request.headerData
             } ).then( function( result ) {
             deferred.resolve( result );
             return result;

             }, function( error ) {
             deferred.reject( error );
             } );*/
            $http({url: request.url + request.moduleName}).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        };
      }]);
(function () {
  'use strict';

  angular.module('ute.common.oneview.header').service('bfappcWirelessDashboardService', bfappcWirelessDashboardService);

  bfappcWirelessDashboardService.$inject = ['$q',
    '$state',
    '$modal',
    'ajax',
    '$translate',
    'pricePlanChangesErrors',
    'myrWirelessDashboardService',
    'ute.common.core.brtswitch.service',
    'ute.blocks.language.switcher',
    'ute.common.user.service',
    'ute.dtm.service',
    'ute.blocks.persistent.storage.service'];

  function bfappcWirelessDashboardService($q,
                                          $state,
                                          $modal,
                                          ajax,
                                          $translate,
                                          pricePlanChangesErrors,
                                          myrWirelessDashboardService,
                                          brtSwitchService,
                                          languageSwitcher,
                                          userService,
                                          dtmService,
                                          persistentStorageService) {
    var dtmBuyFlowError = 'fdm-bf-error';
    var self = {
      scope: {},
      fetchOrderCompleted: false,
      bfappcOrders: [],
      bfahupOrders: [],
      // brtSwitch: {
      //   ppc: null,
      //   mppc: null,
      //   q2ppc: null
      // },
      permission: {
        ppc: null,
        mppc: null
      },
      subscribers: null,
      selectedAdditionalSubscribers: [],
      selectedPrimary: '',
      changeBtnLoadingStatus: false
    };

    self.hasOrder = function (ctn) {
      return self.bfappcOrders.length > 0 && self.getSwitchToOrder(ctn) && self.getOnlyOrders(ctn).length > 0;
    };

    self.getOnlyOrders = function (ctn) {
      return _.filter(self.bfappcOrders, function (order) {
        return _.indexOf(order.assemblyIds, ctn) >= 0 && !order.quotation;
      });
    };

    self.getCurrentOrder = function (ctn) {
      return _.find(self.bfappcOrders, function (order) {
        return order.currentOrder === true && _.indexOf(order.assemblyIds, ctn) >= 0;
      });
    };

    self.getSwitchToOrder = function (ctn) {
      return _.find(self.bfappcOrders, function (order) {
        return _.find(order.assemblyIds, function (assemblyId) {
          return assemblyId == ctn;
        });
      });
    };

    self.isFetchOrderCompleted = function () {
      return self.fetchOrderCompleted;
    };

    self.fetchOrder = function (postData) {
      //console.info('fetchOrder');
      //ajax.fetchOrder().then(
      var deferred = $q.defer();
      ajax.fetchCartOrder(postData).then(
        function (response) {
          self.fetchOrderCompleted = true;
          if (response && response.success) {
            self.fetchOrderFullResponse = response;
            deferred.resolve(self.fetchOrderFullResponse);
            if (response.ppc && response.ppc.length) {
              self.bfappcOrders = response.ppc;
            }
          } else {
            // PPC TODO: error message on fetch error
          }
          if (response.hup && response.hup.length){
            self.bfahupOrders = response.hup;
          }
        }
      ).catch(
        function () {
          self.fetchOrderCompleted = true;
          deferred.reject();
          // PPC TODO: error message on fetch error
        }
      );
      return deferred.promise;
    };

    var trackPpcDtmError = function (errorMessage) {
      try {
        var dtmMessage = angular.element('<span>' + errorMessage + '</span>');
        dtmService.setVar('error', dtmMessage.text() + '|PPC');
        dtmService.direct(dtmBuyFlowError);
        dtmMessage = null;
      } catch (err) {
        console.log('trackPpcDtmError:', err);
      }
    };

    self.gotoBFAPPC = function (appStateForPPC, resumeOrder) {
      var deferred = $q.defer();
      self.appStateForPPC = appStateForPPC;
      self.processAllowedPpcBrt(deferred, resumeOrder);
      return deferred.promise;
    };

    self.processAllowedPpcBrt = function (deferred, resumeOrder) {
      self.hasMultipleSubscribers().then(
        function (hasMultipleSubscribers) {
          if (!hasMultipleSubscribers) {
            deferred.resolve();
            self.checkEligibilityAndSaveState('single', 'all').then(function () {
              $state.go('ppc-singleline');
            });
          } else {
                  self.redirectToPpc(resumeOrder);
          }
        }
      );
    };

    self.isMultiline = function () {
      var deferred = $q.defer();
      // Abdellatif said, if there is an additional subscriber, it is multiline, no matter what the current ctn is
      self.getSubscribers().then(
        function (subscribers) {
          var isMultiline = _.filter(subscribers, function (subscriber) {
              return subscriber.familyShareStatus === 'Additional';
            }).length > 0;
          deferred.resolve(isMultiline);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    self.hasMainSubscriber = function () {
      var deferred = $q.defer();
      self.getSubscribers().then(
        function (subscribers) {
          var hasMain = _.filter(subscribers, function (subscriber) {
              return subscriber.familyShareStatus === 'Main';
            }).length > 0;
          deferred.resolve(hasMain);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    self.hasMultipleSubscribers = function () {
      var deferred = $q.defer();
      self.getSubscribers().then(
        function (subscribers) {
          deferred.resolve(subscribers.length > 1);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    // self.isBRT = function (type) {
    //   var deferred = $q.defer();
    //   if (self.brtSwitch[type] !== null) {
    //     deferred.resolve(self.brtSwitch[type]);
    //   } else {
    //     ajax.getBrtSwitches().then(
    //       function (response) {
    //         // keep the value for PPC_UTE switch, if true means q2PPC(old PPC) is on the BRT mode.
    //         self.brtSwitch.q2ppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'PPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         self.brtSwitch.ppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'NPPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         self.brtSwitch.mppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'MULTI_NPPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         deferred.resolve(self.brtSwitch[type]);
    //       },
    //       function () {
    //         pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
    //         self.changeBtnLoading(false);
    //         deferred.reject();
    //       }
    //     );
    //   }
    //   return deferred.promise;
    // };

    self.isEligible = function (flowType) {
      var deferred = $q.defer();
      var isPpcEligible = false;
      var isPpcBotEligible = false;
      var ppcEligibilityChecks = [];
      var postData = {
        accountNumber: (userService.isCare()) ? persistentStorageService.getFromSession('accountNumber') : persistentStorageService.getFromLocal('accountNumber'),
        accountTypeNumber: (userService.isCare()) ? persistentStorageService.getFromSession('accountTypeNumber') : persistentStorageService.getFromLocal('accountTypeNumber'),
        subscriberNumber: (userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber'),
        consolidatedInd: 'NO',
        flowType: flowType
      };
      if (self.selectedPrimary !== '' && self.selectedPrimary !== null) {
        postData.subscriberNumber = self.selectedPrimary;
      }
      ppcEligibilityChecks.push(ajax.checkEligibility(postData).then(
        function (response) {
          self.appStateForPPC.eligibilityChecked = response.eligible;
          self.appStateForPPC.availableCreditAmount = response.availableCreditAmount;

          if (response.eligible) {
            isPpcEligible = true;
            return isPpcEligible;
          } else {
            var errorResponse = (response && response.eligibilityCode) ? response : {
              'eligible': false,
              'eligibilityCode': '500'
            };
            $modal.open({
              controller: 'notEligibleModalCtrl',
              controllerAs: 'vm',
              templateUrl: 'module/views/modals/ppc-not-eligible.html',
              size: 'md',
              backdrop: 'static',
              backdropClass: 'bkg-modal',
              resolve: {
                'eligibilityResponse': function () {
                  return errorResponse;
                }
              }
            });
            deferred.reject();
          }
        },
        function (response) {
          if (response && response.eligibilityCode) {
            $modal.open({
              controller: 'notEligibleModalCtrl',
              controllerAs: 'vm',
              templateUrl: 'module/views/modals/ppc-not-eligible.html',
              size: 'md',
              backdrop: 'static',
              backdropClass: 'bkg-modal',
              resolve: {
                'eligibilityResponse': function () {
                  return response;
                }
              }
            });
          } else {
            pricePlanChangesErrors.showError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_title'), $translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'), ['OK'], null, true);
            trackPpcDtmError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'));
          }
          self.changeBtnLoading(false);
          deferred.reject();
        }
      ).finally(
        function () {
          //self.selectedPrimary = null;
        }
      ));
      if (userService.isCare() || userService.isDealer()) {
        var request = {
          accountNumber: (userService.isCare()) ? persistentStorageService.getFromSession('accountNumber') : persistentStorageService.getFromLocal('accountNumber'),
          lang: languageSwitcher.getCurrentLanguage().toUpperCase()
        };
        persistentStorageService.putToSession('botFlowType', 'PPC'); //BCR-693 Analytics: Tracking flowType for getCases api
        ppcEligibilityChecks.push(ajax.checkBOTEligibility(request).then(
          function (responseBOT) {
            var isBOTEligible = true;
            var openCases = {};
            angular.forEach(responseBOT.getCasesResponse.cases._case, function (value, key) {
              if ((value.caseStatus.toLowerCase() === "new" || value.caseStatus.toLowerCase() === "in progress" || value.caseStatus.toLowerCase() === "new case") && (value.caseTypeLevel3.toLowerCase() === "hup" || value.caseTypeLevel3.toLowerCase() === "price plan change")) {
                isBOTEligible = false;
                openCases = value;
              }
            });
            if (isBOTEligible) {
              isPpcBotEligible = true;
              return isPpcBotEligible;
            }
            else {
              if (isPpcEligible) {
                var errorResponse = (responseBOT && responseBOT.eligibilityCode) ? responseBOT : {
                  eligible: false,
                  eligibilityCode: 'bot_eligible',
                  openCases: openCases
                };
                $modal.open({
                  controller: 'notEligibleModalCtrl',
                  controllerAs: 'vm',
                  templateUrl: 'module/views/modals/ppc-not-eligible.html',
                  size: 'md',
                  backdrop: 'static',
                  backdropClass: 'bkg-modal',
                  resolve: {
                    'eligibilityResponse': function () {
                      return errorResponse;
                    }
                  }
                });
                deferred.reject();
              }
            }
          }, function (error) {
            pricePlanChangesErrors.showError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_title'), $translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'), ['OK'], null, true);
            self.changeBtnLoading(false);
            deferred.reject();
          }
        ));
      }

      $q.all(ppcEligibilityChecks).then(function (response) {
        if (response.length === 1) {
          if (response[0]) {
            deferred.resolve();
          }
        }
        else {
          if (response[0] && response[1]) {
            deferred.resolve();
          }
        }
      });

      return deferred.promise;
    };

    self.saveState = function (filterOption) {
      filterOption = filterOption || 'all';
      self.appStateForPPC.ban = (userService.isCare()) ? persistentStorageService.getFromSession('accountNumber') : persistentStorageService.getFromLocal('accountNumber');
      self.appStateForPPC.ctnWirelessDashboard = (userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber');
      if (self.selectedPrimary !== '' && self.selectedPrimary !== null) {
        self.appStateForPPC.ctn = self.selectedPrimary;
      } else {
        self.appStateForPPC.ctn = self.appStateForPPC.ctnWirelessDashboard;
      }
      self.appStateForPPC.accountTypeNumber = (userService.isCare()) ? persistentStorageService.getFromSession('accountTypeNumber') : persistentStorageService.getFromLocal('accountTypeNumber');
      self.appStateForPPC.selectedAdditionalSubscribers = self.selectedAdditionalSubscribers.join(',');

      self.appStateForPPC.ctnList = _.pluck(myrWirelessDashboardService.getWirelessDashData(), 'ctn');
      self.appStateForPPC.filterOption = filterOption;
      return ajax.setState(self.appStateForPPC);
    };

    self.getSubscribers = function () {

      var deferred = $q.defer();
      var postData = {
        accountNumber: (userService.isCare()) ? persistentStorageService.getFromSession('accountNumber') : persistentStorageService.getFromLocal('accountNumber')
      };
      if (self.subscribers !== null) {
        deferred.resolve(self.subscribers);
      } else {
        ajax.subscribers(postData).then(
          function (response) {
            self.subscribers = response.subscribers;
            deferred.resolve(response.subscribers);
          },
          function () {
            pricePlanChangesErrors.showError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_title'), $translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'), ['OK'], null, true);
            self.changeBtnLoading(false);
            trackPpcDtmError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'));
            deferred.reject();
          }
        );
      }
      return deferred.promise;
    };

    self.redirectToPpc = function (resumeOrder) {
      if (resumeOrder) {
        self.appStateForPPC.eligibilityChecked = false;
        self.saveState().then(
          function () {
            $state.go('ppc-resume-order');
          }
        );
        return;
      }

      //if mainSubscriber is undefined it means there is no shared group
      var mainSubscriber = _.find(self.subscribers, function (subscriber) {
        return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
      });

      var currentCtnShareStatus = _.result(_.find(self.subscribers, function (subscriber) {
        return subscriber.subscriberNumber === ((userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber'));
      }), 'familyShareStatus');

      var numberOfAdditionalSubscribers = 0;
      var numberOfIndividualSubscribers = 0;
      angular.forEach(self.subscribers, function (subscriber) {
        if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional') {
          numberOfAdditionalSubscribers++;
        }
        if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Individual') {
          numberOfIndividualSubscribers++;
        }
      });

      if (mainSubscriber !== undefined) {
        // below cases are defined in BFA-1911

        if (numberOfAdditionalSubscribers == 0 && currentCtnShareStatus === 'Main') {
          // if there is only 1 subscriber and it is 'main', user must be directed to single line NOT multi line
          // or 'main' & 1+ 'individual' & no additional, also redirect to SL-PPC
          self.checkEligibilityAndSaveState('single', 'all').then(function () {
            $state.go('ppc-singleline');
          });
        } else if (currentCtnShareStatus === 'Additional') {
          self.isEligible('multi').then(function () {
            self.selectedPrimary = mainSubscriber.subscriberNumber;
            self.checkEligibilityAndSaveState('multi', 'main').then(function () {
              $state.go('ppc-multiline-entry-2');
            });
          });
        } else if (currentCtnShareStatus === 'Main') {
          //customer already has a shared group and selected an additional/main CTN
          // bfa-4584: check main ctn eligibility before going into ML flow
          // previous logic: covers 4, 5, 7 - As Abdellatif said, for entry point 2, we should do eligibility check in the entry point itself only for main and we should do eligibility check for additional lines in the calling options page
          self.selectedPrimary = mainSubscriber.subscriberNumber;
          self.checkEligibilityAndSaveState('multi', 'main').then(function () {
            $state.go('ppc-multiline-entry-2');
          });
        } else if (currentCtnShareStatus === 'Individual') {
          //customer already has a shared group and selected an individual CTN
          //covers 6
          self.showThirdMultiLineEntry();
        }

      } else if (currentCtnShareStatus === 'Individual') {
        //covers cases 1, 2, 3
        if (numberOfIndividualSubscribers == 1) {
          self.checkEligibilityAndSaveState('single', 'all').then(function () {
            $state.go('ppc-singleline');
          });
        } else {
          self.showFirstMultiLineEntry();
        }

      }
    };

    self.showThirdMultiLineEntry = function () {
      var entry3ModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html',
        controller: 'mppcEntry3Ctrl'
      });

      entry3ModalInstance.result.then(
        function (response) {
          if (response === 'changeCurrentPlan') {
            self.checkEligibilityAndSaveState('single', 'individual').then(function () {
              $state.go('ppc-singleline');
            });
          } else if (response === 'addToSharedGroup') {
            self.selectedAdditionalSubscribers = _.pluck(_.filter(self.subscribers, function (subscriber) {
              return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional';
            }), 'subscriberNumber');
            self.selectedAdditionalSubscribers.push((userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber'));

            self.selectedPrimary = _.find(self.subscribers, function (subscriber) {
              return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
            }).subscriberNumber;
            self.askAddAdditionalData();
          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.askAddAdditionalData = function () {
      var addAdditionalDataModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcAddAditionalDataModal.html',
        controller: 'mppcAddAdditionalDataModalCtrl'
      });

      addAdditionalDataModalInstance.result.then(
        function (response) {
          self.checkEligibilityAndSaveState('multi', 'main').then(function () {
            if (response) {
              $state.go('ppc-multiline-step-1');
            } else {
              $state.go('ppc-multiline-step-2');
            }
          });
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.showFirstMultiLineEntry = function () {
      var entry1ModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html',
        controller: 'mppcEntry1Ctrl'
      });

      entry1ModalInstance.result.then(
        function (response) {
          if (response === 'changeCurrentPlan') {
            self.checkEligibilityAndSaveState('single', 'all').then(function () {
              $state.go('ppc-singleline');
            });
          } else if (response === 'createSharedGroup') {
            self.createSharedGroup();
          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.createSharedGroup = function () {
      var shareGroupIndividualModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html',
        controller: 'mppcSharedGroupIndividualModalCtrl',
        resolve: {
          subscribers: function () {
            return self.subscribers;
          },
          currentCtn: function () {
            return (userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber');
          }
        }
      });

      shareGroupIndividualModalInstance.result.then(
        function (selectedAdditionalSubscribers) {
          // we need to group the current CTN with these selected subscribers
          var currentCtn = (userService.isCare()) ? persistentStorageService.getFromSession('phoneNumber') : persistentStorageService.getFromLocal('phoneNumber');
          if (selectedAdditionalSubscribers.length > 0) {
            self.selectedAdditionalSubscribers = selectedAdditionalSubscribers;
            var shareGroupPrimaryModalInstance = $modal.open({
              templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html',
              controller: 'mppcSharedGroupPrimaryModalCtrl',
              resolve: {
                selectedAdditionalSubscribers: function () {
                  return selectedAdditionalSubscribers;
                },
                currentCtn: function () {
                  return currentCtn;
                }
              }
            });

            shareGroupPrimaryModalInstance.result.then(
              function (selectedPrimary) {
                if (selectedPrimary) {
                  if (selectedPrimary != currentCtn) {
                    //if user changed the primary subscriber, so old primary one should be an additional now!
                    self.selectedAdditionalSubscribers.push([currentCtn]);
                    //the new selectedPrimary ctn must ne remove from selectedAdditionalSubscribers, because it is a primary now!
                    _.remove(selectedAdditionalSubscribers, function (item) {
                      return item === selectedPrimary;
                    });
                  }
                  self.selectedPrimary = selectedPrimary;
                  self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                    $state.go('ppc-multiline-step-1');
                  });

                }
              },
              function () {
                self.changeBtnLoading(false);
              }
            );

          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.checkEligibilityAndSaveState = function (flowType, filterOption) {
      var deferred = $q.defer();
      self.isEligible(flowType).then(function () {
          self.saveState(filterOption).then(
            function () {
              deferred.resolve();
            },
            function (saveStateError) {
              pricePlanChangesErrors.showError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_title'), $translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'), ['OK'], null, true);
              self.changeBtnLoading(false);
              deferred.reject();
            });
        },
        function () {
          // already displayed eligibility error in isEligible()
          deferred.reject();
        });
      return deferred.promise;
    };

    self.clean = function () {
      self.appStateForPPC = {};
      self.fetchOrderCompleted = false;
      self.bfappcOrders.length = 0;
      self.bfahupOrders.length = 0;
      self.brtSwitch = {
        ppc: null,
        mppc: null,
        q2ppc: null
      };
      self.permission = {
        ppc: null,
        mppc: null
      };
      self.subscribers = null;
      self.fetchOrderFullResponse = {};
      self.changeBtnLoadingStatus = false;
    };

    self.getFetchOrderFullResponse = function () {
      return self.fetchOrderFullResponse;
    };

    self.changeBtnLoading = function (status) {
      if (!arguments.length) {
        return self.changeBtnLoadingStatus;
      }
      self.changeBtnLoadingStatus = status;
    };

    self.openSomethingWentWrongPopup = function(){
      pricePlanChangesErrors.showError($translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_title'), $translate.instant('ute.common.oneview.header.bfappcWirelessDashboardService.ppc_something_went_wrong_message_text'), ['OK'], null, true);
    };

    self.getHupOrder = function (activeCtn) {
      if(self.bfahupOrders.length > 0){
        return _.filter(self.bfahupOrders, function (order) {
                return _.indexOf(order.assemblyIds, activeCtn) >= 0 && !order.quotation;
              });
      }
};

    /**
     * Add DTM Tracking for PPC
     * JIRA: https://rogers.atlassian.net/browse/NPS-1332
     */

    return {
      'isFetchOrderCompleted': self.isFetchOrderCompleted,
      'hasOrder': self.hasOrder,
      'fetchOrder': self.fetchOrder,
      'gotoBFAPPC': self.gotoBFAPPC,
      'clean': self.clean,
      'changeBtnLoading': self.changeBtnLoading,
      'getFetchOrderFullResponse': self.getFetchOrderFullResponse,
      'getSubscribers': self.getSubscribers,
      'openSomethingWentWrongPopup': self.openSomethingWentWrongPopup,
      'getHuporderForCtn': self.getHupOrder
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('ute.common.oneview.header').factory('commonUtilityService', commonUtilityServices);

  commonUtilityServices.$inject = ['$log'];

  /* @ngInject */
  function commonUtilityServices($log) {

    // Public API
    var service = {
      dateTime: {
        parse: parse,
        getDateFromStringYYYYMMDD: getDateFromStringYYYYMMDD
      }, browser: {
        isSafari: isSafari,
        isSafariOnIos: isSafariOnIos
      }
    };

    return service;

    ///////////////////////////////////////////////////////////////

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString should be in YYYY-MM-DD format
     */
    function getDateFromStringYYYYMMDD(dateTimeInString) {
      try {
        // Basic validation
        var dateTimeSplit = dateTimeInString.split('-');

        if (dateTimeSplit.length !== 3) {
          return undefined;
        }
        var yearInt = parseInt(dateTimeSplit[0]);
        var monthInt = parseInt(dateTimeSplit[1]);
        var dayInt = parseInt(dateTimeSplit[2]);

        if (isNaN(yearInt) || isNaN(yearInt) || isNaN(yearInt)) {
          return undefined;
        }

        // Fix the month before set Date
        monthInt = monthInt - 1;

        var returnDateTime = new Date(yearInt, monthInt, dayInt);
        return returnDateTime;

      } catch (e) {
        $log.error('Exception catch during getDateFromStringYYYYMMDD:', e.message);
      }
      return undefined;
    }

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString '2016-02-04', 'Feb 04, 2016'
     * @param expectedFormat 'YYYY-MM-DD', 'MMM DD, YYYY'
     */
    function parse(dateTimeInString, expectedFormat) {
      try {

        if (/yyyy-mm-dd/i.test(expectedFormat)) {
          return getDateFromStringYYYYMMDD(dateTimeInString);
        }

      } catch (e) {
        $log.error('Exception catch during parse:', e.message);
      }
      return new Date();
    }

    /**
     * This function is use to check if the current browser is safari running on IOS
     */
    function isSafariOnIos() {
      try {
        return (
            /ipad|iphone/i.test(window.navigator.platform) && isSafari()
        );
      } catch (e) {
        $log.error('Exception catch during isSafariOnIos:', e.message);
      }
    }

    /**
     * This function is use to check if the current browser is Safari
     */
    function isSafari() {
      try {
        return (
            /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion))
        );
      } catch (e) {
        $log.error('Exception catch during isSafari:', e.message);
      }
    }

  }
}());

// has code from ajax.js, appState.js, user.js
(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name ute.common.oneview.header.module:myrCustomerInfoService
   * @description
   * # myrCustomerInfoService
   */
  var exceptionList = ['_showBroadcastMessage'];
  
  angular.module('ute.common.oneview.header').service('miscService', miscService);

  miscService.$inject = [
    '$injector',
      'ute.oneview.header.service',
      '$location',
      '$cookieStore',
      '$window',
      '$state',
      'ute.common.user.service',
      'ute.blocks.messages.bus.service',
      'ute.common.core.brtswitch.service',
      'ute.blocks.persistent.storage.service',
    'ute.common.agent.info.factory',
  '$cookies', '$timeout'];

  function miscService(// jshint ignore:line
                $injector,
                oneViewHeaderService,
                $location,
                $cookieStore,
                $window,
                $state,
                userService,
                messagesService,
                brtSwitchService,
                rogersStoreService,
                agentInfoFactory,
                $cookies, $timeout) {
    var agentInfoCallInProgress = null;
    var settings = oneViewHeaderService.getConfig().settings;
    var agentInfoService = agentInfoFactory();
    function removeCookie(name) {
        document.cookie = name + '=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
    }
    var service = {
        clearCookies: function () {
            // Kill the cookies
            // The SMSESSION cookie should not be removed for dealer
            if (userService.isDealer()) {
              removeCookie('SMSESSION');
            }
            removeCookie('SM_USERAUTHENTICATED');
            removeCookie('SMLOCK');
            removeCookie('SM_GUID');
            removeCookie('SM_USER');
            removeCookie('userToken');
            removeCookie('selectedAccount');
            removeCookie('accountNumber');
            removeCookie('userType');
            removeCookie('cbid');
            removeCookie('easyLoginCheckPassed');
          },
        kickOutExpired: function () {
            // Non-Angular cookie grab
            var name = 'SMSESSION=';
            var logOffcookie = '';
            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    logOffcookie = c.substring(name.length, c.length);
                }
            }
            // Angular cookie grab
            if (logOffcookie === 'LOGGEDOFF' && !(userService.isCare())) { /* Added isCare check to resolve Care being redirected to Logout Page */
            
                // Do the user logout here
                console.log('calling logout from kickOutExpired');
                return service.logout(false, 'SESSION_EXPIRED');
            }
        },
        logout: function (skipNavigation, logoutReason) {
            if (userService.isDealer()) {
              agentInfoCallInProgress = agentInfoService.getAgentInfo();
            }
            var userType = userService.getUserType();
            // var sspPath = '';
            var cfaInfo = null;

            rogersStoreService.getFromSession('dealerInfo');
            /*
            if (userService.isDealer() && cfaInfo) {
              sspPath = cfaInfo.sourceURL ? cfaInfo.sourceURL + settings.agentInfo.signoutURL : false;
            }
            */
            // console.log('ssppath:',sspPath);
            var ajax = $injector.get('ajax');
            ajax.resetKillSwitches();
            //TODO move to callback in parent Spa .run ajax.resetKillSwitches();
            // Kill the local data

            /* TODO move to logout callback in parent SPA .run method
            myrAccountListService.resetServiceData();

            try {
              if ($rootScope.ao.accountActive !== null) {
                $rootScope.ao.accountActive = null;
              }
            } catch (err) {
              // nonexistent accountActive
            }
            
            $rootScope.popUpOpened = false;
            $rootScope.popUpOpenedAndClosed = false;
            if (userType && userType === settings.userType.care) {
              $rootScope.user.isAuthenticated = false;
            }
            // notify server - logout
            $rootScope.toggleMainPlusMinus = false;
            $rootScope.toggleServicesPlusMinus = false;
            */

            //login from legacy
            var ajax = $injector.get('ajax');
            return ajax.notifyServerLogout().then(
                // kill the state AFTER you get response and do it regardless
                checkForSspPathBeforeSessionCleanUp,
                // logout failed for some reason -> proceed with cleaning and logging out
                checkForSspPathBeforeSessionCleanUp
            );

            function checkForSspPathBeforeSessionCleanUp() {
              if (agentInfoCallInProgress) {
                agentInfoCallInProgress.then(
                  function(agentInfoResponse) {
                    var sspPath = agentInfoResponse && agentInfoResponse.sourceUrl ? agentInfoResponse.sourceURL + settings.agentInfo.signoutURL: null;
                    sessionCleanup(sspPath);
                  },
                  function() {
                    sessionCleanup(null);
                  }
                );
              } else {
                sessionCleanup(null);
              }
            }

            //if calls to logout fails, we still need to do cleanup, otherwise system goes in an endless loop
            function sessionCleanup(sspPath) {
              $cookies.userToken = null;
              // reset rootscope
              /* TODO move to logout callback in parent SPA .run method
                appState.aoFlushScope();
              */
              clearAllLocalStorageValues();
              if (userService.isCare()) {
                clearAllSessionStorageValues();
              }
              rogersStoreService.remove('__userInfo');

              if (userService.isDealer() && sspPath) {
                $cookieStore.remove('userType');
               $window.location.href = sspPath;
              } else if (userService.isCare()) {
                $cookieStore.remove('userType');
                rogersStoreService.remove('userType');
                var reloadAfter = $location.absUrl().indexOf('.com/web/totes/#') >= 0;
                $window.location.href = '/web/totes/#/oneViewInterface?statusCode=' + settings.oneViewStatusCodes.crmSignout;
                //only reload if above redirect takes you to same site.
                if (reloadAfter) {
                  $window.location.reload(true);
                }
              } else {
                // user IS NOT dealer/support
                service.clearCookies();
                if (!skipNavigation) {
                  //If easylogin cookie found, redirect to riverpage else legacy page
                  brtSwitchService.getValue('EASY_LOGIN_PHASE_2').then(function (isEasyLoginPhase2) {
                    if (isEasyLoginPhase2) {
                      var EASY_LOGIN_PHASE_2 = $cookies.EASY_LOGIN_PHASE_2;
                      if (EASY_LOGIN_PHASE_2) {
                        doConditionalRedirection(logoutReason);
                      } else {
                        $state.go('signin', {reload: $state.current.name !== 'signin'});
                      }
                    } else {
                      doConditionalRedirection(logoutReason);
                    }
                  });
                }
                // reset userType
                userType = null;

                userService.unsigned();
                //was only used in livecontent.js, replaced with userService.registerSignoutHandler
                //$rootScope.$broadcast('user.logout.done');
              }
            }
          },
        getBaseUrl: function() {
          var redirectTo = JSON.parse(sessionStorage.getItem('dpIdRedirectTo')),
          baseURL = "", 
          portTo = "";
          if (redirectTo && redirectTo.host) {
            portTo = redirectTo.port.toString().length > 0 ? ":" + redirectTo.port : "";  
            baseURL = redirectTo.host.toString().length > 0 ? redirectTo.protocol + "//" + redirectTo.host + portTo : "";
          }
          return baseURL;
        }
    };

      function clearAllLocalStorageValues() {
        // console.log('inside clearalllocalstorage');
        var index = 0;
        while ($window.localStorage.length > index) {
          var keyIndex = exceptionList.indexOf($window.localStorage.key(index));
          if (keyIndex < 0) {
            $window.localStorage.removeItem($window.localStorage.key(index));
          } else
            index++;
        }
      };

      function clearAllSessionStorageValues() {
        // console.log('inside clearalllocalstorage');
        while ($window.sessionStorage.length > 0) {
          $window.sessionStorage.removeItem($window.sessionStorage.key(0));
        }
      };
      function doConditionalRedirection(logoutReason) {
        switch (logoutReason) {
          case 'LOGOUT':
            $window.location.href = '/consumer/home';
            break;
          case 'USER_NOT_LOGGED_IN':
            $window.location.href = '/consumer/easyloginriverpage?showModal=true';
            break;
          case 'SESSION_EXPIRED':
            $window.location.href = '/consumer/easyloginriverpage?showModal=true&sessionExpired=true';
            break;
          default:
            $window.location.href = $window.location.origin;
            break;
        }
      }
      return service;
    };

})();

(function () {
  'use strict';

  angular.module('ute.common.oneview.header').factory('myrMyOtherServicesService', myrMyOtherServicesService);
  myrMyOtherServicesService.$inject = [
    'ute.blocks.language.switcher',
    'ute.rogers.account.overview.factory',
    'ute.rogers.eclipse.remote.api.service',
    'ute.common.user.service',
    'cookieStore',
    '$modal',
    'ajax',
    '$window'
  ];

  function myrMyOtherServicesService(
      languageSwitcher,
      accountOverviewFactory,
      eclipseRemoteApi,
      userService,
      cookieStore,
      $modal,
      ajax,
      $window
  ) {
    var serviceInterface = {
      addToRemovalList: addToRemovalList,
      resetRemovalList: resetRemovalList,
      configureMasterList: configureMasterList,
      getMasterList: getMasterList,
      isOtherServicesAvailable: isOtherServicesAvailableFn,
      isIgniteComboAccount: isIgniteComboAccount
    };

    var accountOverviewService = accountOverviewFactory();
    var isOtherServicesAvailable = false;
    var removalList = [];
    var finalList = [];
    var isIgniteCombo = false;
    var masterList = [{
      id: 'CTN',
      title: 'myaccoverview_get_wireless',
      //link: 'https://www.rogers.com/web/content/wireless_plan_landing',
      link: 'http://www.rogers.com/consumer/wireless',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-wireless'
    }, {
      id: 'Hi-Speed Internet',
      title: 'myaccoverview_get_internet',
      //link: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans',
      link: 'http://www.rogers.com/consumer/internet',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-internet',
      identicalAs: ['HSI']
    }, {
      id: 'Digital TV',
      title: 'myaccoverview_get_tv',
      //link: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg',
      link: 'https://www.rogers.com/web/link/ptvBrowsePackagesFlowBegin?forwardTo=landing',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: false,
      icon: 'ute-icon-tv',
      identicalAs: ['IPTV']
    }, {
      id: 'RHPc',
      title: 'myaccoverview_get_phone',
      link: '',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-phone',
      identicalAs: ['RHP Phone Line']
    }, {
      id: 'Rogers Smart Home Monitoring',
      title: 'myaccoverview_get_monotoring',
      //link: 'https://www.rogers.com/web/content/smart-home-monitoring-solutions-new',
      link: 'http://www.rogers.com/consumer/home-monitoring',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-security'
    }, {
      id: 'Rogers Bank',
      title: 'myaccoverview_get_rogers_bank',
      link: 'https://www.rogersbank.com/' + languageSwitcher.getCurrentLanguage(),
      updateRogersBank: true,
      addLangRoute: false,
      addLang: false,
      langParameterName: '',
      langFirstParam: true,
      icon: '',
      imageIcon: 'rogers-bank'
    },
    // {
    //   id: 'NHL (GCL)',
    //   title: 'myaccoverview_get_nhl',
    //   link: 'https://gamecentrelive.rogers.com/' + languageSwitcher.getCurrentLanguage(),
    //   updategamecentrelive: true,
    //   addLangRoute: false,
    //   addLang: false,
    //   langParameterName: '',
    //   langFirstParam: true
    // },
    //SEE_Project Implementation
    {
       id: 'Add Individual Line',
       title: 'share_everything_individual',
       link: '',
       addLangRoute: false,
       addLang: true,
       langParameterName: 'setLanguage',
       langFirstParam: true,
       icon: 'ute-icon-wireless',
       allowGoto: true,
       goto: function($event){//when goto is used link property should be empty or both (click and href) functionality will be executed
         $event.preventDefault();
         $event.stopPropagation();
         ajax.nacSaveState({
            key: 'NEW_MULTI_WRLS_INFO',
            isDeeplink: true,
            isIndividual: true,
            clearSession:true,
            nacSessionList: []
          }).then(function(){
           $$window.location.href = "/web/totes/wireless/#/choose-phone?deeplink";
          });
       }
     },//end-SEE_Project Implementation
    {
        // going forward proposing this format
        id: 'Ignite Combo',
        title: 'myaccoverview_get_ignite',
        userRoles: 'care,careRep,dealer',
        eligibleProductNames: ['ROGERS_HSI', 'ROGERS_TV', 'ROGERS_RHP'],
        goTo: function() {
        if (isIgniteCombo) {
          accountOverviewService
            .getSelectedAccount()
            .then(function (account) {
              eclipseRemoteApi.goToComboPackages({
                accountNumber: account.accountNumber
              }, {
                lang: languageSwitcher.getCurrentLanguage(),
                userType: userService.getUserType(),
                province: cookieStore.get('province').toLowerCase()
              });
            });
        } else {
          openIgniteComboModal();
        }
      }
    },
    {
      id: 'HSI',
      title: 'myaccoverview_get_internet',
      //link: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans',
      link: 'http://www.rogers.com/consumer/internet',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-internet',
      identicalAs: ['Hi-Speed Internet']
    }, {
      id: 'IPTV',
      title: 'myaccoverview_get_tv',
      //link: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg',
      link: 'https://www.rogers.com/web/link/ptvBrowsePackagesFlowBegin?forwardTo=landing',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: false,
      icon: 'ute-icon-tv',
      identicalAs: ['Digital TV']
    }, {
      id: 'RHP Phone Line',
      title: 'myaccoverview_get_phone',
      link: '',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-phone',
      identicalAs: ['RHPc']
    }];
    function modifyMasterList(id, prop, val) {
      $.grep(masterList, function (serv, index) {
        if (serv.id === id) {
          serv[prop] = val;
        }
      });
    }

    // For oneview we should not display rogers bank, NHL and Shomi and 'Add Individual Line'
    if (userService.isDealer() || userService.isCare()) {
      for (var i = masterList.length - 1; i >= 0; i--) {
        if (masterList[i].id === 'Rogers Bank' || masterList[i].id === 'NHL (GCL)' || masterList[i].id === 'Add Individual Line') {
          masterList.splice(i, 1);
        }
      }
    }

    return serviceInterface;

    function configureMasterList() {
      var i = 0, identicalIndex = 0, identicalItem, updatedItem = false;
      var item;

      for (i; i < masterList.length; i++) {
        item = masterList[i];
        updatedItem = false;
        if (removalList.indexOf(item.id) < 0) {
          if(item.identicalAs && item.identicalAs.length > 0) {
            for(identicalIndex = 0; identicalIndex < item.identicalAs.length ; identicalIndex++) {
              identicalItem = _.find(masterList, {id: item.identicalAs[identicalIndex]});
              if(identicalItem && identicalItem.isVisible === true) {
                item.isVisible = false;
                updatedItem = true;
              }
            }
          }
          if(updatedItem === false) {
            item.isVisible = true;
          }
          isOtherServicesAvailable = true;
        } else {
          item.isVisible = false;
        }
      }
    }

    function addToRemovalList(item) {
      if (removalList.indexOf(item) === -1) {
        removalList.push(item);
      }
    }

    function resetRemovalList() {
      /// Creating external list
      var externalList = ['Shomi'];
      /// This is for checking the external list other than normal serv
      var intersectList = _.intersection(removalList, externalList);
      if (intersectList.length > 0) {
        removalList = intersectList;
      } else {
        removalList = [];
      }
    }

    function getMasterList() {
      return masterList;
    }

    function isOtherServicesAvailableFn() {
      return isOtherServicesAvailable;
    }

    function isIgniteComboAccount(val) {
      isIgniteCombo = val;
    }

    function openIgniteComboModal () {
      $modal.open({
        templateUrl: 'module/views/modals/eclipseMsgModal.html'

      });
    }
  }
}());

(function () {
    'use strict';
  
    angular.module('ute.common.oneview.header').service('headerMyServicesService', myrMyServicesService);
  
  myrMyServicesService.$inject = [
      'ute.blocks.language.switcher',
      'ute.blocks.persistent.storage.service',
      '$state',
      'ajax',
      'sessionStorage',
      'myrMyOtherServicesService',
      'ute.rogers.eclipse.remote.api.service',
      'cookieStore',
      'ute.data.manager.service',
      'ute.common.user.service',
      'ute.brite.bill.service',
      'ute.common.permissions.service',
      'myrAccountBalanceDataFactory'
    ];
  
    function myrMyServicesService(
                                  languageSwitcher,
                                  persistentStorageService,
                                  $state,
                                  ajax,
                                  sessionStorage,
                                  myrMyOtherServicesService,
                                  eclipseRemoteApi,
                                  cookieStore,
                                  dataManagerService,
                                  userService,
                                  briteBillService,
                                  permissionsService,
                              myrAccountBalanceDataFactory
                          ) {
      var updateCallback, subscriptionList;
      var errorLoading = false;
      var service = {
          selectedAccount: null, // response from accountOverview api
          selectedAccountDetails: null, // response from accountoverview/summary
          myServiceList: null,
          getSubscriptions: getSubscriptions,
          isFraud: isFraud,
          getSelectedAccountDetail: getSelectedAccountDetail,
          registerUpdateCallback: registerUpdateCallback,
          categorizedServices: {
              individual: [],
              residential: [],
              otherServices: []
          }
      }
      return service;
  
      function populateServicesDataModel() {
        // myServicesList
        service.categorizedServices.individual.length = 0;
        service.categorizedServices.residential.length = 0;
        service.categorizedServices.otherServices.length = 0;
  
        _.forEach(service.myServicesList, function (item) {
          if (item.subType === 'CTN') {
            service.categorizedServices.individual.push(item);
          } else if (item.subType === 'Digital TV' ||
            item.subType === 'RHPc' ||
            item.subType === 'Hi-Speed Internet' ||
            item.subType === 'Rogers Smart Home Monitoring' ||
            item.subType === 'HSI' ||
            item.subType === 'IPTV' ||
            item.subType === 'RHP Phone Line'
          ) {
            service.categorizedServices.residential.push(item);
          } else if (item.subType === 'Rogers Bank') {
            service.categorizedServices.otherServices.push(item);
          }
        });
  
        service.fdmIndividualListAmount = service.categorizedServices.individual.length;
        service.fdmResidentialListAmount = service.categorizedServices.residential.length;
        service.fdmOtherListAmount = service.categorizedServices.otherServices.length;
      }
  
      function registerUpdateCallback(callback) {
        updateCallback = callback;
      }
  
      function notifySubs() {
        if (updateCallback && typeof updateCallback === 'function') {
          try {
            updateCallback();
          } catch (e) {
          }
        }
      }
  
      function getSelectedAccountDetail() {
        //wrap account details for selected account, handle account variety.
        if (service.selectedAccountDetails) {
          if (service.selectedAccountDetails.accountBalance !== {}) {
            service.selectedAccountDetails.accountBalance = myrAccountBalanceDataFactory.accountBalance;
          }
  
          return service.selectedAccountDetails;
        }
        if (!service.selectedAccount) {
          return;
        }
  
        var _rtn;
        var _selectedAccount = service.selectedAccount;
        var accountList = service.selectedAccount.accountList;
  
        if (_selectedAccount) {
          var _detail = _selectedAccount;
          var _info = _detail.accountInfo;
          var _subList = _detail.subList;
          var isCreditCardHolder = _.find(accountList, {accountNumber: _selectedAccount.accountNumber}).isCreditCardHolder;
  
          _rtn = {
            number: _detail.accountNumber,
            billableAccountNumber: _detail.billableAccountNumber,
            type: _detail.accountType,
            status: _info.status,
            name: _detail.accountName.firstName,
            accountBalance: myrAccountBalanceDataFactory.accountBalance,
            isPrepaid: _detail.accountType === 9,
            isWireless: _detail.accountType === 1,
            isMastro: _detail.accountType === 30,
            isCable: _detail.accountType === 6,
            isConsolidated: _detail.isConsolidated,
            isViewBillDisplay: ((userService.isDealer() || userService.isCare()) && (briteBillService.getIsbritebillAvailable(_detail.accountNumber) && (_detail.accountType !== 9))),
            isCreditCardHolder: isCreditCardHolder,
            //optional data
            balance: '',
            dueDate: '',
            dateDelimiter: '',
            due: '',
            dateOrder: [],
            dateYearPrefix: '',
            paymentMethod: '',
            userType: '',
            userSubType: '',
            phoneNumber: '',
            contactId: '',
            nextBillingDate: _detail.nextBillingDate
          };
  
          if ((userService.isDealer() || userService.isCare()) && _detail.accountType !== 9) {
            briteBillService.getBills(_detail.accountNumber).then(function (bills) {
              _rtn.isViewBillDisplay = bills.length > 0;
            });
          }
  
          if (myrAccountBalanceDataFactory.accountBalance) {
            _rtn.balance = myrAccountBalanceDataFactory.accountBalance.balanceAmount || '';
            _rtn.dueDate = myrAccountBalanceDataFactory.accountBalance.billDueDate || '';
          }
  
          if (_rtn.isPrepaid) {
            _rtn.due = service.selectedAccountDetails.accountInfo.expiryDate;
            _rtn.dateDelimiter = ' ';
            _rtn.dateOrder = [0, 1, 2];
            _rtn.dateYearPrefix = '';
          } else {
            _rtn.due = myrAccountBalanceDataFactory.accountBalance ? myrAccountBalanceDataFactory.accountBalance.billDueDate : '';
            _rtn.dateDelimiter = '-';
            _rtn.dateOrder = [1, 0, 2];
            _rtn.dateYearPrefix = '20';
          }
  
          //get phone numbers
          var _list = $(_subList).map(function (k, v) {
            // if (v.subAccountId === _rtn.number) {
  
            if (v.subContactList && v.subContactList[0]) {
              _rtn.contactId = v.subContactList[0].contactId;
            }
            // }
  
            if (v.subType === 'CTN') {
              return v.subNumber;
            }
          }).get();
  
          _rtn.phoneNumber = _list[0];
  
          if (_rtn.phoneNumber !== undefined) {
            persistentStorageService.putToLocale('firstCTN', _rtn.phoneNumber);
            persistentStorageService.putToSession('phoneNumber', _rtn.phoneNumber);
          }
  
          //Wireless account
          if (_rtn.isWireless) {
            _rtn.userType = _info.accType;
            _rtn.userSubType = _info.accSubType;
          }
  
          //post-paid account get payment method
          if (!_rtn.isPrepaid && myrAccountBalanceDataFactory.accountBalance !== undefined && myrAccountBalanceDataFactory.accountBalance) {
            //post-paid account
            _rtn.paymentMethod = myrAccountBalanceDataFactory.accountBalance.methodOfPayment ? myrAccountBalanceDataFactory.accountBalance.methodOfPayment.mopType : 'R';
          }
        }
  
        service.selectedAccountDetail = _rtn;
  
        return service.selectedAccountDetail;
      }
      
      function isFraud() {
         if(!sessionStorage.fraud_indicator && sessionStorage.getSessionStorageValue('fraud_indicator') === 'Y'){
           return true;
          }
      }

      function getSubscriptions(subList, disablePermissionNotGranted) {
              if (!subList) {
                  return;
              }
              myrMyOtherServicesService.resetRemovalList();
  
              if (userService.isCare()) {
                  myrMyOtherServicesService.isIgniteComboAccount(false);
              } else if (userService.isDealer()) {
                  myrMyOtherServicesService.isIgniteComboAccount(true);
              }
              var myServicesList = [], serviceAddress;
              subscriptionList = subList;
              var _details = service.getSelectedAccountDetail();
              var isPrepaid = (_details && _details.isPrepaid) ? _details.isPrepaid : false;
  
              for (var i = 0; i < subList.length; i++) {
                  var subscription = subList[i],
                      _sub = {};
                  serviceAddress = '';
                  _sub.serviceDetail = subscription.subNumber;
                  if (userService.isCare()) {
                  _sub.accountNumber = persistentStorageService.getFromSession('accountNumber');
                  } else {
                  _sub.accountNumber = persistentStorageService.getFromLocal('accountNumber');
                  }
                  _sub.showPhone = subscription.subType.toLowerCase() === 'ctn' || subscription.subType.toLowerCase() === 'rhpc' || subscription.subType.toLowerCase() === 'RHP Phone Line';//show phone number for wireless/home phone
                  if (subscription && subscription.subAddress) {
                  serviceAddress = !_.isEmpty(subscription.subAddress.unit) ? serviceAddress + subscription.subAddress.unit + '-' : serviceAddress;
                  serviceAddress = !_.isEmpty(subscription.subAddress.streetNumber) ? serviceAddress + subscription.subAddress.streetNumber + ' ' : serviceAddress;
                  serviceAddress = !_.isEmpty(subscription.subAddress.streetName) ? serviceAddress + subscription.subAddress.streetName + ' ' : serviceAddress;
                  serviceAddress = !_.isEmpty(subscription.subAddress.streetNameSuffix) ? serviceAddress + subscription.subAddress.streetNameSuffix + ' ' : serviceAddress;
                  serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.streetType + ', ' : serviceAddress;
                  serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.city : serviceAddress;;
                  serviceAddress = serviceAddress.toLowerCase();
                  _sub.serviceAddress = '';
                  } else {
                  serviceAddress = '';
                  }
                  if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
                  _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                  _sub.type = ute.common.subscriptionBadge.BadgeTypes.igniteTv;
                  _sub.plan = 'Digital';
                  _sub.subAccountId = subscription.subAccountId;
                  _sub.subNumber = subscription.subNumber;
                  _sub.disabled = disablePermissionNotGranted[0];
                  _sub.sortOrder = 2;
  
                  _sub.subType = 'IPTV';
                  _sub.serviceAddress = serviceAddress.toLowerCase();
                  _sub.serviceType = 'service_tv';
                  _sub.serviceName = 'IPTV';
                  _sub.serviceDetail = subscription.subAccountId;
                  _sub.resolve = function (subItem) {
                      return {
                      goIPTV: function () {
                          eclipseRemoteApi.goToIPTVDashboard({
                            accountNumber: subItem.accountNumber,
                            subAccountId: subItem.subAccountId,
                            subscriptionId: subItem.subNumber,
                            source: 'rogers.com',
                            redirectTo: {
                              protocol: window.location.protocol,
                              host: window.location.hostname,
                              port: window.location.port,
                              path: window.location.pathname,
                              hash: window.location.hash,
                              href: window.location.href
                            }
                          }, {
                          lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
                          userType: userService.getUserType(),
                          province: cookieStore.get('province').toLowerCase() // pull from usersService
                          });
  
                      }
                      };
                  }
                  }
  
                  if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
                  _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                  _sub.type = ute.common.subscriptionBadge.BadgeTypes.igniteInternet;
                  _sub.plan = 'Ignite';
                  _sub.subAccountId = subscription.subAccountId;
                  _sub.subNumber = subscription.subNumber;
                  _sub.disabled = disablePermissionNotGranted[1];
                  _sub.sortOrder = 3;
  
                  _sub.subType = 'HSI';
                  _sub.serviceAddress = serviceAddress.toLowerCase();
                  _sub.serviceType = 'service_internet';
                  _sub.serviceName = 'HSI';
                  _sub.serviceDetail = subscription.subAccountId;
                  _sub.resolve = function (subItem) {
                      return {
                      goHSI: function () {
                          eclipseRemoteApi.goToHSIDashboard({
                            accountNumber: subItem.accountNumber,
                            subAccountId: subItem.subAccountId,
                            subscriptionId: subItem.subNumber,
                            source: 'rogers.com',
                            redirectTo: {
                              protocol: window.location.protocol,
                              host: window.location.hostname,
                              port: window.location.port,
                              path: window.location.pathname,
                              hash: window.location.hash,
                              href: window.location.href
                            }
                          }, {
                          lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                          userType: userService.getUserType(),
                          province: cookieStore.get('province').toLowerCase() // pull from usersService
                          });
                      }
                      };
                  }
                  }
                  if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
  
                  _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                  _sub.type = ute.common.subscriptionBadge.BadgeTypes.homePhone;
                  _sub.plan = 'Ignite';
                  _sub.subAccountId = subscription.subAccountId;
                  _sub.subNumber = subscription.subNumber;
                  _sub.disabled = disablePermissionNotGranted[2];
                  _sub.phoneNumber = subscription.subNumber;
                  _sub.sortOrder = 4;
  
                  _sub.subType = 'RHP Phone Line';
                  _sub.serviceType = 'service_phone';
                  _sub.serviceName = 'RHP Phone Line';
                  _sub.serviceDetail = subscription.subAccountId;
                  _sub.resolve = function (subItem) {
                      return {
                      goRHP: function () {
                          eclipseRemoteApi.goToRHPDashboard({
                            accountNumber: subItem.accountNumber,
                            subAccountId: subItem.subAccountId,
                            subscriptionId: subItem.subNumber,
                            source: 'rogers.com',
                            redirectTo: {
                              protocol: window.location.protocol,
                              host: window.location.hostname,
                              port: window.location.port,
                              path: window.location.pathname,
                              hash: window.location.hash,
                              href: window.location.href
                            }
                          }, {
                          lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                          userType: userService.getUserType(),
                          province: cookieStore.get('province').toLowerCase() // pull from usersService
                          });
                      }
                      };
                  };
                  }
                  if (subscription.subType === 'CTN') {
                  _sub.subType = 'CTN';
                  _sub.serviceType = isPrepaid ? 'service_wireless_prepaid' : 'service_wireless';
                  _sub.icon = 'rui-icon-wireless';
                  _sub.linkText = '_manage';
                  _sub.linkURL = isPrepaid ? 'wirelessPrepaid' : 'wireless';
                  _sub.paramName = 'phoneNumber';
                  _sub.serviceName = isPrepaid ? 'wirelessPrepaid' : 'wireless';
                  _sub.firstName = subscription.firstname || '';
                  _sub.lastName = subscription.lastname || '';
                  _sub.menuFirstName = cleanFirstName(subscription.firstname);
                  _sub.firstNameLength = _sub.firstName.length;
                  _sub.isCTN = true;
                  _sub.sortOrder = 1;
                  _sub.subStatus = subscription.subStatus;
                  /*Check for share Everything CTN*/
                  if ((userService.isDealer() || userService.isCare()) && dataManagerService.getBRT()) {
                      if (subscription.shareEverything) {
                      if (subscription.shareEverything.isSharingData) {
                          _sub.serviceName = 'shareEverything';
                      }
                      }
                  }
                  }
  
                  if (subscription.subType === 'Hi-Speed Internet') {
                  _sub.subType = 'Hi-Speed Internet';
                  _sub.serviceType = 'service_internet';
                  _sub.icon = 'rui-icon-internet';
                  _sub.linkText = '_manage';
                  _sub.linkURL = 'internetdash';
                  _sub.serviceDetail = subscription.subAccountId;
                  _sub.paramName = 'accountNumber';
                  _sub.serviceName = 'internetdash';
                  _sub.isCTN = false;
                  _sub.sortOrder = 6;
                  _sub.serviceAddress = serviceAddress.toLowerCase();
                  }
                  if (subscription.subType === 'Digital TV') {
                  _sub.subType = 'Digital TV';
                  _sub.serviceType = 'service_tv';
                  _sub.icon = 'rui-icon-tv';
                  _sub.linkText = '_manage';
                  _sub.linkURL = 'tvdashboard';
                  _sub.serviceDetail = subscription.subAccountId;
                  _sub.paramName = 'accountNumber';
                  _sub.serviceName = 'tvdashboard';
                  _sub.isCTN = false;
                  _sub.sortOrder = 5;
                  _sub.serviceAddress = serviceAddress.toLowerCase();
                  }
  
                  if (subscription.subType === 'Rogers Smart Home Monitoring') {
                  // _sub.serviceDetail = $translate.instant('myaccoverview_home_monotoring');
                  _sub.subType = 'Rogers Smart Home Monitoring';
                  _sub.serviceType = 'myaccoverview_home_monotoring';
                  _sub.icon = 'rui-icon-home-security';
                  _sub.linkText = '_manage';
                  _sub.linkURL = 'shmdashboard';
                  //_sub.serviceDetail = subscription.subAccountId;
                  _sub.serviceDetail = subscription.serviceNumber;
                  _sub.paramName = 'accountNumber';
                  _sub.serviceName = 'shmdashboard';
                  _sub.disabled = disablePermissionNotGranted[3];
                  _sub.isCTN = false;
                  _sub.sortOrder = 8;
                  _sub.hide =  _sub.disabled || subscription.subStatus === 'Suspended' || isFraud();
                  }
                  if (subscription.subType === 'RHPc') {
                  _sub.subType = 'RHPc';
                  _sub.serviceType = 'service_phone';
                  _sub.icon = 'rui-icon-home-phone';
                  _sub.linkText = '_manage';
                  _sub.linkURL = 'homephone';
                  _sub.accountNumber = '';
                  _sub.serviceName = 'homephone';
                  _sub.isCTN = false;
                  _sub.sortOrder = 7;
                  }
  
                  if (subscription.subStatus === 'Suspended') {
                  _sub.serviceName = 'suspended';
                  _sub.isCTN = false;
                  _sub.sortOrder = 9;
                  }
                  myServicesList.push(_.cloneDeep(_sub));
                  if (eclipseRemoteApi.isEclipseInternetSubscription(subscription) ||
                  eclipseRemoteApi.isEclipseTvSubscription(subscription) ||
                  eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
                  myrMyOtherServicesService.addToRemovalList('Ignite Combo');
                  myrMyOtherServicesService.addToRemovalList(_sub.subType);
                  if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
                      myrMyOtherServicesService.addToRemovalList('Hi-Speed Internet');
                  } else if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
                      myrMyOtherServicesService.addToRemovalList('Digital TV');
                  } else if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
                      myrMyOtherServicesService.addToRemovalList('RHPc');
                  }
                  } else {
                  myrMyOtherServicesService.addToRemovalList(_sub.subType);
                  if (subscription.subType === 'Hi-Speed Internet') {
                      myrMyOtherServicesService.addToRemovalList('HSI');
                  } else if (subscription.subType === 'Digital TV') {
                      myrMyOtherServicesService.addToRemovalList('IPTV');
                  } else if (subscription.subType === 'RHPc') {
                      myrMyOtherServicesService.addToRemovalList('RHP Phone Line');
                  }
                  }
              }
  
              if (_details.isCreditCardHolder) {
                  var bankLink = 'https://rbaccess.rogersbank.com/Rogers_Consumer/ChangeLanguage.do?localeID=';
                  var creditCardService = {
                  subType: 'Rogers Bank',
                  serviceType: 'rogers_credit_card',
                  serviceName: bankLink,
                  serviceDetail: 'getRogersBankLang',
                  imageIcon: 'rogers-bank'
                  };
                  myServicesList.push(creditCardService);
                  myrMyOtherServicesService.addToRemovalList(creditCardService.subType);
              }
              service.myServicesList = myServicesList;
              notifySubs();
              populateServicesDataModel(); // in this point for sure we have myServicesList
  
              /*$injector.get('ute.common.permissions.service').getUserPermission('SEE_UTE_PAGE_VIEW')
                  .then(function (isPermitted) {
                  var $cookies = $injector.get('$cookies');
                  if (!isPermitted && ($cookies.SM_USER || ($cookies.SMSESSION && $cookies.SMSESSION !== 'LOGGEDOFF')) || (myrAccountListService.selectedAccount && myrAccountListService.selectedAccount.accountStatus && myrAccountListService.selectedAccount.accountStatus.toLowerCase() != 'active')) {
                      myrMyOtherServicesService.addToRemovalList('Add Individual Line');
                  }
                  })*/
                  //.finally(function () {
              myrMyOtherServicesService.configureMasterList();
              service.myOtherServicesListFinal = myrMyOtherServicesService.getMasterList();
              service.isOtherServicesAvailable = myrMyOtherServicesService.isOtherServicesAvailable();
              // });
  
  
              /* // other services list require for one view operations.
              var myOtherServicesOneViewListFinal = [];
  
              for (var y = 0; y < myOtherServicesListMaster.length; y++) {
              if (myOtherServicesList.indexOf(myOtherServicesListMaster[y].id) < 0) {
              myOtherServicesListMaster[y].isVisible = true;
              myOtherServicesOneViewListFinal.push(myOtherServicesListMaster[y]);
              }
              }*/
  
              return {
                  myServices: myServicesList,
                  myOtherServices: myrMyOtherServicesService.getMasterList()
              };
          }
          function cleanFirstName(firstname) {
          if (angular.isUndefined(firstname) || firstname === null || firstname.trim() === '') {
              return '';
          } else if (firstname.length > 10) {
              return firstname.substr(0, 9);
          } else {
              return firstname;
          }
          }
      }
  })();
'use strict';

angular
  .module('ute.common.oneview.header')
  .factory('pricePlanChangesErrors', ['$modal', '$state', 'maintenanceService', 'ute.blocks.language.switcher', '$log', 'ute.common.user.service', function ($modal, $state, maintenanceService, languageSwitcher, $log, userService) {
    var service = {};

    function showModal(errorMessage) {
      $('#error-modal-body').html(errorMessage);
      $('#error-modal').modal('show');
    }

    function showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
      reload = reload || false;

      var $modalInstance = $modal.open({
        templateUrl: 'module/views/modals/ppc-modal-template.html',//TODO bring from ovo-client
        className: 'dialog-header',
        windowClass: 'prorated-modal',
        controller: ['$scope', function ($scope) {

          //bold chat changes start
          $scope.setStaticChatButtonValues = function () {
            if (languageSwitcher.getCurrentLanguage() === 'en') {
              $scope.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc';
              $scope.boldChatButtonDiv = 'changePlan-en';
              $scope.boldChatButton = 'chatButtonChangePlanEn';
            } else {
              $scope.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc_Fr';
              $scope.boldChatButtonDiv = 'changePlan-fr';
              $scope.boldChatButton = 'chatButtonChangePlanFr';
            }
          };
          $scope.setStaticChatButtonValues();

          $scope.$on('languageChanged', function () {
            $scope.setStaticChatButtonValues();
          });
          //bold chat changes end

          $scope.title = title;
          $scope.showLiveChat = showLiveChat;
          $scope.message = message;
          $scope.showCancelBtn = false;
          $scope.showOKBtn = false;
          $scope.showConfirmBtn = false;
          $scope.showContinueBtn = false;
          $scope.showRemoveAddOnBtn = false;
          $scope.showGoBackBtn = false;
          $scope.isSuspendedAccount = isSuspended;
          //Remove all instances of errors containing call or chat for care and retail
          // excluding credit check and fraud messages.
          if(showLiveChat === "showToRepAlso") {
            $scope.showLiveChat = true;
          } else if(userService.getUserType().toLowerCase() == 'dealer' || userService.getUserType().toLowerCase() == 'care') {
            $scope.showLiveChat = false;
          } else {
            $scope.showLiveChat = showLiveChat;
          }
          var _length = buttons.length;
          for (var i = 0; i < _length; i++) {
            switch (buttons[i]) {
              case 'OK':
                $scope.showOKBtn = true;
                break;
              case 'Cancel':
                $scope.showCancelBtn = true;
                break;
              case 'Confirm':
                $scope.showConfirmBtn = true;
                break;
              case 'ConfirmPlanChange':
                $scope.showConfirmPlanChangeBtn = true;
                break;
              case 'Continue':
                $scope.showContinueBtn = true;
                break;
              case 'RemoveAddOn':
                $scope.showRemoveAddOnBtn = true;
                break;
              case 'GO_BACK':
                $scope.showGoBackBtn = true;
                break;
            }
          }

          $scope.ok = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.goBack = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.removeAddOn = function () {
            $modalInstance.close(true);
          };

          $scope.cancel = function () {
            $modalInstance.close(false);
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };

          $scope.continue = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward, {}, {reload: reload});
            }
          };

          $scope.confirm = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward);
            }
            else if (redirect && typeof redirect.sendCallback === 'function') {
              redirect.sendCallback();
            }
          };
          if (!$scope.isSuspendedAccount) {
            switch (languageSwitcher.getCurrentLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          } else {
            switch (languageSwitcher.getCurrentLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=204&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=254&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          }

        }],
        //scope: $scope,
        size: 'md',
        backdrop: 'static'
        //keyboard: false,
        //backdropClass: 'bkg-modal',
        //resolve: {}
      });

      return $modalInstance.result;
    }

    // Display provided errorMessage in Modal
    // missing the RELOAD button
    service.showError = function (title, message, buttons, redirect, showLiveChat, isSuspended) {

      try {
        maintenanceService.tagging(['_trackPageView',
          {pn: 'home:MyRogers:PPC_wireless-planchange'},
          {eVar49: message}
        ]);
      } catch (e) {
        $log.error('Exception catch during tagging on pn=home:MyRogers:PPC_wireless-planchange with message:', e.message);
      }

      return showErrorModal(title, message, buttons, redirect, showLiveChat, isSuspended);
    };

    service.showSuspendedError = function (title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
      return showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended);
    };

    // Look up error message for this errorCode and then display in modal
    // This is not used anywhere in OneView
    /*
    service.handleError = function (errorCode) {
      var errorMessage = $translate.instant(errorCode);
      showModal(errorMessage);
    };
    */

    // Look up generic error message and display in modal
    /* this is not used anywhere either
    service.showGenericError = function () {
      var errorMessage = $translate.instant('_something_went_wrong');
      showModal(errorMessage);
    };
    */

    return service;
  }]);

'use strict';

//
angular.module('ute.common.oneview.header').factory('userOptions',[function () {

    var optionsQueue = [];
    var currentOptions = null;
    var callBacks = [];

    function dequeuUserNextOptions() {

        currentOptions = optionsQueue.shift();

        if (currentOptions) {
            _.forEach(callBacks, function(callBack) {
                callBack(currentOptions);
            });
        }

    }

    var userOptions = {

        __optionsQueue: optionsQueue,

        alert: function (message, title, callback) {

            if (angular.isFunction(message) || angular.isUndefined(title)) {
                callback = title;
                title = 'Rogers';
            }

            this.push({
                title: title,
                message: message,
                options: [
                    {
                        id: 'Ok',
                        text:'',
                        action: callback
                    }
                ]
            });
        },

        //eventType is used together with listen
        push: function (options) {

            optionsQueue.push(options);

            if (!currentOptions) {
                dequeuUserNextOptions();
            }
        },

        subscribe: function(callBack) {
            
            if (_.isUndefined(callBack)) {
                return function(){};//no callback function was passed in, still need to pass back an empty function as the callback "unsubscriber"
            }
            callBacks.push(callBack);
            // return a function to "unsubscribe"
            return function() {
                callBacks.splice(callBacks.indexOf(callBack), 1);
            }
        },

        //the done can be trigger asynchronously
        done: function (optionId) {

            var option = optionId && currentOptions && currentOptions.options && currentOptions.options[optionId];

            /*jshint expr:true */
            option && option.action && option.action();
            currentOptions = null;
            dequeuUserNextOptions();
        }
    };

    return userOptions;


}]);

(function () {
  'use strict';

  angular.module('ute.common.oneview.header').factory('ute.common.oneview.header.util', utilFactory);
  utilFactory.$inject = [
    'ute.blocks.language.switcher',
    '$translate',
    'moment'
  ];
  function utilFactory(languageSwitcher,
                       $translate,
                       moment) {

    var prefix = 'ute.common.oneview.header.util.';
    var monthsKeys = [prefix + '_months.0',
    prefix + '_months.1',
    prefix + '_months.2',
    prefix + '_months.3',
    prefix + '_months.4',
    prefix + '_months.5',
    prefix + '_months.6',
    prefix + '_months.7',
    prefix + '_months.8',
    prefix + '_months.9',
    prefix + '_months.10',
    prefix + '_months.11'];

    var service = {
      isPromise: function (obj) {
        return !!obj && angular.isFunction(obj.then);
      },
      updateCTNFormat: function (ctn) {
        var ctnRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        var formattedCTN = ctn;
        if (ctnRegex.test(ctn)) {
          formattedCTN = ctn.replace(ctnRegex, '($1) $2-$3');
        }
        return formattedCTN;
      },
      getNumberOfDays: function (newDateStr) {
        //newDate format should be Eg: Sep-19-15
        var todayDate = new Date();
        var monthName = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        var _date = newDateStr.split('-');
        var oneDayInMilliSecond = 24 * 60 * 60 * 1000;
        var newDate = new Date(2000 + parseInt(_date[2]), monthName.indexOf(_date[0].toUpperCase()), _date[1]);
        // Calculate the difference in milliseconds
        var differenceMs = Math.abs(newDate.getTime() - todayDate.getTime());
        return Math.floor(differenceMs / oneDayInMilliSecond);
      },

      /*
       input: itemTimeStamp format should be either 2015-11-24T15:59:37 or 2015-11-24
       output: November 24, 2015 */
      getDateByDate: function (timeStamp, month) {
        var lng = languageSwitcher.getCurrentLanguage();
        var date = moment(timeStamp);
        var days = moment(new Date());
        /*var monthNames = ["January", "February", "March", "April", "May", "June",
         "July", "August", "September", "October", "November", "December"
         ];
         var monthNamesFr = ["janvier" , "février" , "mars" , "avril" , "mai" , "juin" ,
         "juillet" , "août" , "septembre" , "octobre" , "novembre" , "d&eacute;cembre"
         ];*/
        var dateForDisplay = '';
        if (lng === 'fr') {
          //dateForDisplay = monthNamesFr[date.month()] +' '+date.date()+', '+date.year();
          dateForDisplay = month + ' ' + date.date() + ', ' + date.year();
        } else {
          //dateForDisplay = monthNames[date.month()] +' '+date.date()+', '+date.year();
          dateForDisplay = month + ' ' + date.date() + ', ' + date.year();
        }
        return dateForDisplay;
      },

      getMonthsNames: function () {
        return $translate(monthsKeys);
      },

      // following 3 functions (isSafari, isChromeIOS, getChromeVersion) moved here form wirelessDashboardController
      isSafari: function () {
        return /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion)) && /apple computer/i.test(window.navigator.vendor);
      },

      isChromeIOS: function () {
        return !!navigator.userAgent.match('CriOS');
      },

      getChromeVersion: function () {
        var chromeUserAgent = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        var chromeVersion = 1000; // Hypothetical future Chrome version
        if (chromeUserAgent !== null) {
          chromeVersion = parseInt(chromeUserAgent[2], 10);
        }

        // Microsoft added "Chrome" to Edge's "navigator.userAgent" string which is breaking this function.
        // Below two-line logic identifies and corrects the issue for the time being.
        // In case Edge's "navigator.appName" is "Netscape" the standard CSS code would work just fine, so
        // "chromeVersion" is set to 50 which triggers the standard CSS code
        if (navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
          chromeVersion = 50;
        }
        return chromeVersion;
      },

      getURLParamsByName: function (name, url) {
        //https://stackoverflow.com/a/901144
        if (!url) {
          url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) {
          return null;
        }
        if (!results[2]) {
          return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },

      //EASY LOGIN PHASE 2
      //This property will be used to interface between new registration and legacy registration
      isRedirectedFromELRegistration: false,

      getIsRedirectedFromELRegistration: function() {
        return this.isRedirectedFromELRegistration;
      },

      setIsRedirectedFromELRegistration: function(value) {
        this.isRedirectedFromELRegistration = value;
      }
    };
    return service;
  }
})();



// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('ute.common.oneview.header').service('myrWirelessDashboardService', wirelessDashboardService);

  wirelessDashboardService.$inject = ['ajax', '$translate', 'ute.blocks.language.switcher', '$q'];

  /* @ngInject */
  function wirelessDashboardService(ajax, $translate, languageSwitcher, $q) {

    // Private data
    var _dashboardDataRaw = null;
    var _dashboardData = null;
    var _wirelessPostpaidCache = {};

    // Post-paid
    var _dashboardPostpaidData = null;

    // Pre-paid
    var _dashboardPrepaidData = null;

    // Travel Package data
    var _dashboardTravelPackageData = null;

    /**
     * This is a flag to check if wireless dashboard
     * needs to open the reset voicemail modal or not
     */
    var _openResetVoicemailModal = false;

    var limitLow = 100;			// 75
    var limitHigh = 10000;		// 100
    //MCPPC
    var isMCPPCrerating = false;
    var errorMessageFraudAccess;
    var wirelessDashData = null;
    var isPostPaidDetailsDataReady = false;

    // Check for objects
    function wirelessServiceObjectPush(master, tmpObj, groupType) {
      var myCount = 0;

      if (typeof tmpObj === 'object') {
        // Look through the data and pluck specific data from usageSummary array.
        if (tmpObj.usageSummary.length > 0) {
          for (var u = (tmpObj.usageSummary.length - 1); u >= 0; u--) {
            if (typeof tmpObj.usageSummary[u] === 'object') {
              // this usage set IS and EXTRA and there is no usage meaning that user has ZERO use
              if (tmpObj.usageSummary[u].total === 0 && tmpObj.usageSummary[u].othersUsage === 0 && tmpObj.usageSummary[u].subscriberUsage === 0 && tmpObj.usageSummary[u].used === 0) {
                // extra  ->  total = 0, othersUsage = 0, subscriberUsage = 0, used = 0
                tmpObj.usageSummary.splice(u, 1);
              }
            }
          }

          // Push usages into next set that assesses the data and further decorates them.
          tmpObj = wirelessServiceAddData(tmpObj, groupType);
          master.push(tmpObj);
        }

        // handle - status code 127 (now 10013) exception - MCPPC
        if (parseInt(tmpObj.statusCode) === 10013) {
          myCount = -1000;
          isMCPPCrerating = true;
        } else if (parseInt(tmpObj.statusCode) === 10012) {
          myCount = -1000;
        } else {
          myCount = tmpObj.usageSummary.length;		// pass this back for proper plan counter
        }
      }

      return myCount;
    }

    // Process and andd some data into the object
    function wirelessServiceAddData(tmpObj, groupType) {
      var locSet = tmpObj.usageSummary,
       highestPercentage = 0,
       highestColor = '',
       displayTotal = 0,
       displayUsed = 0,
       displayRemain = 0,
       onlyExtras = true,
       haveExtras = false,
       overExtras = false,
       collect = true,
       collectType = '',
       collectIndex = -1;

      _.forEach(locSet, function (subSet, i) {
        if (typeof subSet === 'object') {

          // unlimited / pay-per-use / limited Definitions
          var locTotal = parseFloat(subSet.total);
          var locUNLflag = subSet.isUsageUnlimited;

          // Tag all sets with parent data sumary type
          subSet.usageSummaryType = tmpObj.usageSummaryType;

          if (locTotal < 0 || (locTotal > 90000 && groupType !== 'data') || (locTotal > 90000000000 && groupType === 'data') || locUNLflag) {
            //		unlimited -> subSet.total < 0
            subSet.usageType = 'unlimited';
            subSet.total = 0;
            subSet.percentage = 0;
            subSet.overExtra = false;
            subSet.usageColor = 'usageNormal';

            // no plan but extras only
            onlyExtras = false;

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal === 0) {
            //		pay-per-use -> subSet.total = 0
            subSet.usageType = 'pay-per-use';
            subSet.total = 0;
            subSet.percentage = 100;
            subSet.overExtra = false;
            subSet.usageColor = 'usageWarning';				// 'usageOver'

            // Show dial/meter flag
            haveExtras = true;

            // Collect data for dial/meter
            if (collectType === '') {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal > 0) {
            //			limited -> subSet.total > 0
            subSet.usageType = 'limited';

            // no plan but extras only
            onlyExtras = false;

            // Calculate percentages and if usage is
            var percentageTemp = (parseFloat(subSet.used) / parseFloat(subSet.total)) * 100;
            subSet.percentage = Math.ceil(percentageTemp);

            // Color definition
            if (subSet.percentage <= limitLow) {
              subSet.overExtra = false;
              subSet.usageColor = 'usageNormal';
            } else if ((subSet.percentage > limitLow && subSet.percentage <= limitHigh) || (subSet.percentage > limitLow)) {
//  limits were pushed from 75/100 to 100/1000 and this logic was simply not working properly.
//									subSet.overExtra = false;
//									subSet.usageColor = 'usageWarning';
//								} else if (subSet.percentage > limitLow) {
//									// subSet.usageColor = 'usageOver';
              subSet.overExtra = true;
              overExtras = true;
              subSet.usageColor = 'usageWarning';
              subSet.percentage = 100;
            }

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collect = false;
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else {
            // This should not happen!!! EVER!!!
            throw new Error('wireless.wirelessServiceAddData - Critical fail!!');
          }

          if (parseFloat(subSet.remaining) <= 0) {
            subSet.remaining = 0;
          }

          // Push it back
          locSet[i] = subSet;
        }
      });

      // Logic overide from colective decision on plan structure to pick the first one and use that as dial / tongue
      // collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list

      // data set has ONLY extras or it is mix of Extras and plans
      if (onlyExtras) {
        // Display orange tongue with extras sign
        displayTotal = 0;
        displayUsed = 0;
        displayRemain = 0;
        highestColor = 'usageWarning';
        highestPercentage = 0;

        collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list
      } else {
        // Decide what color and numbers go to the dial at the top
        if (collectIndex >= 0) {
          // limited or pay-per-use
          displayTotal = locSet[collectIndex].total;
          displayUsed = locSet[collectIndex].used;
          displayRemain = locSet[collectIndex].remaining;
          highestColor = locSet[collectIndex].usageColor;
          highestPercentage = locSet[collectIndex].percentage;

        } else {
          // unlimited
          displayTotal = 0;
          displayUsed = 0;
          displayRemain = 0;
          highestColor = 'usageNormal';
          highestPercentage = 0;

          collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list
        }
      }

      // Safety measure to make sure that collectIndex is never negative after this point.
      // Since unable to verify this issue on multiple servers this needs to be tested very carefuly
      if (collectIndex < 0) {
        collectIndex = 0;
      }

      // Hand-off to level up object
      tmpObj.displayTotal = displayTotal;
      tmpObj.displayUsed = displayUsed;
      tmpObj.displayRemain = displayRemain;
      tmpObj.highestPercentage = highestPercentage;
      tmpObj.highestColor = highestColor;
      tmpObj.usageSummary = locSet;

      tmpObj.onlyExtras = onlyExtras;
      tmpObj.haveExtras = haveExtras;
      tmpObj.overExtras = overExtras;

      // Default display type ( normal = round dial at the top / unlimited = no dial, only name and open link )
      tmpObj.unlimitedShow = false;
      tmpObj.unlimitedClass = 'normal';

      // Only if all plans within are unlimited -> switch display type to unlimited
      if (groupType === 'roaming' || onlyExtras) {
        tmpObj.unlimitedShow = true;
        tmpObj.unlimitedClass = 'unlimited';

      } else {
        if (locSet[collectIndex].usageType === 'unlimited') {
          tmpObj.unlimitedShow = true;
          tmpObj.unlimitedClass = 'unlimited';
        }
      }

      return tmpObj;
    }

    // Add more data into the large data objects - Total usage, color codes, calculate leftovers
    function wirelessServiceGlobalDataSets(masterSet, groupType) {
      var globalDisplayTotal = 0;
      var globalDisplayUsed = 0;
      var globalDisplayRemain = 0;
      var globalPercentage = 0;
      var globalColor = '';

      var globalOnlyExtras = true;
      var globalHaveExtras = false;
      var globalOverExtras = false;

      var globalUnlimitedShow = false;
      var globalUnlimitedClass = 'normal';
//					var globalNotice = '';

      var returnValue = false;
      if (masterSet.length > 0) {
        // Display yes
        returnValue = true;
      } else {
        // Display no
        returnValue = false;
      }

      // Process data
      if (returnValue) {
        // Look through all sets and collect flags that span across entire set
        var sumHaveExtras = false;
        var sumOnlyExtras = true;
        var sumOverExtras = false;

        _.forEach(masterSet, function(subSet) {
          if (subSet.haveExtras) {
            sumHaveExtras = true;
          }
          if (!subSet.onlyExtras) {
            sumOnlyExtras = false;
          }
          if (subSet.overExtras) {
            sumOverExtras = true;
          }
        });

        // Decide which to select - pick the first set of data - as it is assumed that it has the highest priority
        var largeSet = null;
        if (sumOnlyExtras === true) {
          // Pick the first one
          largeSet = masterSet[0];
        } else {
          if (sumHaveExtras === true) {
            // Find first index that is not pay-per-use
            var outIndex = 0;

            _.forEach(masterSet, function (tempSet, index) {
              if (tempSet.onlyExtras === false) {
                outIndex = index;
              }
            });

            largeSet = masterSet[outIndex];
          } else {
            // no extras -> pick the first one
            largeSet = masterSet[0];
          }
        }

        // Show the extras badge if there one or more plans has over-usage
        if (sumOverExtras === true) {
          // do something with this information
          sumHaveExtras = true;			// should user have over usage - it will show as extra badge
        }

        if (typeof largeSet === 'object') {

          // This would be a great place to add more logic if required
          globalDisplayTotal = largeSet.displayTotal;
          globalDisplayUsed = largeSet.displayUsed;
          globalDisplayRemain = largeSet.displayRemain;
          globalPercentage = largeSet.highestPercentage;
          globalColor = largeSet.highestColor;

          globalOnlyExtras = sumOnlyExtras;
          globalHaveExtras = sumHaveExtras;
          globalOverExtras = sumOverExtras;

          globalUnlimitedShow = largeSet.unlimitedShow;
          globalUnlimitedClass = largeSet.unlimitedClass;

          // Color definition
//							if (globalPercentage < limitLow) {
//								globalNotice = 'Looking good';
//							} else if (globalPercentage >= limitLow && globalPercentage < limitHigh) {
//								globalNotice = 'Check it out';
//							} else if (globalPercentage >= limitHigh) {
//								globalNotice = 'Extra Usage';
//							}
        }

        // Add data to master set
        masterSet.globalDisplayTotal = globalDisplayTotal;
        masterSet.globalDisplayUsed = globalDisplayUsed;
        masterSet.globalDisplayRemain = globalDisplayRemain;
        masterSet.globalPercentage = globalPercentage;
        masterSet.globalColor = globalColor;

        masterSet.globalOnlyExtras = globalOnlyExtras;
        masterSet.globalHaveExtras = globalHaveExtras;
        masterSet.globalOverExtras = globalOverExtras;

        masterSet.unlimitedShow = globalUnlimitedShow;
        masterSet.unlimitedClass = globalUnlimitedClass;
//						masterSet.globalNotice = globalNotice;
      }

      return returnValue;
    }

    function wirelessServiceSeparateUsage(masterSet, groupType, countChk) {
      var newMasterSet = {};
      newMasterSet.plans = [];
      newMasterSet.sumary = {};
      newMasterSet.extras = [];
      var newMasterArray = [];

      // split data by type plan (regular/unlimited) and extras
      _.forEach(masterSet, function(tmpObj) {
        _.forEach(tmpObj.usageSummary, function(tmpItem){
          if (typeof tmpItem === 'object') {
            if (tmpItem.usageType === 'pay-per-use') {
              newMasterSet.extras.push(tmpItem);
            } else {
              newMasterSet.plans.push(tmpItem);
            }
          }
        });
      });

      // collect all extras headlines and total values
      if (newMasterSet.extras.length > 0) {
        newMasterSet.sumary.usageType = 'extras_summary';
        newMasterSet.sumary.usageSets = [];

        _.forEach(newMasterSet.extras, function(tmpArr) {
          // header replace "/" with " / " for better breaking purposes
          var sourceHead = tmpArr.periodGroup;
          var cleanHeadline = sourceHead.replace('/', ' / ');

          var stuffObj = {};
          stuffObj.othersUsage = tmpArr.othersUsage;
          stuffObj.overage = tmpArr.overage;
          stuffObj.periodGroup = cleanHeadline;
          stuffObj.remaining = tmpArr.remaining;
          stuffObj.subscriberUsage = tmpArr.subscriberUsage;
          stuffObj.total = tmpArr.total;
          stuffObj.used = tmpArr.used;
          stuffObj.usageSummaryType = tmpArr.usageSummaryType;

          newMasterSet.sumary.usageSets.push(stuffObj);
        });
      }

      // re-assable the data into new array in this order - Plans > extras summary > extras
      if (newMasterSet.plans.length > 0) {
        _.forEach(newMasterSet.plans, function(aaArr){
          newMasterArray.push(aaArr);
        });
      }
      if (newMasterSet.extras.length > 0) {
        // sumary
        newMasterArray.push(newMasterSet.sumary);

        // extras
        _.forEach(newMasterSet.extras, function(ccArr){
          if (groupType === 'roaming') {
            // roamig data are always cinsidered an extras
            newMasterArray.push(ccArr);
          }
        });
        // roaming data also need to be separated into type buckets - data voice text
      }
      return newMasterArray;
    }

    return {
      postpaidDetails: null,
      // Usage data handling
      getWirelessDashBoard: function (request, callback) {
        request.language = languageSwitcher.getCurrentLanguage().toUpperCase();

        // ALWAYS load fresh JSON
        var _return = {};
        _dashboardDataRaw = null;

        ajax.wirelessDashBoard(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _dashboardDataRaw = data;

                // preset defaults
                _dashboardData = {};
                _dashboardData.data = [];
                _dashboardData.dataArr = [];
                _dashboardData.roaming = [];
                _dashboardData.roamingArr = [];
                _dashboardData.sms = [];
                _dashboardData.smsArr = [];
                _dashboardData.talk = [];
                _dashboardData.talkArr = [];

                var dataCounter = {};
                dataCounter.data = 0;
                dataCounter.roaming = 0;
                dataCounter.sms = 0;
                dataCounter.talk = 0;

                // Filter out objects that have no usage information
                var setCounter = 0;

                if (_dashboardDataRaw.data) {
                  // Data
                  _.forEach(_dashboardDataRaw.data, function(tmpObj){
                    var dadat = wirelessServiceObjectPush(_dashboardData.data, tmpObj, 'data');
                    dataCounter.data += dadat;
                    setCounter += dadat;
                  });

                  if (dataCounter.data > 0) {
                    _dashboardData.dataArr = wirelessServiceSeparateUsage(_dashboardData.data, 'data', dataCounter.data);
                  }
                }

                if (_dashboardDataRaw.roaming) {
                  // Roamiong
                  _.forEach(_dashboardDataRaw.roaming, function(tmpObj){
                    var darom = wirelessServiceObjectPush(_dashboardData.roaming, tmpObj, 'roaming');
                    dataCounter.roaming += darom;
                    setCounter += darom;
                  });

                  if (dataCounter.roaming > 0) {
                    _dashboardData.roamingArr = wirelessServiceSeparateUsage(_dashboardData.roaming, 'roaming', dataCounter.roaming);
                  }
                }

                if (_dashboardDataRaw.sms) {
                  // SMS
                  _.forEach(_dashboardDataRaw.sms, function(tmpObj){
                    var dasms = wirelessServiceObjectPush(_dashboardData.sms, tmpObj, 'sms');
                    dataCounter.sms += dasms;
                    setCounter += dasms;
                  });

                  if (dataCounter.sms > 0) {
                    _dashboardData.smsArr = wirelessServiceSeparateUsage(_dashboardData.sms, 'sms', dataCounter.sms);
                  }
                }

                if (_dashboardDataRaw.talk) {
                  // Talk
                  _.forEach(_dashboardDataRaw.talk, function(tmpObj){
                    var datal = wirelessServiceObjectPush(_dashboardData.talk, tmpObj, 'talk');
                    dataCounter.talk += datal;
                    setCounter += datal;
                  });

                  if (dataCounter.talk > 0) {
                    _dashboardData.talkArr = wirelessServiceSeparateUsage(_dashboardData.talk, 'talk', dataCounter.talk);
                  }
                }

                if (setCounter < 0 && isMCPPCrerating) {
                  // statusCode: "127" exeption - MCPPC
                  _return.MCPPCrerating = true;
                  _return.midCycle = false;
                  _return.empty = false;
                }
                else if (setCounter < 0) {
                  // statusCode: "103" exeption
                  _return.MCPPCrerating = false;
                  _return.midCycle = true;
                  _return.empty = false;

                } else if (setCounter === 0) {
                  _return.MCPPCrerating = false;
                  _return.midCycle = false;
                  _return.empty = true;
                } else {
                  _return.MCPPCrerating = false;
                  _return.midCycle = false;
                  _return.empty = false;
                }
// To be removed soon
// TOT-2631 HACK BEGIN
                _.forEach(data.talk, function (item) {
                  if (item.statusCode && item.statusCode === '10012') {
                    _return.MCPPCrerating = false;
                    _return.midCycle = true;
                    _return.empty = false;
                  }
                });
// TOT-2631 HACK END
// To be removed soon
                _return.result = 'success';
                _return.data = _dashboardData;
                return callback(_return);

              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardData = null;
                _return.result = 'fail';
                _return.data = data;
                _return.empty = true;
                _return.midCycle = false;
                _return.MCPPCrerating = false;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      clearWirelessDashBoard: function () {
        // Purge any data
        _dashboardData = null;
        return true;
      },
      clearWirelessPostpaidCache: function() {
        _wirelessPostpaidCache = {};
      },
      globalDataSets: function (masterSet, groupType) {
        return wirelessServiceGlobalDataSets(masterSet, groupType);
      },
      getWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackage(request).then(
            function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                //_dashboardTravelPackageData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            }, function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
                return callback(_return);

              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
                return callback(_return);
              }
            }
        );
      },
      getWirelessTravelPackageStaticContent: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageStaticContent(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardTravelPackageData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      getWirelessTravelPackageAddOnSummary: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageAddOnSummary(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                // _dashboardTravelPackageAddOnSummaryData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      setWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.setwirelessTravelPackage(request)
          .then(function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              // _dashboardTravelPackageAddOnSummaryData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      getFraudSocMessage: function () {
        return errorMessageFraudAccess;
      },
      // Plugin / widget data handling

      // Postpaid data for widgets
      getWirelessPostpaid: function (request) {
        var _this = this,
          _cacheFailSafe = true,
          deferred = $q.defer();  //I need to use defer object, because wirelessPostpaidCall is being called recursively

        var wirelessPostpaidCall = function () {

          // ALWAYS load fresh JSON
          var _return = {};
          _this.postpaidData = null;
          _this.isPostPaidDetailsDataReady = false;

          /**
           * Using the new version api for postpaidDetails with new data structure
           */
          ajax.wirelessPostpaidV2(request)
            .then(function (rawData) {
              /**
               * Check response data and set it to data
               */
              var data;
              if (_.has(rawData, 'content.postPaidDetails.content')) {
                data = rawData.content.postPaidDetails.content;
              }
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.stale = false;

                if (data.cachedResultInfo && data.cachedResultInfo.expired && _cacheFailSafe) {
                  request.refresh = true;
                  _cacheFailSafe = false;
                  _return.stale = true;
                  wirelessPostpaidCall();
                  return; // need to return, otherwise promise will be resolved without getting fresh data.
                }

                /**
                 * Populate Ovagerage Data and Canada wide to data
                 */
                if (_.has(rawData, 'content.wirelessPlanFeatures.content')) {
                  if (_.has(rawData.content.wirelessPlanFeatures.content, 'overAgeRate')) {
                    data.overAgeRate = rawData.content.wirelessPlanFeatures;
                  }
                  if (_.has(rawData.content.wirelessPlanFeatures.content, 'isCanadaWide')) {
                    data.isCanadaWide = rawData.content.wirelessPlanFeatures;
                  }
                }
                _return.result = 'success';
                _return.data = data;
                _this.postpaidData = _return;

                if (_this.postpaidData.data.postPaidPhoneDetails.hasFraudSoc) {
                  errorMessageFraudAccess = $translate.instant('ute.common.oneview.header.wirelessDashboardService.fraud_display_message');
                } else if (_this.postpaidData.data.postPaidPhoneDetails.hasCreditOps) {
                  errorMessageFraudAccess = $translate.instant('ute.common.oneview.header.wirelessDashboardService.credit_ops_display_message');
                } else {
                  errorMessageFraudAccess = undefined;
                }

                _this.isPostPaidDetailsDataReady = true;
                deferred.resolve(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardPostpaidData = null;
                _return.result = 'fail';
                _return.data = data;
                _this.postpaidData = _return;
                _this.isPostPaidDetailsDataReady = true;
                deferred.reject(_return);
              }
            })
            .catch(function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.' + error.error.errorCode);		// Pull message from resource file
                _this.postpaidData = _return;
                deferred.reject(_return);
              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('ute.common.oneview.header.wirelessDashboardService.error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation

                _this.postpaidData = _return;
                deferred.reject(_return);
              }
            });
        };

        if(_wirelessPostpaidCache && _wirelessPostpaidCache.promise && _wirelessPostpaidCache.ctn === request.ctn) {
          return _wirelessPostpaidCache.promise;
        } else {
          wirelessPostpaidCall();

          _wirelessPostpaidCache = {
            promise: deferred.promise,
            ctn: request.ctn
          };

          return deferred.promise;
        }
      },

      setWirelessDashData: function (data) {
        wirelessDashData = data;
      },
      getWirelessDashData: function () {
        return wirelessDashData;
      },

      showResetVoicemailModal: function () {
        return _openResetVoicemailModal;
      },
      enableResetVoicemailModal: function () {
        _openResetVoicemailModal = true;
      },
      disableResetVoicemailModal: function () {
        _openResetVoicemailModal = false;
      }
    };
  }
})();

/* jshint -W106 */
(function () {
  'use strict';

  angular.module('ute.common.oneview.header')
    .controller('wirelessRemoveModalCtrl', wirelessRemoveModalCtrl);

  wirelessRemoveModalCtrl.$inject = ['$scope',
    '$modalInstance',
    'settingsHeader',
    'ute.blocks.language.switcher'];
  function wirelessRemoveModalCtrl($scope,
                                   $modalInstance,
                                   settings,
                                   languageSwitcher) {

    $scope.ok = function () {
      $modalInstance.close('ok');
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    function setStaticChatButtonValues() {
      if ($scope.lng === 'en') {
        $scope.boldChatButtonId = 'S_MRog_Wless_ChngeWlessPln';
        $scope.boldChatButtonDiv = 'changePlan-en';
        $scope.boldChatButton = 'chatButtonChangePlanEn';
      } else {
        $scope.boldChatButtonId = 'S_MRog_Wless_ChngeWlessPln_Fr';
        $scope.boldChatButtonDiv = 'changePlan-Fr';
        $scope.boldChatButton = 'chatButtonChangePlanFr';
      }
    }

    function init() {
      $scope.lng = languageSwitcher.getCurrentLanguage();
      $scope.viewAllPlanslink = '/web/content/wireless_plan_landing?setLanguage=' + $scope.lng;
      $scope.chatHref = $scope.lng === 'en' ? settings.chatLinkChangePlan.en : settings.chatLinkChangePlan.fr;  // 'cuscare_ECare_landing.php?hm=n&s=701',
      setStaticChatButtonValues();

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        $scope.lng = lang;
        $scope.viewAllPlanslink = '/web/content/wireless_plan_landing?setLanguage=' + $scope.lng;
        setStaticChatButtonValues();
      }, 'wirelessRemoveModalCtrlLangSub_'+$scope.$id);

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler('wirelessRemoveModalCtrlLangSub_'+$scope.$id);
      });
    }

    init();
  }
}());

'use strict';

function scrollPageToTop () {
	// plain jquey page scroll to top.  (Could be animated)

//	setTimeout(function () {			// Enable tiout ONLY if really really needed
		window.scrollTo(0, 0);			// jshint ignore:line
		$(window).scrollTop;			// jshint ignore:line
//	}, 100);
}

function nullOrEmpty(value) {
  return (value === null || value === '');
}

function replace(value, target, replacement) {
  if (nullOrEmpty(value)) {
    return value;
  }
  return value.replace(target, replacement);
}

function smUrlDecode(value) {

  // This URL decoding is specific to SiteMinder
  // Some details may be found here
  // https://communities.ca.com/thread/100358666
  // http://cookbooks.ca.com/casiteminder/?p=27

  value = replace(value, /%20/g, ' ');
  value = replace(value, /%26/g, '&');
  value = replace(value, /%2b/g, '+');
  value = replace(value, /%3f/g, '?');
  value = replace(value, /%3d/g, '=');
  value = replace(value, /%2f/g, '/');
  value = replace(value, /%2e/g, '.');
  value = replace(value, /--/g, '-');
  value = replace(value, /-SM-HTTPS/i, 'https');
  value = replace(value, /%3a/, ':');
  value = replace(value, /%24/g, '$');

  return value;
}

function scrollToAnchor(hash) {
    location.hash = '#' + hash;
}

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name ute.common.oneview.header.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the ute.common.oneview.header
   */

  angular.module('ute.common.oneview.header').
	filter('formatCtnInHeader', function() {
		return function(ctn) {
    		if(ctn !== null && ctn !== '') {
    			var formattedCtn = ''+ctn.substring(0,3)+' ' + ctn.substring(3,6)+ '-' + ctn.substring(6,10) ;
    			return formattedCtn;
    		} else {
    			return ctn;
    		}
    	};
	});
  angular.module('ute.common.oneview.header').controller('MyrOneViewHeaderController', oneViewHeaderController);

  oneViewHeaderController.$inject = ['$scope',
    '$rootScope',
    'settingsHeader',
    '$translate',
    'ute.common.permissions.service',
    'ute.common.user.service',
    'ute.blocks.messages.bus.service',
    'ute.blocks.language.switcher',
    'ute.common.agent.info.factory',
    'miscService',
  '$cookies',
'ute.blocks.persistent.storage.service',
'ute.oneview.footer.service',
'ute.oneview.header.service'];

  /* @ngInject */
  function oneViewHeaderController($scope,
                                   $rootScope,
                                   settings,
                                   $translate,
                                   permissionsService,
                                   userService,
                                   messagesService,
                                   languageSwitcher,
                                   agentInfoFactory,
                                   miscService,
                                  $cookies,
                                persistentStorageService,
                                oneViewFooterService,
                                oneViewHeaderService
                              ) {
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.isDealer = $rootScope.isDealer;
    $scope.isCare = $rootScope.isCare;
    $scope.displayAddnoteSection=null;
    $scope.repName = null;
    $scope.userDealerCode = null;
    $scope.isDealerCodeSubmitted = false;
    $scope.displayDealerCodeSection = null;

    $scope.BASEURL = miscService.getBaseUrl();
    
    agentInfoFactory().getAgentInfo().then(function(agentInfo) {
      if (userService.isDealer()) {
        // $scope.repName = $rootScope.userInfo.cfaInfo.cfaInfo.cfaFirstName + " " +  $rootScope.userInfo.cfaInfo.cfaInfo.cfaLastName;
        $scope.repName = agentInfo.cfaInfo.cfaFirstName + ' ' + agentInfo.cfaInfo.cfaLastName;
      } else if (userService.isCare()) {
        $scope.repName = agentInfo.lanId;
      }
    });
    if ($scope.isCare) {
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
        if (isPermitted) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
            .then(function (agentPermission) {
              $scope.displayDealerCodeSection = agentPermission;
          });
        }
      });
    }
    // Self hiding logic
    $scope.repViewHeaderSelfDestruct = function (stateString) {
      // array lookup
      // return true;
      //TODO uncomment after testing 
      return settings.showRepViewHeaderAndFooterStates.indexOf(stateString) !== -1;
    };
    $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct();
    // Listen to the state change broadcast
    var scopewatch1 = $rootScope.$watch('isRepView', function () {
      var toState = $rootScope.toState;
      if ($rootScope.isDealer || $rootScope.isCare) {
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
        //$scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState);
        if ($rootScope.isRepView === 'false') {
          // DO NOT show the repView header and footer
          $scope.selfDestructFlag = false;
          $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState);
          if ($scope.tempFlag) {
            customerViewComponents();
          } else {
            defaultComponents();
          }

        } else {
          $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState);
          if ($scope.selfDestructFlag) {
            repViewComponents();
          } else {
            defaultComponents();
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });
    function customerViewComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').show();
      $('div[data-liveheader] #header').css('position', 'static');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }

    function repViewComponents() {
      $('div[data-liveheader]').hide();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').hide();
      $('div[data-oneviewfooter]').show();
      $('.directive-sub-menu').hide();
      $('.directive-repview-header').show();
      $('.one-view-repview-footer').show();
      $('.one-view-consumer-footer').hide();
    }

    function defaultComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('div[data-liveheader] #header').css('position', 'fixed');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('#toggleSwitch').hide();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }
    $scope.customerViewToggleSwitchDestruct = function (stateString) {
      // array lookup
      return true;//TODO uncomment when done testing ($scope.settings.showCustomerViewToggleSwitchStates.indexOf(stateString) !== -1);
    };
    $scope.isToggleSwitchDisabledMethod = function (stateString) {
          // array lookup
      return true;//TODO uncomment when done testing ($scope.settings.disableToggleSwitchStates.indexOf(stateString) !== -1);
    };

    // because this controller has been used for two directives, we need to provide a unique key (string + scopeId) for "registerOnDataChangeHandler" function.
    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.lang = lang;
      $('html').attr('lang', lang);
      //TODO move to oneView $scope.appInterface.fn.languageChange(lang);

      $scope.dealerCodePlaceholder = $translate.instant('ute.common.oneview.header.util.oneViewHeaderController.dealer-code');
    }, 'oneViewHeaderControllerLangSub_'+$scope.$id);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('oneViewHeaderControllerLangSub_'+$scope.$id);
      scopewatch1(); //n
    });

    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
      //$scope.isInteraction = $rootScope.currentStateName === 'interaction';
      if ($rootScope.isDealer || $rootScope.isCare) {
        if (userService.isSigned()) {
          $scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState.name);
          $scope.isOneViewInterface = $rootScope.isOneViewInterface;
          if ($rootScope.isRepView === 'false') {
            // DO NOT show the repView header and footer
            $scope.selfDestructFlag = false;
            $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState.name);
            if ($scope.tempFlag) {
              customerViewComponents();
            } else {
              defaultComponents();
            }
          } else {
            $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState.name);
            if ($scope.selfDestructFlag) {
              repViewComponents();
            } else {
              defaultComponents();
            }
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });

    $scope.executeLogOut = function () {
      console.log('executeLogout1123');
      if($rootScope.isDealer) {
        /* To redirect the user to SSP dashboard */
        //backToSSPService.backToSSP();
        var language = $cookies.language;
        var province = $cookies.province;
        var postData = {
          ctn: persistentStorageService.getFromLocal('phoneNumber'),
          accountNumber: persistentStorageService.getFromLocal('accountNumber'),
          lang: language,
          prov: province,
          targetFlow: 'sspdashboard'
        };
        if (persistentStorageService.getFromLocal('toStateName') !== 'wireless') {
          postData.ctn = '';
        }
        oneViewFooterService.backToSSP(postData).then(function (result) {
            if (result !== false) {
                if (result.isCableOnly) {
                    $('#footerFormToSSP').attr('action', result.envPath + oneViewHeaderService.getConfig().settings.agentInfo.signoutURL);
                    $('#footerFormToSSP').submit();
                } else {
                    $('#footerFormToSSP').find('#sharedKey').val(result.sharedKey);
                    $('#footerFormToSSP').find('#signature').val(result.signature);
                    $('#footerFormToSSP').find('#content').val(result.content);
                    $('#footerFormToSSP').attr('action', result.envPath + oneViewHeaderService.getConfig().settings.agentInfo.sspDashboardURL);
                    $('#footerFormToSSP').submit();
                }
            } else {
                $('#footerFormToSSP').attr('action', result.envPath + oneViewHeaderService.getConfig().settings.agentInfo.signoutURL);
                $('#footerFormToSSP').submit();
            }
        }).catch(function (result) {
            $('#footerFormToSSP').attr('action', result.envPath + oneViewHeaderService.getConfig().settings.agentInfo.signoutURL);
            $('#footerFormToSSP').submit();
        });
      } else {
        // user.logout(false, 'LOGOUT');
        miscService.logout(false, 'logout');
      }
    };

    $scope.changeLanguage = function () {
      if ($scope.lang === 'en') {
        languageSwitcher.changeLanguage('fr');
      $translate.use('fr');
      } else {
        languageSwitcher.changeLanguage('en');
      $translate.use('en');
      }
      $rootScope.$broadcast('languageChanged');
    };
  languageSwitcher.registerOnDataChangeHandler(function (lang) {
    console.log('lang1123: ', lang);
  });

    $scope.onRepNameSelect = function () {
      return false;
    };

    checkAddNotesPermission();
    function checkAddNotesPermission() {
      if($scope.isDealer) {
        //$scope.displayAddnoteSection=false;
        permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_INTERACTION_NOTES_DEALER).then(function (isPermitted) {
          $scope.displayAddnoteSection = isPermitted;
        });
      } else if($scope.isCare) {
        permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_INTERACTION_NOTES_CARE).then(function (isPermitted) {
          $scope.displayAddnoteSection = isPermitted;
        });
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('ute.common.oneview.header').directive('oneViewHeader', oneViewHeader);

  oneViewHeader.$inject = [];

  /* @ngInject */
  function oneViewHeader() {
    return {
      templateUrl: 'module/oneViewHeaderDirective/oneViewHeader.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyrOneViewHeaderController',
      controllerAs: 'oneViewHeaderController'
    };

  }
})();


(function () {
    'use strict';
  
    angular.module('ute.common.oneview.header').constant('settingsHeader', {
    supportedLanguages: {
        en: 'English',
        fr: 'Français'
    },
    defaultLanguage: 'en',
    isDevBB: window.location.host.match('dev') || window.location.host.match('totes') || window.location.host.match('localhost.rogers.com'),
    isQaBB: window.location.host.match('qa'),
    isProdBB: window.location.host.match('www.rogers.com'),
    devMode: true,
    omitPagesFromGlobalLoader: [''],
    useLocalAPI: false,
    reviewLink: {
        en: 'https://www.rogers.com/web/support/supportbillingpayment',
        fr: 'https://www.rogers.com/web/support/supportbillingpayment/setLanguage=fr'
    },
    chatLink: {
        en: 'http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701',
        fr: 'http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?hm=n&s=751'
    },
    chatLinkChangeModem: {
        en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=16&lctc=16%7C01%7Cws%7Cchange_my_modem_en',
        fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=66&lctc=66%7C01%7Cws%7Cchange_my_modem_fr'
    },
    chatLinkChangePlan: {
        en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en ',
        fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr'
    },
    chatLinkModules: {
        payment: {
            en: 'http://www.rogershelp.com/customerserv/credops_landing.php?hm=n&s=203',
            fr: 'http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253'
        }
    },
    chatLinkHup: {
        en: 'http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&lctc=707%7C01%7Cws%7CHUP_landing%20en',
        fr: 'http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr'
    },
    agentInfo: {
        heartbeatURL: 'shop/cfa/o/logout-keep-alive',
        signoutURL: 'shop/home',
        sspDashboardURL: 'shop/cfa/ssp-ute-interface',
        careTimeout: 45,
        dealerTimeout: 15,
        sspHomeURL: 'shop/cfa/home'
    },
    britebill: {
        local: 'https://qa2.invoiceportal.rogers.com/'
    },
    salesForceUrl: {
        dev: 'https://uat.config.cs7.force.com/',
        qa: 'https://uat.config.cs7.force.com/',
        prod: 'https://rogersprod.secure.force.com/'
    },
    revolutionExternalLinks: {
        spotify: {
            en: {
                qa: 'https://www.spotify.com/ca-en/download/',
                prod: 'https://www.spotify.com/ca-en/download/'
            },
            fr: {
                qa: 'https://www.spotify.com/ca-fr/download/',
                prod: 'https://www.spotify.com/ca-fr/download/'
            }
        },
        nextissue: {
            en: {
                qa: 'https://staging-secure.nextissue.ca/',
                prod: 'https://www.nextissue.ca/en/'
            },
            fr: {
                qa: 'https://staging-secure.nextissue.ca/',
                prod: 'https://www.nextissue.ca/fr/'
            }
        }
    },
    revolutionLink: '/web/totes/plans/#/manage-your-experience',
    revolutionSegmentNumber: 6,
    revolutionPermissionName: 'VIEW_ACCOUNT_BALANCE',
    revolutionAddNhl: false,
    revolutionGetOffersPrefix: '/web/RogersServices.portal/totes/api',
    revolutionGetOffers: 'v1/offer-status', //'http://10.10.94.138:9000/selfserve/v1/offer-status',
    oneViewRevolutionGetOffersPrefix: '/web/totes/api',
    permittedDomains: ['netflix.com'],
  redeemPoints: 400,
  usageLimit: 75,
  msInDay: 1000 * 60 * 60 * 24,
  //The maximum amount user can pay is the due amount + paymentMaximum.
  paymentMaximum: 1000,
  //payment history list: pagesPerSection is the number of pages each pagination section can display. itemsPerPage is the number of records per page.
  paymenthistory: {
    pagesPerSection: 5,
    itemsPerPage: 10
  },
  //creditCardField for semafone
  iframeParameters: {
    en: 'Credit Card Number',
    fr: 'Num%26eacute%3Bro de carte de cr%26eacute%3Bdit' //Numéro de carte de crédit (encoded)
  },
  // Show all failures in a overlay box message
  showErrorPopup: false,
  // secure vs. unsecure path calls
  devServerURL: 'https://www.dev18.rogers.com', //'http://10.10.47.23:8033', // https://www.dev17.rogers.com if you are on localhost this will prepend to your URLs


    unProtectedUrlPrefix: '/web/totes/api/v1/', // secureCallDefault = false
    protectedUrlPrefix: '/web/RogersServices.portal/totes/api/v1/', // secureCallDefault = true

    //userType constants
    userType: {
        dealer: 'dealer',
        care: 'care',
        consumer: 'consumer'
    },
    //oneView Error Code Constants
    oneViewStatusCodes: {
        sspSSOFailure: 'SSP_SSO_FAILURE',
        crmSSOFailure: 'CRM_SSO_FAILURE',
        sspAccessFailure: 'SSP_ACCESS_FAILURE',
        crmAccessFailure: 'CRM_ACCESS_FAILURE',
        fidoAccessFailure: 'FIDO_ACCESS_FAILURE',
        crmServiceFailure: 'CRM_SERVICE_FAILURE',
        sspServiceFailure: 'SSP_SERVICE_FAILURE',
        sessionTimeout: 'SESSION_TIMEOUT',
        crmSignout: 'CRM_SIGN_OUT',
        fraudCheck: 'FRAUD_CUSTOMER',
        creditOps: 'CREDIT_OPS_FAILURE'
    },

    deepLinkStatusCodes: {
        transStatusSuccess: 'SUCCESS',
        transStatusError: 'ERROR',
        changeCTN: 'Change CTN',
        changeSIM: 'SIM/IMEI Change',
        changePricePlan: 'Priceplan Change',
        manageAddon: 'Manage Add-ons',
        updateVoiceMailPassword: 'Reset Voicemail',
        upgradeDevice: 'HUP',
        addaLineShared: 'Add Subscriber - Shared',
        addaLineIndividual: 'Add Subscriber - Individual',
        hupCancellation: 'HUP Cancellation',
        getWireless: 'Create Wireless Account'
    },
    //defaultForRetailandCare:'DefaultForRetailandCare',

    //TBD figure out how to find My5 add-on
    my5soc: 'MY5 Talk',
    myVM: 'VM',
    //!!! secureCallDefault - By default all calls are treated as secure -> true, pages and calls listed will be resolved into unsecure -> false

    // Default value to decide if call should be to [unProtectedUrlPrefix] OR [protectedUrlPrefix]
    secureCallDefault: true,
    // Pages listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
    // array values are module name
    secureCallPages: [
        'home',
        'signin',
        'signin/resetPassword',
        'registration',
        'registrationNoEmailVerify',
        'forgetPassword',
        'forgetusername',
        'invalidPath',
        'demo',
        'permissionDenied',
        'tpsc'
    ],
    // Ajax call functions listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
    // array values are relative paths from the ajax.post call
    // secureCalls: ['wirelessDashBoard', 'profile/question'],		// Example
    unprotectedCalls: [
        'testlogin',
        'signin',
        'signin/resetPassword',
        'profile',
        'register',
        'discardAllSmCookies',
        'profile/question',
        'forgot/username',
        'forgot/password/resubmit',
        'forgot/password',
        'maintenanceSettings',
        'discovery-page/get-content'
    ],
    protectedCalls: [
        'permissions',
        'cart/fetch'
    ],
    // Pages listed in this array will use URL provided as an overide to URLs provided by default (key/value type of arrangement)
    // key = module name
    moduleCallException: {
        // 'linkaccount': '/web/RogersServices.portal/api/v1/'		// Example
    },
    // Ajax call functions listed in this array will use overide value from this array. (key/value type of arrangement)
    // key = relative parh from the ajax.post call  (payment/decrypt IS VALID as array key)
    ajaxCallException: {
        'loggedIn': '/web/RogersServices.portal/totes/api/v1/loggedIn',
        'signin': '/siteminderagent/forms/login.fcc',
        'accountoverview': '/web/RogersServices.portal/totes/api/v1/accountoverview',
        'profile/checkComplete': '/web/RogersServices.portal/totes/api/v1/profile/checkComplete',
        'ebu/nickname': '/web/RogersServices.portal/totes/api/v1/ebu/nickname',
        'usernameMigration/check': '/web/RogersServices.portal/totes/api/v1/usernameMigration/check',
        'wcoc/decryptjwttoken': '/web/RogersServices.portal/totes/api/v1/wcoc/decryptjwttoken'
    },
    // Page login - list pages that need to be login protected
    // THIS IS DIFFERENT from secure / unsecure calls above
    pageLoginRequired: {
        //false - means all users / public
        'home': false,
        'registration': false,
        'signin': false,
        'signin/resetPassword': false,
        'forgetPassword': false,
        'forgetusername': false,
        'invalidPath': false,
        'demo': false,
        'permissionDenied': false,
        'underMaintenance': false,
        'tpsc': false,
        'uaa': false,
        'discoveryPageNoLiveContentParam': false,
        //true - means only for logged-in users
        'guestOverview': true,
        'guestoverview': true,
        'linkaccount': true,
        'accountSelector': true,
        'accountOverview': true,
        'paymenthistory': true,
        'paynow': true,
        'migrateuser': true,
        'changemethod': true,
        'wireless': true,
        'tvdashboard': true,
        'internetdash': true,
        'shmdashboard': true,
        'rhpdashboard': true,
        'viewbill': true,
        'wireless-plan-change': true,
        'review-order': true,
        'confirm-order': true,
        'completeProfile': true,
        'reservedevice': true,
        'profile': true,
        'deviceConfigure': true,
        'deviceCatalog': true,
        'oneViewInterface': false,
        'uteOneviewEnvPage': false
    },
   
    postSigninUrl: window.location.protocol + '//' + window.location.hostname + ((window.location.protocol === 'http' && window.location.port === '80') ||
        (window.location.protocol === 'https' && window.location.port === '443') ? '' : ':' + window.location.port) + '/web/RogersServices.portal/totes/#/accountOverview',
    postSigninUrlShort: '/web/totes/#/accountOverview',
    postSignOutUrl: '/web/totes/#/signin',
    postToRogersUrls: [
        { url: '/web/myrogers/viewBill' },
        { url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary' },
        { url: '/web/myrogers/prepaidTopUp' }
    ],
    oneViewExternalAPIs: {
        news: 'https://news-weather-feeds-prod.herokuapp.com/news/items?site=',
        weather: 'https://news-weather-feeds-prod.herokuapp.com/weather/entries?city='
    },
    newsAvailableProvinces: {
        ON: 'WWW_680NEWS_COM',
        BC: 'WWW_NEWS1130_COM',
        NS: 'WWW_NEWS957_COM',
        NB: 'WWW_NEWS957_COM',
        PE: 'WWW_NEWS957_COM',
        AB: 'WWW_660NEWS_COM',
        QC: 'WWW_LACTUALITE_COM',
        en: 'WWW_MACLEANS_CA',
        fr: 'WWW_LACTUALITE_COM'
    },
    // exceptional behaviour
    siteminderUrl: '/siteminderagent/forms/login.fcc', // Used in signin.js
    tempPasswordUrl: '/siteminderagent/forms/smpwservices.fcc',
    enablePricePlanChanges: true,
    enableSelfServe: true,
    // page that are mandatory to complete and should have all sub menus disabled
    mandatoryPages: [
        'migrateUser',
        'completeProfile'
    ],
    maxRetryOnExpired: 1,
    routingListToHideLiveContentHeader: ['forgotPasswordNoLivecontent', 'forgotUserNameNoLivecontent'],
    routingListToHideLiveContentFooter: ['forgotPasswordNoLivecontent', 'forgotUserNameNoLivecontent', 'shareEverything.accountsSummary'],

    // show the repview header and footer in the mentioned states
    showRepViewHeaderAndFooterStates: [
        'tvdashboard',
        'wireless',
        'internetdash',
        'oneViewDashboard',
        'interaction',
        'profile',
        'self-serve',
        'paynow',
        'changemethod',
        'paymenthistory',
        'simCard.start',
        'simCard.confirmation',
        'simCard.success',
        'viewbill',
        'suspendCtn.start',
        'suspendCtn.success',
        'reactivateCtn.success',
        'shareEverything.dashboard',
        'shareEverythingError',
        'oneViewInterface',
        'transferOfResponsibility.start',
        'transferOfResponsibility.stepOne/ctnSelection',
        'transferOfResponsibility.stepOne/eligibilityCheck',
        'transferOfResponsibility.stepTwo/futureOwnerInfo',
        'transferOfResponsibility.stepTwo/confirmation',
        'transferOfResponsibility.stepThree/subscriberDetails',
        'transferOfResponsibility.stepThree/currentOwnerInfo',
        'transferOfResponsibility.stepThree/eligibilityCheck',
        'transferOfResponsibility.stepFour',
        'creditAdjustmentDetails',
        'creditAdjustmentDetails.display',
        'ptp.start',
        'actionsOffers',
        'inbounds', 
        'outbounds',
        'orders',
        'rhpdashboard'

    ],
    showCustomerViewToggleSwitchStates: [
        'accountOverview',
        'wireless',
        'internetdash',
        'tvdashboard',
        'interaction',
        'profile',
        'self-serve',
        'paynow',
        'changemethod',
        'paymenthistory',
        'simCard.start',
        'simCard.confirmation',
        'simCard.success',
        'viewbill',
        'suspendCtn.start',
        'suspendCtn.success',
        'reactivateCtn.success',
        'shareEverything.dashboard',
        'shareEverythingError',
        'oneViewInterface',
        'transferOfResponsibility.start',
        'transferOfResponsibility.stepOne/ctnSelection',
        'transferOfResponsibility.stepOne/eligibilityCheck',
        'transferOfResponsibility.stepTwo/futureOwnerInfo',
        'transferOfResponsibility.stepTwo/confirmation',
        'transferOfResponsibility.stepThree/subscriberDetails',
        'transferOfResponsibility.stepThree/currentOwnerInfo',
        'transferOfResponsibility.stepThree/eligibilityCheck',
        'transferOfResponsibility.stepFour',
        'creditAdjustmentDetails',
        'creditAdjustmentDetails.display',
        'ptp.start',
        'actionsOffers',
        'inbounds',
        'outbounds',
        'rhpdashboard'
    ],
    disableToggleSwitchStates: [
        'suspendCtn.start',
        'suspendCtn.success',
        'reactivateCtn.success',
        'interaction',
        'oneViewInterface',
        'transferOfResponsibility.start',
        'transferOfResponsibility.stepOne/ctnSelection',
        'transferOfResponsibility.stepOne/eligibilityCheck',
        'transferOfResponsibility.stepTwo/futureOwnerInfo',
        'transferOfResponsibility.stepTwo/confirmation',
        'transferOfResponsibility.stepThree/subscriberDetails',
        'transferOfResponsibility.stepThree/currentOwnerInfo',
        'transferOfResponsibility.stepThree/eligibilityCheck',
        'transferOfResponsibility.stepFour',
        'creditAdjustmentDetails',
        'creditAdjustmentDetails.display',
        'ptp.start',
        'simCard.start',
        'simCard.confirmation',
        'simCard.success',
        'actionsOffers',
        'inbounds',
        'outbounds'
    ],
    restCallRetry: {
        retryCondition: function (error) {
            return ((error.status <= 0) || (error.status === 400));
        },
        1: {
            timeDelay: 500
        },
        2: {
            timeDelay: 1000
        },
        3: {
            timeDelay: 2000
        }
    },
    formToRogersTemplate: 'scripts/modules/rogersForm/formToRogers.html',
    // rfrTwilightView: null,
    interactionsIconClassesMap: {
        'phone': 'interaction-call',
        'call': 'interaction-call',
        'e-chat': 'interaction-livechat',
        'rogers.com': 'interaction-web',
        'self serve': 'interaction-web',
        'ivr': 'interaction-web',
        'web': 'interaction-web',
        'mobile wallet': 'interaction-mobile-wallet',
        'store': 'interaction-store',
        'in person': 'interaction-store',
        'sms': 'interaction-sms',
        'mms': 'interaction-sms',
        'mail': 'interaction-outbound-mail',
        'e-mail': 'interaction-outbound-mail',
        'email': 'interaction-outbound-mail',
        'default': 'interaction-default-icon',
        'social media': 'interaction-default-icon',
        'fax': 'interaction-default-icon',
        'system': 'interaction-default-icon'
    },

    service: {
        wireless: 'service_wireless',
        suspended: 'Suspended'
    },
    contactNumbers: {
        billingIssue: '1 877 559-5202'
    },

    prepaidAccountViewBillUrl: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary'

});
})();
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function (_) {
  'use strict';

  var subMenuItems = {
      overview: 0,
      billingAndPayment: 1,
      services: 2,
      profile: 3,
      guestoverview: 4,
      interaction: 5,
      actionsOffers: 6,
      orders: 7,
      names: {
          0: 'Overview',
          1: 'Billing & Payment',
          2: 'Services',
          3: 'Profile'
      }
  };

  /**
   * @name totesApp.controller:HeaderMyrSubMenuController
   * @description
   * # HeaderMyrSubMenuController
   * Controller of the totesApp
   */
  angular.module('ute.common.oneview.header').controller('HeaderMyrSubMenuController', subMenuController);

  subMenuController.$inject = ['$scope',
    '$rootScope',
    '$state',
    '$location',
    '$window',
    '$modal',
    '$cookies',
    'ute.common.user.service',
    'ute.blocks.language.switcher',
    'ute.common.permissions.service',
    'ute.common.second.level.navigation.service',
    'ute.rogers.eclipse.remote.api.service',
    'ute.data.manager.service',
    '$resolve',
    'ute.transferOfResponsibility.service',
    'ute.common.customer.credit.management.service',
    'ute.brite.bill.service',
    'ute.oneview.header.service',
    'ute.oneview.submenu.service',
    'ute.common.agent.info.factory',
    'ute.blocks.messages.bus.service',
    'headerMyServicesService',
    'ute.rogers.account.overview.factory',
    'miscService'
  ];

  /* @ngInject */
  function subMenuController($scope,
                             $rootScope,
                             $state,
                             $location,
                             $window,
                             $modal,
                             $cookies,
                             userService,
                             languageSwitcher,
                             permissionsService,
                             navigationService,
                             eclipseRemoteApi,
                             dataManagerService,
                             $resolve,
                             torService,
                             ccmService,
                             briteBillService,
                             oneViewHeaderService,
                             oneViewSubmenuService,
                             agentInfoFactory,
                             messagesService,
                             mss,
                             accountOverviewFactory,
                             miscService) {
    var accountOverviewService = accountOverviewFactory();
    var agentInfoService = agentInfoFactory();

    $scope.BASEURL = miscService.getBaseUrl();
    
    $scope.updateBtnSettings = function () {
      if (accountActive && accountActive.accountStatus) {
        $scope.btnSettings =  oneViewHeaderService.getSettingByAccountStatus(accountActive.accountStatus);
      }
    };
    oneViewHeaderService.getSummaryWorker().then( function (worker) {
      worker.getAccountOverviewSummaryRawData().then(function(summary) {

        subscriptionList = summary.subList;
        mss.selectedAccountDetails = summary;
        accountOverviewService.getAccountOverview().then(function(accountOverview) {
          setAccountlist(accountOverview);
          $scope.updateBtnSettings();
          accountOverview.getSelectedAccountDetails().then(function(selectedAccountDetails) {
            mss.selectedAccount = accountOverview;
            var subscriptions;
            if (userService.isConsumer()) {
              subscriptions = mss.getSubscriptions(vm.mss.accountDetails.subList, false);
              $scope.subMenuMyServicesList = subscriptions.myServices;
              $scope.myOtherServicesListFinal = subscriptions.myOtherServices;
            }
            else if (userService.isCare() || userService.isDealer()) {
              var disablePermissionNotGranted = [true,true,true,true];
              var badgePermission = ['Maestro_TV_Dashboard', 'Maestro_INT_Dashboard', 'Maestro_RHP_Dashboard','Maestro_SHM_Dashboard'];
              permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
                if (isPermitted) {
                  if (!_.isArray(badgePermission)) {
                    badgePermission = [badgePermission];
                  }
                  badgePermission.forEach(function (permission,index) {
                    var uteCommonPermission = _.get(ute.common.permissions.service.RamResourceCodes, permission, permission);
                    permissionsService.getRamPermission(uteCommonPermission, ute.common.permissions.service.RamActionCodes.grant)
                      .then(function (repPermission) {
                        if (repPermission) {
                          disablePermissionNotGranted[index] = false
                        } else {
                          disablePermissionNotGranted[index] = true;
                        }
                        subscriptions = mss.getSubscriptions(selectedAccountDetails.subList, disablePermissionNotGranted);
                        $scope.subMenuMyServicesList = subscriptions.myServices;
                        $scope.myOtherServicesListFinal = subscriptions.myOtherServices;
                      });
                  });
                }
              });
            }

          });
        });

      });
      // worker.registerOnDataChangeHandler(setSubscriptionList, 'MyrSubMenuController');
    });

    agentInfoService.registerOnDataChangeHandler(setAgentInfo, 'MyrSubMenuController');

    /*
    oneViewHeaderService.getSummaryWorker().then( function (worker){
      worker.registerOnDataChangeHandler(setAccountlist, 'MyrSubMenuController')
    });
    */

    $scope.$extend({});

    // if one usertype retail/care hide the homephone and link account links from services menu.
    // $scope.userTypeDealer = $rootScope.isDealer;
    $scope.isDealer = userService.isDealer();
    $scope.isCare = userService.isCare();
    $scope.isConsumer = userService.getUserType() !== 'dealer' && userService.getUserType() !== 'care';

    // Self hiding logic
    $scope.selfDestruct = function (stateString) {
      var hideSubMenuStates = [
        'underMaintenance',
        'linkaccount',
        'signin',
        'forgotUserName',
        'forgotPassword',
        'forgotUserNameNoLivecontent',
        'forgotPasswordNoLivecontent',
        'registration',
        'registrationNoEmailVerify',
        'completeProfile',
        'registrationComplete',
        'oneViewInterface',
        'oneViewDashboard',
        'interaction',
        'registrationConfirmation',
        'actionsOffers'
      ];

      // Get location and masage the result a little bit
      var toState = $location.path();

      // Remove first slash and replace other slashes with dots
      toState = toState.substring(1);
      toState = toState.replace(/\//gi, '.');

      toState = (stateString === '' || stateString === undefined) ? toState : stateString;

      // array lookup
      var toStateResult = true;
      if (!$cookies.SMSESSION && $cookies.SMSESSION !== 'LOGGEDOFF') {
        // maybe will show it
        toStateResult = (hideSubMenuStates.indexOf(toState) !== -1);
      } else {
        // definitely will NOT show it
        toStateResult = true;
      }
      return toStateResult;
    };
    $scope.selfDestructFlag = $scope.selfDestruct();
    // ($scope.selfDestructFlag) ? navigationService.disableFullMenu() : navigationService.enableFullMenu();

    // Listen to the state change broadcast
/* TODO: reverse engineer deeplink.data.direction to a modular solution

    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
      if (deeplink.data.direction === 'out') {
        // DO NOT show the submenu
        $scope.selfDestructFlag = true;
      } else {
        $scope.selfDestructFlag = $scope.selfDestruct(toState.name);
      }
      ($scope.selfDestructFlag) ? navigationService.disableFullMenu() : navigationService.enableFullMenu();
    });
*/

    /*if ($scope.isDealer || $scope.isCare) {
     var requestURI = $window.location.href;
     var queryString = requestURI.split('?');
     if (queryString.length > 1) {
     var oneViewStatusCode = $location.search().statusCode;
     //console.log('SubMenuController :: params[1] :: '+params[1]);
     if (oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck ||
     oneViewStatusCode === settings.oneViewStatusCodes.creditOps) {
     $scope.isFraudCheckOrCreditOps = true;
     }
     }
     }*/

    $scope.notInDataManager = function (item) {

      var dmBadgeList = dataManagerService.getBadgeList().subscriberList;

      var notInList = true;

      if ((item.serviceName === 'wireless' || item.serviceName === 'shareEverything') && $scope.dataManagerPermission === true) {

        for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
          if (item.serviceDetail === dmBadgeList[iSELine].ctn) {
            notInList = false;
          }

        }

      }
      /*Removed emply li from service menu if serviceName is homephone*/
      return (item.serviceName === 'homephone') ? false : notInList;
      //return notInList;
    };

    var subscriptionList, agentInfo, myServicesList, accountList, selectedAccountDetails, accountActive;

    $scope.subMenuItems = subMenuItems;
    $scope.isOverview = false;
    $scope.isPayment = false;
    $scope.isService = false;
    $scope.toggleMainPlusMinus = false;

    // $scope.toggleServicesPlusMinus = $rootScope.toggleServicesPlusMinus;
    $scope.toggleServicesPlusMinus = false;

    $scope.isDealer = userService.isDealer();
    $scope.isCare = userService.isCare();
    $scope.isConsumer = userService.getUserType() !== 'dealer' && userService.getUserType() !== 'care';

    $scope.repInteractionRead = true;
    $scope.repProfileRead = true;
    $scope.repPaymentStart = true;
    $scope.repTransferOfResponsibilityStart = false;
    $scope.repCreditAdjustmentRead = false;
    $scope.isAccountSuspended = false;
    $scope.isAccountCancelledOrSuspended = false;
    $scope.dataManagerPermission = false;
    $scope.actionsOffersPermitted = false;
    $scope.repActionOffersUpdate = false;
    $scope.repBundleBuilderAccess = false;
    //$scope.repOfferSaleRead = true;

    if ($scope.isDealer || $scope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.InteractionHistory, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repInteractionRead = repPermission;
        });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repProfileRead = repPermission;
        });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.MakePayment, ute.common.permissions.service.RamActionCodes.start)
        .then(function (repPermission) {
          $scope.repPaymentStart = repPermission;
        });
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER).then(function (isPermittedDataManager) {
        if (isPermittedDataManager) {
          $scope.dataManagerPermission = isPermittedDataManager;
        }
      });
      //permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_ACTIONS_OFFERS).then(function (isPermittedActionsOffers) {
      //  $scope.actionsOffersPermitted = isPermittedActionsOffers;
      //});
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.OfferSale, ute.common.permissions.service.RamActionCodes.read)
        .then(function (agentPermission) {
          $scope.repActionOffersUpdate = agentPermission;
          console.log("AGENT PERM: " + agentPermission);
      });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.BundleBuilder, ute.common.permissions.service.RamActionCodes.start)
        .then(function (repPermission) {
          $scope.repBundleBuilderAccess = repPermission;
        });
    }

    if ($scope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.TransferOfResponsibility, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repTransferOfResponsibilityStart = repPermission;
        });

      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CreditManagement, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repCreditAdjustmentRead = repPermission;
        });
    }

    /*$scope.currentAccount = $rootScope.ao.accountActive;
     if ($scope.currentAccount != null) {
     if ($scope.currentAccount.accountNumber != null) {
     $scope.isWirelessAccount = $scope.currentAccount.accountNumber.length < 12;
     }
     if ($scope.currentAccount.accountStatus != null && $scope.currentAccount.accountStatus.toUpperCase() === 'SUSPENDED'
     || $scope.currentAccount.accountStatus === 'CANCELLED') {
     $scope.isAccountCancelledOrSuspended = true;
     }
     }*/

    // $scope.currentAccount = accountActive;
    function updateAccountInfo() {
      $scope.currentAccount = accountActive;

      if ($scope.currentAccount != null) {
        if ($scope.currentAccount.accountNumber != null) {
          $scope.isWirelessAccount = $scope.currentAccount.accountNumber.toString().length === 9;
        }
        if ($scope.currentAccount.accountTypeNumber != null) {
          var accountTypeNumber = $scope.currentAccount.accountTypeNumber;
          if (accountTypeNumber === 9 || accountTypeNumber === '9') {
            $scope.isPrepaid = true;
          } else {
            $scope.isPrepaid = false;
          }
        }
        if ($scope.currentAccount.accountStatus != null && ($scope.currentAccount.accountStatus.toUpperCase() === 'SUSPENDED'
            || $scope.currentAccount.accountStatus.toUpperCase() === 'CANCELLED')) {
          $scope.isAccountCancelledOrSuspended = true;
        }
        if ($scope.currentAccount.accountStatus != null && ($scope.currentAccount.accountStatus.toUpperCase() === 'SUSPENDED')) {
          $scope.isAccountSuspended = true;
       }
      }
    };

    // $scope.subUser = $rootScope.user;
    $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
    var scopewatch2 = $scope.$watch(function () {
      return $rootScope.selectedSubMenuItem;
    }, function () {
      $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
    }, true);

    function setSubscriptionList(summary) {
      mss.accountDetails = summary;

      selectedAccountDetails = summary.getSelectedAccountDetails(); //should replace $rootScope.ao.accountDetails
      $scope.subMenuMyServicesList = mss.getSubscriptions(mss.accountDetails.subList, false).myServices;
      oneViewSubmenuService.getSubscriptions(subscriptionList).then( function(list) {
        myServicesList = list;
      });
    };

    $scope.hideRHPFlowForCare = function () {
      var rhpMigratedFlag = userService.getPersistentService().get('rhpMigratedSwitch') ? userService.getPersistentService().get('rhpMigratedSwitch') : 'false';
      return $scope.isCare && rhpMigratedFlag === 'false';
    };

    function setAccountlist(accountOverview) {
      accountList = accountOverview.accountList; //should replace $rootScope.ao.raw.accountList
      var selectedAccount = accountOverview.getSelectedAccount();
      accountActive = _.cloneDeep(selectedAccount);
      updateAccountInfo();
      // accountActive = accountOverview.getSelectedAccount(); //should replace $rootScope.ao.accountActive
    };

    function setAgentInfo(agentInfoData) {
      agentInfo = agentInfoData;
    };

    $scope.runService = function (serviceName, value) {
      var accountNumber, subNumber, isRHPMigratedFlow;

      isRHPMigratedFlow = userService.getPersistentService().get('rhpMigratedSwitch');
      accountNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);

      for (var i = 0; i < subscriptionList.length; i++) {
        if (subscriptionList[i].subAccountId === value) {
          subNumber = subscriptionList[i].subNumber;
        }
      }
      switch (serviceName) {
        case 'wireless':
        case 'wirelessPrepaid':
          userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, value);
          break;
        case 'shareEverything':

          userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, value);
          /*getting index of the shared wireless CTN*/
          var dmBadgeList = dataManagerService.getBadgeList().subscriberList;
          var index = 0;
          for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
            if (value === dmBadgeList[iSELine].ctn) {
              index = iSELine;
              break;
            }
          }
          dataManagerService.setActiveTabIndex(index);
          dataManagerService.goToSubModule(dataManagerService.getConfig().advanced.enterDataManager.subState);
          return;
        case 'shmdashboard':
          userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER, value);
          break;
        case 'internetdash':
          userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER, value);
          break;
        case 'tvdashboard':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('tvAccountNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('tvAccountNumber', value);
          // }

          userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER, value);
          break;
        case 'homephone':
          if($scope.isDealer || ($scope.isCare && isRHPMigratedFlow == 'false')) {
            return;
          } else {
            userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER, value);
          }
          break;
        case 'IPTV':
          eclipseRemoteApi.goToIPTVDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com'
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
            userType: userService.getUserType(),
            province: 'on' // pull from usersService
          });
          return;
          break;
        case 'HSI':
          eclipseRemoteApi.goToHSIDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com'
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
            userType: userService.getUserType(),
            province: 'on' // pull from usersService
          });
          return;
          break;
        case 'RHP Phone Line':
          eclipseRemoteApi.goToRHPDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com'
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
            userType: userService.getUserType(),
            province: 'on' // pull from usersService
          });
          return;
          break;
      }

      if (serviceName === $state.current.name || (serviceName == "homephone" && $state.current.name === "rhpdashboard")) {
        $state.reload();
        return;
      }

      oneViewHeaderService.subNavTo(serviceName, $scope.BASEURL);
    }

    $scope.runCustomerCare = function () {
      $window.location.href = oneViewHeaderService.getConfig().basic.devServerURL.replace(/\/\/www/gi, '//internal') + '/web/InternalUse.portal';
    };

    $scope.runRogersProfile = function ($event) {
      $event.preventDefault();
      if ($scope.ssaPermission) {
        $event.preventDefault();
        if ($scope.isDealer || $scope.isCare || $scope.isSubMenuEnabled('profile') || $state.current.name === 'guestOverview') {

          oneViewHeaderService.subNavTo('profile', $scope.BASEURL);
        }
      } else if ($state.current.name === 'guestOverview') {
        oneViewHeaderService.subNavTo('profile', $scope.BASEURL);
      } else {
        //$event.currentTarget.href = $event.currentTarget.href.replace(/ProfileAccountNumber=[\d]*/, 'ProfileAccountNumber=' + $rootScope.selectedAccount);
        // TODO Please add you logic here
        $window.location.href = '/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta&setLanguage=en&ProfileAccountNumber=' + userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
      }
    };

    $scope.accountOverview = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('accountOverview')) {
        scrollPageToTop(); // jshint ignore:line
        oneViewHeaderService.subNavTo('accountOverview', $scope.BASEURL);
      }

      if (!$scope.isSubMenuEnabled('accountOverview') && $state.current.name === 'self-serve') {
        oneViewHeaderService.subNavTo('guestOverview', $scope.BASEURL);
      }
    };
    $scope.oneViewAccountOverview = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('accountOverview')) {
        scrollPageToTop(); // jshint ignore:line
        if (($scope.isDealer || $scope.isCare) && !$scope.isConsumer) {
          oneViewHeaderService.subNavTo('oneViewDashboard', $scope.BASEURL);
        }
      }
    };

    $scope.viewbill = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('billingAndPayment')) {

          $scope.rogersORpaybill();

      }
      if ($state.current.name === 'guestOverview' && $scope.isSubMenuEnabled('billingAndPayment') === true) {
        oneViewHeaderService.subNavTo('accountOverview', $scope.BASEURL);
      }
    };

    $scope.rogersORpaybill = function () {
      var rogersORpaybillType = 0;
      try {
        rogersORpaybillType = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER);
      } catch (e) {
      }

      var isConsumer = !$scope.isDealer && !$scope.isCare;
      if (isConsumer) {
        if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
          $scope.postToRogersTop();
        } else {
          $scope.payBill();
        }
      } else {
        // The accountActive is becoming null, so need to get the accountTypeNumber from local storage
        if (rogersORpaybillType === 0) {
          rogersORpaybillType = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER);
        }
        if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
          // Disable bills & payments in prepaid for dealer and care
          //$scope.openBillingAndPaymentModal();
        } else {
          $scope.payBill();
        }
      }
    };

    var scopewatch3 = $scope.$watch(function () {
      return briteBillService.getIsbritebillAvailable($scope.currentAccount ? $scope.currentAccount.accountNumber : '');
    }, function (newVal) {
      if (($scope.isDealer || $scope.isCare) && newVal) {
        if (($scope.isPrepaid) || ($scope.currentAccount && $scope.currentAccount.isPrepaid)) {
          $scope.isViewBillDisplay = false;
        } else {
          $scope.isViewBillDisplay = true;
        }
      } else {
        $scope.isViewBillDisplay = false;
      }
      console.log('$scope.isViewBillDisplay :: ' + $scope.isViewBillDisplay);
    });

    $scope.postToRogers = function () {
      // For dealer and care - legacy page should not be displayed
      oneViewHeaderService.subNavTo('viewbill', $scope.BASEURL);
    };

    $scope.postToRogersUrls = [
      {url: oneViewHeaderService.getConfig().basic.viewBillLegacyURL},
      {url: oneViewHeaderService.getConfig().basic.billSummaryLegacyURL},
      {url: oneViewHeaderService.getConfig().basic.prepaidTopUpLegacyURL}
    ];

    $scope.postToRogersTop = function () {
      //		$('#formToRogersTop').attr('action', $scope.postToRogersUrls[1].url);
      //		$('#formToRogersTop').submit();
      $window.location.href = $scope.postToRogersUrls[1].url;
    };

    $scope.payBill = function () {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      oneViewHeaderService.subNavTo('paynow', $scope.BASEURL);
    };

    $scope.redirectToInteraction = function () {
      //$rootScope.interactionAndCaseListLength = 0;
      scrollPageToTop(); // jshint ignore:line
      oneViewHeaderService.subNavTo('interaction', $scope.BASEURL);
    };

    $scope.redirectToActionsOffers = function () {
      scrollPageToTop(); // jshint ignore:line
      oneViewHeaderService.subNavTo('actionsOffers', $scope.BASEURL);
    };

    $scope.redirectToOrders = function () {
      scrollPageToTop(); 
      oneViewHeaderService.subNavTo('orders', $scope.BASEURL);
      console.log("Orders page");
    }

    $scope.closeMenu = function () {
      $scope.toggleMainPlusMinus = false;
      $scope.toggleServicesPlusMinus = false;
    };

    $scope.navMainMenuClick = function (/*$event*/) {
      if ($scope.toggleMainPlusMinus) {
        $scope.toggleMainPlusMinus = false;
        $scope.toggleServicesPlusMinus = false;

        // direct call to jQ
        $('.dropdown.open').removeClass('open');

      } else {
        $scope.toggleMainPlusMinus = true;
      }
    };

    $scope.navSubMenuClick = function (/*$event*/) {
      $scope.toggleServicesPlusMinus = !$scope.toggleServicesPlusMinus;

      // Refer to settings for complete list of page this menu should not appear
      if ($scope.isDropDownEnabled === false) {
        $scope.toggleServicesPlusMinus = false;
      }
    };

    $scope.hideDropDown = function () {
      if ($scope.btnSettings === undefined || $scope.btnStatus === undefined) {
        return false;
      } else {
        return ($scope.btnSettings === $scope.btnStatus.hidden) && ($scope.activeAccountType != '9');
      }
    };

    $scope.btnStatus = {
          visible: 0,
          hidden: 1,
          disabled: 2,
          names: {
              0: 'Visible',
              1: 'Hidden',
              2: 'Disabled'
          }
      };

    $scope.isDropDownEnabled = function () {
      return oneViewHeaderService.getConfig().basic.mandatoryPages.indexOf($state.current.name) < 0;
    };

    $scope.isSubMenuEnabled = function (subMenuName) {
      var result = false;
      // if current page is mandatory, disable all subMenus
      if (oneViewHeaderService.getConfig().basic.mandatoryPages.indexOf($state.current.name) >= 0) {
        return false;
      }

      switch (subMenuName) {
        case 'accountOverview':
        case 'billingAndPayment':
        case 'services' :
          result = $rootScope.selectedSubMenuItem !== $scope.subMenuItems.guestoverview;
          if (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER) === null) {
            result = false;
          }
          break;
        case 'profile' :
          result = true;
          break;
        default :
          break;
      }
      return result;
    };

    $rootScope.$on('$stateChangeStart', function () {
      $scope.closeMenu();
      $('#header .shadow').removeClass('in');
      $('.collapse').removeClass('in');
    });

    /*$scope.isDisplayPopup = function () {
     var result = false;
     if($rootScope.isConsumer || $rootScope.isCare){
     result = true;
     } else {
     result = false;
     $scope.open();
     }
     return result;
     };*/
    $scope.menuClick = function () {
      $('#header .shadow').removeClass('in');
    };

    //TODO get accountDetails.subList

    $scope.getSubMenuServices = getSubMenuServices;

    function getSubMenuServices() {
      if (myServicesList) {
        return _.filter(myServicesList, function (item) {
          return (item.subType !== 'Rogers Bank');
        });
      }
    }

    /* Begin: To display only one ShareEverything Sub menu in service menu */
    $scope.getSubMenuServicesShare = getSubMenuServicesShare;

    function getSubMenuServicesShare() {
      if (myServicesList) {
        return myServicesList.filter(function (obj) {
          if (obj.serviceName === 'shareEverything' && obj.subType !== 'Rogers Bank') {
            return obj;
          }
        });
      }
    }

    /* End: To display only one ShareEverything Sub menu in service menu */
    $scope.resolveService = function (service) {
      return $resolve.resolve(service.resolve(service));
    };

    $scope.lang = languageSwitcher.getCurrentLanguage();

    $scope.changeLanguage = function () {
      if ($scope.lang === 'en') {
        languageSwitcher.changeLanguage('fr');
      } else {
        languageSwitcher.changeLanguage('en');
      }
      messagesService.publish('languageChanged', null);

    };

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if (($scope.isDealer || $scope.isCare) && $scope.isRepView === 'false') {
        $('div[data-liveheader] #header').css('position', 'static');
      }
      $scope.lang = lang;
    }, 'subMenuControllerLangSub_' + $scope.$id);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('subMenuControllerLangSub_' + $scope.$id);
      // scopewatch1(); //n
      scopewatch2();
      scopewatch3();
    });

    function getParameter(key, value) {
      var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
      var results = regex.exec(value);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    $scope.redirectToOASYS = function () {
      var connId = '';
      if(agentInfo) {
        if (agentInfo.cfaInfo && agentInfo.cfaInfo.connid) {
          connId = agentInfo.cfaInfo.connid;
        } else if (agentInfo.careInfo && agentInfo.careInfo.connid) {
          connId = agentInfo.careInfo.connid;
        } else if (agentInfo.connid){
          connId = agentInfo.connid;
        } else {
          if($scope.isDealer) {
            connId = getParameter('connid', agentInfo.cfaInfo.playSessionId);
          } else if($scope.isCare) {
            connId = getParameter('connid', agentInfo.careInfo.playSessionId);
          }
        }
      }
      var redirectionUrl = oneViewHeaderService.getConfig().basic.oasysURL;
      var ban = '';
      var can = '';
      if (location.hostname.indexOf('qa') > -1) {
        redirectionUrl = oneViewHeaderService.getConfig().basic.oasysBetaURL;
      }

      if ($scope.currentAccount) {
        if ($scope.currentAccount.accountNumber.toString().length < 12) {
          ban = $scope.currentAccount.accountNumber.toString();
        } else {
          can = $scope.currentAccount.accountNumber.toString();
        }
      }
      redirectionUrl = redirectionUrl + 'BAN=' + ban + '&CAN=' + can + '&Lang=' + $scope.lang + '&ConnID=' + connId;

      $window.open(redirectionUrl, '_blank');
    };
    $scope.goToTransferOfResponsibility = function () {
      var accountNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
      var customCtnList = [];
      // var localServicesList = myServicesList;
      var localServicesList =  $scope.subMenuMyServicesList;
      for (var sub = 0; sub < localServicesList.length; sub++) {
        if (!(localServicesList[sub])) {
        } else {
          var ctnDetails = {};
          ctnDetails["subscriberNumber"] = localServicesList[sub].serviceDetail;
          ctnDetails["firstName"] = localServicesList[sub].firstName;
          if (localServicesList[sub].subType === 'CTN') {
            customCtnList.push(ctnDetails);
          }
        }
      }
      torService.goToEntryState({
        accountNumber: accountNumber,
        ctnList: customCtnList
      });
    };

    $scope.displayCreditAdjustmentDetails = function () {
      var accountNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
      var subscriberDetails = [];
      var localServicesList = myServicesList;
      for (var sub = 0; sub < localServicesList.length; sub++) {
        if (!(localServicesList[sub])) {
          // Do Nothing
        } else {
          var subscriberInfo = {};
          subscriberInfo["subscriberNumber"] = localServicesList[sub].serviceDetail;
          subscriberInfo["subscriberName"] = localServicesList[sub].firstName;
          if (localServicesList[sub].subType === 'CTN') {
            subscriberDetails.push(subscriberInfo);
          }
        }
      }
      ccmService.goToEntryState({
        accountNumber: accountNumber,
        subscriberDetails: subscriberDetails
      });
    };
  }
})(_);

(function () {
  'use strict';

  angular.module('ute.common.oneview.header').directive('oneViewSubmenu', oneViewSubmenu);

  oneViewSubmenu.$inject = ['$rootScope','$compile', '$templateCache', 'ute.rogers.account.overview.factory'];

  /* @ngInject */
  function oneViewSubmenu($rootScope, $compile, $templateCache, accountOverviewFactory) {
    var accountOverviewService = accountOverviewFactory();

    var activeAccount = {};

    var directive = {
      restrict: 'EA',
      scope: {},
      transclude: true,
      link: linkFunc,
      controller: 'HeaderMyrSubMenuController',
      controllerAs: 'sm',
      bindToController: true,
      template: '<div></div>'
    };
    return directive;

    function linkFunc(scope, element, attrs) {
      attrs.$observe('oneViewInterfaceFlag', function (value) {
        if (value === 'true') {
          scope.contentUrl = 'module/oneViewSubmenu/oneViewSubmenuForInterface.html';
        } else if (value === 'false') {
          scope.contentUrl = 'module/oneViewSubmenu/oneViewSubmenu.html';
        }
        if (scope.contentUrl) {
          var data = $templateCache.get(scope.contentUrl);
          element.html(data);
          $compile(element.contents())(scope);
        }

      });

      /* don't think this is needed anymore, services list shouldn't be able to change
      var scrootwatch1 = scope.$root.$watch('myServicesList', function () {
        scope.subMenuMyServicesList = scope.getSubMenuServices();
      });
*/
      

      function permissionWatch (newVal) {
          scope.showCareLink = false;
          if (newVal) {
            if (scope.hasOwnProperty('ssaPermission')) {
              //console.log('ssaPermission already defined on scope: ' + scope.ssaPermission);
              /*if(scope.hasOwnProperty('showCartMenu')){
                $rootScope.showCartMenu = newVal.accountNumber;
              }*/
            }
            else {
               /* var tazoPermission = permissions.permissions.filter(function (permission) {
                  return permission.permission && permission.permission === 'TAZO_UTE_PAGE_VIEW';
                });*/
                //console.log('setting ssaPermission: ' + (ssaPermission.length > 0));
              scope.ssaPermission = true;
                /*scope.showCartMenu = tazoPermission.length > 0;
                if(scope.showCartMenu){
                   $rootScope.showCartMenu = scope.showCartMenu;
                }*/
            }
            var parmissions = newVal.permissions;
            for (var xx = 0; xx < parmissions.length; xx++) {
              var current = parmissions[xx];
              if (current.name === 'INTERNAL_USER') { //TODO INTERNAL_USER
                scope.showCareLink = true;
                break;
              }
            }
          }
        };

        var scrootwatch3 = scope.$root.$watch('interactionAndCaseListLength', function (newVal) {
        if (newVal && newVal != 0) {
          scope.interactionLength = newVal;
        } else {
          scope.interactionLength = '-';
        }

      });

      accountOverviewService.getSelectedAccountDetails(function(x) {
        console.log('selectedAccountDetails3369: ', x);
        
      });

      accountOverviewService.registerOnDataChangeHandler(function(accountOverview) {
        permissionWatch(accountOverview.permissions[0]);
        var selectedAccount = accountOverview.getSelectedAccount();
        scope.activeAccountType = selectedAccount ? selectedAccount.accountTypeNumber: 0;
      }, 'subMenuDirective');

      // var scrootwatch4 = scope.$root.$watch('ao.accountActive', function () {
        // scope.activeAccountType = (!!scope.$root.ao.accountActive) ? scope.$root.ao.accountActive.accountTypeNumber : 0;
        /* uncomment when btnSettings is setup
        if (scope.$root.ao.accountActive) {
          scope.updateBtnSettings(scope.$root.ao.accountActive.accountStatus);
        }
        */
      //});

      //n Remove any watchers
      scope.$on('$destroy', function () {
        scrootwatch3();
      });

    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('ute.common.oneview.header').controller('MyrSspDashBoardController', sspDashBoardController);

  sspDashBoardController.$inject = ['$scope', 'ute.blocks.language.switcher', 'ajax', '$element', 'backToSSPService', 'ute.blocks.messages.bus.service', 'ute.common.user.service'];

  /* @ngInject */
  function sspDashBoardController($scope, languageSwitcher, ajax, $element, backToSSPService, messagesService, userService) {

    $scope.$extend({

    });

    $scope.userTypeDealer = userService.isDealer();
    if(userService.isDealer() || userService.isCare()){
        $element.find('#feedback-tab').hide();
      $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
    }

    $scope.backToSSPdashBoard = function () {
      backToSSPService.targetFlow = 'sspdashboard';
      backToSSPService.backToSSP();
    };
  }

})();





(function () {
  'use strict';

  angular.module('ute.common.oneview.header').directive('sspDashboard', sspDashBoard);

  sspDashBoard.$inject = [];

  /* @ngInject */
  function sspDashBoard($log) {
    return {
      templateUrl: 'module/sspDashBoard/sspDashBoard.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyrSspDashBoardController',
      controllerAs: 'ssp',
      bindToController: true
    };

  }
})();

/*.controller('sspDashboardCtrl', ['$scope', '$rootScope', 'ute.blocks.language.switcher', 'localStorage', 'ajax', '$element', 'settings', '$browser',
			function ($scope, $rootScope, languageSwitcher, localStorage, ajax, $element, settings, $browser) {
        $scope.userTypeDealer = $rootScope.isDealer;
        if($rootScope.isDealer || $rootScope.isCare){
            $element.find('#feedback-tab').hide();
            $element.find("#footer a[onclick='javascript:FSR.popFeedback()']").hide();
        }
        $scope.backToSSPdashBoard = function () {
          var cookies = $browser.cookies();
          var language = cookies.language;
          var province = cookies.province;
         // alert("language:"+language+" province:"+province);
          var postData;
          if(localStorage.getLocalStorageValue('toStateName')==="wireless") {
                postData = {
                   ctn: localStorage.getLocalStorageValue('phoneNumber'),
                   accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                   lang: language,
                   prov: province,
                   targetFlow :"sspdashboard"
                };
          }
          else {
            postData = {
               ctn: "",
               accountNumber: localStorage.getLocalStorageValue('accountNumber'),
               lang: language,
               prov: province,
               targetFlow :"sspdashboard"
            };
          }
          ajax.backToSSP(postData).then(
              function (data) {
                if(data.isCableOnly) {
                  $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                  $('#formToSSP').submit();
                } else {
                  $('#formToSSP').find("#sharedKey").val(data.sharedKey);
                  $('#formToSSP').find("#signature").val(data.signature);
                  $('#formToSSP').find("#content").val(data.content);
                  $('#formToSSP').attr('action', data.envPath +  settings.agentInfo.sspDashboardURL);
                  $('#formToSSP').submit();
                }
              },
              function (error) {
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                $('#formToSSP').submit();
              }
          );
        };
}]);
*/

(function () {
  'use strict';

  angular.module('ute.common.oneview.rep.feedback').controller('MyOneviewRepFeedbackController', oneviewRepFeedbackController);

  oneviewRepFeedbackController.$inject = ['$scope', '$rootScope', 'ute.common.security.service', '$http', 'ute.blocks.persistent.storage.service', 'ute.common.user.service', 'ute.blocks.language.switcher'];

  function oneviewRepFeedbackController($scope, $rootScope, securityService, $http, persistentStorage, userService, languageSwitcher) {
    var vm = this;
    vm.agentDetails = {};
    vm.getCurrentLanguage = function () {
      return languageSwitcher.getCurrentLanguage();
    }
    vm.lang = vm.getCurrentLanguage();
    var x;

    vm.loadQualtricsFeedbackSurveyScript = function () {
      var g=function(e,h,f,g){
        this.get=function(a){for(var a=a+"=",c=document.cookie.split(";"),b=0,e=c.length;b<e;b++){for(var d=c[b];" "==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};
        this.set=function(a,c){var b="",b=new Date;b.setTime(b.getTime()+6048E5);b="; expires="+b.toGMTString();document.cookie=a+"="+c+b+"; path=/; "};
        this.check=function(){var a=this.get(f);if(a)a=a.split(":");else if(100!=e)"v"==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(":"));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case "v":return!1;case "r":return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(":")),!c}return!0};
        this.go=function(){if(this.check()){var a=document.createElement("script");a.type="text/javascript";a.src=g+ "&t=" + (new Date()).getTime();document.body&&document.body.appendChild(a)}};
        this.start=function(){var a=this;window.addEventListener?window.addEventListener("load",function(){a.go()},!1):window.attachEvent&&window.attachEvent("onload",function(){a.go()})}};
        try{(new g(100,"r","QSI_S_ZN_cI39qiLcUmKR0dn","https://znci39qilcumkr0dn-rogersdigital.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_cI39qiLcUmKR0dn&Q_LOC="+encodeURIComponent(window.location.href))).start()}catch(i){};

    }

    vm.loadQualtricsFeedbackSurveyScript();

    vm.getAgentDetails = function () {
      //get Agent Info
      var accountNumber = '';
      if (userService.isCare())
        accountNumber = persistentStorage.getFromSession('accountNumber');
      else if (userService.isDealer()) {
        accountNumber = persistentStorage.getFromLocal('accountNumber');
      }
      var request = {
        acctNbr: accountNumber
      }
      var agentInfoApiURL = 'v1/agentInfo';

      $http.post(securityService.getBackendUrl(agentInfoApiURL), request)
        .then(this.processAgentInfo);
    }

    vm.processAgentInfo = function (response) {
      if (response.data) {
        var agentInfo = response.data;
        var agentName = agentInfo.lanId.split('.');
        var playSessionId = agentInfo.playSessionId;
        var splitPlaySessionId = playSessionId.split('&');
        vm.agentDetails.agentDepartment = '';
        if (playSessionId.indexOf('SOURCE') > 0) {
          splitPlaySessionId.forEach(function (item, index) {
            if (item.indexOf('SOURCE') == 0) {
              vm.agentDetails.agentDepartment = item.split('=')[1];
            }
          });

        }
        vm.agentDetails.sessionId = '';
        if (playSessionId.indexOf('USER_SESSION_ID') > 0) {
          splitPlaySessionId.forEach(function (item, index) {
            if (item.indexOf('USER_SESSION_ID') == 0) {
              vm.agentDetails.sessionId = item.split('=')[1];
            }
          });

        }
        vm.agentDetails.agentId = agentInfo.repInfo.loginId;
        vm.agentDetails.agentFirstName = agentName[0];
        vm.agentDetails.agentLastName = agentName[1];
        vm.agentDetails.agentRciEmailId = agentInfo.lanId + '@rci.rogers.com';
        vm.agentDetails.agentRole = agentInfo.repInfo.repRoles.replace('[', '').replace(']', '');
        vm.agentDetails.timeStamp = agentInfo.timeStamp;
        vm.agentDetails.customerAcctNo = agentInfo.consumer.accountNumber;
      }
    }
    vm.getAgentDetails();

    $rootScope.$on('$stateChangeSuccess', function (event, next, nextParams, current, currentParams) {
      if (current.name !== '') {
        showFeedbackWidget();
      }
    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if (vm.lang !== lang) {
        vm.lang = lang;
        showFeedbackWidget();

      }
    }, 'MyOneviewRepFeedbackController');


    // function loadFeedbackWidget() {
    //   if (typeof (window.QSI) !== 'undefined') {
    //     clearInterval(x);
    //     showFeedbackWidget();
    //   } else {
    //     if (!x) {
    //       x = setInterval(loadFeedbackWidget, 2000);
    //     }
    //   }
    // }
    function showFeedbackWidget() {
      if (typeof(window.QSI) !== 'undefined') {
        var qualtricsTimeout = setTimeout(function () {
          window.QSI.API.unload();
          window.QSI.API.load();
          window.QSI.API.run();
          clearTimeout(qualtricsTimeout);
        }, 500);
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('ute.common.oneview.rep.feedback').directive('uteOneviewRepFeedback', oneviewRepFeedback);

  oneviewRepFeedback.$inject = [];

  /* @ngInject */
  function oneviewRepFeedback() {
    return {
      templateUrl: 'module/oneviewRepFeedbackDirective/oneviewRepFeedback.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyOneviewRepFeedbackController',
      controllerAs: 'feedback',
      bindToController: true
    };

  }
})();


(function () {
  'use strict';

  angular.module('ute.payment.helper.view')
      .controller('MyrPaymentHelperController', PaymentHelperController);

  PaymentHelperController.$inject = [];

  /* @ngInject */
  function PaymentHelperController() {
    var vm = this;
  }

})();

'use strict';
/*
 the payment helper:
 Need help with payment options?   Review Payment FAQs >    Talk to us now with LiveChat >
 */
angular.module('ute.payment.helper.view').directive('myrPaymentHelper', [function () {
  return {
    templateUrl: 'module/myrPaymentHelper/paymentHelper.view.html',
    replace: true,
    controller: 'MyrPaymentHelperController',
    controllerAs: 'ph',
    restrict: 'E',
    link: function (scope, element, attr) {
    }
  };
}]);

(function () {
  'use strict';

  angular.module('ute.common.permissions').directive('uteHasPermission', hasPermission);

  function hasPermission() {
    return {
      restrict: 'E',
      scope: {
        key: '@'
      },
      transclude: true,
      controllerAs: '$ctrl',
      bindToController: true,
      controller: ['ute.common.permissions.service', function (permissionsService) {
        var vm = this;
        vm.hasPermission = undefined;
        permissionsService.getUserPermission(vm.key)
          .then(function (permission) {
            vm.hasPermission = permission;
          });
      }],
      template: '<div data-ng-if="::$ctrl.hasPermission"><ng-transclude></ng-transclude></div>'
    };
  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('ute.common.oneview.header').controller('deepLinkModalCtrl', deepLinkModalCtrl);

  deepLinkModalCtrl.$inject = ['$rootScope', '$modalInstance', 'ajax', 'settingsHeader', 'backToSSPService', 'ute.common.user.service'];

  function deepLinkModalCtrl($rootScope, $modalInstance, ajax, settings, backToSSPService, userService) {
    var dlController = this;

    dlController.setShowMessage = function (checkedStatus) {
      dlController.dontShowGoToSSPMsgAgain = !!checkedStatus;
    };

    dlController.close = function () {
      if (dlController.dontShowGoToSSPMsgAgain) {
        var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
        var userType = userService.getUserType();
        var userPreferenceName = 'displayMovingToSSPPopUp';
        var userPreferenceValue = false;
        ajax.updateUserPreference(userId, userType, userPreferenceName, userPreferenceValue).then(
          function (data) {
            console.log('updateUserPreference data');
          }, function (error) {
            console.log('updateUserPreference error');
          }
        );
      }
      backToSSPService.backToSSP();
      $modalInstance.dismiss('cancel');
    };

    dlController.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    dlController.toggleTooltip = function () {
      dlController.showMoreOptions = !dlController.showMoreOptions;
    };

    dlController.redirectToRogersGeoAuth = function (link) {
      window.open(link,'_blank');
    };

    function init() {
      dlController.isChangePhoneNumber = false;
      dlController.isChangePlan = false;
      dlController.isChangeSim = false;
      dlController.isManageAddon = false;
      dlController.isChangeVoicemailPassword = false;
      dlController.isAddaLineIndividual = false;
      dlController.isAddaLineShared = false;
      dlController.isUpgradeDevice = false;
      dlController.isHupCancellation = false;
      dlController.dontShowGoToSSPMsgAgain = false;
      dlController.showMoreOptions = false;

      if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changeCTN) {
        dlController.isChangePhoneNumber = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changeSIM) {
        dlController.isChangeSim = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changePricePlan) {
        dlController.isChangePlan = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.updateVoiceMailPassword) {
        dlController.isChangeVoicemailPassword = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.upgradeDevice) {
        dlController.isUpgradeDevice = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.addaLineIndividual) {
        dlController.isAddaLineIndividual = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.addaLineShared) {
        dlController.isAddaLineShared = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.hupCancellation) {
        dlController.isHupCancellation = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.getWireless) {
        dlController.isGetWireless = true;
      } else {
        dlController.isManageAddon = true;
      }
    }

    init();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  
  angular.module('ute.common.oneview.header').controller('enableIDVController', enableIDVController);
  
  enableIDVController.$inject = ['$scope',
  '$modal',
  '$modalInstance',
  '$translate',
  'myrCustomerInfoService'
];
/* @ngInject */
function enableIDVController($scope,
  $modal,
  $modalInstance,
  $translate,
  myrCustomerInfoService
  ){
    
    var cis = myrCustomerInfoService;
    
    $scope.closeModal = function() {
      $modalInstance.close();
      var passcode = $scope.myInput.passcode;
      cis.setPasscode(passcode);
    };
    
    $scope.migFee = cis.getmigFee().migFee; 
    $scope.message = $translate.instant('ute.common.oneview.header.modals.confirm_msg', {'migFee':$scope.migFee});
    $scope.header_message = $translate.instant('ute.common.oneview.header.modals.confirm_header_msg', {'migFee':$scope.migFee});
  }
})();







(function () {
  'use strict';

  angular.module('ute.semafone.creditcard').directive('uteCreditCard', uteCreditCard);

  uteCreditCard.$inject = ['ute.common.user.service',
    'creditCardModel',
    '$translate',
    'semafoneConstants',
    '$timeout',
    'ute.blocks.language.switcher',
    'semafoneModel',
    'ute.semafone.service.config',
    'ute.common.permissions.service'];

  function uteCreditCard(userService,
                         creditCardModel,
                         $translate,
                         semfaoneConstants,
                         $timeout,
                         languageSwitcher,
                         semafoneModel,
                         semafoneConfig,
                         permissionsService) {
    return {
      restrict: 'E',
      scope: {
        creditPaymentObj: '=',
        userType: '=',
        cardTime: '=',
        fireDataLayer: '=',
        isModalPopup: '=',
        mappingKey: '=?'
      },
      require: '^form',
      template: '<div ng-include="templateUrl()"></div>',
      link: function (scope, element, attr, modelController) {
        if (scope.userType === 'dealer') {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CreditCardCapture, ute.common.permissions.service.RamActionCodes.reader)
            .then(function (repPermission) {
              if (repPermission) {
                return scope.userType;
              } else {
                permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CreditCardCapture, ute.common.permissions.service.RamActionCodes.manual)
                  .then(function (repPermission) {
                    if (repPermission) {
                      scope.userType = 'consumer';
                      return scope.userType;
                    } else {
                      return scope.userType;
                    }
                  });
              }
            }).finally(function () {
            init();
          });
        } else {
          init();
        }

        function init() {
          var securityCodeErrorTracked;
          var creditCardErrorTracked;
          var invalidExpiryDateTracked;
          var isCodeValid = true;
          var isValidCard = true;
          // scope.isCyberSourceDown = true;
          var isCardNoEmpty = true;
          var isCardNoDirty = false;
          scope.isExpDateValid = true;
          scope.tooltip = $translate.instant('ute.rogers.myrCreditCard.paynow_card_tooltip');
          scope.cards = creditCardModel.cards;
          scope.lang = languageSwitcher.getCurrentLanguage();
          scope.showCCImage = false;
          scope.CvType = 'password';
          scope.errorPayload = {page: semafoneConfig.getConfig().advance.dataLayerTracking.page.makeAPayment.error};
          var securityCodeBlurred = true;
          scope.securityCodeMaxLength = 4;
          scope.securityCodePlaceHolder = $translate.instant('ute.rogers.myrCreditCard.security_code_placeholder_3_4')

          scope.showMoneris = false;
          scope.showSemafone = true;
          permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.MONERIS_POC).then(function (isPermitted) {
            scope.showMoneris =  isPermitted;
            scope.showSemafone = !isPermitted;
          });

          scope.templateUrl = function () {
            return (scope.userType.toLowerCase() === 'consumer') ? 'module/creditcard/directive/templates/consumer.template.html' : 'module/creditcard/directive/templates/ov.template.html';
          };

          if (!scope.creditPaymentObj) {
            scope.creditPaymentObj = {};
          }

          if (scope.userType.toLowerCase() === 'consumer' && userService.isConsumer()) {
            scope.CvType = 'text';
          }

          scope.$watch(function () {
            return semafoneModel.model.semaState;
          }, function (newValue) {
            if (newValue === 'ACTIVE') {
              scope.creditPaymentObj.status = null;
              scope.creditPaymentObj.semafoneError = null;
              scope.creditPaymentObj.maskedCardNumber = null;
              scope.creditPaymentObj.creditCardNo = null;
              scope.creditPaymentObj.isCardSwiped = null;
              scope.creditCardData = scope.creditCardData || {};
              scope.creditCardData.semafoneToken = null;
              scope.creditCardData.cardScheme = null;
              scope.creditCardData.status = null;
              if (scope.creditPaymentObj.creditCardType !== null && scope.creditPaymentObj.creditCardType.id !== null) {
                scope.creditPaymentObj.creditCardType = null;
              }
              modelController.$setValidity('creditCardNo', false);
              scope.showCCImage = false;
              resetCreditCard();
              if (modelController.frmCreditCard.securityCode) {
                modelController.frmCreditCard.securityCode.$setValidity('securityCodeRequired', true);
              }
            }
          });

          scope.creditPaymentObj.creditCardType = null;
          scope.creditPaymentObj.creditCardNo = null;
          scope.creditPaymentObj.expireDate = {
            month: null,
            year: null
          };
          scope.creditPaymentObj.securityCode = null;
          scope.creditPaymentObj.status = null;
          scope.creditPaymentObj.semafoneError = null;
          scope.creditPaymentObj.reset = function () {
            isValidCard = true;
            if (modelController.frmCreditCard) {
              modelController.frmCreditCard.$setPristine();
            }
          };
          scope.creditPaymentObj.maskedCreditCardNumber = null;

          scope.creditPaymentObj.validateCard = function () {
            scope.validateCreditCardType();
            scope.validateSecurityCode(false);
            scope.validateDateExpiry();
          };

          scope.validateCreditCardType = function () {
            if (scope.userType !== semfaoneConstants.userType.care) {
              var ccNum = _.get(scope, 'creditCardData.semafoneToken', '');
              var cardScheme = _.get(scope, 'creditCardData.cardScheme', '');
              if (ccNum === '') {
                if (isCardNoDirty === false) {
                  isCardNoEmpty = true;
                  isValidCard = true;
                } else {
                  // Make sure only one error should be visible
                  isValidCard = isCardNoEmpty;
                }
                modelController.$setValidity('creditCardNo', false);
                return;
              } else {
                isCardNoEmpty = false;
                scope.creditPaymentObj.creditCardNo = ccNum;
              }
              if (_.get(scope, 'creditCardData.status', '') === 'FAIL') {
                isValidCard = false;
                return;
              } else {
                isValidCard = true;
              }
              scope.creditPaymentObj.creditCardType = null;
              setCardScheme(cardScheme);
              if (scope.creditPaymentObj.creditCardType !== null) {
                isValidCard = true;
                modelController.$setValidity('creditCardNo', true);
              } else {
                modelController.$setValidity('creditCardNo', false);
              }

              isValidCard = scope.creditPaymentObj.creditCardType !== null;
              if (isValidCard) {
                scope.validateSecurityCode(false);
              }
            }
          };

          // scope.validateSecurityCodeOnChange = function () {
          //   if (modelController.frmCreditCard.securityCode.$viewValue.length >= 3) {
          //     if (/^\d+$/.test(modelController.frmCreditCard.securityCode.$viewValue)) {
          //       modelController.frmCreditCard.securityCode.$setValidity('securityCodeRequired', true);
          //       scope.validateSecurityCode();
          //     }
          //   }
          // };

          scope.onBlur = function () {
            securityCodeBlurred = true;
            $timeout(scope.validateSecurityCode);
          };

          scope.onFocus = function () {
            securityCodeBlurred = false;
          };

          scope.validateSecurityCode = function (isEvent) {
            if (modelController.frmCreditCard.securityCode) {
              isCodeValid = true;
              var requiredCodeLength = _.get(scope.creditPaymentObj, 'creditCardType.id', -1) === scope.cards.amex.id ? 4 : 3;
              var actualCodeLength = _.get(modelController.frmCreditCard.securityCode, '$viewValue.length', 0);
              if (isEvent && !securityCodeBlurred &&
                (!modelController.frmCreditCard.securityCode.$viewValue || actualCodeLength < requiredCodeLength)) {
                modelController.frmCreditCard.$setValidity('incompleteSecurityCode', false, window);
                // user is still entering security card # stop
                return;
              }
              modelController.frmCreditCard.securityCode.$setValidity('securityCodeRequired', true);

              if (!scope.creditPaymentObj.creditCardType) {
                scope.validateCreditCardType();
              }

              if (!isValidCard || isCardNoEmpty || scope.creditPaymentObj.creditCardType === null) {
                return;
              }

              if (actualCodeLength === 0) {
                modelController.frmCreditCard.$setValidity('incompleteSecurityCode', false, window);
                return;
              } else if (actualCodeLength !== requiredCodeLength) {
                isCodeValid = false;
                modelController.frmCreditCard.securityCode.$setValidity('securityCodeRequired', false);
              }

              modelController.frmCreditCard.$setValidity('incompleteSecurityCode', true, window);
            }
          };

          scope.validateDateExpiry = function () {
            scope.isExpDateValid = true;
            modelController.frmCreditCard.month.$setValidity('monthRequired', null);
            var mm = scope.creditPaymentObj.expireDate.month;
            var yy = scope.creditPaymentObj.expireDate.year;
            var currentYear = new Date().getFullYear();
            var currentMonth = new Date().getMonth();
            mm = Number(mm);
            yy = Number(yy);

            if (mm === 'MM' || yy === 'YYYY' || !mm || !yy) {
              return;
            }

            if (mm === 0 || yy === 0) {
              return;
            }
            if (yy > currentYear) {
              modelController.frmCreditCard.month.$setValidity('monthRequired', true);
              return;
            } else if (currentMonth + 1 <= mm) {
              modelController.frmCreditCard.month.$setValidity('monthRequired', true);
              return;
            }
            scope.isExpDateValid = false;
            if (scope.isExpDateValid === false) {
              invalidExpiryDateTracked = invalidExpiryDateTracked !== undefined;
            }
            modelController.frmCreditCard.month.$setValidity('monthRequired', false);
          };

          scope.isRep = function () {
            if (userService.isDealer() || userService.isCare()) {
              return true;
            }
          };

          scope.isDealer = function () {
            return scope.userType && scope.userType.toLowerCase() === semfaoneConstants.userType.dealer;
          };

          scope.isConsumer = function () {
            return scope.userType && scope.userType.toLowerCase() === semfaoneConstants.userType.consumer;
          };

          scope.isCareRep = function () {
            return scope.userType && scope.userType.toLowerCase() === semfaoneConstants.userType.care;
          };

          scope.getUserType = function () {
            return scope.userType;
          };

          scope.update = function (result) {
            if (result.semafoneValidationState === 'error') {
              scope.creditPaymentObj.status = result.semafoneValidationState;
              isValidCard = false;
              isCardNoEmpty = false;
              isCardNoDirty = true;

              scope.validateCreditCardType();
            } else if (result.semafoneValidationState.toUpperCase() === 'FAIL' || result.semafoneValidationState.toUpperCase() === 'UNKNOWN') {
              if (!result.semafoneErrorCode || result.semafoneErrorCode == '') {
                isValidCard = true;
                if (result.currentCardNumberLength === undefined || result.currentCardNumberLength === null || result.currentCardNumberLength == '') {
                  // input box for CC number contains no character
                  isCardNoEmpty = true;
                } else {
                  isCardNoEmpty = false;
                  isCardNoDirty = true;
                }
              } else if (result.semafoneErrorCode == '100799') {
                isValidCard = true;
                isCardNoEmpty = true;
              } else {
                // Other error code indicates that the CC input box for contains invalid CC number
                isValidCard = false;
                isCardNoEmpty = false;
                isCardNoDirty = true;
              }
            } else if (result.semafoneValidationState.toUpperCase() === 'OK' || result.semafoneValidationState.toUpperCase() === 'SUCCESS') {
              setCardData(result);
              isCardNoDirty = false;
              // When a valid CC number is confirmed we need reset scope.creditCardData.currentCardNumberLength value to empty
              // so that next user entry or copy-paste CC number will be re-evaluated.
              scope.creditCardData.currentCardNumberLength = '';
              scope.validateCreditCardType();
            } else {
              setCardData(result);
              scope.validateSecurityCode();
            }

            scope.$applyAsync(resetCreditCard);
          };

          scope.showSecurityCodeError = function () {
            var showError = modelController.frmCreditCard.securityCode &&
              modelController.frmCreditCard.securityCode.$invalid &&
              ((isCodeValid === false && modelController.frmCreditCard.securityCode.$dirty) ||
                modelController.frmCreditCard.$$parentForm.$submitted ||
                (modelController.frmCreditCard.securityCode.$error && modelController.frmCreditCard.securityCode.$error.pattern));

            if (showError) {
              securityCodeErrorTracked = securityCodeErrorTracked !== undefined;
            }

            return showError;
          };

          scope.showCreditCardError = function () {
            var showError = (isCardNoDirty && isCardNoEmpty) || isValidCard === false;
            if (showError) {
              creditCardErrorTracked = creditCardErrorTracked !== undefined;
            }

            return showError;
          };

          scope.showSelectYearError = function () {
            return showExpiryDateErrors(((modelController.frmCreditCard.month.$dirty && modelController.frmCreditCard.month.$valid) ||
              modelController.frmCreditCard.month.$pristine) && modelController.frmCreditCard.year.$dirty && modelController.frmCreditCard.year.$invalid);
          };

          scope.showSelectMonthError = function () {
            return showExpiryDateErrors(scope.isExpDateValid && modelController.frmCreditCard.month.$dirty && modelController.frmCreditCard.month.$invalid &&
              ((modelController.frmCreditCard.year.$dirty && modelController.frmCreditCard.year.$valid) || modelController.frmCreditCard.year.$pristine));
          };

          scope.showInvalidExpiryDateError = function () {
            return modelController.frmCreditCard.month.$invalid && modelController.frmCreditCard.month.$dirty &&
              modelController.frmCreditCard.year.$invalid && modelController.frmCreditCard.year.$dirty;
          };

          scope.triggerRetail = function () {
            scope.tokenizeRetailCard();
          };

          scope.trackSecurityCodeError = function () {
            return scope.mappingKey !== undefined && securityCodeErrorTracked === false;
          };

          scope.trackExpiryDateError = function () {
            return scope.mappingKey !== undefined && invalidExpiryDateTracked === false;
          };

          scope.trackCreditCardError = function () {
            return scope.mappingKey !== undefined && creditCardErrorTracked === false;
          };

          scope.getCreditCardErrorId = function () {
            return isValidCard === false ? 'semafoneError' : 'emptyCreditCardNumber';
          };

          function setCardScheme(cardScheme) {
            scope.showCCImage = true;
            switch (cardScheme) {
              case 'V':
              case 'VISA':
                scope.creditPaymentObj.creditCardType = _.clone(scope.cards.visa);
                break;
              case 'M' :
              case 'MASTERCARD':
                scope.creditPaymentObj.creditCardType = _.clone(scope.cards.mc);
                break;
              case 'A':
              case 'AMEX':
                scope.creditPaymentObj.creditCardType = _.clone(scope.cards.amex);
                break;
              default:
                scope.creditPaymentObj.creditCardType = null;
                scope.showCCImage = false;
            }
          }

          function cardStatus(cardData) {
            scope.creditPaymentObj.status = cardData.semafoneValidationState;
            scope.creditPaymentObj.semafoneError = cardData.semafoneErrorCode;
            scope.creditPaymentObj.maskedCardNumber = cardData.maskedCardNumber;
            scope.creditPaymentObj.creditCardNo = cardData.semafoneToken;
            scope.creditPaymentObj.isCardSwiped = cardData.isCardSwiped;
          }

          function resetCreditCard() {
            scope.securityCodeMaxLength = 4;
            scope.securityCodePlaceHolder = $translate.instant('ute.rogers.myrCreditCard.security_code_placeholder_3_4');
            var ccType = _.get(scope.creditPaymentObj, 'creditCardType', {});
            if (ccType) {
              switch (ccType.id) {
                case 0:
                case 1:
                  scope.securityCodeMaxLength = 3;
                  scope.securityCodePlaceHolder = $translate.instant('ute.rogers.myrCreditCard.security_code_placeholder_3');
                  break;
                case 2:
                  scope.securityCodePlaceHolder = $translate.instant('ute.rogers.myrCreditCard.security_code_placeholder_4');
                  break;
              }
            }
          }

          function showExpiryDateErrors(showError) {
            if (showError) {
              invalidExpiryDateTracked = invalidExpiryDateTracked !== undefined;
            }

            return showError;
          }

          function setCardData(result) {
            isValidCard = true;
            isCardNoEmpty = false;
            scope.creditCardData = result;
            cardStatus(result);
            setCardScheme(scope.creditCardData.cardScheme);
          }
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('ute.semafone.component').directive('monerisComponent', monerisComponent);


  function monerisComponent (){

    return {
      restirct: 'EA',
      template: '<div id=monerisResponse></div>\n' +
      '  <iframe id=monerisFrame\n' +
      // '    src=monerisPocSrcUrl' +
      '    src="https://www3.moneris.com/HPPtoken/index.php?id=htH6JMIAEK6I4D6&css_body=background:red;&css_textbox=border-width:2px;"\n' +
      '    frameborder="0" width="200px" height="30px">\n' +
      '  </iframe>\n' +
      '  <hr>\n' +
      '  <input type=button data-ng-click="doMonerisSubmit()" id="validateCreditCardButton" value="Validate Credit Card!">' +
      '  <hr>\n',
      scope: {
        creditCardData: '=',
        userType: '=',
        updateResult: '&',
        retailCard: '&'
      },
      link: function (scope, element) {

        scope.$on('$destroy', function () {
          // unregister the receiveMessage callback handler
          $.receiveMessage(); //jshint ignore:line
        });

        scope.doMonerisSubmit = function (){
          var monFrameRef = document.getElementById('monerisFrame').contentWindow;
          console.log(monFrameRef);
          monFrameRef.postMessage('', 'https://www3.moneris.com/HPPtoken/index.php');
          return false;
        };


        function init() {
          semafoneCreditCard.resetToken();
          semafoneLaunch.semafoneCapture();

          var respMsg = function(e) {
            var respData = eval("(" + e.data + ")");
            document.getElementById("monerisResponse").innerHTML = " SENT " + " - " +
              respData.responseCode + "-" + respData.dataKey + "-" + respData.errorMessage;
            console.log(" SENT " + " - " + respData.responseCode + "-" + respData.dataKey + "-" + respData.errorMessage);
            document.getElementById("monerisFrame").style.display = 'none';
          }

          window.onload = function() {
            if (window.addEventListener) {
              window.addEventListener("message", respMsg, false);
            } else {
              if (window.attachEvent) {
                window.attachEvent("onmessage", respMsg);
              }
            }
          }

        }

        init();

      }
    };
  }

})();


(function () {
  'use strict';

  angular.module('ute.semafone.component').directive('semafoneComponent', semafoneComponent);

  semafoneComponent.$inject = [
    'semafoneLaunch',
    'semafoneCreditCard',
    'semafoneConstants',
    '$compile',
    'semafoneRetail',
    '$templateCache',
    'creditCardModel',
    '$timeout'
  ];

  function semafoneComponent(semafoneLaunch,
                             semafoneCreditCard,
                             semafoneConstants,
                             $compile,
                             semafoneRetail,
                             $templateCache,
                             creditCardModel,
                             $timeout) {
    return {
      restirct: 'EA',
      template: '<div></div>',
      scope: {
        creditCardData: '=',
        userType: '=',
        updateResult: '&',
        retailCard: '&'
      },
      link: function (scope, element) {
        scope.swipedCardNumber = '';
        scope.creditCardData = semafoneCreditCard.creditCardData;
        scope.cards = creditCardModel.cards;
        semafoneCreditCard.setUserType(scope.userType);
        scope.encrypteData = '';
        scope.loadingDataIndicator = false;
        scope.getValidToken = false;
        /**
         * Reset All Observer
         */
        semafoneCreditCard.resetObserver();

        function updateSemafoneValidationState(data) {
          if (!data) {
            scope.creditCardData = semafoneCreditCard.creditCardData;
            scope.isDisplayTokenErrorStatus = false;
            if (scope.userType === semafoneConstants.userType.care) {
              scope.$digest();
            }
            scope.getValidToken = true;
            scope.updateResult({result: scope.creditCardData});
          }
        }

        semafoneCreditCard.registerObserver(updateSemafoneValidationState);

        scope.creditCardData.processRetailCard = function () {
          scope.loadingDataIndicator = true;
          var token = document.querySelector('.cardInput').value;
          semafoneRetail.getMaskedCardNumber(token, function (callbackData) {
            if (callbackData) {
              scope.loadingDataIndicator = false;
              if (callbackData.semafoneError) {
                scope.creditCardData.semafoneValidationState = callbackData.semafoneError;
                scope.isDisplayTokenErrorStatus = true;
                console.log('if callbackData.semafoneError:' + callbackData.semafoneError);
              }
              else {
                scope.isDisplayTokenErrorStatus = false;
                scope.creditCardData.semafoneToken = callbackData.token;
                scope.creditCardData.semafoneValidationState = callbackData.result;
                scope.creditCardData.cardScheme = callbackData.cardType;
                scope.creditCardData.isCardSwiped = false;
                scope.isCardSwiped = false;
                scope.getValidToken = true;
                console.log('else callbackData.semafoneError:' + callbackData.semafoneError);
              }
              scope.updateResult({result: scope.creditCardData});
            }
          });
        };

        scope.onCardSwiped = function () {
          var textVal = angular.element('.cardInput').val();
          angular.element('.cardInput').val('');
          if (textVal.length > 1) {
            scope.encrypteData += textVal.charAt(textVal.length - 1);
          } else {
            scope.encrypteData += textVal;
          }

          if (scope.encrypteData.charAt(0) === '0' && scope.encrypteData.charAt(1) === '2') {
            setTimeout(isNotaSwipe, 120000); //in case of user input 0 and 2 manually should reset after 30s
          }
          else {

            if ((scope.encrypteData.charAt(0) !== '0') || (scope.encrypteData.length >= 2 && scope.encrypteData.charAt(1) !== '2')) {
              scope.encrypteData = '';
            }
          }

          validateToken(scope.encrypteData);
        };

        function validateToken(textVal) {
          var hexString = textVal.substring(4, 6) + textVal.substring(2, 4);
          var decVal = parseInt(hexString, 16) + 12;
          if (textVal.substr(textVal.length - 2) === '03' && textVal.length >= decVal) {
            scope.swipedCardNumber = scope.encrypteData;
            scope.isDisplayTokenErrorStatus = false;
            scope.creditCardData.isCardSwiped = true;
            scope.isCardSwiped = true;
            scope.updateResult({result: scope.creditCardData});
            scope.encrypteData = '';
            //event.preventDefault();
            return false;
          }
        }

        function isNotaSwipe() {
          angular.element('.cardInput').focus();
        }

        scope.getCancel = function () {
          scope.swipedCardNumber = '';
          scope.creditCardData.isCardSwiped = false;
          scope.updateResult({result: scope.creditCardData});
          scope.isCardSwiped = false;
        };

        scope.resetMessage = function () {
          scope.getValidToken = false;
        };

        scope.$on('$destroy', function () {
          // unregister the receiveMessage callback handler
          $.receiveMessage(); //jshint ignore:line
        });

        function updateIframe(data) {
          var template;
          if (data) {
            element.empty();
            if (scope.userType === semafoneConstants.userType.dealer) {
              template = $templateCache.get(semafoneConstants.semafoneTemplates.dealer);
              element.append($compile(template)(scope));
            } else if (scope.userType === semafoneConstants.userType.care) {
              template = $templateCache.get(semafoneConstants.semafoneTemplates.care);
              var careTemplate = $(template).find('div[name=semafoneCareRep]').append(data).parent().parent(); //jshint ignore:line
              element.append($compile(careTemplate)(scope));
            } else {
              element.append(data);
            }
          }
        }

        semafoneCreditCard.registerObserver(updateIframe);

        function init() {
          semafoneCreditCard.resetToken();
          semafoneLaunch.semafoneCapture();

          // if (scope.userType === semafoneConstants.userType.consumer) {
          //   $timeout(function () {
          //     var semaIFrame = $('#sema')[0]; //jshint ignore:line
          //     if (semaIFrame) {
          //       semaIFrame.src = semaIFrame.src;
          //     }
          //   }, 1000);
          // }
        }

        init();

      }
    };
  }

})();


(function () {

  'use strict';
  angular.module('ute.semafone.service').factory('creditCardModel', creditCardModel);

  function creditCardModel() {

    var cards = {
      visa: {
        id: 0,
        name: 'VI',
        dealerName: 'V',
        image: 'ute-common-assets/assets/cards/visa-icon-1217.png',
        desc: 'VISA'
      },
      mc: {
        id: 1,
        name: 'MC',
        dealerName: 'M',
        image: 'ute-common-assets/assets/cards/master.png',
        desc: 'MASTERCARD'
      },
      amex: {
        id: 2,
        name: 'AM',
        dealerName: 'A',
        image: 'ute-common-assets/assets/cards/amex.png',
        desc: 'AMERICANEXPRESS'
      }
    };

    var service = {
      cards: cards
    };

    return service;
  }

})();

/**
 * Created by Sanjay on 5/17/2016.
 */

(function () {
    angular.module('ute.semafone').filter('htmlSafe', htmlSafe);

    htmlSafe.$inject = ['$sce'];
    function htmlSafe($sce) {
        return function (input) {
           return $sce.trustAsHtml(input);
        };
    }
})();

(function () {
  'use strict';

  angular.module('ute.semafone.service').constant('semafoneConstants', {
    //userType constants
    userType: {
      dealer: 'dealer',
      care: 'care',
      consumer: 'consumer'
    },
    semafoneMode: {
      disabled: 'DISABLED',
      manualCR: 'MANUAL_CR',
      ctiMode: 'CTI_MODE'
    },
    semafoneEnv: {
      dev: 'dev',
      qa: 'qa',
      prod: 'prod'

    },
    semafoneParams: {
      //semafone params for dev
      dev: {
        cybersource: {
          consumer: {
            semafoneUrl: 'https://htsdev01.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkSJTANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwMTQxWhcNMjUwMjA2MjAwMTQxWjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCar7YRV/nrR3MFB/GoAvwz4ocpnN0ViO9OWlPl9ZvFAVnMAuPNPcwK+xfIgwG3Zdw8WZ56Flc1GTfUFZNV1Mz4AQYagN+s59LyfTLtMVXwTFJSItnTqJ+S0R9Sm0EzmhIMlDha49+h/469kXzDSVpyKayxSB5uQ2OQcn4IB8YmgwIDAQABMA0GCSqGSIb3DQEBBQUAA4GBABGvmhfC5mhStql26Vmc4+fN2GsrRUu4+E/pqywzHCtvd+Ktsd6t1Eqc1wtY40CLWyOyP0eNk7yVPTWgQaU3ZQU88t69GxQjwwRfEy0VLqB7ez7UrLOYgLxv2SK2IqAYEOMRFYc12YW8yHIUQvWaVp2QjXsJLkzsTrMrq5/XHymM',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsdev01.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          care: {
            semafoneUrl: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenPageFragment.html',
            semafoneMode: 'MANUAL_CR',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkTEjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwNTM4WhcNMjUwMjA2MjAwNTM4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzqmdLamUOlCO2kpAZBVTuQN+6Iw6+kNb91EW055udpGNyX04o4xMl1zrLFEVJpuZ3JqyrtuAFKQb8ovEeBNzJWoZL8EhpYXYaCfwL5114lpTbVEi/AvbV0iVSvmADjenEzD1241/KTf8Y9ThhHV9SzJOHdCqdRT8OmUn1BHeCIQIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAHAH048PRyvJA2lmamcN83LfiCr1G92ec8dE9CB0XOIWKsusBcYYPBWfJyTFvRg93nbT6laRMUWPcuFDxjYl1o5b0DMCQPmn01fzM9RSk2h9KdUQj5/ZPMrP+og3950DnsCn4rlAWJ/syWsnVS8j/20Vo+q1oBapJsX0gimwZHgG',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          },
          dealer: {
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          }
        },
        moneris: {
          consumer: {
            semafoneUrl: 'https://htsdev02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            ppUserId: 'vaas000153',
            ppPassword: 'o116tdUOVaqfmtsbSPUw',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsdev01.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          care: {
            semafoneUrl: 'https://htsdev02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'MANUAL_CR',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            ppUserId: 'vaas000153',
            ppPassword: 'o116tdUOVaqfmtsbSPUw',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          },
          dealer: {
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          }
        }

      },
      //semafone details for QA
      qa: {
        cybersource: {
          consumer: {
            semafoneUrl: 'https://htsqa01.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkTEjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwNTM4WhcNMjUwMjA2MjAwNTM4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzqmdLamUOlCO2kpAZBVTuQN+6Iw6+kNb91EW055udpGNyX04o4xMl1zrLFEVJpuZ3JqyrtuAFKQb8ovEeBNzJWoZL8EhpYXYaCfwL5114lpTbVEi/AvbV0iVSvmADjenEzD1241/KTf8Y9ThhHV9SzJOHdCqdRT8OmUn1BHeCIQIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAHAH048PRyvJA2lmamcN83LfiCr1G92ec8dE9CB0XOIWKsusBcYYPBWfJyTFvRg93nbT6laRMUWPcuFDxjYl1o5b0DMCQPmn01fzM9RSk2h9KdUQj5/ZPMrP+og3950DnsCn4rlAWJ/syWsnVS8j/20Vo+q1oBapJsX0gimwZHgG',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          care: {
            semafoneUrl: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenPageFragment.html',
            semafoneMode: 'MANUAL_CR',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVNkTEjANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwMjA5MjAwNTM4WhcNMjUwMjA2MjAwNTM4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCzqmdLamUOlCO2kpAZBVTuQN+6Iw6+kNb91EW055udpGNyX04o4xMl1zrLFEVJpuZ3JqyrtuAFKQb8ovEeBNzJWoZL8EhpYXYaCfwL5114lpTbVEi/AvbV0iVSvmADjenEzD1241/KTf8Y9ThhHV9SzJOHdCqdRT8OmUn1BHeCIQIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAHAH048PRyvJA2lmamcN83LfiCr1G92ec8dE9CB0XOIWKsusBcYYPBWfJyTFvRg93nbT6laRMUWPcuFDxjYl1o5b0DMCQPmn01fzM9RSk2h9KdUQj5/ZPMrP+og3950DnsCn4rlAWJ/syWsnVS8j/20Vo+q1oBapJsX0gimwZHgG',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          },
          dealer: {
            //semafoneUrl: 'https://rtltqa05.rogers.com/semafone/serviceintegration/rogersretial/tokenise'
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          }
        },
        moneris: {
          consumer: {
            semafoneUrl: 'https://htsqa05.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            ppUserId: 'vaas000221',
            ppPassword: 'KiVDIoM0wPjcxBXXkKT3',
            semafoneMode: 'DISABLED',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          care: {
            semafoneUrl: 'https://htsqa05.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            ppUserId: 'vaas000221',
            ppPassword: 'KiVDIoM0wPjcxBXXkKT3',
            semafoneMode: 'DISABLED',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '2kBsYvAs3d',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://htsqa01.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          },
          dealer: {
            //semafoneUrl: 'https://rtltqa05.rogers.com/semafone/serviceintegration/rogersretial/tokenise'
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          }
        }

      },
      //semafone details for production
      prod: {
        cybersource: {
          consumer: {
            semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVUzQzDANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwNTA4MTUwNTQ4WhcNMjUwNTA1MTUwNTQ4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIiTVxBU6TCkukpWoLS28L1t/mTDPevgoKv+ETN1Wji0GYNIibphhEdz8VD2zJ0zCilENcDCLJMdL2RoQVwqetg7b4UwBfNkfAdiRn5P/HR8fvwlky8ETuofm9J0k13KEN3hDQEmvCNqIIF/nI/8GO+MD0IlP0w1+A7Z5bZZb/ewIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAIIzYCkh8cy8WbwXjSDTVRqiorrgFs99Y+GNncZiIDlug25adp5FBjOVYIZkIAZVaJ1Tv/PfzmqmOQrvaKz2GpCEjhDAfoIc8MwQ43Q3+Iq9/U0z98jwA11OmsvZJHy/VsxQ0aMjDL15J48YclVS7nFPkwZb77Oz1z/nzmgwWZTO',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '7QucejpMeP',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          dealer: {
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          },
          care: {
            semafoneUrl: 'https://hts.rogers.com/semafone/service/capture/getHtsTokenPageFragment.html',
            semafoneMode: 'MANUAL_CR',
            gatewayId: 'CYBERSOURCE',
            methodId: 'TOKENISE',
            ppUserId: 'rogers.com',
            ppPassword: 'MIIBmjCCAQOgAwIBAgIEVUzQzDANBgkqhkiG9w0BAQUFADAOMQwwCgYDVQQDDANUREUwHhcNMTUwNTA4MTUwNTQ4WhcNMjUwNTA1MTUwNTQ4WjAVMRMwEQYDVQQDDApyb2dlcnMuY29tMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIiTVxBU6TCkukpWoLS28L1t/mTDPevgoKv+ETN1Wji0GYNIibphhEdz8VD2zJ0zCilENcDCLJMdL2RoQVwqetg7b4UwBfNkfAdiRn5P/HR8fvwlky8ETuofm9J0k13KEN3hDQEmvCNqIIF/nI/8GO+MD0IlP0w1+A7Z5bZZb/ewIDAQABMA0GCSqGSIb3DQEBBQUAA4GBAIIzYCkh8cy8WbwXjSDTVRqiorrgFs99Y+GNncZiIDlug25adp5FBjOVYIZkIAZVaJ1Tv/PfzmqmOQrvaKz2GpCEjhDAfoIc8MwQ43Q3+Iq9/U0z98jwA11OmsvZJHy/VsxQ0aMjDL15J48YclVS7nFPkwZb77Oz1z/nzmgwWZTO',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '7QucejpMeP',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          }
        },
        moneris: {
          consumer: {
            semafoneUrl: 'https://htsdev02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'DISABLED',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            ppUserId: 'vaas000153',
            ppPassword: 'o116tdUOVaqfmtsbSPUw',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '7QucejpMeP',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getSemafoneIMResultsEcommerceFragment.html'
          },
          dealer: {
            semafoneUrl: '/rogers_rest/semafone/retail/tokenise'
          },
          care: {
            semafoneUrl: 'https://htsdev02.rogers.com/semafone/service/capture/getSemafoneIMEcommerceFragment.html',
            semafoneMode: 'MANUAL_CR',
            gatewayId: 'MONERIS',
            methodId: 'TOKENISE',
            ppUserId: 'vaas000153',
            ppPassword: 'o116tdUOVaqfmtsbSPUw',
            tenantId: 'RCI',
            clientId: '9',
            accountId: '531',
            principle: 'rogersp',
            licenseCode: '7QucejpMeP',
            transactionType: 'GetTokenPan',
            responseType: 'web',
            responseURL: 'https://hts.rogers.com/semafone/service/capture/getHtsTokenResultsPage.html'
          }
        }

      }
    },
    transactionReference: '1234567890',

    semafoneTemplates: {
      care: 'module/semafone/directive/semafone.carerep.template.html',
      dealer: 'module/semafone/directive/semafone.dealer.template.html'
    }
  });

})();


(function () {

  'use strict';

  angular.module('ute.semafone.service').factory('semafoneCreditCard', semafoneCreditCard);

  function semafoneCreditCard() {
    var observers = [];
    var creditCardData = {
      semafoneToken: '',
      cardScheme: '',
      semafoneValidationState: '',
      maskedCardNumber: '',
      semafoneErrorCode: '',
      isCardSwiped: false
    };
    var userType = '';
    var iFrame = '';
    var service = {
      creditCardData: creditCardData,
      setSemafoneValidationState: setSemafoneValidationState,
      setSemafoneToken: setSemafoneToken,
      setSemafoneCardScheme: setSemafoneCardScheme,
      setMaskedCardNumber: setMaskedCarNumber,
      setSemafoneData: setSemafoneData,
      resetObserver: resetObserver,
      registerObserver: registerObserver,
      setSemafoneErrorCode: setSemafoneErrorCode,
      getUserType: getUserType,
      setUserType: setUserType,
      updateIFrame: updateIframe,
      resetToken: resetToken,
      setCurrentCardNumberLength: setCurrentCardNumberLength
    };

    function resetToken() {
      creditCardData.semafoneToken = '';
      creditCardData.cardScheme = '';
      creditCardData.semafoneValidationState = '';
      creditCardData.maskedCardNumber = '';
      creditCardData.semafoneErrorCode = '';
    }

    return service;

    /**
     * Reset observers to an empty object
     */
    function resetObserver() {
      observers = [];
    }

    function registerObserver(callback) {
      observers.push(callback);
    }

    function notifyObservers(data) {
      angular.forEach(observers, function (callback) {
        callback(data);
      });
    }

    function setSemafoneValidationState(state, notify) {
      if (creditCardData.semafoneValidationState !== state) {
        creditCardData.semafoneValidationState = state;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setSemafoneToken(token, notify) {
      if (creditCardData.semafoneToken !== token) {
        creditCardData.semafoneToken = token;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setSemafoneCardScheme(cardScheme, notify) {
      if (creditCardData.cardScheme !== cardScheme) {
        creditCardData.cardScheme = cardScheme;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setMaskedCarNumber(maskNumber, notify) {
      if (creditCardData.maskedCardNumber !== maskNumber) {
        creditCardData.maskedCardNumber = maskNumber;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setSemafoneData(creditData, notify) {
      if (creditCardData !== creditData) {
        creditCardData = creditData;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setSemafoneErrorCode(errorCode, notify) {
      if (creditCardData.semafoneErrorCode !== errorCode) {
        creditCardData.semafoneErrorCode = errorCode;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function setCurrentCardNumberLength(cardNumberlength, notify) {
      if (creditCardData.currentCardNumberLength !== cardNumberlength) {
        creditCardData.currentCardNumberLength = cardNumberlength;
        if (notify) {
          notifyObservers();
        }
      }
    }

    function getUserType() {
      return userType;
    }

    function setUserType(uType) {
      userType = uType.toLowerCase();
    }

    function updateIframe(iframeInstance, notify) {
      iFrame = iframeInstance;
      if (notify) {
        notifyObservers(iFrame);
      }
    }
  }

})();

(function () {

  'use strict';
  angular.module('ute.semafone.service').factory('semafoneLaunch', semafoneLaunch);

  semafoneLaunch.$inject = ['semafoneRogers', 'semafoneModel'];

  function semafoneLaunch(semafoneRogers, semafoneModel) {

    var service = {
      semafoneCapture: semafoneCapture
    };

    return service;

    function semafoneCapture() {
      semafoneModel.resetModel();
      semafoneRogers.launchSemafoneCapturePage();
    }
  }

})();



(function () {

    'use strict';

    angular.module('ute.semafone.service').factory('semafoneModel', semafoneModel);

    function semafoneModel() {
        var  semafoneData = {
            token: '',
            cardScheme: '',
            maskedCardNumber: '',
            semafoneTokeniseErrorCode: '',
            semafoneTokeniseReasonCode: '',
            isPanResetOnInitialFocus: '',
            semafoneTokeniseResponseCode: '',
            semafoneTokeniseErrorDesc: '',
            semafoneValidationState: '',
            semafoneState: '',
            cybersourceTokeniseResponseCode: '',
            cybersourceTokeniseReasonCode: '',
            cybersourceTokeniseMessage: '',
            cybersourceTokeniseErrorCause: '',
            semafoneError: '',
            semafoneValidationErrorCode: ''

        };

        var service = {
            model: semafoneData,
            resetModel: resetModel
        };

        return service;

        function resetModel() {
            semafoneData.token = '';
            semafoneData.cardScheme = '';
            semafoneData.maskedCardNumber = '';
            semafoneData.semafoneTokeniseErrorCode = '';
            semafoneData.semafoneTokeniseReasonCode = '';
            semafoneData.isPanResetOnInitialFocus = '';
            semafoneData.semafoneTokeniseResponseCode = '';
            semafoneData.semafoneTokeniseErrorDesc = '';
            semafoneData.semafoneValidationState = '';
            semafoneData.semafoneState = '';
            semafoneData.cybersourceTokeniseResponseCod = '';
            semafoneData.cybersourceTokeniseReasonCode = '';
            semafoneData.cybersourceTokeniseMessage = '';
            semafoneData.cybersourceTokeniseErrorCause = '';
            semafoneData.semafoneError = '';
            semafoneData.semafoneValidationErrorCode = '';
        }

    }

})();
(function () {
    'use strict';

    angular.module('ute.semafone.component').provider('semafoneSettings', semafoneSettings);

    function semafoneSettings() {
        var env = '';
        var params = '';
        var userType = '';

        this.setEnvironment = function (value) {
            env = value;
        };

        this.setUrlParams = function (value) {
            params = value;
        };

        this.setUserType = function (value) {
            userType = value;
        };

        this.$get = [function () {
            return {
                environment: env,
                semafoneParams: params,
                userType: userType
            };
        }];
    }

})();


(function () {
  'use strict';
  angular.module('ute.semafone.component').factory('semafoneRetail', semafoneRetail);

  semafoneRetail.$inject = ['$http', 'semafoneUrl']

  function semafoneRetail($http, semafoneUrl) {

    var service = {
      getMaskedCardNumber: getMaskCardNumber
    }

    return service;

    function semafoneRequestXML(token) {
      var xmlRequest = '<?xml version="1.0" encoding="UTF-8"?>' +
        '<ns2:retailTokenisationRequest xmlns:ns2="http://www.semafone.com/rogers/cde/cash" xmlns="http://www.semafone.com">';
      xmlRequest += '<ns2:cardReaderOutput>' + token + '</ns2:cardReaderOutput>';
      xmlRequest += '<ns2:cardReaderType>IDTECH_SECUREMAG_80096504_001_L</ns2:cardReaderType></ns2:retailTokenisationRequest>';

      return xmlRequest;
    }

    function getMaskCardNumber(token, callback) {
      var result = {};
      var req = semafoneRequestXML(token);
      return semafoneUrl.getUrl().then(function (url) {
        xmlHttpPost(url, req).then(function (data) {
          if (data) {
            result.status = 'ok';
            result.data = data;
            return callback(processXml(result));
          } else {
            result.status = 'fail';
            result.data = data;
            return callback(processXml(result));
          }
        }, function (error) {
          result.error = 'error';
          return callback(result);

        });
      });


    }

    function xmlHttpPost(endpoint, params) {
      var request = {
        //method: params.httpMethod || 'POST',
        method: 'POST',
        url: endpoint,
        headers: {
          'Content-Type': 'text/xml'
        },
        data: params
      };

      return $http(request);
    }

    function processXml(serverResponse) {
      var xmlResponse = {
        result: '',
        cardType: '',
        token: '',
        reasonCode: '',
        responseMsg: '',
        error: ''
      };
      xmlResponse.error = serverResponse.error;
      if (serverResponse.data) {
        var xml = $.parseXML(serverResponse.data.data);
        /* xmlResponse.result = $('result', xml).text();
         xmlResponse.cardType = $('cardType', xml).text();
         xmlResponse.token = $('token', xml).text();
         xmlResponse.reasonCode = $('csReasonCode', xml).text();
         xmlResponse.responseMsg = $('csResponseMsg', xml).text();
         xmlResponse.semafoneError = $('code', xml).text();*/
        var browserName = getBrowserName();
        if (browserName === 'Chrome') {
          xmlResponse.result = $('ns2\\:result', xml).text();
          xmlResponse.cardType = $('ns2\\:cardType', xml).text();
          xmlResponse.token = $('ns2\\:token', xml).text();
          xmlResponse.reasonCode = $('ns2\\:csReasonCode', xml).text();
          xmlResponse.responseMsg = $('ns2\\:csResponseMsg', xml).text();
          xmlResponse.semafoneError = $('ns2\\:code', xml).text();
        } else if (browserName === 'Firefox') {
          if (xml.childNodes[0].getElementsByTagName("ns2:result")[0]) {
            xmlResponse.result = xml.childNodes[0].getElementsByTagName("ns2:result")[0].innerHTML;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:cardType")[0]) {
            xmlResponse.cardType = xml.childNodes[0].getElementsByTagName("ns2:cardType")[0].innerHTML;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:token")[0]) {
            xmlResponse.token = xml.childNodes[0].getElementsByTagName("ns2:token")[0].innerHTML;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:csReasonCode")[0]) {
            xmlResponse.reasonCode = xml.childNodes[0].getElementsByTagName("ns2:csReasonCode")[0].innerHTML;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:csResponseMsg")[0]) {
            xmlResponse.responseMsg = xml.childNodes[0].getElementsByTagName("ns2:csResponseMsg")[0].innerHTML;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:code")[0]) {
            xmlResponse.semafoneError = xml.childNodes[0].getElementsByTagName("ns2:code")[0].innerHTML;
          }
        } else if (browserName = 'Microsoft Internet Explorer' || browserName === 'Safari') {
          if (xml.childNodes[0].getElementsByTagName("ns2:result")[0]) {
            xmlResponse.result = xml.childNodes[0].getElementsByTagName("ns2:result")[0].textContent;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:cardType")[0]) {
            xmlResponse.cardType = xml.childNodes[0].getElementsByTagName("ns2:cardType")[0].textContent;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:token")[0]) {
            xmlResponse.token = xml.childNodes[0].getElementsByTagName("ns2:token")[0].textContent;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:csReasonCode")[0]) {
            xmlResponse.reasonCode = xml.childNodes[0].getElementsByTagName("ns2:csReasonCode")[0].textContent;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:csResponseMsg")[0]) {
            xmlResponse.responseMsg = xml.childNodes[0].getElementsByTagName("ns2:csResponseMsg")[0].textContent;
          }
          if (xml.childNodes[0].getElementsByTagName("ns2:code")[0]) {
            xmlResponse.semafoneError = xml.childNodes[0].getElementsByTagName("ns2:code")[0].textContent;
          }
        }
      }
      return xmlResponse;
    }

    function getBrowserName() {
      var nAgt = navigator.userAgent;
      var browser = navigator.appName;
      var version = '' + parseFloat(navigator.appVersion);
      var nameOffset, verOffset, ix;

      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
      }
      // Other browsers
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }
      return browser;
    }
  }

})();


(function () {

  'use strict';

  angular.module('ute.semafone.service').factory('semafoneRogers', semafoneRogers);

  semafoneRogers.$inject = ['semafoneCreditCard', 'semafoneConstants', 'semafoneUrl', 'semafoneModel'];
  function semafoneRogers(semafoneCreditCard, semafoneConstants, semafoneUrl, semafoneModel) {

    var service = {
      launchSemafoneCapturePage: launchSemafoneCapturePage
    };

    return service;

    function launchSemafoneCapturePage() {
      semafoneUrl.getUrl().then (function (url) {
        initialiseIframe(url);
      });
    }

    function initialiseIframe(iframeUrl) {
      loadIframe(iframeUrl, function (semafoneState, semafoneValidationState, semafoneValidationErrorCode, semafoneValidationErrorDesc,
                                      cardScheme, currentCardNumberLength, expectedCardNumberLength, expectedSecurityCodeLength, token, maskedPan,
                                      processResultState, semafoneResponseCode, semafoneReasonCode, semafoneErrorCode, semafoneErrorName,
                                      semafoneErrorCause, semafoneErrorRemedy, semafoneWarningCode, semafoneWarningName, semafoneWarningCause,
                                      semafoneWarningRemedy, serviceReasonCode, serviceResponseCode, serviceMessage, serviceErrorCode, serviceErrorName,
                                      serviceErrorCause, serviceErrorRemedy, responseToken) {

        if (semafoneState && semafoneState.length > 0) {
          semafoneModel.model.semafoneState = semafoneState;
        }

        if (semafoneValidationState && semafoneValidationState.length > 0) {
          semafoneModel.model.semafoneValidationState = semafoneValidationState;
          semafoneCreditCard.setSemafoneValidationState(semafoneValidationState);
        }

        if (semafoneValidationErrorCode && semafoneValidationErrorCode.length > 0) {
          semafoneModel.model.semafoneValidationErrorCode = semafoneValidationErrorCode;
          semafoneCreditCard.setSemafoneErrorCode(semafoneValidationErrorCode, true);
        }
        else {
          semafoneModel.model.semafoneValidationErrorCode = '';
        }

        if (semafoneValidationErrorDesc && semafoneValidationErrorDesc.length > 0) {
          semafoneModel.semafoneValidationErrorDesc = semafoneValidationErrorDesc;
        }
        else {
          semafoneModel.semafoneValidationErrorDesc = '';
        }

        if ((semafoneState && semafoneState.length > 0 && semafoneState === 'ACTIVE')) {
          semafoneCreditCard.setSemafoneToken('');
          semafoneCreditCard.setSemafoneCardScheme('');
          semafoneCreditCard.setMaskedCardNumber('', false);
          semafoneCreditCard.setSemafoneValidationState('Unknown');

          semafoneModel.resetModel();
        }

        if (semafoneState && semafoneState.length > 0 && semafoneState !== 'COMPLETE') {
          semafoneModel.model.semafoneState = '';
        }

        if (semafoneValidationState && semafoneValidationState.length > 0 && semafoneValidationState !== 'SUCCESS') {
          semafoneModel.model.semafoneValidationState = '';
        }

        if (semafoneValidationState && semafoneValidationState.length > 0 && semafoneValidationState === 'FAIL') {
          semafoneCreditCard.setSemafoneToken('');
          semafoneCreditCard.setMaskedCardNumber('');
          semafoneCreditCard.setSemafoneCardScheme('');
          semafoneCreditCard.setSemafoneValidationState('FAIL', true);
          semafoneModel.resetModel();
        }

        if (serviceMessage && serviceMessage.length > 0) {
          semafoneCreditCard.setSemafoneValidationState(serviceMessage);
        }

        if (semafoneResponseCode && semafoneResponseCode.length > 0) {
          semafoneModel.model.semafoneTokeniseResponseCode = '';
          if (semafoneResponseCode !== 'SUCCESS' && (!serviceResponseCode || serviceResponseCode.length < 1)) {
            semafoneModel.model.isPanResetOnInitialFocus = true;
            reloadSemafonePage();
          }
        }

        if (semafoneErrorCode && semafoneErrorCode.length > 0) {
          semafoneModel.model.semafoneTokeniseErrorCode = semafoneErrorCode;
        }

        if (semafoneErrorCause && semafoneErrorCause.length > 0) {
          semafoneModel.model.semafoneTokeniseErrorDesc = semafoneErrorCause;
        }

        if (serviceResponseCode && serviceResponseCode.length > 0) {
          semafoneModel.model.cybersourceTokeniseResponseCode = serviceResponseCode;
          if (serviceResponseCode !== 100) {
            semafoneModel.model.isPanResetOnInitialFocus = true;
            reloadSemafonePage();
          }
        }

        if (serviceErrorCause && serviceErrorCause.length > 0) {
          semafoneModel.model.cybersourceTokeniseErrorCause = serviceErrorCause;
        }

        if (serviceReasonCode && serviceReasonCode.length > 0) {
          semafoneModel.model.cybersourceTokeniseReasonCode = serviceReasonCode;
        }

        if (serviceMessage && serviceMessage.length > 0) {
          semafoneModel.model.cybersourceTokeniseMessage = serviceMessage;
        }

        if (processResultState === 'SUCCESS' || serviceMessage.substr(0, 3) === '100') {
          if (cardScheme && cardScheme.length > 0) {
            semafoneModel.model.cardScheme = cardScheme;
            if (token && token.length > 0) {
              semafoneCreditCard.setSemafoneCardScheme(cardScheme);
            }
          }

          if (maskedPan && maskedPan.length > 0) {
            semafoneModel.model.maskedCardNumber = maskedPan;
            semafoneModel.model.isPanResetOnInitialFocus = true;
            semafoneCreditCard.setMaskedCardNumber(maskedPan);

            launchSemafoneCapturePage();
          }

          if (token && token.length > 0) {
            semafoneModel.model.token = token;
            semafoneCreditCard.setSemafoneToken(token, true);
          }

        }

        if (currentCardNumberLength && currentCardNumberLength !== '') {
          semafoneCreditCard.setCurrentCardNumberLength(currentCardNumberLength, true);
        }

      });
    }

    function loadIframe(url, fn) {
      var src = url + '#' + encodeURIComponent(document.location.href);
      var iFrameElement = getIframeElement(semafoneCreditCard.getUserType(), src);
      semafoneCreditCard.updateIFrame(iFrameElement, true);

      $.receiveMessage(function (event) {
        var semafoneState = '',
          semafoneValidationState = '',
          semafoneValidationErrorCode = '',
          semafoneValidationErrorDesc = '',
          cardScheme = '',
          currentCardNumberLength = '',
          expectedCardNumberLength = '',
          expectedSecurityCodeLength = '',
          token = '',
          maskedPan = '',
          processResultState = '',
          semafoneResponseCode = '',
          semafoneReasonCode = '',
          semafoneErrorCode = '',
          semafoneErrorName = '',
          semafoneErrorCause = '',
          semafoneErrorRemedy = '',
          semafoneWarningCode = '',
          semafoneWarningName = '',
          semafoneWarningCause = '',
          semafoneWarningRemedy = '',
          serviceReasonCode = '',
          serviceResponseCode = '',
          serviceMessage = '',
          serviceErrorCode = '',
          serviceErrorName = '',
          serviceErrorCause = '',
          serviceErrorRemedy = '';

        if (event && event.data) {
          var bar = event.data.split('&');
          for (var i = 0; i < bar.length; i++) {
            var pair = bar[i].split('=');
            var key = pair[0];
            var value = pair[1];
            if (key === 'semafoneState') {
              semafoneState = value;
              semafoneModel.model.semaState = value;
            }
            else if (key === 'semafoneValidationState') {
              semafoneValidationState = value;
            }
            else if (key === 'semafoneValidationErrorCode') {
              semafoneValidationErrorCode = value;
            }
            else if (key === 'semafoneValidationErrorDesc') {
              semafoneValidationErrorDesc = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'cardScheme') {
              cardScheme = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'currentCardNumberLength') {
              currentCardNumberLength = value;
            }
            else if (key === 'expectedCardNumberLength') {
              expectedCardNumberLength = value;
            }
            else if (key === 'expectedSecurityCodeLength') {
              expectedSecurityCodeLength = value;
            }
            else if (key === 'token') {
              token = decodeURIComponent(value);
            }
            else if (key === 'maskedPan') {
              maskedPan = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'processResultState') {
              processResultState = value;
            }
            else if (key === 'semafoneResponseCode') {
              semafoneResponseCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneReasonCode') {
              semafoneReasonCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneErrorCode') {
              semafoneErrorCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneErrorName') {
              semafoneErrorName = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneErrorCause') {
              semafoneErrorCause = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneErrorRemedy') {
              semafoneErrorRemedy = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneWarningCode') {
              semafoneWarningCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneWarningName') {
              semafoneWarningName = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneWarningCause') {
              semafoneWarningCause = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'semafoneWarningRemedy') {
              semafoneWarningRemedy = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceReasonCode') {
              serviceReasonCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceResponseCode') {
              serviceResponseCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceMessage') {
              serviceMessage = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceErrorCode') {
              serviceErrorCode = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceErrorName') {
              serviceErrorName = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceErrorCause') {
              serviceErrorCause = decodeURIComponent(decodeSpaces(value));
            }
            else if (key === 'serviceErrorRemedy') {
              serviceErrorRemedy = decodeURIComponent(decodeSpaces(value));
            }
          }

          if (semafoneState || semafoneValidationState || semafoneValidationErrorCode || semafoneValidationErrorDesc ||
            cardScheme || currentCardNumberLength || expectedCardNumberLength || expectedSecurityCodeLength || token ||
            maskedPan || processResultState || semafoneResponseCode || semafoneReasonCode || semafoneErrorCode ||
            semafoneErrorName || semafoneErrorCause || semafoneErrorRemedy || semafoneWarningCode || semafoneWarningName ||
            semafoneWarningCause || semafoneWarningRemedy || serviceReasonCode || serviceResponseCode || serviceMessage ||
            serviceErrorCode || serviceErrorName || serviceErrorCause || serviceErrorRemedy) {
            fn(semafoneState, semafoneValidationState, semafoneValidationErrorCode, semafoneValidationErrorDesc,
              cardScheme, currentCardNumberLength, expectedCardNumberLength, expectedSecurityCodeLength, token,
              maskedPan, processResultState, semafoneResponseCode, semafoneReasonCode, semafoneErrorCode,
              semafoneErrorName, semafoneErrorCause, semafoneErrorRemedy, semafoneWarningCode, semafoneWarningName,
              semafoneWarningCause, semafoneWarningRemedy, serviceReasonCode, serviceResponseCode, serviceMessage,
              serviceErrorCode, serviceErrorName, serviceErrorCause, serviceErrorRemedy);
          }
        }
      });

    }

    function reloadSemafonePage() {
      launchSemafoneCapturePage();
    }

    function decodeSpaces(s) {
      s = s.replace(/\+/g, ' ');
      return s;
    }

    function getIframeElement(userType, src) {
      var frame = '';

      if (userType === semafoneConstants.userType.consumer) {
        frame = '<iframe id="sema" src="' + src + '" style="display: inline;width:100%" height="40",' +
          ' scrolling="no" transparency="true" offset="0" border="0" outline="0" frameBorder="0" frameborder="0"' +
          ' marginwidth="0" marginheight="0" cobrowse="false"><\/iframe>';
      }
      else if (semafoneCreditCard.getUserType() === semafoneConstants.userType.care) {
        frame = '<iframe id="sema" src="' + src + '" style="display: inline;max-width:400" width="400"  height="140",' +
          ' scrolling="no" transparency="true" offset="0" border="0" outline="0" frameBorder="0" frameborder="0"' +
          ' marginwidth="0" marginheight="0" cobrowse="false"><\/iframe>';
      }

      else if (semafoneCreditCard.getUserType() === semafoneConstants.userType.dealer) {
        frame = '<div></div>';
      }

      return frame;

    }
  }

})();

(function () {

  'use strict';

  angular.module('ute.semafone.service').factory('semafoneUrl', semafoneUrl);

  semafoneUrl.$inject = [
    'semafoneConstants',
    'semafoneCreditCard',
    'semafoneModel',
    'semafoneSettings',
    'ute.semafone.service.config',
    'ute.common.core.brtswitch.service'];

  function semafoneUrl(semafoneConstants,
                       semafoneCreditCard,
                       semafoneModel,
                       semafoneSettings,
                       semafoneConfig,
                       brtSwitchService) {

    return {
      getUrl: getSemafoneUrl
    };

    function getSemafoneUrl() {
      var compObj = semafoneConfig.getConfig().basic.semafoneParams;
      return brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.TOKENIZATION_EVOLUTION).then(function (isPermitted) {

      var properties = {};

        if (!isPermitted) {
      properties = getUrlData(compObj.moneris);
        }else {
          properties = getUrlData(compObj.cybersource);
        }

      var semafoneUrl = properties.semafoneUrl;
      var semafoneMode = properties.semafoneMode;
      var gatewayId = properties.gatewayId;
      var methodId = properties.methodId;
      var ppUserId = properties.ppUserId;
      var ppPassword = properties.ppPassword;
      var tenantId = properties.tenantId;
      var clientId = properties.clientId;
      var accountId = properties.accountId;
      var principle = properties.principle;
      var licenseCode = properties.licenseCode;
      var transactionType = properties.transactionType;
      var responseType = properties.responseType;
      var responseURL = properties.responseURL;
      var isPanFocusedOnInitialise = false;
      var elementFontSize = '16';
      var elementWidth = /iPad/i.test(navigator.userAgent) ? '220' : '230';
      var elementMaxLength = '16';
      var maskedPan = '';//$translate.instant('ute.rogers.myrSemafone.creditCard') || 'Credit Card Number';
      var url = '';

      if (semafoneModel.model.maskedCardNumber) {
        maskedPan = semafoneModel.model.maskedCardNumber;
      }

      if (semafoneModel.model.isPanFocusedOnInitialise) {
        isPanFocusedOnInitialise = semafoneModel.model.isPanFocusedOnInitialise;
      }

      var isPanResetOnInitialFocus = true;

      if (semafoneModel.model.isPanResetOnInitialFocus) {
        isPanResetOnInitialFocus = semafoneModel.model.isPanResetOnInitialFocus;
      }

      if (semafoneCreditCard.getUserType() === semafoneConstants.userType.consumer) {
        url = semafoneUrl +
          '?semafoneMode=' + semafoneMode +
          '&gatewayId=' + gatewayId +
          '&methodId=' + methodId +
          '&ppUserId=' + ppUserId +
          '&ppPassword=' + encodeURIComponent(ppPassword) +
          '&tenantId=' + tenantId +
          '&clientId=' + clientId +
          '&accountId=' + accountId +
          '&principle=' + principle +
          '&licenseCode=' + licenseCode +
          '&responseType=' + responseType +
          '&transactionType=' + transactionType +
          '&maskedPan=' + maskedPan +
          '&isPanFocusedOnInitialise=' + isPanFocusedOnInitialise +
          '&isPanResetOnInitialFocus=' + isPanResetOnInitialFocus +
          '&elementFontSize=' + elementFontSize +
          '&elementWidth=' + elementWidth +
          '&elementMaxLength=' + elementMaxLength +
          '&responseURL=' + responseURL;
      } else if (semafoneCreditCard.getUserType() === semafoneConstants.userType.care) {
        url = semafoneUrl +
          '?transactionReference=' + semafoneConstants.transactionReference +
          '&semafoneMode=' + semafoneMode +
          '&gatewayId=' + gatewayId +
          '&methodId=' + methodId +
          '&ppUserId=' + ppUserId +
          '&ppPassword=' + encodeURIComponent(ppPassword) +
          '&tenantId=' + tenantId +
          '&clientId=' + clientId +
          '&accountId=' + accountId +
          '&principle=' + principle +
          '&licenseCode=' + licenseCode +
          '&responseType=' + responseType +
          '&transactionType=' + transactionType +
          '&responseURL=' + responseURL;
      } else if (semafoneCreditCard.getUserType() === semafoneConstants.userType.dealer) {
        url = semafoneUrl;
      }
      return url;
      });

    }

    function getUrlData(compObj) {
      if (!compObj || compObj === null) {
        compObj = semafoneConstants.semafoneParams[getSemafoneEnvironment()];
      }

      if (!compObj) {
        console.log('Semafone parameters not configured.');
        return {};
      } else {
        return compObj[semafoneCreditCard.getUserType()];
      }
    }

    function getSemafoneEnvironment() {
      var env = 'prod';

      if (semafoneSettings.environment) {
        env = semafoneSettings.environment;
      }
      else {
        var loc = window.location.toString().toLowerCase();
        if (loc.match('.dev') || loc.match('localhost')) {
          env = 'dev';
        } else if (loc.match('.qa')) {
          env = 'qa';
        }
      }
      return env;
    }
  }
})();

'use strict';

angular.module('totesApp').config(['ute.blocks.environmentProvider', function configure(environmentProvider) {
  var userMonitoring = environmentProvider.getProperty('userMonitoring');

  if (!!userMonitoring && userMonitoring.isEnabled) {
    sessionStorage.setItem('rumenv', userMonitoring.env);
    sessionStorage.setItem('rumservice', userMonitoring.service);
    sessionStorage.setItem('rumversion', environmentProvider.getProperty('buildId'));
  }
}]);


'use strict';

angular
  .module('totesApp')
  .constant('liveChatSettings', {
    floatingAccountOverview: {
      cbid: 'myr.liveChat.floatingAccountOverview.cbid',
      boldChatDiv: 'myr.liveChat.floatingAccountOverview.boldChatDiv',
      chatButton: 'myr.liveChat.floatingAccountOverview.chatButton'
    },
    floatingWirelessLanding: {
      cbid: 'myr.liveChat.floatingWirelessLanding.cbid',
      boldChatDiv: 'myr.liveChat.floatingWirelessLanding.boldChatDiv',
      chatButton: 'myr.liveChat.floatingWirelessLanding.chatButton'
    },
    floatingActivatingSimCard: {
      cbid: 'myr.liveChat.floatingActivatingSimCard.cbid',
      boldChatDiv: 'myr.liveChat.floatingActivatingSimCard.boldChatDiv',
      chatButton: 'myr.liveChat.floatingActivatingSimCard.chatButton'
    },
    floatingTvDashboard: {
      cbid: 'myr.liveChat.floatingTvDashboard.cbid',
      boldChatDiv: 'myr.liveChat.floatingTvDashboard.boldChatDiv',
      chatButton: 'myr.liveChat.floatingTvDashboard.chatButton'
    },
    floatingInternetDash: {
      cbid: 'myr.liveChat.floatingInternetDash.cbid',
      boldChatDiv: 'myr.liveChat.floatingInternetDash.boldChatDiv',
      chatButton: 'myr.liveChat.floatingInternetDash.chatButton'
    },
    floatingViewBill: {
      cbid: 'myr.liveChat.floatingViewBill.cbid',
      boldChatDiv: 'myr.liveChat.floatingViewBill.boldChatDiv',
      chatButton: 'myr.liveChat.floatingViewBill.chatButton'
    },
    viewBillError: {
      cbid: 'myr.liveChat.viewBillError.cbid',
      boldChatDiv: 'myr.liveChat.viewBillError.boldChatDiv',
      chatButton: 'myr.liveChat.viewBillError.chatButton'
    }
  });

'use strict';

angular.module('totesApp').config(configure);

configure.$inject = ['ute.common.pending.order.providerProvider'];

/* @ngInject */
function configure(pendingOrderProvider) {
  pendingOrderProvider.configure({
    basic: {
      applicationId: 'rogers.com'
    },
    advanced: {
    }
  });
}

'use strict';

angular.module('totesApp').config([
  '$stateProvider',
  '$urlRouterProvider',
  '$httpProvider',
  'settings',
  function ($stateProvider,
            $urlRouterProvider,
            $httpProvider,
            settings) {

    $urlRouterProvider.otherwise('error404');
    // Send them to '/' = home or '/error404'

    var signInUrls = ['', '/', '/home'];
    _.each(signInUrls, function (v) {
      $urlRouterProvider.when(v, 'signin');
    });

    $httpProvider.defaults.withCredentials = true;
    $httpProvider.defaults.timeout = 30000;

    var allStates = [

      {
        name: 'winOnlineInvoice',
        url: '/winOnlineInvoice',
        controller: 'WinPastInvoiceController',
        templateUrl: 'scripts/modules/winOnline/pastInvoice.html'
      },
      // Public pages
      {
        name: 'signin',
        url: '/signin',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/signin.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            return deeplink.signInCheck('/signin');
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          easyLogin: ['$q', 'appState', 'ute.common.user.service',
            function ($q, appState, userService) {
              var d = $q.defer();
              if (!userService.isSigned()) {
                appState.redirectToEasyLogin();
              } else {
                d.resolve(false);
              }
              return d.promise;
            }]
        },
        onEnter: ['appInterface', 'localStorage', 'myrAccountOverviewService', 'globalloaderService',
          function (appInterface, localStorage, accountOverviewService, globalloaderService) {
            appInterface.stateEnter('/signin');
            localStorage.clearAllLocalStorageValues();
            accountOverviewService.purgeAccountList();
            globalloaderService.hide();
          }
        ],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/signin');
        }]
      },
      {
        name: 'signinWithBanners',
        url: '/signin' + '/:banners',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/signin.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            return deeplink.signInCheck('/signin');
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          easyLogin: ['$q', 'appState', 'ute.common.user.service',
            function ($q, appState, userService) {
              var d = $q.defer();
              if (!userService.isSigned()) {
                appState.redirectToEasyLogin();
              } else {
                d.resolve(false);
              }
              return d.promise;
            }]
        },
        onEnter: ['appInterface', 'localStorage', 'myrAccountOverviewService', 'globalloaderService',
          function (appInterface, localStorage, accountOverviewService, globalloaderService) {
            appInterface.stateEnter('/signin');
            localStorage.clearAllLocalStorageValues();
            accountOverviewService.purgeAccountList();
            globalloaderService.hide();
          }
        ],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/signin');
        }]
      },
      {
        name: 'signoff',
        url: '/signoff',
        controller: 'MyrSigninController',
        templateUrl: 'scripts/modules/signin/signin.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          easyLogin: ['$q', 'appState', 'ute.common.user.service',
            function ($q, appState, userService) {
              var d = $q.defer();
              if (!userService.isSigned()) {
                appState.redirectToEasyLogin();
              } else {
                d.resolve(false);
              }
              return d.promise;
            }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/signoff');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/signoff');
        }]
      },
      {
        name: 'forgotUserName',
        url: '/forgotusername',
        controller: 'MyrForgotUserNameController',
        templateUrl: 'scripts/modules/forgotUserName/forgotUserName.html',
        resolve: {
          easyLogin: ['$q', 'appState',
            function ($q, appState) {
              appState.redirectToEasyLogin(true);
              return $q.defer().promise;
            }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/forgotusername');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/forgotusername');
        }]
      },
      {
        name: 'forgotUserNameNoLivecontent',
        url: '/forgotUserNameNoLivecontent',
        controller: 'MyrForgotUserNameController',
        templateUrl: 'scripts/modules/forgotUserName/forgotUserName.html',
        resolve: {
          redirectToDAM: ['$window', '$q', function ($window, $q) {
            $window.open('/consumer/profile/forgotusername', '_self');
            return $q.defer().promise;
          }],
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/forgotUserNameNoLivecontent');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/forgotUserNameNoLivecontent');
        }]
      },
      {
        name: 'forgotPassword',
        url: '/forgotpassword',
        resolve: {
          redirect: ['$location', function ($location) {
            $location.path('/sso/forgotPassword');
          }]
        }
      },
      {
        name: 'uteOneviewEnvPage',
        url: '/uteOneviewEnvPage?data&&sig&&content&&sourceChannel',
        controller: 'uteOneviewEnvPageCtrl',
        controllerAs: 'vm',
        templateUrl: 'scripts/modules/crm/uteOneViewEnvPage.html'
      },
      {
        name: 'migrateUser',
        url: '/migrateuser',
        controller: 'MyrMigrateUserController',
        templateUrl: 'scripts/modules/migrateUser/migrateUser.html',
        resolve: {
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/migrateuser');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/migrateuser');
        }]
      },
      {
        name: 'underMaintenance',
        url: '/underMaintenance',
        controller: 'MyrUnderMaintenanceController',
        templateUrl: 'scripts/modules/underMaintenance/underMaintenance.html',
        resolve: {},
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/underMaintenance');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/underMaintenance');
        }]
      },
      {
        name: 'guestOverview',
        url: '/guestoverview',
        resolve: {
          redirectTolinkAccount: ['$window', '$q', function ($window, $q) {
            $window.open('/consumer/self-serve/link-account', '_self');
            return $q.defer().promise;
          }]
        },
      },
      {
        name: 'ssoRegistration',
        url: '/sso/registration',
        resolve: {
          redirectTolinkAccount: ['$window', '$q', function ($window, $q) {
            $window.open('/plans/prepaid', '_self');
            return $q.defer().promise;
          }]
        },
      },
      {
        name: 'prepaidRegistration',
        url: '/prepaidregistration',
        resolve: {
          redirectTolinkAccount: ['$window', '$q', function ($window, $q) {
            $window.open('/plans/prepaid', '_self');
            return $q.defer().promise;
          }]
        },
      },
      {
        name: 'oneViewDashboard',
        url: '/oneViewDashboard',
        controller: 'MyrAccountOverviewController',
        controllerAs: 'ao',
        bindToController: true,
        templateUrl: 'scripts/modules/oneView/oneViewDashboard/oneViewDashboard.html',
        data: {
          _preConditions: {
            accountNumber: 0
          }
        },
        resolve: {
          globalloaderHandler: ['globalloaderService', function (globalloaderService) {
            globalloaderService.show();
          }],
          deepLinkingHandler: ['deeplink', function (deeplink) {
            return deeplink.redirectCheck(this.url.sourcePath);
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          ramPermissionProvider: ['ramPermission', 'ute.common.permissions.service', function (ramPermission, permissionsService) {
            ramPermission.getRepPermission(ute.common.permissions.service.RamResourceCodes.OneView, ute.common.permissions.service.RamActionCodes.read);
          }]
        },
        onEnter: ['localStorage', 'appInterface', 'globalloaderService',
          function (localStorage, appInterface, globalloaderService) {
            this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
            appInterface.stateEnter('/oneViewDashboard');
            globalloaderService.hide();
          }
        ],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/oneViewDashboard');
        }]
      },
      // Pages that require login
      {
        name: 'accountOverview',
        url: '/accountOverview',
        controller: 'MyrAccountOverviewController',
        controllerAs: 'ao',
        bindToController: true,
        templateUrl: 'scripts/modules/accountOverview/accountOverview.html',
        data: {
          _preConditions: {
            accountNumber: 0
          }
        },
        resolve: {
          globalloaderHandler: ['globalloaderService', function (globalloaderService) {
            globalloaderService.show();
          }],
          deepLinkingHandler: ['appState', 'deeplink', 'permissionResolver', 'ute.common.user.service', 'localStorage', '$window', 'sessionStorage',
            function (appState, deeplink, permissionResolver, userService, localStorage, $window, sessionStorage) {
              //This 'if' block is written as part of EasyLogin II project.
              if (!userService.isSigned()) {
                //This method is for deeplinking legacy URL's
                deeplink.accountOverviewCheck();
                //This method retrives token from wcoc portal stores it in session storage as localstorage is getting cleared
                deeplink.settingWcocJwtTokenValue();
              }

              var url = this.url.sourcePath;
              return deeplink.redirectCheck(this.url.sourcePath).then(function () {
                  return permissionResolver.getPermission(url);
                }
              );

            }]
        },
        onEnter: ['localStorage', 'appInterface', 'globalloaderService',
          function (localStorage, appInterface, globalloaderService) {
            this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
            appInterface.stateEnter('/accountOverview');
            globalloaderService.hide();

          }
        ],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/accountOverview');
        }]
      },
      {
        name: 'shmdashboard',
        url: '/shmdashboard',
        controller: 'MyrShmDashboardController',
        templateUrl: 'scripts/modules/smartHomeMonitoring/shmDashboard.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          redirectToCHC: ['$window', '$q', function ($window, $q) {
            $window.open('/home/myrogers/legacy/smart-home', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/shmdashboard');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/shmdashboard');
        }]
      },
      {
        name: 'tvdashboard',
        url: '/tvdashboard',
        controller: 'MyrTvDashboardController',
        controllerAs: 'tvDb',
        templateUrl: 'scripts/modules/tvDashboard/tvdashboard.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          redirectToCHC: ['$window', '$q', function ($window, $q) {
            $window.open('/home/myrogers/legacy/tv', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/tvdashboard');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/tvdashboard');
        }]
      },
      {
        name: 'internetdash',
        url: '/internetdash',
        controller: 'MyrInternetDashboardController',
        controllerAs: '$ctrl',
        templateUrl: 'scripts/modules/internetDashboard/internetDashboard.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', 'deeplinkProductChecker', function (permissionResolver, deeplinkProductChecker) {
            return permissionResolver.getPermission(this.url.sourcePath)
              .then(function () {
                return deeplinkProductChecker.hasProduct(6);
              });
          }],
          redirectToCHC: ['$window', '$q', function ($window, $q) {
            $window.open('/home/myrogers/legacy/internetdash', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/internetdash');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/internetdash');
        }]
      },
      {
        name: 'sso',
        url: '/sso/login/:token?:lang&:target',
        controller: ['ssoService', '$stateParams', function(ssoService, $stateParams){
          ssoService.reset();
          ssoService.startProcess($stateParams);
        }]
      },
      {
        name: 'rhpdashboard',
        url: '/rhpdashboard',
        controller: 'MyrRhpDashboardController',
        controllerAs: 'rhpDb',
        templateUrl: 'scripts/modules/rhpDashboard/rhpDashboard.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }],
          redirectToCHC: ['$window', '$q', function ($window, $q) {
            $window.open('/home/myrogers/legacy/home-phone', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/rhpdashboard');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/rhpdashboard');
        }]
      },
      {
        name: 'wireless',
        url: '/wireless',
        controller: 'MyrWirelessDashboardController',
        controllerAs: 'wdController',
        templateUrl: 'scripts/modules/wirelessDashboard/wirelessDashboard.html',
        data: {
          _preConditions: {
            accountNumber: 0,
            phoneNumber: 0
          }
        },
        resolve: {
          redirectToSelfServe: ['$window', '$q', function ($window, $q) {
            $window.open('/consumer/self-serve/wireless', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['localStorage', 'appInterface', 'globalloaderService', function (localStorage, appInterface, globalloaderService) {
          this.data._preConditions.phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
          this.data._preConditions.accountNumber = localStorage.getLocalStorageValue('accountNumber');
          appInterface.stateEnter('/wireless');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/wireless');
        }]
      },
      {
        name: 'wirelessPrepaid',
        url: '/wirelessPrepaid',
        resolve: {
          redirectToSelfServe: ['$q', '$window', function ($q, $window) {
            $window.open('/consumer/self-serve/overview', '_self');
            return $q.defer().promise;
          }]
        },
      },
      {
        name: 'paynow',
        url: '/paynow',
        resolve: {
          redirectToSelfServe: ['$q', '$window', function ($q, $window) {
            $window.open('/consumer/self-serve/payments/pay', '_self');
            return $q.defer().promise;
          }]
        },
      },
      // {
      //   name: 'paynowInterac',
      //   url: '/paynow/:submodule',
      //   controller: 'MyrPayNowController',
      //   templateUrl: 'scripts/modules/payNow/payNow.html',
      //   resolve: {
      //     deepLinkingHandler: ['deeplink', function (deeplink) {
      //       deeplink.internal();
      //     }],
      //     permissionData: ['permissionResolver', function (permissionResolver) {
      //       return permissionResolver.getPermission(this.url.sourcePath);
      //     }],
      //     dtmEnabled: function () {
      //       return true;
      //     }
      //   },
      //   onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
      //     appInterface.stateEnter('/paynow');
      //     globalloaderService.hide();
      //   }],
      //   onExit: ['appInterface', function (appInterface) {
      //     appInterface.stateExit('/paynow');
      //   }]
      // },
      {
        name: 'changemethod',
        url: '/changemethod',
        controller: 'MyrChangePaymentMethodController',
        templateUrl: 'scripts/modules/changePaymentMethod/changePaymentMethod.html',
        resolve: {
          redirectToSelfServe: ['$q', '$window', function ($q, $window) {
            $window.open('/consumer/self-serve/payments/auto', '_self');
            return $q.defer().promise;
          }]
          // deepLinkingHandler: ['deeplink', function (deeplink) {
          //   deeplink.internal();
          // }],
          // permissionData: ['permissionResolver', 'ute.common.user.service', '$location', '$q', function (permissionResolver, userService, $location, $q) {
          //   return permissionResolver.getPermission(this.url.sourcePath).then(function () {
          //     var defer = $q.defer();
          //     if (userService.getUserType() === 'consumer') {
          //       $location.path('profile/self-serve-payment-info');
          //     } else {
          //       defer.resolve();
          //     }
          //     return defer.promise;

          //   });
          // }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/changemethod');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/changemethod');
        }]
      },
      {
        name: 'paymenthistory',
        url: '/paymenthistory',
        controller: 'MyrPaymentHistoryController',
        templateUrl: 'scripts/modules/paymentHistory/paymentHistory.html',
        resolve: {
          // deepLinkingHandler: ['deeplink', function (deeplink) {
          //   deeplink.internal();
          // }],
          // permissionData: ['permissionResolver', function (permissionResolver) {
          //   return permissionResolver.getPermission(this.url.sourcePath);
          // }]
          redirectToSelfServe: ['$window', '$q', function ($window, $q) {
            $window.open('/consumer/self-serve/payments/history', '_self');
            return $q.defer().promise;
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/paymenthistory');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/paymenthistory');
        }]
      },
      {
        name: 'deviceCatalog',
        url: '/deviceCatalog',
        controller: 'deviceCatalog',
        controllerAs: 'vm',
        templateUrl: 'scripts/modules/hup/deviceCatalog/deviceCatalog.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          brtUser: ['brtHandler', function (brtHandler) {
            return brtHandler.redirectHUPBRTUser(this.url.sourcePath);
          }]
        },
        onEnter: ['localStorage', 'appInterface', 'globalloaderService', function (localStorage, appInterface, globalloaderService) {
          appInterface.stateEnter('/deviceCatalog');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/deviceCatalog');
        }]
      },

      {
        name: 'deviceConfigure',
        url: '/deviceConfigure',
        controller: 'deviceConfigure',
        controllerAs: 'vm',
        templateUrl: 'scripts/modules/hup/deviceConfigure/deviceConfigure.html',
        resolve: {
          brtUser: ['brtHandler', function (brtHandler) {
            return brtHandler.redirectHUPBRTUser(this.url.sourcePath);
          }]
        }
      },
      // Not found and others
      {
        name: 'error404',
        url: '/error404',
        controller: 'pageNotFoundController',
        controllerAs: 'vm',
        templateUrl: 'views/404.html',
        resolve: {},
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/error404');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/error404');
        }]
      },
      {
        name: 'oops',
        url: '/oops',
        templateUrl: 'views/oops.html',
        resolve: {},
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/oops');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/oops');
        }]
      },
      {
        name: 'suspended',
        url: '/suspended',
        templateUrl: 'views/suspended.html',
        resolve: {},
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/suspended');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/suspended');
        }]
      },
      {
        name: 'oneViewInterface',
        url: '/oneViewInterface',
        controller: 'MyrOneViewInterfaceController',
        templateUrl: 'scripts/modules/oneView/oneViewInterface/oneViewInterface.html',
        onEnter: ['appInterface', function (appInterface) {
          appInterface.stateEnter('/oneViewInterface');
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/oneViewInterface');
        }]
      },
      {
        name: 'interaction',
        url: '/interaction?filter',
        templateUrl: 'scripts/modules/oneView/interaction/interactionDetails.html',
        resolve: {
          ramPermissionProvider: ['ramPermission', function (ramPermission) {
            ramPermission.getRepPermission(ute.common.permissions.service.RamResourceCodes.InteractionHistory, ute.common.permissions.service.RamActionCodes.read);
          }]
        },
        onEnter: ['appInterface', function (appInterface) {
          appInterface.stateEnter('/interaction');
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/interaction');
        }]
      },
      {
        name: 'actionsOffers',
        url: '/actionsOffers',
        templateUrl: 'views/offers-page.html',
        onEnter: ['appInterface', function (appInterface) {
          appInterface.stateEnter('/actionsOffers');
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/actionsOffers');
        }]
      },
      {
        name: 'orders',
        url: '/orders',
        controller: 'MyrOneViewOrdersController',
        controllerAs: 'ord',
        bindToController: true,
        templateUrl: 'scripts/modules/oneView/oneViewOrders/oneViewOrders.html',
        onEnter: ['appInterface', function (appInterface) {
          appInterface.stateEnter('/orders');
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/orders');
        }]
      },
      {
        name: 'reservedevice',
        url: '/reservedevice',
        controller: 'MyrReserveDeviceCtrl',
        templateUrl: 'scripts/modules/reserveDevice/reservedevice.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          permissionData: ['permissionResolver', function (permissionResolver) {
            return permissionResolver.getPermission(this.url.sourcePath);
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/reservedevice');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/reservedevice');
        }]
      },
      {
        name: 'discoveryPageNoLiveContentParam',
        url: '/discoveryPageNoLiveContent/:brand/:segment/:accountType/:productType/:pageFilter/:provinceCode/:lang',
        controller: 'MyrDiscoveryPageNoLiveContent',
        controllerAs: 'dpnlc',
        templateUrl: 'scripts/modules/discoveryPageNoLiveContent/discoveryPageNoLiveContent.partial.html',
        data: {
          security: {roles: ['public']},
        },
        resolve: {
          lang: ['$stateParams', function ($stateParams, ajax) {
            return $stateParams.lang;
          }],
          content: ['$stateParams', 'ajax', function ($stateParams, ajax) {
            var postData = {
              'brand': $stateParams.brand,
              'segment': $stateParams.segment,
              'accountType': $stateParams.accountType,
              'productType': $stateParams.productType,
              'pageFilter': $stateParams.pageFilter,
              'provinceCode': $stateParams.provinceCode
            };
            return ajax.getDiscoveryPageContent(postData);
          }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/discoveryPageNoLiveContent');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/discoveryPageNoLiveContent');
        }]
      }
    ];

    if (settings.enablePricePlanChanges) {
      allStates.push({
        name: 'ppc-singleline',
        url: '/ppc-singleline',
        onEnter: ['$window', function ($window) {
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.sessionStorage.setItem('ppc__dashboard', 'wirelessDashboard');
          $window.location.href = origin + '/web/totes/wireless-plan-change/#/choose-plan';
        }]
      });
      allStates.push({
        name: 'ppc-resume-order',
        url: '/ppc-resume-order',
        onEnter: ['$window', function ($window) {
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.sessionStorage.setItem('ppc__dashboard', 'wirelessDashboard');
          $window.location.href = origin + '/web/totes/wireless-plan-change/#/resume';
        }]
      });
      allStates.push({
        name: 'ppc-multiline-entry-2',
        url: '/ppc-multiline-entry-2',
        onEnter: ['$window', function ($window) {
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/totes/wireless-plan-change/#/change-share-plan';
        }]
      });
      allStates.push({
        name: 'ppc-multiline-step-1',
        url: '/ppc-multiline-step-1',
        onEnter: ['$window', function ($window) {
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/totes/wireless-plan-change/#/choose-share-plan';
        }]
      });
      allStates.push({
        name: 'ppc-multiline-step-2',
        url: '/ppc-multiline-step-2',
        onEnter: ['$window', function ($window) {
          var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          $window.location.href = origin + '/web/totes/wireless-plan-change/#/additional-line-options';
        }]
      });
      if (settings.enableSelfServe) {
        // a small tear falls from the side of the eye of the developer who programs by convention not configuration
        allStates.push({
          name: 'self-serve',
          url: '/profile',
          controller: 'selfServeCtrl as selfServe',
          templateUrl: 'views/selfServe/selfServe.html',
          resolve: {
            redirectToSelfServe: ['$window', '$q', 'ute.common.core.brtswitch.service', function ($window, $q, brtSwitchService) {
              return brtSwitchService.getValue('LEGACY_PROFILE_PAGE').then(function (useLegacyProfilePage) {
                if (!useLegacyProfilePage) {
                  $window.open('/consumer/self-serve/profile', '_self');
                  return $q.defer().promise;
                }
                return true;
              });
            }],
            deepLinkingHandler: ['deeplink', 'redirectToSelfServe',  function (deeplink, redirectToSelfServe) {
              deeplink.internal();
            }],
            permissionData: [
              'permissionResolver',
              '$translate',
              'ute.rogers.account.overview.factory',
              'redirectToSelfServe',
              'ute.data.manager.service',
              function (permissionResolver,
                        $translate,
                        accountOverviewSummary,
                        redirectToSelfServe,
                        dataManagerService) {
                return permissionResolver.getPermission(this.url.sourcePath).then(function () {
                  return accountOverviewSummary().getSelectedAccount().then(function (selectedAccount) {
                    if (selectedAccount && selectedAccount.accountTypeNumber === 1) {
                      dataManagerService.accountOverviewSummaryFactory({
                        accountNumber: selectedAccount.accountNumber,
                        accountTypeNumber: selectedAccount.accountTypeNumber,
                        language: $translate.use()
                      }).getAccountOverviewSummary().then(function (accountOverviewSummary) {
                        if (accountOverviewSummary.shareEverything) {
                          dataManagerService.setModel(dataManagerService.transformSummary(accountOverviewSummary, dataManagerService.getModel()));
                        }
                      });
                    }
                  });
                });
              }],
            ramPermissionProvider: ['ramPermission', 'redirectToSelfServe',  function (ramPermission, redirectToSelfServe) {
              ramPermission.getRepPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.read);
            }]
          }
        });
        allStates.push({
          name: 'self-serve-scroll',
          url: '/profile/:scrollToId',
          controller: 'selfServeCtrl as selfServe',
          templateUrl: 'views/selfServe/selfServe.html',
          resolve: {
            redirectToSelfServe: ['$window', '$q', 'ute.common.core.brtswitch.service', function ($window, $q, brtSwitchService) {
              return brtSwitchService.getValue('LEGACY_PROFILE_PAGE').then(function (useLegacyProfilePage) {
                if (!useLegacyProfilePage) {
                  $window.open('/consumer/self-serve/profile', '_self');
                  return $q.defer().promise;
                }
                return true;
              });
            }],
            deepLinkingHandler: ['deeplink', 'redirectToSelfServe',  function (deeplink, redirectToSelfServe) {
              deeplink.internal();
            }],
            permissionData: [
              'permissionResolver',
              '$translate',
              'ute.rogers.account.overview.factory',
              'redirectToSelfServe',
              'ute.data.manager.service',
              function (permissionResolver,
                        $translate,
                        accountOverviewSummary,
                        redirectToSelfServe,
                        dataManagerService) {
                return permissionResolver.getPermission(this.url.sourcePath).then(function () {
                  return accountOverviewSummary().getSelectedAccount().then(function (selectedAccount) {
                    if (selectedAccount && selectedAccount.accountTypeNumber === 1) {
                      dataManagerService.accountOverviewSummaryFactory({
                        accountNumber: selectedAccount.accountNumber,
                        accountTypeNumber: selectedAccount.accountTypeNumber,
                        language: $translate.use()
                      }).getAccountOverviewSummary().then(function (accountOverviewSummary) {
                        if (accountOverviewSummary.shareEverything) {
                          dataManagerService.setModel(dataManagerService.transformSummary(accountOverviewSummary, dataManagerService.getModel()));
                        }
                      });
                    }
                  });
                });
              }],
            ramPermissionProvider: ['ramPermission', 'redirectToSelfServe', function (ramPermission, redirectToSelfServe) {
              ramPermission.getRepPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.read);
            }]
          }
        });
      }
    }

    _.each(allStates, function (v) {
      $stateProvider.state(v);
    });
  }]);

'use strict';

var btnStatus = {
    visible: 0,
    hidden: 1,
    disabled: 2,
    names: {
        0: 'Visible',
        1: 'Hidden',
        2: 'Disabled'
    }
};

var subMenuItems = {
    overview: 0,
    billingAndPayment: 1,
    services: 2,
    profile: 3,
    guestoverview: 4,
    interaction: 5,
    actionsOffers: 6,
    orders: 7,
    names: {
        0: 'Overview',
        1: 'Billing & Payment',
        2: 'Services',
        3: 'Profile'
    }
};

var maintenanceValues = {
    ACCOUNT_OVERVIEW_ON_MAINTENANCE: 0,
    HOME_PHONE_ON_MAINTENANCE: 1,
    INTERNET_ON_MAINTENANCE: 2,
    RSHM_ON_MAINTENANCE: 3,
    SITE_ON_MAINTENANCE: 4,
    TV_ON_MAINTENANCE: 5,
    WIRELESS_ON_MAINTENANCE: 6,
    WIRELESS_PREPAID_ON_MAINTENANCE: 7,
    names: {
        0: 'ACCOUNT_OVERVIEW_ON_MAINTENANCE',
        1: 'HOME_PHONE_ON_MAINTENANCE',
        2: 'INTERNET_ON_MAINTENANCE',
        3: 'RSHM_ON_MAINTENANCE',
        4: 'SITE_ON_MAINTENANCE',
        5: 'TV_ON_MAINTENANCE',
        6: 'WIRELESS_ON_MAINTENANCE',
        7: 'WIRELESS_PREPAID_ON_MAINTENANCE'
    }
};

var permissionValues = {
    CHANGE_FEATURES_ON_WIRELESS_DASHBOARD: 0,
    CHANGE_MY_PLAN_TV: 1,
    CHANGE_PAYMENT_METHOD: 2,
    CHANGE_PLAN_ON_WIRELESS_DASHBOARD: 3,
    REDEEM_LOYALTY_POINTS: 4,
    SHOW_ADD_ONS_TV: 5,
    UPDATE_MY_FAB_CONTACT_ON_WIRELESS_DASHBOARD: 6,
    VIEW_ACCOUNT_BALANCE: 7,
    VIEW_ACCOUNT_DETAILS: 8,
    VIEW_LOYALTY_POINTS: 9,
    names: {
        0: 'CHANGE_FEATURES_ON_WIRELESS_DASHBOARD',
        1: 'CHANGE_MY_PLAN_TV',
        2: 'CHANGE_PAYMENT_METHOD',
        3: 'CHANGE_PLAN_ON_WIRELESS_DASHBOARD',
        4: 'REDEEM_LOYALTY_POINTS',
        5: 'SHOW_ADD_ONS_TV',
        6: 'UPDATE_MY_FAB_CONTACT_ON_WIRELESS_DASHBOARD',
        7: 'VIEW_ACCOUNT_BALANCE',
        8: 'VIEW_ACCOUNT_DETAILS',
        9: 'VIEW_LOYALTY_POINTS'
    }
};

angular
    .module('totesApp')
    .config(['$httpProvider',
      '$logProvider',
      '$compileProvider',
      '$mdThemingProvider',
      function($httpProvider,
               $logProvider,
               $compileProvider,
               $mdThemingProvider) {
        // debug logs/ debug info must be disabled in production
        $logProvider.debugEnabled(false);
        $compileProvider.debugInfoEnabled(false);
        $httpProvider.useApplyAsync(true);
        $mdThemingProvider.disableTheming();
        // TODO: Move this logic to provider
        $httpProvider.defaults.retryOnFail = {
            retryCondition: function(error) {
                return (((error.status <= 0) || (error.status === 400)) &&
                    /ipad|iphone/i.test(window.navigator.platform) &&
                    /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion))
                );
            },
            1: {
                timeDelay: 500
            },
            2: {
                timeDelay: 1000
            },
            3: {
                timeDelay: 2000
            }
        };
    }])
    .constant('jQuery', $)
    .constant('settings', {
        supportedLanguages: {
            en: 'English',
            fr: 'Français'
        },
        defaultLanguage: 'en',
        isDevBB: window.location.host.match('dev') || window.location.host.match('totes') || window.location.host.match('localhost.rogers.com'),
        isQaBB: window.location.host.match('qa'),
        isProdBB: window.location.host.match('www.rogers.com'),
        devMode: true,
        omitPagesFromGlobalLoader: [''],
        useLocalAPI: false,
        reviewLink: {
            en: 'https://www.rogers.com/web/support/supportbillingpayment',
            fr: 'https://www.rogers.com/web/support/supportbillingpayment/setLanguage=fr'
        },
        chatLink: {
            en: 'http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701',
            fr: 'http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?hm=n&s=751'
        },
        chatLinkChangeModem: {
            en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=16&lctc=16%7C01%7Cws%7Cchange_my_modem_en',
            fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=66&lctc=66%7C01%7Cws%7Cchange_my_modem_fr'
        },
        chatLinkChangePlan: {
            en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en ',
            fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr'
        },
        chatLinkModules: {
            payment: {
                en: 'http://www.rogershelp.com/customerserv/credops_landing.php?hm=n&s=203',
                fr: 'http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253'
            }
        },
        chatLinkHup: {
            en: 'http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&lctc=707%7C01%7Cws%7CHUP_landing%20en',
            fr: 'http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr'
        },
        agentInfo: {
            heartbeatURL: 'shop/cfa/o/logout-keep-alive',
            signoutURL: 'shop/home',
            sspDashboardURL: 'shop/cfa/ssp-ute-interface',
            careTimeout: 45,
            dealerTimeout: 15,
            sspHomeURL: 'shop/cfa/home'
        },
        britebill: {
            local: 'https://qa2.invoiceportal.rogers.com/'
        },
        salesForceUrl: {
            dev: 'https://uat.config.cs7.force.com/',
            qa: 'https://uat.config.cs7.force.com/',
            prod: 'https://rogersprod.secure.force.com/'
        },
        revolutionExternalLinks: {
            spotify: {
                en: {
                    qa: 'https://www.spotify.com/ca-en/download/',
                    prod: 'https://www.spotify.com/ca-en/download/'
                },
                fr: {
                    qa: 'https://www.spotify.com/ca-fr/download/',
                    prod: 'https://www.spotify.com/ca-fr/download/'
                }
            },
            nextissue: {
                en: {
                    qa: 'https://staging-secure.nextissue.ca/',
                    prod: 'https://www.nextissue.ca/en/'
                },
                fr: {
                    qa: 'https://staging-secure.nextissue.ca/',
                    prod: 'https://www.nextissue.ca/fr/'
                }
            }
        },
        revolutionLink: '/web/totes/plans/#/manage-your-experience',
        revolutionSegmentNumber: 6,
        revolutionPermissionName: 'VIEW_ACCOUNT_BALANCE',
        revolutionAddNhl: false,
        revolutionGetOffersPrefix: '/web/RogersServices.portal/totes/api',
        revolutionGetOffers: 'v1/offer-status', //'http://10.10.94.138:9000/selfserve/v1/offer-status',
        oneViewRevolutionGetOffersPrefix: '/web/totes/api',
        permittedDomains: ['netflix.com'],
      redeemPoints: 400,
      usageLimit: 75,
      msInDay: 1000 * 60 * 60 * 24,
      //The maximum amount user can pay is the due amount + paymentMaximum.
      paymentMaximum: 1000,
      //payment history list: pagesPerSection is the number of pages each pagination section can display. itemsPerPage is the number of records per page.
      paymenthistory: {
        pagesPerSection: 5,
        itemsPerPage: 10
      },
      //creditCardField for semafone
      iframeParameters: {
        en: 'Credit Card Number',
        fr: 'Num%26eacute%3Bro de carte de cr%26eacute%3Bdit' //Numéro de carte de crédit (encoded)
      },
      // Show all failures in a overlay box message
      showErrorPopup: false,
      // secure vs. unsecure path calls
      devServerURL: 'https://www.dev18.rogers.com', //'http://10.10.47.23:8033', // https://www.dev17.rogers.com if you are on localhost this will prepend to your URLs


        unProtectedUrlPrefix: '/web/totes/api/v1/', // secureCallDefault = false
        protectedUrlPrefix: '/web/RogersServices.portal/totes/api/v1/', // secureCallDefault = true
        tvLandingUrlPrefix: '/web/RogersServices.portal/totes/connectedhome/v1/', // for tvLanding API migration

        //userType constants
        userType: {
            dealer: 'dealer',
            care: 'care',
            consumer: 'consumer'
        },
        //oneView Error Code Constants
        oneViewStatusCodes: {
            sspSSOFailure: 'SSP_SSO_FAILURE',
            crmSSOFailure: 'CRM_SSO_FAILURE',
            sspAccessFailure: 'SSP_ACCESS_FAILURE',
            crmAccessFailure: 'CRM_ACCESS_FAILURE',
            fidoAccessFailure: 'FIDO_ACCESS_FAILURE',
            crmServiceFailure: 'CRM_SERVICE_FAILURE',
            sspServiceFailure: 'SSP_SERVICE_FAILURE',
            sessionTimeout: 'SESSION_TIMEOUT',
            crmSignout: 'CRM_SIGN_OUT',
            fraudCheck: 'FRAUD_CUSTOMER',
            creditOps: 'CREDIT_OPS_FAILURE',
            businessAccessFailure: 'BUSINESS_ACC_ACCESS_FAILURE',
            igniteNACAccessFailure: 'ACCESS_FAILURE_IGNITE',
            igniteNACContactInfoMissing: 'PARAMS_MISSING_IGNITE',
            igniteNACGenericError: 'GENERIC_ERROR_IGNITE'
        },

        deepLinkStatusCodes: {
            transStatusSuccess: 'SUCCESS',
            transStatusError: 'ERROR',
            changeCTN: 'Change CTN',
            changeSIM: 'SIM/IMEI Change',
            changePricePlan: 'Priceplan Change',
            manageAddon: 'Manage Add-ons',
            updateVoiceMailPassword: 'Reset Voicemail',
            upgradeDevice: 'HUP',
            addaLineShared: 'Add Subscriber - Shared',
            addaLineIndividual: 'Add Subscriber - Individual',
            hupCancellation: 'HUP Cancellation',
            getWireless: 'Create Wireless Account'
        },
        //defaultForRetailandCare:'DefaultForRetailandCare',

        //TBD figure out how to find My5 add-on
        my5soc: 'MY5 Talk',
        myVM: 'VM',
        //!!! secureCallDefault - By default all calls are treated as secure -> true, pages and calls listed will be resolved into unsecure -> false

        // Default value to decide if call should be to [unProtectedUrlPrefix] OR [protectedUrlPrefix]
        secureCallDefault: true,
        // Pages listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
        // array values are module name
        secureCallPages: [
            'home',
            'signin',
            'signin/resetPassword',
            'registration',
            'registrationNoEmailVerify',
            'forgetPassword',
            'forgetusername',
            'invalidPath',
            'demo',
            'permissionDenied',
            'tpsc'
        ],
        // Ajax call functions listed in this array will overide [secureCallDefault] to value of FALSE and will therefore use [unProtectedUrlPrefix]
        // array values are relative paths from the ajax.post call
        // secureCalls: ['wirelessDashBoard', 'profile/question'],		// Example
        unprotectedCalls: [
            'testlogin',
            'signin',
            'signin/resetPassword',
            'profile',
            'register',
            'discardAllSmCookies',
            'profile/question',
            'forgot/username',
            'forgot/password/resubmit',
            'forgot/password',
            'maintenanceSettings',
            'discovery-page/get-content'
        ],
        protectedCalls: [
            'permissions',
            'cart/fetch'
        ],
        // Pages listed in this array will use URL provided as an overide to URLs provided by default (key/value type of arrangement)
        // key = module name
        moduleCallException: {
            // 'linkaccount': '/web/RogersServices.portal/api/v1/'		// Example
        },
        // Ajax call functions listed in this array will use overide value from this array. (key/value type of arrangement)
        // key = relative parh from the ajax.post call  (payment/decrypt IS VALID as array key)
        ajaxCallException: {
            'loggedIn': '/web/RogersServices.portal/totes/api/v1/loggedIn',
            'signin': '/siteminderagent/forms/login.fcc',
            'accountoverview': '/web/RogersServices.portal/totes/api/v1/accountoverview',
            'profile/checkComplete': '/web/RogersServices.portal/totes/api/v1/profile/checkComplete',
            'ebu/nickname': '/web/RogersServices.portal/totes/api/v1/ebu/nickname',
            'usernameMigration/check': '/web/RogersServices.portal/totes/api/v1/usernameMigration/check',
            'wcoc/decryptjwttoken': '/web/RogersServices.portal/totes/api/v1/wcoc/decryptjwttoken'
        },
        // Page login - list pages that need to be login protected
        // THIS IS DIFFERENT from secure / unsecure calls above
        pageLoginRequired: {
            //false - means all users / public
            'home': false,
            'registration': false,
            'signin': false,
            'signin/resetPassword': false,
            'forgetPassword': false,
            'forgetusername': false,
            'invalidPath': false,
            'demo': false,
            'permissionDenied': false,
            'underMaintenance': false,
            'tpsc': false,
            'uaa': false,
            'discoveryPageNoLiveContentParam': false,
            //true - means only for logged-in users
            'guestOverview': true,
            'guestoverview': true,
            'linkaccount': true,
            'accountSelector': true,
            'accountOverview': true,
            'paymenthistory': true,
            'paynow': true,
            'migrateuser': true,
            'changemethod': true,
            'wireless': true,
            'tvdashboard': true,
            'internetdash': true,
            'shmdashboard': true,
            'viewbill': true,
            'wireless-plan-change': true,
            'review-order': true,
            'confirm-order': true,
            'completeProfile': true,
            'reservedevice': true,
            'profile': true,
            'deviceConfigure': true,
            'deviceCatalog': true,
            'rhpdashboard': true,
            'oneViewInterface': false,
            'uteOneviewEnvPage': false
        },
        btnSettings: [{
                accountStatus: 'Suspended',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.disabled,
                dashboardLinks: btnStatus.disabled,
                otherAvailableServices: btnStatus.disabled,
                paymenthistory: btnStatus.visible,
                changePaymentMethod: btnStatus.visible,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.hidden,
                totalPoints: btnStatus.visible,
                earnedPoints: btnStatus.visible,
                allSubscriptions: btnStatus.disabled,
                accOverviewEnroll: btnStatus.visible,
                internetPackageLinks: btnStatus.visible,
                //modemDescription:btnStatus.visible,
                internetModemLinks: btnStatus.visible,
                changeModemLink: btnStatus.visible,
                changeModemLinkMessage: btnStatus.hidden,
                changeTVPackageSection: btnStatus.visible,
                infoMessageBox: btnStatus.hidden
            },
            {
                accountStatus: 'Cancelled',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.hidden,
                dashboardLinks: btnStatus.hidden,
                otherAvailableServices: btnStatus.hidden,
                paymenthistory: btnStatus.visible,
                changePaymentMethod: btnStatus.hidden,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.visible,
                totalPoints: btnStatus.hidden,
                earnedPoints: btnStatus.hidden,
                allSubscriptions: btnStatus.hidden,
                accOverviewEnroll: btnStatus.visible,
                internetPackageLinks: btnStatus.visible,
                // modemDescription:btnStatus.visible,
                internetModemLinks: btnStatus.visible,
                changeModemLink: btnStatus.visible,
                changeModemLinkMessage: btnStatus.hidden,
                changeTVPackageSection: btnStatus.visible,
                infoMessageBox: btnStatus.hidden
            },
            {
                accountStatus: 'Deactive',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.hidden,
                dashboardLinks: btnStatus.hidden,
                otherAvailableServices: btnStatus.hidden,
                paymenthistory: btnStatus.visible,
                changePaymentMethod: btnStatus.hidden,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.visible,
                totalPoints: btnStatus.hidden,
                earnedPoints: btnStatus.hidden,
                allSubscriptions: btnStatus.hidden,
                accOverviewEnroll: btnStatus.visible,
                internetPackageLinks: btnStatus.visible,
                // modemDescription:btnStatus.visible,
                internetModemLinks: btnStatus.visible,
                changeModemLink: btnStatus.visible,
                changeModemLinkMessage: btnStatus.hidden,
                changeTVPackageSection: btnStatus.visible,
                infoMessageBox: btnStatus.hidden
            },
            {
                accountStatus: 'CLMExceeded',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.disabled,
                dashboardLinks: btnStatus.disabled,
                otherAvailableServices: btnStatus.disabled,
                paymenthistory: btnStatus.visible,
                changePaymentMethod: btnStatus.visible,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.visible,
                totalPoints: btnStatus.visible,
                earnedPoints: btnStatus.visible,
                allSubscriptions: btnStatus.disabled,
                accOverviewEnroll: btnStatus.visible,
                internetPackageLinks: btnStatus.visible,
                // modemDescription:btnStatus.visible,
                internetModemLinks: btnStatus.visible,
                changeModemLink: btnStatus.visible,
                changeModemLinkMessage: btnStatus.hidden,
                changeTVPackageSection: btnStatus.visible,
                infoMessageBox: btnStatus.hidden
            },
            {
                accountStatus: 'DefaultForRetailandCare',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.hidden,
                dashboardLinks: btnStatus.hidden,
                otherAvailableServices: btnStatus.visible,
                paymenthistory: btnStatus.hidden,
                changePaymentMethod: btnStatus.visible,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.hidden,
                totalPoints: btnStatus.hidden,
                earnedPoints: btnStatus.hidden,
                allSubscriptions: btnStatus.hidden,
                accOverviewEnroll: btnStatus.hidden,
                internetPackageLinks: btnStatus.hidden,
                // modemDescription: btnStatus.hidden,
                internetModemLinks: btnStatus.hidden,
                changeModemLink: btnStatus.hidden,
                changeModemLinkMessage: btnStatus.visible,
                changeTVPackageSection: btnStatus.hidden,
                infoMessageBox: btnStatus.visible
            },
            {
                accountStatus: 'Default',
                viewBill: btnStatus.visible,
                payNow: btnStatus.visible,
                redeemEarnPoints: btnStatus.visible,
                dashboardLinks: btnStatus.visible,
                otherAvailableServices: btnStatus.visible,
                paymenthistory: btnStatus.visible,
                changePaymentMethod: btnStatus.visible,
                accountBalance: btnStatus.visible,
                paymentDueDate: btnStatus.visible,
                totalPoints: btnStatus.visible,
                earnedPoints: btnStatus.visible,
                allSubscriptions: btnStatus.visible,
                accOverviewEnroll: btnStatus.visible,
                internetPackageLinks: btnStatus.visible,
                // modemDescription:btnStatus.visible,
                internetModemLinks: btnStatus.visible,
                changeModemLink: btnStatus.visible,
                changeModemLinkMessage: btnStatus.hidden,
                changeTVPackageSection: btnStatus.visible,
                infoMessageBox: btnStatus.hidden
            }
        ],
        postSigninUrl: window.location.protocol + '//' + window.location.hostname + ((window.location.protocol === 'http' && window.location.port === '80') ||
            (window.location.protocol === 'https' && window.location.port === '443') ? '' : ':' + window.location.port) + '/web/RogersServices.portal/totes/#/accountOverview',
        postSigninUrlShort: '/web/totes/#/accountOverview',
        postSignOutUrl: '/web/totes/#/signin',
        postToRogersUrls: [
            { url: '/web/myrogers/viewBill' },
            { url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary' },
            { url: '/web/myrogers/prepaidTopUp' }
        ],
        oneViewExternalAPIs: {
            news: 'https://news-weather-feeds-prod.herokuapp.com/news/items?site=',
            weather: 'https://news-weather-feeds-prod.herokuapp.com/weather/entries?city='
        },
        newsAvailableProvinces: {
            ON: 'WWW_680NEWS_COM',
            BC: 'WWW_NEWS1130_COM',
            NS: 'WWW_NEWS957_COM',
            NB: 'WWW_NEWS957_COM',
            PE: 'WWW_NEWS957_COM',
            AB: 'WWW_660NEWS_COM',
            QC: 'WWW_LACTUALITE_COM',
            en: 'WWW_MACLEANS_CA',
            fr: 'WWW_LACTUALITE_COM'
        },
        // exceptional behaviour
        siteminderUrl: '/siteminderagent/forms/login.fcc', // Used in signin.js
        tempPasswordUrl: '/siteminderagent/forms/smpwservices.fcc',
        enablePricePlanChanges: true,
        enableSelfServe: true,
        // page that are mandatory to complete and should have all sub menus disabled
        mandatoryPages: [
            'migrateUser',
            'completeProfile'
        ],
        maxRetryOnExpired: 1,
        routingListToHideLiveContentHeader: ['forgotPasswordNoLivecontent', 'forgotUserNameNoLivecontent'],
        routingListToHideLiveContentFooter: ['forgotPasswordNoLivecontent', 'forgotUserNameNoLivecontent', 'shareEverything.accountsSummary'],

        // show the repview header and footer in the mentioned states
        showRepViewHeaderAndFooterStates: [
            'tvdashboard',
            'wireless',
            'internetdash',
            'oneViewDashboard',
            'interaction',
            'profile',
            'self-serve',
            'paynow',
            'changemethod',
            'paymenthistory',
            'simCard.start',
            'simCard.confirmation',
            'simCard.success',
            'viewbill',
            'suspendCtn.start',
            'suspendCtn.success',
            'reactivateCtn.success',
            'shareEverything.dashboard',
            'shareEverythingError',
            'oneViewInterface',
            'transferOfResponsibility.start',
            'transferOfResponsibility.stepOne/ctnSelection',
            'transferOfResponsibility.stepOne/eligibilityCheck',
            'transferOfResponsibility.stepTwo/futureOwnerInfo',
            'transferOfResponsibility.stepTwo/confirmation',
            'transferOfResponsibility.stepThree/subscriberDetails',
            'transferOfResponsibility.stepThree/currentOwnerInfo',
            'transferOfResponsibility.stepThree/eligibilityCheck',
            'transferOfResponsibility.stepFour',
            'creditAdjustmentDetails',
            'creditAdjustmentDetails.display',
            'ptp.start',
            'actionsOffers',
            'inbounds',
            'outbounds',
            'rhpdashboard',
            'orders'

        ],
        showCustomerViewToggleSwitchStates: [
            'accountOverview',
            'wireless',
            'internetdash',
            'tvdashboard',
            'interaction',
            'profile',
            'self-serve',
            'paynow',
            'changemethod',
            'paymenthistory',
            'simCard.start',
            'simCard.confirmation',
            'simCard.success',
            'viewbill',
            'suspendCtn.start',
            'suspendCtn.success',
            'reactivateCtn.success',
            'shareEverything.dashboard',
            'shareEverythingError',
            'oneViewInterface',
            'transferOfResponsibility.start',
            'transferOfResponsibility.stepOne/ctnSelection',
            'transferOfResponsibility.stepOne/eligibilityCheck',
            'transferOfResponsibility.stepTwo/futureOwnerInfo',
            'transferOfResponsibility.stepTwo/confirmation',
            'transferOfResponsibility.stepThree/subscriberDetails',
            'transferOfResponsibility.stepThree/currentOwnerInfo',
            'transferOfResponsibility.stepThree/eligibilityCheck',
            'transferOfResponsibility.stepFour',
            'creditAdjustmentDetails',
            'creditAdjustmentDetails.display',
            'ptp.start',
            'actionsOffers',
            'inbounds',
            'outbounds',
            'rhpdashboard'
        ],
        disableToggleSwitchStates: [
            'suspendCtn.start',
            'suspendCtn.success',
            'reactivateCtn.success',
            'interaction',
            'oneViewInterface',
            'transferOfResponsibility.start',
            'transferOfResponsibility.stepOne/ctnSelection',
            'transferOfResponsibility.stepOne/eligibilityCheck',
            'transferOfResponsibility.stepTwo/futureOwnerInfo',
            'transferOfResponsibility.stepTwo/confirmation',
            'transferOfResponsibility.stepThree/subscriberDetails',
            'transferOfResponsibility.stepThree/currentOwnerInfo',
            'transferOfResponsibility.stepThree/eligibilityCheck',
            'transferOfResponsibility.stepFour',
            'creditAdjustmentDetails',
            'creditAdjustmentDetails.display',
            'ptp.start',
            'simCard.start',
            'simCard.confirmation',
            'simCard.success',
            'actionsOffers',
            'inbounds',
            'outbounds'
        ],
        restCallRetry: {
            retryCondition: function (error) {
                return ((error.status <= 0) || (error.status === 400));
            },
            1: {
                timeDelay: 500
            },
            2: {
                timeDelay: 1000
            },
            3: {
                timeDelay: 2000
            }
        },
        formToRogersTemplate: 'scripts/modules/rogersForm/formToRogers.html',
        // rfrTwilightView: null,
        interactionsIconClassesMap: {
            'phone': 'interaction-call',
            'call': 'interaction-call',
            'e-chat': 'interaction-livechat',
            'rogers.com': 'interaction-web',
            'self serve': 'interaction-web',
            'ivr': 'interaction-web',
            'web': 'interaction-web',
            'mobile wallet': 'interaction-mobile-wallet',
            'store': 'interaction-store',
            'in person': 'interaction-store',
            'sms': 'interaction-sms',
            'mms': 'interaction-sms',
            'mail': 'interaction-outbound-mail',
            'e-mail': 'interaction-outbound-mail',
            'email': 'interaction-outbound-mail',
            'default': 'interaction-default-icon',
            'social media': 'interaction-default-icon',
            'fax': 'interaction-default-icon',
            'system': 'interaction-default-icon'
        },

        service: {
            wireless: 'service_wireless',
            suspended: 'Suspended'
        },
        contactNumbers: {
            billingIssue: '1 877 559-5202',
            billingIssueFr: '1 855 381-7841'
        },

        prepaidAccountViewBillUrl: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary'

    })
    .run(['$rootScope',
        'appState',
        'ute.blocks.language.switcher',
        'settings',
        '$browser',
        '$state',
        '$injector',
        'sessionStorage',
        '$location',
        'ute.common.user.service',
        'agentSession',
        'ml.utilitiesService',
        '$templateCache',
        function($rootScope,
            appState,
            languageSwitcher,
            settings,
            $browser,
            $state,
            $injector,
            sessionStorage,
            $location,
            userService,
            agentSession,
            utilitiesService,
            $templateCache) {
            var userType;

            moment.locale('en'); // setting default locale as english
            // Pre-set global variables
            $('html').attr('lang', languageSwitcher.getCurrentLanguage());
            $rootScope.$injector = $injector;
            //getting querystrings for making specific account call.
            $rootScope.isConsumer = true;
            $rootScope.isDealer = false;
            $rootScope.isCare = false;
            $rootScope.isOneViewInterface = false;
            $rootScope.userType = settings.userType.consumer;
            var queryStrings = appState.getQueryStrings();
            if (queryStrings !== '') {
                // this global variable is being used globally
                userType = $browser.cookies().userType;
                if (userType) {
                    $rootScope.isRepView = sessionStorage.getSessionStorageValue('isRepView');
                    if (userType === settings.userType.dealer) {
                        $rootScope.isDealer = true;
                        $rootScope.isConsumer = false;
                        $rootScope.userType = settings.userType.dealer;
                        if (!$rootScope.userInfo) {
                            console.log('calling startAgentSession');
                            agentSession.startAgentSession();
                        }
                    } else if (userType === settings.userType.care) {
                        $rootScope.isCare = true;
                        $rootScope.isConsumer = false;
                        $rootScope.userType = settings.userType.care;
                        if (sessionStorage.getSessionStorageValue('userType') === settings.userType.care && !$rootScope.userInfo) {
                            console.log('calling startCareSession');
                            agentSession.startCareSession();
                        }
                    }
                }
            }
            var link = $location.path();
            if (link === '/uteOneviewEnvPage') {
                userType = 'consumer';
                $browser.cookies('userType', userType);
                $rootScope.isCare = false;
                $rootScope.isDealer = false;
                $rootScope.isConsumer = true;
                $rootScope.userType = settings.userType.consumer;
                userService.signed({
                    userName: '',
                    userEmail: '',
                    userType: userType
                });
            }
            // initiate Account overview appState
            appState.aoInitiate();

            // Modal instance holder
            $rootScope.modal = null;


            //At the end of every stateChangeSuccess
            if(!($rootScope.isCare||$rootScope.isDealer)) {
            $rootScope.$on('$stateChangeSuccess', function(event, next, nextParams, current, currentParams) {
              utilitiesService.loadQualtrics();
            });
        }

            $rootScope.popUpOpened = false;
            $rootScope.popUpOpenedAndClosed = false;
            $rootScope.$on('$stateChangeStart', function(event, next) {
                if ($rootScope.modal !== null && $rootScope.modal !== undefined) {
                    //	$rootScope.modal.close('url');
                    $rootScope.modal.dismiss('cancel');
                    $rootScope.modal = null;
                }
                if ($rootScope.dialogPNSuccess) {
                    $rootScope.dialogPNSuccess.close();
                    $rootScope.dialogPNSuccess = undefined;
                }
                if ($rootScope.dialogPNFail) {
                    $rootScope.dialogPNFail.close();
                    $rootScope.dialogPNFail = undefined;
                }
                if ($rootScope.dialogPNCancel) {
                    $rootScope.dialogPNCancel.close();
                    $rootScope.dialogPNCancel = undefined;
                }
                /*if (next.url === '/oneViewInterface') {
                 $rootScope.isOneViewInterface = true;
                 $rootScope.isRepView = 'true';
                 }*/
                if ($rootScope.isDealer || $rootScope.isCare) {
                    if (next.url === '/oneViewInterface') {
                        $rootScope.isOneViewInterface = true;
                        //$rootScope.isRepView = 'true';
                    }
                    if (next.url === '/oneViewDashboard') {
                        $rootScope.isRepView = 'true';
                        sessionStorage.setSessionStorageValue('isRepView', true);
                    } else if (next.url === '/accountOverview') {
                        $rootScope.isRepView = 'false';
                        sessionStorage.setSessionStorageValue('isRepView', false);
                    }
                    $rootScope.toState = next.name;
                }
                if (next.redirectTo) {
                    event.preventDefault();
                    $state.go(next.redirectTo);
                }
            });

            $rootScope.errorMessagesMapping = [{
                    'page': 'linkaccount',
                    'field': 'accountNumber',
                    'required': 'linked_err_acc_num',
                    'pattern': 'linked_err_acc_num'
                },
                {
                    'page': 'linkaccount',
                    'field': 'postalCode',
                    'required': 'linked_err_postal',
                    'pattern': 'linked_acc_postalcode_invalid'
                },
                {
                    'page': 'linkaccount',
                    'field': 'phoneNumber',
                    'required': 'linked_acc_phone_invalid',
                    'pattern': 'linked_acc_phone_invalid'
                },
                {
                    'page': 'linkaccount',
                    'field': 'pinNumber',
                    'required': 'linked_acc_prepaid_pin',
                    'pattern': 'linked_acc_prepaid_pin'
                }
            ];

          $templateCache.put('template/carousel/carousel.html',
            '<div ng-mouseenter=\'pause()\' ng-mouseleave=\'play()\' class=\'carousel\' ng-swipe-right=\'prev()\' ng-swipe-left=\'next()\'>\n' +
            '    <a class=\'left carousel-control\' ng-click=\'prev()\' ng-show=\'slides.length > 1\' title="{{::\'carousel_modal.leftNav\' | translate}}"><span class=\'glyphicon glyphicon-chevron-left\'></span></a>\n' +
            '    <a class=\'right carousel-control\' ng-click=\'next()\' ng-show=\'slides.length > 1\' title="{{::\'carousel_modal.rightNav\' | translate}}"><span class=\'glyphicon glyphicon-chevron-right\'></span></a>\n' +
            '    <ol class=\'carousel-indicators\' ng-show=\'slides.length > 1\'>\n' +
            '        <li ng-repeat=\'slide in slides | orderBy:indexOfSlide track by $index\' ng-class=\'{active: isActive(slide)}\' title="{{\'carousel_modal.indicatorTitle\' | translate: { \'index\': $index + 1, \'total\': slides.length } }}" ng-click=\'select(slide)\'></li>\n' +
            '    </ol>\n' +
            '    <div class=\'carousel-inner\' ng-transclude></div>\n' +
            '</div>\n' +
            '');
        }
    ]);

/*
(function () {
'use strict';

  angular.module('totesApp').run(run);

  run.$inject = ['$rootScope', 'appState', 'agentSession', 'settings', '$browser', 'sessionStorage'];

  function run($rootScope, appState, agentSession, settings, $browser, sessionStorage) {
		  var cookies = $browser.cookies();
			var userType = cookies.userType;
      if(userType){
        if(userType === settings.userType.dealer && ! $rootScope.userInfo) {
            agentSession.startAgentSession();
        } else if(userType === settings.userType.care && sessionStorage.getSessionStorageValue('userType') === settings.userType.care && ! $rootScope.userInfo  ){
            agentSession.startCareSession();
        }
    }

    //$rootScope.$extend({
    //  //the view container
    //  page: function () {
    //    return 'views/page.html';
    //  },
    //  //the view body
    //  pageBody: function () {
    //    return appState.module ? 'views/{0}.html'.format(appState.module) : '';
    //  }
    //});
      }
})();

*/

'use strict';

angular.module('totesApp')
  .config(['$provide', function ($provide) {

    $provide.decorator('$exceptionHandler', ['$delegate', '$injector', function ($delegate, $injector) {
      return function (exception) {
        /*
         EvalError: Raised when the eval() functions is used in an incorrect manner.
         RangeError: Raised when a numeric variable exceeds its allowed range.
         ReferenceError: Raised when an invalid reference is used.
         SyntaxError: Raised when a syntax error occurs while parsing JavaScript code.
         TypeError: Raised when the type of a variable is not as expected.
         URIError: Raised when the encodeURI() or decodeURI() functions are used in an incorrect manner.
         Example:
         switch (exception.name) {
         case 'ReferenceError':

         break;
         case 'TypeError':

         break;
         }
         */

        /*
         // Manual error throwing - This Error handler can only receive a string. And therefore for more information to be passed in
         // objects have to converted into a string.
         // Example below.

         var testObj = {};
         testObj.message = 'User cannot continue to accountOverview';
         testObj.id = 42;
         var testJSON = angular.toJson(testObj);

         throw new Error(testJSON);
         //*/

        /*
         var user = $injector.get('user');
         if (!user.isLoggedIn) {
         user.logout();
         }
         //*/

        /*
         var stack = exception.stack.split('\n');
         var moduleName = stack[1];
         */
        function getDateTime() {
          var now = new Date();
          var year = now.getFullYear();
          var month = now.getMonth() + 1;
          var day = now.getDate();
          var hour = now.getHours();
          var minute = now.getMinutes();
          var second = now.getSeconds();

          month = (month.toString().length === 1) ? '0' + month : month;
          day = (day.toString().length === 1) ? '0' + day : day;
          hour = (hour.toString().length === 1) ? '0' + hour : hour;
          minute = (minute.toString().length === 1) ? '0' + minute : minute;
          second = (second.toString().length === 1) ? '0' + second : second;

          var dateTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second;
          return dateTime;
        }

        var appState = $injector.get('appState');
        var $rootScope = $injector.get('$rootScope');
        var $location = $injector.get('$location');

        $rootScope.errorsStack = $rootScope.errorsStack || [];

        var stack = (exception.stack) ? exception.stack.split('\n') : {};
        var url = $location.absUrl();
        var dateTime = getDateTime();

        //commented unused code
        // var accountInfo = {
        //   'accountNumber': ($rootScope.ao && $rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountNumber : undefined,
        //   'accountTypeNumber': ($rootScope.ao && $rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountTypeNumber : undefined,
        //   'accountStatus': ($rootScope.ao && $rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountStatus : undefined,
        //   'accountStatusSimple': ($rootScope.ao && $rootScope.ao.accountActive) ? $rootScope.ao.accountActive.accountStatusSimple : undefined
        // };

        var systemInfo = {
          appCodeName: navigator.appCodeName,
          appName: navigator.appName,
          appVersion: navigator.appVersion,
          cookieEnabled: navigator.cookieEnabled,
          platform: navigator.platform,
          userAgent: navigator.userAgent
        };

        var exceptionObject = {
          'dateTime': dateTime,
          'stack': stack,
          'url': url,
          'message': exception.message,
          'type': exception.name,
          'systemInfo': systemInfo
        };

        if ($location.path() !== '/oops') {
          $rootScope.errorsStack.push(exceptionObject);
        }

        $delegate(exception);
      };

    }]);

  }]);

'use strict';
/*
The directive for the <body> tag.
By checking the environment, this directive will insert class into the body for global css treatment.
 */
angular.module('totesApp')
    .directive('bodyClasses', ['ute.blocks.language.switcher', function (languageSwitcher) {
        return function(scope, element, attr){

            function update(lang){
                var newValue= lang;
                if(!newValue ) {
                    return false;
                }
                element.removeClass();
                var _ret='';
                _ret +=newValue;
                element.addClass(_ret);
            }
            //update(languageSwitcher.getCurrentLanguage());

          languageSwitcher.registerOnDataChangeHandler(update, 'bodyClassesLangSub');

          scope.$on('$destroy', function() {
            languageSwitcher.unregisterOnDataChangeHandler('bodyClassesLangSub');
          });
        };

    }]);

(function (angular, _, $) {

  'use strict';

  angular
    .module('totesApp')
    .directive('breakPoint', function () {
      return {
        restrict: 'E',
        scope: {},
        template: '<div class="breakpoint"><p class="xs"></p><p class="sm"></p><p class="md"></p><p class="lg"></p></div>',
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
          $scope.breakpoints = {
            xs: '',
            sm: '',
            md: '',
            lg: ''
          };
          $scope.currentBreakPoint = '';

          $scope.setBreakPoint = function (size, val) {
            if ($scope.breakpoints.hasOwnProperty(size)) {
              $scope.breakpoints[size] = val;
            }
          };

          $scope.fireBreakPointEvent = function (breakpoint) {
            $rootScope.$broadcast('breakpoint', breakpoint);
          };

          $scope.setCurrentBreakPoint = function (width) {
            var bp = '';
            if (width <= $scope.breakpoints.xs) {
              bp = 'xs';
            } else if (width > $scope.breakpoints.xs && width <= $scope.breakpoints.sm) {
              bp = 'sm';
            } else if (width > $scope.breakpoints.sm && width <= $scope.breakpoints.md) {
              bp = 'md';
            } else if (width > $scope.breakpoints.md) {
              bp = 'lg';
            }
            $scope.currentBreakPoint = bp;
            $rootScope.breakpoint = bp; // we also set the breakpoint on rootscope for access

            return $scope.currentBreakPoint;
          };
        }],
        link: function (scope, elem) {
          // get all the breakpoints from sass
          var xs = elem.find('.breakpoint > .xs').width(), // from sass variable
            sm = elem.find('.breakpoint > .sm').width(), // from sass variable
            md = elem.find('.breakpoint > .md').width(), // from sass variable
            lg = elem.find('.breakpoint > .lg').width(), // from sass variable
            currentWidth = elem.find('.breakpoint').width(), // from the media query
            currentBreakPoint;

          // populate the controllers scope with the breakpoints
          scope.setBreakPoint('xs', xs);
          scope.setBreakPoint('sm', sm);
          scope.setBreakPoint('md', md);
          scope.setBreakPoint('lg', lg);

          // set current size only when all breakpoints are set as
          // there is logic that depends on it
          currentBreakPoint = scope.setCurrentBreakPoint(currentWidth);

          // fire the breakpoint event on rootscope (this is the one that is on page load and not on resize)
          scope.fireBreakPointEvent(currentBreakPoint);

          // fire the breakpoint event on resize
          $(window).resize(_.debounce(function () {
            currentWidth = elem.find('.breakpoint').width();
            var prevBreakPoint = scope.currentBreakPoint;
            var currentBreakpoint = scope.setCurrentBreakPoint(currentWidth);
            if (prevBreakPoint !== currentBreakpoint) {
              scope.fireBreakPointEvent(currentBreakpoint);
            }
          }, 600));
        }
      };
    });
}(angular, _, $));


'use strict';
/*
This directive is placed on elements that have a class of 'cloaked' on them.
The cloaked class is intended to hide 'template flashing' in IE where the contents of the template are briefly
displayed before the content is loaded.
This directive removes the class when it loads (which is later than the flashing occurs)
 */
angular.module('totesApp')
    .directive('cloaker', [function () {
        return {
            restrict: 'A',
            link: function(scope, elem, attr){
                elem.removeClass('cloaked');
            }
        };

    }]);
'use strict';

angular.module('totesApp').directive('digitMask', function () {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, element, attr, ctrl) {
        function inputValue(val) {
          if (val) {
            var digits = val.replace(/[^0-9.,]/g, '');

            if (digits !== val) {
              ctrl.$setViewValue(digits);
              ctrl.$render();
            }
            var result = parseFloat(digits);
            return result;
          }
          return undefined;
        }
        ctrl.$parsers.push(inputValue);
      }
    };
 });

'use strict';

angular
        .module('totesApp')
        .directive('disableWhiteout', function () {
          return {
            restrict: 'AEC',
            controller: ['$scope', '$rootScope', function ($scope, $rootScope) {
              $scope.fireCloseEvent = function () {
                $rootScope.$broadcast('closeonresize');
              };
            }],
            link: function (scope, element, attrs) {
              var runOnce = false;
              // var element = element;      // WHY??? - Commenting this line out
              // var scope = scope;          // WHY??? - Commenting this line out
              
              $(window).resize(function () {
                if (runOnce === false) {
                  scope.fireCloseEvent();
                  runOnce = true; // only execute once;
                }
              });
            }
          };
        });

'use strict';
/*
 The directive for the <form> tag.
 Watching any changes in the form
 */
angular.module('totesApp')
  .directive('formChangeWatch', function() {

    return function (scope, el, attrs, ctrl) {
// console.log(el);
      el.$watch(el.$valid, function (newVal, oldVal) {
// console.log('newVal: ', newVal);
      }, true);

    };

});


'use strict';

angular
        .module('totesApp')
        .directive('formLocator', function () {
          return {
            link: function (scope) {
              scope.$emit('formLocator');
            }
          };
        });

// this directive can be used for all the in page popups which have to be closed when clicked outside the popup.
//pass the class name of the popup as well as the flag variable based on which the popup should be closed.
(function () {
    'use strict';
  
    angular.module('totesApp').directive('genericClosablePopup', genericClosablePopup);
  
    genericClosablePopup.$inject = ['ajax','$rootScope'];
  
    /* @ngInject */
    function genericClosablePopup(ajax,$rootScope) {
      var directive = {
          restrict: 'EA',
          scope: {
            openPopup:'=',
            popupClassName:'@',
            popupOpenTarget: '@',
            popupCloseTarget: '@'
          },
          template: '<ng-transclude></ng-transclude>',
          link: linkFunc,
          transclude: true
      };
      return directive;
  
      function linkFunc(scope, element, attrs) {
        document.addEventListener("click", function(event) {
            if(!scope.openPopup && event.target.id===scope.popupOpenTarget) {
                scope.openPopup = true;
                return;
            } else if(scope.popupCloseTarget && event.target.id === scope.popupCloseTarget) {
                scope.openPopup = false;
                return;
            }
            var isClickedElementChildOfPopup = event.target.closest(element[0].localName);

            if(!isClickedElementChildOfPopup && scope.openPopup) {
                scope.openPopup = false;
            }
        });
      }
    }
  })();
'use strict';

// More info on nested directives
// https://thinkster.io/egghead/directive-to-directive-communication/


angular
        .module('totesApp')
        .provider('globalloaderHandler', function () {
          var data;

          return {
            $get: function () {
              return data;
            },
            $set: function (value) {
              data = value;
            }
          };
        })
        .factory('globalloaderService', ['$rootScope', 'deeplink', '$log','$location','settings',
          function ($rootScope, deeplink, $log,$location,settings) {

            var globalloaderService = {};
            var aryOmittedPages = settings.omitPagesFromGlobalLoader;

            globalloaderService.omitFromPage = function(stPage){
              aryOmittedPages.push(stPage);
            };

            globalloaderService.getOmittedPages = function(){
              return aryOmittedPages;
            };

            globalloaderService.isCurrentPageOmitted = function(){

              var aryNonLoaderPages = globalloaderService.getOmittedPages();
              var stCurrentURL = $location.url();
              return (aryNonLoaderPages.indexOf(stCurrentURL) > -1);
            };

            globalloaderService.show = function () {
              if(!globalloaderService.isCurrentPageOmitted()) {
                $rootScope.$broadcast('showGlobalLoader');
              }
            };

            globalloaderService.hide = function () {
              if(!globalloaderService.isCurrentPageOmitted()) {
                if (deeplink.data.direction === 'out') {
                  // DO NOT shut down the loader image
                } else {
                  $rootScope.$broadcast('hideGlobalLoader');
                }
              }
            };

            return globalloaderService;
          }
        ])
        .directive('globalloader', function () {
          return {
            restrict: 'A',
            scope: {},
            link: function (scope, element, attrs) {
            },
            controller: ['$scope', '$rootScope', '$element', '$attrs', 'ute.blocks.language.switcher',
              function ($scope, $rootScope, $element, $attrs) {

                // Show hide functions
                $scope.initialLoader = function () {
                  // show loader section
                  $element.show();
                };

                // Show hide functions
                $scope.showLoader = function (type) {
                  if (type === 'loader') {
                    // show loader section
                    $element.show();
                  } else {
                    $element.hide();
                  }
                };

                $scope.hideLoader = function (type) {
                  if (type === 'loader') {
                    $element.hide();
                  } else {
                    $element.show();
                  }
                };

                // Show hide triggeres
                $rootScope.$on('showGlobalLoader', function () {                  // <<<<<<<<<<<<<<<<<<< CLEAN this from the rest of the code
                  $scope.showLoader($attrs.globalloader);
                });
                $rootScope.$on('hideGlobalLoader', function () {                  // <<<<<<<<<<<<<<<<<<< CLEAN this from the rest of the code
                  $scope.hideLoader($attrs.globalloader);
                });

                // decide which loader to show -> EN / FR
                $scope.initialLoader();
                // hide by default
                $scope.hideLoader($attrs.globalloader);
              }]

          };
        });

'use strict';

angular.module('totesApp')
	.directive('languageSelector',['settings', 'ute.blocks.language.switcher', '$browser',
	function (settings, languageSwitcher, $browser) {
		return {
			// scope: {},
			replace: true,
			templateUrl: 'views/languageSelector.html',
			restrict: 'E',
			link: function (scope, element, attrs) {
				scope.languages = settings.supportedLanguages;
				scope.selectedLanguage = languageSwitcher.getCurrentLanguage();

        scope.changeLanguage = function () {
					languageSwitcher.changeLanguage(scope.selectedLanguage);
					// $cookies.language = scope.selectedLanguage;
					//$browser.cookies('language', scope.selectedLanguage);
				};
			}
		};
	}]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // More info on nested directives
  // https://thinkster.io/egghead/directive-to-directive-communication/
  // <div livecontent="header" language="en" province="on"></div>

  angular.module('totesApp').factory('liveContentService',
      ['$rootScope',
        '$state',
        'settings',
        function ($rootScope,
                  $state,
                  settings) {

          return {
            showOrHideLiveContentHeader: showOrHideLiveContentHeader,
            showOrHideLiveContentFooter: showOrHideLiveContentFooter
          };

          /// Controlling the show or hide LIve Content from different route
          function showOrHideLiveContentHeader() {
            if (($rootScope.isCare || $state.current.name === 'oneViewInterface') && ($rootScope.isBusinessAccessFailure || $rootScope.isFidoAccessFailure)) {
              return false;
            }
            return !_.includes(settings.routingListToHideLiveContentHeader, $state.current.name);
          }

          function showOrHideLiveContentFooter() {
            if (($rootScope.isCare || $state.current.name === 'oneViewInterface') && ($rootScope.isBusinessAccessFailure || $rootScope.isFidoAccessFailure)) {
              return false;
            }
            return !_.includes(settings.routingListToHideLiveContentFooter, $state.current.name);
          }

        }])
      .directive('liveheader', ['ute.blocks.messages.bus.service', function (messagesService) {
        return {
          restrict: 'A',
          // scope: {},
          controller: ['$scope',
            '$rootScope',
            '$element',
            'settings',
            'user',
            'ute.blocks.language.switcher',
            'userProvince',
            '$browser',
            'appInterface',
            'localStorage',
            'ajax',
            'sessionStorage',
            'ute.common.permissions.service',
            'ute.common.user.service',
            '$http',
            '$locale',
            'ute.oneview.footer.service',
            'ute.common.utils.service',
            'ml.utilitiesService',
            function ($scope, // jshint ignore:line
                      $rootScope,
                      $element,
                      settings,
                      user,
                      languageSwitcher,
                      userProvince,
                      $browser,
                      appInterface,
                      localStorage,
                      ajax,
                      sessionStorage,
                      permissionsService,
                      userService,
                      $http,
                      $locale,
                      oneViewFooterService,
                      utilsService,
                      utilitiesService) {

              var selectedLanguage = languageSwitcher.getCurrentLanguage();
              var selectedProvince = userProvince();
              var hasHeaderCompLoaded = false;
              // Update functions
              function reloadHeaderDOM(forceRedraw) {
                var LCurl = '/cms/rogers/integration/header-new-' + selectedLanguage + '-' + selectedProvince.toLowerCase() + '.xml';
                $http.get(LCurl, {cache: true}).then(_.curry(processHeaderOk)(forceRedraw));
              }

              function processHeaderOk(forceRedraw, response) { // jshint ignore:line
                //Remove unwanted JS files. may cause issues is directly injected to html
                var parsedXMLResponse = $('<div/>').html(response.data);
                parsedXMLResponse.find('script').remove();
                $element.html(parsedXMLResponse.html());

                // login / logout links
                var newURL = '';
                var newID = '';
                var newText = '';
                var userID = '';
                var userCookie = '';
                var userType = $browser.cookies().userType;
                var language = $browser.cookies().language;
                var province = $browser.cookies().province;

                if (($rootScope.isDealer || $rootScope.isCare) && $rootScope.currentStateName === 'oneViewDashboard') {
                  $element.find('.directive-repview-header #header').css('position', 'fixed');
                  $element.find('div[data-liveheader] #header').hide();
                }
                if (($rootScope.isDealer || $rootScope.isCare) && $rootScope.currentStateName === 'accountOverview') {
                  $element.find('div[data-liveheader] #header').css('position', 'static');
                  $element.find('div[data-liveheader] #header').show();
                }

                if ($rootScope.isDealer || $rootScope.isCare) {
                  if ($rootScope.isRepView === 'true') {
                    $element.find('#header').find('#nav-main').find('#main-nav-item-3').attr({
                      href: '/web/totes/#/oneViewDashboard?lang=' + language + '&userType=' + userType + '&prov=' + province
                    });
                  } else {
                    $element.find('#header').find('#nav-main').find('#main-nav-item-3').attr({
                      href: '/web/totes/#/accountOverview?lang=' + language + '&userType=' + userType + '&prov=' + province
                    });
                    if ($('#toggleSwitch:hidden').length > 0) {
                      $('div[data-liveheader] #header').css('position', 'fixed');
                    } else {
                      $('div[data-liveheader] #header').css('position', 'static');
                    }

                  }
                  $element.find('#header').find('#nav-main')
                      .find('#main-nav-item-4, #main-nav-item-5, #main-nav-item-7').parent().addClass('headerLinkDisableLi');
                  $('.QSISlider').hide();
                }

                if (userService.isSigned()) {
                  // User is logged in
                  newURL = '#';
                  newID = 'logoutAction';

                  var userIDa = userService.getUser().userEmail;
                  var userIDb = $browser.cookies().SM_USER;

                  if (userIDa && userIDa !== '') {
                    userCookie = decodeURIComponent(userIDa);
                  } else if (userIDb && userIDb !== '') {
                    userCookie = decodeURIComponent(userIDb);		// localhost development
                  } else if (userType === settings.userType.dealer) {
                    userCookie = '';
                  } else if (userType === settings.userType.care) {
                    userCookie = '';
                  } else {
                    userCookie = '';
                  }

                  // User ID taken from the userID cookie
                  userID += '<span class="signedin">';
                  userID += '<a href="#/accountOverview">';
                  userID += '<i class="rui-icon-lock-small"></i>';

                  if (languageSwitcher.getCurrentLanguage() === 'fr') {
                    newText = 'Fermer la session <i style="font-size: 7px" class="rui-icon-arrow-right"></i>';
                    userID += '	<span>Bienvenue</span> ';
                  } else {
                    newText = 'Sign out <i style="font-size: 7px" class="rui-icon-arrow-right"></i>';
                    userID += '	<span>Welcome</span> ';
                  }
                  userID += '	<span id="user-name">' + userCookie + '</span></a>';
                  userID += '</span>';

                  $element.find('#dds_username').prepend(userID).find('a').last().attr({
                    href: newURL,
                    id: newID
                  }).html(newText);

                  utilsService.setElementScope($element, $scope);

                  // header class postlogin fix
                  $element.find('#header').removeClass('status-pre').addClass('status-post');

                } else {
                  // User needs to sign in
                  newURL = '#/signin';
                  newID = 'loginAction';

                  $element.find('#dds_username').find('a').last().attr({
                    href: newURL,
                    id: newID
                  });
                }

                // Language link
                var languageSelect = '';
                if (selectedLanguage === 'en') {
                  languageSelect += 'languageFrench';
                } else if (selectedLanguage === 'fr') {
                  languageSelect += 'languageEnglish';
                }
                $element.find('li.lang-toggle a').attr('id', languageSelect);
                $element.find('#skipNavigationDesktop div.dds-navbar-nav ul li.dds_o-navLinkList__item.loginStates.stateLoggedin ul li a').attr('id', 'logoutAction');
                $element.find('.dds-mobileNavCard ul.dds_o-mobileNavLinkList .loginStates > .dds_o-mobileNavDropdown li a').attr('id', 'logoutAction');
                utilsService.setElementScope($element, $scope);



               // utilsService.setElementScope($element.find('#languageFrench'), $scope);
                //utilsService.setElementScope($element.find('#languageEnglish'), $scope);

                // Provice abriviation indicator
                //$element.find('#province .dropdown-toggle').html(selectedProvince + ' <span class="caret"></span>');

                //utilsService.setElementScope($element.find('#province'), $scope);

                // Re-initiate header/footer functions
                // if (typeof (disableTypeaheadOnTotes) === 'function') {	// jshint ignore:line
                //   disableTypeaheadOnTotes(); // jshint ignore:line
                // }

                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                if (typeof (init_HTML) === 'function') { // jshint ignore:line
                  init_HTML(); // jshint ignore:line
                }
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                if (typeof (init_header) === 'function') { // jshint ignore:line
                  init_header(); // jshint ignore:line
                }
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                if (typeof (init_footer) === 'function') { // jshint ignore:line
                  init_footer(); // jshint ignore:line
                }
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                if (typeof (init_components) === 'function') { // jshint ignore:line
                  init_components(); // jshint ignore:line
                }
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

                // jscs:disable requireCamelCaseOrUpperCaseIdentifiers
                if (typeof accessibility !== "undefined" && typeof (accessibility.components_angular) === 'function') { // jshint ignore:line
                  accessibility.components_angular(); // jshint ignore:line
                }

                if(typeof ddsHead != undefined) {
                  if(hasHeaderCompLoaded) {
                      ddsHead.initializer();
                  }
                  else hasHeaderCompLoaded = true;
                }
                // jscs:enable requireCamelCaseOrUpperCaseIdentifiers

                // DEAD!!!  Was taken out of rui.js
                // if (typeof (disableTypeaheadOnTotes) === 'function') {
                //   disableTypeaheadOnTotes(); // jshint ignore:line
                // }
                // DEAD END!!!
              }

              $scope.executeLogOut = function () {
                if($rootScope.isDealer) {
                  /* To redirect the user to SSP dashboard */
                  //backToSSPService.backToSSP();
                  var cookies = $browser.cookies();
                  var language = cookies.language;
                  var province = cookies.province;
                  var postData = {
                    ctn: localStorage.getLocalStorageValue('phoneNumber'),
                    accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                    lang: language,
                    prov: province,
                    targetFlow: 'sspdashboard'
                  };
                  if (localStorage.getLocalStorageValue('toStateName') !== 'wireless') {
                    postData.ctn = '';
                  }
                  oneViewFooterService.backToSSP(postData).then(function (result) {
                      if (result !== false) {
                          if (result.isCableOnly) {
                              $('#footerFormToSSP').attr('action', result.envPath + settings.agentInfo.signoutURL);
                              $('#footerFormToSSP').submit();
                          } else {
                              $('#footerFormToSSP').find('#sharedKey').val(result.sharedKey);
                              $('#footerFormToSSP').find('#signature').val(result.signature);
                              $('#footerFormToSSP').find('#content').val(result.content);
                              $('#footerFormToSSP').attr('action', result.envPath +settings.agentInfo.sspDashboardURL);
                              $('#footerFormToSSP').submit();
                          }
                      } else {
                          $('#footerFormToSSP').attr('action', result.envPath + settings.agentInfo.signoutURL);
                          $('#footerFormToSSP').submit();
                      }
                  }).catch(function (result) {
                      $('#footerFormToSSP').attr('action', result.envPath + settings.agentInfo.signoutURL);
                      $('#footerFormToSSP').submit();
                  });
                } else {
                  user.logout(false, 'LOGOUT');
                }
              };
              $scope.languageToggle = function (lang) {

                if (selectedLanguage === lang) {
                  return;
                }
                // Set language
                selectedLanguage = lang;
                languageSwitcher.changeLanguage(selectedLanguage);

                // external functionality notification
                appInterface.fn.languageChange(selectedLanguage);
                $scope.switchTabWrap();

                $rootScope.$broadcast('languageChanged');

                // load the files
                reloadHeaderDOM(true);
                utilitiesService.loadQualtrics();

              };
              /*$scope.languageToFrench = function () {

                if (selectedLanguage === 'fr') {
                  return;
                }
                // Set language
                selectedLanguage = 'fr';
                languageSwitcher.changeLanguage(selectedLanguage);

                // external functionality notification
                appInterface.fn.languageChange(selectedLanguage);
                $scope.switchTabWrap();

                $rootScope.$broadcast('languageChanged');

                // load the files
                reloadHeaderDOM(true);
                utilitiesService.loadQualtrics();

              };
              $scope.languageToEnglish = function () {
                if (selectedLanguage === 'en') {
                  return;
                }
                // Set language
                selectedLanguage = 'en';
                languageSwitcher.changeLanguage(selectedLanguage);

                appInterface.fn.languageChange(selectedLanguage);
                $scope.switchTabWrap();

                // load the files
                $rootScope.$broadcast('languageChanged');
                // load the files
                reloadHeaderDOM(true);
                utilitiesService.loadQualtrics();
              };*/
              $scope.changeProvince = function (prov) {
                // Set province
                selectedProvince = prov;
                userProvince(prov);

                // external functionality notification
                appInterface.fn.provinceChange(selectedProvince);
                $scope.switchTabWrap();

                // load the files
                reloadHeaderDOM(true);
              };

              $scope.switchTabWrap = function () {
                // Right side feedback tab
                var domHolder = $element.find('#feedback-tab').find('a');
                var tabType = appInterface.feedbackTabType;
                if (typeof (switchTab) === 'function') {				// jshint ignore:line
                  switchTab(domHolder, tabType, selectedLanguage); // jshint ignore:line
                }
              };

              // Execute the update
              reloadHeaderDOM(false);

              $scope.$on('pageUserNameChanged', function () {
                reloadHeaderDOM(true);
              });

              messagesService.subscribe(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, function () {
                reloadHeaderDOM(true);
              });

              $scope.$on('user.logout.done', function () {
                reloadHeaderDOM(true);
              });


              /**
               * On Refresh in French locale is not setting correctly
               * If the selected Language does not matching the locale
               * then set the language to the right
               */
              if (!$locale.id.startsWith(selectedLanguage)) {
                languageSwitcher.changeLanguage(selectedLanguage);
              }
            }]
        };
      }])
      .directive('livefooter', function () {
        return {
          restrict: 'A',
          controller: ['$scope',
            '$element',
            'settings',
            'ute.blocks.language.switcher',
            'userProvince',
            'appInterface',
            '$rootScope',
            'ajax',
            'localStorage',
            'sessionStorage',
            '$http',
            function ($scope, // jshint ignore:line
                      $element,
                      settings,
                      languageSwitcher,
                      userProvince,
                      appInterface,
                      $rootScope,
                      ajax,
                      localStorage,
                      sessionStorage,
                      $http) { // jshint ignore:line

              var selectedLanguage;
              var selectedProvince;

              function reloadFooterDOM(forceRedraw) {
                selectedLanguage = languageSwitcher.getCurrentLanguage();
                selectedProvince = userProvince();

                var LCurl = '/cms/rogers/integration/footer-new-' + selectedLanguage + '-' + selectedProvince.toLowerCase() + '.xml';
                $http.get(LCurl, {cache: true}).then(_.curry(processFooterOk)(forceRedraw));
              }

              function processFooterOk(forceRedraw, response) { // jshint ignore:line
                $element.html(response.data);
                // post-load action

                // Right side feedback tab
                var domHolder = $element.find('#feedback-tab').find('a');
                var tabType = appInterface.feedbackTabType;
                var language = languageSwitcher.getCurrentLanguage();
                var QSISlider = $('.QSISlider');

                if (typeof (switchTab) === 'function') { // jshint ignore:line
                  switchTab(domHolder, tabType, language); // jshint ignore:line
                }

                var stateName = localStorage.getLocalStorageValue('toStateName');
                if ($rootScope.isCare) {
                  stateName = sessionStorage.getSessionStorageValue('toStateName');
                }

                // Hiding feedback after signout. As rootScope is not available need to handle with stateName
                if (($rootScope.isDealer || $rootScope.isCare) || stateName === 'oneViewInterface' || true) { //Hiding the feedback tab all the time
                  $element.find('#feedback-tab').hide();
                  $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
                  QSISlider.hide();
                }
                //if(($rootScope.isDealer || $rootScope.isCare && $rootScope.currentStateName === 'oneViewDashboard')){
                if (($rootScope.isDealer || $rootScope.isCare && $rootScope.isRepView === 'true')) {
                  $element.find('div[data-livefooter]').hide();
                  $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
                  $element.find('#feedback-tab').hide();
                  QSISlider.hide();
                }
                QSISlider = null;
              }

              $scope.$on('languageChanged', function () {
                reloadFooterDOM(false);
              });

              $scope.$on('provinceChanged', function () {
                reloadFooterDOM(false);
              });

              // Execute the update
              reloadFooterDOM(false);
            }]
        };
      });

  // jQuery action binding
  var bodyElement = $('body');
  bodyElement.on('click', '#logoutAction', function (event) {
    event.preventDefault();			// Default action
    event.stopPropagation();		// Bubling
    //document.getElementById('logoutAction').scope().executeLogOut();
    this.href="#";
    $(event.currentTarget).parents("[data-liveheader]").get(0).scope().executeLogOut();
  });

  bodyElement.on('click', '#languageFrench, #languageEnglish', function (event) {
    event.preventDefault();			// Default action
    event.stopPropagation();		// Bubling
    var lang = event.currentTarget.id === 'languageEnglish' ? 'en' : 'fr';
    $('html').attr('lang', lang);
   // event.currentTarget.scope().languageToggle(lang);
    $(event.currentTarget).parents("[data-liveheader]").get(0).scope().languageToggle(lang);
  });

  bodyElement.on('click', '#province li a', function (event) {
    event.preventDefault();			// Default action
    event.stopPropagation();		// Bubling

    var linkID = event.currentTarget.id;
    if (linkID) {
      //document.getElementById('province').scope().changeProvince(linkID);
      $(event.currentTarget).parents("[data-liveheader]").get(0).scope().changeProvince(linkID);
    }
  });
  bodyElement = null;
}());

'use strict';

angular.module('totesApp')
	.directive('logoutButton', ['user', function (user) {
		return function (scope, $elem) {
			$elem.click(function () {
				scope.$apply(function () {
          console.log('logout button clicked');
					user.logout();
				});
			});
		};
	}]);

'use strict';

angular.module('totesApp')
  .directive('matchEmail', ['appState', function (appState) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        var scopewatch1 = scope.$watch('[regObj.email, confirmEmail]', function (newVal) {
          if (!!newVal[0] && !!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchEmail', currentValue);
          }
        });

        
        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch1();
        });

      }
    };
  }])

  .directive('matchEmailMu', ['appState', function (appState) {
    return {
      require: 'ngModel',
      link: function (scope, elem, attrs, ctrl) {
        var scopewatch2 = scope.$watch('[regObj.email, confirmEmail]', function (newVal) {
          if (!!newVal[0] && !!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchEmail', currentValue);
            appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_emails_donotmatch'}, {event15: ''}]);
          }
        });

        
        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch2();
        });

      }
    };
  }])
  .directive('matchPassword', function ($interpolate) {
    return {
      require: 'ngModel',
      scope: {
        password: '=',
        confirmpassword: '='
      },
      link: function (scope, elem, attrs, ctrl) {
        if (scope.hasOwnProperty('password') && scope.hasOwnProperty('confirmpassword')) {
          var scopewatch3 = scope.$watch('[password, confirmpassword]', function (newVal) {
            //if (!!newVal[0] && !!newVal[1]) {
            if (!!newVal[1]) {
              var currentValue = newVal[0] === newVal[1];
              // console.log(currentValue);
              ctrl.$setValidity('mismatchPassword', currentValue);
            }
          });
        }
        var scopewatch4 = scope.$watch('[regObj.password, regObj.confirmPassword]', function (newVal) {
          //if (!!newVal[0] && !!newVal[1]) {
          if (!!newVal[1]) {
            var currentValue = newVal[0] === newVal[1];
            ctrl.$setValidity('mismatchPassword', currentValue);
          }
        });

        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch3();
        });

      }
    };
  })
  .directive('compareTo', function () {
    return {
      require: 'ngModel',
      scope: {
        otherModelValue: '=compareTo'
      },
      link: function (scope, element, attributes, ngModel) {

        ngModel.$validators.compareTo = function (modelValue) {
          if (!modelValue && ngModel.$name === 'confirmEmail') {
            ngModel.$setValidity('mismatchPassword', true);
            return;
          }

          if (modelValue !== scope.otherModelValue && scope.otherModelValue) {
            ngModel.$setValidity('mismatchPassword', false);
            return false;
          } else if (modelValue === scope.otherModelValue) {
            ngModel.$setValidity('mismatchPassword', true);
            return true;
          }
        };

        var scopewatch5 = scope.$watch('otherModelValue', function () {
          ngModel.$validate();
        });

        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch5();
        });
      }
    };
  })

/**
 * Directive 'match' has been moved to ute-common-component-directive 'uteMatch'
 * Please replace match='model.name' to ute-match='model.name'
 */
  // .directive('match', function match($parse) {
  //   return {
  //     require: '?ngModel',
  //     restrict: 'A',
  //     link: function (scope, elem, attrs, ctrl) {
  //       if (!ctrl) {
  //         if (console && console.warn) {
  //           console.warn('Match validation requires ngModel to be on the element');
  //         }
  //         return;
  //       }

  //       var matchGetter = $parse(attrs.match);
  //       var caselessGetter = $parse(attrs.matchCaseless);
  //       var unMatch = $parse(attrs.unMatch);
  //       scope.$watch(getMatchValue, function () {
  //         ctrl.$$parseAndValidate();
  //       });

  //       ctrl.$validators.match = function () {
  //         var match = getMatchValue();
  //         if (caselessGetter(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)) {
  //           return ctrl.$viewValue.toLowerCase() === match.toLowerCase();
  //         }
  //         if (unMatch(scope) && angular.isString(match) && angular.isString(ctrl.$viewValue)) {
  //           return ctrl.$viewValue === '' || ctrl.$viewValue !== match;
  //         }
  //         return ctrl.$viewValue === match;
  //       };

  //       function getMatchValue() {
  //         var match = matchGetter(scope);
  //         if (angular.isObject(match) && match.hasOwnProperty('$viewValue')) {
  //           match = match.$viewValue;
  //         }
  //         return match;
  //       }
  //     }
  //   };
  // })
  .directive('truthTest', function match() {
    return {
      require: 'ngModel',
      restrict: 'A',
      link: function (scope, elem, attrs, ctrl) {
        var truthTest = attrs.truthTest == 'true';
        ctrl.$validators.invalidEmail = function (modelValue, viewValue) {
          return modelValue != 'E_BILL' || truthTest;
        };
      }
    };
  })
  .directive('matches', [function () {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function (scope, elm, attrs, ctrl) {
        if (!ctrl) {
          if (console && console.warn) {
            console.warn('Matchs validation requires ngModel to be on the element');
          }
          return;
        }
        ctrl.$parsers.unshift(function (viewValue) {

          var _target = _.get(scope,attrs.matches);

          var _matches = _target.$viewValue;

          if (_matches === viewValue) {
            ctrl.$setValidity('matches', true);
            return viewValue;
          } else {
            ctrl.$setValidity('matches', false);
            return undefined;
          }

        });
      }
    };
  }]);


(function () {
  'use strict';

  angular.module('totesApp').directive('myrCurrencyInput', currencyInput);

  currencyInput.$inject = ['$filter',
    '$browser',
    'currenciesConfig',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function currencyInput($filter,
                         $browser,
                         currenciesConfig,
                         languageSwitcher) {
    return {
      require: 'ngModel',
      link: function ($scope, $element, $attrs, ngModelCtrl) {

        $element.addClass('currencyInput');

        var separators = {
          'thousands': currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'thousandsDelimiter'),
          'decimal': currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'decimalDelimiter'),
          'prefix':currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'prefix'),
          'suffix':currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'suffix')
        };

        var maxDecimals = 2;

        var decimalEntered = false;

        var parse = function(data){
          data = data.split(separators.thousands).join('').split(separators.decimal).join('.').split(separators.prefix).join('').split(separators.suffix).join('').split('$').join('');
          return data;
        };

        var listener = function (e,reset) {

          var key = e ? e.which : 0;
          var decimals = 0;

          if(!reset){
            if (key == 0 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
              return;
            }
            if(key == 8 && $element.val().length == 1){
              return;
            }
          }

          if($element.val().indexOf(separators.decimal)>-1){
            decimals = $element.val().substr($element.val().indexOf(separators.decimal,0),$element.val().length).length-1;
            decimals = decimals - separators.suffix.length;
            decimals = decimals > maxDecimals ? maxDecimals : decimals;
          }

          if(key === 110){
            //decimal pressed
            return;
          }else{

            var value = parse($element.val());

            if(reset){
              separators = {
                'thousands': currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'thousandsDelimiter'),
                'decimal': currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'decimalDelimiter'),
                'prefix':currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'prefix'),
                'suffix':currenciesConfig.getProperty(languageSwitcher.getCurrentLanguage(),'suffix')
              };
            }

            if (decimalEntered) {
              decimalEntered = false;
              return;
            }

            $element.val($filter('currencies')(value, languageSwitcher.getCurrentLanguage(),undefined,decimals));

            var caretPos = $element.val().length - separators.suffix.length;
            $element[0].setSelectionRange(caretPos,caretPos);

          }

        };

        // This runs when we update the text field
        ngModelCtrl.$parsers.push(function (viewValue) {
          return parse(viewValue);
        });

        // This runs when the model gets updated on the scope directly and keeps our view in sync
        ngModelCtrl.$render = function () {
          if(ngModelCtrl.$viewValue){
            var decimals = 0;

            if(ngModelCtrl.$viewValue.indexOf('.')>-1){
              decimals = ngModelCtrl.$viewValue.substr(ngModelCtrl.$viewValue.indexOf('.',0),ngModelCtrl.$viewValue.length).length-1;
              //decimals = decimals - separators.suffix.length;
              decimals = decimals > maxDecimals ? maxDecimals : decimals;
            }
            $element.val($filter('currencies')(parse(ngModelCtrl.$viewValue), languageSwitcher.getCurrentLanguage(),undefined,decimals));
          }
        };

        $element.bind('keyup', listener);
        $element.bind('keypress', function (event) {
          var key = event.which;
          // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
          // This lets us support copy and paste too
          if (key == 0 || key == 8 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
            return;
          }
          // ignore all other keys which we do not need
          if (
            String.fromCharCode(key) != separators.thousands &&
            String.fromCharCode(key) != separators.decimal &&
            String.fromCharCode(key) != separators.prefix &&
            String.fromCharCode(key) != separators.suffix &&
            !(48 <= key && key <= 57) &&
            String.fromCharCode(key) != '-'
          ) {
            event.preventDefault();
            return;
          }
          if (String.fromCharCode(key) == separators.decimal) decimalEntered = true;
          $browser.defer(listener); // Have to do this or changes don't get picked up properly
        });

        $element.bind('paste cut', function () {
          $browser.defer(listener);
        });

        languageSwitcher.registerOnDataChangeHandler(function () {
          listener(null,true);
        }, 'myrCurrencyInputControllerLangSub');

        $scope.$on('$destroy', function() {
          languageSwitcher.unregisterOnDataChangeHandler('myrCurrencyInputControllerLangSub');
        });

      }
    };
  }

})();

'use strict';

//the this directive is to solve insufficiency of original directive ngForm/form and
//ngModel, add a $setAllDirty method to put 'ng-dirty' to input element
//and set ngModel of that element to $dirty(true)

//var formDirectiveBuilder = function (isNgForm) {
//    return function () {
//        return {
//            restrict: isNgForm ? 'EAC' : 'E',
//            require: 'form',
//            link: function postLink(scope, element, attrs, ngForm) {
//
//                ngForm.$setAllDirty = function () {
//                    this.$setDirty();
//                    for (var key in this) {
//                        var model = this[key];
//                        if (model && model.$name) {
//                            model.$dirty = true;
//                        }
//                    }
//                    element.find('[ng-model], [data-ng-model]').removeClass('ng-pristine').addClass('ng-dirty');
//                };
//            }
//        };
//    };
//};
//
//angular.module('totesApp')
//    .directive('form', formDirectiveBuilder())
//    .directive('ngForm', formDirectiveBuilder(true));
//
//formDirectiveBuilder = null;

//angular.module('totesApp')
//    .directive('ngModel', function () {
//        return function (scope, $elem, attrs) {
//
//            $elem.keyup(function (e) {
//
//                if (e.which == 13) {
//                    e.preventDefault();
//                    e.stopImmediatePropagation();
//                    return false;
//                }
//            });
//
//        };
//    });
'use strict';

/*Directive to implement Owl carousel


 How to implement?
 Example:
<div>
<data-owl-carousel class="owl-carousel">                          // Wrap all the items of carousel inside this directive data-owl-carousel
<div owl-carousel-item="" ng-repeat="item in items" class="item">...</div> // Iterating through the items using ng-repeat <div>.....</div>                                                // content(items inside carousel) which is repeated goes into this div
</data-owl-carousel>
</div>

*/

angular.module('totesApp')
  .directive('owlCarousel',[function() {
    return {
      restrict: 'E',
      transclude: false,
      link: function (scope) {
        scope.initCarousel = function(element) {
          // provide any default options you want
          var defaultOptions = {
            items:1,
            itemsDesktop:[1199,1],
            itemsDesktopSmall:[979,1],
            itemsTablet:[768,1],
            itemsMobile:[479,1],
            navigation: true,
            pagination: true,
            rewindNav : false,
            responsive:true,
            navigationText:['<','>']
          };
          var customOptions = scope.$eval($(element).attr('data-options'));
          // combine the two options objects
          for(var key in customOptions) {
            defaultOptions[key] = customOptions[key];
          }
          // init carousel

          $(element).owlCarousel(defaultOptions);


        };
      }
    };
  }])
  .directive('owlCarouselItem', [function() {
    return {
      restrict: 'A',
      transclude: false,
      link: function(scope, element) {
        // wait for the last item in the ng-repeat then call init
        if(scope.$last) {
          scope.initCarousel(element.parent());
        }
      }
    };
  }]);

'use strict';

// More info on nested directives
// https://thinkster.io/egghead/directive-to-directive-communication/


angular.module('totesApp')
  .directive('permission', function () {
    return {
      restrict: 'A',
      controller: ['$scope', '$rootScope', 'appState', '$element', '$attrs', function ($scope, $rootScope, appState, $element, $attrs) {
        $scope.myFlag = $attrs.permission;
        $scope.shomi = false;

        $scope.runner = function () {
          $scope.shomi = false;			// reset

          // Find if listed
          if ($scope.myFlag !== '') {
            $scope.shomi = appState.permissionTo($scope.myFlag);
          }

          // Remove from DOM
          if ($scope.shomi) {
            // Show
            $element.show();
          } else {
            // Hide
            $element.hide();
          }
        };
        $scope.runner();


// 				// Test functions for two way communication - See accountBalance.js to see how to set that up
// 				this.checkFlags = function () {
// // console.log ('Yo... permission directive here!!!');
// 				};
// 				this.passFlags = function (pass) {
// // console.log ('passFlags', pass);
// 				};


        var accountWatcher = $rootScope.$watch('ao.accountDetails.accountNumber', function (newVal, oldVal) {
          $scope.runner();
        }, true);

        var permissionWatcher = $rootScope.$watch('permissions.permissionActive', function (newVal, oldVal) {
          $scope.runner();
        }, true);

        $scope.$on('$destroy', function () {
          if (accountWatcher) {
            accountWatcher();
          }

          if (permissionWatcher) {
            permissionWatcher();
          }
        });

      }]
    };
  });

'use strict';

//<a tab-link="model|news|selected">
//<a tab-link="model|news">
angular.module('totesApp')
    .directive('tabLink', ['$parse', function ($parse) {
        return function (scope, $elem, attrs) {

            var parts = attrs.tabLink.split('|');
            var modelExpression = parts[0];
            var tabId = parts[1];
            var selectedClass = parts[2] || 'selected';

            $elem.click(function () {
                scope.$apply(function () {
                    $parse(modelExpression).assign(scope, tabId);
                });
            });

            var scopewatch1 = scope.$watch(modelExpression, function (value) {
                if (value === tabId) {
                    $elem.addClass(selectedClass);
                } else {
                    $elem.removeClass(selectedClass);
                }
            });

            //n Remove any watchers 
            scope.$on('$destroy', function () {
                scopewatch1();
            });

        };
    }]);

'use strict';

//<div tab-view="appState.module|dashboard|active">
angular.module('totesApp')
    .directive('tabView', function () {
        return function (scope, $elem, attrs) {

            var parts = attrs.tabView.split('|');
            var modelExpression = parts[0];
            var tabId = parts[1];
            var selectedClass = parts[2] || 'selected';

            var scopewatch1 = scope.$watch(modelExpression, function (value) {
                if (value === tabId) {
                    $elem.addClass(selectedClass);
                } else {
                    $elem.removeClass(selectedClass);
                }
            });

            //n Remove any watchers 
            scope.$on('$destroy', function () {
                scopewatch1();
            });

        };
    });

'use strict';

angular
        .module('totesApp')
        .directive('toggleClass', function () {
          return {
            restrict: 'A',
            link: function (scope, element, attrs) {
              element.bind('click', function () {
                element.toggleClass(attrs.toggleClass);
              });
            }
          };
        });

'use strict';
/*
The directive to toggle 'touched' class of the element upon mouse clicking.
 */
angular.module('totesApp')
    .directive('touched', function () {
        return function($scope, $element, attr){

/*            function addClass(){
              $element.toggleClass('touched');
            }*/
/*            function removeClass(){
              $element.toggleClass('touched');
            }*/
/*          var $body = $('body');
          $element.bind( 'click', addClass);
          $body.bind( 'click', addClass);*/

          /*if (!('ontouchstart' in document.documentElement)) {
            document.documentElement.className += ' no-touch';
            $element.addClass('touch');
          }else{
            $element.addClass('no-touch');
          }*/
          $element.bind('touchstart',function(e){
            e.stopPropagation();
            $element.addClass('touch');
           // $body.insert
          });
          var $body = $('body');
          $body.bind('touchstart',function(){
            $element.removeClass('touch');
          });
        };

    });

'use strict';
/*
The directive to tag the validation error of a form field.
use as:
 <input type="text" validation-tag tag-form-name="form" tag-page-name="Registration" name="email" id="email" />
 once the inline validation error occurs, the error object will be tagged through appState service.
 */
angular.module('totesApp')
    .directive('validationTag', ['appState', function (appState) {
        return function($scope, $element, attrs){
          var _formName = attrs.tagFormName;
          var _pageName = attrs.tagPageName || 'unknown_page';
          var _fieldName = attrs.name || attrs.id || 'unknown_field';
          if( !_formName ){
            return;
          }
          var _form = $scope[attrs.tagFormName];
          function getValidity(){
            //return $element.$error;
            return _form[attrs.name].$error;
          }
          //check the form field error type and tag it.
          var scopewatch1 = $scope.$watch( getValidity, function(newVal, oldVal) {
            if( !newVal || $( newVal).length <=0){
              return;
            }

            appState.tagFieldValidationErrors ( _pageName, _fieldName,  newVal  );

          }, true);

          //n Remove any watchers 
          $scope.$on('$destroy', function () {
            scopewatch1();
          });

        };

    }]);

'use strict';
// Filter to change decimal point into comma for french numbers
angular.module('totesApp').
  filter('bilingualnumber', ['$filter', 'ute.blocks.language.switcher', function($filter, languageSwitcher) {
    return function(input, scope) {
      var value     = $filter('number')(input,2),
          language  = languageSwitcher.getCurrentLanguage();
      if (value && language !== 'en'){
        value = value.replace('.',',');
      }
      return value;
    };
  }]);

'use strict';

angular.module('totesApp').
  filter('capitalize', function() {
    return function(input, scope) {
	    if (input  && input.length > 0) {
	    	input = input.toLowerCase();
	    	return input.substring(0,1).toUpperCase()+input.substring(1);
	    } else {
	    	return;
	    }
	  };
  });
 


'use strict';

angular
  .module('totesApp')
  .filter('centsWithDecimal', function () {
    return function (input, showDefault) {
      if (!input) {
        if(showDefault) {
          return '00';
        } else {
          return '';
        }
      }

      if(input === 0) {
        if(showDefault) {
          return '00';
        } else {
          return '';
        }
      }

      var inputRemainder = parseFloat(input) % 1;
      var costInCents = inputRemainder.toFixed(2).substring(1);

      return costInCents;
    };
  });

'use strict';

angular
  .module('totesApp')
  .filter('currencies', ['currenciesConfig', function (currenciesConfig) {
    return function (input, lang, prefixOverride, deci) {

      var defaultInput = 0;
      var defaultDeci = 2;
      var defaultLang = 'en';

      input = (typeof input === 'undefined') ? defaultInput : input;
      deci = (typeof deci === 'undefined') ? defaultDeci : deci;
      lang = (typeof lang === 'undefined') ? defaultLang : lang;

      var prefix = (lang === 'en' && prefixOverride) ? prefixOverride : null;

      if (isNaN(input * 1)) {
        return currenciesConfig.format(lang, input, prefix);
      } else {

        var pow = Math.pow(10, deci);
        var amt = parseFloat(Math.round(input * pow) / pow).toFixed(deci);

        return currenciesConfig.format(lang, amt, prefix);
      }

    };
  }]);

'use strict';

angular.module('totesApp').
  filter('date2',['util', function (util) {
    return function (input, delimiter, separator, yearPrefix, aryOrder) {

      var monthsNames = util.getMonthsNames();
      var months = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
        Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      function formatMonthCheck(val){
        if(val === 0){
          return monthsNames[months[arrDate[val]]];
        }else{
          return arrDate[val];
        }
      }

      if (!input) {
        return '';
      }

      var arrDate = input.split(delimiter);

      return (formatMonthCheck(aryOrder[0]) +
      separator + formatMonthCheck(aryOrder[1]) +
      separator + yearPrefix + formatMonthCheck(aryOrder[2]));

    };
  }]);

'use strict';

angular.module('totesApp').
  filter('date3',[ function () {
    return function (input) {

      var nextbilldaysuntil = '';
      if (input) {
        var stringArray = input.split('-');

        var months = {
          'Jan': 0,
          'Feb': 1,
          'Mar': 2,
          'Apr': 3,
          'May': 4,
          'Jun': 5,
          'Jul': 6,
          'Aug': 7,
          'Sep': 8,
          'Oct': 9,
          'Nov': 10,
          'Dec': 11
        };

        var dueMonth = months[stringArray[0]];
        var dueDay = parseInt(stringArray[1]);
        var dueYear = parseInt(stringArray[2]) + 2000;

        var nextBillDate = new Date(dueYear, dueMonth, dueDay, 0, 0, 0, 0);

        var currectDate = new Date();
        nextbilldaysuntil = ' ' + Math.floor((nextBillDate - currectDate) / 86400000);
      } else {
        nextbilldaysuntil = 'N/A';
      }

      return nextbilldaysuntil;
    };
  }]);

(function () {

  'use strict';

  angular.module('totesApp').filter('dateFormat', ['$translate', 'util', function ($translate, util) {
    return function (input, format) {

      var monthsNames = util.getMonthsNames();
      var monthsShortNames = $translate.instant('_monthShort');

      var convertedDateTime = new Date(input);

      // Check input DateTime string
      if (isNaN(convertedDateTime.getTime())) {
        // If input is not a valid DateTime format then return empty string
        return '';
      } else {
        if (format === undefined || (format && format.length === 0)) {
          return convertedDateTime.toDateString();
        } else {

          var yyyy = convertedDateTime.getFullYear();
          var monthAryNumber = convertedDateTime.getMonth();
          var dateNumber = convertedDateTime.getDate();

          // Convert Month and Date number to 1 or 2 digit string
          var monthString = (monthAryNumber < 9) ? '0' + (monthAryNumber + 1) : (monthAryNumber + 1);
          var dateString = (dateNumber < 10) ? '0' + dateNumber : dateNumber;

          return format
              .replace('YYYY', '%yyyy%')
              .replace('MMMM', '%mmmm%')
              .replace('MMM', '%mm%')
              .replace('MM', '%mm%')
              .replace('M', '%m%')
              .replace('DD', '%dd%')
              .replace('D', '%d%')
              .replace('%yyyy%', yyyy)
              .replace('%mmmm%', monthsNames[monthAryNumber])
              .replace('%mm%', monthsShortNames[monthAryNumber])
              .replace('%MM%', monthString)
              .replace('%m%', monthAryNumber + 1)
              .replace('%dd%', dateString)
              .replace('%d%', dateNumber);
        }
      }

    };
  }]);

})();

'use strict';

angular
  .module('totesApp')
  .filter('decimals', ['$filter', 'currenciesConfig', function ($filter, currenciesConfig) {
    return function (input, lang) {

      if (input) {

        input = $filter('number')(input, 2);

        if (lang === 'fr') {
          input = input.toString().replace(',', '.');
        }
        var pos = input.toString().lastIndexOf('.');
        var langDec = currenciesConfig.getProperty(lang, 'decimalDelimiter');

        if (pos > -1) {
          return (langDec + input.toString().substr(pos + 1, input.length)).toString();
        } else {
          return (langDec + '00').toString();
        }
      }
    };
  }]);

'use strict';

angular
  .module('totesApp')
  .filter('dollarsOnly', function () {
    return function (input, showDefault) {
      if (!input) {
        if(showDefault) {
          return '0';
        } else {
          return '';
        }
      }

      if(input === 0) {
        if(showDefault) {
          return '0';
        } else {
          return '';
        }
      }

      return parseInt(input);
    };
  });

'use strict';

angular.module('totesApp').
  filter('escapeHtml', function() {
  	return function(text) {
//	console.log('text:' + text);
	    if (text) {
//	console.log('text:' + text);
	    return text.
	        replace(/&/g, '&amp;').
	        replace(/</g, '&lt;').
	        replace(/>/g, '&gt;').
	        replace(/'/g, '&#8216;').
	        replace(/'/g, '&#8217;');
		  }
		  return '';
		};
  });



'use strict';

angular.module('totesApp').
	filter('formatCtn', function() {
		return function(ctn) {
    		if(ctn !== null && ctn !== '') {
    			var formattedCtn = ''+ctn.substring(0,3)+' ' + ctn.substring(3,6)+ '-' + ctn.substring(6,10) ;
    			return formattedCtn;
    		} else {
    			return ctn;
    		}
    	};
	});

'use strict';

angular.module('totesApp')
  .filter('floor', function() {
    return function(n) {
      return Math.floor(n);
    };
  });

'use strict';

angular.module('totesApp').
	// split a phone number and add THREE dashes 416-555-5656
	filter('phone', function () {
		return function (input) {

			if (!input) {
				return '';
			}

			// int -> string + cleanup
			var inputStr = input.toString().trim().replace(/^\+/, '');

			// Split
			var area = inputStr.slice(0, 3);
			var trip = inputStr.slice(3, 6);
			var quad = inputStr.slice(6);

			// Pretty phone number
			var retVal = area +'-'+ trip +'-'+ quad;

			return (retVal);
		};
	}).
	// split a phone number and add TWO dashes 416 555-5656
  filter('phone2', function() {
    return function (input) {

      if (!input) {
        return '';
      }

      // int -> string + cleanup
      var inputStr = input.toString().trim().replace(/^\+/, '');

      // Split
      var area = inputStr.slice(0, 3);
      var trip = inputStr.slice(3, 6);
      var quad = inputStr.slice(6);

      // Pretty phone number
      var retVal =  area + ' ' + trip + '-' + quad;

      return (retVal);
    };
  }).// split a phone number and add TWO dashes (416) 555-5656
  filter('phone3', function() {
    return function (input) {

      if (!input) {
        return '';
      }

      // int -> string + cleanup
      var inputStr = input.toString().trim().replace(/^\+/, '');

      // Split
      var area = inputStr.slice(0, 3);
      var trip = inputStr.slice(3, 6);
      var quad = inputStr.slice(6);

      // Pretty phone number
      var retVal =  '(' + area + ') ' + trip + '-' + quad;

      return (retVal);
    };
  }).filter('phoneWithSpaces', function() { // split a phone number and add TWO spaces 416 555 5656
    return function (input) {

      if (!input) {
        return '';
      }

      // int -> string + cleanup
      var inputStr = input.toString().trim().replace(/^\+/, '');

      // Split
      var area = inputStr.slice(0, 3);
      var trip = inputStr.slice(3, 6);
      var quad = inputStr.slice(6);

      // Pretty phone number
      var retVal =  area + ' ' + trip + ' ' + quad;

      return (retVal);
    };

  });


'use strict';

angular.module('totesApp').
  filter('replace', function () {
    return function (input,_replace, _with) {
      if (!!input) {
        return input.replace(_replace, _with);
      } else {
        return;
      }
    };
  });

'use strict';

angular
  .module('totesApp')
  .filter('slice', function() {
    return function(arr, start, end) {
      return (arr || []).slice(start, end);
    };
  });

(function(){
        'use strict';
        angular.module('totesApp').filter('srcResolver' , srcResolver);
        srcResolver.$inject = ['$sce'];
        function srcResolver($sce){
            return function(url) {
                return $sce.trustAsResourceUrl(url);
            };
        }
}
)();

'use strict';

angular
  .module('totesApp')
  .filter('splice', function () {
    return function (input,start,end) {
      if(input){
        input = input.toString();
        input = input.substr(start,end);

        return input;
      }
    };
  });

'use strict';

angular.module('totesApp').
	filter('trustHtml', function ($sce) {
		return function (input) {
      return $sce.trustAs('html', input);
		};
	});

(function() {

  'use strict';
  angular.module('totesApp').filter('unlimitedUsage', unlimitedUsage);

  unlimitedUsage.$inject = ['$filter', '$translate'];

  function unlimitedUsage($filter, $translate) {
    var number = $filter('number');
    return function(minutes) {
      if (minutes >= 0) {
        return number(minutes);
      } else {
        return $translate.instant('wireless_unlimited');
      }
    };
  }
})();

'use strict';
var omnp = omnp || [];
window.addOmnp=function(options){
  try {
    omnp.push(options);
  } catch (e) {
    console.error('Error adding OMNP ' + e );
  }
};

'use strict';

angular.module('totesApp').run(['$rootScope', function ($rootScope) {

    angular.extend($rootScope.constructor.prototype, {
        $extend: function (extension) {
            angular.extend(this, extension);
            return this;
        }
    });

}]);

/**
 * Created by OlgaN on 9/14/2015.
 */
/* UAParser.js
 * Lightweight JavaScript-based User-Agent String Parser */
// jshint ignore: start
'use strict';
 (function (window, undefined) {

  var LIBVERSION = '0.7.1', EMPTY = '', UNKNOWN = '?', FUNC_TYPE = 'function', UNDEF_TYPE = 'undefined', OBJ_TYPE = 'object', MAJOR = 'major', MODEL = 'model', NAME = 'name', TYPE = 'type', VENDOR = 'vendor', VERSION = 'version', ARCHITECTURE = 'architecture', CONSOLE = 'console', MOBILE = 'mobile', TABLET = 'tablet', SMARTTV = 'smarttv';
  var util = {
    extend: function (regexes, extensions) {
      for (var i in extensions) {
        if ('browser cpu device engine os'.indexOf(i) !== -1 && extensions[i].length % 2 === 0) {
          regexes[i] = extensions[i].concat(regexes[i])
        }
      }
      return regexes
    }, has: function (str1, str2) {
      if (typeof str1 === 'string') {
        return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1
      }
    }, lowerize: function (str) {
      return str.toLowerCase();
    }
  };
  var mapper = {
    rgx: function () {
      for (var result, i = 0, j, k, p, q, matches, match, args = arguments; i < args.length; i += 2) {
        var regex = args[i], props = args[i + 1];
        if (typeof result === UNDEF_TYPE) {
          result = {};
          for (p in props) {
            q = props[p];
            if (typeof q === OBJ_TYPE) {
              result[q[0]] = undefined
            } else {
              result[q] = undefined
            }
          }
        }
        for (j = k = 0; j < regex.length; j++) {
          matches = regex[j].exec(this.getUA());
          if (!!matches) {
            for (p = 0; p < props.length; p++) {
              match = matches[++k];
              q = props[p];
              if (typeof q === OBJ_TYPE && q.length > 0) {
                if (q.length == 2) {
                  if (typeof q[1] == FUNC_TYPE) {
                    result[q[0]] = q[1].call(this, match)
                  } else {
                    result[q[0]] = q[1]
                  }
                } else if (q.length == 3) {
                  if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                    result[q[0]] = match ? q[1].call(this, match, q[2]) : undefined
                  } else {
                    result[q[0]] = match ? match.replace(q[1], q[2]) : undefined
                  }
                } else if (q.length == 4) {
                  result[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined
                }
              } else {
                result[q] = match ? match : undefined
              }
            }
            break;
          }
        }
        if (!!matches)
          break;
      }
      return result
    }, str: function (str, map) {
      for (var i in map) {
        if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
          for (var j = 0; j < map[i].length; j++) {
            if (util.has(map[i][j], str)) {
              return i === UNKNOWN ? undefined : i
            }
          }
        } else if (util.has(map[i], str)) {
          return i === UNKNOWN ? undefined : i
        }
      }
      return str
    }
  };
  var maps = {
    browser: {
      oldsafari: {
        major: {1: ['/8', '/1', '/3'], 2: '/4', '?': '/'},
        version: {
          '1.0': '/8',
          1.2: '/1',
          1.3: '/3',
          '2.0': '/412',
          '2.0.2': '/416',
          '2.0.3': '/417',
          '2.0.4': '/419',
          '?': '/'
        }
      }
    },
    device: {
      amazon: {model: {'Fire Phone': ['SD', 'KF']}},
      sprint: {model: {'Evo Shift 4G': '7373KT'}, vendor: {HTC: 'APA', Sprint: 'Sprint'}}
    },
    os: {
      windows: {
        version: {
          ME: '4.90',
          'NT 3.11': 'NT3.51',
          'NT 4.0': 'NT4.0',
          2000: 'NT 5.0',
          XP: ['NT 5.1', 'NT 5.2'],
          Vista: 'NT 6.0',
          7: 'NT 6.1',
          8: 'NT 6.2',
          8.1: 'NT 6.3',
          RT: 'ARM'
        }
      }
    }
  };
  var regexes = {
    browser: [[/(opera\smini)\/((\d+)?[\w\.-]+)/i, /(opera\s[mobiletab]+).+version\/((\d+)?[\w\.-]+)/i, /(opera).+version\/((\d+)?[\w\.]+)/i, /(opera)[\/\s]+((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/\s(opr)\/((\d+)?[\w\.]+)/i], [[NAME, 'Opera'], VERSION, MAJOR], [/(kindle)\/((\d+)?[\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?((\d+)?[\w\.]+)*/i, /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?((\d+)?[\w\.]*)/i, /(?:ms|\()(ie)\s((\d+)?[\w\.]+)/i, /(rekonq)((?:\/)[\w\.]+)*/i, /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron)\/((\d+)?[\w\.-]+)/i], [NAME, VERSION, MAJOR], [/(trident).+rv[:\s]((\d+)?[\w\.]+).+like\sgecko/i], [[NAME, 'IE'], VERSION, MAJOR], [/(yabrowser)\/((\d+)?[\w\.]+)/i], [[NAME, 'Yandex'], VERSION, MAJOR], [/(comodo_dragon)\/((\d+)?[\w\.]+)/i], [[NAME, /_/g, ' '], VERSION, MAJOR], [/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?((\d+)?[\w\.]+)/i, /(uc\s?browser|qqbrowser)[\/\s]?((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/(dolfin)\/((\d+)?[\w\.]+)/i], [[NAME, 'Dolphin'], VERSION, MAJOR], [/((?:android.+)crmo|crios)\/((\d+)?[\w\.]+)/i], [[NAME, 'Chrome'], VERSION, MAJOR], [/version\/((\d+)?[\w\.]+).+?mobile\/\w+\s(safari)/i], [VERSION, MAJOR, [NAME, 'Mobile Safari']], [/version\/((\d+)?[\w\.]+).+?(mobile\s?safari|safari)/i], [VERSION, MAJOR, NAME], [/webkit.+?(mobile\s?safari|safari)((\/[\w\.]+))/i], [NAME, [MAJOR, mapper.str, maps.browser.oldsafari.major], [VERSION, mapper.str, maps.browser.oldsafari.version]], [/(konqueror)\/((\d+)?[\w\.]+)/i, /(webkit|khtml)\/((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR], [/(navigator|netscape)\/((\d+)?[\w\.-]+)/i], [[NAME, 'Netscape'], VERSION, MAJOR], [/(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?((\d+)?[\w\.\+]+)/i, /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix)\/((\d+)?[\w\.-]+)/i, /(mozilla)\/((\d+)?[\w\.]+).+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf)[\/\s]?((\d+)?[\w\.]+)/i, /(links)\s\(((\d+)?[\w\.]+)/i, /(gobrowser)\/?((\d+)?[\w\.]+)*/i, /(ice\s?browser)\/v?((\d+)?[\w\._]+)/i, /(mosaic)[\/\s]((\d+)?[\w\.]+)/i], [NAME, VERSION, MAJOR]],
    cpu: [[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i], [[ARCHITECTURE, 'amd64']], [/(ia32(?=;))/i], [[ARCHITECTURE, util.lowerize]], [/((?:i[346]|x)86)[;\)]/i], [[ARCHITECTURE, 'ia32']], [/windows\s(ce|mobile);\sppc;/i], [[ARCHITECTURE, 'arm']], [/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i], [[ARCHITECTURE, /ower/, '', util.lowerize]], [/(sun4\w)[;\)]/i], [[ARCHITECTURE, 'sparc']], [/(ia64(?=;)|68k(?=\))|arm(?=v\d+;)|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i], [[ARCHITECTURE, util.lowerize]]],
    device: [[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i], [MODEL, VENDOR, [TYPE, TABLET]], [/applecoremedia\/[\w\.]+ \((ipad)/], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [/(apple\s{0,1}tv)/i], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [/(hp).+(touchpad)/i, /(kindle)\/([\w\.]+)/i, /\s(nook)[\w\s]+build\/(\w+)/i, /(dell)\s(strea[kpr\s\d]*[\dko])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(kf[A-z]+)\sbuild\/[\w\.]+.*silk\//i], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [/(sd|kf)[0349hijorstuw]+\sbuild\/[\w\.]+.*silk\//i], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);.+(apple)/i], [MODEL, VENDOR, [TYPE, MOBILE]], [/\((ip[honed|\s\w*]+);/i], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [/(blackberry)[\s-]?(\w+)/i, /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|huawei|meizu|motorola|polytron)[\s_-]?([\w-]+)*/i, /(hp)\s([\w\s]+\w)/i, /(asus)-?(\w+)/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/\((bb10);\s(\w+)/i], [[VENDOR, 'BlackBerry'], MODEL, [TYPE, MOBILE]], [/android.+((transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7))/i], [[VENDOR, 'Asus'], MODEL, [TYPE, TABLET]], [/(sony)\s(tablet\s[ps])/i], [VENDOR, MODEL, [TYPE, TABLET]], [/(nintendo)\s([wids3u]+)/i], [VENDOR, MODEL, [TYPE, CONSOLE]], [/((playstation)\s[3portablevi]+)/i], [[VENDOR, 'Sony'], MODEL, [TYPE, CONSOLE]], [/(sprint\s(\w+))/i], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [/(Lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i], [[VENDOR, 'Lenovo'], MODEL, [TYPE, TABLET]], [/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i, /(zte)-(\w+)*/i, /(alcatel|geeksphone|huawei|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]+)*/i], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [/\s((milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?(:?\s4g)?))[\w\s]+build\//i, /(mot)[\s-]?(\w+)*/i], [[VENDOR, 'Motorola'], MODEL, [TYPE, MOBILE]], [/android.+\s((mz60\d|xoom[\s2]{0,2}))\sbuild\//i], [[VENDOR, 'Motorola'], MODEL, [TYPE, TABLET]], [/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n8000|sgh-t8[56]9|nexus 10))/i, /((SM-T\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-n900))/i, /(sam[sung]*)[\s-]*(\w+-?[\w-]*)*/i, /sec-((sgh\w+))/i], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [/(sie)-(\w+)*/i], [[VENDOR, 'Siemens'], MODEL, [TYPE, MOBILE]], [/(maemo|nokia).*(n900|lumia\s\d+)/i, /(nokia)[\s_-]?([\w-]+)*/i], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [/android\s3\.[\s\w-;]{10}((a\d{3}))/i], [[VENDOR, 'Acer'], MODEL, [TYPE, TABLET]], [/android\s3\.[\s\w-;]{10}(lg?)-([06cv9]{3,4})/i], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [/(lg) netcast\.tv/i], [VENDOR, [TYPE, SMARTTV]], [/((nexus\s[45]))/i, /(lg)[e;\s\/-]+(\w+)*/i], [[VENDOR, 'LG'], MODEL, [TYPE, MOBILE]], [/android.+((ideatab[a-z0-9\-\s]+))/i], [[VENDOR, 'Lenovo'], MODEL, [TYPE, TABLET]], [/linux;.+((jolla));/i], [VENDOR, MODEL, [TYPE, MOBILE]], [/(mobile|tablet);.+rv\:.+gecko\//i], [[TYPE, util.lowerize], VENDOR, MODEL]],
    engine: [[/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i, /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i, /(icab)[\/\s]([23]\.[\d\.]+)/i], [NAME, VERSION], [/rv\:([\w\.]+).*(gecko)/i], [VERSION, NAME]],
    os: [[/microsoft\s(windows)\s(vista|xp)/i], [NAME, VERSION], [/(windows)\snt\s6\.2;\s(arm)/i, /(windows\sphone(?:\sos)*|windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [/\((bb)(10);/i], [[NAME, 'BlackBerry'], VERSION], [/(blackberry)\w*\/?([\w\.]+)*/i, /(tizen)\/([\w\.]+)/i, /(android|webos|palm\os|qnx|bada|rim\stablet\sos|meego)[\/\s-]?([\w\.]+)*/i, /linux;.+(sailfish);/i], [NAME, VERSION], [/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]+)*/i], [[NAME, 'Symbian'], VERSION], [/\((series40);/i], [NAME], [/mozilla.+\(mobile;.+gecko.+firefox/i], [[NAME, 'Firefox OS'], VERSION], [/(nintendo|playstation)\s([wids3portablevu]+)/i, /(mint)[\/\s\(]?(\w+)*/i, /(joli|[kxln]?ubuntu|debian|[open]*suse|gentoo|arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk)[\/\s-]?([\w\.-]+)*/i, /(hurd|linux)\s?([\w\.]+)*/i, /(gnu)\s?([\w\.]+)*/i], [NAME, VERSION], [/(cros)\s[\w]+\s([\w\.]+\w)/i], [[NAME, 'Chromium OS'], VERSION], [/(sunos)\s?([\w\.]+\d)*/i], [[NAME, 'Solaris'], VERSION], [/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]+)*/i], [NAME, VERSION], [/(ip[honead]+)(?:.*os\s*([\w]+)*\slike\smac|;\sopera)/i], [[NAME, 'iOS'], [VERSION, /_/g, '.']], [/(mac\sos\sx)\s?([\w\s\.]+\w)*/i], [NAME, [VERSION, /_/g, '.']], [/(haiku)\s(\w+)/i, /(aix)\s((\d)(?=\.|\)|\s)[\w\.]*)*/i, /(macintosh|mac(?=_powerpc)|plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos)/i, /(unix)\s?([\w\.]+)*/i], [NAME, VERSION]]
  };
  var UAParser = function (uastring, extensions) {
    if (!(this instanceof UAParser)) {
      return new UAParser(uastring, extensions).getResult()
    }
    var ua = uastring || (window && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : EMPTY);
    var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;
    this.getBrowser = function () {
      return mapper.rgx.apply(this, rgxmap.browser)
    };
    this.getCPU = function () {
      return mapper.rgx.apply(this, rgxmap.cpu)
    };
    this.getDevice = function () {
      return mapper.rgx.apply(this, rgxmap.device)
    };
    this.getEngine = function () {
      return mapper.rgx.apply(this, rgxmap.engine)
    };
    this.getOS = function () {
      return mapper.rgx.apply(this, rgxmap.os)
    };
    this.getResult = function () {
      return {
        ua: this.getUA(),
        browser: this.getBrowser(),
        engine: this.getEngine(),
        os: this.getOS(),
        device: this.getDevice(),
        cpu: this.getCPU()
      }
    };
    this.getUA = function () {
      return ua
    };
    this.setUA = function (uastring) {
      ua = uastring;
      return this
    };
    this.setUA(ua)
  };
  UAParser.VERSION = LIBVERSION;
  UAParser.BROWSER = {NAME: NAME, MAJOR: MAJOR, VERSION: VERSION};
  UAParser.CPU = {ARCHITECTURE: ARCHITECTURE};
  UAParser.DEVICE = {
    MODEL: MODEL,
    VENDOR: VENDOR,
    TYPE: TYPE,
    CONSOLE: CONSOLE,
    MOBILE: MOBILE,
    SMARTTV: SMARTTV,
    TABLET: TABLET
  };
  UAParser.ENGINE = {NAME: NAME, VERSION: VERSION};
  UAParser.OS = {NAME: NAME, VERSION: VERSION};
  if (typeof exports !== UNDEF_TYPE) {
    if (typeof module !== UNDEF_TYPE && module.exports) {
      exports = module.exports = UAParser
    }
    exports.UAParser = UAParser;
  } else {
    window.UAParser = UAParser;
    if (typeof define === FUNC_TYPE && define.amd) {
      define(function () {
        return UAParser;
      })
    }
    var $ = window.jQuery || window.Zepto;
    if (typeof $ !== UNDEF_TYPE) {
      var parser = new UAParser;
      $.ua = parser.getResult();
      $.ua.get = function () {
        return parser.getUA()
      };
      $.ua.set = function (uastring) {
        parser.setUA(uastring);
        var result = parser.getResult();
        for (var prop in result) {
          $.ua[prop] = result[prop]
        }
      }
    }
  }
})(this);

  var semafoneParameters = {
  en:'Credit Card Number',
  fr:'Num&#233;ro de carte de cr&#233;dit',
  semafoneUrl: '',
  semafoneMode: '',
  gatewayId:'',
  methodId:'',
  ppUserId:'',
  tenantId:'',
  clientId:'',
  accountId:'',
  principle:'',
  licenseCode:'',
  transactionType:'',
  responseType:'',
  responseURL:''
};

'use strict';

/*
$('.numbersOnly').keypress(function (e) {
    if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
      return false;
    }
  }
);
//*/


function augment(prototype, extension) {
    for (var key in extension) {
        if (!prototype[key]) {
            prototype[key] = extension[key];
        }
    }
}

augment(Array.prototype, {

    contains: function (item) {
        return (this.indexOf(item) !== -1);
    },

    remove: function (item) {
        var position = this.indexOf(item);
        if (position !== -1) {
            this.splice(position, 1);
        }
        return this;
    },

    removeItems: function (items) {
        for (var i = 0; i < items.length; i++) {
            this.remove(items[i]);
        }
        return this;
    },

    removeAt: function (index) {
        this.splice(index, 1);
        return this;
    },

    pushUnique: function (item) {
        if (!this.contains(item)) {
            this.push(item);
        }
        return this;
    },

    merge: function (items) {
        if (items && items.length) {
            for (var i = 0; i < items.length; i++) {
                this.pushUnique(items[i]);
            }
        }
        return this;
    },

    //it can be sortObject()
    //sortObject(by)
    //asc is by default true
    sortObject: function (by, asc) {
        if (angular.isUndefined(asc)) {
            if (angular.isUndefined(by)) {
                asc = true;
                by = undefined;
            } else {
                if (angular.isString(by)) {
                    asc = true;
                } else {
                    asc = by;
                    by = undefined;
                }
            }
        }

        if (by) {
            this.sort(function (a, b) {
                var av = a[by];
                var bv = b[by];
                if (av === bv) {
                    return 0;
                }
                return  asc ? (av > bv) ? 1 : -1 :
                    (av > bv) ? -1 : 1;
            });
        } else {
            //Expected an assignment or function call and instead saw an expression.
            /*jshint -W030 */
            asc ? this.sort() : this.sort().reverse();
        }
        return this;
    },

    //this compare content of two array
    //[1, 2, 3].equalTo([3, 2, 1]) will be true
    equalTo: function (items) {
        if (this.length === items.length) {
            for (var i = 0; i < this.length; i++) {

                if (!items.contains(this[i])) {
                    return false;
                }
            }
            return true;

        } else {
            return false;
        }
    },

    //for example,
    //a = [1, 2, 3], b = [3, 4], c = [4, 5]
    //b.hasAnyInsideOf(a) ==> true
    //c.hasAnyInsideOf(a) ==> false
    hasAnyInsideOf: function (items) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (this.contains(item)) {
                return true;
            }
        }
        return false;
    }
});

var rSupplant = /\{([^\{\}]*)\}/g;

augment(String.prototype, {

    startsWith: function (text) {
        return this.indexOf(text) === 0;
    },

    endsWith: function (suffix) {
        return this.indexOf(suffix, this.length - suffix.length) !== -1;
    },

    contains: function (text) {
        return this.indexOf(text) !== -1;
    },


    supplant: function (obj) {
        return this.replace(rSupplant,
            function (a, b) {
                var r = obj[b];
                return typeof r ? r : a;
            });
    },

    format: function () {
        var source = this;
      _.each(arguments, function (value, index) {
            source = source.replace(new RegExp('\\{' + index + '\\}', 'g'), value);
        });
        return source;
    },

    looseEqual: function (str) {
        return ( str && this.length ) ?
            this.toUpperCase() === str.toUpperCase() :
            this === str;
    }
});

'use strict';

function scrollPageToTop () {
	// plain jquey page scroll to top.  (Could be animated)

//	setTimeout(function () {			// Enable tiout ONLY if really really needed
		window.scrollTo(0, 0);			// jshint ignore:line
		$(window).scrollTop;			// jshint ignore:line
//	}, 100);
}

function nullOrEmpty(value) {
  return (value === null || value === '');
}

function replace(value, target, replacement) {
  if (nullOrEmpty(value)) {
    return value;
  }
  return value.replace(target, replacement);
}

function smUrlDecode(value) {

  // This URL decoding is specific to SiteMinder
  // Some details may be found here
  // https://communities.ca.com/thread/100358666
  // http://cookbooks.ca.com/casiteminder/?p=27

  value = replace(value, /%20/g, ' ');
  value = replace(value, /%26/g, '&');
  value = replace(value, /%2b/g, '+');
  value = replace(value, /%3f/g, '?');
  value = replace(value, /%3d/g, '=');
  value = replace(value, /%2f/g, '/');
  value = replace(value, /%2e/g, '.');
  value = replace(value, /--/g, '-');
  value = replace(value, /-SM-HTTPS/i, 'https');
  value = replace(value, /%3a/, ':');
  value = replace(value, /%24/g, '$');

  return value;
}

function scrollToAnchor(hash) {
    location.hash = '#' + hash;
}

'use strict';

angular.module('totesApp').factory('AppError', function () {

    //new AppError("50001"); //by default isPlainText is false
    //new AppError(true, "Unexpected error just happened"
    function AppError(isPlainText, resourceId) {
        this.name = 'AppError';

        if (angular.isString(isPlainText)) {
            resourceId = isPlainText;
            isPlainText = false;
        }
        this.message = resourceId;
        this.isPlainText = isPlainText;

    }

    AppError.prototype = Error.prototype;
    return AppError;
});
'use strict';

//document can be found at
// http://projects.rogersnpd.com:8090/display/TOT/API+Documentation

angular
  .module('totesApp')
  .factory('ajax', [
    'backend',
    '$browser',
    'settings',
    '$http',
    '$log',
    '$rootScope',
    'sessionStorage',
    'ute.rogers.account.overview.factory',
    'ute.rogers.account.overview.summary.factory',
    '$window',
    '$q',
    'ute.common.permissions.service',
    'ute.common.security.service',
    'ute.rogers.account.billing.detail.factory',
    function (backend,
              $browser,
              settings,
              $http,
              $log,
              $rootScope,
              sessionStorage,
              newAccountOverviewFactory,
              accountOverviewSummaryFactory,
              $window,
              $q,
              permissionsService,
              securityService,
              billingDetailFactory) {
      // Initiate Object
      var ajax = {};
      var killSwitchTrigger = 10;

      ajax.discardAllSmCookiesKillSwitch = 0;
      ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
      ajax.discardLoginSmCookiesKillSwitch = 0;

      var resolveHost = function() {
        if ($window.location.host.substring(0, 20) === 'localhost.rogers.com'){
          return 'https://localhost:3002';
        }
        return '';
      }

      return {
        EOP: {
          getEOPOffers: function(){
            return resolveHost() + '/web/RogersServices.portal/totes/api/v1/getEOPOffers';
          },
          updateCustomersEOPStatus: function(){
            // return 'https://localhost:3002/updateCustomersEOPStatus';
            return resolveHost() + '/web/RogersServices.portal/totes/api/v1/updateCustomersEOPStatus';
          },
          getProductInfo: function(){
          //  return 'https://localhost:3002/getProductInfo';
            return resolveHost() + '/web/RogersServices.portal/totes/api/v1/getProductInfo';
          },
          getCustomersLegacySubscriptionInfo: function(){
          //  return 'https://localhost:3002/getLegacySubscriptions';
            return resolveHost() + '/web/RogersServices.portal/totes/api/v1/getLegacySubscriptions';
          },
        },
        updateNickName: function (accountNumber, accountTypeNumber, nickName) {
          return backend.post('ebu/nickname', {
            accNum: accountNumber,
            accType: accountTypeNumber,
            nickName: nickName
          });
        },
        resetKillSwitches: function () {
          ajax.discardAllSmCookiesKillSwitch = 0;
          ajax.notifyServerDiscardSMCookiesKillSwitch = 0;
          ajax.discardLoginSmCookiesKillSwitch = 0;
        },
        disassociateAccount: function (data) {
          return backend.post('SelfServeAutomation/disassociateAccount', data, true);
        },
        disassociateAccountJanrain: function (data) {
          return backend.post('account/disassociate', data, true);
        },
        updatePinEmail: function (data) {
          //return backend.post('SelfServeAutomation/updatePinEmail', data, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateBillingType: function (data) {
          if ($rootScope.isCare) {
            data.accountTypeNumber = sessionStorage.getSessionStorageValue('accountTypeNumber');
          }
          return backend.post('SelfServeAutomation/updateBillingType', data, true);
        },
        updateBillingTypeV2: function (data) {
          if ($rootScope.isCare) {
            data.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateBillingType', data, true);
        },
        updateUserInfo: function (data) {
          return backend.post('SelfServeAutomation/manageMyOnlineProfile', data, true);
        },
        updateContactInformation: function (data) {
          //return backend.post('SelfServeAutomation/updateContactInformation', {}, true);
          return backend.post('SelfServeAutomation/setAddrContLang', data, true);
        },
        updateServiceAddress: function () {
          return backend.post('SelfServeAutomation/updateServiceAddress', {}, true);
        },
        updateBillingAddress: function () {
          return backend.post('SelfServeAutomation/updateBillingAddress', {}, true);
        },
        updateBillingAddressV2: function (obj) {
          if ($rootScope.isCare) {
            obj.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateBillingAddress', obj, true);
        },
        updateMarketingPermissions: function (mktPermObj) {
          return backend.post('SelfServeAutomation/updateMarketingPermissions', mktPermObj, true);
        },
        updateCredentials: function () {
          return backend.post('SelfServeAutomation/updateCredentials', {}, true);
        },
        getUserInfo: function () {
          var ban;
          if ($rootScope.isCare) {
            ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/manageMyOnlineProfileQuery', {ban: ban}, false);
        },
        setAddressContLang: function (obj) {
          return backend.post('SelfServeAutomation/setAddrContLang', obj, true);
        },
        updateContactInfo: function (obj) {
          if ($rootScope.isCare) {
            obj.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('updateProfileInfo/updateContactInfo', obj, true);
        },
        getMarketingPermissions: function (obj) {
          return backend.post('SelfServeAutomation/getMarketingPermissions', obj, true);
        },
        getProfilePageInfo: function () {
          return backend.post('check.html', {
            'ban': '453532863',
            'ctn': '6043511037',
            'accountNumber': '453532863'
          }, true);
        },

        getAuthorizedLocally: function (userName, password) {
          return backend.post('testlogin', {
            email: userName,
            password: password
          });

        },
        registrationSwitch: function (regObj) {
          return backend.post('registrationSwitch', regObj);
        },
        registerNoEmailVerify: function (regObj) {
          return backend.post('register', regObj);
        },
        agentInfo: function () {
          var acctNbr;
          if ($rootScope.isCare) {
            acctNbr = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('agentInfo', {
            'acctNbr': acctNbr
          });
        },
        signin: function (userName, password) {
          var requestObj = {
            USER: userName,
            password: password,
            SMAUTHREASON: '0',
            target: settings.postSigninUrl
          };
          return backend.postFormData('signin', requestObj);
        },
        pagePermission: function (url) {
          return backend.post('', {
            pageURL: url
          });
        },
        getMaintenanceSettings: function (postData) {
          return backend.post('maintenanceSettings', postData);
        },
        getBillingDetail: function (postData) {
          if (postData.accounTypeNumber != 9) {
            delete postData.indx;
            delete postData.pinNumber;
            delete postData.phoneNumber;
          }
          return billingDetailFactory(postData).getBillingDetail().then(function (data) {
            return normalizedBillingDetails(data);
          });
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          // var data = backend.post('accountoverview/billingDetails', postData);
          // return data;
        },
        getBalance: function (postData) {
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          var data = backend.post('accountoverview/balance', postData);
          return data;
        },
        getAccountList: function (postData) {
          var param;

          if ($rootScope.isCare || postData.acctNbr) {
            if (!postData.acctNbr) {
              postData.acctNbr = sessionStorage.getSessionStorageValue('accountNumber');
            }
            param = {acctNbr: Number(postData.acctNbr)};
          }

          return newAccountOverviewFactory(param).getAccountOverviewRawData().catch(function (error) {
            if (error.status === 555 && error.data.errorCode === 10490) {
              $window.location.href = error.data.errorMessage;
              // $window.location.href = '/business/ss/smb/redesign/dashboard/overview';

              new $q(function (resolve, reject) { // jshint ignore:line
                return reject('redirected');
              });
              // throw new Error('redirected');
            }
          });
        },
        getAccountDetail: function (postData) {
          var request = {
            accountNumber: Number(postData.accountNumber),
            accountTypeNumber: postData.accountTypeNumber,
            language: postData.language
          };
          // if ($window.location.host.substring(0, 20) === 'localhost.rogers.com'){
          //   var deferred = $q.defer();
          
          //   $http({
          //     method: 'POST',
          //     url: resolveHost() + '/web/RogersServices.portal/totes/api/v1/accountoverview/summary',
          //     data: request,
          //     withCredentials: false,
          //   }).then(function(response){
          //     deferred.resolve(response.data)
          //   }, function(error) {
          //     console.log('fetch error',error)
          //     deferred.reject()
          //   })
          //   return deferred.promise
          // }
          return accountOverviewSummaryFactory(request).getAccountOverviewSummaryRawData();
          // else{
          //   return accountOverviewSummaryFactory(request).getAccountOverviewSummaryRawData();
          // }
        },
        getAccountDetailPrepaid: function (postData) {
          //accounts/detail?accountNumber=712137454&language=EN&userId=totes%40rogers.com&guid=70e5db53-ec19-44b2-8f96-0bdbb1724994
          //var data = backend.post('accounts/detail', postData);
          return backend.post('accounts/detail', postData);
        },
        getSecureQuestion: function (email) {
          return backend.post('profile/question', {
            username: email
          });

        },
        getRegisteredUserName: function (email) {
          return backend.post('forgot/username', {
            email: email
          });
        },
        forgetPassword: function (selectedAnswer, fn, cToken, email, attemts) {
          if (attemts > 1) {

            return backend.post('forgot/password/resubmit', {
              username: email,
              answer: selectedAnswer
            });
          }

          return backend.post('forgot/password', {
            answer: selectedAnswer,
            fn: fn,
            cToken: cToken
          });
        },
        linkPostPaidAccount: function (postPaidAccount) {
          // return newAccountOverviewFactory().linkAccount(Number(postPaidAccount.accountNumber), postPaidAccount.billType, postPaidAccount.postalCode);
          return backend.post('account/associate', postPaidAccount);
          // return backend.post('linkAccount/postpaid', postPaidAccount);
        },
        linkPrepaidAccount: function (prepaidAccount) {
          return backend.post('linkAccount/prepaid', prepaidAccount);
        },
        getSegmentationForRGCL: function (postData) {
          var data;
          data = backend.post('accountoverview/getSegmentationForRGCL', postData);
          return data;
        },
        usernameMigration: function () {
          return backend.post('usernameMigration/check', {});
        },
        getEmail: function () {
          return backend.post('usernameMigration/getEmail', {
            username: $browser.cookies().userName
          });
        },
        updateUsername: function (email) {
          return backend.post('usernameMigration/updateUsername', {
            username: $browser.cookies().userName,
            email: email
          });
        },
        changeUsername: function (newUsername) {
          return backend.post('profile/changeUsername', {
            newEmail: newUsername
          });
        },
        getContactInfo: function (accountNumber) {
          var ban;
          if ($rootScope.isCare) {
            ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/getContactInfo', {
            accountNumber: accountNumber,
            ban: ban
          });
        },
        //PPC Check Eligibility Calls
        singleLineIdentity: function (accountNumber, ctn) {
          return backend.post('wirelessPricePlanChange/SingleLineIdentity',
            {
              accountNumber: accountNumber,
              ctn: ctn
            }
          );
        },

        hupEligibility: function (accountNumber, ctn, loyaltyStatus) {
          return backend.post('wirelessPricePlanChange/HupEligibility',
            {
              accountNumber: accountNumber,
              ctn: ctn,
              loyaltyStatus: loyaltyStatus
            });
        },

        //make a payment
        /*make a payment with a credit card*/
        getSignature: function (accountNumber) {
          return backend.post('signature', {accountNumber: accountNumber});
          //return backend.post('signature', { });
        },
        getToken: function (paymentServerUrl) {
          return backend.jsonp(paymentServerUrl);
        },
        decryptToken: function (accountNumber, token, iin, rc, ccType) {
          var requestObj = {
            accountNumber: accountNumber,
            encryptedToken: token,
            bin: iin,
            result: rc,
            creditCardType: ccType
          };
          return backend.post('payment/decrypt', requestObj);
        },
        payNow: function (creditPaymentObj, accountNumber, accountTypeNumber, subNumber, isConsolidated) {
          $log.debug(creditPaymentObj);
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            accountTypeNumber: accountTypeNumber,
            amount: creditPaymentObj.paymentAmount,
            paymentMethod: 'CreditCard',
            subNumber: subNumber,
            consolidated: isConsolidated,
            'creditCardInfo.ccNumber': creditPaymentObj.creditCardNo,
            'creditCardInfo.ccType': creditPaymentObj.creditCardType,
            'creditCardInfo.ccExpiryMonth': creditPaymentObj.expireDate.month,
            'creditCardInfo.ccExpiryYear': creditPaymentObj.expireDate.year,
            'creditCardInfo.securityCode': creditPaymentObj.securityCode
          };

          return backend.post('makePayment', passJson);
        },
        /*make a payment with interac*/
        interacConfirm: function (accountNumber) {
          var requestObj = {
            accountNumber: accountNumber
          };
          return backend.post('interac/confirmationData', requestObj);
        },
        /*make a payment with interac*/
        getSHMlink: function (accountNumber, url) {
          var requestObj = {
            serviceNumber: accountNumber
          };
          return backend.post('shmDashBoard/accessWebControl', requestObj);
        },
        //call this method with the response from interacEligibility directly.
        interacMakePayment: function (requestObj) {
          return backend.post('interac', requestObj);
        },

        billHistory: function (payload) {
          return $http.post(securityService.getBackendUrl('v3/payment/history'), payload);
        },

        /**
         * change payment method
         * requestObj - required to complete the payment operation
         */

        setPaymentMethod: function (requestObj) {
          /*
           var requestObj= {
           accountNumber: accountNumber,
           accountTypeNumber: accountTypeNumber,
           mopType: methodType,
           'creditCardInfo.ccNumber': creditPaymentObj.creditCardNo,
           'creditCardInfo.ccType': creditPaymentObj.creditCardType.name,
           'creditCardInfo.ccExpiryMonth': creditPaymentObj.expireDate.month,
           'creditCardInfo.ccExpiryYear': creditPaymentObj.expireDate.year,
           'creditCardInfo.securityCode': creditPaymentObj.securityCode,
           'chequingInfo.bankNumber': debitPaymentObj.bankCode,
           'chequingInfo.transitNumber': debitPaymentObj.transitNo,
           'chequingInfo.accountNumber': debitPaymentObj.accountNo,
           'phoneNumber':cableAccount.phoneNumber,
           'oldMopType':cableAccount.oldPaymentMethod,
           'email':cableAccount.email
           };
           */
          return backend.post('payment/updatePaymentMethod', requestObj);
        },
        // Wireless Dashboard

        /* required params
         * ban	Account Number	716942875(Wireless)
         * ctn	Phone Number 4162780218
         */
        wirelessDashBoard: function (postData) {
          // postData.ban = 716942875;
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard', postData);
        },
        /* required params
         * ban	Account Number	716936547(Wireless)
         * ctn	Phone Number 4168145924
         */
        wirelessPostpaid: function (postData) {
          // postData.ban = 716936547;
          // postData.ctn = '4168145000';
          return backend.post('wirelessDashBoard/postPaidDetails', postData);
        },
        /* required params
         * ban	Account Number	716936547(Wireless)
         * ctn	Phone Number 4168145924
         */
        wirelessPostpaidV2: function (postData) {
          //return backend.post('wirelessDashBoard/postPaidDetailsV2', postData);
          var deferred = $q.defer();
          $http.post(securityService.getBackendUrl('v2/wirelessDashBoard/postPaidDetails'), postData).then(
          function (response){
            deferred.resolve(response.data);
          }, function (errorResponse) {
            deferred.reject(errorResponse);
          });
          return deferred.promise;
        },
        interacEligibility: function (accountNumber, accountType, amountDue, amount) {
          var requestObj = {
            language: 'EN',
            accountNumber: accountNumber,
            accountTypeNumber: accountType,
            amountDue: amountDue,
            amount: amount
          };
          return backend.post('interac/getEligibility', requestObj);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        wirelessPrepaid: function (postData) {
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashBoard/prepaidDetails', postData);
        },
        prepaidCtnCount: function (postData) {
          // postData.ctn = 4162780218;
          return backend.post('wirelessDashboard/changeCTNCount', postData);
        },
        wirelessTravelPackageStaticContent: function (postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/staticContent', postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        wirelessTravelPackage: function (postData) {
          // postData.ban
          // postData.ctn
          return backend.post('wirelessDashBoard/rlh/getDetails', postData);
        },
        wirelessTravelPackageAddOnSummary: function (postData) {
          // postData.ban
          return backend.post('wirelessDashBoard/planAddOnSummary', postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        setwirelessTravelPackage: function (postData) {
          // postData.ban
          // postData.ctn
          // updateOptInOutFlag
          if ($rootScope.isCare) {
            postData.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }

          if (postData.evolutionOptInOutFlag) {
            return backend.post('wirelessDashBoard/rlh/setDetails', postData);
          } else {
            return backend.post('wirelessDashBoard/rlh/unEnroll', postData);
          }
        },
        /**
         * required params
         * ctn Phone Number 4162780218
         * ban  Account Number  716936547(Wireless)
         * type Service Type Wireless
         *
         */
        adjustmentHistory: function (postData) {
          return backend.post('getAdjustmentHistory', postData);
        },
        /**
         * required params
         * ban  Account Number  716936547(Wireless)
         *
         */
        applyAdjustment: function (url, accountNumber, postData) {
          return backend.post('account/' + accountNumber + '/adjustments' + url, postData);
        },
        /* required params
         * ctn	Phone Number 4162780218
         */
        internetDashboard: function (accountNumber, language, ban) {
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            language: language,
            ban: ban
          };
          if ($rootScope.isCare && !passJson.ban) {
            passJson.ban = sessionStorage.getSessionStorageValue('accountNumber');
          }
          return backend.post('internetDashBoard', passJson, 'internetdash');
        },
        internetDashboardUsage: function (accountNumber) {
          var passJson = {
            accountNumber: accountNumber,
            applicationId: 'Rogers.com'
          };
          if ($rootScope.isCare && !passJson.ban) {
            passJson.ban = sessionStorage.getSessionStorageValue('accountNumber');
          }
          return backend.post('internetDashBoard/usage', passJson, 'internetdash');
        },
        internetDashboardProduct: function (accountNumber, refresh, language) {
          accountNumber = (accountNumber === undefined) ? 0 : accountNumber;
          refresh = (refresh === undefined) ? false : refresh;
          var passJson = {
            accountNumber: accountNumber,
            applicationId: 'Rogers.com',
            language: language,
            refresh: refresh
          };
          if ($rootScope.isCare && !passJson.ban) {
            passJson.ban = sessionStorage.getSessionStorageValue('accountNumber');
          }
          return backend.post('internetDashBoard/productDetails', passJson, 'internetdash');
        },

        /*Adding as part of DSO-7845*/

        persistModalPreference: function (targetPage, programId, endDate, accountNumber) {
          var request = {
            targetPage: targetPage,
            programId: programId,
            endDate: endDate,
            accountNumber: accountNumber
          };
          return backend.post('persistUserModalPreference', request);
        },
        getUserModalPreference: function (targetPage, programId, endDate, accountNumber) {
          var request = {
            targetPage: targetPage,
            programId: programId,
            endDate: endDate,
            accountNumber: accountNumber
          };
          return backend.post('getUserModalPreference', request);
        },

        tvDashboard: function (accountNumber, language, ban, refresh) {
          var passJson = {
            accountNumber: accountNumber, //accountNo,
            language: language.toLowerCase(),
            ban: ban,
            refresh: refresh
          };

          return backend.post('tvLanding', passJson);
        },
        tvFeed: function () {
          return backend.post('tv-feed/contents', {});
        },
        getHomePhonePackages: function (passJson) {
          return backend.post('rhpDashBoard/homePhonePackages', passJson);
        },
        resetRhpVoicemailPassword: function (postData) {
          return backend.post('homephone/resetvoicemailpassword', postData);
        },
        /*
         * Data Eviction Notificaton calls
         */
        notifyServerPreredeem: function (postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('maestro/preredeem', postData);
        },
        notifyServerLOBchange: function (postData) {
          // postData.accountNumber = 4162780218;
          return backend.post('accounts/lobprechange', postData);
        },
        notifyServerDeviceStatuschange: function (postData) {
          return backend.post('wirelessDashBoard/deviceStatusChange', postData);
        },
        notifyServerLoggedIn: function () {
          return backend.post('loggedIn', {});
        },
        notifyServerLogout: function () {
          //return;
          if (ajax.discardAllSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardAllSmCookiesKillSwitch++;
            return backend.post('discardAllSmCookies', {});
          }
        },
        //Added to invoke UCS logout call just before signout
        /* notifyUcsLogout: function () {
         return backend.post('buy/cart/exit', {});
         },*/
        // notifyLegacyLogout: function () {
        //   //return;
        //   return backend.post('web/totesSignOut', {}, 'legacySignout');
        //   // Removed after consultation with Prasanth
        // },
        notifyServerDiscardSMCookies: function () {
          if (ajax.notifyServerDiscardSMCookiesKillSwitch < killSwitchTrigger) {
            ajax.notifyServerDiscardSMCookiesKillSwitch++;
            return backend.post('discardAllSmCookies', {});
          }
        },
        notifyServerDiscardLoginSMCookies: function () {
          if (ajax.discardLoginSmCookiesKillSwitch < killSwitchTrigger) {
            ajax.discardLoginSmCookiesKillSwitch++;
            return backend.post('discardLoginSmCookies', {});

          }
        },
        /* required params
         * currentAccNumber 123456789
         */
        // getBriteBill: function (postData) {
        //   // postData.currentAccNumber
        //   return backend.post('encryptBritebill', postData);
        // },
        // getBriteBillListOfBills: function (postData, headerData) {
        //   return backend.post('briteBillList', postData, null, headerData);
        // },
        // briteBillDownload: function (url, postData, headerData) {
        //   return backend.post(url, postData, 'pdfDownload', headerData);
        // },
        getPermissions: function () {
          return permissionsService.getUserPermissions();
          // return backend.post('permissions');
        },
        getBrtSwitches: function () {
          return 'https://localhost.rogers.com:4000/web/consumer/browsebuy/v2/orderSummary';
          // return backend.post('brtSwitches');
        },
        abort: function () {
          return backend.abort();
        },
        verifyAddress: function (data) {
          return backend.post('SelfServeAutomation/verifyAddress', data);
        },
        verifyAddressV2: function (data) {
          if ($rootScope.isCare) {
            data.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/verifyAddressV2', data);
        },
        serverLog: function (data) {
          data.logLevel = 'INFO';
          return backend.post('log', data);
        },
        backToSSP: function (postData) {
          return backend.post('backToSSP', postData);
        },
        getInteraction: function (selectedAccount, lang) {
          var ban;
          if ($rootScope.isCare) {
            ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          var passJson = {
            lang: lang,
            ban: ban,
            accountNumber: selectedAccount
          };
          return backend.post('interactionDetails', passJson);
        },
        getEncryptNRSData: function (postData) {
          return backend.post('nrs/getPayload', postData);
        },
        getUsageData: function () {
          return backend.post('wirelessPricePlanChange/getUsageData');
        },
        checkEligibility: function (postData) {
          return backend.post('ppc/priceplans/eligibility', postData);
        },
        checkBOTEligibility: function (postData) {
          return backend.post('getCases', postData);
        },
        closeCase: function (postData) {
          return backend.post('closeCase', postData);
        },
        setState: function (postData) {
          //return backend.post('spa/state', postData, null, {'Content-Type': 'application/x-www-form-urlencoded'});
          return backend.post('spa/state', postData);
        },
        fetchOrder: function () {
          return backend.post('buy/cart/fetch');
        },
        getDeviceBalance: function (postData) {
          return backend.post('currentSubsidy', postData);
        },
        checkHupEligibility: function (postData) {
          return backend.post('checkHupEligibility', postData);
        },
        getPostDatedPPC: function (postData) {
          return backend.post('orders/postDatedPPC', postData);
        },
        getWirelessOrders: function (postData) {
          return backend.post('pendingorders/orderdetails', postData);
        },
        isNFDBCheck: function (postData) {
          return backend.post('checkNfdb', postData);
        },
        hupSaveState: function (postData) {
          return backend.post('hup/spa/saveState', postData);
        },
        hupGetState: function (postData) {
          return backend.post('hup/spa/getState', postData);
        },
        subscribers: function (postData) {
          return backend.post('ppc/subscribers', postData);
        },
        getCustomerInfo: function (postData) {
          if ($rootScope.isCare) {
            postData.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('customerInformation', postData);
        },
        updateUserPreference: function (userId, userType, userPreferenceName, userPreferenceValue) {
          var passJson = {
            userId: userId,
            userType: userType,
            userPreferenceName: userPreferenceName,
            userPreferenceValue: userPreferenceValue
          };
          return backend.post('userPreferenceUpdate', passJson);
        },
        getUserPreference: function (userId) {
          var passJson = {
            userId: userId
          };
          return backend.post('userPreferenceRetrieval', passJson);
        },
        getUserPreferenceByKey: function (userId, key) {
          return backend.post('userPreferenceRetrieval', {userId: userId}).then(function (data) {
            return data && data.userPreference ? data.userPreference : null;
          });
        },
        checkWinOnline: function (postData) {
          return backend.post('view/bill', postData);
        },
        resetPassword: function () {
          return backend.post('SelfServeAutomation/resetPassword');
        },
        getAccountStatus: function (postData) {
          if ($rootScope.isCare) {
            postData.ban = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          }
          return backend.post('SelfServeAutomation/checkAccountStatus', postData);
        },
        unlockAccount: function (postData) {
          return backend.post('SelfServeAutomation/unlockAccount', postData);
        },
        getWcocJwtToken: function (postData) {
          return backend.post('wcoc/createjwttoken', postData);
        },
        decryptWcocJwtToken: function (postData) {
          return backend.post('wcoc/decryptjwttoken', postData);
        },
        //},
        /* required params
         * currentAccNumber 123456789
         */
        /* getBriteBill: function (postData) {
         // postData.currentAccNumber
         return backend.post('encryptBritebill', postData);
         },
         getBriteBillListOfBills: function (postData, headerData) {
         return backend.post('briteBillList', postData, null, headerData);
         },
         getPermissions: function () {
         return backend.post('permissions');
         },
         getBrtSwitches: function () {
         return backend.post('brtSwitches');
         },
         abort: function () {
         return backend.abort();
         },
         verifyAddress: function (data) {
         return backend.post('SelfServeAutomation/verifyAddress', data);
         },
         serverLog: function(data){
         data.logLevel = 'INFO';
         return backend.post('log',data);
         },
         backToSSP: function (postData) {
         return backend.post('backToSSP', postData);
         },
         getInteraction: function(selectedAccount, lang){
         var passJson = {
         lang: lang,
         accountNumber: selectedAccount
         };
         return backend.post('interactionDetails', passJson);
         },
         getEncryptNRSData: function(postData) {
         return backend.post('nrs/getPayload' ,postData);
         },
         getUsageData: function() {
         return backend.post('wirelessPricePlanChange/getUsageData');
         },
         checkEligibility: function (postData) {
         return backend.post('ppc/priceplans/eligibility', postData);
         },
         setState: function (postData) {
         //return backend.post('spa/state', postData, null, {'Content-Type': 'application/x-www-form-urlencoded'});
         return backend.post('spa/state', postData);
         },
         fetchOrder: function (){
         return backend.post('buy/cart/fetch');
         },
         getDeviceBalance: function (postData) {
         return backend.post('currentSubsidy', postData);
         },
         checkHupEligibility: function (postData) {
         return backend.post('checkHupEligibility', postData);
         },
         isNFDBCheck: function (postData) {
         return backend.post('checkNfdb', postData);
         },
         hupSaveState: function (postData) {
         return backend.post('hup/spa/saveState', postData);
         },
         hupGetState: function (postData) {
         return backend.post('hup/spa/getState', postData);
         },
         subscribers: function (postData) {
         return backend.post('ppc/subscribers', postData);
         },
         getCustomerInfo: function (postData) {
         return backend.post('customerInformation', postData);
         },
         updateUserPreference: function(userId, userType, userPreferenceName, userPreferenceValue){
         var passJson = {
         userId: userId,
         userType: userType,
         userPreferenceName: userPreferenceName,
         userPreferenceValue: userPreferenceValue
         };
         return backend.post('userPreferenceUpdate', passJson);
         },
         getUserPreference: function(userId){
         var passJson = {
         userId: userId
         };
         return backend.post('userPreferenceRetrieval', passJson);
         },
         resetPassword: function(){
         return backend.post('SelfServeAutomation/resetPassword');
         },*/
        getOneViewNews: function (request) {
          return backend.postExternalAPI(request);
        },
        getOneViewWeather: function (request) {
          return backend.postExternalAPI(request);
        },
        saveState: function (postData) {
          return backend.post('cart/save-state', postData);
        },
        fetchValidatedCart: function (postData) {
          return backend.post('buy/cart/fetch-validated-cart', postData);
        },
        validateOrder: function (postData) {
          return backend.post('checkout/validate-order', postData);
        },
        fetchCartOrder: function (postData) {
          if ($window.location.host.substring(0, 20) === 'localhost.rogers.com'){
            var deferred = $q.defer();
          
            $http({
              method: 'POST',
              url: resolveHost() + '/web/RogersServices.portal/totes/api/v1/cart/fetch',
              withCredentials: false,
              data: postData
            }).then(function(response){
              deferred.resolve(response.data)
            }, function(error) {
              console.log('fetch error',error)
              deferred.reject()
            })
            return deferred.promise
          }
          else {
            return backend.post('cart/fetch', postData);
          }
        },
        cancelOrder: function (postData) {
          return backend.post('cart/cancelOrder', postData);
        },
        getDiscoveryPageContent: function (postData) {
          return backend.post('discovery-page/get-content', postData);
        },
        getAgentPermission: function () {
          return backend.post('ram/permissions/all');
        },
        keepAlive: function () {
          return backend.post('account/session/keepalive');
        },
        onRefresh: function () {
          return backend.post('buy/cart/concurrent-logout');
        },
        getDealerProfile: function (dealerCodeValue) {
          var requestObj = {
            dealerID: dealerCodeValue
          };
          return backend.post('oneView/dealerProfile', requestObj);
        },
        saveDealerCode: function (dealerCodeValue) {
          var acctNbr = sessionStorage.getSessionStorageValue('requestedAccountNumber');
          var requestObj = {
            acctNbr: acctNbr,
            dealerCode: dealerCodeValue
          };
          return backend.post('oneView/saveDealerCode', requestObj);
        },
        // inject and use ute.common.core.caching.CacheableDataFactory to implement simple caching of data for 1 minute
        // getCurrentPlan: function (postData) {
        //   return backend.post('ppc/priceplans/current', postData);
        // },
        nacSaveState: function (postData) {
          return backend.post('nac/saveState', postData);
        },
        saveOrder: function (postData) {
          return backend.post('cart/save-order', postData);
        }
      };

      //Needed to bridge the gap between direct call to billing detail from rogers-client and calling the billing detail api through account overview service module
      function normalizedBillingDetails(data) {
        var normalizedData = _.cloneDeep(data);
        if (normalizedData.balanceAmount || normalizedData.balanceAmount === 0) {
          normalizedData.balanceAmount = normalizedData.balanceAmount.toString();
          if (normalizedData.balanceAmount.indexOf('.') === -1) {
            normalizedData.balanceAmount = normalizedData.balanceAmount = normalizedData.balanceAmount + '.00';
          }
        }
        if (normalizedData.methodOfPayment && normalizedData.methodOfPayment.mopType >= 0) {
          normalizedData.methodOfPayment.mopType = ute.rogers.account.overview.billing.detail.PaymentMethodType[normalizedData.methodOfPayment.mopType];
        }
        if (_.get(normalizedData, 'methodOfPayment.creditCardDetails.ccType') !== undefined && normalizedData.methodOfPayment.creditCardDetails.ccType >= 0) {
          normalizedData.methodOfPayment.creditCardDetails.ccType = ute.rogers.account.overview.billing.detail.CreditCardType[normalizedData.methodOfPayment.creditCardDetails.ccType];
        }

        normalizedData.usedCLM = normalizedData.creditLimit - normalizedData.availableCreditAmount;
        normalizedData.usedCLMpercentage = ((normalizedData.usedCLM / normalizedData.creditLimit) * 100);

        return normalizedData;
      }
    }]);

'use strict';


angular
		.module('totesApp')
		.factory('appInterface', ['$location', '$rootScope', '$state', 'ute.blocks.language.switcher', 'userProvince',
			function ($location, $rootScope, $state, languageSwitcher, userProvince) {

				// Initiate Object
				var appInterface = {};

				// hook up variables
				appInterface.data = {};
				appInterface.selectedLanguage = languageSwitcher.getCurrentLanguage();
				appInterface.selectedProvince = userProvince();
				appInterface.currentURLPath = '';
				appInterface.feedbackTabType = 'regular';

				// Various test function that will trigger outside functionality
				appInterface.fn = {};

				// Feedback tab on side vs. Britebill feedback tab
				appInterface.fn.feedbackTab = function (userPath) {
					appInterface.currentURLPath = userPath;

					if (typeof (setFeedbackTabState) === 'function') {						// jshint ignore:line
						var tabType = 'regular';

						if (typeof (getFeedbackTabURL) === 'function') {					// jshint ignore:line
							tabType = getFeedbackTabURL(userPath);							// jshint ignore:line
						}

						appInterface.feedbackTabType = tabType;
						appInterface.selectedLanguage = languageSwitcher.getCurrentLanguage();
						appInterface.selectedProvince = userProvince();

						var language = appInterface.selectedLanguage;
						var province = appInterface.selectedProvince;
						var customerId = '';

						setFeedbackTabState(tabType, language, province, customerId);		// jshint ignore:line
					}
				};

				// language change notification
				appInterface.fn.languageChange = function (language) {
					if (typeof (setFeedbackTabLanguage) === 'function') {					// jshint ignore:line
						setFeedbackTabLanguage(language, appInterface.feedbackTabType);		// jshint ignore:line
					}
				};

				// province change notification
				appInterface.fn.provinceChange = function (province) {
					if (typeof (setFeedbackTabProvince) === 'function') {										// jshint ignore:line
						setFeedbackTabProvince(province, appInterface.feedbackTabType, languageSwitcher.getCurrentLanguage());			// jshint ignore:line
					}
				};

				// main interaction functions (routing, custom event triggeres)
				// routing.js  ->  onEnter
				appInterface.stateEnter = function (toStatePath) {
					var userPath = (toStatePath === undefined) ? $location.path() : toStatePath;

					// Check function calls
					appInterface.fn.feedbackTab(userPath);
				};
				// routing.js  ->  onExit
				appInterface.stateExit = function (toStatePath) {
				};

				return appInterface;
			}
		]);


angular
		.module('totesApp')
		.provider('appInterfaceHandler', function () {
			var data;

			return {
				$get: function () {
					return data;
				},
				$set: function (value) {
					data = value;
				}
			};
		});

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('appState', ['$rootScope',
    '$window',
    '$location',
    'settings',
    'ute.common.permissions.service',
    'confirmationDialog',
    '$state',
    'webanalytics',
    '$browser',
    '$injector',
    'localStorage',
    'userProvince',
    '$log',
    'sessionStorage',
    'ute.common.user.service',
    '$q',
    '$document',
    '$timeout',
    'cookieStore',
    'util',
    'ute.blocks.language.switcher',
    function ($rootScope, // jshint ignore:line
              $window,
              $location,
              settings,
              permissionsService,
              confirmationDialog,
              $state,
              webanalytics,
              $browser,
              $injector,
              localStorage,
              userProvince,
              $log,
              sessionStorage,
              userService,
              $q,
              $document,
              $timeout,
              cookieStore,
              util,
              languageSwitcher) {
      // Initiate Object
      var appState = {};

      // hook up variables
      appState.module = null;
      appState.submodule = null;

      var stateName = $state.current.name;

      appState.route = stateName || undefined;

      appState.isMobile = false;//for now only set to mobile, need a detection
      appState.newRegistration = false;
      appState.noLinking = false;
      appState.isLinked = false;
      appState.language = 'en';
      appState.usernameChanged = false;
      appState.afterPaymentRefresh = false;
      appState.modalPayNowOpened = false;
      appState.permissionsLoaded = false;
      appState.isFirstLoad = true;
      appState.isDealerCodeExist = false;
      appState.isIE = function () {
        var userAgent = window.navigator.userAgent, msIE = userAgent.indexOf("msIE");
        return parseInt(userAgent.substring(msIE + 5, userAgent.indexOf(".", msIE))) ||
          !!navigator.userAgent.match(/Trident\/7\./) || window.navigator.userAgent.indexOf("Edge") > -1 || false;
      };

      //analytic tagging, to add a tagging object into the global tagging array.
      appState.tagging = function (options) {
        try {
          $window.addOmnp(options);
        } catch (e) {
          $log.error('Exception catch during $window.addOmnp with message:', e.message);
        }
      };

      //analytic tagging, tag a form field validation error
      appState.tagFieldValidationErrors = function (pageName, fieldName, errorObj) {
        if (!pageName || !fieldName || !errorObj) {
          return;
        }
        //set error type
        var errType = '', errMessage = '';
        if (errorObj === 1 || errorObj === 2) {
          errType = errorObj;
        } else {
          if (errorObj.required) {
            errType = 1;
          } else if (errorObj.pattern) {
            errType = 2;
          } else {
            _.each(errorObj, function (value) {
              errType = 3;
              errMessage = value;
            });
          }
        }

        if (errType > 0) {
          try {
            var msg = webanalytics.formatErrorMessage(pageName, fieldName, errType, errMessage);
            appState.tagging(['_trackLink', {eVar49: msg},
              {event15: ''}// Generic Error
            ]);
          } catch (e) {
            $log.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }

      };

      //analytic tagging, tag all form validation errors
      appState.tagFormValidationErrors = function (pageName, errorObj) {

        if (!pageName || !errorObj) {
          return;
        }

        // Form is NOT valid, tag the errors
        var msg = '';
        var numRequiredErrors = (errorObj.required && errorObj.required.length) || 0;
        var numPatternErrors = (errorObj.pattern && errorObj.pattern.length) || 0;

        for (var i = 0; i < numRequiredErrors; i++) {

          try {
            msg = webanalytics.formatErrorMessage(pageName, errorObj.required[i].$name, 1, null);
            appState.tagging(['_trackLink',
              {eVar49: msg},
              {event15: ''}// Generic Error
            ]);
          } catch (e) {
            $log.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }

        for (var j = 0; j < numPatternErrors; j++) {

          try {
            msg = webanalytics.formatErrorMessage(pageName, errorObj.pattern[i].$name, 2, null);
            appState.tagging(['_trackLink',
              {eVar49: msg},
              {event15: ''}// Generic Error
            ]);
          } catch (e) {
            $log.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }
      };

      appState.alert = function (info) {
        confirmationDialog.alert(info);
      };

      appState.setConfirmation = function (options) {
        confirmationDialog.open(options);
      };
      appState.cancelConfirmation = function (options) {
        confirmationDialog.close();
      };

      appState.switchView = function (viewName) {
        var _targetView = viewName.charAt(0) !== '/' ? '/' : '', _targetParam;
        _targetView += viewName;
        $location.path(_targetView);
      };

      appState.validateJSON = function (data) {
        //if data is null or a html page which returned by siteminder, it means user not signed in, so redirect to signin.
      };

      appState.redirectToSignIn = function () {
        $window.location.href = settings.postSignOutUrl;
      };

      appState.kickOutExpired = function () {
        // Non-Angular cookie grab
        var name = (angular.isFunction(userService.getAuthCookieName) && userService.getAuthCookieName || angular.noop)() + '=';
        var logOffcookie = '';
        var ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) === ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
            logOffcookie = c.substring(name.length, c.length);
          }
        }
        // Angular cookie grab
        if (logOffcookie === 'LOGGEDOFF' && !($rootScope.isCare)) { /* Added isCare check to resolve Care being redirected to Logout Page */
          // Do the user logout here
          var user = $injector.get('user');
          console.log('calling logout from kickOutExpired');
          user.logout(false, 'SESSION_EXPIRED');
        }
      };

      /* RootScope handling */

      // Account list and permissions
      // Initial state
      appState.aoInitiate = function () {
        // Account overview
        $rootScope.ao = {};
        $rootScope.ao.raw = null;

        // User accounts list
        $rootScope.ao.allAccounts = null;
        $rootScope.ao.accountActive = null;
        $rootScope.ao.accountActiveIndex = null;
        $rootScope.ao.accountDetails = null;

        // All account permissions
        $rootScope.permissions = {};
        $rootScope.permissions.allPermissions = null;
        $rootScope.permissions.permissionActive = null;
        $rootScope.permissions.permissionActiveIndex = null;

        // All account permissions
        $rootScope.maintenance = {};

        // All user data / flags
        $rootScope.user = {};
      };

      appState.userInitiate = function () {
      };

      // Clear to defaults
      appState.aoFlushScope = function () {
        // Destroy everything
        $rootScope.ao = null;
        $rootScope.permissions = null;
        $rootScope.maintenance = null;
        $rootScope.user = null;
        appState.aoInitiate();
      };
      appState.aoUpdateIndexes = function (accNo) {
        // Update active account indexes using account number => accNo
        $rootScope.ao.accountActiveIndex = _.findIndex($rootScope.ao.allAccounts, {'accountNumber': accNo});
        $rootScope.permissions.permissionActiveIndex = _.findIndex($rootScope.permissions.allPermissions, {'accountNumber': accNo});
        if ($rootScope.ao.accountActiveIndex === -1 && $rootScope.ao.allAccounts && $rootScope.ao.allAccounts.length > 0) {
          $rootScope.ao.accountActiveIndex = 0;
        }

        if ($rootScope.permissions.permissionActiveIndex === -1 && $rootScope.permissions.allPermissions && $rootScope.permissions.allPermissions.length > 0) {
          $rootScope.permissions.permissionActiveIndex = 0;
        }
        if (!$rootScope.permissions.allPermissions) {
          return;
        }
        $rootScope.permissions.permissionActive = $rootScope.permissions.allPermissions[$rootScope.permissions.permissionActiveIndex];
      };

      appState.aoUpdateActiveObjects = function (accNo) {
        // Make sure indexes are up-to-date
        this.aoUpdateIndexes(accNo);
        // Update active account indexes AND active accounts using account number => accNo
        if ($rootScope.ao.accountActiveIndex >= 0) {
          $rootScope.ao.accountActive = $rootScope.ao.allAccounts[$rootScope.ao.accountActiveIndex];
        }

        if ($rootScope.permissions.permissionActiveIndex >= 0) {
          $rootScope.permissions.permissionActive = $rootScope.permissions.allPermissions[$rootScope.permissions.permissionActiveIndex];
        }
        // Return active index back to page reconstruction - part of MYR-1123
        return $rootScope.ao.accountActiveIndex;
      };

      // Reconstruct scope
      appState.aoReconstruct = function (accountNumber) {
        // Grab info and make all necesary calls
        this.aoUpdateActiveObjects(accountNumber);
      };

      // Permissions related function - Look up specific permission flag for active account
      appState.permissionTo = function (flag) {
        // Look it up in flag list
        var permArray = [];

        try {
          permArray = $rootScope.permissions.permissionActive.permissions;
        } catch (e) {
          permArray = [];
        }

        // if (permArray.length > 0) {
        //   var permObj = null;
        //   for (var i in permArray) {
        //     permObj = permArray[i];
        //     if (permObj.name === flag) {
        //       returnVal = true;
        //       break;
        //     }
        //   }
        // }

        return !!(permArray.length && _.find(permArray, {name: flag}));
      };

      //display the maintenance page when account list is not available.
      appState.showMaintenance = function () {
        if (!$rootScope.noAccountList) {

          $rootScope.noAccountList = true;
          $location.path('/underMaintenance');
          $window.location.href = $window.location.origin + '/#/underMaintenance';
          var underMaintenanceTimeout = setTimeout(function () {
            $window.location.reload();
            clearTimeout(underMaintenanceTimeout);
          }, 1000);

        }

      };

      appState.checkMaintenance = function (pageName) {
        var result = false;
        if ($rootScope.altMaintenance && $rootScope.altMaintenance[pageName] && $rootScope.altMaintenance[pageName] === true) {
          result = true;
        }
        return result;
      };

      // Maintenance related function - Look up value of maintanance flag based on current URL
      appState.maintenanceRedirect = function (url) {
        // Look it up in flag list
        var returnVal = null;

        // prep the URL for processing
        var urlArray = url.split('/');
        var keyWord = urlArray[1];

        var maintenance = $rootScope.altMaintenance || {};

        if (maintenance.SITE_ON_MAINTENANCE === true) {
          returnVal = true;
        } else if (keyWord === 'rhpc') {
          returnVal = maintenance.HOME_PHONE_ON_MAINTENANCE;

        } else if (keyWord === 'homephone') {
          returnVal = maintenance.HOME_PHONE_ON_MAINTENANCE;
        } else if (keyWord === 'accountOverview') {
          returnVal = maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE;
        }

        return returnVal;
      };

      // Support functions
      appState.findIndex = function (activeNumber, objectArray) {
        // purpose of this is to find the index of the object in array using one of its properties
        var retVal = -1;
        if (objectArray !== null) {
          for (var i = 0; i < objectArray.length; i++) {
            if (objectArray[i].accountNumber === activeNumber) {
              retVal = i;
            }
          }
        }
        return retVal;
      };

      // Event watchers / transmitters
      //$rootScope.$on('$routeChangeSuccess', function (/*event, currentRoute, previousRout*/) {
      //
      //	//appState.module = $routeParams.module;
      //	//appState.submodule = $routeParams.submodule
      //});

      //on language change
      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        appState.language = lang;
      }, 'appStateLangSub');

      // App state change

      // Start
      $rootScope.$on('$stateChangeStart', function (evt, toState, toParams, fromState, fromParams) {
        if (!userService.isSigned()) {
          var sessionCookie = userService.getAuthCookieValue();
          if (!(sessionCookie === null || sessionCookie === undefined || sessionCookie === 'LOGGEDOFF')) {
            var signInUser = localStorage.getLocalStorageValue('ute.rogers.signin.user');
            if (signInUser) {
              try {
                userService.signed(JSON.parse(signInUser));
              } catch (e) {
                userService.signed(signInUser);
              }

              if ($window.globalEasyLogin && typeof $window.globalEasyLogin.trackSecondarySignin === 'function') {
                $window.globalEasyLogin.trackSecondarySignin(); //this function is defined in easylogin.js
              }
            }
          }
        }

        if (toState.name === 'paynow') {
          evt.preventDefault();
          $window.open('/consumer/self-serve/payments/pay', '_self');
        } else if (toState.name === 'viewbill' &&
          (fromState.name === 'utePaynowInteracNotFunded' ||
            fromState.name === 'utePaynowInteracFunded') &&
          userService.getUserType() === 'consumer') {
          if (fromState.name === 'utePaynowInteracNotFunded') {
            toParams.interacFailed = true;
          } else if (fromState.name === 'utePaynowInteracFunded') {
            toParams.interacSuccess = true;
          }
        } else if (toState.name === 'easylogin/main' || toState.name === 'easylogin/registration') {
          if (userService.isSigned()) {
            evt.preventDefault();
            $state.go('accountOverview');
          }
        }

        if (toState.name !== 'paynow') {
          setSubmenu(toState);
        }
      });

      function setSubmenu(state) {
        if (state && state.name) {

          localStorage.setLocalStorageValue('toStateName', state.name);
          if ($rootScope.isCare) {
            sessionStorage.setSessionStorageValue('toStateName', state.name);
          }
          switch (state.name) {
            case 'accountOverview':
            case 'migrateUser':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.overview;
              break;
            case 'guestOverview':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.guestoverview;
              break;
            case 'creditAdjustmentDetails':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
              break;
            case 'creditAdjustmentDetails.display':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
              break;
            case 'paynow':
            case 'viewbill-payment-method':
            case 'viewbill':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
              $rootScope.briteBillIframeCount = 0;
              break;
            case 'paymenthistory':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.billingAndPayment;
              break;
            case 'self-serve':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.profile;
              break;
            case 'profile':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.profile;
              break;
            case 'linkaccount':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'wireless':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'transferOfResponsibility.start':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'transferOfResponsibility.currentCustomer':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'transferOfResponsibility.destinationCustomer':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'wirelessPrepaid':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'prepaidWireless':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'internetdash':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'tvdashboard':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'rhpdashboard':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'shmdashboard':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'oneViewDashboard':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.overview;
              break;
            case 'interaction':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.interaction;
              break;
            case 'shareEverything.dashboard':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'shareEverythingError':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.services;
              break;
            case 'actionsOffers':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.actionsOffers;
              break;
            case 'orders':
              $rootScope.selectedSubMenuItem = $window.subMenuItems.orders;
              break;
          }
        }
      }

      var hideSubMenuStates = ['underMaintenance',
        'linkaccount',
        'signin',
        'forgotUserName',
        'forgotPassword',
        'registration',
        'choose-phone',
        'build-plan',
        'oneViewInterface'];

      // Success
      $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
        if (toState.name !== 'viewbill') {
          window.onpopstate = function (e) {
          };
        }
        $rootScope.currentPageName = $window.location.href;
        $rootScope.currentStateName = toState.name;
        $rootScope.hideSubMenu = (hideSubMenuStates.indexOf(toState.name) !== -1);

        // var accN = localStorage.getLocalStorageValue('accountNumber');
        // if ($rootScope.isCare) {
        //   accN = sessionStorage.getSessionStorageValue('accountNumber');
        // }

        if (!$rootScope.myServicesList && $rootScope.ao.accountActive && (toState.name !== 'accountOverview')) {
          var myrMyServicesService = $injector.get('myrMyServicesService');
          var request = {
            accountNumber: $rootScope.ao.accountActive.accountNumber,
            accountTypeNumber: $rootScope.ao.accountActive.accountTypeNumber,
            language: languageSwitcher.getCurrentLanguage(),
            refresh: false,
            applicationId: 'Rogers.com'
          };

          // with other items in the call
          try {
            request.pinNumber = $rootScope.ao.accountActive.pinNumber;
          } catch (e) {
          }
          try {
            request.phoneNumber = $rootScope.ao.accountActive.phoneNumber;
          } catch (e) {
          }
          try {
            request.indx = $rootScope.ao.accountActiveIndex;
          } catch (e) {
          }

          myrMyServicesService.getAccountDetails(request, function (data) {
            if (data.result !== 'error') {
              $rootScope.ao.accountDetails = data.data;
              var res;

              if ($rootScope.isConsumer) {
                res = myrMyServicesService.getSubscriptions($rootScope.ao.accountDetails.subList, false);
                $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;
              } else if ($rootScope.isCare || $rootScope.isDealer) {
                var disablePermissionNotGranted = [true, true, true], badgePermission;
                badgePermission = ['Maestro_TV_Dashboard', 'Maestro_INT_Dashboard', 'Maestro_RHP_Dashboard'];
                permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
                  if (isPermitted) {
                    if (!_.isArray(badgePermission)) {
                      badgePermission = [badgePermission];
                    }
                    badgePermission.forEach(function (permission) {
                      var uteCommonPermission = _.get(ute.common.permissions.service.RamResourceCodes, permission, permission);
                      permissionsService.getRamPermission(uteCommonPermission, ute.common.permissions.service.RamActionCodes.grant)
                        .then(function (repPermission) {
                          if (repPermission) {
                            disablePermissionNotGranted[index] = false;

                          } else {
                            disablePermissionNotGranted[index] = true;
                          }
                          res = myrMyServicesService.getSubscriptions($rootScope.ao.accountDetails.subList, disablePermissionNotGranted);
                          $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;
                        });

                    });
                  }
                });
              }
            }
          });
        }
      });

      // Error
      $rootScope.$on('$stateChangeError', function (evt, to, toP, from, fromP, err) {
        setSubmenu(from);
        if (to.name === 'wireless' || to.name === 'internetdash') {
          appState.productNoButton = to.name;
          evt.defaultPrevented = true;
          if (!from.name) {
            appState.switchView('accountOverview');
          } else {
            appState.switchView(from.name);
          }
        } else {
          console.error('appState $stateChangeError', evt, to, toP, from, fromP, err);
        }
      });

      appState.getQueryStrings = function () {
        var keyValues = '';
        var queryString = $window.location.href.split('?');
        var userType = $browser.cookies().userType;
        // Query string is now implemented for dealer and care
        //----- /web/totes/#/oneViewDashboard?lang=en&userType=dealer&prov=ON
        if (queryString.length > 1) {
          var oneViewStatusCode = $location.search().statusCode;
          if (oneViewStatusCode === settings.oneViewStatusCodes.sspSSOFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.crmSSOFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.sspAccessFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.crmAccessFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.crmServiceFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.crmServiceFailure ||
            oneViewStatusCode === settings.oneViewStatusCodes.sessionTimeout ||
            oneViewStatusCode === settings.oneViewStatusCodes.crmSignout ||
            oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck ||
            oneViewStatusCode === settings.oneViewStatusCodes.creditOps) {
            scrollPageToTop();					// jshint ignore:line

            if (oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck ||
              oneViewStatusCode === settings.oneViewStatusCodes.creditOps) {
              console.log('$state.current.name : ' + $state.current.name);
              keyValues = appState.getKeyValues();
              $rootScope.isRepView = true;
              sessionStorage.setSessionStorageValue('isRepView', true);
              if (userType) {
                $rootScope.isRepView = sessionStorage.getSessionStorageValue('isRepView');
                if (userType === settings.userType.dealer) {
                  $rootScope.isDealer = true;
                  $rootScope.isConsumer = false;
                  $rootScope.userType = settings.userType.dealer;
                  $rootScope.isOneViewInterface = true;
                } else if (userType === settings.userType.care) {
                  $rootScope.isCare = true;
                  $rootScope.isConsumer = false;
                  $rootScope.userType = settings.userType.care;
                }
              }
            } else {
              appState.switchView('/oneViewInterface');
            }
          } else {
            keyValues = appState.getKeyValues();
          }
        } else {
          if (userType === settings.userType.dealer || userType === settings.userType.care) {
            userService.signed({
              userName: '',
              userEmail: '',
              userType: userType
            });

            if (userType === settings.userType.dealer) {
              $rootScope.isDealer = true;
              $rootScope.isConsumer = false;
            } else if (userType === settings.userType.care) {
              console.log('setting userType in rootscope-care');
              $rootScope.isCare = true;
              $rootScope.isConsumer = false;
            }
            keyValues = [userType];
          } else {
            $browser.cookies('userType', settings.userType.consumer);
            keyValues = '';
          }
        }
        return keyValues;
      };

      appState.isMultiBanAccount = function (data, sourcePath) {
        if (data && data.result === 'success' && data.accountList && data.accountList.length > 1) {
          var origin = $window.location.origin + $window.location.pathname;
          var referrer = ($window.document.referrer || '').toLowerCase();
          if ($state.current && $state.current.name === '' && !appState.multiBANRedirectionDone &&
            referrer.length > 0 && origin !== referrer &&
            referrer.indexOf('consumer/self-serve') === -1 && // coming from Angular application
            referrer.indexOf('web/myrogers/viewbill') === -1 &&
            referrer.indexOf('web/totes/?') === -1) // we initially came from outside totes
          {
            appState.redirectionPath = sourcePath;
            $location.url('/accountOverview?legacy=true');
            return $q.when(true);
          } else {
            return $q.when(false);
          }
        } else {
          return $q.when(false);
        }
      };

      appState.getKeyValues = function () {
        var params = $location.search();
        // if we have the param before #, $location.search() does not find it so we use getURLParamsByName util function to grab it.
        var language = params.lang || util.getURLParamsByName('lang');
        var ut = params.userType;
        var province = params.prov;
        var acctNbr = params.acctNbr;
        if (ut) {
          $browser.cookies('userType', ut);
          userService.signed({
            userName: '',
            userEmail: '',
            userType: ut
          });
        }
        if (language) {
          languageSwitcher.changeLanguage(language);
          appState.language = language;
          $('html').attr('lang', languageSwitcher.getCurrentLanguage()); // Added to update lang value while loading OneView from SSP/ICM with FR
        }
        if (province) {
          userProvince(province);
        }
        if (ut === settings.userType.care && acctNbr) {
          sessionStorage.setSessionStorageValue('accountNumber', acctNbr);
          sessionStorage.setSessionStorageValue('requestedAccountNumber', acctNbr);
          sessionStorage.setSessionStorageValue('userType', ut);
        }
        if (ut === settings.userType.dealer || ut === settings.userType.care) {
          localStorage.clearAllLocalStorageValues();
          if ($rootScope.isCare) {
            sessionStorage.clearAllSessionStorageValues();
          }
          appState.aoFlushScope();
        }

        // Please add the comment why we need this logic here
        // if (!$location.search().referer) {
        //   userService.signed({
        //     userName: '',
        //     userEmail: '',
        //     userPassword: '',
        //     userType: ut
        //   });
        // }

        return [language, ut, province];
      };

      //Get cookie by using only JS
      appState.readCookie = function (cname) {
        //readCookie method is defined in easylogin.js under easy-login-rogers project
        return readCookie(cname, false) || '';
      };

      //Write cookie by using only JS
      appState.setCookie = function (cname, cvalue, path, domain, expires) {
        var cookie = cname + '=' + cvalue + '; ';
        path = 'path=' + (path || '/') + '; ';
        domain = 'domain=' + (domain || '.rogers.com') + '; ';
        if (expires) {
          var d = new Date();
          d.setTime(d.getTime() + (expires * 24 * 60 * 60 * 1000));
          expires = 'expires=' + d.toUTCString() + '; ';
        }
        document.cookie = cookie + path + domain + expires;
      };

      //Remove cookie by using only JS
      appState.removeCookie = function (cname, path, domain) {
        var cookie = cname + '=; ';
        path = 'path=' + (path || '/') + '; ';
        domain = 'domain=' + (domain || '.rogers.com') + '; ';
        document.cookie = cookie + path + domain + 'expires=Thu, 01 Jan 1970 00:00:01 GMT; ';
      };

      appState.redirectToEasyLogin = function (bypassDeeplinkHandling) {
        if (!bypassDeeplinkHandling && _.get($window.location.href.match(/rogers.com/), 'length', 0) > 0) {
          var linkIn = cookieStore.get('linkIn') || appState.readCookie('linkIn');
          var deepJSON = linkIn && linkIn !== '' ? linkIn : $window.location.href;
          if (decodeURIComponent(deepJSON).indexOf('/consumer/myrogers/') < 0 && decodeURIComponent(deepJSON).indexOf('/web/OnlineManager.portal?maestroIndicator=true') < 0) {
            sessionStorage.setSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL, deepJSON);
          }
          // appState.setCookie('deepJSON', deepJSON);
          if (linkIn) {
            cookieStore.remove('linkIn');
            cookieStore.remove('linkIn', {path: '/'});
            appState.removeCookie('linkIn', '/', window.location.host);
            appState.removeCookie('linkIn', '/web/totes', ' '); //To Handle Firefox Issue
            try { /* IE Issue */
              if (appState.isIE()) {
                var cookieString = 'linkIn=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=';
                document.cookie = cookieString + '/;', document.cookie = cookieString + '/web/totes;';
              }
            } catch (err) {
            }
          }
        }
        $window.location.href = '/consumer/easyloginriverpage?showModal=true';
      };

      return appState;
    }]);
}());

'use strict';

angular.module('totesApp')

    .factory('backend', ['settings', '$http', '$q', '$translate', 'userOptions', 'appState', 'localStorage', '$location', '$rootScope', '$browser', 'sessionStorage',
      function (settings, $http, $q, $translate, userOptions, appState, localStorage, $location, $rootScope, $browser, sessionStorage) {

        var protectedUrlPrefix = settings.protectedUrlPrefix;
        var unprotectedUrlPrefix = settings.unProtectedUrlPrefix;
        //		$rootScope.abortList = [];

        function absUrl(relativeUrl, useProtectedPrefix) {
          if (useProtectedPrefix) {
            return protectedUrlPrefix + relativeUrl;
          } else {
            return unprotectedUrlPrefix + relativeUrl;
          }
        }

        /*
         function removeCanceller(cancelObj) {
         for (var i=0; i < $rootScope.abortList.length; i++) {
         if (cancelObj === $rootScope.abortList[i]) {
         delete $rootScope.abortList[i];
         $rootScope.abortList.splice(i,1);
         }
         }
         }
         //*/
        function addParameterToURL(url, param) {
          var _url = url;
          _url += (_url.split('?')[1] ? '&' : '?') + param;
          return _url;
        }

        function handleError(response, override503ErrorHandling) {
          // look for error code and pick action based on that
          var statusCode = response.status;
          var statusText = response.statusText;
          var statusMessage = statusCode + ' - ' + statusText;
          var error = response.data;

          // Compile more informative error message
          var message = '';

          /*
           * Error brackets
           */

          // 0 - 199
          if (statusCode >= 0 && statusCode < 200) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 300 - 399
          if (statusCode >= 300 && statusCode < 400) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 400 - 499
          if (statusCode >= 400 && statusCode < 500) {
            // Session expired or user is trying to access data without proper credentials
            if (settings.showErrorPopup) {
              userOptions.alert(statusMessage);
            }

            // Special treatment
            if (statusCode === 401) {
              // Analyze requester - if this comes from login page -> pass the response back to the controller
              var sourceURL = response.config.url;
              var sourceArray = sourceURL.split('/');
              var sourceLength = sourceArray.length;
              var action = sourceArray[(sourceLength - 1)];

              if (action === 'testlogin' || action === 'signin') {
                // Failed credentials
                return $q.reject({$handled: false, originalError: statusMessage, data: response, action: 'invalidCredentials'});

              } else {
                // Most likely session expired and server is returning 401s
                return $q.reject({$handled: true, originalError: statusMessage, data: response, action: 'userLogout'});
              }
            } else {
              return $q.reject({$handled: false, originalError: statusMessage, data: response});
            }

          } else
          // 500 - 554

          if (statusCode === 503 && !override503ErrorHandling) {
            localStorage.setLocalStorageValue('maintPage', 'siteMaint');
            if ($rootScope.isCare) {
              sessionStorage.setSessionStorageValue('maintPage', 'siteMaint');
            }
            appState.switchView('/underMaintenance');
          }
          if (statusCode >= 500 && statusCode < 555) {
            // error message and popup is allowed by settings
            if (settings.showErrorPopup) {
              //userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});

          } else
          // 555 - Special case
          if (statusCode === 555) {

            // This section HAS TO pass the error through to the controller fo further processing
            // ALSO to have a way for caller functions to deal with the response.

            var retObj = {};
            var resourceId = null;

            if (error === '') {
              // empty / no message
              // Additional logic goes here to treat the error locally

            } else if (angular.isString(error) && error.search(/<html.*>/i) >= 0) {
              // HTML response
              // Additional logic goes here to treat the error locally

            } else {
              // likely JSON response

              /**
               * The following code is for the new backend Processing Wrapper
               * with different error handling for errorCode and errorMessage
               */
              if (angular.isUndefined(error.errorCode) && _.has(error, 'status.code')) {
                error.errorCode = error.status.code;
              }
              if (angular.isUndefined(error.errorMessage) && _.has(error, 'status.codeName')) {
                error.errorMessage = error.status.codeName;
              }
              try {
                if (error.errorCode >= 10000 && error.errorCode < 11000) {
                  // Event range (ususally in step of 100)
                  resourceId = error.errorCode;

                } else if (error.errorCode >= 11000 && error.errorCode < 12000) {
                  // Event range (ususally in step of 100)
                  resourceId = error.errorCode;

                } else if (error.errorCode >= 12000 && error.errorCode < 12100) {
                  // Loyalty special messages
                  if (error.errorMessage === 'A') {
                    // active - do not trigger error message

                  } else if (error.errorMessage === 'S') {
                    // Suspended - trigger error message but show widget
                    resourceId = error.errorCode + '-' + error.errorMessage;

                  } else {
                    // Do not show the widget and do not show the error
                    resourceId = error.errorCode + '-' + error.errorMessage;
                  }

                } else if (error.errorCode >= 50000 && error.errorCode < 51000) {
                  // Server important
                  resourceId = error.errorCode;

                } else {
                  resourceId = '50000';
                }

              } catch (err) {
                resourceId = '50000';
              }

              // map 50000 unknown error message to generic maintainence message
              if (resourceId === 50000) {
                resourceId = 'maintenance_info';
              }

              // Pass the message
              // message += '<small>For customers:</small><br/>';
              message += $translate.instant('' + resourceId);
            }

            //				message = response.statusText? response.statusText: $translate.instant('50000');
            if (settings.showErrorPopup) {
              //userOptions.alert(message);
            }

            // Reject the value back to caller - For local handling
            retObj.errorCode = error.errorCode;
            retObj.errorMessage = error.errorMessage;
            retObj.message = message;
            retObj.statusCode = 555;

            return $q.reject({$handled: false, originalError: statusMessage, data: response, error: retObj});

          } else {
            // Every other status code and some that don't exist
            if (settings.showErrorPopup) {
              //userOptions.alert(statusMessage);
            }
            return $q.reject({$handled: false, originalError: statusMessage, data: response});
          }
        }

        return {
          postUsingAbsoluteUrl: function (absoluteUrl, data, isFormData, headerData, method, enableCaching, override503ErrorHandling) {
            if (!data) {
              data = {};
            }

            var canceller = $q.defer();
            var _method = 'POST';
            if (method) {
              _method = method;
            }
            // $rootScope.abortList.push(canceller);
            var httpRequest;
            var _url = absoluteUrl;
            if (method === 'GET') {
              for (var key in data) {
                _url = addParameterToURL(_url, key + '=' + data[key]);
              }
            }
            if (isFormData) {
              httpRequest = $http.post(
                  _url,
                  $.param(data),
                  {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}
              );
            } else {
              if (method === 'GET') {
                if (typeof (enableCaching) === 'boolean') {
                  httpRequest = $http({
                    method: _method,
                    url: _url,
                    data: data,
                    headers: headerData,
                    transformResponse: undefined,
                    cache: enableCaching
                  });
                } else {
                  httpRequest = $http({
                    method: _method,
                    url: _url,
                    data: data,
                    headers: headerData,
                    transformResponse: undefined
                  });
                }
              } else {
                httpRequest = $http({
                  method: _method,
                  url: _url,
                  data: data,
                  headers: headerData
                });
              }
            }

            //fix for discardAllSmCookies loop
            var isLogoff = absoluteUrl.indexOf('discardAllSmCookies') >= 0;

            var req = httpRequest.then(
                //response is like {config:xx,data:{}, headers: function () {}, status:200, statusText }
                //response.data is what server return to client
                function (response) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    appState.kickOutExpired();
                  }

                  if (response.status > 199 && response.status < 300) {
                    // Something is right
                    var _json = null;
                    _json = response.data;

                    if (!_json || (angular.isString(_json) && _json.search(/<html.*>/i) >= 0)) {
                      // Response is HTML but it is a pass from server. Strip out HTML -> return null instead
                      _json = null;
                    }
                    return _json;

                  } else {
                    // Something is wrong
                    return handleError(response);
                  }

                }, function (errorData) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    appState.kickOutExpired();
                  }

                  return handleError(errorData, override503ErrorHandling);
                }
            );
            return req;
          },

          pathResolver: function (relativeUrl) {
            var returnPath = '';

            // 1) settings
            var defaultLevel = settings.secureCallDefault;
            //var currentModule = $route.current.params.module;

            //Change for ui-router migration - Commented out on Feb 19th 2015 - due to timing issue comming from local storage
            // var toStateName = localStorage.getLocalStorageValue('toStateName');
            // var currentModule = (toStateName) ? toStateName : $state.current.name;
            var currentModule = $location.path(); //$state.current.name
            if (currentModule.charAt(0) === '/') {
              currentModule = currentModule.substr(1);
            }

            //var currentModule2 = $location.path();

            // 2) is page UNsecure call listed?
            var moduleListed = settings.secureCallPages;
            var pID = moduleListed.indexOf(currentModule);
            if (pID >= 0) {
              defaultLevel = false;				// item found in the array  ->  UNsecure call
            } else {
              // index = -1 -> not found, keep the level
            }

            // 3) is the call UNsecure listed
            var callListed = settings.unprotectedCalls;
            var cID = callListed.indexOf(relativeUrl);
            if (cID >= 0) {
              defaultLevel = false;				// item found in the array  ->  UNsecure call
            } else {
              // index = -1 -> not found, keep the level
            }

            // Localhost hack!!!! FIX the real cause!!!!!!!

            if (relativeUrl == 'teamsite/list' && !window.location.hash.match('sidh')) {
              defaultLevel = false;
            }
            if (window.location.hash.match('sidh')) {
              settings.protectedUrlPrefix = '/v1/';
              settings.unProtectedUrlPrefix = '/v1/';
            }
            // End of hack

            var protectedCallListed = settings.protectedCalls;
            var pcID = protectedCallListed.indexOf(relativeUrl);
            if (pcID >= 0) {
              defaultLevel = true;       // item found in the array  ->  secure call
            }

            // 4) switch from true/false for string -> secure / unsecure URL
            if (defaultLevel) {
              // Secure path
              if(relativeUrl === 'tvLanding') {
                returnPath = settings.tvLandingUrlPrefix + relativeUrl;
              }
              else {
                returnPath = settings.protectedUrlPrefix + relativeUrl;
              }
            } else {
              // Unsecure path
              returnPath = settings.unProtectedUrlPrefix + relativeUrl;
            }

            // EXCEPTIONS
            // 5) Special URLs provided for specific modules - custom path overide
            var pageExceptions = settings.moduleCallException;
            if (pageExceptions[currentModule]) {
              returnPath = pageExceptions[currentModule];
            }

            // 6) Special URLs provided for specific calls - custom path overide
            var callExceptions = settings.ajaxCallException;
            if (callExceptions[relativeUrl]) {
              returnPath = callExceptions[relativeUrl];
            }

            // The backend call should not append RogersServices.portal for dealer or care
            // As the authentication is taken care in server side through SSO
            if ($rootScope.isDealer || $rootScope.isCare) {
              returnPath = settings.unProtectedUrlPrefix + relativeUrl;
            }
            return returnPath;
          },

          getFromLocal: function (relativeUrl) {
            // $rootScope.abortList.push(canceller);
            var httpRequest;

            var absoluteUrl = (relativeUrl.indexOf('/') > -1) ? 'api/' + relativeUrl.substr(relativeUrl.lastIndexOf('/'), relativeUrl.length) : 'api/' + relativeUrl;
            var _method = 'GET';
            var data = '';

            httpRequest = $http({
              method: _method,
              url: absoluteUrl,
              data: data
            });

            //fix for discardAllSmCookies loop
            var isLogoff = absoluteUrl.indexOf('discardAllSmCookies') >= 0;

            var req = httpRequest.then(
                //response is like {config:xx,data:{}, headers: function () {}, status:200, statusText }
                //response.data is what server return to client
                function (response) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    appState.kickOutExpired();
                  }

                  if (response.status > 199 && response.status < 300) {
                    // Something is right
                    var _json = null;
                    _json = response.data;

                    if (!_json || (angular.isString(_json) && _json.search(/<html.*>/i) >= 0)) {
                      // Response is HTML but it is a pass from server. Strip out HTML -> return null instead
                      _json = null;
                    }
                    return _json;

                  } else {
                    // Something is wrong
                    return handleError(response);
                  }

                }, function (errorData) {
                  // If server session is expired sent user to sign in!!!
                  if (!isLogoff) {
                    appState.kickOutExpired();
                  }

                  return handleError(errorData);
                }
            );
            return req;

          },

          post: function (relativeUrl, data, moduleName, headerData) {

            if (settings.useLocalAPI) {
              this.getFromLocal(relativeUrl);
            } else {

              var method = '', enableCaching, override503ErrorHandling = false;
              var fullPath = this.pathResolver(relativeUrl);

              //if(relativeUrl === "maintenanceSettings") fullPath = 'http://10.73.115.75:32263/v1/settings'; 
              
              // Ticket TOT-1201 hack
              if (relativeUrl === 'wirelessDashBoard/rlh/staticContent') {
                fullPath = '/cms/page-specific/addons/content/travel/union-pricing.js';
              } else if (relativeUrl === 'briteBillList') { // Ticket TOT-1128
                fullPath = '/rogers_rest/rogers/documents/activatedUserSummary';
                method = 'GET';
                enableCaching = false; //caching should be disabled for brite bill calls.
                override503ErrorHandling = true;
                // } else if (relativeUrl === 'briteBillDownload') { // Ticket PUB2016-22
                //   fullPath = '/rogers_rest/' + data.link + '.pdf';
                //   data = null;
                //   method = 'GET';
              } else if (relativeUrl === 'news') {
                fullPath = settings.oneViewExternalAPIs.news + moduleName;
              } else if (relativeUrl === 'weather') {
                method = 'GET';
                fullPath = settings.oneViewExternalAPIs.weather + moduleName;
              } else if (moduleName === 'pdfDownload') {
                method = 'GET';
                fullPath = relativeUrl;
              } else if (relativeUrl === 'account/session/keepalive') {
                method = 'POST';
                enableCaching = false;
              }

              /* if(relativeUrl === "buy/cart/exit"){
               method = 'GET';
               }*/

              return this.postUsingAbsoluteUrl(fullPath, data, false, headerData, method, enableCaching, override503ErrorHandling);
            }
          },

          postFormData: function (relativeUrl, data, moduleName, headerData) {
            var fullPath = this.pathResolver(relativeUrl);
            return this.postUsingAbsoluteUrl(fullPath, data, true);
          },

          postToNonAPIlocation: function (fullPath, data) {
            return this.postUsingAbsoluteUrl(fullPath, data, true);
          },

          jsonp: function (absUrl) {
            if (!absUrl) {
              return false;
            }

            return $http.jsonp(absUrl).then(
                function (response) {
                  return response.data;

                }, function (response) {
                  handleError(response);
                }
            );
          },
          abort: function () {
            /*
             for (var i=0; i < $rootScope.abortList.length; i++) {
             $rootScope.abortList[i].resolve();
             }
             return;
             //*/
          },
          getOffers: function (request) {
            var deferred = $q.defer();
            var consumerUrl = settings.revolutionGetOffersPrefix + settings.revolutionGetOffers,
                oneViewUrl = settings.oneViewRevolutionGetOffersPrefix + settings.revolutionGetOffers,
                URL = $rootScope.isConsumer === true ? consumerUrl : oneViewUrl;
            $http({
              //url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
              url: URL, //'http://10.10.94.138:9000/selfserve/v1/offer-status',
              //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
              method: 'POST',
              params: request,

              cache: false
            }).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          },
          getRevPermissions: function (request) {
            var deferred = $q.defer();

            $http({
              // url:  'http://10.10.94.138:9000/selfserve/v1/getOffers',
              url: 'http://10.10.94.153:9000/v1/permissions',
              //url: 'http://10.10.91.58:9000/selfserve/v1/offer-status',
              method: 'POST',
              params: request,
              cache: false
            }).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          },
          postExternalAPI: function (request) {
            var deferred = $q.defer();

            /* $http( {
             url: request.url+request.moduleName,
             method: request.method,
             headers: request.headerData
             } ).then( function( result ) {
             deferred.resolve( result );
             return result;

             }, function( error ) {
             deferred.reject( error );
             } );*/
            $http({url: request.url + request.moduleName}).then(function (result) {
              deferred.resolve(result);
              return result;

            }, function (error) {
              deferred.reject(error);
            });
            return deferred.promise;
          }
        };
      }]);
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp')
    .factory('brtHandler', ['$q',
      '$location',
      'ute.common.user.service',
      function ($q,
                $location,
                userService) {
        var brt = {};
        brt.redirectHUPBRTUser = function () {
          var defer = $q.defer();
          if (userService.isSigned()) {
            defer.resolve(true);
          } else {
            $location.path('/signin');
            defer.resolve(true);
          }
          return defer.promise;
        };
        return brt;
    }]);
}());

'use strict';

angular.module('totesApp')
  .factory('btnSettings', ['settings', function (settings) {
    return {
      getSettings: function(accountStatus) {
        var btnSettings = settings.btnSettings;
        var length = btnSettings.length;
        var res, defaultSettings;
        for (var i = 0; i < length; i++) {
          if (btnSettings[i].accountStatus === accountStatus) {
           res = btnSettings[i];
          }
          if (btnSettings[i].accountStatus === 'Default') {
            defaultSettings = btnSettings[i];
          }
        }
        return (res) ? res : defaultSettings;
      }
    };
  }]);


'use strict';


angular.module('totesApp')
    .factory('checkRoute', ['$timeout', function ($timeout) {


        //fnIsRouteValid is function like function (event, next, current) {}
        return function (scope, fnIsRouteValid, invalidCallback) {

            if (!scope.__routeCheckers) {
                scope.__routeCheckers = [];

                scope.$on('$stateChangeStart', function (event, next, current) {

                    var checkers = scope.__routeCheckers;

                    for (var i = 0; i < checkers.length; i++) {
                        var checker = checkers[i];

                        var fnIsRouteValid = checker.fnIsRouteValid;
                        var invalidCallback = checker.invalidCallback;

                        if (!fnIsRouteValid(event, next, current)) {
                            event.preventDefault();
                            if (invalidCallback) {
                                $timeout(invalidCallback);
                                break;
                            }
                        }
                    }

                });


            }

            scope.__routeCheckers.push({
                fnIsRouteValid: fnIsRouteValid,
                invalidCallback: invalidCallback
            });

        };
    }]);

'use strict';

angular
		.module('totesApp')
		.factory('currenciesConfig', function () {

			var currenciesConfig = {
				'currencies': [],
				'addCurrency': function (lang, pref, thou, dec, suf) {
					var obj = {
						'prefix': pref,
						'thousandsDelimiter': thou,
						'decimalDelimiter': dec,
						'suffix': suf
					};
					this.currencies[lang] = obj;
				},
				'getCurrency': function (lang) {
					return this.currencies[lang];
				},
				'getProperty': function (lang, prop) {
					return this.currencies[lang][prop];
				},
				'format': function (lang, val, prefixOverride) {
					var objCurr = this.currencies[lang];
					var prefix = prefixOverride || objCurr.prefix;
          val = val?val:0;
					// ????? Seriously! Does this look right to you? -- NO! we should be using localization and angular's built in
					return (prefix + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,').replace(',', objCurr.thousandsDelimiter).replace('.', objCurr.decimalDelimiter) + objCurr.suffix);
				}
			};

			//ADDS 2 DEFAULT CURRENCIES EN and FR to be used immediately by the currencies filter
			currenciesConfig.addCurrency('en', '$', ',', '.', '');
			currenciesConfig.addCurrency('fr', '', ' ', ',', ' $');

			return currenciesConfig;
		});

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('deeplink', ['$q',
    '$location',
    '$cookieStore',
    '$browser',
    'settings',
    '$rootScope',
    'localStorage',
    'sessionStorage',
    'appState',
    'myrAccountOverviewService',
    'ute.blocks.language.switcher',
    '$window',
    '$timeout',
    'ute.common.user.service',
    'ute.rogers.account.selection.overlay.service',
    function ($q, // jshint ignore:line
              $location,
              $cookieStore,
              $browser,
              settings,
              $rootScope,
              localStorage,
              sessionStorage,
              appState,
              accountOverviewService,
              languageSwitcher,
              $window,
              $timeout,
              userService,
              accountSelectionService) {

      // Initiate Object
      var deeplink = {
        isDeepLinkExists: isDeepLinkExists,
        resetServiceState: resetServiceState
      };
      var legacyDeeplinked = false;
      function setStorage(state, subType) {
        if ($rootScope.isCare) {
          sessionStorage.setSessionStorageValue(state, subType);
        } else {
          localStorage.setLocalStorageValue(state, subType);
        }
      }

      function isDeepLinkExists() {
        return angular.isDefined(sessionStorage.getSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL));
      }

      /**
       * reset service to initial state
       */
      function resetServiceState() {
        deeplink.data = {
          redirect: false,
          state: '',
          direction: ''
        };
      }

      resetServiceState();

      deeplink.signInCheck = function () {
        // $log.info('deeplink.signInCheck');

        var sic = $q.defer();
        var deepStr = '';

        // /web/RogersServices.portal/totes/ is a SM protected - we can not get views, js and etc - current solution to go to the publicly accessible /web/totes/
        if ($window.location.href.indexOf('/web/RogersServices.portal/totes/#/signin') > 0) {
          $window.location.href = '/web/totes/#/signin';
          return;
        }

        var myCurrentPath = $location.absUrl();
        var lockSearch = $browser.cookies().SMLOCK;
        var signSearch = myCurrentPath.indexOf('signin');

        // $log.info('deeplink.signInCheck - myCurrentPath', myCurrentPath);

        if (!(lockSearch > 0 && signSearch > 0)) {
          deepStr = deeplink.deepLink(myCurrentPath);

          if (deepStr !== '') {
            // Most definitely external link
            deeplink.storeData(myCurrentPath);
          }
        }

        sic.resolve(true);				// proceed
        // sic.resolve(false);			// proceed NOT
        return sic.promise;
      };

       deeplink.accountOverviewCheck = function () {
         var sic = $q.defer();
         var deepStr = '';
         var myCurrentPath = $location.absUrl();
         deepStr = deeplink.deepLink(myCurrentPath);

            if (deepStr !== '') {
                deeplink.storeData(deepStr);
           }

       }
      deeplink.internal = function (toStatePath) {
        // $log.info('deeplink.internal');

        // User and Location info
        var userAuth = userService.isSigned();
        var userPath = (toStatePath) ? toStatePath : $location.path();
        // userPath = userPath.toLowerCase();        // LOWERCASE IT ALL!!! :)

        // $log.info('deeplink.internal - userPath', userPath);

        // Split string based on this pattern /:module/:submodule
        var pathArr = userPath.split('/');
        var module = pathArr[1];

        // Login required - grab data from settings
        var pageLogin = settings.pageLoginRequired[module];

        var userState = '';
        if (module === 'signin') {		// Sign page
          // User is already logged in -> sent them back to Account Overview
          if (userAuth === true) {
            userState = 'signin-page-kickback';
          } else {
            userState = 'signin-page-fall-through';
          }

        } else {
          if (userAuth === false && pageLogin === false) {
            // All clear - no need to log in
            userState = 'public-page';
          } else if (userAuth === false && pageLogin === true) {
            // All bad - you NEED to log in
            userState = 'need-login';

          } else if (userAuth === true && pageLogin === false) {
            // All clear - no need to log in - SignIn page exception handled above
            userState = 'loggedin-in-public';

          } else if (userAuth === true && pageLogin === true) {
            // All clear - no need to log in
            userState = 'no-need-login';
          }
        }

        if (userState === 'need-login') {
          var deepStr = '';

          var myCurrentPath = $location.absUrl();
          var lockSearch = myCurrentPath.indexOf('lock');
          var signSearch = myCurrentPath.indexOf('signin');

          deeplink.clearData();		// Cleanup - just in case
          if (!(lockSearch > 0 && signSearch > 0)) {
            // check existing
            deeplink.storeData(myCurrentPath);
          }
        }
      };

      deeplink.redirectCheck = function (toStatePath) {
        // $log.info('deeplink.redirectCheck');
        var defer = $q.defer();
        // Pull data from cookie
        var deepStr = deeplink.restoreData();

        try {
          if (deepStr) {
            deeplink.deepLinkDirection(deepStr);
          } else {
            defer.resolve();
          }
        } catch (err) {
          // Leave it as is -> do nothing
          defer.resolve();
        }

        return defer.promise;
      };

      deeplink.permissionResolverHook = function (data) {
        // $log.info('deeplink.permissionResolverHook');

        var prh = $q.defer();

        var localStorageAccountNumber = null;
        var defaultAccNumber = null;

        try {
          defaultAccNumber = data.accountList[0].accountNumber;
          setStorage('accountNumber', defaultAccNumber);
        } catch (e) {
          // well, well, well ... now we have three holes in the ground
        }

        if (data.accountList.length > 1 && (_.includes(['viewbill', 'paynow', 'profile'], deeplink.data.state))) {
          appState.redirectionPath = deeplink.data.state;
          appState.switchView('accountOverview');
        } else if (data.accountList.length === 0) {
          appState.switchView('guestoverview');
        } else {
          localStorageAccountNumber = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
          if (localStorageAccountNumber) {
            // Last selected account cookie exists --->>> Commence reconstruction
            appState.aoReconstruct(localStorageAccountNumber);

            var selectedAccount = $rootScope.ao.accountActive;
            var request = {
              applicationId: 'Rogers.com',
              accountNumber: selectedAccount.accountNumber,
              accountTypeNumber: selectedAccount.accountTypeNumber,
              pinNumber: selectedAccount.pinNumber,
              phoneNumber: selectedAccount.phoneNumber,
              language: languageSwitcher.getCurrentLanguage(),
              refresh: false
            };

            accountOverviewService.clearAccountDetails();
            accountOverviewService.getAccountDetails(request, function (tmp) {
              if (tmp.result === 'success') {
                var sublist = tmp.data.subList;
                var foundIT = false;

                // Group page states just to find them and allow them for internal deep-link.
                if (_.includes(['viewbill', 'changemethod', 'wireless-plan-change', 'paymenthistory', 'paynow', 'wireless', 'internetdash', 'profile'], deeplink.data.state)) {
                  foundIT = true;
                } else {
                  if (_.includes(['wirelessPrepaid', 'shmdashboard', 'tvdashboard', 'suspended', 'homephone', 'rhpdashboard'], deeplink.data.state)) {
                    // loop through for states that requires other properties to be checked for.
                    for (var i = 0; i < sublist.length; i++) {
                      var item = sublist[i];
                      if (typeof item === 'object') {
                        if (deeplink.data.state === 'wirelessPrepaid' && item.subType === 'CTN' && item.subStatus === 'Active') {
                          setStorage('phoneNumber', item.subNumber);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'shmdashboard' && item.subType === 'Rogers Smart Home Monitoring' && item.subStatus === 'Active') {
                          setStorage('shmAccountNumber', item.serviceNumber);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'tvdashboard' && item.subType === 'Digital TV' && item.subStatus === 'Active') {
                          setStorage('tvAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'rhpdashboard' && item.subType === 'RHPc' && item.subStatus === 'Active') {
                          setStorage('homePhoneNumber', item.subNumber);
                          setStorage('homePhoneAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'suspended' && item.subStatus === 'Suspended') {
                          foundIT = true;
                          break;
                        }
                        if (deeplink.data.state === 'homephone' && item.subType === 'RHPc' && item.subStatus === 'Active') {
                          setStorage('homePhoneNumber', item.subNumber);
                          setStorage('homePhoneAccountNumber', item.subAccountId);
                          foundIT = true;
                          break;
                        }
                      }

                    }
                  }
                }
                if (foundIT === true) {
                  // Internal deeplinking process - go to the destination URL
                  if (appState.maintenanceRedirect(deeplink.data.state)) {
                    $location.path('/underMaintenance');
                  } else {
                    appState.switchView(deeplink.data.state);
                  }
                  prh.resolve(true);       // proceed
                } else {
                  // Send user to Account overview, dashboard you are looking for is not it
                  appState.switchView('accountOverview');
                }
              } else {
                // fail ??? !!  Something
                appState.switchView('accountOverview');
              }
            });
          }
        }

        // prh.resolve(true);       // proceed
        // prh.resolve(false);			// proceed NOT
        // prh.deffer();            // FAIL!!
        return prh.promise;
      };

      // deep linking cruncher - parse / process URLs and behave upon provided conditions
      deeplink.deepLinkIN = function (tempUrlStr, defer) {
        // $log.info('deeplink.deepLinkIN');
        // $log.info('deeplink.deepLinkIN - tempUrlStr', tempUrlStr);

        // Split string based on this pattern /:module/:submodule
        var module = '';
        var mainSection = '';
        var paramSplitUrl = [];
        var hasParamsBeforeHash = tempUrlStr.substr(0, tempUrlStr.indexOf('#')).indexOf('?') !== -1;

        if (!hasParamsBeforeHash) {
          paramSplitUrl = tempUrlStr.split('?'); // strip parameters from internal deeplink
        } else {
          paramSplitUrl[0] = tempUrlStr;
        }

        var pathArr = paramSplitUrl[0].split(/\/\?[0-9a-zA-Z-=&%]*#\/|\/#\//);
        var urlParamsKeyValue;
        var paramObj = {};

        if (paramSplitUrl.length > 1) {
          urlParamsKeyValue = paramSplitUrl[1].split(/&|=/);
          //create a parameter object to be passed to location service
          for (var i = 0; i < urlParamsKeyValue.length; i = i + 2) {
            paramObj[urlParamsKeyValue[i]] = urlParamsKeyValue[i + 1];
          }
        }

        if (pathArr.length > 1) {
          module = pathArr[1];
          var moduleArr = module.split('/');
          if (moduleArr) {
            mainSection = moduleArr[0];
          }
        }

        try {
          // Login required - grab data from settings
          var pageLogin = settings.pageLoginRequired[mainSection];
          if (pageLogin) {
            deeplink.data.redirect = true;
            deeplink.data.direction = 'in';
            deeplink.data.state = mainSection;

            if (!hasParamsBeforeHash && urlParamsKeyValue) {
              $location.path('/' + pathArr[1]).search(paramObj); // provide parameters if exist
            } else {
              $location.path('/' + pathArr[1]);
            }
          } else {
            defer.resolve();
          }
        } catch (err) {
          defer.resolve();
          // failed to confirm page - do nothing and let the regular pocess follow through
        }
      };

      deeplink.deepLinkOUT = function (tempUrlStr) {
        // $log.info('deeplink.deepLinkOUT');
        // $log.info('deeplink.deepLinkOUT - tempUrlStr', tempUrlStr);

        // Button click like behavior
        deeplink.data.direction = 'out';
        tempUrlStr = tempUrlStr.replace('#/signin', '');        // Clean out the sign-in bit

        // TODO: move to eclipseRemoteAPI

        /*Added change to redirect if URL contains IBLc*/
        if (tempUrlStr && tempUrlStr.indexOf('IBLc') >= 0) {
          $window.location.href = tempUrlStr;
        }

        else if (tempUrlStr.search('eclipse')) {
          accountSelectionService.showAccountSelectionOverlay(tempUrlStr.replace(/^-SM-/, ''));
        }

        else {
          $timeout(function () {
            sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
            $window.location.href = tempUrlStr.replace(/^-SM-/, '');
          }, 1100);
        }
      };

      deeplink.deepLinkDirection = function (urlStr, defer) {
        // $log.info('deeplink.deepLinkDirection');

        // rinse out -SM- From the URL
        var tempUrlStr = urlStr;
        var firstPass = deeplink.deepLink(urlStr);

        if (firstPass === '') {
          // Posibly internal link
          deeplink.deepLinkIN(tempUrlStr, defer);

        } else {
          // Most definitely external link
          deeplink.deepLinkOUT(firstPass);
        }
      };

      deeplink.deepLink = function (url) {
        // $log.info('deeplink.deepLink');

        url = (url === undefined) ? '' : url;
        var decode = '';
        var splitUrlArr = url.split('?');
        var parametersSetStr = splitUrlArr[1];
        var tragetString = '';
        var sourceString = '';
        var jwtString = '';

        if (parametersSetStr !== undefined) {
          var parametersSetArr = parametersSetStr.split('&');

          if (parametersSetArr.length > 0) {
            for (var op in parametersSetArr) {
              var opNum = parseInt(op);

              if (typeof opNum === 'number' && opNum >= 0) {
                var tempStr = parametersSetArr[opNum];

                var targetSearch = tempStr.indexOf('TARGET');
                var refSearch = tempStr.indexOf('referer');
                var sourceSearch = tempStr.indexOf('sourceid');
                var legacyRef = tempStr.indexOf('legacyRef')
                if (sourceSearch === 0) {
                  sourceString = tempStr;
                  sourceString = sourceString.replace('sourceid=', '');
                }
                if (targetSearch === 0 || refSearch === 0 || legacyRef === 0) {
                  tragetString = tempStr;
                  //break;
                }
              }
            }
          }
        }

        if (tragetString !== '') {
          var ts = tragetString.indexOf('TARGET');
          var rs = tragetString.indexOf('referer');
          var lr = tragetString.indexOf('legacyRef');
          // make sure that only the first word is removed
          if (ts === 0) {
            tragetString = tragetString.replace('TARGET=', '');
            tragetString = decodeURIComponent(tragetString);			// Once only
          }
          if (rs === 0) {
            tragetString = tragetString.replace('referer=', '');
            tragetString = decodeURIComponent(tragetString);			// Once
            tragetString = decodeURIComponent(tragetString);			// TWICE encoded!!!  WOWsies!!!
          }
          if (lr === 0) {
              tragetString = tragetString.replace('legacyRef=', '');
              tragetString = decodeURIComponent(tragetString);
              legacyDeeplinked = true;
            }
          decode = smUrlDecode(tragetString);								// jshint ignore:line

        }
        // $log.info('deeplink.deepLink - decode', decode);

        // Objectify this to match the rest of the script
        return decode;
      };

      deeplink.settingWcocJwtTokenValue = function () {

         try{
          var wcocDeepJSON = $window.location.href;
             if(wcocDeepJSON.indexOf('sourceid=wcoc') >= 0){
                 var deepSTR = this.deepLink(wcocDeepJSON);
                 var tokenFromWcocPortal = localStorage.getLocalStorageValue('wcocToken');
                 sessionStorage.setSessionStorageValue('wcocDeepSTR', deepSTR);
                 sessionStorage.setSessionStorageValue('wcocJwtToken', tokenFromWcocPortal);
             }
          }
          catch (err){
              //handle error
          }
       }

      deeplink.storeData = function (deepStr) {
        // $log.info('deeplink.storeData');

        // Cookie way
       var deepStrTmp=decodeURIComponent(deepStr);
        if(deepStrTmp && (deepStrTmp.indexOf('/consumer/myrogers/') >= 0|| deepStrTmp.indexOf('/web/OnlineManager.portal?maestroIndicator=true') >= 0)){
          sessionStorage.setSessionStorageValue('solarisDeeplink', deepStr);
          appState.setCookie('solarisDeeplink', deepStr,'/','.rogers.com');
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
          sessionStorage.setSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL, '/web/totes/#/accountOverview?legacy=true');
        }
        else if (legacyDeeplinked){
          sessionStorage.setSessionStorageValue('legacyDeeplink', deepStr);
          appState.setCookie('legacyDeeplink', deepStr,'/','.rogers.com');
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
        }
        else{
        sessionStorage.setSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL, deepStr);
        }

        //appState.setCookie('deepJSON', deepStr);
      };

      deeplink.restoreData = function () {
        // $log.info('deeplink.restoreData');

        var deepJSON = '';

        try {
          deepJSON = sessionStorage.getSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);

          //appState.removeCookie('deepJSON');

          if (deepJSON === undefined || deepJSON === null || deepJSON === 'undefined') {
            deepJSON = '';
          }
        } catch (err) {
          // And that's how the cookie crumble.
        }
        return deepJSON;
      };

      deeplink.clearData = function () {
        // $log.info('deeplink.clearData');

        // Cookie GO away!!
        try {
          // appState.removeCookie('deepJSON');
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL)
        } catch (monster) {
          // "Me no have cooookie??" - Cookie monster
        }
      };

      return deeplink;
    }

  ]);

  angular.module('totesApp').provider('deepLinkingHandler', function () {
    var data;

    return {
      $get: function () {
        return data;
      },
      $set: function (value) {
        data = value;
      }
    };
  });
}());

/*
 *  Warning
 *  Don't use strict for this file as it's based on old code base and needs updated.
 * This file is copied and customized from the existing Rogers.com for encryption the credit card number purpose.
  * The third-party code used in this file was created in 2005 and doesn't pass the jshint,to keep the functionality working, this file has been excluded from the jshint.
  * Ideally, we should introduce an upgraded version of a Javascript encryption algorithm to replace this piece of code.
   * */
angular.module('totesApp')
    .factory('encryption', function () {

// Augment the basic prototypes if they have not already been augmented.
// These forms are obsolete. It is recommended that JSON.stringify and
// JSON.parse be used instead.

//}// prng4.js - uses Arcfour as a PRNG

        function Arcfour() {
            this.i = 0;
            this.j = 0;
            this.S = new Array();
        }

// Initialize arcfour context from key, an array of ints, each from [0..255]
        function ARC4init(key) {
            var i, j, t;
            for(i = 0; i < 256; ++i)
                this.S[i] = i;
            j = 0;
            for(i = 0; i < 256; ++i) {
                j = (j + this.S[i] + key[i % key.length]) & 255;
                t = this.S[i];
                this.S[i] = this.S[j];
                this.S[j] = t;
            }
            this.i = 0;
            this.j = 0;
        }

        function ARC4next() {
            var t;
            this.i = (this.i + 1) & 255;
            this.j = (this.j + this.S[this.i]) & 255;
            t = this.S[this.i];
            this.S[this.i] = this.S[this.j];
            this.S[this.j] = t;
            return this.S[(t + this.S[this.i]) & 255];
        }

        Arcfour.prototype.init = ARC4init;
        Arcfour.prototype.next = ARC4next;

// Plug in your RNG constructor here
        function prng_newstate() {
            return new Arcfour();
        }

// Pool size must be a multiple of 4 and greater than 32.
// An array of bytes the size of the pool will be passed to init()
        var rng_psize = 256;
// Random number generator - requires a PRNG backend, e.g. prng4.js

// For best results, put code like
// <body onClick='rng_seed_time();' onKeyPress='rng_seed_time();'>
// in your main HTML document.

        var rng_state;
        var rng_pool;
        var rng_pptr;

// Mix in a 32-bit integer into the pool
        function rng_seed_int(x) {
            rng_pool[rng_pptr++] ^= x & 255;
            rng_pool[rng_pptr++] ^= (x >> 8) & 255;
            rng_pool[rng_pptr++] ^= (x >> 16) & 255;
            rng_pool[rng_pptr++] ^= (x >> 24) & 255;
            if(rng_pptr >= rng_psize) rng_pptr -= rng_psize;
        }

// Mix in the current time (w/milliseconds) into the pool
        function rng_seed_time() {
            rng_seed_int(new Date().getTime());
        }

// Initialize the pool with junk if needed.
        if(rng_pool == null) {
            rng_pool = new Array();
            rng_pptr = 0;
            var t;
            if(navigator.appName == "Netscape" && navigator.appVersion < "5" && window.crypto) {
                // Extract entropy (256 bits) from NS4 RNG if available
                var z = window.crypto.random(32);
                for(t = 0; t < z.length; ++t)
                    rng_pool[rng_pptr++] = z.charCodeAt(t) & 255;
            }
            while(rng_pptr < rng_psize) {  // extract some randomness from Math.random()
                t = Math.floor(65536 * Math.random());
                rng_pool[rng_pptr++] = t >>> 8;
                rng_pool[rng_pptr++] = t & 255;
            }
            rng_pptr = 0;
            rng_seed_time();
            //rng_seed_int(window.screenX);
            //rng_seed_int(window.screenY);
        }

        function rng_get_byte() {
            if(rng_state == null) {
                rng_seed_time();
                rng_state = prng_newstate();
                rng_state.init(rng_pool);
                for(rng_pptr = 0; rng_pptr < rng_pool.length; ++rng_pptr)
                    rng_pool[rng_pptr] = 0;
                rng_pptr = 0;
                //rng_pool = null;
            }
            // TODO: allow reseeding after first request
            return rng_state.next();
        }

        function rng_get_bytes(ba) {
            var i;
            for(i = 0; i < ba.length; ++i) ba[i] = rng_get_byte();
        }

        function SecureRandom() {}

        SecureRandom.prototype.nextBytes = rng_get_bytes;
// Depends on jsbn.js and rng.js

// Version 1.1: support utf-8 encoding in pkcs1pad2

// convert a (hex) string to a bignum object
        function parseBigInt(str,r) {
            return new BigInteger(str,r);
        }

        function linebrk(s,n) {
            var ret = "";
            var i = 0;
            while(i + n < s.length) {
                ret += s.substring(i,i+n) + "\n";
                i += n;
            }
            return ret + s.substring(i,s.length);
        }

        function byte2Hex(b) {
            if(b < 0x10)
                return "0" + b.toString(16);
            else
                return b.toString(16);
        }

// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
        function pkcs1pad2(s,n) {
            if(n < s.length + 11) { // TODO: fix for utf-8
                alert("Message too long for RSA");
                return null;
            }
            var ba = new Array();
            var i = s.length - 1;
            while(i >= 0 && n > 0) {
                var c = s.charCodeAt(i--);
                if(c < 128) { // encode using utf-8
                    ba[--n] = c;
                }
                else if((c > 127) && (c < 2048)) {
                    ba[--n] = (c & 63) | 128;
                    ba[--n] = (c >> 6) | 192;
                }
                else {
                    ba[--n] = (c & 63) | 128;
                    ba[--n] = ((c >> 6) & 63) | 128;
                    ba[--n] = (c >> 12) | 224;
                }
            }
            ba[--n] = 0;
            var rng = new SecureRandom();
            var x = new Array();
            while(n > 2) { // random non-zero pad
                x[0] = 0;
                while(x[0] == 0) rng.nextBytes(x);
                ba[--n] = x[0];
            }
            ba[--n] = 2;
            ba[--n] = 0;
            return new BigInteger(ba);
        }

// "empty" RSA key constructor
        function RSAKey() {
            this.n = null;
            this.e = 0;
            this.d = null;
            this.p = null;
            this.q = null;
            this.dmp1 = null;
            this.dmq1 = null;
            this.coeff = null;
        }

// Set the public key fields N and e from hex strings
        function RSASetPublic(N,E) {
            if(N != null && E != null && N.length > 0 && E.length > 0) {
                this.n = parseBigInt(N,16);
                this.e = parseInt(E,16);
            }
            else
                alert("Invalid RSA public key");
        }

// Perform raw public operation on "x": return x^e (mod n)
        function RSADoPublic(x) {
            return x.modPowInt(this.e, this.n);
        }

// Return the PKCS#1 RSA encryption of "text" as an even-length hex string
        function RSAEncrypt(text) {
            var m = pkcs1pad2(text,(this.n.bitLength()+7)>>3);
            if(m == null) return null;
            var c = this.doPublic(m);
            if(c == null) return null;
            var h = c.toString(16);
            if((h.length & 1) == 0) return h; else return "0" + h;
        }

// Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
//function RSAEncryptB64(text) {
//  var h = this.encrypt(text);
//  if(h) return hex2b64(h); else return null;
//}

// protected
        RSAKey.prototype.doPublic = RSADoPublic;

// public
        RSAKey.prototype.setPublic = RSASetPublic;
        RSAKey.prototype.encrypt = RSAEncrypt;
//RSAKey.prototype.encrypt_b64 = RSAEncryptB64;
        var b64map="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
        var b64pad="=";

        function hex2b64(h) {
            var i;
            var c;
            var ret = "";
            for(i = 0; i+3 <= h.length; i+=3) {
                c = parseInt(h.substring(i,i+3),16);
                ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63);
            }
            if(i+1 == h.length) {
                c = parseInt(h.substring(i,i+1),16);
                ret += b64map.charAt(c << 2);
            }
            else if(i+2 == h.length) {
                c = parseInt(h.substring(i,i+2),16);
                ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4);
            }
            while((ret.length & 3) > 0) ret += b64pad;
            return ret;
        }

// convert a base64 string to hex
        function b64tohex(s) {
            var ret = ""
            var i;
            var k = 0; // b64 state, 0-3
            var slop;
            for(i = 0; i < s.length; ++i) {
                if(s.charAt(i) == b64pad) break;
                v = b64map.indexOf(s.charAt(i));
                if(v < 0) continue;
                if(k == 0) {
                    ret += int2char(v >> 2);
                    slop = v & 3;
                    k = 1;
                }
                else if(k == 1) {
                    ret += int2char((slop << 2) | (v >> 4));
                    slop = v & 0xf;
                    k = 2;
                }
                else if(k == 2) {
                    ret += int2char(slop);
                    ret += int2char(v >> 2);
                    slop = v & 3;
                    k = 3;
                }
                else {
                    ret += int2char((slop << 2) | (v >> 4));
                    ret += int2char(v & 0xf);
                    k = 0;
                }
            }
            if(k == 1)
                ret += int2char(slop << 2);
            return ret;
        }

// convert a base64 string to a byte/number array
        function b64toBA(s) {
            //piggyback on b64tohex for now, optimize later
            var h = b64tohex(s);
            var i;
            var a = new Array();
            for(i = 0; 2*i < h.length; ++i) {
                a[i] = parseInt(h.substring(2*i,2*i+2),16);
            }
            return a;
        }



// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Basic JavaScript BN library - subset useful for RSA encryption.

// Bits per digit
        var dbits;

// JavaScript engine analysis
        var canary = 0xdeadbeefcafe;
        var j_lm = ((canary&0xffffff)==0xefcafe);

// (public) Constructor
        function BigInteger(a,b,c) {
            if(a != null)
                //if("number" == typeof a) this.fromNumber(a,b,c);
                if("number" == typeof a) this.fromInt(a);
                else if(b == null && "string" != typeof a) this.fromString(a,256);
                else this.fromString(a,b);
        }

// return new, unset BigInteger
        function nbi() { return new BigInteger(null); }

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
        function am1(i,x,w,j,c,n) {
            while(--n >= 0) {
                var v = x*this[i++]+w[j]+c;
                c = Math.floor(v/0x4000000);
                w[j++] = v&0x3ffffff;
            }
            return c;
        }
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
        function am2(i,x,w,j,c,n) {
            var xl = x&0x7fff, xh = x>>15;
            while(--n >= 0) {
                var l = this[i]&0x7fff;
                var h = this[i++]>>15;
                var m = xh*l+h*xl;
                l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
                c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
                w[j++] = l&0x3fffffff;
            }
            return c;
        }
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
        function am3(i,x,w,j,c,n) {
            var xl = x&0x3fff, xh = x>>14;
            while(--n >= 0) {
                var l = this[i]&0x3fff;
                var h = this[i++]>>14;
                var m = xh*l+h*xl;
                l = xl*l+((m&0x3fff)<<14)+w[j]+c;
                c = (l>>28)+(m>>14)+xh*h;
                w[j++] = l&0xfffffff;
            }
            return c;
        }
        if(j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
            BigInteger.prototype.am = am2;
            dbits = 30;
        }
        else if(j_lm && (navigator.appName != "Netscape")) {
            BigInteger.prototype.am = am1;
            dbits = 26;
        }
        else { // Mozilla/Netscape seems to prefer am3
            BigInteger.prototype.am = am3;
            dbits = 28;
        }

        BigInteger.prototype.DB = dbits;
        BigInteger.prototype.DM = ((1<<dbits)-1);
        BigInteger.prototype.DV = (1<<dbits);

        var BI_FP = 52;
        BigInteger.prototype.FV = Math.pow(2,BI_FP);
        BigInteger.prototype.F1 = BI_FP-dbits;
        BigInteger.prototype.F2 = 2*dbits-BI_FP;

// Digit conversions
        var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
        var BI_RC = new Array();
        var rr,vv;
        rr = "0".charCodeAt(0);
        for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
        rr = "a".charCodeAt(0);
        for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
        rr = "A".charCodeAt(0);
        for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

        function int2char(n) { return BI_RM.charAt(n); }
        function intAt(s,i) {
            var c = BI_RC[s.charCodeAt(i)];
            return (c==null)?-1:c;
        }

// (protected) copy this to r
        function bnpCopyTo(r) {
            for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
            r.t = this.t;
            r.s = this.s;
        }

// (protected) set from integer value x, -DV <= x < DV
        function bnpFromInt(x) {
            this.t = 1;
            this.s = (x<0)?-1:0;
            if(x > 0) this[0] = x;
            else if(x < -1) this[0] = x+this.DV;
            else this.t = 0;
        }

// return bigint initialized to value
        function nbv(i) { var r = nbi(); r.fromInt(i); return r; }

// (protected) set from string and radix
        function bnpFromString(s,b) {
            var k;
            if(b == 16) k = 4;
            else if(b == 8) k = 3;
            else if(b == 256) k = 8; // byte array
            else if(b == 2) k = 1;
            else if(b == 32) k = 5;
            else if(b == 4) k = 2;
            else { this.fromRadix(s,b); return; }
            this.t = 0;
            this.s = 0;
            var i = s.length, mi = false, sh = 0;
            while(--i >= 0) {
                var x = (k==8)?s[i]&0xff:intAt(s,i);
                if(x < 0) {
                    if(s.charAt(i) == "-") mi = true;
                    continue;
                }
                mi = false;
                if(sh == 0)
                    this[this.t++] = x;
                else if(sh+k > this.DB) {
                    this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
                    this[this.t++] = (x>>(this.DB-sh));
                }
                else
                    this[this.t-1] |= x<<sh;
                sh += k;
                if(sh >= this.DB) sh -= this.DB;
            }
            if(k == 8 && (s[0]&0x80) != 0) {
                this.s = -1;
                if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
            }
            this.clamp();
            if(mi) BigInteger.ZERO.subTo(this,this);
        }

// (protected) clamp off excess high words
        function bnpClamp() {
            var c = this.s&this.DM;
            while(this.t > 0 && this[this.t-1] == c) --this.t;
        }

// (public) return string representation in given radix
        function bnToString(b) {
            if(this.s < 0) return "-"+this.negate().toString(b);
            var k;
            if(b == 16) k = 4;
            else if(b == 8) k = 3;
            else if(b == 2) k = 1;
            else if(b == 32) k = 5;
            else if(b == 4) k = 2;
            else return this.toRadix(b);
            var km = (1<<k)-1, d, m = false, r = "", i = this.t;
            var p = this.DB-(i*this.DB)%k;
            if(i-- > 0) {
                if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
                while(i >= 0) {
                    if(p < k) {
                        d = (this[i]&((1<<p)-1))<<(k-p);
                        d |= this[--i]>>(p+=this.DB-k);
                    }
                    else {
                        d = (this[i]>>(p-=k))&km;
                        if(p <= 0) { p += this.DB; --i; }
                    }
                    if(d > 0) m = true;
                    if(m) r += int2char(d);
                }
            }
            return m?r:"0";
        }

// (public) -this
        function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }

// (public) |this|
        function bnAbs() { return (this.s<0)?this.negate():this; }

// (public) return + if this > a, - if this < a, 0 if equal
        function bnCompareTo(a) {
            var r = this.s-a.s;
            if(r != 0) return r;
            var i = this.t;
            r = i-a.t;
            if(r != 0) return (this.s<0)?-r:r;
            while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
            return 0;
        }

// returns bit length of the integer x
        function nbits(x) {
            var r = 1, t;
            if((t=x>>>16) != 0) { x = t; r += 16; }
            if((t=x>>8) != 0) { x = t; r += 8; }
            if((t=x>>4) != 0) { x = t; r += 4; }
            if((t=x>>2) != 0) { x = t; r += 2; }
            if((t=x>>1) != 0) { x = t; r += 1; }
            return r;
        }

// (public) return the number of bits in "this"
        function bnBitLength() {
            if(this.t <= 0) return 0;
            return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
        }

// (protected) r = this << n*DB
        function bnpDLShiftTo(n,r) {
            var i;
            for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
            for(i = n-1; i >= 0; --i) r[i] = 0;
            r.t = this.t+n;
            r.s = this.s;
        }

// (protected) r = this >> n*DB
        function bnpDRShiftTo(n,r) {
            for(var i = n; i < this.t; ++i) r[i-n] = this[i];
            r.t = Math.max(this.t-n,0);
            r.s = this.s;
        }

// (protected) r = this << n
        function bnpLShiftTo(n,r) {
            var bs = n%this.DB;
            var cbs = this.DB-bs;
            var bm = (1<<cbs)-1;
            var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
            for(i = this.t-1; i >= 0; --i) {
                r[i+ds+1] = (this[i]>>cbs)|c;
                c = (this[i]&bm)<<bs;
            }
            for(i = ds-1; i >= 0; --i) r[i] = 0;
            r[ds] = c;
            r.t = this.t+ds+1;
            r.s = this.s;
            r.clamp();
        }

// (protected) r = this >> n
        function bnpRShiftTo(n,r) {
            r.s = this.s;
            var ds = Math.floor(n/this.DB);
            if(ds >= this.t) { r.t = 0; return; }
            var bs = n%this.DB;
            var cbs = this.DB-bs;
            var bm = (1<<bs)-1;
            r[0] = this[ds]>>bs;
            for(var i = ds+1; i < this.t; ++i) {
                r[i-ds-1] |= (this[i]&bm)<<cbs;
                r[i-ds] = this[i]>>bs;
            }
            if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
            r.t = this.t-ds;
            r.clamp();
        }

// (protected) r = this - a
        function bnpSubTo(a,r) {
            var i = 0, c = 0, m = Math.min(a.t,this.t);
            while(i < m) {
                c += this[i]-a[i];
                r[i++] = c&this.DM;
                c >>= this.DB;
            }
            if(a.t < this.t) {
                c -= a.s;
                while(i < this.t) {
                    c += this[i];
                    r[i++] = c&this.DM;
                    c >>= this.DB;
                }
                c += this.s;
            }
            else {
                c += this.s;
                while(i < a.t) {
                    c -= a[i];
                    r[i++] = c&this.DM;
                    c >>= this.DB;
                }
                c -= a.s;
            }
            r.s = (c<0)?-1:0;
            if(c < -1) r[i++] = this.DV+c;
            else if(c > 0) r[i++] = c;
            r.t = i;
            r.clamp();
        }

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
        function bnpMultiplyTo(a,r) {
            var x = this.abs(), y = a.abs();
            var i = x.t;
            r.t = i+y.t;
            while(--i >= 0) r[i] = 0;
            for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
            r.s = 0;
            r.clamp();
            if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
        }

// (protected) r = this^2, r != this (HAC 14.16)
        function bnpSquareTo(r) {
            var x = this.abs();
            var i = r.t = 2*x.t;
            while(--i >= 0) r[i] = 0;
            for(i = 0; i < x.t-1; ++i) {
                var c = x.am(i,x[i],r,2*i,0,1);
                if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
                    r[i+x.t] -= x.DV;
                    r[i+x.t+1] = 1;
                }
            }
            if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
            r.s = 0;
            r.clamp();
        }

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
        function bnpDivRemTo(m,q,r) {
            var pm = m.abs();
            if(pm.t <= 0) return;
            var pt = this.abs();
            if(pt.t < pm.t) {
                if(q != null) q.fromInt(0);
                if(r != null) this.copyTo(r);
                return;
            }
            if(r == null) r = nbi();
            var y = nbi(), ts = this.s, ms = m.s;
            var nsh = this.DB-nbits(pm[pm.t-1]);	// normalize modulus
            if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
            else { pm.copyTo(y); pt.copyTo(r); }
            var ys = y.t;
            var y0 = y[ys-1];
            if(y0 == 0) return;
            var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
            var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
            var i = r.t, j = i-ys, t = (q==null)?nbi():q;
            y.dlShiftTo(j,t);
            if(r.compareTo(t) >= 0) {
                r[r.t++] = 1;
                r.subTo(t,r);
            }
            BigInteger.ONE.dlShiftTo(ys,t);
            t.subTo(y,y);	// "negative" y so we can replace sub with am later
            while(y.t < ys) y[y.t++] = 0;
            while(--j >= 0) {
                // Estimate quotient digit
                var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
                if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {	// Try it out
                    y.dlShiftTo(j,t);
                    r.subTo(t,r);
                    while(r[i] < --qd) r.subTo(t,r);
                }
            }
            if(q != null) {
                r.drShiftTo(ys,q);
                if(ts != ms) BigInteger.ZERO.subTo(q,q);
            }
            r.t = ys;
            r.clamp();
            if(nsh > 0) r.rShiftTo(nsh,r);	// Denormalize remainder
            if(ts < 0) BigInteger.ZERO.subTo(r,r);
        }

// (public) this mod a
        function bnMod(a) {
            var r = nbi();
            this.abs().divRemTo(a,null,r);
            if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
            return r;
        }

// Modular reduction using "classic" algorithm
        function Classic(m) { this.m = m; }
        function cConvert(x) {
            if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
            else return x;
        }
        function cRevert(x) { return x; }
        function cReduce(x) { x.divRemTo(this.m,null,x); }
        function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
        function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

        Classic.prototype.convert = cConvert;
        Classic.prototype.revert = cRevert;
        Classic.prototype.reduce = cReduce;
        Classic.prototype.mulTo = cMulTo;
        Classic.prototype.sqrTo = cSqrTo;

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
        function bnpInvDigit() {
            if(this.t < 1) return 0;
            var x = this[0];
            if((x&1) == 0) return 0;
            var y = x&3;		// y == 1/x mod 2^2
            y = (y*(2-(x&0xf)*y))&0xf;	// y == 1/x mod 2^4
            y = (y*(2-(x&0xff)*y))&0xff;	// y == 1/x mod 2^8
            y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;	// y == 1/x mod 2^16
            // last step - calculate inverse mod DV directly;
            // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
            y = (y*(2-x*y%this.DV))%this.DV;		// y == 1/x mod 2^dbits
            // we really want the negative inverse, and -DV < y < DV
            return (y>0)?this.DV-y:-y;
        }

// Montgomery reduction
        function Montgomery(m) {
            this.m = m;
            this.mp = m.invDigit();
            this.mpl = this.mp&0x7fff;
            this.mph = this.mp>>15;
            this.um = (1<<(m.DB-15))-1;
            this.mt2 = 2*m.t;
        }

// xR mod m
        function montConvert(x) {
            var r = nbi();
            x.abs().dlShiftTo(this.m.t,r);
            r.divRemTo(this.m,null,r);
            if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
            return r;
        }

// x/R mod m
        function montRevert(x) {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }

// x = x/R mod m (HAC 14.32)
        function montReduce(x) {
            while(x.t <= this.mt2)	// pad x so am has enough room later
                x[x.t++] = 0;
            for(var i = 0; i < this.m.t; ++i) {
                // faster way of calculating u0 = x[i]*mp mod DV
                var j = x[i]&0x7fff;
                var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
                // use am to combine the multiply-shift-add into one call
                j = i+this.m.t;
                x[j] += this.m.am(0,u0,x,i,0,this.m.t);
                // propagate carry
                while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
            }
            x.clamp();
            x.drShiftTo(this.m.t,x);
            if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
        }

// r = "x^2/R mod m"; x != r
        function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

// r = "xy/R mod m"; x,y != r
        function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

        Montgomery.prototype.convert = montConvert;
        Montgomery.prototype.revert = montRevert;
        Montgomery.prototype.reduce = montReduce;
        Montgomery.prototype.mulTo = montMulTo;
        Montgomery.prototype.sqrTo = montSqrTo;

// (protected) true iff this is even
        function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }

// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
        function bnpExp(e,z) {
            if(e > 0xffffffff || e < 1) return BigInteger.ONE;
            var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
            g.copyTo(r);
            while(--i >= 0) {
                z.sqrTo(r,r2);
                if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
                else { var t = r; r = r2; r2 = t; }
            }
            return z.revert(r);
        }

// (public) this^e % m, 0 <= e < 2^32
        function bnModPowInt(e,m) {
            var z;
            if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
            return this.exp(e,z);
        }

// protected
        BigInteger.prototype.copyTo = bnpCopyTo;
        BigInteger.prototype.fromInt = bnpFromInt;
        BigInteger.prototype.fromString = bnpFromString;
        BigInteger.prototype.clamp = bnpClamp;
        BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
        BigInteger.prototype.drShiftTo = bnpDRShiftTo;
        BigInteger.prototype.lShiftTo = bnpLShiftTo;
        BigInteger.prototype.rShiftTo = bnpRShiftTo;
        BigInteger.prototype.subTo = bnpSubTo;
        BigInteger.prototype.multiplyTo = bnpMultiplyTo;
        BigInteger.prototype.squareTo = bnpSquareTo;
        BigInteger.prototype.divRemTo = bnpDivRemTo;
        BigInteger.prototype.invDigit = bnpInvDigit;
        BigInteger.prototype.isEven = bnpIsEven;
        BigInteger.prototype.exp = bnpExp;

// public
        BigInteger.prototype.toString = bnToString;
        BigInteger.prototype.negate = bnNegate;
        BigInteger.prototype.abs = bnAbs;
        BigInteger.prototype.compareTo = bnCompareTo;
        BigInteger.prototype.bitLength = bnBitLength;
        BigInteger.prototype.mod = bnMod;
        BigInteger.prototype.modPowInt = bnModPowInt;

// "constants"
        BigInteger.ZERO = nbv(0);
        BigInteger.ONE = nbv(1);

        //serivce return object
        function encrptCard(idNumber, modulus, exponent) {
            var rsa = new RSAKey();
            rsa.setPublic(modulus, exponent);
            var encryptCardNumber = rsa.encrypt(idNumber);
            //hex2b64(encriptCardNumber);

            //alert(encryptCardNumber);
            return hex2b64(encryptCardNumber);
        }

        return  encrptCard;
    })


'use strict';
/**
 * Created by Derek Gu on March 2, 2015
 */

angular.module('totesApp')
	.factory('errorHandler', ['$translate',
	function ($translate) {
		return {
			/**
			 * This is a helper function that extract the error description that can be
			 * displayed to end-user from the error object returned from backend.js.
			 * Note this function will return a generic maintenance message for non-555
			 * errors, for specific treatment controller should implement additional logic
			 * case-by-case.
			 */
			getErrorDescription: function(error) {
				if (!!error.data.status && error.data.status === 555 && !!error.error.message) {
					return error.error.message;
				}
				return $translate.instant('maintenance_info');
			}
		};
}]);

'use strict';
//angular.module('totesApp')
//  .factory('$exceptionHandler', function ($injector) {
//    return function(exception, cause) {
//      var $rootScope = $injector.get('$rootScope');
//      $rootScope.errors = $rootScope || [];
//      $rootScope.errors.push[exception.message];
//    }
//  });

(function () {
  'use strict';

  angular.module('totesApp').factory('landing', landingService);

  landingService.$inject = ['myrProfileFactory',
    '$q',
    'migrateUserService',
    'localStorage',
    '$state',
    'globalloaderService'];

  /* @ngInject */
  function landingService(myrProfileFactory,
                          $q,
                          migrateuserService,
                          localStorage,
                          $state,
                          globalloaderService) {
    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var landingServiceObj = {
      landingRedirect: landingRedirect
    };

    var defer;

    return landingServiceObj;

    function landingRedirect() {
      defer = $q.defer();
      myrProfileFactory
          .isSecurityQuestionComplete()
          .then(securityQuestionComplete, securityQuestionIncomplete);
      return defer.promise;
    }

    function securityQuestionComplete() {
      migrateuserService.migrateCheck().then(function (needMigrate) {
        if (needMigrate) {
          $state.go('migrateUser');
          return;
        }

        localStorage.setLocalStorageValue('usernameMigrationComplete', 'true');
        myrProfileFactory.registrationCompleteSignin();
        globalloaderService.hide();
        defer.resolve(true);
      });
    }

    function securityQuestionIncomplete() {
      $state.go('completeProfile');
    }
  }
})();

'use strict';

angular
    .module('totesApp').factory('localStorage', ['$window',
  function ($window) {
    var localStorage = {};

    // Read
    localStorage.getLocalStorageValue = function (key) {
      return $window.localStorage.getItem(key);
    };
    localStorage.getLocalStorageObject = function (key) {
      var valueString = $window.localStorage.getItem(key);
      return angular.fromJson(valueString);
    };

    // Write
    localStorage.setLocalStorageValue = function (key, val) {
      $window.localStorage.setItem(key, val);
    };
    localStorage.setLocalStorageObject = function (key, val) {
      var valueString = angular.toJson(val);
      $window.localStorage.setItem(key, valueString);
    };

    // Delete
    localStorage.deleteLocalStorageValue = function (key) {
      $window.localStorage.removeItem(key);
    };
    localStorage.deleteLocalStorageObject = function (key) {
      this.deleteLocalStorageValue(key);
    };

    // Clear all
    localStorage.clearAllLocalStorageValues = function () {
      // console.log('inside clearalllocalstorage');
      while ($window.localStorage.length > 0) {
        $window.localStorage.removeItem($window.localStorage.key(0));
      }
    };

    // Clear all except those mentioned in the array
    localStorage.clearAllLocalStorageValuesExcept = function (theseArr) {
      while ($window.localStorage.length > 0) {
        var keyIndex = theseArr.indexOf($window.localStorage.key(0));
        if (keyIndex < 0) {
          $window.localStorage.removeItem($window.localStorage.key(0));
        }
      }
    };

    return localStorage;
  }
]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('permissionResolver', ['$q',
    '$location',
    'settings',
    'ajax',
    '$rootScope',
    'myrAccountListService',
    'appState',
    'userOptions',
    '$translate',
    'localStorage',
    '$window',
    'deeplink',
    'landing',
    'user',
    'myrAccountOverviewService',
    'sessionStorage',
    'ute.common.security.service',
    '$timeout',
    'ute.common.user.service',
    function ($q, // jshint ignore:line
              $location,
              settings,
              ajax,
              $rootScope,
              myrAccountListService,
              appState,
              userOptions,
              $translate,
              localStorage,
              $window,
              deeplink,
              landing,
              user,
              accountOverviewService,
              sessionStorage,
              securityService,
              $timeout,
              userService) {
      // Initiate Object
      var pr = {};

      // hook up variables
      pr.data = {};

      function wcocRedirection(data, wcocDeepStr) {
        $timeout(function () {
          localStorage.setLocalStorageValue('wcocToken', data);
          sessionStorage.deleteSessionStorageValue('wcocDeepSTR');
          sessionStorage.deleteSessionStorageValue('wcocJwtToken');
          $window.location.href = wcocDeepStr + '?entryId=D';
        }, 1100);
      }

      // function getCookie(cname) {
      //   var name = cname + '=';
      //   var ca = document.cookie.split(';');
      //   for (var i = 0; i < ca.length; i++) {
      //     var c = ca[i];
      //     while (c.charAt(0) === ' ') {
      //       c = c.substring(1);
      //     }
      //     if (c.indexOf(name) === 0) {
      //       return c.substring(name.length, c.length);
      //     }
      //   }
      //   return '';
      // }

      function isDeeplinkingOrLegacy() {
        var paths = $location.search();
        if (!!paths && (!!paths.referer || !!paths.TARGET)) {
          $window.open(decodeURIComponent(paths.referer || paths.TARGET), '_self');
          return true;
        }

        // if we are intentionally redirected to #/accountOverview?legacy=true
        if(!!paths && !!paths.legacy) {
          return true;
        }

        var ppcUrl = appState.readCookie('ppc_url');
        var solarisUrl = sessionStorage.getSessionStorageValue('solarisDeeplink') || appState.readCookie('solarisDeeplink');
        var legacyDeepLinkUrl = sessionStorage.getSessionStorageValue('legacyDeeplink') || appState.readCookie('legacyDeeplink');
        return !!ppcUrl || !!solarisUrl || !!legacyDeepLinkUrl;
      }

      function processLoggedInUsers(d, userPath) {
        if ($rootScope.ao.raw === null) {
          // Show loader bit
          // $rootScope.$broadcast('showGlobalLoader');
          // Collect Account list info + permissions info
          var request = {
            refresh: false,
            applicationId: 'Rogers.com'
          };

          // Always get fresh data from server
          ajax.getAccountList(request).then(
            function (data) {
              // Process through account overview services
              data = myrAccountListService.processAccountList(data);
              appState.accountlength = data.accountList ? data.accountList.length : 0;
              // Check if user pressed refresh button on browser
              if ($rootScope.ao.accountDetails === null) {
                var accountNumber = localStorage.getLocalStorageValue('accountNumber');
                if (accountNumber) {
                  // Last selected account cookie exists --->>> Commence reconstruction
                  appState.aoReconstruct(accountNumber);
                }
              }

              // Maintenance redirect
              // Send all traffic to maintenance page with attached request URL and let the maintenance controler cedide which page to show
              if (appState.maintenanceRedirect(userPath)) {
                var underMaintenanceTimeout2 =

                  setTimeout(function () {
                    $location.path('/underMaintenance');
                    clearTimeout(underMaintenanceTimeout2);
                  });
              }

              // Internal deeplinking process verification and state change
              if (deeplink.data.redirect) {
                d.resolve(deeplink.permissionResolverHook(data));           // Promise within a promise
              } else {
                // Resolve this matter and let the page move on
                if (data.result === 'success') {
                  d.resolve(data);
                } else if (data.result === 'redirect') {
                  d.resolve(false);
                } else if (data.result === 'fail') {
                  d.resolve(false);
                }
              }
            },
            function (error) {
              //redirect to the maintenance if account list call fails.

              // VERY special treatment for business redirect
              // if (error.data.status === 555 && error.error.errorCode === 10490) {
              //   // DON'T FREAK OUT!!! WE NEED TO PUT THE REDIRECT SOMEWHERE
              //   $window.location.href = '/business/ss/smb/redesign/dashboard/overview';
              //   throw new Error('redirected');
              // }

              appState.showMaintenance();

              var message = '';
              var errorObj = {};
              var errorJSON = '';

              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                // Stop the app from going further

                if (error.error.errorCode === 10403) {
                  // "errorMessage":"Get postpaid account details failed"
                  message += $translate.instant('error_population_accounts');
                  userOptions.alert(message);

                  // Stop the process
                  errorObj = {};
                  errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
                  errorObj.res = 'error_population_accounts';

                  errorJSON = angular.toJson(errorObj);
                  throw new Error(errorJSON);
                }

              } else {
                // anything but status code 555
                if (error.data.status === 302) {
                  // redirect to location in the
                  $window.location.href = '/business/ss/smb/redesign/dashboard/overview';
                }
                if (error.data.status === 401) {
                  // Unauthorized
                  message += $translate.instant('error_population_accounts');
                  userOptions.alert(message);

                  // Stop the process
                  errorObj = {};
                  errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
                  errorObj.res = 'error_population_accounts';

                  errorJSON = angular.toJson(errorObj);
                  throw new Error(errorJSON);
                }
                if (error.data.status >= 500 && error.data.status < 555) {
                  // Server Error
                  message += $translate.instant('error_population_accounts');
                  userOptions.alert(message);

                  // Stop the process
                  errorObj = {};
                  errorObj.message = 'User cannot continue to accountOverview due to error on server and accounts are missing.';
                  errorObj.res = 'error_population_accounts';

                  errorJSON = angular.toJson(errorObj);
                  throw new Error(errorJSON);
                }
              }

              appState.aoFlushScope();
              error.total = -1;
              error.result = 'error';

              d.resolve(false);
            });
        } else {
          // Maintenance redirect
          // Send all traffic to maintenance page with attached request URL and let the maintenance controler cedide which page to show
          if (appState.maintenanceRedirect(userPath)) {
            localStorage.setLocalStorageValue('maintPage', userPath);
            if ($rootScope.isCare) {
              sessionStorage.setSessionStorageValue('maintPage', userPath);
            }
            var underMaintenanceTimeout1 = setTimeout(function () {
              $location.path('/underMaintenance');
              clearTimeout(underMaintenanceTimeout1);
            });
          }
          //$location.path('/underMaintenance');
          //}

          // Check if user pressed refresh button on browser
          var localStorageAccountNumber = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');

          if (localStorageAccountNumber) {
            // Last selected account cookie exists --->>> Commence reconstruction
            appState.aoReconstruct(localStorageAccountNumber);
          }

          // Take all data from storage
          d.resolve($rootScope.ao.raw);
        }
      }

      // hook up functions
      pr.getPermission = function (toStatePath) {
        var d = $q.defer();
        // Killswitch limit reset every new page visit
        ajax.resetKillSwitches();
        // If server session is expired sent user to sign in!!!
        appState.kickOutExpired();

        // User and Location info
        var userPath = (toStatePath) ? toStatePath : $location.path();
        // Split string based on this pattern /:module/:submodule
        var pathArr = userPath.split('/');
        var module = pathArr[1];

        // Login required - grab data from settings
        var pageLogin = settings.pageLoginRequired[module] || securityService.isStateProtected(toStatePath);
        var userAuth = userService.isSigned();
        // Checking maintenance Setting

        accountOverviewService.getMaintenanceSettings({}, function () {
        });

        if (userAuth === false && pageLogin === false) {
          // All clear - no need to log in - Public page
          d.resolve(true);		// show the page
        } else if (userAuth === false && pageLogin === true) {
          // Send user to sign-in page
          //$location.path('/signin');
          console.log('calling user logout from the permission resolver');
          user.logout(false, 'USER_NOT_LOGGED_IN');
        } else if (userAuth === true && pageLogin === false) {
          // Signed-in user accessing public page
          if (module === 'signin') {		// Sign IN page
            appState.switchView('accountOverview');
          } else {
            d.resolve(true);
          }
        } else if (userAuth === true && pageLogin === true) {
          // Signed-in user accessing protected page
          // Check if data are already present
          //wcoc changes :: start
          var wcocDeepStr = sessionStorage.getSessionStorageValue('wcocDeepSTR');
          var wcocJwtToken = sessionStorage.getSessionStorageValue('wcocJwtToken');
          if (!!wcocDeepStr && wcocDeepStr.indexOf('wcoc') >= 0 && !!wcocJwtToken && userService.isSigned()) {
            var postData = {
              applicationId: 'Rogers.com',
              token: wcocJwtToken
            };
            ajax.decryptWcocJwtToken(postData).then(
              function (data) {
                wcocRedirection(data, wcocDeepStr);
              },
              function () {
                wcocRedirection('', wcocDeepStr);
              }
            );
          } else if (!!toStatePath && toStatePath.indexOf('accountOverview') > -1) {
            // check deeplink
            // redirect to new account overview
            if (isDeeplinkingOrLegacy()) {
              processLoggedInUsers(d, userPath);
            } else {
              $window.open('/consumer/self-serve/overview', '_self');
            }
          } else {
            processLoggedInUsers(d, userPath);
          }
        } else {
          // Unknown state - reboot The Matrix
          d.resolve('Mr. Anderson');
        }

        return d.promise;
      };

      return pr;
    }]);
}());

'use strict';

angular.module('totesApp')
	.service('permissionService',['$rootScope','appState', function ($rootScope, appState) {

		// Use for this one? Anybody?

	}]);
'use strict';

angular.module('totesApp')
	.factory('persistentAccessor', ['$browser', function ($browser) {
		return function (key, initialValue) {
			// var _val = $cookies.key;
			var _val = $browser.cookies()[key];

			if (angular.isUndefined(_val)) {
				// $cookies[key] = initialValue;
				$browser.cookies(key, initialValue);
				_val = initialValue;
			} else {
				if (angular.isUndefined(initialValue)) {
					// $cookies[key] = initialValue;
					$browser.cookies(key, initialValue);
				}
			}

			return function (value) {
				if (angular.isUndefined(value)) {
					return _val;
				} else {
					_val = value;
					// $cookies[key] = initialValue;
					$browser.cookies(key, initialValue);
				}
			};
		};
	}]);

'use strict';

angular.module('totesApp')
    .factory('profileService', ['ajax', '$q', '$log', function(ajax, $q, $log) {
        var service = {};
        service.checkProfileComplete = function () {
            var mic = $q.defer();
            $log.debug('profileService.checkProfileComplete');

            ajax.checkProfileComplete().then(
                function (data) {
                    $log.debug('checkProfileComplete: ajax=' + data);
                    var isComplete;
                    if (data) {
                        var dataObj = angular.fromJson(data);
                        isComplete = dataObj.complete;
                        mic.resolve(isComplete);
                    }else{
                      mic.reject();
                    }

                },
                function (error) {
                    $log.error('Calling /checkProfileComplete failed');
                    mic.reject();
                }
            );

            return mic.promise;
        };

        return service;
    }]);


'use strict';

angular
    .module('totesApp').factory('sessionStorage', ['$window',
  function ($window) {
    var sessionStorage = {};

    // Read
    sessionStorage.getSessionStorageValue = function (key) {
      return $window.sessionStorage.getItem(key);
    };

    sessionStorage.getSessionStorageObject = function (key) {
      var valueString = $window.sessionStorage.getItem(key);
      return angular.fromJson(valueString);
    };

    // Write
    sessionStorage.setSessionStorageValue = function (key, val) {
      $window.sessionStorage.setItem(key, val);
    };

    sessionStorage.setSessionStorageObject = function (key, val) {
      var valueString = angular.toJson(val);
      $window.sessionStorage.setItem(key, valueString);
    };

    // Delete
    sessionStorage.deleteSessionStorageValue = function (key) {
      $window.sessionStorage.removeItem(key);
    };

    sessionStorage.deleteSessionStorageObject = function (key) {
      this.deleteSessionStorageValue(key);
    };

    // Clear all
    sessionStorage.clearAllSessionStorageValues = function () {
      // console.log('inside clearalllocalstorage');
      while ($window.sessionStorage.length > 0) {
        $window.sessionStorage.removeItem($window.sessionStorage.key(0));
      }
    };

    // Clear all except those mentioned in the array
    sessionStorage.clearAllSessionStorageValuesExcept = function (theseArr) {
      while ($window.sessionStorage.length > 0) {
        var keyIndex = theseArr.indexOf($window.sessionStorage.key(0));
        if (keyIndex < 0) {
          $window.sessionStorage.removeItem($window.sessionStorage.key(0));
        }
      }
    };

    return sessionStorage;
  }
]);

(function () {
  'use strict';

  angular.module('totesApp').factory('ssoService', ssoService);

  ssoService.$inject = ['$http',
    '$window',
    '$browser',
    '$q',
    'ajax',
    'deeplink',
    'appState',
    'ute.blocks.language.switcher',
    'ute.blocks.messages.bus.service',
    'ute.common.user.service',
    'ute.blocks.environment',
    'cookieStore'
  ];

  /* @ngInject */
  function ssoService($http,
                      $window,
                      $browser,
                      $q,
                      ajax,
                      deeplink,
                      appState,
                      languageSwitcher,
                      messagesService,
                      userService,
                      environmentProvider,
                      cookieStore) {
    var SSO_TOKEN_API = 'web/genesis/api/user/v1/sso/token/';
    var LITHIUM_API = 'web/RogersServices.portal?_nfpb=true&_pageLabel=beta';
    var ROGERS_BRAND_QUERY_PARAM = '?brand=ROGERS';
    // var PPC_KEYWORD = '/web/totes/wireless-plan-change/'; // https://localhost.rogers.com:3000/web/totes/wireless-plan-change/#/choose-plan
    // var HUP_KEYWORD = '/web/totes/upgrade/'; // https://localhost.rogers.com:3000/web/totes/upgrade/#/choose-phone
    // var USER_STORAGE_KEY = 'ute.rogers.signin.user';
    var X_SESSION_TOKEN_KEY = 'xSessionToken';
    var GUID_KEY = 'guid';
    var SIGNIN_SUCCESS_MSG_KEY = 'ute.rogers.signin.successful';
    // var FLOW_TYPE = {
    //   PPC: 'ppc',
    //   HUP: 'hup'
    // };

    var data = {
      token: null,
      guid: null,
      userId: null,
      originalTarget: null,
      target: null
      //flowType: null
    };
    var isAuthenticated;

    function startProcess(params) {
      isAuthenticated = userService.isSigned();

      try {
        data.target = extractTarget(params.target);
        if (!isAuthenticated) {
          deeplink.storeData(data.target);
        }
      } catch (e) {
        console.log('target param issue in sso url');
      }

      if (!params.token) {
        if (!isAuthenticated) {
          appState.redirectToEasyLogin();
        }
        return;
      } else {
        data.token = params.token;
      }

      callSsoTokenApi()
        .then(processDeeplink)
        .catch(handleErrors);
    }

    function callSsoTokenApi() {
      return $http({
        method: 'GET',
        url: SSO_TOKEN_API + data.token + ROGERS_BRAND_QUERY_PARAM + '&login=' + isAuthenticated,
        headers: {
          'x-app-id': 'Rogers'
        }
      }).then(function (response) {
        if (_.isArray(_.get(response, 'data.content')) && response.data.content.length > 1) {
          var content = response.data.content;

          if (_.has(content, '[1].guid') && content[1].guid !== null &&
            _.has(content, '[1].smSession') && content[1].smSession !== null &&
            _.has(content, '[0].xSessionToken') && content[0].xSessionToken !== null
          ) {
            setupContext(content[1].guid, content[1].userId, content[1].ban, content[1].ctn,
              content[0].xSessionToken, content[1].smSession);
          } else {
            return $q.reject('no guid in sso token API');
          }

        } else {
          return $q.reject('sso token API wrong format');
        }
      });
    }

    function extractTarget(target) {
      data.originalTarget = $window.atob(target);
      // For PPC/HUP we need to go to the wireless dashboard
      // if (data.originalTarget.toLowerCase().indexOf(HUP_KEYWORD) > -1) {
      //   data.flowType = FLOW_TYPE.HUP;
      //   return getWirelessDashboardUrl();
      // } else if (data.originalTarget.toLowerCase().indexOf(PPC_KEYWORD) > -1) {
      //   data.flowType = FLOW_TYPE.PPC;
      //   return getWirelessDashboardUrl();
      // } else {
      //   return data.originalTarget;
      // }
      return data.originalTarget;
    }

    function setupContext(guid, userId, ban, ctn, xSessionToken, smSession) {
      if (!isAuthenticated) {
        data.guid = guid;
        data.userId = userId;
        if (xSessionToken) {
          $window.sessionStorage.setItem(X_SESSION_TOKEN_KEY, xSessionToken);
        }
        $window.sessionStorage.setItem(GUID_KEY, guid);
      }
      $window.localStorage.setItem(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER, ban);
      $window.localStorage.setItem(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, ctn);
      $window.document.cookie = 'SMSESSION=' + smSession + ';domain=.rogers.com;path=/';
    }

    // function getWirelessDashboardUrl() {
    //   var origin = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
    //   return origin + '/web/totes/#/wireless';
    // }

    function processDeeplink() {
      if (!isAuthenticated) {
        callLoggedInApi()
          .then(callLithiumApi) //setting lithium cookies
          .then(function () {
            $browser.cookies('userToken', data.userId);
            $browser.cookies('signInLang', languageSwitcher.getCurrentLanguage());
            userService.signed({
              userName: data.userId,
              userEmail: data.userId,
              userType: 'consumer'
            });
            messagesService.publish(SIGNIN_SUCCESS_MSG_KEY, {email: data.userId});
            goToPage(data.target);
          });
      } else {
        goToPage(data.target);
      }
    }

    function callLoggedInApi() {
      return ajax.notifyServerLoggedIn()
        .then(function () {
          return true;
        });
    }

    function callLithiumApi() {
      return $http({
        method: 'get',
        url: LITHIUM_API
      }).catch(function () {
        // even in error scenario we should continue the flow
        return true;
      });
    }

    function handleErrors(error) {
      console.log('sso service error:', error);
      if (!isAuthenticated) {
        deeplink.storeData(data.originalTarget);
        appState.redirectToEasyLogin(true);
      } else {
        goToPage(data.originalTarget);
      }
    }

    function goToPage(target) {
      $window.location.href = target;
    }

    // function getFlowType() {
    //   return data.flowType;
    // }

    function reset() {
      isAuthenticated = null;
      data = {};
    }

    function fetchSSOToken(payload) {
      var xInfoToken = cookieStore.get('x-info-token') || $window.localStorage.getItem('xInfoToken');
      var headers = {
        'Content-Type': 'application/json',
        'X-APP-ID': 'UTEMyRogers',
        'X-TRANSACTION-ID': new Date().getTime()
      }

      var ssoTokenUrl = environmentProvider.getProperty('ssoTokenUrl') || '';
      return $http.post(ssoTokenUrl, payload, {headers: headers}, { withCredentials: true } )
        .then(function(response) {
          if(_.has(response, 'data.content')){
            var token = response.data.content.token || '';
            return $q.resolve(token);
          } else {
            return $q.reject(' Token Not Available');
          }
      })
    }

    return {
      startProcess: startProcess,
      //getFlowType: getFlowType,
      reset: reset,
      fetchSSOToken: fetchSSOToken
    };
  }

})();

'use strict';


angular.module('totesApp')
    .factory('sync', ['$rootScope', function ($rootScope) {
        //synchronize the property value between two objects a and b

        // let login.userName follow the change of person.name
        //sync(person, "name", login, "userName");

        // let login.userName follow the change of person.name and person.name follow the change of login.userName
        //sync(person, "name", login, "userName", true);
        return function (srcObj, srcProp, targetObj, targetProp, twoWay) {

            targetProp = targetProp || srcProp;

            var scope = targetObj.$apply ? targetObj : $rootScope;

            //when object a change, then copy the value to object b
            var scopewatch1 = scope.$watch(function () {
                return srcObj[srcProp];
            }, function (value) {
                targetObj[targetProp] = value;
            });

            if (twoWay) {
                //when object b change, then copy the value to object b
                var scopewatch2 = scope.$watch(function () {
                    return targetObj[targetProp];
                }, function (value) {
                    srcObj[srcProp] = value;
                });
            }

            //n Remove any watchers 
            scope.$on('$destroy', function () {
                scopewatch1();
                scopewatch2();
            });

        };
    }]);

'use strict';


angular.module('totesApp')
    .factory('syncOnce',['$rootScope', function ($rootScope) {

        return function (srcObj, srcProp, targetObj, targetProp) {

            targetProp = targetProp || srcProp;

            var scope = targetObj.$apply ? targetObj : $rootScope;


            var unwatch = scope.$watch(function () {

                return srcObj[srcProp];

            }, function (value) {
                if (angular.isDefined(value)) {
                    targetObj[targetProp] = value;
                    unwatch();
                }
            });

            
            //n Remove any watchers 
            scope.$on('$destroy', function () {
                unwatch(); 
            });

        };
    }]);



/**
 * Created by OlgaN on 9/14/2015.
 */
// jshint ignore: start
'use strict';

angular
  .module('totesApp')
  .constant( 'offerUrl',
  {
    default: {
      'en': {
        'spotifyComplementary': 'http://www.rogers.com/web/support/wireless/share-everything-plus/2194',
        'spotifyRegistration': 'https://accounts.spotify.com/en/authorize?client_id=',
        'spotifyLogout': 'https://accounts.spotify.com/en/logout?continue=',
        'spotifyCancellation': 'https://www.spotify.com/account/cancel/confirm/partner/',
        'rogersChat': 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=707',
        'upgradePlanUrl': 'http://www.rogers.com/consumer/wireless/share-everything?setLanguage=en'
      },
      'fr': {
        'spotifyComplementary': 'http://www.rogers.com/web/support/wireless/share-everything-plus/2194',
        'spotifyRegistration': 'https://accounts.spotify.com/fr-ca/authorize?client_id=',
        'spotifyLogout': 'https://accounts.spotify.com/fr/logout?continue=',
        'spotifyCancellation': 'https://www.spotify.com/ca-fr/account/cancel/confirm/partner/',
        'rogersChat': 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=757',
        'upgradePlanUrl': 'http://www.rogers.com/consumer/wireless/share-everything?setLanguage=fr'
      }
    },
    offers: {
      spotify: {
        default: {
          'en': 'https://www.spotify.com/ca-en/download/',
          'fr': 'https://www.spotify.com/ca-fr/login/'
        },
        defaultOthers: {
          'en': 'https://www.spotify.com/ca-en/download/',
          'fr': 'https://www.spotify.com/ca-fr/login/'
        },
        iOS: {
          version: '6.0',
          mobile: {
            'en': 'https://itunes.apple.com/ca/app/spotify-music/id324684580',
            'fr': 'https://itunes.apple.com/ca/app/spotify-music/id324684580?l=fr'
          },
          tablet: {
            'en': 'https://itunes.apple.com/ca/app/spotify-music/id324684580',
            'fr': 'https://itunes.apple.com/ca/app/spotify-music/id324684580?l=fr'
          }
        },
        Android: {
          version: '4.4',
          mobile: {
            'en': 'https://play.google.com/store/apps/details?id=com.spotify.music',
            'fr': 'https://play.google.com/store/apps/details?id=com.spotify.music&hl=fr'
          },
          tablet: {
            'en': 'https://play.google.com/store/apps/details?id=com.spotify.music',
            'fr': 'https://play.google.com/store/apps/details?id=com.spotify.music&hl=fr'
          }
        },
        'Windows Phone': {
          version: '8.0',
          'en': 'https://www.microsoft.com/en-ca/store/apps/spotify/9wzdncrfj4wk',
          'fr': 'https://www.microsoft.com/fr-ca/store/apps/spotify/9wzdncrfj4wk'
        },
        Blackberry: {
          version: '10.0',
          'en': 'http://www.amazon.ca/Spotify-Music/dp/B00KLBR6IC',
          'fr': 'http://www.amazon.ca/gp/switch-language/product/B00KLBR6IC/ref=cs_switchlang?ie=UTF8&language=fr_CA'
        }
      },
      nextissue: {
        default: {
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        },
        defaultOthers: {
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        },
        iOS: {
          version: '5.0',
          mobile: {
            'en': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756',
            'fr': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756?l=fr'
          },
          tablet: {
            'en': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756',
            'fr': 'https://itunes.apple.com/ca/app/rogers-next-issue/id649174756?l=fr'
          }
        },
        Android: {
          version: '3.1',
          mobile: {
            'en': 'https://play.google.com/store/apps/details?id=com.nim.rogers',
            'fr': 'https://play.google.com/store/apps/details?id=com.nim.rogers&hl=fr'
          },
          tablet: {
            'en': 'https://play.google.com/store/apps/details?id=com.nim.rogers',
            'fr': 'https://play.google.com/store/apps/details?id=com.nim.rogers&hl=fr'
          }
        },
        'Windows Phone': {
          version: '8.0',
          'en': 'https://www.nextissue.ca/en/device-windows/',
          'fr': 'https://www.nextissue.ca/fr/device-windows-fr/'
        },
        Blackberry: {
          version: '10.0',
          'en': 'https://www.nextissue.ca/appdownload',
          'fr': 'https://www.nextissue.ca/telecharger'
        }
      }
    }

    }
  );
angular
  .module('totesApp')
  .factory('urlDevice', ['offerUrl', function (offerUrl) {

    var urlDevice = {

      // this function is used in my account  in procedural way -  device-check.js
      checkPhone: function () {

        var isSmart = true,
          device = '',
          obj;

        try {
          var clientWidth = document.documentElement && document.documentElement.clientWidth;

          if (clientWidth == undefined || (+clientWidth) > 240) {
            isSmart = true;
          } else {
            isSmart = false;
          }

          var parser = new UAParser(),              // instance of UA-check third party library ->  http://faisalman.github.io/ua-parser-js/
            result = parser.getResult(),
            deviceType = result.device.type,		     // mobile, tablet, undefined
            osName = result.os.name,				         // Android, iOS, BlackBerry, Windows Phone, Symbian
            osVersion = result.os.version,			     // '4.1', '7.0', '10', '8.0', '2.3.5' ... etc
            osVersionFloat = parseFloat(osVersion);  // Crunch the OS version number string into a float value

          // Device Name.
          device = osName;

          if (osName === 'iOS' && osVersionFloat < 6) {
            isSmart = false;
          } else if (osName === 'Android' && osVersionFloat < 4) {
            isSmart = false;
          } else if (osName === 'BlackBerry') {
            if (osVersionFloat >= 10) {
              isSmart = true;
              device = osName + '10+';
            } else {
              isSmart = false;
            }
          } else if (osName === 'Windows Phone' && osVersionFloat < 8) {
            isSmart = false;
          } else {
            // Leave it at the default value
          }
        } catch (e) {
          // An error has occurred so we will default to smart layout.
          isSmart = false;
        }

        obj = {
          'isSmart': isSmart,
          'device': device,
          'osName': osName,
          'deviceType': deviceType,
          'osVersion': osVersion,
          'version': osVersionFloat
        };

        return obj;

      },
      findUrl: function () {
        var urls = {},
          obj = offerUrl.offers,
          getDeviceInfo = urlDevice.checkPhone();

        for (var key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (getDeviceInfo.device === 'iOS' && (parseFloat(getDeviceInfo.osVersion).toFixed(1) >= parseFloat(obj[key][getDeviceInfo.device].version) )) {
              if (getDeviceInfo.deviceType === 'tablet') {
                urls[key] = obj[key][getDeviceInfo.device].tablet;
              }
              else {
                urls[key] = obj[key][getDeviceInfo.device].mobile;
              }
            }
            else if (getDeviceInfo.device === 'Android' && (parseFloat(getDeviceInfo.osVersion).toFixed(1) >= parseFloat(obj[key][getDeviceInfo.device].version) )) {
              if (getDeviceInfo.deviceType === 'tablet') {
                urls[key] = obj[key][getDeviceInfo.device].tablet;
              }
              else {
                urls[key] = obj[key][getDeviceInfo.device].mobile;
              }
            }
            else if (getDeviceInfo.osName === 'BlackBerry') {
              if (getDeviceInfo.device === 'BlackBerry10+' && parseFloat(getDeviceInfo.osVersion).toFixed(1) >= parseFloat(obj[key][getDeviceInfo.device].version)) {
                urls[key] = obj[key][getDeviceInfo.device];
              }
              else {
                urls[key] = obj[key].defaultOthers;
              }
            }
            else if (getDeviceInfo.deviceType === 'mobile' || getDeviceInfo.deviceType === 'tablet') {
              if (getDeviceInfo.device === 'Windows Phone' && (parseFloat(getDeviceInfo.osVersion).toFixed(1) >= parseFloat(obj[key][getDeviceInfo.device].version) )) {
                urls[key] = obj[key][getDeviceInfo.device];
              }
              else {
                urls[key] = obj[key].defaultOthers;
              }
            } else {
              urls[key] = obj[key].default;
            }
          }
        }
        return urls;
      }
    };

    return urlDevice;
  }]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
'use strict';

angular.module('totesApp')
    .factory('user', ['$rootScope',
      'persistentAccessor',
      'settings',
      'ajax',
      '$location',
      '$cookieStore',
      'appState',
      '$window',
      '$browser',
      'localStorage',
      'agentSession',
      'myrForgetPasswordService',
      '$state',
      'sessionStorage',
      'ute.common.user.service',
      'myrAccountListService',
      'ute.blocks.messages.bus.service',
      function ($rootScope, // jshint ignore:line
                persistentAccessor,
                settings,
                ajax,
                $location,
                $cookieStore,
                appState,
                $window,
                $browser,
                localStorage,
                agentSession,
                forgetPasswordService,
                $state,
                sessionStorage,
                userService,
                myrAccountListService,
                messagesService) {

        var user = {
            isAuthenticated: userService.isSigned,
          token: persistentAccessor('userToken', null),
          isLoggedIn: function () {
            //if ($cookies.SMSESSION  && $cookies.SMSESSION === 'LOGGEDOFF') {
            var authCookie = userService.getAuthCookieValue();
            if (!authCookie || authCookie === 'LOGGEDOFF') {
              return false;
            }
          },
          login: function (userName, password) {
            var returnObj = {};

            return ajax.signin(userName, password).then(
                // success
                function (response) {
                  returnObj = {};

                  $rootScope.$broadcast('accountLockAvailable');
                  var browserCookies = $browser.cookies();

                  if (browserCookies.SM_QUERY_STRING) {
                    var params = browserCookies.SM_QUERY_STRING.split('&').map(function (n) {
                      return n = n.split('='), this[n[0]] = n[1], this;
                    }.bind({}))[0];

                    removeCookie('SMTRYNO');
                    removeCookie('SM_QUERY_STRING');
                  }

                  var sessionCookie = userService.getAuthCookieValue();

                  if (!!sessionCookie) {
                    removeCookie('SMTRYNO');
                    returnObj.valid = true;
                    returnObj.statusCode = 200;
                  } else {
                    returnObj.valid = false;
                    returnObj.statusCode = 200;
                  }
                  return returnObj;

                }, function (error) {
                  returnObj = {};
                    /**
                     * Comment out the following code because of Empty block
                     */
                  // Error handling - 555 exception
                    // if (error.data.status === 555) {
                    //   // Server error that needs further processing
                    //   // additional information for 555 error

                    //   // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                    //   // error.error.errorMessage		// Message as delivered from server
                    //   // error.error.message 			// Message as found in resource file
                    //   // error.error.statusCode		// error status code - 555 in this case

                    // } else {
                    //   // anything but status code 555

                    //   if (error.data.status === 401) {
                    //   } else if (error.data.status === 502) {
                    //     // console.log('User(ajax.signin) - Bad gateway.');
                    //   } else if (error.data.status === 503) {
                    //     // console.log('User(ajax.signin) - Server unresponsive.');
                    //   } else {
                    //     // console.log('User(ajax.signin) - error.data.status:', error.data.status);
                    //   }
                    // }

                  returnObj.valid = false;
                  returnObj.statusCode = error.data.status;
                  return returnObj;
                }
            );
          },
          clearCookies: function () {
            // Kill the cookies
            // The SMSESSION cookie should not be removed for dealer
            if ($browser.cookies().userType !== settings.userType.dealer) {
              removeCookie('SMSESSION');
            }
            removeCookie('SM_USERAUTHENTICATED');
            removeCookie('SMLOCK');
            removeCookie('SM_GUID');
            removeCookie('SM_USER');
            removeCookie('userToken');
            removeCookie('selectedAccount');
            removeCookie('accountNumber');
            removeCookie('userType');
            removeCookie('cbid');
            removeCookie('easyLoginCheckPassed');
            removeCookie('Authorization');
          },
          logout: function (skipNavigation, logoutReason) {
              //skipNavigation is not supported anymore and user must be navigated to DAM for logout
            switch (logoutReason) {
              case 'LOGOUT':
                // after logout the default destination is home page unless otherwise stated in ute.rci.deep.link.out.url sessionStorage
                $window.location.href = '/consumer/profile/logout';
                break;
              case 'USER_NOT_LOGGED_IN':
                $window.location.href = '/consumer/profile/signin';
                break;
              case 'SESSION_EXPIRED':
                sessionStorage.setSessionStorageValue('ute.rci.deep.link.url', $window.location.href);
                $window.location.href = '/consumer/profile/logout?login=true';
                break;
              default:
                $window.location.href = '/consumer/profile/logout';
                break;
            }
          },
          isEmail: function (email) {
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
          },
          changeUsername: function (newUsername, isUsernameMigration) {
            if (isUsernameMigration && isUsernameMigration === true) {
              localStorage.setLocalStorageValue('successMessage', 'mu_msg_success');
              localStorage.setLocalStorageValue('usernameMigrationComplete', 'true');
            }
            $browser.cookies('pageUserName', newUsername);
            $browser.cookies('userToken', newUsername);
            $rootScope.$broadcast('pageUserNameChanged');
          },
          allAccounts: [],
          currentAccountId: '',
          currentAccount: {}
        };

        function removeCookie(name) {
          document.cookie = name + '=; domain=.rogers.com; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
        }

        messagesService.register('ute-oneview-footer-logout', function (event, data) {
          console.log("calling signout from ute-oneview-footer-logout");
          user.logout();
        });

        $rootScope.$on('ute.user.unauthorized', function () {
          console.log('calling signout from ute.user.unauthorized');
          user.logout(null, 'SESSION_EXPIRED');
        });
        return user;
      }]);
}());

'use strict';

//
angular.module('totesApp').factory('userOptions',['$rootScope', function ($rootScope) {

    var optionsQueue = [];
    var currentOptions = null;

    function dequeuUserNextOptions() {

        currentOptions = optionsQueue.shift();

        if (currentOptions) {
            $rootScope.$broadcast('options_sent', currentOptions);
        }

    }

    var userOptions = {

        __optionsQueue: optionsQueue,

        alert: function (message, title, callback) {

            if (angular.isFunction(message) || angular.isUndefined(title)) {
                callback = title;
                title = 'Rogers';
            }

            this.push({
                title: title,
                message: message,
                options: [
                    {
                        id: 'Ok',
                        text:'',
                        action: callback
                    }
                ]
            });
        },

        //eventType is used together with listen
        push: function (options) {

            optionsQueue.push(options);

            if (!currentOptions) {
                dequeuUserNextOptions();
            }
        },

        subscribe: function (scope, optionType, callback) {

            if (angular.isFunction(optionType)) {
                callback = optionType;
                optionType = undefined;
            }

            scope.$on('options_sent', function (e, userOptions) {
                if (userOptions.type === optionType) {
                    /*jshint expr:true */
                    callback && callback(userOptions);
                }
            });
        },

        //the done can be trigger asynchronously
        done: function (optionId) {

            var option = optionId && currentOptions && currentOptions.options && currentOptions.options[optionId];

            /*jshint expr:true */
            option && option.action && option.action();
            currentOptions = null;
            dequeuUserNextOptions();
        }
    };

    return userOptions;


}]);

'use strict';

angular.module('totesApp')
    .factory('userProvince', ['$window', '$browser', '$rootScope', 'ute.blocks.messages.bus.service',
      function ($window, $browser, $rootScope, messagesService) {

        var _province = $browser.cookies().province;
        var _domain = $window.location.hostname.replace('www', '');

        function setProvinceCookie(value) {
          $window.document.cookie = 'province=' + value + ';domain=' + _domain + ';path=/';
          $browser.cookies('province', value);
        }

        return function (value) {
          if (angular.isUndefined(value)) {
            if (angular.isUndefined(_province)) {
              _province = 'ON';
              setProvinceCookie(_province);
            }
            return _province;
          } else {
            _province = value;
            setProvinceCookie(value);
            $rootScope.$broadcast('provinceChanged');
            messagesService.publish('ute-oneview-footer-province-change', value);
            return value;
          }
        };
      }
    ]);

(function () {
  'use strict';

  angular.module('totesApp').factory('util', utilFactory);
  utilFactory.$inject = [
    'ute.blocks.language.switcher',
    '$translate',
    'moment'
  ];
  function utilFactory(languageSwitcher,
                       $translate,
                       moment) {
    var monthsKeys = ['_months.0',
      '_months.1',
      '_months.2',
      '_months.3',
      '_months.4',
      '_months.5',
      '_months.6',
      '_months.7',
      '_months.8',
      '_months.9',
      '_months.10',
      '_months.11'];

    return {
      isPromise: function (obj) {
        return !!obj && angular.isFunction(obj.then);
      },
      updateCTNFormat: function (ctn) {
        var ctnRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        var formattedCTN = ctn;
        if (ctnRegex.test(ctn)) {
          formattedCTN = ctn.replace(ctnRegex, '($1) $2-$3');
        }
        return formattedCTN;
      },
      getNumberOfDays: function (newDateStr) {
        //newDate format should be Eg: Sep-19-15
        var todayDate = new Date();
        var monthName = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
        var _date = newDateStr.split('-');
        var oneDayInMilliSecond = 24 * 60 * 60 * 1000;
        var newDate = new Date(2000 + parseInt(_date[2]), monthName.indexOf(_date[0].toUpperCase()), _date[1]);
        // Calculate the difference in milliseconds
        var differenceMs = Math.abs(newDate.getTime() - todayDate.getTime());
        return Math.floor(differenceMs / oneDayInMilliSecond);
      },
      getSevenDaysAgoInFrench: function(timeStamp){
        var number = timeStamp.split(' ')[0];
        var time = timeStamp.split(' ')[1];
        var frenchTimeStamp;
        var agoFr = "il y a";
        var frenchTranslations = ["quelques secondes", "quelques minutes", "1 minute", "1 heure", "quelques heures","1 jour","quelques jours"];
        var englishTranslation = ["few","minutes" ,"minute" ,"hour" ,"hours","day","days"];

        englishTranslation.forEach(function (agoTranslation, index) {
          if (agoTranslation === time){
            if (number == 'a' || number == 'an'){
              frenchTimeStamp = agoFr + ' ' + frenchTranslations[index];
            }
            else {
              frenchTimeStamp = agoFr + ' ' + number + ' ' + frenchTranslations[index];
            }
          }
        });
        return frenchTimeStamp;
      },
      /*
       input: itemTimeStamp format should be either 2015-11-24T15:59:37 or 2015-11-24
       output: November 24, 2015 */
      getDateByDate: function (timeStamp, month) {
        var lng = languageSwitcher.getCurrentLanguage();
        var date = moment(timeStamp);
        var days = moment(new Date());
        /*var monthNames = ["January", "February", "March", "April", "May", "June",
         "July", "August", "September", "October", "November", "December"
         ];
         var monthNamesFr = ["janvier" , "février" , "mars" , "avril" , "mai" , "juin" ,
         "juillet" , "août" , "septembre" , "octobre" , "novembre" , "d&eacute;cembre"
         ];*/
        var dateForDisplay = '';
        if (lng === 'fr') {
          //dateForDisplay = monthNamesFr[date.month()] +' '+date.date()+', '+date.year();
          dateForDisplay = month + ' ' + date.date() + ', ' + date.year();
        } else {
          //dateForDisplay = monthNames[date.month()] +' '+date.date()+', '+date.year();
          dateForDisplay = month + ' ' + date.date() + ', ' + date.year();
        }
        return dateForDisplay;
      },

      getMonthsNames: function () {
        return _.values($translate.instant(monthsKeys));
      },

      // following 3 functions (isSafari, isChromeIOS, getChromeVersion) moved here form wirelessDashboardController
      isSafari: function () {
        return /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion)) && /apple computer/i.test(window.navigator.vendor);
      },

      isChromeIOS: function () {
        return !!navigator.userAgent.match('CriOS');
      },

      getChromeVersion: function () {
        var chromeUserAgent = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        var chromeVersion = 1000; // Hypothetical future Chrome version
        if (chromeUserAgent !== null) {
          chromeVersion = parseInt(chromeUserAgent[2], 10);
        }

        // Microsoft added "Chrome" to Edge's "navigator.userAgent" string which is breaking this function.
        // Below two-line logic identifies and corrects the issue for the time being.
        // In case Edge's "navigator.appName" is "Netscape" the standard CSS code would work just fine, so
        // "chromeVersion" is set to 50 which triggers the standard CSS code
        if (navigator.userAgent.toLowerCase().indexOf('edge') !== -1) {
          chromeVersion = 50;
        }
        return chromeVersion;
      },

      getURLParamsByName: function (name, url) {
        //https://stackoverflow.com/a/901144
        if (!url) {
          url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
        if (!results) {
          return null;
        }
        if (!results[2]) {
          return '';
        }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
      },

      //EASY LOGIN PHASE 2
      //This property will be used to interface between new registration and legacy registration
      isRedirectedFromELRegistration: false,

      getIsRedirectedFromELRegistration: function() {
        return this.isRedirectedFromELRegistration;
      },

      setIsRedirectedFromELRegistration: function(value) {
        this.isRedirectedFromELRegistration = value;
      }
    };
  }
})();



'use strict';

/**
 * @ngdoc service
 * @name totesApp.webanalytics
 * @description
 * # webanalytics
 * Service in the totesApp.
 */
angular.module('totesApp')
  .service('webanalytics', function () {
    // AngularJS will instantiate a singleton by calling "new" on this function
    //tag objects of all modules.
/*    var _pageTags={
      'signin': 'home:signin',
      'registration': 'home:registration:contact-information',
      'forgetPassword': 'home:signin',
      'forgetusername': 'home:signin',
      'invalidPath': 'home:signin',
      'permissionDenied': 'home:signin',
      'tpsc': 'home:signin'
    };*/

    return {

      formatErrorMessage: function (page, controlName, errorType, errorMessage) {
        var message = '';

        if(errorType === 1){
          message = controlName + ' is empty;';
        }

        if(errorType === 2){
          message = controlName + ' pattern is invalid;';
        }

        if( errorType === 3){
          message = controlName + ' is ' + errorMessage;
        }
        return 'Validation Error---'+ 'Page: ' + page + ':' + message ;
      },
      getPageTagObj: function (module) {
        var _pageName = 'home:signin';// the tagging page name of the

        return ['_trackPageView',
          {pn: _pageName}
        ];
      }

    };

  });

(function () {
  'use strict';

  angular.module('selfServe').controller('selfServeCtrl', ['selfServeSvc',
    '$scope',
    '$rootScope',
    'ute.common.user.service',
    '$q',
    '$modal',
    'localStorage',
    '$cookies',
    'appState',
    'profileEditService',
    '$window',
    '$state',
    'myrAccountListService',
    'sessionStorage',
    '$translate',
    'ute.common.permissions.service',
    'ute.rogers.account.overview.factory',
    'ute.data.manager.service',
    'myrAccountUnlockService',
    'ajax',
    'spliceFilter',
    'dateFilter',
    'myrAccountBalanceDataFactory',
    '$interval',
    '$timeout',
    '$anchorScroll',
    '$location',
    '$stateParams',
    'cookieStore',
    'ute.rogers.account.overview.summary.factory',
    'ute.blocks.language.switcher',
    function (selfServeSvc, // jshint ignore:line
              $scope,
              $rootScope,
              userService,
              $q,
              $modal,
              localStorage,
              $cookies,
              appState,
              profileEditService,
              $window,
              $state,
              myrAccountListService,
              sessionStorage,
              $translate,
              permissionsService,
              newAccoutOverviewFactory,
              dataManagerService,
              myrAccountUnlockService,
              ajax,
              splice,
              date,
              myrAccountBalanceDataFactory,
              $interval,
              $timeout,
              $anchorScroll,
              $location,
              $stateParams,
              cookieStore,
              accountOverviewSummaryFactory,
              languageSwitcher) {

      var scrollPageToTopTimer;
      var scrollPageHandlerTimer;
      /**
       * If scrollToId is available like: #/profile/self-serve-payment-info
       * system will scroll to the specific ID
       * Because of the fixed header a 120px vertical offset will add to the scrolling
       */
      if ($stateParams.scrollToId !== undefined) {
        $location.hash($stateParams.scrollToId);
        $anchorScroll.yOffset = 120;
        $anchorScroll();
      }
      /*
       Fixes scroll to anchor inconsistencies
       - cause: async ajax calls may cause incorrect page scroll to an #anchor
       - #anchor needs to be handled after an initial load has completed
       - timeout has to be set to account for long running ajax calls
       */
      $scope.handlePageAnchor = function (timeout) {
        if ($location.hash()) {
          timeout = timeout || (Date.now() + 8000);
          var isInitialLoadDone = $interval(function () {

            //handle long running ajax calls
            if (Date.now() > timeout) {
              $interval.cancel(isInitialLoadDone);
              $anchorScroll();
              return;
            }

            if (!$scope.userInfo) {
              return;
            }
            if (!$scope.BillingAddress) {
              return;
            }
            if (!$scope.ContactInformation) {
              return;
            }
            if (!$scope.paymentInfo || $scope.paymentInfo.isPaymentLoading) {
              return;
            }

            var anchor = $location.hash();
            //reset hash and make sure history did not get poluted
            //This is again to overcome a rather strange #anchor scrolls
            $location.hash('').replace().hash(anchor).replace();
            $interval.cancel(isInitialLoadDone);
            $anchorScroll();

          }, 200);
        }
      };

      scrollPageToTopTimer = $timeout(function () {
        if (!$location.hash()) {
          scrollPageToTop();
        }
      });

      // 1 sec deay is used to let the page load some content initially otherwise anchoring may not work again
      scrollPageHandlerTimer = $timeout(function () {
        $scope.handlePageAnchor();
      }, 1000);

      var userInfoDefer = $q.defer();
      var accountsDefer = $q.defer();
      var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');
      if ($rootScope.isCare) {
        accountTypeNumber = sessionStorage.getSessionStorageValue('accountTypeNumber');
      }
      $scope.isCare = $rootScope.isCare;
      $scope.isDealer = $rootScope.isDealer;
      $scope.isConsumer = $rootScope.isConsumer;
      $scope.repProfileUpdate = true;

      /*For Consumer all the below values should set to true*/
      $scope.repProfileContactInfoRead = $scope.isConsumer;
      $scope.repProfileContactInfoUpdate = $scope.isConsumer;
      $scope.repProfileBillingDetailsRead = $scope.isConsumer;
      $scope.repProfileBillingDetailsUpdate = $scope.isConsumer;
      $scope.hasLinkedAccount = false;
      $scope.hasAuthorizedAccess = false;
      $scope.hasDataAccess = false;
      $scope.hasDataAccessCare = false; //ove-1074
      $scope.hasAutoRegAccessCare = false; //ove-641

      newAccoutOverviewFactory().getSelectedAccount().then(function(account){
      if (account.accountStatus.toLowerCase() != 'cancelled' && account.accountTypeNumber === 1 && account.isWlsSubTypeExists && account.subNumbers && account.subNumbers.length > 0) {
        $scope.hasAuthorizedAccess = true;
      }
      });

      /**
       * Checking number of accounts in the current profile
       * If no account linked with then current profile
       * then do not display Payment Information section
       */
      newAccoutOverviewFactory().getAccountOverview()
        .then(function (account) {
          if (account.accountList && account.accountList.length >= 1) {
            $scope.hasLinkedAccount = true;
          } else {
            appState.switchView('guestoverview');
          }
        });

      if ($scope.isDealer || $scope.isCare) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.update)
          .then(function (agentPermission) {
            $scope.repProfileUpdate = agentPermission;
          });

        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ProfileContactInfo, ute.common.permissions.service.RamActionCodes.read)
          .then(function (agentPermission) {
            $scope.repProfileContactInfoRead = agentPermission;
          });

        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ProfileContactInfo, ute.common.permissions.service.RamActionCodes.update)
          .then(function (agentPermission) {
            $scope.repProfileContactInfoUpdate = agentPermission;
          });

        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ProfileBillingDetails, ute.common.permissions.service.RamActionCodes.read)
          .then(function (agentPermission) {
            $scope.repProfileBillingDetailsRead = agentPermission;
          });

        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ProfileBillingDetails, ute.common.permissions.service.RamActionCodes.update)
          .then(function (agentPermission) {
            $scope.repProfileBillingDetailsUpdate = agentPermission;
          });
          //ove-1074
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.AuthorizedUsersWCoC, ute.common.permissions.service.RamActionCodes.grant).then(function (isPermitted) {
            $scope.hasDataAccessCare = !!isPermitted;
        });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.AutoRegistration, ute.common.permissions.service.RamActionCodes.grant)
          .then(function (agentPermission) {
            $scope.hasAutoRegAccessCare = agentPermission;
          });
               
      }
      $scope.myrAccountUnlockService = myrAccountUnlockService;
      $scope.unlockAccountLoading = false;
      $scope.accountLocked = false;
      $scope.hideUnlockInfo = false;
      $scope.unlockSuccessStatus = undefined;
      $scope.unlockMessageType = '';
      $scope.accountUnlockMsg = '';
      $scope.isEditUsername = true;
      permissionsService.getUserPermission('WCOC_BRT').then(function (isPermitted) {
          $scope.hasDataAccess = !!isPermitted;
      });

      var scopewatch1 = $scope.$watch('myrAccountUnlockService.accountLockStatus', function () {
        if ($scope.isDealer || $scope.isCare) {
          checkAccountLockStatus();
        }
      });

      function checkAccountLockStatus() {
        if (myrAccountUnlockService.accountLockStatus) {
          $scope.accountLocked = true;
          if (myrAccountUnlockService.unlockClicked) {
            $scope.unlockAccount();
          }
        } else {
          $scope.accountLocked = false;
        }
      }

      $scope.unlockAccount = function () {
        $scope.unlockAccountLoading = true;
        myrAccountUnlockService.accountUnlock().then(function (data) {
          $scope.unlockSuccessStatus = data;
          $scope.unlockMessageType = $scope.unlockSuccessStatus === true ? 'success' : 'error';
          $scope.hideUnlockInfo = true;
          getUnlockResourceString();
        });
      };

    // Wcoc changes
      $scope.redirectToWcocPortal = function () {
        myrAccountListService.generateToken().then(function (data) {
          localStorage.setLocalStorageValue('wcocToken', data);
          var redirectionUri = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
          redirectionUri = redirectionUri + '/web/wcoc/#/manage-users/'+languageSwitcher.getCurrentLanguage().toUpperCase()+'/R?entryId=D';
          sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
          $window.open(redirectionUri, "_self");
        },function (error) {
           console.log(error);
         });
      };

      function getUnlockResourceString() {
        if ($scope.unlockMessageType === 'success') {
          $scope.accountUnlockMsg = $translate.instant('account_unlock_success_message');
        } else {
          $scope.accountUnlockMsg = $translate.instant('account_unlock_error_message');
        }
      }

      $rootScope.$broadcast('startLoading');
      selfServeSvc.getUserProfile(userInfoDefer);
      selfServeSvc.getAccountList(accountsDefer);
      $scope.isEditOpen = function () {
        return profileEditService.getEditPanelStatus();
      };


      $scope.cableCustomer = accountTypeNumber === 6;
      $scope.CredentialsHeading = '';
      $scope.ServiceAddressHeading = '';
      $scope.ContactInformationHeading = '';
      $scope.BillingAddressHeading = '';
      $scope.MarketingPermissionsHeading = 'Marketing Permissions';
      $scope.selectedAccount = {};
      $scope.selectedAccountName = '';
      $scope.showRemovalConfirmation = false;
      $scope.userLanguage = languageSwitcher.getCurrentLanguage();
      $scope.loadedpromise = $q.defer();
      $scope.hasEmailUsername = function () {
        if ($scope.userInfo) {
          return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test($scope.userInfo.userName);
        }
        return false;
      };

      //TODO: move these to their module services
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER).then(function (isPermitted) {
        dataManagerService.setBRT(isPermitted);
      });

      $scope.isFDMEnabled = function () {

        return (
          $scope.selectedAccount &&
          dataManagerService.getModel().isShareEverythingEligible > 0 &&
          dataManagerService.getBRT()
        );

      };

      $scope.isShareEverything = function () {

        if ($scope.isFDMEnabled()) {

          var model = dataManagerService.getModel();

          return (
            model &&
            model.badgeList &&
            model.badgeList.subscriberList.length > 0
          );

        }

        return false;

      };

      $scope.isConsumer = function () {
        return userService.getUserType() === 'consumer';
      }

      var scopewatch2 = $scope.$watch(function () {
        return dataManagerService.getModel().badgeList.subscriberList.length;
      }, function (newValue, oldValue) {
        if (userService.isSigned()) {
          $scope.getFDMUsageDetails();
        } else {
          dataManagerService.resetBadgeList();
        }
      });

      $scope.getFDMUsageDetails = function () {
        dataManagerService.resetBadgeList();
        if ($scope.isFDMEnabled() && $scope.selectedAccount.accountTypeNumber === 1) {

          var acctNum = $scope.selectedAccount.accountNumber;
          dataManagerService.setAccountNumber(acctNum);

          var summaryRequest = {
            accountNumber: parseInt(acctNum, 10),
            accountTypeNumber: $scope.selectedAccount.accountTypeNumber,
            language: $scope.userLanguage,
            applicationId: 'Rogers.com',
            refresh: false
          };

          accountOverviewSummaryFactory(summaryRequest).getAccountOverviewSummaryRawData().then(function (accountOverviewSummary) {
            if (accountOverviewSummary.shareEverything) {
              // console.log(accountOverviewSummary.shareEverything, $scope.isShareEverything());
              dataManagerService.setModel(dataManagerService.transformSummary(accountOverviewSummary, dataManagerService.getModel()));

              if ($scope.isShareEverything()) {
                var request = {
                  accountNumber: $scope.selectedAccount.accountNumber,
                  serviceType: dataManagerService.getConfig().basic.serviceType
                };

                var worker = dataManagerService.getUsageDetailsWorker(request);
                worker.getDataManagerServerGetUsageDetails().then(function (response) {

                  var model = dataManagerService.getModel();
                  var modelTransformed = dataManagerService.transformUsageDetails(response, model);
                  dataManagerService.setModel(modelTransformed);
                  worker.resetCachedData();

                }).catch(function () {
                  dataManagerService.setStateToErrorPage();
                });
              }
            }
          });
        }
      };

      $scope.disassociateAccount = function (account) {

        var originalScope = $scope;
        var modalInstance = $modal.open({
          templateUrl: 'views/modals/account-removal-confirmation.html',
          controller: ['$scope', function ($scope) {

            $scope.accountName = account.name;
            $scope.accountNumber = account.accountNumber;

            $scope.close = function (isRemoval) {
              if (isRemoval) {
                modalInstance.close();
                $state.go($state.current, {}, {reload: true});
                //$route.reload();
                //$window.location.reload();
              }
              modalInstance.close();
            };

            $scope.removeAccount = function () {
              $scope.loading = true;
              selfServeSvc.disassociateAccount({
                disassociateAccountNumber: account.accountNumber, // remove this hardcode
                rogersUserID: $cookies.userToken // part of the scope
              }, account.accountTypeNumber).then(function (/*result*/) {
                $scope.loading = false;
                //$scope.close();
                // remove this account from the account list
                selfServeSvc.removeAccountFromList(account);
                originalScope.selectedAccount = originalScope.accounts[0];

                myrAccountListService.removeAccount(account.accountNumber);
                // show the removal confirmation
                originalScope.showRemovalConfirmation = true;

                if (!originalScope.selectedAccount) {
                  if ($rootScope.isCare) {
                    sessionStorage.deleteSessionStorageValue('accountNumber');
                    sessionStorage.deleteSessionStorageValue('accountTypeNumber');
                  } else {
                    localStorage.deleteLocalStorageValue('accountNumber');
                    localStorage.deleteLocalStorageValue('accountTypeNumber');
                  }
                }

                $scope.showRemovalConfirmation = true;

                $scope.$on('modal.closing', function () {
                  if ($scope.showRemovalConfirmation) {
                    $state.go($state.current, {}, {reload: true});
                  }
                });

              }, function (error) {
                $scope.loading = false;
                $scope.close();
                var modalInstance = $modal.open({
                  templateUrl: 'views/modals/disassociateModalFail.html',
                  windowClass: 'verify-address-modal',
                  controller: ['$scope', 'ute.blocks.language.switcher', function ($scope, languageSwitcher) {
                    $scope.language = languageSwitcher.getCurrentLanguage();
                    $scope.close = function () {
                      modalInstance.close();
                    };
                  }]
                });
              });
            };

          }],
          windowClass: 'verify-address-modal'
        });

      };
      userInfoDefer.promise.then(function () {
        $scope.userInfo = selfServeSvc.getUserInfo();
        $scope.userInfo.defer = $q.defer();
        $scope.userInfo.defer.resolve();
      }, function () {
        $scope.userInfo = {};
        $scope.userInfo.failure = $q.defer();
        $scope.userInfo.failure.resolve(); //
        $rootScope.$broadcast('stopLoading');
      });

      $scope.loading = true;
      $scope.accountsFailed = false;

      accountsDefer.promise.then(function () {
        $scope.accounts = selfServeSvc.getAccounts();
        $scope.loading = false;
        var alreadySelectedAccount = localStorage.getLocalStorageValue('accountNumber');

        $scope.noLinkedAccount = (alreadySelectedAccount === null);

        if ($rootScope.isCare) {
          alreadySelectedAccount = sessionStorage.getSessionStorageValue('accountNumber');
        }

        if (alreadySelectedAccount) {
          $scope.selectedAccount = selfServeSvc.getAccountByAccountNumber(alreadySelectedAccount);
          $scope.getFDMUsageDetails();
        } else if ($scope.accounts.length > 0) {
          $scope.selectedAccount = $scope.accounts[0];
          $scope.getFDMUsageDetails();
        }
      }, function () {
        $scope.accountsFailed = true;
      });

      var alreadySelectedAccount = localStorage.getLocalStorageValue('accountNumber');
      if ($rootScope.isCare) {
        alreadySelectedAccount = sessionStorage.getSessionStorageValue('accountNumber');
      }
      $scope.hideMarketingPermissionsSection = true;
      /**
       * Comment out the following code based on
       * MYR-2669 - Remove Marketing permissions call from MyRogers Profile page
       */
      // selfServeSvc.getMarketingPermissions(alreadySelectedAccount).then(function (marketingPermissions) {
      //   $scope.hideMarketingPermissionsSection = false;
      //   if (marketingPermissions) {
      //     $scope.MarketingPermissions = selfServeSvc.transformMarketingPermissions(marketingPermissions);
      //   }
      // });

      $rootScope.$broadcast('marketingPermissionsStopLoading');

      $scope.selectedAccountChanged = function (account) {
        $scope.hasAuthorizedAccess = false;
        $scope.selectedAccount = account;
        $scope.getFDMUsageDetails();
          if (account.accountStatus.toLowerCase() != 'cancelled' && account.accountTypeNumber === 1 && account.isWlsSubTypeExists && account.subNumbers && account.subNumbers.length > 0) {
            $scope.hasAuthorizedAccess = true;
          }
      };

      $scope.accountChanged = function (account, oldAccountValue) {
        if (account && account.accountNumber) {
          var billingTypeDefer = $q.defer();
          if (+account.accountTypeNumber !== 9) {
            // get billing type only if it is NOT a prepaid account
            selfServeSvc.getBillingType(account.accountNumber, account.accountTypeNumber, billingTypeDefer);
          } else {
            billingTypeDefer.reject();
          }

          var contactInfoDefer = $q.defer();
          selfServeSvc.getContactInfo(account.accountNumber, contactInfoDefer);
          //updating localStorage as requested by Shiv
          if ($rootScope.isCare) {
            sessionStorage.setSessionStorageValue('accountNumber', account.accountNumber);
            sessionStorage.setSessionStorageValue('accountTypeNumber', account.accountTypeNumber);
          } else {
            localStorage.setLocalStorageValue('accountNumber', account.accountNumber);
            localStorage.setLocalStorageValue('accountTypeNumber', account.accountTypeNumber);
          }
          var detailPromise = $q.defer();
          selfServeSvc.getAccountDetails(account, detailPromise, $scope.userLanguage);
          selfServeSvc.setCurrentAccount(account);
          //$scope.selectedAccount = account;
          $rootScope.$broadcast('startLoading');

          $scope.loading = true;

          $scope.ContactInformation = {isloaded: false};
          $scope.hideMarketingPermissionsSection = true;

          if (oldAccountValue && oldAccountValue.accountNumber) {
            //Only getMarketingPermissions if this is triggered by an select account change
            // and not when the app initially loads
            /**
             * Comment out the following code based on
             * MYR-2669 - Remove Marketing permissions call from MyRogers Profile page
             */
            // selfServeSvc.getMarketingPermissions(account.accountNumber).then(function (marketingPermissions) {
            //   $scope.hideMarketingPermissionsSection = false;
            //   if (marketingPermissions) {
            //     $scope.MarketingPermissions = selfServeSvc.transformMarketingPermissions(marketingPermissions);
            //   }
            // });
          }

          detailPromise.promise.then(function (account) {

            $scope.BillingAddress = account.billingAddress; //selfServeSvc.getBillingAddressForAccount(account); // old reference
            $scope.BillingAddress.hasActiveResidentialServices = account.billingAddress.hasActiveResidentialServices;
            userInfoDefer.promise.then(function () {
              $scope.userInfo.defer.promise.then(function () {
                $scope.BillingAddress.validEmail = !!$scope.userInfo.email;
              });
            });

            (function fnWrapper(currentAccountNumber) {
              billingTypeDefer.promise.then(function (data) {
                if (currentAccountNumber == $scope.selectedAccount.accountNumber) {
                  if (data.billingtype === 'INVOICE') {
                    $scope.BillingAddress.paper = true;
                    $scope.BillingAddress.ebill = false;
                  } else if (data.billingtype === 'E_BILL') {
                    $scope.BillingAddress.paper = false;
                    $scope.BillingAddress.ebill = true;
                  }
                  /**
                   * Set initial Billing Type value to a new variable
                   * This will not change during run time.
                   */
                  $scope.BillingAddress.initialBillingType = data.billingtype;
                  $scope.BillingAddress.billingType = data.billingtype;
                }
              }, function (error) {
                //
              });
            })(account.accountNumber);

            (function fnWrapper(currentAccountNumber) {
              contactInfoDefer.promise.then(function (data) {
                if (currentAccountNumber === $scope.selectedAccount.accountNumber) {
                  $scope.ContactInformation = selfServeSvc.buildContactInformation($scope.selectedAccount, data);
                  selfServeSvc.setContactInfo(currentAccountNumber, $scope.ContactInformation);
                  $scope.ContactInformation.isloaded = true;
                  /**
                   * Reset updatedEmailAddress to empty string when calling getContactInfo
                   */
                  selfServeSvc.resetUpdatedEmailAddress();
                  /**
                   * Add Email address to the billing address object for update bill type
                   * An empty string will be set to the emailAddress porperties
                   */
                  if (_.has($scope, 'ContactInformation.email')) {
                    $scope.BillingAddress.emailAddress = $scope.ContactInformation.email;
                  } else {
                    $scope.BillingAddress.emailAddress = '';
                  }
                  /**
                   * Add contactId to the billing address object for update bill type
                   * An empty string will be set to the contactId porperties
                   */
                  if (_.has($scope, 'ContactInformation.contactId')) {
                    $scope.BillingAddress.contactId = $scope.ContactInformation.contactId;
                  } else {
                    $scope.BillingAddress.contactId = '';
                  }

                  $scope.BillingAddress.accountNumber = currentAccountNumber;
                  $scope.BillingAddress.accountTypeNumber = $scope.selectedAccount.accountTypeNumber;
                }
              }, function (error) {
                //
              });
            })(account.accountNumber);

            $rootScope.$broadcast('stopLoading');
            $scope.loading = false;
          }, function (response) {
            // this is an error
            $rootScope.$broadcast('stopLoading');
            $scope.loading = false;
            if (response && response.data && response.data.config && response.data.config.data && response.data.config.data.accountTypeNumber &&
              response.data.config.data.accountTypeNumber == 9) {
              $scope.prepaidAccount = true;
            } else {
              $scope.generalError = true;
              $scope.accountsFailed = true;
            }
          });
        }
      };
      $scope.addAccount = function () {
        appState.switchView('linkaccount');
      };

      var scopewatch3 = $scope.$watch('selectedAccount', function (account, oldValue) {
        $scope.accountChanged(account, oldValue);
      });
      $scope.notifyServer = function () {
        selfServeSvc.updateMarketingPermissions();
      };

      $scope.updateAccountInfo = selfServeSvc.updateAccountInfo;
      $scope.updateServiceAddress = selfServeSvc.updateServiceAddress;
      $scope.updateContactInformation = selfServeSvc.updateContactInformation;
      $scope.updateBillingAddress = selfServeSvc.updateBillingAddress;
      $scope.updateMarketingPermissions = selfServeSvc.updateMarketingPermissions;
      $scope.assosciatedAccountsExist = true; //
      $scope.updateBillingType = selfServeSvc.updateBillingType;
      $scope.updatePinEmailAddress = selfServeSvc.updatePinEmailAddress;
      $scope.updateEmailAddress = selfServeSvc.updateEmailAddress;
      $scope.postActionAfterGoPaperlessServiceCall = function (newEmailAddress, newBillingType) {
        if (newEmailAddress) {
          $scope.selectedAccount.contactInformation.email = newEmailAddress;
        }
        if (newBillingType) {
          if (newBillingType === 'INVOICE') {
            $scope.BillingAddress.paper = true;
            $scope.BillingAddress.ebill = false;
          } else if (newBillingType === 'E_BILL') {
            $scope.BillingAddress.paper = false;
            $scope.BillingAddress.ebill = true;
          }

          $scope.BillingAddress.initialBillingType = newBillingType;
          $scope.BillingAddress.billingType = newBillingType;
        }
      };

      $scope.contactInformationCtrl = function (scope) {
        var scopewatch5 = scope.$watch('editableData.english', function () {
          if (scope.editableData.english) {
            scope.editableData.french = false;
          }
        });

        var scopewatch6 = scope.$watch('editableData.french', function () {
          if (scope.editableData.french) {
            scope.editableData.english = false;
          }
        });

        scope.$on('$destroy', function () {
          // scopewatch4();
          scopewatch5();
          scopewatch6();
        });

      };
      $rootScope.resetPwdSuccessStatus = undefined;
      $scope.messageType = undefined;
      $scope.resetPwdLoading = undefined;
      $scope.isRepView = $rootScope.isRepView === 'true';

      var rootwatch1 = $rootScope.$watch('resetPwdLoading', function () {
        if (angular.isDefined($rootScope.resetPwdLoading)) {
          $scope.resetPwdLoading = $rootScope.resetPwdLoading;
        }
      });
      var rootwatch2 = $rootScope.$watch('isRepView', function () {
        $scope.isRepView = $rootScope.isRepView === 'true';
      });
      var rootwatch3 = $rootScope.$watch('resetPwdSuccessStatus', function () {
        if (angular.isDefined($rootScope.resetPwdSuccessStatus)) {
          $scope.resetPwdSuccessStatus = $rootScope.resetPwdSuccessStatus;
          $scope.messageType = $scope.resetPwdSuccessStatus === true ? 'success' : 'error';
          getResetPwdResourceString();
          /* resource.resolveResource().then(function () {
           getResetPwdResourceString();
           });*/
        }
      });

      function getResetPwdResourceString() {
        if ($scope.messageType === 'success') {
          $scope.resetPwdResponseMsg = $translate.instant('reset_password_sucess_message') + ' ' + $rootScope.resetPwdEmail;
        } else {
          $scope.resetPwdResponseMsg = $translate.instant('reset_password_error_message');
        }
      }

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        $scope.userLanguage = lang;
        if (angular.isDefined($rootScope.resetPwdSuccessStatus)) {
          getResetPwdResourceString();
        } else if (angular.isDefined($scope.unlockMessageType)) {
          getUnlockResourceString();
        }
      }, 'selfServeCtrlLangSub');

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler('selfServeCtrlLangSub');
        $timeout.cancel(scrollPageToTopTimer);
        $timeout.cancel(scrollPageHandlerTimer);
        scopewatch1();
        scopewatch2();
        scopewatch3();
        rootwatch1();
        rootwatch2();
        rootwatch3();
        rootwatch4();
        rootwatch5();
      });

      $scope.isGuidNotFound = $rootScope.isGuidNotFound;
      var rootwatch4 = $rootScope.$watch('isGuidNotFound', function () {
        $scope.isGuidNotFound = $rootScope.isGuidNotFound;
      });

      $scope.localNickName = {
        nickNameTruncated: false,
        nickName: '',
        nickNameBeingEdited: false
      };

      $scope.getNickName = function () {
        if ($scope.selectedAccount) {
          $scope.localNickName.nickName = $scope.selectedAccount.nickname ||
            ($scope.selectedAccount.accountName ?
              ($scope.selectedAccount.accountName.firstName + ($scope.selectedAccount.accountName.lastName ? ' ' + $scope.selectedAccount.accountName.lastName : '')) : '');

          if ($scope.localNickName.nickName.length > 14) {
            $scope.localNickName.nickNameTruncated = true;
            $scope.localNickName.nickName = $scope.localNickName.nickName.substring(0, 14);
          }
          else {
            $scope.localNickName.nickNameTruncated = false;
          }
        }
        else {
          $scope.localNickName.nickName = '';
        }

        return $scope.localNickName.nickName;
      };

      $scope.editNickName = function () {
        resetNickNameEditing(true);
      };

      $scope.saveNickNameChanges = function (/*form*/) {
        if ($scope.selectedAccount &&
          (!$scope.selectedAccount.nickname || $scope.selectedAccount.nickname !== $scope.localNickName.nickName)) {
          selfServeSvc.updateNickName($scope.selectedAccount.accountNumber,
            $scope.selectedAccount.accountTypeNumber,
            $scope.localNickName.nickName).then(function (/*data*/) {
            $scope.selectedAccount.nickname = $scope.localNickName.nickName;
            newAccoutOverviewFactory().updateNickName($scope.localNickName.nickName).then(function (accountOverview) {
              // console.log('after updateNickName call', accountOverview.rawData);
            });

            resetNickNameEditing(false);
          }, function (/*error*/) {
            resetNickNameEditing(false);
            var modalInstance = $modal.open({
              templateUrl: 'views/modals/updateNickNameFail.html',
              windowClass: 'verify-address-modal',
              controller: ['$scope', 'ute.blocks.language.switcher', function ($scope, languageSwitcher) {
                $scope.language = languageSwitcher.getCurrentLanguage();
                $scope.close = function () {
                  modalInstance.close();
                };
              }]
            });
          });
        } else {
          resetNickNameEditing(false);
        }
      };

      $scope.cancelNickNameEdit = function () {
        resetNickNameEditing(false);
      };

      var rootwatch5 = $scope.$watchGroup(['selectedAccount.contactInformation.email', 'selectedAccount.accountNumber'], function (newValue, oldValue) {
        if (newValue[1] === oldValue[1] && $scope.BillingAddress) {
          $scope.BillingAddress.emailAddress = newValue[0];
        }
      });

      function resetNickNameEditing(editing) {
        $scope.localNickName.nickNameBeingEdited = editing;
        profileEditService.setEditPanelStatus(editing);
        $scope.getNickName();
      }
    }])
    .factory('profileEditService', [function () {
      var _editPanelStatus = false;
      var getEditPanelStatus = function getEditPanelStatus() {
        return _editPanelStatus;
      };
      var setEditPanelStatus = function setEditPanelStatus(status) {
        _editPanelStatus = status;
      };
      return {
        getEditPanelStatus: getEditPanelStatus,
        setEditPanelStatus: setEditPanelStatus
      };
    }]);
})();

(function () {
  'use strict';
  angular.module('totesApp').directive('altTextForBoldChatButton', function () {
    return {
      template: '<div id="{{boldChatDiv}}"></div>' ,
      replace: true,
      restrict: 'EA',
      scope: {
        cbid: '=',
        cbidFr: '=',
        boldChatDiv: '=dynamicDiv',
        chatButton: '=',
        errorMessage: '=',
        chatButtonFr: '=',
        lang: '=',
        altText: '=',
        needHelpTextKey: '@'
      },
      link: function (scope, element, attrs) {
        var invokeBoldChat = function (oldValue) {
          var cbid = (scope.lang === 'fr' ? scope.cbidFr : scope.cbid),
            chatButton = (scope.lang === 'fr' ? scope.chatButtonFr : scope.chatButton);

          var bdid = /^\d+$/.test(cbid) ? cbid : getBDId(cbid); // jshint ignore:line
          if (scope.altText === null && scope.altText === undefined) {
            staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage); // jshint ignore:line
          } else {
              liveChatAltTextUTE(scope.altText, bdid, scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage);
          }
        };

        var scopewatch1 = scope.$watch(function () {
            return document.getElementById(scope.boldChatDiv);
          }, function (newValue) {
            if (null !== newValue) {
              invokeBoldChat();
            }
          }
        );

        var scopewatch2 = scope.$watch('chatButton', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            invokeBoldChat(oldValue);
          }
        }, true);

        if (scope.lang) {
          var scopewatch3 = scope.$watch('lang', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              scope.chatButton = scope.lang === 'fr' ? scope.chatButtonFr : scope.chatButton;
            }
          }, true);
        }

        invokeBoldChat();

        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch1();
          scopewatch2();
          scopewatch1();
        });

      }
    };
  });
}());

'use strict';

angular.module('totesApp')
    .directive('accountSelector', ['settings', '$rootScope', 'appState', function (settings, $rootScope, appState) {
      return {

        replace: true,

        templateUrl: 'scripts/directives/accountSelector/accountSelector.html',

        restrict: 'E',

        link: function ($scope, $elem, attr) {
          //console.log($scope);
          $scope.postToRogersUrls = [
            {url: '/web/myrogers/viewBill'},

            {url: '/web/myrogers/prepaidTopUp'}

          ];
          $scope.postToRogers = function () {

            // console.log( this);
            if ($rootScope.winFlag) {
              appState.switchView('winOnlineInvoice');
            } else {
              var selectedAccount = this.value;
              $('#formToRogers').attr('accountNumber', selectedAccount.accountNumber);
              /*$('#formToRogers').attr('ctn', selectedAccount.ctnNumber);
               $('#formToRogers').attr('passCode', selectedAccount.pinNumber);*/
              $('#formToRogers').attr('action', $scope.postToRogersUrls[0].url);

              $('#formToRogers').submit();
            }
          };
        }
      };
    }]);

'use strict';

angular.module('totesApp').directive('attemptsErrorBox', function () {

	return {
		templateUrl: 'scripts/directives/attemptsErrorBox/attemptsErrorBox.html',
		replace: true,
		restrict: 'E'
	};
});


'use strict';
angular.module('totesApp').directive('cartMenuOLD', cartMenuOLD);
cartMenuOLD.$inject = [];

function cartMenuOLD() {
  return {
    scope: {},
    templateUrl: 'scripts/directives/cartMenu/cartMenu.html',
    restrict: 'EA',
    controller: 'cartMenuControllerOLD',
    link: function (scope, element, attrs) {
    }
  };
}

//controller
angular.module('totesApp').controller('cartMenuControllerOLD', cartMenuControllerOLD);
cartMenuControllerOLD.$inject = ['$scope', 'cartMenuService', '$rootScope', 'ajax', 'localStorage', 'bfappcWirelessDashboardService', 'ute.rogers.account.overview.factory', 'ute.common.permissions.service', 'sessionStorage', '$q'];

function cartMenuControllerOLD($scope, cartMenuService, $rootScope, ajax, localStorage, bfappcWirelessDashboardService, newAccountOverviewFactory, permissionsService, sessionStorage, $q) {
  $scope.isDealer = $rootScope.isDealer;
  $scope.isCare = $rootScope.isCare;
  $scope.isConsumer = $rootScope.isConsumer;
  $scope.isRepView = $rootScope.isRepView === 'true';
  $scope.isInactiveBan = false;
  if ($scope.isCare || $scope.isDealer) {
    $scope.interactionBRTSwitchName = $scope.isCare ? 'ONEVIEW_INTERACTION_NOTES_CARE' : 'ONEVIEW_INTERACTION_NOTES_DEALER';
  }
  var watcher = $rootScope.$watch('isRepView', function () {
    $scope.isRepView = $rootScope.isRepView === 'true';
  });
  $scope.loadingImg = false;
  var request = {};
  $scope.permittedShopping = false;
  $scope.consumerCart = true;

  $scope.checkCartIcon = function () {
    if ($scope.isCare || $scope.isDealer) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ShoppingCart, ute.common.permissions.service.RamActionCodes.start).then(function (hasShoppingAccess) {
        $scope.permittedShopping = !!hasShoppingAccess;
      }, function (error) {
      });
    }
  };


  $scope.checkPermission = function () {
    var permissionChecks = [];
    if ($scope.isCare || $scope.isDealer) {
      permissionChecks.push(permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PPCBuyFlow, ute.common.permissions.service.RamActionCodes.start));
      permissionChecks.push(permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.HUPBuyFlow, ute.common.permissions.service.RamActionCodes.start));
      $scope.callPermissionAPI(permissionChecks);
    }
    else {
      $scope.callPermissionAPI();
    }
  };

  $scope.callPermissionAPI = function (permissionChecks) {
    if(permissionChecks) {
      $q.all(permissionChecks).then(function (isPermitted) {
        if (isPermitted.indexOf(true) >= 0) {
          var accountNumber = '';
          if ($scope.isCare) {
            accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
            if (accountNumber) {
              request['ban'] = accountNumber;
              getSelectedAccountOverviewData(accountNumber);//DSO-13761
              $scope.fetchOrder();
            }
          } else {
              newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewHandler, 'cartMenuControllerOLD');
              getAccountOverviewData();
           }
        }
      });
    } else {
       newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewHandler, 'cartMenuControllerOLD');
       getAccountOverviewData();
    }
  };

  function accountOverviewHandler(accountOverview) {
    if (accountOverview) {
      var selectedAccount = accountOverview.getSelectedAccount();
      $scope.isInactiveBan =  (selectedAccount.accountStatus != 'Active') ? true : false;
      var selector = {accountNumber: String(selectedAccount.accountNumber)};
      if (selector.accountNumber && (selector.accountNumber != request['ban'])) {
        request['ban'] = selector.accountNumber;
        $scope.fetchOrder();
      }
    }
    return null;
  }

  function accountCareOverviewHandler(accountOverview) {
      if (accountOverview) {
        var selectedAccount = accountOverview.getSelectedAccount();
        $scope.isInactiveBan =  (selectedAccount.accountStatus != 'Active') ? true : false;
      }
      return null;
    }

  function getAccountOverviewData() {
    return newAccountOverviewFactory().getAccountOverview().then(accountOverviewHandler)['catch'](function (reason) {
      return console.log('cartMenuController->getAccountOverview->catch:', reason),
        null
    })
  }

   function getSelectedAccountOverviewData(accountNumber) {
      return newAccountOverviewFactory().getAccountOverview(accountNumber).then(accountCareOverviewHandler)['catch'](function (reason) {
        return console.log('cartMenuController->getSelectedAccountOverviewData->catch:', reason),
          null
      })
    }

  $scope.fetchOrder = function () {
    $scope.loadingImg = true;
    cartMenuService.setFetchCalled(true);
    $scope.content = null;
    bfappcWirelessDashboardService.fetchOrder(request).then(
      function (response) {
        if (response && response.success) {
          $scope.content = response;
          $scope.loadingImg = false;
          bfappcWirelessDashboardService.fetchOrderCompleted = true;
          bfappcWirelessDashboardService.fetchOrderFullResponse = response;
          cartMenuService.setFetchResponse(response);
        } else {
          $scope.loadingImg = false;
        }
      },
      function (error) {
        $scope.loadingImg = false;
      }
    );
  };
  $scope.checkCartIcon();
  $scope.checkPermission();

  // Remove any $rootscope watchers
  $scope.$on('$destroy', function () {
    watcher();
  });
}

(function(){
 'use strict';
 angular.module('totesApp').service('cartMenuServiceOLD',cartMenuServiceOLD);
 cartMenuServiceOLD.$inject = ['ajax'];

 function cartMenuServiceOLD(ajax) {
   var self = {
     fetchOrderCalled : false,
     fetchOrderResponse : ''
   };
   self.fetchOrder = function(postData) {
     return ajax.fetchCartOrder(postData);
   }
   self.saveState = function(postData) {
     return ajax.saveState(postData);
   }
   self.fetchValidatedCart = function(postData) {
     return ajax.fetchValidatedCart(postData);
   }
   self.validateOrder = function() {
     return ajax.validateOrder();
   }
   self.isFetchOrderCalled = function () {
     return self.fetchOrderCalled;
   };
   self.setFetchResponse = function(response) {
     self.fetchOrderResponse = response;
   }
   self.getFetchResponse = function() {
     return self.fetchOrderResponse;
   }
   self.setFetchCalled = function(value) {
     self.fetchOrderCalled = value;
   }
   self.agentInfo = function() {
     return ajax.agentInfo();
   }
   return {
     'fetchOrder': self.fetchOrder,
     'saveState': self.saveState,
     'fetchValidatedCart': self.fetchValidatedCart,
     'validateOrder': self.validateOrder,
     'isFetchOrderCalled': self.isFetchOrderCalled,
     'setFetchResponse' : self.setFetchResponse,
     'getFetchResponse' : self.getFetchResponse,
     'setFetchCalled': self.setFetchCalled,
     'agentInfo':self.agentInfo
   };
 }
})
();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
'use strict';
 angular.module('totesApp').directive('consumerCartMenuOLD', consumerCartMenuOLD);
 consumerCartMenuOLD.$inject = [];

  /* @ngInject */
  function consumerCartMenuOLD() {
    return {
      scope: {
       'content' : '='
      },
      templateUrl: 'scripts/directives/cartMenu/consumerCartMenu.html',
      restrict: 'EA',
      controller: 'consumerCartMenuControllerOLD'
    };
  }

 //controller
 angular.module('totesApp').controller('consumerCartMenuControllerOLD', consumerCartMenuControllerOLD);
 consumerCartMenuControllerOLD.$inject = ['$scope',
    'cartMenuService',
    '$location',
    '$rootScope',
    'localStorage',
    'sessionStorage',
    'settings',
    'backToSSPService',
    'bfappcWirelessDashboardService',
    '$state',
    'ngDialog',
    'ajax',
    '$modal',
    '$window',
    '$translate',
    'ute.common.user.service',
    'ute.common.permissions.service',
    'ute.blocks.persistent.storage.service',
    'ute.dtm.service'
  ];

  /* @ngInject */
  function consumerCartMenuControllerOLD($scope, // jshint ignore:line
                                      cartMenuService,
                                      $location,
                                      $rootScope,
                                      localStorage,
                                      sessionStorage,
                                      settings,
                                      backToSSPService,
                                      bfappcWirelessDashboardService,
                                      $state,
                                      ngDialog,
                                      ajax,
                                      $modal,
                                      $window,
                                      $translate,
                                      userService,
                                      permissionsService,
                                      utePersistentStorageService,
                                      dtmService) {

   $scope.orders = [];
   $scope.quotes = [];
   $scope.isDealer = $rootScope.isDealer;
   $scope.isCare = $rootScope.isCare;
   $scope.isConsumer = $rootScope.isConsumer;
   $scope.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;
   $scope.permissionsObj = {};
   $scope.isHupFlowProcessSaved = false;
   $scope.isFetchOrderCompleted = bfappcWirelessDashboardService.isFetchOrderCompleted;
   $scope.clickedOrder = '';
   var wirelessDashPopup = {
       template: 'scripts/directives/hup/deviceBalance/wirelessDashPopup.html',
       scope: $scope,
       className: 'ngdialog-theme-default',
       showClose: true,
       appendTo: 'div[ui-view]',
       closeByDocument: true
   };
   ajax.getPermissions().then(function (data) {
     $scope.permissionsObj = data;
   });
   var scopewatch1 = $scope.$watchGroup(['isFetchOrderCompleted()', 'permissionsObj'], function (newValue, oldValue) {
       $scope.isHupFlowProcessSaved = !!(newValue !== oldValue && !_.isEmpty($scope.permissionsObj) &&
       newValue[0] && !_.isUndefined(bfappcWirelessDashboardService.getFetchOrderFullResponse().hup) &&
       bfappcWirelessDashboardService.getFetchOrderFullResponse().hup.length > 0 && isCtnHasSavedCart());
   });

   var ctn = '';
   var ban = '';
   var accountTypeNo = '';

  // ban = localStorage.getLocalStorageValue('accountNumber');

   function init() {
     $scope.ordersArray = _.flattenDeep(_.filter($scope.content, function (key, value) {
       console.log('orders1',$scope.ordersArray)
       return value === 'ppc' || value === 'hup' || value === 'nac' || value === 'ignite';
     }));
     
   }

   function processJSON(){
     //console.log("in process" + JSON.stringify($scope.content))
     $scope.totalOrders = _.size($scope.ordersArray);
     console.log('orders',$scope.totalOrders);
     $scope.orders = _.filter($scope.ordersArray,function(key,value){
        return !key.quotation;
     });
     $scope.quotes = _.filter($scope.ordersArray,function(key,value){
        return key.quotation === true;
     });
   }
   //on click of any quote or order
   $scope.redirectToPage = function(activityType,orderId,orderType,contactNo, order){
        localStorage.setLocalStorageValue('phoneNumber',contactNo);
        ctn = localStorage.getLocalStorageValue('phoneNumber');
        ban = localStorage.getLocalStorageValue('accountNumber');
        accountTypeNo = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber');
        utePersistentStorageService.putToSession('order', order ); // BCR-693 Analytics: Send the order data to analytics mainly who saved the quote/order (orderSavedByAgent) like cx or rep
        var saveStatePassJSON = {
          'ctn' : ctn,
          'ban' : ban,
          'activityTypeKey' : activityType,
          'accountTypeNumber' : accountTypeNo
        };
        var fetchValidatedCartPassJSON = {
           'ban' : ban,
           'ctn' : ctn,
           'orderId' : orderId,
           'activityTypeKey' : activityType
        };
        var NFDBrequest = {
                'refresh': false,
                'accountNumber': ban,
                'phoneNumber': ctn,
                'nfdbCaching': true,
                'activityType': activityType
              };
      if (orderType === 'quote') {
           $scope.clickedOrder = orderId;
           cartMenuService.saveState(saveStatePassJSON).then(
             function(response){
                if(response && response.success){
                  cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
                    function(res){
                      if(res && res.success){
                        cartMenuService.validateOrder().then(
                          function(vres){
                            if(vres && vres.success){
                              $scope.clickedOrder = '';
                                if (activityType.toLowerCase() === 'ppc') {
                                $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                              }
                                else if (activityType.toLowerCase() === 'hup') {
                                $window.location.href = '/web/totes/upgrade/#/checkout/review';
                              }
                            }
                          },
                          function(verr){
                            //error in validate Order
                          }
                        );
                      }
                    },
                    function(err){
                      //error in fetchValidatedCart
                    }
                  );
                }
             },
             function(error){
              //error in saveState
             }

           );
        }
        else{
        if (activityType.toLowerCase() === 'ppc') {
               $scope.clickedOrder = orderId;
               openPPC();
           }
        else if (activityType.toLowerCase() === 'hup') {
           $scope.clickedOrder = orderId;
           var hupOrders = bfappcWirelessDashboardService.getHuporderForCtn(ctn);
              var hupActiveOrder = hupOrders[0];
              if(hupActiveOrder && hupActiveOrder.orderSavedStep && hupActiveOrder.orderSavedStep == "orderReview"){
               cartMenuService.saveState(saveStatePassJSON).then(
                    function(response){
                       if(response && response.success){
                         cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
                           function(res){
                             if(res && res.success){
                                var hupOrder = res.hup;
                                var currentHupOrder =getCurrentHupOrder(hupOrder,hupActiveOrder.orderId);
                                var isDeviceValid = true;
                                var isPlanValid = true;
                                var isAddOnValid = true;
                                _.forEach(currentHupOrder[0].cartItems, function (item) {
                                  if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && !item.valid){
                                  isDeviceValid=false;
                                  }
                                  if(item.activityType == 'HUP' && item.itemType == 'planCommerceItem' && !item.valid){
                                    isPlanValid=false;
                                  }
                                  if(item.activityType == 'HUP' && item.itemType == 'addonCommerceItem' && !item.valid){
                                    isAddOnValid=false;
                                  }
                                });
                                if(!isDeviceValid || !isPlanValid || !isAddOnValid){
                                   if(!isPlanValid || !isAddOnValid){
                                     var popupObj = {};
                                     var saveRequest = {
                                      'orderSavedStep' : ''
                                     };
                                     ajax.saveOrder(saveRequest);
                                   }
                                   popupObj.preCloseCallback = function () {
                                     $scope.showChatCallIcon = false;
                                     $scope.showButtons = false;
                                     if(!isDeviceValid){
                                       $window.location.href = '/web/totes/upgrade/#/choose-phone';
                                     }
                                     else{
                                      $window.location.href = '/web/totes/upgrade/#/build-plan';
                                     }
                                   };
                                   $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                                   $scope.showChatCallIcon = true;
                                   $scope.showButtons = true;
                                   openGenericErrorPopup(popupObj);
                                }
                                else{
                               ajax.isNFDBCheck(NFDBrequest).then(
                                 function(nres){
                                 if(!nres.isNFDBExistInd){
                                  cartMenuService.validateOrder().then(
                                   function(vres){
                                     if(vres && vres.success){
                                        if (hupActiveOrder.activityType.toLowerCase() === 'ppc') {
                                         $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                                       }
                                         else if (hupActiveOrder.activityType.toLowerCase() === 'hup') {
                                         $window.location.href = '/web/totes/upgrade/#/checkout/review';
                                       }
                                     }
                                     else{
                                      var popupObj = {};
                                      $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                      $scope.showChatCallIcon = true;
                                      $scope.showButtons = true;
                                      openGenericErrorPopup(popupObj);
                                     }
                                   },
                                   function(verr){
                                      var popupObj = {};
                                      $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                      $scope.showChatCallIcon = true;
                                      $scope.showButtons = true;
                                      openGenericErrorPopup(popupObj);

                                   }
                                 );
                             }
                             else{
                               dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                               notEligibleDeviceUpgrade('NFDB');

                             }
                           },
                           function(nerr){
                             dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                             notEligibleDeviceUpgrade('NFDB');

                           }
                         );
                       }
                       }
                       else{
                         popupObj = {};
                         var hupOrder = res.hup;
                         var currentHupOrder = getCurrentHupOrder(hupOrder,orderId);
                         var isDeviceValid = false;
                         _.forEach(currentHupOrder[0].cartItems, function (item) {
                           if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && item.valid){
                             isDeviceValid=true;
                           }
                         });
                           popupObj.preCloseCallback = function () {
                             $scope.showChatCallIcon = false;
                             $scope.showButtons = false;
                             if(!isDeviceValid){
                               $window.location.href = '/web/totes/upgrade/#/choose-phone';
                              }
                              else{
                              $window.location.href = '/web/totes/upgrade/#/build-plan';
                              }
                           };
                         $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                         $scope.showChatCallIcon = true;
                         $scope.showButtons = true;
                         openGenericErrorPopup(popupObj);
                       }
                    },
                    function(err){
                     var popupObj = {};
                     $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                     $scope.showChatCallIcon = true;
                     $scope.showButtons = true;
                     openGenericErrorPopup(popupObj);
                    }

                  );
               }
               },
               function(error){
                 var popupObj = {};
                 $scope.errorMessage = $translate.instant('generic_error_message');
                 $scope.showChatCallIcon = true;
                 $scope.showButtons = true;
                 openGenericErrorPopup(popupObj);
               }
             );
                 }
                 else{
               openHUP();
               }
           }
        else if (activityType.toLowerCase() === 'nac') {
               $scope.clickedOrder = orderId;
               openNAC(activityType,orderId,orderType,contactNo, order);
           }
        }

    };
    function getCurrentHupOrder (hupOrders,currentOrderID){
      if(hupOrders.length > 0){
        return _.filter(hupOrders, function (order) {
        return order.orderId === currentOrderID;
        });
      }
    }
   //navigate to PPC
    function openPPC() {
      if ($scope.isDealer) {
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
        $scope.deepLinkingModal();
      }
      else {
        //$scope.changeBtnLoading(true);
        var appStateForPPC = {
          ban: '',
          ctn: '',
          accountTypeNumber: '',
          flow: 'PPC',
          eligibilityChecked: 'false',
          availableCreditAmount: 0,
          ctnList: []
        };

        bfappcWirelessDashboardService.gotoBFAPPC(appStateForPPC).then(
          function () {
            //$scope.changeBtnLoading(false);
            $scope.clickedOrder = '';
          },
          function (q2ppcBrtSwitch) {
            // BFA-PPC BRT switch is off
            if (q2ppcBrtSwitch) {
              //if q2PPC itself is on BRT we should only display a msg
              $scope.openChangePlanModal();
            } else {
              $state.go('wireless-plan-change');
            }
            //$scope.changeBtnLoading(false);
            $scope.clickedOrder = '';
          }
        );
      }
    }
   //navigate to HUP
  function openHUP(){
     /* if (!$scope.restoreCartloadingIndicator) {
       $scope.upgradeDeviceObjloadingIndicator = true;
     }
    */
    if (!userService.isSigned()) {
      $location.path('/signin');
      return;
    }
    if ($scope.isDealer) {
      if ($scope.permissionsObj && $scope.permissionsObj.permissions &&
        $scope.permissionsObj.permissions.length !== 0 &&
          _.find($scope.permissionsObj.permissions, {'permission': 'ONEVIEW_HUP'})) {  //todo need refactoring to use permissionsService
        $rootScope.targetFlow = settings.deepLinkStatusCodes.upgradeDevice;
        $scope.deepLinkingModal();
        return;
      }
    }
    if ($scope.isConsumer) {
      var request = {
        refresh: false,
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        phoneNumber: localStorage.getLocalStorageValue('phoneNumber'),
        nfdbCaching: true,
        activityType: 'HUP'
      };
      ajax.isNFDBCheck(request).then(NFDBCheckResolve, NFDBError);
    }
  }

    //navigate to NAC
    ///this is for SEE project
    $scope.nacFlowURL = "/web/totes/wireless/#/choose-phone";
    $scope.nacFlowResumeURL = "/web/totes/wireless/#/checkout/cart-summary";

    function openNAC(activityType,orderId,orderType,contactNo, order) {
      //$window.location.href = '/web/totes/new-wireless-line/#/choose-phone';
      //Redirected to cart-summary page according to story BFA-6968
      // IF SEE_UTE true check for permission else redirect to cart-summary page
      if(order && !order.ban){
        bfappcWirelessDashboardService.openSomethingWentWrongPopup();
        return;
      }
      localStorage.setLocalStorageValue('accountNumber', order.ban);
      var checkForNACSavedCartRequest = {
        ban: order.ban,
        ctn: order.assemblyIds ? order.assemblyIds.join(',') : "",
        orderId: orderId,
        activityTypeKey: 'NAC',
        existingLinesCount: ""
      };
      /*ajax.getBrtSwitches().then(function(data){
        var isBrtOn = !!_.find(data, function (item) {return item.id === 'SEE_UTE' && item.switchIsOn === true;});
        if(isBrtOn){
          permissionsService.getUserPermission('SEE_UTE_PAGE_VIEW').then(function (isPermitted) {
            if(isPermitted){
              checkForNACSavedCart(checkForNACSavedCartRequest);
            }else{
              $window.location.href = '/web/totes/new-wireless-line/#/choose-phone';
            }
          });
        }else{
           checkForNACSavedCart(checkForNACSavedCartRequest);
         }
      });*/
      checkForNACSavedCart(checkForNACSavedCartRequest);
    };

    function checkForNACSavedCart(checkForNACSavedCartRequest){
      var nacOrder =  bfappcWirelessDashboardService.getFetchOrderFullResponse().nac;
      if(!_.isUndefined(nacOrder) && nacOrder.length){
        cartMenuService.fetchValidatedCart(checkForNACSavedCartRequest).then(function(cartResponse){
          if(cartResponse){
            if(cartResponse.errorCode == "50006"){//Main line invalid
              showNacInvalidCartPopup();
            }else if(cartResponse.errorCode == "50007"){//additional Line Invalid
              showNacInvalidCartPopup(cartResponse.errorCode);
            }else if(cartResponse.success && !!_.find(cartResponse.nac,{'orderId': checkForNACSavedCartRequest.orderId})){//cart valid
              //below line is to prevent resume flow block for individual line AAl
              ajax.nacSaveState({key: 'NEW_WRLS_INFO',clearSession:true,});//fire and forget

              ajax.nacSaveState({
                key: 'NEW_MULTI_WRLS_INFO',
                isDeeplink: false,
                isIndividual: false,
                clearSession:true,
                nacSessionList: []
              }).then(function(){
                $window.location.href = $scope.nacFlowResumeURL;
              }).catch(function(){
                $window.location.href = $scope.nacFlowResumeURL;
              });
            }else{
              showNacInvalidCartPopup();
            }
          }else{
            showNacInvalidCartPopup();
          }
        },function(){
          showNacInvalidCartPopup();
        })
      }else{
        showNacInvalidCartPopup();
      }
    }

    function showNacInvalidCartPopup(errorCode){
      var popupObj = {};
      $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
      $scope.showChatCallIcon = true;
      $scope.showButtons = true;
      $scope.nacSaveStateRequest = {
        key: 'NEW_MULTI_WRLS_INFO',
        isDeeplink: errorCode && errorCode == "5007" ? false : true,
        isIndividual: false,
        clearSession:true,
        nacSessionList: []
      };
      popupObj.preCloseCallback = function () {
        $scope.showChatCallIcon = false;
        $scope.showButtons = false;
        ajax.nacSaveState($scope.nacSaveStateRequest).then(function(){
           if($scope.nacSaveStateRequest.isDeeplink == true){
            $window.location.href = $scope.nacFlowURL;
           }else{
            $window.location.href = $scope.nacFlowResumeURL;
           }
        }).catch(function(){
          if($scope.nacSaveStateRequest.isDeeplink == true){
            $window.location.href = $scope.nacFlowURL;
          }else{
            $window.location.href = $scope.nacFlowResumeURL;
          }
        });
      };
      openGenericErrorPopup(popupObj);
    }

    function NFDBError(error) {
      notEligibleDeviceUpgrade();
   }
   function NFDBCheckResolve(data) {
      if (angular.isDefined(data) && data.isNFDBExistInd) {
       notEligibleDeviceUpgrade();
       return;
     }
     var request = {
       refresh: false,
       accountNumber: localStorage.getLocalStorageValue('accountNumber'),
       phoneNumber: localStorage.getLocalStorageValue('phoneNumber'),
       nfdbCaching: true,
       activityType: 'HUP'
     };
     ajax.checkHupEligibility(request).then(checkHupEligibilityResolve, checkHupEligibilityError);
   }

   function notEligibleDeviceUpgrade(errorCode) {
     $scope.hupDetails = {};
     $scope.hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
     if ($scope.isCare || $scope.isDealer) {
      $scope.hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message_care');
     }
     $scope.hupDetails.contactNumber = $translate.instant('toll-free-number');
     //$scope.upgradeDeviceObjloadingIndicator = false;
     $scope.clickedOrder = '';
     $scope.restoreCartloadingIndicator = false;
      if (errorCode && errorCode === 'HNA') {
       $scope.hupDetails.errorMessage = $translate.instant('hna_error_message');
       $scope.hupDetails.contactNumber = $translate.instant('hna_contact_number');
     }
     wirelessDashPopup.scope = $scope;
     ngDialog.open(wirelessDashPopup);
   }

   function checkHupEligibilityResolve(data) {
      if (data == null || data.isHupEligibilityError || (data.hupErrorCode && data.hupErrorCode === 'HNA')) {
       notEligibleDeviceUpgrade(data.hupErrorCode);
       return;
     }
     if ($scope.isHupFlowProcessSaved) {
       checkForSavedCart();
     } else {
       hupSaveState(function (data) {
         $window.location.href = '/web/totes/upgrade/#/choose-phone';
       });
     }
   }

   function checkHupEligibilityError(error) {
     notEligibleDeviceUpgrade();
   }

   function isCtnHasSavedCart() {
     var savedCartObj = bfappcWirelessDashboardService.getFetchOrderFullResponse().hup;
     var ctnHasSavedCart = false;
     if (savedCartObj && savedCartObj.length > 0) {
       angular.forEach(savedCartObj, function (value, index) {
         if (_.contains(value.assemblyIds, localStorage.getLocalStorageValue('phoneNumber'))) {
           ctnHasSavedCart = true;
         }
       });
     } else {
       ctnHasSavedCart = false;
     }
     return ctnHasSavedCart;
   }

   $scope.wirelessDashPopupclose = function () {
      ngDialog.close();
   };

   function checkForSavedCart() {
     var request = {
       'key': 'cartDetails',
       'context': {
         'ctn': localStorage.getLocalStorageValue('phoneNumber'),
         'ban': localStorage.getLocalStorageValue('accountNumber')
       }
     };
     var popupObj = {};
     ajax.hupGetState(request).then(function (data) {
       if (data && data.success && !data.errorMessage) {
         if ((data.phone && !data.phone.valid) || (data.plan && !data.plan.valid) || (data.addons && !data.addons.valid)) {
           popupObj = {};
           $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
           $scope.showChatCallIcon = true;
           $scope.showButtons = true;
           popupObj.preCloseCallback = function () {
             $scope.showChatCallIcon = false;
             $scope.showButtons = false;
             hupSaveState(function (data) {
               if (data.phone && data.phone.valid) {
                 $window.location.href = '/web/totes/upgrade/#/build-plan';
               } else {
                 $window.location.href = '/web/totes/upgrade/#/choose-phone';
               }
             });
           };
           openGenericErrorPopup(popupObj);
         } else if (data.phone && data.phone.valid) {
           hupSaveState(function () {
             $window.location.href = '/web/totes/upgrade/#/build-plan';
           });
         } else {
           hupSaveState(function () {
             $window.location.href = '/web/totes/upgrade/#/choose-phone';
           });
         }
       } else {
         popupObj = {};
         $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
         $scope.showChatCallIcon = true;
         $scope.showButtons = true;
         popupObj.preCloseCallback = function () {
           $scope.showChatCallIcon = false;
           $scope.showButtons = false;
           hupSaveState(function (data) {
             if (data.phone && data.phone.valid) {
               $window.location.href = '/web/totes/upgrade/#/build-plan';
             } else {
               $window.location.href = '/web/totes/upgrade/#/choose-phone';
             }
           });
         };
         openGenericErrorPopup(popupObj);
       }
     }, function (error) {
       showGenericErrorMessage(true);
     });
   }

   function openGenericErrorPopup(obj) {
     var genericErrorPopup = {
       template: (obj.template) ? obj.template : 'views/genericErrorPopup.html',
       scope: (obj.scope) ? obj.scope : $scope,
       className: (obj.className) ? obj.className : 'generic-error-theme ngdialog-theme-default',
       showClose: (obj.showClose) ? obj.showClose : true,
       appendTo: (obj.appendTo) ? obj.appendTo : 'div[ui-view]',
       closeByDocument: (obj.closeByDocument) ? obj.closeByDocument : false,
       preCloseCallback: (obj.preCloseCallback) ? obj.preCloseCallback : function () {

       }
     };
     $scope.restoreCartloadingIndicator = false;
     ngDialog.open(genericErrorPopup);
   }

   $scope.closeGenericErrorPopup = function() {
     ngDialog.close();
   }

   function showGenericErrorMessage(redirecToDeviceCatalog) {
     var popupObj = {};
     $scope.errorMessage = $translate.instant('generic_error_message');
     if (redirecToDeviceCatalog) {
       popupObj.preCloseCallback = function () {
         hupSaveState(function (data) {
           $window.location.href = '/web/totes/upgrade/#/choose-phone';
         });
       };
     }
     openGenericErrorPopup(popupObj);
   }
   function hupSaveState(successCallback, errorCallback) {
     var request = {
       'key': 'hupState',
       'context': {
         'ctn': localStorage.getLocalStorageValue('phoneNumber'),
         'ban': localStorage.getLocalStorageValue('accountNumber')
       }
     };
     ajax.hupSaveState(request).then(function (data) {
       if (successCallback) {
         successCallback(data);
       }
     }, function (error) {
       if (errorCallback) {
         errorCallback(error);
       } else if (successCallback) {
         successCallback(error);
       }
     });
   }

   $scope.deepLinkingModal = function (size) {
     var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
     ajax.getUserPreference(userId).then(
         function (data) {
             if (data && Object.keys(data).length > 0 && _.some(data.userPreference, {"name": "displayMovingToSSPPopUp"})) {
                var userPreferenceObject  = _.find(data.userPreference, function(obj) {
                         return obj.name === 'displayMovingToSSPPopUp';
                });
                if (!userPreferenceObject.value) {
                 backToSSPService.backToSSP();
                } else {
                 $scope.showDeepLinkPopUp(size);
                }
             } else {
             $scope.showDeepLinkPopUp(size);
           }
         }, function (error) {
           $scope.showDeepLinkPopUp(size);
         });
   };
   $scope.showDeepLinkPopUp = function (size) {
     $modal.open({
       templateUrl: 'views/modals/deepLinkModal.html',
       controller: 'deepLinkModalCtrl',
       controllerAs: 'vm',
       size: size,
       backdrop: false,
       resolve: {}
     });
   };
   $scope.openChangePlanModal = function (size) {
     $modal.open({
       templateUrl: 'views/modals/wirelessRemovePlan.html',
       controller: 'wirelessRemoveModalCtrl',
       size: size,
       backdrop: false,
       resolve: {}
     });
   };

   //filter orders based on the selected ctn
   $rootScope.$on('$stateChangeStart', function (evt, toState) {
      processJSON(); // to update deleted item in $scope.orders and $scope.quotes variable
      if (toState.name === 'wireless') {
        ctn = localStorage.getLocalStorageValue('phoneNumber');
        processJSONForSelectedCTN(ctn);
      }
   });

   function processJSONForSelectedCTN(selectedCtn){
      $scope.orders = _.filter($scope.orders,function(key,value){
          return _.indexOf(key.assemblyIds,selectedCtn) >= 0;
      });
      $scope.quotes = _.filter($scope.quotes,function(key,value){
          return _.indexOf(key.assemblyIds,selectedCtn) >= 0;
      });
      $scope.totalOrders = _.size($scope.orders) + _.size($scope.quotes);
   }

   $scope.cancelOrder = function(event, id) {
      event.stopPropagation();
      $scope.clickedOrder = id;
      var postData = {
        "currentOrderId": id
      };
      ajax.cancelOrder(postData).then(function() {
        $scope.ordersArray = _.filter($scope.ordersArray, function(value, key) {
            return value.orderId !== id;
        });
        $state.reload();
      });
   };

   init();
   processJSON();

    //n Remove any watchers
  $scope.$on('$destroy', function () {
    scopewatch1();
  });

 }
}());

'use strict';
 angular.module('totesApp').directive('repCartMenuOLD', repCartMenuOLD);
  repCartMenuOLD.$inject = [];
  function repCartMenuOLD() {
    return {
      scope: {
       'content' : '='
      },
      templateUrl: 'scripts/directives/cartMenu/repCartMenu.html',
      restrict: 'EA',
      controller: 'repCartMenuControllerOLD'
    };
  }

 //controller
 angular.module('totesApp').controller('repCartMenuControllerOLD', repCartMenuControllerOLD);
 repCartMenuControllerOLD.$inject = ['$q','$scope','cartMenuService','$location','$rootScope','localStorage','sessionStorage','$window','ute.capture.dealer.code.service','$modal','appState','bfappcWirelessDashboardService','ute.common.permissions.service', 'ajax', '$state', 'ute.blocks.persistent.storage.service', 'ute.dtm.service', 'ngDialog', '$translate'];

 function repCartMenuControllerOLD($q,$scope,cartMenuService,$location,$rootScope,localStorage,sessionStorage,$window,captureDealerCodeService,$modal,appState,bfappcWirelessDashboardService,permissionsService, ajax, $state, utePersistentStorageService, dtmService, ngDialog, $translate) {

   $scope.orders = [];
   $scope.quotes = [];
   var ctn = '';
   var ban = '';
   var accountTypeNo = '';
   $scope.hasDCAccess = false;
   $scope.clickedOrder = '';
   $scope.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;

   if ($rootScope.isCare) {
       ban = sessionStorage.getSessionStorageValue('accountNumber');
   } else {
       ctn = localStorage.getLocalStorageValue('phoneNumber');
       ban = localStorage.getLocalStorageValue('accountNumber');
   }

   if ($rootScope.isCare) {
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
        if (isPermitted) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
            .then(function (agentPermission) {
              $scope.hasDCAccess = agentPermission;
            });
        }
      });
   }
   function processJSON(){
     $scope.ordersArray = _.flattenDeep( _.filter($scope.content,function(key,value){return  value=='ppc' || value=='hup' || value=='nac'}));
     $scope.totalOrders = _.size($scope.ordersArray);
     $scope.orders = _.filter($scope.ordersArray,function(key,value){
        return !key.quotation;
     });
     $scope.quotes = _.filter($scope.ordersArray,function(key,value){
        return key.quotation==true;
     });
   }

   $scope.validatedRedirect = function (activityType, orderId, orderType, contactNo, order) {
     if ($rootScope.isCare) {
       sessionStorage.setSessionStorageValue('phoneNumber', contactNo);
       ctn = sessionStorage.getSessionStorageValue('phoneNumber');
       accountTypeNo = sessionStorage.getSessionStorageValue('accountTypeNumber');
     }
     else {
       localStorage.setLocalStorageValue('phoneNumber', contactNo);
       ctn = localStorage.getLocalStorageValue('phoneNumber');
       accountTypeNo = localStorage.getLocalStorageValue('accountTypeNumber');
     }
      utePersistentStorageService.putToSession('order', order ); // BCR-693 Analytics: Send the order data to analytics mainly who saved the quote/order(orderSavedByAgent) like cx or rep
     var saveStatePassJSON = {
       'ctn': ctn,
       'activityTypeKey': activityType,
       'accountTypeNumber': accountTypeNo
     };
     var fetchValidatedCartPassJSON = {
       'ban': ban,
       'ctn': ctn,
       'orderId': orderId,
       'activityTypeKey': activityType
     };
      var NFDBrequest = {
       'refresh': false,
       'accountNumber': ban,
       'phoneNumber': ctn,
       'nfdbCaching': true,
       'activityType': activityType
       };
     if (orderType == 'order') {
       saveStatePassJSON['ban'] = ban;
     }
     $scope.clickedOrder = orderId;
     if (orderType == 'order' && activityType == 'HUP') {
       cartMenuService.saveState(saveStatePassJSON).then(
       function (response) {
         if (response && response.success) {
           cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
             function (res) {
               if (res && res.success) {
                    var hupOrder = res.hup;
                        var currentHupOrder = getCurrentHupOrder(hupOrder, orderId);
                        var isDeviceValid = true;
                        var isPlanValid = true;
                        var isAddOnValid = true;
                        _.forEach(currentHupOrder[0].cartItems, function (item) {
                          if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && !item.valid){
                          isDeviceValid=false;
                          }
                          if(item.activityType == 'HUP' && item.itemType == 'planCommerceItem' && !item.valid){
                            isPlanValid=false;
                          }
                          if(item.activityType == 'HUP' && item.itemType == 'addonCommerceItem' && !item.valid){
                            isAddOnValid=false;
                          }
                        });
                        if(!isDeviceValid || !isPlanValid || !isAddOnValid){
                          if(!isPlanValid || !isAddOnValid){
                             var popupObj = {};
                             var saveRequest = {
                              'orderSavedStep' : ''
                             };
                             ajax.saveOrder(saveRequest);
                           }
                           popupObj.preCloseCallback = function () {
                             $scope.showChatCallIcon = false;
                             $scope.showButtons = false;
                             if(!isDeviceValid){
                               $window.location.href = '/web/totes/upgrade/#/choose-phone';
                             }
                             else{
                              $window.location.href = '/web/totes/upgrade/#/build-plan';
                             }
                           };
                           $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                           $scope.showChatCallIcon = true;
                           $scope.showButtons = true;
                           openGenericErrorPopup(popupObj);
                        }
               else{
                ajax.isNFDBCheck(NFDBrequest).then(
                  function(nres){
                  if(!nres.isNFDBExistInd){
                 cartMenuService.validateOrder().then(
                   function (vres) {
                     if (vres && vres.success) {
                       $scope.clickedOrder = '';
                       if (activityType.toLowerCase() == 'ppc') {
                         $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                       }
                       else if (activityType.toLowerCase() == 'hup') {
                         $window.location.href = '/web/totes/upgrade/#/checkout/review';
                       }
                     } else {
                       var popupObj = {};
                       $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                       $scope.showChatCallIcon = true;
                       $scope.showButtons = true;
                       openGenericErrorPopup(popupObj);
                     }
                   },
                   function (verr) {
                      var popupObj = {};
                      $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                      $scope.showChatCallIcon = true;
                      $scope.showButtons = true;
                      openGenericErrorPopup(popupObj);
                   }

                 );
                 }
                 else{
                  dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                  notEligibleDeviceUpgrade('NFDB');
                 }
                 },
                 function (nerr){
                  dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                  notEligibleDeviceUpgrade('NFDB');
                 }
                 );
               }
             } else {
                  popupObj = {};
                  var hupOrder = res.hup;
                  var currentHupOrder = getCurrentHupOrder(hupOrder,orderId);
                  var isDeviceValid = false;
                  _.forEach(currentHupOrder[0].cartItems, function (item) {
                    if(item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && item.valid){
                      isDeviceValid=true;
                    }
                  });
                  popupObj.preCloseCallback = function () {
                    $scope.showChatCallIcon = false;
                    $scope.showButtons = false;
                    if(!isDeviceValid){
                      $window.location.href = '/web/totes/upgrade/#/choose-phone';
                    }
                    else{
                      $window.location.href = '/web/totes/upgrade/#/build-plan';
                    }
                  };
                  $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                  $scope.showChatCallIcon = true;
                  $scope.showButtons = true;
                  openGenericErrorPopup(popupObj);
                }
             },
             function (err) {
                 var popupObj = {};
                 $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                 $scope.showChatCallIcon = true;
                 $scope.showButtons = true;
                 openGenericErrorPopup(popupObj);
             }
           );
         }
         else {
          var popupObj = {};
          $scope.errorMessage = $translate.instant('generic_error_message');
          $scope.showChatCallIcon = true;
          $scope.showButtons = true;
          openGenericErrorPopup(popupObj);
         }
       },
       function (error) {
          var popupObj = {};
          $scope.errorMessage = $translate.instant('generic_error_message');
          $scope.showChatCallIcon = true;
          $scope.showButtons = true;
          openGenericErrorPopup(popupObj);
       }

     );
     }else{
     cartMenuService.saveState(saveStatePassJSON).then(
       function (response) {
         if (response && response.success) {
           cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
             function (res) {
               if (res && res.success) {
                 cartMenuService.validateOrder().then(
                   function (vres) {
                     if (vres && vres.success) {
                       $scope.clickedOrder = '';
                       if (activityType.toLowerCase() == 'ppc') {
                         $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                       }
                       else if (activityType.toLowerCase() == 'hup') {
                         $window.location.href = '/web/totes/upgrade/#/checkout/review';
                       }
                     } else {
                      //error in validate Order
                     }
                   },
                   function (verr) {
                     //error in validate Order
                   }
                 );
               } else {
                 //error in fetchValidatedCart
               }
             },
             function (err) {
               //error in fetchValidatedCart
             }
           );
         }
         else {
           //error in saveState
         }
       },
       function (error) {
         //error in saveState
       }

     );
    }
   }
   function getCurrentHupOrder (hupOrders,currentOrderID){
    if(hupOrders.length > 0){
      return _.filter(hupOrders, function (order) {
       return order.orderId === currentOrderID;
      });
    }
   }

  function openGenericErrorPopup(obj) {
     var genericErrorPopup = {
       template: (obj.template) ? obj.template : 'views/genericErrorPopup.html',
       scope: (obj.scope) ? obj.scope : $scope,
       className: (obj.className) ? obj.className : 'generic-error-theme ngdialog-theme-default',
       showClose: (obj.showClose) ? obj.showClose : true,
       appendTo: (obj.appendTo) ? obj.appendTo : 'div[ui-view]',
       closeByDocument: (obj.closeByDocument) ? obj.closeByDocument : false,
       preCloseCallback: (obj.preCloseCallback) ? obj.preCloseCallback : function () {

       }
     };
     $scope.restoreCartloadingIndicator = false;
     ngDialog.open(genericErrorPopup);
   };

   $scope.closeGenericErrorPopup = function() {
        ngDialog.close();
   }
   //on click of any quote or order
   $scope.redirectToPage = function (activityType, orderId, orderType, contactNo, order) {

     var deferred = $q.defer();

     cartMenuService.agentInfo().then(
       function (response) {
         if (response.dealerCode != "" || (!$scope.hasDCAccess && $rootScope.isCare)) {
           $scope.validatedRedirect(activityType, orderId, orderType, contactNo, order);
         } else {
           captureDealerCodeService.showProceedWithoutDealerCodeModal().then (
              function(result) {
                 if(result !== false) {
                   $scope.validatedRedirect(activityType, orderId, orderType, contactNo, order);
                 } else {
                   $scope.changeBtnLoading(false);
                 }
              }, function(error) {
                 $scope.changeBtnLoading(false);
           });
         }
       },
       function (error) {
         deferred.reject(error);
       });
   }

   $scope.cancelOrder = function(event, id) {
      event.stopPropagation();
      $scope.clickedOrder = id;
      var postData = {
        "currentOrderId": id
      };
      ajax.cancelOrder(postData).then(function() {
        $scope.orders = _.filter($scope.orders, function(value, key) {
            return value.orderId !== id;
        });
        $scope.quotes = _.filter($scope.quotes, function(value, key) {
            return value.orderId !== id;
        });
        $scope.totalOrders = _.size($scope.orders) + _.size($scope.quotes);
        $state.reload();
      });
   };

   processJSON();
 }

'use strict';

/*Directive to implement Owl carousel


 How to implement?
 Example:
<div>
 // Wrap all the items of carousel inside this directive data-owl-carousel
<div owl-carousel-item="" ng-repeat="item in items" class="item">...</div> // Iterating through the items using ng-repeat <div>.....</div>                                                // content(items inside carousel) which is repeated goes into this div

</div>

*/

angular.module('totesApp')
  .directive('customOwlCarouselItem', [function() {
    return {
      restrict: 'EA',
      transclude:false,
      link: function(scope, element) {
        scope.initCarousel = function(element) {
          // provide any default options you want
          var defaultOptions = {
            items:3,
            itemsDesktop:[1199,3],
            itemsDesktopSmall:[979,3],
            itemsTablet:[768,1],
            itemsMobile:[767,1],
            navigation: true,
            pagination: false,
            dots:false,
            rewindNav : false,
            responsive:true,
            navigationText:["<",">"]
          };
          var customOptions = scope.$eval($(element).attr('data-options'));
          // combine the two options objects
          for(var key in customOptions) {
            defaultOptions[key] = customOptions[key];
          }
          scope.sliderInstance = $(element).owlCarousel(defaultOptions);
        };
        if(scope.$last) {
          if($(element).parent().data('owlCarousel'))
            $(element).parent().data('owlCarousel').destroy();
          var carouselTimeout = setTimeout(function(){
            scope.initCarousel(element.parent());
            clearTimeout(carouselTimeout);
          },10);
        }
      }
    };
  }]);

'use strict';

angular.module('totesApp')
  .factory('confirmationDialog',['$rootScope', '$translate', function ($rootScope, $translate) {

    var confirmationDialog = {

      dialogObj: {
        show: false,//switch to open the dialog
        title: null,//dialog title resource key
        message: null,//dialog content resource key
        icon: null,
        iconBody: null,
        onClose: null, //action upon closing the dialog
        buttons: null
        /*
         //buttons is the collection of the buttons on the bottom of the confirmation dialog
         //example:
         buttons:[
         {label: '_cancel', //text on the button
         type:'label', //Totes button type: primary, secondary, tertiary  or label
         action: cancel // the call back of this button, defined the caller scope
         },
         {label: '_continue',
         type:'primary',
         action: callServer}
         ]
         */
      },
      alert: function (info, showIcon) {
        var _info = $translate.instant(info);

        confirmationDialog.open({
          title: '',
          message: _info,
          onClose: null,
          icon: 'alert',
          buttons: [
            {label: 'wireless_close', type: 'primary', action: function(){
              //confirmationDialog.open(null);
            }}
          ]
        });
      },

      close: function () {
        /*      if (confirmationDialog.dialogObj.show) {
         confirmationDialog.open(null);
         } else {
         confirmationDialog.open(null);
         }*/
        confirmationDialog.open(null);
      },

      open: function (options) {
        //reset the dialog object if null
        //else set the buttons
        if (!options) {
          confirmationDialog.dialogObj.title = null;
          confirmationDialog.dialogObj.icon = null;
          confirmationDialog.dialogObj.iconBody= null;
          confirmationDialog.dialogObj.message = null;
          confirmationDialog.dialogObj.buttons = null;
          confirmationDialog.dialogObj.show = false;
          if (confirmationDialog.dialogObj.onClose) {
            confirmationDialog.dialogObj.onClose();
          }
          confirmationDialog.dialogObj.onClose = null;
          return;
        }
        confirmationDialog.dialogObj.show = true;
        confirmationDialog.dialogObj.onClose = options.onClose;
        confirmationDialog.dialogObj.title = options.title;
        confirmationDialog.dialogObj.icon = options.icon;
        confirmationDialog.dialogObj.iconBody = options.iconBody;
        confirmationDialog.dialogObj.message = options.message;
        confirmationDialog.dialogObj.buttons = [];
        for (var i = 0, l = options.buttons.length; i < l; i++) {
          confirmationDialog.dialogObj.buttons.push({
            label: options.buttons[i].label,
            type: options.buttons[i].type,
            action: options.buttons[i].action
          });
        }

        confirmationDialog.dialogObj.liveChatOptions = options.liveChatOptions;
      }
    };

    $rootScope.$on('$stateChangeStart', function () {
      //clear any dialog upon route changes
      confirmationDialog.close();
    });

    return confirmationDialog;
  }])
  .directive('confirmDialog', ['confirmationDialog', function (confirmationDialog) {
    return {
      scope: {},

      replace: true,

      templateUrl: 'scripts/directives/confirmDialog/confirmDialog.html',

      restrict: 'E',

      link: function (scope, $elem, attr) {

        scope.dialog= confirmationDialog.dialogObj;

        function closeDialog() {
          confirmationDialog.open(null);
          scope.$apply();
        }

        $elem.delegate('.close-dialog ', 'click', closeDialog);
        //$elem.find('.close-dialog').bind('click', closeDialog);
      }
    };

  }]);

'use strict';
/**
 * @ngdoc Directive
 * @name PopoverWith close button
 * @description
 * # A directive to show popover (ie) to displaydescription for a particular section.

 *  Usage 1:Show only text in popover
    <parent-element class="popoverParent">
        <element class="new-info-icon" custom-popover data-popover-content="sometext to be shown in popover" data-popover-placement="right">Element Text</element>
    </parent-element>

 * Usage 2: show an HTML template in Popover
   <parent-element class="popoverParent">
      <element custom-popover data-popover-content="html" data-popover-placement="right">Element Text</element>
      <element class="popoverHTMLContent">
          <p ng-show="userLanguage=='EN'">line1</p>
          <p ng-if="userLanguage=='EN'">line2</p>
          <p ng-if="userLanguage=='FR'">line3</p>
      </element>
   </parent-element>


   Attribute Description

     -->'data-popover-content': if text or scope oblect will show the same in popover
                              OR
                              IF  value is "html" (ie:data-popover-content='html')
                              then it will check for sibling with class popoverHTMLContent and display the content present in the same element
    -->'data-popover-placement': where to place the popover(ie:left, right, top, bottom)

 */
angular.module('totesApp')
  .directive('customPopover', customPopover);
customPopover.$inject=['resource', 'userLanguage','$rootScope'];
function customPopover(resource, userLanguage,$rootScope) {
  var varDirective = {
    restrict: 'A',
    scope:{
        popoverContent:'@',
        popoverPlacement:'@'
        },
    link: function (scope, element, attributes) {
        var popoverHTMLContent;
        function init(){

              $(element).off().on("click keydown", function(e){
                if(e.which === 1 || e.which === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    if(scope.popoverContent.toUpperCase()=='HTML') {
                        initializepopover($(element).parent().find(".popoverHTMLContent").html(),scope.popoverPlacement);
                    } else {
                        initializepopover(scope.popoverContent,scope.popoverPlacement);
                    }
                  }
                 });
        }
        function initializepopover(content, position){
            if(!ispopoverOpenForSameElement()){
                $(element).popover({
                    trigger: 'manual',
                    html: true,
                    template:'<div class="custom-popover customPopoverBGBlue" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="closeCustomPopover">X</div><div class="popover-content"></div></div>',
                    content: content,
                    placement: position
                });
                showCustomPopover();
            }else{
                hideCustomPopover();
            }
        }
        function ispopoverOpenForSameElement(){
            return $("body").find("#"+$(element).attr("aria-describedby")).length;
        }
        function showCustomPopover(){
            if(!_.isEmpty($rootScope.activeCustomPopover))
                $rootScope.activeCustomPopover.popover("hide");
            $rootScope.activeCustomPopover=$(element);
            $(element).popover('show');
        }
        function hideCustomPopover(){
            $rootScope.activeCustomPopover={};
            $(element).popover('hide');
        }
        $(element).parent().on("click",".closeCustomPopover",function(e){
            e.preventDefault();
            e.stopPropagation();
            hideCustomPopover();
        });
        setTimeout(function() {init();},100);
        resource.onChanged(function() {
           setTimeout(function() {
               $(element).popover('destroy');
               init();
           },100);
        }, scope);
    }

  };
  return varDirective;
}

/*
	DTM FORM FIELD
*/
'use strict';

angular
		.module('totesApp')
		.directive('dtmErrorFormField', function ()
{
	return {
		restrict: 'E',
		// templateUrl : 'scripts/directives/directive/directive.html' ,
		scope: {Service: '=service', key: '=key', errorPrefix: '@errorPrefix'},
		link : function( $scope , $element , attrs )
		{
      if ( $scope.Service && $scope.key && $scope.errorPrefix) {
        $scope.Service.exceptionFormFieldWithPrefix($scope.key, $element, $scope.errorPrefix);
      }
      else if ($scope.Service && $scope.key)
      {
        $scope.Service.exceptionFormField($scope.key, $element);
      }      
		} ,
		controller : function ( $scope )
		{
			return this ;
		}

	} ;

}) ;





(function (_) {
  'use strict';

  angular.module('selfServe').controller('editableContentController',
    ['$scope',
      '$rootScope',
      '$modal',
      '$translate',
      'ute.blocks.language.switcher',
      'localStorage',
      'omni',
      'selfServeSvc',
      '$q',
      'sessionStorage',
      'profileEditService',
      'ute.common.permissions.service',
      function ($scope,
                $rootScope,
                $modal,
                $translate,
                languageSwitcher,
                localStorage,
                omni,
                selfServeSvc,
                $q,
                sessionStorage,
                profileEditService,
                permissionsService) {
        $scope.currentPanelOpen = false;
        $scope.nonEditableData = $scope.formdata;
        $scope.editableData = $.extend(true, {}, $scope.formdata);
        $scope.isProfileLoading = false;
        $scope.isConsumer = $rootScope.isConsumer;
        $scope.isCare = $rootScope.isCare;
        $scope.isDealer = $rootScope.isDealer;
        $scope.repProfileUpdate = true;

        if ($scope.isDealer || $scope.isCare) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.update).then(function (agentPermission) {
            $scope.repProfileUpdate = agentPermission;
          });
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ProfileBillingType, ute.common.permissions.service.RamActionCodes.update).then(function (agentPermission) {
            $scope.repUpdateBillingType = agentPermission;
          });
        } else {
          $scope.repUpdateBillingType = false;
        }

        $scope.isBillingTypeDefined = function () {
          return $scope.nonEditableData.paper !== undefined && $scope.nonEditableData.ebill !== undefined;
        };

        $scope.checkIfPreviousEmail = function () {
          $scope.isNotPreviousEmail = ($scope.editableData.email !== $scope.nonEditableData.email);
        };

        $scope.checkIfPreviousBillingType = function () {
          $scope.isNotPreviousBillingType = ($scope.editableData.billingType !== $scope.nonEditableData.billingType);
        };

        $scope.checkIfPreviousContactInfo = function () {
          if ($scope.editableData.contactNumber1 !== $scope.nonEditableData.contactNumber1) {
            $scope.isNotPreviousContactInfo = true;
          } else if ($scope.editableData.contactNumber2 !== $scope.nonEditableData.contactNumber2) {
            $scope.isNotPreviousContactInfo = true;
          } else if ($scope.editableData.extension !== $scope.nonEditableData.extension) {
            $scope.isNotPreviousContactInfo = true;
          } else if ($scope.editableData.language !== $scope.nonEditableData.language) {
            $scope.isNotPreviousContactInfo = true;
          } else {
            $scope.isNotPreviousContactInfo = false;
          }
        };

        $scope.checkIfPreviousAddress = function () {
          if ($scope.editableData.Street_number !== $scope.nonEditableData.Street_number) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.Street_name !== $scope.nonEditableData.Street_name) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.Street_type !== $scope.nonEditableData.Street_type) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.AptNo !== $scope.nonEditableData.AptNo) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.AptType !== $scope.nonEditableData.AptType) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.city !== $scope.nonEditableData.city) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.province !== $scope.nonEditableData.province) {
            $scope.isNotPreviousAddress = true;
          } else if ($scope.editableData.postalCode !== $scope.nonEditableData.postalCode) {
            $scope.isNotPreviousAddress = true;
          } else {
            $scope.isNotPreviousAddress = false;
          }
        };

        $scope.isReadOnly = function () {
          return !!(angular.isDefined($scope.readonly) && $scope.readonly);

        };
        if ($scope.loadLoginSecurityQuestions) {
          $scope.loginSecurityQuestions = selfServeSvc.getLoginSecurityQuestions();
        }
        var accountTypeNumber = localStorage.getLocalStorageValue('accountTypeNumber');
        if ($rootScope.isCare) {
          accountTypeNumber = sessionStorage.getSessionStorageValue('accountTypeNumber');
        }

        $scope.cableCustomer = accountTypeNumber == 6;

        $scope.language = languageSwitcher.getCurrentLanguage();

        /**
         * Set default edit panel status to false when the page is loading
         */
        profileEditService.setEditPanelStatus(false);

        $rootScope.$on('startLoading', function () {
          $scope.loading = true;
        });

        $rootScope.$on('stopLoading', function () {
          $scope.loading = false;
        });
        $scope.productCategories = [
          {id: 'WIRELESS', resource: 'wireless'},
          {id: 'CABLE', resource: 'tv'},
          {id: 'INTERNET', resource: '_internet'},
          {id: 'HOME PHONE', resource: 'rogers_home_phone'}];
        $scope.marketingChannels = [
          {id: 'EMAIL', resource: '_email'},
          {id: 'DIRECT MAIL', resource: 'direct_mail'},
          {id: 'TELE-MARKETING', resource: 'telemarketing'},
          {id: 'TEXT MESSAGING', resource: 'text_message'}];
        $scope.getResource = function (key) {
          return $translate.instant(key);
        };
        $scope.getYesNo = function (boolean) {
          if (boolean == void 0) {
            return '';
          }
          return $translate.instant(boolean ? 'yes' : 'no');
        };
        var scopewatch1 = $scope.$watch('formdata', function (newValue) {
          console.log('BillTypeChange inside formdata watch');
          if(newValue && newValue.contactNumber1) {
            newValue.contactNumber1 = newValue.contactNumber1.replace(/\*/g, '•');
          }
          $scope.nonEditableData = newValue;
          $scope.editableData = $.extend(true, {}, newValue);
          if ($scope.formdata && $scope.formdata.defer) {
            $scope.formdata.defer.promise.then(function () {
              $scope.loading = false;
              // reset password fields
              $scope.editableData.confirmPassword = '';
              $scope.editableData.newPassword = '';
              $scope.editableData.oldPassword = '';

            });
          }

          if ($scope.formdata && $scope.formdata.failure) {
            $scope.formdata.failure.promise.then(function () {
              $scope.generalError = true;
              $scope.loading = false; // we don't want to show the loading sign
            });
          }

          //omniture taggings
          var _pageName = '', _options = [];
          switch ($scope.formdata) {
            case 'userInfo':
              _pageName = 'home:MyRogers:change-password';
              _options.push({eVar13: 'MyRogers - change password'});
              _options.push({event5: ''});
              break;
            case 'BillingAddress':
              _pageName = 'home:MyRogers:change-billing address';
              _options.push({eVar13: 'MyRogers - change billing address'});
              _options.push({event5: ''});
              break;
            case 'ContactInformation':
              _pageName = 'home:MyRogers:change-contact information';
              _options.push({eVar13: 'MyRogers - change contact information'});
              _options.push({event5: ''});
              break;
            case 'MarketingPermissions':
              _pageName = 'home:MyRogers:Change-Marketing Permission Information';
              _options.push({eVar13: 'MyRogers - change marketing permission information'});
              _options.push({event5: ''});
              break;
            default:
              break;
          }
          omni.tagPage(_pageName, _options);

          // disable the edit buttons for oneview

          $scope.isGuidNotFound = $rootScope.isGuidNotFound;
          if (($rootScope.isCare || $rootScope.isDealer) && $scope.formdata && $scope.formdata.errorCode != undefined && $scope.formdata.errorCode === 60001) {
            $scope.isGuidNotFound = true;
            $rootScope.isGuidNotFound = true;
            $scope.isProfileLoading = true;
          } else {
            $scope.isProfileLoading = true;
          }
          //$scope.isGuidNotFound=$rootScope.isGuidNotFound;
        }, true);
        var rootwatch1 = $rootScope.$watch('isGuidNotFound', function () {
          $scope.isGuidNotFound = $rootScope.isGuidNotFound;
        });
        $scope.isGuidNotFound = $rootScope.isGuidNotFound;
        $scope.heading = $translate.instant($scope.formheading);
        var scopewatch2 = $scope.$watch('generalError', function () {
          $scope.isProfileLoading = $scope.generalError != undefined;
        });
        $scope.isRepView = $rootScope.isRepView === 'true';
        var rootwatch2 = $rootScope.$watch('isRepView', function () {
          $scope.isRepView = $rootScope.isRepView === 'true';
        });

        $rootScope.$on('languageChanged', function () {
          $scope.heading = $translate.instant($scope.formheading);
          if ($scope.loadLoginSecurityQuestions) {
            $scope.loginSecurityQuestions = selfServeSvc.getLoginSecurityQuestions();
            var translatedCurrentSelectedQuestion = $scope.loginSecurityQuestions.filter(function (q) {
              return q.value == $scope.editableData.questionNo;
            })[0];
            $scope.selectedSecurityQuestion = translatedCurrentSelectedQuestion;
            $scope.$root.$broadcast('loginSecurityQuestionsChanged', translatedCurrentSelectedQuestion);
          }
        });

        $scope.openPaperBillingModal = function (ab) {
          $modal.open({
            templateUrl: 'views/modals/paper-billing-modal.html',
            windowClass: 'verify-address-modal',
            controller: ['$scope', function ($scope) {
              $scope.closeModal = function () {
                this.$close();
              };
            }]
          });
        };

        $scope.clearFieldInObject = function (field, obj) {
          for (var i in obj) {
            if (obj[i].Permissions) {
              obj[i].Permissions[field] = false;
            }
          }
        };

        $scope.copySelections = function (selection) {
        };

        $scope.clearSelections = function (section) {
          if (section === 'wireless') {
            $scope.clearFieldInObject('wireless', $scope.editableData);
          } else if (section === 'cable') {
            $scope.clearFieldInObject('cable', $scope.editableData);
          } else if (section === 'internet') {
            $scope.clearFieldInObject('internet', $scope.editableData);
          } else if (section === 'homephone') {
            $scope.clearFieldInObject('homephone', $scope.editableData);
          } else if (section === 'homemonitoring') {
            $scope.clearFieldInObject('homemonitoring', $scope.editableData);
          }
        };
        var scopewatch3 =  $scope.$watch('editableData', function (newValue) {
          $scope.maybeSelectedSecurityQuestion(newValue);
        });
        $scope.maybeSelectedSecurityQuestion = function (editableData) {
          if (!$.isEmptyObject(editableData) && editableData.questionNo && $scope.loginSecurityQuestions.length) {
            $scope.selectedSecurityQuestion = $scope.selectedSecurityQuestion || $scope.loginSecurityQuestions.filter(function (q) {
                return q.value == $scope.editableData.questionNo;
              })[0];
            //console.log('assign selectedSecQuestion');
          }
        };
        $scope.selectSecurityQuestion = function (question) {
          $scope.editableData.answer = '';
          $scope.editableData.questionNo = question.value;
          $scope.editableData.secretQuestion = question.label;
          $scope.selectedSecurityQuestion = question;
        };

        /*      $scope.$on('formLocator', function(event) {
         $scope.myDeeplyNestedForm = event.targetScope.form;
         }); */

        if ($scope.closeonresize === 'true') {
          $rootScope.$on('closeonresize', function () {
            $scope.cancel(true);
          });
        }
        $scope.openResetPasswordModal = function () {
          $rootScope.modal = $modal.open({
            templateUrl: 'views/modals/resetPasswordModal.html',
            controller: 'resetPasswordModalCtrl',
            backdrop: false,
            resolve: {}
          });
          $rootScope.modal.result.then(function () {

          }, function () {
            // on Cancel behaviour
          });
        };
        $scope.isNumericOnly = function (password) {
          return (/^[0-9]+$/g).test(password);
        };
        $scope.isAlphabetOnly = function (password) {
          return (/^[a-zA-Z]+$/g).test(password);
        };
        $scope.isAlphanumeric = function (password) {
          return (/^[a-zA-Z0-9]+$/g).test(password);
        };

        //n Remove any watchers
        $scope.$on('$destroy', function () {
          rootwatch1();
          rootwatch2();
          scopewatch1();
          scopewatch2();
          scopewatch3();
        });

      }])
    .directive('editableContent', editableContent);
    editableContent.$inject = [
      '$q',
      '$compile',
      '$modal',
      '$location',
      '$state',
      'omni',
      'profileEditService',
      'appState',
      '$log',
      '$rootScope',
      'ute.goPaperless.service',
      'ute.common.user.service',
      '$timeout'];

      /* @ngInject */
    function editableContent(
      $q,
      $compile,
      $modal,
      $location,
      $state,
      omni,
      profileEditService,
      appState,
      $log,
      $rootScope,
      goPaperlessService,
      userService,
      $timeout) {
      return {
        restrict: 'E',
        controller: 'editableContentController',
        transclude: true,
        scope: {
          marketingpermissions: '@',
          editabletemplateurl: '@',
          formtemplate: '@',
          formdata: '=',
          formheading: '@',
          onSubmit: '&',
          onBillingtypeupdate: '&',
          onPostBillingtypeupdate: '&',
          onEmailupdate: '&',
          controller: '&',
          skin: '@',
          whiteout: '@',
          closeonresize: '@',
          billingupdate: '@',
          loadLoginSecurityQuestions: '@',
          emailupdate: '@',
          readonly: '=?',
          editenable: '='
        },
        templateUrl: 'views/editable-content-template.html',
        link: function (scope, element, attrs) {

          var changeBillingInfo1;
          var changeBillingInfo2;

          // keep the element in closure so other functions can access it
          // as angular loses the element attribute when scope methods are hit
          // from the template. This is probably a bug in angular.
          var _element = element;
          scope.isEditOpen = function () {
            //scope.isGuidNotFound = $rootScope.isGuidNotFound;
            return profileEditService.getEditPanelStatus();
          };
          var rootwatch3 = $rootScope.$watch('isGuidNotFound', function () {
            scope.isGuidNotFound = $rootScope.isGuidNotFound;
          });
          scope.whiteoutEnabled = scope.whiteout === 'true';
          //scope.isGuidNotFound = $rootScope.isGuidNotFound;
          // if assigned a controller instantiate instantiate it with the view
          scope.controller({scope: scope});

          // initially show the NON EDITABLE TEMPLATE
          scope.loading = true;
          if (scope.loading === false && scope.generalError === false) {
            scope.contentUrl = attrs.editabletemplateurl;
          }

          var scopewatch4 = scope.$watch('loading', function (newValue) {
            if (newValue === false) {
              if (!scope.contentUrl && !scope.generalError) {
                scope.contentUrl = attrs.editabletemplateurl;
              }
            }
          });

          if (attrs.formdata === 'userInfo') {
            scope.isProfileSection = true;
          }

          //
          // This function switches the view by setting the content url
          // with a given template url. This template is passed through the attributes
          //
          scope.swapView = function (viewName) {
            scope.contentUrl = viewName;
            scope.tagViewLoading(viewName);
          };

          scope.tagViewLoading = function (viewName) {
            var tagOpts;
            switch (viewName) {
              case (viewName.match(/usernameandpasswordform/) || {}).input:
                tagOpts = ['_trackPageView', {pn: 'home:MyRogers:change-password'}, {eVar13: 'MyRogers_change password'}, {event5: ''}];
                break;
              case (viewName.match(/billinginformationform/) || {}).input:
                tagOpts = ['_trackPageView', {pn: 'home:MyRogers:change-billing'}, {eVar14: 'MyRogers_view_change_billing'}, {event5: ''}];
                break;
              case (viewName.match(/contactinformationform/) || {}).input:
                tagOpts = ['_trackPageView', {pn: 'home:MyRogers:change-contact information'}, {eVar14: 'MyRogers_View_change_contactinformation'}, {event5: ''}];
                break;
              case (viewName.match(/marketinginformationform/) || {}).input:
                tagOpts = ['_trackPageView', {pn: 'home:MyRogers:change-marketing permissions'}, {eVar14: 'MyRogers_Profile_Account_change_marketingperm’'}, {event5: ''}];
                break;
              default:
                // console.log('Didn\'t match');
                break;
            }

            try {
              appState.tagging(tagOpts);
            } catch (e) {
              $log.error('Exception catch during tagging on tagViewLoading with message:', e.message);
            }
          };

          //
          // This function sets up the directive to be in the editable mode.
          // The view is swapped to the form and the state is set to isEditOpen = true
          //
          scope.edit = function () {
            // only open if no other directives are open
            // horrible hack for marketing permissions that needs to be changed
            //            scope.myDeeplyNestedForm.horribleHackToHideError = true;
            scope.isGuidNotFound = $rootScope.isGuidNotFound;
            scope.maybeSelectedSecurityQuestion(scope.editableData);
            var domain = $location.protocol() + '://' + $location.host() + ':' + $location.port();
            var url = domain + '/web/RogersServices.portal?_nfpb=true&_pageLabel=Marketing_Permissions';

            if (attrs.marketingpermissions === 'true') {
              window.location = url;
              return;
            }

            //if (isMarketingPermissions) {
            //  $location.redirect('<Domain>/web/RogersServices.portal?_nfpb=true&_pageLabel=Marketing_Permissions');
            //}

            scope.swapView(attrs.formtemplate);
            scope.currentPanelOpen = true;
            profileEditService.setEditPanelStatus(true);
            scope.loading = false;
            if (scope.whiteoutEnabled) {
              //$(element).siblings().toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');

              //$(element).toggleClass('white-out');
              //$(element).siblings().children().toggleClass('white-out');
            }
          };

          scope.scrollToTop = function (element) {
            var scrollTimeout = setTimeout(function () {
              var scrollby = $(element).offset().top - 200;

              $('html, body').animate({
                scrollTop: scrollby
              }, 400);
              clearTimeout(scrollTimeout);
            }, 300);
          };


          //
          // This function restores the directive to the non editable state.
          // It also discards changes made to the form
          //
          scope.cancel = function (force) {
            // we switch back to the non editable form
            scope.swapView(attrs.editabletemplateurl);
            scope.currentPanelOpen = false;
            profileEditService.setEditPanelStatus(false);
            if (scope.whiteoutEnabled) {
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');
            }
            // discard changes
            scope.editableData = $.extend(true, {}, scope.formdata);

            /*            if (scope.myDeeplyNestedForm) {
             scope.myDeeplyNestedForm.$submitted = false;
             }*/

            scope.scrollToTop(element);

            // look at the next digest cycle
            if (force) {
              $(element).click(); // causes a refresh
            }
          };

          scope.onSuccess = function () {
            scope.updatingBillingType = false;
            /**
             * hide loading indicator after switched to invoice
             */
            scope.loading = false;

            scope.swapView(attrs.editabletemplateurl);

            scope.currentPanelOpen = false;
            profileEditService.setEditPanelStatus(false);

            if (scope.whiteoutEnabled) {
              //$(element).siblings().toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.big-half-header').toggleClass('white-out');
              $('.totes-project').find('.self-serve').children().find('.editable-content').each(function (k, v) {
                if (!$(v).parent().is($(element))) {
                  $(v).toggleClass('white-out');
                }
              });

              $('.totes-project').find('.account-select').toggleClass('white-out');
            }

            scope.scrollToTop(element);

            //omniture taggings
            var _options = [];
            switch (attrs.formdata) {
              case 'userInfo':
                _options.push({eVar13: 'MyRogers - change password'});
                _options.push({event6: ''});
                break;
              case 'BillingAddress':
                _options.push({eVar13: 'MyRogers - change Billing Address'});
                _options.push({event6: ''});
                break;
              case 'ContactInformation':
                _options.push({eVar13: 'MyRogers - change contact information'});
                _options.push({event6: ''});
                break;
              case 'MarketingPermissions':
                _options.push({eVar13: 'MyRogers - change marketing permission information'});
                _options.push({event6: ''});
                break;
              default:
                break;
            }
            omni.tagLink(_options);
            scope.loading = false;
          };

          scope.openModal = function () {
            var modal = $modal.open({
              templateUrl: 'views/modals/marketingPermissionsInfo.html',
              windowClass: 'verify-address-modal',
              controller: ['$scope', function ($scope) {
                $scope.closeModal = function () {
                  this.$close();
                };
              }]
            });
          };

          scope.onError = function () {
            scope.loading = false;
            // if billing type
            if (scope.onBillingtypeupdate) {
              scope.updatingBillingType = false;
            }

            var modalInstance = $modal.open({
              templateUrl: 'views/modals/generalErrorDialog.html',
              windowClass: 'verify-address-modal',
              controller: ['$scope', 'ute.blocks.language.switcher', '$rootScope', function ($scope, languageSwitcher, $rootScope) {
                $scope.verifyAddressFailed = $rootScope.verifyAddressFailed;
                $scope.language = languageSwitcher.getCurrentLanguage();
                $scope.close = function () {
                  modalInstance.close();
                  if ($state) {
                    profileEditService.setEditPanelStatus(false);
                    $state.go($state.current, {}, {reload: true});
                  } else {
                    location.reload();
                  }
                };

                $scope.$on('modal.closing', function () {
                  if ($state) {
                    $state.go($state.current, {}, {reload: true});
                  } else {
                    location.reload();
                  }
                });
              }]
            });
          };

          scope.onNotify = function () {
            /*            if (scope.myDeeplyNestedForm) {
             scope.myDeeplyNestedForm.$submitted = false;
             }*/
            scope.loading = false;
          };

          scope.updateEmail = function (form) {
            console.log('inside update email');
            appState.tagging(['_trackLink', {eVar13: 'MyRogers-change_contactinformation_email'}, {event6: ''}]);
            var defer = $q.defer();
            //var doneSavingPromise = defer.promise;
            var emailFields = {
              email: scope.editableData.email,
              emailconfirmation: scope.editableData.emailconfirmation
            };
            scope.loading = true;

            angular.extend(scope.editableData, {EmailChanged: true});

            scope.onEmailupdate({updates: emailFields, defer: defer, form: form});
            defer.promise.then(
              function (successful) {
                scope.onSuccess();
                scope.currentPanelOpen = false;
                profileEditService.setEditPanelStatus(false);
                console.log('inside Email update success');
                console.log('Inside onEmailupdate scope.formdata.email: ', scope.formdata.email);
                form.$valid = false;
              },
              function (rejected) {
                $rootScope.verifyAddressFailed = false;
                scope.onError();
              },
              // on notify we close the loading
              function () {
                scope.onNotify();
              }
            );
          };

          scope.switchToOnlineBilling = function (form) {
            scope.editableData.billingType = 'E_BILL';
            scope.saveBillingChanges(form);
          }

          scope.saveBillingChanges = function (form) {
            /**
             * NPS-1617: Enable rep to switch customer from online to paper billing
             * If bill type is invoice use the existing flow from rogers client
             * If bill type is E_bill use the new flow from go paperless module
             */
            if ( scope.editableData.billingType === 'INVOICE' ) {

            /**
             * show loading indicator before switched to invoice
             */
              scope.loading = true;
              scope.updatingBillingType = true;

              var onBillingUpdateDefer = $q.defer();
              onBillingUpdateDefer.promise;

              scope.onBillingtypeupdate({
                updates: {billingType: scope.editableData.billingType, email: scope.editableData.emailAddress, contactId: scope.editableData.contactId},
                defer: onBillingUpdateDefer
              });

              onBillingUpdateDefer.promise.then(function () {
                /**
                 * Reset GoPaperless data when update billing type successful
                 * next time getBillingType will make real call to backend
                 * instead of returning value from cache
                 */
                goPaperlessService.resetGoPaperless();
                scope.onSuccess();
                /**
                 * After successfully change to INVOICE
                 * Set initialBillingType to billing Type in the form
                 */
                scope.formdata.initialBillingType = scope.editableData.billingType

              }, function () {
                scope.onError();
              });
              return;
            }
            var configObject = {accountNumber: scope.editableData.accountNumber, contactEmail: scope.editableData.emailAddress};
            goPaperlessService.switchToPaperless(configObject)
              .then(function(result){
                if(result.switchSuccess && !!result.updatedEmail){
                  scope.onPostBillingtypeupdate({newEmailAddress: result.updatedEmail, newBillingType: 'E_BILL'});
                } else if (result.switchSuccess){
                  scope.onPostBillingtypeupdate({newBillingType: 'E_BILL'});
                } else if(!result.switchSuccess && !!result.updatedEmail) {
                  scope.onPostBillingtypeupdate({newEmailAddress: result.updatedEmail});
                }
                scope.onSuccess();
              })
              .catch(function(){
                scope.cancel();
              });
          };

          scope.saveChanges = function (form) {

            var defer = $q.defer(),
              doneSavingPromise = defer.promise;

            //if (form.confirmEmail.$valid === false && form.Email.$touched === false) {
            //  form.confirmEmail.$valid = true;
            //  form.confirmEmail.$invalid = false;
            //  form.$valid = true;
            //  form.$invalid = false;
            //}
            //
            // Execute onSubmit callback passed to the directive
            // with a promise and the delta of the changes
            // The promise must be resolved by the onSubmit function such
            // that the directive can switch back to the non editable view.
            //

            scope.loading = true;

            //add a flag to indicate email or phone number change
            //            var emailChanged = !!form.Email;
            //            angular.extend ( scope.editableData, { EmailChanged: emailChanged });
            scope.formdata.answer = scope.editableData.answer;

            //Make a copy of the scope object to make any changes required before submission
            //and submit the copied scope obj instead of the original scope
            var editableDataCopy = angular.copy(scope.editableData);
            if (editableDataCopy.contactNumber1) {
              editableDataCopy.contactNumber1 = editableDataCopy.contactNumber1.replace(/•/g, '*');
            }
            if (editableDataCopy.contactNumber2) {
              editableDataCopy.contactNumber2 = editableDataCopy.contactNumber2.replace(/•/g, '*');
            }
            //Remove whitespace (if any) especially in the middle
            //Since this function is used for other form submissions, check if the postalCode is set
            if (editableDataCopy.postalCode) {
              editableDataCopy.postalCode = editableDataCopy.postalCode.replace(' ', '');
            }

            scope.onSubmit({updates: editableDataCopy, defer: defer, form: form});
            var self = this;
            doneSavingPromise.then(
              function (successful) {
                scope.onSuccess();
                scope.currentPanelOpen = false;
                profileEditService.setEditPanelStatus(false);

                form.$valid = false;

                if (userService.isConsumer()) {
                  // DC-1701 - UC15 - masking phone number after saving without page reload
                  if (scope.nonEditableData.contactNumber1) {
                    scope.nonEditableData.contactNumber1 = scope.nonEditableData.contactNumber1.substring(0, 1) + '•••••' + scope.nonEditableData.contactNumber1.substring(6, 10);
                  }
                  if (scope.nonEditableData.contactNumber2) {
                    scope.nonEditableData.contactNumber2 = scope.nonEditableData.contactNumber2.substring(0, 1) + '•••••' + scope.nonEditableData.contactNumber2.substring(6, 10);
                  }
                }
              },
              function (rejected) {
                if (rejected && rejected.data && rejected.data.data && rejected.data.data.errorCode && rejected.data.data.errorCode === 10510) {
                  form.oldpasswordwrong = true;
                  form.oldpassworderrormsg = rejected.data.data.errorMessage;
                  scope.loading = false;
                  form.generalError = false;
                  form.$setValidity('oldPassword', false, form);
                  //form.oldPassword.$valid = false;
                  form.oldPassword.$touched = false;
                } else {
                  scope.onError();
                }
              },
              // on notify we close the loading
              function () {
                scope.onNotify();
              }
            );
          };

        //n Remove any watchers
        scope.$on('$destroy', function () {
          rootwatch3();
          scopewatch4();
        });

        }
      };
    };
}(_));

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('resetPasswordModalCtrl', resetPasswordModalCtrl);

  resetPasswordModalCtrl.$inject = ['$scope', '$rootScope', '$modalInstance', '$q', 'ajax', 'selfServeSvc'];

  function resetPasswordModalCtrl($scope, $rootScope, $modalInstance, $q, ajax, selfServeSvc) {

    $scope.continueProcess = function () {
      var resetPasswordDefer = $q.defer();
      selfServeSvc.doResetPassword(resetPasswordDefer);
      $rootScope.resetPwdLoading = true;
      resetPasswordDefer.promise.then(function (data) {
        if (data.status === 'success') {
          //$rootScope.resetPwdSuccessStatus = true;
          $rootScope.resetPwdLoading = false;
          $rootScope.resetPwdSuccessStatus = true;
          $rootScope.resetPwdEmail = data.email;
        } else if (data.errorCode === 8001) {
          $rootScope.resetPwdSuccessStatus = false;
          $rootScope.resetPwdLoading = false;
        }
        //$rootScope.resetPwdStatus=data
      }, function (error) {
        $rootScope.resetPwdSuccessStatus = false;
        $rootScope.resetPwdLoading = false;
      });
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

'use strict';

/**
 * Cheque form widget:
 * output object, the parent scope will have this object ready for use,
 * just refer to the object if need to retrieve the value, for example to call server with the cheque information:
 * chequingObj:{
        transitNo:null,
        bankCode: null,
        accountNo:null
    }
 */
angular.module('totesApp')
  .directive('formChequing', ['$rootScope', function ($rootScope) {
    return {
      restrict: 'E',
      templateUrl: function (elem, attrs) {
        return attrs.templateUrl || 'scripts/directives/formChequing/formChequing.html';
      },
      scope: {
        chequingObj: '=',
        showDebitForm: '=',
        form: '=debitForm',
        mopObj: '=',
        dtmName: '='
      },
      link: function ($scope, element, attr) {
        $scope.$extend({
          accountFocused: false,
          bankFocused: false,
          transitFocused: false,
          chequingObj: {
            transitNo: null,
            bankCode: null,
            accountNo: null
          },
          isAccepted: false,
          setHintImg: function (imgSrc) {
            $(element).find('.img-cheque #overlay').attr('src', imgSrc);
          },
          isCare: $rootScope.isCare,
          isDealer: $rootScope.isDealer
        });
      }
    };
  }]);

(function() {
  'use strict';

  var app = angular.module('totesApp');

  app.directive('infoDialogModal', ['ngDialog', 'ute.datalayer.common.service', function (ngDialog, dataLayerService) {

    var link = function(scope, elem, attr) {

      function modalCallback() {
              var modal = ngDialog.open({
                templateUrl: 'scripts/directives/infoDialogModal/infoDialogModal.html',
                controller: ['$scope', function ($scope) {
                  var rvCustomerDetails = {
                    rvCustomer : false
                  }
                  $scope.templateHtml = attr.templateHtml;
                  $scope.info = scope.info;
                  if(scope.rvCustomerInfo && scope.rvCustomerInfo.rvCustomer) {
                    $scope.rvCustomerInfo = scope.rvCustomerInfo;
                  } else {
                    $scope.rvCustomerInfo = rvCustomerDetails;
                  }
                  dataLayerTrackEvent(scope.isShareEverything, scope.analyticsKey, {selfServeComplete: true});
                  $scope.close = function() {
                    modal.close();
                  };

                  $scope.test = function() {
                    console.log('data====', $scope.info);
                  }
                }],
                className: 'info-dialog-modal',
                showClose: false
              });
            }

      elem.on('click', modalCallback);
      elem.on('keydown', function(e){
        e.which === 13 && modalCallback();
      });

      function dataLayerTrackEvent(isShareEverything, analyticsKey, eventsObj) {
        if (analyticsKey) {
          var mappingKey = (isShareEverything.toLowerCase() === 'true') ? 'shareEverythingDashboard.' + analyticsKey : 'wirelessDashboard.' + analyticsKey;
          var payload = {events: eventsObj};
          dataLayerService.track(payload, true, [0, 1, 2, 4], {mappingKey: mappingKey});
        }
      }
    };

    return {
      restrict: 'A',
      scope: {
        info: '=',
        isShareEverything: '@?',
        analyticsKey: '@?',
        rvCustomerInfo: '='
      },
      link: link
    };
  }]);

}());

'use strict';

angular.module('totesApp').directive('liveChat', function () {

    return {
        templateUrl: 'scripts/directives/liveChat/liveChat.html',
        replace: true,
        restrict: 'E'

    };

});

'use strict';

angular
    .module('totesApp')
    .directive('messageInfoBox', function () {
        return {
          scope: {
            infoMessage: '='
          },
          templateUrl: 'scripts/directives/messageInfoBox/messageInfoBox.html',
          replace: true,
          restrict: 'E',
          link: function (scope, element, attrs, $sce) {
          }
        };
      });


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrCTNListLinkModalController', CTNListLinkModalController);

  CTNListLinkModalController.$inject = [
    '$modalInstance',
    'my.rogers.simcard.change.utils.service',
    'resolvedData'
  ];

  /* @ngInject */
  function CTNListLinkModalController($modalInstance,
                                      simcardChangeUtilsService,
                                      resolvedData) {

    var vm = this;
    vm.resolvedData = resolvedData;

    // Function invoked after click in the template
    vm.selectCTNModal = function (val) {
      simcardChangeUtilsService.launchSimCardChangeModule(val.accountNumber, val.serviceDetail);
      $modalInstance.close('close');
    };

    vm.closeThisDialog = function () {
      $modalInstance.close('close');
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  angular.module('totesApp').directive('myOffers', myOffers);

  /* @ngInject */
  function myOffers() {
    return {
      templateUrl: 'scripts/directives/myOffers/myOffers.html',
      restrict: 'E',
      controllerAs: 'mo',
      controller: [
        '$scope',
        'settings',
        'localStorage',
        'sessionStorage',
        'appState',
        'ajax',
        '$timeout',
        '$rootScope',
        '$filter',
        'myrMyServicesService',
        'myrAccountListService',
        'ute.common.permissions.service',
        'selfServeSvc',
        '$q',
        'ute.blocks.language.switcher',
        '$modal',
        'ute.rogers.account.overview.factory',
        'my.rogers.simcard.change.utils.service',
        function ($scope,
                  settings,
                  localStorage,
                  sessionStorage,
                  appState,
                  ajax,
                  $timeout,
                  $rootScope,
                  $filter,
                  myrMyServicesService,
                  myrAccountListService,
                  permissionsService,
                  selfServeSvc,
                  $q,
                  languageSwitcher,
                  $modal,
                  accountOverviewFactory,
                  simcardChangeUtilsService) {

          $scope.revolutionLink = settings.revolutionLink;
          $scope.hasTPSApermission = false;
          $scope.revPermissionLoaded = false;
          $scope.mss = myrMyServicesService;
          $scope.als = myrAccountListService;
          $scope.wirelessimage = false;
          $scope.nonwirelessimage = true;
          $scope.hideRevBanner = $rootScope.isDealer;
          $scope.lng = languageSwitcher.getCurrentLanguage();

          var activeWirelessCount, wpkgclientctn, wpkgclientban;
          var gotPermissionsTimer;

          myrMyServicesService.registerUpdateCallback(checkOffers);

          var accountOverviewService = accountOverviewFactory();
          accountOverviewService.getSelectedAccount()
            .then(function (selectedAccount) {
              checkOffers(selectedAccount);
            })
            .finally(function () {
              accountOverviewService.registerOnDataChangeHandler(function (accountOverview) {
                checkOffers(accountOverview.getSelectedAccount());
              }, 'myOffersController');
            });

          function checkOffers(selectedAccount) {
            selectedAccount = selectedAccount || myrAccountListService.selectedAccount;
            activeWirelessCount = 0;
            $scope.accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
            $scope.nonwirelessimage = true;
            $scope.wirelessimage = false;
            if (selectedAccount && selectedAccount.accountStatus === 'Active' &&
              myrMyServicesService.myServicesList && myrMyServicesService.myServicesList.length > 0) {
              _.each(myrMyServicesService.myServicesList, function (value) {
                if (value.accountNumber === $scope.accLocalSelected &&
                  value.serviceType === settings.service.wireless &&
                  value.serviceName !== settings.service.suspended) {
                  $scope.wirelessimage = true;
                  $scope.nonwirelessimage = false;
                  wpkgclientctn = value.serviceDetail;
                  wpkgclientban = value.accountNumber;
                  activeWirelessCount = activeWirelessCount + 1;
                }
              });
            }

            if ($rootScope.isDealer && $scope.wirelessimage) {
              var userInfoDefer = $q.defer();
              selfServeSvc.getUserProfile(userInfoDefer);
              userInfoDefer.promise.then(function () {
                var userInfo = selfServeSvc.getUserInfo();
                $scope.hideRevBanner = userInfo.errorCode && userInfo.errorCode === 60001;
              });
              $scope.hideRevBanner = true;
            }
          }

          $scope.postToRogersSim = function () {
            if (activeWirelessCount > 1) {
              $rootScope.modal = $modal.open({
                templateUrl: 'views/modals/WirelessCTNLinkModal.html',
                controller: 'MyrCTNListLinkModalController',
                controllerAs: 'ctnList',
                backdrop: 'static',
                keyboard: false,
                backdropClass: 'bkg-modal',
                resolve: {
                  resolvedData: function () {
                    return {
                      al: myrAccountListService.selectedAccount,
                      myServicesList: myrMyServicesService.myServicesList,
                      wpkgclientMultiBAN: wpkgclientban,
                      wpkgclientMultiCTN: wpkgclientctn
                    };
                  }
                }
              });
            }
            else {
              simcardChangeUtilsService.launchSimCardChangeModule($scope.wpkgclientban, $scope.wpkgclientctn);
            }
          };
          // Used in ute-injected content - do not remove
          $scope.openModal = function (size) {
            $rootScope.modal = $modal.open({
              templateUrl: 'views/modals/briteBillPromo.html',
              controller: 'briteBillPromoModalCtrl',
              size: size,
              backdrop: false,
              //backdropClass: 'bkg-modal',
              resolve: {}
            });
            $rootScope.modal.result.then(function () {
            }, function () {
              // on Cancel behaviour
            });
          };


          function getPermissions() {
            $scope.hasTPSApermission = false;
            $scope.revPermissionLoaded = false;
            var hasRevPermission = localStorage.getLocalStorageValue('RevPermission');
            if ($rootScope.isCare) {
              hasRevPermission = sessionStorage.getSessionStorageValue('RevPermission');
            }

            if (hasRevPermission) {
              if (hasRevPermission === '1') {
                $scope.hasTPSApermission = true;
                $scope.revPermissionLoaded = true;
                return;
              }
              if (hasRevPermission === '0') {
                $scope.hasTPSApermission = false;
                $scope.revPermissionLoaded = true;
                return;
              }
            }
            //to avoid second call because widget is displayed twice on the page
            if (appState.permissionsLoaded) {
              return;
            }
            appState.permissionsLoaded = true;

            $scope.hasTPSApermission = true;
            $scope.revPermissionLoaded = true;
            localStorage.setLocalStorageValue('RevPermission', '1');
            if ($rootScope.isCare || $rootScope.isDealer) {
              sessionStorage.setSessionStorageValue('RevPermission', '1');
            }
            gotPermissionsTimer = $timeout(function () {
              $rootScope.$broadcast('gotPermissions');
            }, 500);

          }

          getPermissions();

          $scope.$on('$destroy', function () {
            myrMyServicesService.registerUpdateCallback(null);
            accountOverviewService.unregisterOnDataChangeHandler('myOffersController');
            $timeout.cancel(gotPermissionsTimer);
          });

        }]

    };
  }

  // TODO please finished refactoring according to https://github.com/johnpapa/angular-styleguide
  angular.module('totesApp').controller('briteBillPromoModalCtrl', ['$scope', '$rootScope', '$modalInstance', '$sce', 'ute.blocks.language.switcher',
    function ($scope, $rootScope, $modalInstance, $sce, languageSwitcher) {

      $scope.trustSrc = function (src) {
        return $sce.trustAsResourceUrl(src);
      };

      $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
      };

      function watchVideo() {
        $scope.lang = languageSwitcher.getCurrentLanguage();
        if ($scope.lang === 'en') {
          $scope.videoLink = $scope.trustSrc('https://www.youtube.com/embed/yQhrPek1KJw?autoplay=1&showinfo=0&rel=0&controls=0');
        } else if ($scope.lang === 'fr') {
          $scope.videoLink = $scope.trustSrc('https://www.youtube.com/embed/sQi8PxSD-sA?autoplay=1&showinfo=0&rel=0&controls=0');
        }
      }

      watchVideo();

    }]);
})();


(function(){
    'use strict';
    angular.module('totesApp').controller('AddBadgeModalController', addBadgeModalController);

    addBadgeModalController.$inject = ['$modalInstance', 'badgeTitle', 'contactInfoMissing'];

    /* @ngInject */
    function addBadgeModalController($modalInstance, badgeTitle, contactInfoMissing) {
        var vm = this;
        vm.badgeTitle = badgeTitle;
        vm.contactInfoMissing = contactInfoMissing;
        vm.close = function() {
            $modalInstance.dismiss('cancel');
        };
    }
})();

/* global angular */
(function () {
  'use strict';

  angular.module('totesApp').directive('myserviceaddbadge', myserviceaddbadge);

  myserviceaddbadge.$inject = ['$window', '$modal', 'myrMyServicesService', 'ute.blocks.language.switcher', 'ute.rogers.account.overview.factory', 'ute.blocks.environment'];
  /* @ngInject */
  function myserviceaddbadge($window, $modal, myrMyServicesService, languageSwitcher, accountOverviewFactory, environmentProvider) {

    return {
      templateUrl: 'scripts/directives/myserviceaddbadge/myserviceaddbadge.html',
      restrict: 'E',
      scope: {
        goto: '=',
        allowgoto: '='
      },			// closed scope
      link: function (scope, element, attrs) {

        scope.accountNumber = attrs.accountnumber;
        scope.variation = attrs.variation;

        scope.id = attrs.idname;
        scope.title = attrs.title;
        scope.link = attrs.link;
        scope.addLangRoute = attrs.addlangroute;
        scope.addLang = attrs.addlang;
        scope.langParameterName = attrs.langparametername;
        scope.langFirstParam = attrs.langfirstparam;
        scope.icon = attrs.icon;
        scope.imageIcon = attrs.imageIcon;

        scope.updategamecentrelive = attrs.updategamecentrelive;

        scope.isVisible = attrs.isvisible;
        scope.isRepView = attrs.isrepview;
        scope.isCare = attrs.iscare;
        scope.isDealer = attrs.isdealer;

        scope.accountOverviewService = accountOverviewFactory();
        scope.environmentProvider = environmentProvider;

        var contactMissingInfo = {
          missingFirstName: false,
          missingLastName: false,
          missingPhoneNumber: false,
          missingEmail: false,
          missingLangPref: false,
          error: false
        };

        var mss = myrMyServicesService;

        scope.isClickable = function() {
          return !(scope.isCare === 'true' || scope.isDealer === 'true') || scope.isRepView === 'true';
        };
        scope.openWindow = function(badgeTitle, event) {
          if(scope.isRepView === 'true') {
            if (scope.id === 'Ignite NAC'){
              scope.accountOverviewService.getSelectedAccountDetails().then(function (response) {
                var primaryContactInfo = response.contactInfo;
                if(primaryContactInfo){
                  var contactID = primaryContactInfo.contactId;
                  if(contactID){
                    if(!primaryContactInfo.firstName) {
                      contactMissingInfo.missingFirstName = true;
                    }
                    if(!primaryContactInfo.lastName) {
                      contactMissingInfo.missingLastName = true;
                    }
                    if(!primaryContactInfo.homePhone 
                      && !primaryContactInfo.mobilePhone 
                        && !primaryContactInfo.businessPhone) {
                      contactMissingInfo.missingPhoneNumber = true;
                    }
                    if(!primaryContactInfo.emailAddress) {
                      contactMissingInfo.missingEmail = true;
                    }
                    if(!primaryContactInfo.language) {
                      contactMissingInfo.missingLangPref = true;
                    }
                  } else {
                    contactMissingInfo.error = true;
                  }
                } else {
                  contactMissingInfo.error = true;
                }

                if(contactMissingInfo.missingFirstName || contactMissingInfo.missingLastName || contactMissingInfo.missingPhoneNumber ||
                  contactMissingInfo.missingEmail || contactMissingInfo.missingLangPref || contactMissingInfo.error){
                    $modal.open({
                      templateUrl: 'scripts/directives/myserviceaddbadge/ignite-missing-info-modal.html',
                      controller: 'AddBadgeModalController',
                      controllerAs: 'ctrl',
                      windowClass: 'ignite-error-modal-window',
                      resolve: {
                        badgeTitle: function(){
                          return badgeTitle;
                        },
                        contactInfoMissing: function(){
                          return contactMissingInfo;
                        }
                      }
                    });
                } else {
                  var url = scope.environmentProvider.getProperty('igniteNAC').url;
                  $window.open(url,'_self');
                }
              }).catch(function (error) {
                console.error('error getting account summary');
                contactMissingInfo.error = true;
                $modal.open({
                  templateUrl: 'scripts/directives/myserviceaddbadge/ignite-missing-info-modal.html',
                  controller: 'AddBadgeModalController',
                  controllerAs: 'ctrl',
                  windowClass: 'ignite-error-modal-window',
                  resolve: {
                    badgeTitle: function(){
                      return badgeTitle;
                    },
                    contactInfoMissing: function(){
                      return contactMissingInfo;
                    }
                  }
                });
              });
            } else {
              $modal.open({
                templateUrl: 'scripts/directives/myserviceaddbadge/add-badge-modal.html',
                controller: 'AddBadgeModalController',
                controllerAs: 'ctrl',
                resolve: {
                  badgeTitle: function(){
                    return badgeTitle;
                  },
                  contactInfoMissing: function(){
                    return contactMissingInfo;
                  }
                }
              });
            }
          } else if(scope.isCare !== 'true' && scope.isDealer !== 'true') {
            if(angular.isDefined(scope.goto) && scope.allowgoto) {
              scope.goto(event); // to cover services with goto function (recently introduced for "Add Individual Line" in myOtherServicesService)
            } else {
                /***
                 As part of solaris requirement If customer does not have Legacy or Maestro
                 Home phone then a left turn popup will be displayed
                **/

                if(scope.id === 'RHPc' || scope.id === 'RHP Phone Line' ) {

                  var serviceName = scope.id;
                  var modalInstance = $modal.open({
                    templateUrl: 'views/modals/homephone-contact-care.html',
                    windowClass: 'generic-message-modal',
                    controller: ['$scope', '$translate', function ($scope, $translate) {
                      $scope.close = function () {
                        modalInstance.close();
                      };
                      $scope.isLanguageEnglish = false;
                      if(languageSwitcher.getCurrentLanguage() === 'en')
                        $scope.isLanguageEnglish = true;

                      var myServiceList  = _.filter(mss.myServicesList,
                                             function(service){
                                              return service.subType === 'IPTV' || service.subType === 'HSI';
                                           });
                      if(myServiceList.length<=0) {
                        $scope.liveChat = {
                          cbid: 'home_phone_contact_care_liveChat.cbid_legacy',
                          dynamicDiv: 'home_phone_contact_care_liveChat.dynamicDiv_legacy',
                          chatButton: 'home_phone_contact_care_liveChat.chatButton_legacy'
                        };
                      } else {
                        $scope.liveChat = {
                          cbid: 'home_phone_contact_care_liveChat.cbid_solaris',
                          dynamicDiv: 'home_phone_contact_care_liveChat.dynamicDiv_solaris',
                          chatButton: 'home_phone_contact_care_liveChat.chatButton_solaris'
                        };
                      }
                    }]
                  });
                } else {
                  $window.open(scope.link,'_blank');
                }
            }
          }
        };
      }
    };
  }

})();

/* global angular */
(function () {
  'use strict';

  angular.module('totesApp').directive('myservicebadge', myservicebadge);

  myservicebadge.$inject = ['ute.blocks.language.switcher', '$translate', '$rootScope', 'myrMyServicesService'];
  /* @ngInject */
  function myservicebadge(languageSwitcher, $translate, $rootScope, myrMyServicesService) {

    return {
      templateUrl: 'scripts/directives/myservicebadge/myservicebadge.html',
      restrict: 'E',
      scope: {},			// closed scope
      link: function (scope, element, attrs) {
        scope.variation = attrs.variation;
        scope.accountNumber = attrs.accountnumber;
        scope.firstName = attrs.firstname;
        scope.lastName = attrs.lastNAme;
        scope.icon = attrs.icon;
        scope.imageIcon = attrs.imageIcon;
        scope.linkText = attrs.linktext;
        scope.linkURL = attrs.linkurl;
        scope.paramName = attrs.paramname;
        scope.serviceDetail = attrs.servicedetail;
        scope.serviceName = attrs.servicename;
        scope.serviceType = attrs.servicetype;
        scope.showPhone = attrs.showphone;
        scope.subType = attrs.subtype;
        scope.isDealer = attrs.isdealer;
        scope.isCare = attrs.iscare;
        scope.isRepView = $rootScope.isRepView; /* NPS-1725::Removed SGI from Consumer View and rogers.com */
        scope.label = $translate.instant('home_phone_label');
        scope.lang  = languageSwitcher.getCurrentLanguage();
        console.log("attrs:"+attrs.serviceaddress);
        scope.serviceAddress = attrs.serviceaddress;

        languageSwitcher.registerOnDataChangeHandler(function (lang) {
          scope.label = $translate.instant('home_phone_label');
        }, 'myServiceBadgeLangSub');

        scope.$on('$destroy', function() {
          languageSwitcher.unregisterOnDataChangeHandler('myServiceBadgeLangSub');
        });

        scope.$on('heroOfferInd', function(event, data) {
          if(data && data.targetedHeroOfferMap) {
            scope.heroDetails = data.targetedHeroOfferMap;
          }
        });
      }
    };
  }
})();

/* global angular */

//  <myservicebadge-group groupType="shared"></myservicebadge-group>
//      attrs.grouptype = {possible options: string}  shared, individual, residential, otherServices, addServices


(function () {
  'use strict';

  angular.module('totesApp').directive('myservicebadgeGroup', myservicebadgeGroup);

  myservicebadgeGroup.$inject = ['ute.common.user.service',
    'btnSettings',
    '$window',
    '$translate',
    'myrMyServicesService',
    'ute.data.manager.service',
    'ute.rogers.account.overview.factory',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function myservicebadgeGroup(userService,
                               btnSettings,
                               $window,
                               $translate,
                               myrMyServicesService,
                               dataManagerService,
                               accountOverviewFactory,
                               languageSwitcher) {

    return {
      templateUrl: 'scripts/directives/myservicebadgeGroup/myservicebadgeGroup.html',
      restrict: 'E',
      scope: {},			// closed scope
      link: function (scope, element, attrs) {
        scope.isrepview = attrs.isrepview;
        // select badge variation based on the required group, shared group will switch the badge into badge-list mode
        var grouptype = attrs.grouptype;
        var accountOverviewService = accountOverviewFactory();

        scope.grouptype = attrs.grouptype;
        scope.badgeType = '';       // single, shared
        scope.myrMyServicesService = myrMyServicesService;
        
        scope.notInDataManager = function (item) {

          var dmBadgeList = dataManagerService.getBadgeList().subscriberList;

          var notInList = true;

          if (item.serviceName === 'wireless' || item.serviceName === 'shareEverything') {
            for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
              if (item.serviceDetail === dmBadgeList[iSELine].ctn) {
                notInList = false;
              }
            }
          }
          return notInList;
        };

        scope.isVisible = function (item) {
          // As John Lee (PO) asked in oneview we should always display wireless badge - no matter cx has the service or not.
          return (item.isVisible || 
            (scope.isrepview === 'true' && 
              (item.title === 'myaccoverview_get_wireless' || item.title === 'myaccoverview_get_ignite_bundle')));
        };

        if (grouptype === 'shared') {
          scope.badgeType = 'shared';
        } else {
          scope.badgeType = 'single';
        }

        var messageBoxDom = function () {
          scope.loginMessage = '<strong>' + $translate.instant('login_to') + ' ' + $translate.instant('sgi') + '</strong>';
        };

        // Legacy code
        scope.isDealer = userService.isDealer();
        scope.isCare = userService.isCare();

        function setBtnVars(account) {
          if (account && account.accountStatus) {
            scope.btnSettings = btnSettings.getSettings(account.accountStatus);
            scope.btnStatus = $window.btnStatus;
          }
          messageBoxDom();
        }

        accountOverviewService.getSelectedAccount()
          .then(function (account) {
            setBtnVars(account);
          });

        languageSwitcher.registerOnDataChangeHandler(function (lang) {
          messageBoxDom();
        }, 'myservicebadgeGroupLangSub');

        scope.$on('$destroy', function() {
          languageSwitcher.unregisterOnDataChangeHandler('myservicebadgeGroupLangSub');
        });

        // function link
        // scope.runService = myrMyServicesService.runService;

        var runServiceHttpMethods = {
          'getRogersBankLang': function (url) {
            if (languageSwitcher.getCurrentLanguage() === 'fr') {
              return url + 'French';
            }
            return url + 'English';
          }
        };

        scope.runService = function (serviceName, value) {
          if (serviceName.substr(0, 4) === 'http') {
            window.open(runServiceHttpMethods[value](serviceName));
            return;
          }
          myrMyServicesService.runService(serviceName, value);

          // var userPath = myrMyServicesService.getServicePath(serviceName, value);

          // if (appState.maintenanceRedirect(userPath)) {
          //   $location.path('/underMaintenance');
          // } else {
          //   myrMyServicesService.runService(serviceName, value);
          // }
        };
        console.log("myservicebadgeGroup - myrMyServicesService.myOtherServicesListFinal: " 
                          + JSON.stringify(scope.myrMyServicesService.myOtherServicesListFinal));
      }
    };
  }

})();

(function () {
  'use strict';
  angular.module('totesApp').directive('needHelp', ['$timeout', function ($timeout) {
    return {
      templateUrl: function (elem, attrs) {
        return attrs.templateUrl || 'scripts/directives/needHelp/needHelp.html';
      },
      replace: true,
      restrict: 'EA',
      scope: {
        cbid: '=',
        cbidFr: '=',
        boldChatDiv: '=dynamicDiv',
        chatButton: '=',
        errorMessage: '=',
        chatButtonFr: '=',
        lang: '=',
        altText: '=',
        needHelpTextKey: '@'
      },
      link: function (scope, element, attrs) {
        scope.needHelpTextKey = scope.needHelpTextKey || 'link_account_need_help';
        // scope.forgotUsernamePage = false;
        //
        // if (scope.chatButton == 'chatButtonForgotUserNameEn' || scope.chatButton == 'chatButtonForgotUserNameFr') {
        //   scope.forgotUsernamePage = true;
        // }
        // scope.chatButtonEn = scope.chatButton;
        // var invokeBoldChat = function (oldValue) {
        //   var cbid = (scope.lang === 'fr' ? scope.cbidFr : scope.cbid),
        //     chatButton = (scope.lang === 'fr' ? scope.chatButtonFr : scope.chatButton);
        //
        //   var bdid = /^\d+$/.test(cbid) ? cbid : getBDId(cbid); // jshint ignore:line
        //   staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage); // jshint ignore:line
        // };
        //
        // scope.$watch(function () {
        //     return document.getElementById(scope.boldChatDiv);
        //   }, function (newValue) {
        //     if (null !== newValue) {
        //       invokeBoldChat();
        //     }
        //   }
        // );
        //
        // scope.$watch('chatButton', function (newValue, oldValue) {
        //   if (newValue !== oldValue) {
        //     invokeBoldChat(oldValue);
        //   }
        // }, true);

        if (scope.lang) {
          assignChatVariables();
          var cbid = scope.cbid;
          var chatButton = scope.chatButton;
          var scopewatch1 = scope.$watch('lang', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              assignChatVariables();
            }
          }, true);
        }

        function assignChatVariables() {
          scope.chatButton = scope.lang === 'fr' ? scope.chatButtonFr : chatButton;
          scope.cbid = scope.lang === 'fr' ? scope.cbidFr : cbid;
        }

        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch1();
        });

      }
    };
  }]);
}());

(function () {
  'use strict';
  angular.module('totesApp').directive('needHelpForgotUsername', function () {
    return {
      templateUrl: function (elem, attrs) {
        return attrs.templateUrl || 'scripts/directives/needHelp/needHelpForgotUsername.html';
      },
      replace: true,
      restrict: 'EA',
      scope: {
        cbid: '=',
        cbidFr: '=',
        boldChatDiv: '=dynamicDiv',
        chatButton: '=',
        errorMessage: '=',
        chatButtonFr: '=',
        lang: '=',
        altText: '=',
        needHelpTextKey: '@'
      },
      link: function (scope, element, attrs) {
        scope.needHelpTextKey = scope.needHelpTextKey || 'link_account_need_help';
        var invokeBoldChat = function (oldValue) {
          var cbid = (scope.lang === 'fr' ? scope.cbidFr : scope.cbid),
            chatButton = (scope.lang === 'fr' ? scope.chatButtonFr : scope.chatButton);

          var bdid = /^\d+$/.test(cbid) ? cbid : getBDId(cbid); // jshint ignore:line
          if (scope.altText === null && scope.altText === undefined) {
            staticLiveChatButtonUTE(bdid, scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage); // jshint ignore:line
          } else {
              liveChatAltTextUTE(scope.altText, bdid, scope.boldChatDiv, scope.chatButton, oldValue, scope.errorMessage);
          }
        };

        var scopewatch1 = scope.$watch(function () {
            return document.getElementById(scope.boldChatDiv);
          }, function (newValue) {
            if (null !== newValue) {
              invokeBoldChat();
            }
          }
        );

        var scopewatch2 = scope.$watch('chatButton', function (newValue, oldValue) {
          if (newValue !== oldValue) {
            invokeBoldChat(oldValue);
          }
        }, true);

        if (scope.lang) {
          var scopewatch3 = scope.$watch('lang', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              scope.chatButton = scope.lang === 'fr' ? scope.chatButtonFr : scope.chatButton;
            }
          }, true);
        }

        invokeBoldChat();

        //n Remove any watchers 
        scope.$on('$destroy', function () {
          scopewatch1();
          scopewatch2();
          scopewatch3();
        });

      }
    };
  });
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp')
      .service('agentSession', ['$http',
        '$q',
        '$rootScope',
        'ajax',
        'settings',
        '$window',
        'localStorage',
        'appState',
        '$state',
        '$location',
        '$cookieStore',
        'sessionStorage',
        'ute.common.user.service',
        'ute.blocks.messages.bus.service',
        'my.rogers.dataLayer.utils.service',
        'ute.blocks.persistent.storage.service',
        function ($http, // jshint ignore:line
                  $q,
                  $rootScope,
                  ajax,
                  settings,
                  $window,
                  localStorage,
                  appState,
                  $state,
                  $location,
                  $cookieStore,
                  sessionStorage,
                  userService,
                  messagesService,
                  dataLayerUtilsService,
                  utePersistentStorageService) {
      return {
        startAgentSession: function(){
          var deferred = $q.defer();
          var $this = this;
          var agentUserId;
          var repName;
          ajax.agentInfo().then(
            function (data) {
                  if(!data || !data.cfaInfo){
                    deferred.reject('No cfaInfo');
                  }
                  else {
                    $this.analyticsAgentInfo(data.cfaInfo, 'dealer');
                  }
                  $rootScope.userInfo = {
                    cfaInfo: data
                    //type: 'cfa'
                  };
                 // TODO
                 $rootScope.user.isAuthenticated = true;
                 repName = $rootScope.userInfo.cfaInfo.cfaInfo.cfaFirstName + " " +  $rootScope.userInfo.cfaInfo.cfaInfo.cfaLastName;
                 agentUserId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
                 messagesService.publish('agent-repname', repName);

            }, function (error) {
                deferred.reject(error);
            });
        },
        startCareSession: function(){
            var deferred = $q.defer();
            var $this = this;
            var agentUserId;
            var repName;
            ajax.agentInfo().then(
            function (data) {
                  if(!data || !data.repInfo){
                    deferred.reject('No cfaInfo');
                  }
                  else {
                    $this.analyticsAgentInfo(data, 'care');
                  }
                  $rootScope.userInfo = {
                    careInfo: data
                    //type: 'cfa'
                  };
                  agentUserId = repName = $rootScope.userInfo.careInfo.lanId;
                  messagesService.publish('agent-repname', repName);
            }, function (error) {
                deferred.reject(error);
            });
        },
         analyticsAgentInfo: function(data, agentType) { //BCR-693 Analytics: For Rep name and Dealercode mainly
              var dealerType;
              var dealerCode;
              var userId;
              if(data.dealerType){
                  dealerType = data.dealerType;
              }
              if(data.dealerCode){
                  dealerCode = data.dealerCode;
              }
              if(agentType === 'dealer' && data.userId){
                  userId = data.userId;
              }
              if(agentType === 'care' && data.lanId){
                  userId = data.lanId;
              }
              var agentInfo = {
                  dealerType: dealerType,
                  dealerCode: dealerCode,
                  userId: userId
              };
              dataLayerUtilsService.setDealerInfo(agentInfo);
              utePersistentStorageService.putToSession('dealerInfo', agentInfo);
              utePersistentStorageService.putToSession('operatorId', data.repInfo.loginId);
         },
      };
  }]);
}());

'use strict';

angular.module('totesApp').directive('body', ['agentSession', 'localStorage', 'settings', '$browser', 'ute.blocks.messages.bus.service', function (agentSession, localStorage, settings, $browser, messagesService) {
  return {
    restrict: 'E',
    scope: false
  };
}]);

/* global angular */
'use strict';

angular
    .module('totesApp')
    .factory('ramPermission', ['$rootScope', '$window', 'settings', 'ute.common.permissions.service',
      function ($rootScope, $window, settings, permissionsService) {
        // Initiate Object
        var ramPermission = {};
        ramPermission.getRepPermission = function (ramResourceCode, ramActionCode) {
          if ($rootScope.isDealer || $rootScope.isCare) {
            permissionsService.getRamPermission(ramResourceCode, ramActionCode).then(function (agentPermission) {
              if (!agentPermission) {
                if ($rootScope.isDealer) {
                  $window.location.href = '/web/totes/#/oneViewInterface?statusCode=' + settings.oneViewStatusCodes.sspAccessFailure;
                } else if ($rootScope.isCare) {
                  $window.location.href = '/web/totes/#/oneViewInterface?statusCode=' + settings.oneViewStatusCodes.crmAccessFailure;
                }
              }
            });
          }
        };
        return ramPermission;
      }
    ]);

angular
    .module('totesApp')
    .provider('ramPermissionProvider', function () {
      var data;

      return {
        $get: function () {
          return data;
        },
        $set: function (value) {
          data = value;
        }
      };
    });

'use strict';

angular.module('totesApp')
    .directive('optionsDialog',['userOptions', function (userOptions) {
        return {

            scope: {},

            replace: true,

            templateUrl: 'scripts/directives/optionsDialog/optionsDialog.html',

            restrict: 'E',

            link: function (scope, $elem) {

                var $body = $('body');

                //scope, optionType, callback
                userOptions.subscribe(scope, function /*callback function when userOptions is broadcast*/(param) {

                    scope.$extend(param);

                    scope.action = function (actionId) {
                        closeDialog();
                        userOptions.done(actionId);
                    };


                    var carouselTimeout = setTimeout(function () {
                        $body.css('overflow', 'hidden');
                        $elem.show();
                        clearTimeout(carouselTimeout);
                    }, 20);

                    function closeDialog() {
                        $body.css('overflow', '');
                        $elem.hide();
                    }

                    $elem.delegate('.close', 'click', closeDialog);

                });
            }
        };
    }]);


/*optionDialog.listen( function( currentOptions ) {

 $.extend( scope, currentOptions );
 scope.ignoreCurrentOptions = optionDialog.ignoreCurrentOptions;

 scope.action = function( actionNumber ) {
 optionDialog.done( actionNumber );
 };

 setTimeout( function() {
 //$body.addClass('overflowHidden');
 $body.css( 'overflow', 'hidden' );
 //$elem.show();
 $overlay.show();
 }, 20 );
 } );

 $elem.delegate( '.close', 'click', function() {
 //$body.removeClass('overflowHidden');
 $body.css( 'overflow', '' );
 //$elem.hide();
 $overlay.hide();
 } );
 */
'use strict';

/**
 * @ngdoc directive
 * @name totesApp.directive:otherservices/otherservices
 * @description
 * # otherservices/otherservices
 */
angular.module('totesApp')
    .directive('otherservices', [function () {
      return {
        templateUrl: 'scripts/directives/otherservices/otherservices.html',
        scope: {
          myOtherServicesListFinal: '=list'
        },
        restrict: 'E',
        link: function postLink(scope, element, attrs) {

        }
      };
    }]);

'use strict';

angular.module('totesApp')
  .directive('pageHeadline', function () {
    return {
      restrict: 'EA',
      templateUrl: 'scripts/directives/pageHeadline/pageHeadline.html',
      link: function postLink(scope, element, attrs) {
      },
      controller: ['$scope',
        '$attrs',
        '$translate',
        'ute.blocks.language.switcher',
        function ($scope,
                  $attrs,
                  $translate,
                  languageSwitcher) {
          $scope.pageHeadline = {};

          var title = '';
          if ($translate.instant($attrs.text)) {
            title = $translate.instant($attrs.text);
          } else {
            title = '{missing resource}';
          }

          $scope.pageHeadline.text = title;

          languageSwitcher.registerOnDataChangeHandler(function (lang) {
            if ($translate.instant($attrs.text)) {
              title = $translate.instant($attrs.text);
            } else {
              title = '{missing resource}';
            }

            $scope.pageHeadline.text = title;
          }, 'pageHeadlineControllerLangSub');

          $scope.$on('$destroy', function () {
            languageSwitcher.unregisterOnDataChangeHandler('pageHeadlineControllerLangSub');
          });

        }]
    };
  });

'use strict';
/*
 the payment helper:
 Need help with payment options?   Review Payment FAQs >    Talk to us now with LiveChat >
 */
angular.module('totesApp').directive('paymentHelper', ['settings',
  'ute.blocks.language.switcher',
  function (settings,
            languageSwitcher) {

    return {
      scope: {},
      templateUrl: 'scripts/directives/paymentHelper/paymentHelper.html',
      replace: true,
      restrict: 'E',
      link: function (scope, element, attr) {
        languageSwitcher.registerOnDataChangeHandler(function (lang) {
          scope.lang = lang;
          update();
        }, 'paymentHelperLangSub');

        scope.$on('$destroy', function () {
          languageSwitcher.unregisterOnDataChangeHandler('paymentHelperLangSub');
        });

        function update() {
          var newValue = languageSwitcher.getCurrentLanguage();
          if (!newValue) {
            return false;
          }
          scope.reviewLink = settings.reviewLink.en + '/setLanguage=' + languageSwitcher.getCurrentLanguage();
        }

        scope.reviewLink = settings.reviewLink.en + '?setLanguage=' + languageSwitcher.getCurrentLanguage();
      },
      controller: ['$scope',
        function ($scope) {
          $scope.setStaticChatButtonValues = function () {
            if (languageSwitcher.getCurrentLanguage() === 'en') {
              $scope.boldChatButtonId = 'S_MRog_Payment';
              $scope.boldChatButtonDiv = 'payment-en';
              $scope.boldChatButton = 'chatButtonPayNowEn';
            } else {
              $scope.boldChatButtonId = 'S_MRog_Payment_Fr';
              $scope.boldChatButtonDiv = 'payment-fr';
              $scope.boldChatButton = 'chatButtonPayNowFr';
            }
          };
          $scope.setStaticChatButtonValues();


          $scope.$on('languageChanged', function () {
            $scope.setStaticChatButtonValues();
          });

        }]
    };
  }]);

/**
 * Created by Ming Tu on 26/05/2016.
 */

'use strict';

angular.module('totesApp')
  .directive('privateBrowsingWarning', ['$window', function ($window ) {
    return {
      replace: true,
      templateUrl: 'scripts/directives/privateBrowsing/privateBrowsingWarning.html',
      restrict: 'E',
      link: function ($scope, $elem, attr) {
        $scope.privateBrowsingOn = false;
        function init() {
          //step 1. check location is sign in page
          if ($window.location.href.endsWith('web/totes/') || $window.location.href.indexOf('signin') > 0) {
            //step 2. detect private browsing
            if (detectPrivateBrowsing()) {
              $scope.privateBrowsingOn = true;
            }
          }
        }

        /**
         * Detects whether private browsing is active or not
         * @return {Boolean}
         */
        function detectPrivateBrowsing() {
          var isPrivateBrowsing = false;
          if (window.localStorage && /Safari/i.test(window.navigator.userAgent)  && /Version/i.test(window.navigator.userAgent) && /Apple/i.test(window.navigator.vendor)) {
            var testKey = 'privateBrowsingTest';
            try {
              window.localStorage.setItem(testKey, 'test');
              window.localStorage.removeItem(testKey);
            } catch (e) {
              isPrivateBrowsing = true;
            }
          }

          return isPrivateBrowsing;
        }

        init();
      }
    };
  }]);

'use strict';

angular.module('totesApp').directive('registrationArea', function () {
  return {
    templateUrl: 'scripts/directives/registrationArea/registrationArea.html',
    replace: true,
    restrict: 'E'
  };
});

/**
 * Created by OlgaN on 4/29/2015.
 */
'use strict';

angular.module('totesApp')
  .directive('revolution',
  ['ute.common.security.service',
    'ute.datalayer.common.service',
    '$rootScope',
    '$modal',
    '$window',
    '$translate',
    'ajax',
    'appState',
    'util',
    'settings',
    '$http',
    'localStorage',
    '$filter',
    '$timeout',
    'backend',
    'user',
    'urlDevice',
    'myrRgclService',
    'myrRevolutionService',
    '$state',
    '$q',
    'sessionStorage',
    'myrMyServicesService',
    'ute.common.permissions.service',
    'ute.blocks.language.switcher',
    'urlValidator',
    function (commonSecurityService,
      dataLayerService,
      $rootScope,
      $modal,
      $window,
      $translate,
      ajax,
      appState,
      util,
      settings,
      $http,
      localStorage,
      $filter,
      $timeout,
      backend,
      user,
      urlDevice,
      rgclService,
      myrRevolutionService,
      $state,
      $q,
      sessionStorage,
      myrMyServicesService,
      permissionsService,
      languageSwitcher,
      urlValidator) {
      return {
        template: '<div data-ng-include="templatePath"></div>',

        restrict: 'E',

        scope: {
          openWirelesePackageModal: '&',
          unEnrollPackageModal: '&',
          openWirelessTravelPackageLegalContentModal: '&',
          travelPackageData: '=',
          hideWirelessTravelPackage: '=?',
          travelPackageDataHasPlan: '=?',
          isPageWirelessAttr: '@?'
        },

        controller: ['$scope', '$sce','ute.rogers.account.overview.factory',
          function ($scope, $sce, newAccountOverviewFactory) {


          $scope.templatePath = 'scripts/directives/revolution/revolution.html';

          permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ROAM_LIKE_HOME_IS_BRT).then(function (isPermitted) {
            if (isPermitted) {
              $scope.hideNewRLH = false;
              $scope.hideOldRLH = true;
            } else {
              $scope.hideNewRLH = true;
              $scope.hideOldRLH = false;
            }
          });
          var ErrorType = ute.datalayer.common.service.ErrorType;
          var ErrorCategory = ute.datalayer.common.service.ErrorCategory;

          window.analytics = {};
          window.analytics.makeFriendly = function (item) {
            var str = item.replace(/[^\x20-\x7E]/gmi, '').trim();         // remove all control chars, eg: "↵iPhone 5s↵↵"
            return decodeURIComponent(str).replace(/-|\+/g, ' ').toLowerCase();
          };
          window.analytics.getVirtualHierarchy = function (l) {
            var path = l.pathname;

            // shop pages, or pages that have "/consumer/" in the path
            if (path.lastIndexOf('/') == path.length - 1) path = path.substr(0, path.length - 1);     // band-aid: correct for path ending in "/" (Angular)

            var p = path.split('/');
            p.shift();
            // make friendly names
            for (var j = 0; j < p.length; j++) {
              p[j] = window.analytics.makeFriendly(p[j]);
            }
            if (p) {
              // if (p[0] === 'consumer') p[0] = 'shop';
              if (p[0] === 'consumer') p.shift();

              // hash
              if (l.hash) {
                if (l.hash.indexOf('#/') !== -1)
                  p.push(window.analytics.makeFriendly(l.hash.split('/')[1]));
                else
                  p.push(window.analytics.makeFriendly(l.hash.split('#')[1]));
              }

              return p;
            }

            return [];
          };
          window.analytics.getTimeStamp = function (is_UTC) {
            // format: "Friday|4/22/2016 7:05"

            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

            var dateObj = new Date();

            if (is_UTC) {
              var month = dateObj.getUTCMonth() + 1;
              var day = dateObj.getUTCDate();
              var year = dateObj.getUTCFullYear();
              var hour = dateObj.getUTCHours(); // 2
              var mins = dateObj.getUTCMinutes();

              hour -= 4;       // -2
              if (hour < 0) hour += 24;      // 22
            } else {
              var month = dateObj.getMonth() + 1;
              var day = dateObj.getDate();
              var year = dateObj.getFullYear();
              var hour = dateObj.getHours(); // 2
              var mins = dateObj.getMinutes();
            }

            return days[dateObj.getDay()] + '|' + month + '/' + day + '/' + year + ' ' + hour + ':' + (mins < 10 ? '0' : '') + mins;
          };
          window.analytics.onModal = function () {
            console.log('>> get modal data');

            var w = window;
            var d = document;

            var lang = (d.getElementsByTagName('html')[0].lang || d.cookie.split('language=')[1].split(';')[0]).toLowerCase();
            var prov = d.cookie.split('province=').slice(-1).pop();
            prov = (prov ? prov.split(';')[0] : '').toLowerCase();
            prov = (w.province && typeof w.province === 'string' ? w.province.toLowerCase() : '') || prov.toLowerCase();
            var mobl = (w.innerWidth < 768 ? 'mobile' : 'desktop');

            var loct = window.analytics.getTimeStamp();
            var icmt = window.analytics.getTimeStamp(true) || '';
            var hier = window.analytics.getVirtualHierarchy(d.location);
            var pgnm = '';

            var modalPageData = {   // destroy this on close
              'site': {
                'name': 'R'
              },
              'page': {
                'name': 'modal-' + pgnm,
                'hierarchy': hier,
                'language': lang,
                'province': prov,
                'url': 'modal popup',//d.location.href,
                'referrer': d.location.href,//d.referrer,
                'localTimestamp': loct,
                'ICMTimestamp': icmt,
                'responsiveVersion': mobl
              },
              'events': {
                'pageView': true
              }
            };

            dataLayerService.track(modalPageData);

          };

          if (angular.isUndefinedOrNull($scope.isPageWirelessAttr)) {
            $scope.isPageWireless = false;
          } else if ($scope.isPageWirelessAttr.toLowerCase() === 'true') {
            $scope.isPageWireless = true;
          } else {
            $scope.isPageWireless = false;
          }
          // Setting the default value to true
          $scope.hideWirelessTravelPackage = angular.isUndefinedOrNull($scope.hideWirelessTravelPackage) ? true : $scope.hideWirelessTravelPackage;
          // Setting the default value to false
          $scope.travelPackageDataHasPlanTemp = $scope.travelPackageDataHasPlan;
          $scope.travelPackageDataHasPlan = angular.isUndefinedOrNull($scope.travelPackageDataHasPlanTemp) ? true : $scope.travelPackageDataHasPlan;

          $scope.ban = null;
          $scope.oldBan = null;
          $scope.ctn = null;

          $scope.monthsNames = util.getMonthsNames();
          $scope.lang = languageSwitcher.getCurrentLanguage();
          $scope.loadingDataIndicatorRev = false;
          $scope.errorMessageR = null;
          $scope.tabs = false;
          $scope.loadingPage = true;
          $scope.hasBrtSwitch = false;

          $scope.hasRevSwitch = false; // localStorage.getLocalStorageValue('revpermission');

          $scope.shiftBigCols = 0;
          $scope.numberInnerCols = 4;
          $scope.numberRightCols = 4;
          $scope.shiftSmColsOut = 6;
          $scope.shiftSmColsInL = 6;
          $scope.shiftSmColsInR = 6;
          $scope.showMargin = false;
          $scope.disableRevButtons = $rootScope.isCare || $rootScope.isDealer;
          $scope.hideNewRLH = true;
          $scope.hideOldRLH = false;
          //$scope.globalOffers = {};
          //$scope.globalOffersData = {};
          $scope.allOffers = [];
          $scope.ineligibleUser = false;
          $scope.showRightLabel = false;
          $scope.unEnrollPermission = false;

          $scope.revolutionLink = 'https://' + $window.location.hostname + ((window.location.protocol === 'http' && window.location.port === '80') ||
          (window.location.protocol === 'https' && window.location.port === '443') ? '' : ':' + window.location.port) + settings.revolutionLink;

          $scope.isChooseYorExperienceVisible = false;
          // $scope.isNonSEPlus = false;

          $scope.months = {
            Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
            Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
          };

          $scope.leftHtmlTemplate = 'scripts/directives/revolution/revyouhave.html';
          $scope.isQA = $window.location.href.indexOf('www.qa') >= 0;

          $scope.spotifyph3 = false;

          permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.SPOTIFY_PH3).then(function (isPermitted) {
            $scope.spotifyph3 = isPermitted;
          });

          // BRT switch code for displaying netflix badge under more serviecs
          $scope.netflixBRT = false;
          $scope.isNetflixEligible = false;


          $scope.altText = $translate.instant('rgcl_alt_text');
          $scope.isDealer = $rootScope.isDealer;
          $scope.isCare = $rootScope.isCare;
          $scope.isConsumer = $rootScope.isConsumer;
          $scope.isRepView = $rootScope.isRepView;
          if ($scope.isDealer || $scope.isCare) {
            permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RoamLikeHome, ute.common.permissions.service.RamActionCodes.remove)
              .then(function (repPermission) {
                $scope.unEnrollPermission = repPermission;
              });
          }

          function processOffers(globalOffers, globalOffersData) {

            if ($scope.isPageWireless) {
              $scope.ctn = localStorage.getLocalStorageValue('phoneNumber');
            }

            $scope.allOffers = globalOffers.value[$scope.lang];

            mapOffers(globalOffersData);

            $scope.activeOffers = [];
            $scope.inactiveOffers = [];

            $scope.activeOffers = ($scope.isPageWireless) ?
              $filter('filter')($scope.allOffers, {id: 'spotify', active: true, inView: true})
              : $filter('filter')($scope.allOffers, {active: true, inView: true})
            ;
            $scope.inactiveOffers = ($scope.isPageWireless) ?
              $filter('filter')($scope.allOffers, {id: 'spotify', active: false, inView: true})
              : $filter('filter')($scope.allOffers, {active: false, inView: true})
            ;

            myrRevolutionService.setInactiveOffers($scope.inactiveOffers);
            myrRevolutionService.setActiveOffers($scope.activeOffers);

            /**
             * Create a new var for rgcl
             *
             * Add 1 to the active offer list count for rgcl
             */
            var activeOffersCount = $scope.activeOffers.length + 1;

            if (activeOffersCount > 2 && $scope.allOffers.length < 6) {
              $scope.showMargin = true;
            }

            if (activeOffersCount > 3) {
              $scope.shiftBigCols = 2;
              $scope.numberInnerCols = 3;
              $scope.numberRightCols = 5;
            }
            if ($scope.inactiveOffers.length > 3) {
              $scope.shiftBigCols = -2;
              $scope.numberInnerCols = 5;
              $scope.numberRightCols = 3;
            }

            //shiftSmCols
            switch (activeOffersCount) {
              case 4:
                $scope.shiftSmColsOut = 12; //0 -left column not shown
                $scope.shiftSmColsInL = 3; //0
                $scope.shiftSmColsInR = 0;
                break;
              case 3:
                $scope.shiftSmColsOut = 9; // 3
                $scope.shiftSmColsInL = 4; // 12
                $scope.shiftSmColsInR = 12;
                break;
              case 2:
                $scope.shiftSmColsOut = 6; //6
                $scope.shiftSmColsInL = 6; //6
                $scope.shiftSmColsInR = 6;
                break;
              case 1:
                $scope.shiftSmColsOut = 3; //9
                $scope.shiftSmColsInL = 12; //4
                $scope.shiftSmColsInR = 4;
                break;
              case 0:
                $scope.shiftSmColsOut = 0; //12 - right column not shown
                $scope.shiftSmColsInL = 12; //3
                $scope.shiftSmColsInR = 3;
                break;
              default:
                $scope.shiftSmColsOut = 6;
                $scope.shiftSmColsInL = 6;
            }

            if (activeOffersCount === 3) { ///fix for long spotify description
              $scope.numberRightCols = 5;
            }
            $scope.showRightLabel = $scope.inactiveOffers.length >= 3;

          }

          function mapOffers(globalOffersData) {
            for (var yy = 0; yy < $scope.allOffers.length; yy++) {
              var current = $scope.allOffers[yy];
              current.inView = true;

             /* if($scope.isSegment0() && current.id !== 'netflix'){
                current.inView = false;
              }*/

              var found;
              if (_.has(globalOffersData, 'value.valueAddedOffers')) {
                found = ($filter('filter')(globalOffersData.value.valueAddedOffers, {id: current.id}))[0];
              }
              if (!found) {
                current.inView = false;
                continue;
              }

              if (found.id === 'netflix') {
                if (!$scope.isNetflixEligible || !$scope.netflixBRT) {
                  current.inView = false;
                }
              }

              current.active = !found.canAvailAsOffer;
              current.isFree = (found.isFree && found.opted) || found.optedAsAnotherPromo;
              current.opted = found.opted;
              current.swappable = found.swappable;

              if (found.onAccount && current.isFree) {
                current.isFreeLabel = $scope.mapFreeLabel(found.onAccount);
              }

              if (found.swappable && found.swappableDate) {
                current.swappableDate = '(' + $translate.instant('revo_by') + ' ' + $scope.formatDate(found.swappableDate) + ')';
              }

              if (current.id === 'spotify' && current.active && !$scope.isPageWireless) {
                current.offerDetails[0].messageMap.buttonLabel = $translate.instant('revo_manage');
              }
              else if (current.id === 'spotify' && current.active && $scope.isPageWireless) {
                current.offerDetails[0].messageMap.buttonLabel = $scope.mapSpotifyButton(current, found);
              }

              if (current.active === false) {
                current.offerDetails[0].messageMap.buttonLabel = $translate.instant('revo_get_this');
              }

            }

            if (
              $state.current.name !== 'wireless' &&
              globalOffersData.value
            ) {
              $scope.isChooseYorExperienceVisible = globalOffersData.value.eligible;
            }

          }

          $scope.renderHTML = function (htmlCode) {
            var decoded = angular.element('<textarea />').html(htmlCode).text();
            return $sce.trustAsHtml(decoded);
          };

          $scope.mapSpotifyButton = function (currentObj, foundObj) {
            var result = currentObj.offerDetails[0].messageMap.buttonLabel;

            //v
            if ($scope.isPageWireless) {
              result = $translate.instant('revo_listen');
              currentObj.revSpUrl = true;
            }
            if (foundObj.ctns.length === 0) {
              return result;
            }
            var maxAll = foundObj.numberOfCtnsAllowed;
            var registered = [];
            //DBG
            //var ctnN = '9999999999';
            var ctnN = $scope.ctn;
            registered = $filter('filter')(foundObj.ctns, {registered: true});
            var registeredSelf = $filter('filter')(foundObj.ctns, {registered: true, ctn: ctnN})[0];
            var foundSelf = $filter('filter')(foundObj.ctns, {ctn: ctnN})[0];

            if (!registeredSelf) {  // not registered number
              if (registered.length >= maxAll || !foundSelf) { //hide widgit
                currentObj.inView = false;
              }
              else {
                result = $translate.instant('register_now');
                currentObj.revSpUrl = null;
              }
            }
            return result;
          };

          $scope.isSegment0 = function () {
            return rgclService.segmentNumber === '0';
          };

          $scope.mapFreeLabel = function (onaccount) {
            onaccount = onaccount.toLowerCase();

            var result = $translate.instant('revo_with_internet');
            if (onaccount === 'wireless') {
              result = $translate.instant('revo_with_wireless');
            }
            if (onaccount === 'cable') {
              result = $translate.instant('revo_with_cable');
            }
            return result;
          };

          $scope.formatDate = function (swappableDate) {
            var result = '';

            if (!swappableDate) {
              return result;
            }

            var dateString = swappableDate.substring(0, 10);
            var arrDate = dateString.split('-');

            if (!arrDate || arrDate.length < 3) {
              return result;
            }

            var mName = $scope.monthsNames[Number(arrDate[1]) - 1];

            if ($scope.lang === 'fr') {
              result = Number(arrDate[2]) + ' ' + $scope.monthsNames[Number(arrDate[1]) - 1] + ' ' + arrDate[0];
            }
            else {
              result = mName + ' ' + Number(arrDate[2]) + ', ' + arrDate[0];
            }
            return result;
          };

          function processOffersData(result) {
            var offersData = result.getOffers;
            $scope.globalOffers = result.revolutionLabels.data;
            $scope.globalOffersData = result.getOffers;

            $scope.wirelessimage = false;
            angular.forEach(myrMyServicesService.myServicesList, function (value) {
              if (value.serviceType === 'service_wireless') {
                if (value.serviceName === 'suspended') {
                  if (!$scope.wirelessimage) {
                    $scope.wirelessimage = false;
                  }
                } else {
                  $scope.wirelessimage = true;
                }
              }
            });

            if ($scope.wirelessimage) {

              $scope.disableRevButtons = false;
            }

            $scope.loadingDataIndicatorRev = false;

            if (offersData.status.errorCode === '11020') {
              return;
            }
            if (offersData.status.errorCode > 0) {
              $scope.errorMessageR = offersData.status.reason;
              return;
            }
            processOffers($scope.globalOffers, $scope.globalOffersData);
          }

          function loadOffersData() {

            permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.SPOTIFY_PH3).then(function (isPermitted) {

              //SPH3 Test
              // isPermitted = true;

              if (isPermitted) {

                $q.all({
                  revolutionLabels: $http.get('resource/revolutionLabels.json')
                }).then(function (result) {
                  //SPOTIFY3 - simulate offer-status with subscriptions to spotify and texture
                  result.getOffers = {
                    'status': {'errorCode': '0', 'reason': ''},
                    'value': {
                      'promoServiceStartDate': '2016-12-10 05:00:00',
                      'promoServiceEndDate': '2017-04-28 05:00:00',
                      'promoChangeDate': null,
                      'shomiDecommissionDate': '2016-11-30 00:00:00',
                      'eligible': true,
                      'showShomiMessages': false,
                      'unLocked': false,
                      'valueAddedOffers': [{
                        'isFree': false,
                        'opted': true,
                        'canAvailAsOffer': false,
                        'optedAsAnotherPromo': false,
                        'swappable': false,
                        'swappableDate': null,
                        'numberOfCtnsAllowed': 0,
                        'ctns': [],
                        'id': 'netflix',
                        'onAccount': 'wireless'
                      }]
                    }
                  };
                  processOffersData(result);
                }, function (error) {
                  $scope.loadingDataIndicatorRev = false;
                  $scope.errorMessageR = $translate.instant('50000');
                });

              } else {

                $scope.loadingDataIndicatorRev = true;

                $scope.ban = localStorage.getLocalStorageValue('accountNumber'); //$rootScope.ao.accountActive.accountNumber;

                var request = {ban: $scope.ban, 'includeNhl': settings.revolutionAddNhl};
                //var offersData =  ajax.getOffers(request).then(function (mappings) {
                if ($rootScope.isCare || $rootScope.isDealer) {
                  request = {ban: $scope.ban, 'includeNhl': settings.revolutionAddNhl, 'franchise': 'ROGERS'};
                }
                //var offersData = $http.get('resource/01.json').then(function (mappings) {
                $q.all({
                  // getOffers: backend.getOffers(request),
                  getOffers: myrRevolutionService.getRevolutionOffer(request),
                  revolutionLabels: $http.get('resource/revolutionLabels.json')
                }).then(function (result) {

                  processOffersData(result);

                }, function (error) {
                  $scope.loadingDataIndicatorRev = false;
                  $scope.errorMessageR = $translate.instant('50000');
                });
              }
            });
          }

          var errorModal = function () {
            var modalInstance = $modal.open({
              templateUrl: 'views/modals/netflixFail.html',
              windowClass: 'generic-message-modal',
              controller: ['$scope', function ($scope) {
                $scope.message = {
                  title: 'System Unavailable'
                };
                $scope.close = function () {
                  modalInstance.close();
                };
              }]
            });
          };

          function sendNetflixClickToAnalytics() {
            dataLayerService.track({
              'events': {
                'interaction': true
              },
              'interaction': {
                'type': 'click',
                'name': 'VAS - Netflix'
              }
            });

          }

          function sendNetflixErrorToAnalytics(error, API) {
            dataLayerService.trackError(
              error,
              ErrorType.HTTP,
              error.status,
              'Revolution Directive Error in Checking Netflix subscription',
              ErrorCategory.VAS,
              '',
              API,
              true,
              null
            );
          }

          function redirectWithToken() {
            $http({
              method: 'POST',
              url: commonSecurityService.getBackendUrl('v1/buyNetflix'),
              data: {
                accountNumber: $scope.netflixAccount.accountNumber
              }
            })
              .then(function (res) {
                $scope.loadingSpinIcon = false;
                var ptoken = res.data.content.ptoken;
                var lang = languageSwitcher.getCurrentLanguage() === 'en' ? 'en-CA' : 'fr-CA';
                var netflixURL = ptoken + '&locale=' + lang;
                if(urlValidator.validateURL(netflixURL)) {
                  $window.location.href = netflixURL;
                }
              }, function (error) {
                  $scope.loadingSpinIcon = false;
                  sendNetflixErrorToAnalytics(error, 'buyNetflix');
                  errorModal();
                }
              );
          }

          function processNetflix() {

            sendNetflixClickToAnalytics();

            $scope.loadingSpinIcon = true;

            var accountNumber = $scope.netflixAccount.accountNumber;



            $http.get(commonSecurityService.getBackendUrl( 'v1/') + accountNumber + '/netflixSubscription')
              .then(function (res) {

                $scope.loadingSpinIcon = false;

                if (res.data.content.netflixSubsciptionStatus === 'true') {
                  redirectWithToken();
                }

                else {

                  // Temporary disabling all new Netflix subscriptions in response to Fraud activities.
                  var modalInstance = $modal.open({
                    templateUrl: 'views/modals/terms-conditions.html',
                    size: 'thankYouDesign',
                    backdrop: 'static',
                    backdropClass: 'bkg-modal',
                    controller: ['$scope', '$http', function ($scope, $http) {
                      $scope.lang = languageSwitcher.getCurrentLanguage();
                      $scope.tnc = {
                        en: {
                          tnc: {
                            'heading': 'Important notice',
                            'content': 'We’re not accepting new Netflix subscriptions at the moment.<br>We plan on resuming this service at a later date, and we hope you check back later.<br>Thanks so much for your patience.'
                          }
                        },
                        fr: {
                          tnc: {
                            'heading': 'Avis important',
                            'content': 'Nous n’acceptons plus de nouveaux abonnements à Netflix pour le moment.<br>Nous prévoyons d’offrir ce service de nouveau à une date ultérieure. Nous vous invitons à réessayer plus tard.<br>Merci de votre patience.'
                          }
                        }
                      }
                      $scope.htmlString = $scope.lang === 'en' ? $scope.tnc.en.tnc.content : $scope.tnc.fr.tnc.content;

                      function closeModal() {
                        modalInstance.close();
                      }
                      $scope.ok = closeModal;
                      $scope.close = closeModal;
                    }]
                  });

                }
              }, function (error) {

                $scope.loadingSpinIcon = false;
                sendNetflixErrorToAnalytics(error, 'netflixSubscription');
                errorModal();
              });
          }

          $scope.loadingSpinIcon = false;

          $scope.startOffer = function (offer, revSpUrl) {

            if (offer == 'netflix') {
              processNetflix();
              return;
            }

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }

            var managable = ['nextissue', 'spotify'];

            if (managable.indexOf(offer) > -1 && !revSpUrl) {
              $window.location.href = $scope.revolutionLink;
              return;
            }

            var url = $scope.getExternalLink(offer);

            window.open(
              url,
              '_blank' // <- This is what makes it open in a new window.
            );

          };

          $scope.getOffer = function (offer) {

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }
            var obj = offer;

            $window.location.href = $scope.revolutionLink;
          };

          $scope.goToDetails = function (offer) {

            if (!user.isLoggedIn) {
              appState.switchView('signin');
              return;
            }
            var obj = offer;

            $window.location.href = $scope.revolutionLink;

          };

          $scope.changeSelection = function (offer) {
            $window.location.href = $scope.revolutionLink;
          };

          $scope.clearData = function () {
            $scope.activeOffers = [];
            $scope.inactiveOffers = [];
            $scope.loadingDataIndicatorRev = false;
            $scope.errorMessageR = null;
            $scope.ineligibleUser = false;
            $scope.revoStaticMessage = '';
            $rootScope.hasTPSApermission = false;
          };

          $scope.loadFullData = function () {

            var newBan = localStorage.getLocalStorageValue('accountNumber');
            var hasRevPermission;
            if (!$scope.isConsumer) {
              hasRevPermission = sessionStorage.getSessionStorageValue('RevPermission');
            } else {
              hasRevPermission = localStorage.getLocalStorageValue('RevPermission');
            }
            if (!hasRevPermission || hasRevPermission !== '1') {
              return;
            }

            var banType = localStorage.getLocalStorageValue('accountTypeNumber');
            // console.log(' $rootScope.ao.allAccounts : '+$rootScope.ao.allAccounts);
            // console.log(' newBan : '+newBan);

            if (!$rootScope.ao.allAccounts || !newBan) {
              console.log('Either $rootScope.ao.allAccounts or newBan is null');
              return;
            }
            var found = null;
            if ($rootScope.ao.allAccounts) {
              found = $filter('filter')($rootScope.ao.allAccounts, {accountNumber: newBan})[0];
            }

            if (!found || found.accountStatus !== 'Active' || banType !== '1') {
              if (found && found.accountStatus && (found.accountStatus === 'Suspended' || found.accountStatus === 'Cancelled')) {
                $scope.clearData();
              }
              return;
            }

            //if (($rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatusSimple !== 'Active') || banType !== '1') {
            //  return;
            //}

            //$scope.loadOffers();

            $scope.clearData();


            var newAccountOverviewService = newAccountOverviewFactory();

            $scope.isNetflixEligible = false;

            newAccountOverviewService.getSelectedAccount()
              .then(function(selectedAccount){

                if (selectedAccount.accountTypeNumber === 1 && selectedAccount.accountStatus === 'Active' && selectedAccount.accountType === 'Consumer' && selectedAccount.accountSubType === 'Regular') {
                  $scope.netflixAccount = {accountNumber: selectedAccount.accountNumber, accountTypeNumber: selectedAccount.accountTypeNumber, accountStatus: selectedAccount.accountStatus};
                  $scope.isNetflixEligible = true;
                }

                return selectedAccount;

              })
              .then(function(selectedAccount){

                if (!$scope.isNetflixEligible) {
                  return;
                }

                return selectedAccount.getAccountOverviewSummary().then(function (data) {
                  var ctnSub =  $filter('filter')(data.subList, {'subType': 'CTN',
                    'subStatus': 'Active'}, true)[0];
                  if (ctnSub && ctnSub !== null ) {
                    $scope.isNetflixEligible = true;
                  }
                  else{
                    $scope.isNetflixEligible = false;
                  }
                });
              })
              .then(function(){
                  return permissionsService.getUserPermission('NETFLIX_BOBO')
                  .then(function (isPermitted){
                    $scope.netflixBRT = isPermitted;
                  });
              })
              .catch(function() {
                  $scope.isNetflixEligible = false;
              })
              .then(function(){
                loadOffersData();
              });



            //$timeout(function () {
            //  $scope.hasBrtSwitch = $rootScope.revpermission;
            //  $scope.loadingDataIndicatorRev = true;
            //  var request = {};
            //  var permissionsData = ajax.getPermissions().then(function (result) {
            //    // var permissionsData =  backend.getRevPermissions().then(function (result) {
            //
            //    var permissionRev = ($filter('filter')(result.permissions, {permission: 'TPSA_PAGE_VIEW'}));
            //    $scope.loadingDataIndicatorRev = false;
            //    //DBG
            //    if (permissionRev && permissionRev.length > 0) {
            //      $rootScope.hasTPSApermission = true;
            //      $scope.loadOffersData();
            //      return;
            //    }
            //    $rootScope.hasTPSApermission = false;
            //  }, function (error) {
            //    $rootScope.hasTPSApermission = false;
            //    $scope.loadingDataIndicatorRev = false;
            //    $scope.errorMessageR = $translate.instant('50000');
            //
            //    return;
            //  });
            //
            //});

          };

          $scope.getExternalLink = function (id) {

            var output = '';

            var doCheck = urlDevice.checkPhone();

            var friendlyUrl = urlDevice.findUrl();

            output = friendlyUrl[id][$scope.lang];

            //if (id === 'spotify') {
            //  output = $scope.isQA ? settings.revolutionExternalLinks.spotify[$scope.lang].qa : settings.revolutionExternalLinks.spotify[$scope.lang].prod;
            //}
            //if (id === 'nextissue') {
            //  output = $scope.isQA ? settings.revolutionExternalLinks.nextissue[$scope.lang].qa : settings.revolutionExternalLinks.nextissue[$scope.lang].prod;
            //}

            return output;
          };

          //$scope.loadFullData();

          // if ($scope.isPageWireless) {
          $scope.loadFullData();
          //}

          languageSwitcher.registerOnDataChangeHandler(function (lang) {
            $scope.monthsNames = util.getMonthsNames();
            $scope.altText = $translate.instant('rgcl_alt_text');
            if ($scope.lang !== lang) {
              $scope.lang = lang;
              processOffers($scope.globalOffers, $scope.globalOffersData);
            }
          }, 'revolutionControllerLangSub');

          $scope.$on('$destroy', function () {
            languageSwitcher.unregisterOnDataChangeHandler('revolutionControllerLangSub');
          });

          $scope.$on('ctnHasBeenChanged', function (event, obj) {
            if ($scope.globalOffers && $scope.globalOffersData) {
              processOffers($scope.globalOffers, $scope.globalOffersData);
            }
          });

          $scope.$on('startChangeAccount', function (event, obj) {
            // $scope.clearData();
          });

          $scope.$on('gotPermissions', function (event, obj) {
            $scope.loadFullData();
          });

          $scope.$on('changedAccount', function (event, obj) {
            var newBan = localStorage.getLocalStorageValue('accountNumber');
            if (!newBan || newBan === $scope.ban) {
              return;
            }
            $scope.ban = newBan;
            $scope.loadFullData();
          });

          /*$scope.isUnEnrollPermission = function () {
           if ($rootScope.isDealer || $rootScope.isCare) {
            permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RoamLikeHome, ute.common.permissions.service.RamActionCodes.remove)
            .then(function (repPermission) {
              console.log('revolution.js repPermission' + repPermission);
              $scope.unEnrollPermission = true;
              });
           }
          };*/
          /**
           * MR-6214 - RLH and Fido Roam - Bug Fix and Removal of Cuba from country list
           */
          $scope.openWirelessTravelPackageLegalContentModalLocal = function () {
            var modalContent = $translate.instant('revo_modal_content');
            this.openWirelessTravelPackageLegalContentModal({ev: modalContent});
          };

          $rootScope.$on('setTravelPackageDataHasPlan', function (data) {
            $scope.travelPackageDataHasPlan = true;
          });

          $rootScope.$on('unSetTravelPackageDataHasPlan', function (data) {
            $scope.travelPackageDataHasPlan = false;
          });
        }]
      };
    }]);

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountBalanceService
   * @description
   * # myrAccountBalanceService
   */
  angular.module('totesApp').factory('myrRevolutionService', revolutionService);

  revolutionService.$inject = ['$filter', '$q', 'ute.rogers.revolution.data.offer.factory'];

  function revolutionService($filter, $q, revolutionOfferFactory) {

    var activeOffers = [];
    var inactiveOffers = [];

    var revolutionOfferService;

    var service = {
      getActiveOffers: getActiveOffers,
      setActiveOffers: setActiveOffers,
      getInactiveOffers: getInactiveOffers,
      setInactiveOffers: setInactiveOffers,
      getRevolutionOffer: _getRevolutionOffer
    };

    return service;

    ///////////////////////////////////////////////////////////////

    function setActiveOffers(_ary) {
      activeOffers = _ary;
    }

    function getActiveOffers() {
      return activeOffers;
    }

    function setInactiveOffers(_ary) {
      inactiveOffers = _ary;
    }

    function getInactiveOffers() {
      return inactiveOffers;
    }

    function _getRevolutionOffer(request) {

      revolutionOfferService = revolutionOfferFactory(request);
      var deferred = $q.defer();

      revolutionOfferService.getRevolutionOffer()
          .then(function (offer) {
            deferred.resolve(offer);
          })
          .catch(function (reason) {
            console.log('myrRevolutionService->getRevolutionOffer->catch:', reason);
            deferred.reject(reason);
          });

      return deferred.promise;
    }

  }

}());

/**
 * Created by OlgaN on 5/13/2015.
 */

'use strict';

angular.module('totesApp')
    .directive('revyouhave', ['$rootScope', 'btnSettings', '$window', function ($rootScope, btnSettings, $window) {
      return {
        templateUrl: 'scripts/directives/revolution/revyouhave.html',

        restrict: 'E'

      };
    }]);

(function () {
    'use strict';

    angular.module('totesApp').factory('urlValidator', urlValidator);
    urlValidator.$inject = ['$location', 'settings'];
    function urlValidator($location, settings) {
       var service = {
          validateURL: validateURL,
          parseURL: parseURL
       };

       return service;

       function validateURL(responseURL) {
          var responseHostname = parseURL(responseURL);
          var permittedDomains = settings.permittedDomains;
          console.log("responseHostname :: ",responseHostname);
          console.log("permittedDomains :: ",permittedDomains);
          var hostName = "";
          if (responseHostname.indexOf('www.') === 0) {
              hostName = responseHostname.replace('www.','');
          }
          console.log("responseDomain :: ",hostName);
          if (permittedDomains.indexOf(hostName) > -1) {
            return true;
          }
          else {
            return false;
          }
       }

       function parseURL(url){
           var a = document.createElement('a');
           a.href = url;
           return a.hostname;
       }
    }

})();

'use strict';
angular.module('totesApp').directive('ruiDropdown', [
  '$rootScope',
  '$translate',
  '$filter',
  ruiDropdownDirective]);

function ruiDropdownDirective($rootScope,
                              $translate,
                              $filter) {
  return {
    restrict: 'EA',
    require: '?ngModel',
    templateUrl: 'scripts/directives/ruiDropdown/ruiDropdown.html',
    scope: {
      placeholder: '@',
      list: '=',
      selected: '=',
      selectAction: '&',
      property: '@',
      additional: '@',
      prefix: '@',
      useres: '@',
      filter: '@',
      listenForLanguageChange: '@'
    },
    link: function (scope, element, attrs, ngModel) {
      scope.listVisible = false;
      scope.isPlaceholder = true;
      scope.element = element;

      scope.select = function (item) {
        scope.isPlaceholder = false;
        if (scope.useres === 'true') {
          scope.selected = $translate.instant(item.name);
        } else {
          scope.selected = item;
        }
        scope.selectAction({item: item});
        scope.hide();
      };

      scope.isSelected = function (item) {
        if (scope.useres && scope.selected) {
          return $translate.instant(item[scope.property]) === scope.selected;
        } else if (scope.selected) {
          return item[scope.property] === scope.selected[scope.property];
        } else {
          return false;
        }
      };

      scope.toggle = function () {
        scope.listVisible = !scope.listVisible;
        scope.$root.$broadcast('closeDropdown', scope.$id);
      };

      scope.hide = function () {
        scope.listVisible = false;
      };

      var cleanUpFunc = $rootScope.$on('documentClicked', function (inner, target) {
        if (!$(target[0]).is(".fa.fa-angle-down") && !$(target[0]).is('.dropdown-display.clicked') && !$(target[0]).parents('.dropdown-display.clicked').length > 0) {
          scope.listVisible = false;
        }
      });

      scope.$on('$destroy', function() {
        cleanUpFunc();
      });

      scope.$on('closeDropdown', function (event, id) {
        if (scope.$id !== id) {
          scope.hide();
        }
      });

      scope.$on('schemaFormValidate', function () {
        scope.validateDropdown();
      });

      scope.validateDropdown = function () {
        if (scope.selected.value === '?') {
          scope.element.addClass('ng-invalid-province-select ng-invalid ng-dirty').removeClass('ng-valid-province-select ng-valid');
        } else {
          scope.element.addClass('ng-valid-province-select ng-valid ng-dirty').removeClass('ng-invalid-province-select ng-invalid');
        }
      };

      scope.getValue = function (item, property) {
        return (property !== undefined ? item[property] : item);
      };

      scope.useFilter = function (name, value) {
        return $filter(name)(value);
      };

      var scopewatch1 = scope.$watch('selected', function (value) {
        scope.isPlaceholder = scope.selected === '' && scope.selected[scope.property] === undefined;

        if (!$.isEmptyObject(value)) {
          if (ngModel) {
            if (scope.element.hasClass('ng-dirty')) {
              scope.validateDropdown();
            }
          }

          if (scope.useres === 'true') {
            scope.display = scope.selected;
          } else {
            scope.display = (scope.prefix ? scope.prefix : '') +
              scope.selected[scope.property] +
              (scope.additional && !!scope.selected[scope.additional] ? scope.selected[scope.additional] : '');
          }
        }
      });

      //n Remove any watchers 
      scope.$on('$destroy', function () {
        scopewatch1();
      });

    }
  };
}

'use strict';


angular.module('totesApp')
	.directive('termsConditions', function () {
		return {
			restrict: 'E',
			templateUrl: 'scripts/directives/termsConditions/termsConditions.html',
			link: function ( $scope/*, element, attrs*/) {
                $scope.$extend ({
                    isAccepted: false
                });
			}
		};
	});

'use strict';


angular.module('totesApp')
  .directive('trimOnPaste', ['$timeout', '$window', function ($timeout, $window) {
    return {
      restrict: 'EA',
      scope: {
        trimEnd: '@topTrimEnd',
        trimStart: '@topTrimStart',
        trimAll: '@topTrimAll',
        value: '=topPropertyToTrim'
      },
      template: '',
      link: function (scope, element) {
        var newPastedDataTimer;
        element.on('paste', function (e) {
          var pastedData = undefined;
          var cd = e.clipboardData || (e.originalEvent) ? e.originalEvent.clipboardData : undefined;
          if (cd && cd.getData) {
            pastedData = cd.getData('text/plain');
          }
          else if ($window.clipboardData && clipboardData.getData) {
            pastedData = $window.clipboardData.getData('text');
          }

          if (pastedData && pastedData.length > 0) {
            var newPastedData = !angular.isString(pastedData) ? '' : trim(scope, pastedData);
            if (pastedData !== newPastedData) {
              e.preventDefault();
              newPastedDataTimer = $timeout(function () {
                scope.value = newPastedData;
              }, 0);
            }
          }
        });

        scope.$on("$destroy",function( event ) {
            $timeout.cancel(newPastedDataTimer);
        });
      }
    };

    function trim(scope, pastedData) {
      if (scope.trimAll) {
        return pastedData.replace(/\s+|\s+/g, '');
      }
      else if (scope.trimEnd && scope.trimStart) {
        return pastedData.replace(/^\s+|\s+$/g, '');
      }
      else if (scope.trimEnd) {
        return pastedData.replace(/\s+|\s+$/g, '');
      }
      else if (scope.trimStart) {
        return pastedData.replace(/^\s+|\s+/g, '');
      }
    }
  }]);

'use strict';

angular
	.module('totesApp')
	.directive('validationErrorBox', function () {
			return {
				scope: {
					errorMessage: '=',
          liveChatParams: '='
				},
				templateUrl: 'scripts/directives/validationErrorBox/validationErrorBox.html',
				replace: true,
				restrict: 'E',
				link: function (scope, element, attrs, $sce) {}
			};
		});

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('deepLinkModalCtrl', deepLinkModalCtrl);

  deepLinkModalCtrl.$inject = ['$rootScope', '$modalInstance', 'ajax', 'settings', 'backToSSPService', 'ute.common.user.service'];

  function deepLinkModalCtrl($rootScope, $modalInstance, ajax, settings, backToSSPService, userService) {
    var dlController = this;

    dlController.setShowMessage = function (checkedStatus) {
      dlController.dontShowGoToSSPMsgAgain = !!checkedStatus;
    };

    dlController.close = function () {
      if (dlController.dontShowGoToSSPMsgAgain) {
        var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
        var userType = userService.getUserType();
        var userPreferenceName = 'displayMovingToSSPPopUp';
        var userPreferenceValue = false;
        ajax.updateUserPreference(userId, userType, userPreferenceName, userPreferenceValue).then(
          function (data) {
            console.log('updateUserPreference data');
          }, function (error) {
            console.log('updateUserPreference error');
          }
        );
      }
      backToSSPService.backToSSP();
      $modalInstance.dismiss('cancel');
    };

    dlController.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    dlController.toggleTooltip = function () {
      dlController.showMoreOptions = !dlController.showMoreOptions;
    };

    dlController.redirectToRogersGeoAuth = function (link) {
      window.open(link,'_blank');
    };

    function init() {
      dlController.isChangePhoneNumber = false;
      dlController.isChangePlan = false;
      dlController.isChangeSim = false;
      dlController.isManageAddon = false;
      dlController.isChangeVoicemailPassword = false;
      dlController.isAddaLineIndividual = false;
      dlController.isAddaLineShared = false;
      dlController.isUpgradeDevice = false;
      dlController.isHupCancellation = false;
      dlController.dontShowGoToSSPMsgAgain = false;
      dlController.showMoreOptions = false;

      if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changeCTN) {
        dlController.isChangePhoneNumber = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changeSIM) {
        dlController.isChangeSim = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.changePricePlan) {
        dlController.isChangePlan = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.updateVoiceMailPassword) {
        dlController.isChangeVoicemailPassword = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.upgradeDevice) {
        dlController.isUpgradeDevice = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.addaLineIndividual) {
        dlController.isAddaLineIndividual = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.addaLineShared) {
        dlController.isAddaLineShared = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.hupCancellation) {
        dlController.isHupCancellation = true;
      } else if ($rootScope.targetFlow === settings.deepLinkStatusCodes.getWireless) {
        dlController.isGetWireless = true;
      } else {
        dlController.isManageAddon = true;
      }
    }

    init();
  }
})();

// jscs:disable requireCamelCaseOrUpperCaseIdentifiers
/* jshint -W106 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('WirelessPackageController', WirelessPackageController);

  WirelessPackageController.$inject = ['$scope',
    '$rootScope',
    '$filter',
    'appState',
    'settings',
    '$modal',
    '$translate',
    '$location',
    '$sce',
    'ajax',
    '$q',
    '$window',
    'ngDialog',
    '$state',
    'util',
    'myrMyServicesService',
    'bfappcWirelessDashboardService',
    'backToSSPService',
    'ute.dtm.service',
    'ute.common.permissions.service',
    'ute.common.suspend.ctn.service',
    'ute.common.reactivate.ctn.service',
    'ute.common.core.brtswitch.service',
    'my.rogers.simcard.change.utils.service',
    'ute.common.user.service',
    'ute.common.simcard.change.service',
    'ute.data.manager.service',
    'ute.data.manager.see.service',
    'ute.blocks.language.switcher',
    'myrAccountBalanceDataFactory',
    'myrWirelessDashboardService',
    'ute.common.core.caching.CacheableDataFactory',
    'ute.capture.dealer.code.service',
    'myrRevolutionService',
    '$anchorScroll',
    'cookieStore',
    'ute.blocks.persistent.storage.service',
    'cartMenuService',
    'localStorage',
    'sessionStorage',
    'ute.rogers.hero.modal.service',
    'myrAccountOverviewService',
    '$http',
     'ute.blocks.environment',
    'ssoService',
    'ute.datalayer.common.service','$browser'];

  /* @ngInject */
  function WirelessPackageController($scope,
                                     $rootScope,
                                     $filter,
                                     appState,
                                     settings,
                                     $modal,
                                     $translate,
                                     $location,
                                     $sce,
                                     ajax,
                                     $q,
                                     $window,
                                     ngDialog,
                                     $state,
                                     util,
                                     myrServicesService,
                                     bfappcWirelessDashboardService,
                                     backToSSPService,
                                     dtmService,
                                     permissionsService,
                                     suspendCtnService,
                                     reactivateCtnService,
                                     brtSwitchService,
                                     simcardChangeUtilsService,
                                     userService,
                                     simcardChangeService,
                                     dataManagerService,
                                     dataManagerSeeService,
                                     languageSwitcher,
                                     myrAccountBalanceDataFactory,
                                     wirelessDashboardService,
                                     cacheableData,
                                     captureDealerCodeService,
                                     myrRevolutionService,
                                     $anchorScroll,
                                     cookieStore,
                                     utePersistentStorageService,
                                     cartMenuService,
                                     localStorage,
                                     sessionStorage,
                                     RogersHeroModalService,
                                     accountOverviewService,
                                     $http,
                                     environmentProvider,
                                     ssoService,
                                     dataLayerService,
                                     $browser
                                     ) {

    var wpController = this,
      dtmBuyFlowError,
      holder,
      request,
      wirelessDashPopup,
      wpkg_rawData,
      disableMakePayment,
      wpkg_clientBkp,
      hasDSGAccess,
      hasDCAccess,
      repMakePaymentAccess,
      currentPlan,
      planSoc,
      isBOTEligible,
      isCaseClosed,
      hupDetails,
      openCase,
      seeBrtShowState,
      spotifyModel = [],
      showToolTip = false,
      theSpotifyPromise;

    var heroOfferSelected;
    var hupHeroOfferSelected;
    var hupTvmHeroOfferSelected;
    var heroResponse;
    var heroRedirectUrl;

    var voiceMailSOCCodes = ['OPTSIA06L', 'OPTSIA06C', 'OPTSIA06D', 'OPTSIA06E', 'OPTSIA06F', 'OPTSIA06G',
      'OPTSIA06H', 'OPTSIA06I', 'OPTSIA06J', 'OPTSIA06K', 'OPTSIA06L', 'OPTSIA06M', 'OPTSIA06N', 'OPTSIA06O',
      'OPTSIA06P', 'OPTSIA06Q', 'OPTSIA06R', 'OPTSIA06S', 'OPTSIA06T', 'OPTSIA06U', 'OPTSIA06V', 'OPTSIA06W'];

    wpController.isUFA = false;

    wpController.deviceInfoModal = {
      wp: '',
      balanceObj: '',
      balance: '',
      sim: '',
      finance: '',
      isUpFrontRvAmount: false
    };

    wpController.rvCustomerModalInfo = {
      rvCustomer: false,
      templateHtml: '',
      shareEverything: ''
    };

    wpController.rvCustomer = false;

    wpController.planInfoModal = {
      wp: '',
      getDiscountRate: wpController.getDiscountRate,
      startDate: ''
    };

    wpController.getCurrentState = function () {
      return $state.current.name;
    };

    wpController.hasPropertyValue = function (propertyValue) {
      return (propertyValue && propertyValue.length !== 0);
    };

    wpController.redirectToNrs = function () {
      $window.location.href = '/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice&sourceNRS=NRS_MS';
    };

    // Info Modal Paths
    wpController.infoModalPaths = [
      'scripts/modules/wirelessDashboard/partials/deviceDetailsModal.html',
      'scripts/modules/wirelessDashboard/partials/planDetailsModal.html',
      'scripts/modules/wirelessDashboard/partials/financedDeviceDetailsModal.html'
    ];

    //upfrontAdvantage details
    wpController.upfrontAdvantageDetails = 'scripts/modules/wirelessDashboard/partials/upfrontAdvantageDetails.html';

    wpController.scrollToSection = function (hash) {
      $location.hash(hash);
      $anchorScroll.yOffset = 65;
      $anchorScroll();
    };

    // BPO/Exclusive offer banner enable flag for PPC / HUP nav links
    wpController.exclusiveOfferPresent = true;

    wpController.wirelessDashboardCall = function () {
      if (wpController.isShareEverything()) {
        var displayDataUsage = false;
        var disableAllUsage = false;
        if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
          wpController.permissionsObj.permissions.length !== 0 &&
          _.find(wpController.permissionsObj.permissions, { 'permission': 'ROGERS_DISPLAY_DATA_USAGE' })) {
          displayDataUsage = true;
        }
        if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
          wpController.permissionsObj.permissions.length !== 0 &&
          _.find(wpController.permissionsObj.permissions, { 'permission': 'ROGERS_DISABLE_ALL_USAGE' })) {
          disableAllUsage = true;
        }
        //in case both - disable_all and display_data permission is true, making display_data = false
        if (displayDataUsage && disableAllUsage) {
          displayDataUsage = false;
        }
        if (!disableAllUsage && !displayDataUsage) {
        } else if (disableAllUsage || (!disableAllUsage && displayDataUsage)) {
          wirelessDashboardService.setWirelessDashboardTalkAndTextFDM(true);
        }
      }
    }

    wpController.isRefreshedDial = function () {
      if (wpController.isShareEverything()) {
        return true;
      } else {
        var displayDataUsage = false;
        var disableAllUsage = false;
        if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
          wpController.permissionsObj.permissions.length !== 0 &&
          _.find(wpController.permissionsObj.permissions, { 'permission': 'ROGERS_DISPLAY_DATA_USAGE' })) {
          displayDataUsage = true;
        }
        if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
          wpController.permissionsObj.permissions.length !== 0 &&
          _.find(wpController.permissionsObj.permissions, { 'permission': 'ROGERS_DISABLE_ALL_USAGE' })) {
          disableAllUsage = true;
        }
        if (!displayDataUsage && !disableAllUsage) {
          return true;
        } else if (!$rootScope.dialUsageRefreshEnable && disableAllUsage) {
          return false;
        } else
          return $rootScope.dialUsageRefreshEnable;
      }
    }

    //to toggle discounts div and rotate the icon up and down to denote expansion and collapse (ove-21)

    wpController.toggleDiscountsAndAddonsSection = function (section) {
      if (section === 'discount') {
        if (!$('.wd-card-discount-table').hasClass('wd-card-section-toggle')) {
          $('.wd-card-discount-table').addClass('wd-card-section-toggle');
          $('.disc-toggle-icon').css('transform', 'rotate(180deg)');
        } else if ($('.wd-card-discount-table').hasClass('wd-card-section-toggle')) {
          $('.wd-card-discount-table').removeClass('wd-card-section-toggle');
          $('.disc-toggle-icon').css('transform', 'rotate(0deg)');
        }
      } else if (section === 'addon') {
        if (!$('.wd-card-addon-table').hasClass('wd-card-section-toggle')) {
          $('.wd-card-addon-table').addClass('wd-card-section-toggle');
          $('.addon-toggle-icon').css('transform', 'rotate(180deg)');
        } else if ($('.wd-card-addon-table').hasClass('wd-card-section-toggle')) {
          $('.wd-card-addon-table').removeClass('wd-card-section-toggle');
          $('.addon-toggle-icon').css('transform', 'rotate(0deg)');
        }
      }
    }

    //DC-1286
    //comparing cms socs with addons socs
    function getRvCustomerSoc(productList) {
      wpController.rvCustomer = false;
      var rvCustomer = false;
      var addonsSoc = [];
      if (productList && productList.length > 0) {
        _.forEach(productList, function (product) {
          if (product.productCode) {
            addonsSoc.push(product.productCode);
          }
        });
      }
      if (addonsSoc.length > 0) {
        var rvCustomerSoc;
        $http.get('/web/totes/cms/content/json/airstream/soc_list.json').then(
          function (res) {
            if (_.get(res, 'data.socList', []).length) {
              rvCustomerSoc = res.data.socList;
              var matchedSoc = false;
              matchedSoc = rvCustomerSoc.filter(function (item) {
                return addonsSoc.indexOf(item) > -1;
              });
              if (matchedSoc && matchedSoc.length > 0) {
                wpController.rvCustomer = true;
                if (wpController.rvCustomer) {
                  wpController.rvCustomerModalInfo = {
                    rvCustomer: wpController.rvCustomer,
                    templateHtml: wpController.upfrontAdvantageDetails,
                    shareEverything: wpController.isShareEverything()
                  };
                } else {
                  checkWarning();
                }
              } else {
                checkWarning();
              }
            } else {
              checkWarning();
            }
          }, function (errorRes) {
            wpController.rvCustomer = false;
            checkWarning();
          });
      }
    }
    // Repair link modernization changes:: DC-1672
    wpController.continueToRepairModal = function() {
      const payload = {
        applicationId: 'UTEMyRogers',
        agentType: "End User",
        locale: languageSwitcher.getCurrentLanguage() === 'en' ? 'EN-CA': 'FR-CA',
        userRole: "Customer",
        userId: userService.getUser().userEmail,  
        userName: localStorage.getLocalStorageValue('fullName'),
        accountNumber: wpController.ban,
        subscriberNumber: wpController.ctn,
      };

      const analyticsPL = {
        BAN: payload.accountNumber,
        CTN: payload.subscriberNumber,
        userId: payload.userId
       }

      ssoService.fetchSSOToken(payload).then(function(response) {        
        const token = response;        
        var modalInstanceT = $modal.open({
          templateUrl: 'views/track-repair-modal.html',
          windowClass: 'generic-message-modal',
          controller: ['$scope', function ($scope) {
            trackAnalytics(analyticsPL, '');
            $scope.close = function () {
              modalInstanceT.close();
            };
            $scope.startPhoneRepairClaim = function(){
              document.getElementById('TOKEN').value = token;
              document.getElementById('formForTrackPhoneRepair').action = environmentProvider.getProperty('brightstarServiceUrl')
              document.getElementById('formForTrackPhoneRepair').submit();
              const interaction = {
                type: 'click',
                name: 'Redirect to Brightstar'
              }
              trackAnalytics(analyticsPL, interaction);
              modalInstanceT.close();            
            }
          }]
        });
      }).catch(function(error) {
        var modalInstance = $modal.open({
          templateUrl: 'views/modals/generalErrorDialog.html',
          windowClass: 'verify-address-modal',
          controller: ['$scope', function ($scope) {            
            trackErrorAnalytics(analyticsPL, error);    
            $scope.errorTitle = $translate.instant('OOPS');
            $scope.close = function () {
              modalInstance.close();
            };
          }]
        });        
      })
    }

    function trackAnalytics(payload, interaction) {
      const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
      const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
      const pageView = interaction === '' ? true : false;
      const trackPayload = constructADLPayload(payload, pageView, interaction, true);
      dataLayerService.track(trackPayload, true, selectedSections);
    }

    function trackErrorAnalytics(payload, error) {
      const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
      const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
      const errorType = window.ute.datalayer.common.service.ErrorType;
      const errorCategory = window.ute.datalayer.common.service.ErrorCategory;
      const data = error.data;    
      const errorApi = error.config.api;
      const errPayload = constructADLPayload(payload, false, '', false);
      errPayload.events = { pageView: true, error: true };

     if (_.has(data, 'status.code')) {
        dataLayerService.trackError(errPayload, errorType.HTTP, data.status.code, data.status.codeName, errorCategory.SELF_SERVE, '', errorApi, true,selectedSections);
      } else {
        if (error.status === 404 && error.statusText === '') {
          error.statusText = 'API Not found';
        }
        dataLayerService.trackError(errPayload, errorType.HTTP, error.status, error.statusText, errorCategory.SELF_SERVE, '', errorApi, true, selectedSections);
      }
    }

    function constructADLPayload(tpayload, pageView, interaction, success) {     
      const payload = {
        account: { BAN: tpayload.BAN, CTN: tpayload.CTN, userType: 'Consumer', userName: tpayload.userId },
        page: {
          name: success ? 'continue to repair portal' : 'system error modal',
          hierarchy: !wpController.isShareEverything() ? ['myrogers',  'wireless'] :
            ['myrogers',  'shareeverything', 'dashboard', 'share everything dashboard'],
          language: languageSwitcher.getCurrentLanguage(),
          province: $browser.cookies().province,
          url: 'modal popup',
          Referer: location.href
        },
        user: {
          loginStatus: userService.isSigned()
        },
        site: {
          name: 'R'
        }
      };

      if (pageView) {
        payload.events = {
          pageView: true
        };
      }
      if (interaction) {
        payload.interaction = interaction;
        payload.events = {
          interaction: true
        }
      }
      return payload;
    }

    wpController.refresh = function () {
      wirelessDashboardService.clearWirelessDashBoard();
      wpController.showBalanceSection = true;
      wpController.ctn = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)).toString();

      console.log('wpController.wirelessDashActive.ctn - ' + wpController.wirelessDashActive.ctn)
      if (wpController.targetedHeroOfferMap && wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn]) {
        if (wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].hupOffer != null
          || wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].hup4BPO != null)
          wpController.hasTargetedHupOffer = true;

        if (wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].tvmOffer != null
          || wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].tvmBPO != null)
          wpController.hasTargetedTvmOffer = true;
      }

      request = {
        ctn: wpController.ctn,
        ban: wpController.ban,
        language: wpController.lng,
        applicationId: 'Rogers.com'
      };
      wirelessDashboardService.getWirelessTravelPackage(request, function (_tmp) {
        if (_tmp.result === 'success') {
          if (_tmp.data.evolutionEligibleFlag) {
            wpController.hideWirelessTravelPackage = false;
            //_tmp.data.evolutionOptInOutFlag ? ($scope.travelPackageDataHasPlan = true) : ($scope.travelPackageDataHasPlan = false) ;
            wpController.travelPackageDataHasPlan = _tmp.data.evolutionOptInOutFlag;
            if (wpController.travelPackageDataHasPlan) {
              console.log('calling setTravelPackageDataHasPlan');
              $rootScope.$broadcast('setTravelPackageDataHasPlan');
            } else {
              console.log('calling unSetTravelPackageDataHasPlan');
              $rootScope.$broadcast('unSetTravelPackageDataHasPlan');
            }
            wirelessDashboardService.getWirelessTravelPackageStaticContent(request, function (_tmp1) {
              if (_tmp1.result === 'success') {
                wpController.travelPackageData = {
                  us: _tmp1.data.usa[0],
                  europe: _tmp1.data.europe[0],
                  common: _tmp1.data.common[0]
                };
              } else {
                wpController.hideWirelessTravelPackage = true;
              }
            });
            request.language = wpController.lng;
            wirelessDashboardService.getWirelessTravelPackageAddOnSummary(request, function (_tmp2) {
              if (_tmp2.result === 'success') {
                if (wpController.lng === 'fr' && _.has(_tmp2, 'data.postPaidAddons')) {
                  _.forEach(_tmp2.data.postPaidAddons, function (v) {
                    if (v.socDescFr) {
                      v.socDesc = v.socDescFr;
                      delete v.socDescFr;
                    }
                  });
                }
                $scope.travelPackageAddOnSummaryData = {};
                $scope.travelPackageAddOnSummaryData.planAddOnDetails = _tmp2.data.postPaidAddons;
              }
            });
          } else {
            wpController.hideWirelessTravelPackage = true;
          }
        } else {
          wpController.hideWirelessTravelPackage = true;
        }
      });

      checkBalance();

      request.refresh = false;
      wirelessDashboardService.getWirelessPostpaid(request)
        .then(function (_tmp) {
          if (_tmp.result === 'success') {
            //$log.info('success');
            wpController.fraudSocErrorMessage = wirelessDashboardService.getFraudSocMessage();
            if (!wpController.isConsumer && wpController.fraudSocErrorMessage) {
              wpController.isFraudSocAvailable = true;
            }
            $rootScope.wirelessPackagePostPaidProcessed = true;
            // Proceed to display
            // because wpController.wpkg_wd is being mutated in processWirelessPackage, we need to get its copy, otherwise changes will be applied on our cached promise (_wirelessPostpaidCache)
            wpController.wpkg_wd = _.cloneDeep(_tmp.data);
            processWirelessPackage(wpController.wpkg_wd);
            processDataWirelessMyDevice(wpController.wpkg_wd);
            processLanguageLabels();

            // Hide loading
            wpController.flags.wpkg_displayContentPackage = true;
            // wpController.flags.wpkg_loadingDataIndicatorPackage = _tmp.stale;

            wpController.flags.wpkg_displayContentDevice = true;
            wpController.flags.wpkg_loadingDataIndicatorDevice = _tmp.stale;

            // remove error messages
            if (wpController.wpkg_errorMessageWirelessPackage !== undefined) {
              wpController.wpkg_errorMessageWirelessPackage = undefined;
            }

            setDataForReactivateCtn();
            // handleBfaSso();
            //DC-1286 - Airstream story
            getRvCustomerSoc(_tmp.data.postPaidPhoneDetails.productList);
          }
        })
        .catch(function (_tmp) {
          wpController.flags.wpkg_displayContentPackage = false;
          wpController.flags.wpkg_displayContentDevice = false;
          // wpController.flags.wpkg_loadingDataIndicatorPackage = false;
          wpController.flags.wpkg_loadingDataIndicatorDevice = false;

          if (_tmp.result === 'fail') {
            holder = _tmp.data;
            wpController.wpkg_errorMessageWirelessPackage = $translate.instant('error_wireless_package_device');

          } else if (_tmp.result === 'error') {
            holder = _tmp.data;
            wpController.wpkg_errorMessageWirelessPackage = $translate.instant('error_wireless_package_device');
          }
        });
      openHeroModal(false);
    };

    wpController.goToSingleLinePlanPage = function () {
      if (wpController.isConsumer && settings.enablePricePlanChanges) {
        cookieStore.put('PPCFromWpCtrl', true, { path: '/web/totes' });
        $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan';
      } else if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
      }
    };

    wpController.hasPPCOrder = function () {
      if (!wpController.wirelessDashActive || !wpController.wirelessDashActive.ctn) {
        return false;
      }

      return bfappcWirelessDashboardService.hasOrder(wpController.wirelessDashActive.ctn);
    };

    wpController.openPPC = function (resumeOrder, planSoc) {
      if (wpController.isDealer) {
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
        deepLinkingModal();
      } else if (wpController.isCare) {
        if (wpController.repPpcAccess) {
          if (hasDCAccess && !captureDealerCodeService.isDealerCodeExist()) {
            captureDealerCodeService.showProceedWithoutDealerCodeModal()
              .then(function (result) {
                if (result !== false) {
                  openPPCFlow(resumeOrder);
                } else {
                  wpController.changeBtnLoading(false);
                }
              })
              .catch(function () {
                wpController.changeBtnLoading(false);
              });
          } else {
            openPPCFlow(resumeOrder);
          }
        }
      } else {
        openPPCFlow(resumeOrder, planSoc);
      }
    };

    wpController.openChangePlanModal = function (size) {
      $modal.open({
        templateUrl: 'views/modals/wirelessRemovePlan.html',
        controller: 'wirelessRemoveModalCtrl',
        size: size,
        backdrop: false
      });
    };

    wpController.postToRogersAddOn = function () {
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.manageAddon;
        /* TODO - Need to check why we should go to change price plan for travel pack scenario
         $scope.deepLinkingModal();
         $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
         */
      } else {
        var formToRogersAddOnElement = $('#formToRogersAddOn');
        formToRogersAddOnElement.attr('action', '/web/myrogers/torcom/postPaidAppsAddons' + '?setLanguage=' + wpController.lng);
        formToRogersAddOnElement.submit();
        formToRogersAddOnElement = null;
      }
    };

    wpController.goToChangeSimCard = function () {
      if (wpController.isConsumer) {
        simcardChangeUtilsService.launchSimCardChangeModule(wpController.ban, wpController.ctn);
      } else {
        var accountEmail = getAccountEmail();
        simcardChangeService.goToEntryState({
          phoneNumber: wpController.ctn,
          accountNumber: wpController.ban,
          accountEmail: accountEmail
          //currentSimCardNumber: wpController.wpkg_client.simNumber
        });
      }
    };

    wpController.postToRogersAddaLineShared = function () {
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.addaLineShared;
      }
    };

    wpController.postToRogersAddaLineIndividual = function () {
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.addaLineIndividual;
      }
    };

    wpController.postToRogersHupCancellation = function () {
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.hupCancellation;
      }
    };

    wpController.postToRogersAddOnChange = function (subSet) {
      if (subSet && subSet.socDesc && subSet.socDesc === settings.my5soc) {
        wpController.updateMy5();
      }
      if (subSet && subSet.socSubType && subSet.socSubType === settings.myVM) {
        wpController.changePassword();
      }
    };

    wpController.updateMy5 = function () {
      var formToRogersMy5Element = $('#formToRogersMy5');
      formToRogersMy5Element.attr('action', '/web/myrogers/updateBuddyList' + '?setLanguage=' + wpController.lng);
      formToRogersMy5Element.submit();
      formToRogersMy5Element = null;
    };

    wpController.suspendPhone = function () {
      invokeSuspendCtnService();
    };

    wpController.isReactivateCtnCallInProgress = function () {
      return reactivateCtnService.isReactivateCtnCallInProgress();
    };

    wpController.reactivatePhone = function ($event) {
      $event.preventDefault();
      invokeReactivateCtnService();
    };

    wpController.changePassword = function () {
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.updateVoiceMailPassword;
      } else {
        var formToRogersVoicemailElement = $('#formToRogersVoicemail');
        formToRogersVoicemailElement.attr('action', '/web/myrogers/changeVoiceMailPassword' + '?setLanguage=' + wpController.lng);
        formToRogersVoicemailElement.submit();
        formToRogersVoicemailElement = null;
      }
    };

    wpController.subscriptionInfoModal = function (size) {
      $modal.open({
        templateUrl: 'views/modals/wirelessSubscriptionPricePlanDetails.modal.html',
        controller: 'wirelessSubscriptionModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false,
        resolve: {
          modalCurrentPlanName: function () {
            return wpController.wpkg_client.postPaidAddons[0].socDesc;
          },
          modalAdditionalPlanInfo: function () {
            return wpController.wpkg_client.additionalSocDetails;
          }
        }
      });
    };

    wpController.openHUP = function () {
      wpController.restoreCartloadingIndicator = true;
      var hupActiveOrder = bfappcWirelessDashboardService.getHuporderForCtn(wpController.wirelessDashActive.ctn);
      if (hupActiveOrder && hupActiveOrder[0].orderSavedStep && hupActiveOrder[0].orderSavedStep == "orderReview") {
        wpController.resumeToReviewOrder(hupActiveOrder[0]);
      }
      else {
        wpController.upgradeDevice();
      }
    };

    wpController.resumeToReviewOrder = function (hupActiveOrder) {
      var ctn = wpController.wirelessDashActive.ctn;
      var ban = wpController.wirelessDashActive.ban;
      var accountTypeNo = ($rootScope.isCare) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber');
      var saveStatePassJSON = {
        'ctn': ctn,
        'ban': ban,
        'activityTypeKey': hupActiveOrder.activityType,
        'accountTypeNumber': accountTypeNo
      };
      var fetchValidatedCartPassJSON = {
        'ban': ban,
        'ctn': ctn,
        'orderId': hupActiveOrder.orderId,
        'activityTypeKey': hupActiveOrder.activityType
      };
      var NFDBrequest = {
        'refresh': false,
        'accountNumber': ban,
        'phoneNumber': ctn,
        'nfdbCaching': true,
        'activityType': hupActiveOrder.activityType
      };
      if (hupActiveOrder.orderSavedStep == "orderReview") {
        cartMenuService.saveState(saveStatePassJSON).then(
          function (response) {
            if (response && response.success) {
              cartMenuService.fetchValidatedCart(fetchValidatedCartPassJSON).then(
                function (res) {
                  if (res && res.success) {
                    var hupOrder = res.hup;
                    var currentHupOrder = wpController.getCurrentHupOrder(hupOrder, hupActiveOrder.orderId);
                    var isDeviceValid = true;
                    var isPlanValid = true;
                    var isAddOnValid = true;
                    _.forEach(currentHupOrder[0].cartItems, function (item) {
                      if (item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && !item.valid) {
                        isDeviceValid = false;
                      }
                      if (item.activityType == 'HUP' && item.itemType == 'planCommerceItem' && !item.valid) {
                        isPlanValid = false;
                      }
                      if (item.activityType == 'HUP' && item.itemType == 'addonCommerceItem' && !item.valid) {
                        isAddOnValid = false;
                      }
                    });
                    if (!isDeviceValid || !isPlanValid || !isAddOnValid) {
                      if (!isPlanValid || !isAddOnValid) {
                        var popupObj = {};
                        var saveRequest = {
                          'orderSavedStep': ''
                        };
                        ajax.saveOrder(saveRequest);
                      }
                      popupObj.preCloseCallback = function () {
                        $scope.showChatCallIcon = false;
                        $scope.showButtons = false;
                        if (!isDeviceValid) {
                          $window.location.href = '/web/totes/upgrade/#/choose-phone';
                        }
                        else {
                          $window.location.href = '/web/totes/upgrade/#/build-plan';
                        }
                      };
                      $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                      $scope.showChatCallIcon = true;
                      $scope.showButtons = true;
                      openGenericErrorPopup(popupObj);
                    }
                    else {
                      ajax.isNFDBCheck(NFDBrequest).then(
                        function (nres) {
                          if (!nres.isNFDBExistInd) {
                            cartMenuService.validateOrder().then(
                              function (vres) {
                                if (vres && vres.success) {
                                  if (hupActiveOrder.activityType.toLowerCase() === 'ppc') {
                                    $window.location.href = '/web/totes/wireless-plan-change/#/checkout/review';
                                  }
                                  else if (hupActiveOrder.activityType.toLowerCase() === 'hup') {
                                    $window.location.href = '/web/totes/upgrade/#/checkout/review';
                                  }
                                }
                                else {
                                  var popupObj = {};
                                  $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                  $scope.showChatCallIcon = true;
                                  $scope.showButtons = true;
                                  openGenericErrorPopup(popupObj);
                                }
                              },
                              function (verr) {
                                var popupObj = {};
                                $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                                $scope.showChatCallIcon = true;
                                $scope.showButtons = true;
                                openGenericErrorPopup(popupObj);

                              }
                            );
                          }
                          else {
                            dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                            notEligibleDeviceUpgrade('NFDB');

                          }
                        },
                        function (nerr) {
                          dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
                          notEligibleDeviceUpgrade('NFDB');

                        }
                      );
                    }
                  }
                  else {
                    var popupObj = {};
                    var hupOrder = res.hup;
                    var currentHupOrder = wpController.getCurrentHupOrder(hupOrder, hupActiveOrder.orderId);
                    var isDeviceValid = false;
                    _.forEach(currentHupOrder[0].cartItems, function (item) {
                      if (item.activityType == 'HUP' && item.itemType == 'deviceCommerceItem' && item.valid) {
                        isDeviceValid = true;
                      }
                    });
                    popupObj.preCloseCallback = function () {
                      $scope.showChatCallIcon = false;
                      $scope.showButtons = false;
                      if (!isDeviceValid) {
                        $window.location.href = '/web/totes/upgrade/#/choose-phone';
                      }
                      else {
                        $window.location.href = '/web/totes/upgrade/#/build-plan';
                      }
                    };
                    $scope.errorMessage = $translate.instant('hup_save_cart_offers_changed');
                    $scope.showChatCallIcon = true;
                    $scope.showButtons = true;
                    openGenericErrorPopup(popupObj);
                  }
                },
                function (err) {
                  var popupObj = {};
                  $scope.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
                  $scope.showChatCallIcon = true;
                  $scope.showButtons = true;
                  openGenericErrorPopup(popupObj);
                }

              );
            }
          },
          function (error) {
            var popupObj = {};
            $scope.errorMessage = $translate.instant('generic_error_message');
            $scope.showChatCallIcon = true;
            $scope.showButtons = true;
            openGenericErrorPopup(popupObj);
          }
        );
      }

    };
    wpController.getCurrentHupOrder = function (hupOrders, currentOrderID) {
      if (hupOrders.length > 0) {
        return _.filter(hupOrders, function (order) {
          return order.orderId === currentOrderID;
        });
      }
    };
    wpController.upgradeDevice = function (phoneSku) {
      $rootScope.hupError = false;
      if (!wpController.restoreCartloadingIndicator) {
        wpController.upgradeDeviceObjloadingIndicator = true;
      }
      if (!userService.isSigned()) {
        $location.path('/signin');
        return;
      }
      if (wpController.isDealer) {
        if (!wpController.repHupAccess) {
          if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
            wpController.permissionsObj.permissions.length !== 0 &&
            _.find(wpController.permissionsObj.permissions, { 'permission': 'ONEVIEW_HUP' })) {
            $rootScope.targetFlow = settings.deepLinkStatusCodes.upgradeDevice;
            deepLinkingModal();
          }
        }
        if (wpController.repHupAccess && !wpController.hupDisabled) {
          openUpgradeDeviceModal();
        }
      } else if (wpController.isCare) {
        if (wpController.repHupAccess) {
          if (hasDCAccess && !captureDealerCodeService.isDealerCodeExist()) {
            captureDealerCodeService.showProceedWithoutDealerCodeModal()
              .then(function (result) {
                if (result !== false) {
                  upgradeDeviceFlow();
                } else {
                  wpController.upgradeDeviceObjloadingIndicator = false;
                }
              })
              .catch(function () {
                wpController.upgradeDeviceObjloadingIndicator = false;
              });

          } else {
            upgradeDeviceFlow();
          }
        }
      } else {
        upgradeDeviceFlow(phoneSku);
      }
    };

    function checkBalance() {
      /*$('#formToRogersUpgrade').attr('action', '/web/myrogers/device-upgrade' + '?setLanguage=' + wpController.lng);
       $('#formToRogersUpgrade').submit();*/
      wpController.checkBalanceloadingIndicator = true;
      if (wpController.showBalanceSection) {
        dtmService.track('check balance', 'pasv', null);
        var request = {
          refresh: false,
          accountNumber: wpController.wirelessDashActive.ban,
          phoneNumber: wpController.wirelessDashActive.ctn
        };
        wpController.balanceObj = {};
        var balanceErrorModalConfig = {
          template: 'scripts/directives/hup/deviceBalance/checkBalancePopup.html',
          className: 'ngdialog-theme-default',
          showClose: true,
          appendTo: 'div[ui-view]',
          controller: function () {
            this.lng = wpController.lng;
          },
          controllerAs: 'vm',
          closeByDocument: true
        };
        ajax.getDeviceBalance(request)
          .then(function (data) {
            wpController.checkBalanceloadingIndicator = false;
            if (angular.isObject(data)) {
              if (angular.isDefined(data.isError)) {
                wpController.showBalanceSection = true;
                wpController.checkBalanceloadingIndicator = false;
                ngDialog.open(balanceErrorModalConfig);
              }
              else {
                wpController.showBalanceSection = false;
                wpController.balanceObj = data;
                wpController.balanceObj.todayDate = formatDateWireless(new Date());
                wpController.balanceObj.subsidyStartDate = data.subsidyStartDate;
                wpController.balanceObj.subsidyEndDate = data.subsidyEndDate;
                wpController.isRogersInstallmentCustomer = isRogersInstallmentCustomer(data);
                wpController.showDeviceBalance = wpController.isRogersInstallmentCustomer ? wpController.formatCurrency(wpController.balanceObj.remainingInstallmentBalance) : wpController.formatCurrency(wpController.balanceObj.subsidyBalance);
                wpController.balanceObj.tooltip = setDeviceInfoIcon(data, wpController.isRogersInstallmentCustomer);
                wpController.balanceObj.subsidyBalanceSplit = (wpController.isRogersInstallmentCustomer ? wpController.balanceObj.remainingInstallmentBalance : wpController.balanceObj.subsidyBalance).toString().split('.');
                wpController.balanceObj.subsidyBalanceSplit[1] = wpController.balanceObj.subsidyBalanceSplit[1] === undefined ? '.00' : '.' + wpController.balanceObj.subsidyBalanceSplit[1];
                wpController.deviceInfoModal.balanceObj = wpController.balanceObj;
                wpController.deviceInfoModal.balance = wpController.balanceObj.subsidyBalanceSplit;
                wpController.planInfoModal.startDate = wpController.balanceObj.subsidyStartDate;
                wpController.deviceInfoModal.finance = wpController.isRogersInstallmentCustomer;
                //Begin: Upfront Advantage Changes-AirStream2
                wpController.balanceObj.ufa = data.rvInformation;

                permissionsService.getUserPermission('FINANCED_DEVICE_BRT').then(function(permission) {
                  wpController.financedDeviceBRT = permission;
                });
              }
            }
          })
          .catch(function () {
            wpController.checkBalanceloadingIndicator = false;
            wpController.showBalanceSection = true;
            ngDialog.open(balanceErrorModalConfig);
          });

      }
      else {
        wpController.checkBalanceloadingIndicator = false;
        wpController.showBalanceSection = !wpController.showBalanceSection;
      }
    };

    wpController.showDeviceDetails = function () {
      return wpController.showBalanceSection === false &&
        (wpController.balanceObj.subsidyAmount > 0 || wpController.rvCustomer ||
        !(wpController.deviceInfoModal.finance && wpController.financedDeviceBRT));
    };

    wpController.showFinancedDeviceDetails = function () {
      return wpController.showBalanceSection === false && wpController.deviceInfoModal.finance && wpController.financedDeviceBRT;
    };

    function checkWarning() {
      wpController.isFirstWarning = false;
      wpController.isSecWarning = false;
      if (wpController.balanceObj.ufa) {
        $http.get('/web/totes/cms/content/json/airstream/reminder_days.json').then(function (res) {
          var firstReminder = parseInt(res.data.firstReminder);
          var secondReminder = parseInt(res.data.secondReminder);
          var tde = new Date(wpController.balanceObj.ufa.rvExpectedReturnDate).getTime();
          var cte = new Date().getTime();
          tde = ((tde - cte)) / (1000 * 3600 * 24);
          wpController.isUFA = (tde >= 0) ? true : false;
          wpController.deviceInfoModal.isUFA = wpController.isUFA;
          // R819 -- Airstream 2  Show Interim Solution if soc code is available -- Begin
          if (wpController.rvCustomer === true) {
            wpController.isUFA = false;
            wpController.deviceInfoModal.isUFA = false;
          }
          // R819 -- Airstream 2  Show Interim Solution if soc code is available  -- End
          wpController.ufaWarning = (tde > secondReminder && tde <= firstReminder) ? 'warning-1' : ((tde >= 0 && tde <= secondReminder) ? 'warning-2' : false);
          // console.log("air wpController.ufaWarning :: ", wpController.ufaWarning);
          if (wpController.balanceObj.ufa.rvAmount > 0) {
            wpController.isUpFrontRvAmount = true;
            wpController.deviceInfoModal.isUpFrontRvAmount = true;
          }
        });
      }
      //End: Upfront Advantage Changes-AirStream2
    };

    //reserveDevice
    wpController.reserveDevice = function () {

      //TODO two line below here may cause by code merge
      //$('#formToRogersReserveDevice').attr('action','/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice'+'&setLanguage='+wpController.lng);
      //$('#formToRogersReserveDevice').submit();
      function goToReserveDevice() {
        brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.NRS).then(function (isNrs) {
          if (isNrs) {
            appState.switchView('reservedevice');
          } else {
            var formToRogersReserveDeviceElement = $('#formToRogersReserveDevice');
            formToRogersReserveDeviceElement.attr('action', '/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice&setLanguage=' + wpController.lng);
            formToRogersReserveDeviceElement.submit();
            formToRogersReserveDeviceElement = null;
          }
        });
      }

      if (wpController.wpkg_client.creditLimitAmount === 0) {
        goToReserveDevice();
      } else {
        var modal = $modal.open({
          templateUrl: 'views/modals/reserveDevice.html',
          controller: 'genericWirelessModalCtrl',
          controllerAs: 'vm',
          backdrop: false
        });

        modal.result.then(function () {
          goToReserveDevice();
        });
      }
    };

    wpController.openWirelessTravelPackageLegalContentModal = function (ev, size) {
      $modal.open({
        templateUrl: 'views/modals/wirelessTravelPackageLegal.html',
        controller: 'wirelessTravelPackageLegalModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false,
        resolve: {
          legalContent: function () {
            return $sce.trustAsHtml(angular.element('<textarea />').html(ev).text());
          }
        }
      });
    };

    wpController.openWirelesePackageModal = function (size) {
      if (wpController.isDealer || wpController.isCare) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RoamLikeHome, ute.common.permissions.service.RamActionCodes.add)
          .then(function (repPermission) {
            if (repPermission) {
              if (wpController.isDealer) {
                wpController.ban = wpController.wpkg_client.ban;
                wpController.ctn = wpController.wpkg_client.ctn;
              }
              if (wpController.isCare) {
                wpController.ctn = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)).toString();
                wpController.ban = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)).toString();
              }

              $modal.open({
                templateUrl: 'views/modals/wirelessTravelPackage.html',
                controller: 'wirelessTravelPackageModalCtrl',
                controllerAs: 'vm',
                size: size,
                backdrop: false,
                resolve: {
                  ban: function () {
                    return wpController.ban;
                  },
                  ctn: function () {
                    return wpController.ctn;
                  }
                }
              });
            } else {
              $modal.open({
                templateUrl: 'views/modals/roamEnrollModal.html',
                controller: 'genericWirelessModalCtrl',
                controllerAs: 'vm',
                size: size,
                backdrop: false
              });
            }
          });
      } else {
        $modal.open({
          templateUrl: 'views/modals/wirelessTravelPackage.html',
          controller: 'wirelessTravelPackageModalCtrl',
          controllerAs: 'vm',
          size: size,
          backdrop: false,
          resolve: {
            ban: function () {
              return wpController.ban;
            },
            ctn: function () {
              return wpController.ctn;
            }
          }
        });
      }
    };

    wpController.unEnrollPackageModal = function (size) {
      if (wpController.isDealer || wpController.isCare) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RoamLikeHome, ute.common.permissions.service.RamActionCodes.remove)
          .then(function () {
            if (wpController.isDealer) {
              wpController.ban = wpController.wpkg_client.ban;
              wpController.ctn = wpController.wpkg_client.ctn;
            }
            if (wpController.isCare) {
              wpController.ctn = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)).toString();
              wpController.ban = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)).toString();
            }
            $modal.open({
              templateUrl: 'views/modals/wirelessUnEnrollTravelPackage.html',
              controller: 'wirelessTravelPackageModalCtrl',
              controllerAs: 'vm',
              size: 'lg',
              backdrop: false,
              resolve: {
                ban: function () {
                  return wpController.ban;
                },
                ctn: function () {
                  return wpController.ctn;
                }
              }
            });
          });
      } else {
        $modal.open({
          templateUrl: 'views/modals/wirelessTravelPackage.html',
          controller: 'wirelessTravelPackageModalCtrl',
          controllerAs: 'vm',
          size: size,
          backdrop: false,
          resolve: {
            ban: function () {
              return wpController.ban;
            },
            ctn: function () {
              return wpController.ctn;
            }
          }
        });
      }
    };

    wpController.onClickWirelessChangeWirelessNumber = function () {
      appState.tagging(['_trackPageView', { eVar13: 'MyRogers change wireless number' }, { event5: '' }]);
      if (wpController.isDealer) {
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changeCTN;
        deepLinkingModal();
      } else {
        var supportUrl;
        if (wpController.lng === 'en') {
          supportUrl = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_my_number_en';
        } else {
          supportUrl = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_my_number_fr';
        }
        $window.location.href = supportUrl;
      }
    };

    wpController.onClickWirelessDeviceReservation = function () {
      appState.tagging(['_trackPageView', { eVar13: 'MyRogers device reservation' }, { event5: '' }]);
    };

    wpController.getDiscountRate = function (value) {
      return !!getSEEDiscount() ? (getSEEDiscount().rateType === 'D' ?
        value - getSEEDiscount().rate :
        value - ((getSEEDiscount().rate * value) / 100)) : null;
    };

    wpController.getDiscountExpiryDate = function () {

      //TODO: this hack must go -- all dates from server must be in this format 'YYYY-MM-DD'
      return new Date(getSEEDiscount().formattedExpiryDate);
      // return new Date(getSEEDiscount().expiryDate.replace(/-/g,"/"));
    };

    wpController.isShareEverything = function () {
      return wpController.getCurrentState().indexOf('shareEverything') > -1;
    };

    wpController.isInfinitePlan = function () {
      return wirelessDashboardService.isInfinitePlan();
    }

    wpController.isIndividualSummary = function () {
      return wpController.getCurrentState().indexOf('individualSummary') > -1;
    };

    wpController.isDiscountMode = function (soc) {
      return (seeBrtShowState &&
        !!currentPlan &&
        wpController.isShareEverything() &&
        (dataManagerService.getPrimaryCTN() * 1 !== userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER) * 1) &&
        soc === planSoc &&
        getSEEDiscount() !== undefined &&
        getSEEDiscount().rateType !== null);
    };

    wpController.SOCIsNotSuppressed = function (item) {
      return item.socDesc !== 'TAGSRA01B';
    };

    wpController.addonFilterWithSOCIsNotSuppressed = function (item) {
      if (item.socDesc !== 'TAGSRA01B') {
        if (item.expiryDate && item.expiryDate !== '') {
          var currentDate = new Date();
          var addonExpiryDate = new Date(item.expiryDate);
          addonExpiryDate.setDate(addonExpiryDate.getDate() + 1);
          return (addonExpiryDate >= currentDate);
        }
        return true;
      } else {
        return false;
      }
    };

    wpController.hasAddonMSF = function () {
      var addOnArray = wpController.wpkg_client.postPaidAddons;
      var len = addOnArray.length;
      var hasAddonMSF = false;

      for (var i = 0; i < len; i++) {
        if (i > 0 && parseInt(addOnArray[i].addonMSF, 10) > 0) {
          hasAddonMSF = true;
        }
      }
      return hasAddonMSF;
    };

    wpController.formatCurrency = function (price) {
      if (angular.isUndefined(price)) {
        return '';
      } else {
        price = parseFloat(price);
        price = wpController.isDealer ? price.toFixed(2) : price.toFixed(0);
        if (wpController.lng === 'en') {
          return '<span class=\'superScript\'>$</span>' + price;
        } else {
          price = price.replace('.', ',');
          return price + ' <span class=\'superScript\'>$</span>';
        }
      }
    };

    wpController.showReactivateCtn = function (modelForReactivateCtn) {
      if (wpController.isDealer || wpController.isCare) {
        reactivateConfigure();
      }
      return (
        wpController.wpkg_client &&
        wpController.wpkg_client.planSuspended && !_.isUndefined(modelForReactivateCtn) &&
        wirelessDashboardService.isPostPaidDetailsDataReady
      );
    };

    //TODO: it's being used in genericErrorPopup.html
    $scope.closeGenericErrorPopup = function () {
      ngDialog.close();
      $scope.showChatCallIcon = false;
      $scope.showButtons = false;
    };

    /**
     * Add overage data to Features bullet
     * check if the data contains status code === 200
     */
    function processOverageData(overAgeRateData) {
      if (
        _.has(overAgeRateData.status, 'code') &&
        overAgeRateData.status.code === 0 &&
        _.has(overAgeRateData, 'content.overAgeRate') &&
        _.has(overAgeRateData, 'content.overAgeRate.featureDefinition') &&
        _.has(overAgeRateData, 'content.overAgeRate.featureDefinition.featureGroup')
      ) {
        var dataUnitEn = '', dataUnitFr = '';
        if (_.has(overAgeRateData, 'content.overAgeRate.featureUnit')) {
          dataUnitEn = overAgeRateData.content.overAgeRate.featureUnit.displayName;
          dataUnitFr = overAgeRateData.content.overAgeRate.featureUnit.displayNameFr;
        }
        var descEn = {
          overAgeRate: overAgeRateData.content.overAgeRate.displayNameEn.replace('/', ' per ') + dataUnitEn
        };
        var descFr = {
          overAgeRate: overAgeRateData.content.overAgeRate.displayNameFr.replace('/', ' par tranche de ') + ' ' + dataUnitFr
        };

        wpController.wpkg_client.features.push(descEn);
        wpkg_clientBkp.features.push(descEn);
        wpkg_clientBkp.featuresFr.push(descFr);
      }
    }

    // Support functions
    function processWirelessPackage(data) {
      wpkg_rawData = data;												// All of the data
      wpController.wpkg_client = data.postPaidPhoneDetails;							// Client Data
      angular.copy(wpController.wpkg_client, wpkg_clientBkp);
      wpController.deviceInfoModal.wp = wpController.wpkg_client;
      wpController.planInfoModal.wp = wpController.wpkg_client;
      //wpController.deviceInfoModal.sim = wpController.wpkg_client.simNumber.slice(0, 4) + 'XXXXXXXX' + wpController.wpkg_client.simNumber.slice(-4);

      if (wpController.isDealer || wpController.isCare) {
        permissionsService.getUserPermissions()
          .then(function (data) {
            wpController.permissionsObj = data;
            if (wpController.permissionsObj && wpController.permissionsObj.permissions &&
              wpController.permissionsObj.permissions.length !== 0 &&
              _.find(wpController.permissionsObj.permissions, { 'permission': 'ONEVIEW_HUP' })) {
              wpController.hupDisabled = false;
            }
          });
      }

      var subSet = null;
      var moreDetails = null;

      // Combine short plan details and long plan details, based on their SOC number
      wpController.wpkg_client.hasMyFive = data.postPaidPhoneDetails.hasMyFive;
      wpController.wpkg_client.hasVoiceMail = false;
      wpController.wpkg_client.planSuspended = data.postPaidPhoneDetails.isSuspendedCtn;

      wpController.wpkg_client.features = [];
      wpkg_clientBkp.features = [];
      wpkg_clientBkp.featuresFr = [];

      wpController.wpkg_client.minutes = [];
      wpkg_clientBkp.minutes = [];
      wpkg_clientBkp.minutesFr = [];
      wpController.wpkg_client.discounts = [];
      wpController.wpkg_client.additionalSocDetails = [];

      var codeExists = false;

      if (_.has(data, 'postPaidPhoneDetails.additionalInfo.includedServices')) {
        var additionalSocDetails = data.postPaidPhoneDetails.additionalInfo.additionalSocDetails;
        codeExists = additionalSocDetails.filter(function (data) {
          return data.code && data.code === 'FAMDATMGR';
        });
      }

      if (_.has(data, 'postPaidPhoneDetails.additionalInfo.includedServices')) {
        _.forEach(data.postPaidPhoneDetails.additionalInfo.includedServices, function (item) {
          if (item.hasOwnProperty('desc') && !!item.desc && item.desc.search('GPRS') === -1) {

            if (item.desc.search('Worry-free data management') === -1
              || (item.desc.search('Worry-free data management') !== -1 &&
                wpController.isShareEverything() && codeExists)) {

              wpController.wpkg_client.features.push(item.desc);
              wpkg_clientBkp.features.push(item.desc);
              wpkg_clientBkp.featuresFr.push(item.descFr);
            }
          }
        });
      }

      /**
       * Populate Ovagerage Data to feature
       */
      if (data.overAgeRate) {
        processOverageData(data.overAgeRate);
      }

      if (data.postPaidPhoneDetails.additionalInfo && data.postPaidPhoneDetails.additionalInfo.includedMinutes) {
        _.forEach(data.postPaidPhoneDetails.additionalInfo.includedMinutes, function (item) {
          wpController.wpkg_client.minutes.push(item.desc);
          wpkg_clientBkp.minutes.push(item.desc);
          wpkg_clientBkp.minutesFr.push(item.descFr);
        });
      }

      if (data.postPaidPhoneDetails.additionalInfo && data.postPaidPhoneDetails.additionalInfo.discounts) {
        wpController.wpkg_client.discounts = data.postPaidPhoneDetails.additionalInfo.discounts;
      }

      if (data.postPaidPhoneDetails.additionalInfo && data.postPaidPhoneDetails.additionalInfo.additionalSocDetails) {
        wpController.wpkg_client.additionalSocDetails = data.postPaidPhoneDetails.additionalInfo.additionalSocDetails;
      }

      // change format of json file.
      if (wpController.wpkg_client.hasMyFive) {
        wpController.wpkg_my5.soc = wpController.wpkg_client.soc;
        wpController.wpkg_my5.socDesc = wpController.wpkg_client.socDesc;
        wpController.wpkg_my5.MAX = wpController.wpkg_client.buddyListCount;
        wpController.wpkg_my5.TYPE = wpController.wpkg_client.buddyListType; //subSet.socType;
      }

      //loop throght the postPaidAddons
      _.forEach(wpController.wpkg_client.postPaidAddons, function (subSet, index) {
        moreDetails = null;

        if (typeof subSet === 'object') {
          if (wpController.lng === 'fr' && subSet.socDescFr) {
            subSet.socDesc = subSet.socDescFr;
            delete subSet.socDescFr;
          }
          // Percentages for the ring chart
          var mySOCK = subSet.soc;

          if (wpController.wpkg_client.hasMyFive) {
            wpController.wpkg_my5.soc = mySOCK;
            wpController.wpkg_my5.socDesc = subSet.socDesc;
            wpController.wpkg_my5.MAX = wpController.wpkg_client.buddyListCount;
            wpController.wpkg_my5.TYPE = wpController.wpkg_client.buddyListType; //subSet.socType;
          }

          if (subSet.socSubType && subSet.socSubType === settings.myVM) {
            wpController.wpkg_client.vmsoc = subSet.soc;
            wpController.wpkg_client.hasVoiceMail = true;
          }

          // Find that SOC id in planDetails and add that to the postPaidAddons array
          if (wpkg_rawData.planDetails[mySOCK]) {
            moreDetails = wpkg_rawData.planDetails[mySOCK];
            wpController.wpkg_client.postPaidAddons[index].additionalDetails = moreDetails;
          } else {
            moreDetails = null;
          }
        }
      });

      if (!wpController.wpkg_client.hasVoiceMail) {
        wpController.wpkg_client.hasVoiceMail = !!checkAdditionalSocDetails();
      }

      var socDesc = wpController.lng === 'fr' ? data.postPaidPhoneDetails.planDescriptionFr : data.postPaidPhoneDetails.planDescription;
      var myPlanAddOn = {
        'soc': data.postPaidPhoneDetails.planCode,
        'addonMSF': data.postPaidPhoneDetails.planMSF,
        'socDesc': socDesc,
        'effectiveDate': data.postPaidPhoneDetails.dateEffective,
        'expiryDate': data.postPaidPhoneDetails.expiryDate
      };
      var myPlanAddOnBkp = {
        'soc': data.postPaidPhoneDetails.planCode,
        'addonMSF': data.postPaidPhoneDetails.planMSF,
        'socDesc': data.postPaidPhoneDetails.planDescription,
        'socDescFr': data.postPaidPhoneDetails.planDescriptionFr,
        'effectiveDate': data.postPaidPhoneDetails.dateEffective,
        'expiryDate': data.postPaidPhoneDetails.expiryDate
      };
      planSoc = data.postPaidPhoneDetails.planCode;//for discount changes to not remove
      wpController.wpkg_client.postPaidAddons.unshift(myPlanAddOn);
      wpkg_clientBkp.postPaidAddons.unshift(myPlanAddOnBkp);
      angular.copy(wpController.wpkg_client.postPaidAddons, wpkg_clientBkp.postPaidAddons);
      //sorting in desc order to display in desc order as per ove-21
      if (wpController.isCare) {
        //var discountsWithoutExpiryDate = $filter('filter')(wpController.wpkg_client.discounts, {expiryDate: ''}, true);
        var discountsWithExpiryDate = _.filter(wpController.wpkg_client.discounts, function (o) { return !!o.expiryDate; });
        var discountsWithoutExpiryDate = _.filter(wpController.wpkg_client.discounts, function (o) { return o.expiryDate.length === 0; })
        //var discountsWithExpiryDate = $filter('filter')(wpController.wpkg_client.discounts, {expiryDate: ''}, true);
        discountsWithExpiryDate = $filter('orderBy')(discountsWithExpiryDate, 'expiryDate');
        wpController.wpkg_client.totalDiscounts = discountsWithExpiryDate.concat(discountsWithoutExpiryDate);
        console.log(wpController.wpkg_client);
        //cost addons should be sorted as per the cost n nocostaddons shud be sorted as per effec. date
        wpController.wpkg_client.totalAddons = wpController.wpkg_client.postPaidAddons.concat(wpController.wpkg_client.additionalInfo.additionalSocDetails);
        wpController.wpkg_client.costAddons = _.filter(wpController.wpkg_client.totalAddons, function (addon) { return addon.addonMSF > 0; });
        wpController.wpkg_client.costAddons = wpController.wpkg_client.costAddons.sort(function (a, b) {
          return (parseInt(b.addonMSF) - parseInt(a.addonMSF));
        });
        wpController.wpkg_client.noCostAddons = _.filter(wpController.wpkg_client.totalAddons, function (addon) { return (addon.addonMSF <= 0 || !addon.addonMSF); });
        wpController.wpkg_client.noCostAddons = $filter('orderBy')(wpController.wpkg_client.noCostAddons, 'effectiveDate');
        wpController.wpkg_client.totalAddons = wpController.wpkg_client.costAddons.concat(wpController.wpkg_client.noCostAddons);
      }

      // Potluck -- Show Pool Info  Section --  Begin

      wpController.wpkg_client.includedData = wpController.wpkg_client.includedData || [];
      wpController.wpkg_client.planType = wpController.wpkg_client.planType || "";
      wpController.wpkg_client.planType = (wpController.wpkg_client.planType.toLowerCase() === "voiceanddata" || wpController.wpkg_client.planType.toLowerCase() === "data") ? "sharing" : wpController.wpkg_client.planType.toLowerCase();
      wpController.wpkg_client.isPooling = wpController.wpkg_client.includedData.length > 0 && wpController.wpkg_client.planType === "sharing";
      if (wpController.wpkg_client.isPooling) {
        wpController.wpkg_client.planType = "pooling";
      }
      wpController.showPoolingInfo = !!wpController.wpkg_client.planType && wpController.isShareEverything() && wpController.isCare;

      // Potluck -- Show Pool Info  Section --  End

    }

    function checkAdditionalSocDetails() {
      var socCodeFound;
      if (wpController.wpkg_client.additionalInfo.additionalSocDetails) {
        _.forEach(wpController.wpkg_client.additionalInfo.additionalSocDetails, function (item) {
          if (voiceMailSOCCodes.indexOf(item.code) > -1) {
            socCodeFound = true;
            return false;
          }
        });
      }
      return socCodeFound;
    }

    function processLanguageLabels() {

      if (!wpController.wpkg_client) {
        return;
      }

      var isFrench = wpController.lng === 'fr';

      _.forEach(wpController.wpkg_client.postPaidAddons, function (addon, index) {
        addon.socDesc = wpkg_clientBkp.postPaidAddons[index].socDesc;
      });

      _.forEach(wpController.wpkg_client.features, function (item, index) {
        wpController.wpkg_client.features[index] = isFrench ? wpkg_clientBkp.featuresFr[index] : wpkg_clientBkp.features[index];
      });

      _.forEach(wpController.wpkg_client.minutes, function (item, index) {
        wpController.wpkg_client.minutes[index] = isFrench ? wpkg_clientBkp.minutesFr[index] : wpkg_clientBkp.minutes[index];
      });
    }

    function processDataWirelessMyDevice(data) {
      wpController.wpkg_client = data.postPaidPhoneDetails;					// Client Data

      // Phone image
      var mainImage = '';
      var deviceName = '';
      var deviceNameFr = '';

      var deviceInfo = wpController.wpkg_client.phoneProductId;
      var deviceObject = deviceInfo ? data.deviceDetails[deviceInfo].EN : {};
      var deviceObjectFr = deviceInfo ? data.deviceDetails[deviceInfo].FR : {};

      try {
        if (deviceObject && deviceObject.phoneImagePaths && deviceObject.phoneImagePaths.length > 0) {
          mainImage = deviceObject.phoneImagePaths[0];
        }

      } catch (err) {
        mainImage = 'noimage';
      }

      try {
        deviceName = deviceObject.productTitle;
        deviceNameFr = deviceObjectFr.productTitle;

      } catch (err) {
        deviceName = '';
        deviceNameFr = '';
      }

      var useThis = mainImage;
      if (mainImage === 'noimage' || mainImage === '') {
        useThis = 'images/Wireless-SD.png';
      }

      wpController.wpkg_client.phoneImageProcessed = useThis;
      wpController.wpkg_client.deviceName = deviceName;
      wpController.wpkg_client.deviceNameFr = deviceNameFr;
    }

    function openModal() {
      var size;
      if (wpController.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.changePricePlan;
      } else {
        $modal.open({
          templateUrl: 'views/modals/wirelessRemovePlan.html',
          controller: 'wirelessRemoveModalCtrl',
          size: size,
          backdrop: false
          //backdropClass: 'bkg-modal',
        });
      }
    }

    function openUpgradeDeviceModal(size) {
      var modal = $modal.open({
        templateUrl: 'views/modals/wirelessUpgradeDeviceModal.html',
        controller: 'wirelessUpgradeDeviceModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false
      });
      modal.result.then(function (data) {
        if (data && data === 'SSP') {
          wpController.upgradeDeviceObjloadingIndicator = false;
          $rootScope.targetFlow = settings.deepLinkStatusCodes.upgradeDevice;
          deepLinkingModal();
        } else if (data && data === 'Aisel') {
          upgradeDeviceFlow();
        }
      }, function () {
        wpController.upgradeDeviceObjloadingIndicator = false;
        // on Cancel behaviour
      });
    }

    function deepLinkingModal(size) {
      var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
      ajax.getUserPreference(userId)
        .then(function (data) {
          if (data && Object.keys(data).length > 0 && _.some(data.userPreference, { 'name': 'displayMovingToSSPPopUp' })) {
            var userPreferenceObject = _.find(data.userPreference, function (obj) {
              return obj.name === 'displayMovingToSSPPopUp';
            });
            if (!userPreferenceObject.value) {
              backToSSPService.backToSSP();
            } else {
              showDeepLinkPopUp(size);
            }
          } else {
            showDeepLinkPopUp(size);
          }
        })
        .catch(function () {
          showDeepLinkPopUp(size);
        });
    }

    function showDeepLinkPopUp(size) {
      $modal.open({
        templateUrl: 'views/modals/deepLinkModal.html',
        controller: 'deepLinkModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false
      });
    }

    wpController.showRogersGeoTextPopUp = function (size) {
      $modal.open({
        templateUrl: 'scripts/directives/wirelessPackage/partials/rogersGeoTextModal.html',
        controller: 'deepLinkModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false,
        windowClass: 'geoText-modal'
      });
    };

    function getFirstNameFromCtn(ctn) {
      var ctnRecord = _.find(myrServicesService.myServicesList, { 'subType': 'CTN', 'serviceDetail': ctn });
      if (ctnRecord) {
        return ctnRecord.firstName;
      }
      return '';
    }

    function setDataForReactivateCtn() {
      wpController.modelForReactivateCtn = {
        phoneNumber: wpController.ctn,
        accountNumber: wpController.ban,
        deviceNameEn: wpController.wpkg_client.deviceName,
        deviceNameFr: wpController.wpkg_client.deviceNameFr,
        firstName: getFirstNameFromCtn(wpController.ctn)
      };
    }

    function getAccountEmail() {
      return _.has($rootScope.ao, 'accountDetails.contactInfo.emailAddress') ? $rootScope.ao.accountDetails.contactInfo.emailAddress : '';
    }

    function invokeSuspendCtnService() {
      var accountEmail = getAccountEmail();
      if (wpController.isDealer || wpController.isCare) {
        suspendCtnService.configure({
          basic: {
            mainTemplateUrl: suspendCtnService.getConfig().basic.mainRepViewTemplateUrl
          },
          advanced: {
            confirmSuspendDevice: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewConfirmSuspendDevice.templateUrl
            },
            suspendCtnSuccess: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewSuspendCtnSuccess.templateUrl
            },
            suspendCtnError: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewSuspendCtnError.templateUrl
            }
          }
        });
      }
      suspendCtnService.goToEntryState({
        phoneNumber: wpController.ctn,
        accountNumber: wpController.ban,
        accountEmail: accountEmail,
        deviceNameEn: wpController.wpkg_client.deviceName,
        deviceNameFr: wpController.wpkg_client.deviceNameFr,
        firstName: getFirstNameFromCtn(wpController.ctn)
      });
    }

    function invokeReactivateCtnService() {
      if (wpController.isDealer || wpController.isCare) {
        reactivateConfigure();
      }
      reactivateCtnService.setAccountNumber(wpController.ban);
      reactivateCtnService.setPhoneNumber(wpController.ctn);
      reactivateCtnService.processReactivateCtn();
    }

    function getQ2PPCPermission(permissionStorage, permissionName) {
      var deferred = $q.defer();
      var q2PPCPermission = userService.getPersistentService().get(permissionStorage);
      if (!q2PPCPermission || q2PPCPermission === 'false') {
        permissionsService.getUserPermissions()
          .then(function (result) {
            if (result.permissions && result.permissions.length && _.find(result.permissions, function (obj) {
              return obj.permission === permissionName;
            })) {
              userService.getPersistentService().put(permissionStorage, true);
              deferred.resolve();
            } else {
              userService.getPersistentService().put(permissionStorage, false);
              deferred.reject();
            }
          })
          .catch(function () {
            userService.getPersistentService().put(permissionStorage, false);
            deferred.reject();
          });
      } else {
        deferred.resolve();
      }
      return deferred.promise;
    }

    function activate() {
      $rootScope.salesForceFailed = false;
    }

    function checkPermissionCallerID() {
      if (wpController.isRepView) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangeCallerId,
          ute.common.permissions.service.RamActionCodes.start)
          .then(function (agentPermission) {
            wpController.canChangeCallerId = agentPermission;
            console.log('checkPermission setting to agentPermission - ' + wpController.canChangeCallerId);
          });
      } else {
        wpController.canChangeCallerId = true;
        console.log('checkPermission setting true - ' + wpController.canChangeCallerId);
      }
    }

    function getSEEDiscount() {
      return _.find(dataManagerSeeService.discounts, function (item) {
        if (item.subscriberNumber.toString() === userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)) {
          return item;
        }
      });
    }

    function messageBoxDom() {
      var loginDom;
      var deviceBalanceDom;
      var loginDirection;
      if (wpController.isDealer) {
        loginDirection = $translate.instant('ssp');
      } else if (wpController.isCare) {
        loginDirection = $translate.instant('v21');
      }
      // to chnage the login link text based on the laguage
      if (wpController.lng === 'en') {
        loginDom = '<div class="info-box-col login-text"><div>' + $translate.instant('login') + '</div>' +
          '<div><strong> ' + $translate.instant('to') + ' ' + loginDirection + '</strong></div>' +
          '</div>';
        deviceBalanceDom = '<div><strong>' + $translate.instant('device') + '</strong></div>' +
          '<div><strong>' + $translate.instant('balance') + '</strong></div>';
      } else {
        loginDom = '<div class="info-box-col login-text"><div>' + $translate.instant('login_to') + '</div>' +
          '<div><strong> ' + loginDirection + '</strong></div>' +
          '</div>';
        deviceBalanceDom = '<div><strong>' + $translate.instant('device_balance') + '</strong></div>';
      }

      // for info box message

      if (wpController.isDealer) {
        wpController.loginMsg = $translate.instant('login_to') + ' ' + '<strong>' + $translate.instant('ssp') + '</strong>';
      } else if (wpController.isCare) {
        wpController.careUpgradeMessage = '<div class="info-box-header">' +
          '<strong><span class="header-tab">' + $translate.instant('to_upgrade') +
          ':</span></strong>' +
          '</div>' +
          '<div class="info-box-body">' +
          '<div class="info-box-col">' +
          '<div><strong>' + $translate.instant('device') + '</strong></div></div>' +
          '<div class="info-box-col"><img src="images/message-arrow.png"/></div>' +
          '<div class="info-box-col login-text">' +
          $translate.instant('login_to') + ' ' +
          '<strong>' + $translate.instant('v21') + '</strong></div>' +
          '</div>';

        wpController.careCheckMessage = '<div class="info-box-header">' +
          '<strong><span class="header-tab">' + $translate.instant('to_check') +
          ':</span></strong>' +
          '</div>' +
          '<div class="info-box-body">' +
          '<div class="info-box-col">' +
          '<div><strong>' + $translate.instant('device_balance') + '</strong></div></div>' +
          '<div class="info-box-col"><img src="images/message-arrow.png"/></div>' +
          '<div class="info-box-col login-text">' +
          $translate.instant('log_in_to_telli') + '</div>' +
          '</div>';

        wpController.loginMsg = $translate.instant('login_to') + ' ' +
          '<strong>' + $translate.instant('v21') + '</strong>';
      }

      wpController.upgradeMessage = '<div class="info-box-header">' +
        '<span class="header-tab"><strong>' + $translate.instant('to_upgrade') +
        ':</strong></span><span><strong>' + $translate.instant('to_check') + ':</strong></span>' +
        '</div>' +
        '<div class="info-box-body">' +
        '<div class="info-box-col info-box-border"><strong>' +
        $translate.instant('device') + '</strong></div>' +
        '<div class="info-box-col">' +
        deviceBalanceDom + '</div>' +
        '<div class="info-box-col"><img src="images/message-arrow.png"/></div>' +
        loginDom + '</div>';

      wpController.reserveDeviceMsg = '<span class="green-text">' + $translate.instant('to_reserve_device') +
        '</span> ' + $translate.instant('login_to_v21');

      wpController.loginV21Msg = $translate.instant('login_to') + ' ' +
        '<strong>' + $translate.instant('v21') + '</strong>';
    }

    function openPPCFlow(resumeOrder, planSoc) {
      // the following obj will be saved in backend and will be fetched in PPC SPA again
      var appStateForPPC = {
        ban: '',
        ctn: '',
        accountTypeNumber: '',
        flow: 'PPC',
        eligibilityChecked: 'false',
        availableCreditAmount: 0,
        ctnList: []
      };
      /*var date = new Date();
      cookieStore.put('ppc__dashboard', true, {
        path: '/web/totes',
        end: new Date(date.setTime(date.getTime()+(20*60*1000))) // 30 mins expiry time
      });*/
      sessionStorage.setSessionStorageValue('ppc__dashboard', 'wirelessDashboard'); //Track this session Value in PPC code.
      wpController.changeBtnLoading(true);
      bfappcWirelessDashboardService.gotoBFAPPC(appStateForPPC, resumeOrder, planSoc).then(
        function () {
          wpController.changeBtnLoading(false);
        },
        function (q2ppcBrtSwitch) {
          // BFA-PPC BRT switch is off
          if (q2ppcBrtSwitch) {
            //if q2PPC itself is on BRT we should only display a msg
            wpController.openChangePlanModal();
          } else {
            cookieStore.put('PPCFromWpCtrl', true, {
              path: '/web/totes'
            });
            if (planSoc != null && planSoc !== undefined && planSoc !== '') {
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan?soc=planSoc';
            } else {
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan';
            }
          }
          wpController.changeBtnLoading(false);
        }
      );
    }

    function reactivateConfigure() {
      reactivateCtnService.configure({
        advanced: {
          reactivateCtnSuccess: {
            templateUrl: reactivateCtnService.getConfig().advanced.repViewReactivateCtnSuccess.templateUrl
          },
          reactivateCtnError: {
            templateUrl: reactivateCtnService.getConfig().advanced.repViewReactivateCtnError.templateUrl
          }
        }
      });
    }

    function checkForSavedCart() {
      var request = {
        'key': 'cartDetails',
        'context': {
          'ctn': wpController.wirelessDashActive.ctn,
          'ban': wpController.wirelessDashActive.ban
        }
      };
      var popupObj = {};
      ajax.hupGetState(request)
        .then(function (data) {
          if (data && data.success && !data.errorMessage) {
            if ((data.phone && !data.phone.valid) || (data.plan && !data.plan.valid) || (data.addons && !data.addons.valid)) {
              popupObj = {};
              wpController.errorMessage = $translate.instant('hup_save_cart_offers_changed');
              $scope.showChatCallIcon = true;
              $scope.showButtons = true;
              popupObj.preCloseCallback = function () {
                $scope.showChatCallIcon = false;
                $scope.showButtons = false;
                hupSaveState(function (data) {
                  $window.location.href = '/web/totes/upgrade/#/choose-phone';
                  /* if (data.phone && data.phone.valid) {
                     $window.location.href = '/web/totes/upgrade/#/build-plan';
                   } else {
                     $window.location.href = '/web/totes/upgrade/#/choose-phone';
                   }*/
                });
              };
              openGenericErrorPopup(popupObj);
            }/* else if (data.phone && data.phone.valid) {
              hupSaveState(function () {
                $window.location.href = '/web/totes/upgrade/#/choose-phone';
              });
            }*/ else {
              hupSaveState(function () {
                $window.location.href = '/web/totes/upgrade/#/choose-phone';
              });
            }
          } else {
            popupObj = {};
            wpController.errorMessage = $translate.instant('hup_save_cart_offers_changed');
            $scope.showChatCallIcon = true;
            $scope.showButtons = true;
            popupObj.preCloseCallback = function () {
              $scope.showChatCallIcon = false;
              $scope.showButtons = false;
              hupSaveState(function (data) {
                $window.location.href = '/web/totes/upgrade/#/choose-phone';
                /*    if (data.phone && data.phone.valid) {
                      $window.location.href = '/web/totes/upgrade/#/choose-phone';
                    } else {
                      $window.location.href = '/web/totes/upgrade/#/choose-phone';
                    }*/
              });
            };
            openGenericErrorPopup(popupObj);
          }
        })
        .catch(function (error) {
          showGenericErrorMessage(true);
        });
    }

    function showGenericErrorMessage(redirecToDeviceCatalog) {
      var popupObj = {};
      wpController.errorMessage = $translate.instant('generic_error_message');
      if (redirecToDeviceCatalog) {
        popupObj.preCloseCallback = function () {
          hupSaveState(function (data) {
            $window.location.href = '/web/totes/upgrade/#/choose-phone';
          });
        };
      }
      openGenericErrorPopup(popupObj);
    }

    function openGenericErrorPopup(obj) {
      var genericErrorPopup = {
        template: (obj.template) ? obj.template : 'views/genericErrorPopup.html',
        scope: (obj.scope) ? obj.scope : $scope,
        className: (obj.className) ? obj.className : 'generic-error-theme ngdialog-theme-default',
        showClose: (obj.showClose) ? obj.showClose : true,
        appendTo: (obj.appendTo) ? obj.appendTo : 'div[ui-view]',
        closeByDocument: (obj.closeByDocument) ? obj.closeByDocument : false,
        preCloseCallback: (obj.preCloseCallback) ? obj.preCloseCallback : function () {

        }
      };
      wpController.restoreCartloadingIndicator = false;
      ngDialog.open(genericErrorPopup);
    }

    function hupSaveState(successCallback, errorCallback) {
      var request = {
        'key': 'hupState',
        'context': {
          'ctn': (wpController.heroFlow) ? localStorage.getLocalStorageValue('phoneNumber') : wpController.wirelessDashActive.ctn,
          'ban': wpController.wirelessDashActive.ban
        }
      };
      ajax.hupSaveState(request)
        .then(function (data) {
          if (successCallback) {
            successCallback(data);
          }
        })
        .catch(function (error) {
          if (errorCallback) {
            errorCallback(error);
          } else if (successCallback) {
            successCallback(error);
          }
        });
    }

    function NFDBerror(error) {
      dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
      notEligibleDeviceUpgrade('NFDB');
    }

    function NFDBCheckResolve(data) {
      var hupEligibilityChecks = [];
      if (angular.isDefined(data) && data.isNFDBExistInd) {
        dtmService.exception('actv-bfa-ml hup-error', 'SS | ' + 'Open Hup Page error');
        notEligibleDeviceUpgrade('NFDB');
        return;
      }
      var request = {
        refresh: false,
        accountNumber: wpController.wirelessDashActive.ban,
        phoneNumber: (wpController.heroFlow) ? localStorage.getLocalStorageValue('phoneNumber') : wpController.wirelessDashActive.ctn,
        nfdbCaching: true,
        activityType: 'HUP'
      };

      if (wpController.isDealer) {
        request.applicationId = "UTERogersRetail";
      } else if (wpController.isCare) {
        request.applicationId = "UTERogersCare";
      } else if (wpController.isConsumer) {
        request.applicationId = "UTERogersOnline";
      }

      hupEligibilityChecks.push(ajax.checkHupEligibility(request));
      if (wpController.isCare || wpController.isDealer) {
        var requestBOT = {
          accountNumber: (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)).toString(),
          lang: wpController.lng.toUpperCase()
        };
        hupEligibilityChecks.push(ajax.checkBOTEligibility(requestBOT));
        utePersistentStorageService.putToSession('botFlowType', 'HUP'); //BCR-693 Analytics: To check the flow type for getCases API whether its HUP or PPC, so to track response accordingly
      }
      $q.all(hupEligibilityChecks)
        .then(function (response) {
          if (response.length === 1) {
            checkHupEligibilityResolve(response[0], null);
          }
          else {
            checkHupEligibilityResolve(response[0], response[1]);
          }
        })
        .catch(function (error) {
          checkHupEligibilityError(error);
        });
    }

    function checkHupEligibilityResolve(data, botData) {
      isBOTEligible = false;
      isCaseClosed = false;
      if (data === null || data.isHupEligibilityError || data.hupErrorCode === 'HNA') {
        notEligibleDeviceUpgrade(data.hupErrorCode);
        return;
      }
      if (botData !== null && botData !== undefined) {
        openCase = {};
        angular.forEach(botData.getCasesResponse.cases._case, function (value, key) {
          if ((value.caseStatus.toLowerCase() === 'new' ||
            value.caseStatus.toLowerCase() === 'in progress' ||
            value.caseStatus.toLowerCase() === 'new case') &&
            (value.caseTypeLevel3.toLowerCase() === 'hup' ||
              value.caseTypeLevel3.toLowerCase() === 'price plan change')) {
            isBOTEligible = true;
            openCase = value;
          }
        });
        if (isBOTEligible) {
          notEligibleDeviceUpgrade('bot_eligible');
          return;
        }
      }
      if (wpController.isHupFlowProcessSaved && !wpController.heroFlow) {
        checkForSavedCart();
      } else {
        hupSaveState(function (data) {
          var heroOfferObj = wpController.heroHupFlowObj;
          if (heroOfferObj && heroOfferObj.phoneSku) {
            if (!wpController.heroTvmHupFlow) {
              var pricePlanUrl = '?phoneSku=' + heroOfferObj.phoneSku;
              if (heroOfferObj.programCode) {
                pricePlanUrl = pricePlanUrl + '&programCode=' + heroOfferObj.programCode;
              }
              if (heroOfferObj.programCode && heroOfferObj.term && heroOfferObj.categoryCode) {
                pricePlanUrl = pricePlanUrl + '&sliderValue=' + heroOfferObj.term + heroOfferObj.categoryCode + heroOfferObj.programCode;
              }
              if (heroOfferObj.bpoID) {
                pricePlanUrl = pricePlanUrl + '&bpoSoc=' + heroOfferObj.bpoID;
              }
              console.log("Deeplink params for HUP Only :" + pricePlanUrl);
              $window.location.href = '/web/totes/upgrade/#/build-plan' + pricePlanUrl;
            } else {
              var phoneSkuParam = heroOfferObj.phoneSku;
              var planSoc = heroOfferObj.planSoc;
              console.log("planSocParam :" + phoneSkuParam);
              var pricePlanUrl = '?phoneSku=' + heroOfferObj.phoneSku;
              if (heroOfferObj.programCode) {
                pricePlanUrl = pricePlanUrl + '&programCode=' + heroOfferObj.programCode;
              }
              if (heroOfferObj.planSoc) {
                pricePlanUrl = pricePlanUrl + '&planSoc=' + heroOfferObj.planSoc;
              }
              if (heroOfferObj.bpoID && heroOfferObj.bpoID != '') {
                pricePlanUrl = pricePlanUrl + '&bpoSoc=' + heroOfferObj.bpoID;
              }
              if (heroOfferObj.tvmBpoID && heroOfferObj.tvmBpoID != '') {
                pricePlanUrl = pricePlanUrl + '&tvmBpoSoc=' + heroOfferObj.tvmBpoID;
              }
              console.log("Deeplink params for HUP and TVM :" + pricePlanUrl);
              $window.location.href = '/web/totes/upgrade/#/build-plan' + pricePlanUrl;
            }
          } else {
            $window.location.href = '/web/totes/upgrade/#/choose-phone';
          }
        });
      }
    }

    function isCtnHasSavedCart() {
      var savedCartObj = bfappcWirelessDashboardService.getFetchOrderFullResponse().hup;
      var ctnHasSavedCart = false;
      if (savedCartObj && savedCartObj.length > 0) {
        angular.forEach(savedCartObj, function (value, index) {
          if (_.contains(value.assemblyIds, wpController.wirelessDashActive.ctn) && !value.quotation) {
            ctnHasSavedCart = true;
          }
        });
      } else {
        ctnHasSavedCart = false;
      }
      return ctnHasSavedCart;
    }

    function checkHupEligibilityError(error) {
      notEligibleDeviceUpgrade();//handling when ajax call fails
    }

    function notEligibleDeviceUpgrade(errorCode) {
      //Function handles three scenarios
      /*1. Hup not eligible general
       2. HUp Not Eligible with HNA error code
       3. NFDB Fraud customer
       */
      hupDetails = {}; //TODO: it is being used in wirelessDashPopup.html
      if (wpController.isCare || wpController.isDealer) {
        hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message_care');
      } else {
        hupDetails.errorMessage = $translate.instant('is_not_eligible_device_upgrade_error_message');
      }
      //hupDetails.contactNumber = $translate.instant('800_number');
      hupDetails.contactNumber = $translate.instant('800_number_hup_new');
      wpController.upgradeDeviceObjloadingIndicator = false;
      wpController.restoreCartloadingIndicator = false;
      if (errorCode) {
        var errorValue;
        if ('A' === errorCode.toUpperCase() || 'ERROR_HUP_NOT_ELIGIBLE' === errorCode.toUpperCase()) {
          hupDetails.errorMessage = $translate.instant('hup_errorCode_A_desc');
        } else if ('F' === errorCode.toUpperCase()
          || 'J' === errorCode.toUpperCase()
          || 'ERROR_CTN_LAST_HUP' === errorCode.toUpperCase()) {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('hup_errorCode_FJ_desc');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('error_ctn_last_hup_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_last_hup_retail');
          }
        } else if ('ERROR_CTN_ACTIVATION' === errorCode.toUpperCase()) {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('hup_errorCode_FJ_desc');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('error_ctn_activation_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_activation_retail');
          }
        } else if ('D' === errorCode.toUpperCase() || 'ERROR_HUP_NOT_ELIGIBLE' === errorCode.toUpperCase()) {
          hupDetails.errorMessage = $translate.instant('hup_errorCode_D_desc');
        } else if ('L' === errorCode.toUpperCase() || 'ERROR_CTN_PENDING_DEACTIVATION' === errorCode.toUpperCase()) {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('hup_errorCode_L_desc');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_deactivation_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_deactivation_retail');
          }
          hupDetails.contactNumber = $translate.instant('hup_errorCode_L_contact_number');
        } else if ('G' === errorCode.toUpperCase() || 'ERROR_HUP_NOT_ELIGIBLE' === errorCode.toUpperCase()) { //TODO: have to check regarding G error code.  /*to remove the comment*/
          hupDetails.errorMessage = $translate.instant('hup_errorCode_G_desc');
        } else if ('T' === errorCode.toUpperCase()) {
          hupDetails.errorMessage = $translate.instant('hup_errorCode_T_desc');
        } else if ('N' === errorCode.toUpperCase() || 'ERROR_CTN_PENDING_HUP' === errorCode.toUpperCase()) {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('hup_errorCode_N_desc');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_hup_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_hup_retail');
          }
        } else if (errorCode === 'HNA') {
          hupDetails.errorMessage = $translate.instant('hna_error_message');
        } else if (errorCode.toUpperCase() === 'CTN_SUSPENDED') {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('ctn_suspended_consumer');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('ctn_suspended_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('ctn_suspended_retail');
          }
        } else if (errorCode.toUpperCase() === 'ERROR_CTN_PENDING_PORT_IN') {
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_port_in_consumer');
          } else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_port_in_care');
          } else if (wpController.isDealer) {
            hupDetails.errorMessage = $translate.instant('error_ctn_pending_port_in_retail');
          }
        } else if (errorCode === 'NFDB') {
          hupDetails.nfdb = 'NFDB';
          if (wpController.isConsumer) {
            hupDetails.errorMessage = $translate.instant('is_NFDB_check_error_message');
            hupDetails.contactNumber = $translate.instant('is_NFDB_check_contact_Number');
          }
          else if (wpController.isCare) {
            hupDetails.errorMessage = $translate.instant('is_NFDB_check_error_message_care');
          }
          else {
            hupDetails.errorMessage = $translate.instant('is_NFDB_check_error_message_retail');
          }
        } else if (errorCode === 'bot_eligible') {
          // BCR-158 changes - CQUSR01466901 pending business content for HUP Case
          errorValue = (openCase.caseTypeLevel3.toLowerCase() === 'hup') ? 'hup_bot_message_hup' : 'hup_bot_message_ppc';
          hupDetails.errorMessage = $translate.instant(errorValue);
        } else if ((errorCode.toLowerCase() === 'ban_delinquent' || errorCode.toLowerCase() === 'ban_suspended' || errorCode.toLowerCase() === 'error_hup_not_eligible') &&
          repMakePaymentAccess &&
          !disableMakePayment) {
          hupDetails.isMakePaymentAvailable = true;
          if (!wpController.isRepView) {
            hupDetails.customer = $translate.instant(errorCode.toLowerCase() + '_customer');
          } else if (wpController.isRepView) {
            hupDetails.rep = $translate.instant(errorCode.toLowerCase() + '_rep');
          }
          hupDetails.first = $translate.instant(errorCode.toLowerCase() + '_first');
          hupDetails.last = $translate.instant(errorCode.toLowerCase() + '_last');
          wirelessDashPopup.disableAnimation = true;
          $rootScope.hupError = true;
        } else if ((errorCode.toLowerCase() === 'error_ban_billing_address_retail' || errorCode.toLowerCase() === 'error_ban_billing_address_care' || errorCode.toLowerCase() === 'error_ban_billing_address')
          && repMakePaymentAccess && !disableMakePayment) {
          hupDetails.isMakePaymentAvailable = true;
          if (wpController.isRepView) {
            hupDetails.banAddressRep = $translate.instant('error_ban_billing_address_rep');
          } else {
            hupDetails.banAddressCustomer = $translate.instant('error_ban_billing_address_customer');
          }
          $rootScope.hupError = true;
        } else {
          errorValue = (wpController.isCare) ? errorCode.toLowerCase() + '_care' : (wpController.isDealer) ? errorCode.toLowerCase() + '_retail' : errorCode.toLowerCase();
          hupDetails.errorMessage = $translate.instant(errorValue);
        }
      }
      /**
       * Add DTM Tracking for HUP
       * JIRA: https://rogers.atlassian.net/browse/NPS-1332
       */
      dtmService.setVar('error', hupDetails.errorMessage + '|HUP');
      dtmService.direct(dtmBuyFlowError);
      if (errorCode === 'bot_eligible') {
        wirelessDashPopup.className = "ngdialog-theme-default wireless-hup-elig bot-eligible";
      }
      else {
        wirelessDashPopup.className = 'ngdialog-theme-default wireless-hup-elig';
      }
      ngDialog.open(wirelessDashPopup);
    }

    function upgradeDeviceFlow(phoneSku) {
      var request = {
        refresh: false,
        accountNumber: wpController.wirelessDashActive.ban,
        phoneNumber: (wpController.heroFlow) ? localStorage.getLocalStorageValue('phoneNumber') : wpController.wirelessDashActive.ctn,
        nfdbCaching: true,
        activityType: 'HUP'
      };
      ajax.isNFDBCheck(request).then(NFDBCheckResolve, NFDBerror);
    }

    function isRogersInstallmentCustomer(subsidyVO) {
      return angular.isObject(subsidyVO) && (subsidyVO.initialInstallmentAmount > 0 && subsidyVO.subsidyTerm !== 0 && !subsidyVO.subsidyAmount);
    }

    function isValidDateFormat(dateToCheck) {
      var regExp1 = /^(\d{2})[\/](\d{2})[\/](\d{4})$/.exec(dateToCheck);
      var isValid = false;
      if (regExp1 !== null) {
        var d = regExp1[1];
        var m = regExp1[2] - 1;
        var y = regExp1[3];
        var composedDate = new Date(y, m, d);
        isValid = composedDate.getDate() === d &&
          composedDate.getMonth() === m &&
          composedDate.getFullYear() === y;
      }
      return isValid;
    }

    /* function getsubsidyDates(subsidyDate) {
       var subsidyDates = null;
       if (!!subsidyDate) {
         var isValid = isValidDateFormat(subsidyDate);
         if (isValid) {
           var array = subsidyDate.split('/');
           var dateObj = new Date(array[2], array[1] - 1, array[0]);
           subsidyDates = formatDateWireless(dateObj);
         } else {
           subsidyDates = formatDateWireless(subsidyDate);
         }
       }
       return subsidyDates;
     }*/

    function setDeviceInfoIcon(subsidyVO, isRogersInstallmentCustomer) {
      var flexMonthlyPayment = 0.0;
      var flexTerm = 0;
      var flexMonthsRemain = 0;
      var flexMonthlyInstallment = 0;
      var vo = {};
      if (!isRogersInstallmentCustomer) {
        if (subsidyVO !== null) {
          if (subsidyVO.subsidyTerm !== 0) {
            flexMonthlyPayment = subsidyVO.subsidyAmount / subsidyVO.subsidyTerm;
          }
          if (flexMonthlyPayment > 0.0) {
            flexMonthsRemain = subsidyVO.remainingInstallmentBalance / flexMonthlyPayment;
          }
          flexTerm = subsidyVO.subsidyTerm;
        }
        flexMonthlyPayment = flexMonthlyPayment.toFixed(2);
        vo.flexTab1 = wpController.formatCurrency(flexMonthlyPayment);
        vo.flexTab2 = flexTerm + ' ';
        vo.flexTab3 = ' {' + flexMonthsRemain.toFixed(0) + '} x {' + wpController.formatCurrency(flexMonthlyPayment) + '}';
        vo.showFlexTabInfoBox = true;
        vo.showRogersNextInfoBox = false;
      }
      else {
        flexMonthlyInstallment = subsidyVO.monthlyInstallmentAmount;
        flexTerm = subsidyVO.subsidyTerm;
        if (flexMonthlyInstallment > 0.0) {
          //TODO:need to check with the business LOGIC
          flexMonthsRemain = subsidyVO.remainingInstallmentBalance / flexMonthlyInstallment;
        }
        vo.showFlexTabInfoBox = false;
        vo.showRogersNextInfoBox = true;
        vo.rogersNext1 = wpController.formatCurrency(flexMonthlyInstallment);
        vo.rogersNext2 = flexTerm + ' ';
        vo.rogersNext3 = ' {' + flexMonthsRemain.toFixed(0) + '} x {' + wpController.formatCurrency(flexMonthlyInstallment) + '}';
      }
      return vo;
    }

    function formatDateWireless(dateObj) {
      var monthNames;
      var formattedDate = '';
      monthNames = util.getMonthsNames();
      if (typeof dateObj !== 'undefined' && dateObj !== null && dateObj !== '' && typeof dateObj !== 'string') {
        formattedDate = monthNames[dateObj.getMonth()] + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear();
      } else if (typeof dateObj === 'string' && dateObj !== null && dateObj !== '') {
        dateObj = new Date(dateObj);
        formattedDate = monthNames[dateObj.getMonth()] + ' ' + dateObj.getDate() + ', ' + dateObj.getFullYear();
      }
      return formattedDate;
    }

    function getSeeBrtShowState() {
      seeBrtShowState = true;
    }

    function getCurrentPlan() {
      var postData = {
        ban: wpController.ban,
        ctn: wpController.ctn,
        language: wpController.lng,
        consolidatedInd: 'NO'
      };
      cacheableData({ url: 'v1/ppc/priceplans/current', postData: postData })
        .getData().then(function (response) {
          if (response && response.data) {
            currentPlan = response.data;
          }
        });
    }

    // function handleBfaSso() {
    //   var flowType = ssoService.getFlowType();
    //
    //   if (flowType) {
    //     ssoService.reset();
    //     var unwatchFetchOrder = $scope.$watch('wpController.isFetchOrderCompleted()', function (val) {
    //       if (val) {
    //         if (flowType === 'ppc' && !wpController.wpkg_client.planSuspended && wpController.isFetchOrderCompleted() && !wpController.hasTargetedTvmOffer) {
    //           var resumeOrder = wpController.hasPPCOrder() && wpController.isFetchOrderCompleted();
    //           wpController.openPPC(resumeOrder);
    //         } else if (flowType === 'hup') {
    //           wpController.openHUP()
    //         }
    //         unwatchFetchOrder();
    //       }
    //     });
    //   }
    // }

    function init() {
      dtmBuyFlowError = 'fdm-bf-error';
      holder = null;
      request = {};
      wpkg_rawData = null;
      disableMakePayment = true;
      wpkg_clientBkp = {};
      hasDSGAccess = false;
      hasDCAccess = false;
      repMakePaymentAccess = true;
      currentPlan = null; // added for SEE project to display discounted price
      planSoc = null;
      seeBrtShowState = false;
      isBOTEligible = false;
      isCaseClosed = false;
      hupDetails = {};
      openCase = {};

      //it is being used in wirelessDashPopup.html
      wirelessDashPopup = {
        template: 'scripts/directives/wirelessPackage/wirelessDashPopup.html',
        controller: 'wirelessDashPopupCtrl',
        controllerAs: 'vm',
        resolve: {
          isBOTEligible: function () {
            return isBOTEligible;
          },
          isCaseClosed: function () {
            return isCaseClosed;
          },
          hupDetails: function () {
            return hupDetails;
          },
          isHupFlowProcessSaved: function () {
            return wpController.isHupFlowProcessSaved;
          },
          caseID: function () {
            return openCase && openCase.caseID ? openCase.caseID : '';
          },
          notEligibleDeviceUpgrade: function () {
            return notEligibleDeviceUpgrade; //fn
          },
          hupSaveState: function () {
            return hupSaveState; //fn
          },
          checkForSavedCart: function () {
            return checkForSavedCart; //fn
          }
        },
        className: 'ngdialog-theme-default',
        showClose: false,
        appendTo: 'div[ui-view]',
        closeByDocument: true
      };

      wpController.lng = languageSwitcher.getCurrentLanguage();
      wpController.isOpenPackage = false;
      wpController.isOpenMyDevice = false;

      wpController.isDealer = userService.isDealer();
      wpController.isCare = userService.isCare();
      wpController.isRepView = userService.isRepView();
      wpController.isConsumer = userService.isConsumer();

      wpController.canChangeCallerId = false;

      activate();
      checkPermissionCallerID();

      wpController.pathToWirelessMyPackageSectionUrl = 'scripts/directives/wirelessPackage/wirelessMyPackage.partial.html';
      wpController.pathToManageMyDeviceSectionUrl = 'scripts/directives/wirelessPackage/wirelessManageMyDevice.partial.html';
      wpController.pathToWirelessSubscriptionDetailsUrl = 'scripts/directives/wirelessPackage/wirelessSubscriptionDetails.rep.partial.html';

      wpController.wpkg_wd = null;
      wpController.wpkg_client = null;
      // wpController.flags.wpkg_loadingDataIndicatorPackage = true; //TODO: is being change from 2 other files as well!
      wpController.flags.wpkg_loadingDataIndicatorDevice = true; //TODO: is being change from 2 other files as well!
      wpController.changeBtnLoading = bfappcWirelessDashboardService.changeBtnLoading;
      wpController.wpkg_errorMessageWirelessPackage = undefined;
      wpController.wpkg_my5 = {};
      wpController.fraudSocErrorMessage = null; // need to remain on scope not on wpController as it is being exposed outside of directive
      wpController.isFraudSocAvailable = false; // need to remain on scope not on wpController as it is being exposed outside of directive
      wpController.showBalanceSection = true;
      wpController.balanceObj = {};
      wpController.permissionsObj = {};
      wpController.hideWirelessTravelPackage = true;
      wpController.abdf = myrAccountBalanceDataFactory; //TODO: it's on viewModel only for make it watchable - can be removed from viewModel (keep it as a var) after removing watch

      wpController.isHupFlowProcessSaved = false;

      wpController.repChangeSIMRead = false;
      wpController.repChangeSIMUpdate = false;

      wpController.hupDisabled = true;
      wpController.repPpcAccess = false;
      wpController.repHupAccess = false;
      wpController.unEnrollPermission = false;
      wpController.heroFlow = false;
      wpController.heroTvmHupFlow = false;
      wpController.heroHupFlowObj = {};
     
      wpController.repairDeviceEnabled = false  //DC-1672 Repair link modernization
      /**
       * set the permission service call url to use unprotected path based on isDealer or isCare
       */
      if (wpController.isDealer || wpController.isCare) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PPCBuyFlow, ute.common.permissions.service.RamActionCodes.start)
          .then(function (agentPermission) {
            wpController.repPpcAccess = agentPermission;
          });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.HUPBuyFlow, ute.common.permissions.service.RamActionCodes.start)
          .then(function (agentPermission) {
            wpController.repHupAccess = agentPermission;
          });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
          .then(function (agentPermission) {
            hasDCAccess = agentPermission;
          });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.mandatory)
          .then(function (agentPermission) {
            hasDSGAccess = agentPermission;
          });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.MakePayment, ute.common.permissions.service.RamActionCodes.start)
          .then(function (agentPermission) {
            repMakePaymentAccess = agentPermission;
          });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RoamLikeHome, ute.common.permissions.service.RamActionCodes.remove)
          .then(function (agentPermission) {
            wpController.unEnrollPermission = agentPermission;
          });

      }

      if (wpController.isCare) {
        //adding changeSIM permission check for Care Only
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangeSIM, ute.common.permissions.service.RamActionCodes.read)
          .then(function (agentPermission) {
            wpController.repChangeSIMRead = agentPermission;
          });

        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangeSIM, ute.common.permissions.service.RamActionCodes.update)
          .then(function (agentPermission) {
            wpController.repChangeSIMUpdate = agentPermission;
          });
      }

      var unregisterIsRepViewWatch;
      if (wpController.isDealer || wpController.isCare) {
        unregisterIsRepViewWatch = $rootScope.$watch('isRepView', function () {
          wpController.isRepView = userService.isRepView();
        });
      }

      var scopewatch1 = $scope.$watch('wpController.abdf.accountBalance', function () {
        if (wpController.abdf.accountBalance) {
          disableMakePayment = false;
        }
      });

      var scopewatch2 = $scope.$watchGroup(['wpController.isFetchOrderCompleted()', 'wpController.permissionsObj', 'wpController.wirelessDashActive.ctn'], function (newValue, oldValue) {
        wpController.isHupFlowProcessSaved = !!(newValue !== oldValue && !_.isEmpty(wpController.permissionsObj) &&
          newValue[0] && !_.isUndefined(bfappcWirelessDashboardService.getFetchOrderFullResponse().hup) &&
          bfappcWirelessDashboardService.getFetchOrderFullResponse().hup.length > 0 && isCtnHasSavedCart());
      });

      bfappcWirelessDashboardService.clean();
      bfappcWirelessDashboardService.fetchOrder();

      messageBoxDom();

      wpController.isFetchOrderCompleted = bfappcWirelessDashboardService.isFetchOrderCompleted;

      var openPPCDebounce = _.debounce(wpController.openPPC, 1000, true);
      var var1 = $rootScope.$on('wireless-dashboard-change-plan', function () {
        openPPCDebounce();
      });

      permissionsService.getUserPermissions().then(function (data) {
        wpController.permissionsObj = data;

       
      //Permissions for repair link DC-1672 start
      if (data.permissions && data.permissions.length && _.find(data.permissions, function (obj) {
        return obj.permission === 'ROGERS_REPAIR_DEVICE_ENABLED';
      })){
        wpController.repairDeviceEnabled = true;
      }
         //Permissions for repair link DC-1672 end
      });

      var var2 = $rootScope.$on('setTravelPackageDataHasPlan', function () {
        wpController.travelPackageDataHasPlan = true;
      });

      var var3 = $rootScope.$on('unSetTravelPackageDataHasPlan', function () {
        wpController.travelPackageDataHasPlan = false;
      });

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        messageBoxDom();
        wpController.lng = lang;

        processLanguageLabels();

        if (wpController.wpkg_errorMessageWirelessPackage) {
          wpController.wpkg_errorMessageWirelessPackage = $translate.instant('error_wireless_package_device');
        } else {
          wpController.wpkg_errorMessageWirelessPackage = undefined;
        }

        var stateName = userService.getPersistentService().get('toStateName');
        console.log('Target State - ' + stateName);
        if (stateName === 'wireless' || stateName === 'shareEverything.dashboard') {
          openHeroModal(false); // Trigger Targeted Offers on language change
        }

      }, 'wirelessPackageControllerLangSub_' + $scope.$id);

      $scope.$on('$destroy', function () {
        if (typeof unregisterIsRepViewWatch === 'function') { unregisterIsRepViewWatch(); }
        if (typeof var1 === 'function') { var1(); }
        if (typeof var2 === 'function') { var2(); }
        if (typeof var3 === 'function') { var3(); }

        languageSwitcher.unregisterOnDataChangeHandler('wirelessPackageControllerLangSub_' + $scope.$id);

        //n Remove any watchers
        scopewatch1();
        scopewatch2();
        if (typeof heroOfferSelected === 'function') { heroOfferSelected(); }
        if (typeof hupHeroOfferSelected === 'function') { hupHeroOfferSelected(); }
        if (typeof hupTvmHeroOfferSelected === 'function') { hupTvmHeroOfferSelected(); }
        if (typeof heroResponse === 'function') { heroResponse(); }
        if (typeof heroRedirectUrl === 'function') { heroRedirectUrl(); }
      });

      if (wpController.isShareEverything()) {
        getSeeBrtShowState();
        getCurrentPlan();
      }
      //openHeroModal(false);
    }

    heroOfferSelected = $rootScope.$on('heroOfferSelected', function (evt, data) {
      console.log("inside rogers Hero modal emit");
      var tvmOfferObject = {};
      for (var i = 0; i < data.length; i++) {
        if (data[i].offerName == "tvmOffer") {
          tvmOfferObject.planSoc = data[i].externalId;
          if (data[i].bpoID != '') {
            tvmOfferObject.bpoID = data[i].bpoID;
          }
        }
      }
      wpController.openPPC(false, tvmOfferObject);

    });

    hupHeroOfferSelected = $rootScope.$on('hupHeroOfferSelected', function (evt, data) {
      console.log("inside rogers Hero modal emit -hup");
      wpController.heroFlow = true;
      var hupOfferObject = {};
      for (var i = 0; i < data.length; i++) {
        if (data[i].offerName == "hupOffer") {
          hupOfferObject.phoneSku = data[i].externalId;
          hupOfferObject.programCode = data[i].programCode;
          hupOfferObject.term = data[i].term;
          hupOfferObject.categoryCode = data[i].categoryCode;
          if (data[i].bpoID != '') {
            hupOfferObject.bpoID = data[i].bpoID;
          }
        }
      }
      wpController.heroHupFlowObj = hupOfferObject;
      wpController.upgradeDevice(hupOfferObject);

    });

    hupTvmHeroOfferSelected = $rootScope.$on('hup&TvmHeroOfferSelected', function (evt, data) {
      console.log("inside rogers Hero modal emit -hup");
      wpController.heroFlow = true;
      wpController.heroTvmHupFlow = true;
      var hupTvmOfferObject = {};
      for (var i = 0; i < data.length; i++) {
        if (data[i].offerName == "hupOffer") {
          hupTvmOfferObject.phoneSku = data[i].externalId;
          hupTvmOfferObject.programCode = data[i].programCode;
          hupTvmOfferObject.term = data[i].term;
          hupTvmOfferObject.categoryCode = data[i].categoryCode;
          if (data[i].bpoID != '') {
            hupTvmOfferObject.bpoID = data[i].bpoID;
          }
        }

        if (data[i].offerName == "tvmOffer") {
          hupTvmOfferObject.planSoc = data[i].externalId;
          if (data[i].bpoID != '') {
            hupTvmOfferObject.tvmBpoID = data[i].bpoID;
          }
        }

      }
      wpController.heroHupFlowObj = hupTvmOfferObject;
      wpController.upgradeDevice(hupTvmOfferObject);

    });

    heroResponse = $rootScope.$on('heroResponse', function (evt, data) {
      console.log('heroResponse received - ' + data);
      console.log('Active dashboard CTN - ' + wpController.wirelessDashActive.ctn);
      if (data && data.targetedHeroOfferMap) {
        wpController.targetedHeroOfferMap = data.targetedHeroOfferMap;
      }
      if (wpController.targetedHeroOfferMap && wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn]) {
        if (wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].hupOffer != null
          || wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].hup4BPO != null)
          wpController.hasTargetedHupOffer = true;

        if (wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].tvmOffer != null
          || wpController.targetedHeroOfferMap[wpController.wirelessDashActive.ctn].tvmBPO != null)
          wpController.hasTargetedTvmOffer = true;
      }

    });

    wpController.openTargetedHeroOffersModal = function () {
      console.log('Trigger TargetedHeroOffersModal');

      openHeroModal(true);

      //TODO: Trigger TargetedHeroOffersModal here
    };

    function openHeroModal(flag) {
      if (!flag) {
        wpController.hasTargetedHupOffer = false;
        wpController.hasTargetedTvmOffer = false;
      }
      if (wpController.isConsumer) {
        var ban = localStorage.getLocalStorageValue('accountNumber');
        var preSelectedCtn = ''
        if (flag) {
          preSelectedCtn = localStorage.getLocalStorageValue('phoneNumber');

        }
        var ctnList = [];
        var tempCtnList = [];
        var shareCtnList = [];
        var indCtnList = [];

        var shareBadgeList = dataManagerService.getBadgeList();
        var tempIndividualCtns = myrServicesService.categorizedServices.individual;
        if (!tempIndividualCtns || tempIndividualCtns.length == 0) {
          bfappcWirelessDashboardService.getSubscribers().then(
            function (subscribers) {
              if (subscribers && subscribers.length > 0) {
                subscribers.forEach(function (subscriber) {
                  if (subscriber.status === 'Active')
                    ctnList.push(subscriber.subscriberNumber);
                });
                var dataControlList = dataManagerService.getDataControlList();
                dataControlList.forEach(function (shareCtnData) {
                  tempCtnList.push(shareCtnData.ctn);
                  var shareCtn = {};
                  shareCtn.ctn = shareCtnData.ctn;
                  shareCtn.colorCode = shareCtnData.colorCode;
                  shareCtnList.push(shareCtn);
                });

                indCtnList = ctnList;
                tempCtnList.forEach(function (tempCtn) {
                  indCtnList = _.without(indCtnList, tempCtn);
                });

                var setCtnList = JSON.stringify(ctnList);
                localStorage.setLocalStorageValue('heroCtnList', setCtnList);
                var heroLang = languageSwitcher.getCurrentLanguage();
                RogersHeroModalService.getHeroDetail(ban, ctnList, shareCtnList, indCtnList, preSelectedCtn, flag, heroLang);
              }
            },
            function () {
              console.log('Subscribers call failure');
            }
          );
        } else {
          tempIndividualCtns.forEach(function (tempIndividualCtn) {
            ctnList.push(tempIndividualCtn.serviceDetail);
          });
          var dataControlList = dataManagerService.getDataControlList();
          dataControlList.forEach(function (shareCtnData) {
            tempCtnList.push(shareCtnData.ctn);
            var shareCtn = {};
            shareCtn.ctn = shareCtnData.ctn;
            shareCtn.colorCode = shareCtnData.colorCode;
            shareCtnList.push(shareCtn);
          });

          indCtnList = ctnList;
          tempCtnList.forEach(function (tempCtn) {
            indCtnList = _.without(indCtnList, tempCtn);
          });

          var setCtnList = JSON.stringify(ctnList);
          localStorage.setLocalStorageValue('heroCtnList', setCtnList);
          var heroLang = languageSwitcher.getCurrentLanguage();
          RogersHeroModalService.getHeroDetail(ban, ctnList, shareCtnList, indCtnList, preSelectedCtn, flag, heroLang);
        }
      }
    }

    heroRedirectUrl = $rootScope.$on('heroRedirectUrl', function (evt, data) {
      if (data == 'tvm') {
        wpController.openPPC(false);
      } else {
        wpController.heroFlow = true; //Required to read ctn from localstorage instead of dashboard active ctn
        wpController.upgradeDevice(null);
      }

    });

    init();
  }
})();

(function () {
  angular.module('totesApp')
    .directive('wirelessPackage', ['$log', function ($log) {
      return {
        restrict: 'E',
        replace: 'true',
        //because I have isolated the directive scope, some vars/functions need to expose to outside!
        scope: {
          ban: '=',
          ctn: '=',
          wirelessDashActive: '=',
          fraudSocErrorMessage: '=',
          isFraudSocAvailable: '=',
          flags: '=',
          showReactivateCtn: '=',
          modelForReactivateCtn: '=',
          errorMessage:'=',
          talkTextModalInfo: '=?'
        },
        templateUrl: 'scripts/directives/wirelessPackage/wirelessPackage.html',
        controller: 'WirelessPackageController',
        controllerAs: 'wpController',
        bindToController: true,
        link: function (scope) {
          // DOM or direct jQuery calls
          var scopewatch1 = scope.$watchGroup(['wpController.wirelessDashActive.ban', 'wpController.wirelessDashActive.ctn'], function () {
            scope.wpController.refresh();
          });

          //n Remove any watchers 
          scope.$on('$destroy', function () {
            scopewatch1();
          });
        }
      };
    }]);
}());


'use strict';

angular.module('totesApp')
  .directive('wirelessPlan', function () {
    return {
      restrict: 'E',
      replace: 'true',
      scope: {
        mode: '='			// 1 = postpaid / 2 = prepaid
      },
      templateUrl: 'scripts/directives/wirelessPlan/wirelessPlan.html'
    };
  })
  .controller('wirelessPlanCtrl', ['$scope',
    'settings',
    '$timeout',
    '$translate',
    'localStorage',
    'myrWirelessPrepaidService',
    'prepaidCtnCountService',
    '$rootScope',
    '$modal',
    'sessionStorage',
    'util',
    'ute.blocks.language.switcher',
    'ute.blocks.environment',
    'ute.common.user.service',
    'ssoService',
    'ute.common.permissions.service',
    'ute.datalayer.common.service','$browser',
    function ($scope,
              settings,
              $timeout,
              $translate,
              localStorage,
              wirelessPrepaidService,
              prepaidCtnCountService,
              $rootScope,
              $modal,
              sessionStorage,
              util,
              languageSwitcher,
              environmentProvider,
              userService,
              ssoService,
              permissionsService,
              dataLayerService,
              $browser) {

      $scope.showWpAddOns = false;
      $scope.dtEn = null;
      $scope.showDefaultExpireDate = false;

      $scope.vpd = {};

      $scope.wd = null;
      $scope.loadingDataIndicator = true;

      var holder = null;
      var request = {};

      $scope.postObj = {};
      if ($rootScope.isCare) {
        request.ctn = $scope.ctn = sessionStorage.getSessionStorageValue('phoneNumber');
      } else {
        request.ctn = $scope.ctn = localStorage.getLocalStorageValue('phoneNumber');
      }

      $scope.months = {
        Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
      };

      $scope.addOns = [];
      var postToRogersUrls = [
        {url: '/web/myrogers/prepaidPricePlanChange', flowId: 'PPC'},
        {url: '/web/myrogers/prepaidUpdateWirelessEssential', flowId: 'UWE'},
        {url: '/web/myrogers/prepaidTopUp', flowId: 'TOP'},
        {url: '/web/myrogers/prepaidChangeWirelessNumber', flowId: 'TNC'},
        {url: '/web/myrogers/prepaidResetPasscode', flowId: 'PCR'}
      ];
      $scope.selectedFlow = '';
      $scope.isDealer = $rootScope.isDealer;
      $scope.isCare = $rootScope.isCare;
      $scope.isConsumer = $rootScope.isConsumer;
      var newPastedDataTimerFunc;
      $scope.repairDeviceEnabled = false; //DC-1672 repair link

      $scope.postToRogers = function (actionId) {
        if ($rootScope.isDealer || $rootScope.isCare) {
          $scope.open();
          $rootScope.actionOtherThanTopUp = actionId !== 2;

        }
           if(actionId == 3) {
              var prepaidCtn={};
                prepaidCtn.accountNumber = localStorage.getLocalStorageValue('accountNumber');

                prepaidCtnCountService.getprepaidCtnCount(prepaidCtn, function (response) {
                  if(response.result=='success' && response.data.isExceeded == true) {
                    $scope.openCtnModel();
                  }

                  else {
                    if (response.result === 'fail') {
                      $scope.loadingDataIndicator = false;
                      $scope.displayContent = false;
                      holder = response.data;
                      $scope.errorMessage = 'Failed to load Wireless account data';

                    } else if (response.result === 'error') {
                      // holder = _tmp.data;
                      $scope.loadingDataIndicator = false;
                      $scope.displayContent = false;
                      $scope.errorMessage = response.message;

                    } else {
                      // Unknown state ???

                    $('#formToRogers').attr('action', postToRogersUrls[actionId].url);
                    $scope.selectedFlow = postToRogersUrls[actionId].flowId;
                    newPastedDataTimerFunc =  $timeout(function () {
                      $('#formToRogers').submit();
                    });
                  }
                  }
                });
              }
        else {
          $('#formToRogers').attr('action', postToRogersUrls[actionId].url);
          $scope.selectedFlow = postToRogersUrls[actionId].flowId;
          newPastedDataTimerFunc =  $timeout(function () {
            $('#formToRogers').submit();
          });
        }

      };

      $scope.$on('$destroy', function(){
        $timeout.cancel(newPastedDataTimerFunc);
      });

      // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
      $scope.open = function (size) {
        $rootScope.modal = $modal.open({
          templateUrl: 'views/modals/prepaidModal.html',
          controller: 'MyrWirelessPrepaidModalController',
          size: size,
          backdrop: 'static',
          backdropClass: 'bkg-modal',
          resolve: {}
        });
      };
      $scope.openCtnModel = function (size) {
        $rootScope.modal = $modal.open({
          templateUrl: 'scripts/modules/wirelessPrepaid/prepaidCtnCount/prepaidCtnCount.html',
          controller: 'MyPrepaidCtnCountController',
          size: size,
          backdrop: 'static',
          backdropClass: 'bkg-modal',
          resolve: {}
        });
      };

      $scope.formatDates = function () {
        if (!$scope.vpd.phoneSelected.expireDate) {
          $scope.showDefaultExpireDate = true;
          return;
        }

        var arrDate = $scope.vpd.phoneSelected.expireDate.split('-');
        //var mNum = $scope.months[arrDate[0]];
        //
        //$scope.dtEn = arrDate[1] + '-' + arrDate[0] + '-20' + arrDate[2];
        //$scope.dtFr = arrDate[1] + ' ' + $scope.monthsNames[mNum] + ' 20' + arrDate[2];

        var mNum1 = Number(arrDate[1]);

        $scope.dtEn = $scope.monthsNames[mNum1 - 1] + ' ' + arrDate[2] + ', ' + arrDate[0];
        $scope.dtFr = $scope.dtEn;
      };

      $scope.getWirelessPrepaid = function () {
        $scope.loadingDataIndicator = true;
        $scope.displayContent = false;

        $scope.postObj.ctn = request.ctn;
        $scope.postObj.language = $scope.lang;

        wirelessPrepaidService.getWirelessPrepaid($scope.postObj, function (_tmp) {
          if (_tmp.result === 'success') {
            // Hide loading
            $scope.loadingDataIndicator = false;
            $scope.displayContent = true;

            // Proceed to display
            $scope.vpd = _tmp.data;

            // Split the plan name into two lines
            // Split the plan name into two lines
            for (var i in $scope.vpd.phoneServices) {
              var subSet = $scope.vpd.phoneServices[i];
              //DBG
              //$scope.vpd.phoneServices[i].prePaidAddons = [];

              var addOns = $scope.vpd.phoneServices[i].prePaidAddons;
              subSet.addOns = addOns;

              //subSet.addOns.push({'addonTitle':'test1 - desc1'});
              //subSet.addOns.push({'addonTitle':'test1 - desc1'});

              subSet.expireDate = $scope.vpd.phoneServices[i].expiryDate;  //$scope.vpd.nextBillingDate;
              subSet.pin = $scope.vpd.phoneServices[i].pin;
              subSet.accountNumber = $scope.vpd.phoneServices[i].ban;

              if (typeof subSet === 'object') {
                var origName = subSet.planDesc;
                var origNameArr = origName.split('-');

                if (origNameArr.length === 2) {
                  subSet.planDescHTML = '<h5 >' + origNameArr[0] + '</h5><div class=\"title_28 mtss\">' + origNameArr[1] + '</div>';
                } else {
                  subSet.planDescHTML = '<h5>' + origName + '</h5>';
                }
              }

              $scope.vpd.phoneServices[i] = subSet;
            }

            // !!!!!!!!!!!!!!!!   THIS WILL REFLECT ON USER SELECTION !!!!!!!!!!!!!!!!!!!!!!
            $scope.vpd.phoneSelected = $scope.vpd.phoneServices[0];

            //for (var xx = 0; xx < $scope.vpd.phoneSelected.addOns.length; xx++){
            //	var aoT = $scope.vpd.phoneSelected.addOns[xx].addonTitle;
            //	var aoArr = aoT.split(' - ');
            //	$scope.vpd.phoneSelected.addOns[xx].addonTitle = aoArr[1] +' - '+ aoArr[2];
            //}

            $scope.formatDates();
          } else {
            $scope.loadingDataIndicator = false;
            $scope.displayContent = false;

            if (_tmp.result === 'fail') {
              holder = _tmp.data;
              $scope.errorMessage = 'Failed to load Wireless account data';

            } else if (_tmp.result === 'error') {
              // holder = _tmp.data;
              $scope.errorMessage = _tmp.message;

            } else {
              // Unknown state ???
            }
          }
        });
      };

    // Repair link modernization changes:: DC-1672
    $scope.continueToRepairModal = function(){
      const payload = {
        applicationId: 'UTEMyRogers',
        agentType: "End User",
        locale: languageSwitcher.getCurrentLanguage() === 'en' ? 'EN-CA': 'FR-CA',
        userRole: "Customer",
        userId: userService.getUser().userEmail,  
        userName: localStorage.getLocalStorageValue('fullName'),
        accountNumber: localStorage.getLocalStorageValue('accountNumber') || '',
        subscriberNumber:  $scope.ctn ,
      }

      const analyticsPL = {
        BAN: payload.accountNumber,
        CTN: payload.subscriberNumber,
        userId: payload.userId
      }
       
      ssoService.fetchSSOToken(payload).then(function(response){
        const token = response;   
        var modalInstanceT = $modal.open({
          templateUrl: 'views/track-repair-modal.html',
          windowClass: 'generic-message-modal',
          controller: ['$scope', function ($scope) {
            trackAnalytics(analyticsPL, '');
            $scope.close = function () {
              modalInstanceT.close();
            };
            $scope.startPhoneRepairClaim = function(){              
              document.getElementById('TOKEN').value = token;
              document.getElementById('formForTrackPhoneRepair').action = environmentProvider.getProperty('brightstarServiceUrl')
              document.getElementById('formForTrackPhoneRepair').submit();
              const interaction = {
                type: 'click',
                name: 'Redirect to Brightstar'
              }
              trackAnalytics(analyticsPL, interaction);
              modalInstanceT.close();            
            }
          }]
        });
      }).catch(function(error){
        var modalInstance = $modal.open({
          templateUrl: 'views/modals/generalErrorDialog.html',
          windowClass: 'verify-address-modal',
          controller: ['$scope', function ($scope) {
            trackErrorAnalytics(analyticsPL, error);           
            $scope.errorTitle = $translate.instant('OOPS');           
            $scope.close = function () {
              modalInstance.close();
            };
          }]
        });
      })
    }

    function trackAnalytics(payload, interaction) {
      const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
      const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
      const pageView = interaction === '' ? true : false;
      const trackPayload = constructADLPayload(payload, pageView, interaction, true);
      dataLayerService.track(trackPayload,true,selectedSections);
    }

    function trackErrorAnalytics(payload, error) {
      const section = window.ute.datalayer.common.service.DataLayerPredefinedSection;
      const selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
      const errorType = window.ute.datalayer.common.service.ErrorType;
      const errorCategory = window.ute.datalayer.common.service.ErrorCategory;
      const data = error.data;    
      const errorApi = error.config.api;
      const errPayload = constructADLPayload(payload, false, '', false);
      errPayload.events = { pageView: true, error: true };

     if (_.has(data, 'status.code')) {
      dataLayerService.trackError(errPayload, errorType.HTTP, data.status.code, data.status.codeName, errorCategory.SELF_SERVE, '', errorApi, true,selectedSections);
      } else {
        if (error.status === 404 && error.statusText === '') {
          error.statusText = 'API Not found';
        }
        dataLayerService.trackError(errPayload, errorType.HTTP, error.status, error.statusText, errorCategory.SELF_SERVE, '', errorApi, true, selectedSections);
      }
    }

    function constructADLPayload(tpayload, pageView, interaction, success) {     
      const payload = {
        account: { BAN: tpayload.BAN, CTN: tpayload.CTN, userType: 'Consumer', userName: tpayload.userId },
        page: {
          name: success ? 'continue to repair portal' : 'system error modal',
          hierarchy: ['myrogers',  'shareeverything', 'dashboard', 'share everything dashboard'],
          language: languageSwitcher.getCurrentLanguage(),
          province: $browser.cookies().province,
          url: 'modal popup',
          Referer: location.href
        },
        user: {
          loginStatus: userService.isSigned()
        },
        site: {
          name: 'R'
        }
      };

      if (pageView) {
        payload.events = {
          pageView: true
        };
      }
      if (interaction) {
        payload.interaction = interaction;
        payload.events = {
          interaction: true
        }
      }
      return payload;
    }
      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        $scope.lng = lang + '-CA';
        $scope.lang = lang;
        $scope.monthsNames = util.getMonthsNames();
        $scope.getWirelessPrepaid();
      }, 'wirelessPlanControllerLangSub');

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler('wirelessPlanControllerLangSub');
      });

      init(languageSwitcher.getCurrentLanguage());

      function init(lang) {
        request.language = lang;
        $scope.lng = lang + '-CA';
        $scope.lang = lang;
        $scope.monthsNames = util.getMonthsNames();
        $scope.getWirelessPrepaid();
        permissionsService.getUserPermissions().then(function (data) {
          wpController.permissionsObj = data;
        });
   
        //Permissions for repair link DC-1672 start
        permissionsService.getUserPermissions().then(function (data) {
          if (data.permissions && data.permissions.length){
            if(_.find(data.permissions, function (obj) {
            return obj.permission === 'ROGERS_REPAIR_DEVICE_ENABLED';
            })){
            $scope.repairDeviceEnabled = true;
            }
          }
        });
        //Permissions for repair link DC-1672 end
      }

    }]);

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountBalanceController', accountBalanceController);

  accountBalanceController.$inject = ['$scope',
    '$rootScope',
    '$document',
    'appState',
    'ute.blocks.language.switcher',
    'myrAccountOverviewService',
    'myrAccountListService',
    'myrMyServicesService',
    'btnSettings',
    '$window',
    'localStorage',
    'ajax',
    '$modal',
    'ute.brite.bill.service',
    'util',
    'myrAccountBalanceDataFactory',
    '$log',
    'sessionStorage',
    'commonUtilityService',
    'ute.rogers.account.overview.factory',
    'ute.common.permissions.service',
    '$state',
    'ute.rogers.account.billing.detail.factory',
    'ute.common.core.browser.service',
    'ute.common.user.service',
    'ute.payment.ui.pay.now.service',
    '$translate',
    '$filter',
    '$timeout',
    '$http',
    'ute.datalayer.common.service'];

  /* @ngInject */
  function accountBalanceController($scope,
    $rootScope,
    $document,
    appState,
    languageSwitcher,
    myrAccountOverviewService,
    myrAccountListService,
    myrMyServicesService,
    btnSettings,
    $window,
    localStorage,
    ajax,
    $modal,
    briteBillService,
    util,
    myrAccountBalanceDataFactory,
    $log,
    sessionStorage,
    commonUtilityService,
    newAccountOverviewFactory,
    permissionsService,
    $state,
    billingDetailFactory,
    browser,
    userService,
    payNowService,
    $translate,
    $filter,
    $timeout,
    $http,
    dataLayerService) {
    var dynatraceCustomActionId = null;
    var vm = this; // jshint ignore:line
    var accountOverviewFactory;

    $scope.isConsumer = userService.isConsumer();
    $scope.isDealer = userService.isDealer();
    $scope.isCare = userService.isCare();

    init();

    function init() {
      try {
        dynatraceCustomActionId = dtrum.enterAction('Account Balance Widget', 'change');
      } catch (error) {
      }
      vm.lng = languageSwitcher.getCurrentLanguage();
      vm.isCCExpired = false;
      vm.isCCExpiring = false;
      accountOverviewFactory = newAccountOverviewFactory();
      if (browser.isMobile()) {
        angular.element($window).on('orientationchange', function () {
          $scope.$apply();
        });
      }
      getHowToVideoLinkAndLabel();
    }
    function getHowToVideoLinkAndLabel() {
      if (!$scope.isConsumer) {
        $http.get('./cms/ute/rogers/consumer/oneview/data/billing/'+vm.lng+'/locale.json').then(
          function(res) {
            vm.linkLabel = res.data.linkLabel;
            vm.videoLink = res.data.videoLink;
          },
          function(error) {
            console.error('unable to load locale.json for how to video link: ', error);
          }
        )
      }
    }

    // Public API
    vm.rs = $rootScope;

    //cls
    vm.isShowPanel = false;

    vm.payBill = payBill;
    vm.postToRogers = postToRogers;
    vm.postToRogersTop = postToRogersTop;
    vm.postToRogersPrepaid = postToRogersPrepaid;

    vm.ao = myrAccountOverviewService;
    vm.mss = myrMyServicesService;
    vm.bb = briteBillService;
    vm.abdf = myrAccountBalanceDataFactory;
    vm.appState = appState;

    vm.als = myrAccountListService;
    vm.showTopUpNow = showTopUpNow;
    vm.getBriteBillInvoiceDates = getBriteBillInvoiceDates;
    vm.isLoadingBriteBill = isLoadingBriteBill;
    vm.btnStatus = $window.btnStatus;

    $scope.repMakePaymentAccess = true;
    $scope.repCreditManagementAccess = false;
    vm.selectedAccount = undefined;
    vm.creditAdjustment = creditAdjustment;
    $scope.showAdjustmentButton = false;
    vm.isAgingBucketsPermitted = true;
    vm.openBucketsPopup = false;
    vm.isDelinquent = false;
    vm.isDelinquencyIndicatorPermitted = true;
    vm.pastDueBuckets = [
      {
        name : "current_bucket",
        responseAttribute : "",
        amount : "-"
      },
      { 
        name : "1-30",
        responseAttribute : "oneToThrity",
        amount : "-"
      },
      { 
        name : "31-60",
        responseAttribute : "thirtyOneToSixty",
        amount : "-"
      },
      { 
        name : "61-90",
        responseAttribute : "sixtyOneToNinety",
        amount : "-"
      },
      { 
        name : "91-120",
        responseAttribute : "ninetyOneToOneTwenty",
        amount : "-"
      },
      { 
        name : "121-150",
        responseAttribute : "oneTwentyOneToOneFifty",
        amount : "-"
      },
      { 
        name : "150+",
        responseAttribute : "oneFiftyOnePlus",
        amount : "-"
      }
    ];
      
    vm.agingBucketsDisplayCheck = function() {
      return (vm.isAgingBucketsPermitted && !(vm.abdf.accountBalance.pastDueBalance == 0.00));
    }

    vm.delinquencyIndicatorDisplayCheck = function() {
      return (vm.isDelinquencyIndicatorPermitted && vm.isDelinquent);
    }

    vm.checkAndPopulateAgingBuckets = function () {
      var sumOfAgingBuckets = 0;
      if (!vm.openBucketsPopup && !vm.populateFirstTime && vm.abdf.accountBalance.collectionDetails) {
        var collections = vm.abdf.accountBalance.collectionDetails;
        vm.pastDueBuckets.forEach(function (bucket) {
          if (bucket.responseAttribute && collections[bucket.responseAttribute] && !isNaN(collections[bucket.responseAttribute])) {
            bucket.amount = collections[bucket.responseAttribute];
          }
          if (bucket.amount !== "-") {
            sumOfAgingBuckets += bucket.amount;
          }
        });
        vm.pastDueBuckets[0]["amount"] = vm.abdf.accountBalance.balanceAmount - sumOfAgingBuckets;
        vm.populateFirstTime = true;
      }
    }
    vm.getName = function () {
      if (!vm.selectedAccount) {
        return;
      }
      if (vm.selectedAccount.nickname) {
        return vm.selectedAccount.nickname.toLowerCase();
      } else {
        return (vm.selectedAccount.accountName.firstName + ' ' + vm.selectedAccount.accountName.lastName).toLowerCase();
      }
    };

    vm.displayPaymentDate = function () {
      return Number(vm.abdf.accountBalance.balanceAmount) > 0 && !vm.isSuspended() && !vm.isCanceled() && !!vm.billDueDate && vm.methodOfPayment === 0;
    };

    vm.displayCalendarOptions = function () {
      return vm.methodOfPayment === 0;
    };

    vm.formatCalendarDate = function (date, hours) {
      // Microsoft, Yahoo and Google accept this format: "20170810T170000Z"
      return $window.moment(date).add(hours, 'hours').utc().format('YYYYMMDDTHHmmss') + 'Z';
    }

    vm.isSuspended = function () {
      return vm.selectedAccount && vm.selectedAccount.accountStatus.toLowerCase() === 'suspended';
    };

    vm.isCanceled = function () {
      return vm.selectedAccount && vm.selectedAccount.accountStatus.toLowerCase() === 'cancelled';
    };

    vm.isDesktopView = function () {
      return $window.innerWidth > 768;
    };

    vm.isPaymentBtnWhite = function () {
      // if it's cc or debit
      if (vm.isCLM && vm.usedCLMpercentage >= 100) {
        return false;
      }
      return (_.isUndefined(vm.abdf.accountBalance.balanceAmount) || Number(vm.abdf.accountBalance.balanceAmount) <= 0 || vm.methodOfPayment === 1 || vm.methodOfPayment === 2);
    };

    vm.isCLMStatusLoading = function () {
      return _.isUndefined(vm.isCLM);
    };

    vm.paymentMethodChangedCallback = function (method) {
      // this controller also need to be informed when CC info (isCCExpired, isCCExpiring) is changed so we call getBillingDetails function again to get updated values
      accountOverviewFactory.getSelectedAccount()
        .then(getBillingDetails);
    };

    vm.displayNarrowBox = function () {
      return !vm.displayPaymentDate() && (vm.methodOfPayment !== 1 || (!vm.isCCExpiring && !vm.isCCExpired) || vm.isCanceled());
    };

    vm.getTemplateName = function () {
      if ($scope.isConsumer) {
        if (vm.displayNarrowBox()) {
          return 'scripts/modules/accountBalance/narrowAccountBalance.accountOverview.html';
        } else {
          return 'scripts/modules/accountBalance/accountBalance.accountOverview.html';
        }
      } else {
        // this template is being used for customer view in OV
        return 'scripts/modules/accountBalance/accountBalance.html';
      }
    };

    vm.showLoadingIcon = function (){
      return ($scope.isConsumer || vm.rs.currentStateName === 'viewbill') && vm.isCLMStatusLoading() && !vm.billingDetailsFailed;
    };

    var dataChangeSubscriberName = 'accountBalanceController_' + $scope.$id;
    var languageChangeSubscriberName = 'accountBalanceControllerLangSub_' + $scope.$id;
    // we need to get getSelectedAccountDetails to pass it to ute-payment-method directive
    accountOverviewFactory.getSelectedAccountDetails()
      .then(function (selectedAccountDetails) {
        vm.selectedAccountDetails = selectedAccountDetails.rawData;
      });

    accountOverviewFactory.getSelectedAccount()
      .then(function (selectedAccount) {
        refreshAccountDetails(selectedAccount);
      })
      .finally(function () {
        accountOverviewFactory.registerOnDataChangeHandler(function (accountOverview) {
          refreshAccountDetails(accountOverview.getSelectedAccount());

          accountOverview.getSelectedAccountDetails()
            .then(function (selectedAccountDetails) {
              vm.selectedAccountDetails = selectedAccountDetails.rawData;
            });
        }, dataChangeSubscriberName);
      });

    function refreshAccountDetails(selectedAccount) {
      if (selectedAccount && (!vm.selectedAccount || selectedAccount.accountNumber !== vm.selectedAccount.accountNumber)) {
        vm.selectedAccount = selectedAccount;
        checkAccountType();
        if (selectedAccount.accountTypeNumber !== 9) {
          getBillingDetails(selectedAccount);
          getBalanceDetails();
        }
        setButtonStatus();
      }
    }

    function getBillingDetails(selectedAccount) {
      vm.isCLM = undefined;
      vm.isCCExpired = false;
      vm.isCCExpiring = false;
      
      /* Cache Bursting for all the states,pages*/
      var cacheBurst = true;
      
      billingDetailFactory({
          accountNumber: selectedAccount.accountNumber,
          accountTypeNumber: selectedAccount.accountTypeNumber,
          language: vm.lng,
          applicationId: 'Rogers.com',
          refresh: false
        }).getBillingDetail(cacheBurst)
        .then(function (billingDetail) {
          if (billingDetail.collectionDetails){
            if (billingDetail.collectionDetails.delinquencyLevel === 'Y'){
              vm.isDelinquent = true;
            } 
          }

          if (billingDetail.billDueDate) {
            var normalizedMomentDate = $window.moment(billingDetail.billDueDate, 'MMM-DD-YY');
            if (normalizedMomentDate.isValid()) {
              vm.billDueDate = new Date(normalizedMomentDate.toDate());
            }
          } else {
            vm.billDueDate = undefined;
          }

          if(billingDetail.ptpPendingDate){
            var normailizedMomentDateForPTP = $window.moment(billingDetail.ptpPendingDate, 'MMM-DD-YY');
            if (normailizedMomentDateForPTP.isValid()) {
              vm.ptpPendingDate = new Date(normailizedMomentDateForPTP.toDate());
            }
          } else {
            vm.ptpPendingDate = undefined;
          }

          if (isNaN(billingDetail.availableCreditAmount)) {
            $rootScope.showCreditLimitError = true;
          }

          // OVO -Changes
          // Fetch Bills from billing details API instead of
          // activatedUserSummary API
         
          updateLastBill();
          // if(billingDetail.bill){
          // vm.lastBill = billingDetail.bill;
          // //vm.mss.selectedAccountDetail.isViewBillDisplay = true;
          // updateLastBill();
          // }

          //  150 , 10, 20
          //  150 , 170
          // 200 ,100   (200-100)/200
          vm.isCLM = Number(billingDetail.creditLimit) > 0;
          if (vm.isCLM) {
            vm.remainingCL = billingDetail.availableCreditAmount;
            vm.usedCLM = billingDetail.creditLimit - billingDetail.availableCreditAmount;
            vm.usedCLMpercentage = ((vm.usedCLM / billingDetail.creditLimit) * 100);
            if (vm.usedCLMpercentage >= 100) {
              vm.titleCLM = 'ute.rogers.account.balance.credit_limit_exceeded_title';
              vm.descCLM = ($scope.isCare || $scope.isDealer) ? 'ute.rogers.account.balance.oneView.credit_limit_exceeded_desc' : 'ute.rogers.account.balance.credit_limit_exceeded_desc';
            } else if (vm.usedCLMpercentage > 60 && vm.usedCLMpercentage < 75) {
              vm.titleCLM = 'ute.rogers.account.balance.nearing_credit_limit_title';
              vm.descCLM = ($scope.isCare || $scope.isDealer) ? 'ute.rogers.account.balance.oneView.reached_over_60_percent_desc' : 'ute.rogers.account.balance.reached_over_60_percent_desc';
            } else if (vm.usedCLMpercentage > 75 && vm.usedCLMpercentage < 100) {
              vm.titleCLM = 'ute.rogers.account.balance.almost_credit_limit_title';
              vm.descCLM = ($scope.isCare || $scope.isDealer) ? 'ute.rogers.account.balance.oneView.reached_over_75_percent_desc' : 'ute.rogers.account.balance.reached_over_75_percent_desc';
            }
          }
          vm.methodOfPayment = (billingDetail.methodOfPayment !== undefined) ? billingDetail.methodOfPayment.mopType : '';
          if (billingDetail.methodOfPayment && billingDetail.methodOfPayment.mopType === 1) {
            // check date if method of payment is CC
            checkCCDateValidity(billingDetail);
          }
          dynatraceLeaveAction();
        }, function (error) {
          // DC-1500 track '/billingDetails' API for 'page load'
          try {
            var errorCode = _.get(error, 'data.errorCode') || error.status;
            var errorApi = error.config.api;
            var errorMsg = $translate.instant('acc_overview_oops');
            var dataLayerPredefinedSection = window.ute.datalayer.common.service.DataLayerPredefinedSection,
            dataLayerErrorType = window.ute.datalayer.common.service.ErrorType,
            dataLayerErrorCategory = window.ute.datalayer.common.service.ErrorCategory,
            dataLayerSections = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE];
    
            dataLayerService.trackError(
              {},
              dataLayerErrorType.PAGE_LOAD,
              errorCode,
              errorMsg,
              dataLayerErrorCategory.SELF_SERVE,
              undefined,
              errorApi,
              false,
              dataLayerSections, ''); 
            }
          catch (e) {
            console.log('Exception while tracking billingDetails API' + e);
          }
          dynatraceLeaveAction();
        })
        .catch(function () {
          vm.billingDetailsFailed = true;
          dynatraceLeaveAction();
        });
    }

    function checkCCDateValidity(billingDetail) {
      var ccExpiry = _.get(billingDetail.methodOfPayment, 'creditCardDetails.ccExpiry', '    ');
      var ccExpiryYear = (new Date()).getFullYear().toString().slice(0, 2) + ccExpiry.slice(2, 4);
      var ccExpiryMonth = ccExpiry.slice(0, 2);
      var expiryDate = new Date(+ccExpiryYear, (+ccExpiryMonth - 1), 1);
      var currentDate = new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1);
      var cmpDate = compareDate(currentDate, expiryDate);
      if (cmpDate === 0 || cmpDate === -1) {
        vm.isCCExpiring = true;
      } else if (cmpDate > 0) {
        vm.isCCExpired = true;
      }
    }

    function compareDate(curDate, expDate) {
      return curDate.getMonth() - expDate.getMonth() + (12 * (curDate.getFullYear() - expDate.getFullYear()));
    }

    function getBriteBillInvoiceDates() {
      if (vm.selectedAccount) {
        return briteBillService.getBriteBillInvoiceDates(vm.selectedAccount.accountNumber);
      } else {
        return '';
      }
    }

    function isLoadingBriteBill() {
      if (vm.selectedAccount) {
        return briteBillService.isLoadingBriteBill(vm.selectedAccount.accountNumber);
      } else {
        return false;
      }
    }

    if ($scope.isDealer || $scope.isCare) {
      vm.btnSettings = btnSettings;
      vm.btnStatus = btnStatus;
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.MakePayment, ute.common.permissions.service.RamActionCodes.start)
        .then(function (agentPermission) {
          $scope.repMakePaymentAccess = agentPermission;
        });

    }
    $scope.language = languageSwitcher.getCurrentLanguage();

    // $scope.$watch(function () {
    //   if (vm.abdf.accountBalance) {
    //     return vm.abdf.accountBalance.nextBillDate;
    //   }
    // }, function (val) {
    //   if ($rootScope.isCare) {
    //     sessionStorage.setSessionStorageValue('nextBillDate', val);
    //   } else {
    //     localStorage.setLocalStorageValue('nextBillDate', val);
    //   }
    // });

    function payBill() {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();          // jshint ignore:line
      openPayNowModal();
    }

    function openPayNowModal() {
      accountOverviewFactory.getSelectedAccountDetails().then(function (accountDetails) {
        payNowService.openMakePaymentModal(vm.abdf.accountBalance, accountDetails, $state.current && $state.current.name ? $state.current.name : 'viewbill', getBalanceDetails);
      }).catch(function (error) {
        console.log('error getting account summary');
      });
    }

    var postToRogersUrls = [
      {url: '/web/myrogers/viewBill'},
      {url: '/web/myrogers/prepaidTopUp'},
      {url: '/web/RogersServices.portal?_nfpb=true&&_pageLabel=UpdatePaymentMethod&&_nfls=true&&regCC=false'},
      {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary'}
    ];

    function postToRogers() {
      if (vm.selectedAccount) {
        // For dealer and care - legacy page should not be displayed
        if (vm.rs.isDealer || vm.rs.isCare) {
          appState.switchView('viewbill');
        } else if (briteBillService.getBriteBillError(vm.selectedAccount.accountNumber)) {
          //PCR12 Compliance
          var dataLog = {
            'logLevel': 'INFO',
            'message': 'Sending user to ePost: ' + briteBillService.getBriteBillError(vm.selectedAccount.accountNumber)
          };
          ajax.serverLog(dataLog);
          if ($rootScope.winFlag) {
            appState.switchView('winOnlineInvoice');
          }
          else {
            // $('#formToRogers').attr('action', postToRogersUrls[0].url);
            // $('#formToRogers').submit();
            appState.switchView('viewbill');
          }

        } else {
          appState.switchView('viewbill');
        }
      }
    }

    function postToRogersTop() {
      // For oneview dealer and care display modal for prepaid top-up
      if ($scope.isDealer || $scope.isCare) {
        $scope.openModalPopup();
        $rootScope.actionOtherThanTopUp = false;
        vm.actionOtherThanTopUp = false;
      } else {
        var form = $('#formToRogersTop');
        form.attr('action', postToRogersUrls[1].url);
        form.submit();
      }
    }

    function postToRogersPrepaid(urlIndex, flowId) {
      var form = $('#formToRogersPrepaid');
      if (flowId && flowId.length > 0) {
        form.find('>#flowId').val(flowId);
      }
      /**
       * Set ban value to ctn for Prepaid View Call/Transaction History
       */
      if (urlIndex && urlIndex === 3) {
        form.find('>#ban').val(vm.mss.accountDetails.ctnNumber);
      }
      form.attr('action', postToRogersUrls[urlIndex].url);
      form.submit();
    }

    $scope.openModalPopup = function (size) {
      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/prepaidModal.html',
        controller: 'MyrWirelessPrepaidModalController',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });
    };

    function getBalanceDetails() {

      vm.loadingBalance = true;
      vm.disableBalance = true;
      var acctDetails = vm.selectedAccount;

      var request = {
        accountNumber: acctDetails.accountNumber,
        accountTypeNumber: acctDetails.accountTypeNumber,
        pinNumber: acctDetails.pinNumber,
        phoneNumber: acctDetails.phoneNumber,
        language: vm.lng,
        refresh: false,
        applicationId: 'Rogers.com'
      };

      var balanceDetailsResponse = function (_tmp) {
        // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
        if (_tmp.result === 'success') {
          vm.abdf.accountBalance = _tmp.data;

          if ($scope.isCare) {
            sessionStorage.setSessionStorageValue('nextBillDate', vm.abdf.accountBalance.nextBillDate);
          } else {
            localStorage.setLocalStorageValue('nextBillDate', vm.abdf.accountBalance.nextBillDate);
          }

          // Add Expiry date to accountBalance object
          if (vm.abdf.accountBalance.nextBillingDetail) {

            try {
              var currentExpiryDate = commonUtilityService.dateTime.parse(vm.abdf.accountBalance.nextBillingDetail, 'YYYY-MM-DD');
              if (currentExpiryDate === undefined) {
                vm.abdf.accountBalance.currentExpiryDate = '';
              } else {
                currentExpiryDate.setDate(currentExpiryDate.getDate() - 1);
                vm.abdf.accountBalance.currentExpiryDate = currentExpiryDate;
              }
            } catch (e) {
              $log.error('Exception catch during add currentExpiryDate to accountBalance object:', e.message);
            }
          }

          //PCR6 - converting bill Cycle Start Date and end date in 'mm dd' format
         // if (vm.abdf.accountBalance.billCycleStartDate && vm.abdf.accountBalance.billCycleEndDate) {
            // vm.bcStartDate = moment(vm.abdf.accountBalance.billCycleStartDate).format("MMM DD");
            //vm.bcEndDate = moment(vm.abdf.accountBalance.billCycleEndDate).format("MMM DD");
            ovoPaymentWidgetDateChanges();
          //}

          //vm.billDueDate = $filter('date')(new Date(vm.abdf.accountBalance.billDueDate),"MMM dd, yyyy");
          if (!vm.abdf.accountBalance.pastDueBalance) {
            vm.abdf.accountBalance.pastDueBalance = "0.00";
          } else if (parseFloat(vm.abdf.accountBalance.pastDueBalance) < 0) {
            vm.abdf.accountBalance.pastDueBalance = "0.00";
          }

        } else {
          vm.abdf.accountBalance = {};
        }

        vm.loadingBalance = false;
        vm.disableBalance = false;

        //setting current date for displaying number of days
        if (!$scope.isConsumer && vm.abdf.accountBalance.nextBillDate) {
          var d = new Date();
          var monthname = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
          var currentDate = (monthname[d.getMonth()] + '-') + d.getDate() + '-' + (d.getFullYear());
          vm.cycleEnd = util.getNumberOfDays(vm.abdf.accountBalance.nextBillDate, currentDate);
        }
      };

      vm.abdf.getBalanceDetails(request, balanceDetailsResponse);

    }

    function ovoPaymentWidgetDateChanges() {
      // PCR 6
      if (vm.selectedAccount) {
        $timeout(function(){
          if(vm.abdf.accountBalance.billCycleStartDate !='' && vm.abdf.accountBalance.billCycleEndDate != ''){
            vm.bcStartDate = $filter('date')(new Date(vm.abdf.accountBalance.billCycleStartDate), (vm.lng=='en') ? "MMM dd": "dd MMM");
            vm.bcEndDate = $filter('date')(new Date(vm.abdf.accountBalance.billCycleEndDate), (vm.lng=='en') ? "MMM dd": "dd MMM");
            vm.IsClickEnable = true;
          }else{
            vm.IsClickEnable = false;
          }
          if(!!vm.abdf.accountBalance.billDueDate){
          vm.ovobillDueDate = $filter('date')(new Date(vm.abdf.accountBalance.billDueDate), (vm.lng=='en') ? "MMM dd, yyyy": "dd MMM yyyy");
          }
          if(!!vm.abdf.accountBalance.ptpPendingDate){
          vm.ovoptpDate = $filter('date')(new Date(vm.abdf.accountBalance.ptpPendingDate), (vm.lng=='en') ? "MMM dd, yyyy": "dd MMM yyyy").replace('.','');
          }
      }
    );
  }
    }


function updateLastBill() {
      if (vm.selectedAccount) {
        briteBillService.getBills(vm.selectedAccount.accountNumber).then(function (bills) {
          if (bills && bills.length > 0) {
            // jscs:disable
           // vm.briteBillReceivedDate = briteBillService.convertDate(bills[0].issue_date); // jshint ignore:line
            // jscs:enable
            //vm.briteBillAccountBalance = (bills[0].amount) ? bills[0].amount : 0.00;
            //vm.loadingBalance = false;
            vm.lastBill = bills[0];
            $timeout(function () {
              vm.briteBillReceivedDate = convertDate(vm.lastBill.issue_date);
              vm.briteBillAccountBalance = vm.lastBill.amount+'';
              vm.loadingBalance = false;
            });
          }
        });
      }
    }

       function convertDate(date){
      var parsedDate ="";
      var _dateObj = new Date(Date.parse(date));
      if ($translate.use().indexOf('en', 0) > -1) {
        parsedDate =$filter('date')(_dateObj, 'MMMM dd, yyyy');
        // moment(date).locale('en').format('MMMM DD, YYYY');
      }
      else{
        parsedDate = $filter('date')(_dateObj, 'dd MMMM yyyy');
      }
      return parsedDate;
    }

   

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      vm.lng = lang;
      $scope.language = lang;
      updateLastBill();
      ovoPaymentWidgetDateChanges();
      getHowToVideoLinkAndLabel();
    }, languageChangeSubscriberName);

    $scope.$on('$destroy', function () {
      accountOverviewFactory.unregisterOnDataChangeHandler(dataChangeSubscriberName);
      languageSwitcher.unregisterOnDataChangeHandler(languageChangeSubscriberName);
      angular.element($window).off('orientationchange');
      if (scopewatch1) {
        scopewatch1();
      }     //n Remove any watchers
    });

    function showTopUpNow() {
      if (vm.selectedAccount.accounTypeNumber === 9 &&
        btnSettings.accountStatus !== 'Cancelled' &&
        btnSettings.accountStatus !== 'Suspended') {
        return true;
      }
    }

    var scopewatch1;
    //not needed for consumer
    if (($scope.isDealer || $scope.isCare)) {
      scopewatch1 = $scope.$watch(function () {
        if (vm.selectedAccount) {
          return briteBillService.getIsbritebillAvailable(vm.selectedAccount.accountNumber);
        } else {
          return false;
        }
      }, function (newVal) {
        var stateName = $scope.isCare ? sessionStorage.getSessionStorageValue('toStateName') :
          localStorage.getLocalStorageValue('toStateName');

        if (newVal && vm.selectedAccount.accounTypeNumber !== 9 && (stateName === 'oneViewDashboard' || stateName === 'accountOverview')) {
          vm.mss.selectedAccountDetail.isViewBillDisplay = true;
          vm.loadingBalance = true;
          updateLastBill();
        }
      });
    }

    function openCreditAdjustmentModal() {
      $rootScope.modal = $modal.open({
        templateUrl: 'scripts/modules/creditAdjustment/creditAdjustmentModal.html',
        controller: 'MyrCreditAdjustmentController',
        size: 'creditAdjustment-modal-dialog',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    }

    function checkAccountType () {
      if (
        vm.selectedAccount
        &&  vm.selectedAccount.accountType !== 'Business'
      ) {
        $scope.showAdjustmentButton = true;
      }
    }

    function creditAdjustment() {
      scrollPageToTop(); // jshint ignore:line
      openCreditAdjustmentModal();
    }
    function setButtonStatus() {
      if (vm.selectedAccount && vm.selectedAccount.accountStatus) {
        vm.btnSettings = btnSettings.getSettings(vm.selectedAccount.accountStatus);
      }
    }

    function dynatraceLeaveAction() {
      try {
        if (dynatraceCustomActionId) {
          dtrum.leaveAction(dynatraceCustomActionId);
          dynatraceCustomActionId = null;
        }
      } catch (error) {
      }
    }

    if ($scope.isDealer || $scope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CreditManagement, ute.common.permissions.service.RamActionCodes.start)
        .then(function (creditMgmtPermission) {
          $scope.repCreditManagementAccess = creditMgmtPermission;
        });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.AgingBucket, ute.common.permissions.service.RamActionCodes.grant).then(function(permission) {
          vm.isAgingBucketsPermitted = permission;
        });
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DelinquencyIndicator, ute.common.permissions.service.RamActionCodes.grant).then(function(permission) {
          vm.isDelinquencyIndicatorPermitted = permission;
        }); 
    }
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrAccountBalance', accountBalance);

  accountBalance.$inject = [];

  /* @ngInject */
  function accountBalance($log) {
    return {
      scope: {},
      templateUrl: function (elem, attrs) {
        if (attrs.viewHtml) {
          return 'scripts/modules/accountBalance/' + attrs.viewHtml;
        }
      },
      restrict: 'EA',
      controller: 'MyrAccountBalanceController',
      controllerAs: 'ab',
      bindToController: true
    };
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountBalanceService
   * @description
   * # myrAccountBalanceService
   */
  angular.module('totesApp').factory('myrAccountBalanceService', accountBalanceService);

  accountBalanceService.$inject = [];

  function accountBalanceService() {

    var service = {
      accountBalance:{},
      billingDetails:{},
      loadingData:false,
      errorLoading: undefined,
      getAccountBalance:getAccountBalance
    };

    return service;

    ///////////////////////////////////////////////////////////////
    function getAccountBalance(){
      return service.accountBalance;
    }

  }

}());

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountListController', accountListController);

  accountListController.$inject = ['$scope',
    '$rootScope',
    '$modal',
    'myrAccountListService',
    '$browser',
    '$cookieStore',
    'localStorage',
    'deeplink',
    '$window',
    'myrNotificationBannerService',
    'btnSettings',
    '$state',
    'appState',
    'ute.blocks.language.switcher',
    '$log',
    'myrCustomerInfoService',
    'sessionStorage',
    'ute.rogers.eclipse.remote.api.service',
    'ute.common.user.service',
    'myrAccountOverviewService',
    'cookieStore'];

  /* @ngInject */
  function accountListController($scope,
                                 $rootScope,
                                 $modal,
                                 myrAccountListService,
                                 $browser,
                                 $cookieStore,
                                 localStorage,
                                 deeplink,
                                 $window,
                                 myrNotificationBannerService,
                                 btnSettings,
                                 $state,
                                 appState,
                                 languageSwitcher,
                                 $log,
                                 myrCustomerInfoService,
                                 sessionStorage,
                                 eclipseRemoteApi,
                                 userService,
                                 accountOverviewService,cookieStore) {

    if (appState.checkMaintenance('ACCOUNT_OVERVIEW_ON_MAINTENANCE')) {
      return;
    }

    var vm = this; // jshint ignore:line
    var notificationBannerService = myrNotificationBannerService;

    // Public API
    vm.lng = languageSwitcher.getCurrentLanguage();

    vm.loadingDataIndicator = false;
    vm.als = myrAccountListService;
    vm.cis = myrCustomerInfoService;
    vm.solarisUrl = '';
    vm.inputParams= {};
    vm.queryParams ={};
    /**
     * This method is used to add additional check to display BAN selection modal
     * which was getting skipped when coming from easy login
     */
    function easyLoginCheckPassed() {
      var easyLoginCheckCookie = $cookieStore.get('easyLoginCheckPassed');
      return !!easyLoginCheckCookie;
    }

    function changeAccount() {
      notificationBannerService.cleanBanner('linkedMessage');
      // Update indexes of active user account and permissions
      appState.aoUpdateActiveObjects(vm.als.selectedAccount.accountNumber);

      // Update selection and store it into local or session storage
      if ($rootScope.isCare) {
        sessionStorage.setSessionStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
        sessionStorage.setSessionStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
      } else {
        localStorage.setLocalStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
        localStorage.setLocalStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        localStorage.setLocalStorageValue('banType', vm.als.selectedAccount.accountType);
        localStorage.setLocalStorageValue('banSubType', vm.als.selectedAccount.accountSubType);
      }

      if ($state.current.data && $state.current.data._preConditions) {
        $state.current.data._preConditions.accountNumber = vm.als.selectedAccount.accountNumber;
      }

      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
    }

    var getAccountList = function () {
      //hide the previous account details
      var browserCookies = $browser.cookies();
      var signInLanguage = browserCookies.signInLang;

      var accountListError = function () {
        vm.loadingDataIndicator = false;
      };

      if (signInLanguage) {
        languageSwitcher.changeLanguage(signInLanguage);
        document.cookie ='signInLang=;path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC';
      }

      if ($rootScope.ao.accountActive) {
        //console.log('process account list 2');
        // grab data from rootscope and have the function process that
        if ($rootScope.ao.accountActive.refresh) {
          refreshAccountList(accountListError);

        } else {
          processGetAccountList($rootScope.ao.raw);
        }

        //vm.accountType=$rootScope.accountType;
      } else {
        //first time check signin language
        // Make call to server (Should not need to tho)
        refreshAccountList(accountListError);
      }

      return null;
    };

    function refreshAccountList(accountListError) {
      var cacheFailSafe = true;
      var request = {
        refresh: false,
        applicationId: 'Rogers.com'
      };
      if ($rootScope.isCare) {
        request.acctNbr = sessionStorage.getSessionStorageValue('accountNumber');
      }
      var accountListResponse = function (_tmp) {
        vm.loadingDataIndicator = false;
        if (_tmp) {
          if (_tmp.cachedResultInfo) {
            if (_tmp.cachedResultInfo.expired && cacheFailSafe) {
              cacheFailSafe = false;
              request.refresh = true;
              if (_tmp.accountList.length > 0) {
                processGetAccountList(_tmp);
                vm.als.accountListRaw = _.clone(_tmp);
              }
              vm.loadingDataIndicator = true;
              vm.als.getAccountList(request, accountListResponse, accountListError);
            }
          }

          if (vm.als.accountListRaw) {
            vm.als.accountListRaw.cachedResultInfo = {};
          }
          _tmp.cachedResultInfo = {};
          // updateConsumerDetails();
          if (!vm.als.accountListRaw || (vm.als.accountListRaw && (!_.isEqual(_tmp, vm.als.accountListRaw)))) {
            //console.log('process account list 1');
            processGetAccountList(_tmp);
          }
        }
      };
      vm.loadingDataIndicator = true;
      if ($rootScope.ao.accountActive) {
        $rootScope.ao.accountActive.refresh = false;
        $rootScope.ao.raw.cachedResultInfo.expired = true;
      }
      vm.als.getAccountList({}, accountListResponse, accountListError);
    }

    function processGetAccountList(_tmp) {
      if (_tmp.result === 'success') {
        // for (var i = 0; i < _tmp.accountList.length; i++) {
        //   var tmp = {};
        //   tmp = _tmp.accountList[i];
        //   _tmp.accountList[i].accountStatusSimple = als.getAccountStatus(tmp).accountStatusSimple;
        //   _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
        // }
        //display the linked success banner for the very first account
        var reqIndex = 0;
        var accLocalSelected = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');

        if (vm.als.accountTypes.length > 1 && (easyLoginCheckPassed() === false || vm.als.isAccountPicked() === false || (appState.redirectionPath && appState.redirectionPath.length > 0))) {
          if ($rootScope.ao.accountActiveIndex === null || $rootScope.ao.accountActiveIndex === undefined) {
            accLocalSelected = accLocalSelected || vm.als.accountTypes[0].accountNumber;
            if (accLocalSelected) {
              // Update selected index
              appState.aoUpdateActiveObjects(accLocalSelected);
              reqIndex = $rootScope.ao.accountActiveIndex;
            }
          }

          if (deeplink.data.direction !== 'out') {
            // Show the popup / first time entry
            if (easyLoginCheckPassed() === false || vm.als.isAccountPicked() === false || (appState.redirectionPath && appState.redirectionPath.length > 0)) {
              $rootScope.firstLoad = 1;
              $rootScope.popUpOpened = true;
              $rootScope.popUpOpenedAndClosed = false;

              $rootScope.$broadcast('accountSelectionInProgress');

              openSelectAccount('');
              // vm.als.setAccountPicked(true);
              appState.isFirstLoad = false;

              $cookieStore.put('easyLoginCheckPassed', true, { path: '/', domain: '.rogers.com'});
            }
          }
        } else if (vm.als.accountTypes.length > 1) {
          // Load previously selected/active account
          if (accLocalSelected) {
            // Part of MYR-1123 fix, this directly returns the index from appState and updates vm.als object / service
            var actIndex = appState.aoUpdateActiveObjects(accLocalSelected);
            vm.als.updateSelectedAccount(actIndex);
            reqIndex = vm.als.selectedIndex;
          } else {
            //reqIndex = $rootScope.ao.accountActiveIndex;
            reqIndex = vm.als.selectedIndex;
          }
          $rootScope.$broadcast('accountSelectionBypassed');
        }

        // Update selection and store it into a cookie
        vm.als.updateSelectedAccount(reqIndex);
        var ppcUrl = '';
        if (vm.als.accountTypes.length === 1) {
          ppcUrl = appState.readCookie('ppc_url');
          $rootScope.$broadcast('accountSelectionBypassed')

          // Only one account -> default
          if (appState.isFirstLoad) {
            $rootScope.firstLoad = 1;
            appState.isFirstLoad = false;
          }
        }

        $rootScope.ao.accountActive = vm.als.selectedAccount;

        // $rootScope.$broadcast('accountSelectionProcessed', $rootScope.ao.accountActive);

        try {
          vm.als.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
          vm.als.btnStatus = $window.btnStatus;
        } catch (e) {
          // TODO
        }

        if ($rootScope.isCare) {
          sessionStorage.setSessionStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
          sessionStorage.setSessionStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        } else {
          localStorage.setLocalStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
          localStorage.setLocalStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        }
        appState.aoUpdateIndexes(vm.als.selectedAccount.accountNumber);

        // load default profile
        var modalSelected = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
        appState.aoUpdateActiveObjects(modalSelected);

        // From updated rootScope proceed to update of the page
        vm.als.selectedAccount = vm.als.accountTypes[reqIndex];
        try {
           if(vm.als.accountTypes.length <= 1){
           vm.solarisUrl = sessionStorage.getSessionStorageValue('solarisDeeplink') || appState.readCookie('solarisDeeplink');
           vm.legacyUrl = sessionStorage.getSessionStorageValue('legacyDeeplink') || appState.readCookie('legacyDeeplink');
           sessionStorage.deleteSessionStorageValue('solarisDeeplink');
           appState.removeCookie('solarisDeeplink','/','.rogers.com');
           sessionStorage.deleteSessionStorageValue('legacyDeeplink');
           appState.removeCookie('legacyDeeplink','/','.rogers.com');
           }
          if (vm.solarisUrl === undefined || vm.solarisUrl === null || vm.solarisUrl === 'undefined') {
              vm.solarisUrl = '';
          }
          if (vm.legacyUrl === undefined || vm.legacyUrl === null || vm.legacyUrl === 'undefined') {
              vm.legacyUrl = '';
          }
          } catch (err) {
           }

        if (ppcUrl && ppcUrl.indexOf('choose-plan') > -1) {
          appState.removeCookie('ppc_url', '/web/totes', ' ');
          var ppcDeepLinkUrl = localStorage.getLocalStorageValue('ppc_deeplink_url');
          if (!!ppcDeepLinkUrl && ppcDeepLinkUrl.indexOf('soc') > -1) {
            $window.location.href = '/web/totes/wireless-plan-change/#' + ppcDeepLinkUrl;
          } else {
            $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan';
          }
        }
        else if(vm.solarisUrl != '' || vm.legacyUrl != ''){
                vm.solarisUrl=deeplink.deepLink(vm.solarisUrl);
                getAccountDetails(vm.als.selectedAccount);

        }

        return vm.als.accountTypes;

      } else {
        if (_tmp.result === 'redirect') {
          appState.noLinking = false;
          if ($rootScope.isConsumer) {
            appState.switchView('guestoverview');
          } else {
            appState.switchView('/oneViewInterface');
          }
          //appState.switchView('guestoverview');
          // } else {
          // Unknown state ???
        }
      }
    }

    function openSelectAccount(size) {
      // Modal handling function
      var pageUrl = $window.location.href;
      if (pageUrl.indexOf('underMaintenance') >= 0) {
        return;
      }

      $rootScope.modal = $modal.open({
        templateUrl: 'scripts/modules/accountList/accountOverviewLinkModal.html',
        controller: 'MyrAccountListLinkModalController',
        controllerAs: 'alm',
        size: size,
        backdrop: 'static',
        keyboard: false,
        backdropClass: 'bkg-modal'
      });

      $rootScope.modal.result.then(function (_data) {
        if (_data === 'ok') {
          vm.als.setAccountPicked(true);
          $rootScope.c = true;
          $rootScope.$broadcast('accountSelectionDone')
          if (appState.redirectionPath && appState.redirectionPath.length > 0) {
            var redirectionPath = _.assign(appState.redirectionPath);
            appState.redirectionPath = null;
            appState.multiBANRedirectionDone = true;
            if (redirectionPath !== null) {
              appState.switchView(redirectionPath);
            }
          }
        } else if (_data !== 'url') {
          // Some other undefined operation happened to close the modal
          // accountOverview.openSelectAccount - Close
          $rootScope.$broadcast('accountSelectionDone')
          throw new Error('accountListController.openSelectAccount - Undefined modal close event');
        }
      }, function (_data) {
        if (_data !== 'cancel') {
          // Some other undefined operation happened to dismiss the modal
          // accountOverview.openSelectAccount - Dismiss
          $rootScope.$broadcast('accountSelectionDone')
          throw new Error('accountListController.openSelectAccount - Undefined modal dismiss event');
        }
      });
    }

    // Link modal with the page.
    myrAccountListService.registerUpdateAccountListCallBack('updateAccountList', function () {
      var selectedAccountNumber = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
      if (!vm.als.selectedAccount || (selectedAccountNumber !== vm.als.selectedAccount.accountNumber)) {
        // Take data from localstorage and update few things
        appState.aoUpdateActiveObjects(selectedAccountNumber);
        // Update selected index
        vm.als.selectedIndex = _.findIndex(vm.als.accountTypes, {accountNumber: selectedAccountNumber});
        // From updated rootScope proceed to update of the page
        vm.als.selectedAccount = vm.als.accountTypes[vm.als.selectedIndex];
      } else {
        if (appState.redirectionPath && appState.redirectionPath.length > 0) {
          var redirectionPath = _.clone(appState.redirectionPath);
          appState.redirectionPath = null;
          appState.multiBANRedirectionDone = true;
          if (redirectionPath !== null) {
            appState.switchView(redirectionPath);
          }
        }
      }
    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if (vm.als.selectedAccount) {
        vm.als.getAccountStatus(vm.als.selectedAccount);
      }
    }, 'accountListControllerLangSub');

    $scope.$on('$destroy', function () {
      myrAccountListService.registerUpdateAccountListCallBack(null);
      languageSwitcher.unregisterOnDataChangeHandler('accountListControllerLangSub');
      scopewatch1(); //n Remove any watchers
    });

    var scopewatch1 = $scope.$watch('al.als.selectedAccount.accountNumber', function (acct) {
      if (acct) {
        changeAccount();
      }
    });

    getAccountList();

    if (appState.showNoProductPopup) {
      appState.showNoProductPopup = false;
      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/noproductmodal.html',
        controller: 'MyrAccountListLinkModalController',
        controllerAs: 'alm',
        backdrop: 'static',
        keyboard: false,
        backdropClass: 'bkg-modal'
      });
    }

    function getAccountDetails(val) {
      var request = {
        applicationId: 'Rogers.com',
        accountNumber: val.accountNumber,
        accountTypeNumber: val.accountTypeNumber,
        pinNumber: val.pinNumber,
        phoneNumber: val.phoneNumber,
        language: languageSwitcher.getCurrentLanguage(),
        refresh: false
      };
      accountOverviewService.clearAccountDetails();
      accountOverviewService.getAccountDetails(request, function (tmp) {
        if (tmp.result === 'success') {
          var sublist = tmp.data.subList;
          var foundIT = false;
          for (var i = 0; i < sublist.length; i++) {
            var item = sublist[i];
            if (item.subType === 'HSI' && checkIfInternetUrl()) {
              foundIT = true;
              constructInputForSolaris(item);
              constructQueryParams();
              redirectToSolaris(item);
              break;
            } else if (item.subType === 'IPTV' && vm.solarisUrl.indexOf('/tv') >= 0) {
              foundIT = true;
              constructInputForSolaris(item);
              constructQueryParams();
              redirectToSolaris(item);
              break;
            } else if (item.subType === 'RHP Phone Line' && (vm.solarisUrl.indexOf('/home-phone') >= 0 || vm.solarisUrl.contains('/web/OnlineManager.portal?maestroIndicator=true'))) {
              foundIT = true;
              constructInputForSolaris(item);
              constructQueryParams();
              redirectToSolaris(item);
              break;
            }
            else if(item.subType === 'Digital TV' && vm.legacyUrl != '' && (vm.legacyUrl.indexOf('ResetDigitalBox') >=0 ||
             vm.legacyUrl.indexOf('ResetDigitalPin') >=0 || vm.legacyUrl.indexOf('build-your-tv-package') >=0)){
              var can = item.subAccountId;
              foundIT=true;
              appState.setCookie('legacyCAN', can,'/','.rogers.com');
              $window.location.href = vm.legacyUrl;
              break;
            }
            else{
            vm.legacyUrl = '';
            }
         }
          if(!foundIT){
            $window.open('/consumer/self-serve/overview', '_self');
          }
        } else {
          $window.open('/consumer/self-serve/overview', '_self');
        }
      });
    }
       function constructInputForSolaris(item){
        vm.inputParams= {
                   accountNumber: $rootScope.ao.accountActive.accountNumber,
                   subAccountId: item.subAccountId,
                   subscriptionId: item.subNumber,
                   source: 'rogers.com',
                   redirectTo: {
                     protocol: window.location.protocol,
                     host: window.location.hostname,
                     port: window.location.port,
                     path: window.location.pathname,
                     hash: window.location.hash,
                     href: window.location.href
                   }
                   };

       }

       function constructQueryParams(){
         vm.queryParams= {
             lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
             userType: userService.getUserType(),
             province: cookieStore.get('province').toLowerCase() // pull from usersService
         };
       }
       function redirectToSolaris(item){
       switch (item.subType) {

       case 'HSI':
         if(vm.solarisUrl.contains('/change-internet-package')){
           eclipseRemoteApi.goToInternetChangePackage(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/daily-usage')){
           eclipseRemoteApi.goToInternetDailyUsage(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/monthly-usage')){
           eclipseRemoteApi.goToInternetMonthlyUsage(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/daily-alerts')){
           eclipseRemoteApi.goToInternetDailyAlerts(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/internet')){
           eclipseRemoteApi.goToHSIDashboard(vm.inputParams,vm.queryParams);
         }
           return;
           break;
       case 'IPTV':
         if(vm.solarisUrl.contains('/channels-and-themepacks')){
           eclipseRemoteApi.goToTVChannelsAndThemePacks(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/swap-channels')){
           eclipseRemoteApi.goToTVSwapChannels(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/change-tv-package')){
           eclipseRemoteApi.goToTVChangePackage(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/tv?swap=true')){
          eclipseRemoteApi.goToIPTVSwapDashboard(vm.inputParams,vm.queryParams);
         }
         else if(vm.solarisUrl.contains('/tv')){
           eclipseRemoteApi.goToIPTVDashboard(vm.inputParams,vm.queryParams);
         }
           return;
           break;
       case 'RHP Phone Line':
          if(vm.solarisUrl.contains('/home-phone')){
            eclipseRemoteApi.goToRHPDashboard(vm.inputParams,vm.queryParams);
          }
          else if(vm.solarisUrl.contains('/OnlineManager')){
            appState.setCookie('olmtn', item.serviceNumber,'/','.rogers.com');
            $window.location.href ='/web/torcom/OnlineManager.portal?maestroIndicator=true';
          }
           return;
           break;

       }

     }
       function checkIfInternetUrl(){
        if(vm.solarisUrl.includes('/internet') || vm.solarisUrl.includes('/daily-usage') || vm.solarisUrl.includes('/monthly-usage') || vm.solarisUrl.includes('/daily-alerts')){
         return true;
         }
         return false;
       }
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrAccountList', accountList);

  accountList.$inject = [];

  /* @ngInject */
  function accountList($log) {
    return {
      scope: {disableList: '='},
      // templateUrl: 'scripts/modules/accountList/accountList.html',
      restrict: 'EA',
      controller: 'MyrAccountListController',
      controllerAs: 'al',
      bindToController: true
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrAccountListLinkModalController', AccountListLinkModalController);

  AccountListLinkModalController.$inject = ['$rootScope',
    '$modalInstance',
    'appState',
    'cookieStore',
    'myrAccountListService',
    '$window',
    'localStorage', 'sessionStorage', 'myrAccountOverviewService','ute.blocks.language.switcher', 'ute.rogers.eclipse.remote.api.service', 'ute.common.user.service'];

  /* @ngInject */
  function AccountListLinkModalController($rootScope,
                                          $modalInstance,
                                          appState,
                                          cookieStore,
                                          myrAccountListService,
                                          $window,
                                          localStorage, sessionStorage, accountOverviewService,languageSwitcher, eclipseRemoteApi, userService) {

    var vm = this;
    vm.als = myrAccountListService;
    vm.solarisUrl = '';
    vm.inputParams ={};
    vm.queryParams ={};
    vm.legacyUrl= '';
    // Function invoked after click in the template
    vm.selectAccountModal = function (val) {
      myrAccountListService.selectAccount(val);
      // close modal
      //$modalInstance.close('ok');
      $rootScope.modal = null;
      $rootScope.alsModal = true;
      // Added null check for $rootScope.ao and $rootScope.ao.accountDetails; otherwise we get stuck at account selection modal when overview/summary API calls fails or takes longer
      if ($rootScope.ao && $rootScope.ao.accountDetails && $rootScope.ao.accountDetails.accountNumber === val.accNo) {
        myrAccountListService.captureAccountSelection($rootScope.ao.accountDetails);
        $rootScope.alsModal = false;
      }
      var ppcUrl = cookieStore.get('ppc_url') || appState.readCookie('ppc_url');
      vm.solarisUrl = '';

        try {
          vm.solarisUrl = sessionStorage.getSessionStorageValue('solarisDeeplink') || appState.readCookie('solarisDeeplink');
          vm.legacyUrl = sessionStorage.getSessionStorageValue('legacyDeeplink') || appState.readCookie('legacyDeeplink');
          sessionStorage.deleteSessionStorageValue('solarisDeeplink');
          appState.removeCookie('solarisDeeplink','/','.rogers.com');
          sessionStorage.deleteSessionStorageValue('legacyDeeplink');
          appState.removeCookie('legacyDeeplink','/','.rogers.com');
          if (vm.solarisUrl === undefined || vm.solarisUrl === null || vm.solarisUrl === 'undefined') {
            vm.solarisUrl = '';
          }
           if (vm.legacyUrl === undefined || vm.legacyUrl === null || vm.legacyUrl === 'undefined') {
               vm.legacyUrl = '';
           }
        } catch (err) {
        }

      if (ppcUrl && ppcUrl.indexOf('choose-plan') > -1) {
        appState.removeCookie('ppc_url', '/web/totes', ' ');
        var ppcDeepLinkUrl = localStorage.getLocalStorageValue('ppc_deeplink_url');
        localStorage.setLocalStorageValue('accountNumber', val.accountNumber);
        if (!!ppcDeepLinkUrl && ppcDeepLinkUrl.indexOf('soc') > -1) {
          $window.location.href = '/web/totes/wireless-plan-change/#' + ppcDeepLinkUrl;
        } else {
          $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan';
        }
      }else if(vm.solarisUrl != '' || vm.legacyUrl != ''){
        vm.solarisUrl=vm.deeplinkUrl(vm.solarisUrl);
        getAccountDetails(val);

      } else {
        $window.open('/consumer/self-serve/overview', '_self');
        $modalInstance.close('ok');
      }
    };

    vm.deeplinkUrl = function(url){

        url = (url === undefined) ? '' : url;
        var decode = '';
        var splitUrlArr = url.split('?');
        var parametersSetStr = splitUrlArr[1];
        var tragetString = '';
        var sourceString = '';
        var jwtString = '';

        if (parametersSetStr !== undefined) {
          var parametersSetArr = parametersSetStr.split('&');

          if (parametersSetArr.length > 0) {
            for (var op in parametersSetArr) {
              var opNum = parseInt(op);

              if (typeof opNum === 'number' && opNum >= 0) {
                var tempStr = parametersSetArr[opNum];

                var targetSearch = tempStr.indexOf('TARGET');
                var refSearch = tempStr.indexOf('referer');
                var sourceSearch = tempStr.indexOf('sourceid');

                if (sourceSearch === 0) {
                  sourceString = tempStr;
                  sourceString = sourceString.replace('sourceid=', '');
                }
                if (targetSearch === 0 || refSearch === 0) {
                  tragetString = tempStr;
                  //break;
                }
              }
            }
          }
        }

        if (tragetString !== '') {
          var ts = tragetString.indexOf('TARGET');
          var rs = tragetString.indexOf('referer');

          // make sure that only the first word is removed
          if (ts === 0) {
            tragetString = tragetString.replace('TARGET=', '');
            tragetString = decodeURIComponent(tragetString);			// Once only
          }
          if (rs === 0) {
            tragetString = tragetString.replace('referer=', '');
            tragetString = decodeURIComponent(tragetString);			// Once
            tragetString = decodeURIComponent(tragetString);			// TWICE encoded!!!  WOWsies!!!
          }
          decode = smUrlDecode(tragetString);								// jshint ignore:line

        }
        // $log.info('deeplink.deepLink - decode', decode);

        // Objectify this to match the rest of the script
        return decode;
    };
    // OK / Cancel buttons
    vm.ok = function () {
      // vm.als.accountPicked = true;
      vm.als.setAccountPicked(true);
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };

    vm.getNoProductUrl = function () {
      if (appState.noProductButton === 'wireless') {
        return '/consumer/wireless';
      } else if (appState.noProductButton === 'internetdash') {
        return '/consumer/internet';
      } else {
        return undefined;
      }
    };

    function getAccountDetails(val){
       var request = {
        applicationId: 'Rogers.com',
        accountNumber: val.accountNumber,
        accountTypeNumber: val.accountTypeNumber,
        pinNumber: val.pinNumber,
        phoneNumber: val.phoneNumber,
        language: languageSwitcher.getCurrentLanguage(),
        refresh: false
    };
     accountOverviewService.clearAccountDetails();
     accountOverviewService.getAccountDetails(request, function (tmp) {
      if (tmp.result === 'success') {
        var sublist = tmp.data.subList;
        var foundIT = false;
        for (var i = 0; i < sublist.length; i++) {
         var item = sublist[i];
         if(item.subType === 'HSI' && checkIfInternetUrl()) {
          foundIT=true;
          constructInputForSolaris(item);
          constructQueryParams();
          redirectToSolaris(item);
          break;
          }
         else if(item.subType === 'IPTV' && vm.solarisUrl.indexOf('/tv') >=0) {
           foundIT=true;
           constructInputForSolaris(item);
           constructQueryParams();
           redirectToSolaris(item);
           break;
          }
         else if(item.subType === 'RHP Phone Line' && (vm.solarisUrl.indexOf('/home-phone') >=0 || vm.solarisUrl.contains('/web/OnlineManager.portal?maestroIndicator=true'))) {
           foundIT=true;
           constructInputForSolaris(item);
           constructQueryParams();
           redirectToSolaris(item);
           break;
         }
          else if(item.subType === 'Digital TV' && vm.legacyUrl != '' && (vm.legacyUrl.indexOf('ResetDigitalBox') >=0 ||
            vm.legacyUrl.indexOf('ResetDigitalPin') >=0 || vm.legacyUrl.indexOf('build-your-tv-package') >=0)){
            var can = item.subAccountId;
            foundIT=true;
            appState.setCookie('legacyCAN', can,'/','.rogers.com');
            $window.location.href = vm.legacyUrl;
            break;
          }
      }
       if(!foundIT){
          $window.open('/consumer/self-serve/overview', '_self');
       }
     }
     else {
      $window.open('/consumer/self-serve/overview', '_self');
           }
    });
    }
    function constructInputForSolaris(item){
     vm.inputParams= {
                accountNumber: $rootScope.ao.accountActive.accountNumber,
                subAccountId: item.subAccountId,
                subscriptionId: item.subNumber,
                source: 'rogers.com',
                redirectTo: {
                  protocol: window.location.protocol,
                  host: window.location.hostname,
                  port: window.location.port,
                  path: window.location.pathname,
                  hash: window.location.hash,
                  href: window.location.href
                }
                };

    }

    function constructQueryParams(){
      vm.queryParams= {
          lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
          userType: userService.getUserType(),
          province: cookieStore.get('province').toLowerCase() // pull from usersService
      };
    }
    function redirectToSolaris(item){
    switch (item.subType) {

    case 'HSI':
      if(vm.solarisUrl.contains('/change-internet-package')){
        eclipseRemoteApi.goToInternetChangePackage(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/daily-usage')){
        eclipseRemoteApi.goToInternetDailyUsage(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/monthly-usage')){
        eclipseRemoteApi.goToInternetMonthlyUsage(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/daily-alerts')){
        eclipseRemoteApi.goToInternetDailyAlerts(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/internet')){
        eclipseRemoteApi.goToHSIDashboard(vm.inputParams,vm.queryParams);
      }
        return;
        break;
    case 'IPTV':
      if(vm.solarisUrl.contains('/channels-and-themepacks')){
        eclipseRemoteApi.goToTVChannelsAndThemePacks(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/swap-channels')){
        eclipseRemoteApi.goToTVSwapChannels(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/change-tv-package')){
        eclipseRemoteApi.goToTVChangePackage(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/tv?swap=true')){
        eclipseRemoteApi.goToIPTVSwapDashboard(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/tv')){
        eclipseRemoteApi.goToIPTVDashboard(vm.inputParams,vm.queryParams);
      }
        return;
        break;
    case 'RHP Phone Line':
      if(vm.solarisUrl.contains('/home-phone')){
        eclipseRemoteApi.goToRHPDashboard(vm.inputParams,vm.queryParams);
      }
      else if(vm.solarisUrl.contains('/OnlineManager')){
         appState.setCookie('olmtn', item.serviceNumber,'/','.rogers.com');
         $window.location.href = '/web/torcom/OnlineManager.portal?maestroIndicator=true';
      }
        return;
        break;
    }
  }
    function checkIfInternetUrl(){
     if(vm.solarisUrl.includes('/internet') || vm.solarisUrl.includes('/daily-usage') || vm.solarisUrl.includes('/monthly-usage') || vm.solarisUrl.includes('/daily-alerts')){
      return true;
      }
      return false;
    }
  }
})();

/* jshint -W040 */
(function () {
  'use strict';

  /**
   * @name totesApp.module:myrAccountListService
   * @description
   * # myrAccountListService
   */
  angular.module('totesApp').factory('myrAccountListService', accountListService);

  accountListService.$inject = ['$rootScope',
    '$browser',
    'appState',
    'ajax',
    '$translate',
    '$cookieStore',
    '$q',
    'localStorage',
    'sessionStorage',
    'ute.rogers.account.overview.factory',
    'ute.common.user.service',
    'ute.blocks.language.switcher',
    'ute.rogers.account.selection.service',
    'ute.fraud.logging.service',
    'ute.fraud.logging.TransactionProp'];

  function accountListService($rootScope,
                              $browser,
                              appState,
                              ajax,
                              $translate,
                              $cookieStore,
                              $q,
                              localStorage,
                              sessionStorage,
                              newAccountOverviewFactory,
                              userService,
                              languageSwitcher,
                              accountSelectionService,
                              fraudLoggingService,
                              transactionProp) {
    var accountOverviewFactory = null;
    var rawAccountList, rawData;
    var updateAccountListCallBack;
    var ps;

    var service = {
      accountListRaw: null,
      accountTypes: [],
      selectedIndex: 0,
      selectedAccount: null,
      errorLoadingKey: null,
      apiErrorResponse: {},
      viewBillVisitedAccounts: [],
      isAccountPicked: accountSelectionService.isAccountPicked,
      setAccountPicked: accountSelectionService.setAccountPicked,
      processAccountList: processAccountList,
      getAccountList: getAccountList,
      getSelectedAccount: getSelectedAccount,
      updateSelectedAccount: updateSelectedAccount,
      getAccountStatus: getAccountStatus,
      removeAccount: removeAccount,
      updateSelectedAccountByAccountNumber: updateSelectedAccountByAccountNumber,
      primarycontactName: null,
      selectAccount: selectAccount,
      resetServiceData: resetServiceData,
      registerUpdateAccountListCallBack: registerUpdateAccountListCallBack,
      generateToken: generateToken,
      getWcocLinksStatus: getWcocLinksStatus,
      captureAccountSelection: captureAccountSelection
    };

    if (userService.isSigned()) {
      if (window.document.referrer.indexOf('totes/easylogin') === -1) {
        service.setAccountPicked(true);
      }
      signinHandler();
    }
    userService.registerSigninHandler(_.partial(signinHandler, 'Signin'), signinHandler);
    userService.registerSignoutHandler(_.partial(signoutHandler, 'Signout'), signoutHandler);

    function registerUpdateAccountListCallBack(callBack) {
      updateAccountListCallBack = callBack;
    }

    function getWcocLinksStatus() {
      if (service.selectedAccount.accountStatus.toLowerCase() != 'cancelled' && service.selectedAccount.accountTypeNumber === 1
          && service.selectedAccount.isWlsSubTypeExists && service.selectedAccount.subNumbers && service.selectedAccount.subNumbers.length > 0) {
        return true;
      }
      return false;
    }

    function signoutHandler() {
      resetServiceData();
      accountOverviewFactory.reset();
      accountOverviewFactory.unregisterOnDataChangeHandler('myrAccountListService');
      accountOverviewFactory = null;
      ps.remove('accountNumber');
      ps.remove('accountTypeNumber');

      //Remove cookie related to easylogin, which was used to display the BAN selection modal
      $cookieStore.remove('easyLoginCheckPassed');
    }

    function generateToken() {
      var request = {
        applicationId: 'Rogers.com'
      };
      return ajax.getWcocJwtToken(request);
    }

    languageSwitcher.registerOnDataChangeHandler(function () {
      if (service.updateSelectedAccount(service.selectedIndex)) {
        service.getAccountStatus(service.selectedAccount);
      }
    }, 'accountListServiceLangSub');

    return service;

    function resetServiceData() {
      service.accountListRaw = null;
      service.accountTypes = [];
      service.selectedIndex = 0;
      service.selectedAccount = {accountNumber: ''};
      service.errorLoadingKey = null;
      service.apiErrorResponse = {};
      service.primarycontactName = null;
      service.setAccountPicked(false);
      rawAccountList = null;
      $rootScope.ao.raw = null;
      $rootScope.ao.allAccounts = null;
    }

    function processSelectedAccount(account) {
      if (service.selectedAccount && account && service.selectedAccount.accountNumber !== String(account.accountNumber)) {
        service.selectedIndex = _.findIndex(service.accountTypes, {accountNumber: String(account.accountNumber)});
        service.selectedAccount = service.accountTypes[service.selectedIndex];
        if (service.selectedAccount) {
          appState.aoReconstruct(service.selectedAccount.accountNumber);
        } else {
          resetServiceData();
        }
      }
    }

    function processAccountList(raw) {
      if (raw && raw.accountList && _.isEqual(rawAccountList, raw.accountList)) {
        newAccountOverviewFactory().getSelectedAccount().then(processSelectedAccount);
        return rawData;
      }

      try {
        rawAccountList = _.cloneDeep(raw.accountList);

        raw = rawData = _.cloneDeep(raw);
        raw.total = raw.accountList.length;

        if (raw.total <= 0) {			// WARNING - Should raw.total be used at all???
          //if no account, redirect to the account linking page
          appState.aoFlushScope();
          raw.total = 0;
          raw.result = 'redirect';
        } else if (raw.total > 0) {
          if (raw.total === 1) {
            service.setAccountPicked(true);
            ps.put('accountNumber', raw.accountList[0].accountNumber);
            ps.put('accountTypeNumber', raw.accountList[0].accountTypeNumber);
          }
          // successful data catch
          // for (var i = 0; i < raw.total; i++) {
          //   var account = raw.accountList[i];
          //   account.accountOwner = account.accountName.firstName + ' ' + account.accountName.lastName;
          //
          //   account.payNow = account.accountStatus !== 'Suspended' && account.accountStatus !== 'Cancelled' && account.accountStatus !== 'Deactive';
          //   // MYR-1567 => Find Primary contact First Name
          //   // The variable 'primarycontactName' will use in CMS content ID: cms/content/ute/rogers/views/account-overview/greeting-message1/greeting-message1
          //   // Just comment it out because MYR-191 has been canceled
          //   // if(angular.isUndefinedOrNull(service.primarycontactName) && account.accountName && account.accountName.role && account.accountName.role === 'Primary'){
          //   //   service.primarycontactName = account.accountName.firstName;
          //   // }
          // }

          raw.accountList = raw.accountList.map(function (account) {
            account.accountOwner = account.accountName.firstName + ' ' + account.accountName.lastName;
            account.payNow = account.accountStatus !== 'Suspended' && account.accountStatus !== 'Cancelled' && account.accountStatus !== 'Deactive';
            getAccountStatus(account);
            account.accNo = account.accountNumber;
            return account;
          });

          // store for later and split up the raw data into user and permissions
          appState.aoFlushScope();
          raw.result = 'success';
          $rootScope.ao.allAccounts = service.accountTypes = raw.accountList;

          raw.data = raw.accountList;									// TODO review all functions that deal with list and fix that to allAccounts

          $rootScope.permissions.allPermissions = raw.permissions;
          $rootScope.permissions.permissionActiveIndex = $rootScope.permissions.permissionActiveIndex ? $rootScope.permissions.permissionActiveIndex : 0;
          $rootScope.permissions.permissionActive = $rootScope.permissions.permissionActive ? $rootScope.permissions.permissionActive : $rootScope.permissions.allPermissions[0];

          //TODO: dashboards require an account, account overview requires a process account.. we shouldn't be swapping them around
          var tmp = $rootScope.isCare ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');

          if (!service.selectedAccount || String(service.selectedAccount.accountNumber) !== tmp) {
            service.selectedAccount = _.find(raw.accountList, {accountNumber: tmp}) || raw.accountList[0];
          }
          // NPS-1650: Added to enable View Bill menu on pageload and in Wireless dashboard page
          if (($rootScope.isCare || $rootScope.isDealer) && service.selectedAccount) {
            $rootScope.ao.accountActiveIndex = _.findIndex($rootScope.ao.allAccounts, {'accountNumber': service.selectedAccount.accountNumber});
            $rootScope.ao.accountActive = $rootScope.ao.allAccounts[$rootScope.ao.accountActiveIndex];
          }
        } else {
          appState.aoFlushScope();
          raw.total = -1;
          raw.result = 'fail';
        }
      } catch (err) {
        appState.aoFlushScope();

        if (!raw) {
          raw = {};
        }
        raw.total = -1;
        raw.result = 'fail';
      }

      $rootScope.ao.raw = raw;
      return raw;
    }

    function getAccountStatus(_tmp) {
      _tmp.accountStatusSimple = 'Active';
      _tmp.accountStatusError = '';
      _tmp.accountCancelled = false;
      $rootScope.accountStatus = _tmp.accountStatus;

      if (_tmp.accountStatus === 'Suspended') {
        _tmp.accountStatusSimple = 'Error';
        _tmp.accountStatusModalMessage = 'acc_overview_account_suspended_2';

        if (_tmp.accountTypeNumber === '9' || _tmp.accountTypeNumber === 9) {
          _tmp.accountStatusError = $translate.instant('acc_overview_pay_as_you_go_suspended');
        } else {
          if ($rootScope.isDealer) {
            _tmp.accountStatusError = $translate.instant('acc_overview_account_overdue_one_view');
          }
          if ($rootScope.isCare) {
            _tmp.accountStatusError = $translate.instant('acc_overview_account_overdue_one_view_care');
          }
          else {
            _tmp.accountStatusError = $translate.instant('acc_overview_account_overdue');
          }
        }
      } else {
        if (!!_tmp.postpaidAccountBalance && !_tmp.isCLM && !_tmp.isCLMExceeded) {
          _tmp.isCLM = (Number(_tmp.postpaidAccountBalance.creditLimit) > 0);
          _tmp.isCLMExceeded = _tmp.postpaidAccountBalance.exceedCreditLimit;
        }

        if (_tmp.isCLM && _tmp.isCLMExceeded) {
          _tmp.accountStatusSimple = 'Warning';
          _tmp.accountStatusError = $translate.instant('acc_selection_clm');
          _tmp.accountStatusModalMessage = 'acc_overview_account_exceeded';
          _tmp.accountStatus = 'CLMExceeded';

        } else {
          if (_tmp.accountStatus === 'Cancelled' || _tmp.accountStatus === 'Closed' || _tmp.accountStatus === 'Inactive' ||
            _tmp.accountStatus === 'Expired' || _tmp.accountStatus === 'Deactive') {
            _tmp.accountStatusModalMessage = 'acc_overview_account_cancelled';
            switch (_tmp.accountTypeNumber) {
              case 9:
                _tmp.accountStatusSimple = 'Warning';
                _tmp.accountStatusError = $translate.instant('acc_overview_pay_as_you_go_cancelled');
                break;
              default:
                _tmp.accountStatusSimple = 'Warning';
                _tmp.accountStatusError = $translate.instant('acc_overview_account_limited');
                _tmp.accountCancelled = true;
                break;
            }
          }
        }
      }

      return _tmp;
    }

    function getAccountList(request, callback, errorCallBack) {
      // Always make ajax call to get fresh data

      function processList(data) {
        // Process data
        data = service.processAccountList(data);
        if (data.result === 'success' || data.result === 'redirect' || data.result === 'fail') {
          // if (data.result === 'fail') {
          //   service.errorLoading = 'Failed to load account list';
          // }
          return callback(data);
        }
      }

      function callForAccountList() {
        ajax.getAccountList(request).then(
          function (data) {
            if(data) {
              service.errorLoadingKey = null;
            }
            processList(data);
          },
          function (error) {
            //redirect users to the maintenance page
            //ajax.abort();
            if (request.refresh === false) {
              appState.showMaintenance();
            } else {

              service.errorLoadingKey = 'acc_overview_oops';

              if (errorCallBack) {
                errorCallBack();
              }
            }
          });
      }

      callForAccountList();
      // if ($rootScope.ao.raw && $rootScope.ao.raw.cachedResultInfo && !$rootScope.ao.raw.cachedResultInfo.expired) {
      //   processList($rootScope.ao.raw);
      // } else {
      //   callForAccountList();
      // }

    }

    function removeAccount(accountNum) {
      service.accountTypes = service.accountTypes.filter(function (obj) {
        return obj.accountNumber !== accountNum;
      });
      $rootScope.ao.raw.accountList = $rootScope.ao.raw.accountList.filter(function (obj) {
        return obj.accountNumber !== accountNum;
      });
      $rootScope.ao.allAccounts = service.accountTypes;

      newAccountOverviewFactory().unlinkAccount(accountNum);

      if (String(accountNum) === service.selectedAccount.accountNumber) {
        service.updateSelectedAccount(0);
        $rootScope.ao.accountActiveIndex = 0;
      }
    }

    function getSelectedAccount() {
      // active account
      if (service.accountTypes === null) {
        //return false;										// TODO - make call getAccountList
      } else {
        return (service.selectedAccount);
      }
    }

    function updateSelectedAccountByAccountNumber(accountNumber) {
      var index = _.findIndex(service.accountTypes, {accountNumber: String('accountNumber')});
      if (index >= 0) {
        updateSelectedAccount(index);
      }
    }

    function updateSelectedAccount(index) {
      if (index === -1) {
        index = 0;
      }
      if (service.accountTypes === null || service.accountTypes.length === 0) {
        // Check rootscope storage
        if ($rootScope.ao.allAccounts !== null) {
          service.selectedIndex = index;
          service.accountTypes = $rootScope.ao.allAccounts;
          service.selectedAccount = this.accountTypes[index];		// update private data
          return true;
        } else {
          return false;									// TODO - make call getAccountList
        }
      } else {
        service.selectedAccount = service.accountTypes[index];			// update private data
        service.selectedIndex = index;

        return true;
      }
    }

    function selectAccount(account) {
      console.log(account);
      newAccountOverviewFactory().selectAccount(account);
      // if ($rootScope.isCare) {
      //   sessionStorage.setSessionStorageValue('accountNumber', account.accountNumber);
      // } else {
      //   localStorage.setLocalStorageValue('accountNumber', account.accountNumber);
      // }
      // Broadcast the event

      if (updateAccountListCallBack && typeof updateAccountListCallBack === 'function') {
        try {
          updateAccountListCallBack();
        } catch (e) {
        }
      }
    }

    function signinHandler() {
      ps = userService.getPersistentService();

      if (accountOverviewFactory === null) {
        accountOverviewFactory = newAccountOverviewFactory();
        accountOverviewFactory.getAccountOverviewRawData()
          .then(processAccountList)
          .catch(function(error) {
            service.apiErrorResponse.errorCode = _.get(error, 'status', '');
            service.apiErrorResponse.API = _.get(error, 'config.url', '');
            service.errorLoadingKey = 'maintenance_info';
          })
          .finally(function () {
            accountOverviewFactory.registerOnDataChangeHandler(function (newAccountOverview) {
              processAccountList(newAccountOverview.rawData);
            }, 'myrAccountListService');
          });
      }
    }

    function captureAccountSelection(data) {
      var fraudTransactionPayload = {
        sourceChannel: transactionProp.sourceChannel.rogers,
        transactionType: transactionProp.transactionType.accountOverview,
        action: transactionProp.action.accountSelection,
        franchise: transactionProp.franchise.rogers,
        userType: transactionProp.userType.consumer,
        userEmail: userService.getUser().userEmail,
        loginId: userService.getUser().userEmail,
        authUser: data.accountName.firstName + ' ' + data.accountName.lastName,
        accountStatus: data.accountInfo.originalStatus,
        customerFirstName: data.accountName.firstName,
        customerLastName: data.accountName.lastName,
        transactionStatus: transactionProp.transactionStatus.success
      };
      if (data.accountNumber.length === 12) {
        fraudTransactionPayload.can = data.accountNumber;
      }
      else if (data.accountNumber.length === 9) {
        fraudTransactionPayload.ban = data.accountNumber;
        fraudTransactionPayload.banSubType = data.accountInfo.accSubType;
        fraudTransactionPayload.banType = data.accountInfo.accType;
      }
      fraudLoggingService.captureTransaction(fraudTransactionPayload);
    }
  }

}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name accountOverview
   * @description
   * # account overview service and controller
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrAccountOverviewController', AccountOverviewController);

  AccountOverviewController.$inject = ['$scope',
    '$rootScope',
    'btnSettings',
    'appState',
    'myrAccountOverviewService',
    'settings',
    '$modal',
    'ajax',
    '$window',
    '$cookies',
    'localStorage',
    'myrNotificationBannerService',
    'myrMyServicesService',
    'myrAccountListService',
    'myrAccountBalanceDataFactory',
    'myrRgclService',
    'ute.brite.bill.service',
    'winOnlineService',
    '$translate',
    'myrProfileFactory',
    'sessionStorage',
    'sspDeepLink',
    'backToSSPService',
    'ute.data.manager.service',
    'ute.common.permissions.service',
    'myrAccountUnlockService',
    '$state',
    '$location',
    'ute.rogers.account.overview.factory',
    'liveChatSettings',
    'ute.common.pending.order.service',
    'agentSession',
    'ute.common.user.service',
    'ute.payment.ui.pay.now.service',
    'ute.blocks.language.switcher',
    '$http',
    'ute.rogers.hero.modal.service',
    'ute.datalayer.common.service',
    'cookieStore',
    'EOPService'
  ];

  /* @ngInject */
  function AccountOverviewController($scope,
    $rootScope,
    btnSettings,
    appState,
    accountOverviewService,
    settings,
    $modal,
    ajax,
    $window,
    $cookies,
    localStorage,
    notificationBannerService,
    myrMyServicesService,
    myrAccountListService,
    myrAccountBalanceDataFactory,
    rgclService,
    briteBillService,
    winOnlineService,
    $translate,
    myrProfileFactory,
    sessionStorage,
    sspDeepLink,
    backToSSPService,
    dataManagerService,
    permissionsService,
    myrAccountUnlockService,
    $state,
    $location,
    newAccountOverviewFactory,
    liveChatSettings,
    pendingOrderService,
    agentSession,
    userService,
    payNowService,
    languageSwitcher,
    $http,
    RogersHeroModalService,
    dataLayerService,
    cookieStore,
  EOPService) {
    var vm = this;
    var accountOverviewFactory = newAccountOverviewFactory();

    notificationBannerService.cleanBanner('linkedMessage');
    notificationBannerService.cleanBanner('successMessage');

    //Boldchat Changes starts
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.liveChatSettings = liveChatSettings;
    $scope.setStaticChatButtonValues = function () {
      if (languageSwitcher.getCurrentLanguage() === 'en') {
        $scope.boldChatButtonId = 'S_MyRog_SuspAcc';
        $scope.boldChatButtonDiv = 'account-overview';
        $scope.boldChatButton = 'chatButtonAccountOverview';
      }
    };

    $scope.setStaticChatButtonValues();
    //Boldchat Changes ends

    // Scope variables
    vm.appState = appState;
    vm.btnSettings = btnSettings;
    vm.btnStatus = $window.btnStatus;

    vm.mss = myrMyServicesService;
    vm.als = myrAccountListService;
    vm.aus = myrAccountUnlockService;
    vm.abdf = myrAccountBalanceDataFactory;
    vm.bb = briteBillService;
    vm.win = winOnlineService;

    vm.rgcl = rgclService;

    vm.loadingDataIndicator = false;
    vm.loading = false;
    vm.accountLockStatus = false;
    vm.preCleanCall = preCleanCall;
    vm.postToRogersCancelled = postToRogersCancelled;
    vm.payBill = payBill;
    vm.payBillSuspended = payBillSuspended;
    vm.viewHistory = viewHistory;
    vm.runRogersProfile = runRogersProfile;
    vm.isOtherAvailableServicesHidden = isOtherAvailableServicesHidden;
    vm.isOtherAvailableServicesDisabled = isOtherAvailableServicesDisabled;
    vm.suspendedSubscriptionMessage = myrMyServicesService.suspendedSubscriptionMessage;
    vm.isShareEverything = isShareEverything;
    vm.isEligibleProduct = isEligibleProduct;
    vm.unlockAccount = unlockAccount;
    vm.loadingBriteBill = false;
    vm.actionsOffersPermission = false;
    vm.repActionOffersUpdate = false;
    vm.contactCarePopup = contactCarePopup;
    var hasRHP = false;

    vm.errorMessage = null;

    var newAccountOverviewService = newAccountOverviewFactory();

    var errorMessages = {
      'accountList': null,
      'summary': null,
      'balanceDetails': null,
      'loyalty': null
    };

    vm.maintenanceLiveChatParams = null;

    vm.isInfinitePlan = function() {
      return JSON.parse(window.sessionStorage.getItem('isInfinitePlan'));
    };


    vm.wirelessFilteredListLength = function () {
      var dmBadgeList = dataManagerService.getBadgeList().subscriberList;
      var listLength = 0;

      for (var iService = 0; iService < vm.mss.myServicesList.length; iService++) {

        var service = vm.mss.myServicesList[iService];

        if (service.serviceName === 'wireless' || service.serviceName === 'shareEverything') {

          var bFound = false;

          for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
            if (service.serviceDetail === dmBadgeList[iSELine].ctn) {
              bFound = true;
            }
          }

          if (!bFound) {
            listLength++;
          }
        }

      }

      return listLength;

    };

    vm.onboardingStatus = function (status) {
      // when we display onboarding, goPaperless banner must be hidden
      vm.showGoPaperless = !status;
    };
    /**
     * Call init function
     */
    init();

    if ($rootScope.isDealer || $rootScope.isCare) {
      // Deeplinking is only for dealer
      if ($rootScope.isDealer) {
        $scope.backFromSSPMessage = sspDeepLink.backFromSSPMsg();
        $scope.messageType = sspDeepLink.messageType();
      }
    } else {
      $('#toggleSwitch').hide();
    }

    function isShareEverything() {
      //TODO: BRTSwitch activated
      accountOverviewService.heroShareEverything = (dataManagerService.getBRT() && dataManagerService.getModel().isShareEverythingEligible && (dataManagerService.getModel().badgeList.subscriberList.length > 0));
      return (dataManagerService.getBRT() && dataManagerService.getModel().isShareEverythingEligible && (dataManagerService.getModel().badgeList.subscriberList.length > 0));
    }

    //TODO: move these to their module services
    permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER).then(function (isPermitted) {
      dataManagerService.setBRT(isPermitted);
    });
    //permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_ACTIONS_OFFERS).then(function (isPermitted) {
    //                        vm.actionsOffersPermission = isPermitted;
    //                      });

    if ($rootScope.isDealer || $rootScope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.OfferSale, ute.common.permissions.service.RamActionCodes.read)
            .then(function (agentPermission) {
              vm.repActionOffersUpdate = agentPermission;
              console.log("AGENT PERM: " + agentPermission);
            });
    }

    function errorMessageCheck() {
      errorMessages.accountList = $translate.instant(myrAccountListService.errorLoadingKey);
      errorMessages.summary = $translate.instant(myrMyServicesService.getErrorLoading().errorLoadingKey);
      errorMessages.balanceDetails = $translate.instant(myrAccountBalanceDataFactory.errorLoadingKey);
      vm.errorMessage = '';

      _.each(errorMessages, function (value) {
        if (value) {
          vm.errorMessage = value;
          vm.maintenanceLiveChatParams = (value !== errorMessages.balanceDetails) ? {
            'id': 'maintenance_info_live_chat_params.id',
            'div': 'maintenance_info_live_chat_params.div',
            'button': 'maintenance_info_live_chat_params.button'
          } : null;

          switch (value) {
            case errorMessages.summary:
              trackDataLayerAPIError(
                myrMyServicesService.getErrorLoading().apiErrorResponse.errorCode,
                myrMyServicesService.getErrorLoading().apiErrorResponse.API,
                vm.errorMessage
              );
            break;
            case errorMessages.balanceDetails:
              trackDataLayerAPIError(
                myrAccountBalanceDataFactory.apiErrorResponse.errorCode,
                myrAccountBalanceDataFactory.apiErrorResponse.API,
                vm.errorMessage
              );
            break;
            default:
              trackDataLayerAPIError(
                myrAccountListService.apiErrorResponse.errorCode,
                myrAccountListService.apiErrorResponse.API,
                vm.errorMessage
              );
          }
        }
      });
    }

    function loadingCheck() {
      if (!vm.mss.loadingData && !vm.abdf.loadingData) {
        vm.loading = false;
        vm.loadingDataIndicator = false;
        loadingLinkMessage();
        errorMessageCheck();

      }
    }

    function loadingLinkMessage() {
      if (appState.isLinked) {
        notificationBannerService.sendMessageKey('linkedMessage', 'linked_acc_success');
      } else {
        notificationBannerService.cleanBanner('linkedMessage');
      }
    }

    function trackDataLayerAPIError(errorCode, errorApi, errorMsg) {
      var dataLayerPredefinedSection = window.ute.datalayer.common.service.DataLayerPredefinedSection,
        dataLayerErrorType = window.ute.datalayer.common.service.ErrorType,
        dataLayerErrorCategory = window.ute.datalayer.common.service.ErrorCategory,
        dataLayerSections = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE];

      dataLayerService.trackError(
        {},
        dataLayerErrorType.PAGE_LOAD,
        errorCode,
        errorMsg,
        dataLayerErrorCategory.SELF_SERVE,
        undefined,
        errorApi,
        false,
        dataLayerSections, '');
    }

    var rgclCheck = function () {
      //TODO:DECOUPLE THIS AND MOVE THE FUNCTIONALITY TO THE RESPECTIVE MODULES
      // theres more todos to this than just decoupling... this is ridiculous code...
      // I've only rewritten to so that it works...
      if (
        !vm.mss.loadingData && !vm.rgcl.loadingData &&
        vm.mss.myOtherServicesListFinal &&
        $rootScope.isConsumer
      ) {
        var found = _.find(vm.mss.myOtherServicesListFinal, function (one, key) {
          return one.title === "myaccoverview_get_nhl";
        });

        if (found && found[0]) {
          found[0].isVisible = !rgclService.rgclEligible;
        }
      }
    };

    function isOtherAvailableServicesHidden() {
      if (vm.als.selectedAccount) {
        var btnSettings = vm.btnSettings.getSettings(vm.als.selectedAccount.accountStatus);

        return (btnSettings.otherAvailableServices === vm.btnStatus.hidden);
      }
    }

    function isOtherAvailableServicesDisabled() {
      if (vm.als.selectedAccount) {
        var btnSettings = vm.btnSettings.getSettings(vm.als.selectedAccount.accountStatus);

        return (btnSettings.otherAvailableServices === vm.btnStatus.disabled);
      }
    }

    function unlockAccount() {
      //To capture unlock click from accountOverview page
      vm.aus.unlockClick();
      $state.go('self-serve');
    }

    var scopewatch1 = $scope.$watch(function () {
      return vm.aus.accountLockStatus;
    }, function () {
      checkAccountLockStatus();
    });

    function checkAccountLockStatus() {
      vm.accountLockStatus = vm.aus.accountLockStatus;
    }

    if ($rootScope.isDealer || $rootScope.isCare) {
      checkAccountLockStatus();
    }

    /*

     var getMaintenanceSettings = function () {
     //if ($rootScope.ao.raw === null) {
     if ($rootScope.maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE === undefined) {
     //first time check signin language

     // Make call to server (Should not need to tho)
     var request = {
     refresh: false
     };

     var maintenanceSettingsResponse = function (_tmp) {
     accountOverviewService.processMaintenanceSettings(_tmp, true);
     };

     accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

     } else {
     // grab data from rootscope and have the function process that
     accountOverviewService.processMaintenanceSettings($rootScope.maintenance, true);
     }

     };

     */

    var getMaintenanceSettings = function () {
      var request = {
        refresh: false
      };

      var maintenanceSettingsResponse = function (_tmp) {
        accountOverviewService.processMaintenanceSettings(_tmp, true);
      };

      accountOverviewService.getMaintenanceSettings(request, maintenanceSettingsResponse);

      return null;
    };

    var scopewatch2 = $scope.$watch('ao.mss.loadingData', function (loading) {
      loadingCheck();
      rgclCheck();
    });

    var scopewatch3 = $scope.$watch('ao.abdf.loadingData', function (newValue, oldValue) {
      loadingCheck();
      if (oldValue === true && newValue === false) {
        vm.checkCLM();
      }
    });

    var scopewatch4 = $scope.$watch('ao.rgcl.loadingData', function () {
      rgclCheck();
    });


    function updatePendingOrderBadge(accountNumber) {
      pendingOrderService.setLanguage('en');
      pendingOrderService.setRefresh('false');
    }

    function preCleanCall() {
      // Notify server to prepare fresh data
      if ($rootScope.isDealer) {
        deepLinkingModal();
        $rootScope.targetFlow = settings.deepLinkStatusCodes.getWireless;
      } else {
        var postData = {};
        postData.accountNumber = $rootScope.ao.accountActive.accountNumber;
        ajax.notifyServerLOBchange(postData);
      }
      return true;
    }

    function deepLinkingModal() {
      var userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
      ajax.getUserPreference(userId).then(
        function (data) {
          if (data && Object.keys(data).length > 0 && _.some(data.userPreference, {"name": "displayMovingToSSPPopUp"})) {
            var userPreferenceObject = _.find(data.userPreference, function (obj) {
              return obj.name === 'displayMovingToSSPPopUp';
            });
            if (!userPreferenceObject.value) {
              backToSSPService.backToSSP();
            } else {
              $scope.showDeepLinkPopUp(size);
            }
          } else {
            showDeepLinkPopUp('lg');
          }
        }, function (error) {
          showDeepLinkPopUp('lg');
        }
      );
    }

    function showDeepLinkPopUp(size) {
      $modal.open({
        templateUrl: 'views/modals/deepLinkModal.html',
        controller: 'deepLinkModalCtrl',
        controllerAs: 'vm',
        size: size,
        backdrop: false,
        resolve: {}
      });
    }

    function postToRogersCancelled() {
      if ($rootScope.isDealer || $rootScope.isCare) {
        // For dealer and care the viewbill is displayed only if it is brite bill, so no need to redirect to legacy
        appState.switchView('viewbill');
      } else {
        if ($rootScope.winFlag) {
          appState.switchView('winOnlineInvoice');
        }
        else {
          $('#formToRogers').attr('action', '/web/myrogers/viewBill' + '?setLanguage=' + languageSwitcher.getCurrentLanguage());
          $('#formToRogers').submit();
        }
      }
    }

    function payBillSuspended() {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      openPayNowModal();
    }

    function openPayNowModal() {
      accountOverviewFactory.getSelectedAccountDetails().then(function (accountDetails) {
        payNowService.openMakePaymentModal(vm.abdf.accountBalance, accountDetails, $state.current && $state.current.name ? $state.current.name : 'accountOverview');
      }).catch(function (error) {
        console.log('error getting account summary');
      });
    }

    function payBill() {
      //localStorage.setLocalStorageValue('accountTypeNumber', $scope.selectedAccount.accountTypeNumber);
      ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);

      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();          // jshint ignore:line
      if (userService.getUserType() === 'consumer') {
        newAccountOverviewService.getSelectedAccountDetails().then(function (accountDetails) {
          payNowService.openMakePaymentModal(vm.abdf.accountBalance, accountDetails, $state.current && $state.current.name ? $state.current.name : 'accountOverview');
        }).catch(function (error) {
          console.log("error getting account summary");
        });
      }
      else {
        appState.switchView('/paynow');
      }
    }

    function viewHistory() {
      localStorage.setLocalStorageValue('accountTypeNumber', myrAccountListService.selectedAccount.accountTypeNumber);
      if ($rootScope.isCare) {
        sessionStorage.setSessionStorageValue('accountTypeNumber', myrAccountListService.selectedAccount.accountTypeNumber);
      }
      ////appState.switchView('paynow/' + $scope.selectedAccount.accountNumber + '/' + $scope.selectedAccount.accountTypeNumber);
      appState.switchView('/paymenthistory');
    }

    function runRogersProfile() {
      $window.location.href = '/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta&setLanguage=' + languageSwitcher.getCurrentLanguage();
    }

    // if (appState.afterPaymentRefresh) {
    //   appState.afterPaymentRefresh = false;
    //   //comment out this to avoid page refresh on account overview after payment
    //   //$window.location.reload(true);
    // }

    //Moving this service call to permissionResolver to partially fix the issue for MYR-1739 Safari users on iOS are getting Under Maintenance page
    //getMaintenanceSettings();

    //*  <<<<<<<<<<<<<<<<<<  same bit of code on Guest overview page - Start
    // Setup Thank you / Community links modal
    var thanksModal = function () {
      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/thankYouModalCtrl.html',
        controller: 'MyrThankYouModalController',
        size: 'thankYouDesign',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
        $window.location.href = 'http://communityforums.rogers.com/t5/community/categorypage/category-id/EnglishCommunity?profile.language=' + languageSwitcher.getCurrentLanguage();
      }, function () {
        // on Cancel behaviour
      });
    };
    // Show modal windows in right order
    var thanksModalTimeout = setTimeout(function () {
      // Open Thank you / Community links modal
      if (appState.newRegistration && !myrProfileFactory.getNewRegistrationComplete()) {
        appState.newRegistration = false;
        thanksModal();        // 200ms delay
      }
      clearTimeout(thanksModalTimeout);
    }, 150);
    ////  <<<<<<<<<<<<<<<<<<  same bit of code on Guest overview page - End
    // //*/
    //
    // vm.goPaperless = function () {
    //   $rootScope.modal = $modal.open({
    //     templateUrl: 'scripts/modules/goPaperless/goPaperlessModal.html',
    //     controller: 'MyrGoPaperlessModalController',
    //     backdrop: 'static',
    //     backdropClass: 'bkg-modal',
    //     resolve: {}
    //   });
    //
    //   $rootScope.modal.result.then(function () {
    //     // on OK behaviour
    //   }, function () {
    //     // on Cancel behaviour
    //   });
    // };

    // Check credit Limit exceeded or not
    vm.checkCLM = function () {
      if (vm.als.selectedAccount.accountStatus === 'Active' && vm.abdf.accountBalance.exceedCreditLimit) {
        vm.als.selectedAccount.accountStatus = 'CLMExceeded';
        vm.als.selectedAccount.isCLM = true;
        vm.als.selectedAccount.isCLMExceeded = true;
        vm.als.selectedAccount.accountStatusSimple = 'Warning';
        vm.als.selectedAccount.accountStatusError = $translate.instant('acc_selection_clm');
        $rootScope.$broadcast('checkCLM', {});
      }
    };

    vm.showErrorMessages = function () {
      // if isCLM is true we must display the old banner for suspended accounts
      return !vm.loadingDataIndicator && !!vm.als.selectedAccount.accountStatusError && (vm.als.selectedAccount.accountStatus.toLowerCase() !== 'suspended' || vm.abdf.accountBalance.isCLM);
    };

    $scope.$on('$stateChangeStart', function () {
      appState.isLinked = false;
    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if ($rootScope.isDealer) {
        $scope.backFromSSPMessage = sspDeepLink.backFromSSPMsg();
        $scope.messageType = sspDeepLink.messageType();
      }
      $scope.lang = lang;
      errorMessageCheck();
    }, 'accountOverviewControllerLangSub');

    //var watcher;
    $scope.$on('$destroy', function () {
      languageSwitcher.unregisterOnDataChangeHandler('accountOverviewControllerLangSub');
      newAccountOverviewService.unregisterOnDataChangeHandler('MyrAccountOverviewController');
      $rootScope.eopOfferToShowBadge = undefined;
      //n Remove any watchers
      scopewatch1();
      scopewatch2();
      scopewatch3();
      scopewatch4();
      //watcher();

      if ($scope.$eopModal) $scope.$eopModal.close();
    });

    function isEligibleProduct(productNames) {
      if (!productNames) {
        return true;
      }

      if (agentSession.cfaInfo &&
        agentSession.cfaInfo.eligibleProducts) {
        return !_.difference(productNames, agentSession.cfaInfo.eligibleProducts).length;
      }
    }

    /**
     * Update Data Manager Model
     */
    function updateDataManager(accountDetail) {
      vm.selectedAccountDetails = accountDetail.rawData;
      if (_.isEmpty(accountDetail)) {
        return;
      }

      if (_.has(accountDetail, 'shareEverything.isDataManagerEligible') && accountDetail.shareEverything.isDataManagerEligible) {

        var model = dataManagerService.getModel();
        var modelTransformed = dataManagerService.transformSummary(accountDetail, model);

        dataManagerService.setModel(modelTransformed);

      } else {
        dataManagerService.resetBadgeList();
      }
    }


    function processSelectedAccountChange(selectedAccount) {
      vm.loading = true;
      vm.loadingDataIndicator = true;

      /**
       * Do not call brite bill for prepaid account
       */
      if (selectedAccount.accountTypeNumber !== 9) {
        briteBillService.getBills(selectedAccount.accountNumber);
      }

      vm.win.isWinOnline(selectedAccount.accountNumber);
      vm.rgcl.callGetSegmentationForRGCL(selectedAccount.accountNumber);

      // update pending order badge when account number gets loaded
      updatePendingOrderBadge(selectedAccount.accountNumber);
      loadingCheck();
    }

    function accountDataHandler(selectedAccount) {
      if (_.isEmpty(selectedAccount)) {
        return;
      }
      processSelectedAccountChange(selectedAccount);
      if($rootScope.isCare) {
        populateRepNameAccountNumber(selectedAccount);
      }
    }

    function populateRepNameAccountNumber(selectedAccount) {
      vm.agentInfo = sessionStorage.getSessionStorageObject('dealerInfo');
      vm.repNameAccountNumber = vm.agentInfo['userId'] + '-' + selectedAccount.accountNumber;
      if (typeof dtrum !== "undefined") {
        dtrum.identifyUser(vm.repNameAccountNumber);
      }
    }

    $scope.$eopModal = null;

    $scope.eopTriggeredOnce = false;

    $scope.$processingEOP = false;

    $scope.eopRedirectToPage = function(){
      var name = ''
      switch($rootScope.eopOfferToShowBadge.systemInd){
        case 0:
          name = "eop-offer-badge : You have a special upgrade offer"
          break;
        case 1:
          console.log('dom case',hasRHP)
          if(hasRHP){
            name = "Ignite internet + tv + home phone : You have a special upgrade offer"
          } else {
            name = "Ignite internet + tv : You have a special upgrade offer"
          }
          break;
        case 2:
          name = "Ignite internet : You have a special upgrade offer"
          break;
        case 3:
          name = "Ignite internet + smart stream : You have a special upgrade offer"
          break;
      }
      console.log('dom clicked',name)
      EOPService.track([$rootScope.currentStateName], {
        "interaction": {
          "type": "click",
          "name": name
        },
        "events": {
          "interaction": true,
        }
      });
      console.log('dom eop badge',$rootScope.eopOfferToShowBadge)
      if($rootScope.eopOfferToShowBadge && $rootScope.eopOfferToShowBadge.isLegacy){
        /*EOPService.track([$rootScope.currentStateName], {
          "interaction": {
            "type": "click",
            "name": "eop-offer-badge"
          },
          "events": {
            "interaction": true,
          }
        });*/
        if($rootScope.eopOfferToShowBadge.offerLOB === 'internet'){
          $state.go('internetdash');
        } else {
          $state.go('tvdashboard');
        }
      }else{

        //Ignite redirection rule goes here
        EOPService.handleIgniteRedirect();
      }
    }

    function triggerEOP(account) {
      $scope.$processingEOP = true;
      account.accountOverview.selectedAccount.getAccountOverviewSummary().then(function (summary) {
        summary.subList.forEach(function (sub) {
          console.log('this sub', sub)
          if(sub.subType.toLowerCase() === 'rhpc'){
            hasRHP = true;
          }
        });
        var accountNumber = summary.accountNumber + "";
        var subscriberInfo = EOPService.getActiveSubscriberInfo(summary);
        if (subscriberInfo.can && subscriberInfo.can.length === 12) {
          EOPService.triggerEOPOperation(accountNumber, subscriberInfo.can).then(function(openModalObject){
            $scope.$eopModal = openModalObject;
            $scope.$eopModal.result.then(function () {
              // on OK behaviour
              $scope.$processingEOP = false;
            }, function () {
              // on Cancel behaviour
              $scope.$processingEOP = false;
            });
          }, function(){
            $scope.$processingEOP = false;
          });
        }else{
          $scope.$processingEOP = false;
        }
      }, function () {
        $scope.$processingEOP = false;
      })
    }

    /**
     * Run this function on Selected Account change
     */
    function accountOverviewDataHandler(account) {
      if (_.isEmpty(account) || account.accountList.length === 0) {
        $rootScope.eopOfferToShowBadge = {}; // reset eop offers as it should not be shown to non eop customers
        return;
      }
      appState.isLinked = false;
      account.getSelectedAccountDetails().then(updateDataManager);
      accountDataHandler(account.selectAccount());
      if ($scope.eopTriggeredOnce) {
        $scope.eopTriggeredOnce = false;
        getCurrentAccountAndTriggerEOP()
      }
      getCurrentAccountAndSaveSubAddress();
    }

    function getTargetHeroOffers(summarySubscriberList) {
      var ban = localStorage.getLocalStorageValue('accountNumber');
      var ctnList = [];
      var tempIndividualCtns = myrMyServicesService.categorizedServices.individual;
      if(!tempIndividualCtns || tempIndividualCtns.length == 0) {
        if(summarySubscriberList && summarySubscriberList.length > 0) {
          summarySubscriberList.forEach(function(subscriber) {
            if(subscriber.status === 'Active')
              ctnList.push(subscriber.subscriberNumber);
          });
          RogersHeroModalService.getHeroDetailResponse(ban, ctnList)
          .then(function(response) {
            $scope.$broadcast('$targetheroresponse', response.data);
          });
        }
      } else {
        tempIndividualCtns.forEach(function(tempIndividualCtn) {
          ctnList.push(tempIndividualCtn.serviceDetail);
        });
        RogersHeroModalService.getHeroDetailResponse(ban, ctnList)
        .then(function(response) {
          $scope.$broadcast('$targetheroresponse', response.data);
          $scope.$broadcast('heroOfferInd', response.data);
        });
      }
    }

    /**
     * Init function
     */
    function init() {
      vm.showGoPaperless = false;
      newAccountOverviewService.getSelectedAccount()
        .then(accountDataHandler)
        .finally(function () {
          /**
           * Register on Selected Account change
           */
          newAccountOverviewService.registerOnDataChangeHandler(accountOverviewDataHandler, 'MyrAccountOverviewController');
        });
        newAccountOverviewService.getSelectedAccountDetails()
        .then(function(data) {
          updateDataManager(data)
        });
        getBrtSwitchDetails();

      if (appState.loadPaymentModal) {
        launchPayNowModal();
      }

      $scope.$on('accountSelectionBypassed', getCurrentAccountAndTriggerEOP);
      $scope.$on('accountSelectionBypassed', getCurrentAccountAndSaveSubAddress);

      $scope.$on('accountSelectionInProgress', function(evt){
        $scope.$on('accountSelectionDone', getCurrentAccountAndTriggerEOP);
        $scope.$on('accountSelectionDone', getCurrentAccountAndSaveSubAddress)
      })
    }

    function saveSubAddressCookie (account){
      try {
      account.accountOverview.selectedAccount.getAccountOverviewSummary().then(function (summary) {
        var serviceSubList = _.filter(summary.subList,
            function (service) {
              return service.subType === 'Digital TV';
            });
        if(serviceSubList.length > 0){
            cookieStore.put('subAddress', JSON.stringify(serviceSubList[0].subAddress),{path: '/',domain: ".rogers.com",end: 'Fri, 31 Dec 2100 23:59:59 GMT'});
         }
        if(userService.getUserType() === 'consumer') {
          getTargetHeroOffers(summary.subscriberList);
        }
      })
      } catch (e) {
      } finally {
      }
    }

    function getCurrentAccountAndTriggerEOP (){
      newAccountOverviewService.getSelectedAccount()
      .then(function(selectedAccount){
        if ($scope.$processingEOP === false) {
          $scope.eopTriggeredOnce = true;
          triggerEOP(selectedAccount);
        }
      })
    }
    function getCurrentAccountAndSaveSubAddress (){
      newAccountOverviewService.getSelectedAccount()
      .then(function(selectedAccount){
          saveSubAddressCookie (selectedAccount);
      })
    }

    function launchPayNowModal() {

      if (vm.als.isAccountPicked()) {
        appState.loadPaymentModal = false;
        newAccountOverviewService.getSelectedAccount()
          .then(function (selectedAccount) {
            if (selectedAccount.accountTypeNumber === 9) {
              appState.switchView('viewbill');
            } else {
              vm.abdf.getAccountBalanceAsync(selectedAccount.accountNumber).then(function (accountBalance) {
                newAccountOverviewService.getSelectedAccountDetails().then(function (accountDetails) {
                  payNowService.openMakePaymentModal(accountBalance, accountDetails, 'accountOverview');
                });
              });
            }
          });
      } else {
        var watcher = $scope.$watch(function () {
          return vm.als.isAccountPicked();
        }, function (newVal) {
          if (newVal) {
            watcher();
            launchPayNowModal();
          }
        }, true);
      }
    }
    /***
     As part of solaris requirement If customer does not have Legacy or Maestro
     Home phone then a left turn popup will be displayed
    **/
    function contactCarePopup(productName) {
      var modalInstance = $modal.open({
        templateUrl: 'views/modals/homephone-contact-care.html',
        windowClass: 'generic-message-modal',
        controller: ['$scope', '$translate', 'ute.blocks.language.switcher', function ($scope, $translate, languageSwitcher) {
          $scope.close = function () {
            modalInstance.close();
          };
          /*$scope.liveChat = {
            cbid: 'home_phone_contact_care_liveChat.cbid',
            dynamicDiv: 'home_phone_contact_care_liveChat.dynamicDiv',
            chatButton: 'home_phone_contact_care_liveChat.chatButton'
          };*/
          $scope.isLanguageEnglish = false;
          if (languageSwitcher.getCurrentLanguage() === 'en')
            $scope.isLanguageEnglish = true;
          var serviceName = productName;
          var myServiceList = _.filter(vm.mss.myServicesList,
            function (service) {
              return service.subType === 'IPTV' || service.subType === 'HSI';
            });
          if (myServiceList.length <= 0) {
            $scope.liveChat = {
              cbid: 'home_phone_contact_care_liveChat.cbid_legacy',
              dynamicDiv: 'home_phone_contact_care_liveChat.dynamicDiv_legacy',
              chatButton: 'home_phone_contact_care_liveChat.chatButton_legacy'
            };
          } else {
            $scope.liveChat = {
              cbid: 'home_phone_contact_care_liveChat.cbid_solaris',
              dynamicDiv: 'home_phone_contact_care_liveChat.dynamicDiv_solaris',
              chatButton: 'home_phone_contact_care_liveChat.chatButton_solaris'
            };
          }

        }]
      });
    }
    function getBrtSwitchDetails() {
      $http.get('/web/totes/cms/content/json/home_phone/switchDetails.json')
      .then(function (obj) {
        if (obj && obj.data){
          vm.mss.isRHPMigratedFlow = obj.data[0].isRHPMigratedFlow;
          userService.getPersistentService().put('rhpMigratedSwitch', obj.data[0].isRHPMigratedFlow);
        }
      }, function (error) {
          vm.mss.isRHPMigratedFlow = 'false';
          userService.getPersistentService().put('rhpMigratedSwitch', 'false');
       })
    }

    // To hide header on desktop view when scrolling down as part of the new header change
    function hideHeaderOnScroll(){
        if (window.pageYOffset > 0) {
          document.getElementsByClassName("dds-headerDesk")[0].style.top="-150px";;
        }else {
          document.getElementsByClassName("dds-headerDesk")[0].style.top="0px";
        }
		  document.getElementsByClassName("dds-headerDesk")[0].style.transition="top 0.2s ease-out";
    }
    window.onscroll = function(){hideHeaderOnScroll()};
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrAccountOverviewService', accountOverviewService);

  accountOverviewService.$inject = ['$rootScope',
    'ajax',
    'appState',
    'myrMyServicesService',
    'myrAccountListService',
    'myrAccountBalanceDataFactory'];

  /* @ngInject */
  function accountOverviewService($rootScope,
                                  ajax,
                                  appState,
                                  myrMyServicesService,
                                  myrAccountListService,
                                  myrAccountBalanceDataFactory) {

    return {
      // listing
      heroShareEverything: false,
      briteBillError: null,
      storedAccountList: null,
      storedSummary: null,

      accountBalance: myrAccountBalanceDataFactory.accountBalance,
      getAccountBalance: myrAccountBalanceDataFactory.getAccountBalance,
      getBalanceDetails: myrAccountBalanceDataFactory.getBalanceDetails,
      getSelectedAccount: myrAccountListService.getSelectedAccount,
      getAccountList: myrAccountListService.getAccountList,
      clearAccountDetails: myrMyServicesService.clearAccountDetails,
      getAccountDetails: myrMyServicesService.getAccountDetails,
      getSelectedAccountDetail: myrMyServicesService.getSelectedAccountDetail,
      getSubscriptions: myrMyServicesService.getSubscriptions,
      runService: myrMyServicesService.runService,
      getServicePath: myrMyServicesService.getServicePath,
      resetCallingAccountDetails: myrMyServicesService.resetCallingAccountDetails,
      updateMessage: myrMyServicesService.updateMessage,
      updateSuccessMessage: myrMyServicesService.updateSuccessMessage,

      purgeAccountList: function () {
        // Kill rootscope
        appState.aoFlushScope();
      },

      processMaintenanceSettings: function (raw) {

        // Clean up maintenance object into key > value array
        var TMPmaintenance = [];
        for (var a = 0, b = raw.length; a < b; a++) {		// custom data manipulation
          var _tmpObj = {};
          _tmpObj = raw[a];
          TMPmaintenance[_tmpObj.name] = _tmpObj.ruleValid;
        }

        $rootScope.maintenance = TMPmaintenance;
        $rootScope.altMaintenance = TMPmaintenance;

        // return only the index 4 (SITE_ON_MAINTENANCE) to the caller
        return raw[4];

      },
      getMaintenanceSettings: function (request, callback) {
        // Always make ajax call to get fresh data
        var _this = this;
        ajax.getMaintenanceSettings(request).then(
          function (data) {

            // process data
            data = _this.processMaintenanceSettings(data);
            if (data.name && data.name === 'SITE_ON_MAINTENANCE')/// site on maintenance nothing is available
            {
              $rootScope.maintenance.SITE_ON_MAINTENANCE = data.ruleValid;
              if ($rootScope.maintenance.SITE_ON_MAINTENANCE === true) {
                appState.switchView('underMaintenance');
              }
            }

            if ($rootScope.maintenance.SITE_ON_MAINTENANCE !== undefined) {
              return callback(data);
            }

          }, function (error) {
            // Ref: MYR-1993
            // skip show maintenance for only IOS device (iphone or ipad) and safari with status === 0
            if (!(
                error.data.status === 0 &&
                /ipad|iphone/i.test(window.navigator.platform) &&
                /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion))
              )) {
              appState.showMaintenance();
            }
          }
        );
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.accountPreferences').controller('myrAccountPreferences', AccountPreferences);

  AccountPreferences.$inject = [
    'myrMyServicesService',
    'ute.common.selection.modal.service',
    'myr.modules.accountPreferences.service',
    'myrWirelessDashboardService',
    'ute.common.permissions.service',
    'ute.rogers.account.overview.factory',
    'ute.blocks.language.switcher',
    '$q',
    '$modal',
    'myrAccountListService',
    'cookieStore',
    'sessionStorage',
    'ajax',
    '$window',
    'localStorage'];

  /* @ngInject */
  function AccountPreferences(myrMyServicesService,
                              commonSelectionModalService,
                              accountPreferencesService,
                              myrWirelessDashboardService,
                              permissionsService,
                              newAccoutOverviewFactory,
                              languageSwitcher,
                              $q,
                              $modal,
                              myrAccountListService,
                              cookieStore,
                              sessionStorage,
                              ajax,
                              $window,
                              localStorage) {
    var vm = this;
    vm.showLink = showLink;
    vm.changeVoicemailPassword = changeVoicemailPassword;
    vm.linkOnClick = linkOnClick;
    vm.wcocGenerateToken = wcocGenerateToken;
    vm.accountPreferencesList = [
      {
        label: 'myaccoverview_change_contact_information',
        Url: '#/profile#contactInformation',
        useNgClick: false,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      },
      {
        label: 'myaccoverview_switch_to_online_bill',
        Url: '#/profile#billingInformation',
        useNgClick: false,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      },
      {
        label: 'myaccoverview_change_password',
        Url: '#/profile',
        useNgClick: false,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      },
      {
        label: 'myaccoverview_change_method_of_payment',
        Url: '#/changemethod',
        useNgClick: false,
        template: 'scripts/modules/accountPreferences/ap.changePaymentLink.html'
      },
      {
        label: 'myaccoverview_reset_wireless_voicemail_password',
        useNgClick: true,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      },
      {
        label: 'myaccoverview_restore_data_access',
        useNgClick: true,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      },
      {
        label: 'myaccoverview_manage_who_can restore_data_access',
        useNgClick: true,
        template: 'scripts/modules/accountPreferences/ap.services.links.html'
      }];
    /**
     * Run initialize function to
     * set a flag for show and hide reset voicemail password and go-paperless links
     */
    var isWCOC_BRTSet = false;

    accountPreferencesService.initialize();
    hasDataPermission();

    vm.selectedAccountDetails = null;
    vm.getSelectedAccountDetails = function() {
      return accountPreferencesService.getSelectedAccount().then(function(acc){
        vm.selectedAccountDetails = acc;
      });
    };

    vm.getSelectedAccountDetails();

    function showLink(label) {
     if ((label === 'myaccoverview_switch_to_online_bill' && (accountPreferencesService.isPaperless() || accountPreferencesService.isPrepaid())) ||
        (label === 'myaccoverview_change_method_of_payment' && accountPreferencesService.isPrepaid()) ||
        (label === 'myaccoverview_reset_wireless_voicemail_password' && !accountPreferencesService.getVoicemailLinkFlag()) ||
        (label === 'myaccoverview_manage_who_can restore_data_access'&&  !(isWCOC_BRTSet && myrAccountListService.getWcocLinksStatus()))  ||
        (label === 'myaccoverview_restore_data_access' && !(isWCOC_BRTSet && myrAccountListService.getWcocLinksStatus()))
      ) {
        return false;
      }
      return true;
    }

    function hasDataPermission() {
      permissionsService.getUserPermission('WCOC_BRT').then(function(response) {
          isWCOC_BRTSet = !!response;
      });
    }

    function hasPostpaidAccount() {
      var deferred = $q.defer();
      newAccoutOverviewFactory().getSelectedAccount().then(function(account){
      var flag = false;
      if (account.accountStatus.toLowerCase() != 'cancelled' && account.accountTypeNumber === 1 && account.subNumbers && account.subNumbers.length > 0) {
        flag = true;
      }
        deferred.resolve(flag);
      });
      return deferred.promise;
    }

    function linkOnClick(item) {
      switch (item.label) {
        case 'myaccoverview_reset_wireless_voicemail_password':
          /* jshint -W040 */
          this.changeVoicemailPassword();
          break;
        case 'myaccoverview_restore_data_access':
          vm.wcocGenerateToken('/web/wcoc/#/restore-data/');
          break;
        case 'myaccoverview_manage_who_can restore_data_access':
          vm.wcocGenerateToken('/web/wcoc/#/manage-users/');
          break;
      }
    }

    function wcocGenerateToken(redirection){
      myrAccountListService.generateToken().then(function (data) {
        localStorage.setLocalStorageValue('wcocToken', data);
        var redirectionUri = $window.location.origin || $window.location.protocol + '//' + $window.location.host;
        redirectionUri = redirectionUri + redirection +languageSwitcher.getCurrentLanguage().toUpperCase()+'/R?entryId=D';
        sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
        $window.open(redirectionUri, "_self");
      },function (error) {
        console.log(error);
      });
    }

    function changeVoicemailPassword() {
      accountPreferencesService.getResetVoicemailPassword()
        .then(processServiceModel);
    }

    function processServiceModel(serviceModel) {

      if (!_.has(serviceModel, 'wirelessSubscription')) {
        return;
      }

      /**
       * If the current profile has only 1 wireless subscription
       * goto wireless page
       */

      if (serviceModel.wirelessSubscription.length === 0) {
        var errorKey = myr.modules.accountPreferences.VoicemailErrorCode[serviceModel.voicemailLinkError];
        var errorTitle = 'myr.modules.accountPreferences.reset.voicelmail.error.' + errorKey + '.title';
        var errorDescription = 'myr.modules.accountPreferences.reset.voicelmail.error.' + errorKey + '.description';

        var modalInstance = $modal.open({
          templateUrl: 'views/modals/genericMessageModal.html',
          windowClass: 'generic-message-modal',
          controller: ['$scope', function ($scope) {
            $scope.message = {
              title: errorTitle,
              description: errorDescription
            };
            $scope.close = function () {
              modalInstance.close();
            };
          }]
        });
      } else if (serviceModel.wirelessSubscription.length === 1) {
        if (angular.isFunction(serviceModel.wirelessSubscription[0].action)) {
          myrWirelessDashboardService.enableResetVoicemailModal();
          serviceModel.wirelessSubscription[0].action();
        }
      } else if (serviceModel.wirelessSubscription.length > 1) {
        /**
         * If the current profile has more than 1 wireless subscription
         * open ctn selection modal
         */
        commonSelectionModalService.showSelectionModal({
          title: 'myr.modules.accountPreferences.reset.voicelmail.password',
          selections: {
            title: serviceModel.selectedAccountNickname,
            options: serviceModel.wirelessSubscription
          }
        });
      }
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  angular.module('myr.modules.accountPreferences').directive('accountPreferences', accountPreferences);

  accountPreferences.$inject = ['myr.modules.accountPreferences.service', 'ute.goPaperless.service'];
  function accountPreferences(accountPreferencesService, goPaperlessService) {
    return {
      restrict: 'E',
      templateUrl: 'scripts/modules/accountPreferences/accountPreferences.html',
      replace: true,
      controller: 'myrAccountPreferences',
      controllerAs:'ap',
      bindToController: true,
      link: function(scope){
        scope.$on('$destroy', function(){
          accountPreferencesService.resetModel();
          goPaperlessService.unregisterSwitchCallback('accountPreferences');
        });
      }
    };
  }
})();

angular.module('mdo-angular-cryptography', [])
    .provider('$crypto', function CryptoKeyProvider() {
        var cryptoKey;

        this.setCryptographyKey = function(value) {
            this.cryptoKey = value;
        }

        this.$get = [function(){
            return {
                cryptoKey: this.cryptoKey,

                encrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.encrypt(message, key ).toString();
                },

                decrypt: function(message, key) {

                    if (key === undefined) {
                        key = this.cryptoKey;
                    }

                    return CryptoJS.AES.decrypt(message, key).toString(CryptoJS.enc.Utf8)
                }
            }
        }];
    });
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.authHttp').config(configure);

  configure.$inject = ['ute.rogers.interceptors.auth.serviceProvider'];

  /* @ngInject */
  function configure(authHttpResponseInterceptorProvider) {
    authHttpResponseInterceptorProvider.configure({
      httpCodes: [401, 498],
      notifyEvents: ['ute.user.unauthorized'],
    });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrChangePaymentMethodController', ChangePaymentMethodController);

  ChangePaymentMethodController.$inject = ['$scope', '$state', '$rootScope', 'ajax', 'settings', '$translate',
    'appState', 'myrAccountOverviewService', 'myrChangePaymentMethodService', '$stateParams',
    'ute.rogers.account.billing.detail.factory', '$modal', 'myrAccountListService', 'ute.dtm.service', 'myrMyServicesService',
    'myrPayNowService', 'ute.common.user.service', 'ute.common.permissions.service', 'ute.blocks.language.switcher'];

  /* @ngInject */
  function ChangePaymentMethodController($scope, $state, $rootScope, ajax, settings, $translate,
                                         appState, accountOverviewService, paymentMethodService, $stateParams,
                                         billingDetailFactory, $modal, myrAccountListService, dtmService, myrMyServicesService,
                                         myrPayNowService, userService, permissionsService, languageSwitcher) {
    var requestObj = null;
    var map = {'VISA': 'VI', 'MASTERCARD': 'MC', 'AMEX': 'AM'};
    $scope.state = $state.current.name;
    $scope.creditCardObj = {};
    $scope.isCare = $rootScope.isCare;
    $scope.isDealer = $rootScope.isDealer;

    $scope.setStaticChatButtonValues = function () {
      if (languageSwitcher.getCurrentLanguage() === 'en') {
        $scope.boldChatButtonId = 'S_BillPay_ChngMethdInv';
        $scope.boldChatButtonDiv = 'chngMethdInv-en';
        $scope.boldChatButton = 'chatButtonChangeInvoiceEn';
      }
      else {
        $scope.boldChatButtonId = 'S_BillPay_ChngMethdInv_Fr';
        $scope.boldChatButtonDiv = 'chngMethdInv-fr';
        $scope.boldChatButton = 'chatButtonChangeInvoiceFr';
      }
    };
    $scope.setStaticChatButtonValues();

    $scope.$on('languageChanged', function () {
      $scope.setStaticChatButtonValues();
    });

    $scope.lang = languageSwitcher.getCurrentLanguage();

    $scope.dtmService = dtmService;
    $scope.dtmName = 'change payment method';

    var params = $stateParams;
    $rootScope.showCreditCardForm = false;
    $rootScope.showDebitForm = false;
    function changeCardType(key) {
      return map[key];
    }

    //handle language switch
    //update the resource keys when language switches
    function setMethodNames() {
      $scope.serverMessage = null;
      $scope.paymentMethods[0].resKey = $translate.instant('invoice');
      $scope.paymentMethods[1].resKey = $translate.instant('change_method_credit');
      $scope.paymentMethods[2].resKey = $translate.instant('change_method_debit');
      $scope.chatLink = getChatLink();
    }

    function setMethod() {
      if (!requestObj) {
        return;
      }
      $scope.isChanging = true;
      ajax.setPaymentMethod(requestObj).then(
        function (response) {
          $scope.isChanging = false;
          if (response === undefined) {
            handleError(null);
          } else {
            handleSuccess();
          }
        },
        function (error) {
          $scope.isChanging = false;
          // Error handling - 555 exception
          if (error.data.status === 555) {
            // Server error that needs further processing
            // additional information for 555 error

            // error.error.errorCode        // 10k - 12.1k & 50k - 51k
            // error.error.errorMessage     // Message as delivered from server
            // error.error.message          // Message as found in resource file
            // error.error.statusCode       // error status code - 555 in this case

            $scope.errorMessage = error.error.errorCode + ' - ' + error.error.errorMessage;

          } else {
            // anything but status code 555
            $scope.errorMessage = error.data.status + ' - ' + error.data.statusText;
          }

          handleError(error);
        }
      );
    }

    function setConfirmationDialog() {
      var _options = {
        title: $translate.instant('change_method_confirm_title'),
        message: $translate.instant('change_method_confirm_details'),
        onClose: cancel,
        icon: 'success',
        buttons: [
          {label: '_cancel', type: 'secondary', action: cancel},
          {label: '_continue', type: 'primary', action: callServer}
        ]
      };
      appState.setConfirmation(_options);
    }

    function callServer() {
      //prepare the server call
      //$scope.getCableAccountDetails();
      $scope.storeScope();
      $scope.isChanging = true;
      var _detail = accountOverviewService.getSelectedAccountDetail();

      myrAccountListService.selectedAccount.accountNumber = _detail.billableAccountNumber ? _detail.billableAccountNumber : _detail.number;
      myrAccountListService.selectedAccount.subNumber = _detail.number;
      myrAccountListService.selectedAccount.accountType = _detail.type;

      // var biilAccNumber  = _details.billableAccountNumber ? _details.billableAccountNumber : _details.number;
      if ($scope.selectedMethod === 1) {
        //set credit card
        var card = $scope.creditCardObj.creditCardType.name;     //changeCardType(semafoneService.getCardScheme());
        //$scope.creditPaymentObj.creditCardNo = token;
        requestObj = {
          accountNumber: myrAccountListService.selectedAccount.accountNumber,
          accountTypeNumber: myrAccountListService.selectedAccount.accountType,
          mopType: $scope.selectedMethodObj.type,
          consolidated: _detail.isConsolidated,
          subNumber: myrAccountListService.selectedAccount.subNumber,
          'creditCardInfo.ccNumber': $scope.creditCardObj.creditCardNo, // $scope.creditPaymentObj.creditCardNo,
          'creditCardInfo.ccType': card,
          'creditCardInfo.ccExpiryMonth': $scope.creditCardObj.expireDate.month,
          'creditCardInfo.ccExpiryYear': $scope.creditCardObj.expireDate.year,
          'creditCardInfo.securityCode': $scope.creditCardObj.securityCode,
          'detail.oldMopType': _detail.paymentMethod,
          'detail.contactId': _detail.contactId
        };
        setMethod();

      } else if ($scope.selectedMethod === 2) {
        //set cheque account
        requestObj = {
          accountNumber: myrAccountListService.selectedAccount.accountNumber,
          accountTypeNumber: myrAccountListService.selectedAccount.accountType,
          mopType: $scope.selectedMethodObj.type,
          consolidated: _detail.isConsolidated,
          subNumber: myrAccountListService.selectedAccount.subNumber,
          'chequingInfo.bankNumber': $scope.chequingObj.bankCode,
          'chequingInfo.transitNumber': $scope.chequingObj.transitNo,
          'chequingInfo.accountNumber': $scope.chequingObj.accountNo,
          'chequingInfo.termsChecked': true,
          'detail.oldMopType': _detail.paymentMethod,
          'detail.contactId': _detail.contactId
        };
        setMethod();
      }
    }

    function cancel() {
    }

    function afterChangeMethod() {
      //   appState.afterPaymentRefresh = true;
      /**
       * send user to account overview based following ticket
       * NPS-1402: Incorrect Link - Back to Account Overview button
       */
      /* CHN-2780: Redirect user to respective Rep/Customer views */
      $scope.redirectToOverview();
      //appState.switchView('accountOverview');
      // $window.location.reload();
    }

    function afterErrorMethod() {
      //   appState.afterPaymentRefresh = true;
      //appState.switchView('accountOverview');
      $scope.redirectToOverview();
    }

    function afterDebErrorMethod() {
      appState.cancelConfirmation();
    }

    function handleSuccess() {
      tagChangeMethodSuccess();

      //purge cached data and get latest balence
      billingDetailFactory({
        accountNumber: myrAccountListService.selectedAccount.accountNumber,
        accountTypeNumber: myrAccountListService.selectedAccount.accountType,
        language: languageSwitcher.getCurrentLanguage(),
        applicationId: 'Rogers.com',
        refresh: false
      }).getBillingDetail(true);

      //Add due date into confirmation message
      var _message = $translate.instant('change_method_thankyou_details');
      _message = _message.replace(/\{dueDate\}/i, $scope.accountDetail.dueDate);
      if (myrAccountListService.selectedAccount.accountType === 6 && $scope.selectedMethod === 2 && !accountOverviewService.getSelectedAccountDetail().isConsolidated) {
        _message += '<br/><br/>' + $translate.instant('change_method_note');
      }
      //change_method_note

      //appState.afterPaymentRefresh = true;
      var _options = {
        title: $translate.instant('change_method_thankyou_title'),
        message: _message,
        onClose: afterChangeMethod,
        icon: 'success',
        buttons: [
          {label: 'paynow_go_to_overview', type: 'secondary', action: afterChangeMethod}
        ]
      };
      appState.setConfirmation(_options);
    }

    function handleError(errorCode) {
      $scope.recoverScope();
      var _options;

      if ($scope.selectedMethod == 2) {
        _options = {
          title: '',
          message: $translate.instant('change_method_deb_error'),
          onClose: cancel,
          iconBody: 'alert',
          buttons: [
            {label: 'paynow_tryagain_title', type: 'secondary', action: afterDebErrorMethod}
          ]
        };
      } else {
        _options = {
          title: '',
          message: $translate.instant('change_method_error'),
          onClose: cancel,
          iconBody: 'alert',
          buttons: [
            {label: 'paynow_go_to_overview', type: 'secondary', action: afterErrorMethod}
          ]
        };
      }

      dtmService.fireDtmExceptions($scope.dtmName, [$scope.errorMessage + '|' + _options.message], 'SS');
      appState.setConfirmation(_options);
    }

    function getChatLink() {
      var lang = languageSwitcher.getCurrentLanguage();
      if (!lang) {
        return settings.chatLinkModules.payment.en;
      }
      return settings.chatLinkModules.payment[lang];
    }

    $scope.$extend({
      currentMethodId: null,
      changeInvoiceMethod: false,
      showCreditCardForm: false,
      showDebitForm: false,
      serverMessage: null,
      paymentMethods: [
        {
          id: 0, //invoice
          type: 'R',
          resKey: null
        },
        {
          id: 1, //credit card
          type: 'C',
          resKey: null
        },
        {
          id: 2, //cheque account
          type: 'D',
          resKey: null
        }
      ],
      selectedMethodObj: null,
      selectedMethod: 0,
      chatLink: null,
      isPreAuthorized: paymentMethodService.isActiveAccountMethodInvoice() || false,
      //isUnavailable: paymentMethodService.isMethodUnavailable(),
      isChanging: false,
      //isAccepted: false,

      resetForm: function () {
        $scope.changeInvoiceMethod = false;

        if ($scope.form) {
          $scope.form.$setPristine();
        }

      },
      /**
       * Display the selected payment method form.
       */
      changemethod: function (method) {
        $scope.resetForm();
        if ($scope.currentMethodId !== 0 && method.id === 0) {
          $scope.changeInvoiceMethod = true;
        }
        $scope.selectedMethod = method.id;

        //set flags for the form to be shown
        if ($scope.selectedMethod === 0) {
          $scope.showCreditCardForm = false;
          $scope.showDebitForm = false;

        } else if ($scope.selectedMethod === 1) {

          $scope.showCreditCardForm = true;
          if ($scope.creditCardObj.reset) {
            $scope.creditCardObj.reset();
          }
          $scope.showDebitForm = false;
          $rootScope.showDebitForm = false;
          $rootScope.showCreditCardForm = true;

        }
        if ($scope.selectedMethod === 2) {
          $scope.showCreditCardForm = false;
          $rootScope.showCreditCardForm = false;
          $scope.showDebitForm = true;
          $rootScope.showDebitForm = true;
          $scope.chequingObj = {};
        }
      },
      selectedAccount: accountOverviewService.getSelectedAccount(),
      accountBalance: accountOverviewService.getAccountBalance(),
      accountDetail: {
        dueDate: '',
        mopType: ''
      },
      processBalance: function () {
        $scope.accountDetail.dueDate = $scope.accountBalance.nextBillDate;
        $scope.accountDetail.mopType = 'R';
        if ($scope.accountBalance.methodOfPayment && $scope.accountBalance.methodOfPayment.mopType) {
          $scope.accountDetail.mopType = $scope.accountBalance.methodOfPayment.mopType;
        }
        var _method = $scope.accountDetail.mopType;
        if (_method && (_method = _method.toLowerCase())) {
          $scope.selectedMethodObj = $($scope.paymentMethods).map(function (k, v) {
            if (v.type.toLowerCase() === _method) {
              return v;
            }
          }).get()[0];
          if ($scope.selectedMethodObj) {
            $scope.currentMethodId = $scope.selectedMethodObj.id;
            $scope.changemethod($scope.selectedMethodObj);
          }
        }
        //initialize the method names and update when switch languages.
        setMethodNames();
        $scope.resetForm();
      },
      cancel: function () {
        $scope.redirectToOverview();
      }
    });

    $scope.submit = function () {
      if ($scope.selectedMethod === 1) {
        $scope.creditCardObj.validateCard();
      }
      if ($scope.selectedMethod === 2) {
        $scope.form.$valid = true;
      }

      if (!$scope.selectedMethod || !$scope.form.$valid) {
        return false;
      } else {
        callServer();
      }
    };

    $scope.storeScope = function () {
      $scope.origObj = angular.copy($scope.creditPaymentObj);
    };

    $scope.recoverScope = function () {
      $.extend($scope.creditPaymentObj, $scope.origObj);
    };

    //check rootScope
    if (!$rootScope.ao.accountDetails) {
      //if there is a selected account, fetch it's detail and continue
      if (myrAccountListService.selectedAccount) {
        var request = {
          accountNumber: myrAccountListService.selectedAccount.accountNumber,
          accountTypeNumber: myrAccountListService.selectedAccount.accountTypeNumber,
          pinNumber: myrAccountListService.selectedAccount.pinNumber,
          phoneNumber: myrAccountListService.selectedAccount.phoneNumber,
          language: $scope.lang,
          refresh: false,
          indx: $rootScope.ao ? $rootScope.ao.accountActiveIndex : 0,
          applicationId: 'Rogers.com'
        };
        myrMyServicesService.getAccountDetails(request, function (tmp) {
            if (tmp.result !== 'success') {
              appState.switchView('accountOverview');
            }
            else {
              $scope.selectedAccount = accountOverviewService.getSelectedAccount();
              $scope.accountBalance = accountOverviewService.getAccountBalance();
              $scope.processBalance();
            }
          }
        );
      }
      //can't do anything, accounts are not loaded for some reason, fall back to account overview
      else {
        appState.switchView('accountOverview');
      }
    }
    //set the current payment method.
    //set bill due date
    tagChangePaymentMethod();
    $scope.processBalance();

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.lang = lang;
      $scope.tooltip = $translate.instant('paynow_card_tooltip');
      setMethodNames();
    }, 'changePaymentMethodControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('changePaymentMethodControllerLangSub');
    });

    function tagChangeMethodSuccess() {
      dtmService.setVar('change-payment-method-type', $scope.selectedMethodObj.resKey);
      dtmService.complete($scope.dtmName);
    }

    function tagChangePaymentMethod() {
      dtmService.start($scope.dtmName);
    }

    $scope.userType = function () {
      return userService.getUserType();
    };

    $scope.cardTime = {
      months: myrPayNowService.months,
      years: myrPayNowService.expireYears()
    };

    $scope.redirectToOverview = function () {
      if ($scope.isDealer || $scope.isCare) {
        $scope.isRepView = ($rootScope.isRepView == 'true');
        if ($scope.isRepView) {
          appState.switchView('oneViewDashboard');
          //$state.go('oneViewDashboard');
        } else {
          appState.switchView('accountOverview');
          //$state.go('accountOverview');
        }
      } else {
        appState.switchView('accountOverview');
        //$state.go('accountOverview');
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * change the payment method of selected account.
   * this has a service for the changePaymentMethodController
   */
  angular.module('totesApp').service('myrChangePaymentMethodService', changePaymentMethodService);

  changePaymentMethodService.$inject = ['$rootScope'];

  /* @ngInject */
  function changePaymentMethodService($rootScope) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      isActiveAccountMethodInvoice: isActiveAccountMethodInvoice,
      isMethodUnavailable: isMethodUnavailable
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function isActiveAccountMethodInvoice() {
      if (!$rootScope.ao.accountDetails) {
        return null;
      } else {
        var isInvoice = true;
        if ($rootScope.ao.accountDetails.accountBalance && $rootScope.ao.accountDetails.accountBalance.methodOfPayment && $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType) {
          isInvoice = $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType === 'R';
        }
        return isInvoice;
      }
    }

    function isMethodUnavailable() {
      if (!$rootScope.ao.accountDetails) {
        return null;
      } else {
        return !($rootScope.ao.accountDetails.accountBalance.methodOfPayment && $rootScope.ao.accountDetails.accountBalance.methodOfPayment.mopType);
      }
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.commonUtilities').factory('commonUtilityService', commonUtilityServices);

  commonUtilityServices.$inject = ['$log'];

  /* @ngInject */
  function commonUtilityServices($log) {

    // Public API
    var service = {
      dateTime: {
        parse: parse,
        getDateFromStringYYYYMMDD: getDateFromStringYYYYMMDD
      }, browser: {
        isSafari: isSafari,
        isSafariOnIos: isSafariOnIos
      }
    };

    return service;

    ///////////////////////////////////////////////////////////////

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString should be in YYYY-MM-DD format
     */
    function getDateFromStringYYYYMMDD(dateTimeInString) {
      try {
        // Basic validation
        var dateTimeSplit = dateTimeInString.split('-');

        if (dateTimeSplit.length !== 3) {
          return undefined;
        }
        var yearInt = parseInt(dateTimeSplit[0]);
        var monthInt = parseInt(dateTimeSplit[1]);
        var dayInt = parseInt(dateTimeSplit[2]);

        if (isNaN(yearInt) || isNaN(yearInt) || isNaN(yearInt)) {
          return undefined;
        }

        // Fix the month before set Date
        monthInt = monthInt - 1;

        var returnDateTime = new Date(yearInt, monthInt, dayInt);
        return returnDateTime;

      } catch (e) {
        $log.error('Exception catch during getDateFromStringYYYYMMDD:', e.message);
      }
      return undefined;
    }

    /**
     * This function is use to convert a string in 'YYYY-MM-DD' format into a datetime object
     * @param dateTimeInString '2016-02-04', 'Feb 04, 2016'
     * @param expectedFormat 'YYYY-MM-DD', 'MMM DD, YYYY'
     */
    function parse(dateTimeInString, expectedFormat) {
      try {

        if (/yyyy-mm-dd/i.test(expectedFormat)) {
          return getDateFromStringYYYYMMDD(dateTimeInString);
        }

      } catch (e) {
        $log.error('Exception catch during parse:', e.message);
      }
      return new Date();
    }

    /**
     * This function is use to check if the current browser is safari running on IOS
     */
    function isSafariOnIos() {
      try {
        return (
            /ipad|iphone/i.test(window.navigator.platform) && isSafari()
        );
      } catch (e) {
        $log.error('Exception catch during isSafariOnIos:', e.message);
      }
    }

    /**
     * This function is use to check if the current browser is Safari
     */
    function isSafari() {
      try {
        return (
            /safari/i.test(window.navigator.appVersion) && !(/chrome|crios/i.test(window.navigator.appVersion))
        );
      } catch (e) {
        $log.error('Exception catch during isSafari:', e.message);
      }
    }

  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp')
  .controller('MyrCreditAdjustmentController', CreditAdjustmentController)
  .directive('decimalPrice', DecimalPrice);

  CreditAdjustmentController.$inject = ['$scope',
    '$rootScope',
    '$translate',
    '$modal',
    'ute.rogers.account.overview.factory',
    'ute.blocks.language.switcher',
    'myrWirelessDashboardService',
    'myrCreditAdjustmentService',
    'ute.rogers.account.billing.detail.factory',
    'myrAccountBalanceDataFactory',
    '$filter',
    'myrMyServicesService'];

  /* @ngInject */
  function CreditAdjustmentController(
    $scope,
    $rootScope,
    $translate,
    $modal,
    accountOverviewFactory,
    languageSwitcher,
    wirelessDashboardService,
    creditAdjustmentService,
    billingDetails,
    myrAccountBalanceDataFactory,
    $filter,
    myrMyServicesService
  ) {

    var ca = this;
    ca.abdf = myrAccountBalanceDataFactory;
    ca.backendService = '';
    var accountOverviewService = accountOverviewFactory();
    var solarisServicesList = {
      rhp: 'RHP Phone Line',
      iptv: 'IPTV',
      hsi: 'HSI',
      homeMonitoring: 'Rogers Smart Home Monitoring'
    };
    var adjustmentCodes = ['1GDWL','2GDWL','GDWIL2','GDWILL','GDWL01','GDWL02','GDWL1','GDWL11','GDWL2','GDWL21','GDWL22','GDWLR1',
      'GDWLR2','RGWL01','RGWL02','GDWL3','GDWLHW','GDWLNT','LPGDWL','NGDWI3','USAGD3'];
    var serviceTypeMappings = {
      service_wireless: 'Wireless',
      service_wireless_prepaid: 'PAYASYOUGOTM',
      service_internet: 'Internet',
      service_tv: 'TV',
      service_phone: 'HomePhone',
      service_monitoring: 'Monitoring',
      shm_service_agreement: 'ServiceAgreement',
      service_shm: 'shm',
      myaccoverview_home_monotoring: 'HomeMonitoring'
    };

    init();
    getAccountSummaryAndBillingDetails();
    var tooltips = {
      adjustment: 'adjustment',
      icm: 'icm',
      interactionId: 'interactionId'
    };
    var initialState = {
      policyIssue: {
        known: {
          amount: '',
          approver: null,
          notes: ''
        },
        auto: {
          notes: ''
        }
      },
      serviceNetworkIssue: {
        known: {
          daysAffected: null,
          amount: null,
          approver: null,
          notes: null
        },
        auto: {
          notes: null
        },
        unknown: {
          interactionId: null,
          amount: null,
          approver: null,
          daysAffected: null,
          notes: null
        }
      },
      systemError: {
        known: {
          amount: null,
          approver: null,
          notes: null
        },
        auto: {
          notes: null
        },
        unknown: {
          icmCaseId: null,
          amount: null,
          approver: null,
          notes: null
        }
      },
      goodWillCredit: {
        amount: null,
        approver: null,
        notes: null
      },
      douErrorOrPromise: {
        interactionId: null,
        empId: null,
        amount: null,
        approver: null,
        notes: null
      }
    };

    function init() {
      $scope.lang = ca.lang = languageSwitcher.getCurrentLanguage();
      $scope.subMenuMyServicesList = [];
      $scope.isCare = $rootScope.isCare;
      $scope.isDealer = $rootScope.isDealer;
      $scope.isConsumer = $rootScope.isConsumer;
      $scope.currentAccount = $rootScope.ao.accountActive;

      _clearData();

      if ($scope.currentAccount != null) {
        if ($scope.currentAccount.accountNumber != null) {
          $scope.isWirelessAccount = $scope.currentAccount.accountNumber.length === 9;
        }
      }
    }

    function _clearData() {
      $scope.selectedServiceIndex = null;
      $scope.selectedService = null;
      $scope.packageDetails = null;
      $scope.adjustmentHistory = null;
      $scope.isAdjustmentHistoryShown = false;
      $scope.recentAdjustments = 0;
      $scope.MSF = 0;
      $scope.adjustmentContent = null;
      $scope.selectedAdjustmentType = { code: '' };
      $scope.selectedAdjustmentContent = null;
      $scope.isCancelledServiceSelected = false;
      $scope.cancelledServiceDetail = '';
      $scope.selectedCancelledService = '';
      $scope.goodWillCreditRemaining = 0;
      $scope.selectedReason = null;
      $scope.interactionResponse = null;
      $scope.isAdjustmentToolTipVisible = false;
      $scope.isICMToolTipVisible = false;
      $scope.isInteractionIdToolTipVisible = false;
      $scope.isApproverMandatory = false;
      $scope.accordionsGroup = {
        isPrimaryAccordionOpen: true,
        isSecondaryAccordionOpen: false
      };
      $scope.loadingPlanDetails = false;
      $scope.isLoadingInteraction = false;
      $scope.adjustmentTypesWithFields = _.cloneDeep(initialState);
    };

    $scope.clearData = _clearData;

    var myServiceListWatcher = $rootScope.$watch('myServicesList', function () {
      var servicesList = getSubMenuServices();
      if(servicesList && servicesList.length > 0) {
        $scope.subMenuMyServicesList = $scope.subMenuMyServicesList.concat(servicesList);
      }
    });

    function getSubMenuServices () {
      if ($rootScope.myServicesList) {
        return _.filter($rootScope.myServicesList, function (item) {
          return (item.subType !== 'Rogers Bank');
        });
      }
    }

    function adjustGoodWillCreditByAdjustmentHistory () {
      $scope.recentAdjustments = 0;
      _.forEach($scope.adjustmentHistory, function(adjustmentHistory) {
        if(adjustmentCodes.indexOf(adjustmentHistory.activityReasonCode) > -1) {
          $scope.recentAdjustments = $scope.recentAdjustments + adjustmentHistory.adjustmentAmt;
        }
      });
      $scope.goodWillCreditRemaining = $scope.goodWillCreditRemaining - $scope.recentAdjustments;
      //$scope.goodWillCreditRemaining = $scope.goodWillCreditRemaining < 0 ? 0 : $scope.goodWillCreditRemaining;
	  $scope.goodWillCreditRemaining = $scope.goodWillCreditRemaining < 0 ? 0.00 : $scope.goodWillCreditRemaining;
    }

    function getAccountSummaryAndBillingDetails() {
      accountOverviewService.getSelectedAccount()
        .then(function(selectedAccount) {
          fetchAccountSummary(selectedAccount);
          $scope.selectedAccount = selectedAccount;
          var request = {
            accountNumber: selectedAccount.accountNumber,
            accountTypeNumber: selectedAccount.accountTypeNumber,
            pinNumber: selectedAccount.pinNumber,
            phoneNumber: selectedAccount.phoneNumber,
            language: ca.lang,
            refresh: false,
            applicationId: 'Rogers.com'
          };
          var balanceDetailsResponse = function (_tmp) {
            if (_tmp.result === 'success') {
              $scope.accountBalance = _tmp.data;
            }
          };
          ca.abdf.getBalanceDetails(request, balanceDetailsResponse);
        });

    }

    function fetchAccountSummary(selectedAccount) {
      accountOverviewService.getSelectedAccountDetails().then(function (response) {
        $scope.accountSummary = response;
        //if(selectedAccount.accountStatus === 'Cancelled') {
          $scope.subMenuMyServicesList = $scope.subMenuMyServicesList.concat(myrMyServicesService.getCancelledSubscriptions(response.subscriberList, false).myServices);
          //console.log($scope.subMenuMyServicesList);
        //}
      }).catch(function (error) {
        console.log('error getting account summary');
      });
    }

    $scope.getServicesList = function(list){
      if($scope.accountSummary.subscriberList > 0) {
        return $scope.accountSummary.subscriberList;
      } else if($rootScope.myServicesList.length > 0) {
        return $rootScope.myServicesList;
      }
    }

    function htmlDecode(input) {
      var e = document.createElement('div');
      e.innerHTML = input;
      return e.childNodes[0].nodeValue;
    }

    function fetchAdjustmentAndPlanDetails(serviceDetails) {

      if(!serviceDetails) {
        return;
      }

      var ctnNumber = serviceDetails.serviceDetail;
      var accountNumber = serviceDetails.accountNumber;

      var request_planDetails = {
        ctn: ctnNumber,
        ban: accountNumber,
        language: ca.lang,
        applicationId: 'Rogers.com',
        refresh: false
      };

      adjustmentContent();
      getPlanDetails(request_planDetails, serviceDetails);

    }

    function fetchHistoryAndUpdateGoodwillAmount(serviceDetails) {
      if (serviceDetails.serviceType === 'service_wireless' || serviceDetails.serviceType === 'WIRELESS') {
        var request_adjustmentHistory = {
          account: serviceDetails.accountNumber,
          ctn: serviceDetails.serviceDetail,
          type: 'WIRELESS'
        };
        getAdjustmentHistoryDetails(request_adjustmentHistory);
      } else {
        $scope.adjustmentHistory = null;
      }
    }

    function getAdjustmentHistoryDetails(request) {
      creditAdjustmentService.getAdjustmentHistory(request)
        .then(function(response) {
          if (response && response.data) {
            $scope.adjustmentHistory = response.data.content.creditAdjustmentHistory;
          }
          adjustGoodWillCreditByAdjustmentHistory();
        })
        .catch(function(error) {
          console.log('Error getAdjustmentHistoryDetails', error);
        });
    }

    function getPlanDetails(request, serviceDetails) {
      $scope.loadingPlanDetails = true;
      if($scope.selectedService.serviceType === 'service_wireless') {
        wirelessDashboardService.getWirelessPostpaid(request)
        .then(function (response) {
          if (response.result === 'success') {
            $scope.packageDetails = _.cloneDeep(response.data);
            var gwC = 0.5 * $scope.packageDetails.postPaidPhoneDetails.planMSF;
            $scope.MSF = $scope.packageDetails.postPaidPhoneDetails.planMSF;
            $scope.goodWillCreditRemaining = gwC > 25 ? 25 : gwC;
            $scope.maximumAllowed = gwC > 25 ? 25 : gwC;
            fetchHistoryAndUpdateGoodwillAmount(serviceDetails);
          }
        })
        .catch(function (error) {
          $scope.packageDetails = null;
          console.log('Error getPlanDetails', error);
        })
        .finally(function() {
          $scope.loadingPlanDetails = false;
        });
      }
    }

    function getParameter(key, value) {
      var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
      var results = regex.exec(value);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    function getAdjustmentCode(isWireless, isLineBreakAppended) {
      var adjustmentCodeValue = '';
      if($scope.selectedReason && $scope.selectedReason !== "unknown"  ) {
        adjustmentCodeValue = $scope.selectedReason.adjustmentCode;
      } else {
        // RHP should function the same as wireless. the serviceType mapping can be found in myServicesService.js, subscription.subType === 'RHPc'
        if(isWireless || $scope.selectedService.serviceType === "service_phone") {
          if($scope.selectedAdjustmentContent.unknownSubReason[0].backendSystem === 'v21') {
            adjustmentCodeValue = $scope.selectedAdjustmentContent.unknownSubReason[0].adjustmentCode;
          } else if($scope.selectedAdjustmentContent.unknownSubReason[1].backendSystem === 'v21') {
            adjustmentCodeValue = $scope.selectedAdjustmentContent.unknownSubReason[1].adjustmentCode;
          }
        } else {
          if($scope.selectedAdjustmentContent.unknownSubReason[0].backendSystem === 'sgi') {
            adjustmentCodeValue = $scope.selectedAdjustmentContent.unknownSubReason[0].adjustmentCode;
          } else if($scope.selectedAdjustmentContent.unknownSubReason[1].backendSystem === 'sgi') {
            adjustmentCodeValue = $scope.selectedAdjustmentContent.unknownSubReason[1].adjustmentCode;
          }
        }
      }
      //Added this break tag in CMS
      /*if(isLineBreakAppended) {
        if($scope.lang === 'en') {
          adjustmentCodeValue = adjustmentCodeValue.replace(/TM:/g, '<br/>TM:');
        } else if ($scope.lang === 'fr') {
          adjustmentCodeValue = adjustmentCodeValue.replace(/CE:/g, '<br/>CE:');
        }
      }*/
      return adjustmentCodeValue;
    }

    function openInteractionModal(userData, isWireless) {
      var todayDate = new Date();
      $rootScope.modal.close();
      var popupInteraction = $modal.open({
        templateUrl: 'scripts/modules/creditAdjustment/interactionModal.html',
        controller: ['data', '$scope', function(data, $scope) {
          $scope.data = data;
          $scope.backendService = ca.backendService;
          $scope.close = function () {
            popupInteraction.close();
          };
        }],
        size: 'interactionModal-dialog',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {
          data: function () {
            return {
              date: (todayDate.getMonth() + 1) + '/' + todayDate.getDate() + '/' + todayDate.getFullYear(),
              selectedAdjustmentType: $scope.selectedAdjustmentContent.name,
              adjustmentCode: getAdjustmentCode(isWireless, true),
              amount: 'amount' in userData ? userData.amount : '',
              lang: $scope.lang,
            };
          }
        }
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    }

    function makeInteractionRequest (data, caseOfAdjustment, isWireless) {
      var connId = '';
      if($rootScope.userInfo) {
        if ($rootScope.userInfo.cfaInfo) {
          connId = $rootScope.userInfo.cfaInfo.connid;
        } else if ($rootScope.userInfo.careInfo) {
          connId = $rootScope.userInfo.careInfo.connid;
        } else if ($rootScope.userInfo.connid){
          connId = $rootScope.userInfo.connid;
        } else {
          if($scope.isDealer) {
            connId = getParameter('connid', $rootScope.userInfo.cfaInfo.playSessionId);
          } else if($scope.isCare) {
            connId = getParameter('connid', $rootScope.userInfo.careInfo.playSessionId);
          }
        }
      }

      var request = {
        adjustmentType: $scope.selectedAdjustmentContent.name,
        adjustmentCode: getAdjustmentCode(isWireless, false),
        notes: 'notes' in data ? data.notes : '',
        amt: 'amount' in data ? data.amount : '',
        approver: 'approver' in data ? data.approver : '',
        interactionId: 'interactionId' in data ? data.interactionId : '',
        errorEmployeeId: 'empId' in data ? data.empId : '',
        connectionId: connId,
        icmCaseId: 'icmCaseId' in data ? data.icmCaseId : '',
        daysServiceAffected: 'daysAffected' in data ? data.daysAffected : '',
        ecId: $scope.accountSummary.contactInfo.ecId,
        dcrName: getDcrName(isWireless, false),
        gwCreditRemaining: isWireless && ($scope.selectedAdjustmentContent.code === "goodwillcredit") ? $scope.goodWillCreditRemaining : null
      };
      return request;
    }
	function getDcrName(isWireless) {
      if($scope.selectedReason && $scope.selectedReason !=="unknown") {
        return $scope.selectedReason.dcrName;
      } else {
        return _.find($scope.selectedAdjustmentContent.unknownSubReason, {backendSystem: (isWireless || $scope.selectedService.serviceType === "service_phone" ) ? 'v21': 'sgi'}).dcrName;
      }
    }

    function adjustmentContent() {
      creditAdjustmentService.getAdjustmentContent(ca.lang)
        .then(function (response) {
          if (response && response.data) {
            for(var i = 0; i < response.data.content.length; i++) {
              response.data.content[i].name = htmlDecode(response.data.content[i].name);
            }
            $scope.adjustmentContent = response.data.content;
          }
        })
        .catch(function (error) {
          $scope.adjustmentContent = null;
          console.log('Error adjustmentTypeContent', error);
        });
    }

    $scope.checkServiceVisibility = function(serviceList, service) {

      if(!serviceList.length) {
        return false;
      }

      if (service.status === 'Reserved') {
        return false;
      }

      if(
        service.subType === solarisServicesList.iptv
        || service.subType === solarisServicesList.hsi
        || service.subType === solarisServicesList.rhp
        || service.subType === solarisServicesList.homeMonitoring
      ) {
         return false;
      }

      if((!service.subscriptionBadgeModule && !service.hide)
        || (service.subscriptionBadgeModule && isDealer)){
        return true;
      }

      return true;
    };

    function populateCancelledServiceMessage(selectedServiceIndex) {
      $scope.selectedCancelledService = $scope.subMenuMyServicesList[selectedServiceIndex].serviceName;
      //$scope.cancelledServiceDetail = '';
      if($scope.selectedCancelledService === 'wireless') {
        $scope.selectedCancelledService = $translate.instant('creditadjustment_service_wireless');
        $scope.selectedCancelledService = ($scope.lang === 'en') ? ($scope.selectedCancelledService + ' service:') : ('service ' + $scope.selectedCancelledService + ':');
        $scope.cancelledServiceDetail = $scope.subMenuMyServicesList[selectedServiceIndex].serviceDetail;
      }
      else {
        if($scope.selectedCancelledService === 'tvdashboard') {
          $scope.selectedCancelledService = $translate.instant('creditadjustment_service_tv');
        } else if($scope.selectedCancelledService === 'internetdash') {
          $scope.selectedCancelledService = $translate.instant('creditadjustment_service_internet');
        } else if($scope.selectedCancelledService === 'homephone') {
          $scope.selectedCancelledService = $translate.instant('creditadjustment_service_phone');
        }
        $scope.cancelledServiceDetail = '';
        $scope.selectedCancelledService = ($scope.lang === 'en') ? ($scope.selectedCancelledService + ' service') : ('service ' + $scope.selectedCancelledService);
      }
    }

    $scope.fetchPlanDetails = function (selectedServiceIndex) {
		if($scope.subMenuMyServicesList[selectedServiceIndex].serviceType === "service_tv" || $scope.subMenuMyServicesList[selectedServiceIndex].serviceType === "service_internet")
        ca.backendService = "sgi";
      else if($scope.subMenuMyServicesList[selectedServiceIndex].serviceType === "service_wireless" || $scope.subMenuMyServicesList[selectedServiceIndex].serviceType === "service_phone")
        ca.backendService = "v21";
      if($scope.subMenuMyServicesList[selectedServiceIndex].status === "Cancelled") {
        $scope.isCancelledServiceSelected = true;
        populateCancelledServiceMessage(selectedServiceIndex);
    } else {
      $scope.isCancelledServiceSelected = false;
    }
      $scope.selectedAdjustmentType = { code: '' };
      $scope.selectedService = null;
      $scope.accordionsGroup = {
        isPrimaryAccordionOpen: true,
        isSecondaryAccordionOpen: false
      };
      $scope.selectedAdjustmentContent = null;
      $scope.isAdjustmentHistoryShown = false;
      $scope.adjustmentHistory = null;
      $scope.selectedReason = null;
      $scope.isApproverMandatory = false;

      $scope.adjustmentTypesWithFields = _.cloneDeep(initialState);
      var service = $scope.subMenuMyServicesList[selectedServiceIndex];
      $scope.selectedService = service;
      fetchAdjustmentAndPlanDetails(service);
    };

    $scope.onAdjustmentTypeSelected = function (selectedAdjustmentType) {
      $scope.selectedReason = null;
      $scope.selectedAdjustmentContent = null;
      $scope.isApproverMandatory = false;
      $scope.accordionsGroup = {
        isPrimaryAccordionOpen: true,
        isSecondaryAccordionOpen: false
      };
      if(selectedAdjustmentType) {
        $scope.selectedAdjustmentContent = _.find($scope.adjustmentContent, function (content) {
          return content.name == selectedAdjustmentType.name;
        });
      }
    };

    $scope.$watch('accordionsGroup.isSecondaryAccordionOpen', function(isOpen){
      if (isOpen) {
        $scope.isApproverMandatory = false;
      }
    });

    $scope.$watch('accordionsGroup.isPrimaryAccordionOpen', function(isOpen){
      if (isOpen) {
        $scope.isApproverMandatory = false;
      }
    });

    $scope.closeCreditAdjustmentModal = function () {
      $rootScope.modal.close();
    };

    $scope.filterNumbers = function (isAmountField, inputValue) {
      if (isAmountField) {
        $scope.isApproverMandatory = false;
      }
      var parsedNumber = inputValue.replace(/\s/g, '');
      parsedNumber = parsedNumber.replace(/[^0-9|^.]/gi, '');
      parsedNumber = parsedNumber.replace(/\^/g, '');
      parsedNumber = parsedNumber.replace(/\|/g, '');
      return parsedNumber;
    };

    //OVE-707: Filter decimal numbers
    $scope.filterDecimalNumbers = function (isAmountField, inputValue) {
      if (isAmountField) {
        $scope.isApproverMandatory = false;
      }
      var parsedNumber = inputValue.replace(/\s/g, '');
      parsedNumber = parsedNumber.replace(/(^0+|[^0-9])/gi, '');
      parsedNumber = parsedNumber.replace(/\^/g, '');
      parsedNumber = parsedNumber.replace(/\|/g, '');
      return parsedNumber;
    };

    $scope.toggleAdjustmentHistory = function () {
      $scope.isAdjustmentHistoryShown = !$scope.isAdjustmentHistoryShown;
    };

    $scope.fixDate = function (date) {
      return new Date(date);
    };

    $scope.toggleTooltip = function (type, value) {
      if (type === tooltips.adjustment) {
        $scope.isAdjustmentToolTipVisible = value;
      } else if (type === tooltips.icm){
        $scope.isICMToolTipVisible = value;
      } else if (type === tooltips.interactionId){
        $scope.isInteractionIdToolTipVisible = value;
      }
    };

    $scope.updateRequiredStatus = function (val) {
      if (val) {
        $scope.isApproverMandatory = false;
      }
    };

    $scope.updateAmount = function (src) {
      var val = $filter('number')(src, 2);
      if ($scope.selectedService.serviceType === 'service_wireless') {
        return val;
      } else {
        return null;
      }
    };

    $scope.selectReason = function ($event, selectedReason) {
      $scope.selectedReason = selectedReason;
      $scope.isApproverMandatory = false;
      $scope.adjustmentTypesWithFields = _.cloneDeep(initialState);
      $('li').removeClass('selected-known-type');
      if ($event.target.tagName === 'LI') {
        $($event.target).addClass('selected-known-type');
      } else {
        $($event.target).parents('li').addClass('selected-known-type');
      }
      window.setTimeout(function() {
        document.getElementById('subsection-accordion').scrollIntoView({behavior: 'smooth'});
      }, 500);
    };

    $scope.createInteraction = function (adjustmentType, caseOfAdjustment, interactionForm) {
      if(caseOfAdjustment === "unknown")
      {
        $scope.selectedReason = "unknown";
      }
      $scope.onAdjustmentAmountChange(adjustmentType, caseOfAdjustment);

      if($scope.isApproverMandatory || !interactionForm.$valid) {
        return;
      }

      var isWireless = (
        $scope.selectedService.serviceType === "service_wireless"
        || $scope.selectedService.serviceType === 'WIRELESS'
      ) ? true : false;

      var fetchObject = $scope.adjustmentTypesWithFields[adjustmentType];
      var fetchData = caseOfAdjustment ? fetchObject[caseOfAdjustment] : fetchObject;
      var request_applyAdjustment = makeInteractionRequest(fetchData, caseOfAdjustment, isWireless);

	  if ($scope.selectedReason && $scope.selectedReason !=="unknown" ) {
        request_applyAdjustment.issueTrackingNumber = $scope.selectedReason.ptNo;
        request_applyAdjustment.dcrName = $scope.selectedReason.dcrName;
      }
	  $scope.isLoadingInteraction = true;

      var ctNumber = isWireless ? $scope.selectedService.serviceDetail : '';
      var serviceTypeValue = serviceTypeMappings[$scope.selectedService.serviceType];
      var url = '?serviceType=' + (serviceTypeValue ? serviceTypeValue : '') + '&ctn=' + ctNumber;
      creditAdjustmentService.applyAdjustment(url, $scope.selectedAccount.accountNumber, request_applyAdjustment)
        .then(function (response) {
          $scope.interactionResponse = response;
          openInteractionModal(fetchData, isWireless);
        })
        .catch(function (error) {
          console.log('Error applyAdjustment', error);
        })
        .finally(function () {
          $scope.isLoadingInteraction = false;
        });
    };

    $scope.onAdjustmentAmountChange = function(adjustmentType, caseOfAdjustment){
      $scope.isApproverMandatory = false;
      var isWireless = (
        $scope.selectedService.serviceType === "service_wireless"
        || $scope.selectedService.serviceType === 'WIRELESS'
      ) ? true : false;
      var fetchObject = $scope.adjustmentTypesWithFields[adjustmentType];
      var fetchData = caseOfAdjustment ? fetchObject[caseOfAdjustment] : fetchObject;
      if (fetchData.approver) {
        return;
      }
      if(adjustmentType === 'goodWillCredit' && $scope.goodWillCreditRemaining > -1) {
        if(isWireless)
        $scope.isApproverMandatory = fetchData.amount > $scope.goodWillCreditRemaining;
        else
        $scope.isApproverMandatory = fetchData.amount > 100;
      } 
      else {
        $scope.isApproverMandatory = fetchData.amount > 100;
      }
    };

    $scope.$on('$destroy', function () {
      myServiceListWatcher();
    });
  }

  function DecimalPrice () {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            element.on('input', function (e) {
                var maxDecimal = Number(element.attr('decimal-price'));
                var sal = element.val();
                var parts;
                if (sal.indexOf(".") !== -1) {
                    parts = sal.split(".");
                    if (parts[1].length > maxDecimal) {
                        element.val(sal.substr(0, sal.length - 1));
                    }
                }
            });
            scope.$on('$destroy', function () {
                element.off('input');
            });
        }
  }
}
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').factory('myrCreditAdjustmentService', creditAdjustmentService);

  creditAdjustmentService.$inject = ['ajax', '$http', '$q'];

  /* @ngInject */
  function creditAdjustmentService(ajax, $http, $q) {
    
    var service = {
      getAdjustmentHistory: getAdjustmentHistory,
      getAdjustmentContent: getAdjustmentContent,
      applyAdjustment: applyAdjustment
    };

    function getAdjustmentHistory (data) {
      var deffered = $q.defer();
      $http.get('api/v1/account/'+ data.account +'/adjustments?serviceType=WIRELESS&ctn='+ data.ctn, { cache: false })
      //$http.get('resource/adjustmentHistory.json', { cache: false }) // TODO: Remove stubs
        .then(function (response) {
          deffered.resolve(response);
        })
        .catch(function (error) {
          deffered.reject(error);
        });
      return deffered.promise;
    }

    function getAdjustmentContent (lang) {
      var deffered = $q.defer();
      $http.get('api/v1/reference-data/adjustment-types?language=' + lang, { cache: false })
      // $http.get('resource/creditAdjustment.json', { cache: false })
        .then(function (response) {
          deffered.resolve(response);
        })
        .catch(function (error) {
          deffered.reject(error);
        });
      return deffered.promise;
    }

    function applyAdjustment (url, accountNumber, postData) {
      var deffered = $q.defer();
      // $http.get('resource/applyAdjustment.json', { cache: false })
      ajax.applyAdjustment(url, accountNumber, postData)
        .then(function (response) {
          deffered.resolve(response);
        })
        .catch(function (error) {
          deffered.reject(error);
        });
      return deffered.promise;
    }

    return service;
  }
})();

(function(){
  'use strict';
  angular.module('totesApp').controller('uteOneviewEnvPageCtrl' , uteOneviewEnvPageCtrl);
  uteOneviewEnvPageCtrl.$inject = ['$location','$rootScope','$settings','ute.common.user.service'];
  function uteOneviewEnvPageCtrl($location,$rootScope,$settings,userService) {
    var cookies = $browser.cookies();
    var vm = this;

    $rootScope.$broadcast('timer-start');
    $rootScope.$on('timer-stopped', function (event, data){
      console.log("Session Expired");
    });

    vm.postData = {
      data : decodeURIComponent($location.search().data),
      content : decodeURIComponent($location.search().content),
      sig : decodeURIComponent($location.search().sig),
      sourceChannel : $location.search().sourceChannel
    };
    uteOneviewEnvPageCtrl.getQueryStrings = function () {
    var userType = $location.search().sourceChannel;
    var keyValues = '';
    if (userType === settings.userType.dealer || userType === settings.userType.care) {
        userService.signed({
                        userName: '',
                        userEmail: '',
                        userType: userType
        });

        if (userType === settings.userType.dealer) {
          $rootScope.isDealer = true;
          $rootScope.isConsumer = false;
        } else if (userType === settings.userType.care) {
          console.log('setting userType in rootscope-care');
          $rootScope.isCare = true;
          $rootScope.isConsumer = false;
        }
        keyValues = [userType];
        }
      return keyValues;
     };
    vm.envs = [{env : "QA01" , host : "https://www.qa01.rogers.com/web/totes/api/v1/oneviewSSO"}, {env : "QA02" , host : "https://www.qa02.rogers.com/web/totes/v1/oneviewSSO"}, {env : "QA03" , host : "https://www.qa03.rogers.com/web/totes/v1/oneviewSSO"}, {env : "QA04" , host : "https://www.qa04.rogers.com/web/totes/v1/oneviewSSO"} , {env : "QA05" , host : "https://www.qa05.rogers.com/web/totes/v1/oneviewSSO"},{env : "DEV10" , host : "https://www.dev10.rogers.com/web/totes/v1/oneviewSSO"}, {env : "Dev" , host : "https://localhost.rogers.com:3000/web/totes/api/v1/oneviewSSO"}];
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').config(configureDeeplink);

  configureDeeplink.$inject = ['ute.rogers.deeplink.serviceProvider'];

  /* @ngInject */
  function configureDeeplink(deeplinkProvider) {
    deeplinkProvider.configure({signinState: 'signin'});
  }
})();
/**
 * Created by vikash on 05/07/16.
 */
/* jshint -W040 */
(function (_) {
  'use strict';

  /**
   * @name totesApp: factory deeplink.productChecker
   * @description
   * # deeplink.productChecker
   */
  angular.module('totesApp').factory('deeplinkProductChecker', DeeplinkProductChecker);

  DeeplinkProductChecker.$inject = ['$rootScope',
    '$q',
    'ute.common.permissions.service',
    'ute.rogers.account.overview.factory',
    'myrAccountListService',
    'ute.common.user.service',
    'appState',
    '$modal',
    '$state',
    'deeplink'
  ];

  function DeeplinkProductChecker($rootScope,
                                  $q,
                                  permissionService,
                                  accountOverviewFactory,
                                  myrAccountListService,
                                  userService,
                                  appState,
                                  $modal,
                                  $state,
                                  deeplink) {

    var isDeeplinkFinished = false;
    var storageService = null;

    return {
      hasProduct: hasProduct
    };

    function hasProduct(accountType) {
      if (!userService.isSigned()) {
        return $q.when(true);
      } else {
        storageService = userService.getPersistentService();
        var d = $q.defer();
        checkProduct(accountType)
          .then(function () {
            d.resolve(true);
          })
          .catch(function (error) {
            if (error && error.productNotFound === true) {
              if (accountType === 1) {
                appState.noProductButton = 'wireless';
              } else if (accountType === 6) {
                appState.noProductButton = 'internetdash';
              }

              if ($state.current.name === 'accountOverview') {
                $rootScope.modal = $modal.open({
                  templateUrl: 'views/modals/noproductmodal.html',
                  controller: 'MyrAccountListLinkModalController',
                  controllerAs: 'alm',
                  backdrop: 'static',
                  keyboard: false,
                  backdropClass: 'bkg-modal'
                });
              } else {
                appState.showNoProductPopup = true;
              }
            }
            appState.switchView('accountOverview');
          })
          .finally(function () {
            myrAccountListService.setAccountPicked(true);
          });
        return d.promise;
      }
    }

    function checkProduct(accountType) {
      return accountOverviewFactory().getAccountOverview().then(function (accountOverview) {
        var selectedAccount = accountOverview.getSelectedAccount();
        if (selectedAccount) {
          return checkForRequestedProduct(accountType, selectedAccount, accountOverview);
        } else {
          console.log('unable to determine selected account');
          return $q.reject({});
        }
      });
    }

    function checkForRequestedProduct(accountType, selectedAccount, accountOverview) {
      var payload = {
        accountIndex: 0,
        accountType: accountType,
        selectedAccount: selectedAccount,
        accountOverview: accountOverview
      };

      return getActiveProduct(selectedAccount, payload).then(activeProductFound).catch(activeProductNotFound);
    }

    function getActiveProduct(account, payload) {
      if (account.accountTypeNumber === 9 || (account.accountTypeNumber === 6 && payload.accountType === 1)) {
        return $q.reject(payload);
      }
      return account.getAccountOverviewSummary().then(function (accountSummary) {
        if (accountSummary && accountSummary.subList && accountSummary.subList.length > 0) {
          return getProduct(payload, accountSummary.rawData).then(function (product) {
            if (product.subStatus === 'Suspended' || account.accountStatus === 'Suspended' || account.accountStatus === 'Cancelled') {
              // if suspended product or account is suspended / cancelled save the account / product for later
              // continue searching if no active product / account found use what we got here
              if (angular.isUndefinedOrNull(payload.accountSummary)) {
                payload.accountSummary = accountSummary.rawData;
                payload.product = product;
              }
              return $q.reject(payload);
            } else {
              payload.accountSummary = accountSummary.rawData;
              payload.product = product;
              return $q.when(payload);
            }
          });
        } else {
          return $q.reject(payload);
        }
      }).catch(function () {
        return $q.reject(payload);
      });
    }

    function activeProductFound(payload) {
      selectAccount(payload);
      if (payload.accountType === 1) {
        storageService.put('phoneNumber', payload.product.subNumber);
        return checkIfShareEverythingEnabled(payload).then(function (isShareEverythingEnabled) {
          if (isShareEverythingEnabled === true) {
            appState.switchView('shareEverything');
            return $q.defer().promise;
          } else {
            return $q.when(); //continue to wireless dashboard
          }
        });
      } else if (payload.accountType === 6) {
        storageService.put('internetAccountNumber', payload.product.subAccountId);
        return $q.when(); //continue to internet dashboard
      }
    }

    function activeProductNotFound(payload) {
      if (payload.accountOverview.accountList && payload.accountIndex < payload.accountOverview.accountList.length) {
        var account = payload.accountOverview.accountList[payload.accountIndex];
        payload.accountIndex++;
        if (account && payload.selectedAccount && account.accountNumber !== payload.selectedAccount.accountNumber) {
          return getActiveProduct(account, payload).then(activeProductFound).catch(activeProductNotFound);
        } else {
          return activeProductNotFound(payload);
        }
      } else if (payload.accountOverview.accountList && payload.accountIndex === payload.accountOverview.accountList.length) {
        selectAccount(payload);

        return !payload.accountSummary ? $q.reject({
          productNotFound: true
        }) : $q.reject({});
      }
    }

    function getProduct(result, accountSummary) {
      var subList = accountSummary.subList,
        selector;
      var key, subType;
      if (result.accountType === 1) {
        key = 'phoneNumber';
        subType = 'CTN';
      } else if (result.accountType === 6) {
        key = 'internetAccountNumber';
        subType = 'Hi-Speed Internet';
      }

      if (accountSummary.accountNumber === String(result.selectedAccount.accountNumber)) {
        selector = getProductSelectorWithKey(key, subType);
      }

      var product = null;
      if (selector) {
        product = _.find(subList, selector);
      }

      if (angular.isUndefinedOrNull(product)) {
        product = _.find(subList, getProductSelector(subType, 'Active'));
        if (angular.isUndefinedOrNull(product)) {
          product = _.find(subList, getProductSelector(subType, 'Suspended'));
        }
      }

      return angular.isUndefinedOrNull(product) ? $q.reject() : $q.when(product);
    }

    // function setLocalStorage(key, value, isCare) {
    //   if (isCare) {
    //     sessionStorage.setSessionStorageValue(key, value);
    //   } else {
    //     localStorage.setLocalStorageValue(key, value);
    //   }
    // }

    function checkIfShareEverythingEnabled(payload) {
      var isSharingDataFlag = (deeplink.data.redirect && !isDeeplinkFinished) ? true :
        (payload.product && payload.product.shareEverything && payload.product.shareEverything.isSharingData === true);

      if (!isDeeplinkFinished) {
        isDeeplinkFinished = true;
      }

      if (payload.accountSummary && payload.accountSummary.shareEverything && payload.accountSummary.shareEverything.isDataManagerEligible === true && isSharingDataFlag) {
        return permissionService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER);
      } else {
        return $q.when(false);
      }
    }

    function getProductSelectorWithKey(key, subType) {
      var storageValue = storageService.get(key);
      if (angular.isUndefinedOrNull(storageValue)) {
        return null;
      } else {
        var value = String(storageValue);
        if (subType === 'CTN') {
          return {
            subNumber: value,
            subType: subType,
            subStatus: 'Active'
          };
        } else if (subType === 'Hi-Speed Internet') {
          return {
            subAccountId: value,
            subType: subType,
            subStatus: 'Active'
          };
        } else {
          return null;
        }
      }
    }

    function getProductSelector(subType, subStatus) {
      return {
        subStatus: subStatus,
        subType: subType
      };
    }

    function selectAccount(payload) {
      if (payload.accountSummary && payload.selectedAccount && payload.accountSummary.accountNumber !== String(payload.selectedAccount.accountNumber)) {
        myrAccountListService.selectAccount(payload.accountSummary.accountNumber);
      } else {
        var selectedAccountNumber = storageService.get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
        if ((selectedAccountNumber === null || selectedAccountNumber === undefined) && payload.accountSummary) {
          storageService.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER, payload.accountSummary.accountNumber);
          storageService.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER, payload.accountSummary.accountTypeNumber);
        }
      }
    }
  }
}(_));

// Please read and follow https://github.com/johnpapa/angular-styleguide
/* global angular */
/* global _ */
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:DiscoveryPageNoLiveContent
   * @description
   * # DiscoveryPageNoLiveContent
   * Controller of the totesApp
   */

  angular
    .module('totesApp')
    .controller('MyrDiscoveryPageNoLiveContent', DiscoveryPageNoLiveContent);

  DiscoveryPageNoLiveContent.$inject = ['$stateParams', 'ute.discovery.page.service', 'lang', 'content'];
  /* @ngInject */
  function DiscoveryPageNoLiveContent($stateParams, discoveryPageService, lang, content) {
    var dpnlc = this;
    dpnlc.doNotShow = false;
    dpnlc.lang = lang.toLowerCase();
    dpnlc.pageContent = content;
    console.log('content', content);
    console.log('dpnlc.pageContent', dpnlc.pageContent);

    dpnlc.continue = function() {
      if (dpnlc.doNotShow) {
        // Make server call to update this event - based on checkbox setting
        discoveryPageService.serverSetInteractionState('VIEWED');
      } else {
        discoveryPageService.serverSetInteractionState('VIEW_AGAIN');
      }
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('EOPInternetOfferController', function ($scope, $translate, $modalInstance, $modal, $rootScope, $http, $state, ajax, $window, EOPService, customerLegacySubscriptionInfo, selectedOffer, newPlanDetails, EOPOffersPayload, cmsData, trackingHierarchy, $sce) {


      $scope.loading = false;

      $scope.language = $translate.use();

      var parseUsage = function(usage) {
        if (usage && usage !== '') {
          if (usage === 'UNLIMITED') {
            return $translate.instant('EOP.Unlimited');
          } else {
            return usage + ' GB';
          }
        }
        return '';
      }

      var updateEOPFlagAndHandshake = function(status) {
        var deferred = $.Deferred();
        $scope.loading = true;
        updateEOPStatus(status).then(function(resp){
          deferred.resolve('');
        }, function(err){
          deferred.reject();
          $scope.loading = false;
        })

        return deferred.promise();
      }

      var showErrorModal = function() {
        $rootScope.modal = null;
        var $technicalErrorModal = EOPService.openModal('notification', {
          resolve: {
            type: function() {
              return 'TECHNICAL_ERROR'
            },
            offer: null,
            EOPOffersPayload: null,
            trackingHierarchy: function(){
              return [];
            }
          }
        });
        $technicalErrorModal.result.then(function () {
          $modalInstance.dismiss('cancel');
        }, function () {
          $modalInstance.dismiss('cancel');
        });
      }

      $scope.upgradeNow = function($event, type){
        $event.preventDefault();
        if(selectedOffer.systemInd === 0){
          EOPService.track(trackingHierarchy && trackingHierarchy.length ? trackingHierarchy : [], {
            "interaction": {
              "type": "cta",
              "name": type== "upgrade" ? "upgrade-now" : "compare-with-current-plan"
            },
            "events": {
              "interaction": true,
            }
          });
          if($scope.language === 'fr'){
            showChatBoxForFR ();
            return;
          }

          updateEOPFlagAndHandshake('PENDING').then(function() {
            var redirectURL = $scope.lob === 'internet' ? "/web/myrogers/torcom/internetChangePackage?setLanguage=" + $scope.language : "/web/myrogers/torcom/link/tv/build-your-tv-package?setLanguage=" + $scope.language;
            var $form = $('<form class="hide" method="POST" action="' + redirectURL + '"></form>');
            /*
              For $scope.lob === 'bundle', there is no upgradeNow button, if future if there are adding need to discuss with SS and change the below two form values
            */
            $form.append('<input type="text" name="currentPackageId" value="' + customerLegacySubscriptionInfo.products[$scope.lob].code + '" />');
            $form.append('<input type="text" name="upgradePackageId" value="' + newPlanDetails[$scope.lob].code + '" />');
            $form.append('<input type="text" name="eopOfferId" value="' + selectedOffer.offerId + '" />');
            $form.append('<input type="text" name="eopFlow" value="'+type+'" />');
            $form.append('<input type="text" name="selectedAccountNumber" value="' + EOPOffersPayload.can + '" />');
            $scope.lob === 'internet' ? ($form.append('<input type="text" name="postalCode" value="' + customerLegacySubscriptionInfo.postalCode + '" />'),$form.append('<input type="text" name="currentModemId" value="' + customerLegacySubscriptionInfo.products.internet.deviceCode + '" />')) : $form.append('<input type="text" name="flowType" value="dbchangepkg" />');
            $form.append('<input type="submit" value=""/>');
            $('body').append($form)
            $form.submit();
          }, showErrorModal)
        }
      }

      var updateEOPStatus = function(status) {
        return EOPService.updateCustomersEOPStatus(EOPOffersPayload.accountNumber, EOPOffersPayload.can, status, selectedOffer.offerId)
      }

      $scope.cancel = function(dismissOffer) {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
        if (dismissOffer === true){
          EOPService.clearCachedEOPOffers(EOPOffersPayload.can, true);
          updateEOPFlagAndHandshake('DECLINED');
          EOPService.track(trackingHierarchy && trackingHierarchy.length ? trackingHierarchy : [], {
            "interaction": {
              "type": "click",
              "name": "eop-do-not-show-this-message-again"
            },
            "events": {
              "interaction": true,
            }
          })
          return;
        }
        EOPService.track(trackingHierarchy && trackingHierarchy.length ? trackingHierarchy : [], {
          "interaction": {
            "type": "click",
            "name": "close-eop-offer-button"
          },
          "events": {
            "interaction": true,
          }
        })
      };

      function currentPackageFeatures(){
        var features = [];
        if(!_.isEmpty(customerLegacySubscriptionInfo.products)){
          if($rootScope.currentStateName === 'tvdashboard'){
            if($scope.lob === 'bundle'){
              if(customerLegacySubscriptionInfo.products.tv && customerLegacySubscriptionInfo.products.tv.channelsInclusive){
                features.push({
                  label: 'tv',
                  value: $sce.trustAsHtml(customerLegacySubscriptionInfo.products.tv.channelsInclusive + '+ ' + $translate.instant('EOP.CURRENT_PLAN.features.channels'))
                })
              }
              if(customerLegacySubscriptionInfo.products.internet && customerLegacySubscriptionInfo.products.internet.downloadSpeed && customerLegacySubscriptionInfo.products.internet.downloadSpeedUnit){
                features.push({
                  label: 'internet',
                  value: customerLegacySubscriptionInfo.products.internet.downloadSpeed + ' ' + customerLegacySubscriptionInfo.products.internet.downloadSpeedUnit,
                  value_desc : 'internet_desc'
                })
              }
              if(customerLegacySubscriptionInfo.products.rhp){
                features.push({
                  label: 'home_phone',
                  value: customerLegacySubscriptionInfo.products.rhp['prodDesc'+_.capitalize($scope.language)]
                })
              }
            }else if($scope.lob === 'tv'){
              if(customerLegacySubscriptionInfo.products.tv && customerLegacySubscriptionInfo.products.tv.channelsInclusive){
                features.push({
                  label: 'tv',
                  value: $sce.trustAsHtml(customerLegacySubscriptionInfo.products.tv.channelsInclusive + '+ ' + $translate.instant('EOP.CURRENT_PLAN.features.channels'))
                })
              }
            }
          }else if($rootScope.currentStateName === 'internetdash' && $scope.lob === 'internet'){
            if(customerLegacySubscriptionInfo.products.internet && customerLegacySubscriptionInfo.products.internet.monthlyUsage){
              features.push({
                label: 'internet',
                value:  parseUsage(customerLegacySubscriptionInfo.products.internet.monthlyUsage)
              })
            }
            if(customerLegacySubscriptionInfo.products.internet && customerLegacySubscriptionInfo.products.internet.downloadSpeed && customerLegacySubscriptionInfo.products.internet.downloadSpeedUnit){
              features.push({
                label: 'download',
                value: customerLegacySubscriptionInfo.products.internet.downloadSpeed + ' ' + customerLegacySubscriptionInfo.products.internet.downloadSpeedUnit
              })
            }
          }
        }
        return features;
      }

      function offerPackageFeatures(){
        var features = [];
        if(!_.isEmpty(newPlanDetails)){
          if($rootScope.currentStateName === 'tvdashboard'){
            if($scope.lob === 'bundle'){
              if(newPlanDetails.internet && newPlanDetails.internet.downloadSpeed && newPlanDetails.internet.downloadSpeedUnit){
                features.push({
                  label: 'download',
                  value: newPlanDetails.internet.downloadSpeed,
                  valueDesc: newPlanDetails.internet.downloadSpeedUnit
                })
              }
              if(newPlanDetails.tv && newPlanDetails.tv.channelsInclusive){
                features.push({
                  label: 'tv',
                  title:$sce.trustAsHtml(newPlanDetails.tv['prodDesc'+_.capitalize($scope.language)]),
                  value: newPlanDetails.tv.channelsInclusive,
                  valueDesc: $sce.trustAsHtml($translate.instant('EOP.NEW_OFFER.newPromo.features.channels'))
                })
              }
            }else if($scope.lob === 'tv'){
              if(newPlanDetails.tv && newPlanDetails.tv.channelsInclusive){
                features.push({
                  label: 'tv',
                  value: newPlanDetails.tv.channelsInclusive,
                  valueDesc: $sce.trustAsHtml($translate.instant('EOP.NEW_OFFER.newPromo.features.channels'))
                })
              }
            }
          }else if($rootScope.currentStateName === 'internetdash' && $scope.lob === 'internet'){
            if(newPlanDetails.internet && newPlanDetails.internet.downloadSpeed && newPlanDetails.internet.downloadSpeedUnit){
              features.push({
                label: 'download',
                value: newPlanDetails.internet.downloadSpeed,
                valueDesc: newPlanDetails.internet.downloadSpeedUnit
              })
            }
          }
        }
        return features;
      }

      function showChatBoxForFR () {
        var modalInstance = $modal.open({
          templateUrl: 'views/modals/contact-care-fr-customers.html',
          windowClass: 'generic-message-modal',
          controller: ['$scope', '$translate', function ($scope, $translate) {
            $scope.close = function () {
              modalInstance.close();
            };
          }]
        });
      };

      function init(){
        //creating objects that is required for view and handling all the functionality in controller
        var existingPlanSectionView={
          packageFeatures: [],
          priceAfter: {
            campaignEndDate: 0,
            msf:0.0
          },
          currentPromoPrice:0.0,
          title: ''
        }, offerPlanSectionView={
          packageFeatures: [],
          image: '',
          price: {
            msf:0.0,
            discount:0.0,
            discountedPrice: {
              dollar: 0.00,
              cents: 0.00
            },
            term: 0
          },
          installationFee: 0.0,
          additionalOffer: '',
          title: '',
          includesRHP: false
        };
        $scope.lob = selectedOffer.offerLOB;
        if(selectedOffer.systemInd === 0){
          //populate values for existing details
          existingPlanSectionView.title = $sce.trustAsHtml(customerLegacySubscriptionInfo.products[$scope.lob]['prodDesc'+_.capitalize($scope.language)]);
          existingPlanSectionView.packageFeatures = currentPackageFeatures();
          if(customerLegacySubscriptionInfo.price){
            var temp = customerLegacySubscriptionInfo.price.promoEndDate;
            existingPlanSectionView.priceAfter.campaignEndDate = temp ? temp.substring(0, 2)+'/'+temp.substring(2, 4)+'/'+temp.substring(4, 6) : false;
            //temp = calculateExistingPackagePrice(true);
            existingPlanSectionView.priceAfter.msf = customerLegacySubscriptionInfo.price.regular;
            existingPlanSectionView.currentPromoPrice = customerLegacySubscriptionInfo.price.promo;
          }

          //populate values for new offer section

          offerPlanSectionView.title = $sce.trustAsHtml(($scope.lob === 'bundle' ? cmsData.eop[$scope.lob].newOfferPackageTitle[$scope.language] : newPlanDetails && newPlanDetails[$scope.lob] && ($scope.language === 'fr' ? $translate.instant('EOP.NEW_OFFER.newPromo.name'): '')+ ' ' +(newPlanDetails[$scope.lob]['prodDesc'+_.capitalize($scope.language)]) + ' ' + ($scope.language === 'en' ? $translate.instant('EOP.NEW_OFFER.newPromo.name'):'') + ($scope.lob === 'internet' ? ' - ' + $translate.instant('EOP.Unlimited') : '')));
          offerPlanSectionView.img = cmsData.eop[$scope.lob].OfferImage;
          offerPlanSectionView.packageFeatures = offerPackageFeatures();
          offerPlanSectionView.price.msf = selectedOffer.regularPrice;
          offerPlanSectionView.price.discount = selectedOffer.offerDiscountAmt;
          offerPlanSectionView.price.term = selectedOffer.campDuration;
          temp = selectedOffer.offerPrice.split('.');
          if(temp.length){
            offerPlanSectionView.price.discountedPrice.dollar = temp[0];
            offerPlanSectionView.price.discountedPrice.cents = temp[1];
          }
          offerPlanSectionView.installationFee = cmsData.eop[$scope.lob].installationFee[$scope.language];
          offerPlanSectionView.includesRHP = !!selectedOffer.offerRHPProdCode;
          temp =  _.find(cmsData.eop[$scope.lob].campaigns,{'code': selectedOffer.offerDiscCodeA}) || _.find(cmsData.eop[$scope.lob].campaigns,{'code': selectedOffer.offerDiscCodeB});
          if(temp){
            offerPlanSectionView.additionalOffer = $sce.trustAsHtml(temp[$scope.language]);
          }
        }

        $scope.existingPlanSectionView = existingPlanSectionView;
        $scope.offerPlanSectionView = offerPlanSectionView;
        //set aria-label for live chat link for accessibility
        if(selectedOffer.systemInd === 0 && $scope.lob === 'bundle'){
          var intervalObj = setInterval(function(){
            var liveChatObj = $(".ways-to-buy-section .live-chat a");
            if(liveChatObj.length){
              liveChatObj.attr('aria-label', $translate.instant('EOP.liveChat_alt_text'));
              clearInterval(intervalObj);
            }
          }, 2000);
        }
        if($scope.language === 'fr' && window.innerWidth > 767){
          //set equal heights for title and description
          setTimeout(function(){
            var maxHeight = 0
            $('.current-plan-container .features .featureTitle').each(function(){
              maxHeight = $(this).height() > maxHeight ? $(this).height() : maxHeight;
            })
            $('.current-plan-container .features .featureTitle').height(maxHeight);
            maxHeight = 0;
            $('.current-plan-container .features .featureDescription').each(function(){
              maxHeight = $(this).height() > maxHeight ? $(this).height() : maxHeight;
            })
            $('.current-plan-container .features .featureDescription').height(maxHeight);
          },500)
        }

      }
      init();
    });
  })();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
'use strict';

  angular.module('totesApp').controller('EOPNotificationController', function ($scope, $modalInstance, $rootScope, ajax, $http, $state, $window, $translate, EOPService, type, offer, EOPOffersPayload, trackingHierarchy) {

    $scope.language = $translate.use();//On load of TV dashBoard $rootScope is not having ute object so getting it from translate provider

    $scope.type = type;

    $scope.dismissOffer = false;

    $scope.lob = offer && offer.offerLOB;

    $scope.eopSubType = offer && offer.systemInd === 0 ? 'LEGACY' : 'IGNITE';
    switch(offer.systemInd){
      case 0:
        $scope.eopSubType = 'LEGACY'
        break;
      case 1:
        $scope.eopSubType = 'IGNITE'
        break;
      case 2:
        $scope.eopSubType = 'SAI'
        break;
      case 3:
        $scope.eopSubType = 'TUPELO'
        break;
    }
    console.log('dom eop offer',offer,$scope.eopSubType)

    $scope.offerType = (offer && typeof offer.offerType === 'string' && offer.offerType || '').toLowerCase();
    var name = ''
          switch(offer.systemInd){
            case 0:
              name = "legacy"
              break;
            case 1:
              name = "Ignite internet + tv + home phone"
              break;
            case 2:
              name = "Ignite internet"
              break;
            case 3:
              name = "Ignite internet + smart stream"
              break;
          }

    if (type === 'NEW_OFFER_NOTIFICATION'){
      $scope.ok = function () {
        $modalInstance.close('ok');

        EOPService.track([$rootScope.currentStateName, pageName], {
          "interaction": {
            "type": "click",
            "name": name + " : Yes, view my offer"
          },
          "events": {
            "interaction": true,
          }
        })

        console.log('dom',$scope.eopSubType)

        if ($scope.eopSubType === 'IGNITE' || $scope.eopSubType === 'TUPELO' || $scope.eopSubType === 'SAI') {
          return EOPService.handleIgniteRedirect();
        }

        ($scope.lob === 'internet') ? $state.go('internetdash') : $state.go('tvdashboard')
        $rootScope.modal = null;
        var pageName = $scope.eopSubType === 'IGNITE' ? 'offer-alert' : 'eop-offer-alert';
        
        
      };
    }

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
      var payload = {
        interaction:{
          type: 'click',
          name: name + " : No, continue to MyRogers"
        },
        events:{
          interaction: true
        }
      };
      if (type === 'NEW_OFFER_NOTIFICATION') {
        //payload.interaction.name = "close-eop-offer-alert";
        EOPService.track(trackingHierarchy, payload);
      }
    };
  });


})();

(function() {
  "use strict";
  angular.module("totesApp").factory("EOPService", EOPService);

  EOPService.$inject = [
    "ajax",
    "$http",
    "$window",
    "ute.datalayer.common.service",
    "$modal",
    "$rootScope",
    "myrMyServicesService",
    "ute.common.core.brtswitch.service",
    "$q",
    "$cookies",
    "$browser"
  ];

  var internetSubscriptionTypes = ["service_internet", "service_tv"];

  var parseEOPOffers = function(
    offers,
    isEOPPhase2SwitchOn,
    isIgniteTargetedOffersSwitchOn
  ) {
    var offers_local = [];
    if (
      isEOPPhase2SwitchOn &&
      offers[0].systemInd === 0 &&
      ((offers[0].offerLOB === "internet" && offers[0].offerINTProdCode) ||
        (offers[0].offerLOB === "tv" && offers[0].offerTVProdCode) ||
        (offers[0].offerLOB === "bundle" &&
          offers[0].offerINTProdCode &&
          offers[0].offerTVProdCode))
    ) {
      offers_local.push(offers[0]);
    } else if (isIgniteTargetedOffersSwitchOn && offers[0].systemInd === 1) {
      offers_local.push(offers[0]);
    } else if (isIgniteTargetedOffersSwitchOn && offers[0].systemInd === 2) {
      offers_local.push(offers[0]);
    } else if (isIgniteTargetedOffersSwitchOn && offers[0].systemInd === 3) {
      offers_local.push(offers[0]);
    }
    return offers_local;
  };

  var dataLayerServiceHelpers = {};
  dataLayerServiceHelpers.makeFriendly = function(item) {
    // if (!item) return ''
    var str = item.replace(/[^\x20-\x7E]/gim, "").trim(); // remove all control chars, eg: "↵iPhone 5s↵↵"
    return decodeURIComponent(str)
      .replace(/-|\+/g, " ")
      .toLowerCase();
  };
  dataLayerServiceHelpers.getVirtualHierarchy = function(l) {
    var path = l.pathname;

    // shop pages, or pages that have "/consumer/" in the path
    if (path.lastIndexOf("/") == path.length - 1)
      path = path.substr(0, path.length - 1); // band-aid: correct for path ending in "/" (Angular)

    var p = path.split("/");
    p.shift();
    // make friendly names
    for (var j = 0; j < p.length; j++) {
      p[j] = dataLayerServiceHelpers.makeFriendly(p[j]);
    }
    if (p) {
      // if (p[0] === 'consumer') p[0] = 'shop';
      if (p[0] === "consumer") p.shift();

      // hash
      if (l.hash) {
        if (l.hash.indexOf("#/") !== -1)
          p.push(dataLayerServiceHelpers.makeFriendly(l.hash.split("/")[1]));
        else p.push(dataLayerServiceHelpers.makeFriendly(l.hash.split("#")[1]));
      }

      return p;
    }

    return [];
  };
  dataLayerServiceHelpers.getTimeStamp = function(is_UTC) {
    // format: "Friday|4/22/2016 7:05"

    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];

    var dateObj = new Date();

    if (is_UTC) {
      var month = dateObj.getUTCMonth() + 1;
      var day = dateObj.getUTCDate();
      var year = dateObj.getUTCFullYear();
      var hour = dateObj.getUTCHours(); // 2
      var mins = dateObj.getUTCMinutes();

      hour -= 4; // -2
      if (hour < 0) hour += 24; // 22
    } else {
      var month = dateObj.getMonth() + 1;
      var day = dateObj.getDate();
      var year = dateObj.getFullYear();
      var hour = dateObj.getHours(); // 2
      var mins = dateObj.getMinutes();
    }

    return (
      days[dateObj.getDay()] +
      "|" +
      month +
      "/" +
      day +
      "/" +
      year +
      " " +
      hour +
      ":" +
      (mins < 10 ? "0" : "") +
      mins
    );
  };

  function EOPService(
    ajax,
    $http,
    $window,
    dataLayerService,
    $modal,
    $rootScope,
    myrMyServicesService,
    brtSwitchService,
    $q,
    $cookies,
    $browser
  ) {
    var service = {};
    var self = this;
    var hasRHP = false;
    function resetCurrentSessionObj() {
      self.currentSessionValue = {
        accountNumber: null,
        can: null,
        eopOffersResponse: null,
        customersLegacySubscriptionInfoResponse: null,
        newOfferProductDetails: null,
        installationFeeResponse: null,
        serviceAddress: {},
        name: ""
      };
    }
    $rootScope.eopNotification = {};

    resetCurrentSessionObj(); //creates new object and sets to default value

    service.track = function(states, payload) {
      var UTEDataLayerService = ute.datalayer.common.service;
      var section = UTEDataLayerService.DataLayerPredefinedSection;
      var selectedSections = [section.ACCOUNT, section.PAGE, section.SITE];
      if (!payload.interaction) {
        selectedSections.push(section.PAGE_VIEW_EVENT);
      }
      dataLayerService.track(payload, true, selectedSections, {
        mappingKey: states && states.length ? states.join(",") : ""
      });
    };

    self.cacheGetEOPOffers = _.memoize(
      function() {
        return $http({
          method: "POST",
          url: ajax.EOP.getEOPOffers(),
          withCredentials: false,
          data: {
            can: self.currentSessionValue.can,
            accountNumber: self.currentSessionValue.accountNumber,
            province: self.currentSessionValue.serviceAddress.province
          }
        });
      },
      function() {
        return self.currentSessionValue.can;
      }
    );

    service.getEOPOffers = function(accountNumber, can) {
      console.log('dom geteopoffers')
      var deferred = $q.defer();
      if (
        $rootScope.isConsumer === true &&
        $rootScope.isDealer === false &&
        $rootScope.isCare === false
      ) {
        brtSwitchService
          .getValue("EOP_PHASE2")
          .then(function(isEOPPhase2SwitchOn) {
            brtSwitchService
              .getValue("IGNITE_TARGETED_OFFERS")
              .then(function(isIgniteTargetedOffersSwitchOn) {
                console.log('dom brt',isIgniteTargetedOffersSwitchOn,isEOPPhase2SwitchOn)
                if (isEOPPhase2SwitchOn || isIgniteTargetedOffersSwitchOn) {
                  self
                    .cacheGetEOPOffers()
                    .then(
                      function(response) {
                        console.log('dom brt',isIgniteTargetedOffersSwitchOn,isEOPPhase2SwitchOn,response)
                        if (
                          response.data.responseStatus.status === "success" &&
                          response.data.eopTargetedOffers &&
                          response.data.eopTargetedOffers.length
                        ) {
                          var eopOffers = parseEOPOffers(
                            response.data.eopTargetedOffers,
                            isEOPPhase2SwitchOn,
                            isIgniteTargetedOffersSwitchOn
                          );
                          console.log('dom eopoffers',eopOffers)
                          if (eopOffers.length) {
                            self.currentSessionValue.eopOffersResponse =
                              response.data; //do not remove this line
                            self.currentSessionValue.eopOffersResponse.eopTargetedOffers = eopOffers;
                            self.currentSessionValue.newOfferProductDetails = _.get(
                              response,
                              "data.productEnrichments.products",
                              null
                            );
                            deferred.resolve(response.data);
                          } else {
                            deferred.reject("No eop offers.");
                          }
                        } else {
                          deferred.reject("Failed to fetch offers.");
                        }
                      },
                      function() {
                        deferred.reject("Failed to fetch offers.");
                      }
                    )
                    .finally(function() {
                      // do not cache if there's an error, below line removed the cached failure response
                      service.clearCachedEOPOffers(
                        self.currentSessionValue.can
                      );
                    });
                } else {
                  deferred.reject("EOP switch off.");
                }
              });
          });
      } else {
        deferred.reject("User is not consumer");
      }
      return deferred.promise;
    };

    service.clearCachedEOPOffers = function(can, force) {
      if (self.currentSessionValue.eopOffersResponse === null || force) {
        $rootScope.eopOfferToShowBadge = {};
        self.cacheGetEOPOffers.cache.delete(can);
      }
    };

    service.getCustomersLegacySubscriptionInfo = function(
      accountNumber,
      can,
      lob
    ) {
      var deferred = $q.defer();

      $http({
        method: "POST",
        url: ajax.EOP.getCustomersLegacySubscriptionInfo(),
        withCredentials: false,
        data: {
          accountNumber: accountNumber,
          can: can,
          lob: lob,
          refresh: false
        }
      }).then(
        function(response) {
          if (
            response.data.responseStatus &&
            response.data.responseStatus.status === "success" &&
            !_.isEmpty(response.data.products)
          ) {
            self.currentSessionValue.customersLegacySubscriptionInfoResponse =
              response.data;
          }
          deferred.resolve(response.data);
        },
        function() {
          deferred.reject("Failed to fetch product info.");
        }
      );
      return deferred.promise;
    };

    service.getActiveSubscriberInfo = function(summary) {
      console.log('dom summary',summary)
      var subscriberInfo = {};
      resetCurrentSessionObj();
      summary.subList.forEach(function (sub) {
        console.log('this sub', sub)
        if(sub.subType.toLowerCase() === 'rhpc'){
          hasRHP = true;
        }
      });

      self.currentSessionValue.name =
        summary.accountName.firstName + " " + summary.accountName.lastName;

      try {
        var subscriptions = myrMyServicesService.getSubscriptions(
          summary.subList,
          false
        );
        for (var i = 0; i < subscriptions.myServices.length; i++) {
          if (
            internetSubscriptionTypes.indexOf(
              subscriptions.myServices[i].serviceType
            ) > -1 &&
            subscriptions.myServices[i].status === "Active"
          ) {
            self.currentSessionValue.subList = summary.subList;
            subscriberInfo.can = subscriptions.myServices[i].serviceDetail + "";
            var temp =
              _.find(self.currentSessionValue.subList, {
                subAccountId: subscriberInfo.can * 1
              }) || {};
            self.currentSessionValue.serviceAddress = temp.subAddress;
            subscriberInfo.province =
              (temp.subAddress && temp.subAddress.province) || "";
            break;
          }
        }
      } catch (e) {
        console.log(e);
      } finally {
        return subscriberInfo;
        /*//As part of story CH-1222
        if(subscriberInfo.can && subscriberInfo.province && $cookies.province.toUpperCase() === subscriberInfo.province.toUpperCase()){
          return subscriberInfo;
        } else {
          return {};
        }*/
      }
    };

    service.updateCustomersEOPStatus = function(
      accountNumber,
      can,
      status,
      offerId
    ) {
      return $http({
        method: "POST",
        url: ajax.EOP.updateCustomersEOPStatus(),
        withCredentials: false,
        data: {
          can: can,
          status: status,
          offerId: offerId,
          accountNumber: accountNumber
        }
      });
    };

    service.openModal = function(type, options) {
      try {
        if (type === "notification") {
          var modalOptions = $.extend(
            {},
            {
              templateUrl: "views/modals/EOP/eop-notification-modal.html",
              controller: "EOPNotificationController",
              size: "eop-notification-modal",
              backdrop: "static",
              backdropClass: "bkg-modal"
            },
            options
          );
          return $modal.open(modalOptions);
        } else if (type === "offer") {
          var modalOptions = $.extend(
            {},
            {
              templateUrl:
                "views/modals/EOP/eop-existing-plan-offer-modal.html",
              controller: "EOPInternetOfferController",
              size: "eop-offer-modal existing-cx",
              backdrop: "static",
              backdropClass: "bkg-modal"
            },
            options
          );
          return $modal.open(modalOptions);
        }  else if(type === "tupelo") {
          var modalOptions = $.extend(
            {},
            {
              templateUrl: "views/modals/tupelo/first-time-offer-modal.html",
              controller: "EOPNotificationController",
              size: "eop-notification-modal",
              backdrop: "static",
              backdropClass: "bkg-modal"
            },
            options
          );
          return $modal.open(modalOptions);
        }
        else {
          throw new Error("Undefined type of modal.");
        }
      } catch (e) {
        throw new Error("Couldn't process modal.");
      }
    };

    function showMismatchNotificationModal() {
      var selectedOffer =
        self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0];
      var pageHierarchy = [
        $rootScope.currentStateName,
        "eop-unavailable-or-expired-offer-message"
      ];
      service.updateCustomersEOPStatus(
        self.currentSessionValue.accountNumber,
        self.currentSessionValue.can,
        "INELIGIBLE",
        selectedOffer.offerId
      );
      service.clearCachedEOPOffers(self.currentSessionValue.can);
      trackSelectedOffer(pageHierarchy);
      return service.openModal("notification", {
        resolve: {
          type: function() {
            return "OFFER_MISMATCH";
          },
          offer: function() {
            return selectedOffer;
          },
          EOPOffersPayload: function() {
            return {
              can: self.currentSessionValue.can
            };
          },
          trackingHierarchy: function() {
            return pageHierarchy;
          }
        }
      });
    }

    function showTechnicalErrorMessage() {
      var selectedOffer =
        self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0];
      var pageHierarchy = [];
      return service.openModal("notification", {
        resolve: {
          type: function() {
            return "TECHNICAL_ERROR";
          },
          offer: function() {
            return selectedOffer;
          },
          EOPOffersPayload: function() {
            return {
              can: self.currentSessionValue.can
            };
          },
          trackingHierarchy: function() {
            return pageHierarchy;
          }
        }
      });
    }

    function showNewOfferNotificationModal() {
      var selectedOffer =
        self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0];
      var pageName =
        selectedOffer.systemInd === 0 ? "eop-offer-alert" : "offer-alert";
      var pageHierarchy = [$rootScope.currentStateName, pageName];
      service.updateCustomersEOPStatus(
        self.currentSessionValue.accountNumber,
        self.currentSessionValue.can,
        "TENTATIVE",
        selectedOffer.offerId
      );
      trackSelectedOffer(pageHierarchy);
      if(selectedOffer.systemInd === 1 || selectedOffer.systemInd === 2 || selectedOffer.systemInd === 3){
        return service.openModal("tupelo", {
          resolve: {
            type: function() {
              return "NEW_OFFER_NOTIFICATION";
            },
            offer: function() {
              return selectedOffer;
            },
            EOPOffersPayload: function() {
              return {
                can: self.currentSessionValue.can
              };
            },
            trackingHierarchy: function() {
              return pageHierarchy;
            }
          }
        });
      }
      else{
        return service.openModal("notification", {
          resolve: {
            type: function() {
              return "NEW_OFFER_NOTIFICATION";
            },
            offer: function() {
              return selectedOffer;
            },
            EOPOffersPayload: function() {
              return {
                can: self.currentSessionValue.can,
                accountNumber: self.currentSessionValue.accountNumber
              };
            },
            trackingHierarchy: function() {
              return pageHierarchy;
            }
          }
        });
      }

    }

    function showOfferNotificationModal() {
      var selectedOffer =
        self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0];
      var pageHierarchy = [
        $rootScope.currentStateName,
        "eop-targeted-offer-detail"
      ];
      trackSelectedOffer(pageHierarchy);
      return service.openModal("offer", {
        resolve: {
          customerLegacySubscriptionInfo: function() {
            return self.currentSessionValue
              .customersLegacySubscriptionInfoResponse;
          },
          selectedOffer: function() {
            return selectedOffer;
          },
          newPlanDetails: function() {
            return self.currentSessionValue.newOfferProductDetails;
          },
          EOPOffersPayload: function() {
            return {
              can: self.currentSessionValue.can,
              accountNumber: self.currentSessionValue.accountNumber
            };
          },
          cmsData: function() {
            return self.currentSessionValue.installationFeeResponse;
          },
          trackingHierarchy: function() {
            return pageHierarchy;
          }
        }
      });
    }

    function trackSelectedOffer(trackingHierarchy) {
      var trackDataOffers = [];
      $.each(
        self.currentSessionValue.eopOffersResponse.eopTargetedOffers,
        function(id, offer) {
          var type = ''
          switch(offer.systemInd){
            case 0:
              type = "legacy"
              break;
            case 1:
              console.log('dom case',hasRHP)
              if(hasRHP){
                type = "Ignite internet + tv + home phone"
              } else {
                type = "Ignite internet + tv"
              }
              break;
            case 2:
              type = "Ignite internet"
              break;
            case 3:
              type = "Ignite internet + smart stream"
              break;
          }
          trackDataOffers.push({
            code:
              offer.offerLOB === "internet"
                ? offer.offerINTProdCode
                : offer.offerLOB === "tv"
                  ? offer.offerTVProdCode
                  : offer.offerLOB === "bundle" && offer.offerRHPProdCode
                    ? _.sortBy(
                        _.compact([
                          offer.offerINTProdCode,
                          offer.offerTVProdCode,
                          offer.offerRHPProdCode
                        ])
                      ).join()
                    : _.sortBy(
                        _.compact([
                          offer.offerINTProdCode,
                          offer.offerTVProdCode
                        ])
                      ).join(),
            type: type,
            name: offer.offerDescEn
          });
        }
      );
      service.track(trackingHierarchy || [], {
        ecommerce: {
          offers: trackDataOffers
        }
      });
    }

    function isServiceAddressAndBrowserProvinceMatch() {
      if (
        self.currentSessionValue.serviceAddress.province &&
        $cookies.province.toUpperCase() ===
          self.currentSessionValue.serviceAddress.province.toUpperCase()
      ) {
        return true;
      } else {
        return false;
      }
    }

    function triggerEOPOperation(accountNumber, can) {
      console.log('dom trigger eop', accountNumber,can)
      var deferred = $q.defer();
      self.currentSessionValue.can = can;
      self.currentSessionValue.accountNumber = accountNumber;
      $rootScope.eopOfferToShowBadge = {};
      console.log('dom trigger eop', accountNumber,can)
      service.getEOPOffers(accountNumber, can).then(
        function(eopOffers) {
          console.log('dom eop',can,$rootScope.eopNotification,self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0],!$rootScope.eopNotification[can])
          if (
            self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
              .systemInd === 0 &&
            !isServiceAddressAndBrowserProvinceMatch()
          ) {
            deferred.reject();
            return;
          }
          if (
            self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
              .systemInd === 0
          ) {
            if ($rootScope.currentStateName === "accountOverview") {
              $rootScope.eopOfferToShowBadge = {
                systemInd:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].systemInd,
                offerLOB:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].offerLOB,
                offerId:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].offerId,
                hasHideOffer: _.has(
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0],
                  "hideOffer"
                ),
                isLegacy:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].systemInd === 0
              };
              if (
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .hideOffer === false &&
                !$rootScope.eopNotification[can]
              ) {
                $rootScope.eopNotification[can] = true;
                deferred.resolve(showNewOfferNotificationModal());
              } else {
                deferred.reject();
              }
            } else if (
              (self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                .offerLOB === "internet" &&
                $rootScope.currentStateName === "internetdash") ||
              (self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                .offerLOB !== "internet" &&
                $rootScope.currentStateName === "tvdashboard")
            ) {
              $http
                .get("/web/totes/cms/content/json/eop/lob_schema.json")
                .then(function(switchResponse) {
                  self.currentSessionValue.installationFeeResponse =
                    switchResponse.data;
                  service
                    .getCustomersLegacySubscriptionInfo(
                      self.currentSessionValue.accountNumber,
                      self.currentSessionValue.can,
                      self.currentSessionValue.eopOffersResponse
                        .eopTargetedOffers[0].offerLOB
                    )
                    .then(
                      function(response) {
                        if (response.responseStatus.status === "success") {
                          deferred.resolve(showOfferNotificationModal());
                        } else {
                          deferred.resolve(
                            response.responseStatus.errorCode === "108" ||
                            response.responseStatus.errorCode === "109"
                              ? showMismatchNotificationModal()
                              : showTechnicalErrorMessage()
                          );
                        }
                      },
                      function() {
                        deferred.resolve(showTechnicalErrorMessage());
                      }
                    );
                });
            }
          } else if (
            self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
              .systemInd === 1 &&
            $rootScope.currentStateName === "accountOverview"
          ) {
            //ignite
            $rootScope.eopOfferToShowBadge = {
              systemInd:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].systemInd,
              offerLOB:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerLOB,
              offerId:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerId,
              hasHideOffer: _.has(
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0],
                "hideOffer"
              ),
              isLegacy:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .systemInd === 0,
              offerType: self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].offerType.toLowerCase()
            };
            if (
              self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                .hideOffer === false
            ) {
              deferred.resolve(showNewOfferNotificationModal());
            } else {
              deferred.reject();
            }
          } else if (
            self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
              .systemInd === 2 &&
            $rootScope.currentStateName === "accountOverview"
          ) {
            //SAI
            $rootScope.eopOfferToShowBadge = {
              systemInd:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].systemInd,
              offerLOB:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerLOB,
              offerId:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerId,
              hasHideOffer: _.has(
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0],
                "hideOffer"
              ),
              isLegacy:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .systemInd === 0,
              offerType: self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].offerType.toLowerCase()
            };
            if (
              self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                .hideOffer === false
            ) {
              deferred.resolve(showNewOfferNotificationModal());
            } else {
              deferred.reject();
            }
          }

          else if (
            self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
              .systemInd === 3 &&
            $rootScope.currentStateName === "accountOverview"
          ) {
            //tupelo
            $rootScope.eopOfferToShowBadge = {
              systemInd:
                  self.currentSessionValue.eopOffersResponse
                    .eopTargetedOffers[0].systemInd,
              offerLOB:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerLOB,
              offerId:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .offerId,
              hasHideOffer: _.has(
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0],
                "hideOffer"
              ),
              isLegacy:
                self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                  .systemInd === 0,
              offerType: self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].offerType.toLowerCase()
            };
            if (
              self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
                .hideOffer === false
            ) {
              deferred.resolve(showNewOfferNotificationModal());
            } else {
              deferred.reject();
            }
          }
        },
        function() {
          deferred.reject();
        }
      );
      return deferred.promise;
    }

    function handleIgniteRedirect() {
      console.log('subList',self)
      var prioritySubType = ["Digital TV", "Hi-Speed Internet", "RHPc"],
        listSubType = _.chain(self.currentSessionValue.subList)
          .map(function(sElement) {
            var rList = _.map(prioritySubType, function(pElement) {
              if (_.get(sElement, "subType", "") === pElement) {
                return sElement;
              }
              return undefined;
            });

            return rList[0] || rList[1] || rList[2];
          })
          .without(undefined)
          .value();

      var getProp = function(from, prop) {
        return (from || {})[prop];
      };

      console.log('dom listSubType',listSubType)

      var url = "/web/RogersServices.portal/totes/api/v1/storeData";
      var input = {
        can: self.currentSessionValue.can,
        serviceAddress: self.currentSessionValue.serviceAddress,
        customerName: self.currentSessionValue.name,
        offerId:
          self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
            .offerId,
        offerCode:
          self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
            .offerINTProdCode,
        offerType:
          self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0]
            .offerType,

        accountNumber: self.currentSessionValue.accountNumber,
        subAccountId: getProp(_.first(listSubType), "subAccountId"),
        subscriptionId: getProp(_.first(listSubType), "subNumber"),
        subType: getProp(_.first(listSubType), "subType"),
        source: "rogers.com",
        redirectTo: {
          protocol: window.location.protocol,
          host: window.location.hostname,
          port: window.location.port,
          path: window.location.pathname,
          hash: window.location.hash,
          href: window.location.href
        }
      };

      console.error('currentSessionValue',self.currentSessionValue.serviceAddress,self.currentSessionValue.serviceAddress.province)

      if (
        self.currentSessionValue.serviceAddress &&
        self.currentSessionValue.serviceAddress.province
      ) {
        //updateCookie irrespective of match or no match of services, this is required for a particular scenario
        //Where cookie Province with path /web/totes will be ON and cookie Province with path / and domain .rogers.com will be something else eg:NL.
        //To achive this change province in accountOverview page to ON go to any support page change the province where .rogers.com domain will have the changed province
        //reaching accountOverview qill load ON instead of teh province choosen in support page.
        var province = self.currentSessionValue.serviceAddress.province.toUpperCase();
        var _domain = $window.location.hostname.replace("www", "");
        $window.document.cookie =
          "province=" + province + ";domain=" + _domain + ";path=/;max-age=" + 60*60*24*365;
        $window.document.cookie =
          "province=" + province + ";domain=.rogers.com;path=/;max-age=" + 60*60*24*365;
        // RAJIV - Added one more cookie as angular 7 application added cookie without . and
        // connected-home-consumer application is picking up cookie without .
        // The expiry date is set to 2 years same as the existing cookie
        var _domain2 = $window.location.hostname.replace("www.", "");
        $window.document.cookie =
          "province=" + province + ";domain=" + _domain2 + ";path=/;max-age=" + 60*60*24*365*2;
        $browser.cookies("province", province);
      }

      return $http.post(url, input).then(function(response) {
        brtSwitchService.getValue("HTO_PHASE1").then(function(isHtoEnabled) {
          var redirectPath = ""
          if (typeof isHtoEnabled === 'undefined') isHtoEnabled = true
          if(self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].systemInd === 1){
            redirectPath = hasRHP
            ? "/home/ignite-bundle-home-phone/promo"
            : "/home/ignite-bundle/promo";
          }
          if(self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].systemInd === 2){
            redirectPath = "/home/ignite-internet/promo"
          }
          if(self.currentSessionValue.eopOffersResponse.eopTargetedOffers[0].systemInd === 3){
            redirectPath = "/home/ignite-internet-streaming/promo"
          }

          redirectPath = isHtoEnabled
            ? redirectPath
            : "/bundles/offers";
          console.log('dom redirect',redirectPath)
          $window.location.href = redirectPath + "?dpid=" + response.data.dpid;
        });
      });
    }

    service.triggerEOPOperation = triggerEOPOperation;
    service.handleIgniteRedirect = handleIgniteRedirect;

    return service;
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrForgetPasswordService', forgetPasswordService);

  forgetPasswordService.$inject = ['$q', '$timeout'];

  /* @ngInject */
  function forgetPasswordService($q, $timeout) {

    // Public API
    var service = {
      setCookie: setCookie,
      getSmtoken: getSmtoken,
      getUsername: getUsername,
      getSmauthreason: getSmauthreason,
      getSmagentname: getSmagentname,
      getTarget: getTarget
    };

    // private
    var data = {
      smtoken: undefined,
      username: undefined,
      smauthreason: undefined,
      smagentname: undefined,
      target: undefined
    };

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    // TODO where is cookie here?
    /**
     *
     * @param params
     * @returns {*}
     */
    function setCookie(params) {
      var defer = $q.defer();
      // $cookie gets updated every 100 ms
      // use timeout to let data have time to be ready
      $timeout(function () {
        data.smtoken = params.SMTOKEN;
        data.username = params.USERNAME;
        data.smauthreason = params.SMAUTHREASON;
        data.smagentname = params.SMAGENTNAME;
        data.target = params.TARGET;
        defer.resolve(data);
      }, 125);

      return defer.promise;
    }

    function getSmtoken() {
      return data.smtoken;
    }

    function getUsername() {
      return data.username;
    }

    function getSmauthreason() {
      return data.smauthreason;
    }

    function getSmagentname() {
      return data.smagentname;
    }

    function getTarget() {
      return data.target;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrForgotUserNameController
   * @description
   * # MyrForgotUserNameController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrForgotUserNameController', ForgotUserNameController);

  ForgotUserNameController.$inject = ['$scope',
    'ajax',
    '$translate',
    'appState',
    'myrNotificationBannerService',
    '$log',
    '$rootScope',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function ForgotUserNameController($scope,
                                    ajax,
                                    $translate,
                                    appState,
                                    notificationBannerService,
                                    $log,
                                    $rootScope,
                                    languageSwitcher) {


    notificationBannerService.cleanBanner('successMessage');

    $scope.setStaticChatButtonValues = function () {
      $scope.boldChatAltText = $translate.instant('forgot_username_live_chat_alt_text');
      if (languageSwitcher.getCurrentLanguage() === 'en') {
        $scope.boldChatButtonId = 'S_ForgotUNamePass';
        $scope.boldChatButtonDiv = 'forgotUserName-En';
        $scope.boldChatButton = 'chatButtonForgotUserNameEn';
      } else {
        $scope.boldChatButtonId = 'S_ForgotUNamePassRegIssues_Fr';
        $scope.boldChatButtonDiv = 'forgotUserName-Fr';
        $scope.boldChatButton = 'chatButtonForgotUserNameFr';
      }
    };

    $scope.getAriaLabelContent = function() {
      $scope.aria_label_forgot_username = $translate.instant('_forget_username');
    };

    $scope.setStaticChatButtonValues();
    $scope.getAriaLabelContent();

//    $rootScope.$on('languageChanged', function () {
//      $scope.setStaticChatButtonValues();
//      $scope.getAriaLabelContent();
//    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.setStaticChatButtonValues();
      $scope.getAriaLabelContent();
    }, 'forgotUsernameLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('forgotUsernameLangSub');
    });

    $scope.$extend({
      email: '',
      subModule: function () {
        return appState.submodule;
      },
      //second form
      success: false,
      isError: false,

      failedMessage: '',
      errorDescription: '',
      fn: '',
      cToken: '',
      emailRequiredMessage: null,
      emailInvalidMessage: null,
      isEmailValid: true,
      errorCode: '',
      loadingDataIndicator: false,
      submit: function () {
        var form = $scope.form1;

        if (form.$valid) {
          $scope.loadingDataIndicator = true;
          ajax.getRegisteredUserName($scope.email).then(
            function (data) {
              if (data === undefined) {
                $scope.isError = true;
              } else {
                $scope.success = true;
              }
              $scope.loadingDataIndicator = false;
            },
            function (error) {
              $scope.isError = true;
              try {
                /**
                 * Set error code to a default value 10503
                 */
                $scope.errorCode = 10503;
                $scope.errorDescription = '';
                /**
                 * If errorCode exist from server response
                 * map errorDescription to the the errorCode
                 */
                if (_.has(error, 'error.errorCode')) {
                  $scope.errorDescription = $translate.instant(error.error.errorCode);
                }

                /**
                 * If errorDescription does not exist in our resource file
                 * set errorDescription by using default error code
                 */
                if ( $scope.errorDescription.length === 0 ) {
                  $scope.errorDescription = $translate.instant($scope.errorCode);
                } else {
                  $scope.errorCode = error.error.errorCode;
                }

              } catch (e) {
                $log.error('Exception catch during tagging on errorDescription with message:', e.message);
              }
              $scope.loadingDataIndicator = false;
            }
          );
        }
      }
    });

    $scope.failedMessageX = function () {
      return $scope.failedMessage.format($scope.email);
    };

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      notificationBannerService.sendMessageKey('successMessage', 'login_forget_username_success');
      $scope.failedMessage = $translate.instant('login_invalid_email_sent_desc');
      $scope.emailRequiredMessage = $translate.instant('login_forget_pwd_required');
      $scope.emailInvalidMessage = $translate.instant('login_forget_pwd_email_invalid');
      $scope.errorDescription = $translate.instant($scope.errorCode);
    }, 'forgotUserNameControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('forgotUserNameControllerLangSub');
    });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp')
    .controller('FindAccNumberModalController', FindAccNumberModalController);

  FindAccNumberModalController.$inject = ['$scope',
    '$modalInstance',
    '$rootScope',
    '$timeout',
    'ute.blocks.language.switcher',
    'util',
    'ute.common.core.browser.service'];

  /* @ngInject */
  function FindAccNumberModalController($scope,
                                        $modalInstance,
                                        $rootScope,
                                        $timeout,
                                        languageSwitcher,
                                        util,
                                        browserService) {
    $scope.oneAtATime = true;
    $scope.currentLanguage = languageSwitcher.getCurrentLanguage();
    $scope.accordionStatus = [true, false, false];
    var prevAccordionStatus = [];

    $scope.refocus = function () {
      // open accordions circularly on iOS Safari to solve scrolling issue
      if (util.isSafari() && browserService.isIOS()) {
        if ($scope.accordionStatus[0] === $scope.accordionStatus[1] === $scope.accordionStatus[2] === false) {
          if (prevAccordionStatus.length === 0 || prevAccordionStatus[0]) {
            $scope.accordionStatus[1] = true;
          } else if (prevAccordionStatus[1]) {
            $scope.accordionStatus[2] = true;
          } else if (prevAccordionStatus[2]) {
            $scope.accordionStatus[0] = true;
          }
        }
        prevAccordionStatus = _.clone($scope.accordionStatus);
      }
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };

    function init() {
      if(browserService.isMobile()){
        $timeout(function () {
          $('.modal[size="findAccNumberModal"]')
            .animate({scrollTop: 80}, 500);
        }, 1000);
      }
    }

    init();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrGuestOverviewController
   * @description
   * # MyrGuestOverviewController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrGuestOverviewController', GuestOverviewController);

  GuestOverviewController.$inject = ['$scope', '$modal', '$rootScope'];

  /* @ngInject */
  function GuestOverviewController($scope, $modal, $rootScope) {


    // Find account number modal.
    $scope.openFindAccNumberModal = function (size) {
      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/findAccNumberModal.html',
        controller: 'FindAccNumberModalController',
        size: 'findAccNumberModal',
        backdrop: 'static',
        backdropClass: 'bkg-modal'
      });
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrThankYouModalController', thankYouModalController);

  thankYouModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function thankYouModalController($scope, $modalInstance, $rootScope) {

    $scope.ok = function () {
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @desc This Decorator is targeting to handle $http retry on error
   * The function will retry the rest call based on the retry data
   * Below is the sample data for retry

   restCallRetry: {
    "retryCondition":{
      "statusCodeOnError": [0,-1,400],
      "customCondition": true
    },
    1: {
      timeDelay: 500
    },
    2: {
      timeDelay: 1000
    },
    3: {
      timeDelay: 2000
    }
  }
   */

  angular.module('myr.modules.httpDecorator').config(configure);

  configure.$inject = ['$provide'];

  /* @ngInject */
  function configure($provide) {

    $provide.decorator('$http', ['$delegate', '$q', '$timeout', function ($delegate, $q, $timeout) {
      var $http = $delegate;

      // This flag will turn the use of the default value on or off
      var useDefault = true;
      // This is the default retry value
      var defaultRetrySetting = {
        retryCondition: function (error) {
          return ((error.status <= 0) || (error.status === 400));
        },
        1: {
          timeDelay: 500
        },
        2: {
          timeDelay: 1000
        },
        3: {
          timeDelay: 2000
        }
      };

      var retryWrapper = function () {

        var deferred = $q.defer();
        var retryOnFail = 'retryOnFail';
        var httpArguments = arguments;
        var config = arguments[0];
        var retryConfig;

        // Add the default retry setting for all http calls
        if (useDefault) {

          if (_.has(config.headers, 'retryOnFail') && angular.isObject(config.headers.retryOnFail)) {
            retryConfig = config.headers.retryOnFail;
            delete config.headers.retryOnFail;
          } else if (_.has($http.defaults, 'retryOnFail') && angular.isObject($http.defaults.retryOnFail)) {
            retryConfig = $http.defaults.retryOnFail;
          } else {
            retryConfig = defaultRetrySetting;
          }

        }

        function callHttpService(retryIndex) {

          //var retrySetting = (_.has(config.headers, retryOnFail))?config.headers.retryOnFail[retryIndex + '']:null;

          if (retryIndex === 0 || (angular.isObject(retryConfig) && _.has(retryConfig, retryIndex))) {
            $http.apply($http, httpArguments).then(
                function (data) {
                  deferred.resolve(data);
                }, function (error) {
                  // If http call fails then check the retry condition, if condition return true then retry
                  if ((_.has(retryConfig, 'retryCondition') && retryConfig.retryCondition(error))
                  ) {
                    $timeout(function () {
                      callHttpService(++retryIndex);
                    }, (retryIndex === 0) ? 0 : retryConfig[retryIndex + ''].timeDelay);
                  } else {
                    deferred.reject(error);
                  }
                }
            );
          }
        }

        // Calling for regular http call
        callHttpService(0);

        return deferred.promise;

      };

      // Do not lose not 'function' properties - "pendingRequests" and "defaults"
      retryWrapper = angular.extend(retryWrapper, $http);

      // $http has convenience methods such as $http.get() that we have to pass through as well.
      Object.keys($http).filter(function (key) {
        return (typeof $http[key] === 'function');
      }).forEach(function (key) {
        retryWrapper[key] = function () {

          // Apply global changes to arguments, or perform other nefarious acts.

          return $http[key].apply($http, arguments);
        };
      });

      return retryWrapper;
    }]);
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrInternetChartService', internetChartService);

  internetChartService.$inject = ['$translate', 'util'];

  /* @ngInject */
  function internetChartService($translate, util) {

    // Initiate Object
    var internetChart = {};

    // hook up variables
    internetChart._usages = [];
    internetChart._startDate = new Date();
    internetChart._endDate = new Date();
    internetChart._leftDays = null;
    internetChart.usageLimit = 0;
    internetChart.currentTotal = 0;

    internetChart.graph = {};
    internetChart.xPadding = 25;
    internetChart.yPadding = 25;

    internetChart.axisColor = '#cccccc';
    internetChart.successColor = '#00965E';
    internetChart.warnColor = '#ffbe3e';
    internetChart.gbColor = 'black';
    internetChart.scaleFont = '5pt Calibri';
    internetChart.firstTimeShift = 0;
    internetChart.axisYstep = 1; //MB
    internetChart.axisYFont = '10pt Calibri';

    internetChart.data = {};
    internetChart.isGB = true;

    internetChart.drawChartInner = function () {
      internetChart.axisYstep = 1;
      internetChart.currentTotal = 0;
      internetChart.isGB = true;

      internetChart.getGraph();
      var c = internetChart.graph.getContext('2d');

      internetChart.data.values = [];
      for (var x = 0; x < internetChart._usages.length; x++) {
        internetChart.data.values.push({X: x, Y: internetChart._usages[x].totalDailyUsage});
      }

      var absMax = internetChart.getAbsMax();
      internetChart.isGB = absMax >= 1000;
      //adjust for MB
      if (!internetChart.isGB) {
        var tmp1 = 0;
        for (var xx = 0; xx < internetChart.data.values.length; xx++) {
          tmp1 = internetChart.data.values[xx].Y;
          tmp1 = tmp1 * 1000;
          internetChart.data.values[xx].Y = tmp1;
        }

        absMax = internetChart.getAbsMax();
        internetChart.usageLimit = internetChart.usageLimit * 1000;
      }
      internetChart.drawGB(c);

      var ln = String(absMax).length;
      for (var ox = 1; ox < ln; ox++) {
        internetChart.axisYstep = internetChart.axisYstep * 10;
      }

      var multiply = internetChart.axisYstep / 1000;
      var axisYheight = internetChart.getMaxY();

      c.lineWidth = 2;
      c.strokeStyle = internetChart.axisColor;
      c.font = 'italic 8pt sans-serif';
      c.textAlign = 'center';

      // Draw the axises ===========================================================================================
      internetChart.drawAxises(c, internetChart.graph);
      c.lineWidth = 1;

      // Draw the X value texts ==================================================================================
      c.fillStyle = internetChart.axisColor;
      c.font = internetChart.scaleFont;

      var tt = ((internetChart.graph.width - internetChart.xPadding) / internetChart.data.values.length) / 2;  // shift to make day in the middle
      var shiftCoor = internetChart.data.values.length >= 30 ? tt : 0;
      for (var i = 0; i < internetChart.data.values.length; i++) {
        c.fillText('|', internetChart.getXPixel(i) - shiftCoor, internetChart.graph.height - internetChart.yPadding + internetChart.firstTimeShift);
      }

      // Draw the Y value texts===================================================================================
      c.font = internetChart.axisYFont;
      for (var y = 0; y < axisYheight; y += internetChart.axisYstep) {
        c.textAlign = 'right';
        c.textBaseline = 'Alphabetic';
        c.fillStyle = internetChart.gbColor;
        var gb = Math.round(y / internetChart.axisYstep * multiply);
        c.fillText(String(gb), internetChart.xPadding, internetChart.getYPixel(y));
      }
      //draw dashed lines==========================================================================================
      for (var yz = internetChart.axisYstep; yz < axisYheight; yz += internetChart.axisYstep) {
        c.setLineDash([1, 1]);

        c.moveTo(internetChart.xPadding, internetChart.getYPixel(yz));
        c.lineTo(internetChart.graph.width, internetChart.getYPixel(yz));
        c.stroke();
      }

      c.setLineDash([10, 0]);

      //GB at the top================================================================================================
      // NOT needed at present.... uncomment to show capping line text
      //internetChart.drawGB(c);

      //draw dates at the left and right============================================================================
      internetChart.drawDates(c);

      //draw top line================================================================================================
      // NOT needed at present.... uncomment to show capping line
      // internetChart.drawTopLine(c);

      // Draw the line graph=========================================================================================
      c.strokeStyle = internetChart.successColor;
      c.lineWidth = 3;
      c.beginPath();
      c.moveTo(internetChart.getXPixel(0), internetChart.getYPixel(internetChart.data.values[0].Y));
      internetChart.currentTotal += internetChart.data.values[0].Y;

      // var minusCorrect = internetChart._leftDays <= 0 ? internetChart._leftDays + 1 : internetChart._leftDays - 1;
      // Always add 1 to internetChart._leftDays because we don't want to include today...
      var minusCorrect = internetChart._leftDays <= 0 ? internetChart._leftDays + 1 : internetChart._leftDays + 2;
      if (internetChart.displayLastRecord) {
        minusCorrect -= 1;
      }
      for (var j = 1; j < internetChart.data.values.length - minusCorrect; j++) {
        if (internetChart.currentTotal > internetChart.usageLimit * 1024) {
          c.strokeStyle = internetChart.warnColor;
        }
        c.lineTo(internetChart.getXPixel(j), internetChart.getYPixel(internetChart.data.values[j].Y));
        internetChart.currentTotal += internetChart.data.values[j].Y;
        c.stroke();
        c.beginPath();
        c.moveTo(internetChart.getXPixel(j), internetChart.getYPixel(internetChart.data.values[j].Y));
      }
    };

    internetChart.drawGB = function (ctx) {
      //GB at the top================================================================================================
      ctx.fillStyle = 'black';
      ctx.textAlign = 'right';
      ctx.fontWeight = '300';

      ctx.textBaseline = 'top';
      var gbLabel = internetChart.isGB ? $translate.instant('internet_GB') : $translate.instant('internet_MB');
      ctx.fillText(gbLabel, internetChart.xPadding, 0);
    };

    internetChart.drawDates = function (ctx) {
      ctx.font = '400 12px sans-serif';
      ctx.textBaseline = 'top';
      ctx.textAlign = 'left';
      ctx.fillText(internetChart._startDate, 0, internetChart.graph.height - internetChart.yPadding / 2);
      ctx.textAlign = 'right';
      ctx.fillText(internetChart._endDate, internetChart.graph.width, internetChart.graph.height - internetChart.yPadding / 2);
    };

    internetChart.drawTopLine = function (ctx) {
      ctx.setLineDash([1, 1]);

      ctx.moveTo(internetChart.xPadding, 10);
      ctx.lineTo(internetChart.graph.width, 10);
      ctx.stroke();
      ctx.setLineDash([10, 0]);
    };

    internetChart.drawAxises = function (ctx, graph1) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = internetChart.axisColor;
      ctx.beginPath();

      ctx.moveTo(0, graph1.height - internetChart.yPadding);
      ctx.lineTo(graph1.width, graph1.height - internetChart.yPadding);
      ctx.stroke();
    };

    internetChart.drawAxeY = function (ctx, graph1) {
      ctx.lineWidth = 2;
      ctx.strokeStyle = internetChart.axisColor;

      ctx.beginPath();
      ctx.moveTo(internetChart.xPadding, internetChart.yPadding / 2);  //beginning
      ctx.lineTo(internetChart.xPadding, internetChart.graph.height - internetChart.yPadding);

      ctx.stroke();
    };

    internetChart.getGraph = function () {
      var graphs = $('.chart-position');
      internetChart.graph = graphs[0];
      if (internetChart.graph.clientWidth === 0) {
        internetChart.graph = graphs[1];
      }

      var tmp = internetChart.graph.getContext('2d');
      tmp.clearRect(0, 0, internetChart.graph.width, internetChart.graph.height);
    };

    internetChart.drawChartEmpty = function () {
      internetChart.getGraph();
      var c = internetChart.graph.getContext('2d');

      internetChart.drawGB(c);
      internetChart.drawAxeY(c, internetChart.graph);

      internetChart.drawAxises(c, internetChart.graph);
      internetChart.drawDates(c);

      c.fillStyle = internetChart.axisColor;
      c.font = internetChart.scaleFont;

      for (var i = 0; i < 30; i++) {
        var x2 = ((internetChart.graph.width - internetChart.xPadding) / 30) * i + (internetChart.xPadding * 1.5);
        c.fillText('|', x2, internetChart.graph.height - internetChart.yPadding);
      }
    };

    // Return the x pixel for a graph point================================================================================
    internetChart.getXPixel = function (val) {
      return ((internetChart.graph.width - internetChart.xPadding) / internetChart.data.values.length) * val + (internetChart.xPadding * 1.5);
    };

    // Return the y pixel for a graph point
    internetChart.getYPixel = function (val) {
      return internetChart.graph.height - (((internetChart.graph.height - internetChart.yPadding) / internetChart.getMaxY()) * val) - internetChart.yPadding;
    };

    internetChart.getMaxY = function () {
      var max = 0;

      for (var i = 0; i < internetChart.data.values.length; i++) {
        if (internetChart.data.values[i].Y > max) {
          max = internetChart.data.values[i].Y;
        }
      }
      max += internetChart.axisYstep - max % internetChart.axisYstep;
      // Show axis labelling to be above maximum value
      max += internetChart.axisYstep;
      return max;
    };

    internetChart.getAbsMax = function () {
      var max = 0;

      for (var i = 0; i < internetChart.data.values.length; i++) {
        if (internetChart.data.values[i].Y > max) {
          max = internetChart.data.values[i].Y;
        }
      }

      return max;
    };

    internetChart.drawChart = function (dataObj, limit, startDate, endDate, leftDays, firstTime, displayLastRecord) {
      startDate = (startDate === undefined || startDate === null) ? new Date() : startDate;
      endDate = (endDate === undefined || endDate === null) ? new Date() : endDate;

      internetChart._startDate = startDate;
      internetChart._endDate = endDate;
      internetChart._leftDays = leftDays;
      internetChart._leftDays = internetChart._leftDays < 0 ? 0 : internetChart._leftDays;
      internetChart.firstTimeShift = firstTime ? 5 : 0;
      internetChart.displayLastRecord = displayLastRecord;

      if (!dataObj || dataObj.internetUsageToolVO.dayToDayVO === undefined || dataObj.internetUsageToolVO.dayToDayVO.length === 0) {
        internetChart.drawChartEmpty();
        return false;
      }

      internetChart.usageLimit = limit;
      internetChart._usages = dataObj.internetUsageToolVO.dayToDayVO[0].dailyUsageList; //dataObj.internetUsageToolVO.dayToDayVO;

      internetChart.drawChartInner();

      return true;
    };

    // This one is called from outside functions
    internetChart.drawChartSync = function (graphData, firstTime) {
      var dtStartdate = graphData.dtStartDate;
      var monthsNames = util.getMonthsNames();

      graphData.startDate = monthsNames[dtStartdate.getMonth()];
      graphData.startDate = graphData.startDate.substring(0, 3);
      graphData.startDate += ' ' + dtStartdate.getDate();

      var dtEndDate = graphData.dtEndDate;

      graphData.endDate = monthsNames[dtEndDate.getMonth()];
      graphData.endDate = graphData.endDate.substring(0, 3);
      graphData.endDate += ' ' + dtEndDate.getDate();

      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);

      var displayLastRecord = (((currentDate - dtEndDate) / 86400000) > 0);

      internetChart.drawChart(graphData.data, graphData.total, graphData.startDate, graphData.endDate, graphData.days, firstTime, displayLastRecord);
    };

    return internetChart;
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrInternetDashboardController
   * @description
   * # MyrInternetDashboardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrInternetDashboardController', InternetDashboardController);

  InternetDashboardController.$inject = ['appState', '$state', 'liveChatSettings', 'ute.common.user.service', '$rootScope', 'oneTimeModalPopupService', 'ajax', '$http', '$modal', '$scope', 'ute.datalayer.common.service', '$window', 'EOPService', 'ute.rogers.account.overview.factory'];

  /* @ngInject */
  function InternetDashboardController(appState, $state, liveChatSettings, userService, $rootScope, oneTimeModalPopupService, ajax, $http, $modal, $scope, dataLayerService, $window, EOPService, newAccountOverviewFactory) {
    var newAccountOverviewService = newAccountOverviewFactory();
    this.userService = userService;
    this.appState = appState;
    this.liveChatSettings = liveChatSettings;
    this.selectedAccountNumber = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER)).toString();

    if (appState.checkMaintenance('INTERNET_ON_MAINTENANCE')) {
      $state.go('underMaintenance');
    } else {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
    }

    $scope.loadEOPOffer = true;

    $scope.subscription = null;

    function getCurrentAccountAndTriggerEOP(requestResponse) {
      if ($rootScope.isConsumer === true && $rootScope.isDealer === false && $rootScope.isCare === false) {
        newAccountOverviewService.getSelectedAccount()
        .then(function (selectedAccount) {
          triggerEOP(selectedAccount, requestResponse);
        })
      }
    }

    $scope.$eopModal = null;
    $scope.$wifiModemModal = null;

    function triggerEOP(account, requestResponse) {
      account.accountOverview.selectedAccount.getAccountOverviewSummary().then(function (summary) {
        $scope.loadEOPOffer = false;
        var accountNumber = summary.accountNumber + "";
        var subscriberInfo = EOPService.getActiveSubscriberInfo(summary);
        if (subscriberInfo.can && subscriberInfo.can.length === 12) {
          EOPService.triggerEOPOperation(accountNumber, subscriberInfo.can).then(function(openModalObject){
            $scope.$eopModal = openModalObject;
            $scope.$eopModal.result.then(function () {
              // on OK behaviour
              triggerMyWifiModemModal(requestResponse.response);
            }, function () {
              // on Cancel behaviour
              triggerMyWifiModemModal(requestResponse.response);
            });
          }, function(){
            triggerMyWifiModemModal(requestResponse.response);
          });
        }
      })

    }

    $scope.$on('$destroy', function(){
      if ($scope.$eopModal) $scope.$eopModal.close();
      if ($scope.$wifiModemModal) $scope.$wifiModemModal.close();
    })

    $scope.$on('InternetDashboardProductLoaded', function (evt, requestResponse) {
      try {
        if (
          $scope.loadEOPOffer &&
          $rootScope.ao && $rootScope.ao.accountDetails &&
          requestResponse.response.internetPlan
        ) {
          getCurrentAccountAndTriggerEOP(requestResponse);
        }
      } catch (e) {
      }
    })


    var triggerMyWifiModemModal = function (response) {
      var myWifiModalData = {
        "targetPage":"internetdash",
        "modalName":"MyWiFi",
        "programIDList":[
           {
              "programID":"MyWifiLaunch20180701WiFi",
              "conditionsList":[
                 {
                    "attributes":{
                       "ProductCode":"W31M,W31R"
                    },

              "startDate":"11/01/2018",
              "endDate":"07/26/2118",
                    "rule":"ProductCode"
                 }
              ]
           }
        ],
        "CMSContentURL":"cms/content/ute/rogers/views/my-wifi-modal/my-wifi-modal/my-wifi-modal",
        "ResponseMapping":{
           "ProductCode":"deviceId"
        }
     }
     /*$http.get('/web/totes/cms/content/json/my_wifi/my-wifi-modal.json')
          .then(function (obj) { */
          if (myWifiModalData && !$scope.$wifiModemModal) {
            var programIdObj = oneTimeModalPopupService.validateTheRules(myWifiModalData, response);
            if (programIdObj && programIdObj.endDate && programIdObj.programId) {
              var accountNumber = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER)).toString();
              ajax.getUserModalPreference(myWifiModalData.targetPage, programIdObj.programId, programIdObj.endDate, accountNumber).then(function (res) {

                if (res && res.status == "success" && res.displayModal) {
                  $scope.$wifiModemModal = $modal.open({
                    templateUrl: 'views/modals/myWifiModal.html',
                    windowClass: 'generic-message-modal',
                    controller: ['$scope', '$modalInstance', function ($scope, $modalInstance) {
                      $scope.modalCMSContentUrl = myWifiModalData.CMSContentURL;
                      $scope.close = function () {
                        if ($scope.checked) {
                          ajax.persistModalPreference(myWifiModalData.targetPage, programIdObj.programId, programIdObj.endDate, accountNumber).then(function (resp) {
                            $modalInstance.dismiss('cancel');
                          }, function () {
                            $modalInstance.dismiss('cancel');
                          });
                        } else {
                          $modalInstance.dismiss('cancel');
                        }
                      };
                    }
                    ]
                  });
                  $scope.$wifiModemModal.result.then(null, function() {
                    // $rootScope.modal = null;
                  })
                }
              }, function (error) { });
            }
          }
//        }, function (error) { })
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrInternetService', internetService);

  internetService.$inject = ['ajax', '$rootScope'];

  /* @ngInject */
  function internetService(ajax, $rootScope) {
    var internetService = {
      internetPackageObj: {
        numberOfRetryOnExpired: 0,
        inProgress: false,
        callBack: null,
        callFail: null
      },
      internetModemObj: {
        numberOfRetryOnExpired: 0,
        inProgress: false,
        callBack: null,
        callFail: null
      }
    };

    function processCall(primaryObj, secondaryObj, dataObj, callBack, callFail) {
      primaryObj.inProgress = true;
      if (secondaryObj.inProgress) {
        primaryObj.callBack = callBack;
        primaryObj.callFail = callFail;
      } else {
        ajax.internetDashboardProduct(dataObj.accountNumber, dataObj.refresh, dataObj.language)
          .then(function (data) {
            callBack(data);
            internetService.supportTheOther(secondaryObj, data, 'success');
            $rootScope.$broadcast('InternetDashboardProductLoaded', {
              request: dataObj,
              response: data
            });
          }).catch(function (error) {
            callFail(error);
            internetService.supportTheOther(secondaryObj, error, 'fail');
          }).finally(function () {
            primaryObj.inProgress = false;
          });
      }
    }

    internetService.requestUsage = function (dataObj, callBack, callFail) {
      ajax.internetDashboard(dataObj.accBan, dataObj.accLang, dataObj.accNo).then(callBack, callFail);
    };

    internetService.internetUsage = function (dataObj, callBack, callFail) {
      ajax.internetDashboardUsage(dataObj.accountNumber).then(callBack, callFail);
    };

    internetService.internetPackage = function (dataObj, callBack, callFail) {
      processCall(internetService.internetPackageObj, internetService.internetModemObj, dataObj, callBack, callFail);
    };

    internetService.internetModem = function (dataObj, callBack, callFail) {
      processCall(internetService.internetModemObj, internetService.internetPackageObj, dataObj, callBack, callFail);
    };

    internetService.supportTheOther = function (respObj, blob, status) {
      if (status === 'success' && respObj.callBack !== null) {
        respObj.callBack(blob);
      }
      if (status === 'fail' && respObj.callFail !== null) {
        respObj.callFail(blob);
      }
      respObj.inProgress = false;
      respObj.callBack = null;
      respObj.callFail = null;
    };

    return internetService;
  }
})();

(function() {
  'use strict';
  angular
    .module('totesApp')
    .factory('oneTimeModalPopupService', oneTimeModalPopupService);

  oneTimeModalPopupService.$inject = [];

  function oneTimeModalPopupService() {
    var _service = {};

    function parseRule(rule) {
      var conditionsMap = {
        NOT: '!',
        OR: '||',
        AND: '&&'
      };
      Object.keys(conditionsMap).forEach(function(key) {
        rule = rule.replace(
          new RegExp('\\b' + key + '\\b', 'g'),
          conditionsMap[key]
        );
      });
      return rule;
    }

    function formatTheResponse(attributes) {
      Object.keys(attributes).forEach(function(key) {
        attributes[key] = attributes[key].split(',');
      });
      return attributes;
    }

    _service.validateTheRules = function(cmsObj, response) {
      loop: for (var i = 0; i < cmsObj.programIDList.length; i++) {
        for (	var j = 0;j < cmsObj.programIDList[i].conditionsList.length;j++) {
          var todayDate = new Date();
          //console.log(todayDate);
          var endDate = new Date(
            cmsObj.programIDList[i].conditionsList[j].endDate
          );

          var startDate = new Date(
            cmsObj.programIDList[i].conditionsList[j].startDate
          );
          endDate.setDate(endDate.getDate() + 1);
          //console.log(endDate.getTime());
          if ( todayDate.getTime() < endDate.getTime() && todayDate.getTime() >= startDate.getTime() ) {
            var attributes = formatTheResponse(
              cmsObj.programIDList[i].conditionsList[j].attributes
            );
            var rule = parseRule(
              cmsObj.programIDList[i].conditionsList[j].rule
            );
            Object.keys(cmsObj.ResponseMapping).forEach(function(key) {
              rule = rule.replace(
                key,
                '(attributes.' +
                key +
                '.indexOf( "' +
                response[cmsObj.ResponseMapping[key]] +
                '" )> -1)'
              );
            });
            console.log(rule);
            console.log(eval(rule));
            if (eval(rule)) {
              return {
                programId :cmsObj.programIDList[i].programID,
                endDate:cmsObj.programIDList[i].conditionsList[j].endDate
              }
            }
          }
        }
      }
    };
    return _service;
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrMigrateUserController
   * @description
   * # MyrMigrateUserController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrMigrateUserController', MigrateUserController);

  MigrateUserController.$inject = [
    '$scope',
    'settings',
    '$browser',
    '$translate',
    'ajax',
    'appState',
    'localStorage',
    'landing',
    '$rootScope',
    'ute.common.core.brtswitch.service',
    '$state',
    'ute.dtm.service',
    'ute.blocks.language.switcher']; // jshint ignore:line

  /* @ngInject */
  function MigrateUserController(
    $scope,
    settings,
    $browser,
    $translate,
    ajax,
    appState,
    localStorage,
    landing,
    $rootScope,
    brtSwitchService,
    $state,
    dtmService,
    languageSwitcher) { // jshint ignore:line

    var self = this;
    $scope.dtmName = 'legacy username migration';

    $scope.regObj = {
      email: null
    };
    $scope.loadingDataIndicator = false;
    $scope.confirmEmail = '';
    $scope.errorCode = '';
    $scope.errorDescription = '';
    $scope.isSuccess = null;
    $scope.isDisabled = false;
    $scope.chatHref = languageSwitcher.getCurrentLanguage() === 'en' ? settings.chatLink.en : settings.chatLink.fr; /// 'cuscare_ECare_landing.php?hm=n&s=701',

    $scope.submit = function () {
      var form = $scope.form;
      if (form.$valid) {
        $scope.updateUsername();
      }
    };

    $scope.showGeneralError = function () {
      $scope.errorCode = 'general';
      $scope.onClickEmailAlreadyRegisteredUsage();
      $scope.errorDescription = $translate.instant('maintenance_info');
    };

    $scope.onClickUserNameMigrationPageLoadUsage = function () {

      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:username_migration_start'}, // Page Name
        {eVar14: 'MyRogers_username_migration'}, {event5: ''}]);
    };

    $scope.onClickNotAValidEmailAddressUsage = function () {

      appState.tagging(['_trackLink',
        {eVar49: 'MyRogers-username_mig_not_a_valid_email'}, {event15: ''}]);
    };

    $scope.onClickEmailsDoNotMatchUsage = function () {

      appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_emails_donotmatch'}, {event15: ''}]);
    };

    $scope.onClickEmailAlreadyRegisteredUsage = function () {

      appState.tagging(['_trackLink', {eVar49: 'MyRogers-username_mig_email_already_registered'}, {event15: ''}]);
    };

    $scope.onClickThankYouPageOfUserNameMigrationLoadsUsage = function () {

      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:username_migration_thankyou'}, // Page Name
        {eVar14: 'MyRogers_username_migration'}, {event6: ''}]);
    };

    $scope.updateUsername = function () {
      $scope.loadingDataIndicator = true;
      brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.JANRAIN_REGISTRATION).then(function (val) {
        if (val) {
          $scope.janrainChangeUsername();
        } else {
          $scope.smUpdateUsername();
        }
      });
    };

    $scope.smUpdateUsername = function () {
      ajax.updateUsername($scope.regObj.email).then(
        function (response) {
          if (response === undefined) {
            $scope.loadingDataIndicator = false;
            $scope.showGeneralError();
          } else {
            $scope.changeUsernameSuccessful();
          }
        },
        function (error) {
          $scope.loadingDataIndicator = false;
          dtmService.fireDtmExceptions($scope.dtmName, error.data, 'SS');
          if (error.data.status === 555) {
            if (error.error.errorCode === 10802) {
              $scope.onClickNotAValidEmailAddressUsage();
              $scope.errorCode = error.error.errorCode.toString();
            } else {
              $scope.showGeneralError();
            }
          } else {
            $scope.showGeneralError();
          }
        });
    };

    $scope.janrainChangeUsername = function () {
      ajax.changeUsername($scope.regObj.email).then(
        function (response) {
          if (response === undefined) {
            $scope.loadingDataIndicator = false;
            $scope.showGeneralError();
          } else {
            $scope.changeUsernameSuccessfulJanrain();
          }
        },
        function (error) {
          $scope.loadingDataIndicator = false;
          dtmService.fireDtmExceptions($scope.dtmName, error.data, 'SS');
          if (error.data.status === 555) {
            if (error.error.errorCode === 10802) {
              $scope.onClickNotAValidEmailAddressUsage();
              $scope.errorCode = error.error.errorCode.toString();
            } else {
              $scope.showGeneralError();
            }
          } else {
            $scope.showGeneralError();
          }
        });
    };

    $scope.commoncChangeUsernameSuccessful = function () {
      $scope.loadingDataIndicator = false;
      $scope.isSuccess = true;
      $scope.onClickThankYouPageOfUserNameMigrationLoadsUsage();
      localStorage.setLocalStorageValue('successMessage', 'mu_msg_success');
      localStorage.setLocalStorageValue('usernameMigrationComplete', 'true');
      $browser.cookies('userToken', $scope.email);
      $rootScope.$broadcast('pageUserNameChanged');
      dtmService.complete($scope.dtmName);
    };

    $scope.changeUsernameSuccessful = function () {
      $scope.commoncChangeUsernameSuccessful();
      landing.landingRedirect();
    };

    /**
     * Add this function for Janrain only
     * This function  will skip landingRedirect and go to accountOverview directly
     */
    $scope.changeUsernameSuccessfulJanrain = function () {
      $scope.commoncChangeUsernameSuccessful();
      $state.go('accountOverview');
    };

    $scope.getEmail = function () {
      ajax.getEmail().then(
        function (response) {
          if (response === undefined) {
            $scope.onClickNotAValidEmailAddressUsage();
            // do nothing
          } else {
            $scope.regObj.email = response.email;
          }
        },
        function (error) {
          dtmService.fireDtmExceptions($scope.dtmName, error.data, 'SS');
          // no need to inform user if failed to retrieve suggestion email
        }
      );
    };

    $scope.getEmail();

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.chatHref = lang === 'en' ? settings.chatLink.en : settings.chatLink.fr;
    }, 'migrateUserControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('migrateUserControllerLangSub');
    });

    self.init = function () {
      dtmService.start($scope.dtmName);
    };

    self.init();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  // TODO where it used ?

  angular.module('totesApp').provider('myrMigrateUserHandler', function () {
    var data;

    return {
      $get: function () {
        return data;
      },
      $set: function (value) {
        data = value;
      }
    };
  });
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('migrateUserService', migrateUserService);

  migrateUserService.$inject = ['$q', 'ajax', '$translate', 'user', '$browser'];

  /* @ngInject */
  function migrateUserService($q, ajax, $translate, user, $browser) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      migrateCheck: migrateCheck
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function migrateCheck() {
      var mic = $q.defer();

      var username = $browser.cookies().userName;
      if (!username || user.isEmail(username)) {
        mic.resolve(false);
      }

      ajax.usernameMigration().then(
        function (data) {
          if (data === '') {
            mic.resolve(false);

          } else {
            var dataObj = angular.fromJson(data);
            if (dataObj.migration) {
              mic.resolve(true);
            } else {
              mic.resolve(false);
            }
          }
        },
        function (error) {
          var _return = {};

          if (error.data.status === 555) {
            _return.result = 'error';
            _return.data = error;
            _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
            mic.resolve(false);

          } else {
            _return.result = 'error';
            _return.data = error;
            _return.message = $translate.instant('maintenance_info');		// Pull message from resource file 401 or 5xx situlation
            mic.resolve(false);
          }
        }
      );

      return mic.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').factory('myrMyOtherServicesService', myrMyOtherServicesService);
  myrMyOtherServicesService.$inject = [
    '$rootScope',
    'ute.blocks.language.switcher',
    'myrRevolutionService',
    'myrAccountListService',
    'ute.rogers.account.overview.factory',
    'ute.rogers.eclipse.remote.api.service',
    'ute.common.user.service',
    'cookieStore',
    '$modal',
    '$injector',
    'ute.common.permissions.service'
  ];

  function myrMyOtherServicesService(
      $rootScope,
      languageSwitcher,
      myrRevolutionService,
      myrAccountListService,
      accountOverviewFactory,
      eclipseRemoteApi,
      userService,
      cookieStore,
      $modal,
      $injector,
      permissionsService
  ) {
    var serviceInterface = {
      addToRemovalList: addToRemovalList,
      resetRemovalList: resetRemovalList,
      configureMasterList: configureMasterList,
      getMasterList: getMasterList,
      isOtherServicesAvailable: isOtherServicesAvailableFn,
      isIgniteComboAccount: isIgniteComboAccount
    };

    var accountOverviewService = accountOverviewFactory();
    var isOtherServicesAvailable = false;
    var removalList = [];
    var finalList = [];
    var isIgniteCombo = false;
    var masterList = [{
      id: 'CTN',
      title: 'myaccoverview_get_wireless',
      //link: 'https://www.rogers.com/web/content/wireless_plan_landing',
      link: 'http://www.rogers.com/consumer/wireless',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-wireless'
    }, {
      id: 'Hi-Speed Internet',
      title: 'myaccoverview_get_internet',
      //link: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans',
      link: 'http://www.rogers.com/consumer/internet',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-internet',
      identicalAs: ['HSI']
    }, {
      id: 'Digital TV',
      title: 'myaccoverview_get_tv',
      //link: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg',
      link: 'https://www.rogers.com/web/link/ptvBrowsePackagesFlowBegin?forwardTo=landing',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: false,
      icon: 'ute-icon-tv',
      identicalAs: ['IPTV']
    }, {
      id: 'RHPc',
      title: 'myaccoverview_get_phone',
      link: '',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-phone',
      identicalAs: ['RHP Phone Line']
    }, {
      id: 'Rogers Smart Home Monitoring',
      title: 'myaccoverview_get_monotoring',
      //link: 'https://www.rogers.com/web/content/smart-home-monitoring-solutions-new',
      link: 'http://www.rogers.com/consumer/home-monitoring',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-security'
    }, {
      id: 'Rogers Bank',
      title: 'myaccoverview_get_rogers_bank',
      link: 'https://www.rogersbank.com/' + languageSwitcher.getCurrentLanguage(),
      updateRogersBank: true,
      addLangRoute: false,
      addLang: false,
      langParameterName: '',
      langFirstParam: true,
      icon: '',
      imageIcon: 'rogers-bank'
    },
    // {
    //   id: 'NHL (GCL)',
    //   title: 'myaccoverview_get_nhl',
    //   link: 'https://gamecentrelive.rogers.com/' + languageSwitcher.getCurrentLanguage(),
    //   updategamecentrelive: true,
    //   addLangRoute: false,
    //   addLang: false,
    //   langParameterName: '',
    //   langFirstParam: true
    // },
    //SEE_Project Implementation
    {
       id: 'Add Individual Line',
       title: 'share_everything_individual',
       link: '',
       addLangRoute: false,
       addLang: true,
       langParameterName: 'setLanguage',
       langFirstParam: true,
       icon: 'ute-icon-wireless',
       allowGoto: true,
       goto: function($event){//when goto is used link property should be empty or both (click and href) functionality will be executed
         $event.preventDefault();
         $event.stopPropagation();
         $injector.get("ajax").nacSaveState({
            key: 'NEW_MULTI_WRLS_INFO',
            isDeeplink: true,
            isIndividual: true,
            clearSession:true,
            nacSessionList: []
          }).then(function(){
           $injector.get("$window").location.href = "/web/totes/wireless/#/choose-phone?deeplink";
          });
       }
     },//end-SEE_Project Implementation
    {
      id: 'HSI',
      title: 'myaccoverview_get_internet',
      //link: 'https://www.rogers.com/web/link/hispeedBrowseFlowDefaultPlans',
      link: 'http://www.rogers.com/consumer/internet',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-internet',
      identicalAs: ['Hi-Speed Internet']
    }, {
      id: 'IPTV',
      title: 'myaccoverview_get_tv',
      //link: 'https://www.rogers.com/web/link/tv/build-your-tv-package?flowType=dbchangepkg',
      link: 'https://www.rogers.com/web/link/ptvBrowsePackagesFlowBegin?forwardTo=landing',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: false,
      icon: 'ute-icon-tv',
      identicalAs: ['Digital TV']
    }, {
      id: 'RHP Phone Line',
      title: 'myaccoverview_get_phone',
      link: '',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-home-phone',
      identicalAs: ['RHPc']
    }, {
      id: 'Ignite NAC',
      title: 'myaccoverview_get_ignite_bundle',
      link: '/bundles',
      addLangRoute: false,
      addLang: true,
      langParameterName: 'setLanguage',
      langFirstParam: true,
      icon: 'ute-icon-bundles',
      identicalAs: ['Ignite NAC']
    }];
    function modifyMasterList(id, prop, val) {
      $.grep(masterList, function (serv, index) {
        if (serv.id === id) {
          serv[prop] = val;
        }
      });
    }

    if ($rootScope.isDealer || $rootScope.isCare) {
      for (var i = masterList.length - 1; i >= 0; i--) {
        if (masterList[i].id === 'Rogers Bank' || masterList[i].id === 'NHL (GCL)' || masterList[i].id === 'Add Individual Line') {
          masterList.splice(i, 1);
        } else if (masterList[i].id === 'Ignite NAC'){
          permissionsService.getRamPermission(
            ute.common.permissions.service.RamResourceCodes.Maestro_ExistingCX_IgniteBundleNAC,
            ute.common.permissions.service.RamActionCodes.grant)
            .then(function (repPermission) {
              if(!repPermission) {
                masterList.splice(i, 1);
              }
            })
        }
      }
    }

    return serviceInterface;

    function configureMasterList() {
      var i = 0, identicalIndex = 0, identicalItem, updatedItem = false;
      var item;

      if($rootScope.myServicesList){
        for(var j = 0;j<$rootScope.myServicesList.length;j++){
          if($rootScope.myServicesList[j].subType === "IPTV"){
            masterList.splice(10,1)
          }
        }
      }

      for (i; i < masterList.length; i++) {
        item = masterList[i];
        updatedItem = false;
        if (removalList.indexOf(item.id) < 0) {
          if(item.identicalAs && item.identicalAs.length > 0) {
            for(identicalIndex = 0; identicalIndex < item.identicalAs.length ; identicalIndex++) {
              identicalItem = _.find(masterList, {id: item.identicalAs[identicalIndex]});
              if(identicalItem && identicalItem.isVisible === true) {
                item.isVisible = false;
                updatedItem = true;
              }
            }
          }
          if(updatedItem === false) {
            item.isVisible = true;
          }
          isOtherServicesAvailable = true;
        } else {
          item.isVisible = false;
        }
      }
    }

    function addToRemovalList(item) {
      if (removalList.indexOf(item) === -1) {
        removalList.push(item);
      }
    }

    function resetRemovalList() {
      /// Creating external list
      var externalList = ['Shomi'];
      /// This is for checking the external list other than normal serv
      var intersectList = _.intersection(removalList, externalList);
      if (intersectList.length > 0) {
        removalList = intersectList;
      } else {
        removalList = [];
      }
    }

    function getMasterList() {
      return masterList;
    }

    function isOtherServicesAvailableFn() {
      return isOtherServicesAvailable;
    }

    function isIgniteComboAccount(val) {
      isIgniteCombo = val;
    }

    function openIgniteComboModal () {
      $modal.open({
        templateUrl: 'views/modals/eclipseMsgModal.html'

      });
    }
  }
}());

(function () {
  'use strict';

  angular.module('totesApp').controller('MyrMyServicesController', myServicesController);

  myServicesController.$inject = ['$scope',
    '$rootScope',
    '$window',
    'myrMyServicesService',
    'myrAccountListService',
    'appState',
    '$translate',
    'btnSettings',
    '$location',
    'localStorage',
    '$log',
    'sessionStorage',
    'ute.rogers.account.overview.factory',
    'ute.blocks.language.switcher',
    'ute.common.permissions.service'];

  /* @ngInject */
  function myServicesController($scope, // jshint ignore:line
                                $rootScope,
                                $window,
                                myrMyServicesService,
                                myrAccountListService,
                                appState,
                                $translate,
                                btnSettings,
                                $location,
                                localStorage,
                                $log,
                                sessionStorage,
                                accountOverviewFactory,
                                languageSwitcher,
                                permissionsService) {

    var vm = this; // jshint ignore:line

    $scope.acctListService = myrAccountListService;
    var accountOverviewService = accountOverviewFactory();

    var scopewatch1 = $scope.$watch(function () {
      return $scope.acctListService.selectedAccount && $scope.acctListService.selectedAccount.accountNumber;
    }, function (accountNumber) {
      if (accountNumber) {

        if (appState.usernameChanged) {
          myrMyServicesService.linkedMessageId = 'mu_msg_success';
          myrMyServicesService.updateMessage();
          myrMyServicesService.clearAccountDetails();
          appState.usernameChanged = false;
        }

        getAccountDetails();
      }
    });

    var runServiceHttpMethods = {
      'getRogersBankLang': function (url) {
        if (languageSwitcher.getCurrentLanguage() === 'fr') {
          return url + 'French';
        }
        return url + 'English';
      }
    };

    var runService = function (serviceName, value) {
      if (serviceName.substr(0, 4) === 'http') {
        window.open(runServiceHttpMethods[value](serviceName));
        return;
      }

      var userPath = myrMyServicesService.getServicePath(serviceName, value);

      if (userPath && appState.maintenanceRedirect(userPath)) {
        $location.path('/underMaintenance');
      } else {
        myrMyServicesService.runService(serviceName, value);
      }
    };

    vm.mss = myrMyServicesService;
    vm.isDealer = $rootScope.isDealer;
    vm.isCare = $rootScope.isCare;
    vm.runService = runService;
    vm.btnSettings = null;
    vm.btnStatus = null;
    vm.isSmartHomeMonitoring = false;
    vm.isRepView = $rootScope.isRepView;
    /* NPS-1725::Removed SGI from Consumer View and rogers.com */
    if (vm.isDealer || vm.isCare) {
      vm.btnSettings = btnSettings;
      // vm.btnStatus = btnStatus;
    }

    function tagSelectedAccount() {

      var _details = vm.mss.getSelectedAccountDetail();

      if (!_details) {
        return;
      }

      //get phone numbers
      var _phonesList = '';
      if (_details.phoneNumber) {
        for (var i = 0, l = _details.phoneNumber.length; i < l; i++) {
          _phonesList += _details.phoneNumber[i] + '|';
        }
      }
      _phonesList = _phonesList.substr(0, _phonesList.length - 1);
      try {
        appState.tagging(['_trackPageView',
          {pn: 'home:myrogers:overview'}, // Page Name
          {sACTT: _details.userType}, // Consumer, Business
          {sACSBTT: _details.userSubType}, // Prepaid, Regular
          {sBAN: _details.number}, //Account Number BAN, ex : '12345'
          {sCTN: _phonesList}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
          {sACSS: _details.status} // Active, Suspended:
        ]);
      } catch (e) {
        $log.error('Exception catch during tagging on pn=home:myrogers:overview with message:', e.message);
      }
    }

    function endLoadingData() {
      //broadcast event ended
      //$('#accountType').removeAttr('disabled');
      $scope.isSwitching = false;
      $rootScope.$broadcast('changedAccount');			// accountBalance.js - picks up on this call and initiates $scope.updateBalance ();
      $scope.loadingDataIndicator = false;
    }

    function startLoadingData() {
      $rootScope.$broadcast('startChangeAccount');
      //$('#accountType').prop('disabled', 'disabled');
    }

    function getAccountDetails() {

      var selectedAccount = myrAccountListService.selectedAccount;
      var language = languageSwitcher.getCurrentLanguage();

      //hide the previous account details
      startLoadingData();
      $rootScope.$broadcast('startChangeAccount');
      $scope.myOtherServicesListFinal = [];

      var cacheFailSafe = true;

      //selectedAccount.accountTypeNumber = null;//local test detail failing

      var request = {
        accountNumber: selectedAccount.accountNumber,
        accountTypeNumber: selectedAccount.accountTypeNumber,
        pinNumber: selectedAccount.pinNumber,
        phoneNumber: selectedAccount.phoneNumber,
        language: language,
        refresh: false,
        applicationId: 'Rogers.com'
      };
      if ($rootScope.isCare) {
        request.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      }

      vm.mss.clearAccountDetails();
      vm.mss.myServicesList = [];

      var accountDetailsResponse = function (_tmp) {

        var processDetailsResponse = function () {

          vm.mss.isDetailsNotFound = false;
          vm.mss.accountDetails = _tmp.data;
          $rootScope.ao.accountDetails = null;
          $rootScope.ao.accountDetails = vm.mss.accountDetails;
          var subscriptions;
          //Analytic tagging when select an account
          if (vm.mss.selectedAccount) {
            tagSelectedAccount();
          }

          if ($rootScope.isConsumer) {
            subscriptions = vm.mss.getSubscriptions(vm.mss.accountDetails.subList, false);
            $rootScope.myServicesList = vm.mss.myServicesList = subscriptions.myServices;
            console.log('dom services', $rootScope.myServicesList)
            $scope.myOtherServicesListFinal = subscriptions.myOtherServices;
          } else if ($rootScope.isCare || $rootScope.isDealer) {
            var disablePermissionNotGranted = [true,true,true,true];
            var badgePermission = ['Maestro_TV_Dashboard', 'Maestro_INT_Dashboard', 'Maestro_RHP_Dashboard','Maestro_SHM_Dashboard'];
            permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
              if (isPermitted) {
                if (!_.isArray(badgePermission)) {
                  badgePermission = [badgePermission];
                }
                badgePermission.forEach(function (permission,index) {
                  var uteCommonPermission = _.get(ute.common.permissions.service.RamResourceCodes, permission, permission);
                  permissionsService.getRamPermission(uteCommonPermission, ute.common.permissions.service.RamActionCodes.grant)
                    .then(function (repPermission) {
                      if (repPermission) {
                        disablePermissionNotGranted[index] = false;
                      } else {
                        disablePermissionNotGranted[index] = true;
                      }
                      subscriptions = vm.mss.getSubscriptions(vm.mss.accountDetails.subList, disablePermissionNotGranted);
                      $rootScope.myServicesList = vm.mss.myServicesList = subscriptions.myServices;
                      $scope.myOtherServicesListFinal = subscriptions.myOtherServices;
                    });
                });
              }
            });
          }

        };

        if (_tmp.result === 'success') {

          if (_tmp.data.cachedResultInfo) {
            if (_tmp.data.cachedResultInfo.expired === true && cacheFailSafe) {

              cacheFailSafe = false;
              request.refresh = true;

              var dataToProcess = JSON.parse(JSON.stringify(_tmp));
              vm.mss.storedSummary = JSON.parse(JSON.stringify(_tmp));

              processDetailsResponse(dataToProcess.data);
              vm.mss.getAccountDetails(request, accountDetailsResponse);
            }
          }

          if (!_tmp.data.cachedResultInfo || (_tmp.data.cachedResultInfo && !_tmp.data.cachedResultInfo.expired)) {

            //Account details updated and show them
            endLoadingData();
          }

          processDetailsResponse(_tmp.data);

        } else {
          // Unknown state ???
          endLoadingData();
          $scope.isDetailsNotFound = true;
        }
      };

      vm.mss.getAccountDetails(request, accountDetailsResponse);

    }

    var deregisterCheckCLM = $rootScope.$on('checkCLM', function (event, args) {
      if (myrAccountListService.selectedAccount && myrAccountListService.selectedAccount.accountStatus) {
        vm.btnSettings = btnSettings.getSettings(myrAccountListService.selectedAccount.accountStatus);
        vm.btnStatus = $window.btnStatus;
      }
    });

    var messageBoxDom = function () {
      vm.loginMessage = '<strong>' + $translate.instant('login_to') + ' ' + $translate.instant('sgi') + '</strong>';
    };

    function setBtnVars(account) {
      if (account && account.accountStatus) {
        vm.btnSettings = btnSettings.getSettings(account.accountStatus);
        vm.btnStatus = $window.btnStatus;
      }
      messageBoxDom();
    }

    accountOverviewService.getSelectedAccount()
      .then(function (account) {
        setBtnVars(account);
      });

    myrMyServicesService.successMsgIdFromStorage = localStorage.getLocalStorageValue('successMessage');

    if (myrMyServicesService.successMsgIdFromStorage) {
      localStorage.deleteLocalStorageValue('successMessage');
      if (!(!!myrMyServicesService.linkedMessageId)) {
        myrMyServicesService.updateSuccessMessage();
      }
    }

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      myrMyServicesService.updateMessage();
      myrMyServicesService.updateSuccessMessage();
      messageBoxDom();
    }, 'myServicesControllerLangSub');

    $scope.$on('$destroy', function () {
      deregisterCheckCLM();
      languageSwitcher.unregisterOnDataChangeHandler('myServicesControllerLangSub');
      scopewatch1(); //n
    });

    // User needs to link account
    if (appState.isLinked) {
      myrMyServicesService.linkedMessageId = 'linked_acc_success';
      myrMyServicesService.updateMessage();
      vm.mss.clearAccountDetails();

      //appState.isLinked = false;
    }

    $scope.$on('heroOfferInd', function(event, data) {
      if(data && data.targetedHeroOfferMap) {
        vm.mss.heroDetails = data.targetedHeroOfferMap;
      }
    });
  }

})();

(function () {
  'use strict';

  angular.module('totesApp').directive('myrMyServices', myServices);

  myServices.$inject = [];

  /* @ngInject */
  function myServices($log) {
    return {
      templateUrl: 'scripts/modules/myServices/myServices.html',
      restrict: 'EA',
      controller: 'MyrMyServicesController',
      controllerAs: 'ms',
      bindToController: true
    };

  }
})();

/* jshint -W040 */
(function (_) {
  'use strict';

  /**
   * @name totesApp.module:myrAccountListService
   * @description
   * # myrAccountListService
   */
  angular.module('totesApp').factory('myrMyServicesService', myrMyServicesService);

  myrMyServicesService.$inject = ['$rootScope',
    '$injector',
    '$window',
    'ute.blocks.language.switcher',
    'localStorage',
    '$state',
    'ajax',
    'appState',
    'myrAccountBalanceDataFactory',
    '$translate',
    'myrNotificationBannerService',
    'myrAccountListService',
    '$cookieStore',
    '$browser',
    'myrMyOtherServicesService',
    'sessionStorage',
    'ute.rogers.eclipse.remote.api.service',
    'cookieStore',
    'ute.data.manager.service',
    'ute.common.user.service',
    'ute.brite.bill.service',
    'ute.common.permissions.service',
  ];

  function myrMyServicesService($rootScope, // jshint ignore:line
                                $injector,
                                $window,
                                languageSwitcher,
                                localStorage,
                                $state,
                                ajax,
                                appState,
                                myrAccountBalanceDataFactory,
                                $translate,
                                notificationBannerService,
                                myrAccountListService,
                                $cookieStore,
                                $browser,
                                myrMyOtherServicesService,
                                sessionStorage,
                                eclipseRemoteApi,
                                cookieStore,
                                dataManagerService,
                                userService,
                                briteBillService,
                                permissionsService) {
    var service = {
      myServicesList: null,
      myOtherServicesListFinal: null,
      accountDetails: null,
      selectedAccountDetail: null,
      callingAccountDetails: false,
      isDetailsNotFound: true,
      storedSummary: null,
      loadingData: false,
      linkedMessageId: null,
      successMsgIdFromStorage: null,
      suspendedSubscriptionMessage: null,
      data: null,
      fdmAddListAmount: 0,
      fdmIndividualListAmount: 0,
      fdmResidentialListAmount: 0,
      fdmOtherListAmount: 0,
      categorizedServices: {
        individual: [],
        residential: [],
        otherServices: []
      },
      isRHPMigratedFlow: null,

      clearAccountDetails: clearAccountDetails,
      getAccountDetails: getAccountDetails,
      getSelectedAccountDetail: getSelectedAccountDetail,
      getSubscriptions: getSubscriptions,
      getCancelledSubscriptions: getCancelledSubscriptions,
      runService: runService,
      getServicePath: getServicePath,
      resetCallingAccountDetails: resetCallingAccountDetails,
      updateMessage: updateMessage,
      updateSuccessMessage: updateSuccessMessage,
      getErrorLoading: getErrorLoading,
      isOtherServicesAvailable: false,
      registerUpdateCallback: registerUpdateCallback
    };

    var updateCallback, subscriptionList;
    var errorLoading = false;
    var apiErrorResponse = {
      API: '',
      errorCode: undefined
    };
    return service;

    function registerUpdateCallback(callback) {
      updateCallback = callback;
    }

    ///////////////////////////////////////////////////////////////
    function resetCallingAccountDetails() {
      service.callingAccountDetails = false;
    }

    function runService(serviceName, value) {
      var accountNumber, subNumber;
      if(service.isRHPMigratedFlow == null) {
        service.isRHPMigratedFlow = userService.getPersistentService().get('rhpMigratedSwitch');
      }
      if ($rootScope.isCare) {
        accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      } else {
        accountNumber = localStorage.getLocalStorageValue('accountNumber');
      }
      for (var i = 0; i < subscriptionList.length; i++) {
        if (subscriptionList[i].subAccountId === value) {
          subNumber = subscriptionList[i].subNumber;
        }
      }
      switch (serviceName) {
        case 'wireless':
        case 'wirelessPrepaid':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('phoneNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('phoneNumber', value);
          // }
          setStorage('phoneNumber', value);
          break;
        case 'shareEverything':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('phoneNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('phoneNumber', value);
          // }
          setStorage('phoneNumber', value);
          /*getting index of the shared wireless CTN*/
          var dmBadgeList = dataManagerService.getBadgeList().subscriberList;
          var index = 0;
          for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
            if (value === dmBadgeList[iSELine].ctn) {
              index = iSELine;
              break;
            }
          }
          dataManagerService.setActiveTabIndex(index);
          dataManagerService.goToSubModule(dataManagerService.getConfig().advanced.enterDataManager.subState);
          return;
        case 'shmdashboard':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('shmAccountNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('shmAccountNumber', value);
          // }
          setStorage('shmAccountNumber', value);
          break;
        case 'internetdash':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('internetAccountNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('internetAccountNumber', value);
          // }
          setStorage('internetAccountNumber', value);
          break;
        case 'tvdashboard':
          // if ($rootScope.isCare) {
          //   sessionStorage.setSessionStorageValue('tvAccountNumber', value);
          // } else {
          //   localStorage.setLocalStorageValue('tvAccountNumber', value);
          // }
          setStorage('tvAccountNumber', value);
          break;
//        case 'homephone':
//          if ($rootScope.isDealer || $rootScope.isCare) {
//            return;
//          } else {
//            var urlHomePhone = '/web/myrogers/data/homePhonePackages/redesignHomePhone/' + value + '?setLanguage=' + languageSwitcher.getCurrentLanguage();
//            $window.location.href = urlHomePhone;
//            return;
//          }
//          break;
        case 'homephone':
          if ($rootScope.isDealer || ($rootScope.isCare && service.isRHPMigratedFlow === 'false')) {
            return;
          } else if(service.isRHPMigratedFlow === 'true') {
              for (var i = 0; i < subscriptionList.length; i++) {
                if (subscriptionList[i].subNumber === value) {
                  setStorage('homePhoneAccountNumber', subscriptionList[i].subAccountId);
                  //break;
                }
              }
            setStorage('homePhoneNumber', value); //homePhoneNumber is Home Phone Number
          } else {
            var urlHomePhone = '/web/myrogers/data/homePhonePackages/redesignHomePhone/' + value + '?setLanguage=' + languageSwitcher.getCurrentLanguage();
            $window.location.href = urlHomePhone;
            return;
          }
          break;
        case 'IPTV':
          eclipseRemoteApi.goToIPTVDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com',
            redirectTo: {
              protocol: window.location.protocol,
              host: window.location.hostname,
              port: window.location.port,
              path: window.location.pathname,
              hash: window.location.hash,
              href: window.location.href
            }
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
            userType: userService.getUserType(),
            province: cookieStore.get('province').toLowerCase() // pull from usersService
          });
          return;
          break;
        case 'HSI':
          eclipseRemoteApi.goToHSIDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com',
            redirectTo: {
              protocol: window.location.protocol,
              host: window.location.hostname,
              port: window.location.port,
              path: window.location.pathname,
              hash: window.location.hash,
              href: window.location.href
            }
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
            userType: userService.getUserType(),
            province: cookieStore.get('province').toLowerCase() // pull from usersService
          });
          return;
          break;
        case 'RHP Phone Line':
          eclipseRemoteApi.goToRHPDashboard({
            accountNumber: accountNumber,
            subAccountId: value,
            subscriptionId: subNumber,
            source: 'rogers.com',
            redirectTo: {
              protocol: window.location.protocol,
              host: window.location.hostname,
              port: window.location.port,
              path: window.location.pathname,
              hash: window.location.hash,
              href: window.location.href
            }
          }, {
            lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
            userType: userService.getUserType(),
            province: cookieStore.get('province').toLowerCase() // pull from usersService
          });
          return;
          break;
      }

      if (serviceName === $state.current.name) {
        $state.reload();
        return;
      } else if(serviceName === 'homephone' ) {
        $state.go('rhpdashboard');
        return;
      }

      $state.go(serviceName);
    }

    function setStorage(key, value) {
      if ($rootScope.isCare) {
        sessionStorage.setSessionStorageValue(key, value);
      } else {
        localStorage.setLocalStorageValue(key, value);
      }
    }

    function getServicePath(serviceName, value) {
      var path = '';
      switch (serviceName) {
        case 'wireless':
        case 'shareEverything':
          path = '/wireless';
          break;
        case 'wirelessPrepaid':
          path = '/wirelessPrepaid';
          break;
        case 'shmdashboard':
          path = '/shmdashboard';
          break;
        case 'internetdash':
          path = '/internetdash';
          break;
        case 'tvdashboard':
          path = '/tvdashboard';
          break;
        case 'suspended':
          path = '/suspended';
          break;
        case 'homephone':
          if ($rootScope.isDealer || ($rootScope.isCare && service.isRHPMigratedFlow === 'false')) {
            path = undefined;
          } else if(service.isRHPMigratedFlow === 'true') {
            path = '/rhpdashboard'
          } else {
            path = '/web/myrogers/data/homePhonePackages/redesignHomePhone/' + value + '?setLanguage=' + languageSwitcher.getCurrentLanguage();
          }
          break;
      }
      if (path !== undefined) {
        return (path);
      }
    }

    function clearAccountDetails() {
      // Purge any data
      this.accountDetails = null;
      return true;
    }

    function getSelectedAccountDetail() {
      //wrap account details for selected account, handle account variety.
      if (service.selectedAccountDetail) {
        if (service.selectedAccountDetail.accountBalance !== {}) {
          service.selectedAccountDetail.accountBalance = myrAccountBalanceDataFactory.accountBalance;
        }

        return service.selectedAccountDetail;
      }
      if (!$rootScope.ao.accountDetails) {
        return;
      }

      var _rtn;
      var _selectedAccount = $rootScope.ao.accountDetails;
      var accountList = $rootScope.ao.raw.accountList;

      if (_selectedAccount) {
        var _detail = _selectedAccount;
        var _info = _detail.accountInfo;
        var _subList = _detail.subList;
        var isCreditCardHolder = _.find(accountList, {accountNumber: _selectedAccount.accountNumber}).isCreditCardHolder;

        _rtn = {
          number: _detail.accountNumber,
          billableAccountNumber: _detail.billableAccountNumber,
          type: _detail.accountType,
          status: _info.status,
          get nickName() {
            return myrAccountListService.selectedAccount ? myrAccountListService.selectedAccount.nickname : '';
          }, //to be removed
          name: _detail.accountName.firstName,
          accountBalance: myrAccountBalanceDataFactory.accountBalance,
          isPrepaid: _detail.accountType === 9,
          isWireless: _detail.accountType === 1,
          isMastro: _detail.accountType === 30,
          isCable: _detail.accountType === 6,
          isConsolidated: _detail.isConsolidated,
          isViewBillDisplay: (($rootScope.isDealer || $rootScope.isCare) && (briteBillService.getIsbritebillAvailable(_detail.accountNumber) && (_detail.accountType !== 9))),
          isCreditCardHolder: isCreditCardHolder,
          //optional data
          balance: '',
          dueDate: '',
          dateDelimiter: '',
          due: '',
          dateOrder: [],
          dateYearPrefix: '',
          paymentMethod: '',
          userType: '',
          userSubType: '',
          phoneNumber: '',
          contactId: '',
          nextBillingDate: _detail.nextBillingDate
        };

        if (($rootScope.isDealer || $rootScope.isCare) && _detail.accountType !== 9) {
          briteBillService.getBills(_detail.accountNumber).then(function (bills) {
            _rtn.isViewBillDisplay = bills.length > 0;
          });
        }

        if (myrAccountBalanceDataFactory.accountBalance) {
          _rtn.balance = myrAccountBalanceDataFactory.accountBalance.balanceAmount || '';
          _rtn.dueDate = myrAccountBalanceDataFactory.accountBalance.billDueDate || '';
        }

        if (_rtn.isPrepaid) {
          _rtn.due = $rootScope.ao.accountDetails.accountInfo.expiryDate;
          _rtn.dateDelimiter = ' ';
          _rtn.dateOrder = [0, 1, 2];
          _rtn.dateYearPrefix = '';
        } else {
          _rtn.due = myrAccountBalanceDataFactory.accountBalance ? myrAccountBalanceDataFactory.accountBalance.billDueDate : '';
          _rtn.dateDelimiter = '-';
          _rtn.dateOrder = [1, 0, 2];
          _rtn.dateYearPrefix = '20';
        }

        //get phone numbers
        var _list = $(_subList).map(function (k, v) {
          // if (v.subAccountId === _rtn.number) {

          if (v.subContactList && v.subContactList[0]) {
            _rtn.contactId = v.subContactList[0].contactId;
          }
          // }

          if (v.subType === 'CTN') {
            return v.subNumber;
          }
        }).get();

        _rtn.phoneNumber = _list[0];

        if (_rtn.phoneNumber !== undefined) {
          localStorage.setLocalStorageValue('firstCTN', _rtn.phoneNumber);
          localStorage.setLocalStorageValue('phoneNumber', _rtn.phoneNumber);
        }

        //Wireless account
        if (_rtn.isWireless) {
          _rtn.userType = _info.accType;
          _rtn.userSubType = _info.accSubType;
        }

        //post-paid account get payment method
        if (!_rtn.isPrepaid && myrAccountBalanceDataFactory.accountBalance !== undefined && myrAccountBalanceDataFactory.accountBalance) {
          //post-paid account
          _rtn.paymentMethod = myrAccountBalanceDataFactory.accountBalance.methodOfPayment ? myrAccountBalanceDataFactory.accountBalance.methodOfPayment.mopType : 'R';
        }
      }

      service.selectedAccountDetail = _rtn;

      return service.selectedAccountDetail;
    }

    function cleanFirstName(firstname) {
      if (angular.isUndefined(firstname) || firstname === null || firstname.trim() === '') {
        return '';
      } else if (firstname.length > 10) {
        return firstname.substr(0, 9);
      } else {
        return firstname;
      }
    }

    function populateServicesDataModel() {
      // myServicesList
      service.categorizedServices.individual.length = 0;
      service.categorizedServices.residential.length = 0;
      service.categorizedServices.otherServices.length = 0;

      _.forEach(service.myServicesList, function (item) {
        if (item.subType === 'CTN') {
          service.categorizedServices.individual.push(item);
        } else if (item.subType === 'Digital TV' ||
          item.subType === 'RHPc' ||
          item.subType === 'Hi-Speed Internet' ||
          item.subType === 'Rogers Smart Home Monitoring' ||
          item.subType === 'HSI' ||
          item.subType === 'IPTV' ||
          item.subType === 'RHP Phone Line'
        ) {
          service.categorizedServices.residential.push(item);
        } else if (item.subType === 'Rogers Bank') {
          service.categorizedServices.otherServices.push(item);
        }
      });

      service.fdmIndividualListAmount = service.categorizedServices.individual.length;
      service.fdmResidentialListAmount = service.categorizedServices.residential.length;
      service.fdmOtherListAmount = service.categorizedServices.otherServices.length;
    }

    function getSubscriptions(subList, disablePermissionNotGranted) {
      if (!subList) {
        return;
      }

      myrMyOtherServicesService.resetRemovalList();

      if ($rootScope.isCare) {
        myrMyOtherServicesService.isIgniteComboAccount(false);
      } else if ($rootScope.isDealer) {
        myrMyOtherServicesService.isIgniteComboAccount(true);
      }

      var myServicesList = [], serviceAddress;
      subscriptionList = subList;
      var _details = service.getSelectedAccountDetail();
      var isPrepaid = (_details && _details.isPrepaid) ? _details.isPrepaid : false;

      for (var i = 0; i < subList.length; i++) {
        var subscription = subList[i],
          _sub = {
            status: ''
          };
        _sub.serviceDetail = subscription.subNumber;
        if ($rootScope.isCare) {
          _sub.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
        } else {
          _sub.accountNumber = localStorage.getLocalStorageValue('accountNumber');
        }
        _sub.showPhone = subscription.subType.toLowerCase() === 'ctn' || subscription.subType.toLowerCase() === 'rhpc' || subscription.subType.toLowerCase() === 'RHP Phone Line';//show phone number for wireless/home phone

        if (subscription && subscription.subAddress) {

          serviceAddress = !_.isEmpty(subscription.subAddress.unit) ? subscription.subAddress.unit + '-' : subscription.subAddress.unit;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetNumber) ? serviceAddress + subscription.subAddress.streetNumber + ' ' : serviceAddress + subscription.subAddress.streetNumber;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetName) ? serviceAddress + subscription.subAddress.streetName + ' ' : serviceAddress + subscription.subAddress.streetName;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetNameSuffix) ? serviceAddress + subscription.subAddress.streetNameSuffix + ' ' : serviceAddress + subscription.subAddress.streetNameSuffix;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.streetType + ', ' : serviceAddress + subscription.subAddress.streetType;
          serviceAddress = serviceAddress + subscription.subAddress.city;
          serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceAddress = '';
        } else {
          serviceAddress = '';
        }

        if (subscription && subscription.hasOwnProperty('subStatus')) {
          _sub.status = subscription.subStatus
        }

        if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.plan = 'Digital';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted[0];
          _sub.sortOrder = 2;
          console.log('dom in iptv',subscription)
          _sub.type = subscription.subscriptionSubType === 'T' ? ute.common.subscriptionBadge.BadgeTypes.smartStream : ute.common.subscriptionBadge.BadgeTypes.igniteTv;
          _sub.subType = 'IPTV';
          _sub.serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceName = 'IPTV';
          _sub.serviceDetail = subscription.subAccountId;
          _sub.resolve = function (subItem) {
            return {
              goIPTV: function () {
                eclipseRemoteApi.goToIPTVDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });

              }
            };
          }
        }

        if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.type = ute.common.subscriptionBadge.BadgeTypes.igniteInternet;
          _sub.plan = 'Ignite';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted[1];
          _sub.sortOrder = 3;

          _sub.subType = 'HSI';
          _sub.serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceType = 'service_internet';
          _sub.serviceName = 'HSI';
          _sub.serviceDetail = subscription.subAccountId;
          _sub.resolve = function (subItem) {
            return {
              goHSI: function () {
                eclipseRemoteApi.goToHSIDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });
              }
            };
          }
        }
        if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {

          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.type = ute.common.subscriptionBadge.BadgeTypes.homePhone;
          _sub.plan = 'Ignite';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted[2];
          _sub.phoneNumber = subscription.subNumber;
          _sub.sortOrder = 4;

          _sub.subType = 'RHP Phone Line';
          _sub.serviceType = 'service_phone';
          _sub.serviceName = 'RHP Phone Line';
          _sub.serviceDetail = subscription.subAccountId;
          _sub.resolve = function (subItem) {
            return {
              goRHP: function () {
                eclipseRemoteApi.goToRHPDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });
              }
            };
          };
        }

        if (subscription.subType === 'CTN') {
          _sub.subType = 'CTN';
          _sub.serviceType = isPrepaid ? 'service_wireless_prepaid' : 'service_wireless';
          _sub.icon = 'rui-icon-wireless';
          _sub.linkText = '_manage';
          _sub.linkURL = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.paramName = 'phoneNumber';
          _sub.serviceName = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.firstName = subscription.firstname || '';
          _sub.lastName = subscription.lastname || '';
          _sub.menuFirstName = cleanFirstName(subscription.firstname);
          _sub.firstNameLength = _sub.firstName.length;
          _sub.isCTN = true;
          _sub.sortOrder = 1;
          _sub.subStatus = subscription.subStatus;
          /*Check for share Everything CTN*/
          if (($rootScope.isDealer || $rootScope.isCare) && dataManagerService.getBRT()) {
            if (subscription.shareEverything) {
              if (subscription.shareEverything.isSharingData) {
                _sub.serviceName = 'shareEverything';
              }
            }
          }
        }

        if (subscription.subType === 'Hi-Speed Internet') {
          _sub.subType = 'Hi-Speed Internet';
          _sub.serviceType = 'service_internet';
          _sub.icon = 'rui-icon-internet';
          _sub.linkText = '_manage';
          _sub.linkURL = 'internetdash';
          _sub.serviceDetail = subscription.subAccountId;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'internetdash';
          _sub.isCTN = false;
          _sub.sortOrder = 6;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.subType === 'Digital TV') {
          console.log('dom dtv',subscription)
          // if(subscription.subscriptionSubType === "T"){
            // console.log('dom tupelo',subscription)
            // _sub.subType = 'Tupelo';
            // _sub.serviceType = 'service_tupelo';
            // _sub.icon = 'rui-icon-tv';
            // _sub.linkText = '_manage';
            // _sub.linkURL = 'tvdashboard';
            // _sub.serviceDetail = subscription.subAccountId;
            // _sub.paramName = 'accountNumber';
            // _sub.serviceName = 'tvdashboard';
            // _sub.isCTN = false;
            // _sub.sortOrder = 5;
            // _sub.serviceAddress = serviceAddress.toLowerCase();
            _sub.subType = 'Digital TV';
            _sub.serviceType = 'service_tv';
            _sub.icon = 'rui-icon-tv';
            _sub.linkText = '_manage';
            _sub.linkURL = 'tvdashboard';
            _sub.serviceDetail = subscription.subAccountId;
            _sub.paramName = 'accountNumber';
            _sub.serviceName = 'tvdashboard';
            _sub.isCTN = false;
            _sub.sortOrder = 5;
            _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.subType === 'Rogers Smart Home Monitoring') {
          // _sub.serviceDetail = $translate.instant('myaccoverview_home_monotoring');
          //_sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended';
          _sub.subType = 'Rogers Smart Home Monitoring';
          _sub.serviceType = 'myaccoverview_home_monotoring';
          _sub.icon = 'rui-icon-home-security';
          _sub.linkText = '_manage';
          _sub.linkURL = 'shmdashboard';
          //_sub.serviceDetail = subscription.subAccountId;
          _sub.serviceDetail = subscription.serviceNumber;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'shmdashboard';
          _sub.disabled = _sub.serviceName && (disablePermissionNotGranted[3] || subscription.subStatus == 'Suspended');
          _sub.isCTN = false;
          _sub.sortOrder = 8;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.subType === 'RHPc') {
          _sub.subType = 'RHPc';
          _sub.serviceType = 'service_phone';
          _sub.icon = 'rui-icon-home-phone';
          _sub.linkText = '_manage';
          _sub.linkURL = 'rhpdashboard';
          _sub.subAccountId = subscription.subAccountId;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'homephone';
          _sub.isCTN = false;
          _sub.sortOrder = 7;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.subStatus === 'Suspended') {
          _sub.serviceName = 'suspended';
          _sub.isCTN = false;
          _sub.sortOrder = 9;
        }

        myServicesList.push(_.cloneDeep(_sub));
        if (eclipseRemoteApi.isEclipseInternetSubscription(subscription) ||
          eclipseRemoteApi.isEclipseTvSubscription(subscription) ||
          eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
          myrMyOtherServicesService.addToRemovalList('Ignite Combo');
          myrMyOtherServicesService.addToRemovalList(_sub.subType);
          if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('Hi-Speed Internet');
          } else if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('Digital TV');
          } else if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('RHPc');
          }
        } else {
          myrMyOtherServicesService.addToRemovalList(_sub.subType);
          if (subscription.subType === 'Hi-Speed Internet') {
            myrMyOtherServicesService.addToRemovalList('HSI');
          } else if (subscription.subType === 'Digital TV') {
            myrMyOtherServicesService.addToRemovalList('IPTV');
          } else if (subscription.subType === 'RHPc') {
            myrMyOtherServicesService.addToRemovalList('RHP Phone Line');
          }
        }
      }

      if (_details && _details.isCreditCardHolder) {
        var bankLink = 'https://rbaccess.rogersbank.com/Rogers_Consumer/ChangeLanguage.do?localeID=';
        var creditCardService = {
          subType: 'Rogers Bank',
          serviceType: 'rogers_credit_card',
          serviceName: bankLink,
          serviceDetail: 'getRogersBankLang',
          imageIcon: 'rogers-bank'
        };

        myServicesList.push(creditCardService);
        myrMyOtherServicesService.addToRemovalList(creditCardService.subType);
      }

      this.myServicesList = myServicesList;
      notifySubs();
      populateServicesDataModel(); // in this point for sure we have myServicesList

      /*$injector.get('ute.common.permissions.service').getUserPermission('SEE_UTE_PAGE_VIEW')
        .then(function (isPermitted) {
          var $cookies = $injector.get('$cookies');
          if (!isPermitted && ($cookies.SM_USER || ($cookies.SMSESSION && $cookies.SMSESSION !== 'LOGGEDOFF')) || (myrAccountListService.selectedAccount && myrAccountListService.selectedAccount.accountStatus && myrAccountListService.selectedAccount.accountStatus.toLowerCase() != 'active')) {
            myrMyOtherServicesService.addToRemovalList('Add Individual Line');
          }
        })*/
        //.finally(function () {
      myrMyOtherServicesService.configureMasterList();
      service.myOtherServicesListFinal = myrMyOtherServicesService.getMasterList();
      service.isOtherServicesAvailable = myrMyOtherServicesService.isOtherServicesAvailable();
       // });

      /* // other services list require for one view operations.
       var myOtherServicesOneViewListFinal = [];

       for (var y = 0; y < myOtherServicesListMaster.length; y++) {
       if (myOtherServicesList.indexOf(myOtherServicesListMaster[y].id) < 0) {
       myOtherServicesListMaster[y].isVisible = true;
       myOtherServicesOneViewListFinal.push(myOtherServicesListMaster[y]);
       }
       }*/

      return {
        myServices: myServicesList,
        myOtherServices: myrMyOtherServicesService.getMasterList()
      };
    }
/**my function ends here */
    function getCancelledSubscriptions(subList, disablePermissionNotGranted) {
      if (!subList) {
        return;
      }

      myrMyOtherServicesService.resetRemovalList();

      if ($rootScope.isCare) {
        myrMyOtherServicesService.isIgniteComboAccount(false);
      } else if ($rootScope.isDealer) {
        myrMyOtherServicesService.isIgniteComboAccount(true);
      }

      var myServicesList = [], serviceAddress;
      subscriptionList = subList;
      var _details = service.getSelectedAccountDetail();
      var isPrepaid = (_details && _details.isPrepaid) ? _details.isPrepaid : false;

      for (var i = 0; i < subList.length; i++) {
        var subscription = subList[i],
          _sub = {};
        _sub.serviceDetail = subscription.subscriptionNo;
        if ($rootScope.isCare) {
          _sub.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
        } else {
          _sub.accountNumber = localStorage.getLocalStorageValue('accountNumber');
        }
        _sub.showPhone = subscription.type.toLowerCase() === 'ctn' || subscription.type.toLowerCase() === 'rhpc' || subscription.type.toLowerCase() === 'RHP Phone Line';//show phone number for wireless/home phone

        if (subscription && subscription.subAddress) {

          serviceAddress = !_.isEmpty(subscription.subAddress.unit) ? subscription.subAddress.unit + '-' : subscription.subAddress.unit;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetNumber) ? serviceAddress + subscription.subAddress.streetNumber + ' ' : serviceAddress + subscription.subAddress.streetNumber;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetName) ? serviceAddress + subscription.subAddress.streetName + ' ' : serviceAddress + subscription.subAddress.streetName;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetNameSuffix) ? serviceAddress + subscription.subAddress.streetNameSuffix + ' ' : serviceAddress + subscription.subAddress.streetNameSuffix;
          serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.streetType + ', ' : serviceAddress + subscription.subAddress.streetType;
          serviceAddress = serviceAddress + subscription.subAddress.city;
          serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceAddress = '';
        } else {
          serviceAddress = '';
        }
        if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.type = ute.common.subscriptionBadge.BadgeTypes.igniteTv;
          _sub.plan = 'Digital';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted;
          _sub.sortOrder = 2;

          _sub.subType = 'IPTV';
          _sub.serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceType = 'service_tv';
          _sub.serviceName = 'IPTV';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.resolve = function (subItem) {
            return {
              goIPTV: function () {
                eclipseRemoteApi.goToIPTVDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersServiceg
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });

              }
            };
          }
        }

        if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.type = ute.common.subscriptionBadge.BadgeTypes.igniteInternet;
          _sub.plan = 'Ignite';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted;
          _sub.sortOrder = 3;

          _sub.subType = 'HSI';
          _sub.serviceAddress = serviceAddress.toLowerCase();
          _sub.serviceType = 'service_internet';
          _sub.serviceName = 'HSI';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.resolve = function (subItem) {
            return {
              goHSI: function () {
                eclipseRemoteApi.goToHSIDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });
              }
            };
          }
        }
        if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {

          _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
          _sub.type = ute.common.subscriptionBadge.BadgeTypes.homePhone;
          _sub.plan = 'Ignite';
          _sub.subAccountId = subscription.subAccountId;
          _sub.subNumber = subscription.subNumber;
          _sub.disabled = disablePermissionNotGranted;
          _sub.phoneNumber = subscription.subNumber;
          _sub.sortOrder = 4;

          _sub.subType = 'RHP Phone Line';
          _sub.serviceType = 'service_phone';
          _sub.serviceName = 'RHP Phone Line';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.resolve = function (subItem) {
            return {
              goRHP: function () {
                eclipseRemoteApi.goToRHPDashboard({
                  accountNumber: subItem.accountNumber,
                  subAccountId: subItem.subAccountId,
                  subscriptionId: subItem.subNumber,
                  source: 'rogers.com',
                  redirectTo: {
                    protocol: window.location.protocol,
                    host: window.location.hostname,
                    port: window.location.port,
                    path: window.location.pathname,
                    hash: window.location.hash,
                    href: window.location.href
                  }
                }, {
                  lang: languageSwitcher.getCurrentLanguage(), // pull from usersService
                  userType: userService.getUserType(),
                  province: cookieStore.get('province').toLowerCase() // pull from usersService
                });
              }
            };
          };
        }

        if (subscription.type === 'CTN') {

          if ($rootScope.isCare && (subscription.status === 'Reserved')) {
            _sub.status = 'Reserved';
          }

          _sub.subType = 'CTN';
          _sub.serviceType = isPrepaid ? 'service_wireless_prepaid' : 'service_wireless';
          _sub.icon = 'rui-icon-wireless';
          _sub.linkText = '_manage';
          _sub.linkURL = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.paramName = 'phoneNumber';
          _sub.serviceName = isPrepaid ? 'wirelessPrepaid' : 'wireless';
          _sub.firstName = subscription.firstname || '';
          _sub.lastName = subscription.lastname || '';
          _sub.menuFirstName = cleanFirstName(subscription.firstname);
          _sub.firstNameLength = _sub.firstName.length;
          _sub.isCTN = true;
          _sub.sortOrder = 1;
          /*Check for share Everything CTN*/
          if (($rootScope.isDealer || $rootScope.isCare) && dataManagerService.getBRT()) {
            if (subscription.shareEverything) {
              if (subscription.shareEverything.isSharingData) {
                _sub.serviceName = 'shareEverything';
              }
            }
          }
        }

        if (subscription.type === 'Hi-Speed Internet') {
          _sub.subType = 'Hi-Speed Internet';
          _sub.serviceType = 'service_internet';
          _sub.icon = 'rui-icon-internet';
          _sub.linkText = '_manage';
          _sub.linkURL = 'internetdash';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'internetdash';
          _sub.isCTN = false;
          _sub.sortOrder = 6;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.type === 'Digital TV' || subscription.type === 'TV' || subscription.type === 'HDTV') {
          _sub.subType = 'Digital TV';
          _sub.serviceType = 'service_tv';
          _sub.icon = 'rui-icon-tv';
          _sub.linkText = '_manage';
          _sub.linkURL = 'tvdashboard';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'tvdashboard';
          _sub.isCTN = false;
          _sub.sortOrder = 5;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.type === 'Rogers Smart Home Monitoring') {
          // _sub.serviceDetail = $translate.instant('myaccoverview_home_monotoring');
          _sub.subType = 'Rogers Smart Home Monitoring';
          _sub.serviceType = 'myaccoverview_home_monotoring';
          _sub.icon = 'rui-icon-home-security';
          _sub.linkText = '_manage';
          _sub.linkURL = 'shmdashboard';
          //_sub.serviceDetail = subscription.subAccountId;
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'shmdashboard';
          _sub.isCTN = false;
          _sub.sortOrder = 8;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.type === 'RHPc') {
          _sub.subType = 'RHPc';
          _sub.serviceType = 'service_phone';
          _sub.icon = 'rui-icon-home-phone';
          _sub.linkText = '_manage';
          _sub.linkURL = 'rhpdashboard';
          _sub.serviceDetail = subscription.subscriptionNo;
          _sub.paramName = 'accountNumber';
          _sub.serviceName = 'homephone';
          _sub.isCTN = false;
          _sub.sortOrder = 7;
          _sub.serviceAddress = serviceAddress.toLowerCase();
        }

        if (subscription.subStatus === 'Suspended') {
          _sub.serviceName = 'suspended';
          _sub.isCTN = false;
          _sub.sortOrder = 9;
        }
        /*
        var dateNow = new Date();
        var disconnectDate = '';
        var month = '';
        if(subscription.status !== 'Active' && subscription.disconnectDate) {
          disconnectDate = new Date(subscription.disconnectDate.year,
          subscription.disconnectDate.month,
          subscription.disconnectDate.day,
          subscription.disconnectDate.hour,
          subscription.disconnectDate.minute,
          subscription.disconnectDate.second);
          month = dateNow.getMonth() - disconnectDate.getMonth() + (12 * (dateNow.getFullYear() - disconnectDate.getFullYear()));
        }
        */
        if (subscription.status !== 'Active' && "serviceName" in _sub) {
          _sub.status = subscription.status;
          myServicesList.push(_.cloneDeep(_sub));
        }

        if (eclipseRemoteApi.isEclipseInternetSubscription(subscription) ||
          eclipseRemoteApi.isEclipseTvSubscription(subscription) ||
          eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
          myrMyOtherServicesService.addToRemovalList('Ignite Combo');
          myrMyOtherServicesService.addToRemovalList(_sub.subType);
          if (eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('Hi-Speed Internet');
          } else if (eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('Digital TV');
          } else if (eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
            myrMyOtherServicesService.addToRemovalList('RHPc');
          }
        } else {
          myrMyOtherServicesService.addToRemovalList(_sub.subType);
          if (subscription.subType === 'Hi-Speed Internet') {
            myrMyOtherServicesService.addToRemovalList('HSI');
          } else if (subscription.subType === 'Digital TV') {
            myrMyOtherServicesService.addToRemovalList('IPTV');
          } else if (subscription.subType === 'RHPc') {
            myrMyOtherServicesService.addToRemovalList('RHP Phone Line');
          }
        }
      }

      if (_details.isCreditCardHolder) {
        var bankLink = 'https://rbaccess.rogersbank.com/Rogers_Consumer/ChangeLanguage.do?localeID=';
        var creditCardService = {
          subType: 'Rogers Bank',
          serviceType: 'rogers_credit_card',
          serviceName: bankLink,
          serviceDetail: 'getRogersBankLang',
          imageIcon: 'rogers-bank'
        };

        myServicesList.push(creditCardService);
        myrMyOtherServicesService.addToRemovalList(creditCardService.subType);
      }

      this.myServicesList = myServicesList;
      notifySubs();
      populateServicesDataModel(); // in this point for sure we have myServicesList

      /*$injector.get('ute.common.permissions.service').getUserPermission('SEE_UTE_PAGE_VIEW')
        .then(function (isPermitted) {
          var $cookies = $injector.get('$cookies');
          if (!isPermitted && ($cookies.SM_USER || ($cookies.SMSESSION && $cookies.SMSESSION !== 'LOGGEDOFF')) || (myrAccountListService.selectedAccount && myrAccountListService.selectedAccount.accountStatus && myrAccountListService.selectedAccount.accountStatus.toLowerCase() != 'active')) {
            myrMyOtherServicesService.addToRemovalList('Add Individual Line');
          }
        })*/
        //.finally(function () {
      myrMyOtherServicesService.configureMasterList();
      service.myOtherServicesListFinal = myrMyOtherServicesService.getMasterList();
      service.isOtherServicesAvailable = myrMyOtherServicesService.isOtherServicesAvailable();
      // });

      /* // other services list require for one view operations.
       var myOtherServicesOneViewListFinal = [];

       for (var y = 0; y < myOtherServicesListMaster.length; y++) {
       if (myOtherServicesList.indexOf(myOtherServicesListMaster[y].id) < 0) {
       myOtherServicesListMaster[y].isVisible = true;
       myOtherServicesOneViewListFinal.push(myOtherServicesListMaster[y]);
       }
       }*/

      return {
        myServices: myServicesList,
        myOtherServices: myrMyOtherServicesService.getMasterList()
      };
    }

    function updateMessage() {
      var xx, unit;

      if (service.myOtherServicesListFinal) {
        for (xx = 0; xx < service.myOtherServicesListFinal.length; xx++) {
          unit = service.myOtherServicesListFinal[xx];
          if (unit.updateRogersBank) {
            unit.link = ' https://www.rogersbank.com/' + languageSwitcher.getCurrentLanguage();
          }
        }
      }
      if (service.myOtherServicesListFinal) {
        for (xx = 0; xx < service.myOtherServicesListFinal.length; xx++) {
          unit = service.myOtherServicesListFinal[xx];
          if (unit.updategamecentrelive) {
            unit.link = ' https://gamecentrelive.rogers.com/' + languageSwitcher.getCurrentLanguage();
          }
        }
      }

      if (!!service.linkedMessageId) {
        notificationBannerService.sendMessageKey('linkedMessage', service.linkedMessageId);
      }

      service.suspendedSubscriptionMessage = $translate.instant('_suspended_service');
    }

    function updateSuccessMessage() {
      if (!service.successMsgIdFromStorage) {
        notificationBannerService.cleanBanner('successMessage');
      } else {
        notificationBannerService.sendMessageKey('successMessage', service.successMsgIdFromStorage);
      }
    }

    function getAccountDetails(request, callback) {
      if ($rootScope.ao.accountDetails &&
        $rootScope.ao.accountDetails.accountNumber === request.accountNumber && !request.refresh) {
        processDetails($rootScope.ao.accountDetails);
        return;
      }

      var call = ajax.getAccountDetail;
      if (request.accountTypeNumber === 9) {
        call = ajax.getAccountDetailPrepaid;
      }

      this.callingAccountDetails = true;
      this.loadingData = true;
      this.linkedMessageId = null;

      call(request).then(callSuccess, callError);

      function callSuccess(data) {
        errorLoading = false;
        service.data = data;
        service.callingAccountDetails = false;
        service.loadingData = false;
        var lastSetAccount = localStorage.getLocalStorageValue('accountNumber');
        if ($rootScope.isCare) {
          lastSetAccount = sessionStorage.getSessionStorageValue('accountNumber');
        }
        if (data.accountNumber === lastSetAccount) {
          processDetails(data);
        }
      }

      function callError(error) {
        service.loadingData = false;
        service.callingAccountDetails = false;
        errorLoading = true;
        apiErrorResponse.errorCode = _.get(error, 'status', '');
        apiErrorResponse.API = _.get(error, 'config.url', '');

        return callback({result: 'error', data: error});
      }

      function processDetails(data) {
        if (!data.accountNumber) {
          service.accountDetails = null;
          return callback({result: 'fail', data: data});
        }

        service.selectedAccountDetail = null;

        $rootScope.ao.accountDetails = data;
        $rootScope.ao.accountDetails.accountBalance = data.accountBalance;

        if (data.accountType === 9) {
          myrAccountBalanceDataFactory.accountBalance = data.accountBalance;
        }
        if ($rootScope.isConsumer) {
          var res = service.getSubscriptions($rootScope.ao.accountDetails.subList, false);
          $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;

          if ($rootScope.isCare) {
            sessionStorage.deleteSessionStorageValue('refreshDetails');
          } else {
            localStorage.deleteLocalStorageValue('refreshDetails');
          }

          var browserCookies = $browser.cookies();
          var contactEmail = browserCookies.cbid;
          var _domain = $window.location.hostname.replace('www', '');

          if ($browser.cookies().cbid) {
            $cookieStore.remove('cbid');
          }
          if (data.contactInfo && data.contactInfo.emailAddress) {
            var cbid = data.contactInfo.emailAddress;
            var encrypted = CryptoJS.AES ? CryptoJS.AES.encrypt(cbid, 'BoldChatSecret') : undefined; // jshint ignore:line
            if (encrypted !== undefined) {
              $window.document.cookie = 'cbid=' + encrypted.toString() + ';domain=' + _domain + ';path=/';
            }
          }
          if (data.accountName) {
            if (data.accountName.firstName && data.accountName.lastName) {
              var fullName = data.accountName.firstName + ' ' + data.accountName.lastName;
              localStorage.setLocalStorageValue('fullName', fullName);
            }
          }
          service.accountDetails = data;
          setDefaultSubscriptionsStorage($rootScope.ao.accountDetails.subList);
          if ($rootScope.alsModal) {
            myrAccountListService.captureAccountSelection(data);
            $rootScope.alsModal = false;
          }

          return callback({result: 'success', data: service.accountDetails});

        } else if ($rootScope.isCare || $rootScope.isDealer) {
          var disablePermissionNotGranted = [true,true,true,true], badgePermission;
          badgePermission = ['Maestro_TV_Dashboard', 'Maestro_INT_Dashboard', 'Maestro_RHP_Dashboard','Maestro_SHM_Dashboard'];
          permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
            if (isPermitted) {
              if (!_.isArray(badgePermission)) {
                badgePermission = [badgePermission];
              }
              badgePermission.forEach(function (permission,index) {
                var uteCommonPermission = _.get(ute.common.permissions.service.RamResourceCodes, permission, permission);
                permissionsService.getRamPermission(uteCommonPermission, ute.common.permissions.service.RamActionCodes.grant)
                  .then(function (repPermission) {
                    if (repPermission) {
                      disablePermissionNotGranted[index] = false;

                    } else {
                      disablePermissionNotGranted[index] = true;
                    }

                    var res = service.getSubscriptions($rootScope.ao.accountDetails.subList, disablePermissionNotGranted);
                    $rootScope.myServicesList = (res && res.myServices) ? res.myServices : undefined;

                    if ($rootScope.isCare) {
                      sessionStorage.deleteSessionStorageValue('refreshDetails');
                    } else {
                      localStorage.deleteLocalStorageValue('refreshDetails');
                    }

                    var browserCookies = $browser.cookies();
                    var contactEmail = browserCookies.cbid;
                    var _domain = $window.location.hostname.replace('www', '');

                    if ($browser.cookies().cbid) {
                      $cookieStore.remove('cbid');
                    }
                    if (data.contactInfo && data.contactInfo.emailAddress) {
                      var cbid = data.contactInfo.emailAddress;
                      var encrypted = CryptoJS.AES ? CryptoJS.AES.encrypt(cbid, 'BoldChatSecret') : undefined; // jshint ignore:line
                      if (encrypted !== undefined) {
                        $window.document.cookie = 'cbid=' + encrypted.toString() + ';domain=' + _domain + ';path=/';
                      }
                    }
                    if (data.accountName) {
                      if (data.accountName.firstName && data.accountName.lastName) {
                        var fullName = data.accountName.firstName + ' ' + data.accountName.lastName;
                        localStorage.setLocalStorageValue('fullName', fullName);
                      }
                    }
                    service.accountDetails = data;
                    setDefaultSubscriptionsStorage($rootScope.ao.accountDetails.subList);

                    return callback({result: 'success', data: service.accountDetails});
                  });

              });
            }
          });
        }

      }
    }

    function getErrorLoading() {
      return {
        errorLoadingKey: errorLoading ? 'maintenance_info' : null,
        apiErrorResponse: apiErrorResponse
      };
    }

    function setDefaultSubscriptionsStorage(subscriptions) {
      var subscriptionsSubTypeStorageMap = {
        'Hi-Speed Internet': 'internetAccountNumber',
        'Digital TV': 'tvAccountNumber',
        'RHPc': 'homePhoneAccountNumber'
      };

      angular.forEach(subscriptionsSubTypeStorageMap, function (storageName, subType) {
        var subscription = _.find(subscriptions, {subType: subType});
        if (subscription) {
          if ($rootScope.isCare) {
            sessionStorage.setSessionStorageValue(storageName, subscription.subAccountId);
          } else {
            localStorage.setLocalStorageValue(storageName, subscription.subAccountId);
          }
        }
      });
    }

    function notifySubs() {
      if (updateCallback && typeof updateCallback === 'function') {
        try {
          updateCallback();
        } catch (e) {
        }
      }
    }
  }
}(_));

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrAccountBalanceDataFactory
   * @description
   * # myrAccountBalanceDataFactory
   */
  angular.module('myr.modules.accountBalanceData').factory('myrAccountBalanceDataFactory', accountBalanceFactory);

  accountBalanceFactory.$inject = ['$rootScope',
    'ajax',
    'localStorage',
    '$translate',
    'sessionStorage',
    '$log',
    'commonUtilityService',
    '$q',
    'ute.common.user.service'];

  function accountBalanceFactory($rootScope,
                                 ajax,
                                 localStorage,
                                 $translate,
                                 sessionStorage,
                                 $log,
                                 commonUtilityService,
                                 $q,
                                 userService) {

    var service = {
      accountBalance: {},
      billingDetails: {},
      loadingData: false,
      errorLoadingKey: undefined,
      apiErrorResponse: {},
      getAccountBalance: getAccountBalance,
      getAccountBalanceAsync: getAccountBalanceAsync,
      resetAccountBalance: resetAccountBalance,
      getBalanceDetails: getBalanceDetails
    };
    var accountBalancePromises = [];
    return service;

    ///////////////////////////////////////////////////////////////

    function getAccountBalance() {
      return service.accountBalance;
    }

    /**
     * Reset Account Balance
     */
    function resetAccountBalance() {
      service.accountBalance = {};
    }

    // TODO why we are using 2 different calls for different purpose in one method?
    function getBalanceDetails(request, callback, billingOverride) {
      var deferred = getDeferredObject(request.accountNumber);
      service.accountBalance = {};

      // load JSON
      var _return = {};

      var wirelessAccountTypeNumber = 1;
      // var call = (!billingOverride && (request.accountTypeNumber === wirelessAccountTypeNumber)) ? ajax.getBalance : ajax.getBillingDetail;
      var call = ajax.getBillingDetail;

      var bBillingDetails = (call === ajax.getBillingDetail);

      if (bBillingDetails) {
        service.billingDetails = {};
      }

      service.loadingData = true;
      // Always load new data
      call(request).then(
        function (data) {
          service.errorLoadingKey = '';
          var lastSetAccount = userService.isCare() ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
          if (String(request.accountNumber) === lastSetAccount) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {

              localStorage.deleteLocalStorageValue('refreshDetails');

              if ($rootScope.ao.accountDetails) {
                $rootScope.ao.accountDetails.accountBalance = data;
              }

              data.isCLM = (Number(data.creditLimit) > 0);
              if (data.isCLM) {
                data.exceedCreditLimit = ((Number(data.creditLimit) - Number(data.balanceAmount)) < 0);
              }
              data.isCLMExceeded = data.exceedCreditLimit;

              _return.result = 'success';
              _return.data = service.accountBalance = data;

              // Add Expiry date to accountBalance object
              if (service.accountBalance.nextBillingDetail) {

                try {
                  var currentExpiryDate = commonUtilityService.dateTime.parse(service.accountBalance.nextBillingDetail, 'YYYY-MM-DD');
                  if (currentExpiryDate === undefined) {
                    service.accountBalance.currentExpiryDate = '';
                  } else {
                    currentExpiryDate.setDate(currentExpiryDate.getDate() - 1);
                    service.accountBalance.currentExpiryDate = currentExpiryDate;
                  }
                } catch (e) {
                  $log.error('Exception catch during add currentExpiryDate to accountBalance object in myrAccountBalanceDataFactory:', e.message);
                }
              }

              if (bBillingDetails) {
                service.billingDetails = data;
              } else if (data.balanceAmount && service.billingDetails.balanceAmount === undefined) {
                service.billingDetails = data;
                service.errorLoadingKey = null;
              }

              service.loadingData = false;
              deferred.resolve(service.accountBalance);
              return callback(_return);

            } else {
              service.loadingData = false;
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }
        }, function (error) {
          service.loadingData = false;
          service.apiErrorResponse.errorCode = _.get(error, 'status', '');
          service.apiErrorResponse.API = _.get(error, 'config.api', '');

          if (angular.isUndefined(service.errorLoadingKey)) {
            service.errorLoadingKey = 'acc_overview_oops';
          }

          // Error handling - 555 exception
          // if (error.data.status === 555) {
          //   // Server error that needs further processing
          //   // additional information for 555 error
          //
          //   // error.error.errorCode		// 10k - 12.1k & 50k - 51k
          //   // error.error.errorMessage		// Message as delivered from server
          //   // error.error.message 			// Message as found in resource file
          //   // error.error.statusCode		// error status code - 555 in this case
          //
          // } else {
          //   // anything but status code 555
          // }

          _return.result = 'error';
          _return.data = error;
          deferred.reject();
          return callback(_return);
        }
      );
    }

    function getDeferredObject(accountNumber) {
      accountNumber = String(accountNumber);
      var deferred = accountBalancePromises[accountNumber];
      if (!deferred) {
        accountBalancePromises[accountNumber] = deferred = $q.defer();
      }
      return deferred;
    }

    function getAccountBalanceAsync(accountNumber) {
      return getDeferredObject(accountNumber).promise;
    }

    /**
     * Reset Account Balance after user logout
     */
    userService.registerSignoutHandler(_.partial(resetAccountBalance, 'resetAccountBalance'), resetAccountBalance);

  }

}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.briteBill').controller('MyrBriteBillController', BriteBillController);

  BriteBillController.$inject = ['$scope', '$rootScope', 'ute.brite.bill.service', '$timeout', '$sce'];

  /* @ngInject */
  function BriteBillController($scope, $rootScope, briteBillService, $timeout, $sce) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    var vm = this;
    var showBritebillTimer;

    /*
     $('#bb_iframe_container').on('scroll', function(){
     resizeIframe();
     });

     function resizeIframe(){
     var height = bbIframe.contentDocument.body.scrollHeight;
     bbIframe.height(height);
     }
     */
    vm.trustSrc = function (src) {
      return $sce.trustAsResourceUrl(src);
    };

    vm.getSRC = function () {
      return briteBillService.getSRC(vm.accountNumber);
    };

    function showBritebill() {
      getBriteBill(briteBillService.getDefaultLink(vm.accountNumber));
      $rootScope.bbloadingDataIndicator = false;
    }

    function getBriteBill(link) {
      if (briteBillService.getBriteBillFailed(vm.accountNumber)) {
        $scope.briteBillFailed = true;
      } else {
        $scope.briteBillFailed = false;

        $scope.loadingDataIndicator = true;
        briteBillService.changeBriteBillSrc(vm.accountNumber, link);

        /*
         var _iframe_pre = '<iframe id="bb_iframe" class="bb_iframe" style="display:none;" scrolling="no" src="about:blank"></iframe>'; // jshint ignore:line
         var _iframe_actual = '<iframe id="bb_iframe" class="bb_iframe" style="display:none;" scrolling="no" src=""></iframe>'; // jshint ignore:line
         var target = angular.element('.iframe-ctn');
         target.html(_iframe_pre); // jshint ignore:line
         target.html(_iframe_actual); // jshint ignore:line
         */

        //$timeout(resizeIframe, 1000);
        $rootScope.bbloadingDataIndicator = true;
      }
    }

     showBritebillTimer = $timeout(showBritebill, 100);

     $scope.$on("$destroy",function( event ) {
        $timeout.cancel(showBritebillTimer);              
      });

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /*
   BriteBill
   */
  angular.module('myr.modules.briteBill').directive('myrBriteBill', briteBill);

  briteBill.$inject = ['$log', '$timeout'];

  /* @ngInject */
  function briteBill($log, $timeout) {
    return {
      restrict: 'EA',
      templateUrl: 'scripts/modules/myrBriteBill/briteBillView.html',
      link: linkFunc,
      scope: {accountNumber: '='},
      replace: true,
      controller: 'MyrBriteBillController',
      controllerAs: 'bb',
      bindToController: true
    };

    function linkFunc(scope, element, attrs, ctrl) {

      var resizeIframeTimer;
       
      function resizeIframe() {

        var bbIframe = element[0];
        if (bbIframe.contentDocument) {
          var height = bbIframe.contentDocument.body.scrollHeight;

          bbIframe.style.height = height + 'px';

        }

      }

      $(document).on('scroll', function (evt) {
        resizeIframe();
      });

      scope.$on('$stateChangeStart', function () {
        $(document).off('scroll', function (evt) {
          resizeIframe();
        });
      });

      resizeIframeTimer = $timeout(resizeIframe, 5000);

      scope.$on("$destroy",function( event ) {
          $timeout.cancel(resizeIframeTimer);              
      });

    }
  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.contentExpand').directive('myrContentExpand', ContentExpand);

  ContentExpand.$inject = [];

  //isOpen accepts boolean
  //borderType accepts strings 'infoBorder' 'warningBorder' 'errorBorder' and none

  /* @ngInject */
  function ContentExpand() {
    return {
      restrict: 'E',
      transclude:true,
      scope:{'isOpen':'=','borderType':'@'},
      templateUrl:'scripts/modules/myrContentExpand/contentExpand.template.html',
      link: function (scope, element, attr, ngModelCtrl) {}
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:MyrLinkAccountController
   * @description
   * # MyrLinkAccountController
   * Controller of the totesApp
   */
  angular.module('myr.modules.linkAccount').controller('MyrLinkAccountController', LinkAccountController);

  /* @ngInject */
  function LinkAccountController() {
  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.linkAccount').config(linkAccountRoutesConfig);
  linkAccountRoutesConfig.$inject = ['$stateProvider'];

  function linkAccountRoutesConfig($stateProvider) {
    $stateProvider
      .state({
        name: 'linkaccount',
        url: '/linkaccount',
        // controller: 'MyrLinkAccountController',
        resolve: {
          redirectTolinkAccount: ['$window', '$q', function ($window, $q) {
            $window.open('/consumer/self-serve/link-account', '_self'); 
            return $q.defer().promise;
          }],
        }
      });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').controller('MyrPaymentTopBarController', PaymentTopBarController);

  PaymentTopBarController.$inject = ['$scope',
    '$rootScope',
    'btnSettings',
    '$window',
    'myrPaymentTopBarService',
    'myrAccountBalanceDataFactory',
    '$state',
    '$translate',
    'ute.common.permissions.service',
    'ute.payment.ui.pay.now.service',
    'ute.common.user.service',
    'ute.rogers.account.overview.factory',
    'ute.blocks.language.switcher',
    'myrAccountListService',
    'ute.promise.to.pay.service',
    '$modal',
    'myrWirelessDashboardService'];

  /* @ngInject */
  function PaymentTopBarController($scope,
                                   $rootScope,
                                   btnSettings,
                                   $window,
                                   myrPaymentTopBarService,
                                   myrAccountBalanceDataFactory,
                                   $state,
                                   $translate,
                                   permissionsService,
                                   payNowService,
                                   userService,
                                   accountOverviewFactory,
                                   languageSwitcher,
                                   myrAccountListService,
                                   ptpService,
                                   $modal,
                                   wirelessDashboardService) {
    var vm = this;
    var accountOverviewService;

    init();

    function init() {
      accountOverviewService = accountOverviewFactory();
      vm.abdf = myrAccountBalanceDataFactory;
      vm.lang = languageSwitcher.getCurrentLanguage();
      vm.state = $state.current.name;
      vm.btnSettings = btnSettings;
      vm.ptbs = myrPaymentTopBarService;
      vm.invoiceDateSelected = '';
      vm.getCreditCardImage = getCreditCardImage;
      vm.getCreditCardText = getCreditCardText;
      vm.openPayNowModal = openPayNowModal;
      vm.payBill = payBill;
      vm.btnStatus = $window.btnStatus;
      vm.als = myrAccountListService;
      vm.goToPTP = goToPTP;
      vm.paymentMethodChangedCallback = paymentMethodChangedCallback;
      vm.ptpReadPermissionAccess = false;
      vm.creditAdjustment = creditAdjustment;
      vm.selectedAccount = undefined;

      $scope.repCreditManagementAccess = false;
      $scope.repMakePaymentAccess = true;
      $scope.showAdjustmentButton = false;

      if (userService.isDealer() || userService.isCare()) {
        permissionsService.getRamPermission(
          ute.common.permissions.service.RamResourceCodes.MakePayment,
          ute.common.permissions.service.RamActionCodes.start
        ).then(function (agentPermission) {
          $scope.repMakePaymentAccess = agentPermission;
        });
        permissionsService.getRamPermission(
          ute.common.permissions.service.RamResourceCodes.CreditManagement,
          ute.common.permissions.service.RamActionCodes.start
        ).then(function (creditMgmtPermission) {
            $scope.repCreditManagementAccess = creditMgmtPermission;
          });
      }

      if (userService.isCare()) {
        permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PromiseToPay, ute.common.permissions.service.RamActionCodes.read)
          .then(function (repPermission) {
            vm.ptpReadPermissionAccess = repPermission;
          });
      }

      vm.abdf.accountBalance.balanceAmount = '--.--';
      vm.ptbs.refreshBalanceDetails(vm.balanceHandler);

      var dataChangeSubscriberName = 'paymentTopBarController_' + $scope.id;
      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        vm.lang = lang;
      }, dataChangeSubscriberName);

      accountOverviewService.getSelectedAccount().then(function (selectedAccount) {
        refreshSelectedAccount(selectedAccount);
      });

      accountOverviewService.registerOnDataChangeHandler(function (accountOverview) {
        refreshSelectedAccount(accountOverview.getSelectedAccount());
      }, dataChangeSubscriberName);

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler(dataChangeSubscriberName);
        accountOverviewService.unregisterOnDataChangeHandler(dataChangeSubscriberName);
        myServiceListWatcher();
      });
    }

    function refreshSelectedAccount(selectedAccount) {
      if (selectedAccount) {
        vm.selectedAccount = selectedAccount;
        checkAccountType();
        selectedAccount.getAccountOverviewSummary().then(function(selectedAccountSummary) {
          vm.selectedAccountDetail = selectedAccountSummary;
        });
      }
      if (selectedAccount && selectedAccount.accountStatus) {
        vm.btnSettings = btnSettings.getSettings(selectedAccount.accountStatus);
      }
    }

    function goToPTP() {
      ptpService.goToEntryState();
    }
    function openPayNowModal() {
      accountOverviewService.getSelectedAccountDetails().then(function (accountDetails) {
        payNowService.openMakePaymentModal(
          vm.abdf.accountBalance,
          accountDetails,
          $state.current && $state.current.name ? $state.current.name : 'viewbill',
          myrPaymentTopBarService.refreshBalanceDetails
        );
      }).catch(function (error) {
        console.log('error getting account summary');
      });
    }

    function payBill() {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop(); // jshint ignore:line
      openPayNowModal();
    }

    function getCreditCardImage() {
      return $translate.instant(vm.ptbs.ccType + '_img');
    }

    function getCreditCardText() {
      return $translate.instant(vm.ptbs.ccType);
    }

    function paymentMethodChangedCallback() {
      vm.ptbs.refreshBalanceDetails();
    }

    function openCreditAdjustmentModal() {
      $rootScope.modal = $modal.open({
        templateUrl: 'scripts/modules/creditAdjustment/creditAdjustmentModal.html',
        controller: 'MyrCreditAdjustmentController',
        size: 'creditAdjustment-modal-dialog',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });

      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    }

    function creditAdjustment() {
      scrollPageToTop(); // jshint ignore:line
      openCreditAdjustmentModal();
    }

    function checkAccountType () {
      if (
        vm.selectedAccount
        &&  vm.selectedAccount.accountType !== 'Business'
      ) {
        $scope.showAdjustmentButton = true;
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').directive('myrPaymentTopBar', paymentTopBar);

  paymentTopBar.$inject = ['ute.common.user.service'];

  /* @ngInject */
  function paymentTopBar(userService) {
    var template = userService.isConsumer() ? 'scripts/modules/myrPaymentTopBar/paymentTopBarView.html' : 'scripts/modules/myrPaymentTopBar/paymentTopBarRepView.html';
    return {
      templateUrl: template,
      restrict: 'EA',
      controller: 'MyrPaymentTopBarController',
      controllerAs: 'ptb',
      bindToController: true,
      scope: {
        needsBillingEnhancement: '=?',
        balanceHandler: '&'
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.paymentTopBar').factory('myrPaymentTopBarService', paymentTopBarService);

  paymentTopBarService.$inject = ['ute.rogers.account.overview.factory', 'myrAccountBalanceDataFactory', 'ute.blocks.language.switcher'];

  /* @ngInject */
  function paymentTopBarService(accountOverviewFactory, myrAccountBalanceDataFactory, languageSwitcher) {
    var abdf = myrAccountBalanceDataFactory;
    var accountOverviewService = accountOverviewFactory();
    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      paymentMethod: null,
      ccType: null,
      refreshBalanceDetails: refreshBalanceDetails
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function refreshBalanceDetails(callback) {
      accountOverviewService.getSelectedAccountDetails().then(function (accountDetails) {
        if (accountDetails) {
          var request = {
            accountNumber: accountDetails.accountNumber,
            accountTypeNumber: accountDetails.accountType,
            language: languageSwitcher.getCurrentLanguage(),
            refresh: false,
            applicationId: 'Rogers.com'
          };

          // with other items in the call
          try {
            request.pinNumber = abdf.selectedAccount.pinNumber;
          } catch (e) {
          }
          try {
            request.phoneNumber = accountDetails.phoneNumber;
          } catch (e) {
          }

          abdf.getBalanceDetails(request, function (response) {
            service.paymentMethod = abdf.accountBalance.methodOfPayment ? abdf.accountBalance.methodOfPayment.mopType : 'U';

            try {
              service.ccType = abdf.billingDetails.methodOfPayment.creditCardDetails.ccType;
            } catch (e) {
              service.ccType = null;
            }

            if (callback) {
              callback({response: response});
            }

          }, true);
        }
      });
    }
  }
})();

(function() {
  'use strict';

  angular.module('myr.modules.profile', ['totesApp', 'ui.router']);
})();

(function() {
  'use strict';

  angular.module('myr.modules.profile').factory('myrProfileDataFactory', myrProfileDataFactory);
  myrProfileDataFactory.$inject = ['backend'];

  function myrProfileDataFactory(backend) {
    var publicInterface = {
      checkComplete: checkComplete
    };

    return publicInterface;

    function checkComplete() {
      return backend.post('profile/checkComplete');
    }
  }

})();

(function () {
  'use strict';

  angular.module('myr.modules.profile').factory('myrProfileFactory', myrProfileFactory);
  myrProfileFactory.$inject = ['myrProfileDataFactory',
    '$q',
    '$location',
    'localStorage',
    '$window',
    '$state',
    '$browser',
    'cookieStore',
    'ute.common.core.brtswitch.service'];

  function myrProfileFactory(myrProfileDataFactory,
                             $q,
                             $location,
                             localStorage,
                             $window,
                             $state,
                             $browser,
                             cookieStore,
                             brtSwitchService) {
    var publicInterface = {
      isPasswordChangeComplete: isPasswordChangeComplete,
      isSecurityQuestionComplete: isSecurityQuestionComplete,
      isAccountLinked: isAccountLinked,
      setHasAccountLinked: setHasAccountLinked,
      registrationCompleteSignin: registrationCompleteSignin,
      setCompletingRegistration: setCompletingRegistration,
      getCompletingRegistration: getCompletingRegistration,
      setNewRegistrationComplete: setNewRegistrationComplete,
      getNewRegistrationComplete: getNewRegistrationComplete
    };

    var defer;
    var hasAccountLinked = false;
    var completingRegistration = false;
    var newRegistrationComplete = false;

    return publicInterface;

    function isPasswordChangeComplete() {
      return $location.path() !== '/tpsc';
    }

    function isSecurityQuestionComplete() {
      defer = $q.defer();

      if (localStorage.getLocalStorageValue('profileComplete')) {
        defer.resolve();
        return defer.promise;
      }

      brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.JANRAIN_REGISTRATION).then(function (val) {
        if (val) {
          defer.resolve();
          return defer.promise;
        } else {
          myrProfileDataFactory
              .checkComplete()
              .then(securityQuestionSucess, defer.reject);
        }
      });
      return defer.promise;
    }

    function securityQuestionSucess(data) {
      return (data && data.complete) ? defer.resolve() : defer.reject();
    }

    function registrationCompleteSignin() {
      // Read the overide cookie from other projects
      var linkIn = $browser.cookies().linkIn;
      cookieStore.remove('linkIn');

      if (!linkIn && $state.current.name !== 'registration') {
        $state.go('accountOverview');
        return;
      }

      $window.location.href = linkIn;
    }

    function setHasAccountLinked(bool) {
      hasAccountLinked = bool;
    }

    function isAccountLinked() {
      return hasAccountLinked;
    }

    function setCompletingRegistration(bool) {
      completingRegistration = bool;
    }

    function getCompletingRegistration() {
      return completingRegistration;
    }

    function setNewRegistrationComplete(bool) {
      newRegistrationComplete = bool;
    }

    function getNewRegistrationComplete() {
      return newRegistrationComplete;
    }
  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.securityQuestion').config(securityQuestionRoutesConfig);
  securityQuestionRoutesConfig.$inject = ['$stateProvider'];

  function securityQuestionRoutesConfig($stateProvider) {
    $stateProvider
      .state({
        name: 'completeProfile',
        url: '/completeProfile',
        controller: 'MyrSecurityQuestionController',
        templateUrl: 'scripts/modules/myrSecurityQuestion/securityQuestion.html',
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/completeProfile');
          globalloaderService.hide();
        }],
        resolve: {
          accountList: getAccountList
        }
      });
  }

  getAccountList.$inject = ['backend'];
  function getAccountList(backend) {
    return backend.post('accountoverview', {
      refresh: false,
      applicationId: 'Rogers.com'
    });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.securityQuestion').controller('MyrSecurityQuestionController', SecurityQuestionController);

  SecurityQuestionController.$inject = ['$scope',
    '$translate',
    'appState',
    'localStorage',
    'myrSecurityQuestionFactory',
    'myrProfileFactory',
    'accountList',
    '$state',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function SecurityQuestionController($scope,
                                      $translate,
                                      appState,
                                      localStorage,
                                      myrSecurityQuestionFactory,
                                      myrProfileFactory,
                                      accountList,
                                      $state,
                                      languageSwitcher) {
    if (accountList.accountList.length) {
      myrProfileFactory.setHasAccountLinked(true);
    }

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();          // jshint ignore:line

    $scope.$extend({
      tagPageName: 'Security Question',
      questionId: '',
      answer: '',
      questions: null, //to be populated as below
      form: $scope.form,
      isValid: null,
      loadingDataIndicator: false,
      submit: function () {
        if (!$scope.form.$valid) {
          $scope.isValid = false;
          appState.tagFormValidationErrors($scope.tagPageName, $scope.form.$error);
          $scope.loadingDataIndicator = false;
          return;
        }

        $scope.isValid = true;
        $scope.isError = false;
        $scope.errorDescription = null;
        $scope.loadingDataIndicator = true;
        myrSecurityQuestionFactory
            .updateSecurityQuestion($scope.questionId, $scope.answer)
            .then(updateSecurityQuestionSuccess, updateSecurityQuestionFail)
            .then(function () {
              if ($scope.isError) {
                return;
              }
            });

        function updateSecurityQuestionSuccess() {
          localStorage.setLocalStorageValue('profileComplete', 'true');
          localStorage.deleteLocalStorageValue('successMessage');

          if (!myrProfileFactory.isAccountLinked()) {
            myrProfileFactory.setCompletingRegistration(true);
            $state.go('linkaccount');
            return;
          }

          $state.go('accountOverview');
        }

        function updateSecurityQuestionFail(error) {
          $scope.isError = true;
          $scope.loadingDataIndicator = false;
          $scope.tagErrorAnsweringUsage();
          if (error.data.status === 555) {
            if (error.error.errorCode) {
              $scope.errorDescription = $translate.instant(error.error.errorCode);
            }
          }
          if (!($scope.errorDescription)) {
            $scope.errorDescription = $translate.instant('maintenance_info');
          }
        }
      }
    });

    // TODO: omniture tagging
//            function tagSecurityQuestion() {
//                appState.tagging(['_trackPageView',
//                    {pn: 'home:registration:contact-information'}, // Page Name
//                    {eVar13: 'MyRogers - Security Question'},
//                    {event5: ''},
//                    {event7: ''}
//                ]);
//            }

    $scope.tagSecurityQuestionUsage = function () {
      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:Auto_Regis_Secretques'}, // Page Name
      ]);
    };

    $scope.tagErrorAnsweringUsage = function () {
      appState.tagging(['_trackLink',
        {eVar49: '<ErrorMessages>'},// Error Message example: Please Enter a correct Answer'
        {event15: ''}// Generic Error
      ]);
    };

    languageSwitcher.registerOnDataChangeHandler(function () {
      $scope.questions = $translate.instant('login_security_questions');
    }, 'securityQuestionControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('securityQuestionControllerLangSub');
    });

    //init tagging
    // TODO: omniture tagging
//            tagSecurityQuestion();
  }
})();

(function() {
  'use strict';

  angular.module('myr.modules.securityQuestion').factory('myrSecurityQuestionDataFactory', myrSecurityQuestionDataFactory);
  myrSecurityQuestionDataFactory.$inject = ['backend'];

  function myrSecurityQuestionDataFactory(backend) {
    var publicInterface = {
      updateSecurityQuestion: updateSecurityQuestion
    };

    return publicInterface;

    function updateSecurityQuestion(questionId, answer) {
      return backend.postFormData('profile/updateSecurityQuestion', { questionId: questionId, answer: answer });
    }
  }

})();

(function() {
  'use strict';

  angular.module('myr.modules.securityQuestion').factory('myrSecurityQuestionFactory', myrSecurityQuestionFactory);
  myrSecurityQuestionFactory.$inject = ['myrSecurityQuestionDataFactory', '$q', 'localStorage'];

  function myrSecurityQuestionFactory(myrSecurityQuestionDataFactory, $q, localStorage) {
    var publicInterface = {
      updateSecurityQuestion: updateSecurityQuestion
    };

    var defer;

    return publicInterface;


    function updateSecurityQuestion(questionId, answer) {
      defer = $q.defer();

      myrSecurityQuestionDataFactory
        .updateSecurityQuestion(questionId, answer)
        .then(updateSecurityQuestionSuccess, updateSecurityQuestionFail);

      return defer.promise;
    }

    function updateSecurityQuestionSuccess(data) {
      localStorage.setLocalStorageValue('profileComplete', 'true');
      defer.resolve();
    }

    function updateSecurityQuestionFail(error) {
      defer.reject(error);
    }
  }
})();

(function () {
  'use strict';

  angular.module('myr.modules.viewBill').config(britebillRoutesConfig);
  britebillRoutesConfig.$inject = ['$stateProvider'];

  function britebillRoutesConfig($stateProvider) {
    $stateProvider
      .state({
        name: 'viewbill',
        url: '/viewbill',
        params: {
          loadPaymentMethodModal: false,
          loadPaymentModal: false,
          interacFailed: false,
          interacSuccess: false,
          interacFailureModal: null
        },
        controller: 'MyrViewBillController',
        controllerAs: 'vb',
        templateUrl: 'scripts/modules/myrViewBill/viewBill.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          routeData: ['permissionResolver', 'appState', 'ute.rogers.account.overview.factory', '$rootScope', 'sessionStorage', '$q', '$window',
            function (permissionResolver, appState, newAccountOverviewFactory, $rootScope, sessionStorage, $q, $window) {
              var sourcePath = this.url.sourcePath;
              return permissionResolver.getPermission(sourcePath).then(function (data) {
                var param, accountNumber;
                if ($rootScope.isCare) {
                  accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
                  param = {acctNbr: Number(accountNumber)};
                }
                return newAccountOverviewFactory(param).getSelectedAccount().then(function (selectedAccount) {
                  if (selectedAccount) {
                    if (selectedAccount.accountTypeNumber === 9) {
                      return {isPrepaid: true, selectedAccount: selectedAccount};
                    } else {
                      //redirectToSelfServe: ['$window', function ($window) {
                        $window.open('/consumer/self-serve/view-bill', '_self');
                     // }]
                      return $q.defer().promise;
                      // return appState.isMultiBanAccount(data, sourcePath).then(function (redirectionPending) {
                      //   if (!redirectionPending) {
                      //     return {isPrepaid: false, selectedAccount: selectedAccount};
                      //   }
                      //   //If redirection is pending, return empty object
                      //   return {};
                      // });
                    }
                  } else {
                    appState.switchView('accountOverview');
                  }
                }).catch(function () {
                  return $q.reject({});
                });
              });
            }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewbill');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/viewbill');
        }]
      })
      .state({
        name: 'viewbill-payment-method',
        url: '/viewbill/payment-method',
        params: {
          loadPaymentMethodModal: true,
          loadPaymentModal: false,
          interacFailed: false,
          interacSuccess: false,
          interacFailureModal: null
        },
        controller: 'MyrViewBillController',
        controllerAs: 'vb',
        templateUrl: 'scripts/modules/myrViewBill/viewBill.html',
        resolve: {
          deepLinkingHandler: ['deeplink', function (deeplink) {
            deeplink.internal();
          }],
          routeData: ['permissionResolver', 'appState', 'ute.rogers.account.overview.factory', '$rootScope', 'sessionStorage', '$q', '$window',
            function (permissionResolver, appState, newAccountOverviewFactory, $rootScope, sessionStorage, $q, $window) {
              var sourcePath = this.url.sourcePath;
              return permissionResolver.getPermission(sourcePath).then(function (data) {
                var param, accountNumber;
                if ($rootScope.isCare) {
                  accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
                  param = {acctNbr: Number(accountNumber)};
                }
                return newAccountOverviewFactory(param).getSelectedAccount().then(function (selectedAccount) {
                  if (selectedAccount) {
                    if (selectedAccount.accountTypeNumber === 9) {
                      return {isPrepaid: true, selectedAccount: selectedAccount};
                    } else {
                     // redirectToSelfServe: ['$window', function ($window) {
                        $window.open('/consumer/self-serve/payments/auto', '_self');
                      //}]
                      return $q.defer().promise;
                      // return appState.isMultiBanAccount(data, sourcePath).then(function (redirectionPending) {
                      //   if (!redirectionPending) {
                      //     return {isPrepaid: false, selectedAccount: selectedAccount};
                      //   }
                      //   //If redirection is pending, return empty object
                      //   return {};
                      // });
                    }
                  } else {
                    appState.switchView('accountOverview');
                  }
                }).catch(function () {
                  return $q.reject({});
                });
              });
            }]
        },
        onEnter: ['appInterface', 'globalloaderService', function (appInterface, globalloaderService) {
          appInterface.stateEnter('/viewbill');
          globalloaderService.hide();
        }],
        onExit: ['appInterface', function (appInterface) {
          appInterface.stateExit('/viewbill');
        }]
      });

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').config(configure);

  configure.$inject = ['$logProvider'];

  /* @ngInject */
  function configure($logProvider) {
    if ($logProvider.debugEnabled) {
      $logProvider.debugEnabled(false);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').constant('lodash', _);
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').controller('MyrNotificationBannerController', NotificationBannerController);

  NotificationBannerController.$inject = ['myrNotificationBannerService', '$log'];

  /* @ngInject */
  function NotificationBannerController(notificationBannerService, $log) {
    var vm = this;

    // Public API
    vm.registerBanner = registerBanner;
    vm.getMessage = getMessage;
    vm.isVisible = isVisible;

    ///////////////////////////////////////////////////////////////

    // private
    var _bannerId;

    /**
     *
     * @param bannerId
     */
    function registerBanner(bannerId) {
      _bannerId = bannerId;
      return notificationBannerService.registerBanner(bannerId);
    }

    /**
     * get message for banner
     */
    function getMessage() {
      return notificationBannerService.getMessage(_bannerId);
    }

    /**
     * is banner visible
     */
    function isVisible() {
      return angular.isDefined(notificationBannerService.getMessage(_bannerId)) && !!notificationBannerService.getMessage(_bannerId);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /*
   Global banner widget. When included, it will display a banner with the Rogers icon and
   available types:
   --success
   --warning
   --error
   --info
   Example:
   <notificationBanner type="success" message="resource-key"></notificationBanner>
   */
  angular.module('myr.modules.notificationBanner').directive('myrNotificationBanner', notificationBanner);

  notificationBanner.$inject = ['$log'];

  /* @ngInject */
  function notificationBanner($log) {
    return {
      restrict: 'EA',
      templateUrl: 'scripts/modules/notificationBanner/notificationBanner.html',
      scope: {
        type: '='
      },
      link: linkFunc,
      replace: true,
      controller: 'MyrNotificationBannerController',
      controllerAs: 'nb',
      bindToController: true
    };

    function linkFunc(scope, element, attrs, ctrl) {
      ctrl.registerBanner(attrs.bannerId);
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.notificationBanner').factory('myrNotificationBannerService', notificationBannerService);

  notificationBannerService.$inject = ['$log', '$injector', '$timeout'];

  /* @ngInject */
  function notificationBannerService($log, $injector, $timeout) {

    // Public API
    var service = {
      registerBanner: registerBanner,
      sendMessageKey: sendMessageKey,
      sendMessage: sendMessage,
      getMessage: getMessage,
      cleanBanner: cleanBanner
    };

    var data = {
      banners: {}
    };

    // TODO move to utit tests
    /*
     sendMessageKey('linkedMessage', 'linked_acc_success');
     sendMessage('successMessage', 'test message');

     $timeout(function () {
     cleanBanner('linkedMessage');
     }, 5000);

     $timeout(function () {
     cleanBanner('successMessage');
     }, 10000);
     */
    return service;

    ///////////////////////////////////////////////////////////////

    /**
     *
     * @param bannerId
     */
    function registerBanner(bannerId) {
      // TODO
      return true;
    }

    /**
     * get message for bannerId
     *
     * @param bannerId
     * @returns {*}
     */
    function getMessage(bannerId) {
      return data.banners[bannerId];
    }

    /**
     * Sent message to the banner with bannerId
     *
     * @param bannerId
     * @param message
     * @returns {boolean}
     */
    function sendMessage(bannerId, message) {
      data.banners[bannerId] = message;
      return true;
    }

    /**
     * Sent a message by resource key to the banner with bannerId
     *
     * @param bannerId
     * @param messageKey
     * @returns {boolean}
     */
    function sendMessageKey(bannerId, messageKey) {
      if (!!messageKey && !!bannerId) {
        data.banners[bannerId] = messageKey; //$translate.instant(messageKey); needs to be handled by res directive
        return true;
      } else {
        return false;
      }
    }

    /**
     * Clean a banner with bannerId
     *
     * @param bannerId
     * @returns {boolean}
     */
    function cleanBanner(bannerId) {
      if (!!bannerId) {
        data.banners[bannerId] = null;
        return true;
      } else {
        return false;
      }
    }
  }
}());

(function () {
  'use strict';

  angular.module('onboarding').controller('onboardingController', OnboardingController);

  OnboardingController.$inject = ['$scope',
    'onboardingService',
    'ute.blocks.language.switcher',
    'ute.common.core.browser.service',
    'ute.datalayer.common.service',
    'ute.rogers.account.billing.detail.factory'];

  function OnboardingController($scope,
                                onboardingService,
                                languageService,
                                browser,
                                dataLayerService,
                                billingDetailFactory) {
    var _this = this;
    var billingDetailFactoryRef;
    var scopeId = $scope.$id;

    _this.getAnalyticsSegmentName = onboardingService.getAnalyticsSegmentName;

    _this.calculateProgress = function () {
      return onboardingService.countCompletedTasks() / _this.itemConfigs.length * 100;
    };

    _this.closeCongratsMsg = function() {
      _this.showOnboardingModule = false;
    };

    _this.onToggle = function () {
      if(!_this.isCollapsed) {
        dataLayerService.track({}, false, [], {mappingKey: 'onboarding.showLess'});
      }
      _this.isCollapsed = !_this.isCollapsed;
      onboardingService.setToggleState(_this.isCollapsed);
    };

    _this.showCongratsMessage = function () {
      if (_this.calculateProgress() === 100) {
        onboardingService.setCongratsDisplayed();
        return true;
      } else {
        return false;
      }
    };
    _this.init = function () {
      _this.showOnboardingModule = false;
      onboardingService.reset();
      _this.itemConfigs = onboardingService.getConfig();

      if(_this.billingDataHandlerIsRegistered && onboardingService.getAccountDetails().accountNumber !==  _this.accountDetails.accountNumber) {
        billingDetailFactoryRef.unregisterOnDataChangeHandler('onboardingController' + scopeId);
        _this.billingDataHandlerIsRegistered = false;
      }

      if (!_this.billingDataHandlerIsRegistered) {
        billingDetailFactoryRef = billingDetailFactory({
          accountNumber: _this.accountDetails.accountNumber,
          accountTypeNumber: _this.accountDetails.accountType,
          language: languageService.getCurrentLanguage(),
          applicationId: 'Rogers.com',
          refresh: false
        });
        billingDetailFactoryRef.registerOnDataChangeHandler(checkShowOnboardingModule, 'onboardingController' + scopeId);
        _this.billingDataHandlerIsRegistered = true;
      }

      onboardingService.setAccountDetails(_this.accountDetails);

      var savedToggleState = onboardingService.getToggleState();
      _this.isCollapsed = savedToggleState !== null ? savedToggleState : browser.isMobile();

      checkShowOnboardingModule();
    };

    _this.init();

    function checkShowOnboardingModule() {
      _this.showOnboardingModule = false;

      onboardingService.showOnboardingModule()
        .then(function (data) {
          _this.showOnboardingModule = data;
          _this.onboardingEmitStatus({status: data});
        });
    }

    $scope.$on('$destroy', function () {
      if (onboardingService.checkRegisteredToSmsRecoveryEvent()) {
        $('body').off('sms-recovery-phone-changed');
      }
      billingDetailFactoryRef.unregisterOnDataChangeHandler('onboardingController' + scopeId);
    });
  }

})();

angular
  .module('onboarding')
  .directive('onboarding', Onboarding);

function Onboarding() {
  return {
    restrict: 'E',
    scope: {
      accountDetails: '=',
      onboardingEmitStatus: '&'
    },
    controller: 'onboardingController',
    controllerAs: 'ctrl',
    templateUrl: 'scripts/modules/onboarding/onboarding.view.html',
    bindToController: true,
    link: function(scope, element, attrs, controller){
      scope.$watch('ctrl.accountDetails.accountNumber', function (newAccountNumber, oldAccountNumber) {
        if (newAccountNumber && String(newAccountNumber) !== String(oldAccountNumber)) {
          controller.init();
        }
      });
    }
  };
}

(function () {
  'use strict';

  angular.module('onboarding').factory('onboardingService', onboardingService);

  onboardingService.$inject = ['$q',
    '$http',
    '$window',
    'CONFIG',
    'ute.rogers.account.overview.factory',
    'ute.sms.recovery.rogers.service',
    'ute.goPaperless.service',
    'ute.goPaperless.data.service',
    'ute.common.user.service',
    'ute.datalayer.common.service',
    'ute.blocks.language.switcher',
    'ute.common.core.browser.service',
    'ute.common.core.caching.CacheableDataFactory',
    'ute.payment.method.service'];

  /* @ngInject */
  function onboardingService($q,
                             $http,
                             $window,
                             BUILD_CONFIG,
                             accountOverviewFactory,
                             recoveryService,
                             goPaperlessService,
                             goPaperlessDataService,
                             userService,
                             dataLayerService,
                             languageService,
                             browser,
                             cacheableData,
                             paymentMethodService) {

    var toggleState = null;
    var congratsDisplayed = false;
    var clientCompletedStatus = false;
    var isRegisteredToSmsRecoveryEvent = false;
    var shouldSaveSegmentInfo = false;
    var accountDetails = {};
    var accountOverviewService = accountOverviewFactory();
    var cmsSettingPromise;
    var today = $window.moment().startOf('day');
    var segmentDate = null;
    var segmentType = null;
    var segmentInfoSaved = false;
    var eligibleForSegmentA = false;
    var eligibleForSegmentB = false;
    var SEGMENT_TYPES = {
      A: 'A',
      B: 'B'
    };

    var config = [
      {
        completed: true,
        itemKey: 'loginToAccount',
        completedBg: 'images/onBoarding_checklist/completed-logged-in.svg',
        pendingBg: 'images/onBoarding_checklist/completed-logged-in.svg'
      },
      {
        completed: false,
        itemKey: 'setRecoveryNumber',
        completedBg: 'images/onBoarding_checklist/completed-recovery-number.svg',
        pendingBg: 'images/onBoarding_checklist/incomplete-recovery-number.svg',
        modal: {
          titleTranslationKey: 'onBoarding.tasks.setRecoveryNumber.modal.title',
          descriptionTranslationKey: 'onBoarding.tasks.setRecoveryNumber.modal.description',
          buttons: {
            primary: {
              labelTranslationKey: 'onBoarding.tasks.setRecoveryNumber.modal.buttonText',
              altTranslationKey: 'onBoarding.tasks.setRecoveryNumber.modal.buttonAltText',
              cssClass: 'recovery-interceptor',
              callback: function () {
                if(browser.isMobile()) {
                  $('.recovery-interceptor').click();
                }
                $('body').on('sms-recovery-phone-changed', function () {
                  completeTask('setRecoveryNumber');
                });
                isRegisteredToSmsRecoveryEvent = true;

                // just to show the back drop when open up modal
                setTimeout(function () {
                  document.body.classList.add('modal-open');
                }, 1000);
              }
            }
          }
        }
      },
      {
        completed: false,
        itemKey: 'setOnlineBilling',
        completedBg: 'images/onBoarding_checklist/completed-online-billing.svg',
        pendingBg: 'images/onBoarding_checklist/incomplete-online-billing.svg',
        modal: {
          titleTranslationKey: 'onBoarding.tasks.setOnlineBilling.modal.title',
          descriptionTranslationKey: 'onBoarding.tasks.setOnlineBilling.modal.description',
          buttons: {
            primary: {
              labelTranslationKey: 'onBoarding.tasks.setOnlineBilling.modal.buttonText',
              altTranslationKey: 'onBoarding.tasks.setOnlineBilling.modal.buttonAltText',
              callback: function () {
                var payload = {accountNumber: accountDetails.accountNumber};
                if (userService.isCare()) {
                  payload.ban = accountDetails.accountNumber;
                }

                goPaperlessDataService.getContactInfo(payload)
                  .then(function (response) {
                    var configObject = {accountNumber: accountDetails.accountNumber, contactEmail: response.data.emailAddress};
                    goPaperlessService.switchToPaperless(configObject)
                      .then(function() {
                        completeTask('setOnlineBilling');
                      });
                  });
              }
            }
          }
        }
      },
      {
        completed: false,
        itemKey: 'setAutoPayment',
        completedBg: 'images/onBoarding_checklist/completed-auto-payments.svg',
        pendingBg: 'images/onBoarding_checklist/incomplete-auto-payments.svg',
        modal: {
          titleTranslationKey: 'onBoarding.tasks.setAutoPayment.modal.title',
          descriptionTranslationKey: 'onBoarding.tasks.setAutoPayment.modal.description',
          buttons: {
            primary: {
              labelTranslationKey: 'onBoarding.tasks.setAutoPayment.modal.buttonText',
              altTranslationKey: 'onBoarding.tasks.setAutoPayment.modal.buttonAltText',
              callback: function () {
                paymentMethodService.openChangePaymentMethodModal(false, accountDetails)
                  .then(function() {
                    completeTask('setAutoPayment');
                  });
              }
            }
          }
        }
      }
    ];

    function checkClientStatus() {
      if (clientCompletedStatus) {
        return $q.reject('completed before - client');
      } else {
        return $q.when('not completed');
      }
    }

    function setServerStatus(saveSegmentInfo) {
      var request = {
        brand: 'ROGERS'
      };

      if (saveSegmentInfo) {
        request.accountNumber = accountDetails.accountNumber;
        request.segmentType = segmentType;
      } else {
        request.status = 'Completed';
      }
      var xSessionToken = getXSessionToken();
      var _headers = !!xSessionToken
        ? {
            'x-session-token': xSessionToken,
            'brand': 'ROGERS',
          }
        : { 'brand': 'ROGERS' };

      return $http({
        method: 'POST',
        url: '/web/totes/web/genesis/api/user/v1/byGUID/' + getGUID() + '/OnlineProfile/onBoardingMessageStatus',
        headers: _headers,
        data: request
      }).then(function (response) {
        if(_.get(response, 'data.status.code', null) === '200.001') {
          if(request.status === 'Completed') {
            clientCompletedStatus = true;
            dataLayerService.track({miscellaneous: {name: getAnalyticsSegmentName()}}, false, [0, 1, 4], {mappingKey: 'onboarding.onboardingCompleted'});
          }
          response.isSuccess = true;
        } else {
          response.isSuccess = false;
        }

        return response;
      });
    }

    function checkServerStatus() {
      if (!getGUID()) {
        return $q.reject('no guid');
      }
      var xSessionToken = getXSessionToken();
      var _headers = !!xSessionToken
        ? {
            'x-session-token': xSessionToken,
          }
        : {};
      return $http({
        method: 'GET',
        url: '/web/totes/web/genesis/api/user/v1/byGUID/' + getGUID() + '/OnlineProfile/onBoardingMessageStatus?brand=ROGERS',
        headers: _headers
      }).then(function (response) {
        if (_.get(response, 'data.content.segmentDate')) {
          segmentDate = $window.moment(response.data.content.segmentDate);
        }
        if (_.get(response, 'data.content.segmentType')) {
          segmentType = response.data.content.segmentType;
        }

        if(!!segmentDate && !segmentType) {
          // As per BSA (Vinai), if there is no segmentType but segmentDate is populated it means segmentType is "A"
          segmentType = SEGMENT_TYPES.A;
        }

        if (!_.has(response, 'data.content.onBoardingStatus')) {
          // if data object does not have status, something is wrong
          return $q.reject('API Error - onBoardingMessageStatus');
        } else if (response.data.content.onBoardingStatus && response.data.content.onBoardingStatus.toLowerCase() === 'completed') {
          return $q.reject('completed before - server');
        } else {
          return $q.when('not completed');
        }
      });
    }

    function getCmsSettings() {
      // TODO: segmentBPeriod need to be added in the CMS file
      // return $q.when({
      //   validProfilePeriod: 60,
      //   segmentAPeriod: 60,
      //   segmentBPeriod: 90
      // });
      if(cmsSettingPromise) {
        return cmsSettingPromise;
      }
      cmsSettingPromise = $http.get('/web/totes/cms/content/json/onboarding-setting.json?' + BUILD_CONFIG.buildTimestamp)
        .then(function (response) {
          return response.data;
        });
      return cmsSettingPromise;
    }

    function isEligibleForSegmentA() {
      if (!!segmentType && segmentType !== SEGMENT_TYPES.A) {
        return $q.when(false); // is in another segment
      } else if (eligibleForSegmentA) {
        return $q.when(true);
      } else {
        return getCmsSettings().then(function (settings) {
          var profileActivationDate = $window.moment(getProfileActivationDate());
          if (!profileActivationDate.isValid()) {
            return $q.reject('API error - problem with ProfileActivationDate');
          } else if (isFirstVisitWithinValidProfilePeriod(settings, profileActivationDate) || (!!segmentType && isWithinValidSegmentPeriod(settings, segmentType))) {
            eligibleForSegmentA = true;
            return true; // eligible for segment A - no need to check segment B
          } else {
            return false; // not eligible for segment A - Check segment B
          }
        });
      }
    }

    function setFirstTaskAsInfinite() {
      var item = _.find(config, {itemKey: 'loginToAccount'});

      if (item) {
        item.itemKey = 'switchedToInfinite';
        item.completedBg = 'images/onBoarding_checklist/completed-infinite.svg';
        item.pendingBg = 'images/onBoarding_checklist/completed-infinite.svg';
      }
    }

    function isEligibleForSegmentB(ignore) {
      if (eligibleForSegmentB || ignore) {
        return $q.when(true);
      } else if (!!segmentType && segmentType !== SEGMENT_TYPES.B) {
        return $q.reject('already in another segment - not valid for segment B');
      } else {
        return $q.all([getCmsSettings(), checkIsShareEverythingInfinite()]).then(function (responses) {
          var settings = responses[0];
          var isInfinite = responses[1];

          if(isInfinite) {
            if(_.isNull(segmentDate)) {
              // First visit of onboarding for segment's "B" eligible customers
              shouldSaveSegmentInfo = true;
              segmentType = SEGMENT_TYPES.B;
              eligibleForSegmentB = true;
              setFirstTaskAsInfinite();
              return true;
            } else if(isWithinValidSegmentPeriod(settings, segmentType)) {
              // Subsequents visits for segment B
              eligibleForSegmentB = true;
              setFirstTaskAsInfinite();
              return true;
            } else {
              return $q.reject('not valid for segment B - not in period');
            }
          } else {
            return $q.reject('not infinite');
          }
        });
      }
    }

    function isFirstVisitWithinValidProfilePeriod(settings, profileActivationDate) {
      if(_.isNull(segmentDate) && today.isBefore(profileActivationDate.add(settings.validProfilePeriod, 'days'))) {
        shouldSaveSegmentInfo = true;
        segmentType = SEGMENT_TYPES.A;
        return true;
      } else {
        return false;
      }
    }

    function checkIsShareEverythingInfinite() {
      var primarySubObj = _.find(accountDetails.subList, function (item) {
        return _.get(item, 'shareEverything.isPrimaryCtn', null);
      });
      var primaryCtn = _.get(primarySubObj, 'subNumber', null);

      if (!primaryCtn) {
        return $q.reject('not SE primary CTN');
      }

      var request = {
        ban: accountDetails.accountNumber,
        ctn: primaryCtn,
        language: languageService.getCurrentLanguage(),
        consolidatedInd: 'NO'
      };

      // cacheableData service has been used in data-manager to cache the "priceplans/current" API response. To prevent duplicate API call, we need to use the same mechanism here.
      return cacheableData({
        url: 'v1/ppc/priceplans/current',
        postData: request
      }).getData().then(function (response) {
        return _.get(response, 'data.infinite', null);
      }).catch(function () {
        return $q.reject('API Error - priceplans/current');
      });
      // return $q.when(true);
    }

    function isWithinValidSegmentPeriod(settings, segmentType) {
      // logic to check the code for future segments should come here
      switch (segmentType) {
        case SEGMENT_TYPES.A: return segmentDate.isValid() && today.isBefore(segmentDate.clone().add(settings.segmentAPeriod, 'days'));
        case SEGMENT_TYPES.B: return segmentDate.isValid() && today.isBefore(segmentDate.clone().add(settings.segmentBPeriod, 'days'));
        default: return false;
      }
    }

    function isConsumer() {
      if(userService.isConsumer()) {
        return $q.when(true);
      } else {
        return $q.reject('not consumer');
      }
    }

    function isOpenEligibleAccount() {
      if ((accountDetails.accountType === 1 || accountDetails.accountType === 6) &&
        _.get(accountDetails, '.accountInfo.status', '').toLowerCase() === 'active') {
        return $q.when(true);
      } else {
        return $q.reject('not an open wireless account');
      }
    }

    function areAllTasksCompleted() {
      return $q.all([
        isRecoveryNumberCompleted(),
        isOnlineBillingCompleted(),
        isAutoPaymentCompleted()
      ]).then(function (responses) {
        return responses[0] && responses[1] && responses[2];
      });
    }

    function completeTask(key) {
      var item = _.find(config, {itemKey: key});

      if (item) {
        item.completed = true;
        //triggerAlertRole();
      }

      //when all task are completed, need to save the state in the server.
      if (countCompletedTasks() === config.length) {
        setServerStatus();
      }
    }

    function saveSegmentInfo() {
      if(!segmentInfoSaved && shouldSaveSegmentInfo && !segmentDate) {
        setServerStatus(true)
          .then(function(res){
            if(res.isSuccess) {
              segmentInfoSaved = true;
            }
          });
      }
    }

    function handleAllTasksCompletedRes(allCompleted) {
      if (allCompleted && congratsDisplayed) {
        setServerStatus();
      }
      return !(allCompleted && congratsDisplayed);
    }

    function isRecoveryNumberCompleted() {
      var recoveryNumberItem = _.find(config, {itemKey: 'setRecoveryNumber'});

      if (recoveryNumberItem.completed) {
        return $q.when(true);
      } else if (!getGUID()) {
        return $q.reject('no guid');
      } else {
        return recoveryService.fetchPhone()
          .then(function (phoneNumber) {
            recoveryNumberItem.completed = true;
            return true;
          })
          .catch(function (data) {
            if (data === 200) {
              return false; // there is no phoneNumber
            } else {
              return $q.reject(data); // API error
            }
          });
      }
    }

    function isOnlineBillingCompleted() {
      var onlineBillingItem = _.find(config, {itemKey: 'setOnlineBilling'});

      if (onlineBillingItem.completed) {
        return $q.when(true);
      } else {
        return goPaperlessService.getBillingType(accountDetails.accountNumber, accountDetails.accountType)
          .then(function (billingType) {
            onlineBillingItem.completed = billingType && billingType.toLowerCase() === 'e_bill';
            return $q.when(onlineBillingItem.completed);
          });
      }
    }

    function isAutoPaymentCompleted() {
      var autoPaymentItem = _.find(config, {itemKey: 'setAutoPayment'});
      // for set payment method we should not cache response - because chances are cx change the method again directly from change payment method flow - accessible from menu
      return paymentMethodService.getMethodOfPayment(false, accountDetails.accountNumber, accountDetails.accountType)
        .then(function (res) {
          if (res.mopType === ute.rogers.account.overview.billing.detail.PaymentMethodType.C || res.mopType === ute.rogers.account.overview.billing.detail.PaymentMethodType.D) {
            //pre-auth payment (credit / debit)
            autoPaymentItem.completed = true;
            return autoPaymentItem.completed;
          } else if (res.mopType === ute.rogers.account.overview.billing.detail.PaymentMethodType.R) {
            //invoice
            autoPaymentItem.completed = false;
            return autoPaymentItem.completed;
          } else {
            return $q.reject('unknown mop');
          }
        });
    }

    function getProfileActivationDate() {
      //sample: 11/15/2017
      return $window.localStorage.getItem('profileActivationDate');
    }

    function getXSessionToken() {
      return $window.sessionStorage.getItem('xSessionToken');
    }

    function getGUID() {
      return $window.sessionStorage.getItem('guid');
    }

    function showOnboardingModule() {
      return isConsumer()
        .then(isSingleBan)
        .then(isOpenEligibleAccount)
        .then(checkClientStatus)
        .then(checkServerStatus)
        .then(isEligibleForSegmentA)
        .then(isEligibleForSegmentB)
        .then(saveSegmentInfo)
        .then(areAllTasksCompleted)
        .then(handleAllTasksCompletedRes)
        .catch(handleShowOnboardingError);
    }

    function countCompletedTasks() {
      return _.countBy(config, function (item) {
        return item.completed;
      }).true || 0;
    }

    function setToggleState(state) {
      toggleState = state;
    }

    function getToggleState() {
      return toggleState;
    }

    function getConfig() {
      return config;
    }

    function setCongratsDisplayed() {
      congratsDisplayed = true;
    }

    function setAccountDetails(detail) {
      accountDetails = detail;
    }

    function getAccountDetails() {
      return accountDetails;
    }

    function isSingleBan() {
      return accountOverviewService.getAccountOverview()
        .then(function (overview) {
          return overview.getAccountNumbers().length === 1 ? true : $q.reject('not single BAN');
        });
    }

    function handleShowOnboardingError(res) {
      if (typeof res === 'string') {
        console.log('hide onboarding, reason: ', res);
      } else {
        var data = res.data;
        var payload = dataLayerService.getConfigByMappingKey({
          mappingKey: 'advance.mappingKey.error.onboarding'
        });
        var api = _.get(res, 'config.url', '');
        var errorType = $window.ute.datalayer.common.service.ErrorType;
        var errorCategory = $window.ute.datalayer.common.service.ErrorCategory;
        var dataLayerPredefinedSection = $window.ute.datalayer.common.service.DataLayerPredefinedSection;
        var globalObjects = [dataLayerPredefinedSection.ACCOUNT, dataLayerPredefinedSection.PAGE, dataLayerPredefinedSection.SITE, dataLayerPredefinedSection.GLOBAL];

        if (_.has(data, 'status.code')) {
          dataLayerService.trackError(payload, errorType.HTTP, data.status.code, data.status.codeName, errorCategory.SELF_SERVE, '', api, false, globalObjects);
        } else {
          if (res.status === 404 && res.statusText === '') {
            res.statusText = 'API Not found';
          }
          dataLayerService.trackError(payload, errorType.HTTP, res.status, res.statusText, errorCategory.SELF_SERVE, '', api, false, globalObjects);
        }
      }
      return false;
    }

    function checkRegisteredToSmsRecoveryEvent() {
      return isRegisteredToSmsRecoveryEvent;
    }

    function getAnalyticsSegmentName() {
      var analyticsSegmentName = '';
      if(segmentType === SEGMENT_TYPES.A) {
        analyticsSegmentName ='newly registered myrogers profile';
      } else if (segmentType === SEGMENT_TYPES.B) {
        analyticsSegmentName = 'existing customer switch to infinite plan';
      }
      return analyticsSegmentName;
    }

    function reset() {
      config[0].completed = true;
      config[1].completed = false;
      config[2].completed = false;
      config[3].completed = false;

      congratsDisplayed = false;
      clientCompletedStatus = false;
      segmentDate = null;
      segmentType = null;
      segmentInfoSaved = false;
      isRegisteredToSmsRecoveryEvent = false;
      shouldSaveSegmentInfo = false;
      eligibleForSegmentA = false;
      eligibleForSegmentB = false;
    }

    return {
      showOnboardingModule: showOnboardingModule,
      setToggleState: setToggleState,
      getToggleState: getToggleState,
      getConfig: getConfig,
      setCongratsDisplayed: setCongratsDisplayed,
      setAccountDetails: setAccountDetails,
      getAccountDetails: getAccountDetails,
      countCompletedTasks: countCompletedTasks,
      checkRegisteredToSmsRecoveryEvent: checkRegisteredToSmsRecoveryEvent,
      getAnalyticsSegmentName: getAnalyticsSegmentName,
      reset: reset
    };
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrPaymentHistoryController', PaymentHistoryController);

  PaymentHistoryController.$inject = ['$scope',
    '$state',
    'ute.rogers.account.overview.factory',
    'myrPaymentHistoryService',
    'appState',
    'ajax',
    '$translate',
    'settings',
    'ute.blocks.language.switcher',
    'util',
    '$http',
    'CONFIG',
    'ute.common.user.service'];

  /* @ngInject */
  function PaymentHistoryController($scope,
                                    $state,
                                    accountOverviewFactory,
                                    paymentHistoryService,
                                    appState,
                                    ajax,
                                    $translate,
                                    settings,
                                    languageSwitcher,
                                    util,
                                    $http,
                                    CONFIG,
                                    userService) {
    // sorting-related
    // TODO: DSO-59787 Add new column (Details)
    var SORT_FIELDS = {
      DATE: 'tranDate',
      AMOUNT: 'amount',
      METHOD: 'paymentCode',
      DETAILS: 'paymentStatusDesc',
      REFERENCE: 'refNum'
    };

    // set default ordering
    var DEFAULT_SORT_REVERSE = {};
    DEFAULT_SORT_REVERSE[SORT_FIELDS.DATE] = true;
    DEFAULT_SORT_REVERSE[SORT_FIELDS.AMOUNT] = false;
    DEFAULT_SORT_REVERSE[SORT_FIELDS.METHOD] = false;
    DEFAULT_SORT_REVERSE[SORT_FIELDS.DETAILS] = false;
    DEFAULT_SORT_REVERSE[SORT_FIELDS.REFERENCE] = false;

    var defaultSortField = SORT_FIELDS.DATE;
    $scope.$extend({
      abs: Math.abs,
      isConsumer: userService.isConsumer(),
      isPopoverOpen: true,
      errorCode: 0,
      errorMessage: '',
      sortField: defaultSortField,
      sortReverse: DEFAULT_SORT_REVERSE[defaultSortField],
      histories: null,
      mappings: null,
      historyIsEmpty: false,
      pages: null,
      pagination: {
        start: 0,
        end: 0
      },
      totalPages: 0,
      sectionId: 1,
      grandTotal: 0,
      grandTotalPages: 1,
      more: false,
      recordsOnPage: settings.paymenthistory.itemsPerPage,
      lang: languageSwitcher.getCurrentLanguage(),
      maxSize: settings.paymenthistory.itemsPerPage * settings.paymenthistory.pagesPerSection,
      totalItems: 0,
      pageIndex: 0,
      currentPage: 1,
      loadingDataIndicator: false,
      monthsNames: util.getMonthsNames(),
      SORT_FIELDS: SORT_FIELDS,
      updateSortMethod: function (fieldName) {
        // do nothing if fieldName is blank
        if (!fieldName) {
          return;
        }

        // if currently selected value has been clicked again, toggle direction
        if (fieldName === $scope.sortField) {
          $scope.sortReverse = !$scope.sortReverse;
          return;
        }

        // otherwise, set sort field and direction and go to first page
        $scope.sortField = fieldName;
        $scope.sortReverse = DEFAULT_SORT_REVERSE[fieldName];
        $scope.goToPage(1);
      },
      getPages: function (value) {
        if (!value) {
          return;
        }
        var _rtn = [];

        var addIn = $scope.maxSize / $scope.recordsOnPage * ($scope.sectionId - 1);

        for (var i = 1; i <= value; i++) {
          _rtn.push(i + addIn);
        }
        return _rtn;
      },
      getPageRecords: function () {
        var addIn = $scope.maxSize / $scope.recordsOnPage * ($scope.sectionId - 1);
        var currInner = $scope.currentPage - addIn;
        var start = currInner * $scope.recordsOnPage - $scope.recordsOnPage;
        var end = currInner * $scope.recordsOnPage;

        $scope.pagination.start = start;
        $scope.pagination.end = end;

        $scope.formatDates();
      },
      formatDates: function () {
        if ($scope.histories === null) {
          return;
        }
        for (var i = 0; i < $scope.histories.length; i++) {
          var inner = $scope.histories[i];

          inner.tranDateForm = '';
          if (inner.tranDate === undefined) {
            continue;
          }

          var dtInner = Number(inner.tranDate);

          switch (languageSwitcher.getCurrentLanguage()) {
            case 'en':
              inner.tranDateForm = $scope.monthsNames[new Date(dtInner).getMonth()] + ' ' + new Date(dtInner).getDate() + ', ' + new Date(dtInner).getFullYear();
              break;
            case 'fr':
              inner.tranDateForm = new Date(dtInner).getDate() + ' ' + $scope.monthsNames[new Date(dtInner).getMonth()] + ' ' + new Date(dtInner).getFullYear();
              break;
          }
        }
      },
      goToPage: function (value) {
        // do nothing if attempting to switch to same page
        if ($scope.currentPage === value) {
          return;
        }

        // Look into  non_angular_script/supportFunctions.js  for more information\
        $scope.currentPage = value;
        $scope.getPageRecords();
      },
      goToPrev: function () {
        var addIn = $scope.maxSize / $scope.recordsOnPage * ($scope.sectionId - 1);

        $scope.currentPage -= 1;

        if ($scope.currentPage <= addIn) {  //back
          //$scope.currentPage = $scope.currentPage - addIn + 1;
          // $scope.pageIndex = $scope.pageIndex - $scope.maxSize;
          $scope.sectionId -= 1;
          $scope.getRecords();

        } else {
          $scope.getPageRecords();
        }
      },
      goToNext: function () {
        //var addIn = $scope.maxSize / $scope.recordsOnPage * ($scope.sectionId - 1);
        $scope.currentPage += 1;

        if ($scope.currentPage <= $scope.totalPages) {
          $scope.getPageRecords();
        } else {
          $scope.sectionId += 1;
          //$scope.pageIndex += $scope.maxSize * $scope.sectionId;
          $scope.getRecords();
        }
      },
      mapMethods: function () {
        if ($scope.histories === null) {
          return;
        }
        // TODO: Adjust mapping for payment methods here
        for (var yy = 0; yy < $scope.histories.length; yy++) {

          var currentHistory = $scope.histories[yy];
          currentHistory.paymentCode = currentHistory.paidBy;
          var tAmount = currentHistory.realAmount ? currentHistory.realAmount : (currentHistory.amount / 100);
          currentHistory.amount = Number(tAmount).toFixed(2)*1;

          for (var xx = 0; xx < $scope.mappings.PAYMENTS.PAYMENT.length; xx++) {
            var currentMap = $scope.mappings.PAYMENTS.PAYMENT[xx];
            if (currentMap.PYM_METHOD === currentHistory.paidBy) {
              // DSO-5978 CC, DD, and IN are the only displayed with their description. All other values are described as "Other"
              var descStatusList = ["CC", "DD", "IN"];
              var otherDesc = {"en": "Other", "fr": "Autre"}
              if (descStatusList.indexOf(currentMap.PYM_METHOD) >= 0) {
                currentHistory.paymentCode = ($scope.lang === 'en') ? currentMap.METHOD_DESC : currentMap.METHOD_DESC_F;
              } else {
                currentHistory.paymentCode = ($scope.lang === 'en') ? otherDesc.en : otherDesc.fr;
              }
            }
          }
        }
      },
      mapStatuses: function () {
        if ($scope.histories === null) {
          return;
        }
        // Private function to map payment status with description as per current language
        var map = $scope.mappings.PAYMENTS.STATUS;
        $scope.histories = _.filter($scope.histories, function(currentHistory){
          _.forEach(map, function(status) {
            if (currentHistory.status === status.CODE) {
              currentHistory.paymentStatusDesc = ($scope.lang === 'en') ? status.STATUS_SHORT_DESC : status.STATUS_SHORT_DESC_F;
            }
          });
          if (currentHistory.status === 'BCK' || currentHistory.status === 'RETURNED CHEQUE' || currentHistory.status === 'FNTF') {
            currentHistory.amountPrefix = '-';
            currentHistory.amount *= -1;
          } else if (currentHistory.status === 'RFN' || currentHistory.status === 'REVERSAL') {
            currentHistory.amountPrefix = '+';
          }
          return !!currentHistory.paymentStatusDesc;
        });
      }
    });
    //initialize
    $scope.state = $state.current.name;

    $scope.getRecords = function () {
      paymentHistoryService.selectSection($scope.sectionId - 1);
      var _currentSection = paymentHistoryService.currentSection();
      var _currentSectionData = paymentHistoryService.getSectionItems(_currentSection);

      $scope.pageIndex = _currentSection * $scope.maxSize;
      $scope.loadingDataIndicator = true;

      ajax.billHistory({
        accountId: $scope.selectedAccount.accountNumber,
        accountType: $scope.selectedAccount.accountType,
        index: $scope.pageIndex,
        pageSize: $scope.maxSize
      }).then(
        function (response) {
          $scope.loadingDataIndicator = false;
          if (response.data === undefined) {
            $scope.errorCode = 50000;
          }
          else {

            /*              var resourceCache = $http.get('resource/paymentcodes.json').then(function (mappings) {
             resourceCache = mappings.data;

             $scope.mappings = mappings.data;*/
            //map the payment method names.
            initSection(response.data);
            //store the section data in the service.
            paymentHistoryService.addSectionData(response.data);
          }

        },
        function (error) {
          $scope.historyIsEmpty = true;
          $scope.loadingDataIndicator = false;
          $scope.errorMessage = $translate.instant('maintenance_info_history');
          //$scope.errorCode = error.error.errorCode;
          //// Error handling - 555 exception
          //if (error.data.status === 555) {
          //
          //	$scope.errorMessage = error.error.errorCode + ' - ' + error.error.errorMessage;
          //
          //} else {
          //	// anything but status code 555
          //	$scope.errorMessage = error.data.status + ' - ' + error.data.statusText;
          //}
        }
      );
    };

    $scope.init = function () {
      scrollPageToTop();
      $scope.popoverOptions = {
        isOpen: new Array(10)
      };
      for(var i=0; i< $scope.popoverOptions.isOpen.length; i++){
        $scope.popoverOptions.isOpen[i] = false;
      }
      var accountOverviewService = accountOverviewFactory();
      accountOverviewService.getSelectedAccount()
        .then(function (account) {
          $scope.selectedAccount = {};
          $scope.selectedAccount.accountNumber = account.accountNumber;
          $scope.selectedAccount.accountType = account.accountTypeNumber;
          // TODO: It shall take into account differences in account types (Wireless, SIG, Maestro)
          if ($scope.selectedAccount.accountNumber && $scope.selectedAccount.accountType) {
            appState.tagging(['_trackPageView',
              {pn: 'home:myrogers:payment-history'}
            ]);
            //get map data for the payment method
            var resourceCache = $http.get('resource/paymentcodes.json')
              .then(function (mappings) {
                resourceCache = mappings.data;
                $scope.mappings = mappings.data;
                $scope.getRecords();
                $http.get('/web/totes/cms/content/json/paymentstatuses.json?' + CONFIG.buildTimestamp)
                  .then(function (statuses) {
                    $scope.mappings.PAYMENTS.STATUS = statuses.data.STATUS;
                  });
              });
          }
        })
        .catch(function () {
          appState.switchView('accountOverview');
        });
    };

    function initSection(response) {
      $scope.histories = response.records;
      $scope.mapMethods();
      $scope.mapStatuses();

      $scope.totalItems = $scope.histories.length;
      $scope.historyIsEmpty = !(!!$scope.totalItems);// false if 0 or '' or undefined
      $scope.totalPages = Math.ceil($scope.totalItems / $scope.recordsOnPage);
      $scope.grandTotalPages = $scope.totalPages + $scope.maxSize / $scope.recordsOnPage * ($scope.sectionId - 1);
      $scope.grandTotal = response.total;
      $scope.more = response.more;
      $scope.getPageRecords();

      $scope.pages = $scope.getPages($scope.totalPages);
    }

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.monthsNames = util.getMonthsNames();
      $scope.lang = lang;
      // $scope.formatDates();

      $scope.mapMethods();
      $scope.mapStatuses();
      $scope.formatDates();
    }, 'paymentHistoryControllerLangSub');

    $scope.$on('$destroy', function () {
      languageSwitcher.unregisterOnDataChangeHandler('paymentHistoryControllerLangSub');
    });

    $scope.loadingDataIndicator = true;
    $scope.init();
    // TODO: For SGI Account check
    $scope.isSGIAccount = function () {
      return $scope.selectedAccount ? $scope.selectedAccount.accountType === 6 : undefined;
    };

    $scope.closePopover = function() {
      $scope.popoverOptions.isOpen.forEach(function(item, index, theArray) {
        theArray[index] = false;
      });
    };

    $scope.popoverClickHandler = function(index) {
      $scope.closePopover();
      $scope.popoverOptions.isOpen[index] = true;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.service:myrPaymentHistoryService
   * @description
   * # paymentHistoryService
   * Controller of the totesApp
   * It sorts the payment history by payment date/amount/method/reference#
   * Page navigation is 10 items/per page. Can be configured through settings.paymenthistory.
   */
  angular.module('totesApp').factory('myrPaymentHistoryService', paymentHistoryService);

  paymentHistoryService.$inject = ['$q', 'ajax', 'settings'];

  /* @ngInject */
  function paymentHistoryService($q, ajax, settings) {
    // Public API
    var service = {
      addSectionData: addSectionData,
      selectSection: selectSection,
      getPageItems: getPageData,
      getSectionItems: getSectionData,
      currentSection: currentSection,
      itemsPerPage: itemsPerPage,
      pagesPerSection: pagesPerSection,
      getMethods: getMethods,
      sortHistory: sortHistory
    };

    //current section data
    var _history = null;
    var _itemsPerPage = settings.paymenthistory.itemsPerPage;
    var _pagesPerSection = settings.paymenthistory.pagesPerSection;
    var _currentSectionNo = 0;
    var _currentPageNo = 0;
    var _sectionData = [];
    var _pageData = [];
    var _pages = [];
    var _endPoint = false;
    var _sortMethod = [
      {
        id: 1,
        label: 'history_sort_by_date'
      },
      {
        id: 2,
        label: 'history_sort_by_amount'
      },
      {
        id: 3,
        label: 'history_sort_by_method'
      },
      {
        id: 4,
        label: 'history_sort_by_reference'
      }
    ];

    return service;

    /**
     * Store the data into a new section object, and increase the total section number.
     * @param data, the section list, require a json object.
     *
     */
    function addSectionData(data) {
      //var _list = $.parseJSON(data);
      var _list = data;
      if (!!_list) {
        _sectionData.push(_list);
      }
    }

    /**
     * Return the section data at the given index.
     * @param id: the section index.
     * @return the selected section data.
     */
    function getSectionData(id) {
      if (0 < id < _sectionData.length) {
        return _sectionData[id];
      } else {
        return null;
      }
    }

    /**
     *
     * @returns {number}
     */
    function currentSection() {
      return _currentSectionNo;
    }

    function itemsPerPage() {
      return _itemsPerPage;
    }

    function pagesPerSection() {
      return _pagesPerSection;
    }

    function getMethods() {
      return _sortMethod;
    }

    function sortHistory(sortMethod) {
    }

    /**
     * Set the given index as the current section and initialize the page data.
     * @param id: the section index.
     *
     */
    function selectSection(id) {
      _currentSectionNo = id;
    }

    /**
     * Return the page data at the given index.
     * @param id: the page index.
     *
     */
    function getPageData(id) {
      var _ret = [], _baseIndex, _endIndex, _currentSectionData;
      if (0 < id < (_pagesPerSection - 1)) {
        _baseIndex = id * _itemsPerPage;
        _endIndex = _baseIndex + _itemsPerPage;
        _currentSectionData = getSectionData(_currentSectionNo);
        for (var j = _baseIndex; j < _endIndex; j++) {
          _ret.push(_currentSectionData[j]);
        }
      }
      return _ret;
    }
  }
})();

/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular
    .module('totesApp')
    .controller('MyrReserveDeviceCtrl', _controller);

  _controller.$inject = ['$scope', '$rootScope', '$state', 'myrReserveDeviceService', '$timeout'];

  /* @ngInject */
  function _controller($scope, $rootScope, $state, myrReserveDeviceService, $timeout) {

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line
    var iframeHeightResizeCount = 0;
    var iframeTimeout;
    var postToSalesForceTimer;
    var showSalesForceFrameTimer;
    $scope.state = $state.current.name;

    function resizeIframe() {
      if ($state.current.name !== 'reservedevice') {
        return;
      }
      var height = $('#sf_iframe').contents().height();

      var width = $('.iframe-rd').width();
      if (iframeHeightResizeCount < 16) {
        var timer = 1000;
        if (iframeHeightResizeCount > 1) {
          timer = 2000;
        } else if (iframeHeightResizeCount > 10) {
          timer = 30000;
        }
        $('#sf_iframe').height(height);
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, timer);
      } else {
        $('#sf_iframe').width(width + 1);
        $('#sf_iframe').width(width - 1);
        iframeTimeout = $timeout(resizeIframe, 50);
      }
      $('#sf_iframe').hide();
      $('#sf_iframe').show();
      iframeHeightResizeCount++;
    }


    $scope.$extend({
      loadSalesForeFrame: function (link) {
        if ($rootScope.salesForceFailed) {
          $scope.salesForceFailed = true;
        } else {
          $scope.salesForceFailed = false;

          //var sfErrorMessage = $translate.instant('sf_error_message');
          $scope.loadingDataIndicator = true;
          /*var current_location = window.location;
           var myHistory = $window.history.state;
           console.log(myHistory);
           $window.history.pushState(myHistory, "View Bill", current_location);*/

          postToSalesForceTimer = $timeout(postToSalesForce, 1000);
          //iframeHeightResizeCount = 0;
          //iframeTimeout = $timeout(resizeIframe, 1000); //TODO to be check if need
          $rootScope.bbloadingDataIndicator = true;       //TODO need a busy loading indicator
          showSalesForceFrameTimer = $timeout(showSalesForceFrame, 1000);

        }
      }
    });

    $scope.$on('loadSalesForceFrame', function (event, args) {
      $scope.loadSalesForeFrame();
    });

    $scope.$on("$destroy",function( event ) {
        $timeout.cancel(showSalesForceFrameTimer); 
        $timeout.cancel(postToSalesForceTimer); 
        $timeout.cancel(iframeTimeout);                     
    });

    function showSalesForceFrame() {
      $('#sf_iframe').show();
      $rootScope.bbloadingDataIndicator = false;
    }

    function postToSalesForce() {
      $('#formToSalesForce').attr('action', myrReserveDeviceService.loadSalesForceUrl());
      $('#formToSalesForce').submit();
    }
  }

})();

/**
 * @ngdoc directive
 * @name reserveDevice
 *
 * @description
 *  reserve device salesForce iFrame and post Form template directive
 *
 * @restrict A
 * */
(function () {
  'use strict';
  angular
    .module('totesApp')
    .directive('myrReserveDevice', _reserveDevice);

  function _reserveDevice() {
    var directive = {
      restrict: 'EA',
      scope: true,
      templateUrl: 'scripts/modules/reserveDevice/nrsform.html',
      replace: true,
      controller: 'MyrReserveDeviceNRSFormCtrl',
      controllerAs: 'rd',
      bindToController: true
    };
    return directive;
  }
})();

/**
 * @ngdoc service
 * @name reserveDeviceTokenService
 * @description
 * get NRS Encrypt Data for post to SalesForce iFrame
 *
 * */


(function () {
  'use strict';

  angular
    .module('totesApp')
    .factory('myrReserveDeviceNRSDataService', _service);

  _service.$inject = ['ajax', '$translate'];

  /* @ngInject */
  function _service(ajax, $translate) {

    var Service = {
      getEncryptNRSData: getEncryptNRSData
    };

    return Service;

    function getEncryptNRSData(request, callback) {
      var _result = {};
      ajax.getEncryptNRSData(request).then(
        function (data) {

          if (data) {
            _result.result = 'success';
            _result.data = data;
            return callback(_result);
          } else {
            _result.result = 'fail';
            _result.data = data;
            return callback(_result);
          }
        }, function (error) {
          // Error handling - 555 exception
          if (error.data.status === 555) {
            _result.result = 'error';
            _result.data = error;
            _result.message = $translate.instant(error.error.errorCode);
            return callback(_result);

          } else {
            // anything but status code 555
            _result.result = 'error';
            _result.data = error;
            _result.message = $translate.instant('maintenance_info');//TODO need error message define here
            return callback(_result);
          }
        }
      );
    }
  }

})();

/**
 * @ngdoc controller
 * @name reserveDevice
 *
 * @description
 * _Please update the description and dependencies._
 *
 * @requires $scope
 * */

(function () {
  'use strict';
  angular.module('totesApp').controller('MyrReserveDeviceNRSFormCtrl', _controller);

  _controller.$inject = ['$scope',
    '$rootScope',
    '$location',
    'localStorage',
    'ute.blocks.language.switcher',
    'myrReserveDeviceNRSDataService',
    'ute.common.core.brtswitch.service'];

  /* @ngInject */
  function _controller($scope,
                       $rootScope,
                       $location,
                       localStorage,
                       languageSwitcher,
                       myrReserveDeviceNRSDataService,
                       brtSwitchService) {

    var vm = this; // jshint ignore:line

    vm.salesForceIframeUrl = '';
    vm.encryptedString = '';
    vm.encryptedSignature = '';

    activate();

    function activate() {
      $rootScope.salesForceFailed = false;
      brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.NRS).then(function (isNrs) {
        if (isNrs) {
          var _ctn = localStorage.getLocalStorageValue('phoneNumber') ? localStorage.getLocalStorageValue('phoneNumber') : '';
          var _ban = localStorage.getLocalStorageValue('accountNumber') ? localStorage.getLocalStorageValue('accountNumber') : '';
          var _cancelUrl = $location.absUrl().replace($location.path(), '/accountOverview');

          var _req = {
            applicationId: 'Rogers.com',
            ctn: _ctn,
            ban: _ban,
            language: languageSwitcher.getCurrentLanguage(),
            cancel: _cancelUrl
          };
          myrReserveDeviceNRSDataService.getEncryptNRSData(_req, function (_data) {
            if (_data.result === 'success') {
              if (_data.data.userCustomerBANInfo) {
                vm.encryptedString = _.unescape(_data.data.userCustomerBANInfo);
              }
              if (_data.data.userCustomerBANInfoSignature) {
                vm.encryptedSignature = _data.data.userCustomerBANInfoSignature;
              }
              $scope.$emit('loadSalesForceFrame', null);
            } else if (_data.result === 'fail') {
              $rootScope.salesForceFailed = true;
            } else if (_data.result === 'error') {
              $rootScope.salesForceFailed = true;
              //$rootScope.salesForceFailed = false; //debug
              //vm.encryptedString = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?><ns2:RogersNRSInfo xmlns:ns2="http://wireless.rogers.com/schemas/ReserveDevice/NRS"><UserInfo><userId>c0014fd1-1658-44f9-85be-cec93e86adff</userId><userEmail>postpaid@715.com</userEmail></UserInfo><BanInfo><BanDetails><CTNs><CTNInfo><ctn>4162623678</ctn><selectedCTN>true</selectedCTN></CTNInfo><CTNInfo><ctn>4162622984</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>DONTUSE</firstName><lastName>TOTESDQAQG</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo>4162222222</workTelNo><homeTelNo>4161111111</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>true</selectedBAN><ban>728189904</ban></BanDetails><BanDetails><CTNs><CTNInfo><ctn>4162580098</ctn><selectedCTN>false</selectedCTN></CTNInfo></CTNs><Customer><Name><firstName>JOHN</firstName><lastName>CASTOR</lastName><initial></initial><additionalTitle></additionalTitle><title></title><suffix></suffix></Name><BillingAddress><primaryLine>***,</primaryLine><secondaryLine></secondaryLine><additionalLine></additionalLine><aptNumber></aptNumber><aptDesignator></aptDesignator><city></city><province>**</province><country></country><postCode></postCode><attention></attention></BillingAddress><ContactInformation><workTelExtNo></workTelExtNo><workTelNo></workTelNo><homeTelNo>4168169457</homeTelNo><emailAddressV21></emailAddressV21><contactPhoneNumber></contactPhoneNumber><faxNumber></faxNumber></ContactInformation></Customer><selectedBAN>false</selectedBAN><ban>728194695</ban></BanDetails></BanInfo><RogersIntInfo/><locale>en</locale></ns2:RogersNRSInfo>';
              //vm.encryptedSignature = 'C1czPCVVV8PlN3ptegFiKjVfBIvZDg0TZmzA6xhnx80=';
              //$scope.$emit('loadSalesForceFrame', null);
            }
          });
        } else {
          $('#formToRogersReserveDevice').attr('action', '/web/RogersServices.portal?_nfpb=true&_pageLabel=ReserveDevice' + '&setLanguage=' + $scope.lng);
          $('#formToRogersReserveDevice').submit();
        }
      }).catch(function (error) {
        $rootScope.salesForceFailed = true;
      });
    }
  }
})();

/**
 * @ngdoc service
 * @name myrReserveDeviceService
 * @description
 * get SalesForce iFrame URL
 *
 * */

(function () {
  'use strict';
  angular
      .module('totesApp')
      .factory('myrReserveDeviceService', _service);

  _service.$inject = ['settings'];

  /* @ngInject */
  function _service(settings) {

    var service = {
      loadSalesForceUrl: loadSalesForceUrl
    };
    return service;

    function loadSalesForceUrl() {
      var iFrameUrl;
      if (settings.isDevBB) {
        iFrameUrl = settings.salesForceUrl.dev;
      } else if (settings.isQaBB) {
        iFrameUrl = settings.salesForceUrl.qa;
      } else if (settings.isProdBB) {
        iFrameUrl = settings.salesForceUrl.prod;
      } else {
        iFrameUrl = settings.salesForceUrl.prod;
      }
      return iFrameUrl;
    }
  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.rgcl').factory('myrRgclService', rgclService);

  rgclService.$inject = ['ajax', 'ute.blocks.language.switcher', 'sessionStorage', '$rootScope'];

  /* @ngInject */
  function rgclService(ajax, languageSwitcher, sessionStorage, $rootScope) {

    // Public API
    var service = {
      loadingData: false,
      rgclEligible: false,
      segmentNumber: 0,
      callGetSegmentationForRGCL: callGetSegmentationForRGCL
    };

    var data = {
      rgclEligibile: false,
      segmentNumber: 0
    };

    return service;

    ///////////////////////////////////////////////////////////////

    /**
     *
     * @param accountNumber
     */

    function callGetSegmentationForRGCL(accountNumber) {

      service.loadingData = true;
      if ($rootScope.isCare) {
        accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      }
      return ajax.getSegmentationForRGCL({
        accountNumber: accountNumber,
        language: languageSwitcher.getCurrentLanguage().toUpperCase(),
        applicationId: 'Rogers.com'
      }).then(function (responseData) {
            service.rgclEligible = data.rgclEligibile = responseData.rgclEligibile;
            service.segmentNumber = data.segmentNumber = responseData.segmentation;
            service.loadingData = false;
            return data;
          }, function (error) {
            service.rgclEligible = false;
            data.rgclEligibile = false;
            service.loadingData = false;
            return data;
          }
      );
      //return true;
    }

  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:RhpDashboardController
   * @description
   * # RhpDashboardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrRhpDashboardController', RhpDashboardController);

  RhpDashboardController.$inject = ['$scope',
    '$state',
    'appState',
    '$translate',
    '$timeout',
    'myrRhpDashboardService',
    '$window',
    'liveChatSettings',
    '$modal',
    'ute.common.user.service',
    'ute.blocks.language.switcher',
    '$http',
    'ute.datalayer.common.service'];

  /* @ngInject */
  function RhpDashboardController($scope,
                                 $state,
                                 appState,
                                 $translate,
                                 $timeout,
                                 rhpDashboardService,
                                 $window,
                                 liveChatSettings,
                                 $modal,
                                 userService,
                                 languageSwitcher,
                                 $http,
                                 dataLayerService) {
    var vm = this;
    vm.loadingDataIndicatorRhpDashboard = true;
    vm.rhpInfo = {};
    vm.callingFeatures = [];
    vm.additionalFeatures = [];
    vm.defaultPlan = "";
    vm.lng = languageSwitcher.getCurrentLanguage();
    vm.errorMessage = null;
    vm.selectedAccount = {};
    vm.showTooltip = false;
    if($window.innerWidth > 768) {
      vm.isCollapsed = true;
    } else {
      vm.isCollapsed = false;
    }

    vm.isConsumer = function () { return userService.isConsumer(); };
    vm.isCare = function () { return userService.isCare(); };
    //var formToRogersTimer;

    /* vm.postToRogers = function (actionId) {
        gotoURL = vm.lng === 'en' ? postToRogersUrls.en : postToRogersUrls.fr;
        var formToRogersElement = $('#formToRogers');
        formToRogersElement.attr('action', gotoURL[actionId].url);
        formToRogersElement.submit();
        formToRogersElement = null;
    }; */
    vm.configureFeaturesClicked = function () {
      var payload = {'events' :
                              {'interaction': 'true'},
                     'interaction':
                               {'type':'click', 'name':'rhp dashboard –configure your current features'}
                     };
        gotoURL = vm.lng === 'en' ? postToRogersUrls.en[1].url : postToRogersUrls.fr[1].url;
        $window.location.replace(gotoURL);
         /* Handling Analytics for "Configure your current features"*/
        try{
           dataLayerService.track(payload);
        } catch (e){
           console.log(e);
        }
    };
    /* Handling Analytics for "Access your voicemail settings"
       Payload requries only Events and Interaction.
    */
    vm.voiceMailSettingsAnalytics = function() {
      var payload = {'events' :
                             {'interaction': 'true'},
                    'interaction':
                              {'type':'click', 'name':'rhp dashboard – access your voicemail settings'}
                    };
         try{
             dataLayerService.track(payload);
         } catch (e){
            console.log(e);
         }
    };
    /**
     * to show the modal when user clicks on reset voicemail password
     * @memberof rhpAccountController
     */
    /* vm.resetVoicemailPasswordOpenModal = function () {
      var modalInstance = $modal.open({
        templateUrl: 'views/modals/reset-voicemail-password.html',
        controller: ['$scope', function ($scope) {
          $scope.close = function () {
            modalInstance.close();
          };
          $scope.resetVoicemailPassword = function () {
          var resetPasswordRequestData = {
            accountNumber:  vm.selectedAccount.ban,
            applicationId: 'rogers.com',
            language: vm.lng,
            refresh: true,
            subAccountId:  vm.selectedAccount.can,
            subscriptionId: vm.rhpInfo.homePhoneNumber
          }
          console.log('resetPasswordRequestData', resetPasswordRequestData);
          rhpDashboardService.resetRhpVoicemailPassword(resetPasswordRequestData).then(
            function (response) {
                if(response) {
                   console.log('reset password success');
                   modalInstance.close();
                }
                else {
                  console.log('reset password failed');
                  modalInstance.close();
                }
            },
            function (error) {
               console.log('reset password failed');
               modalInstance.close();
          });
          //To do call home phone resetvoice mail password API
          };

        }],
        windowClass: 'rhp-reset-voicemail-passsword'
      });
    };  */

    vm.manageFeaturesOpenModal = function() {
      var payload = {'page':
                          {'name': 'modal – rhp dashboard : want to add or remove a feature?',
                          'hierarchy': ['myrogers', 'legacy home phone dashboard']}
                     };
       var modalInstance = $modal.open({
          templateUrl: 'views/modals/rhp-add-or-remove-feature.html',
          controller: ['$scope', '$translate', function ($scope, $translate) {
            $scope.close = function () {
              modalInstance.close();
            };
            $scope.isManageFeature = true;
            $scope.isResetPassword = false;
            $scope.rhpLiveChatUrl = $translate.instant('ute.rogers.rhpDashboard.rhp_live_chat_url');
            $scope.rhpContactPhoneNumberUrl = $translate.instant('ute.rogers.rhpDashboard.rhp_contact_care_phoneNumber_url');
            $scope.lang = vm.lng;
         }],
         windowClass: 'rhp-mange-features'
       });
      var UTEDataLayerService = ute.datalayer.common.service;
      var section = UTEDataLayerService.DataLayerPredefinedSection;
      var selectedSections = [section.PAGE, section.SITE, section.PAGE_VIEW_EVENT];
      /* Handling Analytics for "Contact us to manage features"*/
      try{
        dataLayerService.track(payload,true,selectedSections);
      }catch (e){
        console.log(e);
      }
   };

   vm.resetPasswordOpenModal = function() {
      var payload = {'page':
                    {'name': 'modal – rhp dashboard : need a new voicemail password ?',
                    'hierarchy': ['myrogers', 'legacy home phone dashboard']}
                    };
      var modalInstance = $modal.open({
         templateUrl: 'views/modals/rhp-add-or-remove-feature.html',
         controller: ['$scope', '$translate', function ($scope, $translate) {
           $scope.close = function () {
            modalInstance.close();
            };
            $scope.isManageFeature = false;
            $scope.isResetPassword = true;
            $scope.rhpLiveChatUrl = $translate.instant('ute.rogers.rhpDashboard.rhp_live_chat_url');
            $scope.rhpContactPhoneNumberUrl = $translate.instant('ute.rogers.rhpDashboard.rhp_contact_care_phoneNumber_url');
            $scope.lang = vm.lng;
          }],
          windowClass: 'rhp-mange-features'
        });
        var UTEDataLayerService = ute.datalayer.common.service;
        var section = UTEDataLayerService.DataLayerPredefinedSection;
        var selectedSections = [section.PAGE, section.SITE, section.PAGE_VIEW_EVENT];
        /* Handling Analytics for "Reset your voicemail password"*/
        try{
           dataLayerService.track(payload,true,selectedSections);
        }catch (e){
           console.log(e);
        }

    };

    vm.rhpIsToolTipExists = function(featureCode) {
      if(featureCode && (featureCode === 'T117' || featureCode === 'T119')) {
        return true;
      }
      return false;

    };

    vm.isFeatureAvailable = function(feature) {
      var featureName = feature && feature.featureName ? feature.featureName : '';
      if(featureName === '' || (featureName && (featureName.length === 0 || featureName.indexOf('Undefined Feature') > -1 || featureName.indexOf('Impossible d\'accéder à la fonction') > -1))) {
        return false;
      }
      return true;
    };

    vm.isPlanAvailable = function(planName) {
      if(planName === '' || (planName && (planName.length === 0 || planName.indexOf('Unidentified Plan') > -1))) {
        return false;
      }
      return true;
    }

    var gotoURL, postToRogersUrls, errorCode;
    var rhpResponse = {};

    /**
     * Setting for floating chat button
     */
    vm.liveChatSettings = liveChatSettings;
    // check maintainence for RHP  dahsboard
    if (appState.checkMaintenance('HOME_PHONE_ON_MAINTENANCE')) {
      $state.go('underMaintenance');
    }
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    vm.selectedAccount.accountName = {};
    vm.selectedAccount.accountNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER);
    vm.selectedAccount.ban = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
    vm.selectedAccount.can = userService.getPersistentService().get('homePhoneAccountNumber')

    function loadDefaultPlan() {
      // $http.get('/web/totes/cms/content/json/home_phone/home_phone_plan.json')
      //   .then(function (obj) {
      //     if(obj && obj.data) {
      //       vm.defaultPlan = obj.data;
      //     }
      //   }, function (error) {

      //    });
      vm.defaultPlan = {
        "en": { "planName": "Home Phone" },
        "fr": { "planName": "Téléphonie résidentielle" }
      }
    }

    function processResponse (response) {
      console.log('rhp response', response);
      if (_.isEmpty(response) || response.error !== null) {
        vm.displayContentRhpDashboard = false;
        vm.loadingDataIndicatorRhpDashboard = false;
        errorCode = 50000;
        //vm.errorMessage = $translate.instant(errorCode);
        vm.errorMessage = $translate.instant('ute.rogers.rhpDashboard.rhp_error_text');
      } else {
        vm.rhpInfo = response;
        vm.callingFeatures = vm.rhpInfo[vm.lng] && vm.rhpInfo[vm.lng].callingFeatures ? vm.rhpInfo[vm.lng].callingFeatures : [];
        vm.callingFeatures = _.filter(vm.callingFeatures, vm.isFeatureAvailable);
        vm.additionalFeatures = vm.rhpInfo[vm.lng] && vm.rhpInfo[vm.lng].additionalFeatures ? vm.rhpInfo[vm.lng].additionalFeatures : [];
        vm.additionalFeatures = _.filter(vm.additionalFeatures, vm.isFeatureAvailable);
        vm.displayContentRhpDashboard = true;
        //vm.loadingDataIndicatorRhpDashboard = (response.cachedResultInfo == null || !response.cachedResultInfo) ? false : response.cachedResultInfo.expired;
        vm.loadingDataIndicatorRhpDashboard = false;
      }
    };

    function loadRhpDashboard () {
      vm.loadingDataIndicatorRhpDashboard = true;
      vm.displayContentRhpDashboard = false;
      if (!vm.selectedAccount.accountNumber) {
        return;
      }
      rhpDashboardService.rhpDashboard(vm.selectedAccount.ban, vm.selectedAccount.accountNumber, vm.selectedAccount.can).then(
        function (response) {
               vm.displayContentRhpDashboard = true;
               processResponse(response);
        },
        function (error) {
          vm.displayContentRhpDashboard = false;
          vm.loadingDataIndicatorRhpDashboard = false;
          // Error handling - 555 exception
          if (error.data.status === 555) {
            errorCode = error.error.errorCode;
            //vm.errorMessage = error.error.message;
            vm.errorMessage = $translate.instant('ute.rogers.rhpDashboard.rhp_error_text');
          } else {
            vm.errorMessage = $translate.instant('ute.rogers.rhpDashboard.rhp_error_text');
          }
        });
    };



    loadRhpDashboard();
    loadDefaultPlan();

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      init(lang);
    }, 'rhpDashboardControllerLangSub');

    $scope.$on('$destroy', function () {
      languageSwitcher.unregisterOnDataChangeHandler('rhpDashboardControllerLangSub');
      //$timeout.cancel(formToRogersTimer);
    });

    init(languageSwitcher.getCurrentLanguage());

    function init(lang) {
      var oldLang = vm.lng;
      vm.lng = lang;

      if (oldLang !== vm.lng) {
        loadRhpDashboard();
      }
    }

    postToRogersUrls = {
      en: [
        {url: '/web/torcom/OnlineManager.portal?maestroIndicator=true'},
        {url: '/web/torcom/OnlineManager.portal?maestroIndicator=false'},
        {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=HomePhone_Service#'}
      ],
      fr: [
        {url: '/web/OnlineManager.portal?maestroIndicator=true&setLanguage=fr'},
        {url: '/web/OnlineManager.portal?maestroIndicator=false&setLanguage=fr'},
        {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=HomePhone_Service&_nfls=true&setLanguage=fr#'}
      ]
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrRhpDashboardService', rhpDashboardService);

  rhpDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function rhpDashboardService(ajax, $q) {
    var rhpResponse, previousBan, previousCan, previousHomePhone = null;
    // Public API
    var service = {
      rhpDashboard: rhpDashboard,
      resetRhpVoicemailPassword: resetRhpVoicemailPassword
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function rhpDashboard(ban, homePhone, can) {
      var deferred = $q.defer();
      // call rhpDashBoard/homePhonePackages api to get data
      if(null!=rhpResponse && !isNewRequest(ban, homePhone, can)){ //Check if the response is already in context, do not trigger another call if it is..
        deferred.resolve(rhpResponse);
      }else{
      var passJson = {
              applicationId: 'Rogers.com',
              accountNumber: (previousBan = ban),
              phoneNumber: (previousHomePhone = homePhone),
              cableAccountNumber: (previousCan = can)
            };
            ajax.getHomePhonePackages(passJson).then(
              function (response) {
                if (response) {
                 rhpResponse = response;
                 deferred.resolve(response);
                }
              }, function (error) {
                deferred.reject(error);
              });
      }

      return deferred.promise;
    }

    function isNewRequest(ban, homePhone, can){
      return (ban!=previousBan) || (can!=previousCan) || (homePhone!=previousHomePhone);
    }
    function resetRhpVoicemailPassword(postData) {
      var deferred = $q.defer();
      // call  home phone resetRhpVoicemailPassword api
      ajax.resetRhpVoicemailPassword(postData).then(
        function (response) {
          if (response) {
           deferred.resolve(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:MyrSigninController
   * @description
   * # MyrSigninController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('MyrSigninController', SigninController);

  SigninController.$inject = ['$scope',
    '$stateParams',
    'appState',
    'user',
    '$browser',
    '$window',
    'ajax',
    'webanalytics',
    'localStorage',
    'myrSigninService',
    '$log',
    'cookieStore',
    'deeplink',
    '$translate',
    'ute.dtm.service',
    'ute.common.core.brtswitch.service',
    'ute.data.manager.service',
    'ute.blocks.language.switcher',
    'ute.common.user.service'];

  /* @ngInject */
  function SigninController($scope, // jshint ignore:line
                            $stateParams,
                            appState,
                            user,
                            $browser,
                            $window,
                            ajax,
                            webanalytics,
                            localStorage,
                            signinService,
                            $log,
                            cookieStore,
                            deeplink,
                            $translate,
                            dtmService,
                            brtSwitchService,
                            dataManagerService,
                            languageSwitcher,
                            userService) {
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    //$scope.isLocked = Boolean($location.search().lock) || false; //required
    $scope.pasted = false;
    $scope.email = '';
    $scope.password = '';
    $scope.submitted = '';
    $scope.attempts = 0;
    $scope.maxAttempts = 5;
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.myRogersPermission = true; //permissionResolver.data.showWidget,
    $scope.isDisabled = false;
    $scope.isWaiting = false; // Show loader while resolving user credentials
    $scope.isWaitingClass = ''; // Additional style that would be added to login button
    $scope.loginWaiting = false;
    $scope.rememberMe = Boolean(cookieStore.get('rememberMe'));
    var deepJSON = '';
    var emptyUsernameField = '';
    var emptyPasswordField = '';
    $scope.signinType = 'MyRogers'; //This should be updated with Facebook or Gmail sign in type once functionality is available
    var vm = this;
    vm.dtmService = dtmService;
    vm.dtmSignin = 'sign-in attempt';
    vm.dtmSuccess = 'sign-in success';
    vm.dtmError = 'sign-in error';
    $scope.boldChatButton = null;
    $scope.chatButtonOld = null;
    $scope.getAndroidAppUrl = function () {
      return $translate.instant('_myAccount_playstore_url');
    };

    $scope.getAriaLabelContent = function () {
      $scope.aria_label_username = $translate.instant('_username_signin');
      $scope.aria_label_password = $translate.instant('_password_signin');
      $scope.aria_label_rememberMe = $translate.instant('_remember_me_signin');
      $scope.aria_label_plsSignin = $translate.instant('_pls_signin');
    };

    $scope.setStaticChatButtonId = function () {
      $scope.errorDescription = $translate.instant('_require_username_password');
      if ($scope.form !== undefined) {
        emptyUsernameField = !Object.keys($scope.form.USER.$error).length;
        emptyPasswordField = !Object.keys($scope.form.password.$error).length;
      }
      if (languageSwitcher.getCurrentLanguage() === 'en') {
        $scope.chatButtonOld = 'chatButtonLoginFr';
        $scope.boldChatButton = 'chatButtonLoginEn';
        try {
          $scope.bdidEn = getBDId('S_Login'); // jshint ignore:line
        } catch (e) {
        }
        $scope.boldChatButtonDiv = 'unamepwd-fail-en';
        $scope.boldChatButtonId = 'S_Login';
      } else {
        $scope.boldChatButton = 'chatButtonLoginFr';
        $scope.chatButtonOld = 'chatButtonLoginEn';
        try {
          $scope.bdidFr = getBDId('S_Login_Fr'); // jshint ignore:line
        } catch (e) {
        }
        $scope.boldChatButtonDiv = 'unamepwd-fail-fr';
        $scope.boldChatButtonId = 'S_Login_Fr';
      }
    };
    $scope.setStaticChatButtonId();
    $scope.getAriaLabelContent();
    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.setStaticChatButtonId();
      $scope.getAriaLabelContent();
      $scope.lang = lang;
      if ((emptyUsernameField && emptyPasswordField) || !$scope.submitted) {
        $scope.staticBoldChat();
      }
    }, 'signinControllerLangSub');

    var scopewatch1 = $scope.$watch('boldChatButton', function (newValue, oldValue) {
      if (newValue !== oldValue) {
        $scope.chatButtonOld = oldValue;
      }
    }, true);

    function htmlToPlaintext(text) {
      return text ? String(text).replace(/<[^>]+>/gm, '') : '';
    }

    $scope.staticBoldChat = function () {
      $scope.liveChatAltText = $translate.instant('forgot_username_live_chat_alt_text');
      if (($scope.isLocked || $scope.attempts >= 6) && $scope.submitted) {
        var errorMessage1 = $translate.instant('sign_maximum_attempts_line_1') + ' ' + $translate.instant('sign_maximum_attempts_line_2') + ' ' + $translate.instant('sign_maximum_attempts_line_3');
        $scope.errorMessage = $(errorMessage1).text();
        var signinError2 = htmlToPlaintext($translate.instant('sign_maximum_attempts_line_1'));
        dtmService.setVar('error', 'SS|' + signinError2);
        dtmService.direct(vm.dtmError);
        if ($scope.lang === 'en') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidEn, 'boldChatDiv1_En', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        } else if ($scope.lang === 'fr') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidFr, 'boldChatDiv1_Fr', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        }
      } else if (($scope.attempts > 0 && $scope.attempts <= 4) && $scope.submitted) {
        var errorMessage2 = $translate.instant('sign_warning_msg_line_1') + ' ' + $translate.instant('sign_warning_msg_line_2') + ' ' + $translate.instant('sign_warning_msg_line_3');
        $scope.errorMessage = $(errorMessage2).text();
        if ($scope.lang === 'en') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidEn, 'boldChatDiv2_En', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        } else if ($scope.lang === 'fr') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidFr, 'boldChatDiv2_Fr', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        }
      }
      else if (($scope.attempts > 4 && $scope.attempts <= 5) && $scope.submitted) {
        var errorMessage3 = $translate.instant('sign_third_attempts_msg_line_1') + ' ' + $translate.instant('sign_third_attempts_msg_line_2') + ' ' +
          $translate.instant('sign_third_attempts_msg_line_3');

        $scope.errorMessage = $(errorMessage3).text();
        var signinError3 = htmlToPlaintext($translate.instant('sign_maximum_attempts_line_1'));
        dtmService.setVar('errorType', 'SS | ' + signinError3);
        dtmService.direct(vm.dtmError);
        if ($scope.lang === 'en') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidEn, 'boldChatDiv3_En', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        } else if ($scope.lang === 'fr') {
          liveChatAltTextUTE($scope.liveChatAltText, $scope.bdidFr, 'boldChatDiv3_Fr', $scope.boldChatButton, $scope.chatButtonOld, $scope.errorMessage); // jshint ignore:line
        }
      }
    };

    if ($scope.rememberMe) {
      $scope.email = cookieStore.get('rememberMe');
    }

    $scope.$on('accountLockAvailable', function () {
      $scope.isLocked = signinService.isAccountLocked() || false; //required
    });

    $scope.error = {
      wrongCredential: null,
      thirdAttemps: null,
      maxAttempts: null
    };

    dataManagerService.resetBadgeList();

    $scope.isEmail = function (email) {
      var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    };

    $scope.submit = function () {
      dtmService.setVar('signin_type', $scope.signinType);
      dtmService.direct(vm.dtmSignin);
      appState.isFirstLoad = true;

      ajax.resetKillSwitches();

      if ($scope.isDisabled) {
        return false;
      }
      $scope.submitted = true;

      // Show loader and disable the button
      $scope.isWaitingClass = 'disabled';
      $scope.loginWaiting = true;

      var form = $scope.form;
      if (form.$valid) {
        // form IS valid
        deepJSON = sessionStorage.getSessionStorageObject(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
        user.clearCookies();
        deeplink.resetServiceState();

        // Clear storage in more selective way
        localStorage.clearAllLocalStorageValues();
        appState.permissionsLoaded = false;

        ajax.notifyServerDiscardLoginSMCookies().then(
          function () {
            user.login($scope.email, $scope.password.replace(/\s+|\s+$/g, '')).then(
              function (data) {
                $browser.cookies('userToken', $scope.email);
                $browser.cookies('signInLang', languageSwitcher.getCurrentLanguage());

                if (data) {
                  if (data.valid && ($window.cryptoJS && $window.cryptoJS.SHA256)) {
                    try {
                      dtmService.setVar('encryptedLoginId', $window.cryptoJS.SHA256($scope.email).toString());
                      dtmService.direct(vm.dtmSuccess);
                    } catch (error) {
                      console.log(error);
                    }
                  }
                  // Handle the response - cookies will be cleaned
                  signinService.postSignin(data, $scope, deepJSON);
                  if ($scope.attempts > 0) {
                    $scope.staticBoldChat(); //calling boldchat method
                  }
                  if ($scope.attempts >= 0 && !data.valid) {
                    var signinError1 = htmlToPlaintext($translate.instant('sign_warning_msg_line_1'));
                    dtmService.setVar('error', 'SS | ' + signinError1);
                    dtmService.direct(vm.dtmError);
                  }
                }

                // Hide loader and enable the button
                if (!data.valid) {
                  $scope.isWaitingClass = '';
                  $scope.loginWaiting = false;
                }
              }
            );
          }
        );
      } else {
        // Form is NOT valid, tag the errors. Tag sign in differently by adding extra event36 as this is important to the analytic team.
        //all other form validation errors will be tagged through appState.tagFormValidationErrors().
        $scope.isWaitingClass = '';
        $scope.loginWaiting = false;

        var msg = '';
        var obj = $scope.form.$error;
        for (var i = 0; i < obj.required.length; i++) {
          try {
            msg = webanalytics.formatErrorMessage('Signin', obj.required[i].$name, 1);
            dtmService.setVar('error', 'CS | ' + msg);
            dtmService.direct(vm.dtmError);
            appState.tagging(['_trackLink',
              {eVar49: msg},
              {event15: ''}, // Generic Error
              {event36: ''}// Residential Sign-in error
            ]);
          } catch (e) {
            $log.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }
      }
    };

    $scope.langChange = function () {
      return languageSwitcher.getCurrentLanguage();
    };

    $scope.register = function () {
      brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.JANRAIN_REGISTRATION).then(function (val) {
        if (val) {
          appState.switchView('sso/registration');
        } else {
          appState.switchView('registration');
        }
      });
    };

    $scope.keyPressRegister = function (event) {
      if (event.which === 13) {
        $scope.register();
      }
    };

    $scope.hasError = function () {
    };

    $scope.isAppBanners = function () {
      return $stateParams.banners === 'appBanners';
    };

    $scope.isResetPassword = function () {
      return $stateParams.banners === 'resetPassword';
    };

    function tagSignIn() {
      appState.tagging(['_trackPageView',
        {pn: 'home:signin'}
      ]);
    }

    $scope.signOut = function () {
      if ($browser.cookies().SM_USER || userService.getAuthCookieValue()) {
        console.log('signinController logout');
        user.logout();
      }
    };

    $scope.signOut();
    try {
      tagSignIn();
    } catch (e) {
      $log.error('Exception during signOut, message is', e.message);
    }

    $scope.$on('$destroy', function () {
      languageSwitcher.unregisterOnDataChangeHandler('signinControllerLangSub');
      scopewatch1();  //n
    });
  }
})();

(function () {
  'use strict';

  // TODO this is very dirty temporary service

  angular.module('totesApp').factory('myrSigninService', signinService);

  signinService.$inject = ['$log',
    '$q',
    'ajax',
    'settings',
    '$http',
    'appState',
    'user',
    '$browser',
    '$window',
    '$translate',
    'deeplink',
    'landing',
    'cookieStore',
    '$rootScope',
    '$timeout',
    'sessionStorage',
    'ute.common.user.service',
    'ute.blocks.messages.bus.service'];

  /* @ngInject */
  function signinService($log, // jshint ignore:line
                         $q,
                         ajax,
                         settings,
                         $http,
                         appState,
                         user,
                         $browser,
                         $window,
                         $translate,
                         deeplink,
                         landing,
                         cookieStore,
                         $rootScope,
                         $timeout,
                         sessionStorage,
                         userService,
                         messagesService) {
    // Public API
    //noinspection UnnecessaryLocalVariableJS

    var deepSTR = '';

    //noinspection UnnecessaryLocalVariableJS
    var service = {
      postSignin: postSignin,
      isAccountLocked: isAccountLocked
    };

    return service;

    ///////////////////////////////////////////////////////////////

    function isAccountLocked() {
      return $browser.cookies().SMLOCK > 0;
    }

    function postSignin(data, $scope, deepJSON) {
      if (data.statusCode === 200) {
        // pass
        /**
         * This array will contain both ajax.notifyServerLoggedIn() and ssoCookiePull process
         */

        if (data.valid) {
          deepSTR = deeplink.deepLink(deepJSON);
          if ($scope.rememberMe) {
            cookieStore.put('rememberMe', $scope.email, {end: 'Fri, 31 Dec 2100 23:59:59 GMT'});
          } else {
            cookieStore.remove('rememberMe');
          }
          // code do not reach here after easy login implementation
          if (deepSTR.indexOf('wcoc') >= 0 && deeplink.jwtToken !== '') {
             ajax.notifyServerLoggedIn().then(
              function (data) {
               var postData = {
                 applicationId: 'Rogers.com',
                 token: deeplink.jwtToken
               };
               ajax.decryptWcocJwtToken(postData).then(
                 function(data) {
                    $timeout(function () {
                      sessionStorage.deleteSessionStorageValue(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_URL);
                      $window.location.href = deepSTR + '?entryId=D&token=' + data;
                    }, 1100);
                 },
                 function(error) {
                   console.log(error);
                   $window.location.href = deepSTR;
                 }
               );
             });
          } else {
           var combinedProcess = [];

           // notify server - log in
            var notifyServerLoggedInProcess = ajax.notifyServerLoggedIn().then(
                function (data) {
                  userService.signed({
                    userName: $scope.email,
                    userEmail: $scope.email,
                    userPassword: $scope.password,
                    userType: $rootScope.userType
                  });

                  if (deepSTR === '') {
                    //only redirect if we are not deeplinking to external site (non totes)
                    landing.landingRedirect();
                  }
                }).finally(function () {
              messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, {email: $scope.email});
            });

          combinedProcess.push(notifyServerLoggedInProcess);
          // Make call to rogers site to populate SSO cookies
          var ssoCookiePull = '/web/RogersServices.portal?_nfpb=true&_pageLabel=beta';
          var responsePromise = $http.get(ssoCookiePull);
          combinedProcess.push(responsePromise);

          /**
           * This function is for deeplink or device upgrade redirection
           */
          var responsePromiseSuccess = function (response) {
            if (deepSTR.indexOf('/web/myrogers/device-upgrade') >= 0) {
              $window.location.replace('/web/totes/upgrade/#/choose-phone');
            }
            else {
              deeplink.redirectCheck();
            }
          };

            /**
             * Deeplink process will only run all combined process completed
             */
            $q.all(combinedProcess).then(responsePromiseSuccess);
          }


        } else {
          $scope.attempts = $browser.cookies().SMTRYNO;

          //not signed in, error occurs
          user.clearCookies();
          ajax.notifyServerDiscardLoginSMCookies();
          user.token(null);

          //$('#signinForm').attr('method', 'post');
          //$('#signinForm').attr('action', settings.siteminderUrl);
          //$('#target').attr('value', settings.postSigninUrl);
          //$('#signinForm').submit();
          //location.reload(true);
        }
      } else {

        // this block of code is related to the localhost authentication
        $scope.isWaitingClass = '';
        if (data.statusCode === 401) {
          // status: 401
          // statusText: 'Unauthorized'
          try {
            setErrorMessage($scope);
            tagError($scope.errorSummary);
          } catch (e) {
            $log.error('Exception catch during tagging on errorSummary with message:', e.message);
          }

        } else {
          // Server error or bad fail
          try {
            $scope.errorSummary = $translate.instant('10000_sign_in');
            tagError($scope.errorSummary);
          } catch (e) {
            $log.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }
      }
    }

    function setErrorMessage($scope) {
      if ($scope.attempts > 0) {
        $scope.errorSummary = $translate.instant('_attempt') + ' ' + $scope.attempts + ' ' + $translate.instant('_of') + ' ' + $scope.maxAttempts;
      } else {
        $scope.errorSummary = $translate.instant('10000_sign_in');	// TEST PURPOSE
      }
    }

    function tagError(errorMessage) {
      if (errorMessage) {
        appState.tagging([
          '_trackLink',
          {eVar49: errorMessage}, // Error Message
          {event15: ''}, // Generic Error
          {event36: ''}// Residential Sign-in error
        ]);
      }
    }
  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrShmDashboardController
   * @description
   * # MyrShmDashboardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrShmDashboardController', ShmDashboardController);

  ShmDashboardController.$inject = ['$scope',
    '$state',
    '$rootScope',
    'appState',
    '$translate',
    'ajax',
    '$window',
    '$http',
    'myrShmDashboardService',
    'localStorage',
    'sessionStorage',
    'settings',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function ShmDashboardController($scope,
                                  $state,
                                  $rootScope,
                                  appState,
                                  $translate,
                                  ajax,
                                  $window,
                                  $http,
                                  shmDashboardService,
                                  localStorage,
                                  sessionStorage,
                                  settings,
                                  languageSwitcher) {

    //check for maintenance
    if (appState.checkMaintenance('RSHM_ON_MAINTENANCE')) {
      $state.go('underMaintenance');
    }

    $scope.selectedAccount = {};
    $scope.selectedAccount.accountName = {};
    $scope.selectedAccount.accountNumber = localStorage.getLocalStorageValue('shmAccountNumber');
    if ($rootScope.isCare) {
      $scope.selectedAccount.accountNumber = sessionStorage.getSessionStorageValue('shmAccountNumber');
    }
    $scope.shmLink = '';

    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    $scope.formToRogersTemplate = settings.formToRogersTemplate;

    var status = '';
    var accType = '';
    if ($scope.selectedAccount.accountInfo) {
      status = $scope.selectedAccount.accountInfo.status;
      accType = $scope.selectedAccount.accountInfo.accType;
    }
    appState.tagging(['_trackPageView',
      {pn: 'home:myrogers:rshm'},
      {sACTT: status}, // Consumer, Business
      {sBAN: $scope.selectedAccount.accountNumber}, //Account Number BAN, ex : '12345'
      {sCTN: $scope.selectedAccount.accountNumber}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
      {sACSS: accType}
    ]);

    $scope.setLinks = function () {
      $scope.lng = languageSwitcher.getCurrentLanguage();
      switch ($scope.lng) {
        case 'en':
          $scope.quickStartGuideLink = '/pdf/en/Quick-Start-Guide.pdf';
          $scope.serviceAgreementLink = '/en/SHM-Service-Agreement.pdf';
          $scope.municipalPermitsInformationLink = 'setLanguage=en';
          break;
        case 'fr':
          $scope.quickStartGuideLink = '/support/pdfs/SHM/FRE_Quick_Start_Guide%20Oct%202014_FR.pdf';
          $scope.serviceAgreementLink = '/fr/SHM-Service-Agreement-f.pdf';
          $scope.municipalPermitsInformationLink = 'setLanguage=fr';
          break;
      }
    };

    $scope.printCertificate = function(){
      var requestParams = {
        accountNumber: localStorage.getLocalStorageValue('accountNumber'),
        serviceNumber: localStorage.getLocalStorageValue('shmAccountNumber'),
        language: languageSwitcher.getCurrentLanguage()
      };
      shmDashboardService.shmDashboardCertificateService(requestParams).then(function(data){
        var file = new Blob([data.data], {type: 'application/pdf'});
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
        }
        $window.open(URL.createObjectURL(file), '_blank');
      });
    };

    $scope.$extend({
      isCollapsed: true,
      lng: languageSwitcher.getCurrentLanguage(),
      lang: languageSwitcher.getCurrentLanguage() + '-CA',
      langUpper: languageSwitcher.getCurrentLanguage().toUpperCase(),
      loadingUsage: true,
      errorCode: '',
      errorMessage: '',
      url: window.location.host,
      loadData: function () {
        ajax.getSHMlink($scope.selectedAccount.accountNumber, $scope.url).then(
            function (response) {
              if (response === undefined || response === null) {
                $scope.errorCode = 50000;
                $scope.errorMessage = $translate.instant($scope.errorCode);
              } else {
                $scope.shmLink = response.accessWebURl;
              }
            },
            function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                $scope.errorCode = error.error.errorCode;
                $scope.errorMessage = error.error.message;
              } else {
                $scope.errorMessage = $translate.instant('50000');
              }
            });
      }
    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.setLinks();
    }, 'shmDashboardControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('shmDashboardControllerLangSub');
    });

    $scope.loadData();
    $scope.setLinks();
  }
})();

(function() {
    'use strict';
    angular.module('totesApp').factory('myrShmDashboardService', shmDashboardService);
    shmDashboardService.$inject = ['ajax', '$rootScope', '$q', '$http'];
    function shmDashboardService(ajax,$rootScope, $q, $http){

        // window = $window.open(),
        function shmDashboardCertificateService(requestParams){
            return $http.post('/web/RogersServices.portal/totes/api/v1/shm/insurancecertificate/generate', requestParams, {responseType: 'arraybuffer'});
        }
        return {

            shmDashboardCertificateService:shmDashboardCertificateService
        };
    }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function (_) {
  'use strict';

  /**
   * @name totesApp.controller:MyrSubMenuController
   * @description
   * # MyrSubMenuController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrSubMenuControllerOLD', subMenuController);

  subMenuController.$inject = ['$scope',
    '$rootScope',
    '$state',
    '$location',
    'myrAccountOverviewService',
    'btnSettings',
    '$window',
    'settings',
    'appState',
    'user',
    'deeplink',
    'myrMyServicesService',
    'localStorage',
    '$modal',
    'myrWirelessPrepaidService',
    'sessionStorage',
    'ute.blocks.language.switcher',
    'appInterface',
    'ute.common.permissions.service',
    'ute.common.second.level.navigation.service',
    'ute.data.manager.service',
    '$resolve',
    'ute.transferOfResponsibility.service',
    'ute.common.customer.credit.management.service',
    'ute.brite.bill.service',
    'ajax'
  ];

  /* @ngInject */
  function subMenuController($scope,
                             $rootScope,
                             $state,
                             $location,
                             accountOverviewService,
                             btnSettings,
                             $window,
                             settings,
                             appState,
                             user,
                             deeplink,
                             myrMyServicesService,
                             localStorage,
                             $modal,
                             myrWirelessPrepaidService,
                             sessionStorage,
                             languageSwitcher,
                             appInterface,
                             permissionsService,
                             navigationService,
                             dataManagerService,
                             $resolve,
                             torService,
                             ccmService,
                             briteBillService,
                             ajax) {


    $scope.$extend({});

    // if one usertype retail/care hide the homephone and link account links from services menu.
    // $scope.userTypeDealer = $rootScope.isDealer;
    $scope.isDealer = $rootScope.isDealer;
    $scope.isCare = $rootScope.isCare;
    $scope.isConsumer = $rootScope.isConsumer;
    // Self hiding logic
    $scope.selfDestruct = function (stateString) {
      var hideSubMenuStates = [
        'underMaintenance',
        'linkaccount',
        'signin',
        'forgotUserName',
        'forgotPassword',
        'forgotUserNameNoLivecontent',
        'forgotPasswordNoLivecontent',
        'registration',
        'registrationNoEmailVerify',
        'completeProfile',
        'registrationComplete',
        'oneViewInterface',
        'oneViewDashboard',
        'interaction',
        'registrationConfirmation',
        'actionsOffers'
      ];

      // Get location and masage the result a little bit
      var toState = $location.path();

      // Remove first slash and replace other slashes with dots
      toState = toState.substring(1);
      toState = toState.replace(/\//gi, '.');

      toState = (stateString === '' || stateString === undefined) ? toState : stateString;

      // array lookup
      var toStateResult = true;
      if (user.isLoggedIn) {
        // maybe will show it
        toStateResult = (hideSubMenuStates.indexOf(toState) !== -1);
      } else {
        // definitely will NOT show it
        toStateResult = true;
      }
      return toStateResult;
    };
    $scope.selfDestructFlag = $scope.selfDestruct();
    ($scope.selfDestructFlag) ? navigationService.disableFullMenu() : navigationService.enableFullMenu();

    // Listen to the state change broadcast
    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
      if (deeplink.data.direction === 'out') {
        // DO NOT show the submenu
        $scope.selfDestructFlag = true;
      } else {
        $scope.selfDestructFlag = $scope.selfDestruct(toState.name);
      }
      ($scope.selfDestructFlag) ? navigationService.disableFullMenu() : navigationService.enableFullMenu();
    });

    /*if ($scope.isDealer || $scope.isCare) {
     var requestURI = $window.location.href;
     var queryString = requestURI.split('?');
     if (queryString.length > 1) {
     var oneViewStatusCode = $location.search().statusCode;
     //console.log('SubMenuController :: params[1] :: '+params[1]);
     if (oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck ||
     oneViewStatusCode === settings.oneViewStatusCodes.creditOps) {
     $scope.isFraudCheckOrCreditOps = true;
     }
     }
     }*/

    $scope.notInDataManager = function (item) {

      var dmBadgeList = dataManagerService.getBadgeList().subscriberList;

      var notInList = true;

      if ((item.serviceName === 'wireless' || item.serviceName === 'shareEverything') && $scope.dataManagerPermission === true) {

        for (var iSELine = 0; iSELine < dmBadgeList.length; iSELine++) {
          if (item.serviceDetail === dmBadgeList[iSELine].ctn) {
            notInList = false;
          }

        }

      }
      /*Removed emply li from service menu if serviceName is homephone*/
      return (item.serviceName === 'homephone') ? false : notInList;
      //return notInList;
    };


    $scope.subMenuItems = $window.subMenuItems;
    $scope.isOverview = false;
    $scope.isPayment = false;
    $scope.isService = false;
    $scope.toggleMainPlusMinus = $rootScope.toggleMainPlusMinus;

    // $scope.toggleServicesPlusMinus = $rootScope.toggleServicesPlusMinus;
    $scope.toggleServicesPlusMinus = false;

    $scope.isDealer = $rootScope.isDealer;
    $scope.isCare = $rootScope.isCare;
    $scope.isConsumer = $rootScope.isConsumer;

    $scope.repInteractionRead = true;
    $scope.repProfileRead = true;
    $scope.repPaymentStart = true;
    $scope.repTransferOfResponsibilityStart = false;
    $scope.repCreditAdjustmentRead = false;

    $scope.isAccountCancelledOrSuspended = false;
    $scope.dataManagerPermission = false;
    $scope.actionsOffersPermitted = false;
    $scope.repActionOffersUpdate = false;
    $scope.repBundleBuilderAccess = false;
    //$scope.repOfferSaleRead = true;

    if ($rootScope.isDealer || $rootScope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.InteractionHistory, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repInteractionRead = repPermission;
        });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CustomerProfile, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repProfileRead = repPermission;
        });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.MakePayment, ute.common.permissions.service.RamActionCodes.start)
        .then(function (repPermission) {
          $scope.repPaymentStart = repPermission;
        });
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER).then(function (isPermittedDataManager) {
        if (isPermittedDataManager) {
          $scope.dataManagerPermission = isPermittedDataManager;
        }
      });
      //permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_ACTIONS_OFFERS).then(function (isPermittedActionsOffers) {
      //  $scope.actionsOffersPermitted = isPermittedActionsOffers;
      //});
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.OfferSale, ute.common.permissions.service.RamActionCodes.read)
        .then(function (agentPermission) {
          $scope.repActionOffersUpdate = agentPermission;
          console.log("AGENT PERM: " + agentPermission);
      });
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.BundleBuilder, ute.common.permissions.service.RamActionCodes.start)
        .then(function (repPermission) {
          $scope.repBundleBuilderAccess = repPermission;
        });
    }

    if ($rootScope.isCare) {
      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.TransferOfResponsibility, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repTransferOfResponsibilityStart = repPermission;
        });

      permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.CreditManagement, ute.common.permissions.service.RamActionCodes.read)
        .then(function (repPermission) {
          $scope.repCreditAdjustmentRead = repPermission;
        });
    }

    /*$scope.currentAccount = $rootScope.ao.accountActive;
     if ($scope.currentAccount != null) {
     if ($scope.currentAccount.accountNumber != null) {
     $scope.isWirelessAccount = $scope.currentAccount.accountNumber.length < 12;
     }
     if ($scope.currentAccount.accountStatus != null && $scope.currentAccount.accountStatus.toUpperCase() === 'SUSPENDED'
     || $scope.currentAccount.accountStatus === 'CANCELLED') {
     $scope.isAccountCancelledOrSuspended = true;
     }
     }*/
    $scope.currentAccount = $rootScope.ao.accountActive;
    var scopewatch1 = $scope.$watch(function () {
      return $rootScope.ao.accountActive;
    }, function () {
      $scope.currentAccount = $rootScope.ao.accountActive;

      if ($scope.currentAccount != null) {
        if ($scope.currentAccount.accountNumber != null) {
          $scope.isWirelessAccount = $scope.currentAccount.accountNumber.length === 9;
        }
        if ($scope.currentAccount.accountTypeNumber != null) {
          var accountTypeNumber = $scope.currentAccount.accountTypeNumber;
          if (accountTypeNumber === 9 || accountTypeNumber === '9') {
            $scope.isPrepaid = true;
          } else {
            $scope.isPrepaid = false;
          }
        }
        if ($scope.currentAccount.accountStatus != null && ($scope.currentAccount.accountStatus.toUpperCase() === 'SUSPENDED'
          || $scope.currentAccount.accountStatus.toUpperCase() === 'CANCELLED')) {
          $scope.isAccountCancelledOrSuspended = true;
        }
      }
    }, true);


    // $scope.subUser = $rootScope.user;
    $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
    var scopewatch2 = $scope.$watch(function () {
      return $rootScope.selectedSubMenuItem;
    }, function () {
      $scope.selSubMenuItem = $rootScope.selectedSubMenuItem;
    }, true);

    $scope.runService = function (serviceName, value) {
      accountOverviewService.runService(serviceName, value);
    };

    $scope.runCustomerCare = function () {
      $window.location.href = settings.devServerURL.replace(/\/\/www/gi, '//internal') + '/web/InternalUse.portal';
    };

    $scope.runRogersProfile = function ($event) {
      $event.preventDefault();
      if ($scope.ssaPermission) {
        $event.preventDefault();
        if ($rootScope.isDealer || $rootScope.isCare || $scope.isSubMenuEnabled('profile') || $state.current.name === 'guestOverview') {
          $state.go('self-serve');
        }
      } else if ($state.current.name === 'guestOverview') {
        $state.go('self-serve');
      } else {
        //$event.currentTarget.href = $event.currentTarget.href.replace(/ProfileAccountNumber=[\d]*/, 'ProfileAccountNumber=' + $rootScope.selectedAccount);
        // TODO Please add you logic here
        $window.location.href = '/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta&setLanguage=en&ProfileAccountNumber=' + $rootScope.selectedAccount;
      }
    };

    $scope.accountOverview = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('accountOverview')) {
        scrollPageToTop(); // jshint ignore:line
        appState.switchView('accountOverview');
      }

      if (!$scope.isSubMenuEnabled('accountOverview') && $state.current.name === 'self-serve') {
        $state.go('guestOverview');
      }
    };
    $scope.oneViewAccountOverview = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('accountOverview')) {
        scrollPageToTop(); // jshint ignore:line
        if (($scope.isDealer || $scope.isCare) && !$scope.isConsumer) {
          if ($rootScope.isRepView === 'true') {
            appState.switchView('oneViewDashboard');
          } else {
            appState.switchView('accountOverview');
          }
        }
      }
    };

    $scope.viewbill = function ($event) {
      $event.preventDefault();
      if ($scope.isSubMenuEnabled('billingAndPayment')) {

        if ($rootScope.isDealer || $rootScope.isCare) {
          $scope.rogersORpaybill();
        } else if ((myrMyServicesService.selectedAccountDetail && myrMyServicesService.selectedAccountDetail.isPrepaid) ||
          myrWirelessPrepaidService.wirelessPrepaidData.isPrepaidAccount) {

          $scope.postToRogersTop();
        } else {
          scrollPageToTop(); // jshint ignore:line
          appState.switchView('viewbill');
        }
      }
      if ($state.current.name === 'guestOverview' && $scope.isSubMenuEnabled('billingAndPayment') === true) {
        appState.switchView('accountOverview');
      }
    };

    $scope.openBillingAndPaymentModal = function (size) {
      $rootScope.modal = $modal.open({
        templateUrl: 'views/modals/billingAndPaymentModal.html',
        controller: 'MyrBillingAndPaymentModalCtrl',
        size: size,
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });
      $rootScope.modal.result.then(function () {
        // on OK behaviour
      }, function () {
        // on Cancel behaviour
      });
    };

    $scope.rogersORpaybill = function () {
      var rogersORpaybillType = 0;
      try {
        rogersORpaybillType = $rootScope.ao.accountActive.accountTypeNumber;
      } catch (e) {
      }

      var isConsumer = !$scope.isDealer && !$scope.isCare;
      if (isConsumer) {
        if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
          $scope.postToRogersTop();
        } else {
          $scope.payBill();
        }
      } else {
        // The accountActive is becoming null, so need to get the accountTypeNumber from local storage
        if (rogersORpaybillType === 0) {
          rogersORpaybillType = localStorage.getLocalStorageValue('accountTypeNumber');
          if ($rootScope.isCare) {
            rogersORpaybillType = sessionStorage.getSessionStorageValue('accountTypeNumber');
          }
        }
        if (rogersORpaybillType === 9 || rogersORpaybillType === '9') {
          // Disable bills & payments in prepaid for dealer and care
          //$scope.openBillingAndPaymentModal();
        } else {
          $scope.payBill();
        }
      }
    };

    var scopewatch3 = $scope.$watch(function () {
      return briteBillService.getIsbritebillAvailable($scope.currentAccount ? $scope.currentAccount.accountNumber : '');
    }, function (newVal) {
      if (($rootScope.isDealer || $rootScope.isCare) && newVal) {
        if (($scope.isPrepaid) || ($scope.currentAccount && $scope.currentAccount.isPrepaid)) {
          $scope.isViewBillDisplay = false;
        } else {
          $scope.isViewBillDisplay = true;
        }
      } else {
        $scope.isViewBillDisplay = false;
      }
      console.log('$scope.isViewBillDisplay :: ' + $scope.isViewBillDisplay);
    });

    $scope.postToRogers = function () {
      // For dealer and care - legacy page should not be displayed
      appState.switchView('viewbill');
    };

    $scope.postToRogersUrls = [
      {url: '/web/myrogers/viewBill'},
      {url: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary'},
      {url: '/web/myrogers/prepaidTopUp'}
    ];

    $scope.postToRogersTop = function () {
      //		$('#formToRogersTop').attr('action', $scope.postToRogersUrls[1].url);
      //		$('#formToRogersTop').submit();
      $window.location.href = $scope.postToRogersUrls[1].url;
    };

    $scope.payBill = function () {
      // Look into  non_angular_script/supportFunctions.js  for more information
      scrollPageToTop();					// jshint ignore:line
      appState.switchView('paynow');
    };

    $scope.redirectToInteraction = function () {
      //$rootScope.interactionAndCaseListLength = 0;
      scrollPageToTop(); // jshint ignore:line
      appState.switchView('interaction');
    };

    $scope.redirectToActionsOffers = function () {
      scrollPageToTop(); // jshint ignore:line
      appState.switchView('actionsOffers');
    };

    $scope.closeMenu = function () {
      $scope.toggleMainPlusMinus = false;
      $scope.toggleServicesPlusMinus = false;
    };

    $scope.navMainMenuClick = function (/*$event*/) {
      if ($scope.toggleMainPlusMinus) {
        $scope.toggleMainPlusMinus = false;
        $scope.toggleServicesPlusMinus = false;

        // direct call to jQ
        $('.dropdown.open').removeClass('open');

      } else {
        $scope.toggleMainPlusMinus = true;
      }
    };

    $scope.navSubMenuClick = function (/*$event*/) {
      $scope.toggleServicesPlusMinus = !$scope.toggleServicesPlusMinus;

      // Refer to settings for complete list of page this menu should not appear
      if ($scope.isDropDownEnabled === false) {
        $scope.toggleServicesPlusMinus = false;
      }
    };

    $scope.hideDropDown = function () {
      if ($scope.btnSettings === undefined || $scope.btnStatus === undefined) {
        return false;
      } else {
        return $scope.btnSettings.allSubscriptions === $scope.btnStatus.hidden && $scope.activeAccountType != '9';
      }
    };

    $scope.updateBtnSettings = function (accountStatus) {
      if ($rootScope && $rootScope.ao.accountActive && $rootScope.ao.accountActive.accountStatus) {
        $scope.btnSettings = btnSettings.getSettings(accountStatus);
        $scope.btnStatus = $window.btnStatus;
      }
    };

    $scope.isDropDownEnabled = function () {
      var inlineIfThing = settings.mandatoryPages.indexOf($state.current.name) < 0;
      return (inlineIfThing);
    };

    $scope.isSubMenuEnabled = function (subMenuName) {
      var result = false;
      // if current page is mandatory, disable all subMenus
      if (settings.mandatoryPages.indexOf($state.current.name) >= 0) {
        return false;
      }

      switch (subMenuName) {
        case 'accountOverview':
          result = true;
          break;
        case 'billingAndPayment':
          result = true;
          break;
        case 'services' :
          result = $rootScope.selectedSubMenuItem !== $scope.subMenuItems.guestoverview;
          if (localStorage.getLocalStorageValue('accountNumber') === null) {
            result = false;
          }
          break;
        case 'profile' :
          result = true;
          break;
        default :
          break;
      }
      return result;
    };

    $rootScope.$on('$stateChangeStart', function () {
      $scope.closeMenu();
      $('#header .shadow').removeClass('in');
      $('.collapse').removeClass('in');
    });

    /*$scope.isDisplayPopup = function () {
     var result = false;
     if($rootScope.isConsumer || $rootScope.isCare){
     result = true;
     } else {
     result = false;
     $scope.open();
     }
     return result;
     };*/
    $scope.menuClick = function () {
      $('#header .shadow').removeClass('in');
    };

    $scope.getSubMenuServices = getSubMenuServices;

    function getSubMenuServices() {
      if ($rootScope.myServicesList) {
        return _.filter($rootScope.myServicesList, function (item) {
          return (item.subType !== 'Rogers Bank');
        });
      }
    }

    /* Begin: To display only one ShareEverything Sub menu in service menu */
    $scope.getSubMenuServicesShare = getSubMenuServicesShare;

    function getSubMenuServicesShare() {
      if ($rootScope.myServicesList) {
        return $rootScope.myServicesList.filter(function (obj) {
          if (obj.serviceName === 'shareEverything' && obj.subType !== 'Rogers Bank') {
            return obj;
          }
        });
      }
    }

    /* End: To display only one ShareEverything Sub menu in service menu */
    $scope.resolveService = function (service) {
      return $resolve.resolve(service.resolve(service));
    };

    $scope.lang = languageSwitcher.getCurrentLanguage();

    $scope.changeLanguage = function () {
      if ($scope.lang === 'en') {
        languageSwitcher.changeLanguage('fr');
      } else {
        languageSwitcher.changeLanguage('en');
      }
      $rootScope.$broadcast('languageChanged');
    };

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if (($rootScope.isDealer || $rootScope.isCare) && $rootScope.isRepView === 'false') {
        $('div[data-liveheader] #header').css('position', 'static');
      }
      $scope.lang = lang;

      appInterface.fn.languageChange(lang);
    }, 'subMenuControllerLangSub_' + $scope.$id);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('subMenuControllerLangSub_' + $scope.$id);
      scopewatch1(); //n
      scopewatch2();
      scopewatch3();
    });

    function getParameter(key, value) {
      var regex = new RegExp('[\\?&]' + key + '=([^&#]*)');
      var results = regex.exec(value);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }

    // function userInfo () {
    //   ajax.agentInfo().then(
    //     function (data) {
    //       $scope.userInfo = data;
    //     });
    // }

    // userInfo();

    $scope.redirectToOASYS = function () {
      var connId = '';
      if($rootScope.userInfo) {
        if ($rootScope.userInfo.cfaInfo && $rootScope.userInfo.cfaInfo.connid) {
          connId = $rootScope.userInfo.cfaInfo.connid;
        } else if ($rootScope.userInfo.careInfo && $rootScope.userInfo.careInfo.connid) {
          connId = $rootScope.userInfo.careInfo.connid;
        } else if ($rootScope.userInfo.connid){
          connId = $rootScope.userInfo.connid;
        } else {
          if($scope.isDealer) {
            connId = getParameter('connid', $rootScope.userInfo.cfaInfo.playSessionId);
          } else if($scope.isCare) {
            connId = getParameter('connid', $rootScope.userInfo.careInfo.playSessionId);
          }
        }
      }
      var redirectionUrl = 'https://www.rogersoasys2.com/OneViewSSO.aspx?';
      var ban = '';
      var can = '';
      if (location.hostname.indexOf('qa') > -1) {
        redirectionUrl = 'https://beta.rogersoasys2.com/OneViewSSO.aspx?';
      }

      if ($scope.currentAccount) {
        if ($scope.currentAccount.accountNumber.length < 12) {
          ban = $scope.currentAccount.accountNumber;
        } else {
          can = $scope.currentAccount.accountNumber;
        }
      }
      redirectionUrl = redirectionUrl + 'BAN=' + ban + '&CAN=' + can + '&Lang=' + $scope.lang + '&ConnID=' + connId;

      $window.open(redirectionUrl, '_blank');
    };

    $scope.goToTransferOfResponsibility = function () {
      var accountNumber = $scope.isDealer ?
        $rootScope.myServicesList[0].accountNumber :
        localStorage.getLocalStorageValue('accountNumber');
      var customCtnList = [];
      var localServicesList = $rootScope.myServicesList;
      for (var sub = 0; sub < localServicesList.length; sub++) {
        if (!(localServicesList[sub])) {
        } else {
          var ctnDetails = {};
          ctnDetails["subscriberNumber"] = localServicesList[sub].serviceDetail;
          ctnDetails["firstName"] = localServicesList[sub].firstName;
          if (localServicesList[sub].subType === 'CTN') {
            customCtnList.push(ctnDetails);
          }
        }
      }
      torService.goToEntryState({
        accountNumber: accountNumber,
        ctnList: customCtnList
      });
    };

    $scope.displayCreditAdjustmentDetails = function () {
      var accountNumber = $scope.isDealer ? $rootScope.myServicesList[0].accountNumber : localStorage.getLocalStorageValue('accountNumber');
      var subscriberDetails = [];
      var localServicesList = $rootScope.myServicesList;
      for (var sub = 0; sub < localServicesList.length; sub++) {
        if (!(localServicesList[sub])) {
          // Do Nothing
        } else {
          var subscriberInfo = {};
          subscriberInfo["subscriberNumber"] = localServicesList[sub].serviceDetail;
          subscriberInfo["subscriberName"] = localServicesList[sub].firstName;
          if (localServicesList[sub].subType === 'CTN') {
            subscriberDetails.push(subscriberInfo);
          }
        }
      }
      ccmService.goToEntryState({
        accountNumber: accountNumber,
        subscriberDetails: subscriberDetails
      });
    };

  }
})(_);

(function () {
  'use strict';

  angular.module('totesApp').directive('subMenu', subMenu);

  subMenu.$inject = ['ajax','$rootScope'];

  /* @ngInject */
  function subMenu(ajax,$rootScope) {
    var directive = {
        restrict: 'EA',
        templateUrl: 'scripts/modules/subMenu/subMenu.html',
        scope: {
        },
        link: linkFunc,
        replace: 'false',
        controller: 'MyrSubMenuControllerOLD',
        controllerAs: 'sm',
        bindToController: true
    };
    return directive;

    function linkFunc(scope, element, attrs) {
      var scrootwatch1 = scope.$root.$watch('myServicesList', function () {
        scope.subMenuMyServicesList = scope.getSubMenuServices();
        scope.getSubMenuServicesShareItem = scope.getSubMenuServicesShare();
      });

      var scrootwatch2 = scope.$root.$watch('permissions.permissionActive', function (newVal, oldVal) {
        scope.showCareLink = false;
        if (newVal) {
          if (scope.hasOwnProperty('ssaPermission')) {
            // AND now what.
            /* if(scope.hasOwnProperty('showCartMenu')){
                $rootScope.showCartMenu = newVal.accountNumber;
             }*/
          }
          else {
              /*var tazoPermission = permissions.permissions.filter(function (permission) {
                return permission.permission && permission.permission === 'TAZO_UTE_PAGE_VIEW';
              });*/
            scope.ssaPermission = true;
              //scope.showCartMenu = tazoPermission.length > 0;

             /* if(scope.showCartMenu){
                 $rootScope.showCartMenu = scope.showCartMenu;
              }*/

          }

          var parmissions = newVal.permissions;
          for (var xx = 0; xx < parmissions.length; xx++) {
            var current = parmissions[xx];
            if (current.name === 'INTERNAL_USER') {         //TODO INTERNAL_USER
              scope.showCareLink = true;
              break;
            }
          }
        }
      }, true);

      var scrootwatch3 = scope.$root.$watch('ao.accountActive', function () {
        scope.activeAccountType = (!!scope.$root.ao.accountActive) ? scope.$root.ao.accountActive.accountTypeNumber : 0;
        if (scope.$root.ao.accountActive) {
          scope.updateBtnSettings(scope.$root.ao.accountActive.accountStatus);
        }
      });

      //n Remove any watchers
      scope.$on('$destroy', function () {
        scrootwatch1();
        scrootwatch2();
        scrootwatch3();
      });
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:TvdashboardCtrl
   * @description
   * # TvdashboardCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrTvDashboardController', TvDashboardController);

  TvDashboardController.$inject = ['$scope',
    '$browser',
    '$state',
    'appState',
    '$translate',
    'settings',
    '$timeout',
    'myrTvDashboardService',
    '$window',
    'liveChatSettings',
    '$modal',
    'ute.common.user.service',
    'ute.blocks.messages.bus.service',
    'ute.blocks.language.switcher',
    'ute.rogers.account.overview.factory',
    'EOPService',
    '$rootScope',
    '$http'
    ];

  /* @ngInject */
  function TvDashboardController($scope,
                                 $browser,
                                 $state,
                                 appState,
                                 $translate,
                                 settings,
                                 $timeout,
                                 tvDashService,
                                 $window,
                                 liveChatSettings,
                                 $modal,
                                 userService,
                                 messagesService,
                                 languageSwitcher,
                                 newAccountOverviewFactory,
                                 EOPService,
                                 $rootScope,
                                 $http) {
    var vm = this;
    vm.isOneview = userService.isDealer() || userService.isCare();
    vm.loadingDataIndicatorTvFeed = true;
    vm.loadingDataIndicatorTvDashboard = true;
    vm.finalDataReceived = false;
    vm.selectedFlow = '';
    vm.lng = languageSwitcher.getCurrentLanguage();
    vm.province = $browser.cookies().province || 'ON';
    vm.showHardwareDD = true;
    vm.hasExtras = false;
    vm.hasThemes = false;
    vm.errorMessage = null;
    vm.selectedAccount = {};
    vm.igniteBadge = {};
    vm.hasChannelsList = false;
    vm.recentPackages = [];
    vm.withBonus = [];
    vm.showCallBanner = 'false';
    vm.tvObj = {
          globalColor: '',
          unlimitedClass: 'normal',
          myPlan: {},
          myExtras: [],
          myModem: {
            name: '',
            image: '',
            imageSm: ''
          },
          hardwareList: [],
          extraChannelList: [],
          selectedHardwareId: null,
          selectedHardwareName: '',
          selectedProductId: '',
          rtoIndicator: false, // RTO change
          oldTvPackage: true,
          withBonus: true
        };
    $scope.$eopModal = null;

    var formToRogersTimer;

    vm.isRepView = function () { return userService.isRepView(); };
    vm.isConsumer = function () { return userService.isConsumer(); };
    vm.isCare = function() { return userService.isCare(); };
    vm.isDealer = function() { return userService.isDealer(); };
    vm.isRepViewInOneview = function () { return vm.isOneview && userService.isRepView(); };
    vm.isCareRepView = function () { return userService.isRepView() && userService.isCare()};
    vm.changeDeviceImage = function () {
      var selOption = vm.tvObj.selectedHardwareId;
      var imageFile = null;
      for (var x1 = 0; x1 < tvResponse.cableTvDetails.hardwareMap.length; x1++) {
        var productName = tvResponse.cableTvDetails.hardwareMap[x1].productName;
        if (selOption === productName) {
          vm.tvObj.rtoIndicator = tvResponse.cableTvDetails.hardwareMap[x1].rtoIndicator; // RTO change
          var productId = tvResponse.cableTvDetails.hardwareMap[x1].productId;
          var objChild = tvResponse.cableTvDetails.deviceDetails[productId];

          if (objChild) {
            imageFile = objChild.digitalBoxImage;
            break; // show first
          }
        }
      }
      getDeviceImage(imageFile);
    };

    vm.postToRogersBottom = function (actionId) {
      if (vm.isConsumer()) {
        var form = $('#formToRogersBottom');
        form.attr('action', postToRogersUrls[actionId].url);
        form.submit();
      }
    };

    vm.postToRogers = function (actionId) {
      if (vm.lng === 'fr' && (actionId === 0 || actionId === 1 || actionId === 2 || actionId === 8)) {
        showChatBoxForFR();
        return;
      }

      if (vm.isConsumer()) {
        $('#formToRogers').attr('action', postToRogersUrls[actionId].url);
        vm.selectedFlow = postToRogersUrls[actionId].flowId;
        formToRogersTimer =$timeout(function () {
          $('#formToRogers').submit();
        });
      }
    };

    vm.onOmnitureClickTv = function (option) {
      appState.tagging(option);
    };

    vm.goToRogers = function (Id) {
      gotoURL = vm.lng === 'en' ? rogersTvUrls.en : rogersTvUrls.fr;
      $window.open(gotoURL[Id].url, '_blank');
    };

    var gotoURL, rogersTvUrls, postToRogersUrls, errorCode;
    var tvResponse = {};
    var langUpper = vm.lng.toUpperCase();

    /**
     * Setting for floating chat button
     */
    vm.liveChatSettings = liveChatSettings;
    // check maintainence for tv dahsboard
    if (appState.checkMaintenance('TV_ON_MAINTENANCE')) {
      $state.go('underMaintenance');
    }
    // Look into  non_angular_script/supportFunctions.js  for more information
    scrollPageToTop();					// jshint ignore:line

    vm.selectedAccount.accountName = {};
    vm.selectedAccount.accountNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER);
    vm.selectedAccount.ban = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);

    function getDeviceImage(imgFile) {
      if (_.isEmpty(imgFile)) {
        vm.tvObj.myModem.image = 'images/tv_icon_2.png';
      } else {
        vm.tvObj.myModem.image = imgFile;
      }
    };

    function processDevice() {
      for (var x1 = 0; x1 < tvResponse.cableTvDetails.hardwareMap.length; x1++) {
        var productId = tvResponse.cableTvDetails.hardwareMap[x1].productId;
        var objChild = tvResponse.cableTvDetails.deviceDetails[productId];
        if (objChild) {
          vm.tvObj.myModem.image = objChild.digitalBoxImage;
          vm.tvObj.selectedProductId = tvResponse.cableTvDetails.hardwareMap[x1].productId;
          vm.tvObj.selectedHardwareId = tvResponse.cableTvDetails.hardwareMap[x1].productName;
          vm.tvObj.rtoIndicator = tvResponse.cableTvDetails.hardwareMap[x1].rtoIndicator; // RTO change
          break; // show first
        } else if (tvResponse.cableTvDetails.hardwareMap && tvResponse.cableTvDetails.hardwareMap.length > 0) {
          vm.tvObj.selectedProductId = tvResponse.cableTvDetails.hardwareMap[0].productId;
          vm.tvObj.selectedHardwareId = tvResponse.cableTvDetails.hardwareMap[0].productName;
          vm.tvObj.rtoIndicator = tvResponse.cableTvDetails.hardwareMap[0].rtoIndicator; // RTO change
        }
      }
    };

    function loadTvFeed() {
      var status = '';
      var accType = '';
      if (vm.selectedAccount.accountInfo) {
        status = vm.selectedAccount.accountInfo.status;
        accType = vm.selectedAccount.accountInfo.accType;
      }
      appState.tagging(['_trackPageView',
        {pn: 'home:myrogers:tv'},
        {sACTT: status}, // Consumer, Business
        {sBAN: vm.selectedAccount.accountNumber}, //Account Number BAN, ex : '12345'
        {sCTN: vm.selectedAccount.accountNumber}, //Account Telephone Number CTN, ex: '4161234567|4161234568'
        {sACSS: accType}
      ]);
      vm.loadingDataIndicatorTvFeed = false;
    };

    function messageBoxDom() {
      vm.repAddDigitalBoxMsg = $translate.instant('tv_add_box') + '<span class="sgi-text">' + ' (' + $translate.instant('sgi') + ')' + '</span>';
      vm.repResetDigitalBoxMsg = $translate.instant('tv_reset_digital_box') + '<span class="tsp-text">' + ' ' + '(' + $translate.instant('tsp') + ')' + '</span>';
      vm.repResetDigitalPinMsg = $translate.instant('tv_reset_pin') + '<span class="tsp-text">' + ' (' + $translate.instant('tsp') + ')' + '</span>';
      vm.repAddOutletsMsg = $translate.instant('add_outlets') + ' ' + '(' + $translate.instant('sgi') + ')';
    };

    var unSubscribeProvinceChange = messagesService.subscribe('ute-oneview-footer-province-change', function (evt, data) {
      vm.province = data;
    });

    function loadIgniteBadgeJson () {
      /* $http.get('/web/totes/cms/content/json/tv/ignite-migration-badge.json')
        .then(function (obj) {
            if(obj && obj.data) {
               vm.igniteBadge = obj.data;
            }
        }, function (error) { });
 */
        var badgeData = {
          "DTV": {"province":"ON"}
          }
          vm.igniteBadge=badgeData;
    }

    function loadTvPackages () {
          /* $http.get('/web/totes/cms/content/json/tv/tv-packages-description.json')
            .then(function (obj) {
                if(obj && obj.data) {
                   vm.recentPackages = obj.data.latestPackages;
                   vm.withBonus = obj.data.withBonus;
                   vm.showCallBanner = obj.data.showCallBanner;
                }
            }, function (error) { }); */

            var tvData = {
                       	"latestPackages" : ["QDP1","QDP2","QDP3","QDPA","QDPB","QDPC"],
                       	"withBonus" : ["QDP1","QDP2","QDP3"],
                       	"showCallBanner" : "true"
                       }
            vm.recentPackages = tvData.latestPackages;
            vm.withBonus = tvData.withBonus;
            vm.showCallBanner = tvData.showCallBanner;
    }

    function processResponse (response) {
      if (_.isEmpty(response) || !response.cableTvDetails) {
        vm.displayContentTvDashboard = false;
        vm.loadingDataIndicatorTvDashboard = false;
        errorCode = 50000;
        vm.errorMessage = $translate.instant(errorCode);
      } else {  //TBD
        tvResponse = response;
        vm.displayContentTvDashboard = true;
        // To avoid loading error when there is cableTvDetails object & no cachedResultInfo object in the response object
        vm.loadingDataIndicatorTvDashboard = (response.cachedResultInfo == null || !response.cachedResultInfo) ? false : response.cachedResultInfo.expired;
        //console.log(response.cableTvDetails);
        vm.tvObj.myPlan.packageName = response.cableTvDetails.packageName;
        vm.tvObj.oldTvPackage = !(vm.tvObj && vm.tvObj.myPlan && (vm.recentPackages.indexOf(vm.tvObj.myPlan.packageName) >= 0));
        vm.tvObj.withBonus = !(vm.tvObj && vm.tvObj.myPlan && (vm.withBonus.indexOf(vm.tvObj.myPlan.packageName) >= 0));
        vm.tvObj.myPlan.packageDescription = response.cableTvDetails.packageDescription;
        vm.tvObj.myPlan.numChannels = response.cableTvDetails.channelsList.length;
        vm.tvObj.hardwareList = response.cableTvDetails.hardwareList;

        if (vm.tvObj.hardwareList.length < 2) {
          vm.showHardwareDD = false;
          vm.tvObj.selectedHardwareName = vm.tvObj.hardwareList[0];
        }

        processDevice();
        getDeviceImage(vm.tvObj.myModem.image);
        vm.tvObj.extraChannelList = [];

        if (response.cableTvDetails.themePackList !== undefined) {
          vm.tvObj.myExtras = response.cableTvDetails.themePackList;
          vm.hasThemes = vm.tvObj.myExtras.length > 0;
        }
        for (var x2 = 0; x2 < response.cableTvDetails.channelVOList.length; x2++) {
          //if (response.cableTvDetails.channelVOList[x2].extraChannel === true) {
          vm.tvObj.extraChannelList.push(response.cableTvDetails.channelVOList[x2].cmsTitle);
          //}
        }
        vm.hasExtras = vm.tvObj.extraChannelList.length > 0;
        var packagesList = ['QDPCS','QDPA','QDPB','QDPC','QAP1','QDP2','QDP3'];
        if( packagesList.contains(vm.tvObj.myPlan.packageName) ){
            vm.hasChannelsList = true;
        }
      }
    };

    function loadTvDashboard () {
      vm.loadingDataIndicatorTvDashboard = true;
      vm.displayContentTvDashboard = false;
      if (!vm.selectedAccount.accountNumber) {
        return;
      }
      tvDashService.tvDashboard(vm.selectedAccount.accountNumber, langUpper, vm.selectedAccount.ban, false).then(
        function (response) {
          processResponse(response);
          if (response.cachedResultInfo) {
            if (response.cachedResultInfo.expired) {
              tvDashService.tvDashboard(vm.selectedAccount.accountNumber, langUpper, vm.selectedAccount.ban, true).then(
                function (response) {
                  vm.finalDataReceived = true;
                  processResponse(response);
                },
                function (error) {
                  vm.displayContentTvDashboard = false;
                  vm.loadingDataIndicatorTvDashboard = false;

                  // Error handling - 555 exception
                  if (error.data.status === 555) {
                    errorCode = error.error.errorCode;
                    vm.errorMessage = error.error.message;
                  } else {
                    vm.errorMessage = $translate.instant('error_tv_feeder');
                  }
                });
            } else {
              vm.finalDataReceived = true;
            }
          }
        },
        function (error) {
          vm.displayContentTvDashboard = false;
          vm.loadingDataIndicatorTvDashboard = false;
          // Error handling - 555 exception
          if (error.data.status === 555) {
            errorCode = error.error.errorCode;
            vm.errorMessage = error.error.message;
          } else {
            vm.errorMessage = $translate.instant('error_tv_feeder');
          }
        });
    };

    function showChatBoxForFR () {
      var modalInstance = $modal.open({
        templateUrl: 'views/modals/contact-care-fr-customers.html',
        windowClass: 'generic-message-modal',
        controller: ['$scope', '$translate', function ($scope, $translate) {
          $scope.close = function () {
            modalInstance.close();
          };
        }]
      });
    };

    loadTvFeed();

    loadTvPackages();

    loadTvDashboard();

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      init(lang);
    }, 'tvDashboardControllerLangSub');

    $scope.$on('$destroy', function () {
      if ($scope.$eopModal) $scope.$eopModal.close();
      if (unSubscribeProvinceChange) {
        unSubscribeProvinceChange();
      }
      languageSwitcher.unregisterOnDataChangeHandler('tvDashboardControllerLangSub');
      $timeout.cancel(formToRogersTimer);
    });

    loadIgniteBadgeJson();

    init(languageSwitcher.getCurrentLanguage());

    function init(lang) {
      if (vm.isOneview) {
        messageBoxDom();
      }

      var oldLang = vm.lng;
      vm.lng = lang;
      langUpper = lang.toUpperCase();

      if (oldLang !== vm.lng) {
        loadTvDashboard();
        loadIgniteBadgeJson();
      }

      postToRogersUrls = [
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package?setLanguage=' + vm.lng, flowId: 'dbchangechnlortp'},
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package?setLanguage=' + vm.lng, flowId: 'dbchangepkg'},
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package?setLanguage=' + vm.lng, flowId: 'dbchangedigitalbox'},
        {url: '/web/myrogers/resetDigitalBox?setLanguage=' + vm.lng, flowId: ''},
        {url: '/web/myrogers/resetDigitalPin?setLanguage=' + vm.lng, flowId: ''},
        {url: 'https://secure.rogersondemand.com/User/Register?lang=' + vm.lng + '&returnUrl=http%3A%2F%2Fwww.rogersondemand.com%2F', flowId: ''},
        {url: 'http://www.rogersondemand.com/?lang=' + vm.lng, flowId: ''},
        {url: 'http://www.rogersondemand.com/OnDemand/TVShows?lang=' + vm.lng, flowId: ''},
        {url: '/web/myrogers/torcom/link/tv/build-your-tv-package?setLanguage=' + vm.lng, flowId: 'dbchangebonus'}
      ];

      rogersTvUrls = {
        en: [
          {url: 'http://rogers.com/anyplace-tv-signin'},
          {url: 'http://rogers.com/anyplace-tv-shows'},
          {url: 'http://rogers.com/watch-anyplace-tv'}
        ],
        fr: [
          {url: 'http://rogers.com/connexion-teletransportee'},
          {url: 'http://rogers.com/emissions-teletransportee'},
          {url: 'http://rogers.com/regarder-teletransportee'}
        ]
      };
    }

    getCurrentAccountAndTriggerEOP();

    function getCurrentAccountAndTriggerEOP() {
      if ($rootScope.isConsumer === true && $rootScope.isDealer === false && $rootScope.isCare === false) {
        newAccountOverviewFactory().getSelectedAccount()
        .then(function (selectedAccount) {
          triggerEOP(selectedAccount);
        })
      }
    }

    function triggerEOP(account, requestResponse) {
      account.accountOverview.selectedAccount.getAccountOverviewSummary().then(function (summary) {
        var accountNumber = summary.accountNumber + "";
        var subscriberInfo = EOPService.getActiveSubscriberInfo(summary);
        if (subscriberInfo.can && subscriberInfo.can.length === 12) {
          if ($scope.$eopModal) $scope.$eopModal.close();//To resolve unexpected issues
          EOPService.triggerEOPOperation(accountNumber, subscriberInfo.can).then(function(openModalObject){
            $scope.$eopModal = openModalObject;
          });
        }
      })
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('myrTvDashboardService', tvDashboardService);

  tvDashboardService.$inject = ['ajax', '$q'];

  /* @ngInject */
  function tvDashboardService(ajax, $q) {

    // Public API
    //noinspection UnnecessaryLocalVariableJS
    var service = {
      tvDashboard: tvDashboard
    };

    // private vars are here

    return service;

    //////////////////////////// implementation of public API is below ////////////////////////////

    function tvDashboard(accountNumber, language, ban, requestFreshData) {

      var deferred = $q.defer();

      // process the first time result
      function processResult(data) {
        deferred.resolve(data);
      }

      // call tvLanding api to get data
      ajax.tvDashboard(accountNumber, language, ban, requestFreshData).then(
        function (response) {
          if (response) {
            processResult(response);
          }
        }, function (error) {
          deferred.reject(error);
        });
      return deferred.promise;
    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrUnderMaintenanceController', UnderMaintenanceController);

  UnderMaintenanceController.$inject = ['$scope',
    '$rootScope',
    '$translate',
    'myrAccountOverviewService',
    'ute.blocks.messages.bus.service',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function UnderMaintenanceController($scope,
                                      $rootScope,
                                      $translate,
                                      accountOverviewService,
                                      messagesService,
                                      languageSwitcher) {
    if ($rootScope.isCare || $rootScope.isDealer) {
      messagesService.publish('ute-oneview-footer-disable');
    }
    // One of the most amazing codes will be here
    var maintenance = null;
    var languageHandler = 'underMaintenanceControllerLangSub' + $scope.$id;

    $scope.$extend({
      accountTypes: null,
      mAccountOverview: false,
      mWireless: false,
      mResidential: false,
      messageHeader: 'maintenance_page_header',
      messageId: 'maintenance_page_error',
      maintenanceInfo: $translate.instant($scope.messageId),
      maintenanceHeader : $translate.instant($scope.messageHeader)
    });

    $scope.initMT = function () {

      var request = {
        refresh: false
      };

      if ($rootScope.maintenance && $rootScope.maintenance.ACCOUNT_OVERVIEW_ON_MAINTENANCE) {

        accountOverviewService.getAccountList(request, function (_tmp) {
          $scope.accountTypes = _tmp.accountList;

        });

      }
    };

    if (!$rootScope.noAccountList) {
      $scope.initMT();
    }

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if (!$scope.messageId) {
        return;
      }

      $scope.maintenanceInfo = $translate.instant($scope.messageId);
      $scope.maintenanceHeader = $translate.instant($scope.messageHeader);
    }, languageHandler);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler(languageHandler);
    });

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.utilities').value('jQuery', $)/*.value('lodash', _)*/;
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('myr.modules.utilities').service('ml.utilitiesService', utilitiesService);

  utilitiesService.$inject = ['$log'/*, 'lodash'*/];

  /* @ngInject */
  function utilitiesService($log/*, _*/) {

    return {
      getQueryParameters: getQueryParameters,
      loadQualtrics: loadQualtrics
    };

    /**
     * Parse location query params and return hashmap
     *
     * @example http://example.com/test?lunch=sandwich&dinner=stirfry will return { "lunch": "sandwich", "dinner": "stirfry" }
     *
     * @param str
     * @returns {*}
     */
    function getQueryParameters(str) {
      return (str || document.location.search).replace(/(^\?)/, '').split('&').map(function (n) {
        return n = n.split('='), this[n[0]] = n[1], this;
      }.bind({}))[0];
    }
    function loadQualtrics() {
      //Run the Qualtrics code
      if (typeof(window.QSI) !== 'undefined') {
        var loadQualtricsTimeout = setTimeout(function () {
          window.QSI.API.unload();
          window.QSI.API.load();
          window.QSI.API.run();
          clearTimeout(loadQualtricsTimeout);
        }, 500);
      }
    }
  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').factory('winOnlineService', winOnlineService);

  winOnlineService.$inject = ['ajax', '$rootScope'];

  /* @ngInject */
  function winOnlineService(ajax, $rootScope) {

    var retObj = {
      winFlag: false,
      isWinOnline: function (currentAccNumber) {
        //winonline invoice start
        $rootScope.winFlag = false;
        var winrequest = {
          'accountNumber': currentAccNumber
        };

        ajax.checkWinOnline(winrequest).then(
            function (data) {
              //console.log('win data ' + data);
              //console.log('isWinRegistered ' + data.isWinRegistered);
              if (data && data.isWinRegistered == 'Y') {
                $rootScope.winFlag = true;
                retObj.winFlag = true;
              }
            }, function (error) {
            }
        );
        //winonline invoice stop
        return retObj.winFlag;
      }
    };
    return retObj;
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('WinPastInvoiceController', WinPastInvoiceController);

  WinPastInvoiceController.$inject = ['$scope', 'settings', 'ute.blocks.language.switcher', 'myrAccountListService', '$sce'];

  /* @ngInject */
  function WinPastInvoiceController($scope, settings, languageSwitcher, myrAccountListService, $sce) {
    var lang = languageSwitcher.getCurrentLanguage().toLowerCase();
    if (settings.isDevBB) {
      console.log('Dev invoice');
      $scope.iframeurl = $sce.trustAsResourceUrl('http://dev.bss.rogers.com:8219/bizonline/ecom/disp.do?dest=invHistory&lang=' + lang + '_CA&ban=' + myrAccountListService.selectedAccount.accountNumber);
    } else if (settings.isQaBB) {
      $scope.iframeurl = $sce.trustAsResourceUrl('http://qa.bss.rogers.com:8219/bizonline/ecom/disp.do?dest=invHistory&lang=' + lang + '_CA&ban=' + myrAccountListService.selectedAccount.accountNumber);
    } else if (settings.isProdBB) {
      $scope.iframeurl = $sce.trustAsResourceUrl('https://prod.bss.rogers.com/bizonline/ecom/disp.do?dest=invHistory&lang=' + lang + '_CA&ban=' + myrAccountListService.selectedAccount.accountNumber);
    }
  }
})();

/* jshint -W106 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessDashboardController', WirelessDashboardController);

  WirelessDashboardController.$inject = ['$scope',
    '$rootScope',
    'appState',
    'util',
    'myrWirelessDashboardService',
    'myrAccountListService',
    'myrAccountBalanceDataFactory',
    'myrMyServicesService',
    '$log',
    'settings',
    '$state',
    'ute.data.manager.service',
    'ute.common.voicemail.resetPassword.service',
    'liveChatSettings',
    '$translate',
    'ute.dtm.service',
    'ute.common.user.service',
    'ute.rogers.account.overview.factory',
    'ute.rogers.account.overview.summary.factory',
    'ute.change.ctn.callerId',
    'ute.common.permissions.service',
    'ute.blocks.language.switcher',
    '$timeout',
    '$location',
    '$anchorScroll',
    'ute.common.suspend.ctn.service',
    '$window',
    'ute.datalayer.common.service',
    '$filter',
    'ute.common.core.browser.service',
    'localStorage'
  ];

  /* @ngInject */
  function WirelessDashboardController($scope,
                                       $rootScope,
                                       appState,
                                       util,
                                       wirelessDashboardService,
                                       myrAccountListService,
                                       myrAccountBalanceDataFactory,
                                       myrServicesService,
                                       $log,
                                       settings,
                                       $state,
                                       dataManagerService,
                                       voicemailResetPasswordService,
                                       liveChatSettings,
                                       $translate,
                                       dtmService,
                                       userService,
                                       accountOverviewFactory,
                                       accountOverviewSummaryFactory,
                                       changeCtnCallerIdService,
                                       permissionsService,
                                       languageSwitcher,
                                       $timeout,
                                       $location,
                                       $anchorScroll,
                                       suspendCtnService,
                                       $window,
                                       dataLayerService,
                                       $filter,
                                       browserService,
                                       localStorage) {
    var wdController = this;
    var accountOverviewSummaryWorker,
      accountOverviewService,
      request, //TODO: get rid of this var!
      errorMessageKey,
      wirelessAccounts,
      colDataWrapElements,
      date3Filter = $filter('date3'),
      colorHexGuide = ['#008fb6', '#E4BC40', '#662d91', '#7aaa39', '#ac0067', '#2926ab', '#cd5e40', '#2b464c', '#bbb62a', '#317d59'];

    var accelemtTimer;
    var displayWirelessDashBoardTimer;
    var isFirstCycleAfterPpc = false;
    wdController.talkTextInfoModal = {
      wd: '',
      template: 'scripts/modules/wirelessDashboard/partials/talkAndTextModal.html',
      displayContent: false,
      textsLbl: '',
      nextCycle: '',
      lang: ''
    };

    //variables controlling the wirelessDashboard api call
    permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ROGERS_DISABLE_ALL_USAGE).then(function (isPermitted){
      wdController.disableAllUsageSwitch = isPermitted;
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ROGERS_DISPLAY_DATA_USAGE).then(function (dataPermitted){
        wdController.displayDataUsageSwitch = dataPermitted;
        //in case both - disable_all and display_data permission is true, making display_data = false
        if (wdController.disableAllUsageSwitch && wdController.displayDataUsageSwitch) {
          wdController.displayDataUsageSwitch = false;
        }
        if (wdController.disableAllUsageSwitch || wdController.displayDataUsageSwitch) {
          wdController.displayAllUsage = false;
        } else {
          wdController.displayAllUsage = true;
        }
        localStorage.setLocalStorageValue('disableAllUsageSwitch', wdController.disableAllUsageSwitch);
        localStorage.setLocalStorageValue('displayDataUsageSwitch', wdController.displayDataUsageSwitch);
      });
    });


    //Add Topup BRT for Non share
    permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ROGERS_ENABLE_ADDON).then(function(isPermitted){
      wdController.isAddTopUpEnabled = isPermitted;
    });
    //Add Topup BRT for Non share

    wdController.showInfinitePlanAlert =  function() {
      return isFirstCycleAfterPpc;
    };

    wdController.isInfiniteThrottled = function() {
      var _throttled = false;
      if (wirelessDashboardService.isInfinitePlan()) {
        _throttled = (wdController.wd.data.globalDisplayRemain <= 0) && (wdController.wd.data.globalDisplayOverage >= 0);
      }
      wdController.wd.data.globalColor = _throttled ? 'usageWarning': 'usageNormal';
      return _throttled;
    }

    wdController.alertData = {
      copy: {
        ariaLabel: 'aria',
        icon: 'check',
        body: $translate.instant('ute.dataManager.infiniteAlert.body'),
        closeLabel: $translate.instant('ute.dataManager.infiniteAlert.closeLabel'),
      }
    };

    wdController.usageRefreshed = $rootScope.dialUsageRefreshEnable;
    if (!$rootScope.usageRefreshedCTNS || $rootScope.usageRefreshedCTNS == undefined) {
     $rootScope.usageRefreshedCTNS = [];
    }
    //wdController.displayAllUsage = (!wdController.disableAllUsageSwitch && !wdController.displayDataUsageSwitch) ? true : false;
  //dc-827 end
    //FDM -- shareEverything integration functionality /////////////////////////////////////////////
    wdController.getStartMonth = function () {
      return dataManagerService.getBillCycle().startDate.month;
    };

    wdController.getStartDay = function () {
      return dataManagerService.getBillCycle().startDate.day;
    };

    wdController.getEndMonth = function () {
      return dataManagerService.getBillCycle().endDate.month;
    };

    wdController.getEndDay = function () {
      return dataManagerService.getBillCycle().endDate.day;
    };

    wdController.getNextStartMonth = function () {
      var nextBillCycleStartDate;
      nextBillCycleStartDate = myrAccountBalanceDataFactory.accountBalance.nextBillCycleStartDate;
      if (nextBillCycleStartDate) {
        var date = nextBillCycleStartDate.split('-');
        return (date && date.length > 0) ?
          $translate.instant('ute.rogers.wireless_dashboard.next_billing_months.' + parseInt(date[1]), {'startDay': date[2]})
          : '';
      } else {
        return '';
      }
    };

    wdController.getNextBillDaysUntil = function () {
      var billingAccount = myrAccountBalanceDataFactory.accountBalance;
      if (billingAccount && billingAccount.nextBillDate !== null) {
        var date = date3Filter(billingAccount.nextBillDate);
        return date ?
          $translate.instant('ute.rogers.wireless_dashboard.wireless_next_bill_days_until', {'nextbilldaysuntil': parseInt(date.trim()) + 1})
          : '';
      }
    };

    wdController.displayName = function () {
      return dataManagerService.getDisplayNameCTN(wdController.ctn);
    };

    wdController.goToManageAlerts = function (index) {
      dataManagerService.setDataManagerActiveTabIndex(index);
      dataManagerService.goToSubModule(dataManagerService.getConfig().advanced.dataManagerAccountsSummary.subState);
    };

    wdController.getDataAccess = function () {
      return dataManagerService.getDataAccessCTN(wdController.ctn);
    };

    wdController.getReducedVideoQuality = function () {
      return dataManagerService.getVideoQualityReducedCTN(wdController.ctn);
    };

    wdController.getIsVideoThrottlePermitted = function () {
      return dataManagerService.getIsVideoThrottlePermitted();
    };

    var getIndexByCTN = function () {
      return dataManagerService.getIndexByCTN(wdController.ctn);
    };

    wdController.getSavedAlertValue = function () {
      return dataManagerService.getSavedAlertValueCTN(wdController.ctn);
    };

    /////////////////////////////////////////////////////////////////////////////////////////////////

    wdController.onClickViewMyWirelessTalkUsage = function () {
      wdController.talkIsCollapsed = !wdController.talkIsCollapsed;
      if (!wdController.talkIsCollapsed) {
        dataLayerTrackDialDetails('talkUsage');
      }
    };

    wdController.onClickViewMyWirelessDataUsage = function () {
      wdController.dataIsCollapsed = !wdController.dataIsCollapsed;
      if (!wdController.dataIsCollapsed) {
        dataLayerTrackDialDetails('dataUsage');
      }
    };

    wdController.onClickViewMyWirelessTextUsage = function () {
      wdController.smsIsCollapsed = !wdController.smsIsCollapsed;
      if (!wdController.smsIsCollapsed) {
        dataLayerTrackDialDetails('textUsage');
      }
    };

    wdController.changeComboCTN = function (ctn) {

      if (wdController.isShareEverything) {
        getFDMUsageDetails();
      }

      var searchIndex = _.findIndex(wdController.wirelessDashData, {
        ctn: ctn
      });

      if (searchIndex >= 0) {
        wdController.wirelessDashActive = wdController.wirelessDashData[searchIndex];
        changeAccount();
      }
    };

    function dataLayerTrackDialDetails(analyticsKey) {
      var payload = {events: {selfServeComplete: true}};
      dataLayerService.track(payload, false, [0, 4], {mappingKey: 'wirelessDashboard.' + analyticsKey});
    }

    function getAccountEmail() {
      return _.has($rootScope.ao, 'accountDetails.contactInfo.emailAddress') ? $rootScope.ao.accountDetails.contactInfo.emailAddress : '';
    }

    function getFirstNameFromCtn(ctn) {
      var ctnRecord = _.find(myrServicesService.myServicesList, {
        'subType': 'CTN',
        'serviceDetail': ctn
      });
      if (ctnRecord) {
        return ctnRecord.firstName;
      }
      return '';
    }

    wdController.invokeSuspendCtnService = function () {
      var accountEmail = getAccountEmail();
      if (wdController.isDealer || wdController.isCare) {
        suspendCtnService.configure({
          basic: {
            mainTemplateUrl: suspendCtnService.getConfig().basic.mainRepViewTemplateUrl
          },
          advanced: {
            confirmSuspendDevice: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewConfirmSuspendDevice.templateUrl
            },
            suspendCtnSuccess: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewSuspendCtnSuccess.templateUrl
            },
            suspendCtnError: {
              templateUrl: suspendCtnService.getConfig().advanced.repViewSuspendCtnError.templateUrl
            }
          }
        });
      }
      suspendCtnService.goToEntryState({
        phoneNumber: wdController.ctn,
        accountNumber: wdController.ban,
        accountEmail: accountEmail,
        firstName: getFirstNameFromCtn(wdController.ctn)
      });
    };

    wdController.toggleAccordian = function () {
      if (!wdController.isOpenDetails) {
        dtmService.direct('pasv-myrogers-share everything-view usage details');
      }
    };

    function getIndexNameByCTN(summary, ctn) {
      return _.findIndex(summary.subList, function (item) {
        return item.subNumber === ctn;
      });
    }

    function updateModel(summary) {

      var ctnToChange = changeCtnCallerIdService.getCtn(),
        subListIndex = getIndexNameByCTN(summary, ctnToChange),
        newFirstName = summary.subList[subListIndex].firstname,
        newLastName = summary.subList[subListIndex].lastname;

      _.forEach(wdController.wirelessDashData, function (item) {
        if (item.ctn === ctnToChange) {
          item.firstname = newFirstName;
        }
      });

      _.forEach(myrServicesService.myServicesList, function (sub) {
        if (sub.subType === 'CTN' && sub.serviceDetail === ctnToChange) {
          sub.firstName = sub.menuFirstName = newFirstName;
          sub.lastName = newLastName;
        }
      });

      myrServicesService.clearAccountDetails();
      myrServicesService.myServicesList = [];

      myrServicesService.isDetailsNotFound = false;
      $rootScope.ao.accountDetails = myrServicesService.accountDetails = summary;

      var subscriptions;

      if ($rootScope.isConsumer) {
        subscriptions = myrServicesService.getSubscriptions(myrServicesService.accountDetails.subList, false);
        //TODO: why do we need to put the following value on $rootScope?
        $rootScope.myServicesList = myrServicesService.myServicesList = subscriptions.myServices;
        myrServicesService.storedSummary = summary;
        return null;
      } else if ($rootScope.isCare || $rootScope.isDealer) {
        var disablePermissionNotGranted = [true,true,true], badgePermission;
        badgePermission = ['Maestro_TV_Dashboard', 'Maestro_INT_Dashboard', 'Maestro_RHP_Dashboard'];
        permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
          if (isPermitted) {
            if (!_.isArray(badgePermission)) {
              badgePermission = [badgePermission];
            }
            badgePermission.forEach(function (permission) {
              var uteCommonPermission = _.get(ute.common.permissions.service.RamResourceCodes, permission, permission);
              permissionsService.getRamPermission(uteCommonPermission, ute.common.permissions.service.RamActionCodes.grant)
                .then(function (repPermission) {
                  if (repPermission) {
                    disablePermissionNotGranted[index] = false;

                  } else {
                    disablePermissionNotGranted[index] = true;
                  }
                  subscriptions = myrServicesService.getSubscriptions(myrServicesService.accountDetails.subList, disablePermissionNotGranted);
                  //TODO: why do we need to put the following value on $rootScope?
                  $rootScope.myServicesList = myrServicesService.myServicesList = subscriptions.myServices;
                  myrServicesService.storedSummary = summary;
                  return null;
                });
            });
          }
        });
      }
    }

    function getCurrentState() {
      return $state.current.name;
    }

    //	State reset / variables erase
    function pageVariablesInit(firstTime) {
      wirelessAccounts = [];
      errorMessageKey = '';

      wdController.nextBillDate = null;
      wdController.lng = languageSwitcher.getCurrentLanguage();
      wdController.talkTextInfoModal;
      wdController.displayContent = false;
      wdController.loadingDataIndicator = true;

      wdController.errorMessage = '';
      wdController.wirelessDashData = [];
      wdController.wd = null;
      wdController.wdEmpty = false;
      wdController.wdMidCycle = false;
      wdController.wdMCPPCrerating = false;

      // Show / hide sections
      wdController.showData = false;
      wdController.showRoaming = false;
      wdController.showRoamingComingSoon = false;
      wdController.showSms = false;
      wdController.showTalk = false;
      wdController.UnlimitedTalkLocalCalling = false;
      wdController.isCanadaWide = false;

      // Mobile view collapsed
      wdController.dataIsCollapsed = true;
      wdController.talkIsCollapsed = true;
      wdController.smsIsCollapsed = true;
      wdController.roamingIsCollapsed = true;
      wdController.viewContent = false;
      wdController.indexColor = wdController.isShareEverything ? colorHexGuide[getIndexByCTN()] : colorHexGuide[0];

      // Travel packages
      wdController.fraudSocErrorMessage = null;
      wdController.isFraudSocAvailable = false;

      // Trigger collapse event
      colDataWrapElements.collapse('hide');

      // Page refresh is different from selector update.
      if (firstTime) {
        // First time load
        colDataWrapElements.removeClass('in');
      }
    }

    /*
     * Data loading
     */
    function getAccountList() {
      wirelessAccounts = [];
      try {
        appState.tagging(['_trackPageView', {
          pn: 'home:myrogers:wireless'
        }]);
        appState.tagging(['_trackLink', {
          event17: ''
        }]);
      } catch (e) {
        // DSO-10556 - Fix for Privacy Violation (Issue 5.1.5)
        //$log.error('Exception catch during tagging on pn=home:myrogers:wireless with message:', e.message);
      }

      accountOverviewService.getSelectedAccountDetails()
        .then(function (accountDetails) {
          if (accountDetails) {
            getAccountListSimple(accountDetails);
          } else {
            // Redirect to link accounts?
            appState.switchView('accountOverview');
          }
        })
        .catch(function () {
          wdController.loadingDataIndicator = false;
          if (!wdController.isShareEverything) {
            scrollPageToTop();
          }
        });

      if (!myrAccountBalanceDataFactory.accountBalance.nextBillDate) {
        getBalanceDetails();
      }
    }

    function getAccountListSimple(accountDetails) {
      var ban = null;
      wdController.wirelessDashData = [];

      if (accountDetails.dataStatus.toLowerCase() === 'success') {
        if (typeof accountDetails === 'object') {
          // Sift through the raw objects and look for phone numbers
          ban = accountDetails.accountNumber;

          wdController.wirelessDashData = _.filter(_.map(accountDetails.subList, function (item) {
            var shareEverythingCTN = !!(item.shareEverything);
            var shareEverythingPass = dataManagerService.getBRT() ? (wdController.isShareEverything === shareEverythingCTN) : true;

            if ((typeof item === 'object' && item.subType === 'CTN' && item.subStatus !== 'Suspended') && shareEverythingPass) {
              var firstname = item.firstname;

              if (firstname && firstname.length > 11) {
                firstname = firstname.substring(0, 9) + '...';
              }

              var wirelessDashDataObj = {
                ban: ban,
                ctn: item.subNumber,
                firstname: firstname
              };

              if (wirelessDashDataObj.ctn === wdController.ctn) {
                wdController.wirelessDashActive = wirelessDashDataObj;
                dtmService.trackCTN(wdController.wirelessDashActive.ctn);
              }
              return wirelessDashDataObj;
            }
          }), function (wirelessDashDataObj) {
            return wirelessDashDataObj !== undefined; //filter out undefined items from array
          });
        }

        getWirelessDashBoard(wdController.wirelessDashActive);

        //Save wirelessDashData to service to be used in wirelessPackage directive
        wirelessDashboardService.setWirelessDashData(wdController.wirelessDashData);
        /**
         * Check if the system need to show reset voicemail password Modal
         */
        if (wirelessDashboardService.showResetVoicemailModal()) {
          /**
           * set the show reset password flag to flag to false when showing the overlay
           */
          wirelessDashboardService.disableResetVoicemailModal();
          voicemailResetPasswordService.openModalPopup(ban, wdController.ctn);
        }
      } else if (accountDetails.dataStatus.toLowerCase() === 'fail' || accountDetails.dataStatus.toLowerCase() === 'error') {
        setErrorMessage('error_wireless_usage');
      }
    }

    wdController.showDials = function(){
      return !wdController.hideDialsSection && ((!(wdController.wdEmpty || wdController.wdMidCycle) && !wdController.loadingDataIndicator) || wdController.staticForTalkAndTextOnly);
    };

    //refresh button wirelessdashboard.html - dc-827
    wdController.refreshUsage = function() {
      $rootScope.dialUsageRefreshEnable = true;
      wdController.usageRefreshed = $rootScope.dialUsageRefreshEnable;
      if (wdController.usageRefreshed) {
        //wdController.displayAllUsage = false;
        //wdController.displayDataUsageSwitch = false;
        wdController.disableAllUsageSwitch = false;
        $rootScope.usageRefreshedCTNS.push(wdController.wirelessDashActive.ctn);
      }
      getWirelessDashBoard(wdController.wirelessDashActive, true);
    }
    //refresh button wirelessdashboard.html - dc-827

    //FDM - DC-827
    //watch for the click on the "view talk usage" on plan section - wirelessPlan.html
    var watchTalkAndTextFDM = $scope.$watch( function () {
        return wirelessDashboardService.getWirelessDashboardTalkAndTextFDM();
      }, function (newVal, oldVal) {
        if (newVal != oldVal) {
          if (newVal) {
            wdController.planSectionTalkAndText = true;
            getWirelessDashBoard(wdController.wirelessDashActive);
          }
        }
    });
    //Mobile FDM
    wdController.wirelessDashboardCallMobile = function () {
     if (!wdController.disableAllUsageSwitch && !wdController.displayDataUsageSwitch) {
     } else if (wdController.disableAllUsageSwitch || (!wdController.disableAllUsageSwitch && wdController.displayDataUsageSwitch)) {
       wirelessDashboardService.setWirelessDashboardTalkAndTextFDM(true);
     }
    }

    wdController.isRefreshUsageMobile = function () {
      if (wdController.isShareEverything) {
        return true;
      } else {
        if (!wdController.displayDataUsageSwitch && !wdController.disableAllUsageSwitch) {
          return true;
        } else
          return $rootScope.dialUsageRefreshEnable;
      }
    }
    //FDM END

    function getWirelessDashBoard(rdata, calledFromRefreshUsage) {
      var holder;
      calledFromRefreshUsage = calledFromRefreshUsage || false;
      var request = {
        ban: rdata ? rdata.ban : null,
        ctn: rdata ? rdata.ctn : null
      };

      if (!request.ban || !request.ctn) {
        request.ban = wdController.ban;
        request.ctn = wdController.ctn;
      }

      var FDMSpecific = (wdController.isShareEverything && (wdController.planSectionTalkAndText || wdController.displayAllUsage));
      wdController.usageRefreshed = $rootScope.dialUsageRefreshEnable = false;
      _.forEach($rootScope.usageRefreshedCTNS, function(ctn) {
        if (ctn === request.ctn) {
          wdController.usageRefreshed = $rootScope.dialUsageRefreshEnable = true;
        }
      });
      if (wdController.displayAllUsage) {
        wdController.usageRefreshed = true ;
      }

      if (FDMSpecific || (!wdController.isShareEverything && (wdController.usageRefreshed || wdController.displayAllUsage || wdController.displayDataUsageSwitch))) {
        wdController.staticForTalkAndTextOnly = false;
        var newRequest = angular.copy(request);
        newRequest.usageType = 'DATA';
        var postData = wdController.usageRefreshed || wdController.displayAllUsage ? request : newRequest;
        postData = FDMSpecific? request : postData;
        wdController.loadingDataIndicator = true;
        if (postData.ban && postData.ctn) {
          if(calledFromRefreshUsage && browserService.isIOS()) {
            wdController.hideDialsSection = true;
          }
          wirelessDashboardService.getWirelessDashBoard(postData, function (_tmp) {
            wdController.loadingDataIndicator = false;
            if (!wdController.isShareEverything) {
              scrollPageToTop();
            }

          if (_tmp.result === 'success') {
            // Proceed to display
            wdController.wd = _tmp.data;
            wdController.wdEmpty = _tmp.empty;
            wdController.wdMidCycle = _tmp.midCycle;
            wdController.wdMCPPCrerating = _tmp.MCPPCrerating;
            if (!wdController.usageRefreshed && wdController.displayDataUsageSwitch && _tmp.empty) {
              wdController.staticForTalkAndTextOnly = true;
              wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showData.html'});
              wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showTalk.html'});
              wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showSms.html'});
            } else {
              wdController.staticForTalkAndTextOnly = false;
              // If any more variables need to come through -> make params into an object
              displayWirelessDashBoardDelay(_tmp.data, _tmp.empty, _tmp.midCycle, _tmp.MCPPCrerating);
            }
          } else if (_tmp.result === 'fail') {
            holder = _tmp.data;
            setErrorMessage('wireless_usage_failed');
            wdController.hideDialsSection = false;

            } else if (_tmp.result === 'error') {
              // holder = _tmp.data;
              if (wdController.isDealer || wdController.isCare) {
                wdController.flags.wpkg_loadingDataIndicatorPackage = true;
                wdController.flags.wpkg_loadingDataIndicatorDevice = true;
                wdController.flags.wpkg_displayContentPackage = false;
                wdController.flags.wpkg_displayContentDevice = false;
              }
              setErrorMessage('wireless_usage_failed');
            wdController.hideDialsSection = false;
            }
          });
        }
        wdController.planSectionTalkAndText = false;
        wirelessDashboardService.setWirelessDashboardTalkAndTextFDM(false);
      } else if (!FDMSpecific && wdController.disableAllUsageSwitch) {
        wdController.carouselSettings.slides = [];
        wdController.loadingDataIndicator = false;
        wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showData.html'});
        wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showTalk.html'});
        wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showSms.html'});
      }
    }

    /*
     * Data process and display
     */
    function displayWirelessDashBoardDelay(allData, allEmpty, allMidCycle, allMCPPCrerating) {
      displayWirelessDashBoardTimer = $timeout(function () {
        displayWirelessDashBoard(allData, allEmpty, allMidCycle, allMCPPCrerating);
        wdController.hideDialsSection = false;
      }, 100);
    }

    function displayWirelessDashBoard(allData, allEmpty, allMidCycle, allMCPPCrerating) {
      wdController.carouselSettings.slides = [];
      // Display main blocks
      // Need to show a different word when usage is plural in Fr (restant vs restants)
      var isGlobalDataDisplayRemainPlural = function (value) {
        var amountThatIsMoreThanOneGB = 1053818,
          amountThatIsConsideredOneGB = 1048576,
          amountThatIsConsideredOneMB = 1535;
        return (value > amountThatIsMoreThanOneGB || value < amountThatIsConsideredOneGB && value > amountThatIsConsideredOneMB);
      };
      // Need to show a different word when minutes are plural in Fr (restant vs restants)
      var isGlobalTalkDisplayRemainPlural = function (value) {
        return value > 1;
      };
      wdController.wd = allData;

      wdController.talkTextInfoModal.wd = wdController.wd;

      wdController.wdEmpty = allEmpty;
      wdController.wdMidCycle = allMidCycle;
      wdController.wdMCPPCrerating = allMCPPCrerating;

      // Process the highest percentage and select proper color as result decide to show in template (show =  true / false)
      if (wdController.usageRefreshed || wdController.displayAllUsage || wdController.displayDataUsageSwitch) {
        wdController.showData = wirelessDashboardService.globalDataSets(allData.data, 'data');
      }
      if (wdController.showData) {
        if (wdController.displayDataUsageSwitch && !wdController.usageRefreshed) {
          wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showData.html'});
          wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showTalk.html'});
          wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showSms.html'});
        } else {
          wdController.carouselSettings.slides.push({template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showData.html'});
        }
      }
      wdController.showRoaming = false; // Section shutdown on 2015-04-14 11:48am
      wdController.showRoamingComingSoon = wirelessDashboardService.globalDataSets(allData.roaming, 'roaming');
      wdController.showRoamingComingSoonUrl = $translate.instant('wireless_roaming_details_coming_soon_chat_with_us_url');
        wdController.showTalk = wirelessDashboardService.globalDataSets(allData.talk, 'talk');

      if (wdController.showTalk) {
        wdController.carouselSettings.slides.push({
          template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showTalk.html'
          //template: 'showTalk'
        });
      }
        wdController.showSms = wirelessDashboardService.globalDataSets(allData.sms, 'sms');

      if (wdController.showSms) {
        wdController.carouselSettings.slides.push({
          template: 'scripts/modules/wirelessDashboard/partials/wireless.dial.showSms.html'
          //template: 'showSms'
        });
      }

      if (wdController.carouselSettings.slides.length) {
        wdController.carouselSettings.slides[0].active = true;
      }

      wirelessDashboardService.getWirelessPostpaid(request)
        .then(function (result) {
          setIsFirstCycleAfterPpc(result);
          if (result && result.data && result.data.isCanadaWide && result.data.isCanadaWide.content && result.data.isCanadaWide.content.isCanadaWide) {
            wdController.isCanadaWide = true;
            wdController.UnlimitedTalkLocalCalling = false;
          } else if (result && result.data && result.data.isCanadaWide && result.data.isCanadaWide.content && !result.data.isCanadaWide.content.isCanadaWide) {
            wdController.UnlimitedTalkLocalCalling = true;
            wdController.isCanadaWide = false;
          } else {
            wdController.UnlimitedTalkLocalCalling = false;
            wdController.isCanadaWide = false;
          }
        });

      // Show collapsed
      $('.colDataWrap').removeClass('in');

      // Hide loading icon
      wdController.displayContent = true;
      wdController.loadingDataIndicator = false;
      wdController.talkTextInfoModal.displayContent = wdController.displayContent;
      if (!wdController.isShareEverything) {
        scrollPageToTop();
      }

      if (wdController.wd.data){
        wdController.globalDataDisplayRemainPlural = isGlobalDataDisplayRemainPlural(wdController.wd.data.globalDisplayRemain);
        }
      if (wdController.wd.talk){
        wdController.globalTalkDisplayRemainPlural = isGlobalTalkDisplayRemainPlural(wdController.wd.talk.globalDisplayRemain);
        }
      // refresh the scope DOM
    }

    wdController.scrollToSection = function (hash) {
      $location.hash(hash);
      $anchorScroll.yOffset = 65;
      $anchorScroll();
    };

    function setIsFirstCycleAfterPpc(result) {
      wdController.showAddData = false;
      try {
        var effectiveDate = _.get(result, 'data.postPaidPhoneDetails.dateEffective', null);
        var planDescription = _.get(result, 'data.postPaidPhoneDetails.planDescription', null);
        if ((planDescription || '').indexOf('Infinite') > -1) {
          $window.sessionStorage.setItem('isInfinitePlan', JSON.stringify(true));
        }
        var nextBillDate = myrAccountBalanceDataFactory.accountBalance.nextBillingDate;
        var effectiveDateMomentObj = moment(effectiveDate);
        var nextBillDateMomentObj = moment(nextBillDate);
        if (effectiveDateMomentObj.isValid() && nextBillDateMomentObj.isValid()) {
          var effectiveDateMomentObjPlus1Month = moment(effectiveDate).add(1, 'M');
          isFirstCycleAfterPpc = (planDescription || '').indexOf('Infinite') > -1 &&
            (
              nextBillDateMomentObj.isSame(effectiveDateMomentObj) ||
              nextBillDateMomentObj.isSame(effectiveDateMomentObjPlus1Month) ||
              nextBillDateMomentObj.isBetween(effectiveDateMomentObj, effectiveDateMomentObjPlus1Month)
            );
        } else {
          isFirstCycleAfterPpc = false;
        }
      } catch (error) {
        isFirstCycleAfterPpc = false;
      }
      // DC-2463: Hide Add Speed Pass button for the first billing cycle after PPC to Infinite plan.
      wdController.showAddData = !isFirstCycleAfterPpc;
    }

    function changeAccount() {
      // Load JSON with account overview details
      resetErrorMessage();
      resetCarouselSettings();
      wdController.disableAllUsageSwitch = localStorage.getLocalStorageValue('disableAllUsageSwitch') === 'true';
      wdController.displayDataUsageSwitch = localStorage.getLocalStorageValue('displayDataUsageSwitch') === 'true';

      // notify wirelessPackage.js directive that loader icons need to show up
      wdController.flags.wpkg_loadingDataIndicatorPackage = true; // jshint ignore:line
      wdController.flags.wpkg_loadingDataIndicatorDevice = true; // jshint ignore:line

      wdController.flags.wpkg_displayContentPackage = false; // jshint ignore:line
      wdController.flags.wpkg_displayContentDevice = false; // jshint ignore:line

      // Update local storage
      if (wdController.wirelessDashActive && wdController.wirelessDashActive.ctn && wdController.wirelessDashActive.ban) {

        userService.getPersistentService().put('ban', wdController.wirelessDashActive.ban);
        userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, wdController.wirelessDashActive.ctn);

        accountOverviewService.selectSubscription(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, wdController.wirelessDashActive.ctn);
      }

      // reset all initial variables
      pageVariablesInit(false);

      getAccountList();

      if (!wdController.isShareEverything) {
        scrollPageToTop();
      }
    }

    function getBalanceDetails() {
      var acctDetails = myrAccountListService.selectedAccount;
      var request = {
        accountNumber: acctDetails.accountNumber,
        accountTypeNumber: acctDetails.accountTypeNumber,
        pinNumber: acctDetails.pinNumber,
        phoneNumber: acctDetails.phoneNumber,
        language: wdController.lng,
        refresh: false,
        applicationId: 'Rogers.com'
      };

      myrAccountBalanceDataFactory.getBalanceDetails(request, angular.noop);
    }

    function setErrorMessage(key) {
      if (errorMessageKey === '' || errorMessageKey === undefined) {
        errorMessageKey = key;
        wdController.errorMessage = $translate.instant(key);
        wdController.wirelessUsageLiveChatParams = (key === 'wireless_usage_failed') ? {
          'id': 'error_wireless_usage_live_chat_params.id',
          'div': 'error_wireless_usage_live_chat_params.div',
          'button': 'error_wireless_usage_live_chat_params.button'
        } : null;
      }
    }

    function resetErrorMessage() {
      errorMessageKey = '';
      wdController.errorMessage = '';
      wdController.wirelessUsageLiveChatParams = null;
    }

    function resetCarouselSettings() {
      wdController.carouselSettings = {
        noWrapSlides: false,
        slides: []
      }
    }

    function formatDisplayData(displayData) {
      var base = dataManagerService.getConfig().basic.dataConversion;
      var displayDataConverted = $filter('ute_common_filter_data_conversion')(displayData, 'mb', base, 0, true, true);
      var displayDataSecondaryBase = (displayData > base ? 2 : 0);
      var displayDataSecondaryConverted = $filter('ute_common_filter_data_conversion')(displayData, 'mb', base, displayDataSecondaryBase, false, false);
      return displayDataSecondaryConverted + ' ' + displayDataConverted;
    }

    function getFDMUsageDetails() {

      var displayData = 0;
      var othersUsage = 0;
      var FDMUsageDetails = dataManagerService.getModel();
      var totalIncluded = dataManagerService.getDataLimit() + dataManagerService.getAddedExtraData();
      var selectedCtn = _.find(FDMUsageDetails.dataControlList, {
        'ctn': wdController.ctn
      });

      if (dataManagerService.isBucketSizeUnavailableUntilNextBillCycle()) {
        displayData = Math.round(dataManagerService.getDataLimit() * 100) / 100;
      } else {
        displayData = Math.round((dataManagerService.getOverage() > 0 ? dataManagerService.getRemainingTotalData() * -1 : dataManagerService.getRemainingTotalData()) * 100) / 100;
      }

      _.forEach(FDMUsageDetails.dataControlList, function (item) {
        if (item.ctn !== wdController.ctn) {
          othersUsage += item.dataUsed;
        }
      });

      wdController.fdmTotalIncluded = formatDisplayData(totalIncluded);
      wdController.fdmRemaining = dataManagerService.getOverage() ? formatDisplayData(0) : formatDisplayData(displayData);
      wdController.fdmMyUsage = formatDisplayData(selectedCtn.dataUsed);
      wdController.fdmOthersUsage = formatDisplayData(othersUsage);
      wdController.isBucketSizeUnavailableUntilNextBillCycle = dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
      wdController.getTotalUsedData = formatDisplayData(dataManagerService.getTotalUsedData());
    }

    function init() {
      wdController.flags = {};
      wdController.hideDialsSection = false;
      wdController.isOpenDetails = false;
      wdController.wirelessDashActive = null;
      wdController.dial_template = $window.innerWidth <= 768 ?
        'scripts/modules/wirelessDashboard/partials/wirelessDashboard.mobile.html' :
        'scripts/modules/wirelessDashboard/partials/wirelessDashboard.desktop.html';
      resetCarouselSettings();
      if (appState.checkMaintenance('WIRELESS_ON_MAINTENANCE')) {
        $state.go('underMaintenance');
        return;
      }
      wdController.isCare = userService.isCare();
      wdController.isDealer = userService.isDealer();
      wdController.isRepView = userService.isRepView();

      var unregisterIsRepViewWatch;
      if (wdController.isDealer || wdController.isCare) {
        unregisterIsRepViewWatch = $rootScope.$watch('isRepView', function () {
          wdController.isRepView = userService.isRepView();
        });
      }

      wdController.ctn = (userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)).toString();

      var param;
      if (wdController.isCare) {
        param = {
          acctNbr: Number(userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER))
        };
      }
      accountOverviewService = accountOverviewFactory(param);
      accountOverviewService.getAccountOverview().then(function (accountOverview) {
        var account = accountOverview.getSelectedAccount();
        var summaryRequest = {
          accountNumber: account.accountNumber,
          accountTypeNumber: account.accountTypeNumber,
          language: $translate.use()
        };
        wdController.ban = account.accountNumber.toString();
        request = {
          applicationId: 'Rogers.com',
          ctn: wdController.ctn,
          ban: wdController.ban,
          language: languageSwitcher.getCurrentLanguage()
        };

        if (wdController.wirelessDashData.length === 0) {
          getAccountList();
        }

        accountOverviewSummaryWorker = accountOverviewSummaryFactory(summaryRequest);
        accountOverviewSummaryWorker.registerOnDataChangeHandler(updateModel, 'myrWirelessDashboardController');
      });

      wdController.isSafari = util.isSafari;
      wdController.isChromeIOS = util.isChromeIOS;
      wdController.getChromeVersion = util.getChromeVersion;

      wdController.wirelessUsageLiveChatParams = null;
      wdController.isShareEverything = getCurrentState().indexOf('shareEverything') > -1;

      if (wdController.isShareEverything) {
        getFDMUsageDetails();
      }

      // Look into  non_angular_script/supportFunctions.js  for more information
      if (!wdController.isShareEverything) {
        scrollPageToTop();
      }
      wdController.liveChatSettings = liveChatSettings;
      wdController.formToRogersTemplate = settings.formToRogersTemplate;
      wdController.ab = myrAccountBalanceDataFactory;
      wdController.talkTextInfoModal.nextCycle = myrAccountBalanceDataFactory;

      wdController.pathToTalkSectionUrl = 'scripts/modules/wirelessDashboard/wirelessDashboardTalkSection.html';
      wdController.pathToTextSectionUrl = 'scripts/modules/wirelessDashboard/wirelessDashboardTextSection.html';
      wdController.pathToSMSSectionUrl = 'scripts/modules/wirelessDashboard/wirelessDashboardSMSSection.html';
      wdController.pathToDataSectionUrl = 'scripts/modules/wirelessDashboard/wirelessDashboardDataSection.html';

      colDataWrapElements = $('.colDataWrap'); // need to be initialized before calling pageVariablesInit

      pageVariablesInit(true); // THIS HAS TO RUN AT THE BEGINNING!!! default state of all that happens in this page

      var scopewatch1 = $scope.$watch('wdController.wirelessDashActive', function (newValue, oldValue) {
        if (newValue !== oldValue || (newValue === oldValue && !$rootScope.wirelessPackagePostPaidProcessed)) {
          if (newValue && newValue.ctn) {
            wdController.ctn = request.ctn = wdController.wirelessDashActive.ctn;
            request.refresh = false;
            $scope.$broadcast('ctnHasBeenChanged', {
              ctn: newValue.ctn
            });
          }
        }
      });

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        wdController.lng = lang;
        wdController.showRoamingComingSoonUrl = $translate.instant('wireless_roaming_details_coming_soon_chat_with_us_url');
        wdController.textsLbl = $translate.instant('wireless_texts');
        wdController.talkTextInfoModal.textsLbl = $translate.instant('wireless_texts');

        wdController.alertData = {
          copy: {
            ariaLabel: 'aria',
            icon: 'check',
            body: $translate.instant('ute.dataManager.infiniteAlert.body'),
            closeLabel: $translate.instant('ute.dataManager.infiniteAlert.closeLabel'),
          }
        };

        var stateName = userService.getPersistentService().get('toStateName');
        if (stateName === 'wireless') {
          // Re-load the data
          pageVariablesInit(false);
          getAccountList();
        }
        getWirelessDashBoard(wdController.wirelessDashActive);
      }, 'wirelessDashboardControllerLangSub_' + $scope.$id);

      $scope.$on('ute-dataManager-update-wirelessDashboard', function (event, data) {
        var searchIndex = _.findIndex(wdController.wirelessDashData, {
          ctn: data
        });
        wdController.wirelessDashActive = wdController.wirelessDashData[searchIndex];
        changeAccount();
      });

      accelemtTimer = $timeout(function () {
        var accelemt = angular.element('accordion .panel-heading');
        $(accelemt).find('h4').replaceWith(function () {
          return $('<h3 class=\'panel-title\'>').append($(this).contents());
        });
      }, 7000);

      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER)
        .then(function (isPermitted) {
          dataManagerService.setBRT(isPermitted); //prevent displaying shareEverything lines in wirelessDash if cx refresh browser
        });

      $scope.$on('$destroy', function () {
        $timeout.cancel(displayWirelessDashBoardTimer);
        $timeout.cancel(accelemtTimer);
        if (typeof unregisterIsRepViewWatch === 'function') {
          unregisterIsRepViewWatch();
        }
        languageSwitcher.unregisterOnDataChangeHandler('wirelessDashboardControllerLangSub_' + $scope.$id);
        if (accountOverviewSummaryWorker) {
          accountOverviewSummaryWorker.unregisterOnDataChangeHandler('myrWirelessDashboardController');
        }
        wirelessDashboardService.clearWirelessPostpaidCache();

        scopewatch1(); //n
        watchTalkAndTextFDM();
      });
      $window.onresize = function (e) {
        wdController.dial_template = e.target.innerWidth <= 768 ?
          'scripts/modules/wirelessDashboard/partials/wirelessDashboard.mobile.html' :
          'scripts/modules/wirelessDashboard/partials/wirelessDashboard.desktop.html';
        $scope.$applyAsync();
      }
    }

    init();
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('myrWirelessDashboardService', wirelessDashboardService);

  wirelessDashboardService.$inject = ['ajax', '$translate', 'ute.blocks.language.switcher', '$q'];

  /* @ngInject */
  function wirelessDashboardService(ajax, $translate, languageSwitcher, $q) {

    // Private data
    var _dashboardDataRaw = null;
    var _dashboardData = null;
    var _wirelessPostpaidCache = {};

    // Post-paid
    var _dashboardPostpaidData = null;

    // Pre-paid
    var _dashboardPrepaidData = null;

    // Travel Package data
    var _dashboardTravelPackageData = null;

    /**
     * This is a flag to check if wireless dashboard
     * needs to open the reset voicemail modal or not
     */
    var _openResetVoicemailModal = false;

    var limitLow = 100;			// 75
    var limitHigh = 10000;		// 100
    //MCPPC
    var isMCPPCrerating = false;
    var errorMessageFraudAccess;
    var wirelessDashData = null;
    var isPostPaidDetailsDataReady = false;
    var wirelessDashboardTalkAndTextFDM = false;

    // Check for objects
    function wirelessServiceObjectPush(master, tmpObj, groupType) {
      var myCount = 0;

      if (typeof tmpObj === 'object') {
        // Look through the data and pluck specific data from usageSummary array.
        if (tmpObj.usageSummary.length > 0) {
          for (var u = (tmpObj.usageSummary.length - 1); u >= 0; u--) {
            if (typeof tmpObj.usageSummary[u] === 'object') {
              // this usage set IS and EXTRA and there is no usage meaning that user has ZERO use
              if (tmpObj.usageSummary[u].total === 0 && tmpObj.usageSummary[u].othersUsage === 0 && tmpObj.usageSummary[u].subscriberUsage === 0 && tmpObj.usageSummary[u].used === 0) {
                // extra  ->  total = 0, othersUsage = 0, subscriberUsage = 0, used = 0
                tmpObj.usageSummary.splice(u, 1);
              }
            }
          }

          // Push usages into next set that assesses the data and further decorates them.
          tmpObj = wirelessServiceAddData(tmpObj, groupType);
          master.push(tmpObj);
        }

        // handle - status code 127 (now 10013) exception - MCPPC
        if (parseInt(tmpObj.statusCode) === 10013) {
          myCount = -1000;
          isMCPPCrerating = true;
        } else if (parseInt(tmpObj.statusCode) === 10012) {
          myCount = -1000;
        } else {
          myCount = tmpObj.usageSummary.length;		// pass this back for proper plan counter
        }
      }

      return myCount;
    }

    // Process and andd some data into the object
    function wirelessServiceAddData(tmpObj, groupType) {
      var locSet = tmpObj.usageSummary,
       highestPercentage = 0,
       highestColor = '',
       displayTotal = 0,
       displayUsed = 0,
       displayRemain = 0,
       onlyExtras = true,
       haveExtras = false,
       overExtras = false,
       collect = true,
       collectType = '',
       collectIndex = -1;

      _.forEach(locSet, function (subSet, i) {
        if (typeof subSet === 'object') {

          // unlimited / pay-per-use / limited Definitions
          var locTotal = parseFloat(subSet.total);
          var locUNLflag = subSet.isUsageUnlimited;

          // Tag all sets with parent data sumary type
          subSet.usageSummaryType = tmpObj.usageSummaryType;

          if (locTotal < 0 || (locTotal > 90000 && groupType !== 'data') || (locTotal > 90000000000 && groupType === 'data') || locUNLflag) {
            //		unlimited -> subSet.total < 0
            subSet.usageType = 'unlimited';
            subSet.total = 0;
            subSet.percentage = 0;
            subSet.overExtra = false;
            subSet.usageColor = 'usageNormal';

            // no plan but extras only
            onlyExtras = false;

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal === 0) {
            //		pay-per-use -> subSet.total = 0
            subSet.usageType = 'pay-per-use';
            subSet.total = 0;
            subSet.percentage = 100;
            subSet.overExtra = false;
            subSet.usageColor = 'usageWarning';				// 'usageOver'

            // Show dial/meter flag
            haveExtras = true;

            // Collect data for dial/meter
            if (collectType === '') {
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else if (locTotal > 0) {
            //			limited -> subSet.total > 0
            subSet.usageType = 'limited';

            // no plan but extras only
            onlyExtras = false;

            // Calculate percentages and if usage is
            if (groupType === 'data') {
              if (subSet.remaining != 0 || (subSet.remaining == 0 && subSet.overage == 0)) {
                var percentageTemp = 100 - ((parseFloat(subSet.remaining) / parseFloat(subSet.total)) * 100);
                subSet.percentage = Math.ceil(percentageTemp);
              }
              if (subSet.remaining == 0 && subSet.overage != 0) {
                subSet.percentage = 101;
              }
            } else {
              var percentageTemp = (parseFloat(subSet.used) / parseFloat(subSet.total)) * 100;
              subSet.percentage = Math.ceil(percentageTemp);
            }

            // Color definition
            if (subSet.percentage <= limitLow) {
              subSet.overExtra = false;
              subSet.usageColor = 'usageNormal';
            } else if ((subSet.percentage > limitLow && subSet.percentage <= limitHigh) || (subSet.percentage > limitLow)) {
//  limits were pushed from 75/100 to 100/1000 and this logic was simply not working properly.
//									subSet.overExtra = false;
//									subSet.usageColor = 'usageWarning';
//								} else if (subSet.percentage > limitLow) {
//									// subSet.usageColor = 'usageOver';
              subSet.overExtra = true;
              overExtras = true;
              subSet.usageColor = 'usageWarning';
              subSet.percentage = 100;
            }

            // Collect data for dial/meter
            if ((collectType === '' || collectType === 'pay-per-use') && collect) {
              collect = false;
              collectType = subSet.usageType;
              collectIndex = i;
            }

          } else {
            // This should not happen!!! EVER!!!
            throw new Error('wireless.wirelessServiceAddData - Critical fail!!');
          }

          if (parseFloat(subSet.remaining) <= 0) {
            subSet.remaining = 0;
          }

          // Push it back
          locSet[i] = subSet;
        }
      });

      // Logic overide from colective decision on plan structure to pick the first one and use that as dial / tongue
      // collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list

      // data set has ONLY extras or it is mix of Extras and plans
      if (onlyExtras) {
        // Display orange tongue with extras sign
        displayTotal = 0;
        displayUsed = 0;
        displayRemain = 0;
        highestColor = 'usageWarning';
        highestPercentage = 0;

        collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list
      } else {
        // Decide what color and numbers go to the dial at the top
        if (collectIndex >= 0) {
          // limited or pay-per-use
          displayTotal = locSet[collectIndex].total;
          displayUsed = locSet[collectIndex].used;
          displayRemain = locSet[collectIndex].remaining;
          highestColor = locSet[collectIndex].usageColor;
          highestPercentage = locSet[collectIndex].percentage;

        } else {
          // unlimited
          displayTotal = 0;
          displayUsed = 0;
          displayRemain = 0;
          highestColor = 'usageNormal';
          highestPercentage = 0;

          collectIndex = 0;		// pick the first item on the list to match dial/tongue with first item on the list
        }
      }

      // Safety measure to make sure that collectIndex is never negative after this point.
      // Since unable to verify this issue on multiple servers this needs to be tested very carefuly
      if (collectIndex < 0) {
        collectIndex = 0;
      }

      // Hand-off to level up object
      tmpObj.displayTotal = displayTotal;
      tmpObj.displayUsed = displayUsed;
      tmpObj.displayRemain = displayRemain;
      tmpObj.highestPercentage = highestPercentage;
      tmpObj.highestColor = highestColor;
      tmpObj.usageSummary = locSet;

      tmpObj.onlyExtras = onlyExtras;
      tmpObj.haveExtras = haveExtras;
      tmpObj.overExtras = overExtras;

      // Default display type ( normal = round dial at the top / unlimited = no dial, only name and open link )
      tmpObj.unlimitedShow = false;
      tmpObj.unlimitedClass = 'normal';

      // Only if all plans within are unlimited -> switch display type to unlimited
      if (groupType === 'roaming' || onlyExtras) {
        tmpObj.unlimitedShow = true;
        tmpObj.unlimitedClass = 'unlimited';

      } else {
        if (locSet[collectIndex].usageType === 'unlimited') {
          tmpObj.unlimitedShow = true;
          tmpObj.unlimitedClass = 'unlimited';
        }
      }

      return tmpObj;
    }

    // Add more data into the large data objects - Total usage, color codes, calculate leftovers
    function wirelessServiceGlobalDataSets(masterSet, groupType) {
      var globalDisplayTotal = 0;
      var globalDisplayUsed = 0;
      var globalDisplayRemain = 0;
      var globalDisplayOverage = 0;
      var globalPercentage = 0;
      var globalColor = '';

      var globalOnlyExtras = true;
      var globalHaveExtras = false;
      var globalOverExtras = false;

      var globalUnlimitedShow = false;
      var globalUnlimitedClass = 'normal';
//					var globalNotice = '';

      var returnValue = false;
      if (masterSet.length > 0) {
        // Display yes
        returnValue = true;
      } else {
        // Display no
        returnValue = false;
      }

      // Process data
      if (returnValue) {
        // Look through all sets and collect flags that span across entire set
        var sumHaveExtras = false;
        var sumOnlyExtras = true;
        var sumOverExtras = false;

        _.forEach(masterSet, function(subSet) {
          if (subSet.haveExtras) {
            sumHaveExtras = true;
          }
          if (!subSet.onlyExtras) {
            sumOnlyExtras = false;
          }
          if (subSet.overExtras) {
            sumOverExtras = true;
          }
        });

        // Decide which to select - pick the first set of data - as it is assumed that it has the highest priority
        var largeSet = null;
        if (sumOnlyExtras === true) {
          // Pick the first one
          largeSet = masterSet[0];
        } else {
          if (sumHaveExtras === true) {
            // Find first index that is not pay-per-use
            var outIndex = 0;

            _.forEach(masterSet, function (tempSet, index) {
              if (tempSet.onlyExtras === false) {
                outIndex = index;
              }
            });

            largeSet = masterSet[outIndex];
          } else {
            // no extras -> pick the first one
            largeSet = masterSet[0];
          }
        }

        // Show the extras badge if there one or more plans has over-usage
        if (sumOverExtras === true) {
          // do something with this information
          sumHaveExtras = true;			// should user have over usage - it will show as extra badge
        }

        if (typeof largeSet === 'object') {

          // This would be a great place to add more logic if required
          globalDisplayTotal = largeSet.displayTotal;
          globalDisplayUsed = largeSet.displayUsed;
          globalDisplayRemain = largeSet.usageSummary[0].remaining;
          globalDisplayOverage = largeSet.usageSummary[0].overage;
          globalPercentage = largeSet.highestPercentage;
          globalColor = largeSet.highestColor;

          globalOnlyExtras = sumOnlyExtras;
          globalHaveExtras = sumHaveExtras;
          globalOverExtras = sumOverExtras;

          globalUnlimitedShow = largeSet.unlimitedShow;
          globalUnlimitedClass = largeSet.unlimitedClass;

          // Color definition
//							if (globalPercentage < limitLow) {
//								globalNotice = 'Looking good';
//							} else if (globalPercentage >= limitLow && globalPercentage < limitHigh) {
//								globalNotice = 'Check it out';
//							} else if (globalPercentage >= limitHigh) {
//								globalNotice = 'Extra Usage';
//							}
        }

        // Add data to master set
        masterSet.globalDisplayTotal = globalDisplayTotal;
        masterSet.globalDisplayUsed = globalDisplayUsed;
        masterSet.globalDisplayRemain = globalDisplayRemain;
        masterSet.globalDisplayOverage = globalDisplayOverage;
        masterSet.globalPercentage = globalPercentage;
        masterSet.globalColor = globalColor;

        masterSet.globalOnlyExtras = globalOnlyExtras;
        masterSet.globalHaveExtras = globalHaveExtras;
        masterSet.globalOverExtras = globalOverExtras;

        masterSet.unlimitedShow = globalUnlimitedShow;
        masterSet.unlimitedClass = globalUnlimitedClass;
//						masterSet.globalNotice = globalNotice;
      }

      return returnValue;
    }

    function wirelessServiceSeparateUsage(masterSet, groupType, countChk) {
      var newMasterSet = {};
      newMasterSet.plans = [];
      newMasterSet.sumary = {};
      newMasterSet.extras = [];
      var newMasterArray = [];

      // split data by type plan (regular/unlimited) and extras
      _.forEach(masterSet, function(tmpObj) {
        _.forEach(tmpObj.usageSummary, function(tmpItem){
          if (typeof tmpItem === 'object') {
            if (tmpItem.usageType === 'pay-per-use') {
              newMasterSet.extras.push(tmpItem);
            } else {
              newMasterSet.plans.push(tmpItem);
            }
          }
        });
      });

      // collect all extras headlines and total values
      if (newMasterSet.extras.length > 0) {
        newMasterSet.sumary.usageType = 'extras_summary';
        newMasterSet.sumary.usageSets = [];

        _.forEach(newMasterSet.extras, function(tmpArr) {
          // header replace "/" with " / " for better breaking purposes
          var sourceHead = tmpArr.periodGroup;
          var cleanHeadline = sourceHead.replace('/', ' / ');

          var stuffObj = {};
          stuffObj.othersUsage = tmpArr.othersUsage;
          stuffObj.overage = tmpArr.overage;
          stuffObj.periodGroup = cleanHeadline;
          stuffObj.remaining = tmpArr.remaining;
          stuffObj.subscriberUsage = tmpArr.subscriberUsage;
          stuffObj.total = tmpArr.total;
          stuffObj.used = tmpArr.used;
          stuffObj.usageSummaryType = tmpArr.usageSummaryType;

          newMasterSet.sumary.usageSets.push(stuffObj);
        });
      }

      // re-assable the data into new array in this order - Plans > extras summary > extras
      if (newMasterSet.plans.length > 0) {
        _.forEach(newMasterSet.plans, function(aaArr){
          newMasterArray.push(aaArr);
        });
      }
      if (newMasterSet.extras.length > 0) {
        // sumary
        newMasterArray.push(newMasterSet.sumary);

        // extras
        _.forEach(newMasterSet.extras, function(ccArr){
          if (groupType === 'roaming') {
            // roamig data are always cinsidered an extras
            newMasterArray.push(ccArr);
          }
        });
        // roaming data also need to be separated into type buckets - data voice text
      }
      return newMasterArray;
    }

    return {
      postpaidDetails: null,
      // Usage data handling
      getWirelessDashBoard: function (request, callback) {
        request.language = languageSwitcher.getCurrentLanguage().toUpperCase();

        // ALWAYS load fresh JSON
        var _return = {};
        _dashboardDataRaw = null;

        ajax.wirelessDashBoard(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _dashboardDataRaw = data;

                // preset defaults
                _dashboardData = {};
                _dashboardData.data = [];
                _dashboardData.dataArr = [];
                _dashboardData.roaming = [];
                _dashboardData.roamingArr = [];
                _dashboardData.sms = [];
                _dashboardData.smsArr = [];
                _dashboardData.talk = [];
                _dashboardData.talkArr = [];

                var dataCounter = {};
                dataCounter.data = 0;
                dataCounter.roaming = 0;
                dataCounter.sms = 0;
                dataCounter.talk = 0;

                // Filter out objects that have no usage information
                var setCounter = 0;

                if (_dashboardDataRaw.data) {
                  // Data
                  _.forEach(_dashboardDataRaw.data, function(tmpObj){
                    var dadat = wirelessServiceObjectPush(_dashboardData.data, tmpObj, 'data');
                    dataCounter.data += dadat;
                    setCounter += dadat;
                  });

                  if (dataCounter.data > 0) {
                    _dashboardData.dataArr = wirelessServiceSeparateUsage(_dashboardData.data, 'data', dataCounter.data);
                  }
                }

                if (_dashboardDataRaw.roaming) {
                  // Roamiong
                  _.forEach(_dashboardDataRaw.roaming, function(tmpObj){
                    var darom = wirelessServiceObjectPush(_dashboardData.roaming, tmpObj, 'roaming');
                    dataCounter.roaming += darom;
                    setCounter += darom;
                  });

                  if (dataCounter.roaming > 0) {
                    _dashboardData.roamingArr = wirelessServiceSeparateUsage(_dashboardData.roaming, 'roaming', dataCounter.roaming);
                  }
                }

                if (_dashboardDataRaw.sms) {
                  // SMS
                  _.forEach(_dashboardDataRaw.sms, function(tmpObj){
                    var dasms = wirelessServiceObjectPush(_dashboardData.sms, tmpObj, 'sms');
                    dataCounter.sms += dasms;
                    setCounter += dasms;
                  });

                  if (dataCounter.sms > 0) {
                    _dashboardData.smsArr = wirelessServiceSeparateUsage(_dashboardData.sms, 'sms', dataCounter.sms);
                  }
                }

                if (_dashboardDataRaw.talk) {
                  // Talk
                  _.forEach(_dashboardDataRaw.talk, function(tmpObj){
                    var datal = wirelessServiceObjectPush(_dashboardData.talk, tmpObj, 'talk');
                    dataCounter.talk += datal;
                    setCounter += datal;
                  });

                  if (dataCounter.talk > 0) {
                    _dashboardData.talkArr = wirelessServiceSeparateUsage(_dashboardData.talk, 'talk', dataCounter.talk);
                  }
                }

                if (setCounter < 0 && isMCPPCrerating) {
                  // statusCode: "127" exeption - MCPPC
                  _return.MCPPCrerating = true;
                  _return.midCycle = false;
                  _return.empty = false;
                }
                else if (setCounter < 0) {
                  // statusCode: "103" exeption
                  _return.MCPPCrerating = false;
                  _return.midCycle = true;
                  _return.empty = false;

                } else if (setCounter === 0) {
                  _return.MCPPCrerating = false;
                  _return.midCycle = false;
                  _return.empty = true;
                } else {
                  _return.MCPPCrerating = false;
                  _return.midCycle = false;
                  _return.empty = false;
                }
// To be removed soon
// TOT-2631 HACK BEGIN
                _.forEach(data.talk, function (item) {
                  if (item.statusCode && item.statusCode === '10012') {
                    _return.MCPPCrerating = false;
                    _return.midCycle = true;
                    _return.empty = false;
                  }
                });
// TOT-2631 HACK END
// To be removed soon
                _return.result = 'success';
                _return.data = _dashboardData;
                return callback(_return);

              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardData = null;
                _return.result = 'fail';
                _return.data = data;
                _return.empty = true;
                _return.midCycle = false;
                _return.MCPPCrerating = false;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      isInfinitePlan: function() {
        return JSON.parse(window.sessionStorage.getItem('isInfinitePlan'));
      },
      clearWirelessDashBoard: function () {
        // Purge any data
        _dashboardData = null;
        return true;
      },
      clearWirelessPostpaidCache: function() {
        _wirelessPostpaidCache = {};
      },
      globalDataSets: function (masterSet, groupType) {
        return wirelessServiceGlobalDataSets(masterSet, groupType);
      },
      getWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackage(request).then(
            function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                //_dashboardTravelPackageData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            }, function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
                return callback(_return);

              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
                return callback(_return);
              }
            }
        );
      },
      getWirelessTravelPackageStaticContent: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageStaticContent(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardTravelPackageData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      getWirelessTravelPackageAddOnSummary: function (request, callback) {
        var _return = {};
        ajax.wirelessTravelPackageAddOnSummary(request)
          .then(function (data) {
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.result = 'success';
                _return.data = data;
                return callback(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                // _dashboardTravelPackageAddOnSummaryData = null;
                _return.result = 'fail';
                _return.data = data;
                return callback(_return);
              }
            })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      setWirelessTravelPackage: function (request, callback) {
        var _return = {};
        ajax.setwirelessTravelPackage(request)
          .then(function (data) {
            // check for error messages from server / Auth exipre / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              // _dashboardTravelPackageAddOnSummaryData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          })
          .catch(function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          });
      },
      getFraudSocMessage: function () {
        return errorMessageFraudAccess;
      },
      // Plugin / widget data handling

      // Postpaid data for widgets
      getWirelessPostpaid: function (request) {
        var _this = this,
          _cacheFailSafe = true,
          deferred = $q.defer();  //I need to use defer object, because wirelessPostpaidCall is being called recursively

        var wirelessPostpaidCall = function () {

          // ALWAYS load fresh JSON
          var _return = {};
          _this.postpaidData = null;
          _this.isPostPaidDetailsDataReady = false;

          /**
           * Using the new version api for postpaidDetails with new data structure
           */
          ajax.wirelessPostpaidV2(request)
            .then(function (rawData) {
              /**
               * Check response data and set it to data
               */
              var data;
              if (_.has(rawData, 'content.postPaidDetails.content')) {
                data = rawData.content.postPaidDetails.content;
              }
              // check for error messages from server / Auth exipre / other troubles that do return valid JSON
              if (data) {
                _return.stale = false;

                if (data.cachedResultInfo && data.cachedResultInfo.expired && _cacheFailSafe) {
                  request.refresh = true;
                  _cacheFailSafe = false;
                  _return.stale = true;
                  wirelessPostpaidCall();
                  return; // need to return, otherwise promise will be resolved without getting fresh data.
                }

                /**
                 * Populate Ovagerage Data and Canada wide to data
                 */
                if (_.has(rawData, 'content.wirelessPlanFeatures.content')) {
                  if (_.has(rawData.content.wirelessPlanFeatures.content, 'overAgeRate')) {
                    data.overAgeRate = rawData.content.wirelessPlanFeatures;
                  }
                  if (_.has(rawData.content.wirelessPlanFeatures.content, 'isCanadaWide')) {
                    data.isCanadaWide = rawData.content.wirelessPlanFeatures;
                  }
                }
                _return.result = 'success';
                _return.data = data;
                _this.postpaidData = _return;

                if (_this.postpaidData.data.postPaidPhoneDetails.hasFraudSoc) {
                  errorMessageFraudAccess = $translate.instant('fraud_display_message');
                } else if (_this.postpaidData.data.postPaidPhoneDetails.hasCreditOps) {
                  errorMessageFraudAccess = $translate.instant('credit_ops_display_message');
                } else {
                  errorMessageFraudAccess = undefined;
                }

                _this.isPostPaidDetailsDataReady = true;
                deferred.resolve(_return);
              } else {
                // Fail and display error message
                // {'errorCode':10402,'errorMessage':'failed to get account details'}
                _dashboardPostpaidData = null;
                _return.result = 'fail';
                _return.data = data;
                _this.postpaidData = _return;
                _this.isPostPaidDetailsDataReady = true;
                deferred.reject(_return);
              }
            })
            .catch(function (error) {
              // Error handling - 555 exception
              if (error.data.status === 555) {
                // Server error that needs further processing
                // additional information for 555 error

                // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                // error.error.errorMessage		// Message as delivered from server
                // error.error.message 			// Message as found in resource file
                // error.error.statusCode		// error status code - 555 in this case

                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
                _this.postpaidData = _return;
                deferred.reject(_return);
              } else {
                // anything but status code 555
                _return.result = 'error';
                _return.data = error;
                _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation

                _this.postpaidData = _return;
                deferred.reject(_return);
              }
            });
        };

        if(_wirelessPostpaidCache && _wirelessPostpaidCache.promise && _wirelessPostpaidCache.ctn === request.ctn) {
          return _wirelessPostpaidCache.promise;
        } else {
          wirelessPostpaidCall();

          _wirelessPostpaidCache = {
            promise: deferred.promise,
            ctn: request.ctn
          };

          return deferred.promise;
        }
      },

      setWirelessDashData: function (data) {
        wirelessDashData = data;
      },
      getWirelessDashData: function () {
        return wirelessDashData;
      },

      showResetVoicemailModal: function () {
        return _openResetVoicemailModal;
      },
      enableResetVoicemailModal: function () {
        _openResetVoicemailModal = true;
      },
      disableResetVoicemailModal: function () {
        _openResetVoicemailModal = false;
      },
      setWirelessDashboardTalkAndTextFDM: function (value) {
        wirelessDashboardTalkAndTextFDM = value;
      },
      getWirelessDashboardTalkAndTextFDM: function () {
        return wirelessDashboardTalkAndTextFDM;
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('prepaidCtnCountService', prepaidCtnCountService);

  prepaidCtnCountService.$inject = ['ajax', '$translate'];

  /* @ngInject */
  function prepaidCtnCountService(ajax, $translate) {
    return {
      // Postpaid data for widgets
      getprepaidCtnCount: function (request, callback) {
        // ALWAYS load fresh JSON
        var ctnCOunt = {};

        ajax.prepaidCtnCount(request).then(
          function (data) {
            // check for error messages from server / Auth expire / other troubles that do return valid JSON
            if (data) {
              ctnCOunt.result = 'success';
              console.log(data);
              ctnCOunt.data = data;
              return callback(ctnCOunt);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardPrepaidData = null;
              ctnCOunt.result = 'fail';
              ctnCOunt.data = data;
              return callback(ctnCOunt);
            }
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              ctnCOunt.result = 'error';
              ctnCOunt.data = error;
              ctnCOunt.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(ctnCOunt);

            } else {
              // anything but status code 555
              ctnCOunt.result = 'error';
              ctnCOunt.data = error;
              ctnCOunt.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(ctnCOunt);
            }
          }
        );
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessPrepaidController', WirelessPrepaidController);

  WirelessPrepaidController.$inject = ['appState', '$scope', '$translate', '$state'];

  /* @ngInject */
  function WirelessPrepaidController(appState, $scope, $translate, $state) {
    if (appState.checkMaintenance('WIRELESS_PREPAID_ON_MAINTENANCE')) {
      $state.go('underMaintenance');
    }
    appState.tagging(['_trackPageView',
          {pn: 'home:myrogers:payasyougo'}, // Page Name
          {eVar16: 'prepaid'} // Prepaid, Regular
        ]
    );
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrWirelessPrepaidModalController', WirelessPrepaidModalController);

  WirelessPrepaidModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function WirelessPrepaidModalController($scope, $modalInstance, $rootScope) {
    $scope.close = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('myrWirelessPrepaidService', wirelessPrepaidService);

  wirelessPrepaidService.$inject = ['ajax', '$translate'];

  /* @ngInject */
  function wirelessPrepaidService(ajax, $translate) {
    return {
      wirelessPrepaidData:{},
      // Postpaid data for widgets
      getWirelessPrepaid: function (request, callback) {
        // ALWAYS load fresh JSON
        var _return = {};

        var _this = this;

        ajax.wirelessPrepaid(request).then(
          function (data) {
            // check for error messages from server / Auth expire / other troubles that do return valid JSON
            if (data) {
              _return.result = 'success';
              console.log(data);
              _this.wirelessPrepaidData = data;
              _return.data = data;
              return callback(_return);
            } else {
              // Fail and display error message
              // {'errorCode':10402,'errorMessage':'failed to get account details'}
              //_dashboardPrepaidData = null;
              _return.result = 'fail';
              _return.data = data;
              return callback(_return);
            }
          }, function (error) {
            // Error handling - 555 exception
            if (error.data.status === 555) {
              // Server error that needs further processing
              // additional information for 555 error

              // error.error.errorCode		// 10k - 12.1k & 50k - 51k
              // error.error.errorMessage		// Message as delivered from server
              // error.error.message 			// Message as found in resource file
              // error.error.statusCode		// error status code - 555 in this case

              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant(error.error.errorCode);		// Pull message from resource file
              return callback(_return);

            } else {
              // anything but status code 555
              _return.result = 'error';
              _return.data = error;
              _return.message = $translate.instant('error_wireless_usage');		// Pull message from resource file 401 or 5xx situlation
              return callback(_return);
            }
          }
        );
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('backToSSPService', backToSSPService);

  backToSSPService.$inject = ['$rootScope', '$browser', 'ajax', 'settings', 'localStorage', 'sessionStorage'];

  /* @ngInject */
  function backToSSPService($rootScope, $browser, ajax, settings, localStorage, sessionStorage) {

    return {
      backToSSP: function () {
        console.log('back to ssp service method');
        var cookies = $browser.cookies();
        var language = cookies.language;
        var province = cookies.province;
        var phoneNumber = localStorage.getLocalStorageValue('phoneNumber');
        var accountNum = localStorage.getLocalStorageValue('accountNumber');
        var toStateName = localStorage.getLocalStorageValue('toStateName');
        if ($rootScope.isCare) {
          phoneNumber = sessionStorage.getSessionStorageValue('phoneNumber');
          accountNum = sessionStorage.getSessionStorageValue('accountNumber');
        }
        var postData = {
          ctn: phoneNumber,
          accountNumber: accountNum,
          lang: language,
          prov: province,
          targetFlow: $rootScope.targetFlow
        };
        if (toStateName != 'wireless') {
          postData.ctn = '';
        }
        ajax.backToSSP(postData).then(
            function (data) {
              if (data.isCableOnly) {
                console.log('back to ssp ajax success is cable');
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                $('#formToSSP').submit();
              } else {
                console.log('back to ssp ajax success not cable');
                $('#formToSSP').find('#sharedKey').val(data.sharedKey);
                $('#formToSSP').find('#signature').val(data.signature);
                $('#formToSSP').find('#content').val(data.content);
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.sspDashboardURL);
                $('#formToSSP').submit();
              }
            },
            function (error) {
              console.log('back to ssp ajax error', error);
              $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
              $('#formToSSP').submit();
            }
        );
      }
    };

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').service('sspDeepLink', sspDeepLink);

  sspDeepLink.$inject = ['$translate',
    'settings',
    '$window',
    '$location'];

  /* @ngInject */
  function sspDeepLink($translate,
                       settings,
                       $window,
                       $location) {
    var service = {
      backFromSSPMsg: backFromSSPMsg,
      messageType: messageType
    };
    return service;

    function backFromSSPMsg() {
      var backFromSSPMessage = '';
      var queryString = $window.location.href.split('?');
      // Query string is now implemented for dealer and care
      // -----/web/totes/#/oneViewDashboard?lang=en&userType=dealer&prov=ON&transType=Change CTN&transStatus=SUCCESS
      if (queryString.length > 1 && $location.search().transType && $location.search().transStatus) {
        var successFlag = $location.search().transStatus === settings.deepLinkStatusCodes.transStatusSuccess,
            errorFlag = $location.search().transStatus === settings.deepLinkStatusCodes.transStatusError;
        if ($location.search().transType === settings.deepLinkStatusCodes.changeCTN) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('change_phone_number_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('change_phone_number_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.changeSIM) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('change_sim_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('change_sim_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.changePricePlan) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('change_plan_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('change_plan_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.manageAddon) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('manage_addon_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('manage_addon_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.updateVoiceMailPassword) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('reset_voicemail_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('reset_voicemail_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.upgradeDevice) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('device_upgrade_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('device_upgrade_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.addaLineShared) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('add_a_line_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('add_a_line_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.addaLineIndividual) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('add_a_line_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('add_a_line_error_message');
          }
        } else if ($location.search().transType === settings.deepLinkStatusCodes.hupCancellation) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant('hup_cancellation_success_message');
          } else if (errorFlag) {
            backFromSSPMessage = $translate.instant('hup_cancellation_error_message');
          }
        } else if($location.search().transType===settings.deepLinkStatusCodes.getWireless) {
          if (successFlag) {
            backFromSSPMessage = $translate.instant("get_wireless_success_message");
          } else if(errorFlag) {
            backFromSSPMessage = $translate.instant("get_wireless_error_message");
          }
        }
      }
      console.log('backFromSSPMessage' + backFromSSPMessage);
      return backFromSSPMessage;
    }

    function messageType() {
      var messageType = '';
      var queryString = $window.location.href.split('?');
      if (queryString.length > 1 && $location.search().transType && $location.search().transStatus) {
        var successFlag = $location.search().transStatus === settings.deepLinkStatusCodes.transStatusSuccess,
            errorFlag = $location.search().transStatus === settings.deepLinkStatusCodes.transStatusError;
        messageType = successFlag ? 'success' : 'error';
      }
      console.log('messageType' + messageType);
      return messageType;

    }
  }
})();

'use strict';

/**
 * @ngdoc service
 * @name webanalytics
 * @description
 * # webanalytics
 * Service in the totesApp.
 */
angular.module('selfServe')
    .service('omni', ['$window', '$log', 'appState', 'webanalytics', function ($window, $log, appState, webanalytics) {
      // AngularJS will instantiate a singleton by calling "new" on this function
      //tag objects of all modules.
      /*    var _pageTags={
       'signin': 'home:signin',
       'registration': 'home:registration:contact-information',
       'forgetPassword': 'home:signin',
       'forgetusername': 'home:signin',
       'invalidPath': 'home:signin',
       'permissionDenied': 'home:signin',
       'tpsc': 'home:signin'
       };*/

      return {
        tagging: function (options) {
          $window.addOmnp(options);
        },
        tagPage: function (pageName, options) {
          var _tagObj = [
            '_trackPageView',
            {pn: pageName}
          ];
          angular.forEach(options, function (value) {
            _tagObj.push(value);
          });
          return this.tagging(_tagObj);
        },

        tagLink: function (options) {
          var _tagObj = [
            '_trackLink'
          ];
          angular.forEach(options, function (value) {
            _tagObj.push(value);
          });
          this.tagging(_tagObj);
        },
        tagFormValidationErrors: function (pageName, errorObj) {

          if (!pageName || !errorObj) {
            return;
          }

          // Form is NOT valid, tag the errors
          var msg = '';
          var numRequiredErrors = (errorObj.required && errorObj.required.length) || 0;
          var numPatternErrors = (errorObj.pattern && errorObj.pattern.length) || 0;

          for (var i = 0; i < numRequiredErrors; i++) {

            try {
              msg = webanalytics.formatErrorMessage(pageName, errorObj.required[i].$name, 1, null);
              appState.tagging(['_trackLink',
                {eVar49: msg},
                {event15: ''}// Generic Error
              ]);
            } catch (e) {
              $log.error('Exception catch during tagging on msg with message:', e.message);
            }
          }

          for (var j = 0; j < numPatternErrors; j++) {

            try {
              msg = webanalytics.formatErrorMessage(pageName, errorObj.pattern[i].$name, 2, null);
              appState.tagging(['_trackLink',
                {eVar49: msg},
                {event15: ''}// Generic Error
              ]);
            } catch (e) {
              $log.error('Exception catch during tagging on msg with message:', e.message);
            }
          }
        },

        formatErrorMessage: function (page, controlName, errorType, errorMessage) {
          var message = '';

          if (errorType === 1) {
            message = controlName + ' is empty;';
          }

          if (errorType === 2) {
            message = controlName + ' pattern is invalid;';
          }

          if (errorType === 3) {
            message = controlName + ' is ' + errorMessage;
          }
          return 'Validation Error---' + 'Page: ' + page + ':' + message;
        },
        getPageTagObj: function (module) {
          var _pageName = 'home:signin';// the tagging page name of the

          return ['_trackPageView',
            {pn: _pageName}
          ];
        }
      };
    }]);

/* jshint -W106 */
(function (_, $) {
  'use strict';
  angular
    .module('selfServe')
    .factory('selfServeSvc', ['ajax',
      '$http',
      'settings',
      '$modal',
      '$q',
      '$translate',
      'omni',
      '$rootScope',
      'myrAccountListService',
      'ute.blocks.language.switcher',
      'ute.goPaperless.service',
      function (ajax,
                $http,
                settings,
                $modal,
                $q,
                $translate,
                omni,
                $rootScope,
                myrAccountListService,
                languageSwitcher,
                goPaperlessService) {
      var userProfile,
        accounts,
        currentAccount,
        marketingPermissions = {
          'mks': [
            {'MktgChannel': 'TEXT_MESSAGING', 'PlClassCD': 'WIRELESS', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'TEXT_MESSAGING', 'PlClassCD': 'CABLE', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'TEXT_MESSAGING', 'PlClassCD': 'INTERNET', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'TEXT_MESSAGING', 'PlClassCD': 'HOME_PHONE', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'DIRECT_MAIL', 'PlClassCD': 'WIRELESS', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'DIRECT_MAIL', 'PlClassCD': 'CABLE', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'DIRECT_MAIL', 'PlClassCD': 'INTERNET', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'DIRECT_MAIL', 'PlClassCD': 'HOME_PHONE', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'EMAIL', 'PlClassCD': 'HOME_PHONE', 'PermissionGrantedInd': 'YES'},
            {'MktgChannel': 'TELEMARKETING', 'PlClassCD': 'HOME_PHONE', 'PermissionGrantedInd': 'YES'}
          ]
        },
        provinces = [
          {label: 'Alberta', value: 'AB'},
          {label: 'Britsh Columbia', value: 'BC'},
          {label: 'Manitoba', value: 'MB'},
          {label: 'New Brunswick', value: 'NB'},
          {label: 'Newfoundland', value: 'NL'},
          {label: 'Nova Scotia', value: 'NS'},
          {label: 'Northwest Territories', value: 'NT'},
          {label: 'Nunavut', value: 'NU'},
          {label: 'Ontario', value: 'ON'},
          {label: 'Prince Edward Island', value: 'PE'},
          {label: 'Québec', value: 'QC'},
          {label: 'Saskatchewan', value: 'SK'},
          {label: 'Yukon Territory', value: 'YT'}
        ],
        updatedEmailAddress = '';
      var loginSecurityQuestions = [];

      function buildAddressLineForSubmit(updates) {
        var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
        var streetPortion = '';
        var address = '';

        if (validStreet) {
          return updates.Street_number + ' ' + updates.Street_name + ' ' + updates.Street_type;
        } else {
          return '';
        }
      }

      function buildAPTInfo(updates) {
        var validAptType = updates.AptType && updates.AptNo;
        if (validAptType) {
          return updates.AptType + ' ' + updates.AptNo;
        } else {
          return '';
        }
      }

      function buildPrimaryAddressLine(updates) {
        var streetInfo = buildAddressLineForSubmit(updates);
        var aptInfo = buildAPTInfo(updates);
        return streetInfo + ' ' + aptInfo;
      }

      function buildSecondaryAddressLine(updates) {
        var validSecondaryLine = updates.city && updates.postalCode && updates.province;
        if (validSecondaryLine) {
          return updates.city + ', ' + updates.postalCode + ', ' + updates.province;
        } else {
          return '';
        }
      }

      function buildAddressLineForUI(updates) {
        var addressAsEntered = '';
        var streetPortion = '';
        var apartmentPortion = '';
        var cityAndProvince = '';

        var countryToSave = 'CA';

        var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
        var validAptType = updates.AptType && updates.AptNo;
        var validCountry = updates.postalCode && updates.province && countryToSave;

        if (validStreet) {
          streetPortion = updates.Street_number + ' ' + updates.Street_name + ' ' + updates.Street_type + ' ';
        }

        if (validAptType) {
          apartmentPortion = updates.AptType + ' ' + updates.AptNo + ', ';
        }

        if (validCountry) {
          cityAndProvince = updates.city + ', ' + updates.postalCode + ', ' + updates.province + ', ' + countryToSave;
        }

        if (validStreet) {
          addressAsEntered = streetPortion;
          if (validAptType) {
            addressAsEntered += apartmentPortion;
          }
          if (validCountry) {
            addressAsEntered += cityAndProvince;
          }
        }

        return addressAsEntered;
      }

      function buildAddressLineFromVerifyAddress(address) {
        var primaryLine = '';
        var secondaryLine = '';

        var streetPortion = '';
        var apartmentPortion = '';
        var cityAndProvince = '';
        var countryToSave = address.country ? address.country : 'CA';

        var validStreet = address.streetName && address.streetNo;
        var validAptType = address.aptDesignator && address.aptNumber;
        var validCountry = address.city && address.postCode && address.province;

        if (validStreet) {
          streetPortion = address.streetNo + ' ' + address.streetName + ' ' + address.streetSuffix + ' ';
        }
        if (validAptType) {
          apartmentPortion = address.aptDesignator + ' ' + address.aptNumber + ', ';
        }
        if (validCountry) {
          cityAndProvince = address.city + ', ' + address.postCode + ', ' + address.province + ', ' + countryToSave;
        }
        if (validStreet) {
          primaryLine = streetPortion;
          if (validAptType) {
            primaryLine += apartmentPortion;
          }
        }

        if (validCountry) {
          secondaryLine += cityAndProvince;
        }
        address.primaryLine = primaryLine;
        address.secondaryLine = secondaryLine;
        address.country = countryToSave;
        return address;
      }

      function isLanguageChanged(language) {
        if (currentAccount.contactInformation) {
          return (currentAccount.contactInformation.language !== language);
        }
        return true;
      }

      function isContactAddressChanged(updates) {
        if (currentAccount.contactInformation) {
          return !angular.equals(updates, currentAccount.contactInformation);
        }
        return true;
      }

      function isEmailChanged(updates) {
        if (currentAccount.contactInformation) {
          return !angular.equals(updates.email, currentAccount.contactInformation.email);
        }
        return true;
      }

      function update(updates, type, onSuccess, onError) {
        var updateObj = {};
        var selectedAccount = currentAccount;

        updateObj.accountNumber = selectedAccount.accountNumber; // Added for multitab for CARE

        if (selectedAccount.consolidated === true && selectedAccount.accountNumber.length === '12') {
          if (selectedAccount.subNumbers) {
            updateObj.accountNumber = selectedAccount.subNumbers[0];
          }
        }

        // updating LANG implies contact information object is received
        if (type === 'lang' || type === 'contactlang') {
          updateObj.LanguageChanged = true;
          updateObj.contactLanguage = updates.language;
        }

        if (type === 'address') {
          updateObj.primaryLine = buildPrimaryAddressLine(updates);
          updateObj.secondaryLine = buildSecondaryAddressLine(updates);
          updateObj.province = updates.province;
          updateObj.city = updates.city;
          updateObj.postalCode = updates.postalCode;
          updateObj.country = 'Canada';
          updateObj.billingAddress = updates.billingAddress;
        }

        if (type === 'canadaPostAddress') {
          updateObj = updates;
          updateObj.accountNumber = selectedAccount.accountNumber;
        }

        if (type === 'contact' || type === 'contactlang') {
          updateObj.contactLanguage = updates.language;
//        updateObj.emailAddress = updates.email; //
          if (!updates.contactNumber2) {
            updateObj.businessPhone = '9999999999';
          } else {
            updateObj.businessPhone = updates.contactNumber2;
          }

          if (!updates.contactNumber1) {
            updateObj.homePhone = '9999999999';
          } else {
            updateObj.homePhone = updates.contactNumber1;
          }

          if (!updates.extension) {
            updateObj.ext = '00';
          } else {
            updateObj.ext = updates.extension; // verify this
          }

          updateObj.ContactChanged = true;
          updateObj.LanguageChanged = isLanguageChanged(updateObj.contactLanguage);
          updateObj.EmailChanged = isEmailChanged(updates);
        }

        if (type === 'contactInfo') {
          updateObj.contactLanguage = updates.language;
          updateObj.businessPhone = updates.contactNumber2 ? updates.contactNumber2 : '9999999999';
          updateObj.homePhone = updates.contactNumber1 ? updates.contactNumber1 : '9999999999';
          updateObj.ext = updates.extension ? updates.extension : '00';
        }

        if (type === 'email') {
          updateObj.emailAddress = updates.email;
        }

        if (type === 'address' && updates.billingType && updates.billingTypeModified) {
          var arrayPromise = [];
          var onErrorHandler = onError;

          if (updates.billingTypeModified) {
            var updateBillingTypePromise = ajax.updateBillingType({
              accountNumber: updateObj.update_accountNumber,
              billingType: updates.billingType
            }).then(function () {
              onSuccess();
            }, function (data) {
              onErrorHandler(data);
            });
          } else {
            var setAddress = ajax.setAddressContLang(updateObj).then(function (success) {
              var updateBillingTypePromise = ajax.updateBillingType({
                accountNumber: updateObj.update_accountNumber,
                billingType: updates.billingType
              }).then(function () {
                onSuccess();
              }, function (data) {
                onErrorHandler(data);
              });
            }, function (data) {
              onError(data);
            });
          }

          return;
        }

        if (type === 'email' || type === 'contactInfo') {
          return ajax.updateContactInfo(updateObj).then(
            function (result) {
              onSuccess();
            },
            function (data) {
              onError(data);
            });
        } else if (type === 'canadaPostAddress' || type === 'address') {
          return ajax.updateBillingAddressV2(updateObj).then(
            function (result) {
              onSuccess();
            },
            function (data) {
              onError(data);
            });
        } else {
          return ajax.setAddressContLang(updateObj).then(
            function (result) {
              onSuccess();
            },
            function (data) {
              onError(data);
            });
        }
      }

        function getSummary(account, handleSuccessResponse, handleFailureResponse, language) {
        var requestData = {
          accountNumber: account.accountNumber,
          accountTypeNumber: account.accountTypeNumber,
          phoneNumber: account.phoneNumber,
          pinNumber: account.pinNumber,
          //language: lang,
          applicationId: 'Rogers.com',
          refresh: false
        };

        if (account.prepaidAccountBalance) {
          // is prepaid account

          ajax.getAccountDetailPrepaid(requestData, true).then(function (data) {
            if (data.cachedResultInfo && data.cachedResultInfo.expired) {
              requestData.refresh = true;
              ajax.getAccountDetailPrepaid(requestData).then(function (data) {
                handleSuccessResponse(data);
              }, function (data) {
                handleFailureResponse(data);
              });
            }
            handleSuccessResponse(data);
          }, function (data) {
            handleFailureResponse(data);
          });

        } else {
          // is postpaid account
          requestData.language = language;
          ajax.getAccountDetail(requestData, true).then(function (data) {
            if (data.cachedResultInfo && data.cachedResultInfo.expired) {
              requestData.refresh = true;
              ajax.getAccountDetail(requestData).then(function (data) {
                handleSuccessResponse(data);
              }, function (data) {
                handleFailureResponse(data);
              });
            }
            handleSuccessResponse(data);
          }, function (data) {
            handleFailureResponse(data);
          });
        }

        /*
         */

      }

      return {
        getAccountByAccountNumber: function (accountNumber) {
          for (var i = 0; i < accounts.length; i++) {
            if (accounts[i].accountNumber === accountNumber) {
              return accounts[i];
            }
          }
        },
        removeAccountFromList: function (account) {
          // find account using identifier
          var identifier = account.identifier;

          for (var i = 0; i < accounts.length; i++) {
            if (accounts[i].identifier === identifier) {

              if (identifier === currentAccount.identifier) {
                currentAccount = accounts[0]; //
              }

              accounts.splice(i, 1);
              break;
            }
          }
        },
        disassociateAccount: function (obj, accountTypeNumber) {
          /**
           * Keep unlink account for prepaid user calling existing api
           * accountTypeNumber = 9 is for Prepaid account
           * otherwise switch to new Janrain api
           */
          if ( accountTypeNumber === 9 ) {
            return ajax.disassociateAccount(obj);
          } else {
            return ajax.disassociateAccountJanrain(obj);
          }
        },
        // transformtoUnfriendlyMarketingPermissions: function (obj) {
        //   obj = this.transformtoFriendlyMarketingPermissions().objArray;
        //
        //   var permObj,
        //     i = 0;
        //
        //   var objArray = [];
        //
        //   while ((permObj = obj[i])) {
        //     for (var permission in permObj.Permissions) {
        //       var k = {};
        //       k.MktgChannel = permObj.MarketingChannel;
        //       if (permission === 'wireless') {
        //         k.PlClassCD = 'WIRELESS';
        //         k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
        //       }
        //       if (permission === 'cable') {
        //         k.PlClassCD = 'CABLE';
        //         k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
        //       }
        //       if (permission === 'internet') {
        //         k.PlClassCD = 'INTERNET';
        //         k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
        //       }
        //       if (permission === 'homephone') {
        //         k.PlClassCD = 'HOME_PHONE';
        //         k.PermissionGrantedInd = permObj.Permissions[k] === true ? 'YES' : 'NO';
        //       }
        //       objArray.push(k);
        //     }
        //     i++;
        //   }
        //
        //   return {'mks': objArray};
        // },
        // transformtoFriendlyMarketingPermissions: function (marketingPermissionsServer) {
        //   var self = this;
        //   var channelPermissions = function () {
        //     this.MarketingChannel = '',
        //       this.Permissions = {
        //         wireless: false,
        //         cable: false,
        //         internet: false,
        //         homephone: false,
        //         homemonitoring: false
        //       };
        //
        //     this.setPermission = function (label, value) {
        //       if (label === 'WIRELESS') {
        //         if (value === 'YES') {
        //           this.Permissions.wireless = true;
        //         }
        //       }
        //
        //       if (label === 'INTERNET') {
        //         if (value === 'YES') {
        //           this.Permissions.internet = true;
        //         }
        //       }
        //
        //       if (label === 'CABLE') {
        //         if (value === 'YES') {
        //           this.Permissions.cable = true;
        //         }
        //       }
        //
        //       if (label === 'HOME_PHONE') {
        //         if (value === 'YES') {
        //           this.Permissions.homephone = true;
        //         }
        //       }
        //
        //       if (label === 'SMART_HOME_MONITORING') {
        //         if (value === 'YES') {
        //           this.Permissions.homemonitoring = true;
        //         }
        //       }
        //     };
        //
        //     this.toArray = function () {
        //       return {
        //         MarketingChannel: this.MarketingChannel,
        //         Permissions: {
        //           wireless: this.Permissions.wireless,
        //           cable: this.Permissions.cable,
        //           internet: this.Permissions.internet,
        //           homephone: this.Permissions.homephone,
        //           homemonitoring: this.Permissions.homemonitoring
        //         }
        //       };
        //     };
        //   };
        //
        //   var permissionsArray = [], i;
        //
        //   marketingPermissionsServer = marketingPermissions.mks;
        //
        //   for (i = 0; i < marketingPermissionsServer.length; i++) {
        //     var mkp = marketingPermissionsServer[i];
        //     var channel = mkp.MktgChannel, label, value;
        //
        //     // find the channel in existing array
        //     var obj = _.find(permissionsArray, {MarketingChannel: channel});
        //
        //     if (obj) {
        //       label = mkp.PlClassCD;
        //       value = mkp.PermissionGrantedInd;
        //       obj.setPermission(label, value);
        //     } else {
        //       var cp = new channelPermissions();
        //       label = mkp.PlClassCD;
        //       value = mkp.PermissionGrantedInd;
        //
        //       cp.MarketingChannel = mkp.MktgChannel;
        //       cp.setPermission(label, value);
        //       permissionsArray.push(cp);
        //     }
        //   }
        //
        //   var permissionsArrayObject = [];
        //   for (i = 0; i < permissionsArray.length; i++) {
        //     var o = permissionsArray[i];
        //     permissionsArrayObject.push(o.toArray());
        //   }
        //
        //   var literalObj = {};
        //   for (var j = 0; j < permissionsArrayObject.length; j++) {
        //     literalObj[permissionsArrayObject[j].MarketingChannel] = permissionsArrayObject[j];
        //   }
        //   return {
        //     literal: literalObj,
        //     objArray: permissionsArrayObject
        //   };
        // },
        // transformMarketingPermissions: function (serverResponse) {
        //   var productCategories = _.uniq(serverResponse.map(function (marketingPermission) {
        //     return marketingPermission.plClassType;
        //   }));
        //   var transformedPermissions = {};
        //   productCategories.forEach(function (productCategory) {
        //     transformedPermissions[productCategory] = {};
        //     var matchingChannels = serverResponse.filter(function (marketingPermission) {
        //       return marketingPermission.plClassType == productCategory;
        //     });
        //     matchingChannels.forEach(function (matchingChannel) {
        //       transformedPermissions[productCategory][matchingChannel.marketingChannel] = matchingChannel.permissionGranted;
        //     });
        //   });
        //   return transformedPermissions;
        // },
        generateUUID: function generateUUID() {
          var d = new Date().getTime();
          return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (d + Math.random() * 16) % 16 | 0;
            d = Math.floor(d / 16);
            return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
          });
        },
        getProvinces: function () {
          return provinces;
        },
        getBillingAddressForAccount: function (account) {
          for (var i = 0; i < accounts.length; i++) {
            if (account.identifier == accounts[i].identifier) {
              return accounts[i].billingAddress;
            }
          }
        },
        buildBillingAddress: function (obj) {
          // console.log('Inside selfServe.js buildBillingAddress');
          obj = obj.billingAddress;
          if (!obj) {
            return {noBillingAddress: true};
          }

          var billingAddress = {};
          billingAddress = obj;
          if (obj.billingType === 'INVOICE') {
            billingAddress.paper = true;
            // console.log('Inside selfServe.js buildBillingAddress :: billingAddress.paper = true');
          } else if (obj.billingType === 'eBill') {
            billingAddress.ebill = true;
            // console.log('Inside selfServe.js buildBillingAddress :: billingAddress.ebill = true');
          }
          billingAddress.billingType = obj.billingType;
          billingAddress.billing_city = obj.city;
          billingAddress.billing_postalCode = obj.postalCode;
          billingAddress.billing_province = obj.province;
          billingAddress.billing_streetAddress = '';
          billingAddress.Street_number = obj.Street_number || obj.streetNumber;
          billingAddress.Street_type = obj.Street_type || obj.streetType || '';
          if(billingAddress.Street_type.trim().toLowerCase() === 'please specify') {
            billingAddress.Street_type = '';
          }
          billingAddress.Street_name = obj.Street_name || obj.streetName;
          billingAddress.AptNo = obj.AptNo || obj.unit;
          billingAddress.AptType = obj.AptType || 'APT';

//          if (obj.AptNo) {
//            billingAddress.billing_streetAddress = '#' + obj.AptNo + ' ';
//          }
          // Since the middleware is not returning alpha numeric street number (if any), we need to concatenate suffix to the number for display & edit. -As per Aniruddha.
          if (obj.streetNameSuffix) {
            obj.Street_number += obj.streetNameSuffix; // jshint ignore:line
          }

          billingAddress.billing_streetAddress += obj.Street_number + ' '; // jshint ignore:line

          //billingAddress.billing_streetAddress += obj.Street_name + ' ' + obj.Street_type + ', ' + obj.city + ', ' + obj.province + ', ' + obj.postalCode;
          billingAddress.billing_streetAddress += obj.Street_name + ' ' + obj.Street_type;
          billingAddress.billing_streetAddress += obj.AptNo ? ' ' + obj.AptType + ' ' + obj.AptNo + ', ' : ', ';
          billingAddress.billing_streetAddress += obj.city + ', ' + obj.province + ', ' + obj.postalCode;
          billingAddress.provinces = provinces; // this should break part of the closure
          billingAddress.country = 'CA';
          billingAddress.selectedProvince = _.find(provinces, {value: billingAddress.billing_province});
          if (!billingAddress.selectedProvince && billingAddress.billing_province !== '') {
            billingAddress.country = 'US';
          }

          // for (var i = 0; i < billingAddress.provinces.length; i++) {
          //   var province = billingAddress.provinces[i];
          //   if (province.value === billingAddress.billing_province) {
          //     billingAddress.selectedProvince = province;
          //     break;
          //   }
          // }

          return billingAddress;
        },
        hasActiveResidentialServices: function (data) {
          if (data && data.subList && data.subList.length > 0) {
            var subList = data.subList;
            for (var i = 0; i < subList.length; i++) {
              var subListItem = subList[i];
              if (
                subListItem.subStatus === 'Active' && (
                  subListItem.subType === 'Digital TV' ||
                  subListItem.subType === 'RHPc' ||
                  subListItem.subType === 'Hi-Speed Internet' ||
                  subListItem.subType === 'Rogers Smart Home Monitoring' ||
                  subListItem.subType === 'HSI' ||
                  subListItem.subType === 'IPTV' ||
                  subListItem.subType === 'RHP Phone Line'
                )
              ) {
                return true;
              }
            }
          }
          return false;
        },
        buildContactInformation: function (account, obj) {
          console.log('selfServe.js buildContactInformation');
          var contactInfo = {};
          var contactObj = obj; //.contactInfo;

          contactInfo.language = contactObj.language || '';

          if (_.includes(contactObj.homePhone, '*')) {
            contactObj.homePhone = contactObj.homePhone.replace(/[*]/g, '•');
          }

          if (_.includes(contactObj.businessPhone, '*')) {
            contactObj.businessPhone = contactObj.businessPhone.replace(/[*]/g, '•');
          }

          if (contactObj.homePhone === '0000000000' || contactObj.homePhone === '9999999999') {
            contactInfo.contactNumber1 = '';
          } else {
            contactInfo.contactNumber1 = contactObj.homePhone || '';
          }

          if (contactObj.businessPhone === '0000000000' || contactObj.businessPhone === '9999999999') {
            contactInfo.contactNumber2 = '';
          } else {
            contactInfo.contactNumber2 = contactObj.businessPhone || '';
          }

          contactInfo.email = contactObj.emailAddress || '';
          /**
           * Add contact ID to the return contact info object
           */
          contactInfo.contactId = contactObj.contactId || '';

          if (contactObj.extension === '0' || contactObj.extension === '00' || contactObj.extension === '000' ||
            contactObj.extension === '0000' || contactObj.extension === '00000' || contactObj.contactNumber2 === ''
          ) {
            contactInfo.extension = '';
          } else {
            contactInfo.extension = contactObj.extension || '';
          }

          return contactInfo;
        },
        buildSubAccounts: function (account, data) {
          var arr = [];
          var subList = data.subList;
          for (var i = 0; i < subList.length; i++) {
            var subListObj = subList[i];
            var obj = {};
            obj.name = subListObj.name ? subListObj.name : 'Jane Smith';
            obj.accountNumber = subListObj.subAccountId;

            arr.push(obj);
          }

          return arr;
        },
        getAccountDetails: function (account, defer, language) {
          var self = this;

          function handleSuccessResponse(data) {

            account.details = data;
            account.billingAddress = self.buildBillingAddress(data);
            account.billingAddress.hasActiveResidentialServices = self.hasActiveResidentialServices(data);
            account.billingAddress.accountId = account.billingAddress && account.identifier;
            // account.contactInformation = self.buildContactInformation(account, data);
            account.subAccounts = self.buildSubAccounts(account, data);
            account.addresskey = data.addresskey;

            defer.resolve(account);
          }

          function handleFailureResponse(data) {
            defer.reject(data);
          }

          // getSummary function will work for prepaid and postpaid account
          getSummary(account, handleSuccessResponse, handleFailureResponse, language);
        },
        getAccounts: function () {
          var name;
          if (accounts && accounts.length > 0) {
            for (var i = 0; i < accounts.length; i++) {
              // get name
              var account = accounts[i];
              var accountName = account.accountName;
              if (account && accountName) {
                name = accountName.firstName + ' ' + accountName.lastName;
              }
              account.name = name || '';
              account.accountLabel = account.accountType ? account.accountType : '' + ' #' + account.accountNumber;
              account.identifier = this.generateUUID();
              account.consolidated = account.postpaidAccountBalance ? account.postpaidAccountBalance.consolidated : false;
            }
            currentAccount = accounts[0];
          } else {
            return [];
          }
          return accounts;
        },
        getAccountList: function (defer) {

          function handleSuccessResponse(data) {
            defer.resolve(data);
          }

          function handleFailureResponse(data) {
            defer.reject(data);
          }

          return ajax.getAccountList({applicationId: 'Rogers.com', refresh: false}, true).then(function (data) {
            accounts = data ? data.accountList || [] : [];
            if (data && data.cachedResultInfo && data.cachedResultInfo.expired) {
              return ajax.getAccountList(
                {applicationId: 'Rogers.com', refresh: true}, true
              ).then(function (data) {
                myrAccountListService.processAccountList(data);
                handleSuccessResponse(data);
              }, function (data) {
                handleFailureResponse(data);
              });
            }

            // if (accounts.length === 0) {
            //  defer.reject();
            //  return;
            //}
            handleSuccessResponse(data);

          }, function (data) {
            handleFailureResponse(data);
          });
        },
        getLoginSecurityQuestions: function () {
          loginSecurityQuestions = [];
          for (var i = 1; i <= 8; i++) {
            loginSecurityQuestions.push({value: i.toString(), label: $translate.instant('login_security_questions_' + i)});
          }
          return loginSecurityQuestions;
        },
        getUserInfo: function () {
          var questionIndex = parseInt(userProfile.questionNo || 0, 10);

          var matchedQuestions = loginSecurityQuestions.filter(function (q) {
            return q.value == questionIndex;
          });
          userProfile.secretQuestion = matchedQuestions && angular.isArray(matchedQuestions) && matchedQuestions.length > 0 && matchedQuestions[0].hasOwnProperty('label') ? matchedQuestions[0].label : '';
          userProfile.secretQuestions = loginSecurityQuestions;
          userProfile.questionNo = questionIndex;
          //userProfile.oldPassword = '';
          // userProfile.confirmPassword = '';
          //userProfile.newPassword = '';

          return userProfile;
        },
        getMarketingPermissions: function (accountNumber) {
          return ajax.getMarketingPermissions({
            accountNumber: accountNumber
          });
        },
        getUserProfile: function (defer) {
          return ajax.getUserInfo().then(function (data) {
            if (data.errorMessage) {
              if ($rootScope.isCare && data.errorCode === 60001) {
                userProfile = data;
              } else {
                defer.reject();
                return;
              }
            }
            userProfile = data;

            defer.resolve();
          }, function () {
            defer.reject();
          });
        },
        _update: function (updates, type, onsuccess, onError) {
          return update(updates, type, onsuccess, onError);
        },
        setContactInfo: function (accountNumber, contactInfo) {
          if (currentAccount.accountNumber == accountNumber) {
            currentAccount.contactInformation = contactInfo;
          }
        },
        resetUpdatedEmailAddress: function () {
          updatedEmailAddress = '';
        },
        updateBillingType: function (updates, defer) {
          var billingType = updates.billingType;
          var email = updates.email;
          var accountNumber = currentAccount.accountNumber;
          /**
           * Override the email with updated email from update email address call
           */
          /*if (updatedEmailAddress && updatedEmailAddress.length > 0) {
            email = updatedEmailAddress;
          }*/
          $rootScope.updateBillingType = false;
          return ajax.updateBillingTypeV2({
            accountNumber: accountNumber,
            billingType: billingType,
            email: email
          }).then(function (data) {
            if (updates.billingType === 'INVOICE') {
              currentAccount.billingAddress.billingType = 'INVOICE';
              currentAccount.billingAddress.paper = true;
              currentAccount.billingAddress.ebill = false;
            } else if (updates.billingType === 'E_BILL') {
              currentAccount.billingAddress.billingType = 'E_BILL';
              currentAccount.billingAddress.ebill = true;
              currentAccount.billingAddress.paper = false;
            }
            defer.resolve();
            $rootScope.updateBillingType = true;
            var modalData = {
              billingType: billingType
            };
            var modalInstance = $modal.open({
              templateUrl: 'views/modals/update-billing-type.html',
              windowClass: 'verify-address-modal',
              controller: ['$scope', 'selfServeSvc', function ($scope, selfServeSvc) {
                $scope.data = modalData;
                $scope.close = function () {
                  modalInstance.close();
                  defer.notify();
                };
              }]
            });
          }, function (data) {
            defer.reject();
          });
        },
        updateBillingAddress: function (updates, defer, form, $scope) {
          var addressAsEntered = buildAddressLineForUI(updates);
          var verifyAddressObj = {};
          var verifyAddressRequest = {};

          form.$setSubmitted(); //
          verifyAddressRequest.accountNumber = currentAccount.accountNumber;
          verifyAddressRequest.primaryLine = buildPrimaryAddressLine(updates);
          verifyAddressRequest.secondaryLine = buildSecondaryAddressLine(updates);
          verifyAddressRequest.city = updates.city;
          verifyAddressRequest.province = updates.province;
          verifyAddressRequest.postalCode = updates.postalCode;
          verifyAddressRequest.country = 'Canada'; //updates.country;

          var promiseArray = [];

          var verifyAddressReq = ajax.verifyAddressV2(verifyAddressRequest).then(
            function (result) {
              var canadaPostAddress = '';

              if (result.addressVerificationResponse) {
                $rootScope.verifyAddressFailed = false;
                var address = result.addressVerificationResponse.address;
                if (address.primaryLine && address.secondaryLine && address.country) {
                  canadaPostAddress = address.primaryLine + ', ' + address.secondaryLine + ', ' + address.country;
                } else {
                  address = buildAddressLineFromVerifyAddress(address);
                  canadaPostAddress = address.primaryLine + address.secondaryLine;
                }
                var modalData = {
                  address: addressAsEntered,
                  canadaPostAddress: canadaPostAddress || ''
                };

                var addressInfo = {
                  streetNumber: address.streetNo,
                  streetName: address.streetName,
                  streetType: address.streetSuffix
                };

                var canadaPostRawResponseObj = {
                  streetNumber: address.streetNo,
                  streetName: address.streetName,
                  streetNameSuffix: '',
                  streetType: address.streetSuffix,
                  compassDirection: address.compassDirection || '',
                  unit: address.aptNumber,
                  postalCode: address.postCode,
                  city: address.city,
                  province: address.province,
                  additionalAddressInfo: address.primaryLine + ' ' + address.secondaryLine
                };

                var canadaPostResponseForSubmit = {
                  primaryLine: address.primaryLine,
                  secondaryLine: address.secondaryLine,
                  city: address.city,
                  province: address.province,
                  postalCode: address.postCode,
                  country: 'Canada',
                  billingAddress: canadaPostRawResponseObj
                };

                var canadaPostResponseForDisplay = {
                  province: address.province,
                  billing_streetAddress: address.primaryLine, // this might have to be constructed ?
                  billing_postalCode: address.postCode,
                  country: address.country,
                  billing_city: address.city,
                  AptNo: updates.AptNo, //address.aptNumber || '', // canada post not returning apt number
                  AptType: updates.AptType,
                  postalCode: address.postCode,
                  city: address.city
                };

                /*var oldBillingType="";
                if(currentAccount.billingAddress.billingType) {
                   oldBillingType = currentAccount.billingAddress.billingType;
                }
                var newBillingType = updates.billingType;
                var isWirelessAccount = currentAccount.accountNumber.length < 12;

                if (oldBillingType !== "" && angular.isDefined(oldBillingType) && oldBillingType !== newBillingType && isWirelessAccount) {
                  canadaPostResponseForSubmit.billingType = newBillingType;
                  canadaPostResponseForSubmit.billingTypeModified = true;
                }*/

                var modalInstance = $modal.open({
                  templateUrl: 'views/modals/verify-billing-address.html',
                  windowClass: 'verify-address-modal',
                  controller: ['$scope', 'selfServeSvc', function ($scope, selfServeSvc) {
                    $scope.data = modalData;
                    $scope.close = function () {
                      modalInstance.close();
                      defer.notify();
                    };
                    $scope.submitCanadaPostAddress = function () {
                      selfServeSvc._update(canadaPostResponseForSubmit, 'canadaPostAddress', onsuccess, onError);

                      function onsuccess() {
                        _.merge(currentAccount.billingAddress, canadaPostResponseForDisplay);

                        currentAccount.billingAddress.billing_streetAddress = canadaPostAddress;
                        currentAccount.billingAddress.Street_name = addressInfo.streetName;
                        currentAccount.billingAddress.Street_number = addressInfo.streetNumber;
                        currentAccount.billingAddress.Street_type = addressInfo.streetType;
                        modalInstance.close();
                        defer.resolve();
                      }

                      function onError(data) {
                        modalInstance.close();
                        defer.reject();
                      }

                    };
                    $scope.submit = function () {
                      selfServeSvc.saveAddressAsEntered(updates, modalInstance, defer, form);
                    };
                  }]
                });
              } else {
                $rootScope.verifyAddressFailed = true;
              }
            },
            function (data) {
              $rootScope.verifyAddressFailed = true;
              defer.reject();
            }
          );
        },
        updatePinEmailAddress: function (updates, defer, form) {
          //return ajax.updatePinEmail({
          //  accountType: currentAccount.a,
          //  update_accountNumber: currentAccount.accountNumber,
          //  email: updates.email
          //});
        },
        updateEmailAddress: function (updates, defer, form) {
          function onSuccess() {
            _.merge(currentAccount.contactInformation, updates);
            /**
             * Set new Email address to updatedEmailAddress when email address updated successfully
             */
            updatedEmailAddress = updates.email;
            defer.resolve();
          }

          function onError(data) {
            /**
             * reset updatedEmailAddress to empty string when email address updated fail
             */
            updatedEmailAddress = '';
            defer.reject();
          }

          return update(updates, 'email', onSuccess, onError);
        },
        updateContactInformation: function (updates, defer, form) {

          var updateType = 'contactInfo';

          function onSuccess() {
            _.merge(currentAccount.contactInformation, updates);
            defer.resolve();
          }

          function onError(data) {
            $rootScope.verifyAddressFailed = false;
            defer.reject();
          }

          if (updateType !== '') {
            return update(updates, updateType, onSuccess, onError);
          }
        },
        setCurrentAccount: function (account) {
          currentAccount = account;
        },
        getCurrentAccount: function () {
          if (currentAccount) {
            return currentAccount;
          }
        },
        buildAddressLineForSubmit: function (updates) {
          var validStreet = updates.Street_name && updates.Street_type && updates.Street_number;
          var validAptType = updates.AptType && updates.AptNo;
          var streetPortion = '';
          var apartmentPortion = '';
          var address = '';

          if (validStreet) {
            streetPortion = updates.Street_number + ' ' + updates.Street_name + ' ' + updates.Street_type + ' ';
          }

          if (validAptType) {
            apartmentPortion = updates.AptType + ' ' + updates.AptNo;
          }

          if (validStreet) {
            address = streetPortion;
            if (validAptType) {
              address += apartmentPortion;
            }
          }

          return address;
        },

        saveAddressAsEntered: function (updates, modalInstance, defer, form) {
          var verifyAddressObj = {};
          var addressAsEntered = buildAddressLineForSubmit(updates);
          var addressForUI = buildAddressLineForUI(updates);

          verifyAddressObj.Street_number = updates.Street_number;
          verifyAddressObj.Street_name = updates.Street_name;
          verifyAddressObj.Street_type = updates.Street_type;
          verifyAddressObj.AptType = updates.AptType;
          verifyAddressObj.AptNo = updates.AptNo;
          verifyAddressObj.billing_postalCode = updates.postalCode;
          verifyAddressObj.province = updates.province;
          verifyAddressObj.billing_city = updates.city;
          verifyAddressObj.billing_streetAddress = addressAsEntered;
          verifyAddressObj.postalCode = updates.postalCode;
          verifyAddressObj.city = updates.city;
          verifyAddressObj.billingAddress = {
            streetNumber: updates.Street_number,
            streetName: updates.Street_name,
            streetNameSuffix: '',
            streetType: updates.Street_type,
            compassDirection: '',
            unit: updates.AptNo,
            postalCode: updates.postalCode,
            city: updates.city,
            province: updates.province,
            additionalAddressInfo: buildPrimaryAddressLine(updates) + ' ' + buildSecondaryAddressLine(updates)
          };

          function onSuccess() {
            var accountIdentifier = updates.accountId;
            if (accountIdentifier) {
              var account = _.find(accounts, {identifier: accountIdentifier}, 'identifier');
              _.merge(account.billingAddress, verifyAddressObj);
              currentAccount.billingAddress.billing_streetAddress = addressForUI;
              defer.resolve();
            }
            modalInstance.close();
          }

          function onError(data) {
            modalInstance.close();
            defer.reject();
          }

          return update(verifyAddressObj, 'address', onSuccess, onError);
        },
        updateAccountInfo: function (updates, defer, form) {
          var updatesToSend = {
            userName: updates.userName,
            userId: updates.userName
          };
          form.$submitted = true;
          // password changed
          if (updates.newPassword !== '') {
            updatesToSend.oldPassword = updates.oldPassword;
            updatesToSend.newPassword = updates.newPassword;
            updatesToSend.confirmPassword = updates.confirmPassword;
            userProfile.questionNo = updates.questionNo;
            updatesToSend.questionNo = updates.questionNo || userProfile.questionNo;

            if (updates.answer === userProfile.answer) {
              updatesToSend.answer = userProfile.answer;
            } else {
              updatesToSend.answer = updates.answer;
            }
          }
          // secret question changed
          if (updates.questionNo !== '' || updates.answer != '') {
            userProfile.questionNo = updates.questionNo;
            updatesToSend.questionNo = updates.questionNo;
            updatesToSend.answer = updates.answer;
          }

          return ajax.updateUserInfo(updatesToSend)
            .then(
              function (data) {
                _.merge(userProfile, updates);
                var matchedQuestions = loginSecurityQuestions.filter(function (q) {
                  return q.value == updatesToSend.questionNo;
                });
                userProfile.secretQuestion = matchedQuestions && angular.isArray(matchedQuestions) && matchedQuestions.length > 0 && matchedQuestions[0].hasOwnProperty('label') ? matchedQuestions[0].label : '';
                defer.resolve(data);
              },
              function (data) {
                form.$valid = false; // an error should pop up now
                var errorObj = data.data;
                form.errorMsg = errorObj.errorMessage;
                if (errorObj.status == 500) {
                  form.generalError = true;
                }
                defer.reject(data);
              }
            );
        },
        updateMarketingPermissions: function () {
          var requestData = {};

          $http.post(settings.testDevServerURL + 'SelfServeAutomation/updateMarketingPermissions', requestData)
            .then(function () {
            });
        },
        getBillingType: function (accountNumber, accountTypeNumber, defer) {
          return goPaperlessService.getBillingType(accountNumber, accountTypeNumber).then(function (billingType) {
            var data = {};
            data.billingtype = billingType;
            defer.resolve(data);
          }, function (error) {
            defer.reject(error);
          });
        },
        getContactInfo: function (obj, defer) {
          return ajax.getContactInfo(obj).then(function (data) {
            defer.resolve(data);
          }, function (error) {
            defer.reject(error);
          });
        },
        doResetPassword: function (defer) {
          return ajax.resetPassword().then(function (data) {
            defer.resolve(data);
          }, function (error) {
            defer.reject(error);
          });
        },
        updateNickName: function (accountNumber, accountTypeNumber, nickName) {
          var defer = $q.defer();
          ajax.updateNickName(accountNumber, accountTypeNumber, nickName).then(function (data) {
            defer.resolve(data);
          }, function (error) {
            defer.reject(error);
          });
          return defer.promise;
        }
        // getMethodOfPayment: function (account) {
        //   var request = {
        //     accountNumber: account.accountNumber,
        //     accountTypeNumber: account.accountTypeNumber,
        //     language: languageSwitcher.getCurrentLanguage(),
        //     refresh: false,
        //     applicationId: 'Rogers.com'
        //   };
        //
        //   return ajax.getBillingDetail(request);
        // }
      };
    }]);
}(_, $));

/*
  A button that displays either a plus or a minus sign
*/

'use strict';

angular
  .module('totesApp')
  .directive('detailsButton', function() {
    return {
      restrict: 'E',
      scope: {
        showDetails: '=',  // called when PLUS clicked
        hideDetails: '=',  // called when MINUS clicked
        expanded: '=',
        buttonId: '@' // the ID for this button (derived from source element)
      },
      templateUrl: 'scripts/directives/widgets/details-button/details-button.html',
      controller: ['$scope', function($scope) {
        $scope.handleClick = function() {
          if($scope.expanded) {
            $scope.hideDetails();
          } else {
            $scope.showDetails(null, $scope.addOnCode);
          }
        };
      }]
    };
  });

'use strict';

angular
  .module('totesApp')
  .directive('showWhen', function () {
    return {
      restrict: 'A',
      controller: ['$scope',
        '$element',
        '$attrs',
        'ute.blocks.language.switcher',
        function($scope,
                 $element,
                 $attrs,
                 languageSwitcher) {

        function showHide() {
          var shouldBeHidden = languageSwitcher.getCurrentLanguage() !== $attrs.showWhen;

          if (shouldBeHidden) {
            $element.hide();
          } else {
            $element.show();
          }
        }

        languageSwitcher.registerOnDataChangeHandler(function () {
          showHide();
        }, 'showWhenLangSub');

        $scope.$on('$destroy', function() {
          languageSwitcher.unregisterOnDataChangeHandler('showWhenLangSub');
        });

        showHide(); // call this for page load
      }]
    };
  });

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('genericWirelessModalCtrl', genericWirelessModalCtrl);

  genericWirelessModalCtrl.$inject = ['$modalInstance','sessionStorage','localStorage','ute.common.user.service','$window','ajax','$state','ute.blocks.persistent.storage.service'];
  function genericWirelessModalCtrl($modalInstance,sessionStorage,localStorage, userService, $window, ajax, $state, utePersistentStorageService) {
    var vm = this; // jshint ignore:line

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    vm.ok = function () {
      $modalInstance.close('ok');
    };

    vm.closeConcurrentUpdate = function () {
       $modalInstance.close('ok');
    }

    vm.onRefresh = function () {
      var request = {
        'ctn': (userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber'): localStorage.getLocalStorageValue('phoneNumber'),
        'ban': (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountNumber'): localStorage.getLocalStorageValue('accountNumber')
      };
       ajax.onRefresh(request).then(function() {
           vm.closeConcurrentUpdate();
           vm.isRefreshed = true;
           $state.reload();
       }, function() {
           vm.closeConcurrentUpdate();
           vm.isRefreshed = true;
           $state.reload();
       });
     };

       function init() {
          vm.isCare = userService.isCare();
          vm.flowType =  utePersistentStorageService.getFromSession('flowType').toLowerCase();
          vm.isRefreshed = false;
        }

      init();
  }
}());

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('notEligibleModalCtrl', notEligibleModalCtrl);

  notEligibleModalCtrl.$inject = ['$modalInstance',
    'ute.blocks.language.switcher',
    '$translate',
    'settings',
    'eligibilityResponse',
    '$filter',
    '$window',
    'ute.common.user.service',
    'ajax',
    'pricePlanChangesErrors'];
  function notEligibleModalCtrl($modalInstance,
                                languageSwitcher,
                                $translate,
                                settings,
                                eligibilityResponse,
                                $filter,
                                $window,
                                userService,
                                ajax,
                                pricePlanChangesErrors) {
    var vm = this; // jshint ignore:line

    vm.onContinue = function () {
      $modalInstance.close('ok');
    };

    vm.cancelCase = function () {
      var closeDate = $filter('date')(new Date(), "yyyy-MM-dd'T'HH:mm:ss.sss");
      var request = {
        'caseID': vm.openCase.caseID,
        'newStatus': 'Closed Cancelled',
        'notes': 'UTE Cancel BOT',
        'firstResolutionCode': 'Miscellaneous',
        'secondResolutionCode': 'Other',
        'closeDate': closeDate
      };

      ajax.closeCase(request).then(function (response) {
        vm.isCaseClosed = false;
        if (response.responseHeader.status.toLowerCase() === 'success') {
          vm.isCaseClosed = true;
          vm.model = {
            desc: $translate.instant('ppccode_case_cancellation_request')
          };
          // $scope.model.desc = $scope.model.desc + $scope.openCase.caseTypeLevel3;
        }
        else {
          vm.onContinue();
          pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
        }
      }, function () {
        vm.onContinue();
        pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
      });
    };

    vm.proceedWithPPC = function () {
      $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan';
    };

    function init() {
      vm.isConsumer = userService.isConsumer();
      vm.isBOTerror = false;
      vm.chatHref = languageSwitcher.getCurrentLanguage() === 'en' ? settings.chatLinkChangePlan.en : settings.chatLinkChangePlan.fr;
      if (eligibilityResponse.eligibilityCode.toLowerCase() === 'bot_eligible') {
        vm.isBOTerror = true;
        vm.openCase = eligibilityResponse.openCases;
        // BCR-158 changes - CQUSR01466901 pending business content for HUP Case
        var errorValue = (vm.openCase.caseTypeLevel3.toLowerCase() === 'hup') ? 'ppc_bot_message_hup' : 'ppc_bot_message_ppc';
        var errorMsg = $translate.instant(errorValue);
        vm.model = {
          desc: errorMsg
        };
      } else {
        var errorKey = 'ppccode_' + eligibilityResponse.eligibilityCode.toLowerCase();
        if (userService.isCare()) {
          errorKey = errorKey + '_care';
        } else if (userService.isDealer()) {
          errorKey = errorKey + '_retail';
        }
        vm.model = {
          desc: $translate.instant(errorKey)
        };
      }
    }

    init();
  }
})();

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessDashPopupCtrl', wirelessDashPopupCtrl);

  wirelessDashPopupCtrl.$inject = ['$scope',
    '$window',
    '$translate',
    '$filter',
    'isBOTEligible',
    'isCaseClosed',
    'hupDetails',
    'ngDialog',
    'appState',
    'ute.common.user.service',
    'ute.blocks.language.switcher',
    'ajax',
    'notEligibleDeviceUpgrade',
    'hupSaveState',
    'isHupFlowProcessSaved',
    'checkForSavedCart',
    'caseID',
    'settings'];

  function wirelessDashPopupCtrl($scope,
                                 $window,
                                 $translate,
                                 $filter,
                                 isBOTEligible,
                                 isCaseClosed,
                                 hupDetails,
                                 ngDialog,
                                 appState,
                                 userService,
                                 languageSwitcher,
                                 ajax,
                                 notEligibleDeviceUpgrade,
                                 hupSaveState,
                                 isHupFlowProcessSaved,
                                 checkForSavedCart,
                                 caseID,
                                 settings) {

    var vm = this; // jshint ignore:line

    vm.payBill = function () {
      ngDialog.close();
      appState.switchView('/paynow');
    };

    vm.wirelessDashPopupclose = function () {
      ngDialog.close();
    };

    vm.proceedWithHUP = function () {
      if (isHupFlowProcessSaved) {
        checkForSavedCart();
      } else {
        hupSaveState(function () {
          $window.location.href = '/web/totes/upgrade/#/choose-phone';
        });
      }
    };

    vm.cancelCase = function () {
      var request = {
        'caseID': caseID,
        'newStatus': 'Closed Cancelled',
        'notes': 'UTE Cancel BOT',
        'firstResolutionCode': 'Miscellaneous',
        'secondResolutionCode': 'Other',
        'closeDate': $filter('date')(new Date(), "yyyy-MM-dd'T'HH:mm:ss.sss")
      };
      ajax.closeCase(request).then(function (response) {
        vm.isCaseClosed = false;
        if (response.responseHeader.status.toLowerCase() === 'success') {
          vm.isCaseClosed = true;
          // BCR-158 changes - CQUSR01466901 pending business content for HUP Case
          // $scope.hupDetails.errorMessage = $translate.instant('ppccode_case_cancellation_request') + $scope.openCase.caseTypeLevel3;
          vm.hupDetails.errorMessage = $translate.instant('hupcode_case_cancellation_request');
        }
        else {
          vm.wirelessDashPopupclose();
          isBOTEligible = false;
          notEligibleDeviceUpgrade();
        }
      }, function () {
        vm.wirelessDashPopupclose();
        isBOTEligible = false;
        notEligibleDeviceUpgrade();
      });
    };

    function init() {
      vm.isBOTEligible = isBOTEligible;
      vm.isCaseClosed = isCaseClosed;
      vm.hupDetails = hupDetails;
      vm.isConsumer = userService.isConsumer();
      vm.lng = languageSwitcher.getCurrentLanguage();
      vm.chatHref = languageSwitcher.getCurrentLanguage() === 'en' ? settings.chatLinkHup.en : settings.chatLinkHup.fr;

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        vm.lng = lang;
      }, 'wirelessDashPopupCtrlLangSub_'+$scope.$id);

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler('wirelessDashPopupCtrlLangSub_'+$scope.$id);
      });
    }

    init();
  }
})();

/* jshint -W106 */
(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessRemoveModalCtrl', wirelessRemoveModalCtrl);

  wirelessRemoveModalCtrl.$inject = ['$scope',
    '$modalInstance',
    'settings',
    'ute.blocks.language.switcher'];
  function wirelessRemoveModalCtrl($scope,
                                   $modalInstance,
                                   settings,
                                   languageSwitcher) {

    $scope.ok = function () {
      $modalInstance.close('ok');
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    function setStaticChatButtonValues() {
      if ($scope.lng === 'en') {
        $scope.boldChatButtonId = 'S_MRog_Wless_ChngeWlessPln';
        $scope.boldChatButtonDiv = 'changePlan-en';
        $scope.boldChatButton = 'chatButtonChangePlanEn';
      } else {
        $scope.boldChatButtonId = 'S_MRog_Wless_ChngeWlessPln_Fr';
        $scope.boldChatButtonDiv = 'changePlan-Fr';
        $scope.boldChatButton = 'chatButtonChangePlanFr';
      }
    }

    function init() {
      $scope.lng = languageSwitcher.getCurrentLanguage();
      $scope.viewAllPlanslink = '/web/content/wireless_plan_landing?setLanguage=' + $scope.lng;
      $scope.chatHref = $scope.lng === 'en' ? settings.chatLinkChangePlan.en : settings.chatLinkChangePlan.fr;  // 'cuscare_ECare_landing.php?hm=n&s=701',
      setStaticChatButtonValues();

      languageSwitcher.registerOnDataChangeHandler(function (lang) {
        $scope.lng = lang;
        $scope.viewAllPlanslink = '/web/content/wireless_plan_landing?setLanguage=' + $scope.lng;
        setStaticChatButtonValues();
      }, 'wirelessRemoveModalCtrlLangSub_'+$scope.$id);

      $scope.$on('$destroy', function () {
        languageSwitcher.unregisterOnDataChangeHandler('wirelessRemoveModalCtrlLangSub_'+$scope.$id);
      });
    }

    init();
  }
}());

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessSubscriptionModalCtrl', wirelessSubscriptionModalCtrl);

  wirelessSubscriptionModalCtrl.$inject = ['$modalInstance',
    'ute.blocks.language.switcher',
    'modalCurrentPlanName',
    'modalAdditionalPlanInfo'];
  function wirelessSubscriptionModalCtrl($modalInstance,
                                         languageSwitcher,
                                         modalCurrentPlanName,
                                         modalAdditionalPlanInfo) {
    var vm = this;// jshint ignore:line

    vm.close = function () {
      $modalInstance.dismiss('cancel');
    };

    function init() {
      vm.lng = languageSwitcher.getCurrentLanguage();
      vm.modalCurrentPlanName = modalCurrentPlanName;
      vm.modalAdditionalPlanInfo = modalAdditionalPlanInfo;
    }

    init();
  }
})();

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessTravelPackageLegalModalCtrl', wirelessTravelPackageLegalModalCtrl);

  wirelessTravelPackageLegalModalCtrl.$inject = ['$modalInstance', 'legalContent'];
  function wirelessTravelPackageLegalModalCtrl($modalInstance, legalContent) {
    var vm = this; // jshint ignore:line

    vm.legalContent = legalContent;

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }
}());

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessTravelPackageModalCtrl', wirelessTravelPackageModalCtrl);

  wirelessTravelPackageModalCtrl.$inject = ['$rootScope',
    '$modalInstance',
    'myrWirelessDashboardService',
    'ute.common.permissions.service',
    'ban',
    'ctn'];
  function wirelessTravelPackageModalCtrl($rootScope,
                                          $modalInstance,
                                          wirelessService,
                                          permissionsService,
                                          ban,
                                          ctn) {
    var vm = this; // jshint ignore:line

    vm.getPlan = function () {
      callEnrollPlan(true);
    };

    vm.unEnrollPlan = function () {
      callEnrollPlan(false);
    };

    vm.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    function callEnrollPlan(optInFlag) {
      var request = {
        ban: ban,
        ctn: ctn,
        evolutionOptInOutFlag: optInFlag,
        evolutionEligibleFlag: true
      };
      wirelessService.setWirelessTravelPackage(request, function (_tmp1) {
        if (_tmp1.result === 'success') {
          if (_tmp1.data.successFlag) {
            if (_tmp1.data.evolutionOptInOutFlag) {
              $rootScope.$broadcast('setTravelPackageDataHasPlan');
            } else {
              $rootScope.$broadcast('unSetTravelPackageDataHasPlan');
            }
            $modalInstance.close('ok');
          } else {
            vm.errorMessage = true;
          }
        } else if (_tmp1.result === 'fail') {
          vm.errorMessage = true;
        } else if (_tmp1.result === 'error') {
          vm.errorMessage = true;
        } else {
          vm.errorMessage = true;
        }
      });
    }

    function init() {
      vm.errorMessage = false;
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ROAM_LIKE_HOME_IS_BRT)
        .then(function (isPermitted) {
          if (isPermitted) {
            vm.hideNewRLH = false;
            vm.hideOldRLH = true;
          } else {
            vm.hideNewRLH = true;
            vm.hideOldRLH = false;
          }
        });
    }

    init();
  }
})();

(function () {
  'use strict';

  angular.module('totesApp')
    .controller('wirelessUpgradeDeviceModalCtrl', wirelessUpgradeDeviceModalCtrl);

      wirelessUpgradeDeviceModalCtrl.$inject = ['$modalInstance'];
      function wirelessUpgradeDeviceModalCtrl($modalInstance) {
        var vm = this; // jshint ignore:line

        vm.cancel = function () {
          $modalInstance.dismiss('cancel');
        };

        vm.openAiselFlow = function () {
          $modalInstance.close('Aisel');
        };

        vm.openSSP = function () {
          $modalInstance.close('SSP');
        };
      }
})();

'use strict';

angular
.module('totesApp')
.directive('internetMyModem', function () {
  return {
    restrict: 'AE',
    replace: 'true',
    scope: {},
    templateUrl: 'scripts/modules/internetDashboard/internetMyModem/internetMyModem.html',
    controller: [
      'settings',
      'myrInternetService',
      '$translate',
      'appState',
      'ute.blocks.language.switcher',
      'MODEM_DEVICES',
      'ute.common.user.service',
      '$rootScope',
      'oneTimeModalPopupService',
      '$http',
      function (settings,
                internetService,
                $translate,
                appState,
                languageSwitcher,
                MODEM_DEVICES,
                userService,
                $rootScope,
                oneTimeModalPopupService,
                $http) {

        var self = this;

        self.userService = userService;
        self.isCare = _.bind(userService.isCare, userService);
        self.isRepView = _.bind(userService.isRepView, userService);
        self.isDealer = _.bind(userService.isDealer, userService);
        self.loadingDataIndicator = false;
        self.displayContent = false;
        self.errorMessage = '';
        self.serverError = false;
        self.wifiTargetUrl = '';
        self.displayYahooMailButton = false;
        self.isMyWifiBadgeEligible = false;
        self.devices = MODEM_DEVICES;
        self.internetObj = {};
        self.lng = languageSwitcher.getCurrentLanguage();
        self.isCareRepView = function() {
          return self.isRepView() && self.isCare();
        }
        self.goToYahooChackMail = function () {
          var payload = ['_trackPageView', {
            eVar13: 'MyRogers internet check my yahoo rogers mail'
          }, {
            event5: ''
          }];
          onOmnitureClickInternetMyModem(payload);
          window.open($translate.instant('yahoo_email_link'), '_blank');
        };

        function onOmnitureClickInternetMyModem(option) {
          try {
            appState.tagging(option);
          } catch (e) {
            console.error('Exception catch during tagging on pn=home:signin with message:', e.message);
          }
        }

        function loadData(refreshCall) {
          var passParams = {
            accountNumber: (!userService.isCare() ? window.localStorage.getItem('internetAccountNumber') : window.sessionStorage.getItem('internetAccountNumber')),
            refresh: !!refreshCall,
            language: languageSwitcher.getCurrentLanguage()
          };
          self.loadingDataIndicator = true;
          internetService.internetModem(passParams, processResponse, processError);
        }

        //Added as part of DSO-7485
        function loadWifiBadgeJson(){
          $rootScope.$on('InternetProductDetailsLoaded' , function(event, response){
              $http.get('/web/totes/cms/content/json/my_wifi/my-wifi-badge.json').then(function(obj){
                if(obj && obj.data){
                  var programIdObj = oneTimeModalPopupService.validateTheRules(obj.data, response);
                  if(programIdObj && programIdObj.endDate && programIdObj.programId){
                    self.isMyWifiBadgeEligible = true;
                  }
                }
              },function(error){
                self.isMyWifiBadgeEligible = false;
              });
          });
        }

        function processResponse(response) {
          if (response) {
            self.wifiTargetUrl = self.devices[_.get(response, 'deviceId')] || self.devices['default'];
            self.internetObj = {
              myModem: {
                name: _.get(response, 'deviceName', null),
                image: _.get(response, 'deviceDetails.' + _.get(response, 'deviceId', 'default') + '.modemImagePath', 'images/Internet-HD.png')
              }
            };
            self.errorMessage = '';
            self.displayContent = true;
            self.loadingDataIndicator = false;
            self.displayYahooMailButton = _.get(response, 'displayYahooMailButton', false);
            if (response &&
              (_.get(response, 'cachedResultInfo.expired', false) === true) &&
              (++internetService.internetModemObj.numberOfRetryOnExpired <= settings.maxRetryOnExpired)) {
              try {
                var displayContentTimeout = setTimeout(function () {
                  loadData(true);
                  self.displayContent = true;
                  self.loadingDataIndicator = true;
                  clearTimeout(displayContentTimeout);
                }, 0);
              } catch (e) {
              }
            }
          } else {
            self.displayContent = false;
            self.loadingDataIndicator = false;
          }
        }

        function processError(error) {
          self.displayContent = false;
          self.loadingDataIndicator = false;
          if (error.data.status === 555) {
            self.serverError = true;
            self.errorMessage = _.get(error, 'error.message', $translate.instant('error_usage_internet_modem'));
          } else {
            self.serverError = false;
            self.errorMessage = $translate.instant('error_usage_internet_modem');
          }
        }

        loadData();
        loadWifiBadgeJson();
      }
    ],
    controllerAs: '$ctrl'
  };
});

(function () {
  'use strict';

  angular
    .module('totesApp').constant('MODEM_DEVICES', {
    //Signed in Cx has Internet package with one of the following modems -
    // Hitron CGNM3552 or Hitron CGN3ACR or Hitron CGN3
    'WGMR': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WZMR': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WZMP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WZEP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WZPP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WWMR': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WWMP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WWEP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    'WWPP': 'http://www.rogers.com/web/support/Internet/home-networking/181',
    //Signed in Cx has Internet package with modem - Hitron CGN2
    'WCRR': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WCPN': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WCPE': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WCPR': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WM3R': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WM3P': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WMEP': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'WMPP': 'http://www.rogers.com/web/support/Internet/home-networking/178',
    'default': 'https://www.rogers.com/web/support/internet/home-networking/412'
  });
})();

'use strict';

angular
  .module('totesApp')
  .directive('internetMyPackage', function () {
    return {
      restrict: 'AE',
      replace: 'true',
      scope: {},
      templateUrl: 'scripts/modules/internetDashboard/internetMyPackage/internetMyPackage.html',
      controller: [
        'myrInternetService',
        '$translate',
        'settings',
        'appState',
        'ute.blocks.language.switcher',
        'ute.common.user.service',
        '$rootScope',
        function (internetService,
          $translate,
          settings,
          appState,
          languageSwitcher,
          userService,
          $rootScope) {

          var self = this;

          self.displayContent = false;
          self.loadingIndicator = false;
          self.userService = userService;
          self.isCare = _.bind(userService.isCare, userService);
          self.isRepView = _.bind(userService.isRepView, userService);
          self.isConsumer = _.bind(userService.isConsumer, userService);
          self.isDealer = _.bind(userService.isDealer, userService);
          self.lang = languageSwitcher.getCurrentLanguage();
          self.internetObj = {};
          self.serverError = false;
          self.errorMessage = '';
          self.currentPackageId = null;
          self.currentModemId = null;
          self.isCareRepView = function() {
            return self.isRepView() && self.isCare();
          }

          function onOmnitureClickInternet(option) {
            try {
              appState.tagging(option);
            } catch (e) {
              console.error('Exception catch during tagging on onOmnitureClickInternet with message:', e.message);
            }
          }

          function postToRogers(translate) {
            var formToRogersElement = $('#formToRogers');
            formToRogersElement
              .append(
                $('<input>').attr({
                  type: 'text',
                  name: 'currentPackageId',
                  value: self.currentPackageId
                })
              )
              .append(
                $('<input>').attr({
                  type: 'text',
                  name: 'currentModemId',
                  value: self.currentModemId
                })
              )
              .attr('action', $translate.instant('internet_my_package_post_to_url_links.' + translate))
              .submit();
            formToRogersElement = null;
          }

          function loadData(refreshCall) {
            var payload = {
              accountNumber: userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER),
              refresh: !!refreshCall,
              language: self.lang
            };
            internetService.internetPackage(payload, processResponse, processError);
          }

          function processResponse(response) {
            if (response) {
              self.displayContent = true;
              self.loadingIndicator = false;
              self.errorMessage = '';
              self.currentModemId = _.get(response, 'deviceId', null);
              self.currentPackageId = _.get(response, 'internetPlan', null);
              self.internetObj = {
                myModem: {
                  name: _.get(response, 'deviceName', '')
                },
                myPlan: {
                  package: _.get(response, 'planName', _.get(response, 'serviceName', ''))
                }
              };
              if ((_.get(response, 'cachedResultInfo.expired', false) === true) &&
                (++internetService.internetPackageObj.numberOfRetryOnExpired <= settings.maxRetryOnExpired)) {
                try {
                  var displayContentTimeout = setTimeout(function () {
                    loadData(true);
                    self.loadingIndicator = true;
                    self.displayContent = true;
                    clearTimeout(displayContentTimeout);
                  }, 0);
                } catch (e) {}
              }

              if(!_.get(response, 'cachedResultInfo.expired')){
                $rootScope.$broadcast('InternetProductDetailsLoaded' , response);
              }
            } else {
              self.loadingIndicator = false;
              self.displayContent = false;
            }
          }

          function processError(error) {
            self.displayContent = false;
            self.loadingIndicator = false;
            if (error.data.status === 555) {
              self.serverError = true;
              self.errorMessage = _.get(error, 'error.message', $translate.instant('error_usage_internet_modem'));
            } else {
              self.serverError = false;
              self.errorMessage = $translate.instant('error_usage_internet_modem');
            }
          }

          self.changePlan = function () {
            onOmnitureClickInternet(['_trackPageView', {
              pn: 'home:myrogers:internet:manage-my-package',
              eVar13: 'MyRogers internet change package'
            }, {
              event5: ''
            }]);
            postToRogers('internet_change_package');
          };
          loadData();
        }
      ],
      controllerAs: '$ctrl'
    };
  });

'use strict';

angular
  .module('totesApp')
  .directive('internetMyUsage', ['ute.blocks.language.switcher', function (ls) {
    return {
      restrict: 'AE',
      replace: 'true',
      scope: {}, // closed scope
      templateUrl: 'scripts/modules/internetDashboard/internetMyUsage/internetMyUsage.html',
      link: function (scope, element, attrs) {
        scope.$on('$destroy', function () {
          ls.unregisterOnDataChangeHandler('internetMyUsageControllerLangSub');
        });
      },
      controller: [
        '$scope',
        'settings',
        'myrInternetService',
        'myrInternetChartService',
        'appState',
        '$translate',
        '$timeout',
        '$filter',
        'ute.blocks.language.switcher',
        'ute.common.user.service',
        'ute.rogers.eclipse.remote.api.service',
        'localStorage',
        'cookieStore',
        function ($scope,settings,
                  internetService,
                  internetChart,
                  appState,
                  $translate,
                  $timeout,
                  $filter,
                  languageSwitcher,
                  userService,
                  eclipseRemoteService,
                  localStorage,
                  cookieStore) {

          var self = this;
          var internetChartTimer;
          var lsAcc = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER);
          if (lsAcc === null) {
            appState.switchView('accountOverview');
            return;
          }

          self.isDealer = _.bind(userService.isDealer, userService);
          self.isCare = _.bind(userService.isCare, userService);
          self.isRepView = _.bind(userService.isRepView, userService);
          self.isCareRepView = function() {
            return self.isRepView() && self.isCare();
          };
          self.selectedAccount = {
            accountNumber: lsAcc,
            ban: userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)
          };
          // Required by template - Variables set
          self.graphData = {};
          self.internetObj = {
            days: 0,
            usedGb: 0,
            globalColor: '',
            globalPercentage: 0,
            unlimitedClass: 'normal',
            extraUsage: 0,
            chargeAmount: 0,
            myPlan: {
              totalGB: 0,
              total: 0,
              package: '',
              downloadSpeed: '',
              uploadSpeed: ''
            },
            myExtras: [],
            myModem: {
              name: '',
              image: '',
              imagePath: ''
            }
          };

          self.lang = languageSwitcher.getCurrentLanguage();

          self.postToRogersUrls = [{
            adlMappingKey: 'usage-history',
            translate: 'internet_view_history',
            testId: 'myr-internetMyUsage-usageHistory'
          }, {
            adlMappingKey: 'usage-alerts',
            translate: 'internet_usage_alerts',
            testId: 'myr-internetMyUsage-usageAlert'
          }, {
            adlMappingKey: 'daily-usage',
            translate: 'internet_daily_usage',
            testId: 'myr-internetMyUsage-dailyUsage'
          }, {
            adlMappingKey: 'monthly-usage',
            translate: 'internet_monthly_usage',
            testId: 'myr-internetMyUsage-monthlyUsage'
          }];

          self.loadingDataIndicator = true;
          self.displayContent = false;
          self.internetUsageEmpty = '';
          self.errorMessage = '';
          self.unlimitedShow = false;
          self.isOverage = false;

          self.lbGB = '';
          self.lbRemaining = '';
          self.lbTotal = '';
          self.lbDown = 0;
          self.lbUpload = 0;
          self.lblOvrUsedMonth = '';
          self.lblTotalOvrPlan = '';
          self.lblOvrUsed = '';

          // Support functions
          self.postToRogers = function (url) {
            $('#formToRogers').attr('action', $translate.instant('internet_usage_post_to_url_links.' + url.translate));
            $('#formToRogers').submit();
          };

          self.postToConsumer = function (url) {
            var accountNumber = localStorage.getLocalStorageValue('accountNumber');
            var source = 'rogers.com';
            var redirectUrl = {
              protocol: window.location.protocol,
              host: window.location.hostname,
              port: window.location.port,
              path: window.location.pathname,
              hash: window.location.hash,
              href: window.location.href
            };
            var language,userType,province;
            language = languageSwitcher.getCurrentLanguage();
            userType = userService.getUserType();
            province = cookieStore.get('province').toLowerCase();
            var queryParams = {
              lang: language,
              userType: userType,
              province: province
            };
            var input = {
              accountNumber: accountNumber,
              source: source,
              redirectTo: redirectUrl,
              isLegacyCustomer: true,
              isUnlimited: self.unlimitedShow
            };
            switch (url) {
              case 'daily-usage':
                eclipseRemoteService.goToLegacyInternetDailyUsage(input, queryParams);
                break;
              case 'monthly-usage':
                eclipseRemoteService.goToLegacyInternetMonthlyUsage(input, queryParams);
                break;
              case 'usage-alerts':
                eclipseRemoteService.goToLegacyInternetDailyAlerts(input, queryParams);
                break;
            }
          };

          // From old controller
          function loadData() {
            var status = '';
            var accType = '';

            self.loadingDataIndicator = true;
            self.displayContent = false;

            if (self.selectedAccount.accountInfo) {
              status = self.selectedAccount.accountInfo.status;
              accType = self.selectedAccount.accountInfo.accType;
            }

            // Oniture tagging
            try {
              appState.tagging(['_trackPageView', {
                pn: 'home:myrogers:internet'
              }, {
                sACTT: status
              }, {
                sBAN: self.selectedAccount.accountNumber
              }, {
                sCTN: self.selectedAccount.accountNumber
              }, {
                sACSS: accType
              }]);
            } catch (e) {
              console.error('Exception catch during tagging on pn=home:signin with message:', e.message);
            }
            var passParams = {
              accountNumber: self.selectedAccount.accountNumber
            };
            internetService.internetUsage(passParams, processResponse, processError);
          }

          // Process data response
          function processResponse(response) {
            var noUsageFlag = _.get(response, 'internetUsageToolVO.errorCodeCurrentUsageAvailable', '');
            var used = _.get(response, 'internetUsageUsed', -1);
            self.internetUsageEmpty = (noUsageFlag === 'NoUsage' && used < 0);
            if (response) {
              self.displayContent = true;
              self.loadingDataIndicator = false;
              self.graphData = {};
              self.internetObj.days = 0;
              var internetUsageTotal = _.get(response, internetUsageTotal, _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.usageCapacity', 0));
              var internetUsageRemaining = _.get(response, internetUsageRemaining, 0);
              self.unlimitedShow = _.get(response, 'isInternetUsageUnlimited', (internetUsageTotal > 99999 && internetUsageRemaining > 99999));

              self.lblOvrUsedMonth = '';
              self.lblTotalOvrPlan = '';
              self.lblOvrUsed = '';

              self.isOverage = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentTotalExtraUsage', 0) > 0 ? true : false;
              self.internetObj.extraUsage = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentTotalExtraUsage', 0);
              self.internetObj.chargeAmount = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentTotalChargeAmount', 0);

              var total = Math.round(internetUsageTotal * 10) / 10;
              self.internetObj.myPlan.total = total;



              var remaining = (total - used);
              self.internetObj.myPlan.totalGB = self.unlimitedShow === true ? $translate.instant('internet_unlimited') : total;
              self.internetObj.usedGb = used;
              self.internetObj.remainingGb = remaining.toFixed(2);

              var divider = total;
              if (divider === 0) {
                divider = 1;
              }
              self.internetObj.globalPercentage = Math.ceil((used / divider) * 100);

              self.internetObj.downloaded = 0;
              self.internetObj.uploaded = 0;

              var startDate = '';
              var endDate = '';
              var downTotal = 0;
              var upTotal = 0;

              var dayToDay = _.get(response, 'internetUsageToolVO.dayToDayVO[0]', null);

              if (dayToDay) {
                startDate = _.get(dayToDay, 'billPeriodStartDate', null);
                endDate = _.get(dayToDay, 'billPeriodEndDate', null);

                var usageListLength = _.get(dayToDay, 'dailyUsageList.length', 0);
                for (var ix = 0; ix < usageListLength; ix++) {
                  downTotal += _.get(dayToDay, 'dailyUsageList[ix].downLoadUsage', 0);
                  upTotal += _.get(dayToDay, 'dailyUsageList[ix].upLoadUsage', 0);
                }

                self.internetObj.downloaded = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentDownloadTotalUsage', 0);
                self.internetObj.uploaded = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentUploadTotalUsage', 0);

              } else { //no usage
                startDate = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentBillPeriodStartDate', null);
                endDate = _.get(response, 'internetUsageToolVO.currentUsageSummaryVO.currentBillPeriodEndDate', null);
              }

              defineLabels();
              getRoundClass();

              var dtStartdate = new Date(startDate);
              var dtEndDate = new Date(endDate);
              var dtToday = new Date();

              self.internetObj.days = Math.round((dtEndDate.getTime() - dtToday.getTime()) / (settings.msInDay)); //+ 1;
              if (self.internetObj.days < 0) {
                self.internetObj.days = 0;
              }

              self.graphData.data = response;
              self.graphData.total = total;
              self.graphData.startDate = startDate;
              self.graphData.endDate = endDate;
              self.graphData.dtStartDate = dtStartdate;
              self.graphData.dtEndDate = dtEndDate;
              self.graphData.days = self.internetObj.days;

            }

            // internetChartTimer = $timeout(function () {
            //   internetChart.drawChartSync(self.graphData, true);
            // });
          }
          // Process Error response
          function processError(error) {
            // Hide loading usage
            self.displayContent = false;
            self.loadingDataIndicator = false;
            self.errorCode = error.errorCode === undefined ? '50000' : error.errorCode;
            self.errorMessage = $translate.instant(self.errorCode);

            // Error handling - 555 exception
            if (error.data.status === 555) {
              self.errorCode = _.get(error, 'error.errorCode', null);
              self.errorMessage = _.get(error, 'error.message', '');
            } else {
              self.errorCode = 'error_usage_internet_modem';
              self.errorMessage = $translate.instant('error_usage_internet_modem');
            }
          }

          function defineLabels() {
            var remainingAmount = self.internetObj.myPlan.total > 1 ? 'wireless_remaining_plural' : 'wireless_remaining';
            self.lbGB = $filter('bilingualnumber')(self.internetObj.remainingGb, 2);

            self.lbRemaining = $translate.instant(remainingAmount) + ' ' + $translate.instant('_of') + ' ' + $filter('bilingualnumber')(self.internetObj.myPlan.total, 2) + ' ' + $translate.instant('internet_GB');
            self.lbTotal = $filter('bilingualnumber')(self.internetObj.myPlan.total, 2)+ ' ' + $translate.instant('internet_GB');
            self.lbDown = $translate.instant('internet_downloaded') + ': ' + $filter('bilingualnumber')(self.internetObj.downloaded, 2) + ' ' + $translate.instant('internet_GB');
            self.lbUpload = $translate.instant('internet_uploaded') + ': ' + $filter('bilingualnumber')(self.internetObj.uploaded, 2) + ' ' + $translate.instant('internet_GB');
            self.internetObj.myPlan.totalGB = self.unlimitedShow === true ? $translate.instant('internet_unlimited') : $filter('bilingualnumber')(self.internetObj.myPlan.total, 2) + ' ' + $translate.instant('internet_GB');

            self.lblOvrUsedMonth = $filter('bilingualnumber')(self.internetObj.myPlan.total, 2) + ' ' + $translate.instant('internet_GB') + ' ' + $translate.instant('internet_per_month');
            self.lblTotalOvrPlan = $filter('bilingualnumber')(self.internetObj.myPlan.total, 2) + ' ' + $translate.instant('internet_GB');

            self.lblOvrUsed = $filter('bilingualnumber')(self.internetObj.usedGb, 2) + ' ' + $translate.instant('internet_GB') + ' ' + $translate.instant('internet_used');
          }

          function getRoundClass() {
            if (self.internetObj.globalPercentage <= 100) {
              self.internetObj.globalColor = 'usageNormal';
              self.internetObj.globalNotice = 'Looking good';
            } else if (self.internetObj.globalPercentage > 100) {
              self.internetObj.globalColor = 'usageWarning';
              self.internetObj.globalNotice = 'Check it out';
            }

            if (self.internetObj.globalPercentage > 100) {
              self.internetObj.globalPercentage = 100;
            }
          }

          loadData();
          //
          // $scope.$on('$destroy', function () {
          //    $timeout.cancel(internetChartTimer);
          // });

          languageSwitcher.registerOnDataChangeHandler(function (lang) {
            self.errorMessage = $translate.instant(self.errorCode);
            // if (self.loadingDataIndicator === false) {
            //   internetChart.drawChartSync(self.graphData, false);
            // }
            defineLabels();
          }, 'internetMyUsageControllerLangSub');
        }
      ],
      controllerAs: '$ctrl'
    };
  }]);

(function () {
  'use strict';

  angular.module('onboarding').controller('onboardingItemController', OnboardingItemController);

  OnboardingItemController.$inject = ['$modal'];

  function OnboardingItemController($modal) {
    var _this = this;
    init();

    function init() {
    }

    _this.getBackgroundUrl = function () {
      return _this.config.completed ? _this.config.completedBg : _this.config.pendingBg;
    };

    _this.openModal = function (event) {
      if (!_this.config.completed) {
        $modal.open({
          templateUrl: 'scripts/modules/onboarding/onboarding-item/onboarding-modal.html',
          controllerAs: 'ctrl',
          windowClass: 'onBoarding_modal',
          controller: ['$scope', 'ute.datalayer.common.service', function ($scope, dataLayerService) {
            var modalVm = this;

            dataLayerService.track({}, true, [0, 1, 2, 4], {mappingKey: 'onboarding.' + _this.config.itemKey + '.modalLoad'});

            modalVm.titleKey = _this.config.modal.titleTranslationKey;
            modalVm.itemKey = _this.config.itemKey;
            modalVm.descriptionKey = _this.config.modal.descriptionTranslationKey;
            modalVm.buttons = _this.config.modal.buttons;
            modalVm.close = function () {
              $(event.target).focus();
              $scope.$close();
            };
          }]
        });
      }
    };

    _this.getTaskAltTranslationKey = function () {
      return 'onBoarding.tasks.' + _this.config.itemKey + '.alt.' + (_this.config.completed ? 'completed' : 'pending');
    };
  }

})();

(function () {
  'use strict';

  angular.module('onboarding').directive('onboardingItem', OnboardingItem);

  function OnboardingItem() {
    return {
      restrict: 'E',
      scope: {
        config: '='
      },
      templateUrl: 'scripts/modules/onboarding/onboarding-item/onboarding-item.view.html',
      controller: 'onboardingItemController',
      controllerAs: 'ctrl',
      bindToController: true
    };
  }

})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('captureDealerCodeFormController', CaptureDealerCodeController);

  CaptureDealerCodeController.$inject = ['$scope', '$translate'];

  /* @ngInject */
  function CaptureDealerCodeController($scope, $translate) {

  $scope.dealerCode = '';
  $scope.dealerCodePlaceholder = $translate.instant('dealer-code_enter');
  $scope.isDealerCodeError = false;
  $scope.isDealerCodeSuccess = false;


     $scope.onDealerCodeInputChange = function() {
       $scope.isDealerCodeError = false;
       $scope.isDealerCodeSuccess = false;
     };


  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').directive('dealerCodeForm', dealerCodeForm);

  dealerCodeForm.$inject = ['$log'];

  /* @ngInject */
  function dealerCodeForm($log) {
    return {
      restrict: 'E',
      templateUrl: 'scripts/modules/oneView/captureDealerCode/captureDealerCodeForm.partial.html',
      replace: true,
      controller: 'captureDealerCodeFormController',
      controllerAs: 'cdcc',
      bindToController: true
    };

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('captureDealerCodeModalController', CaptureDealerCodeModalController);

  CaptureDealerCodeModalController.$inject = ['$scope', '$modalInstance', '$rootScope', 'ute.blocks.language.switcher', 'captureDealerCodeService'];

  /* @ngInject */
  function CaptureDealerCodeModalController($scope, $modalInstance, $rootScope, languageSwitcher, captureDealerCodeService) {
     $scope.dealerCode = '';
     $scope.lang = languageSwitcher.getCurrentLanguage();
     $scope.submit = function() {
        captureDealerCodeService.submit($scope.dealerCode).then(
        function () {
            $scope.isDealerCodeSuccess = true;
            $modalInstance.close('ok');
        },
        function (isDCExist) {
          if(!isDCExist) {
          $scope.isDealerCodeError = true;
          } else {
                $modalInstance.close('ok');
                captureDealerCodeService.showCaptureDealerCodeErrorModal();
          }
        });
     };

     $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
     };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
// This whole Capture dealer code module got moved to ute-capture-dealer-code module. Kindly use ute-capture-dealer-code module for Dealer Code related requirements.
 // We will delete this module soon
(function () {
  'use strict';

  angular.module('totesApp').factory('captureDealerCodeService', CaptureDealerCodeService);

  CaptureDealerCodeService.$inject = ['ajax', '$rootScope', '$modal', 'settings', 'appState', '$q', 'ute.blocks.messages.bus.service', 'ute.bfa.ppc.service'];

  /* @ngInject */
  function CaptureDealerCodeService(ajax, $rootScope, $modal, settings, appState, $q, messagesService, bfaPpcService) {
      var storedDealerCode = null;
    var service = {
      showCaptureDealerCodeModal: showCaptureDealerCodeModal,
      showProceedWithoutDealerCodeModal: showProceedWithoutDealerCodeModal,
      retrieveDealerCode: retrieveDealerCode,
      showDsgCaptureDealerCodeModal: showDsgCaptureDealerCodeModal,
      showCaptureDealerCodeErrorModal: showCaptureDealerCodeErrorModal,
      submit: submit,
      setStoredDealerCode: setStoredDealerCode,
      getStoredDealerCode: getStoredDealerCode,
      submitToSessionTable: submitToSessionTable
    };

    return service;

    function setStoredDealerCode(dealerCode) {
        storedDealerCode = dealerCode;
    }
    function getStoredDealerCode() {
        return storedDealerCode;
    }
    function setIsDealerCodeExist(val) {
      appState.isDealerCodeExist = val;
      bfaPpcService.setDealerCodeExist(val);
    }
    function showCaptureDealerCodeModal() {
           $rootScope.modal = $modal.open({
             templateUrl: 'scripts/modules/oneView/captureDealerCode/captureDealerCodeModal.html',
             controller: 'captureDealerCodeModalController',
             size: 'md',
             backdrop: 'static',
             backdropClass: 'bkg-modal',
             resolve: {
             }
           });
           $rootScope.modal.result.then(function () {
             // on OK behaviour
             messagesService.publish('care-dealer-code-submitted');
           }, function () {
               // on Cancel behaviour
                if(appState.isDealerCodeExist) {
                messagesService.publish('care-dealer-code-submitted');
                } else {
                  service.showProceedWithoutDealerCodeModal();
                }
            });
         }

    function showProceedWithoutDealerCodeModal() {
      $rootScope.modal = $modal.open({
        templateUrl: 'scripts/modules/oneView/captureDealerCode/proceedWithoutDealerCodeModal.html',
        controller: 'proceedWithoutDealerCodeModalController',
        size: 'md',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {}
      });
      $rootScope.modal.result.then(function () {
        // on OK behaviour
        messagesService.publish('care-dealer-code-submitted');
      }, function () {
        // on Cancel behaviour
         messagesService.publish('care-dealer-code-submitted');
      });
    }

    function showDsgCaptureDealerCodeModal() {

      var dsgDealerCodeData = '';
      if($rootScope.userInfo) {
        dsgDealerCodeData = $rootScope.userInfo.careInfo.dealerCode;
      }
      if(dsgDealerCodeData !== '') {
        setIsDealerCodeExist(true);
        messagesService.publish('care-dealer-code-submitted', {"type": "dsg", "dsgDealerCode":dsgDealerCodeData});
      } else {
          $rootScope.modal = $modal.open({
            templateUrl: 'scripts/modules/oneView/captureDealerCode/dsgCaptureDealerCodeModal.html',
            controller: 'dsgCaptureDealerCodeModalController',
            size: 'md',
            backdrop: 'static',
            backdropClass: 'bkg-modal',
            resolve: {
            }
          });
          $rootScope.modal.result.then(function () {
            // on OK behaviour.
          }, function () {
           messagesService.publish('care-dealer-code-submitted', {"type": "dsg"});
            // on Cancel behaviour
           });
      }
    }
    function showCaptureDealerCodeErrorModal() {
      $rootScope.modal = $modal.open({
        templateUrl: 'scripts/modules/oneView/captureDealerCode/captureDealerCodeErrorModal.html',
        controller: ['$scope', function ($scope) {
          $scope.cancel = function () {
            $rootScope.modal.dismiss('cancel');
            $rootScope.modal = null;
          };
        }],
        size: 'md',
        backdrop: 'static',
        backdropClass: 'bkg-modal',
        resolve: {
        }
      });
      $rootScope.modal.result.then(function () {

      }, function () {

       });
    }
    /**
     * Call backend to retrieve dealer code if profile exist
     * @param userId
     */
    function retrieveDealerCode() {
        var userId = '';
        var dealerCodeData = '';
        if($rootScope.userInfo) {
           userId = $rootScope.userInfo.careInfo.lanId;
           dealerCodeData = $rootScope.userInfo.careInfo.dealerCode;
        }
          ajax.getUserPreference(userId).then(

             function (data) {
                if (data && Object.keys(data).length > 0 && _.some(data.userPreference, {"name": "dealerCode"})) {
                   var userPreferenceObject  = _.find(data.userPreference, function(obj) {
                            return obj.name === 'dealerCode';
                   });
                   if (userPreferenceObject.value) {
                   // getting stored and behalf of dealer code on page Load only
                      if(dealerCodeData !== '' && dealerCodeData !== userPreferenceObject.value) {
                        service.setStoredDealerCode(userPreferenceObject.value);
                        setIsDealerCodeExist(true);
                        //Message Service to update dealer code in rep header ON Load
                        messagesService.publish('dealer-code-update-on-header', userPreferenceObject.value);
                        messagesService.publish('care-dealer-code-submitted', {"sessionDealerCode":dealerCodeData});
                      } else {
                           ajax.saveDealerCode(userPreferenceObject.value).then(
                              function (data) {
                                  service.setStoredDealerCode(userPreferenceObject.value);
                                setIsDealerCodeExist(true);
                                  //Message Service to update dealer code in rep header
                                  messagesService.publish('dealer-code-update-on-header', userPreferenceObject.value);
                                  messagesService.publish('care-dealer-code-submitted');
                              }, function (error) {
                                  messagesService.publish('care-dealer-code-submitted');
                              }
                          );
                      }
                   } else {
                   // open captureDealerCode modal
                       if(dealerCodeData === '') {
                        service.showCaptureDealerCodeModal();
                       } else {
                       // getting on behalf of dealer code on page Load only
                         setIsDealerCodeExist(true);
                          messagesService.publish('dealer-code-update-on-header', 'nocode');
                          messagesService.publish('care-dealer-code-submitted', {"sessionDealerCode":dealerCodeData});
                       }
                   }
                } else {
                  // open captureDealerCode modal
                     if(dealerCodeData === '') {
                      service.showCaptureDealerCodeModal();
                     } else {
                     // getting on behalf of dealer code on page Load only
                       setIsDealerCodeExist(true);
                         messagesService.publish('dealer-code-update-on-header', 'nocode');
                         messagesService.publish('care-dealer-code-submitted', {"sessionDealerCode":dealerCodeData});
                     }
                }
              }, function (error) {
                messagesService.publish('care-dealer-code-submitted');
             });
    }

    /**
     * Call backend to check is dealer profile exist
     * @param dealerCode
     */

    function submit(dealerCodeValue) {
        var deferred = $q.defer();
        // call getDealerProfile call to check dealer profile exist or not
        ajax.getDealerProfile(dealerCodeValue).then(
            function (data) {
                if(data && data.success) {
                updateUserPreferenceTable(dealerCodeValue);
                } else {
                deferred.reject(false);
                }
            }, function (error) {
                 deferred.reject(error);
           }
       );
       function updateUserPreferenceTable(dealerCodeValue) {
            var userId = '';
            if($rootScope.userInfo) {
               userId = $rootScope.userInfo.careInfo.lanId;
            }
            var userType = $rootScope.userType;
            var userPreferenceName = 'dealerCode';
            var userPreferenceValue = dealerCodeValue;
            ajax.updateUserPreference(userId, userType, userPreferenceName, userPreferenceValue).then(
                function (data) {
                    ajax.saveDealerCode(dealerCodeValue).then(
                        function (data) {
                          setIsDealerCodeExist(true);
                            service.setStoredDealerCode(dealerCodeValue);
                            messagesService.publish('dealer-code-update-on-header', dealerCodeValue);
                            deferred.resolve();
                        }, function (error) {
                             deferred.reject(error);
                        }
                    );
                }, function (error) {
                    deferred.reject(error);
                }
            );
       }
       return deferred.promise;
    }

    function submitToSessionTable (dealerCodeValue) {
        var deferred = $q.defer();
        // call getDealerProfile call to check dealer profile exist or not
        ajax.getDealerProfile(dealerCodeValue).then(
            function (data) {
                if(data && data.success) {
                ajax.saveDealerCode(dealerCodeValue).then(
                    function (data) {
                      setIsDealerCodeExist(true);
                        deferred.resolve();
                    }, function (error) {
                        deferred.reject(error);
                   }
                );
                } else {
                deferred.reject(false);
                }
            }, function (error) {
                 deferred.reject(error);
           }
       );
       return deferred.promise;
    }
  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('dsgCaptureDealerCodeModalController', DsgCaptureDealerCodeModalController);

  DsgCaptureDealerCodeModalController.$inject = ['$scope',
    '$modalInstance',
    '$translate',
    '$rootScope',
    'ute.blocks.language.switcher',
    'sessionStorage',
    'captureDealerCodeService',
    'ute.blocks.messages.bus.service'];

  /* @ngInject */
  function DsgCaptureDealerCodeModalController($scope,
                                               $modalInstance,
                                               $translate,
                                               $rootScope,
                                               languageSwitcher,
                                               sessionStorage,
                                               captureDealerCodeService,
                                               messagesService) {

       $scope.dealerCode = '';
       $scope.dealerCodePlaceholder = $translate.instant('dealer-code_enter');
       $scope.lang = languageSwitcher.getCurrentLanguage();



       $scope.onDealerCodeInputChange = function() {
           $scope.isDealerCodeError = false;
           $scope.isDealerCodeSuccess = false;
       };

       $scope.submit = function() {
           captureDealerCodeService.submitToSessionTable($scope.dealerCode).then(
               function () {
                 messagesService.publish('care-dealer-code-submitted', {"type": "dsg", "dsgDealerCode":$scope.dealerCode});
                 $modalInstance.close('ok');
               },
               function (isDCExist) {
                 if(!isDCExist) {
                 $scope.isDealerCodeError = true;
                 } else {
                       messagesService.publish('care-dealer-code-submitted', {"type": "dsg"});
                       $modalInstance.close('ok');
                       captureDealerCodeService.showCaptureDealerCodeErrorModal();
                 }
           });
       };

       $scope.cancel = function () {
          $modalInstance.dismiss('cancel');
          $rootScope.modal = null;
       };

       $scope.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');

       var rootwatch1 = $rootScope.$watch('ao.allAccounts', function (newValue, oldValue) {
          if($rootScope.ao && $rootScope.ao.allAccounts) {
              var selectedAccount = $rootScope.ao.allAccounts[0];
              $scope.customerName = selectedAccount.accountName.firstName + ' ' + selectedAccount.accountName.lastName;
              $scope.customerType = $translate.instant('accType_'+ selectedAccount.accountType.toLowerCase());
          }
       });

      //n Remove any watchers 
      $scope.$on('$destroy', function () {
        rootwatch1();
      });
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:onBehalfOfDealerCodeController
   * @description
   * # onBehalfOfDealerCodeController
   * Controller of the totesApp
   */

  angular.module('totesApp').controller('onBehalfOfDealerCodeController', OnBehalfOfDealerCodeController);

  OnBehalfOfDealerCodeController.$inject = ['$scope',
    'ajax',
    'appState',
    '$translate',
    '$rootScope',
    'captureDealerCodeService',
    'ute.blocks.messages.bus.service',
    'ute.common.permissions.service',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function OnBehalfOfDealerCodeController($scope,
                                          ajax,
                                          appState,
                                          $translate,
                                          $rootScope,
                                          captureDealerCodeService,
                                          messagesService,
                                          permissionsService,
                                          languageSwitcher) {

   // Bootstrap Modals - http://angular-ui.github.io/bootstrap/#/modal
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.behalfDealerCode = '';
    $scope.isBehalfOfDealerCode = false;
    $scope.isDealerCodeModalEntered = false;
    $scope.isDealerCodeSubmitted = false;
    $scope.isDSGDealerCode = false;
    $scope.isDealerCodeError = false;

  $scope.submitBehalfDealerCode = function() {
     captureDealerCodeService.submitToSessionTable($scope.behalfDealerCode).then(
        function () {
             $scope.isBehalfOfDealerCode = true;
        },
        function (isDCExist) {
          if(!isDCExist) {
          $scope.isDealerCodeError = true;
          } else {
                captureDealerCodeService.showCaptureDealerCodeErrorModal();
          }
        });
  };

  $scope.edit = function() {
     $scope.isBehalfOfDealerCode = false;
  };

  languageSwitcher.registerOnDataChangeHandler(function (lang) {
    $scope.dealerCodePlaceholder = $translate.instant('dealer-code');
    $scope.lang = lang;
  }, 'behalfDealerControllerLangSub');

  $scope.$on('$destroy', function() {
    languageSwitcher.unregisterOnDataChangeHandler('behalfDealerControllerLangSub');
  });

  $scope.useMyCode = function() {
    var storedDealerCode = captureDealerCodeService.getStoredDealerCode();
    if(storedDealerCode && storedDealerCode !== '') {
        ajax.saveDealerCode(storedDealerCode).then(
            function (data) {
               $scope.isBehalfOfDealerCode = false;
               $scope.behalfDealerCode = '';
               $scope.isDealerCodeSubmitted = false;
            }, function (error) {
                captureDealerCodeService.showCaptureDealerCodeErrorModal();
           }
        );
    }
  };

  $scope.enableSubmitButton = function() {
    $scope.isDealerCodeSubmitted = false;
    $scope.isDealerCodeError = false;
  };
  messagesService.register('care-dealer-code-submitted', function (event, data) {
    $scope.isDealerCodeModalEntered = true;
       if(data && data.type === 'dsg') {
            if(appState.isDealerCodeExist) {
                $scope.isBehalfOfDealerCode = true;
                $scope.behalfDealerCode = data.dsgDealerCode;
            }
            $scope.isDSGDealerCode = true;
       } else {
          $scope.isBehalfOfDealerCode = false;
          $scope.behalfDealerCode = '';
          if(appState.isDealerCodeExist) {
            if(data && data.sessionDealerCode) {
                 $scope.isBehalfOfDealerCode = true;
                 $scope.behalfDealerCode = data.sessionDealerCode;
             }
            $scope.isDealerCodeSubmitted = true;
          } else {
            messagesService.publish('dealer-code-update-on-header', 'nocode');
          }
       }
    $scope.dealerCodePlaceholder = $translate.instant('dealer-code');
  });

  //Capture Dealer code start
  if ($rootScope.isCare) {
    permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
      .then(function (agentPermission) {
        if (agentPermission) {
          captureDealerCodeService.retrieveDealerCode();
        } else {
          $scope.isDealerCodeModalEntered = false;
        }
      });
    permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.mandatory)
      .then(function (agentPermission) {
        if (agentPermission) {
          captureDealerCodeService.showDsgCaptureDealerCodeModal();
        } else {
          $scope.isDealerCodeModalEntered = false;
        }
      });
  }

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').directive('dealerCodeOnBehalf', dealerCodeOnBehalf);

  dealerCodeOnBehalf.$inject = ['$log', 'appState'];

  /* @ngInject */
  function dealerCodeOnBehalf($log, appState) {
    return {
      restrict: 'E',
      templateUrl: 'scripts/modules/oneView/captureDealerCode/onBehalfOfdealerCode.html',
      replace: true,
      controller: 'onBehalfOfDealerCodeController',
      controllerAs: 'obofDC',
      bindToController: true
    };

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('proceedWithoutDealerCodeModalController', ProceedWithoutDealerCodeModalController);

  ProceedWithoutDealerCodeModalController.$inject = ['$scope', '$modalInstance', '$rootScope', 'ute.blocks.language.switcher', 'captureDealerCodeService', 'ute.blocks.messages.bus.service'];

  /* @ngInject */
  function ProceedWithoutDealerCodeModalController($scope, $modalInstance, $rootScope, languageSwitcher, captureDealerCodeService, messagesService) {

    $scope.dealerCode = '';
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.submit = function() {
      captureDealerCodeService.submit($scope.dealerCode).then(
        function () {
         $scope.isDealerCodeSuccess = true;
         $modalInstance.close('ok');
        },
        function (isDCExist) {
          if(!isDCExist) {
                $scope.isDealerCodeError = true;
          } else {
                $modalInstance.close('ok');
                captureDealerCodeService.showCaptureDealerCodeErrorModal();
          }
        });
    };

    $scope.cancel = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
    };
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('consumerAccountStatusDetails', consumerAccountStatusDetails);

  consumerAccountStatusDetails.$inject = [];

  /* @ngInject */
  function consumerAccountStatusDetails($log) {
    return {
      templateUrl: 'scripts/modules/oneView/consumerAccountStatusDetails/consumerAccountStatusDetails.html',
      scope: {},
      restrict: 'EA',
      controller: '',
      controllerAs: '',
      bindToController: true
    };

  }
})();

/* jshint -W106 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:consumerDetailsController
   * @description
   * # consumerDetailsController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrConsumerDetailsControllerOLD', consumerDetailsControllerOLD);

  consumerDetailsControllerOLD.$inject = ['$scope',
    '$rootScope',
    '$log',
    '$http',
    'localStorage',
    'myrAccountListService',
    'myrCustomerInfoService',
    'util',
    '$translate',
    'sessionStorage',
    'deeplink',
    'appState',
    'btnSettings',
    '$window',
    'myrAccountUnlockService',
    'ute.common.permissions.service',
    'ute.common.user.service',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function consumerDetailsControllerOLD($scope, // jshint ignore:line
                                     $rootScope,
                                     $log,
                                     $http,
                                     localStorage,
                                     myrAccountListService,
                                     myrCustomerInfoService,
                                     util,
                                     $translate,
                                     sessionStorage,
                                     deeplink,
                                     appState,
                                     btnSettings,
                                     $window,
                                     myrAccountUnlockService,
                                     permissionsService,
                                     userService,
                                     languageSwitcher) {
    var vm = this; // jshint ignore:line
    $scope.$extend({});
    $scope.aus = myrAccountUnlockService;
    vm.loadingDataIndicator = true;
    vm.isConsumerBriefInfoReady = false;
    vm.customerInfo = null;
    vm.accountLockStatus = $scope.aus.getAccountLockStatus;
    vm.accountLocked = false;
    vm.als = myrAccountListService;
    vm.cis = myrCustomerInfoService;
    //vm.lng = languageSwitcher.getCurrentLanguage();

    if (userService.isSigned()) {
      getAccountList();
    }

    function updateAccountLockStatus() {
      $scope.aus.selectedAccount = vm.selectedAccount;
      $scope.aus.isAccountLocked(vm.selectedAccount).then(function(data){
        vm.accountLocked = data;
      });
    }

    function getAccountList() {
      var cacheFailSafe = true;
      var accountListResponse = function (_tmp) { // jshint ignore:line
        if (_tmp) {
          if (_tmp.cachedResultInfo) {
            if (_tmp.cachedResultInfo.expired && cacheFailSafe) {
              cacheFailSafe = false;
              request.refresh = true;
              if (_tmp.accountList.length > 0) {
                // var dataToProcess = JSON.parse(JSON.stringify(_tmp));
                processGetAccountList(_tmp);
                vm.als.accountListRaw = _.clone(_tmp);
              }
              //vm.loadingDataIndicator = true;
              vm.als.getAccountList(request, accountListResponse, accountListError);
            }
          }
          if ($rootScope.ao.allAccounts) {
            vm.selectedAccount = $rootScope.ao.allAccounts[0].accountNumber;
          }

          updateAccountLockStatus();

          updateConsumerDetails();
          getCustomerInfo();

          if (vm.als.accountListRaw) {
            vm.als.accountListRaw.cachedResultInfo = {};
          }
          _tmp.cachedResultInfo = {};
          //updateConsumerDetails();
          if (!vm.als.accountListRaw || (vm.als.accountListRaw && (!_.isEqual(_tmp, vm.als.accountListRaw)))) {
            processGetAccountList(_tmp);
          }
        }
      };
      var accountListError = function () {
        //vm.loadingDataIndicator = false;
      };
      var request = {
        refresh: false,
        applicationId: 'Rogers.com'
      };
      vm.als.getAccountList(request, accountListResponse, accountListError);
    }

    function processGetAccountList(_tmp) { // jshint ignore:line
      if (_tmp.result === 'success') {
        // all these are not needed
        // for (var i = 0; i < _tmp.accountList.length; i++) {
        //   var tmp = {};
        //   tmp = _tmp.accountList[i];
        //   _tmp.accountList[i].accountStatusSimple = vm.als.getAccountStatus(tmp).accountStatusSimple;
        //   _tmp.accountList[i].nickName = _tmp.accountList[i].nickname;
        //   _tmp.accountList[i].displayName = _tmp.accountList[i].nickName ? _tmp.accountList[i].nickName : _tmp.accountList[i].accountNumber;
        //
        //   _tmp.accountList[i].comboDisplay = (_tmp.accountList[i].nickName || _tmp.accountList[i].nickName) ? (_tmp.accountList[i].nickName ||
        //   _tmp.accountList[i].nickName) + ' - ' + _tmp.accountList[i].accountNumber : _tmp.accountList[i].accountNumber;
        //
        //   _tmp.accountList[i].accNo = _tmp.accountList[i].accountNumber;
        // }
        //display the linked success banner for the very first account
        //vm.als.accountTypes = _tmp.accountList;

        var reqIndex = 0;
        var accLocalSelected;

        if (vm.als.accountTypes.length > 1 && ($rootScope.ao.accountActiveIndex === null || $rootScope.ao.accountActiveIndex === undefined)) {
          // Check local storage if account was selected in past
          accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
          if ($rootScope.isCare) {
            accLocalSelected = sessionStorage.getSessionStorageValue('accountNumber');
          }
          if (accLocalSelected) {
            // Update selected index
            appState.aoUpdateActiveObjects(accLocalSelected);
            reqIndex = $rootScope.ao.accountActiveIndex;

            if (deeplink.data.direction !== 'out') {
              // Show the popup / first time entry
              if (appState.isFirstLoad) {
                appState.tagging(['_trackLink', {event35: ''}]);
                $rootScope.firstLoad = 1;
                $rootScope.popUpOpened = true;
                $rootScope.popUpOpenedAndClosed = false;

                //openSelectAccount('');
                appState.isFirstLoad = false;

              }
            }
          }
        } else if (vm.als.accountTypes.length > 1) {
          accLocalSelected = localStorage.getLocalStorageValue('accountNumber');
          if ($rootScope.isCare) {
            accLocalSelected = sessionStorage.getSessionStorageValue('accountNumber');
          }
          if (accLocalSelected) {
            // Part of MYR-1123 fix, this directly returns the index from appState and updates vm.als object / service
            var actIndex = appState.aoUpdateActiveObjects(accLocalSelected);
            vm.als.updateSelectedAccount(actIndex);
            reqIndex = vm.als.selectedIndex;
          } else {
            reqIndex = vm.als.selectedIndex;
          }
        }

        if (vm.als.accountTypes.length === 1) {
          if (appState.isFirstLoad) {
            $rootScope.firstLoad = 1;
            appState.isFirstLoad = false;
            appState.tagging(['_trackLink', {event35: ''}]);
          }
        }

        // Update selection and store it into a cookie
        vm.als.updateSelectedAccount(reqIndex);
        $rootScope.ao.accountActive = vm.als.selectedAccount;

        try {
          appState.tagging(['_trackLink', {event17: ''}]);
        } catch (e) {
          $log.error('Exception catch during tagging on vm.als.selectedAccount.accountNumber with message:', e.message);
        }

        vm.als.btnSettings = btnSettings.getSettings($rootScope.ao.accountActive.accountStatus);
        vm.als.btnStatus = $window.btnStatus;

        localStorage.setLocalStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
        localStorage.setLocalStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        if ($rootScope.isCare) {
          sessionStorage.setSessionStorageValue('accountNumber', vm.als.selectedAccount.accountNumber);
          sessionStorage.setSessionStorageValue('accountTypeNumber', vm.als.selectedAccount.accountTypeNumber);
        }
        appState.aoUpdateIndexes(vm.als.selectedAccount.accountNumber);

        // load default profile
        var modalSelected = localStorage.getLocalStorageValue('accountNumber');
        if ($rootScope.isCare) {
          modalSelected = sessionStorage.getSessionStorageValue('accountNumber');
        }
        appState.aoUpdateActiveObjects(modalSelected);

        // From updated rootScope proceed to update of the page
        vm.als.selectedAccount = vm.als.accountTypes[reqIndex];

        updateConsumerDetails();

        return vm.als.accountTypes;

      } else {
        if (_tmp.result === 'redirect') {
          appState.noLinking = false;
          if ($rootScope.isConsumer) {
            appState.switchView('guestoverview');
          } else {
            appState.switchView('/oneViewInterface');
          }
        }
      }
    }

    function getCustomerInfo() {
      var request = {
        accountNumber: vm.selectedAccount
      };
      if ($rootScope.isCare) {
        request.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      }
      var customerInfoResponse = function (data) {
        vm.customerInfo = data;
        getResourceFile();
        vm.isC_LimitDisplay = !((vm.customerInfo.creditLimit === '0.0') || (typeof vm.customerInfo.creditLimit === 'undefined'));// jscs:ignore
      };
      var customerInfoError = function () {
        vm.loadingDataIndicator = false;
        vm.customerInfoFailure = true;
      };

      $http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/interaction/interactionHistoryConfig.json', {cache: false}).then(function (response) {
          $scope.isInteractionHistorySwitchEnabled = response.data.isInteractionHistorySwitchEnabled;
          if ($scope.isInteractionHistorySwitchEnabled) {
            vm.cis.getCustomerInfo(request, customerInfoResponse, customerInfoError);
          } else {
            vm.loadingDataIndicator = false;
            vm.customerInfoFailure = true;
          }
        },
        function (error) {
          vm.cis.getCustomerInfo(request, customerInfoResponse, customerInfoError);
        });
    }

    function getResourceFile() {
      updateConsumerOverLayDetails();
    }

    function updateCustomerType() {
      // maintain the global accountType as it is overridden by accountTypeNumber
      // Need to review why accountType is getting overridden with accountTypeNumber
      if ($rootScope.ao.allAccounts) {
        if ($rootScope.accountType === undefined || $rootScope.accountType === '') {
          $rootScope.accountType = $rootScope.ao.allAccounts[0].accountType;
        }
        if ($rootScope.ao.allAccounts[0].accountTypeNumber === 9) {
          $rootScope.accountType = $translate.instant('one_view_pay_as_you_go');
        }
        vm.accountType = getResourceString('accType', $rootScope.accountType);
      }

    }

    function getResourceString(prefix, key) {
      var modifiedKey;
      if (key) {
        modifiedKey = key.toLowerCase();
        modifiedKey = modifiedKey.replace(/\s+/g, '-');
      }
      var keyWithPrefix = prefix + '_' + modifiedKey;
      var resourceValue = $translate.instant(keyWithPrefix);
      if (resourceValue) {
        return resourceValue;
      } else {
        return key;
      }
    }

    function updateConsumerDetails() {
      if ($rootScope.ao.allAccounts) {
        vm.isConsumerBriefInfoReady = true;
        vm.accountDetails = $rootScope.ao.allAccounts[0];
        updateCustomerType();
        vm.fullName = vm.accountDetails.accountName.firstName + ' ' + vm.accountDetails.accountName.lastName;
        vm.isCable = vm.accountDetails.accountNumber.length === 12;
        if (!$rootScope.isConsumer) {
          $window.document.title = vm.accountDetails.accountNumber + ' - ' + vm.fullName;
        }
      }
    }

    function updateConsumerOverLayDetails() {
      if (vm.customerInfo) {
        vm.loadingDataIndicator = false;
        //updateCustomerType();
        //vm.accountType = getResourceString('accType',$rootScope.accountType);
        vm.accountSubType = getResourceString('accSubType', vm.customerInfo.accountSubType);
        vm.accountStatus = getResourceString('accStatus', vm.customerInfo.accountStatus);
        var date = moment(vm.customerInfo.accountEffectiveDate); // jshint ignore:line
        $scope.monthsNames = util.getMonthsNames();
        var month = $scope.monthsNames[date.month()];
        vm.accountEffectiveDate = util.getDateByDate(vm.customerInfo.accountEffectiveDate, month);
        if (vm.customerInfo.creditClass) {
          vm.isCreditClass = vm.customerInfo.creditClass.length > 0;
        }
      }
    }

    languageSwitcher.registerOnDataChangeHandler(function () {
      getResourceFile();
      updateCustomerType();
    }, 'consumerDetailsControllerLangSub');

    $scope.$on('$destroy', function () {
      languageSwitcher.unregisterOnDataChangeHandler('consumerDetailsControllerLangSub');
    });

    function getWeatherInformation() {
      var data = $rootScope.ao.accountDetails;
      if (data && data.billingAddress) {
        $scope.addressUnavailable = false;
        vm.customerAddress = {
          'streetAddress': (data.billingAddress.unit ? data.billingAddress.unit + '-' : '') + data.billingAddress.streetNumber + ' ' + data.billingAddress.streetName,
          'province': data.billingAddress.province,
          'city': data.billingAddress.city,
          'postalCode': data.billingAddress.postalCode
        };
        vm.customerAddressOneLine = (vm.customerAddress.streetAddress + ' ' + vm.customerAddress.city + ' - ').toLowerCase() + vm.customerAddress.province + ' ' + vm.customerAddress.postalCode;
      }
    }
    $rootScope.$watch('ao.accountDetails', function (newVal, oldVal) {
      if ($rootScope.isCare || $rootScope.isDealer) {
        if (newVal) {
          if (!oldVal) {
            getWeatherInformation();
          } else if (oldVal && newVal.billingAddress.city !== oldVal.billingAddress.city) {
            getWeatherInformation();
          }
        }
      }
    });


  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('consumerDetailsOLD', consumerDetailsOLD);

  consumerDetailsOLD.$inject = ['$window'];

  /* @ngInject */
  function consumerDetailsOLD($window) {
    return {
      scope: {},
      templateUrl: 'scripts/modules/oneView/consumerDetails/consumerDetails.html',
      restrict: 'EA',
      controller: 'MyrConsumerDetailsController',
      controllerAs: 'al',
      bindToController: true,
      link: linkFunc
    };
    function linkFunc(scope, element, attrs) {
      var mq = '(max-width:767px)';
      /*$('body').on('click', '.page-one-view-dashboard', function(e) {
       if(element.find('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
       element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
       // $('.consumer-details-collapsible').removeClass('show');
       //consumer-details-collapsible-expanded
       element.find('.consumer-details-collapsible').hide();
       }
       });*/
      element=$(element);
      $('html').click(function () {
        if (element.find('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
          element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
          // $('.consumer-details-collapsible').removeClass('show');
          //consumer-details-collapsible-expanded
          element.find('.consumer-details-collapsible').hide();
        }
      });
      /*scope.$watch(function () {
        if ($window.matchMedia(mq).matches) {

        } else {
*//*          element.find('.directive-oneview-consumer-details').mouseenter(function () {

            //scope.getConsumerDetails(); commented for CSS hover implemntation
          });*//*
          element.find('.directive-oneview-consumer-details').click(function (e) {
            e.stopPropagation();
            scope.getConsumerDetails();
          });
*//*          element.find('.directive-oneview-consumer-details').mouseleave(function () {
            //scope.closeConsumerDetails(); commented for CSS hover implemntation
          });*//*
        }
      });*/
      scope.getConsumerDetails = function () {
        if (!$('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
          $('.directive-oneview-consumer-details').addClass('consumer-details-expanded');
          //$('.consumer-details-collapsible').addClass('show');
          $('.consumer-details-collapsible').show();
        }
        if (!$window.matchMedia(mq).matches) {
          $('body').on('click', 'body', function (e) {
            if ($('.directive-oneview-consumer-details').hasClass('consumer-details-expanded')) {
              $('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
              // $('.consumer-details-collapsible').removeClass('show');
              //consumer-details-collapsible-expanded
              $('.consumer-details-collapsible').hide();
            }
          });
        }
      };
      scope.closeConsumerDetails = function () {
        element.find('.directive-oneview-consumer-details').removeClass('consumer-details-expanded');
        // element.find('.consumer-details-collapsible').removeClass('show');
        element.find('.consumer-details-collapsible').hide();
        if ($window.matchMedia(mq).matches) {
          //element.find('.show-more-container').removeClass('hide');
          element.find('.show-more-container').show();
          element.find('.show-more-container').addClass('visible-xs');
          element.find('.show-less-container').hide();
        }
      };
      scope.getConsumerDetailsForMobile = function () {
        //element.find('.consumer-details-collapsible').addClass('show');
        element.find('.consumer-details-collapsible').show();
        if ($window.matchMedia(mq).matches) {
          //element.find('.show-more-container').addClass('hide');
          element.find('.show-more-container').hide();
          element.find('.show-more-container').removeClass('visible-xs');
          element.find('.show-less-container').show();
        }
      };
    }
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrCustomerInfoService
   * @description
   * # myrCustomerInfoService
   */
  angular.module('totesApp').factory('myrCustomerInfoServiceOLD', customerInfoServiceOLD);

  customerInfoServiceOLD.$inject = ['ajax'];

  function customerInfoServiceOLD(ajax) {

    var service = {
      customerInfo:null,
      getCustomerInfo:getCustomerInfo

    };

    return service;


    function getCustomerInfo (request, successCallback, errorCallback) {
      try {
        /*var postData = {
        accountNumber: $rootScope.ao.accountActive.accountNumber
        };*/
        ajax.getCustomerInfo(request).then(
        function (data) {
          return successCallback(data);
        },
        function (error) {
          return errorCallback();
        }
        );
      }catch (err) {

      }
      //return vm.customerInfo;
    }



  }

}());

(function () {
  'use strict';

  angular.module('totesApp').directive('repInteraction', interaction);

  interaction.$inject = ['ajax'];
  /* @ngInject */
  function interaction(ajax) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'scripts/modules/oneView/interaction/interaction.html',
      scope: {},
      link: linkFunc,
      replace: 'false',
      controller: 'MyrInteractionHistoryController',
      controllerAs: 'in',
      bindToController: true
    };

    function linkFunc(scope, element, attrs) {

    }

    return directive;
  }
})();

/**
 * Created by m.palanisamy1 on 3/21/2016.
 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';
  /**
   * @name totesApp.controller:MyrInteractionHistoryController
   * @description
   * # MyrInteractionHistoryController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrInteractionHistoryController', interactionController);

  interactionController.$inject = ['$scope',
    '$rootScope',
    '$http',
    'ajax',
    'appState',
    'ute.blocks.language.switcher',
    'myrAccountListService',
    'util',
    'sessionStorage',
    '$filter',
    'settings',
    'ute.common.permissions.service',
    '$stateParams',
    'ute.rogers.account.overview.factory'];

  /* @ngInject */
  function interactionController($scope,
                                 $rootScope,
                                 $http,
                                 ajax,
                                 appState,
                                 languageSwitcher,
                                 myrAccountListService,
                                 util,
                                 sessionStorage,
                                 $filter,
                                 settings,
                                 permissionsService,
                                 $stateParams,
                                 newAccountOverviewFactory) {

    $scope.$extend({});
    var lng = languageSwitcher.getCurrentLanguage();
    $rootScope.interactionAndCaseListLength = 0;
    $scope.interactionAndCaseListResponse = [];
    $scope.interactionAndCaseList = [];
    $scope.interactionNotAvailable = false;
    $scope.errorInRetrieving = false;
    $scope.loading = true;
    $scope.limitCount = 4;
    $scope.currentPage = 1;
    $scope.topics = [];
    $scope.totalItems = [];
    $scope.totalItems.length = 0;
    $scope.typeaheadItems = [];
    $scope.lang = lng.toUpperCase();
    $scope.myrAccountListService = myrAccountListService;
    $scope.isCaseAvailable = false;
    $scope.notesLength = 80;
    $scope.interaction_ticket = 'TICKET';// jscs:ignore
    $scope.modifiedDate = '';
    $scope.saveDropDownOption = '';
    $scope.noPermission = false;
    $scope.repInteractionRead = false;

    function getInteractionAndCaseResponse() {
      $scope.isInteractionHistorySwitchEnabled = false;
      $http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/interaction/interactionHistoryConfig.json', {cache: false}).then(function (response) {
          var selectedAccount;
          $scope.isInteractionHistorySwitchEnabled = response.data.isInteractionHistorySwitchEnabled;
          if ($scope.isInteractionHistorySwitchEnabled && $rootScope.isCare && $scope.repInteractionRead) {
            selectedAccount = sessionStorage.getSessionStorageValue('accountNumber');
            getInteraction(selectedAccount);
          } else if ($scope.isInteractionHistorySwitchEnabled && $rootScope.isDealer && $scope.repInteractionRead) {
            newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewDataHandler, 'MyrInteractionHistoryController');
            getAccountOverview();
          } else {
            $scope.loading = false;
            $scope.interactionNotAvailable = true;
            $scope.noPermission = true;
          }
        },
        function (error) {
          var selectedAccount;
          if ($rootScope.isCare && $scope.repInteractionRead) {
            selectedAccount = sessionStorage.getSessionStorageValue('accountNumber');
            getInteraction(selectedAccount);
          } else if ($rootScope.isDealer && $scope.repInteractionRead) {
            newAccountOverviewFactory().registerOnDataChangeHandler(accountOverviewDataHandler, 'MyrInteractionHistoryController');
            getAccountOverview();
          } else {
            $scope.loading = false;
            $scope.interactionNotAvailable = true;
            $scope.noPermission = true;
          }
        });
    }

    function getInteraction(selectedAccount) {
      ajax.getInteraction(selectedAccount, $scope.lang).then(
        function (response) {
          $scope.loading = false;
          $scope.interactionAndCaseList = response;
          $scope.interactionAndCaseListResponse = response;
          $rootScope.interactionAndCaseListLength = $scope.interactionAndCaseList.length;
          $scope.setLimitCount();
          $scope.getTopics(response);
          $scope.modifyDate();
          if (response.length === 0) {
            $scope.interactionNotAvailable = true;
            $scope.errorInRetrieving = true;
          }
        }, function (error) {
          $scope.loading = false;
          $scope.interactionNotAvailable = true;
          $scope.errorInRetrieving = true;
        });
    }

    function accountOverviewDataHandler(accountOverview) {
      if (accountOverview) {
        getInteraction(String(accountOverview.getSelectedAccount().accountNumber));
      }
      return null;
    }

    function getAccountOverview() {
      return newAccountOverviewFactory().getAccountOverview().then(accountOverviewDataHandler)["catch"](function (reason) {
        return console.log("MyrInteractionHistoryController->getAccountOverview->catch:", reason),
          null
      })
    }

    var scopewatch1 = $scope.$watchGroup(['currentPage', 'totalItems.length'], function (newVal, oldVal) {
      if (oldVal || newVal) {
        angular.element('.pagination-page a').text($scope.currentPage + ' / ' + $scope.numPages);
      }
    });

    var scopewatch2 = $scope.$watch('searchTagDropdown', function (newVal, oldVal) {
      if (oldVal || newVal) {
        $scope.currentPage = 1;
      }
    });

    $scope.setSearch = function (searchKey) {
      $scope.currentPage = 1;
      if (searchKey != null && searchKey != undefined && searchKey.trim().length > 0) {
        $scope.searchTagField = searchKey;
      }
      else {
        $scope.searchHint = searchKey;
        $scope.searchTagField = ' ';
      }
    };

    $scope.setLimitCount = function () {
      if ($scope.interactionAndCaseList.length < 4) {
        $scope.limitCount = $scope.interactionAndCaseList.length;
      } else {
        $scope.limitCount = 4;
      }

      if ($scope.interactionAndCaseList.length === 0) {
        $scope.interactionNotAvailable = true;
        $scope.errorInRetrieving = true;
      }
    };
    $scope.getDate = function (itemTimeStamp) {
      if (lng === 'fr') {
        moment.locale('fr');
      } else {
        moment.locale('en');
      }      
      var date = moment(itemTimeStamp);
      var days = moment(new Date());
      var dateForDisplay = '';
      var diffInDays = days.diff(date, 'days');
      if((lng === 'fr') && ((diffInDays >= 0) && (diffInDays < 7))){
        return util.getSevenDaysAgoInFrench(date.fromNow());
      } else if ((diffInDays >= 0) && (diffInDays < 7)) {
        return (date.fromNow());
      } else {
        date = moment(itemTimeStamp);
        $scope.monthsNames = util.getMonthsNames();
        var month = $scope.monthsNames[date.month()];
        dateForDisplay = util.getDateByDate(itemTimeStamp, month);
        return dateForDisplay;
      }
    };
    $scope.getTimeStamp = function (itemTimeStamp) {
      if (lng === 'fr') {
        moment.locale('fr');
      } else {
        moment.locale('en');
      }
      return moment(itemTimeStamp).format('h:mm A');
    };
    $scope.isInteraction = function (type) {
      return type === 'interaction' ? true : false;
    };
    $scope.isCase = function (type) {
      return type === 'ticket' ? true : false;
    };
    $scope.isDays = function (itemTimeStamp) {
      var date = moment(itemTimeStamp);
      var days = moment(new Date());
      var diffInDays = days.diff(date, 'days');
      if ((diffInDays >= 0) && (diffInDays < 7)) {
        return true;
      } else {
        return false;
      }
    };

    $scope.getIcon = function (media, itemType) {
      if ($scope.isCase(itemType)) {
        return 'interaction-case-icon';
      } else {
        var iconCssClass = settings.interactionsIconClassesMap[media.toLowerCase().trim()];
        if (iconCssClass === undefined) {
          return 'interaction-default-icon';
        }
        return iconCssClass;
      }
    };

    function compare(a, b) {
      return new Date(b.itemTimeStamp).getTime() - new Date(a.itemTimeStamp).getTime();
    }

    $scope.getInteractionText = function (i) {
      var topicsLength = 3;
      if (i.topics.length < 3) {
        topicsLength = i.topics.length;
      }
      var interactionText = '';
      for (var j = 0; j < topicsLength; j++) {
        interactionText = interactionText + i.topics[j].callReason1;
        if (j < topicsLength - 1) {
          interactionText = interactionText + ' | ';
        }
      }
      return interactionText;
    };
    $scope.getCaseText = function (i) {
      var caseText = i.caseTypeLevel1 + ' | ' + i.caseTypeLevel2 + ' | ' + i.caseTypeLevel3 + ' | ' + i.status;
      return caseText;
    };

    $scope.searchInteraction = function (setSearchHint) {
      if (setSearchHint != undefined && setSearchHint != null) {
        $scope.searchTag = setSearchHint;
      }
    };
    $scope.getTopics = function (response) {
      $scope.topics = [];
      $scope.topicsTemp = [];
      $scope.isCaseAvailable = false;
      for (var i = 0; i < response.length; i++) {
        if ($scope.isInteraction(response[i].itemType)) {
          for (var j = 0; j < response[i].topics.length; j++) {
            $scope.topicsTemp.push(response[i].topics[j]);
          }
        }
        else if ($scope.isCase(response[i].itemType)) {
          $scope.isCaseAvailable = true;
        }
      }
      $scope.topics = $filter('unique')($scope.topicsTemp, 'callReason1');
      if ($scope.isCaseAvailable) {
        var obj = [];
        obj.callReason1 = 'Ticket';
        $scope.topics.push(obj);
        if ($stateParams.filter) {
          $scope.searchTagDropdown = $stateParams.filter;
        }
      }
    };

    $scope.setCharacter = function (interaction, character, index) {
      if (character === $scope.notesLength) {
        angular.element('.read-more-' + index).show();
        angular.element('.read-less-' + index).hide();
        angular.element('.read-more-less-ellipis-' + index).show();
        angular.element('.read-more-less-fulltext-' + index).hide();

      }
      else {
        angular.element('.read-less-' + index).removeClass('ng-hide');
        angular.element('.read-more-less-fulltext-' + index).removeClass('ng-hide');
        angular.element('.read-more-less-ellipis-' + index).hide();
        angular.element('.read-more-' + index).hide();
        angular.element('.read-less-' + index).show();
        angular.element('.read-more-less-fulltext-' + index).show();
      }
    };
    $scope.redirectToInteraction = function () {
      appState.switchView('interaction');
    };

    $scope.getChannel = function (channel) {
      //remove starting numbers only from the channel string
      return channel.replace(/^[0-9]+/, '');
    };
    $scope.modifyDate = function () {
      for (var i = 0; i < $scope.interactionAndCaseList.length; i++) {
        if ($scope.isCase($scope.interactionAndCaseList[i].itemType)) {
          $scope.modifiedDate = $scope.getDate($scope.interactionAndCaseList[i].itemTimeStamp);
          $scope.interactionAndCaseList[i].ModifiedDate = $scope.modifiedDate;
        }
        else {
          $scope.modifiedDate = $scope.getDate($scope.interactionAndCaseList[i].topics[0].itemTimeStamp);
          $scope.interactionAndCaseList[i].ModifiedDate = $scope.modifiedDate;
        }
      }

    };

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      lng = lang;
      if (lng.toUpperCase() !== $scope.lang) {
        $scope.lang = lng.toUpperCase();
        getInteractionAndCaseResponse();
        $scope.monthsNames = util.getMonthsNames();
        $scope.searchTagDropdown = $scope.saveDropDownOption;
      }
    }, 'interactionHistoryControllerLangSub' + $scope.id);

    $scope.$on('$destroy', function () {
      //languageSwitcher.unregisterOnDataChangeHandler('interactionHistoryControllerLangSub' + $scope.id);
      scopewatch1();
      scopewatch2();
    });

    permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.InteractionHistory, ute.common.permissions.service.RamActionCodes.read)
      .then(function (agentPermission) {
        $scope.repInteractionRead = agentPermission;
        getInteractionAndCaseResponse();
      });

  }
})();

/**
 * Created by m.palanisamy1 on 3/21/2016.
 */
(function () {
  'use strict';

  angular.module('totesApp').directive('interactionHistory', interaction);

  interaction.$inject = ['ajax'];
  /* @ngInject */
  function interaction(ajax) {
    var directive = {
      restrict: 'EA',
      templateUrl: 'scripts/modules/oneView/interaction/interactionHistory.html',
      scope: {
      },
      link: linkFunc,
      replace: 'false',
      controller: 'MyrInteractionHistoryController',
      controllerAs: 'in',
      bindToController: true
    };
    function linkFunc(scope, element, attrs) {
    }
    return directive;
  }
})();

/**
 * Created by m.palanisamy1 on 3/21/2016.
 */
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:interactionHistoryFilter
   * @description
   * # interactionHistoryFilter
   * Controller of the totesApp
   */
  angular.module('totesApp').filter('interactionHistoryFilter', function () {
    return function (interaction, searchTag, scope) {
      var i;
      scope.typeaheadItems = [];
      scope.saveDropDownOption = searchTag;
      if (searchTag === '' || searchTag === null || searchTag === undefined || searchTag.length === 0) {
        for (i = 0; i < interaction.length; i++) {
          if (scope.isCase(interaction[i].itemType)) {
            scope.typeaheadItems.push(interaction[i].caseID);
          } else {
            scope.typeaheadItems.push(scope.getChannel(interaction[i].channel));
            scope.typeaheadItems.push(interaction[i].interactionID);
            scope.typeaheadItems.push(interaction[i].media);
          }
        }
        return interaction;
      }
      else if (searchTag === 'Ticket') {
        var filteredSearchCase = [];
        for (i = 0; i < interaction.length; i++) {
          if (scope.isCase(interaction[i].itemType)) {
            scope.typeaheadItems.push(interaction[i].caseID);
            filteredSearchCase.push(interaction[i]);
          }
        }
        return filteredSearchCase;
      }
      else {
        var filteredSearch = [];
        for (i = 0; i < interaction.length; i++) {
          if (scope.isInteraction(interaction[i].itemType)) {
            for (var j = 0; j < interaction[i].topics.length; j++) {
              if (interaction[i].topics[j].callReason1 == searchTag) {
                scope.typeaheadItems.push(scope.getChannel(interaction[i].channel));
                scope.typeaheadItems.push(interaction[i].interactionID);
                scope.typeaheadItems.push(interaction[i].media);
                filteredSearch.push(interaction[i]);
                break;
              }
            }
          }
        }
        return filteredSearch;
      }
    };
  });

  angular.module('totesApp').filter('interactionPagination', function () {
    return function (interaction, currentPage, scope) {
      scope.totalItems = interaction;
      scope.totalItems.length = interaction.length;
      return interaction.slice((currentPage - 1) * 6, (currentPage) * 6);
    };
  });

  angular.module('totesApp').filter('highlightText', function () {
    return function (interactionText, searchHint) {
      if (interactionText && searchHint != undefined && searchHint != null && searchHint.trim()) {
        var regexp = new RegExp('(' + searchHint + ')', 'ig');
        var highlightText = interactionText.replace(regexp, '<mark>$1</mark>');
        return highlightText;
      }
      return interactionText;
    };
  });

  angular.module('totesApp').filter('characters', function () {
    return function (input, chars, breakOnWord) {
      if (isNaN(chars)) {
        return input;
      }
      if (chars <= 0) {
        return '';
      }
      if (input && input.length > chars) {
        input = input.substring(0, chars);

        if (!breakOnWord) {
          var lastspace = input.lastIndexOf(' ');
          //get last space
          if (lastspace !== -1) {
            input = input.substr(0, lastspace);
          }
        } else {
          while (input.charAt(input.length - 1) === ' ') {
            input = input.substr(0, input.length - 1);
          }
        }
        return input + '...';
      }
      return input;
    };
  });

})();

(function(){

	'use strict';
	angular.module('totesApp').factory('myrAccountUnlockService', myrAccountUnlockService);

	myrAccountUnlockService.$inject = ['ajax', 'sessionStorage', '$rootScope', 'localStorage'];

	function myrAccountUnlockService(ajax, sessionStorage, $rootScope, localStorage) {
		var service = {
			accountLockStatus: false,
			unlockClicked: false,
			selectedAccount: null,
			unlockClick: unlockClick,
			isAccountLocked: isAccountLocked,
      getAccountLockStatus: getAccountLockStatus,
			accountUnlock: accountUnlock
		};
		return service;

    function getAccountLockStatus(){
      return service.accountLockStatus;
    }

    function unlockClick(){
      service.unlockClicked = true;
      return true;
    }

		function isAccountLocked(accountNumber){
		  if ($rootScope.isCare) {
        accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      }
      return ajax.getAccountStatus({accountNumber: accountNumber}).then(function (responseData) {
       if(responseData && responseData.locked && responseData.locked.toLowerCase() === 'true' ){
        service.accountLockStatus = true;
        return service.accountLockStatus;
        } else{
          service.accountLockStatus = false;
          return service.accountLockStatus;
        }
        },
        function (error) {
          service.accountLockStatus = false;
          return service.accountLockStatus;
        });
      }

	  function accountUnlock(){
      var accountNumber = '';
      var accountUnlocked = false;
      if ($rootScope.isCare) {
        accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
      } else if($rootScope.isDealer) {
         accountNumber = service.selectedAccount;
       }
      return ajax.unlockAccount({accountNumber: accountNumber}).then( function (responseData) {
        if(responseData && responseData.unlocked && responseData.unlocked.toLowerCase() === 'true') {
          service.accountLockStatus = false;
          accountUnlocked = true;
          return accountUnlocked;
        } else {
            service.accountLockStatus = true;
            accountUnlocked = false;
            return accountUnlocked;
        }},
        function (error) {
         service.accountLockStatus = true;
         accountUnlocked = false;
         return accountUnlocked;
        });

	 }

	}
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewBanner', oneViewBanner);

  oneViewBanner.$inject = [];

  /* @ngInject */
  function oneViewBanner($log) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewBanner/oneViewBanner.html',
      scope: {
        type:'=',
        message:'='
      },
      restrict: 'EA',
      link: function (scope) {
        scope.success=true;
      }
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyrFraudCheckModalController', fraudCheckModalController);

  fraudCheckModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function fraudCheckModalController($scope, $modalInstance, $rootScope) {

    $scope.ok = function () {
      $modalInstance.close('ok');
      $rootScope.modal = null;
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
      $rootScope.modal = null;
    };
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:oneViewFooterController
   * @description
   * # oneViewFooterController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyOneViewFooterController', oneViewFooterController);

  oneViewFooterController.$inject = ['$scope', '$rootScope', 'localStorage',  '$element', '$browser', 'ute.blocks.language.switcher', 'sessionStorage'];

  /* @ngInject */
  function oneViewFooterController($scope, $rootScope, localStorage, $element, $browser, languageSwitcher, sessionStorage) {
    $scope.$extend({
    });

    $scope.userTypeDealer = $rootScope.isDealer;
    $scope.userTypeCare =  $rootScope.isCare;
    if($rootScope.isDealer || $rootScope.isCare){
        $element.find('#feedback-tab').hide();
        $element.find("#footer a[onclick='javascript:FSR.popFeedback()']").hide();
    }
  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneviewfooter', oneViewFooter);

  oneViewFooter.$inject = ['$rootScope'];

  /* @ngInject */
  function oneViewFooter($rootScope) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewFooter/oneViewFooter.html',
      scope: {},
      restrict: 'A',
      controller: 'MyRepFeedbackController',
      controllerAs: 'rf',
      bindToController: true,
      link: function (scope, element, attrs) {
        // DOM or direct jQuery calls
        //scope.isRepView = $rootScope.isRepView;
      }
    };

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:ommDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('OneViewFraudIndicatorController', oneViewFraudIndicatorController);

  oneViewFraudIndicatorController.$inject = ['$scope', '$rootScope', 'sessionStorage','backend','appState','ute.rogers.account.overview.factory','$location','settings'];

  /* @ngInject */
  function oneViewFraudIndicatorController($scope, $rootScope, sessionStorage,backend,appState,accountOverviewFactory,$location,settings) {
    $scope.$extend({});
    var vm = this;
    vm.showFraudIndicator =false;
    vm.fraudIndicator="N";
    var accountOverviewService = accountOverviewFactory();

    var getFraudIndicator = function () {
      var oneViewStatusCode = $location.search().statusCode;
      var fraudCheckFromStorage =  sessionStorage.getSessionStorageValue('fraud_indicator');
      if (oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck  ||  fraudCheckFromStorage =='Y'  ) {
        vm.fraudIndicator = 'Y';
        sessionStorage.setSessionStorageValue('fraud_indicator','Y');
      }
    // accountOverviewService.getSelectedAccount()
    //         .then(function (selectedAccount) {
    //          vm.fraudIndicator = selectedAccount.fraudIndicator;
    //          console.info("Testing");
    //         });
    };

    var init = function(){
      getFraudIndicator();
    }

    vm.redirectToInteraction = function (evt) {
      //$rootScope.interactionAndCaseListLength = 0;
      if (evt.target.nodeName==="A"){
        evt.preventDefault();
      scrollPageToTop(); // jshint ignore:line
      appState.switchView('interaction');
      }
    };
   
    init();
  }
})();
(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewFraudIndicator', oneViewFraudIndicator);

  oneViewFraudIndicator.$inject = [];

  /* @ngInject */
  function oneViewFraudIndicator($log) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewFraudIndicator/oneViewFraudIndicator.html',
      scope: {},
      restrict: 'EA',
      controller: 'OneViewFraudIndicatorController',
      controllerAs: 'ofi',
      bindToController: true
    };

  }
})();
// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrOneViewHeaderControllerOLD', oneViewHeaderControllerOLD);

  oneViewHeaderControllerOLD.$inject = ['$scope',
    '$rootScope',
    'appState',
    'settings',
    '$translate',
    'sessionStorage',
    'appInterface',
    'ute.common.permissions.service',
    'ute.common.user.service',
    'ute.blocks.messages.bus.service',
    'captureDealerCodeService',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function oneViewHeaderControllerOLD($scope,
                                   $rootScope,
                                   appState,
                                   settings,
                                   $translate,
                                   sessionStorage,
                                   appInterface,
                                   permissionsService,
                                   userService,
                                   messagesService,
                                   captureDealerCodeService,
                                   languageSwitcher) {

    $scope.$extend({});
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.isDealer = $rootScope.isDealer;
    $scope.isCare = $rootScope.isCare;
    $scope.displayAddnoteSection=null;
    $scope.repName = null;
    $scope.userDealerCode = null;
    $scope.isDealerCodeSubmitted = false;
    $scope.displayDealerCodeSection = null;

    messagesService.register('agent-repname', function (event, data) {
      $scope.repName = data;
    });
    if ($scope.isCare) {
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
        if (isPermitted) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
            .then(function (agentPermission) {
              $scope.displayDealerCodeSection = agentPermission;
          });
        }
      });
    }
    $scope.runUserView = function () {
      if ($rootScope.currentStateName === 'oneViewDashboard') {
        $rootScope.toState = 'accountOverview';
        appState.switchView('accountOverview');
      } else {
        $rootScope.toState = $rootScope.currentStateName;
      }
      sessionStorage.setSessionStorageValue('isRepView', 'false');
      $rootScope.isRepView = 'false';
    };

    $scope.runRepView = function () {
      if ($rootScope.currentStateName === 'accountOverview') {
        $rootScope.toState = 'oneViewDashboard';
        appState.switchView('oneViewDashboard');
      } else {
        $rootScope.toState = $rootScope.currentStateName;
      }
      sessionStorage.setSessionStorageValue('isRepView', 'true');
      $rootScope.isRepView = 'true';
    };

    // Self hiding logic
    $scope.repViewHeaderSelfDestruct = function (stateString) {
      // array lookup
      return settings.showRepViewHeaderAndFooterStates.indexOf(stateString) !== -1;
    };
    $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct();
    // Listen to the state change broadcast
    var scopewatch1 = $rootScope.$watch('isRepView', function () {
      var toState = $rootScope.toState;
      if ($rootScope.isDealer || $rootScope.isCare) {
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
        //$scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState);
        if ($rootScope.isRepView === 'false') {
          // DO NOT show the repView header and footer
          $scope.selfDestructFlag = false;
          $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState);
          if ($scope.tempFlag) {
            customerViewComponents();
          } else {
            defaultComponents();
          }

        } else {
          $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState);
          if ($scope.selfDestructFlag) {
            repViewComponents();
          } else {
            defaultComponents();
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });
    function customerViewComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').show();
      $('div[data-liveheader] #header').css('position', 'static');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }

    function repViewComponents() {
      $('div[data-liveheader]').hide();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').hide();
      $('div[data-oneviewfooter]').show();
      $('.directive-sub-menu').hide();
      $('.directive-repview-header').show();
      $('.one-view-repview-footer').show();
      $('.one-view-consumer-footer').hide();
    }

    function defaultComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('div[data-liveheader] #header').css('position', 'fixed');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('#toggleSwitch').hide();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }
    $scope.customerViewToggleSwitchDestruct = function (stateString) {
      // array lookup
      return (settings.showCustomerViewToggleSwitchStates.indexOf(stateString) !== -1);
    };
    $scope.isToggleSwitchDisabledMethod = function (stateString) {
          // array lookup
      return (settings.disableToggleSwitchStates.indexOf(stateString) !== -1);
    };

    // because this controller has been used for two directives, we need to provide a unique key (string + scopeId) for "registerOnDataChangeHandler" function.
    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.lang = lang;
      $('html').attr('lang', lang);
      appInterface.fn.languageChange(lang);

      $scope.dealerCodePlaceholder = $translate.instant('dealer-code');
    }, 'oneViewHeaderControllerLangSub_'+$scope.$id);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('oneViewHeaderControllerLangSub_'+$scope.$id);
      scopewatch1(); //n
    });

    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
      //$scope.isInteraction = $rootScope.currentStateName === 'interaction';
      if ($rootScope.isDealer || $rootScope.isCare) {
        if (userService.isSigned()) {
          $scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState.name);
          $scope.isOneViewInterface = $rootScope.isOneViewInterface;
          if ($rootScope.isRepView === 'false') {
            // DO NOT show the repView header and footer
            $scope.selfDestructFlag = false;
            $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState.name);
            if ($scope.tempFlag) {
              customerViewComponents();
            } else {
              defaultComponents();
            }
          } else {
            $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState.name);
            if ($scope.selfDestructFlag) {
              repViewComponents();
            } else {
              defaultComponents();
            }
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });

    $scope.changeLanguage = function () {
      if ($scope.lang === 'en') {
        languageSwitcher.changeLanguage('fr');
      } else {
        languageSwitcher.changeLanguage('en');
      }
      $rootScope.$broadcast('languageChanged');
    };

    $scope.onRepNameSelect = function () {
      return false;
    };

    checkAddNotesPermission();
    function checkAddNotesPermission() {
      if($scope.isDealer) {
        //$scope.displayAddnoteSection=false;
        permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_INTERACTION_NOTES_DEALER).then(function (isPermitted) {
          $scope.displayAddnoteSection = isPermitted;
        });
      } else if($scope.isCare) {
        permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.ONEVIEW_INTERACTION_NOTES_CARE).then(function (isPermitted) {
          $scope.displayAddnoteSection = isPermitted;
        });
      }
    }

  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewHeaderOLD', oneViewHeaderOLD);

  oneViewHeaderOLD.$inject = [];

  /* @ngInject */
  function oneViewHeaderOLD() {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewHeader/oneViewHeader.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyrOneViewHeaderControllerOLD'
    };

  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:TvdashboardCtrl
   * @description
   * # TvdashboardCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrOneViewInterfaceController', OneViewInterfaceController);

  OneViewInterfaceController.$inject = ['$scope', 'settings', '$window', '$location', 'ute.blocks.messages.bus.service','$rootScope'];

  /* @ngInject */
  function OneViewInterfaceController($scope, settings, $window, $location, messagesService,$rootScope) {
    messagesService.publish('ute-oneview-footer-disable');
    $scope.$extend({});
    $('#toggleSwitch').hide();
    $('#feedback-tab').hide();
    $('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
    var requestURI = $window.location.href;
    var queryString = requestURI.split('?');
    if (queryString.length > 1) {
      var params = queryString[1].split('=');
      var oneViewStatusCode = $location.search().statusCode;
      if (oneViewStatusCode === settings.oneViewStatusCodes.sspSSOFailure ||
          oneViewStatusCode === settings.oneViewStatusCodes.crmSSOFailure) {
        $scope.isSSOFailure = true;
      } else if(oneViewStatusCode === settings.oneViewStatusCodes.sspAccessFailure ||
          oneViewStatusCode === settings.oneViewStatusCodes.crmAccessFailure) {
        $scope.isAccessFailure = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.fidoAccessFailure) {
        $scope.isFidoAccessFailure = true;
        $rootScope.isFidoAccessFailure = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.igniteNACAccessFailure){
        $scope.igniteNACAccessFailure = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.igniteNACContactInfoMissing){
        var infoMissing = $location.search().lst;
        if (infoMissing){
          $scope.igniteNACContactInfoMissing = true;
          $scope.missingFirstName = infoMissing.includes('fn');
          $scope.missingLastName = infoMissing.includes('ln');
          $scope.missingPhoneNumber = infoMissing.includes('pn');
          $scope.missingEmail = infoMissing.includes('ea');
          $scope.missingLangPref = infoMissing.includes('lp');
        } else {
          $scope.igniteNACGenericError = true;
        }
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.igniteNACGenericError){
        $scope.igniteNACGenericError = true;
      } else if(oneViewStatusCode === settings.oneViewStatusCodes.crmServiceFailure || oneViewStatusCode === settings.oneViewStatusCodes.sspServiceFailure) {
          /* NPS-1676: Added new block to display Service Failure error message for FIDO customers */
          $scope.isServiceFailure = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.sessionTimeout) {
        $scope.isSessionTimeOut = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.crmSignout) {
        $scope.isCareSignout = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.fraudCheck) {
        $scope.isFraudCheck = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.creditOps) {
        $scope.isCreditOps = true;
      } else if (oneViewStatusCode === settings.oneViewStatusCodes.businessAccessFailure) {
        $scope.isBusinessAccessFailure = true;
        $rootScope.isBusinessAccessFailure = true;
      } else {
        $scope.isGenericError = true;
      }
    } else {
      $scope.isGenericError = true;
    }
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewLastBill', oneViewLastBill);

  oneViewLastBill.$inject = [];

  /* @ngInject */
  function oneViewLastBill($log) {
    return {
      //templateUrl: 'scripts/modules/oneView/oneViewLastBill/oneViewLastBill.html',
      templateUrl: function (elem, attrs) {
        
        if (attrs.viewHtml) {
          return 'scripts/modules/oneView/oneViewLastBill/' + attrs.viewHtml;
        }else{
          return 'scripts/modules/oneView/oneViewLastBill/oneViewLastBill.html';
        }
      },
      scope: {disableBalance: '=', loadingBalance: '=', loadingBriteBill: '='},
      restrict: 'EA',
      controller: 'MyrAccountBalanceController',
      controllerAs: 'ab',
      bindToController: true
    };

  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:oneViewNewsController
   * @description
   * # oneViewNewsController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('oneViewNewsController', oneViewNewsController);

  oneViewNewsController.$inject = ['$scope',
    '$rootScope',
    'myrOneViewNewsService',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function oneViewNewsController($scope,
                                 $rootScope,
                                 oneViewNewsService,
                                 languageSwitcher) {
    var vm = this;
    $scope.$extend({
    });
    vm.ovns = oneViewNewsService;
    vm.newsInfo = {};// {"items":[{"title":"Trump wins Christie enforcement, robbing Rubio of momentum","creator":"News Staff","pub_date":"2016-02-27T00:38:31.000Z","description":"FORT WORTH, Texas – New Jersey Gov. Chris Christie on Friday endorsed GOP front-runner Donald Trump, delivering a powerful boost to the billionaire businessman, whom he called the best Republican candidate to lead the country and beat Democrat Hillary Clinton. “I’ve gotten to know all the people on that stage and there is none who […]","link":"http://www.680news.com/2016/02/26/trump-wins-christie-enforcement-robbing-rubio-of-momentum/","category":"World"},{"title":"Group hopes to make Saskatoon park a United Nations World Heritage Site","creator":"News Staff","pub_date":"2016-02-27T00:12:13.000Z","description":"SASKATOON – A group hopes to have the Wanuskewin Heritage Park in Saskatoon designated as a United Nations World Heritage site. Chief Felix Thomas of the Saskatoon Tribal Council says to achieve that goal the park will need to expand and be improved. The plan also calls for re-introducing a small herd of bison to […]","link":"http://www.680news.com/2016/02/26/group-hopes-to-make-saskatoon-park-a-united-nations-world-heritage-site/","category":"National"},{"title":"Maclean’s on the Hill: Assisted dying options, large Liberal deficits \u0026 Conservative rebuilding","creator":"Cormac MacSweeney","pub_date":"2016-02-26T23:44:28.000Z","description":"Each Week our Parliament Hill Reporter Cormac Mac Sweeney sits down with the Maclean’s Ottawa Bureau to interview some of the key political players over the last week in politics. LISTEN HERE On this week’s show… The co-chair of the assisted dying committee discusses the recommendations given to the government, including allowing access for people […]","link":"http://www.660news.com/2016/02/26/macleans-on-the-hill-assisted-dying-options-large-liberal-deficits-conservative-rebuilding/","category":"National"},{"title":"Five dead, including gunman, after standoff in Washington state","creator":"News Staff","pub_date":"2016-02-26T22:13:48.000Z","description":"A gunman who killed four people at a home in rural Washington state called an officer he previously encountered to say he shot his family, leading to an hourslong standoff Friday that ended with his suicide, authorities said. A 12-year-old girl related to the victims survived and was taken to the hospital for an evaluation, […]","link":"http://www.680news.com/2016/02/26/5-dead-including-gunman-after-standoff-in-washington-state/","category":"World"},{"title":"A quick look at the life of former Alberta premier Don Getty","creator":"News Staff","pub_date":"2016-02-26T22:04:13.000Z","description":"EDMONTON – A look at the life and career of former Alberta premier Don Getty, who died Friday at age 82. Born: Donald Ross Getty in Westmount, Que. on Aug. 30, 1933. Education: Was student council president at Sir Adam Beck Collegiate Institute in London, Ont. Captain of the school’s basketball and football teams. Received […]","link":"http://www.680news.com/2016/02/26/a-quick-look-at-the-life-of-former-alberta-premier-don-getty/","category":"National"}]};
    $scope.isNewsInfoNotReady = false;
    $scope.isResponseAvailable = false;
    var isRequestAvailable=false;
    /*$("#newsCarousel").owlCarousel({
         navigation : false, // Show next and prev buttons
         slideSpeed : 300,
         paginationSpeed : 400,
         singleItem:true,
         autoPlay:10000,
         dots: false
         // "singleItem:true" is a shortcut for:
         // items : 1,
         // itemsDesktop : false,
         // itemsDesktopSmall : false,
         // itemsTablet: false,
         // itemsMobile : false
    });*/
    $scope.getNews = function(provinceName){
      var newsInfoResponse = function (data) {
      if($("#newsCarousel").data('owlCarousel')){
         $("#newsCarousel").data('owlCarousel').destroy();
      }
      vm.newsInfo = data;

     /* if($("#newsCarousel").data('owlCarousel')){
        $("#newsCarousel").data('owlCarousel').destroy();
        $("#newsCarousel").owlCarousel({
             navigation : false, // Show next and prev buttons
             slideSpeed : 300,
             paginationSpeed : 400,
             singleItem:true,
             autoPlay:10000,
             dots: false
             // "singleItem:true" is a shortcut for:
             // items : 1,
             // itemsDesktop : false,
             // itemsDesktopSmall : false,
             // itemsTablet: false,
             // itemsMobile : false
        });
      }*/
     /* $("#newsCarousel").owlCarousel({
           navigation : false, // Show next and prev buttons
           slideSpeed : 300,
           paginationSpeed : 400,
           singleItem:true,
           autoPlay:10000,
           dots: false
           // "singleItem:true" is a shortcut for:
           // items : 1,
           // itemsDesktop : false,
           // itemsDesktopSmall : false,
           // itemsTablet: false,
           // itemsMobile : false
      });*/
      var displayContentTimeout = setTimeout(function(){

        $("#newsCarousel").owlCarousel({
             navigation : false, // Show next and prev buttons
             slideSpeed : 300,
             paginationSpeed : 400,
             singleItem:true,
             autoPlay:10000,
             dots: false
             // "singleItem:true" is a shortcut for:
             // items : 1,
             // itemsDesktop : false,
             // itemsDesktopSmall : false,
             // itemsTablet: false,
             // itemsMobile : false
        });
         clearTimeout(displayContentTimeout);
        },1000);

        if(vm.newsInfo.items.length > 0) {
          $scope.isResponseAvailable = true;
        } else {
          $scope.isResponseAvailable = false;
          $scope.isNewsInfoNotReady = true;
        }
      };
      var newsInfoError = function (data) {
        $scope.isResponseAvailable = false;
        $scope.isNewsInfoNotReady = true;
      };
       /*if($("#newsCarousel").data('owlCarousel')){
         $("#newsCarousel").data('owlCarousel').destroy();
       }*/
      vm.ovns.getNews(provinceName,newsInfoResponse, newsInfoError);
    };
    $scope.getTimeStamp = function(itemTimeStamp){
        return moment.utc(itemTimeStamp).format("MMM DD, YYYY, HH:mm A ");
    }
    var rootwatch1 = $rootScope.$watch('ao.accountDetails', function (newVal, oldVal) {
      if($rootScope.isCare || $rootScope.isDealer){
           if (newVal) {

            if(!oldVal){
               $scope.getNews($rootScope.ao.accountDetails.billingAddress.province);
               isRequestAvailable=true;
            } else if(oldVal && newVal.billingAddress.province != oldVal.billingAddress.province) {
               $scope.getNews($rootScope.ao.accountDetails.billingAddress.province);
               isRequestAvailable=true;
            }
          }
      }
    });

    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      if(isRequestAvailable) {
        $scope.isResponseAvailable = false;
        $scope.getNews($rootScope.ao.accountDetails.billingAddress.province);

      }
    }, 'oneViewNewsControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('oneViewNewsControllerLangSub');
      rootwatch1(); //n
    });

  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewNews', oneViewNews);

  oneViewNews.$inject = [];

  /* @ngInject */
  function oneViewNews($log) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewNews/oneViewNews.html',
      restrict: 'EA',
      controller: 'oneViewNewsController',
      controllerAs: 'ovn',
      bindToController: true
    };
    function linkFunc(scope, element, attrs) {
      $(element).owlCarousel({
               navigation : false, // Show next and prev buttons
               slideSpeed : 300,
               paginationSpeed : 400,
               singleItem:true,
               autoPlay:10000,
               dots: false
               // "singleItem:true" is a shortcut for:
               // items : 1,
               // itemsDesktop : false,
               // itemsDesktopSmall : false,
               // itemsTablet: false,
               // itemsMobile : false
          });
    }
  }
})();

(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:myrOneViewNewsService
   * @description
   * # myrOneViewNewsService
   */
  angular.module('totesApp').factory('myrOneViewNewsService', oneViewNewsService);

  oneViewNewsService.$inject = ['settings','ute.blocks.language.switcher'];

  function oneViewNewsService(settings,languageSwitcher) {

    var service = {
      getNews:getNews
    };

    return service;

    function getNews (provinceName, callback) {
      try {
       var selectedLanguage = languageSwitcher.getCurrentLanguage();

         /*var availableProvinces = {
          "ON":"WWW_680NEWS_COM",
          "BC":"WWW_NEWS1130_COM",
          "NS":"WWW_NEWS957_COM",
          "NB":"WWW_NEWS957_COM",
          "PE":"WWW_NEWS957_COM",
          "AB":"WWW_660NEWS_COM",
          "QC":"WWW_LACTUALITE_COM"
         }*/

         var newsData = {};

        var moduleName =  settings.newsAvailableProvinces[provinceName];
        if(!moduleName || moduleName===""){
          moduleName=selectedLanguage==="en"?settings.newsAvailableProvinces["en"]:settings.newsAvailableProvinces["fr"];
        }
        var request = {
                url:settings.oneViewExternalAPIs.news,
            	  moduleName:moduleName,
                method: "GET",
                headerData : {"Content-Type": "application/json","Access-Control-Allow-Origin": "news-weather-feeds-prod.herokuapp.com" ,"AccessControlAllowCredentials": true }
            	};
        $.ajax(request.url+request.moduleName, {
          cache:false,
          success: function (response, status) {
            console.log('getOneViewNews success');
            //sessionStorage.setSessionStorageValue('newsFeed',JSON.stringify(response));
            //newsData = JSON.parse(sessionStorage.getSessionStorageValue('newsFeed'));
            newsData = response;
            return callback(newsData);
          },
          error: function (error, status) {
            console.log('getOneViewNews error ',error);
            /*if(sessionStorage.getSessionStorageValue('newsFeed')){
                newsData = JSON.parse(sessionStorage.getSessionStorageValue('newsFeed'));
            }*/
            return callback(newsData);
          }
        });
        //$scope.selectedProvince = userProvince();

        /*$.get(request.url+request.moduleName, function(data, status){
            //alert("Data: " + data + "\nStatus: " + status);
            //sessionStorage.setSessionStorage("newsFeed",data);
            //sessionStorage.setSessionStorage("newsFeedEntry",data);
            newsData = data;
            return callback(newsData);
        },
        function(data, status) {
          return callback(newsData);
        });*/
      }catch (err) {

      }
    }
  }
}());

(function () {
    'use strict';
    /**
     * @name totesApp.controller:MyrOneViewOrdersController
     * @description
     * # MyrOneViewOrdersController
     * Controller of the totesApp
     */
    angular.module('totesApp').controller('MyrOneViewOrdersController', ordersController);

    ordersController.$inject = ['$scope',
        '$rootScope',
        'ute.blocks.language.switcher',
        'sessionStorage',
        '$filter',
        'MyrOneViewOrdersService',
    ];

    /* @ngInject */
    function ordersController($scope,
        $rootScope,
        languageSwitcher,
        sessionStorage,
        $filter,
        oneViewOrdersService) {
        var ord = this;
        //ord.showOrdersTable = false;
        ord.ppcDetails = [];
        ord.validPPCDetails = [];
        ord.sortingOrder = "ascending";
        ord.isCable = false;
        ord.isCare = $rootScope.isCare;
        ord.lang = languageSwitcher.getCurrentLanguage();
        ord.sortingImageURL = 'images/arrow.png';
        ord.loading = false;
        ord.noFilterSelected = true;
        ord.wirelessOrderDetails = [];
        ord.validWirelessOrderDetails = [];
        ord.firstTimeLoad = true;
        ord.ppcFilterSelected = false;
        ord.wirelessOrdersFilterSelected = false;
        ord.totalOrders = [];
        ord.noTotalOrders = true;
        ord.displayWirelessOrderPopup = [];
        function init() {
            ord.accountNumber = sessionStorage.getSessionStorageValue('accountNumber');
            ord.accountTypeNumber = sessionStorage.getSessionStorageValue('accountTypeNumber');
            ord.isCable = ord.accountNumber.toString().length === 12;
            ord.filters = [
                {
                    name: 'ppc',
                    translateText: 'order_ppc_filter',
                    checked: false
                }, {
                    name: 'wireless-order',
                    translateText: 'order_wireless_order',
                    checked: false
                }
            ]
        }
        function processPostDatedPPCDetails(response) {
            if (response["futureDatedPPCList"]) {
                if (response["futureDatedPPCList"].length > 0) {
                    // ord.showOrdersTable = true;
                    ord.ppcDetails = response["futureDatedPPCList"];
                    populateValidPPCDetails();
                    if (ord.validPPCDetails.length > 0) {
                        //ord.noPPCOrders = false;
                        ord.loading = false;
                        setTotalOrders();
                    } else {
                        ord.loading = false;
                        //ord.noPPCOrders = true;
                    }
                } else {
                    ord.loading = false;
                    //ord.noPPCOrders = true;
                }
            } else {
                ord.loading = false;
                //ord.noPPCOrders = true;
            }
        }

        function errorCallbackPPC() {
            ord.loading = false;
            //ord.noPPCOrders = true;
        }

        function processWirelessOrderDetails(response) {
            if (response["orderDetailsResList"]) {
                if (response["orderDetailsResList"].length > 0) {
                    // ord.showOrdersTable = true;
                    ord.wirelessOrderDetails = response["orderDetailsResList"];
                    populateValidWirelessOrderDetails();
                    if (ord.validWirelessOrderDetails.length > 0) {
                        ord.loading = false;
                        setTotalOrders();
                    } else {
                        ord.loading = false;
                        //ord.noWirelessOrders = true;
                    }
                } else {
                    ord.loading = false;
                    //ord.noWirelessOrders = true;
                }
            } else {
                ord.loading = false;
                //ord.noWirelessOrders = true;
            }
        }

        function errorCallbackWirelessOrders() {
            ord.loading = false;
            //ord.noWirelessOrders = true;
        }

        function populateValidPPCDetails() {
            ord.validPPCDetails = [];
            ord.ppcDetails.forEach(function (ppc) {
                if (ppc.futureSOC || ppc.effectiveDate) {
                    ord.validPPCDetails.push(ppc);
                }
            });
        }

        function populateValidWirelessOrderDetails() {
            var itemDetails = [];
            var itemDetailsIndex;
            ord.validWirelessOrderDetails = [];
            ord.wirelessOrderDetails.forEach(function(order, index) {
                if(order.orderStatus !== 'Order Delivery Complete' && order.orderStatus !== 'Cancelled') {
                    order.orderStatus = getOrderStatus(order.orderStatus);
                    itemDetails = order["orderLineItemsList"];
                    itemDetailsIndex = _.findIndex(itemDetails, function(item) {
                        return (item["ctn"] && item["ctn"].trim());
                    });
                    if(itemDetailsIndex !== -1)
                    order.serviceLine = itemDetails[itemDetailsIndex]["ctn"];
                    ord.validWirelessOrderDetails.push(order);
                }
            });
        }

        function setNoFilterSelected() {
            if (ord.ppcFilterSelected || ord.wirelessOrdersFilterSelected) {
                return false;
            } else {
                return true;
            }
        }

        function setTotalOrders() {
            if(ord.ppcFilterSelected && ord.wirelessOrdersFilterSelected)
                ord.totalOrders = ord.validPPCDetails.concat(ord.validWirelessOrderDetails);
            else if(ord.ppcFilterSelected && !ord.wirelessOrdersFilterSelected)
                ord.totalOrders = ord.validPPCDetails;
            else if(!ord.ppcFilterSelected && ord.wirelessOrdersFilterSelected)
                ord.totalOrders = ord.validWirelessOrderDetails;
            if (ord.totalOrders.length > 0) {
                ord.noTotalOrders = false;
                ord.totalOrders.forEach(function (order, index) {
                    ord.displayWirelessOrderPopup[index] = false;
                })
            } else {
                ord.noTotalOrders = true;
            }
            ord.sortOrdersBasedOnStartDate(ord.sortingOrder);
        }
        //based on code review comments.
        ord.decideDateFilter = function (date) {
            if (ord.lang === 'en') {
                date = $filter('date')(date, 'MMM dd, yyyy');
            } else {
                date = $filter('date')(date, 'dd MMM yyyy');
            }
            return date.replace(".", "");
        }

        ord.convertCreationDate = function (date) {
            return new Date(date);
        }
        //when the api call fails first time, we call it again on second time so that it might work. need to confirm this approach.
        ord.fetchOrderDetails = function (filter) {
            filter.checked = !filter.checked;
            ord.ordersMappingKey = "";
            ord.noOrdersMappingKey = "";
            if (filter.checked) {
                $("#" + filter.name + "-checkbox + .order-custom-checkbox").addClass("check-checkbox");
            } else {
                $("#" + filter.name + "-checkbox + .order-custom-checkbox").removeClass("check-checkbox");
            }
            if (filter.name === "ppc") {
                ord.ordersMappingKey = "PPC-checkbox";
                ord.noOrdersMappingKey = "no-order-ppc";
                ord.ppcFilterSelected = !ord.ppcFilterSelected;
                if (ord.ppcFilterSelected) {
                    if (ord.isCable) {
                        ord.loading = false;
                        //ord.noPPCOrders = true;
                    } else {
                        if (ord.ppcDetails.length === 0 && ord.validPPCDetails.length === 0) {
                            ord.loading = true;
                            oneViewOrdersService.getPostDatedPPC(ord.accountNumber, ord.accountTypeNumber, processPostDatedPPCDetails, errorCallbackPPC);
                        }
                    }
                } else {
                    //ord.ppcDetails = _.clone(ord.validPPCDetails);
                    ord.loading = false;
                }
            } else if (filter.name === "wireless-order") {
                ord.ordersMappingKey = "wireless-orders-checkbox";
                ord.noOrdersMappingKey = "no-order-wireless";
                ord.wirelessOrdersFilterSelected = !ord.wirelessOrdersFilterSelected;
                if (ord.wirelessOrdersFilterSelected) {
                    if (ord.wirelessOrderDetails.length === 0 && ord.validWirelessOrderDetails.length === 0) {
                        ord.loading = true;
                        oneViewOrdersService.getWirelessOrders(ord.accountNumber, processWirelessOrderDetails, errorCallbackWirelessOrders);
                    }
                } else {
                   // ord.wirelessOrderDetails = _.clone(ord.validWirelessOrderDetails);
                    ord.loading = false;
                }
            }
            ord.noFilterSelected = setNoFilterSelected();
            if (ord.ppcFilterSelected && ord.wirelessOrdersFilterSelected) {
             ord.ordersMappingKey = "my-PPC-and-wireless-chckbox";             
             ord.noOrdersMappingKey = "no-order-ppc-wireless";
            }
            setTotalOrders();
        }
        ord.sortOrdersBasedOnStartDate = function (sortOrder) {

            var ordersWithEffectiveDate = _.filter(ord.totalOrders, function (o) { return !!o.effectiveDate; });
            var ordersWithoutEffectiveDate = _.filter(ord.totalOrders, function (o) { return !o.effectiveDate; })
            if (sortOrder === "ascending") {
                ordersWithEffectiveDate = $filter('orderBy')(ordersWithEffectiveDate, 'effectiveDate');
                $('.order-start-date + .sorting-icon').removeClass('rotate-down');
                $('.order-start-date + .sorting-icon').addClass('rotate-up');
            }
            else if (sortOrder === "descending") {
                ordersWithEffectiveDate = $filter('orderBy')(ordersWithEffectiveDate, 'effectiveDate', true);
                $('.order-start-date + .sorting-icon').removeClass('rotate-up');
                $('.order-start-date + .sorting-icon').addClass('rotate-down');

            }
            ord.sortingOrder = sortOrder;
            ord.totalOrders = ordersWithEffectiveDate.concat(ordersWithoutEffectiveDate);
            // setTotalOrders();

        }

        function getOrderStatus (status) {
            var statusText = ("order_" + (status.replace(/\s/g,"_")));
            return statusText;
        }

        ord.deselectAllFilters = function () {
            ord.noFilterSelected = true;
            ord.wirelessOrdersFilterSelected = false;
            ord.ppcFilterSelected = false;
            ord.noTotalOrders = true;
            ord.totalOrders = [];
            // ord.validPPCDetails = [];
            // ord.validWirelessOrderDetails = [];
            ord.displayWirelessOrderPopup = [];
            ord.filters.forEach(function (filter) {
                filter.checked = false;
                $("#" + filter.name + "-checkbox + .order-custom-checkbox").removeClass("check-checkbox");
            });
            // document.querySelectorAll(".order-filter-checkbox > input").forEach(function(filter) {
            //     filter.checked = false;
            // });
        }

        ord.togglePopover = function (index) {
            index = parseInt(index);
            ord.displayWirelessOrderPopup[index] = !ord.displayWirelessOrderPopup[index];
        }

        init();
        languageSwitcher.registerOnDataChangeHandler(function (lang) {
            ord.lang = lang;
        }, 'oneViewOrdersController');
    }
})();

(function () {
    'use strict';
  
    angular.module('totesApp').factory('MyrOneViewOrdersService', oneViewOrderservice);
  
    oneViewOrderservice.$inject = ['$rootScope','ajax', 'ute.blocks.language.switcher'];
  
    /* @ngInject */
    function oneViewOrderservice($rootScope,ajax, languageSwitcher) {

        function getPostDatedPPC(accountNumber, accountTypeNumber, successCallback, errorCallback) {
            var request = {
                accountNumber: accountNumber,
                accountTypeNumber: accountTypeNumber,
                applicationId: "Rogers.com",
                refresh: "false",
                language: languageSwitcher.getCurrentLanguage()
            }
            ajax.getPostDatedPPC(request).then(function(response) {
                successCallback(response);
            }, function() {
                errorCallback();
            });
      }

      function getWirelessOrders(accountNumber, successCallback, errorCallback) {
          var request = {
            ban: accountNumber
          }
          ajax.getWirelessOrders(request).then(function(response) {
            successCallback(response);
          }, function() {
              errorCallback();
          });

      }
      return {
          getPostDatedPPC : getPostDatedPPC,
          getWirelessOrders: getWirelessOrders,
      }
    }
  })();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:MyrBillingAndPaymentModalCtrl
   * @description
   * # MyrBillingAndPaymentModalCtrl
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrBillingAndPaymentModalCtrl', billingAndPaymentModalController);

  billingAndPaymentModalController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function billingAndPaymentModalController($scope, $modalInstance, $rootScope) {

   $scope.close = function () {
       $modalInstance.dismiss('cancel');
       $rootScope.modal = null;
   };

  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewSubmenuOLD', oneViewSubmenuOLD);

  oneViewSubmenuOLD.$inject = ['ajax','$rootScope','$compile', '$templateCache'];

  /* @ngInject */
  function oneViewSubmenuOLD(ajax, $rootScope, $compile, $templateCache) {

    var directive = {
      restrict: 'EA',
      scope: {},
      transclude: true,
      link: linkFunc,
      controller: 'MyrSubMenuControllerOLD',
      controllerAs: 'sm',
      bindToController: true,
      //templateUrl: 'scripts/modules/oneView/oneViewSubmenu/oneViewSubmenu.html',
      //template: '<div ng-include="contentUrl"></div>'
      template: '<div></div>'
    };
    return directive;

    function linkFunc(scope, element, attrs) {
      attrs.$observe('oneViewInterfaceFlag', function (value) {
        if (value === 'true') {
          console.log('if :: isOneViewInterface :: '+value);
          scope.contentUrl = 'scripts/modules/oneView/oneViewSubmenu/oneViewSubmenuForInterface.html';
        } else if (value === 'false') {
          console.log('else :: isOneViewInterface :: '+value);
          scope.contentUrl = 'scripts/modules/oneView/oneViewSubmenu/oneViewSubmenu.html';
        }
        if (scope.contentUrl) {
          var data = $templateCache.get(scope.contentUrl);
          element.html(data);
          $compile(element.contents())(scope);
        }

      });

      var scrootwatch1 = scope.$root.$watch('myServicesList', function () {
        scope.subMenuMyServicesList = scope.getSubMenuServices();
      });

      var scrootwatch2 =   scope.$root.$watch('permissions.permissionActive', function (newVal, oldVal) {
          scope.showCareLink = false;
          if (newVal) {
            if (scope.hasOwnProperty('ssaPermission')) {
              //console.log('ssaPermission already defined on scope: ' + scope.ssaPermission);
              /*if(scope.hasOwnProperty('showCartMenu')){
                $rootScope.showCartMenu = newVal.accountNumber;
              }*/
            }
            else {
               /* var tazoPermission = permissions.permissions.filter(function (permission) {
                  return permission.permission && permission.permission === 'TAZO_UTE_PAGE_VIEW';
                });*/
                //console.log('setting ssaPermission: ' + (ssaPermission.length > 0));
              scope.ssaPermission = true;
                /*scope.showCartMenu = tazoPermission.length > 0;
                if(scope.showCartMenu){
                   $rootScope.showCartMenu = scope.showCartMenu;
                }*/
            }
            var parmissions = newVal.permissions;
            for (var xx = 0; xx < parmissions.length; xx++) {
              var current = parmissions[xx];
              if (current.name === 'INTERNAL_USER') { //TODO INTERNAL_USER
                scope.showCareLink = true;
                break;
              }
            }
          }
        }, true);

        var scrootwatch3 = scope.$root.$watch('interactionAndCaseListLength', function (newVal) {
        if (newVal && newVal != 0) {
          scope.interactionLength = newVal;
        } else {
          scope.interactionLength = '-';
        }

      });

      var scrootwatch4 = scope.$root.$watch('ao.accountActive', function () {
        scope.activeAccountType = (!!scope.$root.ao.accountActive) ? scope.$root.ao.accountActive.accountTypeNumber : 0;
        if (scope.$root.ao.accountActive) {
          scope.updateBtnSettings(scope.$root.ao.accountActive.accountStatus);
        }
      });

      //n Remove any watchers
      scope.$on('$destroy', function () {
        scrootwatch1();
        scrootwatch2();
        scrootwatch3();
        scrootwatch4();
      });

    }
  }
})();

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrOneViewSwitchController', oneViewSwitchController);

  oneViewSwitchController.$inject = ['$scope',
    '$rootScope',
    'appState',
    'settings',
    '$translate',
    'sessionStorage',
    'appInterface',
    'ute.common.permissions.service',
    'ute.common.user.service',
    'ute.blocks.messages.bus.service',
    'captureDealerCodeService',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function oneViewSwitchController($scope,
                                   $rootScope,
                                   appState,
                                   settings,
                                   $translate,
                                   sessionStorage,
                                   appInterface,
                                   permissionsService,
                                   userService,
                                   messagesService,
                                   captureDealerCodeService,
                                   languageSwitcher) {

    $scope.$extend({});
    $scope.lang = languageSwitcher.getCurrentLanguage();
    $scope.isDealer = $rootScope.isDealer;
    $scope.isCare = $rootScope.isCare;
    $scope.displayAddnoteSection=null;
    $scope.repName = null;
    $scope.userDealerCode = null;
    $scope.isDealerCodeSubmitted = false;
    $scope.displayDealerCodeSection = null;

   
    if ($scope.isCare) {
      permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM).then(function (isPermitted) {
        if (isPermitted) {
          permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
            .then(function (agentPermission) {
              $scope.displayDealerCodeSection = agentPermission;
          });
        }
      });
    }
    $scope.runUserView = function () {
      if ($rootScope.currentStateName === 'oneViewDashboard') {
        $rootScope.toState = 'accountOverview';
        appState.switchView('accountOverview');
      } else {
        $rootScope.toState = $rootScope.currentStateName;
      }
      sessionStorage.setSessionStorageValue('isRepView', 'false');
      $rootScope.isRepView = 'false';
    };

    $scope.runRepView = function () {
      if ($rootScope.currentStateName === 'accountOverview') {
        $rootScope.toState = 'oneViewDashboard';
        appState.switchView('oneViewDashboard');
      } else {
        $rootScope.toState = $rootScope.currentStateName;
      }
      sessionStorage.setSessionStorageValue('isRepView', 'true');
      $rootScope.isRepView = 'true';
    };

    // Self hiding logic
    $scope.repViewHeaderSelfDestruct = function (stateString) {
      // array lookup
      return settings.showRepViewHeaderAndFooterStates.indexOf(stateString) !== -1;
    };
    $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct();
    // Listen to the state change broadcast
    var scopewatch1 = $rootScope.$watch('isRepView', function () {
      var toState = $rootScope.toState;
      if ($rootScope.isDealer || $rootScope.isCare) {
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
        //$scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState);
        if ($rootScope.isRepView === 'false') {
          // DO NOT show the repView header and footer
          $scope.selfDestructFlag = false;
          $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState);
          if ($scope.tempFlag) {
            customerViewComponents();
          } else {
            defaultComponents();
          }

        } else {
          $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState);
          if ($scope.selfDestructFlag) {
            repViewComponents();
          } else {
            defaultComponents();
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });
    function customerViewComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').show();
      $('div[data-liveheader] #header').css('position', 'static');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }

    function repViewComponents() {
      $('div[data-liveheader]').hide();
      $('div[data-livefooter]').hide();
      $('#toggleSwitch').hide();
      $('div[data-oneviewfooter]').show();
      $('.directive-sub-menu').hide();
      $('.directive-repview-header').show();
      $('.one-view-repview-footer').show();
      $('.one-view-consumer-footer').hide();
    }

    function defaultComponents() {
      $('div[data-liveheader]').show();
      $('div[data-livefooter]').hide();
      $('div[data-liveheader] #header').css('position', 'fixed');
      $('div[data-oneviewfooter]').hide();
      $('.directive-sub-menu').show();
      $('#toggleSwitch').hide();
      $('.one-view-repview-footer').hide();
      $('.one-view-consumer-footer').show();
    }
    $scope.customerViewToggleSwitchDestruct = function (stateString) {
      // array lookup
      return (settings.showCustomerViewToggleSwitchStates.indexOf(stateString) !== -1);
    };
    $scope.isToggleSwitchDisabledMethod = function (stateString) {
          // array lookup
      return (settings.disableToggleSwitchStates.indexOf(stateString) !== -1);
    };

    // because this controller has been used for two directives, we need to provide a unique key (string + scopeId) for "registerOnDataChangeHandler" function.
    languageSwitcher.registerOnDataChangeHandler(function (lang) {
      $scope.lang = lang;
    //  $('html').attr('lang', lang);
     // appInterface.fn.languageChange(lang);
    }, 'oneViewHeaderControllerLangSub_'+$scope.$id);

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('oneViewHeaderControllerLangSub_'+$scope.$id);
      scopewatch1(); //n
    });

    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
      //$scope.isInteraction = $rootScope.currentStateName === 'interaction';
      if ($rootScope.isDealer || $rootScope.isCare) {
        if (userService.isSigned()) { 
          $scope.isToggleSwitchDisabled = $scope.isToggleSwitchDisabledMethod(toState.name);
          $scope.isOneViewInterface = $rootScope.isOneViewInterface;
          if ($rootScope.isRepView === 'false') {
            // DO NOT show the repView header and footer
            $scope.selfDestructFlag = false;
            $scope.tempFlag = $scope.customerViewToggleSwitchDestruct(toState.name);
            if ($scope.tempFlag) {
              customerViewComponents();
            } else {
              defaultComponents();
            }
          } else {
            $scope.selfDestructFlag = $scope.repViewHeaderSelfDestruct(toState.name);
            if ($scope.selfDestructFlag) {
              repViewComponents();
            } else {
              defaultComponents();
            }
          }
        }
      } else if($rootScope.isOneViewInterface){
        repViewComponents();
        $scope.selfDestructFlag = true;
        $scope.isOneViewInterface = $rootScope.isOneViewInterface;
      }
    });

    $scope.changeLanguage = function () {
      if ($scope.lang === 'en') {
        languageSwitcher.changeLanguage('fr');
      } else {
        languageSwitcher.changeLanguage('en');
      }
      $rootScope.$broadcast('languageChanged');
    };

    $scope.onRepNameSelect = function () {
      return false;
    };

  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewSwitch', oneViewSwitch);

  oneViewSwitch.$inject = [];

  /* @ngInject */
  function oneViewSwitch() {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewSwitch/oneViewSwitch.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyrOneViewSwitchController'
    };

  }
})();


(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewToggle', oneViewToggle);

  oneViewToggle.$inject = ['$rootScope'];

  /* @ngInject */
  function oneViewToggle($rootScope) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewToggle/oneViewToggle.html',
      scope: { },
      restrict: 'EA',
      controller: 'MyrOneViewHeaderControllerOLD',
      controllerAs: 'oh',
      bindToController: true

    };

  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:oneViewWeatherController
   * @description
   * # oneViewWeatherController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('oneViewWeatherController', oneViewWeatherController);

  oneViewWeatherController.$inject = ['$scope',
    '$rootScope',
    'myrOneViewWeatherInfoService',
    'ute.blocks.language.switcher'];

  /* @ngInject */
  function oneViewWeatherController($scope,
                                    $rootScope,
                                    oneViewWeatherInfoService,
                                    languageSwitcher) {

        var ctrl = this;
        $scope.$extend({
        });
        ctrl.ovws = oneViewWeatherInfoService;
        $scope.weatherInformation = {};
        $scope.weatherConditionPresent = false;
        $scope.weatherContentAvailable = false;
        $scope.isWeatherInfoReady = false;
        $scope.addressUnavailable = false;
        var isRequestAvailable;

        $scope.getWeatherInformation = function(){
             var data = $rootScope.ao.accountDetails;

             if(data && data.billingAddress) {
                $scope.addressUnavailable = false;
                var streetAddress = (data.billingAddress.unit ? data.billingAddress.unit + '-' : '') + data.billingAddress.streetNumber + ' ' + data.billingAddress.streetName;
                var cityProvince = data.billingAddress.city + ' ' + data.billingAddress.province;
                var postalCode = data.billingAddress.postalCode;
                var city = data.billingAddress.city;
                $scope.weatherInformation = {
                     "streetAddress": streetAddress,
                     "cityProvince": cityProvince,
                     "postalCode": postalCode
                };
                var cityCodeResponse = function (cityCode) {
                      var weatherInfoResponse = function (weatherData) {
                          if(weatherData){
                              var weatherConditionsResponse = function(weatherConditionList){
                                  var currentWeatherObject = getCurrentWeatherObject(weatherData);
                                  if(currentWeatherObject){
                                      $scope.isWeatherInfoReady = true;
                                      $scope.weatherContentAvailable = true;
                                      $scope.weatherInformation = {
                                           "temperature": currentWeatherObject.temperature,
                                           "condition": currentWeatherObject.condition,
                                           "streetAddress": streetAddress,
                                           "cityProvince": cityProvince,
                                           "postalCode": postalCode,
                                           "imageName": getImageName(weatherConditionList, currentWeatherObject.condition)
                                      };

                                  }
                              }
                              var weatherConditionsError = function (){
                                  $scope.isWeatherInfoReady = true;
                                  $scope.weatherContentAvailable = false;
                              };
                              ctrl.ovws.getWeatherConditions(weatherConditionsResponse,weatherConditionsError);

                          } else{
                                $scope.isWeatherInfoReady = true;
                                $scope.weatherContentAvailable = false;

                          }
                      };
                     var weatherInfoError = function (){
                          $scope.isWeatherInfoReady = true;
                          $scope.weatherContentAvailable = false;
                      };
                      ctrl.ovws.getWeatherInfo(cityCode,weatherInfoResponse,weatherInfoError);
                };

                var cityCodeError = function () {
                    $scope.isWeatherInfoReady = true;
                    $scope.weatherContentAvailable = false;
                };
                if(!data.billingAddress.city || !data.billingAddress.province ||
                      data.billingAddress.city.trim() === '' || data.billingAddress.province.trim() === ''){
                      $scope.isWeatherInfoReady = true;
                      $scope.weatherContentAvailable = false;
                } else {
                      ctrl.ovws.getCityCode(city, data.billingAddress.province, cityCodeResponse, cityCodeError);
                }
            } else {
                $scope.isWeatherInfoReady = true;
                $scope.weatherContentAvailable = false;
                $scope.addressUnavailable = true;
            }

        };

       function getCurrentWeatherObject(data){
            for (var i in data.entries) {
                if(data.entries[i].subject === 'Current Conditions'){
                    return data.entries[i];
                }
            }
            return null;
       }

        function getImageName(weatherConditionList, condition) {
            $scope.weatherConditionPresent = false;
            var imageName = "";
            if(condition){
                if(weatherConditionList.indexOf(condition) > -1){
                    $scope.weatherConditionPresent = true;
                    condition.split(" ").forEach(function (el, idx) {
                        var add = el.toLowerCase();
                        imageName += (idx === 0 ? add : add[0].toUpperCase() + add.slice(1));
                    });
                    imageName = '/web/totes/cms/ute/rogers/consumer/oneview/images/weather/'+imageName+'.png';
                } else{
                   $scope.weatherConditionPresent = false;
                   imageName = condition;
                   if(condition == 'Not observed' || condition == 'No Match'){
                        imageName = '';
                   }
                }
            }
            return imageName;
        }

        var rootwatch1 = $rootScope.$watch('ao.accountDetails', function (newVal, oldVal) {
        if($rootScope.isCare || $rootScope.isDealer){
              if (newVal) {
                if(!oldVal){
                    isRequestAvailable=true;
                    $scope.getWeatherInformation();
                } else if(oldVal && newVal.billingAddress.city != oldVal.billingAddress.city) {
                    isRequestAvailable=true;
                    $scope.getWeatherInformation();
                }
              }
          }
        });

    languageSwitcher.registerOnDataChangeHandler(function () {
      if(isRequestAvailable) {
        $scope.isWeatherInfoReady = false;
        $scope.getWeatherInformation();

      }
    }, 'oneViewWeatherControllerLangSub');

    $scope.$on('$destroy', function() {
      languageSwitcher.unregisterOnDataChangeHandler('oneViewWeatherControllerLangSub');
      rootwatch1(); //n
    });

  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('oneViewWeather', oneViewWeather);

  oneViewWeather.$inject = [];

  /* @ngInject */
  function oneViewWeather($log) {
    return {
      templateUrl: 'scripts/modules/oneView/oneViewWeather/oneViewWeather.html',
      restrict: 'EA',
      controller: 'oneViewWeatherController',
      controllerAs: 'al',
      bindToController: true
    };
  }
})();
(function () {
  'use strict';

  /**
   * @ngdoc module
   * @name totesApp.module:oneViewWeatherInfoService
   * @description
   * # oneViewWeatherInfoService
   */
  angular.module('totesApp').factory('myrOneViewWeatherInfoService', oneViewWeatherInfoService);

  oneViewWeatherInfoService.$inject = ['$rootScope','ajax','$http','settings'];

  function oneViewWeatherInfoService($rootScope,ajax,$http,settings) {

       var service = {
            weatherInfo : null,
            getWeatherInfo : getWeatherInfo,
            getCityCode : getCityCode,
            getWeatherConditions : getWeatherConditions
       };

       return service;

       var url = '';
       var city = '';
       var cityCode = '';
       var weatherInfo = {};
       var postalCode = '';
       var cityProvince = '';
       var streetAddress = '';

       function getCityCode(city , province, cityCodeResponse, cityCodeError){
            var cityCode = '';
            $http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/weather/cityCodes.json').then(function (response) {
              var mappings = response.data;
               if (city && mappings && province && titleCase(city) && mappings[province.toUpperCase()] &&
                   mappings[province.toUpperCase()][titleCase(city)]) {
                  cityCode = mappings[province.toUpperCase()][titleCase(city)];
                  cityCodeResponse(cityCode);
                } else {
                  cityCodeError();
               }

            },
            function (error){
                cityCodeError();
            });
        }

        function getWeatherConditions(weatherConditionsResponse,weatherConditionsError){
          $http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/weather/weatherConditions.json').then(function (response) {
            var weatherConditions = response.data;
            if (weatherConditions && weatherConditions.weatherConditionList) {
              weatherConditionsResponse(weatherConditions.weatherConditionList);
            } else {
              weatherConditionsError();
            }
          },
          function (error){
              weatherConditionsError();
          });
        }

       function getWeatherInfo(cityCode,callbackSuccess,callBackError){
              var weatherData = '';
              var request = {
                  url:settings.oneViewExternalAPIs.weather,
                  moduleName:cityCode+'_E',
                  method: "GET",
                  headerData : {"Content-Type": "application/json","Access-Control-Allow-Origin": "news-weather-feeds-prod.herokuapp.com" ,"AccessControlAllowCredentials": true }
              };
              $.ajax(request.url+request.moduleName, {
                cache:false,
                success: function (response, status) {
                    //sessionStorage.setSessionStorageValue('weatherFeed',JSON.stringify(response));
                    weatherData = response;
                    return callbackSuccess(weatherData);
                },
                error: function (error, status) {
                    console.log('oneViewWeatherService :: getWeather :: error');
                    /*if(sessionStorage.getSessionStorageValue('weatherFeed')){
                        weatherData = JSON.parse(sessionStorage.getSessionStorageValue('weatherFeed'));
                    }*/
                    return callBackError();
                }
              });
       }

       function titleCase(city) {
             city = city.toLowerCase().split(' ');
             for(var i = 0; i < city.length; i++){
               city[i] = city[i].split('');
               if(city[i][0])
               city[i][0] = city[i][0].toUpperCase();
               city[i] = city[i].join('');
             }
             return city.join(' ');
       }

       function searchConditionInArray (str, strArray) {
           for (var j=0; j<strArray.length; j++) {
               if (strArray[j].match(str)) return j;
           }
           return -1;
       }

  }
}());

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyRepFeedbackController', repFeedbackController);

  repFeedbackController.$inject = ['$scope', '$rootScope', '$q', 'localStorage', 'ajax', '$element', 'settings', '$browser', '$cookies', 'ute.blocks.language.switcher', 'sessionStorage'];

  /* @ngInject */
  function repFeedbackController($scope, $rootScope, $q, localStorage, ajax, $element, settings, $browser, $cookies, languageSwitcher, sessionStorage) {
    $scope.$extend({});

    $scope.userTypeDealer = $rootScope.isDealer;
    $scope.userTypeCare = $rootScope.isCare;
    if ($rootScope.isDealer || $rootScope.isCare) {
      $element.find('#feedback-tab').hide();
      $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
    }
    $scope.openSurveyLink = function () {
      $scope.lang = languageSwitcher.getCurrentLanguage();
      var browserName = $scope.getBrowserName();
      //console.log('client browserName' + browserName);
      var browserVer = $.browser.version;
      //console.log('client browserVer' + browserVer);
      var os = $scope.getOs();
      var sessionId = '';
      var site = 'rogers.com';
      var ban = localStorage.getLocalStorageValue('accountNumber');
      if ($rootScope.isCare) {
        ban = sessionStorage.getSessionStorageValue('accountNumber');
      }
      var userId = '';
      if ($scope.userTypeDealer) {
        userId = $rootScope.userInfo.cfaInfo.cfaInfo.userId;
        if ($rootScope.userInfo.cfaInfo.playSessionId) {
          sessionId = $rootScope.userInfo.cfaInfo.playSessionId.split('-');
        }
      } else if ($scope.userTypeCare) {
        /*userId = data.repInfo.loginId;
         if(data.playSessionId){
         sessionId = data.playSessionId.split('-');
         }*/
        userId = $rootScope.userInfo.careInfo.repInfo.loginId;
        if ($rootScope.userInfo.careInfo.playSessionId) {
          sessionId = $rootScope.userInfo.careInfo.playSessionId.split('-');
        }
      }
      var surveyUrl = 'https://www.surveymonkey.com/r/3K87P7G?userid=' + userId +
          '&' + 'browser=' + browserName + '&' + 'browserversion=' + browserVer +
          '&' + 'os=' + os + '&' + 'sessionid=' + sessionId[0] + '&' + 'site=' + site + '&' + 'currentban=' + ban;
      if ($scope.lang === 'fr') {
        surveyUrl = 'https://fr.surveymonkey.com/r/XQLJHDT?userid=' + userId +
            '&' + 'browser=' + browserName + '&' + 'browserversion=' + browserVer +
            '&' + 'os=' + os + '&' + 'sessionid=' + sessionId[0] + '&' + 'site=' + site + '&' + 'currentban=' + ban;
      }
      window.open(surveyUrl, '_blank');
    };

    $scope.getOs = function () {
      var nAgt = navigator.userAgent;
      var os = '';
      var clientStrings = [
        {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
        {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
        {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
        {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
        {s: 'Windows Vista', r: /Windows NT 6.0/},
        {s: 'Windows Server 2003', r: /Windows NT 5.2/},
        {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
        {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
        {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
        {s: 'Windows 98', r: /(Windows 98|Win98)/},
        {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
        {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
        {s: 'Windows CE', r: /Windows CE/},
        {s: 'Windows 3.11', r: /Win16/},
        {s: 'Android', r: /Android/},
        {s: 'Open BSD', r: /OpenBSD/},
        {s: 'Sun OS', r: /SunOS/},
        {s: 'Linux', r: /(Linux|X11)/},
        {s: 'iOS', r: /(iPhone|iPad|iPod)/},
        {s: 'Mac OS X', r: /Mac OS X/},
        {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
        {s: 'QNX', r: /QNX/},
        {s: 'UNIX', r: /UNIX/},
        {s: 'BeOS', r: /BeOS/},
        {s: 'OS/2', r: /OS\/2/},
        {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
      ];
      for (var id in clientStrings) {
        var cs = clientStrings[id];
        if (cs.r.test(nAgt)) {
          os = cs.s;
          break;
        }
      }
      return os;
    };

    $scope.getBrowserName = function () {
      var nAgt = navigator.userAgent;
      var browser = navigator.appName;
      var version = '' + parseFloat(navigator.appVersion);
      var nameOffset, verOffset, ix;

      // Opera
      if ((verOffset = nAgt.indexOf('Opera')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 6);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Opera Next
      if ((verOffset = nAgt.indexOf('OPR')) != -1) {
        browser = 'Opera';
        version = nAgt.substring(verOffset + 4);
      }
      // MSIE
      else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(verOffset + 5);
      }
      // Chrome
      else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
        browser = 'Chrome';
        version = nAgt.substring(verOffset + 7);
      }
      // Safari
      else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
        browser = 'Safari';
        version = nAgt.substring(verOffset + 7);
        if ((verOffset = nAgt.indexOf('Version')) != -1) {
          version = nAgt.substring(verOffset + 8);
        }
      }
      // Firefox
      else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
        browser = 'Firefox';
        version = nAgt.substring(verOffset + 8);
      }
      // MSIE 11+
      else if (nAgt.indexOf('Trident/') != -1) {
        browser = 'Microsoft Internet Explorer';
        version = nAgt.substring(nAgt.indexOf('rv:') + 3);
      }
      // Other browsers
      else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
        browser = nAgt.substring(nameOffset, verOffset);
        version = nAgt.substring(verOffset + 1);
        if (browser.toLowerCase() == browser.toUpperCase()) {
          browser = navigator.appName;
        }
      }
      return browser;
    };
  }
})();





(function () {
  'use strict';

  angular.module('totesApp').directive('repFeedback', repFeedback);

  repFeedback.$inject = [];

  /* @ngInject */
  function repFeedback($log) {
    return {
      templateUrl: 'scripts/modules/oneView/repFeedback/repFeedback.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyRepFeedbackController',
      controllerAs: 'ssp',
      bindToController: true
    };

  }
})();


// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  /**
   * @ngdoc function
   * @name totesApp.controller:sspDashBoardController
   * @description
   * # sspDashBoardController
   * Controller of the totesApp
   */
  angular.module('totesApp').controller('MyrSspDashBoardControllerOLD', sspDashBoardControllerOLD);

  sspDashBoardControllerOLD.$inject = ['$scope', '$rootScope', 'ute.blocks.language.switcher', 'localStorage', 'ajax', '$element', 'settings', '$browser', 'sessionStorage', 'backToSSPService', 'ute.blocks.messages.bus.service'];

  /* @ngInject */
  function sspDashBoardControllerOLD($scope, $rootScope, languageSwitcher, localStorage, ajax, $element, settings, $browser, sessionStorage, backToSSPService, messagesService) {

    $scope.$extend({

    });

    $scope.userTypeDealer = $rootScope.isDealer;
    if($rootScope.isDealer || $rootScope.isCare){
        $element.find('#feedback-tab').hide();
      $element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
    }

    $scope.backToSSPdashBoard = function () {
      $rootScope.targetFlow = 'sspdashboard';
      backToSSPService.backToSSP();
    };
  }

})();





(function () {
  'use strict';

  angular.module('totesApp').directive('sspDashboardOLD', sspDashBoardOLD);

  sspDashBoardOLD.$inject = [];

  /* @ngInject */
  function sspDashBoardOLD($log) {
    return {
      templateUrl: 'scripts/modules/oneView/sspDashBoard/sspDashBoard.html',
      scope: {},
      restrict: 'EA',
      controller: 'MyrSspDashBoardControllerOLD',
      controllerAs: 'ssp',
      bindToController: true
    };

  }
})();

/*.controller('sspDashboardCtrl', ['$scope', '$rootScope', 'ute.blocks.language.switcher', 'localStorage', 'ajax', '$element', 'settings', '$browser',
			function ($scope, $rootScope, languageSwitcher, localStorage, ajax, $element, settings, $browser) {
        $scope.userTypeDealer = $rootScope.isDealer;
        if($rootScope.isDealer || $rootScope.isCare){
            $element.find('#feedback-tab').hide();
            $element.find("#footer a[onclick='javascript:FSR.popFeedback()']").hide();
        }
        $scope.backToSSPdashBoard = function () {
          var cookies = $browser.cookies();
          var language = cookies.language;
          var province = cookies.province;
         // alert("language:"+language+" province:"+province);
          var postData;
          if(localStorage.getLocalStorageValue('toStateName')==="wireless") {
                postData = {
                   ctn: localStorage.getLocalStorageValue('phoneNumber'),
                   accountNumber: localStorage.getLocalStorageValue('accountNumber'),
                   lang: language,
                   prov: province,
                   targetFlow :"sspdashboard"
                };
          }
          else {
            postData = {
               ctn: "",
               accountNumber: localStorage.getLocalStorageValue('accountNumber'),
               lang: language,
               prov: province,
               targetFlow :"sspdashboard"
            };
          }
          ajax.backToSSP(postData).then(
              function (data) {
                if(data.isCableOnly) {
                  $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                  $('#formToSSP').submit();
                } else {
                  $('#formToSSP').find("#sharedKey").val(data.sharedKey);
                  $('#formToSSP').find("#signature").val(data.signature);
                  $('#formToSSP').find("#content").val(data.content);
                  $('#formToSSP').attr('action', data.envPath +  settings.agentInfo.sspDashboardURL);
                  $('#formToSSP').submit();
                }
              },
              function (error) {
                $('#formToSSP').attr('action', data.envPath + settings.agentInfo.signoutURL);
                $('#formToSSP').submit();
              }
          );
        };
}]);
*/

'use strict';
/*
Global banner widget. When included, it will display a banner with the Rogers icon and
available types:
--success
--warning
--error
--info
Example:
 <notificationBanner type="success" message="resource-key"></notificationBanner>
 */
angular
	.module('totesApp')
	.directive('successBanner', function () {
		return {
			scope: {
				type:'=',
				message:'='
			},
			templateUrl: 'scripts/directives/oneview/successBanner/successBanner.html',
			replace: true,
			restrict: 'E',
			link: function (scope) {
				scope.success=true;
			}
		};
	});

//https://github.com/fraywing/textAngular/issues/503
// The checkbox and radio buttons does not work properly when we use both angular-touch and bootstrap modal in mobile devices (iOS), so the following directive was added to prevent touch event in modals
angular.module('totesApp').directive('bfaStopEvent', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attr) {
      element.on(attr.bfaStopEvent, function (e) {
        e.stopPropagation();
        console.log('bfaStopEvent' ,attr);
      });
    }
  };
});

(function () {
  'use strict';

  angular.module('totesApp').service('bfappcWirelessDashboardService', bfappcWirelessDashboardService);

  bfappcWirelessDashboardService.$inject = ['$q',
    '$state',
    '$modal',
    'ajax',
    '$translate',
    'localStorage',
    'pricePlanChangesErrors',
    'myrWirelessDashboardService',
    'sessionStorage',
    'ute.common.core.brtswitch.service',
    'ute.blocks.language.switcher',
    'ute.common.user.service',
    'ute.dtm.service',
    'ute.blocks.persistent.storage.service',
    '$window',
    '$location',
    'ngDialog'];

  function bfappcWirelessDashboardService($q,
                                          $state,
                                          $modal,
                                          ajax,
                                          $translate,
                                          localStorage,
                                          pricePlanChangesErrors,
                                          myrWirelessDashboardService,
                                          sessionStorage,
                                          brtSwitchService,
                                          languageSwitcher,
                                          userService,
                                          dtmService,
                                          utePersistentStorageService,
                                          $window,
                                          $location,
                                          ngDialog) {
    var dtmBuyFlowError = 'fdm-bf-error';
    var self = {
      scope: {},
      fetchOrderCompleted: false,
      bfappcOrders: [],
      bfahupOrders: [],
      // brtSwitch: {
      //   ppc: null,
      //   mppc: null,
      //   q2ppc: null
      // },
      permission: {
        ppc: null,
        mppc: null
      },
      subscribers: null,
      selectedAdditionalSubscribers: [],
      selectedPrimary: '',
      changeBtnLoadingStatus: false,
      heroRedirect: false,
      heroOfferObject: {}
    };

    self.hasOrder = function (ctn) {
      return self.bfappcOrders.length > 0 && self.getSwitchToOrder(ctn) && self.getOnlyOrders(ctn).length > 0;
    };

    self.getOnlyOrders = function (ctn) {
      return _.filter(self.bfappcOrders, function (order) {
        return _.indexOf(order.assemblyIds, ctn) >= 0 && !order.quotation;
      });
    };

    self.getCurrentOrder = function (ctn) {
      return _.find(self.bfappcOrders, function (order) {
        return order.currentOrder === true && _.indexOf(order.assemblyIds, ctn) >= 0;
      });
    };

    self.getSwitchToOrder = function (ctn) {
      return _.find(self.bfappcOrders, function (order) {
        return _.find(order.assemblyIds, function (assemblyId) {
          return assemblyId == ctn;
        });
      });
    };

    self.isFetchOrderCompleted = function () {
      return self.fetchOrderCompleted;
    };

    self.fetchOrder = function (postData) {
      //console.info('fetchOrder');
      //ajax.fetchOrder().then(
      var deferred = $q.defer();
      ajax.fetchCartOrder(postData).then(
        function (response) {
          self.fetchOrderCompleted = true;
          if (response && response.success) {
            self.fetchOrderFullResponse = response;
            deferred.resolve(self.fetchOrderFullResponse);
            if (response.ppc && response.ppc.length) {
              self.bfappcOrders = response.ppc;
            }
          } else {
            // PPC TODO: error message on fetch error
          }
          if (response.hup && response.hup.length){
            self.bfahupOrders = response.hup;
          }
        }
      ).catch(
        function () {
          self.fetchOrderCompleted = true;
          deferred.reject();
          // PPC TODO: error message on fetch error
        }
      );
      return deferred.promise;
    };

    var trackPpcDtmError = function (errorMessage) {
      try {
        var dtmMessage = angular.element('<span>' + errorMessage + '</span>');
        dtmService.setVar('error', dtmMessage.text() + '|PPC');
        dtmService.direct(dtmBuyFlowError);
        dtmMessage = null;
      } catch (err) {
        console.log('trackPpcDtmError:', err);
      }
    };

    self.gotoBFAPPC = function (appStateForPPC, resumeOrder, planSoc) {
      var deferred = $q.defer();
      self.appStateForPPC = appStateForPPC;
      self.processAllowedPpcBrt(deferred, resumeOrder, planSoc);
      return deferred.promise;
    };

    self.singleLineHeroRedirect = function(){
      if(self.heroOfferObject){
        var planSocParam = self.heroOfferObject.planSoc;
        console.log("planSocParam :" + planSocParam);
        var pricePlanUrl = '?soc='+ planSocParam ;
          if(self.heroOfferObject.bpoID){
              var bpoID = self.heroOfferObject.bpoID;
              var bpoIDPlanUrl = '?soc='+ planSocParam + '&bpoSoc=' + bpoID;
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan' + bpoIDPlanUrl;
          } else {
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan' + pricePlanUrl;
          }
      }

    }

    self.multipleLineHeroRedirect = function(){
      if(self.heroOfferObject){
        var planSocParam = self.heroOfferObject.planSoc;
        console.log("planSocParam :" + planSocParam);
        var pricePlanUrl = '?soc='+ planSocParam ;
          if(self.heroOfferObject.bpoID){
              var bpoID = self.heroOfferObject.bpoID;
              var bpoIDPlanUrl = '?soc='+ planSocParam + '&bpoSoc=' + bpoID;
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-share-plan' + bpoIDPlanUrl;
          } else {
              $window.location.href = '/web/totes/wireless-plan-change/#/choose-share-plan' + pricePlanUrl;
          }
      }

    }
    self.processAllowedPpcBrt = function(deferred, resumeOrder, planSoc) {
    var planSocBpo ={};
    if (planSoc != null && planSoc !== undefined && planSoc !== '') {
       self.heroRedirect = true;
       self.heroOfferObject =planSoc;
    }
    planSocBpo = planSoc;
        self.hasMultipleSubscribers(planSocBpo).then(
            function(tempObj) {
                if (!tempObj.noOfSubscribers) {
                   /* if (tempObj.deeplinkPlanSoc != null && tempObj.deeplinkPlanSoc !== undefined && tempObj.deeplinkPlanSoc !== '') {

                        deferred.resolve();

                        var planSocParam = tempObj.deeplinkPlanSoc.planSoc;
                        console.log("planSocParam :" + planSocParam);
                        var pricePlanUrl = '?soc='+ planSocParam ;
                          if(tempObj.deeplinkPlanSoc.bpoID){
                              var bpoID = empObj.deeplinkPlanSoc.bpoID;
                              var bpoIDPlanUrl = '?soc='+ planSocParam + '&bpoSoc=' + bpoID;
                              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan' + bpoIDPlanUrl;
                          } else {
                              $window.location.href = '/web/totes/wireless-plan-change/#/choose-plan' + pricePlanUrl;
                          }
                    } else {*/
                        deferred.resolve();
                        self.checkEligibilityAndSaveState('single', 'all').then(function() {
                        if(self.heroRedirect){
                          self.singleLineHeroRedirect();
                        }else{
                          $state.go('ppc-singleline');
                        }

                        });
                   // }
                } else {
                    /*if (tempObj.deeplinkPlanSoc != null && tempObj.deeplinkPlanSoc !== undefined && tempObj.deeplinkPlanSoc !== '') {
                        var planSocParam = tempObj.deeplinkPlanSoc;
                        console.log("planSocParam :" + planSocParam);
                        var pricePlanUrl = '?soc='+ planSocParam ;
                          if(tempObj.deeplinkPlanSoc.bpoID){
                              var bpoID = empObj.deeplinkPlanSoc.bpoID;
                              var bpoIDPlanUrl = '?soc='+ planSocParam + '&bpoSoc=' + bpoID;
                              $window.location.href = '/web/totes/wireless-plan-change/#/choose-share-plan' + bpoIDPlanUrl;
                          } else {
                              $window.location.href = '/web/totes/wireless-plan-change/#/choose-share-plan' + pricePlanUrl;
                          }
                    }*/
                    self.redirectToPpc(resumeOrder);
                }
            }
        );
    };

    self.isMultiline = function () {
      var deferred = $q.defer();
      // Abdellatif said, if there is an additional subscriber, it is multiline, no matter what the current ctn is
      self.getSubscribers().then(
        function (subscribers) {
          var isMultiline = _.filter(subscribers, function (subscriber) {
              return subscriber.familyShareStatus === 'Additional';
            }).length > 0;
          deferred.resolve(isMultiline);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    self.hasMainSubscriber = function () {
      var deferred = $q.defer();
      self.getSubscribers().then(
        function (subscribers) {
          var hasMain = _.filter(subscribers, function (subscriber) {
              return subscriber.familyShareStatus === 'Main';
            }).length > 0;
          deferred.resolve(hasMain);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    self.hasMultipleSubscribers = function (planSocBpo) {
      var planSocBpoDisplay ={};
      planSocBpoDisplay = planSocBpo;
      var deferred = $q.defer();
      self.getSubscribers().then(
        function (subscribers) {
        var tempObj = {};
         tempObj.noOfSubscribers = subscribers.length > 1 ? true : false;
         tempObj.deeplinkPlanSoc = planSocBpoDisplay;
          deferred.resolve(tempObj);
        },
        function () {
          deferred.reject();
        }
      );
      return deferred.promise;
    };

    // self.isBRT = function (type) {
    //   var deferred = $q.defer();
    //   if (self.brtSwitch[type] !== null) {
    //     deferred.resolve(self.brtSwitch[type]);
    //   } else {
    //     ajax.getBrtSwitches().then(
    //       function (response) {
    //         // keep the value for PPC_UTE switch, if true means q2PPC(old PPC) is on the BRT mode.
    //         self.brtSwitch.q2ppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'PPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         self.brtSwitch.ppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'NPPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         self.brtSwitch.mppc = Boolean(_.result(_.find(response, function (obj) {
    //           return obj.id === 'MULTI_NPPC_UTE';
    //         }), 'switchIsOn'));
    //
    //         deferred.resolve(self.brtSwitch[type]);
    //       },
    //       function () {
    //         pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
    //         self.changeBtnLoading(false);
    //         deferred.reject();
    //       }
    //     );
    //   }
    //   return deferred.promise;
    // };

    self.isEligible = function (flowType) {
      var deferred = $q.defer();
      var isPpcEligible = false;
      var isPpcBotEligible = false;
      var ppcEligibilityChecks = [];
      var postData = {
        accountNumber: (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber'),
        accountTypeNumber: (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber'),
        subscriberNumber: (userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'),
        consolidatedInd: 'NO',
        flowType: flowType
      };
      if (self.selectedPrimary !== '' && self.selectedPrimary !== null) {
        postData.subscriberNumber = self.selectedPrimary;
      }
      ppcEligibilityChecks.push(ajax.checkEligibility(postData).then(
        function (response) {
          self.appStateForPPC.eligibilityChecked = response.eligible;
          self.appStateForPPC.availableCreditAmount = response.availableCreditAmount;

          if (response.eligible) {
            isPpcEligible = true;
            return isPpcEligible;
          } else {
            var errorResponse = (response && response.eligibilityCode) ? response : {
              'eligible': false,
              'eligibilityCode': '500'
            };
            $modal.open({
              controller: 'notEligibleModalCtrl',
              controllerAs: 'vm',
              templateUrl: 'views/modals/ppc-not-eligible.html',
              size: 'md',
              backdrop: 'static',
              backdropClass: 'bkg-modal',
              resolve: {
                'eligibilityResponse': function () {
                  return errorResponse;
                }
              }
            });
            deferred.reject();
          }
        },
        function (response) {
          if (response && response.eligibilityCode) {
            $modal.open({
              controller: 'notEligibleModalCtrl',
              controllerAs: 'vm',
              templateUrl: 'views/modals/ppc-not-eligible.html',
              size: 'md',
              backdrop: 'static',
              backdropClass: 'bkg-modal',
              resolve: {
                'eligibilityResponse': function () {
                  return response;
                }
              }
            });
          } else {
            pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
            trackPpcDtmError($translate.instant('ppc_something_went_wrong_message_text'));
          }
          self.changeBtnLoading(false);
          deferred.reject();
        }
      ).finally(
        function () {
          //self.selectedPrimary = null;
        }
      ));
      if (userService.isCare() || userService.isDealer()) {
        var request = {
          accountNumber: (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber'),
          lang: languageSwitcher.getCurrentLanguage().toUpperCase()
        };
        utePersistentStorageService.putToSession('botFlowType', 'PPC'); //BCR-693 Analytics: Tracking flowType for getCases api
        ppcEligibilityChecks.push(ajax.checkBOTEligibility(request).then(
          function (responseBOT) {
            var isBOTEligible = true;
            var openCases = {};
            angular.forEach(responseBOT.getCasesResponse.cases._case, function (value, key) {
              if ((value.caseStatus.toLowerCase() === "new" || value.caseStatus.toLowerCase() === "in progress" || value.caseStatus.toLowerCase() === "new case") && (value.caseTypeLevel3.toLowerCase() === "hup" || value.caseTypeLevel3.toLowerCase() === "price plan change")) {
                isBOTEligible = false;
                openCases = value;
              }
            });
            if (isBOTEligible) {
              isPpcBotEligible = true;
              return isPpcBotEligible;
            }
            else {
              if (isPpcEligible) {
                var errorResponse = (responseBOT && responseBOT.eligibilityCode) ? responseBOT : {
                  eligible: false,
                  eligibilityCode: 'bot_eligible',
                  openCases: openCases
                };
                $modal.open({
                  controller: 'notEligibleModalCtrl',
                  controllerAs: 'vm',
                  templateUrl: 'views/modals/ppc-not-eligible.html',
                  size: 'md',
                  backdrop: 'static',
                  backdropClass: 'bkg-modal',
                  resolve: {
                    'eligibilityResponse': function () {
                      return errorResponse;
                    }
                  }
                });
                deferred.reject();
              }
            }
          }, function (error) {
            pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
            self.changeBtnLoading(false);
            deferred.reject();
          }
        ));
      }

      $q.all(ppcEligibilityChecks).then(function (response) {
        if (response.length === 1) {
          if (response[0]) {
            deferred.resolve();
          }
        }
        else {
          if (response[0] && response[1]) {
            deferred.resolve();
          }
        }
      });

      return deferred.promise;
    };

    self.saveState = function (filterOption) {
      filterOption = filterOption || 'all';
      self.appStateForPPC.ban = (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber');
      self.appStateForPPC.ctnWirelessDashboard = (userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
      if (self.selectedPrimary !== '' && self.selectedPrimary !== null) {
        self.appStateForPPC.ctn = self.selectedPrimary;
      } else {
        self.appStateForPPC.ctn = self.appStateForPPC.ctnWirelessDashboard;
      }
      self.appStateForPPC.accountTypeNumber = (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountTypeNumber') : localStorage.getLocalStorageValue('accountTypeNumber');
      self.appStateForPPC.selectedAdditionalSubscribers = self.selectedAdditionalSubscribers.join(',');

      self.appStateForPPC.ctnList = _.pluck(myrWirelessDashboardService.getWirelessDashData(), 'ctn');
      self.appStateForPPC.filterOption = filterOption;
      return ajax.setState(self.appStateForPPC);
    };

    self.getSubscribers = function () {

      var deferred = $q.defer();
      var postData = {
        accountNumber: (userService.isCare()) ? sessionStorage.getSessionStorageValue('accountNumber') : localStorage.getLocalStorageValue('accountNumber')
      };
      if (self.subscribers !== null) {
        deferred.resolve(self.subscribers);
      } else {
        ajax.subscribers(postData).then(
          function (response) {
            self.subscribers = response.subscribers;
            deferred.resolve(response.subscribers);
          },
          function () {
            pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
            self.changeBtnLoading(false);
            trackPpcDtmError($translate.instant('ppc_something_went_wrong_message_text'));
            deferred.reject();
          }
        );
      }
      return deferred.promise;
    };

    self.redirectToPpc = function (resumeOrder) {
      if (resumeOrder) {
        self.appStateForPPC.eligibilityChecked = false;
        self.saveState().then(
          function () {
            $state.go('ppc-resume-order');
          }
        );
        return;
      }

      //if mainSubscriber is undefined it means there is no shared group
      var mainSubscriber = _.find(self.subscribers, function (subscriber) {
        return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
      });

      var currentCtnShareStatus = _.result(_.find(self.subscribers, function (subscriber) {
        return subscriber.subscriberNumber === ((userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'));
      }), 'familyShareStatus');

      var numberOfAdditionalSubscribers = 0;
      var numberOfIndividualSubscribers = 0;
      angular.forEach(self.subscribers, function (subscriber) {
        if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional') {
          numberOfAdditionalSubscribers++;
        }
        if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Individual') {
          numberOfIndividualSubscribers++;
        }
      });

      if (mainSubscriber !== undefined) {
        // below cases are defined in BFA-1911

        if (numberOfAdditionalSubscribers == 0 && currentCtnShareStatus === 'Main') {
          // if there is only 1 subscriber and it is 'main', user must be directed to single line NOT multi line
          // or 'main' & 1+ 'individual' & no additional, also redirect to SL-PPC
          self.checkEligibilityAndSaveState('single', 'all').then(function () {
            if(self.heroRedirect){
              self.singleLineHeroRedirect();
            }else{
              $state.go('ppc-singleline');
            }
          });
        } else if (currentCtnShareStatus === 'Additional') {
          self.isEligible('multi').then(function () {
            self.selectedPrimary = mainSubscriber.subscriberNumber;
            self.checkEligibilityAndSaveState('multi', 'main').then(function () {
            if(self.heroRedirect){
               self.multipleLineHeroRedirect();
            }else{
              $state.go('ppc-multiline-entry-2');
            }
            });
          });
        } else if (currentCtnShareStatus === 'Main') {
          //customer already has a shared group and selected an additional/main CTN
          // bfa-4584: check main ctn eligibility before going into ML flow
          // previous logic: covers 4, 5, 7 - As Abdellatif said, for entry point 2, we should do eligibility check in the entry point itself only for main and we should do eligibility check for additional lines in the calling options page
          self.selectedPrimary = mainSubscriber.subscriberNumber;
          self.checkEligibilityAndSaveState('multi', 'main').then(function () {
            if(self.heroRedirect){
              self.multipleLineHeroRedirect();
            }else{
              $state.go('ppc-multiline-entry-2');
            }
          });
        } else if (currentCtnShareStatus === 'Individual') {
          //customer already has a shared group and selected an individual CTN
          //covers 6
          if(self.heroRedirect){
            self.singleLineHeroRedirect();
          } else {
          self.showThirdMultiLineEntry();
          }
        }

      } else if (currentCtnShareStatus === 'Individual') {
        //covers cases 1, 2, 3
        if (numberOfIndividualSubscribers == 1) {
          self.checkEligibilityAndSaveState('single', 'all').then(function () {
            if(self.heroRedirect){
              self.singleLineHeroRedirect();
            }else{
               $state.go('ppc-singleline');
            }
          });
        } else {
            if(self.heroRedirect){
              self.singleLineHeroRedirect();
            } else {
              self.showFirstMultiLineEntry();
          }
        }

      }
    };

    self.showThirdMultiLineEntry = function () {
      var entry3ModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html',
        controller: 'mppcEntry3Ctrl'
      });

      entry3ModalInstance.result.then(
        function (response) {
          if (response === 'changeCurrentPlan') {
            self.checkEligibilityAndSaveState('single', 'individual').then(function () {
              if(self.heroRedirect){
                self.singleLineHeroRedirect();
              }else{
                 $state.go('ppc-singleline');
              }
            });
          } else if (response === 'addToSharedGroup') {
            self.selectedAdditionalSubscribers = _.pluck(_.filter(self.subscribers, function (subscriber) {
              return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional';
            }), 'subscriberNumber');
            self.selectedAdditionalSubscribers.push((userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber'));

            self.selectedPrimary = _.find(self.subscribers, function (subscriber) {
              return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
            }).subscriberNumber;
            self.checkEligibilityAndSaveState('multi', 'main').then(function () {
              $state.go('ppc-multiline-step-2');
            });
          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.showFirstMultiLineEntry = function () {
      var entry1ModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html',
        controller: 'mppcEntry1Ctrl'
      });

      entry1ModalInstance.result.then(
        function (response) {
          if (response === 'changeCurrentPlan') {
            self.checkEligibilityAndSaveState('single', 'all').then(function () {
              if(self.heroRedirect){
                self.singleLineHeroRedirect();
              }else{
                 $state.go('ppc-singleline');
              }

            });
          } else if (response === 'createSharedGroup') {
            self.createSharedGroup();
          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.createSharedGroup = function () {
      var shareGroupIndividualModalInstance = $modal.open({
        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html',
        controller: 'mppcSharedGroupIndividualModalCtrl',
        resolve: {
          subscribers: function () {
            return self.subscribers;
          },
          currentCtn: function () {
            return (userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
          }
        }
      });

      shareGroupIndividualModalInstance.result.then(
        function (selectedAdditionalSubscribers) {
          // we need to group the current CTN with these selected subscribers
          console.log('selectedAdditionalSubscribers: ', selectedAdditionalSubscribers);
          var currentCtn = (userService.isCare()) ? sessionStorage.getSessionStorageValue('phoneNumber') : localStorage.getLocalStorageValue('phoneNumber');
          if (selectedAdditionalSubscribers.length > 0) {
            self.selectedAdditionalSubscribers = selectedAdditionalSubscribers;
            var shareGroupPrimaryModalInstance = $modal.open({
              templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html',
              controller: 'mppcSharedGroupPrimaryModalCtrl',
              resolve: {
                selectedAdditionalSubscribers: function () {
                  return selectedAdditionalSubscribers;
                },
                currentCtn: function () {
                  return currentCtn;
                }
              }
            });

            shareGroupPrimaryModalInstance.result.then(
              function (selectedPrimary) {
                console.log('selectedPrimary', selectedPrimary);
                if (selectedPrimary) {
                  if (selectedPrimary != currentCtn) {
                    //if user changed the primary subscriber, so old primary one should be an additional now!
                    self.selectedAdditionalSubscribers.push([currentCtn]);
                    //the new selectedPrimary ctn must ne remove from selectedAdditionalSubscribers, because it is a primary now!
                    _.remove(selectedAdditionalSubscribers, function (item) {
                      return item === selectedPrimary;
                    });
                  }
                  self.selectedPrimary = selectedPrimary;
                  self.checkEligibilityAndSaveState('multi', 'main').then(function () {
                    if(self.heroRedirect){
                       self.multipleLineHeroRedirect();
                    }else{
                      $state.go('ppc-multiline-step-1');
                    }
                  });

                }
              },
              function () {
                self.changeBtnLoading(false);
              }
            );

          }
        },
        function () {
          self.changeBtnLoading(false);
        });
    };

    self.checkEligibilityAndSaveState = function (flowType, filterOption) {
      var deferred = $q.defer();
      self.isEligible(flowType).then(function () {
          self.saveState(filterOption).then(
            function () {
              deferred.resolve();
            },
            function (saveStateError) {
              pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
              self.changeBtnLoading(false);
              deferred.reject();
            });
        },
        function () {
          // already displayed eligibility error in isEligible()
          deferred.reject();
        });
      return deferred.promise;
    };

    self.clean = function () {
      self.appStateForPPC = {};
      self.fetchOrderCompleted = false;
      self.bfappcOrders.length = 0;
      self.bfahupOrders.length = 0;
      self.brtSwitch = {
        ppc: null,
        mppc: null,
        q2ppc: null
      };
      self.permission = {
        ppc: null,
        mppc: null
      };
      self.subscribers = null;
      self.fetchOrderFullResponse = {};
      self.changeBtnLoadingStatus = false;
    };

    self.getFetchOrderFullResponse = function () {
      return self.fetchOrderFullResponse;
    };

    self.getHupOrder = function (activeCtn) {
          if(self.bfahupOrders.length > 0){
            return _.filter(self.bfahupOrders, function (order) {
                    return _.indexOf(order.assemblyIds, activeCtn) >= 0 && !order.quotation;
                  });
          }
    };

    self.changeBtnLoading = function (status) {
      if (!arguments.length) {
        return self.changeBtnLoadingStatus;
      }
      self.changeBtnLoadingStatus = status;
    };

    self.openSomethingWentWrongPopup = function(){
      pricePlanChangesErrors.showError($translate.instant('ppc_something_went_wrong_message_title'), $translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
    }

    /**
     * Add DTM Tracking for PPC
     * JIRA: https://rogers.atlassian.net/browse/NPS-1332
     */

    return {
      'isFetchOrderCompleted': self.isFetchOrderCompleted,
      'hasOrder': self.hasOrder,
      'fetchOrder': self.fetchOrder,
      'gotoBFAPPC': self.gotoBFAPPC,
      'clean': self.clean,
      'changeBtnLoading': self.changeBtnLoading,
      'getFetchOrderFullResponse': self.getFetchOrderFullResponse,
      'getSubscribers': self.getSubscribers,
      'openSomethingWentWrongPopup': self.openSomethingWentWrongPopup,
      'getHuporderForCtn': self.getHupOrder
    };
  }
})();

(function () {
  'use strict';

  angular.module('totesApp').controller('employeePlanErrorModalCtrl', employeePlanErrorModalCtrl);
  employeePlanErrorModalCtrl.$inject = ['$scope', '$modalInstance','$state'];
  function employeePlanErrorModalCtrl($scope, $modalInstance,$state) {

    $scope.continue = function () {
          $modalInstance.close();
          $state.go('totes-wireless');
        };

  }
})();

(function () {
  'use strict';

  angular.module('totesApp').controller('mppcAdditionalLineErrorModalCtrl', mppcAdditionalLineErrorModalCtrl);
  mppcAdditionalLineErrorModalCtrl.$inject = ['$scope', '$modalInstance'];
  function mppcAdditionalLineErrorModalCtrl($scope, $modalInstance) {

    $scope.continue = function () {
          $modalInstance.close();
        };

  }
})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcEntry1Ctrl', mppcEntry1Ctrl);
  mppcEntry1Ctrl.$inject = ['$scope', '$modalInstance'];
  function mppcEntry1Ctrl($scope, $modalInstance) {
    var self = {};
    $scope.model = {};

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.createSharedGroup = function () {
      $modalInstance.close('createSharedGroup');
    };

    $scope.changeCurrentPlan = function () {
      $modalInstance.close('changeCurrentPlan');
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcEntry3Ctrl', mppcEntry3Ctrl);
  mppcEntry3Ctrl.$inject = ['$scope', '$modalInstance'];
  function mppcEntry3Ctrl($scope, $modalInstance) {
    var self = {};
    $scope.model = {};

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    $scope.addToSharedGroup = function () {
      $modalInstance.close('addToSharedGroup');
    };

    $scope.changeCurrentPlan = function () {
      $modalInstance.close('changeCurrentPlan');
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcSharedGroupIndividualModalCtrl', mppcSharedGroupIndividualModalCtrl);
  mppcSharedGroupIndividualModalCtrl.$inject = ['$scope', '$modalInstance', 'subscribers', 'currentCtn'];
  function mppcSharedGroupIndividualModalCtrl($scope, $modalInstance, subscribers, currentCtn) {
    var self = {};

    $scope.model = {
      subscribers: subscribers,
      currentCtn: currentCtn,
      selectedSubscribersCheckBox:{},
      showBenefits: false,
      isCtnSelected: false
    };

    $scope.toggleBenefits = function () {
      $scope.model.showBenefits = ($scope.model.showBenefits) ? false : true;
    };

    $scope.filterSubscribers = function (item) {
      return item.familyShareStatus === 'Individual' && item.status === 'Active' && item.subscriberNumber != currentCtn;
    };

    $scope.continue = function () {
      if(self.getSelectedSubscribers().length > 0){
      $modalInstance.close(self.getSelectedSubscribers());
      }
      else{
        $scope.model.isCtnSelected =true;
      }
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };

    self.getSelectedSubscribers = function(){
      return _.keys(_.pick($scope.model.selectedSubscribersCheckBox , function(value, key) {
        return value;
      }));
    };
  }

})();


(function () {
  'use strict';

  angular.module('totesApp').controller('mppcSharedGroupPrimaryModalCtrl', mppcSharedGroupPrimaryModalCtrl);
  mppcSharedGroupPrimaryModalCtrl.$inject = ['$scope', '$modalInstance', 'selectedAdditionalSubscribers', 'currentCtn'];
  function mppcSharedGroupPrimaryModalCtrl($scope, $modalInstance, selectedAdditionalSubscribers, currentCtn) {
    var self = {};

    $scope.model = {
      selectedAdditionalSubscribers: selectedAdditionalSubscribers,
      selectedPrimaryCtn: currentCtn, // the selected ctn should be preselected in the list
      currentCtn: currentCtn
    };

    $scope.continue = function () {
      $modalInstance.close($scope.model.selectedPrimaryCtn);
    };

    $scope.cancel = function () {
      $modalInstance.dismiss('cancel');
    };
  }

})();


'use strict';

angular
  .module('totesApp')
  .factory('pricePlanChangesErrors', ['$translate', '$modal', '$state', 'appState', 'ute.blocks.language.switcher', '$log', 'ute.common.user.service', function ($translate, $modal, $state, appState, languageSwitcher, $log, userService) {
    var service = {};

    function showModal(errorMessage) {
      $('#error-modal-body').html(errorMessage);
      $('#error-modal').modal('show');
    }

    function showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
      reload = reload || false;

      var $modalInstance = $modal.open({
        templateUrl: 'views/modals/ppc-modal-template.html',
        windowClass: 'prorated-modal',
        controller: ['$scope', function ($scope) {

          //bold chat changes start
          $scope.setStaticChatButtonValues = function () {
            if (languageSwitcher.getCurrentLanguage() === 'en') {
              $scope.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc';
              $scope.boldChatButtonDiv = 'changePlan-en';
              $scope.boldChatButton = 'chatButtonChangePlanEn';
            } else {
              $scope.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc_Fr';
              $scope.boldChatButtonDiv = 'changePlan-fr';
              $scope.boldChatButton = 'chatButtonChangePlanFr';
            }
          };
          $scope.setStaticChatButtonValues();

          $scope.$on('languageChanged', function () {
            $scope.setStaticChatButtonValues();
          });
          //bold chat changes end

          $scope.title = title;
          $scope.showLiveChat = showLiveChat;
          $scope.message = message;
          $scope.showCancelBtn = false;
          $scope.showOKBtn = false;
          $scope.showConfirmBtn = false;
          $scope.showContinueBtn = false;
          $scope.showRemoveAddOnBtn = false;
          $scope.showGoBackBtn = false;
          $scope.isSuspendedAccount = isSuspended;
          //Remove all instances of errors containing call or chat for care and retail
          // excluding credit check and fraud messages.
          if(showLiveChat === "showToRepAlso") {
            $scope.showLiveChat = true;
          } else if(userService.getUserType().toLowerCase() == 'dealer' || userService.getUserType().toLowerCase() == 'care') {
            $scope.showLiveChat = false;
          } else {
            $scope.showLiveChat = showLiveChat;
          }
          var _length = buttons.length;
          for (var i = 0; i < _length; i++) {
            switch (buttons[i]) {
              case 'OK':
                $scope.showOKBtn = true;
                break;
              case 'Cancel':
                $scope.showCancelBtn = true;
                break;
              case 'Confirm':
                $scope.showConfirmBtn = true;
                break;
              case 'ConfirmPlanChange':
                $scope.showConfirmPlanChangeBtn = true;
                break;
              case 'Continue':
                $scope.showContinueBtn = true;
                break;
              case 'RemoveAddOn':
                $scope.showRemoveAddOnBtn = true;
                break;
              case 'GO_BACK':
                $scope.showGoBackBtn = true;
                break;
            }
          }

          $scope.ok = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.goBack = function () {
            $modalInstance.close();
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };
          $scope.removeAddOn = function () {
            $modalInstance.close(true);
          };

          $scope.cancel = function () {
            $modalInstance.close(false);
            if (redirect && redirect.goBack) {
              $state.go(redirect.goBack);
            }
          };

          $scope.continue = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward, {}, {reload: reload});
            }
          };

          $scope.confirm = function () {
            $modalInstance.close(true);
            if (redirect && redirect.goForward) {
              $state.go(redirect.goForward);
            }
            else if (redirect && typeof redirect.sendCallback === 'function') {
              redirect.sendCallback();
            }
          };
          if (!$scope.isSuspendedAccount) {
            switch (languageSwitcher.getCurrentLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          } else {
            switch (languageSwitcher.getCurrentLanguage()) {
              case 'en':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=204&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                break;
              case 'fr':
                $scope.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=254&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                break;
            }
          }

        }],
        //scope: $scope,
        size: 'md',
        backdrop: 'static'
        //keyboard: false,
        //backdropClass: 'bkg-modal',
        //resolve: {}
      });

      return $modalInstance.result;
    }

    // Display provided errorMessage in Modal
    // missing the RELOAD button
    service.showError = function (title, message, buttons, redirect, showLiveChat, isSuspended) {

      try {
        appState.tagging(['_trackPageView',
          {pn: 'home:MyRogers:PPC_wireless-planchange'},
          {eVar49: message}
        ]);
      } catch (e) {
        $log.error('Exception catch during tagging on pn=home:MyRogers:PPC_wireless-planchange with message:', e.message);
      }

      return showErrorModal(title, message, buttons, redirect, showLiveChat, isSuspended);
    };

    service.showSuspendedError = function (title, message, buttons, redirect, showLiveChat, reload, isSuspended) {
      return showErrorModal(title, message, buttons, redirect, showLiveChat, reload, isSuspended);
    };

    // Look up error message for this errorCode and then display in modal
    service.handleError = function (errorCode) {
      var errorMessage = $translate.instant(errorCode);
      showModal(errorMessage);
    };

    // Look up generic error message and display in modal
    service.showGenericError = function () {
      var errorMessage = $translate.instant('_something_went_wrong');
      showModal(errorMessage);
    };

    return service;
  }]);

// Please read and follow https://github.com/johnpapa/angular-styleguide
(function () {
  'use strict';

  angular.module('totesApp').controller('MyPrepaidCtnCountController', PrepaidCtnCountController);

  PrepaidCtnCountController.$inject = ['$scope', '$modalInstance', '$rootScope'];

  /* @ngInject */
  function PrepaidCtnCountController($scope, $modalInstance, $rootScope ) {
    $scope.close = function () {
        $modalInstance.dismiss('cancel');
        $rootScope.modal = null;
    };
  }
})();

(function () {
    'use strict';
    /**
     * @name totesApp.controller:WirelessOrdersPopupController
     * @description
     * # WirelessOrdersPopupController
     * Controller of the totesApp
     */
    angular.module('totesApp').controller('WirelessOrdersPopupController', wirelessOrdersPopupController);

    wirelessOrdersPopupController.$inject = ['$scope',
        '$rootScope',
        'ute.blocks.language.switcher',
        'sessionStorage',
        '$filter',
        'MyrOneViewOrdersService'
    ];

    /* @ngInject */
    function wirelessOrdersPopupController($scope,
        $rootScope,
        languageSwitcher,
        sessionStorage,
        $filter,
        oneViewOrdersService) {
        var word = this;
        word.loading = true;
        word.lang = languageSwitcher.getCurrentLanguage();

        function init() {
            word.tableColumns = ["ctn","itemNumber","description","lineStatus","hold","quantityOrdered","quantityShipped","serialNumber","lastUpdatedDate","shippedDate","wayBill"];
            if(word.itemDetails.length > 0) {
                word.loading = false;
                word.itemDetails.forEach(function(item) {
                    word.tableColumns.forEach(function(itemIndividual, index){
                        if(!item[word.tableColumns[index]] || !item[word.tableColumns[index]].trim())
                        item[word.tableColumns[index]] = "–";
                    });
                    if(item.lineStatus !== "–" && item.lineStatus.indexOf("order_") < 0)
                    item.lineStatus = getOrderStatus(item.lineStatus);
                });
            }
        }
        word.decideDateFilter = function(date) {
            date = $filter('date')(date, 'dd-MMM-yyyy');
            return date.replace(".","");
        }
        function getOrderStatus (status) {
            var statusText = ("order_" + (status.replace(/\s/g,"_")));
            return statusText;
        }
        init();

        languageSwitcher.registerOnDataChangeHandler(function (lang) {
            word.lang = lang;
        }, 'WirelessOrdersPopupController');
    }
})();
(function () {
    'use strict';
  
    angular.module('totesApp').directive('wirelessOrdersPopup', wirelessOrdersPopup);
    function wirelessOrdersPopup() {
      var directive = {
        restrict: 'EA',
        templateUrl: 'scripts/modules/oneView/oneViewOrders/wirelessOrdersDetailsPopup/wirelessOrdersPopup.html',
        scope: {
          index:'@',
          closePopover: '&',
          itemDetails: '='
        },
        controller:'WirelessOrdersPopupController',
        controllerAs: 'word',
        bindToController: true
      };
      return directive;
    }
  })();
  
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.rogers.account.overview.service', [
                        'ute.blocks.router',
                        'ute.common.security',
                        'ute.common.core.caching',
                        'ute.blocks.language.switcher',
                        'ute.blocks.persistent.storage',
                        'ute.common.filter',
                        'ute.rogers.eclipse.remote.api',
                        'ute.rogers.account.detail.service',
                        'ute.blocks.province',
                        'ute.common.user'
                    ]);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            angular.module('ute.dtm.service', [
                'ute.blocks.language.switcher',
                'ute.blocks.province',
                'ute.rogers.account.overview.service',
                'ute.common.user',
                'ute.common.core.browser'
            ]);
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        angular
            .module('ute.goPaperless', [
            'ute.rogers.account.overview.service',
            'ute.common.security',
            'ute.datalayer.common'
        ]);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            angular.module('ute.historical.usage', [
                'ng',
                'ute.brite.bill.service'
            ]);
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.rogers.revolution.data.service', [
                        'ute.blocks.router',
                        'ute.common.security',
                        'ute.common.core.caching',
                        'ute.blocks.language.switcher',
                        'ute.blocks.persistent.storage',
                        'ute.common.filter',
                        'ute.rogers.eclipse.remote.api'
                    ]);
                })(service = data.service || (data.service = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    angular.module('ute.rogers.second.level.navigation', [
                        'ute.rogers.account.overview.service',
                        'ute.common.second.level.navigation',
                        'ute.common.user',
                        'ute.blocks.language.switcher',
                        'ute.blocks.router',
                        'ute.common.permissions'
                    ]);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.rogers.user.registration', [
                    'ute.blocks.router',
                    'duScroll',
                    'ngMessages',
                    'ute.dtm.service',
                    'vcRecaptcha',
                    'ute.common.encryption',
                    'ute.blocks.language.switcher'
                ]);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            angular.module('ute.common.user', [
                'ute.blocks.persistent.storage',
                'ute.blocks.exception',
                'ute.common.utils',
                'ute.blocks.messages.bus',
                // ute.common.utils.UtilsStatic.getCookieModule()
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
            ]);
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.rogers.account.detail.service', []);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            angular.module('ute.actions.offers', [
                'ute.nova.content',
                'ute.common.decorator.directives',
                'ute.common.runtime.translate',
                'translations',
                'ute.blocks.language.switcher',
                'ute.common.permissions',
                'ute.blocks.messages.bus',
                'ute.active.treatments'
            ]);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
                angular.module('ute.anti.spam.legislation', []);
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            angular.module('ute.bfa.ppc', [
                'ute.blocks.router',
                'ui.bootstrap',
                'pascalprecht.translate',
                'duScroll',
                'ute.common.encryption',
                'ute.common.filter',
                'ute.common.permissions',
                'ute.common.user',
                'ute.common.core.brtswitch',
                'ute.common.security',
                'ute.rogers.account.overview.service',
                'ute.dtm.service'
            ]);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                angular.module('ute.capture.dealer.code', [
                    'ute.common.decorator.directives',
                    'ute.common.runtime.translate',
                    'ute.common.user',
                    'translations',
                    'ute.blocks.language.switcher',
                    'ute.blocks.messages.bus'
                ]);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                angular.module('ute.change.ctn.callerId', [
                    'ui.bootstrap',
                    'ngMessages',
                    'ute.blocks.language.switcher',
                    'ute.common.component.directives',
                    'ute.rogers.account.overview.service',
                    'ute.common.user',
                    'ute.dtm.service',
                    'ute.common.security',
                    'ute.datalayer.common'
                ]);
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            angular.module('ute.common.core', [
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies',
                'ute.common.core.brtswitch',
                'ute.common.core.caching',
                'ute.common.core.subpub',
                'ute.common.core.browser'
            ]);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                angular.module('ute.common.decorator.directives', ['ng', 'ute.blocks.language.switcher']);
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter', ['ng',
                'pascalprecht.translate',
                'ute.blocks.language.switcher',
                'angularMoment']);
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            angular.module('ute.common.utils', []);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    angular.module('ute.common.customer.credit.management', [
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'ngMessages',
                        'pascalprecht.translate',
                        'ute.common.runtime.translate',
                        'duScroll',
                        'ute.common.encryption',
                        'ute.common.filter',
                        'ute.rogers.deeplink',
                        'ute.common.security',
                        'ute.blocks.language.switcher'
                    ]);
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            angular.module('ute.data.manager', [
                'ute.data.manager.service',
                'ute.data.manager.data.control.list',
                'ute.data.manager.tabs',
                'ute.data.manager.profile.alert',
                'ute.data.manager.shared.usage.bar',
                'ute.data.manager.badge.list',
                'ute.data.manager.usage.dial',
                'ute.data.manager.data.alerts',
                'ute.data.manager.data.control.tag.list',
                'ute.data.manager.individual.summary',
                'ute.data.manager.accounts.summary',
                'ute.data.manager.data.access',
                'ute.data.manager.increase.plan',
                'ute.data.manager.upgrade.plan',
                'ute.data.manager.modals',
                'ute.data.manager.info.block',
                'ute.data.manager.tabs.content',
                'ute.blocks.messages.bus',
                'ute.discovery.page',
                'ute.usage.dial',
                // 'ute.rogers.deeplink.checker',
                'ute.common.decorator.directives',
                'ute.app.banner',
                'ute.rogers.account.overview.service',
                'ute.common.second.level.navigation',
                'ute.blocks.router',
                'ui.bootstrap',
                'pascalprecht.translate',
                'duScroll',
                'ute.common.encryption',
                'ute.common.filter',
                'ute.common.permissions',
                'ute.rogers.deeplink',
                'ute.common.utils',
                'ute.data.manager.see',
                'ute.data.manager.data.video.throttle.wrapper',
                'ute.data.manager.video.throttle.control.list',
                'ute.data.manager.video.throttle.control',
                'ute.data.manager.video.throttle.control.tag.list',
                'ute.data.manager.video.throttle.control.tag',
                'ute.datalayer.common'
            ]);
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.datalayer.common', []);
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.rogers.deeplink', [
                    'ute.common.user',
                    'ute.blocks.router',
                    'ute.blocks.logger',
                    'ute.blocks.messages.bus',
                    'ute.common.security',
                    'ute.blocks.persistent.storage'
                ]);
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            'use strict';
            angular.module('ute.discovery.page', [
                'ute.discovery.page.service',
                'ute.discovery.page.directive',
                'ui.bootstrap',
                'pascalprecht.translate',
                'ute.common.encryption',
                'ute.common.permissions',
                'ute.common.decorator.directives',
                'ute.common.runtime.translate',
                'ute.datalayer.common'
            ]);
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.easy.login.registration', ['ute.datalayer.common', 'vcRecaptcha']);
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var eclipse;
        (function (eclipse) {
            var remote;
            (function (remote) {
                var api;
                (function (api) {
                    'use strict';
                    angular.module('ute.rogers.eclipse.remote.api', [
                        'ute.common.encryption',
                        'ui.bootstrap'
                    ]);
                })(api = remote.api || (remote.api = {}));
            })(remote = eclipse.remote || (eclipse.remote = {}));
        })(eclipse = rogers.eclipse || (rogers.eclipse = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption', [
                'ute.blocks.logger',
                'mdo-angular-cryptography',
                'ute.common.user',
                'ute.blocks.router'
            ]);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                angular.module('ute.blocks.language.switcher', [angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies', 'pascalprecht.translate', 'tmh.dynamicLocale']);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            angular.module('ute.fraud.logging', []);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            angular.module('ute.janrain.verification', [
                'ute.common.core',
                'ute.blocks.environment',
                'ute.blocks.persistent.storage',
                'ui.bootstrap',
                'ute.common.utils',
                'ute.common.encryption',
                'pascalprecht.translate',
                'ute.dtm.service'
            ]);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                angular.module('ute.blocks.messages.bus', ['ute.blocks.logger']);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
            angular.module('ute.nova.content', [
                'ui.bootstrap',
                'ngMessages',
                'pascalprecht.translate',
                'duScroll',
                'ute.common.encryption',
                'ute.common.filter',
                'ute.common.decorator.directives',
                'ute.common.security',
                'translations'
            ]);
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
                angular.module('ute.oneview.interaction.notes', [
                    'ui.bootstrap',
                    'ngMessages',
                    'pascalprecht.translate',
                    'duScroll',
                    'ute.common.encryption',
                    'ute.common.filter',
                    'ute.common.decorator.directives',
                    'ute.common.security',
                    'ute.common.runtime.translate',
                    'translations',
                    'ute.rogers.account.overview.service'
                ]);
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            'use strict';
            angular.module('ute.payment.method', [
                'ng',
                'ute.rogers.account.overview.service',
                'ute.payment.service',
                'ute.semafone',
                'ute.common.permissions',
                'ute.blocks.language.switcher',
                'ute.common.user',
                'ute.promise.to.pay',
                'ute.datalayer.common'
            ]);
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
            angular.module('ute.payment.service', ['ng']);
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            'use strict';
            angular.module('ute.payment.ui', [
                'ng',
                'ngDialog',
                'ute.common.core',
                'ute.payment.ui.config',
                'ute.payment.ui.pay.now',
                'ute.payment.service',
                'ute.semafone',
                'ute.rogers.account.overview.service',
                'ute.datalayer.common']);
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                angular.module('ute.common.pending.order', [
                    'ui.bootstrap',
                    'ute.rogers.eclipse.remote.api',
                    'ute.blocks.language.switcher',
                    'ute.common.security',
                    'ute.common.user'
                ]);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage', [
                    'ngStorage'
                ]);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                angular.module('ute.common.profile.edit', [
                    'ute.common.runtime.translate',
                    'ute.common.security',
                    'ute.common.user',
                    'ute.sms.recovery.rogers',
                    'ute.datalayer.common',
                    'ute.common.filter',
                    'ute.blocks.language.switcher'
                ]);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                angular.module('ute.promise.to.pay', [
                    'ute.nova.content',
                    'ute.common.decorator.directives',
                    'ute.common.runtime.translate',
                    'translations',
                    'ute.blocks.language.switcher',
                    'ute.common.permissions',
                    'ute.blocks.messages.bus'
                ]);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var province;
        (function (province) {
            'use strict';
            angular.module('ute.blocks.province', [
                angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
            ]);
        })(province = blocks.province || (blocks.province = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
            angular
                .module('ute.purchase.data', ['ute.datalayer.common', 'ui.bootstrap', 'ui.select'])
                .filter('dollars', function () {
                return function (input) {
                    return (input / 100);
                };
            });
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.reactivate.ctn', [
                    'ute.blocks.router',
                    'ute.common.component.directives',
                    'ute.common.runtime.translate',
                    'ute.common.filter',
                    'ute.rogers.deeplink',
                    'ute.common.security'
                ]);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                angular.module('ute.common.voicemail.resetPassword', [
                    'ui.bootstrap',
                    'ngMessages',
                    'pascalprecht.translate',
                    'duScroll',
                    'ute.common.encryption',
                    'ute.common.filter',
                    'ute.common.decorator.directives',
                    'ute.common.security']);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.rogers.bpo.integration.service', [
                        'ngDialog',
                        'ute.common.utils',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter'
                    ]);
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                angular.module('ute.rogers.interceptors.auth', ['ute.blocks.messages.bus', 'ute.datalayer.common']);
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            angular.module('ute.rogers.setpassword', [
                'ute.blocks.router',
                'pascalprecht.translate',
                'ute.janrain.verification',
                'duScroll',
                'ngMessages',
                'ute.common.utils',
                'ui.bootstrap',
                'ute.rogers.siteminder.signin',
                'ute.datalayer.common'
            ]);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                angular.module('ute.rogers.siteminder.signin', [
                    'ute.blocks.exception',
                    'ute.blocks.environment',
                    'ute.blocks.router',
                    'ute.common.core',
                    'ute.common.user',
                    'ute.blocks.messages.bus',
                    angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'
                ]);
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
                angular.module('ute.common.runtime.translate', ['pascalprecht.translate']);
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            'use strict';
            angular.module('ute.save.bill', [
                'ute.save.bill.service',
                'ute.save.bill.modal',
                'ute.brite.bill.service',
                'ute.common.user',
                'ute.blocks.router',
                'ui.bootstrap',
                'pascalprecht.translate',
                'ute.common.filter',
                'ute.common.permissions'
            ]);
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var modal;
            (function (modal) {
                'use strict';
                angular.module('ute.save.bill.modal', [
                    'ute.save.bill.service',
                    'ute.common.component.directives',
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'pascalprecht.translate',
                    'ute.common.filter',
                    'ngMaterial'
                ]);
            })(modal = bill.modal || (bill.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.save.bill.service', [
                    'pascalprecht.translate',
                    'ute.rogers.account.overview.service',
                    'ute.common.runtime.translate',
                    'ute.common.core.brtswitch',
                    'ute.common.user'
                ]);
            })(service = bill.service || (bill.service = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    angular.module('ute.common.second.level.navigation', [
                        'ute.blocks.logger',
                        'ute.common.runtime.translate',
                        'ute.common.security',
                        'ute.common.user',
                        'ngMaterial',
                        'ute.blocks.router'
                    ]);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            angular.module('ute.common.security', [
                'ute.blocks.logger',
                'ute.common.user'
            ]);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change', [
                        'ute.common.simcard.change.form',
                        'ute.common.simcard.change.confirmation',
                        'ute.common.simcard.change.success',
                        'ute.common.simcard.change.service',
                        'ute.blocks.router',
                        'ute.common.decorator.directives',
                        'ui.bootstrap',
                        'ngMessages',
                        'pascalprecht.translate',
                        'duScroll',
                        'ute.common.encryption',
                        'ute.payment.helper.view',
                        'ute.common.filter',
                        'ute.common.permissions',
                        'ute.rogers.deeplink',
                        'ute.datalayer.common'
                    ]);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        'use strict';
                        angular.module('ute.sm.to.genesis.auth.service', [
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'duScroll',
                            'ute.common.encryption',
                            'ute.common.filter',
                            'ute.common.permissions',
                            'ute.rogers.deeplink',
                            'ute.blocks.persistent.storage'
                        ]);
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
                angular.module('ute.sms.recovery.rogers', [
                    'ui.bootstrap',
                    'pascalprecht.translate',
                    'ute.common.filter',
                    'ute.common.permissions',
                    'ute.rogers.deeplink'
                ]);
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            angular
                .module('ute.common.subscriptionBadge', [
                'ute.common.filter'
            ]);
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.suspend.ctn', [
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'ngMessages',
                    'pascalprecht.translate',
                    'ute.common.runtime.translate',
                    'duScroll',
                    'ute.common.encryption',
                    'ute.common.filter',
                    'ute.rogers.deeplink',
                    'ute.common.security'
                ]);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        angular.module('ute.transferOfResponsibility', [
            'ute.blocks.router',
            'ute.common.decorator.directives',
            'ui.bootstrap',
            'ngMessages',
            'pascalprecht.translate',
            'duScroll',
            'ute.common.encryption',
            'ute.payment.helper.view',
            'ute.rogers.account.overview.service',
            'ute.nova.content',
            'ute.common.permissions'
        ]);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                    angular.module('ute.wireless.product.discount.details', [
                        'ute.common.decorator.directives',
                        'ute.common.runtime.translate',
                        'translations',
                        'ute.blocks.language.switcher'
                    ]);
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                angular.module('ute.common.core.subpub', []);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var browser;
            (function (browser) {
                'use strict';
                angular.module('ute.common.core.browser', []);
            })(browser = core.browser || (core.browser = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                angular.module('ute.common.core.brtswitch', ['ute.blocks.exception']);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                angular.module('ute.common.core.caching', [
                    'ute.common.core.subpub'
                ]);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary', [
                        'ute.data.manager.summary.footer',
                        'ute.data.manager.summary.header',
                        'ute.vertical.stack.bar.graph',
                        'ute.data.manager.summary.data.meter',
                        'ute.data.manager.accounts.summary.data.alert.at',
                        'ute.data.manager.accounts.summary.no.data.alerts.set',
                        'ute.data.manager.accounts.summary.data.access.off',
                        'ute.data.manager.accounts.summary.no.data.plan',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var badge;
            (function (badge) {
                var list;
                (function (list) {
                    'use strict';
                    angular.module('ute.data.manager.badge.list', [
                        'ute.data.manager.service',
                        'ngMaterial',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ute.rogers.account.overview.service',
                        'ngSanitize'
                    ]);
                })(list = badge.list || (badge.list = {}));
            })(badge = manager.badge || (manager.badge = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var access;
                (function (access) {
                    'use strict';
                    angular.module('ute.data.manager.data.access', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(access = data.access || (data.access = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var alerts;
                (function (alerts) {
                    'use strict';
                    angular.module('ute.data.manager.data.alerts', [
                        'ute.data.manager.service',
                        'ute.vertical.stack.bar.graph',
                        'ute.discovery.page',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(alerts = data.alerts || (data.alerts = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var video;
                (function (video) {
                    var throttle;
                    (function (throttle) {
                        var wrapper;
                        (function (wrapper) {
                            'use strict';
                            angular.module('ute.data.manager.data.video.throttle.wrapper', [
                                'ute.data.manager.service',
                                'ute.data.manager.data.control.list',
                                'ute.data.manager.video.throttle.control.list',
                                'ui.bootstrap',
                                'pascalprecht.translate',
                                'ngMaterial'
                            ]);
                        })(wrapper = throttle.wrapper || (throttle.wrapper = {}));
                    })(throttle = video.throttle || (video.throttle = {}));
                })(video = data.video || (data.video = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var list;
                    (function (list) {
                        'use strict';
                        angular.module('ute.data.manager.data.control.list', [
                            'ute.data.manager.service',
                            'ute.data.manager.data.control',
                            'ute.modules.contentExpand',
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial'
                        ]);
                    })(list = control.list || (control.list = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        var list;
                        (function (list) {
                            'use strict';
                            angular.module('ute.data.manager.data.control.tag.list', [
                                'ute.data.manager.service',
                                'ute.data.manager.data.control.tag',
                                'ute.blocks.router',
                                'ui.bootstrap',
                                'pascalprecht.translate',
                                'ute.common.filter',
                                'ngMaterial'
                            ]);
                        })(list = tag.list || (tag.list = {}));
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var increase;
            (function (increase) {
                var plan;
                (function (plan) {
                    'use strict';
                    angular.module('ute.data.manager.increase.plan', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter'
                    ]);
                })(plan = increase.plan || (increase.plan = {}));
            })(increase = manager.increase || (manager.increase = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var individual;
            (function (individual) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.individual.summary', [
                        'ute.data.manager.service',
                        'ute.data.manager.data.control.tag',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(summary = individual.summary || (individual.summary = {}));
            })(individual = manager.individual || (manager.individual = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var info;
            (function (info) {
                var block;
                (function (block) {
                    'use strict';
                    angular.module('ute.data.manager.info.block', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(block = info.block || (info.block = {}));
            })(info = manager.info || (manager.info = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var modals;
            (function (modals) {
                'use strict';
                angular.module('ute.data.manager.modals', [
                    'ute.data.manager.service',
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'pascalprecht.translate',
                    'ute.common.filter',
                    'ngMaterial'
                ]);
            })(modals = manager.modals || (manager.modals = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var profile;
            (function (profile) {
                var alert;
                (function (alert) {
                    'use strict';
                    angular.module('ute.data.manager.profile.alert', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter'
                    ]);
                })(alert = profile.alert || (profile.alert = {}));
            })(profile = manager.profile || (manager.profile = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var see;
            (function (see) {
                'use strict';
                angular.module('ute.data.manager.see', [
                    'ute.common.security',
                    'pascalprecht.translate',
                    'ute.data.manager.service',
                    'ute.common.core',
                    'ute.common.permissions',
                    'ute.blocks.language.switcher'
                ]);
            })(see = manager.see || (manager.see = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var shared;
            (function (shared) {
                var usage;
                (function (usage) {
                    var bar;
                    (function (bar) {
                        'use strict';
                        angular.module('ute.data.manager.shared.usage.bar', [
                            'ute.data.manager.service',
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial'
                        ]);
                    })(bar = usage.bar || (usage.bar = {}));
                })(usage = shared.usage || (shared.usage = {}));
            })(shared = manager.shared || (manager.shared = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                'use strict';
                angular.module('ute.data.manager.tabs', [
                    'ute.data.manager.service',
                    'ute.rogers.account.overview.service',
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'pascalprecht.translate',
                    'ute.common.filter',
                    'ngMaterial'
                ]);
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                var content;
                (function (content) {
                    'use strict';
                    angular.module('ute.data.manager.tabs.content', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter'
                    ]);
                })(content = tabs.content || (tabs.content = {}));
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var upgrade;
            (function (upgrade) {
                var plan;
                (function (plan) {
                    'use strict';
                    angular.module('ute.data.manager.upgrade.plan', [
                        'ute.data.manager.service',
                        'ute.blocks.messages.bus',
                        'ute.common.user',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ute.bfa.ppc',
                        'ute.common.permissions',
                        'ute.common.security'
                    ]);
                })(plan = upgrade.plan || (upgrade.plan = {}));
            })(upgrade = manager.upgrade || (manager.upgrade = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var usage;
            (function (usage) {
                var bar;
                (function (bar) {
                    'use strict';
                    angular.module('ute.data.manager.usage.dial', [
                        'ute.data.manager.service',
                        'ute.blocks.router',
                        'ngAnimate',
                        'ui.bootstrap',
                        'ngTouch',
                        'pascalprecht.translate',
                        'ute.common.filter'
                    ]);
                })(bar = usage.bar || (usage.bar = {}));
            })(usage = manager.usage || (manager.usage = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var list;
                        (function (list) {
                            'use strict';
                            angular.module('ute.data.manager.video.throttle.control.list', [
                                'ute.data.manager.service',
                                'ute.discovery.page',
                                'ute.data.manager.video.throttle.control',
                                'ute.modules.contentExpand',
                                'ute.blocks.router',
                                'ui.bootstrap',
                                'pascalprecht.translate',
                                'ute.common.filter',
                                'ngMaterial'
                            ]);
                        })(list = control.list || (control.list = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            var list;
                            (function (list) {
                                'use strict';
                                angular.module('ute.data.manager.video.throttle.control.tag.list', [
                                    'ute.data.manager.service',
                                    'ute.discovery.page',
                                    'ute.data.manager.video.throttle.control.tag',
                                    'ute.blocks.router',
                                    'ui.bootstrap',
                                    'pascalprecht.translate',
                                    'ute.common.filter',
                                    'ngMaterial',
                                    'ute.data.manager.video.throttle.toggle'
                                ]);
                            })(list = tag.list || (tag.list = {}));
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var toggle;
                    (function (toggle) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.toggle', [
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial'
                        ]);
                    })(toggle = throttle.toggle || (throttle.toggle = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var vertical;
    (function (vertical) {
        var stack;
        (function (stack) {
            var bar;
            (function (bar) {
                var graph;
                (function (graph) {
                    'use strict';
                    angular.module('ute.vertical.stack.bar.graph', ['ui.bootstrap']);
                })(graph = bar.graph || (bar.graph = {}));
            })(bar = stack.bar || (stack.bar = {}));
        })(stack = vertical.stack || (vertical.stack = {}));
    })(vertical = ute.vertical || (ute.vertical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var directive;
            (function (directive) {
                'use strict';
                angular.module('ute.discovery.page.directive', [
                    'ute.discovery.page.service',
                    'ute.blocks.router',
                    'ui.bootstrap',
                    'pascalprecht.translate',
                    'ute.common.filter',
                    'ngMaterial'
                ]);
            })(directive = page.directive || (page.directive = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            angular.module('ute.blocks.environment', ['ute.blocks.exception', 'config']);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            angular.module('ute.blocks.exception', ['ute.blocks.logger']);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            angular.module('ute.blocks.logger', []);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            'use strict';
            angular.module('ute.payment.ui.config', []);
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    angular.module('ute.payment.ui.pay.now', [
                        'ng',
                        'ui.bootstrap',
                        'ute.blocks.language.switcher',
                        'ute.blocks.messages.bus']);
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service', [
                        'ute.common.encryption',
                        'ute.common.user',
                        'ute.common.security'
                    ]);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            angular.module('ute.blocks.router', [
                'ui.router',
                'ute.blocks.logger',
                'pascalprecht.translate'
            ]);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var access;
                        (function (access) {
                            var off;
                            (function (off) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.data.access.off', [
                                    'ute.blocks.router',
                                    'ui.bootstrap',
                                    'pascalprecht.translate',
                                    'ute.common.filter',
                                    'ngMaterial'
                                ]);
                            })(off = access.off || (access.off = {}));
                        })(access = data.access || (data.access = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var alert;
                        (function (alert) {
                            var at;
                            (function (at) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.data.alert.at', [
                                    'ute.blocks.router',
                                    'ui.bootstrap',
                                    'pascalprecht.translate',
                                    'ute.common.filter',
                                    'ngMaterial'
                                ]);
                            })(at = alert.at || (alert.at = {}));
                        })(alert = data.alert || (data.alert = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var data;
                (function (data) {
                    var meter;
                    (function (meter) {
                        'use strict';
                        angular.module('ute.data.manager.summary.data.meter', [
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial'
                        ]);
                    })(meter = data.meter || (data.meter = {}));
                })(data = summary.data || (summary.data = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var footer;
                (function (footer) {
                    'use strict';
                    angular.module('ute.data.manager.summary.footer', [
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(footer = summary.footer || (summary.footer = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var header;
                (function (header) {
                    'use strict';
                    angular.module('ute.data.manager.summary.header', [
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(header = summary.header || (summary.header = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var alerts;
                            (function (alerts) {
                                var set;
                                (function (set) {
                                    'use strict';
                                    angular.module('ute.data.manager.accounts.summary.no.data.alerts.set', [
                                        'ute.blocks.router',
                                        'ui.bootstrap',
                                        'pascalprecht.translate',
                                        'ute.common.filter',
                                        'ngMaterial'
                                    ]);
                                })(set = alerts.set || (alerts.set = {}));
                            })(alerts = data.alerts || (data.alerts = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var plan;
                            (function (plan) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.no.data.plan', [
                                    'ute.blocks.router',
                                    'ui.bootstrap',
                                    'pascalprecht.translate',
                                    'ute.common.filter',
                                    'ngMaterial'
                                ]);
                            })(plan = data.plan || (data.plan = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control', [
                        'ute.data.manager.service',
                        'ute.data.manager.data.access',
                        'ute.blocks.router',
                        'ui.bootstrap',
                        'pascalprecht.translate',
                        'ute.common.filter',
                        'ngMaterial'
                    ]);
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        'use strict';
                        angular.module('ute.data.manager.data.control.tag', [
                            'ute.data.manager.service',
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial'
                        ]);
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control', [
                            'ute.data.manager.service',
                            'ute.data.manager.data.access',
                            'ute.blocks.router',
                            'ui.bootstrap',
                            'pascalprecht.translate',
                            'ute.common.filter',
                            'ngMaterial',
                            'ute.data.manager.video.throttle.toggle'
                        ]);
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            'use strict';
                            angular.module('ute.data.manager.video.throttle.control.tag', [
                                'ute.data.manager.service',
                                'ute.blocks.router',
                                'ui.bootstrap',
                                'pascalprecht.translate',
                                'ute.common.filter',
                                'ngMaterial'
                            ]);
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

/// <reference path="../.tmp/typings/tsd.d.ts" />

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            'use strict';
            (function (UserType) {
                UserType[UserType["dealer"] = 0] = "dealer";
                UserType[UserType["care"] = 1] = "care";
                UserType[UserType["consumer"] = 2] = "consumer";
                UserType[UserType["careRep"] = 3] = "careRep";
            })(user.UserType || (user.UserType = {}));
            var UserType = user.UserType;
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var detail;
            (function (detail) {
                var service;
                (function (service) {
                    'use strict';
                })(service = detail.service || (detail.service = {}));
            })(detail = account.detail || (account.detail = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var detail;
            (function (detail) {
                var service;
                (function (service) {
                    'use strict';
                })(service = detail.service || (detail.service = {}));
            })(detail = account.detail || (account.detail = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var detail;
            (function (detail) {
                var service;
                (function (service) {
                    'use strict';
                })(service = detail.service || (detail.service = {}));
            })(detail = account.detail || (account.detail = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account_1) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    (function (AccountStatuses) {
                        AccountStatuses[AccountStatuses["ACTIVE"] = 0] = "ACTIVE";
                        AccountStatuses[AccountStatuses["DEACTIVE"] = 1] = "DEACTIVE";
                        AccountStatuses[AccountStatuses["SUSPENDED"] = 2] = "SUSPENDED";
                        AccountStatuses[AccountStatuses["CANCELLED"] = 3] = "CANCELLED";
                    })(service.AccountStatuses || (service.AccountStatuses = {}));
                    var AccountStatuses = service.AccountStatuses;
                })(service = overview.service || (overview.service = {}));
            })(overview = account_1.overview || (account_1.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account_1) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account_1.overview || (account_1.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var billing;
                (function (billing) {
                    var detail;
                    (function (detail) {
                        'use strict';
                    })(detail = billing.detail || (billing.detail = {}));
                })(billing = overview.billing || (overview.billing = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var billing;
                (function (billing) {
                    var detail;
                    (function (detail) {
                        'use strict';
                        (function (PaymentMethodType) {
                            PaymentMethodType[PaymentMethodType["R"] = 0] = "R";
                            PaymentMethodType[PaymentMethodType["C"] = 1] = "C";
                            PaymentMethodType[PaymentMethodType["D"] = 2] = "D";
                            PaymentMethodType[PaymentMethodType["U"] = 3] = "U";
                        })(detail.PaymentMethodType || (detail.PaymentMethodType = {}));
                        var PaymentMethodType = detail.PaymentMethodType;
                        (function (CreditCardType) {
                            CreditCardType[CreditCardType["VISA"] = 0] = "VISA";
                            CreditCardType[CreditCardType["MASTER"] = 1] = "MASTER";
                            CreditCardType[CreditCardType["AMEX"] = 2] = "AMEX";
                            CreditCardType[CreditCardType["OTHERS"] = 3] = "OTHERS";
                        })(detail.CreditCardType || (detail.CreditCardType = {}));
                        var CreditCardType = detail.CreditCardType;
                    })(detail = billing.detail || (billing.detail = {}));
                })(billing = overview.billing || (overview.billing = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var billing;
                (function (billing) {
                    var detail;
                    (function (detail) {
                        'use strict';
                    })(detail = billing.detail || (billing.detail = {}));
                })(billing = overview.billing || (overview.billing = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account.selection || (account.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                (function (STEP) {
                    STEP[STEP["INITIAL"] = 0] = "INITIAL";
                    STEP[STEP["CHANGE_FORM"] = 1] = "CHANGE_FORM";
                    STEP[STEP["SUCCESS"] = 2] = "SUCCESS";
                    STEP[STEP["FAILURE"] = 3] = "FAILURE";
                })(callerId.STEP || (callerId.STEP = {}));
                var STEP = callerId.STEP;
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var log;
                (function (log) {
                    'use strict';
                    (function (LogLevel) {
                        LogLevel[LogLevel["OFF"] = 0] = "OFF";
                        LogLevel[LogLevel["FATAL"] = 1] = "FATAL";
                        LogLevel[LogLevel["ERROR"] = 2] = "ERROR";
                        LogLevel[LogLevel["WARN"] = 3] = "WARN";
                        LogLevel[LogLevel["INFO"] = 4] = "INFO";
                        LogLevel[LogLevel["DEBUG"] = 5] = "DEBUG";
                        LogLevel[LogLevel["TRACE"] = 6] = "TRACE";
                        LogLevel[LogLevel["ALL"] = 7] = "ALL";
                    })(log.LogLevel || (log.LogLevel = {}));
                    var LogLevel = log.LogLevel;
                })(log = api.log || (api.log = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                'use strict';
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var types;
                (function (types) {
                    'use strict';
                })(types = api.types || (api.types = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            var UtilsStatic = (function () {
                function UtilsStatic() {
                }
                UtilsStatic.memoizeResolver = function (o) {
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->input:', o);
                    // console.log(UtilsProvider.serviceName + '->memoizeResolver->output:', _.chain(o).filter(e => angular.isDefined(e)).values().value().sort().join('_'));
                    return _.chain(o).filter(function (e) { return angular.isDefined(e); }).values().value().sort().join('_');
                };
                UtilsStatic.getCookieModule = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'ngBiscuit' : 'ngCookies'; };
                UtilsStatic.getCookieService = function () { return angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'; };
                return UtilsStatic;
            }());
            utils.UtilsStatic = UtilsStatic;
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                service.formErrorDefaultFieldName = '<not specified>';
                (function (ErrorType) {
                    ErrorType[ErrorType["FORM"] = 0] = "FORM";
                    ErrorType[ErrorType["SELF_SERVE"] = 1] = "SELF_SERVE";
                    ErrorType[ErrorType["HTTP"] = 2] = "HTTP";
                    ErrorType[ErrorType["SIGNIN"] = 3] = "SIGNIN";
                    ErrorType[ErrorType["LOCATION"] = 4] = "LOCATION";
                    ErrorType[ErrorType["CREDIT"] = 5] = "CREDIT";
                    ErrorType[ErrorType["USER"] = 6] = "USER";
                    ErrorType[ErrorType["BUSINESS_LOGIC"] = 7] = "BUSINESS_LOGIC";
                    ErrorType[ErrorType["PAGE_LOAD"] = 8] = "PAGE_LOAD";
                })(service.ErrorType || (service.ErrorType = {}));
                var ErrorType = service.ErrorType;
                (function (DataLayerPredefinedSection) {
                    DataLayerPredefinedSection[DataLayerPredefinedSection["ACCOUNT"] = 0] = "ACCOUNT";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE"] = 1] = "PAGE";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE_VIEW_EVENT"] = 2] = "PAGE_VIEW_EVENT";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["SIGNIN"] = 3] = "SIGNIN";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["SITE"] = 4] = "SITE";
                    DataLayerPredefinedSection[DataLayerPredefinedSection["GLOBAL"] = 5] = "GLOBAL";
                })(service.DataLayerPredefinedSection || (service.DataLayerPredefinedSection = {}));
                var DataLayerPredefinedSection = service.DataLayerPredefinedSection;
                (function (ErrorCategory) {
                    ErrorCategory[ErrorCategory["BUYFLOW"] = 0] = "BUYFLOW";
                    ErrorCategory[ErrorCategory["SELF_SERVE"] = 1] = "SELF_SERVE";
                    ErrorCategory[ErrorCategory["LOGIN"] = 2] = "LOGIN";
                    ErrorCategory[ErrorCategory["VAS"] = 3] = "VAS";
                })(service.ErrorCategory || (service.ErrorCategory = {}));
                var ErrorCategory = service.ErrorCategory;
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            var DtmServiceAction = (function () {
                function DtmServiceAction() {
                }
                DtmServiceAction.START = 'started';
                DtmServiceAction.COMPLETE = 'completed';
                DtmServiceAction.EXCEPTION = 'error';
                return DtmServiceAction;
            }());
            service.DtmServiceAction = DtmServiceAction;
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            (function (ErrorType) {
                ErrorType[ErrorType["FORM"] = 0] = "FORM";
                ErrorType[ErrorType["SELF_SERVE"] = 1] = "SELF_SERVE";
                ErrorType[ErrorType["HTTP"] = 2] = "HTTP";
                ErrorType[ErrorType["SIGNIN"] = 3] = "SIGNIN";
                ErrorType[ErrorType["LOCATION"] = 4] = "LOCATION";
                ErrorType[ErrorType["CREDIT"] = 5] = "CREDIT";
            })(service.ErrorType || (service.ErrorType = {}));
            var ErrorType = service.ErrorType;
            ;
            (function (DataLayerPredefinedSection) {
                DataLayerPredefinedSection[DataLayerPredefinedSection["ACCOUNT"] = 0] = "ACCOUNT";
                DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE"] = 1] = "PAGE";
                DataLayerPredefinedSection[DataLayerPredefinedSection["PAGE_VIEW_EVENT"] = 2] = "PAGE_VIEW_EVENT";
                DataLayerPredefinedSection[DataLayerPredefinedSection["SIGNIN"] = 3] = "SIGNIN";
                DataLayerPredefinedSection[DataLayerPredefinedSection["SITE"] = 4] = "SITE";
            })(service.DataLayerPredefinedSection || (service.DataLayerPredefinedSection = {}));
            var DataLayerPredefinedSection = service.DataLayerPredefinedSection;
            ;
            ;
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var eclipse;
        (function (eclipse) {
            var remote;
            (function (remote) {
                var api;
                (function (api) {
                    'use strict';
                })(api = remote.api || (remote.api = {}));
            })(remote = eclipse.remote || (eclipse.remote = {}));
        })(eclipse = rogers.eclipse || (rogers.eclipse = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var eclipse;
        (function (eclipse) {
            var remote;
            (function (remote) {
                var api;
                (function (api) {
                    'use strict';
                })(api = remote.api || (remote.api = {}));
            })(remote = eclipse.remote || (eclipse.remote = {}));
        })(eclipse = rogers.eclipse || (rogers.eclipse = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            (function (STATE) {
                STATE[STATE["processing"] = 0] = "processing";
                STATE[STATE["error"] = 1] = "error";
                STATE[STATE["data"] = 2] = "data";
            })(usage.STATE || (usage.STATE = {}));
            var STATE = usage.STATE;
            ;
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));



var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var formChequing;
            (function (formChequing) {
                'use strict';
                (function (BankFormField) {
                    BankFormField[BankFormField["transit"] = 1] = "transit";
                    BankFormField[BankFormField["institution"] = 2] = "institution";
                    BankFormField[BankFormField["account"] = 3] = "account";
                    BankFormField[BankFormField["blank"] = 4] = "blank";
                })(formChequing.BankFormField || (formChequing.BankFormField = {}));
                var BankFormField = formChequing.BankFormField;
            })(formChequing = method.formChequing || (method.formChequing = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            'use strict';
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var modal;
            (function (modal) {
                'use strict';
                (function (STEPS) {
                    STEPS[STEPS["ACCOUNT"] = 1] = "ACCOUNT";
                    STEPS[STEPS["REVIEW"] = 2] = "REVIEW";
                    STEPS[STEPS["CONFIRMATION"] = 3] = "CONFIRMATION";
                    STEPS[STEPS["CHANGE_MOP"] = 4] = "CHANGE_MOP";
                    STEPS[STEPS["SUCCESS"] = 5] = "SUCCESS";
                    STEPS[STEPS["FAILURE"] = 6] = "FAILURE";
                    STEPS[STEPS["MOP_IS_CHANGING"] = 7] = "MOP_IS_CHANGING";
                    STEPS[STEPS["NO_CHANGE_MADE"] = 8] = "NO_CHANGE_MADE";
                })(modal.STEPS || (modal.STEPS = {}));
                var STEPS = modal.STEPS;
            })(modal = method.modal || (method.modal = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var permissions;
        (function (permissions) {
            var service;
            (function (service) {
                'use strict';
                /**
                 * List of all available user permissions
                 */
                (function (UserPermissions) {
                    UserPermissions[UserPermissions["USERNAME_MIGRATION"] = 0] = "USERNAME_MIGRATION";
                    UserPermissions[UserPermissions["REVOLUTION"] = 1] = "REVOLUTION";
                    UserPermissions[UserPermissions["TPSA_PAGE_VIEW"] = 2] = "TPSA_PAGE_VIEW";
                    UserPermissions[UserPermissions["RFR"] = 3] = "RFR";
                    UserPermissions[UserPermissions["ONEVIEW_CHANGE_SIM_CARD_DEALER"] = 4] = "ONEVIEW_CHANGE_SIM_CARD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_RESET_VOICE_MAIL_PASSWORD_DEALER"] = 5] = "ONEVIEW_RESET_VOICE_MAIL_PASSWORD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_CHANGE_SIM_CARD_CARE"] = 6] = "ONEVIEW_CHANGE_SIM_CARD_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_RESET_VOICE_MAIL_PASSWORD_CARE"] = 7] = "ONEVIEW_RESET_VOICE_MAIL_PASSWORD_CARE";
                    UserPermissions[UserPermissions["RAM"] = 8] = "RAM";
                    UserPermissions[UserPermissions["ONEVIEW_REVOLUTION_CARE"] = 9] = "ONEVIEW_REVOLUTION_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_PAY_NOW_DEALER"] = 10] = "ONEVIEW_PAY_NOW_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PAY_NOW_CARE"] = 11] = "ONEVIEW_PAY_NOW_CARE";
                    UserPermissions[UserPermissions["RFR_TWILIGHT_VIEW"] = 12] = "RFR_TWILIGHT_VIEW";
                    UserPermissions[UserPermissions["ONEVIEW_UPDATE_PAYMENT_METHOD_CARE"] = 13] = "ONEVIEW_UPDATE_PAYMENT_METHOD_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_UPDATE_PAYMENT_METHOD_DEALER"] = 14] = "ONEVIEW_UPDATE_PAYMENT_METHOD_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_UNLOCK_CARE"] = 15] = "ONEVIEW_PROFILE_UNLOCK_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_UNLOCK_DEALER"] = 16] = "ONEVIEW_PROFILE_UNLOCK_DEALER";
                    UserPermissions[UserPermissions["DATA_MANAGER_CONSUMER"] = 17] = "DATA_MANAGER_CONSUMER";
                    UserPermissions[UserPermissions["DISCOVERY_PAGE"] = 18] = "DISCOVERY_PAGE";
                    UserPermissions[UserPermissions["ONEVIEW_SUSPEND_CTN_CARE"] = 19] = "ONEVIEW_SUSPEND_CTN_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_SUSPEND_CTN_DEALER"] = 20] = "ONEVIEW_SUSPEND_CTN_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_REACTIVATE_CTN_CARE"] = 21] = "ONEVIEW_REACTIVATE_CTN_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_REACTIVATE_CTN_DEALER"] = 22] = "ONEVIEW_REACTIVATE_CTN_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_INTERACTION_NOTES_DEALER"] = 23] = "ONEVIEW_INTERACTION_NOTES_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_INTERACTION_NOTES_CARE"] = 24] = "ONEVIEW_INTERACTION_NOTES_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_DEALER"] = 25] = "ONEVIEW_PROFILE_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_PROFILE_CARE"] = 26] = "ONEVIEW_PROFILE_CARE";
                    UserPermissions[UserPermissions["ONEVIEW_REVOLUTION_DEALER"] = 27] = "ONEVIEW_REVOLUTION_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_RETENTION_PLANS_DEALER"] = 28] = "ONEVIEW_RETENTION_PLANS_DEALER";
                    UserPermissions[UserPermissions["ONEVIEW_RETENTION_PLANS_CARE"] = 29] = "ONEVIEW_RETENTION_PLANS_CARE";
                    UserPermissions[UserPermissions["CHANGE_SUBSCRIBER_NAME_ONEVIEW"] = 30] = "CHANGE_SUBSCRIBER_NAME_ONEVIEW";
                    UserPermissions[UserPermissions["ROAM_LIKE_HOME_IS_BRT"] = 31] = "ROAM_LIKE_HOME_IS_BRT";
                    UserPermissions[UserPermissions["TOKENIZATION_EVOLUTION"] = 32] = "TOKENIZATION_EVOLUTION";
                    UserPermissions[UserPermissions["CASL_CEM_ALL"] = 33] = "CASL_CEM_ALL";
                    UserPermissions[UserPermissions["CASL_CEM_LIMITED"] = 34] = "CASL_CEM_LIMITED";
                    UserPermissions[UserPermissions["CASL_CEM_UNSUBSCRIBE"] = 35] = "CASL_CEM_UNSUBSCRIBE";
                    UserPermissions[UserPermissions["SPOTIFY_PH3"] = 36] = "SPOTIFY_PH3";
                    UserPermissions[UserPermissions["ONEVIEW_ACTIONS_OFFERS"] = 37] = "ONEVIEW_ACTIONS_OFFERS";
                    UserPermissions[UserPermissions["ONEVIEW_HISTORICAL_USAGE"] = 38] = "ONEVIEW_HISTORICAL_USAGE";
                    UserPermissions[UserPermissions["FDM_VIDEOTHROTTLE"] = 39] = "FDM_VIDEOTHROTTLE";
                    UserPermissions[UserPermissions["WCOC_FDM_PCR9"] = 40] = "WCOC_FDM_PCR9";
                    UserPermissions[UserPermissions["MONERIS_POC"] = 41] = "MONERIS_POC";
                    UserPermissions[UserPermissions["ROGERS_DISABLE_ALL_USAGE"] = 42] = "ROGERS_DISABLE_ALL_USAGE";
                    UserPermissions[UserPermissions["ROGERS_DISPLAY_DATA_USAGE"] = 43] = "ROGERS_DISPLAY_DATA_USAGE";
                    UserPermissions[UserPermissions["ROGERS_ENABLE_ADDON"] = 44] = "ROGERS_ENABLE_ADDON";
                    UserPermissions[UserPermissions["ROGERS_ENABLE_ADDON_SE"] = 45] = "ROGERS_ENABLE_ADDON_SE";
                })(service.UserPermissions || (service.UserPermissions = {}));
                var UserPermissions = service.UserPermissions;
                /**
                 * List of all available resource codes for RAM permissions
                 * Used string type declaration to accept '.' inside the enum
                 */
                (function (RamResourceCodes) {
                    RamResourceCodes[RamResourceCodes["OneView"] = 'OneView'] = "OneView";
                    RamResourceCodes[RamResourceCodes["Rogers"] = 'Rogers'] = "Rogers";
                    RamResourceCodes[RamResourceCodes["InteractionHistory"] = 'InteractionHistory'] = "InteractionHistory";
                    RamResourceCodes[RamResourceCodes["CustomerProfile"] = 'CustomerProfile'] = "CustomerProfile";
                    RamResourceCodes[RamResourceCodes["MakePayment"] = 'MakePayment'] = "MakePayment";
                    RamResourceCodes[RamResourceCodes["SingleLinePPCBuyFlow"] = 'SingleLinePPCBuyFlow'] = "SingleLinePPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["OfferSale"] = 'Offer.Sale'] = "OfferSale";
                    RamResourceCodes[RamResourceCodes["RoamLikeHome"] = 'RoamLikeHome'] = "RoamLikeHome";
                    RamResourceCodes[RamResourceCodes["PromiseToPay"] = 'PromiseToPay'] = "PromiseToPay";
                    RamResourceCodes[RamResourceCodes["TransferOfResponsibility"] = 'TransferOfResponsibility'] = "TransferOfResponsibility";
                    RamResourceCodes[RamResourceCodes["CreditManagement"] = 'CreditManagement'] = "CreditManagement";
                    RamResourceCodes[RamResourceCodes["RepFooter"] = 'RepFooter'] = "RepFooter";
                    RamResourceCodes[RamResourceCodes["ProfileContactInfo"] = 'ProfileContactInfo'] = "ProfileContactInfo";
                    RamResourceCodes[RamResourceCodes["ProfileBillingDetails"] = 'ProfileBillingDetails'] = "ProfileBillingDetails";
                    RamResourceCodes[RamResourceCodes["HUPBuyFlow"] = 'HUPBuyFlow'] = "HUPBuyFlow";
                    RamResourceCodes[RamResourceCodes["RetentionOfferBuyFlow"] = 'RetentionOfferBuyFlow'] = "RetentionOfferBuyFlow";
                    RamResourceCodes[RamResourceCodes["PointsToMentionBuyFlow"] = 'PointsToMentionBuyFlow'] = "PointsToMentionBuyFlow";
                    RamResourceCodes[RamResourceCodes["FutureDatePPCBuyFlow"] = 'FutureDatePPCBuyFlow'] = "FutureDatePPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["DealerCode"] = 'DealerCode'] = "DealerCode";
                    RamResourceCodes[RamResourceCodes["PPCBuyFlow"] = 'PPCBuyFlow'] = "PPCBuyFlow";
                    RamResourceCodes[RamResourceCodes["CreditCardCapture"] = 'CreditCardCapture'] = "CreditCardCapture";
                    RamResourceCodes[RamResourceCodes["OneviewFooter"] = 'OneviewFooter'] = "OneviewFooter";
                    RamResourceCodes[RamResourceCodes["ProfileBillingType"] = 'ProfileBillingType'] = "ProfileBillingType";
                    RamResourceCodes[RamResourceCodes["RegularAdjustment"] = 'RegularAdjustment'] = "RegularAdjustment";
                    RamResourceCodes[RamResourceCodes["AdvancedAdjustment"] = 'AdvancedAdjustment'] = "AdvancedAdjustment";
                    RamResourceCodes[RamResourceCodes["ShoppingCart"] = 'ShoppingCart'] = "ShoppingCart";
                    RamResourceCodes[RamResourceCodes["ChangeCallerId"] = 'ChangeCallerId'] = "ChangeCallerId";
                    RamResourceCodes[RamResourceCodes["ChangePaymentMethod"] = 'ChangePaymentMethod'] = "ChangePaymentMethod";
                    RamResourceCodes[RamResourceCodes["IntChangePkg"] = 'INT_changepkg'] = "IntChangePkg";
                    RamResourceCodes[RamResourceCodes["IntCancelServices"] = 'INT_cancelservices'] = "IntCancelServices";
                    RamResourceCodes[RamResourceCodes["IntExchangeModem"] = 'INT_exchangemodem'] = "IntExchangeModem";
                    RamResourceCodes[RamResourceCodes["IntCheckNetWorkspd"] = 'INT_checknetworkspd'] = "IntCheckNetWorkspd";
                    RamResourceCodes[RamResourceCodes["IntRogersYahooEmail"] = 'INT_rogers_yahooemail'] = "IntRogersYahooEmail";
                    RamResourceCodes[RamResourceCodes["IntSignIn"] = 'INT_sign_in'] = "IntSignIn";
                    RamResourceCodes[RamResourceCodes["IntRegister"] = 'INT_register'] = "IntRegister";
                    RamResourceCodes[RamResourceCodes["RhpManagefeatures"] = 'RHP_managefeatures'] = "RhpManagefeatures";
                    RamResourceCodes[RamResourceCodes["RhpCancelservices"] = 'RHP_cancelservices'] = "RhpCancelservices";
                    RamResourceCodes[RamResourceCodes["ActionOffers"] = 'ActionOffers'] = "ActionOffers";
                    RamResourceCodes[RamResourceCodes["ChangeSIM"] = 'ChangeSIM'] = "ChangeSIM";
                    RamResourceCodes[RamResourceCodes["Maestro_SHM_Dashboard"] = 'Maestro_SHM_Dashboard'] = "Maestro_SHM_Dashboard";
                    RamResourceCodes[RamResourceCodes["TvChngpkg"] = 'TV_chngpkg'] = "TvChngpkg";
                    RamResourceCodes[RamResourceCodes["TvSwapflex"] = 'TV_swapflex'] = "TvSwapflex";
                    RamResourceCodes[RamResourceCodes["TVCancelservices"] = 'TV_cancelservices'] = "TVCancelservices";
                    RamResourceCodes[RamResourceCodes["TVAddChngextras"] = 'TV_add_chngextras'] = "TVAddChngextras";
                    RamResourceCodes[RamResourceCodes["TVAdddigitalbox"] = 'TV_adddigitalbox'] = "TVAdddigitalbox";
                    RamResourceCodes[RamResourceCodes["TVExchngdigitalbox"] = 'TV_exchngdigitalbox'] = "TVExchngdigitalbox";
                    RamResourceCodes[RamResourceCodes["TVResetdigitalbox"] = 'TV_resetdigitalbox'] = "TVResetdigitalbox";
                    RamResourceCodes[RamResourceCodes["TVResetparentalcpin"] = 'TV_resetparentalcpin'] = "TVResetparentalcpin";
                    RamResourceCodes[RamResourceCodes["TVResetondemandpin"] = 'TV_resetondemandpin'] = "TVResetondemandpin";
                    RamResourceCodes[RamResourceCodes["TVChngpkgStarter"] = 'TV_chngpkg_starter'] = "TVChngpkgStarter";
                    RamResourceCodes[RamResourceCodes["TVCancelservicesStarter"] = 'TV_cancelservices_starter'] = "TVCancelservicesStarter";
                    RamResourceCodes[RamResourceCodes["TVAddChngextrasStarter"] = 'TV_add_chngextras_starter'] = "TVAddChngextrasStarter";
                    RamResourceCodes[RamResourceCodes["TVAdddigitalboxStarter"] = 'TV_adddigitalbox_starter'] = "TVAdddigitalboxStarter";
                    RamResourceCodes[RamResourceCodes["TVExchngdigitalboxStarter"] = 'TV_exchngdigitalbox_starter'] = "TVExchngdigitalboxStarter";
                    RamResourceCodes[RamResourceCodes["TVResetdigitalboxStarter"] = 'TV_resetdigitalbox_starter'] = "TVResetdigitalboxStarter";
                    RamResourceCodes[RamResourceCodes["TVResetparentalcpinStarter"] = 'TV_resetparentalcpin_starter'] = "TVResetparentalcpinStarter";
                    RamResourceCodes[RamResourceCodes["TVResetondemandpinStarter"] = 'TV_resetondemandpin_starter'] = "TVResetondemandpinStarter";
                    RamResourceCodes[RamResourceCodes["RHPConfigurefeatures"] = 'RHP_configurefeatures'] = "RHPConfigurefeatures";
                    RamResourceCodes[RamResourceCodes["RHPAccessvoicemailsettings"] = 'RHP_accessvoicemailsettings'] = "RHPAccessvoicemailsettings";
                    RamResourceCodes[RamResourceCodes["RHPVoicemailpassword"] = 'RHP_voicemailpassword'] = "RHPVoicemailpassword";
                    RamResourceCodes[RamResourceCodes["RHPAddremovefeatures"] = 'RHP_addremovefeatures'] = "RHPAddremovefeatures";
                    RamResourceCodes[RamResourceCodes["MaestroResidentialServices"] = 'MaestroResidentialServices'] = "MaestroResidentialServices";
                    RamResourceCodes[RamResourceCodes["BundleBuilder"] = 'BundleBuilder'] = "BundleBuilder";
                    RamResourceCodes[RamResourceCodes["AuthorizedUsersWCoC"] = 'AuthorizedUsersWCoC'] = "AuthorizedUsersWCoC";
                    RamResourceCodes[RamResourceCodes["AgingBucket"] = 'AgingBucket'] = "AgingBucket";
                    RamResourceCodes[RamResourceCodes["DelinquencyIndicator"] = 'DelinquencyIndicator'] = "DelinquencyIndicator";
                    RamResourceCodes[RamResourceCodes["AutoRegistration"] = 'AutoRegistration'] = "AutoRegistration";
                    RamResourceCodes[RamResourceCodes["RepNotifications"] = 'RepNotifications'] = "RepNotifications";
                    RamResourceCodes[RamResourceCodes["Maestro_ExistingCX_IgniteBundleNAC"] = 'Maestro_ExistingCX_IgniteBundleNAC'] = "Maestro_ExistingCX_IgniteBundleNAC";
                    RamResourceCodes[RamResourceCodes["ARPA"] = 'ARPA'] = "ARPA";
                })(service.RamResourceCodes || (service.RamResourceCodes = {}));
                var RamResourceCodes = service.RamResourceCodes;
                /**
                 * List of all available action codes for RAM permissions
                 */
                (function (RamActionCodes) {
                    RamActionCodes[RamActionCodes["read"] = 0] = "read";
                    RamActionCodes[RamActionCodes["update"] = 1] = "update";
                    RamActionCodes[RamActionCodes["start"] = 2] = "start";
                    RamActionCodes[RamActionCodes["remove"] = 3] = "remove";
                    RamActionCodes[RamActionCodes["make"] = 4] = "make";
                    RamActionCodes[RamActionCodes["add"] = 5] = "add";
                    RamActionCodes[RamActionCodes["grant"] = 6] = "grant";
                    RamActionCodes[RamActionCodes["inprogress"] = 7] = "inprogress";
                    RamActionCodes[RamActionCodes["enable"] = 8] = "enable";
                    RamActionCodes[RamActionCodes["mandatory"] = 9] = "mandatory";
                    RamActionCodes[RamActionCodes["manual"] = 10] = "manual";
                    RamActionCodes[RamActionCodes["reader"] = 11] = "reader";
                })(service.RamActionCodes || (service.RamActionCodes = {}));
                var RamActionCodes = service.RamActionCodes;
            })(service = permissions.service || (permissions.service = {}));
        })(permissions = common.permissions || (common.permissions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreKeys = (function () {
                    function RogersStoreKeys() {
                    }
                    RogersStoreKeys.IS_LOGIN = 'ute.rogers.signin.service.isLogin';
                    RogersStoreKeys.ROGERS_SIGNIN_USER = 'ute.rogers.signin.user';
                    RogersStoreKeys.ROGERS_DEEP_LINK_STATE = 'ute.rogers.deep.link.state';
                    RogersStoreKeys.ROGERS_DEEP_LINK_URL = 'ute.rci.deep.link.url';
                    RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER = 'phoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER = 'homePhoneNumber';
                    RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER = 'tvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER = 'shmAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_IPTV_ACCOUNT_NUMBER = 'iptvAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER = 'internetAccountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER = 'accountNumber';
                    RogersStoreKeys.ROGERS_SELECTED_BRITEBILL_ID = 'ute.rogers.selected.britebill.id';
                    RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER = 'accountTypeNumber';
                    RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION = 'ssoCodeVerification';
                    RogersStoreKeys.ROGERS_SESSION_TOKEN = 'ute.rogers.signin.sessionToken';
                    RogersStoreKeys.ROGERS_REMEMBER_ME = 'ute.rogers.signin.rememberMe';
                    RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW = 'isRepView';
                    RogersStoreKeys.ROGERS_X_SESSION_TOKEN = 'x_session_token';
                    return RogersStoreKeys;
                }());
                storage.RogersStoreKeys = RogersStoreKeys;
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    FrontEndErrorCode[FrontEndErrorCode["PROFILE_MANAGEMENT_MIDDLEWARE_FAILURE"] = 2] = "PROFILE_MANAGEMENT_MIDDLEWARE_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["CHANGE_USERNAME_FAILED_CODE"] = 3] = "CHANGE_USERNAME_FAILED_CODE";
                    FrontEndErrorCode[FrontEndErrorCode["PROFILE_MANAGEMENT_GENERIC_FAILURE"] = 4] = "PROFILE_MANAGEMENT_GENERIC_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["PASSWORD_MANAGEMENT_MIDDLEWARE_FAILURE"] = 5] = "PASSWORD_MANAGEMENT_MIDDLEWARE_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["CHANGE_PASSWORD_FAILED_CODE"] = 6] = "CHANGE_PASSWORD_FAILED_CODE";
                    FrontEndErrorCode[FrontEndErrorCode["PASSWORD_MANAGEMENT_GENERIC_FAILURE"] = 7] = "PASSWORD_MANAGEMENT_GENERIC_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["PROFILE_ALREADY_EXIST_MIDDLEWARE_FAILURE"] = 8] = "PROFILE_ALREADY_EXIST_MIDDLEWARE_FAILURE";
                })(edit.FrontEndErrorCode || (edit.FrontEndErrorCode = {}));
                var FrontEndErrorCode = edit.FrontEndErrorCode;
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var province;
        (function (province) {
            'use strict';
        })(province = blocks.province || (blocks.province = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var service;
                (function (service) {
                    'use strict';
                })(service = data.service || (data.service = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var service;
                (function (service) {
                    'use strict';
                })(service = data.service || (data.service = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var service;
                (function (service) {
                    'use strict';
                })(service = data.service || (data.service = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["SAVE_OK"] = 0] = "SAVE_OK";
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    FrontEndErrorCode[FrontEndErrorCode["CREATE_PROFILE_PROFILE_ALREADY_EXIST"] = 2] = "CREATE_PROFILE_PROFILE_ALREADY_EXIST";
                    FrontEndErrorCode[FrontEndErrorCode["CREATE_PROFILE_COMMUNICATION_ALREADY_EXIST"] = 3] = "CREATE_PROFILE_COMMUNICATION_ALREADY_EXIST";
                    FrontEndErrorCode[FrontEndErrorCode["CREATE_PROFILE_EMAIL_ALREADY_EXIST"] = 4] = "CREATE_PROFILE_EMAIL_ALREADY_EXIST";
                })(registration.FrontEndErrorCode || (registration.FrontEndErrorCode = {}));
                var FrontEndErrorCode = registration.FrontEndErrorCode;
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 0] = "GENERIC_ERROR";
                })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                var FrontEndErrorCode = service.FrontEndErrorCode;
            })(service = bill.service || (bill.service = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    (function (NavigationStatus) {
                        NavigationStatus[NavigationStatus["ACCOUNT_DROPDOWN"] = 0] = "ACCOUNT_DROPDOWN";
                        NavigationStatus[NavigationStatus["ACTIVE"] = 1] = "ACTIVE";
                        NavigationStatus[NavigationStatus["SHOW_ENABLE"] = 2] = "SHOW_ENABLE";
                        NavigationStatus[NavigationStatus["SHOW_DISABLE"] = 3] = "SHOW_DISABLE";
                        NavigationStatus[NavigationStatus["HIDE"] = 4] = "HIDE";
                    })(navigation.NavigationStatus || (navigation.NavigationStatus = {}));
                    var NavigationStatus = navigation.NavigationStatus;
                    (function (NavigationVisibility) {
                        NavigationVisibility[NavigationVisibility["ALL"] = 0] = "ALL";
                        NavigationVisibility[NavigationVisibility["DESKTOP_ONLY"] = 1] = "DESKTOP_ONLY";
                        NavigationVisibility[NavigationVisibility["MOBILE_ONLY"] = 2] = "MOBILE_ONLY"; // when width < 768
                    })(navigation.NavigationVisibility || (navigation.NavigationVisibility = {}));
                    var NavigationVisibility = navigation.NavigationVisibility;
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            (function (BadgeTypes) {
                BadgeTypes[BadgeTypes["homePhone"] = 0] = "homePhone";
                BadgeTypes[BadgeTypes["wireless"] = 1] = "wireless";
                BadgeTypes[BadgeTypes["tv"] = 2] = "tv";
                BadgeTypes[BadgeTypes["internet"] = 3] = "internet";
                BadgeTypes[BadgeTypes["smartHomeMonitoring"] = 4] = "smartHomeMonitoring";
                BadgeTypes[BadgeTypes["igniteTv"] = 5] = "igniteTv";
                BadgeTypes[BadgeTypes["igniteInternet"] = 6] = "igniteInternet";
                BadgeTypes[BadgeTypes["gameCenterLive"] = 7] = "gameCenterLive";
                BadgeTypes[BadgeTypes["rogersBank"] = 8] = "rogersBank";
                BadgeTypes[BadgeTypes["smartStream"] = 9] = "smartStream";
            })(subscriptionBadge.BadgeTypes || (subscriptionBadge.BadgeTypes = {}));
            var BadgeTypes = subscriptionBadge.BadgeTypes;
            ;
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 0] = "GENERIC_ERROR";
                })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                var FrontEndErrorCode = service.FrontEndErrorCode;
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                (function (Flows) {
                    Flows[Flows["NAC"] = 0] = "NAC";
                    Flows[Flows["ONEVIEW"] = 1] = "ONEVIEW";
                })(code.Flows || (code.Flows = {}));
                var Flows = code.Flows;
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var browser;
            (function (browser) {
                'use strict';
            })(browser = core.browser || (core.browser = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                /**
                 * List of all available BRT switches
                 */
                (function (BrtSwitches) {
                    BrtSwitches[BrtSwitches["ONEVIEW_RLH"] = 0] = "ONEVIEW_RLH";
                    BrtSwitches[BrtSwitches["REGISTRATION"] = 1] = "REGISTRATION";
                    BrtSwitches[BrtSwitches["USERNAME_MIGRATION"] = 2] = "USERNAME_MIGRATION";
                    BrtSwitches[BrtSwitches["ONEVIEW_HUP"] = 3] = "ONEVIEW_HUP";
                    BrtSwitches[BrtSwitches["BRITEBILL_UTE"] = 4] = "BRITEBILL_UTE";
                    BrtSwitches[BrtSwitches["NRS"] = 5] = "NRS";
                    BrtSwitches[BrtSwitches["REVOLUTION"] = 6] = "REVOLUTION";
                    BrtSwitches[BrtSwitches["RFR"] = 7] = "RFR";
                    BrtSwitches[BrtSwitches["JANRAIN_REGISTRATION"] = 8] = "JANRAIN_REGISTRATION";
                    BrtSwitches[BrtSwitches["TOKENIZATION_EVOLUTION"] = 9] = "TOKENIZATION_EVOLUTION";
                })(brtswitch.BrtSwitches || (brtswitch.BrtSwitches = {}));
                var BrtSwitches = brtswitch.BrtSwitches;
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = management.service || (management.service = {}));
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = management.service || (management.service = {}));
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var see;
            (function (see) {
                'use strict';
            })(see = manager.see || (manager.see = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 0] = "GENERIC_ERROR";
                })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                var FrontEndErrorCode = service.FrontEndErrorCode;
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var app;
    (function (app) {
        var banner;
        (function (banner) {
            'use strict';
        })(banner = app.banner || (app.banner = {}));
    })(app = ute.app || (ute.app = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var service;
            (function (service) {
                'use strict';
            })(service = page.service || (page.service = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var service;
            (function (service) {
                'use strict';
            })(service = page.service || (page.service = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            (function (EnvironmentType) {
                EnvironmentType[EnvironmentType["PROD"] = 0] = "PROD";
                EnvironmentType[EnvironmentType["QA"] = 1] = "QA";
                EnvironmentType[EnvironmentType["SIT"] = 2] = "SIT";
                EnvironmentType[EnvironmentType["DEV"] = 3] = "DEV";
                EnvironmentType[EnvironmentType["LOCAL"] = 4] = "LOCAL";
            })(environment.EnvironmentType || (environment.EnvironmentType = {}));
            var EnvironmentType = environment.EnvironmentType;
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    'use strict';
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var config;
            (function (config) {
                'use strict';
            })(config = ui.config || (ui.config = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var semafone;
    (function (semafone) {
        var service;
        (function (service) {
            'use strict';
        })(service = semafone.service || (semafone.service = {}));
    })(semafone = ute.semafone || (ute.semafone = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["CURRENT_SIM_CARD_NOT_VALID_ERROR"] = 1] = "CURRENT_SIM_CARD_NOT_VALID_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_CARD_NOT_VALID_ERROR"] = 2] = "NEW_SIM_CARD_NOT_VALID_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_CARD_IN_USE_ERROR"] = 3] = "NEW_SIM_CARD_IN_USE_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_HAS_BEEN_USED_BEFORE"] = 4] = "NEW_SIM_HAS_BEEN_USED_BEFORE";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_HAS_INVALID_SIM_PREFIX"] = 5] = "NEW_SIM_HAS_INVALID_SIM_PREFIX";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 6] = "GENERIC_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["NEW_SIM_IN_NFDB"] = 7] = "NEW_SIM_IN_NFDB";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["UPDATED_OK"] = 0] = "UPDATED_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = service.FrontEndErrorCode;
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var StateHandlerPriority = (function () {
                function StateHandlerPriority() {
                }
                StateHandlerPriority.LOW = 0;
                StateHandlerPriority.MEDIUM_LOW = 2500;
                StateHandlerPriority.MEDIUM = 5000;
                StateHandlerPriority.MEDIUM_HIGH = 7500;
                StateHandlerPriority.HIGH = 10000;
                return StateHandlerPriority;
            }());
            router.StateHandlerPriority = StateHandlerPriority;
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var totesApp;
(function (totesApp) {
    'use strict';
    ;
})(totesApp || (totesApp = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var integration;
            (function (integration) {
                'use strict';
            })(integration = common.integration || (common.integration = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var myr;
(function (myr) {
    var modules;
    (function (modules) {
        var viewBill;
        (function (viewBill) {
            'use strict';
        })(viewBill = modules.viewBill || (modules.viewBill = {}));
    })(modules = myr.modules || (myr.modules = {}));
})(myr || (myr = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                'use strict';
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = rogers.simcard || (rogers.simcard = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var TestAbstract = (function () {
                    function TestAbstract() {
                        this.restrict = 'E';
                        this.transclude = true;
                        this.template = '<div data-ng-if="test.test()"><ng-transclude></ng-transclude></div>';
                        this.scope = {};
                        this.controllerAs = 'test';
                        this.bindToController = true;
                    }
                    return TestAbstract;
                }());
                directives.TestAbstract = TestAbstract;
                var ControllerAbstract = (function () {
                    function ControllerAbstract(routerHelper) {
                        this.routerHelper = routerHelper;
                        this.test = function () { return false; };
                        this.statesArray = this.states ? this.states.split(',').map(function (s) { return s.trim(); }) : [];
                    }
                    return ControllerAbstract;
                }());
                directives.ControllerAbstract = ControllerAbstract;
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                var Messages = (function () {
                    function Messages() {
                    }
                    Messages.uteRogersInterceptorsAuthSigninRequired = 'ute.rogers.interceptors.auth.signin.required';
                    Messages.uteRogersInterceptorsAuthSignoutRequired = 'ute.rogers.interceptors.auth.signout.required';
                    Messages.uteUserResourceAccessPermissionDenied = 'ute.user.resource.access.permission.denied';
                    Messages.uteUserUnauthorized = 'ute.user.unauthorized';
                    Messages.uteRogersSigninSuccessful = 'ute.rogers.signin.successful';
                    Messages.uteRogersSignoutSuccessful = 'ute.rogers.signout.successful';
                    Messages.uteRogersAccountChanged = 'ute.rogers.account.has.been.changed';
                    Messages.uteRogersMobileMenuChanged = 'ute.rogers.mobile.menu.changed';
                    return Messages;
                }());
                bus.Messages = Messages;
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTestAbstract = (function () {
                    function UserTestAbstract() {
                        this.restrict = 'E';
                        this.transclude = true;
                        this.template = '<div data-ng-if="user.test()"><ng-transclude></ng-transclude></div>';
                        this.scope = {};
                        this.controllerAs = 'user';
                    }
                    return UserTestAbstract;
                }());
                directives.UserTestAbstract = UserTestAbstract;
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var subpub;
            (function (subpub) {
                'use strict';
                var SubPubGeneric = (function () {
                    function SubPubGeneric(logPrefix) {
                        var _this = this;
                        this.logPrefix = logPrefix;
                        this.onDataChangeSubs = [];
                        /**
                         * @param callback
                         * @param id
                         * @returns {boolean}
                         */
                        this.registerOnDataChangeHandler = function (callback, id) {
                            if (callback && id) {
                                var found = _.find(_this.onDataChangeSubs, function (val) { return val.id === id; });
                                if (found) {
                                    found.callback = callback;
                                }
                                else {
                                    _this.onDataChangeSubs.push({ callback: callback, id: id });
                                }
                                // console.log(this.logPrefix + '->registerOnDataChangeHandler: Subs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.unregisterOnDataChangeHandler = function (id) {
                            _this.onDataChangeSubs = _this.onDataChangeSubs.filter(function (o, index, array) { return o.id !== id; });
                            // if (this.subPubConfig.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                            // console.log(this.logPrefix + '->unregisterOnDataChangeHandler: onDataChangeSubs size=', this.onDataChangeSubs.length, 'id=', id, 'subs=', this.onDataChangeSubs);
                            // }
                            return true; // TODO
                        };
                        this.getSubsSize = function () { return _this.onDataChangeSubs.length; };
                        this.notifySubs = function () {
                            _this.onDataChangeSubs.forEach(function (handler) {
                                try {
                                    // console.log(this.logPrefix + '->notifySubs: handlerId=', handler.id, this.getChangableData());
                                    // noinspection TypeScriptValidateTypes
                                    handler.callback(_this.getChangableData());
                                }
                                catch (e) {
                                    console.log(_this.logPrefix + '->notifySubs->handler.callback->catch:', e, handler.id, _this.getChangableData());
                                }
                            });
                        };
                    }
                    return SubPubGeneric;
                }());
                subpub.SubPubGeneric = SubPubGeneric;
                angular.module('ute.common.core.subpub').constant('SubPubGeneric', SubPubGeneric);
            })(subpub = core.subpub || (core.subpub = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                var CacheableDataGeneric = (function (_super) {
                    __extends(CacheableDataGeneric, _super);
                    function CacheableDataGeneric(data, config, securityService, $http, $q, $timeout, userService, request) {
                        var _this = this;
                        _super.call(this, config.basic.logPrefix);
                        this.data = data;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this.request = request;
                        /**
                         * @returns {IPromise<T>}
                         */
                        this.getData = function () {
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->getData: onDataChangeHandlers.size=', _this.getSubsSize(), 'cachedResultInfo=', _.get(_this.cacheableData, 'cachedResultInfo'), 'isCallInProgress=', _this.isCallInProgress(), 'logLevel=', _this.config.basic.logLevel, ute.common.typescript.api.log.LogLevel.DEBUG);
                            }
                            if (_this.isDataLocallyCached()) {
                                if (!_this.callInProgress) {
                                    if (_this.config.basic.isCachableOnBackend && !_this.isBackendDataUpToDate()) {
                                        // returned locally cached data but schedule call to MW and notify all subs when data arrived
                                        _this.getDataRefresh(true, true);
                                    }
                                    else if (!_this.isLocalDataUpToDate()) {
                                        // returned locally cached data but schedule call to Play!/Cassandra and notify all subs when data arrived
                                        _this.getDataRefresh(false, true);
                                    }
                                }
                                // return this.$q.when<IAccountOverview>(angular.copy(this.accountOverviewData.data)); // old style
                                return new _this.$q(function (resolve) { return resolve(_.clone(_this.cacheableData.data)); });
                            }
                            else if (_this.callInProgress) {
                                // other call with the same request data
                                return _this.callInProgress;
                            }
                            else {
                                // Fastest way to get it from Play!/Cassandra
                                return _this.getDataRefresh(false);
                            }
                        };
                        /**
                         *
                         * @param refresh - true | false | undefined
                         * @param async - true - call has been instantiated internally and result will be processed by subpub
                         * @returns {IPromise<T>}
                         */
                        this.getDataRefresh = function (refresh, async) {
                            if (async === void 0) { async = false; }
                            var base = {
                                applicationId: _this.config.basic.applicationId,
                            };
                            if (_this.config.basic.isCachableOnBackend && !_.isUndefined(refresh)) {
                                base.refresh = refresh;
                            }
                            var config = angular.isObject(_this.$http.defaults) ? {
                                transformRequest: (_.get(_this.config, 'basic.$http.transformRequest') ? [].concat(_this.$http.defaults.transformRequest, _this.config.basic.$http.transformRequest) : _this.$http.defaults.transformRequest),
                                transformResponse: (_.get(_this.config, 'basic.$http.transformResponse') ? [].concat(_this.$http.defaults.transformResponse, _this.config.basic.$http.transformResponse) : _this.$http.defaults.transformResponse)
                            } : {};
                            config = angular.extend(config, async ? { extraInfo: { async: async } } : {});
                            // const config: IRequestShortcutConfig & any = async ? {extraInfo: {async: async}} : undefined;
                            var request = _.assign(base, _this.request);
                            _this.callInProgress = _this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.partialApiUrl), request, config)
                                .then(_this.processOk)
                                .catch(_this.processError);
                            return _this.callInProgress;
                        };
                        /**
                         * @param response
                         * @returns {T}
                         */
                        this.processOk = function (response) {
                            _this.callInProgress = null;
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->processOk:', 'response.config.data=', response.config.data, 'cachedResultInfo=', response.data.cachedResultInfo, 'onDataChangeHandlers.size=', _this.getSubsSize());
                            }
                            var cachedResponse = false;
                            // Cachable or Not Cachable response
                            if (_.has(response.data, 'cachedResultInfo.cachedDate')) {
                                cachedResponse = true;
                                // incomming data just a string
                                response.data.cachedResultInfo.cachedDate = new Date(response.data.cachedResultInfo.cachedDate.toString());
                            }
                            // If No Local Cache or backend(Play!/Cassandra) cache has been updated
                            if (!_this.isDataLocallyCached() || !cachedResponse || _this.isBackendCacheHasBeenUpdated(response.data.cachedResultInfo.cachedDate)) {
                                var rawData = angular.extend({}, response.data);
                                if (cachedResponse) {
                                    var cachedResultInfo = {
                                        cachedDate: response.data.cachedResultInfo.cachedDate,
                                        cacheExpiryDate: new Date(response.data.cachedResultInfo.cacheExpiryDate.toString()),
                                        expired: Boolean(response.data.cachedResultInfo.expired)
                                    };
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        cachedResultInfo: cachedResultInfo,
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                else {
                                    delete response.data.cachedResultInfo; // Do not expose cachedResultInfo to the public
                                    // local cache
                                    _this.cacheableData = {
                                        localCachedDate: new Date(),
                                        data: _this.normalizeData(angular.extend(_this.data, response.data), rawData)
                                    };
                                }
                                if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                    console.log(_this.config.basic.logPrefix + '->LocalCache:', 'cacheableData:', _this.cacheableData);
                                }
                                if (_this.config.basic.isCachableOnBackend && !_this.isRefreshRequested(response.config.data) && !_this.isBackendDataUpToDate()) {
                                    _this.getDataRefresh(true, true);
                                }
                                // only if it's background call //TODO clear distinct between original call with promise returned to the caller and background async call
                                if (_.get(response.config, 'extraInfo.async')) {
                                    // if (this.isRefreshRequested(response.config.data)) {
                                    _this._notifySubs();
                                }
                            }
                            else {
                                _this.cacheableData.localCachedDate = new Date();
                            }
                            // if (this.isBackendDataUpToDate()) {
                            //   this.refreshCount = 1;
                            // } else {
                            // if backend return already expired data on refreshed request - schedule it
                            // If No scheduled and we tried already
                            /*
                             if (!this.scheduledRefresh && this.isRefreshRequested(response.config.data)) {
                             if (this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                             console.log(this.config.basic.logPrefix + '->scheduledRefresh: scheduled full refresh from MW in ' + 10 * this.refreshCount + ' sec');
                             }
                             this.scheduledRefresh = this.$timeout(() => {
                             this.getDataRefresh(true, true); // TODO if refreshable
                             }, 10000 * this.refreshCount); // 10 sec * n
                             this.refreshCount++;
                      
                             this.scheduledRefresh.finally(() => this.scheduledRefresh = null);
                             }
                             */
                            // }
                            // return immutable copy
                            return _.clone(_this.cacheableData.data);
                        };
                        /**
                         * normalizer backend datatypes
                         * default implementation - do nothing
                         * @param input
                         * @returns {T}
                         */
                        this.normalizeData = function (input, rawData) {
                            return input;
                        };
                        /**
                         * @param requestData
                         * @returns {boolean}
                         */
                        this.isRefreshRequested = function (requestData) {
                            return requestData.refresh === true;
                        };
                        /**
                         * @param error
                         * @returns {T}
                         */
                        this.processError = function (error) {
                            _this.callInProgress = null;
                            return new _this.$q(function (resolve, reject) { return reject(error); });
                        };
                        this.resetData = function () {
                            try {
                                _this.cleanup();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isCallInProgress = function () {
                            // return this.isCallInProgress;
                            return !!_this.callInProgress;
                        };
                        this._notifySubs = function () {
                            if (_this.isDataLocallyCached()) {
                                _this.notifySubs();
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isBackendCacheHasBeenUpdated = function (cachedDate) {
                            return angular.isDate(_.get(_this.cacheableData, 'cachedResultInfo.cachedDate')) && _this.cacheableData.cachedResultInfo.cachedDate.getTime() !== cachedDate.getTime();
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isDataLocallyCached = function () {
                            return _.isObject(_this.cacheableData);
                        };
                        /**
                         * Check if backend/Play!/Cassandra data up to date
                         * @returns {boolean}
                         */
                        this.isBackendDataUpToDate = function () {
                            var retval = _this.isDataLocallyCached() && (!_.get(_this.cacheableData, 'cachedResultInfo.expired', false) || _.get(_this.cacheableData, 'cachedResultInfo.expired', true) === false &&
                                _this.cacheableData.cachedResultInfo.cacheExpiryDate > new Date());
                            if (_this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG && _this.isDataLocallyCached() && _.has(_this.cacheableData, 'cachedResultInfo.cacheExpiryDate')) {
                                console.log(_this.config.basic.logPrefix + '->isBackendDataUpToDate:', retval, 'diffTimestamp=', _this.cacheableData.cachedResultInfo.cacheExpiryDate.getTime() - new Date().getTime(), 'backend cacheExpiryDate=', _this.cacheableData.cachedResultInfo.cacheExpiryDate);
                            }
                            return retval;
                        };
                        this.cleanup = function () {
                            _this.cacheableData = null;
                            if (_this.scheduledRefresh) {
                                _this.$timeout.cancel(_this.scheduledRefresh);
                            }
                        };
                        /**
                         * Check if local data up to date - 60 sec for now
                         * @returns {boolean}
                         */
                        this.isLocalDataUpToDate = function () {
                            // TODO 60000
                            var retval = _this.isDataLocallyCached() /*&& this.isBackendDataUpToDate()*/ && new Date().getTime() - _this.cacheableData.localCachedDate.getTime() <= 60000;
                            if (_this.isDataLocallyCached() && _this.config.basic.logLevel >= ute.common.typescript.api.log.LogLevel.DEBUG) {
                                console.log(_this.config.basic.logPrefix + '->isLocalDataUpToDate:', retval, 'diff=', new Date().getTime() - _this.cacheableData.localCachedDate.getTime(), 'localCachedDate=', _this.cacheableData.localCachedDate);
                            }
                            return retval;
                        };
                        this.config.basic.isCachableOnBackend = _.isUndefined(this.config.basic.isCachableOnBackend) ? true : this.config.basic.isCachableOnBackend;
                        this.config.basic.logLevel = this.config.basic.logLevel || ute.common.typescript.api.log.LogLevel.OFF;
                        this.userService.registerSigninHandler(this.cleanup, this);
                    }
                    ;
                    /**
                     * @override
                     * @returns {T}
                     */
                    CacheableDataGeneric.prototype.getChangableData = function () {
                        return _.get(this.cacheableData, 'data');
                    };
                    return CacheableDataGeneric;
                }(ute.common.core.subpub.SubPubGeneric));
                caching.CacheableDataGeneric = CacheableDataGeneric;
                angular.module('ute.common.core.caching').constant('CacheableDataGeneric', CacheableDataGeneric);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var ProviderBase = (function () {
                function ProviderBase() {
                    var _this = this;
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {C}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                }
                return ProviderBase;
            }());
            core.ProviderBase = ProviderBase;
            angular.module('ute.common.core').constant('ProviderBase', ProviderBase);
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var service;
            (function (service) {
                'use strict';
                var ResponseErrorHandlerGeneric = (function () {
                    function ResponseErrorHandlerGeneric(defaultFrontEndErrorCode, defaultBackEndErrorCode, logPrefix, $injector) {
                        var _this = this;
                        this.defaultFrontEndErrorCode = defaultFrontEndErrorCode;
                        this.defaultBackEndErrorCode = defaultBackEndErrorCode;
                        this.logPrefix = logPrefix;
                        this.errorCodesMap = {};
                        this.isCallInProgress = false;
                        this.openModalPopup = function (codeEntry) { return null; };
                        /**
                         * @param code
                         * @returns {boolean}
                         */
                        this.addCode = function (code) {
                            _this.errorCodesMap[code.frontendCode] = code;
                        };
                        /**
                         * @param backendCode
                         * @returns {<CE>}
                         */
                        this.findCodeEntry = function (backendCode) { return (_.find(_this.errorCodesMap, function (ce) {
                            return ce.backendCode === backendCode;
                        }) || _this.errorCodesMap[_this.defaultFrontEndErrorCode]); };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processOk:', 'response:', response, 'backendCode:', backendCode, 'retval:', retval);
                            return retval;
                        };
                        /**
                         * @param error
                         * @return {any}
                         */
                        this.processError = function (error) {
                            var backendCode = _.get(error, 'data.status.code', _this.defaultBackEndErrorCode);
                            var retval = _this.findCodeEntry(backendCode);
                            console.log(_this.logPrefix + '->processError:', 'error:', error, 'backendCode:', backendCode);
                            if (retval.windowTemplateUrl) {
                                return _this.openModalPopup(retval);
                            }
                            else {
                                return new _this.$q(function (resolve, reject) { return reject(retval); });
                            }
                        };
                        this.finaliseCall = function () {
                            _this.isCallInProgress = false;
                        };
                        this.$q = $injector.get('$q');
                    }
                    ;
                    return ResponseErrorHandlerGeneric;
                }());
                service.ResponseErrorHandlerGeneric = ResponseErrorHandlerGeneric;
                angular.module('ute.common.core').constant('ResponseErrorHandlerGeneric', ResponseErrorHandlerGeneric);
            })(service = core.service || (core.service = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestAbstract = (function () {
                        function TestAbstract() {
                            this.restrict = 'E';
                            this.transclude = true;
                            this.template = '<span data-ng-if="$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.scope = {};
                            this.controllerAs = '$ctrl';
                        }
                        return TestAbstract;
                    }());
                    directives.TestAbstract = TestAbstract;
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                    angular.module('ute.rogers.account.selection.overlay', [
                        'ute.rogers.account.overview.service'
                    ]);
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account.selection || (account.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
                angular.module('ute.common.selection.modal', []);
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessController = (function () {
            function GoPaperlessController(accountOverviewFactory, userService, $q, $modal, goPaperlessService, goPaperlessDataService) {
                var _this = this;
                this.accountOverviewFactory = accountOverviewFactory;
                this.userService = userService;
                this.$q = $q;
                this.$modal = $modal;
                this.goPaperlessService = goPaperlessService;
                this.goPaperlessDataService = goPaperlessDataService;
                this.goPaperlessBtnEnabled = true; //this value also has been used to display loading icon in CMS contents
                this.showGoPaperless = false;
                this.applyEBill = function () {
                    _this.goPaperlessBtnEnabled = false;
                    var payload = { accountNumber: _this.accountNumber };
                    if (_this.userService.isCare()) {
                        payload.ban = _this.accountNumber;
                    }
                    _this.goPaperlessDataService.getContactInfo(payload)
                        .then(function (response) {
                        var configObject = { accountNumber: _this.accountNumber, contactEmail: response.data.emailAddress };
                        _this.goPaperlessService.switchToPaperless(configObject)
                            .then(_this.switchToPaperlessSuccess)
                            .catch(_this.switchToPaperlessError);
                    })
                        .catch(function (error) {
                        _this.goPaperlessService.showFailedModal('ute.goPaperless.switchBillingErrorMessage'); // TODO: should we display another message for this scneario?
                        _this.goPaperlessBtnEnabled = true;
                    });
                };
                this.accountOverviewDataHandler = function (accountOverviewData) {
                    var account = accountOverviewData.getSelectedAccount();
                    _this.accountNumber = account.accountNumber;
                    _this.accountTypeNumber = account.accountTypeNumber;
                    if (!_this.isPrepaid()) {
                        //this callback is called many times by registerOnDataChangeHandler, so I added this condition to prevent extra method calls on goPaperlessService
                        if (String(_this.goPaperlessService.getCurrentAccountNumber()) !== String(_this.accountNumber)) {
                            _this.goPaperlessService.resetGoPaperless();
                            _this.resetFlags(); // to avoid displaying banner initially for new selected account, if getBillingType() takes time to get loaded.
                            _this.goPaperlessService.getBillingType(_this.accountNumber, _this.accountTypeNumber)
                                .then(_this.getBillingTypeSuccess);
                        }
                    }
                    else {
                        // if new selected account is prepaid, we should clear the cache bacause we do not have billingType for prepaid accounts
                        _this.goPaperlessService.resetGoPaperless();
                    }
                    return _this.$q.when(accountOverviewData); //Why should we return a promise?
                };
                this.switchToPaperlessSuccess = function (result) {
                    console.log(JSON.stringify(result));
                    _this.showGoPaperless = false;
                };
                this.switchToPaperlessError = function (result) {
                    console.log(JSON.stringify(result));
                    _this.showGoPaperless = true;
                    _this.goPaperlessBtnEnabled = true;
                };
                this.getBillingTypeSuccess = function (billingType) {
                    _this.showGoPaperless = (billingType !== _this.goPaperlessDataService.getConfig().basic.onlineBillingType);
                };
                this.resetFlags = function () {
                    _this.showGoPaperless = false;
                    _this.goPaperlessBtnEnabled = true;
                };
                this.isDealer = this.userService.isDealer();
                this.isCare = this.userService.isCare();
                var param;
                if (this.isCare) {
                    var ban = this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                    param = { acctNbr: Number(ban) };
                }
                var accountOverviewService = accountOverviewFactory(param);
                accountOverviewService.getSelectedAccount()
                    .then(function (account) {
                    if (account && account.accountNumber && +account.accountTypeNumber !== 9) {
                        _this.accountNumber = account.accountNumber;
                        _this.accountTypeNumber = account.accountTypeNumber;
                        _this.goPaperlessService.getBillingType(_this.accountNumber, _this.accountTypeNumber)
                            .then(_this.getBillingTypeSuccess);
                    }
                    else {
                        // if there is no account numbder, the service should be reset - so after linking an account again, it does not try to get the cached result.
                        _this.goPaperlessService.resetGoPaperless();
                    }
                });
            }
            GoPaperlessController.prototype.isBannerVisible = function () {
                // for prepaid accounts (with accountTypeNumber 9) we should not show banner
                return !this.isPrepaid() && this.showGoPaperless;
            };
            GoPaperlessController.prototype.goPaperlessLearnMore = function () {
                var learnMoreModal = this.$modal.open({
                    windowTemplateUrl: this.goPaperlessDataService.getConfig().advanced.modal.learnMore.windowTemplateUrl,
                    templateUrl: this.goPaperlessDataService.getConfig().advanced.modal.learnMore.templateUrl,
                    controller: this.goPaperlessDataService.getConfig().advanced.modal.learnMore.controller,
                    controllerAs: this.goPaperlessDataService.getConfig().advanced.modal.learnMore.controllerAs
                });
                learnMoreModal.result.then(this.applyEBill);
            };
            GoPaperlessController.prototype.isGoPaperlessBtnEnabled = function () {
                return this.goPaperlessBtnEnabled;
            };
            GoPaperlessController.prototype.isPrepaid = function () {
                return (+this.accountTypeNumber === 9);
            };
            GoPaperlessController.$inject = [
                'ute.rogers.account.overview.factory',
                'ute.common.user.service',
                '$q',
                '$modal',
                'ute.goPaperless.service',
                'ute.goPaperless.data.service'];
            return GoPaperlessController;
        }());
        goPaperless.GoPaperlessController = GoPaperlessController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.controller', GoPaperlessController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessDirective = (function () {
            function GoPaperlessDirective(accountOverviewFactory, userService) {
                var _this = this;
                this.accountOverviewFactory = accountOverviewFactory;
                this.userService = userService;
                this.restrict = 'E';
                this.controller = 'ute.goPaperless.controller';
                this.controllerAs = 'gp';
                this.bindToController = true;
                this.templateUrl = 'module/goPaperless.view.html';
                this.link = function (scope, elem, attributes, controller) {
                    _this.accountOverviewService.registerOnDataChangeHandler(controller.accountOverviewDataHandler, 'goPaperless');
                    scope.$on('$destroy', function () {
                        _this.accountOverviewService.unregisterOnDataChangeHandler('goPaperless');
                    });
                };
                var param;
                if (this.userService.isCare()) {
                    var ban = this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                    param = { acctNbr: Number(ban) };
                }
                this.accountOverviewService = accountOverviewFactory(param);
            }
            GoPaperlessDirective.factory = function () {
                var directive = function (accountOverviewFactory, userService) { return new GoPaperlessDirective(accountOverviewFactory, userService); };
                directive.$inject = ['ute.rogers.account.overview.factory', 'ute.common.user.service'];
                return directive;
            };
            return GoPaperlessDirective;
        }());
        angular
            .module('ute.goPaperless')
            .directive('uteGoPaperless', GoPaperlessDirective.factory());
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessService = (function () {
            function GoPaperlessService($q, $http, userService, $modal, goPaperlessDataService, $translate) {
                this.$q = $q;
                this.$http = $http;
                this.userService = userService;
                this.$modal = $modal;
                this.goPaperlessDataService = goPaperlessDataService;
                this.$translate = $translate;
                this.switchCallbacks = [];
                this.data = {
                    contactEmail: null,
                    accountNumber: null,
                    isGetBillingTypeInProgress: false,
                    billingTypePromiseCache: null
                };
                // after sign-in again, we do not want to see cached values in the service.
                userService.registerSignoutHandler(this.resetGoPaperless, this);
            }
            GoPaperlessService.prototype.switchToPaperless = function (configObject) {
                //initial configuration - configObject can be set by profile page or go-paperless banner in acccount overview
                this.data.accountNumber = configObject.accountNumber;
                this.data.contactEmail = configObject.contactEmail;
                this.deferred = this.$q.defer();
                if (!this.data.contactEmail) {
                    this.showSaveEmailModal(this.userService.getUser().userEmail);
                }
                else {
                    this.showCurrentEmailModal(this.data.contactEmail);
                }
                return this.deferred.promise;
            };
            GoPaperlessService.prototype.updateBillingType = function (email, accountNumber) {
                var _this = this;
                if (email === void 0) { email = this.data.contactEmail; }
                if (accountNumber === void 0) { accountNumber = this.data.accountNumber; }
                var payload = {
                    accountNumber: accountNumber,
                    billingType: this.goPaperlessDataService.getConfig().basic.onlineBillingType,
                    email: email
                };
                return this.goPaperlessDataService.updateBillingType(payload)
                    .then(function () {
                    _this.data.billingTypePromiseCache = _this.$q.when(_this.goPaperlessDataService.getConfig().basic.onlineBillingType);
                    _this.notifyListeners(_this.goPaperlessDataService.getConfig().basic.onlineBillingType);
                })
                    .catch(function () {
                    var errorMessageKey = 'ute.goPaperless.switchBillingErrorMessage';
                    _this.showFailedModal(errorMessageKey);
                    return _this.$q.reject();
                });
            };
            GoPaperlessService.prototype.updateEmailAddress = function (newEmail, accountNumber) {
                var _this = this;
                if (accountNumber === void 0) { accountNumber = this.data.accountNumber; }
                var payload = {
                    emailAddress: newEmail,
                    accountNumber: accountNumber
                };
                if (this.userService.isCare()) {
                    payload.ban = accountNumber;
                }
                return this.goPaperlessDataService.updateContactInfo(payload)
                    .catch(function (data) {
                    var errorMessageKey = (_this.data.contactEmail) ? 'ute.goPaperless.switchedButUpdateEmailFailedErrorMessage' : 'ute.goPaperless.updateEmailErrorMessage';
                    _this.showFailedModal(errorMessageKey);
                    return _this.$q.reject();
                });
            };
            GoPaperlessService.prototype.getBillingType = function (accountNumber, accountTypeNumber) {
                var _this = this;
                if ((String(accountNumber) === String(this.data.accountNumber)) && (this.data.isGetBillingTypeInProgress || this.data.billingTypePromiseCache)) {
                    // this condtion prevent parallel API calls and also prevent unnecessary API call if we already have the response
                    return this.data.billingTypePromiseCache;
                }
                else {
                    this.data.accountNumber = accountNumber;
                    this.data.isGetBillingTypeInProgress = true;
                    var payload = { accountNumber: accountNumber };
                    if (!this.isNewBillingTypeApi()) {
                        // for new API no need to pass accountTypeNumber
                        payload.accountTypeNumber = accountTypeNumber;
                    }
                    if (this.userService.isCare()) {
                        payload.ban = accountNumber;
                    }
                    this.data.billingTypePromiseCache = this.goPaperlessDataService.getBillingType(payload)
                        .then(function (response) {
                        console.log(accountNumber + ' billing type --->' + response.data.billingtype);
                        return response.data.billingtype;
                    })
                        .finally(function () {
                        _this.data.isGetBillingTypeInProgress = false;
                    });
                    return this.data.billingTypePromiseCache;
                }
            };
            GoPaperlessService.prototype.resetGoPaperless = function () {
                this.data.contactEmail = null;
                this.data.accountNumber = null;
                this.data.isGetBillingTypeInProgress = false;
                this.data.billingTypePromiseCache = null;
                this.deferred = this.$q.defer();
            };
            GoPaperlessService.prototype.getDeferredObj = function () {
                return this.deferred;
            };
            GoPaperlessService.prototype.getCurrentAccountNumber = function () {
                return this.data.accountNumber;
            };
            GoPaperlessService.prototype.getContactEmail = function () {
                return this.data.contactEmail;
            };
            GoPaperlessService.prototype.registerSwitchCallback = function (callback, id) {
                var found = _.find(this.switchCallbacks, function (value) { return value.id === id; });
                if (!found) {
                    this.switchCallbacks.push({ callback: callback, id: id });
                }
            };
            GoPaperlessService.prototype.unregisterSwitchCallback = function (id) {
                this.switchCallbacks = this.switchCallbacks.filter(function (value) { return value.id !== id; });
            };
            GoPaperlessService.prototype.showFailedModal = function (errorMessageKey) {
                this.$modal.open({
                    windowTemplateUrl: this.goPaperlessDataService.getConfig().advanced.modal.failed.windowTemplateUrl,
                    templateUrl: this.goPaperlessDataService.getConfig().advanced.modal.failed.templateUrl,
                    controller: this.goPaperlessDataService.getConfig().advanced.modal.failed.controller,
                    controllerAs: this.goPaperlessDataService.getConfig().advanced.modal.failed.controllerAs,
                    size: 'lg',
                    resolve: {
                        errorMessageKey: function () { return errorMessageKey; }
                    }
                });
            };
            GoPaperlessService.prototype.showSaveEmailModal = function (email) {
                var _this = this;
                this.$modal.open({
                    windowTemplateUrl: this.goPaperlessDataService.getConfig().advanced.modal.saveEmail.windowTemplateUrl,
                    templateUrl: this.goPaperlessDataService.getConfig().advanced.modal.saveEmail.templateUrl,
                    controller: this.goPaperlessDataService.getConfig().advanced.modal.saveEmail.controller,
                    controllerAs: this.goPaperlessDataService.getConfig().advanced.modal.saveEmail.controllerAs,
                    resolve: {
                        suggestedEmail: function () { return email; }
                    }
                }).result.catch(function () {
                    _this.deferred.reject({ switchSuccess: false });
                });
            };
            GoPaperlessService.prototype.showSuccessModal = function () {
                this.$modal.open({
                    windowTemplateUrl: this.goPaperlessDataService.getConfig().advanced.modal.success.windowTemplateUrl,
                    templateUrl: this.goPaperlessDataService.getConfig().advanced.modal.success.templateUrl,
                    controller: this.goPaperlessDataService.getConfig().advanced.modal.success.controller,
                    controllerAs: this.goPaperlessDataService.getConfig().advanced.modal.success.controllerAs,
                    size: 'lg'
                });
            };
            GoPaperlessService.prototype.notifyListeners = function (billingType) {
                this.switchCallbacks.forEach(function (item) {
                    item.callback(billingType);
                });
            };
            GoPaperlessService.prototype.isNewBillingTypeApi = function () {
                return this.goPaperlessDataService.getConfig().basic.apiUrl.getBillingType === 'v1/SelfServeAutomation/getBillTypeV2';
            };
            GoPaperlessService.prototype.showCurrentEmailModal = function (email) {
                var _this = this;
                this.$modal.open({
                    windowTemplateUrl: this.goPaperlessDataService.getConfig().advanced.modal.currentEmail.windowTemplateUrl,
                    templateUrl: this.goPaperlessDataService.getConfig().advanced.modal.currentEmail.templateUrl,
                    windowClass: 'switching-billing-modal',
                    controller: this.goPaperlessDataService.getConfig().advanced.modal.currentEmail.controller,
                    controllerAs: this.goPaperlessDataService.getConfig().advanced.modal.currentEmail.controllerAs,
                    resolve: {
                        email: function () { return email; }
                    }
                }).result.catch(function () {
                    _this.deferred.reject({ switchSuccess: false });
                });
            };
            GoPaperlessService.$inject = [
                '$q',
                '$http',
                'ute.common.user.service',
                '$modal',
                'ute.goPaperless.data.service',
                '$translate'];
            return GoPaperlessService;
        }());
        goPaperless.GoPaperlessService = GoPaperlessService;
        angular
            .module('ute.goPaperless')
            .service('ute.goPaperless.service', GoPaperlessService);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessDataProvider = (function () {
            /* @ngInject */
            function GoPaperlessDataProvider() {
                var _this = this;
                this.config = {
                    basic: {
                        applicationId: 'ute-application-id',
                        onlineBillingType: 'E_BILL',
                        apiUrl: {
                            updateBillingType: 'v1/updateProfileInfo/updateBillingType',
                            updateContactInfo: 'v1/updateProfileInfo/updateContactInfo',
                            getBillingType: 'v1/SelfServeAutomation/getBillTypeV2',
                            //getBillingType: 'v1/SelfServeAutomation/getBillType', // Old API
                            getContactInfo: 'v1/SelfServeAutomation/getContactInfo'
                        }
                    },
                    advanced: {
                        modal: {
                            learnMore: {
                                windowTemplateUrl: 'module/goPaperlessModalWindow.view.html',
                                templateUrl: 'module/learnMoreModal/view.html',
                                controller: 'ute.goPaperless.learnMore.controller',
                                controllerAs: 'goPaperlessLearnMore'
                            },
                            failed: {
                                windowTemplateUrl: 'module/goPaperlessModalWindow.view.html',
                                templateUrl: 'module/failedModal/view.html',
                                controller: 'ute.goPaperless.failedModal.controller',
                                controllerAs: 'goPaperlessFailedModal'
                            },
                            saveEmail: {
                                windowTemplateUrl: 'module/goPaperlessModalWindow.view.html',
                                templateUrl: 'module/emailModal/saveEmailModal.view.html',
                                controller: 'ute.goPaperless.saveEmailModal.controller',
                                controllerAs: 'goPaperlessSaveEmailModal'
                            },
                            success: {
                                windowTemplateUrl: 'module/goPaperlessModalWindow.view.html',
                                templateUrl: 'module/successModal/view.html',
                                controller: 'ute.goPaperless.successModal.controller',
                                controllerAs: 'goPaperlessSuccessModal'
                            },
                            currentEmail: {
                                windowTemplateUrl: 'module/goPaperlessModalWindow.view.html',
                                templateUrl: 'module/emailModal/currentEmailModal.view.html',
                                controller: 'ute.goPaperless.currentEmailModal.controller',
                                controllerAs: 'goPaperlessCurrentEmailModal',
                            }
                        }
                    }
                };
                /* @ngInject */
                this.$get = function ($http, $injector) {
                    _this.$http = $http;
                    _this.securityService = $injector.get('ute.common.security.service');
                    return {
                        getConfig: _this.getConfig,
                        updateBillingType: _this.updateBillingType,
                        updateContactInfo: _this.updateContactInfo,
                        getBillingType: _this.getBillingType,
                        getContactInfo: _this.getContactInfo
                    };
                };
                this.configure = function (config) {
                    _this.config = _.merge(_this.config, config);
                    return true;
                };
                this.getConfig = function () {
                    return angular.copy(_this.config);
                };
                this.updateBillingType = function (payload) {
                    return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.apiUrl.updateBillingType), payload);
                };
                this.updateContactInfo = function (payload) {
                    return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.apiUrl.updateContactInfo), payload);
                };
                this.getBillingType = function (payload) {
                    return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.apiUrl.getBillingType), payload);
                };
                this.getContactInfo = function (payload) {
                    return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.apiUrl.getContactInfo), payload);
                };
                this.$get.$inject = [
                    '$http',
                    '$injector',
                ];
            }
            return GoPaperlessDataProvider;
        }());
        goPaperless.GoPaperlessDataProvider = GoPaperlessDataProvider;
        angular
            .module('ute.goPaperless')
            .provider('ute.goPaperless.data.service', GoPaperlessDataProvider);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.rogers.user.registration').run(setPasswordRoutesConfig);
                setPasswordRoutesConfig.$inject = ['ute.blocks.router',
                    'ute.rogers.user.registration.service'
                ];
                function setPasswordRoutesConfig(routerHelper, userRegistrationService) {
                    var config = userRegistrationService.getConfig();
                    routerHelper.configureStates([
                        {
                            name: config.advanced.registration.stateName,
                            url: '/' + config.advanced.registration.stateName,
                            // url: '/' + config.advanced.setPassword.stateName,
                            controller: config.advanced.registration.controllerName,
                            controllerAs: 'registration',
                            templateUrl: config.advanced.registration.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        },
                        {
                            name: config.advanced.prepaid.stateName,
                            url: '/' + config.advanced.prepaid.stateName,
                            // url: '/' + config.advanced.setPassword.stateName,
                            controller: config.advanced.prepaid.controllerName,
                            controllerAs: 'registration',
                            templateUrl: config.advanced.prepaid.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        },
                        {
                            name: config.advanced.confirmation.stateName,
                            url: '/' + config.advanced.confirmation.stateName + '/:id',
                            // url: '/' + config.advanced.setPassword.stateName,
                            controller: config.advanced.confirmation.controllerName,
                            controllerAs: 'registration',
                            templateUrl: config.advanced.confirmation.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        }
                    ]);
                    routerHelper.registerToStateHandler(config.advanced.confirmation.stateName, userRegistrationService, ute.blocks.router.StateHandlerPriority.LOW);
                }
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user_1) {
            var service;
            (function (service) {
                'use strict';
                var UserService = (function () {
                    /* @ngInject */
                    function UserService($injector, config) {
                        var _this = this;
                        this.$injector = $injector;
                        this.config = config;
                        //private failSafeKey: string = this.utilsService.randomString();
                        this.failSafeKey = '7RvnncDPUc535aBZftoarnFdYXM1zlfY';
                        this.signinHandlers = [];
                        this.signoutHandlers = [];
                        this.loggedIn = 'loggedIn';
                        this.isSigned = function () {
                            //console.log('isSigned', !!this.user);
                            return !!_this.user;
                        };
                        this.signed = function (user) {
                            // because this called from pure JavaScript
                            if (angular.isString(user.userType)) {
                                //noinspection TypeScriptUnresolvedFunction
                                user.userType = user_1.UserType[user.userType.toString()];
                            }
                            //console.log('ute.user.service.UserService.signed: user=', user, ' cache=', (<any>this.getEncryptionKey).cache);
                            var userWithoutPassword = _.cloneDeep(user);
                            delete userWithoutPassword.userPassword;
                            _this.user = userWithoutPassword;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, userWithoutPassword);
                            _this.callSigninHandlers();
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, _this.user);
                        };
                        /**
                         * !!! do not use this method in real application !!!
                         */
                        this.signout = function () {
                            // TODO still not real signout, real signout provider must be called here
                            // this is temporary
                            // const options: any = {path: '/', domain: '.rogers.com'};
                            // this.$cookies.remove('SMSESSION', options);
                            // this.$cookies.remove('SM_USERAUTHENTICATED', options);
                            _this.config.advanced.signoutCallback(_this.$injector);
                            // this.unsigned();
                        };
                        this.unsigned = function () {
                            _this.callSignoutHandlers();
                            //console.log('ute.user.service.UserService.unsigned: user=', this.user, ' cache=', (<any>this.getEncryptionKey).cache);
                            _this.user = null;
                            _this.storageService.removeFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                            _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSignoutSuccessful);
                            //this.storageService.remove('ute.rogers.signin.user');
                        };
                        /**
                         * @returns {ute.common.user.IUser}
                         */
                        this.getUser = function () {
                            return angular.copy(_this.user);
                        };
                        this.setUsername = function (newUsername) {
                            _this.updateUsername(newUsername);
                        };
                        /**
                         * @returns {string}
                         */
                        this.getUserType = function () {
                            if (angular.isDefined(_this.user)) {
                                var ut = _.get(_this.user, 'userType');
                                return angular.isUndefined(ut) ? undefined : user_1.UserType[ut];
                            }
                            else {
                                return undefined;
                            }
                        };
                        this.setUserView = function (isRepView) {
                            _this.storageService.putToSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW, isRepView);
                        };
                        this.getUserView = function () {
                            return _this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW);
                        };
                        /**
                         * @param partialUrl
                         * @returns {string}
                         */
                        this.getBackendUrl = function (partialUrl) {
                            // console.log('ute.common.security.service->getBackendUrl', (this.config.roleToUrlBase[this.userService.getUserType()]) + partialUrl);
                            return (_.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.baseUrl') || UserProvider.protectedUrlPrefix) + partialUrl;
                        };
                        this.getPersistentService = function () {
                            return _.get(_this.config, 'roleToUrlBase.' + _this.getUserType() + '.persistentService') || _this.$injector.get('ute.blocks.persistent.storage.service').getLocalStoreService();
                        };
                        this.isAnyRoleGranted = function (userRoles) {
                            var rolesArray = userRoles ? userRoles.split(',').map(function (s) { return s.trim(); }) : [];
                            return _.include(rolesArray, _this.getUserType());
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSigninHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signinHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        /**
                         * @param callBack
                         * @param thisArg
                         * @param argArray
                         */
                        this.registerSignoutHandler = function (callBack, thisArg, argArray) {
                            if (callBack && thisArg) {
                                _this.signoutHandlers.push({ callBack: callBack, thisArg: thisArg, argArray: argArray });
                            }
                        };
                        this.getAuthCookieValue = function () {
                            return _this.$cookies.get(_this.loggedIn);
                        };
                        this.getAuthCookieName = function () {
                            return _this.loggedIn;
                        };
                        /**
                         * @returns {any}
                         * @private
                         */
                        this._getEncryptionKey = function () {
                            if (_this.isSigned()) {
                                return _this.$http.get(_this.getBackendUrl('v1/myKey'))
                                    .then(_this.processEncryptionKeyResponse)
                                    .catch(_.curry(_this.fail)('processEncryptionKeyResponse failed.'));
                            }
                            else {
                                return new _this.$q(function (resolve) { return resolve(_this.failSafeKey); });
                            }
                        };
                        /**
                         * @returns {any}
                         */
                        this.getUserName = function () {
                            return _.get(_this.user, 'userName');
                        };
                        this.updateUsername = function (newUsername) {
                            _this.user.userEmail = newUsername;
                            _this.user.userName = newUsername;
                            _this.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER, _this.user);
                        };
                        this.callSigninHandlers = function () {
                            _this.callHandlers(_this.signinHandlers);
                        };
                        this.callSignoutHandlers = function () {
                            _this.callHandlers(_this.signoutHandlers);
                        };
                        /**
                         * @param handlers
                         */
                        this.callHandlers = function (handlers) {
                            handlers.forEach(function (handler) {
                                try {
                                    // TODO async
                                    handler.callBack.apply(handler.thisArg, handler.argArray);
                                }
                                catch (e) {
                                }
                            });
                        };
                        this.getCacheName = function () {
                            return 'EncryptionKeyCacheName';
                        };
                        this.cleanCache = function () {
                            //console.log('ute.user.service.UserService.cleanCache: cache=', (<any>this.getEncryptionKey).cache);
                            _this.getEncryptionKey.cache.delete(_this.getCacheName());
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processEncryptionKeyResponse = function (response) {
                            //console.log('ute.user.service.UserService.processEncryptionKeyResponse', _.get<string>(response, 'data.content.key', this.failSafeKey));
                            return _.get(response, 'data.content.key', _this.failSafeKey);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {string}
                         */
                        //private fail: (reason: string, error: any) => ng.IPromise<any> = (reason: string, error: any) => {
                        this.fail = function (reason, error) {
                            //var msg = _.get(error, 'data.description', error);
                            //this.exceptionHandler.catcher(msg)(reason, 'ute.common.user.service');
                            //return this.$q.reject(msg);
                            //console.log('ute.user.service.UserService.fail', this.failSafeKey + this.getUserName());
                            return _this.failSafeKey + _this.getUserName();
                        };
                        this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                        this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                        this.$q = $injector.get('$q');
                        this.$http = $injector.get('$http');
                        // ute.common.utils.UtilsStatic.getCookieService(),
                        this.$cookies = $injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                        // we don't know who the user is at this point, so we try form both: local and session
                        this.user = this.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER) ||
                            this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SIGNIN_USER);
                        var sessionCookie = this.getAuthCookieValue();
                        if (this.isConsumer() && (sessionCookie === null || sessionCookie === undefined || sessionCookie === 'LOGGEDOFF')) {
                            this.user = null;
                        }
                        this.getEncryptionKey = _.memoize(this._getEncryptionKey, this.getCacheName);
                        this.registerSigninHandler(this.cleanCache, this);
                        this.getUserRole = this.getUserType;
                    }
                    UserService.prototype.setProfileId = function (profileId) {
                        this.user.profileId = profileId;
                    };
                    ;
                    UserService.prototype.getProfileId = function () {
                        return _.get(this.user, 'profileId');
                    };
                    ;
                    UserService.prototype.setAccountId = function (accountId) {
                        this.user.accountId = accountId;
                    };
                    ;
                    UserService.prototype.getAccountId = function () {
                        return _.get(this.user, 'accountId');
                    };
                    ;
                    UserService.prototype.isConsumer = function () {
                        return !!this.user && this.user.userType === user_1.UserType.consumer;
                    };
                    UserService.prototype.isDealer = function () {
                        return !!this.user && this.user.userType === user_1.UserType.dealer;
                    };
                    UserService.prototype.isCare = function () {
                        return !!this.user && this.user.userType === user_1.UserType.care;
                    };
                    UserService.prototype.isRepView = function () {
                        return this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_ONEVIEW_REPVIEW) === true;
                    };
                    UserService.$inject = [
                        '$injector'
                    ];
                    return UserService;
                }());
                var UserProvider = (function () {
                    /* @ngInject */
                    function UserProvider() {
                        var _this = this;
                        this.config = {
                            // roles: [UserType.care, UserType.dealer, UserType.consumer],
                            roleToUrlBase: {}
                        };
                        /* @ngInject */
                        this.$get = function ($injector) {
                            _this.$injector = $injector;
                            var storeService = $injector.get('ute.blocks.persistent.storage.service');
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]].persistentService = storeService.getSessionStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]].persistentService = storeService.getLocalStoreService();
                            _this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]].persistentService = storeService.getLocalStoreService();
                            return new UserService($injector, _this.config);
                        };
                        this.$get.$inject = [
                            '$injector'
                        ];
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.care]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.careRep]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.dealer]] = { baseUrl: UserProvider.publicUrlPrefix };
                        this.config.roleToUrlBase[user_1.UserType[user_1.UserType.consumer]] = { baseUrl: UserProvider.protectedUrlPrefix };
                    }
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    UserProvider.prototype.configure = function (config) {
                        this.config = _.merge(this.config, config);
                        return true;
                    };
                    UserProvider.protectedUrlPrefix = '/web/RogersServices.portal/totes/api/';
                    UserProvider.publicUrlPrefix = '/web/totes/api/';
                    UserProvider.$inject = [];
                    return UserProvider;
                }());
                angular.module('ute.common.user').provider('ute.common.user.service', UserProvider);
            })(service = user_1.service || (user_1.service = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var detail;
            (function (detail) {
                var service;
                (function (service) {
                    'use strict';
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var AccountDetail = (function () {
                        function AccountDetail() {
                        }
                        return AccountDetail;
                    }());
                    service.AccountDetail = AccountDetail;
                    /**
                     * worker return cached result and implement refresh true/false retry logic
                     */
                    var AccountDetailWorker = (function (_super) {
                        __extends(AccountDetailWorker, _super);
                        function AccountDetailWorker(config, securityService, $http, $q, $timeout, userService, $injector, request) {
                            var _this = this;
                            _super.call(this, new AccountDetail(), config, securityService, $http, $q, $timeout, userService, request); // TODO
                            this.$injector = $injector;
                            this.isAccountDetailCallInProgress = this.isCallInProgress;
                            this.getAccountDetail = this.getData;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            /**
                             * @override
                             * @param accountDetail
                             * @returns {IAccountDetail}
                             */
                            this.normalizeData = function (accountDetail) {
                                accountDetail.subList = accountDetail.subList.map(function (sub) {
                                    sub.isPrePaid = true;
                                    // sub.subNumber = Number(sub.subNumber);
                                    sub.subNumber = String(sub.subNumber);
                                    sub.subAccountId = Number(sub.subAccountId);
                                    if (sub.effectiveDate) {
                                        sub.effectiveDate = new Date(sub.effectiveDate.toString());
                                    }
                                    if (sub.subAddress) {
                                        // sub.subAddress.addressId = Number(sub.subAddress.addressId);
                                        sub.subAddress.streetNumber = Number(sub.subAddress.streetNumber);
                                    }
                                    return ute.rogers.account.overview.service.SubscriptionFactory(sub, _this.$injector, _this.config);
                                });
                                accountDetail.billableAccountNumber = Number(accountDetail.billableAccountNumber);
                                accountDetail.accountNumber = Number(accountDetail.accountNumber);
                                accountDetail.accountType = Number(accountDetail.accountType);
                                accountDetail.pinNumber = Number(accountDetail.pinNumber);
                                accountDetail.ctnNumber = Number(accountDetail.ctnNumber);
                                accountDetail.accountBalance.bonusBalanceAmount = Number(accountDetail.accountBalance.bonusBalanceAmount);
                                accountDetail.accountBalance.realBalanceAmount = Number(accountDetail.accountBalance.realBalanceAmount);
                                accountDetail.accountBalance.balanceAmount = Number(accountDetail.accountBalance.balanceAmount);
                                if (angular.isDefined(accountDetail.accountInfo.expiryDate)) {
                                    accountDetail.accountInfo.expiryDate = new Date(accountDetail.accountInfo.expiryDate.toString());
                                }
                                return accountDetail;
                            };
                        }
                        ;
                        return AccountDetailWorker;
                    }(CacheableDataGeneric));
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * only one worker exists for the same request
                     */
                    var AccountDetailFactory = (function () {
                        function AccountDetailFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this.$injector = $injector;
                            this._getWorker = function (request) {
                                return new AccountDetailWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return AccountDetailFactory;
                    }());
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * Provider only responsable for configuration and to return factory
                     */
                    var AccountDetailProvider = (function (_super) {
                        __extends(AccountDetailProvider, _super);
                        /* @ngInject */
                        function AccountDetailProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new AccountDetailFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                                return function (request) { return factory.getWorker(request); };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/accounts/detail',
                                    logPrefix: 'AccountDetail',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF
                                },
                                navigation: {
                                    wirelessPrepaidDashboard: {
                                        url: '/web/totes/#/wirelessPrepaid'
                                    }
                                }
                            };
                        }
                        ;
                        AccountDetailProvider.$inject = [];
                        return AccountDetailProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.account.detail.service').provider('ute.rogers.account.detail.factory', AccountDetailProvider);
                })(service = detail.service || (detail.service = {}));
            })(detail = account.detail || (account.detail = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account_1) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    //TODO rename this to the accountOverview.factory.ts
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var AccountOverview = (function () {
                        function AccountOverview($injector, userService) {
                            var _this = this;
                            this.$injector = $injector;
                            this.userService = userService;
                            /**
                             */
                            this.getAccountNumbers = function () { return _this.accountList.map(function (account) { return Number(account.accountNumber); }); };
                            /**
                             * get selected account or first from the list or null
                             */
                            this.getSelectedAccount = function () { return (_this.selectedAccount || _this.accountList[0] || null); };
                            /**
                             * @param account - number | IAccount
                             * @returns {IAccount} - selected account
                             */
                            this.selectAccount = function (account) {
                                var oldVal = _this.selectedAccount;
                                _this.selectedAccount = _this.getAccount(account) || _this.selectedAccount;
                                // if ($.isNumeric(account)) {
                                //   newVal = this.selectedAccount = _.find<IAccount>(this.accountList, (a: IAccount) => a.accountNumber === Number(account)) || this.selectedAccount;
                                // } else if (_.isObject(account) && _.has(account, 'accountNumber')) {
                                //   // it can be not real account objects
                                //   newVal = this.selectedAccount = _.find<IAccount>(this.accountList, (a: IAccount) => a.accountNumber === Number((<IAccount>account).accountNumber)) || this.selectedAccount;
                                // } else {
                                //   newVal = null;
                                // }
                                var ps = _this.userService.getPersistentService();
                                if (_this.selectedAccount && ((oldVal && _this.selectedAccount.accountNumber !== oldVal.accountNumber) || !oldVal)) {
                                    ps.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER, _this.selectedAccount.accountNumber);
                                    ps.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER, _this.selectedAccount.accountTypeNumber);
                                    _this.accountOverviewService.notifySubs();
                                }
                                return _this.selectedAccount;
                            };
                            /**
                             * Now this method is only removing from local without server call
                             * @param account
                             */
                            this.unlinkAccount = function (account) {
                                var toUnlink = _this.getAccount(account);
                                if (_.has(toUnlink, 'accountNumber')) {
                                    _this.accountList = _.filter(_this.accountList, function (a) { return a.accountNumber !== toUnlink.accountNumber; });
                                    if (_this.selectedAccount === toUnlink) {
                                        _this.selectAccount(_this.accountList[0]); // notify called
                                    }
                                    else {
                                        _this.accountOverviewService.notifySubs();
                                    }
                                }
                                return new _this.$q(function (resolve) { return resolve(_this); });
                            };
                            /**
                             * @override
                             * @returns {IAccountOverview}
                             */
                            this.normalizeData = function () {
                                _this.rawData.accountList = _this.accountList.map(function (account) {
                                    return _.merge({}, account);
                                });
                                _this.accountList = _this.accountList.map(function (account) {
                                    account.accountOverview = _this;
                                    account.accountNumber = Number(account.accountNumber);
                                    account.accountTypeNumber = Number(account.accountTypeNumber);
                                    account.subNumbers = account.subNumbers.map(function (n) {
                                        return Number(n);
                                    });
                                    return _.assign(new Account(_this.$injector), account);
                                });
                                return _this;
                            };
                            this.getConfig = function () { return _this.accountOverviewService.getConfig(); };
                            /**
                             * @returns {IAccount}
                             */
                            this.restoreSelectedAccount = function () {
                                return _this.selectAccount(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                            };
                            /**
                             * @param account
                             * @returns {IAccount|null}
                             */
                            this.getAccount = function (account) {
                                if ($.isNumeric(account)) {
                                    return _.find(_this.accountList, { accountNumber: Number(account) });
                                }
                                else if (_.isObject(account) && _.has(account, 'accountNumber')) {
                                    // it can be not real account objects
                                    return _.find(_this.accountList, { accountNumber: Number(account.accountNumber) });
                                }
                                return null;
                            };
                            this.getSelectedAccountDetails = function (callback) {
                                var account = _this.getSelectedAccount();
                                if (angular.isObject(account)) {
                                    var languageService = _this.$injector.get('ute.blocks.language.switcher');
                                    if (account.accountTypeNumber === 9) {
                                        // TODO Enum and Factory
                                        var accountDetailFactory = _this.$injector.get('ute.rogers.account.detail.factory');
                                        var accountDetailWorker = accountDetailFactory({
                                            accountNumber: account.accountNumber,
                                            accountTypeNumber: account.accountTypeNumber,
                                            language: languageService.getCurrentLanguage(),
                                            phoneNumber: account.phoneNumber,
                                            pinNumber: account.pinNumber
                                        });
                                        accountDetailWorker.registerOnDataChangeHandler(callback, AccountOverviewProvider.factoryName);
                                        return accountDetailWorker.getAccountDetail();
                                    }
                                    else {
                                        var accountOverviewSummaryFactory = _this.$injector.get('ute.rogers.account.overview.summary.factory');
                                        var accountOverviewSummaryWorker = accountOverviewSummaryFactory({
                                            accountNumber: account.accountNumber,
                                            accountTypeNumber: account.accountTypeNumber,
                                            language: languageService.getCurrentLanguage()
                                        });
                                        accountOverviewSummaryWorker.registerOnDataChangeHandler(callback, AccountOverviewProvider.factoryName);
                                        return accountOverviewSummaryWorker.getAccountOverviewSummary();
                                    }
                                }
                                else {
                                    // TODO
                                    return null;
                                }
                            };
                            this.cleanup = function () {
                                _this.selectedAccount = null;
                            };
                            this.storeService = $injector.get('ute.blocks.persistent.storage.service');
                            this.$q = $injector.get('$q');
                            userService.registerSigninHandler(this.cleanup, this);
                        }
                        return AccountOverview;
                    }());
                    var Account = (function () {
                        function Account($injector) {
                            var _this = this;
                            this.$injector = $injector;
                            this.getAccountOverviewSummary = function () {
                                return _this.$injector.get('ute.rogers.account.overview.summary.factory')({
                                    accountNumber: _this.accountNumber,
                                    accountTypeNumber: _this.accountTypeNumber,
                                    language: _this.$injector.get('ute.blocks.language.switcher').getCurrentLanguage()
                                }).getAccountOverviewSummary();
                            };
                            /**
                             * @returns {IPromise<any>}
                             */
                            this.goToAccountOverview = function () {
                                // TODO better
                                var oldAccountNumber = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                                var oldAccountTypeNumber = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER));
                                var isAccountChanged = oldAccountNumber !== _this.accountNumber || oldAccountTypeNumber !== _this.accountTypeNumber;
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                // console.log('rrrrrrrrrrrrrrrrrrrrrrrrrr', oldUrl, isAccountChanged, this.getConfig().navigation.accountOverview.url);
                                /*if (this.getConfig().navigation.accountOverview.state) { // TODO do we need this logic? or we can use url only?
                                 // MyRogers - totes
                                 let $state: IStateService = this.$injector.get('$state');
                                 let localState = this.getConfig().navigation.accountOverview.state;
                          
                                 if ($state.current.name !== localState || isAccountChanged) {
                                 // return $state.go(localState, {}, {reload: $state.current.name !== localState});
                                 return $state.go(localState);
                                 } else {
                                 return new this.$q((resolve: IQResolveReject<boolean>) => resolve(false));
                                 }
                                 } else */
                                if (oldUrl !== _this.getConfig().navigation.accountOverview.url || isAccountChanged) {
                                    _this.$window.location.href = _this.getConfig().navigation.accountOverview.url;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.accountOverview.url); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            this.selectAsDefault = function () { return _this.accountOverview.selectAccount(_this); };
                            this.isActive = function () {
                                // return _.toUpper(this.accountStatus) === AccountStatuses[AccountStatuses.ACTIVE];
                                return angular.isString(_this.accountStatus) && _this.accountStatus.toUpperCase() === service.AccountStatuses[service.AccountStatuses.ACTIVE];
                            };
                            this.isPayable = function () {
                                return angular.isString(_this.accountStatus) && !_.include([
                                    service.AccountStatuses.DEACTIVE,
                                    service.AccountStatuses.SUSPENDED,
                                    service.AccountStatuses.CANCELLED
                                ], service.AccountStatuses[_this.accountStatus.toUpperCase()]);
                            };
                            this.getConfig = function () { return _this.accountOverview.getConfig(); };
                            this.$window = this.$injector.get('$window');
                            this.$q = this.$injector.get('$q');
                            this.userService = this.$injector.get('ute.common.user.service');
                        }
                        return Account;
                    }());
                    var AccountOverviewService = (function (_super) {
                        __extends(AccountOverviewService, _super);
                        function AccountOverviewService(conf, $injector, securityService, $http, $q, $timeout, userService, request) {
                            var _this = this;
                            _super.call(this, new AccountOverview($injector, userService), conf, securityService, $http, $q, $timeout, userService, request);
                            this.conf = conf;
                            this.$injector = $injector;
                            this.isAccountOverviewCallInProgress = this.isCallInProgress;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            /**
                             * get account overview and optionally select default account (used in link account scenario)
                             * @param account
                             */
                            this.getAccountOverview = function (account) {
                                return _this.getData().then(function (accountOverview) {
                                    if (account) {
                                        accountOverview.selectAccount(account);
                                    }
                                    else if (angular.isObject(accountOverview)) {
                                        accountOverview.restoreSelectedAccount();
                                    }
                                    // return new this.$q((resolve: IQResolveReject<IAccountOverview>) => resolve(accountOverview));
                                    return accountOverview;
                                });
                            };
                            this.getAccountOverviewRawData = function () {
                                return _this.getData().then(function (accountOverview) {
                                    return accountOverview.rawData;
                                });
                            };
                            /**
                             * @param account
                             */
                            this.unlinkAccount = function (account) {
                                return _this.getData().then(function (accountOverview) {
                                    return accountOverview.unlinkAccount(account);
                                });
                            };
                            /**
                             * @override
                             * @param accountOverview
                             * @param rawData
                             * @returns {IAccountOverview}
                             */
                            this.normalizeData = function (accountOverview, rawData) {
                                accountOverview.rawData = rawData;
                                accountOverview.accountOverviewService = _this; // TODO to find better solution
                                return accountOverview.normalizeData();
                            };
                            /**
                             * @param accountNumber
                             * @param billType
                             * @param postalCode
                             * @returns {null}
                             */
                            this.linkAccount = function (accountNumber, billType, postalCode) {
                                // TODO little bit fake, move the real code here
                                // Now this call is called after successful legacy linkAccount call
                                return _this.resetAndRefreshAndNotify(accountNumber);
                            };
                            this.linkAccountPrepaid = function (phoneNumber, pinNumber) {
                                // TODO little bit fake, move the real code here
                                // Now this call is called after successful legacy linkAccount call
                                return _this.resetAndRefreshAndNotify();
                            };
                            /**
                             * @param accountNumber
                             * @param accountTypeNumber
                             * @param nickName
                             * @return {IPromise<IAccountOverview>}
                             */
                            this.updateNickName = function (accountNumber, accountTypeNumber, nickName) {
                                // TODO little bit fake, move the real code here
                                // Now this call is called after successful legacy updateNickName call
                                _this.resetData();
                                return _this.getAccountOverview(accountNumber);
                            };
                            /**
                             * @param account
                             */
                            this.selectAccount = function (account) {
                                return _this.getAccountOverview().then(function (accountOverview) { return accountOverview.selectAccount(account); });
                            };
                            this.selectSubscription = function (key, ctn) {
                                _this.userService.getPersistentService().put(key, ctn);
                                _this.notifySubs();
                            };
                            /**
                             * @param account
                             */
                            this.getAccount = function (account) {
                                return _this.getAccountOverview().then(function (accountOverview) { return accountOverview.getAccount(account); });
                            };
                            this.getSelectedAccount = function () {
                                return _this.getAccountOverview().then(function (accountOverview) { return accountOverview.getSelectedAccount(); });
                            };
                            this.getSelectedAccountDetails = function (callback) {
                                return _this.getAccountOverview().then(function (accountOverview) { return accountOverview.getSelectedAccountDetails(callback); });
                            };
                            this.getConfig = function () { return angular.copy(_this.conf); };
                            this.resetAndRefreshAndNotify = function (accountNumber) {
                                _this.resetData();
                                return _this.getAccountOverview(accountNumber).then(function (accountOverview) {
                                    _this.notifySubs();
                                    return accountOverview;
                                });
                            };
                        }
                        ;
                        return AccountOverviewService;
                    }(CacheableDataGeneric));
                    var AccountOverviewWorker = (function (_super) {
                        __extends(AccountOverviewWorker, _super);
                        function AccountOverviewWorker(conf, securityService, $http, $q, $timeout, userService, $injector, request) {
                            _super.call(this, conf, $injector, securityService, $http, $q, $timeout, userService, request);
                        }
                        ;
                        return AccountOverviewWorker;
                    }(AccountOverviewService));
                    /**
                     * only one worker exists for the same request
                     */
                    var AccountOverviewFactory = (function () {
                        function AccountOverviewFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this.$injector = $injector;
                            this._getWorker = function (request) {
                                return new AccountOverviewWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return AccountOverviewFactory;
                    }());
                    var AccountOverviewProvider = (function (_super) {
                        __extends(AccountOverviewProvider, _super);
                        /* @ngInject */
                        function AccountOverviewProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new AccountOverviewFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                                var userService = $injector.get('ute.common.user.service');
                                return function (request) {
                                    if (angular.isUndefined(request) && userService.isSigned() && userService.isCare()) {
                                        request = {
                                            acctNbr: Number(userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER))
                                        };
                                    }
                                    return factory.getWorker(request);
                                };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/accountoverview',
                                    logPrefix: 'AccountOverview',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF
                                },
                                navigation: {
                                    accountOverview: {
                                        url: '/web/totes/#/accountOverview'
                                    }
                                }
                            };
                        }
                        AccountOverviewProvider.$inject = [];
                        AccountOverviewProvider.factoryName = 'ute.rogers.account.overview.factory';
                        return AccountOverviewProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.account.overview.service').provider(AccountOverviewProvider.factoryName, AccountOverviewProvider);
                })(service = overview.service || (overview.service = {}));
            })(overview = account_1.overview || (account_1.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var AccountOverviewBalance = (function () {
                        function AccountOverviewBalance() {
                        }
                        return AccountOverviewBalance;
                    }());
                    /**
                     * worker return cached result and implement refresh true/false retry logic
                     */
                    var AccountOverviewBalanceWorker = (function (_super) {
                        __extends(AccountOverviewBalanceWorker, _super);
                        function AccountOverviewBalanceWorker(config, securityService, $http, $q, $timeout, userService, request) {
                            _super.call(this, new AccountOverviewBalance(), config, securityService, $http, $q, $timeout, userService, request);
                            this.isAccountOverviewBalanceCallInProgress = this.isCallInProgress;
                            this.getAccountOverviewBalance = this.getData;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            /**
                             * @override
                             * @param accountOverviewBalance
                             * @returns {IAccountOverviewBalance}
                             */
                            this.normalizeData = function (accountOverviewBalance) {
                                accountOverviewBalance.balanceAmount = Number(accountOverviewBalance.balanceAmount);
                                accountOverviewBalance.creditLimit = Number(accountOverviewBalance.creditLimit);
                                accountOverviewBalance.nextBillDate = new Date(accountOverviewBalance.nextBillDate.toString());
                                accountOverviewBalance.nextBillingDetail = new Date(accountOverviewBalance.nextBillingDetail.toString());
                                return accountOverviewBalance;
                            };
                        }
                        ;
                        return AccountOverviewBalanceWorker;
                    }(CacheableDataGeneric));
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * only one worker exists for the same request
                     */
                    var AccountOverviewBalanceFactory = (function () {
                        function AccountOverviewBalanceFactory(config, securityService, $http, $q, $timeout, userService) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this._getWorker = function (request) {
                                // console.log('AccountOverviewBalanceFactory->_getWorker: request=', request);
                                return new AccountOverviewBalanceWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return AccountOverviewBalanceFactory;
                    }());
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * Provider only responsable for configuration and to return factory
                     */
                    var AccountOverviewBalanceProvider = (function (_super) {
                        __extends(AccountOverviewBalanceProvider, _super);
                        /* @ngInject */
                        function AccountOverviewBalanceProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new AccountOverviewBalanceFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'));
                                return function (request) { return factory.getWorker(request); };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/accountoverview/balance',
                                    logPrefix: 'AccountOverviewBalance',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                    isCachableOnBackend: false
                                }
                            };
                        }
                        ;
                        AccountOverviewBalanceProvider.$inject = [];
                        return AccountOverviewBalanceProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.account.overview.service').provider('ute.rogers.account.overview.balance.factory', AccountOverviewBalanceProvider);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var billing;
                (function (billing) {
                    var detail;
                    (function (detail) {
                        'use strict';
                        var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                        var ProviderBase = ute.common.core.ProviderBase;
                        var BillingDetail = (function () {
                            function BillingDetail() {
                                var _this = this;
                                /**
                                 * Get number of days till next billing date
                                 * @return {number} or undefined
                                 */
                                this.getCycleEndInDays = function () {
                                    var nextBillDateTimestamp;
                                    var retval;
                                    if (_.isDate(_this.nextBillingDate) && !isNaN((nextBillDateTimestamp = _this.nextBillingDate.getTime()))) {
                                        retval = Math.floor((nextBillDateTimestamp - new Date().getTime()) / (24 * 60 * 60 * 1000));
                                        retval = retval >= 0 ? retval : undefined;
                                    }
                                    return retval;
                                };
                                this.getPaymentMethod = function () { return _this.methodOfPayment; };
                                this.getBalanceAmout = function () {
                                    if (angular.isDefined(_this.balanceAmount)) {
                                        return _this.balanceAmount;
                                    }
                                    else {
                                        return 0;
                                    }
                                };
                            }
                            return BillingDetail;
                        }());
                        /**
                         * worker return cached result and implement refresh true/false retry logic
                         */
                        var BillingDetailWorker = (function (_super) {
                            __extends(BillingDetailWorker, _super);
                            function BillingDetailWorker(config, securityService, $http, $q, $timeout, userService, request) {
                                var _this = this;
                                _super.call(this, new BillingDetail(), config, securityService, $http, $q, $timeout, userService, request);
                                this.isBillingDetailCallInProgress = this.isCallInProgress;
                                this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                                this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                                this.getBillingDetail = function (resetLocalCache) {
                                    if (resetLocalCache === true) {
                                        _this.resetData();
                                    }
                                    return _this.getData().then(function (o) {
                                        if (resetLocalCache) {
                                            _this.notifySubs();
                                        }
                                        return o;
                                    });
                                };
                                /**
                                 * @override
                                 * @param BillingDetail
                                 * @returns {IBillingDetail}
                                 */
                                this.normalizeData = function (BillingDetail) {
                                    if (BillingDetail.methodOfPayment) {
                                        if (BillingDetail.methodOfPayment.mopType) {
                                            BillingDetail.methodOfPayment.mopType = ute.rogers.account.overview.billing.detail.PaymentMethodType[BillingDetail.methodOfPayment.mopType.toString()]; // response is a string;
                                        }
                                        if (BillingDetail.methodOfPayment.creditCardDetails && BillingDetail.methodOfPayment.creditCardDetails.ccType) {
                                            BillingDetail.methodOfPayment.creditCardDetails.ccType = ute.rogers.account.overview.billing.detail.CreditCardType[BillingDetail.methodOfPayment.creditCardDetails.ccType.toString()]; // response is a string;
                                        }
                                    }
                                    if (BillingDetail.balanceAmount) {
                                        BillingDetail.balanceAmount = Number(BillingDetail.balanceAmount);
                                    }
                                    if (BillingDetail.creditLimit) {
                                        BillingDetail.creditLimit = Number(BillingDetail.creditLimit);
                                    }
                                    if (BillingDetail.creditBalance) {
                                        BillingDetail.creditBalance = Number(BillingDetail.creditBalance);
                                    }
                                    return BillingDetail;
                                };
                            }
                            ;
                            return BillingDetailWorker;
                        }(CacheableDataGeneric));
                        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                        /**
                         * only one worker exists for the same request
                         */
                        var BillingDetailFactory = (function () {
                            function BillingDetailFactory(config, securityService, $http, $q, $timeout, userService) {
                                var _this = this;
                                this.config = config;
                                this.securityService = securityService;
                                this.$http = $http;
                                this.$q = $q;
                                this.$timeout = $timeout;
                                this.userService = userService;
                                this._getWorker = function (request) {
                                    return new BillingDetailWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, request);
                                };
                                this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                            }
                            ;
                            return BillingDetailFactory;
                        }());
                        //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                        /**
                         * Provider only responsible for configuration and to return factory
                         */
                        var BillingDetailProvider = (function (_super) {
                            __extends(BillingDetailProvider, _super);
                            /* @ngInject */
                            function BillingDetailProvider() {
                                var _this = this;
                                _super.call(this);
                                /* @ngInject */
                                this.$get = function ($injector, $http, $q, $timeout) {
                                    var factory = new BillingDetailFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'));
                                    return function (request) {
                                        request.language = 'en';
                                        return factory.getWorker(request);
                                    };
                                };
                                this.$get.$inject = [
                                    '$injector',
                                    '$http',
                                    '$q',
                                    '$timeout'
                                ];
                                this.config = detail.DefaultConfigFactory();
                            }
                            ;
                            BillingDetailProvider.$inject = [];
                            return BillingDetailProvider;
                        }(ProviderBase));
                        angular.module('ute.rogers.account.overview.service').provider('ute.rogers.account.billing.detail.factory', BillingDetailProvider);
                    })(detail = billing.detail || (billing.detail = {}));
                })(billing = overview.billing || (overview.billing = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var billing;
                (function (billing) {
                    var detail;
                    (function (detail) {
                        'use strict';
                        function DefaultConfigFactory() {
                            return {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/accountoverview/billingDetails',
                                    logPrefix: 'accountBillingDetails',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                    isCachableOnBackend: true
                                }
                            };
                        }
                        detail.DefaultConfigFactory = DefaultConfigFactory;
                    })(detail = billing.detail || (billing.detail = {}));
                })(billing = overview.billing || (overview.billing = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var AccountOverviewSegmentation = (function () {
                        function AccountOverviewSegmentation() {
                        }
                        return AccountOverviewSegmentation;
                    }());
                    service.AccountOverviewSegmentation = AccountOverviewSegmentation;
                    /**
                     * worker return cached result and implement refresh true/false retry logic
                     */
                    var AccountOverviewSegmentationWorker = (function (_super) {
                        __extends(AccountOverviewSegmentationWorker, _super);
                        function AccountOverviewSegmentationWorker(config, securityService, $http, $q, $timeout, userService, $injector, request) {
                            _super.call(this, new AccountOverviewSegmentation(), config, securityService, $http, $q, $timeout, userService, request); // TODO
                            this.$injector = $injector;
                            this.isAccountOverviewSegmentationCallInProgress = this.isCallInProgress;
                            this.getAccountOverviewSegmentation = this.getData;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            /**
                             * @override
                             * @param accountOverviewSummary
                             * @returns {IAccountOverviewSummary}
                             */
                            this.normalizeData = function (accountOverviewSegmentation) {
                                return accountOverviewSegmentation;
                            };
                        }
                        ;
                        return AccountOverviewSegmentationWorker;
                    }(CacheableDataGeneric));
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * only one worker exists for the same request
                     */
                    var AccountOverviewSegmentationFactory = (function () {
                        function AccountOverviewSegmentationFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this.$injector = $injector;
                            this._getWorker = function (request) {
                                // console.log('IAccountOverviewSegmentationFactory->_getWorker: request=', request);
                                return new AccountOverviewSegmentationWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return AccountOverviewSegmentationFactory;
                    }());
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * Provider only responsable for configuration and to return factory
                     */
                    var AccountOverviewSegmentationProvider = (function (_super) {
                        __extends(AccountOverviewSegmentationProvider, _super);
                        /* @ngInject */
                        function AccountOverviewSegmentationProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new AccountOverviewSegmentationFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                                return function (request) { return factory.getWorker(request); };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: '/v1/accountoverview/getSegmentationForRGCL',
                                    logPrefix: 'AccountOverviewSegmentation',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                    isCachableOnBackend: false
                                }
                            };
                        }
                        ;
                        AccountOverviewSegmentationProvider.$inject = [];
                        return AccountOverviewSegmentationProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.account.overview.service').provider('ute.rogers.account.overview.segmentation.factory', AccountOverviewSegmentationProvider);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var AccountOverviewSummary = (function () {
                        function AccountOverviewSummary() {
                        }
                        return AccountOverviewSummary;
                    }());
                    service.AccountOverviewSummary = AccountOverviewSummary;
                    /**
                     * worker return cached result and implement refresh true/false retry logic
                     */
                    var AccountOverviewSummaryWorker = (function (_super) {
                        __extends(AccountOverviewSummaryWorker, _super);
                        function AccountOverviewSummaryWorker(config, securityService, $http, $q, $timeout, userService, $injector, request) {
                            var _this = this;
                            _super.call(this, new AccountOverviewSummary(), config, securityService, $http, $q, $timeout, userService, request); // TODO
                            this.$injector = $injector;
                            this.isAccountOverviewSummaryCallInProgress = this.isCallInProgress;
                            this.getAccountOverviewSummary = this.getData;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            this.getAccountOverviewSummaryRawData = function () {
                                return _this.getData().then(function (accountOverviewSummary) {
                                    return accountOverviewSummary.rawData;
                                });
                            };
                            this.getWirelessSummary = function () {
                                return _this.getData().then(function (accountOverviewSummary) {
                                    // return accountOverviewSummary.rawData;
                                    return _.map(accountOverviewSummary.rawData.subList, function (sub) {
                                        return { ban: sub.subAccountId, ctn: sub.subNumber, firstname: sub.firstname };
                                    });
                                });
                            };
                            /* Added to get CTNs only for wireless */
                            this.getWirelessCTNSummary = function () {
                                return _this.getData().then(function (accountOverviewSummary) {
                                    return _.map(accountOverviewSummary.rawData.subList, function (sub) {
                                        if (sub.subType === 'CTN' && sub.subStatus !== 'Suspended') {
                                            return { ctn: sub.subNumber };
                                        }
                                    });
                                });
                            };
                            this.updateCtnName = function (request) {
                                var $http = _this.$injector.get('$http');
                                var securityService = _this.$injector.get('ute.common.security.service');
                                return $http.post(securityService.getBackendUrl(_this.config.advanced.partialChangeCTNApiUrl), request)
                                    .success(function () {
                                    _this.resetData();
                                    return _this.getData().then(function (accountOverviewSummary) {
                                        _this.notifySubs();
                                        return accountOverviewSummary;
                                    });
                                });
                            };
                            this.resetAndGetFreshSummaryRawData = function () {
                                _this.resetData();
                                return _this.getData().then(function (accountOverviewSummary) {
                                    _this.notifySubs();
                                    return accountOverviewSummary.rawData;
                                });
                            };
                            /**
                             * @override
                             * @param accountOverviewSummary
                             * @param rawData
                             * @returns {IAccountOverviewSummary}
                             */
                            this.normalizeData = function (accountOverviewSummary, rawData) {
                                accountOverviewSummary.rawData = rawData;
                                accountOverviewSummary.rawData.subList = accountOverviewSummary.rawData.subList.map(function (sub) {
                                    return _.merge({}, sub);
                                });
                                accountOverviewSummary.rawData.contactInfo = _.merge({}, rawData.contactInfo);
                                accountOverviewSummary.rawData.billingAddress = _.merge({}, rawData.billingAddress);
                                accountOverviewSummary.subList = accountOverviewSummary.subList.map(function (sub) {
                                    sub.subAccountId = Number(sub.subAccountId);
                                    sub.effectiveDate = new Date(sub.effectiveDate.toString());
                                    // sub.subAddress.addressId = Number(sub.subAddress.addressId);
                                    sub.subAddress.streetNumber = Number(sub.subAddress.streetNumber);
                                    return service.SubscriptionFactory(sub, _this.$injector, _this.config);
                                });
                                accountOverviewSummary.billableAccountNumber = Number(accountOverviewSummary.billableAccountNumber);
                                accountOverviewSummary.accountNumber = Number(accountOverviewSummary.accountNumber);
                                accountOverviewSummary.accountType = Number(accountOverviewSummary.accountType);
                                accountOverviewSummary.contactInfo.businessPhone = Number(accountOverviewSummary.contactInfo.businessPhone);
                                accountOverviewSummary.contactInfo.homePhone = Number(accountOverviewSummary.contactInfo.homePhone);
                                accountOverviewSummary.contactInfo.extension = Number(accountOverviewSummary.contactInfo.extension);
                                // accountOverviewSummary.contactInfo.contactId = Number(accountOverviewSummary.contactInfo.contactId);
                                // accountOverviewSummary.contactInfo.ecId = Number(accountOverviewSummary.contactInfo.ecId);
                                // accountOverviewSummary.billingAddress.addressId = Number(accountOverviewSummary.billingAddress.addressId);
                                accountOverviewSummary.billingAddress.streetNumber = Number(accountOverviewSummary.billingAddress.streetNumber);
                                return accountOverviewSummary;
                            };
                        }
                        ;
                        return AccountOverviewSummaryWorker;
                    }(CacheableDataGeneric));
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * only one worker exists for the same request
                     */
                    var AccountOverviewSummaryFactory = (function () {
                        function AccountOverviewSummaryFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this.$injector = $injector;
                            this._getWorker = function (request) {
                                return new AccountOverviewSummaryWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return AccountOverviewSummaryFactory;
                    }());
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * Provider only responsable for configuration and to return factory
                     */
                    var AccountOverviewSummaryProvider = (function (_super) {
                        __extends(AccountOverviewSummaryProvider, _super);
                        /* @ngInject */
                        function AccountOverviewSummaryProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new AccountOverviewSummaryFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                                return function (request) { return factory.getWorker(request); };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/accountoverview/summary',
                                    logPrefix: 'AccountOverviewSummary',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF
                                },
                                advanced: {
                                    partialChangeCTNApiUrl: 'v2/wirelessService/changeSubscriberName'
                                },
                                navigation: {
                                    wirelessDashboard: {
                                        url: '/web/totes/#/wireless'
                                    },
                                    wirelessPrepaidDashboard: {
                                        url: '/web/totes/#/wirelessPrepaid'
                                    },
                                    shareEverythingDashboard: {
                                        url: '/web/totes/#/shareEverything'
                                    },
                                    internetDashboard: {
                                        url: '/web/totes/#/internetdash'
                                    },
                                    tvDashboard: {
                                        url: '/web/totes/#/tvdashboard'
                                    },
                                    homePhoneDashboard: {
                                        url: '/web/totes/#/rhpdashboard',
                                        legacyUrl: '/web/RogersServices.portal?_nfpb=true&_pageLabel=HomePhone_Service'
                                    },
                                    iptvDashboard: {
                                        url: '/web/consumer/#/iptvDashboard' // TODO replace me
                                    },
                                    shmDashboard: {
                                        url: '/web/totes/#/shmdashboard'
                                    }
                                }
                            };
                        }
                        ;
                        AccountOverviewSummaryProvider.$inject = [];
                        return AccountOverviewSummaryProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.account.overview.service').provider('ute.rogers.account.overview.summary.factory', AccountOverviewSummaryProvider);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    // export enum AccountType {
                    //   WIRELESS = 1,
                    //   INTERNET = 6,
                    //   PAY_AS_YOU_GO = 9,
                    //   PIA = 11,
                    //   MAESTRO = 30,
                    //   BUSINESS_WIRELESS = 21,
                    //   BUSINESS_CABLE = 22,
                    //   BUSINESS_MAESTRO = 23,
                    //   CREDIT_CARD = 25
                    // }
                    /**
                     * Main factory interface
                     */
                    function SubscriptionFactory(prototype, $injector, config) {
                        var eclipseRemoteApi = $injector.get('ute.rogers.eclipse.remote.api.service');
                        switch (prototype.subType) {
                            case 'CTN':
                                if (prototype.isPrePaid) {
                                    return new PrePaidWirelessSubscription(prototype, $injector, config);
                                }
                                return new WirelessSubscription(prototype, $injector, config);
                            case 'Hi-Speed Internet':
                                return new InternetSubscription(prototype, $injector, config);
                            case 'Digital TV':
                                return new TvSubscription(prototype, $injector, config);
                            case 'RHPc':
                                return new HomePhoneSubscription(prototype, $injector, config);
                            case 'Rogers Smart Home Monitoring':
                                return new ShmSubscription(prototype, $injector, config);
                            case 'HSI':
                                if (eclipseRemoteApi.isEclipseInternetSubscription(prototype)) {
                                    return new HsiInternetSubscription(prototype, $injector, config);
                                }
                                break;
                            case 'IPTV':
                                if (eclipseRemoteApi.isEclipseTvSubscription(prototype)) {
                                    return new IpTvSubscription(prototype, $injector, config);
                                }
                                break;
                            case 'RHP Phone Line':
                                if (eclipseRemoteApi.isEclipseHomePhoneSubscription(prototype)) {
                                    return new RHPPhoneLineSubscription(prototype, $injector, config);
                                }
                                break;
                            default:
                                return prototype;
                        }
                    }
                    service.SubscriptionFactory = SubscriptionFactory;
                    var Subscription = (function () {
                        function Subscription(prototype, $injector, config) {
                            var _this = this;
                            this.$injector = $injector;
                            this.config = config;
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                            this.isSelected = function () { return false; };
                            this.getConfig = function () { return _this.config; };
                            _.assign(this, prototype);
                            this.$state = this.$injector.get('$state');
                            this.$window = this.$injector.get('$window');
                            this.$q = this.$injector.get('$q');
                            this.phoneFilter = this.$injector.get('$filter')('ute_common_filter_phone');
                            this.stringLimitFilter = this.$injector.get('$filter')('ute_common_filter_string_limit_to');
                            this.userService = this.$injector.get('ute.common.user.service');
                            this.eclipseRemoteApi = this.$injector.get('ute.rogers.eclipse.remote.api.service');
                            this.languageSwitcher = this.$injector.get('ute.blocks.language.switcher');
                            this.provinceService = this.$injector.get('ute.blocks.province.service');
                        }
                        return Subscription;
                    }());
                    var WirelessSubscription = (function (_super) {
                        __extends(WirelessSubscription, _super);
                        function WirelessSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var newUrl = angular.isObject(_this.shareEverything) ? _this.getConfig().navigation.shareEverythingDashboard.url : _this.getConfig().navigation.wirelessDashboard.url;
                                var isServiceChanged = String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)) !== String(_this.subNumber);
                                // const isServiceChanged = Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)) !== this.subNumber;
                                // console.log('qqqqqqqqqqqqqqqqqqqqqqqqqq', oldUrl, this.getConfig().navigation.wirelessDashboard.url,
                                //     Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)), this.subNumber);
                                if (oldUrl === newUrl && isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, _this.subNumber);
                                    return _this.$state.go(_this.$state.current.name, {}, { reload: true });
                                }
                                else if (oldUrl !== newUrl || isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, _this.subNumber);
                                    _this.$window.location.href = newUrl;
                                    return new _this.$q(function (resolve) { return resolve(newUrl); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            this.getServiceDropdownName = function () {
                                if (angular.isObject(_this.shareEverything)) {
                                    return _this.isInfinitePlan() ? {
                                        translateId: 'ute.common.second.level.navigation.infiniteTitle'
                                    } : {
                                        translateId: 'ute.common.second.level.navigation.shareEverything'
                                    };
                                }
                                else {
                                    return {
                                        translateId: 'ute.common.second.level.navigation.wireless.phone',
                                        translateValues: {
                                            name: _this.stringLimitFilter(_this.firstname, 12),
                                            phoneNumber: _this.phoneFilter(_this.subNumber, '$1 $2-$3')
                                        }
                                    };
                                }
                            };
                            this.getStateName = function () { return ['shareEverything.dashboard', 'shareEverything.noEncryption', 'shareEverything', 'wireless']; };
                            this.isSelected = function () {
                                var fromStorage = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER);
                                return angular.isDefined(fromStorage) && angular.isDefined(_this.subNumber) && fromStorage !== null && _this.subNumber !== null &&
                                    String(fromStorage) === String(_this.subNumber);
                            };
                        }
                        WirelessSubscription.prototype.isInfinitePlan = function () {
                            return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                        };
                        return WirelessSubscription;
                    }(Subscription));
                    var PrePaidWirelessSubscription = (function (_super) {
                        __extends(PrePaidWirelessSubscription, _super);
                        function PrePaidWirelessSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var isServiceChanged = String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)) !== _this.subNumber;
                                // const isServiceChanged = Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)) !== this.subNumber;
                                // console.log('qqqqqqqqqqqqqqqqqqqqqqqqqq', oldUrl, this.getConfig().navigation.wirelessPrepaidDashboard.url,
                                //     Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)), this.subNumber);
                                if (oldUrl === _this.getConfig().navigation.wirelessPrepaidDashboard.url && isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, _this.subNumber);
                                    return _this.$state.go(_this.$state.current.name, {}, { reload: true });
                                }
                                else if (oldUrl !== _this.getConfig().navigation.wirelessPrepaidDashboard.url || isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, _this.subNumber);
                                    _this.$window.location.href = _this.getConfig().navigation.wirelessPrepaidDashboard.url;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.wirelessPrepaidDashboard.url); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            /**
                             * @override
                             * @returns {ITranslate}
                             */
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.wireless.phone.prepaid',
                                    translateValues: {
                                        // name: this.stringLimitFilter(this.firstname, 12),
                                        phoneNumber: _this.phoneFilter(_this.subNumber, '$1 $2-$3')
                                    }
                                };
                            };
                            this.getStateName = function () { return 'wirelessPrepaid'; };
                        }
                        return PrePaidWirelessSubscription;
                    }(Subscription));
                    var InternetSubscription = (function (_super) {
                        __extends(InternetSubscription, _super);
                        function InternetSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                // console.log('ffffffffffffffffffffff', this.getConfig().navigation.internetDashboard.url, this.$window.location.pathname + this.$window.location.hash);
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var isServiceChanged = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER)) !== _this.subAccountId;
                                if (oldUrl !== _this.getConfig().navigation.internetDashboard.url || isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER, _this.subAccountId);
                                    _this.$window.location.href = _this.getConfig().navigation.internetDashboard.url;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.internetDashboard.url); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                                // const localState = 'internetdash';
                                //
                                // if (this.$state.current.name !== localState || Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER)) !== this.subAccountId) {
                                //   this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_INTERNET_ACCOUNT_NUMBER, this.subAccountId);
                                //   return this.$state.go(localState, {}, {reload: true});
                                // } else {
                                //   return null;
                                // }
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            // getServiceDropdownName: () => string = () => 'Internet'; // TODO translate
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: _this.subscriptionSubType === 'G' ?
                                        'ute.common.second.level.navigation.gateway' :
                                        'ute.common.second.level.navigation.internet'
                                };
                            };
                            this.getStateName = function () { return 'internetdash'; };
                        }
                        return InternetSubscription;
                    }(Subscription));
                    var TvSubscription = (function (_super) {
                        __extends(TvSubscription, _super);
                        function TvSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var isServiceChanged = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER)) !== _this.subAccountId;
                                // console.log('qqqqqqqqqqqqqqqqqqqqqqqqqq', oldUrl, this.getConfig().navigation.tvDashboard.url,
                                //     Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER)), this.subAccountId);
                                if (oldUrl !== _this.getConfig().navigation.tvDashboard.url || isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER, _this.subAccountId);
                                    _this.$window.location.href = _this.getConfig().navigation.tvDashboard.url;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.tvDashboard.url); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                                // const localState = 'tvdashboard';
                                //
                                // if (this.$state.current.name !== localState || Number(this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER)) !== this.subAccountId) {
                                //   this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_TV_ACCOUNT_NUMBER, this.subAccountId);
                                //   return this.$state.go(localState, {}, {reload: true});
                                // } else {
                                //   return null;
                                // }
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            // getServiceDropdownName: () => ITranslate = () => 'TV'; // TODO translate
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.tv',
                                };
                            };
                            this.getStateName = function () { return 'tvdashboard'; };
                        }
                        return TvSubscription;
                    }(Subscription));
                    var HomePhoneSubscription = (function (_super) {
                        __extends(HomePhoneSubscription, _super);
                        function HomePhoneSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var isServiceChanged = String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER)) !== _this.subNumber;
                                var rhpMigratedSwitch = String(_this.userService.getPersistentService().get('rhpMigratedSwitch'));
                                if (rhpMigratedSwitch === 'true') {
                                    if (oldUrl === _this.getConfig().navigation.homePhoneDashboard.url && isServiceChanged) {
                                        _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER, _this.subNumber);
                                        _this.userService.getPersistentService().put('homePhoneAccountNumber', _this.subAccountId);
                                        return _this.$state.go(_this.$state.current.name, {}, { reload: true });
                                    }
                                    else {
                                        _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER, _this.subNumber);
                                        _this.userService.getPersistentService().put('homePhoneAccountNumber', _this.subAccountId);
                                        _this.$window.location.href = _this.getConfig().navigation.homePhoneDashboard.url;
                                        return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.homePhoneDashboard.url); });
                                    }
                                }
                                else {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_HOME_PHONE_NUMBER, _this.subNumber);
                                    _this.$window.location.href = _this.getConfig().navigation.homePhoneDashboard.legacyUrl;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.homePhoneDashboard.legacyUrl); });
                                }
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            // getServiceDropdownName: () => string = () => 'Home Phone ' + this.phoneFilter(this.subNumber, '$1 $2-$3'); // TODO translate
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.home.phone',
                                    translateValues: {
                                        phoneNumber: _this.phoneFilter(_this.subNumber, '$1 $2-$3')
                                    }
                                };
                            };
                            this.getStateName = function () { return 'rhpdashboard'; };
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                        }
                        return HomePhoneSubscription;
                    }(Subscription));
                    var IpTvSubscription = (function (_super) {
                        __extends(IpTvSubscription, _super);
                        function IpTvSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var accountNumber;
                                accountNumber = Number(String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)));
                                return _this.eclipseRemoteApi.goToIPTVDashboard({
                                    accountNumber: accountNumber,
                                    subAccountId: String(_this.subAccountId),
                                    subscriptionId: _this.subNumber,
                                    source: 'rogers.com'
                                }, {
                                    lang: _this.languageSwitcher.getCurrentLanguage(),
                                    userType: _this.userService.getUserType(),
                                    province: _this.provinceService.getCurrentProvince()
                                });
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            // getServiceDropdownName: () => string = () => 'Fake IP TV Eclipse'; // TODO translate
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: _this.subscriptionSubType === 'T' ? 'ute.common.second.level.navigation.smartstream' : 'ute.common.second.level.navigation.iptv'
                                };
                            };
                            //change to tv
                            this.getStateName = function () { return 'iptvdash'; };
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                        }
                        return IpTvSubscription;
                    }(Subscription));
                    var HsiInternetSubscription = (function (_super) {
                        __extends(HsiInternetSubscription, _super);
                        function HsiInternetSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var accountNumber;
                                accountNumber = Number(String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)));
                                return _this.eclipseRemoteApi.goToHSIDashboard({
                                    accountNumber: accountNumber,
                                    subAccountId: String(_this.subAccountId),
                                    subscriptionId: _this.subNumber,
                                    source: 'rogers.com'
                                }, {
                                    lang: _this.languageSwitcher.getCurrentLanguage(),
                                    userType: _this.userService.getUserType(),
                                    province: _this.provinceService.getCurrentProvince()
                                });
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.hsiinternet'
                                };
                            };
                            this.getStateName = function () { return 'hsidash'; };
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                        }
                        return HsiInternetSubscription;
                    }(Subscription));
                    var RHPPhoneLineSubscription = (function (_super) {
                        __extends(RHPPhoneLineSubscription, _super);
                        function RHPPhoneLineSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var accountNumber;
                                accountNumber = Number(String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)));
                                return _this.eclipseRemoteApi.goToRHPDashboard({
                                    accountNumber: accountNumber,
                                    subAccountId: String(_this.subAccountId),
                                    subscriptionId: _this.subNumber,
                                    source: 'rogers.com'
                                }, {
                                    lang: _this.languageSwitcher.getCurrentLanguage(),
                                    userType: _this.userService.getUserType(),
                                    province: _this.provinceService.getCurrentProvince()
                                });
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.home.phone'
                                };
                            };
                            this.getStateName = function () { return 'rhpdash'; };
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                        }
                        return RHPPhoneLineSubscription;
                    }(Subscription));
                    var ShmSubscription = (function (_super) {
                        __extends(ShmSubscription, _super);
                        function ShmSubscription() {
                            var _this = this;
                            _super.apply(this, arguments);
                            /**
                             * @override
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToDashboard = function () {
                                var oldUrl = _this.$window.location.pathname + _this.$window.location.hash;
                                var isServiceChanged = String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER)) !== String(_this.subNumber);
                                if (oldUrl !== _this.getConfig().navigation.shmDashboard.url || isServiceChanged) {
                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_SHM_ACCOUNT_NUMBER, _this.subNumber);
                                    _this.$window.location.href = _this.getConfig().navigation.shmDashboard.url;
                                    return new _this.$q(function (resolve) { return resolve(_this.getConfig().navigation.shmDashboard.url); });
                                }
                                else {
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            /**
                             * @override
                             * @returns {string}
                             */
                            this.getServiceDropdownName = function () {
                                return {
                                    translateId: 'ute.common.second.level.navigation.home.monitoring'
                                };
                            };
                            this.getStateName = function () { return 'shmdashboard'; };
                            this.getId = function () { return _this.getStateName() + '_' + _this.subNumber; };
                        }
                        return ShmSubscription;
                    }(Subscription));
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var overview;
            (function (overview) {
                var service;
                (function (service) {
                    'use strict';
                    var AccountSelectionService = (function () {
                        function AccountSelectionService() {
                            var _this = this;
                            this.accountPicked = false;
                            this.isAccountPicked = function () { return _this.accountPicked; };
                            this.setAccountPicked = function (val) {
                                _this.accountPicked = val;
                            };
                        }
                        AccountSelectionService.$inject = [];
                        return AccountSelectionService;
                    }());
                    angular.module('ute.rogers.account.overview.service').service('ute.rogers.account.selection.service', AccountSelectionService);
                })(service = overview.service || (overview.service = {}));
            })(overview = account.overview || (account.overview = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account.selection || (account.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account.selection || (account.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account_1) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                    var AccountSelectionModalController = (function () {
                        /* @ngInject */
                        function AccountSelectionModalController($modalInstance, accountList, goToUrl, $window) {
                            var _this = this;
                            this.$modalInstance = $modalInstance;
                            this.accountList = accountList;
                            this.goToUrl = goToUrl;
                            this.$window = $window;
                            this.selectAccount = function (account) {
                                console.log('selectAccount.account:', account);
                                account.selectAsDefault();
                                _this.$window.location.href = _this.goToUrl;
                                // account.goToAccountOverview();
                                _this.$modalInstance.close('selected');
                            };
                            this.backToDevicePage = function () {
                                _this.$modalInstance.dismiss('cancel');
                            };
                        }
                        AccountSelectionModalController.prototype.cancel = function () {
                            console.log('ute.rogers.account.selection.overlay.modal.controller: accountList', this.accountList);
                            this.$window.location.href = this.goToUrl;
                            this.$modalInstance.dismiss('cancel');
                        };
                        AccountSelectionModalController.$inject = [
                            '$modalInstance',
                            'accountList',
                            'goToUrl',
                            '$window'
                        ];
                        AccountSelectionModalController.controllerName = 'ute.rogers.account.selection.overlay.modal.controller';
                        return AccountSelectionModalController;
                    }());
                    overlay.AccountSelectionModalController = AccountSelectionModalController;
                    angular.module('ute.rogers.account.selection.overlay').controller(AccountSelectionModalController.controllerName, AccountSelectionModalController);
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account_1.selection || (account_1.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                    function DefaultConfigFactory() {
                        return {
                            basic: {
                                applicationId: 'ute-application-id',
                                logLevel: ute.common.typescript.api.log.LogLevel.OFF
                            }
                        };
                    }
                    overlay.DefaultConfigFactory = DefaultConfigFactory;
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account.selection || (account.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var account;
        (function (account_1) {
            var selection;
            (function (selection) {
                var overlay;
                (function (overlay) {
                    'use strict';
                    var AccountSelectionServiceProvider = (function () {
                        /* @ngInject */
                        function AccountSelectionServiceProvider() {
                            var _this = this;
                            this.config = overlay.DefaultConfigFactory();
                            /* @ngInject */
                            this.$get = function ($injector, $modal, $document, $q, $window) {
                                _this.$modal = $modal;
                                _this.$document = $document;
                                _this.$injector = $injector;
                                _this.$q = $q;
                                _this.$window = $window;
                                _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                                _this.accountOverviewService = _this.accountOverviewFactory();
                                return {
                                    showAccountSelectionOverlay: _this.showAccountSelectionOverlay
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                return true;
                            };
                            this.resetModel = function () {
                                _this.model = {
                                    accountList: null
                                };
                            };
                            /**
                             * @returns ng.IPromise<string>
                             */
                            this.getAccountList = function () {
                                return new _this.$q(function (resolve) { return resolve(_this.model.accountList); });
                            };
                            /**
                             * @returns {INavigationModel}
                             */
                            this.showAccountSelectionOverlay = function (goToUrl) {
                                _this.accountOverviewService.getAccountOverview()
                                    .then(function (account) {
                                    if (account.accountList && account.accountList.length > 1) {
                                        _this.model.accountList = account.accountList;
                                        _this.openModalPopup(goToUrl);
                                    }
                                    else {
                                        _this.$window.location.href = goToUrl;
                                    }
                                });
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$modal',
                                '$document',
                                '$q',
                                '$window'
                            ];
                            this.resetModel();
                        }
                        ;
                        AccountSelectionServiceProvider.prototype.openModalPopup = function (goToUrl) {
                            var _this = this;
                            this.$modal.open({
                                templateUrl: 'module/accountSeletionModal/accountSeletion.modal.view.html',
                                controller: overlay.AccountSelectionModalController.controllerName,
                                controllerAs: 'accountSelectionModal',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {
                                    'accountList': this.getAccountList(),
                                    'goToUrl': this.$q.when(goToUrl)
                                }
                            }).result.then(function (result) {
                                // $modal.close() will get into here.
                                _this.$window.location.href = goToUrl;
                            }, function (result) {
                                // dismissed here.
                                _this.$window.location.href = goToUrl;
                            });
                        };
                        AccountSelectionServiceProvider.$inject = [];
                        return AccountSelectionServiceProvider;
                    }());
                    angular.module('ute.rogers.account.selection.overlay').provider('ute.rogers.account.selection.overlay.service', AccountSelectionServiceProvider);
                })(overlay = selection.overlay || (selection.overlay = {}));
            })(selection = account_1.selection || (account_1.selection = {}));
        })(account = rogers.account || (rogers.account = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            angular.module('ute.actions.offers').run(actionsOffersConfig);
            actionsOffersConfig.$inject = ['ute.blocks.router', 'ute.actions.offers.service'];
            function actionsOffersConfig(routerHelper, actionsOffersService) {
                routerHelper.configureStates(getStates(actionsOffersService));
            }
            function getStates(actionsOffers) {
                return [{
                        name: actionsOffers.getConfig().inbounds.stateName,
                        parent: actionsOffers.getConfig().inbounds.parentState,
                        views: {
                            bounds: {
                                templateUrl: actionsOffers.getConfig().inbounds.templateUrl
                            }
                        },
                        data: {
                            title: '',
                            security: { roles: [] }
                        }
                    }, {
                        name: actionsOffers.getConfig().outbounds.stateName,
                        parent: actionsOffers.getConfig().outbounds.parentState,
                        views: {
                            bounds: {
                                templateUrl: actionsOffers.getConfig().outbounds.templateUrl
                            }
                        },
                        data: {
                            title: '',
                            security: { roles: [] }
                        }
                    }];
            }
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffersMainController = (function () {
                /* @ngInject */
                function ActionsOffersMainController(actionsOffersService) {
                    this.actionsOffersService = actionsOffersService;
                }
                ActionsOffersMainController.controllerName = 'ute.actions.offers.main.controller';
                ActionsOffersMainController.$inject = ['ute.actions.offers.service'];
                return ActionsOffersMainController;
            }());
            offers.ActionsOffersMainController = ActionsOffersMainController;
            angular.module('ute.actions.offers').controller('ute.actions.offers.main.controller', ActionsOffersMainController);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
                var AntiSpamLegislationController = (function () {
                    /* @ngInject */
                    function AntiSpamLegislationController(antiSpamLegislationService) {
                        this.antiSpamLegislationService = antiSpamLegislationService;
                        this.loadingState = false;
                        this.updateCEMPreferenceError = false;
                        this.isUpdatedSelection = false;
                        this.getCEMPreferenceError = false;
                        this.basePreferencesDataModel = {};
                        this.electronicAddressesAndCEMPreferencesList = this.reInitializeModel();
                        this.brtSwitchConfig = {
                            CASL_HIDE_CEM_PREFERENCES: undefined,
                            CASL_CEM_LIMITED: undefined,
                            CASL_CEM_ALL: undefined
                        };
                        this.selectedBrand = this.antiSpamLegislationService.getConfig().basic.brand.toLowerCase();
                        this.imgPath = this.antiSpamLegislationService.getConfig().imagesRootDir;
                        this.loadingImgPath = this.antiSpamLegislationService.getConfig().loadingImagePath;
                    }
                    // Get all electronic addresses and CEM Preferences.
                    AntiSpamLegislationController.prototype.getElectronicAddressesPreferences = function () {
                        var self = this;
                        this.electronicAddressesAndCEMPreferencesList = this.reInitializeModel();
                        self.getCEMPreferenceError = false;
                        //show loading before calling.
                        self.loadingState = true;
                        self.antiSpamLegislationService
                            .getXSessionToken()
                            .then(function (xSessionToken) {
                            self
                                .antiSpamLegislationService
                                .getElectronicAddresses(xSessionToken)
                                .then(function (resp) {
                                if (resp.content) {
                                    self.filterElectronicAddressesByType(resp.content);
                                    //hide loading on error.
                                    self.loadingState = false;
                                }
                            }, function (error) {
                                //hide loading on error.
                                self.loadingState = false;
                                self.getCEMPreferenceError = true;
                            });
                        })
                            .catch(function (error) {
                            //hide loading on error.
                            self.loadingState = false;
                            self.getCEMPreferenceError = true;
                        });
                    };
                    // Update CEM Preferences.
                    AntiSpamLegislationController.prototype.updateCEMPreferences = function (Payload, prefType, toggleShouldBeOff, currentIndex, indexForSection, event) {
                        var _this = this;
                        var self = this;
                        var isSaveButtonEvent = false;
                        var isSelectedPreferenceExists = false;
                        var brandListObj = Payload.cemPreferencesList.BrandList[0];
                        var Brands = {
                            BrandRefID: '',
                            OptOutAll: 'false',
                            PrefList: []
                        };
                        var requestPayload = {
                            ElectronicAddress: {
                                guid: Payload.guid
                            },
                            BrandList: []
                        };
                        //Hide error message below toggle.
                        self.showUpdatePrefErrorOnToggling(currentIndex, false);
                        // Set Brand's reference ID and OptOutAll value.
                        Brands.BrandRefID = brandListObj.Brand.RefID;
                        // config payload if user make toggle button off send api call for update preferences.
                        // Set OptOutAll flag value true and make all checkbox options uncheck.
                        // Remove preferences list if OptOutAll value would be true.
                        Brands.OptOutAll = !!toggleShouldBeOff === true ? 'true' : 'false';
                        if (!toggleShouldBeOff && event === 'button') {
                            isSaveButtonEvent = true;
                            // Show loader for update preferences.
                            self.startUpdatePreferencesLoader(currentIndex, false, true);
                            self.showUpdatePrefErrorOnToggling(indexForSection, false);
                            isSelectedPreferenceExists = self.checkSelectedBrandsPrefNothingSelectedMakeOptOutALlTrueAndHideSection(brandListObj);
                        }
                        //If save button clicked, compare base data copy with updated copy and prepare payload with only updated values
                        if (isSaveButtonEvent === true) {
                            if (isSelectedPreferenceExists === true) {
                                self.prepareRequestPayloadWithUpdatedPrefs(Payload, Brands.PrefList);
                            }
                            else {
                                Brands.OptOutAll = 'true';
                            }
                        }
                        else {
                            // Populate selected preferences data and set payload.
                            brandListObj.Brand.ChannelList.forEach(function (channelListItem) {
                                channelListItem.Channel.PreferenceList.forEach(function (prefItem) {
                                    var preferenceVal = null;
                                    preferenceVal = toggleShouldBeOff === false ? 'true' : 'false';
                                    //Set preference objects into preferences list.
                                    Brands.PrefList.push({
                                        ChannelRefID: channelListItem.Channel.RefID,
                                        ClassRefID: prefItem.Preference.Class.RefID,
                                        SubclassRefID: prefItem.Preference.Subclass.RefID,
                                        PreferenceValue: preferenceVal
                                    });
                                });
                            });
                        }
                        requestPayload.BrandList.push(Brands);
                        self
                            .antiSpamLegislationService
                            .getXSessionToken()
                            .then(function (xSessionToken) {
                            self
                                .antiSpamLegislationService
                                .updateCEMPreferences(xSessionToken, requestPayload)
                                .then(function (resp) {
                                if (resp) {
                                    if (resp.result === 'success') {
                                        // If event is button and atleast one checkbox must be selected
                                        if (isSaveButtonEvent === true && isSelectedPreferenceExists === false) {
                                            //If response success hide preferences section.
                                            _this.hidePrefSectionOnUpdatePrefResponse(indexForSection, Payload, resp, false);
                                        }
                                        if (toggleShouldBeOff === true) {
                                            //Hide loader on success response
                                            self.startUpdatePreferencesLoader(currentIndex, true, false);
                                            // If response success hide preferences section.
                                            _this.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, resp, false);
                                            // self.showHideErrorForupdatePreferencesOnToggling(currentIndex);
                                            //Make all checkbox options uncheck method.
                                            self.checkboxesCheckUncheckForSelectedPreferences(Payload, false, false);
                                        }
                                        else {
                                            if (event === 'button') {
                                                //Hide loader for update preferences.
                                                self.startUpdatePreferencesLoader(currentIndex, false, false);
                                                self.isUpdatedSelection = true;
                                            }
                                            else {
                                                // Hide loader for update preferences.
                                                self.startUpdatePreferencesLoader(currentIndex, true, false);
                                                //Make all checkbox options uncheck method.
                                                self.checkboxesCheckUncheckForSelectedPreferences(Payload, true, true);
                                                _this.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, resp, true);
                                            }
                                        }
                                        //Set base data copy to current data state for future comparisons
                                        self.basePreferencesDataModel = angular.copy(self.electronicAddressesAndCEMPreferencesList);
                                    }
                                }
                            }, function (error) {
                                if (event !== 'button') {
                                    self.showUpdatePrefErrorOnToggling(currentIndex, true);
                                    self.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, error, true);
                                    // Hide loader for update preferences.
                                    self.startUpdatePreferencesLoader(currentIndex, true, false);
                                }
                                else {
                                    self.updateCEMPreferenceError = true;
                                }
                                if (toggleShouldBeOff === true) {
                                    // If response success hide preferences section.
                                    self.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, error, false);
                                }
                                // Hide loader for update preferences.
                                self.startUpdatePreferencesLoader(currentIndex, false, false);
                            });
                        }).catch(function (error) {
                            if (event !== 'button') {
                                self.showUpdatePrefErrorOnToggling(currentIndex, true);
                                self.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, error, true);
                                // Hide loader for update preferences.
                                self.startUpdatePreferencesLoader(currentIndex, true, false);
                            }
                            else {
                                self.updateCEMPreferenceError = true;
                            }
                            if (toggleShouldBeOff === true) {
                                // If response success hide preferences section.
                                _this.hidePrefSectionOnUpdatePrefResponse(currentIndex, Payload, error, false);
                            }
                            // Hide loader for update preferences.
                            self.startUpdatePreferencesLoader(currentIndex, false, false);
                        });
                    };
                    AntiSpamLegislationController.prototype.prepareRequestPayloadWithUpdatedPrefs = function (selectedEAddress, setPrefArray) {
                        var self = this;
                        var brandListObj = selectedEAddress.cemPreferencesList.BrandList[0];
                        var channel = selectedEAddress.type === 'Mobile' ? self.basePreferencesDataModel.sms : self.basePreferencesDataModel.email;
                        channel.electronicAddresses.forEach(function (EAddresse) {
                            //Match GUID selected brands to copied response.
                            if (EAddresse.guid === selectedEAddress.guid) {
                                EAddresse.cemPreferencesList.BrandList.forEach(function (brands) {
                                    brands.Brand.ChannelList.forEach(function (channel) {
                                        channel.Channel.PreferenceList.forEach(function (prefItem) {
                                            //Populate selected object properties for update.
                                            brandListObj.Brand.ChannelList.forEach(function (channelListItem) {
                                                channelListItem.Channel.PreferenceList.forEach(function (selectedPrefItem) {
                                                    if (brandListObj.Brand.RefID === brands.Brand.RefID
                                                        && channelListItem.Channel.RefID === channel.Channel.RefID
                                                        && selectedPrefItem.Preference.Class.RefID === prefItem.Preference.Class.RefID
                                                        && selectedPrefItem.Preference.Subclass.RefID === prefItem.Preference.Subclass.RefID
                                                        && selectedPrefItem.Preference.PreferenceValue !== prefItem.Preference.PreferenceValue) {
                                                        setPrefArray.push({
                                                            ChannelRefID: channelListItem.Channel.RefID,
                                                            ClassRefID: selectedPrefItem.Preference.Class.RefID,
                                                            SubclassRefID: selectedPrefItem.Preference.Subclass.RefID,
                                                            PreferenceValue: selectedPrefItem.Preference.PreferenceValue.toString()
                                                        });
                                                    }
                                                });
                                            });
                                        });
                                    });
                                });
                            }
                        });
                    };
                    // Make all options unchecked OR increase counter on checkbox check for selected preferences object.
                    AntiSpamLegislationController.prototype.checkboxesCheckUncheckForSelectedPreferences = function (selectedBrands, checkboxChecked, setAllPrefChecked) {
                        var self = this;
                        // Check electronic address type is mobile
                        if (selectedBrands.type === 'Mobile') {
                            // Loop over electronic address list find selected preferences by guid.
                            self.electronicAddressesAndCEMPreferencesList.sms.electronicAddresses.forEach(function (EAddressesAndCEMPreferencesList) {
                                //Match selected preferences GUID from  electronic address list object.
                                if (selectedBrands && selectedBrands.guid === EAddressesAndCEMPreferencesList.guid) {
                                    //Set selected checkboxes counter zero.
                                    EAddressesAndCEMPreferencesList.selectedCheckbox = 0;
                                    //If user checked checkbox value increment counter.
                                    if (checkboxChecked) {
                                        self.isUpdatedSelection = false;
                                        self.updateCEMPreferenceError = false;
                                        // This will run when toggling would be ON and make all preferences selected and update counter.
                                        if (checkboxChecked && setAllPrefChecked === true) {
                                            selectedBrands.cemPreferencesList.BrandList.forEach(function (brandList) {
                                                brandList.Brand.ChannelList.forEach(function (channelList) {
                                                    var brandReference = brandList.Brand.RefID.toLowerCase();
                                                    //show specific brands Rogers or Fido.
                                                    if (brandReference === self.selectedBrand) {
                                                        channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                            prefList.Preference.PreferenceValue = true;
                                                            EAddressesAndCEMPreferencesList.selectedCheckbox++;
                                                        });
                                                    }
                                                });
                                            });
                                        }
                                        else {
                                            //If user click on the checkbox update the counter for selected pereferences.
                                            selectedBrands.cemPreferencesList.BrandList.forEach(function (brandList) {
                                                brandList.Brand.ChannelList.forEach(function (channelList) {
                                                    var brandReference = brandList.Brand.RefID.toLowerCase();
                                                    //show specific brands Rogers or Fido.
                                                    if (brandReference === self.selectedBrand) {
                                                        channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                            if (prefList.Preference.PreferenceValue === true) {
                                                                EAddressesAndCEMPreferencesList.selectedCheckbox++;
                                                            }
                                                        });
                                                    }
                                                });
                                            });
                                        }
                                    }
                                    else {
                                        //If user click on toggle button make all checkboxes uncheck.
                                        //Loop over selected preferences brand list and set all checkboxes value false.
                                        selectedBrands.cemPreferencesList.BrandList.forEach(function (BrandListItem) {
                                            BrandListItem.Brand.ChannelList.forEach(function (channelListItem) {
                                                channelListItem.Channel.PreferenceList.forEach(function (prefItem) {
                                                    prefItem.Preference.PreferenceValue = false;
                                                });
                                            });
                                        });
                                    }
                                }
                            });
                        }
                        else {
                            // If electronic address type is Email.
                            // Loop over electronic address list find selected preferences by guid.
                            self.electronicAddressesAndCEMPreferencesList.email.electronicAddresses.forEach(function (EAddressesAndCEMPreferencesList) {
                                //Match selected preferences GUID from  electronic address list object.
                                if (selectedBrands.guid === EAddressesAndCEMPreferencesList.guid) {
                                    //Set selected checkboxes counter zero.
                                    EAddressesAndCEMPreferencesList.selectedCheckbox = 0;
                                    //If user checked checkbox value increment counter.
                                    if (checkboxChecked) {
                                        self.isUpdatedSelection = false;
                                        self.updateCEMPreferenceError = false;
                                        // This will run when toggling would be ON and make all preferences selected and update counter.
                                        if (checkboxChecked && setAllPrefChecked === true) {
                                            selectedBrands.cemPreferencesList.BrandList.forEach(function (brandList) {
                                                brandList.Brand.ChannelList.forEach(function (channelList) {
                                                    var brandReference = brandList.Brand.RefID.toLowerCase();
                                                    //show specific brands Rogers or Fido.
                                                    if (brandReference === self.selectedBrand) {
                                                        channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                            prefList.Preference.PreferenceValue = true;
                                                            EAddressesAndCEMPreferencesList.selectedCheckbox++;
                                                        });
                                                    }
                                                });
                                            });
                                        }
                                        else {
                                            //This will run when user selected checkbox only and update counter.
                                            selectedBrands.cemPreferencesList.BrandList.forEach(function (brandList) {
                                                brandList.Brand.ChannelList.forEach(function (channelList) {
                                                    var brandReference = brandList.Brand.RefID.toLowerCase();
                                                    //show specific brands Rogers or Fido.
                                                    if (brandReference === self.selectedBrand) {
                                                        channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                            if (prefList.Preference.PreferenceValue === true) {
                                                                EAddressesAndCEMPreferencesList.selectedCheckbox++;
                                                            }
                                                        });
                                                    }
                                                });
                                            });
                                        }
                                    }
                                    else {
                                        //Set selected checkboxes counter zero.
                                        //Loop over selected preferences brand list and set all checkboxes value false.
                                        selectedBrands.cemPreferencesList.BrandList.forEach(function (BrandListItem) {
                                            BrandListItem.Brand.ChannelList.forEach(function (channelListItem) {
                                                channelListItem.Channel.PreferenceList.forEach(function (prefItem) {
                                                    prefItem.Preference.PreferenceValue = false;
                                                });
                                            });
                                        });
                                    }
                                }
                            });
                        }
                    };
                    // Filter electronic addresses and CEM preferences by type from response..
                    AntiSpamLegislationController.prototype.filterElectronicAddressesByType = function (data) {
                        var self = this;
                        for (var i = 0; i < data.ElectronicAddressList.length; i++) {
                            //Filter mobile type electronic addresses and preferences..
                            if (data.ElectronicAddressList[i].type === 'Mobile') {
                                var preferencesList = data.ElectronicAddressList[i];
                                var isPreferencesExists = this.prepareEAPreferencesAndToggleForUI(data, preferencesList, i);
                                // If preferences exists.
                                if (isPreferencesExists > 0) {
                                    self.electronicAddressesAndCEMPreferencesList.sms.electronicAddresses.push(preferencesList);
                                }
                                else {
                                    self.electronicAddressesAndCEMPreferencesList.sms.electronicAddresses.push(data.ElectronicAddressList[i]);
                                }
                            }
                            else {
                                var preferencesList = data.ElectronicAddressList[i];
                                var isPreferencesExists = this.prepareEAPreferencesAndToggleForUI(data, preferencesList, i);
                                // If preferences exists.
                                if (isPreferencesExists > 0) {
                                    self.electronicAddressesAndCEMPreferencesList.email.electronicAddresses.push(preferencesList);
                                }
                                else {
                                    self.electronicAddressesAndCEMPreferencesList.email.electronicAddresses.push(data.ElectronicAddressList[i]);
                                }
                            }
                        }
                        self.basePreferencesDataModel = angular.copy(self.electronicAddressesAndCEMPreferencesList);
                    };
                    // Hide preferences list click by toggle button.
                    AntiSpamLegislationController.prototype.makeToggleOffandHidePreferences = function (itemIndex, value, data, serveType) {
                        var self = this;
                        self.updateCEMPreferenceError = false;
                        //If toggle is on, check if limited mode, then send API call else just show the manage messages link
                        if (value) {
                            // Show loader for update preferences.
                            self.startUpdatePreferencesLoader(itemIndex, true, true);
                            //Start update preferences when user toggles on in limited mode
                            self.updateCEMPreferences(data, serveType, false, itemIndex);
                        }
                        else {
                            //Show loader for update preferences.
                            self.startUpdatePreferencesLoader(itemIndex, true, true);
                            //Update Preferences method when user make toggle OFF.
                            self.updateCEMPreferences(data, serveType, true, itemIndex);
                        }
                    };
                    // Hide preferences section on toggling OFF success response.
                    AntiSpamLegislationController.prototype.hidePrefSectionOnUpdatePrefResponse = function (itemIndex, data, resp, showLink) {
                        var self = this;
                        var channel = data.type === 'Mobile' ? self.electronicAddressesAndCEMPreferencesList.sms : self.electronicAddressesAndCEMPreferencesList.email;
                        channel.electronicAddresses.forEach(function (EAddresse) {
                            if (EAddresse.guid === data.guid) {
                                //this will run when make toggle OFF to ON on success manage preferences link will be display.
                                if (showLink) {
                                    if (resp.result && resp.result === 'success') {
                                        data.showManagePrefLink = true;
                                        data.optOutToggleOn = true;
                                    }
                                    else {
                                        data.showManagePrefLink = false;
                                        data.optOutToggleOn = false;
                                    }
                                }
                                else {
                                    //this will run when make toggle OFF and Click on save button and hiding section and manage preferences link
                                    if (resp.result && resp.result === 'success') {
                                        data.optOutToggleOn = false;
                                        data.showManagePrefLink = false;
                                        $('.list-group.sms-marketing-pref-list')
                                            .find('.list-group-item.sms-market-pref-list-item .panel-collapse')
                                            .filter(function (index, elem) {
                                            return $(this).attr('id') === itemIndex;
                                        }).addClass('collapse').attr('aria-hidden', 'true');
                                    }
                                    else {
                                        data.optOutToggleOn = true;
                                        data.showManagePrefLink = true;
                                    }
                                }
                            }
                        });
                    };
                    AntiSpamLegislationController.prototype.toggleAccordion = function (accordionIdentifier) {
                        this.updateCEMPreferenceError = false;
                        var currentElement = $('a[data-accordion-id=' + accordionIdentifier + ']');
                        var targetAccordion = $('#' + accordionIdentifier);
                        if (currentElement.hasClass('collapsed')) {
                            $('.panel-collapse').addClass('collapse').attr('aria-hidden', 'true');
                            $('a[data-accordion-id]').addClass('collapsed');
                            targetAccordion.removeClass('collapse').attr('aria-hidden', 'false');
                            currentElement.removeClass('collapsed');
                            this.isUpdatedSelection = false;
                            return;
                        }
                        targetAccordion.addClass('collapse').attr('aria-hidden', 'true');
                        currentElement.addClass('collapsed');
                    };
                    AntiSpamLegislationController.prototype.reInitializeModel = function () {
                        return {
                            sms: {
                                electronicAddresses: []
                            },
                            email: {
                                electronicAddresses: []
                            }
                        };
                    };
                    // Display error below to toggle on clicking toggle ON OFF.
                    AntiSpamLegislationController.prototype.showUpdatePrefErrorOnToggling = function (itemIndex, showError) {
                        if (showError) {
                            $('.list-group.sms-marketing-pref-list')
                                .find('.list-group-item.sms-market-pref-list-item .preference-not-found.pref-update-error-toggle')
                                .filter(function (index, elem) {
                                return $(this).attr('data-loader') === itemIndex;
                            }).removeClass('hide-updateLoader');
                        }
                        else {
                            $('.list-group.sms-marketing-pref-list')
                                .find('.list-group-item.sms-market-pref-list-item .preference-not-found.pref-update-error-toggle')
                                .filter(function (index, elem) {
                                return $(this).attr('data-loader') === itemIndex;
                            }).addClass('hide-updateLoader');
                        }
                    };
                    AntiSpamLegislationController.prototype.startUpdatePreferencesLoader = function (itemIndex, toggling, start) {
                        $('.lockWrapper').removeClass('hide-updateLoader');
                        if (toggling === true) {
                            if (start) {
                                $('.list-group.sms-marketing-pref-list')
                                    .find('.list-group-item.sms-market-pref-list-item .toggle-btn-loader')
                                    .filter(function (index, elem) {
                                    return $(this).attr('data-loader') === itemIndex;
                                }).removeClass('hide-updateLoader');
                            }
                            else {
                                $('.list-group.sms-marketing-pref-list')
                                    .find('.list-group-item.sms-market-pref-list-item .toggle-btn-loader')
                                    .filter(function (index, elem) {
                                    return $(this).attr('data-loader') === itemIndex;
                                }).addClass('hide-updateLoader');
                                $('.lockWrapper').addClass('hide-updateLoader');
                            }
                        }
                        else {
                            if (start) {
                                $('.list-group.sms-marketing-pref-list')
                                    .find('.list-group-item.sms-market-pref-list-item .save-btn-loader')
                                    .filter(function (index, elem) {
                                    return $(this).attr('data-loader') === itemIndex;
                                }).removeClass('hide-updateLoader');
                            }
                            else {
                                $('.list-group.sms-marketing-pref-list')
                                    .find('.list-group-item.sms-market-pref-list-item .save-btn-loader')
                                    .filter(function (index, elem) {
                                    return $(this).attr('data-loader') === itemIndex;
                                }).addClass('hide-updateLoader');
                                $('.lockWrapper').addClass('hide-updateLoader');
                            }
                        }
                    };
                    AntiSpamLegislationController.prototype.prepareEAPreferencesAndToggleForUI = function (data, preferencesList, currentIndex) {
                        var self = this;
                        var OptOutAll;
                        var isPreferencesExists = 0;
                        var selectedCheckbox = 0;
                        data.CEMPreferenceList.forEach(function (CEMPreferenceListItem) {
                            if (CEMPreferenceListItem && CEMPreferenceListItem.guid === data.ElectronicAddressList[currentIndex].guid) {
                                CEMPreferenceListItem.BrandList.forEach(function (brandList) {
                                    brandList.Brand.ChannelList.forEach(function (channelList) {
                                        var brandReference = brandList.Brand.RefID.toLowerCase();
                                        //show specific brands Rogers or Fido.
                                        if (brandReference === self.selectedBrand) {
                                            OptOutAll = brandList.Brand.OptOutAll;
                                            if (OptOutAll && OptOutAll === 'true') {
                                                preferencesList.optOutToggleOn = false;
                                                preferencesList.showManagePrefLink = false;
                                                channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                    isPreferencesExists++;
                                                    prefList.Preference.PreferenceValue = false;
                                                });
                                            }
                                            else {
                                                preferencesList.optOutToggleOn = true;
                                                preferencesList.showManagePrefLink = true;
                                                channelList.Channel.PreferenceList.forEach(function (prefList) {
                                                    isPreferencesExists++;
                                                    //conversion to handle string values from backend
                                                    prefList.Preference.PreferenceValue =
                                                        prefList.Preference.PreferenceValue === 'true' ? true : false;
                                                    if (prefList.Preference.PreferenceValue === true) {
                                                        selectedCheckbox++;
                                                    }
                                                });
                                            }
                                        }
                                    });
                                });
                                //Count selected checkbox option and preferences exists.
                                preferencesList.selectedCheckbox = selectedCheckbox;
                                preferencesList.isPreferencesExists = isPreferencesExists;
                                //if OptOutAll is NOT true, and NO checkbox is selected then turn the toggle off
                                preferencesList.optOutToggleOn = preferencesList.optOutToggleOn === true && selectedCheckbox === 0 ? false : preferencesList.optOutToggleOn;
                                preferencesList.showManagePrefLink = preferencesList.showManagePrefLink === true && selectedCheckbox === 0 ? false : preferencesList.showManagePrefLink;
                                preferencesList.cemPreferencesList = CEMPreferenceListItem;
                            }
                        });
                        return isPreferencesExists;
                    };
                    // check if no preferences selected uncheck all with
                    AntiSpamLegislationController.prototype.checkSelectedBrandsPrefNothingSelectedMakeOptOutALlTrueAndHideSection = function (brandListObj) {
                        var isSelectedPref = false;
                        // Populate selected preferences data and set payload.
                        brandListObj.Brand.ChannelList.forEach(function (channelListItem) {
                            channelListItem.Channel.PreferenceList.forEach(function (prefItem) {
                                if (prefItem.Preference.PreferenceValue === true) {
                                    isSelectedPref = true;
                                }
                            });
                        });
                        return isSelectedPref;
                    };
                    AntiSpamLegislationController.controllerName = 'ute.anti.spam.legislation.controller';
                    AntiSpamLegislationController.$inject = ['ute.anti.spam.legislation.service'];
                    return AntiSpamLegislationController;
                }());
                legislation.AntiSpamLegislationController = AntiSpamLegislationController;
                angular
                    .module('ute.anti.spam.legislation')
                    .controller('ute.anti.spam.legislation.controller', AntiSpamLegislationController);
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
                angular
                    .module('ute.anti.spam.legislation')
                    .directive('uteAntiSpamLegislationDirective', antiSpamLegislationDirective);
                antiSpamLegislationDirective.$inject = ['ute.anti.spam.legislation.service'];
                /* @ngInject */
                function antiSpamLegislationDirective(antiSpamLegislationService) {
                    return {
                        restrict: 'EA',
                        scope: { accountNumber: '=' },
                        templateUrl: antiSpamLegislationService.getConfig().advanced.root.templateUrl,
                        controller: antiSpamLegislationService.getConfig().advanced.root.controllerName,
                        controllerAs: 'vm'
                    };
                }
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var anti;
    (function (anti) {
        var spam;
        (function (spam) {
            var legislation;
            (function (legislation) {
                'use strict';
                var AntiSpamLegislationProvider = (function () {
                    /* @ngInject */
                    function AntiSpamLegislationProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'Rogers.com',
                                brand: 'ROGERS',
                                identifierType: 'AccountNumber'
                            },
                            advanced: {
                                root: {
                                    controllerName: 'ute.anti.spam.legislation.integration.controller',
                                    templateUrl: 'module/antiSpamLegislation/antiSpamLegislation.view.html'
                                },
                            },
                            imagesRootDir: 'images',
                            loadingImagePath: 'ute-common-assets/assets/widget-loader.gif',
                            baseApi: {
                                getPreferences: '/resource/electronicAddressesPreferences.json',
                                updatePreferences: 'http://demo9915949.mockable.io/casl/v1/CEMPreferences'
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q) {
                            _this.$injector = $injector;
                            _this.http = $http;
                            _this.q = $q;
                            return {
                                http: _this.http,
                                q: _this.q,
                                getConfig: _this.getConfig,
                                resetModel: _this.resetModel,
                                accountNumber: _this.accountNumber,
                                getElectronicAddresses: _this.getElectronicAddresses,
                                updateCEMPreferences: _this.updateCEMPreferences,
                                getXSessionToken: _this.getXSessionToken
                            };
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getXSessionToken = function () {
                            console.log('CASL-overrideable-getXSessionToken');
                            return new _this.q(function (resolve) { return resolve(''); });
                        };
                        this.resetModel = function () {
                            _this.model = {
                                moduleName: 'antiSpamLegislation'
                            };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$q'
                        ];
                        this.resetModel();
                    }
                    // Fetch all electronic Addresses and CEM preferences list.
                    AntiSpamLegislationProvider.prototype.getElectronicAddresses = function (xSessionToken) {
                        var deferred = this.q.defer();
                        var accountNumber = String(this.accountNumber);
                        var config = {
                            headers: {
                                'x-app-id': this.getConfig().basic.applicationId,
                                'x-session-token': xSessionToken,
                                'brand': this.getConfig().basic.brand,
                                'identifierType': this.getConfig().basic.identifierType
                            }
                        };
                        this.http
                            .get(this.getConfig().baseApi.getPreferences + accountNumber, config)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        })
                            .error(function (error) {
                            deferred.reject('error' + error);
                        });
                        return deferred.promise;
                    };
                    // Update CEM preferences method.
                    AntiSpamLegislationProvider.prototype.updateCEMPreferences = function (xSessionToken, payload) {
                        var deferred = this.q.defer();
                        var config = {
                            headers: {
                                'x-app-id': this.getConfig().basic.applicationId,
                                'x-session-token': xSessionToken,
                                'brand': this.getConfig().basic.brand
                            }
                        };
                        //Send api call for update CEMPreferences.
                        this.http
                            .post(this.getConfig().baseApi.updatePreferences, payload, config)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        })
                            .error(function (error) {
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    ;
                    AntiSpamLegislationProvider.$inject = [];
                    return AntiSpamLegislationProvider;
                }());
                legislation.AntiSpamLegislationProvider = AntiSpamLegislationProvider;
                angular
                    .module('ute.anti.spam.legislation')
                    .provider('ute.anti.spam.legislation.service', AntiSpamLegislationProvider);
            })(legislation = spam.legislation || (spam.legislation = {}));
        })(spam = anti.spam || (anti.spam = {}));
    })(anti = ute.anti || (ute.anti = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var BFAPPCProvider = (function () {
                /* @ngInject */
                function BFAPPCProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            applicationId: 'ute-application-id',
                            dtmBuyFlowError: 'fdm-bf-error',
                            fetchOrderAPI: 'v1/cart/fetch',
                            checkEligibilityAPI: 'v1/ppc/priceplans/eligibility',
                            checkBOTEligibilityAPI: 'getCases',
                            setStateAPI: 'v1/spa/state',
                            subscribersAPI: 'v1/ppc/subscribers',
                        },
                        advanced: {
                            root: {
                                controllerName: 'ute.bfa.ppc.controller',
                                templateUrl: 'module/bfaPpc/bfaPpc.view.html'
                            },
                            modals: {
                                notEligible: {
                                    controllerName: 'notEligibleModalCtrl',
                                    templateUrl: 'views/modals/ppc-not-eligible.html',
                                },
                                mppcEntry3: {
                                    templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html',
                                    controllerName: 'mppcEntry3Ctrl'
                                },
                                mppcEntry1: {
                                    templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html',
                                    controllerName: 'mppcEntry1Ctrl'
                                },
                                mppcAddAdditionalData: {
                                    templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcAddAditionalDataModal.html',
                                    controllerName: 'mppcAddAdditionalDataModalCtrl'
                                },
                                mppcSharedGroupIndividual: {
                                    templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html',
                                    controllerName: 'mppcSharedGroupIndividualModalCtrl',
                                },
                                mppcSharedGroupPrimary: {
                                    templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html',
                                    controllerName: 'mppcSharedGroupPrimaryModalCtrl',
                                },
                            }
                        } //<--injectHere
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $q, $state, $translate, $http, $modal) {
                        _this.$injector = $injector;
                        _this.$q = $q;
                        _this.$state = $state;
                        _this.$translate = $translate;
                        _this.$http = $http;
                        _this.$modal = $modal;
                        _this.dtmService = $injector.get('ute.dtm.service');
                        _this.brtSwitchService = $injector.get('ute.common.core.brtswitch.service');
                        _this.userService = $injector.get('ute.common.user.service');
                        _this.securityService = $injector.get('ute.common.security.service');
                        _this.permissionsService = $injector.get('ute.common.permissions.service');
                        _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                        _this.accountOverviewSummaryFactory = $injector.get('ute.rogers.account.overview.summary.factory');
                        _this.pricePlanErrorsService = $injector.get('ute.bfa.ppc.errors.service');
                        var ban = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                        var param = { acctNbr: ban };
                        _this.accountOverviewFactory(param).getAccountOverview().then(function (accountOverview) {
                            var account = accountOverview.getSelectedAccount();
                            var summaryRequest = {
                                accountNumber: account.accountNumber,
                                accountTypeNumber: account.accountTypeNumber,
                                language: _this.$translate.use()
                            };
                            _this.accountOverviewSummaryWorker = _this.accountOverviewSummaryFactory(summaryRequest);
                            // this.accountOverviewSummaryWorker.registerOnDataChangeHandler(updateModel, 'bfaPPCService'); //TODO: summary changes, reinitialize any dependencies that relies on it
                        });
                        return {
                            getConfig: _this.getConfig,
                            resetModel: _this.resetModel,
                            isFetchOrderCompleted: _this.isFetchOrderCompleted,
                            hasOrder: _this.hasOrder,
                            fetchOrder: _this.fetchOrder,
                            gotoBFAPPC: _this.gotoBFAPPC,
                            clean: _this.clean,
                            changeBtnLoading: _this.changeBtnLoading,
                            getFetchOrderFullResponse: _this.getFetchOrderFullResponse,
                            getSubscribers: _this.getSubscribers,
                            openSomethingWentWrongPopup: _this.openSomethingWentWrongPopup,
                            isDealerCodeExist: _this.isDealerCodeExist,
                            setDealerCodeExist: _this.setDealerCodeExist
                        };
                    };
                    /**
                     * @returns {any}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.resetModel = function () {
                        _this.model = {
                            moduleName: 'bfaPpc',
                            fetchOrderCompleted: false,
                            bfappcOrders: [],
                            permission: {
                                ppc: null,
                                mppc: null
                            },
                            subscribers: null,
                            selectedAdditionalSubscribers: [],
                            changeBtnLoadingStatus: null,
                            appStateForPPC: null,
                            brtSwitch: null,
                            fetchOrderFullResponse: null,
                            isDealerCodeExist: false
                        };
                    };
                    /**
                     * @param ctn
                     * @returns {boolean|any}
                     */
                    this.hasOrder = function (ctn) {
                        return _this.model.bfappcOrders.length > 0 && _this.getSwitchToOrder(ctn) && _this.getOnlyOrders(ctn).length > 0;
                    };
                    /**
                     * @param ctn
                     * @returns {T[]}
                     */
                    this.getOnlyOrders = function (ctn) {
                        return _.filter(_this.model.bfappcOrders, function (order) {
                            return _.indexOf(order.assemblyIds, ctn) >= 0 && !order.quotation;
                        });
                    };
                    /*
                    
                        private getCurrentOrder: (ctn: number) => any = (ctn: number) => {
                          return _.find(this.model.bfappcOrders, (order) => {
                            return order.currentOrder === true && _.indexOf(order.assemblyIds, ctn) >= 0;
                          });
                        };
                    */
                    /**
                     * @returns {boolean}
                     */
                    this.isDealerCodeExist = function () {
                        return _this.model.isDealerCodeExist;
                    };
                    /**
                     * @param dealerCodeExist
                     */
                    this.setDealerCodeExist = function (dealerCodeExist) {
                        _this.model.isDealerCodeExist = dealerCodeExist;
                    };
                    /**
                     * @param ctn
                     * @returns {T}
                     */
                    this.getSwitchToOrder = function (ctn) {
                        return _.find(_this.model.bfappcOrders, function (order) {
                            return _.find(order.assemblyIds, function (assemblyId) {
                                return assemblyId === ctn;
                            });
                        });
                    };
                    /**
                     * @returns {any}
                     */
                    this.isFetchOrderCompleted = function () {
                        return _this.model.fetchOrderCompleted;
                    };
                    /**
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.fetchOrder = function () {
                        //console.info('fetchOrder');
                        //ajax.fetchOrder().then(
                        var deferred = _this.$q.defer();
                        _this.$http.get(_this.securityService.getBackendUrl(_this.config.basic.fetchOrderAPI)).then(function (fetchOrderResponse) {
                            var fetchOrder = fetchOrderResponse.data;
                            _this.model.fetchOrderCompleted = true;
                            if (fetchOrder && fetchOrder.success) {
                                _this.model.fetchOrderFullResponse = fetchOrder;
                                deferred.resolve(_this.model.fetchOrderFullResponse);
                                if (fetchOrder.ppc && fetchOrder.ppc.length) {
                                    _this.model.bfappcOrders = fetchOrder.ppc;
                                }
                            }
                            else {
                            }
                        }).catch(function () {
                            _this.model.fetchOrderCompleted = true;
                            deferred.reject();
                            // PPC TODO: error message on fetch error
                        });
                        return deferred.promise;
                    };
                    /**
                     * @param errorMessage
                     */
                    this.trackPpcDtmError = function (errorMessage) {
                        try {
                            var dtmMessage = angular.element('<span>' + errorMessage + '</span>');
                            _this.dtmService.setVar('error', dtmMessage.text() + '|PPC');
                            _this.dtmService.direct(_this.config.basic.dtmBuyFlowError);
                            dtmMessage = null;
                        }
                        catch (err) {
                            console.log('trackPpcDtmError:', err);
                        }
                    };
                    /**
                     * @param appStateForPPC
                     * @param resumeOrder
                     * @returns {IPromise<T>}
                     */
                    this.gotoBFAPPC = function (appStateForPPC, resumeOrder) {
                        var deferred = _this.$q.defer();
                        _this.model.appStateForPPC = appStateForPPC;
                        _this.processAllowedPpcBrt(deferred, resumeOrder);
                        return deferred.promise;
                    };
                    /**
                     * @param deferred
                     * @param resumeOrder
                     */
                    this.processAllowedPpcBrt = function (deferred, resumeOrder) {
                        _this.hasMultipleSubscribers().then(function (hasMultipleSubscribers) {
                            if (!hasMultipleSubscribers) {
                                deferred.resolve();
                                _this.checkEligibilityAndSaveState('single', 'all').then(function () {
                                    _this.$state.go('ppc-singleline');
                                });
                            }
                            else {
                                _this.redirectToPpc(resumeOrder);
                            }
                        });
                    };
                    /**
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.isMultiline = function () {
                        var deferred = _this.$q.defer();
                        // Abdellatif said, if there is an additional subscriber, it is multiline, no matter what the current ctn is
                        _this.getSubscribers().then(function (subscribersResponse) {
                            _this.model.subscribers = subscribersResponse.data.subscribers;
                            var isMultiline = _.filter(subscribersResponse.data.subscribers, function (subscriber) {
                                return subscriber.familyShareStatus === 'Additional';
                            }).length > 0;
                            deferred.resolve(isMultiline);
                        }, function () {
                            deferred.reject();
                        });
                        return deferred.promise;
                    };
                    /**
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.hasMainSubscriber = function () {
                        var deferred = _this.$q.defer();
                        _this.getSubscribers().then(function (subscribersResponse) {
                            _this.model.subscribers = subscribersResponse.data.subscribers;
                            var hasMain = _.filter(subscribersResponse.data.subscribers, function (subscriber) {
                                return subscriber.familyShareStatus === 'Main';
                            }).length > 0;
                            deferred.resolve(hasMain);
                        }, function () {
                            deferred.reject();
                        });
                        return deferred.promise;
                    };
                    /**
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.hasMultipleSubscribers = function () {
                        var deferred = _this.$q.defer();
                        _this.getSubscribers().then(function (subscribersResponse) {
                            _this.model.subscribers = subscribersResponse.data.subscribers;
                            deferred.resolve(subscribersResponse.data.subscribers.length > 1);
                        }, function () {
                            deferred.reject();
                        });
                        return deferred.promise;
                    };
                    /*original
                          var deferred = this.$q.defer();
                          if (self.permission[type] !== null) {
                            deferred.resolve(self.permission[type]);
                          } else {
                            ajax.getPermissions().then(
                              function (response) {
                                self.permission.ppc = false;
                                self.permission.mppc = false;
                    
                                if (response && response.permissions && Array.isArray(response.permissions)) {
                                  self.permission.ppc = response.permissions.some(function (elem) {
                                    return elem.permission === 'NPPC_UTE_PAGE_VIEW';
                                  });
                    
                                  self.permission.mppc = response.permissions.some(function (elem) {
                                    return elem.permission === 'MULTI_NPPC_UTE_PAGE_VIEW';
                                  });
                                }
                                deferred.resolve(self.permission[type]);
                              },
                              function () {
                                pricePlanChangesErrors.showError(this.$translate.instant('ppc_something_went_wrong_message_title'), this.$translate.instant('ppc_something_went_wrong_message_text'), ['OK'], null, true);
                                self.changeBtnLoading(false);
                                trackPpcDtmError(this.$translate.instant('ppc_something_went_wrong_message_text'));
                                deferred.reject();
                              }
                            );
                          }
                    
                          return deferred.promise;
                          */
                    /**
                     * @param flowType
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.isEligible = function (flowType) {
                        var deferred = _this.$q.defer();
                        var isPpcEligible = false;
                        var isPpcBotEligible = false;
                        var ppcEligibilityChecks = [];
                        var postData = {
                            accountNumber: _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER),
                            accountTypeNumber: _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER),
                            subscriberNumber: _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER),
                            consolidatedInd: 'NO',
                            flowType: flowType
                        };
                        if (_this.model.selectedPrimary != null) {
                            postData.subscriberNumber = _this.model.selectedPrimary;
                        }
                        ppcEligibilityChecks.push(_this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.checkEligibilityAPI), postData).then(function (eligibilityResponse) {
                            var eligibility = eligibilityResponse.data;
                            _this.model.appStateForPPC.eligibilityChecked = eligibility.eligible;
                            _this.model.appStateForPPC.availableCreditAmount = eligibility.availableCreditAmount;
                            if (eligibility.eligible) {
                                isPpcEligible = true;
                                return isPpcEligible;
                            }
                            else {
                                var errorResponse_1 = (eligibility && eligibility.eligibilityCode) ? eligibility : {
                                    'eligible': false,
                                    'eligibilityCode': '500'
                                };
                                _this.$modal.open({
                                    controller: _this.config.advanced.modals.notEligible.controllerName,
                                    templateUrl: _this.config.advanced.modals.notEligible.templateUrl,
                                    size: 'md',
                                    backdrop: 'static',
                                    backdropClass: 'bkg-modal',
                                    resolve: {
                                        'eligibilityResponse': function () {
                                            return errorResponse_1;
                                        }
                                    }
                                });
                                deferred.reject();
                            }
                        }, function (response) {
                            if (response && response.eligibilityCode) {
                                _this.$modal.open({
                                    controller: _this.config.advanced.modals.notEligible.controllerName,
                                    templateUrl: _this.config.advanced.modals.notEligible.templateUrl,
                                    size: 'md',
                                    backdrop: 'static',
                                    backdropClass: 'bkg-modal',
                                    resolve: {
                                        'eligibilityResponse': function () {
                                            return response;
                                        }
                                    }
                                });
                            }
                            else {
                                _this.pricePlanErrorsService.showError({ title: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_title'), message: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_text'), buttons: ['OK'], redirect: null, showLiveChat: true });
                                _this.trackPpcDtmError(_this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_text'));
                            }
                            _this.changeBtnLoading(false);
                            deferred.reject();
                        }).finally(function () {
                            //this.selectedPrimary = null;
                        }));
                        if (_this.userService.isCare() || _this.userService.isDealer()) {
                            var request = {
                                accountNumber: _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER),
                                lang: _this.$translate.use().toUpperCase()
                            };
                            ppcEligibilityChecks.push(_this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.checkBOTEligibilityAPI), request).then(function (responseBOT) {
                                var isBOTEligible = true;
                                var openCases = {};
                                angular.forEach(responseBOT.data.getCasesResponse.cases._case, function (value, key) {
                                    if ((value.caseStatus.toLowerCase() === 'new' || value.caseStatus.toLowerCase() === 'in progress' || value.caseStatus.toLowerCase() === 'new case') && (value.caseTypeLevel3.toLowerCase() === 'hup' || value.caseTypeLevel3.toLowerCase() === 'ppc')) {
                                        isBOTEligible = false;
                                        openCases = value;
                                    }
                                });
                                if (isBOTEligible) {
                                    isPpcBotEligible = true;
                                    return isPpcBotEligible;
                                }
                                else {
                                    if (isPpcEligible) {
                                        var errorResponse_2 = (responseBOT.data && responseBOT.data.eligibilityCode) ? responseBOT.data : {
                                            eligible: false,
                                            eligibilityCode: 'bot_eligible',
                                            openCases: openCases
                                        };
                                        _this.$modal.open({
                                            controller: _this.config.advanced.modals.notEligible.controllerName,
                                            templateUrl: _this.config.advanced.modals.notEligible.templateUrl,
                                            size: 'md',
                                            backdrop: 'static',
                                            backdropClass: 'bkg-modal',
                                            resolve: {
                                                'eligibilityResponse': function () {
                                                    return errorResponse_2;
                                                }
                                            }
                                        });
                                        deferred.reject();
                                    }
                                }
                            }, function (error) {
                                _this.pricePlanErrorsService.showError({ title: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_title'), message: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_text'), buttons: ['OK'], redirect: null, showLiveChat: true });
                                _this.changeBtnLoading(false);
                                deferred.reject();
                            }));
                        }
                        _this.$q.all(ppcEligibilityChecks).then(function (response) {
                            if (response.length === 1) {
                                if (response[0]) {
                                    deferred.resolve();
                                }
                            }
                            else {
                                if (response[0] && response[1]) {
                                    deferred.resolve();
                                }
                            }
                        });
                        return deferred.promise;
                    };
                    /**
                     * @param filterOption
                     * @returns {any}
                     */
                    this.saveState = function (filterOption) {
                        filterOption = filterOption || 'all';
                        _this.model.appStateForPPC.ban = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                        _this.model.appStateForPPC.ctnWirelessDashboard = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER);
                        if (_this.model.selectedPrimary != null) {
                            _this.model.appStateForPPC.ctn = _this.model.selectedPrimary;
                        }
                        else {
                            _this.model.appStateForPPC.ctn = _this.model.appStateForPPC.ctnWirelessDashboard;
                        }
                        _this.model.appStateForPPC.ban = _this.model.appStateForPPC.ban.toString();
                        _this.model.appStateForPPC.ctn = _this.model.appStateForPPC.ctn.toString();
                        _this.model.appStateForPPC.accountTypeNumber = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_TYPE_NUMBER);
                        _this.model.appStateForPPC.selectedAdditionalSubscribers = _this.model.selectedAdditionalSubscribers.join(',');
                        return _this.accountOverviewSummaryWorker.getWirelessCTNSummary().then(function (summary) {
                            _this.model.appStateForPPC.ctnList = _.pluck(summary, 'ctn').filter(Boolean);
                            _this.model.appStateForPPC.filterOption = filterOption;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.setStateAPI), _this.model.appStateForPPC);
                        });
                    };
                    /**
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.getSubscribers = function () {
                        var deferred = _this.$q.defer();
                        var postData = {
                            accountNumber: _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)
                        };
                        if (_this.model.subscribers !== null) {
                            deferred.resolve(_this.model.subscribers);
                        }
                        else {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.basic.subscribersAPI), postData);
                        }
                        return deferred.promise;
                    };
                    /**
                     * @param resumeOrder
                     */
                    this.redirectToPpc = function (resumeOrder) {
                        if (resumeOrder) {
                            _this.model.appStateForPPC.eligibilityChecked = false;
                            _this.saveState(null).then(function () {
                                _this.$state.go('ppc-resume-order');
                            });
                            return;
                        }
                        //if mainSubscriber is undefined it means there is no shared group
                        var mainSubscriber = _.find(_this.model.subscribers, function (subscriber) {
                            return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
                        });
                        var currentCtnShareStatus = _.result(_.find(_this.model.subscribers, function (subscriber) {
                            return subscriber.subscriberNumber === (_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER)).toString();
                        }), 'familyShareStatus');
                        var numberOfAdditionalSubscribers = 0;
                        var numberOfIndividualSubscribers = 0;
                        angular.forEach(_this.model.subscribers, function (subscriber) {
                            if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional') {
                                numberOfAdditionalSubscribers++;
                            }
                            if (subscriber.status === 'Active' && subscriber.familyShareStatus === 'Individual') {
                                numberOfIndividualSubscribers++;
                            }
                        });
                        if (mainSubscriber !== undefined) {
                            // below cases are defined in BFA-1911
                            if (numberOfAdditionalSubscribers === 0 && currentCtnShareStatus === 'Main') {
                                // if there is only 1 subscriber and it is 'main', user must be directed to single line NOT multi line
                                // or 'main' & 1+ 'individual' & no additional, also redirect to SL-PPC
                                _this.checkEligibilityAndSaveState('single', 'all').then(function () {
                                    _this.$state.go('ppc-singleline');
                                });
                            }
                            else if (currentCtnShareStatus === 'Additional') {
                                _this.isEligible('multi').then(function () {
                                    _this.model.selectedPrimary = mainSubscriber.subscriberNumber;
                                    _this.checkEligibilityAndSaveState('multi', 'main').then(function () {
                                        _this.$state.go('ppc-multiline-entry-2');
                                    });
                                });
                            }
                            else if (currentCtnShareStatus === 'Main') {
                                //customer already has a shared group and selected an additional/main CTN
                                // bfa-4584: check main ctn eligibility before going into ML flow
                                // previous logic: covers 4, 5, 7 - As Abdellatif said, for entry point 2, we should do eligibility check in the entry point itself only for main and we should do eligibility check for additional lines in the calling options page
                                _this.model.selectedPrimary = mainSubscriber.subscriberNumber;
                                _this.checkEligibilityAndSaveState('multi', 'main').then(function () {
                                    _this.$state.go('ppc-multiline-entry-2');
                                });
                            }
                            else if (currentCtnShareStatus === 'Individual') {
                                //customer already has a shared group and selected an individual CTN
                                _this.showThirdMultiLineEntry();
                            }
                        }
                        else if (currentCtnShareStatus === 'Individual') {
                            //covers cases 1, 2, 3
                            if (numberOfIndividualSubscribers === 1) {
                                _this.checkEligibilityAndSaveState('single', 'all').then(function () {
                                    _this.$state.go('ppc-singleline');
                                });
                            }
                            else {
                                _this.showFirstMultiLineEntry();
                            }
                        }
                    };
                    this.showThirdMultiLineEntry = function () {
                        var entry3ModalInstance = _this.$modal.open({
                            controller: _this.config.advanced.modals.mppcEntry3.controllerName,
                            templateUrl: _this.config.advanced.modals.mppcEntry3.templateUrl,
                        });
                        entry3ModalInstance.result.then(function (response) {
                            if (response === 'changeCurrentPlan') {
                                _this.checkEligibilityAndSaveState('single', 'individual').then(function () {
                                    _this.$state.go('ppc-singleline');
                                });
                            }
                            else if (response === 'addToSharedGroup') {
                                _this.model.selectedAdditionalSubscribers = _.pluck(_.filter(_this.model.subscribers, function (subscriber) {
                                    return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Additional';
                                }), 'subscriberNumber');
                                _this.model.selectedAdditionalSubscribers.push(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER));
                                _this.model.selectedPrimary = _.find(_this.model.subscribers, function (subscriber) {
                                    return subscriber.status === 'Active' && subscriber.familyShareStatus === 'Main';
                                }).subscriberNumber;
                                _this.askAddAdditionalData();
                            }
                        }, function () {
                            _this.changeBtnLoading(false);
                        });
                    };
                    this.askAddAdditionalData = function () {
                        var addAdditionalDataModalInstance = _this.$modal.open({
                            controller: _this.config.advanced.modals.mppcAddAdditionalData.controllerName,
                            templateUrl: _this.config.advanced.modals.mppcAddAdditionalData.templateUrl,
                        });
                        addAdditionalDataModalInstance.result.then(function (response) {
                            _this.checkEligibilityAndSaveState('multi', 'main').then(function () {
                                if (response) {
                                    _this.$state.go('ppc-multiline-step-1');
                                }
                                else {
                                    _this.$state.go('ppc-multiline-step-2');
                                }
                            });
                        }, function () {
                            _this.changeBtnLoading(false);
                        });
                    };
                    this.showFirstMultiLineEntry = function () {
                        var entry1ModalInstance = _this.$modal.open({
                            controller: _this.config.advanced.modals.mppcEntry1.controllerName,
                            templateUrl: _this.config.advanced.modals.mppcEntry1.templateUrl,
                        });
                        entry1ModalInstance.result.then(function (response) {
                            if (response === 'changeCurrentPlan') {
                                _this.checkEligibilityAndSaveState('single', 'all').then(function () {
                                    _this.$state.go('ppc-singleline');
                                });
                            }
                            else if (response === 'createSharedGroup') {
                                _this.createSharedGroup();
                            }
                        }, function () {
                            _this.changeBtnLoading(false);
                        });
                    };
                    this.createSharedGroup = function () {
                        var shareGroupIndividualModalInstance = _this.$modal.open({
                            controller: _this.config.advanced.modals.mppcSharedGroupIndividual.controllerName,
                            templateUrl: _this.config.advanced.modals.mppcSharedGroupIndividual.templateUrl,
                            resolve: {
                                subscribers: function () {
                                    return _this.model.subscribers;
                                },
                                currentCtn: function () {
                                    return _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER);
                                }
                            }
                        });
                        shareGroupIndividualModalInstance.result.then(function (selectedAdditionalSubscribers) {
                            // we need to group the current CTN with these selected subscribers
                            var currentCtn = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER);
                            if (selectedAdditionalSubscribers.length > 0) {
                                _this.model.selectedAdditionalSubscribers = selectedAdditionalSubscribers;
                                var shareGroupPrimaryModalInstance = _this.$modal.open({
                                    controller: _this.config.advanced.modals.mppcSharedGroupPrimary.controllerName,
                                    templateUrl: _this.config.advanced.modals.mppcSharedGroupPrimary.templateUrl,
                                    resolve: {
                                        selectedAdditionalSubscribers: function () {
                                            return selectedAdditionalSubscribers;
                                        },
                                        currentCtn: function () {
                                            return currentCtn;
                                        }
                                    }
                                });
                                shareGroupPrimaryModalInstance.result.then(function (selectedPrimary) {
                                    if (selectedPrimary) {
                                        if (selectedPrimary !== currentCtn) {
                                            //if user changed the primary subscriber, so old primary one should be an additional now!
                                            _this.model.selectedAdditionalSubscribers.push([currentCtn]);
                                            //the new selectedPrimary ctn must ne remove from selectedAdditionalSubscribers, because it is a primary now!
                                            _.remove(selectedAdditionalSubscribers, function (item) {
                                                return item === selectedPrimary;
                                            });
                                        }
                                        _this.model.selectedPrimary = selectedPrimary;
                                        _this.checkEligibilityAndSaveState('multi', 'main').then(function () {
                                            _this.$state.go('ppc-multiline-step-1');
                                        });
                                    }
                                }, function () {
                                    _this.changeBtnLoading(false);
                                });
                            }
                        }, function () {
                            _this.changeBtnLoading(false);
                        });
                    };
                    /**
                     * @param flowType
                     * @param filterOption
                     * @returns {ute.promise|IPromise<T>|ng.IPromise<IBillData>|null|((target?:any)=>JQueryPromise<T>)}
                     */
                    this.checkEligibilityAndSaveState = function (flowType, filterOption) {
                        var deferred = _this.$q.defer();
                        _this.isEligible(flowType).then(function () {
                            _this.saveState(filterOption).then(function () {
                                deferred.resolve();
                            }, function (saveStateError) {
                                _this.pricePlanErrorsService.showError({ title: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_title'), message: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_text'), buttons: ['OK'], redirect: null, showLiveChat: true });
                                _this.changeBtnLoading(false);
                                deferred.reject();
                            });
                        }, function () {
                            // already displayed eligibility error in isEligible()
                            deferred.reject();
                        });
                        return deferred.promise;
                    };
                    this.clean = function () {
                        _this.model.appStateForPPC = {};
                        _this.model.fetchOrderCompleted = false;
                        _this.model.bfappcOrders.length = 0;
                        _this.model.brtSwitch = {
                            ppc: null,
                            mppc: null,
                            q2ppc: null
                        };
                        _this.model.permission = {
                            ppc: null,
                            mppc: null
                        };
                        _this.model.subscribers = null;
                        _this.model.fetchOrderFullResponse = {};
                        _this.model.changeBtnLoadingStatus = false;
                    };
                    /**
                     * @returns {any}
                     */
                    this.getFetchOrderFullResponse = function () {
                        return _this.model.fetchOrderFullResponse;
                    };
                    /**
                     * @param status
                     * @returns {any}
                     */
                    this.changeBtnLoading = function (status) {
                        /*??
                        if (!arguments.length) {
                          return this.model.changeBtnLoadingStatus;
                        }
                        */
                        _this.model.changeBtnLoadingStatus = status;
                    };
                    this.openSomethingWentWrongPopup = function () {
                        _this.pricePlanErrorsService.showError({ title: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_title'), message: _this.$translate.instant('ute.bfa.ppc.ppc_something_went_wrong_message_text'), buttons: ['OK'], redirect: null, showLiveChat: true });
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$q',
                        '$state',
                        '$translate',
                        '$http',
                        '$modal'
                    ];
                    this.resetModel();
                }
                BFAPPCProvider.$inject = [];
                return BFAPPCProvider;
            }());
            angular.module('ute.bfa.ppc').provider('ute.bfa.ppc.service', BFAPPCProvider);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

/**
 * Created by Shahzad on 10/10/2016.
 */
/*
 * @description
 * A async validator for form fields, which validates user entered value for bad language (both en and fr) words
 * that are supposed to be stored in a JSON file, for both languages - separately.
 * */
var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                var BadLangCheckDirective = (function () {
                    function BadLangCheckDirective($q, badLangCheckService) {
                        var _this = this;
                        this.$q = $q;
                        this.badLangCheckService = badLangCheckService;
                        this.restrict = 'A';
                        this.require = 'ngModel';
                        this.link = function (scope, element, attrs, ctrl) {
                            var _self = _this;
                            //hits a GET to fetch JSON
                            var badLangCheck = function (modelValue) {
                                //validates - if input field is empty
                                return ctrl.$isEmpty(modelValue) ? _self.$q.when() : _self.badLangCheckService.validate(modelValue);
                            };
                            //registers the async validator
                            ctrl.$asyncValidators.badLangCheck = badLangCheck;
                        };
                    }
                    BadLangCheckDirective.factory = function () {
                        var directive = function ($q, badLangCheckService) { return new BadLangCheckDirective($q, badLangCheckService); };
                        directive.$inject = ['$q', 'badLangCheckService'];
                        return directive;
                    };
                    return BadLangCheckDirective;
                }());
                angular.module('ute.change.ctn.callerId').directive('badLangCheck', BadLangCheckDirective.factory());
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

/**
 * Created by Shahzad on 14/10/2016.
 */
/*
 * @description
 *
 *
 * */
var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                //will contain strings URLs/paths to fetch bad-lang dictionary for both "en" and "fr".
                var _URL;
                var BadLangCheckService = (function () {
                    function BadLangCheckService($http, $q) {
                        this.$http = $http;
                        this.$q = $q;
                        this._cache = { fetching: undefined, data: undefined };
                        //check if URL for the selected lang is not set via provider.
                        if (!_URL) {
                            var warning = "URL for badwords dictionary was not specified. please use BadLangCheckServiceProvider.setURL() in config()";
                            console.warn(warning);
                        }
                        //initiate fetch request
                        this._fetchJSON();
                    }
                    /*
                
                        isBadWord (name: string) : ng.IPromise<boolean> {
                
                          return this.$http.get('/v1/bannedWord/check/:' + name).then( (response: any): boolean => {
                            if (response.data.status.code === 0) {
                              return true;
                            } else {
                              return false;
                            }
                          }).catch ( (err: any) : boolean => {
                            return false;
                          });
                
                        }
                    */
                    BadLangCheckService.prototype.setURL = function (source) {
                        _URL = source;
                        this._clearCache();
                        this._fetchJSON();
                    };
                    BadLangCheckService.prototype.validate = function (value) {
                        var _this = this;
                        //validates - if input field is empty
                        if (value === undefined) {
                            return this.$q.when();
                        }
                        return this.$http.get('/v1/bannedWord/check/' + value).then(function (response) {
                            if (response.data.status.code === 0) {
                                return true;
                            }
                            else {
                                return _this.$q.reject('Bad words found');
                            }
                        }).catch(function (err) {
                            return _this.$q.reject('Couldn\'t check for bad words.');
                            // return false;
                        });
                        /*
                        this._getJSON()
                          .then(function (res: any) {
                  
                            //Todo: should use Regex to detect bad-word as a part of input
                            //invalidates - if the input matches exactly any of the words mentioned in the dictionary.
                            if (res[value]) {
                              defer.reject('Bad words found');
                  
                            } else {
                              //validates - else
                              defer.resolve();
                            }
                  
                          }, function (reason: any) {
                            //handle this case
                            defer.reject('Couldn\'t check for bad words.');
                          });
                  */
                    };
                    BadLangCheckService.prototype._getJSON = function () {
                        var cacheObj = this._cache;
                        //check if data has already been retrieved and exists in cache
                        if (cacheObj.data) {
                            return this.$q.when(cacheObj.data);
                        }
                        else if (cacheObj.fetching) {
                            return cacheObj.fetching;
                        }
                        else {
                            return cacheObj.fetching = this._fetchJSON();
                        }
                    };
                    BadLangCheckService.prototype._fetchJSON = function () {
                        var cacheObj = this._cache;
                        return this.$http.get(_URL).then(function (res) {
                            cacheObj.fetching = false;
                            return cacheObj.data = res.data;
                        }, function (err) {
                            cacheObj.fetching = false;
                            //cacheObj.data = undefined;
                            return err;
                        });
                    };
                    BadLangCheckService.prototype._clearCache = function () {
                        //clears the badLang dictionary from cache
                        this._cache = { fetching: undefined, data: undefined };
                    };
                    return BadLangCheckService;
                }());
                var BadLangCheckProvider = (function () {
                    function BadLangCheckProvider() {
                        this.$get = ['$http', '$q', function ($http, $q) {
                                return new BadLangCheckService($http, $q);
                            }];
                    }
                    BadLangCheckProvider.factory = function () {
                        var provider = function () { return new BadLangCheckProvider(); };
                        provider.$inject = [];
                        return provider;
                    };
                    BadLangCheckProvider.prototype.setURL = function (source) {
                        _URL = source;
                    };
                    return BadLangCheckProvider;
                }());
                angular.module('ute.change.ctn.callerId').provider('badLangCheckService', BadLangCheckProvider.factory());
                angular.module('ute.change.ctn.callerId').config(['badLangCheckServiceProvider', function (badLangCheckServiceProvider) {
                        badLangCheckServiceProvider.setURL('ute-change-ctn-caller-id/assets/badwords.json');
                    }]);
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                /*
                * Controller class for Modal Dialog to change a CTN caller id.
                * */
                var ChangeCtnCallerIdCtrl = (function () {
                    function ChangeCtnCallerIdCtrl(scope, $modal, changeCtnCallerIdService, permissionsService) {
                        var _this = this;
                        this.scope = scope;
                        this.$modal = $modal;
                        this.changeCtnCallerIdService = changeCtnCallerIdService;
                        this.permissionsService = permissionsService;
                        this.canChangeCallerId = true;
                        this.updateModel = function (summary) {
                            _this.changeCtnCallerIdService.reInitializeModel();
                            return null;
                        };
                        this.selectedCTNChange = function (accountOverview) {
                            _this.changeCtnCallerIdService.reInitializeModel();
                            return null;
                        };
                        this.changeCtnCallerIdService.reInitializeModel();
                        this.getFirstName = this.changeCtnCallerIdService.getFirstName;
                        this.getIsRep = this.changeCtnCallerIdService.getIsRep;
                        this.checkPermission();
                        var summaryWorker;
                        this.changeCtnCallerIdService.getSummaryWorker().then(function (worker) {
                            summaryWorker = worker;
                            worker.registerOnDataChangeHandler(_this.updateModel, ChangeCtnCallerIdCtrl.controllerName);
                        });
                        var overviewWorker = this.changeCtnCallerIdService.getFactoryWorker();
                        overviewWorker.registerOnDataChangeHandler(this.selectedCTNChange, ChangeCtnCallerIdCtrl.controllerName);
                        this.scope.$on('$destroy', function () {
                            summaryWorker.unregisterOnDataChangeHandler(ChangeCtnCallerIdCtrl.controllerName);
                            overviewWorker.unregisterOnDataChangeHandler(ChangeCtnCallerIdCtrl.controllerName);
                        });
                        this.config = this.changeCtnCallerIdService.getConfig();
                    }
                    ChangeCtnCallerIdCtrl.prototype.checkPermission = function () {
                        var _this = this;
                        if (this.getIsRep()) {
                            this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangeCallerId, ute.common.permissions.service.RamActionCodes.start)
                                .then(function (ptpPermission) {
                                _this.canChangeCallerId = ptpPermission;
                            });
                        }
                        else {
                            this.canChangeCallerId = true;
                        }
                    };
                    ChangeCtnCallerIdCtrl.prototype.openChangeCallerIdModal = function () {
                        var _this = this;
                        this.changeCtnCallerIdService.isEligible().then(function (resp) {
                            if (resp) {
                                _this.$modal.open({
                                    templateUrl: _this.config.advanced.changeCtnModal.templateUrl,
                                    controller: _this.config.advanced.changeCtnModal.controller,
                                    controllerAs: 'vm',
                                    size: 'lg',
                                    windowClass: _this.config.advanced.changeCtnModal.windowClass
                                }).result.then(function (result) {
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'success':
                                            _this.openSuccessModal();
                                            break;
                                        case 'error':
                                            _this.openErrorModal();
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                });
                            }
                            else {
                                _this.eligibilityFailModal();
                            }
                        });
                    };
                    ChangeCtnCallerIdCtrl.prototype.openErrorModal = function () {
                        this.$modal.open({
                            templateUrl: this.config.advanced.changeCtnModal.error.templateUrl,
                            controller: this.config.advanced.changeCtnModal.controller,
                            controllerAs: 'vm',
                            size: 'lg',
                            windowClass: this.config.advanced.changeCtnModal.windowClass
                        });
                    };
                    ChangeCtnCallerIdCtrl.prototype.openSuccessModal = function () {
                        this.$modal.open({
                            templateUrl: this.config.advanced.changeCtnModal.success.templateUrl,
                            controller: this.config.advanced.changeCtnModal.controller,
                            controllerAs: 'vm',
                            size: 'lg',
                            windowClass: this.config.advanced.changeCtnModal.windowClass
                        });
                    };
                    ChangeCtnCallerIdCtrl.prototype.eligibilityFailModal = function () {
                        this.$modal.open({
                            templateUrl: this.config.advanced.changeCtnModal.eligibilityFail.templateUrl,
                            controller: this.config.advanced.changeCtnModal.controller,
                            controllerAs: 'vm',
                            size: 'lg',
                            windowClass: this.config.advanced.changeCtnModal.windowClass
                        });
                    };
                    ChangeCtnCallerIdCtrl.controllerName = 'ute.change.ctn.callerId.controller';
                    ChangeCtnCallerIdCtrl.$inject = [
                        '$scope',
                        '$modal',
                        'ute.change.ctn.callerId',
                        'ute.common.permissions.service'
                    ];
                    return ChangeCtnCallerIdCtrl;
                }());
                callerId.ChangeCtnCallerIdCtrl = ChangeCtnCallerIdCtrl;
                angular.module('ute.change.ctn.callerId').controller('ute.change.ctn.callerId.controller', ChangeCtnCallerIdCtrl);
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                function changeCtnCallerId() {
                    return {
                        restrict: 'AE',
                        scope: {
                            showName: '='
                        },
                        bindToController: true,
                        controller: ute.change.ctn.callerId.ChangeCtnCallerIdCtrl,
                        controllerAs: 'vm',
                        templateUrl: 'module/changeCtnCallerId/views/changeCtnCallerId.directive.html'
                    };
                }
                callerId.changeCtnCallerId = changeCtnCallerId;
                function stopEvent() {
                    return {
                        restrict: 'A',
                        link: function (scope, element, attr) {
                            element.on(attr.stopEvent, function (e) {
                                var elem = element[0];
                                if (elem.name === 'liveChatButton') {
                                    angular.element(elem).parent().find('#CCTNCID-live-chat a').trigger('click');
                                }
                                else {
                                    element.focus();
                                }
                                e.preventDefault();
                                e.stopPropagation();
                            });
                        }
                    };
                }
                callerId.stopEvent = stopEvent;
                angular.module('ute.change.ctn.callerId').directive('changeCtnCallerId', changeCtnCallerId);
                angular.module('ute.change.ctn.callerId').directive('stopEvent', stopEvent);
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                var ChangeCtnCallerIdProvider = (function () {
                    function ChangeCtnCallerIdProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                forbiddenWordAPIURL: 'v1/bannedWord/check/',
                                eligibilityCheckAPIURL: 'v1/wirelessService/changeSubscriberNameEligibility'
                            },
                            advanced: {
                                medium: {
                                    consumer: '',
                                    care: '',
                                    retail: '',
                                },
                                applicationId: {
                                    consumer: '',
                                    care: '',
                                    retail: '',
                                },
                                changeCtnModal: {
                                    templateUrl: 'module/changeCtnCallerId/views/changeCallerId.html',
                                    controller: 'ute.change.ctn.callerId.modal.controller',
                                    windowClass: 'uteChangeCtnCallerId',
                                    error: {
                                        templateUrl: 'module/changeCtnCallerId/views/changeCallerIdError.html'
                                    },
                                    success: {
                                        templateUrl: 'module/changeCtnCallerId/views/changeCallerIdSuccess.html'
                                    },
                                    eligibilityFail: {
                                        templateUrl: 'module/changeCtnCallerId/views/eligibilityFail.html'
                                    }
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q, $modal, $window, $timeout, $translate) {
                            _this.$injector = $injector;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.$modal = $modal;
                            _this.$window = $window;
                            _this.$timeout = $timeout;
                            _this.$translate = $translate;
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            _this.accountOverviewSummaryFactory = $injector.get('ute.rogers.account.overview.summary.factory');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            return {
                                reInitializeModel: _this.reInitializeModel,
                                getConfig: _this.getConfig,
                                getDisplayName: _this.getDisplayName,
                                getEmail: _this.getEmail,
                                getCtn: _this.getCtn,
                                fetchCtn: _this.fetchCtn,
                                getIsRep: _this.getIsRep,
                                getLang: _this.getLang,
                                openChangeCtnModal: _this.openChangeCtnModal,
                                getModalOptions: _this.getModalOptions,
                                validateForBadWords: _this.validateForBadWords,
                                isEligible: _this.isEligible,
                                changeSubscriberName: _this.changeSubscriberName,
                                changeSubscriberNameSuccessHandler: _this.changeSubscriberNameSuccessHandler,
                                changeSubscriberNameErrorHandler: _this.changeSubscriberNameErrorHandler,
                                getFirstName: _this.getFirstName,
                                getLastName: _this.getLastName,
                                getNewFirstName: _this.getNewFirstName,
                                getNewLastName: _this.getNewLastName,
                                setNewFirstName: _this.setNewFirstName,
                                setNewLastName: _this.setNewLastName,
                                getExistingDisplayName: _this.getExistingDisplayName,
                                getDisplayNameFromSummaryData: _this.getDisplayNameFromSummaryData,
                                getSummaryWorker: _this.getSummaryWorker,
                                getFactoryWorker: _this.getFactoryWorker
                            };
                        };
                        /**
                         *
                         * @returns {IChangeCTNCallerIdConfig}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.reInitializeModel = function () {
                            _this.model.ctn = _this.fetchCtn();
                            _this.fetchEmail().then(function (email) { return _this.model.email = email; });
                            _this.fetchFirstName().then(function (firstname) { return _this.model.firstName = firstname; });
                            _this.fetchLastName().then(function (lastname) { return _this.model.lastName = lastname; });
                        };
                        this.resetModel = function () {
                            _this.model = {
                                email: '',
                                ctn: '',
                                firstName: '',
                                lastName: ''
                            };
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getFirstName = function () {
                            return _this.model.firstName;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getLastName = function () {
                            return _this.model.lastName;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getNewFirstName = function () {
                            return _this.model.newFirstName;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getNewLastName = function () {
                            return _this.model.newLastName;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.setNewFirstName = function (firstName) {
                            _this.model.newFirstName = firstName;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.setNewLastName = function (lastName) {
                            _this.model.newLastName = lastName;
                        };
                        /**
                         *
                         * @param summary
                         * @returns {string}
                         */
                        this.getDisplayNameFromSummaryData = function (summary) {
                            var ctnInfo = _.findWhere(summary.subList, {
                                subNumber: _this.model.ctn
                            });
                            return ctnInfo.firstname + ' ' + ctnInfo.lastname;
                        };
                        /**
                         *
                         * @returns {IAccountOverviewWorker}
                         */
                        this.getFactoryWorker = function () {
                            var param;
                            if (_this.userService.isCare()) {
                                var ban = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                                param = { acctNbr: ban };
                            }
                            return _this.accountOverviewFactory(param);
                        };
                        /**
                         *
                         * @returns {IPromise<IAccountOverviewSummaryWorker>}
                         */
                        this.getSummaryWorker = function () {
                            return _this.getFactoryWorker().getSelectedAccount().then(function (account) {
                                var summaryRequest = {
                                    accountNumber: account.accountNumber,
                                    accountTypeNumber: account.accountTypeNumber,
                                    language: _this.getLang()
                                };
                                return _this.accountOverviewSummaryFactory(summaryRequest);
                            });
                        };
                        /**
                         *
                         * @returns {IPromise<IHttpPromiseCallbackArg<IAccountOverviewSummary>>}
                         */
                        this.getSummaryData = function () {
                            return _this.getSummaryWorker().then(function (worker) {
                                return worker.getAccountOverviewSummary();
                            });
                        };
                        /**
                         *
                         * @returns {IPromise<string>}
                         */
                        this.getDisplayName = function () {
                            return _this.getSummaryData().then(function (summary) {
                                return _this.getDisplayNameFromSummaryData(summary);
                            });
                        };
                        /**
                         *
                         * @returns {IPromise<string>}
                         */
                        this.fetchFirstName = function () {
                            return _this.getSummaryData().then(function (summary) {
                                var ctnInfo = _.findWhere(summary.subList, {
                                    subNumber: _this.model.ctn
                                });
                                return ctnInfo ? ctnInfo.firstname : '';
                            });
                        };
                        /**
                         *
                         * @returns {IPromise<string>}
                         */
                        this.fetchLastName = function () {
                            return _this.getSummaryData().then(function (summary) {
                                var ctnInfo = _.findWhere(summary.subList, {
                                    subNumber: _this.model.ctn
                                });
                                return ctnInfo ? ctnInfo.lastname : '';
                            });
                        };
                        /**
                         *
                         * @returns {String}
                         */
                        this.fetchCtn = function () {
                            return String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER));
                        };
                        /**
                         *
                         * @returns {IPromise<string>}
                         */
                        this.fetchEmail = function () {
                            return _this.getSummaryData().then(function (summary) {
                                return summary.contactInfo.emailAddress;
                            });
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getEmail = function () {
                            return _this.model.email;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getCtn = function () {
                            return _this.model.ctn;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getIsRep = function () {
                            return _this.userService.isRepView();
                        };
                        this.openChangeCtnModal = function () {
                            _this.$modal.open({
                                templateUrl: _this.config.advanced.changeCtnModal.templateUrl,
                                controller: _this.config.advanced.changeCtnModal.controller,
                                controllerAs: 'vm',
                                size: 'lg',
                                windowClass: _this.config.advanced.changeCtnModal.windowClass
                            });
                        };
                        /**
                         *
                         * @returns {{ctn: string, existingDisplayName: string, isRep: boolean}}
                         */
                        this.getModalOptions = function () {
                            return {
                                email: _this.model.email,
                                ctn: _this.model.ctn,
                                existingDisplayName: _this.getExistingDisplayName(),
                                isRep: _this.getIsRep()
                            };
                        };
                        /**
                         *
                         * @param value
                         * @returns {IPromise<boolean>}
                         */
                        this.validateForBadWords = function (value) {
                            var url = _this.securityService.getBackendUrl(_this.config.basic.forbiddenWordAPIURL + value);
                            return _this.$http.get(url).then(function (response) {
                                return (response.data.status.code === 0);
                            }).catch(function (err) {
                                return false;
                            });
                        };
                        /**
                         *
                         * @param value
                         * @returns {IPromise<boolean>}
                         */
                        this.isEligible = function () {
                            var url = _this.securityService.getBackendUrl(_this.config.basic.eligibilityCheckAPIURL);
                            var data = {
                                telephoneNumber: _this.fetchCtn()
                            };
                            return _this.$http.post(url, data).then(function (response) {
                                return !!(response.data.status.code === 0 && response.data.content.isEligible);
                            });
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getMedium = function () {
                            if (_this.userService.isConsumer()) {
                                return _this.config.advanced.medium.consumer;
                            }
                            else if (_this.userService.isCare()) {
                                return _this.config.advanced.medium.care;
                            }
                            else if (_this.userService.isDealer()) {
                                return _this.config.advanced.medium.retail;
                            }
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getApplicationId = function () {
                            if (_this.userService.isConsumer()) {
                                return _this.config.advanced.applicationId.consumer;
                            }
                            else if (_this.userService.isCare()) {
                                return _this.config.advanced.applicationId.care;
                            }
                            else if (_this.userService.isDealer()) {
                                return _this.config.advanced.applicationId.retail;
                            }
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getLang = function () {
                            return _this.$translate.use();
                        };
                        /**
                         *
                         * @param options
                         * @returns {IPromise<IHttpPromiseCallbackArg<IAccountOverviewSummary>>}
                         */
                        this.changeSubscriberName = function () {
                            return _this.getSummaryWorker().then(function (worker) {
                                var request = {
                                    accountNumber: String(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER)),
                                    telephoneNumber: _this.model.ctn,
                                    firstName: _this.model.newFirstName,
                                    lastName: _this.model.newLastName,
                                    medium: _this.getMedium(),
                                    applicationId: _this.getApplicationId()
                                };
                                return worker.updateCtnName(request)
                                    .then(_this.changeSubscriberNameSuccessHandler)
                                    .catch(_this.changeSubscriberNameErrorHandler);
                            });
                        };
                        /**
                         *
                         * @param res
                         * @returns {ng.IHttpPromiseCallbackArg<IAccountOverviewSummary>}
                         */
                        this.changeSubscriberNameSuccessHandler = function (res) {
                            return res;
                        };
                        /**
                         *
                         * @param err
                         * @returns {IPromise<any>}
                         */
                        this.changeSubscriberNameErrorHandler = function (err) {
                            return _this.$q.reject(err);
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getExistingDisplayName = function () {
                            return _this.model.firstName + ' ' + _this.model.lastName;
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$q',
                            '$modal',
                            '$window',
                            '$timeout',
                            '$translate'
                        ];
                        this.resetModel();
                    }
                    ChangeCtnCallerIdProvider.$inject = [];
                    return ChangeCtnCallerIdProvider;
                }());
                callerId.ChangeCtnCallerIdProvider = ChangeCtnCallerIdProvider;
                angular.module('ute.change.ctn.callerId').provider('ute.change.ctn.callerId', ChangeCtnCallerIdProvider);
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

/**
 * Created by Shahzad on 10/10/2016.
 */
/*
 * @description
 * A sync validator for form fields, which validates user entered value for special characters.
 * */
var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
                var SpecialCharCheck = (function () {
                    function SpecialCharCheck() {
                        this.restrict = 'A';
                        this.require = 'ngModel';
                        this.link = function (scope, element, attrs, ctrl) {
                            var regSpecialChars = /[!@#$%^&*()]/;
                            //check string against special chars.
                            var SpecialCharCheck = function (modelValue) {
                                //validates - if input field is empty
                                //Invalidates - if input field has special characters
                                return ctrl.$isEmpty(modelValue) || !regSpecialChars.test(modelValue);
                            };
                            //registers the async validator
                            ctrl.$validators.SpecialCharCheck = SpecialCharCheck;
                        };
                    }
                    SpecialCharCheck.factory = function () {
                        var directive = function () { return new SpecialCharCheck(); };
                        directive.$inject = [];
                        return directive;
                    };
                    return SpecialCharCheck;
                }());
                angular.module('ute.change.ctn.callerId').directive('specialCharCheck', SpecialCharCheck.factory());
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn_1) {
            var callerId;
            (function (callerId) {
                'use strict';
                var ChangeCtnCallerIdModalCtrl = (function () {
                    function ChangeCtnCallerIdModalCtrl($scope, $modalInstance, changeCtnCallerIdService, $timeout, $translate, $q, $window) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.changeCtnCallerIdService = changeCtnCallerIdService;
                        this.$timeout = $timeout;
                        this.$translate = $translate;
                        this.$q = $q;
                        this.$window = $window;
                        this.sendingState = false;
                        this.changeNameInProgess = false;
                        this.STEP = callerId.STEP;
                        this.getFormattedCtn = function () {
                            var ctn = _this.getCtn().split('');
                            var p1 = '(' + ctn.slice(0, 3).join() + ') ';
                            var p2 = ctn.slice(3, 6).join();
                            var p3 = '-' + ctn.slice(6, 10).join();
                            return (p1 + p2 + p3).replace(/\,/g, '');
                        };
                        this.triggerChat = function (e) {
                            _this.$timeout(function () {
                                var link = angular.element('#uteChangeCallerIDLiveChat').find('a');
                                if (link && link.click) {
                                    link.click();
                                }
                            }, 0);
                        };
                        this.inputChanged = function (value, model, form) {
                            form[model].$setValidity('validated', false);
                            form[model].$setValidity('badWordCheck', true);
                            if (model === 'firstName' && value && value.split(' ').length > 2) {
                                form[model].$setValidity('moreThanTwoWords', false);
                            }
                            else if (model === 'lastName' && value && value.split(' ').length > 1) {
                                form[model].$setValidity('moreThanTwoWords', false);
                            }
                            else {
                                form[model].$setValidity('moreThanTwoWords', true);
                            }
                        };
                        this.openPolicyLink = function () {
                            _this.$window.open(_this.$translate.instant('ute.changeCtnCallerId.change.disclaimer_link'), '_blank');
                        };
                        this.checkForBadWord = function (value, model, form) {
                            if (Object.keys(form[model].$error).length === 1 && form[model].$error.validated) {
                                if (!value || value === '' && form[model].$touched) {
                                    form[model].$setValidity('badWordCheck', false);
                                    form[model].$setValidity('validated', true);
                                    return;
                                }
                                _this.sendingState = true;
                                var values = value.split(/\-| |'/);
                                if (values.length > 1) {
                                    values.push(values.join('+'));
                                }
                                var requests = _.map(values, function (value) { return _this.changeCtnCallerIdService.validateForBadWords(value); });
                                _this.$q.all(requests).then(function (results) {
                                    _.each(results, function (isGoodWord) {
                                        if (isGoodWord === false) {
                                            form[model].$setValidity('badWordCheck', false);
                                            return false;
                                        }
                                    });
                                    console.log(results);
                                }).catch(function () {
                                    form[model].$setValidity('badWordCheck', false);
                                }).finally(function () {
                                    form[model].$setValidity('validated', true);
                                    _this.sendingState = false;
                                });
                            }
                        };
                        this.isFormValid = function (form) {
                            return form.$valid;
                        };
                        this.changeSubscriberName = function () {
                            if (!_this.changeNameInProgess) {
                                _this.changeNameInProgess = true;
                                _this.changeCtnCallerIdService.changeSubscriberName()
                                    .then(function (res) {
                                    _this.step = callerId.STEP.SUCCESS;
                                    angular.element('.uteChangeCtnCallerId').scrollTop(0);
                                })
                                    .catch(function (err) {
                                    _this.changeFailed = true;
                                    _this.$timeout(function () {
                                        _this.step = callerId.STEP.FAILURE;
                                        _this.changeFailed = false;
                                        angular.element('.uteChangeCtnCallerId').scrollTop(0);
                                    }, 1000);
                                }).finally(function () {
                                    this.changeNameInProgess = false;
                                });
                            }
                        };
                        this.gotoChangeForm = function (form) {
                            if (form.$valid) {
                                _this.changeCtnCallerIdService.setNewFirstName(_this.data.newFirstName);
                                _this.changeCtnCallerIdService.setNewLastName(_this.data.newLastName);
                                _this.step = callerId.STEP.CHANGE_FORM;
                            }
                        };
                        this.toggleInstruction = function (e) {
                            _this.isInstructionOpen = !_this.isInstructionOpen;
                        };
                        this.closeModal = function (e) {
                            _this.$modalInstance.dismiss();
                        };
                        this.getSubmitButtonText = function () {
                            return (_this.changeNameInProgess && !_this.changeFailed) ? _this.$translate.instant('ute.changeCtnCallerId.initial.processing_button') :
                                (_this.changeNameInProgess && _this.changeFailed) ? _this.$translate.instant('ute.changeCtnCallerId.initial.change_failed') :
                                    _this.$translate.instant('ute.changeCtnCallerId.initial.update_and_continue');
                        };
                        this.step = callerId.STEP.INITIAL;
                        this.isInstructionOpen = false;
                        this.changeFailed = false;
                        this.getExistingDisplayName = this.changeCtnCallerIdService.getExistingDisplayName;
                        this.getEmail = this.changeCtnCallerIdService.getEmail;
                        this.getIsRep = changeCtnCallerIdService.getIsRep;
                        this.getCtn = changeCtnCallerIdService.getCtn;
                        this.getNewFirstName = this.changeCtnCallerIdService.getNewFirstName;
                        this.getNewLastName = this.changeCtnCallerIdService.getNewLastName;
                    }
                    ChangeCtnCallerIdModalCtrl.$inject = ['$scope', '$modalInstance', 'ute.change.ctn.callerId', '$timeout', '$translate', '$q', '$window'];
                    return ChangeCtnCallerIdModalCtrl;
                }());
                callerId.ChangeCtnCallerIdModalCtrl = ChangeCtnCallerIdModalCtrl;
                angular.module('ute.change.ctn.callerId').controller('ute.change.ctn.callerId.modal.controller', ChangeCtnCallerIdModalCtrl);
            })(callerId = ctn_1.callerId || (ctn_1.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var change;
    (function (change) {
        var ctn;
        (function (ctn) {
            var callerId;
            (function (callerId) {
                'use strict';
            })(callerId = ctn.callerId || (ctn.callerId = {}));
        })(ctn = change.ctn || (change.ctn = {}));
    })(change = ute.change || (ute.change = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var MatchDirective = (function () {
                    function MatchDirective($parse) {
                        var _this = this;
                        this.$parse = $parse;
                        this.require = '?ngModel';
                        this.restrict = 'A';
                        this.linkFn = function ($scope, $element, $attrs, $ctrl) {
                            if (angular.isUndefined($ctrl) && console && console.warn) {
                                console.warn('Match validation requires ngModel to be on the element');
                            }
                            var matchGetter = _this.$parse($attrs.uteMatch);
                            var caselessGetter = _this.$parse($attrs.matchCaseless);
                            var unMatch = _this.$parse($attrs.unMatch);
                            $scope.$watch(getMatchValue, function () {
                                $ctrl.$$parseAndValidate();
                            });
                            $ctrl.$validators.match = function () {
                                var match = getMatchValue();
                                if (caselessGetter($scope) && angular.isString(match) && angular.isString($ctrl.$viewValue)) {
                                    return $ctrl.$viewValue.toLowerCase() === match.toLowerCase();
                                }
                                if (unMatch($scope) && angular.isString(match) && angular.isString($ctrl.$viewValue)) {
                                    return $ctrl.$viewValue === '' || $ctrl.$viewValue !== match;
                                }
                                return $ctrl.$viewValue === match;
                            };
                            function getMatchValue() {
                                var match = matchGetter($scope);
                                if (angular.isObject(match) && match.hasOwnProperty('$viewValue')) {
                                    match = match.$viewValue;
                                }
                                return match;
                            }
                            /**
                             * Switch the matching field validation to on keyup
                             * By setting attribute ute-match-real-time to true and please make sure
                             * the matching field id attribute is equal to name attribute
                             * usage:
                             * data-ute-match-real-time="true"
                             */
                            if (!angular.isUndefined($attrs.uteMatchRealTime) && $attrs.uteMatchRealTime === 'true') {
                                var _matchingElement = angular.element('#' + matchGetter($scope).$name);
                                _matchingElement.bind('keyup', function () {
                                    $scope.$apply(function () {
                                        $ctrl.$$parseAndValidate();
                                    });
                                });
                                $scope.$on('$destroy', function () {
                                    _matchingElement.unbind('keyup');
                                });
                            }
                        };
                        this.link = this.linkFn;
                    }
                    MatchDirective.factory = function () {
                        var directive = function ($parse) { return new MatchDirective($parse); };
                        directive.$inject = ['$parse'];
                        return directive;
                    };
                    return MatchDirective;
                }());
                angular
                    .module('ute.common.component.directives')
                    .directive('uteMatch', MatchDirective.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var EnterAsTabDirective = (function () {
                    function EnterAsTabDirective() {
                        this.restrict = 'A';
                        this.scope = {
                            nextElement: '@'
                        };
                        this.linkFn = function (scope, elementInstance, attributesInstance, ctrl) {
                            /**
                             * bind keydown event to element
                             */
                            elementInstance.bind('keydown', function (e) {
                                var code = e.keyCode || e.which;
                                /**
                                 * Only for Enter keypress
                                 */
                                if (code === 13) {
                                    e.preventDefault();
                                    /**
                                     * Use nextElement as a target element
                                     */
                                    if (!angular.isUndefined(attributesInstance.nextElement)) {
                                        var targetElement = angular.element('#' + attributesInstance.nextElement);
                                        targetElement.select();
                                        targetElement.focus();
                                    }
                                    else {
                                        elementInstance.next().focus();
                                    }
                                }
                            });
                            /**
                             * unbind keydown event from element
                             */
                            scope.$on('$destroy', function () {
                                elementInstance.unbind('keydown');
                            });
                        };
                        this.link = this.linkFn;
                    }
                    EnterAsTabDirective.factory = function () {
                        var directive = function () { return new EnterAsTabDirective(); };
                        return directive;
                    };
                    return EnterAsTabDirective;
                }());
                angular.module('ute.common.component.directives').directive('uteEnterAsTab', EnterAsTabDirective.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var FloatingLiveChatDirective = (function () {
                    function FloatingLiveChatDirective() {
                        this.restrict = 'E';
                        this.templateUrl = 'module/floatingLiveChat/floatingLiveChat.view.html';
                        // controller: string = 'floatingLiveChatCtrl';
                        // controllerAs: string = 'floatingLiveChat';
                        this.bindToController = true;
                        this.scope = {
                            cbid: '=',
                            boldChatDiv: '=',
                            chatButton: '=',
                            snapMobileTo: '@'
                        };
                    }
                    FloatingLiveChatDirective.factory = function () {
                        var directive = function () { return new FloatingLiveChatDirective(); };
                        return directive;
                    };
                    return FloatingLiveChatDirective;
                }());
                angular.module('ute.common.component.directives').directive('uteFloatingLiveChat', FloatingLiveChatDirective.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var Test = (function (_super) {
                    __extends(Test, _super);
                    function Test() {
                        _super.call(this);
                        this.scope = {
                            states: '@'
                        };
                        this.controller = Controller;
                    }
                    Test.factory = function () {
                        return function () { return new Test(); };
                    };
                    return Test;
                }(directives.TestAbstract));
                var Controller = (function (_super) {
                    __extends(Controller, _super);
                    /* @ngInject */
                    function Controller(routerHelper) {
                        var _this = this;
                        _super.call(this, routerHelper);
                        this.test = function () { return _.include(_this.statesArray, _.get(_this.routerHelper.getCurrentState(), 'name')); };
                    }
                    Controller.$inject = ['ute.blocks.router'];
                    return Controller;
                }(directives.ControllerAbstract));
                /**
                 * <ute-if-in-any-routing-state states='state1,state2'> directive
                 */
                angular.module('ute.common.component.directives').directive('uteIfInAnyRoutingState', Test.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var Test = (function (_super) {
                    __extends(Test, _super);
                    function Test() {
                        _super.call(this);
                        this.scope = {
                            states: '@'
                        };
                        this.controller = Controller;
                    }
                    Test.factory = function () {
                        return function () { return new Test(); };
                    };
                    return Test;
                }(directives.TestAbstract));
                var Controller = (function (_super) {
                    __extends(Controller, _super);
                    /* @ngInject */
                    function Controller(routerHelper) {
                        var _this = this;
                        _super.call(this, routerHelper);
                        this.test = function () { return !_.include(_this.statesArray, _.get(_this.routerHelper.getCurrentState(), 'name')); };
                    }
                    Controller.$inject = ['ute.blocks.router'];
                    return Controller;
                }(directives.ControllerAbstract));
                /**
                 * <ute-if-not-in-any-routing-state states='state1,state2'> directive
                 */
                angular.module('ute.common.component.directives').directive('uteIfNotInAnyRoutingState', Test.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var NotificationBannerController = (function () {
                    function NotificationBannerController(notificationBannerService) {
                        this.notificationBannerService = notificationBannerService;
                        notificationBannerService.cleanReadMessages();
                        notificationBannerService.markMessagesAsRead();
                    }
                    NotificationBannerController.prototype.getMessages = function () {
                        return this.notificationBannerService.getMessages();
                    };
                    NotificationBannerController.$inject = ['ute.notificationBanner.service'];
                    return NotificationBannerController;
                }());
                directives.NotificationBannerController = NotificationBannerController;
                angular
                    .module('ute.common.component.directives')
                    .controller('ute.notificationBanner.controller', NotificationBannerController);
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var NotificationBannerDirective = (function () {
                    function NotificationBannerDirective() {
                        this.restrict = 'E';
                        this.controller = 'ute.notificationBanner.controller';
                        this.controllerAs = 'notificationBanner';
                        this.bindToController = true;
                        this.templateUrl = 'module/notificationBanner/notificationBanner.view.html';
                    }
                    NotificationBannerDirective.factory = function () {
                        var directive = function () { return new NotificationBannerDirective(); };
                        return directive;
                    };
                    return NotificationBannerDirective;
                }());
                angular
                    .module('ute.common.component.directives')
                    .directive('uteNotificationBanner', NotificationBannerDirective.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                // currently only succes being used, add more templates if needed
                (function (NotificationMessageType) {
                    NotificationMessageType[NotificationMessageType["SUCCESS"] = 0] = "SUCCESS";
                    NotificationMessageType[NotificationMessageType["INFO"] = 1] = "INFO";
                    NotificationMessageType[NotificationMessageType["WARNING"] = 2] = "WARNING";
                    NotificationMessageType[NotificationMessageType["ERROR"] = 3] = "ERROR";
                })(directives.NotificationMessageType || (directives.NotificationMessageType = {}));
                var NotificationMessageType = directives.NotificationMessageType;
                var NotificationBannerService = (function () {
                    function NotificationBannerService() {
                        this.notificationMessages = [];
                    }
                    NotificationBannerService.prototype.sendMessage = function (message) {
                        var messageIndex = _.findIndex(this.notificationMessages, { id: message.id });
                        // defaulting message to success type
                        if (!message.type) {
                            message = angular.extend({ type: NotificationMessageType.SUCCESS }, message);
                        }
                        message = angular.extend({ template: NotificationMessageType[message.type] }, message);
                        if (messageIndex > -1) {
                            this.notificationMessages[messageIndex] = message;
                            return;
                        }
                        this.notificationMessages = this.notificationMessages.concat([message]);
                    };
                    NotificationBannerService.prototype.cleanMessage = function (id) {
                        this.notificationMessages = _.filter(this.notificationMessages, function (message) { return id !== message.id; });
                    };
                    NotificationBannerService.prototype.getMessages = function () {
                        return this.notificationMessages;
                    };
                    NotificationBannerService.prototype.cleanAllMessages = function () {
                        this.notificationMessages = [];
                    };
                    NotificationBannerService.prototype.markMessagesAsRead = function () {
                        this.notificationMessages = this.notificationMessages.map(function (message) {
                            message.hasBeenRead = true;
                            return message;
                        });
                    };
                    NotificationBannerService.prototype.cleanReadMessages = function () {
                        this.notificationMessages = this.notificationMessages.filter(function (message) { return !message.hasBeenRead; });
                    };
                    return NotificationBannerService;
                }());
                directives.NotificationBannerService = NotificationBannerService;
                angular
                    .module('ute.common.component.directives')
                    .service('ute.notificationBanner.service', NotificationBannerService);
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var AddToCalendarController = (function () {
                    function AddToCalendarController($scope, $window, browserService, dataLayerService, $timeout, languageSwitcher) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$window = $window;
                        this.browserService = browserService;
                        this.dataLayerService = dataLayerService;
                        this.$timeout = $timeout;
                        this.languageSwitcher = languageSwitcher;
                        this.buildUrl = function () {
                            var isEnglish, androidLabel;
                            isEnglish = _this.languageSwitcher.getCurrentLanguage() === 'en';
                            androidLabel = isEnglish ? 'Android Calendar' : 'Calendrier Android';
                            _this.$timeout(function () {
                                _this.calendarUrl = [
                                    { url: _this.getGoogleCalendarUrl(), label: isEnglish ? 'Google Calendar' : 'Calendrier Google' },
                                    { url: _this.getYahooCalendarUrl(), label: isEnglish ? 'Yahoo Calendar' : 'Calendrier Yahoo' },
                                    { url: _this.getMicrosoftCalendarUrl(), label: isEnglish ? 'Microsoft Calendar' : 'Calendrier Microsoft ' }
                                ];
                                if (!_this.browserService.isIOS() || !_this.isChrome) {
                                    _this.calendarUrl.splice(0, 0, {
                                        url: _this.getIcsFileUrl(),
                                        label: _this.browserService.isAndroid() ? androidLabel : 'iCalendar'
                                    });
                                    _this.calendarUrl.splice(2, 0, {
                                        url: _this.getIcsFileUrl(),
                                        label: isEnglish ? 'Outlook Calendar' : 'Calendrier Outlook'
                                    });
                                }
                            });
                        };
                        this.getGoogleCalendarUrl = function () {
                            var googleCalendarUrl = 'https://www.google.com/calendar/render?action=TEMPLATE';
                            googleCalendarUrl += '&text=' + _this.$scope.title;
                            googleCalendarUrl += '&dates=' + _this.$scope.startDate + '/' + _this.$scope.endDate;
                            googleCalendarUrl += '&details=' + _this.$scope.description;
                            googleCalendarUrl += '&location=' + _this.$scope.location;
                            return encodeURI(googleCalendarUrl);
                        };
                        this.languageSwitcher.registerOnDataChangeHandler(this.buildUrl, 'addToCalendarControllerLangSub');
                        this.isChrome = !!window.navigator.userAgent.match('CriOS');
                        $scope.$on('$destroy', function () {
                            _this.languageSwitcher.unregisterOnDataChangeHandler('addToCalendarControllerLangSub');
                        });
                        this.buildUrl();
                    }
                    AddToCalendarController.prototype.trackCalType = function (calendar) {
                        this.dataLayerService.track({
                            selfServe: {
                                type: 'inquiry',
                                name: 'add to calendar - ' + calendar.label
                            }
                        }, false, [0, 1, 4], { mappingKey: 'addToCalendar.complete' });
                        this.$window.open(calendar.url, '_blank');
                    };
                    AddToCalendarController.prototype.getIcsFileUrl = function () {
                        return '/web/totes/api/v1/addToCalendar/' +
                            this.$scope.startDate +
                            '/' + this.$scope.endDate +
                            '/' + this.b64EncodeUnicode(this.$scope.location) +
                            '/' + this.b64EncodeUnicode(this.$scope.title) +
                            '/' + this.b64EncodeUnicode(this.$scope.description);
                    };
                    AddToCalendarController.prototype.getMicrosoftCalendarUrl = function () {
                        var microsoftCalendarUrl = 'https://outlook.live.com/owa/?path=/calendar/action/compose&rru=addevent&allday=false';
                        microsoftCalendarUrl += '&subject=' + this.$scope.title;
                        microsoftCalendarUrl += '&startdt=' + this.$scope.startDate + '&enddt=' + this.$scope.endDate;
                        microsoftCalendarUrl += '&body=' + this.$scope.description;
                        microsoftCalendarUrl += '&location=' + this.$scope.location;
                        return encodeURI(microsoftCalendarUrl);
                    };
                    AddToCalendarController.prototype.getYahooCalendarUrl = function () {
                        var yahooCalendarUrl = 'http://calendar.yahoo.com/?v=60&view=d&type=20';
                        var duration = this.getTimeDuration(this.$scope.startDate, this.$scope.endDate);
                        yahooCalendarUrl += '&TITLE=' + this.$scope.title;
                        yahooCalendarUrl += '&ST=' + this.$scope.startDate + '&DUR=' + duration;
                        yahooCalendarUrl += '&DESC=' + this.$scope.description;
                        yahooCalendarUrl += '&in_loc=' + this.$scope.location;
                        return encodeURI(yahooCalendarUrl);
                    };
                    AddToCalendarController.prototype.b64EncodeUnicode = function (str) {
                        //https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding
                        // first we use encodeURIComponent to get percent-encoded UTF-8,
                        // then we convert the percent encodings into raw bytes which
                        // can be fed into btoa.
                        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
                            var charCode = parseInt('0x' + p1, 16);
                            return String.fromCharCode(charCode);
                        }));
                    };
                    AddToCalendarController.prototype.getTimeDuration = function (start, end) {
                        var startMoment = moment(start, 'YYYYMMDDThhmmssZ'); //todays date
                        var endMoment = moment(end, 'YYYYMMDDThhmmssZ'); // another date
                        var duration = moment.duration(endMoment.diff(startMoment));
                        var minutes = duration.asMinutes();
                        return this.pad(Math.floor(minutes / 60)).toString() + this.pad(minutes % 60).toString();
                    };
                    AddToCalendarController.prototype.pad = function (n) {
                        return (n < 10) ? ('0' + n) : n;
                    };
                    AddToCalendarController.$inject = ['$scope',
                        '$window',
                        'ute.common.core.browser.service',
                        'ute.datalayer.common.service',
                        '$timeout',
                        'ute.blocks.language.switcher'];
                    return AddToCalendarController;
                }());
                directives.AddToCalendarController = AddToCalendarController;
                angular
                    .module('ute.common.component.directives')
                    .controller('ute.addToCalendar.controller', AddToCalendarController);
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var UteAddToCalendar = (function () {
                    /* @ngInject */
                    function UteAddToCalendar(browserService, $compile) {
                        this.browserService = browserService;
                        this.$compile = $compile;
                        this.restrict = 'E';
                        this.templateUrl = 'module/uteAddToCalendar/uteAddToCalendar.view.html';
                        this.controllerAs = 'ctrl';
                        this.scope = {
                            startDate: '@',
                            endDate: '@',
                            title: '@',
                            dropdownTitle: '@',
                            description: '@',
                            location: '@',
                            className: '@',
                            btnText: '@',
                            caret: '@',
                            hoverText: '@',
                            format: '@'
                        };
                        this.linkFn = function (scope, element) {
                            var detachedAddToCalendarOptions = element.find('ul.dropdown-menu').addClass('detached-addtocalendar-options ng-hide');
                            var bodyElement = angular.element('body');
                            var backdrop = angular.element('<div class="addtocalendar-backdrop"></div>').addClass('ng-hide');
                            bodyElement.append(backdrop);
                            bodyElement.append(detachedAddToCalendarOptions);
                            var clickListener = function () {
                                detachedAddToCalendarOptions.toggleClass('ng-hide');
                                backdrop.toggleClass('ng-hide');
                                bodyElement.toggleClass('modal-open');
                            };
                            element.on('click', clickListener);
                            detachedAddToCalendarOptions.find('li.calendars-title img').on('click', clickListener);
                            scope.$on('$destroy', function () {
                                element.off('click', clickListener);
                                detachedAddToCalendarOptions.find('li.calendars-title img').off('click', clickListener);
                                detachedAddToCalendarOptions = null;
                                bodyElement = null;
                                backdrop = null;
                            });
                        };
                        this.link = this.linkFn;
                        this.controller = 'ute.addToCalendar.controller';
                    }
                    UteAddToCalendar.factory = function () {
                        var directive = function (browserService, $compile) { return new UteAddToCalendar(browserService, $compile); };
                        directive.$inject = ['ute.common.core.browser.service', '$compile'];
                        return directive;
                    };
                    return UteAddToCalendar;
                }());
                angular.module('ute.common.component.directives').directive('uteAddToCalendar', UteAddToCalendar.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var component;
        (function (component) {
            var directives;
            (function (directives) {
                'use strict';
                var PayNowScrollDown = (function () {
                    /* @ngInject */
                    function PayNowScrollDown(browserService) {
                        this.browserService = browserService;
                        this.restrict = 'A';
                        this.scope = {
                            uteScrollIsActive: '=',
                            uteScrollSelector: '@',
                            uteScrollTarget: '=',
                            uteScrollSpeed: '@'
                        };
                        this.linkFn = function (scope, element) {
                            element.on('click', function () {
                                if (scope.uteScrollIsActive) {
                                    setTimeout(function () {
                                        $(scope.uteScrollSelector).animate({
                                            scrollTop: scope.uteScrollTarget
                                        }, scope.uteScrollSpeed);
                                    });
                                }
                            });
                        };
                        this.link = this.linkFn;
                    }
                    PayNowScrollDown.factory = function () {
                        var directive = function (browserService) { return new PayNowScrollDown(browserService); };
                        directive.$inject = ['ute.common.core.browser.service'];
                        return directive;
                    };
                    return PayNowScrollDown;
                }());
                angular.module('ute.common.component.directives').directive('uteScroll', PayNowScrollDown.factory());
            })(directives = component.directives || (component.directives = {}));
        })(component = common.component || (common.component = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            'use strict';
            var RogersCookies = (function () {
                function RogersCookies() {
                }
                RogersCookies.SM_USERNOTFOUND = 'SM_USERNOTFOUND';
                //static SM_USERAUTHENTICATED = 'SM_USERAUTHENTICATED';
                RogersCookies.SMTRYNO = 'SMTRYNO';
                RogersCookies.SM_USER = 'SM_USER';
                RogersCookies.SMLOCK = 'SMLOCK';
                //static SMSESSION = 'SMSESSION';
                RogersCookies.SM_QUERY_STRING = 'SM_QUERY_STRING';
                RogersCookies.LANGUAGE = 'language';
                RogersCookies.ROGERS_LEGACY_DEEP_LINK = 'deepJSON';
                return RogersCookies;
            }());
            core.RogersCookies = RogersCookies;
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var CurrencyDirective = (function () {
                    function CurrencyDirective($filter, $locale) {
                        var _this = this;
                        this.$filter = $filter;
                        this.$locale = $locale;
                        this.restrict = 'A';
                        this.require = 'ngModel';
                        this.bindToController = true;
                        this.linkFn = function (scope, element, attributes, controller) {
                            var hardCap, min, max, currencySymbol, ngRequired;
                            var active = true;
                            var fraction = 2;
                            var reformat = function (oldDecimalSep) {
                                oldDecimalSep = oldDecimalSep || '.';
                                if (active) {
                                    var value = void 0;
                                    if (controller.$options && controller.$options.updateOn === 'blur') {
                                        value = controller.$viewValue;
                                        if (oldDecimalSep) {
                                            value = String(value).replace(oldDecimalSep, _this.$locale.NUMBER_FORMATS.DECIMAL_SEP);
                                        }
                                        for (var i = controller.$parsers.length - 1; i >= 0; i--) {
                                            value = controller.$parsers[i](value);
                                        }
                                    }
                                    else {
                                        value = controller.$$rawModelValue;
                                        if (oldDecimalSep) {
                                            value = String(value).replace(oldDecimalSep, _this.$locale.NUMBER_FORMATS.DECIMAL_SEP);
                                        }
                                    }
                                    for (var i = controller.$formatters.length - 1; i >= 0; i--) {
                                        value = controller.$formatters[i](value);
                                    }
                                    controller.$viewValue = value;
                                    controller.$render();
                                }
                            };
                            var keepInRange = function (value) {
                                if (hardCap) {
                                    value = String(value);
                                    value = value.replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                    if (max !== undefined && value > max) {
                                        value = max;
                                    }
                                    else if (min !== undefined && value < min) {
                                        value = min;
                                    }
                                    value = value.replace('.', _this.$locale.NUMBER_FORMATS.DECIMAL_SEP);
                                }
                                return value;
                            };
                            var revalidate = function () {
                                controller.$validate();
                                if (active) {
                                    var value = keepInRange(controller.$$rawModelValue);
                                    if (value !== controller.$$rawModelValue) {
                                        value = value.replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                        controller.$setViewValue(String(value.toFixed(fraction)).replace('.', _this.$locale.NUMBER_FORMATS.DECIMAL_SEP));
                                        controller.$commitViewValue();
                                        reformat();
                                    }
                                }
                            };
                            var getCurrencySymbol = function () {
                                return currencySymbol === undefined ? _this.$locale.NUMBER_FORMATS.CURRENCY_SYM : currencySymbol;
                            };
                            attributes.$observe('uteCurrency', function (value) {
                                active = (value !== 'false');
                                if (active) {
                                    reformat();
                                }
                                else {
                                    controller.$viewValue = controller.$$rawModelValue;
                                    controller.$render();
                                }
                            });
                            attributes.$observe('hardCap', function (value) {
                                hardCap = (value === 'true');
                                revalidate();
                            });
                            attributes.$observe('min', function (value) {
                                min = value ? Number(value) : undefined;
                                revalidate();
                            });
                            attributes.$observe('max', function (value) {
                                max = value ? Number(value) : undefined;
                                revalidate();
                            });
                            attributes.$observe('currencySymbol', function (value) {
                                currencySymbol = value;
                                reformat();
                            });
                            attributes.$observe('ngRequired', function (value) {
                                ngRequired = value;
                                revalidate();
                            });
                            attributes.$observe('fraction', function (value) {
                                fraction = value || 2;
                                reformat();
                                revalidate();
                            });
                            scope.$watch(function () {
                                return _this.$locale.NUMBER_FORMATS.DECIMAL_SEP;
                            }, function (newVal, oldVal) {
                                if (newVal !== oldVal) {
                                    reformat(oldVal);
                                }
                            });
                            controller.$parsers.push(function (value) {
                                if (active && [undefined, null, ''].indexOf(value) === -1) {
                                    var dec = _this.$locale.NUMBER_FORMATS.DECIMAL_SEP;
                                    var rx = new RegExp('[^0-9' + dec + ']', 'g');
                                    value = value.replace(rx, '');
                                    var valParts = value.split(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP);
                                    if (valParts.length >= 2) {
                                        var decimalPart = valParts[1];
                                        if (decimalPart.length > fraction) {
                                            decimalPart = decimalPart.substring(0, fraction);
                                        }
                                        value = valParts[0] + _this.$locale.NUMBER_FORMATS.DECIMAL_SEP + decimalPart;
                                    }
                                    if (controller.$viewValue !== value) {
                                        controller.$setViewValue(value);
                                        controller.$render();
                                    }
                                    /**
                                     * Keep the return value as a valid numnber
                                     */
                                    if (value.indexOf(',') >= 0) {
                                        value = parseFloat(value.replace(/,/g, '.'));
                                    }
                                    else {
                                        value = parseFloat(value);
                                    }
                                    return value;
                                }
                                return value;
                            });
                            controller.$formatters.push(function (value) {
                                if (active && [undefined, null, ''].indexOf(value) === -1) {
                                    value = String(value);
                                    value = value.replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                    return _this.$filter('currency')(value, getCurrencySymbol(), fraction);
                                }
                                return value;
                            });
                            controller.$validators.min = function (value) {
                                value = String(value).replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                if (!ngRequired && ([undefined, null, ''].indexOf(value) !== -1 || isNaN(value))) {
                                    return true;
                                }
                                return !active ||
                                    [undefined, null].indexOf(min) !== -1 || isNaN(min) ||
                                    value >= min;
                            };
                            controller.$validators.max = function (value) {
                                value = String(value).replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                if (!ngRequired && ([undefined, null, ''].indexOf(value) !== -1 || value)) {
                                    return true;
                                }
                                return !active ||
                                    [undefined, null].indexOf(max) !== -1 || isNaN(max) ||
                                    value <= max;
                            };
                            controller.$validators.fraction = function (value) {
                                value = String(value).replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                return !active || !value || !isNaN(value.replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.'));
                            };
                            element.bind('focus', function () {
                                if (active) {
                                    var groupRegex = new RegExp("\\" + _this.$locale.NUMBER_FORMATS.GROUP_SEP, 'g');
                                    var value = void 0;
                                    if ([undefined, null, ''].indexOf(controller.$$rawModelValue) === -1) {
                                        value = String(controller.$$rawModelValue).replace(_this.$locale.NUMBER_FORMATS.DECIMAL_SEP, '.');
                                        value = _this.$filter('number')(value, fraction).replace(groupRegex, '');
                                    }
                                    else {
                                        value = controller.$$rawModelValue;
                                    }
                                    if ([undefined, null, ''].indexOf(value) === -1) {
                                        value = value.replace('.', _this.$locale.NUMBER_FORMATS.DECIMAL_SEP);
                                    }
                                    if (controller.$viewValue !== value) {
                                        controller.$viewValue = value;
                                        controller.$render();
                                        element.triggerHandler('focus');
                                    }
                                }
                            });
                            element.bind('blur', reformat);
                        };
                        this.link = this.linkFn;
                    }
                    CurrencyDirective.factory = function () {
                        var directive = function ($filter, $locale) { return new CurrencyDirective($filter, $locale); };
                        directive.$inject = ['$filter', '$locale'];
                        return directive;
                    };
                    return CurrencyDirective;
                }());
                angular.module('ute.common.decorator.directives').directive('uteCurrency', CurrencyDirective.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var CurrencyInputDirective = (function () {
                    // static $inject: Array<string> = ['$filter', '$browser', '$injector'];
                    function CurrencyInputDirective($filter, $browser, languageSwitcher) {
                        var _this = this;
                        this.$filter = $filter;
                        this.$browser = $browser;
                        this.languageSwitcher = languageSwitcher;
                        this.restrict = 'A';
                        this.require = 'ngModel';
                        this.bindToController = true;
                        this.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                            instanceElement.addClass('currencyInput');
                            var languageSettings = [
                                {
                                    lang: 'en',
                                    prefix: '$',
                                    decimalDelimiter: '.',
                                    thousandsDelimiter: ',',
                                    suffix: ''
                                }, {
                                    lang: 'fr',
                                    prefix: '',
                                    decimalDelimiter: ',',
                                    thousandsDelimiter: ' ',
                                    suffix: ' $'
                                }
                            ];
                            var selectedLanguageSetting = _.find(languageSettings, { 'lang': _this.languageSwitcher.getCurrentLanguage() });
                            var maxDecimals = 2;
                            var decimalEntered = false;
                            var parse = function (inputText) {
                                inputText = inputText.split(selectedLanguageSetting.thousandsDelimiter).join('').split(selectedLanguageSetting.decimalDelimiter).join('.').split(selectedLanguageSetting.prefix).join('').split(selectedLanguageSetting.suffix).join('').split('$').join('');
                                return inputText;
                            };
                            var listener = function (e, reset) {
                                var key = e ? e.which : 0;
                                var decimals = 0;
                                if (!reset) {
                                    if (key === 0 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                                        return;
                                    }
                                    if (key === 8 && instanceElement.val().length === 1) {
                                        return;
                                    }
                                }
                                if (instanceElement.val().indexOf(selectedLanguageSetting.decimalDelimiter) > -1) {
                                    decimals = instanceElement.val().substr(instanceElement.val().indexOf(selectedLanguageSetting.decimalDelimiter, 0), instanceElement.val().length).length - 1;
                                    decimals = decimals - selectedLanguageSetting.suffix.length;
                                    decimals = decimals > maxDecimals ? maxDecimals : decimals;
                                }
                                if (key === 110) {
                                    //decimal pressed
                                    return;
                                }
                                else {
                                    var value = parse(instanceElement.val());
                                    if (decimalEntered) {
                                        decimalEntered = false;
                                        return;
                                    }
                                    /**
                                     * update language setting based on selected language
                                     */
                                    selectedLanguageSetting = _.find(languageSettings, { 'lang': _this.languageSwitcher.getCurrentLanguage() });
                                    instanceElement.val(_this.$filter('currencies')(value, _this.languageSwitcher.getCurrentLanguage(), undefined, decimals));
                                    var caretPos = instanceElement.val().length - selectedLanguageSetting.suffix.length;
                                    instanceElement[0].setSelectionRange(caretPos, caretPos);
                                }
                                console.log('');
                            };
                            var updateLanguage = function () {
                                listener(null, true);
                            };
                            // This runs when we update the text field
                            controller.$parsers.push(parse);
                            // This runs when the model gets updated on the scope directly and keeps our view in sync
                            controller.$render = function () {
                                if (controller.$viewValue) {
                                    var decimals = 0;
                                    if (controller.$viewValue.indexOf('.') > -1) {
                                        decimals = controller.$viewValue.substr(controller.$viewValue.indexOf('.', 0), controller.$viewValue.length).length - 1;
                                        decimals = decimals > maxDecimals ? maxDecimals : decimals;
                                    }
                                    instanceElement.val(_this.$filter('currencies')(parse(controller.$viewValue), _this.languageSwitcher.getCurrentLanguage(), undefined, decimals));
                                }
                            };
                            instanceElement.bind('keyup', listener);
                            instanceElement.bind('keypress', function (event) {
                                var key = event.which;
                                // If the keys include the CTRL, SHIFT, ALT, or META keys, or the arrow keys, do nothing.
                                // This lets us support copy and paste too
                                if (key === 0 || key === 8 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                                    event.preventDefault();
                                    return;
                                }
                                // ignore all other keys which we do not need
                                if (String.fromCharCode(key) !== selectedLanguageSetting.thousandsDelimiter &&
                                    String.fromCharCode(key) !== selectedLanguageSetting.decimalDelimiter &&
                                    String.fromCharCode(key) !== selectedLanguageSetting.prefix &&
                                    String.fromCharCode(key) !== selectedLanguageSetting.suffix &&
                                    !(48 <= key && key <= 57) &&
                                    String.fromCharCode(key) !== '-') {
                                    event.preventDefault();
                                    return;
                                }
                                if (String.fromCharCode(key) === selectedLanguageSetting.decimalDelimiter) {
                                    decimalEntered = true;
                                }
                                _this.$browser.defer(listener); // Have to do this or changes don't get picked up properly
                            });
                            _this.languageSwitcher.registerOnDataChangeHandler(updateLanguage, 'languageSwitcherDataHandlerTest');
                        };
                        this.link = this.linkFn;
                    }
                    CurrencyInputDirective.factory = function () {
                        var directive = function ($filter, $browser, languageSwitcher) { return new CurrencyInputDirective($filter, $browser, languageSwitcher); };
                        directive.$inject = ['$filter', '$browser', 'ute.blocks.language.switcher'];
                        return directive;
                    };
                    return CurrencyInputDirective;
                }());
                angular.module('ute.common.decorator.directives').directive('uteCurrencyInput', CurrencyInputDirective.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var ModalInputFocusOnClick = (function () {
                    ///* @ngInject */
                    function ModalInputFocusOnClick() {
                        this.restrict = 'A';
                        this.link = this.linkFn;
                    }
                    ModalInputFocusOnClick.factory = function () {
                        var directive = function () { return new ModalInputFocusOnClick(); };
                        return directive;
                    };
                    ModalInputFocusOnClick.prototype.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                        instanceElement.bind('click', function (evt) {
                            console.log('setFocus to click event', evt);
                            evt.preventDefault();
                            evt.stopPropagation();
                            evt.target.focus();
                        });
                    };
                    return ModalInputFocusOnClick;
                }());
                angular.module('ute.common.decorator.directives').directive('uteModalInputFocusOnClick', ModalInputFocusOnClick.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var NumbersOnlyInput = (function () {
                    /* @ngInject */
                    function NumbersOnlyInput() {
                        this.require = 'ngModel';
                        this.link = this.linkFn;
                        //console.log('NumbersOnlyInput->constructor', $translate);
                    }
                    NumbersOnlyInput.factory = function () {
                        var directive = function () { return new NumbersOnlyInput(); };
                        //directive.$inject = ['$translate'];
                        return directive;
                    };
                    NumbersOnlyInput.prototype.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                        function inputFromUser(text) {
                            if (text) {
                                var transformedInput = text.replace(/[^0-9]/g, '');
                                if (transformedInput !== text) {
                                    controller.$setViewValue(transformedInput);
                                    controller.$render();
                                }
                                return transformedInput;
                            }
                            return undefined;
                        }
                        controller.$parsers.push(inputFromUser);
                    };
                    return NumbersOnlyInput;
                }());
                angular.module('ute.common.decorator.directives').directive('uteNumbersOnlyInput', NumbersOnlyInput.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var decorator;
        (function (decorator) {
            var directives;
            (function (directives) {
                'use strict';
                var PositiveAmountDirective = (function () {
                    // static $inject: Array<string> = ['$filter', '$browser', '$injector'];
                    function PositiveAmountDirective() {
                        this.restrict = 'A';
                        this.require = 'ngModel';
                        this.bindToController = true;
                        this.linkFn = function (scope, instanceElement, instanceAttributes, controller, transclude) {
                            instanceElement.bind('keypress', function (event) {
                                var key = event.which;
                                if (key !== 8 && key !== 0 && (key < 48 || key > 57) && key !== 44 && key !== 46) {
                                    event.preventDefault();
                                    return false;
                                }
                            });
                        };
                        this.link = this.linkFn;
                    }
                    PositiveAmountDirective.factory = function () {
                        var directive = function () { return new PositiveAmountDirective(); };
                        directive.$inject = [];
                        return directive;
                    };
                    return PositiveAmountDirective;
                }());
                angular.module('ute.common.decorator.directives').directive('utePositiveAmountOnly', PositiveAmountDirective.factory());
            })(directives = decorator.directives || (decorator.directives = {}));
        })(decorator = common.decorator || (common.decorator = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('uteCanadianDate', uteCanadianDate);
            uteCanadianDate.$inject = ['$filter', 'ute.blocks.language.switcher'];
            function uteCanadianDate($filter, languageSwitcher) {
                customFilter.$stateful = true;
                function customFilter(input, formatObj) {
                    var language = languageSwitcher.getCurrentLanguage();
                    var format = (language === 'fr') ? 'dd MMM yyyy' : 'MMM dd, yyyy'; //default values
                    if (formatObj && formatObj[language]) {
                        format = formatObj[language];
                    }
                    var formattedDate = $filter('date')(input, format);
                    if (language === 'fr') {
                        //As a biz requirement, only first day of each month should be displayed as "1er" for french. - if the pattern starts with day
                        var day = parseInt(formattedDate.slice(0, 2));
                        if (day === 1 && format[0] === 'd') {
                            formattedDate = '1 <sup>er</sup>' + formattedDate.substr(2);
                        }
                    }
                    return formattedDate;
                }
                return customFilter;
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('ute_common_filter_data_conversion', dataConversion); // split a phone number and format it like this (416) 555-5656
            /**
             *
             * @returns {function(number, string, number, boolean): string}
             */
            dataConversion.$inject = ['$filter'];
            function dataConversion($filter) {
                return function (input, format, base, decimals, showUnit, showUnitOnly) {
                    var units = ['kb', 'mb', 'gb', 'tb'], index = units.indexOf(format), data = input, finalUnit = units[index], decimalFactor = Math.pow(10, decimals);
                    for (index; index < units.length; index++) {
                        if (data >= base) {
                            data = data / base;
                        }
                        else {
                            finalUnit = units[index];
                            break;
                        }
                    }
                    var outputAmount = $filter('number')(Math.round(data * (decimalFactor)) / decimalFactor, decimals);
                    var outputUnit = (showUnit ? ($filter('translate')('ute.commonFilters.dataConversion.' + finalUnit)) : '');
                    var output = '';
                    if (showUnitOnly) {
                        output = outputUnit;
                    }
                    else {
                        output = outputAmount + outputUnit;
                    }
                    return output;
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter')
                .filter('ute_common_filter_language_date', languageDate);
            /**
             * Convert YYYY-MM-DD to long date format based on language
             * @returns {function(string): string}
             *
             * Business Requirements
             * |----------------------|----------------------|----------------------|
             * |        input         |    current lang      |   Expected Result    |
             * |----------------------|----------------------|----------------------|
             * | 2016-10-25           |          en          |  October 25, 2016    |
             * | 2016-10-25           |          fr          |   25 octobre 2016    |
             * |----------------------|----------------------|----------------------|
             */
            languageDate.$inject = ['$filter', '$translate'];
            function languageDate($filter, $translate) {
                return function (input) {
                    /**
                     * inpute validation
                     */
                    if (angular.isUndefined(input) || _.isNull(input)) {
                        return '';
                    }
                    var _date = input.split('-');
                    /**
                     * If input is not in YYYY-MM-DD format then return input
                     */
                    if (_date.length !== 3) {
                        return input;
                    }
                    var p2 = parseInt(_date[1], 10) - 1;
                    var _dateObj = new Date(parseInt(_date[0], 10), p2, parseInt(_date[2], 10));
                    var day = _dateObj.getDate();
                    var month = $filter('date')(_dateObj, 'MMMM');
                    if ($translate.use().indexOf('en', 0) > -1) {
                        input = month + ' ' + day + ', ' + _dateObj.getFullYear();
                    }
                    else {
                        input = day + ' ' + month + ' ' + _dateObj.getFullYear();
                    }
                    return input;
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter')
                .filter('ute_common_filter_language_decimal', languageDecimal);
            /**
             * Limit a string to input number
             * @returns {function(string): string}
             *
             * Business Requirements
             * |----------------------|----------------------|----------------------|
             * |        input         |    decimalDelimiter  |   Expected Result    |
             * |----------------------|----------------------|----------------------|
             * | 123.00               |           .          | .00                  |
             * | 123.456              |           .          | .46                  |
             * |----------------------|----------------------|----------------------|
             */
            function languageDecimal() {
                return function (input, decimalDelimiter) {
                    if (angular.isUndefined(input) || _.isNull(input)) {
                        return '';
                    }
                    /**
                     * Just in case javascript pass a number to this function
                     * then convert it to string before process
                     */
                    if (typeof (input) === 'number') {
                        input = input + '';
                    }
                    /**
                     * Checking if the string contains comma
                     * then remove it
                     */
                    if (input.indexOf(',') >= 0) {
                        input = input.replace(/,/g, '');
                    }
                    /**
                     * convert to 2 decimal string
                     */
                    input = (Math.round(Number(input) * 100) / 100) + '';
                    var decimalPosition = input.toString().lastIndexOf('.');
                    if (decimalPosition > -1) {
                        return (decimalDelimiter + input.toString().substr(decimalPosition + 1, 2)).toString();
                    }
                    else {
                        return (decimalDelimiter + '00').toString();
                    }
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('ute_common_moment_date', momentDate); // return a cross browser friendly date
            /**
             *
             * @returns {function(number, string, number, boolean): string}
             */
            momentDate.$inject = ['$filter', 'moment'];
            function momentDate($filter, angularMoment) {
                return function (text, format) {
                    var moment = angularMoment(text);
                    if (moment.isValid) {
                        var tempdate = new Date(moment);
                        return $filter('date')(tempdate, format);
                    }
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter').filter('ute_common_filter_phone', phone).
                filter('ute_common_filter_phone2', phone2).
                filter('ute_common_filter_phone3', phone3).
                filter('ute_common_filter_phone4_masked', phone4); // split a masked phone number and format it like this 4XX-XXX-5656 DC-1451
            /**
             * Format phone# as '416-123-4567'
             * @returns {function(string): string}
             */
            function phone() {
                return function (input, format) {
                    return formatPhone(input, format || '$1-$2-$3');
                };
            }
            /**
             * Format phone# as '416 123-4567'
             * @returns {function(string): string}
             */
            function phone2() {
                return function (input, format) {
                    return formatPhone(input, format || '$1 $2-$3');
                };
            }
            /**
             * Format phone# as '(416) 123-4567'
             * @returns {function(string): string}
             */
            function phone3() {
                return function (input, format) {
                    return formatPhone(input, format || '($1) $2-$3');
                };
            }
            function phone4() {
                return function (input, format) {
                    return formatPhone2(input, format || '$1-$2-$3');
                };
            }
            /**
             * Format phone# as @param format
             * @param input
             * @param format
             * @returns {string}
             */
            function formatPhone(input, format) {
                if (input && format) {
                    return input.toString().trim().replace(/^\+/, '').replace(/(\d{3})(\d{3})(\d{4})/, format);
                }
                // else will be undefined
            }
            function formatPhone2(input, format) {
                if (input) {
                    var inputStr = input.toString().trim().replace(/^\+/, '');
                    // Split
                    var area = inputStr.slice(0, 3);
                    var trip = inputStr.slice(3, 6);
                    var quad = inputStr.slice(6);
                    // Pretty phone number
                    var retVal = area + '-' + trip + '-' + quad;
                    return (retVal);
                }
                ;
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var filter;
        (function (filter) {
            'use strict';
            angular.module('ute.common.filter')
                .filter('ute_common_filter_string_limit_to', limitTo);
            /**
             * Limit a string to input number
             * @returns {function(string): string}
             *
             * Business Requirements
             * |----------------------|----------------------|----------------------|----------------------|
             * |        input         |     characterLimit   |      isEllipsis      |   Expected Result    |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            12        |         true         | 123456789...         |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            10        |         true         | 1234567...           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678901234567890 |            10        |         false        | 1234567890           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 123456789            |            10        |         false        | 123456789            |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 1234567890           |            10        |         true         | 1234567890           |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 123456789            |            10        |         true         | 123456789            |
             * |----------------------|----------------------|----------------------|----------------------|
             * | 12345678             |            10        |         true         | 12345678             |
             * |----------------------|----------------------|----------------------|----------------------|
             */
            function limitTo() {
                return function (input, characterLimit, isEllipsis) {
                    if (angular.isUndefined(input) || _.isNull(input)) {
                        return '';
                    }
                    isEllipsis = angular.isUndefined(isEllipsis) || _.isNull(isEllipsis) ? true : !!isEllipsis;
                    var hellipLength = 3;
                    if (input.length > characterLimit && isEllipsis === true) {
                        return input.substring(0, (characterLimit - hellipLength)) + '...';
                    }
                    else if (input.length > characterLimit && isEllipsis === false) {
                        return input.substring(0, (characterLimit));
                    }
                    else {
                        return input;
                    }
                };
            }
        })(filter = common.filter || (common.filter = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
                var CommonSelectionModalController = (function () {
                    /* @ngInject */
                    function CommonSelectionModalController($modalInstance, selectionData) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.selectionData = selectionData;
                        this.actionOnClick = function (selectedItem) {
                            if (selectedItem.action) {
                                selectedItem.action();
                            }
                            _this.$modalInstance.dismiss('cancel');
                        };
                        this.cancel = function () {
                            _this.$modalInstance.dismiss('cancel');
                        };
                    }
                    CommonSelectionModalController.$inject = [
                        '$modalInstance',
                        'selectionData'
                    ];
                    CommonSelectionModalController.controllerName = 'ute.common.selection.modal.modal.controller';
                    return CommonSelectionModalController;
                }());
                modal.CommonSelectionModalController = CommonSelectionModalController;
                angular.module('ute.common.selection.modal').controller(CommonSelectionModalController.controllerName, CommonSelectionModalController);
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            applicationId: 'ute-application-id',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF
                        },
                        advanced: {
                            modal: {
                                templateUrl: 'module/commonSeletionModal/common.seletion.modal.view.html',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal'
                            }
                        }
                    };
                }
                modal.DefaultConfigFactory = DefaultConfigFactory;
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var selection;
        (function (selection) {
            var modal;
            (function (modal) {
                'use strict';
                var CommonSelectionServiceProvider = (function () {
                    /* @ngInject */
                    function CommonSelectionServiceProvider() {
                        var _this = this;
                        this.config = modal.DefaultConfigFactory();
                        /* @ngInject */
                        this.$get = function ($injector, $modal, $document) {
                            _this.$modal = $modal;
                            _this.$document = $document;
                            _this.$injector = $injector;
                            return {
                                showSelectionModal: _this.showSelectionModal
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.resetModel = function () {
                            _this.model = {
                                accountList: null
                            };
                        };
                        /**
                         * @returns {INavigationModel}
                         */
                        this.showSelectionModal = function (selectionData) {
                            _this.openModalPopup(selectionData);
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$modal',
                            '$document'
                        ];
                        this.resetModel();
                    }
                    ;
                    CommonSelectionServiceProvider.prototype.openModalPopup = function (selectionData) {
                        this.$modal.open({
                            templateUrl: this.config.advanced.modal.templateUrl,
                            controller: modal.CommonSelectionModalController.controllerName,
                            controllerAs: 'commonSelectionModal',
                            size: this.config.advanced.modal.size,
                            backdrop: this.config.advanced.modal.backdrop,
                            backdropClass: this.config.advanced.modal.backdropClass,
                            resolve: {
                                'selectionData': function () { return selectionData; }
                            }
                        }).result.then(function (result) {
                            // $modal.close() will get into here.
                            console.log('$modal.close.result:', result);
                        }, function (result) {
                            // dismissed here.
                            console.log('$modal.dismiss.result:', result);
                        });
                    };
                    CommonSelectionServiceProvider.$inject = [];
                    return CommonSelectionServiceProvider;
                }());
                angular.module('ute.common.selection.modal').provider('ute.common.selection.modal.service', CommonSelectionServiceProvider);
            })(modal = selection.modal || (selection.modal = {}));
        })(selection = common.selection || (common.selection = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var typescript;
        (function (typescript) {
            var api;
            (function (api) {
                var mixin;
                (function (mixin) {
                    'use strict';
                    var MixinHelper = (function () {
                        function MixinHelper() {
                        }
                        /**
                         * apply Mixins pattern to the derivedCtor class
                         * example:
                         * class SmartObject implements Disposable, Activatable {
                         *   ...
                         * }
                         * applyMixins(SmartObject, [Disposable, Activatable]);
                         *
                         * @param derivedCtor
                         * @param baseCtors
                         */
                        MixinHelper.applyMixins = function (derivedCtor, baseCtors) {
                            baseCtors.forEach(function (baseCtor) {
                                Object.getOwnPropertyNames(baseCtor.prototype).forEach(function (name) {
                                    derivedCtor.prototype[name] = baseCtor.prototype[name];
                                });
                            });
                        };
                        return MixinHelper;
                    }());
                    mixin.MixinHelper = MixinHelper;
                })(mixin = api.mixin || (api.mixin = {}));
            })(api = typescript.api || (typescript.api = {}));
        })(typescript = common.typescript || (common.typescript = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var utils;
        (function (utils) {
            'use strict';
            var UtilsProvider = (function () {
                /* @ngInject */
                function UtilsProvider() {
                    var _this = this;
                    this.config = {}; // defaults
                    /* @ngInject */
                    this.$get = function ($injector) {
                        _this.$window = $injector.get('$window');
                        return {
                            randomString: _this.randomString,
                            parseTimer: _this.parseTimer,
                            formatPhoneNumber: _this.formatPhoneNumber,
                            objectToArray: _this.objectToArray,
                            arrayToObject: _this.arrayToObject,
                            getQuerystringParameter: _this.getQuerystringParameter,
                            calculateAge: _this.calculateAge,
                            isNullOrEmptyObject: _this.isNullOrEmptyObject,
                            isAlphabetOnly: _this.isAlphabetOnly,
                            isAlphanumeric: _this.isAlphanumeric,
                            isNumericOnly: _this.isNumericOnly,
                            stringContains: _this.stringContains,
                            detectBrowser: _this.detectBrowser,
                            getQueryParameters: _this.getQueryParameters,
                            getHomePage: _this.getHomePage,
                            setElementScope: _this.setElementScope
                        };
                    };
                    /**
                     * TODO validation + defaults
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.randomString = function (length, chars) {
                        if (length && chars) {
                            var result = '';
                            for (var i = length; i > 0; --i) {
                                result += chars[Math.floor(Math.random() * chars.length)];
                            }
                            return result;
                        }
                        else {
                            return _this.randomString(32, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
                        }
                    };
                    this.parseTimer = function (t) {
                        var days, hours, minutes, seconds;
                        days = Math.floor(t / 86400);
                        t -= days * 86400;
                        hours = Math.floor(t / 3600) % 24;
                        t -= hours * 3600;
                        minutes = Math.floor(t / 60) % 60;
                        t -= minutes * 60;
                        seconds = t % 60;
                        if (minutes < 10) {
                            minutes = '0' + minutes;
                        }
                        if (seconds < 10) {
                            seconds = '0' + seconds;
                        }
                        return minutes + ":" + seconds;
                    };
                    this.formatPhoneNumber = function (n, regex) {
                        if (n == null) {
                            return n;
                        }
                        if (regex == null) {
                            regex = /[\-\s\.]/g;
                        }
                        return n.replace(regex, '');
                    };
                    this.objectToArray = function (obj) {
                        var arr = [];
                        for (var prop in obj) {
                            if (obj.hasOwnProperty(prop)) {
                                //console.log('o.' + prop + ' = ' + obj[prop]);
                                arr.push(obj[prop]);
                            }
                        }
                        return arr;
                    };
                    this.arrayToObject = function (arr) {
                        var obj = {};
                        arr.forEach(function (el, index) {
                            obj[index] = el;
                        });
                        return obj;
                    };
                    this.getQuerystringParameter = function (name) {
                        var nm = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
                        var regex = new RegExp('[\\?&]' + nm + '=([^&#]*)');
                        var results = regex.exec(location.href.replace('&amp;', '&'));
                        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
                    };
                    this.calculateAge = function (birthDate, currentDate) {
                        var bd = new Date(birthDate);
                        if (currentDate == null) {
                            currentDate = new Date();
                        }
                        var years = (currentDate.getFullYear() - bd.getFullYear());
                        if (currentDate.getMonth() < bd.getMonth() ||
                            currentDate.getMonth() === bd.getMonth() &&
                                currentDate.getDay() < bd.getDay()) {
                            years--;
                        }
                        return years;
                    };
                    // former isUndefinedOrNull
                    this.isNullOrEmptyObject = function (val) {
                        if (angular.isUndefined(val) || val === null) {
                            return true;
                        }
                        var jsonStr;
                        try {
                            jsonStr = angular.toJson(val);
                        }
                        catch (e) {
                            return false;
                        }
                        return jsonStr === '{}';
                    };
                    this.stringContains = function (s, val) {
                        return s.indexOf(val) !== -1;
                    };
                    this.detectBrowser = function () {
                        var ua = navigator.userAgent;
                        var tem;
                        var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                        if (/trident/i.test(M[1])) {
                            tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
                            return {
                                type: 'ie',
                                version: (tem[1] || '')
                            };
                        }
                        if (M[1] === 'Chrome') {
                            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
                            if (tem != null) {
                                return {
                                    type: tem.slice(1).join(' ').replace('OPR', 'Opera'),
                                    version: M[1]
                                };
                            }
                        }
                        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
                        if ((tem = ua.match(/version\/(\d+)/i)) != null) {
                            M.splice(1, 1, tem[1]);
                        }
                        return {
                            type: M[0].toLowerCase(),
                            version: M[1]
                        };
                    };
                    this.isNumericOnly = function (test) {
                        return (/^[0-9]+$/g).test(test);
                    };
                    this.isAlphabetOnly = function (test) {
                        return (/^[a-zA-Z]+$/g).test(test);
                    };
                    this.isAlphanumeric = function (test) {
                        return (/^[a-zA-Z0-9]+$/g).test(test);
                    };
                    /**
                     * Parse location query params and return hashmap
                     *
                     * @example http://example.com/test?lunch=sandwich&dinner=stirfry will return { "lunch": "sandwich", "dinner": "stirfry" }
                     *
                     * @param str
                     * @returns {*}
                     */
                    this.getQueryParameters = function (str) {
                        return _.chain((str || _this.$window.location.search).replace(/(^\?)/, '').split('&')).map(function (params) {
                            var p = params.split('=');
                            return [p[0], angular.isUndefined(p[1]) ? true : p[1]];
                        }).object().value();
                    };
                    this.getHomePage = function () {
                        var wl = _this.$window.location;
                        if (!wl.origin) {
                            // polyfill for IE
                            wl.origin = wl.protocol + '//' + wl.hostname + (wl.port ? ':' + wl.port : '');
                        }
                        return wl.origin;
                    };
                    /**
                     * after setting $compileProvider.debugInfoEnabled(false); we can use the setElementScope method to set a scope on only some specific elements.
                     */
                    this.setElementScope = function (element, scope) {
                        if (element.length > 0) {
                            element[0].scope = function () { return scope; };
                        }
                    };
                    this.$get.$inject = [
                        '$injector'
                    ];
                }
                UtilsProvider.$inject = [];
                UtilsProvider.serviceName = 'ute.common.utils.service';
                return UtilsProvider;
            }());
            angular.module('ute.common.utils').provider(UtilsProvider.serviceName, UtilsProvider);
        })(utils = common.utils || (common.utils = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    angular.module('ute.common.customer.credit.management').run(customerCreditManagementRoutesConfig);
                    customerCreditManagementRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.customer.credit.management.service'];
                    /* @ngInject */
                    function customerCreditManagementRoutesConfig(routerHelper, customerCreditManagementService) {
                        routerHelper.configureStates(getStates(customerCreditManagementService));
                    }
                    function getStates(customerCreditManagementService) {
                        var creditAdjustmentRootState = customerCreditManagementService.getConfig().basic.creditAdjustmentRootState;
                        return [
                            {
                                name: creditAdjustmentRootState,
                                abstract: true,
                                url: '/' + creditAdjustmentRootState,
                                controller: customerCreditManagementService.getConfig().basic.mainControllerName,
                                controllerAs: 'mainCustomerCreditManagement',
                                templateUrl: customerCreditManagementService.getConfig().basic.mainTemplateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] }
                                },
                                resolve: customerCreditManagementService.getConfig().advanced.resolve
                            },
                            {
                                name: customerCreditManagementService.getEntryState(),
                                url: '/' + customerCreditManagementService.getConfig().advanced.displayCreditAdjustmentDetails.subState + '/:id',
                                controller: customerCreditManagementService.getConfig().advanced.displayCreditAdjustmentDetails.controllerName,
                                controllerAs: 'displayCustomerCreditManagement',
                                templateUrl: customerCreditManagementService.getConfig().advanced.displayCreditAdjustmentDetails.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: customerCreditManagementService.getConfig().basic.cancelState }
                                }
                            }
                        ];
                    }
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    var CustomerCreditManagementMainController = (function () {
                        /* @ngInject */
                        function CustomerCreditManagementMainController($document, customerCreditManagementService) {
                            this.$document = $document;
                            this.customerCreditManagementService = customerCreditManagementService;
                            customerCreditManagementService.restoreState();
                            $document.scrollTop(0);
                        }
                        CustomerCreditManagementMainController.$inject = [
                            '$document',
                            'ute.common.customer.credit.management.service'
                        ];
                        return CustomerCreditManagementMainController;
                    }());
                    management.CustomerCreditManagementMainController = CustomerCreditManagementMainController;
                    angular.module('ute.common.customer.credit.management').controller('ute.common.customer.credit.management.main.controller', CustomerCreditManagementMainController);
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            var DataManagerController = (function () {
                /* @ngInject */
                function DataManagerController($scope, languageService, $document, $translate, dataManagerService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.languageService = languageService;
                    this.$document = $document;
                    this.$translate = $translate;
                    this.dataManagerService = dataManagerService;
                    this.updateModel = function (summary) {
                        _this.dataManagerService.setModel(_this.dataManagerService.transformSummary(summary, _this.dataManagerService.getModel()));
                        var request = {
                            accountNumber: _this.dataManagerService.getAccountNumber(),
                            serviceType: _this.dataManagerService.getConfig().basic.serviceType
                        };
                        var worker = _this.dataManagerService.getUsageDetailsWorker(request);
                        worker.forceGetUsageDetails().then(function (dataManagerServerGetUsageDetails) {
                            return _this.dataManagerService.setModel(_this.dataManagerService.transformUsageDetails(dataManagerServerGetUsageDetails, _this.dataManagerService.getModel()));
                        });
                        return null;
                    };
                    this.getBan = dataManagerService.getAccountNumber;
                    this.model = dataManagerService.getModel();
                    dataManagerService.restoreDefault();
                    //dataManagerService.usageDetailsAPI();
                    $document.scrollTop(0);
                    this.dataManagerService.getSummaryWorker().then(function (worker) {
                        return worker.registerOnDataChangeHandler(_this.updateModel, DataManagerController.controllerName);
                    });
                    this.$scope.$on('$destroy', function () {
                        return _this.dataManagerService.getSummaryWorker().then(function (worker) {
                            return worker.unregisterOnDataChangeHandler(DataManagerController.controllerName);
                        });
                    });
                    this.$scope.alertData = {
                        copy: {
                            ariaLabel: 'aria',
                            icon: 'check',
                            body: this.$translate.instant('ute.dataManager.infiniteAlert.body'),
                            closeLabel: this.$translate.instant('ute.dataManager.infiniteAlert.closeLabel'),
                        },
                    };
                    this.$scope.isInfinitePlan = function () {
                        return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                    };
                    this.$scope.showInfinitePlanAlert = function () {
                        return _this.$scope.isInfinitePlan() && _this.dataManagerService.getIsFirstCycleAfterPpc();
                    };
                    this.languageService.registerOnDataChangeHandler(function () {
                        _this.$scope.alertData.copy.body = _this.$translate.instant('ute.dataManager.infiniteAlert.body');
                        _this.$scope.alertData.copy.closeLabel = _this.$translate.instant('ute.dataManager.infiniteAlert.closeLabel');
                        return null;
                    }, 'ute.data.manager.main.controller');
                }
                DataManagerController.controllerName = 'ute.data.manager.main.controller';
                DataManagerController.$inject = ['$scope', 'ute.blocks.language.switcher', '$document', '$translate', 'ute.data.manager.service'];
                return DataManagerController;
            }());
            manager.DataManagerController = DataManagerController;
            angular.module('ute.data.manager').controller('ute.data.manager.main.controller', DataManagerController);
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            angular.module('ute.data.manager').run(dataManagerRoutesConfig);
            dataManagerRoutesConfig.$inject = ['$window', '$state', 'ute.blocks.router', 'ute.data.manager.service', 'ute.rogers.account.overview.factory', 'ute.rogers.account.overview.summary.factory', 'ute.rogers.account.selection.service'];
            /* @ngInject */
            function dataManagerRoutesConfig($window, $state, routerHelper, dataManagerService, accountOverviewFactory, accountOverviewSummaryFactory, accountSelectionService) {
                routerHelper.configureStates(getStates($window, $state, dataManagerService, accountOverviewFactory, accountOverviewSummaryFactory, accountSelectionService));
            }
            function getStates($window, $state, dataManagerService, accountOverviewFactory, accountOverviewSummaryFactory, accountSelectionService) {
                var config = dataManagerService.getConfig();
                var dataManagerRootState = config.basic.dataManagerRootState;
                return [
                    {
                        name: dataManagerRootState,
                        abstract: true,
                        url: '/' + dataManagerRootState,
                        templateUrl: config.basic.mainTemplateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        },
                        resolve: {
                            // dashboardChecker: ['ute.rogers.deeplink.checker.service', function (deeplinkChecker: ute.rogers.deeplink.checker.IDeeplinkService) {
                            //   return deeplinkChecker.checkSubscription('CTN', 'accountOverview');
                            // }],
                            redirectToSelfServe: ['$window', '$q', function ($window, $q) {
                                    $window.open('/consumer/self-serve/wireless', '_self');
                                    return $q.defer().promise;
                                }],
                            usageDetailsFDM: ['$window', 'redirectToSelfServe', function ($window, redirectToSelfServe) {
                                    dataManagerService.resetLoadComplete();
                                    dataManagerService.setIsVideoThrottlePermitted();
                                    dataManagerService.setIsRogersAddonEnabled();
                                    dataManagerService.setIsRogersDataPurchaseEnabled();
                                    if (dataManagerService.isMockDataEnabled()) {
                                        dataManagerService.usageDetailsAPI();
                                        dataManagerService.setUsageDetailsCallInProgress(false);
                                    }
                                    else {
                                        dataManagerService.setUsageDetailsCallInProgress(true);
                                        var isCare_1 = dataManagerService.isCare();
                                        var index_1 = 0;
                                        var fdmWithSuspendedAccount_1;
                                        var selectedAccount_1 = null;
                                        var accountOverviewService = accountOverviewFactory();
                                        var checkLastAndRedirect_1;
                                        var recurseAccount_1;
                                        var processFdm_1;
                                        checkLastAndRedirect_1 = function (account, accountOverview) {
                                            if (index_1 === accountOverview.accountList.length - 1) {
                                                if (fdmWithSuspendedAccount_1) {
                                                    accountOverview.selectAccount(fdmWithSuspendedAccount_1);
                                                    accountSelectionService.setAccountPicked(true);
                                                    $state.go(config.basic.invalidSEAccountRedirectState);
                                                }
                                                else {
                                                    $state.go(config.basic.invalidSEAccountRedirectStateWireless);
                                                }
                                            }
                                            else {
                                                recurseAccount_1(accountOverview.accountList[++index_1], accountOverview);
                                            }
                                        };
                                        processFdm_1 = function (accSummary) {
                                            accountOverviewService.selectAccount(accSummary.accountNumber);
                                            accountSelectionService.setAccountPicked(true);
                                            dataManagerService.setModel(dataManagerService.transformSummary(accSummary, dataManagerService.getModel()));
                                            var request = {
                                                accountNumber: accSummary.accountNumber.toString(),
                                                serviceType: config.basic.serviceType
                                            };
                                            var worker = dataManagerService.getUsageDetailsWorker(request);
                                            worker.getDataManagerServerGetUsageDetails().then(function (dataManagerServerGetUsageDetails) {
                                                worker.resetCachedData();
                                                dataManagerService.setModel(dataManagerService.transformUsageDetails(dataManagerServerGetUsageDetails, dataManagerService.getModel()));
                                                function isCTNValid(ctn) {
                                                    var badgeList = dataManagerService.getModel().badgeList.subscriberList;
                                                    var searchIndex = _.findIndex(badgeList, {
                                                        ctn: ctn
                                                    });
                                                    if (searchIndex !== -1 && badgeList[searchIndex].subStatus !== 'Suspended') {
                                                        return true;
                                                    }
                                                    else {
                                                        return false;
                                                    }
                                                }
                                                function getValidCTN() {
                                                    var accountLine = dataManagerService.getDataControlList();
                                                    for (var iControlLine = 0; iControlLine < accountLine.length; iControlLine++) {
                                                        var ctn = accountLine[iControlLine].ctn;
                                                        if (isCTNValid(ctn)) {
                                                            return ctn;
                                                        }
                                                    }
                                                    return '';
                                                }
                                                var validCTN;
                                                if (!$window.localStorage.getItem('phoneNumber') || (isCare_1 && !$window.sessionStorage.getItem('phoneNumber'))) {
                                                    //Required for wireless dashboard totes integration...
                                                    validCTN = getValidCTN();
                                                }
                                                else {
                                                    var presetCTN = isCare_1 ? $window.sessionStorage.getItem('phoneNumber') : $window.localStorage.getItem('phoneNumber');
                                                    validCTN = isCTNValid(presetCTN) ? presetCTN : getValidCTN();
                                                }
                                                $window.localStorage.setItem('phoneNumber', validCTN);
                                                if (isCare_1) {
                                                    $window.sessionStorage.setItem('phoneNumber', validCTN);
                                                }
                                                //console.log('After data loaded');
                                                dataManagerService.expandDataSection();
                                            }).catch(function () {
                                                dataManagerService.setStateToErrorPage();
                                            }).finally(function () {
                                                dataManagerService.setUsageDetailsCallInProgress(false);
                                            });
                                        };
                                        recurseAccount_1 = function (account, accountOverview) {
                                            if (account.accountTypeNumber === 1 && selectedAccount_1 !== account.accountNumber) {
                                                var summaryRequest = {
                                                    accountNumber: account.accountNumber,
                                                    accountTypeNumber: account.accountTypeNumber,
                                                    language: 'en'
                                                };
                                                accountOverviewSummaryFactory(summaryRequest).getAccountOverviewSummaryRawData().then(function (accountOverviewSummary) {
                                                    var shareEverythingAccount = _.get(accountOverviewSummary, 'shareEverything', null);
                                                    var accountStatus = _.get(accountOverviewSummary, 'accountInfo.status', null);
                                                    if (shareEverythingAccount === null) {
                                                        checkLastAndRedirect_1(accountOverview.accountList[index_1], accountOverview);
                                                    }
                                                    else if (shareEverythingAccount !== null &&
                                                        (accountStatus === 'Suspended' ||
                                                            accountStatus === 'Cancelled')) {
                                                        fdmWithSuspendedAccount_1 = fdmWithSuspendedAccount_1 ? fdmWithSuspendedAccount_1 : account.accountNumber;
                                                        checkLastAndRedirect_1(accountOverview.accountList[index_1], accountOverview);
                                                    }
                                                    else if (shareEverythingAccount !== null &&
                                                        accountStatus === 'Active') {
                                                        processFdm_1(accountOverviewSummary);
                                                    }
                                                });
                                            }
                                            else {
                                                checkLastAndRedirect_1(accountOverview.accountList[index_1], accountOverview);
                                            }
                                        };
                                        accountOverviewService.getSelectedAccountDetails(undefined).then(function (accountDetail) {
                                            if (!accountDetail) {
                                                $state.go(config.basic.noAccountLinkedState);
                                            }
                                            selectedAccount_1 = accountDetail.accountNumber;
                                            var accountStatus = _.get(accountDetail, 'accountInfo.status', null);
                                            var isFdmAccount = _.get(accountDetail, 'shareEverything', null);
                                            if (isFdmAccount === null ||
                                                (accountStatus === 'Suspended' && isFdmAccount) ||
                                                (accountStatus === 'Cancelled' && isFdmAccount)) {
                                                if (isFdmAccount && (accountStatus === 'Suspended' || accountStatus === 'Cancelled')) {
                                                    fdmWithSuspendedAccount_1 = fdmWithSuspendedAccount_1 ? fdmWithSuspendedAccount_1 : accountDetail.accountNumber;
                                                }
                                                accountOverviewService.getAccountOverview().then(function (accountOverview) {
                                                    if (_.get(accountOverview.accountList, 'length', 0) === 0) {
                                                        $state.go(config.basic.noAccountLinkedState);
                                                    }
                                                    else {
                                                        recurseAccount_1(accountOverview.accountList[index_1], accountOverview); // if not loop all accounts
                                                    }
                                                });
                                            }
                                            else {
                                                processFdm_1(accountDetail);
                                            }
                                        });
                                    }
                                }]
                        }
                    },
                    {
                        name: dataManagerService.getEntryStateNoEncryption(),
                        url: '',
                        controller: config.advanced.enterDataManager.controllerName,
                        templateUrl: config.advanced.enterDataManager.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    },
                    {
                        name: dataManagerService.getSecondEntryState(),
                        url: '/' + 'dataManagerConsole' + '/:id',
                        controller: config.advanced.enterDataManager.controllerName,
                        templateUrl: config.advanced.enterDataManager.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    },
                    {
                        name: dataManagerService.getEntryState(),
                        url: '/' + config.advanced.enterDataManager.subState + '/:id',
                        controller: config.advanced.enterDataManager.controllerName,
                        templateUrl: config.advanced.enterDataManager.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    },
                    {
                        name: dataManagerRootState + '.manage',
                        url: '/manage',
                        controller: config.advanced.enterDataManager.controllerName,
                        templateUrl: config.advanced.enterDataManager.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    },
                    {
                        name: dataManagerService.getAccountsSummaryState(),
                        url: '/' + config.advanced.dataManagerAccountsSummary.subState,
                        controller: config.advanced.dataManagerAccountsSummary.controllerName,
                        controllerAs: 'familyDataManagerAccountsSummary',
                        templateUrl: config.advanced.dataManagerAccountsSummary.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        },
                        onEnter: ['ute.common.second.level.navigation.service', function (navigationService) {
                                navigationService.disableFullMenu();
                            }],
                        onExit: ['ute.common.second.level.navigation.service', function (navigationService) {
                                navigationService.enableFullMenu();
                            }]
                    },
                    {
                        name: dataManagerService.getIndividualSummaryState(),
                        url: '/' + config.advanced.dataManagerIndividualSummary.subState + '/:id',
                        controller: config.advanced.dataManagerIndividualSummary.controllerName,
                        controllerAs: 'familyDataManagerIndividualSummary',
                        templateUrl: config.advanced.dataManagerIndividualSummary.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    },
                    {
                        name: dataManagerService.getErrorPageState(),
                        url: '/' + config.advanced.dataManagerErrorPage.subState,
                        controller: config.advanced.dataManagerErrorPage.controllerName,
                        controllerAs: 'familyDataManagerErrorPage',
                        templateUrl: config.advanced.dataManagerErrorPage.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['user'] }
                        }
                    }
                ];
            }
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

/* ---------------------------------------------------------------------------
  This directive is deprecated. Please use error.track.directive.ts instead
--------------------------------------------------------------------------- */
var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerFormFieldError = (function () {
                    function UteDataLayerFormFieldError(dataLayerService, $parse, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$parse = $parse;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var fireDataLayer = _this.$parse(attrs.fireDataLayer)($scope);
                            var mappingKey, isModalPopup, mapping;
                            var selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                            if (!(fireDataLayer === false) && _this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                $scope.$applyAsync(function () {
                                    try {
                                        isModalPopup = _this.$parse(attrs.isModalPopup)($scope) || false;
                                        // if mappingKey is not bound to parent scope or controller variable, then tries to get mappingKey from attrs object
                                        try {
                                            mappingKey = _this.$parse(attrs.mappingKey)($scope);
                                        }
                                        catch (e) {
                                        }
                                        if (!mappingKey) {
                                            mappingKey = attrs.mappingKey;
                                        }
                                        if (mappingKey) {
                                            mapping = {
                                                mappingKey: mappingKey
                                            };
                                        }
                                        if (attrs.pageView === 'true') {
                                            selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                        }
                                        _this.getErrorPayload($scope, attrs).then(function (payload) {
                                            _this.dataLayerService.trackFormError(payload, element.text().trim(), attrs.formFieldName || '', isModalPopup, selectedSections, mapping);
                                        });
                                    }
                                    catch (err) {
                                        console.warn('(deprecated) Exception in dataLayer form error directive', err);
                                    }
                                });
                            }
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerFormFieldError.factory = function () {
                        var directive = function (dataLayerService, $parse, $q, $state) { return new UteDataLayerFormFieldError(dataLayerService, $parse, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$parse', '$q', '$state'];
                        return directive;
                    };
                    ;
                    UteDataLayerFormFieldError.prototype.getErrorPayload = function (scope, attrs) {
                        var errorPayload_cb, errorPayload_promise, payload;
                        errorPayload_cb = this.dataLayerService.getCallbackByKey('errorPayload');
                        if (errorPayload_cb) {
                            errorPayload_promise = errorPayload_cb.callback(attrs.errorData);
                        }
                        // try parse json object . In case when payload specified as a json object.
                        try {
                            payload = JSON.parse(attrs.errorPayload);
                        }
                        catch (e) {
                        }
                        // try parse bound variable ( scope or controller(as syntax)) when json parsing failed.
                        if (!payload) {
                            try {
                                payload = this.$parse(attrs.errorPayload)(scope);
                            }
                            catch (e) {
                            }
                        }
                        return this.$q.when(errorPayload_promise)
                            .then(function (callBackpayload) {
                            if (payload && callBackpayload) {
                                _.merge(payload, callBackpayload);
                            }
                            else if (callBackpayload) {
                                payload = callBackpayload;
                            }
                            return payload;
                        })
                            .catch(function (error) {
                            console.warn('(deprecated) Error in handling errorPayload callback.');
                            return payload;
                        });
                    };
                    return UteDataLayerFormFieldError;
                }());
                angular.module('ute.datalayer.common').directive('uteDataLayerFormFieldError', UteDataLayerFormFieldError.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

/* ---------------------------------------------------------------------------
  This directive is deprecated. Please use event.track.directive.ts instead
--------------------------------------------------------------------------- */
var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerEvent = (function () {
                    function UteDataLayerEvent(dataLayerService, $parse, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$parse = $parse;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var mappingKey, isModalPopup, mapping;
                            var self = _this;
                            var selectedSections;
                            function setTrackParams(parse) {
                                selectedSections = [
                                    service.DataLayerPredefinedSection.ACCOUNT,
                                    service.DataLayerPredefinedSection.PAGE,
                                    service.DataLayerPredefinedSection.SITE];
                                if (attrs.pageView === 'true') {
                                    selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                }
                                isModalPopup = (attrs.isModalPopup === 'true');
                                try {
                                    mappingKey = parse(attrs.mappingKey)($scope);
                                }
                                catch (e) {
                                }
                                if (!mappingKey) {
                                    mappingKey = attrs.mappingKey;
                                }
                                if (mappingKey) {
                                    mapping = {
                                        mappingKey: mappingKey
                                    };
                                }
                            }
                            function track($parse) {
                                try {
                                    setTrackParams($parse);
                                    self.getEventPayload($scope, attrs).then(function (payload) {
                                        self.dataLayerService.track(payload, isModalPopup, selectedSections, mapping);
                                    });
                                }
                                catch (err) {
                                    console.warn('(deprecated) Exception in adl form event tracking directive', err);
                                }
                            }
                            $scope.$applyAsync(function () {
                                if (_this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                    if (attrs.eventName) {
                                        element.on(attrs.eventName, function (event) {
                                            track(_this.$parse);
                                        });
                                    }
                                    else {
                                        track(_this.$parse);
                                    }
                                }
                            });
                            $scope.$on('$destroy', function () {
                                if (attrs.eventName) {
                                    element.off(attrs.eventName);
                                }
                            });
                        };
                        this.getEventPayload = function ($scope, attrs) {
                            var eventPayload_cb, eventPayload_promise, payload;
                            eventPayload_cb = _this.dataLayerService.getCallbackByKey('eventPayload');
                            if (eventPayload_cb) {
                                eventPayload_promise = eventPayload_cb.callback(attrs.eventData);
                            }
                            try {
                                payload = JSON.parse(attrs.eventPayload);
                            }
                            catch (e) {
                            }
                            // try parse bound variable ( scope or controller(as syntax)) when json parsing failed.
                            if (!payload) {
                                try {
                                    payload = _this.$parse(attrs.eventPayload)($scope);
                                }
                                catch (e) {
                                }
                            }
                            return _this.$q.when(eventPayload_promise)
                                .then(function (callBackpayload) {
                                if (payload && callBackpayload) {
                                    _.merge(payload, callBackpayload);
                                }
                                else if (callBackpayload) {
                                    payload = callBackpayload;
                                }
                                return payload;
                            })
                                .catch(function (error) {
                                console.warn('(deprecated) Error in handling eventPayload callback.');
                                return payload;
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerEvent.factory = function () {
                        var directive = function (dataLayerService, $parse, $q, $state) { return new UteDataLayerEvent(dataLayerService, $parse, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$parse', '$q', '$state'];
                        return directive;
                    };
                    ;
                    return UteDataLayerEvent;
                }());
                angular.module('ute.datalayer.common').directive('uteDataLayerEvent', UteDataLayerEvent.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var DataLayerServiceProvider = (function () {
                    function DataLayerServiceProvider() {
                        var _this = this;
                        this.config = {};
                        this.is_trackDataFunctionExist = (typeof (_trackData) === 'function');
                        this.configLoaded = false;
                        this.registeredCallbacks = [];
                        this.referrer = '';
                        this.queue = [];
                        this.flag = [false, false];
                        this.$get = function ($q, $window, $rootScope, $injector) {
                            _this.$q = $q;
                            _this.$window = $window;
                            _this.$rootScope = $rootScope;
                            _this.$injector = $injector;
                            _this.getConfig().then(function () {
                                var exclusive = _.get(_this.config, 'advance.configOptions.globalTrackingExclusive', false);
                                if (_.get(_this.config, 'advance.configOptions.globalTrackingOn', false)) {
                                    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
                                        if (!_this.queue.includes(toState.name)) {
                                            _this.queue.push(toState.name);
                                        }
                                        else {
                                            return;
                                        }
                                        if (!exclusive || exclusive && _.has(_this.config.advance.mappingKey, toState.name)) {
                                            _this.trackGlobalAsync({
                                                mappingKey: _this.getDelegateMappingKey(_this.config, toState.name),
                                                stateURL: toState.url
                                            });
                                        }
                                    });
                                }
                            });
                            return {
                                returnConfig: _this.returnConfig,
                                track: _this.trackAsync,
                                trackGlobal: _this.trackGlobalAsync,
                                getMappingPayload: _this.getMappingPayload,
                                getPageHierarchy: _this.getPageHierarchy,
                                getConfigByMappingKey: _this.getConfigByMappingKey,
                                registerCallbacks: _this.registerCallbacks,
                                getQueryString: _this.getQueryString,
                                getCallbackByKey: _this.getCallbackByKey,
                                trackError: _this.trackError,
                                trackFormError: _this.trackFormErrorAsync,
                                trackErrors: _this.trackErrors,
                                trackAPIError: _this.trackAPIErrorAsync,
                                isStateDefined: _this.isStateDefined,
                                trackHttpRequest: _this.trackHttpRequest,
                                trackHttpResponse: _this.trackHttpResponseAsync,
                                trackHttpResponseError: _this.trackHttpResponseErrorAsync,
                                trackUteModal: _this.trackUteModalAsync,
                                getLastPayload: _this.getLastPayload,
                                resetLastModalPayload: _this.resetLastModalPayload
                            };
                        };
                        /**
                         * @description To merge the passed in configuration with the local configuration
                         * @param config: IDataLayerServiceConfig
                         * @returns boolean
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            if (!_this.flag[0] && typeof _satellite !== 'undefined' && typeof _satellite.track === 'function') {
                                _this.flag[0] = true;
                                _satellite.track('angular-analytics');
                            }
                            return true;
                        };
                        /**
                         * @description TBD
                         * @param field:
                         * @param url:
                         * @returns TBD
                         */
                        this.getQueryString = function (field, url) {
                            var href = url ? url : window.location.href;
                            var reg = new RegExp('[?&]' + field + '=([^&#]*)', 'i');
                            var queryString = reg.exec(href);
                            return queryString ? queryString[1] : null;
                        };
                        this.getDelegateMappingKey = function (config, state) {
                            var delegatedMappingKey = state;
                            if (_.get(config, 'advance.configOptions.queryParamTrackingOn', false) && _.get(config, ['advance', 'configOptions', 'queryParamsMapping', state], false)) {
                                _.forEach(_.get(config, ['advance', 'configOptions', 'queryParamsMapping', state], null), function (queryParamKey) {
                                    if (this.getQueryString(queryParamKey)) {
                                        delegatedMappingKey = this.getQueryString(queryParamKey);
                                        return false;
                                    }
                                });
                            }
                            return delegatedMappingKey;
                        };
                        this.getLastPayload = function () { return _this.lastModalPayload || _this.lastPayload; };
                        this.resetLastModalPayload = function () {
                            _this.lastModalPayload = null;
                        };
                        /**
                         * @description To obtain a flag if state name is defined in config object.
                         * @param stateName: string
                         * @returns boolean
                         */
                        this.isStateDefined = function (stateName) { return _.has(_this.config.advance.mappingKey, stateName); };
                        /**
                         * @description To retrieve callback object by callback key
                         * @param callbackKey: string
                         * @returns IDataLayerCallback
                         */
                        this.getCallbackByKey = function (callbackKey) {
                            return _.find(_this.registeredCallbacks, { 'callbackKey': callbackKey });
                        };
                        /**
                         * @description To register callbacks in common datalayer to obtain data that require app specific implementation
                         * @param callBacks: Array<IDataLayerCallback>
                         */
                        this.registerCallbacks = function (callBacks) {
                            _this.registeredCallbacks = [];
                            for (var i = 0; i < callBacks.length; i++) {
                                _this.registeredCallbacks.push(callBacks[i]);
                            }
                        };
                        /**
                         * @description To get configuration from  external source or from local object.
                         * If property advance.configOptions.loadFromFile is defined in config and its value is true then it performs http.get call
                         * to obtain configuration using path that defined in property advance.configOptions.pathToConfigFile. Otherwise resolves the promise.
                         * @returns Promise for configuration data.
                         */
                        this.getConfig = function () {
                            if (_this.configLoaded) {
                                return _this.$q.when(true);
                            }
                            else {
                                if (_.has(_this.config, 'advance.configOptions.loadFromFile')) {
                                    if (_this.config.advance.configOptions.loadFromFile) {
                                        var pathName = _this.config.advance.configOptions.pathToConfigFile;
                                        if (!_this.config.advance.configOptions.isAbsolutePath) {
                                            pathName = location.origin + location.pathname + pathName;
                                        }
                                        var $http = _this.$injector.get('$http');
                                        return $http.get(_this.config.advance.configOptions.pathToConfigFile)
                                            .then(function (response) {
                                            _this.configure(response.data);
                                            _this.configLoaded = true;
                                            return true;
                                        }).catch(function (error) {
                                            console.warn('Initializing data layer config from file failed', error);
                                            return true;
                                        });
                                    }
                                    else {
                                        return _this.$q.when(true);
                                    }
                                }
                                else {
                                    return _this.$q.when(true);
                                }
                            }
                        };
                        this.getGlobalSections = function () {
                            return [
                                service.DataLayerPredefinedSection.ACCOUNT,
                                service.DataLayerPredefinedSection.PAGE,
                                service.DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                                service.DataLayerPredefinedSection.SITE
                            ];
                        };
                        /**
                         * @description To pass all the required parameters to the track function in common service
                         * @param mapping?: IDataLayerMapping
                         * @param resetSessionEvent?: boolean
                         */
                        this.trackGlobalAsync = function (mapping, resetSessionEvent) {
                            setTimeout(function () {
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    var datalayerTrackParams_1 = {}, currentPayload_cb = _this.getCallbackByKey('payload'), currentPayload_promise = void 0, stateName = void 0;
                                    if (mapping) {
                                        stateName = mapping.mappingKey;
                                        datalayerTrackParams_1.mapping = mapping;
                                    }
                                    currentPayload_promise = (currentPayload_cb) ? currentPayload_cb.callback(stateName) : {};
                                    _this.$q.when(currentPayload_promise)
                                        .then(function (payLoadData) {
                                        _this.mergeSelectedInformation(payLoadData || {}, false, [service.DataLayerPredefinedSection.GLOBAL])
                                            .then(function (payload) {
                                            _this.lastPayload = payload;
                                            _this.lastModalPayload = null;
                                            datalayerTrackParams_1.payload = payload;
                                            if (_.isBoolean(resetSessionEvent) && resetSessionEvent) {
                                                _this.$rootScope.$emit('resetSessionEvent', true);
                                            }
                                            _this._track(datalayerTrackParams_1);
                                        })
                                            .catch(function (error) {
                                            console.warn('trackGlobalAsync -> mergeSelectedInformation: Error in merging payload data', error);
                                        });
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                    });
                                }
                                catch (error) {
                                    console.warn('trackGlobalAsync -> Data layer global track', error);
                                }
                            });
                        };
                        /**
                         * @description To return the complete / partial configuration at any point of time.
                         * @param key: if key is specified, only the corresponding config associated with the key will be returned.
                         * @returns IDataLayerServiceConfig
                         */
                        this.returnConfig = function (key) {
                            try {
                                if (_this.config) {
                                    return _.get(_this.config, key, !key && _this.config);
                                }
                            }
                            catch (error) {
                                console.warn('Error in returnConfig function', error);
                            }
                        };
                        /**
                         * @description To construct the payload object based on the passed in parameters.
                         * @param payload: IDataLayerTrackParams
                         * @param isModalPopup: Boolean, true if it's a modal popup
                         * @param selectedSections: DataLayerPredefinedSection[], predefined section
                         * @param mapping: IDataLayerMapping
                         */
                        this.trackAsync = function (payload, isModalPopup, selectedSections, mapping) {
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            payload = payload || {};
                            var datalayerTrackParams = {
                                payload: payload,
                                mapping: mapping
                            }, payload_cb, payload_promise;
                            setTimeout(function () {
                                try {
                                    payload_cb = _this.getCallbackByKey('trackPayload');
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    payload_promise = (payload_cb) ? payload_cb.callback() : {};
                                    _this.$q.when(payload_promise)
                                        .then(function (payLoadData) {
                                        if (payLoadData) {
                                            _.merge(payload, payLoadData);
                                        }
                                        if (selectedSections && selectedSections.length > 0) {
                                            _this.mergeSelectedInformation(payload, isModalPopup, selectedSections)
                                                .then(function (payload) {
                                                if (!_.get(payload, 'liveChat')) {
                                                    _this.lastModalPayload = isModalPopup && payload || _this.lastModalPayload;
                                                    _this.lastPayload = !isModalPopup && payload || _this.lastPayload;
                                                }
                                                datalayerTrackParams.payload = payload;
                                                _this._track(datalayerTrackParams);
                                            })
                                                .catch(function (error) {
                                                console.warn('track -> mergeSelectedInformation: Error in merging payload data', error);
                                            });
                                        }
                                        else {
                                            if (!_.get(payload, 'liveChat')) {
                                                _this.lastModalPayload = isModalPopup && payload || _this.lastModalPayload;
                                                _this.lastPayload = !isModalPopup && payload || _this.lastPayload;
                                            }
                                            _this._track(datalayerTrackParams);
                                        }
                                    })
                                        .catch(function (error) {
                                        console.warn('Error in resolving payload promise.');
                                    });
                                }
                                catch (error) {
                                    console.warn('Error in track function', error);
                                }
                            });
                        };
                        /**
                         * @description 1. To construct the payload object based on the passed in parameters.
                         *              2. To obtain partial payload based on params.mapping and merge into final payload.
                         *              3. To perform call to _trackData function with final payload object
                         * @param params: Contains 2 properties => mapping and payload
                         */
                        this._track = function (params) {
                            var mappingPayLoad;
                            //To make sure the tracking library has loaded and _trackData is a function
                            if (!_this.is_trackDataFunctionExist) {
                                return;
                            }
                            // Loading custom mapping from DTM (angular-analytics)
                            if (!_this.flag[1] && _.has(_this.$window, 'tmCustomMapping')) {
                                _this.flag[1] = _this.configure(_.get(_this.$window, 'tmCustomMapping', {}));
                            }
                            _this.getConfig().then(function () {
                                if (params && params.mapping) {
                                    mappingPayLoad = _this.getMappingPayload(params.mapping);
                                    if (mappingPayLoad) {
                                        _.merge(params.payload, mappingPayLoad);
                                    }
                                }
                                if (!(_.get(params.payload, 'suppressTracking'))) {
                                    _trackData(params.payload);
                                    window.analyticsLayer = window.analyticsLayer || [];
                                    window.analyticsLayer.push(params.payload);
                                    _this.queue.length = 0;
                                }
                            });
                        };
                        /**
                         * @description To send the payload object with errors to the dataLayerTrack function from the data layer common service.
                         * @param payload: ITrackDataPayload,
                         * @param trackingErrors: IADLError[],
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[],
                         */
                        this.trackErrors = function (payload, trackingErrors, isModalPopup, selectedSections) {
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            try {
                                /* To make sure the tracking library has loaded and _trackData function exists */
                                if (!_this.is_trackDataFunctionExist) {
                                    return;
                                }
                                var errors = trackingErrors;
                                var event_1 = { error: true };
                                /* To set Error Type to lowercase and Decode HTML entity for message */
                                errors.map(function (err) {
                                    err.type = err.type.replace('_', ' ').toLocaleLowerCase();
                                    err.message = angular.element('<textarea />').html(err.message).text();
                                    err.category = err.category.replace('_', ' ').toLocaleLowerCase();
                                });
                                var _payload = {
                                    errors: errors,
                                    events: event_1
                                };
                                if (angular.isObject(payload)) {
                                    _.merge(payload, _payload);
                                }
                                _this.trackAsync(payload, isModalPopup, selectedSections);
                            }
                            catch (error) {
                                console.warn('Data layer tracking errors', error);
                            }
                        };
                        /**
                         * @description
                         * @param payload: ITrackDataPayload,
                         * @param errorType: ErrorType,
                         * @param errorCode: string,
                         * @param errorMessage: string,
                         * @param errorCategory: ErrorType,
                         * @param errorField: string,
                         * @param errorAPI: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[],
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackError = function (payload, errorType, errorCode, errorMessage, errorCategory, errorField, errorAPI, isModalPopup, selectedSections, mapping) {
                            if (errorField === void 0) { errorField = service.formErrorDefaultFieldName; }
                            if (isModalPopup === void 0) { isModalPopup = false; }
                            setTimeout(function () {
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    payload = payload || {};
                                    var errors = [{
                                            type: service.ErrorType[errorType],
                                            code: errorCode,
                                            message: errorMessage,
                                            category: service.ErrorCategory[errorCategory],
                                            field: errorField,
                                            API: errorAPI
                                        }];
                                    if (mapping && mapping.mappingKey) {
                                        _.merge(payload, _this.getMappingPayload(mapping));
                                    }
                                    _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                }
                                catch (error) {
                                    console.warn('trackError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track error on form field
                         * @param payload: ITrackDataPayload, // if payload param is undefined then tryies to get payload from configuration
                         * @param errorMessage: string,
                         * @param errorField: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[], if not specified then used all 4 sections
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackFormErrorAsync = function (payload, errorMessage, errorField, isModalPopup, selectedSections, mapping) {
                            setTimeout(function () {
                                var error, errors = [];
                                payload = payload || {};
                                try {
                                    /* To make sure the tracking library has loaded and _trackData function exists */
                                    if (!_this.is_trackDataFunctionExist) {
                                        return;
                                    }
                                    if (mapping && mapping.mappingKey) {
                                        var mappingKeys = mapping.mappingKey.split(',');
                                        //set error mapping keys
                                        var errorMappingKeysArr = _.filter(mappingKeys, function (keyItem) {
                                            return keyItem.indexOf('errors:') > -1;
                                        });
                                        error = _this.getErrorData('', errorMessage, errorField, errorMappingKeysArr);
                                        // Merge value "FORM" to property "type" in error object. This value will always be used in tracking error
                                        // on form validation.
                                        if (error) {
                                            _.merge(error, { type: service.ErrorType[service.ErrorType.FORM] });
                                            errors.push(error);
                                        }
                                        //remove error mapping keys prefixed by 'errors:' from mapping object
                                        mapping.mappingKey = _.difference(mappingKeys, errorMappingKeysArr).join(',');
                                        _.merge(payload, _this.getMappingPayload(mapping));
                                    }
                                    _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                }
                                catch (error) {
                                    console.warn('trackFormError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track error on api failure
                         * @param errorCode: string,
                         * @param errorMessage: string,
                         * @param isModalPopup?: boolean, (default = false)
                         * @param selectedSections?: DataLayerPredefinedSection[], if not specified then used all 4 sections
                         * @param mapping?: IDataLayerMapping
                         */
                        this.trackAPIErrorAsync = function (errorCode, errorMessage, isModalPopup, selectedSections, mapping) {
                            setTimeout(function () {
                                var payload = {}, error, errors = [];
                                try {
                                    if (mapping && mapping.mappingKey) {
                                        var mappingKeys = mapping.mappingKey.split(',');
                                        var errorMappingKeysArr = _.filter(mappingKeys, function (keyItem) {
                                            return keyItem.indexOf('errors:') > -1;
                                        });
                                        error = _this.getErrorData(errorCode, errorMessage, '', errorMappingKeysArr);
                                        //remove error mapping keys prefixed by 'errors:' from mapping object
                                        mapping.mappingKey = _.difference(mappingKeys, errorMappingKeysArr).join(',');
                                        payload = _this.getMappingPayload(mapping);
                                        errors.push(error);
                                        _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                                    }
                                }
                                catch (error) {
                                    console.warn('trackAPIError method: ', error);
                                }
                            });
                        };
                        /**
                         * @description 1. To track modal popup triggered by UteModal
                         *              2. This function will be called when uteModal.defaultConfigObject.opened function is invoked.
                         *              3. either trackAsync or trackFormErrorAsync (when data.isError === true) will be called.
                         * @param config: uteModal.config object
                         */
                        this.trackUteModalAsync = function (config) {
                            setTimeout(function () {
                                try {
                                    var $state = _this.$injector.get('$state');
                                    var mapping = _this.getMappingPayload({ mappingKey: $state.current.name });
                                    if (mapping && Object.keys(mapping).length > 0) {
                                        var key = _this.getConfigByMappingKey({ 'mappingKey': 'modal' });
                                        var template = _.get(key, config.templateUrl, {});
                                        var func = _.get(template, 'response', '');
                                        if (func) {
                                            var data_1 = func(config, $state.current.name);
                                            if (data_1 && Object.keys(data_1).length > 0) {
                                                var payload = _.get(data_1, 'payload', {});
                                                if (data_1.isError) {
                                                    _this.trackError(payload, data_1.errorType || service.ErrorType.FORM, data_1.errorCode, data_1.errorMessage, data_1.errorCategory, data_1.errorField, data_1.errorAPI, true, [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                                else {
                                                    _this.trackAsync(payload, true, [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                            }
                                        }
                                    }
                                }
                                catch (error) {
                                    console.warn('trackUteModal method: ', error);
                                }
                            });
                        };
                        /**
                         * @description To track on httpInterceptor request.
                         * @param config: config object from http interceptor
                         */
                        this.trackHttpRequest = function (config) {
                            try {
                                var key = _this.getConfigByMappingKey({ 'mappingKey': 'api' }) || {};
                                var path_1 = _this.URI(config.url).path;
                                var keys = Object.keys(key).sort(function (a, b) { return b.length - a.length; });
                                var api = keys[_.findIndex(keys, function (k) { return path_1.match(k) && k.substr(k.lastIndexOf('/')) === path_1.substr(path_1.lastIndexOf('/')); })] || '';
                                var func = _.get(key, api + '.request', '');
                                if (func) {
                                    var $state = _this.$injector.get('$state');
                                    var respData = func(config, api, $state.current.name, _this.$injector);
                                    _this.$q.when(respData).then(function (data) {
                                        var payload = _.get(data, 'payload', {});
                                        if (data && Object.keys(data).length > 0) {
                                            var selectedSections = (data.pageView === false) ? [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE] : [service.DataLayerPredefinedSection.GLOBAL];
                                            _this.trackAsync(payload, data.isModalPopup, data.section || selectedSections);
                                        }
                                    });
                                    config.track = true;
                                    config.api = api;
                                }
                                else if (_.get(key, api + '.response') || _.get(key, api + '.responseError')) {
                                    config.track = true;
                                    config.api = api;
                                }
                            }
                            catch (error) {
                                console.warn('Error in trackHttpRequest function', error);
                            }
                        };
                        /**
                         * @description To track on httpInterceptor response.
                         * @param response: response object from http interceptor
                         */
                        this.trackHttpResponseAsync = function (response) {
                            setTimeout(function () {
                                try {
                                    var api = response.config.api;
                                    var key = _this.getConfigByMappingKey({ 'mappingKey': 'api.' + api });
                                    var func = _.get(key, 'response', '');
                                    if (func) {
                                        var $state = _this.$injector.get('$state');
                                        var respData = func(response, api, $state.current.name, _this.$injector);
                                        _this.$q.when(respData).then(function (data) {
                                            var payload = _.get(data, 'payload', {});
                                            if (data && Object.keys(data).length > 0) {
                                                var selectedSections = (data.pageView === false) ? [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE] : [service.DataLayerPredefinedSection.GLOBAL];
                                                if (data.isError) {
                                                    _this.trackError(payload, data.errorType, data.errorCode, data.errorMessage, data.errorCategory, '', data.errorAPI, data.isModalPopup, data.section || [service.DataLayerPredefinedSection.GLOBAL]);
                                                }
                                                else {
                                                    _this.trackAsync(payload, data.isModalPopup, data.section || selectedSections);
                                                }
                                            }
                                        });
                                    }
                                }
                                catch (error) {
                                    console.warn('Error in trackHttpResponseAsync function', error);
                                }
                            });
                        };
                        /**
                         * @description To track on httpInterceptor responseError.
                         * @param rejection: rejection object from http interceptor
                         */
                        this.trackHttpResponseErrorAsync = function (rejection) {
                            setTimeout(function () {
                                try {
                                    var key = _this.getConfigByMappingKey({ 'mappingKey': 'api' });
                                    var api = rejection.config.api || _this.URI(rejection.config.url).path;
                                    var func = _.get(key, api + '.responseError', _.get(key, 'default.responseError'));
                                    if (func) {
                                        var $state = _this.$injector.get('$state');
                                        var respData = func(rejection, api, $state.current.name, _this.$injector);
                                        _this.$q.when(respData).then(function (data) {
                                            if (data && Object.keys(data).length > 0) {
                                                var payload = _.get(data, 'payload', {});
                                                _this.trackError(payload, data.errorType, data.errorCode, data.errorMessage, data.errorCategory, '', data.errorAPI, data.isModalPopup, data.section || [service.DataLayerPredefinedSection.GLOBAL]);
                                            }
                                        });
                                    }
                                }
                                catch (error) {
                                    console.warn('Error in trackHttpResponseErrorAsync function', error);
                                }
                            });
                        };
                        /**
                         * @description To return a error object by:
                         *  1. Retrieving mapping values by mapping keys for category, type and API properties.
                         *  2. Setting properties code, message, field using passed in params
                         * @param errorCode: string
                         * @param errorMessage: string
                         * @param fieldName: string
                         * @param keysArr: string[]; can contain one or more mapping key items in the following structure:
                         *                           ['errors:key1:key2',errors:key3']
                         * @returns error: IADLError
                         */
                        this.getErrorData = function (errorCode, errorMessage, fieldName, keysArr) {
                            var self = _this;
                            var errorData = {
                                code: errorCode,
                                message: errorMessage,
                                field: fieldName,
                                type: '',
                                category: '',
                                API: ''
                            };
                            var mappingKeys = [], errorMappingKeysStr;
                            _.forEach(keysArr, function (keyItem) {
                                keyItem = _.trim(keyItem);
                                //trim errors keyword in keyItem string from index 7 till end of the string: errors:key1:key2 => key1:key2
                                errorMappingKeysStr = keyItem.substr(7);
                                //concat mappingKeys array and errorMappingKeysStr.split(':')
                                mappingKeys = mappingKeys.concat(errorMappingKeysStr.split(':'));
                            });
                            _.forEach(mappingKeys, function (mappingKey) {
                                if (_.has(self.config.advance.mappingKey, mappingKey)) {
                                    _.merge(errorData, _.cloneDeep(_.get(self.config.advance.mappingKey, mappingKey)));
                                }
                                else {
                                    console.warn('getErrorData => errorMappingKey: ' + mappingKey + ' is not defined in advance.mappingKey configuration property');
                                }
                            });
                            return errorData;
                        };
                        /**
                         * @description To return a page payload object by:
                         *  1. Retrieving mapping value by mapping key from config object.
                         *  2. Setting the page name and hierarchy by parsing the hash value if a mapping doesn't exist.
                         * @param mapping: IDataLayerMapping
                         * @returns payload: ITrackDataPayload
                         */
                        this.getMappingPayload = function (mapping) {
                            var payload = {}, _location = location.hash, _stateURL = (mapping.stateURL) ? mapping.stateURL : '';
                            if (mapping.mappingKey) {
                                var mappingKeys = mapping.mappingKey.split(',');
                                _.forEach(mappingKeys, function (mappingKey) {
                                    mappingKey = _.trim(mappingKey);
                                    if (_.has(_this.config.advance.mappingKey, mappingKey)) {
                                        _.merge(payload, _.cloneDeep(_.get(_this.config.advance.mappingKey, mappingKey)));
                                    }
                                    else {
                                        console.warn('getMappingPayload => mappingKey: ' + mappingKey + ' is not defined in advance.mappingKey configuration property');
                                    }
                                });
                            }
                            else if (mapping.mappingKey !== '') {
                                //Setting the page name and hierarchy by parsing the hash value if a mappingKey is not provided.
                                //In case mappingKey is empty string, this functionality will be skipped.
                                if (Object.keys(payload).length === 0) {
                                    /* to handle cases when a parameter exists in an URL */
                                    if (_stateURL.indexOf('/:') > -1) {
                                        var key = _stateURL.split('/:')[0];
                                        _location = _location.substring(0, _location.indexOf(key) + key.length);
                                    }
                                    payload = {
                                        page: _this.parseHashValue(_location)
                                    };
                                }
                            }
                            return payload;
                        };
                        /**
                         * @description To return page hierarchy and page name by:
                         *  1. Parsing the hash value (i.e. location.hash)
                         * @returns page: IADLPage
                         */
                        this.getPageHierarchy = function () {
                            var _location = location.hash;
                            return _this.parseHashValue(_location);
                        };
                        /**
                         * @description To return config object by:
                         *  1. Retrieving mapping value by mapping key from config object.
                         * @param mapping: IDataLayerMapping
                         * @returns mappedObject: any
                         */
                        this.getConfigByMappingKey = function (mapping) {
                            var mappedObject;
                            if (_.has(_this.config, mapping.mappingKey)) {
                                mappedObject = _.cloneDeep(_.get(_this.config, mapping.mappingKey));
                            }
                            return mappedObject;
                        };
                        /**
                         * @description To configure page payload object
                         *
                         */
                        this.getAccountPayloadData = function () {
                            var accountPayload, accountData, wirelessData;
                            var currentAccount_cb = _this.getCallbackByKey('account');
                            var currentUser_cb = _this.getCallbackByKey('user');
                            var currentDevice_cb = _this.getCallbackByKey('device');
                            var currentPlanInfo_cb = _this.getCallbackByKey('plan');
                            var currentAccount_promise, currentUser_promise, currentDevice_promise, currentPlanInfo_promise;
                            if (currentAccount_cb) {
                                currentAccount_promise = currentAccount_cb.callback();
                            }
                            if (currentUser_cb) {
                                currentUser_promise = currentUser_cb.callback();
                            }
                            if (currentDevice_cb) {
                                currentDevice_promise = currentDevice_cb.callback();
                            }
                            if (currentPlanInfo_cb) {
                                currentPlanInfo_promise = currentPlanInfo_cb.callback();
                            }
                            return _this.$q.all([currentAccount_promise, currentUser_promise, currentDevice_promise, currentPlanInfo_promise])
                                .then(function (values) {
                                var accountObj = values[0], userObj = values[1], deviceObj = values[2], planObj = values[3];
                                if ((accountObj && !_.isEmpty(accountObj)) || (userObj && !_.isEmpty(userObj))) {
                                    accountData = {};
                                    if (accountObj && !_.isEmpty(accountObj)) {
                                        if (accountObj.accountType) {
                                            accountData.type = accountObj.accountType.toLowerCase();
                                        }
                                        if (accountObj.accountNumber) {
                                            accountData.BAN = accountObj.accountNumber.toString();
                                        }
                                        if (accountObj.phoneNumber) {
                                            accountData.CTN = accountObj.phoneNumber.toString();
                                        }
                                    }
                                    if (userObj && !_.isEmpty(userObj)) {
                                        accountData.userType = userObj.userType;
                                        accountData.userName = userObj.userName;
                                        if (userObj.dealerCode) {
                                            accountData.dealerCode = userObj.dealerCode;
                                        }
                                        if (userObj.dealerType) {
                                            accountData.dealerType = userObj.dealerType;
                                        }
                                        if (userObj.agentType) {
                                            accountData.agentType = userObj.agentType;
                                        }
                                        if (userObj.interactionId) {
                                            accountData.interactionId = userObj.interactionId;
                                        }
                                        if (userObj.connId) {
                                            accountData.connId = userObj.connId;
                                        }
                                    }
                                    if ((deviceObj && !_.isEmpty(deviceObj)) || (planObj && !_.isEmpty(planObj))) {
                                        wirelessData = {};
                                        if (deviceObj && !_.isEmpty(deviceObj)) {
                                            wirelessData.device = deviceObj.device;
                                        }
                                        if (planObj && !_.isEmpty(planObj)) {
                                            wirelessData.plan = planObj.plan;
                                            wirelessData.balance = {
                                                amount: planObj.amount,
                                                payoffDate: planObj.payoffDate
                                            };
                                        }
                                        if (wirelessData && !_.isEmpty(wirelessData)) {
                                            accountData.wireless = wirelessData;
                                        }
                                    }
                                    if (accountData && !_.isEmpty(accountData)) {
                                        accountPayload = { account: accountData };
                                    }
                                }
                                return accountPayload;
                            })
                                .catch(function (error) {
                                console.warn('Error in configuring account section. Failed to load account/user details.');
                                return accountPayload;
                            });
                        };
                        /**
                         * @description To configure page payload object
                         *
                         */
                        this.getPagePayloadData = function (isModalPopup) {
                            var pagePayload;
                            var pageData;
                            var currentLanguage_cb = _this.getCallbackByKey('language');
                            var currentProvince_cb = _this.getCallbackByKey('province');
                            var currentLanguage_promise;
                            var currentProvince_promise;
                            if (currentLanguage_cb) {
                                currentLanguage_promise = currentLanguage_cb.callback();
                            }
                            if (currentProvince_cb) {
                                currentProvince_promise = currentProvince_cb.callback();
                            }
                            return _this.$q.all([currentLanguage_promise, currentProvince_promise])
                                .then(function (values) {
                                var languageResponse = values[0];
                                var provinceResponse = values[1];
                                pageData = {
                                    url: isModalPopup ? 'modal popup' : location.href,
                                    referrer: isModalPopup ? location.href : _this.referrer || location.href,
                                    ICMTimestamp: moment().format('dddd|MM/DD/YYYY HH:mm'),
                                    responsiveVersion: _this.isMobile() ? 'mobile' : 'desktop'
                                };
                                if (languageResponse) {
                                    pageData.language = languageResponse.language;
                                }
                                if (provinceResponse) {
                                    pageData.province = provinceResponse.province.toLowerCase();
                                }
                                _this.referrer = location.href;
                                return pagePayload = { page: pageData };
                            })
                                .catch(function (error) {
                                console.warn('Error in configuring page section. Failed to load language/province details.');
                                return pagePayload;
                            });
                        };
                        /**
                         * @description To merge all the selected information to the payload object.
                         * @param payload: ITrackDataPayload,
                         * @param selectedSections: DataLayerPredefinedSection[]
                         */
                        this.mergeSelectedInformationSync = function (payload, selectedSections) {
                            try {
                                //DA-45 - Remove pageView event for all errors tracking
                                var pageViewIndex = selectedSections.indexOf(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                if (_.get(payload, 'events.error') === true && pageViewIndex >= 0) {
                                    selectedSections.splice(pageViewIndex, 1);
                                }
                                /* Populate selected payload information */
                                selectedSections.forEach(function (section) {
                                    switch (section) {
                                        case service.DataLayerPredefinedSection.PAGE_VIEW_EVENT:
                                            _.merge(payload, { events: _this.getPageViewEventObject() });
                                            break;
                                        case service.DataLayerPredefinedSection.SIGNIN:
                                            _.merge(payload, { signin: _this.getSigninObject() });
                                            break;
                                        case service.DataLayerPredefinedSection.SITE:
                                            _.merge(payload, { site: _this.getSiteObject() });
                                            break;
                                        default:
                                    }
                                });
                                return payload;
                            }
                            catch (error) {
                                console.warn('Merge selected tracking data', error);
                            }
                        };
                        /**
                         * @description To merge all the selected information to the payload object.
                         * @param payload: ITrackDataPayload,
                         * @param isModalPopup: boolean,
                         * @param selectedSections: DataLayerPredefinedSection[]
                         */
                        this.mergeSelectedInformation = function (payload, isModalPopup, selectedSections) {
                            var promises = [];
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.GLOBAL) >= 0) {
                                selectedSections = _this.getGlobalSections();
                            }
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.ACCOUNT) >= 0) {
                                promises.push(_this.getAccountPayloadData());
                            }
                            if (_.indexOf(selectedSections, service.DataLayerPredefinedSection.PAGE) >= 0) {
                                promises.push(_this.getPagePayloadData(isModalPopup));
                            }
                            if (promises.length > 0) {
                                return _this.$q.all(promises)
                                    .then(function (payLoadData) {
                                    payLoadData.forEach(function (_payLoadItem) {
                                        if (_payLoadItem) {
                                            _.merge(payload, _payLoadItem);
                                        }
                                    });
                                    _.merge(payload, _this.mergeSelectedInformationSync(payload, selectedSections));
                                    return payload;
                                }).catch(function (error) {
                                    console.warn('Error in merging selected tracking data', error);
                                    return _this.$q.reject(error);
                                });
                            }
                            else {
                                _.merge(payload, _this.mergeSelectedInformationSync(payload, selectedSections));
                                return _this.$q.when(payload);
                            }
                        };
                        /**
                         * @description To get the data layer site object.
                         */
                        this.getSiteObject = function () {
                            return {
                                name: _this.config.basic.site.name
                            };
                        };
                        /**
                         * @description To get the data layer signin object
                         */
                        this.getSigninObject = function () {
                            return {
                                type: _this.config.basic.signin.type
                            };
                        };
                        /**
                         * @description To get the data layer event object
                         */
                        this.getPageViewEventObject = function () {
                            return {
                                pageView: true
                            };
                        };
                        this.isMobile = function () {
                            return (_this.isAndroid() || _this.isBlackBerry() || _this.isIOS() || _this.isWindowsMobile());
                        };
                        this.isWindowsMobile = function () {
                            return /IEMobile/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isAndroid = function () {
                            return /Android/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isBlackBerry = function () {
                            return /BlackBerry/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isIOS = function () {
                            return /iPhone|iPad|iPod/i.test(_this.$window.navigator.userAgent);
                        };
                        this.URI = function (str) {
                            // Based on the regex in RFC2396 Appendix B.
                            var parser = /^(?:([^:\/?\#]+):)?(?:\/\/([^\/?\#]*))?([^?\#]*)(?:\?([^\#]*))?(?:\#(.*))?/;
                            var result = str.match(parser);
                            return {
                                scheme: result[1] || null,
                                authority: result[2] || null,
                                path: result[3] || null,
                                query: result[4] || null,
                                fragment: result[5] || null
                            };
                        };
                        this.$get.$inject = ['$q', '$window', '$rootScope', '$injector'];
                    }
                    /**
                     * @description To return an object with page name and hierarchy by parsing the hash value (i.e. location.hash)
                     * @param hash: string
                     * @returns pageObj: { name: string, hierarchy: string }
                     */
                    DataLayerServiceProvider.prototype.parseHashValue = function (hash) {
                        var hashValue, pageName, hashValueParts, hashValueArr, rootHierarchy, pageObj = {};
                        if (_.has(this.config, 'advance.configOptions.rootHierarchy')) {
                            rootHierarchy = this.config.advance.configOptions.rootHierarchy;
                        }
                        // Removing query parameters from the URI
                        if (hash.indexOf('?') > 0) {
                            hash = hash.split('?')[0];
                        }
                        hashValueArr = hash.split('#/');
                        if (hashValueArr.length > 1) {
                            hashValue = hashValueArr[1]; // hashValueArr[0] will be empty string
                            hashValueParts = hashValue.split('/').join('|').toLowerCase().split('|');
                            pageName = hashValueParts[hashValueParts.length - 1];
                            if (rootHierarchy && rootHierarchy.length > 0) {
                                hashValueParts = rootHierarchy.concat(hashValueParts);
                            }
                            pageObj = {
                                name: pageName,
                                hierarchy: hashValueParts
                            };
                        }
                        return pageObj;
                    };
                    return DataLayerServiceProvider;
                }());
                angular.module('ute.datalayer.common').provider('ute.datalayer.common.service', DataLayerServiceProvider);
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerErrorTrack = (function () {
                    function UteDataLayerErrorTrack(dataLayerService, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var parsedErrorAttributes;
                            var mapping, errorCode = '', errorApi = '';
                            var selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                            var field;
                            var type;
                            var category;
                            if (_this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                $scope.$applyAsync(function () {
                                    try {
                                        parsedErrorAttributes = JSON.parse(attrs.adlErrorTrack);
                                        if (parsedErrorAttributes.mappingKey) {
                                            mapping = {
                                                mappingKey: parsedErrorAttributes.mappingKey
                                            };
                                        }
                                        if (parsedErrorAttributes.pageView) {
                                            selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                        }
                                        _this.getErrorPayload($scope, parsedErrorAttributes.callBackParam).then(function (payload) {
                                            field = _this.dataLayerService.returnConfig('advance.mappingKey.' + parsedErrorAttributes.field) || parsedErrorAttributes.field;
                                            category = _this.getErrorCategory(_.get(payload, 'category', ''), _.get(parsedErrorAttributes, 'category', ''));
                                            type = _this.getErrorType(_.get(payload, 'type', ''), _.get(parsedErrorAttributes, 'type', ''));
                                            _this.dataLayerService.trackError(payload, type, errorCode, element.text().trim(), category, field, errorApi, parsedErrorAttributes.isModalPopup, selectedSections, mapping);
                                        });
                                    }
                                    catch (err) {
                                        console.warn('Exception in error.track.directive: ', err);
                                    }
                                });
                            }
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerErrorTrack.factory = function () {
                        var directive = function (dataLayerService, $q, $state) { return new UteDataLayerErrorTrack(dataLayerService, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$q', '$state'];
                        return directive;
                    };
                    ;
                    /**
                     * @description To return the error category based on the passed in strings (cat has priority over cat2)
                     * @returns error category based on passed in strings or SELF_SERVE if category not found.
                     */
                    UteDataLayerErrorTrack.prototype.getErrorCategory = function (cat, cat2) {
                        if (cat && service.ErrorCategory[cat.toLocaleUpperCase()] >= 0) {
                            //From call back function
                            return service.ErrorCategory[cat.toLocaleUpperCase()];
                        }
                        else if (cat2 && service.ErrorCategory[cat2.toLocaleUpperCase()] >= 0) {
                            //From attributes
                            return service.ErrorCategory[cat2.toLocaleUpperCase()];
                        }
                        else {
                            //Default
                            return service.ErrorCategory.SELF_SERVE;
                        }
                    };
                    /**
                     * @description To return the error type based on the passed in strings (type has priority over type2)
                     * @returns error type based on passed in strings or FORM if type not found.
                     */
                    UteDataLayerErrorTrack.prototype.getErrorType = function (type, type2) {
                        if (type && service.ErrorType[type.toLocaleUpperCase()] >= 0) {
                            //From call back function
                            return service.ErrorType[type.toLocaleUpperCase()];
                        }
                        else if (type2 && service.ErrorType[type2.toLocaleUpperCase()] >= 0) {
                            //From attributes
                            return service.ErrorType[type2.toLocaleUpperCase()];
                        }
                        else {
                            //Default
                            return service.ErrorType.FORM;
                        }
                    };
                    UteDataLayerErrorTrack.prototype.getErrorPayload = function (scope, callbackParam) {
                        var errorPayload_cb, errorPayload_promise;
                        errorPayload_cb = this.dataLayerService.getCallbackByKey('errorPayload');
                        if (errorPayload_cb && callbackParam) {
                            errorPayload_promise = errorPayload_cb.callback(callbackParam);
                            return this.$q.when(errorPayload_promise)
                                .catch(function (error) {
                                console.warn('Error in handling getErrorPayload callback.');
                                return;
                            });
                        }
                        return this.$q.when({});
                    };
                    return UteDataLayerErrorTrack;
                }());
                angular.module('ute.datalayer.common').directive('adlErrorTrack', UteDataLayerErrorTrack.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var service;
            (function (service) {
                'use strict';
                var UteDataLayerEventTrack = (function () {
                    function UteDataLayerEventTrack(dataLayerService, $q, $state) {
                        var _this = this;
                        this.dataLayerService = dataLayerService;
                        this.$q = $q;
                        this.$state = $state;
                        this.restrict = 'A';
                        this.linkFn = function ($scope, element, attrs) {
                            var mapping;
                            var parsedEventAttributes;
                            var self = _this;
                            var selectedSections;
                            try {
                                parsedEventAttributes = JSON.parse(attrs.adlEventTrack);
                                if (!parsedEventAttributes.pageView || parsedEventAttributes.pageView.toString() === 'false' || _this.dataLayerService.isStateDefined(_this.$state.current.name)) {
                                    if (parsedEventAttributes.action) {
                                        element.on(parsedEventAttributes.action, function (event) {
                                            if (parsedEventAttributes.oneTimeAction) {
                                                element.off(parsedEventAttributes.action);
                                                parsedEventAttributes.oneTimeAction = false;
                                            }
                                            track();
                                        });
                                    }
                                    else {
                                        track();
                                    }
                                }
                            }
                            catch (err) {
                                console.warn('Exception in event.track.directive: ', err);
                            }
                            $scope.$on('$destroy', function () {
                                if (parsedEventAttributes && parsedEventAttributes.action) {
                                    element.off(parsedEventAttributes.action);
                                }
                            });
                            function track() {
                                $scope.$applyAsync(function () {
                                    try {
                                        selectedSections = [service.DataLayerPredefinedSection.ACCOUNT, service.DataLayerPredefinedSection.PAGE, service.DataLayerPredefinedSection.SITE];
                                        // Have to parse second time at the moment when event occurs to obtain updated evaluated expression
                                        parsedEventAttributes = JSON.parse(attrs.adlEventTrack);
                                        if (!(parsedEventAttributes.suppressTracking === true)) {
                                            if (parsedEventAttributes.pageView) {
                                                selectedSections.push(service.DataLayerPredefinedSection.PAGE_VIEW_EVENT);
                                            }
                                            if (parsedEventAttributes.mappingKey) {
                                                mapping = {
                                                    mappingKey: parsedEventAttributes.mappingKey
                                                };
                                            }
                                            self.getEventPayload($scope, parsedEventAttributes.callBackParam)
                                                .then(function (payload) {
                                                self.dataLayerService.track(payload, parsedEventAttributes.isModalPopup, selectedSections, mapping);
                                            });
                                        }
                                    }
                                    catch (err) {
                                        console.warn('Exception in event.track.directive: ', err);
                                    }
                                });
                            }
                        };
                        this.getEventPayload = function ($scope, callbackParam) {
                            var eventPayload_cb, eventPayload_promise;
                            eventPayload_cb = _this.dataLayerService.getCallbackByKey('eventPayload');
                            if (eventPayload_cb && callbackParam) {
                                eventPayload_promise = eventPayload_cb.callback(callbackParam);
                                return _this.$q.when(eventPayload_promise)
                                    .catch(function (error) {
                                    console.warn('Error in handling getEventPayload callback.');
                                    return;
                                });
                            }
                            return _this.$q.when({});
                        };
                        this.link = this.linkFn;
                    }
                    UteDataLayerEventTrack.factory = function () {
                        var directive = function (dataLayerService, $q, $state) { return new UteDataLayerEventTrack(dataLayerService, $q, $state); };
                        directive.$inject = ['ute.datalayer.common.service', '$q', '$state'];
                        return directive;
                    };
                    ;
                    return UteDataLayerEventTrack;
                }());
                angular.module('ute.datalayer.common').directive('adlEventTrack', UteDataLayerEventTrack.factory());
            })(service = common.service || (common.service = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                angular.module('ute.rogers.deeplink').run(addStateHandler);
                addStateHandler.$inject = ['ute.blocks.router', 'ute.rogers.deeplink.service'];
                /* @ngInject */
                function addStateHandler(routerHelper, deeplinkService) {
                    routerHelper.registerGlobalToStateHandler(deeplinkService, ute.blocks.router.StateHandlerPriority.HIGH);
                }
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var deeplink;
        (function (deeplink) {
            var service;
            (function (service) {
                'use strict';
                var DeeplinkProvider = (function () {
                    /* @ngInject */
                    function DeeplinkProvider() {
                        var _this = this;
                        this.config = {
                            signinState: 'signin',
                            signoutState: 'signout',
                            referer: 'referer'
                        }; // defaults
                        /* @ngInject */
                        this.$get = function ($state, $injector, $location, $window, $timeout) {
                            _this.$state = $state;
                            _this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.$location = $location;
                            _this.$window = $window;
                            _this.$timeout = $timeout;
                            var messagesService = $injector.get('ute.blocks.messages.bus.service');
                            //messagesService.register(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, this.signinSuccessfulHandler);
                            //messagesService.register(Messages.uteUserUnauthorized, (event: ng.IAngularEvent, ...args: any[]) => {
                            //  console.log('SigninService got a message:', event.name);
                            //  $state.go(this.environmentService.getProperty('apiUrls.signoutState'));
                            //});
                            messagesService.register(ute.blocks.messages.bus.Messages.uteUserUnauthorized, function (event) {
                                var args = [];
                                for (var _i = 1; _i < arguments.length; _i++) {
                                    args[_i - 1] = arguments[_i];
                                }
                                // console.log('DeeplinkService got a message:', event.name, /*args[0].toState.name*/ $state.current.name, $state.params);
                                _this.userService.unsigned();
                                _this.navigateToSignin($state.current, $state.params);
                                // $state.go(this.config.signoutState).then((data: any) => {
                                //   //console.log('signin.service->$state.go->then', data);
                                // }).catch((error: any) => {
                                //   //console.log('signin.service->$state.go->catch', error);
                                //   //this.$state.go();
                                // }).finally(() => {
                                //   //console.log('signin.service->$state.go->finally');
                                // });
                            });
                            _this.savedState = _this.storageService.get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
                            // if (_.get<string>(this.savedState, 'params.id')) {  // TODO all params
                            //   this.savedState.params.id = encodeURIComponent(this.savedState.params.id).replace(/%/g, '~');
                            // }
                            // console.log('DeeplinkService->restore from storage: savedState=', this.savedState);
                            return {
                                stateTransitionHandler: _this.stateTransitionHandler.bind(_this),
                                getDeeplinkState: _this.getDeeplinkState,
                                signinAndNavigate: _this.signinAndNavigate
                            };
                        };
                        /**
                         * TODO validation + defaults
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        /**
                         * @param toState - optional, if specified url will be ignored
                         * @param toParams - optional
                         * @param url - optional, full url, if not specified 'window.location.href' will be used
                         * @returns {boolean} - true if navigation Ok
                         */
                        this.navigateToSignin = function (toState, toParams, url) {
                            if (_this.config.signinUri || !angular.isDefined(toState)) {
                                _this.saveDeeplinkState({ name: url || _this.$window.location.href });
                                _this.$window.location.href = _this.config.signinUri;
                                return true;
                            }
                            else if (_this.config.signinState && angular.isDefined(toState)) {
                                _this.saveDeeplinkState({ name: toState.name, params: toParams });
                                _this.$state.go(_this.config.signinState);
                                return true;
                            }
                            return false;
                        };
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            //           console.log(`DeeplinkService->stateTransitionHandler: event.name=${event.name} toState=${toState.name} \
                            // isStateProtected=${this.securityService.isStateProtected(<ute.common.security.IState>toState)} fromState=${fromState.name} \
                            // isUserSigned=${this.userService.isSigned()} referer=${this.$location.search()[this.config.referer]} \
                            // toParams=`, toParams, ` toState.abstract=${toState.abstract} fromState.abstract=${fromState.abstract}`
                            //           );
                            // console.log('aaaaaaaaaa', !this.userService.isSigned(), !this.checkAndSaveReferer(), this.securityService.isStateProtected(<ute.common.security.IState>toState),
                            //     toState.name, _.get(this, 'savedState.name'));
                            //https://localhost.rogers.com:3000/web/totes/#/signin?lithium_forum=true&referer=http%253A%252F%252Fcommunityforums.rogers.com%252Ft5%252Fcommunity%252Fcategorypage%252Fcategory-id%252FEnglishCommunity%253Fprofile.language%253Den%2526lang%253Den
                            if (toState.name !== _.get(_this.savedState, 'name')) {
                                // console.log('00000000000000000', !this.userService.isSigned(), !this.checkAndSaveReferer(), this.securityService.isStateProtected(<ute.common.security.IState>toState));
                                if (!_this.userService.isSigned() && !_this.checkAndSaveReferer() && _this.securityService.isStateProtected(toState)) {
                                    event.preventDefault();
                                    return !_this.navigateToSignin(toState, toParams);
                                }
                                else if (_this.isDeepLinkable() && fromState.name && fromState.name !== _.get(_this.savedState, 'name') && !_.includes([_this.config.signinState, _this.config.signoutState], toState.name) && _this.userService.isSigned()) {
                                    // console.log('2222222222222222222', fromState.name, toState.name, this.config.signinState, this.isDeepLinkable(this.savedState), this.savedState);
                                    event.preventDefault();
                                    _this.transitToSavedState();
                                    return false;
                                }
                                else if (toState.name === _this.config.signinState && _this.userService.isSigned() && _this.isExternal(_this.$location.search()[_this.config.referer])) {
                                    // console.log('33333333333333333333333333');
                                    event.preventDefault();
                                    _this.$window.location.href = decodeURIComponent(_this.$location.search()[_this.config.referer]);
                                    return false;
                                }
                            }
                            return true;
                        };
                        this.getDeeplinkState = function () {
                            return _this.savedState;
                        };
                        /**
                         * If url is specified, navigate to it after signin, if not provided navigate to the current url
                         * @param url
                         */
                        this.signinAndNavigate = function (url) {
                            return _this.navigateToSignin(undefined, undefined, url);
                        };
                        /**
                         * Check if current windows.location has a 'referer' key, if yes save it for future use
                         * @returns {boolean} if current windows.location has a 'referer' key
                         */
                        this.checkAndSaveReferer = function () {
                            //console.log('DeeplinkService->checkAndSaveReferer: $state.current.name=', this.$state.current.name);
                            var referer = _this.$location.search()[_this.config.referer];
                            if (referer) {
                                return _this.saveDeeplinkState({ name: decodeURIComponent(referer) });
                            }
                            return false;
                        };
                        /**
                         * save valid provided routing state in memory and in persistent storage
                         * @param toState
                         * @returns {boolean} return true if state has been saved
                         */
                        this.saveDeeplinkState = function (toState) {
                            if (_this.isStateValid(toState.name) && (_this.isExternal(toState.name) || _this.securityService.isStateProtected(_this.$state.get(toState.name)))) {
                                // console.log('saveDeeplinkState:', toState);
                                _this.savedState = toState;
                                _this.storageService.put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE, toState);
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        //private signinSuccessfulHandler: (event: ng.IAngularEvent, ...args: any[]) => void = (event: ng.IAngularEvent, ...args: any[]) => {
                        //  console.log('DeeplinkService got a message', event);
                        //  if (this.transitToSavedState()) {
                        //    event.preventDefault();
                        //  }
                        //};
                        this.isStateValid = function (name) {
                            return _this.isExternal(name) || !!_this.$state.get(name);
                        };
                        this.isExternal = function (name) {
                            //console.log('isExternal:', 'name=', name);
                            return name && name.toLowerCase().indexOf('http') === 0;
                        };
                        this.isDeepLinkable = function () {
                            return !!_this.savedState;
                        };
                        this.transitToSavedState = function () {
                            var savedState = _this.savedState;
                            _this.savedState = undefined;
                            // console.log('transitToSavedState:', savedState);
                            _this.storageService.remove(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_DEEP_LINK_STATE);
                            _this.storageService.remove('toStateName'); // TODO
                            if (_this.isExternal(savedState.name)) {
                                // this.savedState = undefined;
                                _this.$window.location.href = savedState.name;
                            }
                            else {
                                // this.$timeout(() => {
                                // console.log('transitToSavedState->$state.go->before', savedState.name, savedState.params, this.$state.current);
                                _this.$state.go(savedState.name, savedState.params /*, {notify: false}*/).then(function (data) {
                                    // console.log('transitToSavedState->$state.go->then', data);
                                }).catch(function (error) {
                                    // console.log('transitToSavedState->$state.go->catch1', error);
                                    // myRogers cancel me because has it own deeplink
                                    _this.$state.go(savedState.name, savedState.params).catch(function (error) {
                                        // console.log('transitToSavedState->$state.go->catch2', error);
                                    });
                                }) /*.finally(() => {
                                 this.savedState = undefined;
                                 //console.log('transitToSavedState->$state.go->finally');
                                 })*/;
                            }
                        };
                        this.$get.$inject = [
                            '$state',
                            '$injector',
                            '$location',
                            '$window',
                            '$timeout'
                        ];
                    }
                    DeeplinkProvider.$inject = [];
                    return DeeplinkProvider;
                }());
                angular.module('ute.rogers.deeplink').provider('ute.rogers.deeplink.service', DeeplinkProvider);
            })(service = deeplink.service || (deeplink.service = {}));
        })(deeplink = rogers.deeplink || (rogers.deeplink = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            var DtmServiceProvider = (function () {
                /* @ngInject */
                function DtmServiceProvider() {
                    var _this = this;
                    this.isSatelliteExist = false;
                    this.config = {
                        basic: {
                            project: 'myrogers',
                            category: 'actv',
                            transaction: 'unknown',
                            isDebug: true,
                            enabled: true
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $timeout, $window) {
                        _this.$injector = $injector;
                        _this.$window = $window;
                        /*The _satellite argument is coming from application so this is an requirement meanwhile to have this dependency on a calling application */
                        _this.$dtm = $window._satellite;
                        _this.isSatelliteExist = !_.isEmpty(_this.$dtm);
                        _this.$timeout = $timeout;
                        _this.$cookies = $injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                        if (!_this.isSatelliteExist) {
                            console.warn('DTM error:', '$window._satellite does not exist!!');
                        }
                        return {
                            getConfig: _this.getConfig,
                            getVar: _this.getVar,
                            setVar: _this.setVar,
                            start: _this.start,
                            complete: _this.complete,
                            exception: _this.exception,
                            exceptionFormField: _this.exceptionFormField,
                            exceptionFormFieldWithPrefix: _this.exceptionFormFieldWithPrefix,
                            fireDtmExceptions: _this.fireDtmExceptions,
                            noAction: _this.noAction,
                            track: _this.track,
                            direct: _this.direct,
                            trackAccountNumber: _this.trackAccountNumber,
                            trackCTN: _this.trackCTN
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        if (_.isEmpty(_this.config.basic.project)) {
                            console.error('project:', 'Config Provider should override project with valid Project name');
                            return false;
                        }
                        if (_.isEmpty(_this.config.basic.category)) {
                            console.error('category:', 'Config Provider should override category with valid Category name');
                            return false;
                        }
                        return true;
                    };
                    /**
                     * @returns {IDtmServiceConfig}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /**
                     * @function
                     * @description Alias to _satellite.getVar()
                     * @param {String} key - Key to get
                     * @return {String} Value of Key
                     * @memberof Factories.dtmService
                     */
                    this.getVar = function (key) {
                        try {
                            if (!_this.isSatelliteExist) {
                                return '';
                            }
                            return _this.$dtm.getVar(key);
                        }
                        catch (error) {
                            console.log(error);
                        }
                    };
                    /**
                     * @function
                     * @description Alias to _satellite.setVar()
                     * @param {String} key - Key to set to
                     * @param {String} value - Value to set
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.setVar = function (key, value) {
                        try {
                            if (!_this.isSatelliteExist) {
                                return;
                            }
                            _this.$dtm.setVar(key, value);
                        }
                        catch (error) {
                            console.log(error);
                        }
                    };
                    /**
                     * @function
                     * @description Track a "start" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.start = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.START);
                    };
                    /**
                     * @function
                     * @description Track a "complete" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.complete = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.COMPLETE);
                    };
                    /**
                     * @function
                     * @description Track an "error" action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} message - Error message to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.exception = function (transaction, message, cat) {
                        if (!_.isEmpty(message) && _this.config.basic.isDebug) {
                            console.log(message);
                        }
                        _this.setVar(service.DtmServiceAction.EXCEPTION, message);
                        _this.track(transaction, cat || _this.config.basic.category, service.DtmServiceAction.EXCEPTION);
                    };
                    /**
                 * @function
                 * @description Track a Form Field Validation "error" action
                 * @param {String} transaction - Transaction name to use
                 * @param {Object} $element - jQuery $element to get the message form
                 * @param {String} cat - Category name to use, usually "actv" or "pasv"
                 * @return {Object} Fluent interface, this object
                 * @memberof Factories.dtmService
                 */
                    this.exceptionFormField = function (transaction, element, cat) {
                        _this.$timeout(function () {
                            var message = element.parent().text().trim();
                            if (message) {
                                _this.exception(transaction, message, cat || _this.config.basic.category);
                            }
                        }, 500);
                    };
                    /**
                       * @function
                       * @description Track a Form Field Validation "error" action with prefix for error message
                       * @param {String} transaction - Transaction name to use
                       * @param {Object} $element - jQuery $element to get the message form
                       * @param {String} errorPrefix - this value will be prefixed to the error message.
                       *                 typical usage, type of error, usually "CS" (client side error) or "SS" (server side error)
                       * @param {String} cat - Category name to use, usually "actv" or "pasv"*
                       * @return {Object} Fluent interface, this object
                       * @memberof Factories.dtmService
                       */
                    this.exceptionFormFieldWithPrefix = function (transaction, element, errorPrefix, errorCode, errorMessage, errorUrl, cat) {
                        _this.$timeout(function () {
                            var message = element.parent().text().trim();
                            if (errorMessage && errorCode) {
                                _this.exception(transaction, errorPrefix + '|' + errorUrl + '|' + '|' + errorCode + '|' + errorMessage + '|', cat || _this.config.basic.category);
                            }
                            else if (message) {
                                _this.exception(transaction, errorPrefix + '|' + message, cat || _this.config.basic.category);
                            }
                        }, 500);
                    };
                    this.fireDtmExceptions = function (ruleName, errorMessages, errorSource) {
                        _this.$timeout(function () {
                            if (_.isArray(errorMessages)) {
                                angular.forEach(errorMessages, function (errorMessage) {
                                    //decoding errorMessage because sometimes it may contain encoded special french characters
                                    errorMessage = angular.element('<i>').html(errorMessage).text();
                                    if (errorSource && errorSource.length > 0) {
                                        errorMessage = errorSource + '|' + errorMessage;
                                    }
                                    _this.exception(ruleName, errorMessage);
                                });
                            }
                            else if (typeof errorMessages === 'object') {
                                var extractedErrorMessage = _this.extractErrorMessage(errorMessages);
                                if (errorSource && errorSource.length > 0) {
                                    extractedErrorMessage = errorSource + '|' + extractedErrorMessage;
                                }
                                _this.exception(ruleName, extractedErrorMessage);
                            }
                        });
                    };
                    /**
                     * @function
                     * @description Track a "no action"
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.noAction = function (transaction, cat) {
                        _this.track(transaction, cat || _this.config.basic.category);
                    };
                    /**
                     * @function
                     * @description Track an action
                     * @param {String} transaction - Transaction name to use
                     * @param {String} cat - Category name to use, usually "actv" or "pasv"
                     * @param {String} action - Action name to use
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.track = function (transaction, cat, action) {
                        try {
                            if (!_this.isSatelliteExist) {
                                return;
                            }
                            var value = [
                                cat || _this.config.basic.category,
                                _this.config.basic.project,
                                transaction
                            ];
                            if (!_.isEmpty(action)) {
                                value.push(action);
                            }
                            var stringValue = value.map(function (o) { return o.valueOf(); }).join('-');
                            if (_this.config.basic.isDebug) {
                                console.log(stringValue);
                            }
                            _this.$dtm.track(stringValue);
                        }
                        catch (error) {
                            console.log(error);
                        }
                    };
                    /**
                     * @function
                     * @description Track an action
                     * @param {String} method - Method name to use
                     * @return {Object} Fluent interface, this object
                     * @memberof Factories.dtmService
                     */
                    this.direct = function (method) {
                        try {
                            if (!_this.isSatelliteExist) {
                                return;
                            }
                            _this.$dtm.track(method);
                            if (_this.config.basic.isDebug) {
                                console.log(method);
                            }
                        }
                        catch (error) {
                            console.log(error);
                        }
                    };
                    this.trackAccountNumber = function (accountNumber, ruleName) {
                        if (!_this.isSatelliteExist) {
                            return;
                        }
                        _this.$timeout(function () {
                            accountNumber = String(accountNumber);
                            ruleName = ruleName || _this.config.basic.project + '-BAN';
                            var currentAccountNumber = _this.$window.localStorage.getItem('accountNumberForDTMTracking');
                            if (accountNumber !== currentAccountNumber) {
                                var encryptedBAN = _this.$window.cryptoJS.SHA256(accountNumber).toString();
                                _this.$cookies.put('uidenc3', encryptedBAN);
                                _this.setVar('encryptedBAN', encryptedBAN);
                                _this.direct(ruleName);
                                _this.$window.localStorage.setItem('accountNumberForDTMTracking', accountNumber);
                            }
                        });
                    };
                    this.trackCTN = function (ctn, ruleName) {
                        if (!_this.isSatelliteExist) {
                            return;
                        }
                        _this.$timeout(function () {
                            ctn = String(ctn);
                            ruleName = ruleName || _this.config.basic.project + '-CTN';
                            var currentCTN = _this.$window.localStorage.getItem('CTNForDTMTracking');
                            if (ctn !== currentCTN) {
                                var encryptedCTN = _this.$window.cryptoJS.SHA256(ctn).toString();
                                _this.$cookies.put('uidenc4', encryptedCTN);
                                _this.setVar('isCtnSet', 'true');
                                _this.setVar('encryptedCTN', encryptedCTN);
                                _this.direct(ruleName);
                                _this.$window.localStorage.setItem('CTNForDTMTracking', ctn);
                            }
                        });
                    };
                    this.extractErrorMessage = function (errorObj) {
                        var error;
                        if (_.has(errorObj, 'error.errorMessage')) {
                            error = errorObj.error.errorMessage;
                        }
                        else if (_.has(errorObj, 'data.errorMessage')) {
                            error = errorObj.data.errorMessage;
                        }
                        else if (_.has(errorObj, 'data.data.errorMessage')) {
                            error = errorObj.data.data.errorMessage;
                        }
                        else if (_.has(errorObj, 'data.status')) {
                            error = errorObj.data.status.code + ' - ' + errorObj.data.status.codeName;
                        }
                        else {
                            error = errorObj.status + ' - ' + errorObj.statusText;
                        }
                        return error;
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$timeout',
                        '$window'
                    ];
                }
                DtmServiceProvider.$inject = [];
                return DtmServiceProvider;
            }());
            angular.module('ute.dtm.service').provider('ute.dtm.service', DtmServiceProvider);
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            angular.module('ute.dtm.service').directive('uteDtmErrorFormField', UteDtmErrorFormField);
            UteDtmErrorFormField.$inject = ['ute.dtm.service'];
            /* @ngInject */
            function UteDtmErrorFormField(dtmService) {
                return {
                    restrict: 'E',
                    scope: { key: '=key', errorPrefix: '@errorPrefix', errorCode: '@errorCode', errorUrl: '@errorUrl', errorMessage: '@errorMessage' },
                    link: function ($scope, $element, attrs) {
                        if ($scope.key && $scope.errorPrefix && $scope.errorCode) {
                            dtmService.exceptionFormFieldWithPrefix($scope.key, $element, $scope.errorPrefix, $scope.errorCode, $scope.errorMessage, $scope.errorUrl);
                        }
                        else if ($scope.key && $scope.errorPrefix) {
                            dtmService.exceptionFormFieldWithPrefix($scope.key, $element, $scope.errorPrefix);
                        }
                        else if ($scope.key) {
                            dtmService.exceptionFormField($scope.key, $element);
                        }
                    }
                };
            }
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            angular.module('ute.dtm.service').directive('uteDataLayerErrorFormField', UteDataLayerErrorFormField);
            UteDataLayerErrorFormField.$inject = ['ute.dtm.dataLayer.service', '$timeout'];
            /* @ngInject */
            function UteDataLayerErrorFormField(dataLayerService, $timeout) {
                return {
                    restrict: 'A',
                    scope: {
                        fireDataLayer: '=',
                        errorPayload: '=',
                        isModalPopup: '=',
                        dataLayerErrorType: '='
                    },
                    link: function ($scope, $element, attrs) {
                        if (!($scope.fireDataLayer === false)) {
                            $scope.$applyAsync(function () {
                                dataLayerService.trackError($scope.errorPayload, service.ErrorType.FORM, '', $element.text().trim(), !!$scope.isModalPopup, [service.DataLayerPredefinedSection.ACCOUNT, ute.dtm.service.DataLayerPredefinedSection.PAGE_VIEW_EVENT, service.DataLayerPredefinedSection.SITE]);
                            });
                        }
                    }
                };
            }
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            'use strict';
            var DtmDataLayerServiceProvider = (function () {
                /* @ngInject */
                function DtmDataLayerServiceProvider() {
                    var _this = this;
                    this.is_trackDataFunctionExist = (typeof (_trackData) === 'function');
                    this.config = {
                        basic: {
                            site: {
                                name: 'R'
                            },
                            signin: {
                                type: 'MyRogers'
                            }
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $q) {
                        _this.$injector = $injector;
                        _this.languageSwitcher = _this.$injector.get('ute.blocks.language.switcher');
                        _this.provinceService = _this.$injector.get('ute.blocks.province.service');
                        _this.userService = _this.$injector.get('ute.common.user.service');
                        _this.accountOverviewFactory = _this.$injector.get('ute.rogers.account.overview.factory');
                        _this.browserService = _this.$injector.get('ute.common.core.browser.service');
                        _this.$q = $q;
                        return {
                            getConfig: _this.getConfig,
                            dataLayerTrack: _this.dataLayerTrack,
                            trackError: _this.trackError,
                            trackErrors: _this.trackErrors
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {IDataLayerServiceConfig}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    this.dataLayerTrack = function (payload, isModalPopup, selectedSections) {
                        if (isModalPopup === void 0) { isModalPopup = false; }
                        /**
                         * Check _trackData exist before calling it
                         */
                        try {
                            /**
                             * Make sure the tracking library has loaded and _trackData is a function
                             */
                            if (!_this.is_trackDataFunctionExist) {
                                return;
                            }
                            /**
                             * Merge make a payment payload to bacic information like site, page signin and account
                             */
                            if (selectedSections !== null && selectedSections !== undefined && selectedSections.length > 0) {
                                _this.mergeSelectedInformation(payload, isModalPopup, selectedSections)
                                    .then(function (payload) {
                                    _trackData(payload);
                                });
                            }
                            else {
                                _trackData(payload);
                            }
                        }
                        catch (error) {
                            console.error('data layer tracking', error);
                        }
                        return;
                    };
                    this.trackErrors = function (payload, trackingErrors, isModalPopup, selectedSections) {
                        if (isModalPopup === void 0) { isModalPopup = false; }
                        /**
                         * Check _trackData exist before calling it
                         */
                        try {
                            /**
                             * Make sure the tracking library has loaded and _trackData is a function
                             */
                            if (!_this.is_trackDataFunctionExist) {
                                return;
                            }
                            var errors = trackingErrors;
                            var event_1 = {
                                error: true
                            };
                            /**
                             * set Error Type to lowercase
                             * and Decode HTML entity for message
                             */
                            errors.map(function (err) {
                                err.type = err.type.toLocaleLowerCase();
                                err.message = angular.element('<textarea />').html(err.message).text();
                            });
                            var _payload = {
                                errors: errors,
                                events: event_1
                            };
                            if (angular.isObject(payload)) {
                                _.merge(payload, _payload);
                            }
                            _this.dataLayerTrack(payload, isModalPopup, selectedSections);
                        }
                        catch (error) {
                            console.error('data layer tracking', error);
                        }
                        return;
                    };
                    this.trackError = function (payload, errorType, errorCode, errorMessage, isModalPopup, selectedSections) {
                        if (isModalPopup === void 0) { isModalPopup = false; }
                        /**
                         * Check _trackData exist before calling it
                         */
                        try {
                            /**
                             * Make sure the tracking library has loaded and _trackData is a function
                             */
                            if (!_this.is_trackDataFunctionExist) {
                                return;
                            }
                            var errors = [];
                            var error = {
                                type: service.ErrorType[errorType],
                                code: errorCode,
                                message: errorMessage
                            };
                            errors.push(error);
                            _this.trackErrors(payload, errors, isModalPopup, selectedSections);
                        }
                        catch (error) {
                            console.error('data layer tracking', error);
                        }
                        return;
                    };
                    this.selectionContainsAccount = function (selectedSections) {
                        return (selectedSections.filter(function (item) { return (item === service.DataLayerPredefinedSection.ACCOUNT); }).length >= 1);
                    };
                    this.mergeSelectedInformation = function (payload, isModalPopup, selectedSections) {
                        var deferred = _this.$q.defer();
                        try {
                            if (_this.selectionContainsAccount(selectedSections)) {
                                _this.getAccountObject().then(function (dataLayerAccount) {
                                    _.merge(payload, { account: dataLayerAccount });
                                    _.merge(payload, _this.mergeSelectedInformationWithoutAcc(payload, isModalPopup, selectedSections));
                                    deferred.resolve(payload);
                                });
                            }
                            else {
                                _.merge(payload, _this.mergeSelectedInformationWithoutAcc(payload, isModalPopup, selectedSections));
                                deferred.resolve(payload);
                            }
                        }
                        catch (error) {
                            console.error('Merge selected tracking data', error);
                            deferred.reject();
                        }
                        return deferred.promise;
                    };
                    this.mergeSelectedInformationWithoutAcc = function (payload, isModalPopup, selectedSections) {
                        try {
                            /**
                             * Populate selected payload information
                             */
                            selectedSections.forEach(function (section) {
                                switch (section) {
                                    case service.DataLayerPredefinedSection.PAGE:
                                        _.merge(payload, { page: _this.getPageObject(isModalPopup) });
                                        break;
                                    case service.DataLayerPredefinedSection.PAGE_VIEW_EVENT:
                                        _.merge(payload, { events: _this.getPageViewEventObject() });
                                        break;
                                    case service.DataLayerPredefinedSection.SIGNIN:
                                        _.merge(payload, { signin: _this.getSigninObject() });
                                        break;
                                    case service.DataLayerPredefinedSection.SITE:
                                        _.merge(payload, { site: _this.getSiteObject() });
                                        break;
                                    default:
                                }
                            });
                            return payload;
                        }
                        catch (error) {
                            console.error('Merge selected tracking data', error);
                        }
                    };
                    this.getPageObject = function (isModalPopup) {
                        var returnObject = {
                            language: _this.languageSwitcher.getCurrentLanguage(),
                            province: _this.provinceService.getCurrentProvince().toLowerCase(),
                            url: isModalPopup ? 'modal popup' : location.href,
                            referrer: isModalPopup ? location.href : document.referrer,
                            ICMTimestamp: moment().format('dddd|MM/DD/YYYY HH:mm'),
                            responsiveVersion: _this.browserService.isMobile() ? 'mobile' : 'desktop'
                        };
                        return returnObject;
                    };
                    this.getSiteObject = function () {
                        var returnObject = {
                            name: _this.getConfig().basic.site.name
                        };
                        return returnObject;
                    };
                    this.getSigninObject = function () {
                        var returnObject = {
                            type: _this.getConfig().basic.signin.type
                        };
                        return returnObject;
                    };
                    this.getPageViewEventObject = function () {
                        var returnObject = {
                            pageView: true
                        };
                        return returnObject;
                    };
                    /**
                     * Get Account object in data layer format
                     * this function will return a promise
                     */
                    this.getAccountObject = function () {
                        var deferred = _this.$q.defer();
                        /**
                         * Populate user information from user service
                         */
                        var returnObject = {
                            type: '',
                            userType: _this.userService.getUserType(),
                            userName: _this.userService.getUser().userName,
                            BAN: ''
                        };
                        /**
                         * Get selected Account information
                         */
                        _this.accountOverviewFactory().getSelectedAccount()
                            .then(function (account) {
                            returnObject.type = account.accountType;
                            returnObject.BAN = account.accountNumber.toString();
                        })
                            .catch(function (error) {
                            console.error('get Account object:', error);
                        })
                            .finally(function () {
                            deferred.resolve(returnObject);
                        });
                        return deferred.promise;
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$q'
                    ];
                }
                DtmDataLayerServiceProvider.$inject = [];
                return DtmDataLayerServiceProvider;
            }());
            angular.module('ute.dtm.service').provider('ute.dtm.dataLayer.service', DtmDataLayerServiceProvider);
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                var ErrorType = ute.datalayer.common.service.ErrorType;
                var ErrorCategory = ute.datalayer.common.service.ErrorCategory;
                (function (STEP) {
                    STEP[STEP["MAIN"] = 0] = "MAIN";
                    STEP[STEP["ACCOUNT"] = 1] = "ACCOUNT";
                    STEP[STEP["EMAIL"] = 2] = "EMAIL";
                    STEP[STEP["VERIFY"] = 3] = "VERIFY";
                    STEP[STEP["PASSWORD"] = 4] = "PASSWORD";
                    STEP[STEP["COMPLETE"] = 5] = "COMPLETE";
                })(registration.STEP || (registration.STEP = {}));
                var STEP = registration.STEP;
                (function (SUBSTEP) {
                    SUBSTEP[SUBSTEP["MAIN"] = 0] = "MAIN";
                    SUBSTEP[SUBSTEP["NUMBER"] = 1] = "NUMBER";
                    SUBSTEP[SUBSTEP["VERIFY_SMS"] = 2] = "VERIFY_SMS";
                    SUBSTEP[SUBSTEP["EMAIL"] = 3] = "EMAIL";
                    SUBSTEP[SUBSTEP["VERIFY"] = 4] = "VERIFY";
                    SUBSTEP[SUBSTEP["PASSWORD"] = 5] = "PASSWORD";
                    SUBSTEP[SUBSTEP["COMPLETE"] = 6] = "COMPLETE";
                })(registration.SUBSTEP || (registration.SUBSTEP = {}));
                var SUBSTEP = registration.SUBSTEP;
                var EasyLoginRegistrationController = (function () {
                    function EasyLoginRegistrationController(easyLoginRegistrationService, $window, $state, $modal, dataLayerService, $translate, $injector, $timeout, vcRecaptchaService, util, fraudLoggingService, transactionProp) {
                        var _this = this;
                        this.easyLoginRegistrationService = easyLoginRegistrationService;
                        this.$window = $window;
                        this.$state = $state;
                        this.$modal = $modal;
                        this.dataLayerService = dataLayerService;
                        this.$translate = $translate;
                        this.$injector = $injector;
                        this.$timeout = $timeout;
                        this.vcRecaptchaService = vcRecaptchaService;
                        this.util = util;
                        this.fraudLoggingService = fraudLoggingService;
                        this.transactionProp = transactionProp;
                        this.STEP = STEP; // Reference for template
                        this.devicePlatform = this.getDevicePlatform();
                        //DC-2680: Temp token fix
                        this.blockRecaptcha = false;
                        this.rogersErrorMap = {
                            "OT05ON18ET21-InvalidRealm": {
                                code: "eck5",
                                type: "USER",
                            },
                            "OT05ON18ET23-Invalid_Account": {
                                code: "eck5",
                                type: "USER",
                            },
                            "OT05ON18ET25-InvalidPostalcode": {
                                code: "eck5",
                                type: "USER",
                            },
                            "OT05ON18ET23-InvalidAccount": {
                                code: "eck5",
                                type: "USER",
                            },
                            "OT05ON21ET20-accountNumber": {
                                code: "eck5",
                                type: "USER",
                            },
                            "OT13ON40ET28-EMAIL_ALREADY_LINKED": {
                                code: "ecd5",
                                type: "USER",
                            },
                            "OT05ON18ET24-InvalidAccountStatus": {
                                code: "eck6",
                                type: "BUSINESS_LOGIC",
                            },
                            "OT18ON37ET19-ACCOUNT_ALREADY_LINKED": {
                                code: "eck7",
                                type: "USER",
                            },
                            'OT13ON40ET19-ACCOUNT_NO_ALREADY_LINKED': {
                                code: "eck8",
                                type: "USER",
                            },
                            "OT18ON18ET19-AccountLinkedWithDifferentProfile": {
                                code: "eck8",
                                type: "HTTP",
                            },
                            "OT31ON39ET30-TokenExpired": {
                                code: "eck9",
                                type: "BUSINESS_LOGIC",
                            },
                            "OT23ON32ET29-TokenInvalid": {
                                code: "eck9",
                                type: "USER",
                            },
                            "OT31ON39ET31-TokenNotFound": {
                                code: "eck11",
                                type: "USER",
                            },
                            "OT19ON38ET22-ROGERS_BUSSINESS_ACCOUNT": {
                                code: "ecf5",
                                type: "USER",
                            },
                            "OT05ON00ET10-password": {
                                code: "ech2",
                                type: 'USER'
                            },
                            /*
                              OT05ON19ET07-RecaptchaResponseError
                              OT05ON45ET09-MissingRecaptch
                              OT05ON00ET10-Missing Realm
                              OT46ON64ET58-EIFException
                              OT12ON28ET05-ServiceTimedOut
                              OT03ON59ET57-DBException
                              OT46ON38ET27-CONSUMER_ACC_NOT_FOUND
                              SV056-OT05ON00ET10-emailToken
                              OT05ON00ET10-email
                              OT05ON00ET09-email
                              OT05ON00ET10-password
                              OT05ON00ET10-accountNumber
                              OT05ON00ET10-postalCode
                              OT05ON00ET09-language
                              OT05ON45ET09-MissingRecaptcha
                              OT32ON40ET05-SendEmailFailure
                              OT00ON00ET36-Err
                            */
                            default: { code: "ecp2", type: "HTTP" },
                        };
                        this.errorCodeDefault = 'ecp2';
                        this.fraudTransactionPayload = {};
                        /*  Rogers Micro Services Interfaces Start */
                        // step 1
                        this.rogersAccountForm = function () {
                            var accountValid = _this.validateAcccountField(_this.accountForm.accountNumber);
                            var postalValid = _this.validatePostalField(_this.accountForm.postalCode);
                            if (accountValid && postalValid) {
                                if (_this.blockRecaptcha) {
                                    _this.blockRecaptcha = true;
                                    _this.rogerscaptchaVerified(_this.patToken);
                                }
                                else {
                                    _this.vcRecaptchaService.execute();
                                }
                            }
                            else {
                                angular.element("#accountNumber-field").focus();
                            }
                        };
                        this.rogerscaptchaVerified = function (response) {
                            _this.accountModel.captcha = response;
                            var captchaValid = _this.validateCaptcha();
                            if (captchaValid) {
                                _this.setLoadingIndicators(true);
                                if (_this.isSubscriberFlow) {
                                    _this.requestPhoneNumberVerification(_this.accountModel);
                                }
                                else {
                                    _this.rogerscheckIfAccountNumberExists();
                                }
                            }
                        };
                        // step 1
                        this.rogerscheckIfAccountNumberExists = function () {
                            _this.easyLoginRegistrationService
                                .rogersRequestAccountNumber(_this.accountModel)
                                .then(function (response) {
                                var res = response.data;
                                _this.successAccountHandling(res);
                                _this.setLoadingIndicators(false, true);
                            })
                                .catch(function (e) {
                                _this.setLoadingIndicators(false, false, true);
                                _this.errorAccountHandling(e.data);
                            });
                        };
                        // step 1
                        this.successAccountHandling = function (res) {
                            // this.accountModel.rogersAccountResponse = res;   // TODO fix
                            _this.accountModel.accountError = "error_null";
                            _this.accountModel.postalError = "error_null";
                            _this.accountModel.generalError = "error_null";
                            _this.accountModel.captchaError = "error_null";
                            _this.$timeout(function () {
                                _this.setLoadingIndicators(false, false, false);
                                _this.changeStep(_this.STEP.EMAIL);
                            }, 200);
                        };
                        // step 1
                        this.errorAccountHandling = function (res) {
                            var error = res.errors ? _.first(res.errors) : { code: 'AN05-SY11-SV084-OT00ON00ET36-Err' };
                            var errorCode = error.code.split('-').slice(3).join('-');
                            var maskedEmail = _this.maskEmailAddress(_.get(error, "data.maskedEmailId", ""));
                            var accountNumber = _.get(error, "data.accountNumber", "");
                            // if (
                            //   errorCode ===
                            //   "OT35ON18ET18-UnfinishedRegistrationSession"
                            // ) {
                            //   // to resend verification step
                            //   this.isAutoRegistrationStarted = true;
                            //   this.setLoadingIndicators(false, false, false);
                            //   this.emailModel.maskedEmail = maskedEmail;
                            // }
                            //Reset captcha If Account number does not exists.
                            _this.accountModel.captcha = null;
                            if (!_this.blockRecaptcha) {
                                _this.vcRecaptchaService.reload();
                            }
                            // if (
                            //   errorCode !==
                            //   "OT35ON18ET18-UnfinishedRegistrationSession"
                            // ) {
                            var code = _this.rogersErrorMap[errorCode]
                                ? _this.rogersErrorMap[errorCode]
                                : _this.rogersErrorMap["default"];
                            if (errorCode === "OT18ON37ET19-ACCOUNT_ALREADY_LINKED") {
                                _this.emailModel.maskedEmail = maskedEmail;
                            }
                            _this.errorCodeType = code;
                            _this.accountModel.generalError = code.code;
                            try {
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.account.page }, ErrorType[_this.errorCodeType.type], error.code ? error.code : "", _this.getErrorMessage("ute.easy.login.error." + _this.accountModel.generalError, res), ErrorCategory.SELF_SERVE, "", "Check Account", false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                            catch (e) {
                                console.log("An error occured during data layer track" + e);
                            }
                            // }
                            if (_this.isAutoRegistrationStarted) {
                                _this.dataLayerService.track(_this.dataLayerConfig.great_news, false, [
                                    DataLayerPredefinedSection.PAGE,
                                    DataLayerPredefinedSection.SITE,
                                ]);
                            }
                        };
                        // step2
                        this.rogersEmailFormValidation = function (form) {
                            var validEmail = _this.validateEmail(form.email);
                            var validConfirm = _this.validateConfirmEmail();
                            if (validEmail && !validConfirm) {
                                _this.emailModel.generalError = "ech3";
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.email.page }, ErrorType.FORM, "", _this.sanitizeText(_this.$translate.instant("ute.easy.login.error." + _this.emailModel.generalError)), ErrorCategory.SELF_SERVE, "Confirm Email Address", "", false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                            else if (!validEmail || !validConfirm) {
                                _this.emailModel.generalError = "error_null";
                            }
                            else if (validEmail && validConfirm) {
                                if (_this.sendToDifferentEmailInitiated) {
                                    _this.rogersResendEmail(null, "send");
                                }
                                else {
                                    _this.rogersTryEmailCreation({
                                        email: _this.emailModel.email,
                                        language: _this.getCurrentLanguage().toLowerCase(),
                                        accountNumber: _this.accountModel.accountNumber,
                                        postalCode: _this.accountModel.postalCode,
                                    });
                                }
                            }
                        };
                        // step2
                        this.rogersResendEmail = function (token, type) {
                            var _payload = {
                                language: _this.getCurrentLanguage().toLowerCase(),
                                accountNumber: _this.accountModel.accountNumber,
                                postalCode: _this.accountModel.postalCode,
                            };
                            if (_this.emailModel.email !== "") {
                                _payload.email = _this.emailModel.email;
                            }
                            _this.trackEmailResend({ selfServeStart: true });
                            _this.rogersTryEmailCreation(_payload, token, type);
                        };
                        // step2
                        this.rogersTryEmailCreation = function (payload, token, mode) {
                            _this.getLoadingIndicators(mode, true);
                            if (payload.postalCode) {
                                payload.postalCode = payload.postalCode.replace(/\s/g, "");
                            }
                            if (token !== null && token !== undefined) {
                                payload.token = token;
                            }
                            if (mode === "send") {
                                _this.accountModel.sendEmailButtonText =
                                    "ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode";
                            }
                            else if (mode === "resend" || mode === "") {
                                if (_this.isResendEmail) {
                                    _this.accountModel.reSendButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode";
                                }
                                else {
                                    _this.accountModel.sendEmailButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode";
                                }
                            }
                            _this.easyLoginRegistrationService
                                .rogersRequestEmail(payload)
                                .then(function (response) {
                                var res = response.data;
                                _this.rogersSuccessEmailHandling(payload.action, mode);
                            })
                                .catch(function (e) {
                                _this.rogersEmailErrorHandling(e.data, mode);
                                _this.getLoadingIndicators(mode, false, false, true);
                                if (mode === "send") {
                                    _this.accountModel.sendEmailButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                    _this.accountModel.disableState = true;
                                }
                                else if (mode === "resend" || mode === "") {
                                    if (_this.isResendEmail) {
                                        _this.accountModel.reSendButtonText =
                                            "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                        _this.resendState = true;
                                    }
                                    else {
                                        _this.accountModel.sendEmailButtonText =
                                            "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                        _this.accountModel.disableState = true;
                                    }
                                }
                            });
                        };
                        // step 2
                        this.rogersSuccessEmailHandling = function (
                            // res: RResponseFieldError,
                            action, mode) {
                            _this.getLoadingIndicators(mode, false, true);
                            if (action === "resend") {
                                _this.trackEmailResend({ selfServeComplete: true });
                            }
                            _this.accountModel.requestCounter += 1;
                            if (mode === "send") {
                                _this.accountModel.sendEmailButtonText =
                                    "ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent";
                                _this.accountModel.disableState = true;
                            }
                            else if (mode === "resend" || mode === "") {
                                if (_this.isResendEmail) {
                                    _this.accountModel.reSendButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent";
                                    _this.resendState = true;
                                }
                                else {
                                    _this.accountModel.sendEmailButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent";
                                    _this.accountModel.disableState = true;
                                }
                            }
                            if ((!_this.isAutoRegistrationStarted && _this.step !== _this.STEP.VERIFY) ||
                                _this.sendToDifferentEmailInitiated) {
                                _this.$timeout(function () {
                                    _this.setLoadingIndicators(false, false, false);
                                    _this.changeStep(_this.STEP.VERIFY);
                                }, 200);
                            }
                            _this.sendToDifferentEmailInitiated = false;
                        };
                        // step 2
                        this.rogersEmailErrorHandling = function (res, mode) {
                            _this.emailModel.maskedEmail = _.get(res, "data.maskedEmailId", "");
                            var error = res.errors ? _.first(res.errors) : { code: 'AN05-SY11-SV084-OT00ON00ET36-Err' };
                            var statusCode = error.code.split('-').slice(3).join('-');
                            if (statusCode === "OT00ON00ET36-Err") {
                                _this.getLoadingIndicators(mode, false, false, true);
                                if (mode === "send") {
                                    _this.accountModel.sendEmailButtonText =
                                        "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                    _this.accountModel.disableState = true;
                                }
                                else if (mode === "resend" || mode === "") {
                                    if (_this.isResendEmail) {
                                        _this.accountModel.reSendButtonText =
                                            "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                        _this.resendState = true;
                                    }
                                    else {
                                        _this.accountModel.sendEmailButtonText =
                                            "ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs";
                                        _this.accountModel.disableState = true;
                                    }
                                }
                            }
                            var code = _this.rogersErrorMap[statusCode]
                                ? _this.rogersErrorMap[statusCode]
                                : _this.rogersErrorMap["default"];
                            _this.errorCodeType = code;
                            _this.emailModel.generalError = code.code;
                            var pagePayload = _this.getEmailErrorPayload();
                            try {
                                _this.dataLayerService.trackError({ page: pagePayload }, ErrorType[_this.errorCodeType.type], error.code ? error.code : '', _this.getErrorMessage("ute.easy.login.error." + _this.emailModel.generalError, res), ErrorCategory.SELF_SERVE, "", "Create Email", false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                            catch (e) {
                                console.log("An error occured during data layer track" + e);
                            }
                            _this.sendToDifferentEmailInitiated = true;
                        };
                        // step 4 start
                        this.rogersValidatePassword = function (form) {
                            var trackErrorFlag = false;
                            if (_this.passwordModel.password === "" ||
                                _this.passwordModel.confirmPassword === "") {
                                _this.passwordModel.generalError = "ech1";
                                trackErrorFlag = true;
                            }
                            else if (!_this.passwordModel.confirmPasswordIsValid) {
                                _this.passwordModel.generalError = "ech3";
                                trackErrorFlag = true;
                            }
                            else if (!_this.passwordModel.passwordIsValid ||
                                !_this.passwordModel.passwordIsEnough) {
                                _this.passwordModel.generalError = "ech2";
                                trackErrorFlag = true;
                            }
                            else {
                                if (_this.passwordModel.passwordIsValid &&
                                    _this.passwordModel.passwordIsEnough &&
                                    _this.passwordModel.confirmPasswordIsValid) {
                                    _this.passwordModel.generalError = "error_null";
                                    _this.showTransitionScreen = true;
                                    _this.setLoadingIndicators(true);
                                    _this.easyLoginRegistrationService
                                        .rogersCreatePassword({
                                        emailToken: _this.emailModel.validationToken,
                                        password: _this.passwordModel.password,
                                        confirmPassword: _this.passwordModel.confirmPassword,
                                        flow: "selfReg",
                                    })
                                        .then(function (response) {
                                        var res = response.data;
                                        _this.rogersPassowrdSuccussHandling(res);
                                        _this.setLoadingIndicators(false, true);
                                    })
                                        .catch(function (e) {
                                        _this.rogersPasswordErrorHandling(e.data);
                                        _this.setLoadingIndicators(false, false, false);
                                    });
                                }
                            }
                            if (trackErrorFlag) {
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.password.page }, ErrorType.FORM, "", _this.sanitizeText(_this.$translate.instant("ute.easy.login.error." + _this.passwordModel.generalError)), ErrorCategory.SELF_SERVE, "Password or Confirm Password", "", false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                        };
                        // step 4
                        this.rogersPassowrdSuccussHandling = function (res) {
                            if (_this.getBrand() === "fido") {
                                window.history.pushState({}, "title", window.location.href);
                            }
                            _this.$timeout(function () {
                                _this.fraudTransactionPayload.userEmail = _this.emailModel.email;
                                _this.fraudTransactionPayload.loginId = _this.emailModel.email;
                                _this.fraudTransactionPayload.transactionStatus = _this.transactionProp.transactionStatus.success;
                                _this.fraudLoggingService.captureTransaction(_this.fraudTransactionPayload);
                                _this.setLoadingIndicators(false, false, false);
                                if (_this.getBrand() === "fido") {
                                    _this.handleFidoLoginAfterSetPass(res);
                                }
                                _this.changeStep(_this.STEP.COMPLETE);
                            }, 200);
                        };
                        // step 4
                        this.rogersPasswordErrorHandling = function (res) {
                            var error = res.errors ? _.first(res.errors) : { code: 'AN05-SY11-SV084-OT00ON00ET36-Err' };
                            var statusCode = error.code.split('-').slice(3).join('-');
                            ;
                            _this.showTransitionScreen = false;
                            var code = _this.rogersErrorMap[statusCode]
                                ? _this.rogersErrorMap[statusCode]
                                : _this.rogersErrorMap["default"];
                            _this.errorCodeType = code;
                            _this.passwordModel.generalError = code.code;
                            _this.dataLayerService.trackError({ page: _this.dataLayerConfig.password.page }, ErrorType[_this.errorCodeType.type], error.code ? error.code : '', _this.getErrorMessage("ute.easy.login.error." + _this.passwordModel.generalError, res), ErrorCategory.SELF_SERVE, "", "Create Password", false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                        };
                        /*  Rogers Micro Services Interfaces End */
                        this.getCurrentStepTemplate = function () {
                            return 'module/easyLoginRegistration/templates/' + _this.getBrand() + '/easyLogin-step-' + _this.getStepLowerCase(_this.step) + '.html';
                        };
                        this.getTransitionScreenTemplate = function () {
                            if (_this.getBrand() === 'fido') {
                                return 'module/easyLoginRegistration/templates/' + _this.getBrand() + '/transition-loading-screen.html';
                            }
                        };
                        this.changeStep = function (step, skippingStep) {
                            _this.step = step;
                            _this.setInputFocus(_this.step);
                            _this.resetStates();
                            _this.setInputFocus(step);
                            if (step !== 0) {
                                _this.stepManager[step - 1].complete = true;
                            }
                            _this.stepManager[step].active = true;
                            if (!skippingStep) {
                                _this.trackStep();
                            }
                        };
                        this.backStep = function (step) {
                            _this.step = step;
                            _this.resetStates();
                            _this.stepManager[step + 1].active = false;
                            _this.stepManager[step].active = true;
                            _this.stepManager[step].complete = false;
                        };
                        this.jumpStep = function (step) {
                            for (var i = _this.step; i <= step; i++) {
                                _this.changeStep(i, true);
                            }
                            _this.trackStep();
                        };
                        this.redirect = function (link) {
                            if (link === '#/sso/registration') {
                                _this.util.setIsRedirectedFromELRegistration(true);
                            }
                            _this.$window.location.href = link;
                        };
                        this.redirectToNewTab = function (link) {
                            window.open(link, '_blank');
                        };
                        this.goToMyAccount = function () {
                            _this.$state.go('accountOverview');
                        };
                        // Account
                        this.validateAcccountField = function (account) {
                            return _this.commonAccountFieldValidation(account, 'accountError', 'account', 'account number');
                        };
                        this.validatePostalField = function (postal) {
                            return _this.commonAccountFieldValidation(postal, 'postalError', 'postal', 'Postal Code');
                        };
                        this.commonAccountFieldValidation = function (field, errorProperty, fieldName, fieldName2) {
                            if (_.get(field, '$error.required', null)) {
                                _this.accountModel[errorProperty] = fieldName + 'RequiredError';
                            }
                            else if (_.get(field, '$error.pattern', null)) {
                                _this.accountModel[errorProperty] = fieldName + 'PatternError';
                            }
                            else {
                                _this.accountModel[errorProperty] = 'error_null';
                                return true;
                            }
                            _this.dataLayerService.trackError({ page: _this.dataLayerConfig.account.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.registration.account.' + _this.accountModel[errorProperty])), ErrorCategory.SELF_SERVE, fieldName2, '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            return false;
                        };
                        this.validateCaptcha = function () {
                            if (_.get(_this.accountModel, 'captcha', '').length === 0) {
                                _this.accountModel.generalError = 'ecp2';
                                var errorPage = _this.isSubscriberFlow ? _this.dataLayerConfig.number : _this.dataLayerConfig.account;
                                _this.dataLayerService.trackError({ page: errorPage.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.accountModel.generalError)), ErrorCategory.SELF_SERVE, 'reCAPTCHA', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                            else {
                                _this.accountModel.generalError = 'error_null';
                                return true;
                            }
                            return false;
                        };
                        this.validateAccountForm = function () {
                            var accountValid = _this.validateAcccountField(_this.accountForm.accountNumber);
                            var postalValid = _this.validatePostalField(_this.accountForm.postalCode);
                            // let captchaValid = this.validateCaptcha();
                            if (accountValid && postalValid) {
                                if (_this.blockRecaptcha) {
                                    _this.blockRecaptcha = true;
                                    _this.captchaVerified(_this.patToken);
                                }
                                else {
                                    _this.vcRecaptchaService.execute();
                                }
                            }
                            else {
                                angular.element('#accountNumber-field').focus();
                            }
                        };
                        this.getLoadingIndicators = function (mode, isProcessing, isSuccess, isFailed) {
                            if (isSuccess === void 0) { isSuccess = false; }
                            if (isFailed === void 0) { isFailed = false; }
                            if (mode === 'send') {
                                _this.setLoadingIndicators(isProcessing, isSuccess, isFailed);
                            }
                            else if (mode === 'resend') {
                                if (_this.isResendEmail) {
                                    _this.setSecondaryLoadingIndicators(isProcessing, isSuccess, isFailed);
                                }
                                else {
                                    _this.setLoadingIndicators(isProcessing, isSuccess, isFailed);
                                }
                            }
                        };
                        this.setLoadingIndicators = function (isProcessing, isSuccess, isFailed) {
                            if (isSuccess === void 0) { isSuccess = false; }
                            if (isFailed === void 0) { isFailed = false; }
                            _this.isLoading = isProcessing;
                            _this.isSuccess = isSuccess;
                            _this.isFailed = isFailed;
                        };
                        this.setSecondaryLoadingIndicators = function (isProcessing, isSuccess, isFailed) {
                            if (isSuccess === void 0) { isSuccess = false; }
                            if (isFailed === void 0) { isFailed = false; }
                            _this.isLoadingSecondary = isProcessing;
                            _this.isSuccessSecondary = isSuccess;
                            _this.isFailedSecondary = isFailed;
                        };
                        this.onAccountNumberChange = function () {
                            var an = _this.accountModel.accountNumber;
                            if (an.length > 12 || isNaN(Number(an[an.length - 1]))) {
                                _this.accountModel.accountNumber.slice(0, -1);
                            }
                        };
                        this.checkIfAccountNumberExists = function () {
                            _this.easyLoginRegistrationService.requestAccountNumber(_this.accountModel).then(function (response) {
                                var res = response.data;
                                _this.parseAccountResponseCodes(res);
                                _this.setLoadingIndicators(false, true);
                            }).catch(function (e) {
                                _this.setLoadingIndicators(false, false, true);
                                _this.parseAccountResponseCodes(e.data);
                            });
                        };
                        this.parseAccountResponseCodes = function (res) {
                            var statusCode = _.get(res, 'status.code', '').toString();
                            var maskedEmail = _this.maskEmailAddress(_.get(res, 'content.maskedEmailId', ''));
                            if (statusCode === '200.000') {
                                _this.accountModel.accountResponse = res;
                                _this.accountModel.accountError = 'error_null';
                                _this.accountModel.postalError = 'error_null';
                                _this.accountModel.generalError = 'error_null';
                                _this.accountModel.captchaError = 'error_null';
                                _this.$timeout(function () {
                                    _this.setLoadingIndicators(false, false, false);
                                    _this.changeStep(_this.STEP.EMAIL);
                                }, 200);
                            }
                            else if (statusCode === '400.021') {
                                _this.accountModel.accountError = 'eck2';
                                _this.accountModel.postalError = 'eck3';
                            }
                            else if (statusCode === '400.028') {
                                // to resend verification step
                                _this.isAutoRegistrationStarted = true;
                                _this.setLoadingIndicators(false, false, false);
                                _this.accountModel.emailGenerationToken = _.get(res, 'content.emailGenerationToken', '');
                                _this.emailModel.email = _.get(res, 'content.maskedEmailId', '');
                                _this.emailModel.maskedEmail = maskedEmail;
                                _this.accountModel.accountResponse.content.accountType = _.get(res, 'content.accountType', '');
                                _this.accountModel.accountResponse.content.consolidated = _.get(res, 'content.consolidated', '');
                            }
                            else if (statusCode === '400.029') {
                                _this.emailModel.maskedEmail = maskedEmail;
                                _this.emailModel.email = _.get(res, 'content.maskedEmailId', '');
                            }
                            //Reset captcha If Account number does not exists.
                            _this.accountModel.captcha = null;
                            if (!_this.blockRecaptcha) {
                                _this.vcRecaptchaService.reload();
                            }
                            ;
                            if (!(statusCode === '200.000' || statusCode === '400.028')) {
                                _this.errorCodeType = (statusCode) ? _this.getApiErrorCodeMapping(statusCode) : { code: '', type: 'HTTP' }; // DC-24
                                _this.accountModel.generalError = _this.errorCodeType.code || _this.errorCodeDefault;
                                try {
                                    _this.dataLayerService.trackError({ page: _this.dataLayerConfig.account.page }, ErrorType[_this.errorCodeType.type], _this.errorCodeType.code ? _this.errorCodeType.code.toUpperCase() : statusCode, _this.getErrorMessage('ute.easy.login.error.' + _this.accountModel.generalError, res), ErrorCategory.SELF_SERVE, '', 'Check Account', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                                }
                                catch (e) {
                                    console.log('An error occured during data layer track' + e);
                                }
                            }
                            if (_this.isAutoRegistrationStarted) {
                                _this.dataLayerService.track(_this.dataLayerConfig.great_news, false, [DataLayerPredefinedSection.PAGE,
                                    DataLayerPredefinedSection.SITE]);
                            }
                        };
                        this.captchaVerified = function (response) {
                            _this.accountModel.captcha = response;
                            var captchaValid = _this.validateCaptcha();
                            if (captchaValid) {
                                _this.setLoadingIndicators(true);
                                if (_this.isSubscriberFlow) {
                                    _this.requestPhoneNumberVerification(_this.accountModel);
                                }
                                else {
                                    _this.checkIfAccountNumberExists();
                                }
                            }
                        };
                        this.onCaptchaExpire = function () {
                            _this.accountModel.captcha = '';
                            var errorPage = _this.isSubscriberFlow ? _this.dataLayerConfig.number : _this.dataLayerConfig.account;
                            _this.dataLayerService.trackError({ page: errorPage.page }, ErrorType.FORM, '', 'Verification expired. Check the checkbox again.', ErrorCategory.SELF_SERVE, 'reCAPTCHA', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                        };
                        // Account - End
                        // Email
                        this.emailFormValidation = function (form) {
                            var validEmail = _this.validateEmail(form.email);
                            var validConfirm = _this.validateConfirmEmail();
                            if (validEmail && !validConfirm) {
                                _this.emailModel.generalError = 'ech3';
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.email.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.emailModel.generalError)), ErrorCategory.SELF_SERVE, 'Confirm Email Address', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                            else if (!validEmail || !validConfirm) {
                                _this.emailModel.generalError = 'error_null';
                            }
                            else if (validEmail && validConfirm) {
                                if (_this.sendToDifferentEmailInitiated) {
                                    _this.resendEmail(null, 'send');
                                }
                                else {
                                    _this.tryEmailCreation({
                                        email: _this.emailModel.email,
                                        brand: _this.easyLoginRegistrationService.getConfig().basic.branding.toLowerCase(),
                                        action: 'send',
                                        language: _this.getCurrentLanguage().toLowerCase(),
                                        account: _this.accountModel.accountNumber,
                                        postalCode: _this.accountModel.postalCode,
                                        phoneNumber: _this.accountModel.phoneNumber,
                                        accountType: _.get(_this.accountModel, 'accountResponse.content.accountType', null),
                                        consolidated: _.get(_this.accountModel, 'accountResponse.content.consolidated', '').toString()
                                    });
                                }
                            }
                        };
                        this.resendEmail = function (token, type) {
                            var _payload = {
                                brand: _this.easyLoginRegistrationService.getConfig().basic.branding.toLowerCase(),
                                action: 'resend',
                                language: _this.getCurrentLanguage().toLowerCase(),
                                account: _this.accountModel.accountNumber,
                                postalCode: _this.accountModel.postalCode,
                                phoneNumber: _this.accountModel.phoneNumber,
                                accountType: _.get(_this.accountModel, 'accountResponse.content.accountType', null),
                                consolidated: _.get(_this.accountModel, 'accountResponse.content.consolidated', '').toString()
                            };
                            if (_this.emailModel.email !== '') {
                                _payload.email = _this.emailModel.email;
                            }
                            // this.trackEmailResend({ selfServeStart: true });
                            _this.tryEmailCreation(_payload, token, type);
                        };
                        this.tryEmailCreation = function (payload, token, mode) {
                            _this.getLoadingIndicators(mode, true);
                            // mode === 'send' ? this.setLoadingIndicators(true) : this.setSecondaryLoadingIndicators(true);
                            if (payload.postalCode) {
                                payload.postalCode = payload.postalCode.replace(/\s/g, '');
                            }
                            if (token !== null && token !== undefined) {
                                payload.token = token;
                            }
                            if (mode === 'send') {
                                _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode';
                            }
                            else if (mode === 'resend' || mode === '') {
                                if (_this.isResendEmail) {
                                    _this.accountModel.reSendButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode';
                                }
                                else {
                                    _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.sendingCode';
                                }
                            }
                            // payload.action = (mode === 'resend') ? 'resend' : 'send';
                            _this.easyLoginRegistrationService.requestEmail(payload).then(function (response) {
                                var res = response.data;
                                _this.parseEmailResponseCodes(res, payload.action, mode);
                                // this.setLoadingIndicators(false, true);
                            }).catch(function (e) {
                                _this.parseEmailResponseCodes(e.data, payload.action, mode);
                                _this.getLoadingIndicators(mode, false, false, true);
                                // this.setLoadingIndicators(false, false, true);
                                if (mode === 'send') {
                                    _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                    _this.accountModel.disableState = true;
                                }
                                else if (mode === 'resend' || mode === '') {
                                    if (_this.isResendEmail) {
                                        _this.accountModel.reSendButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                        _this.resendState = true;
                                    }
                                    else {
                                        _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                        _this.accountModel.disableState = true;
                                    }
                                }
                            });
                        };
                        this.parseEmailResponseCodes = function (res, action, mode) {
                            // Added below line as self-registration requirements (from step 1 to step 2) changed as part of DC-1721
                            _this.emailModel.maskedEmail = _.get(res, 'content.maskedEmailId', '');
                            var statusCode = _.get(res, 'status.code', '').toString();
                            if (statusCode === '200') {
                                _this.getLoadingIndicators(mode, false, true);
                                if (action === 'resend') {
                                    _this.trackEmailResend({ selfServeComplete: true });
                                }
                                _this.accountModel.requestCounter += 1;
                                if (mode === 'send') {
                                    _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent';
                                    _this.accountModel.disableState = true;
                                }
                                else if (mode === 'resend' || mode === '') {
                                    if (_this.isResendEmail) {
                                        _this.accountModel.reSendButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent';
                                        _this.resendState = true;
                                    }
                                    else {
                                        _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.codeSent';
                                        _this.accountModel.disableState = true;
                                    }
                                }
                                if ((!_this.isAutoRegistrationStarted && _this.step !== _this.STEP.VERIFY) || _this.sendToDifferentEmailInitiated) {
                                    _this.$timeout(function () {
                                        _this.setLoadingIndicators(false, false, false);
                                        _this.changeStep(_this.STEP.VERIFY);
                                    }, 200);
                                }
                                _this.sendToDifferentEmailInitiated = false;
                            }
                            else {
                                if (statusCode === '500.013') {
                                    _this.getLoadingIndicators(mode, false, false, true);
                                    if (mode === 'send') {
                                        _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                        _this.accountModel.disableState = true;
                                    }
                                    else if (mode === 'resend' || mode === '') {
                                        if (_this.isResendEmail) {
                                            _this.accountModel.reSendButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                            _this.resendState = true;
                                        }
                                        else {
                                            _this.accountModel.sendEmailButtonText = 'ute.easy.login.registration.verify.didntGetEmailExpanded.pleaseContactUs';
                                            _this.accountModel.disableState = true;
                                        }
                                    }
                                }
                                _this.errorCodeType = (statusCode) ? _this.getApiErrorCodeMapping(statusCode) : { code: '', type: 'HTTP' };
                                _this.emailModel.generalError = _this.errorCodeType.code || _this.errorCodeDefault;
                                var pagePayload = _this.getEmailErrorPayload();
                                try {
                                    _this.dataLayerService.trackError({ page: pagePayload }, ErrorType[_this.errorCodeType.type], _this.errorCodeType.code ? _this.errorCodeType.code.toUpperCase() : statusCode, _this.getErrorMessage('ute.easy.login.error.' + _this.emailModel.generalError, res), ErrorCategory.SELF_SERVE, '', 'Create Email', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                                }
                                catch (e) {
                                    console.log('An error occured during data layer track' + e);
                                }
                                _this.sendToDifferentEmailInitiated = true;
                            }
                        };
                        this.validateEmail = function (email) {
                            if (_.get(email, '$error.required', null)) {
                                _this.emailModel.emailError = 'ech1';
                            }
                            else if (_.get(email, '$error.email', null)) {
                                _this.emailModel.emailError = 'ecd2';
                            }
                            else {
                                _this.emailModel.emailError = 'error_null';
                                return true;
                            }
                            _this.dataLayerService.trackError({ page: _this.dataLayerConfig.email.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.emailModel.emailError)), ErrorCategory.SELF_SERVE, 'Email Address', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            return false;
                        };
                        this.validateConfirmEmail = function () {
                            if (_this.emailModel.confirmEmail === _this.emailModel.email) {
                                return true; // Copy does not contain error messages for this scenario
                            }
                            return false;
                        };
                        this.sendToDifferentEmail = function () {
                            _this.sendToDifferentEmailInitiated = true;
                            _this.changeStep(_this.STEP.EMAIL);
                        };
                        // Email - End
                        /**
                         * Method: onConfirmEmailInputChange.
                         * description: matching email and confirm email value on input change.
                         * return: Boolean.
                         */
                        this.onConfirmEmailInputChange = function () {
                            var pss = _this.emailModel.confirmEmail;
                            _this.emailModel.confirmEmailIsValid = pss === _this.emailModel.email;
                        };
                        this.validatePassword = function (form) {
                            var trackErrorFlag = false;
                            if (_this.passwordModel.password === '' || _this.passwordModel.confirmPassword === '') {
                                _this.passwordModel.generalError = 'ech1';
                                trackErrorFlag = true;
                            }
                            else if (!_this.passwordModel.confirmPasswordIsValid) {
                                _this.passwordModel.generalError = 'ech3';
                                trackErrorFlag = true;
                            }
                            else if (!_this.passwordModel.passwordIsValid || !_this.passwordModel.passwordIsEnough) {
                                _this.passwordModel.generalError = 'ech2';
                                trackErrorFlag = true;
                            }
                            else {
                                if (_this.passwordModel.passwordIsValid && _this.passwordModel.passwordIsEnough && _this.passwordModel.confirmPasswordIsValid) {
                                    _this.passwordModel.generalError = 'error_null';
                                    _this.showTransitionScreen = true;
                                    _this.setLoadingIndicators(true);
                                    _this.easyLoginRegistrationService.createPassword({
                                        token: _this.emailModel.validationToken,
                                        password: _this.passwordModel.password,
                                        confirmPassword: _this.passwordModel.confirmPassword,
                                        activate: 'yes'
                                    }).then(function (response) {
                                        var res = response.data;
                                        _this.handlePasswordResponse(res);
                                        _this.setLoadingIndicators(false, true);
                                    }).catch(function (e) {
                                        var res = e.data;
                                        _this.handlePasswordResponse(res);
                                        _this.setLoadingIndicators(false, false, false);
                                    });
                                }
                            }
                            if (trackErrorFlag) {
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.password.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.passwordModel.generalError)), ErrorCategory.SELF_SERVE, 'Password or Confirm Password', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                        };
                        //DSO-14644
                        this.saveForm = function (form) {
                            var username = form.username.value;
                            var password = form.password.value;
                            if (username && password) {
                                //its is save to use this condition here, it will be always true
                                window.history.pushState({}, 'title', window.location.href);
                            }
                            else {
                                _this.validatePassword(form);
                            }
                        };
                        this.handlePasswordResponse = function (res) {
                            var code = _.get(res, 'status.code', '').toString();
                            _this.showTransitionScreen = false;
                            if (code === '200') {
                                //DSO-14644 : fido save password story
                                //before changing the step, form is being submitted - does nothing
                                //but enables the browser to invoke save password prompt
                                if (_this.getBrand() === 'fido') {
                                    window.history.pushState({}, 'title', window.location.href);
                                }
                                _this.$timeout(function () {
                                    _this.fraudTransactionPayload.userEmail = _this.emailModel.email;
                                    _this.fraudTransactionPayload.loginId = _this.emailModel.email;
                                    if (_.has(res, 'content')) {
                                        if (res.content.loginResponse.length) {
                                            _this.fraudTransactionPayload.sessionId = res.content.loginResponse[1].accessToken;
                                        }
                                    }
                                    _this.fraudTransactionPayload.transactionStatus = _this.transactionProp.transactionStatus.success;
                                    _this.fraudLoggingService.captureTransaction(_this.fraudTransactionPayload);
                                    _this.setLoadingIndicators(false, false, false);
                                    if (_this.getBrand() === 'fido') {
                                        _this.handleFidoLoginAfterSetPass(res);
                                    }
                                    _this.changeStep(_this.STEP.COMPLETE);
                                    if (_this.getBrand() === 'fido') {
                                        // auto redirect to overview if left idle on step 5 for 1 minute.
                                        _this.timeout = _this.$timeout(function () {
                                            _this.gotoAccountOverview(false);
                                        }, 60000);
                                    }
                                }, 200);
                            }
                            else {
                                _this.errorCodeType = _this.getApiErrorCodeMapping(code);
                                _this.passwordModel.generalError = _this.errorCodeType.code || _this.errorCodeDefault;
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.password.page }, ErrorType[_this.errorCodeType.type], _this.errorCodeType.code ? _this.errorCodeType.code.toUpperCase() : code, _this.getErrorMessage('ute.easy.login.error.' + _this.passwordModel.generalError, res), ErrorCategory.SELF_SERVE, '', 'Create Password', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                        };
                        this.handleFidoLoginAfterSetPass = function (data) {
                            var commonService = _this.$injector.get('commonService');
                            if (_.has(data, 'content')) {
                                if (data.content.loginResponse.length) {
                                    if (_.has(data.content.loginResponse[0], 'xSessionToken')) {
                                        window.sessionStorage.setItem('xSessionToken', data.content.loginResponse[0].xSessionToken);
                                    }
                                    if (_.has(data.content.loginResponse[1], 'guid')) {
                                        window.sessionStorage.setItem('guid', data.content.loginResponse[1].guid);
                                    }
                                }
                                var loginInfo = data.content.loginResponse[1];
                                window.janrain.capture.ui.createCaptureSession(loginInfo.accessToken);
                                commonService.accessToken = loginInfo.accessToken;
                                _this.guid = loginInfo.guid;
                                _this.userId = loginInfo.userId;
                                var userInfo = {
                                    uuid: loginInfo.guid,
                                    userID: loginInfo.userId,
                                    lastName: loginInfo.familyName,
                                    firstName: loginInfo.givenName
                                };
                                var janrainCaptureProfileData = {
                                    uuid: userInfo.uuid,
                                    userID: userInfo.userID,
                                    email: userInfo.userID,
                                    profileType: 1
                                };
                                var host = window.location.host.replace('www', '');
                                document.cookie = 'userInfo=' + JSON.stringify(userInfo) + '; domain=' + host + '; path=/';
                                document.cookie = 'janrainCaptureProfileData=' + JSON.stringify(janrainCaptureProfileData) + '; domain=' + host + '; path=/';
                                window.localStorage.setItem('janrainCaptureProfileData', JSON.stringify(janrainCaptureProfileData));
                                window.localStorage.setItem('rememberMeUserID', loginInfo.userId);
                                window.localStorage.setItem('rememberMeValue', 'true');
                            }
                        };
                        this.setPasswordInputType = function (key) {
                            _this.passwordModel[key] = _this.passwordModel[key] === 'password' ? 'text' : 'password';
                            if (key === 'passwordType') {
                                angular.element('#password').focus();
                            }
                            else {
                                angular.element('#confirmPassword').focus();
                            }
                        };
                        this.onPasswordInputChange = function () {
                            var pss = _this.passwordModel.password;
                            if (pss && pss.length > 0) {
                                _this.passwordModel.passwordIsEnough = pss.length >= 8 && pss.length <= 64;
                                _this.passwordModel.passwordIsValid = _this.easyLoginRegistrationService.getPasswordValidationRegExp().test(pss);
                            }
                        };
                        this.onConfirmPasswordInputChange = function () {
                            var pss = _this.passwordModel.confirmPassword;
                            _this.passwordModel.confirmPasswordIsValid = pss === _this.passwordModel.password;
                        };
                        this.getStepClasses = function (index) {
                            return _this.stepManager[index].complete ? 'active complete' : _this.stepManager[index].active ? 'active' : '';
                        };
                        this.getStepLowerCase = function (step) {
                            return _this.STEP[step].toString().toLowerCase();
                        };
                        this.getBrand = function () {
                            return _this.easyLoginRegistrationService.getConfig().basic.branding.toLowerCase();
                        };
                        this.getCurrentLanguage = function () {
                            if (_this.getBrand() === 'rogers') {
                                return angular.element('body:lang(fr)').length > 0 ? 'fr' : 'en';
                            }
                            else {
                                return angular.element('body').attr('ute-language');
                            }
                        };
                        this.startSubscriberFlow = function () {
                            _this.stepManager = [];
                            _this.isSubscriberFlow = true;
                            _this.resetStepManager(true);
                            _this.step = _this.STEP.MAIN;
                            _this.changeStep(_this.STEP.NUMBER);
                            _this.dataLayerConfig = _this.dataLayerService.getConfigByMappingKey({
                                mappingKey: 'advance.mappingKey.subscriberRegistration'
                            });
                        };
                        this.openJanrainRegistrationModal = function () {
                            _this.$window.janrain.capture.ui.renderScreen('traditionalRegistration');
                        };
                        this.startAccountFlow = function () {
                            _this.stepManager = [];
                            _this.isSubscriberFlow = false;
                            _this.resetStepManager(false);
                            _this.step = _this.STEP.MAIN;
                            _this.changeStep(_this.STEP.ACCOUNT);
                            _this.dataLayerConfig = _this.dataLayerService.getConfigByMappingKey({
                                mappingKey: 'advance.mappingKey.accountRegistration'
                            });
                        };
                        this.validateSubAccountForm = function (form) {
                            var phoneNumberValid = _this.validatePhoneNumberField(form);
                            if ((form === undefined || form === null) || phoneNumberValid) {
                                _this.accountModel.phoneNumber = _this.accountModel.phoneNumber.split('-').join('');
                                _this.vcRecaptchaService.execute();
                            }
                        };
                        this.resendSms = function (form) {
                            _this.accountModel.phoneNumber = _this.accountModel.phoneNumber.split('-').join('');
                            // this.trackSmsResend({ selfServeStart: true });
                            _this.requestPhoneNumberVerification(_this.accountModel);
                        };
                        this.validatePhoneNumberField = function (account) {
                            if (account.phoneNumber.$error.required) {
                                _this.accountModel.phoneError = 'ecl1';
                            }
                            else if (account.phoneNumber.$error.pattern) {
                                _this.accountModel.phoneError = 'ecl2';
                            }
                            else {
                                _this.accountModel.phoneError = 'error_null';
                                return true;
                            }
                            _this.dataLayerService.trackError({ page: _this.dataLayerConfig.number.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.accountModel.generalError)), ErrorCategory.SELF_SERVE, 'Phone Number', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            return false;
                        };
                        this.requestPhoneNumberVerification = function (params) {
                            // this.setLoadingIndicators(true);
                            if (_this.smsModel.smsCounter >= 1) {
                                _this.smsModel.reSendButtonText = 'ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.sendingCode';
                            }
                            _this.getSmsContent().then(function (res) {
                                params.smsContent = res;
                                params.mode = _this.accountModel.mode;
                                if (_this.accountModel.mode === 'resend') {
                                    params.captcha = _this.accountModel.accountResponse.captcha;
                                }
                                _this.easyLoginRegistrationService.requestSubAccount(params).then(function (response) {
                                    var res = response.data;
                                    _this.handlePhoneNumberResponse(res);
                                    _this.setLoadingIndicators(false, true);
                                    _this.accountModel.mode = 'resend';
                                }).catch(function (e) {
                                    _this.handlePhoneNumberResponse(e.data);
                                    _this.setLoadingIndicators(false, false, true);
                                    if (_this.accountModel.mode === 'resend') {
                                        _this.smsModel.reSendButtonText = 'ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.pleaseContactUs';
                                    }
                                });
                            });
                        };
                        this.handlePhoneNumberResponse = function (res) {
                            var statusCode = _.get(res, 'status.code', '').toString();
                            var maskedEmail = _this.maskEmailAddress(_.get(res, 'content.maskedEmailId', ''));
                            _this.vcRecaptchaService.reload();
                            if (statusCode === '200') {
                                _this.accountModel.accountResponse.content.accountType = _.get(res, 'content.accountType', '');
                                _this.accountModel.accountResponse.content.token = _.get(res, 'content.token', '');
                                _this.accountModel.accountResponse.captcha = _.get(res, 'content.signedRecaptcha', '');
                                _this.smsModel.smsCounter += 1;
                                if (_this.smsModel.smsCounter > 1) {
                                    _this.trackSmsResend({ selfServeComplete: true });
                                    _this.smsModel.reSendButtonText = 'ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.codeSent';
                                }
                                _this.accountModel.generalError = 'error_null';
                                if (_this.step !== SUBSTEP.VERIFY_SMS) {
                                    _this.$timeout(function () {
                                        _this.setLoadingIndicators(false, false, false);
                                        _this.changeStep(_this.STEP.VERIFY_SMS);
                                    }, 200);
                                }
                            }
                            else {
                                if (_this.smsModel.smsCounter > 1) {
                                    _this.smsModel.reSendButtonText = 'ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.pleaseContactUs';
                                }
                                else if (statusCode === '400.041') {
                                    _this.emailModel.maskedEmail = maskedEmail;
                                    _this.emailModel.email = _.get(res, 'content.maskedEmailId', '');
                                }
                                _this.errorCodeType = _this.getApiErrorCodeMapping(statusCode);
                                _this.accountModel.generalError = _this.errorCodeType.code || _this.errorCodeDefault;
                                var pagePayload = _this.step === SUBSTEP.VERIFY_SMS ? _this.dataLayerConfig.verify.page :
                                    (_this.step === _this.STEP.NUMBER ? _this.dataLayerConfig.number.page : _this.dataLayerConfig.number.page);
                                _this.dataLayerService.trackError({ page: pagePayload }, ErrorType[_this.errorCodeType.type], _this.errorCodeType.code ? _this.errorCodeType.code.toUpperCase() : statusCode, _this.getErrorMessage('ute.easy.login.error.' + _this.accountModel.generalError, res), ErrorCategory.SELF_SERVE, '', 'Phone Number Verification', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                        };
                        this.validatePinCodeField = function (pin) {
                            if (_.get(pin, '$error.required', null)) {
                                _this.smsModel.pinError = 'ecc1';
                            }
                            else if (_.get(pin, '$error.pattern', null)) {
                                _this.smsModel.pinError = 'ecc2';
                            }
                            else {
                                _this.smsModel.pinError = 'error_null';
                                return true;
                            }
                            _this.dataLayerService.trackError({ page: _this.dataLayerConfig.verify_sms.page }, ErrorType.FORM, '', _this.sanitizeText(_this.$translate.instant('ute.easy.login.error.' + _this.smsModel.pinError)), ErrorCategory.SELF_SERVE, 'SMS Verification Code', '', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            return false;
                        };
                        this.validatePinCodeForm = function (form) {
                            var pinCodeValid = _this.validatePinCodeField(form.pin);
                            if (pinCodeValid) {
                                _this.requestSmsPinValidation(_this.smsModel);
                            }
                            else {
                                console.log('VerificationFailed');
                            }
                        };
                        this.requestSmsPinValidation = function (params) {
                            _this.easyLoginRegistrationService.requestSmsVerification({
                                brand: _this.getBrand(),
                                pin: _this.smsModel.pin,
                                token: _this.accountModel.accountResponse.content.token
                            }).then(function (response) {
                                var res = response.data;
                                _this.handleSmsPinResponse(res);
                            }).catch(function (e) {
                                _this.handleSmsPinResponse(e.data);
                            });
                        };
                        this.handleSmsPinResponse = function (res) {
                            var statusCode = _.get(res, 'status.code', '').toString();
                            if (statusCode === '200') {
                                _this.smsModel.reponse = res;
                                _this.changeStep(_this.STEP.EMAIL);
                            }
                            else if (statusCode === '400.002') {
                                _this.smsModel.remainingAttempts = _.get(res, 'content.remainingAttempts', '');
                                _this.smsModel.generalError = 'ecc3';
                            }
                            else if (statusCode === '400.003') {
                                _this.smsModel.generalError = 'ecc6';
                            }
                            else if (statusCode === '400.004') {
                                _this.smsModel.generalError = 'ecc5';
                            }
                            else if (statusCode === '400.011') {
                                _this.smsModel.generalError = 'ecc4';
                            }
                            else if (statusCode === '500.008') {
                                _this.smsModel.generalError = 'ecp2';
                            }
                            else {
                                _this.smsModel.generalError = 'error_null';
                            }
                            if (statusCode !== '200') {
                                _this.errorCodeType = _this.getApiErrorCodeMapping(statusCode);
                                _this.dataLayerService.trackError({ page: _this.dataLayerConfig.verify_sms.page }, ErrorType[_this.errorCodeType.type], _this.errorCodeType.code ? _this.errorCodeType.code.toUpperCase() : statusCode, _this.getErrorMessage('ute.easy.login.error.' + _this.smsModel.generalError, res) ||
                                    (typeof res === 'string') ? _this.sanitizeText(String(res)) : '', ErrorCategory.SELF_SERVE, '', 'SMS Pin Validate', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                            }
                        };
                        this.loginRogers = function (route) {
                            _this.$window.sessionStorage.setItem('ute.rci.deep.link.url', '/web/totes/#/' + route);
                            _this.$window.location.href = '/consumer/easyloginriverpage?showModal=true';
                        };
                        this.gotoAccountOverview = function (userClicked) {
                            if (userClicked === true) {
                                _this.$timeout.cancel(_this.timeout);
                            }
                            var janrainEvents = _this.$injector.get('janrainEvents');
                            janrainEvents.proceedWithLogin(_this.guid, _this.userId);
                        };
                        this.getLoadingClass = function (buttonType) {
                            if (buttonType === 'secondary') {
                                if (_this.isLoadingSecondary) {
                                    return 'elr-loader';
                                }
                                else if (_this.isSuccessSecondary) {
                                    return 'state-btn-success';
                                }
                                else if (_this.isFailedSecondary) {
                                    return 'state-btn-fail';
                                }
                                else {
                                    return '';
                                }
                            }
                            else {
                                if (_this.isLoading) {
                                    return 'elr-loader';
                                }
                                else if (_this.isSuccess) {
                                    return 'state-btn-success';
                                }
                                else if (_this.isFailed) {
                                    return 'state-btn-fail';
                                }
                                else {
                                    return '';
                                }
                            }
                        };
                        this.resetStates = function () {
                            _this.accountModel.generalError = '';
                            _this.resendState = false;
                            _this.isLoading = false;
                            _this.isLoadingSecondary = false;
                            _this.isSuccess = false;
                            _this.isSuccessSecondary = false;
                            _this.isFailed = false;
                            _this.isFailedSecondary = false;
                        };
                        this.maskPhonenumber = function (phoneNumber) {
                            if (_.isEmpty(phoneNumber)) {
                                return '';
                            }
                            var matchNumber = phoneNumber.match(/(\d)(\d*)(\d{3})(\d{4})$/);
                            var section1 = matchNumber[1];
                            var section2 = matchNumber[2].replace(/\d/g, '*');
                            var section3 = matchNumber[3].replace(/\d/g, '*');
                            var section4 = matchNumber[4].replace(/\d*(\d{2})/, '**$1');
                            return "" + section1 + section2 + "-" + section3 + "-" + section4;
                        };
                        this.getSmsContent = function () {
                            return _this.$translate('ute.easy.login.registration.account.smsContent');
                        };
                        this.setInputFocusForMobileEnterKeyPress = function (event) {
                            event.preventDefault();
                            if (event.which === 13 || event.keyCode === 13) {
                                if (!_this.accountModel.accountNumber && !_this.accountModel.postalCode) {
                                    angular.element('#accountNumber-field').focus();
                                }
                                else if (_this.accountModel.accountNumber && !_this.accountModel.postalCode) {
                                    angular.element('#postalCode-field').focus();
                                }
                                else if (!_this.accountModel.accountNumber && _this.accountModel.postalCode) {
                                    angular.element('#accountNumber-field').focus();
                                }
                                else if (_this.accountModel.accountNumber && _this.accountModel.postalCode) {
                                    _this.validateAccountForm();
                                }
                            }
                        };
                        this.init = function () {
                            _this.showTransitionScreen = false;
                            _this.showContestBanner = false;
                            _this.captchaKey = _this.easyLoginRegistrationService.getConfig().basic.recaptchaSiteKey;
                            _this.visaPromotionConfig = _this.easyLoginRegistrationService.getConfig().basic.visaPromotion;
                            var accountType = _.get(_this.$state, 'params.accountType', '');
                            _this.resetStepManager(accountType === 'FIDOSUBSCRIBER');
                            _this.step = _this.STEP.MAIN;
                            _this.isResendWidgetCollapsed = true;
                            _this.isAutoRegistrationStarted = false;
                            _this.isSubscriberFlow = accountType === 'FIDOSUBSCRIBER';
                            _this.resendState = false;
                            _this.isLoading = false;
                            _this.isLoadingSecondary = false;
                            _this.isSuccess = false;
                            _this.isSuccessSecondary = false;
                            _this.isFailed = false;
                            _this.isFailedSecondary = false;
                            _this.infoShowHide = false;
                            _this.sendToDifferentEmailInitiated = false;
                            _this.errorMap = [
                                { '400.021': { code: 'eck2', type: 'USER' } },
                                { '400.023': { code: 'eck5', type: 'USER' } },
                                { '400.024': { code: 'eck5', type: 'USER' } },
                                { '400.025': { code: 'eck5', type: 'USER' } },
                                { '400.027': { code: 'eck5', type: 'USER' } },
                                { '400.026': { code: 'eck6', type: 'BUSINESS_LOGIC' } },
                                { '400.029': { code: 'eck7', type: 'USER' } },
                                { '400.032': { code: 'eck8', type: 'USER' } },
                                { '400.030': { code: 'ecp2', type: 'BUSINESS_LOGIC' } },
                                { '400.031': { code: 'ecf4', type: 'USER' } },
                                { '500.020': { code: 'eck5', type: 'USER' } },
                                { '400.002': { code: 'ecc3', type: 'USER' } },
                                { '400.011': { code: 'ecc4', type: 'USER' } },
                                { '400.003': { code: 'ecc6', type: 'USER' } },
                                { '400.004': { code: 'ecc5', type: 'BUSINESS_LOGIC' } },
                                { '400.008': { code: 'ecd5', type: 'USER' } },
                                { '400.010': { code: 'ecn2', type: 'BUSINESS_LOGIC' } },
                                { '400.001': { code: 'eck9', type: 'BUSINESS_LOGIC' } },
                                { '400.042': { code: 'ecl3', type: 'USER' } },
                                { '400.040': { code: 'ecl4', type: 'BUSINESS_LOGIC' } },
                                { '400.041': { code: 'ecl5', type: 'USER' } },
                                { '400.009': { code: 'eca7', type: 'USER' } },
                                { '400.055': { code: 'eca6', type: 'BUSINESS_LOGIC' } },
                                { '500.016': { code: 'ecp2', type: 'HTTP' } },
                                { '500.015': { code: 'ecp2', type: 'HTTP' } },
                                { '500.013': { code: 'ecp2', type: 'HTTP' } },
                                { '500.008': { code: 'eck5', type: 'HTTP' } },
                                { '500': { code: 'ecp2', type: 'HTTP' } },
                                { 'default': { code: '', type: 'HTTP' } }
                            ];
                            _this.passwordModel = {
                                password: '',
                                confirmPassword: '',
                                passwordType: 'password',
                                confirmPasswordType: 'password',
                                passwordError: 'error_null',
                                confirmPasswordError: 'error_null',
                                generalError: 'error_null',
                                passwordIsEnough: false,
                                passwordIsValid: false,
                                confirmPasswordIsValid: false
                            };
                            _this.accountModel = {
                                accountNumber: '',
                                postalCode: '',
                                // captcha: false,
                                phoneNumber: '',
                                captcha: '',
                                accountError: 'error_null',
                                postalError: 'error_null',
                                captchaError: 'error_null',
                                phoneError: 'error_null',
                                generalError: 'error_null',
                                mode: 'send',
                                disableState: false,
                                reSendButtonText: 'ute.easy.login.registration.verify.didntGetEmailExpanded.resendCode',
                                sendEmailButtonText: 'ute.easy.login.registration.accountRegistered.sendEmail',
                                requestCounter: 0, accountResponse: {
                                    content: {
                                        accountType: '',
                                        token: ''
                                    }
                                }
                            };
                            _this.smsModel = {
                                pin: '',
                                remainingAttempts: '', pinError: 'error_null',
                                generalError: 'error_null',
                                reSendButtonText: 'ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.resendCode',
                                smsCounter: 0
                            };
                            _this.emailModel = {
                                email: '',
                                emailError: 'error_null',
                                confirmEmail: '',
                                maskedEmail: '',
                                confirmEmailError: 'error_null',
                                generalError: 'error_null'
                            };
                            _this.dataLayerConfig = _this.dataLayerService.getConfigByMappingKey({
                                mappingKey: _this.isSubscriberFlow ? 'advance.mappingKey.subscriberRegistration' : 'advance.mappingKey.accountRegistration'
                            });
                            var token = _.get(_this.$state, 'params.token', null);
                            if (token) {
                                _this.$translate.use(_.get(_this.$state, 'params.setLanguage', 'en'));
                                // call api and validate token and navigate to password step
                                _this.handleEmailDeeplink(token);
                            }
                            else {
                                _this.trackStep();
                            }
                            if (_this.getBrand() === 'rogers') {
                                _this.displayContestBanner();
                            }
                            _this.fraudTransactionPayload.sourceChannel = _this.transactionProp.sourceChannel[_this.getBrand().toLowerCase()];
                            _this.fraudTransactionPayload.transactionType = _this.transactionProp.transactionType.createProfile;
                            _this.fraudTransactionPayload.action = _this.transactionProp.action.createProfile;
                            _this.fraudTransactionPayload.userType = _this.transactionProp.userType.consumer;
                            _this.fraudTransactionPayload.franchise = _this.transactionProp.franchise[_this.getBrand().toLowerCase()];
                            //DC-2680: Temp token fix
                            _this.patToken = _this.$window.getCookie('temp_token_r');
                            _this.blockRecaptcha = !!_this.patToken;
                        };
                        // step 3
                        this.handleEmailDeeplink = function (token) {
                            var brand = _this.getBrand();
                            var modalTemplateUrl = 'module/easyLoginRegistration/templates/' + brand + '/emailVerificationModal.html';
                            var modal = _this.$modal.open({
                                templateUrl: modalTemplateUrl,
                                controller: "ute.easy.login.registration." + brand + "EmailVerification.modal.controller",
                                controllerAs: '$ctrl',
                                backdrop: 'static',
                                size: 'registration-validateEmailLink',
                                keyboard: false,
                                backdropClass: 'bkg-model',
                                resolve: {
                                    token: function () { return token; }
                                }
                            });
                            modal.result.then(function (result) {
                                if (result && result.token !== 'invalid') {
                                    _this.emailModel.validationToken = result.token;
                                    _this.emailModel.email = result.userID;
                                    _this.step = _this.STEP[_this.STEP[1]];
                                    _this.jumpStep(_this.STEP.PASSWORD);
                                }
                                else {
                                    _this.emailModel.maskedEmail = _.get(result.errorResponse, "errors[0].data.emailId", "");
                                    _this.step = _this.STEP[_this.STEP[0]];
                                    _this.jumpStep(_this.STEP[_this.STEP[1]]);
                                    /* Rogers micro services implmentatin start*/
                                    if (brand === 'rogers') {
                                        _this.errorCodeType = _this.rogersErrorMap[result.statusCode] ? _this.rogersErrorMap[result.statusCode] : _this.rogersErrorMap["default"];
                                    }
                                    else {
                                        _this.errorCodeType = _this.getApiErrorCodeMapping('400.001');
                                    }
                                    /* Rogers micro services implmentatin end*/
                                    _this.accountModel.generalError = _this.errorCodeType.code;
                                    var errorPage = _this.isSubscriberFlow ? _this.dataLayerConfig.number : _this.dataLayerConfig.account;
                                    _this.dataLayerService.trackError({ page: errorPage.page }, ErrorType[_this.errorCodeType.type], _this.accountModel.generalError.toUpperCase(), _this.getErrorMessage('ute.easy.login.error.' + _this.accountModel.generalError, result.errorResponse), ErrorCategory.SELF_SERVE, '', 'Verify Email Link', false, [DataLayerPredefinedSection.PAGE, DataLayerPredefinedSection.SITE]);
                                }
                            });
                        };
                        this.getApiErrorCodeMapping = function (ec) {
                            var ret = _.find(_this.errorMap, function (o) {
                                return o[ec];
                            });
                            return ret ? ret[ec] : ret['default'];
                        };
                        this.maskEmailAddress = function (email) {
                            if (_.isEmpty(email)) {
                                return '';
                            }
                            var matchString = email.match(/(^\w.*)(@)(\w.*)(\.\w*$)/);
                            var section1 = matchString[1];
                            var section2 = matchString[2];
                            var section3 = matchString[3];
                            var section4 = matchString[4];
                            /**
                             * Reformat Section
                             */
                            section1 = "" + section1.substr(0, 1) + section1.substr(1, section1.length - 2).replace(/./g, '*') + section1.substr(section1.length - 1, 1);
                            if (section3.indexOf('.') > -1) {
                                section3 = section3.substr(0, 1) + section3.substr(1, section3.length - 2).replace(/[^.]/g, '*') + section3.slice(-1);
                            }
                            else {
                                section3 = section3.substr(0, 1) + section3.substr(1, section3.length - 2).replace(/./g, '*') + section3.slice(-1);
                            }
                            return "" + section1 + section2 + section3 + section4;
                        };
                        this.init();
                    }
                    EasyLoginRegistrationController.prototype.resetStepManager = function (subscriber) {
                        var _this = this;
                        this.STEP = subscriber ? SUBSTEP : STEP;
                        var keys = Object.keys(this.STEP).map(function (k) { return _this.STEP[k]; }).filter(function (v) { return typeof v === 'number'; });
                        this.stepManager = [];
                        keys.forEach(function (v) {
                            _this.stepManager.push(_this.getBasicStepModel(v));
                        });
                    };
                    EasyLoginRegistrationController.prototype.getBasicStepModel = function (step) {
                        return {
                            step: step,
                            active: false,
                            complete: false
                        };
                    };
                    EasyLoginRegistrationController.prototype.trackStep = function () {
                        var flowName = this.isSubscriberFlow && this.step !== this.STEP.MAIN ? 'subscriberRegistration' : 'accountRegistration';
                        var pageNameKey = this.getStepLowerCase(this.step);
                        if (this.step === this.STEP.VERIFY && this.isAutoRegistrationStarted) {
                            pageNameKey = 'great_news_verify';
                        }
                        this.trackDataLayer(flowName, pageNameKey);
                    };
                    EasyLoginRegistrationController.prototype.trackEmailResend = function (event) {
                        var dataLayerPayload = _.clone(this.dataLayerConfig.resendEmail);
                        if (this.step === this.STEP.ACCOUNT || this.step === SUBSTEP.NUMBER) {
                            dataLayerPayload.page = this.dataLayerConfig.great_news.page;
                        }
                        else if (this.step === this.STEP.VERIFY && this.isAutoRegistrationStarted) {
                            dataLayerPayload.page = this.dataLayerConfig.great_news_verify.page;
                        }
                        dataLayerPayload.events = event;
                        this.dataLayerService.track(dataLayerPayload, false, [DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.SITE]);
                    };
                    EasyLoginRegistrationController.prototype.trackSmsResend = function (event) {
                        var dataLayerPayload = _.clone(this.dataLayerConfig.resend_sms);
                        dataLayerPayload.events = event;
                        this.dataLayerService.track(dataLayerPayload, false, [DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.SITE]);
                    };
                    EasyLoginRegistrationController.prototype.trackDataLayer = function (key1, key2) {
                        this.dataLayerService.track({}, false, [DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                            DataLayerPredefinedSection.SITE], { mappingKey: key1 + '.' + key2 });
                    };
                    EasyLoginRegistrationController.prototype.getErrorMessage = function (translationKey, error) {
                        var serverErrorMessage = _.get(error, 'status.codeName', '');
                        if (serverErrorMessage) {
                            return this.sanitizeText(serverErrorMessage + ', ' + this.$translate.instant(translationKey));
                        }
                        else {
                            return this.sanitizeText(this.$translate.instant(translationKey));
                        }
                    };
                    EasyLoginRegistrationController.prototype.sanitizeText = function (text) {
                        return angular.element('<div>' + text + '</div>').text();
                    };
                    EasyLoginRegistrationController.prototype.getEmailErrorPayload = function () {
                        if (this.step === this.STEP.VERIFY) {
                            return this.isAutoRegistrationStarted ? this.dataLayerConfig.great_news_verify.page : this.dataLayerConfig.verify.page;
                        }
                        else if (this.step === this.STEP.EMAIL) {
                            return this.dataLayerConfig.email.page;
                        }
                        else if (this.step === this.STEP.ACCOUNT || this.step === SUBSTEP.NUMBER) {
                            return this.dataLayerConfig.great_news.page;
                        }
                    };
                    //Display visa promotions banner from  23rd May to 18th April.
                    EasyLoginRegistrationController.prototype.displayContestBanner = function () {
                        var date = new moment(), startDate = this.visaPromotionConfig.startDate, endDate = this.visaPromotionConfig.endDate;
                        if (!!startDate && !!endDate) {
                            startDate = moment(startDate, 'YYYYMMDD');
                            endDate = moment(endDate, 'YYYYMMDD');
                            if ((moment(date).isAfter(startDate) && moment(date).isBefore(endDate))
                                || (moment(date).isSame(startDate) || moment(date).isSame(endDate))) {
                                this.showContestBanner = true;
                            }
                        }
                    };
                    EasyLoginRegistrationController.prototype.setInputFocus = function (step) {
                        //Cancel timeout if the task already executed.
                        if (this.cancelTimeOut) {
                            this.$timeout.cancel(this.cancelTimeOut);
                        }
                        if (step === 1) {
                            var timeout = (this.devicePlatform.iOS() || this.devicePlatform.Android()) ? 500 : 0;
                            var thisObj_1 = this;
                            this.cancelTimeOut = this.$timeout(function () {
                                angular.element('#accountNumber-field').focus();
                                thisObj_1.$window.scrollTo(0, 0);
                            }, timeout);
                        }
                    };
                    ;
                    EasyLoginRegistrationController.prototype.getDevicePlatform = function () {
                        return {
                            Android: function () {
                                return navigator.userAgent.match(/Android/i);
                            },
                            iOS: function () {
                                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
                            }
                        };
                    };
                    EasyLoginRegistrationController.$inject = [
                        'ute.easy.login.registration.service',
                        '$window',
                        '$state',
                        '$modal',
                        'ute.datalayer.common.service',
                        '$translate',
                        '$injector',
                        '$timeout',
                        'vcRecaptchaService',
                        'util',
                        'ute.fraud.logging.service',
                        'ute.fraud.logging.TransactionProp'];
                    EasyLoginRegistrationController.controlerName = 'ute.easy.login.registration.controller';
                    return EasyLoginRegistrationController;
                }());
                angular.module('ute.easy.login.registration').controller(EasyLoginRegistrationController.controlerName, EasyLoginRegistrationController);
                angular.module('ute.easy.login.registration').directive('uteAccountNumberInput', function () {
                    return {
                        require: 'ngModel',
                        link: function (scope, el, attr, ngModelCtrl) {
                            function fromUser(text) {
                                var newVal = text;
                                newVal = newVal.replace(/\D/g, '');
                                if (newVal.length > 12) {
                                    newVal = newVal.substring(0, 12);
                                }
                                if (newVal !== text) {
                                    ngModelCtrl.$setViewValue(newVal);
                                    ngModelCtrl.$render();
                                }
                                return newVal;
                            }
                            ;
                            ngModelCtrl.$parsers.push(fromUser);
                        }
                    };
                });
                angular.module('ute.easy.login.registration').directive('utePostalCodeInput', function () {
                    return {
                        require: 'ngModel',
                        link: function (scope, el, attr, ngModelCtrl) {
                            function fromUser(text) {
                                var t = text;
                                //t = t.replace(/\W/g, '');
                                // if ( t.length > 6) {
                                //     t = t.substring(0, 6);
                                // }
                                // if (t !== text) {
                                //     ngModelCtrl.$setViewValue(t);
                                //     ngModelCtrl.$render();
                                // }
                                var match = /\W/.exec(t);
                                if (match && match[0] !== ' ') {
                                    t = t.slice(0, match.index) + t.slice(match.index + 1, t.length);
                                    ngModelCtrl.$setViewValue(t);
                                    ngModelCtrl.$render();
                                }
                                return text;
                            }
                            ngModelCtrl.$parsers.push(fromUser);
                        }
                    };
                });
                angular.module('ute.easy.login.registration').directive('phoneNumberMasking', function () {
                    return {
                        require: 'ngModel',
                        link: function (scope, el, attr, ngModelCtrl) {
                            ngModelCtrl.$parsers.push(function (value) {
                                var newVal = value || '';
                                newVal = newVal.replace(/\D/g, '');
                                if (newVal.length === 0) {
                                    newVal = '';
                                }
                                else if (newVal.length <= 3) {
                                    newVal = newVal.replace(/^(\d{0,3})/, '$1');
                                }
                                else if (newVal.length <= 6) {
                                    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '$1-$2');
                                }
                                else {
                                    newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(.*)/, '$1-$2-$3');
                                }
                                if (newVal.length > 12) {
                                    newVal = newVal.substring(0, 12);
                                }
                                if (newVal !== value) {
                                    ngModelCtrl.$setViewValue(newVal);
                                    ngModelCtrl.$render();
                                }
                                return newVal;
                            });
                        }
                    };
                });
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                angular.module('ute.easy.login.registration').config([
                    '$stateProvider',
                    function ($stateProvider) {
                        if (window.location.hostname.match(/fido.ca/) !== null) {
                            $stateProvider.state('easylogin/main', {
                                url: '/easylogin/main',
                                controller: 'ute.easy.login.registration.controller',
                                controllerAs: '$ctrl',
                                title: 'easyLoginMain',
                                templateUrl: 'module/easyLoginRegistration/templates/fido/easyLoginRegistration.html',
                            }).state('easylogin/registration', {
                                url: '/easylogin/registration?token&setLanguage&accountType',
                                controller: 'ute.easy.login.registration.controller',
                                controllerAs: '$ctrl',
                                title: 'easyLoginMain',
                                templateUrl: 'module/easyLoginRegistration/templates/fido/easyLoginRegistration.html',
                            });
                        }
                        else {
                            $stateProvider.state('easylogin/main', {
                                url: '/easylogin/main',
                                controller: 'ute.easy.login.registration.controller',
                                controllerAs: '$ctrl',
                                templateUrl: 'module/easyLoginRegistration/templates/rogers/easyLoginRegistration.html',
                                resolve: {
                                    redirectToDAM: ['$window', '$q', function ($window, $q) {
                                            $window.open('/consumer/profile/register', '_self');
                                            return $q.defer().promise;
                                        }],
                                }
                            }).state('easylogin/registration', {
                                url: '/easylogin/registration?token&setLanguage',
                                controller: 'ute.easy.login.registration.controller',
                                controllerAs: '$ctrl',
                                templateUrl: 'module/easyLoginRegistration/templates/rogers/easyLoginRegistration.html',
                            });
                        }
                    }
                ]);
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                var MODAL_STEP;
                (function (MODAL_STEP) {
                    MODAL_STEP[MODAL_STEP["processing"] = 1] = "processing";
                    MODAL_STEP[MODAL_STEP["success"] = 2] = "success";
                    MODAL_STEP[MODAL_STEP["invalid"] = 3] = "invalid";
                })(MODAL_STEP || (MODAL_STEP = {}));
                var FidoEmailVerificationModalController = (function () {
                    function FidoEmailVerificationModalController($modalInstance, token, easyLoginRegistrationService, $timeout) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.token = token;
                        this.easyLoginRegistrationService = easyLoginRegistrationService;
                        this.$timeout = $timeout;
                        this.init = function () {
                            _this.step = MODAL_STEP.processing;
                            _this.MODAL_STEP = MODAL_STEP;
                            _this.encryptedToken = '';
                            _this.userID = '';
                            if (_this.token) {
                                _this.easyLoginRegistrationService.verifyEmail({
                                    emailToken: _this.token
                                }).then(function (response) {
                                    var res = response.data;
                                    var statusCode = _.get(res, 'status.code', '');
                                    if (statusCode.toString() === '200') {
                                        _this.step = MODAL_STEP.success;
                                        _this.encryptedToken = _.get(res, 'content.token', '');
                                        _this.userID = _.get(res, 'content.userID', '');
                                        _this.$timeout(function () {
                                            _this.$modalInstance.close({ token: _this.encryptedToken, userID: _this.userID });
                                        }, 1000);
                                    }
                                    else {
                                        _this.step = MODAL_STEP.invalid;
                                        _this.$timeout(function () {
                                            _this.$modalInstance.close({ token: 'invalid', statusCode: statusCode, errorResponse: res });
                                        }, 1000);
                                    }
                                }).catch(function (e) {
                                    // console.log(e);
                                    _this.step = MODAL_STEP.invalid;
                                    var statusCode = _.get(e, 'data.status.code', _.get(e, 'status', ''));
                                    _this.$timeout(function () {
                                        _this.$modalInstance.close({ token: 'invalid', statusCode: statusCode, errorResponse: e.data });
                                    }, 1000);
                                });
                            }
                            else {
                                _this.$modalInstance.close();
                            }
                        };
                        this.init();
                    }
                    FidoEmailVerificationModalController.$inject = [
                        '$modalInstance',
                        'token',
                        'ute.easy.login.registration.service',
                        '$timeout'
                    ];
                    FidoEmailVerificationModalController.controlerName = 'ute.easy.login.registration.fidoEmailVerification.modal.controller';
                    return FidoEmailVerificationModalController;
                }());
                angular.module('ute.easy.login.registration').controller(FidoEmailVerificationModalController.controlerName, FidoEmailVerificationModalController);
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                var MODAL_STEP;
                (function (MODAL_STEP) {
                    MODAL_STEP[MODAL_STEP["processing"] = 1] = "processing";
                    MODAL_STEP[MODAL_STEP["success"] = 2] = "success";
                    MODAL_STEP[MODAL_STEP["invalid"] = 3] = "invalid";
                })(MODAL_STEP || (MODAL_STEP = {}));
                var RogersEmailVerificationController = (function () {
                    function RogersEmailVerificationController($modalInstance, token, easyLoginRegistrationService, $timeout) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.token = token;
                        this.easyLoginRegistrationService = easyLoginRegistrationService;
                        this.$timeout = $timeout;
                        this.init = function () {
                            _this.step = MODAL_STEP.processing;
                            _this.MODAL_STEP = MODAL_STEP;
                            _this.encryptedToken = '';
                            _this.userID = '';
                            if (_this.token) {
                                console.log(_this.token);
                                _this.easyLoginRegistrationService.rogersVerifyEmail({
                                    token: _this.token
                                }).then(function (response) {
                                    var res = response.data;
                                    _this.step = MODAL_STEP.success;
                                    _this.encryptedToken = _.get(res, 'data.token', '');
                                    _this.userID = _.get(res, 'data.userName', '');
                                    _this.$timeout(function () {
                                        _this.$modalInstance.close({ token: _this.encryptedToken, userID: _this.userID });
                                    }, 1000);
                                }).catch(function (e) {
                                    var res = e.data;
                                    var error = res.errors ? _.first(res.errors) : { code: 'AN05-SY11-SV084-OT00ON00ET36-Err' };
                                    var errorCode = error.code.split('-').slice(3).join('-');
                                    ;
                                    console.log('the error is', errorCode);
                                    _this.step = MODAL_STEP.invalid;
                                    _this.$timeout(function () {
                                        _this.$modalInstance.close({ token: 'invalid', statusCode: errorCode, errorResponse: e.data });
                                    }, 1000);
                                });
                            }
                            else {
                                _this.$modalInstance.close();
                            }
                        };
                        this.init();
                    }
                    RogersEmailVerificationController.$inject = [
                        '$modalInstance',
                        'token',
                        'ute.easy.login.registration.service',
                        '$timeout'
                    ];
                    RogersEmailVerificationController.controlerName = 'ute.easy.login.registration.rogersEmailVerification.modal.controller';
                    return RogersEmailVerificationController;
                }());
                angular.module('ute.easy.login.registration').controller(RogersEmailVerificationController.controlerName, RogersEmailVerificationController);
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var eclipse;
        (function (eclipse) {
            var remote;
            (function (remote) {
                var api;
                (function (api) {
                    'use strict';
                    var EclipseRemoteApiProvider = (function () {
                        /* @ngInject */
                        function EclipseRemoteApiProvider() {
                            var _this = this;
                            this.config = {
                                contextRoot: '',
                                logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                api: 'v1/storeData',
                                errorModalTemplate: 'module/eclipseRemoteAPi/eclipseRemoteAPiViews/errorModal.view.html'
                            };
                            this.solarisConsumerUrl = '/web/consumer';
                            this.solarisRepUrl = '/web/rep';
                            /* @ngInject */
                            this.$get = function ($injector, $window, $urlMatcherFactory, $q, $http) {
                                _this.$window = $window;
                                _this.$q = $q;
                                _this.$urlMatcherFactory = $urlMatcherFactory;
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.$http = $http;
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.$modal = $injector.get('$modal');
                                return {
                                    goToIPTVDashboard: _this.goToRemoteIPTVDashboard,
                                    goToIPTVFromCravePage: _this.goToIPTVDashboardFromCrave,
                                    goToIPTVSwapDashboard: _this.goToRemoteIPTVSwapDashboard,
                                    goToHSIDashboard: _this.goToRemoteHSIDashboard,
                                    goToPendingOrders: _this.goToPendingOrders,
                                    goToComboPackages: _this.goToComboPackages,
                                    goToRHPDashboard: _this.goToRemoteRHPDashboard,
                                    goToTVChannelsAndThemePacks: _this.goToChannelsAndThemePacks,
                                    goToTVSwapChannels: _this.goToRemoteTVSwapChannels,
                                    goToTVChangePackage: _this.goToRemoteTVChangePackage,
                                    goToInternetDailyUsage: _this.goToRemoteInternetDailyUsage,
                                    goToInternetMonthlyUsage: _this.goToRemoteInternetMonthlyUsage,
                                    goToInternetDailyAlerts: _this.goToRemoteInternetDailyAlerts,
                                    goToLegacyInternetDailyUsage: _this.goToLegacyInternetDailyUsage,
                                    goToLegacyInternetMonthlyUsage: _this.goToLegacyInternetMonthlyUsage,
                                    goToLegacyInternetDailyAlerts: _this.goToLegacyInternetDailyAlerts,
                                    goToInternetChangePackage: _this.goToRemoteInternetChangePackage,
                                    getIPTVData: _this.getIPTVData,
                                    getInternetData: _this.getInternetData,
                                    isEclipseSubscription: _this.isEclipseSubscription,
                                    isEclipseTvSubscription: _this.isEclipseTvSubscription,
                                    isEclipseInternetSubscription: _this.isEclipseInternetSubscription,
                                    isEclipseHomePhoneSubscription: _this.isEclipseHomePhoneSubscription
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                return true;
                            };
                            this.goToRemoteIPTVDashboard = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv');
                            };
                            this.goToIPTVDashboardFromCrave = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv?contentupsell=true');
                            };
                            this.goToRemoteIPTVSwapDashboard = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv?swap=true');
                            };
                            this.goToRemoteHSIDashboard = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/internet');
                            };
                            this.goToRemoteRHPDashboard = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/home-phone');
                            };
                            this.goToChannelsAndThemePacks = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv/channels-and-themepacks');
                            };
                            this.goToRemoteTVSwapChannels = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv/swap-channels');
                            };
                            this.goToRemoteTVChangePackage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/tv/change-tv-package');
                            };
                            this.goToRemoteInternetDailyUsage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/internet/usage/daily');
                            };
                            this.goToRemoteInternetMonthlyUsage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/internet/usage/monthly');
                            };
                            this.goToRemoteInternetDailyAlerts = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/internet/usage/alerts');
                            };
                            this.goToLegacyInternetDailyUsage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/legacy/internet/usage/daily');
                            };
                            this.goToLegacyInternetMonthlyUsage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/legacy/internet/usage/monthly');
                            };
                            this.goToLegacyInternetDailyAlerts = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/legacy/internet/usage/alerts');
                            };
                            this.goToRemoteInternetChangePackage = function (input, queryParams, options) {
                                return _this.goTo(input, queryParams, options, 'myrogers/internet/change-internet-package');
                            };
                            this.goToPendingOrders = function (input) {
                                return _this.goTo(input, {}, {}, 'manageappt');
                            };
                            this.goToComboPackages = function (input, queryParams) {
                                return _this.encryptionService.encrypt(input).then(function (id) {
                                    var allParams = angular.extend({ id: id }, queryParams);
                                    var url = _this.getContextUrl(queryParams.userType) + "/#/combo-packages/tv-internet" + _this.serialize(allParams);
                                    _this.$window.location.href = url;
                                    return url;
                                });
                            };
                            this.goTo = function (input, queryParams, options, remoteState) {
                                var self = _this;
                                var _queryParams = angular.extend(queryParams);
                                if (input) {
                                    _this.$http.post(_this.securityService.getBackendUrl(_this.config.api), input)
                                        .then(function (response) {
                                        if (!_.isEmpty(response.data.dpid)) {
                                            var url = self.getContextUrl(_queryParams.userType) + "/" + self.$urlMatcherFactory.compile(remoteState);
                                            if (_.contains(url, '?')) {
                                                self.$window.location.href = url + '&dpid=' + response.data.dpid + '&userType=' + _queryParams.userType;
                                            }
                                            else {
                                                self.$window.location.href = url + '?dpid=' + response.data.dpid + '&userType=' + _queryParams.userType;
                                            }
                                            return url;
                                        }
                                    })
                                        .catch(function () {
                                        var modalInstance = self.$modal.open({
                                            templateUrl: self.config.errorModalTemplate,
                                            controller: ['$scope', function ($scope) {
                                                    $scope.close = function () {
                                                        modalInstance.close();
                                                    };
                                                }]
                                        });
                                    })
                                        .finally(function () { });
                                }
                                else {
                                    var url = self.getContextUrl(_queryParams.userType) + "/#/" + _this.$urlMatcherFactory.compile(remoteState);
                                    _this.$window.location.href = url + _this.serialize(_queryParams);
                                    return _this.$q.when(url);
                                }
                            };
                            this.getContextUrl = function (userType) {
                                return userType === 'care' ? _this.solarisRepUrl : _this.solarisConsumerUrl;
                            };
                            this.isEclipseTvSubscription = function (subscription /* ISub */) {
                                return (subscription.subType === 'IPTV');
                            };
                            this.isEclipseInternetSubscription = function (subscription /* ISub */) {
                                return (subscription.subType === 'HSI');
                            };
                            this.isEclipseHomePhoneSubscription = function (subscription /* ISub */) {
                                return (subscription.subType === 'RHP Phone Line');
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$window',
                                '$urlMatcherFactory',
                                '$q',
                                '$http'
                            ];
                        }
                        ;
                        EclipseRemoteApiProvider.prototype.isEclipseSubscription = function (subAccountId) {
                            return (subAccountId &&
                                subAccountId.toString().length === 9 &&
                                subAccountId.toString().substr(0, 2) === '21');
                        };
                        //temp - use $httpParamSerializer?
                        EclipseRemoteApiProvider.prototype.serialize = function (obj) {
                            if (!obj) {
                                return '';
                            }
                            return '?' + Object.keys(obj).reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a; }, []).join('&');
                        };
                        //TEMP HARDCODE
                        EclipseRemoteApiProvider.prototype.getIPTVData = function () {
                            return {
                                'subNumber': 'F72000CAB124',
                                'isAccountHolder': true,
                                'subType': 'Digital TV',
                                'subStatus': 'Active',
                                'realSubStatus': 'Active',
                                'subAccountId': '211697529',
                                'subAddress': {
                                    'streetNumber': '****',
                                    'streetName': '****',
                                    'streetNameSuffix': '',
                                    'streetType': '****',
                                    'compassDirection': 'Please Specify',
                                    'unit': '',
                                    'postalCode': '****',
                                    'city': '****',
                                    'province': 'ON',
                                    'addressId': '2021173118',
                                    'additionalAddressInfo': '**** ****  **** ON ****'
                                },
                                'serviceNumber': 'F72000CAB124',
                                'effectiveDate': '2016-03-08',
                                'firstname': 'CHRIS'
                            };
                        };
                        ;
                        //TEMP HARDCODE
                        EclipseRemoteApiProvider.prototype.getInternetData = function () {
                            return {
                                'subNumber': 'F72000CAB125',
                                'isAccountHolder': true,
                                'subType': 'Hi-Speed Internet',
                                'subStatus': 'Active',
                                'realSubStatus': 'Active',
                                'subAccountId': '211697529',
                                'subAddress': {
                                    'streetNumber': '****',
                                    'streetName': '****',
                                    'streetNameSuffix': '',
                                    'streetType': '****',
                                    'compassDirection': 'Please Specify',
                                    'unit': '',
                                    'postalCode': '****',
                                    'city': '****',
                                    'province': 'ON',
                                    'addressId': '2021173118',
                                    'additionalAddressInfo': '**** ****  **** ON ****'
                                },
                                'serviceNumber': 'F72000CAB124',
                                'effectiveDate': '2016-03-08',
                                'firstname': 'CHRIS'
                            };
                        };
                        ;
                        EclipseRemoteApiProvider.$inject = [];
                        return EclipseRemoteApiProvider;
                    }());
                    angular.module('ute.rogers.eclipse.remote.api').provider('ute.rogers.eclipse.remote.api.service', EclipseRemoteApiProvider);
                })(api = remote.api || (remote.api = {}));
            })(remote = eclipse.remote || (eclipse.remote = {}));
        })(eclipse = rogers.eclipse || (rogers.eclipse = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            angular.module('ute.common.encryption').config(configure).run(addStateHandler);
            configure.$inject = ['$cryptoProvider'];
            /* @ngInject */
            function configure($cryptoProvider) {
                $cryptoProvider.setCryptographyKey('ABCD123');
            }
            addStateHandler.$inject = ['ute.blocks.router', 'ute.common.encryption.service'];
            /* @ngInject */
            function addStateHandler(routerHelper, encryptionService) {
                routerHelper.registerGlobalToStateHandler(encryptionService);
            }
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var encryption;
        (function (encryption) {
            'use strict';
            // !!!! Do not remove or rename existing members only add new at the end
            var Params;
            (function (Params) {
                Params[Params["phoneNumber"] = 1] = "phoneNumber";
                Params[Params["accountNumber"] = 2] = "accountNumber";
                Params[Params["currentSimCardNumber"] = 3] = "currentSimCardNumber";
                Params[Params["newSimCardNumber"] = 4] = "newSimCardNumber";
                Params[Params["accountEmail"] = 5] = "accountEmail";
                Params[Params["deviceNameEn"] = 6] = "deviceNameEn";
                Params[Params["deviceNameFr"] = 7] = "deviceNameFr";
                Params[Params["firstName"] = 8] = "firstName";
                Params[Params["email"] = 9] = "email";
            })(Params || (Params = {}));
            var EncryptionService = (function () {
                /* @ngInject */
                function EncryptionService(logger, $crypto, userService, utilsService, $state) {
                    var _this = this;
                    this.logger = logger;
                    this.$crypto = $crypto;
                    this.userService = userService;
                    this.utilsService = utilsService;
                    this.$state = $state;
                    this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                        var params = _.intersection(_.keys(toParams), _.get(toState, 'data.encryption.params'));
                        if (params) {
                            params.forEach(function (param) {
                                _this.decrypt(toParams[param]).then(function () {
                                    //
                                }).catch(function (error) {
                                    event.preventDefault();
                                    _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                                });
                            });
                        }
                        else {
                            event.preventDefault();
                            _this.$state.go(_.get(toState, 'data.encryption.failbackState'));
                        }
                        return true;
                    };
                    this._encrypt = function (obj) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.encryptWithKey)(obj));
                    };
                    /**
                     * @param obj
                     * @returns {string}
                     */
                    this.resolver = function (obj) {
                        if (_this.userService.getUser()) {
                            var userName = _this.userService.getUser().userName;
                            var objStr = _.isString(obj) ? obj : angular.toJson(obj);
                            //console.log('EncryptionService->resolver:', objStr + userName);
                            return objStr + userName;
                        }
                        else {
                            _this.utilsService.randomString();
                        }
                    };
                    /**
                     * @param obj
                     * @param key
                     * @returns {ng.IPromise<string>|*|any}
                     */
                    this.encryptWithKey = function (obj, key) {
                        //console.log('EncryptionService->encrypt:', key);
                        //console.log('EncryptionService->encrypt:', key, obj, (_.reduce<{}, _.Dictionary<{}>>(
                        //    obj,
                        //    (result: _.Dictionary<{}>, value: {}, key: string): _.Dictionary<{}> => {
                        //      result[_.find([Params[key], key], angular.isDefined)] = value;
                        //      return result;
                        //    }, {})));
                        return _this.$crypto.encrypt(angular.toJson(_.reduce(obj, function (result, value, key) {
                            result[_.find([Params[key], key], angular.isDefined)] = value;
                            return result;
                        }, {})), key);
                    };
                    /**
                     * @param str
                     * @returns {any}
                     * @private
                     */
                    this._decrypt = function (str) {
                        return _this.userService.getEncryptionKey().then(_.curry(_this.decryptWithKey)(str));
                    };
                    /**
                     * @param str
                     * @param key
                     * @returns {any}
                     */
                    this.decryptWithKey = function (str, key) {
                        try {
                            //console.log('EncryptionService->decrypt:', str, key, angular.fromJson(this.$crypto.decrypt(str, key)));
                            return _.reduce(angular.fromJson(_this.$crypto.decrypt(str, key)), function (result, value, key) {
                                result[_.find([Params[key], key], angular.isDefined)] = value;
                                return result;
                            }, {});
                        }
                        catch (e) {
                            throw new Error('EncryptionService->decryptWithKey error: ' + e.toString());
                        }
                    };
                    this.encrypt = _.memoize(this._encrypt, this.resolver);
                    this.decrypt = _.memoize(this._decrypt, this.resolver);
                }
                EncryptionService.$inject = [
                    'ute.blocks.loggerService',
                    '$crypto',
                    'ute.common.user.service',
                    'ute.common.utils.service',
                    '$state'
                ];
                return EncryptionService;
            }());
            angular.module('ute.common.encryption').service('ute.common.encryption.service', EncryptionService);
        })(encryption = common.encryption || (common.encryption = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                // TODO where it used?
                var locales = {
                    'locales': {
                        'fr_CA': 'Français',
                        'en_CA': 'English'
                    },
                    'preferredLocale': 'en_CA'
                };
                angular.module('ute.blocks.language.switcher').config(configure).constant('LOCALES', locales);
                configure.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];
                /* @ngInject */
                function configure($translateProvider, tmhDynamicLocaleProvider) {
                    // TODO 'en' move to config
                    $translateProvider
                        .preferredLanguage('en')
                        .useStorage('ute.blocks.language.switcher.customLocaleStorage')
                        .useSanitizeValueStrategy(null);
                    tmhDynamicLocaleProvider.localeLocationPattern('scripts/angular-i18n/angular-locale_{{locale}}.js');
                }
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var CustomLocaleStorage = (function () {
                    /* @ngInject */
                    function CustomLocaleStorage($cookies) {
                        var _this = this;
                        this.$cookies = $cookies;
                        // TODO provider and configure
                        this.path = '/';
                        this.domain = '.rogers.com';
                        this.LANG_KEY = 'NG_TRANSLATE_LANG_KEY';
                        this.put = function (name, value) {
                            //console.log('CustomLocaleStorage->put: name=', name, ' value=', value);
                            if (name === _this.LANG_KEY) {
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path, domain: _this.domain });
                                _this.$cookies.put(ute.common.core.RogersCookies.LANGUAGE, value, { path: _this.path }); // to support ute.ui
                            }
                        };
                        this.get = function (name) {
                            //console.log('CustomLocaleStorage->get: name=', name);
                            if (name === _this.LANG_KEY) {
                                return _this.getCurrentLanguage();
                            }
                        };
                        this.getCurrentLanguage = function () {
                            // TODO use default lang from angular-translate
                            return _this.$cookies.get(ute.common.core.RogersCookies.LANGUAGE) || 'en';
                        };
                    }
                    CustomLocaleStorage.$inject = [angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'];
                    return CustomLocaleStorage;
                }());
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher.customLocaleStorage', CustomLocaleStorage);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitchController = (function () {
                    /* @ngInject */
                    function LanguageSwitchController($translate, tmhDynamicLocale, languageSwitcher) {
                        var _this = this;
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.languageSwitcher = languageSwitcher;
                        this.changeLanguage = function () {
                            if (angular.isDefined($)) {
                                $('html').attr('lang', _this.$translate.instant('ute.blocks.language.switcher.to'));
                            }
                            return _this.languageSwitcher.changeLanguage(_this.$translate.instant('ute.blocks.language.switcher.to'));
                        };
                    }
                    LanguageSwitchController.$inject = ['$translate', 'tmhDynamicLocale', 'ute.blocks.language.switcher'];
                    return LanguageSwitchController;
                }());
                switcher.LanguageSwitchController = LanguageSwitchController;
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var LanguageSwitch = (function () {
                    function LanguageSwitch() {
                        this.bindToController = true;
                        //controller: string = 'ute.common.core.LanguageSwitchController';
                        this.controller = switcher.LanguageSwitchController;
                        this.controllerAs = 'languageSwitch';
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = 'module/language.switcher/languageSwitch.html';
                    }
                    //constructor(private $translate: ng.translate.ITranslateService) {
                    //}
                    LanguageSwitch.factory = function () {
                        var directive = function () { return new LanguageSwitch(); };
                        //directive.$inject = ['$translate'];
                        return directive;
                    };
                    return LanguageSwitch;
                }());
                angular.module('ute.blocks.language.switcher').directive('uteLanguageSwitch', LanguageSwitch.factory());
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var language;
        (function (language) {
            var switcher;
            (function (switcher) {
                'use strict';
                var SubPubGeneric = ute.common.core.subpub.SubPubGeneric;
                var LanguageSwitcher = (function (_super) {
                    __extends(LanguageSwitcher, _super);
                    /* @ngInject */
                    function LanguageSwitcher($translate, tmhDynamicLocale, localeStorage, routerHelper, $location) {
                        var _this = this;
                        _super.call(this, 'LanguageSwitcher');
                        this.$translate = $translate;
                        this.tmhDynamicLocale = tmhDynamicLocale;
                        this.$location = $location;
                        this.lang2locale = {
                            fr: 'fr-ca',
                            en: 'en-ca'
                        };
                        this.getCurrentLanguage = function () { return _this.currentLanguage; };
                        /**
                         * @param switchToLang
                         * @returns {boolean}
                         */
                        this.changeLanguage = function (switchToLang) {
                            if (!_.include(LanguageSwitcher.supportedLanguages, switchToLang)) {
                                return false;
                            }
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.$location.search(_.assign(search, { lang: switchToLang }));
                            }
                            _this.currentLanguage = switchToLang;
                            // console.log('changeLanguage: switchToLang=' + switchToLang,
                            //     'tmhDynamicLocale.get()=', this.tmhDynamicLocale.get(),
                            //     'currentLanguage=', this.currentLanguage);
                            _this.$translate.use(switchToLang);
                            _this.tmhDynamicLocale.set(_this.lang2locale[switchToLang]);
                            _this.notifySubs();
                            return true;
                        };
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            var search = _this.$location.search();
                            if (_.has(search, 'lang')) {
                                _this.changeLanguage(search.lang);
                            }
                            return true;
                        };
                        this.currentLanguage = localeStorage.getCurrentLanguage();
                        LanguageSwitcher.supportedLanguages.forEach(function (lang) { return _this.tmhDynamicLocale.set(_this.lang2locale[lang]); });
                        this.tmhDynamicLocale.set(this.lang2locale[this.currentLanguage]);
                        routerHelper.registerGlobalFromStateHandler(this, ute.blocks.router.StateHandlerPriority.HIGH);
                    }
                    LanguageSwitcher.prototype.getChangableData = function () {
                        return this.currentLanguage;
                    };
                    LanguageSwitcher.$inject = [
                        '$translate',
                        'tmhDynamicLocale',
                        'ute.blocks.language.switcher.customLocaleStorage',
                        'ute.blocks.router',
                        '$location'];
                    LanguageSwitcher.supportedLanguages = ['en', 'fr'];
                    return LanguageSwitcher;
                }(SubPubGeneric));
                angular.module('ute.blocks.language.switcher').service('ute.blocks.language.switcher', LanguageSwitcher);
            })(switcher = language.switcher || (language.switcher = {}));
        })(language = blocks.language || (blocks.language = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            var TransactionProp = {
                requestUrl: {
                    rogers: '/web/totes/api/v1/captureTransactionInfo',
                    fido: '/bfa-api/v1/captureTransactionInfo',
                    bss: '/web/smb/api/v1/captureTransactionInfo'
                },
                sourceChannel: {
                    rogers: 'UTE-ROGERS-ONLINE',
                    fido: 'UTE-FIDO-ONLINE',
                    bss: 'UTE-ROGERS-BSS',
                    oneview: 'ONEVIEW-CARE'
                },
                transactionType: {
                    login: 'Login',
                    createProfile: 'Create Profile',
                    accountOverview: 'Account Overview',
                    profile: 'Profile',
                    billing: 'Billing'
                },
                action: {
                    login: 'login',
                    createProfile: 'create profile',
                    accountSelection: 'account selection',
                    setRecoveryNumber: 'set recovery number',
                    changeRecoveryNumber: 'change recovery number',
                    forgotUsername: 'forgot username',
                    forgotPassword: 'forgot password',
                    viewBill: 'view bill',
                    changePassword: 'change password'
                },
                userType: {
                    consumer: 'Customer',
                    employee: 'Employee'
                },
                transactionStatus: {
                    success: 'Success',
                    failure: 'Failure'
                },
                franchise: {
                    rogers: 'Rogers',
                    fido: 'Fido'
                }
            };
            angular.module('ute.fraud.logging').constant('ute.fraud.logging.TransactionProp', TransactionProp);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var fraud;
    (function (fraud) {
        var logging;
        (function (logging) {
            'use strict';
            /**
             * @description Class for capturing transaction info
             * @class FraudLoggingService
             * @implements {IFraudLoggingService}
             */
            var FraudLoggingService = (function () {
                function FraudLoggingService($http, $q, transactionProp) {
                    this.$http = $http;
                    this.$q = $q;
                    this.transactionProp = transactionProp;
                    this.useMockData = false;
                }
                /**
                 * @description Function to call v1/captureTransactionInfo POST API
                 * @param payload
                 * @return HTTP promise
                 */
                FraudLoggingService.prototype.captureTransaction = function (payload) {
                    var deferred = this.$q.defer();
                    var captureTransactionRequest = '';
                    if (payload.sourceChannel === this.transactionProp.sourceChannel.rogers) {
                        captureTransactionRequest = this.transactionProp.requestUrl.rogers;
                    }
                    else if (payload.sourceChannel === this.transactionProp.sourceChannel.fido) {
                        captureTransactionRequest = this.transactionProp.requestUrl.fido;
                    }
                    else if (payload.sourceChannel === this.transactionProp.sourceChannel.bss) {
                        captureTransactionRequest = this.transactionProp.requestUrl.bss;
                    }
                    if (this.useMockData) {
                        this.$http.get('ute-fraud-logging/assets/mocks/captureTransactionInfo-auth-failure.json')
                            .then(function (resp) { return deferred.resolve(resp); }, function (err) { return deferred.reject(err); });
                    }
                    else {
                        this.$http.post(captureTransactionRequest, payload)
                            .then(function (resp) { return deferred.resolve(resp); }, function (err) { return deferred.reject(err); });
                    }
                    return deferred.promise;
                };
                FraudLoggingService.$inject = ['$http', '$q', 'ute.fraud.logging.TransactionProp'];
                return FraudLoggingService;
            }());
            angular.module('ute.fraud.logging').service('ute.fraud.logging.service', FraudLoggingService);
        })(logging = fraud.logging || (fraud.logging = {}));
    })(fraud = ute.fraud || (ute.fraud = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessFailedModalController = (function () {
            function GoPaperlessFailedModalController($modalInstance, errorMessageKey) {
                this.$modalInstance = $modalInstance;
                this.errorMessageKey = errorMessageKey;
            }
            GoPaperlessFailedModalController.prototype.ok = function () {
                this.$modalInstance.close('ok');
            };
            GoPaperlessFailedModalController.$inject = [
                '$modalInstance',
                'errorMessageKey'];
            return GoPaperlessFailedModalController;
        }());
        goPaperless.GoPaperlessFailedModalController = GoPaperlessFailedModalController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.failedModal.controller', GoPaperlessFailedModalController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessCurrentEmailModalController = (function () {
            function GoPaperlessCurrentEmailModalController($modalInstance, goPaperlessService, email) {
                this.$modalInstance = $modalInstance;
                this.goPaperlessService = goPaperlessService;
                this.email = email;
                this.isProcessing = false;
            }
            GoPaperlessCurrentEmailModalController.prototype.closeModal = function () {
                this.$modalInstance.dismiss();
            };
            GoPaperlessCurrentEmailModalController.prototype.switchBillingType = function () {
                var _this = this;
                this.isProcessing = true;
                this.goPaperlessService.updateBillingType()
                    .then(function () {
                    _this.goPaperlessService.showSuccessModal();
                    _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: true });
                })
                    .catch(function () {
                    _this.goPaperlessService.getDeferredObj().reject({ switchSuccess: false });
                })
                    .finally(function () {
                    _this.$modalInstance.close();
                    _this.isProcessing = false;
                });
            };
            GoPaperlessCurrentEmailModalController.prototype.updateEmail = function () {
                this.goPaperlessService.showSaveEmailModal(this.email);
                this.$modalInstance.close();
            };
            GoPaperlessCurrentEmailModalController.$inject = [
                '$modalInstance',
                'ute.goPaperless.service',
                'email'
            ];
            return GoPaperlessCurrentEmailModalController;
        }());
        goPaperless.GoPaperlessCurrentEmailModalController = GoPaperlessCurrentEmailModalController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.currentEmailModal.controller', GoPaperlessCurrentEmailModalController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessSaveEmailModalController = (function () {
            function GoPaperlessSaveEmailModalController($modalInstance, goPaperlessService, suggestedEmail) {
                var _this = this;
                this.$modalInstance = $modalInstance;
                this.goPaperlessService = goPaperlessService;
                this.suggestedEmail = suggestedEmail;
                this.isProcessing = false;
                this.formModel = {};
                this.closeCallback = function () {
                    _this.isProcessing = false;
                    _this.$modalInstance.close();
                };
                this.formModel.email = (this.isEmail(this.suggestedEmail)) ? this.suggestedEmail : '';
                this.customerHasContactEmail = !!this.goPaperlessService.getContactEmail();
            }
            GoPaperlessSaveEmailModalController.prototype.closeModal = function () {
                this.$modalInstance.dismiss();
            };
            ;
            GoPaperlessSaveEmailModalController.prototype.updateAndSwitch = function (form) {
                var _this = this;
                if (!form.$valid) {
                    this.isProcessing = false;
                    return;
                }
                else {
                    this.isProcessing = true;
                }
                if (this.customerHasContactEmail) {
                    this.goPaperlessService.updateBillingType(this.formModel.email)
                        .then(function () {
                        if (_this.formModel.email.toLowerCase() !== _this.goPaperlessService.getContactEmail().toLowerCase()) {
                            _this.goPaperlessService.updateEmailAddress(_this.formModel.email)
                                .then(function () {
                                _this.goPaperlessService.showSuccessModal();
                                _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: true, updatedEmail: _this.formModel.email });
                            })
                                .catch(function () {
                                _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: true });
                            })
                                .finally(_this.closeCallback);
                        }
                        else {
                            // if cx enter the old email again, no need to call updateEmailAddress.
                            _this.goPaperlessService.showSuccessModal();
                            _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: true });
                            _this.closeCallback();
                        }
                    })
                        .catch(function () {
                        _this.goPaperlessService.getDeferredObj().reject({ switchSuccess: false });
                        _this.closeCallback();
                    });
                }
                else {
                    this.goPaperlessService.updateEmailAddress(this.formModel.email)
                        .then(function () {
                        _this.goPaperlessService.updateBillingType(_this.formModel.email)
                            .then(function () {
                            _this.goPaperlessService.showSuccessModal();
                            _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: true, updatedEmail: _this.formModel.email });
                        })
                            .catch(function () {
                            _this.goPaperlessService.getDeferredObj().resolve({ switchSuccess: false, updatedEmail: _this.formModel.email });
                        })
                            .finally(_this.closeCallback);
                    })
                        .catch(function () {
                        _this.goPaperlessService.getDeferredObj().reject({ switchSuccess: false });
                        _this.closeCallback();
                    });
                }
            };
            ;
            GoPaperlessSaveEmailModalController.prototype.isEmail = function (email) {
                var regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
                return regex.test(email);
            };
            GoPaperlessSaveEmailModalController.$inject = [
                '$modalInstance',
                'ute.goPaperless.service',
                'suggestedEmail'];
            return GoPaperlessSaveEmailModalController;
        }());
        goPaperless.GoPaperlessSaveEmailModalController = GoPaperlessSaveEmailModalController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.saveEmailModal.controller', GoPaperlessSaveEmailModalController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var LearnMoreController = (function () {
            function LearnMoreController($modalInstance) {
                var _this = this;
                this.$modalInstance = $modalInstance;
                this.switchToPaperless = function () {
                    _this.$modalInstance.close('ok');
                };
                this.cancel = function () {
                    _this.$modalInstance.dismiss('cancel');
                };
            }
            LearnMoreController.$inject = [
                '$modalInstance'];
            return LearnMoreController;
        }());
        goPaperless.LearnMoreController = LearnMoreController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.learnMore.controller', LearnMoreController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var goPaperless;
    (function (goPaperless) {
        'use strict';
        var GoPaperlessSuccessModalController = (function () {
            function GoPaperlessSuccessModalController($modalInstance) {
                var _this = this;
                this.$modalInstance = $modalInstance;
                this.cancel = function () {
                    _this.$modalInstance.dismiss('cancel');
                };
            }
            GoPaperlessSuccessModalController.$inject = [
                '$modalInstance'];
            return GoPaperlessSuccessModalController;
        }());
        goPaperless.GoPaperlessSuccessModalController = GoPaperlessSuccessModalController;
        angular
            .module('ute.goPaperless')
            .controller('ute.goPaperless.successModal.controller', GoPaperlessSuccessModalController);
    })(goPaperless = ute.goPaperless || (ute.goPaperless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            var UteHUController = (function () {
                function UteHUController(huService) {
                    var _this = this;
                    this.huService = huService;
                    this.viewHistoryUsage = function () {
                        _this.huService.openUsageModal({
                            controller: 'ute.historical.usage.modal.controller',
                            controllerAs: '$ctrl',
                            templateUrl: 'module/historicalUsage/templates/hu.modal.html',
                            backdropClass: 'ute_hu_backdrop',
                            keyboard: false,
                            windowTemplateUrl: 'module/historicalUsage/templates/modal.window.html',
                            backdrop: 'static'
                        });
                    };
                }
                UteHUController.$inject = [
                    'ute.historical.usage.service'
                ];
                return UteHUController;
            }());
            usage.UteHUController = UteHUController;
            angular.module('ute.historical.usage').controller('ute.historical.usage.controller', UteHUController);
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            var UteHUDirective = (function () {
                function UteHUDirective() {
                    this.controller = 'ute.historical.usage.controller';
                    this.controllerAs = '$ctrl';
                    this.templateUrl = 'module/historicalUsage/templates/hu.directive.html';
                    this.bindToController = true;
                    this.scope = {
                        translateKey: '='
                    };
                    this.linkFn = function (scope, element, attrs, controller) {
                        // 
                    };
                    this.link = this.linkFn;
                }
                UteHUDirective.factory = function () {
                    var directive = function () { return new UteHUDirective(); };
                    return directive;
                };
                ;
                return UteHUDirective;
            }());
            usage.UteHUDirective = UteHUDirective;
            angular.module('ute.historical.usage').directive('uteHistoricalUsage', UteHUDirective.factory());
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            var UteHUModalController = (function () {
                function UteHUModalController($modalInstance, huService, $translate) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.huService = huService;
                    this.$translate = $translate;
                    this.totalUsage = [];
                    this.usageHeader = [];
                    this.usageHeaderValue = [];
                    this.fdmLine = [];
                    this.fdmLines = [];
                    this.totalBucket = [];
                    this.overage = [];
                    this.usageTable = [];
                    this.STATE = usage.STATE;
                    this.primaryLinePlanName = '';
                    this.getCurrentStateTemplate = function () {
                        return 'module/historicalUsage/templates/' + usage.STATE[_this.state] + '.html';
                    };
                    this.close = function (data) {
                        _this.$modalInstance.close(data);
                    };
                    this.getCurrentBan = function () {
                        return _this.huService.currentBan;
                    };
                    this.init = function () {
                        _this.state = usage.STATE.processing;
                        _this.huService.getHistoricalUsageData().then(function (billData) {
                            var lines = _this.huService.getLines();
                            moment.locale(_this.$translate.use() === 'en' ? 'en' : 'fr-ca');
                            _this.usageTable.push({ classList: 'thead fbold', col: _this.createTableHeader(billData) });
                            _this.usageTable.push({ classList: 'hu-total-data', col: _this.createTotalBucketRowData(billData) });
                            _this.usageTable.push({ classList: 'hu-total-data', col: _this.createTotalUsageData(billData) });
                            _this.usageTable.push({ classList: 'hu-total-data hu-overage', col: _this.createOverageData(billData) });
                            _this.usageTable.push({ classList: 'hu-usage-by-line', col: _this.createLineHeader() });
                            var primaryLine = _.find(lines, function (i) { return i.phone_number.split('-').join('') === _this.huService.primaryLine; });
                            _this.primaryLinePlanName = _this.huService.primaryPlanTitle;
                            _.remove(lines, function (i) { return i.phone_number.split('-').join('') === _this.huService.primaryLine; });
                            lines.unshift(primaryLine);
                            lines.forEach(function (line) {
                                _this.usageTable.push({ classList: 'hu-fdmline-data', col: _this.createLineRowData(line) });
                            });
                            _this.state = usage.STATE.data;
                            moment.locale('en');
                        }).catch(function (e) {
                            _this.state = usage.STATE.error;
                        });
                    };
                    this.createTotalBucketRowData = function (bills) {
                        var ret = [];
                        ret.push({ templateName: 'hu.usageOverview.cell', translateKey: 'total_data' });
                        ret.push({ templateName: 'hu.usage.cell', usage: { value: ' ' } });
                        bills.forEach(function (bill) {
                            var obj = { usage: {} };
                            if (bill.topup && bill.topup > 0) {
                                obj.templateName = 'hu.topup';
                                obj.usage.topup = _this.huService.formatBytes(bill.topup.toString(), false, true);
                            }
                            else {
                                obj.templateName = 'hu.usage.cell';
                            }
                            obj.usage.value = _this.huService.formatBytes(bill.totalBucket.toString(), false, true);
                            ret.push(obj);
                        });
                        for (var i = ret.length; i < 5; i++) {
                            ret[i] = {};
                        }
                        return ret;
                    };
                    this.createTotalUsageData = function (bills) {
                        var ret = [], usageObj = [], sum = 0, count = 0;
                        ret.push({ templateName: 'hu.usageOverview.cell', translateKey: 'totalUsage' });
                        bills.forEach(function (bill) {
                            var obj = {};
                            obj = _this.setCellObject(_this.huService.formatBytes(_.get(bill, 'totalUsage', undefined), false, true), 'hu.usage.cell', '');
                            sum += Number(_.get(bill, 'totalUsage', '0'));
                            count = _.get(bill, 'totalUsage', undefined) !== undefined ? count + 1 : count;
                            usageObj.push(obj);
                        });
                        ret.push(_this.setCellObject(sum !== 0 ? _this.huService.formatBytes((sum / count).toString(), false, true) : ' ', 'hu.usage.cell', ''));
                        ret = ret.concat(usageObj);
                        for (var i = ret.length; i < 5; i++) {
                            ret[i] = {};
                        }
                        return ret;
                    };
                    this.createOverageData = function (bills) {
                        var ret = [], usageObj = [], sum = 0, count = 0;
                        ret.push({ templateName: 'hu.usageOverview.cell', translateKey: 'overage' });
                        bills.forEach(function (bill) {
                            var obj = {};
                            //let overage = _.get(bill, 'overage', '-');
                            var overage = _this.huService.formatBytes(_.get(bill, 'overage', undefined), false, true);
                            obj = _this.setCellObject(overage, 'hu.usage.cell', overage !== '-' ? 'hu-td-overage' : '');
                            sum += Number(_.get(bill, 'overage', '0'));
                            count = overage !== '-' ? count + 1 : count;
                            usageObj.push(obj);
                        });
                        ret.push(_this.setCellObject(sum !== 0 ? _this.huService.formatBytes((sum / count).toString(), false, true) : ' ', 'hu.usage.cell', sum !== 0 ? 'hu-td-overage' : ''));
                        ret = ret.concat(usageObj);
                        for (var i = ret.length; i < 5; i++) {
                            ret[i] = {};
                        }
                        return ret;
                    };
                    this.createLineHeader = function () {
                        var ret = [];
                        for (var i = 0; i < 5; i++) {
                            ret.push({
                                templateName: i === 0 ? 'hu.usage.header' : 'hu.usage.cell',
                                classList: 'f16',
                                usage: {
                                    header: _this.$translate.instant('ute.historical.usage.usage_by_line')
                                }
                            });
                        }
                        return ret;
                    };
                    this.createLineRowData = function (line) {
                        var bills = [], ret = [{ templateName: 'hu.fdmline', ctn: line.phone_number, planName: line.plan_name }];
                        line.bills.forEach(function (bill, index) {
                            bills.push({ templateName: 'hu.usage.cell', usage: { value: bill.usage } });
                        });
                        var usages = line.bills.filter(function (i) { return i.usage !== '-'; }).map(function (v) { return _this.huService.getUsageFromText(v.usage.replace(',', '.')); });
                        var avg = usages && usages.length > 0 ? usages.reduce(function (a, b) { return (Number(a) + Number(b)).toFixed(2); }) / usages.length : '-';
                        ret.push({ templateName: 'hu.usage.cell', usage: { value: usages && usages.length ? _this.huService.formatBytes(avg.toString(), false, true) : '-' } });
                        ret = ret.concat(bills);
                        for (var i = ret.length; i < 5; i++) {
                            ret[i] = {};
                        }
                        return ret;
                    };
                    this.getOrdinalDate = function (date) {
                        var formatDate = moment(date).format('Do MMM');
                        var ordinal = formatDate.match(/st|nd|rd|th|er/i);
                        if (ordinal) {
                            return formatDate.replace(ordinal[0], '<sup>' + ordinal[0] + '</sup>');
                        }
                        return formatDate;
                    };
                    this.getBillCycleDates = function (bills, index) {
                        var currentDate = bills[index].issue_date;
                        var previousDate = _this.getPreviousBillStartDate(bills, index);
                        return _this.formatDateRange(previousDate, currentDate);
                    };
                    this.getPreviousBillStartDate = function (bills, index) {
                        var date = _this.huService.getDate(_.get(bills[index + 1], 'issue_date', _.get(_this.huService.getOldBill(), 'issue_date', _.get(_this.huService.getActivatedUserSummary(), 'activationDate', null))));
                        var inc = bills[index].issue_date.toDateString() === date.toDateString() ? 0 : 1;
                        var _d = new Date(date.valueOf());
                        _d.setDate(_d.getDate() + inc);
                        return _d;
                    };
                    this.formatDateRange = function (start, end) {
                        return _this.getOrdinalDate(start) + '-' + _this.getOrdinalDate(end);
                    };
                    this.createTableHeader = function (billData) {
                        var ret = [];
                        ret.push({ templateName: 'hu.usage.header', classList: 'f16', usage: { header: _this.$translate.instant('ute.historical.usage.usage_header') } }, {
                            templateName: 'hu.usage.header',
                            classList: 'hu-avg-cell',
                            usage: {
                                header: '<span><strong>' + _this.$translate.instant('ute.historical.usage.average') + '</strong></span><br><span>' +
                                    _this.getOrdinalDate(_this.getPreviousBillStartDate(billData, billData.length - 1)) +
                                    '-' +
                                    _this.getOrdinalDate((billData[0].issue_date)) +
                                    '</span>'
                            }
                        });
                        billData.forEach(function (bill, index) {
                            ret.push({ templateName: 'hu.usage.header', classList: 'f14', usage: { header: _this.getBillCycleDates(billData, index) } });
                        });
                        for (var i = ret.length; i < 5; i++) {
                            ret[i] = {};
                        }
                        return ret;
                    };
                    this.setCellObject = function (value, templateName, classList) {
                        return {
                            usage: { value: value },
                            templateName: templateName,
                            classList: classList
                        };
                    };
                    this.init();
                }
                UteHUModalController.$inject = [
                    '$modalInstance',
                    'ute.historical.usage.service',
                    '$translate'
                ];
                return UteHUModalController;
            }());
            usage.UteHUModalController = UteHUModalController;
            angular.module('ute.historical.usage').controller('ute.historical.usage.modal.controller', UteHUModalController);
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage_1) {
            'use strict';
            var UteHUService = (function () {
                function UteHUService($modal, briteBillService, $q, $http, userService, ao, dataManagerService, $translate, cacheableData, $filter, securityService) {
                    var _this = this;
                    this.$modal = $modal;
                    this.briteBillService = briteBillService;
                    this.$q = $q;
                    this.$http = $http;
                    this.userService = userService;
                    this.ao = ao;
                    this.dataManagerService = dataManagerService;
                    this.$translate = $translate;
                    this.cacheableData = cacheableData;
                    this.$filter = $filter;
                    this.securityService = securityService;
                    this.currentBan = null;
                    this.currentFdmLineList = [];
                    this.primaryLine = null;
                    this.primaryPlanTitle = '';
                    this.lines = [];
                    this.billData = [];
                    this.oldBill = null;
                    this.activatedUserSummary = null;
                    this.openUsageModal = function (config) {
                        return _this.$modal.open(config);
                    };
                    this.log = function (o) {
                        console.log('UTE HISTORICAL SERVICE LOGGER', o);
                    };
                    this.convertToRawData = function (usage, unit) {
                        if (unit.match(/mb|mo/i) !== null) {
                            return { usage: usage, unit: unit };
                        }
                        return { usage: (Number(usage) * 1024).toString(), unit: 'GB' };
                    };
                    this.incrementUsage = function (obj, call, key) {
                        var usage = _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure) || 0;
                        var val = _.get(obj, key, 0);
                        val += usage;
                        obj[key] = val;
                    };
                    this.getUsageFromText = function (usage) {
                        var u = usage.match(/[+-]?([0-9]*[.])?[0-9]+/)[0];
                        var unit = usage.match(/[a-zA-Z]+/g);
                        return unit && unit.length > 0 ? _this.getRawUsage(u, unit[0]) : Number(u);
                    };
                    this.getRawUsage = function (usage, unit) {
                        var u = usage.match(/[+-]?([0-9]*[.])?[0-9]+/)[0];
                        if (!unit) {
                            return Number(u);
                        }
                        else if (unit.match(/kb|ko/i)) {
                            return Number(u) / 1024;
                        }
                        else if (unit.match(/mb|mo/i)) {
                            return Number(u);
                        }
                        return Number(u) * 1024;
                    };
                    this.getLines = function () {
                        return _this.lines;
                    };
                    this.getOldBill = function () {
                        return _this.oldBill;
                    };
                    this.getActivatedUserSummary = function () {
                        return _this.activatedUserSummary;
                    };
                    this.getHistoricalUsageData = function () {
                        _this.billData = [];
                        _this.currentFdmLineList = [];
                        _this.lines = [];
                        _this.oldBill = null;
                        return _this.ao().getSelectedAccountDetails(null).then(function (account) {
                            _this.currentBan = account.accountNumber;
                            return _this.briteBillService.getBills(account.accountNumber.toString()).then(function (bills) {
                                if (!bills || bills.length === 0) {
                                    throw new Error('No Bills Found');
                                }
                                _this.activatedUserSummary = _this.briteBillService.getCurrentActivatedUserSummary();
                                return _this.processBillList(bills, 4);
                            });
                        });
                    };
                    this.convertToRowData = function (billData) {
                        billData.forEach(function (bill) {
                            bill.lines.forEach(function (line) {
                                var lineIndex = _.findIndex(_this.lines, function (i) { return i.phone_number === line.phoneNumber; });
                                if (lineIndex === -1) {
                                    _this.lines.push({ phone_number: line.phoneNumber });
                                    lineIndex = _.findIndex(_this.lines, function (i) { return i.phone_number === line.phoneNumber; });
                                }
                                _this.lines[lineIndex].plan_name = _this.getPlanDetails(_this.lines[lineIndex].phone_number.split('-').join(''));
                                _this.lines[lineIndex].bills = _.get(_this.lines[lineIndex], 'bills', []);
                                var billIndex = _.findIndex(_this.lines[lineIndex].bills, function (i) { return i.bill_date === bill.issue_date; });
                                if (billIndex === -1) {
                                    _this.lines[lineIndex].bills.push({ bill_date: bill.issue_date });
                                    billIndex = _.findIndex(_this.lines[lineIndex].bills, function (i) { return i.bill_date === bill.issue_date; });
                                }
                                _this.lines[lineIndex].bills[billIndex].usage = _this.formatBytes(line.usage, false, true);
                            });
                        });
                        return _this.lines;
                    };
                    // endregion
                    this.init = function () { };
                    this.formatBytes = function (x, seperateUnit, localeFormat) {
                        if (x === undefined || x === null) {
                            return '-';
                        }
                        var units = ['MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                        var l = 0, n = parseFloat(x.toString()) || 0.00;
                        while (n >= 1024) {
                            n = n / 1024;
                            l++;
                        }
                        if (seperateUnit === true) {
                            return (_this.formatUsage(n, localeFormat) + '| ' + _this.$translate.instant('ute.historical.usage.' + units[l]));
                        }
                        return (_this.formatUsage(n, localeFormat) + ' ' + _this.$translate.instant('ute.historical.usage.' + units[l]));
                    };
                    this.formatUsage = function (usage, localeFormat) {
                        var u = usage.toFixed(2).split('.');
                        var seperator = '.';
                        if (localeFormat) {
                            seperator = _this.$translate.use() === 'fr' ? ',' : '.';
                        }
                        return u[1] === '00' ? u[0] : u.join(seperator);
                    };
                    this.getParsableDate = function (date) {
                    };
                    this.getDate = function (date) {
                        if (date instanceof Date) {
                            return date;
                        }
                        var parseDate = date.split('-').join('/');
                        var index = parseDate.indexOf(':');
                        if (index > 3) {
                            parseDate = _this.replateAt(parseDate, index - 3, ' ');
                        }
                        return new Date(parseDate);
                    };
                    this.replateAt = function (str, index, replacement) {
                        return str.substr(0, index) + replacement + str.substr(index + replacement.length);
                    };
                    this.getPlanDetails = function (ctn) {
                        var ret = '';
                        var line = _.find(_this.currentFdmLineList, function (i) { return i.subscriptionNumber === ctn; });
                        if (!line || (line && line.status === 'Cancelled')) {
                            ret = '<span class="hu-left-plan-text">' + _this.$translate.instant('ute.historical.usage.leftplan') + '</span>';
                        }
                        else {
                            if (_this.currentNac) {
                                var c = _.find(_this.currentNac, function (i) { return i.ctn === ctn; });
                                if (c) {
                                    ret = _this.$filter('currency')(c.planCost, undefined, 0) + ' ' + c.socNumber + ' ' + c.planTitle[_this.$translate.use().toLowerCase()];
                                }
                            }
                        }
                        return ret;
                    };
                    this.findBillOrAppend = function (bill) {
                        var date = _this.getDate(bill.issue_date);
                        var billIndex = _.findIndex(_this.billData, function (i) { return i.issue_date.toString() === date.toString(); });
                        if (billIndex === -1) {
                            _this.billData.push({
                                issue_date: date,
                                lines: []
                            });
                            billIndex = _.findIndex(_this.billData, function (i) { return i.issue_date === date; });
                        }
                        return billIndex;
                    };
                    this.findLineOrAppend = function (billIndex, phone_number) {
                        var lineIndex = _.findIndex(_this.billData[billIndex].lines, function (i) { return i.phoneNumber === phone_number; });
                        if (lineIndex === -1) {
                            _this.billData[billIndex].lines.push({ phoneNumber: phone_number });
                            lineIndex = _.findIndex(_this.billData[billIndex].lines, function (i) { return i.phoneNumber === phone_number; });
                        }
                        return lineIndex;
                    };
                    this.processBillList = function (billsList, numberOfBillingCycles) {
                        return _this.fetchWirelessUSageDetails(billsList, numberOfBillingCycles).then(function (o) {
                            _this.convertToRowData(_this.billData);
                            return o;
                        });
                    };
                    this.fetchWirelessUSageDetails = function (billsList, numberOfBillingCycles) {
                        return _this.briteBillService.encryptedBriteBillToken({
                            'currentAccNumber': _this.currentBan.toString(),
                            'applicationId': 'Rogers.com'
                        }).then(function (res) {
                            var documents = _.take(billsList, numberOfBillingCycles).map(function (n) {
                                var config = {
                                    headers: {
                                        'EncryptedToken': res.data.encryptedString
                                    }
                                };
                                return _this.$http.get('/rogers_rest/' + n.link, config);
                            });
                            return _this.$q.all(documents).then(_this.extractPlanDataAndUsages);
                        });
                    };
                    this.extractPlanDataAndUsages = function (results) {
                        return new _this.$q(function (res, rej) {
                            try {
                                _this.processBillUsageData(results).then(function (v) {
                                    res(_this.billData);
                                });
                            }
                            catch (error) {
                                rej(error);
                            }
                        });
                    };
                    this.processBillUsageData = function (results) {
                        return _this.dataManagerService.getUsageDetailsWorker({
                            accountNumber: _this.currentBan.toString(),
                            serviceType: 'DM'
                        }).getDataManagerServerGetUsageDetails().then(function (response) {
                            _this.currentFdmLineList = response.body.subscriptionList;
                            _this.primaryLine = _.find(response.body.subscriptionList, function (i) { return i.isPrimaryCtn === true; }).subscriptionNumber;
                            var nacCurrentUrl = _this.securityService.getBackendUrl('v1/see/priceplans/list/current');
                            _this.primaryPlanTitle = _this.$translate.use() === 'en' ? response.body.planName : response.body.planNameFr;
                            return _this.$http.post(nacCurrentUrl, {
                                ban: _this.currentBan,
                                ctn: _this.currentFdmLineList.map(function (i) { return i.subscriptionNumber; }).join(','),
                                language: _this.$translate.use(),
                                consolidatedInd: 'NO',
                                activityTypeKey: 'NAC',
                                applicationId: 'Rogers.com',
                                refresh: false,
                                regionCode: 'ON',
                                guid: 'Rogers_Wireless'
                            }).then(function (current) {
                                var q = _this.$q.defer();
                                _this.currentNac = current.data;
                                _this.processBillsData(results);
                                q.resolve(_this.billData);
                                return q.promise;
                            }).catch(function (e) {
                                var q = _this.$q.defer();
                                _this.currentNac = null;
                                _this.processBillsData(results);
                                q.resolve(_this.billData);
                                return q.promise;
                            });
                        });
                    };
                    this.processBillsData = function (results) {
                        (results).forEach(function (res, index) {
                            if (index < 3) {
                                var bill = res.data;
                                var shared_bundle = _.get(bill, 'shared_bundles.shared_bundle', null);
                                if (!shared_bundle) {
                                    var telecomAssets = _.get(bill, 'telecom_service_asset', null);
                                    _this.processTelecomAssets(telecomAssets, bill);
                                }
                                else if (shared_bundle) {
                                    _this.processSharedBundles(shared_bundle, bill);
                                }
                            }
                            else {
                                _this.oldBill = res.data;
                            }
                        });
                    };
                    this.processTelecomAssets = function (telecomAssets, bill) {
                        if (!telecomAssets || (telecomAssets && telecomAssets.length === 0)) {
                            throw new Error('No telecom assets found');
                        }
                        telecomAssets.forEach(function (asset) {
                            if (asset.calls) {
                                asset.calls.forEach(function (call) {
                                    var groupBy = _.get(call, '@GroupBy', null);
                                    var collection = _.get(call, '@Collection', null);
                                    if (groupBy === 'Data' || (groupBy === 'UsageSummary' && collection === 'Data')) {
                                        var billIndex_1 = _this.findBillOrAppend(bill);
                                        var lineIndex = _this.findLineOrAppend(billIndex_1, asset.phone_number);
                                        if (groupBy === 'Data') {
                                            _this.billData[billIndex_1].totalUsage = Number(call.call_summary.total_usage_amount) / 1024;
                                        }
                                        else if (groupBy === 'UsageSummary' && collection === 'Data') {
                                            var desc = call.call_summary.description;
                                            if (desc.match(/comprises|included/i) !== null) {
                                                _this.billData[billIndex_1].lines[lineIndex].usage = _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure);
                                                _this.billData[billIndex_1].lines[lineIndex].unit = 'MB';
                                                desc.split(' ').forEach(function (v) {
                                                    var quantity = v.match(/[+-]?([0-9]*[.])?[0-9]+(gb|go|mb|mo)/i);
                                                    //let unit = v.match(/gb|go|mb|mo/i);
                                                    if (quantity !== null) {
                                                        _this.billData[billIndex_1].totalBucket = _this.getUsageFromText(v);
                                                    }
                                                });
                                            }
                                            else if (desc.match(/Utilisation de données add.|(Additional Data Usage)/i)) {
                                                _this.billData[billIndex_1].lines[lineIndex].usage = _this.billData[billIndex_1].lines[lineIndex].usage ? _this.billData[billIndex_1].lines[lineIndex].usage : 0;
                                                _this.billData[billIndex_1].lines[lineIndex].usage += _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure) || 0;
                                                _this.billData[billIndex_1].overage = _this.billData[billIndex_1].overage ? _this.billData[billIndex_1].overage : 0;
                                                _this.billData[billIndex_1].overage += _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure);
                                            }
                                            else {
                                                _this.billData[billIndex_1].lines[lineIndex].usage = _this.billData[billIndex_1].lines[lineIndex].usage ? _this.billData[billIndex_1].lines[lineIndex].usage : 0;
                                                _this.billData[billIndex_1].lines[lineIndex].usage += _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure);
                                                _this.billData[billIndex_1].topup = _this.billData[billIndex_1].topup ? _this.billData[billIndex_1].topup : 0;
                                                _this.billData[billIndex_1].topup += _this.getRawUsage(call.call_summary.total_usage_amount, call.call_summary.unit_of_measure);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    };
                    this.extractUsageByLine = function (used_amount_details, billIndex) {
                        used_amount_details.forEach(function (asset) {
                            var lineIndex = _this.findLineOrAppend(billIndex, asset.subscriber_phone_number), um = _.get(asset, 'unit_of_measure', null), usage = _.get(asset, 'used_amount', null);
                            if (usage) {
                                _this.billData[billIndex].lines[lineIndex].usage = _this.billData[billIndex].lines[lineIndex].usage || 0;
                                _this.billData[billIndex].lines[lineIndex].usage += _this.getRawUsage(usage, um || 'mb');
                            }
                            else if (!usage || um === 'N/A') {
                                _this.billData[billIndex].lines[lineIndex].usage = (_this.billData[billIndex].lines[lineIndex].usage >= 0) ? _this.billData[billIndex].lines[lineIndex].usage : undefined;
                            }
                        });
                    };
                    this.processSharedBundles = function (shared_bundle, bill) {
                        shared_bundle.forEach(function (bundle) {
                            if (bundle.category.match(/Data|Données/i) !== null) {
                                var billIndex = _this.findBillOrAppend(bill);
                                _this.extractUsageByLine(bundle.used_amount_details, billIndex);
                                if (bundle.description.match(/(Internet sans fil partagé)|(Shared Wireless Internet)/i)) {
                                    _this.billData[billIndex].totalBucket = _this.getUsageFromText(bundle.start_amount);
                                }
                                else if (bundle.description.match(/(Shared Additional Data Usage)|(Utilis. données additionnelles partagées)/i)) {
                                    var usages_1 = bundle.used_amount_details.filter(function (i) { return i.used_amount !== undefined; }).map(function (i) { return _this.getRawUsage(i.used_amount, i.unit_of_measure || 'mb'); });
                                    if (usages_1.length > 0) {
                                        _this.billData[billIndex].overage = usages_1.reduce(function (a, b) { return (Number(a) + Number(b)).toFixed(2); });
                                    }
                                }
                                else {
                                    _this.billData[billIndex].topup = _this.billData[billIndex].topup || 0;
                                    var u = bundle.start_amount.match(/[a-zA-Z]+/g);
                                    _this.billData[billIndex].topup += _this.getRawUsage(bundle.start_amount, u ? u[0] : 'mb');
                                }
                                var usages = _this.billData[billIndex].lines.filter(function (i) { return i.usage !== undefined; }).map(function (i) { return i.usage; });
                                if (usages.length > 0) {
                                    _this.billData[billIndex].totalUsage = usages.reduce(function (a, b) { return (Number(a) + Number(b)).toFixed(2); });
                                }
                            }
                        });
                    };
                    this.init();
                }
                return UteHUService;
            }());
            usage_1.UteHUService = UteHUService;
            var UteHUProvider = (function () {
                function UteHUProvider() {
                    this.$get = function ($modal, $injector, $q, $http, $translate, $filter) {
                        return new UteHUService($modal, $injector.get('ute.brite.bill.service'), $q, $http, $injector.get('ute.common.user.service'), $injector.get('ute.rogers.account.overview.factory'), $injector.get('ute.data.manager.service'), $translate, $injector.get('ute.common.core.caching.CacheableDataFactory'), $filter, $injector.get('ute.common.security.service'));
                    };
                    this.$get.$inject = [
                        '$modal',
                        '$injector',
                        '$q',
                        '$http',
                        '$translate',
                        '$filter'
                    ];
                }
                return UteHUProvider;
            }());
            usage_1.UteHUProvider = UteHUProvider;
            angular.module('ute.historical.usage').provider('ute.historical.usage.service', UteHUProvider);
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var historical;
    (function (historical) {
        var usage;
        (function (usage) {
            'use strict';
            var UteHUUsageCellDirective = (function () {
                // templateUrl: any = (element: ng.IAugmentedJQuery, at: any) => {
                //   return 'module/historicalUsage/templates/' + this.scope.cellModel.templateName + '.html';
                // };
                function UteHUUsageCellDirective() {
                    this.controller = 'ute.historical.usage.cell.controller';
                    this.controllerAs = '$ctrl';
                    this.bindToController = true;
                    this.template = '<ng-include ng-if="$ctrl.cellModel.templateName" src="$ctrl.getTemplateUrl()"/>';
                    this.scope = {
                        cellModel: '='
                    };
                    this.linkFn = function (scope, element, attrs, controller) {
                        //
                    };
                    this.link = this.linkFn;
                }
                UteHUUsageCellDirective.factory = function () {
                    var directive = function () { return new UteHUUsageCellDirective(); };
                    return directive;
                };
                ;
                return UteHUUsageCellDirective;
            }());
            usage.UteHUUsageCellDirective = UteHUUsageCellDirective;
            var UteHUUsageCellController = (function () {
                function UteHUUsageCellController() {
                    var _this = this;
                    this.getTemplateUrl = function () {
                        return 'module/historicalUsage/templates/' + _this.cellModel.templateName + '.html';
                    };
                    //
                }
                return UteHUUsageCellController;
            }());
            usage.UteHUUsageCellController = UteHUUsageCellController;
            angular.module('ute.historical.usage').controller('ute.historical.usage.cell.controller', UteHUUsageCellController);
            angular.module('ute.historical.usage').directive('uteHistoricalUsageCell', UteHUUsageCellDirective.factory());
        })(usage = historical.usage || (historical.usage = {}));
    })(historical = ute.historical || (ute.historical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var messages;
        (function (messages) {
            var bus;
            (function (bus) {
                'use strict';
                var MessagesService = (function () {
                    /* @ngInject */
                    function MessagesService(logger, $rootScope) {
                        var _this = this;
                        this.logger = logger;
                        this.$rootScope = $rootScope;
                        /**
                         * Simple wrap
                         * @param event
                         * @param data
                         * @return IAngularEvent
                         */
                        this.publish = function (event, data) {
                            return _this.$rootScope.$broadcast(event, data);
                        };
                        this.register = function (name, listener) {
                            return _this.$rootScope.$on(name, listener);
                        };
                        this.subscribe = this.register;
                    }
                    MessagesService.$inject = ['ute.blocks.loggerService', '$rootScope'];
                    return MessagesService;
                }());
                angular.module('ute.blocks.messages.bus').service('ute.blocks.messages.bus.service', MessagesService);
            })(bus = messages.bus || (messages.bus = {}));
        })(messages = blocks.messages || (blocks.messages = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
            var NovaContentController = (function () {
                /* @ngInject */
                function NovaContentController(novaContentService, languageService) {
                    var _this = this;
                    this.novaContentService = novaContentService;
                    this.languageService = languageService;
                    this.getNovaContent = function () {
                        _this.novaContentService.getTorNovaContent().then(function (result) {
                            console.log('nova content success');
                        })
                            .catch(function (error) {
                            console.log('error');
                        });
                    };
                    this.model = this.novaContentService.getModel();
                    this.getNovaContent();
                    this.languageService.registerOnDataChangeHandler(function (lang) {
                        if (lang === 'fr') {
                            _this.novaContentService.setFrenchNovaContent(_this.model.novaResponse);
                        }
                        else {
                            _this.novaContentService.setEnglishNovaContent(_this.model.novaResponse);
                        }
                        return null;
                    }, 'ute.nova.content.directive.controller');
                }
                NovaContentController.$inject = ['ute.nova.content.service',
                    'ute.blocks.language.switcher'
                ];
                return NovaContentController;
            }());
            content.NovaContentController = NovaContentController;
            angular.module('ute.nova.content').controller('ute.nova.content.directive.controller', NovaContentController);
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
            var NovaContent = (function () {
                /* @ngInject */
                function NovaContent(novaContentService) {
                    var _this = this;
                    this.novaContentService = novaContentService;
                    this.restrict = 'E';
                    this.scope = {
                        screenName: '='
                    };
                    this.templateUrl = this.novaContentService.getConfig().basic.templateUrl;
                    this.controller = this.novaContentService.getConfig().basic.controllerName;
                    this.controllerAs = 'nc';
                    /**
                     * @param scope
                     */
                    this.linkFn = function (scope) {
                        // Set screenName to the service model
                        _this.novaContentService.setScreenName(scope.screenName);
                    };
                    this.link = this.linkFn;
                }
                /**
                 * @returns {function(ute.nova.content.INovaContentService): ute.nova.content.NovaContent}
                 */
                NovaContent.factory = function () {
                    var directive = function (novaContentService) { return new NovaContent(novaContentService); };
                    directive.$inject = ['ute.nova.content.service'];
                    return directive;
                };
                return NovaContent;
            }());
            angular.module('ute.nova.content').directive('uteNovaContent', NovaContent.factory());
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var nova;
    (function (nova) {
        var content;
        (function (content) {
            'use strict';
            var NovaContentProvider = (function () {
                /* @ngInject */
                function NovaContentProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            applicationId: 'ute-application-id',
                            medium: 'WEB',
                            templateUrl: 'module/novaContentDirective/novaContent.directive.view.html',
                            controllerName: 'ute.nova.content.directive.controller',
                            torNovaContent: '/web/totes/cms/ute/rogers/consumer/oneview/data/novaContent/novaContent.json'
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $http, sessionStorage, languageService) {
                        _this.$http = $http;
                        _this.$injector = $injector;
                        _this.sessionStorage = sessionStorage;
                        _this.securityService = $injector.get('ute.common.security.service');
                        _this.languageService = languageService;
                        return {
                            getConfig: _this.getConfig,
                            getModel: _this.getModel,
                            setScreenName: _this.setScreenName,
                            getScreenName: _this.getScreenName,
                            getTorNovaContent: _this.getTorNovaContent,
                            setEnglishNovaContent: _this.setEnglishNovaContent,
                            setFrenchNovaContent: _this.setFrenchNovaContent
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        if (_this.config.basic.medium.length === 0) {
                            console.error('medium:', 'Config Provider should override medium with vaid Medium');
                            return false;
                        }
                        return true;
                    };
                    this.setEnglishNovaContent = function (response) {
                        if (_this.getScreenName() === 'tor') {
                            _this.model.novaContent = response.tor.en;
                        }
                        else if (_this.getScreenName() === 'ptp') {
                            _this.model.novaContent = response.ptp.en;
                        }
                    };
                    this.setFrenchNovaContent = function (response) {
                        if (_this.getScreenName() === 'tor') {
                            _this.model.novaContent = response.tor.fr;
                        }
                        else if (_this.getScreenName() === 'ptp') {
                            _this.model.novaContent = response.ptp.fr;
                        }
                    };
                    /**
                     * @returns {ng.IPromise<any>}
                     */
                    this.getTorNovaContent = function () {
                        var apiUrl = _this.config.basic.torNovaContent;
                        return _this.$http.get(apiUrl)
                            .then(_this.processSuccess)
                            .catch(_this.processError)
                            .finally(_this.finaliseCall);
                    };
                    /**
                     * @param response
                     * @returns {any}
                     */
                    this.processSuccess = function (response) {
                        console.log('Got success response');
                        /*this.model.novaContent.primaryHeading = response.data.tor.en.primaryHeading;
                        this.model.novaContent.secondaryHeading = response.data.tor.en.secondaryHeading;
                        this.model.novaContent.contentList = response.data.tor.en.linkItems;*/
                        var language = _this.languageService.getCurrentLanguage();
                        if (language === 'en') {
                            _this.setEnglishNovaContent(response.data);
                        }
                        else if (language === 'fr') {
                            _this.setFrenchNovaContent(response.data);
                        }
                        _this.model.novaResponse = response.data;
                        return response;
                    };
                    /**
                     * @param error
                     * @returns {any}
                     */
                    this.processError = function (error) {
                        console.log('Got error response');
                        return error;
                    };
                    this.finaliseCall = function () {
                        console.log('Finally call has been executed');
                    };
                    /**
                     * Get Screen name from the model
                     * @returns {string}
                     */
                    this.getScreenName = function () {
                        return _this.model.screenName;
                    };
                    /**
                     * get the config setting
                     * @returns {any}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /**
                     * Return immutable INovaContentModel object
                     * @returns {INovaContentModel}
                     */
                    this.getModel = function () {
                        return _this.model;
                    };
                    /**
                     * @param screenName - set screen name
                     */
                    this.setScreenName = function (screenName) {
                        _this.model.screenName = screenName;
                    };
                    /**
                     * Reset model to initial state
                     */
                    this.resetModel = function () {
                        _this.model = {
                            screenName: null,
                            novaContent: null
                        };
                        /*novaContent: <INovaContent> {
                            primaryHeading : '',
                            secondaryHeading: '',
                            contentList: []
                          }*/
                    };
                    this.$get.$inject = ['$injector', '$http', 'sessionStorage',
                        'ute.blocks.language.switcher'];
                    this.resetModel();
                }
                NovaContentProvider.$inject = [];
                NovaContentProvider.serviceName = 'ute.nova.content.service';
                return NovaContentProvider;
            }());
            angular.module('ute.nova.content').provider(NovaContentProvider.serviceName, NovaContentProvider);
        })(content = nova.content || (nova.content = {}));
    })(nova = ute.nova || (ute.nova = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneviewCommonFooterController = (function () {
                    function OneviewCommonFooterController(oneviewCommonFooterService, userService, messagesService, permissionsService, languageService, accountOverviewFactory, sessionStorage, localStorage, $browser, $state) {
                        var _this = this;
                        this.oneviewCommonFooterService = oneviewCommonFooterService;
                        this.userService = userService;
                        this.messagesService = messagesService;
                        this.permissionsService = permissionsService;
                        this.languageService = languageService;
                        this.sessionStorage = sessionStorage;
                        this.localStorage = localStorage;
                        this.$browser = $browser;
                        this.$state = $state;
                        this.placeQuickLinks = [];
                        this.tempQuickLinks = [];
                        this.footerPermission = false;
                        this.currentDropElement = null;
                        this.accountOverviewDataHandler = function (accountOverview) {
                            if (accountOverview) {
                                _this.oneviewCommonFooterService.agentInfo(String(accountOverview.getSelectedAccount().accountNumber))
                                    .then(function (result) {
                                    if (result !== false) {
                                        _this.checkPermission();
                                    }
                                    else {
                                    }
                                })
                                    .catch(function (result) {
                                    //console.log('agentInfo call fail dealer' );
                                });
                            }
                            else {
                            }
                            return null;
                        };
                        this.getAccountOverview = function () {
                            return _this.accountOverviewService.getAccountOverview()
                                .then(_this.accountOverviewDataHandler)
                                .catch(function (reason) {
                                //console.log('OneviewFooterDirectiveController->getAccountOverview->catch:', reason);
                                return null;
                            });
                        };
                        this.accountOverviewService = accountOverviewFactory();
                        this.disableFooter = true;
                        this.sessionStorage = sessionStorage;
                        this.messagesService.register('ute-oneview-footer-disable', function (data, val) { return _this.hideFooter(); });
                        this.userType = this.userService.getUserType();
                        this.oneviewCommonFooterService.setUserType(this.userType);
                        this.isDealer = this.isCare = false;
                        if (this.userType === 'dealer') {
                            this.isDealer = true;
                            this.accountOverviewService.registerOnDataChangeHandler(this.accountOverviewDataHandler, OneviewCommonFooterController.controllerName);
                            this.getAccountOverview();
                        }
                        else if (this.userType === 'care' && this.sessionStorage.getSessionStorageValue('userType')) {
                            this.isCare = true;
                            this.oneviewCommonFooterService.agentInfo('')
                                .then(function (result) {
                                if (result !== false) {
                                    _this.checkPermission();
                                }
                                else {
                                }
                            })
                                .catch(function (result) {
                                //console.log('agentInfo call failed for dealer');
                            });
                        }
                        for (var i = 0; i < 5; i++) {
                            this.placeQuickLinks.push({ 'label': '', 'name': '', 'displayOrder': '', 'link': '' });
                        }
                        this.tempQuickLinks = angular.copy(this.placeQuickLinks);
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.callFooterApi();
                            _this.switchNovaLang(lang);
                            return null;
                        }, 'ute.oneview.footer.directive.controller');
                        this.showQuickLinks = false;
                        this.editQuickLinks = false;
                    }
                    /**
                     * Checking Ram Permission --> (RepFooter, update) exists or not
                     */
                    OneviewCommonFooterController.prototype.checkPermission = function () {
                        var _this = this;
                        this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.RepFooter, ute.common.permissions.service.RamActionCodes.update)
                            .then(function (FooterPermission) {
                            return _this.setFooterPermission(FooterPermission);
                        });
                    };
                    /**
                     * Enabling/Disabling footer based on Permission
                     */
                    OneviewCommonFooterController.prototype.setFooterPermission = function (permission) {
                        this.footerPermission = permission;
                        if (this.footerPermission) {
                            this.disableFooter = false;
                            this.callFooterApi();
                        }
                        else {
                            this.disableFooter = true;
                        }
                    };
                    /**
                     * Display approprite nova link based on language
                     */
                    OneviewCommonFooterController.prototype.switchNovaLang = function (lang) {
                        if (lang === "en") {
                            this.novaLink = "http://nova.rogers.com";
                        }
                        else {
                            this.novaLink = "http://nova.rogers.com/infocenter/index?page=tabs&tabsource=home&locale=fr_CA&uevt=Language_head&loadTemplate=Y";
                        }
                    };
                    /**
                     * Start loading QuickLinks if the conditions are met
                     */
                    OneviewCommonFooterController.prototype.callFooterApi = function () {
                        if (this.oneviewCommonFooterService.getUserId() !== '' && !this.disableFooter) {
                            this.loadQuickLinksSection();
                        }
                    };
                    /**
                     * Loading 15 quicklinks and calling the five pinnedlinks
                     */
                    OneviewCommonFooterController.prototype.loadQuickLinksSection = function () {
                        var _this = this;
                        this.oneviewCommonFooterService.loadQuickLinks()
                            .then(function (result) {
                            if (result !== false) {
                                _this.quickLinksResult = angular.copy(result);
                                var quicklinks = [];
                                for (var i in result) {
                                    if (result.hasOwnProperty(i)) {
                                        result[i].name = i; // Adding name parameter to the list, this is useful when we drag the item as we need name while saving the links to cassandra
                                        quicklinks.push(result[i]); //Converting objects into Array, to access orderBy filter in view
                                    }
                                }
                                var notificationViewerIndex = _.findIndex(quicklinks, function (i) { return i.link.match('notificationsViewer') !== null; });
                                if (notificationViewerIndex >= 0) {
                                    quicklinks[notificationViewerIndex].link = quicklinks[notificationViewerIndex].link.split('?')[0].concat('?reqApp=icm&accountId=' + _this.userService.getPersistentService().get('accountNumber') + '&ln=' + _this.languageService.getCurrentLanguage());
                                }
                                _this.quickLinksList = _.clone(quicklinks);
                                _this.retrieveQuickLinksSection(_this.oneviewCommonFooterService.getUserId());
                            }
                            else {
                            }
                        })
                            .catch(function (result) {
                            //catch Block
                        });
                    };
                    /**
                     * Getting the 5 quicklinks to be displayed in the footer
                     */
                    OneviewCommonFooterController.prototype.retrieveQuickLinksSection = function (userId) {
                        var _this = this;
                        if (userId !== '') {
                            this.oneviewCommonFooterService.retrieveQuickLinks(userId)
                                .then(function (result) {
                                if (result !== false) {
                                    _this.retrieveQuickLinkIds = angular.copy(result);
                                    var displayQuickLinks = [];
                                    var quickLinksResult = angular.copy(_this.quickLinksResult);
                                    _.forEach(_this.retrieveQuickLinkIds, function (item, index) {
                                        //if the item is saved as null in DB, we will show empty placeholder in footer else we will show the link
                                        if (item === '' || item === ' ') {
                                            displayQuickLinks.push({ 'label': '', 'name': ' ', 'displayOrder': '', 'link': '' });
                                        }
                                        else {
                                            var temp = {};
                                            temp = angular.copy(quickLinksResult[item]);
                                            temp.name = item;
                                            displayQuickLinks.push(temp);
                                        }
                                    });
                                    _this.placeQuickLinks = angular.copy(displayQuickLinks);
                                    _this.tempQuickLinks = angular.copy(displayQuickLinks);
                                }
                                else {
                                }
                            })
                                .catch(function (result) {
                                //catch Block
                            });
                        }
                    };
                    /**
                     * Saving the 5 Quicklinks on click of save button
                     */
                    OneviewCommonFooterController.prototype.saveQuickLinksSection = function () {
                        var _this = this;
                        this.editQuickLinks = false;
                        var quickLinksSave = angular.copy(this.placeQuickLinks);
                        var saveLinks = [];
                        _.forEach(quickLinksSave, function (item, index) {
                            saveLinks.push(item.name);
                        });
                        this.oneviewCommonFooterService.setSaveLinksString(saveLinks);
                        this.oneviewCommonFooterService.updateQuickLinks()
                            .then(function (result) {
                            if (result !== false) {
                                _this.tempQuickLinks = angular.copy(_this.placeQuickLinks);
                            }
                            else {
                            }
                        })
                            .catch(function (result) {
                            // console.log('updateQuickLinks() Error');
                        });
                    };
                    OneviewCommonFooterController.prototype.toggleQuickLinksSection = function () {
                        if (this.showQuickLinks) {
                            this.hideQuickLinksSection();
                        }
                        else {
                            this.showQuickLinksSection();
                        }
                    };
                    OneviewCommonFooterController.prototype.showQuickLinksSection = function () {
                        this.showQuickLinks = true;
                    };
                    OneviewCommonFooterController.prototype.hideQuickLinksSection = function () {
                        this.placeQuickLinks = angular.copy(this.tempQuickLinks);
                        this.showQuickLinks = false;
                        this.editQuickLinks = false;
                        this.oneviewCommonFooterService.setFooterEditMode(this.editQuickLinks);
                    };
                    OneviewCommonFooterController.prototype.editQuickLinksSection = function () {
                        this.showQuickLinks = true;
                        this.editQuickLinks = true;
                        this.oneviewCommonFooterService.setFooterEditMode(this.editQuickLinks);
                    };
                    /**
                     * Saving the dragged quickLink on DROP of links in the pinned placeholders
                     */
                    OneviewCommonFooterController.prototype.onDrop = function (data, index) {
                        if (data && this.currentDropElement) {
                            this.placeQuickLinks[index] = angular.copy(data);
                        }
                    };
                    /**
                     * Removing the dragged quickLink on drop into extended footer part
                     */
                    OneviewCommonFooterController.prototype.onDropPinnedLink = function (data, index) {
                        var dragIndex = this.draggedLinkIndex; //Getting the index from onDragStart method
                        if (data) {
                            var dropQLinks = [];
                            dropQLinks = angular.copy(this.placeQuickLinks);
                            for (var p in dropQLinks[dragIndex]) {
                                if (dropQLinks[dragIndex].hasOwnProperty(p)) {
                                    dropQLinks[dragIndex][p] = '';
                                }
                            }
                            this.placeQuickLinks = angular.copy(dropQLinks);
                        }
                    };
                    OneviewCommonFooterController.prototype.onDragOver = function (data, dragElement, dropElement) {
                        this.currentDropElement = dropElement;
                    };
                    OneviewCommonFooterController.prototype.onDragOverLinks = function (data, index, dragElement, dropElement) {
                        //onDragOverLinks
                    };
                    OneviewCommonFooterController.prototype.onDragLeave = function () {
                        this.currentDropElement = null;
                    };
                    OneviewCommonFooterController.prototype.onDragStart = function (data, index) {
                        this.draggedLinkIndex = index;
                    };
                    OneviewCommonFooterController.prototype.onDragEnd = function (data, index) {
                        this.draggedLinkIndex = null;
                    };
                    /**
                     * On click of 'Go To SSP'
                     */
                    OneviewCommonFooterController.prototype.goToSsp = function () {
                        var _this = this;
                        var cookies = this.$browser.cookies();
                        var language = cookies.language;
                        var province = cookies.province;
                        var phoneNumber = this.localStorage.getLocalStorageValue('phoneNumber');
                        var accountNum = this.localStorage.getLocalStorageValue('accountNumber');
                        var toStateName = this.localStorage.getLocalStorageValue('toStateName');
                        var postData = {
                            ctn: phoneNumber,
                            accountNumber: accountNum,
                            lang: language,
                            prov: province,
                            targetFlow: 'sspdashboard'
                        };
                        if (toStateName !== 'wireless') {
                            postData.ctn = '';
                        }
                        this.oneviewCommonFooterService.backToSSP(postData)
                            .then(function (result) {
                            if (result !== false) {
                                if (result.isCableOnly) {
                                    $('#footerFormToSSP').attr('action', result.envPath + _this.oneviewCommonFooterService.getConfig().basic.signoutURL);
                                    $('#footerFormToSSP').submit();
                                }
                                else {
                                    $('#footerFormToSSP').find('#sharedKey').val(result.sharedKey);
                                    $('#footerFormToSSP').find('#signature').val(result.signature);
                                    $('#footerFormToSSP').find('#content').val(result.content);
                                    $('#footerFormToSSP').attr('action', result.envPath + _this.oneviewCommonFooterService.getConfig().basic.sspDashboardURL);
                                    $('#footerFormToSSP').submit();
                                }
                            }
                            else {
                                $('#footerFormToSSP').attr('action', result.envPath + _this.oneviewCommonFooterService.getConfig().basic.signoutURL);
                                $('#footerFormToSSP').submit();
                            }
                        })
                            .catch(function (result) {
                            $('#footerFormToSSP').attr('action', result.envPath + _this.oneviewCommonFooterService.getConfig().basic.signoutURL);
                            $('#footerFormToSSP').submit();
                        });
                    };
                    OneviewCommonFooterController.prototype.hideFooter = function () {
                        this.disableFooter = true;
                    };
                    OneviewCommonFooterController.prototype.showFooter = function () {
                        this.disableFooter = false;
                    };
                    OneviewCommonFooterController.controllerName = 'ute.oneview.footer.directive.controller';
                    OneviewCommonFooterController.$inject = [
                        'ute.oneview.footer.service',
                        'ute.common.user.service',
                        'ute.blocks.messages.bus.service',
                        'ute.common.permissions.service',
                        'ute.blocks.language.switcher',
                        'ute.rogers.account.overview.factory',
                        'sessionStorage',
                        'localStorage',
                        '$browser',
                        '$state'
                    ];
                    return OneviewCommonFooterController;
                }());
                footer.OneviewCommonFooterController = OneviewCommonFooterController;
                angular.module('ute.common.oneview.footer').controller('ute.oneview.footer.directive.controller', OneviewCommonFooterController);
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneViewFooter = (function () {
                    function OneViewFooter(oneViewFooterService) {
                        this.oneViewFooterService = oneViewFooterService;
                        this.restrict = 'E';
                        this.templateUrl = this.oneViewFooterService.getConfig().basic.mainTemplateUrl;
                        this.controller = this.oneViewFooterService.getConfig().basic.mainControllerName;
                        this.controllerAs = 'oneviewFooter';
                    }
                    OneViewFooter.factory = function () {
                        var directive = function (oneViewFooterService) { return new OneViewFooter(oneViewFooterService); };
                        directive.$inject = ['ute.oneview.footer.service'];
                        return directive;
                    };
                    return OneViewFooter;
                }());
                angular.module('ute.common.oneview.footer').directive('uteOneviewFooter', OneViewFooter.factory());
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

//no more required as the feedback functionaity has been implemented as a separate module
// module ute.common.oneview.footer {
//   'use strict';
//   import ILanguageService = ute.blocks.language.switcher.ILanguageSwitcher;
//   export class OneviewCommonFooterRepFeedbackController {
//     static $inject: Array<string> = [
//                                       '$element',
//                                       'ute.common.utils.service',
//                                       'ute.oneview.footer.service',
//                                       'ute.blocks.language.switcher'
//                                     ];
//     /* @ngInject */
//     constructor( private $element: ng.IRootElementService,
//                  private UtilService: ute.common.utils.IUtilsService,
//                  private oneviewCommonFooterService: ute.common.oneview.footer.IOneViewFooterService,
//                  private languageService: ILanguageService
//                 ) {
//       this.userType = this.oneviewCommonFooterService.getUserType();
//       this.isDealer = this.isCare = false;
//       if (this.userType === 'dealer') {
//         this.isDealer = true;
//       } else if ( this.userType === 'care') {
//           this.isCare = true;
//         }
//       if (this.isCare || this.isDealer) {
//         this.$element.find('#feedback-tab').hide();
//         this.$element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
//       }
//     }
//     private userType: string;
//     private isCare: boolean;
//     private isDealer: boolean;
//     private lang: string;
//     openSurveyLink(): void  {
//       /*
//       this.lang = this.languageService.getCurrentLanguage();
//       var browserInfo: ute.common.utils.IBrowserInfo = this.UtilService.detectBrowser();
//       var browserName = browserInfo.type;
//       var browserVer = browserInfo.version;
//       var os = this.getOs();
//       var sessionId = '';
//       var site = 'rogers.com';
//       var ban: string = this.oneviewCommonFooterService.getAccountNumber();
//       var userId = this.oneviewCommonFooterService.getUserId();
//       var userInfo = this.oneviewCommonFooterService.getUserInfo();
//       sessionId = userInfo.playSessionId.split('-');
//       var surveyUrl = 'https://www.surveymonkey.com/r/3K87P7G?userid=' + userId +
//           '&' + 'browser=' + browserName + '&' + 'browserversion=' + browserVer +
//           '&' + 'os=' + os + '&' + 'sessionid=' + sessionId[0] + '&' + 'site=' + site + '&' + 'currentban=' + ban;
//       if (this.lang === 'fr') {
//         surveyUrl = 'https://fr.surveymonkey.com/r/XQLJHDT?userid=' + userId +
//             '&' + 'browser=' + browserName + '&' + 'browserversion=' + browserVer +
//             '&' + 'os=' + os + '&' + 'sessionid=' + sessionId[0] + '&' + 'site=' + site + '&' + 'currentban=' + ban;
//       }
//           */
//       window.open("https://rogersdigital.ca1.qualtrics.com/jfe/form/SV_a8C0jKn7TIBBXbD", '_blank');
//     }
//     getOs(): any {
//       var nAgt = navigator.userAgent;
//       var os = '';
//       var clientStrings = [
//         {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
//         {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
//         {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
//         {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
//         {s: 'Windows Vista', r: /Windows NT 6.0/},
//         {s: 'Windows Server 2003', r: /Windows NT 5.2/},
//         {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
//         {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
//         {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
//         {s: 'Windows 98', r: /(Windows 98|Win98)/},
//         {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
//         {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
//         {s: 'Windows CE', r: /Windows CE/},
//         {s: 'Windows 3.11', r: /Win16/},
//         {s: 'Android', r: /Android/},
//         {s: 'Open BSD', r: /OpenBSD/},
//         {s: 'Sun OS', r: /SunOS/},
//         {s: 'Linux', r: /(Linux|X11)/},
//         {s: 'iOS', r: /(iPhone|iPad|iPod)/},
//         {s: 'Mac OS X', r: /Mac OS X/},
//         {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
//         {s: 'QNX', r: /QNX/},
//         {s: 'UNIX', r: /UNIX/},
//         {s: 'BeOS', r: /BeOS/},
//         {s: 'OS/2', r: /OS\/2/},
//         {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
//       ];
//       for (var id in clientStrings) {
//         if (clientStrings.hasOwnProperty(id)) {
//           var cs = clientStrings[id];
//           if (cs.r.test(nAgt)) {
//             os = cs.s;
//             break;
//           }
//         }
//       }
//       return os;
//     }
//    }
//   angular.module('ute.common.oneview.footer').controller('ute.oneview.footer.rep.feedback.controller', OneviewCommonFooterRepFeedbackController);
// }

//no more required as the feedback functionaity has been implemented as a separate module
// namespace ute.common.oneview.footer {
//   'use strict';
//   class OneViewFooterRepFeedback implements ng.IDirective {
//     constructor(private oneViewFooterService: ute.common.oneview.footer.IOneViewFooterService) {
//     }
//     restrict: string = 'E';
//     templateUrl: string = this.oneViewFooterService.getConfig().advanced.repFeedback.templateUrl;
//     controller: string = this.oneViewFooterService.getConfig().advanced.repFeedback.controllerName;
//     controllerAs: string = 'repFeedback';
//     static factory(): ng.IDirectiveFactory {
//       const directive = (oneViewFooterService: ute.common.oneview.footer.IOneViewFooterService) => new OneViewFooterRepFeedback(oneViewFooterService);
//       directive.$inject = ['ute.oneview.footer.service'];
//       return directive;
//     }
//   }
//   angular.module('ute.common.oneview.footer').directive('uteOneviewFooterRepFeedback', OneViewFooterRepFeedback.factory());
// }

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneViewFooterProvider = (function () {
                    /* @ngInject */
                    function OneViewFooterProvider() {
                        var _this = this;
                        this.userId = '';
                        this.editQuickLinkMode = false;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                mainTemplateUrl: 'module/oneviewFooterDirective/oneviewFooter.directive.view.html',
                                mainControllerName: 'ute.oneview.footer.directive.controller',
                                consumerControllerName: 'ute.oneview.consumer.footer.directive.controller',
                                footerRetrieveLinksUrl: 'v1/userPreferenceRetrieval',
                                footerUpdateLinksUrl: 'v1/userPreferenceUpdate',
                                footerLoadFrLinksUrl: 'cms/ute/rogers/consumer/oneview/data/quickLinks/quickLinkList_fr.json',
                                footerLoadEnLinksUrl: 'cms/ute/rogers/consumer/oneview/data/quickLinks/quickLinkList_en.json',
                                popupTime: 3,
                                careSessionTime: 45,
                                dealerSessionTime: 15,
                                heartbeatURL: 'shop/cfa/o/logout-keep-alive',
                                keepAlive: 'v1/session/keepalive',
                                sspHomeURL: 'shop/cfa/home',
                                agentInfo: 'v1/agentInfo',
                                sspDashboardURL: 'shop/cfa/ssp-ute-interface',
                                signoutURL: 'shop/home',
                                backToSSP: 'v1/backToSSP'
                            },
                            advanced: {
                                session: {
                                    controllerName: 'ute.oneview.footer.session.directive.controller',
                                    templateUrl: 'module/oneviewFooterSession/oneviewFooter.session.directive.view.html'
                                },
                                sessionPopup: {
                                    templateUrl: 'module/oneviewFooterSession/oneviewFooter.session.popup.directive.view.html'
                                },
                                sspModal: {
                                    controllerName: 'ute.oneview.footer.ssp.modal.controller',
                                    templateUrl: 'module/oneviewFooterDirective/oneviewFooter.ssp.modal.view.html'
                                },
                                repFeedback: {
                                    controllerName: 'ute.oneview.footer.rep.feedback.controller',
                                    templateUrl: 'module/oneviewFooterDirective/oneviewFooter.rep.feedback.directive.view.html'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http, sessionStorage) {
                            _this.$http = $http;
                            _this.$injector = $injector;
                            _this.sessionStorage = sessionStorage;
                            _this.securityService = $injector.get('ute.common.security.service');
                            return {
                                getConfig: _this.getConfig,
                                retrieveQuickLinks: _this.retrieveQuickLinks,
                                updateQuickLinks: _this.updateQuickLinks, loadQuickLinks: _this.loadQuickLinks,
                                setUserId: _this.setUserId,
                                getUserId: _this.getUserId,
                                setUserType: _this.setUserType,
                                getUserType: _this.getUserType,
                                setSaveLinksString: _this.setSaveLinksString,
                                setFooterEditMode: _this.setFooterEditMode,
                                getFooterEditMode: _this.getFooterEditMode,
                                setUserInfo: _this.setUserInfo,
                                getUserInfo: _this.getUserInfo,
                                keepAlive: _this.keepAlive,
                                agentInfo: _this.agentInfo,
                                backToSSP: _this.backToSSP,
                                setAccountNumber: _this.setAccountNumber,
                                getAccountNumber: _this.getAccountNumber,
                                setCurrentLanguage: _this.setCurrentLanguage,
                                getCurrentLanguage: _this.getCurrentLanguage
                            };
                        };
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        this.retrieveQuickLinks = function (agentUserId) {
                            var request = {
                                userId: agentUserId
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.footerRetrieveLinksUrl), request)
                                .then(_this.processRetrieveQuickLinkSuccess)
                                .catch(_this.processRetrieveQuickLinkError)
                                .finally(_this.finaliseprocessRetrieveQuickLinkCall);
                        };
                        this.processRetrieveQuickLinkSuccess = function (response) {
                            /* tslint:disable */
                            if (_.some(response.data.userPreference, { "name": "quickLinks" })) {
                                var quickLinkValues = _.find(response.data.userPreference, function (obj) {
                                    return obj.name === 'quickLinks';
                                });
                                return quickLinkValues.value;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processRetrieveQuickLinkError = function (reason) {
                            return false;
                        };
                        this.finaliseprocessRetrieveQuickLinkCall = function () {
                            return true;
                        };
                        this.updateQuickLinks = function () {
                            var request = {
                                userId: _this.userId,
                                userType: _this.userType,
                                userPreferenceName: 'quickLinks',
                                userPreferenceValue: _this.saveLinks
                            };
                            _this.editQuickLinkMode = false;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.footerUpdateLinksUrl), request)
                                .then(_this.processUpdateQuickLinkSuccess)
                                .catch(_this.processUpdateQuickLinkError)
                                .finally(_this.finaliseProcessUpdateQuickLinkCall);
                        };
                        this.processUpdateQuickLinkSuccess = function (response) {
                            if (response.status === 200) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processUpdateQuickLinkError = function (reason) {
                            return false;
                        };
                        this.finaliseProcessUpdateQuickLinkCall = function () {
                            return true;
                        };
                        this.loadQuickLinks = function () {
                            var languageService = _this.$injector.get('ute.blocks.language.switcher');
                            var LoadUrl;
                            if (languageService.getCurrentLanguage() === 'en') {
                                LoadUrl = _this.getConfig().basic.footerLoadEnLinksUrl;
                            }
                            else if (languageService.getCurrentLanguage() === 'fr') {
                                LoadUrl = _this.getConfig().basic.footerLoadFrLinksUrl;
                            }
                            return _this.$http.get(LoadUrl)
                                .then(_this.processQuickLinkSuccess)
                                .catch(_this.processQuickLinkError)
                                .finally(_this.finaliseprocessQuickLinkCall);
                        };
                        this.processQuickLinkSuccess = function (response) {
                            if (_.has(response.data, 'quickLink1')) {
                                _this.quickLinksIds = _.filter(response.data, function (obj) {
                                    // userType 'dealer' maps to 'retail' in permission array.
                                    // IDK why, but code deals in terms of 'dealer' but business always refers to this channel as 'retail'. 
                                    var permissionKey = _this.userType === 'dealer' ? 'retail' : 'care';
                                    return obj.hasOwnProperty('permissions') && obj.permissions.indexOf(permissionKey) >= 0;
                                });
                                return _this.quickLinksIds;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processQuickLinkError = function (reason) {
                            return false;
                        };
                        this.finaliseprocessQuickLinkCall = function () {
                            return true;
                        };
                        this.keepAlive = function () {
                            var request = {
                                cache: false
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.keepAlive), request);
                        };
                        this.setUserId = function (agentUserId) {
                            _this.userId = agentUserId;
                        };
                        this.getUserId = function () {
                            return _this.userId;
                        };
                        this.setUserType = function (userType) {
                            _this.userType = userType;
                        };
                        this.getUserType = function () {
                            return _this.userType;
                        };
                        this.setSaveLinksString = function (saveString) {
                            _this.saveLinks = saveString;
                        };
                        this.setFooterEditMode = function (editMode) {
                            _this.editQuickLinkMode = editMode;
                        };
                        this.getFooterEditMode = function () {
                            return _this.editQuickLinkMode;
                        };
                        this.setUserInfo = function (userInfo) {
                            _this.userInfo = userInfo;
                        };
                        this.getUserInfo = function () {
                            return _this.userInfo;
                        };
                        this.agentInfo = function (accountNumber) {
                            if (accountNumber === '' && _this.userType === 'care') {
                                _this.accountNumber = _this.sessionStorage.getSessionStorageValue('accountNumber');
                            }
                            else {
                                _this.accountNumber = accountNumber;
                            }
                            _this.setAccountNumber(_this.accountNumber);
                            var request = {
                                acctNbr: _this.accountNumber
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.agentInfo), request)
                                .then(_this.processAgentInfoSuccess)
                                .catch(_this.processAgentInfoError)
                                .finally(_this.finaliseAgentInfoCall);
                        };
                        this.processAgentInfoSuccess = function (response) {
                            if (response.data) {
                                _this.userInfo = response.data;
                                if (_this.userType === 'dealer') {
                                    _this.userId = _this.userInfo.cfaInfo.userId;
                                }
                                else if (_this.userType === 'care') {
                                    _this.userId = _this.userInfo.lanId;
                                }
                                return _this.userInfo;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processAgentInfoError = function (reason) {
                            return false;
                        };
                        this.finaliseAgentInfoCall = function () {
                            return true;
                        };
                        this.backToSSP = function (postData) {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.backToSSP), postData)
                                .then(_this.processBackToSSPSuccess)
                                .catch(_this.processBackToSSPError);
                        };
                        this.processBackToSSPSuccess = function (response) {
                            if (response.data) {
                                return response.data;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processBackToSSPError = function (reason) {
                            return false;
                        };
                        this.setAccountNumber = function (accountNumber) {
                            _this.accountNumber = accountNumber;
                        };
                        this.getAccountNumber = function () {
                            return _this.accountNumber;
                        };
                        this.setCurrentLanguage = function (lang) {
                            _this.language = lang;
                        };
                        this.getCurrentLanguage = function () {
                            return _this.language;
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            'sessionStorage'
                        ];
                    }
                    OneViewFooterProvider.$inject = [];
                    OneViewFooterProvider.serviceName = 'ute.oneview.footer.service';
                    return OneViewFooterProvider;
                }());
                angular.module('ute.common.oneview.footer').provider(OneViewFooterProvider.serviceName, OneViewFooterProvider);
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneviewCommonFooterSessionController = (function () {
                    function OneviewCommonFooterSessionController(oneviewCommonFooterService, userService, messagesService, $interval, $cookieStore, $window, sessionStorage, $http) {
                        this.oneviewCommonFooterService = oneviewCommonFooterService;
                        this.userService = userService;
                        this.messagesService = messagesService;
                        this.$interval = $interval;
                        this.$cookieStore = $cookieStore;
                        this.$window = $window;
                        this.sessionStorage = sessionStorage;
                        this.$http = $http;
                        this.intervalTime = 1000;
                        this.isSessionExpired = false;
                        this.timerExpired = false;
                        this.interval = $interval;
                        this.userType = this.oneviewCommonFooterService.getUserType();
                        this.http = $http;
                        this.isDealer = this.isCare = false;
                        if (this.userType === 'dealer') {
                            this.isDealer = true;
                            this.timeOut = this.oneviewCommonFooterService.getConfig().basic.dealerSessionTime;
                        }
                        else if (this.userType === 'care') {
                            this.isCare = true;
                            this.timeOut = this.oneviewCommonFooterService.getConfig().basic.careSessionTime;
                        }
                        this.popupTime = this.oneviewCommonFooterService.getConfig().basic.popupTime;
                    }
                    OneviewCommonFooterSessionController.prototype.renewSession = function () {
                        if (this.userType) {
                            if (this.isDealer) {
                                this.renewTimer();
                                this.renewAgentSession();
                            }
                            else if (this.isCare) {
                                if (this.sessionStorage.getSessionStorageValue('userType')) {
                                    this.renewTimer();
                                }
                            }
                        }
                    };
                    /**
                     * To maintain SSP session through Heartbeat URL
                     */
                    OneviewCommonFooterSessionController.prototype.renewAgentSession = function () {
                        var userInfo = this.oneviewCommonFooterService.getUserInfo();
                        if (userInfo) {
                            this.http.post(userInfo.sourceURL + this.oneviewCommonFooterService.getConfig().basic.heartbeatURL + ';jsessionid=' + userInfo.jsessionId);
                        }
                    };
                    OneviewCommonFooterSessionController.prototype.renewTimer = function () {
                        this.interval.cancel(this.handle); //Reset the running Timer
                        this.handle = undefined;
                        this.startTimer();
                    };
                    OneviewCommonFooterSessionController.prototype.renewKeepAlive = function () {
                        this.oneviewCommonFooterService.keepAlive()
                            .then(function (result) {
                            //
                        });
                    };
                    OneviewCommonFooterSessionController.prototype.startTimer = function () {
                        var _this = this;
                        this.runningTime = (this.timeOut) * 60;
                        this.showPopup = false;
                        this.handle = this.interval(function () { return _this.timer(); }, this.intervalTime); //Start the Timer
                    };
                    OneviewCommonFooterSessionController.prototype.timer = function () {
                        var minutes;
                        var seconds;
                        if (!this.isSessionExpired) {
                            minutes = String(Math.floor(this.runningTime / 60));
                            seconds = String(this.runningTime % 60);
                            this.minutes = Number(minutes) < 10 ? ('0' + minutes) : minutes;
                            this.seconds = Number(seconds) < 10 ? ('0' + seconds) : seconds;
                            if (--this.runningTime < 0) {
                                this.runningTime = 0;
                                this.intervalTime = 0;
                                this.minutes = this.seconds = '00';
                                this.timerExpired = true;
                                this.showPopup = false;
                                this.sessionExpired();
                                this.isSessionExpired = true;
                            }
                            else if (Number(minutes) === this.popupTime && Number(seconds) === 0) {
                                this.showPopup = true;
                            }
                        }
                    };
                    OneviewCommonFooterSessionController.prototype.sessionExpired = function () {
                        if (this.userType) {
                            this.userType = null;
                            this.interval.cancel(this.handle);
                            if (this.isDealer) {
                                this.endAgentSession();
                            }
                            else if (this.isCare) {
                                this.endCareSession();
                            }
                        }
                    };
                    OneviewCommonFooterSessionController.prototype.endAgentSession = function () {
                        this.$cookieStore.remove('userType');
                        var userInfo = this.oneviewCommonFooterService.getUserInfo();
                        if (userInfo) {
                            var path = userInfo.sourceURL ? userInfo.sourceURL + this.oneviewCommonFooterService.getConfig().basic.sspHomeURL : '';
                        }
                        if (path) {
                            this.$window.location = path;
                        }
                    };
                    OneviewCommonFooterSessionController.prototype.endCareSession = function () {
                        this.sessionStorage.deleteSessionStorageValue('userType');
                        this.$window.location.href = '/web/totes/#/oneViewInterface?statusCode=SESSION_TIMEOUT';
                        this.$window.location.reload(true);
                    };
                    OneviewCommonFooterSessionController.prototype.signedOut = function ($event) {
                        $event.preventDefault();
                        $event.stopPropagation();
                        this.minutes = this.seconds = '00';
                        this.timerExpired = true;
                        this.messagesService.publish('ute-oneview-footer-logout');
                        return null;
                    };
                    OneviewCommonFooterSessionController.prototype.showPopupTimer = function () {
                        this.showPopup = true;
                    };
                    /**
                     * To display Drag and Drop message on click of Edit Icon
                     */
                    OneviewCommonFooterSessionController.prototype.editMode = function (flag) {
                        this.editQuickLinks = flag;
                    };
                    OneviewCommonFooterSessionController.$inject = [
                        'ute.oneview.footer.service',
                        'ute.common.user.service',
                        'ute.blocks.messages.bus.service',
                        '$interval',
                        '$cookieStore',
                        '$window',
                        'sessionStorage',
                        '$http'
                    ];
                    return OneviewCommonFooterSessionController;
                }());
                footer.OneviewCommonFooterSessionController = OneviewCommonFooterSessionController;
                angular.module('ute.common.oneview.footer').controller('ute.oneview.footer.session.directive.controller', OneviewCommonFooterSessionController);
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneViewFooterSessionTimer = (function () {
                    function OneViewFooterSessionTimer(oneViewFooterService, $document, $interval, sessionStorage) {
                        var _this = this;
                        this.oneViewFooterService = oneViewFooterService;
                        this.$document = $document;
                        this.$interval = $interval;
                        this.sessionStorage = sessionStorage;
                        this.restrict = 'E';
                        this.templateUrl = this.oneViewFooterService.getConfig().advanced.session.templateUrl;
                        this.controller = this.oneViewFooterService.getConfig().advanced.session.controllerName;
                        this.controllerAs = 'oneviewFooterSession';
                        this.test = function () {
                            return _this.oneViewFooterService.getFooterEditMode();
                        };
                        this.linkFn = function (scope, element, attrs, controller) {
                            controller.renewSession();
                            var handle = null;
                            var interval = 60000;
                            var $interval = _this.$interval;
                            var sessionStorage = _this.sessionStorage;
                            var userType = _this.oneViewFooterService.getUserType();
                            var isDealer = false;
                            var isCare = false;
                            isDealer = userType === 'dealer' ? true : false;
                            isCare = userType === 'care' ? true : false;
                            _this.$document.on('click', function () { return renewClick(); });
                            function renewClick() {
                                controller.renewSession();
                                if (handle === null && userType) {
                                    if (isDealer) {
                                        handle = $interval(function () { return renewHeartBeat(); }, interval);
                                    }
                                    else if (isCare) {
                                        if (sessionStorage.getSessionStorageValue('userType')) {
                                            handle = $interval(function () { return renewHeartBeat(); }, interval);
                                        }
                                    }
                                }
                            }
                            function renewHeartBeat() {
                                $interval.cancel(handle);
                                handle = null;
                                controller.renewKeepAlive();
                            }
                            scope.$watch(_this.test, function (value) {
                                controller.editMode(value);
                            });
                        };
                        this.link = this.linkFn;
                    }
                    OneViewFooterSessionTimer.factory = function () {
                        var directive = function (oneViewFooterService, $document, $interval, sessionStorage) { return new OneViewFooterSessionTimer(oneViewFooterService, $document, $interval, sessionStorage); };
                        directive.$inject = ['ute.oneview.footer.service', '$document', '$interval', 'sessionStorage'];
                        return directive;
                    };
                    return OneViewFooterSessionTimer;
                }());
                angular.module('ute.common.oneview.footer').directive('uteOneviewFooterSessionTimer', OneViewFooterSessionTimer.factory());
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneViewFooterSessionPopup = (function () {
                    function OneViewFooterSessionPopup(oneViewFooterService) {
                        this.oneViewFooterService = oneViewFooterService;
                        this.restrict = 'E';
                        this.templateUrl = this.oneViewFooterService.getConfig().advanced.sessionPopup.templateUrl;
                        this.controller = this.oneViewFooterService.getConfig().advanced.session.controllerName;
                        this.controllerAs = 'oneviewFooterSessionPopup';
                    }
                    OneViewFooterSessionPopup.factory = function () {
                        var directive = function (oneViewFooterService) { return new OneViewFooterSessionPopup(oneViewFooterService); };
                        directive.$inject = ['ute.oneview.footer.service'];
                        return directive;
                    };
                    return OneViewFooterSessionPopup;
                }());
                angular.module('ute.common.oneview.footer').directive('uteOneviewFooterSessionPopup', OneViewFooterSessionPopup.factory());
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
                var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                var ProviderBase = ute.common.core.ProviderBase;
                ;
                var AgentInfo = (function () {
                    function AgentInfo($injector, userService) {
                        var _this = this;
                        this.$injector = $injector;
                        this.userService = userService;
                        /**
                         * @override
                         * @returns {IAgentInfo}
                         */
                        this.normalizeData = function () {
                            return _this;
                        };
                        this.storeService = $injector.get('ute.blocks.persistent.storage.service');
                        this.$q = $injector.get('$q');
                    }
                    return AgentInfo;
                }());
                var AgentInfoService = (function (_super) {
                    __extends(AgentInfoService, _super);
                    function AgentInfoService(conf, $injector, securityService, $http, $q, $timeout, userService, request) {
                        var _this = this;
                        _super.call(this, new AgentInfo($injector, userService), conf, securityService, $http, $q, $timeout, userService, request);
                        this.conf = conf;
                        this.$injector = $injector;
                        this.isAgentInfoCallInProgress = this.isCallInProgress;
                        this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                        this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                        /**
                         * @param account
                         */
                        this.getAgentInfo = function () {
                            return _this.getData();
                        };
                        this.getConfig = function () {
                            return _this.config;
                        };
                    }
                    ;
                    return AgentInfoService;
                }(CacheableDataGeneric));
                var AgentInfoWorker = (function (_super) {
                    __extends(AgentInfoWorker, _super);
                    function AgentInfoWorker(conf, securityService, $http, $q, $timeout, userService, $injector, request) {
                        _super.call(this, conf, $injector, securityService, $http, $q, $timeout, userService, request);
                    }
                    ;
                    return AgentInfoWorker;
                }(AgentInfoService));
                /**
                 * only one worker exists for the same request
                 */
                var AgentInfoFactory = (function () {
                    function AgentInfoFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                        var _this = this;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this.$injector = $injector;
                        this._getWorker = function (request) {
                            return new AgentInfoWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                        };
                        this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                    }
                    ;
                    return AgentInfoFactory;
                }());
                var AgentInfoProvider = (function (_super) {
                    __extends(AgentInfoProvider, _super);
                    /* @ngInject */
                    function AgentInfoProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q, $timeout) {
                            var factory = new AgentInfoFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                            var userService = $injector.get('ute.common.user.service');
                            return function (request) {
                                if (angular.isUndefined(request) && userService.isSigned() && userService.isCare()) {
                                    request = {
                                        acctNbr: Number(userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER))
                                    };
                                }
                                return factory.getWorker(request);
                            };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$q',
                            '$timeout'
                        ];
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                partialApiUrl: 'v1/agentInfo',
                                logPrefix: 'AccountOverview',
                                logLevel: ute.common.typescript.api.log.LogLevel.OFF
                            }
                        };
                    }
                    AgentInfoProvider.$inject = [];
                    AgentInfoProvider.factoryName = 'ute.common.agent.info.factory';
                    return AgentInfoProvider;
                }(ProviderBase));
                angular.module('ute.common.oneview.header').provider(AgentInfoProvider.factoryName, AgentInfoProvider);
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
                var OneViewHeaderServiceProvider = (function () {
                    /* @ngInject */
                    function OneViewHeaderServiceProvider(accountOverviewProvider, accountOverviewSummaryProvider) {
                        var _this = this;
                        this.accountOverviewProvider = accountOverviewProvider;
                        this.accountOverviewSummaryProvider = accountOverviewSummaryProvider;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                devServerURL: 'https://www.dev18.rogers.com',
                                accountOverviewAPI: 'v1/accountoverview',
                                accountOverviewSummaryAPI: 'v1/accountoverview/summary',
                                billSummaryLegacyURL: '/web/RogersServices.portal?_nfpb=true&_pageLabel=Bill_Summary',
                                prepaidTopUpLegacyURL: '/web/myrogers/prepaidTopUp',
                                oasysURL: 'https://www.rogersoasys2.com/OneViewSSO.aspx?',
                                oasysBetaURL: 'https://beta.rogersoasys2.com/OneViewSSO.aspx?',
                                stateSub: '/web/totes/#/',
                                stateNav: [
                                    {
                                        name: 'wireless',
                                        state: 'wireless'
                                    }, {
                                        name: 'wirelessPrepaid',
                                        state: 'wirelessPrepaid'
                                    }, {
                                        name: 'shareEverything',
                                        state: 'shareEverything'
                                    }, {
                                        name: 'shmdashboard',
                                        state: 'shmdashboard'
                                    }, {
                                        name: 'internetdash',
                                        state: 'internetdash'
                                    }, {
                                        name: 'tvdashboard',
                                        state: 'tvdashboard'
                                    }, {
                                        name: 'homephone',
                                        state: 'rhpdashboard'
                                    }, {
                                        name: 'HSI',
                                        state: 'HSI'
                                    }, {
                                        name: 'IPTV',
                                        state: 'IPTV'
                                    }, {
                                        name: 'RHP Phone Line',
                                        state: 'RHP Phone Line'
                                    }, {
                                        name: 'self-serve',
                                        state: 'self-serve'
                                    }, {
                                        name: 'guestOverview',
                                        state: 'guestOverview'
                                    }, {
                                        name: 'accountOverview',
                                        state: 'accountOverview'
                                    }, {
                                        name: 'oneViewDashboard',
                                        state: 'oneViewDashboard'
                                    }, {
                                        name: 'viewbill',
                                        state: 'viewbill'
                                    }, {
                                        name: 'paynow',
                                        state: 'paynow'
                                    }, {
                                        name: 'interaction',
                                        state: 'interaction'
                                    }, {
                                        name: 'actionsOffers',
                                        state: 'actionsOffers'
                                    }, {
                                        name: 'profile',
                                        state: 'profile'
                                    }, {
                                        name: 'orders',
                                        state: 'orders'
                                    },
                                ],
                                mandatoryPages: [
                                    'migrateUser',
                                    'completeProfile'
                                ],
                                buttonSettings: [
                                    {
                                        accountType: 'Suspended',
                                        mode: 'Disabled'
                                    },
                                    {
                                        accountType: 'Cancelled',
                                        mode: 'Hidden'
                                    },
                                    {
                                        accountType: 'Deactive',
                                        mode: 'Hidden'
                                    },
                                    {
                                        accountType: 'CLMExceeded',
                                        mode: 'Disabled'
                                    },
                                    {
                                        accountType: 'DefaultForRetailandCare',
                                        mode: 'Hidden'
                                    },
                                    {
                                        accountType: 'Default',
                                        mode: 'Visible'
                                    }
                                ],
                                viewBillLegacyURL: '/web/myrogers/viewBill',
                            },
                            advanced: {
                                consumerDetails: {
                                    controllerName: 'MyrConsumerDetailsController',
                                    templateUrl: 'module/consumerDetails/consumerDetails.html'
                                },
                                oneViewHeaderDirective: {
                                    controllerName: 'MyrOneViewHeaderController',
                                    templateUrl: 'module/oneViewHeaderDirective/oneViewHeader.html'
                                },
                                oneViewSubmenu: {
                                    controllerName: 'HeaderMyrSubMenuController',
                                    templateUrl: 'module/oneViewSubMenu/oneViewSubmenu.html'
                                }
                            },
                            settings: {
                                oneViewExternalAPIs: {
                                    news: 'https://news-weather-feeds-prod.herokuapp.com/news/items?site=',
                                    weather: 'https://news-weather-feeds-prod.herokuapp.com/weather/entries?city='
                                },
                                revolutionGetOffersPrefix: '/web/RogersServices.portal/totes/api',
                                revolutionGetOffers: 'v1/offer-status',
                                oneViewRevolutionGetOffersPrefix: '/web/totes/api',
                                unProtectedUrlPrefix: '/web/totes/api/v1/',
                                protectedUrlPrefix: '/web/RogersServices.portal/totes/api/v1/',
                                secureCallDefault: true,
                                showErrorPopup: false,
                                useLocalAPI: false,
                                secureCallPages: [
                                    'home',
                                    'signin',
                                    'signin/resetPassword',
                                    'registration',
                                    'registrationNoEmailVerify',
                                    'forgetPassword',
                                    'forgetusername',
                                    'invalidPath',
                                    'demo',
                                    'permissionDenied',
                                    'tpsc'
                                ],
                                unprotectedCalls: [
                                    'testlogin',
                                    'signin',
                                    'signin/resetPassword',
                                    'profile',
                                    'register',
                                    'discardAllSmCookies',
                                    'profile/question',
                                    'forgot/username',
                                    'forgot/password/resubmit',
                                    'forgot/password',
                                    'maintenanceSettings',
                                    'discovery-page/get-content'
                                ],
                                protectedCalls: [
                                    'permissions',
                                    'cart/fetch'
                                ],
                                moduleCallException: {},
                                ajaxCallException: {
                                    'loggedIn': '/web/RogersServices.portal/totes/api/v1/loggedIn',
                                    'signin': '/siteminderagent/forms/login.fcc',
                                    'accountoverview': '/web/RogersServices.portal/totes/api/v1/accountoverview',
                                    'profile/checkComplete': '/web/RogersServices.portal/totes/api/v1/profile/checkComplete',
                                    'ebu/nickname': '/web/RogersServices.portal/totes/api/v1/ebu/nickname',
                                    'usernameMigration/check': '/web/RogersServices.portal/totes/api/v1/usernameMigration/check',
                                    'wcoc/decryptjwttoken': '/web/RogersServices.portal/totes/api/v1/wcoc/decryptjwttoken'
                                },
                                postSigninUrl: window.location.protocol + '//' + window.location.hostname + ((window.location.protocol === 'http' && window.location.port === '80') ||
                                    (window.location.protocol === 'https' && window.location.port === '443') ? '' : ':' + window.location.port) + '/web/RogersServices.portal/totes/#/accountOverview',
                                agentInfo: {
                                    heartbeatURL: 'shop/cfa/o/logout-keep-alive',
                                    signoutURL: 'shop/home',
                                    sspDashboardURL: 'shop/cfa/ssp-ute-interface',
                                    careTimeout: 45,
                                    dealerTimeout: 15,
                                    sspHomeURL: 'shop/cfa/home'
                                },
                                oneViewStatusCodes: {
                                    sspSSOFailure: 'SSP_SSO_FAILURE',
                                    crmSSOFailure: 'CRM_SSO_FAILURE',
                                    sspAccessFailure: 'SSP_ACCESS_FAILURE',
                                    crmAccessFailure: 'CRM_ACCESS_FAILURE',
                                    fidoAccessFailure: 'FIDO_ACCESS_FAILURE',
                                    crmServiceFailure: 'CRM_SERVICE_FAILURE',
                                    sspServiceFailure: 'SSP_SERVICE_FAILURE',
                                    sessionTimeout: 'SESSION_TIMEOUT',
                                    crmSignout: 'CRM_SIGN_OUT',
                                    fraudCheck: 'FRAUD_CUSTOMER',
                                    creditOps: 'CREDIT_OPS_FAILURE'
                                },
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector) {
                            _this.$injector = $injector;
                            _this.accountOverviewSummaryFactory = $injector.get('ute.rogers.account.overview.summary.factory');
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.$window = $injector.get('$window');
                            _this.$translate = $injector.get('$translate');
                            return {
                                getConfig: _this.getConfig,
                                getSettingByAccountStatus: _this.getSettingByAccountStatus,
                                getSummaryWorker: _this.getSummaryWorker,
                                getFactoryWorker: _this.getFactoryWorker,
                                subNavTo: _this.subNavTo
                            };
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return _this.config;
                        };
                        /**
                         *
                         * @param {string} accountStatus
                         */
                        this.getSettingByAccountStatus = function (accountStatus) {
                            var btnSettings = _.find(_this.getConfig().basic.buttonSettings, { 'accountType': accountStatus });
                            return btnSettings ? btnSettings.mode : '';
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            _this.accountOverviewProvider.configure({
                                basic: {
                                    applicationId: _this.config.basic.applicationId,
                                    partialApiUrl: _this.config.basic.accountOverviewAPI
                                }
                            });
                            _this.accountOverviewSummaryProvider.configure({
                                basic: {
                                    applicationId: _this.config.basic.applicationId,
                                    partialApiUrl: _this.config.basic.accountOverviewSummaryAPI
                                }
                            });
                            return true;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getLang = function () {
                            return _this.$translate.use();
                        };
                        /**
                         *
                         * @param {string} navKey
                         */
                        this.getStateNav = function (navKey) {
                            return _.findWhere(_this.getConfig().basic.stateNav, { 'name': navKey }).state;
                        };
                        /**
                         *
                         * @param {string} navKey
                         * @param {string} BASEURL
                         */
                        this.subNavTo = function (navKey, BASEURL) {
                            _this.$window.location.href = BASEURL + _this.getConfig().basic.stateSub + _this.getStateNav(navKey);
                        };
                        /**
                         *
                         * @returns {IAccountOverviewWorker}
                         */
                        this.getFactoryWorker = function () {
                            var param;
                            var ban = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                            param = { acctNbr: ban };
                            return _this.accountOverviewFactory(param);
                        };
                        /**
                         *
                         * @returns {IPromise<IAccountOverviewSummaryWorker>}
                         */
                        this.getSummaryWorker = function () {
                            return _this.getFactoryWorker().getSelectedAccount().then(function (account) {
                                var summaryRequest = {
                                    accountNumber: account.accountNumber,
                                    accountTypeNumber: account.accountTypeNumber,
                                    language: _this.getLang()
                                };
                                return _this.accountOverviewSummaryFactory(summaryRequest);
                            });
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$translate'
                        ];
                        // this.resetModel();
                    }
                    OneViewHeaderServiceProvider.$inject = [];
                    return OneViewHeaderServiceProvider;
                }());
                angular.module('ute.common.oneview.header').provider('ute.oneview.header.service', OneViewHeaderServiceProvider);
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var header;
            (function (header) {
                'use strict';
                var BadgeTypes = ute.common.subscriptionBadge.BadgeTypes;
                var OneViewSubmenuServiceProvider = (function () {
                    /* @ngInject */
                    function OneViewSubmenuServiceProvider(billingDetailFactory) {
                        var _this = this;
                        this.billingDetailFactory = billingDetailFactory;
                        /* @ngInject */
                        this.$get = function ($injector, $cookieStore) {
                            _this.$injector = $injector;
                            _this.eclipseRemoteApi = $injector.get('ute.rogers.eclipse.remote.api.service');
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            return {
                                getSubscriptions: _this.getSubscriptions
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            return true;
                        };
                        this.getSelectedAccountDetail = function () {
                            //wrap account details for selected account, handle account variety.
                            var _rtn;
                            var _selectedAccount;
                            var accountOverviewWorker = _this.accountOverviewFactory();
                            return accountOverviewWorker.getAccountOverviewRawData().then(function (rawData) {
                                var accountList = rawData.accountList;
                                return accountOverviewWorker.getSelectedAccount().then(function (selectedAccount) {
                                    var accountListServiceSelected = selectedAccount;
                                    return accountOverviewWorker.getSelectedAccountDetails(null).then(function (accountDetail) {
                                        // this.oneViewHeaderService.getSummaryWorker().then( (summaryWorker) => {
                                        _selectedAccount = accountDetail;
                                        _this.billingDetailService = _this.billingDetailFactory({
                                            accountNumber: accountDetail.accountNumber,
                                            accountTypeNumber: accountDetail.accountType,
                                            language: 'en',
                                            applicationId: 'Rogers.com',
                                            refresh: false
                                        });
                                        _this.billingDetailService.getBillingDetail().then(function (billingDetail) {
                                            if (_selectedAccount) {
                                                var _detail = _selectedAccount;
                                                var _info = _detail.accountInfo;
                                                //var _subList = _detail.subList;
                                                var isCreditCardHolder = _.find(accountList, { accountNumber: _selectedAccount.accountNumber }).isCreditCardHolder;
                                                _rtn = {
                                                    number: _detail.accountNumber,
                                                    billableAccountNumber: _detail.billableAccountNumber,
                                                    type: _detail.accountType,
                                                    status: _info.status,
                                                    get nickName() {
                                                        return accountListServiceSelected ? accountListServiceSelected.nickname : '';
                                                    },
                                                    name: _detail.accountName.firstName,
                                                    accountBalance: accountDetail.accountBalance,
                                                    isPrepaid: _detail.accountType === 9,
                                                    isWireless: _detail.accountType === 1,
                                                    isMastro: _detail.accountType === 30,
                                                    isCable: _detail.accountType === 6,
                                                    isConsolidated: _detail.isConsolidated,
                                                    isViewBillDisplay: (_this.briteBillService.getIsbritebillAvailable(_detail.accountNumber) && (_detail.accountType !== 9)),
                                                    isCreditCardHolder: isCreditCardHolder,
                                                    //optional data
                                                    balance: '',
                                                    dueDate: '',
                                                    dateDelimiter: '',
                                                    due: '',
                                                    dateOrder: [],
                                                    dateYearPrefix: '',
                                                    paymentMethod: '',
                                                    userType: '',
                                                    userSubType: '',
                                                    phoneNumber: '',
                                                    contactId: '',
                                                    nextBillingDate: _detail.nextBillingDate
                                                };
                                                if (_detail.accountType !== 9) {
                                                    _this.briteBillService.getBills(_detail.accountNumber).then(function (bills) {
                                                        _rtn.isViewBillDisplay = bills.length > 0;
                                                    });
                                                }
                                                if (accountDetail.accountBalance) {
                                                    _rtn.balance = accountDetail.accountBalance.balanceAmount || '';
                                                    _rtn.dueDate = billingDetail.billDueDate || '';
                                                }
                                                if (_rtn.isPrepaid) {
                                                    _rtn.due = _selectedAccount.accountInfo.expiryDate;
                                                    _rtn.dateDelimiter = ' ';
                                                    _rtn.dateOrder = [0, 1, 2];
                                                    _rtn.dateYearPrefix = '';
                                                }
                                                else {
                                                    _rtn.due = billingDetail.billDueDate || '';
                                                    _rtn.dateDelimiter = '-';
                                                    _rtn.dateOrder = [1, 0, 2];
                                                    _rtn.dateYearPrefix = '20';
                                                }
                                                //get phone numbers
                                                var _list = _.map(accountDetail.subList, function (v) {
                                                    if (v.subType === 'CTN') {
                                                        return v.subNumber;
                                                    }
                                                });
                                                _rtn.phoneNumber = _list[0];
                                                if (_rtn.phoneNumber !== undefined) {
                                                    _this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, _rtn.phoneNumber);
                                                }
                                                //Wireless account
                                                if (_rtn.isWireless) {
                                                    _rtn.userType = _info.accType;
                                                    _rtn.userSubType = _info.accSubType;
                                                }
                                                //post-paid account get payment method
                                                if (!_rtn.isPrepaid && accountDetail.accountBalance !== undefined && accountDetail.accountBalance) {
                                                    //post-paid account
                                                    _rtn.paymentMethod = billingDetail.methodOfPayment ? billingDetail.methodOfPayment.mopType : 'R';
                                                }
                                            }
                                            return _rtn;
                                        });
                                    });
                                    // });
                                });
                            });
                        };
                        this.cleanFirstName = function (firstname) {
                            if (angular.isUndefined(firstname) || firstname === null || firstname.trim() === '') {
                                return '';
                            }
                            else if (firstname.length > 10) {
                                return firstname.substr(0, 9);
                            }
                            else {
                                return firstname;
                            }
                        };
                        /**
                         *
                         * @param subList
                         * @param disablePermissionNotGranted
                         * @returns {{myServices: any[]}}
                         */
                        this.getSubscriptions = function (subList, disablePermissionNotGranted) {
                            var myServicesList = [], serviceAddress;
                            return _this.getSelectedAccountDetail().then(function (_details) {
                                var isPrepaid = (_details && _details.isPrepaid) ? _details.isPrepaid : false;
                                for (var i = 0; i < subList.length; i++) {
                                    var subscription = subList[i], _sub = {};
                                    serviceAddress = '';
                                    _sub.serviceDetail = subscription.subNumber;
                                    _sub.accountNumber = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                                    _sub.showPhone = subscription.subType.toLowerCase() === 'ctn' || subscription.subType.toLowerCase() === 'rhpc' || subscription.subType.toLowerCase() === 'RHP Phone Line'; //show phone number for wireless/home phone
                                    if (subscription && subscription.subAddress) {
                                        serviceAddress = !_.isEmpty(subscription.subAddress.unit) ? serviceAddress + subscription.subAddress.unit + '-' : serviceAddress;
                                        serviceAddress = !_.isEmpty(subscription.subAddress.streetNumber) ? serviceAddress + subscription.subAddress.streetNumber + ' ' : serviceAddress;
                                        serviceAddress = !_.isEmpty(subscription.subAddress.streetName) ? serviceAddress + subscription.subAddress.streetName + ' ' : serviceAddress;
                                        serviceAddress = !_.isEmpty(subscription.subAddress.streetNameSuffix) ? serviceAddress + subscription.subAddress.streetNameSuffix + ' ' : serviceAddress;
                                        serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.streetType + ', ' : serviceAddress;
                                        serviceAddress = !_.isEmpty(subscription.subAddress.streetType) ? serviceAddress + subscription.subAddress.city : serviceAddress;
                                        serviceAddress = serviceAddress.toLowerCase();
                                        _sub.serviceAddress = '';
                                    }
                                    else {
                                        serviceAddress = '';
                                    }
                                    if (_this.eclipseRemoteApi.isEclipseTvSubscription(subscription)) {
                                        _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                                        _sub.type = BadgeTypes.igniteTv;
                                        _sub.plan = 'Digital';
                                        _sub.subAccountId = subscription.subAccountId;
                                        _sub.subNumber = subscription.subNumber;
                                        _sub.disabled = disablePermissionNotGranted[0];
                                        _sub.sortOrder = 2;
                                        _sub.subType = 'IPTV';
                                        _sub.serviceAddress = serviceAddress.toLowerCase();
                                        _sub.serviceType = 'service_tv';
                                        _sub.serviceName = 'IPTV';
                                        _sub.serviceDetail = subscription.subAccountId;
                                        _sub.resolve = function (subItem) {
                                            return {
                                                goIPTV: function () {
                                                    this.eclipseRemoteApi.goToIPTVDashboard({
                                                        accountNumber: subItem.accountNumber,
                                                        subAccountId: subItem.subAccountId,
                                                        subscriptionId: subItem.subNumber,
                                                        source: 'rogers.com'
                                                    }, {
                                                        lang: this.languageSwitcher.getCurrentLanguage(),
                                                        userType: this.userService.getUserType(),
                                                        province: this.$cookieStore.get('province').toLowerCase() // pull from usersService
                                                    });
                                                }
                                            };
                                        };
                                    }
                                    if (_this.eclipseRemoteApi.isEclipseInternetSubscription(subscription)) {
                                        _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                                        _sub.type = BadgeTypes.igniteInternet;
                                        _sub.plan = 'Ignite';
                                        _sub.subAccountId = subscription.subAccountId;
                                        _sub.subNumber = subscription.subNumber;
                                        _sub.disabled = disablePermissionNotGranted[1];
                                        _sub.sortOrder = 3;
                                        _sub.subType = 'HSI';
                                        _sub.serviceAddress = serviceAddress.toLowerCase();
                                        _sub.serviceType = 'service_internet';
                                        _sub.serviceName = 'HSI';
                                        _sub.serviceDetail = subscription.subAccountId;
                                        _sub.resolve = function (subItem) {
                                            return {
                                                goHSI: function () {
                                                    this.eclipseRemoteApi.goToHSIDashboard({
                                                        accountNumber: subItem.accountNumber,
                                                        subAccountId: subItem.subAccountId,
                                                        subscriptionId: subItem.subNumber,
                                                        source: 'rogers.com'
                                                    }, {
                                                        lang: this.languageSwitcher.getCurrentLanguage(),
                                                        userType: this.userService.getUserType(),
                                                        province: this.$cookieStore.get('province').toLowerCase() // pull from usersService
                                                    });
                                                }
                                            };
                                        };
                                    }
                                    if (_this.eclipseRemoteApi.isEclipseHomePhoneSubscription(subscription)) {
                                        _sub.subscriptionBadgeModule = subscription.subStatus !== 'Suspended'; // Disable subscriptionBadgeModule is subStatus is suspended
                                        _sub.type = BadgeTypes.homePhone;
                                        _sub.plan = 'Ignite';
                                        _sub.subAccountId = subscription.subAccountId;
                                        _sub.subNumber = subscription.subNumber;
                                        _sub.disabled = disablePermissionNotGranted[2];
                                        _sub.phoneNumber = subscription.subNumber;
                                        _sub.sortOrder = 4;
                                        _sub.subType = 'RHP Phone Line';
                                        _sub.serviceType = 'service_phone';
                                        _sub.serviceName = 'RHP Phone Line';
                                        _sub.serviceDetail = subscription.subAccountId;
                                        _sub.resolve = function (subItem) {
                                            return {
                                                goRHP: function () {
                                                    this.eclipseRemoteApi.goToRHPDashboard({
                                                        accountNumber: subItem.accountNumber,
                                                        subAccountId: subItem.subAccountId,
                                                        subscriptionId: subItem.subNumber,
                                                        source: 'rogers.com'
                                                    }, {
                                                        lang: this.languageSwitcher.getCurrentLanguage(),
                                                        userType: this.userService.getUserType(),
                                                        province: this.$cookieStore.get('province').toLowerCase() // pull from usersService
                                                    });
                                                }
                                            };
                                        };
                                    }
                                    if (subscription.subType === 'CTN') {
                                        _sub.subType = 'CTN';
                                        _sub.serviceType = isPrepaid ? 'service_wireless_prepaid' : 'service_wireless';
                                        _sub.icon = 'rui-icon-wireless';
                                        _sub.linkText = '_manage';
                                        _sub.linkURL = isPrepaid ? 'wirelessPrepaid' : 'wireless';
                                        _sub.paramName = 'phoneNumber';
                                        _sub.serviceName = isPrepaid ? 'wirelessPrepaid' : 'wireless';
                                        _sub.firstName = subscription.firstname || '';
                                        _sub.lastName = subscription.lastname || '';
                                        _sub.menuFirstName = _this.cleanFirstName(subscription.firstname);
                                        _sub.firstNameLength = _sub.firstName.length;
                                        _sub.isCTN = true;
                                        _sub.sortOrder = 1;
                                        _sub.subStatus = subscription.subStatus;
                                        /*Check for share Everything CTN*/
                                        if (_this.dataManagerService.getBRT()) {
                                            if (subscription.shareEverything) {
                                                if (subscription.shareEverything.isSharingData) {
                                                    _sub.serviceName = 'shareEverything';
                                                }
                                            }
                                        }
                                    }
                                    if (subscription.subType === 'Hi-Speed Internet') {
                                        _sub.subType = 'Hi-Speed Internet';
                                        _sub.serviceType = 'service_internet';
                                        _sub.icon = 'rui-icon-internet';
                                        _sub.linkText = '_manage';
                                        _sub.linkURL = 'internetdash';
                                        _sub.serviceDetail = subscription.subAccountId;
                                        _sub.paramName = 'accountNumber';
                                        _sub.serviceName = 'internetdash';
                                        _sub.isCTN = false;
                                        _sub.sortOrder = 6;
                                        _sub.serviceAddress = serviceAddress.toLowerCase();
                                    }
                                    if (subscription.subType === 'Digital TV') {
                                        _sub.subType = 'Digital TV';
                                        _sub.serviceType = 'service_tv';
                                        _sub.icon = 'rui-icon-tv';
                                        _sub.linkText = '_manage';
                                        _sub.linkURL = 'tvdashboard';
                                        _sub.serviceDetail = subscription.subAccountId;
                                        _sub.paramName = 'accountNumber';
                                        _sub.serviceName = 'tvdashboard';
                                        _sub.isCTN = false;
                                        _sub.sortOrder = 5;
                                        _sub.serviceAddress = serviceAddress.toLowerCase();
                                    }
                                    if (subscription.subType === 'Rogers Smart Home Monitoring') {
                                        // _sub.serviceDetail = $translate.instant('myaccoverview_home_monotoring');
                                        _sub.subType = 'Rogers Smart Home Monitoring';
                                        _sub.serviceType = 'myaccoverview_home_monotoring';
                                        _sub.icon = 'rui-icon-home-security';
                                        _sub.linkText = '_manage';
                                        _sub.linkURL = 'shmdashboard';
                                        //_sub.serviceDetail = subscription.subAccountId;
                                        _sub.serviceDetail = subscription.serviceNumber;
                                        _sub.paramName = 'accountNumber';
                                        _sub.serviceName = 'shmdashboard';
                                        _sub.disabled = disablePermissionNotGranted[3];
                                        _sub.isCTN = false;
                                        _sub.sortOrder = 8;
                                        _sub.hide = _sub.disabled || subscription.subStatus === 'Suspended';
                                    }
                                    if (subscription.subType === 'RHPc') {
                                        _sub.subType = 'RHPc';
                                        _sub.serviceType = 'service_phone';
                                        _sub.icon = 'rui-icon-home-phone';
                                        _sub.linkText = '_manage';
                                        _sub.linkURL = 'rhpdashboard';
                                        _sub.accountNumber = '';
                                        _sub.serviceName = 'homephone';
                                        _sub.isCTN = false;
                                        _sub.sortOrder = 7;
                                    }
                                    if (subscription.subStatus === 'Suspended') {
                                        _sub.serviceName = 'suspended';
                                        _sub.isCTN = false;
                                        _sub.sortOrder = 9;
                                    }
                                    myServicesList.push(_.cloneDeep(_sub));
                                }
                                if (_details.isCreditCardHolder) {
                                    var bankLink = 'https://rbaccess.rogersbank.com/Rogers_Consumer/ChangeLanguage.do?localeID=';
                                    var creditCardService = {
                                        subType: 'Rogers Bank',
                                        serviceType: 'rogers_credit_card',
                                        serviceName: bankLink,
                                        serviceDetail: 'getRogersBankLang',
                                        imageIcon: 'rogers-bank'
                                    };
                                    myServicesList.push(creditCardService);
                                }
                                return {
                                    myServices: myServicesList
                                };
                            });
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$cookieStore',
                            'ute.rogers.eclipse.remote.api.service'
                        ];
                    }
                    OneViewSubmenuServiceProvider.$inject = [];
                    return OneViewSubmenuServiceProvider;
                }());
                angular.module('ute.common.oneview.header').provider('ute.oneview.submenu.service', OneViewSubmenuServiceProvider);
            })(header = oneview.header || (oneview.header = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
                var OneviewInteractionNotesController = (function () {
                    /* @ngInject */
                    function OneviewInteractionNotesController(oneviewInteractionNotesService, userService, accountOverviewFactory) {
                        var _this = this;
                        this.oneviewInteractionNotesService = oneviewInteractionNotesService;
                        this.userService = userService;
                        this.updateSuccessful = false;
                        this.saveNotesSuccessful = '';
                        /**
                         * @param accountOverview
                         * @returns {null}
                         */
                        this.accountOverviewDataHandler = function (accountOverview) {
                            if (accountOverview) {
                                _this.oneviewInteractionNotesService.getNotes(String(accountOverview.getSelectedAccount().accountNumber))
                                    .then(function (result) {
                                    _this.callInProgress = false;
                                    _this.model = _this.oneviewInteractionNotesService.getModel();
                                    if (result.notes === '') {
                                        _this.disableTextArea = true;
                                        _this.displaySaveNoteButton = false;
                                    }
                                    else if (result.notes === 'error') {
                                        _this.isAPIError = true;
                                        _this.errorMessageKey = 'getNoteErrorMessage';
                                    }
                                })
                                    .catch(function (error) {
                                    _this.callInProgress = false;
                                    _this.isAPIError = true;
                                    _this.errorMessageKey = 'getNoteErrorMessage';
                                });
                            }
                            else {
                            }
                            return null;
                        };
                        this.getAccountOverview = function () {
                            return _this.accountOverviewService.getAccountOverview()
                                .then(_this.accountOverviewDataHandler)
                                .catch(function (reason) {
                                console.log('RogersSecondLevelNavigationController->getAccountOverview->catch:', reason);
                                return null;
                            });
                        };
                        this.accountOverviewService = accountOverviewFactory();
                        this.model = this.oneviewInteractionNotesService.getModel();
                        this.displayNotePad = false;
                        this.displaySaveNoteButton = true;
                        this.disableTextArea = false;
                        this.saveNotesSuccessful = '';
                        this.isAPIError = false;
                        this.userType = this.userService.getUserType();
                        if (this.userType === 'dealer') {
                            this.accountOverviewService.registerOnDataChangeHandler(this.accountOverviewDataHandler, OneviewInteractionNotesController.controllerName);
                        }
                        else if (this.userType === 'care') {
                            this.oneviewInteractionNotesService.setUserType(this.userType);
                        }
                    }
                    OneviewInteractionNotesController.prototype.openNotepad = function () {
                        var _this = this;
                        this.displayNotePad = !this.displayNotePad;
                        if (this.displayNotePad) {
                            this.model = this.oneviewInteractionNotesService.getModel();
                            this.callInProgress = true;
                            this.disableTextArea = false;
                            this.isAPIError = false;
                            this.displaySaveNoteButton = true;
                            if (this.userType === 'dealer') {
                                this.getAccountOverview();
                            }
                            else {
                                this.oneviewInteractionNotesService.setUserType(this.userType);
                                this.oneviewInteractionNotesService.getNotes('')
                                    .then(function (result) {
                                    _this.callInProgress = false;
                                    _this.model = _this.oneviewInteractionNotesService.getModel();
                                    if (result.notes === '') {
                                    }
                                    else if (result.notes === 'error') {
                                        _this.isAPIError = true;
                                        _this.errorMessageKey = 'getNoteErrorMessage';
                                    }
                                })
                                    .catch(function (error) {
                                    _this.isAPIError = true;
                                    _this.errorMessageKey = 'getNoteErrorMessage';
                                    _this.callInProgress = false;
                                });
                            }
                        }
                        else {
                            if (this.oneviewInteractionNotesService.getInteractionNotepadContent() !==
                                this.model.interactionNotepadContent) {
                                this.saveNotes();
                            }
                            this.isAPIError = false;
                        }
                    };
                    OneviewInteractionNotesController.prototype.saveNotes = function () {
                        var _this = this;
                        this.callInProgress = true;
                        this.isAPIError = false;
                        this.oneviewInteractionNotesService.setInteractionNotepadContent(this.model.interactionNotepadContent);
                        this.oneviewInteractionNotesService.saveNotes()
                            .then(function (result) {
                            console.log('oneviewInteractionNotesService saveNotes()', result);
                            _this.disableTextArea = true;
                            _this.displaySaveNoteButton = false;
                            _this.callInProgress = false;
                            if (result.notes === 'error') {
                                _this.isAPIError = true;
                                _this.errorMessageKey = 'saveNoteErrorMessage';
                            }
                        })
                            .catch(function (error) {
                            console.log('oneviewInteractionNotesService has error');
                            _this.isAPIError = true;
                            _this.errorMessageKey = 'saveNoteErrorMessage';
                            _this.callInProgress = false;
                        });
                    };
                    OneviewInteractionNotesController.prototype.editNotes = function () {
                        this.disableTextArea = false;
                        this.displaySaveNoteButton = true;
                    };
                    OneviewInteractionNotesController.controllerName = 'ute.oneview.interaction.notes.controller';
                    OneviewInteractionNotesController.$inject = ['ute.oneview.interaction.notes.service',
                        'ute.common.user.service',
                        'ute.rogers.account.overview.factory',
                    ];
                    return OneviewInteractionNotesController;
                }());
                notes.OneviewInteractionNotesController = OneviewInteractionNotesController;
                angular.module('ute.oneview.interaction.notes').controller('ute.oneview.interaction.notes.directive.controller', OneviewInteractionNotesController);
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
                /*interface IOneviewInteractionNotesAttrib {
                  accountNumber: string;
                }
              
                interface IOneviewInteractionNotesScope extends ng.IScope {
                  accountNumber: number;
                } */
                var OneviewInteractionNotes = (function () {
                    /* @ngInject */
                    function OneviewInteractionNotes(oneviewInteractionNotesService) {
                        this.oneviewInteractionNotesService = oneviewInteractionNotesService;
                        this.restrict = 'E';
                        this.templateUrl = this.oneviewInteractionNotesService.getConfig().advanced.oneviewInteractionNotesDirective.templateUrl;
                        this.controller = this.oneviewInteractionNotesService.getConfig().advanced.oneviewInteractionNotesDirective.controllerName;
                        this.controllerAs = 'oneviewInteractionNotes';
                        // this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.oneview.interaction.notes.IOneviewInteractionNotesService): ute.oneview.interaction.notes.OneviewInteractionNotes}
                     */
                    OneviewInteractionNotes.factory = function () {
                        var directive = function (oneviewInteractionNotesService) { return new OneviewInteractionNotes(oneviewInteractionNotesService); };
                        directive.$inject = ['ute.oneview.interaction.notes.service'];
                        return directive;
                    };
                    return OneviewInteractionNotes;
                }());
                angular.module('ute.oneview.interaction.notes').directive('uteOneviewInteractionNotes', OneviewInteractionNotes.factory());
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var oneview;
    (function (oneview) {
        var interaction;
        (function (interaction) {
            var notes;
            (function (notes) {
                'use strict';
                /**
                 * Private interface
                 */
                var OneviewInteractionNotesProvider = (function () {
                    /* @ngInject */
                    function OneviewInteractionNotesProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                medium: 'WEB',
                                updateNotesApiUrl: 'v1/updateInteractionNotes',
                                getNotesApiUrl: 'v1/retrieveInteractionNotes'
                            },
                            advanced: {
                                oneviewInteractionNotesDirective: {
                                    templateUrl: 'module/oneviewInteractionNotesDirective/oneviewInteractionNotes.directive.view.html',
                                    controllerName: 'ute.oneview.interaction.notes.directive.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http, sessionStorage) {
                            _this.$http = $http;
                            _this.$injector = $injector;
                            _this.sessionStorage = sessionStorage;
                            _this.securityService = $injector.get('ute.common.security.service');
                            return {
                                getConfig: _this.getConfig,
                                getModel: _this.getModel,
                                setAccountNumber: _this.setAccountNumber,
                                getAccountNumber: _this.getAccountNumber,
                                setInteractionNotepadContent: _this.setInteractionNotepadContent,
                                getInteractionNotepadContent: _this.getInteractionNotepadContent,
                                saveNotes: _this.saveNotes,
                                getNotes: _this.getNotes,
                                setUserType: _this.setUserType
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            if (_this.config.basic.medium.length === 0) {
                                console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                return false;
                            }
                            return true;
                        };
                        /**
                         * @returns {IPromise<ISubmitResult>}
                         */
                        this.saveNotes = function () {
                            var request = {
                                applicationId: _this.getConfig().basic.applicationId,
                                accountNumber: _this.model.accountNumber,
                                notes: _this.model.interactionNotepadContent,
                                medium: _this.getConfig().basic.medium
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.updateNotesApiUrl), request)
                                .then(_this.processSaveNotesResponseOk)
                                .catch(_this.processSaveNotesResponseError)
                                .finally(_this.processSaveNotesResponseFinal);
                        };
                        /**
                         * @returns {IPromise<ISubmitResult>}
                         */
                        this.getNotes = function (accountNumber) {
                            if (accountNumber === '' && _this.model.userType === 'care') {
                                _this.accountNumber = _this.sessionStorage.getSessionStorageValue('accountNumber');
                            }
                            else {
                                _this.accountNumber = accountNumber;
                            }
                            _this.setAccountNumber(_this.accountNumber);
                            var request = {
                                applicationId: _this.getConfig().basic.applicationId,
                                accountNumber: _this.accountNumber,
                                medium: _this.getConfig().basic.medium
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.getNotesApiUrl), request)
                                .then(_this.processGetNotesResponseOk)
                                .catch(_this.processGetNotesResponseError)
                                .finally(_this.processGetNotesResponseFinal);
                        };
                        /**
                         * @param response
                         * @returns {boolean}
                         */
                        this.processGetNotesResponseOk = function (response) {
                            if (_.has(response.data, 'notes') && response.data.status === 'success') {
                                _this.setInteractionNotepadContent(response.data.notes);
                                if (response.data.notes === '') {
                                }
                                return { result: true, notes: response.data.notes };
                            }
                            else {
                                return { result: false, notes: 'error' };
                            }
                        };
                        this.processGetNotesResponseError = function (reason) {
                            return { result: false, notes: 'error' };
                        };
                        this.processGetNotesResponseFinal = function () {
                            return true;
                        };
                        /**
                         * @param response
                         * @returns {boolean}
                         */
                        this.processSaveNotesResponseOk = function (response) {
                            if (_.has(response.data, 'status') && response.data.status === 'success') {
                                return { result: true, notes: '' };
                            }
                            else {
                                return { result: false, notes: 'error' };
                            }
                        };
                        this.processSaveNotesResponseError = function (reason) {
                            return { result: false, notes: 'error' };
                        };
                        this.processSaveNotesResponseFinal = function () {
                            return true;
                        };
                        /**
                         * Get Interaction Notepad Content from the model
                         * @returns {string}
                         */
                        this.getInteractionNotepadContent = function () {
                            return _this.model.interactionNotepadContent;
                        };
                        /**
                         * Get Account number from the model
                         * @returns {number}
                         */
                        this.getAccountNumber = function () {
                            return _this.model.accountNumber;
                        };
                        /**
                         * get the config setting
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * Return immutable IOneviewInteractionNotesModel object
                         * @returns {IOneviewInteractionNotesModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /**
                         * @param accountNumber - set account number
                         */
                        this.setAccountNumber = function (accountNumber) {
                            _this.model.accountNumber = accountNumber;
                        };
                        /**
                         * @param interactionNotepadContent - set interaction notepad content
                         */
                        this.setInteractionNotepadContent = function (interactionNotepadContent) {
                            _this.model.interactionNotepadContent = interactionNotepadContent;
                        };
                        this.setUserType = function (userType) {
                            _this.model.userType = userType;
                        };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                accountNumber: null,
                                interactionNotepadContent: null // may be from local store?
                            };
                        };
                        this.$get.$inject = ['$injector', '$http', 'sessionStorage'];
                        this.resetModel();
                    }
                    OneviewInteractionNotesProvider.$inject = [];
                    OneviewInteractionNotesProvider.serviceName = 'ute.oneview.interaction.notes.service';
                    return OneviewInteractionNotesProvider;
                }());
                angular.module('ute.oneview.interaction.notes').provider(OneviewInteractionNotesProvider.serviceName, OneviewInteractionNotesProvider);
            })(notes = interaction.notes || (interaction.notes = {}));
        })(interaction = oneview.interaction || (oneview.interaction = {}));
    })(oneview = ute.oneview || (ute.oneview = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var formChequing;
            (function (formChequing) {
                'use strict';
                var FormChequingController = (function () {
                    function FormChequingController($element, userService, $translate, languageSwitcher) {
                        this.$element = $element;
                        this.userService = userService;
                        this.$translate = $translate;
                        this.languageSwitcher = languageSwitcher;
                        this.accountFocused = false;
                        this.bankFocused = false;
                        this.transitFocused = false;
                        this.chequingObj = {
                            transitNo: null,
                            bankCode: null,
                            accountNo: null
                        };
                        this.isAccepted = false;
                        this.isCare = userService.getUser().userType === (ute.common.user.UserType.care || ute.common.user.UserType.careRep);
                        this.isDealer = userService.getUser().userType === ute.common.user.UserType.dealer;
                        this.isPaymentUpdating = false;
                        this.tandcText = this.getTandCText();
                        this.STEP = ute.payment.method.modal.STEPS;
                        this.selectedField = 'blank';
                        this.lang = languageSwitcher.getCurrentLanguage();
                    }
                    FormChequingController.prototype.getTandCText = function () {
                        return this.$translate.instant('ute.payment.method.change_method_terms');
                    };
                    FormChequingController.prototype.setHinting = function (imgSrc) {
                        //$(this.$element).find('.img-cheque #overlay').attr('src', imgSrc);
                    };
                    FormChequingController.prototype.cancel = function (event) {
                        this.mopObj.$modalInstance.dismiss();
                    };
                    FormChequingController.prototype.selectFormField = function (index) {
                        this.selectedField = formChequing.BankFormField[index];
                    };
                    FormChequingController.prototype.log = function (obj) {
                        console.log(obj);
                    };
                    FormChequingController.prototype.continue = function () {
                        this.currentStep = ute.payment.method.modal.STEPS.REVIEW;
                    };
                    FormChequingController.prototype.update = function (event) {
                        if (this.debitForm.$valid && !this.debitForm.$invalid) {
                            this.isPaymentUpdating = true;
                            this.submitForm();
                        }
                        else {
                            this.debitForm.$setSubmitted();
                        }
                    };
                    FormChequingController.prototype.getBankImage = function () {
                        return 'ute-payment-method/assets/cheque-' + this.selectedField + '-' + this.lang + '.png';
                    };
                    FormChequingController.$inject = [
                        '$element',
                        'ute.common.user.service',
                        '$translate',
                        'ute.blocks.language.switcher'
                    ];
                    return FormChequingController;
                }());
                angular.module('ute.payment.method').controller('ute.payment.method.formChequing.controller', FormChequingController);
            })(formChequing = method.formChequing || (method.formChequing = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var formChequing;
            (function (formChequing) {
                'use strict';
                var FormChequing = (function () {
                    function FormChequing() {
                        this.controller = 'ute.payment.method.formChequing.controller';
                        this.controllerAs = 'formChequing';
                        this.bindToController = true;
                        this.scope = {
                            chequingObj: '=',
                            showDebitForm: '=',
                            mopObj: '=',
                            dtmName: '=',
                            debitForm: '=',
                            submitForm: '&',
                            currentStep: '='
                        };
                        this.linkFn = function (scope, element, attrs, controller) {
                            element = element;
                        };
                        this.link = this.linkFn;
                        this.templateUrl = function (elem, attrs) { return attrs.templateUrl; };
                    }
                    FormChequing.factory = function () {
                        var directive = function () { return new FormChequing(); };
                        return directive;
                    };
                    ;
                    return FormChequing;
                }());
                angular.module('ute.payment.method').directive('uteFormChequing', FormChequing.factory());
            })(formChequing = method.formChequing || (method.formChequing = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

/**
 * Created by Vikash Singh on 05/07/17.
 */
var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('ute.payment.method').config(configureDataLayer);
                configureDataLayer.$inject = ['ute.datalayer.common.serviceProvider'];
                function configureDataLayer(dataLayerCommonServiceProvider) {
                    var paymentMethodName = 'change payment method';
                    var hierarchy = ['myrogers', 'payment method'];
                    var selfServe = {
                        name: paymentMethodName,
                        type: 'transaction'
                    };
                    var config = {
                        advance: {
                            mappingKey: {
                                paymentMethod: {
                                    start: {
                                        page: {
                                            name: 'select payment',
                                            hierarchy: hierarchy
                                        },
                                        selfServe: selfServe,
                                        events: {
                                            selfServeStart: true
                                        }
                                    },
                                    review: {
                                        page: {
                                            name: 'review',
                                            hierarchy: hierarchy
                                        },
                                        selfServe: selfServe
                                    },
                                    termsAndCondition: {
                                        page: {
                                            name: 'terms & conditions',
                                            hierarchy: hierarchy
                                        },
                                        selfServe: selfServe
                                    },
                                    complete: {
                                        page: {
                                            name: 'confirmation',
                                            hierarchy: hierarchy
                                        },
                                        selfServe: selfServe,
                                        events: {
                                            selfServeComplete: true
                                        }
                                    },
                                    errorDebit: {
                                        page: {
                                            name: 'terms & conditions',
                                            hierarchy: hierarchy
                                        }
                                    },
                                    errorCredit: {
                                        page: {
                                            name: 'select payment',
                                            hierarchy: hierarchy
                                        }
                                    },
                                    error_api: {
                                        page: {
                                            name: 'error',
                                            hierarchy: hierarchy
                                        }
                                    },
                                    errorCategory: {
                                        category: 'SELF_SERVE'
                                    },
                                    paymentMethod: {
                                        manual: 'manual payment',
                                        visa: 'credit/debit VISA',
                                        mastercard: 'credit/debit MASTERCARD',
                                        amex: 'credit/debit AMERICANEXPRESS',
                                        bank: 'bank account'
                                    },
                                    /*,
                                    updatePaymentMethodCard: {
                                      name: 'update auto pay credit',
                                      type: 'transaction'
                                    },
                                    updatePaymentMethodBank: {
                                      name: 'update auto pay bank',
                                      type: 'transaction'
                                    },*/
                                    changePaymentMethodAPI: paymentMethodName
                                }
                            }
                        }
                    };
                    dataLayerCommonServiceProvider.configure(config);
                }
            })(integration = method.integration || (method.integration = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            'use strict';
            var PaymentMethodType = ute.rogers.account.overview.billing.detail.PaymentMethodType;
            var PaymentMethodController = (function () {
                function PaymentMethodController($scope, $modal, billingDetailFactory, languageService, userService, permissionsService, browserService, $rootScope, $window, ptpService, paymentMethodService) {
                    var _this = this;
                    this.$scope = $scope;
                    this.$modal = $modal;
                    this.billingDetailFactory = billingDetailFactory;
                    this.languageService = languageService;
                    this.userService = userService;
                    this.permissionsService = permissionsService;
                    this.browserService = browserService;
                    this.$rootScope = $rootScope;
                    this.$window = $window;
                    this.ptpService = ptpService;
                    this.paymentMethodService = paymentMethodService;
                    this.billingDetailCallbackKey = 'utePaymentMethodBillDetailSubscriber' + this.$scope.$id;
                    this.isPaymentMethodChanging = false;
                    this.isPaymentMethodLoading = true;
                    this.isMethodOfPaymentUnavailable = false;
                    this.accountPreferenceLinkText = '';
                    this.rs = this.$rootScope;
                    this.canChangePayment = true;
                    this.ptpReadPermissionAccess = false;
                    this.aoChangePayment = function () {
                        if (_this.methodOfPaymentData.mopType === PaymentMethodType.R) {
                            _this.onSetupAutoPayment(null);
                        }
                        else {
                            _this.onChangePayment(null);
                        }
                    };
                    this.billingDetailsubscriber = function (billingDetail, refresh) {
                        _this.billingDetail = billingDetail;
                        _this.methodOfPaymentData = _.get(billingDetail, 'methodOfPayment', { mopType: PaymentMethodType.U });
                        if (_this.methodOfPaymentData.mopType === PaymentMethodType.R) {
                            _this.accountPreferenceLinkText = 'ute.payment.method.setup_automatic_payment_link';
                        }
                        else {
                            _this.accountPreferenceLinkText = 'ute.payment.method.ap_change_pm_link';
                        }
                        if (refresh && _this.paymentMethodChangedCallback && typeof _this.paymentMethodChangedCallback === 'function') {
                            try {
                                _this.paymentMethodChangedCallback({ method: _.get(_this.methodOfPaymentData, 'mopType', PaymentMethodType.U) });
                            }
                            catch (e) {
                                console.log(e);
                            }
                        }
                        _this.checkCCDateValidity();
                        _this.billingDetailPromiseFinal();
                    };
                    this.billingDetailPromiseFinal = function () {
                        if (_this.methodOfPaymentData.mopType === PaymentMethodType.U) {
                            _this.isMethodOfPaymentUnavailable = true;
                        }
                        else {
                            _this.selectedPaymentMethod = _this.currentPaymentMethod = _.find(_this.paymentMethods, { paymentMethodType: _this.methodOfPaymentData.mopType });
                        }
                        _this.currentPaymentMethodType = _this.methodOfPaymentData.mopType;
                        if (_this.currentPaymentMethodType === PaymentMethodType.C) {
                            _this.creditCardDetail = _this.getCreditCardDetails();
                            _this.creditCardImage = _this.paymentMethodService.getCreditCardImage(_this.creditCardDetail.type);
                        }
                        if (_this.currentPaymentMethodType === PaymentMethodType.D) {
                            _this.chequingAccountNumber = _this.getChequingAccountNumber();
                        }
                        _this.isSGI = (_this.selectedAccount.accountType === 6);
                        _this.isPaymentMethodLoading = false;
                    };
                    this.subscribeBillingDetail = function (payload, refresh) {
                        if (_this.billingDetailFactoryRef) {
                            _this.billingDetailFactoryRef.unregisterOnDataChangeHandler(_this.billingDetailCallbackKey);
                        }
                        _this.billingDetailFactoryRef = _this.billingDetailFactory(payload);
                        _this.billingDetailFactoryRef.registerOnDataChangeHandler(function (billingDetail) {
                            _this.billingDetailsubscriber(billingDetail, refresh);
                        }, _this.billingDetailCallbackKey);
                        _this.billingDetailFactoryRef.getBillingDetail(refresh)
                            .then(function (billigDetail) {
                            _this.billingDetailsubscriber(billigDetail);
                        })
                            .catch(function (e) {
                            _this.methodOfPaymentData = { mopType: PaymentMethodType.U };
                            _this.billingDetailPromiseFinal();
                        });
                    };
                    this.showCreditPaymentMethodInformation = function () { return _this.methodOfPaymentData != null && _this.methodOfPaymentData.mopType === PaymentMethodType.C; };
                    this.showDebitPaymentMethodInformation = function () { return _this.methodOfPaymentData != null && _this.methodOfPaymentData.mopType === PaymentMethodType.D; };
                    this.showInvoicePaymentMethodInformation = function () { return _this.methodOfPaymentData != null && _this.methodOfPaymentData.mopType === PaymentMethodType.R; };
                    this.getPaymentMethods = function () {
                        return _this.userService.isConsumer() ? _this.paymentMethods : [_this.paymentMethods[0], _this.paymentMethods[2]];
                    };
                    this.init();
                }
                /**
                 * Sets payment method change flag to true
                 */
                PaymentMethodController.prototype.onChangePayment = function (event) {
                    if (event) {
                        event.preventDefault();
                    }
                    if (this.userService.isConsumer()) {
                        this.changePaymentMethod(false);
                    }
                    else {
                        this.isPaymentMethodChanging = true;
                    }
                };
                /**
                 * new flow for setting auto payment to either card or bank account
                 */
                PaymentMethodController.prototype.onSetupAutoPayment = function (event) {
                    if (event) {
                        event.preventDefault();
                    }
                    if (this.userService.isConsumer()) {
                        this.changePaymentMethod(false);
                    }
                    else {
                        this.isPaymentMethodChanging = true;
                    }
                };
                /**
                 * Sets payment method change flag to false
                 */
                PaymentMethodController.prototype.onPaymentCancel = function (event) {
                    event.preventDefault();
                    this.selectedPaymentMethod = this.currentPaymentMethod;
                    this.isPaymentMethodChanging = false;
                };
                /**
                 * Called when user selects new payment method from the select box
                 */
                PaymentMethodController.prototype.paymentMethodChanged = function () {
                    this.changePaymentMethod(false);
                };
                PaymentMethodController.prototype.selectMethodOfPayment = function (mop) {
                    if (mop.paymentMethodType !== PaymentMethodType.U &&
                        this.currentPaymentMethodType !== mop.paymentMethodType) {
                        this.selectedPaymentMethod = mop;
                        if (this.isCare || this.isDealer) {
                            if (mop.paymentMethodType === PaymentMethodType.C) {
                                this.changePaymentMethod(true);
                            }
                            else {
                                this.paymentMethodChanged();
                            }
                        }
                        else {
                            this.paymentMethodChanged();
                        }
                    }
                };
                PaymentMethodController.prototype.changeToAutomaticPayment = function (methodType) {
                    if (this.canChangePayment) {
                        if (methodType) {
                            this.selectedPaymentMethod = _.find(this.paymentMethods, { paymentMethodType: PaymentMethodType.C });
                            this.changePaymentMethod(true);
                        }
                        else {
                            this.selectedPaymentMethod = _.find(this.paymentMethods, { paymentMethodType: PaymentMethodType.R });
                            this.paymentMethodChanged();
                        }
                    }
                };
                PaymentMethodController.prototype.updatePaymentMethod = function () {
                    if (!(!this.userService.isConsumer() && this.currentPaymentMethod.paymentMethodType === PaymentMethodType.D)) {
                        this.changePaymentMethod(true);
                    }
                };
                /**
                 *  Called when selected account is changed on self serve
                 */
                PaymentMethodController.prototype.selectedAccountChanged = function () {
                    this.isMethodOfPaymentUnavailable = false;
                    this.getMethodOfPayment(false);
                };
                PaymentMethodController.prototype.isOneView = function () {
                    return (this.userService.isCare() || this.userService.isDealer());
                };
                PaymentMethodController.prototype.getMethodOfPayment = function (refresh) {
                    if (this.selectedAccount && this.canChangePayment) {
                        this.isPaymentMethodLoading = true;
                        this.isPaymentMethodChanging = false;
                        this.chequingAccountNumber = '';
                        this.creditCardDetail = {};
                        this.isCCExpiring = this.isCCExpired = false;
                        this.subscribeBillingDetail({
                            accountNumber: this.selectedAccount.accountNumber,
                            accountTypeNumber: this.selectedAccount.accountType,
                            language: this.languageService.getCurrentLanguage(),
                            applicationId: 'Rogers.com',
                            refresh: false
                        }, refresh);
                    }
                };
                PaymentMethodController.prototype.checkCCDateValidity = function () {
                    this.isCCExpired = false;
                    this.isCCExpiring = false;
                    var ccExpiry = _.get(this.methodOfPaymentData, 'creditCardDetails.ccExpiry', '    ');
                    var ccExpiryYear = (new Date()).getFullYear().toString().slice(0, 2) + ccExpiry.slice(2, 4);
                    var ccExpiryMonth = ccExpiry.slice(0, 2);
                    var expiryDate = new Date(+ccExpiryYear, (+ccExpiryMonth - 1), 1);
                    var currentDate = new Date((new Date()).getFullYear(), (new Date).getMonth(), 1);
                    var cmpDate = this.compareDate(currentDate, expiryDate);
                    if (cmpDate === 0 || cmpDate === -1) {
                        this.isCCExpiring = true;
                    }
                    else if (cmpDate > 0) {
                        this.isCCExpired = true;
                    }
                };
                PaymentMethodController.prototype.openModalPopup = function (goToUrl) {
                    this.$modal.open({
                        templateUrl: 'module/paymentMethod/otherWaysToPayModal/otherWaysToPay.modal.view.html',
                        controller: 'ute.payment.method.otherwaysmodal.controller',
                        controllerAs: 'ctrl.otherway',
                        size: 'md',
                        backdrop: 'static',
                        backdropClass: 'bkg-modal'
                    });
                };
                PaymentMethodController.prototype.getLast4Digits = function () {
                    return _.get(this.methodOfPaymentData, 'creditCardDetails.ccNumber', '    ');
                };
                PaymentMethodController.prototype.getDaysToExpire = function () {
                    //https://stackoverflow.com/a/543152
                    var daysInMs = this.getFullExpiryDate() - new Date().setHours(0, 0, 0, 0);
                    return Math.round(daysInMs / (1000 * 60 * 60 * 24));
                };
                PaymentMethodController.prototype.getFullExpiryDate = function () {
                    var dateParts = this.creditCardDetail.expiry.split('/');
                    return new Date(parseInt(dateParts[1]), parseInt(dateParts[0]), 0);
                };
                PaymentMethodController.prototype.isAccountCancelled = function () {
                    return this.selectedAccount && this.selectedAccount.accountInfo && this.selectedAccount.accountInfo.status.toLowerCase() === 'cancelled';
                };
                PaymentMethodController.prototype.hasOutstandingBalance = function () {
                    return Number(this.billingDetail.balanceAmount) > 0;
                };
                PaymentMethodController.prototype.getPaymentMethodTitleKey = function () {
                    if (this.hasOutstandingBalance()) {
                        return 'ute.payment.method.will_auto_charge';
                    }
                    else {
                        return 'ute.payment.method.payment_method';
                    }
                };
                PaymentMethodController.prototype.goToPTP = function () {
                    this.ptpService.goToEntryState();
                };
                PaymentMethodController.prototype.compareDate = function (curDate, expDate) {
                    return curDate.getMonth() - expDate.getMonth()
                        + (12 * (curDate.getFullYear() - expDate.getFullYear()));
                };
                /**
                 * Open Payment Method Modal based on Payment Method Type
                 */
                PaymentMethodController.prototype.changePaymentMethod = function (_isPaymentMethodUpdating) {
                    this.$window.open('/consumer/self-serve/payments/auto', '_self');
                };
                PaymentMethodController.prototype.init = function () {
                    var _this = this;
                    this.paymentMethods = [
                        {
                            paymentMethodType: PaymentMethodType.C,
                            translationId: 'ute.payment.method.CREDIT',
                            type: 'CREDIT'
                        },
                        {
                            paymentMethodType: PaymentMethodType.D,
                            translationId: 'ute.payment.method.DEBIT',
                            type: 'DEBIT'
                        },
                        {
                            paymentMethodType: PaymentMethodType.R,
                            translationId: 'ute.payment.method.INVOICE',
                            type: 'INVOICE'
                        }
                    ];
                    this.PaymentMethodType = PaymentMethodType;
                    this.selectedPaymentMethod = {
                        paymentMethodType: PaymentMethodType.U
                    };
                    this.isCCExpired = false;
                    this.isCCExpiring = false;
                    this.desktopView = window.innerWidth >= 768;
                    this.isCare = this.userService.isCare();
                    this.isDealer = this.userService.isDealer();
                    if (this.isCare || this.isDealer) {
                        this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangePaymentMethod, ute.common.permissions.service.RamActionCodes.start)
                            .then(function (agentPermission) {
                            _this.canChangePayment = agentPermission;
                            _this.canChangePayment = true;
                        });
                    }
                    if (this.isCare) {
                        this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PromiseToPay, ute.common.permissions.service.RamActionCodes.read)
                            .then(function (repPermission) {
                            _this.ptpReadPermissionAccess = repPermission;
                        });
                    }
                    this.windowTemplate = '';
                    this.templateUrl = '';
                    this.getMethodOfPayment(false);
                    if (this.browserService.isAndroid()) {
                        this.showAppLink = 'ute.payment.method.android_app_link';
                    }
                    else if (this.browserService.isIOS()) {
                        this.showAppLink = 'ute.payment.method.ios_app_link';
                    }
                    else {
                        this.showAppLink = 'ute.payment.method.rogers_app';
                    }
                    this.$scope.$on('$destroy', function () {
                        if (_this.billingDetailFactoryRef) {
                            _this.billingDetailFactoryRef.unregisterOnDataChangeHandler(_this.billingDetailCallbackKey);
                        }
                    });
                };
                PaymentMethodController.prototype.getCreditCardDetails = function () {
                    if (this.methodOfPaymentData.mopType === PaymentMethodType.C) {
                        var ccExpiry = _.get(this.methodOfPaymentData, 'creditCardDetails.ccExpiry', '    ');
                        return {
                            number: '•••• •••• •••• ' + _.get(this.methodOfPaymentData, 'creditCardDetails.ccNumber', '    '),
                            expiry: ccExpiry.slice(0, 2) + '/' + (new Date()).getFullYear().toString().slice(0, 2) + ccExpiry.slice(2),
                            type: ute.rogers.account.overview.billing.detail.CreditCardType[String(_.get(this.methodOfPaymentData, 'creditCardDetails.ccType'))]
                        };
                    }
                };
                PaymentMethodController.prototype.getChequingAccountNumber = function () {
                    var accountNumber = _.get(this.methodOfPaymentData, 'chequingDetails.accountNumber', '');
                    return accountNumber.slice(0, 1) + ' ••• •••• •••• • ' + accountNumber.slice(1);
                };
                PaymentMethodController.$inject = [
                    '$scope',
                    '$modal',
                    'ute.rogers.account.billing.detail.factory',
                    'ute.blocks.language.switcher',
                    'ute.common.user.service',
                    'ute.common.permissions.service',
                    'ute.common.core.browser.service',
                    '$rootScope',
                    '$window',
                    'ute.promise.to.pay.service',
                    'ute.payment.method.service'
                ];
                return PaymentMethodController;
            }());
            angular.module('ute.payment.method').controller('ute.payment.method.controller', PaymentMethodController);
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            'use strict';
            var PaymentMethod = (function () {
                function PaymentMethod() {
                    this.controller = 'ute.payment.method.controller';
                    this.controllerAs = 'paymentMethod';
                    this.bindToController = true;
                    this.scope = {
                        selectedAccount: '=',
                        paymentMethodChangedCallback: '&?',
                        oneViewViewBill: '@?'
                    };
                    this.templateUrl = function (elem, attr) {
                        if ('ovoPaymentWidgetCcInformation' in attr) {
                            return 'module/paymentMethod/templates/ovoPaymentWidget/paymentMethodCCInformation.html';
                        }
                        else if ('oneViewViewBill' in attr) {
                            return 'module/paymentMethod/templates/paymentMethodOneviewViewbill.html';
                        }
                        else if ('oneViewAccountBalance' in attr) {
                            return 'module/paymentMethod/templates/paymentMethodOneviewAccountBalance.html';
                        }
                        else if ('accountBalance' in attr) {
                            return 'module/paymentMethod/templates/paymentMethodAccountBalance.html';
                        }
                        else if ('viewBill' in attr) {
                            return 'module/paymentMethod/templates/paymentMethodAccountBalanceViewBill.html';
                        }
                        else if ('paymentTopBar' in attr) {
                            return 'module/paymentMethod/templates/paymentMethodPaymentTopBar.html';
                        }
                        else if ('accountPreferenceLink' in attr) {
                            return 'module/paymentMethod/templates/ap.link.html';
                        }
                        else {
                            return 'module/paymentMethod/templates/paymentMethod.html';
                        }
                    };
                    this.linkFn = function (scope, element, attrs, controller) {
                        scope.$watch('paymentMethod.selectedAccount.accountNumber', function (newAccount, oldAccount) {
                            if (String(newAccount) !== String(oldAccount)) {
                                controller.selectedAccountChanged();
                            }
                        });
                    };
                    this.link = this.linkFn;
                }
                PaymentMethod.factory = function () {
                    var directive = function () { return new PaymentMethod(); };
                    return directive;
                };
                ;
                return PaymentMethod;
            }());
            angular.module('ute.payment.method').directive('utePaymentMethod', PaymentMethod.factory());
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            'use strict';
            var PaymentMethodType = ute.rogers.account.overview.billing.detail.PaymentMethodType;
            var PaymentMethodService = (function () {
                function PaymentMethodService($modal, $q, $window, languageService, billingDetailFactory, permissionsService, userService) {
                    var _this = this;
                    this.$modal = $modal;
                    this.$q = $q;
                    this.$window = $window;
                    this.languageService = languageService;
                    this.billingDetailFactory = billingDetailFactory;
                    this.permissionsService = permissionsService;
                    this.userService = userService;
                    this.isCare = this.userService.isCare();
                    this.isDealer = this.userService.isDealer();
                    this.isConsumer = this.userService.isConsumer();
                    this.canChangePaymentMethod = true;
                    this.selectedPaymentMethod = {
                        paymentMethodType: PaymentMethodType.U
                    };
                    this.creditCardImages = {
                        VISA: {
                            name: 'VI',
                            dealerName: 'V',
                            image: 'ute-common-assets/assets/cards/visa-icon-1217.png',
                            desc: 'VISA'
                        },
                        MASTER: {
                            name: 'MC',
                            dealerName: 'M',
                            image: 'ute-common-assets/assets/cards/master.png',
                            desc: 'MASTERCARD'
                        },
                        AMEX: {
                            name: 'AM',
                            dealerName: 'A',
                            image: 'ute-common-assets/assets/cards/amex.png',
                            desc: 'AMERICANEXPRESS'
                        }
                    };
                    this.paymentMethods = [
                        {
                            paymentMethodType: PaymentMethodType.C,
                            translationId: 'ute.payment.method.CREDIT',
                            type: 'CREDIT'
                        },
                        {
                            paymentMethodType: PaymentMethodType.D,
                            translationId: 'ute.payment.method.DEBIT',
                            type: 'DEBIT'
                        },
                        {
                            paymentMethodType: PaymentMethodType.R,
                            translationId: 'ute.payment.method.INVOICE',
                            type: 'INVOICE'
                        }
                    ];
                    if (this.isCare || this.isDealer) {
                        this.canChangePaymentMethod = false;
                        this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.ChangePaymentMethod, ute.common.permissions.service.RamActionCodes.start)
                            .then(function () {
                            _this.canChangePaymentMethod = true;
                        });
                    }
                }
                PaymentMethodService.prototype.getCreditCardImage = function (type) {
                    return this.creditCardImages[type].image;
                };
                ;
                PaymentMethodService.prototype.setSelectedPaymentMethod = function (mopType) {
                    this.selectedPaymentMethod = _.find(this.paymentMethods, { paymentMethodType: PaymentMethodType[mopType] });
                };
                ;
                PaymentMethodService.prototype.getMethodOfPayment = function (refresh, accountNumber, accountType) {
                    var _this = this;
                    this.isPaymentMethodLoading = true;
                    return this.billingDetailFactory({
                        accountNumber: accountNumber,
                        accountTypeNumber: accountType,
                        language: this.languageService.getCurrentLanguage(),
                        applicationId: 'Rogers.com',
                        refresh: false
                    }).getBillingDetail(refresh)
                        .then(function (billingDetail) {
                        _this.billingDetail = billingDetail;
                        _this.methodOfPaymentData = _.get(billingDetail, 'methodOfPayment', { mopType: PaymentMethodType.U });
                        _this.isPaymentMethodLoading = false;
                        return _this.$q.when(_this.methodOfPaymentData);
                    })
                        .catch(function () {
                        _this.methodOfPaymentData = { mopType: PaymentMethodType.U };
                        return _this.$q.when(_this.methodOfPaymentData);
                    })
                        .finally(function () {
                        if (_this.methodOfPaymentData.mopType !== PaymentMethodType.U) {
                            _this.currentPaymentMethod = _.find(_this.paymentMethods, { paymentMethodType: _this.methodOfPaymentData.mopType });
                            if (_this.isConsumer) {
                                _this.selectedPaymentMethod = _this.currentPaymentMethod;
                            }
                        }
                    });
                };
                PaymentMethodService.prototype.openChangePaymentMethodModal = function (_isPaymentMethodUpdating, _selectedAccount) {
                    this.$window.open('/consumer/self-serve/payments/auto', '_self');
                    return this.$q.defer().promise;
                };
                PaymentMethodService.$inject = ['$modal',
                    '$q',
                    '$window',
                    'ute.blocks.language.switcher',
                    'ute.rogers.account.billing.detail.factory',
                    'ute.common.permissions.service',
                    'ute.common.user.service'];
                return PaymentMethodService;
            }());
            angular
                .module('ute.payment.method')
                .service('ute.payment.method.service', PaymentMethodService);
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var modal;
            (function (modal) {
                'use strict';
                var PaymentMethodType = ute.rogers.account.overview.billing.detail.PaymentMethodType;
                var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                var CreditCardType = ute.rogers.account.overview.billing.detail.CreditCardType;
                var ErrorCategory = ute.datalayer.common.service.ErrorCategory;
                var ErrorType = ute.datalayer.common.service.ErrorType;
                var MOPOverlayController = (function () {
                    function MOPOverlayController($modal, $modalInstance, languageSwitcher, userService, paymentService, permissionsService, overlayModel, $translate, dataLayerService, $timeout, paymentMethodService) {
                        var _this = this;
                        this.$modal = $modal;
                        this.$modalInstance = $modalInstance;
                        this.languageSwitcher = languageSwitcher;
                        this.userService = userService;
                        this.paymentService = paymentService;
                        this.permissionsService = permissionsService;
                        this.overlayModel = overlayModel;
                        this.$translate = $translate;
                        this.dataLayerService = dataLayerService;
                        this.$timeout = $timeout;
                        this.paymentMethodService = paymentMethodService;
                        this.dataLayerMappingKey = 'paymentMethod.errorCredit,errors:paymentMethod.errorCategory';
                        this.preAuthPaymentCreditMappingKey = 'preAuthPaymentMethod-credit,errors:paymentMethod.errorCategory';
                        this.billingDetail = {
                            balanceAmount: 0
                        };
                        this._expireYears = [];
                        this.dataLayerPredefinedSection = [DataLayerPredefinedSection.ACCOUNT,
                            DataLayerPredefinedSection.PAGE,
                            DataLayerPredefinedSection.PAGE_VIEW_EVENT,
                            DataLayerPredefinedSection.SITE];
                        this.processError = function (error) {
                            _this.step = modal.STEPS.FAILURE;
                            if (_this.overlayModel.isPaymentMethodUpdating && _this.isCredit) {
                                _this.updateCreditCardFailed = true;
                            }
                            var errorMessage = _this.$translate.instant('ute.payment.method.failure.' + _this.selectedPaymentMethod + '.header');
                            var errorCode = String(!!error ? (error.status === 555 ? error.backendCode || ute.payment.service.BackEndPaymentErrorCode.GENERIC_ERROR : error.status)
                                : ute.payment.service.BackEndPaymentErrorCode.STATUS_OK);
                            if (!_this.overlayModel.isPaymentMethodUpdating) {
                                _this.dataLayerService.trackError(_this.apiErrorPayload, !!error ? ErrorType.HTTP : ErrorType.CREDIT, errorCode, errorMessage, ErrorCategory[_this.dataLayerConfig.errorCategory.category], '', _this.dataLayerConfig.changePaymentMethodAPI, true, _this.dataLayerPredefinedSection);
                            }
                            _this.isPaymentMethodChanging = false;
                        };
                        this.init();
                    }
                    MOPOverlayController.prototype.edit = function () {
                        this.updateCreditCardFailed = false;
                        this.step = modal.STEPS.CHANGE_MOP;
                    };
                    MOPOverlayController.prototype.close = function () {
                        this.updateCreditCardFailed = false;
                        var message = this.step === modal.STEPS.SUCCESS || this.step === modal.STEPS.CONFIRMATION ? 'success' : '';
                        if (this.step !== modal.STEPS.CONFIRMATION && this.userService.isConsumer() && !this.overlayModel.isPaymentMethodUpdating && this.step !== modal.STEPS.NO_CHANGE_MADE) {
                            this.goToNoChangesMade();
                        }
                        else {
                            this.$modalInstance.close(message);
                        }
                    };
                    MOPOverlayController.prototype.cancel = function () {
                        this.updateCreditCardFailed = false;
                        var message = this.step === modal.STEPS.SUCCESS || this.step === modal.STEPS.CONFIRMATION ? 'success' : '';
                        if (this.step !== modal.STEPS.CONFIRMATION && this.userService.isConsumer() && !this.overlayModel.isPaymentMethodUpdating && this.step !== modal.STEPS.NO_CHANGE_MADE) {
                            this.goToNoChangesMade();
                        }
                        else {
                            this.$modalInstance.dismiss(message);
                        }
                    };
                    MOPOverlayController.prototype.submit = function (form, type) {
                        var _this = this;
                        if (form && form.$valid || !form) {
                            this.form = form;
                            if (type === PaymentMethodType.C) {
                                this.$timeout(function () {
                                    _this.creditCard.validateCard();
                                    if (_this.creditCard.creditCardNo) {
                                        _this.goToNextStep(type);
                                    }
                                    else {
                                        form.$setSubmitted();
                                    }
                                });
                            }
                            else {
                                this.goToNextStep(type);
                            }
                        }
                        else {
                            form.$setSubmitted();
                        }
                    };
                    MOPOverlayController.prototype.tryAgain = function () {
                        if (!this.firstAttempt) {
                            this.step = modal.STEPS.ACCOUNT;
                            this.firstAttempt = true;
                            this.resetStepManager();
                            this.selectedPaymentMethod = '';
                            this.trackPaymentMethod(this.step);
                        }
                    };
                    MOPOverlayController.prototype.showBalanceBanner = function () {
                        return (this.step === modal.STEPS.CONFIRMATION && this.overlayModel.billingDetail.balanceAmount > 0 && (this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.D] || this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.C]));
                    };
                    MOPOverlayController.prototype.debitNextStep = function (form) {
                        if (this.step === modal.STEPS.ACCOUNT) {
                            this.submit(form, PaymentMethodType.D);
                        }
                        else if (this.step === modal.STEPS.REVIEW) {
                            this.callServer();
                        }
                        else if (this.step === modal.STEPS.CONFIRMATION) {
                            this.close();
                        }
                    };
                    MOPOverlayController.prototype.creditNextStep = function () {
                        if (this.step === modal.STEPS.REVIEW) {
                            this.callServer();
                        }
                        else {
                            this.close();
                        }
                    };
                    MOPOverlayController.prototype.checkTermsAndSubmit = function (form) {
                        if (form && form.$valid && _.get(form, 'isAccepted.$valid', false) || !form) {
                            this.callServer();
                        }
                        else {
                            form.$setSubmitted();
                        }
                    };
                    MOPOverlayController.prototype.getMaskedBankAccount = function () {
                        return this.bankAccount.slice(0, 1) + ' ••• •••• •••• • ' + this.bankAccount.slice(-3);
                    };
                    MOPOverlayController.prototype.getCreditCardMaskedText = function () {
                        return this.creditCard.maskedCardNumber ? this.creditCard.maskedCardNumber.split('*').join('•') : '';
                    };
                    MOPOverlayController.prototype.callServer = function () {
                        var _this = this;
                        this.isPaymentMethodChanging = true;
                        if (this.userService.isConsumer() && !this.overlayModel.isPaymentMethodUpdating) {
                            this.step = modal.STEPS.MOP_IS_CHANGING;
                        }
                        var paymentMethodRequest = {
                            accountNumber: this.overlayModel.selectedAccount.billableAccountNumber || this.overlayModel.selectedAccount.accountNumber,
                            accountTypeNumber: this.overlayModel.selectedAccount.accountType,
                            mopType: this.selectedPaymentMethod,
                            subNumber: this.overlayModel.selectedAccount.accountNumber,
                            isConsolidated: this.overlayModel.selectedAccount.isConsolidated,
                            oldMopType: PaymentMethodType[String(this.overlayModel.oldPaymentMethod.paymentMethodType)],
                            contactId: _.get(this.overlayModel.selectedAccount, 'contactInfo.contactId', '')
                        };
                        if (this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.C]) {
                            paymentMethodRequest.cardDetails = {
                                cardNumber: this.creditCard.creditCardNo,
                                cardType: this.creditCard.creditCardType.name,
                                expireDateMonth: this.creditCard.expireDate.month,
                                expireDateYear: this.creditCard.expireDate.year,
                                securityCode: this.creditCard.securityCode
                            };
                        }
                        else if (this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.D]) {
                            paymentMethodRequest.bankDetails = {
                                bankCode: this.chequingObj.bankCode,
                                transitNumber: this.chequingObj.transitNo,
                                accountNumber: this.chequingObj.accountNo,
                                termsChecked: true
                            };
                            this.bankAccount = this.chequingObj.accountNo;
                        }
                        this.paymentService.setPaymentMethod((paymentMethodRequest))
                            .then(function (response) {
                            var success = _.get(response, 'content.status', false);
                            if (success) {
                                _this.step = modal.STEPS.SUCCESS;
                                _this.isPaymentSuccess = true;
                                _this.nextBillingDateMsg = _this.$translate.instant('ute.payment.method.pm_payment_for_next_billing_month__desc', { 'nextBillingDate': _this.nextBillingDate });
                                _this.currentPaymentMethod = _this.selectedPaymentMethod;
                                if (_this.userService.isConsumer() && !_this.overlayModel.isPaymentMethodUpdating) {
                                    _this.$timeout(function () {
                                        if (_this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.D]) {
                                            _this.chequingObj.accountNo = _this.bankAccount;
                                        }
                                        _this.goToConfirmation();
                                    }, 1000);
                                }
                            }
                            else {
                                _this.processError(null);
                            }
                        }).catch(this.processError)
                            .finally(function () { return _this.isPaymentMethodChanging = false; });
                    };
                    MOPOverlayController.prototype.getMopObject = function () {
                        return {
                            newPaymentMethod: this.overlayModel.newPaymentMethod,
                            oldPaymentMethod: this.overlayModel.oldPaymentMethod,
                            isPaymentChanging: this.isPaymentMethodChanging,
                            $modalInstance: this.$modalInstance
                        };
                    };
                    MOPOverlayController.prototype.getDebitAccountNumberString = function (accountNumber) {
                        var arr = [];
                        arr.push(accountNumber.split('').reverse().pop());
                        for (var i = 0; i < accountNumber.length - 4; i++) {
                            arr.push('x');
                        }
                        arr = arr.concat(accountNumber.split('').reverse().slice(0, 3).reverse());
                        return arr.join('');
                    };
                    MOPOverlayController.prototype.getCreditCardType = function (type) {
                        var map = { 'VI': 'VISA', 'MC': 'MASTER', 'AM': 'AMEX' };
                        return map[type];
                    };
                    MOPOverlayController.prototype.getCreditCardImages = function () {
                        return this.paymentMethodService.getCreditCardImage(this.getCreditCardType(this.creditCard.creditCardType.name));
                    };
                    MOPOverlayController.prototype.selectPaymentType = function (type) {
                        this.selectedPaymentMethod = type;
                        this.resetStepManager();
                        this.step = modal.STEPS.ACCOUNT;
                        if (type === PaymentMethodType[PaymentMethodType.R]) {
                            this.continueToReview(PaymentMethodType.R);
                            this.isInvoice = true;
                        }
                        else if (type === PaymentMethodType[PaymentMethodType.C]) {
                            this.stepManager[1].text = modal.STEPS[modal.STEPS.REVIEW].toLowerCase();
                            this.isCredit = true;
                        }
                        else if (type === PaymentMethodType[PaymentMethodType.D]) {
                            this.stepManager[1].text = modal.STEPS[modal.STEPS.REVIEW].toLowerCase() + '_D';
                        }
                        if (window.innerWidth <= 768) {
                            angular.element('.pm-modal').scrollTop(0);
                            angular.element('.pm-modal').animate({ scrollTop: $('#pm-right-body').offset().top }, {
                                duration: 500,
                                easing: 'swing'
                            });
                        }
                    };
                    MOPOverlayController.prototype.continueToReview = function (type) {
                        var _this = this;
                        this.step = modal.STEPS.REVIEW;
                        this.stepManager[modal.STEPS.ACCOUNT - 1].complete = true;
                        this.stepManager[modal.STEPS.REVIEW - 1].active = true;
                        this.$timeout(function () {
                            if (type === PaymentMethodType.D) {
                                _this.form.$valid = false;
                                _this.form.$submitted = false;
                            }
                            else if (type === PaymentMethodType.C) {
                                _this.savedCreditCardObject = _.cloneDeep(_this.creditCard);
                                _this.savedExpriyDate = _this.getCreditCardExpiry();
                            }
                        }, 0);
                        this.trackPaymentMethod(this.step);
                    };
                    MOPOverlayController.prototype.goToConfirmation = function () {
                        this.step = modal.STEPS.CONFIRMATION;
                        this.stepManager[modal.STEPS.REVIEW - 1].complete = true;
                        this.stepManager[modal.STEPS.CONFIRMATION - 1].active = true;
                        this.trackPaymentMethod(this.step);
                    };
                    MOPOverlayController.prototype.goToNoChangesMade = function () {
                        var _this = this;
                        this.resetStepManager();
                        this.step = modal.STEPS.NO_CHANGE_MADE;
                        this.$timeout(function () {
                            _this.$modalInstance.dismiss('');
                        }, 1000);
                    };
                    MOPOverlayController.prototype.goBackToAccount = function () {
                        this.step = modal.STEPS.ACCOUNT;
                        this.stepManager[modal.STEPS.REVIEW - 1].active = false;
                        this.stepManager[modal.STEPS.ACCOUNT - 1].complete = false;
                    };
                    MOPOverlayController.prototype.getCreditCardExpiry = function () {
                        return this.savedCreditCardObject.expireDate.month +
                            '/' +
                            this.savedCreditCardObject.expireDate.year.toString();
                    };
                    MOPOverlayController.prototype.getCurrentPaymentMethodText = function () {
                        return 'ute.payment.method.current_payment_method.' +
                            this.currentPaymentMethod +
                            '.text';
                    };
                    MOPOverlayController.prototype.expireYears = function () {
                        if (this._expireYears.length > 0) {
                            return this._expireYears;
                        }
                        var _currentYear = new Date().getFullYear();
                        this._expireYears.push(_currentYear);
                        //get current year and add up to 10 years
                        for (var i = 1; i <= 10; i++) {
                            this._expireYears.push(_currentYear + i);
                        }
                        return this._expireYears;
                    };
                    MOPOverlayController.prototype.parseDate = function (input) {
                        var map = {
                            Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5,
                            Jul: 6, Aug: 7, Sep: 8, Oct: 9, Nov: 10, Dec: 11
                        };
                        var dateParts = input.replace(/^(\w+)-(\d+)/, '$2-$1').split('-');
                        return new Date(2000 + Number(dateParts[2]), map[dateParts[1]], +dateParts[0]);
                    };
                    MOPOverlayController.prototype.init = function () {
                        this.livechat = {
                            cbid: 'ute.payment.method.liveChat.cbid',
                            dynamicDivId: 'ute.payment.method.liveChat.dynamicDivId',
                            chatButtonClass: 'ute.payment.method.liveChat.chatButtonClass'
                        };
                        this.hideOutline = false;
                        this.user = this.userService.getUser();
                        this.userType = this.userService.getUserType();
                        this.lang = this.languageSwitcher.getCurrentLanguage();
                        this.dtmName = this.overlayModel.isPaymentMethodUpdating ? 'update preauth-payment information' : 'change payment method';
                        this.showDebitForm = this.overlayModel.newPaymentMethod.paymentMethodType === PaymentMethodType.D;
                        this.isCredit = this.overlayModel.newPaymentMethod.paymentMethodType === PaymentMethodType.C;
                        this.isInvoice = this.overlayModel.newPaymentMethod.paymentMethodType === PaymentMethodType.R;
                        this.selectionType = this.overlayModel.oldPaymentMethod.paymentMethodType === PaymentMethodType.R;
                        this.billingDetail.balanceAmount = this.overlayModel.billingDetail.balanceAmount;
                        this.accountDetails = this.overlayModel.selectedAccount;
                        this.toStateName = window.localStorage.getItem('toStateName');
                        this.creditCard = {};
                        this.PaymentMethodType = PaymentMethodType;
                        this.cardTime = {
                            months: MONTHS.getMonths(),
                            years: this.expireYears()
                        };
                        if (this.showDebitForm) {
                            this.chequingObj = {};
                        }
                        this.billDueDate = angular.isDefined(this.overlayModel.billingDetail.billDueDate) ? this.parseDate(this.overlayModel.billingDetail.billDueDate) : undefined;
                        this.nextBillingDate = angular.isDefined(this.overlayModel.billingDetail.nextBillDate) ? this.setNextBillingDateFormate(this.overlayModel.billingDetail.nextBillingDate) : undefined;
                        this.isPaymentMethodChanging = false;
                        this.isPaymentSuccess = false;
                        this.STEP = modal.STEPS;
                        this.mopObj = this.getMopObject();
                        this.updateCreditCardFailed = false;
                        if (this.overlayModel.isPaymentMethodUpdating) {
                            if (this.overlayModel.methodOfPaymentData.mopType === PaymentMethodType.C) {
                                this.preAuthPaymentCreditMappingKey += ',selfServe-' + this.overlayModel.methodOfPaymentData.creditCardDetails.ccType;
                            }
                        }
                        else {
                            sessionStorage.removeItem('__adl');
                        }
                        this.selectedPaymentMethod = '';
                        if (!this.userService.isConsumer() || (this.userService.isConsumer() && this.overlayModel.isPaymentMethodUpdating)) {
                            this.selectedPaymentMethod = PaymentMethodType[this.overlayModel.newPaymentMethod.paymentMethodType];
                        }
                        if (this.userService.isConsumer() && !this.overlayModel.isPaymentMethodUpdating) {
                            this.step = modal.STEPS.ACCOUNT;
                            this.savedCreditCardObject = {};
                            this.savedExpriyDate = '';
                            this.pmModalHeader = 'mop_title';
                            this.resetStepManager();
                            this.currentPaymentMethod = this.originalPaymentMethod = PaymentMethodType[this.overlayModel.oldPaymentMethod.paymentMethodType];
                            this.firstAttempt = false;
                        }
                        else {
                            this.step = modal.STEPS.CHANGE_MOP;
                        }
                        this.initDataLayer();
                    };
                    MOPOverlayController.prototype.initDataLayer = function () {
                        var mapping = {
                            mappingKey: 'advance.mappingKey.paymentMethod'
                        };
                        this.dataLayerConfig = this.dataLayerService.getConfigByMappingKey(mapping);
                        this.apiErrorPayload = this.dataLayerConfig.error_api;
                        this.startPayload = this.dataLayerConfig.start;
                        this.reviewPayload = this.dataLayerConfig.review;
                        this.termsAndConditionPayload = this.dataLayerConfig.termsAndCondition;
                        this.completePayload = this.dataLayerConfig.complete;
                        // if (this.overlayModel.oldPaymentMethod.paymentMethodType === PaymentMethodType.D) {
                        //   this.updateSelfServe(this.dataLayerConfig.updatePaymentMethodBank);
                        // } else if (this.overlayModel.oldPaymentMethod.paymentMethodType === PaymentMethodType.C) {
                        //   this.updateSelfServe(this.dataLayerConfig.updatePaymentMethodCard);
                        // }
                        this.trackPaymentMethod(modal.STEPS.ACCOUNT);
                    };
                    // private updateSelfServe(selfServe: IADLSelfServe): void {
                    //   this.startPayload.selfServe = selfServe;
                    //   this.reviewPayload.selfServe = selfServe;
                    //   this.termsAndConditionPayload.selfServe = selfServe;
                    //   this.completePayload.selfServe = selfServe;
                    // }
                    MOPOverlayController.prototype.resetStepManager = function () {
                        this.stepManager = [
                            this.getBasicStepModel(modal.STEPS.ACCOUNT),
                            this.getBasicStepModel(modal.STEPS.REVIEW),
                            this.getBasicStepModel(modal.STEPS.CONFIRMATION)
                        ];
                        this.stepManager[0].active = true;
                    };
                    MOPOverlayController.prototype.getBasicStepModel = function (step) {
                        return {
                            number: step,
                            text: modal.STEPS[step].toString().toLowerCase(),
                            active: false,
                            complete: false
                        };
                    };
                    MOPOverlayController.prototype.trackPaymentMethod = function (step) {
                        if (!this.overlayModel.isPaymentMethodUpdating) {
                            try {
                                var _payload = void 0;
                                var _isAutoPayment = void 0;
                                if (step === modal.STEPS.ACCOUNT) {
                                    _payload = this.startPayload;
                                }
                                else if (step === modal.STEPS.REVIEW) {
                                    _payload = this.selectedPaymentMethod === PaymentMethodType[PaymentMethodType.D] ? this.termsAndConditionPayload : this.reviewPayload;
                                }
                                else if (step === modal.STEPS.CONFIRMATION) {
                                    _isAutoPayment = this.overlayModel.oldPaymentMethod.paymentMethodType === PaymentMethodType.R;
                                    _payload = this.completePayload;
                                }
                                if (_payload) {
                                    if (step === modal.STEPS.REVIEW || step === modal.STEPS.CONFIRMATION) {
                                        var oldPaymentMethod = this.getPaymentMethod(PaymentMethodType[this.overlayModel.methodOfPaymentData.mopType], true);
                                        var newPaymentMethod = this.getPaymentMethod(this.selectedPaymentMethod, false);
                                        _payload.ecommerce = { paymentMethods: [oldPaymentMethod, newPaymentMethod] };
                                    }
                                    if (_isAutoPayment) {
                                        _.merge(_payload, { events: { autopay: _isAutoPayment } });
                                    }
                                }
                                this.dataLayerService.track(_payload, true, this.dataLayerPredefinedSection);
                            }
                            catch (error) {
                                console.error('data layer tracking - Make a payment', error);
                            }
                            return;
                        }
                    };
                    MOPOverlayController.prototype.getPaymentMethod = function (paymentMethodType, isOldPaymentMethod) {
                        if (paymentMethodType === PaymentMethodType[PaymentMethodType.R]) {
                            return this.dataLayerConfig.paymentMethod.manual;
                        }
                        else if (paymentMethodType === PaymentMethodType[PaymentMethodType.D]) {
                            return this.dataLayerConfig.paymentMethod.bank;
                        }
                        else if (paymentMethodType === PaymentMethodType[PaymentMethodType.C]) {
                            var ccType = isOldPaymentMethod ? this.overlayModel.methodOfPaymentData.creditCardDetails.ccType :
                                this.creditCard.creditCardType.id;
                            if (ccType === CreditCardType.VISA) {
                                return this.dataLayerConfig.paymentMethod.visa;
                            }
                            else if (ccType === CreditCardType.MASTER) {
                                return this.dataLayerConfig.paymentMethod.mastercard;
                            }
                            else if (ccType === CreditCardType.AMEX) {
                                return this.dataLayerConfig.paymentMethod.amex;
                            }
                        }
                        return 'Unknown';
                    };
                    MOPOverlayController.prototype.goToNextStep = function (type) {
                        if (this.userService.isConsumer() && !this.overlayModel.isPaymentMethodUpdating) {
                            this.continueToReview(type);
                        }
                        else {
                            this.callServer();
                        }
                    };
                    MOPOverlayController.prototype.setNextBillingDateFormate = function (nextDate) {
                        var date, billingDate, map;
                        map = {
                            en: {
                                '01': 'January', '02': 'February', '03': 'March', '04': 'April', '05': 'May', '06': 'June',
                                '07': 'July', '08': 'August', '09': 'September', '10': 'October', '11': 'November', '12': 'December'
                            },
                            fr: {
                                '01': 'janvier', '02': 'février', '03': 'mars', '04': 'avril', '05': 'mai', '06': 'juin',
                                '07': 'juillet', '08': 'août', '09': 'septembre', '10': 'octobre', '11': 'novembre', '12': 'décembre'
                            }
                        };
                        if (nextDate) {
                            billingDate = nextDate.split('-');
                            date = this.lang === 'en' ?
                                (map[this.lang][billingDate[1]] + ' ' + billingDate[2] + ', ' + billingDate[0]) :
                                (billingDate[2] + ' ' + map[this.lang][billingDate[1]] + ', ' + billingDate[0]);
                        }
                        return date;
                    };
                    MOPOverlayController.$inject = [
                        '$modal',
                        '$modalInstance',
                        'ute.blocks.language.switcher',
                        'ute.common.user.service',
                        'ute.payment.service',
                        'ute.common.permissions.service',
                        'overlayModel',
                        '$translate',
                        'ute.datalayer.common.service',
                        '$timeout',
                        'ute.payment.method.service'
                    ];
                    return MOPOverlayController;
                }());
                var MONTHS = (function () {
                    function MONTHS() {
                    }
                    MONTHS.getMonths = function () {
                        return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
                    };
                    return MONTHS;
                }());
                modal.MONTHS = MONTHS;
                angular.module('ute.payment.method').controller('ute.payment.method.modal.controller', MOPOverlayController);
            })(modal = method.modal || (method.modal = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var modal;
            (function (modal) {
                var creditCard;
                (function (creditCard) {
                    'use strict';
                    var CreditCardUI = (function () {
                        function CreditCardUI() {
                            this.templateUrl = 'module/paymentMethodModal/templates/paymentMethod.modal.creditCard.html';
                            this.restrict = 'EA';
                        }
                        CreditCardUI.factory = function () {
                            var directive = function () { return new CreditCardUI(); };
                            return directive;
                        };
                        ;
                        CreditCardUI.$inject = [];
                        return CreditCardUI;
                    }());
                    angular.module('ute.payment.method').directive('creditCardUi', CreditCardUI.factory());
                })(creditCard = modal.creditCard || (modal.creditCard = {}));
            })(modal = method.modal || (method.modal = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var method;
        (function (method) {
            var modal;
            (function (modal) {
                var debitCard;
                (function (debitCard) {
                    'use strict';
                    var DebitCardUI = (function () {
                        function DebitCardUI() {
                            this.templateUrl = 'module/paymentMethodModal/templates/paymentMethod.modal.debitCard.html';
                            this.restrict = 'EA';
                        }
                        DebitCardUI.factory = function () {
                            var directive = function () { return new DebitCardUI(); };
                            return directive;
                        };
                        ;
                        DebitCardUI.$inject = [];
                        return DebitCardUI;
                    }());
                    angular.module('ute.payment.method').directive('debitCardUi', DebitCardUI.factory());
                })(debitCard = modal.debitCard || (modal.debitCard = {}));
            })(modal = method.modal || (method.modal = {}));
        })(method = payment.method || (payment.method = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
            var BackEndPaymentErrorCode = (function () {
                function BackEndPaymentErrorCode() {
                }
                BackEndPaymentErrorCode.STATUS_OK = 0;
                BackEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED = 10645;
                BackEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED_SPM = 10701;
                BackEndPaymentErrorCode.DUPLICATE_PAYMENT = 10649;
                BackEndPaymentErrorCode.TRY_AGAIN = 50000;
                BackEndPaymentErrorCode.SECURITY_CODE_INVALID = 1005972;
                BackEndPaymentErrorCode.GENERIC_ERROR = 17052;
                return BackEndPaymentErrorCode;
            }());
            service.BackEndPaymentErrorCode = BackEndPaymentErrorCode;
            (function (FrontEndPaymentErrorCode) {
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["STATUS_OK"] = 0] = "STATUS_OK";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["CARD_AUTHORIZATION_DECLINED"] = 1] = "CARD_AUTHORIZATION_DECLINED";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["CARD_AUTHORIZATION_DECLINED_SPM"] = 2] = "CARD_AUTHORIZATION_DECLINED_SPM";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["DUPLICATE_PAYMENT"] = 3] = "DUPLICATE_PAYMENT";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["TRY_AGAIN"] = 4] = "TRY_AGAIN";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["SECURITY_CODE_INVALID"] = 5] = "SECURITY_CODE_INVALID";
                FrontEndPaymentErrorCode[FrontEndPaymentErrorCode["GENERIC_ERROR"] = 6] = "GENERIC_ERROR";
            })(service.FrontEndPaymentErrorCode || (service.FrontEndPaymentErrorCode = {}));
            var FrontEndPaymentErrorCode = service.FrontEndPaymentErrorCode;
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
            var ProviderBase = ute.common.core.ProviderBase;
            var PaymentService = (function () {
                function PaymentService(config, $http, $q, securityService) {
                    var _this = this;
                    this.config = config;
                    this.$http = $http;
                    this.$q = $q;
                    this.securityService = securityService;
                    this.errorCodesMap = {};
                    this.getConfig = function () { return angular.copy(_this.config); };
                    this.makePayment = function (paymentRequest) {
                        var request = {
                            accountNumber: paymentRequest.accountNumber,
                            accountTypeNumber: paymentRequest.accountTypeNumber,
                            amount: paymentRequest.paymentAmount,
                            paymentMethod: paymentRequest.paymentMethod || 'CreditCard',
                            subNumber: paymentRequest.subNumber,
                            consolidated: paymentRequest.isConsolidated,
                            'creditCardInfo.ccNumber': paymentRequest.cardDetails.cardNumber,
                            'creditCardInfo.ccType': paymentRequest.cardDetails.cardType,
                            'creditCardInfo.ccExpiryMonth': paymentRequest.cardDetails.expireDateMonth,
                            'creditCardInfo.ccExpiryYear': paymentRequest.cardDetails.expireDateYear,
                            'creditCardInfo.securityCode': paymentRequest.cardDetails.securityCode
                        };
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.config.advanced.makePayment.apiUrl), request)
                            .then(_this.processOk)
                            .catch(_this.processMakeAPaymentError);
                    };
                    this.getInteracEligibility = function (interacEligibilityRequest) {
                        var request = {
                            language: interacEligibilityRequest.language || 'en',
                            accountNumber: String(interacEligibilityRequest.accountNumber),
                            accountTypeNumber: interacEligibilityRequest.accountTypeNumber,
                            amountDue: String(interacEligibilityRequest.amountDue),
                            amount: String(interacEligibilityRequest.amount)
                        };
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.config.advanced.getInteracEligibility.apiUrl), request)
                            .then(_this.interacEligibilityOk)
                            .catch(_this.processError);
                    };
                    this.setPaymentMethod = function (paymentMethod) {
                        var request = _this.buildPaymentMethodRequest(paymentMethod);
                        if (request) {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.advanced.setPaymentMethod.apiUrl), request)
                                .then(_this.processSetPaymentMethodOk)
                                .catch(_this.processError);
                        }
                        else {
                            return new _this.$q(function (resolve, reject) { return reject(_this.errorCodesMap[service.FrontEndPaymentErrorCode.GENERIC_ERROR]); });
                        }
                    };
                    this.getPaymentHistory = function (paymentHistoryRequest) {
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.config.advanced.getPaymentHistory.apiUrl), paymentHistoryRequest)
                            .then(_this.processGetPaymentHistoryOk)
                            .catch(_this.processGetPaymentHistoryError);
                    };
                    /**
                     * @param paymentMethod
                     * @returns {any}
                     */
                    this.buildPaymentMethodRequest = function (paymentMethod) {
                        var request = {
                            accountNumber: paymentMethod.accountNumber,
                            accountTypeNumber: paymentMethod.accountTypeNumber,
                            mopType: paymentMethod.mopType,
                            consolidated: paymentMethod.isConsolidated,
                            subNumber: paymentMethod.subNumber,
                            'detail.oldMopType': paymentMethod.oldMopType,
                            'detail.contactId': paymentMethod.contactId
                        };
                        if (service.MethodOfPaymentType.DebitOrCreditCard === paymentMethod.mopType) {
                            if (paymentMethod.cardDetails) {
                                request = angular.extend(request, {
                                    'creditCardInfo.ccNumber': paymentMethod.cardDetails.cardNumber,
                                    'creditCardInfo.ccType': paymentMethod.cardDetails.cardType,
                                    'creditCardInfo.ccExpiryMonth': paymentMethod.cardDetails.expireDateMonth,
                                    'creditCardInfo.ccExpiryYear': paymentMethod.cardDetails.expireDateYear,
                                    'creditCardInfo.securityCode': paymentMethod.cardDetails.securityCode
                                });
                            }
                            else {
                                request = null;
                            }
                        }
                        else if (service.MethodOfPaymentType.Debit === paymentMethod.mopType) {
                            if (paymentMethod.bankDetails) {
                                request = angular.extend(request, {
                                    'chequingInfo.bankNumber': paymentMethod.bankDetails.bankCode,
                                    'chequingInfo.transitNumber': paymentMethod.bankDetails.transitNumber,
                                    'chequingInfo.accountNumber': paymentMethod.bankDetails.accountNumber,
                                    'chequingInfo.termsChecked': paymentMethod.bankDetails.termsChecked
                                });
                            }
                            else {
                                request = null;
                            }
                        }
                        else if (service.MethodOfPaymentType.Invoice !== paymentMethod.mopType) {
                            request = null;
                        }
                        return request;
                    };
                    /**
                     * @param code
                     * @returns {ICodeEntry}
                     */
                    this.addCode = function (code) {
                        _this.errorCodesMap[code.frontendCode] = code;
                    };
                    this.addCodes = function () {
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.STATUS_OK,
                            backendCode: service.BackEndPaymentErrorCode.STATUS_OK
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED,
                            backendCode: service.BackEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED_SPM,
                            backendCode: service.BackEndPaymentErrorCode.CARD_AUTHORIZATION_DECLINED_SPM
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.TRY_AGAIN,
                            backendCode: service.BackEndPaymentErrorCode.TRY_AGAIN
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.DUPLICATE_PAYMENT,
                            backendCode: service.BackEndPaymentErrorCode.DUPLICATE_PAYMENT
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.SECURITY_CODE_INVALID,
                            backendCode: service.BackEndPaymentErrorCode.SECURITY_CODE_INVALID
                        });
                        _this.addCode({
                            frontendCode: service.FrontEndPaymentErrorCode.GENERIC_ERROR,
                            backendCode: service.BackEndPaymentErrorCode.GENERIC_ERROR
                        });
                    };
                    /**
                     * @param response
                     * @returns {ICodeEntry|any}
                     */
                    this.processOk = function (response) {
                        var successful = _.get(response, 'data.successful', false);
                        var backendCode = successful ? service.BackEndPaymentErrorCode.STATUS_OK : _.get(response, 'data.errorCode', service.BackEndPaymentErrorCode.GENERIC_ERROR);
                        return _this.findCodeEntry(backendCode, response, 'data.errorMessage');
                    };
                    /**
                     * @param backendCode
                     * @param response
                     * @param errorPropertyName
                     * @returns {ICodeEntry|any}cd ..
                     */
                    this.findCodeEntry = function (backendCode, response, errorPropertyName) {
                        var codeEntry = _.find(_this.errorCodesMap, function (ce) {
                            return ce.backendCode === backendCode;
                        }) || _this.errorCodesMap[service.FrontEndPaymentErrorCode.GENERIC_ERROR];
                        codeEntry.status = response.status;
                        codeEntry.backendCode = backendCode;
                        codeEntry.backendErrorMessage = _.get(response, errorPropertyName, '') || response.status + ' - ' + response.statusText;
                        return codeEntry;
                    };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processMakeAPaymentError = function (error) {
                        var backendCode = _.get(error, 'data.errorCode', service.BackEndPaymentErrorCode.GENERIC_ERROR);
                        return new _this.$q(function (resolve, reject) {
                            return reject(_this.findCodeEntry(backendCode, error, 'data.errorMessage'));
                        });
                    };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processError = function (error) {
                        var backendCode = _.get(error, 'data.status.code', service.BackEndPaymentErrorCode.GENERIC_ERROR);
                        return new _this.$q(function (resolve, reject) {
                            return reject(_this.findCodeEntry(backendCode, error, 'data.status.codeName'));
                        });
                    };
                    /**
                     * @param response
                     * @returns IInteracEligibilityData
                     */
                    this.interacEligibilityOk = function (response) {
                        return response && response.data && response.data.content ?
                            {
                                fundedUrl: response.data.content.IDEBIT_FUNDEDURL,
                                amount: response.data.content.IDEBIT_AMOUNT,
                                currency: response.data.content.IDEBIT_CURRENCY,
                                invoice: response.data.content.IDEBIT_INVOICE,
                                merchantData: response.data.content.IDEBIT_MERCHDATA,
                                merchantLanguage: response.data.content.IDEBIT_MERCHLANG ? response.data.content.IDEBIT_MERCHLANG.toLowerCase() : 'en',
                                merchantNumber: response.data.content.IDEBIT_MERCHNUM,
                                nonFundedUrl: response.data.content.IDEBIT_NOTFUNDEDURL,
                                termId: response.data.content.IDEBIT_TERMID,
                                version: response.data.content.IDEBIT_VERSION,
                                accountNumber: response.data.content.accountNumber,
                                interacUrl: response.data.content.interac_URL,
                                paymentAmount: response.data.content.paymentAmount
                            } : null;
                    };
                    /**
                     * @param response
                     * @returns {ICodeEntry|any}
                     */
                    this.processSetPaymentMethodOk = function (response) {
                        return response.data;
                    };
                    /**
                     * @param response
                     * @returns {ICodeEntry|any}
                     */
                    this.processGetPaymentHistoryOk = function (response) {
                        return response.data;
                    };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processGetPaymentHistoryError = function (error) {
                        var backendCode = _.get(error, 'data.errorCode', service.BackEndPaymentErrorCode.GENERIC_ERROR);
                        return new _this.$q(function (resolve, reject) {
                            return reject(_this.findCodeEntry(backendCode, error, 'data.errorMessage'));
                        });
                    };
                    this.addCodes();
                }
                ;
                PaymentService.serviceName = 'ute.payment.service';
                return PaymentService;
            }());
            var PaymentServicedProvider = (function (_super) {
                __extends(PaymentServicedProvider, _super);
                /* @ngInject */
                function PaymentServicedProvider() {
                    var _this = this;
                    _super.call(this);
                    /* @ngInject */
                    this.$get = function ($http, $q, securityService) {
                        return new PaymentService(_this.config, $http, $q, securityService);
                    };
                    this.$get.$inject = [
                        '$http',
                        '$q',
                        'ute.common.security.service'
                    ];
                    this.config = service.PaymentServiceConfig();
                }
                PaymentServicedProvider.$inject = [];
                return PaymentServicedProvider;
            }(ProviderBase));
            angular.module('ute.payment.service').provider(PaymentService.serviceName, PaymentServicedProvider);
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
            function PaymentServiceConfig() {
                return {
                    basic: {
                        logPrefix: 'PaymentServiceC',
                        logLevel: ute.common.typescript.api.log.LogLevel.OFF
                    },
                    advanced: {
                        makePayment: {
                            apiUrl: 'v1/makePayment'
                        },
                        getInteracEligibility: {
                            apiUrl: 'v2/interac/getEligibility'
                        },
                        setPaymentMethod: {
                            apiUrl: 'v2/payment/updatePaymentMethod'
                        },
                        getPaymentHistory: {
                            apiUrl: 'v1/payment/history'
                        }
                    }
                };
            }
            service.PaymentServiceConfig = PaymentServiceConfig;
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            'use strict';
            configureRoutes.$inject = [
                'ute.blocks.router'
            ];
            function configureRoutes(routerHelper) {
                routerHelper.configureStates(getStates());
            }
            function getStates() {
                return [
                    {
                        name: 'utePaynowInteracFunded',
                        url: '/utepaynow/funded/:amount',
                        controller: 'ute.payment.ui.pay.now.interac.controller',
                        template: '',
                        controllerAs: 'interacCtrl',
                        resolve: {
                            interacPaymentStatus: function () {
                                return ute.payment.ui.pay.now.InteracPaymentStatus.funded;
                            }
                        },
                        data: {
                            title: '',
                            security: {
                                roles: ['user']
                            }
                        }
                    },
                    {
                        name: 'utePaynowInteracNotFunded',
                        url: '/utepaynow/notfunded',
                        controller: 'ute.payment.ui.pay.now.interac.controller',
                        template: '',
                        controllerAs: 'interacCtrl',
                        resolve: {
                            interacPaymentStatus: function () {
                                return ute.payment.ui.pay.now.InteracPaymentStatus.notFunded;
                            }
                        },
                        data: {
                            title: '',
                            security: {
                                roles: ['user']
                            }
                        }
                    }
                ];
            }
            angular.module('ute.payment.ui.config').run(configureRoutes);
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var PendingOrderController = (function () {
                    /* ngInject */
                    function PendingOrderController($modal, pendingOrderService, accountOverviewFactory, $q) {
                        var _this = this;
                        this.$modal = $modal;
                        this.pendingOrderService = pendingOrderService;
                        this.accountOverviewFactory = accountOverviewFactory;
                        this.$q = $q;
                        this.carousel = [];
                        this.hasError = false;
                        this.accountOverviewDataHandler = function (accountOverviewData) {
                            _this.carousel = [];
                            _this.fetchOrders(accountOverviewData.getSelectedAccount().accountNumber.toString());
                            return _this.$q.when(accountOverviewData);
                        };
                        this.accountOverviewService = accountOverviewFactory();
                        this.hasError = true;
                        // this.accountOverviewService
                        //   .getSelectedAccount()
                        //   .then((account: IAccount) => {
                        //     this.fetchOrders(account.accountNumber.toString());
                        //   });
                        // this.accountOverviewService
                        //   .registerOnDataChangeHandler(this.accountOverviewDataHandler, 'rogersPendingOrder');
                    }
                    PendingOrderController.prototype.termsConditionModal = function () {
                        this.$modal.open(this.pendingOrderService.getTermsModalConfig());
                    };
                    PendingOrderController.prototype.orderDetailModal = function (orderID) {
                        this.pendingOrderService.setOrderId(orderID);
                        this.$modal.open(this.pendingOrderService.getOrderDetailsModalConfig());
                    };
                    PendingOrderController.prototype.fetchOrders = function (accountNumber) {
                        var _this = this;
                        this.pendingOrderService.setAccountNumber(accountNumber);
                        this.pendingOrderService.getOrderInfo(accountNumber)
                            .then(function (resp) {
                            if (!resp.data.orderInfo || !resp.data.orderInfo.orders) {
                                _this.hasError = true;
                                return;
                            }
                            _this.carousel = resp.data.orderInfo.orders;
                        })
                            .catch(function () {
                            _this.hasError = true;
                        });
                    };
                    PendingOrderController.$inject = [
                        '$modal',
                        'ute.common.pending.order.service',
                        'ute.rogers.account.overview.factory',
                        '$q'
                    ];
                    PendingOrderController.controllerId = 'PendingOrderController';
                    return PendingOrderController;
                }());
                order.PendingOrderController = PendingOrderController;
                angular
                    .module('ute.common.pending.order')
                    .controller('ute.common.pending.order.controller', PendingOrderController);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var PendingOrderDirective = (function () {
                    /* @ngInject */
                    function PendingOrderDirective(pendingOrderProvider) {
                        this.pendingOrderProvider = pendingOrderProvider;
                        this.scope = {};
                        this.restrict = 'E';
                        this.controller = this.pendingOrderProvider.getConfig().basic.pendingOrderController;
                        this.controllerAs = this.pendingOrderProvider.getConfig().basic.pendingOrderControllerAs;
                        this.bindToController = true;
                        this.templateUrl = this.pendingOrderProvider.getConfig().basic.templateUrl;
                    }
                    PendingOrderDirective.factory = function () {
                        var directive = function (pendingOrderProvider) { return new PendingOrderDirective(pendingOrderProvider); };
                        directive.$inject = ['ute.common.pending.order.provider'];
                        return directive;
                    };
                    return PendingOrderDirective;
                }());
                angular.module('ute.common.pending.order').directive('utePendingOrder', PendingOrderDirective.factory());
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var permissions;
        (function (permissions) {
            var service;
            (function (service) {
                'use strict';
                var PermissionsProvider = (function () {
                    /* @ngInject */
                    function PermissionsProvider() {
                        var _this = this;
                        // private isProtectedCall: boolean;
                        //private logger: ute.blocks.logger.ILogger;
                        this.config = {
                            partialApiUrl: 'v1/permissions',
                            ramPartialApiUrl: 'v1/ram/permissions/all',
                            ovAuthzPartialApiUrl: 'web/genesis/api/oneview-authz/v1/permissions/all',
                            ovAuthzfullApiUrl: 'https://www.ute-env16.rogers.com/web/genesis/api/oneview-authz/v1/permissions/all'
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http) {
                            _this.exceptionHandler = $injector.get('ute.blocks.exceptionService');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            //this.logger = $injector.get('ute.blocks.loggerService');
                            _this.$http = $http;
                            _this.getUserPermissions = _.memoize(_this._getUserPermissions, _this.getCacheName);
                            /**
                             * @param getRamPermissions
                             */
                            _this.getRamPermissions = _.memoize(_this._getRamPermissions, _this.getRamCacheName);
                            /**
                             * @param getOneViewAuthzPermissionAll
                             */
                            _this.getOneViewAuthzPermissions = _.memoize(_this._getOneViewAuthzPermissions, _this.getOneViewAuthzCacheName);
                            _this.userService.registerSigninHandler(_this.cleanCache, _this);
                            return {
                                getUserPermission: _this.getUserPermission,
                                getUserPermissions: _this.getUserPermissions,
                                getRamPermission: _this.getRamPermission,
                                getOneViewAuthzPermission: _this.getOneViewAuthzPermission
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getCacheName = function () {
                            return 'PermissionsCacheName';
                        };
                        /**
                         * @return RamPermissions CacheName
                         */
                        this.getRamCacheName = function () {
                            return 'RamPermissionsCacheName';
                        };
                        /**
                         * @return OneViewAuthzPermissions CacheName
                         */
                        this.getOneViewAuthzCacheName = function () {
                            return 'OneViewAuthzPermissionsCacheName';
                        };
                        this.cleanCache = function () {
                            //console.log('ute.user.service.UserService.cleanCache: cache=', (<any>this.getEncryptionKey).cache);
                            //console.log('ute.permission.service.cleanRamCache: cache=', (<any>this.getRamPermissions).cache);
                            _this.getUserPermissions.cache.delete(_this.getCacheName());
                            _this.getRamPermissions.cache.delete(_this.getRamCacheName());
                            _this.getOneViewAuthzPermissions.cache.delete(_this.getOneViewAuthzCacheName());
                        };
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getUserPermission = function (key) {
                            return _this.getUserPermissions().then(function (val) {
                                //console.log('PermissionsProvider->getUserPermission', key, !!_.find<IPermissionEntry, IPermissionEntry>(val.permissions, <IPermissionEntry>{permission: _.isNumber(key) ? UserPermissions[key] : key}));
                                return !!_.find(val.permissions, { permission: _.isNumber(key) ? service.UserPermissions[key] : key });
                            });
                        };
                        /**
                         * @param ramCode ramAction
                         * @returns {IPromise<boolean>}
                         */
                        this.getRamPermission = function (ramCode, ramAction) {
                            return _this.getRamPermissions().then(function (val) {
                                //console.log('ramPermissions', _.find<IRamPermissionEntry, IRamPermissionEntry>(val.content, <IRamPermissionEntry>{resourceCode: _.isNumber(ramCode) ? RamResourceCodes[ramCode] : ramCode ,actionCode: _.isNumber(ramAction) ? RamActionCodes[ramAction] : ramAction}));
                                return !!_.find(val.content, {
                                    resourceCode: _.isNumber(ramCode) ? service.RamResourceCodes[ramCode] : ramCode,
                                    actionCode: _.isNumber(ramAction) ? service.RamActionCodes[ramAction] : ramAction
                                });
                            });
                        };
                        /**
                         * @param ramCode ramAction
                         * @returns {IPromise<boolean>}
                         */
                        this.getOneViewAuthzPermission = function (ramCode, ramAction) {
                            return _this.getOneViewAuthzPermissions().then(function (val) {
                                //console.log('ramPermissions', _.find<IRamPermissionEntry, IRamPermissionEntry>(val.content, <IRamPermissionEntry>{resourceCode: _.isNumber(ramCode) ? RamResourceCodes[ramCode] : ramCode ,actionCode: _.isNumber(ramAction) ? RamActionCodes[ramAction] : ramAction}));
                                return !!_.find(val.content, {
                                    resourceCode: _.isNumber(ramCode) ? service.RamResourceCodes[ramCode] : ramCode,
                                    actionCode: _.isNumber(ramAction) ? service.RamActionCodes[ramAction] : ramAction
                                });
                            });
                        };
                        /**
                         * @returns {IPromise<IPermissions>}
                         * @private
                         */
                        this._getUserPermissions = function () {
                            return _this.$http.post('/web/totes/api/' + _this.config.partialApiUrl, {})
                                .then(_this.processUserPermissionsResponse)
                                .catch(_.curry(_this.fail)('processUserPermissionsResponse failed.'));
                        };
                        /**
                         * @getRamPermissions
                         * @returns {IPromise<IRamPermissions>}
                         * @private
                         */
                        this._getRamPermissions = function () {
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.config.ramPartialApiUrl), {})
                                .then(_this.processRamPermissionsResponse)
                                .catch(_.curry(_this.ramFail)('processRamPermissionsResponse failed.'));
                        };
                        /**
                         * @getRamPermissions
                         * @returns {IPromise<IRamPermissions>}
                         * @private
                         */
                        this._getOneViewAuthzPermissions = function () {
                            return _this.$http.post(_this.config.ovAuthzfullApiUrl, {})
                                .then(_this.processOneViewAuthzPermissionsResponse)
                                .catch(_.curry(_this.ramFail)('processRamPermissionsResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IPermissions}
                         */
                        this.processUserPermissionsResponse = function (response) {
                            //console.log('BrtSwitchService->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', { permissions: [] });
                        };
                        /**
                         * @param response
                         * @returns {IRamPermissions}
                         */
                        this.processRamPermissionsResponse = function (response) {
                            //console.log('RamPermissions->ramPermissionsReponse', response.data);
                            return _.get(response, 'data', { content: [] });
                        };
                        /**
                         * @param response
                         * @returns {IRamPermissions}
                         */
                        this.processOneViewAuthzPermissionsResponse = function (response) {
                            //console.log('RamPermissions->ramPermissionsReponse', response.data);
                            return _.get(response, 'data', { content: [] });
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IPermissions}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.permissions.service fail');
                            return { permissions: [] };
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IRamPermissions}
                         */
                        this.ramFail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.permissions.service ramFail');
                            return { content: [] };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http'
                        ];
                    }
                    PermissionsProvider.$inject = [];
                    return PermissionsProvider;
                }());
                angular.module('ute.common.permissions').provider('ute.common.permissions.service', PermissionsProvider);
            })(service = permissions.service || (permissions.service = {}));
        })(permissions = common.permissions || (common.permissions = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                angular.module('ute.blocks.persistent.storage').config(configure);
                configure.$inject = ['$sessionStorageProvider', '$localStorageProvider'];
                /* @ngInject */
                function configure($sessionStorageProvider, $localStorageProvider) {
                    $sessionStorageProvider.setKeyPrefix('');
                    $localStorageProvider.setKeyPrefix('');
                    $sessionStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                    $localStorageProvider.setDeserializer(function (value) {
                        try {
                            return angular.fromJson(value);
                        }
                        catch (e) {
                            return value;
                        }
                    });
                }
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var persistent;
        (function (persistent) {
            var storage;
            (function (storage) {
                'use strict';
                var RogersStoreService = (function () {
                    /* @ngInject */
                    function RogersStoreService($window) {
                        var _this = this;
                        this.$window = $window;
                        this.put = function (key, value) {
                            _this.$window.sessionStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.get = function (key) {
                            var value = _this.$window.sessionStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.remove = function (key) {
                            _this.$window.sessionStorage.removeItem(key);
                            return true;
                        };
                        this.putToLocal = function (key, value) {
                            _this.$window.localStorage.setItem(key, angular.isObject(value) || angular.isArray(value) ? angular.toJson(value) : value);
                            return true;
                        };
                        this.getFromLocal = function (key) {
                            var value = _this.$window.localStorage.getItem(key);
                            try {
                                return angular.fromJson(value);
                            }
                            catch (e) {
                                return value;
                            }
                        };
                        this.removeFromLocal = function (key) {
                            _this.$window.localStorage.removeItem(key);
                            return true;
                        };
                        this.getLocalStoreService = function () { return ({
                            put: _this.putToLocal,
                            get: _this.getFromLocal,
                            remove: _this.removeFromLocal
                        }); };
                        this.getSessionStoreService = function () { return ({
                            put: _this.putToSession,
                            get: _this.getFromSession,
                            remove: _this.removeFromSession
                        }); };
                        this.putToSession = this.put;
                        this.getFromSession = this.get;
                        this.removeFromSession = this.remove;
                    }
                    RogersStoreService.$inject = ['$window'];
                    return RogersStoreService;
                }());
                angular.module('ute.blocks.persistent.storage').service('ute.blocks.persistent.storage.service', RogersStoreService);
            })(storage = persistent.storage || (persistent.storage = {}));
        })(persistent = blocks.persistent || (blocks.persistent = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var ProfileCreateModalController = (function () {
                    /* @ngInject */
                    function ProfileCreateModalController($modalInstance, profileEditService, existingEmail, $translate) {
                        this.$modalInstance = $modalInstance;
                        this.profileEditService = profileEditService;
                        this.existingEmail = existingEmail;
                        this.$translate = $translate;
                        this.isEmailExists = false;
                        this.enteredEmailId = '';
                        this.enteredConfirmEmailId = '';
                        this.showErrorMessage = false;
                        this.isInvalidFormat = false;
                        if (this.existingEmail.email && this.existingEmail.email.trim().length > 0) {
                            this.isEmailExists = true;
                        }
                    }
                    ProfileCreateModalController.prototype.checkEmailFormat = function (emailForm) {
                        if (emailForm.emailInput.$viewValue.length > 0 && emailForm.emailInput.$invalid) {
                            this.isInvalidFormat = true;
                        }
                        else {
                            this.isInvalidFormat = false;
                        }
                        return true;
                    };
                    ProfileCreateModalController.prototype.checkForEmailsMatch = function (emailForm) {
                        if (emailForm.emailInput.$viewValue.length === 0 || emailForm.confirmEmailInput.$viewValue.length === 0) {
                            this.showErrorMessage = false;
                        }
                        else if (emailForm.emailInput.$dirty && emailForm.confirmEmailInput.$dirty && this.enteredEmailId !== this.enteredConfirmEmailId) {
                            this.showErrorMessage = true;
                        }
                        else {
                            this.showErrorMessage = false;
                        }
                    };
                    ProfileCreateModalController.prototype.checkForFormValidity = function (emailForm) {
                        if (emailForm.emailInput.$dirty && emailForm.confirmEmailInput.$dirty && emailForm.$valid) {
                            if (this.enteredEmailId !== this.enteredConfirmEmailId) {
                                this.showErrorMessage = true;
                                return false;
                            }
                            this.showErrorMessage = false;
                            return true;
                        }
                        else {
                            return false;
                        }
                    };
                    ProfileCreateModalController.prototype.setLabelAnimation = function (event) {
                        event.target.classList.add('border-bottom-on-focus');
                        if (event.target.classList.contains('email-input')) {
                            $('.email-input-label').addClass('label-transitions');
                            var shortLabel = this.$translate.instant('ute.noProfile.createProfileModal.enterMailIdPlaceholderShort');
                            $('.email-input-label').html(shortLabel);
                        }
                        else if (event.target.classList.contains('confirm-email-input')) {
                            $('.confirm-email-input-label').addClass('label-transitions');
                        }
                    };
                    ProfileCreateModalController.prototype.resetLabelAnimationAndProcessInput = function (event, emailForm) {
                        event.target.classList.remove('border-bottom-on-focus');
                        this.checkForEmailsMatch(emailForm);
                        if (event.target.value.length === 0) {
                            if (event.target.classList.contains('email-input')) {
                                $('.email-input-label').removeClass('label-transitions');
                                var longLabel = this.$translate.instant('ute.noProfile.createProfileModal.enterMailIdPlaceholder');
                                $('.email-input-label').html(longLabel);
                            }
                            else if (event.target.classList.contains('confirm-email-input')) {
                                $('.confirm-email-input-label').removeClass('label-transitions');
                            }
                        }
                    };
                    ProfileCreateModalController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    ProfileCreateModalController.prototype.closeModal = function (useOldEmail) {
                        var result = {
                            email: useOldEmail ? this.existingEmail.email : this.enteredEmailId
                        };
                        this.$modalInstance.close(result);
                    };
                    ProfileCreateModalController.$inject = [
                        '$modalInstance',
                        'ute.common.profile.edit.service',
                        'existingEmail',
                        '$translate'
                    ];
                    ProfileCreateModalController.controllerName = 'ute.common.profile.create.modal.controller';
                    return ProfileCreateModalController;
                }());
                edit.ProfileCreateModalController = ProfileCreateModalController;
                angular.module('ute.common.profile.edit').controller('ute.common.profile.create.modal.controller', ProfileCreateModalController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                (function (ModificationType) {
                    ModificationType[ModificationType["EDIT"] = 0] = "EDIT";
                    ModificationType[ModificationType["RESET"] = 1] = "RESET";
                })(edit.ModificationType || (edit.ModificationType = {}));
                var ModificationType = edit.ModificationType;
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                angular.module('ute.common.profile.edit').run(profileEditRoutesConfig);
                profileEditRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.profile.edit.service'];
                function profileEditRoutesConfig(routerHelper, profileEditService) {
                    var config = profileEditService.getConfig();
                    routerHelper.configureStates([
                        {
                            name: config.advanced.changeUsername.success.state,
                            url: '/' + config.advanced.changeUsername.success.state,
                            controller: config.advanced.changeUsername.success.controllerName,
                            controllerAs: 'profileEditSuccessCtrl',
                            templateUrl: config.advanced.changeUsername.success.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['public'] }
                            }
                        }
                    ]);
                }
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var DisplayUsernameAndPasswordController = (function () {
                    /* @ngInject */
                    function DisplayUsernameAndPasswordController(profileEditService, userService, $window, $modal, scope) {
                        var _this = this;
                        this.profileEditService = profileEditService;
                        this.userService = userService;
                        this.$window = $window;
                        this.$modal = $modal;
                        this.scope = scope;
                        this.isIE = false;
                        this.showPasswordTips = false;
                        this.showConfirmPasswordTips = false;
                        this.UPDATED_OK = 0;
                        this.billingTypeNumber = '-1';
                        this.hasAutoRegAccess = false;
                        this.editOnClick = function () {
                            if (_this.isEditable) {
                                _this.profileEditService.setEditModeOn();
                            }
                        };
                        this.setAutoRegAccess = function () {
                            if (_this.autoRegAccess) {
                                _this.hasAutoRegAccess = true;
                            }
                            else {
                                _this.hasAutoRegAccess = false;
                            }
                        };
                        this.setBillingType = function () {
                            if (_this.billingType === 'INVOICE') {
                                _this.billingTypeNumber = '0';
                            }
                            else if (_this.billingType === 'E_BILL') {
                                _this.billingTypeNumber = '1';
                            }
                        };
                        this.myRogersProfileExists = function () {
                            if (_this.userInfo && _this.userInfo.errorCode === 60001) {
                                return false;
                            }
                            return true;
                        };
                        this.cancelEditOnClick = function () {
                            _this.profileEditService.setEditModeOff();
                        };
                        this.changeUsernameOnClick = function () {
                            if (_this.isEditUsername) {
                                _this.profileEditService.changeUsername()
                                    .then(function (response) {
                                    if (response && response.backendCode === _this.UPDATED_OK) {
                                        _this.userInfo = _this.userService.getUser();
                                    }
                                });
                            }
                        };
                        this.changePasswordOnClick = function (form) {
                            _this.profileEditService.changePassword().then(function () {
                                _this.$window.history.pushState({}, '', '#/profile');
                            }).finally(function () {
                                form.$setPristine();
                                form.$setUntouched();
                            });
                        };
                        this.isPwAtLeastOneLetterNOneNum = function (newPassword) {
                            var regexAtLeastOneLetterNOneNum = /^(?=.*[A-Za-z])(?=.*\d).{2,}$/;
                            return regexAtLeastOneLetterNOneNum.test(newPassword);
                        };
                        this.isPwdAtLeastEightCharacters = function (newPassword) {
                            return newPassword && newPassword.length >= 8;
                        };
                        this.sendAutoRegMail = function (result) {
                            _this.profileEditService.sendAutoRegMail(result.email, _this.billingTypeNumber).then(function (response) {
                                if (response.profileSucessResponse && response.profileSucessResponse.status === '200') {
                                    if (response.profileSucessResponse.data.detailsList[0].guid && response.profileSucessResponse.data.detailsList[0].guid.trim().length > 0) {
                                        _this.createMyRogersProfileLink();
                                    }
                                    else {
                                        _this.createMyRogersProfileSuccess(result.email);
                                    }
                                }
                                else {
                                    _this.createMyRogersProfileError();
                                }
                            }, function (error) {
                                _this.createMyRogersProfileError();
                            });
                        };
                        this.resetPassword = function () {
                            console.log('resetPassword', _this.$modal);
                            _this.$modal.open({
                                templateUrl: _this.moduleConfig.advanced.resetPassword.templateUrl,
                                controller: _this.moduleConfig.advanced.resetPassword.controllerName,
                                controllerAs: 'profileResetPasswordModal',
                                size: _this.moduleConfig.advanced.resetPassword.modalSize,
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {
                                    'userInfo': _this.userInfo
                                }
                            }).result.then(function (result) {
                                // $modal.close() will get into here.
                                console.log('$modal.close.result:', result);
                            }, function (result) {
                                // dismissed here.
                                console.log('$modal.dismiss.result:', result);
                            });
                        };
                        this.createMyRogersProfile = function () {
                            _this.$modal.open({
                                templateUrl: _this.moduleConfig.advanced.createMyRogersProfile.templateUrl,
                                controller: _this.moduleConfig.advanced.createMyRogersProfile.controllerName,
                                controllerAs: 'createMyRogersProfileModal',
                                size: 'custom-width',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal transparent-bkg',
                                resolve: {
                                    'existingEmail': { email: _this.existingEmail }
                                }
                            }).result.then(function (result) {
                                if (_this.billingTypeNumber === '-1') {
                                    _this.profileEditService.getBillType().then(function (response) {
                                        if (response.status === 200) {
                                            if (response.billingtype) {
                                                _this.billingType = response.billingtype;
                                                _this.setBillingType();
                                                _this.sendAutoRegMail(result);
                                            }
                                        }
                                    }, function (error) {
                                        _this.createMyRogersProfileError();
                                    });
                                }
                                else if (_this.billingTypeNumber === '1' || _this.billingTypeNumber === '0') {
                                    _this.sendAutoRegMail(result);
                                }
                                else {
                                    _this.createMyRogersProfileError();
                                }
                            });
                        };
                        this.createMyRogersProfileSuccess = function (email) {
                            _this.scope.existingEmail = email;
                            _this.$modal.open({
                                templateUrl: _this.moduleConfig.advanced.createMyRogersProfileSuccess.templateUrl,
                                size: 'custom-width',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal transparent-bkg',
                                scope: _this.scope
                            }).result.then(function (result) {
                                _this.profileEditService.getUserInfoAfterProfileCreation().then(function (response) {
                                    _this.userInfo = response;
                                });
                            });
                        };
                        this.createMyRogersProfileLink = function () {
                            _this.$modal.open({
                                templateUrl: _this.moduleConfig.advanced.createMyRogersProfileLink.templateUrl,
                                size: 'custom-width',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal transparent-bkg',
                            }).result.then(function (result) {
                                _this.profileEditService.getUserInfoAfterProfileCreation().then(function (response) {
                                    _this.userInfo = response;
                                });
                            });
                        };
                        this.createMyRogersProfileError = function () {
                            _this.$modal.open({
                                templateUrl: _this.moduleConfig.advanced.createMyRogersProfileError.templateUrl,
                                size: 'custom-width',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal transparent-bkg',
                            }).result.then(function (result) {
                                _this.createMyRogersProfile();
                            });
                        };
                        this.UIModel = profileEditService.getUIModel;
                        this.serviceModel = profileEditService.getModel;
                        this.inputModel = profileEditService.getInputModel;
                        this.moduleConfig = profileEditService.getConfig();
                        this.isCare = userService.isCare();
                        profileEditService.forgotPasswordOneviewInit();
                        this.isInternetExplorer();
                        if (this.isCare) {
                            profileEditService.getWirelessRecoveryNumber();
                            this.wirelessRecoveryNumberValue = profileEditService.getWirelessRecoveryNumberValue;
                            this.emptyWirelessRecoveryNumber = '___ - ___ - ___';
                            this.setBillingType();
                            this.setAutoRegAccess();
                        }
                    }
                    DisplayUsernameAndPasswordController.prototype.isInternetExplorer = function () {
                        if (this.$window.document.documentMode) {
                            this.isIE = true;
                        }
                    };
                    DisplayUsernameAndPasswordController.$inject = ['ute.common.profile.edit.service',
                        'ute.common.user.service',
                        '$window',
                        '$modal',
                        '$scope'];
                    return DisplayUsernameAndPasswordController;
                }());
                angular.module('ute.common.profile.edit').controller('ute.common.profile.edit.usernameAndPassword.controller', DisplayUsernameAndPasswordController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var DisplayUsernameAndPasswordDirective = (function () {
                    /* @ngInject */
                    function DisplayUsernameAndPasswordDirective(profileEditService) {
                        this.profileEditService = profileEditService;
                        this.restrict = 'E';
                        this.templateUrl = this.profileEditService.getConfig().advanced.DisplayUsernameAndPasswordDirective.templateUrl;
                        this.controller = this.profileEditService.getConfig().advanced.DisplayUsernameAndPasswordDirective.controllerName;
                        this.controllerAs = 'profileEditUserNPass';
                        this.bindToController = true;
                        this.scope = {
                            userInfo: '=',
                            isResetFlow: '=',
                            isEditable: '=',
                            isEditUsername: '=',
                            existingEmail: '=',
                            billingType: '=',
                            autoRegAccess: '='
                        };
                        // this.link = this.linkFn;
                    }
                    DisplayUsernameAndPasswordDirective.factory = function () {
                        var directive = function (profileEditService) { return new DisplayUsernameAndPasswordDirective(profileEditService); };
                        directive.$inject = ['ute.common.profile.edit.service'];
                        return directive;
                    };
                    return DisplayUsernameAndPasswordDirective;
                }());
                angular.module('ute.common.profile.edit').directive('uteProfileEditUsernameAndPassword', DisplayUsernameAndPasswordDirective.factory());
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var ProfileEditModalController = (function () {
                    /* @ngInject */
                    function ProfileEditModalController($modalInstance, profileEditService, errorCode, email) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.profileEditService = profileEditService;
                        this.errorCode = errorCode;
                        this.email = email;
                        this.backToDevicePage = function () {
                            _this.$modalInstance.dismiss('cancel');
                            // this.profileEditService.backToDevice();
                        };
                        if (errorCode) {
                            this.errorMessage = errorCode.frontendMessageKey;
                            this.modalIcon = errorCode.modalIcon;
                        }
                        if (email) {
                            this.displayEmail = email;
                        }
                    }
                    ProfileEditModalController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    ProfileEditModalController.$inject = [
                        '$modalInstance',
                        'ute.common.profile.edit.service',
                        'ute.common.profile.edit.service.errorHandler',
                        'email'
                    ];
                    return ProfileEditModalController;
                }());
                edit.ProfileEditModalController = ProfileEditModalController;
                angular.module('ute.common.profile.edit').controller('ute.common.profile.edit.modal.controller', ProfileEditModalController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            applicationId: 'ute-application-id',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            changeUsernameApiUrl: 'v1/profile/changeUsername',
                            changePasswordApiUrl: 'v1/profile/changePassword',
                            forgotPasswordOneviewApiUrl: 'v1/profile/forgotPasswordOneView',
                            wirelessRecoveryNumberApiUrl: 'v1/SelfServeAutomation/recoveryNumber',
                            getContactInfoApiUrl: 'v1/SelfServeAutomation/getContactInfo',
                            getUserInfo: 'v1/SelfServeAutomation/manageMyOnlineProfileQuery',
                            getMWAutoCreateApiUrl: 'v1/user/registration/mwautocreate',
                            getBillTypeV2Url: 'v1/SelfServeAutomation/getBillTypeV2',
                            getCreateProfileUrl: 'v1/autoreg/createProfile'
                        },
                        advanced: {
                            DisplayUsernameAndPasswordDirective: {
                                controllerName: 'ute.common.profile.edit.usernameAndPassword.controller',
                                templateUrl: 'module/profileEditDirective/profile.edit.directive.view.html'
                            },
                            changeUsername: {
                                success: {
                                    state: 'sso/changeUsernameSuccess',
                                    controllerName: ute.common.profile.edit.ProfileEditUsernameSuccessController.controllerName,
                                    templateUrl: 'module/profileEditUsername/profile.edit.username.success.view.html'
                                },
                                failure: {
                                    controllerName: 'ute.common.profile.edit.modal.controller',
                                    templateUrl: 'module/profileEditModal/profile.edit.modal.fail.view.html'
                                }
                            },
                            resetPassword: {
                                controllerName: ute.common.profile.edit.ProfileResetPasswordModalController.controlerName,
                                templateUrl: ute.common.profile.edit.ProfileResetPasswordModalController.templateUrl,
                                modalSize: 'md'
                            },
                            createMyRogersProfile: {
                                templateUrl: 'module/profileCreateMyRogersProfileModal/profile.create.modal.html',
                                controllerName: ute.common.profile.edit.ProfileCreateModalController.controllerName
                            },
                            createMyRogersProfileSuccess: {
                                templateUrl: 'module/profileCreateMyRogersProfileModal/profile.create.success.modal.html',
                                controllerName: ute.common.profile.edit.ProfileCreateModalController.controllerName
                            },
                            createMyRogersProfileLink: {
                                templateUrl: 'module/profileCreateMyRogersProfileModal/profile.create.link.modal.html',
                                controllerName: ute.common.profile.edit.ProfileCreateModalController.controllerName
                            },
                            createMyRogersProfileError: {
                                templateUrl: 'module/profileCreateMyRogersProfileModal/profile.create.error.modal.html',
                                controllerName: ute.common.profile.edit.ProfileCreateModalController.controllerName
                            }
                        }
                    };
                }
                edit.DefaultConfigFactory = DefaultConfigFactory;
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.UPDATED_OK = 0;
                    BackEndErrorCode.GENERIC_ERROR = 17102;
                    BackEndErrorCode.PROFILE_MANAGEMENT_MIDDLEWARE_FAILURE = 17053;
                    BackEndErrorCode.CHANGE_USERNAME_FAILED_CODE = 17081;
                    BackEndErrorCode.PROFILE_MANAGEMENT_GENERIC_FAILURE = 17051;
                    BackEndErrorCode.PASSWORD_MANAGEMENT_MIDDLEWARE_FAILURE = 17054;
                    BackEndErrorCode.CHANGE_PASSWORD_FAILED_CODE = 17071;
                    BackEndErrorCode.PASSWORD_MANAGEMENT_GENERIC_FAILURE = 17052;
                    BackEndErrorCode.PROFILE_ALREADY_EXIST_MIDDLEWARE_FAILURE = 17058;
                    BackEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE = 17056;
                    BackEndErrorCode.REQUEST_FORGOT_PASSWORD_FAILED_CODE = 17091;
                    BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST = 17095;
                    BackEndErrorCode.FORGOT_PASSWORD_FAILED_CODE = 17055;
                    return BackEndErrorCode;
                }());
                var ProfileEditServiceProvider = (function () {
                    /* @ngInject */
                    function ProfileEditServiceProvider() {
                        var _this = this;
                        //private getContactEmail: string;
                        this.config = edit.DefaultConfigFactory();
                        this.errorCodesMap = {};
                        /* @ngInject */
                        this.$get = function ($injector, $state, $http, $modal, $document, $q) {
                            _this.$http = $http;
                            _this.$state = $state;
                            _this.$modal = $modal;
                            _this.$document = $document;
                            _this.$injector = $injector;
                            _this.$q = $q;
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.languageService = $injector.get('ute.blocks.language.switcher');
                            return {
                                getModel: _this.getModel,
                                setModel: _this.setModel,
                                getInputModel: _this.getInputModel,
                                setInputModel: _this.setInputModel,
                                getUIModel: _this.getUIModel,
                                getConfig: _this.getConfig,
                                isDataCallInProgressFn: _this.isDataCallInProgressFn,
                                isEditModeFn: _this.isEditModeFn,
                                setEditModeOn: _this.setEditModeOn,
                                setEditModeOff: _this.setEditModeOff,
                                changeUsername: _this.changeUsername,
                                changePassword: _this.changePassword,
                                createMyRogersProfile: _this.createMyRogersProfile,
                                resetPasswordOneView: _this.resetPasswordOneView,
                                forgotPasswordOneviewInit: _this.forgotPasswordOneviewInit,
                                getWirelessRecoveryNumber: _this.getWirelessRecoveryNumber,
                                getWirelessRecoveryNumberValue: _this.getWirelessRecoveryNumberValue,
                                getUserInfoAfterProfileCreation: _this.getUserInfoAfterProfileCreation,
                                sendAutoRegMail: _this.sendAutoRegMail,
                                getBillType: _this.getBillType
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.addCode = function (code) {
                            _this.errorCodesMap[code.frontendCode] = code;
                        };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.UPDATED_OK,
                                controllerName: '',
                                templateUrl: '',
                                modalIcon: '',
                                modalSize: '',
                                backendCode: BackEndErrorCode.UPDATED_OK
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.GENERIC_ERROR,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.GENERIC_ERROR
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.PROFILE_MANAGEMENT_MIDDLEWARE_FAILURE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.PROFILE_MANAGEMENT_MIDDLEWARE_FAILURE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.CHANGE_USERNAME_FAILED_CODE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.CHANGE_USERNAME_FAILED_CODE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.PROFILE_MANAGEMENT_GENERIC_FAILURE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.PROFILE_MANAGEMENT_GENERIC_FAILURE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.PASSWORD_MANAGEMENT_MIDDLEWARE_FAILURE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.PASSWORD_MANAGEMENT_MIDDLEWARE_FAILURE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.CHANGE_PASSWORD_FAILED_CODE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.CHANGE_PASSWORD_FAILED_CODE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.PASSWORD_MANAGEMENT_GENERIC_FAILURE,
                                frontendMessageKey: 'ute.common.error.general',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.PASSWORD_MANAGEMENT_GENERIC_FAILURE
                            });
                            _this.addCode({
                                frontendCode: edit.FrontEndErrorCode.PROFILE_ALREADY_EXIST_MIDDLEWARE_FAILURE,
                                frontendMessageKey: 'ute.profile.error.profile_already_exist_middleware_failure',
                                controllerName: _this.getConfig().advanced.changeUsername.failure.controllerName,
                                templateUrl: _this.getConfig().advanced.changeUsername.failure.templateUrl,
                                modalIcon: 'ute.profile.images.errorWarning',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.PROFILE_ALREADY_EXIST_MIDDLEWARE_FAILURE
                            });
                        };
                        /**
                         * System does not need to use the function for now
                         */
                        // private goToState: (state: string) => angular.IPromise<any> = (state: string) => {
                        //     return this.$state.go(state);
                        // };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                inputModel: null,
                                UI: {
                                    modificationType: edit.ModificationType.EDIT,
                                    isDataCallInProgress: false,
                                    isEditMode: false,
                                    isUpdateUsernameCallInProgress: false,
                                    isUpdatePasswordCallInProgress: false,
                                    isUpdateWirelessRecoveryNumber: false,
                                    isForgotPasswordOneviewCallInProgress: false,
                                    showOneviewResetPasswordSuccess: false,
                                    showOneviewResetPasswordFailure: false
                                },
                                form: {
                                    changeUsername: {
                                        username: null
                                    },
                                    changePassword: {
                                        oldPassword: null,
                                        newPassword: null,
                                        confirmPassword: null
                                    },
                                },
                                wirelessRecoveryNumber: null
                            };
                        };
                        this.resetFormUsername = function () {
                            _this.model.form.changeUsername.username = '';
                        };
                        this.resetFormPassword = function () {
                            _this.model.form.changePassword.oldPassword = '';
                            _this.model.form.changePassword.newPassword = '';
                            _this.model.form.changePassword.confirmPassword = '';
                        };
                        /**
                         * @returns {INavigationModel}
                         */
                        this.getModel = function () { return _this.model; };
                        /**
                         * @param dataModel - set data model
                         */
                        this.setModel = function (dataModel) { return _this.model = dataModel; };
                        /**
                         * @returns {INavigationModel}
                         */
                        this.getInputModel = function () { return _this.model.inputModel; };
                        /**
                         * @param inputModel - set data input model
                         */
                        this.setInputModel = function (inputModel) { return _this.model.inputModel = inputModel; };
                        /**
                         * @returns {INavigationModel}
                         */
                        this.getUIModel = function () { return _this.model.UI; };
                        this.getWirelessRecoveryNumberValue = function () { return _this.model.wirelessRecoveryNumber; };
                        /**
                         * @returns ng.IPromise<string>
                         */
                        this.getFormUsername = function () {
                            return new _this.$q(function (resolve) { return resolve(_this.model.form.changeUsername.username); });
                        };
                        /**
                         * @returns {INavigationServiceConfig}
                         */
                        this.getConfig = function () { return angular.copy(_this.config); };
                        /**
                         * Check data call in progress or not
                         */
                        this.isDataCallInProgressFn = function () { return _this.model.UI.isDataCallInProgress; };
                        /**
                         * get Edit Mode
                         */
                        this.isEditModeFn = function () { return _this.model.UI.isEditMode; };
                        /**
                         * Switch Edit mode on or off
                         */
                        this.setEditModeOn = function () { return _this.model.UI.isEditMode = true; };
                        this.setEditModeOff = function () {
                            _this.model.UI.isEditMode = false;
                            _this.$document.scrollTop(0);
                        };
                        this.findCodeEntry = function (backendCode) {
                            return _.find(_this.errorCodesMap, function (ce) {
                                return ce.backendCode === backendCode;
                            }) || _this.errorCodesMap[edit.FrontEndErrorCode.GENERIC_ERROR];
                        };
                        this.changeUsername = function () {
                            return _this._changeUsername().then(function (result) {
                                if (result && result.backendCode === BackEndErrorCode.UPDATED_OK) {
                                    /**
                                     * when change username successful
                                     * logout the existing user and redirect to singin page, use the following code
                                     * this.userService.signout();
                                     * this.goToState(this.getConfig().advanced.changeUsername.success.state);
                                     */
                                    _this.getConfig().advanced.changeUsername.success.callback(_this.$injector, _this.model.form.changeUsername.username, false);
                                    _this.userService.setUsername(_this.model.form.changeUsername.username);
                                    var $cookies = _this.$injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                                    var isRememberMeFlag = $cookies.get('rememberMeFlag');
                                    if (isRememberMeFlag === 'true') {
                                        $cookies.put('rememberMe', _this.model.form.changeUsername.username, { path: '/' });
                                    }
                                    /**
                                     * Reset username values
                                     */
                                    _this.model.form.changeUsername.username = '';
                                    return result;
                                }
                                _this.openModalPopup(result);
                                return result;
                            }).catch(function (error) {
                                _this.userService.signout();
                                _this.openModalPopup(error);
                                return error;
                            }).finally(function () {
                                _this.setEditModeOff();
                                _this.resetFormUsername();
                            });
                        };
                        /**
                         * Change username Server side Call
                         */
                        this._changeUsername = function () {
                            var request = {
                                newEmail: _this.model.form.changeUsername.username
                            };
                            // console.log('changeUsername.request =>', request);
                            _this.model.UI.isUpdateUsernameCallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.changeUsernameApiUrl), request)
                                .then(_this.processChangeUsernameSuccess)
                                .catch(_this.processChangeUsernameError)
                                .finally(_this.finalizeChangeUsernameCall);
                        };
                        this.processChangeUsernameSuccess = function (response) {
                            // console.log('processChangeUsernameSuccess.response =>', response);
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                return _this.errorCodesMap[edit.FrontEndErrorCode.UPDATED_OK];
                            }
                            else {
                                return _this.findCodeEntry(backendCode);
                            }
                        };
                        this.processChangeUsernameError = function (error) {
                            // console.log('processChangeUsernameError.error =>', error);
                            var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            return _this.findCodeEntry(backendCode);
                            // return this.findCodeEntry(BackEndErrorCode.GENERIC_ERROR);
                        };
                        this.finalizeChangeUsernameCall = function () {
                            // console.log('finalizeChangeUsernameCall');
                            _this.model.UI.isUpdateUsernameCallInProgress = false;
                        };
                        /*     private getContactInfo: () => void = () => {
                              let request = {
                                ban: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : ''
                              };
                              this.$http.post(this.securityService.getBackendUrl(this.getConfig().basic.getContactInfoApiUrl), request)
                                .then((response: ng.IHttpPromiseCallbackArg<any>) => {
                                  this.getContactEmail = response.data.emailAddress;
                                })
                                .catch(() => {
                                  this.getContactEmail = '';
                                });
                            } */
                        this.getWirelessRecoveryNumber = function () {
                            var request = {
                                ban: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : ''
                            };
                            _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.wirelessRecoveryNumberApiUrl), request)
                                .then(function (response) {
                                _this.model.wirelessRecoveryNumber = response.data.recoveryNumber;
                            })
                                .catch(function () {
                                _this.model.wirelessRecoveryNumber = '';
                            });
                        };
                        this.getUserInfoAfterProfileCreation = function () {
                            var request = {
                                ban: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : ''
                            };
                            var deferred = _this.$q.defer();
                            _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.getUserInfo), request)
                                .then(function (response) {
                                deferred.resolve(response.data);
                            })
                                .catch(function (error) {
                                deferred.reject(error);
                            });
                            return deferred.promise;
                        };
                        this.getBillType = function () {
                            var request = {
                                accountNumber: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : '',
                                ban: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : ''
                            };
                            var deferred = _this.$q.defer();
                            _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.getBillTypeV2Url), request)
                                .then(function (response) {
                                deferred.resolve(response.data);
                            })
                                .catch(function (error) {
                                deferred.reject(error);
                            });
                            return deferred.promise;
                        };
                        this.sendAutoRegMail = function (email, billType) {
                            var request = {
                                language: _this.languageService.getCurrentLanguage(),
                                onlineBillInd: billType === '1' ? 'Y' : 'N',
                                email: email,
                                accountNumber: sessionStorage.getItem('accountNumber') ? sessionStorage.getItem('accountNumber').toString() : ''
                            };
                            var deferred = _this.$q.defer();
                            _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.getCreateProfileUrl), request)
                                .then(function (response) {
                                deferred.resolve(response.data);
                            })
                                .catch(function (error) {
                                deferred.reject(error);
                            });
                            return deferred.promise;
                        };
                        this.changePassword = function () {
                            return _this._changePassword().then(function (result) {
                                switch (result.frontendCode) {
                                    case ute.common.profile.edit.FrontEndErrorCode.UPDATED_OK:
                                        _this.setEditModeOff();
                                        break;
                                    default:
                                        _this.openModalPopup(result);
                                        break;
                                }
                                return result;
                            }).catch(function (error) {
                                _this.openModalPopup(error);
                                return error;
                            }).finally(function () {
                                _this.resetFormPassword();
                            });
                        };
                        /**
                         * Change Password Server side Call
                         */
                        this._changePassword = function () {
                            var request = {
                                oldPassword: _this.model.form.changePassword.oldPassword,
                                newPassword: _this.model.form.changePassword.newPassword,
                                confirmPassword: _this.model.form.changePassword.confirmPassword
                            };
                            // console.log('changePassword.request =>', request);
                            _this.model.UI.isUpdatePasswordCallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.changePasswordApiUrl), request)
                                .then(_this.processChangePasswordSuccess)
                                .catch(_this.processChangePasswordError)
                                .finally(_this.finaliseChangePasswordCall);
                        };
                        this.processChangePasswordSuccess = function (response) {
                            // console.log('processChangePasswordSuccess.response =>', response);
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                return _this.errorCodesMap[edit.FrontEndErrorCode.UPDATED_OK];
                            }
                            else {
                                return _this.findCodeEntry(backendCode);
                            }
                        };
                        this.processChangePasswordError = function (error) {
                            // console.log('processChangePasswordError.error =>', error);
                            return _this.findCodeEntry(BackEndErrorCode.GENERIC_ERROR);
                        };
                        this.finaliseChangePasswordCall = function () {
                            // console.log('finaliseChangePasswordCall');
                            _this.model.UI.isUpdatePasswordCallInProgress = false;
                            /**
                             * Reset all password values
                             */
                            _this.model.form.changePassword.oldPassword = '';
                            _this.model.form.changePassword.newPassword = '';
                            _this.model.form.changePassword.confirmPassword = '';
                        };
                        this.resetPasswordOneView = function (email) {
                            _this._resetPasswordOneView(email).then(function (result) {
                                if (result && result.backendCode === BackEndErrorCode.UPDATED_OK) {
                                    /**
                                     * when reset password successful
                                     */
                                    _this.model.UI.showOneviewResetPasswordSuccess = true;
                                    return;
                                }
                                // this.openModalPopup(result);
                                return result;
                            }).catch(function (error) {
                                // this.openModalPopup(error);
                                return error;
                            }).finally(function () {
                                // console.log('_resetPasswordOneView.finally');
                            });
                        };
                        /**
                         * Change username Server side Call
                         */
                        this._resetPasswordOneView = function (email) {
                            _this.forgotPasswordOneviewInit();
                            var request = {
                                email: email
                            };
                            // console.log('reset password for one view request =>', request);
                            _this.model.UI.isForgotPasswordOneviewCallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.forgotPasswordOneviewApiUrl), request)
                                .then(_this.processForgotPasswordOneviewSuccess)
                                .catch(_this.processForgotPasswordOneviewError)
                                .finally(_this.finalizeForgotPasswordOneview);
                        };
                        this.processForgotPasswordOneviewSuccess = function (response) {
                            // console.log('processForgotPasswordOneviewSuccess.response =>', response);
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                _this.showForgotPasswordOneviewSuccess();
                                return _this.errorCodesMap[edit.FrontEndErrorCode.UPDATED_OK];
                            }
                            else {
                                _this.showForgotPasswordOneviewFailure();
                                return _this.findCodeEntry(backendCode);
                            }
                        };
                        this.processForgotPasswordOneviewError = function (error) {
                            // console.log('processForgotPasswordOneviewError.error =>', error);
                            _this.showForgotPasswordOneviewFailure();
                            return _this.findCodeEntry(BackEndErrorCode.GENERIC_ERROR);
                        };
                        this.finalizeForgotPasswordOneview = function () {
                            // console.log('finalizeForgotPasswordOneview');
                            _this.model.UI.isForgotPasswordOneviewCallInProgress = false;
                        };
                        this.forgotPasswordOneviewInit = function () {
                            _this.model.UI.showOneviewResetPasswordSuccess = false;
                            _this.model.UI.showOneviewResetPasswordFailure = false;
                            _this.model.UI.isForgotPasswordOneviewCallInProgress = false;
                        };
                        this.showForgotPasswordOneviewSuccess = function () {
                            _this.model.UI.showOneviewResetPasswordSuccess = true;
                            _this.model.UI.showOneviewResetPasswordFailure = false;
                        };
                        this.showForgotPasswordOneviewFailure = function () {
                            _this.model.UI.showOneviewResetPasswordSuccess = false;
                            _this.model.UI.showOneviewResetPasswordFailure = true;
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$modal',
                            '$document',
                            '$q',
                        ];
                        this.resetModel();
                        this.addCodes();
                    }
                    ;
                    ProfileEditServiceProvider.prototype.openModalPopup = function (errorHandler) {
                        var _this = this;
                        this.$modal.open({
                            templateUrl: errorHandler.templateUrl,
                            controller: errorHandler.controllerName,
                            controllerAs: 'profileEditModal',
                            size: errorHandler.modalSize,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {
                                'ute.common.profile.edit.service.errorHandler': errorHandler,
                                'email': this.getFormUsername()
                            }
                        }).result.then(function (result) {
                            // $modal.close() will get into here.
                            // console.log('$modal.close.result:', result);
                            _this.setEditModeOff();
                        }, function (result) {
                            // dismissed here.
                            // console.log('$modal.dismiss.result:', result);
                            _this.setEditModeOff();
                        });
                    };
                    ProfileEditServiceProvider.$inject = [];
                    return ProfileEditServiceProvider;
                }());
                angular.module('ute.common.profile.edit').provider('ute.common.profile.edit.service', ProfileEditServiceProvider);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var ProfileEditUsernameSuccessController = (function () {
                    /* @ngInject */
                    function ProfileEditUsernameSuccessController($document) {
                        this.$document = $document;
                        $document.scrollTop(0);
                    }
                    ProfileEditUsernameSuccessController.$inject = ['$document'];
                    ProfileEditUsernameSuccessController.controllerName = 'ute.common.profile.edit.username.success.controller';
                    return ProfileEditUsernameSuccessController;
                }());
                edit.ProfileEditUsernameSuccessController = ProfileEditUsernameSuccessController;
                angular.module('ute.common.profile.edit').controller(ProfileEditUsernameSuccessController.controllerName, ProfileEditUsernameSuccessController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var profile;
        (function (profile) {
            var edit;
            (function (edit) {
                'use strict';
                var ProfileResetPasswordModalController = (function () {
                    /* @ngInject */
                    function ProfileResetPasswordModalController($modalInstance, profileEditService, userInfo) {
                        this.$modalInstance = $modalInstance;
                        this.profileEditService = profileEditService;
                        this.userInfo = userInfo;
                    }
                    ProfileResetPasswordModalController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    ProfileResetPasswordModalController.prototype.continueProcess = function () {
                        console.log('continueProcess');
                        console.log('continueProcess.userInfo:', this.userInfo);
                        this.$modalInstance.dismiss('cancel');
                        this.profileEditService.resetPasswordOneView(this.userInfo.userName);
                    };
                    ProfileResetPasswordModalController.$inject = [
                        '$modalInstance',
                        'ute.common.profile.edit.service',
                        'userInfo'
                    ];
                    ProfileResetPasswordModalController.controlerName = 'ute.common.profile.reset.password.modal.controller';
                    ProfileResetPasswordModalController.templateUrl = 'module/profileResetPasswordModal/profile.reset.password.modal.view.html';
                    return ProfileResetPasswordModalController;
                }());
                edit.ProfileResetPasswordModalController = ProfileResetPasswordModalController;
                angular.module('ute.common.profile.edit').controller(ProfileResetPasswordModalController.controlerName, ProfileResetPasswordModalController);
            })(edit = profile.edit || (profile.edit = {}));
        })(profile = common.profile || (common.profile = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                angular.module('ute.promise.to.pay').run(promiseToPayRoutesConfig);
                promiseToPayRoutesConfig.$inject = ['ute.blocks.router', 'ute.promise.to.pay.service'];
                /* @ngInject */
                function promiseToPayRoutesConfig(routerHelper, promiseToPayService) {
                    routerHelper.configureStates(getStates(promiseToPayService));
                }
                function getStates(promiseToPayService) {
                    var promiseToPayRootState = promiseToPayService.getConfig().basic.ptpRootState;
                    return [
                        {
                            name: promiseToPayRootState,
                            abstract: true,
                            url: '/' + promiseToPayRootState,
                            controller: promiseToPayService.getConfig().basic.controllerName,
                            controllerAs: 'ptp',
                            templateUrl: promiseToPayService.getConfig().basic.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            }
                        },
                        {
                            name: promiseToPayService.getEntryState(),
                            url: '/' + promiseToPayService.getConfig().basic.ptpStartState + '/:id',
                            controller: promiseToPayService.getConfig().basic.mainControllerName,
                            controllerAs: 'ptpSelection',
                            templateUrl: promiseToPayService.getConfig().basic.mainTemplateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            }
                        }
                    ];
                }
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayMainController = (function () {
                    /* @ngInject */
                    function PromiseToPayMainController(promiseToPayService) {
                        this.promiseToPayService = promiseToPayService;
                    }
                    PromiseToPayMainController.controllerName = 'ute.promise.to.pay.main.controller';
                    PromiseToPayMainController.$inject = ['ute.promise.to.pay.service'];
                    return PromiseToPayMainController;
                }());
                pay.PromiseToPayMainController = PromiseToPayMainController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.main.controller', PromiseToPayMainController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var province;
        (function (province) {
            'use strict';
            var ProvinceStorage = (function () {
                /* @ngInject */
                function ProvinceStorage($cookies) {
                    var _this = this;
                    this.$cookies = $cookies;
                    this.path = '/';
                    this.domain = '.rogers.com';
                    this.provinceCookieName = 'province';
                    this.put = function (value) {
                        _this.$cookies.put(_this.provinceCookieName, value, {
                            path: _this.path,
                            domain: _this.domain
                        });
                    };
                    this.getCurrentProvince = function () {
                        return _this.$cookies.get(_this.provinceCookieName) || 'on';
                    };
                }
                ProvinceStorage.$inject = [angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'];
                return ProvinceStorage;
            }());
            angular.module('ute.blocks.province').service('ute.blocks.province.service', ProvinceStorage);
        })(province = blocks.province || (blocks.province = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
            var UtePurchaseDataController = (function () {
                /* @ngInject */
                function UtePurchaseDataController(utePurchaseDataService, $translate, $window, $filter) {
                    var _this = this;
                    this.utePurchaseDataService = utePurchaseDataService;
                    this.$translate = $translate;
                    this.$window = $window;
                    this.$filter = $filter;
                    this.availableTopupPlansList = [];
                    this.selectedPlanType = [];
                    this.isOneTimeOrMonthlyTopUpExists = {};
                    this.apiResponse = {};
                    this.purchaseDataPlansSuccessHandler = function (response) {
                        _this.apiResponse.success = true;
                        _this.modalTitle = _this.$translate.instant('ute.purchaseData.purchasingPlansSuccess.title', { 'dataPlan': _this.$filter('number')(_this.selectedPlan.size.value) + ' ' + _this.setDataPlanUnitFormat(_this.selectedPlan.size.unit) });
                        _this.resetModalFlows();
                        _this.getFocusOnClosebtn();
                        try {
                            _this.utePurchaseDataService.trackDataLayerInteraction(_this.utePurchaseDataService.getDataLayerStep().buyFlowComplete, (_this.selectedPlan.type === 'monthly') ? _this.utePurchaseDataService.getDataLayerEvent().monthlyData : _this.utePurchaseDataService.getDataLayerEvent().oneTimeData, _this.selectedPlan);
                        }
                        catch (error) {
                            console.error('data layer tracking - purchase data - complete', error);
                        }
                    };
                    this.purchaseDataPlansErrorHandler = function (error) {
                        var _self = _this;
                        _self.isLimitExceeded = false;
                        _self.consentError = '';
                        if (error && _.get(error, 'status.code')) {
                            switch (error.status.code) {
                                case '403.303':
                                    if (_self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()) {
                                        _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansError.limitExceed.titleSP');
                                        _self.consentError = _self.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDescSP');
                                    }
                                    else {
                                        _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansError.limitExceed.title');
                                        _self.consentError = _self.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDesc');
                                    }
                                    _self.isLimitExceeded = true;
                                    _self.getFocusOnClosebtn();
                                    break;
                                case '403.304':
                                    _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansError.limitExceed.title');
                                    _self.consentError = _self.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanThreeDesc');
                                    _self.isLimitExceeded = true;
                                    _self.getFocusOnClosebtn();
                                    break;
                                case '403.305':
                                    if (_self.selectedBrand === 'rogers') {
                                        if (_self.isOneTimeOrMonthlyTopUpExists.oneTime && !_self.isSelectedPlanMonthly) {
                                            _self.modalTitle = _self.$translate.instant('ute.purchaseData.warning.consentTitle');
                                            _self.consentError = _self.$translate.instant('ute.purchaseData.warning.consentDesc');
                                            _self.isWCOCFlag = true;
                                        }
                                        else {
                                            _self.genericErrorHandler();
                                        }
                                    }
                                    else {
                                        if (_self.isOneTimeOrMonthlyTopUpExists.oneTime && !_self.isSelectedPlanMonthly) {
                                            var userInfo = JSON.parse(decodeURIComponent(_self.utePurchaseDataService.getCookie('userInfo')));
                                            if (userInfo.profileType.subscriber) {
                                                // only for Profile type 'Subscribers'
                                                // _self.checkIfWCOCAuthorized();
                                                _self.setConsentErrorHandler();
                                            }
                                            else {
                                                _self.modalTitle = _self.$translate.instant('ute.purchaseData.warning.consentTitle');
                                                _self.consentError = _self.$translate.instant('ute.purchaseData.warning.consentDesc');
                                                _self.isWCOCFlag = true;
                                            }
                                        }
                                    }
                                    break;
                                default:
                                    _self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()
                                        ? _this.speedPassErrorHandler()
                                        : _this.genericErrorHandler();
                            }
                        }
                        else {
                            _self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()
                                ? _this.speedPassErrorHandler()
                                : _this.genericErrorHandler();
                        }
                    };
                    var _self = this;
                    _self.model = {};
                    _self.selectedBrand = _self.utePurchaseDataService.getConfig().basic.brand.toLowerCase();
                    _self.lang = _self.selectedBrand === 'fido' ? _self.utePurchaseDataService.getCookie('language') : _self.utePurchaseDataService.getLanguage();
                    this.accountDetailsForPurchaseTopup = {
                        accountAlias: '',
                        accountId: '',
                        serviceAlias: '',
                        serviceId: '',
                    };
                    _self.isPurchasedPlansOptionsFLow = false;
                    _self.isSelectedPlanTypeFLow = false;
                    _self.isPurchasingPlanConfirmationFLow = false;
                    _self.apiResponse = {
                        success: false,
                        error: false,
                    };
                    _self.isOneTimeOrMonthlyTopUpExists = {
                        oneTime: false,
                        monthly: false,
                    };
                    _self.consentError = '';
                    _self.limitCycleError = '';
                    _self.isWCOCFlag = false;
                    _self.selectedFlowType = '';
                    _self.availableTopupPlansList = [];
                    _self.billingDetails = {};
                    _self.selectedPlan = '';
                    _self.selectedPlanIndex = undefined;
                    _self.planSelectionError = false;
                    _self.isShareEveryThingFlow = false;
                    _self.isGenericError = false;
                    _self.isSpeedPassError = false;
                    _self.isLimitExceeded = false;
                    _self.isSelectedPlanMonthly = false;
                    _self.showEligibleAlert = false;
                    _self.isConsentAPIError = false;
                    _self.isDropDownFlow = false;
                    _self.isMobileDevice = false;
                    _self.isShareEveryThingFlow = _self.utePurchaseDataService.isShareEverything();
                    _self.getServiceId();
                    _self.geDeviceWidth();
                    angular.element(this.$window).on('resize', function (e) { _self.geDeviceWidth(); });
                }
                UtePurchaseDataController.prototype.openPurchaseDataSelectorModal = function (flow) {
                    var _self = this;
                    flow = !flow ? _self.utePurchaseDataService.getConfig().advanced.flows.purchaseDataOptions : flow;
                    _self.$modalInstance = _self.utePurchaseDataService.openPurchaseDataModal(flow, 'lg');
                    try {
                        _self.$modalInstance.opened.then(function () {
                            if (_self.isPurchasedPlansOptionsFLow) {
                                _self.utePurchaseDataService.trackDataLayerInteraction(_self.utePurchaseDataService.getDataLayerStep().addDataStep1, _self.utePurchaseDataService.getDataLayerEvent().addDataModal);
                            }
                            else {
                                if (_self.isOneTimeOrMonthlyTopUpExists.monthly || _self.isOneTimeOrMonthlyTopUpExists.oneTime) {
                                    _self.utePurchaseDataService.trackDataLayerInteraction(_self.utePurchaseDataService.getDataLayerStep().addDataStep2, (_self.isOneTimeOrMonthlyTopUpExists.monthly) ? _self.utePurchaseDataService.getDataLayerEvent().monthlyData : _self.utePurchaseDataService.getDataLayerEvent().oneTimeData);
                                }
                            }
                        });
                    }
                    catch (error) {
                        console.error('data layer tracking - purchase data - step1', error);
                    }
                };
                /* hideEligibleAlertBox (type) {
                  this.showEligibleAlert = false;
                } */
                UtePurchaseDataController.prototype.setModalTitle = function (translateKey) {
                    var _self = this;
                    return _self.$translate.instant(translateKey);
                };
                UtePurchaseDataController.prototype.setConsentErrorHandler = function (error) {
                    var _self = this;
                    _self.isConsentAPIError = true;
                    _self.modalTitle = _self.$translate.instant('ute.purchaseData.consentError.title');
                    _self.consentError = _self.$translate.instant('ute.purchaseData.consentError.desc');
                };
                UtePurchaseDataController.prototype.resetModalFlows = function () {
                    this.isPurchasedPlansOptionsFLow = false;
                    this.isSelectedPlanTypeFLow = false;
                    this.isPurchasingPlanConfirmationFLow = false;
                };
                UtePurchaseDataController.prototype.loadAvailableTopUps = function () {
                    var _this = this;
                    var _self = this;
                    var payload = _self.setTopUpPayload();
                    _self.utePurchaseDataService
                        .getListOfAvailablePlans(payload)
                        .then(function (response) {
                        if (response.length > 0) {
                            _self.availableTopupPlansList = response;
                            _self.filterPlanType(response);
                            _self.openDirectSelectedPlansFlow();
                        }
                        else {
                            _self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()
                                ? _this.speedPassErrorHandler(response.status)
                                : _this.genericErrorHandler(response.status);
                        }
                    }, function (error) {
                        if (_.has(error, 'status.code') && _.get(error, 'status.code') === '403.303') {
                            if (_self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()) {
                                _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansError.limitExceed.titleSP');
                                _self.limitCycleError = _self.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDescSP');
                            }
                            else {
                                _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansError.limitExceed.title');
                                _self.limitCycleError = _self.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDesc');
                            }
                        }
                        else {
                            _self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()
                                ? _this.speedPassErrorHandler(error)
                                : _this.genericErrorHandler(error);
                        }
                    });
                };
                UtePurchaseDataController.prototype.fetchBillingInfo = function (payload) {
                    var _self = this;
                    _self.utePurchaseDataService
                        .getUserBillingInfo(payload)
                        .then(function (response) {
                        if (_.get(response, 'status.code') === '200.000' && _.has(response, 'content')) {
                            _self.billingDetails = response.content;
                            _self.billingCyclEndeDate = _self.utePurchaseDataService.getBillingCycleEndDate(_self.billingDetails.billCycleEndDate, _self.lang);
                        }
                    }, function (error) {
                        console.log('getUserBillingInfo error:', error);
                    });
                };
                UtePurchaseDataController.prototype.openDirectSelectedPlansFlow = function () {
                    var _self = this;
                    if (!_self.isOneTimeOrMonthlyTopUpExists.monthly && _self.isOneTimeOrMonthlyTopUpExists.oneTime) {
                        _self.isSelectedPlanTypeFLow = true;
                        _self.isSelectedPlanMonthly = false;
                        _self.isPurchasedPlansOptionsFLow = false;
                        _self.isPurchasingPlanConfirmationFLow = false;
                        _self.availableTopupPlansList = _self.filterPlansByType('one-time');
                        if (_self.availableTopupPlansList.length <= 0) {
                            if (_self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()) {
                                _self.speedPassErrorHandler();
                            }
                            else {
                                _self.genericErrorHandler();
                            }
                        }
                        else {
                            if (_self.selectedBrand === 'rogers' && _self.utePurchaseDataService.isInfinitePlan()) {
                                _self.modalTitle = _self.setModalTitle('ute.purchaseData.selectedPlansType.oneTimeTitleSP');
                                _self.selectedFlowType = _self.$translate.instant('ute.purchaseData.purchasingPlansConfirmationModal.spDesc');
                            }
                            else {
                                _self.modalTitle = _self.setModalTitle('ute.purchaseData.selectedPlansType.oneTimeTitle');
                                _self.selectedFlowType = _self.$translate.instant('ute.purchaseData.purchasingPlansConfirmationModal.ottDesc');
                            }
                            _self.selectedPlanIndex = undefined;
                        }
                    }
                    else if (_self.isOneTimeOrMonthlyTopUpExists.monthly && !_self.isOneTimeOrMonthlyTopUpExists.oneTime) {
                        _self.isSelectedPlanTypeFLow = true;
                        _self.isSelectedPlanMonthly = true;
                        _self.isPurchasedPlansOptionsFLow = false;
                        _self.isPurchasingPlanConfirmationFLow = false;
                        _self.availableTopupPlansList = _self.filterPlansByType('monthly');
                        if (_self.availableTopupPlansList.length <= 0) {
                            _self.genericErrorHandler();
                        }
                        else {
                            _self.modalTitle = _self.setModalTitle('ute.purchaseData.selectedPlansType.monthlyTitle');
                            _self.selectedFlowType = _self.$translate.instant('ute.purchaseData.purchasingPlansConfirmationModal.mdtDesc');
                            _self.selectedPlanIndex = undefined;
                        }
                    }
                    else {
                        _self.isPurchasedPlansOptionsFLow = true;
                        _self.isSelectedPlanTypeFLow = false;
                        _self.isPurchasingPlanConfirmationFLow = false;
                        _self.modalTitle = this.setModalTitle('ute.purchaseData.selectPlanOption.title');
                    }
                };
                UtePurchaseDataController.prototype.selectPurchaseDataPlanType = function (type) {
                    var _self = this;
                    var flowKey = type === 'monthly' ? 'ute.purchaseData.purchasingPlansConfirmationModal.mdtDesc' : '';
                    _self.availableTopupPlansList = _self.filterPlansByType(type === 'monthly' ? type : 'one-time');
                    _self.modalTitle = _self.setModalTitle(type === 'monthly'
                        ? 'ute.purchaseData.selectedPlansType.monthlyTitle'
                        : _self.selectedBrand === 'rogers'
                            ? 'ute.purchaseData.selectedPlansType.oneTimeTitleSP'
                            : 'ute.purchaseData.selectedPlansType.oneTimeTitle');
                    _self.selectedFlowType = _self.$translate.instant(flowKey);
                    _self.selectedPlanIndex = undefined;
                    _self.isPurchasedPlansOptionsFLow = false;
                    _self.isSelectedPlanTypeFLow = true;
                    _self.isSelectedPlanMonthly = (type === 'monthly') ? true : false;
                    try {
                        _self.utePurchaseDataService.trackDataLayerInteraction(_self.utePurchaseDataService.getDataLayerStep().buyFlowStart, (type === 'monthly') ? _self.utePurchaseDataService.getDataLayerEvent().monthlyData : _self.utePurchaseDataService.getDataLayerEvent().oneTimeData);
                    }
                    catch (error) {
                        console.error('data layer tracking - purchase data - step2', error);
                    }
                };
                ;
                UtePurchaseDataController.prototype.selectPurchaseDataPlan = function (plan, index) {
                    var _self = this;
                    _self.isDropDownFlow = !index ? true : false;
                    _self.selectedPlan = plan;
                    _self.selectedPlanIndex = index;
                    _self.planSelectionError = false;
                };
                ;
                UtePurchaseDataController.prototype.gotoConfirmation = function () {
                    var _self = this;
                    if ((_self.selectedPlanIndex === undefined && !_self.isDropDownFlow) || (_self.isDropDownFlow && !_self.selectedPlan)) {
                        _self.planSelectionError = true;
                        _self.utePurchaseDataService.trackDataLayerInteraction(_self.utePurchaseDataService.getDataLayerStep().errorUser, _self.utePurchaseDataService.getDataLayerEvent().buyflow);
                    }
                    else {
                        _self.isPurchasedPlansOptionsFLow = false;
                        _self.isSelectedPlanTypeFLow = false;
                        _self.isPurchasingPlanConfirmationFLow = true;
                        _self.getFocusOnClosebtn();
                        try {
                            _self.utePurchaseDataService.trackDataLayerInteraction(_self.utePurchaseDataService.getDataLayerStep().purchaseReview, (_self.selectedPlan.type === 'monthly') ? _self.utePurchaseDataService.getDataLayerEvent().monthlyData : _self.utePurchaseDataService.getDataLayerEvent().oneTimeData, _self.selectedPlan);
                        }
                        catch (error) {
                            console.error('data layer tracking - purchase data - review', error);
                        }
                        if (_self.selectedBrand === 'rogers' && this.utePurchaseDataService.isInfinitePlan()) {
                            _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansConfirmationModal.infiniteTitle');
                        }
                        else {
                            _self.modalTitle = _self.setModalTitle('ute.purchaseData.purchasingPlansConfirmationModal.title');
                        }
                    }
                };
                UtePurchaseDataController.prototype.getSelectedAltText = function () {
                    var _self = this;
                    _self.selectedAltText = _self.$translate.instant('ute.purchaseData.altTextSelected', { 'dataPlan': _self.$filter('number')(_self.selectedPlan.size.value) + ' ' + _self.setDataPlanUnitFormat(_self.selectedPlan.size.unit) });
                    return _self.selectedAltText;
                };
                UtePurchaseDataController.prototype.filterPlanType = function (plans) {
                    var _self = this;
                    _self.isOneTimeOrMonthlyTopUpExists = {
                        oneTime: false,
                        monthly: false,
                    };
                    if (_self.selectedBrand === 'rogers') {
                        if (this.utePurchaseDataService.isInfinitePlan()) {
                            // For Rogers Infinite plan, suppress MDTs even if they are returned by API
                            _self.isOneTimeOrMonthlyTopUpExists.oneTime = true;
                            _self.isOneTimeOrMonthlyTopUpExists.monthly = false;
                        }
                        else {
                            // For Rogers non-Infinite plan, suppress OTTs even if they are returned by API
                            _self.isOneTimeOrMonthlyTopUpExists.oneTime = false;
                            _self.isOneTimeOrMonthlyTopUpExists.monthly = true;
                        }
                    }
                    else {
                        if (plans && plans.length && plans.length > 0) {
                            for (var i = 0; i < plans.length; i++) {
                                if (plans[i].type === 'monthly') {
                                    _self.isOneTimeOrMonthlyTopUpExists.monthly = true;
                                }
                                else if (plans[i].type === 'one-time') {
                                    _self.isOneTimeOrMonthlyTopUpExists.oneTime = true;
                                }
                            }
                        }
                        else {
                            _self.genericErrorHandler();
                        }
                    }
                };
                UtePurchaseDataController.prototype.filterPlansByType = function (type) {
                    var _self = this;
                    if (_self.availableTopupPlansList && this.availableTopupPlansList.length && this.availableTopupPlansList.length > 0) {
                        return _self.availableTopupPlansList.filter(function (plan, index, array) {
                            if (plan.type === type) {
                                return plan;
                            }
                        });
                    }
                };
                ;
                UtePurchaseDataController.prototype.setDataPlanUnitFormat = function (unit) {
                    if (unit === 'GB') {
                        return (this.lang === 'fr') ? 'Go' : unit + ' ';
                    }
                    if (unit === 'MB') {
                        return (this.lang === 'fr') ? 'Mo' : unit + ' ';
                    }
                };
                UtePurchaseDataController.prototype.setPriceFormat = function (price) {
                    if (angular.isUndefined(price)) {
                        return '';
                    }
                    price = this.$filter('dollars')(price);
                    price = (typeof price === 'number') ? price.toString() : price;
                    price = (price.indexOf('.') === -1) ? (price + '.00') : price;
                    price = price.split('.');
                    return (this.lang === 'en') ? '<span class=\'dollor-sign\'>$</span>' + price[0] + '<span class=\'decimal-part\'>.' + price[1] + '</span>' : price[0] + '<span class=\'decimal-part\'>,' + price[1] + '</span>' + '<span class=\'dollor-sign\'>$</span>';
                };
                UtePurchaseDataController.prototype.proceedWithPurchaseDataPopup = function (plan) {
                    var _self = this;
                    var selectedPlan = plan ? plan : _self.selectedPlan;
                    var payload = _self.setTopUpPayload(selectedPlan);
                    _self.utePurchaseDataService
                        .proceedToPurchaseDataPopup(payload)
                        .then(_self.purchaseDataPlansSuccessHandler, _self.purchaseDataPlansErrorHandler);
                };
                UtePurchaseDataController.prototype.genericErrorHandler = function (error) {
                    this.isGenericError = true;
                    this.modalTitle = this.setModalTitle('ute.purchaseData.purchasingPlansError.title');
                    this.getFocusOnClosebtn();
                };
                UtePurchaseDataController.prototype.speedPassErrorHandler = function (error) {
                    this.isSpeedPassError = true;
                    this.modalTitle = this.setModalTitle('ute.purchaseData.purchasingPlansError.title');
                    this.getFocusOnClosebtn();
                };
                /**
                 * The following logic is deferred to a future release. For current implementation, Subcribers cannot provide WCoC Consent and they will be
                 * shown the "Contact Account holder" message
                 */
                UtePurchaseDataController.prototype.checkIfWCOCAuthorized = function () {
                    var _self = this;
                    _self.utePurchaseDataService.generateWcocToken(_self.accountDetailsForPurchaseTopup.accountNumber, _self.accountDetailsForPurchaseTopup.currentCtn)
                        .then(function (response) {
                        if (_.has(response, 'wcocAuthToken')) {
                            var token = response.wcocAuthToken;
                            _self.jwtToken = token;
                            _self.utePurchaseDataService.getWcocAuthUsers(_self.accountDetailsForPurchaseTopup.currentCtn, token)
                                .then(function (response) {
                                // iterate to check current ctn is authorized or not
                                if (_.has(response, 'status.code') && _.get(response, 'status.code') === '200') {
                                    if (_.has(response, 'content.authCTNs') && response.content.authCTNs.length > 0) {
                                        var currentCTN_1 = '1' + window.sessionStorage.getItem('addDataSelectedCTN');
                                        angular.forEach(response.content.authCTNs, function (authCTN) {
                                            if (authCTN.ctn === currentCTN_1) {
                                                if (authCTN.isAuthorized === '1') {
                                                    _self.modalTitle = _self.$translate.instant('ute.purchaseData.warning.consentTitle');
                                                    _self.consentError = _self.$translate.instant('ute.purchaseData.warning.consentDesc');
                                                    _self.isWCOCFlag = true;
                                                }
                                                else {
                                                    _self.setConsentErrorHandler();
                                                }
                                                return;
                                            }
                                        });
                                    }
                                }
                                else {
                                    _self.genericErrorHandler();
                                }
                            }, function (error) {
                                _self.consentError = '';
                                _self.genericErrorHandler(error);
                            });
                        }
                    }, function (error) {
                        _self.consentError = '';
                        _self.genericErrorHandler(error);
                    });
                };
                UtePurchaseDataController.prototype.proceedWithConsent = function () {
                    var _self = this;
                    _self.isConsentAPIError = false;
                    if (_self.jwtToken) {
                        _self.setWCOCConsent(_self.jwtToken);
                    }
                    else {
                        _self.utePurchaseDataService.generateWcocToken(_self.accountDetailsForPurchaseTopup.accountNumber, _self.accountDetailsForPurchaseTopup.currentCtn)
                            .then(function (response) {
                            if (_.has(response, 'wcocAuthToken')) {
                                var token = response.wcocAuthToken;
                                _self.jwtToken = token;
                                _self.setWCOCConsent(token);
                            }
                            else {
                                _self.consentError = '';
                                _self.genericErrorHandler();
                            }
                        }, function (error) {
                            _self.consentError = '';
                            _self.genericErrorHandler(error);
                        });
                    }
                };
                UtePurchaseDataController.prototype.setWCOCConsent = function (token) {
                    var _self = this;
                    _self.utePurchaseDataService.setWcocConsent(_self.accountDetailsForPurchaseTopup.accountNumber, 'Y', token)
                        .then(function (response) {
                        if (response && response.code === '200') {
                            // Set WCOC consent success flow and triggered the purchase data api call again.
                            _self.proceedWithPurchaseDataPopup(_self.selectedPlan);
                        }
                        else {
                            _self.genericErrorHandler();
                        }
                    }, function (error) {
                        _self.consentError = '';
                        _self.genericErrorHandler(error);
                    });
                };
                UtePurchaseDataController.prototype.getServiceId = function () {
                    var _self = this;
                    _self.utePurchaseDataService
                        .getUserServiceId()
                        .then(function (response) {
                        if (_.has(response, 'status.code') && _.get(response, 'status.code') === '200.000') {
                            var subscriptionsList = [];
                            // iterate accounts and match with current selected account
                            var selectedBAN_1 = _self.selectedBrand === 'fido' ? window.sessionStorage.getItem('addDataSelectedBAN') : window.localStorage.getItem('accountNumber');
                            // let selectedAccountContext: any = _.find( _.get(response, 'content.accounts'), { 'accountNumber': selectedBAN });
                            var selectedAccountContext = response.content.accounts.find(function (account) { return account.accountNumber === selectedBAN_1; });
                            if (selectedAccountContext) {
                                _self.accountDetailsForPurchaseTopup.accountAlias = selectedAccountContext.accountAlias;
                                _self.accountDetailsForPurchaseTopup.accountId = selectedAccountContext.accountId;
                                _self.accountDetailsForPurchaseTopup.accountNumber = selectedAccountContext.accountNumber;
                                subscriptionsList = selectedAccountContext.subscriptions;
                                if (subscriptionsList && subscriptionsList.length > 0) {
                                    var selectedCTN = _self.selectedBrand === 'fido' ? window.sessionStorage.getItem('addDataSelectedCTN') : {};
                                    var currentCtn_1 = _self.selectedBrand === 'fido' ? selectedCTN : window.localStorage.getItem('phoneNumber');
                                    angular.forEach(subscriptionsList, function (subscription) {
                                        if (subscription.subscriptionNumber === currentCtn_1) {
                                            _self.accountDetailsForPurchaseTopup.currentCtn = currentCtn_1;
                                            _self.accountDetailsForPurchaseTopup.serviceAlias = subscription.subscriptionAlias;
                                            _self.accountDetailsForPurchaseTopup.serviceId = subscription.subscriptionId;
                                        }
                                    });
                                }
                            }
                            else {
                                _self.genericErrorHandler();
                            }
                            _self.loadAvailableTopUps();
                            _self.fetchBillingInfo(_self.accountDetailsForPurchaseTopup);
                        }
                    }, function (error) {
                        _self.genericErrorHandler(error);
                    });
                };
                UtePurchaseDataController.prototype.setTopUpPayload = function (selectedPlan) {
                    var _self = this;
                    var payload = {};
                    payload = {
                        accountId: _self.selectedBrand === 'fido'
                            ? (_self.accountDetailsForPurchaseTopup && _self.accountDetailsForPurchaseTopup.accountAlias) ? _self.accountDetailsForPurchaseTopup.accountAlias : ''
                            : (_self.accountDetailsForPurchaseTopup && _self.accountDetailsForPurchaseTopup.accountId) ? _self.accountDetailsForPurchaseTopup.accountId : '',
                        serviceType: _self.isShareEveryThingFlow ? 'share-everything' : 'non-shared',
                    };
                    if (_self.selectedBrand === 'fido') {
                        payload.serviceId = (_self.accountDetailsForPurchaseTopup && _self.accountDetailsForPurchaseTopup.serviceAlias) ? _self.accountDetailsForPurchaseTopup.serviceAlias : '';
                    }
                    else {
                        payload.serviceId = _self.isShareEveryThingFlow
                            ? 'SE'
                            : (_self.accountDetailsForPurchaseTopup && _self.accountDetailsForPurchaseTopup.serviceId) ? _self.accountDetailsForPurchaseTopup.serviceId : '';
                    }
                    if (selectedPlan) {
                        payload.purchasePlan = selectedPlan;
                    }
                    return payload;
                };
                /* showEligibleAlertBox (type) {
                  let keyName = '';
                  this.showEligibleAlert = true;
                  keyName = type === 'monthly' ? 'ute.purchaseData.selectPlanOption.option2' : 'ute.purchaseData.selectPlanOption.option1';
                  this.eligibleAlertBoxImage = type === 'monthly' ? 'images/purchase-data/monthly.png' : 'images/purchase-data/one-time.png';
                  this.eligibleAlertBoxTitle = this.$translate.instant(keyName);
                } */
                UtePurchaseDataController.prototype.resetAllFlags = function () {
                    var _self = this;
                    _self.consentError = '';
                    _self.limitCycleError = '';
                    _self.availableTopupPlansList = [];
                    _self.billingDetails = {};
                    _self.selectedPlan = '';
                    _self.selectedPlanIndex = undefined;
                    _self.planSelectionError = false;
                    _self.isGenericError = false;
                    _self.isSpeedPassError = false;
                    _self.showEligibleAlert = false;
                    _self.isConsentAPIError = false;
                    _self.isDropDownFlow = false;
                };
                UtePurchaseDataController.prototype.geDeviceWidth = function () {
                    var windowWidth = $(window).innerWidth();
                    this.isMobileDevice = (windowWidth <= 768) ? true : false;
                };
                ;
                UtePurchaseDataController.prototype.getFocusOnClosebtn = function () {
                    setTimeout(function () {
                        var element = angular.element('.modal-close');
                        element.focus();
                    }, 0);
                };
                UtePurchaseDataController.prototype.getAddDataTranslationKey = function () {
                    var isInfinitePlan = this.utePurchaseDataService.isInfinitePlan();
                    return isInfinitePlan ? 'ute.purchaseData.addSpeedPass' : 'ute.purchaseData.addData';
                };
                UtePurchaseDataController.prototype.checkHideBtn = function () {
                    // a temp function to hide button for until backend issue is fixed
                    var _self = this;
                    return this.utePurchaseDataService.isInfinitePlan() && _self.isShareEveryThingFlow;
                };
                UtePurchaseDataController.controllerName = 'ute.purchase.data.controller';
                UtePurchaseDataController.$inject = [
                    'ute.purchase.data.service',
                    '$translate',
                    '$window',
                    '$filter'
                ];
                return UtePurchaseDataController;
            }());
            data.UtePurchaseDataController = UtePurchaseDataController;
            angular
                .module('ute.purchase.data')
                .controller('ute.purchase.data.controller', UtePurchaseDataController);
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
            var PurchaseDataAnalyticsConfigService = (function () {
                function PurchaseDataAnalyticsConfigService() {
                }
                PurchaseDataAnalyticsConfigService.prototype.loadDataLayerConfig = function () {
                    return this.dataLayerConfig = {
                        uteDataLayerTracking: {
                            events: {
                                pageView: {
                                    pageView: true
                                },
                                buyFlow: {
                                    buyFlowStart: {
                                        pageView: true,
                                        buyFlowStart: true
                                    },
                                    buyFlowComplete: {
                                        pageView: true,
                                        purchase: true,
                                        buyFlowComplete: true
                                    }
                                },
                                selfServe: {
                                    selfServeStart: {
                                        pageView: true,
                                        selfServeStart: true
                                    },
                                    selfServeComplete: {
                                        pageView: true,
                                        selfServeComplete: true
                                    }
                                },
                                purchase: {
                                    purchaseReview: {
                                        pageView: true,
                                        productView: true,
                                        orderReview: true
                                    }
                                },
                                error: {
                                    pageView: true,
                                    error: true
                                }
                            },
                            errors: [{
                                    category: '',
                                    type: '',
                                    code: '',
                                    API: '',
                                    field: '',
                                    message: ''
                                }],
                            pages: {
                                addDataModal: {
                                    name: 'step 1: choose data top-up',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                selectDataTopUp: {
                                    name: 'step 2:choose data top-up plan',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                purchaseDataTopUp: {
                                    name: 'step 3:confirm data top-up purchase',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                purchaseCongrats: {
                                    name: 'step 4:data top-up success',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                genericErrorModal: {
                                    name: 'add data top-up:sorry about this',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                businessError: {
                                    name: 'contact account holder',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                cancelDataTopUp: {
                                    name: 'step 1:confirm monthly data top-up cancellation',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                confirmCancelDataTopUp: {
                                    name: 'step 2:monthly data top-up cancellation success',
                                    url: 'modal popup',
                                    hierarchy: ''
                                },
                                cancelDataTopUpError: {
                                    name: 'cancel MDT:sorry about this',
                                    url: 'modal popup',
                                    hierarchy: ''
                                }
                            },
                            buyflow: {
                                monthlyData: {
                                    name: 'monthly data top-up',
                                    serial: ''
                                },
                                oneTimeData: {
                                    name: 'one time data top-up',
                                    serial: ''
                                }
                            },
                            selfServe: {
                                type: 'transaction',
                                name: ''
                            },
                            ecommerce: {
                                products: [{
                                        name: '',
                                        ID: '',
                                        category: 'wireless',
                                        subCategory: 'data top-up plan',
                                        findingMethod: 'wireless dashboard',
                                        price: '',
                                        MSF: ''
                                    }]
                            },
                            errorMessage: {
                                'available-top-ups': {
                                    message: ''
                                },
                                'accounts': {
                                    message: ''
                                },
                                'profile': {
                                    message: ''
                                },
                                'top-ups': {
                                    message: ''
                                }
                            }
                        }
                    };
                };
                ;
                PurchaseDataAnalyticsConfigService.$inject = [];
                return PurchaseDataAnalyticsConfigService;
            }());
            data.PurchaseDataAnalyticsConfigService = PurchaseDataAnalyticsConfigService;
            angular
                .module('ute.purchase.data')
                .service('purchase-data-analytics-config-service', PurchaseDataAnalyticsConfigService);
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data_1) {
            'use strict';
            var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
            var UtePurchaseDataProvider = (function () {
                /* @ngInject */
                function UtePurchaseDataProvider(dataLayerService) {
                    var _this = this;
                    this.dataLayerService = dataLayerService;
                    this.fidoConfig = {
                        basic: {
                            applicationId: 'FIDOWEB',
                            brand: 'FIDO',
                        },
                        advanced: {
                            root: {
                                controllerName: 'ute.purchase.data.controller',
                                templateUrl: 'module/purchaseData/purchase-data.html'
                            },
                            flows: {
                                purchaseDataOptions: 'purchaseDataOptions',
                                purchaseDataError: 'purchaseDataError',
                                purchaseDataSuccess: 'purchaseDataSuccess',
                            },
                            modals: {
                                purchaseDataOptions: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/fido/ute-purchase-data-modal.html',
                                    windowClass: 'ute-purchase-data-options-modal-wrapper'
                                },
                                purchaseDataError: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/ute-purchase-data-error-modal.html',
                                    windowClass: 'ute-purchase-data-error-modal-wrapper'
                                },
                                purchaseDataSuccess: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/ute-purchase-data-error-modal.html',
                                    windowClass: 'ute-purchase-data-error-modal-wrapper'
                                },
                            }
                        },
                        apiConfig: {
                            baseUrl: '/v2/customer/accounts',
                            generateWcocToken: '/pages/web/genesis/api/user/v1/generateToken',
                            getWcocAuthUsers: 'web/wcoc/api/wcocauthusers?ctn=',
                            setWcocConsent: '/web/wcoc/api/wcocConsent',
                            topUpUrlv3: '/pages/web/genesis/api/usage/v3/customer/accounts/',
                            topUpUrl: '/pages/web/genesis/api/usage/v2/customer/accounts/',
                            genesis: '/pages/web/genesis/api/'
                        }
                    };
                    this.rogersConfig = {
                        basic: {
                            applicationId: 'UTEMyRogersApp',
                            brand: 'ROGERS',
                        },
                        advanced: {
                            root: {
                                controllerName: 'ute.purchase.data.controller',
                                templateUrl: 'module/purchaseData/purchase-data.html'
                            },
                            flows: {
                                purchaseDataOptions: 'purchaseDataOptions',
                                purchaseDataError: 'purchaseDataError',
                                purchaseDataSuccess: 'purchaseDataSuccess',
                            },
                            modals: {
                                purchaseDataOptions: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/rogers/ute-purchase-data-modal.html',
                                    windowClass: 'ute-purchase-data-options-modal-wrapper'
                                },
                                purchaseDataError: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/ute-purchase-data-error-modal.html',
                                    windowClass: 'ute-purchase-data-error-modal-wrapper'
                                },
                                purchaseDataSuccess: {
                                    controllerName: 'ute.purchase.data.controller',
                                    templateUrl: 'module/purchaseData/views/ute-purchase-data-error-modal.html',
                                    windowClass: 'ute-purchase-data-error-modal-wrapper'
                                },
                            }
                        },
                        apiConfig: {
                            baseUrl: '/v2/customer/accounts',
                            getWcocAuthUsers: 'web/wcoc/api/getWcocAuthUsers',
                            generateWcocToken: '/web/RogersServices.portal/totes/api/v1/wcoc/fdm/generateToken',
                            setWcocConsent: '/web/totes/web/wcoc/api/wcoc/wcocConsent',
                            topUpUrl: '/web/totes/web/genesis/api/usage/v2/customer/accounts/',
                            topUpUrlv3: '/web/totes/web/genesis/api/usage/v3/customer/accounts/',
                            genesis: '/web/totes/web/genesis/api/'
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $http, $q, $modal, $filter, $translate) {
                        _this.$injector = $injector;
                        _this.http = $http;
                        _this.q = $q;
                        _this.$modal = $modal;
                        _this.isMockData = false;
                        _this.$filter = $filter;
                        _this.$translate = $translate;
                        _this.apiName = '';
                        _this.errorMessageApi = '';
                        _this.errorMessageUser = '';
                        _this.dataLayerService = $injector.get('ute.datalayer.common.service');
                        _this.purchaseDataAnalyticsConfigService = $injector.get('purchase-data-analytics-config-service');
                        return {
                            accountNumber: null,
                            getConfig: _this.getConfig,
                            resetModel: _this.resetModel,
                            openPurchaseDataModal: _this.openPurchaseDataModal,
                            openPurchaseDataErrorModal: _this.openPurchaseDataErrorModal,
                            getXSessionToken: _this.getXSessionToken,
                            getWcocAuthUsers: _this.getWcocAuthUsers,
                            setWcocConsent: _this.setWcocConsent,
                            generateWcocToken: _this.generateWcocToken,
                            getListOfAvailablePlans: _this.getListOfAvailablePlans,
                            setAvailablePlansList: _this.setAvailablePlansList,
                            getAvailablePlansList: _this.getAvailablePlansList,
                            proceedToPurchaseDataPopup: _this.proceedToPurchaseDataPopup,
                            getBillingCycleEndDate: _this.getBillingCycleEndDate,
                            getUserServiceId: _this.getUserServiceId,
                            getLanguage: _this.getLanguage,
                            isShareEverything: _this.isShareEverything,
                            isInfinitePlan: _this.isInfinitePlan,
                            getDataLayerEvent: _this.getDataLayerEvent,
                            getDataLayerStep: _this.getDataLayerStep,
                            trackDataLayerInteraction: _this.trackDataLayerInteraction,
                            setPriceFormat: _this.setPriceFormat,
                            getUserBillingInfo: _this.getUserBillingInfo,
                            getCookie: _this.getCookie,
                        };
                    };
                    /**
                     * @method getConfig
                     * @returns {IUtePurchaseDataServiceConfig}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /**
                     * @method configure
                     * @param config: {IUtePurchaseDataServiceConfig}
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.getLanguage = function () {
                        var languageService = _this.$injector.get('ute.blocks.language.switcher');
                        return languageService.getCurrentLanguage();
                    };
                    this.resetModel = function () {
                        _this.model = {
                            moduleName: 'purchaseData'
                        };
                    };
                    /**
                     * @method getBillingCycleEndDate
                     * @param usageDetails
                     * @Desc Get billing cycle end date.
                     * @returns {any}
                     */
                    this.getBillingCycleEndDate = function (date, lang) {
                        var result = '';
                        var day = moment(date, 'MMM-DD-YY').date();
                        var month = _this.getMonthFormat()[lang][moment(date).get('month') + 1];
                        var year = moment(date, 'MMM-DD-YY').year();
                        result = lang === 'en' ? month + ' ' + day + ', ' + year : day + ' ' + month + ' ' + year;
                        return result;
                    };
                    /**
                     * @method openPurchaseDataErrorModal
                     * @param modalFlow, size:
                     * @Desc Purchase data modal failure
                     */
                    this.openPurchaseDataErrorModal = function (modalFlow, size) {
                        return _this.$modal.open({
                            windowClass: _this.getConfig().advanced.modals.purchaseDataOptions.windowClass,
                            templateUrl: _this.getConfig().advanced.modals.purchaseDataOptions.templateUrl,
                            controller: _this.getConfig().advanced.modals.purchaseDataOptions.controllerName,
                            controllerAs: 'ctrl',
                            size: size ? size : 'lg',
                            backdrop: 'static',
                            keyboard: false
                        });
                    };
                    /**
                     * @method openPurchaseDataModal
                     * @param modalFlow, size:
                     * @Desc  purchase data modal
                     */
                    this.openPurchaseDataModal = function (modalFlow, size) {
                        return _this.$modal.open({
                            windowClass: _this.getConfig().advanced.modals[modalFlow].windowClass,
                            templateUrl: _this.getConfig().advanced.modals[modalFlow].templateUrl,
                            controller: _this.getConfig().advanced.modals[modalFlow].controllerName,
                            controllerAs: 'ctrl',
                            size: size ? size : 'lg',
                            backdrop: 'static',
                            keyboard: false
                        });
                    };
                    this.getXSessionToken = function () {
                        return new _this.q(function (resolve) { return resolve(''); });
                    };
                    /**
                     * setWCOCConsent - Set WCOC consent
                     * @param  {string} accNumber: Account number
                     * @param  {string} dConsent
                     * @param  {string} token
                     */
                    this.setWcocConsent = function (accNumber, dConsent, token) {
                        var deferred = _this.q.defer();
                        var payload = {
                            ban: accNumber,
                            dConsent: dConsent
                        };
                        var config = {
                            headers: {
                                'x-app-id': 'UTEWCOC',
                                'JWT': token
                            }
                        };
                        _this.apiName = _this.getConfig().apiConfig.setWcocConsent;
                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.warning.consentDesc');
                        _this.http.post(_this.getConfig().apiConfig.setWcocConsent, payload, config)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        })
                            .error(function (error) {
                            try {
                                _this.trackDataLayerInteraction(_this.getDataLayerStep().errorBusiness, _this.getDataLayerEvent().buyflow, error);
                            }
                            catch (error) {
                                console.log('error tracking data purchase api', _this.apiName);
                            }
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    this.getWcocAuthUsers = function (ctn, token) {
                        var deferred = _this.q.defer();
                        var config = {
                            headers: {
                                'x-app-id': 'UTEWCOC',
                                'JWT': token
                            }
                        };
                        _this.apiName = _this.getConfig().apiConfig.getWcocAuthUsers + ctn;
                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.warning.consentDesc');
                        _this.http.get(_this.getConfig().apiConfig.getWcocAuthUsers + ctn, config)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        })
                            .error(function (error) {
                            try {
                                _this.trackDataLayerInteraction(_this.getDataLayerStep().errorBusiness, _this.getDataLayerEvent().buyflow, error);
                            }
                            catch (error) {
                                console.log('error tracking data purchase api', _this.apiName);
                            }
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    /**
                     * generateWCoCToken - Generate token using WCOC mock data api.
                     * @param  {string} accNumber.
                     * @param  {string} ctn.
                     */
                    this.generateWcocToken = function (accNumber, ctn) {
                        var deferred = _this.q.defer();
                        var request = {
                            ban: accNumber,
                            ctn: ctn
                        };
                        var config = {};
                        if (_this.getConfig().basic.brand.toLowerCase() === 'fido') {
                            config = {
                                headers: {
                                    'x-app-id': 'UTEFIDO',
                                    'x-session-token': window.sessionStorage.getItem('xSessionToken')
                                }
                            };
                        }
                        _this.apiName = _this.getConfig().apiConfig.generateWcocToken;
                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.warning.consentDesc');
                        _this.http.post(window.location.protocol + '//' + window.location.host + _this.getConfig().apiConfig.generateWcocToken, request, config)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        }).error(function (error) {
                            try {
                                _this.trackDataLayerInteraction(_this.getDataLayerStep().errorBusiness, _this.getDataLayerEvent().buyflow, error);
                            }
                            catch (error) {
                                console.log('error tracking data purchase api', _this.apiName);
                            }
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    /**
                     * getListOfPurchasedPopup - Fetch list of available top-ups.
                     * @param  {string | number} accountId.
                     */
                    this.getListOfAvailablePlans = function (payload) {
                        var deferred = _this.q.defer();
                        /* Commenting out the hacky CMS solution provided for Infinite Speed Pass launch
                           v2/available-top-ups is expected to return OTTs for Infinite plans and MDT for others
                        */
                        /* if (this.isInfinitePlan()) {
                          const isLocal = location.href.indexOf('localhost.rogers') >= 0;
                          if (isLocal) {
                            deferred.resolve([{
                              'code': 'PGDATUPRSH4',
                              'description': {
                                'en': 'Montly Data Top-Up 15GB',
                                'fr': 'Réapprovision données - 15 Go'
                              },
                              'size': {
                                'value': 3,
                                'unit': 'GB'
                              },
                              'price': {
                                'value': 1500,
                                'unit': 'CENTS'
                              },
                              'type': 'one-time'
                            }]);
                          } else {
                            const timestamp = +new Date();
                            const url = '/web/totes/cms/content/json/speedpass.json?v=' + timestamp;
                            this.http.get(url, {
                              cache: false,
                              withCredentials: false
                            }).then((res) => {
                              const topups = _.get(res, 'data.speedpass.topups', []);
                              deferred.resolve(topups);
                              console.log('topups obj >>>>>> ', topups);
                            });
                          }
                        } else { } */
                        var headers = {
                            'x-session-token': window.sessionStorage.getItem('xSessionToken'),
                            'x-info-token': window.sessionStorage.getItem('x_info_token'),
                            'x-app-id': _this.getConfig().basic.applicationId,
                            brand: _this.getConfig().basic.brand.toLowerCase()
                        };
                        var url = _this.isMockData
                            ? _this.getConfig().basic.brand.toLowerCase() === 'fido' ? 'resource/purchase-data/getAvailableTopUpsList.json' : 'ute-purchase-data/assets/getAvailableTopUpsList.json'
                            : (_this.getConfig().basic.brand.toLowerCase() === 'rogers'
                                ? _this.getConfig().apiConfig.topUpUrl
                                : _this.getConfig().apiConfig.topUpUrlv3)
                                + payload.accountId + '/services/' + payload.serviceType + '/' + payload.serviceId + '/available-top-ups';
                        _this.apiName = url;
                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.desc1');
                        _this.http.get(url, { headers: headers })
                            .success(function (resp) {
                            deferred.resolve(resp);
                        }).error(function (error) {
                            try {
                                _this.trackDataLayerInteraction(_this.getDataLayerStep().errorGeneric, _this.getDataLayerEvent().buyflow, error);
                            }
                            catch (error) {
                                console.log('error tracking data purchase api', _this.apiName);
                            }
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    /**
                     * getUserServiceId - Fetch list of available top-ups.
                     */
                    this.getUserServiceId = function () {
                        var deferred = _this.q.defer();
                        var brand = _this.getConfig().basic.brand;
                        var guid = window.sessionStorage.getItem('guid');
                        var options = {
                            headers: {
                                'x-session-token': window.sessionStorage.getItem('xSessionToken'),
                                'x-app-id': _this.getConfig().basic.applicationId
                            }
                        };
                        var url = _this.isMockData
                            ? _this.getConfig().basic.brand.toLowerCase() === 'fido' ? 'resource/purchase-data/getUserServiceId.json' : 'ute-purchase-data/assets/getUserServiceId.json'
                            : _this.getConfig().apiConfig.genesis + 'genesis-agg-svc/v3/profile/' + guid + '?brand=' + brand;
                        _this.apiName = url;
                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.title');
                        _this.http.get(url, options)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        }).error(function (error) {
                            try {
                                _this.trackDataLayerInteraction(_this.getDataLayerStep().errorGeneric, _this.getDataLayerEvent().buyflow, error);
                            }
                            catch (error) {
                                console.log('error tracking data purchase api', _this.apiName);
                            }
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    /**
                     * getBillingDetails - Fetch billing details.
                     */
                    this.getUserBillingInfo = function (payload) {
                        var deferred = _this.q.defer();
                        var options = {
                            headers: {
                                'x-session-token': window.sessionStorage.getItem('xSessionToken'),
                                'x-app-id': _this.getConfig().basic.applicationId,
                                'userId': _this.getCookie('userName'),
                                'brand': _this.getConfig().basic.brand.toLowerCase()
                            }
                        };
                        var url = _this.isMockData
                            ? _this.getConfig().basic.brand.toLowerCase() === 'fido' ? 'resource/purchase-data/getBillingInfo.json' : 'ute-purchase-data/assets/getBillingInfo.json'
                            : _this.getConfig().apiConfig.genesis + 'billing-account-svc/v1/accounts/' + payload.accountId + '/billingInfo';
                        _this.http.get(url, options)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        }).error(function (error) {
                            deferred.reject(error);
                        });
                        return deferred.promise;
                    };
                    /**
                     * proceedToPurchaseDataPupup - Purchase topup api call.
                     * @param  {any} payloadData.
                     */
                    this.proceedToPurchaseDataPopup = function (payloadData) {
                        var deferred = _this.q.defer();
                        var request = {
                            headers: {
                                'brand': _this.getConfig().basic.brand.toLowerCase(),
                                'x-app-id': _this.getConfig().basic.applicationId,
                                'x-session-token': sessionStorage.getItem('xSessionToken'),
                                'x-info-token': window.sessionStorage.getItem('x_info_token')
                            }
                        };
                        var payload = {
                            topUpCode: payloadData.purchasePlan.code
                        };
                        var url = _this.isMockData
                            ? _this.getConfig().basic.brand.toLowerCase() === 'fido' ? 'resource/purchase-data/getAvailableTopUpsList.json' : 'ute-purchase-data/assets/purchaseDataPopUp.json'
                            : (_this.getConfig().basic.brand.toLowerCase() === 'rogers'
                                ? _this.getConfig().apiConfig.topUpUrl
                                : _this.getConfig().apiConfig.topUpUrlv3) + payloadData.accountId + '/services/' + payloadData.serviceType + '/' + payloadData.serviceId + '/top-ups';
                        _this.apiName = url;
                        _this.http.post(url, payload, request)
                            .success(function (resp) {
                            deferred.resolve(resp);
                        })
                            .error(function (data, status) {
                            if (data && _.get(data, 'status.code')) {
                                switch (data.status.code) {
                                    case '403.303':
                                        if (_this.getConfig().basic.brand.toLowerCase() === 'rogers' && _this.isInfinitePlan()) {
                                            _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDescSP');
                                        }
                                        else {
                                            _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanTenDesc');
                                        }
                                        break;
                                    case '403.304':
                                        _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.limitExceed.moreThanThreeDesc');
                                        break;
                                    default:
                                        if (_this.getConfig().basic.brand.toLowerCase() === 'rogers' && _this.isInfinitePlan()) {
                                            _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.speedpass.desc1');
                                        }
                                        else {
                                            _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.desc1');
                                        }
                                }
                                try {
                                    _this.trackDataLayerInteraction(_this.getDataLayerStep().errorGeneric, _this.getDataLayerEvent().buyflow, data);
                                }
                                catch (ex) {
                                    console.log('error tracking data purchase api', _this.apiName);
                                }
                                deferred.reject(data);
                            }
                            else {
                                _this.errorMessageApi = _this.$translate.instant('ute.purchaseData.purchasingPlansError.desc1');
                                try {
                                    _this.trackDataLayerInteraction(_this.getDataLayerStep().errorGeneric, _this.getDataLayerEvent().buyflow, status);
                                }
                                catch (ex) {
                                    console.log('error tracking data purchase api', _this.apiName);
                                }
                                deferred.reject(status);
                            }
                        });
                        return deferred.promise;
                    };
                    this.setAvailablePlansList = function (availablePlans) {
                        _this.availablePlansList = availablePlans;
                    };
                    //Analytics data layer.
                    this.getDataLayerEvent = function () {
                        return _this.dataLayerEvent;
                    };
                    this.getDataLayerStep = function () {
                        return _this.dataLayerStep;
                    };
                    /** Tracking Modal and api errors
                     * each modal step is determined by trackingStep
                     * flow - buyflow (one time topup and monthly topup), self serve is determined by trackingEvent
                     */
                    this.trackDataLayerInteraction = function (trackingStep, trackingEvent, info, ctn) {
                        try {
                            var self_1 = _this;
                            //Load data layer configuration object.
                            _this.dataLayerConfig = _this.purchaseDataAnalyticsConfigService.loadDataLayerConfig().uteDataLayerTracking;
                            var dataLayerPayloadConfig = {
                                selfServe: '',
                                page: '',
                                event: '',
                                buyflow: '',
                                user: {
                                    loginStatus: true
                                },
                                site: (window.location.hostname.match(/fido.ca/) !== null) ? 'F' : 'R',
                                ecommerce: {
                                    products: self_1.dataLayerConfig.ecommerce.products
                                }
                            };
                            if (info && (trackingEvent === self_1.dataLayerEvent.monthlyData || trackingEvent === self_1.dataLayerEvent.oneTimeData)) {
                                var planName = info.size.value +
                                    info.size.unit +
                                    ' ' +
                                    (_this.getConfig().basic.brand.toLowerCase() === 'rogers' && _this.isInfinitePlan()
                                        ? _this.$translate.instant('ute.purchaseData.purchasingPlansConfirmationModal.priceLabelSP')
                                        : _this.$translate.instant('ute.purchaseData.purchasingPlansConfirmationModal.priceLabel')) +
                                    ' ' +
                                    _this.setPriceFormat(info.price.value);
                                var planId = info.code;
                                var planPrice = _this.setPriceFormat(info.price.value);
                                dataLayerPayloadConfig.ecommerce.products[0].name = planName;
                                dataLayerPayloadConfig.ecommerce.products[0].ID = planId;
                                dataLayerPayloadConfig.ecommerce.products[0].price = planPrice;
                                if (trackingEvent === self_1.dataLayerEvent.monthlyData) {
                                    dataLayerPayloadConfig.ecommerce.products[0].MSF = planPrice;
                                }
                            }
                            var flow = _this.isShareEverything() ? 'shareeverything' : 'wireless';
                            var brand = 'myrogers';
                            var hierarchy = [brand, flow, 'data buyflow'];
                            if (window.location.hostname.match(/fido.ca/) !== null) {
                                hierarchy = ['myaccount', 'data buyflow'];
                            }
                            // set data layer events for interactions.
                            // trackingStep value would be buyflowStart/complete, purchase review, selfServeStart/complete, error.
                            switch (trackingStep) {
                                case self_1.dataLayerStep.addDataStep1:
                                    self_1.dataLayerConfig.pages.addDataModal.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.addDataModal;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.pageView;
                                    break;
                                case self_1.dataLayerStep.addDataStep2:
                                    self_1.dataLayerConfig.pages.selectDataTopUp.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.selectDataTopUp;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.buyFlow.buyFlowStart;
                                    break;
                                case self_1.dataLayerStep.buyFlowStart:
                                    self_1.dataLayerConfig.pages.selectDataTopUp.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.selectDataTopUp;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.buyFlow.buyFlowStart;
                                    break;
                                case self_1.dataLayerStep.buyFlowComplete:
                                    self_1.dataLayerConfig.pages.purchaseCongrats.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.purchaseCongrats;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.buyFlow.buyFlowComplete;
                                    break;
                                case self_1.dataLayerStep.selfServeStart:
                                    self_1.dataLayerConfig.pages.cancelDataTopUp.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.cancelDataTopUp;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.selfServe.selfServeStart;
                                    break;
                                case self_1.dataLayerStep.selfServeComplete:
                                    self_1.dataLayerConfig.pages.confirmCancelDataTopUp.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.confirmCancelDataTopUp;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.selfServe.selfServeComplete;
                                    break;
                                case self_1.dataLayerStep.purchaseReview:
                                    self_1.dataLayerConfig.pages.purchaseDataTopUp.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.purchaseDataTopUp;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.purchase.purchaseReview;
                                    break;
                                case self_1.dataLayerStep.errorBusiness:
                                    self_1.dataLayerConfig.pages.businessError.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.businessError;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.error;
                                    break;
                                case self_1.dataLayerStep.errorUser:
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.error;
                                    self_1.errorMessageUser = _this.$translate.instant('ute.purchaseData.warning.desc');
                                    break;
                                case self_1.dataLayerStep.errorCancelDataTopUp:
                                    self_1.dataLayerConfig.pages.cancelDataTopUpError.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.cancelDataTopUpError;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.error;
                                    break;
                                default:
                                    self_1.dataLayerConfig.pages.genericErrorModal.hierarchy = hierarchy;
                                    dataLayerPayloadConfig.page = self_1.dataLayerConfig.pages.genericErrorModal;
                                    dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.error;
                            }
                            if (trackingEvent && !dataLayerPayloadConfig.event.error) {
                                switch (trackingEvent) {
                                    case self_1.dataLayerEvent.oneTimeData:
                                        dataLayerPayloadConfig.buyflow = self_1.dataLayerConfig.buyflow.oneTimeData;
                                        break;
                                    case self_1.dataLayerEvent.monthlyData:
                                        dataLayerPayloadConfig.buyflow = self_1.dataLayerConfig.buyflow.monthlyData;
                                        break;
                                    case self_1.dataLayerEvent.selfServe:
                                        dataLayerPayloadConfig.selfServe = self_1.dataLayerConfig.selfServe;
                                        break;
                                    default:
                                }
                            }
                            //Set payload for data layer.
                            var payload = {
                                page: dataLayerPayloadConfig.page,
                                events: dataLayerPayloadConfig.event,
                                user: dataLayerPayloadConfig.user,
                                site: dataLayerPayloadConfig.site,
                                ecommerce: dataLayerPayloadConfig.ecommerce
                            };
                            if (trackingEvent && (trackingEvent === self_1.dataLayerEvent.monthlyData || trackingEvent === self_1.dataLayerEvent.oneTimeData)) {
                                payload.buyflow = dataLayerPayloadConfig.buyflow;
                                if (info) {
                                    payload.ecommerce.products = dataLayerPayloadConfig.ecommerce.products;
                                }
                            }
                            else if (trackingEvent && trackingEvent === self_1.dataLayerEvent.selfServe) {
                                payload.selfServe = dataLayerPayloadConfig.selfServe;
                            }
                            // If any case api give error response then set error type with data layer paylaod.
                            if (payload.events.error) {
                                if (trackingEvent) {
                                    if (trackingEvent === self_1.dataLayerEvent.selfServe) {
                                        self_1.dataLayerConfig.errors[0].category = 'self serve';
                                    }
                                    else if (trackingEvent === self_1.dataLayerEvent.buyflow) {
                                        self_1.dataLayerConfig.errors[0].category = 'buyflow';
                                    }
                                }
                                if (trackingStep && trackingStep === self_1.dataLayerStep.errorGeneric) {
                                    self_1.dataLayerConfig.errors[0].type = 'http';
                                }
                                else if (trackingStep && trackingStep === self_1.dataLayerStep.errorBusiness) {
                                    self_1.dataLayerConfig.errors[0].type = 'business';
                                }
                                else if (trackingStep && trackingStep === self_1.dataLayerStep.errorUser) {
                                    self_1.dataLayerConfig.errors[0].type = 'user';
                                }
                                if (info && trackingStep && (trackingStep === self_1.dataLayerStep.errorGeneric || trackingStep === self_1.dataLayerStep.errorBusiness)) {
                                    var statusCode = info && info.status && info.status.code ? info.status.code : info ? info : '';
                                    self_1.dataLayerConfig.errors[0].code = statusCode ? statusCode : '';
                                }
                                self_1.dataLayerConfig.errors[0].API = trackingStep === self_1.dataLayerStep.errorUser ? '' : _this.apiName;
                                if (trackingStep === self_1.dataLayerStep.errorGeneric || trackingStep === self_1.dataLayerStep.errorBusiness) {
                                    self_1.dataLayerConfig.errors[0].message = _this.errorMessageApi;
                                }
                                else if (trackingStep === self_1.dataLayerStep.errorUser) {
                                    self_1.dataLayerConfig.errors[0].message = _this.errorMessageUser;
                                }
                                payload.errors = self_1.dataLayerConfig.errors;
                            }
                            self_1.dataLayerService.track(payload, true, [
                                DataLayerPredefinedSection.ACCOUNT,
                                DataLayerPredefinedSection.PAGE,
                                DataLayerPredefinedSection.SITE
                            ]);
                        }
                        catch (error) {
                            console.error('data layer tracking - purchase data', error);
                        }
                        return;
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$http',
                        '$q',
                        '$modal',
                        '$filter',
                        '$translate'
                    ];
                    this.resetModel();
                    this.config = (window.location.hostname.match(/fido.ca/) !== null) ? this.fidoConfig : this.rogersConfig;
                    this.dataLayerEvent = {
                        addDataModal: 'add-data',
                        oneTimeData: 'one-time-data',
                        monthlyData: 'monthly-data',
                        selfServe: 'self-serve',
                        buyflow: 'buy-flow'
                    };
                    this.dataLayerStep = {
                        buyFlowStart: 'buy-flow-start',
                        buyFlowComplete: 'buy-flow-complete',
                        purchaseReview: 'purchase-review',
                        selfServeStart: 'self-serve-start',
                        selfServeComplete: 'self-serve-complete',
                        errorCancelDataTopUp: 'error-cancel-data',
                        errorBusiness: 'error-business',
                        errorUser: 'error-user',
                        addDataStep1: 'add-data-modal',
                        addDataStep2: 'choose-data-plan',
                        errorGeneric: 'error-generic'
                    };
                }
                UtePurchaseDataProvider.prototype.isShareEverything = function () {
                    return window.location.href.indexOf('shareEverything') > -1;
                };
                ;
                UtePurchaseDataProvider.prototype.isInfinitePlan = function () {
                    return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                };
                UtePurchaseDataProvider.prototype.setPriceFormat = function (price) {
                    if (angular.isUndefined(price)) {
                        return '';
                    }
                    price = this.$filter('dollars')(price);
                    return '$' + price;
                };
                UtePurchaseDataProvider.prototype.getCookie = function (name) {
                    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
                    return v ? v[2] : null;
                };
                UtePurchaseDataProvider.prototype.getAvailablePlansList = function () {
                    return this.availablePlansList;
                };
                UtePurchaseDataProvider.prototype.getMonthFormat = function () {
                    return {
                        'en': { '1': 'January', '2': 'February', '3': 'March', '4': 'April', '5': 'May', '6': 'June', '7': 'July', '8': 'August', '9': 'September', '10': 'October', '11': 'November', '12': 'December' },
                        'fr': { '1': 'Janvier', '2': 'F\u00e9vrier', '3': 'Mars', '4': 'Avril', '5': 'Mai', '6': 'Juin', '7': 'Juillet', '8': 'Ao\u00fbt', '9': 'Septembre', '10': 'Octobre', '11': 'Novembre', '12': 'D\u00e9cembre' }
                    };
                };
                UtePurchaseDataProvider.$inject = [];
                return UtePurchaseDataProvider;
            }());
            data_1.UtePurchaseDataProvider = UtePurchaseDataProvider;
            angular
                .module('ute.purchase.data')
                .provider('ute.purchase.data.service', UtePurchaseDataProvider);
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var purchase;
    (function (purchase) {
        var data;
        (function (data) {
            'use strict';
            angular
                .module('ute.purchase.data')
                .directive('utePurchaseDataDirective', utePurchaseDataDirective);
            utePurchaseDataDirective.$inject = ['ute.purchase.data.service'];
            /* @ngInject */
            function utePurchaseDataDirective(utePurchaseDataService) {
                return {
                    restrict: 'EA',
                    scope: { accountNumber: '=' },
                    templateUrl: utePurchaseDataService.getConfig().advanced.root.templateUrl,
                    controller: utePurchaseDataService.getConfig().advanced.root.controllerName,
                    controllerAs: 'ctrl'
                };
            }
        })(data = purchase.data || (purchase.data = {}));
    })(purchase = ute.purchase || (ute.purchase = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.reactivate.ctn').run(reactivateCtnRoutesConfig);
                reactivateCtnRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.reactivate.ctn.service'];
                /* @ngInject */
                function reactivateCtnRoutesConfig(routerHelper, reactivateCtnService) {
                    routerHelper.configureStates(getStates(reactivateCtnService));
                }
                function getStates(reactivateCtnService) {
                    var reactivateCtnRootState = reactivateCtnService.getConfig().basic.reactivateCtnRootState;
                    return [
                        {
                            name: reactivateCtnRootState,
                            abstract: true,
                            url: '/' + reactivateCtnRootState,
                            controller: reactivateCtnService.getConfig().basic.mainControllerName,
                            templateUrl: reactivateCtnService.getConfig().basic.mainTemplateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            },
                            resolve: reactivateCtnService.getConfig().advanced.resolve
                        },
                        {
                            name: reactivateCtnRootState + '.' + reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState,
                            url: '/' + reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.subState + '/:id',
                            controller: reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.controllerName,
                            controllerAs: 'successSuspendDevice',
                            templateUrl: reactivateCtnService.getConfig().advanced.reactivateCtnSuccess.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            }
                        }
                    ];
                }
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var ReactivateCtnController = (function () {
                        /* @ngInject */
                        function ReactivateCtnController($document, reactivateCtnService) {
                            this.$document = $document;
                            this.reactivateCtnService = reactivateCtnService;
                            reactivateCtnService.restoreState();
                            $document.scrollTop(0);
                        }
                        ReactivateCtnController.$inject = ['$document', 'ute.common.reactivate.ctn.service'];
                        return ReactivateCtnController;
                    }());
                    service.ReactivateCtnController = ReactivateCtnController;
                    angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.main.controller', ReactivateCtnController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                /**
                 * Private interface
                 */
                var ResetVoicemailPasswordProvider = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                medium: 'WEB',
                                partialApiUrl: 'v1/wirelessDashBoard/resetvoicemailPassword'
                            },
                            advanced: {
                                voicemailResetPasswordDirective: {
                                    templateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPassword.directive.view.html',
                                    controllerName: 'ute.common.voicemail.resetPassword.directive.controller'
                                },
                                voicemailResetPasswordModalDirective: {
                                    windowTemplateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPasswordWindow.modal.view.html',
                                    templateUrl: 'module/resetVoicemailPasswordDirective/resetVoicemailPassword.modal.view.html',
                                    controllerName: 'ute.common.voicemail.resetPassword.modal.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($modal) {
                            _this.$modal = $modal;
                            return {
                                getConfig: _this.getConfig,
                                getModel: _this.getModel,
                                setAccountNumber: _this.setAccountNumber,
                                getAccountNumber: _this.getAccountNumber,
                                setPhoneNumber: _this.setPhoneNumber,
                                getPhoneNumber: _this.getPhoneNumber,
                                setNewVoicemailPassword: _this.setNewVoicemailPassword,
                                cancelResetVoicemailPassword: _this.cancelResetVoicemailPassword,
                                setConfirmVoicemailPassword: _this.setConfirmVoicemailPassword,
                                openModalPopup: _this.openModalPopup
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            if (_this.config.basic.medium.length === 0) {
                                console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                return false;
                            }
                            return true;
                        };
                        /**
                         * Get Phone number from the model
                         * @returns {number}
                         */
                        this.getPhoneNumber = function () {
                            return _this.model.phoneNumber;
                        };
                        /**
                         * Get Account number from the model
                         * @returns {number}
                         */
                        this.getAccountNumber = function () {
                            return _this.model.accountNumber;
                        };
                        /**
                         * get the config setting
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * Return immutable IResetVoicemailPasswordModel object
                         * @returns {IResetVoicemailPasswordModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /**
                         * @param accountNumber - set account number
                         */
                        this.setAccountNumber = function (accountNumber) {
                            _this.model.accountNumber = accountNumber;
                        };
                        /**
                         * @param ctn - set phone number
                         */
                        this.setPhoneNumber = function (ctn) {
                            _this.model.phoneNumber = ctn;
                        };
                        /**
                         * @param newPassword - New voicemail password
                         */
                        this.setNewVoicemailPassword = function (newPassword) {
                            _this.model.newVoicemailPassword = newPassword;
                        };
                        /**
                         * cancel Sim Card Change Wizard and naviagte to the 'start' state
                         * @returns {angular.IPromise<any>}
                         */
                        this.cancelResetVoicemailPassword = function () {
                            // close modal
                        };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                accountNumber: null,
                                phoneNumber: null,
                                newVoicemailPassword: null,
                                confirmVoicemailPassword: null
                            };
                        };
                        /**
                         * @param newPassword - New voicemail password
                         */
                        this.setConfirmVoicemailPassword = function (newPassword) {
                            _this.model.confirmVoicemailPassword = newPassword;
                        };
                        this.openModalPopup = function (accountNumber, ctn) {
                            _this.setAccountNumber(accountNumber);
                            _this.setPhoneNumber(ctn);
                            // TODO config
                            _this.$modal.open({
                                windowTemplateUrl: _this.config.advanced.voicemailResetPasswordModalDirective.windowTemplateUrl,
                                templateUrl: _this.config.advanced.voicemailResetPasswordModalDirective.templateUrl,
                                controller: _this.config.advanced.voicemailResetPasswordModalDirective.controllerName,
                                controllerAs: 'resetPasswordModal',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {}
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        break;
                                    case 'no':
                                        _this.cancelResetVoicemailPassword();
                                        break;
                                }
                            }).catch(function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        this.$get.$inject = ['$modal'];
                        this.resetModel();
                    }
                    ResetVoicemailPasswordProvider.$inject = [];
                    return ResetVoicemailPasswordProvider;
                }());
                angular.module('ute.common.voicemail.resetPassword').provider('ute.common.voicemail.resetPassword.service', ResetVoicemailPasswordProvider);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordController = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordController($modal, resetVoicemailPasswordService, userService) {
                        var _this = this;
                        this.$modal = $modal;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.userService = userService;
                        /**
                         * @param size
                         * @param view
                         */
                        this.openModalPopup = function (size, view) {
                            _this.resetVoicemailPasswordService.setAccountNumber(_this.accountNumber);
                            _this.resetVoicemailPasswordService.setPhoneNumber(_this.ctn);
                            // TODO config
                            _this.$modal.open({
                                windowTemplateUrl: _this.moduleConfig.advanced.voicemailResetPasswordModalDirective.windowTemplateUrl,
                                templateUrl: _this.moduleConfig.advanced.voicemailResetPasswordModalDirective.templateUrl,
                                controller: _this.moduleConfig.advanced.voicemailResetPasswordModalDirective.controllerName,
                                controllerAs: 'resetPasswordModal',
                                size: size,
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {}
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        break;
                                    case 'no':
                                        _this.resetVoicemailPasswordService.cancelResetVoicemailPassword();
                                        break;
                                }
                            }).catch(function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        this.model = this.resetVoicemailPasswordService.getModel();
                        this.moduleConfig = this.resetVoicemailPasswordService.getConfig();
                        this.userType = this.userService.getUserType();
                    }
                    /**
                     * @param simCardForm
                     * @returns {boolean}
                     */
                    ResetVoicemailPasswordController.isFormValid = function (simCardForm) {
                        simCardForm.$submitted = true;
                        return simCardForm.$valid;
                    };
                    /**
                     * @param simCardForm
                     * @param $event
                     */
                    ResetVoicemailPasswordController.prototype.submit = function (simCardForm, $event) {
                        $event.preventDefault();
                        if (ute.common.voicemail.resetPassword.ResetVoicemailPasswordController.isFormValid(simCardForm)) {
                            this.resetVoicemailPasswordService.setNewVoicemailPassword(this.model.newVoicemailPassword);
                            return this.resetVoicemailPasswordService.cancelResetVoicemailPassword();
                        }
                    };
                    ResetVoicemailPasswordController.$inject = ['$modal', 'ute.common.voicemail.resetPassword.service', 'ute.common.user.service'];
                    return ResetVoicemailPasswordController;
                }());
                resetPassword.ResetVoicemailPasswordController = ResetVoicemailPasswordController;
                angular.module('ute.common.voicemail.resetPassword').controller('ute.common.voicemail.resetPassword.directive.controller', ResetVoicemailPasswordController);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPassword = (function () {
                    /* @ngInject */
                    function ResetVoicemailPassword(resetVoicemailPasswordService) {
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.restrict = 'E';
                        this.scope = {
                            accountNumber: '@',
                            ctn: '@'
                        };
                        this.templateUrl = this.resetVoicemailPasswordService.getConfig().advanced.voicemailResetPasswordDirective.templateUrl;
                        this.controller = this.resetVoicemailPasswordService.getConfig().advanced.voicemailResetPasswordDirective.controllerName;
                        this.controllerAs = 'voicemailResetPassword';
                        this.bindToController = true;
                    }
                    /**
                     * @returns {function(ute.common.voicemail.resetPassword.IResetVoicemailPasswordService): ute.common.voicemail.resetPassword.ResetVoicemailPassword}
                     */
                    ResetVoicemailPassword.factory = function () {
                        var directive = function (resetVoicemailPasswordService) { return new ResetVoicemailPassword(resetVoicemailPasswordService); };
                        directive.$inject = ['ute.common.voicemail.resetPassword.service'];
                        return directive;
                    };
                    return ResetVoicemailPassword;
                }());
                angular.module('ute.common.voicemail.resetPassword').directive('uteVoicemailResetPassword', ResetVoicemailPassword.factory());
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordModalController = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordModalController($scope, $translate, $modalInstance, resetVoicemailPasswordModalService, userService, resetVoicemailPasswordService) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$translate = $translate;
                        this.$modalInstance = $modalInstance;
                        this.resetVoicemailPasswordModalService = resetVoicemailPasswordModalService;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.updateSuccessful = false;
                        this.isCallInProgress = function () { return _this.resetVoicemailPasswordModalService.isCallInProgress(); };
                        this.errorMessagePath = function () { return _this.resetVoicemailPasswordModalService.getErrorMessagePath(); };
                        this.showChatOption = function () { return _this.resetVoicemailPasswordModalService.getShowChatOption(); };
                        this.noSelection = function () {
                            _this.resetVoicemailPasswordModalService.resetErrorMessage();
                            _this.$modalInstance.dismiss('cancel');
                        };
                        /**
                         * This onClick function will prevent ng-touch to do the blur() from onClick(event)
                         * Tried to move this function to directive 'ute-modal-input-focus-on-click',
                         * but it is still not working in mobile view.
                         * The same directive is working on desktop view.
                         * Will check it in the future.
                         */
                        this.inputOnClick = function (event) {
                            event.preventDefault();
                            event.stopPropagation();
                            event.target.focus();
                        };
                        this.cancel = function () {
                            _this.resetVoicemailPasswordModalService.resetErrorMessage();
                            _this.$modalInstance.close('no');
                        };
                        this.submit = function (resetVoicemailPasswordForm) {
                            if (_this.resetVoicemailPasswordModalService.formValidation(resetVoicemailPasswordForm)) {
                                _this.resetVoicemailPasswordModalService.setFormData(resetVoicemailPasswordForm);
                                _this.resetVoicemailPasswordModalService.updateVoicemailPassword()
                                    .then(function (result) {
                                    _this.updateSuccessful = result.result;
                                })
                                    .catch(function (error) {
                                    _this.updateSuccessful = error.result;
                                });
                            }
                        };
                        var isCare = userService.getUserType() === 'care';
                        var isDealer = userService.getUserType() === 'dealer';
                        if (isCare || isDealer) {
                            this.resetVoicemailPasswordModalService.populateLastFourDigitsOfPhoneNumber();
                            this.model = this.resetVoicemailPasswordService.getModel();
                        }
                    }
                    ResetVoicemailPasswordModalController.$inject = ['$scope',
                        '$translate',
                        '$modalInstance',
                        'ute.common.voicemail.resetPassword.modal.service',
                        'ute.common.user.service',
                        'ute.common.voicemail.resetPassword.service'];
                    return ResetVoicemailPasswordModalController;
                }());
                resetPassword.ResetVoicemailPasswordModalController = ResetVoicemailPasswordModalController;
                angular.module('ute.common.voicemail.resetPassword').controller('ute.common.voicemail.resetPassword.modal.controller', ResetVoicemailPasswordModalController);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var voicemail;
        (function (voicemail) {
            var resetPassword;
            (function (resetPassword) {
                'use strict';
                var ResetVoicemailPasswordModalService = (function () {
                    /* @ngInject */
                    function ResetVoicemailPasswordModalService($http, $q, resetVoicemailPasswordService, securityService) {
                        var _this = this;
                        this.$http = $http;
                        this.$q = $q;
                        this.resetVoicemailPasswordService = resetVoicemailPasswordService;
                        this.securityService = securityService;
                        this.callInProgress = false;
                        /**
                         * @param resetVoicemailPasswordForm
                         * @returns {boolean}
                         */
                        this.formValidation = function (resetVoicemailPasswordForm) {
                            // Set default value to the error message
                            _this.errorMessagePath = '';
                            _this.showChatOption = false;
                            // First check both new voicemail password and confirm voicemail password are valid
                            //resetVoicemailPasswordForm.newVoicemailPassword.$invalid
                            if (angular.isUndefined(resetVoicemailPasswordForm.newVoicemailPassword.$viewValue) ||
                                angular.isUndefined(resetVoicemailPasswordForm.confirmVoicemailPassword.$viewValue) ||
                                resetVoicemailPasswordForm.newVoicemailPassword.$viewValue.length <= 0 ||
                                resetVoicemailPasswordForm.confirmVoicemailPassword.$viewValue.length <= 0) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.notEnterBothFields';
                                return false;
                            }
                            else if (resetVoicemailPasswordForm.newVoicemailPassword.$invalid ||
                                resetVoicemailPasswordForm.confirmVoicemailPassword.$invalid) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.notFourToFiveDigits';
                                return false;
                            }
                            else if (resetVoicemailPasswordForm.newVoicemailPassword.$modelValue !== resetVoicemailPasswordForm.confirmVoicemailPassword.$modelValue) {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.passwordNotMatch';
                                return false;
                            }
                            return true;
                        };
                        /**
                         * @param resetVoicemailPasswordForm
                         */
                        this.setFormData = function (resetVoicemailPasswordForm) {
                            _this.resetVoicemailPasswordService.setNewVoicemailPassword(resetVoicemailPasswordForm.newVoicemailPassword.$viewValue);
                        };
                        /**
                         * @returns {IPromise<ISubmitResult>}
                         */
                        this.updateVoicemailPassword = function () {
                            var model = _this.resetVoicemailPasswordService.getModel();
                            var request = {
                                applicationId: _this.resetVoicemailPasswordService.getConfig().basic.applicationId,
                                accountNumber: model.accountNumber,
                                phoneNumber: model.phoneNumber,
                                password: model.newVoicemailPassword,
                                medium: _this.resetVoicemailPasswordService.getConfig().basic.medium
                            };
                            _this.callInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.resetVoicemailPasswordService.getConfig().basic.partialApiUrl), request)
                                .then(_this.processResponseOk)
                                .catch(_this.processResponseError)
                                .finally(_this.processResponseFinal);
                        };
                        this.isCallInProgress = function () {
                            return _this.callInProgress;
                        };
                        this.getErrorMessagePath = function () {
                            return _this.errorMessagePath;
                        };
                        this.getShowChatOption = function () {
                            return _this.showChatOption;
                        };
                        this.resetErrorMessage = function () {
                            _this.errorMessagePath = '';
                            _this.showChatOption = false;
                        };
                        this.populateLastFourDigitsOfPhoneNumber = function () {
                            var lastFourDigitOfCTNStr = String(_this.resetVoicemailPasswordService.getPhoneNumber()).slice(6);
                            _this.resetVoicemailPasswordService.setNewVoicemailPassword(lastFourDigitOfCTNStr);
                            _this.resetVoicemailPasswordService.setConfirmVoicemailPassword(lastFourDigitOfCTNStr);
                        };
                        /**
                         * @param response
                         * @returns {boolean}
                         */
                        this.processResponseOk = function (response) {
                            //console.log('response.data', response.data);
                            //response.data = { 'status': { 'code': 0, 'requestId': '484ae78d-2900-455f-a71f-5636f4c6b3fa' }, 'content': { 'status': true } };
                            //response.data = {"status":{"code":15650,"codeName":"FAILED_IN_RESET","requestId":"2dc27924-7119-48b8-b1b4-b4adc3d53760","description":"Failed to reset voicemail password116417199"}};
                            _this.showChatOption = false;
                            if (_.has(response.data, 'content.status') && response.data.content.status === true) {
                                _this.errorMessagePath = '';
                                return _this.$q.when({ result: true, errorKey: '', errorObject: null });
                            }
                            else {
                                _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.failure';
                                return _this.$q.reject({ result: false, errorKey: 'ute.voicemail.resetPassword.responseMessage.failure', errorObject: null });
                            }
                        };
                        this.processResponseError = function (reason) {
                            //console.log('processResponseError->response', reason);
                            _this.showChatOption = true;
                            _this.errorMessagePath = 'ute.voicemail.resetPassword.responseMessage.failure';
                            return _this.$q.reject({ result: false, errorKey: 'ute.voicemail.resetPassword.responseMessage.failure', errorObject: reason });
                        };
                        this.processResponseFinal = function () {
                            _this.callInProgress = false;
                            //console.log('processResponseFinal', this.callInProgress);
                            return true;
                        };
                        this.errorMessagePath = '';
                        this.showChatOption = false;
                    }
                    ResetVoicemailPasswordModalService.$inject = [
                        '$http',
                        '$q',
                        'ute.common.voicemail.resetPassword.service',
                        'ute.common.security.service'];
                    return ResetVoicemailPasswordModalService;
                }());
                angular.module('ute.common.voicemail.resetPassword').service('ute.common.voicemail.resetPassword.modal.service', ResetVoicemailPasswordModalService);
            })(resetPassword = voicemail.resetPassword || (voicemail.resetPassword = {}));
        })(voicemail = common.voicemail || (common.voicemail = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var service;
                (function (service) {
                    'use strict';
                    var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                    var ProviderBase = ute.common.core.ProviderBase;
                    var RevolutionOffer = (function () {
                        function RevolutionOffer() {
                        }
                        return RevolutionOffer;
                    }());
                    service.RevolutionOffer = RevolutionOffer;
                    /**
                     * worker return cached result and implement refresh true/false retry logic
                     */
                    var RevolutionOfferWorker = (function (_super) {
                        __extends(RevolutionOfferWorker, _super);
                        function RevolutionOfferWorker(config, securityService, $http, $q, $timeout, userService, $injector, request) {
                            _super.call(this, new RevolutionOffer(), config, securityService, $http, $q, $timeout, userService, request); // TODO
                            this.$injector = $injector;
                            this.isRevolutionOfferCallInProgress = this.isCallInProgress;
                            this.getRevolutionOffer = this.getData;
                            this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                            this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                            this.normalizeData = function (revolutionOffer) {
                                return revolutionOffer;
                            };
                        }
                        ;
                        return RevolutionOfferWorker;
                    }(CacheableDataGeneric));
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * only one worker exists for the same request
                     */
                    var RevolutionOfferFactory = (function () {
                        function RevolutionOfferFactory(config, securityService, $http, $q, $timeout, userService, $injector) {
                            var _this = this;
                            this.config = config;
                            this.securityService = securityService;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.userService = userService;
                            this.$injector = $injector;
                            this._getWorker = function (request) {
                                // console.log('IRevolutionOfferFactory->_getWorker: request=', request);
                                return new RevolutionOfferWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, _this.$injector, request);
                            };
                            this.getWorker = _.memoize(this._getWorker, ute.common.utils.UtilsStatic.memoizeResolver);
                        }
                        ;
                        return RevolutionOfferFactory;
                    }());
                    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                    /**
                     * Provider only responsable for configuration and to return factory
                     */
                    var RevolutionOfferProvider = (function (_super) {
                        __extends(RevolutionOfferProvider, _super);
                        /* @ngInject */
                        function RevolutionOfferProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout) {
                                var factory = new RevolutionOfferFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'), $injector);
                                return function (request) { return factory.getWorker(request); };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout'
                            ];
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    partialApiUrl: 'v1/offer-status',
                                    logPrefix: 'RevolutionOfferStatus',
                                    revolutionAddNhl: false,
                                    revolutionGetOffers: 'v1/offer-status',
                                    logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                    isCachableOnBackend: false
                                }
                            };
                        }
                        ;
                        RevolutionOfferProvider.$inject = [];
                        return RevolutionOfferProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.revolution.data.service').provider('ute.rogers.revolution.data.offer.factory', RevolutionOfferProvider);
                })(service = data.service || (data.service = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                    /* @ngInject */
                    var RogersHeroModalController = (function () {
                        /* @ngInject */
                        function RogersHeroModalController($scope, RogersHeroModalService, ngDialog, $rootScope, $http, $window, $cookies) {
                            var _this = this;
                            this.RogersHeroModalService = RogersHeroModalService;
                            this.ngDialog = ngDialog;
                            this.noSelection = function () {
                            };
                            this.isSingleHeroOffer = function () {
                                return _this.RogersHeroModalService.isSingleHeroOffer();
                            };
                            this.isOfferPresentForSingleCtn = function () {
                                return _this.RogersHeroModalService.isOfferPresentForSingleCtn();
                            };
                            this.getHeroOfferDetails = function () {
                                return _this.scope.ShareEveythingheroCtnsformed;
                            };
                            this.init = function () {
                                _this.scope.ShareEveythingheroCtnsformed = _this.RogersHeroModalService.getHeroOffers();
                                _this.scope.indHeroCtn = _this.RogersHeroModalService.getIndHeroOffers();
                                _this.config = _this.RogersHeroModalService.getConfig();
                                //this.rootscope.$emit('heroResponse', this.RogersHeroModalService.heroResponse);
                                _this.noTransactionalBpoPresent = _this.RogersHeroModalService.getNoTransactionalBpoPresent();
                                _this.noTransactionalBpoOfferDetails = _this.RogersHeroModalService.getNoTransactionalBpoOfferDetails();
                            };
                            $scope.message1 = 'hello';
                            this.scope = $scope;
                            this.rootscope = $rootScope;
                            this.http = $http;
                            this.window = $window;
                            this.cookie = $cookies;
                            this.init();
                        }
                        RogersHeroModalController.prototype.isShareEveryThing = function () {
                            return this.RogersHeroModalService.isShareEverything();
                        };
                        RogersHeroModalController.prototype.getLang = function () {
                            var lang = this.RogersHeroModalService.getLang();
                            return lang;
                        };
                        RogersHeroModalController.prototype.isIndividual = function () {
                            return this.RogersHeroModalService.isIndividual();
                        };
                        RogersHeroModalController.prototype.getShareEverythingCtnList = function () {
                            //$scope.ShareEveythingheroCtns[0]=ctnDetails1;
                            //$scope.ShareEveythingheroCtns[1]=ctnDetails2;
                            //$scope.ShareEveythingheroCtns[2]=ctnDetails3;
                            return this.scope.ShareEveythingheroCtnsformed;
                        };
                        ;
                        RogersHeroModalController.prototype.getIndCtnList = function () {
                            return this.scope.indHeroCtn;
                        };
                        ;
                        RogersHeroModalController.prototype.getCtnOffers = function (index) {
                            return this.scope.ShareEveythingheroCtnsformed[index].offer;
                        };
                        ;
                        RogersHeroModalController.prototype.getIndCtnOffers = function (index) {
                            return this.scope.indHeroCtn[index].offer;
                        };
                        ;
                        RogersHeroModalController.prototype.getShareEverythingCtnBpos = function (index) {
                            var heroBpos = this.scope.ShareEveythingheroCtnsformed[index].bpo;
                            //Handling multiple standalone BPOs
                            /* if (heroBpos && heroBpos.length > 0) {
                                if (heroBpos.some(bpoDetails => bpoDetails.bpoCategory === 'hupBpo')) {
                                    return heroBpos.filter(bpoDetails => bpoDetails.bpoCategory === 'hupBpo');
                                } else {
                                    return heroBpos.filter(bpoDetails => bpoDetails.bpoCategory === 'tvmBpo');
                                }
                            } */
                            return heroBpos;
                        };
                        ;
                        RogersHeroModalController.prototype.getIndCtnBpos = function (index) {
                            var heroBpos = this.scope.indHeroCtn[index].bpo;
                            //Handling multiple standalone BPOs
                            /* if (heroBpos && heroBpos.length > 0) {
                                if (heroBpos.some(bpoDetails => bpoDetails.bpoCategory === 'hupBpo')) {
                                    return heroBpos.filter(bpoDetails => bpoDetails.bpoCategory === 'hupBpo');
                                } else {
                                    return heroBpos.filter(bpoDetails => bpoDetails.bpoCategory === 'tvmBpo');
                                }
                            } */
                            return heroBpos;
                        };
                        ;
                        RogersHeroModalController.prototype.shareCtnHasBpoOnly = function (index) {
                            var hasBpoOnly = !this.scope.ShareEveythingheroCtnsformed[index].hupPresent && !this.scope.ShareEveythingheroCtnsformed[index].tvmPresent
                                && (this.scope.ShareEveythingheroCtnsformed[index].hupBpoPresent || this.scope.ShareEveythingheroCtnsformed[index].tvmBpoPresent || this.scope.ShareEveythingheroCtnsformed[index].noTransactionalBpoPresent);
                            console.log('CTN - ' + this.scope.ShareEveythingheroCtnsformed[index].ctn + 'hasBpoOnly - ' + hasBpoOnly);
                            return hasBpoOnly;
                        };
                        ;
                        RogersHeroModalController.prototype.indHasBpoOnly = function (index) {
                            var hasBpoOnly = !this.scope.indHeroCtn[index].hupPresent && !this.scope.indHeroCtn[index].tvmPresent
                                && (this.scope.indHeroCtn[index].hupBpoPresent || this.scope.indHeroCtn[index].tvmBpoPresent || this.scope.indHeroCtn[index].noTransactionalBpoPresent);
                            console.log('CTN - ' + this.scope.indHeroCtn[index].ctn + 'hasBpoOnly - ' + hasBpoOnly);
                            return hasBpoOnly;
                        };
                        ;
                        RogersHeroModalController.prototype.displayShareCtnOtherDeviceOffers = function (index) {
                            return this.scope.ShareEveythingheroCtnsformed[index].hupPresent || this.scope.ShareEveythingheroCtnsformed[index].hupBpoPresent;
                        };
                        ;
                        RogersHeroModalController.prototype.displayShareCtnOtherPlanOffers = function (index) {
                            return this.scope.ShareEveythingheroCtnsformed[index].tvmPresent || this.scope.ShareEveythingheroCtnsformed[index].tvmBpoPresent;
                        };
                        ;
                        RogersHeroModalController.prototype.displayIndCtnOtherDeviceOffers = function (index) {
                            return this.scope.indHeroCtn[index].hupPresent || this.scope.indHeroCtn[index].hupBpoPresent;
                        };
                        ;
                        RogersHeroModalController.prototype.displayIndCtnOtherPlanOffers = function (index) {
                            return this.scope.indHeroCtn[index].tvmPresent || this.scope.indHeroCtn[index].tvmBpoPresent;
                        };
                        ;
                        RogersHeroModalController.prototype.closeDialog = function () {
                            var request = this.RogersHeroModalService.heroDeclinedTargetedOffers;
                            this.http.post(this.config.advanced.HeroModal.protectedRoot + this.config.advanced.declineHeroModal.apiUrl, request);
                            this.RogersHeroModalService.DialogVM.close();
                        };
                        ;
                        RogersHeroModalController.prototype.closeSuccessOrErrorDialog = function () {
                            this.RogersHeroModalService.DialogVM.close();
                        };
                        RogersHeroModalController.prototype.isDisabled = function (index, isShareCtn) {
                            var heroCtnObj;
                            if (isShareCtn) {
                                heroCtnObj = this.scope.ShareEveythingheroCtnsformed[index];
                            }
                            else {
                                heroCtnObj = this.scope.indHeroCtn[index];
                            }
                            if (heroCtnObj.tvmPresent || heroCtnObj.hupPresent) {
                                var showButton = false;
                                var offers = heroCtnObj.offer;
                                offers.forEach(function (offer) {
                                    if (offer.offerType === 'hupOffer') {
                                        if (offer.offerSelected || !heroCtnObj.tvmPresent) {
                                            showButton = true;
                                        }
                                    }
                                    else if (offer.offerType === 'tvmOffer') {
                                        if (offer.offerSelected || !heroCtnObj.hupPresent) {
                                            showButton = true;
                                        }
                                    }
                                });
                                return showButton;
                            }
                            else if (heroCtnObj.hupBpoPresent || heroCtnObj.tvmBpoPresent) {
                                var bpos = heroCtnObj.bpo;
                                var showButtonBpo = false;
                                bpos.forEach(function (bpoDetailObj) {
                                    if (bpoDetailObj.bpoCategory === 'hupBpo') {
                                        if (bpoDetailObj.offerSelected || !heroCtnObj.tvmBpoPresent) {
                                            showButtonBpo = true;
                                        }
                                    }
                                    else if (bpoDetailObj.bpoCategory === 'tvmBpo') {
                                        if (bpoDetailObj.offerSelected || !heroCtnObj.hupBpoPresent) {
                                            showButtonBpo = true;
                                        }
                                    }
                                });
                                return showButtonBpo;
                            }
                            else if (heroCtnObj.noTransactionalBpoPresent) {
                                var bpos = heroCtnObj.bpo;
                                var showButtonBpo = false;
                                bpos.forEach(function (bpoDetailObj) {
                                    if (bpoDetailObj.bpoCategory === 'noTransactionalBPO') {
                                        showButtonBpo = true;
                                    }
                                });
                                return showButtonBpo;
                            }
                        };
                        RogersHeroModalController.prototype.setSelectedHeroOffers = function (index, isShareCtn) {
                            var _this = this;
                            var heroCtnObj;
                            if (isShareCtn) {
                                heroCtnObj = this.scope.ShareEveythingheroCtnsformed[index];
                            }
                            else {
                                heroCtnObj = this.scope.indHeroCtn[index];
                            }
                            var offers = heroCtnObj.offer;
                            var bpoSkuIdSelected;
                            var bpoExtIdSelected;
                            var getUserLanguage;
                            var selectedOfferDetails = [];
                            var selectedBpoDetails = [];
                            var checkedOfferList = [];
                            var checkedOffer = {
                                ctn: '',
                                hupOffer: '',
                                tvmOffer: '',
                                hup4BPO: '',
                                tvmBPO: '',
                                standAloneBPO: ''
                            };
                            var hupSelected = false;
                            var tvmSelected = false;
                            var hupBpoSelected = false;
                            var tvmBpoSelected = false;
                            var selectedHupBpoId = '';
                            var selectedTvmBpoId = '';
                            var isHeroSelected = false;
                            checkedOffer.ctn = heroCtnObj.ctn;
                            if (heroCtnObj.tvmPresent || heroCtnObj.hupPresent) {
                                offers.forEach(function (offer) {
                                    if (offer.offerType === 'hupOffer') {
                                        if (offer.offerSelected || !heroCtnObj.tvmPresent) {
                                            isHeroSelected = true;
                                            _this.window.localStorage.setItem('phoneNumber', heroCtnObj.ctn);
                                            var hupOfferDetails = {
                                                ctn: heroCtnObj.ctn,
                                                offerName: 'hupOffer',
                                                externalId: offer.id,
                                                phoneSku: offer.skuId,
                                                programCode: offer.programCode,
                                                term: offer.term,
                                                categoryCode: offer.hupOfferCategory,
                                                bpoID: (offer.bpoDetails && offer.bpoDetails.bpoCategory === 'hupBpo') ? offer.bpoDetails.bpoid : ''
                                            };
                                            hupSelected = true;
                                            checkedOffer.hupOffer = offer.skuId;
                                            selectedOfferDetails.push(hupOfferDetails);
                                        }
                                    }
                                    else if (offer.offerType === 'tvmOffer') {
                                        if (offer.offerSelected || !heroCtnObj.hupPresent) {
                                            isHeroSelected = true;
                                            _this.window.localStorage.setItem('phoneNumber', heroCtnObj.ctn);
                                            var tvmOfferDetails = {
                                                ctn: heroCtnObj.ctn,
                                                offerName: 'tvmOffer',
                                                externalId: offer.id,
                                                planeSoc: offer.skuId,
                                                bpoID: (offer.bpoDetails && offer.bpoDetails.bpoCategory === 'tvmBpo') ? offer.bpoDetails.bpoid : ''
                                            };
                                            tvmSelected = true;
                                            checkedOffer.tvmOffer = offer.skuId;
                                            selectedOfferDetails.push(tvmOfferDetails);
                                        }
                                    }
                                });
                            }
                            else if (heroCtnObj.hupBpoPresent || heroCtnObj.tvmBpoPresent) {
                                var bpos = heroCtnObj.bpo;
                                bpos.forEach(function (bpoDetailObj) {
                                    if (bpoDetailObj.bpoCategory === 'hupBpo') {
                                        if (bpoDetailObj.offerSelected || !heroCtnObj.tvmBpoPresent) {
                                            isHeroSelected = true;
                                            _this.window.localStorage.setItem('phoneNumber', heroCtnObj.ctn);
                                            var bpoDetails = {
                                                ctn: heroCtnObj.ctn,
                                                bpoCategory: bpoDetailObj.bpoCategory,
                                                bpoID: bpoDetailObj.bpoid
                                            };
                                            selectedHupBpoId = bpoDetailObj.bpoid;
                                            hupBpoSelected = true;
                                            checkedOffer.hup4BPO = bpoDetailObj.bpoSkuId;
                                            selectedBpoDetails.push(bpoDetails);
                                        }
                                    }
                                    else if (bpoDetailObj.bpoCategory === 'tvmBpo') {
                                        if (bpoDetailObj.offerSelected || !heroCtnObj.hupBpoPresent) {
                                            isHeroSelected = true;
                                            _this.window.localStorage.setItem('phoneNumber', heroCtnObj.ctn);
                                            var bpoDetails = {
                                                ctn: heroCtnObj.ctn,
                                                bpoCategory: bpoDetailObj.bpoCategory,
                                                bpoID: bpoDetailObj.bpoid
                                            };
                                            selectedTvmBpoId = bpoDetailObj.bpoid;
                                            tvmBpoSelected = true;
                                            checkedOffer.tvmBPO = bpoDetailObj.bpoSkuId;
                                            selectedBpoDetails.push(bpoDetails);
                                        }
                                    }
                                });
                            }
                            else if (heroCtnObj.noTransactionalBpoPresent && !heroCtnObj.hupBpoPresent && !heroCtnObj.tvmBpoPresent) {
                                var bpos = heroCtnObj.bpo;
                                bpos.forEach(function (bpoDetailObj) {
                                    if (bpoDetailObj.bpoCategory === 'noTransactionalBPO') {
                                        isHeroSelected = true;
                                        _this.window.localStorage.setItem('phoneNumber', heroCtnObj.ctn);
                                        var bpoDetails = {
                                            ctn: heroCtnObj.ctn,
                                            bpoCategory: bpoDetailObj.bpoCategory,
                                            bpoID: bpoDetailObj.bpoid
                                        };
                                        bpoExtIdSelected = bpoDetailObj.bpoid;
                                        checkedOffer.standAloneBPO = bpoDetailObj.bpoSkuId;
                                        bpoSkuIdSelected = bpoDetailObj.bpoSkuId;
                                        selectedBpoDetails.push(bpoDetails);
                                        _this.RogersHeroModalService.setNoTransactionalBpoOfferDetails(bpoDetailObj);
                                    }
                                });
                            }
                            console.log('Selected Offer Details - ' + selectedOfferDetails);
                            console.log('Selected BPO Details - ' + selectedBpoDetails);
                            if (hupSelected && !tvmSelected) {
                                this.rootscope.$emit('hupHeroOfferSelected', selectedOfferDetails);
                            }
                            else if (hupSelected && tvmSelected) {
                                this.rootscope.$emit('hup&TvmHeroOfferSelected', selectedOfferDetails);
                            }
                            else if (!hupSelected && tvmSelected) {
                                this.rootscope.$emit('heroOfferSelected', selectedOfferDetails);
                            }
                            else if (hupBpoSelected && tvmBpoSelected) {
                                this.window.localStorage.setItem('hupStandaloneBpo', selectedHupBpoId);
                                this.window.localStorage.setItem('tvmStandaloneBpo', selectedTvmBpoId);
                                this.rootscope.$emit('heroRedirectUrl', 'hup');
                            }
                            else if (hupBpoSelected) {
                                this.window.localStorage.setItem('hupStandaloneBpo', selectedHupBpoId);
                                this.rootscope.$emit('heroRedirectUrl', 'hup');
                            }
                            else if (tvmBpoSelected) {
                                this.window.localStorage.setItem('tvmStandaloneBpo', selectedTvmBpoId);
                                this.rootscope.$emit('heroRedirectUrl', 'tvm');
                            }
                            checkedOfferList.push(checkedOffer);
                            if (isHeroSelected) {
                                var request = {
                                    ban: this.window.localStorage.getItem('accountNumber'),
                                    offersList: checkedOfferList
                                };
                                this.http.post(this.config.advanced.HeroModal.protectedRoot + this.config.advanced.updateHeroOffersInDb.url, request);
                                this.RogersHeroModalService.trackSelectedHeroOffers(heroCtnObj.ctn, hupSelected, tvmSelected, hupBpoSelected, tvmBpoSelected, heroCtnObj.noTransactionalBpoPresent); //analytics changes
                                getUserLanguage = this.RogersHeroModalService.getLang();
                                if (heroCtnObj.noTransactionalBpoPresent) {
                                    var bpoRequest = {
                                        accountNumber: this.window.localStorage.getItem('accountNumber'),
                                        phoneNumber: heroCtnObj.ctn,
                                        externalId: bpoExtIdSelected,
                                        skuId: bpoSkuIdSelected,
                                        applicationId: 'Rogers.com',
                                        language: getUserLanguage,
                                        sessionKey: ""
                                    };
                                    this.RogersHeroModalService.validateBPOOffer(bpoRequest);
                                }
                                this.RogersHeroModalService.DialogVM.close();
                            }
                        };
                        ;
                        RogersHeroModalController.prototype.openOfferDetails = function (index) {
                            console.log('Opening ShareEverything Offer Section');
                            for (var i = 0; i < this.scope.ShareEveythingheroCtnsformed.length; i++) {
                                if (index === i) {
                                    this.scope.ShareEveythingheroCtnsformed[i].showContent = !this.scope.ShareEveythingheroCtnsformed[i].showContent;
                                    if (this.scope.ShareEveythingheroCtnsformed[i].showContent) {
                                        this.RogersHeroModalService.trackCtnHeroOffers(this.scope.ShareEveythingheroCtnsformed[i].ctn); //analytics changes
                                    }
                                }
                                else {
                                    this.scope.ShareEveythingheroCtnsformed[i].showContent = false;
                                }
                            }
                            for (var i = 0; i < this.scope.indHeroCtn.length; i++) {
                                this.scope.indHeroCtn[i].showContent = false;
                            }
                        };
                        RogersHeroModalController.prototype.openIndOfferDetails = function (index) {
                            console.log('Opening Individual Offer Section');
                            for (var i = 0; i < this.scope.indHeroCtn.length; i++) {
                                if (index === i) {
                                    this.scope.indHeroCtn[i].showContent = !this.scope.indHeroCtn[i].showContent;
                                    if (this.scope.indHeroCtn[i].showContent) {
                                        this.RogersHeroModalService.trackCtnHeroOffers(this.scope.indHeroCtn[i].ctn);
                                    }
                                }
                                else {
                                    this.scope.indHeroCtn[i].showContent = false;
                                }
                            }
                            for (var i = 0; i < this.scope.ShareEveythingheroCtnsformed.length; i++) {
                                this.scope.ShareEveythingheroCtnsformed[i].showContent = false;
                            }
                        };
                        RogersHeroModalController.prototype.redirectUrl = function (flag, index, flow) {
                            if (flow === 'share') {
                                this.window.localStorage.setItem('phoneNumber', this.scope.ShareEveythingheroCtnsformed[index].ctn);
                            }
                            else {
                                this.window.localStorage.setItem('phoneNumber', this.scope.indHeroCtn[index].ctn);
                            }
                            this.rootscope.$emit('heroRedirectUrl', flag);
                            this.RogersHeroModalService.DialogVM.close();
                        };
                        RogersHeroModalController.$inject = [
                            '$scope', 'ute.rogers.hero.modal.service', 'ngDialog', '$rootScope', '$http', '$window', '$cookies'
                        ];
                        RogersHeroModalController.controlerName = 'ute.rogers.hero.modal.controller';
                        return RogersHeroModalController;
                    }());
                    angular.module('ute.rogers.bpo.integration.service').controller(RogersHeroModalController.controlerName, RogersHeroModalController);
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                angular.module('ute.rogers.interceptors.auth').config(configure);
                configure.$inject = ['$httpProvider', 'ute.rogers.interceptors.auth.serviceProvider'];
                /* @ngInject */
                function configure($httpProvider, authHttpResponseInterceptorProvider) {
                    //authHttpResponseInterceptorProvider.configure({
                    //  httpCodes: [401],
                    //  notifyEvents: [ute.blocks.messages.bus.Messages.uteUserUnauthorized]
                    //});
                    $httpProvider.interceptors.push(authHttpResponseInterceptorProvider.$get);
                }
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var interceptors;
        (function (interceptors) {
            var auth;
            (function (auth) {
                'use strict';
                var AuthHttpResponseInterceptorProvider = (function () {
                    /* @ngInject */
                    function AuthHttpResponseInterceptorProvider() {
                        var _this = this;
                        this.config = {
                            httpCodes: [401],
                            notifyEvents: [ute.blocks.messages.bus.Messages.uteUserUnauthorized],
                        };
                        this.isRefreshing = null;
                        /* @ngInject */
                        this.$get = function ($q, $injector) {
                            _this.$q = $q;
                            _this.$injector = $injector;
                            _this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                            _this.dataLayerService = $injector.get('ute.datalayer.common.service');
                            return {
                                request: _this.request,
                                response: _this.response,
                                responseError: _this.responseError,
                            };
                        };
                        this.configure = function (config) {
                            _this.config = (_.merge(_this.config, config));
                            return true;
                        };
                        this.request = function (config) {
                            if (config.url.match(/api\//)) {
                                _this.dataLayerService.trackHttpRequest(config);
                            }
                            return config;
                        };
                        this.response = function (response) {
                            if (_.get(response.config, 'track')) {
                                _this.dataLayerService.trackHttpResponse(response);
                            }
                            // TODO search text
                            if (_.includes(_this.config.httpCodes, response.status) ||
                                (angular.isString(response.data) &&
                                    response.data.search(/<html.*>.*You will be forwarded to continue the authorization process/i) >= 0)) {
                                _this.notify();
                                return _this.$q.reject(response);
                            }
                            else {
                                return _this.$q.when(response);
                            }
                        };
                        this.responseError = function (rejection) {
                            if (rejection.config.url.match(/api\//)) {
                                _this.dataLayerService.trackHttpResponseError(rejection);
                            }
                            if (_.includes(_this.config.httpCodes, rejection.status)) {
                                if (rejection.status === 401) {
                                    _this.notify();
                                    return _this.$q.reject(rejection);
                                }
                                return _this.handleTokenError(rejection);
                            }
                        };
                        this.notify = function () {
                            _.forEach(_this.config.notifyEvents, function (value) {
                                _this.messagesService.publish(value);
                            });
                        };
                        this.handleTokenError = function (rejection) {
                            var deferred = _this.$q.defer();
                            if (!_this.isRefreshing) {
                                console.log('rogers-client calling triggerSilentTokenRefresh() for API endpoint: ', rejection.config.url);
                                _this.isRefreshing = _this.damSilentAuth.triggerSilentTokenRefresh();
                            }
                            _this.isRefreshing.then(function (isTokenRefreshed) {
                                _this.isRefreshing = null;
                                if (!isTokenRefreshed) {
                                    // if token is not refreshed, log the user out
                                    console.log('rogers-client silent reauth failed, logging user out!');
                                    _this.notify();
                                    return _this.$q.reject();
                                }
                                // if token is refreshed, then re-try failed API
                                console.log('rogers-client silent reauth successful, re-trying failed API endpoint: ', rejection.config.url);
                                _this.$injector
                                    .get('$http')(rejection.config)
                                    .then(function (data) {
                                    deferred.resolve(data);
                                }, function (error) {
                                    deferred.reject(error);
                                });
                            }, function (error) {
                                console.log('rogers-client silent reauth triggerSilentTokenRefresh() rejected, logging user out!');
                                _this.isRefreshing = null;
                                _this.notify();
                                return _this.$q.reject(error);
                            });
                            return deferred.promise;
                        };
                        this.initializeDamSilentAuth = function () {
                            try {
                                // tslint:disable-next-line
                                _this.damSilentAuth = new window['DamSilentAuth']();
                            }
                            catch (error) {
                                console.error('dam-silent-auth.js needs to be added in the html header otherwise error 498 cannot be handled!', error);
                                _this.damSilentAuth = {
                                    triggerSilentTokenRefresh: function () {
                                        var deferredSilentAuth = _this.$q.defer();
                                        deferredSilentAuth.resolve(false);
                                        return deferredSilentAuth.promise;
                                    },
                                };
                            }
                        };
                        this.$get.$inject = ['$q', '$injector'];
                        this.initializeDamSilentAuth();
                    }
                    AuthHttpResponseInterceptorProvider.$inject = [];
                    return AuthHttpResponseInterceptorProvider;
                }());
                angular
                    .module('ute.rogers.interceptors.auth')
                    .provider('ute.rogers.interceptors.auth.service', AuthHttpResponseInterceptorProvider);
            })(auth = interceptors.auth || (interceptors.auth = {}));
        })(interceptors = rogers.interceptors || (rogers.interceptors = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersSecondLevelNavigation = (function () {
                        function RogersSecondLevelNavigation() {
                            // DDO properties
                            this.restrict = 'E';
                            this.templateUrl = 'module/rogersSecondLevelNavigation/navigationBar.directive.view.html';
                            this.scope = false;
                            this.controller = navigation.RogersSecondLevelNavigationConsumerController.controllerName;
                            this.controllerAs = '$ctrl';
                        }
                        RogersSecondLevelNavigation.factory = function () {
                            var directive = function () { return new RogersSecondLevelNavigation(); };
                            directive.$inject = [];
                            return directive;
                        };
                        return RogersSecondLevelNavigation;
                    }());
                    angular.module('ute.rogers.second.level.navigation').directive('uteRogersSecondLevelNavigation', RogersSecondLevelNavigation.factory());
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersNavigationService = (function () {
                        function RogersNavigationService(config, navigationService, provider) {
                            var _this = this;
                            this.config = config;
                            this.navigationService = navigationService;
                            this.provider = provider;
                            this.configure = this.provider.configure;
                            this.getConfigByUserType = this.provider.getConfigByUserType;
                            /**
                             * @returns {IRogersNavigationServiceConfig}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                        }
                        ;
                        return RogersNavigationService;
                    }());
                    var RogersNavigationProvider = (function () {
                        /* @ngInject */
                        function RogersNavigationProvider(accountOverviewServiceProvider, accountOverviewSummaryProvider, accountDetailProvider, navigationProvider) {
                            var _this = this;
                            this.accountOverviewServiceProvider = accountOverviewServiceProvider;
                            this.accountOverviewSummaryProvider = accountOverviewSummaryProvider;
                            this.accountDetailProvider = accountDetailProvider;
                            this.navigationProvider = navigationProvider;
                            this.config = {
                                basic: {}
                            };
                            this.getConfigByUserType = function (userType) {
                                // TODO: move this to a config file
                                var configMap = {
                                    'consumer': {
                                        basic: {
                                            navigation: {
                                                accountOverview: {
                                                    url: '/web/totes/#/accountOverview'
                                                },
                                                wirelessDashboard: {
                                                    url: '/web/totes/#/wireless'
                                                },
                                                shareEverythingDashboard: {
                                                    url: '/web/totes/#/shareEverything'
                                                },
                                                wirelessPrepaidDashboard: {
                                                    url: '/web/totes/#/wirelessPrepaid'
                                                },
                                                internetDashboard: {
                                                    url: '/web/totes/#/internetdash'
                                                },
                                                tvDashboard: {
                                                    url: '/web/totes/#/tvdashboard'
                                                },
                                                viewBill: {
                                                    url: '/web/totes/#/viewbill'
                                                },
                                                paymentHistory: {
                                                    url: '/web/totes/#/paymenthistory'
                                                },
                                                linkAccount: {
                                                    url: '/web/totes/#/linkaccount'
                                                },
                                                profile: {
                                                    url: '/web/totes/#/profile'
                                                }
                                            }
                                        }
                                    },
                                    'dealer': {
                                        basic: {
                                            navigation: {
                                                accountOverview: {
                                                    url: '/web/totes/#/oneViewDashboard'
                                                },
                                                /* there may be additional logic required here to direct user to different places */
                                                viewBill: {
                                                    url: '/web/totes/#/viewbill'
                                                },
                                                /* this just opens a modal window telling user to go to SSP or SGI, temporarily sending back to totes overview*/
                                                profile: {
                                                    url: '/web/totes/#/oneViewDashboard'
                                                },
                                                interactions: {
                                                    url: '/web/totes/#/interaction'
                                                }
                                            }
                                        }
                                    }
                                };
                                return configMap[userType];
                            };
                            /* @ngInject */
                            this.$get = function ($injector) {
                                // this.userService = $injector.get('ute.common.user.service');
                                // this.securityService = $injector.get('ute.common.security.service');
                                // this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                var navigationService = $injector.get('ute.common.second.level.navigation.service');
                                navigationService.enableFullMenu(); // TODO
                                return new RogersNavigationService(_this.config, navigationService, _this);
                                // return new RogersNavigationService(this.config, navigationService);
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                _this.accountOverviewServiceProvider.configure({
                                    basic: {
                                        applicationId: _this.config.basic.applicationId
                                    },
                                    navigation: {
                                        accountOverview: {
                                            url: _this.config.basic.navigation.accountOverview.url
                                        }
                                    }
                                });
                                _this.accountOverviewSummaryProvider.configure({
                                    basic: {
                                        applicationId: _this.config.basic.applicationId
                                    },
                                    navigation: {
                                        wirelessDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.wirelessDashboard.url')
                                        },
                                        shareEverythingDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.shareEverythingDashboard.url')
                                        },
                                        internetDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.internetDashboard.url')
                                        },
                                        tvDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.tvDashboard.url')
                                        },
                                        homePhoneDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.homePhoneDashboard.url')
                                        },
                                        iptvDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.iptvDashboard.url')
                                        },
                                        shmDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.shmDashboard.url')
                                        }
                                    }
                                });
                                _this.accountDetailProvider.configure({
                                    basic: {
                                        applicationId: _this.config.basic.applicationId
                                    },
                                    navigation: {
                                        wirelessPrepaidDashboard: {
                                            url: _.get(_this.config, 'basic.navigation.wirelessPrepaidDashboard.url')
                                        }
                                    }
                                });
                                return true;
                            };
                            this.$get.$inject = [
                                '$injector'
                            ];
                            // set to consumer config by default
                            this.config = this.getConfigByUserType('consumer');
                        }
                        ;
                        RogersNavigationProvider.$inject = ['ute.rogers.account.overview.factoryProvider',
                            'ute.rogers.account.overview.summary.factoryProvider',
                            'ute.rogers.account.detail.factoryProvider',
                            'ute.common.second.level.navigation.serviceProvider'];
                        return RogersNavigationProvider;
                    }());
                    angular.module('ute.rogers.second.level.navigation').provider('ute.rogers.second.level.navigation.service', RogersNavigationProvider);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var ForgotPasswordController = (function () {
                /* @ngInject */
                function ForgotPasswordController($document, setPasswordService, $modal, $translate) {
                    var _this = this;
                    this.$document = $document;
                    this.setPasswordService = setPasswordService;
                    this.$modal = $modal;
                    this.$translate = $translate;
                    this.isRogersForgotPasswordCallInProgress = this.setPasswordService.isRogersForgotPasswordCallInProgress;
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.submit = function () {
                        // console.log(ForgotPasswordController.controlerName + '->submit continue');
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.setPasswordService.forgotPassword(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.cancel = function () {
                        // console.log(ForgotPasswordController.controlerName + '->submit has been called');
                        _this.setPasswordService.goToState(_this.config.advanced.forgotPassword.cancelState);
                    };
                    this.isSubmitButtonEnable = function () {
                        return _this.form.$valid && !_this.isRogersForgotPasswordCallInProgress();
                    };
                    this.processOk = function (codeEntry) {
                        // console.log(ForgotPasswordController.controlerName + '->processOk: codeEntry=', codeEntry);
                        // return this.userRegistrationService.goToConfirmation();
                        // return codeEntry;
                        return null; // TODO
                    };
                    /**
                     * @param codeEntry
                     */
                    this.processError = function (codeEntry) {
                        // console.log(ForgotPasswordController.controlerName + '->processError: codeEntry=', codeEntry);
                        _this.errorMessageKey = codeEntry.frontendMessageKey;
                        // this.userRegistrationService.goToConfirmation();
                        _this.openModalPopup(codeEntry);
                    };
                    $document.scrollTop(0);
                    this.setPasswordService.resetForgotPasswordModel();
                    this.model = this.setPasswordService.getForgotPasswordModel();
                    this.config = this.setPasswordService.getConfig();
                }
                ForgotPasswordController.prototype.openModalPopup = function (errorHandler) {
                    this.$modal.open({
                        windowTemplateUrl: this.config.advanced.genericErrorModal.windowTemplateUrl,
                        templateUrl: errorHandler.templateUrl,
                        controller: this.config.advanced.genericErrorModal.controllerName,
                        controllerAs: 'errorModal',
                        size: errorHandler.modalSize,
                        backdrop: 'static',
                        resolve: {
                            'ute.rogers.setpassword.errorHandler': errorHandler
                        }
                    }).result.then(function (result) {
                        // Result selection behaviour
                        switch (result) {
                            case 'yes':
                                // this.simCardService.cancelSimCardChange();
                                break;
                            case 'no':
                                // this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.enterSimCard.subState);
                                break;
                        }
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                    });
                };
                ForgotPasswordController.$inject = ['$document',
                    'ute.rogers.setpassword.service',
                    '$modal',
                    '$translate'
                ];
                ForgotPasswordController.controlerName = 'ute.rogers.forgotpassword.controller';
                return ForgotPasswordController;
            }());
            angular.module('ute.rogers.setpassword').controller(ForgotPasswordController.controlerName, ForgotPasswordController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var SetPasswordController = (function () {
                /* @ngInject */
                function SetPasswordController($document, setPasswordService, utilsService, janrainVerificationService, $modal, $translate, $state) {
                    var _this = this;
                    this.$document = $document;
                    this.setPasswordService = setPasswordService;
                    this.utilsService = utilsService;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$modal = $modal;
                    this.$translate = $translate;
                    this.$state = $state;
                    this.getVerificationCode = this.janrainVerificationService.getVerificationCode;
                    this.getUuid = this.janrainVerificationService.getUuid;
                    this.getEmail = this.janrainVerificationService.getEmail;
                    this.isCodeValid = this.janrainVerificationService.isCodeValid;
                    // isExpired: () => boolean = this.janrainVerificationService.isCodeExpired;
                    this.isAlphabetOnly = this.utilsService.isAlphabetOnly;
                    this.isAlphanumeric = this.utilsService.isAlphanumeric;
                    this.isNumericOnly = this.utilsService.isNumericOnly;
                    this.isJanrainVerificationCallInProgress = this.janrainVerificationService.isJanrainVerificationCallInProgress;
                    this.isRogersSetPasswordCallInProgress = this.setPasswordService.isRogersSetPasswordCallInProgress;
                    // verifyJanrainCode: ($event?: IAngularEvent) => ng.IPromise<ICodeEntry> = ($event?: IAngularEvent) => {
                    //   if ($event) {
                    //     $event.preventDefault();
                    //   }
                    //   //   return this.janrainVerificationService.verifyJanrainCode().then((code: ICodeEntry) => {
                    //   //     // console.log(JanrainVerificationController.controlerName + '->verifyJanrainCode: code=', code);
                    //   //     return code;
                    //   //   });
                    //   return null;
                    // };
                    /**
                     * @returns {IPromise<any>}
                     */
                    this.submit = function () {
                        // console.log(SetPasswordController.controlerName + '->submit has been called');
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.setPasswordService.savePassword(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    this.isPasswordsMatched = function () {
                        return _this.model.newPassword === _this.model.confirmPassword;
                    };
                    this.isSubmitButtonEnable = function () {
                        return _.get(_this.form, '$valid', false) /*&& this.isPasswordsMatched()*/ && !_this.isRogersSetPasswordCallInProgress();
                    };
                    this.processOk = function (codeEntry) {
                        // console.log(SetPasswordController.controlerName + '->processOk: codeEntry=', codeEntry);
                        return _this.setPasswordService.onSuccessSetPassword();
                    };
                    /**
                     * @param codeEntry
                     */
                    this.processError = function (codeEntry) {
                        // console.log(SetPasswordController.controlerName + '->processError: codeEntry=', codeEntry);
                        _this.errorMessageKey = codeEntry.frontendMessageKey;
                        // this.userRegistrationService.goToConfirmation();
                        _this.openModalPopup(codeEntry);
                    };
                    $document.scrollTop(0);
                    this.model = this.setPasswordService.getModel();
                    this.config = this.setPasswordService.getConfig();
                }
                SetPasswordController.prototype.openModalPopup = function (errorHandler) {
                    this.$modal.open({
                        windowTemplateUrl: this.config.advanced.genericErrorModal.windowTemplateUrl,
                        templateUrl: errorHandler.templateUrl,
                        controller: this.config.advanced.genericErrorModal.controllerName,
                        controllerAs: 'errorModal',
                        size: errorHandler.modalSize,
                        backdrop: 'static',
                        resolve: {
                            'ute.rogers.setpassword.errorHandler': errorHandler
                        }
                    }).result.then(function (result) {
                        // Result selection behaviour
                        switch (result) {
                            case 'yes':
                                // this.simCardService.cancelSimCardChange();
                                break;
                            case 'no':
                                // this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.enterSimCard.subState);
                                break;
                        }
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                    });
                };
                SetPasswordController.$inject = ['$document',
                    'ute.rogers.setpassword.service',
                    'ute.common.utils.service',
                    'ute.janrain.verification.service',
                    '$modal',
                    '$translate',
                    '$state'
                ];
                SetPasswordController.controlerName = 'ute.rogers.setpassword.controller';
                return SetPasswordController;
            }());
            angular.module('ute.rogers.setpassword').controller(SetPasswordController.controlerName, SetPasswordController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            angular.module('ute.rogers.setpassword').run(setPasswordRoutesConfig);
            setPasswordRoutesConfig.$inject = ['ute.blocks.router',
                'ute.rogers.setpassword.service',
                'ute.janrain.verification.service'
            ];
            function setPasswordRoutesConfig(routerHelper, setPasswordService, janrainVerificationService) {
                var config = setPasswordService.getConfig();
                routerHelper.configureStates([
                    {
                        name: config.advanced.setPassword.stateName,
                        url: '/' + config.advanced.setPassword.stateName + '/:id',
                        // url: '/' + config.advanced.setPassword.stateName,
                        controller: config.advanced.setPassword.controllerName,
                        controllerAs: 'setPasswordCtrl',
                        templateUrl: config.advanced.setPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] },
                            settings: {
                                codeVerificationApiUrl: config.advanced.setPassword.codeVerificationApiUrl,
                                needAutoRegCheck: config.advanced.setPassword.needAutoRegCheck
                            }
                        }
                    },
                    {
                        name: config.advanced.resetPassword.stateName,
                        url: '/' + config.advanced.resetPassword.stateName + '/:id',
                        // url: '/' + config.advanced.resetPassword.stateName,
                        controller: config.advanced.resetPassword.controllerName,
                        controllerAs: 'setPasswordCtrl',
                        templateUrl: config.advanced.resetPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] },
                            settings: {
                                codeVerificationApiUrl: config.advanced.resetPassword.codeVerificationApiUrl,
                                needAutoRegCheck: config.advanced.resetPassword.needAutoRegCheck
                            }
                        }
                    },
                    {
                        name: config.advanced.forgotPassword.stateName,
                        url: '/' + config.advanced.forgotPassword.stateName,
                        controller: config.advanced.forgotPassword.controllerName,
                        controllerAs: 'forgotPasswordCtrl',
                        templateUrl: config.advanced.forgotPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] }
                        },
                        resolve: {
                            easyLogin: ['$window', '$q',
                                function ($window, $q) {
                                    $window.location.href = '/consumer/easyloginriverpage?showModal=true';
                                    return $q.defer().promise;
                                }
                            ]
                        }
                    },
                    {
                        name: config.advanced.forgotPassword.noLiveContentStateName,
                        url: '/' + config.advanced.forgotPassword.noLiveContentStateName,
                        controller: config.advanced.forgotPassword.controllerName,
                        controllerAs: 'forgotPasswordCtrl',
                        templateUrl: config.advanced.forgotPassword.templateUrl,
                        data: {
                            title: '',
                            security: { roles: ['public'] }
                        },
                        resolve: {
                            redirectToDAM: ['$window', '$q', function ($window, $q) {
                                    $window.open('/consumer/profile/forgotpassword', '_self');
                                    return $q.defer().promise;
                                }],
                        }
                    }
                ]);
                routerHelper.registerToStateHandler(config.advanced.setPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerToStateHandler(config.advanced.resetPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerFromStateHandler(config.advanced.setPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
                routerHelper.registerFromStateHandler(config.advanced.resetPassword.stateName, janrainVerificationService, ute.blocks.router.StateHandlerPriority.LOW);
            }
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            /* @ngInject */
            var ErrorController = (function () {
                /* @ngInject */
                function ErrorController($modalInstance, setPasswordService, errorHandler) {
                    // console.log(ErrorController.controlerName + '->constructor: errorHandler:', errorHandler);
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.setPasswordService = setPasswordService;
                    this.errorHandler = errorHandler;
                    // getUserEmailAddress(): string {
                    //   // return this.simCardService.getUser().userEmail;
                    //   return this.simCardService.getAccountEmail();
                    // }
                    //
                    // finishedRoute(): angular.IPromise<any> {
                    //   return this.simCardService.finishedRoute();
                    // }
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                    };
                }
                ErrorController.$inject = [
                    '$modalInstance',
                    'ute.rogers.setpassword.service',
                    'ute.rogers.setpassword.errorHandler'];
                ErrorController.controlerName = 'ute.rogers.setpassword.error.controller';
                return ErrorController;
            }());
            angular.module('ute.rogers.setpassword').controller(ErrorController.controlerName, ErrorController);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                var RogersCookies = ute.common.core.RogersCookies;
                var UserType = ute.common.user.UserType;
                var SigninService = (function () {
                    // static $inject: Array<string> = [];
                    // /* @ngInject */
                    function SigninService(config, $http, $q, $injector, $window, $state, $cookies) {
                        var _this = this;
                        this.config = config;
                        this.$http = $http;
                        this.$q = $q;
                        this.$injector = $injector;
                        this.$window = $window;
                        this.$state = $state;
                        this.$cookies = $cookies;
                        // private decomESF: string;
                        this.signinUser = function (user) {
                            console.log(SigninService.serviceName + '->signinUser->user:', user);
                            _this.resetModel(user);
                            return _this.signinFn() // siteMinder call
                                .then(function (isSigninOk) { return _this.$q.all({
                                isUserFound: _this.isUserFoundFunc(isSigninOk),
                                isUserNotLocked: _this.isUserNotLocked(isSigninOk),
                                isUserAuthenticated: _this.isUserAuthenticatedFunc(isSigninOk),
                                isNotTemporaryPassword: _this.isNotTemporaryPassword(isSigninOk)
                            }); })
                                .then(_this.postSignin)
                                .catch(_.curry(_this.fail)('signin failed.'));
                        };
                        this.getRetryNumber = function () { return _this.model.smTryNumber; };
                        this.discardLoginSmCookies = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.discardLoginSmCookies'), {})
                                .then(_this.discardSuccess)
                                .catch(_.curry(_this.fail)('discardLoginSmCookies failed.'));
                        };
                        this.loggedIn = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.loggedIn'), {}).then(_this.loggedInSuccess).catch(_.curry(_this.fail)('loggedIn failed.'));
                        };
                        this.processPostSignin = function () {
                            return _this.$http.get(_this.environmentService.getProperty('apiUrls.postSigninRequest')).then(_this.processPostSigninSuccess).catch(_.curry(_this.fail)('processPostSignin failed.'));
                        };
                        this.signin = function (user) {
                            // TODO interface
                            var postData = {
                                USER: user.userName,
                                password: user.userPassword,
                                SMAUTHREASON: '0',
                                target: _this.postSigninUrl()
                            };
                            return _this.$http.post(_this.environmentService.getProperty('siteminder.signinActionUrl'), $.param(postData), {
                                headers: {
                                    'Accept': 'text/plain, */*',
                                    'Content-Type': 'application/x-www-form-urlencoded'
                                }
                            })
                                .then(_this.signinSuccess)
                                .catch(_.curry(_this.fail)('signin failed'));
                        };
                        this.isUserFound = function () { return (_this.$q.when(_this.$cookies.get(RogersCookies.SM_USERNOTFOUND) !== '1')); };
                        this.isSignin = function () { return _this.userService.isSigned(); };
                        this.signout = function () {
                            //this.$cookies.remove(RogersCookies.SM_USERAUTHENTICATED, {domain: this.environmentService.getProperty('cookies.defaultDomain')});
                            //this.$cookies.remove(RogersCookies.SMSESSION, {domain: this.environmentService.getProperty('cookies.defaultDomain')});
                            if (_this.userService.isSigned()) {
                                return _this.discardAllSmCookies().finally(function () {
                                    // regardless of Ok or not Ok notify user service and transit to signin state
                                    _this.userService.unsigned();
                                    return _this.$state.go(_this.config.signinState);
                                });
                            }
                            else {
                                return _this.$state.go(_this.config.signinState);
                            }
                        };
                        this.signinCheck = function () {
                            //this.logger.info('signinCheck: ' + this.environmentService.getProperty('apiUrls.defaultLandingState'));
                            if (_this.isSignin()) {
                                //console.log('signinCheck', this.config.landingState);
                                return _this.$state.go(_this.config.landingState);
                            }
                            return _this.$q.when(true);
                        };
                        this.isUserLocked = function () { return (_this.$q.when(_this.$cookies.get(RogersCookies.SMLOCK) === '1')); };
                        this.isTemporaryPassword = function () {
                            var retval = false;
                            var smQueryCookie = _this.$cookies.get(RogersCookies.SM_QUERY_STRING);
                            //var smQueryCookie='SMENC=UTF-8&SMTOKEN={RC2}tHHbCU9XYKDFOIkbQhVUCNEYWPkhyg1f1JTa+VKqp6wkOAUHrmDWcKCSzNeWURmNqBGCtyyT/omvSeWYGHF7DOn3/ymf2IROKGf7JF+xvl5tLlnee2N0/R9TfB5RB3zjt0W+UBi7LPeKqvAiRKLI11M5l4SgSewS/utExahyYQpgJcGBhC2eHraF8fTeq3SUwKONjiraiUQ=&USERNAME=spidermonca@yahoo.ca&SMAUTHREASON=20&SMAGENTNAME=zKoliFagzIafTRmv55EAwldWZCnBmFSsGdnDIWiwclBez3MZgA58Eu5EhbBDxIO8&TARGET=-SM-https%3a%2f%2fwww%2edev42%2erogers%2ecom%2fweb%2fRogersServices%2eportal%2ftotes%2f';
                            if (smQueryCookie) {
                                var params = (_.chain(smQueryCookie.split('&')).map(function (params) {
                                    var p = params.split('=');
                                    return [p[0], decodeURIComponent(p[1])];
                                }).object().value());
                                _this.$cookies.remove(RogersCookies.SM_QUERY_STRING);
                                if (params.SMAUTHREASON === '20' && params.SMTOKEN) {
                                    params.SMTOKEN = params.SMTOKEN + '=';
                                    retval = true;
                                }
                            }
                            return _this.$q.when(retval);
                        };
                        this.isUserAuthenticated = function () {
                            return _this.$q.when(!(Number(_this.$cookies.get(RogersCookies.SMTRYNO)) >= 1));
                        };
                        this.postSignin = function (results) {
                            //console.log('postSignin:', results);
                            if (angular.isUndefined(_.find(results, function (val) { return !val; }))) {
                                return _this.$q.all([_this.loggedIn(), _this.processPostSignin()]).then(_this.finaliseSignin);
                            }
                            else {
                                return _this.$q.reject('User is not loggedin');
                            }
                        };
                        this.discardAllSmCookies = function () {
                            return _this.$http.post(_this.environmentService.getProperty('apiUrls.discardAllSmCookies'), {}).then(_this.discardSuccess).catch(_.curry(_this.fail)('discardAllSmCookies failed.'));
                        };
                        this.finaliseSignin = function (results) {
                            if (angular.isUndefined(_.find(results, function (val) { return !val; }))) {
                                // All calls successful
                                _this.userService.signed(_this.model.user);
                                _this.messagesService.publish(ute.blocks.messages.bus.Messages.uteRogersSigninSuccessful, { email: _this.model.user.userEmail });
                                //console.log('finaliseSignin', this.config.landingState);
                                return _this.$state.go(_this.config.landingState);
                            }
                            else {
                                return _this.$q.reject('User PostSignin not Ok');
                            }
                        };
                        // TODO move to the common service
                        this.postSigninUrl = function () { return (_this.$window.location.protocol + '//' + _this.$window.location.hostname +
                            ((_this.$window.location.protocol === 'http' && _this.$window.location.port === '80') || (_this.$window.location.protocol === 'https' && _this.$window.location.port === '443') ?
                                '' : ':' + _this.$window.location.port) + _this.environmentService.getProperty('apiUrls.defaultLandingPage')); };
                        this.loggedInSuccess = function (response) {
                            var retval = response.data === 'success:true';
                            if (!retval) {
                                _this.userService.unsigned();
                            }
                            return retval;
                        };
                        this.discardSuccess = function (response) { return (response.data === 'success:true'); };
                        this.processPostSigninSuccess = function (response) { return true; };
                        this.signinSuccess = function (response) {
                            _this.model.smTryNumber = Number(_this.$cookies.get(RogersCookies.SMTRYNO));
                            /*
                             if (this.smTryNumber >= 1) {
                             throw {message: 'Signin not Ok', data: {description: 'smTryNumber=' + this.smTryNumber}};
                             }
                             return true;
                             */
                            //return !(this.smTryNumber >= 1);
                            return true;
                        };
                        this.signinFn = function () {
                            return new _this.$q(function (resolve) {
                                resolve(true);
                            });
                        };
                        this.isUserFoundFunc = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserFound().then(function (result) {
                                    _this.model.isUserFound = result;
                                    _this.logger.info('isUserFound=' + result);
                                    return result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.isUserNotLocked = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserLocked().then(function (result) {
                                    _this.model.isUserLocked = result;
                                    _this.logger.info('isUserLocked=' + result);
                                    return !result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin User failed');
                            }
                        };
                        this.isUserAuthenticatedFunc = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isUserAuthenticated().then(function (result) {
                                    _this.model.isUserAuthenticated = result;
                                    _this.logger.info('isUserAuthenticated=' + result);
                                    return result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.isNotTemporaryPassword = function (isSigninOk) {
                            if (isSigninOk) {
                                return _this.isTemporaryPassword().then(function (result) {
                                    _this.logger.info('isTemporaryPassword=' + result);
                                    if (result) {
                                        _this.$state.go(_this.environmentService.getProperty('apiUrls.changeTemporaryPasswordState'));
                                    }
                                    return !result;
                                });
                            }
                            else {
                                return _this.$q.reject('Signin not Ok');
                            }
                        };
                        this.resetModel = function (userIn) {
                            var user = _.assign({}, userIn);
                            user.userType = UserType.consumer; // TODO factory from userService
                            _this.model = {
                                user: user,
                                isUserFound: undefined,
                                isUserLocked: undefined,
                                isUserAuthenticated: undefined,
                                smTryNumber: 0
                            };
                        };
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            //this.exception.catcher(msg)(reason, 'signin.data.service.ts');
                            return _this.$q.reject(msg);
                        };
                        this.environmentService = $injector.get('ute.blocks.environment');
                        this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                        this.userService = $injector.get('ute.common.user.service');
                        this.logger = $injector.get('ute.blocks.loggerService');
                    }
                    SigninService.serviceName = 'ute.rogers.siteminder.signin.service';
                    return SigninService;
                }());
                var SigninProvider = (function () {
                    /* @ngInject */
                    function SigninProvider() {
                        var _this = this;
                        this.config = signin.DefaultConfigFactory();
                        /* @ngInject */
                        this.$get = function ($http, $q, $injector, $window, $state, $cookies) {
                            return new SigninService(_this.config, $http, $q, $injector, $window, $state, $cookies);
                        };
                        /**
                         * TODO validation
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.$get.$inject = [
                            '$http',
                            '$q',
                            '$injector',
                            '$window',
                            '$state',
                            angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies'
                        ];
                    }
                    SigninProvider.$inject = [];
                    return SigninProvider;
                }());
                angular.module('ute.rogers.siteminder.signin').provider(SigninService.serviceName, SigninProvider);
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var siteminder;
        (function (siteminder) {
            var signin;
            (function (signin) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        landingState: 'accountOverview',
                        signinState: 'signin',
                        signoutState: 'signout'
                    };
                }
                signin.DefaultConfigFactory = DefaultConfigFactory;
            })(signin = siteminder.signin || (siteminder.signin = {}));
        })(siteminder = rogers.siteminder || (rogers.siteminder = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var UserRegistrationController = (function () {
                    /* @ngInject */
                    function UserRegistrationController($document, userRegistrationService, dtmService) {
                        $document.scrollTop(0);
                        this.emailAddress = userRegistrationService.getModel().email;
                        dtmService.complete(userRegistrationService.getConfig().basic.dtmName);
                    }
                    UserRegistrationController.$inject = ['$document',
                        'ute.rogers.user.registration.service',
                        'ute.dtm.service'
                    ];
                    UserRegistrationController.controlerName = 'ute.rogers.user.registration.confirmation.controller';
                    return UserRegistrationController;
                }());
                angular.module('ute.rogers.user.registration').controller(UserRegistrationController.controlerName, UserRegistrationController);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var UserRegistrationController = (function () {
                    /* @ngInject */
                    function UserRegistrationController($document, userRegistrationService, dtmService, $window, languageService, vcRecaptchaService, $scope, $http, $injector) {
                        var _this = this;
                        this.userRegistrationService = userRegistrationService;
                        this.dtmService = dtmService;
                        this.$window = $window;
                        this.languageService = languageService;
                        this.vcRecaptchaService = vcRecaptchaService;
                        this.$scope = $scope;
                        this.$http = $http;
                        this.$injector = $injector;
                        this.useRecaptchaV3 = true;
                        this.modelOptions = { updateOn: 'default blur', debounce: { 'default': 500, 'blur': 0 }, allowInvalid: true };
                        this.isUserRegistrationCallInProgress = this.userRegistrationService.isUserRegistrationCallInProgress;
                        this.generateV3Recaptcha = function () {
                            return window['grecaptcha'].execute(_this.recaptchaSiteKey, { action: 'prepaid' });
                        };
                        this.setRecaptchaSiteKey = function () {
                            _this.recaptchaSiteKey = _this.recaptchaV3Sitekey;
                            var recaptchaScript = document.createElement('script');
                            recaptchaScript.type = 'text/javascript';
                            recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?render=' + _this.recaptchaSiteKey;
                            document.getElementById('renderV3Recaptcha').appendChild(recaptchaScript);
                        };
                        this.isSubmitButtonEnabled = function () {
                            // console.log(UserRegistrationController.controlerName + '->isSubmitButtonEnabled', this.form.$valid, !this.userRegistrationService.isUserRegistrationCallInProgress());
                            if (_this.useRecaptchaV3) {
                                return !_this.isUserRegistrationCallInProgress();
                            }
                            return !_this.isUserRegistrationCallInProgress() && angular.isDefined(_this.model.reCaptchaResponse);
                            // return this.form.$valid && !this.userRegistrationService.isUserRegistrationCallInProgress();
                        };
                        this.getCancelStateName = function () { return _this.config.advanced.registration.cancelState; };
                        this.registerNewUserHandler = function (captchaToken) {
                            return _this.userRegistrationService.registerNewUser(_this.model, _this.createProfileAPIUrl, _this.useRecaptchaV3, captchaToken)
                                .then(function () {
                                return _this.userRegistrationService.goToConfirmation();
                            })
                                .catch(function (error) {
                                if (error.backendCode === 500.018) {
                                    _this.recaptchaSiteKey = _this.recaptchaV2Sitekey;
                                    _this.useRecaptchaV3 = false;
                                    _this.model.reCaptchaResponse = undefined;
                                    _this.vcRecaptchaService.reload();
                                }
                                else {
                                    _this.scope.backendErrorText = _this.userRegistrationService.getBackendErrorMessage();
                                    _this.errorCode = error;
                                    _this.model.reCaptchaResponse = undefined;
                                }
                            });
                        };
                        /**
                         * @returns {IPromise<any>}
                         */
                        this.submit = function () {
                            // console.log(UserRegistrationController.controlerName + '->submit: form.$valid=', this.form.$valid,
                            //     'form.email=', this.form.email,
                            //     'form.confirmEmail=', this.form.confirmEmail,
                            //     'form=', this.form
                            // );
                            if (_this.form.$valid) {
                                _this.errorCode = null;
                                // console.log(UserRegistrationController.controlerName + '->submit->model:', this.model);
                                _this.userRegistrationService.setUserRegistrationCallToPropgress();
                                if (_this.useRecaptchaV3) {
                                    return _this.generateV3Recaptcha().then(function (captchaToken) {
                                        return _this.registerNewUserHandler(captchaToken);
                                    });
                                }
                                else {
                                    return _this.registerNewUserHandler('');
                                }
                            }
                            else {
                                return null;
                            }
                        };
                        this.verifyReCaptchaCallback = function (response) {
                            _this.$scope.$apply(function () {
                                _this.model.reCaptchaResponse = response;
                            });
                        };
                        this.processOk = function (codeEntry) {
                            // console.log(UserRegistrationController.controlerName + '->processOk: codeEntry=', codeEntry);
                            return _this.userRegistrationService.goToConfirmation();
                        };
                        this.processError = function (codeEntry) {
                            // console.log(UserRegistrationController.controlerName + '->processError: codeEntry=', codeEntry);
                            _this.scope.backendErrorText = _this.userRegistrationService.getBackendErrorMessage();
                            _this.errorCode = codeEntry;
                            _this.model.reCaptchaResponse = undefined;
                            _this.vcRecaptchaService.reload();
                        };
                        this.envConfig = this.$injector.get('CONFIG');
                        this.recaptchaV3Sitekey = this.envConfig.recaptchaSiteKeyPrepaidV3;
                        this.recaptchaV2Sitekey = this.envConfig.recaptchaSiteKeyPrepaidV2;
                        this.createProfileAPIUrl = this.envConfig.createProfile;
                        this.init($document, $scope);
                    }
                    UserRegistrationController.prototype.init = function ($document, $scope) {
                        $document.scrollTop(0);
                        var _self = this;
                        this.model = this.userRegistrationService.getModel();
                        this.config = this.userRegistrationService.getConfig();
                        this.languages = this.config.advanced.supportedLanguages;
                        this.dtmService.start(this.config.basic.dtmName);
                        this.dtmName = this.config.basic.dtmName;
                        this.scope = $scope;
                        this.lang = this.languageService.getCurrentLanguage();
                        this.setRecaptchaSiteKey();
                        this.languageService.registerOnDataChangeHandler(function (currentLanguage) {
                            _self.lang = currentLanguage;
                            return null;
                        }, 'ute.data.manager.tabs.directive.controller_' + _self.scope.$id);
                        this.scope.$on('$destroy', function () {
                            if (_self && _self.languageService) {
                                _self.languageService.unregisterOnDataChangeHandler('ute.rogers.user.registration.controller_' + _self.scope.$id);
                            }
                        });
                    };
                    UserRegistrationController.$inject = ['$document',
                        'ute.rogers.user.registration.service',
                        'ute.dtm.service',
                        '$window',
                        'ute.blocks.language.switcher',
                        'vcRecaptchaService',
                        '$scope',
                        '$http',
                        '$injector'
                    ];
                    UserRegistrationController.controlerName = 'ute.rogers.user.registration.controller';
                    return UserRegistrationController;
                }());
                angular.module('ute.rogers.user.registration').controller(UserRegistrationController.controlerName, UserRegistrationController);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                var ProviderBase = ute.common.core.ProviderBase;
                var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.SAVE_OK = 0;
                    BackEndErrorCode.GENERIC_ERROR = 17082;
                    BackEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST = 17083;
                    BackEndErrorCode.CREATE_PROFILE_COMMUNICATION_ALREADY_EXIST = 17084;
                    BackEndErrorCode.CREATE_PROFILE_EMAIL_ALREADY_EXIST = 123110;
                    BackEndErrorCode.RECAPTCHA_V3_LESS_SCORE = 500.018;
                    return BackEndErrorCode;
                }());
                var UserRegistrationService = (function (_super) {
                    __extends(UserRegistrationService, _super);
                    function UserRegistrationService(config, $injector, $http, $timeout, $state, encryptionService, dataLayerService) {
                        var _this = this;
                        _super.call(this, registration.FrontEndErrorCode.GENERIC_ERROR, BackEndErrorCode.GENERIC_ERROR, UserRegistrationService.serviceName, $injector);
                        this.config = config;
                        this.$injector = $injector;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.$state = $state;
                        this.encryptionService = encryptionService;
                        this.dataLayerService = dataLayerService;
                        this.getConfig = function () { return angular.copy(_this.config); };
                        this.isUserRegistrationCallInProgress = function () { return _this.isCallInProgress; };
                        this.setUserRegistrationCallToPropgress = function () {
                            _this.isCallInProgress = true;
                        };
                        /**
                         * Return immutable IUserRegistrationModel object
                         * @returns {IUserRegistrationModel}
                         */
                        this.getModel = function () {
                            // console.log(UserRegistrationService.serviceName + '->getModel->model', this.model);
                            return angular.copy(_this.model);
                        };
                        /**
                         * @returns {IPromise<ICodeEntry>}
                         */
                        this.registerUser = function (model) {
                            // this.model = _.assign({}, this.model, model);
                            _this.model = (_.assign({}, _this.model, model));
                            // this.model = model;
                            var request = {
                                email: _this.model.email,
                                lang: _this.model.lang,
                                // reCaptchaResponse: this.model.reCaptchaResponse
                                response: _this.model.reCaptchaResponse
                            };
                            _this.isCallInProgress = true;
                            return _this.$http.post(_this.config.basic.apiUrl, request)
                                .then(_this.processOk)
                                .catch(_this.processError)
                                .finally(_this.finaliseCall);
                        };
                        this.mapToNewErrorCodes = function (errorCode) {
                            return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(errorCode)); });
                        };
                        this.registerNewUser = function (model, apiUrl, useRecaptchaV3, captchaV3) {
                            _this.model = (_.assign({}, _this.model, model));
                            var finalEndpoint;
                            var request = {
                                emailAddress: _this.model.email,
                                emailConfirm: _this.model.confirmEmail,
                                newPassword: '',
                                newPasswordConfirm: '',
                                language: _this.model.lang
                            };
                            _this.isCallInProgress = true;
                            var headers = {
                                'x-request-id': new Date().toISOString(),
                                'x-app-name': 'UTERogersOnline',
                                'realm': 'ROGERS',
                                'recaptcha-retry': !useRecaptchaV3
                            };
                            if (useRecaptchaV3) {
                                finalEndpoint = apiUrl + encodeURIComponent(captchaV3);
                            }
                            else {
                                finalEndpoint = apiUrl + _this.model.reCaptchaResponse;
                            }
                            return _this.$http.post(finalEndpoint, request, { headers: headers })
                                .then(function (response) {
                                var backendCode = _.get(response, 'data.status.code', '');
                                if (backendCode === '200') {
                                    return _this.findCodeEntry(BackEndErrorCode.SAVE_OK);
                                }
                                ;
                            })
                                .catch(function (error) {
                                var backendCode = _.get(error, 'data.status.code', '');
                                _this.backendErrorMessage = _.get(error, 'data.status.codeName', '');
                                var errorType = ute.datalayer.common.service.ErrorType;
                                var errorCategory = ute.datalayer.common.service.ErrorCategory;
                                var dataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                                _this.dataLayerService.trackError({}, errorType.HTTP, error.status, JSON.stringify(error.data.status), errorCategory.SELF_SERVE, '', 'v1/user/profile', false, [dataLayerPredefinedSection.GLOBAL]);
                                if (backendCode === '400.005') {
                                    return _this.mapToNewErrorCodes(BackEndErrorCode.CREATE_PROFILE_EMAIL_ALREADY_EXIST);
                                }
                                else if (backendCode === '500.018') {
                                    return _this.mapToNewErrorCodes(BackEndErrorCode.RECAPTCHA_V3_LESS_SCORE);
                                }
                                else {
                                    return _this.mapToNewErrorCodes(BackEndErrorCode.GENERIC_ERROR);
                                }
                            })
                                .finally(_this.finaliseCall);
                        };
                        this.goToConfirmation = function () {
                            // console.log(UserRegistrationService.serviceName + '->goToConfirmation->', this.model);
                            return _this.encryptionService.encrypt({
                                email: _this.model.email
                            }).then(function (id) {
                                return _this.$state.go(_this.config.advanced.confirmation.stateName, {
                                    id: id
                                });
                            });
                        };
                        /**
                         * implementation of ute.blocks.router.IStateHandler
                         * @param event
                         * @param toState
                         * @param toParams
                         * @param fromState
                         * @param fromParams
                         * @returns {boolean}
                         */
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            _this.restoreFromInput(toParams).then(function (result) {
                                // console.log(UserRegistrationService.serviceName + '->stateTransitionHandler->then', result);
                                if (!result) {
                                    event.preventDefault();
                                }
                            });
                            return true;
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            // console.log(UserRegistrationService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                            return _this.findCodeEntry(backendCode);
                        };
                        this.processErrorRegister = function (error) {
                            _this.backendErrorMessage = _.get(error, 'data.status.codeName', '');
                            // console.log("Process Error Register: "+ this.backendErrorMessage);
                            return _this.processError(error);
                        };
                        this.getBackendErrorMessage = function () { return _this.backendErrorMessage; };
                        this.finaliseCall = function () {
                            _this.isCallInProgress = false;
                            _this.model.reCaptchaResponse = undefined;
                        };
                        /**
                         * @param $stateParams
                         * @returns {IPromise<boolean>}
                         */
                        this.restoreFromInput = function ($stateParams) {
                            if ($stateParams.id) {
                                return _this.encryptionService.decrypt($stateParams.id).then(function (obj) {
                                    // console.log(UserRegistrationService.serviceName + '->restoreFromInput->then', obj);
                                    if (obj.email) {
                                        _this.model.email = obj.email;
                                        return true;
                                    }
                                    else {
                                        // this.$state.go(this.config.advanced.registration.stateName);
                                        return false;
                                    }
                                }).catch(function (error) {
                                    // console.log(UserRegistrationService.serviceName + '->restoreFromInput->catch', error);
                                    // this.$state.go(this.config.advanced.registration.stateName);
                                    return false;
                                });
                            }
                            else {
                                // this.$state.go(this.config.advanced.registration.stateName);
                                return new _this.$q(function (resolve) { return resolve(false); });
                            }
                        };
                        /**
                         * Reset model to initial state
                         */
                        this.resetModel = function () {
                            _this.model = {
                                email: undefined,
                                confirmEmail: undefined,
                                lang: 'en',
                                reCaptchaResponse: undefined
                            };
                        };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: registration.FrontEndErrorCode.SAVE_OK,
                                backendCode: BackEndErrorCode.SAVE_OK
                            });
                            _this.addCode({
                                frontendCode: registration.FrontEndErrorCode.GENERIC_ERROR,
                                frontendMessageKey: 'ute.rogers.user.registration.system.error.message',
                                backendCode: BackEndErrorCode.GENERIC_ERROR
                            });
                            _this.addCode({
                                frontendCode: registration.FrontEndErrorCode.CREATE_PROFILE_EMAIL_ALREADY_EXIST,
                                frontendMessageKey: 'ute.rogers.user.registration.email.already.exists',
                                backendCode: BackEndErrorCode.CREATE_PROFILE_EMAIL_ALREADY_EXIST
                            });
                            _this.addCode({
                                frontendCode: registration.FrontEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST,
                                frontendMessageKey: 'ute.rogers.user.registration.account.already.associated',
                                backendCode: BackEndErrorCode.CREATE_PROFILE_PROFILE_ALREADY_EXIST,
                                boldChat: {
                                    cbid: 'ute.rogers.user.registration.boldChat.cbid',
                                    dynamicDivId: 'ute.rogers.user.registration.boldChat.dynamicDivId',
                                    chatButtonClass: 'ute.rogers.user.registration.boldChat.chatButtonClass'
                                }
                            });
                            _this.addCode({
                                frontendCode: registration.FrontEndErrorCode.CREATE_PROFILE_COMMUNICATION_ALREADY_EXIST,
                                frontendMessageKey: 'ute.rogers.user.registration.account.already.associated',
                                backendCode: BackEndErrorCode.CREATE_PROFILE_COMMUNICATION_ALREADY_EXIST,
                                boldChat: {
                                    cbid: 'ute.rogers.user.registration.boldChat.cbid',
                                    dynamicDivId: 'ute.rogers.user.registration.boldChat.dynamicDivId',
                                    chatButtonClass: 'ute.rogers.user.registration.boldChat.chatButtonClass'
                                }
                            });
                            _this.addCode({
                                backendCode: BackEndErrorCode.RECAPTCHA_V3_LESS_SCORE
                            });
                        };
                        this.addCodes();
                        this.resetModel();
                    }
                    ;
                    UserRegistrationService.serviceName = 'ute.rogers.user.registration.service';
                    return UserRegistrationService;
                }(ResponseErrorHandlerGeneric));
                var UserRegistrationProvider = (function (_super) {
                    __extends(UserRegistrationProvider, _super);
                    /* @ngInject */
                    function UserRegistrationProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($injector, $http, $timeout, $state) {
                            return new UserRegistrationService(_this.config, $injector, $http, $timeout, $state, $injector.get('ute.common.encryption.service'), $injector.get('ute.datalayer.common.service'));
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$timeout',
                            '$state'
                        ];
                        this.config = registration.DefaultConfigFactory();
                    }
                    UserRegistrationProvider.$inject = [];
                    return UserRegistrationProvider;
                }(ProviderBase));
                angular.module('ute.rogers.user.registration').provider(UserRegistrationService.serviceName, UserRegistrationProvider);
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var registration;
            (function (registration) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            apiUrl: 'api/v1/profile/create',
                            dtmName: 'account registration',
                            logPrefix: 'UserRegistration',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            recaptchaSiteKey: '6LfmNCYTAAAAALEqhfoLZeelZ5jWm3vsW_xUeYpf'
                        },
                        advanced: {
                            registration: {
                                stateName: 'sso/registration',
                                cancelState: 'wireless',
                                controllerName: 'ute.rogers.user.registration.controller',
                                templateUrl: 'module/registrationStart/userRegistration.html',
                            },
                            prepaid: {
                                stateName: 'prepaidregistration',
                                cancelState: 'wireless',
                                controllerName: 'ute.rogers.user.registration.controller',
                                templateUrl: 'module/registrationStart/userRegistration.html',
                            },
                            confirmation: {
                                stateName: 'sso/registrationConfirmation',
                                controllerName: 'ute.rogers.user.registration.confirmation.controller',
                                templateUrl: 'module/registrationConfirmation/registrationConfirmation.html',
                            },
                            supportedLanguages: {
                                en: 'English',
                                fr: 'Français'
                            }
                        }
                    };
                }
                registration.DefaultConfigFactory = DefaultConfigFactory;
            })(registration = user.registration || (user.registration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var runtime;
        (function (runtime) {
            var translate;
            (function (translate) {
                'use strict';
                var RuntimeTranslateProvider = (function () {
                    /* @ngInject */
                    function RuntimeTranslateProvider($translateProvider) {
                        var _this = this;
                        this.$translateProvider = $translateProvider;
                        /* @ngInject */
                        this.$get = function ($injector, $translate) {
                            _this.$translate = $translate;
                            return {
                                addTranslations: _this.addTranslations,
                                addTranslation: _this.addTranslation,
                                hasTranslation: _this.hasTranslation
                            };
                        };
                        /**
                         * @param langKey
                         * @param translationTable
                         * @returns {ute.common.runtime.translate.RuntimeTranslateProvider}
                         */
                        this.addTranslations = function (langKey, translationTable) {
                            if (langKey && translationTable) {
                                _this.$translateProvider.translations(langKey, translationTable);
                            }
                            return _this;
                        };
                        /**
                         * @param langKey
                         * @param trKey
                         * @param trVal
                         * @returns {ute.common.runtime.translate.RuntimeTranslateProvider}
                         */
                        this.addTranslation = function (langKey, trKey, trVal) {
                            if (langKey && trKey) {
                                var translationTable = {};
                                translationTable[trKey] = trVal;
                                _this.$translateProvider.translations(langKey, translationTable);
                            }
                            return _this;
                        };
                        /**
                         * @param key
                         * @returns {boolean}
                         */
                        this.hasTranslation = function (key) {
                            try {
                                return !_.isEmpty(_this.$translate.instant(key));
                            }
                            catch (e) {
                                console.log('aaaaaaaaaa', e.message, e.name);
                                return false;
                            }
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$translate'
                        ];
                    }
                    RuntimeTranslateProvider.$inject = ['$translateProvider'];
                    return RuntimeTranslateProvider;
                }());
                angular.module('ute.common.runtime.translate').provider('ute.common.runtime.translate.service', RuntimeTranslateProvider);
            })(translate = runtime.translate || (runtime.translate = {}));
        })(runtime = common.runtime || (common.runtime = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var modal;
            (function (modal) {
                'use strict';
                var SaveBillBannerController = (function () {
                    /* @ngInject */
                    function SaveBillBannerController($rootScope, $modal, $timeout, briteBillService, saveBillService, dtmService) {
                        this.$rootScope = $rootScope;
                        this.$modal = $modal;
                        this.$timeout = $timeout;
                        this.briteBillService = briteBillService;
                        this.saveBillService = saveBillService;
                        this.dtmService = dtmService;
                        /* tslint:disable */
                        this.openBanner = false;
                        this.config = this.saveBillService.getConfig();
                    }
                    SaveBillBannerController.prototype.downloadAsExcel = function () {
                        var contentLink = this.briteBillService.getSelectedInvoiceBill(this.accountNumber).content_id;
                        this.briteBillService.downloadExcelService(contentLink)
                            .then(this.processDownloadResponse.bind(this, 'excel', 'downloadExcel'));
                        this.trackBillDownloadType('Excel');
                    };
                    SaveBillBannerController.prototype.downloadAsCSV = function () {
                        var contentLink = this.briteBillService.getSelectedInvoiceBill(this.accountNumber).content_id;
                        this.briteBillService.downloadCSVService(contentLink)
                            .then(this.processDownloadResponse.bind(this, 'csv', 'downloadCSV'));
                        this.trackBillDownloadType('CSV');
                    };
                    SaveBillBannerController.prototype.downloadMutiplePDFConfirmationBox = function () {
                        var _this = this;
                        this.$modal.open({
                            windowTemplateUrl: this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                            templateUrl: this.config.advanced.confirmationController.templateUrl,
                            controller: this.config.advanced.confirmationController.controllerName,
                            controllerAs: 'ctrl',
                            size: 'md',
                            windowClass: 'downlaod-pdf-confirmation-modal-wrapper',
                            backdrop: 'static',
                            resolve: {
                                accountNumber: function () {
                                    return _this.accountNumber;
                                }
                            }
                        });
                        this.trackBillDownloadType('Print');
                    };
                    SaveBillBannerController.prototype.close = function () {
                        console.log(this.$modal);
                    };
                    SaveBillBannerController.prototype.printBill = function () {
                        var _this = this;
                        this.$modal.open({
                            windowTemplateUrl: this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                            templateUrl: this.config.advanced.saveBillPrintModal.templateUrl,
                            controller: this.config.advanced.saveBillPrintModal.controllerName,
                            controllerAs: 'ctrl',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                accountNumber: function () {
                                    console.log(_this.accountNumber);
                                    return _this.accountNumber;
                                }
                            }
                        });
                        this.trackBillDownloadType('Print');
                    };
                    SaveBillBannerController.prototype.showSuccessModal = function (type) {
                        var modalScope = this.$rootScope.$new();
                        modalScope.params = { type: type };
                        this.saveBillService.successModal(modalScope);
                    };
                    SaveBillBannerController.prototype.showNoDataModal = function () {
                        this.saveBillService.noDataModalModal();
                    };
                    SaveBillBannerController.prototype.errorModalPopup = function (primary, secondary) {
                        var errorModalScope = this.$rootScope.$new();
                        errorModalScope.params = { primary: primary, secondary: secondary };
                        this.saveBillService.errorPopupModal(errorModalScope);
                    };
                    SaveBillBannerController.prototype.trackBillDownloadType = function (downloadMethod) {
                        this.dtmService.setVar('downloadMethod', downloadMethod);
                        this.dtmService.track(this.config.basic.analyticsId, 'pasv');
                    };
                    SaveBillBannerController.prototype.processDownloadResponse = function (type, translationKey, response) {
                        var _this = this;
                        if (response === true) {
                            this.$timeout(function () { return _this.showSuccessModal(type); }, 5);
                        }
                        else if (response === 'error') {
                            this.$timeout(function () { return _this.errorModalPopup('ute.saveBillModal.errorHeading.' + translationKey, 'ute.saveBillModal.errorBody.' + translationKey); }, 5);
                        }
                        else if (response === 'noData') {
                            this.$timeout(function () { return _this.showNoDataModal(); }, 5);
                        }
                    };
                    SaveBillBannerController.$inject = ['$rootScope', '$modal', '$timeout', 'ute.brite.bill.service', 'ute.save.bill.service', 'ute.dtm.service'];
                    return SaveBillBannerController;
                }());
                modal.SaveBillBannerController = SaveBillBannerController;
                angular
                    .module('ute.save.bill')
                    .controller('ute.save.bill.banner.controller', SaveBillBannerController);
            })(modal = bill.modal || (bill.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            'use strict';
            angular.module('ute.save.bill').directive('uteSaveBillBanner', uteSaveBillBannerDirective);
            uteSaveBillBannerDirective.$inject = ['ute.save.bill.service'];
            /* @ngInject */
            function uteSaveBillBannerDirective(savebillService) {
                var config = savebillService.getConfig();
                return {
                    restrict: 'E',
                    scope: {
                        accountNumber: '='
                    },
                    templateUrl: config.advanced.saveBillBanner.templateUrl,
                    controller: config.advanced.saveBillBanner.controllerName,
                    controllerAs: 'saveBillBanner',
                    bindToController: true
                };
            }
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            'use strict';
            var SaveBillDirectiveController = (function () {
                /* @ngInject */
                function SaveBillDirectiveController($window, $location, $modal, $modalStack, saveBillService, briteBillService) {
                    this.$window = $window;
                    this.$location = $location;
                    this.$modal = $modal;
                    this.$modalStack = $modalStack;
                    this.saveBillService = saveBillService;
                    this.briteBillService = briteBillService;
                    this.loadingModalInstance = null;
                    this.config = this.saveBillService.getConfig();
                }
                SaveBillDirectiveController.modalDismissed = function () {
                    console.log('User answer - Close');
                };
                SaveBillDirectiveController.prototype.isLoadingBriteBill = function () {
                    return this.briteBillService.isLoadingBriteBill(this.accountNumber);
                };
                SaveBillDirectiveController.prototype.getLoadingFileData = function () {
                    return this.briteBillService.getLoadingFileData();
                };
                SaveBillDirectiveController.prototype.dismissLoadingModal = function () {
                    if (this.loadingModalInstance) {
                        // this.$modalStack.dismissAll();
                        var openedModal = this.$modalStack.getTop();
                        openedModal.key.close(openedModal.key);
                    }
                };
                SaveBillDirectiveController.prototype.showLoadingModal = function () {
                    this.loadingModalInstance = this.$modal.open({
                        windowTemplateUrl: this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                        templateUrl: this.config.advanced.saveBillLoadingModal.templateUrl,
                        controller: this.config.advanced.saveBillGenericModal.controllerName,
                        controllerAs: 'saveBillLoadingModal',
                        size: 'sm',
                        backdrop: 'static'
                    }).result.then(function (result) {
                        // Result selection behaviour
                        SaveBillDirectiveController.modalDismissed();
                    }, function () {
                        // Dismiss behaviour
                        // Do nothing/close
                        SaveBillDirectiveController.modalDismissed();
                    });
                };
                ;
                SaveBillDirectiveController.$inject = ['$window', '$location', '$modal', '$modalStack', 'ute.save.bill.service', 'ute.brite.bill.service'];
                return SaveBillDirectiveController;
            }());
            bill.SaveBillDirectiveController = SaveBillDirectiveController;
            angular.module('ute.save.bill').controller('ute.save.bill.directive.controller', SaveBillDirectiveController);
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            'use strict';
            angular.module('ute.save.bill').directive('uteSaveBill', uteSaveBillDirective);
            uteSaveBillDirective.$inject = ['ute.save.bill.service', 'ute.brite.bill.service'];
            /* @ngInject */
            function uteSaveBillDirective(savebillService, briteBillService) {
                var config = savebillService.getConfig();
                return {
                    restrict: 'E',
                    scope: {
                        accountNumber: '=',
                    },
                    templateUrl: config.advanced.savebillDirective.templateUrl,
                    controller: config.advanced.savebillDirective.controllerName,
                    controllerAs: 'saveBillButton',
                    bindToController: true,
                    link: function (scope, element, attrs, controller) {
                        scope.$watch(function () {
                            return briteBillService.getLoadingFileData();
                        }, function (newVal, oldVal) {
                            if (newVal) {
                                controller.showLoadingModal();
                            }
                            else {
                                controller.dismissLoadingModal();
                            }
                        });
                    }
                };
            }
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var modal;
            (function (modal) {
                'use strict';
                angular.module('ute.save.bill.modal').directive('uteSaveBillModalIFrameOnLoad', uteSaveBillModalIFrameDirective);
                uteSaveBillModalIFrameDirective.$inject = [];
                /* @ngInject */
                function uteSaveBillModalIFrameDirective() {
                    return {
                        restrict: 'A',
                        scope: { callBack: '&uteSaveBillModalIFrameOnLoad' },
                        link: function (scope, element) {
                            element.on('load', function () {
                                return scope.callBack();
                            });
                        }
                    };
                }
            })(modal = bill.modal || (bill.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                var SaveBillProvider = (function () {
                    /* @ngInject */
                    function SaveBillProvider(briteBillProvider) {
                        var _this = this;
                        this.briteBillProvider = briteBillProvider;
                        this.config = {
                            basic: {
                                applicationId: 'Rogers.com',
                                partialApiUrl: 'v1/encryptBritebill',
                                analyticsId: 'download bill',
                                postToUrl: ''
                            },
                            advanced: {
                                savebillDirective: {
                                    templateUrl: 'module/savebill/savebill.partial.html',
                                    controllerName: 'ute.save.bill.directive.controller'
                                },
                                confirmationController: {
                                    templateUrl: 'module/savebillModal/savebillPrintModal/confirmationModal.partial.html',
                                    controllerName: 'ute.save.bill.modal.confirmation.modal.controller'
                                },
                                saveBillBanner: {
                                    templateUrl: 'module/savebill/savebill-banner.partial.html',
                                    controllerName: 'ute.save.bill.banner.controller'
                                },
                                saveBillDirectiveModal: {
                                    windowTemplateUrl: 'module/savebillModal/savebillModal.windowTemplate.html',
                                },
                                saveBillGenericModal: {
                                    templateUrl: 'module/savebillModal/saveBillGenericModal/saveBillGenericErrorModal.partial.html',
                                    controllerName: 'ute.save.bill.modal.generic.modal.controller'
                                },
                                saveBillLoadingModal: {
                                    templateUrl: 'module/savebillModal/saveBillGenericModal/saveBillLoadingModal.partial.html'
                                },
                                saveBillNoDataModal: {
                                    templateUrl: 'module/savebillModal/saveBillGenericModal/saveBillNoDataModal.partial.html'
                                },
                                saveBillSuccessModal: {
                                    templateUrl: 'module/savebillModal/saveBillGenericModal/saveBillSuccessModal.partial.html'
                                },
                                saveBillPrintModal: {
                                    templateUrl: 'module/savebillModal/savebillPrintModal/savebillPrintModal.partial.html',
                                    controllerName: 'ute.save.bill.print.modal.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $state, $http, $q, $modal, $rootScope, $window, $translate, $filter) {
                            _this.encryptionService = $injector.get('ute.common.encryption.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.$injector = $injector;
                            _this.$state = $state;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.$modal = $modal;
                            _this.$rootScope = $rootScope;
                            _this.$window = $window;
                            _this.$translate = $translate;
                            _this.$filter = $filter;
                            _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            _this.brtSwitchService = $injector.get('ute.common.core.brtswitch.service');
                            return {
                                getConfig: _this.getConfig,
                                $injector: _this.$injector,
                                resetModel: _this.resetModel,
                                getModel: _this.getModel,
                                successModal: _this.successModal,
                                noDataModalModal: _this.noDataModalModal,
                                errorPopupModal: _this.errorPopupModal
                            };
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            /*
                                  this.briteBillProvider.configure({
                                    basic: {
                                      applicationId: this.config.basic.applicationId
                                    }
                                  });
                            */
                            return true;
                        };
                        /**
                         *
                         * @returns {ISaveBillModel}
                         */
                        this.getModel = function () {
                            return _this.model;
                        };
                        this.resetModel = function () {
                            _this.model = {
                                enhancedPermission: true
                            };
                        };
                        this.successModal = function (modalScope) {
                            _this.$modal.open({
                                windowTemplateUrl: _this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                                templateUrl: _this.config.advanced.saveBillSuccessModal.templateUrl,
                                controller: _this.config.advanced.saveBillGenericModal.controllerName,
                                controllerAs: 'saveBillGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: modalScope
                            });
                        };
                        this.errorPopupModal = function (errorModalScope) {
                            _this.$modal.open({
                                windowTemplateUrl: _this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                                templateUrl: _this.config.advanced.saveBillGenericModal.templateUrl,
                                controller: _this.config.advanced.saveBillGenericModal.controllerName,
                                controllerAs: 'saveBillGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        this.noDataModalModal = function () {
                            _this.$modal.open({
                                windowTemplateUrl: _this.config.advanced.saveBillDirectiveModal.windowTemplateUrl,
                                templateUrl: _this.config.advanced.saveBillNoDataModal.templateUrl,
                                controller: _this.config.advanced.saveBillGenericModal.controllerName,
                                controllerAs: 'saveBillGenericModal',
                                size: 'md',
                                backdrop: 'static'
                            });
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$q',
                            '$modal',
                            '$rootScope',
                            '$window',
                            '$translate',
                            '$filter'
                        ];
                        this.resetModel();
                    }
                    SaveBillProvider.$inject = [
                        'ute.rogers.account.overview.factoryProvider'];
                    return SaveBillProvider;
                }());
                angular.module('ute.save.bill.service').provider('ute.save.bill.service', SaveBillProvider);
            })(service = bill.service || (bill.service = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var NavigationMainController = (function () {
                        /* @ngInject */
                        function NavigationMainController($document) {
                            this.$document = $document;
                            $document.scrollTop(0);
                        }
                        NavigationMainController.$inject = ['$document'];
                        return NavigationMainController;
                    }());
                    navigation.NavigationMainController = NavigationMainController;
                    angular.module('ute.common.second.level.navigation').controller('ute.common.second.level.navigation.main.controller', NavigationMainController);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    var service;
                    (function (service) {
                        'use strict';
                        var NavigationProvider = (function () {
                            /* @ngInject */
                            function NavigationProvider() {
                                var _this = this;
                                this.config = {
                                    basic: {
                                        applicationId: 'ute-application-id',
                                        mainControllerName: 'ute.common.second.level.navigation.main.controller',
                                        mainTemplateUrl: 'module/secondLevelNavigation/secondLevelNavigation.main.view.html',
                                        isNavigationBarSticky: true
                                    },
                                    advanced: {
                                        navigationBarDirective: {
                                            controllerName: 'ute.common.second.level.navigation.navigationBar.controller',
                                            templateUrl: 'module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.view.html'
                                        }
                                    }
                                };
                                /**
                                 * @param event
                                 * @param toState
                                 * @param toParams
                                 * @param fromState
                                 * @param fromParams
                                 * @returns {boolean}
                                 */
                                this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                                    _this.currentState = toState;
                                    if (_.has(_this.model, 'inputModel.navigationBar')) {
                                        _this.activeRootMenu(_this.getNavigationItemByStateName(toState.name, _this.model.inputModel.navigationBar));
                                    }
                                    return true;
                                };
                                /* @ngInject */
                                this.$get = function ($injector) {
                                    _this.userService = $injector.get('ute.common.user.service');
                                    _this.securityService = $injector.get('ute.common.security.service');
                                    _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                    $injector.get('ute.blocks.router').registerGlobalToStateHandler(_this, ute.blocks.router.StateHandlerPriority.LOW);
                                    return {
                                        getModel: _this.getModel,
                                        getConfig: _this.getConfig,
                                        setDataModel: _this.setDataModel,
                                        onDataModelChange: _this.onDataModelChange,
                                        getInputModel: _this.getInputModel,
                                        setInputModel: _this.setInputModel,
                                        enableRootMenu: _this.enableRootMenu,
                                        disableRootMenu: _this.disableRootMenu,
                                        activeRootMenu: _this.activeRootMenu,
                                        setSubMenuItemActive: _this.setSubMenuItemActive,
                                        getShowNavigationMenu: _this.getShowNavigationMenu,
                                        enableFullMenu: _this.enableFullMenu,
                                        disableFullMenu: _this.disableFullMenu,
                                        setSelectAccount: _this.setSelectAccount,
                                        getSelectedAccount: _this.getSelectedAccount,
                                        getAccounts: _this.getAccounts,
                                        getDropdown: _this.getDropdown,
                                        getNavigationBarSticky: _this.getNavigationBarSticky,
                                        setNavigationBarSticky: _this.setNavigationBarSticky,
                                        resetSelectedAccount: _this.resetSelectedAccount
                                    };
                                };
                                /**
                                 * @param config
                                 * @returns {boolean}
                                 */
                                this.configure = function (config) {
                                    _this.config = _.merge(_this.config, config);
                                    return true;
                                };
                                /**
                                 * @returns {INavigationModel}
                                 */
                                this.getModel = function () { return _this.model; };
                                /**
                                 * @param stateName
                                 * @param collection
                                 * @returns {string|undefined}
                                 */
                                this.getNavigationItemByStateName = function (stateName, collection) {
                                    var retval = _.find(collection, function (item) {
                                        if (angular.isString(item.stateName)) {
                                            return item.stateName === stateName;
                                        }
                                        else if (angular.isArray(item.stateName)) {
                                            return _.include(item.stateName, stateName);
                                        }
                                        else {
                                            return false;
                                        }
                                    });
                                    if (angular.isUndefined(retval)) {
                                        retval = _.find(collection, _.curry(_this.getNavigationItemFromDropdown)(stateName));
                                    }
                                    return retval;
                                };
                                /**
                                 * @param stateName
                                 * @param item
                                 * @returns {INavigationItem}
                                 */
                                this.getNavigationItemFromDropdown = function (stateName, item) {
                                    var retval;
                                    if (_.has(item, 'dropdown')) {
                                        retval = _this.getNavigationItemByStateName(stateName, item.dropdown);
                                    }
                                    return retval;
                                };
                                /**
                                 * @returns {INavigationServiceConfig}
                                 */
                                this.getConfig = function () { return angular.copy(_this.config); };
                                /**
                                 * @param dataModel - set data model
                                 */
                                this.setDataModel = function (dataModel) { return _this.model = dataModel; };
                                this.onDataModelChange = function () {
                                    if (angular.isObject(_this.currentState)) {
                                        _this.activeRootMenu(_this.getNavigationItemByStateName(_this.currentState.name, _this.model.inputModel.navigationBar));
                                    }
                                };
                                /**
                                 * @returns {INavigationInput}
                                 */
                                this.getInputModel = function () { return _this.model.inputModel; };
                                /**
                                 * @param dataModel - set input model
                                 */
                                this.setInputModel = function (dataModel) { return _this.model.inputModel = dataModel; };
                                /**
                                 * @param item
                                 * @param inputStatus
                                 */
                                this.setStatus = function (item, inputStatus) {
                                    if (angular.isObject(item)) {
                                        item.status = inputStatus;
                                    }
                                };
                                /**
                                 * Reset model to initial state
                                 */
                                this.resetModel = function () {
                                    _this.model = {
                                        inputModel: null,
                                        showNavigationMenu: false,
                                        selectedAccount: null,
                                        isNavigationBarSticky: true
                                    };
                                };
                                /**
                                 * Reset selected Account model
                                 */
                                this.resetSelectedAccount = function () {
                                    _this.model.selectedAccount = null;
                                };
                                /**
                                 * @returns {INavigationInput}
                                 */
                                this.getSelectedAccount = function () { return _this.model.selectedAccount; };
                                /**
                                 * @returns {Array<INavigationItem>}
                                 */
                                this.getAccounts = function () { return _.find(_this.model.inputModel.navigationBar, { status: navigation.NavigationStatus.ACCOUNT_DROPDOWN }).dropdown; };
                                /**
                                 * @returns {Array<INavigationItem>}
                                 */
                                this.getDropdown = function (itemId) {
                                    var targetItem = _.find(_this.model.inputModel.navigationBar, { id: itemId });
                                    if (_.has(targetItem, 'dropdown')) {
                                        return targetItem.dropdown;
                                    }
                                    return null;
                                };
                                /**
                                 * @returns {INavigationInput}
                                 */
                                this.getShowNavigationMenu = function () { return _this.model.showNavigationMenu; };
                                /**
                                 * Enable the menu item in the root level
                                 */
                                this.enableRootMenu = function (item) { return _this.setStatus(item, navigation.NavigationStatus.SHOW_ENABLE); };
                                /**
                                 * Disable the menu item in the root level
                                 */
                                this.disableRootMenu = function (item) { return _this.setStatus(item, navigation.NavigationStatus.SHOW_DISABLE); };
                                /**
                                 * Active the menu item in the root level
                                 */
                                this.activeRootMenu = function (item) {
                                    if (angular.isObject(item)) {
                                        /**
                                         * Change existing active menu to enable
                                         */
                                        var currentActiveMenu = _.find(_this.model.inputModel.navigationBar, { status: navigation.NavigationStatus.ACTIVE });
                                        if (currentActiveMenu) {
                                            /**
                                             * If the targetItem is equals to current Active item then do nothing just return
                                             */
                                            if (currentActiveMenu.id === item.id) {
                                                return;
                                            }
                                            currentActiveMenu.status = navigation.NavigationStatus.SHOW_ENABLE;
                                        }
                                        _this.setStatus(item, navigation.NavigationStatus.ACTIVE);
                                    }
                                };
                                /**
                                 *
                                 */
                                this.getDropdownListById = function (id) {
                                    var retval = {
                                        list: null,
                                        targetItem: null
                                    };
                                    /**
                                     * Comment out the following code because the current lodash.d.ts does not contains flow method
                                     */
                                    // let parentItem: INavigationItem = _.find(this.model.inputModel.navigationBar, _.flow(_.property('dropdown'), _.partialRight(_.any, { id: id })));
                                    // if (angular.isUndefined(parentItem)) {
                                    //   return parentItem.dropdown;
                                    // };
                                    var rootMenuWithDropdown = _.filter(_this.model.inputModel.navigationBar, function (item) {
                                        if (item.dropdown === null || angular.isUndefined(item.dropdown)) {
                                            return false;
                                        }
                                        /**
                                         * item contains dropdown
                                         */
                                        var checkMatchingId = function (dropdownItem) {
                                            if (dropdownItem.id === id) {
                                                retval.targetItem = dropdownItem;
                                                return true;
                                            }
                                        };
                                        if (_.find(item.dropdown, checkMatchingId)) {
                                            return true;
                                        }
                                        return false;
                                    });
                                    if (!angular.isUndefined(rootMenuWithDropdown)) {
                                        retval.list = rootMenuWithDropdown[0].dropdown;
                                        return retval;
                                    }
                                    return null;
                                };
                                /**
                                 * Reset active menu to show enable
                                 */
                                this.resetNavigationItemList = function (itemList) {
                                    if (!angular.isObject(itemList)) {
                                        return;
                                    }
                                    /**
                                     * Change existing active menu to enable
                                     */
                                    var currentActiveMenu = _.find(itemList, { status: navigation.NavigationStatus.ACTIVE });
                                    if (currentActiveMenu) {
                                        currentActiveMenu.status = navigation.NavigationStatus.SHOW_ENABLE;
                                    }
                                };
                                /**
                                 * Active the sub menu item
                                 */
                                this.setSubMenuItemActive = function (id) {
                                    // set subMenu item to active
                                    var targetDropdownList = _this.getDropdownListById(id);
                                    if (targetDropdownList.list.length > 0) {
                                        _this.resetNavigationItemList(targetDropdownList.list);
                                    }
                                    targetDropdownList.targetItem.status = navigation.NavigationStatus.ACTIVE;
                                };
                                /**
                                 * Enable the Full menu
                                 */
                                this.enableFullMenu = function () { return _this.model.showNavigationMenu = true; };
                                /**
                                 * Disable the Full menu
                                 */
                                this.disableFullMenu = function () { return _this.model.showNavigationMenu = false; };
                                this.setSelectAccount = function (accountInfo) { return _this.model.selectedAccount = accountInfo; };
                                this.getNavigationBarSticky = function () { return _this.model.isNavigationBarSticky; };
                                this.setNavigationBarSticky = function (item) { return _this.model.isNavigationBarSticky = item; };
                                this.$get.$inject = [
                                    '$injector'
                                ];
                                this.resetModel();
                            }
                            ;
                            NavigationProvider.$inject = [];
                            return NavigationProvider;
                        }());
                        angular.module('ute.common.second.level.navigation').provider('ute.common.second.level.navigation.service', NavigationProvider);
                    })(service = navigation.service || (navigation.service = {}));
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var security;
        (function (security) {
            'use strict';
            // import UserType = ute.common.user.UserType;
            var SecurityProvider = (function () {
                /* @ngInject */
                function SecurityProvider(userProvider) {
                    var _this = this;
                    this.userProvider = userProvider;
                    // private protectedUrlPrefix: string = '/web/RogersServices.portal/totes/api/';
                    // private publicUrlPrefix: string = '/web/totes/api/';
                    /* @ngInject */
                    this.$get = function ($injector, $state) {
                        _this.$state = $state;
                        _this.userService = $injector.get('ute.common.user.service');
                        return {
                            isStateProtected: _this.isStateProtected,
                            getBackendUrl: _this.userService.getBackendUrl
                        };
                    };
                    /**
                     * @param state
                     * @returns {boolean}
                     */
                    this.isStateProtected = function (state) {
                        var roles = _.get(_.isString(state) ? _this.$state.get(state) : state, 'data.security.roles');
                        // if not exists = public
                        return !(angular.isUndefined(roles) || _.contains(roles, 'public'));
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$state'
                    ];
                    // this.config.roleToUrlBase[UserType[UserType.care]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.careRep]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.dealer]] = this.publicUrlPrefix;
                    // this.config.roleToUrlBase[UserType[UserType.consumer]] = this.protectedUrlPrefix;
                }
                /**
                 * @param config
                 * @returns {boolean}
                 */
                SecurityProvider.prototype.configure = function (config) {
                    // this.config = <ISecurityConfig>_.merge(this.config, config);
                    // this.userProvider.configure({roleToUrlBase: config.roleToUrlBase});
                    return true;
                };
                SecurityProvider.$inject = ['ute.common.user.serviceProvider'];
                return SecurityProvider;
            }());
            angular.module('ute.common.security').provider('ute.common.security.service', SecurityProvider);
        })(security = common.security || (common.security = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardController = (function () {
                        /* @ngInject */
                        function SimCardController($document, simCardService) {
                            this.$document = $document;
                            this.simCardService = simCardService;
                            this.howToFindNumberPartialPath = simCardService.getConfig().advanced.secondaryColumnPartialPath;
                            this.simCardHeaderPartialPath = simCardService.getConfig().advanced.simCardHeaderPartialPath;
                            this.simCardDefaultPartialPath = simCardService.getConfig().advanced.simCardDefaultPartialPath;
                            this.getCtn = simCardService.getPhoneNumber;
                            this.getBan = simCardService.getAccountNumber;
                            this.getEmail = simCardService.getAccountEmail;
                            this.floatingLiveChatSetting = {
                                cbid: 'ute.rogers.myrSimCard.liveChat.cbid',
                                boldChatDiv: 'ute.rogers.myrSimCard.liveChat.boldChatDiv',
                                chatButton: 'ute.rogers.myrSimCard.liveChat.chatButton'
                            };
                            simCardService.restoreFromInput();
                            // getCtn() need to be called after restoreFromInput() - because phoneNumber is set in this method.
                            var ctn = this.getCtn();
                            $document.scrollTop(0);
                        }
                        SimCardController.$inject = ['$document', 'ute.common.simcard.change.service'];
                        return SimCardController;
                    }());
                    service.SimCardController = SimCardController;
                    angular.module('ute.common.simcard.change').controller('ute.common.simcard.change.main.controller', SimCardController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service').run(simCardRoutesConfig);
                    simCardRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.simcard.change.service'];
                    /* @ngInject */
                    function simCardRoutesConfig(routerHelper, simCardService) {
                        routerHelper.configureStates(getStates(simCardService));
                    }
                    function getStates(simCardService) {
                        var simCardRootState = simCardService.getConfig().basic.simCardRootState;
                        return [
                            {
                                name: simCardRootState,
                                abstract: true,
                                url: '/' + simCardRootState,
                                controller: simCardService.getConfig().basic.mainControllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().basic.mainTemplateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] }
                                },
                                resolve: simCardService.getConfig().advanced.resolve
                            },
                            {
                                name: simCardService.getEntryState(),
                                url: '/' + simCardService.getConfig().advanced.enterSimCard.subState + '/:id',
                                controller: simCardService.getConfig().advanced.enterSimCard.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.enterSimCard.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            },
                            {
                                name: simCardRootState + '.' + simCardService.getConfig().advanced.confirmation.subState,
                                url: '/' + simCardService.getConfig().advanced.confirmation.subState + '/:id',
                                controller: simCardService.getConfig().advanced.confirmation.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.confirmation.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            },
                            {
                                name: simCardRootState + '.' + simCardService.getConfig().advanced.success.subState,
                                url: '/' + simCardService.getConfig().advanced.success.subState + '/:id',
                                controller: simCardService.getConfig().advanced.success.controllerName,
                                controllerAs: 'sc',
                                templateUrl: simCardService.getConfig().advanced.success.templateUrl,
                                data: {
                                    title: '',
                                    security: { roles: ['user'] },
                                    encryption: { params: ['id'], failbackState: simCardService.getConfig().advanced.enterSimCard.cancelState }
                                }
                            }];
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        'use strict';
                        var SmToGenesisAuthServiceProvider = (function () {
                            /* @ngInject */
                            function SmToGenesisAuthServiceProvider() {
                                var _this = this;
                                this.config = {
                                    basic: {
                                        applicationId: 'Rogers.com',
                                        brand: 'ROGERS'
                                    },
                                    advanced: {
                                        tokenLifetime: 180000,
                                        apiUrl: {
                                            getXSessionToken: 'http://demo9915949.mockable.io/v1/siteminder-authc-svc',
                                            deleteXSessionToken: 'http://demo9915949.mockable.io/v1/siteminder-authc-svc'
                                        }
                                    }
                                };
                                /* @ngInject */
                                this.$get = function ($injector, $http, $q) {
                                    _this.$injector = $injector;
                                    _this.$http = $http;
                                    _this.$q = $q;
                                    _this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                                    return {
                                        getConfig: _this.getConfig,
                                        getXSessionToken: _this.getXSessionToken,
                                        killXSessionToken: _this.killXSessionToken
                                    };
                                };
                                /**
                                 * @returns {any}
                                 */
                                this.getConfig = function () {
                                    return angular.copy(_this.config);
                                };
                                /**
                                 * @param config
                                 * @returns {boolean}
                                 */
                                this.configure = function (config) {
                                    _this.config = _.merge(_this.config, config);
                                    return true;
                                };
                                /**
                                 * @param payload
                                 * @returns {string}
                                 * This method will be called to get the x-session-token.
                                 * It will check and return the x-session-token if it exists in the localStorage and it is not expired.
                                 * If it's not in the localStorage or if it's expired, we'll call the API to get a new x-session-token
                                 * and update in localStorage and update the expiration time as well before returning to the caller.
                                 */
                                this.getXSessionToken = function () {
                                    if (_this.isTokenStoredAndValid() === true) {
                                        return new _this.$q(function (resolve) { return resolve(_this.getStoredToken()); });
                                    }
                                    var config = {
                                        headers: {
                                            'x-app-key': _this.getConfig().basic.applicationId,
                                            'x-session-lifetime': _this.getConfig().advanced.tokenLifetime
                                        }
                                    };
                                    return _this.$http
                                        .post(_this.getConfig().advanced.apiUrl.getXSessionToken, {}, config)
                                        .then(_this.xSessionTokenSuccessCallback);
                                };
                                /**
                                 * This method will be used to handle the logout call and kill the x-session-token
                                 */
                                this.killXSessionToken = function () {
                                    var storedToken = _this.getStoredToken();
                                    if (storedToken) {
                                        _this.storageService.removeFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_X_SESSION_TOKEN);
                                        return _this.$http.delete(_this.getConfig().advanced.apiUrl.deleteXSessionToken + '/' + storedToken);
                                    }
                                    return new _this.$q(function (reject) { return reject({
                                        status: {
                                            code: 401,
                                            codeName: 'xSessionToken invalid or has expired'
                                        }
                                    }); });
                                };
                                this.xSessionTokenSuccessCallback = function (response) {
                                    _this.storageService.putToSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_X_SESSION_TOKEN, response.data);
                                    return response.data.content.xSessionToken;
                                };
                                this.isTokenStoredAndValid = function () {
                                    var storedTokenData = _this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_X_SESSION_TOKEN);
                                    return storedTokenData && storedTokenData.content.expiresOn > Date.now();
                                };
                                this.getStoredToken = function () {
                                    var storedTokenData = _this.storageService.getFromSession(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_X_SESSION_TOKEN);
                                    return storedTokenData.content.xSessionToken;
                                };
                                this.$get.$inject = [
                                    '$injector',
                                    '$http',
                                    '$q'
                                ];
                            }
                            SmToGenesisAuthServiceProvider.$inject = [];
                            return SmToGenesisAuthServiceProvider;
                        }());
                        angular.module('ute.sm.to.genesis.auth.service').provider('ute.sm.to.genesis.auth.service', SmToGenesisAuthServiceProvider);
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
                var UteSmsRecoveryRogersController = (function () {
                    /* @ngInject */
                    function UteSmsRecoveryRogersController(uteSmsRecoveryRogersService) {
                        this.uteSmsRecoveryRogersService = uteSmsRecoveryRogersService;
                        this.data = {
                            phone: undefined,
                            noPhone: false
                        };
                        this.isRecoveryApiFetched = false;
                        if (window.sessionStorage.getItem('xSessionToken')) {
                            this.fetchPhone();
                            this.bindToPhoneChangeEvent();
                            this.isRecoveryApiFetched = true;
                        }
                    }
                    UteSmsRecoveryRogersController.prototype.fetchPhone = function () {
                        var _self = this;
                        _self.data.phone = undefined;
                        _self.data.noPhone = false;
                        this.uteSmsRecoveryRogersService
                            .fetchPhone()
                            .then(function (phone) {
                            console.log('::success', phone);
                            if (_.includes(phone, '*')) {
                                phone = phone.replace(/[*]/g, '•');
                            }
                            _self.data.phone = phone;
                        }, function () {
                            console.log('error from ctrl');
                            _self.data.noPhone = true;
                        });
                    };
                    UteSmsRecoveryRogersController.prototype.bindToPhoneChangeEvent = function () {
                        var _self = this;
                        window['$']('body').on('sms-recovery-phone-changed', function () {
                            //fetch new phone from API to involve angular digest cycle
                            _self.fetchPhone();
                        });
                    };
                    UteSmsRecoveryRogersController.controllerName = 'ute.sms.recovery.rogers.controller';
                    UteSmsRecoveryRogersController.$inject = [
                        'ute.sms.recovery.rogers.service',
                    ];
                    return UteSmsRecoveryRogersController;
                }());
                rogers.UteSmsRecoveryRogersController = UteSmsRecoveryRogersController;
                angular.module('ute.sms.recovery.rogers').controller('ute.sms.recovery.rogers.controller', UteSmsRecoveryRogersController);
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
                angular.module('ute.sms.recovery.rogers').directive('uteSmsRecoveryRogers', uteSmsRecoveryRogersDirective);
                uteSmsRecoveryRogersDirective.$inject = ['ute.sms.recovery.rogers.service'];
                /* @ngInject */
                function uteSmsRecoveryRogersDirective(uteSmsRecoveryRogersService) {
                    var obj = {
                        restrict: 'E',
                        scope: true,
                        templateUrl: uteSmsRecoveryRogersService.getConfig().advanced.root.templateUrl,
                        controller: uteSmsRecoveryRogersService.getConfig().advanced.root.controllerName,
                        controllerAs: '$ctrl'
                    };
                    return obj;
                }
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var sms;
    (function (sms) {
        var recovery;
        (function (recovery) {
            var rogers;
            (function (rogers) {
                'use strict';
                var UteSmsRecoveryRogersProvider = (function () {
                    /* @ngInject */
                    function UteSmsRecoveryRogersProvider() {
                        var _this = this;
                        this.mock = window.location.href.indexOf('localhost') >= 0;
                        this.genesisUrlPrefix = '/web/totes/web/genesis/api';
                        this.branding = 'ROGERS';
                        //private mock: boolean = false;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                            },
                            advanced: {
                                root: {
                                    controllerName: 'ute.sms.recovery.rogers.controller',
                                    templateUrl: 'module/uteSmsRecoveryRogers/uteSmsRecoveryRogers.view.html'
                                }
                            } //<--injectHere
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q) {
                            _this.$injector = $injector;
                            _this.$http = $http;
                            _this.$q = $q;
                            return {
                                fetchPhone: _this.fetchPhone,
                                getConfig: _this.getConfig,
                                resetModel: _this.resetModel
                            };
                        };
                        this.getRecoverySMSURL = function () {
                            var GUID = _this.getGUID();
                            var brand = _this.getBrandValue();
                            return _this.genesisUrlPrefix + "/user/v1/byGUID/" + GUID + "/OnlineProfile/recoverySMS?brand=" + brand;
                        };
                        this.fetchPhone = function () {
                            var options = {
                                method: 'GET',
                                url: _this.getRecoverySMSURL() + '&timestamp=' + Date.now(),
                                headers: {
                                    'x-session-token': _this.getSessionToken(),
                                    'x-app-id': _this.getXAppId()
                                }
                            };
                            // adding mock support for API
                            if (_this.mock) {
                                options.url = 'resource/uteSmsRecovery.json';
                            }
                            return _this.$http(options)
                                .then(function (res) {
                                console.log('::res', res);
                                var data = res.data;
                                if ((data.status.code === 200) && data.content.phoneNumber) {
                                    console.log('::sending success to ctrl');
                                    window.localStorage.setItem('recoveryNumber', data.content.phoneNumber);
                                    return data.content.phoneNumber;
                                }
                                window.localStorage.removeItem('recoveryNumber');
                                console.log('::sending error to ctrl');
                                return _this.$q.reject(data.status.code);
                            });
                        };
                        this.getGUID = function () {
                            return window.sessionStorage.getItem('guid');
                        };
                        this.getSessionToken = function () {
                            return window.sessionStorage.getItem('xSessionToken');
                        };
                        this.getXAppId = function () {
                            return _this.branding === 'ROGERS' ? 'Rogers.com' : 'Fido.ca';
                        };
                        this.getBrandValue = function () {
                            return _this.branding === 'ROGERS' ? 'Rogers' : 'Fido';
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.resetModel = function () {
                            _this.model = {
                                moduleName: 'uteSmsRecoveryRogers'
                            };
                        };
                        this.$get.$inject = ['$injector', '$http', '$q'];
                        this.resetModel();
                        console.log('mocking', this.mock);
                    }
                    UteSmsRecoveryRogersProvider.$inject = [];
                    return UteSmsRecoveryRogersProvider;
                }());
                angular.module('ute.sms.recovery.rogers').provider('ute.sms.recovery.rogers.service', UteSmsRecoveryRogersProvider);
            })(rogers = recovery.rogers || (recovery.rogers = {}));
        })(recovery = sms.recovery || (sms.recovery = {}));
    })(sms = ute.sms || (ute.sms = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            var SubscriptionBadgeController = (function () {
                /* ngInject */
                function SubscriptionBadgeController(subscriptionBadgeService) {
                    this.subscriptionBadgeService = subscriptionBadgeService;
                    this.viewModel = this.subscriptionBadgeService.buildViewModel(this.model);
                }
                SubscriptionBadgeController.$inject = ['ute.common.subscriptionBadge.service'];
                return SubscriptionBadgeController;
            }());
            subscriptionBadge.SubscriptionBadgeController = SubscriptionBadgeController;
            angular
                .module('ute.common.subscriptionBadge')
                .controller('ute.common.subscriptionBadge.controller', SubscriptionBadgeController);
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            var SubscriptionBadgeDirective = (function () {
                /* @ngInject */
                function SubscriptionBadgeDirective(subscriptionBadgeProviderService) {
                    this.subscriptionBadgeProviderService = subscriptionBadgeProviderService;
                    this.restrict = 'E';
                    this.controller = this.subscriptionBadgeProviderService.getConfig().basic.controller;
                    this.controllerAs = 'subscriptionBadge';
                    this.bindToController = true;
                    this.templateUrl = this.subscriptionBadgeProviderService.getConfig().basic.templateUrl;
                    this.scope = {
                        model: '=uteSubscriptionBadgeAttrModel'
                    };
                }
                SubscriptionBadgeDirective.factory = function () {
                    var directive = function (subscriptionBadgeProviderService) {
                        return new SubscriptionBadgeDirective(subscriptionBadgeProviderService);
                    };
                    directive.$inject = ['ute.common.subscriptionBadge.provider'];
                    return directive;
                };
                return SubscriptionBadgeDirective;
            }());
            angular.module('ute.common.subscriptionBadge').directive('uteSubscriptionBadge', SubscriptionBadgeDirective.factory());
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            var SubscriptionBadgeService = (function () {
                function SubscriptionBadgeService($filter, $resolve) {
                    this.$filter = $filter;
                    this.$resolve = $resolve;
                    this.badgesViewConfig = [{
                            type: subscriptionBadge.BadgeTypes.homePhone,
                            icon: 'ute-icon-home-phone',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'homePhone',
                                    translationKey: 'ute.subscriptionBadge.homePhone',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'phoneNumber',
                                    class: 'ute-subscription-badge-address',
                                    filter: 'ute_common_filter_phone2'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.tv,
                            icon: 'ute-icon-tv',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'tv',
                                    translationKey: 'ute.subscriptionBadge.tv',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'subAddress',
                                    class: 'ute-subscription-badge-address'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.wireless,
                            icon: 'ute-icon-wireless',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'userName',
                                    class: 'ute-subscription-badge-label-medium'
                                }, {
                                    key: 'phoneNumber',
                                    class: 'ute-subscription-badge-label',
                                    filter: 'ute_common_filter_phone2'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.internet,
                            icon: 'ute-icon-internet',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'internet',
                                    translationKey: 'ute.subscriptionBadge.internet',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'subAddress',
                                    class: 'ute-subscription-badge-address'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.smartHomeMonitoring,
                            icon: 'ute-icon-home-security',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'shm',
                                    translationKey: 'ute.subscriptionBadge.smartHomeMonitoring',
                                    class: 'ute-subscription-badge-label-medium'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.igniteTv,
                            icon: 'ute-icon-tv',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'tv',
                                    translationKey: 'ute.subscriptionBadge.tv',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'subAddress',
                                    class: 'ute-subscription-badge-address'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.smartStream,
                            icon: 'ute-icon-tv',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'smartStream',
                                    translationKey: 'ute.subscriptionBadge.smartStream',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'subAddress',
                                    class: 'ute-subscription-badge-address'
                                }]
                        }, {
                            type: subscriptionBadge.BadgeTypes.igniteInternet,
                            icon: 'ute-icon-internet',
                            template: 'module/subscriptionBadge/subscriptionBadgeViews/basic.view.html',
                            labels: [{
                                    key: 'internet',
                                    translationKey: 'ute.subscriptionBadge.internet',
                                    class: 'ute-subscription-badge-label-medium-small'
                                }, {
                                    key: 'subAddress',
                                    class: 'ute-subscription-badge-address'
                                }]
                        }
                    ];
                    this.$filter = $filter;
                    this.$resolve = $resolve;
                }
                SubscriptionBadgeService.prototype.buildViewModel = function (inputModel) {
                    var viewConfigModel = _.find(this.badgesViewConfig, { type: inputModel.type });
                    var viewModel = _.cloneDeep(angular.extend({}, viewConfigModel, inputModel));
                    this.buildLabels(viewModel);
                    this.bindResolve(viewModel);
                    return viewModel;
                };
                SubscriptionBadgeService.prototype.buildLabels = function (viewModel) {
                    for (var _i = 0, _a = viewModel.labels; _i < _a.length; _i++) {
                        var label = _a[_i];
                        label.text = viewModel[label.key] || label.text;
                        if (label.filter) {
                            label.text = this.$filter(label.filter)(label.text);
                        }
                        if (!_.isEmpty(viewModel.serviceAddress)) {
                            label.subAddress = viewModel.serviceAddress;
                        }
                    }
                    return viewModel;
                };
                SubscriptionBadgeService.prototype.bindResolve = function (viewModel) {
                    var _this = this;
                    if (viewModel.resolve && !viewModel.disabled) {
                        viewModel.resolveAll = function (subscription) {
                            return _this.$resolve.resolve(viewModel.resolve(viewModel));
                        };
                    }
                    return viewModel;
                };
                SubscriptionBadgeService.$inject = ['$filter', '$resolve'];
                return SubscriptionBadgeService;
            }());
            subscriptionBadge.SubscriptionBadgeService = SubscriptionBadgeService;
            angular
                .module('ute.common.subscriptionBadge')
                .service('ute.common.subscriptionBadge.service', SubscriptionBadgeService);
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                angular.module('ute.common.suspend.ctn').run(suspendCtnRoutesConfig);
                suspendCtnRoutesConfig.$inject = ['ute.blocks.router', 'ute.common.suspend.ctn.service'];
                /* @ngInject */
                function suspendCtnRoutesConfig(routerHelper, suspendCtnService) {
                    routerHelper.configureStates(getStates(suspendCtnService));
                }
                function getStates(suspendCtnService) {
                    var suspendCtnRootState = suspendCtnService.getConfig().basic.suspendCtnRootState;
                    return [
                        {
                            name: suspendCtnRootState,
                            abstract: true,
                            url: '/' + suspendCtnRootState,
                            controller: suspendCtnService.getConfig().basic.mainControllerName,
                            controllerAs: 'mainSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().basic.mainTemplateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] }
                            },
                            resolve: suspendCtnService.getConfig().advanced.resolve
                        },
                        {
                            name: suspendCtnService.getEntryState(),
                            url: '/' + suspendCtnService.getConfig().advanced.confirmSuspendDevice.subState + '/:id',
                            controller: suspendCtnService.getConfig().advanced.confirmSuspendDevice.controllerName,
                            controllerAs: 'confirmSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().advanced.confirmSuspendDevice.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] },
                                encryption: { params: ['id'], failbackState: suspendCtnService.getConfig().basic.cancelState }
                            }
                        },
                        {
                            name: suspendCtnRootState + '.' + suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState,
                            url: '/' + suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState + '/:id',
                            controller: suspendCtnService.getConfig().advanced.suspendCtnSuccess.controllerName,
                            controllerAs: 'successSuspendDevice',
                            templateUrl: suspendCtnService.getConfig().advanced.suspendCtnSuccess.templateUrl,
                            data: {
                                title: '',
                                security: { roles: ['user'] },
                                encryption: { params: ['id'], failbackState: suspendCtnService.getConfig().basic.cancelState }
                            }
                        }
                    ];
                }
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnMainController = (function () {
                    /* @ngInject */
                    function SuspendCtnMainController($document, suspendCtnService) {
                        this.$document = $document;
                        this.suspendCtnService = suspendCtnService;
                        suspendCtnService.restoreState();
                        $document.scrollTop(0);
                    }
                    SuspendCtnMainController.$inject = [
                        '$document',
                        'ute.common.suspend.ctn.service'
                    ];
                    return SuspendCtnMainController;
                }());
                ctn.SuspendCtnMainController = SuspendCtnMainController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.main.controller', SuspendCtnMainController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TransferOfResponsibilityController = (function () {
            /* @ngInject */
            function TransferOfResponsibilityController($document, torService) {
                this.$document = $document;
                this.torService = torService;
                $document.scrollTop(0);
                this.screenName = this.torService.getScreenName();
            }
            TransferOfResponsibilityController.$inject = ['$document', 'ute.transferOfResponsibility.service'];
            return TransferOfResponsibilityController;
        }());
        transferOfResponsibility.TransferOfResponsibilityController = TransferOfResponsibilityController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.main.controller', TransferOfResponsibilityController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        /* import ITransferOfResponsibilityService = ute.transferOfResponsibility.service.ITransferOfResponsibilityService;*/
        angular.module('ute.transferOfResponsibility').run(transferOfResponsibilityRoutesConfig);
        transferOfResponsibilityRoutesConfig.$inject = ['ute.blocks.router', 'ute.transferOfResponsibility.service'];
        /* @ngInject */
        function transferOfResponsibilityRoutesConfig(routerHelper, transferOfResponsibilityService) {
            routerHelper.configureStates(getStates(transferOfResponsibilityService));
        }
        function getStates(transferOfResponsibilityService) {
            var torRootState = transferOfResponsibilityService.getConfig().basic.torRootState;
            return [
                {
                    name: torRootState,
                    abstract: true,
                    url: '/' + torRootState,
                    controller: transferOfResponsibilityService.getConfig().basic.mainControllerName,
                    controllerAs: 'tor',
                    templateUrl: transferOfResponsibilityService.getConfig().basic.mainTemplateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] }
                    }
                },
                {
                    name: transferOfResponsibilityService.getEntryState(),
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.selectTransferOfResponsibility.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.selectTransferOfResponsibility.controllerName,
                    controllerAs: 'torSelection',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.selectTransferOfResponsibility.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepOne.ctnSelection.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepOne.ctnSelection.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepOne.ctnSelection.controllerName,
                    controllerAs: 'ctnSelection',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepOne.ctnSelection.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepOne.eligibilityCheck.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepOne.eligibilityCheck.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepOne.eligibilityCheck.controllerName,
                    controllerAs: 'currentOwnerEligibility',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepOne.eligibilityCheck.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepTwo.futureOwnerInfo.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepTwo.futureOwnerInfo.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepTwo.futureOwnerInfo.controllerName,
                    controllerAs: 'futureOwnerInfo',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepTwo.futureOwnerInfo.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepTwo.confirmation.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepTwo.confirmation.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepTwo.confirmation.controllerName,
                    controllerAs: 'confirmation',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepTwo.confirmation.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepThree.subscriberDetails.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepThree.subscriberDetails.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepThree.subscriberDetails.controllerName,
                    controllerAs: 'subscriberDetails',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepThree.subscriberDetails.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepThree.currentOwnerInfo.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepThree.currentOwnerInfo.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepThree.currentOwnerInfo.controllerName,
                    controllerAs: 'currentOwnerInfo',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepThree.currentOwnerInfo.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepThree.eligibilityCheck.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepThree.eligibilityCheck.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepThree.eligibilityCheck.controllerName,
                    controllerAs: 'futureOwnerEligibility',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepThree.eligibilityCheck.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                },
                {
                    name: torRootState + '.' + transferOfResponsibilityService.getConfig().advanced.stepFour.subState,
                    url: '/' + transferOfResponsibilityService.getConfig().advanced.stepFour.subState + '/:id',
                    controller: transferOfResponsibilityService.getConfig().advanced.stepFour.controllerName,
                    controllerAs: 'stepFour',
                    templateUrl: transferOfResponsibilityService.getConfig().advanced.stepFour.templateUrl,
                    data: {
                        title: '',
                        security: { roles: ['user'] },
                        encryption: { params: ['id'], failbackState: transferOfResponsibilityService.getConfig().basic.torRootState }
                    }
                }
            ];
        }
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
            var UsageDialController = (function () {
                /* @ngInject */
                function UsageDialController($scope, $state, $document) {
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$document = $document;
                    this.scope = $scope;
                    this.document = $document;
                }
                UsageDialController.prototype.getDialCopy = function () {
                    return this.scope.dataRemaining < 0 ? 'ute.usageDial.overPlanLimit' : 'ute.usageDial.remaining';
                };
                UsageDialController.prototype.getDisplayData = function () {
                    var displayData = Math.round((this.scope.dataRemaining < 0 ? this.scope.dataRemaining * -1 : this.scope.dataRemaining) * 100) / 100;
                    return displayData;
                };
                UsageDialController.prototype.isOverage = function () {
                    return this.scope.dataRemaining < 0;
                };
                UsageDialController.$inject = ['$scope', '$state', '$document'];
                return UsageDialController;
            }());
            dial.UsageDialController = UsageDialController;
            angular.module('ute.usage.dial').controller('ute.usage.dial.controller', UsageDialController);
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
            angular.module('ute.usage.dial').directive('uteUsageDial', uteUsageDial);
            uteUsageDial.$inject = ['$rootScope', 'ute.usage.dial'];
            /* @ngInject */
            function uteUsageDial($rootScope, usageDialService) {
                return {
                    restrict: 'E',
                    scope: {
                        'dataRemaining': '@',
                        'unit': '@',
                        'percentageRemaining': '@'
                    },
                    templateUrl: usageDialService.getConfig().basic.templateUrl,
                    controller: usageDialService.getConfig().basic.controllerName,
                    controllerAs: 'usageDial',
                    link: function (scope, element, attrs, controller) {
                        scope.height = usageDialService.getConfig().basic.height;
                        scope.width = usageDialService.getConfig().basic.width;
                        var container = angular.element(element[0].getElementsByClassName('ute-usageDial-container'));
                        container.css('width', usageDialService.getConfig().basic.width + 'px');
                        $rootScope.$on('ute-usageDialAnimateStroke-overageHit', function () {
                            var radialGraph = angular.element(element[0].getElementsByClassName('ute-usageDialContent'));
                            radialGraph.css('backgroundColor', '#FFE9C7');
                        });
                    }
                };
            }
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
            angular.module('ute.usage.dial').directive('uteUsageDialAnimatedStroke', uteUsageDialAnimatedStroke);
            uteUsageDialAnimatedStroke.$inject = ['$interval', '$rootScope', 'ute.usage.dial'];
            /* @ngInject */
            function uteUsageDialAnimatedStroke($interval, $rootScope, usageDialService) {
                return {
                    restrict: 'E',
                    scope: {
                        'percentRemaining': '@'
                    },
                    templateUrl: usageDialService.getConfig().basic.animatedStrokeTemplateUrl,
                    controllerAs: 'usageDialAnimateStroke',
                    link: function (scope, element) {
                        scope.height = usageDialService.getConfig().basic.height;
                        scope.width = usageDialService.getConfig().basic.width;
                        var radialDialInterval;
                        scope.percentRemaining *= 1;
                        var c = element[0].getElementsByClassName('ute-usageDialChart')[0], ctx = c.getContext('2d'), inc = 2, circleRadius = usageDialService.getConfig().basic.radius, xPosition = usageDialService.getConfig().basic.width / 2, yPosition = usageDialService.getConfig().basic.height / 2, x1 = usageDialService.getConfig().basic.height, multiplier = 0.02, speed = 12, maxSpeed = 10, endSpeed = 100, incOverage = 0, iterationsLeft = (inc / scope.percentRemaining) / multiplier, iterations = inc / multiplier, totalIterations = iterations - iterationsLeft, speedDifferential = endSpeed / maxSpeed, velocityIncrement = totalIterations / speedDifferential;
                        function drawArc() {
                            var gradient = ctx.createLinearGradient(circleRadius, circleRadius, x1, circleRadius);
                            gradient.addColorStop('0', usageDialService.getConfig().basic.nominalColor);
                            gradient.addColorStop('1', usageDialService.getConfig().basic.warningColor);
                            ctx.beginPath();
                            ctx.strokeStyle = usageDialService.getConfig().basic.nominalColor;
                            ctx.arc(xPosition, yPosition, circleRadius, 0, inc * Math.PI);
                            ctx.lineWidth = usageDialService.getConfig().basic.strokeWidth;
                            ctx.stroke();
                            ctx.closePath();
                            ctx.beginPath();
                            ctx.strokeStyle = gradient;
                            if (inc <= 1) {
                                ctx.arc(xPosition, yPosition, circleRadius, 0, inc * Math.PI);
                            }
                            else {
                                ctx.arc(xPosition, yPosition, circleRadius, 0, -1 * Math.PI);
                            }
                            ctx.lineWidth = usageDialService.getConfig().basic.strokeWidth;
                            ctx.stroke();
                            ctx.closePath();
                        }
                        function dialAnimationComplete(int) {
                            $interval.cancel(int);
                        }
                        scope.$on('$destroy', function () {
                            dialAnimationComplete(radialDialInterval);
                        });
                        radialDialInterval = $interval(function () {
                            if (scope.percentRemaining < 100) {
                                inc = inc - multiplier;
                            }
                            if (inc <= (scope.percentRemaining > 0 ? (scope.percentRemaining / 50) : 0)) {
                                if (scope.percentRemaining * -1 > 0) {
                                    if (incOverage < (scope.percentRemaining * -1) / 50) {
                                        if (incOverage === 0) {
                                            $rootScope.$emit('ute-usageDialAnimateStroke-overageHit');
                                            ctx.clearRect(0, 0, usageDialService.getConfig().basic.width, usageDialService.getConfig().basic.height);
                                        }
                                    }
                                    else {
                                        dialAnimationComplete(radialDialInterval);
                                    }
                                }
                                else if (scope.percentRemaining * 1 === 0) {
                                    dialAnimationComplete(radialDialInterval);
                                    ctx.clearRect(0, 0, usageDialService.getConfig().basic.width, usageDialService.getConfig().basic.height);
                                }
                                else if (scope.percentRemaining * 1 === 100) {
                                    drawArc();
                                    dialAnimationComplete(radialDialInterval);
                                }
                            }
                            else if (inc > 0) {
                                speed = speed + velocityIncrement;
                                ctx.clearRect(0, 0, usageDialService.getConfig().basic.width, usageDialService.getConfig().basic.height);
                                drawArc();
                            }
                            //Overage animation is not included
                            if (inc < 0) {
                                dialAnimationComplete(radialDialInterval);
                            }
                        }, speed);
                    }
                };
            }
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            'use strict';
            var UsageDialProvider = (function () {
                /* @ngInject */
                function UsageDialProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            controllerName: 'ute.usage.dial.controller',
                            templateUrl: 'module/uteUsageDial/usageDial.partial.html',
                            animatedStrokeTemplateUrl: 'module/uteUsageDial/usageDialAnimatedStroke.partial.html',
                            height: 210,
                            width: 210,
                            radius: 95,
                            strokeWidth: 10,
                            nominalColor: '#538711',
                            warningColor: '#FFE600',
                            overageColor: '#F59829'
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $translate) {
                        _this.$injector = $injector;
                        _this.$translate = $translate;
                        return {
                            getConfig: _this.getConfig,
                            $injector: _this.$injector
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {any}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$translate'
                    ];
                }
                UsageDialProvider.$inject = [];
                return UsageDialProvider;
            }());
            angular.module('ute.usage.dial').provider('ute.usage.dial', UsageDialProvider);
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserHideIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserHideIfAnyGranted ? scope.uteUserHideIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                _this.$animate[value ? 'addClass' : 'removeClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-hide-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserHideIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function () {
                    /* @ngInject */
                    function UserTest(userService, $animate) {
                        var _this = this;
                        this.userService = userService;
                        this.$animate = $animate;
                        this.scope = {
                            uteUserShowIfAnyGranted: '@'
                        };
                        this.restrict = 'A';
                        this.multiElement = true;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.rolesArray, _this.userService.getUserType());
                        };
                        this.linkFn = function (scope, instanceElement) {
                            _this.rolesArray = scope.uteUserShowIfAnyGranted ? scope.uteUserShowIfAnyGranted.split(',').map(function (s) { return s.trim(); }) : [];
                            scope.$watch(_this.test, function (value) {
                                // console.log('wwwwwwwwwwwwwwwwww', this.rolesArray, value, scope);
                                _this.$animate[value ? 'removeClass' : 'addClass'](instanceElement, UserTest.NG_HIDE_CLASS, {
                                    tempClasses: UserTest.NG_HIDE_IN_PROGRESS_CLASS
                                });
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        var directive = function (userService, $animate) { return new UserTest(userService, $animate); };
                        directive.$inject = ['ute.common.user.service', '$animate'];
                        return directive;
                    };
                    UserTest.NG_HIDE_CLASS = 'ng-hide';
                    UserTest.NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
                    return UserTest;
                }());
                /**
                 * <div ute-user-show-if-any-granted='role1,role2'> directive
                 */
                angular.module('ute.common.user').directive('uteUserShowIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && _.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-any-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfAnyGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        this.userService = userService;
                        this.test = this.userService.isSigned;
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.scope = {
                            roles: '@'
                        };
                        this.linkFn = function (scope) {
                            scope.rolesArray = scope.roles ? scope.roles.split(',').map(function (s) { return s.trim(); }) : [];
                        };
                        this.controller = Controller;
                        this.link = this.linkFn;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.test = function () {
                            return _this.userService.isSigned() && !_.include(_this.$scope.rolesArray, _this.userService.getUserType());
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-granted roles='consumer,dealer'> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotGranted', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserTest = (function (_super) {
                    __extends(UserTest, _super);
                    function UserTest() {
                        _super.call(this);
                        this.controller = Controller;
                    }
                    UserTest.factory = function () {
                        return function () { return new UserTest(); };
                    };
                    return UserTest;
                }(directives.UserTestAbstract));
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService) {
                        var _this = this;
                        this.userService = userService;
                        this.test = function () { return !_this.userService.isSigned(); };
                    }
                    Controller.$inject = ['ute.common.user.service'];
                    return Controller;
                }());
                /**
                 * <ute-user-if-not-logged-in> directive
                 */
                angular.module('ute.common.user').directive('uteUserIfNotLoggedIn', UserTest.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserInfo = (function () {
                    function UserInfo() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.template = '{{user.getUserInfo()}}';
                        this.controller = Controller;
                    }
                    UserInfo.factory = function () {
                        return function () { return new UserInfo(); };
                    };
                    return UserInfo;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.getUserInfo = function () {
                            try {
                                return _.get(_this.userService.getUser(), _this.$scope.field) || _this.userService['get' + _this.capitalize(_this.$scope.field)]();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * TODO 1. move it to ute common utils
                         * TODO 2. migrate to lodash 4.x and use _.upperFirst
                         * @param s
                         * @returns {string}
                         */
                        this.capitalize = function (s) {
                            return s && s[0].toUpperCase() + s.slice(1);
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-logged-in-user-info field='userEmail'> directive
                 * <ute-user-logged-in-user-info field='userRole'> directive
                 */
                angular.module('ute.common.user').directive('uteUserLoggedInUserInfo', UserInfo.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var user;
        (function (user) {
            var directives;
            (function (directives) {
                'use strict';
                var UserSignout = (function () {
                    function UserSignout() {
                        this.restrict = 'E';
                        this.controllerAs = 'user';
                        this.scope = {
                            field: '@'
                        };
                        this.transclude = true;
                        this.template = '<div data-ng-click="user.userSignout()"><ng-transclude></ng-transclude></div>';
                        this.controller = Controller;
                    }
                    UserSignout.factory = function () {
                        return function () { return new UserSignout(); };
                    };
                    return UserSignout;
                }());
                var Controller = (function () {
                    /* @ngInject */
                    function Controller(userService, $scope) {
                        var _this = this;
                        this.userService = userService;
                        this.$scope = $scope;
                        this.userSignout = function () {
                            try {
                                return _this.userService.signout();
                            }
                            catch (e) {
                            }
                        };
                    }
                    Controller.$inject = ['ute.common.user.service', '$scope'];
                    return Controller;
                }());
                /**
                 * <ute-user-signout> directive
                 */
                angular.module('ute.common.user').directive('uteUserSignout', UserSignout.factory());
            })(directives = user.directives || (user.directives = {}));
        })(user = common.user || (common.user = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount_1) {
                var details;
                (function (details) {
                    'use strict';
                    var WirelessProductDiscountDetailsController = (function () {
                        /* @ngInject */
                        function WirelessProductDiscountDetailsController(wirelessProductDiscountDetailsService) {
                            this.wirelessProductDiscountDetailsService = wirelessProductDiscountDetailsService;
                            this.hasWirelessDiscounts = -1;
                            this.lang = this.wirelessProductDiscountDetailsService.getLanguage();
                        }
                        WirelessProductDiscountDetailsController.prototype.hasEffectiveDate = function (discount) {
                            if (discount.effectiveDate) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        WirelessProductDiscountDetailsController.prototype.hasExpiryDate = function (discount) {
                            if (discount.expiryDate && discount.expiryDate !== '') {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        WirelessProductDiscountDetailsController.prototype.discountsFilter = function (item) {
                            if (item.expiryDate && item.expiryDate !== '') {
                                var currentDate = new Date();
                                var discountExpiryDate = new Date(item.expiryDate);
                                discountExpiryDate.setDate(discountExpiryDate.getDate() + 1);
                                return (discountExpiryDate >= currentDate);
                            }
                            return true;
                        };
                        WirelessProductDiscountDetailsController.controllerName = 'ute.wireless.product.discount.details.directive.controller';
                        WirelessProductDiscountDetailsController.$inject = ['ute.wireless.product.discount.details.service'];
                        return WirelessProductDiscountDetailsController;
                    }());
                    details.WirelessProductDiscountDetailsController = WirelessProductDiscountDetailsController;
                    angular.module('ute.wireless.product.discount.details').controller('ute.wireless.product.discount.details.directive.controller', WirelessProductDiscountDetailsController);
                })(details = discount_1.details || (discount_1.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                    var WirelessProductDiscountDetails = (function () {
                        /* @ngInject */
                        function WirelessProductDiscountDetails(wirelessProductDiscountDetailsService) {
                            this.wirelessProductDiscountDetailsService = wirelessProductDiscountDetailsService;
                            this.restrict = 'E';
                            this.scope = {
                                productDiscountDetails: '='
                            };
                            this.templateUrl = this.wirelessProductDiscountDetailsService.getConfig().basic.templateUrl;
                            this.controller = this.wirelessProductDiscountDetailsService.getConfig().basic.controllerName;
                            this.controllerAs = 'wirelessProductDiscountDetails';
                            //this.link = this.linkFn;
                        }
                        //link: ng.IDirectiveLinkFn;
                        /* link: ng.IDirectiveLinkFn;*/
                        /**
                         * @returns {function(ute.wireless.product.discount.details.IWirelessProductDiscountDetailsService): ute.wireless.product.discount.details.WirelessProductDiscountDetails}
                         */
                        WirelessProductDiscountDetails.factory = function () {
                            var directive = function (wirelessProductDiscountDetailsService) { return new WirelessProductDiscountDetails(wirelessProductDiscountDetailsService); };
                            directive.$inject = ['ute.wireless.product.discount.details.service'];
                            return directive;
                        };
                        return WirelessProductDiscountDetails;
                    }());
                    angular.module('ute.wireless.product.discount.details').directive('uteWirelessProductDiscountDetails', WirelessProductDiscountDetails.factory());
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var wireless;
    (function (wireless) {
        var product;
        (function (product) {
            var discount;
            (function (discount) {
                var details;
                (function (details) {
                    'use strict';
                    var WirelessProductDiscountDetailsProvider = (function () {
                        /* @ngInject */
                        function WirelessProductDiscountDetailsProvider() {
                            var _this = this;
                            this.config = {
                                basic: {
                                    controllerName: 'ute.wireless.product.discount.details.directive.controller',
                                    templateUrl: 'module/wirelessProductDiscountDetailsDirective/wirelessProductDiscountDetails.html'
                                }
                            };
                            /* @ngInject */
                            this.$get = function ($injector) {
                                _this.$injector = $injector;
                                return {
                                    getConfig: _this.getConfig,
                                    getLanguage: _this.getLanguage
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                return true;
                            };
                            this.getLanguage = function () {
                                var languageService = _this.$injector.get('ute.blocks.language.switcher');
                                return languageService.getCurrentLanguage();
                            };
                            /**
                             * @returns {any}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            this.$get.$inject = [
                                '$injector'
                            ];
                        }
                        WirelessProductDiscountDetailsProvider.$inject = [];
                        WirelessProductDiscountDetailsProvider.serviceName = 'ute.wireless.product.discount.details.service';
                        return WirelessProductDiscountDetailsProvider;
                    }());
                    angular.module('ute.wireless.product.discount.details').provider(WirelessProductDiscountDetailsProvider.serviceName, WirelessProductDiscountDetailsProvider);
                })(details = discount.details || (discount.details = {}));
            })(discount = product.discount || (product.discount = {}));
        })(product = wireless.product || (wireless.product = {}));
    })(wireless = ute.wireless || (ute.wireless = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffersController = (function () {
                /* @ngInject */
                function ActionsOffersController(actionsOffersService, languageService, translate, $modal, $state) {
                    var _this = this;
                    this.actionsOffersService = actionsOffersService;
                    this.languageService = languageService;
                    this.translate = translate;
                    this.$modal = $modal;
                    this.$state = $state;
                    this.inboundsCopyList = [];
                    this.outboundsCopyList = [];
                    this.filteredList = [];
                    this.expiredSMS = false;
                    this.expiredEmail = false;
                    this.expiredDirectMail = false;
                    this.expiredTeleMar = false;
                    this.displayInboundsList = [];
                    this.displayOutboundsList = [];
                    this.displayActionsList = [];
                    this.prevDispState = [];
                    this.activeTreatmnentsFailed = false;
                    this.treatmentHistoryFailed = false;
                    this.loadingActions = false;
                    this.loadingOffers = false;
                    this.declineDivIndex = -1;
                    this.declineDivTreatment = null;
                    this.loadingDisposition = {};
                    this.loadHistory = false;
                    this.offersPageLanguage = this.actionsOffersService.getLanguage();
                    this.$state = $state;
                    this.getTreatmentDetails();
                    this.accepted = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                    this.interested = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                    this.declined = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                    this.yes = this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.yes');
                    this.no = this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.no');
                    this.hideFullDetails = this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.hideFullDetails');
                    this.tabData = [{
                            content: this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.inbound'),
                            route: this.actionsOffersService.getConfig().constants.inbounds,
                        }, {
                            content: this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.outbound'),
                            route: this.actionsOffersService.getConfig().constants.outbounds,
                        }];
                    this.languageService.registerOnDataChangeHandler(function (lang) {
                        if (_this.offersPageLanguage === lang || _this.$state.current.name === _this.actionsOffersService.getConfig().constants.oneViewDashboard) {
                            return null;
                        }
                        _this.offersPageLanguage = lang;
                        _this.searchedValue = '';
                        _this.getTreatmentDetails();
                        _this.tabData[0].content = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.inbound');
                        _this.tabData[1].content = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.outbound');
                        _this.accepted = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                        _this.interested = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                        _this.declined = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                        _this.yes = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.yes');
                        _this.no = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.no');
                        _this.hideFullDetails = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.hideFullDetails');
                        return null;
                    }, 'ute.actions.offers.directive.controller');
                    this.offersPageLanguage = this.actionsOffersService.getLanguage();
                    this.checkboxItems = [this.actionsOffersService.getConfig().constants.interestedCase,
                        this.actionsOffersService.getConfig().constants.availableCase,
                        this.actionsOffersService.getConfig().constants.acceptedCase,
                        this.actionsOffersService.getConfig().constants.declinedCase,
                        this.actionsOffersService.getConfig().constants.expiredCase];
                    this.selectedItems = [this.actionsOffersService.getConfig().constants.interested,
                        this.actionsOffersService.getConfig().constants.available,
                        this.actionsOffersService.getConfig().constants.accepted,
                        this.actionsOffersService.getConfig().constants.declined];
                    this.checkBoxModel = {
                        'Interested': true,
                        'Available': true,
                        'Accepted': true,
                        'Declined': true,
                        'Expired': false
                    };
                    this.outboundCheckboxItems = [this.actionsOffersService.getConfig().constants.sms,
                        this.actionsOffersService.getConfig().constants.email,
                        this.actionsOffersService.getConfig().constants.directmail,
                        this.actionsOffersService.getConfig().constants.telemarketing,
                        this.actionsOffersService.getConfig().constants.expiredCase];
                    this.outboundSelectedItems = [this.actionsOffersService.getConfig().constants.sms.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.email.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.directmail.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.telemarketing.toLowerCase()];
                    this.outboundCheckBoxModel = {
                        'SMS': true,
                        'Email': true,
                        'Direct Mail': true,
                        'Telemarketing': true,
                        'Expired': false
                    };
                    this.expiredInt = false;
                    this.expiredAcc = false;
                    this.expiredDec = false;
                }
                /*method for calling activeTreatments API*/
                ActionsOffersController.prototype.getTreatmentDetails = function () {
                    var _this = this;
                    this.loadingOffers = true;
                    this.loadingActions = true;
                    this.actionsOffersService.getProductTreatment().then(function (res) {
                        _this.displayActionsList = [];
                        _this.displayInboundsList = [];
                        _this.displayOutboundsList = [];
                        _this.inboundsCopyList = [];
                        _this.outboundsCopyList = [];
                        _this.productTreatments = res;
                        var dynCheckboxItems = [_this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.available').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined').toLowerCase()];
                        for (var _i = 0, _a = res.getProductTreatmentDetailsList; _i < _a.length; _i++) {
                            var entry = _a[_i];
                            /* PCR #22 changes BEGIN
                            if lastDispositionCode is 'Acknowledge' or any other dynamic value, then it should be displayed under
                            'Accepted' category and lastDispositionCode should displayed at 'Acknowledge on ...(date)' */
                            if (entry.lastDispositionCode) {
                                entry.displayDisposition = entry.lastDispositionCode;
                            }
                            //changes for dynamic button display
                            entry.dynamicValues = entry.dispositionsInbound.filter(function (obj) { return dynCheckboxItems.indexOf(obj.toLowerCase()) === -1; });
                            //PCR #22 changes END
                            if ((entry.treatmentGroup.toLowerCase() === _this.actionsOffersService.getConfig().constants.offer || entry.treatmentGroup.toLowerCase() === _this.actionsOffersService.getConfig().constants.treatment) &&
                                _this.selectedItems.indexOf(entry.lastDispositionCode.toLowerCase()) >= 0) {
                                _this.inboundsCopyList.push(entry);
                            }
                            else if (entry.treatmentGroup.toLowerCase() === _this.actionsOffersService.getConfig().constants.action) {
                                _this.displayActionsList.push(entry);
                            }
                        }
                        _this.ecid = _this.productTreatments.ecid;
                        if (!_this.loadHistory) {
                            _this.makeTreatmentHistoryCall(_this.ecid);
                        }
                        _this.displayInboundsList = _this.inboundsCopyList;
                        _this.displayOutboundsList = _this.outboundsCopyList;
                        _this.actionsOffersService.readDispositionCache(_this.ecid).then(function (res) {
                            if (res.dispositionStatusMap != null) {
                                _this.actionsOffersService.setStatusMap(res.dispositionStatusMap);
                            }
                        }, function (errRes) {
                            console.log('err rc ');
                        });
                        _this.loadingActions = false;
                        _this.activeTreatmnentsFailed = false;
                    }, function (errRes) {
                        _this.loadingActions = false;
                        _this.activeTreatmnentsFailed = true;
                        _this.errorCode = '';
                        _this.errorDesc = '';
                        var data;
                        if (!_this.loadHistory) {
                            _this.displayActionsList = [];
                            _this.displayInboundsList = [];
                            _this.displayOutboundsList = [];
                            _this.inboundsCopyList = [];
                            _this.outboundsCopyList = [];
                            _this.makeTreatmentHistoryCall('');
                        }
                        _this.displayInboundsList = _this.inboundsCopyList;
                        _this.displayOutboundsList = _this.outboundsCopyList;
                        if (errRes.data.errorCode !== undefined) {
                            data = angular.fromJson(errRes.data);
                            if (errRes.status === 555) {
                                if (data.errorCategory === _this.actionsOffersService.getConfig().constants.rtdm) {
                                    _this.errorDesc = data.errorDesc;
                                }
                                else if (data.errorCategory === _this.actionsOffersService.getConfig().constants.mw ||
                                    data.errorCategory === _this.actionsOffersService.getConfig().constants.other) {
                                    _this.errorCode = data.errorCode;
                                }
                            }
                        }
                    });
                };
                /*method for calling treatmentHistory API*/
                ActionsOffersController.prototype.makeTreatmentHistoryCall = function (ecid) {
                    var _this = this;
                    this.loadHistory = true;
                    this.actionsOffersService.getProductTreatmentHistory(ecid).then(function (res) {
                        _this.productTreatmentsHistory = res;
                        for (var _i = 0, _a = res.inBoundOffersList; _i < _a.length; _i++) {
                            var entry = _a[_i];
                            /* PCR #22 changes BEGIN
                            if lastDispositionCode is 'Acknowledge' or any other dynamic value, then it should be displayed under
                            'Accepted' category and lastDispositionCode should displayed at 'Acknowledge on ...(date)' */
                            if (entry.lastDispositionCode) {
                                if (_this.selectedItems.indexOf(entry.lastDispositionCode.toLowerCase()) < 0) {
                                    entry.displayDisposition = entry.lastDispositionCode;
                                    entry.lastDispositionCode = _this.actionsOffersService.getConfig().constants.acceptedCase;
                                    entry.dynamicValue = true;
                                }
                                else {
                                    entry.displayDisposition = entry.lastDispositionCode;
                                    entry.dynamicValue = false;
                                }
                            }
                            //PCR #22 changes END
                            if (_this.selectedItems.indexOf(entry.lastDispositionCode.toLowerCase()) >= 0) {
                                if (entry.lastDispositionCode.toLowerCase() === _this.actionsOffersService.getConfig().constants.interested) {
                                    if (entry.expired) {
                                        _this.inboundsCopyList.push(entry);
                                    }
                                }
                                else {
                                    _this.inboundsCopyList.push(entry);
                                }
                            }
                        }
                        for (var _b = 0, _c = res.outBoundOffersList; _b < _c.length; _b++) {
                            var entry = _c[_b];
                            if (_this.outboundSelectedItems.indexOf(entry.channelName.toLowerCase()) >= 0) {
                                _this.outboundsCopyList.push(entry);
                            }
                        }
                        _this.loadingOffers = false;
                        _this.treatmentHistoryFailed = false;
                        _this.loadHistory = false;
                    }, function (err) {
                        _this.loadingOffers = false;
                        _this.treatmentHistoryFailed = true;
                        _this.loadHistory = false;
                    });
                };
                ActionsOffersController.prototype.getDispStatus = function (treatmentId) {
                    return this.actionsOffersService.getDispStatus(treatmentId);
                };
                ActionsOffersController.prototype.showDeclineDiv = function (index, treatmentId) {
                    if (this.declineDivIndex !== -1) {
                        this.restoreDispState();
                    }
                    this.declineDivIndex = index;
                    this.declineDivTreatment = treatmentId;
                    this.prevDispState[treatmentId] = this.actionsOffersService.getDispStatus(treatmentId);
                    this.actionsOffersService.updateStatusMap(treatmentId, this.actionsOffersService.getConfig().constants.tempdeclined);
                };
                ActionsOffersController.prototype.hideDeclineDiv = function () {
                    this.declineDivIndex = -1;
                    this.declineDivTreatment = null;
                };
                ActionsOffersController.prototype.restoreDispState = function () {
                    if (this.declineDivTreatment != null) {
                        this.actionsOffersService.updateStatusMap(this.declineDivTreatment, this.prevDispState[this.declineDivTreatment]);
                        this.hideDeclineDiv();
                    }
                };
                ActionsOffersController.prototype.displayDiv = function (index) {
                    return this.declineDivIndex === index;
                };
                ActionsOffersController.prototype.updateDispositionMethod = function (treatment, dispositionCode, dispositionReason) {
                    var _this = this;
                    this.actionsOffersService.updateStatusMap(treatment.treatmentId, dispositionCode);
                    this.loadingDisposition[treatment.treatmentId] = true;
                    this.actionsOffersService.updateDispositions(treatment, dispositionCode, dispositionReason).then(function (res) {
                        _this.updateDisposition = res;
                        _this.loadingDisposition[treatment.treatmentId] = false;
                    }, function (err) {
                        console.log(err);
                        _this.loadingDisposition[treatment.treatmentId] = false;
                    });
                };
                ActionsOffersController.prototype.declineDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.hideDeclineDiv();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                ActionsOffersController.prototype.restoreAndUpdateDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.restoreDispState();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                ActionsOffersController.prototype.toggleAll = function () {
                    var toggleStatus = this.isAllSelected;
                    for (var _i = 0, _a = this.checkboxItems; _i < _a.length; _i++) {
                        var entry = _a[_i];
                        this.checkBoxModel[entry] = toggleStatus;
                    }
                };
                ActionsOffersController.prototype.optionToggled = function () {
                    for (var _i = 0, _a = this.checkboxItems; _i < _a.length; _i++) {
                        var entry = _a[_i];
                        if (this.checkBoxModel[entry] === false) {
                            this.isAllSelected = false;
                        }
                    }
                };
                ActionsOffersController.prototype.toggleAllOutbound = function () {
                    var toggleStatus = this.isAllSelectedOutbound;
                    for (var _i = 0, _a = this.outboundCheckboxItems; _i < _a.length; _i++) {
                        var entry = _a[_i];
                        this.outboundCheckBoxModel[entry] = toggleStatus;
                    }
                };
                ActionsOffersController.prototype.optionToggledOutbound = function () {
                    for (var _i = 0, _a = this.outboundCheckboxItems; _i < _a.length; _i++) {
                        var entry = _a[_i];
                        if (this.outboundCheckBoxModel[entry] === false) {
                            this.isAllSelectedOutbound = false;
                        }
                    }
                };
                ActionsOffersController.prototype.setPanelValues = function () {
                    this.offerPanelShow = {
                        'Interested': false,
                        'Available': false,
                        'Accepted': false,
                        'Declined': false
                    };
                };
                ActionsOffersController.prototype.isHavingExpired = function (offerType) {
                    if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.interested && this.expiredInt) {
                        return true;
                    }
                    else if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.accepted && this.expiredAcc) {
                        return true;
                    }
                    else if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.declined && this.expiredDec) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                ActionsOffersController.prototype.isHavingExpiredOutbound = function (offerType) {
                    if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.sms.toLowerCase() && this.expiredSMS) {
                        return true;
                    }
                    else if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.email.toLowerCase() && this.expiredEmail) {
                        return true;
                    }
                    else if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.directmail.toLowerCase() && this.expiredDirectMail) {
                        return true;
                    }
                    else if (offerType.toLowerCase() === this.actionsOffersService.getConfig().constants.telemarketing.toLowerCase() && this.expiredTeleMar) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                /*method for search functionality*/
                ActionsOffersController.prototype.searchOffers = function (searchedValue) {
                    var state = this.actionsOffersService.getState();
                    this.filteredList = [];
                    if (searchedValue) {
                        searchedValue = searchedValue.toLowerCase();
                        if (state === this.actionsOffersService.getConfig().constants.inbounds) {
                            this.filteredList = _.filter(this.inboundsCopyList, function (item) {
                                return (item.treatmentCode && item.treatmentCode.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentType && item.treatmentType.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentDescription && item.treatmentDescription.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentKeywords && item.treatmentKeywords.toLowerCase().indexOf(searchedValue) >= 0);
                            });
                            this.displayInboundsList = this.filteredList;
                        }
                        else if (state === this.actionsOffersService.getConfig().constants.outbounds) {
                            //this.filteredList = this.getFilteredList(this.outboundsCopyList, searchedValue);
                            this.filteredList = _.filter(this.outboundsCopyList, function (item) {
                                //return ~item.treatmentCode.toLowerCase().indexOf(searchedValue) || ~item.treatmentType.toLowerCase().indexOf(searchedValue) ||
                                //~item.treatmentDescription.toLowerCase().indexOf(searchedValue) || ~item.treatmentKeywords.toLowerCase().indexOf(searchedValue);
                                return (item.treatmentCode && item.treatmentCode.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentType && item.treatmentType.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentDescription && item.treatmentDescription.toLowerCase().indexOf(searchedValue) >= 0) ||
                                    (item.treatmentKeywords && item.treatmentKeywords.toLowerCase().indexOf(searchedValue) >= 0);
                            });
                            this.displayOutboundsList = this.filteredList;
                        }
                    }
                };
                /*Save this alternate code for future use for search functionality in Offers page */
                /*getFilteredList(list:any[], searchedValue:string): any {
                 let finalList: any[] = [];
                 for (let entry of list) {
                 /!* if (entry.treatmentTitle.toLowerCase().indexOf(searchedValue.toLowerCase()) >0 ||
                 entry.treatmentType.toLowerCase().indexOf(searchedValue.toLowerCase()) >0 ||
                 entry.treatmentDescription.toLowerCase().indexOf(searchedValue.toLowerCase()) >0 ||
                 entry.treatmentGroup.toLowerCase().indexOf('Action'.toLowerCase()) >0) {
                 finalList.push(entry);
                 }*!/
        
                 if (entry.treatmentTitle.toLowerCase().indexOf(searchedValue.toLowerCase()) >=0) {
                 finalList.push(entry);
                 }
                 else if (entry.treatmentType.toLowerCase().indexOf(searchedValue.toLowerCase()) >=0) {
                 finalList.push(entry);
                 }
                 else if (entry.treatmentDescription.toLowerCase().indexOf(searchedValue.toLowerCase()) >=0) {
                 finalList.push(entry);
                 }
                 /!*else if (entry.treatmentGroup === 'Action') {
                 finalList.push(entry);
                 }*!/
                 }
                 return finalList;
                 }*/
                /*method for displaying original data when search text is cleared*/
                ActionsOffersController.prototype.searchNothingDefault = function () {
                    this.displayInboundsList = this.inboundsCopyList;
                    this.displayOutboundsList = this.outboundsCopyList;
                };
                ActionsOffersController.prototype.clearSearchbox = function () {
                    this.searchedValue = '';
                    this.checkBoxModel = {
                        'Interested': true,
                        'Available': true,
                        'Accepted': true,
                        'Declined': true,
                        'Expired': false
                    };
                    this.outboundCheckBoxModel = {
                        'SMS': true,
                        'Email': true,
                        'Direct Mail': true,
                        'Telemarketing': true,
                        'Expired': false
                    };
                    this.searchNothingDefault();
                };
                /*method for avoiding the display of panels if no data present for respective offerType*/
                ActionsOffersController.prototype.hidePanels = function (offersList, disposition, filterValue) {
                    /*let result = offersList.filter(x => x.lastDispositionCode == disposition);*/
                    var _this = this;
                    var state = this.actionsOffersService.getState();
                    var result = [];
                    disposition = disposition.toLowerCase();
                    if (state === this.actionsOffersService.getConfig().constants.outbounds) {
                        result = offersList.filter(function (x) { return filterValue === undefined ?
                            ((x.channelName && x.channelName.toLowerCase() === disposition) && (x.expired ? _this.outboundCheckBoxModel[_this.actionsOffersService.getConfig().constants.expiredCase] : true)) :
                            ((x.lobDescription === filterValue) && (x.channelName && x.channelName.toLowerCase() === disposition) && (x.expired ? _this.outboundCheckBoxModel[_this.actionsOffersService.getConfig().constants.expiredCase] : true)); });
                    }
                    else {
                        result = offersList.filter(function (x) { return filterValue === undefined ?
                            ((x.lastDispositionCode && x.lastDispositionCode.toLowerCase() === disposition) && (x.expired ? _this.checkBoxModel[_this.actionsOffersService.getConfig().constants.expiredCase] : true)) :
                            ((x.lobDescription === filterValue) && (x.lastDispositionCode && x.lastDispositionCode.toLowerCase() === disposition) && (x.expired ? _this.checkBoxModel[_this.actionsOffersService.getConfig().constants.expiredCase] : true)); });
                    }
                    return result.length > 0;
                };
                /*method for displaying the panel popup on click of non-expired offers*/
                ActionsOffersController.prototype.selectPanel = function (index, selectedTreatment) {
                    this.restoreDispState();
                    if (this.selectedPanelIndex === index) {
                        this.selectedPanelIndex = -1;
                    }
                    else if (selectedTreatment !== null && selectedTreatment.treatmentGroup !== undefined &&
                        selectedTreatment.lastDispositionCode !== undefined &&
                        (selectedTreatment.treatmentGroup.toLowerCase() === this.actionsOffersService.getConfig().constants.offer || selectedTreatment.treatmentGroup.toLowerCase() === this.actionsOffersService.getConfig().constants.treatment) &&
                        (selectedTreatment.lastDispositionCode.toLowerCase() === this.actionsOffersService.getConfig().constants.available
                            || selectedTreatment.lastDispositionCode.toLowerCase() === this.actionsOffersService.getConfig().constants.interested) &&
                        !selectedTreatment.expired) {
                        this.selectedPanelIndex = -1;
                        var modal = this.$modal.open({
                            templateUrl: this.actionsOffersService.getConfig().offerPanel.templateUrl,
                            controller: 'ute.actions.offers.widget.panel.controller',
                            controllerAs: 'offersWidgetPanel',
                            backdrop: 'static',
                            size: 'offer',
                            keyboard: true,
                            backdropClass: 'bkg-model',
                            resolve: {
                                selectedTreatment: function () { return selectedTreatment; }
                            }
                        });
                    }
                    else {
                        this.selectedPanelIndex = index;
                    }
                };
                ActionsOffersController.prototype.haveMoreActionContent = function (treatmentId) {
                    var elem = document.getElementById('action-block-content-' + treatmentId);
                    return (elem && !isNaN(elem.offsetHeight)) ? (elem.offsetHeight < elem.scrollHeight) : false;
                };
                ActionsOffersController.prototype.toggleDetails = function (treatmentId, showMore) {
                    var actionBlock = angular.element(document.querySelector('#action-block-' + treatmentId));
                    var actionBlockContent = angular.element(document.querySelector('#action-block-content-' + treatmentId));
                    if (showMore) {
                        actionBlock.addClass('ao-height-auto');
                        actionBlockContent.addClass('ao-height-auto');
                        document.getElementById('show-less-' + treatmentId).innerHTML = '<span>' + this.hideFullDetails + '</span> <span class="more-less-icon"> <i class="rui-icon-chevron-up"></i> </span>';
                    }
                    else {
                        actionBlock.removeClass('ao-height-auto');
                        actionBlockContent.removeClass('ao-height-auto');
                        document.getElementById('show-less-' + treatmentId).innerHTML = '';
                    }
                };
                /*method for removing empty lobDescription for dropdown display*/
                ActionsOffersController.prototype.filterLobDescList = function (input) {
                    var filteredArray = [];
                    for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
                        var entry = input_1[_i];
                        if (entry.lobDescription !== null && entry.lobDescription !== undefined && entry.lobDescription !== '' && entry.lobDescription.trim() !== '') {
                            filteredArray.push(entry);
                        }
                    }
                    return filteredArray;
                };
                ActionsOffersController.controllerName = 'ute.actions.offers.directive.controller';
                ActionsOffersController.$inject = ['ute.actions.offers.service', 'ute.blocks.language.switcher', '$translate', '$modal', '$state'];
                return ActionsOffersController;
            }());
            offers.ActionsOffersController = ActionsOffersController;
            angular.module('ute.actions.offers').controller('ute.actions.offers.directive.controller', ActionsOffersController);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffers = (function () {
                /* @ngInject */
                function ActionsOffers(actionsOffersService) {
                    this.actionsOffersService = actionsOffersService;
                    this.restrict = 'E';
                    this.templateUrl = this.actionsOffersService.getConfig().main.templateUrl;
                    this.controller = this.actionsOffersService.getConfig().main.controllerName;
                    this.controllerAs = 'actionsOffers';
                    /**
                     * @param scope
                     */
                    this.linkFn = function () {
                        //linkFn
                    };
                    this.link = this.linkFn;
                }
                /* link: ng.IDirectiveLinkFn;*/
                /**
                 * @returns {function(ute.actions.offers.IActionsOffersService): ute.actions.offers.actionsOffers}
                 */
                ActionsOffers.factory = function () {
                    var directive = function (actionsOffersService) { return new ActionsOffers(actionsOffersService); };
                    directive.$inject = ['ute.actions.offers.service'];
                    return directive;
                };
                return ActionsOffers;
            }());
            angular.module('ute.actions.offers').directive('uteActionsOffers', ActionsOffers.factory());
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            angular.module('ute.actions.offers').filter('remove_spaces', removeSpaces);
            /*filter for removing empty spaces in a string*/
            function removeSpaces() {
                return function (input) {
                    if (input) {
                        return input.replace(/\s+/g, '');
                    }
                };
            }
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffersProvider = (function () {
                /* @ngInject */
                function ActionsOffersProvider() {
                    var _this = this;
                    this.statusMap = [];
                    this.config = offers.ActionsOffersConfig();
                    /* private config: IActionsOffersConfig = {
                       widget: {
                         actionsOffersWidgetState: 'actionsOffersWidget',
                         treatmentApiUrl: 'v1/actionsOffers/GetProductTreatmentResponseUTE',
                         controllerName: 'ute.actions.offers.widget.directive.controller',
                         templateUrl: 'module/actionsOffers/actionsOffersWidgetDirective/actionsOffersWidget.html',
                         updateDispositionApiUrl: 'v1/actionsOffers/UpdateDispositionResponseUTE',
                         readDispositionCacheApiUrl: 'v1/actionsOffers/ReadDispositionCache'
                       },
                       offerPanel: {
                         offersWidgetPanelState: 'offersWidgetPanel',
                         controllerName: 'ute.actions.offers.widget.panel.controller',
                         templateUrl: 'module/actionsOffers/actionsOffersWidgetDirective/offersWidgetPanel.html',
                         colorHexCodes: [ '#008fb6', '#E4BC40', '#662d91', '#7aaa39', '#ac0067', '#2926ab', '#cd5e40', '#2b464c', '#bbb62a', '#317d59' ]
                       },
                       main: {
                         actionsOffersMainState: 'actionsOffers',
                         mainControllerName: 'ute.actions.offers.main.controller',
                         mainTemplateUrl: 'module/actionsOffers/actionsOffersMain.view.html',
                         controllerName: 'ute.actions.offers.directive.controller',
                         templateUrl: 'module/actionsOffers/actionsOffersDirective/actionsOffers.html',
                         treatmentApiUrl: 'v1/cmt/getActiveTreatments',
                         treatemntHistoryApiUrl: 'v1/cmt/getTreatmentHistory',
                         updateDispositionApiUrl: 'v1/cmt/updateDisposition',
                         readDispositionCacheApiUrl: 'v1/cmt/readDispositionStatus',
                         cancelState: 'oneViewDashboard'
                       },
                       inbounds: {
                         stateName: 'inbounds',
                         templateUrl: 'module/actionsOffers/actionsOffersBounds/offers-inbounds.html',
                         parentState: 'actionsOffers'
                       },
                       outbounds: {
                         stateName: 'outbounds',
                         templateUrl: 'module/actionsOffers/actionsOffersBounds/offers-outbounds.html',
                         parentState: 'actionsOffers'
                       }
                     };*/
                    /* @ngInject */
                    this.$get = function (messagesService, $injector, $http, $state, sessionStorage, activeTreatmentsService) {
                        _this.$http = $http;
                        _this.$state = $state;
                        _this.$injector = $injector;
                        _this.securityService = $injector.get('ute.common.security.service');
                        _this.encryptionService = $injector.get('ute.common.encryption.service');
                        _this.sessionStorage = sessionStorage;
                        _this.messagesService = messagesService;
                        _this.activeTreatmentsService = activeTreatmentsService;
                        return {
                            getConfig: _this.getConfig,
                            getLanguage: _this.getLanguage,
                            getProductTreatment: _this.getProductTreatment,
                            getProductTreatmentHistory: _this.getProductTreatmentHistory,
                            getAccountNumber: _this.getAccountNumber,
                            goToActionsOffers: _this.goToActionsOffers,
                            getActionsOffersState: _this.getActionsOffersState,
                            getActionsOffersWidgetState: _this.getActionsOffersWidgetState,
                            getRetriveTreatmentInfo: _this.getRetriveTreatmentInfo,
                            getRetriveTreatmentHistoryInfo: _this.getRetriveTreatmentHistoryInfo,
                            updateDispositions: _this.updateDispositions,
                            readDispositionCache: _this.readDispositionCache,
                            getState: _this.getState,
                            getStatusMap: _this.getStatusMap,
                            setStatusMap: _this.setStatusMap,
                            updateStatusMap: _this.updateStatusMap,
                            getDispStatus: _this.getDispStatus
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    this.getState = function () {
                        return _this.$state.current.name;
                    };
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    this.goToActionsOffers = function () {
                        return _this.$state.go(_this.getActionsOffersState());
                    };
                    this.getActionsOffersState = function () {
                        return _this.config.main.actionsOffersMainState;
                    };
                    this.getActionsOffersWidgetState = function () {
                        return _this.config.widget.actionsOffersWidgetState;
                    };
                    this.getAccountNumber = function () {
                        return _this.sessionStorage.getSessionStorageValue('accountNumber');
                    };
                    this.getLanguage = function () {
                        var languageService = _this.$injector.get('ute.blocks.language.switcher');
                        _this.lang = languageService.getCurrentLanguage();
                        return _this.lang;
                    };
                    this.getProductTreatment = function () {
                        // var request: any = {
                        //   accountNumber: this.getAccountNumber(),
                        //   lang: this.getLanguage()
                        // };
                        // return this.$http.post(this.securityService.getBackendUrl(this.getConfig().main.treatmentApiUrl), request)
                        //   .then <any>(this.processGetProductTreatmentSuccess);
                        return _this.activeTreatmentsService.callActiveTreatments().then(_this.processGetProductTreatmentSuccess);
                    };
                    this.readDispositionCache = function (ecid) {
                        var request = {
                            accountNumber: _this.getAccountNumber(),
                            lang: _this.getLanguage(),
                            ecid: ecid
                        };
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().main.readDispositionCacheApiUrl), request)
                            .then(_this.processReadDispositionCacheSuccess)
                            .catch(_this.processReadDispositionCacheError);
                    };
                    this.processReadDispositionCacheSuccess = function (response) {
                        return angular.copy(response.data);
                    };
                    this.processReadDispositionCacheError = function (reason) {
                        var data = '{"status": "error"}';
                        return angular.fromJson(data);
                    };
                    this.updateDispositions = function (treatment, dispositionCode, dispositionReason) {
                        if (dispositionReason == null) {
                            dispositionReason = '';
                        }
                        var request = {
                            accountNumber: _this.getAccountNumber(),
                            lang: _this.getLanguage(),
                            dispositionCode: dispositionCode,
                            rtdmResponseTrackingCode: treatment.rtdmTrackingCode,
                            treatmentTrackingCode: treatment.treatmentTrackingCode,
                            dispositionReason: dispositionReason,
                            ecid: treatment.ecid,
                            treatmentId: treatment.treatmentId,
                            treatmentCode: treatment.treatmentCode
                        };
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().main.updateDispositionApiUrl), request)
                            .then(_this.processUpdateDispositionSuccess)
                            .catch(_this.processUpdateDispositionError);
                    };
                    this.processUpdateDispositionSuccess = function (response) {
                        return response.data;
                    };
                    this.processUpdateDispositionError = function (reason) {
                        var data = '{"status": "error"}';
                        return angular.fromJson(data);
                    };
                    this.processGetProductTreatmentSuccess = function (response) {
                        if (response.data && response.data > 0 && response.data != null) {
                            _this.retriveTreatmentInfo = angular.copy(response.data);
                        }
                        return response.data;
                    };
                    this.processGetProductTreatmentError = function (reason) {
                        var data = '{"status": "error"}';
                        return angular.fromJson(data);
                    };
                    this.getRetriveTreatmentInfo = function () {
                        return _this.retriveTreatmentInfo;
                    };
                    this.getProductTreatmentHistory = function (ecid) {
                        var request = {
                            accountNumber: _this.getAccountNumber(),
                            ecid: ecid,
                            lang: _this.getLanguage()
                        };
                        return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().main.treatemntHistoryApiUrl), request)
                            .then(_this.processGetProductTreatmentHistorySuccess);
                    };
                    this.processGetProductTreatmentHistorySuccess = function (response) {
                        if (response.data) {
                            _this.retriveTreatmentHistoryInfo = angular.copy(response.data);
                        }
                        return response.data;
                    };
                    this.processGetProductTreatmentHistoryError = function (reason) {
                        var data = '{"status": "error"}';
                        return angular.fromJson(data);
                    };
                    this.getRetriveTreatmentHistoryInfo = function () {
                        return _this.retriveTreatmentHistoryInfo;
                    };
                    this.getStatusMap = function () {
                        return _this.statusMap;
                    };
                    this.setStatusMap = function (statusMap) {
                        _this.statusMap = statusMap;
                    };
                    this.updateStatusMap = function (treatmentId, status) {
                        _this.statusMap[treatmentId] = status;
                    };
                    this.getDispStatus = function (treatmentId) {
                        return _this.statusMap[treatmentId];
                    };
                    this.$get.$inject = [
                        'ute.blocks.messages.bus.service',
                        '$injector',
                        '$http',
                        '$state',
                        'sessionStorage',
                        'ute.active.treatments.service'
                    ];
                }
                ActionsOffersProvider.$inject = [];
                ActionsOffersProvider.serviceName = 'ute.actions.offers.service';
                return ActionsOffersProvider;
            }());
            angular.module('ute.actions.offers').provider(ActionsOffersProvider.serviceName, ActionsOffersProvider);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            function ActionsOffersConfig() {
                return {
                    main: {
                        actionsOffersMainState: 'actionsOffers',
                        mainControllerName: 'ute.actions.offers.main.controller',
                        mainTemplateUrl: 'module/actionsOffers/actionsOffersMain.view.html',
                        controllerName: 'ute.actions.offers.directive.controller',
                        templateUrl: 'module/actionsOffers/actionsOffersDirective/actionsOffers.html',
                        treatmentApiUrl: 'v1/cmt/getActiveTreatments',
                        treatemntHistoryApiUrl: 'v1/cmt/getTreatmentHistory',
                        updateDispositionApiUrl: 'v1/cmt/updateDisposition',
                        readDispositionCacheApiUrl: 'v1/cmt/readDispositionStatus',
                        cancelState: 'oneViewDashboard'
                    },
                    widget: {
                        actionsOffersWidgetState: 'actionsOffersWidget',
                        treatmentApiUrl: 'v1/actionsOffers/GetProductTreatmentResponseUTE',
                        controllerName: 'ute.actions.offers.widget.directive.controller',
                        templateUrl: 'module/actionsOffers/actionsOffersWidgetDirective/actionsOffersWidget.html',
                        updateDispositionApiUrl: 'v1/actionsOffers/UpdateDispositionResponseUTE',
                        readDispositionCacheApiUrl: 'v1/actionsOffers/ReadDispositionCache'
                    },
                    offerPanel: {
                        offersWidgetPanelState: 'offersWidgetPanel',
                        controllerName: 'ute.actions.offers.widget.panel.controller',
                        templateUrl: 'module/actionsOffers/actionsOffersWidgetDirective/offersWidgetPanel.html',
                        colorHexCodes: ['#008fb6', '#E4BC40', '#662d91', '#7aaa39', '#ac0067', '#2926ab', '#cd5e40', '#2b464c', '#bbb62a', '#317d59']
                    },
                    inbounds: {
                        stateName: 'inbounds',
                        templateUrl: 'module/actionsOffers/actionsOffersBounds/offers-inbounds.html',
                        parentState: 'actionsOffers'
                    },
                    outbounds: {
                        stateName: 'outbounds',
                        templateUrl: 'module/actionsOffers/actionsOffersBounds/offers-outbounds.html',
                        parentState: 'actionsOffers'
                    },
                    constants: {
                        action: 'action',
                        offer: 'offer',
                        treatment: 'treatment',
                        inbounds: 'inbounds',
                        outbounds: 'outbounds',
                        yes: 'yes',
                        yesCase: 'Yes',
                        no: 'no',
                        noCase: 'No',
                        interested: 'interested',
                        interestedCase: 'Interested',
                        available: 'available',
                        availableCase: 'Available',
                        accepted: 'accepted',
                        acceptedCase: 'Accepted',
                        declined: 'declined',
                        declinedCase: 'Declined',
                        expired: 'expired',
                        expiredCase: 'Expired',
                        sms: 'SMS',
                        email: 'Email',
                        directmail: 'Direct Mail',
                        telemarketing: 'Telemarketing',
                        tempdeclined: 'tempdeclined',
                        oneViewDashboard: 'oneViewDashboard',
                        rtdm: 'RTDM',
                        mw: 'MW',
                        other: 'OTHER'
                    }
                };
            }
            offers.ActionsOffersConfig = ActionsOffersConfig;
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffersWidgetController = (function () {
                /* @ngInject */
                function ActionsOffersWidgetController(actionsOffersService, $state, $location, languageService, $modal, translate, $sce) {
                    var _this = this;
                    this.actionsOffersService = actionsOffersService;
                    this.$state = $state;
                    this.$location = $location;
                    this.languageService = languageService;
                    this.$modal = $modal;
                    this.translate = translate;
                    this.$sce = $sce;
                    this.loading = true;
                    this.treatmentsNotAvailable = false;
                    this.displayError = false;
                    this.prevDispState = [];
                    this.selectedPanelIndex = -1;
                    this.declineDivIndex = -1;
                    this.declineDivTreatment = null;
                    this.loadingDisposition = {};
                    this.showTerms = false;
                    this.$state = $state;
                    this.getTreatmentDetails();
                    this.localLanguage = this.actionsOffersService.getLanguage();
                    this.accepted = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                    this.interested = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                    this.declined = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                    this.yes = this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.yes');
                    this.no = this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.no');
                    this.languageService.registerOnDataChangeHandler(function (lang) {
                        if (_this.$state.current.name === _this.actionsOffersService.getConfig().main.actionsOffersMainState || _this.localLanguage === lang ||
                            _this.$state.current.name === _this.actionsOffersService.getConfig().constants.inbounds ||
                            _this.$state.current.name === _this.actionsOffersService.getConfig().constants.outbounds) {
                            return null;
                        }
                        _this.localLanguage = lang;
                        _this.loading = true;
                        _this.getTreatmentDetails();
                        _this.accepted = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                        _this.interested = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                        _this.declined = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                        _this.yes = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.yes');
                        _this.no = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersPanel.no');
                        return null;
                    }, 'ute.actions.offers.widget.directive.controller');
                }
                /*method for calling activeTreatments API*/
                ActionsOffersWidgetController.prototype.getTreatmentDetails = function () {
                    var _this = this;
                    this.actionsOffersService.getProductTreatment().then(function (res) {
                        _this.loading = false;
                        _this.getProductTreatmentResponse = res;
                        _this.productTreatments = res;
                        _this.getProductTreatmentResponseLength = _this.getProductTreatmentResponse.length;
                        if (res.length === 0) {
                            _this.treatmentsNotAvailable = true;
                            _this.displayError = true;
                        }
                        //PCR22 changes for dynamic button display
                        var dynCheckboxItems = [_this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.available').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted').toLowerCase(),
                            _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined').toLowerCase()];
                        for (var _i = 0, _a = res.getProductTreatmentDetailsList; _i < _a.length; _i++) {
                            var entry = _a[_i];
                            entry.dynamicValues = entry.dispositionsInbound.filter(function (obj) { return dynCheckboxItems.indexOf(obj.toLowerCase()) === -1; });
                        }
                        _this.ecid = _this.productTreatments.ecid;
                        _this.actionsOffersService.readDispositionCache(_this.ecid).then(function (res) {
                            if (res.dispositionStatusMap != null) {
                                _this.actionsOffersService.setStatusMap(res.dispositionStatusMap);
                            }
                        }, function (err) {
                            console.log(err);
                        });
                    }, function (errRes) {
                        _this.loading = false;
                        _this.treatmentsNotAvailable = true;
                        _this.errorCode = '';
                        _this.errorDesc = '';
                        var data;
                        if (errRes.data.errorCode !== undefined) {
                            data = angular.fromJson(errRes.data);
                            if (errRes.status === 555) {
                                if (data.errorCategory === _this.actionsOffersService.getConfig().constants.rtdm) {
                                    _this.errorDesc = data.errorDesc;
                                }
                                else if (data.errorCategory === _this.actionsOffersService.getConfig().constants.mw ||
                                    data.errorCategory === _this.actionsOffersService.getConfig().constants.other) {
                                    _this.errorCode = data.errorCode;
                                }
                            }
                        }
                    });
                };
                ActionsOffersWidgetController.prototype.getDispStatus = function (treatmentId) {
                    return this.actionsOffersService.getDispStatus(treatmentId);
                };
                ActionsOffersWidgetController.prototype.updateStatusMap = function (treatmentId, status) {
                    this.actionsOffersService.updateStatusMap(treatmentId, status);
                };
                ActionsOffersWidgetController.prototype.isPanelSelected = function (index) {
                    return this.selectedPanelIndex === index;
                };
                /*method for displaying the panel popup on click of offers*/
                ActionsOffersWidgetController.prototype.selectPanel = function (index, treatment) {
                    this.restoreDispState();
                    if (this.selectedPanelIndex === index) {
                        this.selectedPanelIndex = -1;
                    }
                    else if (treatment !== null && treatment.treatmentGroup.toLowerCase() === this.actionsOffersService.getConfig().constants.offer || treatment.treatmentGroup.toLowerCase() === this.actionsOffersService.getConfig().constants.treatment) {
                        this.selectedPanelIndex = -1;
                        var selectedTreatment_1 = treatment;
                        var modal = this.$modal.open({
                            templateUrl: this.actionsOffersService.getConfig().offerPanel.templateUrl,
                            controller: 'ute.actions.offers.widget.panel.controller',
                            controllerAs: 'offersWidgetPanel',
                            backdrop: 'static',
                            size: 'offer',
                            keyboard: true,
                            backdropClass: 'bkg-model',
                            resolve: {
                                selectedTreatment: function () { return selectedTreatment_1; }
                            }
                        });
                    }
                    else {
                        this.selectedPanelIndex = index;
                    }
                };
                ActionsOffersWidgetController.prototype.unselectPanels = function () {
                    this.selectedPanelIndex = -1;
                };
                ActionsOffersWidgetController.prototype.trustHTML = function (html) {
                    return this.$sce.trustAsHtml(html);
                };
                ActionsOffersWidgetController.prototype.showDeclineDiv = function (index, treatmentId, clickedPosition) {
                    this.declineClickState = clickedPosition;
                    if (this.declineDivIndex !== -1) {
                        this.restoreDispState();
                    }
                    this.declineDivIndex = index;
                    this.declineDivTreatment = treatmentId;
                    this.prevDispState[treatmentId] = this.actionsOffersService.getDispStatus(treatmentId);
                    this.actionsOffersService.updateStatusMap(treatmentId, this.actionsOffersService.getConfig().constants.tempdeclined);
                };
                ActionsOffersWidgetController.prototype.hideDeclineDiv = function () {
                    this.declineDivIndex = -1;
                    this.declineDivTreatment = null;
                };
                ActionsOffersWidgetController.prototype.restoreDispState = function () {
                    if (this.declineDivTreatment != null) {
                        this.actionsOffersService.updateStatusMap(this.declineDivTreatment, this.prevDispState[this.declineDivTreatment]);
                        this.hideDeclineDiv();
                    }
                };
                ActionsOffersWidgetController.prototype.displayDiv = function (index) {
                    return this.declineDivIndex === index;
                };
                ActionsOffersWidgetController.prototype.showTermAndCondn = function () {
                    this.showTerms = true;
                    return this.showTerms;
                };
                ActionsOffersWidgetController.prototype.hideTermAndCondn = function () {
                    this.showTerms = false;
                    return this.showTerms;
                };
                ActionsOffersWidgetController.prototype.declineDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.hideDeclineDiv();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                ActionsOffersWidgetController.prototype.restoreAndUpdateDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.restoreDispState();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                ActionsOffersWidgetController.prototype.updateDispositionMethod = function (treatment, dispositionCode, dispositionReason) {
                    var _this = this;
                    this.loadingDisposition[treatment.treatmentId] = true;
                    this.actionsOffersService.updateStatusMap(treatment.treatmentId, dispositionCode);
                    this.actionsOffersService.updateDispositions(treatment, dispositionCode, dispositionReason).then(function (res) {
                        _this.updateDisposition = res;
                        _this.loadingDisposition[treatment.treatmentId] = false;
                    }, function (err) {
                        console.log(err);
                        _this.loadingDisposition[treatment.treatmentId] = false;
                    });
                };
                ActionsOffersWidgetController.prototype.seeAll = function () {
                    this.switchView(this.actionsOffersService.getConfig().main.actionsOffersMainState);
                };
                ;
                ActionsOffersWidgetController.prototype.switchView = function (viewName) {
                    var _targetView = viewName.charAt(0) !== '/' ? '/' : '', _targetParam;
                    _targetView += viewName;
                    this.$location.path(_targetView);
                };
                ;
                ActionsOffersWidgetController.controllerName = 'ute.actions.offers.widget.directive.controller';
                ActionsOffersWidgetController.$inject = ['ute.actions.offers.service', '$state', '$location', 'ute.blocks.language.switcher', '$modal', '$translate', '$sce'];
                return ActionsOffersWidgetController;
            }());
            offers.ActionsOffersWidgetController = ActionsOffersWidgetController;
            angular.module('ute.actions.offers').controller('ute.actions.offers.widget.directive.controller', ActionsOffersWidgetController);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var ActionsOffersWidget = (function () {
                /* @ngInject */
                function ActionsOffersWidget(actionsOffersService) {
                    this.actionsOffersService = actionsOffersService;
                    this.restrict = 'E';
                    this.templateUrl = this.actionsOffersService.getConfig().widget.templateUrl;
                    this.controller = this.actionsOffersService.getConfig().widget.controllerName;
                    this.controllerAs = 'actionsOffersWidget';
                    /**
                     * @param scope
                     */
                    this.linkFn = function () {
                        //linkFn
                    };
                    this.link = this.linkFn;
                }
                /* link: ng.IDirectiveLinkFn;*/
                /**
                 * @returns {function(ute.actions.offers.IActionsOffersService): ute.actions.offers.actionsOffers}
                 */
                ActionsOffersWidget.factory = function () {
                    var directive = function (actionsOffersService) { return new ActionsOffersWidget(actionsOffersService); };
                    directive.$inject = ['ute.actions.offers.service'];
                    return directive;
                };
                return ActionsOffersWidget;
            }());
            angular.module('ute.actions.offers').directive('repOffers', ActionsOffersWidget.factory());
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            angular.module('ute.actions.offers').filter('filter_date', filterDate);
            /*filter for formatting date. Ex: input= June 20, 2017 output: 20 2017 */
            function filterDate() {
                return function (input) {
                    if (input) {
                        input = input.split(' ');
                        var input2 = input[1] + ' ' + input[2];
                        return input2.replace(',', '');
                    }
                };
            }
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            angular.module('ute.actions.offers').filter('first_word', firstWord);
            /*filter for obtaining first word of a string*/
            function firstWord() {
                return function (input) {
                    if (input) {
                        input = input.split(' ');
                        return input[0];
                    }
                };
            }
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var OffersWidgetPanelController = (function () {
                /* @ngInject */
                function OffersWidgetPanelController(actionsOffersService, selectedTreatment, $modalInstance, languageService, translate, $state, $sce) {
                    var _this = this;
                    this.actionsOffersService = actionsOffersService;
                    this.selectedTreatment = selectedTreatment;
                    this.$modalInstance = $modalInstance;
                    this.languageService = languageService;
                    this.translate = translate;
                    this.$state = $state;
                    this.$sce = $sce;
                    this.showTerms = false;
                    this.showDeclineFlag = false;
                    this.prevDispState = [];
                    this.circleContent = [this.actionsOffersService.getConfig().constants.sms.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.email.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.directmail.toLowerCase(),
                        this.actionsOffersService.getConfig().constants.telemarketing.toLowerCase()];
                    this.colorHex = this.actionsOffersService.getConfig().offerPanel.colorHexCodes;
                    this.$state = $state;
                    this.valueContent = this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.value');
                    this.detailContent = this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.details');
                    this.howToContent = this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.howTo');
                    this.eligibilityContent = this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.eligibility');
                    this.accepted = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                    this.interested = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                    this.declined = this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                    this.localLanguage = this.actionsOffersService.getLanguage();
                    this.languageService.registerOnDataChangeHandler(function (lang) {
                        if (_this.localLanguage === lang || _this.$state.current.name === _this.actionsOffersService.getConfig().constants.oneViewDashboard) {
                            return null;
                        }
                        _this.localLanguage = lang;
                        _this.valueContent = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.value');
                        _this.detailContent = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.details');
                        _this.howToContent = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.howTo');
                        _this.eligibilityContent = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersWidget.eligibility');
                        _this.accepted = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.accepted');
                        _this.interested = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.interested');
                        _this.declined = _this.translate.instant('ute.rogers.actionsOffers.actionsOffersBounds.declined');
                    }, 'ute.actions.offers.widget.panel.controller');
                }
                OffersWidgetPanelController.prototype.showTermAndCondn = function () {
                    this.showTerms = true;
                    return this.showTerms;
                };
                OffersWidgetPanelController.prototype.hideTermAndCondn = function () {
                    this.showTerms = false;
                    return this.showTerms;
                };
                OffersWidgetPanelController.prototype.close = function () {
                    this.$modalInstance.close();
                };
                OffersWidgetPanelController.prototype.expandOffer = function () {
                    angular.element(document.querySelector('ute-ao-panel-desc')).removeClass('overflow');
                    angular.element(document.querySelector('ao-title')).removeClass('ute-header-align');
                };
                OffersWidgetPanelController.prototype.checkOverflow = function () {
                    var titleElementPanel = document.getElementById('ao-header');
                    var titleElementWidget = document.getElementById('title-wrapper');
                    var descriptionElement = document.getElementById('ao-desc');
                    if ((titleElementPanel.offsetHeight < titleElementPanel.scrollHeight) ||
                        (titleElementWidget.offsetHeight < titleElementWidget.scrollHeight) ||
                        (descriptionElement.offsetHeight < descriptionElement.scrollHeight)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                };
                OffersWidgetPanelController.prototype.trustHTML = function (html) {
                    return this.$sce.trustAsHtml(html);
                };
                OffersWidgetPanelController.prototype.getDispStatus = function (treatmentId) {
                    return this.actionsOffersService.getDispStatus(treatmentId);
                };
                OffersWidgetPanelController.prototype.updateStatusMap = function (treatmentId, status) {
                    this.actionsOffersService.updateStatusMap(treatmentId, status);
                };
                OffersWidgetPanelController.prototype.showDeclineDiv = function () {
                    this.showDeclineFlag = true;
                };
                OffersWidgetPanelController.prototype.hideDeclineDiv = function () {
                    this.showDeclineFlag = false;
                };
                OffersWidgetPanelController.prototype.restoreDispState = function () {
                    if (this.showDeclineFlag === true) {
                        this.hideDeclineDiv();
                    }
                };
                OffersWidgetPanelController.prototype.displayDiv = function () {
                    return this.showDeclineFlag;
                };
                OffersWidgetPanelController.prototype.declineDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.hideDeclineDiv();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                OffersWidgetPanelController.prototype.restoreAndUpdateDisposition = function (treatment, dispositionCode, dispositionReason) {
                    this.restoreDispState();
                    this.updateDispositionMethod(treatment, dispositionCode, dispositionReason);
                };
                OffersWidgetPanelController.prototype.updateDispositionMethod = function (treatment, dispositionCode, dispositionReason) {
                    this.actionsOffersService.updateStatusMap(treatment.treatmentId, dispositionCode);
                    this.actionsOffersService.updateDispositions(treatment, dispositionCode, dispositionReason).then(function (res) {
                    }, function (err) {
                        console.log(err);
                    });
                };
                OffersWidgetPanelController.controllerName = 'ute.actions.offers.widget.panel.controller';
                OffersWidgetPanelController.$inject = ['ute.actions.offers.service', 'selectedTreatment', '$modalInstance', 'ute.blocks.language.switcher', '$translate', '$state', '$sce'];
                return OffersWidgetPanelController;
            }());
            offers.OffersWidgetPanelController = OffersWidgetPanelController;
            angular.module('ute.actions.offers').controller('ute.actions.offers.widget.panel.controller', OffersWidgetPanelController);
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var actions;
    (function (actions) {
        var offers;
        (function (offers) {
            'use strict';
            var OffersWidgetPanel = (function () {
                /* @ngInject */
                function OffersWidgetPanel(actionsOffersService) {
                    this.actionsOffersService = actionsOffersService;
                    this.restrict = 'E';
                    this.templateUrl = this.actionsOffersService.getConfig().offerPanel.templateUrl;
                    this.controller = this.actionsOffersService.getConfig().offerPanel.controllerName;
                    this.controllerAs = 'offersWidgetPanel';
                    /**
                     * @param scope
                     */
                    this.linkFn = function () {
                        //linkFn
                    };
                    this.link = this.linkFn;
                }
                /* link: ng.IDirectiveLinkFn;*/
                /**
                 * @returns {function(ute.actions.offers.IActionsOffersService): ute.actions.offers.actionsOffers}
                 */
                OffersWidgetPanel.factory = function () {
                    var directive = function (actionsOffersService) { return new OffersWidgetPanel(actionsOffersService); };
                    directive.$inject = ['ute.actions.offers.service'];
                    return directive;
                };
                return OffersWidgetPanel;
            }());
            angular.module('ute.actions.offers').directive('offersWidgetPanel', OffersWidgetPanel.factory());
        })(offers = actions.offers || (actions.offers = {}));
    })(actions = ute.actions || (ute.actions = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var BFAPPCErrorsProvider = (function () {
                /* @ngInject */
                function BFAPPCErrorsProvider() {
                    var _this = this;
                    /*
                    private $state: ng.ui.IState;
                    private $log: ng.ILogService;
                */
                    this.config = {
                        basic: {
                            applicationId: 'ute-application-id',
                        },
                        modal: {
                            templateUrl: 'module/BFA-PPC/bfaPpcErrors/bfaPpcErrorsModal/bfaPpcErrorsModal.view.html',
                            controller: 'ute.bfa.ppc.errors.modalCtrl'
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $translate, $modal) {
                        _this.$injector = $injector;
                        _this.$translate = $translate;
                        _this.$modal = $modal;
                        return {
                            getConfig: _this.getConfig,
                            showError: _this.showError,
                            showSuspendedError: _this.showSuspendedError,
                            handleError: _this.handleError,
                            showGenericError: _this.showGenericError
                        };
                    };
                    /*
                      ** @returns {any}
                    */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    /*
                      ** @param config
                      ** @returns {boolean}
                    */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @param errorMessage
                     */
                    this.showModal = function (errorMessage) {
                        $('#error-modal-body').html(errorMessage);
                        var errorModal = $('#error-modal');
                        errorModal.modal('show');
                    };
                    /**
                     * @param params
                     * @returns {angular.IPromise<any>}
                     */
                    this.showErrorModal = function (params) {
                        params.reload = params.reload || false;
                        var $modalInstance = _this.$modal.open({
                            templateUrl: _this.config.modal.templateUrl,
                            windowClass: 'ute-bfa-ppc-errors-prorated-modal',
                            controller: _this.config.modal.controller,
                            controllerAs: 'modal',
                            size: 'md',
                            backdrop: 'static',
                            resolve: {
                                params: function () { return params; }
                            }
                        });
                        return $modalInstance.result;
                    };
                    /**
                     * @param params
                     * @returns {ng.IPromise<any>}
                     */
                    this.showError = function (params) {
                        //TODO: import the analytics.js script used behind the appState.tagging method
                        // try {
                        //   appState.tagging(['_trackPageView',
                        //       {pn:'home:MyRogers:PPC_wireless-planchange'},
                        //       {eVar49: params.message}
                        //   ]);
                        // } catch (e) {
                        //   this.$log.error('Exception catch during tagging on pn=home:MyRogers:PPC_wireless-planchange with message:', e.message);
                        // }
                        return _this.showErrorModal(params);
                    };
                    /**
                     * @param params
                     * @returns {ng.IPromise<any>}
                     */
                    this.showSuspendedError = function (params) {
                        return _this.showErrorModal(params);
                    };
                    /**
                     * @param errorCode
                     */
                    this.handleError = function (errorCode) {
                        var errorMessage = _this.$translate.instant(errorCode);
                        _this.showModal(errorMessage);
                    };
                    this.showGenericError = function () {
                        var errorMessage = _this.$translate.instant('_something_went_wrong');
                        _this.showModal(errorMessage);
                    };
                    this.$get.$inject = ['$injector', '$translate', '$modal'];
                }
                BFAPPCErrorsProvider.$inject = [];
                return BFAPPCErrorsProvider;
            }());
            angular.module('ute.bfa.ppc').provider('ute.bfa.ppc.errors.service', BFAPPCErrorsProvider);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCAddAdditionalDataModalCtrl = (function () {
                function IBFAPPCAddAdditionalDataModalCtrl($scope, $modalInstance) {
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                }
                IBFAPPCAddAdditionalDataModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.dismiss('cancel');
                };
                ;
                IBFAPPCAddAdditionalDataModalCtrl.prototype.yes = function () {
                    this.$modalInstance.close(true);
                };
                ;
                IBFAPPCAddAdditionalDataModalCtrl.prototype.no = function () {
                    this.$modalInstance.close(false);
                };
                ;
                IBFAPPCAddAdditionalDataModalCtrl.$inject = ['$scope', '$modalInstance'];
                return IBFAPPCAddAdditionalDataModalCtrl;
            }());
            ppc.IBFAPPCAddAdditionalDataModalCtrl = IBFAPPCAddAdditionalDataModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.addAdditionalDataModalCtrl', IBFAPPCAddAdditionalDataModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCEntry1ModalCtrl = (function () {
                function IBFAPPCEntry1ModalCtrl($scope, $modalInstance) {
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                }
                IBFAPPCEntry1ModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.dismiss('cancel');
                };
                ;
                IBFAPPCEntry1ModalCtrl.prototype.createSharedGroup = function () {
                    this.$modalInstance.close('createSharedGroup');
                };
                ;
                IBFAPPCEntry1ModalCtrl.prototype.changeCurrentPlan = function () {
                    this.$modalInstance.close('changeCurrentPlan');
                };
                ;
                IBFAPPCEntry1ModalCtrl.$inject = ['$scope', '$modalInstance'];
                return IBFAPPCEntry1ModalCtrl;
            }());
            ppc.IBFAPPCEntry1ModalCtrl = IBFAPPCEntry1ModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.entry1ModalCtrl', IBFAPPCEntry1ModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCEntry3ModalCtrl = (function () {
                function IBFAPPCEntry3ModalCtrl($scope, $modalInstance) {
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                }
                IBFAPPCEntry3ModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.dismiss('cancel');
                };
                ;
                IBFAPPCEntry3ModalCtrl.prototype.addToSharedGroup = function () {
                    this.$modalInstance.close('addToSharedGroup');
                };
                ;
                IBFAPPCEntry3ModalCtrl.prototype.changeCurrentPlan = function () {
                    this.$modalInstance.close('changeCurrentPlan');
                };
                ;
                IBFAPPCEntry3ModalCtrl.$inject = ['$scope', '$modalInstance'];
                return IBFAPPCEntry3ModalCtrl;
            }());
            ppc.IBFAPPCEntry3ModalCtrl = IBFAPPCEntry3ModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.entry3ModalCtrl', IBFAPPCEntry3ModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCSharedGroupIndividualModalCtrl = (function () {
                function IBFAPPCSharedGroupIndividualModalCtrl($scope, $modalInstance, subscribers, currentCtn) {
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                    this.subscribers = subscribers;
                    this.currentCtn = currentCtn;
                }
                IBFAPPCSharedGroupIndividualModalCtrl.prototype.toggleBenefits = function () {
                    this.showBenefits = !this.showBenefits;
                };
                ;
                IBFAPPCSharedGroupIndividualModalCtrl.prototype.filterSubscribers = function (item) {
                    return item.familyShareStatus === 'Individual' && item.status === 'Active' && item.subscriberNumber !== this.currentCtn;
                };
                ;
                IBFAPPCSharedGroupIndividualModalCtrl.prototype.continue = function () {
                    this.$modalInstance.close(this.getSelectedSubscribers());
                };
                ;
                IBFAPPCSharedGroupIndividualModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.dismiss('cancel');
                };
                ;
                IBFAPPCSharedGroupIndividualModalCtrl.prototype.getSelectedSubscribers = function () {
                    return _.keys(_.pick(this.selectedSubscribersCheckBox, function (value, key) {
                        return value;
                    }));
                };
                ;
                IBFAPPCSharedGroupIndividualModalCtrl.$inject = ['$scope', '$modalInstance', 'subscribers', 'currentCtn'];
                return IBFAPPCSharedGroupIndividualModalCtrl;
            }());
            ppc.IBFAPPCSharedGroupIndividualModalCtrl = IBFAPPCSharedGroupIndividualModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.sharedGroupIndividualCtrl', IBFAPPCSharedGroupIndividualModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCSharedGroupPrimaryModalCtrl = (function () {
                function IBFAPPCSharedGroupPrimaryModalCtrl($scope, $modalInstance, selectedAdditionalSubscribers, currentCtn) {
                    this.$scope = $scope;
                    this.$modalInstance = $modalInstance;
                    this.selectedAdditionalSubscribers = selectedAdditionalSubscribers;
                    this.currentCtn = currentCtn;
                }
                IBFAPPCSharedGroupPrimaryModalCtrl.prototype.continue = function () {
                    this.$modalInstance.close(this.selectedPrimaryCtn);
                };
                ;
                IBFAPPCSharedGroupPrimaryModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.dismiss('cancel');
                };
                ;
                IBFAPPCSharedGroupPrimaryModalCtrl.$inject = ['$scope', '$modalInstance', 'selectedAdditionalSubscribers', 'currentCtn'];
                return IBFAPPCSharedGroupPrimaryModalCtrl;
            }());
            ppc.IBFAPPCSharedGroupPrimaryModalCtrl = IBFAPPCSharedGroupPrimaryModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.sharedGroupPrimaryCtrl', IBFAPPCSharedGroupPrimaryModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                var Messages = ute.blocks.messages.bus.Messages;
                var BriteBillProvider = (function () {
                    function BriteBillProvider(accountOverviewProvider, $injector) {
                        var _this = this;
                        this.accountOverviewProvider = accountOverviewProvider;
                        this.$injector = $injector;
                        this.briteBillServerLogs = {
                            'briteBillError': 'BriteBill error - '
                        };
                        this.config = {
                            basic: {
                                applicationId: 'Rogers.com',
                                partialApiUrl: 'v1/encryptBritebill',
                                analyticsId: 'brandanalysticsid',
                                activatedUserSummaryAPI: '/rogers_rest/rogers/documents/activatedUserSummary',
                                postToUrl: '',
                                sessionStorageUserTypeBAN: '',
                                legacyInvoiceDateUserType: 'consumer',
                                legacyStateRedirect: '',
                                useAccountNumberOverride: false,
                                accountNumberOverride: '520672247' //520672247
                            },
                            advanced: {
                                excelAppType: 'application/vnd.ms-excel',
                                csvAppType: 'text/csv'
                            }
                        };
                        this.$get = function ($injector, $state, $http, $q, $window, $filter, $translate) {
                            _this.encryptionService = $injector.get('ute.common.encryption.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.$state = $state;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.$window = $window;
                            _this.$filter = $filter;
                            _this.$translate = $translate;
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            _this.brtSwitchService = $injector.get('ute.common.core.brtswitch.service');
                            _this.encryptBriteBillFactory = $injector.get('ute.brite.bill.service.encrypt.factory');
                            _this.messagesService = _this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                            _this.messagesService.register(Messages.uteRogersSignoutSuccessful, _this.signoutHandler);
                            return {
                                changeBriteBillSrc: _this.changeBriteBillSrc,
                                downloadPdfService: _this.downloadPdfService,
                                downloadMultiplePdfService: _this.downloadMultiplePdfService,
                                pdfDownload: _this.pdfDownload,
                                getIsbritebillAvailable: _this.getIsbritebillAvailable,
                                getBBPermission: _this.getBBPermission,
                                getBriteBillInvoiceDates: _this.getBriteBillInvoiceDates,
                                getSRC: _this.getSRC,
                                getDefaultLink: _this.getDefaultLink,
                                getBillByLink: _this.getBillByLink,
                                getInvoiceDateSelected: _this.getInvoiceDateSelected,
                                setInvoiceDateSelected: _this.setInvoiceDateSelected,
                                getInvoiceDateArray: _this.getInvoiceDateArray,
                                isNoBillsAvailable: _this.isNoBillsAvailable,
                                isBriteBillErrorOccurred: _this.isBriteBillErrorOccurred,
                                isLoadingBriteBill: _this.isLoadingBriteBill,
                                getBills: _this.getBills,
                                getBriteBillOldestDate: _this.getBriteBillOldestDate,
                                setBriteBillOldestDate: _this.setBriteBillOldestDate,
                                getBriteBillError: _this.getBriteBillError,
                                setLegacyStateRedirect: _this.setLegacyStateRedirect,
                                downloadExcelService: _this.downloadExcelService,
                                downloadCSVService: _this.downloadCSVService,
                                downloadFileService: _this.downloadFileService,
                                getSelectedInvoiceBill: _this.getSelectedInvoiceBill,
                                setPrintBillSRC: _this.setPrintBillSRC,
                                getPrintBillSRC: _this.getPrintBillSRC,
                                getLoadingFileData: _this.getLoadingFileData,
                                getBriteBillFailed: _this.getBriteBillFailed,
                                convertDate: _this.convertDate,
                                getCurrentActivatedUserSummary: _this.getCurrentActivatedUserSummary,
                                encryptedBriteBillToken: _this.encryptedBriteBillToken,
                                clearBillsData: _this.clearBillsData
                            };
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            _this.accountOverviewProvider.configure({
                                basic: {
                                    applicationId: _this.config.basic.applicationId
                                }
                            });
                            return true;
                        };
                        this.getCurrentActivatedUserSummary = function () {
                            return _this.activatedUserSummary;
                        };
                        this.changeBriteBillSrc = function (accountNumber, link) {
                            if (link) {
                                _this.getBillData(accountNumber).src = '/web/totes/viewInvoiceDetail.html?accountNumber=' + accountNumber + '&link=' + link;
                            }
                        };
                        this.getBriteBillFailed = function (accountNumber) { return _this.getBillData(accountNumber).briteBillFailed; };
                        this.encryptedBriteBillToken = function (request) {
                            var _return = {
                                result: '',
                                data: null,
                                message: ''
                            };
                            if (_this.config.basic.useAccountNumberOverride) {
                                request.currentAccNumber = _this.config.basic.accountNumberOverride;
                            }
                            if (request.currentAccNumber && request.currentAccNumber !== '') {
                                var worker = _this.encryptBriteBillFactory(request);
                                return worker.getEncryptBriteBill().then(function (data) {
                                    // check for error messages from server / Auth exipre / other troubles that do return valid JSON
                                    worker.resetCachedData();
                                    if (data) {
                                        _return.result = 'success';
                                        _return.data = data;
                                    }
                                    else {
                                        _return.result = 'fail';
                                    }
                                    return _return;
                                }, function (error) {
                                    // Error handling - 555 exception
                                    if (error.data.status === 555) {
                                        // Server error that needs further processing
                                        // additional information for 555 error
                                        // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                                        // error.error.errorMessage		// Message as delivered from server
                                        // error.error.message 			// Message as found in resource file
                                        // error.error.statusCode		// error status code - 555 in this case
                                        _return.result = 'error';
                                        _return.message = _this.$translate.instant('ute.briteBill.service.errorCode' + error.error.errorCode); // Pull message from resource file
                                    }
                                    else {
                                        // anything but status code 555
                                        _return.result = 'error';
                                        _return.message = _this.$translate.instant('ute.briteBill.service.error_wireless_usage'); // Pull message from resource file 401 or 5xx situlation
                                    }
                                    return _return;
                                });
                            }
                            else {
                                return _this.$q.reject();
                            }
                        };
                        /**
                         *
                         * @param request
                         * @param headerData
                         * @param callback
                         */
                        this.getBriteBillListOfBills = function (request, headerData) {
                            var _return = {
                                result: '',
                                data: null,
                                message: ''
                            };
                            var deferred = _this.$q.defer();
                            _this.$http.get(_this.config.basic.activatedUserSummaryAPI, {
                                data: request,
                                headers: headerData,
                                cache: false,
                                transformResponse: undefined
                            }).success(function (data) {
                                // check for error messages from server / Auth exipre / other troubles that do return valid JSON
                                if (data) {
                                    _return.result = 'success';
                                    try {
                                        if (data !== 'Customer Not Registered') {
                                            _return.data = JSON.parse(data);
                                        }
                                        else {
                                            _return.data = undefined;
                                            _return.result = 'fail';
                                        }
                                    }
                                    catch (e) {
                                        _return.result = 'fail';
                                        _return.data = undefined;
                                    }
                                }
                                else {
                                    // Fail and display error message
                                    // {'errorCode':10402,'errorMessage':'failed to get account details'}
                                    //_dashboardTravelPackageData = null;
                                    _return.result = 'fail';
                                    _return.data = undefined;
                                }
                                return deferred.resolve(_return);
                            }).error(function (error) {
                                // Error handling - 555 exception
                                if (!error) {
                                    // Fail and display error message
                                    // {'errorCode':10402,'errorMessage':'failed to get account details'}
                                    //_dashboardTravelPackageData = null;
                                    _return.result = 'fail';
                                }
                                else if (!error.data) {
                                    // anything but status code 555
                                    _return.result = 'error';
                                    _return.message = _this.$translate.instant('ute.briteBill.service.error_brite_bill_get_bill_list'); // Pull message from resource file 401 or 5xx situlation
                                }
                                else if (error.data.status === 555) {
                                    // Server error that needs further processing
                                    // additional information for 555 error
                                    // error.error.errorCode		// 10k - 12.1k & 50k - 51k
                                    // error.error.errorMessage		// Message as delivered from server
                                    // error.error.message 			// Message as found in resource file
                                    // error.error.statusCode		// error status code - 555 in this case
                                    _return.result = 'error';
                                    _return.data = null;
                                    _return.message = _this.$translate.instant('ute.briteBill.service.errorCode.' + error.error.errorCode); // Pull message from resource file
                                }
                                else {
                                    // anything but status code 555
                                    _return.result = 'error';
                                    _return.data = null;
                                    _return.message = _this.$translate.instant('ute.briteBill.service.error_brite_bill_get_bill_list'); // Pull message from resource file 401 or 5xx situlation
                                }
                                return deferred.resolve(_return);
                            });
                            return deferred.promise;
                        };
                        //Date filter...
                        //CONVERT DATE IS PART OF BRITEBILL FUNCTIONALITY -- WE NEED TO TURN THIS INTO A FILTER
                        this.convertDate = function (date) {
                            //console.log("date:" +date);
                            //date = "2015-06-01";
                            var _date = date.split('-');
                            // _date[0] - year, _date[1] - month, _date[2] - day
                            var p2 = parseInt(_date[1], 10) - 1;
                            var _dateObj = new Date(parseInt(_date[0], 10), p2, parseInt(_date[2], 10));
                            //console.log(_dateObj);
                            var day = _dateObj.getDate();
                            //Commenting out the date increment as we should use the date that is returned by the britebill server - was causing MYR-1041
                            //day++;
                            var month = _this.$filter('date')(_dateObj, 'MMMM');
                            if (_this.$translate.use().indexOf('en', 0) > -1) {
                                date = month + ' ' + day + ', ' + _dateObj.getFullYear();
                            }
                            else {
                                date = day + ' ' + month + ' ' + _dateObj.getFullYear();
                            }
                            //console.log(userLanguage() + ":" + date);
                            return date;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getIsbritebillAvailable = function (accountNumber) {
                            return _this.getBillData(accountNumber).isbritebillAvailable;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getBBPermission = function () {
                            return _this.bbpermission;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getBriteBillInvoiceDates = function (accountNumber) { return _this.getBillData(accountNumber).briteBillInvoiceDates; };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getLoadingFileData = function () { return _this.loadingFileData; };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getSRC = function (accountNumber) { return _this.getBillData(accountNumber).src; };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getDefaultLink = function (accountNumber) { return _this.getBillData(accountNumber).defaultLink; };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getInvoiceDateSelected = function (accountNumber) { return _this.getBillData(accountNumber).invoiceDateSelected; };
                        /**
                         *
                         * @param date
                         */
                        this.setInvoiceDateSelected = function (accountNumber, date) {
                            _this.getBillData(accountNumber).invoiceDateSelected = date;
                        };
                        /**
                         *
                         * @returns {Array}
                         */
                        this.getInvoiceDateArray = function (currentAccNumber) {
                            return _this.getBriteBillList(currentAccNumber).then(function (billData) { return billData.invoiceDateArray; });
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isNoBillsAvailable = function (accountNumber) { return _this.getBillData(accountNumber).noBillsAvailable; };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isBriteBillErrorOccurred = function (accountNumber) { return _this.getBillData(accountNumber).briteBillErrorOccurred; };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isLoadingBriteBill = function (accountNumber) { return _this.getBillData(accountNumber).loadingBriteBill; };
                        /**
                         *
                         * @returns {null}
                         */
                        this.getBills = function (accountNumber) {
                            return _this.getBriteBillList(accountNumber).then(function (billData) { return billData.briteBills; });
                        };
                        /**
                         *
                         * @param link
                         * @returns {IActivatedUserSummaryBillData}
                         */
                        this.getBillByLink = function (accountNumber, link) {
                            var briteBills = _this.getBillData(accountNumber).briteBills;
                            var index = _.findIndex(briteBills, { content_id: link });
                            return briteBills[index];
                        };
                        /**
                         *
                         * @param currentAccNumber
                         */
                        this.getBriteBillList = function (accountNumber) {
                            if (_this.config.basic.useAccountNumberOverride) {
                                accountNumber = _this.config.basic.accountNumberOverride;
                            }
                            accountNumber = String(accountNumber);
                            var billData = _this.getBillData(accountNumber);
                            if (billData.briteBillLoaded) {
                                return _this.$q.when(billData);
                            }
                            else if (billData.loadingBriteBill) {
                                return billData.promise;
                            }
                            else {
                                billData.loadingBriteBill = true;
                                return billData.promise = _this.brtSwitchService.getValue(ute.common.core.brtswitch.BrtSwitches.BRITEBILL_UTE).then(function (val) {
                                    if (val) {
                                        _this.bbpermission = val;
                                        var bbrequest = {
                                            'currentAccNumber': accountNumber,
                                            'applicationId': _this.config.basic.applicationId
                                        };
                                        return _this.encryptedBriteBillToken(bbrequest).then(function (_tmp) {
                                            if (_tmp.result === 'success') {
                                                if (_tmp.data.encryptedString) {
                                                    var headerData = {
                                                        'EncryptedToken': _tmp.data.encryptedString,
                                                        'If-Modified-Since': 0
                                                    };
                                                    var data = {
                                                        'appID': 'myAccount'
                                                    };
                                                    return _this.getBriteBillListOfBills(data, headerData).then(function (_tmp2) {
                                                        if (_tmp2.result === 'success') {
                                                            if (_tmp2.data && _tmp2.data.bills && _tmp2.data.bills.length > 0) {
                                                                _this.activatedUserSummary = _tmp2.data;
                                                                var bills = _tmp2.data.bills;
                                                                bills.sort(function (a, b) {
                                                                    //Dates are iso std YYYY-MM-DD
                                                                    var c = new Date(a.issue_date); // jshint ignore:line
                                                                    var d = new Date(b.issue_date); // jshint ignore:line
                                                                    return d - c;
                                                                });
                                                                billData.briteBillInvoiceDates = '';
                                                                for (var i = 0; i < bills.length; i++) {
                                                                    // bills[i].name = bills[i].issue_date ? this.convertDate(bills[i].issue_date) : bills[i].name; // jshint ignore:line
                                                                    bills[i].name = bills[i].issue_date;
                                                                    bills[i].id = bills[i].issue_date; // jshint ignore:line
                                                                    if (billData.briteBillInvoiceDates) {
                                                                        billData.briteBillInvoiceDates += ',' + bills[i].issue_date; // jshint ignore:line
                                                                    }
                                                                    else {
                                                                        billData.briteBillInvoiceDates += bills[i].issue_date; // jshint ignore:line
                                                                    }
                                                                }
                                                                if (bills.length > 0) {
                                                                    billData.briteBillOldestDate = bills[bills.length - 1].name;
                                                                }
                                                                billData.briteBills = bills;
                                                                if (bills.length > 0) {
                                                                    billData.isbritebillAvailable = true;
                                                                }
                                                                billData.invoiceDateArray = bills;
                                                                // if (this.userService.getUserType() === this.config.basic.legacyInvoiceDateUserType) {
                                                                //   billData.invoiceDateArray.push({
                                                                //     id: 'legacy',
                                                                //     // name: this.$translate.instant('ute.briteBill.service.acc_balance_view_older_bill')//+ ' ' +this.briteBillOldestDate
                                                                //     name: 'ute.briteBill.service.acc_balance_view_older_bill'
                                                                //   });
                                                                // }
                                                                billData.invoiceDateSelected = bills[0].issue_date; // jshint ignore:line
                                                                billData.showInvoiceDates = true;
                                                                billData.defaultLink = bills[0].link;
                                                            }
                                                            else if (_tmp2.data && _tmp2.data.bills && _tmp2.data.bills.length === 0) {
                                                                billData.noBillsAvailable = true;
                                                            }
                                                            else {
                                                                // no bills
                                                                if (typeof (_tmp2.data) === 'string') {
                                                                    billData.briteBillError = _this.briteBillServerLogs.briteBillError + _tmp2.data;
                                                                }
                                                                else {
                                                                    billData.briteBillError = _this.briteBillServerLogs.briteBillError + 'no bills';
                                                                }
                                                                billData.briteBillErrorOccurred = true;
                                                            }
                                                        }
                                                        else {
                                                            billData.briteBillErrorOccurred = true;
                                                            if (_tmp2.result === 'error') {
                                                                billData.briteBillFailed = true;
                                                            }
                                                        }
                                                        billData.briteBillLoaded = true;
                                                        billData.loadingBriteBill = false;
                                                        return _this.$q.when(billData);
                                                    });
                                                }
                                                else {
                                                    billData.briteBillErrorOccurred = true;
                                                    billData.briteBillLoaded = true;
                                                    billData.loadingBriteBill = false;
                                                    return _this.$q.when(billData);
                                                }
                                            }
                                            else {
                                                billData.briteBillErrorOccurred = true;
                                                billData.briteBillLoaded = true;
                                                billData.loadingBriteBill = false;
                                                billData.briteBillFailed = true;
                                                return _this.$q.when(billData);
                                            }
                                        });
                                    }
                                    else {
                                        billData.briteBillLoaded = true;
                                        billData.loadingBriteBill = false;
                                        billData.briteBillError = _this.briteBillServerLogs.briteBillError + 'brtSwitch is off';
                                        return _this.$q.when(billData);
                                    }
                                }).catch(function () {
                                    billData.briteBillErrorOccurred = true;
                                    billData.briteBillLoaded = true;
                                    billData.loadingBriteBill = false;
                                    billData.briteBillFailed = true;
                                    return _this.$q.when(billData);
                                });
                            }
                        };
                        /**
                         *
                         * @returns {null}
                         */
                        this.getBriteBillOldestDate = function (accountNumber) { return _this.getBillData(accountNumber).briteBillOldestDate; };
                        /**
                         *
                         * @param date
                         */
                        this.setBriteBillOldestDate = function (accountNumber, date) {
                            _this.getBillData(accountNumber).briteBillOldestDate = date;
                        };
                        /**
                         *
                         * @returns {null}
                         */
                        this.getBriteBillError = function (accountNumber) { return _this.getBillData(accountNumber).briteBillError; };
                        /**
                         *
                         * @returns {IBriteBillBillData}
                         */
                        this.getSelectedInvoiceBill = function (accountNumber) {
                            var billData = _this.getBillData(accountNumber);
                            return _.find(billData.invoiceDateArray, { issue_date: billData.invoiceDateSelected }); // jscs:ignore
                        };
                        /**
                         *
                         * @param redirect
                         */
                        this.setLegacyStateRedirect = function (redirect) {
                            _this.useLegacyStateRedirect = redirect;
                        };
                        /**
                         *
                         * @param link
                         * @returns {IPromise<T>}
                         */
                        this.downloadPdfService = function (link) {
                            _this.loadingFileData = true;
                            var d = _this.$q.defer();
                            var param;
                            //var ban: number = this.$window.localStorage.getItem('accountNumber');
                            if (_this.userService.isCare()) {
                                var ban = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                                param = { acctNbr: Number(ban) };
                            }
                            _this.accountOverviewFactory(param).getAccountOverview()
                                .then(function (accountOverview) {
                                var currentAccNumber = accountOverview.getSelectedAccount().accountNumber.toString();
                                if (_this.config.basic.useAccountNumberOverride) {
                                    currentAccNumber = _this.config.basic.accountNumberOverride;
                                }
                                var bbrequest = {
                                    'currentAccNumber': currentAccNumber,
                                    'applicationId': _this.config.basic.applicationId
                                };
                                _this.encryptedBriteBillToken(bbrequest).then(function (_tmp) {
                                    if (_tmp.result === 'success') {
                                        if (_tmp.data.encryptedString) {
                                            _this.loadingFileData = false;
                                            window.location.href = '/rogers_rest/rogers/' + link + '.pdf' + '?download=true&EncryptedToken=' + encodeURIComponent(_tmp.data.encryptedString);
                                            d.resolve(true);
                                        }
                                        else {
                                            d.resolve(false);
                                        }
                                    }
                                    else {
                                        d.resolve(false);
                                    }
                                });
                            });
                            return d.promise;
                        };
                        this.downloadMultiplePdfService = function (links, dates, accountNumber) {
                            _this.loadingFileData = true;
                            var d = _this.$q.defer();
                            var bbrequest = {
                                'currentAccNumber': accountNumber,
                                'applicationId': _this.config.basic.applicationId
                            };
                            _this.encryptedBriteBillToken(bbrequest).then(function (_tmp) {
                                if (_tmp.result === 'success') {
                                    if (_tmp.data.encryptedString) {
                                        _this.loadingFileData = false;
                                        var urls_1 = [];
                                        var filenames_1 = [];
                                        angular.forEach(links, function (value, key) {
                                            urls_1.push('/rogers_rest/rogers/' + value + '.pdf' + '?download=true&EncryptedToken=' + encodeURIComponent(_tmp.data.encryptedString));
                                        });
                                        angular.forEach(dates, function (value, key) {
                                            filenames_1.push(value);
                                        });
                                        angular.forEach(urls_1, function (value, key) {
                                            _this.pdfDownload(value)
                                                .then(function (response) {
                                                if (response) {
                                                    var file = new Blob([response.data], { type: 'pdf' });
                                                    var filename = 'Rogers-' + filenames_1[key] + '.pdf';
                                                    if (window.navigator.msSaveOrOpenBlob) {
                                                        window.navigator.msSaveOrOpenBlob(file, filename);
                                                    }
                                                    else {
                                                        var a = $('<a style="display: none;"/>');
                                                        var url = URL.createObjectURL(file);
                                                        a.attr('href', url);
                                                        a.attr('download', filename);
                                                        $('body').append(a);
                                                        a[0].click();
                                                        setTimeout(function () {
                                                            window.URL.revokeObjectURL(url);
                                                        }, 200);
                                                    }
                                                    d.resolve(true);
                                                }
                                            }).catch(function (errResponse) {
                                                d.reject('error');
                                            });
                                        });
                                    }
                                    else {
                                        _this.loadingFileData = false;
                                        d.resolve(false);
                                    }
                                }
                                else {
                                    _this.loadingFileData = false;
                                    d.reject('error');
                                }
                            }).catch(function (error) {
                                _this.loadingFileData = false;
                                d.reject('error');
                            });
                            return d.promise;
                        };
                        /**
                         *
                         * @param link
                         */
                        this.downloadExcelService = function (link) {
                            return _this.downloadFileService(link, _this.config.advanced.excelAppType);
                        };
                        /**
                         *
                         * @param link
                         */
                        this.downloadCSVService = function (link) {
                            return _this.downloadFileService(link, _this.config.advanced.csvAppType);
                        };
                        /**
                         *
                         * @param link
                         * @param fileType
                         * @returns {IPromise<T>}
                         */
                        this.downloadFileService = function (link, fileType) {
                            _this.loadingFileData = true;
                            var d = _this.$q.defer();
                            var param;
                            //var ban: number = this.$window.localStorage.getItem('accountNumber');
                            if (_this.userService.isCare()) {
                                var ban = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                                param = { acctNbr: Number(ban) };
                            }
                            _this.accountOverviewFactory(param).getAccountOverview()
                                .then(function (accountOverview) {
                                var currentAccNumber = accountOverview.getSelectedAccount().accountNumber.toString();
                                if (_this.config.basic.useAccountNumberOverride) {
                                    currentAccNumber = _this.config.basic.accountNumberOverride;
                                }
                                var bbrequest = {
                                    'currentAccNumber': currentAccNumber,
                                    'applicationId': _this.config.basic.applicationId
                                };
                                _this.encryptedBriteBillToken(bbrequest).then(function (_tmp) {
                                    if (_tmp.result === 'success') {
                                        if (_tmp.data.encryptedString) {
                                            var billDate = new Date(_this.getBillByLink(currentAccNumber, link).issue_date);
                                            billDate.setDate(billDate.getDate() + 1);
                                            var billCycle = _this.$filter('date')(billDate, 'MMMdd_yyyy');
                                            _this.$http({
                                                method: 'GET',
                                                headers: {
                                                    'Accept': fileType
                                                },
                                                url: '/rogers_rest/rogers/document/' + link + '/usage/details/Rogers-' + billCycle + '-' + currentAccNumber + '-Usage/?download=true&EncryptedToken=' + encodeURIComponent(_tmp.data.encryptedString),
                                                responseType: 'arraybuffer'
                                            }).then(function (result) {
                                                _this.loadingFileData = false;
                                                var extension = fileType === _this.config.advanced.excelAppType ? '.xls' : '.csv';
                                                var data = result.data;
                                                var filename = 'Rogers-' + billCycle + '-' + currentAccNumber + '-Usage' + extension;
                                                var type = fileType;
                                                var a = $('<a style="display: none;"/>');
                                                var file = new Blob([data], { type: type });
                                                if (window.navigator.msSaveOrOpenBlob) {
                                                    window.navigator.msSaveOrOpenBlob(file, filename);
                                                    d.resolve(true);
                                                }
                                                else {
                                                    var url = URL.createObjectURL(file);
                                                    a.attr('href', url);
                                                    a.attr('download', filename);
                                                    $('body').append(a);
                                                    a[0].click();
                                                    setTimeout(function () {
                                                        window.URL.revokeObjectURL(url);
                                                    }, 200); // Added time out for firefox, as it removes the link before invoking
                                                    a.remove();
                                                    d.resolve(true);
                                                }
                                            }).catch(function (result) {
                                                _this.loadingFileData = false;
                                                if (result.status === 417) {
                                                    d.resolve('noData');
                                                }
                                                else {
                                                    d.resolve('error');
                                                }
                                            });
                                        }
                                    }
                                });
                            });
                            return d.promise;
                        };
                        this.getPrintBillSRC = function () { return _this.printBillSRC; };
                        this.setPrintBillSRC = function (link) {
                            _this.loadingFileData = true;
                            var d = _this.$q.defer();
                            var param;
                            //var ban: number = this.$window.localStorage.getItem('accountNumber');
                            if (_this.userService.isCare()) {
                                var ban = _this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER);
                                param = { acctNbr: Number(ban) };
                            }
                            _this.accountOverviewFactory(param).getAccountOverview()
                                .then(function (accountOverview) {
                                var currentAccNumber = accountOverview.getSelectedAccount().accountNumber.toString();
                                if (_this.config.basic.useAccountNumberOverride) {
                                    currentAccNumber = _this.config.basic.accountNumberOverride;
                                }
                                var bbrequest = {
                                    'currentAccNumber': currentAccNumber,
                                    'applicationId': _this.config.basic.applicationId
                                };
                                _this.encryptedBriteBillToken(bbrequest).then(function (_tmp) {
                                    if (_tmp.result === 'success') {
                                        if (_tmp.data.encryptedString) {
                                            _this.loadingFileData = false;
                                            _this.printBillSRC = '/rogers_rest/rogers/' + link + '.pdf' + '?download=false&EncryptedToken=' + encodeURIComponent(_tmp.data.encryptedString);
                                        }
                                    }
                                    else {
                                        _this.loadingFileData = false;
                                        d.resolve(false);
                                    }
                                });
                            });
                            return d.promise;
                        };
                        this.getBillData = function (accountNumber) {
                            accountNumber = String(accountNumber);
                            var billData = _this.billsData[accountNumber];
                            if (!billData) {
                                billData = {
                                    src: 'about:blank',
                                    defaultLink: '',
                                    loadingBriteBill: false,
                                    briteBillLoaded: false,
                                    briteBills: [],
                                    briteBillError: '',
                                    briteBillOldestDate: '',
                                    invoiceDateSelected: '',
                                    invoiceDateArray: [],
                                    briteBillInvoiceDates: '',
                                    briteBillFailed: false,
                                    noBillsAvailable: false,
                                    briteBillErrorOccurred: false,
                                    showInvoiceDates: false,
                                    isbritebillAvailable: false
                                };
                                _this.billsData[accountNumber] = billData;
                            }
                            return billData;
                        };
                        this.signoutHandler = function (event) {
                            _this.billsData = [];
                        };
                        this.clearBillsData = function () {
                            _this.billsData = [];
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$q',
                            '$window',
                            '$filter',
                            '$translate'
                        ];
                        this.billsData = [];
                    }
                    BriteBillProvider.prototype.pdfDownload = function (url) {
                        var deferred = this.$q.defer();
                        this.$http({
                            method: 'get',
                            url: url,
                            headers: {
                                'Content-type': 'application/pdf'
                            },
                            responseType: 'blob'
                        }).then(function (response) {
                            deferred.resolve(response);
                        }).catch(function (errorResponse) {
                            deferred.reject(errorResponse);
                        });
                        return deferred.promise;
                    };
                    BriteBillProvider.$inject = [
                        'ute.rogers.account.overview.factoryProvider', '$injector'];
                    return BriteBillProvider;
                }());
                angular.module('ute.brite.bill.service').provider('ute.brite.bill.service', BriteBillProvider);
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureDealerCodeProvider = (function () {
                    /* @ngInject */
                    function CaptureDealerCodeProvider() {
                        var _this = this;
                        this.isDisplayDealerCodePopUp = true;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                agentInfoUrl: 'v1/agentInfo',
                                dealerCodeRetrievalApiUrl: 'v1/userPreferenceRetrieval',
                                saveDealerCodeApiUrl: 'v1/oneView/saveDealerCode',
                                userPreferenceUpdateApiUrl: 'v1/userPreferenceUpdate',
                                getDealerProfileApiUrl: 'v1/oneView/dealerProfile'
                            },
                            advanced: {
                                captureDealerCodeFormDirective: {
                                    templateUrl: 'module/captureDealerCode/captureDealerCodeDirective/captureDealerCodeForm/captureDealerCodeForm.partial.html',
                                    controllerName: 'ute.capture.dealer.code.form.controller'
                                },
                                onBehalfOfDealerCodeDirective: {
                                    templateUrl: 'module/captureDealerCode/captureDealerCodeDirective/onBehalfOfDealerCode/onBehalfOfdealerCode.html',
                                    controllerName: 'ute.capture.dealer.code.behalf.controller'
                                },
                                updateDealerCodeDirective: {
                                    templateUrl: 'module/captureDealerCode/captureDealerCodeDirective/updateDealerCode/updateDealerCode.html',
                                    controllerName: 'ute.capture.dealer.code.update.controller'
                                },
                                captureDealerCodeModals: {
                                    captureDealerCodeModal: {
                                        windowTemplateUrl: 'module/captureDealerCode/captureDealerCodeWindow.modal.view.html',
                                        templateUrl: 'module/captureDealerCode/captureDealerCodeModals/captureDealerCodeModal/captureDealerCodeModal.html',
                                        controllerName: 'capture.dealer.code.modal.controller'
                                    },
                                    proceedWithoutDealerCodeModal: {
                                        windowTemplateUrl: 'module/captureDealerCode/captureDealerCodeWindow.modal.view.html',
                                        templateUrl: 'module/captureDealerCode/captureDealerCodeModals/proceedWithoutDealerCodeModal/proceedWithoutDealerCodeModal.html',
                                        controllerName: 'proceed.with.out.dealer.code.modal.controller'
                                    },
                                    captureNacDealerCodeModal: {
                                        windowTemplateUrl: 'module/captureDealerCode/captureDealerCodeWindow.modal.view.html',
                                        templateUrl: 'module/captureDealerCode/captureDealerCodeModals/CaptureNacDealerCodeModal/CaptureNacDealerCodeModal.html',
                                        controllerName: 'capture.nac.dealer.code.modal.controller'
                                    },
                                    captureDealerCodeErrorModal: {
                                        windowTemplateUrl: 'module/captureDealerCode/captureDealerCodeWindow.modal.view.html',
                                        templateUrl: 'module/captureDealerCode/captureDealerCodeModals/captureDealerCodeErrorModal/captureDealerCodeErrorModal.html',
                                        controllerName: 'capture.dealer.code.error.modal.controller'
                                    }
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($modal, $injector, $http, $q, $state, sessionStorage) {
                            _this.$modal = $modal;
                            _this.$injector = $injector;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.$state = $state;
                            _this.messagesService = $injector.get('ute.blocks.messages.bus.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.permissionsService = $injector.get('ute.common.permissions.service');
                            _this.sessionStorage = sessionStorage;
                            return {
                                getConfig: _this.getConfig,
                                getModel: _this.getModel,
                                getAccountNumber: _this.getAccountNumber,
                                getUserType: _this.getUserType,
                                agentInfo: _this.agentInfo,
                                checkDCPermitted: _this.checkDCPermitted,
                                retrieveDealerCode: _this.retrieveDealerCode,
                                retrieveDealerCodeAPI: _this.retrieveDealerCodeAPI,
                                saveDealerCode: _this.saveDealerCode,
                                updateUserPreferenceTable: _this.updateUserPreferenceTable,
                                submit: _this.submit,
                                submitToSessionTable: _this.submitToSessionTable,
                                showCaptureDealerCodeModal: _this.showCaptureDealerCodeModal,
                                showProceedWithoutDealerCodeModal: _this.showProceedWithoutDealerCodeModal,
                                showCaptureNacDealerCodeModal: _this.showCaptureNacDealerCodeModal,
                                showCaptureDealerCodeErrorModal: _this.showCaptureDealerCodeErrorModal,
                                getDealerProfile: _this.getDealerProfile,
                                isDealerCodeExist: _this.isDealerCodeExist,
                                getLanguage: _this.getLanguage
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        this.getUserType = function () {
                            return _this.userService.getUserType();
                        };
                        this.getAccountNumber = function () {
                            return _this.sessionStorage.getSessionStorageValue('requestedAccountNumber');
                        };
                        this.isDealerCodeExist = function () {
                            if (_this.model.storedDealerCode || _this.model.behalfOfDealerCode) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.agentInfo = function () {
                            var request;
                            if (_this.userType === 'care' && !_this.model.isNacFlow) {
                                _this.accountNumber = _this.getAccountNumber();
                                request = {
                                    acctNbr: _this.accountNumber
                                };
                            }
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.agentInfoUrl), request)
                                .then(_this.processAgentInfoSuccess)
                                .catch(_this.processAgentInfoError)
                                .finally(_this.finaliseAgentInfoCall);
                        };
                        this.processAgentInfoSuccess = function (response) {
                            if (response.data) {
                                var userInfo = response.data;
                                _this.userId = userInfo.lanId;
                                _this.dealerCodeFromAgentInfo = userInfo.dealerCode;
                                if (_this.dealerCodeFromAgentInfo && _this.dealerCodeFromAgentInfo !== '') {
                                    _this.model.behalfOfDealerCode = _this.dealerCodeFromAgentInfo;
                                }
                                return userInfo;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processAgentInfoError = function (reason) {
                            return false;
                        };
                        this.finaliseAgentInfoCall = function () {
                            return true;
                        };
                        this.checkDCPermitted = function () {
                            return _this.isDealerCodePermitted;
                        };
                        this.retrieveDealerCode = function (flowName) {
                            _this.userType = _this.getUserType();
                            if (_this.userType === 'care') {
                                _this.permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.RAM)
                                    .then(function (isPermitted) {
                                    if (isPermitted) {
                                        _this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
                                            .then(function (DealerCodePermission) {
                                            if (DealerCodePermission) {
                                                _this.isDealerCodePermitted = true;
                                                if (flowName === code.Flows.NAC) {
                                                    _this.model.isNacFlow = true;
                                                }
                                                _this.agentInfo().then(function (result) {
                                                    if (result !== false) {
                                                        _this.retrieveDealerCodeAPI().then(function (result) {
                                                            if (result !== false) {
                                                                if (_this.isDealerCodeExist()) {
                                                                    if (_this.model.isNacFlow) {
                                                                        if (_this.dealerCodeFromAgentInfo !== '' && _this.dealerCodeFromAgentInfo !== _this.model.storedDealerCode) {
                                                                        }
                                                                        else {
                                                                            _this.showCaptureNacDealerCodeModal();
                                                                        }
                                                                    }
                                                                    else {
                                                                        //Checking agentInfo dc (may be SESSION dc) and userpreference dc are same or not on ONLOAD
                                                                        // Message service to update DEALER CODE in the rep view Header AND behalf of dealer code section
                                                                        if (_this.dealerCodeFromAgentInfo !== '' && _this.dealerCodeFromAgentInfo !== _this.model.storedDealerCode) {
                                                                            _this.messagesService.publish('ute-capture-DC-on-header', _this.dealerCodeFromAgentInfo);
                                                                            _this.messagesService.publish('ute-capture-DC-at-repName', _this.model.storedDealerCode);
                                                                        }
                                                                        else {
                                                                            _this.saveDealerCode(_this.model.storedDealerCode).then(function (result) {
                                                                                if (result !== false) {
                                                                                    _this.messagesService.publish('ute-capture-DC-on-header');
                                                                                    _this.messagesService.publish('ute-capture-DC-at-repName', _this.model.storedDealerCode);
                                                                                }
                                                                                else {
                                                                                    _this.messagesService.publish('ute-capture-DC-on-header');
                                                                                    _this.messagesService.publish('ute-capture-DC-at-repName');
                                                                                }
                                                                            });
                                                                        }
                                                                    }
                                                                }
                                                                else {
                                                                    if (_this.model.isNacFlow) {
                                                                        _this.showCaptureDealerCodeModal();
                                                                    }
                                                                    else if (_this.isDisplayDealerCodePopUp) {
                                                                        _this.showCaptureDealerCodeModal();
                                                                    }
                                                                    else {
                                                                        _this.messagesService.publish('ute-capture-DC-on-header');
                                                                        _this.messagesService.publish('ute-capture-DC-at-repName');
                                                                    }
                                                                }
                                                            }
                                                            else {
                                                                // Message service to update NO CODE in the rep view Header AND behalf of dealer code section
                                                                if (!_this.model.isNacFlow) {
                                                                    _this.messagesService.publish('ute-capture-DC-on-header');
                                                                    _this.messagesService.publish('ute-capture-DC-at-repName');
                                                                }
                                                            }
                                                        });
                                                    }
                                                    else {
                                                        // Message service to update NO CODE in the rep view Header AND behalf of dealer code section
                                                        if (!_this.model.isNacFlow) {
                                                            _this.messagesService.publish('ute-capture-DC-on-header');
                                                            _this.messagesService.publish('ute-capture-DC-at-repName');
                                                        }
                                                    }
                                                });
                                            }
                                        });
                                    }
                                });
                            }
                        };
                        this.retrieveDealerCodeAPI = function () {
                            var request = {
                                userId: _this.userId
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dealerCodeRetrievalApiUrl), request)
                                .then(_this.processRetrieveDCSuccess)
                                .catch(_this.processRetrieveDCError)
                                .finally(_this.finalizeRetrieveDCCall);
                        };
                        this.processRetrieveDCSuccess = function (response) {
                            /* tslint:disable */
                            if (_.some(response.data.userPreference, { "name": "dealerCode" })) {
                                var dealerCode = _.find(response.data.userPreference, function (obj) {
                                    return obj.name === 'dealerCode';
                                });
                                _this.model.storedDealerCode = dealerCode.value;
                                return dealerCode.value;
                            }
                            else if (_.some(response.data.userPreference, { "name": "displayDealerCodePopUp" })) {
                                var displayDealerCodePopUp = _.find(response.data.userPreference, function (obj) {
                                    return obj.name === 'displayDealerCodePopUp';
                                });
                                _this.isDisplayDealerCodePopUp = displayDealerCodePopUp.value;
                                return true;
                            }
                            else {
                                return true;
                            }
                        };
                        this.processRetrieveDCError = function (reason) {
                            return false;
                        };
                        this.finalizeRetrieveDCCall = function () {
                            return true;
                        };
                        this.saveDealerCode = function (dealerCodeValue) {
                            var ban = _this.getAccountNumber();
                            var request = {
                                dealerCode: dealerCodeValue
                            };
                            if (!_this.model.isNacFlow) {
                                request.acctNbr = Number(ban);
                            }
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.saveDealerCodeApiUrl), request)
                                .then(_this.processSaveDCSuccess)
                                .catch(_this.processSaveDCError)
                                .finally(_this.finalizeSaveDCCall);
                        };
                        this.processSaveDCSuccess = function (response) {
                            /* tslint:disable */
                            if (response.data === "Succeeded") {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processSaveDCError = function (reason) {
                            return false;
                        };
                        this.finalizeSaveDCCall = function () {
                            return true;
                        };
                        this.updateUserPreferenceTable = function (preferenceName, preferenceValue) {
                            var request = {
                                userId: _this.userId,
                                userType: _this.userType,
                                userPreferenceName: preferenceName,
                                userPreferenceValue: preferenceValue
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.userPreferenceUpdateApiUrl), request)
                                .then(_this.processUpdateDCSuccess)
                                .catch(_this.processUpdateDCError)
                                .finally(_this.finalizeUpdateDCCall);
                        };
                        this.processUpdateDCSuccess = function (response) {
                            /* tslint:disable */
                            if (response.status === 200) {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processUpdateDCError = function (reason) {
                            return false;
                        };
                        this.finalizeUpdateDCCall = function () {
                            return true;
                        };
                        this.getDealerProfile = function (dealerCodeValue) {
                            var request = {
                                dealerID: dealerCodeValue
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.getDealerProfileApiUrl), request)
                                .then(_this.processGetDCSuccess)
                                .catch(_this.processGetDCError)
                                .finally(_this.finalizeGetDCCall);
                        };
                        this.processGetDCSuccess = function (response) {
                            /* tslint:disable */
                            if (response.status === 200) {
                                return response.data;
                            }
                            else {
                                return false;
                            }
                        };
                        this.processGetDCError = function (reason) {
                            return false;
                        };
                        this.finalizeGetDCCall = function () {
                            return true;
                        };
                        //Submit functionality Save dealerCode in userPreference and sessions Table
                        this.submit = function (dealerCodeValue) {
                            var d = _this.$q.defer();
                            _this.getDealerProfile(dealerCodeValue).then(function (result) {
                                if (result !== false) {
                                    var gerProfileResponse = result;
                                    if (gerProfileResponse.success) {
                                        _this.updateUserPreferenceTable('dealerCode', dealerCodeValue).then(function (result) {
                                            if (result !== false) {
                                                _this.saveDealerCode(dealerCodeValue).then(function (result) {
                                                    if (result !== false) {
                                                        _this.model.storedDealerCode = dealerCodeValue;
                                                        if (!_this.model.isNacFlow) {
                                                            _this.messagesService.publish('ute-capture-DC-on-header');
                                                            _this.messagesService.publish('ute-capture-DC-at-repName', dealerCodeValue);
                                                        }
                                                        else {
                                                            _this.sessionStorage.setSessionStorageValue('dealerCode', dealerCodeValue);
                                                        }
                                                        d.resolve(true);
                                                    }
                                                    else {
                                                        d.resolve('error');
                                                    }
                                                });
                                            }
                                            else {
                                                d.resolve('error');
                                            }
                                        });
                                    }
                                    else {
                                        d.resolve(false);
                                    }
                                }
                                else {
                                    d.resolve('error');
                                }
                            });
                            return d.promise;
                        };
                        this.submitToSessionTable = function (dealerCodeValue) {
                            var d = _this.$q.defer();
                            _this.getDealerProfile(dealerCodeValue).then(function (result) {
                                if (result !== false) {
                                    var gerProfileResponse = result;
                                    if (gerProfileResponse.success) {
                                        _this.saveDealerCode(dealerCodeValue).then(function (result) {
                                            if (result !== false) {
                                                _this.model.behalfOfDealerCode = dealerCodeValue;
                                                d.resolve(true);
                                            }
                                            else {
                                                d.resolve('error');
                                            }
                                        });
                                    }
                                    else {
                                        d.resolve(false);
                                    }
                                }
                                else {
                                    d.resolve('error');
                                }
                            });
                            return d.promise;
                        };
                        this.showCaptureDealerCodeModal = function () {
                            _this.$modal.open({
                                templateUrl: _this.getConfig().advanced.captureDealerCodeModals.captureDealerCodeModal.templateUrl,
                                controller: _this.getConfig().advanced.captureDealerCodeModals.captureDealerCodeModal.controllerName,
                                controllerAs: 'DCModalController',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                keyboard: false,
                            }).result.then(function (result) {
                                if (_this.isDealerCodeExist()) {
                                    _this.messagesService.publish('ute-capture-DC-at-repName', _this.model.storedDealerCode);
                                }
                                else {
                                    _this.messagesService.publish('ute-capture-DC-at-repName');
                                }
                                _this.messagesService.publish('ute-capture-DC-on-header');
                            }, function (result) {
                                _this.showProceedWithoutDealerCodeModal().then(function (result) {
                                    //Message Service to update dealer code with No Code
                                    if (result === false) {
                                        _this.messagesService.publish('ute-capture-DC-on-header');
                                        _this.messagesService.publish('ute-capture-DC-at-repName');
                                    }
                                });
                            });
                        };
                        this.showProceedWithoutDealerCodeModal = function () {
                            var d = _this.$q.defer();
                            _this.$modal.open({
                                templateUrl: _this.getConfig().advanced.captureDealerCodeModals.proceedWithoutDealerCodeModal.templateUrl,
                                controller: _this.getConfig().advanced.captureDealerCodeModals.proceedWithoutDealerCodeModal.controllerName,
                                controllerAs: 'withoutDCModalController',
                                size: 'md',
                                backdrop: 'static',
                                keyboard: false,
                                backdropClass: 'bkg-modal',
                            }).result.then(function (result) {
                                d.resolve(true);
                            }, function (result) {
                                d.resolve(false);
                            });
                            return d.promise;
                        };
                        this.showCaptureNacDealerCodeModal = function () {
                            _this.$modal.open({
                                templateUrl: _this.getConfig().advanced.captureDealerCodeModals.captureNacDealerCodeModal.templateUrl,
                                controller: _this.getConfig().advanced.captureDealerCodeModals.captureNacDealerCodeModal.controllerName,
                                controllerAs: 'nacDCModalController',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                keyboard: false,
                            }).result.then(function (result) {
                            }, function (result) {
                            });
                        };
                        this.showCaptureDealerCodeErrorModal = function () {
                            _this.$modal.open({
                                templateUrl: _this.getConfig().advanced.captureDealerCodeModals.captureDealerCodeErrorModal.templateUrl,
                                controller: _this.getConfig().advanced.captureDealerCodeModals.captureDealerCodeErrorModal.controllerName,
                                controllerAs: 'errorModalController',
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                keyboard: false,
                            }).result.then(function (result) {
                            }, function (result) {
                                //Message service to update NOCode on failure of any API call, when no dealer code exist
                                if (!_this.model.storedDealerCode) {
                                    _this.messagesService.publish('ute-capture-DC-on-header');
                                    _this.messagesService.publish('ute-capture-DC-at-repName');
                                }
                            });
                        };
                        this.getLanguage = function () {
                            var languageService = _this.$injector.get('ute.blocks.language.switcher');
                            var lang = languageService.getCurrentLanguage();
                            return lang;
                        };
                        this.resetModel = function () {
                            _this.model = {
                                storedDealerCode: null,
                                behalfOfDealerCode: null,
                                isNacFlow: false
                            };
                        };
                        this.$get.$inject = [
                            '$modal',
                            '$injector',
                            '$http',
                            '$q',
                            '$state',
                            'sessionStorage'
                        ];
                        this.resetModel();
                    }
                    CaptureDealerCodeProvider.$inject = [];
                    CaptureDealerCodeProvider.serviceName = 'ute.capture.dealer.code.service';
                    return CaptureDealerCodeProvider;
                }());
                angular.module('ute.capture.dealer.code').provider(CaptureDealerCodeProvider.serviceName, CaptureDealerCodeProvider);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var browser;
            (function (browser) {
                'use strict';
                // TODO provider
                var BrowserService = (function () {
                    /* @ngInject */
                    function BrowserService($window) {
                        var _this = this;
                        this.$window = $window;
                        this._isMobile = false;
                        /**
                         * @param keys
                         * @returns {boolean}
                         */
                        this.isMobile = function () {
                            return _this._isMobile;
                        };
                        this.isWindowsMobile = function () {
                            return /IEMobile/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isAndroid = function () {
                            return /Android/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isBlackBerry = function () {
                            return /BlackBerry/i.test(_this.$window.navigator.userAgent);
                        };
                        this.isIOS = function () {
                            return /iPhone|iPad|iPod/i.test(_this.$window.navigator.userAgent);
                        };
                        // to check for specific instances of ipad, test for ipad pro to be added
                        this.isIpad = function () {
                            return /iPad/i.test(_this.$window.navigator.userAgent);
                        };
                        this._isMobile = (this.isAndroid() || this.isBlackBerry() || this.isIOS() || this.isWindowsMobile());
                    }
                    BrowserService.$inject = ['$window'];
                    BrowserService.serviceName = 'ute.common.core.browser.service';
                    return BrowserService;
                }());
                angular.module('ute.common.core.browser').service(BrowserService.serviceName, BrowserService);
            })(browser = core.browser || (core.browser = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                'use strict';
                (function (ApplicationDomain) {
                    ApplicationDomain[ApplicationDomain["FIDO"] = 0] = "FIDO";
                    ApplicationDomain[ApplicationDomain["ROGERS"] = 1] = "ROGERS";
                    ApplicationDomain[ApplicationDomain["SMB"] = 2] = "SMB";
                })(brtswitch.ApplicationDomain || (brtswitch.ApplicationDomain = {}));
                var ApplicationDomain = brtswitch.ApplicationDomain;
                // TODO provider
                var BrtSwitchService = (function () {
                    /* @ngInject */
                    function BrtSwitchService($http, $timeout, exceptionHandler) {
                        var _this = this;
                        this.$http = $http;
                        this.$timeout = $timeout;
                        this.exceptionHandler = exceptionHandler;
                        /**
                         * @param key
                         * @returns {IPromise<boolean>}
                         */
                        this.getValue = function (key, seeker) {
                            return _this.getBrtSwitches(seeker).then(function (val) {
                                return _.get(_.find(val, { 'id': _.isNumber(key) ? brtswitch.BrtSwitches[key] : key }), 'switchIsOn');
                            });
                        };
                        /**
                         * @param keys
                         * @returns {IPromise<boolean>}
                         */
                        this.isSome = function (keys) {
                            return _this.getBrtSwitches().then(function (vals) {
                                return _.isEmpty(keys) ? false : _.intersection(_.chain(vals)
                                    .filter({ switchIsOn: true })
                                    .map(function (e) { return e.id; })
                                    .value(), _this.getKeys(keys)).length > 0;
                            });
                        };
                        /**
                         * @param keys
                         */
                        this.getKeys = function (keys) {
                            return _.isEmpty(keys) ? [] : _.isNumber(keys[0]) ? keys.map(function (key) { return brtswitch.BrtSwitches[key]; }) : keys;
                        };
                        /**
                         * @returns {IPromise<IBrtSwitches>}
                         * @private
                         */
                        this._getBrtSwitches = function (seeker) {
                            var url = '/web/totes/api/v1/brtSwitches';
                            if (!_.isUndefined(seeker) && _.isNumber(seeker)) {
                                if (ute.common.core.brtswitch.ApplicationDomain.FIDO === seeker) {
                                    url = '/bfa-api/v1/brtSwitches';
                                }
                                else if (ute.common.core.brtswitch.ApplicationDomain.SMB === seeker) {
                                    url = '/web/smb/api/v1/brtSwitches';
                                }
                                else if (ute.common.core.brtswitch.ApplicationDomain.ROGERS === seeker) {
                                    url = '/web/totes/api/v1/brtSwitches';
                                }
                                else {
                                    url = '/web/totes/api/v1/brtSwitches';
                                }
                            }
                            return _this.$http.post(url, {})
                                .then(_this.processBrtSwitchesResponse)
                                .catch(_.curry(_this.fail)('processBrtSwitchesResponse failed.'));
                        };
                        /**
                         * @param response
                         * @returns {IBrtSwitches}
                         */
                        this.processBrtSwitchesResponse = function (response) {
                            // console.log(BrtSwitchService.serviceName + '->processBrtSwitchesResponse', response.data);
                            return _.get(response, 'data', []);
                        };
                        /**
                         * @param reason
                         * @param error
                         * @returns {IBrtSwitches}
                         */
                        this.fail = function (reason, error) {
                            var msg = _.get(error, 'data.description', error);
                            _this.exceptionHandler.catcher(msg)(reason, 'ute.common.core.brtswitch fail');
                            _this.$timeout(_this.cleanCache);
                            return [];
                        };
                        this.cleanCache = function () {
                            _this.getBrtSwitches.cache.clear();
                        };
                        (_.memoize).Cache = window.Map; // required https://www.npmjs.com/package/es6-shim
                        this.getBrtSwitches = _.memoize(this._getBrtSwitches);
                    }
                    BrtSwitchService.$inject = [
                        '$http',
                        '$timeout',
                        'ute.blocks.exceptionService'
                    ];
                    BrtSwitchService.serviceName = 'ute.common.core.brtswitch.service';
                    return BrtSwitchService;
                }());
                angular.module('ute.common.core.brtswitch').service(BrtSwitchService.serviceName, BrtSwitchService);
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var caching;
            (function (caching) {
                'use strict';
                var CacheableDataService = (function () {
                    function CacheableDataService(securityService, userService, $http, $q) {
                        var _this = this;
                        this.securityService = securityService;
                        this.userService = userService;
                        this.$http = $http;
                        this.$q = $q;
                        this._getWorker = function (payload) {
                            return new CacheableDataWorker(_this.securityService, _this.$http, _this.$q, _this.userService, payload);
                        };
                        this.getWorker = _.memoize(this._getWorker, JSON.stringify);
                    }
                    ;
                    return CacheableDataService;
                }());
                var CacheableDataWorker = (function () {
                    function CacheableDataWorker(securityService, $http, $q, userService, payload) {
                        var _this = this;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.userService = userService;
                        this.payload = payload;
                        /**
                         * @returns {ng.IPromise<any>}
                         */
                        this.getData = function () {
                            if (_this.isDataLocallyCached()) {
                                if (!_this.callInProgress && !_this.isLocalDataUpToDate()) {
                                    return _this.getDataFromServer();
                                }
                                return _this.$q.when(_.cloneDeep(_this.cacheableData.data));
                            }
                            else if (_this.callInProgress) {
                                // other call with the same request data
                                return _this.callInProgress;
                            }
                            else {
                                // Fastest way to get it from Play!/Cassandra
                                return _this.getDataFromServer();
                            }
                        };
                        this.resetData = function () {
                            try {
                                _this.cleanup();
                            }
                            catch (e) {
                            }
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isCallInProgress = function () {
                            return !!_this.callInProgress;
                        };
                        /**
                         *
                         * @returns {ng.IPromise<any>}
                         */
                        this.getDataFromServer = function () {
                            _this.callInProgress = _this.$http.post(_this.securityService.getBackendUrl(_this.payload.url), _this.payload.postData)
                                .then(_this.processOk)
                                .catch(_this.processError)
                                .finally(function () { return _this.callInProgress = null; });
                            return _this.callInProgress;
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            _this.cacheableData = {
                                localCachedDate: new Date(),
                                data: response
                            };
                            // return immutable copy
                            return _.cloneDeep(_this.cacheableData.data);
                        };
                        this.processError = function (error) {
                            return _this.$q.reject(error);
                        };
                        /**
                         * @returns {boolean}
                         */
                        this.isDataLocallyCached = function () {
                            return _.isObject(_this.cacheableData);
                        };
                        this.cleanup = function () {
                            _this.cacheableData = null;
                        };
                        /**
                         * Check if local data up to date - 60 sec for now
                         * @returns {boolean}
                         */
                        this.isLocalDataUpToDate = function () {
                            var retval = _this.isDataLocallyCached() && new Date().getTime() - _this.cacheableData.localCachedDate.getTime() <= 60000;
                            return retval;
                        };
                        this.userService.registerSigninHandler(this.cleanup, this);
                    }
                    return CacheableDataWorker;
                }());
                var CacheableDataFactory = (function () {
                    function CacheableDataFactory(securityService, userService, $http, $q) {
                        var factory = new CacheableDataService(securityService, userService, $http, $q);
                        return function (payload) {
                            return factory.getWorker(payload);
                        };
                    }
                    CacheableDataFactory.$inject = [
                        'ute.common.security.service',
                        'ute.common.user.service',
                        '$http',
                        '$q'
                    ];
                    return CacheableDataFactory;
                }());
                angular.module('ute.common.core.caching').factory('ute.common.core.caching.CacheableDataFactory', CacheableDataFactory);
            })(caching = core.caching || (core.caching = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    var CreditManagementController = (function () {
                        /* @ngInject */
                        function CreditManagementController($modal, customerCreditManagementService, $state, languageService) {
                            var _this = this;
                            this.$modal = $modal;
                            this.customerCreditManagementService = customerCreditManagementService;
                            this.$state = $state;
                            this.languageService = languageService;
                            this.loadCreditAdjustmentDetails = function () {
                                _this.customerCreditManagementService.retrieveCreditAdjustmentConfig().then(function (response) {
                                    _this.customerCreditManagementService.configure({
                                        basic: {
                                            maxAllowedAmount: response.data.maxAllowedAmount,
                                            allowedDiscCreditSOCs: response.data.discretionaryCreditSOCs,
                                            allowedNonDiscCreditSOCs: response.data.nonDiscretionaryCreditSOCPatterns,
                                            preDefinedNonDiscCheckSOCs: response.data.nonDiscretionaryCreditSOCs
                                        }
                                    });
                                    console.log('goToEntryState :: this.config', _this.customerCreditManagementService.getConfig());
                                    _this.retrieveDiscCreditAdjustmentInfoService();
                                    _this.retrieveNonDiscCreditAdjustmentInfoService();
                                    return response;
                                });
                            };
                            /**
                             * Get Selected Subscriber Number
                             */
                            this.getSelectedSubscriberNumber = function () {
                                return _this.customerCreditManagementService.getSelectedSubscriberNumber();
                            };
                            /**
                             * Set Selected Subscriber Number
                             */
                            this.setSelectedSubscriberNumber = function (selectedSubscriber) {
                                return _this.customerCreditManagementService.setSelectedSubscriberNumber(selectedSubscriber);
                            };
                            /**
                             * Set DiscCreditAdjustment Call InProgress
                             */
                            this.setDiscCreditAdjustmentCallInProgress = function (flag) {
                                return _this.customerCreditManagementService.setDiscCreditAdjustmentCallInProgress(flag);
                            };
                            /**
                             * Set NonDiscCreditAdjustment Call InProgress
                             */
                            this.setNonDiscCreditAdjustmentCallInProgress = function (flag) {
                                return _this.customerCreditManagementService.setNonDiscCreditAdjustmentCallInProgress(flag);
                            };
                            /**
                             * Set Valid DiscCreditAdjustmentList
                             */
                            this.setValidDiscCreditAdjustmentList = function (flag) {
                                return _this.customerCreditManagementService.setValidDiscCreditAdjustmentList(flag);
                            };
                            /**
                             * Set Valid NonDiscCreditAdjustmentList
                             */
                            this.setValidNonDiscCreditAdjustmentList = function (flag) {
                                return _this.customerCreditManagementService.setValidNonDiscCreditAdjustmentList(flag);
                            };
                            /**
                             * Set DiscCreditAdjustment Call Failed
                             */
                            this.setDiscCreditAdjustmentCallFailed = function (flag) {
                                return _this.customerCreditManagementService.setDiscCreditAdjustmentCallFailed(flag);
                            };
                            /**
                             * Set NonDiscCreditAdjustment Call Failed
                             */
                            this.setNonDiscCreditAdjustmentCallFailed = function (flag) {
                                return _this.customerCreditManagementService.setNonDiscCreditAdjustmentCallFailed(flag);
                            };
                            /**
                             * Set No DiscCreditAdjustment Records Found
                             */
                            this.setNoDiscCreditAdjustmentRecordsFound = function (flag) {
                                return _this.customerCreditManagementService.setNoDiscCreditAdjustmentRecordsFound(flag);
                            };
                            /**
                             * Set No NonDiscCreditAdjustment Records Found
                             */
                            this.setNoNonDiscCreditAdjustmentRecordsFound = function (flag) {
                                return _this.customerCreditManagementService.setNoNonDiscCreditAdjustmentRecordsFound(flag);
                            };
                            /**
                             * Get Subscriber Details
                             */
                            this.getSubscriberDetails = function () {
                                return _this.customerCreditManagementService.getSubscriberDetails();
                            };
                            /**
                             * @returns {discCreditAdjustmentList : IAdjustmentDetail[]}
                             */
                            this.getDiscCreditAdjustmentList = function () {
                                return _this.customerCreditManagementService.getDiscCreditAdjustmentList();
                            };
                            /**
                             * @returns {nonDiscCreditAdjustmentList : IAdjustmentDetail[]}
                             */
                            this.getNonDiscCreditAdjustmentList = function () {
                                return _this.customerCreditManagementService.getNonDiscCreditAdjustmentList();
                            };
                            /**
                             * @returns {maxAllowedAmount : number}
                             */
                            this.getMaxAllowedAmount = function () {
                                return _this.customerCreditManagementService.getConfig().basic.maxAllowedAmount;
                            };
                            /**
                             * @returns {recentCreditAdjustments : number}
                             */
                            this.getRecentCreditAdjustments = function () {
                                return _this.customerCreditManagementService.getRecentCreditAdjustments();
                            };
                            /**
                             * @returns {totalAllowedCreditAdjustments : number}
                             */
                            this.getTotalAllowedCreditAdjustments = function () {
                                return _this.customerCreditManagementService.getConfig().basic.maxAllowedAmount - _this.getRecentCreditAdjustments();
                            };
                            this.reloadCreditAdjustmentDetails = function () {
                                console.log(_this.model.selectedSubscriberNumber);
                                _this.setSelectedSubscriberNumber(_this.model.selectedSubscriberNumber);
                                _this.retrieveDiscCreditAdjustmentInfoService();
                                _this.retrieveNonDiscCreditAdjustmentInfoService();
                            };
                            this.loadCreditAdjustmentDetails();
                            //runtime language change
                            this.languageService.registerOnDataChangeHandler(function (lang) {
                                _this.retrieveNonDiscCreditAdjustmentInfoService();
                                return null;
                            }, 'ute.oneview.footer.directive.controller');
                            this.model = this.customerCreditManagementService.getModel();
                        }
                        /**
                         * Discretionary Service
                         */
                        CreditManagementController.prototype.retrieveDiscCreditAdjustmentInfoService = function () {
                            var _this = this;
                            //$event.preventDefault();
                            var adjustmentType = this.customerCreditManagementService.getConfig().basic.discretionaryType;
                            return this.customerCreditManagementService.getCreditAdjustmentDetails(adjustmentType).then(function (result) {
                                if (result.status === 'SUCCESS' || result.status === 'success') {
                                    _this.customerCreditManagementService.formulateCreditAdjustmentDetails(result, adjustmentType);
                                    if (_this.customerCreditManagementService.getDiscCreditAdjustmentList().length > 0) {
                                        _this.setValidDiscCreditAdjustmentList(true);
                                    }
                                    else {
                                        _this.setNoDiscCreditAdjustmentRecordsFound(true);
                                    }
                                }
                                else {
                                    if (result.errorDetails && result.errorDetails[0]) {
                                        if (result.errorDetails[0].errorCode === '30110') {
                                            _this.setNoDiscCreditAdjustmentRecordsFound(true);
                                        }
                                        else {
                                            _this.setDiscCreditAdjustmentCallFailed(true);
                                        }
                                    }
                                    else {
                                        _this.setDiscCreditAdjustmentCallFailed(true);
                                    }
                                }
                                return result;
                            }).catch(function (error) {
                                _this.setDiscCreditAdjustmentCallFailed(true);
                                return error;
                            });
                        };
                        /**
                         * Non-Discretionary Service
                         */
                        CreditManagementController.prototype.retrieveNonDiscCreditAdjustmentInfoService = function () {
                            var _this = this;
                            //$event.preventDefault();
                            var adjustmentType = this.customerCreditManagementService.getConfig().basic.nonDiscretionaryType;
                            return this.customerCreditManagementService.getCreditAdjustmentDetails(adjustmentType).then(function (result) {
                                if (result.status === 'SUCCESS' || result.status === 'success') {
                                    _this.customerCreditManagementService.formulateCreditAdjustmentDetails(result, adjustmentType);
                                    if (_this.customerCreditManagementService.getNonDiscCreditAdjustmentList().length > 0) {
                                        _this.setValidNonDiscCreditAdjustmentList(true);
                                    }
                                    else {
                                        _this.setNoNonDiscCreditAdjustmentRecordsFound(true);
                                    }
                                }
                                else {
                                    _this.setNonDiscCreditAdjustmentCallFailed(true);
                                }
                                return result;
                            }).catch(function (error) {
                                _this.setNonDiscCreditAdjustmentCallFailed(true);
                                return error;
                            });
                        };
                        /**
                         * Get Subscriber Numbers
                         */
                        CreditManagementController.prototype.getSubscriberNumbers = function () {
                            return this.customerCreditManagementService.getSubscriberNumbers();
                        };
                        ;
                        CreditManagementController.$inject = [
                            '$modal',
                            'ute.common.customer.credit.management.service',
                            '$state',
                            'ute.blocks.language.switcher'
                        ];
                        return CreditManagementController;
                    }());
                    management.CreditManagementController = CreditManagementController;
                    angular.module('ute.common.customer.credit.management').controller('ute.common.customer.credit.management.display.controller', CreditManagementController);
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = management.service || (management.service = {}));
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    var service;
                    (function (service) {
                        'use strict';
                        var BackEndStatus = (function () {
                            function BackEndStatus() {
                            }
                            BackEndStatus.SUCCESS = 'SUCCESS';
                            BackEndStatus.FAILURE = 'FAILURE';
                            BackEndStatus.RESP_ERROR = 'RESP_ERROR';
                            BackEndStatus.SYSTEM_ERROR = 'SYSTEM_ERROR';
                            BackEndStatus.GENERIC_ERROR = 'GENERIC_ERROR';
                            return BackEndStatus;
                        }());
                        service.BackEndStatus = BackEndStatus;
                        var CustomerCreditManagementProvider = (function () {
                            /* @ngInject */
                            function CustomerCreditManagementProvider() {
                                var _this = this;
                                this.config = {
                                    basic: {
                                        applicationId: 'ute-application-id',
                                        medium: 'WEB',
                                        maxAllowedAmount: 0,
                                        allowedDiscCreditSOCs: [],
                                        allowedNonDiscCreditSOCs: [],
                                        preDefinedNonDiscCheckSOCs: [],
                                        discretionaryType: 'discretionary',
                                        nonDiscretionaryType: 'non-discretionary',
                                        partialApiUrl: 'v1/ccm/getAdjustmentDetails',
                                        creditAdjustmentRootState: 'creditAdjustmentDetails',
                                        cancelState: 'creditAdjustmentDetails',
                                        updateProfileState: 'self-serve',
                                        mainControllerName: 'ute.common.customer.credit.management.main.controller',
                                        mainTemplateUrl: 'module/customerCreditManagement/customerCreditManagementMain.view.html',
                                        mainRepViewTemplateUrl: 'module/customerCreditManagement/customerCreditManagementMain.RepView.view.html'
                                    },
                                    advanced: {
                                        displayCreditAdjustmentDetails: {
                                            subState: 'display',
                                            backToState: 'wireless',
                                            controllerName: 'ute.common.customer.credit.management.display.controller',
                                            templateUrl: 'module/customerCreditManagement/creditManagement/creditManagement.view.html'
                                        }
                                    }
                                };
                                /* @ngInject */
                                this.$get = function ($injector, $state, $http, $stateParams, $filter, sessionStorage) {
                                    _this.encryptionService = $injector.get('ute.common.encryption.service');
                                    _this.userService = $injector.get('ute.common.user.service');
                                    _this.securityService = $injector.get('ute.common.security.service');
                                    _this.routerHelper = $injector.get('ute.blocks.router');
                                    _this.$state = $state;
                                    _this.$http = $http;
                                    _this.$stateParams = $stateParams;
                                    _this.$filter = $filter;
                                    _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                    _this.sessionStorage = sessionStorage;
                                    return {
                                        getConfig: _this.getConfig,
                                        goToEntryState: _this.goToEntryState,
                                        getEntryState: _this.getEntryState,
                                        goToState: _this.goToState,
                                        getModel: _this.getModel,
                                        getRequestedAccountNumber: _this.getRequestedAccountNumber,
                                        getCreditAdjustmentDetails: _this.getCreditAdjustmentDetails,
                                        getSubscriberNumbers: _this.getSubscriberNumbers,
                                        getSelectedSubscriberNumber: _this.getSelectedSubscriberNumber,
                                        setSelectedSubscriberNumber: _this.setSelectedSubscriberNumber,
                                        getSubscriberDetails: _this.getSubscriberDetails,
                                        isDiscCreditAdjustmentCallInProgress: _this.isDiscCreditAdjustmentCallInProgressFn,
                                        setDiscCreditAdjustmentCallInProgress: _this.setDiscCreditAdjustmentCallInProgressFn,
                                        isNonDiscCreditAdjustmentCallInProgress: _this.isNonDiscCreditAdjustmentCallInProgressFn,
                                        setNonDiscCreditAdjustmentCallInProgress: _this.setNonDiscCreditAdjustmentCallInProgressFn,
                                        isValidDiscCreditAdjustmentList: _this.isValidDiscCreditAdjustmentListFn,
                                        setValidDiscCreditAdjustmentList: _this.setValidDiscCreditAdjustmentListFn,
                                        isValidNonDiscCreditAdjustmentList: _this.isValidNonDiscCreditAdjustmentListFn,
                                        setValidNonDiscCreditAdjustmentList: _this.setValidNonDiscCreditAdjustmentListFn,
                                        isDiscCreditAdjustmentCallFailed: _this.isDiscCreditAdjustmentCallFailedFn,
                                        setDiscCreditAdjustmentCallFailed: _this.setDiscCreditAdjustmentCallFailedFn,
                                        isNonDiscCreditAdjustmentCallFailed: _this.isNonDiscCreditAdjustmentCallFailedFn,
                                        setNonDiscCreditAdjustmentCallFailed: _this.setNonDiscCreditAdjustmentCallFailedFn,
                                        noDiscCreditAdjustmentRecordsFound: _this.noDiscCreditAdjustmentRecordsFoundFn,
                                        setNoDiscCreditAdjustmentRecordsFound: _this.setNoDiscCreditAdjustmentRecordsFoundFn,
                                        noNonDiscCreditAdjustmentRecordsFound: _this.noNonDiscCreditAdjustmentRecordsFoundFn,
                                        setNoNonDiscCreditAdjustmentRecordsFound: _this.setNoNonDiscCreditAdjustmentRecordsFoundFn,
                                        setDiscCreditAdjustmentList: _this.setDiscCreditAdjustmentList,
                                        getDiscCreditAdjustmentList: _this.getDiscCreditAdjustmentList,
                                        setNonDiscCreditAdjustmentList: _this.setNonDiscCreditAdjustmentList,
                                        getNonDiscCreditAdjustmentList: _this.getNonDiscCreditAdjustmentList,
                                        formulateCreditAdjustmentDetails: _this.formulateCreditAdjustmentDetails,
                                        getRecentCreditAdjustments: _this.getRecentCreditAdjustments,
                                        getAllowedDiscCreditSOCs: _this.getAllowedDiscCreditSOCs,
                                        getAllowedNonDiscCreditSOCs: _this.getAllowedNonDiscCreditSOCs,
                                        getPreDefinedNonDiscCheckSOCs: _this.getPreDefinedNonDiscCheckSOCs,
                                        retrieveCreditAdjustmentConfig: _this.retrieveCreditAdjustmentConfig,
                                        restoreState: _this.restoreState,
                                        configure: _this.configure
                                    };
                                };
                                /**
                                 * @param config
                                 * @returns {boolean}
                                 */
                                this.configure = function (config) {
                                    _this.config = _.merge(_this.config, config);
                                    if (_.isEmpty(_this.config.basic.medium)) {
                                        console.error('medium:', 'configure method should override medium with vaid Medium');
                                        return false;
                                    }
                                    return true;
                                };
                                /**
                                 * Initial Call
                                 */
                                this.restoreState = function () {
                                    if (_this.$stateParams.id) {
                                        _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                            if (obj.accountNumber && obj.subscriberDetails) {
                                                _this.model.accountNumber = obj.accountNumber;
                                                _this.model.subscriberDetails = obj.subscriberDetails;
                                            }
                                        });
                                    }
                                };
                                /**
                                 * @returns {subscriberNumbers : number[]}
                                 */
                                this.getSubscriberNumbers = function () {
                                    return _this.model.subscriberNumber;
                                };
                                /**
                                 * @returns {selectedSubscriberNumber : number}
                                 */
                                this.getSelectedSubscriberNumber = function () {
                                    return _this.model.selectedSubscriberNumber;
                                };
                                /**
                                 * @returns {selectedSubscriberNumber : number}
                                 */
                                this.setSelectedSubscriberNumber = function (selectedSubscriber) {
                                    _this.model.selectedSubscriberNumber = selectedSubscriber;
                                };
                                /**
                                 * @returns {subscriberDetails : ISubscriberInfo[]}
                                 */
                                this.getSubscriberDetails = function () {
                                    return _this.model.subscriberDetails;
                                };
                                /**
                                 * @set {discCreditAdjustmentList : IAdjustmentDetail[]}
                                 */
                                this.setDiscCreditAdjustmentList = function (adjustmentList) {
                                    _this.model.discCreditAdjustmentList = adjustmentList;
                                };
                                /**
                                 * @returns {discCreditAdjustmentList : IAdjustmentDetail[]}
                                 */
                                this.getDiscCreditAdjustmentList = function () {
                                    return _this.model.discCreditAdjustmentList;
                                };
                                /**
                                 * @set {nonDiscCreditAdjustmentList : IAdjustmentDetail[]}
                                 */
                                this.setNonDiscCreditAdjustmentList = function (adjustmentList) {
                                    _this.model.nonDiscCreditAdjustmentList = adjustmentList;
                                };
                                /**
                                 * @returns {nonDiscCreditAdjustmentList : IAdjustmentDetail[]}
                                 */
                                this.getNonDiscCreditAdjustmentList = function () {
                                    return _this.model.nonDiscCreditAdjustmentList;
                                };
                                this.getRequestedAccountNumber = function () {
                                    return _this.sessionStorage.getSessionStorageValue('requestedAccountNumber');
                                };
                                /**
                                 * @returns {ng.IPromise<IBackEndResponse>}
                                 */
                                this.getCreditAdjustmentDetails = function (adjustmentType) {
                                    var apiUrl = '';
                                    if (adjustmentType === _this.getConfig().basic.discretionaryType) {
                                        apiUrl = _this.getConfig().basic.partialApiUrl;
                                        //apiUrl = 'discCreditAdjustments.json';
                                        _this.resetDiscCreditAdjustmentFlags();
                                        _this.setDiscCreditAdjustmentList(null);
                                    }
                                    else if (adjustmentType === _this.getConfig().basic.nonDiscretionaryType) {
                                        apiUrl = _this.getConfig().basic.partialApiUrl;
                                        //apiUrl = 'nonDiscCreditAdjustments.json';
                                        _this.resetNonDiscCreditAdjustmentFlags();
                                        _this.setNonDiscCreditAdjustmentList(null);
                                    }
                                    var request = {
                                        ban: _this.getRequestedAccountNumber(),
                                        accountNumber: _this.model.accountNumber,
                                        subscriberNumber: _this.model.selectedSubscriberNumber,
                                        type: adjustmentType
                                    };
                                    if (adjustmentType === _this.getConfig().basic.discretionaryType) {
                                        _this.setDiscCreditAdjustmentCallInProgressFn(true);
                                        _this.model.isDiscCreditAdjustmentCallInProgress = true;
                                    }
                                    else if (adjustmentType === _this.getConfig().basic.nonDiscretionaryType) {
                                        _this.setNonDiscCreditAdjustmentCallInProgressFn(true);
                                        _this.model.isNonDiscCreditAdjustmentCallInProgress = true;
                                    }
                                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                                        .then(_this.processCreditAdjustmentSuccess)
                                        .catch(_this.processCreditAdjustmentError)
                                        .finally(_this.finaliseCreditAdjustmentCall(adjustmentType));
                                };
                                /**
                                 * @param response
                                 * @returns {any}
                                 */
                                this.processCreditAdjustmentSuccess = function (response) {
                                    var backendStatus = _.get(response, 'data.status', BackEndStatus.GENERIC_ERROR);
                                    if (backendStatus === BackEndStatus.SUCCESS || backendStatus === 'success') {
                                        console.log('Success Response');
                                        return _.get(response, 'data', { status: BackEndStatus.FAILURE, reason: BackEndStatus.SYSTEM_ERROR });
                                    }
                                    else {
                                        console.log('Success with Error Response');
                                        return { status: BackEndStatus.FAILURE, reason: BackEndStatus.SYSTEM_ERROR };
                                    }
                                };
                                /**
                                 * @param error
                                 * @returns {IBackEndResponse}
                                 */
                                this.processCreditAdjustmentError = function (error) {
                                    //const backendCode: number = _.get(error, 'data.status', BackEndErrorCode.GENERIC_ERROR);
                                    console.log('Error Response');
                                    var actualBackendResponse = _.get(error, 'data');
                                    return { status: BackEndStatus.FAILURE, reason: BackEndStatus.SYSTEM_ERROR, errorDetails: actualBackendResponse.errorDetailsList };
                                };
                                this.finaliseCreditAdjustmentCall = function (adjustmentType) {
                                    if (adjustmentType === _this.getConfig().basic.discretionaryType) {
                                        _this.setDiscCreditAdjustmentCallInProgressFn(false);
                                        _this.model.isDiscCreditAdjustmentCallInProgress = false;
                                    }
                                    else if (adjustmentType === _this.getConfig().basic.nonDiscretionaryType) {
                                        _this.setNonDiscCreditAdjustmentCallInProgressFn(false);
                                        _this.model.isNonDiscCreditAdjustmentCallInProgress = false;
                                    }
                                };
                                this.resetDiscCreditAdjustmentFlags = function () {
                                    _this.model.isDiscCreditAdjustmentCallInProgress = false;
                                    _this.model.isValidDiscCreditAdjustmentList = false;
                                    _this.model.isDiscCreditAdjustmentCallFailed = false;
                                    _this.model.noDiscCreditAdjustmentRecordsFound = false;
                                    _this.setDiscCreditAdjustmentCallInProgressFn(false);
                                    _this.setValidDiscCreditAdjustmentListFn(false);
                                    _this.setDiscCreditAdjustmentCallFailedFn(false);
                                    _this.setNoDiscCreditAdjustmentRecordsFoundFn(false);
                                };
                                this.resetNonDiscCreditAdjustmentFlags = function () {
                                    _this.model.isNonDiscCreditAdjustmentCallInProgress = false;
                                    _this.model.isValidNonDiscCreditAdjustmentList = false;
                                    _this.model.isNonDiscCreditAdjustmentCallFailed = false;
                                    _this.model.noNonDiscCreditAdjustmentRecordsFound = false;
                                    _this.setNonDiscCreditAdjustmentCallInProgressFn(false);
                                    _this.setValidNonDiscCreditAdjustmentListFn(false);
                                    _this.setNonDiscCreditAdjustmentCallFailedFn(false);
                                    _this.setNoNonDiscCreditAdjustmentRecordsFoundFn(false);
                                };
                                this.formulateCreditAdjustmentDetails = function (response, adjustmentType) {
                                    if (adjustmentType === _this.getConfig().basic.discretionaryType) {
                                        _this.setDiscCreditAdjustmentList(_this.$filter('check_allowed_disc_credit_socs')(response.creditAdjustmentDetailsList));
                                    }
                                    else if (adjustmentType === _this.getConfig().basic.nonDiscretionaryType) {
                                        _this.setNonDiscCreditAdjustmentList(_this.$filter('check_allowed_non_disc_credit_socs')(response.creditAdjustmentDetailsList));
                                    }
                                };
                                this.getRecentCreditAdjustments = function () {
                                    return _this.calcTotalCreditAdjustments(_this.getDiscCreditAdjustmentList());
                                };
                                this.calcTotalCreditAdjustments = function (creditAdjustmentDetailsList) {
                                    var totalAdjustment;
                                    totalAdjustment = 0;
                                    _.forEach(creditAdjustmentDetailsList, function (adjustmentDetail, index) {
                                        if (parseFloat(adjustmentDetail.amount) >= 0) {
                                            totalAdjustment = totalAdjustment + parseFloat(adjustmentDetail.amount);
                                        }
                                    });
                                    return totalAdjustment;
                                };
                                this.isDiscCreditAdjustmentCallInProgressFn = function () {
                                    return _this.model.isDiscCreditAdjustmentCallInProgress;
                                };
                                this.setDiscCreditAdjustmentCallInProgressFn = function (flag) {
                                    _this.model.isDiscCreditAdjustmentCallInProgress = flag;
                                };
                                this.isNonDiscCreditAdjustmentCallInProgressFn = function () {
                                    return _this.model.isNonDiscCreditAdjustmentCallInProgress;
                                };
                                this.setNonDiscCreditAdjustmentCallInProgressFn = function (flag) {
                                    _this.model.isNonDiscCreditAdjustmentCallInProgress = flag;
                                };
                                this.isValidDiscCreditAdjustmentListFn = function () {
                                    return _this.model.isValidDiscCreditAdjustmentList;
                                };
                                this.setValidDiscCreditAdjustmentListFn = function (flag) {
                                    _this.model.isValidDiscCreditAdjustmentList = flag;
                                };
                                this.isValidNonDiscCreditAdjustmentListFn = function () {
                                    return _this.model.isValidNonDiscCreditAdjustmentList;
                                };
                                this.setValidNonDiscCreditAdjustmentListFn = function (flag) {
                                    _this.model.isValidNonDiscCreditAdjustmentList = flag;
                                };
                                this.isDiscCreditAdjustmentCallFailedFn = function () {
                                    return _this.model.isDiscCreditAdjustmentCallFailed;
                                };
                                this.setDiscCreditAdjustmentCallFailedFn = function (flag) {
                                    _this.model.isDiscCreditAdjustmentCallFailed = flag;
                                };
                                this.isNonDiscCreditAdjustmentCallFailedFn = function () {
                                    return _this.model.isNonDiscCreditAdjustmentCallFailed;
                                };
                                this.setNonDiscCreditAdjustmentCallFailedFn = function (flag) {
                                    _this.model.isNonDiscCreditAdjustmentCallFailed = flag;
                                };
                                this.noDiscCreditAdjustmentRecordsFoundFn = function () {
                                    return _this.model.noDiscCreditAdjustmentRecordsFound;
                                };
                                this.setNoDiscCreditAdjustmentRecordsFoundFn = function (flag) {
                                    _this.model.noDiscCreditAdjustmentRecordsFound = flag;
                                };
                                this.noNonDiscCreditAdjustmentRecordsFoundFn = function () {
                                    return _this.model.noNonDiscCreditAdjustmentRecordsFound;
                                };
                                this.setNoNonDiscCreditAdjustmentRecordsFoundFn = function (flag) {
                                    _this.model.noNonDiscCreditAdjustmentRecordsFound = flag;
                                };
                                /**
                                 * @returns {allowedDiscCreditSOCs : string[]}
                                 */
                                this.getAllowedDiscCreditSOCs = function () {
                                    return _this.getConfig().basic.allowedDiscCreditSOCs;
                                };
                                /**
                                 * @returns {allowedNonDiscCreditSOCs : string[]}
                                 */
                                this.getAllowedNonDiscCreditSOCs = function () {
                                    return _this.getConfig().basic.allowedNonDiscCreditSOCs;
                                };
                                /**
                                 * @returns {preDefinedNonDiscCheckSOC : string[]}
                                 */
                                this.getPreDefinedNonDiscCheckSOCs = function () {
                                    return _this.getConfig().basic.preDefinedNonDiscCheckSOCs;
                                };
                                /**
                                 * @returns {any}
                                 */
                                this.getConfig = function () {
                                    return angular.copy(_this.config);
                                };
                                /**
                                 * @returns {string}
                                 */
                                this.getEntryState = function () {
                                    return _this.config.basic.creditAdjustmentRootState + '.' + _this.config.advanced.displayCreditAdjustmentDetails.subState;
                                };
                                /**
                                 * @param input
                                 * @returns {angular.IPromise<any>}
                                 */
                                this.goToEntryState = function (input) {
                                    console.log('goToEntryState', input);
                                    _this.model = input;
                                    if (input.subscriberDetails[0] && input.subscriberDetails[0].subscriberNumber) {
                                        _this.model.selectedSubscriberNumber = input.subscriberDetails[0].subscriberNumber;
                                        return _this.encryptionService.encrypt(input).then(function (id) {
                                            return _this.$state.go(_this.getEntryState(), { id: id });
                                        });
                                    }
                                };
                                /**
                                 * @returns {ng.IPromise<any>}
                                 */
                                this.retrieveCreditAdjustmentConfig = function () {
                                    return _this.$http.get('/web/totes/cms/ute/rogers/consumer/oneview/data/creditManagement/creditManagementConfig.json')
                                        .then(_this.processCreditAdjustmentConfig)
                                        .catch(_this.processCreditAdjustmentConfigError)
                                        .finally(_this.finaliseSuspendCtnCallCall);
                                };
                                /**
                                 * @param response
                                 * @returns {ICreditAdjustmentConfig}
                                 */
                                this.processCreditAdjustmentConfig = function (response) {
                                    console.log('Got success response');
                                    return response;
                                };
                                /**
                                 * @param error
                                 * @returns {ICreditAdjustmentConfig}
                                 */
                                this.processCreditAdjustmentConfigError = function (error) {
                                    console.log('Got error response');
                                    return error;
                                };
                                this.finaliseSuspendCtnCallCall = function () {
                                    console.log('Finally call has been executed');
                                };
                                /**
                                 * @param state
                                 * @returns {angular.IPromise<any>}
                                 */
                                this.goToState = function (state) {
                                    return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                        return _this.$state.go(_this.config.basic.creditAdjustmentRootState + '.' + state, {
                                            id: id
                                        });
                                    });
                                };
                                /**
                                 * Return immutable ICustomerCreditManagementModel object
                                 * @returns {ICustomerCreditManagementModel}
                                 */
                                this.getModel = function () {
                                    //return angular.copy(this.model);
                                    return _this.model;
                                };
                                /**
                                 * Reset model to initial state
                                 */
                                this.resetModel = function () {
                                    _this.model = {
                                        subscriberNumber: null,
                                        accountNumber: null
                                    };
                                };
                                this.$get.$inject = [
                                    '$injector',
                                    '$state',
                                    '$http',
                                    '$stateParams',
                                    '$filter',
                                    'sessionStorage'
                                ];
                                this.resetModel();
                            }
                            ;
                            CustomerCreditManagementProvider.$inject = [];
                            return CustomerCreditManagementProvider;
                        }());
                        angular.module('ute.common.customer.credit.management').provider('ute.common.customer.credit.management.service', CustomerCreditManagementProvider);
                    })(service = management.service || (management.service = {}));
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    var service;
                    (function (service) {
                        'use strict';
                    })(service = management.service || (management.service = {}));
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    angular.module('ute.common.customer.credit.management').filter('check_allowed_disc_credit_socs', checkAllowedDiscCreditSOC); // split a phone number and format it like this (416) 555-5656
                    checkAllowedDiscCreditSOC.$inject = ['ute.common.customer.credit.management.service'];
                    function checkAllowedDiscCreditSOC(customerCreditManagementService) {
                        return function (input) {
                            var creditAdjustmentList;
                            var isValidAdjustmentDetailFound = false;
                            creditAdjustmentList = [];
                            _.forEach(input, function (adjustmentDetail, index) {
                                if (_.contains(customerCreditManagementService.getAllowedDiscCreditSOCs(), adjustmentDetail.code)) {
                                    creditAdjustmentList.push(adjustmentDetail);
                                    isValidAdjustmentDetailFound = true;
                                }
                            });
                            if (!isValidAdjustmentDetailFound && !customerCreditManagementService.isDiscCreditAdjustmentCallFailed()) {
                                customerCreditManagementService.setValidDiscCreditAdjustmentList(false);
                                customerCreditManagementService.setNoDiscCreditAdjustmentRecordsFound(true);
                            }
                            else {
                                customerCreditManagementService.setNoDiscCreditAdjustmentRecordsFound(false);
                            }
                            return creditAdjustmentList;
                        };
                    }
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    angular.module('ute.common.customer.credit.management').filter('check_allowed_non_disc_credit_socs', checkAllowedNonDiscCreditSOC); // split a phone number and format it like this (416) 555-5656
                    checkAllowedNonDiscCreditSOC.$inject = ['ute.common.customer.credit.management.service'];
                    function checkAllowedNonDiscCreditSOC(customerCreditManagementService) {
                        return function (input) {
                            var creditAdjustmentList;
                            var isValidAdjustmentDetailFound = false;
                            creditAdjustmentList = [];
                            _.forEach(input, function (adjustmentDetail, index) {
                                if (_.contains(customerCreditManagementService.getPreDefinedNonDiscCheckSOCs(), adjustmentDetail.code)
                                    || checkAllowedNonDiscCreditSOCPattern(customerCreditManagementService, adjustmentDetail.code)) {
                                    creditAdjustmentList.push(adjustmentDetail);
                                    isValidAdjustmentDetailFound = true;
                                }
                            });
                            if (!isValidAdjustmentDetailFound && !customerCreditManagementService.isNonDiscCreditAdjustmentCallFailed()) {
                                customerCreditManagementService.setValidNonDiscCreditAdjustmentList(false);
                                customerCreditManagementService.setNoNonDiscCreditAdjustmentRecordsFound(true);
                            }
                            else {
                                customerCreditManagementService.setNoNonDiscCreditAdjustmentRecordsFound(false);
                            }
                            return creditAdjustmentList;
                        };
                    }
                    function checkAllowedNonDiscCreditSOCPattern(customerCreditManagementService, creditSOC) {
                        var isPatternMatched = false;
                        _.forEach(customerCreditManagementService.getAllowedNonDiscCreditSOCs(), function (creditSOCPattern, index) {
                            if (_.startsWith(creditSOC, creditSOCPattern)) {
                                isPatternMatched = true;
                            }
                        });
                        return isPatternMatched;
                    }
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var customer;
        (function (customer) {
            var credit;
            (function (credit) {
                var management;
                (function (management) {
                    'use strict';
                    angular.module('ute.common.customer.credit.management').filter('display_if_empty', displayIfEmpty);
                    displayIfEmpty.$inject = ['$filter'];
                    function displayIfEmpty($filter) {
                        return function (input, defaultValue) {
                            if (defaultValue === 'N/A' && (angular.isUndefined(input) || input === null || input === '')) {
                                return $filter('translate')('ute.common.customer.credit.management.service.notAvailable');
                            }
                            else if (defaultValue === '0' && isNaN(input)) {
                                return defaultValue;
                            }
                            return input;
                        };
                    }
                })(management = credit.management || (credit.management = {}));
            })(credit = customer.credit || (customer.credit = {}));
        })(customer = common.customer || (common.customer = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

'use strict';
angular.module('ute.data.manager')
    .directive('rogersAlert', [function () {
        return {
            templateUrl: 'module/dataManager/alert/alert.view.html',
            restrict: 'E',
            bindToController: true,
            scope: {
                alertData: '='
            },
            controllerAs: 'ctrl',
            controller: function () {
                var _self = this;
                _self.alertShow = true;
                _self.dismissAlert = function () {
                    _self.alertShow = false;
                };
            }
        };
    }]);

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryController($scope, $rootScope, $compile, $translate, dataManagerService) {
                            var _this = this;
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$compile = $compile;
                            this.$translate = $translate;
                            this.dataManagerService = dataManagerService;
                            this.mobileMode = false;
                            this.moduleManager = [
                                {
                                    container: 'ute-dataManager-accountsSummary',
                                    moduleString: '<ute-data-manager-accounts-summary></ute-data-manager-accounts-summary>',
                                    exists: true,
                                    mobileOnly: false,
                                    desktopOnly: false
                                }
                            ];
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $scope.$watch(function () { return $translate.use(); }, function () { return _this.staticRecompile(); });
                        }
                        DataManagerAccountsSummaryController.prototype.getPurchaseDataProductCallInProgress = function () {
                            return this.dataManagerService.getPurchaseDataProductCallInProgress();
                        };
                        DataManagerAccountsSummaryController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerAccountsSummaryController.prototype.getAlertsRecipientCTN = function () {
                            return this.dataManagerService.getAlertsRecipientCTN();
                        };
                        DataManagerAccountsSummaryController.prototype.getIndexByCTN = function (ctn) {
                            return this.dataManagerService.getIndexByCTN(ctn);
                        };
                        DataManagerAccountsSummaryController.prototype.alertsRecipientCTNExists = function () {
                            return this.dataManagerService.getAlertsRecipientCTN() !== null;
                        };
                        DataManagerAccountsSummaryController.prototype.getHeaderHeight = function () {
                            return this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.footerOffset;
                        };
                        DataManagerAccountsSummaryController.prototype.goToDashboard = function () {
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                        };
                        DataManagerAccountsSummaryController.prototype.getAccountsSummaryChartHeight = function () {
                            var summaryObject = { height: '0px' };
                            summaryObject.height = 'calc( 100vh - ' + this.getHeaderHeight() + 'px)';
                            return summaryObject;
                        };
                        DataManagerAccountsSummaryController.prototype.getUsageDetailsCallInProgress = function () {
                            return this.dataManagerService.getUsageDetailsCallInProgress();
                        };
                        DataManagerAccountsSummaryController.prototype.decomissionModule = function (target, targetScope, container) {
                            if (targetScope) {
                                targetScope.$destroy();
                            }
                            target.remove();
                            this.getModByContainer(container).exists = false;
                        };
                        DataManagerAccountsSummaryController.prototype.destroyContents = function (container) {
                            var target = this.getTarget(container);
                            if (target) {
                                this.decomissionModule(target, this.getTargetScope(container), container);
                            }
                        };
                        DataManagerAccountsSummaryController.prototype.getParentElement = function (container) {
                            return angular.element($('.' + container));
                            // return angular.element(element[0].getElementsByClassName(container)[0]);
                        };
                        DataManagerAccountsSummaryController.prototype.getTarget = function (container) {
                            if (this.getParentElement(container)[0]) {
                                return angular.element(this.getParentElement(container)[0].childNodes[0]);
                            }
                            else {
                                return null;
                            }
                        };
                        DataManagerAccountsSummaryController.prototype.getTargetScope = function (container) {
                            try {
                                return this.getParentElement(container)[0].childNodes[0].childNodes[0].scope();
                            }
                            catch (e) {
                                return null;
                            }
                        };
                        DataManagerAccountsSummaryController.prototype.getModByContainer = function (container) {
                            var searchIndex = _.findIndex(this.moduleManager, {
                                container: container
                            });
                            return this.moduleManager[searchIndex];
                        };
                        DataManagerAccountsSummaryController.prototype.compileModule = function (container, content) {
                            var compiled = this.$compile(content)(this.scope);
                            this.getParentElement(container).append(compiled);
                            this.getModByContainer(container).exists = true;
                        };
                        DataManagerAccountsSummaryController.prototype.staticRecompile = function () {
                            this.destroyAll();
                            this.updateState();
                        };
                        DataManagerAccountsSummaryController.prototype.destroyAll = function () {
                            for (var iMod = 0; iMod < this.moduleManager.length; iMod++) {
                                var mod = this.moduleManager[iMod];
                                if (mod.exists) {
                                    this.destroyContents(mod.container);
                                }
                            }
                        };
                        DataManagerAccountsSummaryController.prototype.updateState = function () {
                            for (var iMod = 0; iMod < this.moduleManager.length; iMod++) {
                                var mod = this.moduleManager[iMod];
                                if (mod.exists) {
                                    if (this.mobileMode && !mod.mobileOnly && mod.desktopOnly) {
                                        this.destroyContents(mod.container);
                                    }
                                    else if (!this.mobileMode && mod.mobileOnly && !mod.desktopOnly) {
                                        this.destroyContents(mod.container);
                                    }
                                }
                                else {
                                    if (this.mobileMode && mod.mobileOnly && !mod.desktopOnly) {
                                        this.compileModule(mod.container, mod.moduleString);
                                    }
                                    else if (!this.mobileMode && !mod.mobileOnly && mod.desktopOnly) {
                                        this.compileModule(mod.container, mod.moduleString);
                                    }
                                    else if (!mod.mobileOnly && !mod.desktopOnly) {
                                        this.compileModule(mod.container, mod.moduleString);
                                    }
                                }
                            }
                        };
                        DataManagerAccountsSummaryController.$inject = ['$scope', '$rootScope', '$compile', '$translate', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryController;
                    }());
                    summary.DataManagerAccountsSummaryController = DataManagerAccountsSummaryController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.controller', DataManagerAccountsSummaryController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummary', uteDataManagerAccountsSummary);
                    uteDataManagerAccountsSummary.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummary(dataManagerService) {
                        return {
                            require: 'uteDataManagerAccountsSummary',
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryDirective',
                            link: function (scope, element, attrs, controller) {
                                scope.dataManagerActiveTabIndex = dataManagerService.getDataManagerActiveTabIndex();
                                scope.$watch(function () { return dataManagerService.getDataManagerActiveTabIndex(); }, function (newVal, oldVal) {
                                    if (newVal !== oldVal) {
                                        scope.dataManagerActiveTabIndex = newVal;
                                    }
                                });
                                if ((dataManagerService.getAlertsRecipientCTN()) === null && dataManagerService.getModel().loadComplete) {
                                    controller.openModalPopup();
                                }
                            }
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryBarContainerController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryBarContainerController($document, $scope, $modal, $filter, dataManagerService, messagesService, $window) {
                            var _this = this;
                            this.$document = $document;
                            this.$scope = $scope;
                            this.$modal = $modal;
                            this.$filter = $filter;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.$window = $window;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.modal = $modal;
                            this.dataManagerService.setSummaryMode(true);
                            this.messagesService.register('ute-vertical-stack-bar-graph-copy-click', function (data, val) { return _this.barClicked(val); });
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryBarContainerController.prototype.alertAtContainerClass = function (idx) {
                            if (!this.getDataAccess(idx)) {
                                return 'ute-data-manager-accounts-summary-data-alert-at-container-noAccess';
                            }
                            else if (this.getDataLineAlertAt(idx) < (this.getMaxLimit() / 1.65)) {
                                return 'ute-data-manager-accounts-summary-data-alert-at-container-high';
                            }
                            else {
                                return 'ute-data-manager-accounts-summary-data-alert-at-container-low';
                            }
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.isCompact = function () {
                            //Needed for dynamic height adjustment...
                            //dataManagerService.getSummaryChartHeight() won't work without
                            var width = this.$window.innerWidth;
                            var listLength = this.getFilteredList().length;
                            var minWidth = 100;
                            return (width / listLength) < minWidth;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.graphBaseCopy = function (accountLine) {
                            return this.getBaseCopy(accountLine.dataUsed);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.graphSecondaryCopy = function (accountLine) {
                            return this.isCompact() ? (this.$filter('ute_common_filter_string_limit_to')(accountLine.displayName, 2, false)) : accountLine.displayName;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.graphPrimaryValue = function (accountLine) {
                            return accountLine.dataUsed >= 1024 ? accountLine.dataUsed / 1024 * 1000 : accountLine.dataUsed;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.graphSecondaryValue = function (accountLine) {
                            return (accountLine.useAlert ? (this.isBucketSizeUnavailableUntilNextBillCycle() ? 0 : (accountLine.savedAlertValue >= 1024 ? accountLine.savedAlertValue / 1024 * 1000 : accountLine.savedAlertValue)) : 0);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getIndividualCTNLine = function () {
                            var _ctnIndex = this.dataManagerService.getIndividualCTNView();
                            return this.dataManagerService.getFilteredList()[_ctnIndex];
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.showSwipeInstructions = function (accountLine) {
                            return this.dataManagerService.showSwipeInstructions() && (accountLine.ctn === this.getIndividualCTNLine().ctn);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideAlertAt = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || !accountLine.useAlert || !accountLine.dataAccess || !accountLine.hasData || (accountLine.status === 'suspended' || (accountLine.status === 'cancelled') || this.isBucketSizeUnavailableUntilNextBillCycle());
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideAlertAtContainer = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || !accountLine.useAlert || !accountLine.hasData || (accountLine.status === 'suspended') || (accountLine.status === 'cancelled') || this.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideAlertAtBar = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || !accountLine.hasData || !accountLine.useAlert;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideAlertSetContainer = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || accountLine.useAlert || !accountLine.dataAccess || !accountLine.hasData || (accountLine.status === 'suspended') || (accountLine.status === 'cancelled');
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideNoAlertSetContainer = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || accountLine.useAlert || !accountLine.dataAccess || !accountLine.hasData || (accountLine.status === 'suspended') || (accountLine.status === 'cancelled');
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideDataAccessOffContainer = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || accountLine.dataAccess || !accountLine.hasData || (accountLine.status === 'suspended') || (accountLine.status === 'cancelled');
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.hideNoDataPlanContainer = function (accountLine) {
                            return this.getSummaryMode() || this.dataManagerService.showSwipeInstructions() || accountLine.hasData;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.showStatusContainer = function (accountLine) {
                            return !this.getSummaryMode() && accountLine.groupStatus === 'LEFT_GROUP';
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDataAccess = function (idx) {
                            return this.dataManagerService.getDataAccess(idx);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getBaseCopy = function (dataUsed) {
                            var htmlcopy = '';
                            if (!this.isCompact()) {
                                htmlcopy = this.$filter('translate')('ute.dataManager.accountsSummary.used');
                                htmlcopy += '<br>';
                                htmlcopy += this.$filter('ute_common_filter_data_conversion')(dataUsed, 'mb', 1024, (dataUsed >= 1024 ? 2 : 0), true, false);
                            }
                            return htmlcopy;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getMaxLimit = function () {
                            return this.dataManagerService.getChartDataTicks()[0];
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.convertToRoundValue = function (value) {
                            return value / this.dataManagerService.getConfig().basic.dataConversion * this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDataLimit = function () {
                            return this.convertToRoundValue(this.dataManagerService.getDataLimit());
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getAlertsRecipientCTN = function () {
                            return this.dataManagerService.getAlertsRecipientCTN();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getControlListWithData = function () {
                            return this.dataManagerService.getDataControlListWithData();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getIndividualCTNView = function () {
                            return this.dataManagerService.getIndividualCTNView();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getBarStyle = function (idx) {
                            //var accountLines: Array<IDataManagerAccountLine> = this.dataManagerService.getFilteredList();
                            var barWidth = 0;
                            var barOpacity = 0;
                            if (this.dataManagerService.getSummaryMode()) {
                                barWidth = this.getBarsWidth(); //(accountLines[idx].hasData ? this.getBarsWidth() : 0);
                                barOpacity = 1; //(accountLines[idx].hasData ? 1 : 0);
                            }
                            else {
                                if (this.dataManagerService.getIndividualCTNView() === idx) {
                                    barWidth = 100;
                                    barOpacity = 1;
                                }
                                else {
                                    barWidth = 0;
                                    barOpacity = 0;
                                }
                            }
                            var style = {
                                width: barWidth + '%',
                                height: this.getSummaryChartHeight(),
                                opacity: barOpacity
                            };
                            return style;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDisplayNameCTN = function (ctn) {
                            return this.dataManagerService.getDisplayNameCTN(ctn);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getSecondaryFilteredList = function () {
                            return this.dataManagerService.getSecondaryFilteredList();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getFilteredList = function () {
                            return this.dataManagerService.getFilteredList();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getBarsWidth = function () {
                            return 100 / this.dataManagerService.getFilteredList().length;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getIndexByCTN = function (ctn) {
                            return this.dataManagerService.getIndexByCTN(ctn);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getButtonHeight = function (secondaryValue, primaryValue, useAlerts) {
                            if (this.isBucketSizeUnavailableUntilNextBillCycle() || !useAlerts) {
                                secondaryValue = 0;
                            }
                            var value = Math.max(secondaryValue, primaryValue);
                            return (value >= 1000 ? value / 1024 * 1000 : value) * (this.getSummaryChartHeight() / this.getMaxLimit());
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.calcBarBottomPosition = function (pageY) {
                            return Math.abs(pageY - this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.headerOffset - this.getSummaryChartHeight()) - this.getSummaryChartHeight();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.calcAlertSetFromBarPosition = function (pageY) {
                            var valueFromBottom = Math.max((pageY - this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.headerOffset - this.getSummaryChartHeight()) * -1, 0);
                            var value = Math.round((valueFromBottom * this.getMaxLimit() / this.getSummaryChartHeight()) * 100) / 100;
                            value = value >= 1000 ?
                                value / 1000 * 1024 : value;
                            return value;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDataLineAlertAt = function (index) {
                            return this.dataManagerService.getDataLineAlertAt(index);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.setAlert = function (index, value) {
                            this.dataManagerService.setDataLineAlertAt(index, value);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.updateAlertAtBarPosition = function (mouseY, index) {
                            if (this.$scope.dragging) {
                                var ratio = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                                var maxPos = this.dataManagerService.getSummaryChartHeight() + this.calcBarBottomPosition((this.getDataLimit() >= 1000 ? this.getDataLimit() : this.getDataLimit() / 1000 * 1024) * ratio);
                                var minPos = this.dataManagerService.getSummaryChartHeight() + this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.headerOffset;
                                var offset = (mouseY - minPos) * -1 < 50 ?
                                    (mouseY - minPos) + 50 :
                                    ((mouseY - maxPos) < 10 ?
                                        ((mouseY - maxPos) - 10) : 0);
                                var dragToPosition = Math.max(maxPos, Math.min(mouseY + offset, minPos));
                                var bottomPos = this.calcBarBottomPosition(dragToPosition);
                                var dataAmount = this.calcAlertSetFromBarPosition(dragToPosition);
                                this.dataManagerService.setDataLineAlertAt(this.dataManagerService.getIndexByCTN(this.dataManagerService.getFilteredList()[index].ctn), dataAmount);
                                this.dataManagerService.setAlertMoved(this.getFilteredList()[index].ctn);
                                this.$scope.setBottom(bottomPos, index);
                            }
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.chartMove = function (event, index) {
                            this.updateAlertAtBarPosition(event.pageY, index);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getSummaryChartHeight = function () {
                            return this.dataManagerService.getSummaryChartHeight();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.barClicked = function (index) {
                            this.dataManagerService.setIndividualCTNView(index);
                            this.dataManagerService.setSummaryMode(false);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.swipeRight = function () {
                            this.$scope.navToIndividualCTN(this.dataManagerService.getPrevIndividualCTNIndex());
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.swipeLeft = function () {
                            this.$scope.navToIndividualCTN(this.dataManagerService.getNextIndividualCTNIndex());
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.setSummaryMode = function (val) {
                            this.dataManagerService.setSummaryMode(val);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getSummaryMode = function () {
                            return this.dataManagerService.getSummaryMode();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.thumbDown = function () {
                            this.$scope.dragging = true;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.thumbUp = function () {
                            this.$scope.dragging = false;
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.goToWireless = function (ctn) {
                            this.dataManagerService.setWirelessCTN(ctn);
                            this.dataManagerService.goToWirelessState();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getBarPosition = function (savedAlertValue) {
                            return ((savedAlertValue >= 1024 ? savedAlertValue / 1024 * 1000 : savedAlertValue) * (this.dataManagerService.getSummaryChartHeight() / this.getMaxLimit())) - this.dataManagerService.getSummaryChartHeight();
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getOpacity = function (index) {
                            return ((this.getIndividualCTNView() === index) && !this.getSummaryMode() ? 1 : 0);
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.translateToPixels = function (amount) {
                            return (amount * (this.getSummaryChartHeight() / this.getMaxLimit()));
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDarkUsageHeight = function (usage) {
                            var value = this.translateToPixels(usage);
                            var formattedValue = value > 30 ? 30 : value;
                            var difference = 30 - formattedValue;
                            return difference + 'px';
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.getDarkBottomOffset = function (usage) {
                            var value = this.translateToPixels(usage);
                            var formattedValue = value > 30 ? 30 : value;
                            var difference = 30 - formattedValue;
                            var bottom = 30 - difference;
                            return bottom + 'px';
                            // return difference + 'px';
                        };
                        DataManagerAccountsSummaryBarContainerController.prototype.alertsOverDataLimitModalPopup = function () {
                            this.modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.controllerName,
                                controllerAs: 'dataManagerAlertsOverDataLimitModal',
                                size: 'md',
                                backdrop: 'static'
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        break;
                                    case 'no':
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        DataManagerAccountsSummaryBarContainerController.$inject = ['$document', '$scope', '$modal', '$filter', 'ute.data.manager.service', 'ute.blocks.messages.bus.service', '$window'];
                        return DataManagerAccountsSummaryBarContainerController;
                    }());
                    summary.DataManagerAccountsSummaryBarContainerController = DataManagerAccountsSummaryBarContainerController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.bar.container.controller', DataManagerAccountsSummaryBarContainerController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryBarContainer', uteDataManagerAccountsSummaryBarContainer);
                    uteDataManagerAccountsSummaryBarContainer.$inject = ['$timeout', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryBarContainer($timeout, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryBarContainerDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryBarContainerDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryBarContainer',
                            link: function (scope, element, attrs, controller) {
                                scope.dragging = false;
                                scope.swipeInstructionsVisible = false;
                                scope.setBottom = function (value, index) {
                                    var bar = angular.element(element[0].getElementsByClassName('ute-dataManager-accountsSummary-dataAlertBarContainer' + index));
                                    bar.css('bottom', value);
                                    bar.css('transition', 'none');
                                };
                                function collapseBar(index) {
                                    var container = element[0].getElementsByClassName('ute-dataManager-accountsSummary-barContainer' + index)[0];
                                    var alertAtBar = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataAlertBar'));
                                    var alertAtCopy = angular.element(container.getElementsByClassName('ute-data-manager-accounts-summary-data-alert-at-container'));
                                    var noAlerts = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataNoAlertsSetContainer'));
                                    var dataAccess = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataAccessOffContainer'));
                                    var noDataPlan = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-noDataPlanContainer'));
                                    noDataPlan.css('opacity', 0);
                                    dataAccess.css('opacity', 0);
                                    noAlerts.css('opacity', 0);
                                    alertAtBar.css('opacity', 0);
                                    alertAtCopy.css('opacity', 0);
                                }
                                function expandBar(index) {
                                    var container = element[0].getElementsByClassName('ute-dataManager-accountsSummary-barContainer' + index)[0];
                                    var alertAtBar = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataAlertBar'));
                                    var alertAtCopy = angular.element(container.getElementsByClassName('ute-data-manager-accounts-summary-data-alert-at-container'));
                                    var noAlerts = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataNoAlertsSetContainer'));
                                    var noDataPlan = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-noDataPlanContainer'));
                                    var dataAccess = angular.element(container.getElementsByClassName('ute-dataManager-accountsSummary-dataAccessOffContainer'));
                                    dataAccess.css('opacity', 1);
                                    noDataPlan.css('opacity', 1);
                                    noAlerts.css('opacity', 1);
                                    alertAtBar.css('opacity', 1);
                                    alertAtCopy.css('opacity', 1);
                                }
                                scope.navToIndividualCTN = function (index) {
                                    var controlLines = controller.getFilteredList();
                                    for (var iLine = 0; iLine < controlLines.length; iLine++) {
                                        if (iLine === index) {
                                            expandBar(iLine);
                                        }
                                        else {
                                            collapseBar(iLine);
                                        }
                                    }
                                    if (!dataManagerService.getSwipeInstructionsShown()) {
                                        dataManagerService.setShowSwipeInstructions(true);
                                        dataManagerService.countdownSwipeInstructions();
                                        if (scope.swipeInstructionsVisible) {
                                            dataManagerService.setSwipeInstructionsShown(true);
                                            dataManagerService.setShowSwipeInstructions(false);
                                            scope.swipeInstructionsVisible = false;
                                        }
                                        else {
                                            scope.swipeInstructionsVisible = true;
                                            $timeout(function () {
                                                scope.swipeInstructionsVisible = false;
                                            }, 3000);
                                        }
                                    }
                                };
                                scope.$watch(function () {
                                    return dataManagerService.getSummaryMode();
                                }, function (showHeader) {
                                    if (!showHeader) {
                                        var _ctnIndex = dataManagerService.getIndividualCTNView();
                                        scope.navToIndividualCTN(_ctnIndex);
                                    }
                                    for (var index = 0; index < dataManagerService.getFilteredList().length; index++) {
                                        var containerElement = element[0].getElementsByClassName('ute-dataManager-accountsSummary-barContainer' + index);
                                        if (containerElement.length > 0) {
                                            var container = containerElement[0];
                                            var secondaryCopy = angular.element(container.getElementsByClassName('ute-verticalStackBarGraph-secondaryCopy'));
                                            var baseCopy = angular.element(container.getElementsByClassName('ute-verticalStackBarGraph-baseCopy'));
                                            secondaryCopy.css('opacity', showHeader ? 1 : 0);
                                            baseCopy.css('opacity', showHeader ? 1 : 0);
                                        }
                                    }
                                });
                                var index = 0;
                                var touchStartIcon = function (e) {
                                    if (navigator.userAgent.match(/Android/i)) {
                                        e.preventDefault();
                                    }
                                    scope.dragging = true;
                                    dataManagerService.setAlertMoved(controller.getFilteredList()[index].ctn);
                                };
                                var touchMoveIcon = function (e) {
                                    e.preventDefault();
                                    var touchY = e.changedTouches[0].pageY;
                                    controller.updateAlertAtBarPosition(touchY, index);
                                    scope.$apply(); //This solution is not angular, apply required
                                };
                                //TODO: Find better angular solution
                                var setAlertIconEvents = function (currentIndex) {
                                    if (document.getElementsByClassName('ute-dataManager-accountsSummary-iconButton')[currentIndex]) {
                                        document.getElementsByClassName('ute-dataManager-accountsSummary-iconButton')[currentIndex].addEventListener('touchstart', touchStartIcon, false);
                                        document.getElementsByClassName('ute-dataManager-accountsSummary-dataAlertBarContainer')[currentIndex].addEventListener('touchmove', touchMoveIcon, false);
                                    }
                                };
                                var removeAlertIconEvents = function (currentIndex) {
                                    document.getElementsByClassName('ute-dataManager-accountsSummary-dataAlertBarContainer')[currentIndex].removeEventListener('touchmove', touchMoveIcon, false);
                                    if (document.getElementsByClassName('ute-dataManager-accountsSummary-iconButton')[currentIndex]) {
                                        document.getElementsByClassName('ute-dataManager-accountsSummary-iconButton')[currentIndex].removeEventListener('touchstart', touchStartIcon, false);
                                    }
                                };
                                /**
                                 * Snap the alert bar to the nearest steps based on the setting
                                 */
                                var snapAlertBarToYourPlan = function () {
                                    /**
                                     * Get the step setting from config
                                     */
                                    var slidingStep = dataManagerService.getSliderStep();
                                    /**
                                     * Calculate the ratio for 1MB
                                     */
                                    var userSelectedAlert = controller.getDataLineAlertAt(index);
                                    /**
                                     * Convert the user selected alert value the unit of GB if it is greater than 1GB
                                     * Then round up the number with the converted value
                                     * Because the user is based on the unit of GB to set their alert
                                     */
                                    if ((userSelectedAlert > 1024)) {
                                        userSelectedAlert = (userSelectedAlert / 1024) * 1000;
                                    }
                                    /**
                                     * Round the value based on setting
                                     */
                                    var snapToDataAmount;
                                    snapToDataAmount = slidingStep * Math.floor((userSelectedAlert / slidingStep) + (slidingStep / (slidingStep * 2)));
                                    /**
                                     * Convert the number back to the unit of MB to set the position of the alert bar
                                     */
                                    if ((snapToDataAmount > 1024)) {
                                        snapToDataAmount = (snapToDataAmount / 1000) * 1024;
                                    }
                                    dataManagerService.setDataLineAlertAt(dataManagerService.getIndexByCTN(dataManagerService.getFilteredList()[index].ctn), snapToDataAmount);
                                    dataManagerService.setAlertMoved(controller.getFilteredList()[index].ctn);
                                };
                                var barTouchend = function () {
                                    scope.dragging = false;
                                    /**
                                     * After scrolling done call to Snap the alert bar to the nearest steps based on the setting
                                     */
                                    snapAlertBarToYourPlan();
                                    scope.$applyAsync(); //This solution is not angular, apply required
                                };
                                document.addEventListener('touchend', barTouchend, false);
                                scope.$watch(function () {
                                    return dataManagerService.getIndividualCTNView();
                                }, function (newIndex, oldIndex) {
                                    setAlertIconEvents(newIndex);
                                    index = newIndex;
                                    if (oldIndex !== null) {
                                        removeAlertIconEvents(oldIndex);
                                    }
                                });
                                scope.$on('$destroy', function () {
                                    document.removeEventListener('touchend', barTouchend);
                                });
                                // scope.$on('ute-dataManager-data-alert-bar-linked', function(event: any, data: number) {
                                //   var index: number = dataManagerService.getIndividualCTNView();
                                //   if (data * 1 === index * 1) {
                                //     setAlertIconEvents(index);
                                //   }
                                // });
                                ////////////////////////////
                            }
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryDirectiveController($scope, $modal, $rootScope, dataManagerService) {
                            this.$scope = $scope;
                            this.$modal = $modal;
                            this.$rootScope = $rootScope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            this.rootScope = $rootScope;
                            this.modal = $modal;
                            this.dataAlertsTabActive = !this.dataManagerService.getIsVideoThrottlePermitted() || (this.dataManagerService.getIsVideoThrottlePermitted() && this.dataManagerService.getDataManagerActiveTabIndex() === 0);
                        }
                        DataManagerAccountsSummaryDirectiveController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.inOverage = function () {
                            return (this.dataManagerService.getOverage() > 0);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getPrimaryMeterHeight = function () {
                            var firstVisibleLine = this.dataManagerService.getSummaryMode() ? this.dataManagerService.getFilteredList()[0] : this.dataManagerService.getFilteredList()[this.dataManagerService.getIndividualCTNView()];
                            if (firstVisibleLine) {
                                var chartTickData = this.dataManagerService.getChartDataTicks();
                                var dataUsed = firstVisibleLine.hasData ? firstVisibleLine.dataUsed : 0;
                                // var dataUsed: number = this.dataManagerService.getDataLimit();
                                return (dataUsed >= 1000 ? dataUsed / 1024 * 1000 : dataUsed) * ((this.dataManagerService.getSummaryChartHeight() / chartTickData[0]) || 0);
                            }
                            else {
                                return 0;
                            }
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getSecondaryMeterHeight = function () {
                            var primaryLine = this.dataManagerService.getSummaryMode() ? this.dataManagerService.getFilteredList()[0] : this.dataManagerService.getFilteredList()[this.dataManagerService.getIndividualCTNView()];
                            if (primaryLine) {
                                var totalAllowableData = this.dataManagerService.getDataLimit() + this.dataManagerService.getAddedExtraData();
                                var chartTickData = this.dataManagerService.getChartDataTicks();
                                var dataUsed = primaryLine.hasData ? primaryLine.dataUsed : 0;
                                return ((totalAllowableData - dataUsed) >= 1000 ? (totalAllowableData - dataUsed) / 1024 * 1000 : (totalAllowableData - dataUsed)) * ((this.dataManagerService.getSummaryChartHeight() / chartTickData[0]) || 0);
                            }
                            else {
                                return 0;
                            }
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getTertiaryMeterHeight = function () {
                            var chartTickData = this.dataManagerService.getChartDataTicks();
                            return (chartTickData[0]) * ((this.dataManagerService.getSummaryChartHeight() / chartTickData[0]) || 0);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getDataAddedBottomPosition = function () {
                            var ratio = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                            return (this.dataManagerService.getDataLimit() >= 1024 ? this.dataManagerService.getDataLimit() / 1024 * 1000 : this.dataManagerService.getDataLimit()) * ratio;
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getOverageCoverageBottomPosition = function () {
                            var ratio = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                            var extraData = this.dataManagerService.getAddedExtraData();
                            return ((this.dataManagerService.getDataLimit() + extraData) >= 1024 ? (this.dataManagerService.getDataLimit() + extraData) / 1024 * 1000 : (this.dataManagerService.getDataLimit() + extraData)) * ratio;
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getDataAddedBarHeight = function () {
                            /*
                            
                                  var ratio: number = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                            
                                  return (this.dataManagerService.getDataLimit() >= 1024 ? this.dataManagerService.getAddedExtraData() / 1024 * 1000 : this.dataManagerService.getAddedExtraData()) * ratio;
                            */
                            var totalAllowableData = this.dataManagerService.getDataLimit() + this.dataManagerService.getAddedExtraData();
                            var chartTickData = this.dataManagerService.getChartDataTicks();
                            var dataLimit = this.dataManagerService.getDataLimit();
                            return ((totalAllowableData - dataLimit) >= 1000 ? (totalAllowableData - dataLimit) / 1024 * 1000 : (totalAllowableData - dataLimit)) * ((this.dataManagerService.getSummaryChartHeight() / chartTickData[0]) || 0);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getOverageCoverageHeight = function () {
                            var addedExtra = this.dataManagerService.getAddedExtraData();
                            var ratio = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                            var overageDataAmountToCover = (this.dataManagerService.getChartDataTicks()[0] - (this.dataManagerService.getDataLimit() + addedExtra));
                            return ((overageDataAmountToCover >= 1000 ? overageDataAmountToCover / 1000 * 1024 : overageDataAmountToCover / 1024 * 1000) * ratio);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.hasAddedData = function () {
                            return this.dataManagerService.getAddedExtraData() > 0;
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getAlertsRecipientCTN = function () {
                            return this.dataManagerService.getAlertsRecipientCTN();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getIndividualCTNView = function () {
                            return this.dataManagerService.getIndividualCTNView();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getIndexByCTN = function (ctn) {
                            return this.dataManagerService.getIndexByCTN(ctn);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getIndividualCTNLine = function () {
                            var _ctnIndex = this.dataManagerService.getIndividualCTNView();
                            return this.dataManagerService.getFilteredList()[_ctnIndex];
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getSummaryMode = function () {
                            return this.dataManagerService.getSummaryMode();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getSummaryChartHeight = function () {
                            return this.dataManagerService.getSummaryChartHeight();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getTotalUsedDataBucket = function () {
                            return this.dataManagerService.getTotalUsedDataBucket();
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getOverageBottomPosition = function () {
                            var ratio = this.dataManagerService.getSummaryChartHeight() / this.dataManagerService.getChartDataTicks()[0];
                            var bottomPosition = (this.dataManagerService.getTotalUsedData() >= 1000 ? this.dataManagerService.getTotalUsedData() / 1024 * 1000 : this.dataManagerService.getTotalUsedData()) * ratio;
                            return bottomPosition;
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.goToDashboard = function () {
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.openModalPopup = function () {
                            var _this = this;
                            this.modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                controllerAs: 'dataManagerAlertsRecipientModal',
                                size: 'md',
                                backdrop: 'static'
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        break;
                                    case 'no':
                                        _this.goToDashboard();
                                        break;
                                    case 'error':
                                        _this.errorModalPopup('ute.dataManager.accountsSummary.errorHeading', 'ute.dataManager.accountsSummary.errorSecondary');
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                                _this.goToDashboard();
                            });
                        };
                        DataManagerAccountsSummaryDirectiveController.prototype.getIsVideoThrottlePermitted = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted();
                        };
                        DataManagerAccountsSummaryDirectiveController.$inject = ['$scope', '$modal', '$rootScope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryDirectiveController;
                    }());
                    summary.DataManagerAccountsSummaryDirectiveController = DataManagerAccountsSummaryDirectiveController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.directive.controller', DataManagerAccountsSummaryDirectiveController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var badge;
            (function (badge) {
                var list;
                (function (list) {
                    'use strict';
                    var DataManagerBadgeListDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerBadgeListDirectiveController($scope, $state, $window, dataManagerService, dataManagerSeeService, languageService, $translate) {
                            var _this = this;
                            this.$scope = $scope;
                            this.$state = $state;
                            this.$window = $window;
                            this.dataManagerService = dataManagerService;
                            this.dataManagerSeeService = dataManagerSeeService;
                            this.languageService = languageService;
                            this.$translate = $translate;
                            this.isInfinitePlan = function () {
                                return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                            };
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            // SEE project implementation
                            dataManagerSeeService.getSeeBrtShowState().then(function (showState) {
                                if (showState) {
                                    _this.dataManagerSeeService.tabAccountLinks = [];
                                    _this.seeLinks = [];
                                    _this.initSeeLink();
                                    _this.getLabel();
                                    $scope.$watch(function () { return _this.dataManagerService.getAccountNumber(); }, function (newValue, oldValue) {
                                        if (newValue && newValue !== oldValue) {
                                            _this.dataManagerSeeService.tabAccountLinks = [];
                                            _this.seeLinks = [];
                                            _this.initSeeLink();
                                        }
                                    });
                                    _this.languageService.registerOnDataChangeHandler(function (lang) {
                                        _this.dataManagerSeeService.tabAccountLinks = [];
                                        _this.seeLinks = [];
                                        _this.initSeeLink();
                                        _this.getLabel();
                                        return null;
                                    }, 'ute.data.manager.badge.list.directive.controller');
                                    $scope.$on('$targetheroresponse', function (event, data) {
                                        if (data && data.targetedHeroOfferMap && _this.dataManagerService.getBadgeList()) {
                                            var count = 0;
                                            count = _.size(_.filter(_this.dataManagerService.getBadgeList().subscriberList, function (s) {
                                                return _.find(data.targetedHeroOfferMap, function (p) {
                                                    return (s.ctn == p.ctn) && (p.hupOffer || p.tvmOffer || p.hup4BPO || p.tvmBPO || p.standAloneBPO);
                                                });
                                            }));
                                            if (count > 0) {
                                                _this.isTargetHeroOffer = true;
                                            }
                                        }
                                    });
                                    $scope.$on('$destroy', function () {
                                        if (_this && _this.languageService) {
                                            _this.languageService.unregisterOnDataChangeHandler('ute.data.manager.badge.list.directive.controller');
                                        }
                                    });
                                }
                            });
                            // End of SEE project implementation
                            /*
                             this.dataManagerService.loadbadgeData().then((result: any): void => {
                             this.planName = result.planName;
                             this.shareUserList = result.subList;
                             });
                             */
                        }
                        DataManagerBadgeListDirectiveController.prototype.initSeeLink = function () {
                            var _this = this;
                            this.dataManagerSeeService.tabAccountLinks = [];
                            this.seeLinks = []; //clearing value in controller scope as it retains the previous BAN details
                            this.dataManagerService.getAccountStatus().then(function (accountOverview) {
                                if (accountOverview.getSelectedAccount().accountStatus && accountOverview.getSelectedAccount().accountStatus.toLowerCase() === 'active') {
                                    _this.dataManagerSeeService.addTabLink(_this.dataManagerService.getBadgeList().subscriberList).then(function () {
                                        _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                    }).catch(function () {
                                        _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                    });
                                }
                            });
                        };
                        DataManagerBadgeListDirectiveController.prototype.getLabel = function () {
                            this.headBadgeLabel = this.$translate.instant('ute.dataManager.badge.list.headBadgeLabel');
                        };
                        DataManagerBadgeListDirectiveController.prototype.badgeClick = function () {
                            return this.goToDashboard(this.getBadgeListSubscribers()[0].ctn);
                        };
                        /**
                         *
                         *
                         * @returns {Array<IDataManagerBadgeItemModel>}
                         */
                        // SEE project implementation - Modified
                        DataManagerBadgeListDirectiveController.prototype.getBadgeListSubscribers = function () {
                            if (this.seeLinks) {
                                return this.dataManagerService.getBadgeList().subscriberList.concat(this.seeLinks);
                            }
                            else {
                                return this.dataManagerService.getBadgeList().subscriberList;
                            }
                        };
                        DataManagerBadgeListDirectiveController.prototype.getSeeAddLineLinks = function () {
                            return this.seeLinks ? this.seeLinks : [];
                        };
                        DataManagerBadgeListDirectiveController.prototype.getBadgeList = function () {
                            return this.dataManagerService.getBadgeList();
                        };
                        DataManagerBadgeListDirectiveController.prototype.checkBadgeEnabled = function () {
                            if (this.scope.accountStatus !== 'Suspended' && this.scope.accountStatus !== 'Cancelled') {
                                return true;
                            }
                            else {
                                return false;
                            }
                        };
                        //SEE implementation
                        DataManagerBadgeListDirectiveController.prototype.goToAddLine = function () {
                            this.dataManagerSeeService.goToAddLine();
                        };
                        DataManagerBadgeListDirectiveController.prototype.isDiscountLoading = function () {
                            return this.dataManagerSeeService.discountLoading;
                        };
                        //END of SEE implementation
                        DataManagerBadgeListDirectiveController.prototype.goToDashboard = function (ctn) {
                            if (this.scope.accountStatus !== 'Suspended' && this.scope.accountStatus !== 'Cancelled') {
                                this.$window.localStorage.setItem('phoneNumber', ctn); //Required for wireless dashboard totes integration...
                                if (this.dataManagerService.isCare()) {
                                    this.$window.sessionStorage.setItem('phoneNumber', ctn);
                                }
                                this.dataManagerService.setSelectedBadgeCTN(ctn);
                                this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                            }
                        };
                        DataManagerBadgeListDirectiveController.$inject = ['$scope', '$state', '$window', 'ute.data.manager.service', 'ute.data.manager.see.service', 'ute.blocks.language.switcher', '$translate'];
                        return DataManagerBadgeListDirectiveController;
                    }());
                    list.DataManagerBadgeListDirectiveController = DataManagerBadgeListDirectiveController;
                    angular.module('ute.data.manager.badge.list').controller('ute.data.manager.badge.list.directive.controller', DataManagerBadgeListDirectiveController);
                })(list = badge.list || (badge.list = {}));
            })(badge = manager.badge || (manager.badge = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var badge;
            (function (badge) {
                var list;
                (function (list) {
                    'use strict';
                    angular.module('ute.data.manager.badge.list').directive('uteDataManagerBadgeListDirective', uteDataManagerBadgeListDirective);
                    uteDataManagerBadgeListDirective.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerBadgeListDirective(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'accountNumber': '@', 'accountStatus': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerBadgeListDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerBadgeListDirective.controllerName,
                            controllerAs: 'dataManagerBadgeListDirective'
                        };
                    }
                })(list = badge.list || (badge.list = {}));
            })(badge = manager.badge || (manager.badge = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            var DataManagerDashboardController = (function () {
                /* @ngInject */
                function DataManagerDashboardController(dataManagerService) {
                    this.dataManagerService = dataManagerService;
                    this.waitReady = false;
                }
                /**
                 * mutable model
                 */
                DataManagerDashboardController.prototype.getUsageDetailsCallInProgress = function () {
                    return this.dataManagerService.getUsageDetailsCallInProgress();
                };
                DataManagerDashboardController.prototype.getIsVideoQualityAPICallInProgress = function () {
                    return this.dataManagerService.getIsVideoQualityAPICallInProgress();
                };
                DataManagerDashboardController.prototype.tabsContentOkayToLoad = function () {
                    return ((this.dataManagerService.getUsageDetailsCallInProgress() === false) && this.waitReady);
                };
                DataManagerDashboardController.$inject = ['ute.data.manager.service'];
                return DataManagerDashboardController;
            }());
            manager.DataManagerDashboardController = DataManagerDashboardController;
            angular.module('ute.data.manager').controller('ute.data.manager.dashboard.controller', DataManagerDashboardController);
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            angular.module('ute.data.manager').directive('uteDataManagerDasboard', uteDataManagerDashboard);
            uteDataManagerDashboard.$inject = ['$translate',
                '$timeout',
                '$rootScope',
                '$compile',
                '$window',
                'ute.data.manager.service'];
            /* @ngInject */
            function uteDataManagerDashboard($translate, $timeout, $rootScope, $compile, $window, dataManagerService) {
                return {
                    restrict: 'E',
                    scope: {},
                    templateUrl: dataManagerService.getConfig().advanced.dataManagerDashboard.templateUrl,
                    controller: dataManagerService.getConfig().advanced.dataManagerDashboard.controllerName,
                    controllerAs: 'dataManagerDashboard',
                    link: function (scope, element, attrs, controller) {
                        var mobileMode = ($window.innerWidth < 768);
                        var w = angular.element($window);
                        var moduleManager = dataManagerService.getModel().dataManagerModules;
                        controller.waitReady = false;
                        //The following is required for performance enhancements for IE 11 -- dynamically destroying components
                        function decomissionModule(target, targetScope, container) {
                            getModByContainer(container).exists = false;
                            if (targetScope) {
                                targetScope.$destroy();
                            }
                            target.remove();
                        }
                        function destroyContents(container) {
                            var target = getTarget(container);
                            if (target) {
                                var targetScope = getTargetScope(container);
                                decomissionModule(target, targetScope, container);
                            }
                        }
                        function getParentElement(container) {
                            return angular.element(element[0].getElementsByClassName(container)[0]);
                        }
                        function getTarget(container) {
                            if (getParentElement(container)[0]) {
                                return angular.element(getParentElement(container)[0].childNodes[0]);
                            }
                            else {
                                return null;
                            }
                        }
                        function getTargetScope(container) {
                            try {
                                return getParentElement(container)[0].childNodes[0].childNodes[0].scope();
                            }
                            catch (e) {
                                return null;
                            }
                        }
                        function getModByContainer(container) {
                            var searchIndex = _.findIndex(moduleManager, {
                                container: container
                            });
                            return moduleManager[searchIndex];
                        }
                        function compileModule(container, content) {
                            if (!getModByContainer(container).exists) {
                                getModByContainer(container).exists = true;
                                var compiled = $compile(content)(scope);
                                getParentElement(container).append(compiled);
                            }
                        }
                        function staticRecompile() {
                            destroyAll();
                            updateState();
                        }
                        $rootScope.$on('ute-dataManager-targettedModuleReload', function (modContainers) {
                            for (var iMod = 0; iMod < modContainers.length; iMod++) {
                                var mod = getModByContainer(modContainers[iMod]);
                                if (mod.exists) {
                                    destroyContents(mod.container);
                                    compileModule(mod.container, mod.moduleString);
                                }
                            }
                        });
                        function destroyAll() {
                            for (var iMod = 0; iMod < moduleManager.length; iMod++) {
                                var mod = moduleManager[iMod];
                                if (mod.exists && !mod.exemptDestroyAll) {
                                    destroyContents(mod.container);
                                }
                            }
                        }
                        scope.$watch(function () { return $translate.use(); }, function (lang) {
                            if (dataManagerService.getModel().loadComplete) {
                                staticRecompile();
                            }
                        });
                        function updateState() {
                            for (var iMod = 0; iMod < moduleManager.length; iMod++) {
                                var mod = moduleManager[iMod];
                                if (mod.exists) {
                                    if (mobileMode && !mod.mobileOnly && mod.desktopOnly) {
                                        destroyContents(mod.container);
                                    }
                                    else if (!mobileMode && mod.mobileOnly && !mod.desktopOnly) {
                                        destroyContents(mod.container);
                                    }
                                }
                                else {
                                    if (mobileMode && mod.mobileOnly && !mod.desktopOnly) {
                                        compileModule(mod.container, mod.moduleString);
                                    }
                                    else if (!mobileMode && !mod.mobileOnly && mod.desktopOnly) {
                                        compileModule(mod.container, mod.moduleString);
                                    }
                                    else if (!mod.mobileOnly && !mod.desktopOnly) {
                                        compileModule(mod.container, mod.moduleString);
                                    }
                                }
                            }
                        }
                        scope.$watch(function () { return dataManagerService.getModel().loadComplete; }, function (complete) {
                            if (complete) {
                                // $timeout(function(){
                                updateState();
                                // }, 1);
                                $timeout(function () {
                                    controller.waitReady = true;
                                }, 500);
                            }
                        });
                        scope.$on('$stateChangeStart', function () {
                            destroyContents(moduleManager[6].container); //tabsContentContainer
                        });
                        scope.$watch(function () {
                            return $window.innerWidth;
                        }, function (value) {
                            if (value < 768) {
                                if (!mobileMode && dataManagerService.getModel().loadComplete) {
                                    mobileMode = true;
                                    updateState();
                                }
                            }
                            else {
                                if (mobileMode && dataManagerService.getModel().loadComplete) {
                                    mobileMode = false;
                                    updateState();
                                }
                            }
                        }, true);
                        w.bind('resize', function () {
                            scope.$apply();
                        });
                    }
                };
            }
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var access;
                (function (access) {
                    'use strict';
                    var DataManagerDataAccessDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerDataAccessDirectiveController($rootScope, $scope, $state, $modal, dataManagerService, messagesService) {
                            this.$rootScope = $rootScope;
                            this.$scope = $scope;
                            this.$state = $state;
                            this.$modal = $modal;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.rootScope = $rootScope;
                            this.scope = $scope;
                        }
                        // Modal setup
                        DataManagerDataAccessDirectiveController.prototype.enableDataAccessCall = function (ctn) {
                            // var ctrl: any = this;
                            var _this = this;
                            // Notify server about this change
                            this.dataManagerService.setBlockAPI(this.scope.ctn, !this.dataAccess)
                                .then(function (result) {
                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                    _this.setDataAccess(_this.scope.ctn, true);
                                }
                                else {
                                    var errorMessageKey = 'ute.dataManager.dataAccess.errorSecondaryDataOn';
                                    _this.errorModalPopup('ute.dataManager.dataAccess.errorHeading', errorMessageKey);
                                    _this.setDataAccess(_this.scope.ctn, false);
                                }
                            })
                                .catch(function () {
                                var errorMessageKey = 'ute.dataManager.dataAccess.errorSecondaryDataOn';
                                _this.errorModalPopup('ute.dataManager.dataAccess.errorHeading', errorMessageKey);
                                _this.setDataAccess(_this.scope.ctn, false);
                            });
                        };
                        DataManagerDataAccessDirectiveController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        DataManagerDataAccessDirectiveController.prototype.getSetBlockCallInProgress = function () {
                            return this.dataManagerService.getSetBlockCallInProgress();
                        };
                        DataManagerDataAccessDirectiveController.prototype.confirmDataCancelModalPopup = function (ctn) {
                            var _this = this;
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.controllerName,
                                controllerAs: 'dataManagerDataAccessModal',
                                size: 'md',
                                scope: this.scope,
                                backdrop: 'static'
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        _this.modalUserAnswerYes();
                                        break;
                                    case 'no':
                                        _this.modalUserAnswerNo();
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                                _this.modalDismissed();
                            });
                        };
                        DataManagerDataAccessDirectiveController.prototype.modalUserAnswerYes = function () {
                            var _this = this;
                            // var ctrl: any = this;
                            this.dataManagerService.setBlockAPI(this.scope.ctn, !this.dataAccess)
                                .then(function (result) {
                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                    _this.setDataAccess(_this.scope.ctn, false);
                                }
                                else {
                                    var errorMessageKey = 'ute.dataManager.dataAccess.errorSecondaryDataOff';
                                    _this.setDataAccess(_this.scope.ctn, true);
                                    _this.errorModalPopup('ute.dataManager.dataAccess.errorHeading', errorMessageKey);
                                }
                            })
                                .catch(function () {
                                var errorMessageKey = 'ute.dataManager.dataAccess.errorSecondaryDataOff';
                                _this.setDataAccess(_this.scope.ctn, true);
                                _this.errorModalPopup('ute.dataManager.dataAccess.errorHeading', errorMessageKey);
                            });
                        };
                        DataManagerDataAccessDirectiveController.prototype.modalUserAnswerNo = function () {
                            this.setDataAccess(this.scope.ctn, true);
                        };
                        DataManagerDataAccessDirectiveController.prototype.modalDismissed = function () {
                            this.modalUserAnswerNo();
                        };
                        DataManagerDataAccessDirectiveController.prototype.getDataAccessCTN = function (ctn) {
                            return this.dataManagerService.getDataAccessCTN(ctn);
                        };
                        DataManagerDataAccessDirectiveController.prototype.setDataAccess = function (ctn, val) {
                            this.dataAccess = val;
                            this.dataManagerService.setDataAccessCTN(ctn, val);
                        };
                        DataManagerDataAccessDirectiveController.prototype.dataAccessChange = function () {
                            if (this.dataAccess) {
                                this.enableDataAccessCall(this.scope.ctn);
                            }
                            else {
                                this.confirmDataCancelModalPopup(this.scope.ctn);
                            }
                            this.scope.switchValueChange(this.dataAccess);
                        };
                        DataManagerDataAccessDirectiveController.prototype.swipeLeft = function () {
                            if (this.dataAccess) {
                                this.dataAccess = !this.dataAccess;
                                this.dataAccessChange();
                            }
                        };
                        DataManagerDataAccessDirectiveController.prototype.swipeRight = function () {
                            if (!this.dataAccess) {
                                this.dataAccess = !this.dataAccess;
                                this.dataAccessChange();
                            }
                        };
                        DataManagerDataAccessDirectiveController.$inject = ['$rootScope', '$scope', '$state', '$modal', 'ute.data.manager.service', 'ute.blocks.messages.bus.service'];
                        return DataManagerDataAccessDirectiveController;
                    }());
                    access.DataManagerDataAccessDirectiveController = DataManagerDataAccessDirectiveController;
                    angular.module('ute.data.manager.data.access').controller('ute.data.manager.data.access.directive.controller', DataManagerDataAccessDirectiveController);
                })(access = data.access || (data.access = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var access;
                (function (access) {
                    'use strict';
                    angular.module('ute.data.manager.data.access').directive('uteDataManagerDataAccessDirective', uteDataManagerDataAccessDirective);
                    uteDataManagerDataAccessDirective.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerDataAccessDirective(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'ctn': '@', 'colorCode': '@', 'onCopy': '@', 'offCopy': '@', 'topUpTarget': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerDataAccessDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerDataAccessDirective.controllerName,
                            controllerAs: 'dataManagerDataAccessDirective',
                            link: function (scope, element, attrs, controller) {
                                var uteDataManagerDataControlDataAccessMDThumb = angular.element(element[0].getElementsByClassName('md-bar'));
                                scope.switchValueChange = function (newVal) {
                                    if (newVal) {
                                        uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                    }
                                    else {
                                        uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                    }
                                };
                                scope.$watch('ctn', function (newCTN, oldCTN) {
                                    if (newCTN) {
                                        controller.dataAccess = dataManagerService.getDataAccessCTN(scope.ctn);
                                        if (controller.dataAccess) {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                        }
                                        else {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                        }
                                    }
                                });
                                scope.$watch(function () { return controller.dataAccess; }, function (currentAccess) {
                                    if (currentAccess) {
                                        uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                    }
                                    else {
                                        uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                    }
                                });
                            }
                        };
                    }
                })(access = data.access || (data.access = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var alerts;
                (function (alerts) {
                    'use strict';
                    var DataManagerDataAlertsController = (function () {
                        /* @ngInject */
                        function DataManagerDataAlertsController($scope, $window, $state, $filter, dataManagerService) {
                            this.$scope = $scope;
                            this.$window = $window;
                            this.$state = $state;
                            this.$filter = $filter;
                            this.dataManagerService = dataManagerService;
                            this.discoveryParams = {};
                            this.model = this.dataManagerService.getModel();
                            /*
                                  var _this = this;
                                  $scope.$watch(this.getDiscoveryParams(), function (params: any) {
                                    _this.discoveryParams = params;
                                  });
                            //*/
                            this.discoveryParams = this.getDiscoveryParams();
                        }
                        DataManagerDataAlertsController.prototype.getIsVideoThrottlePermitted = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted();
                        };
                        DataManagerDataAlertsController.prototype.getManageButtonCopy = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted() ? 'ute.dataManager.dataAlerts.manageVideoStreaming' : 'ute.dataManager.dataAlerts.manage';
                        };
                        DataManagerDataAlertsController.prototype.getAlertTagCopy = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted() ? 'ute.dataManager.dataAlerts.myVTAlert' : 'ute.dataManager.dataAlerts.myAlert';
                        };
                        DataManagerDataAlertsController.prototype.graphBaseCopy = function (line) {
                            return this.getBarsWidthInPixels() > 50 ? this.$filter('ute_common_filter_data_conversion')(line.dataUsed, 'mb', this.getBase(), (line.dataUsed > this.getBase() ? 2 : 0), true, false) : '';
                        };
                        DataManagerDataAlertsController.prototype.graphSecondaryValue = function (line) {
                            return line.useAlert ? this.isBucketSizeUnavailableUntilNextBillCycle() ? 0 : (line.savedAlertValue >= 1024 ? line.savedAlertValue / 1024 * 1000 : line.savedAlertValue) : 0;
                        };
                        DataManagerDataAlertsController.prototype.getMaxLimit = function () {
                            return this.dataManagerService.getDataLimit();
                        };
                        DataManagerDataAlertsController.prototype.getHighestDataPoint = function () {
                            return this.dataManagerService.getHighestDataPoint();
                        };
                        DataManagerDataAlertsController.prototype.getFilteredList = function () {
                            return this.dataManagerService.getFilteredList();
                        };
                        DataManagerDataAlertsController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerDataAlertsController.prototype.getBarsWidth = function () {
                            var filteredList = this.getFilteredList();
                            if (filteredList.length === 0) {
                                return 0;
                            }
                            else {
                                return 100 / filteredList.length;
                            }
                        };
                        DataManagerDataAlertsController.prototype.getBarsWidthInPixels = function () {
                            var filteredList = this.getFilteredList();
                            if (filteredList.length === 0) {
                                return 0;
                            }
                            else {
                                return this.$window.innerWidth / filteredList.length;
                            }
                        };
                        DataManagerDataAlertsController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerDataAlertsController.prototype.getDataControlListWithData = function () {
                            return this.dataManagerService.getDataControlListWithData();
                        };
                        DataManagerDataAlertsController.prototype.getAlertsRecipientCTN = function () {
                            return this.dataManagerService.getAlertsRecipientCTN();
                        };
                        DataManagerDataAlertsController.prototype.getAccountNumber = function () {
                            return this.dataManagerService.getModel().accountNumber;
                        };
                        DataManagerDataAlertsController.prototype.getBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversion;
                        };
                        DataManagerDataAlertsController.prototype.goToManageAlerts = function (tabIndex) {
                            if (tabIndex === 1) {
                                this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().complete, this.dataManagerService.getDataLayerEvent().viewVideoQualityTab);
                            }
                            this.dataManagerService.setDataManagerActiveTabIndex(tabIndex);
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.subState);
                        };
                        DataManagerDataAlertsController.prototype.getDiscoveryParams = function () {
                            var config = this.dataManagerService.getConfig();
                            var model = this.dataManagerService.getModel();
                            return {
                                ban: model.accountNumber,
                                ctn: model.dataControlList.length > 0 ? model.dataControlList[0].ctn : '',
                                copy: this.$filter('translate')('ute.dataManager.dataAlerts.informationLink'),
                                brand: config.advanced.dataManagerDiscoveryIntegration.brand,
                                segment: config.advanced.dataManagerDiscoveryIntegration.segment,
                                accountType: config.advanced.dataManagerDiscoveryIntegration.accountType,
                                productType: config.advanced.dataManagerDiscoveryIntegration.productType,
                                pageFilter: config.advanced.dataManagerDiscoveryIntegration.pageFilter,
                                province: model.province
                            };
                        };
                        DataManagerDataAlertsController.$inject = ['$scope', '$window', '$state', '$filter', 'ute.data.manager.service'];
                        return DataManagerDataAlertsController;
                    }());
                    alerts.DataManagerDataAlertsController = DataManagerDataAlertsController;
                    angular.module('ute.data.manager.data.alerts').controller('ute.data.manager.data.alerts.controller', DataManagerDataAlertsController);
                })(alerts = data.alerts || (data.alerts = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var alerts;
                (function (alerts) {
                    'use strict';
                    angular.module('ute.data.manager.data.alerts').directive('uteDataManagerDataAlerts', uteDataManagerDataAlerts);
                    uteDataManagerDataAlerts.$inject = ['ute.data.manager.service',
                        'ute.common.utils.service'];
                    /* @ngInject */
                    function uteDataManagerDataAlerts(dataManagerService, utilsService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerDataAlertsDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerDataAlertsDirective.controllerName,
                            controllerAs: 'dataManagerDataAlerts',
                            link: function (scope, element, attrs, controller) {
                                utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                            }
                        };
                    }
                })(alerts = data.alerts || (data.alerts = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var video;
                (function (video) {
                    var throttle;
                    (function (throttle) {
                        var wrapper;
                        (function (wrapper) {
                            'use strict';
                            var DataManagerDataAndVideoThrottleWrapperController = (function () {
                                /* @ngInject */
                                function DataManagerDataAndVideoThrottleWrapperController($scope, $rootScope, $modal, dataManagerService) {
                                    this.$scope = $scope;
                                    this.$rootScope = $rootScope;
                                    this.$modal = $modal;
                                    this.dataManagerService = dataManagerService;
                                    this.scope = $scope;
                                    this.rootScope = $rootScope;
                                    this.isDataAlertsConsoleLoaded = false;
                                    this.dataManagerService.fetchConfirmationModalPreference();
                                    if (this.dataManagerService.getDataAlertsOpen()) {
                                        this.dataManagerService.toggleDataAlerts();
                                    }
                                }
                                DataManagerDataAndVideoThrottleWrapperController.prototype.getIsVideoThrottlePermitted = function () {
                                    return this.dataManagerService.getIsVideoThrottlePermitted();
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.getUsageDetailsCallInProgress = function () {
                                    return this.dataManagerService.getUsageDetailsCallInProgress();
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.toggleDataAlertsTab = function (tabIndex) {
                                    if (tabIndex === 1) {
                                        this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().complete, this.dataManagerService.getDataLayerEvent().viewVideoQualityTab);
                                    }
                                    this.dataManagerService.toggleDataAlerts(tabIndex);
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.setDataAlertsActiveTabIndex = function (tabIndex) {
                                    this.dataManagerService.setDataAlertsActiveTabIndex(tabIndex);
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.getButtonCopy = function () {
                                    return this.getDataAlertsOpen() ? 'ute.dataManager.dataAndVideoThrottleWrapper.closeDataAlerts' : 'ute.dataManager.dataAndVideoThrottleWrapper.openDataAlerts';
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.getDataAlertsOpen = function () {
                                    return this.dataManagerService.getDataAlertsOpen();
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.getButtonArrowClass = function () {
                                    return this.dataManagerService.getDataAlertsOpen() ? 'ute-icon-arrow-down-invert' : '';
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.isConsoleLoaded = function () {
                                    return this.isDataAlertsConsoleLoaded;
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.alertsRecipientCheck = function () {
                                    if (this.getDataAlertsOpen() && !this.dataManagerService.getAlertsRecipientCTN()) {
                                        this.openModalPopup();
                                    }
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.errorModalPopup = function (primary, secondary) {
                                    var errorModalScope = this.rootScope.$new();
                                    errorModalScope.params = { primary: primary, secondary: secondary };
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                        controllerAs: 'dataManagerGenericModal',
                                        size: 'md',
                                        backdrop: 'static',
                                        scope: errorModalScope
                                    });
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.openModalPopup = function () {
                                    var _this = this;
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                        controllerAs: 'dataManagerAlertsRecipientModal',
                                        size: 'md',
                                        backdrop: 'static'
                                    }).result.then(function (result) {
                                        // Result selection behaviour
                                        switch (result) {
                                            case 'yes':
                                                break;
                                            case 'no':
                                                _this.toggleDataAlerts();
                                                console.log('Toggle Data Alerts Call');
                                                break;
                                            case 'error':
                                                _this.errorModalPopup('ute.dataManager.dataControlList.errorHeading', 'ute.dataManager.dataControlList.errorSecondary');
                                                _this.toggleDataAlerts();
                                                break;
                                        }
                                    }, function () {
                                        // Dismiss behaviour
                                        // Do nothing/close
                                        _this.toggleDataAlerts();
                                    });
                                };
                                DataManagerDataAndVideoThrottleWrapperController.prototype.toggleDataAlerts = function () {
                                    this.isDataAlertsConsoleLoaded = true;
                                    this.dataManagerService.toggleDataAlerts();
                                };
                                DataManagerDataAndVideoThrottleWrapperController.$inject = ['$scope', '$rootScope', '$modal', 'ute.data.manager.service'];
                                return DataManagerDataAndVideoThrottleWrapperController;
                            }());
                            wrapper.DataManagerDataAndVideoThrottleWrapperController = DataManagerDataAndVideoThrottleWrapperController;
                            angular.module('ute.data.manager.data.video.throttle.wrapper').controller('ute.data.manager.data.video.throttle.wrapper.directive.controller', DataManagerDataAndVideoThrottleWrapperController);
                        })(wrapper = throttle.wrapper || (throttle.wrapper = {}));
                    })(throttle = video.throttle || (video.throttle = {}));
                })(video = data.video || (data.video = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var video;
                (function (video) {
                    var throttle;
                    (function (throttle) {
                        var wrapper;
                        (function (wrapper) {
                            'use strict';
                            angular.module('ute.data.manager.data.video.throttle.wrapper').directive('uteDataManagerDataVideoThrottleWrapper', uteDataManagerDataVideoThrottleWrapper);
                            uteDataManagerDataVideoThrottleWrapper.$inject = [
                                'ute.data.manager.service',
                                'ute.common.utils.service',
                                '$timeout'
                            ];
                            /* @ngInject */
                            function uteDataManagerDataVideoThrottleWrapper(dataManagerService, utilsService, $timeout) {
                                return {
                                    restrict: 'E',
                                    scope: {},
                                    templateUrl: dataManagerService.getConfig().advanced.dataManagerDataVideoThrottleWrapperDirective.templateUrl,
                                    controller: dataManagerService.getConfig().advanced.dataManagerDataVideoThrottleWrapperDirective.controllerName,
                                    controllerAs: 'dataManagerDataVideoThrottleWrapper',
                                    link: function (scope, element, attrs, controller) {
                                        utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                        controller.dataManagerActiveTabIndex = dataManagerService.getDataManagerActiveTabIndex();
                                        scope.$watch(function () { return dataManagerService.getDataManagerActiveTabIndex(); }, function (newVal, oldVal) {
                                            if (newVal !== oldVal) {
                                                controller.dataManagerActiveTabIndex = newVal;
                                            }
                                        });
                                        scope.$watch(function () { return dataManagerService.getDataAlertsOpen(); }, function (open) {
                                            if (open) {
                                                controller.alertsRecipientCheck();
                                            }
                                        });
                                        $timeout(function () {
                                            var mdTabItemList = element[0].getElementsByTagName('md-tab-item');
                                            var mdTabsCanvas = element[0].getElementsByTagName('md-tabs-canvas');
                                            var mdTabItemListLength = mdTabItemList.length;
                                            mdTabsCanvas[0].tabIndex = '-1';
                                            for (var iList = 0; iList < mdTabItemListLength; iList++) {
                                                mdTabItemList[iList].tabIndex = '0';
                                                angular.element(mdTabItemList[iList]).bind('keydown', function (e) {
                                                    if (e.which === 13) {
                                                        $(this).click();
                                                    }
                                                });
                                            }
                                        }, 4000);
                                    }
                                };
                            }
                        })(wrapper = throttle.wrapper || (throttle.wrapper = {}));
                    })(throttle = video.throttle || (video.throttle = {}));
                })(video = data.video || (data.video = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var list;
                    (function (list) {
                        'use strict';
                        var DataManagerDataControlListController = (function () {
                            /* @ngInject */
                            function DataManagerDataControlListController($state, $filter, $rootScope, $modal, dataManagerService, messagesService, $document) {
                                this.$state = $state;
                                this.$filter = $filter;
                                this.$rootScope = $rootScope;
                                this.$modal = $modal;
                                this.dataManagerService = dataManagerService;
                                this.messagesService = messagesService;
                                this.$document = $document;
                                this.discoveryParams = {};
                                this.model = this.dataManagerService.getModel();
                                this.discoveryParams = this.getDiscoveryParams();
                                this.rootScope = $rootScope;
                                this.isDataAlertsConsoleLoaded = false;
                            }
                            DataManagerDataControlListController.prototype.getTotalDataLimit = function () {
                                return this.dataManagerService.getTotalDataLimit();
                            };
                            DataManagerDataControlListController.prototype.buttonClick = function () {
                                this.messagesService.publish('ute-data-manager-increase-plan-button-click-usageDial');
                                this.$document.scrollTop(0);
                            };
                            DataManagerDataControlListController.prototype.getIsVideoThrottlePermitted = function () {
                                return this.dataManagerService.getIsVideoThrottlePermitted();
                            };
                            DataManagerDataControlListController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                                return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                            };
                            DataManagerDataControlListController.prototype.getConfig = function () {
                                return this.dataManagerService.getConfig();
                            };
                            DataManagerDataControlListController.prototype.getDataControlList = function () {
                                return this.dataManagerService.getDataControlList();
                            };
                            DataManagerDataControlListController.prototype.isAllowedToPurchaseData = function () {
                                return this.dataManagerService.isAllowedToPurchaseData();
                            };
                            DataManagerDataControlListController.prototype.getDataLimit = function () {
                                if (this.dataManagerService.isCare()) {
                                    return this.dataManagerService.getDataLimit() + this.dataManagerService.getAddedExtraData();
                                }
                                else {
                                    return this.dataManagerService.getDataLimit();
                                }
                            };
                            DataManagerDataControlListController.prototype.getAlertsRecipientCTN = function () {
                                return this.dataManagerService.getAlertsRecipientCTN();
                            };
                            DataManagerDataControlListController.prototype.getBase = function () {
                                return this.dataManagerService.getDataLimit() >= this.dataManagerService.getConfig().basic.dataConversionRoundValues ? this.dataManagerService.getConfig().basic.dataConversion : this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                            };
                            DataManagerDataControlListController.prototype.getAlertedDataTotal = function () {
                                return Math.round(this.dataManagerService.getAlertedDataTotal() * 100) / 100;
                            };
                            DataManagerDataControlListController.prototype.getSavedAlertDataTotal = function () {
                                return Math.round(this.dataManagerService.getSavedAlertedDataTotal() * 100) / 100;
                            };
                            DataManagerDataControlListController.prototype.alertsRecipientCTNExists = function () {
                                return this.dataManagerService.getAlertsRecipientCTN() !== null;
                            };
                            DataManagerDataControlListController.prototype.getUsageDetailsCallInProgress = function () {
                                return this.dataManagerService.getUsageDetailsCallInProgress();
                            };
                            DataManagerDataControlListController.prototype.toggleDataAlerts = function () {
                                this.isDataAlertsConsoleLoaded = true;
                                this.dataManagerService.toggleDataAlerts();
                            };
                            DataManagerDataControlListController.prototype.alertsRecipientCheck = function () {
                                if (this.getDataAlertsOpen() && !this.dataManagerService.getAlertsRecipientCTN()) {
                                    this.openModalPopup();
                                }
                            };
                            DataManagerDataControlListController.prototype.isConsoleLoaded = function () {
                                return this.isDataAlertsConsoleLoaded;
                            };
                            DataManagerDataControlListController.prototype.getDataAlertsOpen = function () {
                                return this.dataManagerService.getDataAlertsOpen();
                            };
                            DataManagerDataControlListController.prototype.errorModalPopup = function (primary, secondary) {
                                var errorModalScope = this.rootScope.$new();
                                errorModalScope.params = { primary: primary, secondary: secondary };
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                    controllerAs: 'dataManagerGenericModal',
                                    size: 'md',
                                    backdrop: 'static',
                                    scope: errorModalScope
                                });
                            };
                            DataManagerDataControlListController.prototype.openModalPopup = function () {
                                var _this = this;
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                    controllerAs: 'dataManagerAlertsRecipientModal',
                                    size: 'md',
                                    backdrop: 'static'
                                }).result.then(function (result) {
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            break;
                                        case 'no':
                                            _this.toggleDataAlerts();
                                            break;
                                        case 'error':
                                            _this.errorModalPopup('ute.dataManager.dataControlList.errorHeading', 'ute.dataManager.dataControlList.errorSecondary');
                                            _this.toggleDataAlerts();
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                    _this.toggleDataAlerts();
                                });
                            };
                            DataManagerDataControlListController.prototype.getDiscoveryParams = function () {
                                var config = this.dataManagerService.getConfig();
                                var model = this.dataManagerService.getModel();
                                return {
                                    ban: model.accountNumber,
                                    ctn: model.dataControlList.length > 0 ? model.dataControlList[0].ctn : '',
                                    copy: this.$filter('translate')('ute.dataManager.dataAlerts.informationLink'),
                                    brand: config.advanced.dataManagerDiscoveryIntegration.brand,
                                    segment: config.advanced.dataManagerDiscoveryIntegration.segment,
                                    accountType: config.advanced.dataManagerDiscoveryIntegration.accountType,
                                    productType: config.advanced.dataManagerDiscoveryIntegration.productType,
                                    pageFilter: config.advanced.dataManagerDiscoveryIntegration.pageFilter,
                                    province: model.province
                                };
                            };
                            DataManagerDataControlListController.prototype.getButtonCopy = function () {
                                return this.getDataAlertsOpen() ? 'ute.dataManager.dataControlList.closeDataAlerts' : 'ute.dataManager.dataControlList.openDataAlerts';
                            };
                            DataManagerDataControlListController.prototype.getButtonArrowClass = function () {
                                return this.dataManagerService.getDataAlertsOpen() ? 'ute-icon-arrow-down-invert' : '';
                            };
                            DataManagerDataControlListController.prototype.getTitleBarClass = function () {
                                return this.isBucketSizeUnavailableUntilNextBillCycle() ? 'col-lg-5 col-md-5 col-sm-5' : 'col-lg-2 col-md-2 col-sm-2';
                            };
                            DataManagerDataControlListController.prototype.isGBMode = function () {
                                return this.getDataLimit() >= this.getBase();
                            };
                            DataManagerDataControlListController.prototype.getPrecisionPlace = function () {
                                return this.isGBMode() ? 2 : 0;
                            };
                            DataManagerDataControlListController.prototype.getSavedAlertedDataValue = function () {
                                return this.isGBMode() ? ((this.getSavedAlertDataTotal() * 1) / 1024) : this.getSavedAlertDataTotal();
                            };
                            DataManagerDataControlListController.prototype.isInfinitePlan = function () {
                                return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                            };
                            DataManagerDataControlListController.prototype.getAddDataTranslationKey = function () {
                                var isInfinitePlan = this.isInfinitePlan();
                                return isInfinitePlan ? 'ute.dataManager.dataControlList.addSpeedPass' : 'ute.dataManager.dataControlList.addData';
                            };
                            DataManagerDataControlListController.$inject = ['$state', '$filter', '$rootScope', '$modal', 'ute.data.manager.service', 'ute.blocks.messages.bus.service', '$document', 'ute.data.manager.see.service'];
                            return DataManagerDataControlListController;
                        }());
                        list.DataManagerDataControlListController = DataManagerDataControlListController;
                        angular.module('ute.data.manager.data.control.list').controller('ute.data.manager.data.control.list.directive.controller', DataManagerDataControlListController);
                    })(list = control.list || (control.list = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control.list').directive('uteDataManagerDataControlList', uteDataManagerDataControlList);
                    uteDataManagerDataControlList.$inject = ['ute.data.manager.service',
                        'ute.common.utils.service'];
                    /* @ngInject */
                    function uteDataManagerDataControlList(dataManagerService, utilsService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerDataControlListDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerDataControlListDirective.controllerName,
                            controllerAs: 'dataManagerDataControlList',
                            link: function (scope, element, attrs, controller) {
                                utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                scope.dataLimit = controller.getDataLimit();
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        var list;
                        (function (list) {
                            'use strict';
                            var DataManagerDataControlTagListController = (function () {
                                /* @ngInject */
                                function DataManagerDataControlTagListController($scope, $state, $rootScope, dataManagerService, dataManagerSeeService, languageService) {
                                    var _this = this;
                                    this.$scope = $scope;
                                    this.$state = $state;
                                    this.$rootScope = $rootScope;
                                    this.dataManagerService = dataManagerService;
                                    this.dataManagerSeeService = dataManagerSeeService;
                                    this.languageService = languageService;
                                    this.model = this.dataManagerService.getModel();
                                    // SEE project implementation
                                    dataManagerSeeService.getSeeBrtShowState().then(function (showState) {
                                        if (showState) {
                                            if (_this.dataManagerSeeService.tabAccountLinks && _this.dataManagerSeeService.tabAccountLinks.length) {
                                                _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                            }
                                            else {
                                                _this.dataManagerService.getAccountStatus().then(function (accountOverview) {
                                                    if (accountOverview.getSelectedAccount().accountStatus && accountOverview.getSelectedAccount().accountStatus.toLowerCase() === 'active') {
                                                        _this.dataManagerSeeService.addTabLink(_this.dataManagerService.getDataControlList()).then(function () {
                                                            _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                                        });
                                                    }
                                                });
                                            }
                                        }
                                    });
                                    this.languageService.registerOnDataChangeHandler(function (lang) {
                                        _this.dataManagerSeeService.tabAccountLinks = [];
                                        _this.seeLinks = [];
                                        _this.dataManagerService.getAccountStatus().then(function (accountOverview) {
                                            if (accountOverview.getSelectedAccount().accountStatus && accountOverview.getSelectedAccount().accountStatus.toLowerCase() === 'active') {
                                                _this.dataManagerSeeService.addTabLink(_this.dataManagerService.getDataControlList()).then(function () {
                                                    _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                                });
                                            }
                                        });
                                        return null;
                                    }, 'ute.data.manager.data.control.tag.list.controller');
                                    $scope.$on('$destroy', function () {
                                        if (_this && _this.languageService) {
                                            _this.languageService.unregisterOnDataChangeHandler('ute.data.manager.data.control.tag.list.controller');
                                        }
                                    });
                                    // END of SEE project implementation
                                }
                                DataManagerDataControlTagListController.prototype.getMaxLimit = function () {
                                    return this.dataManagerService.getDataLimit();
                                };
                                DataManagerDataControlTagListController.prototype.getDataControlList = function () {
                                    return this.dataManagerService.getDataControlList();
                                };
                                DataManagerDataControlTagListController.prototype.getAlertsRecipientCTN = function () {
                                    return this.dataManagerService.getAlertsRecipientCTN();
                                };
                                DataManagerDataControlTagListController.prototype.isAlertsRecipient = function (ctn) {
                                    return (this.dataManagerService.getAlertsRecipientCTN() === ctn);
                                };
                                DataManagerDataControlTagListController.prototype.getSeeLinks = function () {
                                    return this.seeLinks;
                                };
                                DataManagerDataControlTagListController.prototype.seeAddLine = function () {
                                    this.dataManagerSeeService.goToAddLine();
                                    return;
                                };
                                DataManagerDataControlTagListController.$inject = ['$scope', '$state', '$rootScope', 'ute.data.manager.service', 'ute.data.manager.see.service', 'ute.blocks.language.switcher'];
                                return DataManagerDataControlTagListController;
                            }());
                            list.DataManagerDataControlTagListController = DataManagerDataControlTagListController;
                            angular.module('ute.data.manager.data.control.tag.list').controller('ute.data.manager.data.control.tag.list.controller', DataManagerDataControlTagListController);
                        })(list = tag.list || (tag.list = {}));
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        var list;
                        (function (list) {
                            'use strict';
                            angular.module('ute.data.manager.data.control.tag.list').directive('uteDataManagerDataControlTagList', uteDataManagerDataControlTagList);
                            uteDataManagerDataControlTagList.$inject = ['ute.data.manager.service',
                                'ute.common.utils.service'];
                            /* @ngInject */
                            function uteDataManagerDataControlTagList(dataManagerService, utilsService) {
                                return {
                                    restrict: 'E',
                                    scope: {},
                                    templateUrl: dataManagerService.getConfig().advanced.dataManagerDataControlTagListDirective.templateUrl,
                                    controller: dataManagerService.getConfig().advanced.dataManagerDataControlTagListDirective.controllerName,
                                    controllerAs: 'dataManagerDataControlTagList',
                                    link: function (scope, element, attrs, controller) {
                                        utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                    }
                                };
                            }
                        })(list = tag.list || (tag.list = {}));
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            'use strict';
            var DataManagerErrorPageController = (function () {
                /* @ngInject */
                function DataManagerErrorPageController($state, $modal, dataManagerService) {
                    this.$state = $state;
                    this.$modal = $modal;
                    this.dataManagerService = dataManagerService;
                    this.state = $state;
                }
                DataManagerErrorPageController.prototype.backToDashboard = function () {
                    this.state.go(this.dataManagerService.getConfig().basic.dashboardState);
                };
                DataManagerErrorPageController.$inject = ['$state', '$modal', 'ute.data.manager.service'];
                return DataManagerErrorPageController;
            }());
            manager.DataManagerErrorPageController = DataManagerErrorPageController;
            angular.module('ute.data.manager').controller('ute.data.manager.error.page.controller', DataManagerErrorPageController);
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var increase;
            (function (increase) {
                var plan;
                (function (plan) {
                    'use strict';
                    //import IDataManagerDataProduct = ute.data.manager.service.IDataManagerDataProduct;
                    var DataManagerIncreasePlanDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerIncreasePlanDirectiveController($scope, $rootScope, $window, $state, $modal, $timeout, dataManagerService, messagesService, $translate, $filter) {
                            var _this = this;
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$window = $window;
                            this.$state = $state;
                            this.$modal = $modal;
                            this.$timeout = $timeout;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.$translate = $translate;
                            this.$filter = $filter;
                            this.errorModalPopup = function (primary, secondary) {
                                var errorModalScope = _this.rootScope.$new();
                                errorModalScope.params = { primary: primary, secondary: secondary };
                                _this.$modal.open({
                                    windowTemplateUrl: _this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                    templateUrl: _this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                    controller: _this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                    controllerAs: 'dataManagerGenericModal',
                                    size: 'md',
                                    backdrop: 'static',
                                    scope: errorModalScope
                                });
                            };
                            this.handleIncreseDataError = function () {
                                _this.addMoreTagSwitchOff();
                                _this.errorModalPopup('ute.dataManager.increasePlan.errorHeading', 'ute.dataManager.increasePlan.errorBody');
                                _this.dataManagerService.setPurchaseDataProductCallInProgress(false);
                            };
                            this.handleIncreaseDataSuccess = function () {
                                _this.addMoreTagSwitchOff();
                                var ctrl = _this;
                                var request = {
                                    accountNumber: _this.dataManagerService.getModel().accountNumber,
                                    serviceType: _this.dataManagerService.getConfig().basic.serviceType
                                };
                                var worker = _this.dataManagerService.getUsageDetailsWorker(request);
                                worker.getDataManagerServerGetUsageDetails()
                                    .then(function (dataManagerServerGetUsageDetails) {
                                    ctrl.dataManagerService.setModel(ctrl.dataManagerService.transformUsageDetails(dataManagerServerGetUsageDetails, ctrl.dataManagerService.getModel()));
                                    worker.resetCachedData();
                                })
                                    .catch(function () {
                                    ctrl.dataManagerService.setStateToErrorPage();
                                });
                            };
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.rootScope = $rootScope;
                            this.addMoreTag = false;
                            this.clickToClose = false;
                            this.expandAnimation = '';
                            this.scope.selectedDataPlan = -1;
                            this.pathToSharedIncreasePartial = this.dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirectivePopUp.templateUrl;
                            //Fly-out control can be triggered from multiple points outside this module
                            this.scope.$on('ute-data-manager-increase-plan-button-click-' + $scope.id, function (evt) { return _this.addMoreTagSwitch(); });
                            this.selectedPlan = null;
                            this.showWcocConsent = false;
                        }
                        DataManagerIncreasePlanDirectiveController.prototype.increaseData = function (selectedDataPlanIndex) {
                            var ctrl = this;
                            if (selectedDataPlanIndex > -1) {
                                this.dataManagerService.purchaseDataProductAPI(selectedDataPlanIndex)
                                    .then(function (result) {
                                    if (result && result.data) {
                                        var body = result.data.body || {};
                                        var error = result.data.error || {};
                                        if (body.isSuccess) {
                                            ctrl.handleIncreaseDataSuccess();
                                        }
                                        else {
                                            if (ctrl.dataManagerService.getIsFdmWcocPermitted()
                                                && (error.code === '25' || error.type === 'WCOC')) {
                                                ctrl.selectedPlan = ctrl.dataManagerService.getModel().increaseDataOptions[selectedDataPlanIndex];
                                                ctrl.selectedPlan.index = selectedDataPlanIndex;
                                                //Show consent modal
                                                ctrl.showWcocConsent = true;
                                            }
                                            else {
                                                ctrl.handleIncreseDataError();
                                            }
                                        }
                                    }
                                    else {
                                        ctrl.handleIncreseDataError();
                                    }
                                })
                                    .catch(function () {
                                    ctrl.handleIncreseDataError();
                                });
                            }
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.isAddDataVisible = function () {
                            return this.dataManagerService.getIsRogersDataPurchaseEnabled();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.isAllowedToPurchaseData = function () {
                            if (this.dataManagerService.isAllowedToPurchaseData()) {
                                return true;
                            }
                            else {
                                if (this.dataManagerService.getOverageForDTU() > 0) {
                                    return this.dataManagerService.getIsRogersAddonEnabled() ? true : false;
                                }
                                else {
                                    return false;
                                }
                            }
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.isStrokeHidden = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle() || this.dataManagerService.getUsageDetailsCallInProgress() || this.dataManagerService.isProrationError();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.isAtAddedLimit = function () {
                            return this.dataManagerService.getPurchaseDataIncreases().length >= this.dataManagerService.getConfig().basic.purchaseDataProductLimit;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.getPurchaseDataProductCallInProgress = function () {
                            return this.dataManagerService.getPurchaseDataProductCallInProgress();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.getDataProductsCallInProgress = function () {
                            return this.dataManagerService.getDataProductsCallInProgress();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.getIncreaseDataOptions = function () {
                            return this.dataManagerService.getIncreaseDataOptions();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.getBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversion;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.isOverage = function () {
                            return this.dataManagerService.getOverage() > 0;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.noSelection = function () {
                            this.clickToClose = false;
                            this.messagesService.publish('ute-data-manager-increase-plan-button-click-usageDial');
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.addMoreTagSwitch = function () {
                            var _this = this;
                            this.addMoreTag = !this.addMoreTag;
                            if (this.addMoreTag) {
                                this.$timeout(function (evt) {
                                    _this.addMoreModalMobile();
                                    _this.clickToClose = true;
                                }, 100);
                                this.expandAnimation = 'openTag';
                            }
                            else {
                                this.clickToClose = false;
                                this.expandAnimation = '';
                            }
                            this.selectedPlan = null;
                            this.showWcocConsent = false;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.addMoreTagSwitchOff = function () {
                            var _this = this;
                            this.$timeout(function () {
                                _this.clickToClose = false;
                                _this.addMoreTag = false;
                                _this.expandAnimation = '';
                                _this.selectedPlan = null;
                                _this.showWcocConsent = false;
                            });
                        };
                        // Shared HTML across mobile and desktop
                        DataManagerIncreasePlanDirectiveController.prototype.getSharedIncreasePartial = function () {
                            return this.pathToSharedIncreasePartial;
                        };
                        // Modal for mobile view
                        DataManagerIncreasePlanDirectiveController.prototype.addMoreModalMobile = function () {
                            var modalInstance = '';
                            if (this.$window.innerWidth < 768) {
                                modalInstance = this.confirmDataIncreaseModal();
                            }
                            /* DSO-11752: Replace One-time Top-up with iSMS MDT content - Commenting out WCoC section : Start */
                            /*if (!this.dataManagerService.getDataProductsCallInProgress()) {
                              this.dataManagerService.getDataProductsAPI().then((result: any): void => {
                                if (!result) {
                                  if (modalInstance) {
                                    modalInstance.dismiss('no');
                                  }
                                  this.addMoreTagSwitchOff();
                                  this.errorModalPopup('ute.dataManager.increasePlan.errorHeading', 'ute.dataManager.increasePlan.errorBodyTopupOptions');
                                }
                              }, (): void => {
                                if (modalInstance) {
                                  modalInstance.dismiss('no');
                                }
                                this.addMoreTagSwitchOff();
                                this.errorModalPopup('ute.dataManager.increasePlan.errorHeading', 'ute.dataManager.increasePlan.errorBodyTopupOptions');
                              });
                            } */
                            //DSO-11752: Replace One-time Top-up with iSMS MDT content - Commenting out WCoC section : End
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.confirmDataIncreaseModal = function () {
                            var _this = this;
                            var modalInstance = this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirectiveModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirectiveModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirectiveModal.controllerName,
                                controllerAs: 'dataManagerIncreasePlanDirectiveModal',
                                size: 'sm',
                                scope: this.scope,
                                backdrop: 'static'
                            });
                            modalInstance.result.then(function (result) {
                                // Result selection behaviour
                                switch (result.answer) {
                                    case 'yes':
                                        _this.modalUserAnswerYes(result.idx);
                                        break;
                                    case 'no':
                                        _this.modalUserAnswerNo();
                                        break;
                                    case 'proceedWithConsent':
                                        _this.proceedWithConsent(result.idx, true);
                                        break;
                                    case 'error':
                                        _this.handleIncreseDataError();
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                                _this.modalDismissed();
                            });
                            return modalInstance;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.modalUserAnswerYes = function (selectedDataPlanIndex) {
                            this.handleIncreaseDataSuccess();
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.modalUserAnswerNo = function () {
                            this.addMoreTag = false;
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.modalDismissed = function () {
                            //
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.proceedWithConsent = function (selectedDataPlanIndex, mobileView) {
                            var ctrl = this;
                            var accNumber = this.dataManagerService.getModel().accountNumber;
                            this.dataManagerService.generateWcocToken(accNumber)
                                .then(function (response) {
                                if (response
                                    && response.data
                                    && response.data.wcocAuthToken) {
                                    var token = response.data.wcocAuthToken;
                                    ctrl.dataManagerService.setWcocConsent(accNumber, 'Y', token)
                                        .then(function (response) {
                                        if (response
                                            && response.data
                                            && response.data.code === '200') {
                                            ctrl.increaseData(mobileView ? selectedDataPlanIndex : ctrl.selectedPlan.index);
                                        }
                                        else {
                                            ctrl.handleIncreseDataError();
                                        }
                                    })
                                        .catch(function (error) {
                                        ctrl.handleIncreseDataError();
                                    });
                                }
                                else {
                                    ctrl.handleIncreseDataError();
                                }
                            })
                                .catch(function (error) {
                                ctrl.handleIncreseDataError();
                            });
                        };
                        DataManagerIncreasePlanDirectiveController.prototype.getWcocConsentCallInProgress = function () {
                            return this.dataManagerService.getWcocConsentCallInProgress();
                        };
                        DataManagerIncreasePlanDirectiveController.$inject = ['$scope', '$rootScope', '$window', '$state', '$modal', '$timeout', 'ute.data.manager.service', 'ute.blocks.messages.bus.service', '$translate', '$filter'];
                        return DataManagerIncreasePlanDirectiveController;
                    }());
                    plan.DataManagerIncreasePlanDirectiveController = DataManagerIncreasePlanDirectiveController;
                    angular.module('ute.data.manager.increase.plan').controller('ute.data.manager.increase.plan.directive.controller', DataManagerIncreasePlanDirectiveController);
                })(plan = increase.plan || (increase.plan = {}));
            })(increase = manager.increase || (manager.increase = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var increase;
            (function (increase) {
                var plan;
                (function (plan) {
                    'use strict';
                    angular.module('ute.data.manager.increase.plan').directive('uteDataManagerIncreasePlanDirective', uteDataManagerIncreasePlanDirective);
                    uteDataManagerIncreasePlanDirective.$inject = ['$timeout', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerIncreasePlanDirective($timeout, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { id: '@', disabledOverride: '=' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerIncreasePlanDirective.controllerName,
                            controllerAs: 'dataManagerIncreasePlanDirective',
                            link: function (scope, element, attrs, controller) {
                                controller.dataManagerService.setIsFdmWcocPermitted();
                                $(window).click(function () {
                                    if ($(window).width() > 769 && controller.addMoreTag && controller.clickToClose) {
                                        controller.addMoreTagSwitchOff();
                                    }
                                });
                                $(window).keydown(function (event) {
                                    if (event.keyCode === 27) {
                                        controller.addMoreTagSwitchOff();
                                    }
                                });
                                element.click(function (event) {
                                    if ($(window).width() > 769) {
                                        event.stopPropagation();
                                    }
                                });
                            }
                        };
                    }
                })(plan = increase.plan || (increase.plan = {}));
            })(increase = manager.increase || (manager.increase = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var individual;
            (function (individual) {
                var summary;
                (function (summary_1) {
                    'use strict';
                    var DataManagerIndividualSummaryController = (function () {
                        /* @ngInject */
                        function DataManagerIndividualSummaryController($scope, dataManagerService) {
                            var _this = this;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.updateModel = function (summary) {
                                _this.dataManagerService.setModel(_this.dataManagerService.transformSummary(summary, _this.dataManagerService.getModel()));
                                var request = {
                                    accountNumber: _this.dataManagerService.getAccountNumber(),
                                    serviceType: _this.dataManagerService.getConfig().basic.serviceType
                                };
                                var worker = _this.dataManagerService.getUsageDetailsWorker(request);
                                worker.forceGetUsageDetails().then(function (dataManagerServerGetUsageDetails) {
                                    return _this.dataManagerService.setModel(_this.dataManagerService.transformUsageDetails(dataManagerServerGetUsageDetails, _this.dataManagerService.getModel()));
                                });
                                return null;
                            };
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.accountLine = this.getAccountLineByCTN(this.scope.ctn);
                            this.dataManagerService.getSummaryWorker().then(function (worker) {
                                return worker.registerOnDataChangeHandler(_this.updateModel, DataManagerIndividualSummaryController.controllerName);
                            });
                            this.$scope.$on('$destroy', function () {
                                _this.dataManagerService.getSummaryWorker().then(function (worker) {
                                    return worker.unregisterOnDataChangeHandler(DataManagerIndividualSummaryController.controllerName);
                                });
                            });
                        }
                        DataManagerIndividualSummaryController.prototype.getAccountLineByCTN = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn);
                        };
                        DataManagerIndividualSummaryController.prototype.isAlertsRecipient = function (ctn) {
                            return (this.dataManagerService.getAlertsRecipientCTN() === ctn);
                        };
                        DataManagerIndividualSummaryController.prototype.getIndividualSummaryCTN = function () {
                            return this.dataManagerService.getIndividualSummaryCTN();
                        };
                        DataManagerIndividualSummaryController.prototype.getUsageDetailsCallInProgress = function () {
                            return this.dataManagerService.getUsageDetailsCallInProgress();
                        };
                        DataManagerIndividualSummaryController.controllerName = 'ute.data.manager.individual.summary.controller';
                        DataManagerIndividualSummaryController.$inject = ['$scope', 'ute.data.manager.service'];
                        return DataManagerIndividualSummaryController;
                    }());
                    summary_1.DataManagerIndividualSummaryController = DataManagerIndividualSummaryController;
                    angular.module('ute.data.manager.individual.summary').controller('ute.data.manager.individual.summary.controller', DataManagerIndividualSummaryController);
                })(summary = individual.summary || (individual.summary = {}));
            })(individual = manager.individual || (manager.individual = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var individual;
            (function (individual) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.individual.summary').directive('uteDataManagerIndividualSummary', uteDataManagerIndividualSummary);
                    uteDataManagerIndividualSummary.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerIndividualSummary(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerIndividualSummaryDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerIndividualSummaryDirective.controllerName,
                            controllerAs: 'dataManagerIndividualSummary',
                            link: function (scope, element, attrs, controller) {
                                scope.ctn = controller.ctn = dataManagerService.getIndividualSummaryCTN();
                            }
                        };
                    }
                })(summary = individual.summary || (individual.summary = {}));
            })(individual = manager.individual || (manager.individual = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var individual;
            (function (individual) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerIndividualSummaryDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerIndividualSummaryDirectiveController($scope, dataManagerService) {
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.accountLine = this.getAccountLineByCTN(this.scope.ctn);
                        }
                        DataManagerIndividualSummaryDirectiveController.prototype.getAccountLineByCTN = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn);
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.isAlertsRecipient = function (ctn) {
                            return (this.dataManagerService.getAlertsRecipientCTN() === ctn);
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.goToDashboard = function () {
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.goToManageAlerts = function () {
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.subState);
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getIndividualSummaryCTN = function () {
                            return this.dataManagerService.getIndividualSummaryCTN();
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getStartMonth = function () {
                            return this.dataManagerService.getBillCycle().startDate.month;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getStartDay = function () {
                            return this.dataManagerService.getBillCycle().startDate.day;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getEndMonth = function () {
                            return this.dataManagerService.getBillCycle().endDate.month;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getEndDay = function () {
                            return this.dataManagerService.getBillCycle().endDate.day;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getDaysUntilEnd = function () {
                            return this.dataManagerService.getBillCycle().daysUntilEndDate;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getNextStartDay = function () {
                            return this.dataManagerService.getBillCycle().nextStartDate.day;
                        };
                        DataManagerIndividualSummaryDirectiveController.prototype.getNextStartMonth = function () {
                            return this.dataManagerService.getBillCycle().nextStartDate.month;
                        };
                        DataManagerIndividualSummaryDirectiveController.$inject = ['$scope', 'ute.data.manager.service'];
                        return DataManagerIndividualSummaryDirectiveController;
                    }());
                    summary.DataManagerIndividualSummaryDirectiveController = DataManagerIndividualSummaryDirectiveController;
                    angular.module('ute.data.manager.individual.summary').controller('ute.data.manager.individual.summary.directive.controller', DataManagerIndividualSummaryDirectiveController);
                })(summary = individual.summary || (individual.summary = {}));
            })(individual = manager.individual || (manager.individual = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var info;
            (function (info) {
                var block;
                (function (block) {
                    'use strict';
                    var DataManagerInfoBlockController = (function () {
                        /* @ngInject */
                        function DataManagerInfoBlockController($scope, $state, dataManagerService) {
                            this.$scope = $scope;
                            this.$state = $state;
                            this.dataManagerService = dataManagerService;
                            this.model = this.dataManagerService.getModel();
                        }
                        DataManagerInfoBlockController.$inject = ['$scope', '$state', 'ute.data.manager.service'];
                        return DataManagerInfoBlockController;
                    }());
                    block.DataManagerInfoBlockController = DataManagerInfoBlockController;
                    angular.module('ute.data.manager.info.block').controller('ute.data.manager.info.block.controller', DataManagerInfoBlockController);
                })(block = info.block || (info.block = {}));
            })(info = manager.info || (manager.info = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var info;
            (function (info) {
                var block;
                (function (block) {
                    'use strict';
                    angular.module('ute.data.manager.info.block').directive('uteDataManagerInfoBlock', uteDataManagerInfoBlock);
                    uteDataManagerInfoBlock.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerInfoBlock(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'infoBlock': '=' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerInfoBlockDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerInfoBlockDirective.controllerName,
                            controllerAs: 'dataManagerInfoBlock',
                            link: function (scope, element, attrs, controller) {
                                controller.infoBlock = scope.infoBlock;
                            }
                        };
                    }
                })(block = info.block || (info.block = {}));
            })(info = manager.info || (manager.info = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var profile;
            (function (profile) {
                var alert;
                (function (alert) {
                    'use strict';
                    var DataManagerProfileAlertDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerProfileAlertDirectiveController($state, $scope, $rootScope, $modal, $filter, dataManagerService) {
                            this.$state = $state;
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$modal = $modal;
                            this.$filter = $filter;
                            this.dataManagerService = dataManagerService;
                            this.selectedIndex = 0;
                            this.confirmChange = false;
                            this.model = this.dataManagerService.getModel();
                            this.rootScope = $rootScope;
                            this.confirmChange = false;
                        }
                        DataManagerProfileAlertDirectiveController.prototype.initialize = function () {
                            var _this = this;
                            this.$scope.$watch(function () { return _this.getAlertsRecipientCTN(); }, function (newCTN) {
                                _this.selectedIndex = _this.dataManagerService.getAlertRecipientIndex(newCTN);
                            });
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getCurrent = function () {
                            var alertRecipientCTN = this.dataManagerService.getAlertsRecipientCTN();
                            var _this = this;
                            return parseInt(_this.dataManagerService.getAlertRecipientIndex(alertRecipientCTN), 10) || 0;
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getOptions = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerProfileAlertDirectiveController.prototype.changeAlert = function ($event) {
                            var _this = this;
                            if (parseInt(_this.selectedIndex, 10) === parseInt(_this.getCurrent(), 10)) {
                                this.confirmChange = false;
                            }
                            else {
                                this.confirmChange = true;
                            }
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getSetDataManagerCallInProgress = function () {
                            return this.dataManagerService.getSetDataManagerCallInProgress();
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getAlertsRecipientCTN = function () {
                            return this.dataManagerService.getAlertsRecipientCTN();
                        };
                        DataManagerProfileAlertDirectiveController.prototype.getDefaultDisplayCTN = function () {
                            return ((this.dataManagerService.getAlertsRecipientCTN() === null) ? this.$filter('translate')('ute.dataManager.profile.alert.selectOne') : this.dataManagerService.getAlertsRecipientCTN());
                        };
                        DataManagerProfileAlertDirectiveController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        DataManagerProfileAlertDirectiveController.prototype.changeSave = function ($event) {
                            var _this = this;
                            this.confirmChange = false;
                            this.dataManagerService.setDataManagerAPI(this.dataManagerService.getDataControlList()[this.selectedIndex].ctn)
                                .then(function (result) {
                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                    _this.dataManagerService.setAlertsRecipientCTN(_this.getOptions()[_this.selectedIndex].ctn);
                                    _this.$state.go('shareEverything.manage');
                                }
                                else {
                                    _this.errorModalPopup('ute.dataManager.profile.alert.errorHeading', 'ute.dataManager.profile.alert.errorSecondary');
                                }
                            })
                                .catch(function () {
                                _this.errorModalPopup('ute.dataManager.profile.alert.errorHeading', 'ute.dataManager.profile.alert.errorSecondary');
                            });
                        };
                        DataManagerProfileAlertDirectiveController.$inject = ['$state', '$scope', '$rootScope', '$modal', '$filter', 'ute.data.manager.service'];
                        return DataManagerProfileAlertDirectiveController;
                    }());
                    alert.DataManagerProfileAlertDirectiveController = DataManagerProfileAlertDirectiveController;
                    angular.module('ute.data.manager.profile.alert').controller('ute.data.manager.profile.alert.directive.controller', DataManagerProfileAlertDirectiveController);
                })(alert = profile.alert || (profile.alert = {}));
            })(profile = manager.profile || (manager.profile = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var profile;
            (function (profile) {
                var alert;
                (function (alert) {
                    'use strict';
                    angular.module('ute.data.manager.profile.alert').directive('uteDataManagerProfileAlertDirective', uteDataManagerProfileAlertDirective);
                    uteDataManagerProfileAlertDirective.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerProfileAlertDirective(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerProfileAlertDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerProfileAlertDirective.controllerName,
                            controllerAs: 'dataManagerProfileAlertDirective'
                        };
                    }
                })(alert = profile.alert || (profile.alert = {}));
            })(profile = manager.profile || (manager.profile = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var see;
            (function (see) {
                'use strict';
                /**
                 *
                 *
                 * @class DataManagerSeeDataService
                 * @implements {IDataManagerSeeDataService}
                 */
                var DataManagerSeeDataService = (function () {
                    function DataManagerSeeDataService($http, $q, dataManagerService, $translate, $window, securityService, localStorage, cacheableData, permissionsService, userService) {
                        var _this = this;
                        this.$http = $http;
                        this.$q = $q;
                        this.dataManagerService = dataManagerService;
                        this.$translate = $translate;
                        this.$window = $window;
                        this.securityService = securityService;
                        this.localStorage = localStorage;
                        this.cacheableData = cacheableData;
                        this.permissionsService = permissionsService;
                        this.userService = userService;
                        this.useMockData = false;
                        this.MAX_TAB = 9;
                        this.DISCOUNT_API = 'v1/see/discount';
                        this.EXISTING_PLAN_API = 'v1/ppc/priceplans/current';
                        this.NAC_SAVESTATE_API = 'v1/nac/saveState';
                        this.NAC_URL = '/web/totes/wireless/#/choose-phone?deeplink'; //TODO : change to prod
                        this._discountLoading = false;
                        this._discounts = null;
                        this._tabAccountLinks = [];
                        this._tempTabOrBadgeList = [];
                        this._planID = null;
                        this.planSuccess = function (response) {
                            var deferred = _this.$q.defer();
                            if (response.data) {
                                _this.setIsInfinitePlanInStorage(_.get(response, 'data.planTitle.en', ''));
                                _this.planID = response.data.socNumber;
                                if (_this.tempTabOrBadgeList.length === _this.MAX_TAB) {
                                    deferred.resolve(_this.tabAccountLinks);
                                    return;
                                }
                                else {
                                    _this.getDiscounts().then(function (result) {
                                        if (!_this.tempTabOrBadgeList) {
                                            return null;
                                        }
                                        /*var discountSeqNumber: number = this.tempTabOrBadgeList.length + 1;
                                        if (discountSeqNumber <= this.MAX_TAB) {
                                          this.createLink(discountSeqNumber);
                                        }
                            
                                        if (this.discounts && this.discounts.length && this.discounts[0].rateType === 'P' && discountSeqNumber + 1 <= this.MAX_TAB) {
                                          this.createLink(discountSeqNumber + 1);
                                        }*/
                                        _this.createAdditionalLink();
                                        deferred.resolve(_this.tabAccountLinks);
                                    }).catch(function (reason) {
                                        console.log('Failed: Discount Processing tabAccountLinks', reason);
                                        _this.createAdditionalLink();
                                        deferred.reject(response);
                                    });
                                }
                            }
                            else {
                                _this.createAdditionalLink();
                                deferred.reject(response);
                            }
                            return deferred.promise;
                        };
                        this.createAdditionalLink = function () {
                            var discountSeqNumber = _this.tempTabOrBadgeList.length + 1;
                            if (_this.discounts !== null && _this.discounts.length && _this.discounts[1] && _this.discounts[1].flatDiscount) {
                                for (var i = discountSeqNumber; i <= _this.MAX_TAB; i++) {
                                    _this.createLink(discountSeqNumber);
                                }
                                _this.discountLoading = false;
                                return;
                            }
                            if (discountSeqNumber <= _this.MAX_TAB) {
                                _this.createLink(discountSeqNumber);
                            }
                            /*if (this.discounts && this.discounts.length && this.discounts[0].rateType === 'P' && discountSeqNumber + 1 <= this.MAX_TAB) {
                              this.createLink(discountSeqNumber + 1);
                            }*/
                            _this.discountLoading = false;
                        };
                        this.createLink = function (discountSeqNumber) {
                            if (_.isEmpty(_.find(_this.tabAccountLinks, function (obj) {
                                return obj.basketSeqNo === discountSeqNumber;
                            }))) {
                                var displayName = discountSeqNumber === 8 ? 'Add an ' : 'Add a ';
                                _this.tabAccountLinks.push({
                                    displayName: _this.$translate.use() === 'en' ? displayName + _this.getOrdinalText(discountSeqNumber).toString() + ' line' : 'Ajouter une ' + _this.getOrdinalText(discountSeqNumber).toString() + ' ligne',
                                    displayNameAtr: _this.$translate.use() === 'en' ? displayName + _this.getOrdinalText(discountSeqNumber, 'aria-label') + ' line' : 'Ajouter une ' + _this.getOrdinalText(discountSeqNumber, 'aria-label') + ' ligne',
                                    discount: _this.getTabDiscount(discountSeqNumber.toString()),
                                    isLink: true,
                                    basketSeqNo: discountSeqNumber,
                                    colorCode: _this.dataManagerService.getConfig().basic.colorHexGuide[Number(discountSeqNumber) - 1],
                                    ctn: null,
                                    dataUsed: 0,
                                    dataAlertAt: 0,
                                    savedAlertValue: 0,
                                    groupStatus: 'IN_GROUP',
                                    hasData: false,
                                    useAlert: false,
                                    dataAccess: false,
                                    status: '',
                                    language: _this.$translate.use()
                                });
                            }
                            return;
                        };
                        this.planFail = function (error) {
                            var deferred = _this.$q.defer();
                            console.log('Existing Plan API failed', error.data.description);
                            //show error popup if required
                            _this.createAdditionalLink();
                            deferred.reject();
                            return deferred.promise;
                        };
                        this.discountSuccess = function (response) {
                            var deferred = _this.$q.defer();
                            if (response.data) {
                                _this.discounts = response.data.discounts;
                                deferred.resolve(_this.discounts);
                            }
                            else {
                                deferred.reject(response);
                            }
                            return deferred.promise;
                        };
                        this.discountFail = function (error) {
                            console.log('Discount API failed', error);
                            _this.$q.defer().reject();
                            return _this.$q.defer().promise;
                        };
                        this.setIsInfinitePlanInStorage = function (currentPlan) {
                            try {
                                var timestamp = +new Date();
                                var url = '/web/totes/cms/content/json/speedpass.json?v=' + timestamp;
                                var infiniteString_1 = 'Infinite';
                                var isInfinitePlan_1 = false;
                                _this.$http.get(url, {
                                    cache: false,
                                    withCredentials: false
                                }).then(function (res) {
                                    infiniteString_1 = _.get(res, 'data.speedpass.name', 'Infinite');
                                    if (currentPlan.toLowerCase().indexOf(infiniteString_1.toLowerCase()) !== -1) {
                                        isInfinitePlan_1 = true;
                                    }
                                    sessionStorage.setItem('isInfinitePlan', JSON.stringify(isInfinitePlan_1));
                                }).catch(function () {
                                    if (currentPlan.toLowerCase().indexOf(infiniteString_1.toLowerCase()) !== -1) {
                                        isInfinitePlan_1 = true;
                                    }
                                    sessionStorage.setItem('isInfinitePlan', JSON.stringify(isInfinitePlan_1));
                                });
                            }
                            catch (err) {
                                sessionStorage.setItem('isInfinitePlan', JSON.stringify(false));
                            }
                        };
                        /**
                         *
                         * @type {(seqNumber: string, price?: number)}
                         * @returns {IDataManagerSeeDiscountModel}
                         */
                        this.getTabDiscount = function (seqNumber, price) {
                            if (price === void 0) { price = 0; }
                            if (_this.discounts !== null) {
                                for (var i = 0; i < _this.discounts.length; i++) {
                                    var tempObj = _this.discounts[i];
                                    if (tempObj.basketSeqNo === seqNumber) {
                                        var discountObj = new see.DataManagerSeeDiscountModel(price);
                                        discountObj.basketSeqNo = tempObj.basketSeqNo;
                                        discountObj.effectiveDate = tempObj.effectiveDate;
                                        discountObj.expiryDate = tempObj.expiryDate;
                                        discountObj.rate = tempObj.rate;
                                        discountObj.rateType = tempObj.rateType;
                                        discountObj.term = tempObj.term;
                                        return discountObj;
                                    }
                                }
                                return null;
                            }
                            return null;
                        };
                    }
                    Object.defineProperty(DataManagerSeeDataService.prototype, "discountLoading", {
                        get: function () {
                            return this._discountLoading;
                        },
                        set: function (value) {
                            this._discountLoading = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataManagerSeeDataService.prototype, "discounts", {
                        get: function () {
                            return this._discounts;
                        },
                        set: function (value) {
                            this._discounts = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataManagerSeeDataService.prototype, "tabAccountLinks", {
                        get: function () {
                            return this._tabAccountLinks;
                        },
                        set: function (value) {
                            this._tabAccountLinks = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataManagerSeeDataService.prototype, "tempTabOrBadgeList", {
                        get: function () {
                            return this._tempTabOrBadgeList;
                        },
                        set: function (value) {
                            this._tempTabOrBadgeList = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    Object.defineProperty(DataManagerSeeDataService.prototype, "planID", {
                        get: function () {
                            return this._planID;
                        },
                        set: function (value) {
                            this._planID = value;
                        },
                        enumerable: true,
                        configurable: true
                    });
                    /**
                     *
                     *
                     * @private
                     * @param {number} pos
                     * @param flow
                     * @returns {*}
                     */
                    DataManagerSeeDataService.prototype.getOrdinalText = function (pos, flow) {
                        if (this.$translate.use() === 'fr') {
                            return flow === 'aria-label' ? pos + 'e' : pos + '<sup>e</sup>';
                        }
                        var ordinals = ['th', 'st', 'nd', 'rd'];
                        var v = pos % 100;
                        return flow === 'aria-label' ? (pos + (ordinals[(v - 20) % 10] || ordinals[v] || ordinals[0])) : pos + '<sup>' + (ordinals[(v - 20) % 10] || ordinals[v] || ordinals[0]) + '</sup>';
                    };
                    ;
                    /**
                     *
                     *
                     * @returns {ng.IPromise<any>}
                     */
                    DataManagerSeeDataService.prototype.getDiscounts = function () {
                        if (this.planID === null || (typeof this.planID === 'undefined')) {
                            return;
                        }
                        /*var subList = [{
                          ActivityCode: 'NAC',
                          BasketSeqNo: '1',
                          CurrentPricePlan: this.planID,
                          PayeeInd: 'M',
                          Number: this.tempTabOrBadgeList[0]?this.tempTabOrBadgeList[0].ctn:this.localStorage.getLocalStorageValue('firstCTN'),
                          isMain: true
                        }];*/
                        var subList = [];
                        for (var i = 0, existinglineLength = this.tempTabOrBadgeList.length; i < existinglineLength; i++) {
                            subList.push({
                                ActivityCode: 'NAC',
                                Number: this.tempTabOrBadgeList[i].ctn,
                                BasketSeqNo: (i + 1).toString(),
                                CurrentPricePlan: this.planID,
                                PayeeInd: (i === 0) ? 'M' : 'D',
                                isMain: (i === 0)
                            });
                        }
                        /*for (var i = 2, itrLength = this.tempTabOrBadgeList.length; i < itrLength + 1; i++) {
                          subList.push({
                            ActivityCode: 'NAC',
                            Number: this.tempTabOrBadgeList[i].ctn,
                            BasketSeqNo: i.toString(),
                            CurrentPricePlan: this.planID,
                            PayeeInd: 'D',
                            isMain: false
                          });
                        }*/
                        var postData = {
                            Mode: 'B',
                            AccountType: 'Consumer',
                            AccountSubType: 'Regular',
                            AccountNumber: this.localStorage.getLocalStorageValue('accountNumber'),
                            SubscriberList: subList
                        };
                        var requestUrl = this.securityService.getBackendUrl(this.DISCOUNT_API);
                        var call;
                        if (this.useMockData) {
                            requestUrl = 'ute-data-manager/assets/mockSeeDiscount.json';
                            call = this.$http.get(requestUrl);
                        }
                        else {
                            call = this.$http.post(requestUrl, postData);
                        }
                        return call
                            .then(this.discountSuccess)
                            .catch(this.discountFail);
                    };
                    DataManagerSeeDataService.prototype.goToAddLine = function () {
                        var _this = this;
                        var postData = {
                            key: 'NEW_MULTI_WRLS_INFO',
                            isDeeplink: true,
                            isIndividual: false,
                            clearSession: true,
                            nacSessionList: []
                        };
                        this.$http.post(this.securityService.getBackendUrl(this.NAC_SAVESTATE_API), postData).then(function () {
                            _this.$window.location.href = _this.NAC_URL; //this.dataManagerService.getConfig().basic.addDataToLineUrl;
                        }, function () {
                            _this.$window.location.href = _this.NAC_URL; //failure block
                        });
                    };
                    /**
                     *
                     *
                     * @param {Array<IDataManagerAccountLine>} controlList
                     * @returns {ng.IPromise<any>}
                     */
                    DataManagerSeeDataService.prototype.addTabLink = function (controlList) {
                        this.tempTabOrBadgeList = controlList;
                        //      var theBan = this.dataManagerService.getAccountNumber();
                        var theBan = this.localStorage.getLocalStorageValue('accountNumber');
                        var theMainCTN = this.tempTabOrBadgeList[0].ctn;
                        var postData = {
                            ban: theBan,
                            ctn: theMainCTN,
                            language: this.$translate.use(),
                            consolidatedInd: 'NO'
                        };
                        var requestUrl = this.securityService.getBackendUrl(this.EXISTING_PLAN_API);
                        var call;
                        if (this.useMockData) {
                            requestUrl = 'ute-data-manager/assets/mockSeePlan.json';
                            call = this.$http.get(requestUrl);
                        }
                        else {
                            this.discountLoading = true;
                            this.tabAccountLinks = [];
                            call = this.cacheableData({
                                url: this.EXISTING_PLAN_API,
                                postData: postData
                            }).getData();
                        }
                        return call
                            .then(this.planSuccess)
                            .catch(this.planFail);
                    };
                    DataManagerSeeDataService.prototype.getSeeBrtShowState = function () {
                        //return this.$q.when(true);
                        if (this.userService.isCare() || this.userService.isDealer()) {
                            return this.$q.when(false);
                        }
                        else {
                            return this.$q.when(true);
                        }
                    };
                    DataManagerSeeDataService.$inject = [
                        '$http',
                        '$q',
                        'ute.data.manager.service',
                        '$translate',
                        '$window',
                        'ute.common.security.service',
                        'localStorage',
                        'ute.common.core.caching.CacheableDataFactory',
                        'ute.common.permissions.service',
                        'ute.common.user.service'
                    ];
                    return DataManagerSeeDataService;
                }());
                angular.module('ute.data.manager.see').service('ute.data.manager.see.service', DataManagerSeeDataService);
            })(see = manager.see || (manager.see = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var see;
            (function (see) {
                'use strict';
            })(see = manager.see || (manager.see = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var see;
            (function (see) {
                'use strict';
                var DataManagerSeeDiscountModel = (function () {
                    function DataManagerSeeDiscountModel(price) {
                        if (price === void 0) { price = 0; }
                        this.basketSeqNo = '';
                        this.effectiveDate = '';
                        this.expiryDate = '';
                        this.rateType = '';
                        this.rate = '';
                        this.term = '';
                        this.amount = 0;
                        this.flatDiscount = false;
                        if (price && price > 0) {
                            this.amount = price;
                        }
                    }
                    DataManagerSeeDiscountModel.prototype.getCalculatedAmount = function () {
                        var discountAmount = 0;
                        if (this.rateType === 'D') {
                            discountAmount = this.amount - Number(this.rate);
                        }
                        if (this.rateType === 'P') {
                            discountAmount = this.amount - (this.amount * (Number(this.rate) / 100));
                        }
                        return discountAmount >= 0 ? discountAmount : 0;
                    };
                    DataManagerSeeDiscountModel.prototype.getDiscountAmount = function () {
                        var discountAmount = 0;
                        if (this.rateType === 'D') {
                            discountAmount = Number(this.rate);
                        }
                        if (this.rateType === 'P') {
                            discountAmount = Number(this.rate) / 100; // return in percentage;
                        }
                        return discountAmount >= 0 ? discountAmount : 0;
                    };
                    return DataManagerSeeDiscountModel;
                }());
                see.DataManagerSeeDiscountModel = DataManagerSeeDiscountModel;
            })(see = manager.see || (manager.see = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
                var DataLayerPredefinedSection = ute.dtm.service.DataLayerPredefinedSection;
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.GENERIC_ERROR = 15600;
                    return BackEndErrorCode;
                }());
                var StatusCode = (function () {
                    function StatusCode() {
                    }
                    StatusCode.ACTIVE = 'active';
                    StatusCode.SUSPENDED = 'suspended';
                    StatusCode.CANCELLED = 'cancelled';
                    return StatusCode;
                }());
                var GroupStatusCode = (function () {
                    function GroupStatusCode() {
                    }
                    GroupStatusCode.ACTIVE = 'IN_GROUP';
                    GroupStatusCode.JOINED = 'JOINED_GROUP';
                    GroupStatusCode.LEFT = 'LEFT_GROUP';
                    return GroupStatusCode;
                }());
                var DataManagerProvider = (function () {
                    /* @ngInject */
                    function DataManagerProvider(accountOverviewProvider, accountOverviewSummaryProvider, dataLayerServiceProvider) {
                        var _this = this;
                        this.accountOverviewProvider = accountOverviewProvider;
                        this.accountOverviewSummaryProvider = accountOverviewSummaryProvider;
                        this.dataLayerServiceProvider = dataLayerServiceProvider;
                        this.errorCodesMap = {};
                        this.saveAlertCallInProgress = false;
                        this.isSetBlockAPICallInProgress = false;
                        this.isSetDataManagerAPICallInProgress = false;
                        this.isPurchaseDataProductAPICallInProgress = false;
                        this.isGetDataProductsCallInProgress = false;
                        this.isVideoQualityAPICallInProgress = false;
                        this.isWcocConsentCallInProgress = false;
                        this.useMockData = false;
                        this.isFirstCycleAfterPpc = false;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                brand: 'ROGERS',
                                analyticsId: 'brandanalysticsid',
                                serviceType: 'DM',
                                medium: 'WEB',
                                channelId: 'UTERogersOnline',
                                purchaseDataProductLimit: 3,
                                errorLocation: 'shareEverythingError',
                                dataManagerAccountOverviewAPI: 'v1/accountoverview',
                                dataManagerSummaryAPI: 'v1/accountoverview/summary',
                                dataManagerGetDataProductsAPI: 'v1/data-manager/get-data-products',
                                dataManagerGetUsageDetailsAPI: 'v1/data-manager/get-usage-details',
                                dataManagerPurchaseDataAPI: 'v1/data-manager/purchase-data-product',
                                dataManagerSetAlertAPI: 'v1/data-manager/set-alert',
                                dataManagerSetBlockAPI: 'v1/data-manager/set-block',
                                dataManagerSetDataManagerAPI: 'v1/data-manager/set-data-manager',
                                dataManagerRootState: 'shareEverything',
                                dataManagerConsoleState: 'dataManagerConsole',
                                mainControllerName: 'ute.data.manager.main.controller',
                                mainTemplateUrl: 'module/dataManager/dataManagerMain.view.html',
                                addDataToLineUrl: 'http://www.rogers.com/web/totes/wireless-plan-change/#/choose-plan',
                                dashboardState: 'accountOverview',
                                wirelessState: 'wireless',
                                dataConversion: 1024,
                                dataConversionRoundValues: 1000,
                                colorHexGuide: ['#008fb6', '#E4BC40', '#662d91', '#7aaa39', '#ac0067', '#2926ab', '#cd5e40', '#2b464c', '#bbb62a', '#317d59'],
                                invalidSEAccountRedirectState: 'accountOverview',
                                invalidSEAccountRedirectStateWireless: 'wireless',
                                dataManagerSetVideoQualityAPI: 'v1/data-manager/set-videothrottle',
                                dataManagerGetConfirmationModalPreferenceAPI: 'v1/getUserShowScreenPref',
                                dataManagerSetConfirmationModalPreferenceAPI: 'v1/setUserShowScreenPref',
                                generateWcocToken: 'v1/wcoc/fdm/generateToken',
                                setWcocConsent: '/web/totes/web/wcoc/api/wcoc/wcocConsent',
                                noAccountLinkedState: 'guestOverview'
                            },
                            advanced: {
                                dataManagerTabsContent: {
                                    controllerName: 'ute.data.manager.tabs.content.controller',
                                    templateUrl: 'module/dataManager/dataManagerTabsContent/dataManagerTabsContent.partial.html'
                                },
                                enterDataManager: {
                                    subState: 'dashboard',
                                    subStateNoEncryption: 'noEncryption',
                                    controllerName: 'ute.data.manager.main.controller',
                                    templateUrl: 'module/dataManager/dataManagerDashboard/dataManagerEnterMain.view.html'
                                },
                                dataManagerDashboard: {
                                    controllerName: 'ute.data.manager.dashboard.controller',
                                    templateUrl: 'module/dataManager/dataManagerDashboard/dataManagerDashboard.partial.html'
                                },
                                dataManagerAccountsSummary: {
                                    subState: 'accountsSummary',
                                    controllerName: 'ute.data.manager.accounts.summary.controller',
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummary.html',
                                    chartHeightOffset: 160,
                                    headerOffset: 100,
                                    footerOffset: 100
                                },
                                dataManagerIndividualSummary: {
                                    subState: 'individualSummary',
                                    controllerName: 'ute.data.manager.individual.summary.controller',
                                    templateUrl: 'module/dataManager/dataManagerIndividualSummary/dataManagerIndividualSummary.html'
                                },
                                dataManagerDataControlDirective: {
                                    controllerName: 'ute.data.manager.data.control.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerDataControlList/dataManagerDataControl/dataManagerDataControl.partial.html',
                                    reconstruct: ['ute-dataManager-dashboard-controlListContainer']
                                },
                                dataManagerDataControlListDirective: {
                                    controllerName: 'ute.data.manager.data.control.list.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerDataControlList/dataManagerDataControlList.partial.html'
                                },
                                dataManagerProfileAlertDirective: {
                                    controllerName: 'ute.data.manager.profile.alert.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerProfileAlert/dataManagerProfileAlert.partial.html'
                                },
                                dataManagerTabsDirective: {
                                    controllerName: 'ute.data.manager.tabs.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerTabs/dataManagerTabs.partial.html',
                                    tabsWidth: 152
                                },
                                dataManagerSharedUsageBarDirective: {
                                    controllerName: 'ute.data.manager.shared.usage.bar.controller',
                                    templateUrl: 'module/dataManager/dataManagerSharedUsageBar/dataManagerSharedUsageBar.partial.html'
                                },
                                dataManagerBadgeListDirective: {
                                    controllerName: 'ute.data.manager.badge.list.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerBadgeList/dataManagerBadgeList.partial.html'
                                },
                                dataManagerUsageDialDirective: {
                                    controllerName: 'ute.data.manager.usage.dial.controller',
                                    templateUrl: 'module/dataManager/dataManagerUsageDial/dataManagerUsageDial.partial.html',
                                    templateUrlSharedDataPartial: 'module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedData.partial.html',
                                    templateUrlSharedTalkPartial: 'module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedTalk.partial.html',
                                    templateUrlSharedTextPartial: 'module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedText.partial.html'
                                },
                                dataManagerSharedUsageBarSegmentDirective: {
                                    controllerName: 'ute.data.manager.shared.usage.bar.segment.controller',
                                    templateUrl: 'module/dataManager/dataManagerSharedUsageBar/dataManagerSharedUsageBarSegment.partial.html'
                                },
                                dataManagerAlertsRecipientModal: {
                                    controllerName: 'ute.data.manager.alerts.recipient.modal.controller',
                                    windowTemplateUrl: 'module/dataManager/dataManager.windowTemplate.html',
                                    templateUrl: 'module/dataManager/dataManagerModals/dataManagerAlertsRecipientModal/dataManagerAlertsRecipientModal.partial.html',
                                    reconstruct: ['ute-dataManager-dashboard-controlListContainer']
                                },
                                dataManagerDataAccessModal: {
                                    controllerName: 'ute.data.manager.data.access.modal.controller',
                                    windowTemplateUrl: 'module/dataManager/dataManager.windowTemplate.html',
                                    templateUrl: 'module/dataManager/dataManagerDataAccess/dataManagerDataAccessModal/dataManagerDataOnOffModal.partial.html'
                                },
                                dataManagerVideoThrottleModal: {
                                    controllerName: 'ute.data.manager.video.throttle.modal.controller',
                                    windowTemplateUrl: 'module/dataManager/dataManagerVideoThrottle.windowTemplate.html',
                                    templateUrl: 'module/dataManager/dataManagerModals/dataManagerVideoThrottleModal/dataManagerVideoThrottleModal.partial.html'
                                },
                                dataManagerDataAlertsDirective: {
                                    templateUrl: 'module/dataManager/dataManagerDataAlerts/dataManagerDataAlerts.view.html',
                                    controllerName: 'ute.data.manager.data.alerts.controller'
                                },
                                dataManagerDataControlTagDirective: {
                                    templateUrl: 'module/dataManager/dataManagerDataControlTagList/dataManagerDataControlTag/dataManagerDataControlTag.view.html',
                                    controllerName: 'ute.data.manager.data.control.tag.controller'
                                },
                                dataManagerDataControlTagListDirective: {
                                    templateUrl: 'module/dataManager/dataManagerDataControlTagList/dataManagerDataControlTagList.view.html',
                                    controllerName: 'ute.data.manager.data.control.tag.list.controller'
                                },
                                dataManagerIndividualSummaryDirective: {
                                    templateUrl: 'module/dataManager/dataManagerIndividualSummary/dataManagerIndividualSummary.partial.html',
                                    controllerName: 'ute.data.manager.individual.summary.directive.controller'
                                },
                                dataManagerAccountsSummaryFooterDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryFooter/dataManagerAccountsSummaryFooter.partial.html',
                                    controllerName: 'ute.data.manager.summary.footer.controller'
                                },
                                dataManagerAccountsSummaryHeaderDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryHeader/dataManagerAccountsSummaryHeader.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.header.directive.controller'
                                },
                                dataManagerAccountsSummaryIndividualHeaderDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryIndividualHeader/dataManagerAccountsSummaryIndividualHeader.partial.html',
                                    controllerName: 'ute.data.manager.summary.header.controller'
                                },
                                dataManagerAccountsSummaryDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDirective.view.html',
                                    controllerName: 'ute.data.manager.accounts.summary.directive.controller'
                                },
                                dataManagerAccountsSummaryDataMeterDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataMeter/dataManagerAccountsSummaryDataMeter.partial.html',
                                    controllerName: 'ute.data.manager.summary.data.meter.controller'
                                },
                                dataManagerAccountsSummaryDataMeterTickDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataMeter/dataManagerAccountsSummaryDataMeterTick.partial.html',
                                    controllerName: 'ute.data.manager.summary.data.meter.tick.controller'
                                },
                                dataManagerAccountsSummaryBarContainerDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryBarContainer.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.bar.container.controller'
                                },
                                dataManagerAccountsSummaryDataAlertBarDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAlertBar/dataManagerAccountsSummaryDataAlertBar.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.data.alert.bar.directive.controller'
                                },
                                dataManagerAccountsSummaryOverageBarDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryOverageBar/dataManagerAccountsSummaryOverageBar.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.overage.bar.directive.controller'
                                },
                                dataManagerAccountsSummaryOverageCoverageDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryOverageCoverage/dataManagerAccountsSummaryOverageCoverage.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.overage.coverage.directive.controller'
                                },
                                dataManagerAccountsSummaryDataAddedBarDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAddedBar/dataManagerAccountsSummaryDataAddedBar.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.data.added.bar.directive.controller'
                                },
                                dataManagerAccountsSummarySwipeInstructionsDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummarySwipeInstructions/dataManagerAccountsSummarySwipe.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.swipe.instructions.directive.controller'
                                },
                                dataManagerDataAccessDirective: {
                                    controllerName: 'ute.data.manager.data.access.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerDataAccess/dataManagerDataAccess.partial.html',
                                    reconstruct: ['ute-dataManager-dashboard-controlListContainer']
                                },
                                dataManagerVideoThrottleDirective: {
                                    controllerName: 'ute.data.manager.video.throttle.directive.controller',
                                    templateUrl: 'module/dataManager/dataManagerVideoThrottleToggleSwitch/dataManagerVideoThrottleToggleSwitch.partial.html',
                                    reconstruct: ['ute-dataManager-dashboard-controlListContainer']
                                },
                                dataManagerAccountsSummaryDataAlertAtDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAlertAt/dataManagerAccountsSummaryDataAlertAt.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.data.alert.at.directive.controller'
                                },
                                dataManagerIncreasePlanDirective: {
                                    templateUrl: 'module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlan.partial.html',
                                    controllerName: 'ute.data.manager.increase.plan.directive.controller',
                                    reconstruct: ['ute-dataManager-dashboard-sharedUsageBar', 'ute-dataManager-dashboard-usageDialContainer']
                                },
                                dataManagerIncreasePlanDirectiveModal: {
                                    windowTemplateUrl: 'module/dataManager/dataManager.windowTemplate.html',
                                    templateUrl: 'module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlanModal/dataManagerIncreasePlanModal.partial.html',
                                    controllerName: 'ute.data.manager.increase.plan.modal.controller'
                                },
                                dataManagerIncreasePlanDirectivePopUp: {
                                    templateUrl: 'module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlan.partial.popup.html',
                                    controllerName: 'ute.data.manager.increase.plan.directive.controller'
                                },
                                dataManagerUpgradePlanDirective: {
                                    templateUrl: 'module/dataManager/dataManagerUpgradePlan/dataManagerUpgradePlan.partial.html',
                                    controllerName: 'ute.data.manager.upgrade.plan.directive.controller',
                                    modals: {
                                        wirelessRemovePlan: {
                                            controllerName: 'ute.data.manager.upgrade.plan.wireless.remove.plan.modal.controller',
                                            templateUrl: 'module/dataManager/dataManagerUpgradePlan/modals/wirelessRemovePlanModal.html'
                                        },
                                        deepLink: {
                                            controllerName: 'ute.data.manager.upgrade.plan.deeplink.modal.controller',
                                            templateUrl: 'module/dataManager/dataManagerUpgradePlan/modals/deepLinkModal.html'
                                        },
                                        captureDealerCode: {
                                            controllerName: 'ute.data.manager.upgrade.plan.capture.dealer.code.modal.controller',
                                            templateUrl: 'module/dataManager/dataManagerUpgradePlan/modals/captureDealerCodeModal.html'
                                        },
                                        proceedWithoutDealerCode: {
                                            controllerName: 'ute.data.manager.upgrade.plan.proceed.without.dealer.code.modal.controller',
                                            templateUrl: 'module/dataManager/dataManagerUpgradePlan/modals/proceedWithoutDealerCodeModal.html'
                                        }
                                    }
                                },
                                dataManagerAccountsSummaryNoAlertsSetDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryNoDataAlertsSet/dataManagerAccountsSummaryNoDataAlertsSet.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.no.data.alerts.set.directive.controller'
                                },
                                dataManagerAccountsSummaryDataAccessOffDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAccessOff/dataManagerAccountsSummaryDataAccessOff.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.data.access.off.directive.controller'
                                },
                                dataManagerAccountsSummaryNoDataPlanDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryNoDataPlan/dataManagerAccountsSummaryNoDataPlan.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.data.access.off.directive.controller'
                                },
                                dataManagerInfoBlockDirective: {
                                    templateUrl: 'module/dataManager/dataManagerInfoBlock/dataManagerInfoBlock.view.html',
                                    controllerName: 'ute.data.manager.info.block.controller'
                                },
                                dataManagerErrorPage: {
                                    subState: 'shareEverythingError',
                                    templateUrl: 'module/dataManager/dataManagerErrorPage/dataManagerErrorPage.view.html',
                                    controllerName: 'ute.data.manager.error.page.controller'
                                },
                                dataManagerModals: {
                                    genericModal: {
                                        templateUrl: 'module/dataManager/dataManagerModals/dataManagerGenericModal/dataManagerGenericModal.partial.html',
                                        templateUrlNoIcon: 'module/dataManager/dataManagerModals/dataManagerGenericModal/dataManagerGenericModalNoIcon.partial.html',
                                        controllerName: 'ute.data.manager.modals.generic.modal.controller'
                                    },
                                    alertsOverDataLimit: {
                                        templateUrl: 'module/dataManager/dataManagerModals/dataManagerModalAlertsOverDataLimit/dataManagerModalAlertsOverDataLimit.partial.html',
                                        controllerName: 'ute.data.manager.modals.alerts.over.data.limit.controller'
                                    },
                                    windowTemplateUrl: 'module/dataManager/dataManager.windowTemplate.html'
                                },
                                dataManagerDiscoveryIntegration: {
                                    brand: 'ROGERS',
                                    segment: 'CONSUMER',
                                    accountType: 'WIRELESS',
                                    productType: 'WL_POSTPAID',
                                    pageFilter: 'SHARE_EVERYTHING'
                                },
                                dataManagerGenericModal: {
                                    templateUrl: ''
                                },
                                serverErrorState: '',
                                dataErrorState: '',
                                dataPlanIncrementFactors: [
                                    {
                                        dataLimitMin: 0,
                                        dataLimitMax: 2048,
                                        incrementStep: 10
                                    }, {
                                        dataLimitMin: 2049,
                                        dataLimitMax: 5120,
                                        incrementStep: 20
                                    }, {
                                        dataLimitMin: 5121,
                                        dataLimitMax: 15360,
                                        incrementStep: 50
                                    }, {
                                        dataLimitMin: 15361,
                                        dataLimitMax: 1024000,
                                        incrementStep: 100
                                    }
                                ],
                                dataManagerDataVideoThrottleWrapperDirective: {
                                    templateUrl: 'module/dataManager/dataManagerDataAndVideoThrottleWrapper/dataManagerDataAndVideoThrottleWrapper.partial.html',
                                    controllerName: 'ute.data.manager.data.video.throttle.wrapper.directive.controller'
                                },
                                dataManagerVideoThrottleControlListDirective: {
                                    templateUrl: 'module/dataManager/dataManagerVideoThrottleControlList/dataManagerVideoThrottleControlList.partial.html',
                                    controllerName: 'ute.data.manager.video.throttle.control.list.directive.controller'
                                },
                                dataManagerVideoThrottleControlDirective: {
                                    templateUrl: 'module/dataManager/dataManagerVideoThrottleControlList/dataManagerVideoThrottleControl/dataManagerVideoThrottleControl.partial.html',
                                    controllerName: 'ute.data.manager.video.throttle.control.directive.controller'
                                },
                                dataManagerAccountsSummaryTabsDirective: {
                                    templateUrl: 'module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryTabs/dataManagerAccountsSummaryTabs.partial.html',
                                    controllerName: 'ute.data.manager.accounts.summary.tabs.directive.controller'
                                },
                                dataManagerVideoThrottleControlTagListDirective: {
                                    templateUrl: 'module/dataManager/dataManagerVideoThrottleControlTagList/dataManagerVideoThrottleControlTagList.view.html',
                                    controllerName: 'ute.data.manager.video.throttle.control.tag.list.controller'
                                },
                                dataManagerVideoThrottleControlTagDirective: {
                                    templateUrl: 'module/dataManager/dataManagerVideoThrottleControlTagList/dataManagerVideoThrottleControlTag/dataManagerVideoThrottleControlTag.view.html',
                                    controllerName: 'ute.data.manager.video.throttle.control.tag.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $state, $http, $q, $stateParams, $rootScope, $window, $timeout, $translate, $filter) {
                            _this.encryptionService = $injector.get('ute.common.encryption.service');
                            _this.userService = $injector.get('ute.common.user.service');
                            _this.dataLayerServiceProvider = $injector.get('ute.dtm.dataLayer.service');
                            _this.$injector = $injector;
                            _this.$state = $state;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.browserService = $injector.get('ute.common.core.browser.service');
                            _this.$rootScope = $rootScope;
                            _this.$stateParams = $stateParams;
                            _this.$window = $window;
                            _this.$timeout = $timeout;
                            _this.$translate = $translate;
                            _this.$filter = $filter;
                            _this.permissionsService = $injector.get('ute.common.permissions.service');
                            _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.accountOverviewSummaryFactory = $injector.get('ute.rogers.account.overview.summary.factory');
                            _this.dataManagerServerGetUsageDetailsFactory = $injector.get('ute.data.manager.service.factory');
                            _this.accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                            _this.uteDataManagerAnalyticsConfigService = $injector.get('ute-data-manager-analytics-config-service');
                            return {
                                getConfig: _this.getConfig,
                                goToEntryState: _this.goToEntryState,
                                goToWirelessState: _this.goToWirelessState,
                                getEntryState: _this.getEntryState,
                                getWirelessState: _this.getWirelessState,
                                getEntryStateNoEncryption: _this.getEntryStateNoEncryption,
                                getAccountsSummaryState: _this.getAccountsSummaryState,
                                getIndividualSummaryState: _this.getIndividualSummaryState,
                                getControlLineCTN: _this.getControlLineCTN,
                                getAccountNumber: _this.getAccountNumber,
                                getAccountStatus: _this.getAccountStatus,
                                isTabDisabled: _this.isTabDisabled,
                                transformPurchaseProduct: _this.transformPurchaseProduct,
                                getAlertedDataTotal: _this.getAlertedDataTotal,
                                setDataLineAlertAt: _this.setDataLineAlertAt,
                                getDataLineAlertAt: _this.getDataLineAlertAt,
                                setSelectedBadgeCTN: _this.setSelectedBadgeCTN,
                                getSelectedBadgeCTN: _this.getSelectedBadgeCTN,
                                getErrorPageState: _this.getErrorPageState,
                                getDataAlertsOpen: _this.getDataAlertsOpen,
                                getColorCodeCTN: _this.getColorCodeCTN,
                                getColorCodeClass: _this.getColorCodeClass,
                                reCompile: _this.reCompile,
                                setUsageDetailsCallInProgress: _this.setUsageDetailsCallInProgress,
                                getUsageDetailsCallInProgress: _this.getUsageDetailsCallInProgress,
                                getSavedAlertValue: _this.getSavedAlertValue,
                                getSavedAlertValueCTN: _this.getSavedAlertValueCTN,
                                setSavedAlertValue: _this.setSavedAlertValue,
                                summaryBarsFilter: _this.summaryBarsFilter,
                                summaryBarsFilterSecondary: _this.summaryBarsFilterSecondary,
                                getFilteredList: _this.getFilteredList,
                                getBadgeSubStatusByCTN: _this.getBadgeSubStatusByCTN,
                                getSecondaryFilteredList: _this.getSecondaryFilteredList,
                                getAccountsSummaryChartData: _this.getAccountsSummaryChartData,
                                getSavedAlertedDataTotal: _this.getSavedAlertedDataTotal,
                                setIndividualSummaryCTN: _this.setIndividualSummaryCTN,
                                getIndividualSummaryCTN: _this.getIndividualSummaryCTN,
                                setWirelessCTN: _this.setWirelessCTN,
                                getWirelessCTN: _this.getWirelessCTN,
                                setStateToErrorPage: _this.setStateToErrorPage,
                                toggleDataAlerts: _this.toggleDataAlerts,
                                getDataControlListWithData: _this.getDataControlListWithData,
                                getAlertsRecipientDisplayName: _this.getAlertsRecipientDisplayName,
                                getDisplayNameCTN: _this.getDisplayNameCTN,
                                getTotalDataPurchasedAmount: _this.getTotalDataPurchasedAmount,
                                setAlertsRecipientCTN: _this.setAlertsRecipientCTN,
                                getAccountLineByCTN: _this.getAccountLineByCTN,
                                increaseData: _this.increaseData,
                                getOverage: _this.getOverage,
                                getOverageForDTU: _this.getOverageForDTU,
                                getDataProductsCallInProgress: _this.getDataProductsCallInProgress,
                                setAddedExtraData: _this.setAddedExtraData,
                                getAddedExtraData: _this.getAddedExtraData,
                                increaseAddedExtra: _this.increaseAddedExtra,
                                getIndexByCTN: _this.getIndexByCTN,
                                getTotalUsedDataBucket: _this.getTotalUsedDataBucket,
                                getTotalUsedData: _this.getTotalUsedData,
                                resetBadgeList: _this.resetBadgeList,
                                getAlertRecipientIndex: _this.getAlertRecipientIndex,
                                getRemainingTotalData: _this.getRemainingTotalData,
                                getPrevIndividualCTNIndex: _this.getPrevIndividualCTNIndex,
                                getNextIndividualCTNIndex: _this.getNextIndividualCTNIndex,
                                setSummaryMode: _this.setSummaryMode,
                                getSummaryMode: _this.getSummaryMode,
                                isBucketSizeUnavailableUntilNextBillCycle: _this.isBucketSizeUnavailableUntilNextBillCycle,
                                isProrationError: _this.isProrationError,
                                hasDataCTN: _this.hasDataCTN,
                                getBillCycle: _this.getBillCycle,
                                setDataAccess: _this.setDataAccess,
                                getDataAccess: _this.getDataAccess,
                                setDataAccessCTN: _this.setDataAccessCTN,
                                getDataAccessCTN: _this.getDataAccessCTN,
                                setIndividualCTNView: _this.setIndividualCTNView,
                                getIndividualCTNView: _this.getIndividualCTNView,
                                getControlLineByIndex: _this.getControlLineByIndex,
                                getInfoBlock: _this.getInfoBlock,
                                setDataUseAlert: _this.setDataUseAlert,
                                resetLoadComplete: _this.resetLoadComplete,
                                setBRT: _this.setBRT,
                                getBRT: _this.getBRT,
                                getAlertsRecipientCTN: _this.getAlertsRecipientCTN,
                                getPrimaryCTN: _this.getPrimaryCTN,
                                getIncreaseDataOptions: _this.getIncreaseDataOptions,
                                getSaveAlertCallInProgress: _this.getSaveAlertCallInProgress,
                                getSetBlockCallInProgress: _this.getSetBlockCallInProgress,
                                getSetDataManagerCallInProgress: _this.getSetDataManagerCallInProgress,
                                getPurchaseDataProductCallInProgress: _this.getPurchaseDataProductCallInProgress,
                                setPurchaseDataProductCallInProgress: _this.setPurchaseDataProductCallInProgress,
                                getUser: _this.userService.getUser,
                                getSummaryChartHeight: _this.getSummaryChartHeight,
                                getChartDataTicks: _this.getChartDataTicks,
                                getDisplayChartDataTicks: _this.getDisplayChartDataTicks,
                                getCTNByIndex: _this.getCTNByIndex,
                                goToSubModule: _this.goToSubModule,
                                getModel: _this.getModel,
                                setModel: _this.setModel,
                                setAccountNumber: _this.setAccountNumber,
                                getDataControlList: _this.getDataControlList,
                                clearDataControlList: _this.clearDataControlList,
                                getBadgeList: _this.getBadgeList,
                                restoreDefault: _this.restoreDefault,
                                loadbadgeData: _this.loadbadgeData,
                                getHighestDataPoint: _this.getHighestDataPoint,
                                getUsageReportingDelay: _this.getUsageReportingDelay,
                                getTotalDataPurchased: _this.getTotalDataPurchased,
                                accountOverviewAPI: _this.accountOverviewAPI,
                                summaryMockAPI: _this.summaryMockAPI,
                                isMockDataEnabled: _this.isMockDataEnabled,
                                usageDetailsAPI: _this.usageDetailsAPI,
                                setAlertMoved: _this.setAlertMoved,
                                getWirelessSummary: _this.getWirelessSummary,
                                accountOverviewSummaryFactory: _this.accountOverviewSummaryFactory,
                                dataManagerServerGetUsageDetailsFactory: _this.dataManagerServerGetUsageDetailsFactory,
                                getUsageDetailsWorker: _this.getUsageDetailsWorker,
                                getDataProductsAPI: _this.getDataProductsAPI,
                                getStatusCode: _this.getStatusCode,
                                getGroupStatusCode: _this.getGroupStatusCode,
                                getSecondTickValue: _this.getSecondTickValue,
                                isAllowedToPurchaseData: _this.isAllowedToPurchaseData,
                                setDataAlertAPI: _this.setDataAlertAPI,
                                setBlockAPI: _this.setBlockAPI,
                                setDataManagerAPI: _this.setDataManagerAPI,
                                purchaseDataProductAPI: _this.purchaseDataProductAPI,
                                getSummaryWorker: _this.getSummaryWorker,
                                getFactoryWorker: _this.getFactoryWorker,
                                getDataLimit: _this.getDataLimit,
                                getTotalDataLimit: _this.getTotalDataLimit,
                                getPurchaseDataIncreases: _this.getPurchaseDataIncreases,
                                addToPurchaseDataIncreases: _this.addToPurchaseDataIncreases,
                                getAlertOverDataLimit: _this.getAlertOverDataLimit,
                                setAlertOverDataLimit: _this.setAlertOverDataLimit,
                                showSwipeInstructions: _this.showSwipeInstructions,
                                getSwipeInstructionsShown: _this.getSwipeInstructionsShown,
                                setSwipeInstructionsShown: _this.setSwipeInstructionsShown,
                                countdownSwipeInstructions: _this.countdownSwipeInstructions,
                                setShowSwipeInstructions: _this.setShowSwipeInstructions,
                                transformAccountOverview: _this.transformAccountOverview,
                                transformSummary: _this.transformSummary,
                                transformUsageDetails: _this.transformUsageDetails,
                                transformDataProducts: _this.transformDataProducts,
                                transformDataProduct: _this.transformDataProduct,
                                getState: _this.getState,
                                expandDataSection: _this.expandDataSection,
                                getIndividualMode: _this.getIndividualMode,
                                setIndividualMode: _this.setIndividualMode,
                                getActiveTabIndex: _this.getActiveTabIndex,
                                setActiveTabIndex: _this.setActiveTabIndex,
                                getSecondEntryState: _this.getSecondEntryState,
                                isCare: _this.isCare,
                                getSliderStep: _this.getSliderStep,
                                getIsVideoQualityAPICallInProgress: _this.getIsVideoQualityAPICallInProgress,
                                setIsVideoThrottlePermitted: _this.setIsVideoThrottlePermitted,
                                getIsVideoThrottlePermitted: _this.getIsVideoThrottlePermitted,
                                setDataManagerActiveTabIndex: _this.setDataManagerActiveTabIndex,
                                getDataManagerActiveTabIndex: _this.getDataManagerActiveTabIndex,
                                setVideoQualityReducedCTN: _this.setVideoQualityReducedCTN,
                                getVideoQualityReducedCTN: _this.getVideoQualityReducedCTN,
                                setVideoQualityAPI: _this.setVideoQualityAPI,
                                fetchConfirmationModalPreference: _this.fetchConfirmationModalPreference,
                                getShowVideoThrottleConfirmationModalPref: _this.getShowVideoThrottleConfirmationModalPref,
                                setShowVideoThrottleConfirmationModalPref: _this.setShowVideoThrottleConfirmationModalPref,
                                getDataLayerEvent: _this.getDataLayerEvent,
                                getDataLayerStep: _this.getDataLayerStep,
                                trackDataLayerInteraction: _this.trackDataLayerInteraction,
                                getWcocConsentCallInProgress: _this.getWcocConsentCallInProgress,
                                setIsFdmWcocPermitted: _this.setIsFdmWcocPermitted,
                                getIsFdmWcocPermitted: _this.getIsFdmWcocPermitted,
                                generateWcocToken: _this.generateWcocToken,
                                setWcocConsent: _this.setWcocConsent,
                                $injector: _this.$injector,
                                getDataAlertsActiveTabIndex: _this.getDataAlertsActiveTabIndex,
                                setDataAlertsActiveTabIndex: _this.setDataAlertsActiveTabIndex,
                                getIsRogersAddonEnabled: _this.getIsRogersAddonEnabled,
                                setIsRogersAddonEnabled: _this.setIsRogersAddonEnabled,
                                getIsRogersDataPurchaseEnabled: _this.getIsRogersDataPurchaseEnabled,
                                setIsRogersDataPurchaseEnabled: _this.setIsRogersDataPurchaseEnabled,
                                getIsFirstCycleAfterPpc: _this.getIsFirstCycleAfterPpc
                            };
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return _this.config;
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            _this.accountOverviewProvider.configure({
                                basic: {
                                    applicationId: _this.config.basic.applicationId,
                                    partialApiUrl: _this.config.basic.dataManagerAccountOverviewAPI
                                }
                            });
                            _this.accountOverviewSummaryProvider.configure({
                                basic: {
                                    applicationId: _this.config.basic.applicationId,
                                    partialApiUrl: _this.config.basic.dataManagerSummaryAPI
                                }
                            });
                            return true;
                        };
                        /**
                         * @param code
                         * @returns {boolean}
                         */
                        this.addCode = function (code) {
                            _this.errorCodesMap[code.frontendCode] = code;
                        };
                        /**
                         *
                         * @returns {ute.data.manager.service.StatusCode}
                         */
                        this.getStatusCode = function () {
                            return StatusCode;
                        };
                        /**
                         *
                         * @returns {ute.data.manager.service.GroupStatusCode}
                         */
                        this.getGroupStatusCode = function () {
                            return GroupStatusCode;
                        };
                        this.getIsFirstCycleAfterPpc = function () { return _this.isFirstCycleAfterPpc; };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                frontendMessageKey: 'ute.dataManager.error.systemErrorMessage',
                                templateUrl: _this.getConfig().advanced.dataManagerGenericModal.templateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.GENERIC_ERROR
                            });
                        };
                        /*
                         Example API
                    
                         private genericAPICall: () => ng.IPromise<ICodeEntry> = () => {
                         var request: any = {
                         accountNumber: this.model.accountNumber,
                         applicationId: this.config.basic.applicationId
                         };
                    
                         this.isDataManagerCallInProgress = true;
                    
                         return this.$http.put(this.getConfig().basic.dataManagerAPI, request)
                         .then<ICodeEntry>(this.processDataManagerCallOk)
                         .catch<ICodeEntry>(this.processShareEverythingError)
                         .finally<ICodeEntry>(this.finaliseDataManagerCall);
                         };
                         */
                        /**
                         * @param response
                         * @returns {any}
                         */
                        /* Example Success Handling
                    
                         private processDataManagerCallOk: (response: ng.IHttpPromiseCallbackArg<IBackEndResponse>) => ICodeEntry = (response: ng.IHttpPromiseCallbackArg<IBackEndResponse>) => {
                         return this.errorCodesMap[FrontEndErrorCode.CALL_OK];
                         };
                         */
                        /**
                         * @param error
                         * @returns {ICodeEntry}
                         */
                        /* Example Error Management
                    
                         private processShareEverythingError: (error: any) => ICodeEntry = (error: any) => {
                         const backendCode: number = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                    
                         return _.find(this.errorCodesMap, (ce: ICodeEntry) => {
                         return ce.backendCode === backendCode;
                         }) || this.errorCodesMap[FrontEndErrorCode.GENERIC_ERROR];
                         };
                         */
                        /* Example API Finalization
                         private finaliseDataManagerCall: () => void = () => {
                         this.isDataManagerCallInProgress = false;
                         };
                         */
                        this.getSecondTickValue = function () {
                            var chartTicks = _this.getChartDataTicks();
                            return chartTicks[chartTicks.length - 2];
                        };
                        this.setSelectedBadgeCTN = function (ctn) {
                            _this.model.badgeList.selectedCTN = ctn;
                        };
                        this.getSelectedBadgeCTN = function () {
                            return _this.model.badgeList.selectedCTN;
                        };
                        /**
                         * @returns {number}
                         */
                        this.getAccountNumber = function () {
                            return _this.model.accountNumber;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getAccountStatus = function () {
                            return _this.accountOverviewFactory().getAccountOverview();
                        };
                        /**
                         * TODO to make it automaticaly
                         */
                        this.restoreDefault = function () {
                            if (_this.$stateParams.id) {
                                // not expecting any encrypted state if
                                // coming from discover page/console
                                if (_this.$stateParams.id === 'true') {
                                    return null;
                                }
                                return _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                    _this.model = _.merge(_this.model, obj);
                                    // this.model.accountNumber = this.$window.localStorage.getItem('accountNumber');
                                    return _this.model;
                                }).catch(function (error) {
                                    _this.$state.go(_this.config.advanced.serverErrorState);
                                    return null;
                                });
                            }
                            else {
                                // TODO route where ? or maybe restore from localstore - refresh on confirm
                                // this.$state.go(this.config.basic.entryState);
                                return null;
                            }
                        };
                        this.setAccountNumber = function (accountNumber) {
                            _this.model.accountNumber = accountNumber;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getEntryState = function () {
                            return _this.config.basic.dataManagerRootState + '.' + _this.config.advanced.enterDataManager.subState;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getWirelessState = function () {
                            return _this.config.basic.wirelessState;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getEntryStateNoEncryption = function () {
                            return _this.config.basic.dataManagerRootState + '.' + _this.config.advanced.enterDataManager.subStateNoEncryption;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getSecondEntryState = function () {
                            return _this.config.basic.dataManagerRootState + '.' + 'dataManagerConsole';
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isCare = function () {
                            return (_this.userService.getUserType() === 'care');
                        };
                        /**
                         *
                         * @param brt
                         */
                        this.setBRT = function (brt) {
                            _this.model.isBRTEnabled = brt;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        this.getBRT = function () {
                            return _this.model.isBRTEnabled;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getAccountsSummaryState = function () {
                            return _this.config.basic.dataManagerRootState + '.' + _this.config.advanced.dataManagerAccountsSummary.subState;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getUsageReportingDelay = function () {
                            return _this.model.usageReportingDelay;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getSaveAlertCallInProgress = function () {
                            return _this.saveAlertCallInProgress;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getSetBlockCallInProgress = function () {
                            return _this.isSetBlockAPICallInProgress;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getSetDataManagerCallInProgress = function () {
                            return _this.isSetDataManagerAPICallInProgress;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getPurchaseDataProductCallInProgress = function () {
                            return _this.isPurchaseDataProductAPICallInProgress;
                        };
                        /**
                         * @param value
                         * @returns {void}
                         */
                        this.setPurchaseDataProductCallInProgress = function (value) {
                            _this.isPurchaseDataProductAPICallInProgress = value;
                        };
                        /**
                         * @returns {string}
                         */
                        this.getIndividualSummaryState = function () {
                            return _this.config.basic.dataManagerRootState + '.' + _this.config.advanced.dataManagerIndividualSummary.subState;
                        };
                        /**
                         * @param input
                         * @returns {any}
                         */
                        this.goToEntryState = function (input) {
                            return _this.encryptionService.encrypt(input).then(function (id) {
                                return _this.$state.go(_this.getEntryState(), { id: id });
                            });
                        };
                        /**
                         * @param input
                         *
                         */
                        this.goToWirelessState = function () {
                            _this.$state.go(_this.getWirelessState());
                        };
                        /**
                         * @param module
                         * @returns {angular.IPromise<any>}
                         */
                        this.goToSubModule = function (module) {
                            var dataManagerInput = {
                                accountNumber: _this.model.accountNumber
                            };
                            return _this.encryptionService.encrypt(dataManagerInput).then(function (id) {
                                return _this.$state.go(_this.config.basic.dataManagerRootState + '.' + module, {
                                    id: id
                                });
                            });
                        };
                        this.reCompile = function (env, element, container, content) {
                            var angularElement = angular.element(element[0].getElementsByClassName(container)[0]);
                            angularElement.empty();
                            var html = _this.$compile(content)(env);
                            angularElement.append(html);
                        };
                        /**
                         * Return immutable IDataManagerModel object
                         * @returns {IDataManagerModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /**
                         *
                         * @param model
                         */
                        this.setModel = function (model) {
                            _this.model = model;
                        };
                        this.getWirelessSummary = function () {
                            return _this.getSummaryWorker().then(function (worker) { return worker.getWirelessSummary(); });
                        };
                        /**
                         *
                         * @param iLineIndex
                         * @param iDataAmount
                         */
                        this.setDataLineAlertAt = function (iLineIndex, iDataAmount) {
                            _this.model.dataControlList[iLineIndex].dataAlertAt = iDataAmount;
                        };
                        /**
                         *
                         * @param iLineIndex
                         * @returns {number}
                         */
                        this.getDataLineAlertAt = function (iLineIndex) {
                            return _this.model.dataControlList[iLineIndex].dataAlertAt;
                        };
                        /**
                         *
                         * @param index
                         * @returns {string}
                         */
                        this.getCTNByIndex = function (index) {
                            return _this.model.dataControlList[index].ctn;
                        };
                        /**
                         *
                         * @param iLineIndex
                         * @param bEnabled
                         */
                        this.setDataUseAlert = function (iLineIndex, bEnabled) {
                            _this.model.dataControlList[iLineIndex].useAlert = bEnabled;
                        };
                        /**
                         *
                         * @param iLineIndex
                         * @param bEnabled
                         */
                        this.setDataAccess = function (iLineIndex, bEnabled) {
                            _this.model.dataControlList[iLineIndex].dataAccess = bEnabled;
                        };
                        /**
                         *
                         * @param index
                         * @returns {boolean}
                         */
                        this.getDataAccess = function (index) {
                            return _this.model.dataControlList[index].dataAccess;
                        };
                        /**
                         * @param ctn
                         * @param bEnabled
                         */
                        this.setDataAccessCTN = function (ctn, bEnabled) {
                            // Find the item by CTN
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            if (searchIndex >= 0) {
                                _this.model.dataControlList[searchIndex].dataAccess = bEnabled;
                            }
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {number}
                         */
                        this.getAlertRecipientIndex = function (ctn) {
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            return searchIndex;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        this.getInfoBlock = function () {
                            return _this.model.infoBlock;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {boolean}
                         */
                        this.getDataAccessCTN = function (ctn) {
                            // Find the item by CTN
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            return _this.model.dataControlList[searchIndex].dataAccess;
                        };
                        /**
                         * Inverts boolean model property isDataAlertsOpen and sets active tab index
                         */
                        this.toggleDataAlerts = function (tabIndex) {
                            if (_this.getIsVideoThrottlePermitted()) {
                                _this.model.dataManagerActiveTabIndex = tabIndex;
                            }
                            _this.model.isDataAlertsOpen = !_this.model.isDataAlertsOpen;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getDataAlertsOpen = function () {
                            return _this.model.isDataAlertsOpen;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        /**
                         *
                         * @returns {number}
                         */
                        this.getRemainingTotalData = function () {
                            var totalData = _this.model.dataLimit + _this.getAddedExtraData();
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                var currentLine = _this.model.dataControlList[iLine];
                                if (currentLine.groupStatus !== GroupStatusCode.JOINED) {
                                    totalData = totalData - currentLine.dataUsed;
                                }
                            }
                            return totalData;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {IDataManagerAccountLine}
                         */
                        this.getAccountLineByCTN = function (ctn) {
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                var currentLine = _this.model.dataControlList[iLine];
                                if (currentLine.ctn === ctn) {
                                    return currentLine;
                                }
                            }
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getAlertedDataTotal = function () {
                            var iTotal = 0;
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                var currentLine = _this.model.dataControlList[iLine];
                                if (currentLine.hasData) {
                                    if (currentLine.dataAccess) {
                                        if (currentLine.useAlert) {
                                            iTotal = (iTotal * 1) + (currentLine.dataAlertAt * 1);
                                        }
                                    }
                                }
                            }
                            return iTotal;
                        };
                        /**
                         *
                         * @param ctn
                         */
                        this.setAlertMoved = function (ctn) {
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            _this.model.dataControlList[searchIndex].alertMoved = true;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getSavedAlertedDataTotal = function () {
                            var iTotal = 0;
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                var currentLine = _this.model.dataControlList[iLine];
                                if (currentLine.hasData) {
                                    if (currentLine.dataAccess) {
                                        if (currentLine.useAlert) {
                                            iTotal = iTotal + (currentLine.savedAlertValue > -1 ? currentLine.savedAlertValue : 0);
                                        }
                                    }
                                }
                            }
                            return iTotal;
                        };
                        /**
                         *
                         * @param amountToIncrease
                         */
                        this.increaseData = function (gb) {
                            _this.model.addedExtraData += gb;
                        };
                        this.isMockDataEnabled = function () {
                            return _this.useMockData;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getAlertsRecipientDisplayName = function () {
                            var alertsRecipientDisplayName = 'noMatchFound';
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                if (_this.model.dataControlList[iLine].ctn === _this.model.alertsRecipientCTN) {
                                    alertsRecipientDisplayName = _this.model.dataControlList[iLine].displayName;
                                }
                            }
                            return alertsRecipientDisplayName;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {string}
                         */
                        this.getDisplayNameCTN = function (ctn) {
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            return searchIndex !== -1 ? _this.model.dataControlList[searchIndex].displayName : '';
                        };
                        /**
                         *
                         * @returns {Array<IDataManagerAccountLine>}
                         */
                        this.getDataControlList = function () {
                            // Profile Alert Directive - dataManagerProfileAlert.controller.ts
                            return _this.model.dataControlList;
                        };
                        this.clearDataControlList = function () {
                            return _this.model.dataControlList = [];
                        };
                        /**
                         *
                         * @returns {IDataManagerBadgeModel}
                         */
                        this.getBadgeList = function () {
                            return _this.model.badgeList;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getAlertsRecipientCTN = function () {
                            return _this.model.alertsRecipientCTN;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getPrimaryCTN = function () {
                            return _this.model.primaryCTN;
                        };
                        /**
                         *
                         * @param ctn
                         */
                        this.setAlertsRecipientCTN = function (ctn) {
                            _this.model.alertsRecipientCTN = ctn;
                            /* REORDER ALERTS RECIPIENT TO TOP -- NO LONGER A REQUIREMENT
                      
                             var accountLine: IDataManagerAccountLine;
                      
                             for (var iLine = 0 ; iLine < this.model.dataControlList.length ; iLine ++) {
                             if (this.model.dataControlList[iLine].ctn === ctn) {
                             accountLine = this.model.dataControlList.splice(iLine, 1)[0];
                             this.model.dataControlList.unshift( accountLine );
                             }
                             }
                      
                             */
                        };
                        /*
                         private getTotalAvailableData: () => number = () => {
                         return this.dataManagerService.getDataLimit() + this.model.addedExtraData;
                         };
                         */
                        /**
                         *
                         * @returns {number}
                         */
                        this.getTotalUsedData = function () {
                            var totalUsedData = 0;
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                totalUsedData = totalUsedData + _this.model.dataControlList[iLine].dataUsed;
                            }
                            return totalUsedData;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getOverageForDTU = function () {
                            var overageData = _this.model.overage;
                            return overageData;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getOverage = function () {
                            var usedData = _this.getTotalUsedData();
                            var dataLimit = _this.model.dataLimit;
                            var addedExtra = _this.getAddedExtraData();
                            return (usedData > (dataLimit + addedExtra)) ? usedData - (dataLimit + addedExtra) : 0;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getAddedExtraData = function () {
                            /*
                      
                             var extraDataPurchases: Array<any> = this.getPurchaseDataIncreases();
                             var totalExtraDataMB: number = 0;
                      
                             for (var iExtras: number = 0; iExtras < extraDataPurchases.length ; iExtras ++) {
                             totalExtraDataMB = (totalExtraDataMB * 1) + (extraDataPurchases[iExtras].amount * 1);
                             }
                             */
                            return _this.model.planUpsellSize;
                        };
                        /**
                         *
                         * @param addedExtra
                         */
                        this.increaseAddedExtra = function (addedExtra) {
                            _this.model.planUpsellSize += addedExtra;
                        };
                        /**
                         *
                         * @param addedExtra
                         */
                        this.setAddedExtraData = function (addedExtra) {
                            _this.model.planUpsellSize = addedExtra;
                        };
                        /**
                         *
                         * @param accountIndex
                         * @returns {number}
                         */
                        this.getSavedAlertValue = function (accountIndex) {
                            return _this.model.dataControlList[accountIndex].savedAlertValue;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {number}
                         */
                        this.getSavedAlertValueCTN = function (ctn) {
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            return _this.model.dataControlList[searchIndex].savedAlertValue;
                        };
                        /**
                         *
                         * @param accountIndex
                         * @param amount
                         */
                        this.setSavedAlertValue = function (accountIndex, amount) {
                            _this.model.dataControlList[accountIndex].savedAlertValue = amount;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {number}
                         */
                        this.getIndexByCTN = function (ctn) {
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                if (_this.model.dataControlList[iLine].ctn === ctn) {
                                    return iLine;
                                }
                            }
                        };
                        this.setIsRogersAddonEnabled = function () {
                            var key = ute.common.permissions.service.UserPermissions.ROGERS_ENABLE_ADDON;
                            _this.permissionsService.getUserPermission(key).then(function (isPermitted) {
                                _this.model.isRogersAddonEnabled = isPermitted;
                            });
                        };
                        this.getIsRogersAddonEnabled = function () {
                            return !!_this.model.isRogersAddonEnabled;
                        };
                        this.setIsRogersDataPurchaseEnabled = function () {
                            var key = ute.common.permissions.service.UserPermissions.ROGERS_ENABLE_ADDON_SE;
                            _this.permissionsService.getUserPermission(key).then(function (isPermitted) {
                                _this.model.isRogersDataPurchaseEnabled = isPermitted;
                            });
                        };
                        this.getIsRogersDataPurchaseEnabled = function () {
                            return !!_this.model.isRogersDataPurchaseEnabled;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isAllowedToPurchaseData = function () {
                            return _this.model.isAllowedToPurchaseData;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getSummaryChartHeight = function () {
                            return _this.$window.innerHeight - _this.config.advanced.dataManagerAccountsSummary.chartHeightOffset;
                        };
                        /**
                         *
                         * @param index
                         */
                        this.setIndividualCTNView = function (index) {
                            _this.model.ctnView = index;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getIndividualCTNView = function () {
                            return _this.model.ctnView;
                        };
                        /**
                         *
                         * @param item
                         * @returns {boolean}
                         */
                        this.summaryBarsFilter = function (item) {
                            return (item.groupStatus !== GroupStatusCode.JOINED);
                        };
                        /**
                         *
                         * @returns {Array<IDataManagerAccountLine>}
                         */
                        this.getFilteredList = function () {
                            var controlList = _this.getDataControlList();
                            var filteredList = [];
                            for (var iControl = 0; iControl < controlList.length; iControl++) {
                                var ctrl = controlList[iControl];
                                if (_this.summaryBarsFilter(ctrl)) {
                                    filteredList.push(ctrl);
                                }
                            }
                            return filteredList;
                        };
                        this.summaryBarsFilterSecondary = function (item) {
                            return (item.groupStatus !== GroupStatusCode.JOINED) && item.hasData;
                        };
                        this.getSecondaryFilteredList = function () {
                            var controlList = _this.getDataControlList();
                            var filteredList = [];
                            for (var iControl = 0; iControl < controlList.length; iControl++) {
                                var ctrl = controlList[iControl];
                                if (_this.summaryBarsFilterSecondary(ctrl)) {
                                    filteredList.push(ctrl);
                                }
                            }
                            return filteredList;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getNextIndividualCTNIndex = function () {
                            if (_this.model.ctnView < _this.getFilteredList().length - 1) {
                                _this.setIndividualCTNView(_this.model.ctnView + 1);
                                return _this.model.ctnView;
                            }
                            else {
                                return _this.model.ctnView;
                            }
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getPrevIndividualCTNIndex = function () {
                            if (_this.model.ctnView > 0) {
                                _this.setIndividualCTNView(_this.model.ctnView - 1);
                                return _this.model.ctnView;
                            }
                            else {
                                return _this.model.ctnView;
                            }
                        };
                        /**
                         *
                         * @param val
                         */
                        this.setUsageDetailsCallInProgress = function (val) {
                            _this.model.usageDetailCallInProgress = val;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getUsageDetailsCallInProgress = function () {
                            return _this.model.usageDetailCallInProgress;
                        };
                        this.getDataProductsCallInProgress = function () {
                            return _this.isGetDataProductsCallInProgress;
                        };
                        /**
                         *
                         * @param index
                         * @returns {IDataManagerAccountLine}
                         */
                        this.getControlLineByIndex = function (index) {
                            return _this.model.dataControlList[index];
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getIndividualSummaryCTN = function () {
                            return _this.model.individualSummaryCTN;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getWirelessCTN = function () {
                            if (_this.isCare()) {
                                return _this.$window.sessionStorage.getItem('phoneNumber');
                            }
                            else {
                                return _this.$window.localStorage.getItem('phoneNumber');
                            }
                        };
                        /**
                         *
                         * @param value
                         */
                        this.setSummaryMode = function (value) {
                            _this.model.summaryMode = value;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getSummaryMode = function () {
                            return _this.model.summaryMode;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {string}
                         */
                        this.getColorCodeCTN = function (ctn) {
                            var controlLine = _this.getControlLineCTN(ctn);
                            return controlLine.colorCode;
                        };
                        this.getColorCodeClass = function (ctn) {
                            var iconClassName = 'ute-data-manager-vt-icon-' + ctn.substr(1);
                            return iconClassName;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {boolean}
                         */
                        this.hasDataCTN = function (ctn) {
                            var controlLine = _this.getControlLineCTN(ctn);
                            return controlLine.hasData;
                        };
                        /**
                         *
                         * @param ctn
                         * @returns {IDataManagerAccountLine}
                         */
                        this.getControlLineCTN = function (ctn) {
                            var controlLine = _.find(_this.model.dataControlList, function (obj) {
                                return obj.ctn === ctn;
                            });
                            return controlLine;
                        };
                        /**
                         *
                         * @param ctn
                         */
                        this.setIndividualSummaryCTN = function (ctn) {
                            _this.model.individualSummaryCTN = ctn;
                        };
                        /**
                         *
                         * @param ctn
                         */
                        this.setWirelessCTN = function (ctn) {
                            if (_this.isCare()) {
                                _this.$window.sessionStorage.setItem('phoneNumber', ctn);
                            }
                            else {
                                _this.$window.localStorage.setItem('phoneNumber', ctn);
                            }
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getErrorPageState = function () {
                            return _this.config.basic.errorLocation;
                        };
                        /**
                         *
                         * @returns {Array<IDataManagerAccountLine>}
                         */
                        this.getDataControlListWithData = function () {
                            var controlListWithData = [];
                            for (var iLine = 0; iLine < _this.model.dataControlList.length; iLine++) {
                                if (_this.model.dataControlList[iLine].hasData) {
                                    controlListWithData.push(_this.model.dataControlList[iLine]);
                                }
                            }
                            return controlListWithData;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getAlertOverDataLimit = function () {
                            return _this.model.alertOverDataLimit;
                        };
                        /**
                         *
                         * @param value
                         */
                        this.setAlertOverDataLimit = function (value) {
                            _this.model.alertOverDataLimit = value;
                        };
                        /**
                         *
                         * @returns {Array<number>}
                         */
                        this.getChartDataTicks = function () {
                            return _this.model.accountsSummaryChart.displayTicks;
                        };
                        /**
                         *
                         * @returns {Array|any}
                         */
                        this.getDisplayChartDataTicks = function () {
                            return _this.model.accountsSummaryChart.displayTicks;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getTotalUsedDataBucket = function () {
                            return Math.ceil(_this.getDataLimit() + _this.getAddedExtraData() + _this.getOverage());
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getDataLimit = function () {
                            return _this.model.dataLimit;
                        };
                        this.getBillCycle = function () {
                            return _this.model.billCycle;
                        };
                        /**
                         *
                         * @returns {string}
                         */
                        this.getLang = function () {
                            return _this.$translate.use();
                        };
                        /**
                         *
                         * @returns {IAccountOverviewWorker}
                         */
                        this.getFactoryWorker = function () {
                            var param;
                            if (_this.userService.isCare()) {
                                var ban = Number(_this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER));
                                param = { acctNbr: ban };
                            }
                            return _this.accountOverviewFactory(param);
                        };
                        /**
                         *
                         * @returns {IPromise<IAccountOverviewSummaryWorker>}
                         */
                        this.getSummaryWorker = function () {
                            return _this.getFactoryWorker().getSelectedAccount().then(function (account) {
                                var summaryRequest = {
                                    accountNumber: account.accountNumber,
                                    accountTypeNumber: account.accountTypeNumber,
                                    language: _this.getLang()
                                };
                                return _this.accountOverviewSummaryFactory(summaryRequest);
                            });
                        };
                        this.getUsageDetailsWorker = function (input) {
                            return _this.dataManagerServerGetUsageDetailsFactory(input);
                        };
                        /**
                         *
                         * @returns {Array<any>}
                         */
                        this.getIncreaseDataOptions = function () {
                            return _this.model.increaseDataOptions;
                        };
                        this.setStateToErrorPage = function () {
                            _this.$state.go(_this.getConfig().basic.errorLocation);
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getIndividualMode = function () {
                            return _this.model.individualMode;
                        };
                        /**
                         *
                         * @param mode
                         */
                        this.setIndividualMode = function (mode) {
                            _this.model.individualMode = mode;
                        };
                        /**
                         *
                         * @returns {Array<any>}
                         */
                        this.getPurchaseDataIncreases = function () {
                            return _this.model.increaseDataPurchases;
                        };
                        /**
                         *
                         * @param product
                         */
                        this.addToPurchaseDataIncreases = function (product) {
                            // this.model.increaseDataPurchases.push(product);
                            var transformedProduct = _this.transformDataProduct(product);
                            var searchIndex = _.findIndex(_this.model.increaseDataPurchases, {
                                amount: transformedProduct.amount,
                                value: transformedProduct.value
                            });
                            if (searchIndex > -1) {
                                _this.model.increaseDataPurchases[searchIndex].multiplier++;
                            }
                            else {
                                _this.model.increaseDataPurchases.push(transformedProduct);
                            }
                        };
                        /**
                         *
                         * @param index
                         */
                        this.setActiveTabIndex = function (index) {
                            _this.model.activeTabIndex = index;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getActiveTabIndex = function () {
                            return _this.model.activeTabIndex;
                        };
                        this.getState = function () {
                            return _this.$state.current.name;
                        };
                        this.expandDataSection = function () {
                            if (_this.$state.current.name === _this.config.basic.dataManagerRootState + '.manage') {
                                var ismobilePhones = _this.browserService.isMobile() && !_this.browserService.isIpad();
                                if (!ismobilePhones) {
                                    _this.model.isDataAlertsOpen = true;
                                }
                                else {
                                    _this.goToSubModule(_this.getConfig().advanced.dataManagerAccountsSummary.subState);
                                }
                            }
                            return;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getTotalDataPurchased = function () {
                            var dataPurchases = _this.getPurchaseDataIncreases();
                            var totalPurchased = 0;
                            for (var iPurchase = 0; iPurchase < dataPurchases.length; iPurchase++) {
                                totalPurchased = totalPurchased + dataPurchases[iPurchase].value;
                            }
                            return totalPurchased;
                        };
                        /**
                         * @param ctn
                         * @returns {boolean}
                         */
                        this.isTabDisabled = function (ctn) {
                            var isLeftGroup = _this.getControlLineCTN(ctn).groupStatus === _this.getGroupStatusCode().LEFT, isCancelled = (_this.getControlLineCTN(ctn).status === _this.getStatusCode().CANCELLED), isBadgeSubStatusSuspended = (_this.getBadgeSubStatusByCTN(ctn) === 'Suspended');
                            return (isLeftGroup || isCancelled || isBadgeSubStatusSuspended);
                        };
                        this.resetBadgeList = function () {
                            _this.model.badgeList = {
                                planName: '',
                                isShareEverythingEligible: false,
                                selectedCTN: '',
                                subscriberList: []
                            };
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getHighestDataPoint = function () {
                            var highestPoint = 0;
                            for (var iSub = 0; iSub < _this.model.dataControlList.length; iSub++) {
                                var sub = _this.model.dataControlList[iSub];
                                if (sub.dataUsed > highestPoint) {
                                    highestPoint = sub.dataUsed;
                                }
                                if (sub.savedAlertValue > highestPoint && sub.useAlert && !_this.model.bucketSizeUnavailableUntilNextBillCycle) {
                                    highestPoint = sub.savedAlertValue;
                                }
                            }
                            return highestPoint;
                        };
                        /**
                         *
                         * @returns {number}
                         */
                        this.getTotalDataPurchasedAmount = function () {
                            var dataPurchases = _this.getPurchaseDataIncreases();
                            var totalData = 0;
                            for (var iPurchase = 0; iPurchase < dataPurchases.length; iPurchase++) {
                                totalData = totalData + dataPurchases[iPurchase].amount;
                            }
                            return totalData;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return _this.model.bucketSizeUnavailableUntilNextBillCycle;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.isProrationError = function () {
                            return _this.model.prorationError;
                        };
                        this.resetModel = function () {
                            _this.model = {
                                accountNumber: null,
                                dataLimit: 1,
                                loadComplete: false,
                                isDataAlertsOpen: false,
                                alertsRecipientCTN: null,
                                primaryCTN: '',
                                individualSummaryCTN: null,
                                activeTabIndex: 0,
                                usageDetailCallInProgress: true,
                                planUpsellSize: 0,
                                addedExtraData: 0,
                                ctnView: 0,
                                isBRTEnabled: false,
                                summaryMode: true,
                                planName: 'Share Everything',
                                bucketSizeUnavailableUntilNextBillCycle: false,
                                dataUsageMayBeInaccurateDueToPlanChange: false,
                                individualMode: false,
                                alertOverDataLimit: false,
                                isShareEverythingEligible: true,
                                isAllowedToPurchaseData: false,
                                isPlanChanged: false,
                                province: 'ON',
                                highestDataPoint: 0,
                                showSwipeInstructions: false,
                                swipeInstructionsShown: false,
                                accountsSummaryChart: {
                                    displayTicks: [],
                                    dataTicks: []
                                },
                                usageReportingDelay: '',
                                badgeList: {
                                    planName: '',
                                    isShareEverythingEligible: false,
                                    selectedCTN: '',
                                    subscriberList: []
                                },
                                billCycle: {
                                    nextStartDate: {
                                        month: 1,
                                        day: 1
                                    },
                                    startDate: {
                                        month: 1,
                                        day: 1
                                    },
                                    endDate: {
                                        month: 2,
                                        day: 12
                                    },
                                    daysUntilEndDate: 1
                                },
                                increaseDataPurchases: [],
                                increaseDataOptions: [],
                                dataControlList: [],
                                infoBlock: [],
                                dataManagerModules: [
                                    {
                                        container: 'ute-dataManager-dashboard-usageDialContainer',
                                        moduleString: '<ute-data-manager-usage-dial></ute-data-manager-usage-dial>',
                                        exists: true,
                                        mobileOnly: false,
                                        desktopOnly: false,
                                        exemptDestroyAll: false
                                    },
                                    {
                                        container: 'ute-dataManager-dashboard-dataAlertsContainer',
                                        moduleString: '<ute-data-manager-data-alerts></ute-data-manager-data-alerts>',
                                        exists: true,
                                        mobileOnly: true,
                                        desktopOnly: false,
                                        exemptDestroyAll: false
                                    },
                                    {
                                        container: 'ute-dataManager-dashboard-dataControlTagList-container',
                                        moduleString: '<ute-data-manager-data-control-tag-list></ute-data-manager-data-control-tag-list>',
                                        exists: true,
                                        mobileOnly: true,
                                        desktopOnly: false,
                                        exemptDestroyAll: false
                                    },
                                    {
                                        container: 'ute-dataManager-dashboard-sharedUsageBar',
                                        moduleString: '<ute-data-manager-shared-usage-bar></ute-data-manager-shared-usage-bar>',
                                        exists: true,
                                        mobileOnly: false,
                                        desktopOnly: true,
                                        exemptDestroyAll: false
                                    },
                                    // {
                                    //   container: 'ute-dataManager-dashboard-controlListContainer',
                                    //   moduleString: '<ute-data-manager-data-control-list></ute-data-manager-data-control-list>',
                                    //   exists: true,
                                    //   mobileOnly: false,
                                    //   desktopOnly: true,
                                    //   exemptDestroyAll: false
                                    // },
                                    {
                                        container: 'ute-dataManager-dashboard-tabsContainer',
                                        moduleString: '<ute-data-manager-tabs></ute-data-manager-tabs>',
                                        exists: true,
                                        mobileOnly: false,
                                        desktopOnly: true,
                                        exemptDestroyAll: false
                                    },
                                    {
                                        container: 'ute-dataManager-dashboard-tabsContentContainer',
                                        moduleString: '<ute-data-manager-tabs-content></ute-data-manager-tabs-content>',
                                        exists: true,
                                        mobileOnly: false,
                                        desktopOnly: true,
                                        exemptDestroyAll: true
                                    },
                                    {
                                        container: 'ute-dataManager-dashboard-controlListContainer',
                                        moduleString: '<ute-data-manager-data-video-throttle-wrapper></ute-data-manager-data-video-throttle-wrapper>',
                                        exists: true,
                                        mobileOnly: false,
                                        desktopOnly: true,
                                        exemptDestroyAll: false
                                    }
                                ],
                                isVideoThrottlePermitted: null,
                                dataManagerActiveTabIndex: 0,
                                doNotShowVideoThrottleConfirmationModal: false,
                                dataAlertsActiveTabIndex: 0,
                                isFdmWcocPermitted: null,
                                overage: 0,
                                remaining: 0,
                                prorationError: false,
                                totalDataUsage: 0,
                                isRogersAddonEnabled: null,
                                isRogersDataPurchaseEnabled: null
                            };
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.getSwipeInstructionsShown = function () {
                            return _this.model.swipeInstructionsShown;
                        };
                        /**
                         *
                         * @param value
                         */
                        this.setSwipeInstructionsShown = function (value) {
                            _this.model.swipeInstructionsShown = value;
                        };
                        /**
                         *
                         * @returns {boolean}
                         */
                        this.showSwipeInstructions = function () {
                            return _this.model.showSwipeInstructions;
                        };
                        /**
                         *
                         * @param showSwipe
                         */
                        this.setShowSwipeInstructions = function (showSwipe) {
                            _this.model.showSwipeInstructions = showSwipe;
                        };
                        this.countdownSwipeInstructions = function () {
                            _this.$timeout(function () {
                                _this.model.showSwipeInstructions = false;
                                _this.model.swipeInstructionsShown = true;
                            }, 4000);
                        };
                        // Load data from temporray text file and prepare for directive consumption
                        this.loadbadgeData = function () {
                            return _this.$http.get('ute-data-manager/assets/accountdata.json')
                                .catch(_this.loadbadgeDataFail);
                        };
                        /*
                         private loadbadgeDataSuccess: (response: ng.IHttpPromiseCallbackArg<string>) => Object = (response: ng.IHttpPromiseCallbackArg<string>) => {
                         var processedResponse = this.loadbadgeDataProcess(response.data);
                         return processedResponse;
                         };*/
                        this.loadbadgeDataFail = function (response) {
                            return response;
                        };
                        //TODO: change this to generic sorting function
                        /*
                    
                         private loadbadgeDataProcess: (dataLoad: any) => any = (dataLoad: any) => {
                         // find sublist and loop through it to pull all the shared users
                         var i: number = 0;
                         var item: any = {};
                         var subList: Array<any> = dataLoad.shareEverything.subList;
                         var mainList: Array<any> = [];
                         var sharedList: Array<any> = [];
                         var sharedListSorted: Array<any> = [];
                         var finalListSorted: Array<any> = [];
                    
                         for (i = 0; i < subList.length; i++) {
                         item = subList[i];
                    
                         // Sorting rules
                         // 1) has shared data
                         if (item.isSharingData === true || item.isSharingData === 'true') {
                         // 2) pick Main user and push all the others to shared list
                         if (item.isAccountHolder === true || item.isAccountHolder === 'true') {
                         mainList.push(item);
                         } else {
                         sharedList.push(item);
                         }
                         }
                         }
                    
                         // Sort the list of shared folks by one property from the object
                         sharedListSorted = _.sortBy(sharedList, function(o: any) { return o.subNumber; });
                    
                         // merge main owner with the rest if the users
                         finalListSorted = _.union(mainList, sharedList);
                    
                         // Add colours
                         for (i = 0; i < finalListSorted.length; i++) {
                         finalListSorted[i].colorCode = this.config.basic.colorHexGuide[i];
                         }
                    
                         // Put data back to original object with additioal information
                         dataLoad.shareEverything.subList = finalListSorted;
                    
                         //FTODO: scrap this for future model mapping
                    
                         return dataLoad.shareEverything;
                         };
                    
                         */
                        /**
                         *
                         * @param accountOverview
                         * @param model
                         */
                        this.transformAccountOverview = function (accountOverview, model) {
                            _this.model.accountNumber = accountOverview.accountList[0].accountNumber;
                            return model;
                        };
                        this.transformSummary = function (summary, model) {
                            model.accountNumber = String(summary.accountNumber);
                            model.province = summary.billingAddress.province;
                            var translationKey = 'ute.dataManager.runtimeTranslation.badgeList.planName';
                            _this.runtimeTranslateService.addTranslation('en', translationKey, summary.shareEverything.planName);
                            _this.runtimeTranslateService.addTranslation('fr', translationKey, summary.shareEverything.planNameFr);
                            model.badgeList = {
                                planName: translationKey,
                                isShareEverythingEligible: summary.shareEverything.isDataManagerEligible,
                                selectedCTN: '',
                                subscriberList: []
                            };
                            for (var iSub = 0; iSub < summary.subList.length; iSub++) {
                                var sub = summary.subList[iSub];
                                if (sub.shareEverything && sub.subType === 'CTN') {
                                    model.badgeList.subscriberList.push({
                                        displayName: sub.firstname,
                                        ctn: sub.subNumber,
                                        colorCode: _this.config.basic.colorHexGuide[iSub],
                                        subStatus: sub.subStatus
                                    });
                                }
                            }
                            //TESTING OVERRIDES
                            // model.badgeList.subscriberList[0].subStatus = 'Suspended';
                            ////////////////////
                            model.badgeList.selectedCTN = model.badgeList.subscriberList[0].ctn;
                            return model;
                        };
                        this.transformProduct = function (product) {
                            var translationKey = 'ute.dataManager.runtimeTranslation.products.displayInfo.' + product.socID;
                            _this.runtimeTranslateService.addTranslation('en', translationKey, product.socDisplayName);
                            _this.runtimeTranslateService.addTranslation('fr', translationKey, product.socDisplayNameFr);
                            var translationKeyDataUnit = 'ute.dataManager.runtimeTranslation.products.displayInfo.translationKeyDataUnit' + product.socSizeUnit.toLowerCase();
                            _this.runtimeTranslateService.addTranslation('en', translationKeyDataUnit, product.socSizeUnit);
                            _this.runtimeTranslateService.addTranslation('fr', translationKeyDataUnit, product.socSizeUnitFr);
                            return {
                                socID: product.socID,
                                unit: product.socSizeUnit.toLowerCase(),
                                socDisplay: translationKey,
                                socDescription: product.socDescription,
                                value: product.socPriceInCents,
                                amount: product.socSize
                            };
                        };
                        /**
                         *
                         * @param product
                         * @returns {IDataManagerPurchasedDataProduct}
                         */
                        this.transformPurchaseProduct = function (product) {
                            return {
                                socID: product.id,
                                socDescription: product.description,
                                value: product.cost,
                                amount: product.size,
                                multiplier: 1
                            };
                        };
                        /**
                         *
                         * @param dataProduct
                         * @returns {IDataManagerPurchasedDataProduct}
                         */
                        this.transformDataProduct = function (dataProduct) {
                            return {
                                socID: dataProduct.socID,
                                socDescription: dataProduct.socDescription,
                                value: dataProduct.value,
                                amount: dataProduct.amount,
                                multiplier: 1
                            };
                        };
                        this.transformDataProducts = function (dataProducts, model) {
                            model.increaseDataOptions = [];
                            for (var iProduct = 0; iProduct < dataProducts.body.length; iProduct++) {
                                var product = dataProducts.body[iProduct];
                                var transformedProduct = _this.transformProduct(product);
                                model.increaseDataOptions.push(transformedProduct);
                            }
                            return model;
                        };
                        this.getAccountsSummaryChartData = function (planSize, planUpsellSize, overage) {
                            //TODO: add usage increases to data limit here
                            var maxMajorTicks = 7, //TODO: To provider for config
                            quotient = _this.config.basic.dataConversionRoundValues / 10, modifiedPlanSize = planSize / _this.config.basic.dataConversion * _this.config.basic.dataConversionRoundValues, totalDataBucket = (Math.ceil((modifiedPlanSize + planUpsellSize + overage) / quotient) * quotient), ticks = [], topBucket = 0, baseFactor = [1, 2, 5], //TODO: To provider for config
                            factor = 1;
                            var multiplier = 1;
                            var finished = false;
                            do {
                                for (var iBase = 0; iBase < baseFactor.length; iBase++) {
                                    if (totalDataBucket / (baseFactor[iBase] * multiplier) <= maxMajorTicks) {
                                        factor = baseFactor[iBase] * multiplier;
                                        topBucket = factor * Math.ceil(totalDataBucket / (factor));
                                        finished = true;
                                        break;
                                    }
                                }
                                multiplier = multiplier * 10;
                            } while (!finished);
                            for (var iTick = 0; (topBucket - (factor * iTick)) >= 0; iTick++) {
                                ticks.push(topBucket - (factor * iTick));
                            }
                            return ticks;
                        };
                        this.transformUsageDetails = function (usageDetails, model) {
                            // usageDetails.body.overage = 5;
                            // usageDetails.body.subscriptionList[0].totalDataUsed = 999999;
                            //usageDetails.body.dataManagerTelephoneNumber = '';
                            // usageDetails.body.subscriptionList = [usageDetails.body.subscriptionList[0], usageDetails.body.subscriptionList[1], usageDetails.body.subscriptionList[2]];
                            // usageDetails.body.subscriptionList[0].isSharingData = false;
                            //TESTING OVERRIDES
                            /*
                             usageDetails.body.subscriptionList[0].status = 'suspended';
                             usageDetails.body.subscriptionList[1].status = 'cancelled';
                             usageDetails.body.subscriptionList[2].groupStatus = 'LEFT_GROUP';
                             usageDetails.body.subscriptionList[3].groupStatus = 'JOINED_GROUP';
                             */
                            // usageDetails.body.bucketSizeUnavailableUntilNextBillCycle = true;
                            // usageDetails.body.dataUsageMayBeInaccurateDueToPlanChange = true;
                            // usageDetails.body.planSize = 500;
                            // usageDetails.body.planSize = 1024;
                            // usageDetails.body.planSize = 2048;
                            // usageDetails.body.planUpsellSize = 300;
                            // usageDetails.body.planUpsellSize = 1024;
                            // usageDetails.body.planUpsellSize = 1324;
                            // planUpsellSize : 300
                            // usageDetails.body.overage = 4320;   //planSize : 500
                            // usageDetails.body.overage = 3796;   //planSize : 1024
                            // usageDetails.body.overage = 2772;   //planSize : 2048
                            // planUpsellSize : 1024
                            // usageDetails.body.overage = 3596;   //planSize : 500
                            // usageDetails.body.overage = 3072;   //planSize : 1024
                            // usageDetails.body.overage = 2048;   //planSize : 2048
                            // planUpsellSize : 1324
                            // usageDetails.body.overage = 3296;   //planSize : 500
                            // usageDetails.body.overage = 2772;   //planSize : 1024
                            // usageDetails.body.overage = 1748;   //planSize : 2048
                            /*
                             usageDetails.body.subscriptionList[0].totalDataUsed = 500;
                             usageDetails.body.subscriptionList[0].dataAlert.threshold = -1;
                      
                             usageDetails.body.subscriptionList[1].totalDataUsed = 500;
                             usageDetails.body.subscriptionList[1].dataAlert.threshold = 500;
                             usageDetails.body.subscriptionList[1].dataAlert.isActive = true;
                      
                             usageDetails.body.subscriptionList[2].totalDataUsed = 1000;
                             usageDetails.body.subscriptionList[2].dataAlert.threshold = 1020;
                             usageDetails.body.subscriptionList[2].dataAlert.isActive = true;
                      
                             usageDetails.body.subscriptionList[3].totalDataUsed = 1024;
                             usageDetails.body.subscriptionList[3].dataAlert.threshold = 1050;
                             usageDetails.body.subscriptionList[3].dataAlert.isActive = true;
                      
                             usageDetails.body.subscriptionList[4].totalDataUsed = 2048;
                             usageDetails.body.subscriptionList[4].dataAlert.threshold = 2048;
                             usageDetails.body.subscriptionList[4].dataAlert.isActive = true;
                      
                             usageDetails.body.subscriptionList[5].totalDataUsed = 48;
                             usageDetails.body.subscriptionList[5].dataAlert.threshold = 250;
                             usageDetails.body.subscriptionList[5].dataAlert.isActive = true;
                             */
                            /* PCR 28 scenario for cetfdm14
                             usageDetails.body.overage = 1;
                             usageDetails.body.subscriptionList[0].totalDataUsed = 2861;
                      
                             usageDetails.body.isAllowedToPurchaseData = false;
                             usageDetails.body.dataPurchaseList.push({
                             cost: 800,
                             description: 'Data Top-Up 300MB',
                             descriptionFr: 'Réapprovisionn données -300 Mo',
                             id: 'UPSPRA00T',
                             size: 300
                             });
                      
                             usageDetails.body.dataPurchaseList.push({
                             cost: 900,
                             description: 'Data Top-Up 300MB',
                             descriptionFr: 'Réapprovisionn données -300 Mo',
                             id: 'UPSPRA00T',
                             size: 300
                             });
                      
                             */
                            //////////
                            var dataBucketNotAvailable = usageDetails.body.bucketSizeUnavailableUntilNextBillCycle;
                            var totalDataUsed = 0;
                            model.bucketSizeUnavailableUntilNextBillCycle = usageDetails.body.bucketSizeUnavailableUntilNextBillCycle;
                            model.dataUsageMayBeInaccurateDueToPlanChange = usageDetails.body.dataUsageMayBeInaccurateDueToPlanChange;
                            model.prorationError = usageDetails.body.prorationError;
                            model.totalDataUsage = usageDetails.body.totalDataUsage;
                            var translationKey = 'ute.dataManager.runtimeTranslation.planName';
                            _this.runtimeTranslateService.addTranslation('en', translationKey, usageDetails.body.planName);
                            _this.runtimeTranslateService.addTranslation('fr', translationKey, usageDetails.body.planNameFr);
                            model.planName = translationKey;
                            model.isAllowedToPurchaseData = usageDetails.body.isAllowedToPurchaseData;
                            model.dataLimit = usageDetails.body.planSize;
                            model.overage = usageDetails.body.overage;
                            model.remaining = usageDetails.body.remaining;
                            model.alertsRecipientCTN = usageDetails.body.dataManagerTelephoneNumber === '' ? null : usageDetails.body.dataManagerTelephoneNumber;
                            var searchIndex = _.findIndex(usageDetails.body.subscriptionList, {
                                isPrimaryCtn: true
                            });
                            try {
                                model.primaryCTN = usageDetails.body.subscriptionList[searchIndex].subscriptionNumber;
                            }
                            catch (error) {
                                throw 'ERROR : No primary CTN found.';
                            }
                            var nextStartDate = usageDetails.body.billCycle.nextStartDate;
                            var startDate = usageDetails.body.billCycle.startDate;
                            var endDate = usageDetails.body.billCycle.endDate;
                            var effectiveDate = _.get(usageDetails, 'body.planEffectiveDate', null);
                            _this.setIsFirstCycleAfterPpcInStorage(effectiveDate, nextStartDate);
                            model.billCycle.nextStartDate.month = nextStartDate.getMonth();
                            model.billCycle.nextStartDate.day = nextStartDate.getDate();
                            model.billCycle.startDate.month = startDate.getMonth();
                            model.billCycle.startDate.day = startDate.getDate();
                            model.billCycle.endDate.month = endDate.getMonth();
                            model.billCycle.endDate.day = endDate.getDate();
                            model.billCycle.daysUntilEndDate = usageDetails.body.billCycle.daysUntilEndDate;
                            model.increaseDataPurchases = [];
                            for (var iPurchase = 0; iPurchase < usageDetails.body.dataPurchaseList.length; iPurchase++) {
                                var productPurchase = usageDetails.body.dataPurchaseList[iPurchase];
                                var transformedProduct = _this.transformPurchaseProduct(productPurchase);
                                var searchIndex = _.findIndex(model.increaseDataPurchases, {
                                    amount: transformedProduct.amount,
                                    value: transformedProduct.value
                                });
                                if (searchIndex > -1) {
                                    model.increaseDataPurchases[searchIndex].multiplier++;
                                }
                                else {
                                    model.increaseDataPurchases.push(transformedProduct);
                                }
                            }
                            if ((_this.$stateParams.id === 'true') && (_this.$state.current.name === _this.getSecondEntryState())) {
                                model.isDataAlertsOpen = true;
                            }
                            model.dataControlList = [];
                            if (usageDetails.body.subscriptionList.length === 0) {
                                throw 'ERROR : Empty subscriptionList detected.';
                            }
                            for (var iSubscription = 0; iSubscription < usageDetails.body.subscriptionList.length; iSubscription++) {
                                var subscription = usageDetails.body.subscriptionList[iSubscription];
                                model.dataControlList.push({
                                    displayName: subscription.subscriberName.firstName,
                                    ctn: subscription.subscriptionNumber,
                                    colorCode: _this.config.basic.colorHexGuide[iSubscription],
                                    dataUsed: subscription.totalDataUsed,
                                    dataAlertAt: subscription.dataAlert.threshold,
                                    savedAlertValue: subscription.dataAlert.threshold,
                                    alertMoved: !(subscription.dataAlert.threshold === -1),
                                    isAllowedToBeDataManager: subscription.isAllowedToBeDataManager,
                                    hasData: subscription.isSharingData,
                                    useAlert: subscription.dataAlert.isActive,
                                    dataAccess: !subscription.isDataAccessBlocked,
                                    status: subscription.status.toLowerCase(),
                                    groupStatus: subscription.status.toLowerCase() !== StatusCode.ACTIVE ? GroupStatusCode.ACTIVE : subscription.groupStatus.toUpperCase(),
                                    videoQualityReduced: !!subscription.videoQualityReduced
                                });
                                if (dataBucketNotAvailable || usageDetails.body.prorationError) {
                                    totalDataUsed += subscription.totalDataUsed;
                                }
                            }
                            if (dataBucketNotAvailable || usageDetails.body.prorationError) {
                                model.dataLimit = totalDataUsed;
                            }
                            else {
                                model.dataLimit = usageDetails.body.planSize;
                            }
                            model.usageReportingDelay = usageDetails.body.usageReportingDelay;
                            model.infoBlock = [];
                            _this.setIsInfinitePlanInStorage(usageDetails.body.planName)
                                .then(function (isInfinitePlan) {
                                if (usageDetails.body.dataUsageMayBeInaccurateDueToPlanChange && !isInfinitePlan) {
                                    var messageHead = 'ute.dataManager.info.limitedDataHeader';
                                    var messageBody = 'ute.dataManager.info.limitedDataBody';
                                    model.infoBlock.push({
                                        blockShow: true,
                                        blockType: 'error',
                                        blockIcon: 'rui-icon-error',
                                        blockMessage: {
                                            messageHead: messageHead,
                                            messageBody: messageBody
                                        },
                                        liveChat: false
                                    });
                                }
                                if (usageDetails.body.bucketSizeUnavailableUntilNextBillCycle && !isInfinitePlan) {
                                    var messageHead = 'ute.dataManager.error.bucketSizeUnavailableHeader';
                                    var messageBody = 'ute.dataManager.error.bucketSizeUnavailableBody';
                                    model.infoBlock.push({
                                        blockShow: true,
                                        blockType: 'error',
                                        blockIcon: 'rui-icon-error',
                                        blockMessage: {
                                            messageHead: messageHead,
                                            messageBody: messageBody
                                        },
                                        liveChat: false
                                    });
                                }
                                if (usageDetails.body.isPlanChanged && !isInfinitePlan) {
                                    var messageHead = 'ute.dataManager.info.planChangeDataHeader';
                                    var messageBody = 'ute.dataManager.info.planChangeDataBody';
                                    model.infoBlock.push({
                                        blockShow: true,
                                        blockType: 'notification',
                                        blockIcon: 'rui-icon-error',
                                        blockMessage: {
                                            messageHead: messageHead,
                                            messageBody: messageBody
                                        },
                                        liveChat: false
                                    });
                                }
                                if (usageDetails.body.prorationError && !isInfinitePlan) {
                                    var messageHead = 'ute.dataManager.error.prorationErrorHeader';
                                    var messageBody = 'ute.dataManager.error.prorationErrorBody';
                                    model.infoBlock.push({
                                        blockShow: true,
                                        blockType: 'notification',
                                        blockIcon: 'rui-icon-info',
                                        blockMessage: {
                                            messageHead: messageHead,
                                            messageBody: messageBody
                                        },
                                        liveChat: false
                                    });
                                }
                            });
                            model.isPlanChanged = usageDetails.body.isPlanChanged;
                            model.planUpsellSize = usageDetails.body.planUpsellSize;
                            var activeTabCTN = model.badgeList.selectedCTN;
                            var searchCTNIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: activeTabCTN
                            });
                            if (searchCTNIndex === -1) {
                                activeTabCTN = model.dataControlList[0].ctn;
                            }
                            function isTabDisabled(ctn) {
                                var index = _.findIndex(model.dataControlList, { ctn: ctn }), isLeftGroup = model.dataControlList[index].groupStatus === GroupStatusCode.LEFT, isCancelled = (model.dataControlList[index].status === StatusCode.CANCELLED), badgeList = model.badgeList.subscriberList, searchIndex = _.findIndex(badgeList, {
                                    ctn: ctn
                                });
                                var isBadgeSubStatusSuspended = false;
                                if (badgeList[searchIndex]) {
                                    isBadgeSubStatusSuspended = (badgeList[searchIndex].subStatus === 'Suspended');
                                }
                                return (isLeftGroup || isCancelled || isBadgeSubStatusSuspended);
                            }
                            //TODO: uncomment this individualSummaryCTN-FIX -- for web alpha
                            // model.individualSummaryCTN = model.individualSummaryCTN === null ? model.dataControlList[model.activeTabIndex].ctn.toString() : model.individualSummaryCTN;
                            if (isTabDisabled(activeTabCTN)) {
                                for (var iCTN = 0; iCTN < model.dataControlList.length; iCTN++) {
                                    if (!isTabDisabled(model.dataControlList[iCTN].ctn)) {
                                        model.activeTabIndex = iCTN;
                                        //TODO: uncomment this individualSummaryCTN-FIX -- for web alpha
                                        // model.individualSummaryCTN = model.dataControlList[iCTN].ctn.toString();
                                        break;
                                    }
                                }
                            }
                            model.accountsSummaryChart.displayTicks = _this.getAccountsSummaryChartData(model.dataLimit, usageDetails.body.planUpsellSize, usageDetails.body.overage);
                            model.loadComplete = true;
                            //TESTING OVERRIDES
                            ///////////////////
                            return model;
                        };
                        this.setIsFirstCycleAfterPpcInStorage = function (effectiveDate, nextStartDate) {
                            try {
                                var effectiveDateMomentObj = moment(effectiveDate);
                                var nextBillDateMomentObj = moment(nextStartDate);
                                if (effectiveDateMomentObj.isValid() && nextBillDateMomentObj.isValid()) {
                                    var effectiveDateMomentObjPlus1Month = moment(effectiveDate).add(1, 'M');
                                    _this.isFirstCycleAfterPpc = nextBillDateMomentObj.isSame(effectiveDateMomentObj) ||
                                        nextBillDateMomentObj.isSame(effectiveDateMomentObjPlus1Month) ||
                                        nextBillDateMomentObj.isBetween(effectiveDateMomentObj, effectiveDateMomentObjPlus1Month);
                                }
                                else {
                                    _this.isFirstCycleAfterPpc = false;
                                }
                            }
                            catch (error) {
                                _this.isFirstCycleAfterPpc = false;
                            }
                        };
                        this.setIsInfinitePlanInStorage = function (currentPlan) {
                            var deferred = _this.$q.defer();
                            try {
                                var timestamp = +new Date();
                                var url = '/web/totes/cms/content/json/speedpass.json?v=' + timestamp;
                                var infiniteString_1 = 'Infinite';
                                var isInfinitePlan_1 = false;
                                _this.$http.get(url, {
                                    cache: false,
                                    withCredentials: false
                                }).then(function (res) {
                                    infiniteString_1 = _.get(res, 'data.speedpass.name', 'Infinite');
                                    if (currentPlan.toLowerCase().indexOf(infiniteString_1.toLowerCase()) !== -1) {
                                        isInfinitePlan_1 = true;
                                    }
                                    sessionStorage.setItem('isInfinitePlan', JSON.stringify(isInfinitePlan_1));
                                    deferred.resolve(isInfinitePlan_1);
                                }).catch(function () {
                                    if (currentPlan.toLowerCase().indexOf(infiniteString_1.toLowerCase()) !== -1) {
                                        isInfinitePlan_1 = true;
                                    }
                                    sessionStorage.setItem('isInfinitePlan', JSON.stringify(isInfinitePlan_1));
                                    deferred.resolve(isInfinitePlan_1);
                                });
                            }
                            catch (err) {
                                sessionStorage.setItem('isInfinitePlan', JSON.stringify(false));
                                deferred.resolve(false);
                            }
                            return deferred.promise;
                        };
                        /**
                         *
                         * @returns {any}
                         *
                         */
                        //private accountOverviewAPI: () => void = () => {
                        this.accountOverviewAPI = function () {
                            var request = {
                                'applicationId': _this.getConfig().basic.applicationId,
                                'refresh': true
                            };
                            //this.model = this.transformAccountOverview(this.mockAccountOverviewResponse, this.model);
                            var requestUrl = _this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerAccountOverviewAPI);
                            if (_this.useMockData) {
                                requestUrl = 'ute-data-manager/assets/mockFDMAccountOverview.json';
                            }
                            return _this.$http.post(requestUrl, request)
                                .then(_this.processAccountOverviewCallOk)
                                .catch(_this.processAccountOverviewError)
                                .finally(_this.finaliseAccountOverviewCall);
                        };
                        this.processAccountOverviewCallOk = function (response) {
                            return true;
                        };
                        this.processAccountOverviewError = function (error) {
                            return false;
                        };
                        this.finaliseAccountOverviewCall = function () {
                            //bCallEnded = true;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        //private summaryAPI: () => void = () => {
                        // return this.accountOverviewService.getAccountOverview()
                        //   .then<IAccountOverview>(this.accountOverviewDataHandler)
                        //   .catch<IAccountOverview>((reason: any) => {
                        //   console.log('AccountOverviewDemoController->getAccountOverview->catch:', reason);
                        this.resetLoadComplete = function () {
                            _this.model.loadComplete = false;
                        };
                        this.summaryMockAPI = function () {
                            var request = {
                                accountNumber: _this.model.accountNumber,
                                accountTypeNumber: 6,
                                language: _this.$translate.use(),
                                refresh: true,
                                applicationId: _this.getConfig().basic.applicationId
                            };
                            var requestUrl = _this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSummaryAPI);
                            var call;
                            if (_this.useMockData) {
                                requestUrl = 'ute-data-manager/assets/mockFDMSummary.json';
                                call = _this.$http.get(requestUrl);
                            }
                            else {
                                call = _this.$http.post(requestUrl, request);
                            }
                            return call
                                .then(_this.processSummaryCallOk)
                                .catch(_this.processSummaryError)
                                .finally(_this.finaliseSummaryCall);
                        };
                        this.processSummaryCallOk = function (response) {
                            return response.data;
                        };
                        this.processSummaryError = function (error) {
                            return false;
                        };
                        this.finaliseSummaryCall = function () {
                            //bCallEnded = true;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        this.usageDetailsAPI = function () {
                            var accountNum = _this.$window.localStorage.getItem('accountNumber');
                            if (_this.isCare()) {
                                accountNum = _this.$window.sessionStorage.getItem('accountNumber');
                            }
                            //FOR MOCK DATA ONLY
                            var request = {
                                serviceType: _this.getConfig().basic.serviceType,
                                accountNumber: accountNum //TODO: Use encryption string for accountNumber when account overview refactored properly
                            };
                            var requestUrl = _this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerGetUsageDetailsAPI);
                            var call;
                            if (_this.useMockData) {
                                requestUrl = 'ute-data-manager/assets/mockFDMGetUsageDetails.json';
                                call = _this.$http.get(requestUrl);
                            }
                            else {
                                call = _this.$http.post(requestUrl, request);
                            }
                            return call.then(_this.processUsageDetailsCallOk)
                                .catch(_this.processUsageDetailsError)
                                .finally(_this.finaliseUsageDetailsCall);
                        };
                        this.processUsageDetailsCallOk = function (response) {
                            response.data.body.billCycle.nextStartDate = new Date(response.data.body.billCycle.nextStartDate);
                            response.data.body.billCycle.startDate = new Date(response.data.body.billCycle.startDate);
                            response.data.body.billCycle.endDate = new Date(response.data.body.billCycle.endDate);
                            _this.setModel(_this.transformUsageDetails(response.data, _this.getModel()));
                            _this.getDataProductsAPI();
                            return true;
                        };
                        this.processUsageDetailsError = function (error) {
                            if (!_this.useMockData) {
                                _this.setStateToErrorPage();
                            }
                        };
                        this.finaliseUsageDetailsCall = function () {
                            //bCallEnded = true;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        //private getDataProductsAPI: () => any = () => {
                        this.getDataProductsAPI = function () {
                            _this.isGetDataProductsCallInProgress = true;
                            var request = {
                                provinceCode: _this.model.province,
                                accountNumber: _this.model.accountNumber
                            };
                            var requestUrl = _this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerGetDataProductsAPI);
                            var call;
                            if (_this.useMockData) {
                                requestUrl = 'ute-data-manager/assets/mockFDMDataProducts.json';
                                call = _this.$http.get(requestUrl);
                            }
                            else {
                                call = _this.$http.post(requestUrl, request);
                            }
                            return call.then(_this.processGetDataProductsCallOk)
                                .catch(_this.processGetDataProductsError)
                                .finally(_this.finaliseGetDataProductsCall);
                        };
                        this.processGetDataProductsCallOk = function (response) {
                            if (response.data.error) {
                                return false;
                            }
                            else {
                                _this.setModel(_this.transformDataProducts(response.data, _this.getModel()));
                                return true;
                            }
                        };
                        this.processGetDataProductsError = function (error) {
                            _this.model.increaseDataOptions = [];
                            return false;
                        };
                        this.finaliseGetDataProductsCall = function () {
                            //bCallEnded = true;
                            _this.isGetDataProductsCallInProgress = false;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        this.setDataAlertAPI = function (ctn, alertOn, alertThreshold) {
                            var request = {
                                serviceType: _this.config.basic.serviceType,
                                channelId: _this.config.basic.channelId,
                                medium: _this.config.basic.medium,
                                accountNumber: _this.model.accountNumber,
                                telephoneNumber: ctn,
                                isAlertOn: alertOn,
                                alertThreshold: alertThreshold
                            };
                            _this.saveAlertCallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSetAlertAPI), request)
                                .then(_this.processSetAlertCallOk)
                                .catch(_this.processSetAlertError)
                                .finally(_this.finaliseSetAlertCall);
                        };
                        this.processSetAlertCallOk = function (response) {
                            return response;
                        };
                        this.processSetAlertError = function (error) {
                            return error;
                        };
                        this.finaliseSetAlertCall = function () {
                            _this.saveAlertCallInProgress = false;
                        };
                        /**
                         *
                         * @returns {any}
                         */
                        this.setDataManagerAPI = function (ctn) {
                            var request = {
                                serviceType: _this.config.basic.serviceType,
                                channelId: _this.config.basic.channelId,
                                medium: _this.config.basic.medium,
                                accountNumber: _this.model.accountNumber,
                                telephoneNumber: ctn
                            };
                            _this.isSetDataManagerAPICallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSetDataManagerAPI), request)
                                .then(_this.processSetDataManagerCallOk)
                                .catch(_this.processSetShareEverythingError)
                                .finally(_this.finaliseSetDataManagerCall);
                        };
                        this.processSetDataManagerCallOk = function (response) {
                            return response;
                        };
                        this.processSetShareEverythingError = function (error) {
                            return error;
                        };
                        this.finaliseSetDataManagerCall = function () {
                            _this.isSetDataManagerAPICallInProgress = false;
                        };
                        // Load data from temporray text file and prepare for directive consumption
                        this.setBlockAPI = function (ctn, setAccess) {
                            var request = {
                                serviceType: _this.config.basic.serviceType,
                                channelId: _this.config.basic.channelId,
                                medium: _this.config.basic.medium,
                                accountNumber: _this.model.accountNumber,
                                telephoneNumber: ctn,
                                isDataAccessBlocked: setAccess
                            };
                            _this.isSetBlockAPICallInProgress = true;
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSetBlockAPI), request)
                                .then(_this.processSetBlockCallOk)
                                .catch(_this.processSetBlockCallError)
                                .finally(_this.finalizeSetBlockCall);
                        };
                        this.processSetBlockCallOk = function (response) {
                            return response;
                        };
                        this.processSetBlockCallError = function (error) {
                            return error;
                        };
                        this.finalizeSetBlockCall = function () {
                            _this.isSetBlockAPICallInProgress = false;
                        };
                        // Load data from temporray text file and prepare for directive consumption
                        this.purchaseDataProductAPI = function (productIndex) {
                            var product = _this.model.increaseDataOptions[productIndex];
                            var request = {
                                serviceType: _this.config.basic.serviceType,
                                channelId: _this.config.basic.channelId,
                                medium: _this.config.basic.medium,
                                accountNumber: _this.model.accountNumber,
                                telephoneNumber: _this.model.primaryCTN,
                                socId: product.socID,
                                socPriceInCents: product.value,
                                socDescription: product.socDescription,
                                direction: 'Inbound'
                            };
                            _this.isPurchaseDataProductAPICallInProgress = true;
                            if (_this.useMockData) {
                                return _this.$http.get('ute-data-manager/assets/purchaseDataProductAPI.json?t=' + Date.now())
                                    .then(_this.setWcocConsentSuccess)
                                    .catch(_this.setWcocConsentError);
                            }
                            else {
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerPurchaseDataAPI), request)
                                    .then(_this.processPurchaseDataProductCallOk)
                                    .catch(_this.processPurchaseDataProductError)
                                    .finally(_this.finalisePurchaseDataProductCall);
                            }
                        };
                        this.processPurchaseDataProductCallOk = function (response) {
                            return response;
                        };
                        this.processPurchaseDataProductError = function (error) {
                            return error;
                        };
                        this.finalisePurchaseDataProductCall = function () {
                            _this.isPurchaseDataProductAPICallInProgress = false;
                        };
                        /**
                         * Calculate the incremental Step based on data plan limit
                         */
                        this.getSliderStep = function () {
                            /**
                             * Find match setting with dataLimit between dataLimitMin and dataLimitMax
                             */
                            var _dataLimit = _this.model.dataLimit;
                            var matchedSetting = _.find(_this.getConfig().advanced.dataPlanIncrementFactors, function (setting) {
                                return setting.dataLimitMax >= _dataLimit && setting.dataLimitMin <= _dataLimit;
                            });
                            if (!angular.isUndefined(matchedSetting)) {
                                return matchedSetting.incrementStep;
                            }
                            /**
                             * If setting not found from the configuration return 1mb as default
                             */
                            return 1;
                        };
                        this.getIsVideoQualityAPICallInProgress = function () {
                            return _this.isVideoQualityAPICallInProgress;
                        };
                        this.setIsVideoThrottlePermitted = function () {
                            _this.isVideoQualityAPICallInProgress = true;
                            var key = ute.common.permissions.service.UserPermissions.FDM_VIDEOTHROTTLE;
                            _this.permissionsService.getUserPermission(key).then(function (isPermitted) {
                                _this.model.isVideoThrottlePermitted = isPermitted;
                                _this.isVideoQualityAPICallInProgress = false;
                            });
                        };
                        this.getIsVideoThrottlePermitted = function () {
                            return !!_this.model.isVideoThrottlePermitted;
                        };
                        this.setDataManagerActiveTabIndex = function (index) {
                            _this.model.dataManagerActiveTabIndex = index;
                        };
                        this.getDataManagerActiveTabIndex = function () {
                            return _this.model.dataManagerActiveTabIndex ? _this.model.dataManagerActiveTabIndex : 0;
                        };
                        this.setDataAlertsActiveTabIndex = function (index) {
                            _this.model.dataAlertsActiveTabIndex = index;
                        };
                        this.getDataAlertsActiveTabIndex = function () {
                            return _this.model.dataAlertsActiveTabIndex ? _this.model.dataAlertsActiveTabIndex : 0;
                        };
                        this.setVideoQualityReducedCTN = function (ctn, videoQualityReduced) {
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            if (searchIndex >= 0) {
                                _this.model.dataControlList[searchIndex].videoQualityReduced = videoQualityReduced;
                            }
                        };
                        this.getVideoQualityReducedCTN = function (ctn) {
                            // Find the item by CTN
                            var searchIndex = _.findIndex(_this.model.dataControlList, {
                                ctn: ctn
                            });
                            return _this.model.dataControlList[searchIndex].videoQualityReduced;
                        };
                        this.setVideoQualityAPI = function (ctn, videoQualityReduced) {
                            var request = {
                                serviceType: _this.config.basic.serviceType,
                                channelId: _this.config.basic.channelId,
                                medium: _this.config.basic.medium,
                                accountNumber: _this.model.accountNumber,
                                telephoneNumber: ctn,
                                reduceVideoQuality: videoQualityReduced
                            };
                            var call;
                            if (_this.useMockData) {
                                call = _this.$http.get('ute-data-manager/assets/setVideoQualityAPI.json')
                                    .then(_this.processSetVideoQualityCallOk)
                                    .catch(_this.processSetVideoQualityCallError);
                            }
                            else {
                                call = _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSetVideoQualityAPI), request)
                                    .then(_this.processSetVideoQualityCallOk)
                                    .catch(_this.processSetVideoQualityCallError);
                            }
                            return call;
                        };
                        this.processSetVideoQualityCallOk = function (response) {
                            return response;
                        };
                        this.processSetVideoQualityCallError = function (error) {
                            return error;
                        };
                        this.fetchConfirmationModalPreference = function () {
                            var url = _this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerGetConfirmationModalPreferenceAPI);
                            url = url + '?brand=' + _this.getConfig().basic.brand;
                            if (_this.useMockData) {
                                url = 'ute-data-manager/assets/getUserShowScreenPref.json';
                            }
                            _this.$http.get(url)
                                .then(_this.processFetchConfirmationModalPreferenceCallOk)
                                .catch(_this.processFetchConfirmationModalPreferenceCallError);
                        };
                        this.processFetchConfirmationModalPreferenceCallOk = function (response) {
                            var screenName = _.find(response.data.screenNames, function (sn) {
                                return sn.screenNameId === 'VIDEO_TROTTLE_POPUP';
                            });
                            if (screenName === undefined) {
                                _this.model.doNotShowVideoThrottleConfirmationModal = true;
                            }
                        };
                        this.processFetchConfirmationModalPreferenceCallError = function (error) {
                            _this.model.doNotShowVideoThrottleConfirmationModal = false;
                        };
                        this.getShowVideoThrottleConfirmationModalPref = function () {
                            return !_this.model.doNotShowVideoThrottleConfirmationModal;
                        };
                        this.setShowVideoThrottleConfirmationModalPref = function (doNotShowModal) {
                            var request = {
                                'screenNameId': 'VIDEO_TROTTLE_POPUP',
                                'interactionState': doNotShowModal === true ? 'DO_NOT_SHOW' : 'SHOW'
                            };
                            var call;
                            var self = _this;
                            if (_this.useMockData) {
                                call = _this.$http.get('ute-data-manager/assets/setUserShowScreenPref.json')
                                    .then(function (response) {
                                    self.model.doNotShowVideoThrottleConfirmationModal = doNotShowModal;
                                })
                                    .catch(_this.processConfirmationModalPreferenceCallError);
                            }
                            else {
                                call = _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.dataManagerSetConfirmationModalPreferenceAPI), request)
                                    .then(function (response) {
                                    self.model.doNotShowVideoThrottleConfirmationModal = doNotShowModal;
                                })
                                    .catch(_this.processConfirmationModalPreferenceCallError);
                            }
                            return call;
                        };
                        this.processConfirmationModalPreferenceCallError = function (error) {
                            _this.model.doNotShowVideoThrottleConfirmationModal = false;
                            return null;
                        };
                        /**
                         * Start: FDM WCoC PCR
                         */
                        this.getWcocConsentCallInProgress = function () {
                            return _this.isWcocConsentCallInProgress;
                        };
                        this.setIsFdmWcocPermitted = function () {
                            _this.isWcocConsentCallInProgress = true;
                            var key = ute.common.permissions.service.UserPermissions.WCOC_FDM_PCR9;
                            _this.permissionsService.getUserPermission(key).then(function (isPermitted) {
                                _this.model.isFdmWcocPermitted = isPermitted;
                                _this.isWcocConsentCallInProgress = false;
                            });
                        };
                        this.getIsFdmWcocPermitted = function () {
                            return !!_this.model.isFdmWcocPermitted;
                        };
                        /**
                         * generateWCoCToken - Generate token using WCOC mock data api.
                         * @param  {string} accNumber.
                         * @param  {string} ctn.
                         */
                        this.generateWcocToken = function (accNumber, ctn) {
                            var request = {
                                ban: accNumber,
                                ctn: ctn
                            };
                            _this.isWcocConsentCallInProgress = true;
                            if (_this.useMockData) {
                                return _this.$http.get('ute-data-manager/assets/generateWcocToken.json')
                                    .then(_this.generateWcocTokenSuccess)
                                    .catch(_this.generateWcocTokenError);
                            }
                            else {
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.generateWcocToken), request)
                                    .then(_this.generateWcocTokenSuccess)
                                    .catch(_this.generateWcocTokenError);
                            }
                        };
                        this.generateWcocTokenSuccess = function (response) {
                            return response;
                        };
                        this.generateWcocTokenError = function (error) {
                            _this.isWcocConsentCallInProgress = false;
                            return error;
                        };
                        /**
                         * setWCOCConsent - Set WCCC consent using WCoC mock data api.
                         * @param  {string} accNumber: Account number
                         * @param  {string} dConsent
                         * @param  {string} token
                         */
                        this.setWcocConsent = function (accNumber, dConsent, token) {
                            var payload = {
                                ban: accNumber,
                                dConsent: dConsent
                            };
                            var config = {
                                headers: {
                                    'x-app-id': 'UTEWCOC',
                                    'JWT': token
                                }
                            };
                            if (_this.useMockData) {
                                return _this.$http.get('ute-data-manager/assets/setWcocConsent.json')
                                    .then(_this.setWcocConsentSuccess)
                                    .catch(_this.setWcocConsentError);
                            }
                            else {
                                return _this.$http.post(_this.getConfig().basic.setWcocConsent, payload, config)
                                    .then(_this.setWcocConsentSuccess)
                                    .catch(_this.setWcocConsentError);
                            }
                        };
                        this.setWcocConsentSuccess = function (response) {
                            _this.isWcocConsentCallInProgress = false;
                            return response;
                        };
                        this.setWcocConsentError = function (error) {
                            _this.isWcocConsentCallInProgress = false;
                            return error;
                        };
                        /**
                         * End: FDM WCoC PCR
                         */
                        //Analytics data layer.
                        this.getDataLayerEvent = function () {
                            return _this.dataLayerEvent;
                        };
                        this.getDataLayerStep = function () {
                            return _this.dataLayerStep;
                        };
                        this.getTotalDataLimit = function () {
                            return _this.getDataLimit() + _this.getAddedExtraData();
                        };
                        this.trackDataLayerInteraction = function (trackingStep, trackingEvent, errorInfo, ctn) {
                            try {
                                var self_1 = _this;
                                //Load data layer configuration object.
                                _this.dataLayerConfig = _this.uteDataManagerAnalyticsConfigService.loadDataLayerConfig().uteDataLayerTracking;
                                var dataLayerPayloadConfig = {
                                    selfServe: '',
                                    page: '',
                                    event: '',
                                    interaction: ''
                                };
                                // set data layer events for interactions.
                                // trackingStep value would be start or complete or error.
                                switch (trackingStep) {
                                    case self_1.dataLayerStep.start:
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.start;
                                        break;
                                    case self_1.dataLayerStep.complete:
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.complete;
                                        break;
                                    default:
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.error;
                                }
                                // set data layer self serve method type for interactions.
                                // trackingStep value would be start or complete or error
                                // Expected value is 'get electronic addresses and cem preferences' or 'update cem preferences'
                                switch (trackingEvent) {
                                    case self_1.dataLayerEvent.videoThrottlingToggleON:
                                        dataLayerPayloadConfig.selfServe = self_1.dataLayerConfig.selfServe.videoThrottlingToggleON;
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.videoStreaming;
                                        break;
                                    case self_1.dataLayerEvent.videoThrottlingToggleOFF:
                                        dataLayerPayloadConfig.selfServe = self_1.dataLayerConfig.selfServe.videoThrottlingToggleOFF;
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.videoStreaming;
                                        break;
                                    case self_1.dataLayerEvent.cancelButtonInteraction:
                                        dataLayerPayloadConfig.interaction = self_1.dataLayerConfig.interactions.cancelButtonInteraction;
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.interaction;
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.viewReduceVideoQualityModal;
                                        break;
                                    case self_1.dataLayerEvent.viewReduceVideoQualityModal:
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.viewReduceVideoQualityModal;
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.pageView;
                                        break;
                                    case self_1.dataLayerEvent.viewErrorModal:
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.viewErrorModal;
                                        dataLayerPayloadConfig.event = self_1.dataLayerConfig.events.errorWithPageView;
                                        dataLayerPayloadConfig.selfServe =
                                            (_.get(errorInfo, 'event') === self_1.dataLayerEvent.videoThrottlingToggleON)
                                                ? self_1.dataLayerConfig.selfServe.videoThrottlingToggleON
                                                : self_1.dataLayerConfig.selfServe.videoThrottlingToggleOFF;
                                        break;
                                    case self_1.dataLayerEvent.viewVideoQualityTab:
                                        dataLayerPayloadConfig.selfServe = self_1.dataLayerConfig.selfServe.viewVideoQualityTab;
                                        dataLayerPayloadConfig.page = self_1.dataLayerConfig.page.videoStreaming;
                                        break;
                                    default:
                                }
                                //Set payload for data layer.
                                var payload = {
                                    page: '',
                                    selfServe: '',
                                    events: ''
                                };
                                // Cancel button event on VT confirmation pop-up.
                                if (trackingEvent === self_1.dataLayerEvent.cancelButtonInteraction) {
                                    payload = {
                                        events: dataLayerPayloadConfig.event,
                                        interaction: dataLayerPayloadConfig.interaction,
                                        page: dataLayerPayloadConfig.page
                                    };
                                }
                                else {
                                    //Views the reduce video quality or error modal payload.
                                    if (trackingEvent === self_1.dataLayerEvent.viewReduceVideoQualityModal ||
                                        trackingEvent === self_1.dataLayerEvent.viewErrorModal) {
                                        // Set payload for data layer service.
                                        payload = {
                                            site: dataLayerPayloadConfig.site,
                                            page: dataLayerPayloadConfig.page,
                                            events: dataLayerPayloadConfig.event
                                        };
                                        if (trackingEvent === self_1.dataLayerEvent.viewErrorModal) {
                                            payload.selfServe = dataLayerPayloadConfig.selfServe;
                                        }
                                    }
                                    else {
                                        //Set payload for data layer service.
                                        payload = {
                                            page: dataLayerPayloadConfig.page,
                                            selfServe: dataLayerPayloadConfig.selfServe,
                                            events: dataLayerPayloadConfig.event
                                        };
                                    }
                                }
                                // If any case api give error response then set error type with data layer paylaod.
                                if (payload.events.error || payload.events.errorWithPageView) {
                                    self_1.dataLayerConfig.errors = [
                                        {
                                            type: 'http',
                                            category: 'self serve',
                                            code: _.get(errorInfo, 'error.status.code', _.get(errorInfo, 'error.data.error.code', 'General Error Code')),
                                            message: _.get(errorInfo, 'error.status.codeName', _.get(errorInfo, 'error.data.error.message', 'General Error')),
                                            API: _this.getConfig().basic.dataManagerSetVideoQualityAPI
                                        }
                                    ];
                                    payload.errors = self_1.dataLayerConfig.errors;
                                }
                                self_1.dataLayerServiceProvider.dataLayerTrack(payload, (trackingEvent === self_1.dataLayerEvent.viewReduceVideoQualityModal ||
                                    trackingEvent === self_1.dataLayerEvent.viewErrorModal ||
                                    trackingEvent === self_1.dataLayerEvent.cancelButtonInteraction), [
                                    DataLayerPredefinedSection.ACCOUNT,
                                    DataLayerPredefinedSection.PAGE,
                                    DataLayerPredefinedSection.SITE
                                ]);
                            }
                            catch (error) {
                                console.error('data layer tracking - data manager', error);
                            }
                            return;
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$q',
                            '$stateParams',
                            '$rootScope',
                            '$window',
                            '$timeout',
                            '$translate',
                            '$compile',
                            '$filter'
                        ];
                        this.resetModel();
                        this.addCodes();
                        this.dataLayerEvent = {
                            videoThrottlingToggleON: 'video-throttling-toggle-on',
                            videoThrottlingToggleOFF: 'actv-myrogersapp-fdm-video-streaming-off',
                            cancelButtonInteraction: 'throttle-video-cancel',
                            viewReduceVideoQualityModal: 'view-reduce-video-quality-modal',
                            viewErrorModal: 'view-error-modal',
                            viewVideoQualityTab: 'view-video-quality-tab'
                        };
                        this.dataLayerStep = {
                            start: 'start',
                            complete: 'complete',
                            error: 'error'
                        };
                    }
                    DataManagerProvider.prototype.getBadgeSubStatusByCTN = function (ctn) {
                        if (this.getModel() && this.getModel().badgeList) {
                            var badgeList = this.getModel().badgeList.subscriberList;
                            var searchIndex = _.findIndex(badgeList, {
                                ctn: ctn
                            });
                            if (searchIndex > -1) {
                                return badgeList[searchIndex].subStatus;
                            }
                            else {
                                return '';
                            }
                        }
                        else {
                            return '';
                        }
                    };
                    DataManagerProvider.$inject = [
                        'ute.rogers.account.overview.factoryProvider',
                        'ute.rogers.account.overview.summary.factoryProvider'];
                    return DataManagerProvider;
                }());
                angular.module('ute.data.manager.service').provider('ute.data.manager.service', DataManagerProvider);
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

/**
 * Created by Muhammad Zubair on 6/14/2017.
 */
var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
                var UteDataManagerAnalyticsConfigService = (function () {
                    function UteDataManagerAnalyticsConfigService() {
                    }
                    UteDataManagerAnalyticsConfigService.prototype.loadDataLayerConfig = function () {
                        return this.dataLayerConfig = {
                            uteDataLayerTracking: {
                                interactions: {
                                    cancelButtonInteraction: {
                                        type: 'FDM',
                                        name: 'Throttle Video Cancel'
                                    }
                                },
                                selfServe: {
                                    videoThrottlingToggleON: {
                                        type: 'transaction',
                                        name: 'FDM video throttle - ON',
                                    },
                                    videoThrottlingToggleOFF: {
                                        type: 'transaction',
                                        name: 'FDM video throttle - OFF',
                                    },
                                    viewVideoQualityTab: {
                                        type: 'inquiry',
                                        name: 'myrogers fdm - set video quality',
                                    }
                                },
                                page: {
                                    videoStreaming: {
                                        name: 'shareeverything',
                                        hierarchy: ['myrogers']
                                    },
                                    viewReduceVideoQualityModal: {
                                        name: 'Reduce Video Quality',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    },
                                    viewErrorModal: {
                                        name: 'Error',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    }
                                },
                                events: {
                                    interaction: {
                                        interaction: true,
                                    },
                                    pageView: {
                                        pageView: true,
                                    },
                                    start: {
                                        selfServeStart: true,
                                    },
                                    complete: {
                                        selfServeComplete: true,
                                    },
                                    error: {
                                        error: true,
                                    },
                                    errorWithPageView: {
                                        error: true,
                                        pageView: true
                                    }
                                },
                                errors: [{
                                        type: 'selfServe',
                                        code: '',
                                        message: ''
                                    }]
                            }
                        };
                    };
                    ;
                    UteDataManagerAnalyticsConfigService.$inject = [];
                    return UteDataManagerAnalyticsConfigService;
                }());
                service.UteDataManagerAnalyticsConfigService = UteDataManagerAnalyticsConfigService;
                angular
                    .module('ute.data.manager.service')
                    .service('ute-data-manager-analytics-config-service', UteDataManagerAnalyticsConfigService);
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var shared;
            (function (shared) {
                var usage;
                (function (usage) {
                    var bar;
                    (function (bar) {
                        'use strict';
                        var DataManagerSharedUsageBarController = (function () {
                            /* @ngInject */
                            function DataManagerSharedUsageBarController($scope, $state, dataManagerService) {
                                this.$scope = $scope;
                                this.$state = $state;
                                this.dataManagerService = dataManagerService;
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                                this.isCare = this.dataManagerService.isCare();
                            }
                            DataManagerSharedUsageBarController.prototype.getOverage = function () {
                                return this.dataManagerService.getOverage();
                            };
                            DataManagerSharedUsageBarController.prototype.getDataControlList = function () {
                                return this.dataManagerService.getDataControlList();
                            };
                            DataManagerSharedUsageBarController.prototype.getDataLimitWithOverage = function () {
                                return this.dataManagerService.getDataLimit() + this.dataManagerService.getOverage() + this.dataManagerService.getAddedExtraData();
                            };
                            DataManagerSharedUsageBarController.prototype.getDataLimitIncBonuses = function () {
                                return this.dataManagerService.getDataLimit() + this.dataManagerService.getAddedExtraData();
                            };
                            DataManagerSharedUsageBarController.prototype.getDataLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            DataManagerSharedUsageBarController.prototype.getUsageDetailsCallInProgress = function () {
                                return this.dataManagerService.getUsageDetailsCallInProgress();
                            };
                            DataManagerSharedUsageBarController.prototype.getMidPointValue = function () {
                                return this.dataManagerService.getDataLimit() / 2;
                            };
                            DataManagerSharedUsageBarController.prototype.getBase = function () {
                                return this.dataManagerService.getConfig().basic.dataConversion;
                            };
                            DataManagerSharedUsageBarController.prototype.lineHasData = function (usageControlLine) {
                                return usageControlLine.dataUsed > 0;
                            };
                            DataManagerSharedUsageBarController.prototype.sharedUsageFilter = function (usageControlLine) {
                                return (usageControlLine.dataUsed > 0 && (usageControlLine.groupStatus !== 'JOINED_GROUP'));
                            };
                            DataManagerSharedUsageBarController.prototype.getFilteredList = function () {
                                var list = this.getDataControlList();
                                var filteredList = [];
                                for (var iItem = 0; iItem < list.length; iItem++) {
                                    if (this.sharedUsageFilter(list[iItem])) {
                                        filteredList.push(list[iItem]);
                                    }
                                }
                                return filteredList;
                            };
                            DataManagerSharedUsageBarController.prototype.getMidPointPercentage = function () {
                                /*
                                var usedData: number = this.dataManagerService.getTotalUsedData();
                                var addedExtra: number = this.dataManagerService.getAddedExtraData();
                                var dataLimit: number = this.dataManagerService.getDataLimit();
                                var indicatorValue: number = (usedData < (dataLimit + addedExtra)) ? (dataLimit + addedExtra) : Math.ceil(usedData);
                          
                                return (usedData / 2) / indicatorValue * 100;
                                */
                                var usedData = this.dataManagerService.getTotalUsedData(), addedExtra = this.dataManagerService.getAddedExtraData(), dataLimit = this.dataManagerService.getDataLimit(), maxData = Math.max(usedData, (dataLimit + addedExtra));
                                return (dataLimit / maxData * 100) / 2;
                                /*
                                
                                      this.dataManagerService.getAddedExtraData()
                                      var usedData: number = this.dataManagerService.getTotalUsedData();
                                      var dataLimit: number = this.dataManagerService.getDataLimit();
                                      var midPoint: number = this.dataManagerService.getDataLimit() / 2;
                                
                                      return (usedData < dataLimit) ? 50 : midPoint / usedData * 100;
                                */
                            };
                            DataManagerSharedUsageBarController.prototype.getLeftIndicatorValue = function () {
                                var usedData = this.dataManagerService.getTotalUsedData();
                                var addedExtra = this.dataManagerService.getAddedExtraData();
                                var dataLimit = this.dataManagerService.getDataLimit();
                                return (usedData < (dataLimit + addedExtra)) ? dataLimit : Math.ceil(usedData);
                            };
                            DataManagerSharedUsageBarController.prototype.getBaseDataLimitPosition = function () {
                                var usedData = this.dataManagerService.getTotalUsedData(), addedExtra = this.dataManagerService.getAddedExtraData(), dataLimit = this.dataManagerService.getDataLimit(), maxData = Math.max(usedData, (dataLimit + addedExtra));
                                return dataLimit / maxData * 100;
                            };
                            DataManagerSharedUsageBarController.prototype.getAddedExtraData = function () {
                                return this.dataManagerService.getAddedExtraData();
                            };
                            DataManagerSharedUsageBarController.prototype.getAddedExtraDataExists = function () {
                                return this.dataManagerService.getAddedExtraData() > 0;
                            };
                            DataManagerSharedUsageBarController.prototype.getDataLimitWithAddedExtraPercentage = function () {
                                var usedData = this.dataManagerService.getTotalUsedData(), addedExtra = this.dataManagerService.getAddedExtraData(), dataLimit = this.dataManagerService.getDataLimit(), maxData = Math.max(usedData, (dataLimit + addedExtra));
                                return (dataLimit + addedExtra) / maxData * 100;
                            };
                            DataManagerSharedUsageBarController.prototype.getIndicatorCopy = function () {
                                return this.getBaseDataLimitPosition() > 50 ? 'ute-dataManager-sharedUsageBar-indicatorCopyThird' : 'ute-dataManager-sharedUsageBar-indicatorCopyThirdLessMid';
                            };
                            DataManagerSharedUsageBarController.prototype.getTotalDataUsage = function () {
                                return this.dataManagerService.getModel().totalDataUsage;
                            };
                            DataManagerSharedUsageBarController.prototype.getSharedUsageBarTranslationKey = function () {
                                var isInfinitePlan = JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                                return isInfinitePlan ? 'ute.dataManager.sharedUsageBar.infiniteTitle' : 'ute.dataManager.sharedUsageBar.title';
                            };
                            DataManagerSharedUsageBarController.$inject = ['$scope', '$state', 'ute.data.manager.service'];
                            return DataManagerSharedUsageBarController;
                        }());
                        bar.DataManagerSharedUsageBarController = DataManagerSharedUsageBarController;
                        angular.module('ute.data.manager.shared.usage.bar').controller('ute.data.manager.shared.usage.bar.controller', DataManagerSharedUsageBarController);
                    })(bar = usage.bar || (usage.bar = {}));
                })(usage = shared.usage || (shared.usage = {}));
            })(shared = manager.shared || (manager.shared = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var shared;
            (function (shared) {
                var usage;
                (function (usage) {
                    var bar;
                    (function (bar) {
                        'use strict';
                        angular.module('ute.data.manager.shared.usage.bar').directive('uteDataManagerSharedUsageBar', uteDataManagerSharedUsageBar);
                        uteDataManagerSharedUsageBar.$inject = ['ute.data.manager.service',
                            'ute.common.utils.service'];
                        /* @ngInject */
                        function uteDataManagerSharedUsageBar(dataManagerService, utilsService) {
                            return {
                                restrict: 'E',
                                scope: {},
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerSharedUsageBarDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerSharedUsageBarDirective.controllerName,
                                controllerAs: 'dataManagerSharedUsageBar',
                                link: function (scope, element, attrs, controller) {
                                    utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                    /*
                                    
                                            scope.$watch(function(){ return controller.getMidPointPercentage(); }, function( midPoint: number ) {
                                              angular.element(element[0].getElementsByClassName('ute-dataManager-sharedUsageBar-indicator-mid')).css('left', midPoint + '%');
                                            });
                                    
                                            scope.$watch(function(){ return controller.getBaseDataLimitPosition(); }, function( limitPoint: number ) {
                                              angular.element(element[0].getElementsByClassName('ute-dataManager-sharedUsageBar-indicator-limit')).css('left', limitPoint + '%');
                                            });
                                    
                                            scope.$watch(function(){ return controller.getDataLimitWithAddedExtraPercentage(); }, function( addedExtra: number ) {
                                              angular.element(element[0].getElementsByClassName('ute-dataManager-sharedUsageBar-indicator-addedExtra')).css('left', addedExtra + '%');
                                            });
                                    */
                                }
                            };
                        }
                    })(bar = usage.bar || (usage.bar = {}));
                })(usage = shared.usage || (shared.usage = {}));
            })(shared = manager.shared || (manager.shared = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var shared;
            (function (shared) {
                var usage;
                (function (usage) {
                    var bar;
                    (function (bar) {
                        'use strict';
                        var DataManagerSharedUsageBarSegmentController = (function () {
                            /* @ngInject */
                            function DataManagerSharedUsageBarSegmentController($scope, $state, dataManagerService) {
                                this.$scope = $scope;
                                this.$state = $state;
                                this.dataManagerService = dataManagerService;
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                            }
                            DataManagerSharedUsageBarSegmentController.prototype.getDataControlList = function () {
                                return this.model.dataControlList;
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.getBase = function () {
                                return this.dataManagerService.getConfig().basic.dataConversion;
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.getLastFailSafeWidth = function (value) {
                                var list = this.getFilteredList();
                                var totalLessFinal = 0;
                                for (var iAmount = 0; iAmount < list.length - 1; iAmount++) {
                                    totalLessFinal += (list[iAmount].dataUsed / this.scope.total * 100);
                                }
                                return (value > (100 - totalLessFinal) ? (100 - totalLessFinal) : value);
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.sharedUsageFilter = function (usageControlLine) {
                                return (usageControlLine.dataUsed > 0 && (usageControlLine.groupStatus !== 'JOINED_GROUP'));
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.getFilteredList = function () {
                                var list = this.getDataControlList();
                                var filteredList = [];
                                for (var iItem = 0; iItem < list.length; iItem++) {
                                    if (this.sharedUsageFilter(list[iItem])) {
                                        filteredList.push(list[iItem]);
                                    }
                                }
                                return filteredList;
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.getUsageStyle = function () {
                                var isLast = this.scope.lastItem === 'true', dataUsedPercent = this.scope.dataUsed / this.scope.total * 100, dataUsedPercentWithFailSafe = this.getLastFailSafeWidth(dataUsedPercent);
                                return isLast ? { width: dataUsedPercentWithFailSafe + '%' } : { width: (dataUsedPercent) + '%' };
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.getUsageClass = function () {
                                return (this.scope.index === '0' ? 'ute-dataManager-sharedUsageBar-trimLeftMeter' : '');
                            };
                            DataManagerSharedUsageBarSegmentController.prototype.isUsageVisible = function () {
                                return (this.scope.dataUsed / this.scope.total * 100) >= 12;
                            };
                            DataManagerSharedUsageBarSegmentController.$inject = ['$scope', '$state', 'ute.data.manager.service'];
                            return DataManagerSharedUsageBarSegmentController;
                        }());
                        bar.DataManagerSharedUsageBarSegmentController = DataManagerSharedUsageBarSegmentController;
                        angular.module('ute.data.manager.shared.usage.bar').controller('ute.data.manager.shared.usage.bar.segment.controller', DataManagerSharedUsageBarSegmentController);
                    })(bar = usage.bar || (usage.bar = {}));
                })(usage = shared.usage || (shared.usage = {}));
            })(shared = manager.shared || (manager.shared = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var shared;
            (function (shared) {
                var usage;
                (function (usage_1) {
                    var bar;
                    (function (bar) {
                        'use strict';
                        angular.module('ute.data.manager.shared.usage.bar').directive('uteDataManagerSharedUsageBarSegment', uteDataManagerSharedUsageBarSegment);
                        uteDataManagerSharedUsageBarSegment.$inject = ['$timeout', 'ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerSharedUsageBarSegment($timeout, dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: { 'colorCode': '@', 'dataUsed': '@', 'dataLimit': '@', 'index': '@', 'totalLines': '@', 'lastItem': '@' },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerSharedUsageBarSegmentDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerSharedUsageBarSegmentDirective.controllerName,
                                controllerAs: 'dataManagerSharedUsageBarSegment',
                                link: function (scope, element, attrs, controller) {
                                    scope.$watch('colorCode', function (newValue) {
                                        var usageBar = angular.element(element[0].getElementsByClassName('ute-dataManager-sharedUsageBar-usage'));
                                        usageBar.css('backgroundColor', newValue);
                                    });
                                    var usage = angular.element(element[0].getElementsByClassName('ute-dataManager-sharedUsageBar-usage'));
                                    usage.css('width', '1%');
                                    usage.css('opacity', '0');
                                    var totalUsed;
                                    var dataLimit;
                                    scope.total = 0;
                                    scope.$watch(function () { return dataManagerService.getAddedExtraData(); }, function (addedExtras, oldAddedExtras) {
                                        if (addedExtras !== oldAddedExtras) {
                                            scope.total = ((totalUsed > (dataLimit + addedExtras)) ? totalUsed : (dataLimit + addedExtras));
                                            usage.css('width', (scope.dataUsed / scope.total * 100) + '%');
                                            updateSegmentWidth(addedExtras);
                                        }
                                    });
                                    scope.total = ((dataManagerService.getTotalUsedData() > (dataManagerService.getDataLimit() + dataManagerService.getAddedExtraData())) ? dataManagerService.getTotalUsedData() : (dataManagerService.getDataLimit() + dataManagerService.getAddedExtraData()));
                                    $timeout(function () {
                                        usage.css('width', (scope.dataUsed / scope.total * 100) + '%');
                                    }, 1);
                                    usage.css('opacity', '1');
                                    function updateSegmentWidth(addedExtras) {
                                        var list = controller.getFilteredList();
                                        totalUsed = dataManagerService.getTotalUsedData();
                                        dataLimit = dataManagerService.getDataLimit();
                                        scope.total = ((totalUsed > (dataLimit + addedExtras)) ? totalUsed : (dataLimit + addedExtras));
                                        if ((scope.index * 1) === list.length - 1) {
                                            if (totalUsed > (dataLimit + addedExtras)) {
                                                usage.css('border-top-right-radius', '5px');
                                            }
                                        }
                                        if ((scope.index * 1) === 0) {
                                            usage.css('border-top-left-radius', '5px');
                                        }
                                    }
                                    updateSegmentWidth(dataManagerService.getAddedExtraData());
                                }
                            };
                        }
                    })(bar = usage_1.bar || (usage_1.bar = {}));
                })(usage = shared.usage || (shared.usage = {}));
            })(shared = manager.shared || (manager.shared = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                'use strict';
                var DataManagerTabsController = (function () {
                    /* @ngInject */
                    function DataManagerTabsController($scope, $state, $rootScope, $window, $filter, dataManagerService, dataManagerSeeService, languageService) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$state = $state;
                        this.$rootScope = $rootScope;
                        this.$window = $window;
                        this.$filter = $filter;
                        this.dataManagerService = dataManagerService;
                        this.dataManagerSeeService = dataManagerSeeService;
                        this.languageService = languageService;
                        this.updateModel = function (summary) {
                            _this.dataManagerService.clearDataControlList();
                            _this.dataManagerService.setModel(_this.dataManagerService.transformSummary(summary, _this.dataManagerService.getModel()));
                            return null;
                        };
                        this.model = this.dataManagerService.getModel();
                        this.rootScope = $rootScope;
                        this.window = $window;
                        // SEE project implementation
                        dataManagerSeeService.getSeeBrtShowState().then(function (showState) {
                            if (showState) {
                                if (_this.dataManagerSeeService.tabAccountLinks && _this.dataManagerSeeService.tabAccountLinks.length) {
                                    _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                }
                                else {
                                    _this.dataManagerService.getAccountStatus().then(function (accountOverview) {
                                        if (accountOverview.getSelectedAccount().accountStatus && accountOverview.getSelectedAccount().accountStatus.toLowerCase() === 'active') {
                                            _this.dataManagerSeeService.addTabLink(_this.dataManagerService.getDataControlList()).then(function () {
                                                _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                            });
                                        }
                                    });
                                }
                            }
                        });
                        this.dataManagerService.getSummaryWorker().then(function (worker) {
                            return worker.registerOnDataChangeHandler(_this.updateModel, DataManagerTabsController.controllerName);
                        });
                        this.$scope.$on('$destroy', function () {
                            return _this.dataManagerService.getSummaryWorker().then(function (worker) {
                                return worker.unregisterOnDataChangeHandler(DataManagerTabsController.controllerName);
                            });
                        });
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.dataManagerSeeService.tabAccountLinks = [];
                            _this.seeLinks = [];
                            _this.dataManagerService.getAccountStatus().then(function (accountOverview) {
                                if (accountOverview.getSelectedAccount().accountStatus && accountOverview.getSelectedAccount().accountStatus.toLowerCase() === 'active') {
                                    _this.dataManagerSeeService.addTabLink(_this.dataManagerService.getDataControlList()).then(function () {
                                        _this.seeLinks = _this.dataManagerSeeService.tabAccountLinks;
                                    });
                                }
                            });
                            return null;
                        }, 'ute.data.manager.tabs.directive.controller');
                        $scope.$on('$destroy', function () {
                            if (_this && _this.languageService) {
                                _this.languageService.unregisterOnDataChangeHandler('ute.data.manager.tabs.directive.controller');
                            }
                        });
                        // END of SEE project implementation
                    }
                    DataManagerTabsController.prototype.getSeeLinks = function () {
                        return this.seeLinks;
                    };
                    DataManagerTabsController.prototype.getDataControlList = function () {
                        return this.dataManagerService.getDataControlList();
                    };
                    DataManagerTabsController.prototype.getElementID = function (account, index) {
                        return account.ctn === this.getPrimaryCTN() ? 'data-manager-primary-ctn-tab' : 'data-manager-secondary-ctn-tab' + index;
                    };
                    DataManagerTabsController.prototype.getPrimaryCTN = function () {
                        return this.dataManagerService.getPrimaryCTN();
                    };
                    DataManagerTabsController.prototype.getUsageDetailsCallInProgress = function () {
                        return this.dataManagerService.getUsageDetailsCallInProgress();
                    };
                    DataManagerTabsController.prototype.isTabDisabled = function (ctn) {
                        return this.dataManagerService.isTabDisabled(ctn);
                    };
                    DataManagerTabsController.prototype.changeTab = function (index, isSeeLink) {
                        //SEE implementation
                        if (isSeeLink) {
                            this.dataManagerSeeService.goToAddLine();
                            return;
                        }
                        //END of SEE implementation
                        this.dataManagerService.setActiveTabIndex(index);
                    };
                    DataManagerTabsController.prototype.getStatus = function (ctn) {
                        if (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).status;
                        }
                        return '';
                    };
                    DataManagerTabsController.prototype.getGroupStatus = function (ctn) {
                        if (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                        }
                        return '';
                    };
                    DataManagerTabsController.prototype.getSelectedTabIndex = function () {
                        return this.dataManagerService.getActiveTabIndex();
                    };
                    DataManagerTabsController.prototype.tabsCompactMode = function () {
                        return this.$scope.checkForCompactMode();
                    };
                    DataManagerTabsController.prototype.tabsExtremeCompact = function () {
                        var controlListLength = this.dataManagerService.getDataControlList().length;
                        var tabsContainerWidth = angular.element(document.getElementsByTagName('md-tabs-canvas')).width();
                        if (tabsContainerWidth > (controlListLength * 95)) {
                            return false;
                        }
                        else {
                            return true;
                        }
                    };
                    DataManagerTabsController.prototype.getTabsClass = function () {
                        return this.tabsCompactMode() ? 'ute-dataManager-tabs-small' : 'ute-dataManager-tabs';
                    };
                    DataManagerTabsController.prototype.getTabLabelClass = function (tab) {
                        return (this.getGroupStatus(tab.ctn) !== this.getGroupStatusCode().ACTIVE) || (this.getStatus(tab.ctn) !== this.getStatusCode().ACTIVE) ? 'ute-dataManager-tabs-statusContainer' : 'ute-dataManager-tabs-contentContainer';
                    };
                    DataManagerTabsController.prototype.getCTNClass = function () {
                        return this.tabsExtremeCompact() ? 'ute-dataManager-tabs-ctn-extremeCompact' : '';
                    };
                    DataManagerTabsController.prototype.getPrimaryCopy = function (tab) {
                        return (this.getPrimaryCTN() === tab.ctn) ? (this.$filter('translate')('ute.dataManager.tabs.primaryLine')) : '';
                    };
                    DataManagerTabsController.prototype.getGroupStatusCode = function () {
                        return this.dataManagerService.getGroupStatusCode();
                    };
                    DataManagerTabsController.prototype.getStatusCode = function () {
                        return this.dataManagerService.getStatusCode();
                    };
                    DataManagerTabsController.prototype.isAccountJoined = function (ctn) {
                        return (this.getGroupStatus(ctn) === this.getGroupStatusCode().JOINED);
                    };
                    DataManagerTabsController.prototype.isAccountLeftGroup = function (ctn) {
                        return (this.getGroupStatus(ctn) === this.getGroupStatusCode().LEFT);
                    };
                    DataManagerTabsController.prototype.isAccountSuspended = function (ctn) {
                        return (this.getStatus(ctn) === this.getStatusCode().SUSPENDED);
                    };
                    DataManagerTabsController.prototype.isAccountCancelled = function (ctn) {
                        return (this.getStatus(ctn) === this.getStatusCode().CANCELLED);
                    };
                    DataManagerTabsController.prototype.getUnderlineStyle = function () {
                        return { 'margin-top': (this.tabsCompactMode() ? '0px' : '-1px') };
                    };
                    DataManagerTabsController.controllerName = 'ute.data.manager.tabs.directive.controller';
                    DataManagerTabsController.$inject = ['$scope', '$state', '$rootScope', '$window', '$filter', 'ute.data.manager.service', 'ute.data.manager.see.service', 'ute.blocks.language.switcher'];
                    return DataManagerTabsController;
                }());
                tabs.DataManagerTabsController = DataManagerTabsController;
                angular.module('ute.data.manager.tabs').controller(DataManagerTabsController.controllerName, DataManagerTabsController);
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                'use strict';
                angular.module('ute.data.manager.tabs').directive('uteDataManagerTabs', uteDataManagerTabs);
                uteDataManagerTabs.$inject = ['ute.data.manager.service',
                    '$timeout',
                    '$window',
                    'ute.blocks.messages.bus.service',
                    'ute.common.utils.service'];
                /* @ngInject */
                function uteDataManagerTabs(dataManagerService, $timeout, $window, messagesService, utilsService) {
                    return {
                        restrict: 'E',
                        scope: {},
                        templateUrl: dataManagerService.getConfig().advanced.dataManagerTabsDirective.templateUrl,
                        controller: dataManagerService.getConfig().advanced.dataManagerTabsDirective.controllerName,
                        controllerAs: 'dataManagerTabs',
                        link: function (scope, element, attrs, controller) {
                            utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                            scope.activeTabIndex = controller.getSelectedTabIndex();
                            controller.activeCTN = controller.getPrimaryCTN();
                            var tabItems = element[0].getElementsByTagName('md-tab-item'), underline = element[0].getElementsByTagName('md-tabs-wrapper'), coverUpBar = angular.element(element[0].getElementsByTagName('md-ink-bar')), borderUnderline = element[0].getElementsByClassName('ute-dataManager-tabs-underline'), mdTabsCanvas = element[0].getElementsByTagName('md-tabs-canvas'), mdTabItemList = element[0].getElementsByTagName('md-tab-item');
                            /*
                                    scope.$watch( function() { dataManagerService.getDataControlList(); }, function ( controlList: Array<IDataManagerAccountLine>) {
                            
                                      if (controlList && controlList.length > 0) {
                                        var searchIndex: number = _.findIndex(dataManagerService.getDataControlList(), {
                                          ctn: this.window.localStorage.getItem('accountNumber')
                                        });
                            
                                        dataManagerService.setActiveTabIndex(searchIndex);
                                      }
                            
                                    });
                                    */
                            function tabColors(index) {
                                angular.element(tabItems[index]).css('border-right-color', dataManagerService.getControlLineByIndex(index).colorCode);
                                angular.element(tabItems[index]).css('border-left-color', dataManagerService.getControlLineByIndex(index).colorCode);
                                angular.element(underline).css('border-bottom-color', dataManagerService.getControlLineByIndex(index).colorCode);
                                angular.element(borderUnderline).css('background-color', dataManagerService.getControlLineByIndex(index).colorCode);
                                coverUpBar.css('bottom', '-1px');
                                coverUpBar.css('height', '1px');
                                coverUpBar.css('margin-left', '1px');
                                coverUpBar.css('margin-right', '1px');
                            }
                            function setWatchForTabChange() {
                                scope.$watch(function () {
                                    return dataManagerService.getActiveTabIndex();
                                }, function (index, oldIndex) {
                                    var existingCTN = dataManagerService.isCare() ? $window.sessionStorage.getItem('phoneNumber') : $window.localStorage.getItem('phoneNumber'), tabCTN = dataManagerService.getCTNByIndex(index);
                                    if (index !== oldIndex) {
                                        if (tabCTN !== existingCTN) {
                                            if (!dataManagerService.isTabDisabled(tabCTN)) {
                                                scope.activeTabIndex = controller.getSelectedTabIndex();
                                                angular.element(tabItems[oldIndex]).css('border-right-color', '#939598');
                                                angular.element(tabItems[oldIndex]).css('border-left-color', '#939598');
                                                tabColors(index);
                                                $window.localStorage.setItem('phoneNumber', tabCTN);
                                                if (dataManagerService.isCare()) {
                                                    $window.sessionStorage.setItem('phoneNumber', tabCTN);
                                                }
                                                messagesService.publish('ute-dataManager-update-wirelessDashboard', tabCTN);
                                            }
                                        }
                                    }
                                });
                            }
                            scope.checkForCompactMode = function () {
                                var tabsWidth = dataManagerService.getConfig().advanced.dataManagerTabsDirective.tabsWidth;
                                var controlListLength = dataManagerService.getDataControlList().length + 1;
                                var tabsContainer = angular.element(element[0].getElementsByClassName('md-stretch-tabs'))[0];
                                if (tabsContainer) {
                                    if (Math.min(tabsContainer.offsetWidth, 1150) > (controlListLength * tabsWidth)) {
                                        return false;
                                    }
                                    else {
                                        return true;
                                    }
                                }
                            };
                            //SEE Project - Tab Link Item
                            scope.$watch(function () { return controller.getSeeLinks(); }, function (controlList) {
                                $timeout(function () {
                                    if (controlList) {
                                        for (var iLine = 0; iLine < controlList.length; iLine++) {
                                            var iMatchingTab = Number(iLine) + controller.getDataControlList().length;
                                            var tab = angular.element(tabItems[iMatchingTab]);
                                            tab.css('border-top-color', controlList[iLine].colorCode);
                                            tab.css('border-top-width', '10px');
                                            tab.css('overflow', 'visible');
                                            tab.css('position', 'relative');
                                            tab.css('border-left-style', 'dashed');
                                            tab.css('border-right-style', 'dashed');
                                            tab.css('color', controlList[iLine].colorCode);
                                            tab.css('opacity', '0.6');
                                        }
                                    }
                                }, 1);
                            });
                            //End of SEE Project - Tab Link Item
                            scope.$watch(function () { return dataManagerService.getDataControlList().length; }, function (listLength) {
                                if (listLength > 0) {
                                    var controlList = dataManagerService.getDataControlList();
                                    $timeout(function () {
                                        if (controlList && controlList.length > 0) {
                                            var phoneNumber = $window.localStorage.getItem('phoneNumber');
                                            if (dataManagerService.isCare()) {
                                                phoneNumber = $window.sessionStorage.getItem('phoneNumber');
                                            }
                                            // var searchIndex: number = _.findIndex(dataManagerService.getDataControlList(), {
                                            //   ctn: phoneNumber
                                            // });
                                            var searchIndex = dataManagerService.getIndexByCTN(phoneNumber);
                                            scope.activeTabIndex = searchIndex;
                                            dataManagerService.setActiveTabIndex(searchIndex);
                                            tabColors(searchIndex);
                                            for (var iLine = 0; iLine < listLength; iLine++) {
                                                var iMatchingTab = Number(iLine);
                                                var tab = angular.element(tabItems[iMatchingTab]);
                                                tab.css('border-top-color', controlList[iLine].colorCode);
                                                tab.css('border-top-width', '10px');
                                                tab.css('overflow', 'visible');
                                                tab.css('position', 'relative');
                                            }
                                            setWatchForTabChange();
                                        }
                                    }, 1);
                                }
                            });
                            $timeout(function () {
                                var mdTabItemListLength = mdTabItemList.length;
                                mdTabsCanvas[0].tabIndex = '-1';
                                for (var iList = 0; iList < mdTabItemListLength; iList++) {
                                    mdTabItemList[iList].tabIndex = '0';
                                    angular.element(mdTabItemList[iList]).bind('keydown', function (e) {
                                        mdTabsCanvas[0].tabIndex = '-1';
                                        if (e.which === 13) {
                                            $(this).click();
                                        }
                                    });
                                }
                            }, 4000);
                        }
                    };
                }
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                var content;
                (function (content) {
                    'use strict';
                    var DataManagerTabsContentController = (function () {
                        /* @ngInject */
                        function DataManagerTabsContentController(dataManagerService) {
                            this.dataManagerService = dataManagerService;
                            this.model = this.dataManagerService.getModel();
                        }
                        DataManagerTabsContentController.$inject = ['ute.data.manager.service'];
                        return DataManagerTabsContentController;
                    }());
                    content.DataManagerTabsContentController = DataManagerTabsContentController;
                    angular.module('ute.data.manager.tabs.content').controller('ute.data.manager.tabs.content.controller', DataManagerTabsContentController);
                })(content = tabs.content || (tabs.content = {}));
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var tabs;
            (function (tabs) {
                var content;
                (function (content) {
                    'use strict';
                    angular.module('ute.data.manager.tabs.content').directive('uteDataManagerTabsContent', uteDataManagerTabsContent);
                    uteDataManagerTabsContent.$inject = ['ute.data.manager.service',
                        'ute.common.utils.service'];
                    /* @ngInject */
                    function uteDataManagerTabsContent(dataManagerService, utilsService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerTabsContent.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerTabsContent.controllerName,
                            controllerAs: 'wdController',
                            link: function (scope, element, attrs, controller) {
                                utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                            }
                        };
                    }
                })(content = tabs.content || (tabs.content = {}));
            })(tabs = manager.tabs || (manager.tabs = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var upgrade;
            (function (upgrade) {
                var plan;
                (function (plan) {
                    'use strict';
                    var DataManagerUpgradePlanDirectiveController = (function () {
                        /* @ngInject */
                        function DataManagerUpgradePlanDirectiveController($window, $location, $rootScope, $http, $modal, dataManagerService, messagesService, userService, permissionsService, bfaPpcService, securityService) {
                            this.$window = $window;
                            this.$location = $location;
                            this.$rootScope = $rootScope;
                            this.$http = $http;
                            this.$modal = $modal;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.userService = userService;
                            this.permissionsService = permissionsService;
                            this.bfaPpcService = bfaPpcService;
                            this.securityService = securityService;
                            this.model = this.dataManagerService.getModel();
                            this.canChangePlan = false;
                            this.ChangePlanRam();
                        }
                        /**
                         * RAM Upgrade Plan button for Care !!!Default False for Reps as per PCR29!!!
                         */
                        DataManagerUpgradePlanDirectiveController.prototype.ChangePlanRam = function () {
                            var _this = this;
                            if (this.userService.isCare() || this.userService.isDealer()) {
                                this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PPCBuyFlow, ute.common.permissions.service.RamActionCodes.start)
                                    .then(function (repPermission) {
                                    _this.canChangePlan = false;
                                });
                            }
                            else {
                                this.canChangePlan = true;
                            }
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.upgradeClick = function () {
                            // let primaryCTN: string = this.dataManagerService.getDataControlList()[0].ctn;
                            // this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, primaryCTN);
                            /*
                            
                                  let prefix: string = this.$location.absUrl().substr(0, this.$location.absUrl().indexOf('/web/totes/', 0));
                                  this.$window.location.href = prefix + '/web/totes/wireless-plan-change/#/change-share-plan';
                            */
                            // this.messagesService.publish('wireless-dashboard-change-plan');
                            this.openPPC(undefined);
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.openPPC = function (resumeOrder) {
                            var _this = this;
                            if (this.userService.isDealer()) {
                                this.$rootScope.targetFlow = 'Priceplan Change'; //settings.deepLinkStatusCodes.changePricePlan; //set in config
                                this.deepLinkingModal('md');
                            }
                            else if (this.userService.isCare()) {
                                this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.update)
                                    .then(function (hasDCAccess) {
                                    _this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PPCBuyFlow, ute.common.permissions.service.RamActionCodes.start)
                                        .then(function (repPpcAccess) {
                                        if (repPpcAccess) {
                                            _this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.DealerCode, ute.common.permissions.service.RamActionCodes.mandatory)
                                                .then(function (hasDSGAccess) {
                                                if (hasDSGAccess && !_this.bfaPpcService.isDealerCodeExist()) {
                                                    //controller and view --> config
                                                    _this.openPPCDealerCodeModal(_this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.captureDealerCode.templateUrl, _this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.captureDealerCode.controllerName, resumeOrder);
                                                }
                                                else if (hasDCAccess && !_this.bfaPpcService.isDealerCodeExist()) {
                                                    _this.openPPCDealerCodeModal(_this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.proceedWithoutDealerCode.templateUrl, _this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.proceedWithoutDealerCode.controllerName, resumeOrder);
                                                }
                                                else {
                                                    _this.openPPCFlow(resumeOrder);
                                                }
                                            });
                                        }
                                    });
                                });
                            }
                            else {
                                this.openPPCFlow(resumeOrder);
                            }
                        };
                        ;
                        DataManagerUpgradePlanDirectiveController.prototype.openPPCFlow = function (resumeOrder) {
                            var _this = this;
                            // $scope.changeBtnLoading(true);
                            var appStateForPPC = {
                                ban: '',
                                ctn: '',
                                accountTypeNumber: '',
                                flow: 'PPC',
                                eligibilityChecked: false,
                                availableCreditAmount: 0,
                                ctnList: []
                            };
                            this.bfaPpcService.gotoBFAPPC(appStateForPPC, resumeOrder).then(function () {
                                // $scope.changeBtnLoading(false);
                            }, function (q2ppcBrtSwitch) {
                                // BFA-PPC BRT switch is off
                                if (q2ppcBrtSwitch) {
                                    //if q2PPC itself is on BRT we should only display a msg
                                    _this.openChangePlanModal('md');
                                }
                                else {
                                    _this.$window.location.href = '/web/totes/wireless-plan-change/#/choose-plan'; //config
                                }
                                // $scope.changeBtnLoading(false);
                            });
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.openChangePlanModal = function (size) {
                            this.$modal.open({
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.wirelessRemovePlan.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.modals.wirelessRemovePlan.controllerName,
                                size: size,
                                backdrop: false,
                                resolve: {}
                            });
                        };
                        ;
                        DataManagerUpgradePlanDirectiveController.prototype.openPPCDealerCodeModal = function (dcTemplateUrl, dcController, resumeOrder) {
                            this.$rootScope.modal = this.$modal.open({
                                templateUrl: dcTemplateUrl,
                                controller: dcController,
                                size: 'md',
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {}
                            });
                            this.$rootScope.modal.result.then(function () {
                                // on OK behaviour
                                if (this.bfaPpcService.isDealerCodeExist()) {
                                    this.openPPCFlow(resumeOrder);
                                }
                                else {
                                }
                            }, function () {
                                // on Cancel behaviour
                                // $scope.changeBtnLoading(false);
                            });
                        };
                        ;
                        DataManagerUpgradePlanDirectiveController.prototype.deepLinkingModal = function (size) {
                            /*
                             requestedAcctNumber???
                             var acctNbr;
                             if ($rootScope.isCare) {
                             acctNbr = sessionStorage.getSessionStorageValue('requestedAccountNumber');
                             }
                             */
                            var _this = this;
                            this.$http.post(this.securityService.getBackendUrl('agentInfo'), { 'acctNbr': this.userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_ACCOUNT_NUMBER) }).then(function (data) {
                                var userId = data.cfaInfo.userId;
                                _this.$http.post(_this.securityService.getBackendUrl('userPreferenceRetrieval'), userId).then(function (data) {
                                    if (data && Object.keys(data).length > 0 && _.some(data.userPreference, { 'name': 'displayMovingToSSPPopUp' })) {
                                        var userPreferenceObject = _.find(data.userPreference, function (obj) {
                                            return obj.name === 'displayMovingToSSPPopUp';
                                        });
                                        if (!userPreferenceObject.value) {
                                            _this.backToSSP({});
                                        }
                                        else {
                                            _this.showDeepLinkPopUp(size);
                                        }
                                    }
                                    else {
                                        _this.showDeepLinkPopUp(size);
                                    }
                                }, function (error) {
                                    _this.showDeepLinkPopUp(size);
                                });
                            }, function (error) {
                                _this.showDeepLinkPopUp(size);
                            });
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.backToSSP = function (postData) {
                            //config -> backToSSP API url
                            return this.$http.post(this.securityService.getBackendUrl('backToSSP'), postData)
                                .then(this.processBackToSSPSuccess)
                                .catch(this.processBackToSSPError);
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.processBackToSSPSuccess = function (response) {
                            if (response.data) {
                                return response.data;
                            }
                            else {
                                return false;
                            }
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.processBackToSSPError = function (reason) {
                            return false;
                        };
                        DataManagerUpgradePlanDirectiveController.prototype.showDeepLinkPopUp = function (size) {
                            this.$rootScope.modal = this.$modal.open({
                                templateUrl: 'views/modals/deepLinkModal.html',
                                controller: 'deepLinkModalCtrl',
                                size: size,
                                backdrop: false,
                                //backdropClass: 'bkg-modal',
                                resolve: {}
                            });
                            this.$rootScope.modal.result.then(function () {
                                // do nothing
                            }, function () {
                                // on Cancel behaviour
                            });
                        };
                        ;
                        DataManagerUpgradePlanDirectiveController.$inject = [
                            '$window',
                            '$location',
                            '$rootScope',
                            '$http',
                            '$modal',
                            'ute.data.manager.service',
                            'ute.blocks.messages.bus.service',
                            'ute.common.user.service',
                            'ute.common.permissions.service',
                            'ute.bfa.ppc.service',
                            'ute.common.security.service'];
                        return DataManagerUpgradePlanDirectiveController;
                    }());
                    plan.DataManagerUpgradePlanDirectiveController = DataManagerUpgradePlanDirectiveController;
                    angular.module('ute.data.manager.upgrade.plan').controller('ute.data.manager.upgrade.plan.directive.controller', DataManagerUpgradePlanDirectiveController);
                })(plan = upgrade.plan || (upgrade.plan = {}));
            })(upgrade = manager.upgrade || (manager.upgrade = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var upgrade;
            (function (upgrade) {
                var plan;
                (function (plan) {
                    'use strict';
                    angular.module('ute.data.manager.upgrade.plan').directive('uteDataManagerUpgradePlanDirective', uteDataManagerUpgradePlanDirective);
                    uteDataManagerUpgradePlanDirective.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerUpgradePlanDirective(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerUpgradePlanDirective.controllerName,
                            controllerAs: 'dataManagerUpgradePlanDirective'
                        };
                    }
                })(plan = upgrade.plan || (upgrade.plan = {}));
            })(upgrade = manager.upgrade || (manager.upgrade = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var usage;
            (function (usage) {
                var dial;
                (function (dial) {
                    'use strict';
                    var DataManagerUsageDialController = (function () {
                        /* @ngInject */
                        function DataManagerUsageDialController($rootScope, $scope, $modal, $document, $filter, languageService, cacheableData, runtimeTranslateService, dataManagerService, $timeout) {
                            this.$rootScope = $rootScope;
                            this.$scope = $scope;
                            this.$modal = $modal;
                            this.$document = $document;
                            this.$filter = $filter;
                            this.languageService = languageService;
                            this.cacheableData = cacheableData;
                            this.runtimeTranslateService = runtimeTranslateService;
                            this.dataManagerService = dataManagerService;
                            this.$timeout = $timeout;
                            this.hasOverageCharge = undefined;
                            this.hasMultipleMDT = false;
                            this.viewContent = false;
                            this.overageChargeDetailKey = 'ute.dataManager.runtimeTranslation.overageChargeDetail';
                            this.config = this.dataManagerService.getConfig();
                            this.pathToSharedDataPartial = this.config.advanced.dataManagerUsageDialDirective.templateUrlSharedDataPartial;
                            this.pathToSharedTalkPartial = this.config.advanced.dataManagerUsageDialDirective.templateUrlSharedTalkPartial;
                            this.pathToSharedTextPartial = this.config.advanced.dataManagerUsageDialDirective.templateUrlSharedTextPartial;
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.document = $document;
                            this.init();
                        }
                        DataManagerUsageDialController.prototype.showHistoricalUsageNewBadge = function () {
                            return moment() < moment('2017/12/11').add(30, 'days'); // DSO 485 - remove 30days after BRT
                        };
                        DataManagerUsageDialController.prototype.getPurchaseDataProductCallInProgress = function () {
                            return this.dataManagerService.getPurchaseDataProductCallInProgress();
                        };
                        DataManagerUsageDialController.prototype.getStartMonth = function () {
                            return this.dataManagerService.getBillCycle().startDate.month;
                        };
                        DataManagerUsageDialController.prototype.getStartDay = function () {
                            return this.dataManagerService.getBillCycle().startDate.day;
                        };
                        DataManagerUsageDialController.prototype.getEndMonth = function () {
                            return this.dataManagerService.getBillCycle().endDate.month;
                        };
                        DataManagerUsageDialController.prototype.getEndDay = function () {
                            return this.dataManagerService.getBillCycle().endDate.day;
                        };
                        DataManagerUsageDialController.prototype.getDaysUntilEnd = function () {
                            return this.dataManagerService.getBillCycle().daysUntilEndDate;
                        };
                        DataManagerUsageDialController.prototype.getNextStartDay = function () {
                            return this.dataManagerService.getBillCycle().nextStartDate.day;
                        };
                        DataManagerUsageDialController.prototype.getNextStartMonth = function () {
                            return this.dataManagerService.getBillCycle().nextStartDate.month;
                        };
                        DataManagerUsageDialController.prototype.getBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversion;
                        };
                        DataManagerUsageDialController.prototype.getSharedDataPartial = function () {
                            return this.pathToSharedDataPartial;
                        };
                        DataManagerUsageDialController.prototype.getSharedTextPartial = function () {
                            return this.pathToSharedTextPartial;
                        };
                        DataManagerUsageDialController.prototype.getSharedTalkPartial = function () {
                            return this.pathToSharedTalkPartial;
                        };
                        DataManagerUsageDialController.prototype.getPurchaseDelayButtonClass = function () {
                            return this.isOverageWarningUpgradeVisible() && this.getPurchaseDataIncreases().length < 2 ? 'ute-dataManager-usageDial-dataPurchaseDelayCopy' : 'ute-dataManager-usageDial-dataPurchaseDelayCopyInline';
                        };
                        DataManagerUsageDialController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerUsageDialController.prototype.isProrationError = function () {
                            return this.dataManagerService.isProrationError();
                        };
                        DataManagerUsageDialController.prototype.isAddDataVisible = function () {
                            return this.dataManagerService.getIsRogersDataPurchaseEnabled();
                        };
                        DataManagerUsageDialController.prototype.isInfintePlanFirstCycle = function () {
                            var value = false;
                            if (this.isInfinitePlan()) {
                                value = this.dataManagerService.getIsFirstCycleAfterPpc();
                            }
                            return value;
                        };
                        DataManagerUsageDialController.prototype.isAllowedToPurchaseData = function () {
                            if (this.dataManagerService.isAllowedToPurchaseData()) {
                                return true;
                            }
                            else {
                                if (this.dataManagerService.getOverageForDTU() > 0) {
                                    return this.dataManagerService.getIsRogersAddonEnabled() ? true : false;
                                }
                                else {
                                    return false;
                                }
                            }
                            // return this.dataManagerService.isAllowedToPurchaseData();
                        };
                        DataManagerUsageDialController.prototype.isRogersAddonEnabled = function () {
                            return this.dataManagerService.getIsRogersAddonEnabled();
                        };
                        DataManagerUsageDialController.prototype.validateDateData = function () {
                            var pass = true;
                            if (isNaN(this.getEndDay()) || isNaN(this.getEndMonth()) || isNaN(this.getStartDay()) || isNaN(this.getStartMonth()) || isNaN(this.getDaysUntilEnd())) {
                                pass = false;
                            }
                            return pass;
                        };
                        //    increaseData(): void {
                        //      this.dataManagerService.increaseData(2);
                        //    }
                        DataManagerUsageDialController.prototype.getDialCopy = function () {
                            var copy = '';
                            // var remainingData: number = this.dataManagerService.getModel().remaining;
                            var remainingData = this.getRemainingTotalData();
                            var overage = this.dataManagerService.getModel().overage;
                            if (this.isBucketSizeUnavailableUntilNextBillCycle() || this.isProrationError()) {
                                copy = 'ute.dataManager.usageDial.used';
                            }
                            else {
                                if ((remainingData > 0 && overage > 0) || (remainingData >= 0 && overage <= 0)) {
                                    copy = 'ute.dataManager.usageDial.remaining';
                                }
                                else {
                                    copy = 'ute.dataManager.usageDial.overPlanLimit';
                                }
                            }
                            return copy;
                        };
                        DataManagerUsageDialController.prototype.getDialRemainingCopy = function () {
                            var base = this.getBase(), copy = this.getDialCopy(), displayData = this.getDisplayData(), displayDataConverted = this.$filter('ute_common_filter_data_conversion')(displayData, 'mb', base, 0, true, true), displayDataConvertedWrap = '<strong class="ute-dataManager-usageDialContent-gbAmountUnit">' + displayDataConverted + '</strong>', displayDataSecondaryBase = (displayData > base ? 2 : 0), displayDataSecondaryConverted = this.$filter('ute_common_filter_data_conversion')(displayData, 'mb', base, displayDataSecondaryBase, false, false), params = { data: displayDataSecondaryConverted + ' ' + displayDataConvertedWrap };
                            return this.$filter('translate')(copy, params);
                        };
                        DataManagerUsageDialController.prototype.getDisplayData = function () {
                            var displayData = 0;
                            // var remainingData: number = this.dataManagerService.getModel().remaining;
                            var remainingData = this.getRemainingTotalData();
                            var overage = this.dataManagerService.getModel().overage;
                            var used = this.dataManagerService.getModel().totalDataUsage;
                            if (this.isBucketSizeUnavailableUntilNextBillCycle()) {
                                displayData = Math.round(this.dataManagerService.getDataLimit() * 100) / 100;
                            }
                            else if (this.isProrationError()) {
                                displayData = used;
                            }
                            else {
                                if ((remainingData > 0 && overage > 0) || (remainingData >= 0 && overage <= 0)) {
                                    displayData = remainingData;
                                }
                                else {
                                    displayData = overage;
                                }
                            }
                            return displayData;
                        };
                        DataManagerUsageDialController.prototype.getRemainingTotalDataPercentage = function () {
                            var remainingData = this.dataManagerService.getModel().remaining;
                            var dataLimit = this.dataManagerService.getDataLimit();
                            var addedExtraData = this.dataManagerService.getAddedExtraData();
                            var overage = this.dataManagerService.getModel().overage;
                            var percentage = 0;
                            if (remainingData !== 0 || (remainingData === 0 && overage === 0)) {
                                percentage = Math.abs(remainingData) / (dataLimit + addedExtraData) * 100;
                            }
                            else if (remainingData === 0 && overage !== 0) {
                                percentage = -1;
                            }
                            return percentage;
                        };
                        DataManagerUsageDialController.prototype.isInfiniteThrottled = function () {
                            var remainingData = this.getRemainingTotalData();
                            var overage = this.dataManagerService.getModel().overage;
                            return this.isInfinitePlan() && (remainingData <= 0) && (overage >= 0);
                        };
                        DataManagerUsageDialController.prototype.getPurchaseDataIncreases = function () {
                            return this.dataManagerService.getPurchaseDataIncreases();
                        };
                        DataManagerUsageDialController.prototype.getRemainingTotalData = function () {
                            return this.dataManagerService.getRemainingTotalData();
                        };
                        DataManagerUsageDialController.prototype.isOverage = function () {
                            return this.dataManagerService.getOverageForDTU() > 0;
                        };
                        DataManagerUsageDialController.prototype.getTotalDataPurchased = function () {
                            return this.dataManagerService.getTotalDataPurchased();
                        };
                        DataManagerUsageDialController.prototype.getTotalDataPurchaseAmount = function () {
                            return this.dataManagerService.getTotalDataPurchasedAmount();
                        };
                        DataManagerUsageDialController.prototype.isRealTime = function () {
                            return this.dataManagerService.getUsageReportingDelay() === 'NONE';
                        };
                        DataManagerUsageDialController.prototype.getUsageDetailsCallInProgress = function () {
                            return this.dataManagerService.getUsageDetailsCallInProgress();
                        };
                        DataManagerUsageDialController.prototype.getInfoBlock = function () {
                            return this.dataManagerService.getInfoBlock();
                        };
                        /*
                            goNext(): void{
                              var carousel: any = angular.element('.myCarousel');
                              carousel.carousel(2);
                            }
                        */
                        DataManagerUsageDialController.prototype.getUsageDialStyle = function () {
                            return { 'margin-bottom': (((this.getPurchaseDataIncreases().length > 1) && !this.isOverage()) ? '74px' : '') };
                        };
                        DataManagerUsageDialController.prototype.getUsageDialClass = function () {
                            return this.isOverage() ? 'ute-dataManager-usageDial-overage' : '';
                        };
                        DataManagerUsageDialController.prototype.showSecondaryReminder = function () {
                            return (this.getNextStartDay() !== null && this.getNextStartMonth() !== null);
                        };
                        DataManagerUsageDialController.prototype.hideRealTime = function () {
                            return this.getUsageDetailsCallInProgress() || !this.isRealTime() || this.isInfiniteThrottled();
                        };
                        DataManagerUsageDialController.prototype.hideOneHourDelay = function () {
                            return this.getUsageDetailsCallInProgress() || this.isRealTime();
                        };
                        DataManagerUsageDialController.prototype.isStrokeHidden = function () {
                            return this.isBucketSizeUnavailableUntilNextBillCycle() || this.getUsageDetailsCallInProgress() || this.isProrationError();
                        };
                        DataManagerUsageDialController.prototype.isPurchasedCopyVisible = function () {
                            return this.getPurchaseDataIncreases().length > 0 && !this.getUsageDetailsCallInProgress() && !this.getPurchaseDataProductCallInProgress();
                        };
                        DataManagerUsageDialController.prototype.getUpgradePlanClass = function () {
                            return this.getPurchaseDataIncreases().length ? 'ute-dataManager-usageDial-upgradePlanAddedData' : '';
                        };
                        DataManagerUsageDialController.prototype.isOverageWarningUpgradeVisible = function () {
                            return this.isOverage() && !this.getUsageDetailsCallInProgress() && !this.isInfiniteThrottled();
                        };
                        DataManagerUsageDialController.prototype.isOverageWarningIncreaseVisible = function () {
                            if (!this.getUsageDetailsCallInProgress()) {
                                if (this.isAllowedToPurchaseData()) {
                                    // if allowed to purchase data, then dont display any error message
                                    return false;
                                }
                                else {
                                    // if NOT allowed to purchase data
                                    if (this.isOverage()) {
                                        // if overage > 0 & if BRT switch is ON, then don't display any error message
                                        return this.isRogersAddonEnabled() ? false : true;
                                    }
                                    else {
                                        // overage <= 0, don't display any error message
                                        return false;
                                    }
                                }
                            }
                        };
                        DataManagerUsageDialController.prototype.getIncreasePlanClass = function () {
                            var planClass;
                            planClass = this.getPurchaseDataIncreases().length ? 'ute-dataManager-usageDial-increaseDataAddedData' : 'ute-dataManager-usageDial-increaseData';
                            if (!this.isAllowedToPurchaseData() && !this.isOverage()) {
                                planClass = planClass.concat(' ute-dataManager-usageDial-increaseData-disabled');
                            }
                            return planClass;
                        };
                        DataManagerUsageDialController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.$rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrlNoIcon,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'sm',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        DataManagerUsageDialController.prototype.dataPurchasePopup = function () {
                            this.errorModalPopup('ute.dataManager.usageDial.dataDelayHeader', 'ute.dataManager.usageDial.dataDelayBody');
                        };
                        DataManagerUsageDialController.prototype.getUsageDialStyling = function () {
                            return (this.dataManagerService.getIsVideoThrottlePermitted() ? 'ute-dataManager-usageCarouselContainer-vt-tab' : '');
                        };
                        DataManagerUsageDialController.prototype.navigateToPrimaryCtnSummary = function (scroll) {
                            if (scroll) {
                                this.$timeout(function () {
                                    angular.element('#data-manager-primary-ctn-tab').click();
                                    $('html, body').animate({ scrollTop: $('#data-manager-primary-ctn-tab').offset().top - 150 }, 200);
                                }, 0);
                            }
                            else {
                                var ctn = this.dataManagerService.getPrimaryCTN();
                                this.dataManagerService.setWirelessCTN(ctn);
                                this.dataManagerService.setIndividualSummaryCTN(ctn);
                                this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerIndividualSummary.subState);
                            }
                        };
                        DataManagerUsageDialController.prototype.getLanguage = function () {
                            return this.languageService.getCurrentLanguage();
                        };
                        DataManagerUsageDialController.prototype.isAddedOrBonusMDT = function () {
                            var mdtCopy = 'ute.dataManager.usageDial.bonusData';
                            var mdtList = this.getPurchaseDataIncreases();
                            for (var m = 0; m < mdtList.length; m++) {
                                if (mdtList[m].value > 0) {
                                    mdtCopy = 'ute.dataManager.usageDial.addedData';
                                    break;
                                }
                            }
                            return mdtCopy;
                        };
                        DataManagerUsageDialController.prototype.isInfinitePlan = function () {
                            return JSON.parse(sessionStorage.getItem('isInfinitePlan'));
                        };
                        DataManagerUsageDialController.prototype.getSharedDataTranslationKey = function () {
                            var isInfinitePlan = this.isInfinitePlan();
                            return isInfinitePlan
                                ?
                                    (this.isInfiniteThrottled()
                                        ? 'ute.dataManager.usageDial.unlimitedData'
                                        : 'ute.dataManager.usageDial.infiniteData')
                                : 'ute.dataManager.usageDial.sharedData';
                        };
                        DataManagerUsageDialController.prototype.init = function () {
                            var _this = this;
                            if (this.isOverage() &&
                                !this.getUsageDetailsCallInProgress() &&
                                this.model &&
                                this.model.accountNumber &&
                                this.model.primaryCTN) {
                                this.calculateOverageDetail();
                            }
                            else {
                                var watcher = this.scope.$watch(function () {
                                    return !_this.getUsageDetailsCallInProgress() &&
                                        !!_this.dataManagerService.getAccountNumber() &&
                                        !!_this.dataManagerService.getPrimaryCTN();
                                }, function (value) {
                                    if (value === true) {
                                        watcher();
                                        if (_this.isOverage()) {
                                            _this.calculateOverageDetail();
                                        }
                                        else if (!_this.isOverage()) {
                                            _this.hasOverageCharge = false;
                                        }
                                    }
                                });
                            }
                        };
                        DataManagerUsageDialController.prototype.calculateOverageDetail = function () {
                            var _this = this;
                            this.cacheableData({
                                url: 'v1/ppc/priceplans/current',
                                postData: {
                                    ban: this.dataManagerService.getAccountNumber(),
                                    ctn: this.dataManagerService.getPrimaryCTN(),
                                    language: this.languageService.getCurrentLanguage(),
                                    consolidatedInd: 'NO'
                                }
                            }).getData()
                                .then(function (response) {
                                var featureGroupList = _.get(response, 'data.featureGroupList', []);
                                var dataFeatureGroup = _.filter(featureGroupList, function (featureGroup) {
                                    return _.get(featureGroup, 'featureGroup.label.en', '') === 'Data';
                                });
                                if (dataFeatureGroup.length > 0) {
                                    var overageRate = _.find(_.get(dataFeatureGroup[0], 'featureGroup.featureList', []), { featureKey: 'OVERAGERATE' });
                                    if (overageRate) {
                                        var overageRateData = overageRate.en.split('Overage Rate : $')[1].split(/\/| /);
                                        if (overageRateData.length === 3) {
                                            var unit = overageRateData[2]; // MB or GB
                                            var price = Number(overageRateData[0]);
                                            var dataUnit = Number(overageRateData[1]);
                                            var dataUnitInMB = (unit === 'GB') ? (dataUnit * 1024) : dataUnit;
                                            var overageUnit = Math.ceil(_this.dataManagerService.getOverageForDTU() / dataUnitInMB);
                                            // const englisht = overageUnit + ' x $' + price + '<br>/' + dataUnit + unit + ' = $' + (overageUnit * price);
                                            // const frencht = overageUnit + ' x ' + price + ' $<br>/' + dataUnit + (unit === 'MB' ? 'Mo' : 'Go') + ' = ' + (overageUnit * price) + ' $';
                                            var englisht = '<strong>' + overageUnit + '</strong> X ' + dataUnit + ' ' + unit + ' FOR <span>$' + price + ' each</span>';
                                            var frencht = '<strong>' + overageUnit + ' </strong> X ' + dataUnit + ' ' + (unit === 'MB' ? 'Mo' : 'Go') + ' À <span>' + price + ' $ ' + ' par ajout</span>';
                                            _this.runtimeTranslateService.addTranslation('en', _this.overageChargeDetailKey, englisht);
                                            _this.runtimeTranslateService.addTranslation('fr', _this.overageChargeDetailKey, frencht);
                                            _this.hasOverageCharge = true;
                                            return;
                                        }
                                    }
                                }
                                _this.hasOverageCharge = false;
                            })
                                .catch(function (error) { return _this.hasOverageCharge = false; });
                        };
                        DataManagerUsageDialController.$inject = [
                            '$rootScope',
                            '$scope',
                            '$modal',
                            '$document',
                            '$filter',
                            'ute.blocks.language.switcher',
                            'ute.common.core.caching.CacheableDataFactory',
                            'ute.common.runtime.translate.service',
                            'ute.data.manager.service',
                            '$timeout'
                        ];
                        return DataManagerUsageDialController;
                    }());
                    dial.DataManagerUsageDialController = DataManagerUsageDialController;
                    angular.module('ute.data.manager.usage.dial').controller('ute.data.manager.usage.dial.controller', DataManagerUsageDialController);
                })(dial = usage.dial || (usage.dial = {}));
            })(usage = manager.usage || (manager.usage = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var usage;
            (function (usage) {
                var dial;
                (function (dial) {
                    'use strict';
                    angular.module('ute.data.manager.usage.dial').directive('uteDataManagerUsageDial', uteDataManagerUsageDial);
                    uteDataManagerUsageDial.$inject = ['$rootScope',
                        'ute.data.manager.service',
                        '$timeout',
                        'ute.common.utils.service',
                        '$animate'];
                    /* @ngInject */
                    function uteDataManagerUsageDial($rootScope, dataManagerService, $timeout, utilsService, $animate) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerUsageDialDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerUsageDialDirective.controllerName,
                            controllerAs: 'dataManagerUsageDial',
                            link: function (scope, element, attrs, controller) {
                                utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                var usageDialAnimateStrokeOverageHit = $rootScope.$on('ute-dataManager-usageDialAnimateStroke-overageHit', function () {
                                    angular.element(element[0].getElementsByClassName('ute-dataManager-usageDialContent')).css('backgroundColor', '#FFE9C7');
                                });
                                scope.$on('$destroy', function () {
                                    usageDialAnimateStrokeOverageHit();
                                });
                                scope.$watch(function () { return $(window).width(); }, function (newWidth, oldWidth) {
                                    isMobile(newWidth);
                                });
                                function isMobile(width) {
                                    controller.isMobile = (width < 768);
                                }
                                isMobile($(window).width());
                            }
                        };
                    }
                })(dial = usage.dial || (usage.dial = {}));
            })(usage = manager.usage || (manager.usage = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var usage;
            (function (usage) {
                var dial;
                (function (dial) {
                    'use strict';
                    angular.module('ute.data.manager.usage.dial').directive('uteDataManagerUsageDialAnimateStroke', uteDataManagerUsageDialAnimatedStroke);
                    uteDataManagerUsageDialAnimatedStroke.$inject = ['$interval', '$rootScope'];
                    /* @ngInject */
                    function uteDataManagerUsageDialAnimatedStroke($interval, $rootScope) {
                        return {
                            restrict: 'E',
                            scope: {
                                'percentRemaining': '@',
                                'height': '@',
                                'width': '@',
                                'radius': '@',
                                'strokeWidth': '@',
                                'nominalColor': '@',
                                'warningColor': '@',
                                'overageColor': '@',
                                'animationComplete': '='
                            },
                            template: function () { return '<canvas class="ute-dataManager-usageDialChart" width="{{width}}px" height="{{height}}px"></canvas>'; },
                            controllerAs: 'dataManagerUsageDialAnimateStroke',
                            link: function (scope, element, attrs, controller) {
                                var radialDialInterval;
                                scope.percentRemaining *= 1;
                                var c = element[0].getElementsByClassName('ute-dataManager-usageDialChart')[0], ctx = c.getContext('2d'), inc = 2, circleRadius = scope.radius, xPosition = scope.width / 2, yPosition = scope.height / 2, x1 = scope.height, multiplier = 0.02, speed = 12, maxSpeed = 10, endSpeed = 100, incOverage = 0, iterationsLeft = (inc / scope.percentRemaining) / multiplier, iterations = inc / multiplier, totalIterations = iterations - iterationsLeft, speedDifferential = endSpeed / maxSpeed, velocityIncrement = totalIterations / speedDifferential;
                                function drawArc() {
                                    var gradient = ctx.createLinearGradient(circleRadius, circleRadius, x1, circleRadius);
                                    gradient.addColorStop('0', scope.nominalColor);
                                    gradient.addColorStop('1', scope.warningColor);
                                    ctx.beginPath();
                                    ctx.strokeStyle = scope.nominalColor;
                                    ctx.arc(xPosition, yPosition, circleRadius, 0, inc * Math.PI);
                                    ctx.lineWidth = scope.strokeWidth;
                                    ctx.stroke();
                                    ctx.closePath();
                                    ctx.beginPath();
                                    ctx.strokeStyle = gradient;
                                    if (inc <= 1) {
                                        ctx.arc(xPosition, yPosition, circleRadius, 0, inc * Math.PI);
                                    }
                                    else {
                                        ctx.arc(xPosition, yPosition, circleRadius, 0, -1 * Math.PI);
                                    }
                                    ctx.lineWidth = scope.strokeWidth;
                                    ctx.stroke();
                                    ctx.closePath();
                                }
                                function dialAnimationComplete(int) {
                                    scope.animationComplete = true;
                                    $interval.cancel(int);
                                }
                                scope.$on('$destroy', function () {
                                    dialAnimationComplete(radialDialInterval);
                                });
                                radialDialInterval = $interval(function () {
                                    if (scope.percentRemaining < 100) {
                                        inc = inc - multiplier;
                                    }
                                    if (inc <= (scope.percentRemaining > 0 ? (scope.percentRemaining / 50) : 0)) {
                                        if (scope.percentRemaining * -1 > 0) {
                                            if (incOverage < (scope.percentRemaining * -1) / 50) {
                                                if (incOverage === 0) {
                                                    $rootScope.$emit('ute-dataManager-usageDialAnimateStroke-overageHit');
                                                    ctx.clearRect(0, 0, scope.width, scope.height);
                                                }
                                            }
                                            else {
                                                dialAnimationComplete(radialDialInterval);
                                            }
                                        }
                                        else if (scope.percentRemaining * 1 === 0) {
                                            dialAnimationComplete(radialDialInterval);
                                            ctx.clearRect(0, 0, scope.width, scope.height);
                                        }
                                        else if (scope.percentRemaining * 1 === 100) {
                                            drawArc();
                                            dialAnimationComplete(radialDialInterval);
                                        }
                                        else {
                                            ctx.clearRect(0, 0, scope.width, scope.height);
                                            drawArc();
                                            dialAnimationComplete(radialDialInterval);
                                        }
                                    }
                                    else if (inc > 0) {
                                        speed = speed + velocityIncrement;
                                        ctx.clearRect(0, 0, scope.width, scope.height);
                                        drawArc();
                                    }
                                    //Overage animation is not included
                                    if (inc < 0) {
                                        dialAnimationComplete(radialDialInterval);
                                    }
                                }, speed);
                            }
                        };
                    }
                })(dial = usage.dial || (usage.dial = {}));
            })(usage = manager.usage || (manager.usage = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var list;
                        (function (list) {
                            'use strict';
                            var DataManagerVideoThrottleControlListController = (function () {
                                /* @ngInject */
                                function DataManagerVideoThrottleControlListController($state, $filter, $rootScope, $modal, dataManagerService, messagesService, dtmService, $document) {
                                    this.$state = $state;
                                    this.$filter = $filter;
                                    this.$rootScope = $rootScope;
                                    this.$modal = $modal;
                                    this.dataManagerService = dataManagerService;
                                    this.messagesService = messagesService;
                                    this.dtmService = dtmService;
                                    this.$document = $document;
                                    this.discoveryParams = {};
                                    this.model = this.dataManagerService.getModel();
                                    this.discoveryParams = this.getDiscoveryParams();
                                    this.rootScope = $rootScope;
                                    this.isDataAlertsConsoleLoaded = false;
                                }
                                DataManagerVideoThrottleControlListController.prototype.buttonClick = function () {
                                    this.messagesService.publish('ute-data-manager-increase-plan-button-click-usageDial');
                                    this.$document.scrollTop(0);
                                };
                                DataManagerVideoThrottleControlListController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                                    return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getConfig = function () {
                                    return this.dataManagerService.getConfig();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getDataControlList = function () {
                                    return this.dataManagerService.getDataControlList();
                                };
                                DataManagerVideoThrottleControlListController.prototype.isAllowedToPurchaseData = function () {
                                    return this.dataManagerService.isAllowedToPurchaseData();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getDataLimit = function () {
                                    return this.dataManagerService.getDataLimit();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getAlertsRecipientCTN = function () {
                                    return this.dataManagerService.getAlertsRecipientCTN();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getBase = function () {
                                    return this.dataManagerService.getDataLimit() >= this.dataManagerService.getConfig().basic.dataConversionRoundValues ? this.dataManagerService.getConfig().basic.dataConversion : this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                                };
                                DataManagerVideoThrottleControlListController.prototype.getAlertedDataTotal = function () {
                                    return Math.round(this.dataManagerService.getAlertedDataTotal() * 100) / 100;
                                };
                                DataManagerVideoThrottleControlListController.prototype.getSavedAlertDataTotal = function () {
                                    return Math.round(this.dataManagerService.getSavedAlertedDataTotal() * 100) / 100;
                                };
                                DataManagerVideoThrottleControlListController.prototype.alertsRecipientCTNExists = function () {
                                    return this.dataManagerService.getAlertsRecipientCTN() !== null;
                                };
                                DataManagerVideoThrottleControlListController.prototype.getUsageDetailsCallInProgress = function () {
                                    return this.dataManagerService.getUsageDetailsCallInProgress();
                                };
                                DataManagerVideoThrottleControlListController.prototype.toggleDataAlerts = function () {
                                    this.isDataAlertsConsoleLoaded = true;
                                    this.dataManagerService.toggleDataAlerts();
                                };
                                DataManagerVideoThrottleControlListController.prototype.alertsRecipientCheck = function () {
                                    if (this.getDataAlertsOpen() && !this.dataManagerService.getAlertsRecipientCTN()) {
                                        this.openModalPopup();
                                    }
                                };
                                DataManagerVideoThrottleControlListController.prototype.isConsoleLoaded = function () {
                                    return this.isDataAlertsConsoleLoaded;
                                };
                                DataManagerVideoThrottleControlListController.prototype.getDataAlertsOpen = function () {
                                    return this.dataManagerService.getDataAlertsOpen();
                                };
                                DataManagerVideoThrottleControlListController.prototype.errorModalPopup = function (primary, secondary) {
                                    var errorModalScope = this.rootScope.$new();
                                    errorModalScope.params = { primary: primary, secondary: secondary };
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                        controllerAs: 'dataManagerGenericModal',
                                        size: 'md',
                                        backdrop: 'static',
                                        scope: errorModalScope
                                    });
                                };
                                DataManagerVideoThrottleControlListController.prototype.openModalPopup = function () {
                                    var _this = this;
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                        controllerAs: 'dataManagerAlertsRecipientModal',
                                        size: 'md',
                                        backdrop: 'static'
                                    }).result.then(function (result) {
                                        // Result selection behaviour
                                        switch (result) {
                                            case 'yes':
                                                break;
                                            case 'no':
                                                _this.toggleDataAlerts();
                                                break;
                                            case 'error':
                                                _this.errorModalPopup('ute.dataManager.videoThrottleControlList.errorHeading', 'ute.dataManager.videoThrottleControlList.errorSecondary');
                                                _this.toggleDataAlerts();
                                                break;
                                        }
                                    }, function () {
                                        // Dismiss behaviour
                                        // Do nothing/close
                                        _this.toggleDataAlerts();
                                    });
                                };
                                DataManagerVideoThrottleControlListController.prototype.getDiscoveryParams = function () {
                                    var config = this.dataManagerService.getConfig();
                                    var model = this.dataManagerService.getModel();
                                    return {
                                        ban: model.accountNumber,
                                        ctn: model.dataControlList.length > 0 ? model.dataControlList[0].ctn : '',
                                        copy: this.$filter('translate')('ute.dataManager.dataAlerts.informationLink'),
                                        brand: config.advanced.dataManagerDiscoveryIntegration.brand,
                                        segment: config.advanced.dataManagerDiscoveryIntegration.segment,
                                        accountType: config.advanced.dataManagerDiscoveryIntegration.accountType,
                                        productType: config.advanced.dataManagerDiscoveryIntegration.productType,
                                        pageFilter: config.advanced.dataManagerDiscoveryIntegration.pageFilter,
                                        province: model.province
                                    };
                                };
                                DataManagerVideoThrottleControlListController.prototype.getButtonCopy = function () {
                                    return this.getDataAlertsOpen() ? 'ute.dataManager.videoThrottleControlList.closeDataAlerts' : 'ute.dataManager.videoThrottleControlList.openDataAlerts';
                                };
                                DataManagerVideoThrottleControlListController.prototype.getButtonArrowClass = function () {
                                    return this.dataManagerService.getDataAlertsOpen() ? 'ute-icon-arrow-down-invert' : '';
                                };
                                DataManagerVideoThrottleControlListController.prototype.getTitleBarClass = function () {
                                    return this.isBucketSizeUnavailableUntilNextBillCycle() ? 'col-lg-5 col-md-5 col-sm-5' : 'col-lg-2 col-md-2 col-sm-2';
                                };
                                DataManagerVideoThrottleControlListController.prototype.isGBMode = function () {
                                    return this.getDataLimit() >= this.getBase();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getPrecisionPlace = function () {
                                    return this.isGBMode() ? 2 : 0;
                                };
                                DataManagerVideoThrottleControlListController.prototype.getSavedAlertedDataValue = function () {
                                    return this.isGBMode() ? ((this.getSavedAlertDataTotal() * 1) / 1024) : this.getSavedAlertDataTotal();
                                };
                                DataManagerVideoThrottleControlListController.prototype.getIsVideoThrottlePermitted = function () {
                                    return this.dataManagerService.getIsVideoThrottlePermitted();
                                };
                                DataManagerVideoThrottleControlListController.$inject = ['$state', '$filter', '$rootScope', '$modal', 'ute.data.manager.service', 'ute.blocks.messages.bus.service', 'ute.dtm.service', '$document', 'ute.data.manager.see.service'];
                                return DataManagerVideoThrottleControlListController;
                            }());
                            list.DataManagerVideoThrottleControlListController = DataManagerVideoThrottleControlListController;
                            angular.module('ute.data.manager.video.throttle.control.list').controller('ute.data.manager.video.throttle.control.list.directive.controller', DataManagerVideoThrottleControlListController);
                        })(list = control.list || (control.list = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var list;
                        (function (list) {
                            'use strict';
                            angular.module('ute.data.manager.video.throttle.control.list').directive('uteDataManagerVideoThrottleControlList', uteDataManagerVideoThrottleControlList);
                            uteDataManagerVideoThrottleControlList.$inject = [
                                'ute.data.manager.service',
                                'ute.common.utils.service',
                                'ute.blocks.language.switcher'
                            ];
                            /* @ngInject */
                            function uteDataManagerVideoThrottleControlList(dataManagerService, utilsService, languageSwitcher) {
                                return {
                                    restrict: 'E',
                                    scope: {},
                                    templateUrl: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlListDirective.templateUrl,
                                    controller: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlListDirective.controllerName,
                                    controllerAs: 'dataManagerVideoThrottleControlList',
                                    link: function (scope, element, attrs, controller) {
                                        utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                        scope.currentLanguage = languageSwitcher.getCurrentLanguage();
                                    }
                                };
                            }
                        })(list = control.list || (control.list = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            var list;
                            (function (list) {
                                'use strict';
                                var DataManagerVideoThrottleControlTagListController = (function () {
                                    /* @ngInject */
                                    function DataManagerVideoThrottleControlTagListController($scope, $filter, $state, $rootScope, dataManagerService, dataManagerSeeService, languageService) {
                                        this.$scope = $scope;
                                        this.$filter = $filter;
                                        this.$state = $state;
                                        this.$rootScope = $rootScope;
                                        this.dataManagerService = dataManagerService;
                                        this.dataManagerSeeService = dataManagerSeeService;
                                        this.languageService = languageService;
                                        this.discoveryParams = {};
                                        this.model = this.dataManagerService.getModel();
                                        this.discoveryParams = this.getDiscoveryParams();
                                    }
                                    DataManagerVideoThrottleControlTagListController.prototype.getMaxLimit = function () {
                                        return this.dataManagerService.getDataLimit();
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.getIsVideoThrottlePermitted = function () {
                                        return this.dataManagerService.getIsVideoThrottlePermitted();
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.getDataControlList = function () {
                                        return this.dataManagerService.getDataControlList();
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.getAlertsRecipientCTN = function () {
                                        return this.dataManagerService.getAlertsRecipientCTN();
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.isAlertsRecipient = function (ctn) {
                                        return (this.dataManagerService.getAlertsRecipientCTN() === ctn);
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.getSeeLinks = function () {
                                        return this.seeLinks;
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.seeAddLine = function () {
                                        this.dataManagerSeeService.goToAddLine();
                                        return;
                                    };
                                    DataManagerVideoThrottleControlTagListController.prototype.getDiscoveryParams = function () {
                                        var config = this.dataManagerService.getConfig();
                                        var model = this.dataManagerService.getModel();
                                        return {
                                            ban: model.accountNumber,
                                            ctn: model.dataControlList.length > 0 ? model.dataControlList[0].ctn : '',
                                            copy: this.$filter('translate')('ute.dataManager.dataAlerts.informationLink'),
                                            brand: config.advanced.dataManagerDiscoveryIntegration.brand,
                                            segment: config.advanced.dataManagerDiscoveryIntegration.segment,
                                            accountType: config.advanced.dataManagerDiscoveryIntegration.accountType,
                                            productType: config.advanced.dataManagerDiscoveryIntegration.productType,
                                            pageFilter: config.advanced.dataManagerDiscoveryIntegration.pageFilter,
                                            province: model.province
                                        };
                                    };
                                    DataManagerVideoThrottleControlTagListController.$inject = ['$scope', '$filter', '$state', '$rootScope', 'ute.data.manager.service', 'ute.data.manager.see.service', 'ute.blocks.language.switcher'];
                                    return DataManagerVideoThrottleControlTagListController;
                                }());
                                list.DataManagerVideoThrottleControlTagListController = DataManagerVideoThrottleControlTagListController;
                                angular.module('ute.data.manager.video.throttle.control.tag.list').controller('ute.data.manager.video.throttle.control.tag.list.controller', DataManagerVideoThrottleControlTagListController);
                            })(list = tag.list || (tag.list = {}));
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            var list;
                            (function (list) {
                                'use strict';
                                angular.module('ute.data.manager.video.throttle.control.tag.list').directive('uteDataManagerVideoThrottleControlTagList', uteDataManagerVideoThrottleControlTagList);
                                uteDataManagerVideoThrottleControlTagList.$inject = ['ute.data.manager.service',
                                    'ute.common.utils.service'];
                                /* @ngInject */
                                function uteDataManagerVideoThrottleControlTagList(dataManagerService, utilsService) {
                                    return {
                                        restrict: 'E',
                                        scope: {},
                                        templateUrl: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlTagListDirective.templateUrl,
                                        controller: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlTagListDirective.controllerName,
                                        controllerAs: 'dataManagerVideoThrottleControlTagList',
                                        link: function (scope, element, attrs, controller) {
                                            utilsService.setElementScope(angular.element(element[0].childNodes[0]), scope);
                                        }
                                    };
                                }
                            })(list = tag.list || (tag.list = {}));
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var toggle;
                    (function (toggle) {
                        'use strict';
                        var DataManagerVideoThrottleDirectiveController = (function () {
                            /* @ngInject */
                            function DataManagerVideoThrottleDirectiveController($rootScope, $scope, $state, $modal, $translate, dataManagerService, dtmService, messagesService) {
                                this.$rootScope = $rootScope;
                                this.$scope = $scope;
                                this.$state = $state;
                                this.$modal = $modal;
                                this.$translate = $translate;
                                this.dataManagerService = dataManagerService;
                                this.dtmService = dtmService;
                                this.messagesService = messagesService;
                                this.isSetVideoQualityAPICallInProgress = false;
                                this.rootScope = $rootScope;
                                this.scope = $scope;
                            }
                            DataManagerVideoThrottleDirectiveController.prototype.enableHighQualityVideoCall = function (ctn) {
                                var self = this;
                                this.isSetVideoQualityAPICallInProgress = true;
                                this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().start, this.dataManagerService.getDataLayerEvent().videoThrottlingToggleOFF);
                                // Notify server about this change
                                this.dataManagerService.setVideoQualityAPI(this.scope.ctn, false)
                                    .then(function (result) {
                                    if (result && result.data && result.data.body && result.data.body.isSuccess) {
                                        self.dataManagerService.trackDataLayerInteraction(self.dataManagerService.getDataLayerStep().complete, self.dataManagerService.getDataLayerEvent().videoThrottlingToggleOFF);
                                        self.setVideoQualityReduced(self.scope.ctn, false);
                                    }
                                    else {
                                        var errorMessageKey = 'ute.dataManager.videoThrottle.errorSetThrottle';
                                        self.errorModalPopup('ute.dataManager.videoThrottle.errorHeading', errorMessageKey, {
                                            event: self.dataManagerService.getDataLayerEvent().videoThrottlingToggleOFF,
                                            error: result
                                        });
                                        self.setVideoQualityReduced(self.scope.ctn, true);
                                    }
                                })
                                    .catch(function (error) {
                                    var errorMessageKey = 'ute.dataManager.videoThrottle.errorSetThrottle';
                                    self.errorModalPopup('ute.dataManager.videoThrottle.errorHeading', errorMessageKey, {
                                        event: self.dataManagerService.getDataLayerEvent().videoThrottlingToggleOFF,
                                        error: error
                                    });
                                    self.setVideoQualityReduced(self.scope.ctn, true);
                                })
                                    .finally(function () {
                                    self.isSetVideoQualityAPICallInProgress = false;
                                });
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.errorModalPopup = function (primary, secondary, trackData) {
                                var errorModalScope = this.rootScope.$new();
                                errorModalScope.params = { primary: primary, secondary: secondary, trackData: trackData };
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                    controllerAs: 'dataManagerGenericModal',
                                    size: 'md',
                                    backdrop: 'static',
                                    scope: errorModalScope
                                });
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.confirmReduceQualityModalPopup = function (ctn) {
                                var _this = this;
                                this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().start, this.dataManagerService.getDataLayerEvent().viewReduceVideoQualityModal);
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerVideoThrottleModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerVideoThrottleModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerVideoThrottleModal.controllerName,
                                    controllerAs: 'dataManagerVideoThrottleModal',
                                    size: 'md',
                                    scope: this.scope,
                                    backdrop: 'static'
                                }).result.then(function (data) {
                                    switch (data.result) {
                                        case 'yes':
                                            _this.modalUserAnswerYes(data.doNotShowModal);
                                            break;
                                        case 'no':
                                            _this.modalUserAnswerNo();
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                    _this.modalDismissed();
                                });
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.modalUserAnswerYes = function (doNotShowModal) {
                                var self = this;
                                this.isSetVideoQualityAPICallInProgress = true;
                                this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().start, this.dataManagerService.getDataLayerEvent().videoThrottlingToggleON);
                                this.dataManagerService.setVideoQualityAPI(this.scope.ctn, true)
                                    .then(function (result) {
                                    if (result && result.data && result.data.body && result.data.body.isSuccess) {
                                        self.dataManagerService.trackDataLayerInteraction(self.dataManagerService.getDataLayerStep().complete, self.dataManagerService.getDataLayerEvent().videoThrottlingToggleON);
                                        self.setVideoQualityReduced(self.scope.ctn, true);
                                        if (doNotShowModal !== undefined) {
                                            //set show modal preference
                                            self.dataManagerService.setShowVideoThrottleConfirmationModalPref(doNotShowModal);
                                        }
                                    }
                                    else {
                                        var errorMessageKey = 'ute.dataManager.videoThrottle.errorSetThrottle';
                                        self.setVideoQualityReduced(self.scope.ctn, false);
                                        self.errorModalPopup('ute.dataManager.videoThrottle.errorHeading', errorMessageKey, {
                                            event: self.dataManagerService.getDataLayerEvent().videoThrottlingToggleON,
                                            error: result
                                        });
                                    }
                                })
                                    .catch(function (error) {
                                    var errorMessageKey = 'ute.dataManager.videoThrottle.errorSetThrottle';
                                    self.setVideoQualityReduced(self.scope.ctn, false);
                                    self.errorModalPopup('ute.dataManager.videoThrottle.errorHeading', errorMessageKey, {
                                        event: self.dataManagerService.getDataLayerEvent().videoThrottlingToggleON,
                                        error: error
                                    });
                                })
                                    .finally(function () {
                                    self.isSetVideoQualityAPICallInProgress = false;
                                });
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.modalUserAnswerNo = function () {
                                this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().start, this.dataManagerService.getDataLayerEvent().cancelButtonInteraction);
                                this.setVideoQualityReduced(this.scope.ctn, false);
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.modalDismissed = function () {
                                this.modalUserAnswerNo();
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.getDataAccessCTN = function (ctn) {
                                return this.dataManagerService.getDataAccessCTN(ctn);
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.getVideoQualityReducedCTN = function (ctn) {
                                return this.dataManagerService.getVideoQualityReducedCTN(ctn);
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.setVideoQualityReduced = function (ctn, val) {
                                this.videoQualityReduced = val;
                                this.dataManagerService.setVideoQualityReducedCTN(ctn, val);
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.videoQualityReducedChange = function () {
                                if (this.videoQualityReduced) {
                                    if (this.dataManagerService.getShowVideoThrottleConfirmationModalPref()) {
                                        this.confirmReduceQualityModalPopup(this.scope.ctn);
                                        return;
                                    }
                                    //By pass the modal confirmation
                                    this.modalUserAnswerYes();
                                }
                                else {
                                    this.enableHighQualityVideoCall(this.scope.ctn);
                                }
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.swipeLeft = function () {
                                if (this.videoQualityReduced) {
                                    this.videoQualityReduced = !this.videoQualityReduced;
                                    this.videoQualityReducedChange();
                                }
                            };
                            DataManagerVideoThrottleDirectiveController.prototype.swipeRight = function () {
                                if (!this.videoQualityReduced) {
                                    this.videoQualityReduced = !this.videoQualityReduced;
                                    this.videoQualityReducedChange();
                                }
                            };
                            DataManagerVideoThrottleDirectiveController.$inject = ['$rootScope', '$scope', '$state', '$modal', '$translate', 'ute.data.manager.service', 'ute.dtm.service', 'ute.blocks.messages.bus.service'];
                            return DataManagerVideoThrottleDirectiveController;
                        }());
                        toggle.DataManagerVideoThrottleDirectiveController = DataManagerVideoThrottleDirectiveController;
                        angular.module('ute.data.manager.video.throttle.toggle').controller('ute.data.manager.video.throttle.directive.controller', DataManagerVideoThrottleDirectiveController);
                    })(toggle = throttle.toggle || (throttle.toggle = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var toggle;
                    (function (toggle) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.toggle').directive('uteDataManagerVideoThrottleDirective', uteDataManagerVideoThrottleDirective);
                        uteDataManagerVideoThrottleDirective.$inject = ['ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerVideoThrottleDirective(dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: {
                                    'ctn': '@',
                                    'colorCode': '@',
                                    'onCopy': '@',
                                    'offCopy': '@',
                                    'videoQualityReduced': '@'
                                },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerVideoThrottleDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerVideoThrottleDirective.controllerName,
                                controllerAs: 'dataManagerVideoThrottleDirective',
                                link: function (scope, element, attrs, controller) {
                                    var uteDataManagerDataControlDataAccessMDThumb = angular.element(element[0].getElementsByClassName('md-bar'));
                                    var uteDataManagerDataControlColorDataAccessMDThumb = angular.element(element[0].getElementsByClassName('md-label'));
                                    controller.videoQualityReduced = scope.videoQualityReduced;
                                    scope.switchValueChange = function (newVal) {
                                        if (newVal) {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                            uteDataManagerDataControlColorDataAccessMDThumb.css('color', scope.colorCode);
                                        }
                                        else {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                            uteDataManagerDataControlColorDataAccessMDThumb.css('color', '#D1D1D1');
                                        }
                                    };
                                    scope.$watch('ctn', function (newCTN, oldCTN) {
                                        if (newCTN) {
                                            controller.videoQualityReduced = dataManagerService.getVideoQualityReducedCTN(scope.ctn);
                                            if (controller.videoQualityReduced) {
                                                uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                                uteDataManagerDataControlColorDataAccessMDThumb.css('color', scope.colorCode);
                                            }
                                            else {
                                                uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                                uteDataManagerDataControlColorDataAccessMDThumb.css('color', '#D1D1D1');
                                            }
                                        }
                                    });
                                    scope.$watch(function () { return controller.videoQualityReduced; }, function (videoQualityReduced) {
                                        if (videoQualityReduced) {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', scope.colorCode);
                                            uteDataManagerDataControlColorDataAccessMDThumb.css('color', scope.colorCode);
                                        }
                                        else {
                                            uteDataManagerDataControlDataAccessMDThumb.css('backgroundColor', '#D1D1D1');
                                            uteDataManagerDataControlColorDataAccessMDThumb.css('color', '#D1D1D1');
                                        }
                                    });
                                }
                            };
                        }
                    })(toggle = throttle.toggle || (throttle.toggle = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var app;
    (function (app) {
        var banner;
        (function (banner) {
            'use strict';
            var AppBannerController = (function () {
                /* @ngInject */
                function AppBannerController($scope, $state, $window, $document, appBannerService) {
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$window = $window;
                    this.$document = $document;
                    this.appBannerService = appBannerService;
                    this.scope = $scope;
                    this.document = $document;
                }
                AppBannerController.prototype.getAppClick = function () {
                    this.$window.location.href = this.scope.androidUrl;
                };
                AppBannerController.prototype.closeBannerClick = function () {
                    this.scope.isOpen = false;
                };
                AppBannerController.prototype.isAndroid = function () {
                    return /Android/i.test(navigator.userAgent);
                };
                AppBannerController.prototype.getAndroidAppUrl = function () {
                    return this.appBannerService.getConfig().basic.androidAppUrl;
                };
                AppBannerController.$inject = ['$scope', '$state', '$window', '$document', 'ute.app.banner'];
                return AppBannerController;
            }());
            banner.AppBannerController = AppBannerController;
            angular.module('ute.app.banner').controller('ute.app.banner.controller', AppBannerController);
        })(banner = app.banner || (app.banner = {}));
    })(app = ute.app || (ute.app = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var app;
    (function (app) {
        var banner;
        (function (banner) {
            'use strict';
            angular.module('ute.app.banner').directive('uteAppBanner', uteAppBanner);
            uteAppBanner.$inject = ['$window', '$compile', 'ute.app.banner'];
            /* @ngInject */
            function uteAppBanner($window, $compile, appBannerService) {
                return {
                    restrict: 'E',
                    scope: { androidUrl: '@' },
                    templateUrl: appBannerService.getConfig().basic.templateUrl,
                    controller: appBannerService.getConfig().basic.controllerName,
                    controllerAs: 'appBanner',
                    link: function (scope, element) {
                        scope.isOpen = true;
                        var isMobile = {
                            Windows: function () {
                                return /IEMobile/i.test(navigator.userAgent);
                            },
                            Android: function () {
                                return /Android/i.test(navigator.userAgent);
                            },
                            BlackBerry: function () {
                                return /BlackBerry/i.test(navigator.userAgent);
                            },
                            iOS: function () {
                                return /iPhone|iPad|iPod/i.test(navigator.userAgent);
                            },
                            any: function () {
                                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
                            }
                        };
                        scope.isAndroid = false;
                        /*
                        MUST BE HANDLED IN INDEX.HTML
                          if (isMobile.iOS()) {
                            var head = $document.find('head').eq(0);
                            head.append('<meta name="' + appBannerService.getConfig().basic.appName + '" content="app-id="' + appBannerService.getConfig().basic.appId + '" />');
                          }
                        */
                        if (isMobile.Android()) {
                            scope.isAndroid = true;
                        }
                    }
                };
            }
        })(banner = app.banner || (app.banner = {}));
    })(app = ute.app || (ute.app = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var app;
    (function (app) {
        var banner;
        (function (banner) {
            'use strict';
            var AppBannerProvider = (function () {
                /* @ngInject */
                function AppBannerProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            controllerName: 'ute.app.banner.controller',
                            templateUrl: 'module/dataManager/uteAppBanner/appBanner.partial.html',
                            appId: '337618972',
                            appName: 'myrogers',
                            androidAppUrl: 'myrogers://fdms'
                        }
                    };
                    /* @ngInject */
                    this.$get = function ($injector, $translate) {
                        _this.$injector = $injector;
                        _this.$translate = $translate;
                        return {
                            getConfig: _this.getConfig,
                            $injector: _this.$injector
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * @returns {any}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$translate'
                    ];
                }
                AppBannerProvider.$inject = [];
                return AppBannerProvider;
            }());
            angular.module('ute.app.banner').provider('ute.app.banner', AppBannerProvider);
        })(banner = app.banner || (app.banner = {}));
    })(app = ute.app || (ute.app = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var app;
    (function (app) {
        var banner;
        (function (banner) {
            'use strict';
        })(banner = app.banner || (app.banner = {}));
    })(app = ute.app || (ute.app = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var vertical;
    (function (vertical) {
        var stack;
        (function (stack) {
            var bar;
            (function (bar) {
                var graph;
                (function (graph) {
                    'use strict';
                    var VerticalStackBarGraphController = (function () {
                        /* @ngInject */
                        function VerticalStackBarGraphController($state, $scope, messagesService) {
                            this.$state = $state;
                            this.$scope = $scope;
                            this.messagesService = messagesService;
                            this.scope = $scope;
                        }
                        VerticalStackBarGraphController.prototype.copyClick = function () {
                            this.messagesService.publish('ute-vertical-stack-bar-graph-copy-click', this.scope.index * 1);
                        };
                        VerticalStackBarGraphController.prototype.getPrimaryHeight = function () {
                            return this.scope.maxHeight * (this.scope.primaryValue / Math.max(this.scope.maxLimit, 1));
                        };
                        VerticalStackBarGraphController.prototype.getSecondaryHeight = function () {
                            return this.scope.maxHeight * (this.scope.secondaryValue / Math.max(this.scope.maxLimit, 1));
                        };
                        VerticalStackBarGraphController.prototype.getCopyType = function () {
                            return (this.getPrimaryHeight() > this.scope.flipHeight * 1) ? 'ute-verticalStackBarGraph-flipCopy' : 'ute-verticalStackBarGraph-unFlipCopy';
                        };
                        VerticalStackBarGraphController.prototype.getBarTopHeight = function () {
                            return Math.max(this.getPrimaryHeight(), this.getSecondaryHeight());
                        };
                        VerticalStackBarGraphController.prototype.getCopyBottomPos = function () {
                            // BRT-416: the code here looks odd, changed it to return 0.
                            return 0; //(this.getSecondaryHeight() > this.scope.flipHeight * 1) ? 0 : this.getBarTopHeight();
                        };
                        VerticalStackBarGraphController.prototype.getFlipTrigger = function () {
                            return (this.getPrimaryHeight() < this.scope.flipHeight * 1) && (this.getSecondaryHeight() < this.scope.flipHeight * 1);
                        };
                        VerticalStackBarGraphController.prototype.showBaseCopy = function () {
                            // BRT-416: the calculation here has problem
                            // return (this.scope.baseFlipHidden === 'true' && (this.getPrimaryHeight() < this.scope.flipHeight * 1));
                            return (this.scope.baseFlipHidden === 'true' && this.getFlipTrigger());
                        };
                        VerticalStackBarGraphController.$inject = ['$state', '$scope', 'ute.blocks.messages.bus.service'];
                        return VerticalStackBarGraphController;
                    }());
                    graph.VerticalStackBarGraphController = VerticalStackBarGraphController;
                    angular.module('ute.vertical.stack.bar.graph').controller('ute.vertical.stack.bar.graph.controller', VerticalStackBarGraphController);
                })(graph = bar.graph || (bar.graph = {}));
            })(bar = stack.bar || (stack.bar = {}));
        })(stack = vertical.stack || (vertical.stack = {}));
    })(vertical = ute.vertical || (ute.vertical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var vertical;
    (function (vertical) {
        var stack;
        (function (stack) {
            var bar;
            (function (bar) {
                var graph;
                (function (graph) {
                    'use strict';
                    angular.module('ute.vertical.stack.bar.graph').directive('uteVerticalStackBarGraph', uteVerticalStackBarGraph);
                    uteVerticalStackBarGraph.$inject = ['$timeout', '$document'];
                    /* @ngInject */
                    function uteVerticalStackBarGraph($timeout, $document) {
                        return {
                            restrict: 'E',
                            scope: {
                                'colorCode': '@',
                                'baseCopy': '@',
                                'secondaryCopy': '@',
                                'maxLimit': '@',
                                'primaryValue': '@',
                                'secondaryValue': '@',
                                'flipHeight': '@',
                                'maxHeight': '@',
                                'index': '@',
                                'baseFlipHidden': '@'
                            },
                            templateUrl: 'module/dataManager/verticalStackBarGraph/verticalStackBarGraph.view.html',
                            controller: 'ute.vertical.stack.bar.graph.controller',
                            controllerAs: 'verticalStackBarGraph',
                            link: function (scope, element, attrs, controller) {
                                var primaryBar = angular.element(element[0].getElementsByClassName('ute-verticalStackBarGraph-primaryBar'));
                                var secondaryBar = angular.element(element[0].getElementsByClassName('ute-verticalStackBarGraph-secondaryBar'));
                                var baseCopy = angular.element(element[0].getElementsByClassName('ute-verticalStackBarGraph-baseCopy'));
                                var secondaryCopyContainer = angular.element(element[0].getElementsByClassName('ute-verticalStackBarGraph-secondaryCopyContainer'));
                                var nameHeightOffset = 15;
                                var bottomPositionHandler = function () {
                                    primaryBar.css('height', Math.min(controller.getPrimaryHeight(), scope.maxHeight));
                                    secondaryBar.css('height', Math.min(controller.getSecondaryHeight(), scope.maxHeight));
                                    secondaryCopyContainer.css('height', Math.max((controller.getSecondaryHeight() + nameHeightOffset), (controller.getPrimaryHeight() + nameHeightOffset)));
                                    baseCopy.css('bottom', controller.getCopyBottomPos());
                                };
                                $timeout(function () {
                                    primaryBar.css('background-color', scope.colorCode);
                                    secondaryBar.css('background-color', scope.colorCode);
                                    bottomPositionHandler();
                                    $timeout(function () {
                                        baseCopy.css('opacity', 1);
                                    }, 1);
                                }, 1);
                                scope.$watch('maxHeight', function (newHeight, oldHeight) {
                                    if (newHeight !== oldHeight) {
                                        bottomPositionHandler();
                                    }
                                });
                                scope.$watch('secondaryValue', function (newValue, oldValue) {
                                    secondaryBar.css('height', Math.min(controller.getSecondaryHeight(), scope.maxHeight));
                                    bottomPositionHandler();
                                });
                            }
                        };
                    }
                })(graph = bar.graph || (bar.graph = {}));
            })(bar = stack.bar || (stack.bar = {}));
        })(stack = vertical.stack || (vertical.stack = {}));
    })(vertical = ute.vertical || (ute.vertical = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var directive;
            (function (directive) {
                'use strict';
                var DiscoveryPageDirectiveController = (function () {
                    /* @ngInject */
                    function DiscoveryPageDirectiveController($scope, $state, $modal, $window, discoveryPageService) {
                        this.$scope = $scope;
                        this.$state = $state;
                        this.$modal = $modal;
                        this.$window = $window;
                        this.discoveryPageService = discoveryPageService;
                        this.model = this.discoveryPageService.getModel();
                        this.scope = $scope;
                        this.autoLaunch = this.scope.autoLaunch;
                        this.tooltipmode = this.scope.tooltipmode;
                        this.paramObject = this.scope.paramObject;
                        this.copy = this.scope.copy;
                        this.serverData = this.scope.serverData;
                        this.linkText = this.scope.linkText;
                        // Re-map the functions to scope due to the stupid scope limit in event broadcast -> receive function
                        $scope.scope = this.scope;
                        $scope.collectDataFromServer = this.collectDataFromServer;
                        $scope.discoveryPageService = this.discoveryPageService;
                        $scope.autoLaunchModal = this.autoLaunchModal;
                        $scope.confirmDataCancelModalPopup = this.confirmDataCancelModalPopup;
                        $scope.modalUserAnswerYes = this.modalUserAnswerYes;
                        $scope.modalUserAnswerNo = this.modalUserAnswerNo;
                        $scope.modalDismissed = this.modalDismissed;
                        $scope.$modal = this.$modal;
                        $scope.serverData = this.serverData;
                        // Server call - Commented outto not be annoing to other developers
                        // this.collectDataFromServer();
                        // Listen to bradcast from all around
                        // $scope.$broadcast('launchDiscoveryPage', null); - excecute
                        //this.$rootScope.$on('ute-discovery-page-activate', function(event: ng.IAngularEvent, data: any) {
                        var _this = this;
                        $scope.$on('launchDiscoveryPage', function (event, data) {
                            if (_this.discoveryPageService.getBRT()) {
                                event.currentScope = $scope;
                                $scope.collectDataFromServer();
                            }
                        });
                    }
                    DiscoveryPageDirectiveController.prototype.collectDataFromServer = function () {
                        // Collect data from server
                        var _this = this;
                        var dataPassObject = {};
                        dataPassObject.userId = this.paramObject.userId;
                        dataPassObject.brand = this.paramObject.brand;
                        dataPassObject.segment = this.paramObject.segment;
                        dataPassObject.accountType = this.paramObject.accountType;
                        dataPassObject.productType = this.paramObject.productType;
                        dataPassObject.pageFilter = this.paramObject.pageFilter;
                        dataPassObject.provinceCode = this.paramObject.province;
                        dataPassObject.involveInteractionState = false;
                        this.discoveryPageService.serverGetContent(dataPassObject).then(function (result) {
                            if (result.status === 200) {
                                // Pass - process the data
                                try {
                                    var oneSegment = result.data.body;
                                    if (oneSegment.isActive === 'Y') {
                                        _this.serverData = oneSegment;
                                        _this.serverData.englishContent.topicButtonUrl = _this.serverData.englishContent.topicButtonUrl.split(',');
                                        _this.serverData.frenchContent.topicButtonUrl = _this.serverData.frenchContent.topicButtonUrl.split(',');
                                        _this.autoLaunchModal();
                                    }
                                }
                                catch (e) {
                                }
                            }
                            else {
                            }
                        });
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.autoLaunchModal = function () {
                        this.confirmDataCancelModalPopup();
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.confirmDataCancelModalPopup = function () {
                        var _this = this;
                        this.scope.autoLaunch = this.autoLaunch;
                        this.scope.tooltipmode = this.tooltipmode;
                        this.scope.paramObject = this.paramObject;
                        this.scope.copy = this.copy;
                        this.scope.serverData = this.serverData;
                        this.$modal.open({
                            windowTemplateUrl: this.discoveryPageService.getConfig().advanced.discoveryPageDirectiveModal.windowTemplateUrl,
                            templateUrl: this.discoveryPageService.getConfig().advanced.discoveryPageDirectiveModal.templateUrl,
                            controller: this.discoveryPageService.getConfig().advanced.discoveryPageDirectiveModal.controllerName,
                            controllerAs: 'discoveryPageDirectiveModal',
                            size: 'lg',
                            scope: this.scope,
                            backdrop: 'static'
                        }).result.then(function (result) {
                            // Result selection behaviour
                            switch (result) {
                                case 'yes':
                                    _this.modalUserAnswerYes();
                                    break;
                                case 'no':
                                    _this.modalUserAnswerNo();
                                    break;
                            }
                        }, function () {
                            // Dismiss behaviour
                            // Do nothing/close
                            _this.modalDismissed();
                        });
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.modalUserAnswerYes = function () {
                        // console.log ('User Answered - yes');
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.modalUserAnswerNo = function () {
                        // console.log ('User Answered - no');
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.modalDismissed = function () {
                        // console.log ('User dismissed the modal');
                    };
                    ;
                    // Testing stuff - delete after development is finished
                    DiscoveryPageDirectiveController.prototype.openDiscoveryModal = function () {
                        this.collectDataFromServer();
                    };
                    ;
                    DiscoveryPageDirectiveController.prototype.getLinkText = function () {
                        return (this.linkText && this.linkText !== '') ? this.linkText : 'ute.discoveryPage.directive.whyWouldI';
                    };
                    DiscoveryPageDirectiveController.$inject = ['$scope', '$state', '$modal', '$window', 'ute.discovery.page.service'];
                    return DiscoveryPageDirectiveController;
                }());
                directive.DiscoveryPageDirectiveController = DiscoveryPageDirectiveController;
                angular.module('ute.discovery.page.directive').controller('ute.discovery.page.directive.directive.controller', DiscoveryPageDirectiveController);
            })(directive = page.directive || (page.directive = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var directive;
            (function (directive) {
                'use strict';
                angular.module('ute.discovery.page.directive').directive('uteDiscoveryPageDirective', uteDiscoveryPageDirective);
                uteDiscoveryPageDirective.$inject = ['ute.discovery.page.service', '$window', '$animate', '$document', '$timeout'];
                /* @ngInject */
                function uteDiscoveryPageDirective(discoveryPageService, $window, $animate, $document, $timeout) {
                    return {
                        restrict: 'AE',
                        scope: { 'autolaunch': '=', 'tooltipmode': '=', 'paramload': '=' },
                        templateUrl: discoveryPageService.getConfig().advanced.discoveryPageDirective.templateUrl,
                        controller: discoveryPageService.getConfig().advanced.discoveryPageDirective.controllerName,
                        controllerAs: 'discoveryPageDirective',
                        link: function (scope, element, attrs, controller) {
                            var paramObject = {};
                            var autolaunch = false;
                            var tooltipmode = false;
                            scope.nextSlide = function () {
                                // $('#myCarousel').carousel('next'); //TODO: -- these will keep ts from compiling, we need to resolve carousel typings
                                $timeout(function () {
                                    $('.right').trigger('click');
                                }, 10);
                            };
                            scope.prevSlide = function () {
                                // $('#myCarousel').carousel('prev'); //TODO: -- these will keep ts from compiling, we need to resolve carousel typings
                                $timeout(function () {
                                    $('.left').trigger('click');
                                }, 10);
                            };
                            // No attribute is mandatory -> test and use what was provided
                            try {
                                // sanitize attributes
                                autolaunch = (attrs.autolaunch === 'true') ? true : false;
                                tooltipmode = (attrs.tooltipmode === 'true') ? true : false;
                                // read passed object
                                paramObject = scope.paramload;
                                if (paramObject.userId !== null && paramObject.ban === null && paramObject.ctn === null) {
                                }
                                else if (paramObject.userId === null && paramObject.ban !== null && paramObject.ctn !== null) {
                                }
                                else {
                                }
                                /* -- scope.paramload
                                      this.discoveryModalObject = {
                                        userId: 'd@g.com',              // null in mobile
                                        ban: '879200389',               // null for web
                                        ctn: '4162873298',              // null for web
                                
                                        copy: 'Discovery Page Modal',
                                        brand: 'ROGERS',
                                        segment: 'CONSUMER',
                                        accountType: 'WIRELESS',
                                        productType: 'WL_POSTPAID',
                                        pageFilter: 'SHARE_EVERYTHING',
                                        province: 'ON'
                                      };
                                //*/
                                // Assign to controller
                                controller.paramObject = scope.paramload;
                                controller.autoLaunch = autolaunch;
                                controller.tooltipmode = tooltipmode;
                                controller.copy = paramObject.copy;
                                controller.linkText = attrs.linkText;
                                // Assign to scope
                                scope.paramObject = scope.paramload;
                                scope.autoLaunch = autolaunch;
                                scope.tooltipmode = tooltipmode;
                                scope.linkText = attrs.linkText;
                                scope.copy = paramObject.copy;
                            }
                            catch (e) {
                            }
                            // Initiate the server call to collect the data
                            if (autolaunch) {
                                controller.collectDataFromServer();
                            }
                        }
                    };
                }
            })(directive = page.directive || (page.directive = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var service;
            (function (service) {
                'use strict';
            })(service = page.service || (page.service = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var service;
            (function (service) {
                'use strict';
                var DiscoveryPageProvider = (function () {
                    /* @ngInject */
                    function DiscoveryPageProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                applicationId: 'ute-application-id',
                                mainControllerName: 'ute.data.manager.main.controller',
                                mainTemplateUrl: 'module/discoveryPage/discoveryPageMain.view.html',
                                urlSuffix: '/web/totes'
                            },
                            advanced: {
                                discoveryPageDirective: {
                                    controllerName: 'ute.discovery.page.directive.directive.controller',
                                    templateUrl: 'module/discoveryPage/discoveryPageDirective/discoveryPageDirective.partial.html'
                                },
                                discoveryPageDirectiveModal: {
                                    windowTemplateUrl: 'module/discoveryPage/discoveryPageDirective/discoveryPageDirective.window.html',
                                    templateUrl: 'module/discoveryPage/discoveryPageDirective/discoveryPageDirectiveModal/discoveryPageDirectiveModal.partial.html',
                                    controllerName: 'ute.discovery.page.directive.modal.controller'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function ($injector, $state, $http, $q, $translate) {
                            _this.$injector = $injector;
                            _this.$state = $state;
                            _this.$http = $http;
                            _this.$q = $q;
                            _this.$translate = $translate;
                            return {
                                getConfig: _this.getConfig,
                                getModel: _this.getModel,
                                getLanguage: _this.getLanguage,
                                serverGetContent: _this.serverGetContent,
                                getBRT: _this.getBRT,
                                setBRT: _this.setBRT,
                                serverSetInteractionState: _this.serverSetInteractionState,
                                $injector: _this.$injector
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        /**
                         * @returns {any}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        /**
                         * Return immutable IDiscoveryPageModel object
                         * @returns {IDiscoveryPageModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /**
                         * @returns {string}
                         */
                        this.getLanguage = function () {
                            var returnLanguage = '';
                            returnLanguage = _this.$translate.use();
                            return returnLanguage;
                        };
                        /**
                         *
                         * @param brt
                         */
                        this.getBRT = function () {
                            return _this.isBRTEnabled;
                        };
                        /**
                         *
                         * @param brt
                         */
                        this.setBRT = function (brt) {
                            _this.isBRTEnabled = brt;
                        };
                        // server call - /v1/discovery-page/get-content
                        this.serverGetContent = function (dataPassObject) {
                            // Service keeps copy of the data for later use in serverSetInteractionState
                            if (_this.dataPassObject === null) {
                                _this.dataPassObject = dataPassObject;
                            }
                            var reqData = {
                                'userId': dataPassObject.userId,
                                'brand': dataPassObject.brand,
                                'segment': dataPassObject.segment,
                                'accountType': dataPassObject.accountType,
                                'productType': dataPassObject.productType,
                                'pageFilter': dataPassObject.pageFilter,
                                'provinceCode': dataPassObject.provinceCode
                            };
                            if (dataPassObject.pageFilter === 'SHARE_EVERYTHING') {
                                reqData.involveInteractionState = dataPassObject.involveInteractionState; //Request value required only for share everything page
                            }
                            if (dataPassObject.pageFilter === 'ACCOUNT_OVERVIEW') {
                                reqData.pageFilter = 'SHARE_EVERYTHING'; //Todo - Send Actual page filter value based on server contract
                            }
                            var req = {
                                method: 'POST',
                                url: '/web/RogersServices.portal/totes/api/v1/discovery-page/get-content',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: reqData
                            };
                            return _this.$http(req)
                                .then(_this.serverGetContentSuccess)
                                .catch(_this.serverGetContentFail);
                        };
                        this.serverGetContentSuccess = function (response) {
                            var processedResponse = response;
                            return processedResponse;
                        };
                        this.serverGetContentFail = function (response) {
                            return response;
                        };
                        // server call - /v1/discovery-page/set-interaction-state
                        this.serverSetInteractionState = function (intState) {
                            // Service keeps copy of the last data used in serverGetContent
                            var dataPassObject = {};
                            if (_this.dataPassObject !== null) {
                                dataPassObject = _this.dataPassObject;
                            }
                            var req = {
                                method: 'POST',
                                url: '/web/RogersServices.portal/totes/api/v1/discovery-page/set-interaction-state',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                data: {
                                    'userId': dataPassObject.userId,
                                    'pageTopicId': 'TOPIC_1',
                                    'interactionState': intState
                                }
                            };
                            return _this.$http(req)
                                .then(_this.serverSetInteractionStateSuccess)
                                .catch(_this.serverSetInteractionStateFail);
                        };
                        this.serverSetInteractionStateSuccess = function (response) {
                            var processedResponse = response.data;
                            // clean-up after successful call
                            if (_this.dataPassObject !== null) {
                                _this.dataPassObject = null;
                            }
                            return processedResponse;
                        };
                        this.serverSetInteractionStateFail = function (response) {
                            return response;
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$q',
                            '$translate'
                        ];
                        this.dataPassObject = null;
                    }
                    DiscoveryPageProvider.$inject = [];
                    return DiscoveryPageProvider;
                }());
                angular.module('ute.discovery.page.service').provider('ute.discovery.page.service', DiscoveryPageProvider);
            })(service = page.service || (page.service = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var service;
            (function (service) {
                'use strict';
            })(service = page.service || (page.service = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

// /**
//  * Created by Vikash Singh on 05/07/17.
//  */
// module ute.payment.method.integration {
//     'use strict';
//
//     import IDataLayerCommonServiceProvider = ute.datalayer.common.service.IDataLayerServiceProvider;
//     import IDataLayerServiceConfig = ute.datalayer.common.service.IDataLayerServiceConfig;
//
//     angular.module('ute.easy.login.registration').config(configureDataLayer);
//
//     configureDataLayer.$inject = ['ute.datalayer.common.serviceProvider'];
//
//     function configureDataLayer(dataLayerCommonServiceProvider: IDataLayerCommonServiceProvider) {
//         let sefServeName = 'account registration';
//         let hierarchy = ['myrogers', 'registration'];
//         let selfServe = {
//             name: sefServeName,
//             type: 'transaction'
//         };
//
//         let config: IDataLayerServiceConfig = {
//             advance: {
//                 mappingKey: {
//                     accountRegistration: {
//                         main: {
//                             page: {
//                                 name: 'registration main',
//                                 hierarchy: hierarchy
//                             }
//                         },
//                         account: {
//                             page: {
//                                 name: 'registration step1 account',
//                                 hierarchy: hierarchy
//                             },
//                             selfServe: selfServe,
//                             events: {
//                                 selfServeStart: true
//                             }
//                         },
//                         email: {
//                             page: {
//                                 name: 'registration step2 email',
//                                 hierarchy: hierarchy
//                             }
//                         },
//                         resendEmail: {
//                             page: {
//                                 name: 'registration step3 verify',
//                                 hierarchy: hierarchy
//                             },
//                             selfServe: {
//                                 name: 'account registration - resend email',
//                                 type: 'inquiry'
//                             }
//                         },
//                         verify: {
//                             page: {
//                                 name: 'registration step3 verify',
//                                 hierarchy: hierarchy
//                             }
//                         },
//                         password: {
//                             page: {
//                                 name: 'registration step4 password',
//                                 hierarchy: hierarchy
//                             }
//                         },
//                         complete: {
//                             page: {
//                                 name: 'registration step5 complete',
//                                 hierarchy: hierarchy
//                             },
//                             selfServe: selfServe,
//                             events: {
//                                 selfServeComplete: true
//                             }
//                         },
//                         great_news: {
//                             page: {
//                                 name: 'registration resume great news',
//                                 hierarchy: hierarchy
//                             }
//                         },
//                         great_news_verify: {
//                             page: {
//                                 name: 'registration resume verify',
//                                 hierarchy: hierarchy
//                             }
//                         }
//                     }
//                 }
//             }
//         };
//         dataLayerCommonServiceProvider.configure(config);
//     }
// }

var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                function DefaultConfigFactory() {
                    return null;
                }
                registration.DefaultConfigFactory = DefaultConfigFactory;
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var easy;
    (function (easy) {
        var login;
        (function (login) {
            var registration;
            (function (registration) {
                'use strict';
                var RegistrationProviderBase = (function () {
                    function RegistrationProviderBase() {
                        var _this = this;
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        /**
                         * @returns {C}
                         */
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                    }
                    return RegistrationProviderBase;
                }());
                registration.RegistrationProviderBase = RegistrationProviderBase;
                angular.module('ute.easy.login.registration').constant('RegistrationProviderBase', RegistrationProviderBase);
                var EasyLoginRegistrationService = (function () {
                    function EasyLoginRegistrationService(config, $http, $q, $cookies) {
                        var _this = this;
                        this.config = config;
                        this.$http = $http;
                        this.$q = $q;
                        this.$cookies = $cookies;
                        this.loginAttempts = 0;
                        this.getLoginAttempts = function () {
                            return _this.loginAttempts;
                        };
                        this.getConfig = function () { return angular.copy(_this.config); };
                        /**
                         * Return immutable IEasyLoginRegistrationModel object
                         * @returns {IEasyLoginRegistrationModel}
                         */
                        this.getModel = function () {
                            return angular.copy(_this.model);
                        };
                        /* Rogers Micro Services Start */
                        this.rogersGetCrossApplicationID = function () {
                            return { 'realm': _this.config.basic.branding, 'applicationId': _this.config.basic.applicationId };
                        };
                        this.rogersGetRequesttoVerify = function (apiEndPoint) {
                            return _this.$http.get(apiEndPoint, { headers: _this.rogersGetCrossApplicationID() });
                        };
                        // step 1
                        this.rogersRequestAccountNumber = function (params) {
                            var urlParams = _this.config.advanced.apis.accounts + '?op=tryCreate&recaptcha=' + params.captcha;
                            return _this.makePostRequest(urlParams, { 'accountNumber': params.accountNumber.toString(), 'postalCode': params.postalCode.replace(/\s/g, '') }, { headers: _this.rogersGetCrossApplicationID() });
                        };
                        // step 2
                        this.rogersRequestEmail = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.sendEmail, params, { headers: _this.rogersGetCrossApplicationID() });
                        };
                        // step 3 - get request
                        this.rogersVerifyEmail = function (params) {
                            var urlParams = _this.config.advanced.apis.verifyEmail + '?flow=selfReg&emailtoken=' + encodeURIComponent(params.token.toString());
                            return _this.rogersGetRequesttoVerify(urlParams);
                        };
                        // step 4
                        this.rogersCreatePassword = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.createPassword, params, { headers: _this.rogersGetCrossApplicationID() });
                        };
                        /* Rogers Micro Services End */
                        this.makeGetRequest = function (apiEndPoint, getUrlParams) {
                            return _this.$http.get(''.concat(apiEndPoint, getUrlParams));
                        };
                        this.makePostRequest = function (apiEndPoint, payload, headers) {
                            return _this.$http.post(apiEndPoint, payload, headers);
                        };
                        this.requestAccountNumber = function (params) {
                            var urlParams = params.accountNumber.toString() +
                                '?op=check&recaptcha=' + params.captcha +
                                '&accountVerificationInfoKey=PostalCode&accountVerificationInfoValue=' +
                                params.postalCode.replace(/\s/g, '') +
                                '&brand=' + _this.config.basic.branding.toLowerCase();
                            return _this.makeGetRequest(_this.config.advanced.apis.accounts, urlParams);
                        };
                        this.requestSubAccount = function (params) {
                            var urlParams = _this.config.advanced.apis.subscriber + params.phoneNumber + '?op=check';
                            return _this.makePostRequest(urlParams, { 'recaptcha': params.captcha, 'smsContent': params.smsContent, 'mode': params.mode }, { headers: _this.getCrossApplicationID() });
                        };
                        this.requestSmsVerification = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.smsverify, params, { headers: _this.getCrossApplicationID() });
                        };
                        this.requestEmail = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.sendEmail, params, { headers: _this.getCrossApplicationID() });
                        };
                        this.verifyEmail = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.verifyEmail, params);
                        };
                        this.createPassword = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.createPassword, params, { headers: _this.getCrossApplicationID() });
                        };
                        this.linkAccount = function (params) {
                            return _this.makePostRequest(_this.config.advanced.apis.linkAccount, params, { headers: _this.getCrossApplicationID() });
                        };
                        this.easyLoginFido = function (username, password) {
                            return _this.janrainLogin(username, password).then(function (response) {
                                return response;
                            }).catch(function (e) {
                                ++_this.loginAttempts;
                                return e;
                            });
                        };
                        this.easyLoginRogers = function (username, password) {
                            var janrainLogin = _this.janrainLogin(username, password).then(function (response) {
                                _this.setupJanrainData(response.data);
                                return _this.esfLogin(username, password);
                            }).catch(function (e) {
                                ++_this.loginAttempts;
                                return e;
                            });
                            return janrainLogin;
                        };
                        this.getPasswordValidationRegExp = function () {
                            return _this.config.advanced.validation.passwordRegex;
                        };
                        this.esfLogin = function (username, password) {
                            return _this.discardSMSession()
                                .then(function (res) {
                                return _this.siteMinderLogin(username, password);
                            })
                                .then(function (res) {
                                return _this.loggedIn();
                            }).catch(function (e) {
                                return e;
                            });
                        };
                        this.loggedIn = function () {
                            return _this.makePostRequest(_this.config.advanced.apis.loggedIn, {});
                        };
                        this.discardSMSession = function () {
                            return _this.makePostRequest(_this.config.advanced.apis.discardSMSession, {});
                        };
                        this.siteMinderLogin = function (username, password) {
                            // let postData = {
                            //   USER: username,
                            //   password: password,
                            //   SMAUTHREASON: 0,
                            //   target: '/web/RogersServices.portal/totes/#/accountOverview'
                            // };
                            var body = encodeURI(''.concat('USER=' + username + '&password=' + password + '&SMAUTHREASON=0&target=/web/RogersServices.portal/totes/%23/accountOverview'));
                            var siteMinder = _this.makePostRequest(_this.config.advanced.apis.siteMinder, body, { headers: { 'Accept': 'text/plain, */*', 'Content-Type': 'application/x-www-form-urlencoded' } });
                            siteMinder.then(function (response) {
                                var data = response.data;
                                var loginUser = {
                                    userName: username,
                                    userEmail: username,
                                    userPassword: null,
                                    userType: 2
                                };
                                window.localStorage.setItem('ute.rogers.signin.user', JSON.stringify(loginUser));
                                return data;
                            });
                            return siteMinder;
                        };
                        this.janrainLogin = function (username, password) {
                            var payload = {
                                method: 'userpass',
                                brand: _this.config.basic.branding.toLowerCase(),
                                token: '',
                                user: username,
                                password: password,
                                lob: 'consumer'
                            };
                            var janrainLogin = _this.makePostRequest(_this.config.advanced.apis.janrainLogin, payload);
                            janrainLogin.then(function (response) {
                                var data = response.data;
                                /**
                                 * Save xSessionToken to session store storage
                                 */
                                if (data.content.length > 0 && _.has(data.content[0], 'xSessionToken')) {
                                    window.sessionStorage.setItem('xSessionToken', data.content[0].xSessionToken);
                                }
                                /**
                                 * Save GUID to session store storage
                                 */
                                if (data.content.length > 0 && _.has(data.content[1], 'guid')) {
                                    window.sessionStorage.setItem('guid', data.content[1].guid);
                                }
                                return data;
                            });
                            return janrainLogin;
                        };
                        this.setupJanrainData = function (res) {
                            var content1, accessToken = '', guid = '', email = '';
                            if (res.content.length > 1) {
                                content1 = res.content[1];
                            }
                            if (_.has(content1, 'accessToken')) {
                                accessToken = content1.accessToken;
                            }
                            if (_.has(content1, 'guid')) {
                                guid = content1.guid;
                            }
                            if (_.has(content1, 'email')) {
                                email = content1.email;
                                if (_this.getBrand() === 'rogers') {
                                    _this.$cookies.put('userName', email);
                                }
                                else {
                                    _this.$cookies.SIGN_IN = 'true';
                                    _this.$cookies.pageUserName = email;
                                }
                            }
                            localStorage.setItem('janrainCaptureToken', accessToken);
                            localStorage.setItem('janrainCaptureProfileData', JSON.stringify({ uuid: guid, userID: email, email: email, profileType: 1 }));
                            localStorage.setItem('janrainCaptureReturnExperienceData', JSON.stringify({ userID: email, uuid: guid }));
                            var easyLoginDataJanrain = JSON.stringify({ userID: email, uuid: guid, accessToken: accessToken });
                            localStorage.setItem('easyLoginDataJanrain', easyLoginDataJanrain);
                            sessionStorage.setItem('easyLoginDataJanrain', easyLoginDataJanrain);
                        };
                        this.getBrand = function () {
                            return _this.config.basic.domain.toLowerCase();
                        };
                        this.getCrossApplicationID = function () {
                            return { 'x-app-id': _this.getBrand() };
                        };
                    }
                    ;
                    EasyLoginRegistrationService.serviceName = 'ute.easy.login.registration.service';
                    return EasyLoginRegistrationService;
                }());
                var EasyLoginRegistrationProvider = (function (_super) {
                    __extends(EasyLoginRegistrationProvider, _super);
                    /* @ngInject */
                    function EasyLoginRegistrationProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($http, $q, $cookies) {
                            return new EasyLoginRegistrationService(_this.config, $http, $q, $cookies);
                        };
                        this.$get.$inject = [
                            '$http',
                            '$q',
                            '$cookies'
                        ];
                        this.config = this.fidoConfig();
                    }
                    /* Rogers Config comes from Rogers Client Repo */
                    EasyLoginRegistrationProvider.prototype.fidoConfig = function () {
                        return {
                            basic: {
                                branding: 'FIDO',
                                domain: 'fido.ca',
                                accountOverview: '/pages/#/my-account/overview?easylogin=true',
                                apiUrl: 'api/v1/profile/create',
                                dtmName: 'account registration',
                                logPrefix: 'UserRegistration',
                                logLevel: 0,
                                recaptchaSiteKey: '6LeI_FAUAAAAAFAibCBAp4L9cN-BJ6HH4VeBFjwm'
                            },
                            advanced: {
                                apis: {
                                    accounts: 'web/genesis/api/account/v2/accounts/all/',
                                    verifyEmail: 'web/genesis/api/user/v1/registration/email?op=verify',
                                    sendEmail: 'web/genesis/api/user/v1/registration?op=tryCreate',
                                    createPassword: 'web/genesis/api/user/v1/registration?op=create',
                                    linkAccount: 'web/genesis/api/customer/v1/byGUID/:GUID/Linked?op=link',
                                    subscriber: 'web/genesis/api/account/v2/accounts/all/ctns/',
                                    smsverify: 'web/genesis/api/user/v1/pin?op=validate',
                                    janrainLogin: 'web/genesis/api/user/v1/loginSession'
                                },
                                main: {
                                    stateName: 'easylogin/main',
                                    cancelState: 'wireless',
                                    controllerName: 'ute.easy.login.registration.controller',
                                    templateUrl: 'module/easyLoginRegistration/templates/fido/easyLoginRegistration.html',
                                },
                                registration: {
                                    stateName: 'easylogin/registration?token',
                                    cancelState: 'wireless',
                                    controllerName: 'ute.easy.login.registration.controller',
                                    templateUrl: 'module/easyLoginRegistration/templates/fido/easyLoginRegistration.html',
                                },
                                supportedLanguages: {
                                    en: 'English',
                                    fr: 'Français'
                                },
                                validation: {
                                    passwordRegex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d!@#\$[\]]{8,64}$/
                                }
                            }
                        };
                    };
                    EasyLoginRegistrationProvider.$inject = [];
                    return EasyLoginRegistrationProvider;
                }(RegistrationProviderBase));
                angular.module('ute.easy.login.registration').provider(EasyLoginRegistrationService.serviceName, EasyLoginRegistrationProvider);
            })(registration = login.registration || (login.registration = {}));
        })(login = easy.login || (easy.login = {}));
    })(easy = ute.easy || (ute.easy = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var environment;
        (function (environment) {
            'use strict';
            var EnvironmentStatic = (function () {
                function EnvironmentStatic() {
                }
                /**
                 *
                 * @returns {ute.blocks.environment.EnvironmentType}
                 */
                EnvironmentStatic.getEnvType = function () {
                    if (location.hostname.indexOf('www.rogers.com') === 0) {
                        return ute.blocks.environment.EnvironmentType.PROD;
                    }
                    else if (location.hostname.indexOf('www.dev') === 0) {
                        return ute.blocks.environment.EnvironmentType.DEV;
                    }
                    else if (location.hostname.indexOf('www.qa') === 0) {
                        return ute.blocks.environment.EnvironmentType.QA;
                    }
                    else {
                        return ute.blocks.environment.EnvironmentType.LOCAL;
                    }
                };
                /**
                 * @returns {string}
                 */
                EnvironmentStatic.getEnvConfigPath = function () {
                    return 'environments/' + environment.EnvironmentType[EnvironmentStatic.getEnvType()].toLowerCase() + '.js';
                };
                /**
                 *
                 * @param success
                 * @returns {JQueryXHR}
                 */
                EnvironmentStatic.getEnvConfig = function (success) {
                    return $.getScript(EnvironmentStatic.getEnvConfigPath(), success);
                };
                return EnvironmentStatic;
            }());
            environment.EnvironmentStatic = EnvironmentStatic;
            var EnvironmentHelperProvider = (function () {
                /* @ngInject */
                function EnvironmentHelperProvider(CONFIG) {
                    var _this = this;
                    this.config = {
                        url: '/environment.json'
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return {
                            getProperty: _this.getProperty
                        };
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        return true;
                    };
                    this.configureByHostName = function () {
                        _this.config.url = _this.buildEnvUrl(location.hostname);
                    };
                    this.configureByEnvType = function (envDetector) {
                        _this.config.url = _this.buildEnvUrl(environment.EnvironmentType[envDetector ? envDetector.getEnvType() : EnvironmentStatic.getEnvType()].toLowerCase());
                    };
                    this.getProperty = function (name) {
                        return _.get(_this.envJson, name, name);
                    };
                    this.buildEnvUrl = function (name) { return '/environments/' + name + '.json'; };
                    this.$get.$inject = [];
                    this.envJson = CONFIG;
                }
                EnvironmentHelperProvider.$inject = ['CONFIG'];
                return EnvironmentHelperProvider;
            }());
            angular.module('ute.blocks.environment').provider('ute.blocks.environment', EnvironmentHelperProvider);
        })(environment = blocks.environment || (blocks.environment = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

// Include in index.html so that app level exceptions are handled.
// Exclude from testRunner.html which should run exactly what it wants to run
var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception_1) {
            'use strict';
            var ExceptionHandlerProvider = (function () {
                /* @ngInject */
                function ExceptionHandlerProvider() {
                    var _this = this;
                    this.config = {
                        appErrorPrefix: undefined
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return { config: _this.config };
                    };
                    this.$get.$inject = [];
                }
                ExceptionHandlerProvider.prototype.configure = function (appErrorPrefix) {
                    this.config.appErrorPrefix = appErrorPrefix;
                };
                ExceptionHandlerProvider.$inject = [];
                return ExceptionHandlerProvider;
            }());
            config.$inject = ['$provide'];
            /* @ngInject */
            function config($provide) {
                $provide.decorator('$exceptionHandler', extendExceptionHandler);
            }
            extendExceptionHandler.$inject = ['$delegate', 'exceptionHandler', 'ute.blocks.loggerService'];
            /**
             * Extend the $exceptionHandler service to also display a toast.
             * @param  {Object} $delegate
             * @param  {Object} exceptionHandler
             * @param  {Object} logger
             * @return {Function} the decorated $exceptionHandler service
             */
            /* @ngInject */
            function extendExceptionHandler($delegate, exceptionHandler, logger) {
                return function (exception, cause) {
                    //            var appErrorPrefix = '[Error] ';
                    var appErrorPrefix = exceptionHandler.config.appErrorPrefix || '';
                    var errorData = { exception: exception, cause: cause };
                    exception.message = appErrorPrefix + exception.message;
                    $delegate(exception, cause);
                    /**
                     * Could add the error to a service's collection,
                     * add errors to $rootScope, log errors to remote web server,
                     * or log locally. Or throw hard. It is entirely up to you.
                     * throw exception;
                     * @example
                     *     throw { message: 'error message we added' };
                     */
                    logger.error(exception.message, errorData);
                };
            }
            angular.module('ute.blocks.exception').provider('exceptionHandler', ExceptionHandlerProvider).config(config);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var exception;
        (function (exception) {
            'use strict';
            var Exception = (function () {
                /* @ngInject */
                function Exception(logger) {
                    var _this = this;
                    this.logger = logger;
                    this.catcher = function (message) { return function (reason, title) { return _this.logger.error(message, reason, title); }; };
                }
                Exception.$inject = ['ute.blocks.loggerService'];
                return Exception;
            }());
            angular.module('ute.blocks.exception').service('ute.blocks.exceptionService', Exception);
        })(exception = blocks.exception || (blocks.exception = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var ErrorModalController = (function () {
                /* @ngInject */
                function ErrorModalController($modalInstance, errorCode, janrainVerificationService, $state, $translate, dtmService) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.dtmService = dtmService;
                    this.getModalIcon = function () { return _this.errorCode.modalIcon; };
                    this.getFrontendMessageKey = function () { return _this.errorCode.frontendMessageKey; };
                    this.getFrontendMessageP2Key = function () { return _this.errorCode.frontendMessageP2Key; };
                    this.getBoldChat = function () { return _this.errorCode.boldChat; };
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () { return _this.$modalInstance.close('no'); };
                    this.continue = function () { return _this.$modalInstance.close('yes'); };
                    this.config = ute.janrain.verification.service.DefaultConfigFactory();
                    var tagName = (this.$state.current.name === this.config.advanced.setPassword.stateName) ? this.config.advanced.setPassword.dtmName : this.config.advanced.resetPassword.dtmName;
                    this.$translate(this.errorCode.frontendMessageKey).then(function (errorMessage) {
                        _this.dtmService.fireDtmExceptions(tagName, [errorMessage], 'SS');
                    });
                }
                ErrorModalController.controlerName = 'ute.janrain.verification.error.modal.controller';
                ErrorModalController.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.service',
                    '$state',
                    '$translate',
                    'ute.dtm.service'];
                return ErrorModalController;
            }());
            verification.ErrorModalController = ErrorModalController;
            angular.module('ute.janrain.verification').controller(ErrorModalController.controlerName, ErrorModalController);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var InvalidForgotPasswordModalController = (function () {
                /* @ngInject */
                function InvalidForgotPasswordModalController($modalInstance, errorCode, janrainVerificationService, $state, $translate, dtmService) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.dtmService = dtmService;
                    this.getModalIcon = function () { return _this.errorCode.modalIcon; };
                    this.getFrontendMessageKey = function () { return _this.errorCode.frontendMessageKey; };
                    this.getFrontendMessageP2Key = function () { return _this.errorCode.frontendMessageP2Key; };
                    this.getBoldChat = function () { return _this.errorCode.boldChat; };
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.tryAgain = function () {
                        _this.$modalInstance.close();
                        return _this.$state.go('sso/forgotPassword');
                    };
                    this.config = ute.janrain.verification.service.DefaultConfigFactory();
                    var tagName = (this.$state.current.name === this.config.advanced.setPassword.stateName) ? this.config.advanced.setPassword.dtmName : this.config.advanced.resetPassword.dtmName;
                    this.$translate(this.errorCode.errorTitleMessageKey).then(function (errorMessage) {
                        _this.dtmService.fireDtmExceptions(tagName, [errorMessage], 'SS');
                    });
                }
                InvalidForgotPasswordModalController.controlerName = 'ute.janrain.verification.invalidate.forgot.password.controller';
                InvalidForgotPasswordModalController.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.service',
                    '$state',
                    '$translate',
                    'ute.dtm.service'];
                return InvalidForgotPasswordModalController;
            }());
            verification.InvalidForgotPasswordModalController = InvalidForgotPasswordModalController;
            angular.module('ute.janrain.verification').controller(InvalidForgotPasswordModalController.controlerName, InvalidForgotPasswordModalController);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    'use strict';
                    var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.CODE_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 17000;
                        BackEndErrorCode.EMAIL_ALREADY_VARIFIED = 17003;
                        BackEndErrorCode.EMAIL_NOT_FOUND = 17004;
                        return BackEndErrorCode;
                    }());
                    var FrontEndErrorCode;
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["CODE_OK"] = 0] = "CODE_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                        FrontEndErrorCode[FrontEndErrorCode["EMAIL_ALREADY_VARIFIED"] = 2] = "EMAIL_ALREADY_VARIFIED";
                        FrontEndErrorCode[FrontEndErrorCode["EMAIL_NOT_FOUND"] = 3] = "EMAIL_NOT_FOUND";
                    })(FrontEndErrorCode || (FrontEndErrorCode = {}));
                    var ResendEmailService = (function (_super) {
                        __extends(ResendEmailService, _super);
                        /* @ngInject */
                        function ResendEmailService($injector, $state, $http, $modal, janrainVerificationService, encryptionService) {
                            var _this = this;
                            _super.call(this, FrontEndErrorCode.GENERIC_ERROR, BackEndErrorCode.GENERIC_ERROR, ResendEmailService.serviceName, $injector);
                            this.$state = $state;
                            this.$http = $http;
                            this.$modal = $modal;
                            this.janrainVerificationService = janrainVerificationService;
                            this.encryptionService = encryptionService;
                            this.model = { email: undefined, locale: undefined };
                            this.processOkSuper = this.processOk; // super.processOk
                            /**
                             * implementation of ute.blocks.router.IStateHandler
                             * @param event
                             * @param toState
                             * @param toParams
                             * @param fromState
                             * @param fromParams
                             * @returns {boolean}
                             */
                            this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                                _this.restoreFromInput(toParams).then(function (result) {
                                    // console.log(UserRegistrationService.serviceName + '->stateTransitionHandler->then', result);
                                    if (!result) {
                                        event.preventDefault();
                                    }
                                });
                                return true;
                            };
                            this.getEmail = function () { return _this.model.email; };
                            // isCallInProgress: () => boolean = () => this.isCallInProgress;
                            /**
                             * @returns {IPromise<ICodeEntry>}
                             */
                            this.resendEmail = function (model) {
                                var request = {
                                    email: model.email,
                                    lang: model.locale
                                };
                                _this.model.email = model.email;
                                _this.isCallInProgress = true;
                                return _this.$http.post(_this.config.basic.resendEmailApiUrl, request)
                                    .then(_this.processOk)
                                    .catch(_this.processError)
                                    .finally(_this.finaliseCall);
                            };
                            /**
                             * @override
                             * @param response
                             * @return {ICodeEntry}
                             */
                            this.processOk = function (response) {
                                var retval = _this.processOkSuper(response);
                                _this.goToResendEmailConfirmation();
                                return retval;
                            };
                            this.openModalPopup = function (codeEntry) {
                                return _this.$modal.open({
                                    windowTemplateUrl: codeEntry.windowTemplateUrl,
                                    templateUrl: codeEntry.templateUrl,
                                    controller: codeEntry.controller,
                                    controllerAs: 'errorModal',
                                    size: codeEntry.modalSize,
                                    backdrop: 'static',
                                    resolve: {
                                        'ute.janrain.verification.errorHandler': codeEntry
                                    }
                                }).result.then(function (result) {
                                    // console.log(ResendEmailService.serviceName + '->openModalPopup->then:', 'result:', result);
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            return true;
                                        case 'no':
                                            return false;
                                        default:
                                            return false;
                                    }
                                }).catch(function (reason) {
                                    // console.log(ResendEmailService.serviceName + '->openModalPopup->catch:', 'reason:', reason);
                                    return false;
                                });
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.CODE_OK,
                                    // templateUrl: this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.CODE_OK
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.subTitle',
                                    frontendMessageKey: 'ute.common.label.system.error.message',
                                    frontendMessageP2Key: 'ute.common.label.system.error.message.p2',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    // modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR,
                                    boldChat: {
                                        cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                        dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                        chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass'
                                    }
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.EMAIL_ALREADY_VARIFIED,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.email.already.verified.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.email.already.verified.subTitle',
                                    frontendMessageKey: 'ute.janrain.verification.email.already.verified.error.message',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'lg',
                                    backendCode: BackEndErrorCode.EMAIL_ALREADY_VARIFIED
                                });
                                _this.addCode({
                                    frontendCode: FrontEndErrorCode.EMAIL_NOT_FOUND,
                                    errorTitleMessageKey: 'ute.janrain.verification.modalPopup.email.not.found.title',
                                    errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.email.not.found.subTitle',
                                    frontendMessageKey: 'ute.janrain.verification.email.not.found.error.message',
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'lg',
                                    backendCode: BackEndErrorCode.EMAIL_NOT_FOUND
                                });
                            };
                            /**
                             * @param $stateParams
                             * @returns {IPromise<boolean>}
                             */
                            this.restoreFromInput = function ($stateParams) {
                                if ($stateParams.id) {
                                    return _this.encryptionService.decrypt($stateParams.id).then(function (obj) {
                                        // console.log(UserRegistrationService.serviceName + '->restoreFromInput->then', obj);
                                        if (obj.email) {
                                            _this.model.email = obj.email;
                                            return true;
                                        }
                                        else {
                                            // this.$state.go(this.config.advanced.registration.stateName);
                                            return false;
                                        }
                                    }).catch(function (error) {
                                        // console.log(UserRegistrationService.serviceName + '->restoreFromInput->catch', error);
                                        // this.$state.go(this.config.advanced.registration.stateName);
                                        return false;
                                    });
                                }
                                else {
                                    // this.$state.go(this.config.advanced.registration.stateName);
                                    return new _this.$q(function (resolve) { return resolve(false); });
                                }
                            };
                            this.goToResendEmailConfirmation = function () {
                                return _this.encryptionService.encrypt({ email: _this.model.email }).then(function (id) {
                                    return _this.$state.go(_this.config.advanced.emailResendConfirmation.stateName, { id: id });
                                });
                            };
                            this.config = this.janrainVerificationService.getConfig();
                            this.addCodes();
                        }
                        ;
                        ResendEmailService.serviceName = 'ute.janrain.verification.resend.email.service';
                        ResendEmailService.$inject = [
                            '$injector',
                            '$state',
                            '$http',
                            '$modal',
                            'ute.janrain.verification.service',
                            'ute.common.encryption.service'
                        ];
                        return ResendEmailService;
                    }(ResponseErrorHandlerGeneric));
                    angular.module('ute.janrain.verification').service(ResendEmailService.serviceName, ResendEmailService);
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                var ProviderBase = ute.common.core.ProviderBase;
                var ResponseErrorHandlerGeneric = ute.common.core.service.ResponseErrorHandlerGeneric;
                /**
                 * Private
                 */
                var BackEndErrorCode = (function () {
                    function BackEndErrorCode() {
                    }
                    BackEndErrorCode.CODE_OK = 0;
                    BackEndErrorCode.GENERIC_ERROR = 17000;
                    BackEndErrorCode.CODE_EXPIRED = 17001;
                    BackEndErrorCode.CODE_NOT_VALID = 17002;
                    BackEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE = 17056;
                    BackEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE = 17092;
                    return BackEndErrorCode;
                }());
                (function (FrontEndErrorCode) {
                    FrontEndErrorCode[FrontEndErrorCode["CODE_OK"] = 0] = "CODE_OK";
                    FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    FrontEndErrorCode[FrontEndErrorCode["CODE_EXPIRED"] = 2] = "CODE_EXPIRED";
                    FrontEndErrorCode[FrontEndErrorCode["CODE_NOT_VALID"] = 3] = "CODE_NOT_VALID";
                    FrontEndErrorCode[FrontEndErrorCode["FORGOT_PASSWORD_MIDDLEWARE_FAILURE"] = 4] = "FORGOT_PASSWORD_MIDDLEWARE_FAILURE";
                    FrontEndErrorCode[FrontEndErrorCode["FORGOT_PASSWORD_VALIDATION_FAILED_CODE"] = 5] = "FORGOT_PASSWORD_VALIDATION_FAILED_CODE";
                })(service.FrontEndErrorCode || (service.FrontEndErrorCode = {}));
                var FrontEndErrorCode = service.FrontEndErrorCode;
                var JanrainVerificationService = (function (_super) {
                    __extends(JanrainVerificationService, _super);
                    function JanrainVerificationService(config, $injector) {
                        var _this = this;
                        _super.call(this, FrontEndErrorCode.GENERIC_ERROR, BackEndErrorCode.GENERIC_ERROR, JanrainVerificationService.serviceName, $injector);
                        this.config = config;
                        /**
                         * implementation of ute.blocks.router.IStateHandler
                         * @param event
                         * @param toState
                         * @param toParams
                         * @param fromState
                         * @param fromParams
                         * @returns {boolean}
                         */
                        this.stateTransitionHandler = function (event, toState, toParams, fromState, fromParams) {
                            if (angular.isUndefined(_.get(toState, 'data.settings.codeVerificationApiUrl'))) {
                                _this.storageService.removeFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                            }
                            else {
                                _this.model = {
                                    verificationCode: toParams.id || _this.extractCode('code') || _this.extractCode('verification_code'),
                                    email: undefined,
                                    uuid: undefined,
                                    token: undefined,
                                    locale: _this.extractCode('lang') || '',
                                    needAutoRegCheck: toState.data.settings.needAutoRegCheck
                                };
                                _this.verifyJanrainCode(toState.data.settings.codeVerificationApiUrl);
                            }
                            return true;
                        };
                        this.getConfig = function () { return angular.copy(_this.config); };
                        this.getVerificationCode = function () { return _this.model.verificationCode; };
                        this.getUuid = function () { return _this.model.uuid; };
                        this.getEmail = function () { return _this.model.email; };
                        this.getToken = function () { return _this.model.token; };
                        this.getLocale = function () { return _this.model.locale; };
                        this.getJanrainToken = function () { return _this.model.janrainToken; };
                        // isCodeExpired: () => boolean = () => !angular.isDefined(this.model.uuid); // TODO
                        this.isCodeValid = function () { return (angular.isDefined(_this.model.uuid) || angular.isDefined(_this.model.token)) && angular.isDefined(_this.model.verificationCode); };
                        this.isJanrainVerificationCallInProgress = function () { return _this.isCallInProgress; };
                        this.goToRescueState = function () { return _this.$state.go(_this.config.basic.rescueState); };
                        /**
                         * @returns {IPromise<ICodeEntry>}
                         */
                        this.verifyJanrainCode = function (codeVerificationApiUrl) {
                            var request = {
                                code: _this.model.verificationCode
                            };
                            _this.isCallInProgress = true;
                            _this.model.uuid = undefined;
                            _this.model.email = undefined;
                            _this.model.token = undefined;
                            _this.model.janrainToken = undefined;
                            _this.openVerificationModalPopup();
                            return _this.$http.post(codeVerificationApiUrl || _this.config.basic.codeVerificationApiUrl, request)
                                .then(_this.processOk)
                                .catch(_this.processError)
                                .finally(_this.finaliseCall);
                        };
                        /**
                         * @param errorHandler
                         * @returns {IPromise<boolean>}
                         */
                        this.openModalPopup = function (errorHandler) {
                            return _this.$modal.open({
                                windowTemplateUrl: errorHandler.windowTemplateUrl,
                                templateUrl: errorHandler.templateUrl,
                                controller: errorHandler.controller,
                                controllerAs: 'errorModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                resolve: {
                                    'ute.janrain.verification.errorHandler': errorHandler
                                }
                            }).result.then(function (result) {
                                // console.log(JanrainVerificationService.serviceName + '->openModalPopup->then:', 'result:', result);
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        return true;
                                    case 'no':
                                        return false;
                                    default:
                                        return false;
                                }
                            }).catch(function (reason) {
                                // console.log(JanrainVerificationService.serviceName + '->openModalPopup->catch:', 'reason:', reason);
                                return false;
                            });
                        };
                        /**
                         * @param response
                         * @returns {any}
                         */
                        this.processOk = function (response) {
                            var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            var retval = _this.findCodeEntry(backendCode);
                            // console.log(JanrainVerificationService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, 'retval:', retval);
                            _this.$modalInstance.close();
                            if (angular.isObject(response.data)) {
                                // same code can be used only once - but we have to support refresh (F5)
                                var model = _this.storageService.getFromLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                                if (_.get(model, 'verificationCode') !== response.config.data.code) {
                                    _this.model.uuid = response.data.content.uuid;
                                    _this.model.email = _.get(response.data, 'content.attributes.email');
                                    _this.model.token = response.data.content.token;
                                    _this.model.janrainToken = response.data.content.token;
                                    // TODO when it will be removed
                                    // console.log('xxxxxxxxxxxxxxxxxx', this.model);
                                    _this.storageService.putToLocal(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION, _this.model);
                                }
                                else {
                                    _this.model = model;
                                }
                                if (_this.isCodeValid()) {
                                    _this.openVerifySuccessModalPopup();
                                    /**
                                     * Add autoreg check logic:
                                     * when autoreg is true means New Registration then stay in set password page
                                     * when autoreg is false means change username then redirect user to resue state
                                     */
                                    if (_this.model.needAutoRegCheck && !_.get(response.data, 'content.attributes.autoreg')) {
                                        _this.goToRescueState();
                                    }
                                }
                                else {
                                    if (retval.windowTemplateUrl) {
                                        _this.openModalPopup(retval);
                                    }
                                }
                            }
                            return retval;
                        };
                        /**
                         * @param error
                         * @returns {any}
                         */
                        this.processError = function (error) {
                            var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                            // console.log(JanrainVerificationService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                            /**
                             * Close verification modal
                             */
                            _this.$modalInstance.close();
                            /**
                             * Because the validation token will expire within 1 hour
                             * therefore the system cannot let the user the set the new password
                             * when the code validation has failed
                             */
                            // if (angular.isObject(error.config)) {
                            //   // same code can be used only once
                            //   const model: IJanrainVerificationModel = this.storageService.getFromLocal<IJanrainVerificationModel>(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SSO_CODE_VERIFICATION);
                            //   if (_.get(model, 'verificationCode') === _.get(error.config, 'data.code')) {
                            //     this.model = model;
                            //     backendCode = BackEndErrorCode.CODE_OK;
                            //     this.openVerifySuccessModalPopup();
                            //   }
                            // }
                            var retval = _this.findCodeEntry(backendCode);
                            if (retval.windowTemplateUrl) {
                                return _this.openModalPopup(retval);
                            }
                            else {
                                return retval;
                            }
                        };
                        /**
                         * Extract code from http query
                         * @param paramName
                         * @return {string}
                         */
                        this.extractCode = function (paramName) {
                            return _this.$location.search()[paramName] || _.get(_this.utilsService.getQueryParameters(), paramName);
                        };
                        this.addCodes = function () {
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CODE_OK,
                                // templateUrl: this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.CODE_OK
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                                frontendMessageKey: 'ute.common.label.system.error.message',
                                frontendMessageP2Key: 'ute.common.label.system.error.message.p2',
                                templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                                controller: _this.config.advanced.genericErrorModal.controllerName,
                                windowTemplateUrl: _this.config.advanced.genericErrorModal.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'md',
                                backendCode: BackEndErrorCode.GENERIC_ERROR,
                                boldChat: {
                                    cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                    dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                    chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass' // TODO
                                }
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CODE_EXPIRED,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.expired.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.expired.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.CODE_EXPIRED
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.CODE_NOT_VALID,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.CODE_NOT_VALID
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.invalid.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                templateUrl: _this.config.advanced.invalidForgotPasswordModal.templateUrl,
                                controller: _this.config.advanced.invalidForgotPasswordModal.controllerName,
                                windowTemplateUrl: _this.config.advanced.invalidForgotPasswordModal.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.FORGOT_PASSWORD_VALIDATION_FAILED_CODE
                            });
                            _this.addCode({
                                frontendCode: FrontEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE,
                                errorTitleMessageKey: 'ute.janrain.verification.modalPopup.middleware.failure.title',
                                errorSubTitleMessageKey: 'ute.janrain.verification.modalPopup.middleware.failure.subTitle',
                                frontendMessageKey: 'ute.janrain.verification.invalid.error.message',
                                // frontendMessageP2Key: 'ute.janrain.verification.system.error.message.p2',
                                templateUrl: _this.config.advanced.askEmail.templateUrl,
                                controller: _this.config.advanced.askEmail.controllerName,
                                windowTemplateUrl: _this.config.advanced.askEmail.windowTemplateUrl,
                                modalIcon: 'ute-common-assets/assets/error_warning.png',
                                modalSize: 'lg',
                                backendCode: BackEndErrorCode.FORGOT_PASSWORD_MIDDLEWARE_FAILURE
                            });
                        };
                        this.$location = $injector.get('$location');
                        this.storageService = $injector.get('ute.blocks.persistent.storage.service');
                        this.$modal = $injector.get('$modal');
                        this.$http = $injector.get('$http');
                        this.$timeout = $injector.get('$timeout');
                        this.$state = $injector.get('$state');
                        this.utilsService = $injector.get('ute.common.utils.service');
                        this.encryptionService = $injector.get('ute.common.encryption.service');
                        this.addCodes();
                    }
                    ;
                    /**
                     * @returns {IPromise<boolean>}
                     */
                    JanrainVerificationService.prototype.openVerificationModalPopup = function () {
                        this.$modalInstance = this.$modal.open({
                            windowTemplateUrl: this.config.advanced.verificationModal.windowTemplateUrl,
                            templateUrl: this.config.advanced.verificationModal.templateUrl,
                            controller: this.config.advanced.verificationModal.controllerName,
                            controllerAs: 'verificationModal',
                            size: 'md',
                            backdrop: 'static',
                            keyboard: false
                        });
                    };
                    JanrainVerificationService.prototype.openVerifySuccessModalPopup = function () {
                        /**
                         * open success modal and wait for 5 seconds then close the modal
                         */
                        var $modalInstance = this.$modal.open({
                            windowTemplateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.success.view.html',
                            templateUrl: this.config.advanced.verificationModal.templateUrl,
                            controller: this.config.advanced.verificationModal.controllerName,
                            controllerAs: 'verificationModal',
                            size: 'md',
                            backdrop: 'static',
                            keyboard: false
                        });
                        this.$timeout(function () {
                            $modalInstance.close();
                        }, 5000);
                    };
                    JanrainVerificationService.serviceName = 'ute.janrain.verification.service';
                    return JanrainVerificationService;
                }(ResponseErrorHandlerGeneric));
                var JanrainVerificationProvider = (function (_super) {
                    __extends(JanrainVerificationProvider, _super);
                    /* @ngInject */
                    function JanrainVerificationProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function ($injector) {
                            return new JanrainVerificationService(_this.config, $injector);
                        };
                        this.$get.$inject = ['$injector'];
                        this.config = service.DefaultConfigFactory();
                    }
                    JanrainVerificationProvider.$inject = [];
                    return JanrainVerificationProvider;
                }(ProviderBase));
                angular.module('ute.janrain.verification').provider(JanrainVerificationService.serviceName, JanrainVerificationProvider);
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: {
                            applicationId: 'ute-application-id',
                            codeVerificationApiUrl: 'api/v1/profile/activate',
                            resendEmailApiUrl: 'api/v1/profile/reactivate',
                            logPrefix: 'JanrainVerification',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            rescueState: 'signin'
                        },
                        advanced: {
                            genericErrorModal: {
                                controllerName: 'ute.janrain.verification.error.modal.controller',
                                windowTemplateUrl: 'module/janrainVerification/genericError/errorWindow.view.html',
                                templateUrl: 'module/janrainVerification/genericError/errorModal.view.html'
                            },
                            askEmail: {
                                controllerName: 'ute.janrain.verification.resend.email.ask.controller',
                                windowTemplateUrl: 'module/janrainVerification/resendEmail/askEmail/window.view.html',
                                templateUrl: 'module/janrainVerification/resendEmail/askEmail/modal.view.html'
                            },
                            invalidForgotPasswordModal: {
                                controllerName: verification.InvalidForgotPasswordModalController.controlerName,
                                windowTemplateUrl: 'module/janrainVerification/invalidForgotPassword/invalidForgotPasswordWindow.view.html',
                                templateUrl: 'module/janrainVerification/invalidForgotPassword/invalidForgotPasswordModal.view.html'
                            },
                            verificationModal: {
                                controllerName: service.VerificationModalController.controlerName,
                                windowTemplateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html',
                                templateUrl: 'module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html'
                            },
                            emailResendConfirmation: {
                                stateName: 'sso/emailResendConfirmation',
                                controllerName: 'ute.janrain.verification.resend.email.confirmation.controller',
                                templateUrl: 'module/janrainVerification/resendEmail/confirmation/view.html'
                            },
                            setPassword: {
                                stateName: 'sso/setPassword',
                                dtmName: 'set new password'
                            },
                            resetPassword: {
                                dtmName: 'reset password'
                            },
                            forgotPassword: {
                                apiUrl: 'api/v1/profile/forgotPassword'
                            }
                        }
                    };
                }
                service.DefaultConfigFactory = DefaultConfigFactory;
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var service;
            (function (service) {
                'use strict';
                /* @ngInject */
                var VerificationModalController = (function () {
                    /* @ngInject */
                    function VerificationModalController($modalInstance) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.noSelection = function () {
                            _this.$modalInstance.dismiss('cancel');
                        };
                        // console.log('ute.janrain.verification.service:', $modalInstance, contentId);
                    }
                    VerificationModalController.$inject = ['$modalInstance'];
                    VerificationModalController.controlerName = 'ute.rogers.verification.modal.controller';
                    return VerificationModalController;
                }());
                service.VerificationModalController = VerificationModalController;
                angular.module('ute.janrain.verification').controller(VerificationModalController.controlerName, VerificationModalController);
            })(service = verification.service || (verification.service = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var logger;
        (function (logger) {
            'use strict';
            var Logger = (function () {
                /* @ngInject */
                function Logger($log /*, private toastr: Toastr*/) {
                    this.$log = $log;
                }
                // straight to console; bypass toastr
                Logger.prototype.log = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i - 0] = arguments[_i];
                    }
                    this.$log.log(args);
                };
                Logger.prototype.error = function (message, data, title) {
                    //this.toastr.error(message, title);
                    this.$log.error('Error: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.info = function (message, data, title) {
                    //this.toastr.info(message, title);
                    this.$log.info('Info: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.success = function (message, data, title) {
                    //this.toastr.success(message, title);
                    this.$log.info('Success: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.prototype.warning = function (message, data, title) {
                    //this.toastr.warning(message, title);
                    this.$log.warn('Warning: ' + message, '\nSummary:', title, '\nDetails:', data);
                };
                Logger.$inject = ['$log' /*, 'toastr'*/];
                return Logger;
            }());
            angular.module('ute.blocks.logger').service('ute.blocks.loggerService', Logger);
        })(logger = blocks.logger || (blocks.logger = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneviewConsumerFooterController = (function () {
                    function OneviewConsumerFooterController(oneviewCommonFooterService, userService, messagesService, languageService, $browser, $element, $http, provinceService) {
                        var _this = this;
                        this.oneviewCommonFooterService = oneviewCommonFooterService;
                        this.userService = userService;
                        this.messagesService = messagesService;
                        this.languageService = languageService;
                        this.$browser = $browser;
                        this.$element = $element;
                        this.$http = $http;
                        this.provinceService = provinceService;
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.reloadFooterDOM(false);
                            return null;
                        }, 'ute.oneview.consumer.footer.directive.controller');
                        this.userType = this.oneviewCommonFooterService.getUserType();
                        this.isDealer = this.isCare = false;
                        if (this.userType === 'dealer') {
                            this.isDealer = true;
                        }
                        else if (this.userType === 'care') {
                            this.isCare = true;
                        }
                        //Detecting Province change and load Footer xml
                        this.messagesService.register('ute-oneview-footer-province-change', function (evt) { return _this.reloadFooterDOM(false); });
                    }
                    OneviewConsumerFooterController.prototype.reloadFooterDOM = function (forceRedraw) {
                        var _this = this;
                        this.selectedLanguage = this.languageService.getCurrentLanguage();
                        this.selectedProvince = this.provinceService.getCurrentProvince();
                        var LCurl = '/cms/rogers/integration/footer-' + this.selectedLanguage + '-' + this.selectedProvince.toLowerCase() + '.xml';
                        this.$http.get(LCurl, { cache: true })
                            .then(function (result) {
                            _this.response = result.data;
                            $('.QSISlider').hide();
                            _this.$element.html(result.data);
                            _this.$element.find('#feedback-tab').hide();
                            _this.$element.find('#footer a[onclick=\'javascript:FSR.popFeedback()\']').hide();
                        });
                    };
                    OneviewConsumerFooterController.controllerName = 'ute.oneview.footer.directive.controller';
                    OneviewConsumerFooterController.$inject = [
                        'ute.oneview.footer.service',
                        'ute.common.user.service',
                        'ute.blocks.messages.bus.service',
                        'ute.blocks.language.switcher',
                        '$browser',
                        '$element',
                        '$http',
                        'ute.blocks.province.service'
                    ];
                    return OneviewConsumerFooterController;
                }());
                footer.OneviewConsumerFooterController = OneviewConsumerFooterController;
                angular.module('ute.common.oneview.footer').controller('ute.oneview.consumer.footer.directive.controller', OneviewConsumerFooterController);
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var oneview;
        (function (oneview) {
            var footer;
            (function (footer) {
                'use strict';
                var OneViewConsumerFooter = (function () {
                    function OneViewConsumerFooter(oneViewFooterService) {
                        this.oneViewFooterService = oneViewFooterService;
                        this.restrict = 'A';
                        this.controller = this.oneViewFooterService.getConfig().basic.consumerControllerName;
                        this.controllerAs = 'oneviewConsumerFooter';
                    }
                    OneViewConsumerFooter.factory = function () {
                        var directive = function (oneViewFooterService) { return new OneViewConsumerFooter(oneViewFooterService); };
                        directive.$inject = ['ute.oneview.footer.service'];
                        return directive;
                    };
                    return OneViewConsumerFooter;
                }());
                angular.module('ute.common.oneview.footer').directive('uteoneviewconsumerfooter', OneViewConsumerFooter.factory());
            })(footer = oneview.footer || (oneview.footer = {}));
        })(oneview = common.oneview || (common.oneview = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var service;
        (function (service) {
            'use strict';
            var MethodOfPaymentType = (function () {
                function MethodOfPaymentType() {
                }
                MethodOfPaymentType.Debit = 'D';
                MethodOfPaymentType.DebitOrCreditCard = 'C';
                MethodOfPaymentType.Invoice = 'R';
                return MethodOfPaymentType;
            }());
            service.MethodOfPaymentType = MethodOfPaymentType;
        })(service = payment.service || (payment.service = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var config;
            (function (config) {
                'use strict';
                function DefaultConfigFactory() {
                    return {
                        basic: { applicationId: 'Rogers.com' },
                        advance: {
                            threshHoldPaymentAmount: 1000,
                            defaultState: 'accountOverview',
                            successState: 'paymenthistory',
                            accountOverviewState: 'accountOverview',
                            interactPaymentDetail: 'interactPaymentDetail'
                        }
                    };
                }
                config.DefaultConfigFactory = DefaultConfigFactory;
            })(config = ui.config || (ui.config = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var config;
            (function (config_1) {
                'use strict';
                var ProviderBase = ute.common.core.ProviderBase;
                var PaymentUIConfigService = (function () {
                    function PaymentUIConfigService(config) {
                        var _this = this;
                        this.config = config;
                        this.getConfig = function () { return angular.copy(_this.config); };
                    }
                    PaymentUIConfigService.serviceName = 'ute.payment.ui.config.service';
                    return PaymentUIConfigService;
                }());
                var PaymentUIConfigProvider = (function (_super) {
                    __extends(PaymentUIConfigProvider, _super);
                    /* @ngInject */
                    function PaymentUIConfigProvider() {
                        var _this = this;
                        _super.call(this);
                        /* @ngInject */
                        this.$get = function () {
                            return new PaymentUIConfigService(_this.config);
                        };
                        this.config = config_1.DefaultConfigFactory();
                    }
                    PaymentUIConfigProvider.$inject = [];
                    return PaymentUIConfigProvider;
                }(ProviderBase));
                angular.module('ute.payment.ui.config').provider(PaymentUIConfigService.serviceName, PaymentUIConfigProvider);
            })(config = ui.config || (ui.config = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('ute.payment.ui').config(configurePaymentUI);
                configurePaymentUI.$inject = ['ute.datalayer.common.serviceProvider'];
                function configurePaymentUI(dataLayerCommonServiceProvider) {
                    var makeAPaymentName = 'Make a Payment';
                    var config = {
                        advance: {
                            mappingKey: {
                                'makeAPayment': {
                                    start: {
                                        page: {
                                            name: 'payment',
                                            hierarchy: ['myrogers', 'pay now']
                                        },
                                        events: {
                                            selfServeStart: true
                                        }
                                    },
                                    pay_via_bank: {
                                        page: {
                                            name: 'pay via bank',
                                            hierarchy: ['myrogers', 'pay now']
                                        },
                                        events: {
                                            selfServeComplete: true
                                        }
                                    },
                                    details: {
                                        page: {
                                            name: 'payment details',
                                            hierarchy: ['myrogers', 'pay now']
                                        }
                                    },
                                    review: {
                                        page: {
                                            name: 'review',
                                            hierarchy: ['myrogers', 'pay now']
                                        }
                                    },
                                    confirmation: {
                                        page: {
                                            name: 'confirmation',
                                            hierarchy: ['myrogers', 'pay now']
                                        }
                                    },
                                    complete: {
                                        page: {
                                            name: 'confirmation',
                                            hierarchy: ['myrogers', 'pay now']
                                        },
                                        events: {
                                            selfServeComplete: true
                                        }
                                    },
                                    error: {
                                        page: {
                                            name: 'payment',
                                            hierarchy: ['myrogers', 'pay now']
                                        }
                                    },
                                    errorApiPayload: {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'pay now']
                                        }
                                    },
                                    errorCategory: {
                                        category: 'SELF_SERVE'
                                    },
                                    selfServe: {
                                        selfServe: {
                                            name: makeAPaymentName,
                                            type: 'transaction'
                                        }
                                    },
                                    api: {
                                        interacEligibility: {
                                            API: 'interac eligibility'
                                        },
                                        makeAPayment: {
                                            API: 'payment'
                                        },
                                        switchToPreauthorizedPayment: {
                                            API: 'switch pre-auth'
                                        },
                                        interacPayment: {
                                            API: 'interac payment'
                                        },
                                        interacPaymentConfirmation: {
                                            API: 'interac confirm'
                                        },
                                        type: {
                                            http: {
                                                type: 'HTTP'
                                            },
                                            credit: {
                                                type: 'CREDIT'
                                            },
                                            selfServe: {
                                                type: 'SELF_SERVE'
                                            }
                                        }
                                    },
                                    paymentType: {
                                        visaDebit: 'visa debit',
                                        mastercardDebit: 'mastercard debit',
                                        creditCard: 'credit/debit',
                                        interac: 'interac',
                                    },
                                    changePaymentMethod: {
                                        name: 'Change Payment Method',
                                        type: 'transaction'
                                    }
                                }
                            }
                        }
                    };
                    dataLayerCommonServiceProvider.configure(config);
                }
            })(integration = ui.integration || (ui.integration = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    (function (PaymentChannelType) {
                        PaymentChannelType[PaymentChannelType["CARD"] = 0] = "CARD";
                        PaymentChannelType[PaymentChannelType["INTERAC"] = 1] = "INTERAC";
                        PaymentChannelType[PaymentChannelType["BANK"] = 2] = "BANK";
                    })(now.PaymentChannelType || (now.PaymentChannelType = {}));
                    var PaymentChannelType = now.PaymentChannelType;
                    (function (PaymentStepStatus) {
                        PaymentStepStatus[PaymentStepStatus["Current"] = 0] = "Current";
                        PaymentStepStatus[PaymentStepStatus["Completed"] = 1] = "Completed";
                        PaymentStepStatus[PaymentStepStatus["Pending"] = 2] = "Pending";
                        PaymentStepStatus[PaymentStepStatus["ServerError"] = 3] = "ServerError";
                        PaymentStepStatus[PaymentStepStatus["Processing"] = 4] = "Processing";
                        PaymentStepStatus[PaymentStepStatus["Received"] = 5] = "Received";
                        PaymentStepStatus[PaymentStepStatus["Duplicate"] = 6] = "Duplicate";
                    })(now.PaymentStepStatus || (now.PaymentStepStatus = {}));
                    var PaymentStepStatus = now.PaymentStepStatus;
                    (function (PaymentStep) {
                        PaymentStep[PaymentStep["Payment"] = 0] = "Payment";
                        PaymentStep[PaymentStep["Review"] = 1] = "Review";
                        PaymentStep[PaymentStep["Confirmation"] = 2] = "Confirmation";
                        PaymentStep[PaymentStep["PayViaBank"] = 3] = "PayViaBank";
                    })(now.PaymentStep || (now.PaymentStep = {}));
                    var PaymentStep = now.PaymentStep;
                    (function (DataLayerPaymentStep) {
                        DataLayerPaymentStep[DataLayerPaymentStep["start"] = 0] = "start";
                        DataLayerPaymentStep[DataLayerPaymentStep["details"] = 1] = "details";
                        DataLayerPaymentStep[DataLayerPaymentStep["review"] = 2] = "review";
                        DataLayerPaymentStep[DataLayerPaymentStep["complete"] = 3] = "complete";
                    })(now.DataLayerPaymentStep || (now.DataLayerPaymentStep = {}));
                    var DataLayerPaymentStep = now.DataLayerPaymentStep;
                    (function (InteracPaymentStatus) {
                        InteracPaymentStatus[InteracPaymentStatus["funded"] = 0] = "funded";
                        InteracPaymentStatus[InteracPaymentStatus["notFunded"] = 1] = "notFunded";
                    })(now.InteracPaymentStatus || (now.InteracPaymentStatus = {}));
                    var InteracPaymentStatus = now.InteracPaymentStatus;
                    (function (FrontEndErrorCode) {
                        FrontEndErrorCode[FrontEndErrorCode["CODE_OK"] = 0] = "CODE_OK";
                        FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                    })(now.FrontEndErrorCode || (now.FrontEndErrorCode = {}));
                    var FrontEndErrorCode = now.FrontEndErrorCode;
                    (function (BANK) {
                        BANK[BANK["TD"] = 0] = "TD";
                        BANK[BANK["ATB"] = 1] = "ATB";
                        BANK[BANK["RBC"] = 2] = "RBC";
                        BANK[BANK["BMO"] = 3] = "BMO";
                        BANK[BANK["SCOTIABANK"] = 4] = "SCOTIABANK";
                        BANK[BANK["CIBC"] = 5] = "CIBC";
                        BANK[BANK["DESJARDINS"] = 6] = "DESJARDINS";
                        BANK[BANK["NATIONALBANK"] = 7] = "NATIONALBANK";
                        BANK[BANK["TANGERINE"] = 8] = "TANGERINE";
                    })(now.BANK || (now.BANK = {}));
                    var BANK = now.BANK;
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                    var PayNowService = (function () {
                        /* @ngInject */
                        function PayNowService(userService, configService, dataLayerService, $q, $window, ngDialog) {
                            var _this = this;
                            this.userService = userService;
                            this.configService = configService;
                            this.dataLayerService = dataLayerService;
                            this.$q = $q;
                            this.$window = $window;
                            this.ngDialog = ngDialog;
                            this.expireYears = [];
                            this.getMonths = function () { return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12']; };
                            this.getCcType = function () { return ['V', 'M', 'A']; };
                            this.getExpiryYears = function () {
                                //return already calculated data
                                if (_this.expireYears.length > 0) {
                                    return _this.expireYears;
                                }
                                var currentYear = new Date().getFullYear();
                                _this.expireYears.push(currentYear);
                                //get current year and add up to 10 years
                                for (var i = 1; i <= PayNowService.postExpiryYearNumber; i++) {
                                    _this.expireYears.push(currentYear + i);
                                }
                                return _this.expireYears;
                            };
                            this.retrieveLastPaymentDetail = function () {
                                var returnData = (_.clone(_this.model.paymentSuccess));
                                _this.resetModel();
                                return returnData;
                            };
                            this.storeLastPaymentDetail = function (value, referenceId) {
                                _this.model.paymentSuccess.paymentAmount = value;
                                _this.model.paymentSuccess.paymentReferenceId = referenceId;
                                _this.model.paymentSuccess.showSuccessfulMessage = true;
                            };
                            this.openMakePaymentModal = function (_accountBalance, _accountDetails, _parentState, _callback) {
                                _this.$window.open('/consumer/self-serve/payments/pay', '_self');
                                return _this.$q.defer().promise;
                            };
                            this.trackMakeAPayment = function (trackingStep, paymentType, amount, referenceId, isAutoPayment, addBasicPayload) {
                                if (addBasicPayload === void 0) { addBasicPayload = false; }
                                try {
                                    var mapping = {
                                        mappingKey: 'makeAPayment.selfServe,makeAPayment.' + now.DataLayerPaymentStep[trackingStep]
                                    };
                                    var _payload = {};
                                    /**
                                     * payment method does not need in Review step
                                     */
                                    if (trackingStep !== now.DataLayerPaymentStep.review) {
                                        _.merge(_payload, { selfServe: { paymentMethod: paymentType } });
                                    }
                                    if (amount) {
                                        _.merge(_payload, { selfServe: { revenue: amount.toFixed(2) } });
                                    }
                                    if (!(referenceId === null || referenceId === undefined)) {
                                        _.merge(_payload, { selfServe: { transactionID: referenceId } });
                                    }
                                    if (isAutoPayment !== null) {
                                        _.merge(_payload, { events: { autopay: isAutoPayment } });
                                    }
                                    _this.dataLayerService.track(_payload, true, [DataLayerPredefinedSection.GLOBAL], mapping);
                                }
                                catch (error) {
                                    console.warn('data layer tracking - Make a payment', error);
                                }
                                return;
                            };
                            /**
                             * Reset model to initial state
                             */
                            this.resetModel = function () {
                                _this.model = {
                                    paymentSuccess: {
                                        paymentAmount: 0,
                                        paymentReferenceId: null,
                                        showSuccessfulMessage: false
                                    }
                                };
                            };
                            this.resetModel();
                        }
                        ;
                        PayNowService.$inject = [
                            'ute.common.user.service',
                            'ute.payment.ui.config.service',
                            'ute.datalayer.common.service',
                            '$q',
                            '$window',
                            'ngDialog'
                        ];
                        PayNowService.postExpiryYearNumber = 10;
                        return PayNowService;
                    }());
                    angular.module('ute.payment.ui.pay.now').service('ute.payment.ui.pay.now.service', PayNowService);
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    var PayNowButtonController = (function () {
                        /* @ngInject */
                        function PayNowButtonController(payNowService) {
                            this.payNowService = payNowService;
                        }
                        PayNowButtonController.prototype.openMakePaymentOverlay = function () {
                            this.payNowService.openMakePaymentModal(this.accountBalance, this.accountDetails, this.parentState);
                        };
                        PayNowButtonController.$inject = ['ute.payment.ui.pay.now.service'];
                        return PayNowButtonController;
                    }());
                    angular.module('ute.payment.ui.pay.now').controller('ute.payment.ui.pay.now.button.controller', PayNowButtonController);
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    var PayNowButton = (function () {
                        /* @ngInject */
                        function PayNowButton() {
                            this.restrict = 'EA';
                            this.controller = 'ute.payment.ui.pay.now.button.controller';
                            this.controllerAs = 'payNowButton';
                            this.bindToController = true;
                            this.scope = {
                                accountDetails: '=',
                                accountBalance: '=',
                                parentState: '@'
                            };
                            /**
                             * @param scope
                             */
                            this.linkFn = function (scope, element, attribs, controller) {
                                element.on('click', function (e) {
                                    e.preventDefault();
                                    controller.openMakePaymentOverlay();
                                });
                            };
                            this.link = this.linkFn;
                        }
                        PayNowButton.factory = function () {
                            var directive = function () { return new PayNowButton(); };
                            return directive;
                        };
                        return PayNowButton;
                    }());
                    angular.module('ute.payment.ui.pay.now').directive('utePayNowButton', PayNowButton.factory());
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

/**
 * Created by Vikash Singh on 18/08/16.
 */
var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                    var BackEndPaymentErrorCode = ute.payment.service.BackEndPaymentErrorCode;
                    var PayNowInteracController = (function () {
                        /* @ngInject */
                        function PayNowInteracController($state, $timeout, $translate, $q, ngDialog, payNowService, userService, $window, $stateParams, interacPaymentStatus, dataLayerService, configService) {
                            var _this = this;
                            this.$state = $state;
                            this.$timeout = $timeout;
                            this.$translate = $translate;
                            this.$q = $q;
                            this.ngDialog = ngDialog;
                            this.payNowService = payNowService;
                            this.userService = userService;
                            this.$window = $window;
                            this.$stateParams = $stateParams;
                            this.interacPaymentStatus = interacPaymentStatus;
                            this.dataLayerService = dataLayerService;
                            this.configService = configService;
                            this.dataLayerMappingKey = 'advance.mappingKey.makeAPayment';
                            this.config = configService.getConfig();
                            var parentState = this.$window.sessionStorage.getItem('ute.payment.ui.parentState');
                            var paymentData = {
                                userType: this.userService.getUserType() || '',
                                cardTime: {
                                    months: this.payNowService.getMonths(),
                                    years: this.payNowService.getExpiryYears()
                                },
                                creditCardDetails: null,
                                paymentChannel: now.PaymentChannelType.INTERAC,
                                parentState: parentState,
                                paidAmount: (interacPaymentStatus === now.InteracPaymentStatus.funded && !angular.isUndefined($stateParams.amount)) ?
                                    Number(atob($stateParams.amount)) : 0.0
                            };
                            paymentData.paymentStepStatus = (interacPaymentStatus === now.InteracPaymentStatus.funded) ? now.PaymentStepStatus.Received : now.PaymentStepStatus.ServerError;
                            paymentData.paymentStep = now.PaymentStep.Confirmation;
                            /**
                             * Capture Interac Error
                             */
                            if (interacPaymentStatus === now.InteracPaymentStatus.notFunded) {
                                this.$q.all({
                                    header: this.$translate('ute.payment.ui.payNow.serverErrorHeaderInterac'),
                                    message: this.$translate('ute.payment.ui.payNow.serverErrorMessageInterac')
                                }).then(function (errorMessages) {
                                    var mapping = {
                                        mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory:makeAPayment.api.interacPayment:makeAPayment.api.type.selfServe'
                                    };
                                    _this.dataLayerService.trackAPIError(String(BackEndPaymentErrorCode.GENERIC_ERROR), errorMessages.header + ', ' + errorMessages.message, true, [DataLayerPredefinedSection.GLOBAL], mapping);
                                });
                            }
                            if (angular.isUndefined(parentState) || parentState === null) {
                                $state.go(this.configService.getConfig().advance.defaultState);
                            }
                            else {
                                var modal = this.ngDialog.open({
                                    templateUrl: 'module/paymentUI/payNow/templates/payNowMain.modal.html',
                                    controller: 'ute.payment.ui.pay.now.modal.controller',
                                    controllerAs: 'utePayNowModal',
                                    className: 'ute-pay-now-modal-window',
                                    showClose: false,
                                    closeByEscape: false,
                                    closeByDocument: false,
                                    resolve: {
                                        paymentData: function () {
                                            return paymentData;
                                        },
                                        callback: function () {
                                            return null;
                                        }
                                    }
                                });
                                this.$window.sessionStorage.removeItem('ute.payment.ui.parentState');
                                $state.go(parentState, parentState === 'viewbill' ? { interacFailureModal: modal } : null);
                            }
                        }
                        PayNowInteracController.$inject = [
                            '$state',
                            '$timeout',
                            '$translate',
                            '$q',
                            'ngDialog',
                            'ute.payment.ui.pay.now.service',
                            'ute.common.user.service',
                            '$window',
                            '$stateParams',
                            'interacPaymentStatus',
                            'ute.datalayer.common.service',
                            'ute.payment.ui.config.service'];
                        return PayNowInteracController;
                    }());
                    angular.module('ute.payment.ui.pay.now').controller('ute.payment.ui.pay.now.interac.controller', PayNowInteracController);
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    'use strict';
                    var FrontEndPaymentErrorCode = ute.payment.service.FrontEndPaymentErrorCode;
                    var Messages = ute.blocks.messages.bus.Messages;
                    var DataLayerPredefinedSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                    var BackEndPaymentErrorCode = ute.payment.service.BackEndPaymentErrorCode;
                    var PaymentStep = ute.payment.ui.pay.now.PaymentStep;
                    var DataLayerSelectedSections = [
                        ute.datalayer.common.service.DataLayerPredefinedSection.ACCOUNT,
                        ute.datalayer.common.service.DataLayerPredefinedSection.PAGE,
                        ute.datalayer.common.service.DataLayerPredefinedSection.SITE
                    ];
                    var PayNowModalController = (function () {
                        /* @ngInject */
                        function PayNowModalController($window, $scope, $translate, $state, $timeout, paymentData, callback, configService, paymentService, $q, payNowService, dataLayerService, messagesService, billingDetailFactory, languageService, browserService, storageService, userService) {
                            var _this = this;
                            this.$window = $window;
                            this.$scope = $scope;
                            this.$translate = $translate;
                            this.$state = $state;
                            this.$timeout = $timeout;
                            this.paymentData = paymentData;
                            this.callback = callback;
                            this.configService = configService;
                            this.paymentService = paymentService;
                            this.$q = $q;
                            this.payNowService = payNowService;
                            this.dataLayerService = dataLayerService;
                            this.messagesService = messagesService;
                            this.billingDetailFactory = billingDetailFactory;
                            this.languageService = languageService;
                            this.browserService = browserService;
                            this.storageService = storageService;
                            this.userService = userService;
                            this.reviewStep = PaymentStep.Review;
                            this.paymentStep = PaymentStep.Payment;
                            this.confirmationStep = PaymentStep.Confirmation;
                            this.current = now.PaymentStepStatus.Current;
                            this.completed = now.PaymentStepStatus.Completed;
                            this.pending = now.PaymentStepStatus.Pending;
                            this.serverError = now.PaymentStepStatus.ServerError;
                            this.received = now.PaymentStepStatus.Received;
                            this.processing = now.PaymentStepStatus.Processing;
                            this.duplicate = now.PaymentStepStatus.Duplicate;
                            this.autoPaymentMethodSet = null;
                            this.isPaymentAmountFocused = false;
                            this.banks = [];
                            this.liveChat = {
                                cbid: 'ute.payment.ui.payNow.liveChat.cbid',
                                dynamicDiv: 'ute.payment.ui.payNow.liveChat.dynamicDiv',
                                chatButton: 'ute.payment.ui.payNow.liveChat.chatButton'
                            };
                            this.errorMappingKey = 'makeAPayment.error,errors:makeAPayment.errorCategory';
                            this.showServerErrorMessageGeneral = false;
                            this.showSpecificErrorMessage = false;
                            this.showSupportlinks = true;
                            this.showOverLimitMessage = true;
                            this.paymentInProgress = false;
                            this.closeOverLimitMessage = function () {
                                _this.showOverLimitMessage = false;
                            };
                            this.gotoPaymentStep = function () {
                                _this.goToStep(_this.paymentStep);
                            };
                            this.isRep = function () {
                                if (_this.userService.isCare() || _this.userService.isDealer()) {
                                    return true;
                                }
                            };
                            this.getContactTranslationKey = function () {
                                return _this.isSGIAccount() ? 'ute.payment.ui.payNow.dup_contact_us' : 'ute.payment.ui.payNow.dup_check_payment_contact_us';
                            };
                            this.close = function (changeState) {
                                if (_this.isConfirmationStep() && _this.paymentSteps[_this.currentStep].status === now.PaymentStepStatus.Current) {
                                    _this.navigateToSuccessState();
                                }
                                else {
                                    _this.unauthorizedCallListener();
                                    if (changeState === true && !_this.isSGIAccount()) {
                                        _this.$state.go('paymenthistory');
                                    }
                                    _this.$scope.closeThisDialog('ok');
                                }
                            };
                            this.paymentAmountFocused = function () {
                                _this.isPaymentAmountFocused = true;
                            };
                            this.triggerAmountErrorCase = function (errorKey) {
                                _this.amountErrors.inlineError = _this.amountErrors[errorKey].translate;
                                if (!_this.amountErrors[errorKey].isTriggered) {
                                    _this.amountErrors[errorKey].isTriggered = true;
                                    _this.dataLayerService.trackFormError({}, _this.$translate.instant('ute.payment.ui.payNow.' + _this.amountErrors.inlineError, { threshHoldPaymentAmount: (_this.threshHoldPaymentAmount + _this.dueAmount).toString() }), 'payment amount', true, DataLayerSelectedSections, { mappingKey: 'makeAPayment.error,errors:makeAPayment.errorCategory' });
                                }
                            };
                            this.validateAmount = function () {
                                _this.isPaymentAmountFocused = false;
                                _this.$scope.$applyAsync(function () {
                                    if (_this.paymentAmount < 0.00) {
                                        _this.paymentAmount = 0.00;
                                    }
                                    else if (_this.showInvalidPaymentAmountError()) {
                                        _this.triggerAmountErrorCase('invalid');
                                    }
                                    else if (_this.paymentAmount > _this.dueAmount && _this.paymentAmount < _this.threshHoldPaymentAmount) {
                                        _this.triggerAmountErrorCase('overDueAmount');
                                    }
                                    else if (_this.isOverThreshhold()) {
                                        _this.triggerAmountErrorCase('overThreshold');
                                        _this.amountErrors.translateValue = (_this.threshHoldPaymentAmount + _this.dueAmount).toString();
                                    }
                                    else {
                                        _this.amountErrors.inlineError = 'null_error';
                                    }
                                });
                            };
                            this.canProcessPayment = function () {
                                return (_this.paymentAmount > 0 &&
                                    _this.paymentAmount <= _this.dueAmount + _this.config.advance.threshHoldPaymentAmount);
                            };
                            this.processInteracPayment = function () {
                                var interacEligibilityRequest = {
                                    accountNumber: _this.paymentData.accountDetails.accountNumber,
                                    accountTypeNumber: _this.paymentData.accountDetails.accountType,
                                    amount: _this.paymentAmount,
                                    amountDue: _this.dueAmount,
                                    language: 'EN'
                                };
                                _this.paymentSteps[_this.currentStep].status = ute.payment.ui.pay.now.PaymentStepStatus.Processing;
                                _this.paymentService.getInteracEligibility(interacEligibilityRequest)
                                    .then(_this.getInteracEligibilitySuccess)
                                    .catch(_this.getInteracEligibilityFail);
                            };
                            this.getAccountNumber = function () {
                                return _.get(_this.paymentData, 'accountDetails.billableAccountNumber', '').toString();
                            };
                            this.processCardPayment = function () {
                                _this.paymentReferenceId = null;
                                if (_this.paymentData.creditCardDetails) {
                                    if (_this.paymentInProgress) {
                                        return;
                                    }
                                    _this.paymentInProgress = true;
                                    _this.paymentSteps[_this.currentStep].status = _this.processing;
                                    _this.creditCardDetails = angular.copy(_this.paymentData.creditCardDetails);
                                    var paymentRequest = {
                                        accountNumber: _this.paymentData.accountDetails.billableAccountNumber || _this.paymentData.accountDetails.accountNumber,
                                        accountTypeNumber: _this.paymentData.accountDetails.accountType,
                                        paymentAmount: _this.paymentAmount,
                                        paymentMethod: 'CreditCard',
                                        subNumber: _this.paymentData.accountDetails.accountNumber,
                                        isConsolidated: _this.paymentData.accountDetails.isConsolidated,
                                        cardDetails: {
                                            cardNumber: _this.creditCardDetails.creditCardNo,
                                            cardType: _this.creditCardDetails.creditCardType.name,
                                            expireDateMonth: _this.creditCardDetails.expireDate.month,
                                            expireDateYear: _this.creditCardDetails.expireDate.year,
                                            securityCode: _this.creditCardDetails.securityCode
                                        }
                                    };
                                    _this.paymentService.makePayment(paymentRequest)
                                        .then(_this.makePaymentSuccess)
                                        .catch(_this.makePaymentFail)
                                        .finally(function () { return _this.paymentInProgress = false; });
                                }
                            };
                            this.isOverThreshhold = function () {
                                if (_this.isAmountEmpty()) {
                                    return false;
                                }
                                //http://stackoverflow.com/a/10713947 - to fix precision issue
                                return _this.paymentAmount > ((_this.dueAmount * 100) + (_this.config.advance.threshHoldPaymentAmount * 100)) / 100;
                            };
                            this.isAmountEmpty = function () {
                                if (angular.isUndefined(_this.paymentAmount) || _this.paymentAmount === null) {
                                    return true;
                                }
                                if (_this.paymentAmount.toString().length <= 0) {
                                    return true;
                                }
                                return false;
                            };
                            this.isAmountZero = function () { return (_this.paymentAmount === 0 || _this.paymentAmount.toString() === '0'); };
                            this.isAmountInvalid = function () {
                                /**
                                 * If payment Amount is undefined return false
                                 */
                                if (angular.isUndefined(_this.paymentAmount)) {
                                    return false;
                                }
                                /**
                                 * Checking multiple decimal
                                 */
                                var matchAry = _this.paymentAmount.toString().match(/\./g);
                                if (matchAry && matchAry.length > 1) {
                                    return true;
                                }
                                /**
                                 * Checking multiple comma
                                 */
                                matchAry = _this.paymentAmount.toString().match(/,/g);
                                if (matchAry && matchAry.length > 1) {
                                    return true;
                                }
                                return false;
                            };
                            this.showInvalidPaymentAmountError = function () {
                                if (!_this.payNowForm.paymentAmount || !(_this.payNowForm.paymentAmount.$dirty || _this.payNowForm.$submitted)) {
                                    return false;
                                }
                                if (_this.isAmountInvalid() || _this.isAmountEmpty() || _this.isAmountZero()) {
                                    return true;
                                }
                                return false;
                            };
                            this.isPaymentMethodCard = function () { return Number(_this.paymentChannel) === now.PaymentChannelType.CARD; };
                            this.isPaymentMethodInterac = function () { return Number(_this.paymentChannel) === now.PaymentChannelType.INTERAC; };
                            this.isPaymentMethodBank = function () { return Number(_this.paymentChannel) === now.PaymentChannelType.BANK; };
                            this.debugLogger = function (object) {
                                console.log('----nk----', object);
                            };
                            this.getStepClassName = function (step) {
                                if (step) {
                                    switch (step.status) {
                                        case now.PaymentStepStatus.Pending:
                                            return 'ute-pay-now-step-tracker-circle-pending';
                                        case now.PaymentStepStatus.Current:
                                            return 'ute-pay-now-step-tracker-circle-current';
                                        case now.PaymentStepStatus.ServerError:
                                            return 'ute-pay-now-step-tracker-circle-current';
                                        case now.PaymentStepStatus.Completed:
                                            return step.step === PaymentStep.Confirmation ? 'ute-pay-now-step-tracker-circle-current' : 'ute-pay-now-step-tracker-circle-completed';
                                        default:
                                            return 'ute-pay-now-step-tracker-circle-pending';
                                    }
                                }
                            };
                            this.goToStep = function (nextStep) {
                                var prevStep = _this.currentStep;
                                _this.currentStep = nextStep;
                                _this.paymentSteps[nextStep].status = _this.current;
                                _this.paymentSteps[prevStep].status = prevStep === PaymentStep.Payment ? _this.completed : _this.pending;
                            };
                            this.getHeaderLogoClass = function () {
                                var step = _this.paymentSteps[_this.currentStep];
                                if (step.status === now.PaymentStepStatus.ServerError) {
                                    return 'ute-pay-now-modal-header-logo-error';
                                }
                                else if (step.status === now.PaymentStepStatus.Received) {
                                    return 'ute-pay-now-modal-header-logo-received';
                                }
                                else if (step.status === now.PaymentStepStatus.Processing) {
                                    return 'ute-pay-now-modal-header-logo-processing';
                                }
                                else {
                                    return 'ute-pay-now-modal-header-logo';
                                }
                            };
                            this.getModalContentClass = function () {
                                var step = _this.paymentSteps[_this.currentStep];
                                if (step.status === now.PaymentStepStatus.ServerError) {
                                    return 'ute-pay-now-modalContent-server-error';
                                }
                                else if (step.status === now.PaymentStepStatus.Received) {
                                    return 'ute-pay-now-modalContent-received';
                                }
                                else if (step.status === now.PaymentStepStatus.Processing) {
                                    return 'ute-pay-now-modalContent-processing';
                                }
                                else if (step.status === now.PaymentStepStatus.Duplicate) {
                                    return 'ute-pay-now-modalContent ute-pay-now-modalContent-duplicate';
                                }
                                else {
                                    return 'ute-pay-now-modalContent';
                                }
                            };
                            this.switchToCreditOrDebit = function () {
                                _this.paymentChannel = now.PaymentChannelType.CARD;
                            };
                            this.isDisabled = function () {
                                return _this.paymentAmount <= 0 || _this.isOverThreshhold() || _this.isAmountInvalid() || _this.isAmountEmpty() || _this.isAmountZero() || !_this.uteSemafoneForm.$valid;
                            };
                            this.getBalanceRemainingClass = function () {
                                if (_this.remainingBalance > 0) {
                                    return 'ute-pay-now-balance-due';
                                }
                                else if (_this.remainingBalance === 0) {
                                    return 'ute-pay-now-balance-paid';
                                }
                                else if (_this.remainingBalance < 0) {
                                    return 'ute-pay-now-balance-overpaid';
                                }
                            };
                            this.isPaymentStep = function () { return _this.currentStep === PaymentStep.Payment; };
                            this.isReviewStep = function () { return _this.currentStep === PaymentStep.Review; };
                            this.isConfirmationStep = function () { return _this.currentStep === PaymentStep.Confirmation; };
                            this.isPayViaBankStep = function () { return _this.currentStep === PaymentStep.PayViaBank; };
                            this.showCancelButton = function () {
                                return !(_this.paymentSteps[_this.currentStep].status === _this.processing ||
                                    _this.paymentSteps[_this.currentStep].status === _this.received);
                            };
                            this.showContents = function () {
                                return !(_this.paymentSteps[_this.currentStep].status === _this.serverError ||
                                    _this.paymentSteps[_this.currentStep].status === _this.received ||
                                    _this.paymentSteps[_this.currentStep].status === _this.processing ||
                                    _this.paymentSteps[_this.currentStep].status === _this.duplicate);
                            };
                            this.bankReturnPreviousStep = function () {
                                _this.goToStep(PaymentStep.Payment);
                            };
                            this.makeAnotherPayment = function () {
                                if (_this.callback) {
                                    _this.callback();
                                }
                                _this.updatedBalance = _this.updatedBalance - _this.paymentAmount;
                                _this.goToStep(_this.paymentStep);
                            };
                            this.isServerError = function () { return _this.paymentSteps[_this.currentStep].status === _this.serverError; };
                            this.isPaymentReceived = function () { return _this.paymentSteps[_this.currentStep].status === _this.received; };
                            this.isProcessing = function () { return _this.paymentSteps[_this.currentStep].status === _this.processing; };
                            this.isDuplicate = function () { return _this.paymentSteps[_this.currentStep].status === _this.duplicate; };
                            this.wasPaymentMethodUpdated = function () { return _this.setAutoPayment && _this.autoPaymentMethodSet; };
                            this.navigateToSuccessState = function () {
                                _this.unauthorizedCallListener();
                                _this.$scope.closeThisDialog('success');
                                if (!_this.isSGIAccount()) {
                                    _this.payNowService.storeLastPaymentDetail(_this.paymentAmount, _this.paymentReferenceId);
                                    _this.$state.go(_this.config.advance.successState);
                                }
                                /**
                                 * Reload the state when the current and the new state are the same or payment is done for SGI accounts
                                 */
                                if (_this.config.advance.successState === _this.$state.current.name || _this.isSGIAccount()) {
                                    _this.$state.reload();
                                }
                            };
                            this.changePaymentChannel = function (channel) {
                                if (channel.value === now.PaymentChannelType.BANK && _this.paymentSteps.length !== 2) {
                                    _this.initBankSteps();
                                }
                                else if (channel.value !== now.PaymentChannelType.BANK && _this.paymentSteps.length !== 3) {
                                    _this.initPaymentSteps();
                                }
                                if (channel.value === now.PaymentChannelType.CARD) {
                                    _this.isCCAlreadySelected = true;
                                }
                                // this.$timeout(() => {
                                //   if (window.innerWidth <= 768) {
                                //     angular.element('.ute-pay-now-modal-window').scrollTop(0);
                                //     angular.element('.ute-pay-now-modal-window').animate({ scrollTop: $('#payNowRightBody').offset().top - 300 }, {
                                //       duration: 500,
                                //       easing: 'swing'
                                //     });
                                //   }
                                // }, 200);
                                _this.paymentChannel = channel.value;
                            };
                            this.getStepGridClass = function () {
                                return _this.isPaymentMethodBank() ? 'col-xs-6' : 'col-xs-4';
                            };
                            this.goToReviewStep = function () {
                                if (_this.paymentAmount > 0 && !_this.isOverThreshhold() && _this.uteSemafoneForm && _this.uteSemafoneForm.$valid) {
                                    _this.$timeout(function () {
                                        if (_this.paymentData.creditCardDetails) {
                                            _this.paymentData.creditCardDetails.validateCard();
                                            if (_this.paymentData.creditCardDetails && _this.paymentData.creditCardDetails.creditCardNo) {
                                                var cardType = _this.configPaymentType.creditCard + " - " + _this.paymentData.creditCardDetails.creditCardType.desc;
                                                _this.creditCardLastFour = _this.paymentData.creditCardDetails.creditCardNo.slice(-4);
                                                _this.payNowService.trackMakeAPayment(now.DataLayerPaymentStep.review, cardType, null, null, null, true);
                                                _this.goToStep(_this.reviewStep);
                                            }
                                        }
                                    });
                                }
                                else if (_this.uteSemafoneForm && !_this.uteSemafoneForm.$valid) {
                                    _this.uteSemafoneForm.$setSubmitted();
                                }
                            };
                            this.goToAccountOverview = function () {
                                _this.unauthorizedCallListener();
                                _this.$scope.closeThisDialog('accountOverview');
                                _this.$state.go(_this.config.advance.accountOverviewState);
                            };
                            this.isSGIAccount = function () {
                                return (_this.paymentData.accountDetails.accountType === 6);
                            };
                            this.tryAgain = function () {
                                var interactPaymentDetail = _this.storageService.getFromSession(_this.config.advance.interactPaymentDetail);
                                _this.restorePaymentDataFromSessionStorage(interactPaymentDetail);
                                _this.paymentChannel = now.PaymentChannelType.INTERAC;
                                _this.paymentAmount = interactPaymentDetail.paymentAmount;
                                _this.dueAmount = interactPaymentDetail.dueAmount;
                                _this.dataLayerService.track({}, true, [DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.start,makeAPayment.selfServe' });
                                _this.goToStep(_this.paymentStep);
                                _this.paymentSteps[PaymentStep.Review].status = now.PaymentStepStatus.Pending;
                            };
                            this.isPaymentChannelSelected = function () {
                                return angular.isDefined(_this.paymentChannel);
                            };
                            this.showBlanceWidget = function () {
                                return !_this.isPaymentMethodInterac() && !_this.isPaymentMethodCard();
                            };
                            this.showBalanceForm = function () {
                                return _this.isPaymentMethodInterac() || _this.isPaymentMethodCard() || !_this.isPaymentChannelSelected();
                            };
                            this.getBankImageClass = function () {
                                return '' + now.BANK[_this.currentBank ? _this.currentBank : 0] + '-bank-image';
                            };
                            this.isMobile = function () {
                                // this.$window.innerWidth < 992 is for handling "iPad pro" - because browserService says it's mobile but it should be treated like desktop
                                return _this.browserService.isMobile() && _this.$window.innerWidth < 992;
                            };
                            this.getModalDialogClass = function () {
                                return _this.isPaymentStep() && !_this.isPaymentChannelSelected() ? 'ute-paynow-payment-step' : '';
                            };
                            this.selectBank = function (bank) {
                                //todo
                                _this.currentBank = bank;
                                _this.dataLayerService.track({
                                    selfServe: {
                                        name: 'Make a Payment',
                                        type: 'transaction',
                                        revenue: _this.paymentAmount.toFixed(2).toString(),
                                        paymentMethod: 'Online Bank - ' + _this.$translate.instant('ute.payment.ui.payNow.banks.' + now.BANK[bank].toLowerCase())
                                    }
                                }, true, [DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.pay_via_bank' });
                                _this.goToStep(PaymentStep.PayViaBank);
                                _this.$window.open(_this.$translate.instant(_.find(_this.banks, { id: bank }).link), '_blank');
                            };
                            this.getCurrentBalance = function () {
                                return _this.paymentData.accountBalance.balanceAmount;
                            };
                            this.init = function () {
                                // temp fix until this issue get fixed by Apple: https://bugs.webkit.org/show_bug.cgi?id=176896
                                _this.uteScrollSelector = '.ute-pay-now-modal-window';
                                _this.uteScrollTarget = 400;
                                if (_this.browserService.isIOS()) {
                                    angular.element('body').addClass('iosBugFixCaret').scrollTop(0);
                                    _this.$scope.$on('$destroy', function () {
                                        angular.element('body').removeClass('iosBugFixCaret');
                                    });
                                    _this.uteScrollSelector = 'body';
                                }
                                _this.language = _this.languageService.getCurrentLanguage();
                                _this.BANK = now.BANK;
                                _this.isCCAlreadySelected = false;
                                _this.currentBank = null;
                                _this.unauthorizedCallListener = _this.messagesService.register(Messages.uteUserUnauthorized, _this.unauthorizedCallHandler);
                                if (_this.paymentData.paymentStepStatus === _this.received) {
                                    _this.paymentAmount = _this.paymentData.paidAmount;
                                }
                                else {
                                    _this.paymentMethod = _.get(_this.paymentData, 'accountBalance.methodOfPayment.mopType', 'U');
                                    _this.paymentAmount = _this.dueAmount = _this.updatedBalance = _this.paymentData.accountBalance && _this.paymentData.accountBalance.balanceAmount ?
                                        Number(_this.paymentData.accountBalance.balanceAmount) : 0.00;
                                    if (_this.paymentAmount < 0) {
                                        _this.paymentAmount = 0;
                                    }
                                }
                                _this.amountErrors = {
                                    invalid: {
                                        translate: 'invalidPaymentAmount',
                                        isTriggered: false
                                    },
                                    overDueAmount: {
                                        translate: 'overPaying',
                                        isTriggered: false
                                    },
                                    overThreshold: {
                                        translate: 'overThreshhold',
                                        isTriggered: false
                                    },
                                    inlineError: 'null_error',
                                    translateValue: null
                                };
                                _this.config = _this.configService.getConfig();
                                _this.threshHoldPaymentAmount = _this.config.advance.threshHoldPaymentAmount;
                                var mapping = {
                                    mappingKey: 'advance.mappingKey.makeAPayment.paymentType'
                                };
                                _this.configPaymentType = _this.dataLayerService.getConfigByMappingKey(mapping);
                                if (!_this.paymentData.paymentStep) {
                                    _this.dataLayerService.track({}, true, [DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.start,makeAPayment.selfServe' });
                                }
                                _this.paymentDate = new Date();
                                _this.initPaymentChannels();
                                _this.initPaymentSteps();
                                _this.initBanks();
                                if (_this.paymentData.paymentStepStatus === _this.received) {
                                    if (_this.isPaymentMethodInterac()) {
                                        var interactPaymentDetail = _this.storageService.getFromSession(_this.config.advance.interactPaymentDetail);
                                        _this.restorePaymentDataFromSessionStorage(interactPaymentDetail);
                                        /**
                                         * Try to get payment history records from backend
                                         * this will not block normal interact payment process
                                         */
                                        var paymentHistoryRequest = {
                                            accountId: interactPaymentDetail.accountNumber,
                                            accountType: interactPaymentDetail.accountTypeNumber,
                                            index: 0,
                                            pageSize: 2
                                        };
                                        _this.paymentService.getPaymentHistory(paymentHistoryRequest)
                                            .then(_this.paymentHistorySuccess)
                                            .catch(_this.paymentHistoryFail)
                                            .finally(_this.paymentHistoryInteracFinally);
                                    }
                                    _this.$timeout(function () {
                                        _this.paymentSteps[_this.currentStep].status = _this.current;
                                    }, 2000);
                                }
                            };
                            this.initBanks = function () {
                                for (var bank in now.BANK) {
                                    if (isNaN(Number(bank))) {
                                        _this.banks.push({
                                            id: now.BANK[bank],
                                            name: 'ute.payment.ui.payNow.banks.' + bank.toString().toLowerCase(),
                                            link: 'ute.payment.ui.payNow.banks.' + bank.toString().toLowerCase() + '_link'
                                        });
                                    }
                                }
                            };
                            this.getInteracEligibilitySuccess = function (response) {
                                if (response !== null) {
                                    _this.formData = response;
                                    if (angular.isUndefined(_this.formData.accountNumber)) {
                                        _this.dataLayerService.trackAPIError(String(BackEndPaymentErrorCode.GENERIC_ERROR), 'SS|Unknown Error returned by interac/getEligibility api call', true, [ute.datalayer.common.service.DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory:makeAPayment.api.interacEligibility' });
                                        _this.paymentSteps[_this.currentStep].status = _this.serverError;
                                    }
                                    else {
                                        var interacForm_1 = angular.element('#formToRogersInteracPayment');
                                        interacForm_1.attr('action', _this.formData.interacUrl);
                                        _this.$window.sessionStorage.setItem('ute.payment.ui.parentState', _this.paymentData.parentState);
                                        _this.payNowService.trackMakeAPayment(now.DataLayerPaymentStep.review, _this.configPaymentType.interac, null, null, null, true);
                                        var interactPaymentDetail = {
                                            accountNumber: _this.paymentData.accountDetails.accountNumber,
                                            accountTypeNumber: _this.paymentData.accountDetails.accountType,
                                            paymentAmount: _this.paymentAmount,
                                            dueAmount: _this.dueAmount
                                        };
                                        _this.storageService.putToSession(_this.config.advance.interactPaymentDetail, interactPaymentDetail);
                                        _this.$timeout(function () { return interacForm_1.submit(); }, 200);
                                    }
                                }
                                else {
                                    _this.dataLayerService.trackAPIError(String(BackEndPaymentErrorCode.GENERIC_ERROR), 'SS|Unknown Error returned by interac/getEligibility api call', true, [ute.datalayer.common.service.DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory:makeAPayment.api.interacEligibility' });
                                    _this.paymentSteps[_this.currentStep].status = _this.serverError;
                                }
                            };
                            this.getInteracEligibilityFail = function (error) {
                                _this.captureDtmError(error, 'interacEligibility');
                                _this.paymentSteps[_this.currentStep].status = _this.serverError;
                            };
                            this.makePaymentSuccess = function (response) {
                                var codeEntry = response;
                                if (codeEntry.frontendCode === FrontEndPaymentErrorCode.STATUS_OK) {
                                    if (_this.setAutoPayment) {
                                        _this.setPaymentMethod()
                                            .then(function (setPaymentMethodSuccessful) { return _this.autoPaymentMethodSet = setPaymentMethodSuccessful; })
                                            .finally(function () {
                                            _this.cardPaymentSucceeded();
                                        });
                                    }
                                    else {
                                        _this.cardPaymentSucceeded();
                                    }
                                }
                                else {
                                    _this.makePaymentFail(codeEntry);
                                }
                            };
                            this.cardPaymentSucceeded = function () {
                                _this.currentStep = _this.confirmationStep;
                                _this.paymentSteps[_this.currentStep].status = _this.received;
                                _this.remainingBalance = _this.dueAmount - _this.paymentAmount;
                                /**
                                 * Try to get payment history records from backend
                                 * this will not block normal payment process
                                 */
                                var paymentHistoryRequest = {
                                    accountId: _this.paymentData.accountDetails.billableAccountNumber || _this.paymentData.accountDetails.accountNumber,
                                    accountType: _this.paymentData.accountDetails.accountType,
                                    index: 0,
                                    pageSize: 2
                                };
                                var cardType = _this.configPaymentType.creditCard + " - " + _this.paymentData.creditCardDetails.creditCardType.desc;
                                _this.paymentService.getPaymentHistory(paymentHistoryRequest)
                                    .then(_this.paymentHistorySuccess)
                                    .catch(_this.paymentHistoryFail)
                                    .finally(function () {
                                    _this.payNowService.trackMakeAPayment(now.DataLayerPaymentStep.complete, cardType, _this.paymentAmount, _this.paymentReferenceId, _this.autoPaymentMethodSet, true);
                                });
                                if (_this.paymentData && _this.paymentData.accountDetails) {
                                    _this.billingDetailFactory({
                                        accountNumber: _this.paymentData.accountDetails.accountNumber,
                                        accountTypeNumber: _this.paymentData.accountDetails.accountType,
                                        language: _this.languageService.getCurrentLanguage(),
                                        applicationId: 'Rogers.com',
                                        refresh: false
                                    }).getBillingDetail(true);
                                }
                                _this.$timeout(function () {
                                    _this.paymentSteps[PaymentStep.Review].status = _this.completed;
                                    _this.paymentSteps[_this.currentStep].status = _this.current;
                                }, 2000);
                            };
                            this.paymentHistorySuccess = function (response) {
                                /**
                                 * Validate response data
                                 */
                                if (!response.records || response.records.length === 0) {
                                    return;
                                }
                                var lastPaymentHistory = response.records[0];
                                /**
                                 * Compare the payment amount to payment history amount
                                 * and payment date to payment history transaction date
                                 * If both condition match then set payment reference ID
                                 */
                                if (lastPaymentHistory.realAmount === _this.paymentAmount &&
                                    (_this.paymentDate.setHours(0, 0, 0, 0) - lastPaymentHistory.tranDate) === 0 || true) {
                                    _this.paymentReferenceId = lastPaymentHistory.refNum;
                                }
                            };
                            this.paymentHistoryFail = function (error) {
                                /**
                                 * No action for now
                                 * It may need dtm service in here
                                 */
                            };
                            this.paymentHistoryInteracFinally = function (error) {
                                /**
                                 * Remove session value
                                 */
                                _this.storageService.removeFromSession(_this.config.advance.interactPaymentDetail);
                                /**
                                 * This function is only calling for interac payment successful
                                 * call data layer tracking
                                 */
                                _this.payNowService.trackMakeAPayment(now.DataLayerPaymentStep.complete, _this.configPaymentType.interac, _this.paymentAmount, _this.paymentReferenceId, null, true);
                            };
                            this.makePaymentFail = function (error) {
                                if (_.get(error, 'backendCode', null) === 50000 && _.get(error, 'frontendCode', null) === 4 && !_this.isRep()) {
                                    _this.captureDtmError(error, 'makeAPayment');
                                    _this.paymentSteps[_this.currentStep].status = _this.duplicate;
                                }
                                else {
                                    switch (error.backendCode) {
                                        case '1005972':
                                        case 'CCQ2':
                                            _this.serverErrorMessageCard = 'ute.payment.ui.payNow.serverErrorMessageCard_1005972_CCQ2';
                                            _this.serverErrorHeaderCard = 'ute.payment.ui.payNow.serverErrorHeaderCardUnableToProcess';
                                            _this.serverErrorMessagePartOne = 'ute.payment.ui.payNow.serverErrorMessageCard_1005972_CCQ2_part_one';
                                            _this.serverErrorMessagePartTwo = 'ute.payment.ui.payNow.serverErrorMessageCard_1005972_CCQ2_part_two';
                                            _this.showSpecificErrorMessage = true;
                                            _this.showSupportlinks = !_this.isRep();
                                            break;
                                        case '10645':
                                        case 'CA84':
                                            _this.serverErrorMessageCard = 'ute.payment.ui.payNow.serverErrorMessageCard_10645_CA84';
                                            _this.serverErrorHeaderCard = 'ute.payment.ui.payNow.serverErrorHeaderCardUnableToProcess';
                                            _this.serverErrorMessagePartOne = 'ute.payment.ui.payNow.serverErrorMessageCard_10645_CA84_part_one';
                                            _this.serverErrorMessagePartTwo = 'ute.payment.ui.payNow.serverErrorMessageCard_10645_CA84_part_two';
                                            _this.showSpecificErrorMessage = true;
                                            _this.showSupportlinks = !_this.isRep();
                                            break;
                                        default:
                                            _this.serverErrorMessageCard = 'ute.payment.ui.payNow.serverErrorMessageCard';
                                            _this.serverErrorHeaderCard = 'ute.payment.ui.payNow.serverErrorHeaderCard';
                                            _this.showServerErrorMessageGeneral = true;
                                            _this.showSupportlinks = true;
                                    }
                                    _this.paymentChannels[_this.paymentChannel].errorHeaderKey = _this.serverErrorHeaderCard;
                                    _this.paymentChannels[_this.paymentChannel].errorMessageKey = _this.serverErrorMessageCard;
                                    _this.captureDtmError(error, 'makeAPayment');
                                    _this.paymentSteps[_this.currentStep].status = _this.serverError;
                                }
                            };
                            this.parseBackendErrorMessage = function (error) {
                                var textToReplace = 'Message Text: ';
                                var index = error.indexOf(textToReplace);
                                return index > 0 ? error.substring(index).replace('Message Text: ', '') : error;
                            };
                            this.captureDtmError = function (error, apiMappingKey) {
                                _this.$translate([_this.paymentChannels[_this.paymentChannel].errorHeaderKey, _this.paymentChannels[_this.paymentChannel].errorMessageKey])
                                    .then(function (translations) {
                                    var backendErrorMessage = _this.parseBackendErrorMessage(error.backendErrorMessage || '');
                                    if (backendErrorMessage !== '') {
                                        backendErrorMessage += ', ';
                                    }
                                    var message;
                                    if (_.includes(backendErrorMessage, 'duplicate payment')) {
                                        message = backendErrorMessage +
                                            _this.$translate.instant('ute.payment.ui.payNow.dup_info') +
                                            ' ' + _this.$translate.instant('ute.payment.ui.payNow.dup_protection');
                                    }
                                    else {
                                        message = backendErrorMessage +
                                            translations[_this.paymentChannels[_this.paymentChannel].errorHeaderKey] +
                                            ', ' + translations[_this.paymentChannels[_this.paymentChannel].errorMessageKey];
                                    }
                                    var mapping = {
                                        mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory'
                                    };
                                    mapping.mappingKey += ',errors:makeAPayment.api.' + apiMappingKey;
                                    if (error.status === 555) {
                                        mapping.mappingKey += ',errors:makeAPayment.api.type.credit';
                                    }
                                    else {
                                        mapping.mappingKey += ',errors:makeAPayment.api.type.http';
                                    }
                                    _this.dataLayerService.trackAPIError(String(error.backendCode || BackEndPaymentErrorCode.GENERIC_ERROR), message, true, [ute.datalayer.common.service.DataLayerPredefinedSection.GLOBAL], mapping);
                                });
                            };
                            this.initPaymentChannels = function () {
                                _this.paymentChannels = [];
                                _this.paymentChannels.push({
                                    name: 'optBank',
                                    value: now.PaymentChannelType.BANK,
                                    copyResource: 'ute.payment.ui.payNow.bankMethod',
                                    messageResource: 'ute.payment.ui.payNow.bankMethodMessage',
                                    desc: 'Bank',
                                    errorHeaderKey: 'ute.payment.ui.payNow.serverErrorHeaderBank',
                                    errorMessageKey: 'ute.payment.ui.payNow.serverErrorMessageBank'
                                });
                                _this.paymentChannels.push({
                                    name: 'optCreditCard',
                                    value: now.PaymentChannelType.CARD,
                                    copyResource: 'ute.payment.ui.payNow.cardMethod',
                                    desc: 'Credit/Debit',
                                    errorHeaderKey: 'ute.payment.ui.payNow.serverErrorHeaderCard',
                                    errorMessageKey: 'ute.payment.ui.payNow.serverErrorMessageCard'
                                });
                                _this.paymentChannels.push({
                                    name: 'optInterac',
                                    value: now.PaymentChannelType.INTERAC,
                                    copyResource: 'ute.payment.ui.payNow.interacMethod',
                                    desc: 'Interac',
                                    errorHeaderKey: 'ute.payment.ui.payNow.serverErrorHeaderInterac',
                                    errorMessageKey: 'ute.payment.ui.payNow.serverErrorMessageInterac'
                                });
                                if (_this.paymentData.paymentChannel) {
                                    _this.paymentChannel = _this.paymentData.paymentChannel;
                                }
                                else if (!_this.isMobile()) {
                                    if (_this.userService.isConsumer()) {
                                        _this.paymentChannel = undefined;
                                    }
                                    else {
                                        _this.paymentChannel = now.PaymentChannelType.CARD;
                                    }
                                }
                            };
                            this.initPaymentSteps = function () {
                                _this.paymentSteps = [];
                                _this.paymentSteps[PaymentStep.Payment] = {
                                    index: 1,
                                    step: PaymentStep.Payment,
                                    name: 'ute.payment.ui.payNow.payment',
                                    status: _this.paymentData.paymentStep ? now.PaymentStepStatus.Completed : now.PaymentStepStatus.Current
                                };
                                _this.paymentSteps[PaymentStep.Review] = {
                                    index: 2,
                                    step: PaymentStep.Review,
                                    name: 'ute.payment.ui.payNow.review',
                                    status: (_this.paymentData.paymentStep) ? now.PaymentStepStatus.Completed : now.PaymentStepStatus.Pending
                                };
                                _this.paymentSteps[PaymentStep.Confirmation] = {
                                    index: 3,
                                    step: PaymentStep.Confirmation,
                                    name: 'ute.payment.ui.payNow.confirmation',
                                    status: now.PaymentStepStatus.Pending
                                };
                                if (_this.paymentData.paymentStep) {
                                    _this.paymentSteps[_this.paymentData.paymentStep].status = _this.paymentData.paymentStepStatus;
                                }
                                _this.currentStep = _this.paymentData.paymentStep || _this.paymentStep;
                            };
                            this.initBankSteps = function () {
                                _this.paymentSteps = [];
                                _this.paymentSteps[PaymentStep.Payment] = {
                                    index: 1,
                                    step: PaymentStep.Payment,
                                    name: 'ute.payment.ui.payNow.payment',
                                    status: _this.paymentData.paymentStep ? now.PaymentStepStatus.Completed : now.PaymentStepStatus.Current
                                };
                                _this.paymentSteps[PaymentStep.PayViaBank] = {
                                    index: 2,
                                    step: PaymentStep.PayViaBank,
                                    name: 'ute.payment.ui.payNow.pay_via_bank',
                                    status: now.PaymentStepStatus.Pending
                                };
                                if (_this.paymentData.paymentStep) {
                                    _this.paymentSteps[_this.paymentData.paymentStep].status = _this.paymentData.paymentStepStatus;
                                }
                                _this.currentStep = _this.paymentData.paymentStep || _this.paymentStep;
                            };
                            this.setPaymentMethod = function () {
                                var paymentMethodRequest = {
                                    accountNumber: _this.paymentData.accountDetails.billableAccountNumber || _this.paymentData.accountDetails.accountNumber,
                                    accountTypeNumber: _this.paymentData.accountDetails.accountType,
                                    mopType: ute.payment.service.MethodOfPaymentType.DebitOrCreditCard,
                                    subNumber: _this.paymentData.accountDetails.accountNumber,
                                    isConsolidated: _this.paymentData.accountDetails.isConsolidated,
                                    cardDetails: {
                                        cardNumber: _this.creditCardDetails.creditCardNo,
                                        cardType: _this.creditCardDetails.creditCardType.name,
                                        expireDateMonth: _this.creditCardDetails.expireDate.month,
                                        expireDateYear: _this.creditCardDetails.expireDate.year,
                                        securityCode: _this.creditCardDetails.securityCode
                                    },
                                    oldMopType: _this.paymentMethod,
                                    contactId: _.get(_this.paymentData.accountDetails, 'contactInfo.contactId', '')
                                };
                                return _this.paymentService.setPaymentMethod(paymentMethodRequest)
                                    .then(_this.setPaymentMethodSuccess)
                                    .catch(_this.setPaymentMethodError);
                            };
                            this.setPaymentMethodSuccess = function (response) {
                                var status = _.get(response, 'content.status', false);
                                if (!status) {
                                    _this.dataLayerService.trackAPIError(String(BackEndPaymentErrorCode.GENERIC_ERROR), 'SS|setPaymentMethod - response.content.status: false', true, [ute.datalayer.common.service.DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory:makeAPayment.api.switchToPreauthorizedPayment' });
                                }
                                return status;
                            };
                            this.setPaymentMethodError = function (errorCode) {
                                _this.dataLayerService.trackAPIError(String(errorCode.backendCode), 'SS|' + errorCode.backendErrorMessage, true, [ute.datalayer.common.service.DataLayerPredefinedSection.GLOBAL], { mappingKey: 'makeAPayment.errorApiPayload,errors:makeAPayment.errorCategory:makeAPayment.api.switchToPreauthorizedPayment' });
                                return new _this.$q(function (resolve, reject) { return resolve(false); });
                            };
                            this.unauthorizedCallHandler = function (event) {
                                event.preventDefault();
                                _this.unauthorizedCallListener();
                                _this.$scope.closeThisDialog('close');
                            };
                            this.restorePaymentDataFromSessionStorage = function (interactPaymentDetail) {
                                _this.paymentData.accountDetails = {
                                    accountNumber: interactPaymentDetail.accountNumber,
                                    accountType: interactPaymentDetail.accountTypeNumber
                                };
                                _this.paymentData.accountBalance = {
                                    balanceAmount: interactPaymentDetail.dueAmount
                                };
                            };
                            this.init();
                        }
                        PayNowModalController.$inject = [
                            '$window',
                            '$scope',
                            '$translate',
                            '$state',
                            '$timeout',
                            'paymentData',
                            'callback',
                            'ute.payment.ui.config.service',
                            'ute.payment.service',
                            '$q',
                            'ute.payment.ui.pay.now.service',
                            'ute.datalayer.common.service',
                            'ute.blocks.messages.bus.service',
                            'ute.rogers.account.billing.detail.factory',
                            'ute.blocks.language.switcher',
                            'ute.common.core.browser.service',
                            'ute.blocks.persistent.storage.service',
                            'ute.common.user.service'
                        ];
                        return PayNowModalController;
                    }());
                    now.PayNowModalController = PayNowModalController;
                    angular.module('ute.payment.ui.pay.now').controller('ute.payment.ui.pay.now.modal.controller', PayNowModalController);
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment.ui || (payment.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var OrderDetailController = (function () {
                    function OrderDetailController($modal, $modalInstance, pendingOrderService, pendingOrderProvider, $translate) {
                        this.$modal = $modal;
                        this.$modalInstance = $modalInstance;
                        this.pendingOrderService = pendingOrderService;
                        this.pendingOrderProvider = pendingOrderProvider;
                        this.$translate = $translate;
                        this.hasError = false;
                        this.cmsContentURL = this.pendingOrderProvider.getConfig().basic.cmsContentURL;
                        this.hasTechInstallAppointment = 'LOADING';
                        this.canViewChangeAppointment = false;
                        this.isAgent = this.pendingOrderService.isAgent();
                        this.fetchOrderDetails();
                    }
                    OrderDetailController.prototype.viewAppointment = function () {
                        this.viewAppointmentModalConfig = {
                            controller: this.pendingOrderProvider.getConfig().basic.viewAppointmentModalController,
                            templateUrl: this.pendingOrderProvider.getConfig().basic.viewAppointmentModalTemplateUrl,
                            controllerAs: this.pendingOrderProvider.getConfig().basic.viewAppointmentModalControllerAs,
                            size: this.pendingOrderProvider.getConfig().basic.viewAppointmentModalSize
                        };
                        this.$modal.open(this.viewAppointmentModalConfig);
                    };
                    OrderDetailController.prototype.parseOrderDetailForEligibleFulfillmentOption = function (orderDetail) {
                        var respKey = 'productInfo';
                        var productServices = [], isProviderTP, isProviderTC, isProviderTN;
                        if (orderDetail &&
                            orderDetail[respKey] &&
                            orderDetail[respKey].services &&
                            angular.isArray(orderDetail[respKey].services) &&
                            orderDetail[respKey].services.length) {
                            productServices = angular.copy(orderDetail[respKey].services);
                            productServices = _.map(productServices, function (v) {
                                v.actionType = v.actionType.toLowerCase();
                                v.fulfillmentOption = v.fulfillmentOption.toLowerCase();
                                return v;
                            });
                            isProviderTP = _.chain(productServices)
                                .find({ 'actionType': 'provide', 'fulfillmentOption': 'tp' })
                                .isObject()
                                .value();
                            isProviderTC = _.chain(productServices)
                                .find({ 'actionType': 'provide', 'fulfillmentOption': 'tc' })
                                .isObject()
                                .value();
                            isProviderTN = _.chain(productServices)
                                .find({ 'actionType': 'provide', 'fulfillmentOption': 'tn' })
                                .isObject()
                                .value();
                            return (isProviderTP || isProviderTC || isProviderTN);
                        }
                        return false;
                    };
                    OrderDetailController.prototype.transformData = function (productServices) {
                        _.map(productServices, function (obj) {
                            var productName = obj.productName.replace(/ /g, '-');
                            obj.fulfillmentOptionData = productName.toLowerCase() + '.' +
                                obj.actionType.toLowerCase() + '.' +
                                obj.fulfillmentOption.toLowerCase();
                        });
                        return productServices;
                    };
                    OrderDetailController.prototype.fetchOrderDetails = function () {
                        var _this = this;
                        var data = this.pendingOrderService.getOrderDetail();
                        data.success(function (resp, status, headers, config) {
                            _this.orderDetails = (resp.productInfo && resp.productInfo.services) ? resp.productInfo.services : [];
                            if ((_this.orderDetails || []).length > 0) {
                                _this.hasError = false;
                                _this.hasTechInstallAppointment = 'TRUE';
                                _this.orderDetails = _this.transformData(_this.orderDetails);
                                _this.canViewChangeAppointment = _this.parseOrderDetailForEligibleFulfillmentOption(resp);
                                if (!_this.canViewChangeAppointment) {
                                    _this.hasTechInstallAppointment = 'CANT_CHANGE';
                                }
                            }
                            else {
                                _this.hasError = true;
                                _this.hasTechInstallAppointment = 'ERROR';
                            }
                        }).error(function (err, status, headers, config) {
                            _this.hasError = true;
                            _this.hasTechInstallAppointment = 'ERROR';
                        });
                    };
                    OrderDetailController.$inject = ['$modal', '$modalInstance', 'ute.common.pending.order.service', 'ute.common.pending.order.provider', '$translate'];
                    OrderDetailController.controllerId = 'OrderDetailController';
                    return OrderDetailController;
                }());
                order.OrderDetailController = OrderDetailController;
                angular
                    .module('ute.common.pending.order')
                    .controller('ute.common.pending.order.detail.controller', OrderDetailController);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var TermsConditionController = (function () {
                    function TermsConditionController(pendingOrderProvider, languageProvider) {
                        this.pendingOrderProvider = pendingOrderProvider;
                        this.languageProvider = languageProvider;
                        this.cmsContentURL = this.pendingOrderProvider.getConfig().basic.cmsContentURL;
                        this.currentLanguage = this.languageProvider.getCurrentLanguage();
                    }
                    TermsConditionController.$inject = ['ute.common.pending.order.provider', 'ute.blocks.language.switcher'];
                    TermsConditionController.controllerId = 'TermsConditionController';
                    return TermsConditionController;
                }());
                order.TermsConditionController = TermsConditionController;
                angular
                    .module('ute.common.pending.order')
                    .controller('ute.common.pending.order.terms.controller', TermsConditionController);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var ViewAppointmentController = (function () {
                    function ViewAppointmentController($modalInstance, pendingOrderService, pendingOrderProvider, eclipseRemoteApi) {
                        this.$modalInstance = $modalInstance;
                        this.pendingOrderService = pendingOrderService;
                        this.pendingOrderProvider = pendingOrderProvider;
                        this.eclipseRemoteApi = eclipseRemoteApi;
                        this.hasError = false;
                        this.cmsContentURL = this.pendingOrderProvider.getConfig().basic.cmsContentURL;
                        this.hasTechInstallAppointment = 'LOADING';
                        this.errorType = '';
                        this.isAgent = this.pendingOrderService.isAgent();
                        this.fetchAppointment();
                    }
                    ViewAppointmentController.prototype.reScheduleAppointment = function () {
                        this.hasTechInstallAppointment = 'GOTO_PENDING_ORDERS';
                        var params = {
                            accountNumber: this.pendingOrderService.getAccountNumber(),
                            serviceRequiredDate: this.serviceRequiredDate,
                        };
                        console.log('pending order sending params:', params);
                        this.eclipseRemoteApi.goToPendingOrders(params);
                    };
                    ViewAppointmentController.prototype.fetchAppointment = function () {
                        var _this = this;
                        var data = this.pendingOrderService.getAppointment();
                        data.success(function (resp, status, headers, config) {
                            _this.appointment = (resp.getCurrentTechInstallAppointment) ? resp.getCurrentTechInstallAppointment : [];
                            if (_this.appointment && _this.appointment.error === '') {
                                _this.hasError = false;
                                _this.hasTechInstallAppointment = 'TRUE';
                                _this.serviceRequiredDate = _this.appointment.appointmentDate;
                            }
                            else if (_this.appointment && (_this.appointment.error === '70042' || _this.appointment.error === '30001841')) {
                                _this.hasError = true;
                                _this.hasTechInstallAppointment = 'ERROR';
                                _this.errorType = 'DUPLICATE';
                            }
                            else {
                                _this.hasError = true;
                                _this.hasTechInstallAppointment = 'ERROR';
                            }
                        }).error(function (err, status, headers, config) {
                            _this.hasError = true;
                            _this.hasTechInstallAppointment = 'ERROR';
                        });
                    };
                    ViewAppointmentController.$inject = ['$modalInstance', 'ute.common.pending.order.service', 'ute.common.pending.order.provider', 'ute.rogers.eclipse.remote.api.service'];
                    ViewAppointmentController.controllerId = 'ViewAppointmentController';
                    return ViewAppointmentController;
                }());
                order.ViewAppointmentController = ViewAppointmentController;
                angular
                    .module('ute.common.pending.order')
                    .controller('ute.common.pending.order.view.appointment.controller', ViewAppointmentController);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                /**
                 * Private interface
                 */
                var PendingOrderProvider = (function () {
                    function PendingOrderProvider() {
                        var _this = this;
                        this.config = {
                            basic: {
                                cmsContentURL: window.location.origin + '/web/totes/cms/content/ute/rogers/eclipse/views',
                                applicationId: 'rogers.com',
                                pendingOrderController: 'ute.common.pending.order.controller',
                                pendingOrderControllerAs: 'pendingOrder',
                                templateUrl: 'module/pendingOrder/pendingOrder.view.html',
                                modalWindowTemplateUrl: 'module/pendingOrder/pendingOrderModal/modalWindow.view.html',
                                termsConditionModalController: 'ute.common.pending.order.terms.controller',
                                termsConditionModalTemplateUrl: 'module/pendingOrder/pendingOrderModal/termsCondition.view.html',
                                termsConditionModalControllerAs: 'termsVM',
                                termsConditionModalSize: 'lg',
                                orderDetailModalController: 'ute.common.pending.order.detail.controller',
                                orderDetailModalTemplateUrl: 'module/pendingOrder/pendingOrderModal/orderDetail.view.html',
                                orderDetailModalControllerAs: 'orderVM',
                                orderDetailModalSize: 'lg',
                                viewAppointmentModalController: 'ute.common.pending.order.view.appointment.controller',
                                viewAppointmentModalTemplateUrl: 'module/pendingOrder/pendingOrderModal/viewAppointment.view.html',
                                viewAppointmentModalControllerAs: 'appointmentVM',
                                viewAppointmentModalSize: 'lg'
                            },
                            advanced: {
                                orderInfoApiUrl: 'v1/getOrderInfo',
                                orderDetailsApiURL: 'v1/getOrderDetail',
                                viewAppointmentApiURL: 'v1/viewInstallationAppointment'
                            }
                        };
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.$get = function () {
                            return {
                                getConfig: _this.getConfig,
                            };
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        this.$get.$inject = [];
                    }
                    PendingOrderProvider.$inject = [];
                    return PendingOrderProvider;
                }());
                angular.module('ute.common.pending.order').provider('ute.common.pending.order.provider', PendingOrderProvider);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var pending;
        (function (pending) {
            var order;
            (function (order) {
                'use strict';
                var PendingOrderService = (function () {
                    function PendingOrderService($http, pendingOrderProvider, securityService, uteCommonUserService, $timeout) {
                        var _this = this;
                        this.$http = $http;
                        this.pendingOrderProvider = pendingOrderProvider;
                        this.securityService = securityService;
                        this.uteCommonUserService = uteCommonUserService;
                        this.$timeout = $timeout;
                        this.cache = {};
                        this.resetModel = function () {
                            _this.model = {
                                accountNumber: null,
                                language: null,
                                orderId: null,
                                refresh: 'false'
                            };
                        };
                        this.resetModel();
                    }
                    ;
                    PendingOrderService.prototype.getOrderInfo = function (accountNumber) {
                        var _this = this;
                        var request = {
                            accountNumber: accountNumber,
                            applicationId: this.pendingOrderProvider.getConfig().basic.applicationId,
                            language: this.model.language,
                            refresh: this.model.refresh
                        };
                        if (this.cache[accountNumber]) {
                            if (this.cache[accountNumber].pendingRequest) {
                                return this.cache[accountNumber].promise;
                            }
                            else {
                                this.$timeout(function () {
                                    return _this.cache[accountNumber].result;
                                }, 20);
                            }
                        }
                        var httpPromise = this.$http.post(this.securityService.getBackendUrl(this.pendingOrderProvider.getConfig().advanced.orderInfoApiUrl), request)
                            .success(function (result) {
                            _this.cache[accountNumber] = {
                                pendingRequest: false,
                                promise: null,
                                result: result
                            };
                        })
                            .error(function (result) {
                            _this.cache[accountNumber] = {
                                pendingRequest: false,
                                promise: null,
                                result: result
                            };
                        });
                        this.cache[accountNumber] = {
                            pendingRequest: true,
                            promise: httpPromise,
                            result: null
                        };
                        return httpPromise;
                    };
                    PendingOrderService.prototype.getOrderDetail = function () {
                        var request = {
                            accountNumber: this.model.accountNumber,
                            applicationId: this.pendingOrderProvider.getConfig().basic.applicationId,
                            language: this.model.language,
                            orderId: this.model.orderId,
                            refresh: this.model.refresh
                        };
                        var result = this.$http.post(this.securityService.getBackendUrl(this.pendingOrderProvider.getConfig().advanced.orderDetailsApiURL), request);
                        return result;
                    };
                    PendingOrderService.prototype.getAppointment = function () {
                        var request = {
                            accountNumber: this.model.accountNumber,
                            applicationId: this.pendingOrderProvider.getConfig().basic.applicationId,
                            language: this.model.language,
                            refresh: this.model.refresh
                        };
                        var result = this.$http.post(this.securityService.getBackendUrl(this.pendingOrderProvider.getConfig().advanced.viewAppointmentApiURL), request);
                        return result;
                    };
                    PendingOrderService.prototype.setAccountNumber = function (account) {
                        this.model.accountNumber = account;
                    };
                    PendingOrderService.prototype.getAccountNumber = function () {
                        return this.model.accountNumber;
                    };
                    PendingOrderService.prototype.setLanguage = function (language) {
                        this.model.language = language;
                    };
                    PendingOrderService.prototype.getLanguage = function () {
                        return this.model.language;
                    };
                    PendingOrderService.prototype.setOrderId = function (orderId) {
                        this.model.orderId = orderId;
                    };
                    PendingOrderService.prototype.getOrderId = function () {
                        return this.model.orderId;
                    };
                    PendingOrderService.prototype.setRefresh = function (refresh) {
                        this.model.refresh = refresh;
                    };
                    PendingOrderService.prototype.getRefresh = function () {
                        return this.model.refresh;
                    };
                    PendingOrderService.prototype.setHasOrders = function (hasOrders) {
                        this.model.hasOrders = hasOrders;
                    };
                    PendingOrderService.prototype.getHasOrders = function () {
                        return this.model ? this.model.hasOrders : false;
                    };
                    PendingOrderService.prototype.getTermsModalConfig = function () {
                        return {
                            windowTemplateUrl: this.pendingOrderProvider.getConfig().basic.modalWindowTemplateUrl,
                            controller: this.pendingOrderProvider.getConfig().basic.termsConditionModalController,
                            templateUrl: this.pendingOrderProvider.getConfig().basic.termsConditionModalTemplateUrl,
                            controllerAs: this.pendingOrderProvider.getConfig().basic.termsConditionModalControllerAs,
                            size: this.pendingOrderProvider.getConfig().basic.termsConditionModalSize
                        };
                    };
                    PendingOrderService.prototype.getOrderDetailsModalConfig = function () {
                        return {
                            windowTemplateUrl: this.pendingOrderProvider.getConfig().basic.modalWindowTemplateUrl,
                            controller: this.pendingOrderProvider.getConfig().basic.orderDetailModalController,
                            templateUrl: this.pendingOrderProvider.getConfig().basic.orderDetailModalTemplateUrl,
                            controllerAs: this.pendingOrderProvider.getConfig().basic.orderDetailModalControllerAs,
                            size: this.pendingOrderProvider.getConfig().basic.orderDetailModalSize
                        };
                    };
                    PendingOrderService.prototype.getUserType = function () {
                        return this.uteCommonUserService.getUserType();
                    };
                    PendingOrderService.prototype.isAgent = function () {
                        return this.uteCommonUserService.getUserType() === 'dealer';
                    };
                    PendingOrderService.$inject = ['$http', 'ute.common.pending.order.provider', 'ute.common.security.service', 'ute.common.user.service', '$timeout'];
                    return PendingOrderService;
                }());
                order.PendingOrderService = PendingOrderService;
                angular
                    .module('ute.common.pending.order')
                    .service('ute.common.pending.order.service', PendingOrderService);
            })(order = pending.order || (pending.order = {}));
        })(pending = common.pending || (common.pending = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayController = (function () {
                    /* @ngInject */
                    function PromiseToPayController(promiseToPayService) {
                        this.promiseToPayService = promiseToPayService;
                        this.screenName = this.promiseToPayService.getScreenName();
                    }
                    PromiseToPayController.controllerName = 'ute.promise.to.pay.directive.controller';
                    PromiseToPayController.$inject = ['ute.promise.to.pay.service'];
                    return PromiseToPayController;
                }());
                pay.PromiseToPayController = PromiseToPayController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.directive.controller', PromiseToPayController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPay = (function () {
                    /* @ngInject */
                    function PromiseToPay(promiseToPayService) {
                        this.promiseToPayService = promiseToPayService;
                        this.restrict = 'E';
                        this.templateUrl = this.promiseToPayService.getConfig().basic.templateUrl;
                        this.controller = this.promiseToPayService.getConfig().basic.controllerName;
                        this.controllerAs = 'promiseToPay';
                        /**
                         * @param scope
                         */
                        this.linkFn = function () {
                            //linkFn
                        };
                        this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.promise.to.pay.IPromiseToPayService): ute.promise.to.pay.PromiseToPay}
                     */
                    PromiseToPay.factory = function () {
                        var directive = function (promiseToPayService) { return new PromiseToPay(promiseToPayService); };
                        directive.$inject = ['ute.promise.to.pay.service'];
                        return directive;
                    };
                    return PromiseToPay;
                }());
                angular.module('ute.promise.to.pay').directive('utePromiseToPay', PromiseToPay.factory());
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayModalController = (function () {
                    /* @ngInject */
                    function PromiseToPayModalController($modalInstance) {
                        this.$modalInstance = $modalInstance;
                    }
                    PromiseToPayModalController.prototype.cancelModal = function () {
                        this.$modalInstance.close('yes');
                    };
                    PromiseToPayModalController.controllerName = 'ute.promise.to.pay.modal.controller';
                    PromiseToPayModalController.$inject = ['$modalInstance'];
                    return PromiseToPayModalController;
                }());
                pay.PromiseToPayModalController = PromiseToPayModalController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.modal.controller', PromiseToPayModalController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayProvider = (function () {
                    /* @ngInject */
                    function PromiseToPayProvider() {
                        var _this = this;
                        this.inEligibleReasons = [];
                        this.config = {
                            basic: {
                                ptpRootState: 'ptp',
                                ptpStartState: 'start',
                                mainControllerName: 'ute.promise.to.pay.main.controller',
                                mainTemplateUrl: 'module/promiseToPay/promiseToPayMain.view.html',
                                controllerName: 'ute.promise.to.pay.directive.controller',
                                templateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPay.html',
                                partialRetrieveApiUrl: 'v1/ptp/retrievePTPInfo',
                                cancelState: 'oneViewDashboard',
                                paynow: 'paynow'
                            },
                            advanced: {
                                ptpCheckEligibility: {
                                    checkEligibilityApiUrl: 'v1/ptp/checkPromiseToPayEligibility',
                                    controllerName: 'ute.promise.to.pay.check.eligibility.directive.controller',
                                    templateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPayCheckEligibility/promiseToPayCheckEligibility.partial.html',
                                    checkEligibilitySuccessMessageUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPayCheckEligibility/promiseToPayCheckEligibilitySuccessError.html'
                                },
                                ptpMessageBanner: {
                                    messageBannerTemplateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPayMessageBanner/promiseToPayMessageBanner.html',
                                    messageBannerControllerName: 'ute.promise.to.pay.message.banner.directive.controller',
                                },
                                ptpSchedule: {
                                    schedulePTPApiUrl: 'v1/ptp/schedulePromiseToPay',
                                    controllerName: 'ute.promise.to.pay.schedulePTP.directive.controller',
                                    templateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPaySchedulePTP/promiseToPaySchedulePTPForm.partial.html'
                                },
                                ptpErrorModal: {
                                    controllerName: 'ute.promise.to.pay.modal.controller',
                                    templateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPayGeneralErrorModal.html'
                                },
                                ptpTabs: {
                                    controllerName: 'ute.promise.to.pay.directive.tabs.controller',
                                    templateUrl: 'module/promiseToPay/promiseToPayDirective/promiseToPayTabs/promiseToPayTabs.html'
                                }
                            }
                        };
                        /* @ngInject */
                        this.$get = function (messagesService, $injector, $http, $state, sessionStorage) {
                            _this.$http = $http;
                            _this.$state = $state;
                            _this.$injector = $injector;
                            _this.securityService = $injector.get('ute.common.security.service');
                            _this.encryptionService = $injector.get('ute.common.encryption.service');
                            _this.sessionStorage = sessionStorage;
                            _this.messagesService = messagesService;
                            return {
                                getConfig: _this.getConfig,
                                goToEntryState: _this.goToEntryState,
                                getEntryState: _this.getEntryState,
                                getAccountNumber: _this.getAccountNumber,
                                retrieve: _this.retrieve,
                                checkEligibility: _this.checkEligibility,
                                getLanguage: _this.getLanguage,
                                setPromiseDate: _this.setPromiseDate,
                                setPaymentMethod: _this.setPaymentMethod,
                                setPaymentAmount: _this.setPaymentAmount,
                                getEstimatedPostingDate: _this.getEstimatedPostingDate,
                                addDays: _this.addDays,
                                schedulePTP: _this.schedulePTP,
                                getRetrivePTPInfo: _this.getRetrivePTPInfo,
                                getDataModel: _this.getDataModel,
                                resetDataModel: _this.resetDataModel,
                                getWatchVariables: _this.getWatchVariables,
                                getIneligibleReasons: _this.getIneligibleReasons,
                                setIneligibleReasons: _this.setIneligibleReasons,
                                getScreenName: _this.getScreenName,
                                initializeWatchVariables: _this.initializeWatchVariables,
                                getPendingPTPDataModel: _this.getPendingPTPDataModel
                            };
                        };
                        /**
                         * @param config
                         * @returns {boolean}
                         */
                        this.configure = function (config) {
                            _this.config = _.merge(_this.config, config);
                            return true;
                        };
                        this.getConfig = function () {
                            return angular.copy(_this.config);
                        };
                        this.goToEntryState = function () {
                            return _this.$state.go(_this.getEntryState());
                        };
                        this.getEntryState = function () {
                            return _this.config.basic.ptpRootState + '.' + _this.config.basic.ptpStartState;
                        };
                        this.getAccountNumber = function () {
                            return _this.sessionStorage.getSessionStorageValue('accountNumber');
                        };
                        this.getRequestedAccountNumber = function () {
                            return _this.sessionStorage.getSessionStorageValue('requestedAccountNumber');
                        };
                        this.retrieve = function () {
                            var request = {
                                accountNumber: _this.getAccountNumber(),
                                ban: _this.getRequestedAccountNumber()
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialRetrieveApiUrl), request)
                                .then(_this.processRetrievePTPSuccess)
                                .catch(_this.processRetrievePTPError);
                        };
                        this.processRetrievePTPSuccess = function (response) {
                            if (response.data && response.data.status && response.data.status.toLowerCase() === 'success') {
                                _this.retrivePTPInfo = angular.copy(response.data);
                            }
                            return response.data;
                        };
                        this.processRetrievePTPError = function (reason) {
                            var data = '{"status": "error"}';
                            return angular.fromJson(data);
                        };
                        this.checkEligibility = function () {
                            var request = {
                                accountNumber: _this.getAccountNumber(),
                                ban: _this.getRequestedAccountNumber()
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().advanced.ptpCheckEligibility.checkEligibilityApiUrl), request)
                                .then(_this.processCheckEligibilitySuccess)
                                .catch(_this.processCheckEligibilityError);
                        };
                        this.processCheckEligibilitySuccess = function (response) {
                            if (response.data && response.data.isPTPEligible) {
                                _this.setWatchVariables(false, true, false, false);
                            }
                            else if (response.data && !response.data.isPTPEligible) {
                                _this.setIneligibleReasons(response.data.inEligibleReasonCodes);
                                _this.setWatchVariables(false, false, true, false);
                            }
                            return response.data;
                        };
                        this.processCheckEligibilityError = function (reason) {
                            var data = '{"isPTPEligible": false}';
                            return angular.fromJson(data);
                        };
                        this.getLanguage = function () {
                            var languageService = _this.$injector.get('ute.blocks.language.switcher');
                            _this.lang = languageService.getCurrentLanguage();
                            return _this.lang;
                        };
                        this.setPromiseDate = function (promiseDate) {
                            _this.dataModel.promiseDate = promiseDate;
                        };
                        this.setPaymentMethod = function (paymentMethod) {
                            _this.dataModel.paymentMethod = paymentMethod;
                        };
                        this.setPaymentAmount = function (paymentAmount) {
                            _this.dataModel.paymentAmount = paymentAmount;
                        };
                        this.getPendingPTPAmount = function () {
                            return _this.getPendingPTPAmount;
                        };
                        this.getPendingPTPDate = function () {
                            return _this.getPendingPTPDate;
                        };
                        this.getEstimatedPostingDate = function () {
                            var currentPaymentMethod = _this.dataModel.paymentMethod;
                            var numberOfDays = 1;
                            switch (currentPaymentMethod) {
                                case 'Internet/PhoneBanking':
                                    numberOfDays = 5;
                                    break;
                                case 'RogersStore':
                                    numberOfDays = 1;
                                    break;
                                case 'NRPC':
                                    numberOfDays = 10;
                                    break;
                                case 'CC/InteracDebit':
                                    numberOfDays = 1;
                                    break;
                                case 'Bank':
                                    numberOfDays = 10;
                                    break;
                                default:
                                    numberOfDays = 1;
                                    break;
                            }
                            var estimatedPostingDate = _this.addDays(new Date(_this.dataModel.promiseDate), numberOfDays);
                            _this.dataModel.postingDate = estimatedPostingDate;
                            return estimatedPostingDate;
                        };
                        this.addDays = function (date, days) {
                            if (date) {
                                date.setDate(date.getDate() + days);
                                console.log('tempDate-->' + date);
                                return date;
                            }
                        };
                        this.resetDataModel = function () {
                            _this.dataModel = {
                                promiseDate: new Date().toString(),
                                paymentMethod: 'CC/InteracDebit',
                                postingDate: new Date(),
                                paymentAmount: '0.0'
                            };
                        };
                        this.initializeWatchVariables = function () {
                            _this.watchVariables = {
                                showPendingPTP: false,
                                checkEligibilitySuccess: false,
                                checkEligibilityError: false,
                                shedulePTPSuccess: false
                            };
                        };
                        this.schedulePTP = function () {
                            //var accountNumber = this.getAccountNumber();
                            var request = {
                                paymentMethod: _this.dataModel.paymentMethod,
                                accountNumber: _this.getAccountNumber(),
                                paymentScheduledDate: new Date(_this.dataModel.promiseDate),
                                paymentAmount: _this.dataModel.paymentAmount,
                                ban: _this.getRequestedAccountNumber()
                            };
                            return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().advanced.ptpSchedule.schedulePTPApiUrl), request)
                                .then(_this.schedulePtpSuccess)
                                .catch(_this.schedulePtpError);
                        };
                        this.getRetrivePTPInfo = function () {
                            return _this.retrivePTPInfo;
                        };
                        this.schedulePtpSuccess = function (response) {
                            if (response.data.status && response.data.status.toLowerCase() === 'success') {
                                _this.setWatchVariables(false, false, false, true);
                                _this.pendingPTPDataModel = angular.copy(_this.dataModel);
                            }
                            return response.data;
                        };
                        this.schedulePtpError = function () {
                            _this.watchVariables.shedulePTPSuccess = false;
                        };
                        this.getDataModel = function () {
                            return angular.copy(_this.dataModel);
                        };
                        this.getWatchVariables = function () {
                            return _this.watchVariables;
                        };
                        this.getIneligibleReasons = function () {
                            return _this.inEligibleReasons;
                        };
                        this.setIneligibleReasons = function (reasons) {
                            _this.inEligibleReasons = [];
                            _.forEach(reasons, function (item, index) {
                                _this.inEligibleReasons.push(item.code);
                            });
                        };
                        this.getScreenName = function () {
                            return 'ptp';
                        };
                        this.getPendingPTPDataModel = function () {
                            return _this.pendingPTPDataModel;
                        };
                        this.setWatchVariables = function (showPendingPTP, chkEligibilitySuccess, chkEligibilityError, shedulePTPSuccess) {
                            _this.watchVariables.shedulePTPSuccess = shedulePTPSuccess;
                            _this.watchVariables.checkEligibilitySuccess = chkEligibilitySuccess;
                            _this.watchVariables.checkEligibilityError = chkEligibilityError;
                            _this.watchVariables.showPendingPTP = showPendingPTP;
                            _this.messagesService.publish('ute-ptp-update-message-banner');
                        };
                        this.$get.$inject = [
                            'ute.blocks.messages.bus.service',
                            '$injector',
                            '$http',
                            '$state',
                            'sessionStorage'
                        ];
                        this.resetDataModel();
                        this.initializeWatchVariables();
                    }
                    PromiseToPayProvider.$inject = [];
                    PromiseToPayProvider.serviceName = 'ute.promise.to.pay.service';
                    return PromiseToPayProvider;
                }());
                angular.module('ute.promise.to.pay').provider(PromiseToPayProvider.serviceName, PromiseToPayProvider);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnDeviceController = (function () {
                    /* @ngInject */
                    function ReactivateCtnDeviceController(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.hasDeviceName = function () {
                            return _this.reactivateCtnService.hasDeviceName();
                        };
                    }
                    ReactivateCtnDeviceController.$inject = ['ute.common.reactivate.ctn.service'];
                    return ReactivateCtnDeviceController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.device.controller', ReactivateCtnDeviceController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnDevice = (function () {
                    /* @ngInject */
                    function ReactivateCtnDevice(reactivateCtnService) {
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnDevice.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnDevice.controllerName;
                        this.controllerAs = 'reactivateCtnDevice';
                    }
                    ReactivateCtnDevice.factory = function () {
                        var directive = function (reactivateCtnService) { return new ReactivateCtnDevice(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return ReactivateCtnDevice;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnDevice', ReactivateCtnDevice.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnMessageBoxController = (function () {
                    /* @ngInject */
                    function ReactivateCtnMessageBoxController($modal, reactivateCtnService) {
                        var _this = this;
                        this.$modal = $modal;
                        this.reactivateCtnService = reactivateCtnService;
                        this.reactivateDevice = function ($event) {
                            $event.preventDefault();
                            _this.reactivateCtnService.processReactivateCtn();
                        };
                        this.isReactivateCtnCallInProgress = reactivateCtnService.isReactivateCtnCallInProgress;
                    }
                    ReactivateCtnMessageBoxController.prototype.openModalPopup = function (errorHandler) {
                        this.$modal.open({
                            templateUrl: errorHandler.templateUrl,
                            controller: this.reactivateCtnService.getConfig().advanced.reactivateCtnError.controllerName,
                            controllerAs: 'reactivateCtnErrorModal',
                            size: errorHandler.modalSize,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {
                                'ute.common.reactivate.ctn.service.errorHandler': errorHandler
                            }
                        });
                    };
                    ReactivateCtnMessageBoxController.$inject = ['$modal', 'ute.common.reactivate.ctn.service'];
                    return ReactivateCtnMessageBoxController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.messageBox.controller', ReactivateCtnMessageBoxController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var RepviewReactivateCtnMessageBox = (function () {
                    /* @ngInject */
                    function RepviewReactivateCtnMessageBox(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {
                            inputModel: '='
                        };
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.repViewReactivateCtnMessageBox.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnMessageBox.controllerName;
                        this.controllerAs = 'reactivateCtnMessageBox';
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope) {
                            // Set account number and phone number to the service model
                            _this.reactivateCtnService.setModel(scope.inputModel);
                        };
                        this.link = this.linkFn;
                    }
                    RepviewReactivateCtnMessageBox.factory = function () {
                        var directive = function (reactivateCtnService) { return new RepviewReactivateCtnMessageBox(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return RepviewReactivateCtnMessageBox;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteRepviewReactivateCtnMessageBox', RepviewReactivateCtnMessageBox.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnMessageBox = (function () {
                    /* @ngInject */
                    function ReactivateCtnMessageBox(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {
                            inputModel: '='
                        };
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnMessageBox.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnMessageBox.controllerName;
                        this.controllerAs = 'reactivateCtnMessageBox';
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope) {
                            // Set account number and phone number to the service model
                            _this.reactivateCtnService.setModel(scope.inputModel);
                        };
                        this.link = this.linkFn;
                    }
                    ReactivateCtnMessageBox.factory = function () {
                        var directive = function (reactivateCtnService) { return new ReactivateCtnMessageBox(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return ReactivateCtnMessageBox;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnMessageBox', ReactivateCtnMessageBox.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnWirelessNumberController = (function () {
                    /* @ngInject */
                    function ReactivateCtnWirelessNumberController(reactivateCtnService) {
                        var _this = this;
                        this.reactivateCtnService = reactivateCtnService;
                        this.getPhoneNumber = function () {
                            return _this.reactivateCtnService.getPhoneNumber();
                        };
                        this.getFirstName = function () {
                            return _this.reactivateCtnService.getFirstName();
                        };
                        this.backToDevicePage = function () {
                            _this.reactivateCtnService.backToDevice();
                        };
                    }
                    ReactivateCtnWirelessNumberController.$inject = ['ute.common.reactivate.ctn.service'];
                    return ReactivateCtnWirelessNumberController;
                }());
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.wirelessNumber.controller', ReactivateCtnWirelessNumberController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumber = (function () {
                    /* @ngInject */
                    function SuspendCtnWirelessNumber(reactivateCtnService) {
                        this.reactivateCtnService = reactivateCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.reactivateCtnService.getConfig().advanced.reactivateCtnWirelessNumber.templateUrl;
                        this.controller = this.reactivateCtnService.getConfig().advanced.reactivateCtnWirelessNumber.controllerName;
                        this.controllerAs = 'reactivateCtnWirelessNumber';
                    }
                    SuspendCtnWirelessNumber.factory = function () {
                        var directive = function (reactivateCtnService) { return new SuspendCtnWirelessNumber(reactivateCtnService); };
                        directive.$inject = ['ute.common.reactivate.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnWirelessNumber;
                }());
                angular.module('ute.common.reactivate.ctn').directive('uteReactivateCtnWirelessNumber', SuspendCtnWirelessNumber.factory());
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnErrorController = (function () {
                    /* @ngInject */
                    function ReactivateCtnErrorController($modalInstance, reactivateCtnService, errorCode) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.reactivateCtnService = reactivateCtnService;
                        this.errorCode = errorCode;
                        this.backToDevicePage = function () {
                            _this.$modalInstance.dismiss('cancel');
                            _this.reactivateCtnService.backToDevice();
                        };
                        if (errorCode) {
                            this.errorMessage = errorCode.frontendMessageKey;
                            this.modalIcon = errorCode.modalIcon;
                        }
                    }
                    ReactivateCtnErrorController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    ReactivateCtnErrorController.$inject = [
                        '$modalInstance',
                        'ute.common.reactivate.ctn.service',
                        'ute.common.reactivate.ctn.service.errorHandler'
                    ];
                    return ReactivateCtnErrorController;
                }());
                ctn.ReactivateCtnErrorController = ReactivateCtnErrorController;
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.error.controller', ReactivateCtnErrorController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn_1) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15700;
                        return BackEndErrorCode;
                    }());
                    var ReactivateCtnProvider = (function () {
                        /* @ngInject */
                        function ReactivateCtnProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isReactivateCtnCallInProgress = false;
                            // TODO move it to separate config
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessService/reactivate',
                                    reactivateCtnRootState: 'reactivateCtn',
                                    cancelState: 'wireless',
                                    mainControllerName: 'ute.common.reactivate.ctn.main.controller',
                                    mainTemplateUrl: 'module/reactivateCtn/reactivateCtnMain.view.html'
                                },
                                advanced: {
                                    reactivateCtnMessageBox: {
                                        controllerName: 'ute.common.reactivate.ctn.messageBox.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.view.html'
                                    },
                                    repViewReactivateCtnMessageBox: {
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.RepView.view.html'
                                    },
                                    reactivateCtnSuccess: {
                                        subState: 'success',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.reactivate.ctn.success.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.view.html'
                                    },
                                    repViewReactivateCtnSuccess: {
                                        templateUrl: 'module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.RepView.view.html'
                                    },
                                    reactivateCtnError: {
                                        controllerName: 'ute.common.reactivate.ctn.error.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnError/reactivateCtn.error.view.html'
                                    },
                                    repViewReactivateCtnError: {
                                        templateUrl: 'module/reactivateCtn/reactivateCtnError/reactivateCtn.error.RepView.view.html'
                                    },
                                    reactivateCtnWirelessNumber: {
                                        controllerName: 'ute.common.reactivate.ctn.wirelessNumber.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.wirelessNumber.directive.view.html'
                                    },
                                    reactivateCtnDevice: {
                                        controllerName: 'ute.common.reactivate.ctn.device.controller',
                                        templateUrl: 'module/reactivateCtn/reactivateCtnDirective/reactivateCtn.device.directive.view.html'
                                    }
                                }
                            };
                            /* @ngInject */
                            this.$get = function ($injector, $state, $http, $modal, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.routerHelper = $injector.get('ute.blocks.router');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$modal = $modal;
                                _this.$stateParams = $stateParams;
                                _this.$injector = $injector;
                                return {
                                    getConfig: _this.getConfig,
                                    getEntryState: _this.getEntryState,
                                    getAccountNumber: _this.getAccountNumber,
                                    setAccountNumber: _this.setAccountNumber,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    setPhoneNumber: _this.setPhoneNumber,
                                    setModel: _this.setModel,
                                    getFirstName: _this.getFirstName,
                                    hasDeviceName: _this.hasDeviceName,
                                    processReactivateCtn: _this.processReactivateCtn,
                                    reactivateCtn: _this.reactivateCtn,
                                    isReactivateCtnCallInProgress: _this.isReactivateCtnCallInProgressFn,
                                    goToState: _this.goToState,
                                    backToDevice: _this.backToDevice,
                                    restoreState: _this.restoreState,
                                    $injector: _this.$injector,
                                    configure: _this.runtimeConfigure
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                return true;
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.runtimeConfigure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                try {
                                    if (_.has(config, 'advanced.reactivateCtnSuccess.templateUrl')) {
                                        var reactiveSuccessState = _this.routerHelper.getState('reactivateCtn.success');
                                        _this.config.advanced.reactivateCtnError.templateUrl = config.advanced.reactivateCtnError.templateUrl;
                                        _this.config.advanced.reactivateCtnSuccess.templateUrl = config.advanced.reactivateCtnSuccess.templateUrl;
                                        _this.addCodes();
                                        reactiveSuccessState.templateUrl = config.advanced.reactivateCtnSuccess.templateUrl;
                                    }
                                }
                                catch (e) {
                                }
                                return true;
                            };
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.restoreState = function () {
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        console.log('ReactivateCtnProvider->restoreState', obj);
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.deviceNameEn = obj.deviceNameEn;
                                            _this.model.deviceNameFr = obj.deviceNameFr || obj.deviceNameEn;
                                            _this.model.firstName = obj.firstName;
                                            _this.runtimeTranslateService.addTranslation('en', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                            _this.runtimeTranslateService.addTranslation('fr', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                                        }
                                        else {
                                            _this.$state.go(_this.config.basic.cancelState);
                                        }
                                    });
                                }
                                else {
                                    _this.$state.go(_this.config.basic.cancelState);
                                }
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.reactivateCtnSuccess.templateUrl,
                                    modalIcon: '',
                                    modalSize: '',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.common.reactivate.ctn.fail.message',
                                    templateUrl: _this.getConfig().advanced.reactivateCtnError.templateUrl,
                                    modalIcon: 'ute.common.reactivate.ctn.images.errorWarning',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR
                                });
                            };
                            /**
                             * Get Account number from the model
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            /**
                             * @param accountNumber - set account number
                             */
                            this.setAccountNumber = function (accountNumber) {
                                _this.model.accountNumber = accountNumber;
                            };
                            /**
                             * Get Phone number from the model
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            /**
                             * @param ctn - set phone number
                             */
                            this.setPhoneNumber = function (ctn) {
                                _this.model.phoneNumber = ctn;
                            };
                            this.setModel = function (inputModel) {
                                _this.model = inputModel;
                                _this.runtimeTranslateService.addTranslation('en', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                _this.runtimeTranslateService.addTranslation('fr', ReactivateCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                            };
                            this.hasDeviceName = function () {
                                return _this.runtimeTranslateService.hasTranslation(ReactivateCtnProvider.deviceNameTranslateKey);
                            };
                            this.getFirstName = function () {
                                return _this.model.firstName;
                            };
                            this.goToState = function (state) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.reactivateCtnRootState + '.' + state, {
                                        id: id
                                    });
                                });
                            };
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null // may be from local store?
                                };
                            };
                            this.processReactivateCtn = function () {
                                _this.reactivateCtn().then(function (result) {
                                    switch (result.frontendCode) {
                                        case ute.common.reactivate.ctn.service.FrontEndErrorCode.UPDATED_OK:
                                            _this.goToState(_this.getConfig().advanced.reactivateCtnSuccess.subState);
                                            break;
                                        default:
                                            _this.openModalPopup(result);
                                            break;
                                    }
                                    return result;
                                }).catch(function (error) {
                                    _this.openModalPopup(error);
                                    return error;
                                });
                            };
                            this.reactivateCtn = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isReactivateCtnCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processReactivateCtnSuccess)
                                    .catch(_this.processReactivateCtnError)
                                    .finally(_this.finaliseReactivateCtnCallCall);
                            };
                            this.processReactivateCtnSuccess = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            this.processReactivateCtnError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseReactivateCtnCallCall = function () {
                                _this.isReactivateCtnCallInProgress = false;
                            };
                            this.isReactivateCtnCallInProgressFn = function () {
                                return _this.isReactivateCtnCallInProgress;
                            };
                            this.backToDevice = function () {
                                _this.$state.go(_this.config.basic.cancelState);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getEntryState = function () {
                                return _this.config.basic.reactivateCtnRootState + '.' + _this.config.advanced.reactivateCtnSuccess.subState;
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$modal',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        ReactivateCtnProvider.prototype.openModalPopup = function (errorHandler) {
                            this.$modal.open({
                                templateUrl: errorHandler.templateUrl,
                                controller: this.getConfig().advanced.reactivateCtnError.controllerName,
                                controllerAs: 'reactivateCtnErrorModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                backdropClass: 'bkg-modal',
                                resolve: {
                                    'ute.common.reactivate.ctn.service.errorHandler': errorHandler
                                }
                            });
                        };
                        ReactivateCtnProvider.$inject = [];
                        ReactivateCtnProvider.deviceNameTranslateKey = 'ute.common.reactivate.ctn.deviceName';
                        return ReactivateCtnProvider;
                    }());
                    angular.module('ute.common.reactivate.ctn').provider('ute.common.reactivate.ctn.service', ReactivateCtnProvider);
                })(service = ctn_1.service || (ctn_1.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var reactivate;
        (function (reactivate) {
            var ctn;
            (function (ctn) {
                'use strict';
                var ReactivateCtnSuccessController = (function () {
                    /* @ngInject */
                    function ReactivateCtnSuccessController($document, reactivateCtnService) {
                        this.$document = $document;
                        this.reactivateCtnService = reactivateCtnService;
                    }
                    ReactivateCtnSuccessController.$inject = [
                        '$document',
                        'ute.common.reactivate.ctn.service'
                    ];
                    return ReactivateCtnSuccessController;
                }());
                ctn.ReactivateCtnSuccessController = ReactivateCtnSuccessController;
                angular.module('ute.common.reactivate.ctn').controller('ute.common.reactivate.ctn.success.controller', ReactivateCtnSuccessController);
            })(ctn = reactivate.ctn || (reactivate.ctn = {}));
        })(reactivate = common.reactivate || (common.reactivate = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                    var ProviderBase = ute.common.core.ProviderBase;
                    var RogersHeroModalService = (function () {
                        function RogersHeroModalService(config, $injector, $http, $q, $timeout, $state, $cookiesTemp, $window, ngDialog, dataLayerService, $rootScope) {
                            var _this = this;
                            this.config = config;
                            this.$http = $http;
                            this.$q = $q;
                            this.$timeout = $timeout;
                            this.$state = $state;
                            this.$window = $window;
                            this.ngDialog = ngDialog;
                            this.dataLayerService = dataLayerService;
                            this.$rootScope = $rootScope;
                            this.heroResponse = {};
                            this.heroDeclinedTargetedOffers = {};
                            this.ctnList = [];
                            this.heroOfferDetails = [];
                            this.individualOfferDetails = [];
                            this.shareCtnList = [];
                            this.indCtnList = [];
                            this.heroBan = '';
                            this.isSingleOffer = false;
                            this.multiOfferPresent = false;
                            this.totalCtnsWithOffersCount = 0;
                            this.getConfig = function () { return angular.copy(_this.config); };
                            this.getHeroOffers = function () {
                                return _this.heroOfferDetails;
                            };
                            this.getIndHeroOffers = function () {
                                return _this.individualOfferDetails;
                            };
                            this.isShareEverything = function () {
                                if (_this.shareCtnList.length > 0 && _this.heroOfferDetails.length > 0) {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            };
                            this.getLang = function () {
                                return _this.heroLang;
                            };
                            this.isSingleHeroOffer = function () {
                                return _this.isSingleOffer;
                            };
                            this.isOfferPresentForSingleCtn = function () {
                                return _this.totalCtnsWithOffersCount === 1;
                            };
                            this.isIndividual = function () {
                                if (_this.indCtnList.length > 0 && _this.individualOfferDetails.length > 0) {
                                    return true;
                                }
                                else {
                                    return false;
                                }
                            };
                            this.trackCtnHeroOffers = function (ctn) {
                                try {
                                    //This try catch Block is only for analytics tracking
                                    var payload_1 = {
                                        'ecommerce': {
                                            'offers': []
                                        },
                                        'page': {}
                                    };
                                    if (!_.isEmpty(_this.heroResponseAnalytics)) {
                                        _.forEach(_this.heroResponseAnalytics.targetedHeroOfferMap[ctn], function (responseOffer, key) {
                                            if (key.toLowerCase() !== 'ctn' && !_.isEmpty(responseOffer)) {
                                                var offerType = key.toLowerCase() === 'hupoffer' ? 'HERO_HUP4' : key.toLowerCase() === 'tvmoffer' ? 'HERO_TVM' : responseOffer.bpoTypeForAnalytics;
                                                payload_1.ecommerce.offers.push({
                                                    'code': responseOffer.externalId,
                                                    'type': offerType
                                                });
                                            }
                                        });
                                    }
                                    payload_1.page = { 'name': 'bpo-offer-view', 'hierarchy': ['myrogers', 'wireless', 'bpo-offer-view'] };
                                    if (!_.isEmpty(payload_1)) {
                                        _this.dataLayerService.track(payload_1, true, [5]);
                                    }
                                }
                                catch (e) {
                                    console.log(e);
                                }
                            };
                            this.trackSelectedHeroOffers = function (ctn, hupSelected, tvmSelected, hupBpoSelected, tvmBpoSelected, noTransactionalBpoSelected) {
                                try {
                                    //This try catch Block is only for analytics tracking
                                    var payload_2 = {
                                        'ecommerce': {
                                            'offers': []
                                        },
                                        'page': {}
                                    };
                                    _.forEach(_this.heroResponseAnalytics.targetedHeroOfferMap[ctn], function (responseOffer, key) {
                                        if ((hupSelected && (key === 'hupOffer' || key === 'hup4BPO'))
                                            || (tvmSelected && (key === 'tvmOffer' || key === 'tvmBPO'))
                                            || (hupBpoSelected && key === 'hup4BPO')
                                            || (tvmBpoSelected && key === 'tvmBPO')
                                            || (noTransactionalBpoSelected && key === 'standAloneBPO')) {
                                            var offerType = key.toLowerCase() === 'hupoffer' ? 'HERO_HUP4' : key.toLowerCase() === 'tvmoffer' ? 'HERO_TVM' : key.toLowerCase() === 'standalonebpo' ? 'STANDALONE' : responseOffer.bpoTypeForAnalytics;
                                            payload_2.ecommerce.offers.push({
                                                'code': responseOffer.externalId,
                                                'type': offerType
                                            });
                                        }
                                    });
                                    payload_2.page = { 'name': 'bpo-offer-accept', 'hierarchy': ['myrogers', 'wireless', 'bpo-offer-accept'] };
                                    _this.dataLayerService.track(payload_2, true, [5]);
                                }
                                catch (e) {
                                    console.log(e);
                                }
                            };
                            this.getHupcategoryValue = function (categoryCode) {
                                var categoryMap = {
                                    'SMARTPHONE': 'Premium Tab',
                                    'PREMIUMTAB': 'Premium Tab',
                                    'PREMTAB_MB': 'Premium Tab',
                                    'PREMTAB_PQ': 'Premium Tab',
                                    'PREMTAB_SK': 'Premium Tab',
                                    'PREM_ATL': 'Premium Tab',
                                    'PREMTAB_BC': 'Premium Tab',
                                    'PREMTAB_AB': 'Premium Tab',
                                    'PREMPLUSTAB': 'Premium+ Tab',
                                    'SMARTPICKS': 'Smart Tab',
                                    'SMARTTAB': 'Smart Tab',
                                    'SMARTTAB_MB': 'Smart Tab',
                                    'SMARTTAB_SK': 'Smart Tab',
                                    'SMARTTAB_PQ': 'Smart Tab',
                                    'SMART_ATL': 'Smart Tab',
                                    'SMARTTAB_BC': 'Smart Tab',
                                    'SMARTTAB_AB': 'Smart Tab',
                                    'TALKANDTEXT': 'Talk & Text',
                                    'TALKTEXT': 'Talk & Text',
                                    'ULTRATAB': 'Ultra Tab',
                                    'ULTRATAB_AB': 'Ultra Tab',
                                    'ULTRATAB_AT': 'Ultra Tab',
                                    'ULTRATAB_BC': 'Ultra Tab',
                                    'ULTRATAB_MB': 'Ultra Tab',
                                    'ULTRATAB_PQ': 'Ultra Tab',
                                    'ULTRATAB_SK': 'Ultra Tab'
                                };
                                if (categoryMap[categoryCode]) {
                                    return categoryMap[categoryCode];
                                }
                                else {
                                    return categoryCode;
                                }
                            };
                            this.getBpoDetailsPopulated = function (targetedHeroBpo, bpocategory) {
                                var bpoDetails = {
                                    bpoid: '',
                                    bpoCategory: '',
                                    bpoType: '',
                                    bpoDisplayName: '',
                                    bpoDisplayNameFr: '',
                                    bpoDiscountValue: '',
                                    bpoDuration: '',
                                    bpoFeaturevalue: '',
                                    bpoFeatureUnit: '',
                                    bpoFeatureUnitFr: '',
                                    offerSelected: false,
                                    bpoSkuId: ''
                                };
                                bpoDetails.bpoCategory = bpocategory;
                                bpoDetails.bpoSkuId = targetedHeroBpo.id;
                                bpoDetails.bpoid = targetedHeroBpo.externalId;
                                if (targetedHeroBpo.bpoType.displayName === _this.config.constants.fixedCreditBpo) {
                                    bpoDetails.bpoDiscountValue = targetedHeroBpo.discountValue;
                                    bpoDetails.bpoType = 'fixedCredit';
                                    bpoDetails.bpoDisplayName = targetedHeroBpo.displayName;
                                    bpoDetails.bpoDisplayNameFr = targetedHeroBpo.displayNameFr;
                                }
                                if (targetedHeroBpo.bpoType.displayName === _this.config.constants.uptoCreditBpo) {
                                    bpoDetails.bpoDiscountValue = targetedHeroBpo.discountValue;
                                    bpoDetails.bpoType = 'uptoCredit';
                                    bpoDetails.bpoDisplayName = targetedHeroBpo.displayName;
                                    bpoDetails.bpoDisplayNameFr = targetedHeroBpo.displayNameFr;
                                }
                                if (targetedHeroBpo.bpoType.displayName === _this.config.constants.msfDiscountBpo) {
                                    bpoDetails.bpoDiscountValue = targetedHeroBpo.discountValue;
                                    bpoDetails.bpoDuration = targetedHeroBpo.duration;
                                    bpoDetails.bpoType = 'msfDiscount';
                                    bpoDetails.bpoDisplayName = targetedHeroBpo.displayName;
                                    bpoDetails.bpoDisplayNameFr = targetedHeroBpo.displayNameFr;
                                }
                                if (targetedHeroBpo.bpoType.displayName === _this.config.constants.bonusMinutesBpo) {
                                    bpoDetails.bpoFeaturevalue = targetedHeroBpo.featuresMap.LDMINUTES.displayNameEN;
                                    bpoDetails.bpoFeatureUnit = targetedHeroBpo.featuresMap.LDMINUTES.unitEN;
                                    bpoDetails.bpoFeatureUnitFr = targetedHeroBpo.featuresMap.LDMINUTES.unitFR;
                                    bpoDetails.bpoDuration = targetedHeroBpo.duration;
                                    bpoDetails.bpoType = 'bonusMinutes';
                                    bpoDetails.bpoDisplayName = targetedHeroBpo.displayName;
                                    bpoDetails.bpoDisplayNameFr = targetedHeroBpo.displayNameFr;
                                }
                                if (targetedHeroBpo.bpoType.displayName === _this.config.constants.bonusDataBpo) {
                                    bpoDetails.bpoFeaturevalue = targetedHeroBpo.featuresMap.DATAUSAGE.displayNameEN;
                                    bpoDetails.bpoFeatureUnit = targetedHeroBpo.featuresMap.DATAUSAGE.unitEN;
                                    bpoDetails.bpoFeatureUnitFr = targetedHeroBpo.featuresMap.DATAUSAGE.unitFR;
                                    bpoDetails.bpoDuration = targetedHeroBpo.duration;
                                    bpoDetails.bpoType = 'dataBonus';
                                    bpoDetails.bpoDisplayName = targetedHeroBpo.displayName;
                                    bpoDetails.bpoDisplayNameFr = targetedHeroBpo.displayNameFr;
                                }
                                return bpoDetails;
                            };
                            this.getHeroOfferDetailsPopulated = function (targetedHeroOffer, offerType, heroBpo) {
                                var heroOffer = {
                                    offerType: '',
                                    id: '',
                                    skuId: '',
                                    programCode: '',
                                    hupOfferCategory: '',
                                    hupOfferCategoryValueEn: '',
                                    hupOfferCategoryValueFr: '',
                                    devicePrice: '',
                                    devicePriceDecimal: '',
                                    deviceDisplayName: '',
                                    deviceDisplayNameFr: '',
                                    deviceImageUrl: '',
                                    planPrice: '',
                                    dataDisplayNameEn: '',
                                    dataDisplayNameFr: '',
                                    dataDisplayUnitEn: '',
                                    dataDisplayUnitFr: '',
                                    talkDisplayNameEn: '',
                                    talkDisplayNameFr: '',
                                    textDisplayNameEn: '',
                                    textDisplayNameFr: '',
                                    bpoDetails: '',
                                    term: '',
                                    offerSelected: false,
                                    tvmDisplayName: '',
                                    tvmDisplayNameFr: ''
                                };
                                heroOffer.offerType = offerType;
                                heroOffer.id = targetedHeroOffer.externalId;
                                heroOffer.skuId = targetedHeroOffer.id;
                                if (offerType === 'hupOffer') {
                                    heroOffer.deviceDisplayNameFr = targetedHeroOffer.displayNameFr;
                                    heroOffer.deviceDisplayName = targetedHeroOffer.displayName;
                                    heroOffer.programCode = targetedHeroOffer.programCode;
                                    heroOffer.hupOfferCategory = targetedHeroOffer.categoryCode;
                                    heroOffer.hupOfferCategoryValueEn = _this.getHupcategoryValue(targetedHeroOffer.categoryCode);
                                    heroOffer.hupOfferCategoryValueFr = _this.getHupcategoryValue(targetedHeroOffer.categoryCode);
                                    var stringPrice = targetedHeroOffer.price.toString();
                                    heroOffer.term = targetedHeroOffer.term;
                                    var nameArr = stringPrice.split('.');
                                    if (nameArr.length > 1) {
                                        heroOffer.devicePrice = nameArr[0];
                                        heroOffer.devicePriceDecimal = '.' + nameArr[1];
                                    }
                                    else {
                                        heroOffer.devicePrice = targetedHeroOffer.price;
                                    }
                                    heroOffer.deviceImageUrl = _this.config.constants.imageUrlPrefix + targetedHeroOffer.media.largeImage_1.url;
                                    if (heroBpo.some(function (bpoDetails) { return bpoDetails.bpoCategory === 'hupBpo'; })) {
                                        heroOffer.bpoDetails = heroBpo.filter(function (bpoDetails) { return bpoDetails.bpoCategory === 'hupBpo'; })[0];
                                    }
                                }
                                else if (offerType === 'tvmOffer') {
                                    heroOffer.planPrice = targetedHeroOffer.price;
                                    heroOffer.tvmDisplayName = targetedHeroOffer.displayName;
                                    heroOffer.tvmDisplayNameFr = targetedHeroOffer.displayNameFr;
                                    if (targetedHeroOffer.featuresMap.data) {
                                        heroOffer.dataDisplayNameEn = targetedHeroOffer.featuresMap.data.displayNameEN;
                                        heroOffer.dataDisplayNameFr = targetedHeroOffer.featuresMap.data.displayNameFR;
                                        heroOffer.dataDisplayUnitEn = targetedHeroOffer.featuresMap.data.unitEN;
                                        heroOffer.dataDisplayUnitFr = targetedHeroOffer.featuresMap.data.unitFR;
                                    }
                                    if (targetedHeroOffer.featuresMap.talk) {
                                        heroOffer.talkDisplayNameEn = targetedHeroOffer.featuresMap.talk.displayNameEN;
                                        heroOffer.talkDisplayNameFr = targetedHeroOffer.featuresMap.talk.displayNameFR;
                                    }
                                    if (targetedHeroOffer.featuresMap.text) {
                                        heroOffer.textDisplayNameEn = targetedHeroOffer.featuresMap.text.displayNameEN;
                                        heroOffer.textDisplayNameFr = targetedHeroOffer.featuresMap.text.displayNameFR;
                                    }
                                    if (heroBpo.some(function (bpoDetails) { return bpoDetails.bpoCategory === 'tvmBpo'; })) {
                                        heroOffer.bpoDetails = heroBpo.filter(function (bpoDetails) { return bpoDetails.bpoCategory === 'tvmBpo'; })[0];
                                    }
                                }
                                heroOffer.offerSelected = false;
                                return heroOffer;
                            };
                            this.getHeroDetail = function (ban, ctnListparam, shareCtnListParam, indCtnListParam, ctnParam, ifPreSelectedParam, heroLang) {
                                _this.$window.localStorage.removeItem('hupStandaloneBpo');
                                _this.$window.localStorage.removeItem('tvmStandaloneBpo');
                                if (ctnListparam && ctnListparam.length > 0) {
                                    var ctnListRequest = ctnListparam;
                                    var request = {
                                        ban: ban,
                                        ctnList: ctnListRequest,
                                    };
                                    _this.heroLang = heroLang;
                                    _this.ifPreSelected = ifPreSelectedParam;
                                    _this.heroBan = ban;
                                    _this.preSelectedCtn = ctnParam;
                                    _this.ctnList = ctnListparam;
                                    _this.indCtnList = indCtnListParam;
                                    _this.shareCtnList = shareCtnListParam;
                                    _this.isIndividual();
                                    _this.isShareEverything();
                                    _this.$http.post(_this.config.advanced.HeroModal.protectedRoot + _this.config.advanced.HeroModal.apiUrl, request)
                                        .then(_this.processOk)
                                        .catch(_this.processError)
                                        .finally(_this.finaliseCall);
                                }
                                else {
                                    console.log('CTN List empty - TargetedOffers not called');
                                }
                            };
                            this.getHeroDetailResponse = function (ban, ctnListparam) {
                                if (ctnListparam && ctnListparam.length > 0) {
                                    var ctnListRequest = ctnListparam;
                                    var request = {
                                        ban: ban,
                                        ctnList: ctnListRequest,
                                    };
                                    return _this.$http.post(_this.config.advanced.HeroModal.protectedRoot + _this.config.advanced.HeroModal.apiUrl, request)
                                        .then(_this.processSuccess)
                                        .catch(_this.processError)
                                        .finally(_this.finaliseCall);
                                }
                                else {
                                    console.log('CTN List empty - TargetedOffers not called');
                                }
                            };
                            this.processSuccess = function (response) {
                                return response;
                            };
                            this.processOk = function (response) {
                                console.log('getHeroDetailsResponse' + response);
                                _this.heroOfferDetails = [];
                                _this.individualOfferDetails = [];
                                _this.heroResponse = response.data;
                                _this.heroResponseAnalytics = response.data;
                                var declinedHeroOffers = {
                                    ban: '',
                                    offersList: []
                                };
                                declinedHeroOffers.ban = _this.heroBan;
                                if (_this.ctnList.length > 0) {
                                    _this.ctnList.forEach(function (contextCtn) {
                                        var isShareCtn = _this.shareCtnList.some(function (shareCtnObj) { return shareCtnObj.ctn === contextCtn; });
                                        var isIndividualCtn = _this.indCtnList.some(function (indCtn) { return indCtn === contextCtn; });
                                        console.log('CTN in context - ' + contextCtn);
                                        var ctn = contextCtn;
                                        var heroOfferDetailsForCtn = {
                                            ctn: '',
                                            offer: [],
                                            bpo: [],
                                            showContent: false,
                                            showCheckbox: false,
                                            hupPresent: false,
                                            tvmPresent: false,
                                            hupBpoPresent: false,
                                            tvmBpoPresent: false,
                                            colorCode: '',
                                            noTransactionalBpoPresent: false
                                        };
                                        if (response.data.targetedHeroOfferMap[ctn]) {
                                            var targetedHeroOffer = response.data.targetedHeroOfferMap[ctn];
                                            heroOfferDetailsForCtn.ctn = ctn;
                                            if (isShareCtn) {
                                                heroOfferDetailsForCtn.colorCode = _this.shareCtnList.filter(function (shareCtnObj) { return shareCtnObj.ctn === contextCtn; })[0].colorCode;
                                            }
                                            if (_this.preSelectedCtn === ctn) {
                                                heroOfferDetailsForCtn.showContent = true;
                                            }
                                            else {
                                                heroOfferDetailsForCtn.showContent = false;
                                            }
                                            var declinedOffer = {
                                                ctn: '',
                                                hupOffer: '',
                                                tvmOffer: '',
                                                hup4BPO: '',
                                                tvmBPO: '',
                                                standAloneBPO: ''
                                            };
                                            declinedOffer.ctn = ctn;
                                            if (targetedHeroOffer.hup4BPO) {
                                                heroOfferDetailsForCtn.hupBpoPresent = true;
                                                declinedOffer.hup4BPO = targetedHeroOffer.hup4BPO.id;
                                                heroOfferDetailsForCtn.bpo.push(_this.getBpoDetailsPopulated(targetedHeroOffer.hup4BPO, 'hupBpo'));
                                            }
                                            if (targetedHeroOffer.tvmBPO) {
                                                heroOfferDetailsForCtn.tvmBpoPresent = true;
                                                declinedOffer.tvmBPO = targetedHeroOffer.tvmBPO.id;
                                                heroOfferDetailsForCtn.bpo.push(_this.getBpoDetailsPopulated(targetedHeroOffer.tvmBPO, 'tvmBpo'));
                                            }
                                            if (targetedHeroOffer.hupOffer) {
                                                heroOfferDetailsForCtn.hupPresent = true;
                                                declinedOffer.hupOffer = targetedHeroOffer.hupOffer.id;
                                                heroOfferDetailsForCtn.offer.push(_this.getHeroOfferDetailsPopulated(targetedHeroOffer.hupOffer, 'hupOffer', heroOfferDetailsForCtn.bpo));
                                            }
                                            if (targetedHeroOffer.tvmOffer) {
                                                heroOfferDetailsForCtn.tvmPresent = true;
                                                declinedOffer.tvmOffer = targetedHeroOffer.tvmOffer.id;
                                                heroOfferDetailsForCtn.offer.push(_this.getHeroOfferDetailsPopulated(targetedHeroOffer.tvmOffer, 'tvmOffer', heroOfferDetailsForCtn.bpo));
                                            }
                                            if (targetedHeroOffer.standAloneBPO) {
                                                heroOfferDetailsForCtn.noTransactionalBpoPresent = true;
                                                _this.noTransactionalBpoPresent = true;
                                                declinedOffer.standAloneBPO = targetedHeroOffer.standAloneBPO.id;
                                                heroOfferDetailsForCtn.bpo.push(_this.getBpoDetailsPopulated(targetedHeroOffer.standAloneBPO, 'noTransactionalBPO'));
                                            }
                                            //If HUP4Offer or TVMOffer present, after adding the BPO into offer, reset to empty. To handle not displaying BPO under standalone section
                                            if (heroOfferDetailsForCtn.hupPresent || heroOfferDetailsForCtn.tvmPresent) {
                                                heroOfferDetailsForCtn.bpo = [];
                                            } /* Commented out to handle multiple standalone BPOs
                                                else {
                                                //If no HUP4 or TVM offer present, it is standalone BPO scenario. If both HUP4 and TVM BPOs present, consider only HUP4 BPO
                                                if (heroOfferDetailsForCtn.hupBpoPresent && heroOfferDetailsForCtn.tvmBpoPresent) {
                                                    heroOfferDetailsForCtn.bpo = heroOfferDetailsForCtn.bpo.filter(bpo => bpo.bpoCategory === 'hupBpo');
                                                }
                                            } */
                                            if (heroOfferDetailsForCtn.hupPresent && heroOfferDetailsForCtn.tvmPresent) {
                                                heroOfferDetailsForCtn.showCheckbox = true;
                                                _this.multiOfferPresent = true;
                                            }
                                            if (heroOfferDetailsForCtn.hupBpoPresent && heroOfferDetailsForCtn.tvmBpoPresent) {
                                                heroOfferDetailsForCtn.showCheckbox = true;
                                                _this.multiOfferPresent = true;
                                            }
                                            /* if (this.listLength === 1) {
                                              if ((heroOfferDetailsForCtn.hupPresent && !heroOfferDetailsForCtn.tvmPresent)
                                                    || (!heroOfferDetailsForCtn.hupPresent && heroOfferDetailsForCtn.tvmPresent)) {
                                                this.isSingleOffer = true;
                                              }
                                              if ((!heroOfferDetailsForCtn.hupPresent && !heroOfferDetailsForCtn.tvmPresent)
                                                    && ((!heroOfferDetailsForCtn.hupBpoPresent && heroOfferDetailsForCtn.tvmBpoPresent)
                                                    || (heroOfferDetailsForCtn.hupBpoPresent && !heroOfferDetailsForCtn.tvmBpoPresent))) {
                                                this.isSingleOffer = true;
                                              }
                                            } */
                                            if (isShareCtn) {
                                                _this.heroOfferDetails.push(heroOfferDetailsForCtn);
                                            }
                                            else if (isIndividualCtn) {
                                                _this.individualOfferDetails.push(heroOfferDetailsForCtn);
                                            }
                                            declinedHeroOffers.offersList.push(declinedOffer);
                                        }
                                    });
                                    _this.totalCtnsWithOffersCount = _this.heroOfferDetails.length + _this.individualOfferDetails.length;
                                    if (_this.totalCtnsWithOffersCount === 1) {
                                        if (!_this.multiOfferPresent) {
                                            _this.isSingleOffer = true;
                                        }
                                        if (_this.heroOfferDetails.length > 0) {
                                            _this.heroOfferDetails[0].showContent = true;
                                        }
                                        else {
                                            _this.individualOfferDetails[0].showContent = true;
                                        }
                                    }
                                }
                                _this.heroDeclinedTargetedOffers = declinedHeroOffers;
                                if ((!response.data.heroOffersdeclined || _this.ifPreSelected) && (_this.heroOfferDetails.length > 0 || _this.individualOfferDetails.length > 0)) {
                                    _this.DialogVM = _this.ngDialog.open({
                                        template: _this.config.advanced.HeroModal.templateUrl,
                                        controller: _this.config.advanced.HeroModal.controllerName,
                                        controllerAs: 'vm',
                                        className: 'hero-modal-container'
                                    });
                                    if (_this.totalCtnsWithOffersCount === 1) {
                                        //Only for single CTN with offer scenario, we will auto open the offer. Other cases offer is shown only on expansion of CTN tab
                                        try {
                                            //This try catch Block is only for analytics tracking
                                            var payload_3 = {
                                                'ecommerce': {
                                                    'offers': []
                                                },
                                                'page': {}
                                            };
                                            if (!_.isEmpty(_this.heroResponseAnalytics)) {
                                                _.forEach(_this.heroResponseAnalytics.targetedHeroOfferMap[Object.keys(_this.heroResponseAnalytics.targetedHeroOfferMap)[0]], function (responseOffer, key) {
                                                    if (key.toLowerCase() !== 'ctn' && !_.isEmpty(responseOffer)) {
                                                        var offerType = key.toLowerCase() === 'hupoffer' ? 'HERO_HUP4' : key.toLowerCase() === 'tvmoffer' ? 'HERO_TVM' : key.toLowerCase() === 'standalonebpo' ? 'STANDALONE' : responseOffer.bpoTypeForAnalytics;
                                                        payload_3.ecommerce.offers.push({
                                                            'code': responseOffer.externalId,
                                                            'type': offerType
                                                        });
                                                    }
                                                });
                                            }
                                            payload_3.page = { 'name': 'bpo-offer-view', 'hierarchy': ['myrogers', 'wireless', 'bpo-offer-view'] };
                                            if (!_.isEmpty(payload_3)) {
                                                _this.dataLayerService.track(payload_3, true, [5]);
                                            }
                                        }
                                        catch (e) {
                                            console.log(e);
                                        }
                                    }
                                }
                                //Emit this to Wireless Dashboard only if offers are constructed
                                _this.$rootScope.$emit('heroResponse', _this.heroResponse);
                            };
                            this.validateBPOOffer = function (bpoRequest) {
                                _this.$http.post(_this.config.advanced.HeroModal.protectedRoot + _this.config.advanced.validateBPOOffer.apiUrl, bpoRequest)
                                    .success(function (response) {
                                    bpoRequest.sessionKey = response.sessionKey ? response.sessionKey : "";
                                    _this.callSubmitBPOOffers(bpoRequest);
                                })
                                    .error(function (error) {
                                    _this.DialogVM.close();
                                    _this.DialogVM = _this.ngDialog.open({
                                        template: _this.config.advanced.HeroModal.errorPopUpUrl,
                                        controller: _this.config.advanced.HeroModal.controllerName,
                                        controllerAs: 'vm',
                                        className: 'success-error-modal-container',
                                        backdrop: 'static'
                                    });
                                });
                            };
                            this.callSubmitBPOOffers = function (bpoRequest) {
                                _this.$http.post(_this.config.advanced.HeroModal.protectedRoot + _this.config.advanced.submitBPOOffers.apiUrl, bpoRequest)
                                    .success(function (response) {
                                    _this.DialogVM.close();
                                    _this.DialogVM = _this.ngDialog.open({
                                        template: _this.config.advanced.HeroModal.successPopUpUrl,
                                        controller: _this.config.advanced.HeroModal.controllerName,
                                        controllerAs: 'vm',
                                        className: 'success-error-modal-container',
                                        backdrop: 'static'
                                    });
                                })
                                    .error(function (error) {
                                    _this.DialogVM.close();
                                    _this.DialogVM = _this.ngDialog.open({
                                        template: _this.config.advanced.HeroModal.errorPopUpUrl,
                                        controller: _this.config.advanced.HeroModal.controllerName,
                                        controllerAs: 'vm',
                                        className: 'success-error-modal-container',
                                        backdrop: 'static'
                                    });
                                });
                            };
                            this.getNoTransactionalBpoPresent = function () {
                                return _this.noTransactionalBpoPresent;
                            };
                            this.setNoTransactionalBpoPresent = function (noTransactionalBpoPresent) {
                                _this.noTransactionalBpoPresent = noTransactionalBpoPresent;
                            };
                            this.setNoTransactionalBpoOfferDetails = function (noTransactionalBpoOffer) {
                                _this.noTransactionalBpoOfferDetails = noTransactionalBpoOffer;
                            };
                            this.getNoTransactionalBpoOfferDetails = function () {
                                return _this.noTransactionalBpoOfferDetails;
                            };
                            this.processError = function (response) { };
                            this.finaliseCall = function () { };
                        }
                        ;
                        RogersHeroModalService.serviceName = 'ute.rogers.hero.modal.service';
                        return RogersHeroModalService;
                    }());
                    var RogersHeroModalProvider = (function (_super) {
                        __extends(RogersHeroModalProvider, _super);
                        /* @ngInject */
                        function RogersHeroModalProvider() {
                            var _this = this;
                            _super.call(this);
                            /* @ngInject */
                            this.$get = function ($injector, $http, $q, $timeout, $state, $cookies, $window, ngDialog, dataLayerService, $rootScope) {
                                return new RogersHeroModalService(_this.config, $injector, $http, $q, $timeout, $state, $cookies, $window, ngDialog, dataLayerService, $rootScope);
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$http',
                                '$q',
                                '$timeout',
                                '$state',
                                '$cookies',
                                '$window',
                                'ngDialog',
                                'ute.datalayer.common.service',
                                '$rootScope'
                            ];
                            this.config = service.DefaultConfigFactory();
                        }
                        RogersHeroModalProvider.$inject = [];
                        return RogersHeroModalProvider;
                    }(ProviderBase));
                    angular.module('ute.rogers.bpo.integration.service').provider(RogersHeroModalService.serviceName, RogersHeroModalProvider);
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var bpo;
        (function (bpo) {
            var integration;
            (function (integration) {
                var service;
                (function (service) {
                    'use strict';
                    function DefaultConfigFactory() {
                        return {
                            basic: {
                                colorHexGuide: ['#008fb6', '#E4BC40', '#662d91', '#7aaa39', '#ac0067', '#2926ab', '#cd5e40', '#2b464c', '#bbb62a', '#317d59']
                            },
                            advanced: {
                                HeroModal: {
                                    protectedRoot: '/web/RogersServices.portal/totes/',
                                    apiUrl: 'api/v1/getTargetedHeroOffers',
                                    controllerName: 'ute.rogers.hero.modal.controller',
                                    templateUrl: 'module/hero/heroModal.view.html',
                                    successPopUpUrl: 'module/hero/heroModal.successModal.html',
                                    errorPopUpUrl: 'module/hero/heroModal.errorModal.html'
                                },
                                declineHeroModal: {
                                    apiUrl: 'api/v1/declineTargetedHeroOffers'
                                },
                                updateHeroOffersInDb: {
                                    url: 'api/v1/updateHeroOffersInDb'
                                },
                                validateBPOOffer: {
                                    apiUrl: 'api/v1/checkout/validateBPOOffer'
                                },
                                submitBPOOffers: {
                                    apiUrl: 'api/v1/checkout/submitBPOOffer'
                                }
                            },
                            constants: {
                                uptoCreditBpo: 'ACCOUNT_CREDIT_UPTO_DEVICE_PRICE',
                                fixedCreditBpo: 'ACCOUNT_CREDIT_FIXED',
                                bonusDataBpo: 'DATA_BONUS_BPO',
                                bonusMinutesBpo: 'LD_BPO',
                                msfDiscountBpo: 'MSF_DISCOUNT_BPO',
                                imageUrlPrefix: '/web/totes'
                            }
                        };
                    }
                    service.DefaultConfigFactory = DefaultConfigFactory;
                })(service = integration.service || (integration.service = {}));
            })(integration = bpo.integration || (bpo.integration = {}));
        })(bpo = rogers.bpo || (rogers.bpo = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersSecondLevelNavigationConsumerController = (function () {
                        /* @ngInject */
                        function RogersSecondLevelNavigationConsumerController($q, $state, $scope, $window, $injector, navigationService, accountOverviewFactory, accountOverviewSummaryFactory, languageService, userService, rogersNavigationService, permissionsService, payNowService, billingDetailFactory, paymentMethodService, brtSwitchService, messageService) {
                            var _this = this;
                            this.$q = $q;
                            this.$state = $state;
                            this.$scope = $scope;
                            this.$window = $window;
                            this.$injector = $injector;
                            this.navigationService = navigationService;
                            this.accountOverviewSummaryFactory = accountOverviewSummaryFactory;
                            this.languageService = languageService;
                            this.userService = userService;
                            this.rogersNavigationService = rogersNavigationService;
                            this.permissionsService = permissionsService;
                            this.payNowService = payNowService;
                            this.billingDetailFactory = billingDetailFactory;
                            this.paymentMethodService = paymentMethodService;
                            this.brtSwitchService = brtSwitchService;
                            this.messageService = messageService;
                            this.shareEverythingPermission = false;
                            this.showSecondLevelNavigationConsumer = true;
                            this.initializeDataModel = function () {
                                _this.secondLevelNavDataModel = {
                                    title: 'ute.common.second.level.navigation.header',
                                    titleMobile: 'ute.common.second.level.navigation.headerShort',
                                    navigationBar: [{
                                            id: 'account',
                                            name: 'ute.common.label.family',
                                            stateName: null,
                                            status: ute.common.second.level.navigation.NavigationStatus.ACCOUNT_DROPDOWN,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL
                                        }, {
                                            id: 'overview',
                                            name: 'ute.common.label.overview',
                                            stateName: 'accountOverview',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoAccountOverview
                                        }, {
                                            id: 'billAndPayment',
                                            name: 'ute.common.label.billAndPayment',
                                            stateName: ['viewbill', 'paynow', 'changemethod', 'paymenthistory', 'viewbill-payment-method'],
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY
                                        }, {
                                            id: 'myServices',
                                            name: 'ute.common.label.myServices',
                                            mobileName: 'ute.common.label.overview',
                                            stateName: ['myServices', 'shareEverything.manage'],
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY
                                        }, {
                                            id: 'profileAndSetting',
                                            name: 'ute.common.label.profileAndSetting',
                                            stateName: ['self-serve', 'self-serve-scroll'],
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY,
                                        }]
                                };
                            };
                            this.gotoAccountOverview = function () {
                                // return this.$state.go('accountOverview');
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.accountOverview.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.accountOverview.url); });
                            };
                            this.gotoViewBill = function () {
                                // return this.$state.go('viewbill');
                                if (_this.$state.current.name === 'viewbill') {
                                    _this.messageService.publish('refreshViewBill', { refresh: true });
                                }
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.viewBill.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.viewBill.url); });
                            };
                            this.gotoPaymentHistory = function () {
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.paymentHistory.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.paymentHistory.url); });
                            };
                            this.goToMakePayment = function (billingDetail, accountDetails, parentState) {
                                _this.payNowService.openMakePaymentModal(billingDetail, accountDetails, parentState);
                                return _this.$q.when(true);
                            };
                            this.goToSetPaymentMethod = function (isManualPayment, accountDetails) {
                                _this.paymentMethodService.openChangePaymentMethodModal(false, accountDetails);
                                return _this.$q.when(true);
                            };
                            this.gotoProfile = function () {
                                // return this.$state.go('self-serve'); // profile
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.profile.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.profile.url); });
                            };
                            this.gotoProfileContactAndBilling = function () {
                                // return this.$state.go('self-serve'); // profile
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.profileContactAndBilling.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.profileContactAndBilling.url); });
                            };
                            this.gotoProfileAndSecurity = function () {
                                // return this.$state.go('self-serve'); // profile
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.profileSecurity.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.profileSecurity.url); });
                            };
                            this.gotoProfileLinkedAccount = function () {
                                // return this.$state.go('self-serve'); // profile
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.profileLinkedAccounts.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.profileLinkedAccounts.url); });
                            };
                            this.gotoLinkAccount = function () {
                                // return this.$state.go('linkaccount');
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.linkAccount.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.linkAccount.url); });
                            };
                            /**
                             * @param account
                             * @returns {null}
                             */
                            this.setDisplayAccount = function (account) {
                                if (!angular.isUndefined(account) && angular.isObject(account)) {
                                    _this.navigationService.setSelectAccount({ display: account.nickname, accountNumber: account.accountNumber });
                                }
                                else {
                                    _this.navigationService.resetSelectedAccount();
                                }
                            };
                            /**
                             * @param account
                             * @returns {null}
                             */
                            this.selectAccount = function (account) {
                                account.selectAsDefault();
                                _this.setDisplayAccount(account);
                                _this.getSelectedAccountDetails();
                                if (_this.$state.current.name === 'accountOverview') {
                                    _this.$window.open('/consumer/self-serve/overview', '_self');
                                }
                                if (account.accountTypeNumber !== 9 && (_this.$state.current.name === 'viewbill' ||
                                    _this.$state.current.name === 'viewbill-payment-method' ||
                                    _this.$state.current.name === 'paymenthistory')) {
                                    _this.$state.reload();
                                    return _this.$q.when(true);
                                }
                                else {
                                    return account.goToAccountOverview();
                                }
                            };
                            /**
                             * @param sub
                             * @returns {null}
                             */
                            this.selectService = function (sub) {
                                return sub.goToDashboard();
                            };
                            /**
                             * @param accountOverview
                             * @returns {null}
                             */
                            this.accountOverviewDataHandler = function (accountOverview) {
                                if (accountOverview) {
                                    //Hide second level navigation bar if accountList is empty.
                                    _this.showSecondLevelNavigationConsumer = (accountOverview.accountList && accountOverview.accountList.length === 0) ? false : true;
                                    _this.setDisplayAccount(accountOverview.getSelectedAccount());
                                    _this.getSelectedAccountDetails();
                                    var item = _.find(_this.secondLevelNavDataModel.navigationBar, function (item) {
                                        return item.status === ute.common.second.level.navigation.NavigationStatus.ACCOUNT_DROPDOWN;
                                    });
                                    // do nothing if model was not found
                                    if (!item) {
                                        return;
                                    }
                                    item.dropdown = accountOverview.accountList.map(function (account) {
                                        return {
                                            id: account.accountNumber.toString(),
                                            // name: account.accountName.firstName + ' ' + account.accountName.lastName,
                                            name: account.nickname,
                                            displayValue: { translateId: String(account.accountNumber) },
                                            stateName: '',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _.partial(_this.selectAccount, account),
                                            accountStatus: account.accountStatus
                                        };
                                    });
                                    item.dropdown.unshift({
                                        id: 'selectTheAccount',
                                        name: '',
                                        displayValue: { translateId: 'ute.common.second.level.navigation.selectTheAccount' },
                                        stateName: '',
                                        status: ute.common.second.level.navigation.NavigationStatus.SHOW_DISABLE,
                                        visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY,
                                        callback: _this.gotoLinkAccount
                                    });
                                    item.dropdown.push({
                                        id: 'linkAnotherAccount',
                                        name: 'ute.common.second.level.navigation.linkAnotherAccount',
                                        stateName: '',
                                        status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                        visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                        callback: _this.gotoLinkAccount
                                    });
                                }
                                else {
                                }
                                return null;
                            };
                            /**
                             * @param accountDetail
                             * @returns {null}
                             */
                            this.accountDetailsDataHandler = function (accountDetail) {
                                if (accountDetail) {
                                    var item = _.find(_this.secondLevelNavDataModel.navigationBar, function (item) { return item.name === 'ute.common.label.myServices'; });
                                    item.dropdown = accountDetail.subList.filter(_this.filterShareEverythingList).map(function (sub) {
                                        // If shareEverything permission is false, show CTNs as Wireless.
                                        if (angular.isObject(sub.shareEverything)) {
                                            delete sub.shareEverything;
                                        }
                                        return {
                                            id: sub.getId(),
                                            name: '',
                                            displayValue: sub.getServiceDropdownName(),
                                            stateName: sub.getStateName(),
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _.partial(_this.selectService, sub)
                                        };
                                    });
                                    if (_this.shareEverythingPermission) {
                                        var shareEverything = _.find(accountDetail.subList, function (sub) { return angular.isDefined(sub.shareEverything); });
                                        var status = ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE;
                                        if (accountDetail.accountInfo && accountDetail.accountInfo.status !== 'Suspended' && accountDetail.accountInfo.status !== 'Cancelled') {
                                            status = ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE;
                                        }
                                        else {
                                            status = ute.common.second.level.navigation.NavigationStatus.SHOW_DISABLE;
                                        }
                                        if (angular.isObject(shareEverything)) {
                                            item.dropdown.unshift({
                                                id: shareEverything.getId(),
                                                name: shareEverything.getServiceDropdownName().translateId,
                                                stateName: shareEverything.getStateName(),
                                                status: status,
                                                visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                                callback: _.partial(_this.selectService, shareEverything)
                                            });
                                        }
                                    }
                                    var profileItem = _.find(_this.secondLevelNavDataModel.navigationBar, function (item) { return item.id === 'profileAndSetting'; });
                                    profileItem.dropdown = [{
                                            id: 'settingsOverview',
                                            name: '',
                                            displayValue: { translateId: 'ute.common.second.level.navigation.profileLanding.overview' },
                                            stateName: 'settingsOverview',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoProfile
                                        },
                                        {
                                            id: 'contactAndBilling',
                                            name: '',
                                            displayValue: { translateId: 'ute.common.second.level.navigation.profileLanding.contactAndBilling' },
                                            stateName: 'contactAndBilling',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoProfileContactAndBilling
                                        },
                                        {
                                            id: 'security',
                                            name: '',
                                            displayValue: { translateId: 'ute.common.second.level.navigation.profileLanding.security' },
                                            stateName: 'profileAndSecurity',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoProfileAndSecurity
                                        },
                                        {
                                            id: 'linkedAccount',
                                            name: '',
                                            displayValue: { translateId: 'ute.common.second.level.navigation.profileLanding.linkedAccounts' },
                                            stateName: 'linkedAccounts',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoProfileLinkedAccount
                                        },
                                    ];
                                    var billingItem_1 = _.find(_this.secondLevelNavDataModel.navigationBar, function (item) { return item.id === 'billAndPayment'; });
                                    if (accountDetail.accountType === 9) {
                                        billingItem_1.callback = _this.gotoViewBill;
                                        delete billingItem_1.dropdown;
                                    }
                                    else {
                                        billingItem_1.dropdown = [{
                                                id: 'viewBill',
                                                name: '',
                                                displayValue: { translateId: 'ute.common.second.level.navigation.billing.viewBill' },
                                                stateName: 'viewbill',
                                                status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                                visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                                callback: _this.gotoViewBill
                                            }, {
                                                id: 'makePayment',
                                                name: '',
                                                displayValue: { translateId: 'ute.common.second.level.navigation.billing.makePayment' },
                                                stateName: 'viewbill',
                                                status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                                visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                                isModal: true,
                                                callback: _this.goToMakePayment
                                            }, {
                                                id: 'paymentHistory',
                                                name: '',
                                                displayValue: { translateId: 'ute.common.second.level.navigation.billing.paymentHistory' },
                                                stateName: 'paymenthistory',
                                                status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                                visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                                callback: _this.gotoPaymentHistory
                                            }];
                                        if (accountDetail.accountInfo && accountDetail.accountInfo.status !== 'Cancelled') {
                                            // For cancelled accounts fo not display "change payment method" option.
                                            // Put the item as the 3rd one in the array
                                            billingItem_1.dropdown.splice(2, 0, {
                                                id: 'setPaymentMethod',
                                                name: '',
                                                displayValue: { translateId: '' },
                                                stateName: 'changemethod',
                                                status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                                visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                                isModal: true,
                                                callback: _this.goToSetPaymentMethod
                                            });
                                        }
                                        _this.billingDetailService = _this.billingDetailFactory({
                                            accountNumber: accountDetail.accountNumber,
                                            accountTypeNumber: accountDetail.accountType,
                                            language: 'en',
                                            applicationId: 'Rogers.com',
                                            refresh: false
                                        });
                                        var billingDetailsubscriber_1 = function (billingDetail) {
                                            // set callback for "makePayment"
                                            billingItem_1.dropdown[1].callback = _.partial(_this.goToMakePayment, billingDetail, accountDetail, _this.$state.current.name);
                                            // set the contextual displayValue based on mopType
                                            var setPaymentMethodItem = _.find(billingItem_1.dropdown, function (item) { return item.id === 'setPaymentMethod'; });
                                            if (setPaymentMethodItem) {
                                                if (_.has(billingDetail, 'methodOfPayment.mopType')) {
                                                    var isManualPayment = billingDetail.methodOfPayment && billingDetail.methodOfPayment.mopType === 0;
                                                    setPaymentMethodItem.displayValue.translateId = isManualPayment ? 'ute.common.second.level.navigation.billing.setUpAutomaticPayments' : 'ute.common.second.level.navigation.billing.changePaymentMethod';
                                                    setPaymentMethodItem.callback = _.partial(_this.goToSetPaymentMethod, isManualPayment, accountDetail);
                                                }
                                                else {
                                                    // if mopType is unknown do not display "change payment method" option
                                                    _.remove(billingItem_1.dropdown, function (item) { return item.id === 'setPaymentMethod'; });
                                                }
                                            }
                                        };
                                        if (_this.billingDetailService) {
                                            _this.billingDetailService.unregisterOnDataChangeHandler(_this.billingDetailCallbackKey);
                                        }
                                        _this.billingDetailService.registerOnDataChangeHandler(function (billingDetail) {
                                            billingDetailsubscriber_1(billingDetail);
                                        }, _this.billingDetailCallbackKey);
                                        _this.billingDetailService.getBillingDetail()
                                            .then(billingDetailsubscriber_1)
                                            .catch(function () {
                                            _.remove(billingItem_1.dropdown, function (item) { return item.id === 'setPaymentMethod'; });
                                        });
                                    }
                                    _this.navigationService.onDataModelChange();
                                }
                                return null;
                            };
                            this.onSingin = function () {
                                _this.navigationService.resetSelectedAccount();
                                _this.getAccountOverview();
                            };
                            /**
                             * @returns {IPromise<IAccountOverview>}
                             */
                            this.getAccountOverview = function () { return _this.accountOverviewService.getAccountOverview()
                                .then(_this.accountOverviewDataHandler)
                                .catch(function (reason) {
                                return null;
                            }); };
                            /**
                             * @returns {IPromise<IAccountDetail>}
                             */
                            this.getSelectedAccountDetails = function () { return _this.accountOverviewService.getSelectedAccountDetails(_this.accountDetailsDataHandler)
                                .then(_this.accountDetailsDataHandler)
                                .catch(function (reason) {
                                return null;
                            }); };
                            // private gotoShareEverything = (): ng.IPromise<any> => {
                            //   // return this.$state.go('linkaccount');
                            //   this.$window.location.href = this.rogersNavigationService.getConfig().basic.navigation.shareEverythingDashboard.url;
                            //   return new this.$q((resolve: IQResolveReject<string>) => resolve(this.rogersNavigationService.getConfig().basic.navigation.shareEverythingDashboard.url));
                            // };
                            this.filterShareEverythingList = function (value) {
                                if (_this.shareEverythingPermission) {
                                    return !value.shareEverything;
                                }
                                else {
                                    return true;
                                }
                            };
                            this.$cookies = $injector.get(angular.version.major === 1 && angular.version.minor === 3 ? 'cookieStore' : '$cookies');
                            this.permissionsService.getUserPermission(ute.common.permissions.service.UserPermissions.DATA_MANAGER_CONSUMER).then(function (isPermitted) { return _this.shareEverythingPermission = isPermitted; });
                            this.accountOverviewService = accountOverviewFactory();
                            userService.registerSigninHandler(this.onSingin, this);
                            this.initializeDataModel();
                            this.accountOverviewService.registerOnDataChangeHandler(this.accountOverviewDataHandler, RogersSecondLevelNavigationConsumerController.controllerName);
                            $scope.$on('$destroy', function () {
                                _this.accountOverviewService.unregisterOnDataChangeHandler(RogersSecondLevelNavigationConsumerController.controllerName);
                                _this.languageService.unregisterOnDataChangeHandler(RogersSecondLevelNavigationConsumerController.controllerName);
                                if (_this.billingDetailService) {
                                    _this.billingDetailService.unregisterOnDataChangeHandler(_this.billingDetailCallbackKey);
                                }
                            });
                            this.getAccountOverview();
                            this.billingDetailCallbackKey = 'NavigationBarConsumerSubscriber' + this.$scope.$id;
                        }
                        RogersSecondLevelNavigationConsumerController.controllerName = 'ute.rogers.second.level.navigation.consumer.controller';
                        RogersSecondLevelNavigationConsumerController.$inject = ['$q',
                            '$state',
                            '$scope',
                            '$window',
                            '$injector',
                            'ute.common.second.level.navigation.service',
                            'ute.rogers.account.overview.factory',
                            'ute.rogers.account.overview.summary.factory',
                            'ute.blocks.language.switcher',
                            'ute.common.user.service',
                            'ute.rogers.second.level.navigation.service',
                            'ute.common.permissions.service',
                            'ute.payment.ui.pay.now.service',
                            'ute.rogers.account.billing.detail.factory',
                            'ute.payment.method.service',
                            'ute.common.core.brtswitch.service',
                            'ute.blocks.messages.bus.service'
                        ];
                        return RogersSecondLevelNavigationConsumerController;
                    }());
                    navigation.RogersSecondLevelNavigationConsumerController = RogersSecondLevelNavigationConsumerController;
                    angular.module('ute.rogers.second.level.navigation').controller(RogersSecondLevelNavigationConsumerController.controllerName, RogersSecondLevelNavigationConsumerController);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersSecondLevelNavigationConsumer = (function () {
                        /* @ngInject */
                        function RogersSecondLevelNavigationConsumer(rogersNavigationService) {
                            var _this = this;
                            this.rogersNavigationService = rogersNavigationService;
                            // DDO properties
                            this.restrict = 'E';
                            this.templateUrl = 'module/rogersSecondLevelNavigation/navigationBarConsumer/navigationBarConsumer.directive.view.html';
                            this.controller = navigation.RogersSecondLevelNavigationConsumerController.controllerName;
                            this.controllerAs = 'rogersNavigationBar';
                            this.scope = {};
                            // class properties
                            this.config = {
                                basic: {
                                    mainControllerName: this.controller,
                                    mainTemplateUrl: this.templateUrl,
                                    navigation: {
                                        accountOverview: {
                                            url: '/web/totes/#/accountOverview'
                                        },
                                        wirelessDashboard: {
                                            url: '/web/totes/#/wireless'
                                        },
                                        wirelessPrepaidDashboard: {
                                            url: '/web/totes/#/wirelessPrepaid'
                                        },
                                        internetDashboard: {
                                            url: '/web/totes/#/internetdash'
                                        },
                                        tvDashboard: {
                                            url: '/web/totes/#/tvdashboard'
                                        },
                                        viewBill: {
                                            url: '/web/totes/#/viewbill'
                                        },
                                        linkAccount: {
                                            url: '/consumer/self-serve/link-account'
                                        },
                                        profile: {
                                            url: '/consumer/self-serve/profile-settings'
                                        },
                                        profileContactAndBilling: {
                                            url: '/consumer/self-serve/profile-settings/contact-billing'
                                        },
                                        profileSecurity: {
                                            url: '/consumer/self-serve/profile-settings/profile-security'
                                        },
                                        profileLinkedAccounts: {
                                            url: '/consumer/self-serve/profile-settings/linked-accounts'
                                        },
                                    }
                                }
                            };
                            this.linkFn = function () {
                                _this.configure();
                            };
                            this.configure = function () {
                                _this.rogersNavigationService.configure(angular.copy(_this.config));
                            };
                            this.link = this.linkFn;
                        }
                        RogersSecondLevelNavigationConsumer.factory = function () {
                            var directive = function (rogersNavigationService) { return new RogersSecondLevelNavigationConsumer(rogersNavigationService); };
                            directive.$inject = ['ute.rogers.second.level.navigation.service'];
                            return directive;
                        };
                        return RogersSecondLevelNavigationConsumer;
                    }());
                    angular.module('ute.rogers.second.level.navigation').directive('uteRogersSecondLevelNavigationConsumer', RogersSecondLevelNavigationConsumer.factory());
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersSecondLevelNavigationDealerController = (function (_super) {
                        __extends(RogersSecondLevelNavigationDealerController, _super);
                        /* @ngInject */
                        function RogersSecondLevelNavigationDealerController($q, $state, $scope, $window, $injector, navigationService, accountOverviewFactory, accountOverviewSummaryFactory, languageService, userService, rogersNavigationService, permissionsService, payNowService, billingDetailFactory, paymentMethodService, brtSwitchService, messageService) {
                            var _this = this;
                            // call base class constructor
                            _super.call(this, $q, $state, $scope, $window, $injector, navigationService, accountOverviewFactory, accountOverviewSummaryFactory, languageService, userService, rogersNavigationService, permissionsService, payNowService, billingDetailFactory, paymentMethodService, brtSwitchService, messageService);
                            this.initializeDataModel = function () {
                                _this.secondLevelNavDataModel = {
                                    title: 'ute.common.second.level.navigation.header',
                                    titleMobile: 'ute.common.second.level.navigation.headerShort',
                                    navigationBar: [{
                                            id: 'overview',
                                            name: 'ute.common.label.overview',
                                            stateName: 'accountOverview',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoAccountOverview
                                        }, {
                                            id: 'billAndPayment',
                                            name: 'ute.common.label.billAndPayment',
                                            stateName: ['viewbill'],
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY,
                                            callback: _this.gotoViewBill
                                        }, {
                                            id: 'myServices',
                                            name: 'ute.common.label.services',
                                            mobileName: 'ute.common.label.overview',
                                            stateName: 'myServices',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY
                                        }, {
                                            id: 'profileAndSetting',
                                            name: 'ute.common.label.profileAndSetting',
                                            stateName: 'self-serve',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.DESKTOP_ONLY,
                                            callback: _this.gotoProfile
                                        }, {
                                            id: 'interactions',
                                            name: 'ute.common.label.interactions',
                                            stateName: 'interactions',
                                            status: ute.common.second.level.navigation.NavigationStatus.SHOW_ENABLE,
                                            visibility: ute.common.second.level.navigation.NavigationVisibility.ALL,
                                            callback: _this.gotoInteractions
                                        }]
                                };
                                // fetch account details
                                _this.accountOverviewService.getSelectedAccountDetails(_this.updateAccountDetails)
                                    .then(_this.updateAccountDetails)
                                    .catch(function (reason) {
                                    console.log('RogersSecondLevelNavigationConsumerController->getSelectedAccountDetails->catch:', reason);
                                    return null;
                                });
                            };
                            this.itemOnClick = function (cb) {
                                cb();
                            };
                            this.childOnClick = function (childObj) {
                                if (childObj.callback) {
                                    childObj.callback();
                                }
                            };
                            this.getCustomerName = function () {
                                if (!_this.secondLevelNavDataModel || !_this.secondLevelNavDataModel.selectedAccount) {
                                    return '';
                                }
                                var firstName = _this.secondLevelNavDataModel.selectedAccount.accountName.firstName;
                                var lastName = _this.secondLevelNavDataModel.selectedAccount.accountName.lastName;
                                return firstName + " " + lastName;
                            };
                            this.getCustomerStreetAddress = function () {
                                if (!_this.secondLevelNavDataModel || !_this.secondLevelNavDataModel.selectedAccount) {
                                    return '';
                                }
                                var unit = _this.secondLevelNavDataModel.selectedAccount.billingAddress.unit;
                                var streetNumber = _this.secondLevelNavDataModel.selectedAccount.billingAddress.streetNumber;
                                var streetName = _this.secondLevelNavDataModel.selectedAccount.billingAddress.streetName;
                                var streetType = _this.secondLevelNavDataModel.selectedAccount.billingAddress.streetType;
                                return "" + (unit ? unit + '-' : '') + streetNumber + " " + streetName + " " + streetType;
                            };
                            this.updateAccountDetails = function (accountDetails) {
                                _this.secondLevelNavDataModel.selectedAccount = accountDetails;
                                return new _this.$q(function (resolve) { return resolve(accountDetails); });
                            };
                            this.gotoInteractions = function () {
                                // return this.$state.go('viewbill');
                                _this.$window.location.href = _this.rogersNavigationService.getConfig().basic.navigation.interactions.url;
                                return new _this.$q(function (resolve) { return resolve(_this.rogersNavigationService.getConfig().basic.navigation.interactions.url); });
                            };
                            this.initializeDataModel();
                        }
                        RogersSecondLevelNavigationDealerController.controllerName = 'ute.rogers.second.level.navigation.dealer.controller';
                        return RogersSecondLevelNavigationDealerController;
                    }(ute.rogers.second.level.navigation.RogersSecondLevelNavigationConsumerController));
                    navigation.RogersSecondLevelNavigationDealerController = RogersSecondLevelNavigationDealerController;
                    angular.module('ute.rogers.second.level.navigation').controller(RogersSecondLevelNavigationDealerController.controllerName, RogersSecondLevelNavigationDealerController);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var RogersSecondLevelNavigationDealer = (function () {
                        /* @ngInject */
                        function RogersSecondLevelNavigationDealer(rogersNavigationService) {
                            var _this = this;
                            this.rogersNavigationService = rogersNavigationService;
                            // DDO properties
                            this.restrict = 'E';
                            this.templateUrl = 'module/rogersSecondLevelNavigation/navigationBarDealer/navigationBarDealer.directive.view.html';
                            this.controller = navigation.RogersSecondLevelNavigationDealerController.controllerName;
                            this.controllerAs = 'rogersNavigationBar';
                            this.scope = {};
                            // class properties
                            this.config = {
                                basic: {
                                    mainControllerName: this.controller,
                                    mainTemplateUrl: this.templateUrl,
                                    navigation: {
                                        accountOverview: {
                                            url: '/web/totes/#/oneViewDashboard'
                                        },
                                        /* there may be additional logic required here to direct user to different places */
                                        viewBill: {
                                            url: '/web/totes/#/viewbill'
                                        },
                                        /* this just opens a modal window telling user to go to SSP or SGI, temporarily sending back to totes overview*/
                                        profile: {
                                            url: '/web/totes/#/oneViewDashboard'
                                        },
                                        interactions: {
                                            url: '/web/totes/#/interaction'
                                        }
                                    }
                                }
                            };
                            this.configure = function () {
                                _this.rogersNavigationService.configure(_this.config);
                            };
                            this.configure();
                        }
                        RogersSecondLevelNavigationDealer.factory = function () {
                            var directive = function (rogersNavigationService) { return new RogersSecondLevelNavigationDealer(rogersNavigationService); };
                            directive.$inject = ['ute.rogers.second.level.navigation.service'];
                            return directive;
                        };
                        return RogersSecondLevelNavigationDealer;
                    }());
                    angular.module('ute.rogers.second.level.navigation').directive('uteRogersSecondLevelNavigationDealer', RogersSecondLevelNavigationDealer.factory());
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            var ProviderBase = ute.common.core.ProviderBase;
            /**
             * Private
             */
            var BackEndErrorCode = (function () {
                function BackEndErrorCode() {
                }
                BackEndErrorCode.SET_NEW_PASSWORD_OK = 0;
                BackEndErrorCode.GENERIC_ERROR = 17052;
                BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST = 17095;
                return BackEndErrorCode;
            }());
            (function (FrontEndErrorCode) {
                FrontEndErrorCode[FrontEndErrorCode["SET_NEW_PASSWORD_OK"] = 0] = "SET_NEW_PASSWORD_OK";
                FrontEndErrorCode[FrontEndErrorCode["GENERIC_ERROR"] = 1] = "GENERIC_ERROR";
                FrontEndErrorCode[FrontEndErrorCode["REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST"] = 2] = "REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST";
            })(setpassword.FrontEndErrorCode || (setpassword.FrontEndErrorCode = {}));
            var FrontEndErrorCode = setpassword.FrontEndErrorCode;
            ;
            ;
            ;
            var JanrainLogin = {
                xSessionToken: 'xSessionToken',
                guidName: 'guid',
                profileActivationDateName: 'profileActivationDate'
            };
            var RogersSetPasswordService = (function () {
                function RogersSetPasswordService(config, $injector, $http, $q, $timeout, $state, $window) {
                    var _this = this;
                    this.config = config;
                    this.$http = $http;
                    this.$q = $q;
                    this.$timeout = $timeout;
                    this.$state = $state;
                    this.$window = $window;
                    this.errorCodesMap = {};
                    this.isCallInProgress = false;
                    this.isForgotPasswordCallInProgress = false;
                    this.autoLogin = true;
                    this.getConfig = function () { return angular.copy(_this.config); };
                    this.isRogersSetPasswordCallInProgress = function () { return _this.isCallInProgress; };
                    this.isRogersForgotPasswordCallInProgress = function () { return _this.isForgotPasswordCallInProgress; };
                    this.setAutoLogin = function (value) {
                        _this.autoLogin = value;
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.savePassword = function (model) {
                        if (_this.isResetPassword()) {
                            return _this.resetPassword(model);
                        }
                        else {
                            return _this.password(model, _this.setPasswordApiUrl);
                        }
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.forgotPassword = function (model) {
                        _this.forgotPasswordModel = model;
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                        var request = {
                            email: _this.forgotPasswordModel.email
                        };
                        _this.isForgotPasswordCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.forgotPassword.apiUrl, request)
                            .then(_this.processForgotPasswordOk)
                            .catch(_this.processForgotPasswordError)
                            .finally(_this.finaliseForgotPasswordCall);
                    };
                    this.onSuccessSetPassword = function () {
                        _this.isCallInProgress = true;
                        if (_this.isResetPassword()) {
                            _this.$state.go(_this.config.advanced.resetPassword.onSuccessState.name, _this.config.advanced.resetPassword.onSuccessState.params);
                        }
                        else {
                            return _this.$timeout(function () { return _this.signinService.signinUser({
                                userName: _this.janrainVerificationService.getEmail(),
                                userEmail: _this.janrainVerificationService.getEmail(),
                                userPassword: _this.model.newPassword,
                                userType: ute.common.user.UserType.consumer,
                                encryptionKey: undefined
                            }).finally(function () {
                                _this.isCallInProgress = false;
                                return _this.goToState(_this.config.advanced.setPassword.onSuccessState);
                            }); }, 3000); // To make sure Janrain propagate changes to ESF
                        }
                    };
                    this.goToState = function (state) {
                        return _this.$state.go(state);
                    };
                    /**
                     * Return immutable IRogersSetPasswordModel object
                     * @returns {IPasswordModel}
                     */
                    this.getModel = function () {
                        return angular.copy(_this.model);
                    };
                    /**
                     * Return immutable IRogersSetPasswordModel object
                     * @returns {IForgotPasswordModel}
                     */
                    this.getForgotPasswordModel = function () {
                        return angular.copy(_this.forgotPasswordModel);
                    };
                    this.resetForgotPasswordModel = function () {
                        _this._resetForgotPasswordModel();
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.resetPassword = function (model) {
                        // this.model = _.merge({}, model);
                        _this.model = model;
                        var request = {
                            token: _this.janrainVerificationService.getToken(),
                            newPassword: _this.model.newPassword
                        };
                        _this.isCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.resetPassword.apiUrl, request)
                            .then(_this.processOk)
                            .catch(_this.processError)
                            .finally(_this.finaliseCall);
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.setPassword = function (model) {
                        // this.model = _.merge({}, model);
                        _this.model = model;
                        var request = {
                            uuid: _this.janrainVerificationService.getUuid(),
                            email: _this.janrainVerificationService.getEmail(),
                            newPassword: _this.model.newPassword,
                            confirmPassword: _this.model.confirmPassword
                        };
                        _this.isCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.setPassword.apiUrl, request)
                            .then(_this.processOk)
                            .catch(_this.processError)
                            .finally(_this.finaliseCall);
                    };
                    this.password = function (model, apiUrl) {
                        _this.model = model;
                        var request = {
                            newPassword: _this.model.newPassword,
                            confirmPassword: _this.model.confirmPassword,
                            email: _this.janrainVerificationService.getEmail()
                        };
                        _this.isCallInProgress = true;
                        return _this.$http.put(apiUrl + _this.autoLogin, request, {
                            headers: {
                                'realm': 'ROGERS',
                                'x-request-id': new Date().toISOString(),
                                'x-app-name': 'ROGERS',
                                'token': _this.janrainVerificationService.getJanrainToken(),
                            }
                        }).then(function (response) {
                            if (!_this.autoLogin) {
                                window.location.href = '/consumer/easyloginriverpage?showModal=true';
                                return;
                            }
                            _this.storeJanrainLoginResponse(response.data);
                            var backendCode = _.get(response, 'data.status.code', '');
                            if (backendCode === '200.000') {
                                return _this.findCodeEntry(BackEndErrorCode.SET_NEW_PASSWORD_OK);
                            }
                        }).catch(function (error) {
                            var backendCode = _.get(error, 'data.status.code', '');
                            if (backendCode === '210.001') {
                                _this.$window.location.href = '/consumer/easyloginriverpage?showModal=true';
                                return;
                            }
                            return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(BackEndErrorCode.GENERIC_ERROR)); });
                        }).finally(function () {
                            _this.isCallInProgress = false;
                        });
                    };
                    this.storeJanrainLoginResponse = function (data) {
                        if (data &&
                            data.content) {
                            var content = data.content;
                            if (content.length > 0 &&
                                _.has(content[0], JanrainLogin.xSessionToken)) {
                                sessionStorage.setItem(JanrainLogin.xSessionToken, content[0][JanrainLogin.xSessionToken]);
                            }
                            if (content.length > 1 &&
                                _.has(content[1], JanrainLogin.guidName) &&
                                _.has(content[1], JanrainLogin.profileActivationDateName)) {
                                sessionStorage.setItem(JanrainLogin.guidName, content[1][JanrainLogin.guidName]);
                                localStorage.setItem(JanrainLogin.profileActivationDateName, content[1][JanrainLogin.profileActivationDateName]);
                            }
                        }
                    };
                    this.isResetPassword = function () { return _this.$state.current.name === _this.config.advanced.resetPassword.stateName; };
                    /**
                     * Reset model to initial state
                     */
                    this.resetModel = function () {
                        _this.model = {
                            newPassword: null,
                            confirmPassword: null
                        };
                    };
                    this._resetForgotPasswordModel = function () {
                        _this.forgotPasswordModel = {
                            email: null,
                            isServiceCallSuccess: false
                        };
                    };
                    /**
                     * @param code
                     * @returns {boolean}
                     */
                    this.addCode = function (code) {
                        _this.errorCodesMap[code.frontendCode] = code;
                    };
                    this.addCodes = function () {
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST,
                            frontendMessageKey: 'ute.rogers.forgotPassword.email.not.found',
                            frontendMessageP2Key: '',
                            templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'md',
                            backendCode: BackEndErrorCode.REQUEST_FORGOT_PASSWORD_PROFILE_NOT_EXIST
                        });
                        _this.addCode({
                            frontendCode: FrontEndErrorCode.GENERIC_ERROR,
                            frontendMessageKey: 'ute.common.error.general',
                            frontendMessageP2Key: '',
                            templateUrl: _this.config.advanced.genericErrorModal.templateUrl,
                            modalIcon: 'ute-common-assets/assets/error_warning.png',
                            modalSize: 'md',
                            backendCode: BackEndErrorCode.GENERIC_ERROR,
                            boldChat: {
                                cbid: '',
                                dynamicDivId: '',
                                chatButtonClass: ''
                            }
                        });
                    };
                    /**
                     * @param response
                     * @returns {any}
                     */
                    this.processOk = function (response) {
                        var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                        return _this.findCodeEntry(backendCode);
                    };
                    /**
                     * @param backendCode
                     * @returns {ICodeEntry|any}
                     */
                    this.findCodeEntry = function (backendCode) { return (_.find(_this.errorCodesMap, function (ce) {
                        return ce.backendCode === backendCode;
                    }) || _this.errorCodesMap[FrontEndErrorCode.GENERIC_ERROR]); };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processError = function (error) {
                        var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                        return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(backendCode)); });
                    };
                    this.finaliseCall = function () { return _this.isCallInProgress = false; };
                    /**
                     * @param response
                     * @returns {any}
                     */
                    this.processForgotPasswordOk = function (response) {
                        var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processForgotPasswordOk:', 'response:', response, 'backendCode:', backendCode, this.findCodeEntry(backendCode));
                        _this.forgotPasswordModel.isServiceCallSuccess = true;
                        return _this.findCodeEntry(backendCode);
                    };
                    /**
                     * @param error
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.processForgotPasswordError = function (error) {
                        var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                        // console.log(RogersSetPasswordService.serviceName + '->processError:', 'error:', error, 'backendCode:', backendCode);
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                        return new _this.$q(function (resolve, reject) { return reject(_this.findCodeEntry(backendCode)); });
                    };
                    this.finaliseForgotPasswordCall = function () {
                        _this.isForgotPasswordCallInProgress = false;
                    };
                    this.janrainVerificationService = $injector.get('ute.janrain.verification.service');
                    this.signinService = $injector.get('ute.rogers.siteminder.signin.service');
                    this.setPasswordApiUrl = $injector.get('CONFIG').setPassword;
                    this.addCodes();
                    this.resetModel();
                    this._resetForgotPasswordModel();
                }
                ;
                RogersSetPasswordService.serviceName = 'ute.rogers.setpassword.service';
                return RogersSetPasswordService;
            }());
            var RogersSetPasswordProvider = (function (_super) {
                __extends(RogersSetPasswordProvider, _super);
                /* @ngInject */
                function RogersSetPasswordProvider() {
                    var _this = this;
                    _super.call(this);
                    /* @ngInject */
                    this.$get = function ($injector, $http, $q, $timeout, $state, $window) {
                        return new RogersSetPasswordService(_this.config, $injector, $http, $q, $timeout, $state, $window);
                    };
                    this.$get.$inject = [
                        '$injector',
                        '$http',
                        '$q',
                        '$timeout',
                        '$state',
                        '$window'
                    ];
                    this.config = setpassword.DefaultConfigFactory();
                }
                RogersSetPasswordProvider.$inject = [];
                return RogersSetPasswordProvider;
            }(ProviderBase));
            angular.module('ute.rogers.setpassword').provider(RogersSetPasswordService.serviceName, RogersSetPasswordProvider);
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var setpassword;
        (function (setpassword) {
            'use strict';
            function DefaultConfigFactory() {
                return {
                    basic: {
                        logPrefix: 'RogersSetPassword',
                        logLevel: ute.common.typescript.api.log.LogLevel.OFF
                    },
                    advanced: {
                        setPassword: {
                            apiUrl: 'api/v1/profile/setPassword',
                            stateName: 'sso/setPassword',
                            controllerName: 'ute.rogers.setpassword.controller',
                            templateUrl: 'module/setPassword/setPassword.html',
                            codeVerificationApiUrl: 'api/v1/profile/activate',
                            onSuccessState: 'accountOverview',
                            needAutoRegCheck: true
                        },
                        resetPassword: {
                            apiUrl: 'api/v1/profile/resetPassword',
                            stateName: 'sso/resetPassword',
                            controllerName: 'ute.rogers.setpassword.controller',
                            templateUrl: 'module/setPassword/setPassword.html',
                            codeVerificationApiUrl: 'api/v1/profile/forgotPasswordValidation',
                            onSuccessState: {
                                name: 'signinWithBanners',
                                params: {
                                    banners: 'resetPassword'
                                }
                            },
                            needAutoRegCheck: false
                        },
                        forgotPassword: {
                            apiUrl: 'api/v1/profile/forgotPassword',
                            noLiveContentStateName: 'forgotPasswordNoLivecontent',
                            stateName: 'sso/forgotPassword',
                            cancelState: 'signin',
                            controllerName: 'ute.rogers.forgotpassword.controller',
                            templateUrl: 'module/forgotPassword/forgotPassword.html'
                        },
                        changeUsernameSuccess: {
                            stateName: 'sso/changeUsernameSuccess',
                            controllerName: 'ute.rogers.changeUsernameSuccess.controller',
                            templateUrl: 'module/changeUsernameSuccess/changeUsernameSuccess.html'
                        },
                        genericErrorModal: {
                            windowTemplateUrl: 'module/setPassword/setPasswordErrorMessageWindow.view.html',
                            controllerName: 'ute.rogers.setpassword.error.controller',
                            templateUrl: 'module/setPassword/setPasswordGenericErrorModal.view.html'
                        }
                    }
                };
            }
            setpassword.DefaultConfigFactory = DefaultConfigFactory;
        })(setpassword = rogers.setpassword || (rogers.setpassword = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var modal;
            (function (modal) {
                'use strict';
                // import IDataManagerAccountLine = ute.data.manager.service.IDataManagerAccountLine;
                var SaveBillGenericModalController = (function () {
                    /* @ngInject */
                    function SaveBillGenericModalController($scope, $modalInstance, $window) {
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.$window = $window;
                        this.isMobile = false;
                        this.scope = $scope;
                        var isMobile = {
                            Windows: function () {
                                return /IEMobile/i.test(navigator.userAgent);
                            },
                            Android: function () {
                                return /Android/i.test(navigator.userAgent);
                            },
                            BlackBerry: function () {
                                return /BlackBerry/i.test(navigator.userAgent);
                            },
                            iOS: function () {
                                return /iPhone|iPad|iPod/i.test(navigator.userAgent);
                            },
                            any: function () {
                                return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Windows());
                            }
                        };
                        this.isMobile = isMobile.any();
                    }
                    SaveBillGenericModalController.prototype.noSelection = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    SaveBillGenericModalController.prototype.continue = function () {
                        this.$modalInstance.close('yes');
                    };
                    SaveBillGenericModalController.prototype.cancel = function () {
                        this.$modalInstance.close('no');
                    };
                    SaveBillGenericModalController.prototype.contactUs = function (e) {
                        this.$window.location.href = 'https://www.rogers.com/consumer/support/contactus';
                    };
                    SaveBillGenericModalController.$inject = ['$scope', '$modalInstance', '$window'];
                    return SaveBillGenericModalController;
                }());
                modal.SaveBillGenericModalController = SaveBillGenericModalController;
                angular.module('ute.save.bill.modal').controller('ute.save.bill.modal.generic.modal.controller', SaveBillGenericModalController);
            })(modal = bill.modal || (bill.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill_1) {
            var modal;
            (function (modal) {
                'use strict';
                var ConfirmationModalController = (function () {
                    /* @ngInject */
                    function ConfirmationModalController($rootScope, $modal, $timeout, $modalInstance, briteBillService, saveBillService, dtmService, $q, accountNumber) {
                        var _this = this;
                        this.$rootScope = $rootScope;
                        this.$modal = $modal;
                        this.$timeout = $timeout;
                        this.$modalInstance = $modalInstance;
                        this.briteBillService = briteBillService;
                        this.saveBillService = saveBillService;
                        this.dtmService = dtmService;
                        this.$q = $q;
                        this.accountNumber = accountNumber;
                        this.init = function () {
                            _this.getSelectedBill();
                            _this.getBills().then(_this.setAutoFocusForFirstCheckbox.bind(_this));
                        };
                        this.getBills = function () {
                            return _this.briteBillService.getBills(_this.accountNumber).then(function (bills) {
                                bills.map(function (bill) {
                                    bill.selected = false;
                                    if (bill.link === _this.selectedBill) {
                                        bill.selected = true;
                                        _this.links.push(bill.link);
                                        _this.dates.push(bill.issue_date);
                                    }
                                });
                                _this.bills = bills;
                                return _this.$q.when(true);
                            });
                        };
                        this.config = this.saveBillService.getConfig();
                        this.links = [];
                        this.dates = [];
                        this.selectAll = false;
                        this.init();
                    }
                    ConfirmationModalController.prototype.close = function () {
                        this.$modalInstance.close('no');
                    };
                    ConfirmationModalController.prototype.selectedDates = function (link, date, selectedValue, index) {
                        var linkIndex = this.links.indexOf(link);
                        var dateIndex = this.dates.indexOf(date);
                        if (this.selectAll && index !== -1) {
                            this.selectAll = false;
                        }
                        if (selectedValue) {
                            if (linkIndex === -1) {
                                this.links.push(link);
                                this.dates.push(date);
                            }
                        }
                        else {
                            var deleteCount = 1;
                            if (linkIndex > -1) {
                                this.links.splice(linkIndex, deleteCount);
                            }
                            if (dateIndex > -1) {
                                this.dates.splice(dateIndex, deleteCount);
                            }
                        }
                    };
                    ConfirmationModalController.prototype.selectAllCheckbox = function (selectAll) {
                        var _this = this;
                        this.bills.forEach(function (bill) {
                            if (selectAll) {
                                if (bill.issue_date.match(new Date().getFullYear())) {
                                    bill.selected = true;
                                    _this.selectedDates(bill.link, bill.issue_date, bill.selected, -1);
                                }
                            }
                            else {
                                bill.selected = false;
                                _this.links = [];
                                _this.dates = [];
                            }
                        });
                    };
                    ConfirmationModalController.prototype.saveMultipleBills = function () {
                        if ((this.links && this.links.length > 0) && (this.dates && this.dates.length > 0)) {
                            this.briteBillService.downloadMultiplePdfService(this.links, this.dates, this.accountNumber)
                                .then(this.processDownloadResponse.bind(this, 'pdf', 'savePDF', true))
                                .catch(this.processDownloadResponse.bind(this, 'pdf', 'downloadPdf', 'error'));
                            this.trackBillDownloadType('PDF');
                        }
                    };
                    ConfirmationModalController.prototype.setAutoFocusForFirstCheckbox = function () {
                        this.$timeout(function () { return angular.element('.ute-checkbox-holder input[type="checkbox"]:checked').focus(); }, 100);
                    };
                    ConfirmationModalController.prototype.getSelectedBill = function () {
                        var contentLink = this.briteBillService.getSelectedInvoiceBill(this.accountNumber);
                        this.selectedBill = contentLink.link;
                    };
                    ConfirmationModalController.prototype.processDownloadResponse = function (type, translationKey, response) {
                        var _this = this;
                        if (response === true) {
                            this.$timeout(function () { return _this.showSuccessModal(type); }, 5);
                        }
                        else if (response === 'error') {
                            this.$timeout(function () { return _this.errorModalPopup('', 'ute.saveBillModal.errorBody.' + translationKey); }, 5);
                        }
                        else if (response === 'noData') {
                            this.$timeout(function () { return _this.showNoDataModal(); }, 5);
                        }
                    };
                    ConfirmationModalController.prototype.showSuccessModal = function (type) {
                        var modalScope = this.$rootScope.$new();
                        modalScope.params = { type: type };
                        this.saveBillService.successModal(modalScope);
                    };
                    ConfirmationModalController.prototype.showNoDataModal = function () {
                        this.saveBillService.noDataModalModal();
                    };
                    ConfirmationModalController.prototype.errorModalPopup = function (primary, secondary) {
                        var errorModalScope = this.$rootScope.$new();
                        errorModalScope.params = { primary: primary, secondary: secondary };
                        this.saveBillService.errorPopupModal(errorModalScope);
                    };
                    ConfirmationModalController.prototype.trackBillDownloadType = function (downloadMethod) {
                        this.dtmService.setVar('downloadMethod', downloadMethod);
                        this.dtmService.track(this.config.basic.analyticsId, 'pasv');
                    };
                    ConfirmationModalController.$inject = ['$rootScope',
                        '$modal',
                        '$timeout',
                        '$modalInstance',
                        'ute.brite.bill.service',
                        'ute.save.bill.service',
                        'ute.dtm.service',
                        '$q',
                        'accountNumber'];
                    return ConfirmationModalController;
                }());
                modal.ConfirmationModalController = ConfirmationModalController;
                angular.module('ute.save.bill.modal').controller('ute.save.bill.modal.confirmation.modal.controller', ConfirmationModalController);
            })(modal = bill_1.modal || (bill_1.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var save;
    (function (save) {
        var bill;
        (function (bill) {
            var modal;
            (function (modal) {
                'use strict';
                var SaveBillPrintModalController = (function () {
                    /* @ngInject */
                    function SaveBillPrintModalController($timeout, $modalInstance, briteBillService, accountNumber) {
                        this.$timeout = $timeout;
                        this.$modalInstance = $modalInstance;
                        this.briteBillService = briteBillService;
                        this.accountNumber = accountNumber;
                        console.log(this.accountNumber);
                        var billLink = this.briteBillService.getSelectedInvoiceBill(this.accountNumber).link;
                        this.briteBillService.setPrintBillSRC(billLink);
                        console.log(this.accountNumber);
                    }
                    SaveBillPrintModalController.prototype.close = function () {
                        this.$modalInstance.close('no');
                    };
                    SaveBillPrintModalController.prototype.getPrintBillSRC = function () {
                        return this.briteBillService.getPrintBillSRC();
                    };
                    SaveBillPrintModalController.prototype.iFrameLoadedCallback = function () {
                        this.$timeout(function () {
                            var iFramePrintFile = document.getElementById('iFramePrintFile');
                            if (iFramePrintFile) {
                                iFramePrintFile.focus();
                                var result = iFramePrintFile.contentWindow.document.execCommand('print', false, null);
                                if (!result) {
                                    iFramePrintFile.contentWindow.print();
                                }
                            }
                        }, 3000);
                    };
                    SaveBillPrintModalController.$inject = ['$timeout', '$modalInstance', 'ute.brite.bill.service', 'accountNumber'];
                    return SaveBillPrintModalController;
                }());
                modal.SaveBillPrintModalController = SaveBillPrintModalController;
                angular.module('ute.save.bill.modal').controller('ute.save.bill.print.modal.controller', SaveBillPrintModalController);
            })(modal = bill.modal || (bill.modal = {}));
        })(bill = save.bill || (save.bill = {}));
    })(save = ute.save || (ute.save = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var NavigationBarMobileController = (function () {
                        /* @ngInject */
                        function NavigationBarMobileController(navigationService, $mdBottomSheet, $state) {
                            var _this = this;
                            this.navigationService = navigationService;
                            this.$mdBottomSheet = $mdBottomSheet;
                            this.$state = $state;
                            this.itemOnClick = function (cb) {
                                cb();
                            };
                            this.childOnClick = function (childObj) {
                                if (childObj.callback) {
                                    childObj.callback();
                                }
                            };
                            this.MobileViewOnClick = function (navObj) {
                                // if (navObj.callback) {
                                //   navObj.callback();
                                // }
                                _this.$mdBottomSheet.show({
                                    templateUrl: 'module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.mobile.accounts.view.html',
                                    controller: 'ute.common.second.level.navigation.navigationBar.controller'
                                }).then(function () {
                                    console.log('show bottom sheet clicked!');
                                });
                                console.log('MobileViewOnClick', navObj);
                            };
                            this.inputModel = navigationService.getInputModel;
                            this.showMenu = navigationService.getShowNavigationMenu;
                            this.selectedAccount = navigationService.getSelectedAccount;
                            this.accountsDropdown = navigationService.getAccounts;
                            this.state = $state;
                        }
                        NavigationBarMobileController.prototype.isAccountDropdownStyle = function (status) {
                            return (status === ute.common.second.level.navigation.NavigationStatus.ACCOUNT_DROPDOWN);
                        };
                        NavigationBarMobileController.prototype.isStatusShowDisable = function (status) {
                            return (status === ute.common.second.level.navigation.NavigationStatus.SHOW_DISABLE);
                        };
                        NavigationBarMobileController.$inject = ['ute.common.second.level.navigation.service', '$mdBottomSheet', '$state'];
                        return NavigationBarMobileController;
                    }());
                    angular.module('ute.common.second.level.navigation').controller('ute.common.second.level.navigation.navigationBar.mobile.controller', NavigationBarMobileController);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var NavigationBarController = (function () {
                        /* @ngInject */
                        function NavigationBarController(navigationService, $mdMenu, $interval, $state, browserService) {
                            var _this = this;
                            this.navigationService = navigationService;
                            this.$mdMenu = $mdMenu;
                            this.$interval = $interval;
                            this.$state = $state;
                            this.browserService = browserService;
                            this.intervalTime = 200;
                            this.isDeviceMobile = false;
                            this.triggerScroll = true;
                            this.itemOnClick = function (cb) {
                                _this.triggerScroll = false;
                                if (cb) {
                                    cb();
                                }
                            };
                            this.childOnClick = function (childObj) {
                                _this.triggerScroll = false;
                                _this.MobileViewHideAllMenu();
                                _this.$mdMenu.hide(null, { closeAll: true });
                                if (childObj.callback) {
                                    childObj.callback();
                                    _this.windowScrollTop();
                                }
                                if (!childObj.isModal) {
                                    _this.navigationService.setSubMenuItemActive(childObj.id);
                                }
                            };
                            this.mobileViewBottomMenuOnClick = function (navObj) {
                                _this.triggerScroll = false;
                                _this.MobileViewHideAllMenu();
                                _this.mobileOptionType = navObj.id;
                                _this.mobileOptionLIst = _this.navigationService.getDropdown(navObj.id);
                                _this.showDynamicMenu = true;
                            };
                            this.MobileViewOnClick = function (navObj) {
                                _this.MobileViewHideAllMenu();
                                _this.mobileOptionType = navObj.id;
                                if (navObj.stateName === null && !angular.isUndefined(navObj.dropdown)) {
                                    var mobileOptionListWithClass = _.map(_this.navigationService.getDropdown(navObj.id), function (item) {
                                        if (item.accountStatus) {
                                            item.className = item.accountStatus.toLowerCase() + '-status';
                                        }
                                        return item;
                                    });
                                    _this.mobileOptionLIst = _.filter(mobileOptionListWithClass, function (item) {
                                        return item.status !== 0;
                                    });
                                    _this.showDynamicMenu = true;
                                }
                                else {
                                    _this.showServiceMenu = true;
                                }
                            };
                            this.mobileViewFilter = function (item) {
                                return (item.status === 0 || item.status === 1);
                            };
                            this.MobileViewHideAllMenu = function () {
                                _this.showServiceMenu = false;
                                _this.showDynamicMenu = false;
                            };
                            this.isMobileViewActive = function () { return (_this.showServiceMenu || _this.showDynamicMenu); };
                            this.firstNavInterval = function () {
                                /* tslint:disable */
                                $('body').attr('hasSecondLevelNav', "true");
                                /* tslint:enable */
                            };
                            this.secondNavInterval = function () {
                                var firstNavHeaderHeight = $('header').height();
                                if (firstNavHeaderHeight > 0) {
                                    var height_1 = $('.ute-secondLevelNav').height();
                                    $('header').removeClass('navbar-fixed-top');
                                    _this.secondNavBarAffix = {};
                                    var isNavBarSticky = _this.navigationService.getNavigationBarSticky();
                                    if (isNavBarSticky) {
                                        _this.secondNavBarAffix = {
                                            'dataSpy': 'affix',
                                            'dataOffsetTop': firstNavHeaderHeight
                                        };
                                        $('.ute-secondLevelNav').affix({
                                            offset: {
                                                top: function () {
                                                    return firstNavHeaderHeight;
                                                }
                                            }
                                        });
                                        $('.ute-secondLevelNav').on('affixed.bs.affix', function () {
                                            $('body').addClass('secondNavSticky');
                                            $('header').css({ 'margin-bottom': height_1 });
                                        }).on('affixed-top.bs.affix', function () {
                                            $('body').removeClass('secondNavSticky');
                                            $('header').css({ 'margin-bottom': '' });
                                        });
                                    }
                                    _this.setDevice();
                                    _this.clearInterval(_this.intervalPromiseSecondNav);
                                }
                            };
                            this.setDevice = function () {
                                _this.isDeviceMobile = _this.browserService.isMobile();
                                console.log('this.isDeviceMobile:', _this.isDeviceMobile);
                                if (_this.isDeviceMobile) {
                                    _this.mobileScroll();
                                    /* tslint:disable */
                                    $('body').attr('isMobileDevice', "true");
                                }
                                else {
                                    /* tslint:disable */
                                    $('body').attr('isMobileDevice', "false");
                                }
                            };
                            this.inputModel = navigationService.getInputModel;
                            this.showMenu = navigationService.getShowNavigationMenu;
                            this.selectedAccount = navigationService.getSelectedAccount;
                            this.accountsDropdown = navigationService.getAccounts;
                            this.showServiceMenu = false;
                            this.showDynamicMenu = false;
                            this.navigationBarSticky();
                            this.state = $state;
                        }
                        NavigationBarController.prototype.isAccountSuspended = function (item) {
                            return item.accountStatus && item.accountStatus.toLowerCase() === 'suspended';
                        };
                        NavigationBarController.prototype.isAccountCancelled = function (item) {
                            return item.accountStatus && item.accountStatus.toLowerCase() === 'cancelled';
                        };
                        NavigationBarController.prototype.isAccountDropdownStyle = function (status) {
                            return (status === ute.common.second.level.navigation.NavigationStatus.ACCOUNT_DROPDOWN);
                        };
                        NavigationBarController.prototype.isStatusShowDisable = function (status) {
                            return (status === ute.common.second.level.navigation.NavigationStatus.SHOW_DISABLE);
                        };
                        NavigationBarController.prototype.isStatusActive = function (status) {
                            return (status === ute.common.second.level.navigation.NavigationStatus.ACTIVE);
                        };
                        NavigationBarController.prototype.navigationBarSticky = function () {
                            this.firstNavInterval();
                            this.intervalPromiseSecondNav = this.$interval(this.secondNavInterval, this.intervalTime);
                        };
                        NavigationBarController.prototype.clearInterval = function (item) {
                            this.$interval.cancel(item);
                        };
                        NavigationBarController.prototype.mobileScroll = function () {
                            console.log('triggerScroll:', this.triggerScroll);
                            if (!this.triggerScroll) {
                                console.log('mobile scroll wont be called');
                                return;
                            }
                            var $header = $('header'), $headerHeight = 0, $secondNav = $('.ute-secondLevelNav'), lastScrollTop = 0, delta = 60; //amount to scroll before showing header
                            console.log('header:', $header, $headerHeight);
                            $(window).scroll(function (event) {
                                var currentScrollPos = $(this).scrollTop();
                                if (currentScrollPos > lastScrollTop && currentScrollPos > $headerHeight) {
                                    // downscroll code
                                    //console.log( 'scroll down : ' + currentScrollPos );
                                    $('body').removeClass('up');
                                    $secondNav.css({ top: '' });
                                }
                                if (currentScrollPos < delta) {
                                    $secondNav.css({ top: $headerHeight });
                                }
                                if (Math.abs(lastScrollTop - currentScrollPos) <= delta) {
                                    return;
                                }
                                if (currentScrollPos < lastScrollTop) {
                                    // upscroll code
                                    console.log('scroll up :' + currentScrollPos);
                                    $('body').addClass('up');
                                    $header.addClass('clone');
                                    $secondNav.css({ top: $headerHeight });
                                }
                                lastScrollTop = currentScrollPos;
                            });
                        };
                        NavigationBarController.prototype.windowScrollTop = function () {
                            $(window).scrollTop(0);
                        };
                        NavigationBarController.$inject = ['ute.common.second.level.navigation.service', '$mdMenu', '$interval', '$state', 'ute.common.core.browser.service'];
                        return NavigationBarController;
                    }());
                    angular.module('ute.common.second.level.navigation').controller('ute.common.second.level.navigation.navigationBar.controller', NavigationBarController);
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var SecondLevelNavigation = (function () {
                        /* @ngInject */
                        function SecondLevelNavigation(navigationService) {
                            var _this = this;
                            this.navigationService = navigationService;
                            this.restrict = 'E';
                            this.templateUrl = this.navigationService.getConfig().advanced.navigationBarDirective.templateUrl;
                            this.controller = this.navigationService.getConfig().advanced.navigationBarDirective.controllerName;
                            this.controllerAs = 'navigationBar';
                            this.scope = {
                                navigationInput: '=navigationModel'
                            };
                            /**
                             * @param scope
                             */
                            this.linkFn = function (scope) {
                                // this.navigationService.setDataModel(scope.navigationInput);
                                _this.navigationService.setInputModel(scope.navigationInput);
                                scope.$on('$destroy', function () {
                                    /* tslint:disable */
                                    $('body').attr('hasSecondLevelNav', "false");
                                    /* tslint:enable */
                                });
                            };
                            this.link = this.linkFn;
                        }
                        SecondLevelNavigation.factory = function () {
                            var directive = function (navigationService) { return new SecondLevelNavigation(navigationService); };
                            directive.$inject = ['ute.common.second.level.navigation.service'];
                            return directive;
                        };
                        return SecondLevelNavigation;
                    }());
                    angular.module('ute.common.second.level.navigation').directive('uteSecondLevelNavigation', SecondLevelNavigation.factory());
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    'use strict';
                    var SecondLevelNavigationAccountStatus = (function () {
                        /* @ngInject */
                        function SecondLevelNavigationAccountStatus() {
                            this.restrict = 'E';
                            this.template = "<div class=\"status-tag\">\n            <img src=\"ute-common-assets/assets/warning-white.png\"/>\n            <span translate=\"{{statusTagKey}}\"></span>\n          </div>";
                            this.scope = {
                                accountStatus: '@'
                            };
                            this.linkFn = function (scope) {
                                if (scope.accountStatus.toLowerCase() === 'suspended') {
                                    scope.statusTagKey = 'ute.secondLevelNavigation.suspendedStatus';
                                }
                                else if (scope.accountStatus.toLowerCase() === 'cancelled') {
                                    scope.statusTagKey = 'ute.secondLevelNavigation.cancelledStatus';
                                }
                            };
                            this.link = this.linkFn;
                        }
                        SecondLevelNavigationAccountStatus.factory = function () {
                            return function () { return new SecondLevelNavigationAccountStatus(); };
                        };
                        return SecondLevelNavigationAccountStatus;
                    }());
                    angular.module('ute.common.second.level.navigation').directive('uteNavigationAccountStatus', SecondLevelNavigationAccountStatus.factory());
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = common.second || (common.second = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var semafone;
    (function (semafone) {
        var service;
        (function (service) {
            'use strict';
            function DefaultConfigFactory() {
                return {
                    basic: {
                        semafoneParams: null
                    },
                    advance: {
                        dataLayerTracking: {
                            page: {
                                makeAPayment: {
                                    error: {
                                        name: 'payment',
                                        hierarchy: ['myrogers', 'pay now']
                                    }
                                }
                            }
                        }
                    }
                };
            }
            service.DefaultConfigFactory = DefaultConfigFactory;
        })(service = semafone.service || (semafone.service = {}));
    })(semafone = ute.semafone || (ute.semafone = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var semafone;
    (function (semafone) {
        var service;
        (function (service) {
            'use strict';
            var ProviderBase = ute.common.core.ProviderBase;
            var SemafoneServiceConfigFactory = (function () {
                function SemafoneServiceConfigFactory(config) {
                    var _this = this;
                    this.config = config;
                    this.getConfig = function () { return angular.copy(_this.config); };
                }
                ;
                SemafoneServiceConfigFactory.factoryName = 'ute.semafone.service.config';
                return SemafoneServiceConfigFactory;
            }());
            var SemafoneServiceConfigProvider = (function (_super) {
                __extends(SemafoneServiceConfigProvider, _super);
                /* @ngInject */
                function SemafoneServiceConfigProvider() {
                    var _this = this;
                    _super.call(this);
                    /* @ngInject */
                    this.$get = function () {
                        return new SemafoneServiceConfigFactory(_this.config);
                    };
                    this.config = service.DefaultConfigFactory();
                }
                SemafoneServiceConfigProvider.$inject = [];
                return SemafoneServiceConfigProvider;
            }(ProviderBase));
            angular.module('ute.semafone').provider(SemafoneServiceConfigFactory.factoryName, SemafoneServiceConfigProvider);
        })(service = semafone.service || (semafone.service = {}));
    })(semafone = ute.semafone || (ute.semafone = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardChangeController = (function () {
                        /* @ngInject */
                        function SimCardChangeController($state, simCardService) {
                            this.$state = $state;
                            this.simCardService = simCardService;
                            this.model = this.simCardService.getModel();
                            this.hasInputFocus = false;
                            this.hasNewInputFocus = false;
                        }
                        SimCardChangeController.prototype.isFormValid = function (simCardForm) {
                            simCardForm.$submitted = true;
                            return simCardForm.$valid;
                        };
                        SimCardChangeController.prototype.setCurrentSimInputFocus = function (isCurrentInput) {
                            if (isCurrentInput) {
                                this.hasInputFocus = true;
                            }
                            else {
                                this.hasNewInputFocus = true;
                            }
                        };
                        SimCardChangeController.prototype.submit = function (simCardForm, $event) {
                            $event.preventDefault();
                            if (this.isFormValid(simCardForm)) {
                                this.simCardService.setCurrentSimCardNumber(this.model.currentSimCardNumber);
                                this.simCardService.setNewSimCardNumber(this.model.newSimCardNumber);
                                return this.simCardService.goToSubModule(this.simCardService.getConfig().advanced.confirmation.subState);
                            }
                        };
                        SimCardChangeController.prototype.cancel = function ($event) {
                            $event.preventDefault();
                            this.simCardService.resetModel();
                            return this.$state.go(this.simCardService.getConfig().advanced.enterSimCard.cancelState);
                        };
                        SimCardChangeController.$inject = ['$state', 'ute.common.simcard.change.service'];
                        return SimCardChangeController;
                    }());
                    service.SimCardChangeController = SimCardChangeController;
                    angular.module('ute.common.simcard.change.form').controller('ute.common.simcard.change.directive.controller', SimCardChangeController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.form').directive('myrSimCardChange', myrSimCardChange);
                    myrSimCardChange.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function myrSimCardChange(simCardService) {
                        return {
                            restrict: 'E',
                            scope: {
                                isDesktopView: '@'
                            },
                            templateUrl: simCardService.getConfig().advanced.simCardChangeDirective.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardChangeDirective.controllerName,
                            controllerAs: 'simCardChange'
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardConfirmationController = (function () {
                        /* @ngInject */
                        function SimCardConfirmationController($modal, $translate, simCardService) {
                            var _this = this;
                            this.$modal = $modal;
                            this.$translate = $translate;
                            this.simCardService = simCardService;
                            //protected backToUpdateSimCard(): void {
                            //  this.openModalPopup({modalSize: 'lg', templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationModal.view.html'});
                            //}
                            this.backToUpdateSimCard = function () {
                                return _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.enterSimCard.subState);
                            };
                            this.isChangeSimCallInProgress = simCardService.isChangeSimCallInProgress;
                            //this.model = this.simCardService.getModel();
                        }
                        /**
                         * mutable model
                         */
                        //private model: ISimCardModel;
                        SimCardConfirmationController.prototype.getNewSimCardNumber = function () {
                            return this.simCardService.getModel().newSimCardNumber;
                        };
                        SimCardConfirmationController.prototype.submitConfirmation = function () {
                            var _this = this;
                            this.simCardService.changeSim().then(function (result) {
                                //console.log('submitConfirmation', errorHandler, FrontEndErrorCode[errorHandler.frontendCode]);
                                //switch (_.get(response, 'frontendCode')) {
                                switch (result.frontendCode) {
                                    case service.FrontEndErrorCode.UPDATED_OK:
                                        _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.success.subState);
                                        break;
                                    default:
                                        _this.openModalPopup(result);
                                        break;
                                }
                                return result;
                            }).catch(function (error) {
                                //system error
                                //Sorry! It seems something went wrong on our end. Please contact us on Live Chat to get this sorted out.
                                //console.log('submitConfirmation->catch', error);
                                _this.openModalPopup(error);
                                return error;
                            });
                        };
                        SimCardConfirmationController.prototype.cancelConfirmation = function () {
                            // TODO configurable
                            this.openModalPopup({ modalSize: 'lg', templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationModal.view.html' });
                        };
                        SimCardConfirmationController.prototype.openModalPopup = function (errorHandler) {
                            var _this = this;
                            this.$modal.open({
                                windowTemplateUrl: this.simCardService.getConfig().advanced.simCardConfirmationModal.windowTemplateUrl,
                                templateUrl: errorHandler.templateUrl,
                                controller: this.simCardService.getConfig().advanced.simCardConfirmationModal.controllerName,
                                controllerAs: 'simCardConfirmationModal',
                                size: errorHandler.modalSize,
                                backdrop: 'static',
                                resolve: {
                                    'ute.common.simcard.change.service.errorHandler': errorHandler
                                }
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        _this.simCardService.cancelSimCardChange();
                                        break;
                                    case 'no':
                                        // Send the user back to SIM card enter page and close modal
                                        _this.simCardService.goToSubModule(_this.simCardService.getConfig().advanced.enterSimCard.subState);
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        SimCardConfirmationController.$inject = ['$modal', '$translate', 'ute.common.simcard.change.service'];
                        return SimCardConfirmationController;
                    }());
                    service.SimCardConfirmationController = SimCardConfirmationController;
                    angular.module('ute.common.simcard.change.confirmation').controller('ute.common.simcard.change.confirmation.controller', SimCardConfirmationController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.confirmation').directive('myrSimCardConfirmation', simCardConfirmation);
                    simCardConfirmation.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function simCardConfirmation(simCardService) {
                        return {
                            restrict: 'E',
                            templateUrl: simCardService.getConfig().advanced.simCardConfirmationDirective.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardConfirmationDirective.controllerName,
                            controllerAs: 'simCardConfirmation'
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    var SimCardConfirmationModalController = (function () {
                        /* @ngInject */
                        function SimCardConfirmationModalController($scope, $modalInstance, simCardService, errorCode, userService) {
                            this.$scope = $scope;
                            this.$modalInstance = $modalInstance;
                            this.simCardService = simCardService;
                            this.errorCode = errorCode;
                            this.userService = userService;
                            if (errorCode) {
                                this.errorMessage = errorCode.frontendMessageKey;
                                this.modalTitle = 'ute.rogers.myrSimCard.simCardConfirmation.sorry';
                                if (errorCode.backendCode === 15607) {
                                    this.errorMessage = errorCode.frontendMessageKey + userService.getUserType();
                                }
                                if (_.has(errorCode, 'frontendMessageP2Key')) {
                                    this.errorMessage_p2 = errorCode.frontendMessageP2Key;
                                }
                                if (_.has(errorCode, 'boldChat')) {
                                    this.boldChat = errorCode.boldChat;
                                }
                                this.modalIcon = errorCode.modalIcon;
                                if (errorCode.backendCode === 15601) {
                                    this.modalTitle = 'ute.rogers.myrSimCard.simCardConfirmation.error_current_sim_invalid_title';
                                }
                            }
                        }
                        SimCardConfirmationModalController.prototype.noSelection = function () {
                            if (this.simCardService.isGenericError(this.errorCode.backendCode)) {
                                this.$modalInstance.dismiss('cancel');
                            }
                            else {
                                this.$modalInstance.close('no');
                            }
                        };
                        SimCardConfirmationModalController.prototype.cancel = function () {
                            this.$modalInstance.close('no');
                        };
                        SimCardConfirmationModalController.prototype.continue = function () {
                            this.$modalInstance.close('yes');
                        };
                        SimCardConfirmationModalController.$inject = ['$scope', '$modalInstance', 'ute.common.simcard.change.service', 'ute.common.simcard.change.service.errorHandler', 'ute.common.user.service'];
                        return SimCardConfirmationModalController;
                    }());
                    service.SimCardConfirmationModalController = SimCardConfirmationModalController;
                    angular.module('ute.common.simcard.change.confirmation').controller('ute.common.simcard.change.confirmation.modal.controller', SimCardConfirmationModalController);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

// TODO move to the different module
var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    angular.module('ute.common.simcard.change.service').directive('myrErrorMessage', errorMessage);
                    errorMessage.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function errorMessage(simCardService) {
                        return {
                            restrict: 'E',
                            transclude: true,
                            templateUrl: simCardService.getConfig().advanced.simCardErrorDirective.templateUrl
                        };
                    }
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15600;
                        BackEndErrorCode.CURRENT_SIM_IS_NOT_VALID = 15601;
                        BackEndErrorCode.NEW_SIM_IS_NOT_VALID = 15602;
                        BackEndErrorCode.NEW_SIM_IS_ALREADY_IN_USE = 15603;
                        BackEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE = 15604;
                        BackEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX = 15605;
                        BackEndErrorCode.NEW_SIM_IN_NFDB = 15607;
                        return BackEndErrorCode;
                    }());
                    var SimCardChangeProvider = (function () {
                        /* @ngInject */
                        function SimCardChangeProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isChangeSimCallInProgress = false;
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessDashBoard/changeSimCardNumber',
                                    simCardRootState: 'simCard',
                                    defaultSimNumber: 89302,
                                    mainControllerName: 'ute.common.simcard.change.main.controller',
                                    mainTemplateUrl: 'module/simCard/simCardMain.view.html',
                                },
                                advanced: {
                                    enterSimCard: {
                                        subState: 'start',
                                        cancelState: 'wireless',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardEnterSimCard/simCardEnterSimCard.view.html'
                                    },
                                    confirmation: {
                                        subState: 'confirmation',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmation.html'
                                    },
                                    success: {
                                        subState: 'success',
                                        backToState: 'accountOverview',
                                        backToRepState: 'oneViewDashboard',
                                        controllerName: 'ute.common.simcard.change.main.controller',
                                        templateUrl: 'module/simCard/simCardSuccess/simCardSuccess.html'
                                    },
                                    simCardChangeDirective: {
                                        controllerName: 'ute.common.simcard.change.directive.controller',
                                        templateUrl: 'module/simCard/simCardChange/simCardChangeNumberForm.partial.html'
                                    },
                                    simCardErrorDirective: {
                                        templateUrl: 'module/simCard/simCardErrorMessage/simCardErrorMessage.template.html'
                                    },
                                    simCardConfirmationDirective: {
                                        controllerName: 'ute.common.simcard.change.confirmation.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmation.view.html'
                                    },
                                    simCardSuccess: {
                                        controllerName: 'ute.common.simcard.change.success.controller',
                                        templateUrl: 'module/simCard/simCardSuccess/simCardSuccess.view.html'
                                    },
                                    simCardConfirmationModal: {
                                        controllerName: 'ute.common.simcard.change.confirmation.modal.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationErrorModal.view.html',
                                        windowTemplateUrl: 'module/simCard/simCardErrorMessage/simCardErrorMessageWindow.view.html'
                                    },
                                    simCardConfirmationNFDBModal: {
                                        controllerName: 'ute.common.simcard.change.confirmation.modal.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationNFDBErrorModal.view.html',
                                        windowTemplateUrl: 'module/simCard/simCardErrorMessage/simCardErrorMessageWindow.view.html'
                                    },
                                    simCardConfirmationGenericModal: {
                                        controllerName: 'ute.common.simcard.change.success.controller',
                                        templateUrl: 'module/simCard/simCardConfirmation/simCardConfirmationGenericModal.view.html'
                                    },
                                    secondaryColumnPartialPath: 'module/simCard/simCardEnterSimCard/simCardHowToFindNumber.partial.html',
                                    simCardHeaderPartialPath: 'module/simCard/simCardHeader.partial.html',
                                    simCardDefaultPartialPath: 'module/simCard/simCardDefault.view.html'
                                }
                            };
                            /* @ngInject */
                            this.$get = function ($injector, $state, $http, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$stateParams = $stateParams;
                                return {
                                    getConfig: _this.getConfig,
                                    goToEntryState: _this.goToEntryState,
                                    getEntryState: _this.getEntryState,
                                    changeSim: _this.changeSim,
                                    restoreFromInput: _this.restoreFromInput,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    getAccountNumber: _this.getAccountNumber,
                                    getAccountEmail: _this.getAccountEmail,
                                    isChangeSimCallInProgress: _this.isChangeSimCallInProgressFn,
                                    getUser: _this.userService.getUser,
                                    goToSubModule: _this.goToSubModule,
                                    cancelSimCardChange: _this.cancelSimCardChange,
                                    resetModel: _this.resetModel,
                                    getModel: _this.getModel,
                                    setCurrentSimCardNumber: _this.setCurrentSimCardNumber,
                                    setNewSimCardNumber: _this.setNewSimCardNumber,
                                    finishedRoute: _this.finishedRoute,
                                    isGenericError: _this.isGenericError,
                                    getUserType: _this.getUserType
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                if (_.isEmpty(_this.config.basic.medium)) {
                                    console.error('medium:', 'Config Provider should override medium with vaid Medium');
                                    return false;
                                }
                                _this.config.advanced.confirmation.cancelSubState = _.get(config, 'advanced.confirmation.cancelSubState') ||
                                    _.get(config, 'advanced.enterSimCard.subState') ||
                                    _this.config.advanced.enterSimCard.subState;
                                return true;
                            };
                            /**
                             * @param code
                             * @returns {boolean}
                             */
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/green-checkbox.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.system_error_message',
                                    frontendMessageP2Key: 'ute.rogers.myrSimCard.simCardConfirmation.system_error_message_p2',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationGenericModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR,
                                    boldChat: {
                                        cbid: 'ute.rogers.myrSimCard.boldChat.cbid',
                                        dynamicDivId: 'ute.rogers.myrSimCard.boldChat.dynamicDivId',
                                        chatButtonClass: 'ute.rogers.myrSimCard.boldChat.chatButtonClass'
                                    }
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.CURRENT_SIM_CARD_NOT_VALID_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_current_sim_invalid_body',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.CURRENT_SIM_IS_NOT_VALID
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_CARD_NOT_VALID_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_new_sim_invalid',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_IS_NOT_VALID
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_CARD_IN_USE_ERROR,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.error_new_sim_in_use',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_IS_ALREADY_IN_USE
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.new.sim.has.been.used.before',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_HAS_BEEN_USED_BEFORE
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.new.sim.has.invalid.sim.prefix',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_HAS_INVALID_SIM_PREFIX
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.NEW_SIM_IN_NFDB,
                                    frontendMessageKey: 'ute.rogers.myrSimCard.simCardConfirmation.new.sim.in.nfdb.message.',
                                    templateUrl: _this.getConfig().advanced.simCardConfirmationNFDBModal.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.NEW_SIM_IN_NFDB
                                });
                            };
                            /**
                             * @returns {ng.IPromise<ICodeEntry>}
                             */
                            this.changeSim = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    oldSimNumber: _this.model.currentSimCardNumber,
                                    newSimNumber: _this.model.newSimCardNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isChangeSimCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processChangeSimOk)
                                    .catch(_this.processChangeSimError)
                                    .finally(_this.finaliseChangeSimCardCall);
                            };
                            /**
                             * @param response
                             * @returns {any}
                             */
                            this.processChangeSimOk = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                console.log('processChangeSimOk:', 'response:', response, 'backendCode:', backendCode);
                                // TODO
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            /**
                             * @param backendCode
                             * @returns {ICodeEntry|any}
                             */
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            /**
                             * @param error
                             * @returns {ICodeEntry}
                             */
                            this.processChangeSimError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                //console.log('ute.common.simcard.change.service->processChangeSimError:', 'error:', error, 'backendCode:', backendCode);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseChangeSimCardCall = function () {
                                _this.isChangeSimCallInProgress = false;
                                //console.log('ute.common.simcard.change.service->finaliseChangeSimError:', this.isChangeSimCallInProgress);
                            };
                            /**
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            this.isChangeSimCallInProgressFn = function () {
                                return _this.isChangeSimCallInProgress;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            /**
                             * @returns {string}
                             */
                            this.getAccountEmail = function () {
                                return _this.model.accountEmail;
                            };
                            /**
                             * TODO to make it automaticaly
                             */
                            this.restoreFromInput = function () {
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        // console.log('SimCard->restoreFromInput', obj);
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.accountEmail = obj.accountEmail;
                                        }
                                        else {
                                            _this.$state.go(_this.config.advanced.enterSimCard.cancelState);
                                        }
                                        if (obj.currentSimCardNumber) {
                                            _this.model.currentSimCardNumber = obj.currentSimCardNumber;
                                        }
                                        if (obj.currentSimCardNumber && obj.newSimCardNumber) {
                                            _this.model.currentSimCardNumber = obj.currentSimCardNumber;
                                            _this.model.newSimCardNumber = obj.newSimCardNumber;
                                        }
                                        else {
                                            _this.goToEntryState(_this.model);
                                        }
                                    });
                                }
                                else {
                                    // TODO route where ? or maybe restore from localstore - refresh on confirm
                                    _this.$state.go(_this.config.advanced.enterSimCard.cancelState);
                                }
                            };
                            //function setOnStateChangeStartHandler() {
                            //  $rootScope.$on('$stateChangeStart',
                            //      function (event, toState, toParams, fromState, fromParams) {
                            //        if (_.startsWith(toState.name, myrSimCardService.getSimCardState())) {
                            //          restoreSimAndBan();
                            //        }
                            //      });
                            //}
                            /**
                             * @returns {any}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getEntryState = function () {
                                return _this.config.basic.simCardRootState + '.' + _this.config.advanced.enterSimCard.subState;
                            };
                            /**
                             * @param input
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToEntryState = function (input) {
                                return _this.encryptionService.encrypt(input).then(function (id) {
                                    return _this.$state.go(_this.getEntryState(), { id: id });
                                });
                            };
                            /**
                             * @param module
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToSubModule = function (module) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.simCardRootState + '.' + module, {
                                        id: id
                                    });
                                });
                            };
                            /**
                             * Return immutable ISimCardModel object
                             * @returns {ISimCardModel}
                             */
                            this.getModel = function () {
                                return angular.copy(_this.model);
                            };
                            /**
                             * @param sim - current SimCard Number
                             */
                            this.setCurrentSimCardNumber = function (sim) {
                                _this.model.currentSimCardNumber = sim;
                            };
                            /**
                             * @param sim - New SimCard Number
                             */
                            this.setNewSimCardNumber = function (sim) {
                                _this.model.newSimCardNumber = sim;
                            };
                            /**
                             * cancel Sim Card Change Wizard and naviagte to the 'start' state
                             * @returns {angular.IPromise<any>}
                             */
                            this.cancelSimCardChange = function () {
                                _this.model.currentSimCardNumber = _this.config.basic.defaultSimNumber;
                                _this.model.newSimCardNumber = _this.config.basic.defaultSimNumber;
                                return _this.goToSubModule(_this.getConfig().advanced.confirmation.cancelSubState);
                            };
                            /**
                             * Reset model to initial state
                             */
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null,
                                    currentSimCardNumber: _this.config.basic.defaultSimNumber,
                                    newSimCardNumber: _this.config.basic.defaultSimNumber,
                                    accountEmail: null
                                };
                            };
                            /**
                             * @returns {IPromise<TResult>}
                             */
                            this.finishedRoute = function () {
                                return _this.$state.go((_this.userService.getUserType() === 'care' || _this.userService.getUserType() === 'dealer') ? _this.getConfig().advanced.success.backToRepState : _this.getConfig().advanced.success.backToState).then(function (data) {
                                    _this.resetModel();
                                }).catch(function (error) {
                                    // TODO
                                }).finally(function () {
                                    //TODO
                                });
                            };
                            /**
                             * @returns {boolean}
                             */
                            this.isGenericError = function (backendErrorCode) {
                                return (backendErrorCode === BackEndErrorCode.GENERIC_ERROR);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getUserType = function () {
                                return _this.userService.getUserType();
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        SimCardChangeProvider.$inject = [];
                        return SimCardChangeProvider;
                    }());
                    angular.module('ute.common.simcard.change.service').provider('ute.common.simcard.change.service', SimCardChangeProvider);
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var service;
                (function (service) {
                    'use strict';
                })(service = change.service || (change.service = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var success;
                (function (success) {
                    'use strict';
                    /* @ngInject */
                    var SimCardSuccessController = (function () {
                        /* @ngInject */
                        function SimCardSuccessController(simCardService) {
                            this.simCardService = simCardService;
                        }
                        SimCardSuccessController.prototype.getUserEmailAddress = function () {
                            // return this.simCardService.getUser().userEmail;
                            return this.simCardService.getAccountEmail();
                        };
                        SimCardSuccessController.prototype.finishedRoute = function () {
                            return this.simCardService.finishedRoute();
                        };
                        SimCardSuccessController.$inject = [
                            'ute.common.simcard.change.service'];
                        return SimCardSuccessController;
                    }());
                    success.SimCardSuccessController = SimCardSuccessController;
                    angular.module('ute.common.simcard.change.success').controller('ute.common.simcard.change.success.controller', SimCardSuccessController);
                })(success = change.success || (change.success = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var success;
                (function (success) {
                    'use strict';
                    angular.module('ute.common.simcard.change.success').directive('myrSimCardSuccess', MyrSimCardSuccess);
                    MyrSimCardSuccess.$inject = ['ute.common.simcard.change.service'];
                    /* @ngInject */
                    function MyrSimCardSuccess(simCardService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: simCardService.getConfig().advanced.simCardSuccess.templateUrl,
                            controller: simCardService.getConfig().advanced.simCardSuccess.controllerName,
                            controllerAs: 'simCardSuccess'
                        };
                    }
                })(success = change.success || (change.success = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = common.simcard || (common.simcard = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var subscriptionBadge;
        (function (subscriptionBadge) {
            'use strict';
            /**
             * Private interface
             */
            var SubscriptionBadgeProvider = (function () {
                /* @ngInject */
                function SubscriptionBadgeProvider() {
                    var _this = this;
                    this.config = {
                        basic: {
                            applicationId: 'ute-application-id',
                            templateUrl: 'module/subscriptionBadge/subscriptionBadge.view.html',
                            controller: 'ute.common.subscriptionBadge.controller'
                        }
                    };
                    /* @ngInject */
                    this.$get = function () {
                        return {
                            getConfig: _this.getConfig
                        };
                    };
                    /**
                     * @param config
                     * @returns {boolean}
                     */
                    this.configure = function (config) {
                        _this.config = _.merge(_this.config, config);
                        return true;
                    };
                    /**
                     * get the config setting
                     * @returns {any}
                     */
                    this.getConfig = function () {
                        return angular.copy(_this.config);
                    };
                    this.$get.$inject = [];
                }
                SubscriptionBadgeProvider.$inject = [];
                return SubscriptionBadgeProvider;
            }());
            angular.module('ute.common.subscriptionBadge').provider('ute.common.subscriptionBadge.provider', SubscriptionBadgeProvider);
        })(subscriptionBadge = common.subscriptionBadge || (common.subscriptionBadge = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnConfirmController = (function () {
                    /* @ngInject */
                    function SuspendCtnConfirmController($modal, suspendCtnService, $state) {
                        this.$modal = $modal;
                        this.suspendCtnService = suspendCtnService;
                        this.$state = $state;
                        this.isSuspendCtnCallInProgress = suspendCtnService.isSuspendCtnCallInProgress;
                    }
                    /**
                     * Switch Off Service
                     */
                    SuspendCtnConfirmController.prototype.switchOffService = function ($event) {
                        var _this = this;
                        $event.preventDefault();
                        return this.suspendCtnService.suspendCtn().then(function (result) {
                            switch (result.frontendCode) {
                                case ute.common.suspend.ctn.service.FrontEndErrorCode.UPDATED_OK:
                                    _this.suspendCtnService.goToState(_this.suspendCtnService.getConfig().advanced.suspendCtnSuccess.subState);
                                    break;
                                default:
                                    _this.openModalPopup(result);
                                    break;
                            }
                            return result;
                        }).catch(function (error) {
                            _this.openModalPopup(error);
                            return error;
                        });
                    };
                    SuspendCtnConfirmController.prototype.backToDevice = function ($event) {
                        $event.preventDefault();
                        return this.$state.go(this.suspendCtnService.getConfig().basic.cancelState);
                    };
                    /**
                     * Get First Name
                     */
                    SuspendCtnConfirmController.prototype.getFirstName = function () {
                        return this.suspendCtnService.getFirstName();
                    };
                    /**
                     * Get Account Email
                     */
                    SuspendCtnConfirmController.prototype.getAccountEmail = function () {
                        return this.suspendCtnService.getAccountEmail();
                    };
                    /**
                     * Get
                     */
                    SuspendCtnConfirmController.prototype.getUpdateProfileState = function () {
                        return this.suspendCtnService.getConfig().basic.updateProfileState;
                    };
                    SuspendCtnConfirmController.prototype.openModalPopup = function (errorHandler) {
                        this.$modal.open({
                            templateUrl: errorHandler.templateUrl,
                            controller: this.suspendCtnService.getConfig().advanced.suspendCtnError.controllerName,
                            controllerAs: 'simCardErrorModal',
                            size: errorHandler.modalSize,
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {
                                'ute.common.simcard.change.service.errorHandler': errorHandler
                            }
                        });
                    };
                    SuspendCtnConfirmController.$inject = [
                        '$modal',
                        'ute.common.suspend.ctn.service',
                        '$state'
                    ];
                    return SuspendCtnConfirmController;
                }());
                ctn.SuspendCtnConfirmController = SuspendCtnConfirmController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.confirm.controller', SuspendCtnConfirmController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnErrorController = (function () {
                    /* @ngInject */
                    function SuspendCtnErrorController($modalInstance, suspendCtnService) {
                        var _this = this;
                        this.$modalInstance = $modalInstance;
                        this.suspendCtnService = suspendCtnService;
                        this.backToDevicePage = function () {
                            _this.$modalInstance.dismiss('cancel');
                            _this.suspendCtnService.backToDevice();
                        };
                    }
                    SuspendCtnErrorController.prototype.cancel = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    SuspendCtnErrorController.$inject = ['$modalInstance', 'ute.common.suspend.ctn.service'];
                    return SuspendCtnErrorController;
                }());
                ctn.SuspendCtnErrorController = SuspendCtnErrorController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.error.controller', SuspendCtnErrorController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnDeviceController = (function () {
                    /* @ngInject */
                    function SuspendCtnDeviceController(suspendCtnService) {
                        var _this = this;
                        this.suspendCtnService = suspendCtnService;
                        this.hasDeviceName = function () {
                            return _this.suspendCtnService.hasDeviceName();
                        };
                    }
                    SuspendCtnDeviceController.$inject = ['ute.common.suspend.ctn.service'];
                    return SuspendCtnDeviceController;
                }());
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.device.controller', SuspendCtnDeviceController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnDevice = (function () {
                    /* @ngInject */
                    function SuspendCtnDevice(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnDevice.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnDevice.controllerName;
                        this.controllerAs = 'suspendCtnDevice';
                    }
                    SuspendCtnDevice.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnDevice(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnDevice;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnDevice', SuspendCtnDevice.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnFaqController = (function () {
                    function SuspendCtnFaqController() {
                    }
                    SuspendCtnFaqController.$inject = [];
                    return SuspendCtnFaqController;
                }());
                ctn.SuspendCtnFaqController = SuspendCtnFaqController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.faq.controller', SuspendCtnFaqController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnFaq = (function () {
                    /* @ngInject */
                    function SuspendCtnFaq(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnFaq.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnFaq.controllerName;
                        this.controllerAs = 'suspendCtnFaq';
                    }
                    SuspendCtnFaq.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnFaq(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnFaq;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnFaq', SuspendCtnFaq.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumberController = (function () {
                    /* @ngInject */
                    function SuspendCtnWirelessNumberController(suspendCtnService) {
                        var _this = this;
                        this.suspendCtnService = suspendCtnService;
                        this.getPhoneNumber = function () {
                            return _this.suspendCtnService.getPhoneNumber();
                        };
                        this.getFirstName = function () {
                            return _this.suspendCtnService.getFirstName();
                        };
                        this.backToDevicePage = function () {
                            _this.suspendCtnService.backToDevice();
                        };
                    }
                    SuspendCtnWirelessNumberController.$inject = ['ute.common.suspend.ctn.service'];
                    return SuspendCtnWirelessNumberController;
                }());
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.wirelessNumber.controller', SuspendCtnWirelessNumberController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnWirelessNumber = (function () {
                    /* @ngInject */
                    function SuspendCtnWirelessNumber(suspendCtnService) {
                        this.suspendCtnService = suspendCtnService;
                        this.restrict = 'E';
                        this.scope = {};
                        this.templateUrl = this.suspendCtnService.getConfig().advanced.suspendCtnWirelessNumber.templateUrl;
                        this.controller = this.suspendCtnService.getConfig().advanced.suspendCtnWirelessNumber.controllerName;
                        this.controllerAs = 'suspendCtnWirelessNumber';
                    }
                    SuspendCtnWirelessNumber.factory = function () {
                        var directive = function (suspendCtnService) { return new SuspendCtnWirelessNumber(suspendCtnService); };
                        directive.$inject = ['ute.common.suspend.ctn.service'];
                        return directive;
                    };
                    return SuspendCtnWirelessNumber;
                }());
                angular.module('ute.common.suspend.ctn').directive('uteSuspendCtnWirelessNumber', SuspendCtnWirelessNumber.factory());
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend_1) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                    /**
                     * Private
                     */
                    var BackEndErrorCode = (function () {
                        function BackEndErrorCode() {
                        }
                        BackEndErrorCode.UPDATED_OK = 0;
                        BackEndErrorCode.GENERIC_ERROR = 15700;
                        return BackEndErrorCode;
                    }());
                    var SuspendCtnProvider = (function () {
                        /* @ngInject */
                        function SuspendCtnProvider() {
                            var _this = this;
                            this.errorCodesMap = {};
                            this.isSuspendCtnCallInProgress = false;
                            this.config = {
                                basic: {
                                    applicationId: 'ute-application-id',
                                    medium: 'WEB',
                                    partialApiUrl: 'v1/wirelessService/suspend',
                                    suspendCtnRootState: 'suspendCtn',
                                    cancelState: 'wireless',
                                    updateProfileState: 'self-serve',
                                    mainControllerName: 'ute.common.suspend.ctn.main.controller',
                                    mainTemplateUrl: 'module/suspendCtn/suspendCtnMain.view.html',
                                    mainRepViewTemplateUrl: 'module/suspendCtn/suspendCtnMain.RepView.view.html'
                                },
                                advanced: {
                                    suspendCtnFaq: {
                                        controllerName: 'ute.common.suspend.ctn.faq.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.faq.directive.html'
                                    },
                                    suspendCtnWirelessNumber: {
                                        controllerName: 'ute.common.suspend.ctn.wirelessNumber.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.wirelessNumber.directive.html'
                                    },
                                    suspendCtnDevice: {
                                        controllerName: 'ute.common.suspend.ctn.device.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnDirective/suspendCtn.device.directive.html'
                                    },
                                    confirmSuspendDevice: {
                                        subState: 'start',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.suspend.ctn.confirm.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.view.html'
                                    },
                                    repViewConfirmSuspendDevice: {
                                        templateUrl: 'module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.RepView.view.html'
                                    },
                                    suspendCtnSuccess: {
                                        subState: 'success',
                                        backToState: 'wireless',
                                        controllerName: 'ute.common.suspend.ctn.success.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.view.html'
                                    },
                                    repViewSuspendCtnSuccess: {
                                        templateUrl: 'module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.RepView.view.html'
                                    },
                                    suspendCtnError: {
                                        controllerName: 'ute.common.suspend.ctn.error.controller',
                                        templateUrl: 'module/suspendCtn/suspendCtnError/suspendCtnError.view.html'
                                    },
                                    repViewSuspendCtnError: {
                                        templateUrl: 'module/suspendCtn/suspendCtnError/suspendCtnError.RepView.view.html'
                                    }
                                }
                            };
                            /* @ngInject */
                            this.$get = function ($injector, $state, $http, $stateParams) {
                                _this.encryptionService = $injector.get('ute.common.encryption.service');
                                _this.userService = $injector.get('ute.common.user.service');
                                _this.securityService = $injector.get('ute.common.security.service');
                                _this.routerHelper = $injector.get('ute.blocks.router');
                                _this.$state = $state;
                                _this.$http = $http;
                                _this.$stateParams = $stateParams;
                                _this.runtimeTranslateService = $injector.get('ute.common.runtime.translate.service');
                                return {
                                    getConfig: _this.getConfig,
                                    goToEntryState: _this.goToEntryState,
                                    getEntryState: _this.getEntryState,
                                    getPhoneNumber: _this.getPhoneNumber,
                                    getAccountNumber: _this.getAccountNumber,
                                    getFirstName: _this.getFirstName,
                                    getAccountEmail: _this.getAccountEmail,
                                    getUser: _this.userService.getUser,
                                    goToState: _this.goToState,
                                    getModel: _this.getModel,
                                    suspendCtn: _this.suspendCtn,
                                    isSuspendCtnCallInProgress: _this.isSuspendCtnCallInProgressFn,
                                    hasDeviceName: _this.hasDeviceName,
                                    backToDevice: _this.backToDevice,
                                    restoreState: _this.restoreState,
                                    configure: _this.runtimeConfigure
                                };
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.configure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                if (_.isEmpty(_this.config.basic.medium)) {
                                    console.error('medium:', 'configure method should override medium with vaid Medium');
                                    return false;
                                }
                                return true;
                            };
                            /**
                             * @param config
                             * @returns {boolean}
                             */
                            this.runtimeConfigure = function (config) {
                                _this.config = _.merge(_this.config, config);
                                try {
                                    if (_.has(config, 'advanced.confirmSuspendDevice.templateUrl')) {
                                        var suspend_2 = _this.routerHelper.getState('suspendCtn');
                                        var suspendStart = _this.routerHelper.getState('suspendCtn.start');
                                        var suspendSuccess = _this.routerHelper.getState('suspendCtn.success');
                                        _this.config.advanced.confirmSuspendDevice.templateUrl = config.advanced.confirmSuspendDevice.templateUrl;
                                        _this.config.advanced.suspendCtnError.templateUrl = config.advanced.suspendCtnError.templateUrl;
                                        _this.config.advanced.suspendCtnSuccess.templateUrl = config.advanced.suspendCtnSuccess.templateUrl;
                                        _this.config.basic.mainTemplateUrl = config.basic.mainTemplateUrl;
                                        _this.addCodes();
                                        suspend_2.templateUrl = config.basic.mainTemplateUrl;
                                        suspendStart.templateUrl = config.advanced.confirmSuspendDevice.templateUrl;
                                        suspendSuccess.templateUrl = config.advanced.suspendCtnSuccess.templateUrl;
                                    }
                                }
                                catch (e) {
                                }
                                return true;
                            };
                            /**
                             * @param code
                             * @returns {boolean}
                             */
                            this.addCode = function (code) {
                                _this.errorCodesMap[code.frontendCode] = code;
                            };
                            this.addCodes = function () {
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.UPDATED_OK,
                                    templateUrl: _this.getConfig().advanced.suspendCtnSuccess.templateUrl,
                                    modalIcon: '',
                                    modalSize: '',
                                    backendCode: BackEndErrorCode.UPDATED_OK
                                });
                                _this.addCode({
                                    frontendCode: service.FrontEndErrorCode.GENERIC_ERROR,
                                    frontendMessageKey: 'ute.rogers.suspendCtn.system_error_message',
                                    templateUrl: _this.getConfig().advanced.suspendCtnError.templateUrl,
                                    modalIcon: 'ute-common-assets/assets/error_warning.png',
                                    modalSize: 'md',
                                    backendCode: BackEndErrorCode.GENERIC_ERROR
                                });
                            };
                            /**
                             * TODO to make it automaticaly
                             */
                            this.restoreState = function () {
                                if (_this.$stateParams.id) {
                                    _this.encryptionService.decrypt(_this.$stateParams.id).then(function (obj) {
                                        if (obj.accountNumber && obj.phoneNumber) {
                                            _this.model.accountNumber = obj.accountNumber;
                                            _this.model.phoneNumber = obj.phoneNumber;
                                            _this.model.deviceNameEn = obj.deviceNameEn;
                                            _this.model.deviceNameFr = obj.deviceNameFr || obj.deviceNameEn;
                                            _this.model.firstName = obj.firstName;
                                            _this.model.accountEmail = obj.accountEmail;
                                            _this.runtimeTranslateService.addTranslation('en', SuspendCtnProvider.deviceNameTranslateKey, _this.model.deviceNameEn);
                                            _this.runtimeTranslateService.addTranslation('fr', SuspendCtnProvider.deviceNameTranslateKey, _this.model.deviceNameFr);
                                        }
                                        else {
                                            _this.$state.go(_this.config.basic.cancelState);
                                        }
                                    });
                                }
                                else {
                                    _this.$state.go(_this.config.basic.cancelState);
                                }
                            };
                            /**
                             * @returns {ng.IPromise<ICodeEntry>}
                             */
                            this.suspendCtn = function () {
                                var request = {
                                    accountNumber: _this.model.accountNumber,
                                    phoneNumber: _this.model.phoneNumber,
                                    applicationId: _this.config.basic.applicationId,
                                    medium: _this.config.basic.medium
                                };
                                _this.isSuspendCtnCallInProgress = true;
                                return _this.$http.post(_this.securityService.getBackendUrl(_this.getConfig().basic.partialApiUrl), request)
                                    .then(_this.processSuspendCtn)
                                    .catch(_this.processSuspendCtnError)
                                    .finally(_this.finaliseSuspendCtnCallCall);
                            };
                            /**
                             * @param response
                             * @returns {any}
                             */
                            this.processSuspendCtn = function (response) {
                                var backendCode = _.get(response, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                if (backendCode === BackEndErrorCode.UPDATED_OK) {
                                    return _this.errorCodesMap[service.FrontEndErrorCode.UPDATED_OK];
                                }
                                else {
                                    return _this.findCodeEntry(backendCode);
                                }
                            };
                            /**
                             * @param backendCode
                             * @returns {ICodeEntry|any}
                             */
                            this.findCodeEntry = function (backendCode) {
                                return _.find(_this.errorCodesMap, function (ce) {
                                    return ce.backendCode === backendCode;
                                }) || _this.errorCodesMap[service.FrontEndErrorCode.GENERIC_ERROR];
                            };
                            /**
                             * @param error
                             * @returns {ICodeEntry}
                             */
                            this.processSuspendCtnError = function (error) {
                                var backendCode = _.get(error, 'data.status.code', BackEndErrorCode.GENERIC_ERROR);
                                return _this.findCodeEntry(backendCode);
                            };
                            this.finaliseSuspendCtnCallCall = function () {
                                _this.isSuspendCtnCallInProgress = false;
                            };
                            this.backToDevice = function () {
                                _this.$state.go(_this.config.basic.cancelState);
                            };
                            this.isSuspendCtnCallInProgressFn = function () {
                                return _this.isSuspendCtnCallInProgress;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getPhoneNumber = function () {
                                return _this.model.phoneNumber;
                            };
                            this.getAccountEmail = function () {
                                return _this.model.accountEmail;
                            };
                            /**
                             * @returns {string}
                             */
                            this.getFirstName = function () {
                                return _this.model.firstName;
                            };
                            /**
                             * @returns {number}
                             */
                            this.getAccountNumber = function () {
                                return _this.model.accountNumber;
                            };
                            this.hasDeviceName = function () {
                                return _this.runtimeTranslateService.hasTranslation(SuspendCtnProvider.deviceNameTranslateKey);
                            };
                            /**
                             * @returns {any}
                             */
                            this.getConfig = function () {
                                return angular.copy(_this.config);
                            };
                            /**
                             * @returns {string}
                             */
                            this.getEntryState = function () {
                                return _this.config.basic.suspendCtnRootState + '.' + _this.config.advanced.confirmSuspendDevice.subState;
                            };
                            /**
                             * @param input
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToEntryState = function (input) {
                                console.log('goToEntryState', input);
                                _this.model = input;
                                return _this.encryptionService.encrypt(input).then(function (id) {
                                    return _this.$state.go(_this.getEntryState(), { id: id });
                                });
                            };
                            /**
                             * @param state
                             * @returns {angular.IPromise<any>}
                             */
                            this.goToState = function (state) {
                                return _this.encryptionService.encrypt(_this.model).then(function (id) {
                                    return _this.$state.go(_this.config.basic.suspendCtnRootState + '.' + state, {
                                        id: id
                                    });
                                });
                            };
                            /**
                             * Return immutable ISimCardModel object
                             * @returns {ISimCardModel}
                             */
                            this.getModel = function () {
                                return angular.copy(_this.model);
                            };
                            /**
                             * Reset model to initial state
                             */
                            this.resetModel = function () {
                                _this.model = {
                                    phoneNumber: null,
                                    accountNumber: null
                                };
                            };
                            this.$get.$inject = [
                                '$injector',
                                '$state',
                                '$http',
                                '$stateParams'
                            ];
                            this.resetModel();
                            this.addCodes();
                        }
                        ;
                        SuspendCtnProvider.$inject = [];
                        SuspendCtnProvider.deviceNameTranslateKey = 'ute.common.suspend.ctn.success.header.deviceName';
                        return SuspendCtnProvider;
                    }());
                    angular.module('ute.common.suspend.ctn').provider('ute.common.suspend.ctn.service', SuspendCtnProvider);
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend_1.ctn || (suspend_1.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var service;
                (function (service) {
                    'use strict';
                })(service = ctn.service || (ctn.service = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var common;
    (function (common) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                'use strict';
                var SuspendCtnSucessController = (function () {
                    /* @ngInject */
                    function SuspendCtnSucessController($document, $state, $translate, suspendCtnService) {
                        this.$document = $document;
                        this.$state = $state;
                        this.$translate = $translate;
                        this.suspendCtnService = suspendCtnService;
                        this.phoneNumber = this.suspendCtnService.getPhoneNumber();
                    }
                    SuspendCtnSucessController.$inject = ['$document', '$state', '$translate', 'ute.common.suspend.ctn.service'];
                    return SuspendCtnSucessController;
                }());
                ctn.SuspendCtnSucessController = SuspendCtnSucessController;
                angular.module('ute.common.suspend.ctn').controller('ute.common.suspend.ctn.success.controller', SuspendCtnSucessController);
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = common.suspend || (common.suspend = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var StepFourController = (function () {
            /* @ngInject */
            function StepFourController($scope, torDestinationCustomerService, TORService) {
                this.$scope = $scope;
                this.torDestinationCustomerService = torDestinationCustomerService;
                this.TORService = TORService;
                this.model = this.TORService.getModel();
                this.ctnList = this.model.ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 4;
                this.model.stepTrackerIndex = 4;
                this.screenName = this.TORService.getScreenName();
            }
            StepFourController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            StepFourController.prototype.copyNumber = function () {
                //document.querySelector('.subscriberNumber');
                //document.execCommand('copy');
                //angular.element(document.querySelector('#subscriberNumber'));
                //angular.element(document.execCommand('copy'));
                console.log('copieng');
            };
            StepFourController.$inject = ['$scope',
                'ute.transferOfResponsibility.futureOwner.service',
                'ute.transferOfResponsibility.service'
            ];
            return StepFourController;
        }());
        transferOfResponsibility.StepFourController = StepFourController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.stepFour.controller', StepFourController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TORCurrentOwnerService = (function () {
            /* @ngInject */
            function TORCurrentOwnerService($http, TORService, securityService) {
                var _this = this;
                this.$http = $http;
                this.TORService = TORService;
                this.securityService = securityService;
                this.callInProgress = false;
                /**
                 * @returns {ng.IPromise<IEligibilityCheckResult>}
                 */
                this.eligibilityCheck = function (ctn) {
                    var apiUrl = '', request;
                    if (ctn) {
                        request = {
                            accountNumber: _this.model.accountNumber,
                            subscriberNumber: ctn.subscriberNumber,
                            applicationId: _this.config.basic.applicationId,
                            medium: _this.config.basic.medium,
                            eligibilityType: 'ctn',
                            ban: _this.TORService.getRequestedAccountNumber()
                        };
                    }
                    else {
                        request = {
                            accountNumber: _this.model.accountNumber,
                            applicationId: _this.config.basic.applicationId,
                            medium: _this.config.basic.medium,
                            eligibilityType: 'ban',
                            ban: _this.TORService.getRequestedAccountNumber()
                        };
                    }
                    _this.callInProgress = true;
                    apiUrl = _this.config.basic.sourceTorEligibilityApiUrl;
                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                        .then(_this.processEligibilityCheckOk)
                        .catch(_this.processEligibilityCheckError)
                        .finally(_this.finaliseEligibilityCheckCall);
                };
                /**
                 * @returns {ng.IPromise<ISubmitResult>}
                 */
                this.sourceSubmit = function () {
                    var apiUrl = '';
                    apiUrl = _this.config.basic.sourceTorSubmitApiUrl;
                    _this.callInProgress = true;
                    var eligibelCtnList = [];
                    var ctnList = _this.TORService.getModel().ctnList;
                    for (var _i = 0, ctnList_1 = ctnList; _i < ctnList_1.length; _i++) {
                        var ctn = ctnList_1[_i];
                        if (ctn.isEligible === true) {
                            eligibelCtnList.push(ctn.subscriberNumber);
                        }
                    }
                    var request = {
                        accountNumber: _this.TORService.getModel().accountNumber,
                        subList: eligibelCtnList,
                        securityCode: _this.TORService.getModel().sourceAccountInfo.securityCode,
                        firstName: _this.TORService.getModel().sourceAccountInfo.firstName,
                        lastName: _this.TORService.getModel().sourceAccountInfo.lastName,
                        applicationId: _this.config.basic.applicationId,
                        medium: _this.config.basic.medium,
                        ban: _this.TORService.getRequestedAccountNumber()
                    };
                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                        .then(_this.processSourceSubmitSuccess)
                        .catch(_this.processSourceSubmitError)
                        .finally(_this.finaliseSourceSubmitCall);
                };
                /**
                 * @param response
                 * @returns {IEligibilityCheckResult}
                 */
                this.processEligibilityCheckOk = function (response) {
                    return { status: response.data.status,
                        isEligible: response.data.isEligible,
                        reasonCodes: response.data.reasonCodes
                    };
                };
                /**
                 * @param error
                 * @returns {IEligibilityCheckResult}
                 */
                this.processEligibilityCheckError = function (error) {
                    return { status: error.data.status, isEligible: null, reasonCodes: null };
                };
                this.finaliseEligibilityCheckCall = function () {
                    _this.callInProgress = false;
                    return true;
                };
                /**
                 * @param response
                 * @returns {ISubmitResult}
                 */
                this.processSourceSubmitSuccess = function (response) {
                    return { status: response.data.status, errorCode: response.data.errorCode };
                };
                /**
                 * @param error
                 * @returns {ISubmitResult}
                 */
                this.processSourceSubmitError = function (error) {
                    return { status: 'failure', errorCode: error.data.errorCode };
                };
                this.finaliseSourceSubmitCall = function () {
                    _this.callInProgress = false;
                    return true;
                };
                this.errorMessagePath = '';
                this.model = this.TORService.getModel();
                this.config = this.TORService.getConfig();
            }
            TORCurrentOwnerService.$inject = ['$http',
                'ute.transferOfResponsibility.service',
                'ute.common.security.service'
            ];
            return TORCurrentOwnerService;
        }());
        angular.module('ute.transferOfResponsibility').service('ute.transferOfResponsibility.currentOwner.service', TORCurrentOwnerService);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TORFutureOwnerService = (function () {
            /* @ngInject */
            function TORFutureOwnerService($http, TORService, securityService) {
                var _this = this;
                this.$http = $http;
                this.TORService = TORService;
                this.securityService = securityService;
                this.callInProgress = false;
                /**
                 * @returns {ng.IPromise<IEligibilityCheckResult>}
                 */
                this.eligibilityCheck = function (request) {
                    var apiUrl = '';
                    _this.callInProgress = true;
                    apiUrl = _this.config.basic.destinationTorEligibilityApiUrl;
                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                        .then(_this.processEligibilityCheckOk)
                        .catch(_this.processEligibilityCheckError)
                        .finally(_this.finaliseEligibilityCheckCall);
                };
                /**
                 * @returns {ng.IPromise<ISubmitResult>}
                 */
                this.destinationSubmit = function () {
                    var apiUrl = '';
                    apiUrl = _this.config.basic.destinationTorSubmitApiUrl;
                    _this.callInProgress = true;
                    var request = {
                        accountNumber: _this.TORService.getModel().accountNumber,
                        applicationId: _this.config.basic.applicationId,
                        medium: _this.config.basic.medium,
                        subscriberNumber: _this.TORService.getModel().sourceAccountInfo.subscriberNumber,
                        ban: _this.TORService.getRequestedAccountNumber()
                    };
                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                        .then(_this.processDestinationSubmitSuccess)
                        .catch(_this.processDestinationSubmitError)
                        .finally(_this.finaliseDestinationSubmitCall);
                };
                /**
                 * @param currentOwnerNumber - curretn owner ctn number
                 */
                this.setCurrentOwnerNumber = function (currentOwnerNumber) {
                    _this.TORService.getModel().sourceAccountInfo.subscriberNumber = currentOwnerNumber;
                };
                /**
                 * @returns {ng.IPromise<ISubmitResult>}
                 */
                this.getDetails = function () {
                    var apiUrl = _this.config.basic.destinationTorRetrieveApiUrl;
                    _this.callInProgress = true;
                    var request = {
                        accountNumber: _this.TORService.getModel().accountNumber,
                        applicationId: _this.config.basic.applicationId,
                        medium: _this.config.basic.medium,
                        subscriberNumber: _this.TORService.getModel().sourceAccountInfo.subscriberNumber,
                        ban: _this.TORService.getRequestedAccountNumber()
                    };
                    return _this.$http.post(_this.securityService.getBackendUrl(apiUrl), request)
                        .then(_this.processGetDetailsOk)
                        .catch(_this.processGetDetailsError)
                        .finally(_this.finaliseGetDetailsCall);
                };
                /**
                 * @param response
                 * @returns {IEligibilityCheckResult}
                 */
                this.processEligibilityCheckOk = function (response) {
                    return { status: response.data.status,
                        isEligible: response.data.isEligible,
                        reasonCodes: response.data.reasonCodes
                    };
                };
                /**
                 * @param error
                 * @returns {IEligibilityCheckResult}
                 */
                this.processEligibilityCheckError = function (error) {
                    return { status: 'failure', isEligible: null, reasonCodes: null };
                };
                this.finaliseEligibilityCheckCall = function () {
                    _this.callInProgress = false;
                    return true;
                };
                /**
                 * @param response
                 * @returns {ISubmitResult}
                 */
                this.processGetDetailsOk = function (response) {
                    _this.TORService.getModel().sourceAccountInfo.firstName = response.data.custFirstName;
                    _this.TORService.getModel().sourceAccountInfo.lastName = response.data.custLastName;
                    _this.TORService.getModel().sourceAccountInfo.securityCode = response.data.securityCode;
                    _this.TORService.getModel().sourceAccountInfo.accountNumber = response.data.accountNumber;
                    _this.TORService.getModel().sourceAccountInfo.isCtnFound = response.data.isCtnFound;
                    var torProcessStartedDate = new Date(response.data.timestamp);
                    var expiryDate = torProcessStartedDate.setDate(torProcessStartedDate.getDate() + 30);
                    _this.TORService.getModel().sourceAccountInfo.expiryDate = String(expiryDate);
                    return { status: response.data.status, errorCode: response.data.errorCode };
                };
                /**
                 * @param error
                 * @returns {ISubmitResult}
                 */
                this.processGetDetailsError = function (error) {
                    return { status: 'failure', errorCode: '' };
                };
                this.finaliseGetDetailsCall = function () {
                    _this.callInProgress = false;
                    return true;
                };
                /**
                 * @param response
                 * @returns {ISubmitResult}
                 */
                this.processDestinationSubmitSuccess = function (response) {
                    return { status: response.data.status, errorCode: response.data.errorCode };
                };
                /**
                 * @param error
                 * @returns {ISubmitResult}
                 */
                this.processDestinationSubmitError = function (error) {
                    return { status: 'failure', errorCode: error.data.errorCode };
                };
                this.finaliseDestinationSubmitCall = function () {
                    _this.callInProgress = false;
                    return true;
                };
                this.errorMessagePath = '';
                this.config = this.TORService.getConfig();
            }
            TORFutureOwnerService.$inject = ['$http',
                'ute.transferOfResponsibility.service',
                'ute.common.security.service'
            ];
            return TORFutureOwnerService;
        }());
        angular.module('ute.transferOfResponsibility').service('ute.transferOfResponsibility.futureOwner.service', TORFutureOwnerService);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TransferOfResponsibilitySelectionController = (function () {
            /* @ngInject */
            function TransferOfResponsibilitySelectionController(torService, $state, permissionsService, accountOverviewFactory, accountOverviewSummaryFactory, userService, sessionStorage) {
                var _this = this;
                this.torService = torService;
                this.$state = $state;
                this.permissionsService = permissionsService;
                this.accountOverviewSummaryFactory = accountOverviewSummaryFactory;
                this.userService = userService;
                this.sessionStorage = sessionStorage;
                this.ctnDetails = {};
                this.accountSummaryAPICall = function (request) {
                    var thisObject = _this;
                    _this.accountOverviewSummaryFactory(request).getAccountOverviewSummaryRawData().then(function (accountSummary) {
                        console.log('success');
                        thisObject.model.accountNumber = String(accountSummary.accountNumber);
                        var customCtnList = [];
                        for (var sub = 0; sub < accountSummary.subList.length; sub++) {
                            thisObject.ctnDetails = {};
                            thisObject.ctnDetails.subscriberNumber = accountSummary.subList[sub].subNumber;
                            thisObject.ctnDetails.firstName = accountSummary.subList[sub].firstname;
                            if (accountSummary.subList[sub].subType === 'CTN') {
                                customCtnList.push(thisObject.ctnDetails);
                            }
                        }
                        thisObject.model.ctnList = customCtnList;
                    }, function () {
                        console.log('error');
                    });
                };
                this.model = this.torService.getModel();
                this.checkRAMPermission();
                this.screenName = this.torService.getScreenName();
                this.userType = this.userService.getUserType();
                this.accountOverviewService = accountOverviewFactory();
                this.doAccountSummaryCall();
            }
            /**
             * go to currentOwner View
             */
            TransferOfResponsibilitySelectionController.prototype.goToCurrentOwner = function () {
                this.model.stepTrackerIndex = 1;
                this.torService.resetCtnList();
                this.torService.goToState(this.torService.getConfig().advanced.stepOne.ctnSelection.subState);
            };
            /**
             * go to futureOwner View
             */
            TransferOfResponsibilitySelectionController.prototype.goToFutureOwner = function () {
                this.model.stepTrackerIndex = 3;
                this.torService.resetCtnList();
                this.torService.goToState(this.torService.getConfig().advanced.stepThree.subscriberDetails.subState);
            };
            /**
             * checking  the RAM Permission for TOR
             */
            TransferOfResponsibilitySelectionController.prototype.checkRAMPermission = function () {
                var _this = this;
                this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.TransferOfResponsibility, ute.common.permissions.service.RamActionCodes.inprogress)
                    .then(function (FooterPermission) {
                    return _this.isCurrentOwnerPemitted = true;
                });
                this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.TransferOfResponsibility, ute.common.permissions.service.RamActionCodes.grant)
                    .then(function (FooterPermission) {
                    return _this.isFutureOwnerPemitted = true;
                });
            };
            TransferOfResponsibilitySelectionController.prototype.doAccountSummaryCall = function () {
                if (this.model.ctnList.length <= 0) {
                    var request = {};
                    if (this.userType === 'care') {
                        request = {};
                        var accountNumber = this.sessionStorage.getSessionStorageValue('accountNumber');
                        var accountTypeNumber = this.sessionStorage.getSessionStorageValue('accountTypeNumber');
                        request = {
                            accountNumber: accountNumber,
                            accountTypeNumber: accountTypeNumber
                        };
                    }
                    this.accountSummaryAPICall(request);
                }
            };
            TransferOfResponsibilitySelectionController.controllerName = 'ute.transferOfResponsibility.selection.controller';
            TransferOfResponsibilitySelectionController.$inject = [
                'ute.transferOfResponsibility.service',
                '$state',
                'ute.common.permissions.service',
                'ute.rogers.account.overview.factory',
                'ute.rogers.account.overview.summary.factory',
                'ute.common.user.service',
                'sessionStorage'
            ];
            return TransferOfResponsibilitySelectionController;
        }());
        transferOfResponsibility.TransferOfResponsibilitySelectionController = TransferOfResponsibilitySelectionController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.selection.controller', TransferOfResponsibilitySelectionController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var AddAnotherCtnModalController = (function () {
            /* @ngInject */
            function AddAnotherCtnModalController($scope, $modalInstance, torCurrentOwnerService, TORService) {
                var _this = this;
                this.$scope = $scope;
                this.$modalInstance = $modalInstance;
                this.torCurrentOwnerService = torCurrentOwnerService;
                this.TORService = TORService;
                this.updateSuccessful = false;
                this.noOfCtnCallsCount = 0;
                this.cancel = function () {
                    if (_this.selectedCtnsValue.length > 0 && _this.noOfCtnCallsCount === 0) {
                        var localCtnList = _this.model.ctnList;
                        for (var _i = 0, localCtnList_1 = localCtnList; _i < localCtnList_1.length; _i++) {
                            var ctn = localCtnList_1[_i];
                            if (ctn.isSelected && (ctn.isEligible === null ||
                                angular.isUndefined(ctn.isEligible))) {
                                ctn.isSelected = false;
                                _this.model.selectedCtnList = _.without(_this.model.selectedCtnList, ctn.subscriberNumber);
                            }
                        }
                    }
                    _this.$modalInstance.close('no');
                };
                /**
                 * @returns {void}
                 */
                this.addEligibilityCheckCall = function () {
                    var localCtnList = _this.model.ctnList;
                    for (var _i = 0, localCtnList_2 = localCtnList; _i < localCtnList_2.length; _i++) {
                        var ctn = localCtnList_2[_i];
                        if (ctn.isSelected && (ctn.isEligible === null ||
                            angular.isUndefined(ctn.isEligible))) {
                            _this.doCtnAPICall(ctn);
                        }
                    }
                };
                this.doCtnAPICall = function (ctn) {
                    _this.torCurrentOwnerService.eligibilityCheck(ctn)
                        .then(function (result) {
                        if (result.status === 'success') {
                            console.log('ctn.subscriberNumber: ' + ctn.subscriberNumber);
                            ctn.isEligible = result.isEligible;
                            if (!ctn.isEligible) {
                                ctn.reasonCodes = result.reasonCodes;
                            }
                        }
                        else if (result.status === 'failure') {
                            console.log('failure response');
                            if (ctn) {
                                ctn.isStatusFailure = true;
                            }
                        }
                        _this.noOfCtnCallsCount++;
                        if (_this.noOfCtnCallsCount === _this.selectedCtnsValue.length) {
                            _this.$modalInstance.close('no');
                        }
                    })
                        .catch(function (error) {
                        console.log('exception in add another ctn eligibility check');
                    });
                };
                this.model = this.TORService.getModel();
                this.selectedCtnsValue = [];
            }
            AddAnotherCtnModalController.prototype.addToEligibilityCheck = function () {
                this.addEligibilityCheckCall();
            };
            AddAnotherCtnModalController.prototype.updateModalSelectedCtnList = function (ctn) {
                if (ctn.isSelected) {
                    this.selectedCtnsValue.push(ctn.subscriberNumber);
                    this.selectedCtnsValue = _.uniq(this.selectedCtnsValue);
                    this.model.selectedCtnList.push(ctn.subscriberNumber);
                    this.model.selectedCtnList = _.uniq(this.model.selectedCtnList);
                }
                else {
                    this.selectedCtnsValue = _.without(this.selectedCtnsValue, ctn.subscriberNumber);
                    this.model.selectedCtnList = _.without(this.model.selectedCtnList, ctn.subscriberNumber);
                }
            };
            AddAnotherCtnModalController.$inject = ['$scope',
                '$modalInstance',
                'ute.transferOfResponsibility.currentOwner.service',
                'ute.transferOfResponsibility.service'
            ];
            return AddAnotherCtnModalController;
        }());
        transferOfResponsibility.AddAnotherCtnModalController = AddAnotherCtnModalController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.addAnotherCtn.modal.controller', AddAnotherCtnModalController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var CopyToClipboard = (function () {
            /* @ngInject */
            function CopyToClipboard(torService, $window) {
                var _this = this;
                this.torService = torService;
                this.restrict = 'A';
                this.scope = {
                    uteCopyToClipboard: '='
                };
                this.copy = function (toCopy) {
                    _this.textarea.val(toCopy);
                    _this.body.append(_this.textarea);
                    _this.textarea[0].select();
                    try {
                        var successful = document.execCommand('copy');
                        if (!successful) {
                            throw successful;
                        }
                    }
                    catch (err) {
                        console.log('failed to copy', toCopy);
                    }
                    _this.textarea.remove();
                };
                /**
                 * @param scope
                 */
                this.linkFn = function (scope, elem, attributes) {
                    var copyThis = _this;
                    elem.bind('click', function () {
                        copyThis.copy(scope.uteCopyToClipboard);
                    });
                };
                this.link = this.linkFn;
                this.body = angular.element($window.document.body);
                this.textarea = angular.element('<textarea/>');
                this.textarea.css({
                    position: 'fixed',
                    opacity: '0'
                });
            }
            CopyToClipboard.factory = function () {
                var directive = function (torService, $window) { return new CopyToClipboard(torService, $window); };
                directive.$inject = ['ute.transferOfResponsibility.service', '$window'];
                return directive;
            };
            return CopyToClipboard;
        }());
        angular.module('ute.transferOfResponsibility').directive('uteCopyToClipboard', CopyToClipboard.factory());
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TORStepTrackerController = (function () {
            /* @ngInject */
            function TORStepTrackerController($scope, TORService) {
                this.$scope = $scope;
                this.TORService = TORService;
                this.model = this.TORService.getModel();
            }
            TORStepTrackerController.$inject = ['$scope',
                'ute.transferOfResponsibility.service'];
            return TORStepTrackerController;
        }());
        transferOfResponsibility.TORStepTrackerController = TORStepTrackerController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.TORStepTracker.controller', TORStepTrackerController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TorStepTracker = (function () {
            /* @ngInject */
            function TorStepTracker(torService) {
                var _this = this;
                this.torService = torService;
                this.restrict = 'E';
                this.scope = {
                    stepTrackerIndex: '='
                };
                this.templateUrl = this.torService.getConfig().advanced.stepTracker.templateUrl;
                this.controller = this.torService.getConfig().advanced.stepTracker.controllerName;
                this.controllerAs = 'stepTracker';
                /**
                 * @param scope
                 */
                this.linkFn = function (scope, elem, attributes) {
                    // Set step tracker index to the service model
                    _this.torService.setStepTrackerIndex(scope.stepTrackerIndex);
                };
                this.link = this.linkFn;
            }
            TorStepTracker.factory = function () {
                var directive = function (torService) { return new TorStepTracker(torService); };
                directive.$inject = ['ute.transferOfResponsibility.service'];
                return directive;
            };
            return TorStepTracker;
        }());
        angular.module('ute.transferOfResponsibility').directive('uteTorStepTracker', TorStepTracker.factory());
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var SystemExceptionModalController = (function () {
            /* @ngInject */
            function SystemExceptionModalController($scope, $modalInstance) {
                var _this = this;
                this.$scope = $scope;
                this.$modalInstance = $modalInstance;
                this.updateSuccessful = false;
                this.close = function () {
                    _this.$modalInstance.close('no');
                };
            }
            SystemExceptionModalController.$inject = ['$scope',
                '$modalInstance'
            ];
            return SystemExceptionModalController;
        }());
        transferOfResponsibility.SystemExceptionModalController = SystemExceptionModalController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.systemException.modal.controller', SystemExceptionModalController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var TransferOfResponsibilityProvider = (function () {
            /* @ngInject */
            function TransferOfResponsibilityProvider() {
                var _this = this;
                this.isEligibilityCheckCallInProgress = false;
                this.config = {
                    basic: {
                        applicationId: 'ute-application-id',
                        medium: 'WEB',
                        torRootState: 'transferOfResponsibility',
                        mainControllerName: 'ute.transferOfResponsibility.main.controller',
                        mainTemplateUrl: 'module/transferOfResponsibility/transferOfResponsibilityMain.view.html',
                        sourceTorEligibilityApiUrl: 'v1/tor/sourceTorEligibility',
                        destinationTorEligibilityApiUrl: 'v1/tor/destinationTorEligibility',
                        sourceTorSubmitApiUrl: 'v1/tor/sourceTorSubmit',
                        destinationTorSubmitApiUrl: 'v1/tor/destinationTorSubmit',
                        destinationTorRetrieveApiUrl: 'v1/tor/destinationTorRetrieve'
                    },
                    advanced: {
                        selectTransferOfResponsibility: {
                            subState: 'start',
                            controllerName: 'ute.transferOfResponsibility.selection.controller',
                            templateUrl: 'module/transferOfResponsibility/transferOfResponsibilitySelection/transferOfResponsibilitySelection.view.html'
                        },
                        stepOne: {
                            ctnSelection: {
                                subState: 'stepOne/ctnSelection',
                                controllerName: 'ute.transferOfResponsibility.ctnSelection.controller',
                                templateUrl: 'module/transferOfResponsibility/stepOne/ctnSelection/ctnSelection.view.html'
                            },
                            eligibilityCheck: {
                                subState: 'stepOne/eligibilityCheck',
                                controllerName: 'ute.transferOfResponsibility.currentOwnerEligibilityCheck.controller',
                                templateUrl: 'module/transferOfResponsibility/stepOne/currentOwnerEligibilityCheck/currentOwnerEligibilityCheck.view.html'
                            }
                        },
                        stepTwo: {
                            futureOwnerInfo: {
                                subState: 'stepTwo/futureOwnerInfo',
                                controllerName: 'ute.transferOfResponsibility.futureOwnerInfo.controller',
                                templateUrl: 'module/transferOfResponsibility/stepTwo/futureOwnerInfo/futureOwnerInfo.view.html'
                            },
                            confirmation: {
                                subState: 'stepTwo/confirmation',
                                controllerName: 'ute.transferOfResponsibility.confirmation.controller',
                                templateUrl: 'module/transferOfResponsibility/stepTwo/confirmation/confirmation.view.html'
                            }
                        },
                        stepThree: {
                            subscriberDetails: {
                                subState: 'stepThree/subscriberDetails',
                                controllerName: 'ute.transferOfResponsibility.subscriberDetails.controller',
                                templateUrl: 'module/transferOfResponsibility/stepThree/subscriberDetails/subscriberDetails.view.html'
                            },
                            currentOwnerInfo: {
                                subState: 'stepThree/currentOwnerInfo',
                                controllerName: 'ute.transferOfResponsibility.currentOwnerInfo.controller',
                                templateUrl: 'module/transferOfResponsibility/stepThree/currentOwnerInfo/currentOwnerInfo.view.html'
                            },
                            eligibilityCheck: {
                                subState: 'stepThree/eligibilityCheck',
                                controllerName: 'ute.transferOfResponsibility.futureOwnerEligibilityCheck.controller',
                                templateUrl: 'module/transferOfResponsibility/stepThree/futureOwnerEligibilityCheck/futureOwnerEligibilityCheck.view.html'
                            }
                        },
                        stepFour: {
                            subState: 'stepFour',
                            controllerName: 'ute.transferOfResponsibility.stepFour.controller',
                            templateUrl: 'module/transferOfResponsibility/stepFour/stepFour.view.html'
                        },
                        currentOwnerEligibilityResults: {
                            controllerName: '',
                            templateUrl: 'module/transferOfResponsibility/torTemplates/tor.currentOwnerEligibilityResults.html'
                        },
                        futureOwnerEligibilityResults: {
                            controllerName: '',
                            templateUrl: 'module/transferOfResponsibility/torTemplates/tor.futureOwnerEligibilityResults.html'
                        },
                        currentOwnerConfirmation: {
                            templateUrl: 'module/transferOfResponsibility/torTemplates/tor.currentOwnerConfirmation.html'
                        },
                        currentOwnerInformation: {
                            templateUrl: 'module/transferOfResponsibility/torTemplates/tor.currentOwnerInformation.html'
                        },
                        futureOwnerInfoForm: {
                            templateUrl: 'module/transferOfResponsibility/torTemplates/futureOwnerInfoForm.html'
                        },
                        addAnotherCtnModal: {
                            controllerName: 'ute.transferOfResponsibility.addAnotherCtn.modal.controller',
                            templateUrl: 'module/transferOfResponsibility/transferOfResponsibilityDirective/tor.addAnotherCtn.modal.view.html'
                        },
                        futureOwnerFinalConfirmation: {
                            templateUrl: 'module/transferOfResponsibility/torTemplates/tor.futureOwnerFinalConfirmation.html'
                        },
                        errorModal: {
                            controllerName: 'ute.transferOfResponsibility.systemException.modal.controller',
                            templateUrl: 'module/transferOfResponsibility/transferOfResponsibilityDirective/tor.systemException.modal.view.html'
                        },
                        stepTracker: {
                            controllerName: 'ute.transferOfResponsibility.TORStepTracker.controller',
                            templateUrl: 'module/transferOfResponsibility/transferOfResponsibilityDirective/tor.stepTracker.directive.html'
                        }
                    }
                };
                /* @ngInject */
                this.$get = function ($injector, $state, $http, $stateParams, sessionStorage) {
                    _this.encryptionService = $injector.get('ute.common.encryption.service');
                    _this.userService = $injector.get('ute.common.user.service');
                    _this.securityService = $injector.get('ute.common.security.service');
                    _this.$state = $state;
                    _this.$http = $http;
                    _this.$stateParams = $stateParams;
                    _this.sessionStorage = sessionStorage;
                    return {
                        getConfig: _this.getConfig,
                        goToEntryState: _this.goToEntryState,
                        getEntryState: _this.getEntryState,
                        getCtnList: _this.getCtnList,
                        getAccountNumber: _this.getAccountNumber,
                        isEligibilityCheckCallInProgress: _this.isEligibilityCheckCallInProgressFn,
                        getUser: _this.userService.getUser,
                        goToState: _this.goToState,
                        cancelTranferOfResponsibility: _this.cancelTranferOfResponsibility,
                        resetModel: _this.resetModel,
                        getModel: _this.getModel,
                        setBANEligibility: _this.setBANEligibility,
                        resetCtnList: _this.resetCtnList,
                        setModel: _this.setModel,
                        getScreenName: _this.getScreenName,
                        getDate: _this.getDate,
                        setStepTrackerIndex: _this.setStepTrackerIndex,
                        getRequestedAccountNumber: _this.getRequestedAccountNumber
                    };
                };
                /**
                 * @param config
                 * @returns {boolean}
                 */
                this.configure = function (config) {
                    _this.config = _.merge(_this.config, config);
                    if (_.isEmpty(_this.config.basic.medium)) {
                        console.error('medium:', 'Config Provider should override medium with vaid Medium');
                        return false;
                    }
                    return true;
                };
                // TODO getDateAfterNoOfDays
                this.getDate = function (noOfDays) {
                    var todayDate = new Date();
                    var finalDate;
                    if (noOfDays > 0) {
                        finalDate = todayDate.setDate(todayDate.getDate() + noOfDays);
                    }
                    else {
                        finalDate = todayDate;
                    }
                    return finalDate; // TODO Ternaryoperator
                };
                /**
                 * @returns {void}
                 */
                // TODO change name from setModel to updateModel
                this.setStepTrackerIndex = function (index) {
                    _this.model.stepTrackerIndex = index;
                };
                /**
                 * @returns {void}
                 */
                // TODO change name from setModel to updateModel
                this.setModel = function (modelObject) {
                    _this.model = modelObject;
                };
                /**
                 * @returns {ITORCtnDetails}
                 */
                this.getCtnList = function () {
                    return _this.model.ctnList;
                };
                this.isEligibilityCheckCallInProgressFn = function () {
                    return _this.isEligibilityCheckCallInProgress;
                };
                /**
                 * @returns {string}
                 */
                this.getScreenName = function () {
                    return 'tor';
                };
                /**
                 * @returns {any}
                 */
                this.getConfig = function () {
                    return angular.copy(_this.config);
                };
                /**
                 * @returns {string}
                 */
                this.getEntryState = function () {
                    return _this.config.basic.torRootState + '.' + _this.config.advanced.selectTransferOfResponsibility.subState;
                };
                /**
                 * @param input
                 * @returns {angular.IPromise<any>}
                 */
                this.goToEntryState = function (input) {
                    if (input) {
                        _this.model.accountNumber = input.accountNumber;
                        _this.model.ctnList = input.ctnList;
                        return _this.encryptionService.encrypt(input).then(function (id) {
                            return _this.$state.go(_this.getEntryState(), { id: id });
                        });
                    }
                };
                /**
                 * @param module
                 * @returns {angular.IPromise<any>}
                 */
                this.goToState = function (state) {
                    var statePath = _this.config.basic.torRootState + '.' + state;
                    if (state === _this.config.basic.torRootState) {
                        statePath = _this.config.basic.torRootState + '.' + _this.config.advanced.selectTransferOfResponsibility.subState;
                    }
                    return _this.encryptionService.encrypt(_this.model).then(function (id) {
                        return _this.$state.go(statePath, {
                            id: id
                        });
                    });
                };
                /**
                 * Return immutable ITransferOfResponsibilityModel object
                 * @returns {ITransferOfResponsibilityModel}
                 */
                this.getModel = function () {
                    return _this.model;
                };
                /**
                 * @param ctnList - ctnList
                 */
                this.setBANEligibility = function (banEligibility) {
                    _this.model.isBANEligible = banEligibility;
                };
                /**
                 * cancel transfer of responsibility Wizard and naviagte to the 'start' state
                 * @returns {angular.IPromise<any>}
                 */
                this.cancelTranferOfResponsibility = function () {
                    _this.resetCtnList();
                    return _this.goToState(_this.getConfig().basic.torRootState);
                };
                /**
                 * Reset model to initial state
                 */
                this.resetModel = function () {
                    _this.model = {
                        accountNumber: '',
                        ctnList: [],
                        stepTrackerIndex: 0,
                        sourceAccountInfo: {
                            firstName: '',
                            lastName: '',
                            securityCode: '',
                            accountNumber: '',
                            subscriberNumber: '',
                            isSourceBANEligible: null,
                            isSourceCtnEligible: null,
                            reasonCodes: [],
                            isCtnFound: null,
                            banReasonCodes: [],
                            expiryDate: ''
                        },
                        isBANEligible: null,
                        banReasonCodes: [],
                        selectedCtnList: []
                    };
                };
                this.getAccountNumber = function () {
                    return _this.sessionStorage.getSessionStorageValue('accountNumber');
                };
                this.getRequestedAccountNumber = function () {
                    return _this.sessionStorage.getSessionStorageValue('requestedAccountNumber');
                };
                /**
                 * @returns {void}
                 */
                this.resetCtnList = function () {
                    var ctnList = _this.model.ctnList;
                    var localAccountNumber = _this.model.accountNumber;
                    for (var _i = 0, ctnList_1 = ctnList; _i < ctnList_1.length; _i++) {
                        var ctn = ctnList_1[_i];
                        ctn.isEligible = null;
                        ctn.isSelected = null;
                    }
                    _this.model = {
                        stepTrackerIndex: _this.model.stepTrackerIndex,
                        ctnList: ctnList,
                        accountNumber: localAccountNumber,
                        sourceAccountInfo: {
                            firstName: '',
                            lastName: '',
                            securityCode: '',
                            accountNumber: '',
                            subscriberNumber: '',
                            isSourceBANEligible: null,
                            isSourceCtnEligible: null,
                            reasonCodes: [],
                            isCtnFound: null,
                            banReasonCodes: [],
                            expiryDate: ''
                        },
                        isBANEligible: null,
                        banReasonCodes: [],
                        selectedCtnList: []
                    };
                };
                this.$get.$inject = [
                    '$injector',
                    '$state',
                    '$http',
                    '$stateParams',
                    'sessionStorage'
                ];
                this.resetModel();
            }
            ;
            TransferOfResponsibilityProvider.$inject = [];
            return TransferOfResponsibilityProvider;
        }());
        angular.module('ute.transferOfResponsibility').provider('ute.transferOfResponsibility.service', TransferOfResponsibilityProvider);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var DataService = (function () {
                /* @ngInject */
                function DataService($q, exception, logger) {
                    var _this = this;
                    this.$q = $q;
                    this.exception = exception;
                    this.logger = logger;
                    this.ready = function (promises) {
                        return _this.readyForAny(promises);
                    };
                    this.readyForAny = function (promises) {
                        return _this.getReady().then(function () {
                            return promises ? _this.$q.all(promises) : _this.readyPromise;
                        }).catch(_this.exception.catcher('"ready" function failed'));
                    };
                    this.getReady = function () {
                        if (!_this.readyPromise) {
                            // Apps often pre-fetch session data ("prime the app")
                            // before showing the first view.
                            // This app doesn't need priming but we add a
                            // no-op implementation to show how it would work.
                            _this.logger.info('Primed the app data');
                            _this.readyPromise = _this.$q.when(_this);
                        }
                        return _this.readyPromise;
                    };
                }
                DataService.$inject = ['$q', 'ute.blocks.exceptionService', 'ute.blocks.loggerService'];
                return DataService;
            }());
            angular.module('ute.blocks.router').service('ute.blocks.router.dataservice', DataService);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var blocks;
    (function (blocks) {
        var router;
        (function (router) {
            'use strict';
            var RouterHelperProvider = (function () {
                /* @ngInject */
                function RouterHelperProvider($stateProvider, $urlRouterProvider) {
                    var _this = this;
                    this.$stateProvider = $stateProvider;
                    this.$urlRouterProvider = $urlRouterProvider;
                    this.config = {
                        docTitle: undefined
                    };
                    this.hasOtherwise = false;
                    this.handlingStateChangeError = false;
                    this.stateCounts = { errors: 0, changes: 0 };
                    this.resolveAlways = [];
                    this.globalTransitionHandlers = { from: [], to: [] };
                    /* @ngInject */
                    this.$get = function ($location, $rootScope, $state, $injector, $translate) {
                        _this.$location = $location;
                        _this.$rootScope = $rootScope;
                        _this.$translate = $translate;
                        _this.$state = $state;
                        _this.logger = $injector.get('ute.blocks.loggerService');
                        _this.handleRoutingErrors();
                        _this.handleStateChanges();
                        _this.handleLangChanges();
                        _this.handleStateChangeStart();
                        return {
                            configureStates: _this.configureStates.bind(_this),
                            registerFromStateHandler: _this.registerFromStateHandler.bind(_this),
                            registerToStateHandler: _this.registerToStateHandler.bind(_this),
                            registerGlobalFromStateHandler: _this.registerGlobalFromStateHandler.bind(_this),
                            registerGlobalToStateHandler: _this.registerGlobalToStateHandler.bind(_this),
                            getCountFromStateHandlers: _this.getCountFromStateHandlers.bind(_this),
                            getCountToStateHandlers: _this.getCountToStateHandlers.bind(_this),
                            when: _this.when.bind(_this),
                            getState: function (state) { return _this.$state.get(state); },
                            getCurrentState: function () { return _this.currentState; },
                            getStates: function () { return _this.$state.get(); }
                        };
                    };
                    this.when = function (whenPath, toPath) {
                        return _this.$urlRouterProvider.when(whenPath, toPath);
                    };
                    this.configure = function (config) {
                        angular.extend(_this.config, config);
                        if (!_this.config.resolveAlways) {
                            // TODO this is not working
                            _this.config.resolveAlways = {
                                /* @ngInject */
                                ready: ['ute.blocks.router.dataservice', function (dataservice) {
                                        var tmp = {};
                                        this.resolveAlways.forEach(function (e) {
                                            tmp = _.merge(tmp, e());
                                        });
                                        return dataservice.ready(tmp);
                                    }]
                            };
                        }
                        return true;
                    };
                    this.addToResolveAlways = function (resolveCallback) {
                        _this.resolveAlways.push(resolveCallback);
                    };
                    //$locationProvider.html5Mode(true);
                    this.configureStates = function (states, otherwisePath) {
                        states.forEach(function (state) {
                            if (!state.abstract) {
                                state.resolve = angular.extend(state.resolve || {}, _this.config.resolveAlways || {});
                                // TODO define 'ready' in constants
                                _.forEach(state.resolve, function (val, key) {
                                    if (key !== 'ready' && angular.isObject(_this.config.resolveAlways) && _.isArray(val)) {
                                        val.splice(val.length - 1, 0, 'ready');
                                    }
                                });
                            }
                            _this.$stateProvider.state(state);
                        });
                        if (otherwisePath && !_this.hasOtherwise) {
                            _this.hasOtherwise = true;
                            _this.$urlRouterProvider.otherwise(otherwisePath);
                        }
                    };
                    this.registerStateHandler = function (fromTo, stateName, si) {
                        var state = _this.$state.get(stateName);
                        if (state) {
                            state.data = (state.data || {});
                            var transitionHandlers = state.data.$transitionHandlers = (state.data.$transitionHandlers || {
                                from: [],
                                to: []
                            });
                            transitionHandlers[fromTo].push(si);
                            // TODO upgrade to lodash 4.x
                            // state.data.$transitionHandlers[fromTo] = _.orderBy/*<IStateHandler>*/(transitionHandlers[fromTo], ['priority'], ['desc']);
                            state.data.$transitionHandlers[fromTo] = _.sortBy(transitionHandlers[fromTo], 'priority').reverse();
                        }
                        else {
                            _this.logger.info('not able to find state "' + stateName + '"');
                        }
                        //this.logger.info('state "' + stateName + '" has ' + transitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerGlobalStateHandler = function (fromTo, stateHandler) {
                        _this.globalTransitionHandlers[fromTo].push(stateHandler);
                        // this.globalTransitionHandlers[fromTo] = _.chain<IStateHandler>(this.globalTransitionHandlers[fromTo]).sortBy(['priority']).value().reverse();
                        _this.globalTransitionHandlers[fromTo] = _.sortBy(_this.globalTransitionHandlers[fromTo], 'priority').reverse();
                        //this.logger.info('global has ' + this.globalTransitionHandlers[fromTo].length + ' "' + fromTo + '" transition handlers');
                    };
                    this.registerFromStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('from', stateName, stateHandler);
                        }
                    };
                    this.registerToStateHandler = function (stateName, stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerStateHandler('to', stateName, stateHandler);
                        }
                    };
                    this.registerGlobalFromStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('from', stateHandler);
                        }
                    };
                    this.registerGlobalToStateHandler = function (stateHandler, priority) {
                        if (priority === void 0) { priority = router.StateHandlerPriority.MEDIUM; }
                        if (angular.isObject(stateHandler)) {
                            stateHandler.priority = stateHandler.priority || priority;
                            _this.registerGlobalStateHandler('to', stateHandler);
                        }
                    };
                    this.getCountFromStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.from.length : 0;
                    };
                    this.getCountToStateHandlers = function (stateName) {
                        var state = _this.$state.get(stateName);
                        return state ? state.data.$transitionHandlers.to.length : 0;
                    };
                    this.handleRoutingErrors = function () {
                        //TODO: must inject $state so we can kick off routing
                        // Route cancellation:
                        // On routing error, go to the dashboard.
                        // Provide an exit clause if it tries to do it twice.
                        _this.$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
                            if (_this.handlingStateChangeError) {
                                return;
                            }
                            _this.stateCounts.errors++;
                            _this.handlingStateChangeError = true;
                            var destination = (toState &&
                                (toState.name || toState.loadedTemplateUrl)) ||
                                'unknown target';
                            var msg = 'Error routing to ' + destination + '. ' +
                                (_.get(error, 'data') || '') + '. <br/>' + (error.statusText || '') +
                                ': ' + (error.status || '');
                            _this.logger.warning(msg, toState);
                            // TODO from settings
                            //this.$location.path('/');
                        });
                    };
                    this.handleStateChangeStart = function () {
                        _this.$rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                            // var promise = funcs[0](input);
                            // for (var i = 1; i < funcs.length; i++)
                            //   promise = promise.then(funcs[i]);
                            // funcs.reduce(function(prev, cur) {
                            //   return prev.then(cur);
                            // }, starting_promise);
                            (_this.globalTransitionHandlers.from).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.from:', e.message);
                                    return true;
                                }
                            });
                            (_this.globalTransitionHandlers.to).every(function (handler) {
                                try {
                                    return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                }
                                catch (e) {
                                    _this.logger.error('Exception catch during call stateTransitionHandler on globalTransitionHandlers.to:', e.message);
                                    return true;
                                }
                            });
                            if (_.get(fromState, 'data.$transitionHandlers.from')) {
                                (fromState.data.$transitionHandlers.from).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.from:', e.message);
                                        return true;
                                    }
                                });
                            }
                            if (_.get(toState, 'data.$transitionHandlers.to')) {
                                (toState.data.$transitionHandlers.to).every(function (handler) {
                                    try {
                                        return handler.stateTransitionHandler(event, toState, toParams, fromState, fromParams);
                                    }
                                    catch (e) {
                                        _this.logger.error('Exception catch during call stateTransitionHandler on $transitionHandlers.to:', e.message);
                                        return true;
                                    }
                                });
                            }
                        });
                    };
                    this.handleStateChanges = function () {
                        _this.$rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
                            _this.stateCounts.changes++;
                            _this.handlingStateChangeError = false;
                            _this.currentState = toState;
                            if (toState.data && toState.data.title) {
                                _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant(toState.data.title) || '');
                            } // data bind to <title>
                        });
                    };
                    this.handleLangChanges = function () {
                        _this.$rootScope.$on('$translateChangeSuccess', function () {
                            _this.$rootScope.title = _this.config.docTitle + ' ' + (_this.$translate.instant((_.get(_this.$state, 'current.data.title'))) || ''); // data bind to <title>
                        });
                    };
                    this.$get.$inject = [
                        '$location',
                        '$rootScope',
                        '$state',
                        '$injector',
                        '$translate'
                    ];
                }
                RouterHelperProvider.$inject = ['$stateProvider', '$urlRouterProvider'];
                return RouterHelperProvider;
            }());
            angular.module('ute.blocks.router').provider('ute.blocks.router', RouterHelperProvider);
        })(router = blocks.router || (blocks.router = {}));
    })(blocks = ute.blocks || (ute.blocks = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var bfa;
    (function (bfa) {
        var ppc;
        (function (ppc) {
            'use strict';
            var IBFAPPCErrorsModalCtrl = (function () {
                function IBFAPPCErrorsModalCtrl($scope, $state, $translate, $modalInstance, params) {
                    this.$scope = $scope;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.$modalInstance = $modalInstance;
                    this.params = params;
                    $scope.showCancelBtn = false;
                    $scope.showOKBtn = false;
                    $scope.showConfirmBtn = false;
                    $scope.showContinueBtn = false;
                    $scope.showRemoveAddOnBtn = false;
                    $scope.showGoBackBtn = false;
                    $scope.showConfirmPlanChangeBtn = false;
                    $scope.showLiveChat = params.showLiveChat;
                    $scope.isSuspended = params.isSuspended;
                    $scope.message = params.message;
                    $scope.title = params.title;
                    this.$scope = $scope;
                    this.init();
                }
                IBFAPPCErrorsModalCtrl.prototype.setStaticChatButtonValues = function () {
                    if (this.$translate.use() === 'en') {
                        this.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc';
                        this.boldChatButtonDiv = 'changePlan-en';
                        this.boldChatButton = 'chatButtonChangePlanEn';
                    }
                    else {
                        this.boldChatButtonId = 'S_MRog_Wless_ChngePlnPpc_Fr';
                        this.boldChatButtonDiv = 'changePlan-fr';
                        this.boldChatButton = 'chatButtonChangePlanFr';
                    }
                };
                IBFAPPCErrorsModalCtrl.prototype.ok = function () {
                    this.$modalInstance.close();
                    if (this.params.redirect && this.params.redirect.goBack) {
                        this.$state.go(this.params.redirect.goBack);
                    }
                };
                ;
                IBFAPPCErrorsModalCtrl.prototype.okAndGoBack = function () {
                    this.$modalInstance.close();
                    if (this.params.redirect && this.params.redirect.goBack) {
                        this.$state.go(this.params.redirect.goBack);
                    }
                };
                IBFAPPCErrorsModalCtrl.prototype.removeAddOn = function () {
                    this.$modalInstance.close(true);
                };
                IBFAPPCErrorsModalCtrl.prototype.cancel = function () {
                    this.$modalInstance.close(false);
                    if (this.params.redirect && this.params.redirect.goBack) {
                        this.$state.go(this.params.redirect.goBack);
                    }
                };
                IBFAPPCErrorsModalCtrl.prototype.continue = function () {
                    this.$modalInstance.close(true);
                    if (this.params.redirect && this.params.redirect.goForward) {
                        this.$state.go(this.params.redirect.goForward, {}, { reload: this.params.reload });
                    }
                };
                IBFAPPCErrorsModalCtrl.prototype.confirm = function () {
                    this.$modalInstance.close(true);
                    if (this.params.redirect && this.params.redirect.goForward) {
                        this.$state.go(this.params.redirect.goForward);
                    }
                    else if (this.params.redirect && typeof this.params.redirect.sendCallback === 'function') {
                        this.params.redirect.sendCallback();
                    }
                };
                IBFAPPCErrorsModalCtrl.prototype.init = function () {
                    console.log(this.params);
                    var _length = this.params.buttons.length;
                    for (var i = 0; i < _length; i++) {
                        switch (this.params.buttons[i]) {
                            case 'OK':
                                this.$scope.showOKBtn = true;
                                break;
                            case 'Cancel':
                                this.$scope.showCancelBtn = true;
                                break;
                            case 'Confirm':
                                this.$scope.showConfirmBtn = true;
                                break;
                            case 'ConfirmPlanChange':
                                this.$scope.showConfirmPlanChangeBtn = true;
                                break;
                            case 'Continue':
                                this.$scope.showContinueBtn = true;
                                break;
                            case 'RemoveAddOn':
                                this.$scope.showRemoveAddOnBtn = true;
                                break;
                            case 'GO_BACK':
                                this.$scope.showGoBackBtn = true;
                                break;
                        }
                    }
                    if (!this.params.isSuspended) {
                        switch (this.$translate.use()) {
                            case 'en':
                                this.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                                break;
                            case 'fr':
                                this.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                                break;
                        }
                    }
                    else {
                        switch (this.$translate.use()) {
                            case 'en':
                                this.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=204&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en';
                                break;
                            case 'fr':
                                this.liveChatLink = 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=254&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr';
                                break;
                        }
                    }
                    this.setStaticChatButtonValues();
                };
                IBFAPPCErrorsModalCtrl.$inject = ['$scope', '$state', '$translate', '$modalInstance', 'params'];
                return IBFAPPCErrorsModalCtrl;
            }());
            ppc.IBFAPPCErrorsModalCtrl = IBFAPPCErrorsModalCtrl;
            angular.module('ute.bfa.ppc').controller('ute.bfa.ppc.errors.modalCtrl', IBFAPPCErrorsModalCtrl);
        })(ppc = bfa.ppc || (bfa.ppc = {}));
    })(bfa = ute.bfa || (ute.bfa = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureDealerCodeFormController = (function () {
                    /* @ngInject */
                    function CaptureDealerCodeFormController(captureDealerCodeService) {
                        var _this = this;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.onDealerCodeInputChange = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSuccess = false;
                        };
                    }
                    CaptureDealerCodeFormController.$inject = ['ute.capture.dealer.code.service'];
                    return CaptureDealerCodeFormController;
                }());
                angular.module('ute.capture.dealer.code').controller('ute.capture.dealer.code.form.controller', CaptureDealerCodeFormController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureDealerCodeForm = (function () {
                    function CaptureDealerCodeForm(captureDealerCodeService) {
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.restrict = 'E';
                        this.scope = { 'submit': '&', 'isDealerCodeError': '=', 'dealerCode': '=', 'isDealerCodeSuccess': '=', 'onDealerCodeInputChange': '&', 'dealerCodePlaceholder': '@' };
                        this.templateUrl = this.captureDealerCodeService.getConfig().advanced.captureDealerCodeFormDirective.templateUrl;
                        this.controller = this.captureDealerCodeService.getConfig().advanced.captureDealerCodeFormDirective.controllerName;
                        this.controllerAs = 'dealerCodeForm';
                    }
                    CaptureDealerCodeForm.factory = function () {
                        var directive = function (captureDealerCodeService) { return new CaptureDealerCodeForm(captureDealerCodeService); };
                        directive.$inject = ['ute.capture.dealer.code.service'];
                        return directive;
                    };
                    return CaptureDealerCodeForm;
                }());
                angular.module('ute.capture.dealer.code').directive('uteCaptureDealerCodeForm', CaptureDealerCodeForm.factory());
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureBehalfOfDealerCodeController = (function () {
                    /* @ngInject */
                    function CaptureBehalfOfDealerCodeController(captureDealerCodeService, userService, messagesService, permissionsService, languageService) {
                        var _this = this;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.userService = userService;
                        this.messagesService = messagesService;
                        this.permissionsService = permissionsService;
                        this.languageService = languageService;
                        this.showToolTip = false;
                        this.submitBehalfDealerCode = function () {
                            _this.captureDealerCodeService.submitToSessionTable(_this.behalfDealerCode).then(function (result) {
                                if (result === true) {
                                    _this.isBehalfOfDealerCode = true;
                                }
                                else if (result === false) {
                                    _this.isDealerCodeError = true;
                                }
                                else {
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.edit = function () {
                            _this.isBehalfOfDealerCode = false;
                            _this.isDealerCodeSubmitted = false;
                        };
                        this.useMyCode = function () {
                            var storedDC = _this.captureDealerCodeService.getModel().storedDealerCode;
                            if (storedDC && storedDC !== '') {
                                _this.captureDealerCodeService.saveDealerCode(storedDC).then(function (result) {
                                    if (result !== false) {
                                        _this.isBehalfOfDealerCode = false;
                                        _this.behalfDealerCode = '';
                                        _this.isDealerCodeSubmitted = false;
                                    }
                                    else {
                                        _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                    }
                                });
                            }
                        };
                        this.enableSubmitButton = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSubmitted = false;
                        };
                        this.toggleToolTip = function () {
                            (_this.showToolTip === true) ? _this.showToolTip = false : _this.showToolTip = true;
                        };
                        if (this.userService.getUserType() === 'care') {
                            this.captureDealerCodeService.retrieveDealerCode(code.Flows.ONEVIEW);
                        }
                        this.lang = this.captureDealerCodeService.getLanguage();
                        this.messagesService.register('ute-capture-DC-on-header', function (data, val) { return _this.updateDCOnHeader(val); });
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.lang = lang;
                            return null;
                        }, 'ute.capture.dealer.code.behalf.controller');
                    }
                    /*    closeToolTip: () => void = () => {
                          this.showToolTip = false;
                        };*/
                    CaptureBehalfOfDealerCodeController.prototype.updateDCOnHeader = function (val) {
                        this.isDealerCodeModalEntered = true;
                        this.isBehalfOfDealerCode = false;
                        this.behalfDealerCode = '';
                        if (this.captureDealerCodeService.isDealerCodeExist()) {
                            if (val && val !== '') {
                                this.isBehalfOfDealerCode = true;
                                this.behalfDealerCode = val;
                            }
                            this.isDealerCodeSubmitted = true;
                        }
                    };
                    ;
                    CaptureBehalfOfDealerCodeController.$inject = [
                        'ute.capture.dealer.code.service',
                        'ute.common.user.service',
                        'ute.blocks.messages.bus.service',
                        'ute.common.permissions.service',
                        'ute.blocks.language.switcher'
                    ];
                    return CaptureBehalfOfDealerCodeController;
                }());
                angular.module('ute.capture.dealer.code').controller('ute.capture.dealer.code.behalf.controller', CaptureBehalfOfDealerCodeController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureBehalfOfDealerCode = (function () {
                    function CaptureBehalfOfDealerCode(captureDealerCodeService) {
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.restrict = 'E';
                        this.templateUrl = this.captureDealerCodeService.getConfig().advanced.onBehalfOfDealerCodeDirective.templateUrl;
                        this.controller = this.captureDealerCodeService.getConfig().advanced.onBehalfOfDealerCodeDirective.controllerName;
                        this.controllerAs = 'behalfOfDC';
                    }
                    CaptureBehalfOfDealerCode.factory = function () {
                        var directive = function (captureDealerCodeService) { return new CaptureBehalfOfDealerCode(captureDealerCodeService); };
                        directive.$inject = ['ute.capture.dealer.code.service'];
                        return directive;
                    };
                    return CaptureBehalfOfDealerCode;
                }());
                angular.module('ute.capture.dealer.code').directive('uteCaptureBehalfOfDealerCode', CaptureBehalfOfDealerCode.factory());
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var UpdateDealerCodeController = (function () {
                    /* @ngInject */
                    function UpdateDealerCodeController(captureDealerCodeService, messagesService, $translate) {
                        var _this = this;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.messagesService = messagesService;
                        this.$translate = $translate;
                        this.updatedDealerCode = null;
                        this.submit = function () {
                            _this.captureDealerCodeService.submit(_this.dealerCode).then(function (result) {
                                if (result === true) {
                                    _this.isDealerCodeSuccess = true;
                                    _this.displayChangeDC = false;
                                }
                                else if (result === false) {
                                    _this.isDealerCodeError = true;
                                }
                                else {
                                    _this.displayChangeDC = false;
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.onDealerCodeInputChange = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSuccess = false;
                        };
                        this.lang = this.captureDealerCodeService.getLanguage();
                        this.dealerCodePlaceholder = this.$translate.instant('ute.rogers.captureDealerCode.dealerCode');
                        this.messagesService.register('ute-capture-DC-at-repName', function (data, val) { return _this.updateDCAtRepName(val); });
                    }
                    UpdateDealerCodeController.prototype.updateDCAtRepName = function (val) {
                        this.isDCModalEntered = true;
                        if (this.captureDealerCodeService.isDealerCodeExist()) {
                            this.updatedDealerCode = val;
                        }
                        else {
                            this.updatedDealerCode = null;
                        }
                    };
                    ;
                    UpdateDealerCodeController.$inject = [
                        'ute.capture.dealer.code.service',
                        'ute.blocks.messages.bus.service',
                        '$translate'
                    ];
                    return UpdateDealerCodeController;
                }());
                angular.module('ute.capture.dealer.code').controller('ute.capture.dealer.code.update.controller', UpdateDealerCodeController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var UpdateDealerCode = (function () {
                    function UpdateDealerCode(captureDealerCodeService, $document) {
                        var _this = this;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.$document = $document;
                        this.restrict = 'E';
                        this.templateUrl = this.captureDealerCodeService.getConfig().advanced.updateDealerCodeDirective.templateUrl;
                        this.controller = this.captureDealerCodeService.getConfig().advanced.updateDealerCodeDirective.controllerName;
                        this.controllerAs = 'updateDealerCode';
                        this.linkFn = function (scope, element, attrs, controller) {
                            scope.displayChangeDC = controller.displayChangeDC = false;
                            controller.openChangeDC = function () {
                                controller.lang = this.captureDealerCodeService.getLanguage();
                                controller.displayChangeDC = !controller.displayChangeDC;
                            };
                            _this.$document.bind('click', function (event) {
                                var isClickedElementChildOfPopup = element
                                    .find(event.target)
                                    .length > 0;
                                if (isClickedElementChildOfPopup) {
                                    return;
                                }
                                controller.displayChangeDC = false;
                                scope.$apply();
                            });
                        };
                        this.link = this.linkFn;
                    }
                    UpdateDealerCode.factory = function () {
                        var directive = function (captureDealerCodeService, $document) { return new UpdateDealerCode(captureDealerCodeService, $document); };
                        directive.$inject = ['ute.capture.dealer.code.service', '$document'];
                        return directive;
                    };
                    return UpdateDealerCode;
                }());
                angular.module('ute.capture.dealer.code').directive('uteUpdateDealerCode', UpdateDealerCode.factory());
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureNacDealerCodeModalController = (function () {
                    /* @ngInject */
                    function CaptureNacDealerCodeModalController($scope, $modalInstance, captureDealerCodeService, sessionStorage) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.sessionStorage = sessionStorage;
                        this.close = function () {
                            _this.$modalInstance.close('ok');
                        };
                        this.onDealerCodeInputChange = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSubmitted = false;
                        };
                        this.onEnter = function () {
                            _this.captureDealerCodeService.saveDealerCode(_this.storedDealerCode).then(function (result) {
                                if (result !== false) {
                                    _this.sessionStorage.setSessionStorageValue('dealerCode', _this.storedDealerCode);
                                    _this.$modalInstance.close('ok');
                                }
                                else {
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.submit = function () {
                            _this.captureDealerCodeService.submitToSessionTable(_this.dealerCode).then(function (result) {
                                if (result === true) {
                                    _this.sessionStorage.setSessionStorageValue('dealerCode', _this.dealerCode);
                                    _this.$modalInstance.close('ok');
                                }
                                else if (result === false) {
                                    _this.isDealerCodeError = true;
                                }
                                else {
                                    _this.$modalInstance.dismiss('no');
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.lang = this.captureDealerCodeService.getLanguage();
                        this.storedDealerCode = this.captureDealerCodeService.getModel().storedDealerCode;
                        this.isDealerCodeSubmitted = true;
                    }
                    CaptureNacDealerCodeModalController.$inject = ['$scope',
                        '$modalInstance',
                        'ute.capture.dealer.code.service',
                        'sessionStorage'
                    ];
                    return CaptureNacDealerCodeModalController;
                }());
                angular.module('ute.capture.dealer.code').controller('capture.nac.dealer.code.modal.controller', CaptureNacDealerCodeModalController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureDealerCodeErrorModalController = (function () {
                    /* @ngInject */
                    function CaptureDealerCodeErrorModalController($scope, $modalInstance, captureDealerCodeService) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.cancel = function () {
                            if (!_this.isNacFlow()) {
                                _this.$modalInstance.dismiss('cancel');
                            }
                        };
                        this.isNacFlow = function () {
                            return _this.captureDealerCodeService.getModel().isNacFlow;
                        };
                    }
                    CaptureDealerCodeErrorModalController.$inject = ['$scope',
                        '$modalInstance',
                        'ute.capture.dealer.code.service'];
                    return CaptureDealerCodeErrorModalController;
                }());
                angular.module('ute.capture.dealer.code').controller('capture.dealer.code.error.modal.controller', CaptureDealerCodeErrorModalController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var CaptureDealerCodeModalController = (function () {
                    /* @ngInject */
                    function CaptureDealerCodeModalController($scope, $modalInstance, captureDealerCodeService, $translate, languageService) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.$translate = $translate;
                        this.languageService = languageService;
                        this.cancel = function () {
                            if (!_this.isNacFlow()) {
                                if (_this.doNotShowDCModalAgain) {
                                    _this.captureDealerCodeService.updateUserPreferenceTable('displayDealerCodePopUp', false).then(function (result) {
                                        if (result === false) {
                                            _this.$modalInstance.close('no');
                                            _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                        }
                                        else {
                                            _this.$modalInstance.dismiss('cancel');
                                        }
                                    });
                                }
                                else {
                                    _this.$modalInstance.dismiss('cancel');
                                }
                            }
                        };
                        this.isNacFlow = function () {
                            return _this.captureDealerCodeService.getModel().isNacFlow;
                        };
                        this.showMessage = function (checkedStatus) {
                            _this.doNotShowDCModalAgain = checkedStatus;
                        };
                        this.submit = function () {
                            _this.captureDealerCodeService.submit(_this.dealerCode).then(function (result) {
                                if (result === true) {
                                    _this.isDealerCodeSuccess = true;
                                    _this.$modalInstance.close('ok');
                                }
                                else if (result === false) {
                                    _this.isDealerCodeError = true;
                                }
                                else {
                                    _this.$modalInstance.close('no');
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.onDealerCodeInputChange = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSuccess = false;
                        };
                        //this.isNacFlow = this.captureDealerCodeService.getModel().isNacFlow;
                        this.lang = this.captureDealerCodeService.getLanguage();
                        this.dealerCodePlaceholder = this.$translate.instant('ute.rogers.captureDealerCode.enterDealerCode');
                    }
                    CaptureDealerCodeModalController.$inject = ['$scope',
                        '$modalInstance',
                        'ute.capture.dealer.code.service',
                        '$translate'];
                    return CaptureDealerCodeModalController;
                }());
                angular.module('ute.capture.dealer.code').controller('capture.dealer.code.modal.controller', CaptureDealerCodeModalController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var capture;
    (function (capture) {
        var dealer;
        (function (dealer) {
            var code;
            (function (code) {
                'use strict';
                var ProceedWithOutModalController = (function () {
                    /* @ngInject */
                    function ProceedWithOutModalController($scope, $modalInstance, captureDealerCodeService, $translate) {
                        var _this = this;
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.captureDealerCodeService = captureDealerCodeService;
                        this.$translate = $translate;
                        this.cancel = function () {
                            _this.$modalInstance.dismiss('cancel');
                        };
                        this.submit = function () {
                            _this.captureDealerCodeService.submit(_this.dealerCode).then(function (result) {
                                if (result === true) {
                                    _this.isDealerCodeSuccess = true;
                                    _this.$modalInstance.close('ok');
                                }
                                else if (result === false) {
                                    _this.isDealerCodeError = true;
                                }
                                else {
                                    _this.$modalInstance.dismiss('no');
                                    _this.captureDealerCodeService.showCaptureDealerCodeErrorModal();
                                }
                            });
                        };
                        this.onDealerCodeInputChange = function () {
                            _this.isDealerCodeError = false;
                            _this.isDealerCodeSuccess = false;
                        };
                        this.lang = this.captureDealerCodeService.getLanguage();
                        this.dealerCodePlaceholder = this.$translate.instant('ute.rogers.captureDealerCode.enterDealerCode');
                    }
                    ProceedWithOutModalController.$inject = ['$scope',
                        '$modalInstance',
                        'ute.capture.dealer.code.service',
                        '$translate'];
                    return ProceedWithOutModalController;
                }());
                angular.module('ute.capture.dealer.code').controller('proceed.with.out.dealer.code.modal.controller', ProceedWithOutModalController);
            })(code = dealer.code || (dealer.code = {}));
        })(dealer = capture.dealer || (capture.dealer = {}));
    })(capture = ute.capture || (ute.capture = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                keys: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.service = service;
                            this.$scope = $scope;
                            this.init = function () {
                                var keysArray = angular.isDefined(_this.$scope.keys) ? _this.$scope.keys.split(',').map(function (s) { return s.trim(); }) : [];
                                return _this.service.isSome(keysArray).then(function (result) { return _this.test = result; });
                            };
                            this.init();
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-any-brt keys='RAM, REGISTRATION'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfAnyBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var Test = (function (_super) {
                        __extends(Test, _super);
                        function Test() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.controller = Controller;
                        }
                        Test.factory = function () {
                            return function () { return new Test(); };
                        };
                        return Test;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfBrt', Test.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var common;
    (function (common) {
        var core;
        (function (core) {
            var brtswitch;
            (function (brtswitch) {
                var directives;
                (function (directives) {
                    'use strict';
                    var TestNot = (function (_super) {
                        __extends(TestNot, _super);
                        function TestNot() {
                            _super.call(this);
                            this.scope = {
                                key: '@'
                            };
                            this.template = '<span data-ng-if="!$ctrl.test"><ng-transclude></ng-transclude></span>';
                            this.controller = Controller;
                        }
                        TestNot.factory = function () {
                            return function () { return new TestNot(); };
                        };
                        return TestNot;
                    }(directives.TestAbstract));
                    var Controller = (function () {
                        /* @ngInject */
                        function Controller(service, $scope) {
                            var _this = this;
                            this.$scope = $scope;
                            this.test = true;
                            service.getValue(this.$scope.key).then(function (result) { return _this.test = result; });
                        }
                        Controller.$inject = ['ute.common.core.brtswitch.service', '$scope'];
                        return Controller;
                    }());
                    /**
                     * <ute-if-not-brt key='BSS_UCC_P1_BRT'> directive
                     */
                    angular.module('ute.common.core.brtswitch').directive('uteIfNotBrt', TestNot.factory());
                })(directives = brtswitch.directives || (brtswitch.directives = {}));
            })(brtswitch = core.brtswitch || (core.brtswitch = {}));
        })(core = common.core || (common.core = {}));
    })(common = ute.common || (ute.common = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var access;
                        (function (access) {
                            var off;
                            (function (off) {
                                'use strict';
                                var DataManagerAccountsSummaryDataAccessOffController = (function () {
                                    /* @ngInject */
                                    function DataManagerAccountsSummaryDataAccessOffController($document, $scope, dataManagerService) {
                                        this.$document = $document;
                                        this.$scope = $scope;
                                        this.dataManagerService = dataManagerService;
                                        this.getBan = dataManagerService.getAccountNumber;
                                        this.model = dataManagerService.getModel();
                                        this.scope = $scope;
                                        $document.scrollTop(0);
                                    }
                                    DataManagerAccountsSummaryDataAccessOffController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                                    return DataManagerAccountsSummaryDataAccessOffController;
                                }());
                                off.DataManagerAccountsSummaryDataAccessOffController = DataManagerAccountsSummaryDataAccessOffController;
                                angular.module('ute.data.manager.accounts.summary.data.access.off').controller('ute.data.manager.accounts.summary.data.access.off.directive.controller', DataManagerAccountsSummaryDataAccessOffController);
                            })(off = access.off || (access.off = {}));
                        })(access = data.access || (data.access = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var access;
                        (function (access) {
                            var off;
                            (function (off) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.data.access.off').directive('uteDataManagerAccountsSummaryDataAccessOff', uteDataManagerAccountsSummaryDataAccessOff);
                                uteDataManagerAccountsSummaryDataAccessOff.$inject = ['$window', 'ute.data.manager.service'];
                                /* @ngInject */
                                function uteDataManagerAccountsSummaryDataAccessOff($window, dataManagerService) {
                                    return {
                                        restrict: 'E',
                                        scope: { 'index': '@', 'dataAlertAt': '@', 'useAlert': '=' },
                                        templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAccessOffDirective.templateUrl,
                                        controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAccessOffDirective.controllerName,
                                        controllerAs: 'dataManagerAccountsSummaryDataAccessOff'
                                    };
                                }
                            })(off = access.off || (access.off = {}));
                        })(access = data.access || (data.access = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryDataAddedBarController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryDataAddedBarController($document, $scope, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryDataAddedBarController.prototype.getSavedAlertValue = function (index) {
                            return this.dataManagerService.getSavedAlertValue(index);
                        };
                        DataManagerAccountsSummaryDataAddedBarController.prototype.getBarPosition = function () {
                            return (this.scope.maxLimit - this.dataManagerService.getSavedAlertValue(this.scope.index)) * (this.scope.maxHeight / this.scope.maxLimit);
                        };
                        DataManagerAccountsSummaryDataAddedBarController.prototype.thumbDown = function () {
                            this.scope.dragging = true;
                        };
                        DataManagerAccountsSummaryDataAddedBarController.prototype.thumbUp = function () {
                            this.scope.dragging = false;
                        };
                        DataManagerAccountsSummaryDataAddedBarController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryDataAddedBarController;
                    }());
                    summary.DataManagerAccountsSummaryDataAddedBarController = DataManagerAccountsSummaryDataAddedBarController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.data.added.bar.directive.controller', DataManagerAccountsSummaryDataAddedBarController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryDataAddedBar', uteDataManagerAccountsSummaryDataAddedBar);
                    uteDataManagerAccountsSummaryDataAddedBar.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryDataAddedBar(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'height': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAddedBarDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAddedBarDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryDataAddedBar'
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var alert;
                        (function (alert) {
                            var at;
                            (function (at) {
                                'use strict';
                                // import IDataManagerServerGetUsageDetails = ute.data.manager.service.IDataManagerServerGetUsageDetails;
                                // import IDataManagerServerGetUsageDetailsWorker = ute.data.manager.service.IDataManagerServerGetUsageDetailsWorker;
                                // import IDataManagerServerGetUsageDetailsRequest = ute.data.manager.service.IDataManagerServerGetUsageDetailsRequest;
                                var DataManagerAccountsSummaryDataAlertAtController = (function () {
                                    /* @ngInject */
                                    function DataManagerAccountsSummaryDataAlertAtController($document, $scope, $rootScope, $modal, dataManagerService) {
                                        this.$document = $document;
                                        this.$scope = $scope;
                                        this.$rootScope = $rootScope;
                                        this.$modal = $modal;
                                        this.dataManagerService = dataManagerService;
                                        this.getBan = dataManagerService.getAccountNumber;
                                        this.model = dataManagerService.getModel();
                                        this.rootScope = $rootScope;
                                        this.scope = $scope;
                                        this.useAlert = true;
                                        $document.scrollTop(0);
                                    }
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.showDashNegativeAlert = function () {
                                        return (!this.isAlertMoved() && (this.scope.savedAlertValue < 0));
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.showDataValue = function () {
                                        return (this.isAlertMoved() || (this.scope.savedAlertValue >= 0));
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.isAlertMoved = function () {
                                        return this.dataManagerService.getAccountLineByCTN(this.scope.ctn).alertMoved;
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.getSavedAlertValue = function (index) {
                                        return this.dataManagerService.getSavedAlertValue(index);
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.getBarPosition = function () {
                                        return (this.scope.maxLimit - this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn))) * (this.scope.maxHeight / this.scope.maxLimit);
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.getSaveAlertCallInProgress = function () {
                                        return this.dataManagerService.getSaveAlertCallInProgress();
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                                        return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.getBase = function () {
                                        /*
                                          this.dataManagerService.getConfig().basic.dataConversionRoundValues
                                        */
                                        return (this.scope.dataAlertAt * 1 > 1024 ?
                                            this.dataManagerService.getConfig().basic.dataConversion :
                                            this.dataManagerService.getConfig().basic.dataConversionRoundValues) * 1;
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.useAlertChange = function ($event) {
                                        // var ctrl: any = this;
                                        var _this = this;
                                        this.dataManagerService.setDataAlertAPI(this.dataManagerService.getCTNByIndex(this.dataManagerService.getIndexByCTN(this.scope.ctn)), false, this.scope.savedAlertValue)
                                            .then(function (result) {
                                            if (result.data && result.data.body && result.data.body.isSuccess) {
                                                _this.dataManagerService.setDataUseAlert(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), false);
                                                _this.useAlert = true;
                                            }
                                            else {
                                                if (_this.useAlert) {
                                                    _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondaryUseAlertsOn');
                                                }
                                                else {
                                                    _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondaryUseAlertsOff');
                                                }
                                                _this.useAlert = !_this.useAlert;
                                            }
                                        })
                                            .catch(function () {
                                            if (_this.useAlert) {
                                                _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondaryUseAlertsOn');
                                            }
                                            else {
                                                _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondaryUseAlertsOff');
                                            }
                                            _this.useAlert = !_this.useAlert;
                                        });
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.errorModalPopup = function (primary, secondary) {
                                        var errorModalScope = this.rootScope.$new();
                                        errorModalScope.params = { primary: primary, secondary: secondary };
                                        this.$modal.open({
                                            windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                            templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                            controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                            controllerAs: 'dataManagerGenericModal',
                                            size: 'md',
                                            backdrop: 'static',
                                            scope: errorModalScope
                                        });
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.alertThresholdCheck = function () {
                                        if (this.dataManagerService.getSavedAlertedDataTotal() > this.dataManagerService.getDataLimit()) {
                                            this.alertsOverDataLimitModalPopup();
                                        }
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.alertsOverDataLimitModalPopup = function () {
                                        this.$modal.open({
                                            windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.windowTemplateUrl,
                                            templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.templateUrl,
                                            controller: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.controllerName,
                                            controllerAs: 'dataManagerAlertsOverDataLimitModal',
                                            size: 'md',
                                            backdrop: 'static'
                                        }).result.then(function (result) {
                                            // Result selection behaviour
                                            switch (result) {
                                                case 'yes':
                                                    break;
                                                case 'no':
                                                    break;
                                            }
                                        }, function () {
                                            // Dismiss behaviour
                                            // Do nothing/close
                                        });
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.saveAlertChange = function ($event) {
                                        var _this = this;
                                        // var ctrl: any = this;
                                        // var value: number = this.scope.dataAlertAt > 1000 ? Math.round(this.scope.dataAlertAt * 1) / 1000 * 1024 : this.scope.dataAlertAt;//this.scope.dataAlertAt * 1 < this.getBase() ? Math.round(this.scope.dataAlertAt * 1) : Math.round(this.scope.dataAlertAt * 100) / 100;
                                        var value = this.scope.dataAlertAt * 1 < this.getBase() ? Math.round(this.scope.dataAlertAt * 1) : Math.round(this.scope.dataAlertAt * 100) / 100;
                                        this.dataManagerService.setDataAlertAPI(this.dataManagerService.getCTNByIndex(this.dataManagerService.getIndexByCTN(this.scope.ctn)), this.scope.useAlert, value)
                                            .then(function (result) {
                                            if (result.data && result.data.body && result.data.body.isSuccess) {
                                                _this.dataManagerService.setSavedAlertValue(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), value);
                                                _this.dataManagerService.setDataLineAlertAt(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), value);
                                                _this.alertThresholdCheck();
                                            }
                                            else {
                                                _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondary');
                                            }
                                        })
                                            .catch(function () {
                                            _this.errorModalPopup('ute.dataManager.accountsSummary.dataAlertAt.errorHeading', 'ute.dataManager.accountsSummary.dataAlertAt.errorSecondary');
                                        });
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.showSaveCheck = function () {
                                        return !(this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn)) === Math.round(this.scope.dataAlertAt * 100) / 100);
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.prototype.showSaveButton = function () {
                                        return this.showSaveCheck() && this.isAlertMoved() && this.scope.dataAccess && this.scope.useAlert;
                                    };
                                    DataManagerAccountsSummaryDataAlertAtController.$inject = ['$document', '$scope', '$rootScope', '$modal', 'ute.data.manager.service'];
                                    return DataManagerAccountsSummaryDataAlertAtController;
                                }());
                                at.DataManagerAccountsSummaryDataAlertAtController = DataManagerAccountsSummaryDataAlertAtController;
                                angular.module('ute.data.manager.accounts.summary.data.alert.at').controller('ute.data.manager.accounts.summary.data.alert.at.directive.controller', DataManagerAccountsSummaryDataAlertAtController);
                            })(at = alert.at || (alert.at = {}));
                        })(alert = data.alert || (data.alert = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var data;
                    (function (data) {
                        var alert;
                        (function (alert) {
                            var at;
                            (function (at) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.data.alert.at').directive('uteDataManagerAccountsSummaryDataAlertAt', uteDataManagerAccountsSummaryDataAlertAt);
                                uteDataManagerAccountsSummaryDataAlertAt.$inject = ['$window', 'ute.data.manager.service'];
                                /* @ngInject */
                                function uteDataManagerAccountsSummaryDataAlertAt($window, dataManagerService) {
                                    return {
                                        restrict: 'E',
                                        scope: { 'savedAlertValue': '@', 'dataAlertAt': '@', 'useAlert': '=', 'dataAccess': '=', 'ctn': '@' },
                                        templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAlertAtDirective.templateUrl,
                                        controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAlertAtDirective.controllerName,
                                        controllerAs: 'dataManagerAccountsSummaryDataAlertAt'
                                    };
                                }
                            })(at = alert.at || (alert.at = {}));
                        })(alert = data.alert || (data.alert = {}));
                    })(data = summary.data || (summary.data = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryDataAlertBarController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryDataAlertBarController($document, $scope, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryDataAlertBarController.prototype.getSavedAlertValue = function (index) {
                            return this.dataManagerService.getSavedAlertValue(index);
                        };
                        DataManagerAccountsSummaryDataAlertBarController.prototype.getBarPosition = function () {
                            return (this.scope.maxLimit - this.dataManagerService.getSavedAlertValue(this.scope.index)) * (this.scope.maxHeight / this.scope.maxLimit);
                        };
                        DataManagerAccountsSummaryDataAlertBarController.prototype.thumbDown = function () {
                            this.scope.dragging = true;
                        };
                        DataManagerAccountsSummaryDataAlertBarController.prototype.thumbUp = function () {
                            this.scope.dragging = false;
                        };
                        DataManagerAccountsSummaryDataAlertBarController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerAccountsSummaryDataAlertBarController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryDataAlertBarController;
                    }());
                    summary.DataManagerAccountsSummaryDataAlertBarController = DataManagerAccountsSummaryDataAlertBarController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.data.alert.bar.directive.controller', DataManagerAccountsSummaryDataAlertBarController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryDataAlertBar', uteDataManagerAccountsSummaryDataAlertBar);
                    uteDataManagerAccountsSummaryDataAlertBar.$inject = ['$window', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryDataAlertBar($window, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'index': '@', 'maxLimit': '@', 'maxHeight': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAlertBarDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataAlertBarDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryDataAlertBar',
                            link: function (scope, element, attrs, controller) {
                                // scope.$emit('ute-dataManager-data-alert-bar-linked', scope.index);
                            }
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var data;
                (function (data) {
                    var meter;
                    (function (meter) {
                        'use strict';
                        var DataManagerSummaryDataMeterController = (function () {
                            /* @ngInject */
                            function DataManagerSummaryDataMeterController($document, dataManagerService) {
                                this.$document = $document;
                                this.dataManagerService = dataManagerService;
                                this.getBan = dataManagerService.getAccountNumber;
                                this.model = dataManagerService.getModel();
                                $document.scrollTop(0);
                            }
                            DataManagerSummaryDataMeterController.prototype.getDataLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            DataManagerSummaryDataMeterController.prototype.inOverage = function () {
                                return (this.dataManagerService.getOverage() > 0);
                            };
                            DataManagerSummaryDataMeterController.prototype.getAddedExtraData = function () {
                                return this.dataManagerService.getAddedExtraData();
                            };
                            DataManagerSummaryDataMeterController.prototype.getSecondTickValue = function () {
                                return this.dataManagerService.getSecondTickValue();
                            };
                            DataManagerSummaryDataMeterController.prototype.getSummaryChartHeight = function () {
                                return this.dataManagerService.getSummaryChartHeight();
                            };
                            DataManagerSummaryDataMeterController.prototype.getTickHeight = function () {
                                return this.getSummaryChartHeight() / (this.getDataTicks().length - 1);
                            };
                            DataManagerSummaryDataMeterController.prototype.getChartDataLimit = function () {
                                return this.dataManagerService.getTotalUsedDataBucket();
                            };
                            DataManagerSummaryDataMeterController.prototype.getDataTicks = function () {
                                return this.dataManagerService.getChartDataTicks();
                            };
                            DataManagerSummaryDataMeterController.$inject = ['$document', 'ute.data.manager.service'];
                            return DataManagerSummaryDataMeterController;
                        }());
                        meter.DataManagerSummaryDataMeterController = DataManagerSummaryDataMeterController;
                        angular.module('ute.data.manager.summary.data.meter').controller('ute.data.manager.summary.data.meter.controller', DataManagerSummaryDataMeterController);
                    })(meter = data.meter || (data.meter = {}));
                })(data = summary.data || (summary.data = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var data;
                (function (data) {
                    var meter;
                    (function (meter) {
                        'use strict';
                        angular.module('ute.data.manager.summary.data.meter').directive('uteDataManagerSummaryDataMeter', uteDataManagerSummaryDataMeter);
                        uteDataManagerSummaryDataMeter.$inject = ['ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerSummaryDataMeter(dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: { primaryHeight: '@', secondaryHeight: '@', tertiaryHeight: '@' },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataMeterDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataMeterDirective.controllerName,
                                controllerAs: 'uteDataManagerSummaryDataMeter'
                            };
                        }
                    })(meter = data.meter || (data.meter = {}));
                })(data = summary.data || (summary.data = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var data;
                (function (data) {
                    var meter;
                    (function (meter) {
                        'use strict';
                        var DataManagerSummaryDataMeterTickController = (function () {
                            /* @ngInject */
                            function DataManagerSummaryDataMeterTickController($scope, $document, dataManagerService) {
                                this.$scope = $scope;
                                this.$document = $document;
                                this.dataManagerService = dataManagerService;
                                this.getBan = dataManagerService.getAccountNumber;
                                this.model = dataManagerService.getModel();
                                this.scope = $scope;
                                $document.scrollTop(0);
                            }
                            DataManagerSummaryDataMeterTickController.prototype.getDataLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            DataManagerSummaryDataMeterTickController.prototype.getBase = function () {
                                return this.dataManagerService.getConfig().basic.dataConversion;
                            };
                            DataManagerSummaryDataMeterTickController.prototype.getDataMeterValueStyle = function () {
                                var style = {};
                                style.color = this.scope.meterColor;
                                return style;
                            };
                            DataManagerSummaryDataMeterTickController.prototype.getMajorTickStyle = function () {
                                var style = {};
                                style['border-bottom-color'] = this.scope.meterColor;
                                return style;
                            };
                            DataManagerSummaryDataMeterTickController.prototype.getMinorTickStyle = function () {
                                var style = {};
                                if (this.scope.topTick) {
                                    style.opacity = 0;
                                }
                                style['border-bottom-color'] = this.scope.meterColor;
                                return style;
                            };
                            DataManagerSummaryDataMeterTickController.$inject = ['$scope', '$document', 'ute.data.manager.service'];
                            return DataManagerSummaryDataMeterTickController;
                        }());
                        meter.DataManagerSummaryDataMeterTickController = DataManagerSummaryDataMeterTickController;
                        angular.module('ute.data.manager.summary.data.meter').controller('ute.data.manager.summary.data.meter.tick.controller', DataManagerSummaryDataMeterTickController);
                    })(meter = data.meter || (data.meter = {}));
                })(data = summary.data || (summary.data = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var data;
                (function (data) {
                    var meter;
                    (function (meter) {
                        'use strict';
                        angular.module('ute.data.manager.summary.data.meter').directive('uteDataManagerSummaryDataMeterTick', uteDataManagerSummaryDataMeterTick);
                        uteDataManagerSummaryDataMeterTick.$inject = ['ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerSummaryDataMeterTick(dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: { 'value': '@',
                                    'tickHeight': '@',
                                    'topTick': '=',
                                    'midTick': '=',
                                    'bottomTick': '=',
                                    'meterColor': '@',
                                    'overageTick': '=',
                                    'secondTickValue': '@'
                                },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataMeterTickDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryDataMeterTickDirective.controllerName,
                                controllerAs: 'uteDataManagerSummaryDataMeterTick'
                            };
                        }
                    })(meter = data.meter || (data.meter = {}));
                })(data = summary.data || (summary.data = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var footer;
                (function (footer) {
                    'use strict';
                    var DataManagerAccountsSummaryFooterController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryFooterController($document, dataManagerService) {
                            this.$document = $document;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryFooterController.prototype.buttonClass = function () {
                            return this.summaryMode() ? 'ute-dataManager-accountsSummaryFooter-summaryMode' : '';
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getDataLimit = function () {
                            return this.dataManagerService.getDataLimit();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getTotalUsedData = function () {
                            return this.dataManagerService.getTotalUsedData();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getSavedAlertDataTotal = function () {
                            return this.dataManagerService.getSavedAlertedDataTotal();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getAlertedDataTotal = function () {
                            return this.dataManagerService.getAlertedDataTotal();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversion;
                        };
                        DataManagerAccountsSummaryFooterController.prototype.getRoundedBase = function () {
                            return this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                        };
                        DataManagerAccountsSummaryFooterController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.summaryMode = function () {
                            return this.dataManagerService.getSummaryMode();
                        };
                        DataManagerAccountsSummaryFooterController.prototype.footerButtonClick = function () {
                            this.dataManagerService.setSummaryMode(true);
                        };
                        DataManagerAccountsSummaryFooterController.$inject = ['$document', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryFooterController;
                    }());
                    footer.DataManagerAccountsSummaryFooterController = DataManagerAccountsSummaryFooterController;
                    angular.module('ute.data.manager.summary.footer').controller('ute.data.manager.summary.footer.controller', DataManagerAccountsSummaryFooterController);
                })(footer = summary.footer || (summary.footer = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var footer;
                (function (footer) {
                    'use strict';
                    angular.module('ute.data.manager.summary.footer').directive('uteDataManagerAccountsSummaryFooter', uteDataManagerAccountsSummaryFooter);
                    uteDataManagerAccountsSummaryFooter.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryFooter(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryFooterDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryFooterDirective.controllerName,
                            controllerAs: 'uteDataManagerAccountsSummaryFooter'
                        };
                    }
                })(footer = summary.footer || (summary.footer = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryHeaderController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryHeaderController($document, $scope, $rootScope, $modal, dataManagerService) {
                            var _this = this;
                            this.$document = $document;
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$modal = $modal;
                            this.dataManagerService = dataManagerService;
                            this.getSelectYourLineMessageKey = function () {
                                var accLength = _this.dataManagerService.getFilteredList().length;
                                if (accLength !== 0 && accLength === 1) {
                                    return 'ute.dataManager.accountsSummary.header.singleAccountMessage';
                                }
                                else if (accLength !== 0 && accLength >= 2) {
                                    return 'ute.dataManager.accountsSummary.header.multiAccountMessage';
                                }
                            };
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryHeaderController.prototype.goToDashboard = function () {
                            this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                        };
                        DataManagerAccountsSummaryHeaderController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.$rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrlNoIcon,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'sm',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        DataManagerAccountsSummaryHeaderController.prototype.dataPurchasePopup = function () {
                            this.errorModalPopup('ute.dataManager.accountsSummary.header.dataDelayHeader', 'ute.dataManager.accountsSummary.header.dataDelayBody');
                        };
                        DataManagerAccountsSummaryHeaderController.prototype.isPurchasedCopyVisible = function () {
                            return this.dataManagerService.getPurchaseDataIncreases().length > 0 &&
                                this.dataManagerService.getOverage() === 0 &&
                                !this.dataManagerService.getUsageDetailsCallInProgress();
                        };
                        DataManagerAccountsSummaryHeaderController.prototype.getIsVideoThrottlePermitted = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted();
                        };
                        DataManagerAccountsSummaryHeaderController.$inject = ['$document', '$scope', '$rootScope', '$modal', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryHeaderController;
                    }());
                    summary.DataManagerAccountsSummaryHeaderController = DataManagerAccountsSummaryHeaderController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.header.directive.controller', DataManagerAccountsSummaryHeaderController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryHeader', uteDataManagerAccountsSummaryHeader);
                    uteDataManagerAccountsSummaryHeader.$inject = ['$window', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryHeader($window, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryHeaderDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryHeaderDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryHeader',
                            link: function (scope, element, attrs, controller) {
                                scope.dataManagerActiveTabIndex = dataManagerService.getDataManagerActiveTabIndex();
                                scope.$watch(function () { return dataManagerService.getDataManagerActiveTabIndex(); }, function (newVal, oldVal) {
                                    if (newVal !== oldVal) {
                                        scope.dataManagerActiveTabIndex = newVal;
                                    }
                                });
                            }
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var header;
                (function (header) {
                    'use strict';
                    var DataManagerAccountsSummaryIndividualHeaderController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryIndividualHeaderController($document, dataManagerService) {
                            this.$document = $document;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.showRightCol = function (ctn) {
                            return (ctn ? this.hasDataCTN(ctn) : false) && ((this.getStatusByCTN(ctn) !== 'cancelled') && (this.getStatusByCTN(ctn) !== 'suspended'));
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.getDataLimit = function () {
                            return this.dataManagerService.getDataLimit();
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.goToDashboard = function () {
                            if (!this.dataManagerService.getSummaryMode()) {
                                this.dataManagerService.setSummaryMode(true);
                            }
                            else {
                                this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.enterDataManager.subState);
                            }
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.getStatusByCTN = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).status;
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.getGroupStatusByCTN = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.hasDataCTN = function (ctn) {
                            return this.dataManagerService.hasDataCTN(ctn);
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.prototype.getIsVideoThrottlePermitted = function () {
                            return this.dataManagerService.getIsVideoThrottlePermitted();
                        };
                        DataManagerAccountsSummaryIndividualHeaderController.$inject = ['$document', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryIndividualHeaderController;
                    }());
                    header.DataManagerAccountsSummaryIndividualHeaderController = DataManagerAccountsSummaryIndividualHeaderController;
                    angular.module('ute.data.manager.summary.header').controller('ute.data.manager.summary.header.controller', DataManagerAccountsSummaryIndividualHeaderController);
                })(header = summary.header || (summary.header = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var summary;
            (function (summary) {
                var header;
                (function (header) {
                    'use strict';
                    angular.module('ute.data.manager.summary.header').directive('uteDataManagerAccountsSummaryIndividualHeader', uteDataManagerAccountsSummaryIndividualHeader);
                    uteDataManagerAccountsSummaryIndividualHeader.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryIndividualHeader(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'index': '@', 'displayName': '@', 'ctn': '@', 'colorCode': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryIndividualHeaderDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryIndividualHeaderDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryIndividualHeader',
                            link: function (scope, element, attrs, controller) {
                                var alert = angular.element(element[0].getElementsByClassName('ute-dataManager-accountsSummary-individualHeader-noDataIcon'));
                                scope.$watch('ctn', function () {
                                    alert.css('fill', scope.colorCode);
                                });
                                scope.dataManagerActiveTabIndex = dataManagerService.getDataManagerActiveTabIndex();
                                scope.$watch(function () { return dataManagerService.getDataManagerActiveTabIndex(); }, function (newVal, oldVal) {
                                    if (newVal !== oldVal) {
                                        scope.dataManagerActiveTabIndex = newVal;
                                    }
                                });
                            }
                        };
                    }
                })(header = summary.header || (summary.header = {}));
            })(summary = manager.summary || (manager.summary = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var alerts;
                            (function (alerts) {
                                var set;
                                (function (set) {
                                    'use strict';
                                    var DataManagerAccountsSummaryNoDataAlertsSetController = (function () {
                                        /* @ngInject */
                                        function DataManagerAccountsSummaryNoDataAlertsSetController($document, $scope, $rootScope, $modal, dataManagerService) {
                                            this.$document = $document;
                                            this.$scope = $scope;
                                            this.$rootScope = $rootScope;
                                            this.$modal = $modal;
                                            this.dataManagerService = dataManagerService;
                                            this.getBan = dataManagerService.getAccountNumber;
                                            this.model = dataManagerService.getModel();
                                            this.rootScope = $rootScope;
                                            this.scope = $scope;
                                            this.useAlert = false;
                                            $document.scrollTop(0);
                                        }
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.errorModalPopup = function (primary, secondary) {
                                            var errorModalScope = this.rootScope.$new();
                                            errorModalScope.params = { primary: primary, secondary: secondary };
                                            this.$modal.open({
                                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                                controllerAs: 'dataManagerGenericModal',
                                                size: 'md',
                                                backdrop: 'static',
                                                scope: errorModalScope
                                            });
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.useAlertChange = function ($event) {
                                            var _this = this;
                                            this.dataManagerService.setDataAlertAPI(this.dataManagerService.getCTNByIndex(this.scope.index), true, this.scope.savedAlertValue)
                                                .then(function (result) {
                                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                                    _this.dataManagerService.setDataUseAlert(_this.scope.index, true);
                                                    _this.useAlert = false;
                                                }
                                                else {
                                                    _this.errorModalPopup('ute.dataManager.accountsSummary.noDataAlert.errorHeading', 'ute.dataManager.accountsSummary.noDataAlert.errorSecondaryUseAlertsOn');
                                                    _this.useAlert = !_this.useAlert;
                                                }
                                            })
                                                .catch(function () {
                                                _this.errorModalPopup('ute.dataManager.accountsSummary.noDataAlert.errorHeading', 'ute.dataManager.accountsSummary.noDataAlert.errorSecondaryUseAlertsOn');
                                                _this.useAlert = !_this.useAlert;
                                            });
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.getSaveAlertCallInProgress = function () {
                                            return this.dataManagerService.getSaveAlertCallInProgress();
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.getSavedAlertValue = function (index) {
                                            return this.dataManagerService.getSavedAlertValue(index);
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.prototype.getBarPosition = function () {
                                            return (this.scope.maxLimit - this.dataManagerService.getSavedAlertValue(this.scope.index)) * (this.scope.maxHeight / this.scope.maxLimit);
                                        };
                                        DataManagerAccountsSummaryNoDataAlertsSetController.$inject = ['$document', '$scope', '$rootScope', '$modal', 'ute.data.manager.service'];
                                        return DataManagerAccountsSummaryNoDataAlertsSetController;
                                    }());
                                    set.DataManagerAccountsSummaryNoDataAlertsSetController = DataManagerAccountsSummaryNoDataAlertsSetController;
                                    angular.module('ute.data.manager.accounts.summary.no.data.alerts.set').controller('ute.data.manager.accounts.summary.no.data.alerts.set.directive.controller', DataManagerAccountsSummaryNoDataAlertsSetController);
                                })(set = alerts.set || (alerts.set = {}));
                            })(alerts = data.alerts || (data.alerts = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var alerts;
                            (function (alerts) {
                                var set;
                                (function (set) {
                                    'use strict';
                                    angular.module('ute.data.manager.accounts.summary.no.data.alerts.set').directive('uteDataManagerAccountsSummaryNoDataAlertsSet', uteDataManagerAccountsSummaryNoDataAlertsSet);
                                    uteDataManagerAccountsSummaryNoDataAlertsSet.$inject = ['$window', 'ute.data.manager.service'];
                                    /* @ngInject */
                                    function uteDataManagerAccountsSummaryNoDataAlertsSet($window, dataManagerService) {
                                        return {
                                            restrict: 'E',
                                            scope: { 'index': '@', 'savedAlertValue': '@', 'useAlert': '=', 'dataAlertAt': '@' },
                                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryNoAlertsSetDirective.templateUrl,
                                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryNoAlertsSetDirective.controllerName,
                                            controllerAs: 'dataManagerAccountsSummaryNoDataAlertsSet'
                                        };
                                    }
                                })(set = alerts.set || (alerts.set = {}));
                            })(alerts = data.alerts || (data.alerts = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var plan;
                            (function (plan) {
                                'use strict';
                                var DataManagerAccountsSummaryDataAccessOffController = (function () {
                                    /* @ngInject */
                                    function DataManagerAccountsSummaryDataAccessOffController($document, $scope, $rootScope, dataManagerService) {
                                        this.$document = $document;
                                        this.$scope = $scope;
                                        this.$rootScope = $rootScope;
                                        this.dataManagerService = dataManagerService;
                                        this.getBan = dataManagerService.getAccountNumber;
                                        this.model = dataManagerService.getModel();
                                        this.scope = $scope;
                                        $document.scrollTop(0);
                                    }
                                    DataManagerAccountsSummaryDataAccessOffController.prototype.addDataToLine = function () {
                                        // this.$window.location.href = this.dataManagerService.getConfig().basic.addDataToLineUrl;
                                        this.$rootScope.$emit('wireless-dashboard-change-plan');
                                    };
                                    DataManagerAccountsSummaryDataAccessOffController.$inject = ['$document', '$scope', '$rootScope', 'ute.data.manager.service'];
                                    return DataManagerAccountsSummaryDataAccessOffController;
                                }());
                                plan.DataManagerAccountsSummaryDataAccessOffController = DataManagerAccountsSummaryDataAccessOffController;
                                angular.module('ute.data.manager.accounts.summary.data.access.off').controller('ute.data.manager.accounts.summary.data.access.off.directive.controller', DataManagerAccountsSummaryDataAccessOffController);
                            })(plan = data.plan || (data.plan = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    var no;
                    (function (no) {
                        var data;
                        (function (data) {
                            var plan;
                            (function (plan) {
                                'use strict';
                                angular.module('ute.data.manager.accounts.summary.no.data.plan').directive('uteDataManagerAccountsSummaryNoDataPlan', uteDataManagerAccountsSummaryNoDataPlan);
                                uteDataManagerAccountsSummaryNoDataPlan.$inject = ['$window', 'ute.data.manager.service'];
                                /* @ngInject */
                                function uteDataManagerAccountsSummaryNoDataPlan($window, dataManagerService) {
                                    return {
                                        restrict: 'E',
                                        scope: { 'index': '@', 'dataAlertAt': '@', 'useAlert': '=' },
                                        templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryNoDataPlanDirective.templateUrl,
                                        controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryNoDataPlanDirective.controllerName,
                                        controllerAs: 'dataManagerAccountsSummaryNoDataPlan'
                                    };
                                }
                            })(plan = data.plan || (data.plan = {}));
                        })(data = no.data || (no.data = {}));
                    })(no = summary.no || (summary.no = {}));
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryOverageBarController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryOverageBarController($document, $scope, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryOverageBarController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryOverageBarController;
                    }());
                    summary.DataManagerAccountsSummaryOverageBarController = DataManagerAccountsSummaryOverageBarController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.overage.bar.directive.controller', DataManagerAccountsSummaryOverageBarController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryOverageBar', uteDataManagerAccountsSummaryOverageBar);
                    uteDataManagerAccountsSummaryOverageBar.$inject = ['$window', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryOverageBar($window, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryOverageBarDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryOverageBarDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryOverageBar'
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryOverageCoverageController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryOverageCoverageController($document, $scope, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryOverageCoverageController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryOverageCoverageController;
                    }());
                    summary.DataManagerAccountsSummaryOverageCoverageController = DataManagerAccountsSummaryOverageCoverageController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.overage.coverage.directive.controller', DataManagerAccountsSummaryOverageCoverageController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryOverageCoverage', uteDataManagerAccountsSummaryOverageCoverage);
                    uteDataManagerAccountsSummaryOverageCoverage.$inject = ['$window', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryOverageCoverage($window, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { 'height': '@' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryOverageCoverageDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryOverageCoverageDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryOverageCoverage'
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummarySwipeInstructionsController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummarySwipeInstructionsController($document, $scope, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummarySwipeInstructionsController.$inject = ['$document', '$scope', 'ute.data.manager.service'];
                        return DataManagerAccountsSummarySwipeInstructionsController;
                    }());
                    summary.DataManagerAccountsSummarySwipeInstructionsController = DataManagerAccountsSummarySwipeInstructionsController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.swipe.instructions.directive.controller', DataManagerAccountsSummarySwipeInstructionsController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummarySwipeInstructions', uteDataManagerAccountsSummarySwipeInstructions);
                    uteDataManagerAccountsSummarySwipeInstructions.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummarySwipeInstructions(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: { fade: '=' },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummarySwipeInstructionsDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummarySwipeInstructionsDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummarySwipeInstructions'
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    var DataManagerAccountsSummaryTabsController = (function () {
                        /* @ngInject */
                        function DataManagerAccountsSummaryTabsController($document, $scope, $rootScope, $modal, dataManagerService) {
                            this.$document = $document;
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$modal = $modal;
                            this.dataManagerService = dataManagerService;
                            this.getBan = dataManagerService.getAccountNumber;
                            this.model = dataManagerService.getModel();
                            this.scope = $scope;
                            $document.scrollTop(0);
                        }
                        DataManagerAccountsSummaryTabsController.prototype.getDataManagerActiveTabIndex = function () {
                            return this.dataManagerService.getDataManagerActiveTabIndex();
                        };
                        DataManagerAccountsSummaryTabsController.prototype.setDataManagerActiveTabIndex = function (index) {
                            this.scope.dataManagerActiveTabIndex = index;
                            this.dataManagerService.setDataManagerActiveTabIndex(index);
                        };
                        DataManagerAccountsSummaryTabsController.$inject = ['$document', '$scope', '$rootScope', '$modal', 'ute.data.manager.service'];
                        return DataManagerAccountsSummaryTabsController;
                    }());
                    summary.DataManagerAccountsSummaryTabsController = DataManagerAccountsSummaryTabsController;
                    angular.module('ute.data.manager.accounts.summary').controller('ute.data.manager.accounts.summary.tabs.directive.controller', DataManagerAccountsSummaryTabsController);
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var accounts;
            (function (accounts) {
                var summary;
                (function (summary) {
                    'use strict';
                    angular.module('ute.data.manager.accounts.summary').directive('uteDataManagerAccountsSummaryTabs', uteDataManagerAccountsSummaryTabs);
                    uteDataManagerAccountsSummaryTabs.$inject = ['$window', 'ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerAccountsSummaryTabs($window, dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {},
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryTabsDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerAccountsSummaryTabsDirective.controllerName,
                            controllerAs: 'dataManagerAccountsSummaryTabs',
                            link: function (scope, element, attrs, controller) {
                                scope.dataManagerActiveTabIndex = controller.getDataManagerActiveTabIndex();
                            }
                        };
                    }
                })(summary = accounts.summary || (accounts.summary = {}));
            })(accounts = manager.accounts || (manager.accounts = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var access;
                (function (access) {
                    'use strict';
                    var DataManagerDataAccessModalController = (function () {
                        /* @ngInject */
                        function DataManagerDataAccessModalController($scope, $modalInstance, dataManagerService, messagesService) {
                            this.$scope = $scope;
                            this.$modalInstance = $modalInstance;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.showSucces = false;
                            this.showError = false;
                            this.selectedCTN = this.getDefaultDisplayCTN();
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                        }
                        DataManagerDataAccessModalController.prototype.getDataControlList = function () {
                            return this.dataManagerService.getDataControlList();
                        };
                        DataManagerDataAccessModalController.prototype.validateAccountLine = function (accountLine) {
                            /*if ( accountLine.hasData && accountLine.hasText && accountLine.hasTalk ) {
                              return true;
                            } else {
                              return false;
                            }*/
                            return true;
                        };
                        DataManagerDataAccessModalController.prototype.isSuccess = function () {
                            return this.showSucces;
                        };
                        DataManagerDataAccessModalController.prototype.isError = function () {
                            return this.showError;
                        };
                        DataManagerDataAccessModalController.prototype.addDataClick = function () {
                            this.messagesService.publish('ute-data-manager-increase-plan-button-click-' + this.scope.topUpTarget);
                            this.$modalInstance.dismiss('cancel');
                        };
                        DataManagerDataAccessModalController.prototype.isAllowedToPurchaseData = function () {
                            return this.dataManagerService.isAllowedToPurchaseData();
                        };
                        DataManagerDataAccessModalController.prototype.getColorCodeCTN = function () {
                            return this.dataManagerService.getColorCodeCTN(this.scope.ctn);
                        };
                        DataManagerDataAccessModalController.prototype.getDefaultDisplayCTN = function () {
                            return ((this.dataManagerService.getAlertsRecipientCTN() === null) ? this.dataManagerService.getDataControlList()[0].ctn : this.dataManagerService.getAlertsRecipientCTN());
                        };
                        DataManagerDataAccessModalController.prototype.getDisplayNameCTN = function () {
                            return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                        };
                        DataManagerDataAccessModalController.prototype.noSelection = function () {
                            this.$modalInstance.dismiss('cancel');
                        };
                        DataManagerDataAccessModalController.prototype.continue = function () {
                            this.$modalInstance.close('yes');
                        };
                        DataManagerDataAccessModalController.prototype.cancel = function () {
                            this.$modalInstance.close('no');
                        };
                        DataManagerDataAccessModalController.prototype.continueVerified = function (ctn) {
                            var accountLine = this.dataManagerService.getAccountLineByCTN(ctn);
                            if (this.validateAccountLine(accountLine)) {
                                this.showError = false;
                                this.dataManagerService.setAlertsRecipientCTN(this.selectedCTN);
                                this.$modalInstance.close('yes');
                            }
                            else {
                                this.showError = true;
                            }
                        };
                        DataManagerDataAccessModalController.$inject = ['$scope', '$modalInstance', 'ute.data.manager.service', 'ute.blocks.messages.bus.service'];
                        return DataManagerDataAccessModalController;
                    }());
                    access.DataManagerDataAccessModalController = DataManagerDataAccessModalController;
                    angular.module('ute.data.manager.data.access').controller('ute.data.manager.data.access.modal.controller', DataManagerDataAccessModalController);
                })(access = data.access || (data.access = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    var DataManagerDataControlController = (function () {
                        /* @ngInject */
                        function DataManagerDataControlController($scope, $rootScope, $modal, $timeout, $window, dataManagerService, messagesService) {
                            this.$scope = $scope;
                            this.$rootScope = $rootScope;
                            this.$modal = $modal;
                            this.$timeout = $timeout;
                            this.$window = $window;
                            this.dataManagerService = dataManagerService;
                            this.messagesService = messagesService;
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.rootScope = $rootScope;
                            this.timeout = $timeout;
                        }
                        DataManagerDataControlController.prototype.showSaveCheck = function (dataAlertAt) {
                            var base = 1;
                            var savedValue = this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn)) === -1 ? -1 : Math.round(this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn)) / base) * base;
                            return (savedValue !== Math.round(dataAlertAt / base) * base) && (this.scope.dataAccess === 'true') && this.scope.useAlert;
                            /*
                            let margin: number = 1024 / 10 / 2;
                            let index: number = this.scope.lineIndex;
                            let savedAlertValue: number = this.dataManagerService.getSavedAlertValue(index);
                            let dataAlertAt: number = this.dataManagerService.getDataLineAlertAt(index);
                            let max: number = Math.round(savedAlertValue + margin);
                            let min: number = Math.round(savedAlertValue - margin);
                      
                            return (dataAlertAt > min && dataAlertAt <= max)
                              ? false
                              : true
                              ;
                              */
                        };
                        DataManagerDataControlController.prototype.getTotalDataLimit = function () {
                            return this.dataManagerService.getTotalDataLimit();
                        };
                        DataManagerDataControlController.prototype.getIndicatorWidth = function () {
                            return this.scope.getDataIndicatorWidth();
                        };
                        DataManagerDataControlController.prototype.getDataAccessCTN = function () {
                            return this.dataManagerService.getDataAccessCTN(this.scope.ctn);
                        };
                        DataManagerDataControlController.prototype.getSaveAlertCallInProgress = function () {
                            return this.dataManagerService.getSaveAlertCallInProgress();
                        };
                        DataManagerDataControlController.prototype.getDataLimit = function () {
                            if (this.dataManagerService.isCare()) {
                                return this.dataManagerService.getDataLimit() + this.dataManagerService.getAddedExtraData();
                            }
                            else {
                                return this.dataManagerService.getDataLimit();
                            }
                        };
                        /**
                         * Calculate the incremental Step based on data plan limit
                         */
                        DataManagerDataControlController.prototype.getSliderStep = function () {
                            return this.dataManagerService.getSliderStep();
                        };
                        DataManagerDataControlController.prototype.getBase = function () {
                            return this.scope.dataAlertAt >= 1000 ? this.dataManagerService.getConfig().basic.dataConversion : this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                        };
                        DataManagerDataControlController.prototype.goToWireless = function (ctn) {
                            this.dataManagerService.setWirelessCTN(ctn);
                            this.dataManagerService.goToWirelessState();
                        };
                        DataManagerDataControlController.prototype.getDisplayNameCTN = function () {
                            return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                        };
                        DataManagerDataControlController.prototype.alertThresholdCheck = function () {
                            if (this.dataManagerService.getSavedAlertedDataTotal() > this.getDataLimit()) {
                                this.alertsOverDataLimitModalPopup();
                            }
                        };
                        DataManagerDataControlController.prototype.alertsOverDataLimitModalPopup = function () {
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.controllerName,
                                controllerAs: 'dataManagerAlertsOverDataLimitModal',
                                size: 'md',
                                backdrop: 'static'
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        break;
                                    case 'no':
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                            });
                        };
                        DataManagerDataControlController.prototype.saveAlertChange = function ($event) {
                            // var ctrl: any = this;
                            var _this = this;
                            var ctn = this.scope.ctn;
                            var threshold = this.scope.dataAlertAt;
                            this.dataManagerService.setDataAlertAPI(ctn, this.scope.useAlert, threshold)
                                .then(function (result) {
                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                    _this.dataManagerService.setSavedAlertValue(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), _this.scope.dataManagerDataControl.dataAlertAt);
                                    _this.alertThresholdCheck();
                                }
                                else {
                                    _this.errorModalPopup('ute.dataManager.dataControl.errorHeading', 'ute.dataManager.dataControl.errorSecondaryThreshold');
                                }
                            })
                                .catch(function () {
                                _this.errorModalPopup('ute.dataManager.dataControl.errorHeading', 'ute.dataManager.dataControl.errorSecondaryThreshold');
                            });
                        };
                        DataManagerDataControlController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                            return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                        };
                        DataManagerDataControlController.prototype.changeDisplayAlertedAmount = function ($event) {
                            this.dataManagerService.setDataLineAlertAt(this.dataManagerService.getIndexByCTN(this.scope.ctn), this.scope.dataManagerDataControl.dataAlertAt);
                        };
                        DataManagerDataControlController.prototype.setDataUseAlerts = function () {
                            var _this = this;
                            var ctn = this.scope.ctn;
                            var threshold = this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn));
                            this.dataManagerService.setDataAlertAPI(ctn, this.scope.useAlert, threshold)
                                .then(function (result) {
                                if (result.data && result.data.body && result.data.body.isSuccess) {
                                    _this.dataManagerService.setDataUseAlert(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), _this.scope.useAlert);
                                }
                                else {
                                    var errorHeadingKey = 'ute.dataManager.dataControl.errorHeading';
                                    var errorMessageKey = (_this.scope.useAlert) ? 'ute.dataManager.dataControl.errorSecondaryUseAlertsOn' : 'ute.dataManager.dataControl.errorSecondaryUseAlertsOff';
                                    _this.errorModalPopup(errorHeadingKey, errorMessageKey);
                                    _this.scope.useAlert = !_this.scope.useAlert;
                                }
                            })
                                .catch(function () {
                                var errorHeadingKey = 'ute.dataManager.dataControl.errorHeading';
                                var errorMessageKey = (_this.scope.useAlert) ? 'ute.dataManager.dataControl.errorSecondaryUseAlertsOn' : 'ute.dataManager.dataControl.errorSecondaryUseAlertsOff';
                                _this.errorModalPopup(errorHeadingKey, errorMessageKey);
                                _this.scope.useAlert = !_this.scope.useAlert;
                            });
                        };
                        DataManagerDataControlController.prototype.errorModalPopup = function (primary, secondary) {
                            var errorModalScope = this.rootScope.$new();
                            errorModalScope.params = { primary: primary, secondary: secondary };
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                controllerAs: 'dataManagerGenericModal',
                                size: 'md',
                                backdrop: 'static',
                                scope: errorModalScope
                            });
                        };
                        // Code to support Modal for of primary notifiaction recipient
                        DataManagerDataControlController.prototype.requestChangeModal = function ($event) {
                            this.openModalPopup();
                        };
                        DataManagerDataControlController.prototype.openModalPopup = function () {
                            var _this = this;
                            this.$modal.open({
                                windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                controllerAs: 'dataManagerAlertsRecipientModal',
                                size: 'md',
                                backdrop: 'static'
                            }).result.then(function (result) {
                                // Result selection behaviour
                                switch (result) {
                                    case 'yes':
                                        _this.modalUserAnswerYes();
                                        break;
                                    case 'no':
                                        _this.modalUserAnswerNo();
                                        break;
                                    case 'error':
                                        _this.errorModalPopup('ute.dataManager.dataControl.errorHeading', 'ute.dataManager.dataControl.errorSecondary');
                                        break;
                                }
                            }, function () {
                                // Dismiss behaviour
                                // Do nothing/close
                                _this.modalDismissed();
                            });
                        };
                        DataManagerDataControlController.prototype.modalUserAnswerYes = function () {
                            // console.log ('User answer - YES');
                        };
                        DataManagerDataControlController.prototype.modalUserAnswerNo = function () {
                            // console.log ('User answer - NO');
                        };
                        DataManagerDataControlController.prototype.modalDismissed = function () {
                            // console.log ('User answer - MEH');
                        };
                        DataManagerDataControlController.prototype.addDataToLine = function (ctn) {
                            // this.$window.location.href = this.dataManagerService.getConfig().basic.addDataToLineUrl;
                            if (this.dataManagerService.isCare()) {
                                this.$window.sessionStorage.setItem('phoneNumber', ctn);
                            }
                            else {
                                this.$window.localStorage.setItem('phoneNumber', ctn);
                            }
                            this.rootScope.$emit('wireless-dashboard-change-plan');
                        };
                        DataManagerDataControlController.prototype.getDisplayNameClass = function (ctn) {
                            return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                        };
                        DataManagerDataControlController.prototype.getDisplayNameMediumClass = function (ctn) {
                            return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                        };
                        DataManagerDataControlController.prototype.getCTNClass = function (ctn) {
                            return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                        };
                        DataManagerDataControlController.prototype.getMidSectionClass = function (ctn) {
                            return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                        };
                        DataManagerDataControlController.prototype.showMidSection = function (ctn) {
                            return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn);
                        };
                        DataManagerDataControlController.prototype.showUpperMidSection = function (ctn) {
                            return !this.isAccountSuspended(ctn) && !this.isAccountCancelled(ctn) && !this.isAccountJoined(ctn);
                        };
                        DataManagerDataControlController.prototype.showAlertCopy = function () {
                            return (this.scope.dataAccess === 'true') && this.scope.useAlert;
                        };
                        DataManagerDataControlController.prototype.showAlertOffCopy = function () {
                            return (this.scope.dataAccess === 'true') && !this.scope.useAlert;
                        };
                        DataManagerDataControlController.prototype.showDisabledCopy = function () {
                            return (this.scope.dataAccess === 'false');
                        };
                        DataManagerDataControlController.prototype.MCPPCAlert = function () {
                            return (this.scope.savedAlertValue < 0) ? 0 : this.scope.savedAlertValue;
                        };
                        DataManagerDataControlController.prototype.showInputLabel = function () {
                            return (this.scope.dataAccess === 'true') && this.scope.useAlert;
                        };
                        DataManagerDataControlController.prototype.getSliderClass = function () {
                            return 'ute-dataManager-dataControl-md-slider' + this.scope.lineIndex;
                        };
                        DataManagerDataControlController.prototype.getDataIndicatorClasses = function () {
                            return 'ute-dataManager-dataControl-dataIndicator' + this.scope.lineIndex + ' ' + (this.getIndicatorWidth() > 70 ? 'ute-dataManager-dataControl-dataIndicatorCopy' : 'ute-dataManager-dataControl-dataIndicatorBlack');
                        };
                        DataManagerDataControlController.prototype.getDataIndicatorStyles = function () {
                            return { 'margin-left': (this.getIndicatorWidth() > 70 ? 0 : this.getIndicatorWidth() + 10) + 'px' };
                        };
                        DataManagerDataControlController.prototype.isSliderDisabled = function () {
                            return !this.scope.useAlert || !(this.scope.dataAccess === 'true') || this.getSaveAlertCallInProgress();
                        };
                        DataManagerDataControlController.prototype.getDataAlertPrecisionValue = function () {
                            return ((this.scope.dataAlertAt * 1) > this.getBase() ? 2 : 0);
                        };
                        DataManagerDataControlController.prototype.getSavedAlertPrecisionValue = function () {
                            return ((this.scope.savedAlertValue * 1) > this.getBase() ? 2 : 0);
                        };
                        DataManagerDataControlController.prototype.getDataUsedBase = function () {
                            return (this.scope.dataLimit >= 1000 ? 1024 : 1000);
                        };
                        DataManagerDataControlController.prototype.getDataUsedPrecisionValue = function () {
                            return (this.scope.dataUsed > 1024 ? 1 : 0);
                        };
                        DataManagerDataControlController.prototype.getDataLimitBase = function () {
                            return (this.scope.dataLimit >= 1000 ? 1024 : 1000);
                        };
                        DataManagerDataControlController.prototype.getDataLimitPrecision = function () {
                            return (this.scope.dataLimit >= 1024 ? 1 : 0);
                        };
                        DataManagerDataControlController.prototype.getGroupStatusCode = function () {
                            return this.dataManagerService.getGroupStatusCode();
                        };
                        DataManagerDataControlController.prototype.getStatusCode = function () {
                            return this.dataManagerService.getStatusCode();
                        };
                        DataManagerDataControlController.prototype.getStatus = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).status;
                        };
                        DataManagerDataControlController.prototype.getGroupStatus = function (ctn) {
                            return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                        };
                        DataManagerDataControlController.prototype.isAccountJoined = function (ctn) {
                            return (this.getGroupStatus(ctn) === this.getGroupStatusCode().JOINED);
                        };
                        DataManagerDataControlController.prototype.isAccountActiveInGroup = function (ctn) {
                            return (this.getGroupStatus(ctn) === this.getGroupStatusCode().ACTIVE);
                        };
                        DataManagerDataControlController.prototype.isAccountLeftGroup = function (ctn) {
                            return (this.getGroupStatus(ctn) === this.getGroupStatusCode().LEFT);
                        };
                        DataManagerDataControlController.prototype.isAccountSuspended = function (ctn) {
                            return (this.getStatus(ctn) === this.getStatusCode().SUSPENDED);
                        };
                        DataManagerDataControlController.prototype.isAccountCancelled = function (ctn) {
                            return (this.getStatus(ctn) === this.getStatusCode().CANCELLED);
                        };
                        DataManagerDataControlController.prototype.swipeLeft = function () {
                            if (this.scope.useAlert) {
                                this.scope.useAlert = !this.scope.useAlert;
                                this.setDataUseAlerts();
                            }
                        };
                        DataManagerDataControlController.prototype.swipeRight = function () {
                            if (!this.scope.useAlert) {
                                this.scope.useAlert = !this.scope.useAlert;
                                this.setDataUseAlerts();
                            }
                        };
                        DataManagerDataControlController.$inject = ['$scope', '$rootScope', '$modal', '$timeout', '$window', 'ute.data.manager.service', 'ute.blocks.messages.bus.service'];
                        return DataManagerDataControlController;
                    }());
                    control.DataManagerDataControlController = DataManagerDataControlController;
                    angular.module('ute.data.manager.data.control').controller('ute.data.manager.data.control.directive.controller', DataManagerDataControlController);
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('uteDataManagerDataControl', uteDataManagerDataControl);
                    uteDataManagerDataControl.$inject = ['ute.data.manager.service'];
                    /* @ngInject */
                    function uteDataManagerDataControl(dataManagerService) {
                        return {
                            restrict: 'E',
                            scope: {
                                'lineIndex': '@',
                                'colorCode': '@',
                                'displayName': '@',
                                'ctn': '@',
                                'dataLimit': '@',
                                'dataUsed': '@',
                                'dataAlertAt': '@',
                                'savedAlertValue': '@',
                                'status': '@',
                                'groupStatus': '@',
                                'isAlertsRecipient': '@',
                                'hasData': '@',
                                'useAlert': '=',
                                'dataAccess': '@'
                            },
                            templateUrl: dataManagerService.getConfig().advanced.dataManagerDataControlDirective.templateUrl,
                            controller: dataManagerService.getConfig().advanced.dataManagerDataControlDirective.controllerName,
                            controllerAs: 'dataManagerDataControl',
                            link: function (scope, element, attrs, controller) {
                                scope.dataAccess = (scope.dataAccess === 'true');
                                controller.lineIndex = scope.lineIndex;
                                controller.dataAlertAt = scope.dataAlertAt * 1;
                                var uteDataManagerDataControlColorBlock = angular.element(element[0].getElementsByClassName('ute-dataManager-dataControl-colorBlock')), uteDataManagerDataControlMDSwitch = angular.element(element[0].getElementsByClassName('md-bar')), uteDataManagerDataControlDataAlertInputContainerOn = angular.element(element[0].getElementsByClassName('ute-dataManager-dataControl-dataAlertInputContainerOn')), uteDataManagerDataControlDataAlertInputContainerOff = angular.element(element[0].getElementsByClassName('ute-dataManager-dataControl-dataAlertInputContainerOff')), uteDataManagerDataControlMDSwitches = element[0].getElementsByTagName('md-switch'), uteDataManagerDataControlMDThumb, uteDataManagerDataControlMDInkRipple, dataManagerDataControlEnableAlert = angular.element(element[0].getElementsByClassName('dataManagerDataControlEnableAlert')), uteDataManagerDataControlEnableAlertMDThumb = angular.element(dataManagerDataControlEnableAlert[0].getElementsByClassName('md-bar')), dataManagerDataControlDataSlider = angular.element(element[0].getElementsByClassName('dataManagerDataControlDataSlider')), dataManagerDataControlDataSliderFocusRing = angular.element(dataManagerDataControlDataSlider[0].getElementsByClassName('md-focus-ring')), dataManagerDataControlDataSliderTrackFill = angular.element(dataManagerDataControlDataSlider[0].getElementsByClassName('md-track-fill')), dataManagerDataControlSliderThumb = angular.element(dataManagerDataControlDataSlider[0].getElementsByClassName('md-thumb'));
                                scope.indicatorWidth = 0;
                                scope.getDataIndicatorWidth = function () {
                                    var dataManagerDataControlDataIndicator = element[0].getElementsByClassName('ute-dataManager-dataControl-dataIndicator' + scope.lineIndex)[0];
                                    if (dataManagerDataControlDataIndicator) {
                                        return dataManagerDataControlDataIndicator.clientWidth;
                                    }
                                    else {
                                        return 0;
                                    }
                                };
                                uteDataManagerDataControlColorBlock.css('backgroundColor', scope.colorCode);
                                uteDataManagerDataControlMDSwitch.css('backgroundColor', scope.colorCode);
                                for (var iSwitch = 0; iSwitch < uteDataManagerDataControlMDSwitches.length; iSwitch++) {
                                    uteDataManagerDataControlMDThumb = angular.element(uteDataManagerDataControlMDSwitches[iSwitch].getElementsByClassName('md-thumb'));
                                    uteDataManagerDataControlMDInkRipple = angular.element(uteDataManagerDataControlMDSwitches[iSwitch].getElementsByClassName('md-ink-ripple'));
                                    uteDataManagerDataControlMDThumb.css('borderColor', scope.colorCode);
                                    uteDataManagerDataControlMDInkRipple.css('color', scope.colorCode);
                                }
                                scope.$watch(function () { return scope.dataAlertAt; }, function (dataAlertVal) {
                                    if ((dataAlertVal * 1) > (scope.dataLimit * 1)) {
                                        dataManagerDataControlSliderThumb.css('display', 'none');
                                    }
                                    else {
                                        dataManagerDataControlSliderThumb.css('display', 'inline');
                                    }
                                });
                                scope.$watch(function () { return scope.useAlert; }, function (newVal) {
                                    if (newVal) {
                                        uteDataManagerDataControlEnableAlertMDThumb.css('backgroundColor', scope.colorCode);
                                        dataManagerDataControlSliderThumb.css('opacity', '1');
                                        dataManagerDataControlDataSliderFocusRing.css('opacity', 0.3);
                                    }
                                    else {
                                        uteDataManagerDataControlEnableAlertMDThumb.css('backgroundColor', '#a5a5a5');
                                        dataManagerDataControlSliderThumb.css('opacity', '0');
                                        dataManagerDataControlDataSliderFocusRing.css('opacity', 0);
                                    }
                                });
                                dataManagerDataControlDataSliderFocusRing.css('backgroundColor', scope.colorCode);
                                dataManagerDataControlDataSliderTrackFill.css('backgroundColor', scope.colorCode);
                                uteDataManagerDataControlDataAlertInputContainerOn.css('borderColor', scope.colorCode);
                                uteDataManagerDataControlDataAlertInputContainerOff.css('borderColor', scope.colorCode);
                                dataManagerDataControlSliderThumb.attr('tabIndex', '0');
                                ///////////////////////////////////////////////////////////////////////////////
                                // Dynamic CSS Rule Creator
                                // for Dynamically Generated HTML
                                // Elements That Require Dynamically
                                // Generated CSS Styles
                                ///////////////////////////////////////////////////////////////////////////////
                                var addInlineCSSRule = (function (style) {
                                    style.appendChild(document.createTextNode(''));
                                    document.head.appendChild(style);
                                    var sheet = style.sheet;
                                    return function (selector, css) {
                                        var propText = Object.keys(css).map(function (p) {
                                            return p + ':' + css[p];
                                        }).join(';');
                                        sheet.insertRule(selector + '{' + propText + '}', sheet.cssRules.length);
                                    };
                                })(document.createElement('style'));
                                ///////////////////////////////////////////////////////////////////////////////
                                addInlineCSSRule('.ute-dataManager-dataControl-md-slider' + scope.lineIndex + ' md-slider .md-thumb:after', { 'background-color': scope.colorCode });
                                addInlineCSSRule('.ute-dataManager-dataControl-md-slider' + scope.lineIndex + ' md-slider.md-min .md-thumb:after', { 'background-color': scope.colorCode });
                                addInlineCSSRule('.ute-dataManager-dataControl-md-slider' + scope.lineIndex + ' md-slider .md-track-fill', { 'width': (Math.min((scope.dataUsed / scope.dataLimit * 100), 100)) + '% !important' });
                                addInlineCSSRule('.ute-dataManager-dataControl-dataIndicator' + scope.lineIndex, { 'width': ((Math.min((scope.dataUsed / scope.dataLimit * 100), 100)) + '% !important') });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('dataTo', dataTo);
                    dataTo.$inject = ['$browser'];
                    /* @ngInject */
                    function dataTo($browser) {
                        return {
                            require: 'ngModel',
                            restrict: 'A',
                            link: function ($scope, $elem, $attrs, $ctrl) {
                                //attrs used limitFloat, dataBase, limitMax
                                var limitFloat = parseInt($attrs.limitFloat, 10);
                                function maxTo(value, limitMax) {
                                    return value > limitMax ? limitMax : value;
                                }
                                function transformDataTo(value, transformData) {
                                    return (value / transformData);
                                }
                                function formatValue(value) {
                                    return (value.toFixed(limitFloat) * 1);
                                }
                                //Parser for initial value MODEL
                                $ctrl.$parsers.push(function (value) {
                                    var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), model = parseInt(value, 10);
                                    model = transformDataTo(model, transformData);
                                    model = (model.toFixed(limitFloat) * 1);
                                    model = maxTo(model, limitMax);
                                    model = (model * transformData);
                                    return model;
                                });
                                //Formatter for initial value VIEW
                                $ctrl.$formatters.push(function (value) {
                                    var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), viewValue = parseInt(value, 10);
                                    viewValue = transformDataTo(viewValue, transformData);
                                    viewValue = (viewValue.toFixed(limitFloat) * 1);
                                    viewValue = maxTo(viewValue, limitMax);
                                    return viewValue;
                                });
                                var formatInput = function (e) {
                                    var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), viewValue = transformDataTo($elem.val(), transformData), idx = $elem.val().indexOf('.'), formattedValue = 0;
                                    if (idx > -1) {
                                        if ((viewValue.toString()).split('.')[1].length > limitFloat) {
                                            if (isNaN(parseFloat(viewValue.toString()))) {
                                                formattedValue = 0;
                                            }
                                            else {
                                                formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                            }
                                        }
                                        else {
                                            formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                        }
                                    }
                                    else {
                                        formattedValue = $elem.val();
                                    }
                                    //Setting the max value
                                    formattedValue = (maxTo(formattedValue, limitMax));
                                    $elem.val(formattedValue);
                                };
                                $elem.bind('paste cut change keypress keyup', function ($event) {
                                    //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                    var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                    if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                        $browser.defer(formatInput);
                                    }
                                });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('limitFloatTo', uteLimitFloatTo);
                    uteLimitFloatTo.$inject = ['$browser'];
                    /* @ngInject */
                    function uteLimitFloatTo($browser) {
                        return {
                            require: 'ngModel',
                            restrict: 'A',
                            link: function ($scope, $elem, $attrs, $ctrl) {
                                //Parser for initial value
                                $ctrl.$parsers.push(function (modelValue) {
                                    var limitFloatTo = $attrs.limitFloatTo, model = Number(parseFloat(modelValue).toFixed(parseInt(limitFloatTo, 10)));
                                    return model;
                                });
                                //Formatter for initial value
                                $ctrl.$formatters.push(function (modelValue) {
                                    var limitFloatTo = $attrs.limitFloatTo, viewValue = Number(parseFloat(modelValue).toFixed(parseInt(limitFloatTo, 10)));
                                    return viewValue;
                                });
                                var formatInput = function (e) {
                                    var limitFloatTo = $attrs.limitFloatTo, viewValue = $elem.val().toString(), idx = viewValue.indexOf('.'), formattedValue = 0;
                                    function formatValue(value) {
                                        return Number(parseFloat(value).toFixed(limitFloatTo));
                                    }
                                    if (idx > -1) {
                                        if (viewValue.split('.')[1].length > Number(limitFloatTo)) {
                                            if (isNaN(parseFloat(viewValue))) {
                                                formattedValue = 0;
                                            }
                                            else {
                                                formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                            }
                                        }
                                        else {
                                            formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                        }
                                    }
                                    else {
                                        formattedValue = $elem.val();
                                    }
                                    $elem.val(formattedValue);
                                };
                                $elem.bind('paste cut change keypress keyup', function ($event) {
                                    //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                    var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                    if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                        $browser.defer(formatInput);
                                    }
                                });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('limitMaxTo', uteLimitMaxTo);
                    uteLimitMaxTo.$inject = ['$browser'];
                    /* @ngInject */
                    function uteLimitMaxTo($browser) {
                        return {
                            require: 'ngModel',
                            restrict: 'A',
                            link: function ($scope, $elem, $attrs, $ctrl) {
                                function maxTo(value, limitMaxTo) {
                                    return (value * 1) > (limitMaxTo * 1) ? limitMaxTo : value;
                                }
                                //Formatter for initial value
                                $ctrl.$formatters.push(function (viewValue) {
                                    return maxTo(viewValue, $attrs.limitMaxTo);
                                });
                                //Parser for initial value
                                $ctrl.$parsers.push(function (modelValue) {
                                    return maxTo(modelValue, $attrs.limitMaxTo);
                                });
                                var formatInput = function (e) {
                                    $elem.val(maxTo($elem.val(), $attrs.limitMaxTo));
                                };
                                $elem.bind('paste cut change keypress keyup', function ($event) {
                                    //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                    var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                    if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                        $browser.defer(formatInput);
                                    }
                                });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('limitToPattern', uteLimitToPattern);
                    uteLimitToPattern.$inject = ['$browser'];
                    /* @ngInject */
                    function uteLimitToPattern($browser) {
                        return {
                            require: 'ngModel',
                            restrict: 'A',
                            link: function ($scope, $elem, $attrs, $ctrl) {
                                function limitToPattern(value, limitToPattern) {
                                    var transformedInput = value ? value.toString().replace(new RegExp(limitToPattern), '') : value;
                                    if (transformedInput !== value) {
                                        $ctrl.$setViewValue(transformedInput);
                                        $ctrl.$render();
                                    }
                                    return transformedInput;
                                }
                                //Formatter for initial value
                                $ctrl.$formatters.push(function (viewValue) {
                                    return limitToPattern(viewValue, $attrs.limitToPattern);
                                });
                                //Parser for initial value
                                $ctrl.$parsers.push(function (modelValue) {
                                    return limitToPattern(modelValue, $attrs.limitToPattern);
                                });
                                var formatInput = function (e) {
                                    limitToPattern($elem.val(), $attrs.limitToPattern);
                                };
                                $elem.bind('paste cut change keypress keyup', function ($event) {
                                    //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                    var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                    if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                        $browser.defer(formatInput);
                                    }
                                });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    'use strict';
                    angular.module('ute.data.manager.data.control').directive('transformData', uteTransformData);
                    uteTransformData.$inject = ['$browser', '$filter', '$translate'];
                    /* @ngInject */
                    function uteTransformData($browser, $filter, $translate) {
                        return {
                            require: 'ngModel',
                            restrict: 'A',
                            link: function ($scope, $elem, $attrs, $ctrl) {
                                /*
                                $scope.$watch(function(){return $translate.use(); }, function(lang: string){
                        
                                  var limitFloat: number = $elem.val().indexOf(',') > -1 || $elem.val().indexOf('.') > -1 ? parseInt($attrs.limitFloat, 10) : 0;
                        
                                  $ctrl.$setViewValue($filter('number')($elem.val(), limitFloat));
                        
                                  $ctrl.$render();
                        
                                });
                        
                        */
                                function transformViewTo() {
                                    var limitFloat = parseInt($attrs.limitFloat, 10), base = parseInt($attrs.base, 10), limitMax = parseInt($attrs.limitMax, 10) / base, view = parseInt($ctrl.$modelValue.toString().replace(/\./g, '').replace(',', '.'), 10) / base;
                                    view = view > limitMax ? limitMax : view;
                                    view = Math.round(view * Math.pow(10, limitFloat)) / Math.pow(10, limitFloat);
                                    $ctrl.$setViewValue(view);
                                    $ctrl.$render();
                                    return view.toString();
                                }
                                //Formatter for initial value
                                $ctrl.$formatters.push(function (viewValue) {
                                    var limitFloat = parseInt($attrs.limitFloat, 10);
                                    return $filter('number')(transformViewTo(), limitFloat);
                                });
                                //Parser for initial value
                                $ctrl.$parsers.push(function (modelValue) {
                                    var formattedModel = (modelValue.toString().replace(',', '.')) * 1;
                                    var base = parseInt($attrs.base, 10), limitMax = parseInt($attrs.limitMax, 10) / base, model = (formattedModel > limitMax ? limitMax : formattedModel);
                                    model = Math.round(model * base);
                                    return model;
                                });
                                var formatInput = function (e) {
                                    var limitFloat = $elem.val().indexOf(',') > -1 || $elem.val().indexOf('.') > -1 ? parseInt($attrs.limitFloat, 10) : 0;
                                    $elem.val($filter('number')(transformViewTo(), limitFloat));
                                };
                                $elem.bind('paste cut change keypress keyup', function ($event) {
                                    //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                    var ignoreKeys = [8, 48, 46, 37, 38, 39, 40, 190, 110, 188, 44];
                                    /*
                                    
                                              if ( ($elem.val().match(/./g) || []).length > 1 ) {
                                                $ctrl.$rollbackViewValue();
                                                return;
                                              }
                                    */
                                    if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                        $browser.defer(formatInput);
                                    }
                                });
                            }
                        };
                    }
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        'use strict';
                        var DataManagerDataControlTagController = (function () {
                            /* @ngInject */
                            function DataManagerDataControlTagController($state, $rootScope, $scope, $location, $anchorScroll, $modal, dataManagerService, userService, dataManagerSeeService) {
                                this.$state = $state;
                                this.$rootScope = $rootScope;
                                this.$scope = $scope;
                                this.$location = $location;
                                this.$anchorScroll = $anchorScroll;
                                this.$modal = $modal;
                                this.dataManagerService = dataManagerService;
                                this.userService = userService;
                                this.dataManagerSeeService = dataManagerSeeService;
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                                this.rootScope = $rootScope;
                            }
                            DataManagerDataControlTagController.prototype.getMaxLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            DataManagerDataControlTagController.prototype.getDataControlList = function () {
                                return this.dataManagerService.getDataControlList();
                            };
                            ;
                            DataManagerDataControlTagController.prototype.getDisplayNameCTN = function () {
                                return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                            };
                            DataManagerDataControlTagController.prototype.getAlertsRecipientCTN = function () {
                                return this.dataManagerService.getAlertsRecipientCTN();
                            };
                            ;
                            DataManagerDataControlTagController.prototype.getBase = function () {
                                return this.dataManagerService.getConfig().basic.dataConversion;
                            };
                            DataManagerDataControlTagController.prototype.getDataLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            DataManagerDataControlTagController.prototype.isIndividualSuspended = function (ctn) {
                                return this.dataManagerService.isTabDisabled(ctn);
                            };
                            DataManagerDataControlTagController.prototype.getTagIcon = function () {
                                var tagIcon = ((!this.dataManagerService.getDataAccessCTN(this.scope.ctn) || this.scope.useAlert === 'false') ? 'alertsOff' : 'alertsOn');
                                if (!this.dataManagerService.hasDataCTN(this.scope.ctn)) {
                                    tagIcon = 'dataOff';
                                }
                                return tagIcon;
                            };
                            DataManagerDataControlTagController.prototype.goToIndividualSummary = function (ctn, hash) {
                                var _this = this;
                                this.dataManagerService.setWirelessCTN(ctn);
                                this.dataManagerService.setIndividualSummaryCTN(ctn);
                                this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerIndividualSummary.subState).then(function () {
                                    if (hash) {
                                        _this.$location.hash(hash);
                                        _this.$anchorScroll.yOffset = 65;
                                        _this.$anchorScroll();
                                    }
                                    else {
                                        _this.$location.hash('');
                                        _this.$anchorScroll();
                                    }
                                });
                            };
                            DataManagerDataControlTagController.prototype.goToManageAlerts = function (index) {
                                this.dataManagerService.setDataManagerActiveTabIndex(index);
                                this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerAccountsSummary.subState);
                            };
                            DataManagerDataControlTagController.prototype.goToWireless = function (ctn) {
                                this.dataManagerService.setWirelessCTN(ctn);
                                this.dataManagerService.goToWirelessState();
                            };
                            DataManagerDataControlTagController.prototype.errorModalPopup = function (primary, secondary) {
                                var errorModalScope = this.rootScope.$new();
                                errorModalScope.params = { primary: primary, secondary: secondary };
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                    controllerAs: 'dataManagerGenericModal',
                                    size: 'md',
                                    backdrop: 'static',
                                    scope: errorModalScope
                                });
                            };
                            // Code to support Modal for of primary notifiaction recipient
                            DataManagerDataControlTagController.prototype.requestChangeModal = function ($event) {
                                this.openModalPopup();
                            };
                            DataManagerDataControlTagController.prototype.openModalPopup = function () {
                                var _this = this;
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                    controllerAs: 'dataManagerAlertsRecipientModal',
                                    size: 'md',
                                    backdrop: 'static'
                                }).result.then(function (result) {
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            _this.modalUserAnswerYes();
                                            break;
                                        case 'no':
                                            _this.modalUserAnswerNo();
                                            break;
                                        case 'error':
                                            _this.errorModalPopup('ute.dataManager.dataControlTag.errorHeading', 'ute.dataManager.dataControlTag.errorSecondary');
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                    _this.modalDismissed();
                                });
                            };
                            DataManagerDataControlTagController.prototype.modalUserAnswerYes = function () {
                                // console.log ('User answer - YES');
                            };
                            DataManagerDataControlTagController.prototype.modalUserAnswerNo = function () {
                                // console.log ('User answer - NO');
                            };
                            DataManagerDataControlTagController.prototype.modalDismissed = function () {
                                // console.log ('User answer - MEH');
                            };
                            DataManagerDataControlTagController.prototype.getDataUsedPrecision = function () {
                                return (this.scope.dataUsed * 1 > this.getBase() ? 2 : 0);
                            };
                            DataManagerDataControlTagController.prototype.getDataAlertAtPrecision = function () {
                                return (this.scope.dataAlertAt > this.getBase() ? 2 : 0);
                            };
                            DataManagerDataControlTagController.prototype.getColorBlockClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getDisplayNameClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getCTNClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getJoinedGroupClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getBottomContainerClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getClickAreaClass = function (ctn) {
                                return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabledRight' : '';
                            };
                            DataManagerDataControlTagController.prototype.showClickArea = function () {
                                return this.scope.buttonMode === 'true' && this.scope.groupStatus !== this.getGroupStatusCode().LEFT;
                            };
                            DataManagerDataControlTagController.prototype.getAlertClass = function (ctn) {
                                return ''; //(this.scope.status === 'cancelled' || this.isAccountLeftGroup(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                            };
                            DataManagerDataControlTagController.prototype.getTagIconClass = function (ctn) {
                                return this.isAccountSuspended(ctn) ? 'ute-dataManager-dataControlTag-tagIcon-suspended' : 'ute-dataManager-dataControlTag-tagIcon';
                            };
                            DataManagerDataControlTagController.prototype.getChevronIconClass = function (ctn) {
                                return this.isAccountSuspended(ctn) ? 'ute-dataManager-dataControlTag-chevron-suspended' : 'ute-dataManager-dataControlTag-chevron';
                            };
                            DataManagerDataControlTagController.prototype.showChevronIcon = function (ctn) {
                                return this.scope.buttonMode === 'true' && !(this.isAccountCancelled(ctn)) && !(this.isIndividualSuspended(ctn));
                            };
                            DataManagerDataControlTagController.prototype.getGroupStatusCode = function () {
                                return this.dataManagerService.getGroupStatusCode();
                            };
                            DataManagerDataControlTagController.prototype.getStatusCode = function () {
                                return this.dataManagerService.getStatusCode();
                            };
                            DataManagerDataControlTagController.prototype.getStatus = function (ctn) {
                                return this.dataManagerService.getAccountLineByCTN(ctn).status;
                            };
                            DataManagerDataControlTagController.prototype.getGroupStatus = function (ctn) {
                                return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                            };
                            DataManagerDataControlTagController.prototype.isAccountJoined = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().JOINED);
                            };
                            DataManagerDataControlTagController.prototype.isAccountActiveInGroup = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().ACTIVE);
                            };
                            DataManagerDataControlTagController.prototype.isAccountLeftGroup = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().LEFT);
                            };
                            DataManagerDataControlTagController.prototype.isAccountSuspended = function (ctn) {
                                return (this.getStatus(ctn) === this.getStatusCode().SUSPENDED);
                            };
                            DataManagerDataControlTagController.prototype.isAccountCancelled = function (ctn) {
                                return (this.getStatus(ctn) === this.getStatusCode().CANCELLED);
                            };
                            DataManagerDataControlTagController.prototype.getIconClass = function (colorCode) {
                                return this.dataManagerService.getColorCodeClass(colorCode);
                            };
                            DataManagerDataControlTagController.prototype.getIsVideoThrottlePermitted = function () {
                                return this.dataManagerService.getIsVideoThrottlePermitted();
                            };
                            DataManagerDataControlTagController.prototype.getLabelCopy = function (label) {
                                var rogersWirelessCopy = 'ute.rogers.wireless.' + label;
                                var dataControlTagCopy = 'ute.dataManager.dataControlTag.' + label;
                                return this.dataManagerService.getIsVideoThrottlePermitted() ? dataControlTagCopy : rogersWirelessCopy;
                            };
                            DataManagerDataControlTagController.$inject = ['$state', '$rootScope', '$scope', '$location', '$anchorScroll', '$modal', 'ute.data.manager.service', 'ute.common.user.service', 'ute.data.manager.see.service'];
                            return DataManagerDataControlTagController;
                        }());
                        tag.DataManagerDataControlTagController = DataManagerDataControlTagController;
                        angular.module('ute.data.manager.data.control.tag').controller('ute.data.manager.data.control.tag.controller', DataManagerDataControlTagController);
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var tag;
                    (function (tag) {
                        'use strict';
                        angular.module('ute.data.manager.data.control.tag').directive('uteDataManagerDataControlTag', uteDataManagerDataControlTag);
                        uteDataManagerDataControlTag.$inject = ['$timeout', 'ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerDataControlTag($timeout, dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: {
                                    'colorCode': '@',
                                    'displayName': '@',
                                    'ctn': '@',
                                    'dataAlertAt': '@',
                                    'status': '@',
                                    'groupStatus': '@',
                                    'dataUsed': '@',
                                    'isAlertsRecipient': '@',
                                    'dataAccess': '@',
                                    'buttonMode': '@',
                                    'useAlert': '@',
                                    'index': '@',
                                    'videoQualityReduced': '@'
                                },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerDataControlTagDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerDataControlTagDirective.controllerName,
                                controllerAs: 'dataManagerDataControlTag',
                                link: function (scope, element, attrs, controller) {
                                    $timeout(function () {
                                        var alert = angular.element(element[0].getElementsByClassName('ute-dataManagerDataControlTag-alertIcon'));
                                        alert.css('fill', scope.colorCode);
                                    }, 1);
                                }
                            };
                        }
                    })(tag = control.tag || (control.tag = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var increase;
            (function (increase) {
                var plan;
                (function (plan) {
                    'use strict';
                    var DataManagerIncreasePlanModalController = (function () {
                        /* @ngInject */
                        function DataManagerIncreasePlanModalController($scope, $modalInstance, dataManagerService) {
                            this.$scope = $scope;
                            this.$modalInstance = $modalInstance;
                            this.dataManagerService = dataManagerService;
                            this.model = this.dataManagerService.getModel();
                            this.scope = $scope;
                            this.selectedPlan = null;
                            this.showWcocConsent = false;
                        }
                        DataManagerIncreasePlanModalController.prototype.noSelection = function () {
                            this.$modalInstance.dismiss('cancel');
                        };
                        DataManagerIncreasePlanModalController.prototype.closeModal = function (answer, idx) {
                            var passBack = {};
                            passBack.answer = answer;
                            passBack.idx = idx || -1;
                            this.$modalInstance.close(passBack);
                        };
                        DataManagerIncreasePlanModalController.prototype.increaseDataModal = function (idx) {
                            var ctrl = this;
                            if (idx > -1) {
                                this.dataManagerService.purchaseDataProductAPI(idx)
                                    .then(function (result) {
                                    if (result && result.data) {
                                        var body = result.data.body || {};
                                        var error = result.data.error || {};
                                        if (body.isSuccess) {
                                            ctrl.closeModal('yes', idx);
                                        }
                                        else {
                                            if (ctrl.dataManagerService.getIsFdmWcocPermitted()
                                                && (error.code === '25' || error.type === 'WCOC')) {
                                                ctrl.selectedPlan = ctrl.dataManagerService.getModel().increaseDataOptions[idx];
                                                ctrl.selectedPlan.index = idx;
                                                //Show consent modal
                                                ctrl.showWcocConsent = true;
                                            }
                                            else {
                                                ctrl.closeModal('error', -1);
                                            }
                                        }
                                    }
                                    else {
                                        ctrl.closeModal('error', -1);
                                    }
                                })
                                    .catch(function () {
                                    ctrl.closeModal('error', -1);
                                });
                            }
                        };
                        DataManagerIncreasePlanModalController.prototype.proceedWithConsent = function (selectedDataPlanIndex) {
                            var ctrl = this;
                            this.closeModal('proceedWithConsent', ctrl.selectedPlan.index);
                        };
                        DataManagerIncreasePlanModalController.prototype.getWcocConsentCallInProgress = function () {
                            return this.dataManagerService.getWcocConsentCallInProgress();
                        };
                        DataManagerIncreasePlanModalController.$inject = ['$scope', '$modalInstance', 'ute.data.manager.service'];
                        return DataManagerIncreasePlanModalController;
                    }());
                    plan.DataManagerIncreasePlanModalController = DataManagerIncreasePlanModalController;
                    angular.module('ute.data.manager.increase.plan').controller('ute.data.manager.increase.plan.modal.controller', DataManagerIncreasePlanModalController);
                })(plan = increase.plan || (increase.plan = {}));
            })(increase = manager.increase || (manager.increase = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var list;
                    (function (list) {
                        'use strict';
                        var DataManagerAlertsRecipientModalController = (function () {
                            /* @ngInject */
                            function DataManagerAlertsRecipientModalController($scope, $rootScope, $modalInstance, dataManagerService, $translate, $filter, messagesService) {
                                this.$scope = $scope;
                                this.$rootScope = $rootScope;
                                this.$modalInstance = $modalInstance;
                                this.dataManagerService = dataManagerService;
                                this.$translate = $translate;
                                this.$filter = $filter;
                                this.messagesService = messagesService;
                                this.showSucces = false;
                                this.showError = false;
                                this.selectedCTN = this.getDefaultDisplayCTN();
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                                this.continueBtnText = this.$translate.instant('ute.dataManager.alertRecipientModal.continueButton');
                                this.cancelBtnText = this.$translate.instant('ute.dataManager.alertRecipientModal.cancel');
                            }
                            DataManagerAlertsRecipientModalController.prototype.getDataControlList = function () {
                                return this.dataManagerService.getDataControlList();
                            };
                            DataManagerAlertsRecipientModalController.prototype.validateAccountLine = function (accountLine) {
                                /*if ( accountLine.hasData && accountLine.hasText && accountLine.hasTalk ) {
                                  return true;
                                } else {
                                  return false;
                                }*/
                                return true;
                            };
                            DataManagerAlertsRecipientModalController.prototype.isSuccess = function () {
                                return this.showSucces;
                            };
                            DataManagerAlertsRecipientModalController.prototype.isError = function () {
                                return this.showError;
                            };
                            DataManagerAlertsRecipientModalController.prototype.getSetDataManagerCallInProgress = function () {
                                return this.dataManagerService.getSetDataManagerCallInProgress();
                            };
                            DataManagerAlertsRecipientModalController.prototype.getDefaultDisplayCTN = function () {
                                return ((this.dataManagerService.getAlertsRecipientCTN() === null) ? (this.dataManagerService.getDataControlList().length > 0 ? this.dataManagerService.getDataControlList()[0].ctn : '') : this.dataManagerService.getAlertsRecipientCTN());
                            };
                            DataManagerAlertsRecipientModalController.prototype.getDataManagerOptionLabel = function (line) {
                                return line.displayName + this.$translate.instant('ute.dataManager.alertRecipientModal.colon') + ' ' + this.$filter('ute_common_filter_phone')(line.ctn, '$1 $2-$3');
                            };
                            DataManagerAlertsRecipientModalController.prototype.noSelection = function () {
                                this.$modalInstance.dismiss('cancel');
                            };
                            DataManagerAlertsRecipientModalController.prototype.continue = function () {
                                this.dataManagerService.setDataManagerAPI(this.selectedCTN);
                                //TODO: handle yes/no based on response
                                this.$modalInstance.close('yes');
                            };
                            DataManagerAlertsRecipientModalController.prototype.cancel = function () {
                                this.$modalInstance.close('no');
                            };
                            DataManagerAlertsRecipientModalController.prototype.continueVerified = function (ctn) {
                                // var ctrl: any = this;
                                var _this = this;
                                var accountLine = this.dataManagerService.getAccountLineByCTN(ctn);
                                if (this.validateAccountLine(accountLine)) {
                                    this.showError = false;
                                    this.dataManagerService.setDataManagerAPI(this.selectedCTN).then(function (result) {
                                        if (result.data && result.data.body && result.data.body.isSuccess) {
                                            _this.dataManagerService.setAlertsRecipientCTN(_this.selectedCTN);
                                            _this.$modalInstance.close('yes');
                                        }
                                        else {
                                            _this.$modalInstance.close('error');
                                        }
                                    });
                                }
                                else {
                                    this.showError = true;
                                }
                            };
                            DataManagerAlertsRecipientModalController.$inject = ['$scope',
                                '$rootScope',
                                '$modalInstance',
                                'ute.data.manager.service',
                                '$translate',
                                '$filter',
                                'ute.blocks.messages.bus.service'];
                            return DataManagerAlertsRecipientModalController;
                        }());
                        list.DataManagerAlertsRecipientModalController = DataManagerAlertsRecipientModalController;
                        angular.module('ute.data.manager.data.control.list').controller('ute.data.manager.alerts.recipient.modal.controller', DataManagerAlertsRecipientModalController);
                    })(list = control.list || (control.list = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data_1) {
        var manager;
        (function (manager) {
            var data;
            (function (data) {
                var control;
                (function (control) {
                    var list;
                    (function (list) {
                        'use strict';
                        // import IDataManagerAccountLine = ute.data.manager.service.IDataManagerAccountLine;
                        var DataManagerGenericModalController = (function () {
                            /* @ngInject */
                            function DataManagerGenericModalController($scope, $modalInstance, dataManagerService) {
                                this.$scope = $scope;
                                this.$modalInstance = $modalInstance;
                                this.dataManagerService = dataManagerService;
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                                if (this.dataManagerService.getIsVideoThrottlePermitted() && this.dataManagerService.getDataAlertsActiveTabIndex() === 1) {
                                    this.dataManagerService.trackDataLayerInteraction(this.dataManagerService.getDataLayerStep().error, this.dataManagerService.getDataLayerEvent().viewErrorModal, $scope.params.trackData);
                                }
                            }
                            DataManagerGenericModalController.prototype.noSelection = function () {
                                this.$modalInstance.dismiss('cancel');
                            };
                            DataManagerGenericModalController.prototype.continue = function () {
                                this.$modalInstance.close('yes');
                            };
                            DataManagerGenericModalController.prototype.cancel = function () {
                                this.$modalInstance.close('no');
                            };
                            DataManagerGenericModalController.prototype.getOkButtonCopy = function () {
                                return this.dataManagerService.getIsVideoThrottlePermitted() ? 'ute.dataManager.genericModal.button2' : 'ute.dataManager.genericModal.button';
                            };
                            DataManagerGenericModalController.$inject = ['$scope', '$modalInstance', 'ute.data.manager.service'];
                            return DataManagerGenericModalController;
                        }());
                        list.DataManagerGenericModalController = DataManagerGenericModalController;
                        angular.module('ute.data.manager.modals').controller('ute.data.manager.modals.generic.modal.controller', DataManagerGenericModalController);
                    })(list = control.list || (control.list = {}));
                })(control = data.control || (data.control = {}));
            })(data = manager.data || (manager.data = {}));
        })(manager = data_1.manager || (data_1.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var modals;
            (function (modals) {
                'use strict';
                var DataManagerModalsAlertsOverDataLimitController = (function () {
                    /* @ngInject */
                    function DataManagerModalsAlertsOverDataLimitController($scope, $modalInstance, dataManagerService) {
                        this.$scope = $scope;
                        this.$modalInstance = $modalInstance;
                        this.dataManagerService = dataManagerService;
                        this.model = this.dataManagerService.getModel();
                        this.scope = $scope;
                    }
                    DataManagerModalsAlertsOverDataLimitController.prototype.noSelection = function () {
                        this.$modalInstance.dismiss('cancel');
                    };
                    DataManagerModalsAlertsOverDataLimitController.prototype.continue = function () {
                        this.$modalInstance.close('yes');
                    };
                    DataManagerModalsAlertsOverDataLimitController.$inject = ['$scope', '$modalInstance', 'ute.data.manager.service'];
                    return DataManagerModalsAlertsOverDataLimitController;
                }());
                modals.DataManagerModalsAlertsOverDataLimitController = DataManagerModalsAlertsOverDataLimitController;
                angular.module('ute.data.manager.modals').controller('ute.data.manager.modals.alerts.over.data.limit.controller', DataManagerModalsAlertsOverDataLimitController);
            })(modals = manager.modals || (manager.modals = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var list;
                        (function (list) {
                            'use strict';
                            var DataManagerVideoThrottleModalController = (function () {
                                /* @ngInject */
                                function DataManagerVideoThrottleModalController($scope, $modalInstance, dataManagerService, messagesService) {
                                    this.$scope = $scope;
                                    this.$modalInstance = $modalInstance;
                                    this.dataManagerService = dataManagerService;
                                    this.messagesService = messagesService;
                                    this.showSucces = false;
                                    this.showError = false;
                                    this.selectedCTN = this.getDefaultDisplayCTN();
                                    this.doNotShowModal = false;
                                    this.model = this.dataManagerService.getModel();
                                    this.scope = $scope;
                                }
                                DataManagerVideoThrottleModalController.prototype.getDataControlList = function () {
                                    return this.dataManagerService.getDataControlList();
                                };
                                DataManagerVideoThrottleModalController.prototype.validateAccountLine = function (accountLine) {
                                    /*if ( accountLine.hasData && accountLine.hasText && accountLine.hasTalk ) {
                                      return true;
                                    } else {
                                      return false;
                                    }*/
                                    return true;
                                };
                                DataManagerVideoThrottleModalController.prototype.isSuccess = function () {
                                    return this.showSucces;
                                };
                                DataManagerVideoThrottleModalController.prototype.isError = function () {
                                    return this.showError;
                                };
                                DataManagerVideoThrottleModalController.prototype.addDataClick = function () {
                                    this.messagesService.publish('ute-data-manager-increase-plan-button-click-' + this.scope.topUpTarget);
                                    this.$modalInstance.dismiss('cancel');
                                };
                                DataManagerVideoThrottleModalController.prototype.isAllowedToPurchaseData = function () {
                                    return this.dataManagerService.isAllowedToPurchaseData();
                                };
                                DataManagerVideoThrottleModalController.prototype.getColorCodeCTN = function () {
                                    return this.dataManagerService.getColorCodeCTN(this.scope.ctn);
                                };
                                DataManagerVideoThrottleModalController.prototype.getDefaultDisplayCTN = function () {
                                    return ((this.dataManagerService.getAlertsRecipientCTN() === null) ? this.dataManagerService.getDataControlList()[0].ctn : this.dataManagerService.getAlertsRecipientCTN());
                                };
                                DataManagerVideoThrottleModalController.prototype.getDisplayNameCTN = function () {
                                    return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                                };
                                DataManagerVideoThrottleModalController.prototype.noSelection = function () {
                                    this.$modalInstance.dismiss({
                                        result: 'cancel'
                                    });
                                };
                                DataManagerVideoThrottleModalController.prototype.continue = function () {
                                    this.$modalInstance.close({
                                        result: 'yes',
                                        doNotShowModal: this.doNotShowModal
                                    });
                                };
                                DataManagerVideoThrottleModalController.prototype.cancel = function () {
                                    this.$modalInstance.close({
                                        result: 'no'
                                    });
                                };
                                DataManagerVideoThrottleModalController.prototype.continueVerified = function (ctn) {
                                    var accountLine = this.dataManagerService.getAccountLineByCTN(ctn);
                                    if (this.validateAccountLine(accountLine)) {
                                        this.showError = false;
                                        this.dataManagerService.setAlertsRecipientCTN(this.selectedCTN);
                                        this.$modalInstance.close('yes');
                                    }
                                    else {
                                        this.showError = true;
                                    }
                                };
                                DataManagerVideoThrottleModalController.$inject = ['$scope', '$modalInstance', 'ute.data.manager.service', 'ute.blocks.messages.bus.service'];
                                return DataManagerVideoThrottleModalController;
                            }());
                            list.DataManagerVideoThrottleModalController = DataManagerVideoThrottleModalController;
                            angular.module('ute.data.manager.video.throttle.control.list').controller('ute.data.manager.video.throttle.modal.controller', DataManagerVideoThrottleModalController);
                        })(list = control.list || (control.list = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
                var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                var ProviderBase = ute.common.core.ProviderBase;
                var UtilsStatic = ute.common.utils.UtilsStatic;
                var DataManagerServerGetUsageDetails = (function () {
                    function DataManagerServerGetUsageDetails() {
                    }
                    return DataManagerServerGetUsageDetails;
                }());
                var DataManagerServerSubscription = (function () {
                    function DataManagerServerSubscription() {
                    }
                    return DataManagerServerSubscription;
                }());
                var DataManagerServerPurchasedDataProduct = (function () {
                    function DataManagerServerPurchasedDataProduct() {
                    }
                    return DataManagerServerPurchasedDataProduct;
                }());
                /**
                 * worker return cached result and implement refresh true/false retry logic
                 */
                var DataManagerServerGetUsageDetailsWorker = (function (_super) {
                    __extends(DataManagerServerGetUsageDetailsWorker, _super);
                    function DataManagerServerGetUsageDetailsWorker(config, securityService, $http, $q, $timeout, userService, request) {
                        var _this = this;
                        _super.call(this, new DataManagerServerGetUsageDetails(), config, securityService, $http, $q, $timeout, userService, request);
                        this.isDataManagerServerGetUsageDetailsCallInProgress = this.isCallInProgress;
                        this.getDataManagerServerGetUsageDetails = this.getData;
                        this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                        this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                        /**
                         * @override
                         *
                         */
                        this.resetCachedData = function () {
                            _this.resetData();
                        };
                        /**
                         * @override
                         *
                         */
                        this.forceGetUsageDetails = function () {
                            _this.resetData();
                            return _this.getDataManagerServerGetUsageDetails();
                        };
                        /**
                         * @override
                         * @param dataManagerServerGetUsageDetails
                         * @returns {IDataManagerServerGetUsageDetails}
                         */
                        this.normalizeData = function (dataManagerServerGetUsageDetails) {
                            dataManagerServerGetUsageDetails.body.billCycle.daysUntilEndDate = Number(dataManagerServerGetUsageDetails.body.billCycle.daysUntilEndDate);
                            dataManagerServerGetUsageDetails.body.billCycle.endDate = moment(dataManagerServerGetUsageDetails.body.billCycle.endDate, 'YYYY-MM-DD').toDate();
                            dataManagerServerGetUsageDetails.body.billCycle.startDate = moment(dataManagerServerGetUsageDetails.body.billCycle.startDate, 'YYYY-MM-DD').toDate();
                            dataManagerServerGetUsageDetails.body.billCycle.nextStartDate = moment(dataManagerServerGetUsageDetails.body.billCycle.nextStartDate, 'YYYY-MM-DD').toDate();
                            dataManagerServerGetUsageDetails.body.subscriptionList = dataManagerServerGetUsageDetails.body.subscriptionList.map(function (sub) {
                                sub.effectiveDate = new Date(sub.effectiveDate);
                                sub.includesData = Boolean(sub.includesData);
                                sub.isDataAccessBlocked = Boolean(sub.isDataAccessBlocked);
                                sub.isPrimaryCtn = Boolean(sub.isPrimaryCtn);
                                sub.isSharingData = Boolean(sub.isSharingData);
                                sub.totalDataUsed = Number(sub.totalDataUsed);
                                sub.dataAlert.isActive = Boolean(sub.dataAlert.isActive);
                                sub.dataAlert.threshold = Number(sub.dataAlert.threshold);
                                return _.assign(new DataManagerServerSubscription(), sub);
                            });
                            dataManagerServerGetUsageDetails.body.dataPurchaseList = dataManagerServerGetUsageDetails.body.dataPurchaseList.map(function (dataPurchase) {
                                dataPurchase.cost = Number(dataPurchase.cost);
                                dataPurchase.size = Number(dataPurchase.size);
                                return _.assign(new DataManagerServerPurchasedDataProduct(), dataPurchase);
                            });
                            dataManagerServerGetUsageDetails.body.isAllowedToPurchaseData = Boolean(dataManagerServerGetUsageDetails.body.isAllowedToPurchaseData);
                            dataManagerServerGetUsageDetails.body.isDataManagerEligible = Boolean(dataManagerServerGetUsageDetails.body.isDataManagerEligible);
                            dataManagerServerGetUsageDetails.body.isPlanChanged = Boolean(dataManagerServerGetUsageDetails.body.isPlanChanged);
                            dataManagerServerGetUsageDetails.body.planSize = Number(dataManagerServerGetUsageDetails.body.planSize);
                            dataManagerServerGetUsageDetails.body.planUpsellSize = Number(dataManagerServerGetUsageDetails.body.planUpsellSize);
                            dataManagerServerGetUsageDetails.body.totalDataUsage = Number(dataManagerServerGetUsageDetails.body.totalDataUsage);
                            dataManagerServerGetUsageDetails.body.bucketSizeUnavailableUntilNextBillCycle = Boolean(dataManagerServerGetUsageDetails.body.bucketSizeUnavailableUntilNextBillCycle);
                            dataManagerServerGetUsageDetails.body.dataUsageMayBeInaccurateDueToPlanChange = Boolean(dataManagerServerGetUsageDetails.body.dataUsageMayBeInaccurateDueToPlanChange);
                            return dataManagerServerGetUsageDetails;
                        };
                    }
                    ;
                    return DataManagerServerGetUsageDetailsWorker;
                }(CacheableDataGeneric));
                //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                /**
                 * only one worker exists for the same request
                 */
                var DataManagerServerGetUsageDetailsFactory = (function () {
                    function DataManagerServerGetUsageDetailsFactory(config, securityService, $http, $q, $timeout, userService) {
                        var _this = this;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this._getWorker = function (request) {
                            return new DataManagerServerGetUsageDetailsWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, request);
                        };
                        this.getWorker = _.memoize(this._getWorker, UtilsStatic.memoizeResolver);
                    }
                    ;
                    return DataManagerServerGetUsageDetailsFactory;
                }());
                //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                /**
                 * Provider only responsable for configuration and to return factory
                 */
                var DataManagerServerGetUsageDetailsProvider = (function (_super) {
                    __extends(DataManagerServerGetUsageDetailsProvider, _super);
                    /* @ngInject */
                    function DataManagerServerGetUsageDetailsProvider(dataManagerProvider) {
                        var _this = this;
                        _super.call(this);
                        this.dataManagerProvider = dataManagerProvider;
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q, $timeout) {
                            var factory = new DataManagerServerGetUsageDetailsFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'));
                            return function (request) { return factory.getWorker(request); };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$q',
                            '$timeout'
                        ];
                        this.config = {
                            basic: {
                                applicationId: dataManagerProvider.getConfig().basic.applicationId,
                                partialApiUrl: dataManagerProvider.getConfig().basic.dataManagerGetUsageDetailsAPI,
                                logPrefix: 'DataManagerServerGetUsageDetails',
                                logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                isCachableOnBackend: false
                            }
                        };
                    }
                    ;
                    DataManagerServerGetUsageDetailsProvider.$inject = ['ute.data.manager.serviceProvider'];
                    return DataManagerServerGetUsageDetailsProvider;
                }(ProviderBase));
                angular.module('ute.data.manager.service').provider('ute.data.manager.service.factory', DataManagerServerGetUsageDetailsProvider);
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

/*
module ute.data.manager.service {
  'use strict';

  import IAccountOverviewSummary =  ute.rogers.account.overview.service.IAccountOverviewSummary; //ute.rogers.account.overview.service.IAccountOverviewSummary;
  /!**
   * Main data manager model
   *!/
  export interface IDataManagerSummary extends IAccountOverviewSummary {

    isDataManagerEligible: boolean;

  }
}
*/

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var upgrade;
            (function (upgrade) {
                var plan;
                (function (plan) {
                    'use strict';
                    var DataManagerWirelessRemovePlanModalController = (function () {
                        /* @ngInject */
                        function DataManagerWirelessRemovePlanModalController($rootScope, $modalInstance, $translate, userService) {
                            this.$rootScope = $rootScope;
                            this.$modalInstance = $modalInstance;
                            this.$translate = $translate;
                            this.userService = userService;
                            this.chatLinkChangePlan = {
                                en: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=10&lctc=10%7C01%7Cws%7Cchange_wireless_plan_en ',
                                fr: 'http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=60&lctc=60%7C01%7Cws%7Cchange_wireless_plan_fr'
                            };
                            this.chatHref = this.$translate.use() === 'en' ? this.chatLinkChangePlan.en : this.chatLinkChangePlan.fr; /// 'cuscare_ECare_landing.php?hm=n&s=701',
                        }
                        DataManagerWirelessRemovePlanModalController.prototype.ok = function () {
                            this.$modalInstance.close('ok');
                            this.$rootScope.modal = null;
                        };
                        ;
                        DataManagerWirelessRemovePlanModalController.prototype.cancel = function () {
                            this.$modalInstance.dismiss('cancel');
                            this.$rootScope.modal = null;
                        };
                        ;
                        DataManagerWirelessRemovePlanModalController.prototype.getViewAllPlansLink = function () {
                            return '/web/content/wireless_plan_landing?setLanguage=' + this.$translate.use();
                        };
                        /**
                         * disable Upgrade Plan button for Care
                         */
                        DataManagerWirelessRemovePlanModalController.prototype.isDmCare = function () {
                            return this.userService.isCare();
                        };
                        DataManagerWirelessRemovePlanModalController.$inject = [
                            '$rootScope',
                            '$modalInstance',
                            '$translate'
                        ];
                        return DataManagerWirelessRemovePlanModalController;
                    }());
                    plan.DataManagerWirelessRemovePlanModalController = DataManagerWirelessRemovePlanModalController;
                    angular.module('ute.data.manager.upgrade.plan').controller('ute.data.manager.wireless.remove.plan.modal.controller', DataManagerWirelessRemovePlanModalController);
                })(plan = upgrade.plan || (upgrade.plan = {}));
            })(upgrade = manager.upgrade || (manager.upgrade = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        var DataManagerVideoThrottleControlController = (function () {
                            /* @ngInject */
                            function DataManagerVideoThrottleControlController($scope, $rootScope, $modal, $timeout, $window, dataManagerService, dtmService, messagesService) {
                                this.$scope = $scope;
                                this.$rootScope = $rootScope;
                                this.$modal = $modal;
                                this.$timeout = $timeout;
                                this.$window = $window;
                                this.dataManagerService = dataManagerService;
                                this.dtmService = dtmService;
                                this.messagesService = messagesService;
                                this.model = this.dataManagerService.getModel();
                                this.scope = $scope;
                                this.rootScope = $rootScope;
                                this.timeout = $timeout;
                            }
                            DataManagerVideoThrottleControlController.prototype.showSaveCheck = function (dataAlertAt) {
                                var base = 1;
                                var savedValue = this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn)) === -1 ? -1 : Math.round(this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn)) / base) * base;
                                return (savedValue !== Math.round(dataAlertAt / base) * base) && (this.scope.dataAccess === 'true') && this.scope.useAlert;
                            };
                            DataManagerVideoThrottleControlController.prototype.getIndicatorWidth = function () {
                                return this.scope.getDataIndicatorWidth();
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataAccessCTN = function () {
                                return this.dataManagerService.getDataAccessCTN(this.scope.ctn);
                            };
                            DataManagerVideoThrottleControlController.prototype.getSaveAlertCallInProgress = function () {
                                return this.dataManagerService.getSaveAlertCallInProgress();
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataLimit = function () {
                                return this.dataManagerService.getDataLimit();
                            };
                            /**
                             * Calculate the incremental Step based on data plan limit
                             */
                            DataManagerVideoThrottleControlController.prototype.getSliderStep = function () {
                                return this.dataManagerService.getSliderStep();
                            };
                            DataManagerVideoThrottleControlController.prototype.getBase = function () {
                                return this.scope.dataAlertAt >= 1000 ? this.dataManagerService.getConfig().basic.dataConversion : this.dataManagerService.getConfig().basic.dataConversionRoundValues;
                            };
                            DataManagerVideoThrottleControlController.prototype.goToWireless = function (ctn) {
                                this.dataManagerService.setWirelessCTN(ctn);
                                this.dataManagerService.goToWirelessState();
                            };
                            DataManagerVideoThrottleControlController.prototype.getDisplayNameCTN = function () {
                                return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                            };
                            DataManagerVideoThrottleControlController.prototype.alertThresholdCheck = function () {
                                if (this.dataManagerService.getSavedAlertedDataTotal() > this.dataManagerService.getDataLimit()) {
                                    this.alertsOverDataLimitModalPopup();
                                }
                            };
                            DataManagerVideoThrottleControlController.prototype.alertsOverDataLimitModalPopup = function () {
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerModals.alertsOverDataLimit.controllerName,
                                    controllerAs: 'dataManagerAlertsOverDataLimitModal',
                                    size: 'md',
                                    backdrop: 'static'
                                }).result.then(function (result) {
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            break;
                                        case 'no':
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                });
                            };
                            DataManagerVideoThrottleControlController.prototype.saveAlertChange = function ($event) {
                                // var ctrl: any = this;
                                var _this = this;
                                var ctn = this.scope.ctn;
                                var threshold = this.scope.dataAlertAt;
                                this.dataManagerService.setDataAlertAPI(ctn, this.scope.useAlert, threshold)
                                    .then(function (result) {
                                    if (result.data && result.data.body && result.data.body.isSuccess) {
                                        _this.dataManagerService.setSavedAlertValue(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), _this.scope.dataManagerVideoThrottleControl.dataAlertAt);
                                        _this.alertThresholdCheck();
                                    }
                                    else {
                                        _this.errorModalPopup('ute.dataManager.videoThrottleControl.errorHeading', 'ute.dataManager.videoThrottleControl.errorSecondaryThreshold');
                                    }
                                })
                                    .catch(function () {
                                    _this.errorModalPopup('ute.dataManager.videoThrottleControl.errorHeading', 'ute.dataManager.videoThrottleControl.errorSecondaryThreshold');
                                });
                            };
                            DataManagerVideoThrottleControlController.prototype.isBucketSizeUnavailableUntilNextBillCycle = function () {
                                return this.dataManagerService.isBucketSizeUnavailableUntilNextBillCycle();
                            };
                            DataManagerVideoThrottleControlController.prototype.changeDisplayAlertedAmount = function ($event) {
                                this.dataManagerService.setDataLineAlertAt(this.dataManagerService.getIndexByCTN(this.scope.ctn), this.scope.dataManagerVideoThrottleControl.dataAlertAt);
                            };
                            DataManagerVideoThrottleControlController.prototype.setDataUseAlerts = function () {
                                // var ctrl: any = this;
                                var _this = this;
                                var ctn = this.scope.ctn;
                                var threshold = this.dataManagerService.getSavedAlertValue(this.dataManagerService.getIndexByCTN(this.scope.ctn));
                                this.dataManagerService.setDataAlertAPI(ctn, this.scope.useAlert, threshold)
                                    .then(function (result) {
                                    if (result.data && result.data.body && result.data.body.isSuccess) {
                                        _this.dataManagerService.setDataUseAlert(_this.dataManagerService.getIndexByCTN(_this.scope.ctn), _this.scope.useAlert);
                                    }
                                    else {
                                        var errorHeadingKey = 'ute.dataManager.videoThrottleControl.errorHeading';
                                        var errorMessageKey = (_this.scope.useAlert) ? 'ute.dataManager.videoThrottleControl.errorSecondaryUseAlertsOn' : 'ute.dataManager.videoThrottleControl.errorSecondaryUseAlertsOff';
                                        _this.errorModalPopup(errorHeadingKey, errorMessageKey);
                                        _this.scope.useAlert = !_this.scope.useAlert;
                                    }
                                })
                                    .catch(function () {
                                    var errorHeadingKey = 'ute.dataManager.videoThrottleControl.errorHeading';
                                    var errorMessageKey = (_this.scope.useAlert) ? 'ute.dataManager.videoThrottleControl.errorSecondaryUseAlertsOn' : 'ute.dataManager.videoThrottleControl.errorSecondaryUseAlertsOff';
                                    _this.errorModalPopup(errorHeadingKey, errorMessageKey);
                                    _this.scope.useAlert = !_this.scope.useAlert;
                                });
                            };
                            DataManagerVideoThrottleControlController.prototype.errorModalPopup = function (primary, secondary) {
                                var errorModalScope = this.rootScope.$new();
                                errorModalScope.params = { primary: primary, secondary: secondary };
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                    controllerAs: 'dataManagerGenericModal',
                                    size: 'md',
                                    backdrop: 'static',
                                    scope: errorModalScope
                                });
                            };
                            // Code to support Modal for of primary notifiaction recipient
                            DataManagerVideoThrottleControlController.prototype.requestChangeModal = function ($event) {
                                this.openModalPopup();
                            };
                            DataManagerVideoThrottleControlController.prototype.openModalPopup = function () {
                                var _this = this;
                                this.$modal.open({
                                    windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                    templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                    controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                    controllerAs: 'dataManagerAlertsRecipientModal',
                                    size: 'md',
                                    backdrop: 'static'
                                }).result.then(function (result) {
                                    // Result selection behaviour
                                    switch (result) {
                                        case 'yes':
                                            _this.modalUserAnswerYes();
                                            break;
                                        case 'no':
                                            _this.modalUserAnswerNo();
                                            break;
                                        case 'error':
                                            _this.errorModalPopup('ute.dataManager.videoThrottleControl.errorHeading', 'ute.dataManager.videoThrottleControl.errorSecondary');
                                            break;
                                    }
                                }, function () {
                                    // Dismiss behaviour
                                    // Do nothing/close
                                    _this.modalDismissed();
                                });
                            };
                            DataManagerVideoThrottleControlController.prototype.modalUserAnswerYes = function () {
                                // console.log ('User answer - YES');
                            };
                            DataManagerVideoThrottleControlController.prototype.modalUserAnswerNo = function () {
                                // console.log ('User answer - NO');
                            };
                            DataManagerVideoThrottleControlController.prototype.modalDismissed = function () {
                                // console.log ('User answer - MEH');
                            };
                            DataManagerVideoThrottleControlController.prototype.addDataToLine = function (ctn) {
                                // this.$window.location.href = this.dataManagerService.getConfig().basic.addDataToLineUrl;
                                if (this.dataManagerService.isCare()) {
                                    this.$window.sessionStorage.setItem('phoneNumber', ctn);
                                }
                                else {
                                    this.$window.localStorage.setItem('phoneNumber', ctn);
                                }
                                this.rootScope.$emit('wireless-dashboard-change-plan');
                            };
                            DataManagerVideoThrottleControlController.prototype.getDisplayNameClass = function (ctn) {
                                return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                            };
                            DataManagerVideoThrottleControlController.prototype.getDisplayNameMediumClass = function (ctn) {
                                return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                            };
                            DataManagerVideoThrottleControlController.prototype.getCTNClass = function (ctn) {
                                return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                            };
                            DataManagerVideoThrottleControlController.prototype.getMidSectionClass = function (ctn) {
                                return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn) ? 'ute-dataManager-dataControl-disabled' : '';
                            };
                            DataManagerVideoThrottleControlController.prototype.showMidSection = function (ctn) {
                                return this.isAccountSuspended(ctn) || this.isAccountCancelled(ctn) || this.isAccountJoined(ctn);
                            };
                            DataManagerVideoThrottleControlController.prototype.showUpperMidSection = function (ctn) {
                                return !this.isAccountSuspended(ctn) && !this.isAccountCancelled(ctn) && !this.isAccountJoined(ctn);
                            };
                            DataManagerVideoThrottleControlController.prototype.showAlertCopy = function () {
                                return (this.scope.dataAccess === 'true') && this.scope.useAlert;
                            };
                            DataManagerVideoThrottleControlController.prototype.showAlertOffCopy = function () {
                                return (this.scope.dataAccess === 'true') && !this.scope.useAlert;
                            };
                            DataManagerVideoThrottleControlController.prototype.showDisabledCopy = function () {
                                return (this.scope.dataAccess === 'false');
                            };
                            DataManagerVideoThrottleControlController.prototype.MCPPCAlert = function () {
                                return (this.scope.savedAlertValue < 0) ? 0 : this.scope.savedAlertValue;
                            };
                            DataManagerVideoThrottleControlController.prototype.showInputLabel = function () {
                                return (this.scope.dataAccess === 'true') && this.scope.useAlert;
                            };
                            DataManagerVideoThrottleControlController.prototype.getSliderClass = function () {
                                return 'ute-dataManager-dataControl-md-slider' + this.scope.lineIndex;
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataIndicatorClasses = function () {
                                return 'ute-dataManager-dataControl-dataIndicator' + this.scope.lineIndex + ' ' + (this.getIndicatorWidth() > 70 ? 'ute-dataManager-dataControl-dataIndicatorCopy' : 'ute-dataManager-dataControl-dataIndicatorBlack');
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataIndicatorStyles = function () {
                                return { 'margin-left': (this.getIndicatorWidth() > 70 ? 0 : this.getIndicatorWidth() + 10) + 'px' };
                            };
                            DataManagerVideoThrottleControlController.prototype.isSliderDisabled = function () {
                                return !this.scope.useAlert || !(this.scope.dataAccess === 'true') || this.getSaveAlertCallInProgress();
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataAlertPrecisionValue = function () {
                                return ((this.scope.dataAlertAt * 1) > this.getBase() ? 2 : 0);
                            };
                            DataManagerVideoThrottleControlController.prototype.getSavedAlertPrecisionValue = function () {
                                return ((this.scope.savedAlertValue * 1) > this.getBase() ? 2 : 0);
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataUsedBase = function () {
                                return (this.scope.dataLimit >= 1000 ? 1024 : 1000);
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataUsedPrecisionValue = function () {
                                return (this.scope.dataUsed > 1024 ? 1 : 0);
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataLimitBase = function () {
                                return (this.scope.dataLimit >= 1000 ? 1024 : 1000);
                            };
                            DataManagerVideoThrottleControlController.prototype.getDataLimitPrecision = function () {
                                return (this.scope.dataLimit >= 1024 ? 1 : 0);
                            };
                            DataManagerVideoThrottleControlController.prototype.getGroupStatusCode = function () {
                                return this.dataManagerService.getGroupStatusCode();
                            };
                            DataManagerVideoThrottleControlController.prototype.getStatusCode = function () {
                                return this.dataManagerService.getStatusCode();
                            };
                            DataManagerVideoThrottleControlController.prototype.getStatus = function (ctn) {
                                return this.dataManagerService.getAccountLineByCTN(ctn).status;
                            };
                            DataManagerVideoThrottleControlController.prototype.getIconClass = function (colorCode) {
                                return this.dataManagerService.getColorCodeClass(colorCode);
                            };
                            DataManagerVideoThrottleControlController.prototype.getGroupStatus = function (ctn) {
                                return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                            };
                            DataManagerVideoThrottleControlController.prototype.isAccountJoined = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().JOINED);
                            };
                            DataManagerVideoThrottleControlController.prototype.isAccountActiveInGroup = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().ACTIVE);
                            };
                            DataManagerVideoThrottleControlController.prototype.isAccountLeftGroup = function (ctn) {
                                return (this.getGroupStatus(ctn) === this.getGroupStatusCode().LEFT);
                            };
                            DataManagerVideoThrottleControlController.prototype.isAccountSuspended = function (ctn) {
                                return (this.getStatus(ctn) === this.getStatusCode().SUSPENDED);
                            };
                            DataManagerVideoThrottleControlController.prototype.isAccountCancelled = function (ctn) {
                                return (this.getStatus(ctn) === this.getStatusCode().CANCELLED);
                            };
                            DataManagerVideoThrottleControlController.prototype.swipeLeft = function () {
                                if (this.scope.useAlert) {
                                    this.scope.useAlert = !this.scope.useAlert;
                                    this.setDataUseAlerts();
                                }
                            };
                            DataManagerVideoThrottleControlController.prototype.swipeRight = function () {
                                if (!this.scope.useAlert) {
                                    this.scope.useAlert = !this.scope.useAlert;
                                    this.setDataUseAlerts();
                                }
                            };
                            DataManagerVideoThrottleControlController.$inject = ['$scope', '$rootScope', '$modal', '$timeout', '$window', 'ute.data.manager.service', 'ute.dtm.service', 'ute.blocks.messages.bus.service'];
                            return DataManagerVideoThrottleControlController;
                        }());
                        control.DataManagerVideoThrottleControlController = DataManagerVideoThrottleControlController;
                        angular.module('ute.data.manager.video.throttle.control').controller('ute.data.manager.video.throttle.control.directive.controller', DataManagerVideoThrottleControlController);
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('uteDataManagerVideoThrottleControl', uteDataManagerVideoThrottleControl);
                        uteDataManagerVideoThrottleControl.$inject = ['ute.data.manager.service'];
                        /* @ngInject */
                        function uteDataManagerVideoThrottleControl(dataManagerService) {
                            return {
                                restrict: 'E',
                                scope: {
                                    'lineIndex': '@',
                                    'colorCode': '@',
                                    'displayName': '@',
                                    'ctn': '@',
                                    'dataLimit': '@',
                                    'dataUsed': '@',
                                    'dataAlertAt': '@',
                                    'savedAlertValue': '@',
                                    'status': '@',
                                    'groupStatus': '@',
                                    'isAlertsRecipient': '@',
                                    'hasData': '@',
                                    'useAlert': '=',
                                    'dataAccess': '@',
                                    'videoQualityReduced': '@'
                                },
                                templateUrl: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlDirective.templateUrl,
                                controller: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlDirective.controllerName,
                                controllerAs: 'dataManagerVideoThrottleControl',
                                link: function (scope, element, attrs, controller) {
                                    scope.videoQualityReduced = (scope.videoQualityReduced === 'true');
                                    controller.lineIndex = scope.lineIndex;
                                    controller.dataAlertAt = scope.dataAlertAt * 1;
                                    var uteDataManagerVideoThrottleControlColorBlock = angular.element(element[0].getElementsByClassName('ute-dataManager-videoThrottleControl-colorBlock')), uteDataManagerVideoThrottleControlMDSwitch = angular.element(element[0].getElementsByClassName('md-bar')), uteDataManagerVideoThrottleControlDataAlertInputContainerOn = angular.element(element[0].getElementsByClassName('ute-dataManager-videoThrottleControl-dataAlertInputContainerOn')), uteDataManagerVideoThrottleControlDataAlertInputContainerOff = angular.element(element[0].getElementsByClassName('ute-dataManager-videoThrottleControl-dataAlertInputContainerOff')), uteDataManagerVideoThrottleControlMDSwitches = element[0].getElementsByTagName('md-switch'), uteDataManagerVideoThrottleControlMDThumb, uteDataManagerVideoThrottleControlMDInkRipple;
                                    // dataManagerVideoThrottleControlEnableAlert = angular.element(element[0].getElementsByClassName('dataManagerVideoThrottleControlEnableAlert')),
                                    // uteDataManagerVideoThrottleControlEnableAlertMDThumb = angular.element(dataManagerVideoThrottleControlEnableAlert[0].getElementsByClassName('md-bar')),
                                    // dataManagerVideoThrottleControlDataSlider = angular.element(element[0].getElementsByClassName('dataManagerVideoThrottleControlDataSlider')),
                                    // dataManagerVideoThrottleControlDataSliderFocusRing = angular.element(dataManagerVideoThrottleControlDataSlider[0].getElementsByClassName('md-focus-ring')),
                                    // dataManagerVideoThrottleControlDataSliderTrackFill = angular.element(dataManagerVideoThrottleControlDataSlider[0].getElementsByClassName('md-track-fill')),
                                    // dataManagerVideoThrottleControlSliderThumb = angular.element(dataManagerVideoThrottleControlDataSlider[0].getElementsByClassName('md-thumb'));
                                    scope.indicatorWidth = 0;
                                    scope.getDataIndicatorWidth = function () {
                                        var dataManagerVideoThrottleControlDataIndicator = element[0].getElementsByClassName('ute-dataManager-videoThrottleControl-dataIndicator' + scope.lineIndex)[0];
                                        if (dataManagerVideoThrottleControlDataIndicator) {
                                            return dataManagerVideoThrottleControlDataIndicator.clientWidth;
                                        }
                                        else {
                                            return 0;
                                        }
                                    };
                                    uteDataManagerVideoThrottleControlColorBlock.css('backgroundColor', scope.colorCode);
                                    uteDataManagerVideoThrottleControlMDSwitch.css('backgroundColor', scope.colorCode);
                                    for (var iSwitch = 0; iSwitch < uteDataManagerVideoThrottleControlMDSwitches.length; iSwitch++) {
                                        uteDataManagerVideoThrottleControlMDThumb = angular.element(uteDataManagerVideoThrottleControlMDSwitches[iSwitch].getElementsByClassName('md-thumb'));
                                        uteDataManagerVideoThrottleControlMDInkRipple = angular.element(uteDataManagerVideoThrottleControlMDSwitches[iSwitch].getElementsByClassName('md-ink-ripple'));
                                        uteDataManagerVideoThrottleControlMDThumb.css('borderColor', scope.colorCode);
                                        uteDataManagerVideoThrottleControlMDInkRipple.css('color', scope.colorCode);
                                    }
                                    // scope.$watch( function() { return scope.dataAlertAt; }, function (dataAlertVal: number) {
                                    //   if ( (dataAlertVal * 1) > (scope.dataLimit * 1)) {
                                    //     dataManagerVideoThrottleControlSliderThumb.css('display', 'none');
                                    //   } else {
                                    //     dataManagerVideoThrottleControlSliderThumb.css('display', 'inline');
                                    //   }
                                    // });
                                    // scope.$watch( function(){ return scope.useAlert; }, function(newVal: boolean) {
                                    //   if (newVal) {
                                    //     uteDataManagerVideoThrottleControlEnableAlertMDThumb.css('backgroundColor', scope.colorCode );
                                    //     dataManagerVideoThrottleControlSliderThumb.css('opacity', '1');
                                    //     dataManagerVideoThrottleControlDataSliderFocusRing.css('opacity', 0.3);
                                    //   } else {
                                    //     uteDataManagerVideoThrottleControlEnableAlertMDThumb.css('backgroundColor', '#D1D1D1' );
                                    //     dataManagerVideoThrottleControlSliderThumb.css('opacity', '0');
                                    //     dataManagerVideoThrottleControlDataSliderFocusRing.css('opacity', 0);
                                    //   }
                                    // });
                                    // dataManagerVideoThrottleControlDataSliderFocusRing.css('backgroundColor', scope.colorCode);
                                    // dataManagerVideoThrottleControlDataSliderTrackFill.css('backgroundColor', scope.colorCode);
                                    uteDataManagerVideoThrottleControlDataAlertInputContainerOn.css('borderColor', scope.colorCode);
                                    uteDataManagerVideoThrottleControlDataAlertInputContainerOff.css('borderColor', scope.colorCode);
                                    ///////////////////////////////////////////////////////////////////////////////
                                    // Dynamic CSS Rule Creator
                                    // for Dynamically Generated HTML
                                    // Elements That Require Dynamically
                                    // Generated CSS Styles
                                    ///////////////////////////////////////////////////////////////////////////////
                                    var addInlineCSSRule = (function (style) {
                                        style.appendChild(document.createTextNode(''));
                                        document.head.appendChild(style);
                                        var sheet = style.sheet;
                                        return function (selector, css) {
                                            var propText = Object.keys(css).map(function (p) {
                                                return p + ':' + css[p];
                                            }).join(';');
                                            sheet.insertRule(selector + '{' + propText + '}', sheet.cssRules.length);
                                        };
                                    })(document.createElement('style'));
                                    ///////////////////////////////////////////////////////////////////////////////
                                    addInlineCSSRule('.ute-dataManager-videoThrottleControl-md-slider' + scope.lineIndex + ' md-slider .md-thumb:after', { 'background-color': scope.colorCode });
                                    addInlineCSSRule('.ute-dataManager-videoThrottleControl-md-slider' + scope.lineIndex + ' md-slider.md-min .md-thumb:after', { 'background-color': scope.colorCode });
                                    addInlineCSSRule('.ute-dataManager-videoThrottleControl-md-slider' + scope.lineIndex + ' md-slider .md-track-fill', { 'width': (Math.min((scope.dataUsed / scope.dataLimit * 100), 100)) + '% !important' });
                                    addInlineCSSRule('.ute-dataManager-videoThrottleControl-dataIndicator' + scope.lineIndex, { 'width': ((Math.min((scope.dataUsed / scope.dataLimit * 100), 100)) + '% !important') });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('dataTo', dataTo);
                        dataTo.$inject = ['$browser'];
                        /* @ngInject */
                        function dataTo($browser) {
                            return {
                                require: 'ngModel',
                                restrict: 'A',
                                link: function ($scope, $elem, $attrs, $ctrl) {
                                    //attrs used limitFloat, dataBase, limitMax
                                    var limitFloat = parseInt($attrs.limitFloat, 10);
                                    function maxTo(value, limitMax) {
                                        return value > limitMax ? limitMax : value;
                                    }
                                    function transformDataTo(value, transformData) {
                                        return (value / transformData);
                                    }
                                    function formatValue(value) {
                                        return (value.toFixed(limitFloat) * 1);
                                    }
                                    //Parser for initial value MODEL
                                    $ctrl.$parsers.push(function (value) {
                                        var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), model = parseInt(value, 10);
                                        model = transformDataTo(model, transformData);
                                        model = (model.toFixed(limitFloat) * 1);
                                        model = maxTo(model, limitMax);
                                        model = (model * transformData);
                                        return model;
                                    });
                                    //Formatter for initial value VIEW
                                    $ctrl.$formatters.push(function (value) {
                                        var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), viewValue = parseInt(value, 10);
                                        viewValue = transformDataTo(viewValue, transformData);
                                        viewValue = (viewValue.toFixed(limitFloat) * 1);
                                        viewValue = maxTo(viewValue, limitMax);
                                        return viewValue;
                                    });
                                    var formatInput = function (e) {
                                        var transformData = parseInt($attrs.dataBase, 10), limitFloat = parseInt($attrs.limitFloat, 10), limitMax = parseInt($attrs.limitMax, 10), viewValue = transformDataTo($elem.val(), transformData), idx = $elem.val().indexOf('.'), formattedValue = 0;
                                        if (idx > -1) {
                                            if ((viewValue.toString()).split('.')[1].length > limitFloat) {
                                                if (isNaN(parseFloat(viewValue.toString()))) {
                                                    formattedValue = 0;
                                                }
                                                else {
                                                    formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                                }
                                            }
                                            else {
                                                formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                            }
                                        }
                                        else {
                                            formattedValue = $elem.val();
                                        }
                                        //Setting the max value
                                        formattedValue = (maxTo(formattedValue, limitMax));
                                        $elem.val(formattedValue);
                                    };
                                    $elem.bind('paste cut change keypress keyup', function ($event) {
                                        //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                        var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                        if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                            $browser.defer(formatInput);
                                        }
                                    });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('limitFloatTo', uteLimitFloatTo);
                        uteLimitFloatTo.$inject = ['$browser'];
                        /* @ngInject */
                        function uteLimitFloatTo($browser) {
                            return {
                                require: 'ngModel',
                                restrict: 'A',
                                link: function ($scope, $elem, $attrs, $ctrl) {
                                    //Parser for initial value
                                    $ctrl.$parsers.push(function (modelValue) {
                                        var limitFloatTo = $attrs.limitFloatTo, model = Number(parseFloat(modelValue).toFixed(parseInt(limitFloatTo, 10)));
                                        return model;
                                    });
                                    //Formatter for initial value
                                    $ctrl.$formatters.push(function (modelValue) {
                                        var limitFloatTo = $attrs.limitFloatTo, viewValue = Number(parseFloat(modelValue).toFixed(parseInt(limitFloatTo, 10)));
                                        return viewValue;
                                    });
                                    var formatInput = function (e) {
                                        var limitFloatTo = $attrs.limitFloatTo, viewValue = $elem.val().toString(), idx = viewValue.indexOf('.'), formattedValue = 0;
                                        function formatValue(value) {
                                            return Number(parseFloat(value).toFixed(limitFloatTo));
                                        }
                                        if (idx > -1) {
                                            if (viewValue.split('.')[1].length > Number(limitFloatTo)) {
                                                if (isNaN(parseFloat(viewValue))) {
                                                    formattedValue = 0;
                                                }
                                                else {
                                                    formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                                }
                                            }
                                            else {
                                                formattedValue = formatValue(viewValue); //forces the decimal places to the number
                                            }
                                        }
                                        else {
                                            formattedValue = $elem.val();
                                        }
                                        $elem.val(formattedValue);
                                    };
                                    $elem.bind('paste cut change keypress keyup', function ($event) {
                                        //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                        var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                        if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                            $browser.defer(formatInput);
                                        }
                                    });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('limitMaxTo', uteLimitMaxTo);
                        uteLimitMaxTo.$inject = ['$browser'];
                        /* @ngInject */
                        function uteLimitMaxTo($browser) {
                            return {
                                require: 'ngModel',
                                restrict: 'A',
                                link: function ($scope, $elem, $attrs, $ctrl) {
                                    function maxTo(value, limitMaxTo) {
                                        return (value * 1) > (limitMaxTo * 1) ? limitMaxTo : value;
                                    }
                                    //Formatter for initial value
                                    $ctrl.$formatters.push(function (viewValue) {
                                        return maxTo(viewValue, $attrs.limitMaxTo);
                                    });
                                    //Parser for initial value
                                    $ctrl.$parsers.push(function (modelValue) {
                                        return maxTo(modelValue, $attrs.limitMaxTo);
                                    });
                                    var formatInput = function (e) {
                                        $elem.val(maxTo($elem.val(), $attrs.limitMaxTo));
                                    };
                                    $elem.bind('paste cut change keypress keyup', function ($event) {
                                        //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                        var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                        if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                            $browser.defer(formatInput);
                                        }
                                    });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('limitToPattern', uteLimitToPattern);
                        uteLimitToPattern.$inject = ['$browser'];
                        /* @ngInject */
                        function uteLimitToPattern($browser) {
                            return {
                                require: 'ngModel',
                                restrict: 'A',
                                link: function ($scope, $elem, $attrs, $ctrl) {
                                    function limitToPattern(value, limitToPattern) {
                                        var transformedInput = value ? value.toString().replace(new RegExp(limitToPattern), '') : value;
                                        if (transformedInput !== value) {
                                            $ctrl.$setViewValue(transformedInput);
                                            $ctrl.$render();
                                        }
                                        return transformedInput;
                                    }
                                    //Formatter for initial value
                                    $ctrl.$formatters.push(function (viewValue) {
                                        return limitToPattern(viewValue, $attrs.limitToPattern);
                                    });
                                    //Parser for initial value
                                    $ctrl.$parsers.push(function (modelValue) {
                                        return limitToPattern(modelValue, $attrs.limitToPattern);
                                    });
                                    var formatInput = function (e) {
                                        limitToPattern($elem.val(), $attrs.limitToPattern);
                                    };
                                    $elem.bind('paste cut change keypress keyup', function ($event) {
                                        //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                        var ignoreKeys = [8, 190, 110, 48, 46, 37, 38, 39, 40];
                                        if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                            $browser.defer(formatInput);
                                        }
                                    });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        'use strict';
                        angular.module('ute.data.manager.video.throttle.control').directive('transformData', uteTransformData);
                        uteTransformData.$inject = ['$browser', '$filter', '$translate'];
                        /* @ngInject */
                        function uteTransformData($browser, $filter, $translate) {
                            return {
                                require: 'ngModel',
                                restrict: 'A',
                                link: function ($scope, $elem, $attrs, $ctrl) {
                                    /*
                                    $scope.$watch(function(){return $translate.use(); }, function(lang: string){
                            
                                      var limitFloat: number = $elem.val().indexOf(',') > -1 || $elem.val().indexOf('.') > -1 ? parseInt($attrs.limitFloat, 10) : 0;
                            
                                      $ctrl.$setViewValue($filter('number')($elem.val(), limitFloat));
                            
                                      $ctrl.$render();
                            
                                    });
                            
                            */
                                    function transformViewTo() {
                                        var limitFloat = parseInt($attrs.limitFloat, 10), base = parseInt($attrs.base, 10), limitMax = parseInt($attrs.limitMax, 10) / base, view = parseInt($ctrl.$modelValue.toString().replace(/\./g, '').replace(',', '.'), 10) / base;
                                        view = view > limitMax ? limitMax : view;
                                        view = Math.round(view * Math.pow(10, limitFloat)) / Math.pow(10, limitFloat);
                                        $ctrl.$setViewValue(view);
                                        $ctrl.$render();
                                        return view.toString();
                                    }
                                    //Formatter for initial value
                                    $ctrl.$formatters.push(function (viewValue) {
                                        var limitFloat = parseInt($attrs.limitFloat, 10);
                                        return $filter('number')(transformViewTo(), limitFloat);
                                    });
                                    //Parser for initial value
                                    $ctrl.$parsers.push(function (modelValue) {
                                        var formattedModel = (modelValue.toString().replace(',', '.')) * 1;
                                        var base = parseInt($attrs.base, 10), limitMax = parseInt($attrs.limitMax, 10) / base, model = (formattedModel > limitMax ? limitMax : formattedModel);
                                        model = Math.round(model * base);
                                        return model;
                                    });
                                    var formatInput = function (e) {
                                        var limitFloat = $elem.val().indexOf(',') > -1 || $elem.val().indexOf('.') > -1 ? parseInt($attrs.limitFloat, 10) : 0;
                                        $elem.val($filter('number')(transformViewTo(), limitFloat));
                                    };
                                    $elem.bind('paste cut change keypress keyup', function ($event) {
                                        //backspace, decimal, decimal?, zero, delete, right, left, up, down
                                        var ignoreKeys = [8, 48, 46, 37, 38, 39, 40, 190, 110, 188, 44];
                                        /*
                                        
                                                  if ( ($elem.val().match(/./g) || []).length > 1 ) {
                                                    $ctrl.$rollbackViewValue();
                                                    return;
                                                  }
                                        */
                                        if (ignoreKeys.indexOf($event.keyCode) === -1) {
                                            $browser.defer(formatInput);
                                        }
                                    });
                                }
                            };
                        }
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            'use strict';
                            var DataManagerVideoThrottleControlTagController = (function () {
                                /* @ngInject */
                                function DataManagerVideoThrottleControlTagController($state, $rootScope, $scope, $modal, dataManagerService, dtmService, userService, dataManagerSeeService) {
                                    this.$state = $state;
                                    this.$rootScope = $rootScope;
                                    this.$scope = $scope;
                                    this.$modal = $modal;
                                    this.dataManagerService = dataManagerService;
                                    this.dtmService = dtmService;
                                    this.userService = userService;
                                    this.dataManagerSeeService = dataManagerSeeService;
                                    this.model = this.dataManagerService.getModel();
                                    this.scope = $scope;
                                    this.rootScope = $rootScope;
                                }
                                DataManagerVideoThrottleControlTagController.prototype.getMaxLimit = function () {
                                    return this.dataManagerService.getDataLimit();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getDataControlList = function () {
                                    return this.dataManagerService.getDataControlList();
                                };
                                ;
                                DataManagerVideoThrottleControlTagController.prototype.getDisplayNameCTN = function () {
                                    return this.dataManagerService.getDisplayNameCTN(this.scope.ctn);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getAlertsRecipientCTN = function () {
                                    return this.dataManagerService.getAlertsRecipientCTN();
                                };
                                ;
                                DataManagerVideoThrottleControlTagController.prototype.getBase = function () {
                                    return this.dataManagerService.getConfig().basic.dataConversion;
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getDataLimit = function () {
                                    return this.dataManagerService.getDataLimit();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isIndividualSuspended = function (ctn) {
                                    return this.dataManagerService.isTabDisabled(ctn);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getTagIcon = function () {
                                    var tagIcon = ((!this.dataManagerService.getDataAccessCTN(this.scope.ctn) || this.scope.useAlert === 'false') ? 'alertsOff' : 'alertsOn');
                                    if (!this.dataManagerService.hasDataCTN(this.scope.ctn)) {
                                        tagIcon = 'dataOff';
                                    }
                                    return tagIcon;
                                };
                                DataManagerVideoThrottleControlTagController.prototype.goToIndividualSummary = function (ctn) {
                                    //TODO: uncomment this individualSummaryCTN-FIX -- for web alpha
                                    // this.userService.getPersistentService().put(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER, ctn);
                                    //SEE implementation
                                    if (ctn === '') {
                                        this.dataManagerSeeService.goToAddLine();
                                        return;
                                    }
                                    //END of SEE implementation
                                    this.dataManagerService.setIndividualSummaryCTN(ctn);
                                    this.dataManagerService.goToSubModule(this.dataManagerService.getConfig().advanced.dataManagerIndividualSummary.subState);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.goToWireless = function (ctn) {
                                    this.dataManagerService.setWirelessCTN(ctn);
                                    this.dataManagerService.goToWirelessState();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.errorModalPopup = function (primary, secondary) {
                                    var errorModalScope = this.rootScope.$new();
                                    errorModalScope.params = { primary: primary, secondary: secondary };
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerDataAccessModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerModals.genericModal.controllerName,
                                        controllerAs: 'dataManagerGenericModal',
                                        size: 'md',
                                        backdrop: 'static',
                                        scope: errorModalScope
                                    });
                                };
                                // Code to support Modal for of primary notifiaction recipient
                                DataManagerVideoThrottleControlTagController.prototype.requestChangeModal = function ($event) {
                                    this.openModalPopup();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.openModalPopup = function () {
                                    var _this = this;
                                    this.$modal.open({
                                        windowTemplateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.windowTemplateUrl,
                                        templateUrl: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.templateUrl,
                                        controller: this.dataManagerService.getConfig().advanced.dataManagerAlertsRecipientModal.controllerName,
                                        controllerAs: 'dataManagerAlertsRecipientModal',
                                        size: 'md',
                                        backdrop: 'static'
                                    }).result.then(function (result) {
                                        // Result selection behaviour
                                        switch (result) {
                                            case 'yes':
                                                _this.modalUserAnswerYes();
                                                break;
                                            case 'no':
                                                _this.modalUserAnswerNo();
                                                break;
                                            case 'error':
                                                _this.errorModalPopup('ute.dataManager.dataControlTag.errorHeading', 'ute.dataManager.dataControlTag.errorSecondary');
                                                break;
                                        }
                                    }, function () {
                                        // Dismiss behaviour
                                        // Do nothing/close
                                        _this.modalDismissed();
                                    });
                                };
                                DataManagerVideoThrottleControlTagController.prototype.modalUserAnswerYes = function () {
                                    // console.log ('User answer - YES');
                                };
                                DataManagerVideoThrottleControlTagController.prototype.modalUserAnswerNo = function () {
                                    // console.log ('User answer - NO');
                                };
                                DataManagerVideoThrottleControlTagController.prototype.modalDismissed = function () {
                                    // console.log ('User answer - MEH');
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getDataUsedPrecision = function () {
                                    return (this.scope.dataUsed * 1 > this.getBase() ? 2 : 0);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getDataAlertAtPrecision = function () {
                                    return (this.scope.dataAlertAt > this.getBase() ? 2 : 0);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getColorBlockClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getDisplayNameClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getCTNClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getJoinedGroupClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getBottomContainerClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getClickAreaClass = function (ctn) {
                                    return (this.isAccountCancelled(ctn) || this.isAccountLeftGroup(ctn) || this.isIndividualSuspended(ctn)) ? 'ute-dataManager-dataControlTag-disabledRight' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.showClickArea = function () {
                                    return this.scope.buttonMode === 'true' && this.scope.groupStatus !== this.getGroupStatusCode().LEFT;
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getAlertClass = function (ctn) {
                                    return ''; //(this.scope.status === 'cancelled' || this.isAccountLeftGroup(ctn)) ? 'ute-dataManager-dataControlTag-disabled' : '';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getTagIconClass = function (ctn) {
                                    return this.isAccountSuspended(ctn) ? 'ute-dataManager-dataControlTag-tagIcon-suspended' : 'ute-dataManager-dataControlTag-tagIcon';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getChevronIconClass = function (ctn) {
                                    return this.isAccountSuspended(ctn) ? 'ute-dataManager-dataControlTag-chevron-suspended' : 'ute-dataManager-dataControlTag-chevron';
                                };
                                DataManagerVideoThrottleControlTagController.prototype.showChevronIcon = function (ctn) {
                                    return this.scope.buttonMode === 'true' && !(this.isAccountCancelled(ctn)) && !(this.isIndividualSuspended(ctn));
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getGroupStatusCode = function () {
                                    return this.dataManagerService.getGroupStatusCode();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getStatusCode = function () {
                                    return this.dataManagerService.getStatusCode();
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getStatus = function (ctn) {
                                    return this.dataManagerService.getAccountLineByCTN(ctn).status;
                                };
                                DataManagerVideoThrottleControlTagController.prototype.getGroupStatus = function (ctn) {
                                    return this.dataManagerService.getAccountLineByCTN(ctn).groupStatus;
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isAccountJoined = function (ctn) {
                                    return (this.getGroupStatus(ctn) === this.getGroupStatusCode().JOINED);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isAccountActiveInGroup = function (ctn) {
                                    return (this.getGroupStatus(ctn) === this.getGroupStatusCode().ACTIVE);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isAccountLeftGroup = function (ctn) {
                                    return (this.getGroupStatus(ctn) === this.getGroupStatusCode().LEFT);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isAccountSuspended = function (ctn) {
                                    return (this.getStatus(ctn) === this.getStatusCode().SUSPENDED);
                                };
                                DataManagerVideoThrottleControlTagController.prototype.isAccountCancelled = function (ctn) {
                                    return (this.getStatus(ctn) === this.getStatusCode().CANCELLED);
                                };
                                DataManagerVideoThrottleControlTagController.$inject = ['$state', '$rootScope', '$scope', '$modal', 'ute.data.manager.service', 'ute.dtm.service', 'ute.common.user.service', 'ute.data.manager.see.service'];
                                return DataManagerVideoThrottleControlTagController;
                            }());
                            tag.DataManagerVideoThrottleControlTagController = DataManagerVideoThrottleControlTagController;
                            angular.module('ute.data.manager.video.throttle.control.tag').controller('ute.data.manager.video.throttle.control.tag.controller', DataManagerVideoThrottleControlTagController);
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var video;
            (function (video) {
                var throttle;
                (function (throttle) {
                    var control;
                    (function (control) {
                        var tag;
                        (function (tag) {
                            'use strict';
                            angular.module('ute.data.manager.video.throttle.control.tag').directive('uteDataManagerVideoThrottleControlTag', uteDataManagerVideoThrottleControlTag);
                            uteDataManagerVideoThrottleControlTag.$inject = ['$timeout', 'ute.data.manager.service'];
                            /* @ngInject */
                            function uteDataManagerVideoThrottleControlTag($timeout, dataManagerService) {
                                return {
                                    restrict: 'E',
                                    scope: {
                                        'colorCode': '@',
                                        'displayName': '@',
                                        'ctn': '@',
                                        'dataAlertAt': '@',
                                        'status': '@',
                                        'groupStatus': '@',
                                        'dataUsed': '@',
                                        'isAlertsRecipient': '@',
                                        'dataAccess': '@',
                                        'buttonMode': '@',
                                        'useAlert': '@',
                                        'index': '@',
                                        'hasData': '@',
                                        'videoQualityReduced': '@'
                                    },
                                    templateUrl: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlTagDirective.templateUrl,
                                    controller: dataManagerService.getConfig().advanced.dataManagerVideoThrottleControlTagDirective.controllerName,
                                    controllerAs: 'dataManagerVideoThrottleControlTag',
                                    link: function (scope, element, attrs, controller) {
                                        $timeout(function () {
                                            var alert = angular.element(element[0].getElementsByClassName('ute-dataManagerVideoThrottleControlTag-alertIcon'));
                                            alert.css('fill', scope.colorCode);
                                        }, 1);
                                    }
                                };
                            }
                        })(tag = control.tag || (control.tag = {}));
                    })(control = throttle.control || (throttle.control = {}));
                })(throttle = video.throttle || (video.throttle = {}));
            })(video = manager.video || (manager.video = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var discovery;
    (function (discovery) {
        var page;
        (function (page) {
            var directive;
            (function (directive) {
                'use strict';
                var DiscoveryPageDirectiveModalController = (function () {
                    /* @ngInject */
                    function DiscoveryPageDirectiveModalController($scope, $window, $location, $modalInstance, discoveryPageService, $timeout) {
                        this.$scope = $scope;
                        this.$window = $window;
                        this.$location = $location;
                        this.$modalInstance = $modalInstance;
                        this.discoveryPageService = discoveryPageService;
                        this.$timeout = $timeout;
                        this.model = this.discoveryPageService.getModel();
                        this.scope = $scope;
                        this.doNotShow = false;
                        this.tooltipmode = $scope.$parent.tooltipmode;
                        this.paramObject = $scope.$parent.paramObject;
                        this.serverData = $scope.$parent.serverData;
                        this.selectedLanguage = this.discoveryPageService.getLanguage();
                        $timeout(function () {
                            var carouselControlElem = document.getElementsByClassName('carousel-control');
                            angular.element(carouselControlElem).bind('keydown', function (event) {
                                if (event.which === 13) {
                                    $(this).click();
                                }
                            });
                        }, 0);
                    }
                    DiscoveryPageDirectiveModalController.prototype.doNotShowToggle = function () {
                        this.doNotShow = !this.doNotShow;
                        return this.doNotShow;
                    };
                    DiscoveryPageDirectiveModalController.prototype.setInteraction = function (url) {
                        if (this.doNotShow) {
                            // Make server call to update this event - based on checkbox setting
                            this.discoveryPageService.serverSetInteractionState('VIEWED').then(function (result) {
                                // Close after completing the call
                            });
                        }
                        else {
                            this.discoveryPageService.serverSetInteractionState('VIEW_AGAIN').then(function (result) {
                                // Close after completing the call
                            });
                        }
                    };
                    DiscoveryPageDirectiveModalController.prototype.continue = function (url) {
                        var prefix = this.$location.absUrl().substr(0, this.$location.absUrl().indexOf('/web/totes/', 0));
                        this.setInteraction(prefix + url);
                        this.$window.location.href = prefix + url;
                        this.$modalInstance.close('yes');
                    };
                    DiscoveryPageDirectiveModalController.prototype.cancel = function () {
                        this.setInteraction('');
                        this.$modalInstance.close('no');
                    };
                    DiscoveryPageDirectiveModalController.prototype.noSelection = function () {
                        this.setInteraction('');
                        this.$modalInstance.dismiss('cancel');
                    };
                    DiscoveryPageDirectiveModalController.prototype.pointToRelativePath = function (path) {
                        var prefix = this.$location.absUrl().substr(0, this.$location.absUrl().indexOf('/web/totes/', 0));
                        return prefix + this.discoveryPageService.getConfig().basic.urlSuffix + path;
                    };
                    DiscoveryPageDirectiveModalController.prototype.prevSlide = function () {
                        this.scope.$parent.prevSlide();
                    };
                    DiscoveryPageDirectiveModalController.prototype.nextSlide = function () {
                        this.scope.$parent.nextSlide();
                    };
                    DiscoveryPageDirectiveModalController.prototype.getResponsiveTopicUrlIndex = function () {
                        return this.$window.innerWidth <= 768 ? 1 : 0;
                    };
                    DiscoveryPageDirectiveModalController.$inject = ['$scope', '$window', '$location', '$modalInstance', 'ute.discovery.page.service', '$timeout'];
                    return DiscoveryPageDirectiveModalController;
                }());
                directive.DiscoveryPageDirectiveModalController = DiscoveryPageDirectiveModalController;
                angular.module('ute.discovery.page.directive').controller('ute.discovery.page.directive.modal.controller', DiscoveryPageDirectiveModalController);
            })(directive = page.directive || (page.directive = {}));
        })(page = discovery.page || (discovery.page = {}));
    })(discovery = ute.discovery || (ute.discovery = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            'use strict';
            var Controller = (function () {
                /* @ngInject */
                function Controller($modalInstance, errorCode, resendEmailService, janrainVerificationService, $state, $translate, dtmService, $http, $q) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.errorCode = errorCode;
                    this.resendEmailService = resendEmailService;
                    this.janrainVerificationService = janrainVerificationService;
                    this.$state = $state;
                    this.$translate = $translate;
                    this.dtmService = dtmService;
                    this.$http = $http;
                    this.$q = $q;
                    this.organicExpiry = false;
                    this.isForgotPasswordCallInProgress = false;
                    // protected getModalIcon: () => string = () => this.errorCode.modalIcon;
                    // protected getErrorTitleMessageKey: () => string = () => this.errorCode.errorTitleMessageKey;
                    // protected getErrorSubTitleMessageKey: () => string = () => this.errorCode.errorSubTitleMessageKey;
                    // protected getFrontendMessageKey: () => string = () => this.errorCode.frontendMessageKey;
                    // protected getFrontendMessageP2Key: () => string = () => this.errorCode.frontendMessageP2Key;
                    // protected getBoldChat: () => IBoldChat = () => this.errorCode.boldChat;
                    this.noSelection = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.cancel = function () {
                        _this.$modalInstance.dismiss('cancel');
                        return _this.janrainVerificationService.goToRescueState();
                    };
                    this.continue = function () { return _this.$modalInstance.close('yes'); };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.submit = function (errorCode) {
                        // console.log(Controller.controlerName + '->submit: form.$valid=', this.form.$valid,
                        //     'form.email=', this.form.email,
                        //     'form=', this.form,
                        //     'model=', this.model
                        // );
                        _this.organicExpiry = !!(errorCode && (errorCode === 17001 || errorCode === 17002));
                        if (_this.form.$valid) {
                            _this.errorMessageKey = null;
                            return _this.resendEmailService.resendEmail(_this.model)
                                .then(_this.processOk)
                                .catch(_this.processError);
                        }
                        else {
                            return null;
                        }
                    };
                    this.processOk = function (codeEntry) {
                        // return this.userRegistrationService.goToConfirmation();
                        if (_this.organicExpiry) {
                            //17001 - VALIDATION_EXPRIED_CODE
                            _this.successMessageKey = 'ute.janrain.verification.email.not.found.error.CODE_NOT_VALID';
                        }
                        else {
                            _this.$modalInstance.close();
                        }
                        _this.janrainVerificationService.goToRescueState();
                        return null;
                    };
                    this.processError = function (codeEntry) {
                        switch (codeEntry.backendCode) {
                            case 17002: //17002 - CODE_NOT_VALID
                            case 17003:
                                _this.forgotPassword({ email: _this.model.email, isServiceCallSuccess: true });
                                break;
                            case 17004:
                                _this.errorMessageKey = 'ute.janrain.verification.email.not.found.error.EMAIL_NOT_FOUND';
                                break;
                            default:
                                _this.errorMessageKey = codeEntry.frontendMessageKey;
                        }
                        return null;
                    };
                    /**
                     * @returns {IPromise<ICodeEntry>}
                     */
                    this.forgotPassword = function (model) {
                        _this.forgotPasswordModel = model;
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                        var request = {
                            email: _this.forgotPasswordModel.email
                        };
                        _this.isForgotPasswordCallInProgress = true;
                        return _this.$http.post(_this.config.advanced.forgotPassword.apiUrl, request)
                            .then(_this.processForgotPasswordOk)
                            .catch(_this.processForgotPasswordError);
                    };
                    /**
                     * @param response
                     * @returns {void}
                     */
                    this.processForgotPasswordOk = function () {
                        _this.successMessageKey = 'ute.janrain.verification.email.not.found.error.CODE_NOT_VALID';
                        _this.forgotPasswordModel.isServiceCallSuccess = true;
                    };
                    /**
                     * @param error
                     * @returns {void}
                     */
                    this.processForgotPasswordError = function () {
                        _this.forgotPasswordModel.isServiceCallSuccess = false;
                    };
                    this.model = {
                        email: this.resendEmailService.getEmail(),
                        locale: this.janrainVerificationService.getLocale()
                    };
                    this.config = ute.janrain.verification.service.DefaultConfigFactory();
                    this.tagName = (this.$state.current.name === this.config.advanced.setPassword.stateName) ? this.config.advanced.setPassword.dtmName : this.config.advanced.resetPassword.dtmName;
                    this.$translate(this.errorCode.errorTitleMessageKey).then(function (errorMessage) {
                        _this.dtmService.fireDtmExceptions(_this.tagName, [errorMessage], 'SS');
                    });
                }
                Controller.controlerName = 'ute.janrain.verification.resend.email.ask.controller';
                Controller.$inject = ['$modalInstance',
                    'ute.janrain.verification.errorHandler',
                    'ute.janrain.verification.resend.email.service',
                    'ute.janrain.verification.service',
                    '$state',
                    '$translate',
                    'ute.dtm.service',
                    '$http',
                    '$q'];
                return Controller;
            }());
            angular.module('ute.janrain.verification').controller(Controller.controlerName, Controller);
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var janrain;
    (function (janrain) {
        var verification;
        (function (verification) {
            var resend;
            (function (resend) {
                var email;
                (function (email) {
                    var confirmation;
                    (function (confirmation) {
                        'use strict';
                        var Controller = (function () {
                            /* @ngInject */
                            function Controller($document, resendEmailService /*,
                                 dtmService: ute.dtm.service.IDtmService*/) {
                                this.resendEmailService = resendEmailService;
                                this.getEmail = this.resendEmailService.getEmail;
                                $document.scrollTop(0);
                                // dtmService.complete(userRegistrationService.getConfig().basic.dtmName);
                            }
                            Controller.$inject = ['$document',
                                'ute.janrain.verification.resend.email.service' /*,
                                 'ute.dtm.service'*/
                            ];
                            Controller.controlerName = 'ute.janrain.verification.resend.email.confirmation.controller';
                            return Controller;
                        }());
                        angular.module('ute.rogers.user.registration').controller(Controller.controlerName, Controller);
                    })(confirmation = email.confirmation || (email.confirmation = {}));
                })(email = resend.email || (resend.email = {}));
            })(resend = verification.resend || (verification.resend = {}));
        })(verification = janrain.verification || (janrain.verification = {}));
    })(janrain = ute.janrain || (ute.janrain = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment_1) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    var recent;
                    (function (recent) {
                        var payment;
                        (function (payment) {
                            var success;
                            (function (success) {
                                var message;
                                (function (message) {
                                    'use strict';
                                    var RecentPaymentSuccessMessageController = (function () {
                                        /* @ngInject */
                                        function RecentPaymentSuccessMessageController(payNowService) {
                                            this.payNowService = payNowService;
                                            this.lastPaymentDetails = payNowService.retrieveLastPaymentDetail();
                                        }
                                        RecentPaymentSuccessMessageController.$inject = ['ute.payment.ui.pay.now.service'];
                                        RecentPaymentSuccessMessageController.controllerName = 'ute.payment.ui.pay.now.recent.payment.success.message.controller';
                                        return RecentPaymentSuccessMessageController;
                                    }());
                                    message.RecentPaymentSuccessMessageController = RecentPaymentSuccessMessageController;
                                    angular.module('ute.payment.ui.pay.now').controller(RecentPaymentSuccessMessageController.controllerName, RecentPaymentSuccessMessageController);
                                })(message = success.message || (success.message = {}));
                            })(success = payment.success || (payment.success = {}));
                        })(payment = recent.payment || (recent.payment = {}));
                    })(recent = now.recent || (now.recent = {}));
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment_1.ui || (payment_1.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var payment;
    (function (payment_1) {
        var ui;
        (function (ui) {
            var pay;
            (function (pay) {
                var now;
                (function (now) {
                    var recent;
                    (function (recent) {
                        var payment;
                        (function (payment) {
                            var success;
                            (function (success) {
                                var message;
                                (function (message) {
                                    'use strict';
                                    var PaymentSuccessMessageDirective = (function () {
                                        /* @ngInject */
                                        function PaymentSuccessMessageDirective() {
                                            this.restrict = 'E';
                                            this.templateUrl = 'module/paymentUI/payNow/recent.payment.success.message/recent.payment.success.message.view.html';
                                            this.controller = message.RecentPaymentSuccessMessageController.controllerName;
                                            this.controllerAs = 'lastPayment';
                                            this.bindToController = true;
                                            this.scope = {};
                                            // this.link = this.linkFn;
                                        }
                                        PaymentSuccessMessageDirective.factory = function () {
                                            var directive = function () { return new PaymentSuccessMessageDirective(); };
                                            return directive;
                                        };
                                        return PaymentSuccessMessageDirective;
                                    }());
                                    angular.module('ute.payment.ui.pay.now').directive('uteRecentPaymentSuccessMessage', PaymentSuccessMessageDirective.factory());
                                })(message = success.message || (success.message = {}));
                            })(success = payment.success || (payment.success = {}));
                        })(payment = recent.payment || (recent.payment = {}));
                    })(recent = now.recent || (now.recent = {}));
                })(now = pay.now || (pay.now = {}));
            })(pay = ui.pay || (ui.pay = {}));
        })(ui = payment_1.ui || (payment_1.ui = {}));
    })(payment = ute.payment || (ute.payment = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayCheckEligibilityController = (function () {
                    /* @ngInject */
                    function PromiseToPayCheckEligibilityController(promiseToPayService, $modal, languageService) {
                        var _this = this;
                        this.promiseToPayService = promiseToPayService;
                        this.$modal = $modal;
                        this.languageService = languageService;
                        this.accountBalance = '--.--';
                        this.pastDueBalance = '--.--';
                        this.ptpPendingAmount = '--.--';
                        this.showPendingPTP = false;
                        this.enableCheckEligibiltyFlag = true;
                        this.shedulePTPSuccess = false;
                        this.checkEligibilityLoading = false;
                        this.showCheckEligibilityContainer = false;
                        this.writePaymentMethodKeys = {};
                        this.readPaymentMethodKeys = {};
                        this.lang = this.promiseToPayService.getLanguage();
                        this.screenName = this.promiseToPayService.getScreenName();
                        this.promiseToPayService.resetDataModel();
                        this.promiseToPayService.initializeWatchVariables();
                        this.writePaymentMethodKeys = {
                            'internet/phonebanking': '0',
                            'rogersstore': '1',
                            'nrpc': '2',
                            'cc/interacdebit': '3',
                            'bank': '4'
                        };
                        this.readPaymentMethodKeys = {
                            'bankmachine': '5',
                            'bankline': '6',
                            'bankbranch': '7',
                            'video/retail': '8',
                            'mail': '9',
                            'creditcard/interacdebit': '10',
                            'westernunion/certifiedcheque': '11',
                            'cash': '12',
                            'fidostore': '13',
                            'inputpayments': '14',
                            'nrpc': '2',
                            'rogersstore': '1',
                            'internet/phonebanking': '0'
                        };
                        this.promiseToPayService.retrieve().then(function (result) {
                            _this.showCheckEligibilityContainer = true;
                            if (result && result.status && result.status.toLowerCase() === 'success') {
                                _this.accountBalance = result.accountBalance ? result.accountBalance : '--.--';
                                _this.pastDueBalance = result.pastDueBalance ? result.pastDueBalance : '--.--';
                                if (result.ptpPendingIndicator && !(_this.promiseToPayService.getAccountNumber() &&
                                    _this.promiseToPayService.getAccountNumber().length === 12)) {
                                    _this.showPendingPTP = true;
                                    _this.ptpPendingAmount = result.ptpPaymentInfo ? result.ptpPaymentInfo.amount : '--.--';
                                    _this.ptpPendingDate = result.ptpPaymentInfo ? result.ptpPaymentInfo.date : '';
                                    _this.ptpPendingMOP = _this.getReadPaymentMethodValue(result.ptpPaymentInfo ? result.ptpPaymentInfo.paymentType : '');
                                }
                            }
                            else {
                                _this.openModel();
                                _this.enableCheckEligibiltyFlag = false;
                            }
                        }).catch(function (result) {
                            _this.showCheckEligibilityContainer = true;
                            _this.openModel();
                        });
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.lang = lang;
                            return null;
                        }, 'ute.promise.to.pay.check.eligibility.directive.controller');
                    }
                    PromiseToPayCheckEligibilityController.prototype.checkPTPEligibility = function () {
                        var _this = this;
                        this.checkEligibilityLoading = true;
                        this.promiseToPayService.checkEligibility().then(function (result) {
                            _this.isPTPEligible = result.isPTPEligible;
                            _this.checkEligibilityLoading = false;
                        }).catch(function (result) {
                            _this.checkEligibilityLoading = false;
                            _this.enableCheckEligibiltyFlag = false;
                            _this.openModel();
                        });
                    };
                    PromiseToPayCheckEligibilityController.prototype.setPendingPTP = function () {
                        this.ptpPendingAmount = this.promiseToPayService.getPendingPTPDataModel().paymentAmount.toString();
                        this.ptpPendingDate = this.promiseToPayService.getPendingPTPDataModel().postingDate ? new Date(this.promiseToPayService.getPendingPTPDataModel().postingDate.toString()) : '';
                        this.ptpPendingMOP = this.getWritePaymentMethodValue(this.promiseToPayService.getPendingPTPDataModel().paymentMethod);
                        this.showPendingPTP = true;
                    };
                    PromiseToPayCheckEligibilityController.prototype.schedulePTPSuccessDisplay = function () {
                        this.shedulePTPSuccess = true;
                        //if (!(this.promiseToPayService.getAccountNumber() && this.promiseToPayService.getAccountNumber().length === 12 )) {
                        this.setPendingPTP();
                        //}
                    };
                    PromiseToPayCheckEligibilityController.prototype.splitAmount = function (amount) {
                        var splittedAmount;
                        if (amount) {
                            splittedAmount = amount.split('.');
                            return splittedAmount[0];
                        }
                        return amount;
                    };
                    PromiseToPayCheckEligibilityController.prototype.getDecimals = function (input) {
                        var splittedAmount = '00';
                        if (input) {
                            var amount = input.split('.');
                            if (amount[1]) {
                                splittedAmount = String(Math.floor(Number(amount[1]) * 100) / 100);
                            }
                        }
                        if (this.lang === 'fr') {
                            splittedAmount = ',' + splittedAmount;
                        }
                        else {
                            splittedAmount = '.' + splittedAmount;
                        }
                        return splittedAmount;
                    };
                    PromiseToPayCheckEligibilityController.prototype.openModel = function () {
                        this.$modal.open({
                            templateUrl: this.promiseToPayService.getConfig().advanced.ptpErrorModal.templateUrl,
                            controller: this.promiseToPayService.getConfig().advanced.ptpErrorModal.controllerName,
                            controllerAs: 'modalContoller',
                            size: 'md',
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                        });
                    };
                    PromiseToPayCheckEligibilityController.prototype.getWritePaymentMethodValue = function (paymentMethod) {
                        return this.getPaymentMethodValue(paymentMethod, this.writePaymentMethodKeys);
                    };
                    PromiseToPayCheckEligibilityController.prototype.getReadPaymentMethodValue = function (paymentMethod) {
                        return this.getPaymentMethodValue(paymentMethod, this.readPaymentMethodKeys);
                    };
                    PromiseToPayCheckEligibilityController.prototype.getPaymentMethodValue = function (paymentMethod, paymentMethodKeys) {
                        if (paymentMethod) {
                            /* tslint:disable */
                            paymentMethod = paymentMethod.replace(/\s+/g, '').toLowerCase();
                            var paymentMethodValue = paymentMethodKeys[paymentMethod];
                        }
                        if (paymentMethodValue) {
                            return paymentMethodValue;
                        }
                        else {
                            return '15';
                        }
                    };
                    PromiseToPayCheckEligibilityController.controllerName = 'ute.promise.to.pay.check.eligibility.directive.controller';
                    PromiseToPayCheckEligibilityController.$inject = [
                        'ute.promise.to.pay.service',
                        '$modal',
                        'ute.blocks.language.switcher'
                    ];
                    return PromiseToPayCheckEligibilityController;
                }());
                pay.PromiseToPayCheckEligibilityController = PromiseToPayCheckEligibilityController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.check.eligibility.directive.controller', PromiseToPayCheckEligibilityController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayCheckEligibility = (function () {
                    /* @ngInject */
                    function PromiseToPayCheckEligibility(promiseToPayService) {
                        var _this = this;
                        this.promiseToPayService = promiseToPayService;
                        this.restrict = 'E';
                        this.templateUrl = this.promiseToPayService.getConfig().advanced.ptpCheckEligibility.templateUrl;
                        this.controller = this.promiseToPayService.getConfig().advanced.ptpCheckEligibility.controllerName;
                        this.controllerAs = 'promiseToPayCheckEligibility';
                        this.returnWatchVariables = function () {
                            return _this.promiseToPayService.getWatchVariables();
                        };
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope, element, attrs, controller) {
                            scope.$watch(_this.returnWatchVariables, function (value) {
                                if (value) {
                                    if (value.shedulePTPSuccess) {
                                        controller.schedulePTPSuccessDisplay();
                                    }
                                }
                            }, true);
                        };
                        this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.promise.to.pay.IPromiseToPayService): ute.promise.to.pay.PromiseToPay}
                     */
                    PromiseToPayCheckEligibility.factory = function () {
                        var directive = function (promiseToPayService) { return new PromiseToPayCheckEligibility(promiseToPayService); };
                        directive.$inject = ['ute.promise.to.pay.service'];
                        return directive;
                    };
                    return PromiseToPayCheckEligibility;
                }());
                angular.module('ute.promise.to.pay').directive('utePromiseToPayCheckEligibility', PromiseToPayCheckEligibility.factory());
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                angular.module('ute.promise.to.pay').filter('ptp_fraction_part', ptpFractionPart)
                    .filter('ptp_integer_part', ptpIntegerPart);
                function ptpFractionPart() {
                    return function (input, lang) {
                        var splittedAmount = '00';
                        if (input) {
                            var amount = input.split('.');
                            if (amount[1]) {
                                splittedAmount = amount[1].substr(0, 2);
                                if (splittedAmount && splittedAmount.length < 2) {
                                    splittedAmount = splittedAmount + '0';
                                }
                            }
                        }
                        if (lang === 'fr') {
                            splittedAmount = ',' + splittedAmount;
                        }
                        else {
                            splittedAmount = '.' + splittedAmount;
                        }
                        return splittedAmount;
                    };
                }
                function ptpIntegerPart() {
                    return function (input) {
                        var splittedAmount;
                        if (input) {
                            var amount = input.split('.');
                            if (amount[0]) {
                                splittedAmount = amount[0];
                            }
                        }
                        return splittedAmount;
                    };
                }
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayMessageBannerController = (function () {
                    /* @ngInject */
                    function PromiseToPayMessageBannerController(promiseToPayService, $scope, messagesService) {
                        var _this = this;
                        this.promiseToPayService = promiseToPayService;
                        this.$scope = $scope;
                        this.messagesService = messagesService;
                        this.type = '';
                        this.message = '';
                        this.displayCheckEligibleSuccessBanner = false;
                        this.displayInEligibleReasons = false;
                        this.inEligibleReasons = [];
                        this.scope = $scope;
                        this.checkEligibilitySuccessMessageUrl = this.promiseToPayService.getConfig().advanced.ptpCheckEligibility.checkEligibilitySuccessMessageUrl;
                        this.messagesService.register('ute-ptp-update-message-banner', function (data, val) { return _this.updateMessageBanner(); });
                    }
                    PromiseToPayMessageBannerController.prototype.displayCheckEligibilitySuccess = function () {
                        this.type = 'success';
                        this.message = 'ute.rogers.promiseToPay.messageBanner.success';
                        this.displayCheckEligibleSuccessBanner = true;
                    };
                    PromiseToPayMessageBannerController.prototype.displayShedulePTPSuccess = function () {
                        this.type = 'success';
                        this.message = 'ute.rogers.promiseToPay.schedulePTP.pendingPTPmessage1';
                        this.displayCheckEligibleSuccessBanner = false;
                    };
                    PromiseToPayMessageBannerController.prototype.displayCheckEligibilityError = function () {
                        this.inEligibleReasons = [];
                        this.type = 'error';
                        this.message = 'ute.rogers.promiseToPay.messageBanner.inEligibleForPromiseToPay';
                        this.inEligibleReasons = this.promiseToPayService.getIneligibleReasons();
                        this.displayCheckEligibleSuccessBanner = false;
                        this.displayInEligibleReasons = true;
                    };
                    PromiseToPayMessageBannerController.prototype.updateMessageBanner = function () {
                        this.watchVariables = this.promiseToPayService.getWatchVariables();
                        if (this.watchVariables) {
                            if (this.watchVariables.checkEligibilitySuccess) {
                                this.displayCheckEligibilitySuccess();
                            }
                            else if (this.watchVariables.shedulePTPSuccess) {
                                this.displayShedulePTPSuccess();
                            }
                            else if (this.watchVariables.checkEligibilityError) {
                                this.displayCheckEligibilityError();
                            }
                        }
                    };
                    PromiseToPayMessageBannerController.controllerName = 'ute.promise.to.pay.message.banner.directive.controller';
                    PromiseToPayMessageBannerController.$inject = [
                        'ute.promise.to.pay.service',
                        '$scope',
                        'ute.blocks.messages.bus.service'
                    ];
                    return PromiseToPayMessageBannerController;
                }());
                pay.PromiseToPayMessageBannerController = PromiseToPayMessageBannerController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.message.banner.directive.controller', PromiseToPayMessageBannerController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                //import IwatchVariable = ute.promise.to.pay.IwatchVariable;
                var PromiseToPayMessageBanner = (function () {
                    /* @ngInject */
                    function PromiseToPayMessageBanner(promiseToPayService) {
                        this.promiseToPayService = promiseToPayService;
                        this.restrict = 'EA';
                        this.templateUrl = this.promiseToPayService.getConfig().advanced.ptpMessageBanner.messageBannerTemplateUrl;
                        this.controller = this.promiseToPayService.getConfig().advanced.ptpMessageBanner.messageBannerControllerName;
                        this.controllerAs = 'promiseToPayMessageBanner';
                        /* private returnWatchVariables: () => IwatchVariable = () => {
                           return this.promiseToPayService.getWatchVariables();
                         }*/
                        /**
                         * @param scope
                         */
                        this.linkFn = function (scope, element, attrs, controller) {
                            /*scope.$watch(this.returnWatchVariables, (value: IwatchVariable) => {
                              if (value) {
                                if (value.checkEligibilitySuccess) {
                                  controller.displayCheckEligibilitySuccess();
                                } else if (value.shedulePTPSuccess) {
                                  controller.displayShedulePTPSuccess();
                                } else if (value.checkEligibilityError) {
                                  controller.displayCheckEligibilityError();
                                }
                             }
                          }, true);*/
                        };
                        this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.promise.to.pay.IPromiseToPayService): ute.promise.to.pay.PromiseToPay}
                     */
                    PromiseToPayMessageBanner.factory = function () {
                        var directive = function (promiseToPayService) { return new PromiseToPayMessageBanner(promiseToPayService); };
                        directive.$inject = ['ute.promise.to.pay.service'];
                        return directive;
                    };
                    return PromiseToPayMessageBanner;
                }());
                angular.module('ute.promise.to.pay').directive('utePromiseToPayMessageBanner', PromiseToPayMessageBanner.factory());
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                angular.module('ute.promise.to.pay').directive('utePtpCurrency', utePtpCurrency);
                utePtpCurrency.$inject = [];
                /* @ngInject */
                function utePtpCurrency() {
                    return {
                        require: 'ngModel',
                        restrict: 'A',
                        link: function (scope, $elem, $attrs, ngModelCtrl) {
                            $elem.bind('keypress', function (event) {
                                var key = event.which;
                                if (key === 0 || key === 8 || (15 < key && key < 19) || (37 <= key && key <= 40)) {
                                    return;
                                }
                                if (!(48 <= key && key <= 57) &&
                                    String.fromCharCode(key) !== ',' &&
                                    String.fromCharCode(key) !== '.') {
                                    event.preventDefault();
                                    return;
                                }
                            });
                        }
                    };
                }
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                angular.module('ute.promise.to.pay').directive('utePtpDatePicker', utePtpDatePicker);
                utePtpDatePicker.$inject = ['$browser'];
                /* @ngInject */
                function utePtpDatePicker($browser) {
                    return {
                        require: 'ngModel',
                        restrict: 'A',
                        link: function (scope, $elem, $attrs, ngModelCtrl) {
                            var updateModel = function (dateText) {
                                scope.$apply(function () {
                                    ngModelCtrl.$setViewValue(dateText);
                                });
                            };
                            var options = {
                                dateFormat: 'mm/dd/yy',
                                numberOfMonths: [1, 2],
                                maxDate: '+29d',
                                minDate: 0,
                                showOn: 'button',
                                buttonImage: 'ute-promise-to-pay/assets/calander.png',
                                buttonImageOnly: true,
                                prevText: '<',
                                nextText: '>',
                                onSelect: function (dateText) {
                                    updateModel(dateText);
                                }
                            };
                            $elem.datepicker(options);
                        }
                    };
                }
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPaySchedulePTPController = (function () {
                    /* @ngInject */
                    function PromiseToPaySchedulePTPController(promiseToPayService, $modal, $translate, $state, languageService, permissionsService) {
                        var _this = this;
                        this.promiseToPayService = promiseToPayService;
                        this.$modal = $modal;
                        this.$translate = $translate;
                        this.$state = $state;
                        this.languageService = languageService;
                        this.permissionsService = permissionsService;
                        this.isValidPromiseAmount = false;
                        this.schedulePromisePermission = false;
                        this.scheduleFormLoad = false;
                        this.translate = $translate;
                        this.$state = $state;
                        this.estimatedPostingDate = this.promiseToPayService.getEstimatedPostingDate();
                        this.lang = this.promiseToPayService.getLanguage();
                        this.placeHolderValue = this.translate.instant('ute.rogers.promiseToPay.schedulePTP.placeHolderValue');
                        this.checkPermission();
                        this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.lang = lang;
                            _this.placeHolderValue = _this.translate.instant('ute.rogers.promiseToPay.schedulePTP.placeHolderValue');
                            return null;
                        }, 'ute.promise.to.pay.schedulePTP.directive.controller');
                    }
                    PromiseToPaySchedulePTPController.prototype.checkPermission = function () {
                        var _this = this;
                        this.permissionsService.getRamPermission(ute.common.permissions.service.RamResourceCodes.PromiseToPay, ute.common.permissions.service.RamActionCodes.make)
                            .then(function (ptpPermission) {
                            _this.schedulePromisePermission = ptpPermission;
                            console.log('schedulePromisePermission inside the checkPermission' + _this.schedulePromisePermission);
                        });
                    };
                    PromiseToPaySchedulePTPController.prototype.getEstimatedPostingDate = function () {
                        this.estimatedPostingDate = this.promiseToPayService.getEstimatedPostingDate();
                        //this.isValidPromiseDate = true;
                        this.collectionNotPaused = false;
                        var postingDate = this.estimatedPostingDate;
                        var currentDatePlusEleven = this.promiseToPayService.addDays(new Date(), 11);
                        if (postingDate > currentDatePlusEleven) {
                            this.collectionNotPaused = true;
                        }
                    };
                    PromiseToPaySchedulePTPController.prototype.setPromiseDate = function () {
                        this.promiseToPayService.setPromiseDate(this.formPromiseDate);
                        this.getEstimatedPostingDate();
                    };
                    PromiseToPaySchedulePTPController.prototype.setPaymentMethod = function () {
                        this.promiseToPayService.setPaymentMethod(this.formPaymentMethod);
                        this.getEstimatedPostingDate();
                    };
                    PromiseToPaySchedulePTPController.prototype.schedulePTP = function () {
                        var _this = this;
                        this.scheduleFormLoad = true;
                        this.promiseToPayService.setPaymentAmount(this.getEnglishAmount(this.formPaymentAmount));
                        this.promiseToPayService.schedulePTP().then(function (result) {
                            _this.scheduleFormLoad = false;
                            if (result.status && result.status.toLowerCase() === 'success') {
                                _this.enableForm = false;
                                _this.resetForm();
                            }
                            else {
                                _this.openModel();
                            }
                        }).catch(function (result) {
                            _this.scheduleFormLoad = false;
                            _this.openModel();
                        });
                    };
                    PromiseToPaySchedulePTPController.prototype.cancelPTP = function () {
                        this.$state.go(this.promiseToPayService.getConfig().basic.cancelState);
                    };
                    PromiseToPaySchedulePTPController.prototype.validateAmount = function () {
                        var paymentValue = this.formPaymentAmount;
                        var paymentNumber = Number(this.getEnglishAmount(paymentValue));
                        if (paymentNumber && paymentNumber > 0) {
                            this.isValidPromiseAmount = true;
                        }
                        else {
                            this.isValidPromiseAmount = false;
                        }
                    };
                    PromiseToPaySchedulePTPController.prototype.openModel = function () {
                        this.$modal.open({
                            templateUrl: this.promiseToPayService.getConfig().advanced.ptpErrorModal.templateUrl,
                            controller: this.promiseToPayService.getConfig().advanced.ptpErrorModal.controllerName,
                            controllerAs: 'modalContoller',
                            size: 'md',
                            backdrop: 'static',
                            backdropClass: 'bkg-modal',
                            resolve: {}
                        });
                    };
                    PromiseToPaySchedulePTPController.prototype.enableSheduleForm = function () {
                        this.enableForm = true;
                        if (Number(this.promiseToPayService.getRetrivePTPInfo().accountBalance) > 0) {
                            if (this.lang === 'en') {
                                this.formPaymentAmount = this.promiseToPayService.getRetrivePTPInfo().accountBalance;
                            }
                            else {
                                this.formPaymentAmount = this.getFrenchAmount(this.promiseToPayService.getRetrivePTPInfo().accountBalance);
                            }
                        }
                        this.validateAmount();
                    };
                    PromiseToPaySchedulePTPController.prototype.getFrenchAmount = function (paymentValue) {
                        if (paymentValue) {
                            paymentValue = paymentValue.replace('.', ',');
                        }
                        return paymentValue;
                    };
                    PromiseToPaySchedulePTPController.prototype.getEnglishAmount = function (paymentValue) {
                        if (paymentValue) {
                            paymentValue = paymentValue.replace(',', '.');
                        }
                        return paymentValue;
                    };
                    PromiseToPaySchedulePTPController.prototype.resetForm = function () {
                        this.promiseToPayService.resetDataModel();
                        this.collectionNotPaused = false;
                        this.formPaymentAmount = '';
                        this.formPromiseDate = '';
                        this.estimatedPostingDate = this.promiseToPayService.getEstimatedPostingDate();
                        this.formPaymentMethod = 'CC/InteracDebit';
                        this.isValidPromiseAmount = false;
                    };
                    PromiseToPaySchedulePTPController.controllerName = 'ute.promise.to.pay.schedulePTP.directive.controller';
                    PromiseToPaySchedulePTPController.$inject = [
                        'ute.promise.to.pay.service',
                        '$modal',
                        '$translate',
                        '$state',
                        'ute.blocks.language.switcher',
                        'ute.common.permissions.service'
                    ];
                    return PromiseToPaySchedulePTPController;
                }());
                pay.PromiseToPaySchedulePTPController = PromiseToPaySchedulePTPController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.schedulePTP.directive.controller', PromiseToPaySchedulePTPController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPaySchedulePTP = (function () {
                    /* @ngInject */
                    function PromiseToPaySchedulePTP(promiseToPayService) {
                        var _this = this;
                        this.promiseToPayService = promiseToPayService;
                        this.restrict = 'E';
                        this.templateUrl = this.promiseToPayService.getConfig().advanced.ptpSchedule.templateUrl;
                        this.controller = this.promiseToPayService.getConfig().advanced.ptpSchedule.controllerName;
                        this.controllerAs = 'promiseToPaySchedulePTP';
                        /**
                         * @param scope
                         */
                        this.getWatchVariables = function () {
                            return _this.promiseToPayService.getWatchVariables();
                        };
                        this.linkFn = function (scope, element, attrs, controller) {
                            scope.$watch(_this.getWatchVariables, function (value) {
                                if (value) {
                                    if (value.checkEligibilitySuccess) {
                                        controller.enableSheduleForm();
                                    }
                                }
                            }, true);
                        };
                        this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.promise.to.pay.IPromiseToPayService): ute.promise.to.pay.PromiseToPay}
                     */
                    PromiseToPaySchedulePTP.factory = function () {
                        var directive = function (promiseToPayService) { return new PromiseToPaySchedulePTP(promiseToPayService); };
                        directive.$inject = ['ute.promise.to.pay.service'];
                        return directive;
                    };
                    return PromiseToPaySchedulePTP;
                }());
                angular.module('ute.promise.to.pay').directive('utePromiseToPaySchedulePtp', PromiseToPaySchedulePTP.factory());
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayTabsController = (function () {
                    /* @ngInject */
                    function PromiseToPayTabsController(promiseToPayService, $state, $scope) {
                        this.promiseToPayService = promiseToPayService;
                        this.$state = $state;
                        this.$scope = $scope;
                        this.$state = $state;
                        this.scope = $scope;
                        if (this.scope.tabName === 'takePayment') {
                            this.takePayment = true;
                        }
                        else {
                            this.takePayment = false;
                        }
                    }
                    PromiseToPayTabsController.prototype.takePaymentTab = function () {
                        this.takePayment = true;
                        this.$state.go(this.promiseToPayService.getConfig().basic.paynow);
                    };
                    PromiseToPayTabsController.prototype.promiseToPayTab = function () {
                        this.takePayment = false;
                        this.promiseToPayService.goToEntryState();
                    };
                    PromiseToPayTabsController.controllerName = 'ute.promise.to.pay.directive.tabs.controller';
                    PromiseToPayTabsController.$inject = [
                        'ute.promise.to.pay.service',
                        '$state',
                        '$scope'
                    ];
                    return PromiseToPayTabsController;
                }());
                pay.PromiseToPayTabsController = PromiseToPayTabsController;
                angular.module('ute.promise.to.pay').controller('ute.promise.to.pay.directive.tabs.controller', PromiseToPayTabsController);
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var promise;
    (function (promise) {
        var to;
        (function (to) {
            var pay;
            (function (pay) {
                'use strict';
                var PromiseToPayTabs = (function () {
                    /* @ngInject */
                    function PromiseToPayTabs(promiseToPayService) {
                        this.promiseToPayService = promiseToPayService;
                        this.restrict = 'E';
                        this.scope = {
                            tabName: '@'
                        };
                        this.templateUrl = this.promiseToPayService.getConfig().advanced.ptpTabs.templateUrl;
                        this.controller = this.promiseToPayService.getConfig().advanced.ptpTabs.controllerName;
                        this.controllerAs = 'promiseToPayTabs';
                        this.linkFn = function (scope, element, attrs, controller) {
                            //
                        };
                        this.link = this.linkFn;
                    }
                    /* link: ng.IDirectiveLinkFn;*/
                    /**
                     * @returns {function(ute.promise.to.pay.IPromiseToPayService): ute.promise.to.pay.PromiseToPay}
                     */
                    PromiseToPayTabs.factory = function () {
                        var directive = function (promiseToPayService) { return new PromiseToPayTabs(promiseToPayService); };
                        directive.$inject = ['ute.promise.to.pay.service'];
                        return directive;
                    };
                    return PromiseToPayTabs;
                }());
                angular.module('ute.promise.to.pay').directive('utePromiseToPayTabs', PromiseToPayTabs.factory());
            })(pay = to.pay || (to.pay = {}));
        })(to = promise.to || (promise.to = {}));
    })(promise = ute.promise || (ute.promise = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var CTNSelectionController = (function () {
            /* @ngInject */
            function CTNSelectionController($scope, torCurrentCustomerService, TORService) {
                this.$scope = $scope;
                this.torCurrentCustomerService = torCurrentCustomerService;
                this.TORService = TORService;
                this.model = this.TORService.getModel();
                this.ctnList = this.TORService.getModel().ctnList;
                this.config = this.TORService.getConfig();
                this.selectedCtnsValue = [];
                this.stepTrackerIndex = 1;
                this.model.stepTrackerIndex = 1;
                this.screenName = this.TORService.getScreenName();
            }
            CTNSelectionController.prototype.goToEligibilityResults = function () {
                this.model.stepTrackerIndex = 1;
                this.TORService.goToState(this.TORService.getConfig().advanced.stepOne.eligibilityCheck.subState);
            };
            CTNSelectionController.prototype.updateSelectedCtnList = function (ctn) {
                if (ctn.isSelected) {
                    this.selectedCtnsValue.push(ctn.subscriberNumber);
                    this.selectedCtnsValue = _.uniq(this.selectedCtnsValue);
                    this.model.selectedCtnList.push(ctn.subscriberNumber);
                    this.model.selectedCtnList = _.uniq(this.model.selectedCtnList);
                }
                else {
                    this.selectedCtnsValue = _.without(this.selectedCtnsValue, ctn.subscriberNumber);
                    this.model.selectedCtnList = _.without(this.model.selectedCtnList, ctn.subscriberNumber);
                }
            };
            CTNSelectionController.$inject = ['$scope',
                'ute.transferOfResponsibility.currentOwner.service',
                'ute.transferOfResponsibility.service'
            ];
            return CTNSelectionController;
        }());
        transferOfResponsibility.CTNSelectionController = CTNSelectionController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.ctnSelection.controller', CTNSelectionController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var CurrentOwnerEligibilityCheckController = (function () {
            /* @ngInject */
            function CurrentOwnerEligibilityCheckController($scope, torCurrentCustomerService, TORService, $modal) {
                var _this = this;
                this.$scope = $scope;
                this.torCurrentCustomerService = torCurrentCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                /**
                 * @returns {void}
                 */
                this.openErrorModal = function () {
                    if (!_this.isModalShown) {
                        _this.isModalShown = true;
                        _this.$modal.open({
                            templateUrl: _this.config.advanced.errorModal.templateUrl,
                            controller: _this.config.advanced.errorModal.controllerName,
                            controllerAs: 'errorModal',
                            size: '',
                            backdrop: 'static',
                            backdropClass: 'bkg-modal'
                        });
                    }
                };
                /**
                 * @returns {void}
                 */
                this.doCtnAPICalls = function () {
                    var localCtnList = _this.model.ctnList;
                    for (var _i = 0, localCtnList_1 = localCtnList; _i < localCtnList_1.length; _i++) {
                        var ctn = localCtnList_1[_i];
                        if (ctn.isSelected && (ctn.isEligible === null ||
                            angular.isUndefined(ctn.isEligible))) {
                            _this.checkEligibilityCall(ctn);
                        }
                    }
                };
                /**
                 * @returns {void}
                 */
                this.doBanAPICall = function () {
                    _this.torCurrentCustomerService.eligibilityCheck(null)
                        .then(function (result) {
                        if (result.status === 'success') {
                            _this.model.isBANEligible = result.isEligible;
                            if (!result.isEligible) {
                                _this.model.banReasonCodes = result.reasonCodes;
                            }
                        }
                        else if (result.status === 'failure') {
                            _this.openErrorModal();
                        }
                        else {
                            _this.openErrorModal();
                        }
                    })
                        .catch(function (error) {
                        _this.openErrorModal();
                    });
                };
                /**
                 * @returns {void}
                 */
                this.addAnotherCtnInDialog = function (selectedCtnsCount) {
                    var total = selectedCtnsCount.length + _this.model.selectedCtnList.length;
                    _this.isAllCtnsSelected = (total === _this.model.ctnList.length) ? true : false;
                };
                this.model = this.TORService.getModel();
                this.ctnList = this.TORService.getModel().ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 1;
                this.model.stepTrackerIndex = 1;
                this.screenName = this.TORService.getScreenName();
                this.doCtnAPICalls();
                this.doBanAPICall();
            }
            CurrentOwnerEligibilityCheckController.prototype.checkEligibilityCall = function (ctn) {
                var _this = this;
                this.torCurrentCustomerService.eligibilityCheck(ctn)
                    .then(function (result) {
                    if (result.status === 'success') {
                        if (ctn) {
                            console.log('ctn.subscriberNumber: ' + ctn.subscriberNumber);
                            ctn.isEligible = result.isEligible;
                            if (ctn.isEligible) {
                                _this.isOneCtnEligible = true;
                            }
                            if (!result.isEligible) {
                                ctn.reasonCodes = result.reasonCodes;
                            }
                        }
                    }
                    else if (result.status === 'failure') {
                        if (ctn) {
                            ctn.isStatusFailure = true;
                        }
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            CurrentOwnerEligibilityCheckController.prototype.eligibitySaveAndProceed = function () {
                this.model.stepTrackerIndex = 2;
                if ((this.model.isBANEligible && this.isOneCtnEligible)) {
                    this.TORService.goToState(this.TORService.getConfig().advanced.stepTwo.futureOwnerInfo.subState);
                }
            };
            CurrentOwnerEligibilityCheckController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            CurrentOwnerEligibilityCheckController.prototype.addAnotherCtn = function () {
                this.$modal.open({
                    templateUrl: this.config.advanced.addAnotherCtnModal.templateUrl,
                    controller: this.config.advanced.addAnotherCtnModal.controllerName,
                    controllerAs: 'addAnotherCtnModal',
                    size: '',
                    backdrop: 'static',
                    backdropClass: 'bkg-modal'
                });
            };
            CurrentOwnerEligibilityCheckController.prototype.addAnotherNumber = function () {
                this.TORService.goToState(this.TORService.getConfig().advanced.stepOne.ctnSelection.subState);
            };
            CurrentOwnerEligibilityCheckController.$inject = ['$scope',
                'ute.transferOfResponsibility.currentOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal'
            ];
            return CurrentOwnerEligibilityCheckController;
        }());
        transferOfResponsibility.CurrentOwnerEligibilityCheckController = CurrentOwnerEligibilityCheckController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.currentOwnerEligibilityCheck.controller', CurrentOwnerEligibilityCheckController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var CurrentOwnerInfoController = (function () {
            /* @ngInject */
            function CurrentOwnerInfoController($scope, torDestinationCustomerService, TORService, $modal) {
                this.$scope = $scope;
                this.torDestinationCustomerService = torDestinationCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                this.model = this.TORService.getModel();
                this.ctnList = this.model.ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 3;
                this.model.stepTrackerIndex = 3;
                this.screenName = this.TORService.getScreenName();
            }
            CurrentOwnerInfoController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            CurrentOwnerInfoController.prototype.runEligibilityCheck = function () {
                this.TORService.goToState(this.TORService.getConfig().advanced.stepThree.eligibilityCheck.subState);
            };
            CurrentOwnerInfoController.$inject = ['$scope',
                'ute.transferOfResponsibility.futureOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal'];
            return CurrentOwnerInfoController;
        }());
        transferOfResponsibility.CurrentOwnerInfoController = CurrentOwnerInfoController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.currentOwnerInfo.controller', CurrentOwnerInfoController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var FutureOwnerEligibilityCheckController = (function () {
            /* @ngInject */
            function FutureOwnerEligibilityCheckController($scope, torDestinationCustomerService, TORService, $modal) {
                var _this = this;
                this.$scope = $scope;
                this.torDestinationCustomerService = torDestinationCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                this.checkApiCount = 0;
                /**
                 * @returns {void}
                 */
                this.openErrorModal = function () {
                    if (!_this.isErrorPopupOpen) {
                        _this.isErrorPopupOpen = true;
                        _this.$modal.open({
                            templateUrl: _this.config.advanced.errorModal.templateUrl,
                            controller: _this.config.advanced.errorModal.controllerName,
                            controllerAs: 'errorModal',
                            size: '',
                            backdrop: 'static',
                            backdropClass: 'bkg-modal'
                        });
                    }
                };
                this.model = this.TORService.getModel();
                this.ctnList = this.model.ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 3;
                this.model.stepTrackerIndex = 3;
                this.screenName = this.TORService.getScreenName();
                this.futureOwnerAccountNumberValidation();
                this.currentOwnerCtnNumberValidation();
                this.currentOwnerAccountNumberValidation();
            }
            FutureOwnerEligibilityCheckController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            /* future owner accountNumber Validation */
            FutureOwnerEligibilityCheckController.prototype.futureOwnerAccountNumberValidation = function () {
                var request = {
                    accountNumber: this.model.accountNumber,
                    applicationId: this.config.basic.applicationId,
                    medium: this.config.basic.medium,
                    eligibilityType: 'ban',
                    ban: this.TORService.getRequestedAccountNumber()
                };
                this.doFutureOwnerAccountNumberEligibility(request);
            };
            /* current owner ctn number Validation */
            FutureOwnerEligibilityCheckController.prototype.currentOwnerCtnNumberValidation = function () {
                var request = {
                    accountNumber: this.model.accountNumber,
                    applicationId: this.config.basic.applicationId,
                    medium: this.config.basic.medium,
                    eligibilityType: 'ctn',
                    subscriberNumber: this.model.sourceAccountInfo.subscriberNumber,
                    sourceAccountNumber: this.model.sourceAccountInfo.accountNumber,
                    ban: this.TORService.getRequestedAccountNumber()
                };
                this.doCurrentOwnerCtnEligibility(request);
            };
            /* current owner account number Validation */
            FutureOwnerEligibilityCheckController.prototype.currentOwnerAccountNumberValidation = function () {
                var request = {
                    accountNumber: this.model.accountNumber,
                    applicationId: this.config.basic.applicationId,
                    medium: this.config.basic.medium,
                    eligibilityType: 'ban',
                    subscriberNumber: this.model.sourceAccountInfo.subscriberNumber,
                    sourceAccountNumber: this.model.sourceAccountInfo.accountNumber,
                    ban: this.TORService.getRequestedAccountNumber()
                };
                this.doCurrentOwnerAccountNumberEligibility(request);
            };
            FutureOwnerEligibilityCheckController.prototype.doFutureOwnerAccountNumberEligibility = function (request) {
                var _this = this;
                this.torDestinationCustomerService.eligibilityCheck(request)
                    .then(function (result) {
                    if (result.status === 'success') {
                        _this.model.isBANEligible = result.isEligible;
                        if (!_this.model.isBANEligible) {
                            _this.model.banReasonCodes = result.reasonCodes;
                        }
                        else {
                            _this.checkApiCount = _this.checkApiCount + 1;
                        }
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            FutureOwnerEligibilityCheckController.prototype.doCurrentOwnerCtnEligibility = function (request) {
                var _this = this;
                this.torDestinationCustomerService.eligibilityCheck(request)
                    .then(function (result) {
                    if (result.status === 'success') {
                        _this.model.sourceAccountInfo.isSourceCtnEligible = result.isEligible;
                        if (!_this.model.sourceAccountInfo.isSourceCtnEligible) {
                            _this.model.sourceAccountInfo.reasonCodes = result.reasonCodes;
                        }
                        else {
                            _this.checkApiCount = _this.checkApiCount + 1;
                        }
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            FutureOwnerEligibilityCheckController.prototype.doCurrentOwnerAccountNumberEligibility = function (request) {
                var _this = this;
                this.torDestinationCustomerService.eligibilityCheck(request)
                    .then(function (result) {
                    if (result.status === 'success') {
                        _this.model.sourceAccountInfo.isSourceBANEligible = result.isEligible;
                        if (!_this.model.sourceAccountInfo.isSourceBANEligible) {
                            _this.model.sourceAccountInfo.banReasonCodes = result.reasonCodes;
                        }
                        else {
                            _this.checkApiCount = _this.checkApiCount + 1;
                        }
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            FutureOwnerEligibilityCheckController.prototype.destinationSubmit = function () {
                var _this = this;
                this.destinationSubmitCallInProgress = true;
                this.torDestinationCustomerService.destinationSubmit()
                    .then(function (result) {
                    _this.destinationSubmitCallInProgress = false;
                    if (result.status === 'success') {
                        _this.TORService.goToState(_this.TORService.getConfig().advanced.stepFour.subState);
                        _this.model.stepTrackerIndex = 4;
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            FutureOwnerEligibilityCheckController.prototype.copyNumber = function () {
                document.querySelector('#subscriberNumber');
                document.execCommand('copy');
            };
            FutureOwnerEligibilityCheckController.$inject = ['$scope',
                'ute.transferOfResponsibility.futureOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal'];
            return FutureOwnerEligibilityCheckController;
        }());
        transferOfResponsibility.FutureOwnerEligibilityCheckController = FutureOwnerEligibilityCheckController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.futureOwnerEligibilityCheck.controller', FutureOwnerEligibilityCheckController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var SubscriberDetailsController = (function () {
            /* @ngInject */
            function SubscriberDetailsController($scope, torDestinationCustomerService, TORService, $modal) {
                var _this = this;
                this.$scope = $scope;
                this.torDestinationCustomerService = torDestinationCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                /**
                 * @returns {void}
                 */
                this.openErrorModal = function () {
                    if (!_this.isErrorPopupOpen) {
                        _this.isErrorPopupOpen = true;
                        _this.$modal.open({
                            templateUrl: _this.config.advanced.errorModal.templateUrl,
                            controller: _this.config.advanced.errorModal.controllerName,
                            controllerAs: 'errorModal',
                            size: '',
                            backdrop: 'static',
                            backdropClass: 'bkg-modal'
                        });
                    }
                };
                this.model = this.TORService.getModel();
                this.ctnList = this.model.ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 3;
                this.model.stepTrackerIndex = 3;
                this.screenName = this.TORService.getScreenName();
            }
            SubscriberDetailsController.prototype.getTORInProgressDetails = function () {
                var _this = this;
                this.showErrorMessage = false;
                this.isGetDetailsInProgress = true;
                this.torDestinationCustomerService.getDetails()
                    .then(function (result) {
                    _this.isGetDetailsInProgress = false;
                    if (result.status === 'success') {
                        if (_this.TORService.getModel().sourceAccountInfo.isCtnFound) {
                            _this.TORService.goToState(_this.TORService.getConfig().advanced.stepThree.currentOwnerInfo.subState);
                        }
                        else {
                            _this.showErrorMessage = true;
                        }
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.isGetDetailsInProgress = false;
                    _this.openErrorModal();
                });
            };
            SubscriberDetailsController.$inject = ['$scope',
                'ute.transferOfResponsibility.futureOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal'];
            return SubscriberDetailsController;
        }());
        transferOfResponsibility.SubscriberDetailsController = SubscriberDetailsController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.subscriberDetails.controller', SubscriberDetailsController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var ConfirmationController = (function () {
            /* @ngInject */
            function ConfirmationController($scope, torCurrentCustomerService, TORService, $modal, messagesService) {
                this.$scope = $scope;
                this.torCurrentCustomerService = torCurrentCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                this.messagesService = messagesService;
                this.model = this.TORService.getModel();
                this.ctnList = this.TORService.getModel().ctnList;
                this.config = this.TORService.getConfig();
                this.stepTrackerIndex = 2;
                this.model.stepTrackerIndex = 2;
                this.screenName = this.TORService.getScreenName();
            }
            ConfirmationController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            ConfirmationController.$inject = ['$scope',
                'ute.transferOfResponsibility.currentOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal',
                'ute.blocks.messages.bus.service'
            ];
            return ConfirmationController;
        }());
        transferOfResponsibility.ConfirmationController = ConfirmationController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.confirmation.controller', ConfirmationController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var transferOfResponsibility;
    (function (transferOfResponsibility) {
        'use strict';
        var FutureOwnerInfoController = (function () {
            /* @ngInject */
            function FutureOwnerInfoController($scope, torCurrentCustomerService, TORService, $modal) {
                var _this = this;
                this.$scope = $scope;
                this.torCurrentCustomerService = torCurrentCustomerService;
                this.TORService = TORService;
                this.$modal = $modal;
                /**
                 * @returns {void}
                 */
                this.openErrorModal = function () {
                    _this.sourceSubmitCallInProgress = false;
                    _this.$modal.open({
                        templateUrl: _this.config.advanced.errorModal.templateUrl,
                        controller: _this.config.advanced.errorModal.controllerName,
                        controllerAs: 'errorModal',
                        size: '',
                        backdrop: 'static',
                        backdropClass: 'bkg-modal'
                    });
                };
                this.model = this.TORService.getModel();
                this.ctnList = this.TORService.getModel().ctnList;
                this.config = this.TORService.getConfig();
                this.selectedCtnsValue = [];
                this.stepTrackerIndex = 2;
                this.model.stepTrackerIndex = 2;
                this.screenName = this.TORService.getScreenName();
            }
            FutureOwnerInfoController.prototype.formSaveAndProceed = function () {
                this.sourceSubmit();
            };
            FutureOwnerInfoController.prototype.backToTor = function () {
                this.TORService.cancelTranferOfResponsibility();
            };
            FutureOwnerInfoController.prototype.sourceSubmit = function () {
                var _this = this;
                this.sourceSubmitCallInProgress = true;
                this.torCurrentCustomerService.sourceSubmit()
                    .then(function (result) {
                    _this.sourceSubmitCallInProgress = false;
                    if (result.status === 'success') {
                        _this.TORService.goToState(_this.TORService.getConfig().advanced.stepTwo.confirmation.subState);
                    }
                    else if (result.status === 'failure') {
                        _this.openErrorModal();
                    }
                    else {
                        _this.openErrorModal();
                    }
                })
                    .catch(function (error) {
                    _this.openErrorModal();
                });
            };
            FutureOwnerInfoController.$inject = ['$scope',
                'ute.transferOfResponsibility.currentOwner.service',
                'ute.transferOfResponsibility.service',
                '$modal'
            ];
            return FutureOwnerInfoController;
        }());
        transferOfResponsibility.FutureOwnerInfoController = FutureOwnerInfoController;
        angular.module('ute.transferOfResponsibility').controller('ute.transferOfResponsibility.futureOwnerInfo.controller', FutureOwnerInfoController);
    })(transferOfResponsibility = ute.transferOfResponsibility || (ute.transferOfResponsibility = {}));
})(ute || (ute = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
                var CacheableDataGeneric = ute.common.core.caching.CacheableDataGeneric;
                var ProviderBase = ute.common.core.ProviderBase;
                var UtilsStatic = ute.common.utils.UtilsStatic;
                var EncryptBriteBillResponseData = (function () {
                    function EncryptBriteBillResponseData() {
                    }
                    return EncryptBriteBillResponseData;
                }());
                /**
                 * worker return cached result and implement refresh true/false retry logic
                 */
                var EncryptBriteBillWorker = (function (_super) {
                    __extends(EncryptBriteBillWorker, _super);
                    function EncryptBriteBillWorker(config, securityService, $http, $q, $timeout, userService, requestHeader) {
                        var _this = this;
                        _super.call(this, new EncryptBriteBillResponseData(), config, securityService, $http, $q, $timeout, userService, requestHeader);
                        this.isEncryptBriteBillCallInProgress = this.isCallInProgress;
                        this.getEncryptBriteBill = this.getData;
                        this.registerOnDataChangeHandler = this.registerOnDataChangeHandler;
                        this.unregisterOnDataChangeHandler = this.unregisterOnDataChangeHandler;
                        /**
                         * @override
                         *
                         */
                        this.resetCachedData = function () {
                            _this.resetData();
                        };
                        /**
                         * @override
                         * @param encryptBriteBillResponse
                         * @returns {IEncryptBriteBillResponseData}
                         */
                        this.normalizeData = function (encryptBriteBillResponse) {
                            encryptBriteBillResponse.errorCode = Boolean(encryptBriteBillResponse.errorCode);
                            return encryptBriteBillResponse;
                        };
                    }
                    ;
                    return EncryptBriteBillWorker;
                }(CacheableDataGeneric));
                //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                /**
                 * only one worker exists for the same request
                 */
                var EncryptBriteBillFactory = (function () {
                    function EncryptBriteBillFactory(config, securityService, $http, $q, $timeout, userService) {
                        var _this = this;
                        this.config = config;
                        this.securityService = securityService;
                        this.$http = $http;
                        this.$q = $q;
                        this.$timeout = $timeout;
                        this.userService = userService;
                        this._getWorker = function (request) {
                            return new EncryptBriteBillWorker(_this.config, _this.securityService, _this.$http, _this.$q, _this.$timeout, _this.userService, request);
                        };
                        this.getWorker = _.memoize(this._getWorker, UtilsStatic.memoizeResolver);
                    }
                    ;
                    return EncryptBriteBillFactory;
                }());
                //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
                /**
                 * Provider only responsable for configuration and to return factory
                 */
                var EncryptBriteBillProvider = (function (_super) {
                    __extends(EncryptBriteBillProvider, _super);
                    /* @ngInject */
                    function EncryptBriteBillProvider(briteBillProvider) {
                        var _this = this;
                        _super.call(this);
                        this.briteBillProvider = briteBillProvider;
                        /* @ngInject */
                        this.$get = function ($injector, $http, $q, $timeout) {
                            var factory = new EncryptBriteBillFactory(_this.config, $injector.get('ute.common.security.service'), $http, $q, $timeout, $injector.get('ute.common.user.service'));
                            return function (request) { return factory.getWorker(request); };
                        };
                        this.$get.$inject = [
                            '$injector',
                            '$http',
                            '$q',
                            '$timeout'
                        ];
                        this.config = {
                            basic: {
                                applicationId: briteBillProvider.getConfig().basic.applicationId,
                                partialApiUrl: briteBillProvider.getConfig().basic.partialApiUrl,
                                logPrefix: 'EncryptBriteBill',
                                logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                                isCachableOnBackend: false
                            }
                        };
                    }
                    ;
                    EncryptBriteBillProvider.$inject = ['ute.brite.bill.serviceProvider'];
                    return EncryptBriteBillProvider;
                }(ProviderBase));
                angular.module('ute.brite.bill.service').provider('ute.brite.bill.service.encrypt.factory', EncryptBriteBillProvider);
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var data;
    (function (data) {
        var manager;
        (function (manager) {
            var service;
            (function (service) {
                'use strict';
            })(service = manager.service || (manager.service = {}));
        })(manager = data.manager || (data.manager = {}));
    })(data = ute.data || (ute.data = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var brite;
    (function (brite) {
        var bill;
        (function (bill) {
            var service;
            (function (service) {
                'use strict';
            })(service = bill.service || (bill.service = {}));
        })(bill = brite.bill || (brite.bill = {}));
    })(brite = ute.brite || (ute.brite = {}));
})(ute || (ute = {}));

var app;
(function (app) {
    var config;
    (function (config) {
        'use strict';
        angular.module('totesApp').config(configure);
        configure.$inject = [
            'ute.rogers.account.overview.factoryProvider',
            'ute.blocks.environmentProvider'
        ];
        /* @ngInject */
        function configure(accountOverviewProvider, environmentProvider) {
            accountOverviewProvider.configure({
                basic: {
                    applicationId: environmentProvider.getProperty('applicationId')
                }
            });
        }
    })(config = app.config || (app.config = {}));
})(app || (app = {}));

// namespace app.boot {
//   'use strict';
//
//   (() => {
//     /**
//      * example of custom implementation of environment type detector
//      */
//     //ute.blocks.environment.EnvironmentStatic.getEnvType = () => {
//     //  if (location.hostname.indexOf('www.rogers.com') === 0) {
//     //    return ute.blocks.environment.EnvironmentType.PROD;
//     //  } else if (location.hostname.indexOf('www.dev') === 0) {
//     //    return ute.blocks.environment.EnvironmentType.DEV;
//     //  } else if (location.hostname.indexOf('www.qa') === 0) {
//     //    return ute.blocks.environment.EnvironmentType.QA;
//     //  } else {
//     //    return ute.blocks.environment.EnvironmentType.LOCAL;
//     //  }
//     //};
//
//     /**
//      * or example of custom implementation of environment path detector
//      */
//     //ute.blocks.environment.EnvironmentStatic.getEnvConfigPath = () => {
//     //  return 'environments/customEnv.js';
//     //};
//
//     /**
//      * bootstrap angular app after get environment config
//      */
//     ute.blocks.environment.EnvironmentStatic.getEnvConfig(() => {
//           angular.element(document).ready(() => {
//             angular.bootstrap(document, ['totesApp'], {
//               // strictDi: true
//               strictDi: true
//             });
//           });
//         }
//     );
//   })();
// }

var app;
(function (app) {
    var config;
    (function (config) {
        'use strict';
        angular.module('totesApp').config(configure).run(run);
        configure.$inject = ['$httpProvider'];
        /* @ngInject */
        function configure($httpProvider) {
            $httpProvider.defaults.cache = true;
        }
        /**
         * @param $cacheFactory
         * @param fromMsg
         */
        function cleanCache($cacheFactory, fromMsg) {
            console.log('$cacheFactory->$http->cleanCache has been called from', fromMsg);
            $cacheFactory.get('$http').removeAll();
        }
        run.$inject = ['ute.common.user.service', '$cacheFactory'];
        /* @ngInject */
        function run(userService, $cacheFactory) {
            // debugger;
            userService.registerSigninHandler(_.partial(cleanCache, $cacheFactory, 'Signin'), cleanCache);
            userService.registerSignoutHandler(_.partial(cleanCache, $cacheFactory, 'Signout'), cleanCache);
        }
    })(config = app.config || (app.config = {}));
})(app || (app = {}));

var myr;
(function (myr) {
    var service;
    (function (service) {
        'use strict';
        var PageNotFoundController = (function () {
            /* @ngInject */
            function PageNotFoundController($window, $state) {
                var _this = this;
                this.$window = $window;
                this.$state = $state;
                this.gotoSignin = function () {
                    _this.$state.go('signin');
                };
                this.isNoHistory = ($window.history.length === 1);
            }
            PageNotFoundController.$inject = ['$window', '$state'];
            return PageNotFoundController;
        }());
        service.PageNotFoundController = PageNotFoundController;
        angular.module('totesApp').controller('pageNotFoundController', PageNotFoundController);
    })(service = myr.service || (myr.service = {}));
})(myr || (myr = {}));

var myr;
(function (myr) {
    var modules;
    (function (modules) {
        var accountPreferences;
        (function (accountPreferences) {
            'use strict';
            (function (VoicemailErrorCode) {
                VoicemailErrorCode[VoicemailErrorCode["GENERIC_ERROR"] = 0] = "GENERIC_ERROR";
                VoicemailErrorCode[VoicemailErrorCode["SUSPENDED_CTN"] = 1] = "SUSPENDED_CTN";
            })(accountPreferences.VoicemailErrorCode || (accountPreferences.VoicemailErrorCode = {}));
            var VoicemailErrorCode = accountPreferences.VoicemailErrorCode;
            var AccountPreferencesService = (function () {
                /* @ngInject */
                function AccountPreferencesService($http, $q, accountOverviewFactory, myrWirelessDashboardService, goPaperlessService) {
                    var _this = this;
                    this.$http = $http;
                    this.$q = $q;
                    this.accountOverviewFactory = accountOverviewFactory;
                    this.myrWirelessDashboardService = myrWirelessDashboardService;
                    this.goPaperlessService = goPaperlessService;
                    this.accountOverviewDataHandler = function (accountOverview) {
                        var account = accountOverview.getSelectedAccount();
                        _this.retrieveAccountOverviewSummary(account)
                            .then(_this.verifyWirelessSubscription)
                            .then(_this.setLink)
                            .then(_this.setPaperlessFlag)
                            .catch(_this.resetVoicemailPasswordErrorHandler);
                        return null;
                    };
                    this.getSelectedAccount = function () {
                        return _this.accountOverviewService.getSelectedAccountDetails(null);
                    };
                    this.getResetVoicemailPassword = function () {
                        _this.cleanAccountOverivewData();
                        return _this.accountOverviewService
                            .getSelectedAccount()
                            .then(_this.retrieveAccountOverviewSummary)
                            .then(_this.retrieveWirelessSubscription)
                            .then(function () { return _this.$q.when(_this.model); });
                    };
                    this.isPaperless = function () {
                        return _this.model.isPaperless;
                    };
                    this.isPrepaid = function () {
                        return _this.model.accountTypeNumber === 9;
                    };
                    this.initialize = function () {
                        if (_this.model.accountNumber !== null) {
                            return;
                        }
                        _this.accountOverviewService
                            .getSelectedAccount()
                            .then(_this.retrieveAccountOverviewSummary)
                            .then(_this.verifyWirelessSubscription)
                            .then(_this.setLink)
                            .then(_this.setPaperlessFlag)
                            .catch(_this.resetVoicemailPasswordErrorHandler);
                    };
                    this.getVoicemailLinkFlag = function () { return _this.model.showLink; };
                    this.setLink = function (setValue) {
                        _this.model.showLink = setValue;
                        _this.model.isPaperless = true; // to avoid displaying paperless link initially for new selected account, if getBillingType() takes time to get loaded.
                        return (_this.model.accountNumber && !_this.isPrepaid()) ? _this.goPaperlessService.getBillingType(_this.model.accountNumber, _this.model.accountTypeNumber) : null;
                    };
                    this.setPaperlessFlag = function (billingType) {
                        _this.model.isPaperless = (billingType === 'E_BILL');
                        if (!_this.model.isPaperless) {
                            _this.goPaperlessService.registerSwitchCallback(function (billingType) { return _this.model.isPaperless = (billingType === 'E_BILL'); }, 'accountPreferences');
                        }
                    };
                    this.resetVoicemailPasswordErrorHandler = function () {
                        _this.setLink(false);
                    };
                    this.verifyWirelessSubscription = function (accountOverviewSummary) {
                        var deffered = _this.$q.defer();
                        if (_this.model.accountTypeNumber === 1 && accountOverviewSummary.subList.filter(_this.filterWirelessList).length >= 1) {
                            deffered.resolve(true);
                        }
                        deffered.resolve(false);
                        return deffered.promise;
                    };
                    this.resetModel = function () {
                        _this.model = {
                            accountTypeNumber: 9,
                            accountNumber: null,
                            selectedAccountNickname: null,
                            wirelessSubscription: [],
                            showLink: false,
                            isPaperless: true,
                            voicemailLinkError: VoicemailErrorCode.GENERIC_ERROR
                        };
                    };
                    this.cleanAccountOverivewData = function () {
                        _this.model = {
                            accountTypeNumber: 9,
                            accountNumber: null,
                            selectedAccountNickname: null,
                            wirelessSubscription: [],
                            showLink: _this.model.showLink,
                            isPaperless: _this.model.isPaperless,
                            voicemailLinkError: VoicemailErrorCode.GENERIC_ERROR
                        };
                    };
                    this.filterWirelessList = function (subscription) {
                        if (subscription.subType === 'CTN' && subscription.subStatus === 'Active') {
                            return true;
                        }
                        return false;
                    };
                    /**
                     * Retrieve Account overview summary
                     */
                    this.retrieveAccountOverviewSummary = function (account) {
                        if (account && account.accountTypeNumber && +account.accountTypeNumber !== 9) {
                            _this.model.accountTypeNumber = account.accountTypeNumber;
                            _this.model.accountNumber = account.accountNumber;
                            _this.model.selectedAccountNickname = (account.nickname) ? account.nickname : account.accountName.firstName;
                            return account.getAccountOverviewSummary();
                        }
                        else {
                            return _this.$q.reject();
                        }
                    };
                    /**
                     * Check to find this wireless service has voicemail or not
                     */
                    this.hasVoicmailAddon = function (responseData) {
                        /**
                         * CTN should not in suspended mode and contains voicemail service
                         */
                        return ((_.has(responseData, 'content.postPaidDetails.content.postPaidPhoneDetails.isSuspendedCtn')
                            && responseData.content.postPaidDetails.content.postPaidPhoneDetails.isSuspendedCtn === false) &&
                            (_.has(responseData, 'content.postPaidDetails.content.postPaidPhoneDetails.postPaidAddons')
                                && _.filter(responseData.content.postPaidDetails.content.postPaidPhoneDetails.postPaidAddons, { socType: 'WIRELESS', socSubType: 'VM' }).length > 0));
                    };
                    this.retrieveWirelessSubscription = function (accountOverviewSummary) {
                        var promises = [];
                        accountOverviewSummary.subList.filter(_this.filterWirelessList).map(function (sub) {
                            var deffered = _this.$q.defer();
                            /**
                             * make an api call to get value to valid voicemail flag
                             */
                            var promise = _this.$http.post(AccountPreferencesService.postPaidDetailsV2, {
                                applicationId: AccountPreferencesService.applicationID,
                                ban: sub.subAccountId,
                                ctn: sub.subNumber,
                                language: 'en'
                            }).then(function (response) {
                                /**
                                 * Check to find this wireless service has voicemail or not
                                 */
                                if (_this.hasVoicmailAddon(response.data)) {
                                    /**
                                     * set display and action for the dropdown list
                                     */
                                    _this.model.wirelessSubscription.push({
                                        display: sub.subNumber + " >",
                                        action: (function () {
                                            _this.myrWirelessDashboardService.enableResetVoicemailModal();
                                            sub.goToDashboard();
                                        })
                                    });
                                }
                                else {
                                    /**
                                     * Set voicemail error code
                                     */
                                    if (_.has(response.data, 'content.postPaidDetails.content.postPaidPhoneDetails.isSuspendedCtn')
                                        && response.data.content.postPaidDetails.content.postPaidPhoneDetails.isSuspendedCtn === true) {
                                        _this.model.voicemailLinkError = VoicemailErrorCode.SUSPENDED_CTN;
                                    }
                                }
                                deffered.resolve(response);
                            }).catch(function (error) {
                                deffered.reject();
                            });
                            promises.push(promise);
                        });
                        return _this.$q.all(promises);
                    };
                    this.resetModel();
                    this.accountOverviewService = accountOverviewFactory();
                    // this.myrWirelessDashboardService = myrWirelessDashboardService;
                    this.accountOverviewService.registerOnDataChangeHandler(this.accountOverviewDataHandler, AccountPreferencesService.serviceName);
                }
                ;
                AccountPreferencesService.serviceName = 'myr.modules.accountPreferences.service';
                AccountPreferencesService.applicationID = 'Rogers.com';
                AccountPreferencesService.postPaidDetailsV2 = '/web/RogersServices.portal/totes/api/v2/wirelessDashBoard/postPaidDetails';
                AccountPreferencesService.$inject = [
                    '$http',
                    '$q',
                    'ute.rogers.account.overview.factory',
                    'myrWirelessDashboardService',
                    'ute.goPaperless.service'];
                return AccountPreferencesService;
            }());
            angular.module('myr.modules.accountPreferences').service(AccountPreferencesService.serviceName, AccountPreferencesService);
        })(accountPreferences = modules.accountPreferences || (modules.accountPreferences = {}));
    })(modules = myr.modules || (myr.modules = {}));
})(myr || (myr = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var bfa;
        (function (bfa) {
            var ppc;
            (function (ppc) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureBfaPpc);
                    configureBfaPpc.$inject = ['ute.bfa.ppc.serviceProvider'];
                    /* @ngInject */
                    function configureBfaPpc(bfaPpcServiceProvider) {
                        bfaPpcServiceProvider.configure({
                            basic: {
                                applicationId: 'Rogers.com',
                                dtmBuyFlowError: 'fdm-bf-error',
                                fetchOrderAPI: 'v1/cart/fetch',
                                checkEligibilityAPI: 'v1/ppc/priceplans/eligibility',
                                checkBOTEligibilityAPI: 'getCases',
                                setStateAPI: 'v1/spa/state',
                                subscribersAPI: 'v1/ppc/subscribers'
                            },
                            advanced: {
                                modals: {
                                    notEligible: {
                                        controllerName: 'notEligibleModalCtrl',
                                        templateUrl: 'views/modals/ppc-not-eligible.html',
                                    },
                                    mppcEntry3: {
                                        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html',
                                        controllerName: 'mppcEntry3Ctrl'
                                    },
                                    mppcEntry1: {
                                        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html',
                                        controllerName: 'mppcEntry1Ctrl'
                                    },
                                    mppcAddAdditionalData: {
                                        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcAddAditionalDataModal.html',
                                        controllerName: 'mppcAddAdditionalDataModalCtrl'
                                    },
                                    mppcSharedGroupIndividual: {
                                        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html',
                                        controllerName: 'mppcSharedGroupIndividualModalCtrl',
                                    },
                                    mppcSharedGroupPrimary: {
                                        templateUrl: 'scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html',
                                        controllerName: 'mppcSharedGroupPrimaryModalCtrl',
                                    }
                                }
                            }
                        });
                    }
                })(integration = ppc.integration || (ppc.integration = {}));
            })(ppc = bfa.ppc || (bfa.ppc = {}));
        })(bfa = rogers.bfa || (rogers.bfa = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var brite;
        (function (brite) {
            var bill;
            (function (bill) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureBriteBillService);
                    configureBriteBillService.$inject = ['ute.data.manager.serviceProvider'];
                    /* @ngInject */
                    function configureBriteBillService(britebillServiceProvider) {
                        britebillServiceProvider.configure({
                            basic: {
                                applicationId: 'Rogers.com',
                                partialApiUrl: 'v1/encryptBritebill',
                                activatedUserSummaryAPI: '/rogers_rest/rogers/documents/activatedUserSummary',
                                analyticsId: 'myrogers',
                                postToUrl: '/web/myrogers/viewBill',
                                sessionStorageUserTypeBAN: 'care',
                                legacyInvoiceDateUserType: 'consumer',
                                legacyStateRedirect: 'winOnlineInvoice'
                            },
                            advanced: {}
                        });
                    }
                })(integration = bill.integration || (bill.integration = {}));
            })(bill = brite.bill || (brite.bill = {}));
        })(brite = rogers.brite || (rogers.brite = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var change;
        (function (change) {
            var ctn;
            (function (ctn) {
                var caller;
                (function (caller) {
                    var id;
                    (function (id) {
                        var integration;
                        (function (integration) {
                            'use strict';
                            angular.module('totesApp').config(configureChangeCtnCallerId);
                            configureChangeCtnCallerId.$inject = ['ute.change.ctn.callerIdProvider'];
                            /* @ngInject */
                            function configureChangeCtnCallerId(changeCtnCallerIdProvider) {
                                changeCtnCallerIdProvider.configure({
                                    basic: {
                                        applicationId: 'Rogers.com'
                                    },
                                    advanced: {
                                        medium: {
                                            consumer: 'WEB',
                                            care: 'Phone',
                                            retail: 'In Person',
                                        },
                                        applicationId: {
                                            consumer: 'UTERogersOnline',
                                            care: 'UTERogersCare',
                                            retail: 'UTERogersRetail',
                                        }
                                    }
                                });
                            }
                        })(integration = id.integration || (id.integration = {}));
                    })(id = caller.id || (caller.id = {}));
                })(caller = ctn.caller || (ctn.caller = {}));
            })(ctn = change.ctn || (change.ctn = {}));
        })(change = rogers.change || (rogers.change = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var integration;
            (function (integration) {
                'use strict';
                var DataLayerSection = ute.datalayer.common.service.DataLayerPredefinedSection;
                angular.module('totesApp')
                    .config(configureDataLayerService)
                    .run(registerCallBacksInDataLayer)
                    .run(observeLiveChat);
                configureDataLayerService.$inject = ['ute.datalayer.common.serviceProvider', '$provide', '$injector'];
                registerCallBacksInDataLayer.$inject = ['$injector'];
                observeLiveChat.$inject = ['$window', 'ute.datalayer.common.service'];
                var callbacks = [
                    {
                        callbackKey: 'account',
                        callback: getCurrentAccount
                    },
                    {
                        callbackKey: 'user',
                        callback: getCurrentUser
                    },
                    {
                        callbackKey: 'province',
                        callback: getCurrentProvince
                    },
                    {
                        callbackKey: 'language',
                        callback: getCurrentLanguage
                    },
                    {
                        callbackKey: 'errorPayload',
                        callback: getErrorPayload
                    },
                    {
                        callbackKey: 'eventPayload',
                        callback: getEventPayload
                    },
                    {
                        callbackKey: 'payload',
                        callback: getCurrentPayload
                    }
                ];
                var languageSwitcher;
                var provinceService;
                var userService;
                var accountOverviewFactory;
                var $q;
                var $window;
                var commonDataLayerService;
                var $state;
                var dataLayerUtilsService;
                var utePersistentStorageService;
                var $rootScope;
                var accountNumber;
                var phoneNumber;
                var switchAccount = false;
                function registerCallBacksInDataLayer($injector) {
                    commonDataLayerService = $injector.get('ute.datalayer.common.service');
                    languageSwitcher = $injector.get('ute.blocks.language.switcher');
                    provinceService = $injector.get('ute.blocks.province.service');
                    userService = $injector.get('ute.common.user.service');
                    accountOverviewFactory = $injector.get('ute.rogers.account.overview.factory');
                    $q = $injector.get('$q');
                    $state = $injector.get('$state');
                    dataLayerUtilsService = $injector.get('my.rogers.dataLayer.utils.service');
                    utePersistentStorageService = $injector.get('ute.blocks.persistent.storage.service');
                    $rootScope = $injector.get('$rootScope');
                    commonDataLayerService.registerCallbacks(callbacks);
                    changeAccountListener();
                }
                function changeAccountListener() {
                    accountOverviewFactory().registerOnDataChangeHandler(function (accountOverview) {
                        var accNum = _.get(accountOverview, 'selectedAccount.accountNumber');
                        if (accountNumber !== accNum) {
                            var previousPage = utePersistentStorageService.getFromSession('previous-pagename') + '';
                            switchAccount = !!(accountNumber);
                            accountNumber = accNum;
                            if (switchAccount && previousPage.indexOf('accountoverview')) {
                                commonDataLayerService.trackGlobal({ 'mappingKey': 'accountOverview' });
                            }
                        }
                    }, 'ADL select account listener');
                }
                function dataLayerTrack($injector, isModalPopup, pageView, mapping) {
                    var dataLayerService = $injector.get('ute.datalayer.common.service');
                    var selectedSections = [DataLayerSection.ACCOUNT, DataLayerSection.PAGE, DataLayerSection.SITE];
                    if (pageView) {
                        selectedSections.push(DataLayerSection.PAGE_VIEW_EVENT);
                    }
                    dataLayerService.track({}, isModalPopup, selectedSections, mapping);
                }
                //----------------------------------
                // Listening to liveChat events
                //----------------------------------
                function observeLiveChat($window, dataLayerService) {
                    var liveChatStarted = false;
                    var liveChatOpened = false;
                    $window.bc_newHistoryMessageCallback = function () {
                        if (liveChatStarted === false) {
                            getLiveChatPayload('liveChatStart');
                            liveChatStarted = true;
                        }
                    };
                    $window.bc_chatEndedEventCallback = function () {
                        liveChatStarted = false;
                    };
                    $window.bc_chatClosedEventCallback = function () {
                        liveChatOpened = false;
                    };
                    $window.bc_chatWindowLoadedEventCallback = function () {
                        if (liveChatOpened === false) {
                            getLiveChatPayload('liveChatOpen');
                            liveChatOpened = true;
                        }
                    };
                    function getLiveChatPayload(liveChatEvent) {
                        var obj = dataLayerService.getLastPayload();
                        var ref = obj.site.name + ':' + (obj.page.hierarchy.length > 0 ? obj.page.hierarchy.join(':') + ':' : '') + obj.page.name;
                        var payload = {
                            'liveChat': {
                                'referrer': ref,
                                'ID': _.get($window, 'bcConfig.aid', '')
                            },
                            'events': {
                                event: true
                            }
                        };
                        payload.events[liveChatEvent] = true;
                        dataLayerService.track(payload);
                    }
                }
                function secondHierarchy(secondLevel) {
                    return ['myrogers', secondLevel];
                }
                function configureDataLayerService(dataLayerCommonServiceProvider, $provide, $injector) {
                    var wirelessHierarchy = secondHierarchy('wireless'); // ['myrogers', 'wireless'];
                    var shareEverythingHierarchy = secondHierarchy('shareeverything'); // ['myrogers', 'shareeverything'];
                    var sefServeNameAccountRegistration = 'account registration';
                    var hierarchyAccountRegistration = secondHierarchy('registration'); // ['myrogers', 'registration'];
                    var accountOverviewHierarchy = secondHierarchy('accountoverview'); // ['myrogers', 'accountoverview'];
                    var interactionsHierarchy = ['myrogers', 'interaction'];
                    var overviewHierarchy = secondHierarchy('overview'); // ['myrogers', 'overview'];
                    var preAuthPaymentMethodNameBank = 'actv-myrogers-update preauth info bank';
                    var preAuthPaymentMethodNameCreditCard = 'actv-myrogers-update preauth info';
                    var selfServeAccountRegistration = {
                        name: sefServeNameAccountRegistration,
                        type: 'transaction'
                    };
                    var profilePage = {
                        name: 'profile',
                        hierarchy: ['myrogers', 'profile']
                    };
                    var isEBill = false;
                    //---------------------------------------------
                    // Initializing custom mapping keys from DTM
                    //---------------------------------------------
                    // if (typeof _satellite !== 'undefined') {
                    //   _satellite.track('angular-analytics-dev');
                    //   console.log('adl rogers client initializing custom mapping' + typeof _satellite);
                    // }
                    //----------------------------------------------------------
                    // Listening to $modal popup (i.e. change payment method)
                    //----------------------------------------------------------
                    decorateModal('$modal', 'result');
                    //-----------------------------------------------
                    // Listening to ngDialog (i.e. make a payment)
                    //-----------------------------------------------
                    decorateModal('ngDialog', 'closePromise');
                    var config = {
                        basic: {
                            site: {
                                name: (getParameterByName('userType') === 'care' || getFromCookie('userType') === 'userType=care') ? 'OV' : 'R'
                            },
                            signin: {
                                type: 'MyRogers'
                            }
                        },
                        advance: {
                            //---------------------------------------
                            // About the 'configOptions' property:
                            //
                            // - Indicate whether you'd like to load the configuration from the file specified in 'pathToConfigFile'.
                            // - If the configuration file is not specified, the locally defined configuration mapping will be used instead.
                            //---------------------------------------
                            configOptions: {
                                //   pathToConfigFile: 'resource/dataLayerConfig.json',
                                //   loadFromFile: true,
                                //   isAbsolutePath: false
                                globalTrackingOn: true,
                                globalTrackingExclusive: true //global tracking will fire only for state names that are defined in mappingKey.
                            },
                            mappingKey: {
                                'firstHierarchy': 'myrogers',
                                'accountOverview': {
                                    page: {
                                        name: 'account overview',
                                        hierarchy: accountOverviewHierarchy
                                    }
                                },
                                'forgotPasswordNoLivecontent': {
                                    page: {
                                        name: 'forgot password no live content',
                                        hierarchy: ['myrogers', 'forgotpasswordnolivecontent']
                                    }
                                },
                                'forgotUserNameNoLivecontent': {
                                    page: {
                                        name: 'forgot username no live content',
                                        hierarchy: ['myrogers', 'forgotusernamenolivecontent']
                                    }
                                },
                                'sso/resetPassword': {
                                    page: {
                                        name: 'sso reset password',
                                        hierarchy: ['myrogers', 'sso', 'resetpassword']
                                    }
                                },
                                interaction: {
                                    page: {
                                        name: 'interactions',
                                        hierarchy: interactionsHierarchy
                                    }
                                },
                                oneViewDashboard: {
                                    page: {
                                        name: 'overview',
                                        hierarchy: overviewHierarchy
                                    }
                                },
                                'wireless': {
                                    page: {
                                        name: 'wireless',
                                        hierarchy: ['myrogers', 'wireless']
                                    }
                                },
                                'self-serve': {
                                    page: {
                                        name: 'profile',
                                        hierarchy: ['myrogers', 'profile']
                                    }
                                },
                                'inbounds': {
                                    page: {
                                        name: 'actions & offers',
                                        hierarchy: secondHierarchy('actionsoffers')
                                    }
                                },
                                'simCard.start': {
                                    page: {
                                        name: 'start',
                                        hierarchy: ['myrogers', 'simcard', 'start']
                                    }
                                },
                                'simCard.confirmation': {
                                    page: {
                                        name: 'confirmation',
                                        hierarchy: ['myrogers', 'simcard', 'confirmation']
                                    }
                                },
                                'transferOfResponsibility.stepTwo/confirmation': {
                                    page: {
                                        name: 'tor step 2 confirmation',
                                        hierarchy: ['myrogers', 'transferofresponsibility', 'steptwo', 'confirmation']
                                    }
                                },
                                'transferOfResponsibility.stepOne/ctnSelection': {
                                    page: {
                                        name: 'tor step 1 ctn selection',
                                        hierarchy: ['myrogers', 'transferofresponsibility', 'stepone', 'ctnselection']
                                    }
                                },
                                'transferOfResponsibility.stepOne/eligibilityCheck': {
                                    page: {
                                        name: 'tor step 1 eligibility check',
                                        hierarchy: ['myrogers', 'transferofresponsibility', 'stepone', 'eligibilitycheck']
                                    }
                                },
                                'transferOfResponsibility.stepThree/subscriberDetails': {
                                    page: {
                                        name: 'tor step 3 ctn selection future owner',
                                        hierarchy: ['myrogers', 'transferofresponsibility', 'stepthree', 'subscriberdetails']
                                    }
                                },
                                'transferOfResponsibility.stepThree/eligibilityCheck': {
                                    page: {
                                        name: 'tor step 3 eligibility check',
                                        hierarchy: ['myrogers', 'transferofresponsibility', 'stepthree', 'eligibilitycheck']
                                    }
                                },
                                'shareEverything.noEncryption': {
                                    page: {
                                        name: 'share everything',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    }
                                },
                                'shareEverything.individualSummary': {
                                    page: {
                                        name: 'share everything individual summary',
                                        hierarchy: ['myrogers', 'shareeverything', 'individualsummary']
                                    }
                                },
                                'shareEverything.dashboard': {
                                    page: {
                                        name: 'share everything dashboard',
                                        hierarchy: ['myrogers', 'shareeverything', 'dashboard']
                                    }
                                },
                                'shareEverythingError': {
                                    page: {
                                        name: 'share everything error',
                                        hierarchy: ['myrogers', 'shareeverythingerror']
                                    }
                                },
                                'shareEverything.manage': {
                                    page: {
                                        name: 'share everything manage',
                                        hierarchy: ['myrogers', 'shareeverything', 'manage']
                                    }
                                },
                                'viewbill': {
                                    page: {
                                        name: 'view bill',
                                        hierarchy: secondHierarchy('viewbill')
                                    }
                                },
                                'signin': {
                                    page: {
                                        name: 'sign in',
                                        hierarchy: ['myrogers', 'signin']
                                    }
                                },
                                'forgotUserName': {
                                    page: {
                                        name: 'forgot username',
                                        hierarchy: ['myrogers', 'forgotusername']
                                    }
                                },
                                'internetdash': {
                                    page: {
                                        name: 'internet dashboard',
                                        hierarchy: ['myrogers', 'internetdash']
                                    }
                                },
                                'shmdashboard': {
                                    page: {
                                        name: 'smart home monitoring dashboard',
                                        hierarchy: ['myrogers', 'shmdashboard']
                                    }
                                },
                                'sso/forgotPassword': {
                                    page: {
                                        name: 'forgot password',
                                        hierarchy: ['myrogers', 'sso', 'forgotpassword']
                                    }
                                },
                                'sso/registration': {
                                    page: {
                                        name: 'registration',
                                        hierarchy: ['myrogers', 'sso', 'registration']
                                    }
                                },
                                'tvdashboard': {
                                    page: {
                                        name: 'tv dashboard',
                                        hierarchy: ['myrogers', 'tvdashboard']
                                    }
                                },
                                'linkaccount': {
                                    page: {
                                        name: 'link account',
                                        hierarchy: ['myrogers', 'linkaccount']
                                    }
                                },
                                'paymenthistory': {
                                    page: {
                                        name: 'payment history',
                                        hierarchy: ['myrogers', 'paymenthistory']
                                    }
                                },
                                'oasys-bundle': {
                                    interaction: {
                                        type: 'click',
                                        name: 'oasys bundle'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                'guestOverview': {
                                    page: {
                                        name: 'guest overview',
                                        hierarchy: ['myrogers', 'guest overview']
                                    }
                                },
                                'underMaintenance': {
                                    page: {
                                        name: 'under maintenance',
                                        hierarchy: ['myrogers', 'undermaintenance']
                                    }
                                },
                                'schedule-ptp': {
                                    page: {
                                        name: 'schedule promise to pay',
                                        hierarchy: ['myrogers']
                                    },
                                    selfServe: {
                                        name: 'schedule promise to pay',
                                        type: 'transaction'
                                    }
                                },
                                //-----------------------------------------
                                //       Custom Mapping Keys
                                //-----------------------------------------
                                onboarding: {
                                    widget: {
                                        page: {
                                            name: 'account overview',
                                            hierarchy: ['myrogers']
                                        },
                                        miscellaneous: {
                                            type: 'onboarding widget',
                                        },
                                        events: {
                                            interaction: true,
                                            pageView: true,
                                            miscellaneous: true
                                        },
                                        user: {
                                            loginStatus: true
                                        },
                                        interaction: {
                                            type: 'show',
                                            name: 'onboarding widget',
                                        }
                                    },
                                    setRecoveryNumber: {
                                        step1: {
                                            interaction: {
                                                type: 'click',
                                                name: 'wireless recovery onboarding step 1'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                        modalLoad: {
                                            page: {
                                                name: 'modal-wireless recovery',
                                                hierarchy: ['myrogers', 'onboarding widget']
                                            },
                                            user: {
                                                loginStatus: true
                                            }
                                        },
                                        step2: {
                                            interaction: {
                                                type: 'click',
                                                name: 'wireless recovery onboarding step 2'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                    },
                                    setOnlineBilling: {
                                        step1: {
                                            interaction: {
                                                type: 'click',
                                                name: 'online billing onboarding step 1'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                        modalLoad: {
                                            page: {
                                                name: 'modal-online billing',
                                                hierarchy: ['myrogers', 'onboarding widget']
                                            },
                                            user: {
                                                loginStatus: true
                                            }
                                        },
                                        step2: {
                                            interaction: {
                                                type: 'click',
                                                name: 'online billing onboarding step  2'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                    },
                                    setAutoPayment: {
                                        step1: {
                                            interaction: {
                                                type: 'click',
                                                name: 'automatic payment onboarding step 1'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                        modalLoad: {
                                            page: {
                                                name: 'modal-pre-authorized payments',
                                                hierarchy: ['myrogers', 'onboarding widget']
                                            },
                                            user: {
                                                loginStatus: true
                                            }
                                        },
                                        step2: {
                                            interaction: {
                                                type: 'click',
                                                name: 'automatic payment onboarding step 2'
                                            },
                                            events: {
                                                interaction: true
                                            },
                                        },
                                    },
                                    onboardingCompleted: {
                                        events: {
                                            interaction: true,
                                            miscellaneous: true
                                        },
                                        interaction: {
                                            type: 'show',
                                            name: 'onboarding completion message'
                                        },
                                        miscellaneous: {
                                            type: 'onboarding widget',
                                        }
                                    },
                                    showLess: {
                                        interaction: {
                                            type: 'click',
                                            name: 'onboarding widget:show less'
                                        },
                                        events: {
                                            interaction: true
                                        }
                                    }
                                },
                                addToCalendar: {
                                    open: {
                                        interaction: {
                                            type: 'open',
                                            name: 'add to calendar'
                                        },
                                        events: {
                                            interaction: true
                                        },
                                        page: {
                                            name: 'account overview',
                                            hierarchy: accountOverviewHierarchy
                                        }
                                    },
                                    complete: {
                                        events: {
                                            selfServeComplete: true
                                        },
                                        page: {
                                            name: 'account overview',
                                            hierarchy: accountOverviewHierarchy
                                        }
                                    }
                                },
                                'wirelessDashboard': {
                                    deviceDetails: {
                                        page: getPageObject('modal-device details', wirelessHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Device Details')
                                    },
                                    planDetails: {
                                        page: getPageObject('modal-plan details', wirelessHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Plan Details')
                                    },
                                    talkTextUsage: {
                                        page: getPageObject('modal-talk and text usage', wirelessHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Text/Talk Usage')
                                    },
                                    dataUsage: {
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Data Usage')
                                    },
                                    textUsage: {
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Text Usage')
                                    },
                                    talkUsage: {
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Talk Usage')
                                    }
                                },
                                'shareEverythingDashboard': {
                                    deviceDetails: {
                                        page: getPageObject('modal-device details', shareEverythingHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Device Details')
                                    },
                                    planDetails: {
                                        page: getPageObject('modal-plan details', shareEverythingHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Plan Details')
                                    },
                                    talkTextUsage: {
                                        page: getPageObject('modal-talk and text usage', shareEverythingHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'View Wireless Text/Talk Usage')
                                    },
                                    manageDataAlerts: {
                                        page: getPageObject('manage my data', shareEverythingHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'myrogers FDM Manage Data Alerts and Usage')
                                    },
                                    'manageDataAlerts-modal': {
                                        page: getPageObject('manage my data', shareEverythingHierarchy),
                                        selfServe: getSelfServeObj('inquiry', 'myrogers FDM Manage Data Alerts and Usage - Modal')
                                    }
                                },
                                accountRegistration: {
                                    main: {
                                        page: {
                                            name: 'registration main',
                                            hierarchy: hierarchyAccountRegistration
                                        }
                                    },
                                    account: {
                                        page: {
                                            name: 'registration step1 account',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration,
                                        events: {
                                            selfServeStart: true
                                        }
                                    },
                                    email: {
                                        page: {
                                            name: 'registration step2 email',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration
                                    },
                                    resendEmail: {
                                        page: {
                                            name: 'registration step3 verify',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: {
                                            name: 'account registration - resend email',
                                            type: 'inquiry'
                                        }
                                    },
                                    verify: {
                                        page: {
                                            name: 'registration step3 verify',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration
                                    },
                                    password: {
                                        page: {
                                            name: 'registration step4 password',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration
                                    },
                                    complete: {
                                        page: {
                                            name: 'registration step5 complete',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration,
                                        events: {
                                            selfServeComplete: true
                                        }
                                    },
                                    great_news: {
                                        page: {
                                            name: 'registration resume great news',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration
                                    },
                                    great_news_verify: {
                                        page: {
                                            name: 'registration resume verify',
                                            hierarchy: hierarchyAccountRegistration
                                        },
                                        selfServe: selfServeAccountRegistration
                                    }
                                },
                                fdmAddData: {
                                    open: {
                                        interaction: {
                                            type: 'open',
                                            name: 'family data manager add data'
                                        },
                                        events: {
                                            interaction: true
                                        }
                                    }
                                },
                                //-----------------------------------------
                                //       MyRogers Self-Serve Keys
                                //-----------------------------------------
                                'rlh-activated': {
                                    selfServe: {
                                        name: 'RLH activated',
                                        type: 'transaction'
                                    }
                                },
                                'rlh-un-enroll': {
                                    selfServe: {
                                        name: 'RLH un-enroll',
                                        type: 'transaction'
                                    }
                                },
                                'tor-current-owner': {
                                    selfServe: {
                                        name: 'TOR eligibility check - current owner',
                                        type: 'transaction'
                                    }
                                },
                                'tor-future-owner': {
                                    selfServe: {
                                        name: 'TOR eligibility check - future owner',
                                        type: 'transaction'
                                    }
                                },
                                'customer-flyout': {
                                    interaction: {
                                        type: 'click',
                                        name: 'customer flyout'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                'enable-IDV-account': {
                                    selfServe: {
                                        name: 'enable IDV account',
                                        type: 'transaction'
                                    }
                                },
                                'create-my-rogers-profile': {
                                    selfServe: {
                                        name: 'auto-registration',
                                        type: 'transaction'
                                    }
                                },
                                'enable-IDV-interaction': {
                                    interaction: {
                                        type: 'click',
                                        name: 'click|IDV $50 fee charged'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                'make-a-payment': {
                                    selfServe: {
                                        name: 'make a payment',
                                        type: 'transaction'
                                    }
                                },
                                'viewbill-account-overview': {
                                    interaction: {
                                        type: 'click',
                                        name: 'view bill - account overview'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                'viewbill-billing-and-payment': {
                                    interaction: {
                                        type: 'click',
                                        name: 'view bill - billing & payment tab'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                'change-username': {
                                    page: profilePage,
                                    selfServe: {
                                        name: 'actv-myrogers-change username',
                                        type: 'transaction'
                                    }
                                },
                                'quicklinks-customization': {
                                    selfServe: {
                                        name: 'quicklinks customization',
                                        type: 'transaction'
                                    }
                                },
                                'actions-offers': {
                                    selfServe: {
                                        name: 'oneview rep selects actions and offers -',
                                        type: 'inquiry'
                                    }
                                },
                                'hup-sent-to-bot': {
                                    selfServe: {
                                        name: 'oneview HUP sent to BOT',
                                        type: 'transaction'
                                    }
                                },
                                'automatic-payment-setup': {
                                    selfServe: {
                                        name: 'automatic payment setup',
                                        type: 'transaction'
                                    }
                                },
                                footerLinks: {
                                    interaction: {
                                        type: 'click',
                                    },
                                    events: {
                                        interaction: true
                                    },
                                },
                                'change-password': {
                                    page: profilePage,
                                    selfServe: {
                                        name: 'actv-myrogers-change password',
                                        type: 'transaction'
                                    }
                                },
                                'forgot-password': {
                                    selfServe: {
                                        name: 'actv-myrogers-forgot password',
                                        type: 'transaction'
                                    }
                                },
                                'forgot-username': {
                                    selfServe: {
                                        name: 'actv-myrogers-forgot username',
                                        type: 'transaction'
                                    }
                                },
                                'reset-password': {
                                    selfServe: {
                                        name: 'actv-myrogers-reset password',
                                        type: 'transaction'
                                    }
                                },
                                'link-account-wireless-cable': {
                                    page: {
                                        name: 'linkaccount',
                                        hierarchy: ['myrogers', 'linkaccount']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-link account wireless or cable',
                                        type: 'transaction'
                                    }
                                },
                                'link-account-pay-as-you-go': {
                                    page: {
                                        name: 'linkaccount',
                                        hierarchy: ['myrogers', 'linkaccount']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-link account pay as you go',
                                        type: 'transaction'
                                    },
                                },
                                'remove-account': {
                                    page: {
                                        name: 'account removal confirmation',
                                        hierarchy: ['myrogers', 'account removal confirmation']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-remove account',
                                        type: 'transaction'
                                    }
                                },
                                'edit-contact-information': {
                                    page: profilePage,
                                    selfServe: {
                                        name: 'actv-myrogers-contact information',
                                        type: 'transaction'
                                    }
                                },
                                'edit-billing-information': {
                                    page: profilePage,
                                    selfServe: {
                                        name: 'actv-myrogers-change billing information',
                                        type: 'transaction'
                                    }
                                },
                                'change-sim': {
                                    selfServe: {
                                        name: 'actv-myrogers-change SIM card',
                                        type: 'transaction'
                                    }
                                },
                                'change-sim-success': {
                                    page: {
                                        name: 'success',
                                        hierarchy: ['myrogers', 'simcard', 'success']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-change SIM card',
                                        type: 'transaction'
                                    }
                                },
                                'change-voicemail-password': {
                                    selfServe: {
                                        name: 'actv-myrogers-change voicemail password',
                                        type: 'transaction'
                                    }
                                },
                                'switch-to-online-billing': {
                                    page: {
                                        name: 'switch to online billing',
                                        hierarchy: ['myrogers', 'switch to online billing']
                                    }
                                },
                                'myrogers-pwd-reset': {
                                    selfServe: {
                                        name: 'myrogers pwd reset initiated',
                                        type: 'transaction'
                                    }
                                },
                                'validate-order': {
                                    page: {
                                        name: 'validate order success',
                                        hierarchy: ['myrogers', 'oneViewDashboard']
                                    }
                                },
                                planChangeInProgress: {
                                    name: 'plan change in progress',
                                    hierarchy: ['myrogers', 'wireless']
                                },
                                ppcBotCancellation: {
                                    name: 'bot cancellation success, proceed with price plan change',
                                    hierarchy: ['myrogers', 'wireless']
                                },
                                hupBotCancellation: {
                                    name: 'bot cancellation success, proceed with hardware upgrade',
                                    hierarchy: ['myrogers', 'wireless']
                                },
                                hardwareUpgradeInProgress: {
                                    name: 'hardware upgrade in progress',
                                    hierarchy: ['myrogers', 'wireless']
                                },
                                /*
                                    'close-case': {
                                      page: {
                                        name: 'closecase success',
                                        hierarchy: ['myrogers', 'wireless']
                                      }
                                    },*/
                                'update-email': {
                                    page: {
                                        name: 'update your email address',
                                        hierarchy: ['myrogers', 'update your email address']
                                    }
                                },
                                'accept-a-payment': {
                                    page: {
                                        name: 'accept a payment',
                                        hierarchy: ['myrogers', 'billing', 'accept a payment']
                                    }
                                },
                                'switch-to-online-billing-benefits': {
                                    page: {
                                        name: 'the benefits of online billing',
                                        hierarchy: ['myrogers', 'the benefits of online billing']
                                    }
                                },
                                'switch-to-online-billing-self-serve': {
                                    selfServe: {
                                        name: 'actv-myrogers-go paperless profile',
                                        type: 'transaction'
                                    }
                                },
                                'switch-to-online-billing-accountOverview': {
                                    selfServe: {
                                        name: 'actv-myrogers-go paperless banner',
                                        type: 'transaction'
                                    }
                                },
                                'switch-to-invoice-billing': {
                                    selfServe: {
                                        name: 'actv-myrogers-go invoice banner',
                                        type: 'transaction'
                                    }
                                },
                                'change-caller-id': {
                                    page: {
                                        name: 'change my caller id',
                                        hierarchy: ['myrogers', 'change my caller id']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-change caller ID',
                                        type: 'transaction'
                                    }
                                },
                                'set-alert': {
                                    page: {
                                        name: 'share everything',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-save alert threshold',
                                        type: 'transaction'
                                    }
                                },
                                'turn-on-alert': {
                                    page: {
                                        name: 'share everything',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-turn on alert',
                                        type: 'transaction'
                                    }
                                },
                                'turn-off-alert': {
                                    page: {
                                        name: 'share everything',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-turn off alert',
                                        type: 'transaction'
                                    }
                                },
                                'set-recipient': {
                                    page: {
                                        name: 'assigning a data manager',
                                        hierarchy: ['myrogers', 'assigning a data manager']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-set recipient',
                                        type: 'transaction'
                                    }
                                },
                                'data-block': {
                                    page: {
                                        name: 'pause data access',
                                        hierarchy: ['myrogers', 'pause data access'],
                                        url: 'modal popup'
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-block data',
                                        type: 'transaction'
                                    }
                                },
                                'data-unblock': {
                                    page: {
                                        name: 'share everything',
                                        hierarchy: ['myrogers', 'shareeverything']
                                    },
                                    selfServe: {
                                        name: 'actv-myrogers-familydatamanager-unblock data',
                                        type: 'transaction'
                                    }
                                },
                                'preAuthPaymentMethod-credit': {
                                    page: {
                                        name: 'update your credit card',
                                        hierarchy: ['myrogers', 'update your credit card']
                                    },
                                    selfServe: {
                                        type: 'transaction'
                                    }
                                },
                                'preAuthPaymentMethod-bank': {
                                    page: {
                                        name: 'update pre-authorized debit',
                                        hierarchy: ['myrogers', 'update pre-authorized debit']
                                    },
                                    selfServe: {
                                        name: preAuthPaymentMethodNameBank,
                                        type: 'transaction'
                                    }
                                },
                                'selfServe-0': {
                                    selfServe: {
                                        name: preAuthPaymentMethodNameCreditCard + ' visa'
                                    }
                                },
                                'selfServe-1': {
                                    selfServe: {
                                        name: preAuthPaymentMethodNameCreditCard + ' mastercard'
                                    }
                                },
                                'selfServe-2': {
                                    selfServe: {
                                        name: preAuthPaymentMethodNameCreditCard + ' amex'
                                    }
                                },
                                'selfServe-3': {
                                    selfServe: {
                                        name: preAuthPaymentMethodNameCreditCard + ' others'
                                    }
                                },
                                'payment-history': {
                                    selfServe: {
                                        name: 'pasv-myrogers-paymenthistory',
                                        type: 'inquiry'
                                    }
                                },
                                'internetdash-daily-usage': {
                                    selfServe: {
                                        name: 'pasv-myrogers-internet daily usage',
                                        type: 'inquiry'
                                    }
                                },
                                'internetdash-monthly-usage': {
                                    selfServe: {
                                        name: 'pasv-myrogers-internet monthly usage',
                                        type: 'inquiry'
                                    }
                                },
                                'internetdash-usage-history': {
                                    selfServe: {
                                        name: 'pasv-myrogers-internet usage history',
                                        type: 'inquiry'
                                    }
                                },
                                'internetdash-usage-alerts': {
                                    selfServe: {
                                        name: 'pasv-myrogers-internet usage alerts',
                                        type: 'inquiry'
                                    }
                                },
                                // Orders Tab Analytics
                                // on orders click
                                'orders-click': {
                                    interaction: {
                                        type: 'click',
                                        name: 'orders'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // checkbox on orders page
                                // PPC checkbox
                                'PPC-checkbox': {
                                    interaction: {
                                        type: 'click',
                                        name: 'post-dated ppc order filter'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // wireless orders checkbox
                                'wireless-orders-checkbox': {
                                    interaction: {
                                        type: 'click',
                                        name: 'wireless order filter'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // PPC and wireless orders checkbox
                                'my-PPC-and-wireless-chckbox': {
                                    interaction: {
                                        type: 'click',
                                        name: 'post-dated ppc order filter and wireless order filter'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // mapping keys for no orders message
                                // No orders message ppc key
                                'no-order-ppc': {
                                    interaction: {
                                        type: 'show',
                                        name: 'no post dated ppc order warning'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // no orders message wireless key
                                'no-order-wireless': {
                                    interaction: {
                                        type: 'show',
                                        name: 'no wireless order warning'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                // no orders message ppc and wireless
                                'no-order-ppc-wireless': {
                                    interaction: {
                                        type: 'show',
                                        name: 'no post dated ppc order and wireless order warning'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                },
                                //Orders Analytics END
                                //--------------------------------------------
                                //       MyRogers Self-Serve Shared Keys
                                //--------------------------------------------
                                event: {
                                    selfServeStart: {
                                        events: {
                                            selfServeStart: true
                                        }
                                    },
                                    selfServeComplete: {
                                        events: {
                                            selfServeComplete: true
                                        }
                                    }
                                },
                                //-------------------------------------------------------------
                                //               FORM FIELD ERROR & ERROR KEYS
                                //-------------------------------------------------------------
                                f0: 'username',
                                f1: 'old password',
                                f2: 'new password',
                                f3: 'confirm new password',
                                f4: 'account number',
                                f5: 'postal code',
                                f6: 'phone number',
                                f7: 'account pin',
                                f8: 'link account submit button',
                                f9: 'current sim card number',
                                f10: 'new sim card number',
                                f11: 'change my caller id first name',
                                f12: 'change my caller id last name',
                                f13: 'change my caller id',
                                error: {
                                    'forgot-username': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'forgotusernamenolivecontent']
                                        }
                                    },
                                    'billingNotification': {
                                        page: {
                                            name: 'view bill',
                                            hierarchy: ['myrogers', 'viewBill']
                                        }
                                    },
                                    'self-serve-change-password': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'profile']
                                        }
                                    },
                                    'myrogers-pwd-reset': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'profile']
                                        }
                                    },
                                    'change-voicemail-password': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'profile']
                                        }
                                    },
                                    'linkAccount': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'linkaccount']
                                        }
                                    },
                                    'changeSIM': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'simcard', 'start']
                                        }
                                    },
                                    'changeCallerID': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'wireless']
                                        }
                                    },
                                    'changeCallerIDNotEligible': {
                                        page: {
                                            name: 'change my caller id',
                                            hierarchy: ['myrogers', 'change my caller id']
                                        }
                                    },
                                    'setAlert': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'shareeverything']
                                        }
                                    },
                                    'setRecipient': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'shareeverything']
                                        }
                                    },
                                    'hupNotEligibleWireless': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'wireless']
                                        }
                                    },
                                    'hupNotEligibleShareEverything': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'shareeverything']
                                        }
                                    },
                                    'getCasesWireless': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'wireless']
                                        }
                                    },
                                    'getCasesShareEverything': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'shareeverything']
                                        }
                                    },
                                    'closeCase': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'wireless']
                                        }
                                    },
                                    'dealerProfile': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'oneViewDashboard']
                                        }
                                    },
                                    'saveDealerCode': {
                                        page: {
                                            name: 'error',
                                            hierarchy: ['myrogers', 'oneViewDashboard']
                                        }
                                    },
                                },
                                'dealerProfile': {
                                    page: {
                                        name: 'account overview',
                                        hierarchy: ['myrogers', 'accountOverview']
                                    },
                                },
                                'eop-offer-alert': {
                                    page: {
                                        name: 'eop-offer-alert'
                                    }
                                },
                                'offer-alert': {
                                    page: {
                                        name: 'offer-alert'
                                    }
                                },
                                'eop-targeted-offer-detail': {
                                    page: {
                                        name: 'eop-targeted-offer-detail'
                                    }
                                },
                                'eop-unavailable-or-expired-offer-message': {
                                    page: {
                                        name: 'eop-unavailable-or-expired-offer-message'
                                    }
                                },
                                'cart-abandonment-ignite-bundle': {
                                    interaction: {
                                        type: 'click',
                                        name: 'cart retrieval'
                                    },
                                    events: {
                                        interaction: true
                                    }
                                }
                            } //mappingKey
                        },
                        //---------------------------------------------------------------
                        //                       MODAL TRACKING
                        //---------------------------------------------------------------
                        modal: {
                            'module/emailModal/currentEmailModal.view.html': {
                                response: function (cfg, stateName, state) {
                                    var data = { payload: getPayload(stateName + ',event.selfServeStart,switch-to-online-billing-' + stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'modal-switch to online billing';
                                    }
                                    updateSessionStorage('__adl', { switchOnlineBill: true });
                                    return data;
                                }
                            },
                            'scripts/modules/accountList/accountOverviewLinkModal.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload(stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'account selection';
                                    }
                                    return data;
                                }
                            },
                            'views/modals/ppc-not-eligible.html': {
                                response: function (cfg, stateName) {
                                    return { payload: getPayload('planChangeInProgress') };
                                }
                            },
                            'scripts/directives/wirelessPackage/wirelessDashPopup.html': {
                                response: function (cfg, stateName) {
                                    return { payload: getPayload('hardwareUpgradeInProgress') };
                                }
                            },
                            'module/discoveryPage/discoveryPageDirective/discoveryPageDirectiveModal/discoveryPageDirectiveModal.partial.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload(stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'discovery page';
                                    }
                                    return data;
                                }
                            },
                            'module/dataManager/dataManagerModals/dataManagerModalAlertsOverDataLimit/dataManagerModalAlertsOverDataLimit.partial.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload(stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'over data limit';
                                    }
                                    return data;
                                }
                            },
                            'module/emailModal/saveEmailModal.view.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload('edit-contact-information,event.selfServeStart,' + stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'update your email address';
                                    }
                                    if (!getSessionStorage('__adl', 'switchOnlineBill')) {
                                        var dataOnlineBillingStart = getPayload(stateName + ',event.selfServeStart,switch-to-online-billing-' + stateName);
                                        dataOnlineBillingStart.site = { name: 'R' };
                                        if (typeof (_trackData) === 'function') {
                                            _trackData(dataOnlineBillingStart);
                                        }
                                    }
                                    return data;
                                }
                            },
                            'views/modals/linkAccountModalCtrl.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload(stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'link rogers account';
                                    }
                                    return data;
                                }
                            },
                            'module/resetVoicemailPasswordDirective/resetVoicemailPassword.modal.view.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload('change-voicemail-password,event.selfServeStart,' + stateName) };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = 'update voicemail password';
                                    }
                                    return data;
                                }
                            },
                            'module/profileResetPasswordModal/profile.reset.password.modal.view.html': {
                                response: function (cfg, stateName) {
                                    var data = { payload: getPayload('myrogers-pwd-reset,event.selfServeStart') };
                                    if (_.has(data, 'payload.page.name')) {
                                        data.payload.page.name = "reset customer's password";
                                    }
                                    return data;
                                }
                            }
                        },
                        //---------------------------------------------------------------
                        //                       API TRACKING
                        //---------------------------------------------------------------
                        api: {
                            'api/v1/wirelessDashBoard/rlh/unEnroll': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'successFlag') == true) {
                                        payload = getPayload('rlh-un-enroll,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                }
                            },
                            'api/v1/wirelessDashBoard/rlh/setDetails': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'successFlag') == true) {
                                        payload = getPayload('rlh-activated,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                }
                            },
                            'api/v1/ptp/schedulePromiseToPay': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, c = response.config, data = {}, payload;
                                    if (r.status.toLowerCase() === 'success') {
                                        payload = getPayload('schedule-ptp,event.selfServeComplete');
                                        if (payload.selfServe) {
                                            payload.selfServe.paymentMethod = c.data.paymentMethod;
                                        }
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var errorCode = _.get(rejection.data, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(rejection.data, ['status.codeName', 'status.description']);
                                        var payload = getPayload('schedule-ptp');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, true, $injector);
                                    }
                                }
                            },
                            'api/v1/ptp/checkPromiseToPayEligibility': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status >= 200) {
                                        payload = getPayload('schedule-ptp,event.selfServeStart');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var errorCode = _.get(rejection.data, 'errorCode');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(rejection.data, ['errorMessage']);
                                        var payload = getPayload('schedule-ptp');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/cmt/updateDisposition': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, c = response.config, data = {}, payload;
                                    if (r.status.toLowerCase() === 'success') {
                                        payload = getPayload('actions-offers,event.selfServeComplete');
                                        if (payload.selfServe && payload.selfServe.name) {
                                            var splitCode = c.data.treatmentCode.split('_');
                                            if (isNaN(parseInt(splitCode[splitCode.length - 1], 10))) {
                                                payload.selfServe.name += c.data.treatmentCode + ' - ' + c.data.dispositionCode.toLowerCase();
                                            }
                                            else {
                                                payload.selfServe.name += splitCode[splitCode.length - 1] + ' - ' + c.data.dispositionCode.toLowerCase();
                                            }
                                            //payload.selfServe.name += c.data.treatmentId + " - " + c.data.dispositionCode.toLowerCase();
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('actions-offers');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            'api/v1/ppc/priceplans/eligibility': {
                                response: function (response, api, state, $injector) {
                                    console.log('response: ', response);
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    console.log('rejection: ', rejection);
                                }
                            },
                            'api/v1/profile/forgotPassword': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('forgot-password,forgotPasswordNoLivecontent,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                }
                            },
                            '/api/v1/forgot/username': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('forgot-username,forgotUserNameNoLivecontent,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                }
                            },
                            '/api/v1/makePayment': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, c = response.config, data = {}, payload;
                                    if (r.status.toLowerCase() === 'success') {
                                        payload = getPayload('make-a-payment,event.selfServeComplete');
                                        if (payload.selfServe && payload.selfServe.name) {
                                            payload.selfServe.name += c.data.treatmentId + ' - ' + c.data.dispositionCode.toLowerCase();
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('make-a-payment');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/accountoverview': {
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data;
                                    var payload = getPayload(state);
                                    var errorCode = rejection.status;
                                    var defaultErrorMessage = rejection.status + ': ' + rejection.statusText + ', ';
                                    var errorMessage = defaultErrorMessage + getErrorMessage(r, ['errorCode', 'errorMessage']);
                                    var section = [DataLayerSection.PAGE, DataLayerSection.SITE];
                                    if (!_.isEmpty(payload)) {
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector, section);
                                    }
                                }
                            },
                            '/api/v1/accountoverview/billingDetails': {
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data;
                                    var payload = getPayload(state);
                                    var errorCode = rejection.status;
                                    var defaultErrorMessage = rejection.status + ': ' + rejection.statusText + ', ';
                                    var errorMessage = defaultErrorMessage + getErrorMessage(r, ['errorCode', 'errorMessage']);
                                    var section = [DataLayerSection.PAGE, DataLayerSection.SITE];
                                    if (!_.isEmpty(payload)) {
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector, section);
                                    }
                                }
                            },
                            '/api/v1/accountoverview/summary': {
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data;
                                    var payload = getPayload(state);
                                    var errorCode = rejection.status;
                                    var defaultErrorMessage = rejection.status + ': ' + rejection.statusText + ', ';
                                    var errorMessage = defaultErrorMessage + getErrorMessage(r, ['errorCode', 'errorMessage']);
                                    var section = [DataLayerSection.PAGE, DataLayerSection.SITE];
                                    if (!_.isEmpty(payload)) {
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector, section);
                                    }
                                }
                            },
                            '/api/v1/profile/changeUsername': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('change-username,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('change-username');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/profile/changePassword': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('change-password,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('change-password');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/linkAccount/prepaid': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status >= 200) {
                                        payload = getPayload('link-account-pay-as-you-go,accountOverview,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'errorCode');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['errorMessage']);
                                        payload = getPayload('error.linkAccount');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/account/disassociate': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('remove-account,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, isModalPopup: true };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('error.linkAccount');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/SelfServeAutomation/disassociateAccount': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status === 200) {
                                        payload = getPayload('remove-account,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, isModalPopup: true };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = rejection.status;
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['disassociateAccountNumber[0]']);
                                        payload = getPayload('error.linkAccount');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/updateProfileInfo/updateContactInfo': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status === 200) {
                                        payload = getPayload('edit-contact-information,event.selfServeComplete,' + state);
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                }
                            },
                            '/api/v1/updateProfileInfo/updateBillingAddress': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status === 200) {
                                        payload = getPayload('edit-billing-information,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var payload = getPayload('edit-billing-information');
                                    var errorCode = _.get(rejection, 'data.errorCode', rejection.status);
                                    var errorMessage = _.get(rejection, 'data.errorMessage', rejection.statusText);
                                    if (!_.isEmpty(payload)) {
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v3/payment/history': {
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status === 200) {
                                        payload = getPayload(state + ',payment-history,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                }
                            },
                            '/api/v1/wirelessDashBoard/changeSimCardNumber': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('change-sim-success,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        var errorMessage = getErrorMessage(r, ['status.codeName', 'status.description']);
                                        payload = getPayload('error.changeSIM');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            'api/v1/wirelessDashBoard/resetvoicemailPassword': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('change-voicemail-password,event.selfServeComplete,' + state);
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                            },
                            'api/v1/profile/forgotPasswordOneView': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('myrogers-pwd-reset,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        payload = getPayload('error.myrogers-pwd-reset');
                                        return getResponseErrorPayload(payload, errorCode, _.get(r, 'status.codeName'), 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v2/wirelessService/changeSubscriberName': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'status.code') === 0) {
                                        payload = getPayload('change-caller-id,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(r, 'status.code');
                                    if (errorCode) {
                                        payload = getPayload('error.changeCallerID');
                                        return getResponseErrorPayload(payload, errorCode, _.get(r, 'status.codeName'), 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/updateProfileInfo/updateBillingType': {
                                request: function (request, api, state, $injector) {
                                    var r = request.data, data = {}, payload = {};
                                    isEBill = (_.get(r, 'billingType') === 'E_BILL');
                                    if (!isEBill) {
                                        payload = getPayload('switch-to-invoice-billing,event.selfServeStart');
                                    }
                                    if (!_.isEmpty(payload)) {
                                        data = { payload: payload, pageView: false };
                                    }
                                    return data;
                                },
                                response: function (response, api, state, $injector) {
                                    var data = {}, payload = {};
                                    if (response.status === 200) {
                                        payload = getPayload((isEBill
                                            ? ('switch-to-online-billing-' + state)
                                            : 'switch-to-invoice-billing')
                                            + ',event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var payload = getPayload((isEBill
                                        ? ('switch-to-online-billing-' + state)
                                        : 'switch-to-invoice-billing'));
                                    var errorCode = _.get(rejection, 'data.errorCode', rejection.status);
                                    var errorMessage = _.get(rejection, 'data.errorMessage', rejection.statusText);
                                    if (!_.isEmpty(payload)) {
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/data-manager/get-usage-details': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, alertKey = '';
                                    _.forEach(_.get(r, 'body.subscriptionList', ''), function (item) {
                                        var threshold = _.get(item, 'dataAlert.threshold', '').toString();
                                        var ctn = _.get(item, 'subscriptionNumber', '').toString();
                                        alertKey += threshold + ctn + ' ';
                                    });
                                    var dataManagerTelephoneNumber = _.get(r, 'body.dataManagerTelephoneNumber');
                                    updateSessionStorage('__adl', {
                                        alertKey: alertKey,
                                        dataManagerTelephoneNumberIsSet: dataManagerTelephoneNumber !== ''
                                    });
                                }
                            },
                            '/api/v1/data-manager/set-alert': {
                                request: function (request, api, state, $injector) {
                                    var r = request.data, data = {}, payload = {}, alert = '';
                                    if (_.get(r, 'isAlertOn') === false) {
                                        alert = 'turn-off-alert';
                                    }
                                    else {
                                        alert = 'set-alert';
                                        var alertKey_1 = getSessionStorage('__adl', 'alertKey').toString().split(' ');
                                        var alertRequest_1 = _.get(r, 'alertThreshold', '').toString() + _.get(r, 'telephoneNumber', '').toString();
                                        _.forEach(alertKey_1, function (item, idx) {
                                            if (item === alertRequest_1) {
                                                alert = 'turn-on-alert';
                                            }
                                            else if (item.indexOf(_.get(r, 'telephoneNumber').toString()) >= 0) {
                                                alertKey_1[idx] = alertRequest_1;
                                            }
                                        });
                                        if (alert === 'set-alert') {
                                            updateSessionStorage('__adl', { alertKey: alertKey_1.join(' ') });
                                        }
                                    }
                                    if (alert) {
                                        updateSessionStorage('__adl', { alert: alert });
                                        payload = getPayload(alert + ',event.selfServeStart');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'body.isSuccess')) {
                                        var alert_1 = getSessionStorage('__adl', 'alert');
                                        payload = getPayload(alert_1 + ',event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    else {
                                        var errorCode = _.get(r, 'error.code');
                                        var errorMessage = _.get(r, 'error.message');
                                        payload = getPayload('error.setAlert');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, true, $injector);
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(rejection, 'data.errorCode', _.get(r, 'status.code', rejection.status));
                                    var errorMessage = _.get(rejection, 'data.errorMessage', _.get(r, 'status.codeName', rejection.statusText));
                                    if (errorCode) {
                                        payload = getPayload('error.setAlert');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v1/data-manager/set-data-manager': {
                                request: function (request, api, state, $injector) {
                                    updateSessionStorage('__adl', { setDMInitState: state });
                                },
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'body.isSuccess')) {
                                        payload = getPayload('set-recipient,event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                        var initState = getSessionStorage('__adl', 'setDMInitState');
                                        var dataManagerTelephoneNumberIsSet = getSessionStorage('__adl', 'dataManagerTelephoneNumberIsSet');
                                        if (dataManagerTelephoneNumberIsSet === false && initState !== 'self-serve') {
                                            dataLayerTrack($injector, false, false, { 'mappingKey': 'shareEverythingDashboard.manageDataAlerts-modal,event.selfServeComplete' });
                                        }
                                    }
                                    else {
                                        var errorCode = _.get(r, 'error.code');
                                        var errorMessage = _.get(r, 'error.message');
                                        payload = getPayload('error.setRecipient');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, true, $injector);
                                    }
                                    return data;
                                },
                            },
                            '/api/v1/data-manager/set-block': {
                                request: function (request, api, state, $injector) {
                                    var r = request.data, data = {}, payload = {};
                                    if (_.has(r, 'isDataAccessBlocked')) {
                                        var flag = !!_.get(r, 'isDataAccessBlocked');
                                        updateSessionStorage('__adl', { block: flag });
                                        payload = getPayload('data-' + ((flag) ? 'block' : 'unblock') + ',event.selfServeStart');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    return data;
                                },
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    if (_.get(r, 'body.isSuccess')) {
                                        var blockOption = (getSessionStorage('__adl', 'block') === true) ? 'block' : 'unblock';
                                        payload = getPayload('data-' + blockOption + ',event.selfServeComplete');
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    else {
                                        var errorCode = _.get(r, 'error.code');
                                        var errorMessage = _.get(r, 'error.message');
                                        payload = getPayload('error.setRecipient');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, true, $injector);
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var r = rejection.data, payload = {};
                                    var errorCode = _.get(rejection, 'data.errorCode', _.get(r, 'status.code', rejection.status));
                                    var errorMessage = _.get(rejection, 'data.errorMessage', _.get(r, 'status.codeName', rejection.statusText));
                                    if (errorCode) {
                                        payload = getPayload('error.setAlert');
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                }
                            },
                            '/api/v2/payment/updatePaymentMethod': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {}, mappingKey = 'automatic-payment-setup,event.selfServeComplete', ssData;
                                    if (_.get(r, 'content.status')) {
                                        ssData = getSessionStorage('__adl', 'updatePaymentMethod');
                                        if (ssData && ssData.pageKey) {
                                            mappingKey += ',' + ssData.pageKey;
                                            if (ssData.pageKey === 'preAuthPaymentMethod-credit') {
                                                mappingKey += ',' + ssData.selfServeKey;
                                            }
                                            payload = getPayload(mappingKey);
                                            if (!_.isEmpty(payload)) {
                                                data = { payload: payload, pageView: false };
                                            }
                                        }
                                        else {
                                            data = null;
                                        }
                                    }
                                    return data;
                                },
                                responseError: function (rejection, api, state, $injector) {
                                    var payload = {}, mappingKey = '', ssData = _.get(JSON.parse(sessionStorage.getItem('__adl')), 'updatePaymentMethod');
                                    if (ssData && ssData.pageKey) {
                                        mappingKey += ',' + ssData.pageKey;
                                        if (ssData.pageKey === 'preAuthPaymentMethod-credit') {
                                            mappingKey += ',' + ssData.selfServeKey;
                                        }
                                        payload = getPayload(mappingKey);
                                        var errorCode = _.get(rejection, 'data.errorCode', rejection.status);
                                        var errorMessage = _.get(rejection, 'data.errorMessage', rejection.statusText);
                                        if (!_.isEmpty(payload)) {
                                            return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                        }
                                    }
                                }
                            },
                            // Only used to clear the information recorded above about a rep
                            '/api/v1/discardAllSmCookies': {
                                request: function (request, api, state, $injector) {
                                    sessionStorage.removeItem('__adl');
                                    sessionStorage.removeItem('trackDataPayload');
                                }
                            },
                            'api/v1/checkHupEligibility': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, payload = {};
                                    var userType = userService.getUserType();
                                    var errorCodesArray = ['ban_delinquent', 'error_ban_billing_address', 'ban_cra', 'error_ctn_activation', 'error_ctn_last_hup', 'error_ctn_pending_hup', 'error_ctn_pending_port_in', 'error_ctn_pending_deactivation', 'fraud_alert'];
                                    if (response.status === 200) {
                                        if (userType === 'dealer' || userType === 'care') {
                                            if (_.get(r, 'isHupEligibilityError') && _.includes(errorCodesArray, r.hupErrorCode.toLowerCase())) {
                                                var errorMessage = r.hupErrorCode.toLowerCase() + '_' + userType;
                                                var errorCode = r.hupErrorCode;
                                                var currentStateURL = $window.location.href;
                                                payload = (currentStateURL.indexOf('wireless') > -1) ? getPayload('error.hupNotEligibleWireless') : getPayload('error.hupNotEligibleShareEverything'); //TODO: send payload according to the state: wireless or shareEverything
                                                return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                            }
                                        }
                                    }
                                },
                            },
                            'api/v1/getCases': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, payload = {};
                                    var isBOTEligible = false, openCase, errorMessage;
                                    var flowType = utePersistentStorageService.getFromSession('botFlowType'); // PPC or HUP
                                    angular.forEach(r.getCasesResponse.cases._case, function (value, key) {
                                        if ((value.caseStatus.toLowerCase() === 'new' ||
                                            value.caseStatus.toLowerCase() === 'in progress' ||
                                            value.caseStatus.toLowerCase() === 'new case') &&
                                            (value.caseTypeLevel3.toLowerCase() === 'hup' ||
                                                value.caseTypeLevel3.toLowerCase() === 'price plan change')) {
                                            isBOTEligible = true;
                                            openCase = value;
                                        }
                                    });
                                    if (isBOTEligible) {
                                        if (flowType === 'HUP') {
                                            errorMessage = (openCase.caseTypeLevel3.toLowerCase() === 'hup') ? 'hup_bot_message_hup' : 'hup_bot_message_ppc';
                                        }
                                        else if (flowType === 'PPC') {
                                            errorMessage = (openCase.caseTypeLevel3.toLowerCase() === 'hup') ? 'ppc_bot_message_hup' : 'ppc_bot_message_ppc';
                                        }
                                        var currentStateURL = $window.location.href;
                                        payload = (currentStateURL.indexOf('wireless') > -1) ? getPayload('error.getCasesWireless') : getPayload('error.getCasesShareEverything'); //TODO: send payload according to the state: wireless or shareEverything
                                        var errorCode = errorMessage; // Since there is no errorcode, send the message as code
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                },
                            },
                            'api/v1/closeCase': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, payload, data, message;
                                    var flowType = utePersistentStorageService.getFromSession('botFlowType');
                                    if (r.responseHeader.status.toLowerCase() === 'success') {
                                        /* if (flowType === 'HUP') {
                                           message = 'hupcode_case_cancellation_request';
                                         } else if (flowType === 'PPC') {
                                           message = 'ppccode_case_cancellation_request';
                                         }*/
                                        if (flowType === 'HUP') {
                                            return { payload: getPayload('hupBotCancellation') };
                                        }
                                        else if (flowType === 'PPC') {
                                            return { payload: getPayload('ppcBotCancellation') };
                                        }
                                        payload = getPayload('close-case,event.selfServeComplete'); //TODO: send payload according to the state: wireless or shareEverything
                                        var payLoadCode = message;
                                        var payLoadMessage = getTranslatedMessage(200, message, $injector);
                                        payload.code = payLoadCode; // TODO: As of now, adding to paylod, but have to check with Analytics team and confirm on the object
                                        payload.message = payLoadMessage; // TODO: Same as above
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                        else {
                                            data = null;
                                        }
                                    }
                                    return data;
                                },
                            },
                            'api/v1/oneView/dealerProfile': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, payload = {};
                                    if (r.success && r.dealerInfo && r.dealerInfo.DealerID) {
                                        var payload_1 = getPayload('dealerProfile'); //TODO arbitrary key has been taken. Need to take the correct key
                                        payload_1.dealer = { dealerCode: r.dealerInfo.DealerID };
                                        payload_1.events = { dealerSubmit: true };
                                        return { payload: payload_1, pageView: false };
                                    }
                                    if (!r.success) {
                                        payload = getPayload('error.dealerProfile');
                                        var errorCode = _.get(r, 'errorMessage');
                                        var errorMessage = 'ute.rogers.captureDealerCode.error';
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                },
                            },
                            'api/v1/oneView/saveDealerCode': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, payload = {};
                                    if (r !== 'Succeeded') {
                                        payload = getPayload('error.saveDealerCode');
                                        var errorCode = _.get(r, 'errorMessage');
                                        var errorMessage = 'ute.rogers.captureDealerCode.error';
                                        return getResponseErrorPayload(payload, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                    }
                                },
                            },
                            'api/v1/checkout/validate-order': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {};
                                    if (r.success) {
                                        var orderDetails = utePersistentStorageService.getFromSession('order'), order = void 0;
                                        if (orderDetails) {
                                            var orderId = orderDetails.orderId;
                                            var orderSavedByAgent = orderDetails.orderSavedByAgent;
                                            var userType = userService.getUserType();
                                            order = { orderId: orderId, orderSavedByAgent: orderSavedByAgent, orderSelectedBy: userType };
                                        }
                                        var payload = getPayload('validate-order,event.selfServeComplete');
                                        payload.order = order; // TODO: As of now, sending the entire object which has orderSavedByAgent flag. Confirm with Analytics on the structure
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload, pageView: false };
                                        }
                                    }
                                    else {
                                        data = null;
                                    }
                                    return data;
                                }
                            },
                            '/api/v1/wirelessDashBoard/rlh/getDetails': {
                                response: function (response, api, state, $injector) {
                                    var r = response.data, data = {}, payload = {};
                                    var ctn = _.get(r, 'ctn');
                                    if (ctn && phoneNumber !== ctn && _.get(r, 'successFlag')) {
                                        payload = getPayload(state);
                                        if (!_.isEmpty(payload)) {
                                            data = { payload: payload };
                                        }
                                    }
                                    return data;
                                }
                            },
                            '/OnlineProfile/onBoardingMessageStatus': {
                                // Suppress global error tracking for OnlineProfile/onBoardingMessageStatus API
                                responseError: function () {
                                    return null;
                                }
                            },
                            'default': {
                                responseError: function (rejection, api, state, $injector) {
                                    try {
                                        var errorCode = rejection.status;
                                        if (errorCode !== 0 && errorCode !== -1) {
                                            var errorMessage = JSON.stringify(rejection.data);
                                            return getResponseErrorPayload({}, errorCode, errorMessage, 'self_serve', 'http', api, false, $injector);
                                        }
                                    }
                                    catch (e) {
                                        console.warn('ADL error in default.responseError method: ', e);
                                    }
                                }
                            }
                        }
                    };
                    function decorateModal(modalType, onClose) {
                        $provide.decorator(modalType, ['$delegate', 'ute.datalayer.common.service', function ($delegate, dataLayerService) {
                                var open = $delegate.open;
                                $delegate.open = function () {
                                    var r = open.apply(this, arguments);
                                    try {
                                        dataLayerService.trackUteModal(arguments[0]);
                                    }
                                    catch (e) {
                                        console.warn('trackUteModal method from modal open: ', e);
                                    }
                                    r[onClose].finally(function () {
                                        dataLayerService.resetLastModalPayload();
                                    });
                                    return r;
                                };
                                return $delegate;
                            }]);
                    }
                    function getPayload(key) {
                        var payload = {};
                        var mappingKeys = key.split(',');
                        _.forEach(mappingKeys, function (mappingKey) {
                            mappingKey = _.trim(mappingKey);
                            if (_.has(config.advance.mappingKey, mappingKey)) {
                                _.merge(payload, _.cloneDeep(_.get(config.advance.mappingKey, mappingKey)));
                            }
                        });
                        return payload;
                    }
                    dataLayerCommonServiceProvider.configure(config);
                }
                function getErrorMessage(obj, paths, recursive) {
                    if (recursive === void 0) { recursive = false; }
                    if (paths.length === 0) {
                        return '';
                    }
                    else if (paths.length === 1) {
                        var msg = _.get(obj, paths[0], (!recursive && typeof obj === 'object') ? JSON.stringify(obj) : '');
                        return (typeof msg === 'object') ? JSON.stringify(msg) : msg;
                    }
                    else {
                        return (getErrorMessage(obj, paths.splice(0, 1), true) + ' ' + getErrorMessage(obj, paths, true)).trim() || (typeof obj === 'object' ? JSON.stringify(obj) : obj);
                    }
                }
                function getTranslatedMessage(code, message, $injector) {
                    var $translate = $injector.get('$translate');
                    message = ($translate.instant(code) === code.toString()) ? $translate.instant(message) : $translate.instant(code) + ' ' + $translate.instant(message);
                    message = message.replace(/<(?:.|\n)*?>/gm, ' ').replace(/  +/g, ' ').trim().toLowerCase();
                    return message;
                }
                function getResponseErrorPayload(payload, errorCode, errorMessage, errorCategory, errorType, errorAPI, isModalPopup, $injector, section) {
                    if (section === void 0) { section = null; }
                    var tMessage = getTranslatedMessage(errorCode, errorMessage, $injector);
                    return getDefaultErrorPayload(payload, errorCode, tMessage, errorCategory, errorType, errorAPI, isModalPopup, section);
                }
                function getDefaultErrorPayload(payload, errorCode, errorMessage, errorCategory, errorType, errorAPI, isModalPopup, section) {
                    if (section === void 0) { section = null; }
                    return {
                        payload: payload || {},
                        errorCode: errorCode,
                        errorMessage: errorMessage,
                        errorCategory: [ute.datalayer.common.service.ErrorCategory[errorCategory.toUpperCase()]],
                        errorType: [ute.datalayer.common.service.ErrorType[errorType.toUpperCase()]],
                        errorAPI: errorAPI,
                        isModalPopup: isModalPopup,
                        isError: true,
                        section: section
                    };
                }
                /// Implementation of callbacks
                function getCurrentAccount() {
                    var returnObject;
                    /* Get selected Account information */
                    if (userService.isSigned()) {
                        return accountOverviewFactory().getSelectedAccount()
                            .then(function (account) {
                            returnObject = {
                                accountType: account.accountType,
                                accountNumber: account.accountNumber.toString()
                            };
                            phoneNumber = userService.getPersistentService().get(ute.blocks.persistent.storage.RogersStoreKeys.ROGERS_SELECTED_PHONE_NUMBER);
                            if (phoneNumber) {
                                returnObject.phoneNumber = phoneNumber += '';
                            }
                            return returnObject;
                        })
                            .catch(function (error) {
                            console.warn('Error in getting Account object:', error);
                            return returnObject;
                        });
                    }
                    else {
                        return $q.when(returnObject);
                    }
                }
                function getCurrentUser() {
                    var returnObject;
                    return dataLayerUtilsService.getDealerInfo().then(function (dealerInfo) {
                        try {
                            if (userService.isSigned()) {
                                var userType = userService.getUserType();
                                returnObject = {
                                    userType: (userType !== 'consumer' ? 'agent' : 'consumer')
                                };
                                if (userType && userType === 'consumer') {
                                    returnObject.userName = userService.getUser().userName;
                                }
                                else if (dealerInfo && dealerInfo.userId) {
                                    returnObject.userName = dealerInfo.userId;
                                    returnObject.agentType = userType === 'dealer' ? 'retail' : userType;
                                    returnObject.dealerCode = dealerInfo.dealerCode;
                                }
                            }
                        }
                        catch (error) {
                            console.warn('Current user is not signed in. Unable to obtain user details: ', error);
                        }
                        return $q.when(returnObject);
                    });
                }
                function getCurrentLanguage() {
                    var returnObject;
                    try {
                        returnObject = {
                            language: languageSwitcher.getCurrentLanguage(),
                        };
                    }
                    catch (error) {
                        console.warn('Error getting current language:', error);
                    }
                    return $q.when(returnObject);
                }
                function getCurrentProvince() {
                    var returnObject;
                    try {
                        returnObject = {
                            province: provinceService.getCurrentProvince()
                        };
                    }
                    catch (error) {
                        console.warn('Error getting current province:', error);
                    }
                    return $q.when(returnObject);
                }
                function getErrorPayload(param) {
                    var payload = {}, stateName;
                    try {
                        stateName = $state.current.name;
                        if (param === 'change-password') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: 'error.' + stateName + '-' + param });
                        }
                        else if (param === 'change-voicemail-password') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: stateName });
                            payload['page.name'] = 'error';
                        }
                        else if (param === 'switch-to-online-billing') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param + ',' + param + '-' + stateName });
                        }
                        else if (param && param.pageKey === 'preAuthPaymentMethod-bank') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param.pageKey });
                            updateSessionStorage('__adl', { updatePaymentMethod: param });
                        }
                        else if (param && param.pageKey === 'preAuthPaymentMethod-credit') {
                            var mappingKey = param.pageKey + ',' + param.selfServeKey;
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: mappingKey });
                            updateSessionStorage('__adl', { updatePaymentMethod: param });
                        }
                    }
                    catch (error) {
                        console.warn('ADL error in getErrorPayload method: ', error);
                    }
                    return $q.when(payload);
                }
                function getEventPayload(param) {
                    var payload = {}, stateName;
                    try {
                        stateName = $state.current.name;
                        if (param === 'switch-to-online-billing') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param + '-' + stateName });
                        }
                        else if (param && param.mappingKey === 'footerLinks') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param.mappingKey });
                            if (payload) {
                                if (payload.interaction) {
                                    payload.interaction.name = 'quicklink|' + param.linkId;
                                }
                                if (!payload.page) {
                                    payload.page = {};
                                }
                                var pageInfo = commonDataLayerService.getMappingPayload({ mappingKey: stateName });
                                if (pageInfo && pageInfo.page) {
                                    _.merge(payload.page, pageInfo.page);
                                }
                            }
                        }
                        else if (param && param.pageKey === 'preAuthPaymentMethod-bank') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param.pageKey });
                            updateSessionStorage('__adl', { updatePaymentMethod: param });
                        }
                        else if (param && param.pageKey === 'preAuthPaymentMethod-credit') {
                            var mappingKey = param.pageKey + ',' + param.selfServeKey;
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: mappingKey });
                            updateSessionStorage('__adl', { updatePaymentMethod: param });
                        }
                        else if (param && param.mappingKey === 'onboarding.widget') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: param.mappingKey });
                            payload.miscellaneous.name = param.segmentName;
                        }
                    }
                    catch (error) {
                        console.warn('ADL error in getEventPayload method: ', error);
                    }
                    return $q.when(payload);
                }
                function getCurrentPayload(param) {
                    var payload = {};
                    try {
                        if (param === 'simCard.start') {
                            payload = commonDataLayerService.getMappingPayload({ mappingKey: 'change-sim,event.selfServeStart' });
                        }
                    }
                    catch (error) {
                        console.warn('ADL error in getCurrentPayload method: ', error);
                    }
                    return $q.when(payload);
                }
                function getSelfServeObj(type, name) {
                    return {
                        type: type,
                        name: name
                    };
                }
                function getPageObject(name, hierarchy) {
                    return {
                        name: name,
                        hierarchy: hierarchy
                    };
                }
                function updateSessionStorage(key, obj) {
                    var existingData = JSON.parse(sessionStorage.getItem(key)) || {};
                    var newData = _.merge(existingData, obj);
                    sessionStorage.setItem(key, JSON.stringify(newData));
                }
                function getSessionStorage(key, path) {
                    return _.get(JSON.parse(sessionStorage.getItem(key)), path);
                }
                function getParameterByName(name) {
                    name = name.replace(/[\[\]]/g, '\\$&');
                    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = _.get(regex.exec(window.location.href), '2', '');
                    return decodeURIComponent(results.replace(/\+/g, ' '));
                }
                function getFromCookie(name) {
                    return _.get(RegExp(name + '[^;]+').exec(document.cookie), '0', null);
                }
            })(integration = common.integration || (common.integration = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var ute;
(function (ute) {
    var datalayer;
    (function (datalayer) {
        var common;
        (function (common) {
            var integration;
            (function (integration) {
                'use strict';
                //BCR-693 Analytics: Creating a new Utils service
                var DataLayerUtils = (function () {
                    function DataLayerUtils($q, utePersistentStorageService) {
                        var _this = this;
                        this.$q = $q;
                        this.utePersistentStorageService = utePersistentStorageService;
                        /**
                         * @description To set the dealer info object.
                         */
                        this.setDealerInfo = function (dealerInfoObj) {
                            var currentDealerInfoObj = {};
                            try {
                                currentDealerInfoObj.dealerCode = dealerInfoObj.dealerCode;
                                currentDealerInfoObj.dealerType = dealerInfoObj.dealerType;
                                currentDealerInfoObj.userId = dealerInfoObj.userId;
                                _this.utePersistentStorageService.putToSession('dealerInfo', currentDealerInfoObj);
                            }
                            catch (error) {
                                console.error('ADL error while setting the Current dealer code Object : ', error);
                            }
                            return _this.$q.when(true);
                        };
                        /**
                         * @description To get the dealer info object.
                         */
                        this.getDealerInfo = function () {
                            var returnObject = {};
                            try {
                                returnObject = _this.utePersistentStorageService.getFromSession('dealerInfo');
                            }
                            catch (error) {
                                console.error('ADL error while getting the Current dealer code Object : ', error);
                            }
                            return _this.$q.when(returnObject);
                        };
                    }
                    DataLayerUtils.$inject = ['$q',
                        'ute.blocks.persistent.storage.service'
                    ];
                    return DataLayerUtils;
                }());
                angular.module('totesApp').service('my.rogers.dataLayer.utils.service', DataLayerUtils);
            })(integration = common.integration || (common.integration = {}));
        })(common = datalayer.common || (datalayer.common = {}));
    })(datalayer = ute.datalayer || (ute.datalayer = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var data;
        (function (data) {
            var manager;
            (function (manager) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureDataManager);
                    configureDataManager.$inject = ['ute.data.manager.serviceProvider'];
                    /* @ngInject */
                    function configureDataManager(dataManagerServiceProvider) {
                        dataManagerServiceProvider.configure({
                            basic: {
                                applicationId: 'Rogers.com',
                                brand: 'ROGERS',
                                serviceType: 'DM',
                                medium: 'WEB',
                                channelId: 'UTERogersOnline',
                                analyticsId: 'myrogers',
                                dashboardState: 'accountOverview',
                                wirelessState: 'wireless',
                                invalidSEAccountRedirectState: 'accountOverview',
                                invalidSEAccountRedirectStateWireless: 'wireless'
                            },
                            advanced: {
                                dataManagerTabsContent: {
                                    controllerName: 'MyrWirelessDashboardController',
                                    templateUrl: 'scripts/modules/wirelessDashboard/wirelessDashboard.html'
                                },
                                dataManagerAccountsSummary: {
                                    chartHeightOffset: 212,
                                    headerOffset: 155,
                                    footerOffset: 85 //Decreasing lowers footer position
                                },
                                dataManagerDiscoveryIntegration: {
                                    brand: 'ROGERS'
                                },
                                dataManagerUpgradePlanDirective: {
                                    modals: {
                                        wirelessRemovePlan: {
                                            controllerName: 'wirelessRemoveModalCtrl',
                                            templateUrl: 'views/modals/wirelessRemovePlan.html',
                                        },
                                        deepLink: {
                                            controllerName: 'deepLinkModalCtrl',
                                            templateUrl: 'views/modals/deepLinkModal.html',
                                        },
                                        captureDealerCode: {
                                            controllerName: 'dsgCaptureDealerCodeModalController',
                                            templateUrl: 'scripts/modules/oneView/captureDealerCode/dsgCaptureDealerCodeModal.html',
                                        },
                                        proceedWithoutDealerCode: {
                                            controllerName: 'proceedWithoutDealerCodeModalController',
                                            templateUrl: 'scripts/modules/oneView/captureDealerCode/proceedWithoutDealerCodeModal.html',
                                        }
                                    }
                                }
                            }
                        });
                    }
                })(integration = manager.integration || (manager.integration = {}));
            })(manager = data.manager || (data.manager = {}));
        })(data = rogers.data || (rogers.data = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var dtm;
    (function (dtm) {
        var service;
        (function (service) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureDtmDataLayerSetting);
                configureDtmDataLayerSetting.$inject = ['ute.dtm.dataLayer.serviceProvider'];
                /* @ngInject */
                function configureDtmDataLayerSetting(dtmDataLayerProviderProvider) {
                    dtmDataLayerProviderProvider.configure({
                        basic: {
                            site: {
                                name: 'R'
                            },
                            signin: {
                                type: 'MyRogers'
                            }
                        }
                    });
                }
            })(integration = service.integration || (service.integration = {}));
        })(service = dtm.service || (dtm.service = {}));
    })(dtm = ute.dtm || (ute.dtm = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var paymentUI;
        (function (paymentUI) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureEasyLoginRegistration);
                configureEasyLoginRegistration.$inject = [
                    'ute.easy.login.registration.serviceProvider',
                    'ute.blocks.environmentProvider'
                ];
                /* @ngInject */
                function configureEasyLoginRegistration(easyLoginRegistrationConfigProvider, environmentProvider) {
                    //Configure all initiating view which are likely going to use PaymentUI module
                    var mservicesUrl = environmentProvider.getProperty('msBaseUrl');
                    easyLoginRegistrationConfigProvider.configure({
                        basic: {
                            branding: 'ROGERS',
                            domain: 'rogers.com',
                            apiUrl: 'api/v1/profile/create',
                            dtmName: 'account registration',
                            logPrefix: 'UserRegistration',
                            applicationId: 'UTERogersOnline',
                            logLevel: ute.common.typescript.api.log.LogLevel.OFF,
                            recaptchaSiteKey: '6LeI_FAUAAAAAFAibCBAp4L9cN-BJ6HH4VeBFjwm',
                            visaPromotion: environmentProvider.getProperty('visaPromotion')
                        },
                        advanced: {
                            apis: {
                                accounts: mservicesUrl + '/v1/user/registration',
                                verifyEmail: mservicesUrl + '/v1/user/registration/mwautoverify',
                                sendEmail: mservicesUrl + '/v1/user/registration?op=create',
                                createPassword: mservicesUrl + '/v1/user/registration/mwautoactivate',
                            },
                            main: {
                                stateName: 'easylogin/main',
                                cancelState: 'wireless',
                                controllerName: 'ute.easy.login.registration.controller',
                                templateUrl: 'module/easyLoginRegistration/templates/rogers/easyLoginRegistration.html',
                            },
                            registration: {
                                stateName: 'easylogin/registration?token',
                                cancelState: 'wireless',
                                controllerName: 'ute.easy.login.registration.controller',
                                templateUrl: 'module/easyLoginRegistration/templates/rogers/easyLoginRegistration.html',
                            },
                            confirmation: {
                                stateName: 'easylogin/registrationConfirmation',
                                controllerName: 'ute.rogers.user.registration.confirmation.controller',
                                templateUrl: 'module/registrationConfirmation/registrationConfirmation.html',
                            },
                            supportedLanguages: {
                                en: 'English',
                                fr: 'Français'
                            }
                        }
                    });
                }
            })(integration = paymentUI.integration || (paymentUI.integration = {}));
        })(paymentUI = rogers.paymentUI || (rogers.paymentUI = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var myr;
(function (myr) {
    var modules;
    (function (modules) {
        var viewBill;
        (function (viewBill) {
            'use strict';
            var BillingEnhancementModal = (function () {
                function BillingEnhancementModal($modalInstance, $rootScope, $timeout, language) {
                    var _this = this;
                    this.$modalInstance = $modalInstance;
                    this.$rootScope = $rootScope;
                    this.$timeout = $timeout;
                    this.language = language;
                    this.cancel = function (e) {
                        e.preventDefault();
                        var element = angular.element(e.target);
                        element.closest('.briteBill-enhancement-overlay').removeClass('animate-bottom-open');
                        element.closest('.briteBill-enhancement-overlay').addClass('animate-bottom-close');
                        _this.$timeout(function () {
                            _this.$modalInstance.dismiss('cancel');
                            _this.$rootScope.modal = null;
                        }, 500);
                    };
                    this.closeVideoModal = function (e) {
                        _this.$modalInstance.dismiss('cancel');
                        _this.$rootScope.modal = null;
                    };
                    this.getLang = function () {
                        return _this.language.getCurrentLanguage();
                    };
                }
                BillingEnhancementModal.$inject = [
                    '$modalInstance', '$rootScope', '$timeout', 'ute.blocks.language.switcher'
                ];
                return BillingEnhancementModal;
            }());
            angular.module('myr.modules.viewBill').controller('BillingEnhancementModal', BillingEnhancementModal);
        })(viewBill = modules.viewBill || (modules.viewBill = {}));
    })(modules = myr.modules || (myr.modules = {}));
})(myr || (myr = {}));

var myr;
(function (myr) {
    var modules;
    (function (modules) {
        var viewBill;
        (function (viewBill) {
            'use strict';
            var ViewBillController = (function () {
                function ViewBillController($state, dtmService, briteBillService, myrAccountBalanceDataFactory, $rootScope, $timeout, $modal, settings, routeData, liveChatSettings, payNowService, accountOverviewFactory, ajax, userService, $window, ngDialog, messageService, billingDetailFactory, languageService, $translate, util, goPaperlessService, dataLayerService, $scope, fraudLoggingService, transactionProp, paymentMethodService, myrAccountListService) {
                    var _this = this;
                    this.$state = $state;
                    this.dtmService = dtmService;
                    this.briteBillService = briteBillService;
                    this.myrAccountBalanceDataFactory = myrAccountBalanceDataFactory;
                    this.$rootScope = $rootScope;
                    this.$timeout = $timeout;
                    this.$modal = $modal;
                    this.settings = settings;
                    this.routeData = routeData;
                    this.liveChatSettings = liveChatSettings;
                    this.payNowService = payNowService;
                    this.accountOverviewFactory = accountOverviewFactory;
                    this.ajax = ajax;
                    this.userService = userService;
                    this.$window = $window;
                    this.ngDialog = ngDialog;
                    this.messageService = messageService;
                    this.billingDetailFactory = billingDetailFactory;
                    this.languageService = languageService;
                    this.$translate = $translate;
                    this.util = util;
                    this.goPaperlessService = goPaperlessService;
                    this.dataLayerService = dataLayerService;
                    this.$scope = $scope;
                    this.fraudLoggingService = fraudLoggingService;
                    this.transactionProp = transactionProp;
                    this.paymentMethodService = paymentMethodService;
                    this.myrAccountListService = myrAccountListService;
                    this.billingCycleEndDate = function () {
                        return moment(_this.abdf.billingDetails.billCycleEndDate, 'MMM-DD-YY').toDate() || _this.abdf.billingDetails.billCycleEndDate;
                    };
                    this.isLoadingBriteBill = function () {
                        return _this.briteBillService.isLoadingBriteBill(_this.accountNumber);
                    };
                    this.isNoBillsAvailable = function () {
                        return _this.briteBillService.isNoBillsAvailable(_this.accountNumber);
                    };
                    this.getLang = function () {
                        var lan = _this.languageService.getCurrentLanguage();
                        return lan;
                    };
                    this.isBriteBillErrorOccurred = function () {
                        return _this.briteBillService.isBriteBillErrorOccurred(_this.accountNumber);
                    };
                    this.downloadPdf = function (event) {
                        event.preventDefault();
                        var briteBillInvoice = _.find(_this.invoiceDateArray, { issue_date: _this.invoiceDateSelected });
                        if (briteBillInvoice) {
                            _this.briteBillService.downloadPdfService(briteBillInvoice.link);
                        }
                    };
                    this.invoiceDateChange = function () {
                        _this.briteBillService.setInvoiceDateSelected(_this.accountNumber, _this.invoiceDateSelected);
                        var briteBillInvoice = _.find(_this.invoiceDateArray, { issue_date: _this.invoiceDateSelected });
                        _this.briteBillService.changeBriteBillSrc(_this.accountNumber, briteBillInvoice.link);
                    };
                    this.balanceCallback = function (response) {
                        if (response.result === 'success' && !_this.isPrepaid) {
                            if (_this.$state.params && _this.$state.params.loadPaymentModal) {
                                if (_this.$rootScope.isConsumer) {
                                    _this.accountOverviewFactory().getSelectedAccountDetails(function (accountDetail) {
                                        return;
                                    })
                                        .then(function (accountDetails) {
                                        _this.payNowService.openMakePaymentModal(response.data, accountDetails, _this.$state.current && _this.$state.current.name ? _this.$state.current.name : 'viewbill')
                                            .then(function (result) {
                                            if (result.value === 'ok' || result.value === 'cancel') {
                                                _this.getBills().then(function (bills) {
                                                    if (bills && bills.length > 0) {
                                                        _this.showPayNowModal = false;
                                                    }
                                                });
                                            }
                                        });
                                    })
                                        .catch(function (error) {
                                        console.log('Error getting account summary');
                                    });
                                }
                            }
                        }
                    };
                    this.postToRogers = function () {
                        $('#formToRogers').attr('action', _this.settings.postToRogersUrls[0].url).submit();
                    };
                    this.showBillingVideoAd = function () {
                        _this.ngDialog.open({
                            template: 'scripts/modules/myrViewBill/billingVideoModal.html',
                            showClose: false,
                            className: 'ngdialog-theme-default billing-video-modal',
                            controller: ['ute.blocks.language.switcher', function (language) {
                                    this.lang = language.getCurrentLanguage();
                                }],
                            controllerAs: 'vb'
                        });
                    };
                    this.processBillingNotification = function (bills, selectedAccount) {
                        var issueDate;
                        if (bills[0] && bills[0].issue_date) {
                            issueDate = moment(bills[0].issue_date, 'YYYY-MM-DD');
                        }
                        var billCycleEndDate;
                        var today = moment().startOf('day');
                        var email;
                        selectedAccount.getAccountOverviewSummary()
                            .then(function (summary) {
                            if (selectedAccount.accountTypeNumber === 1 && selectedAccount.isActive()) {
                                email = _.get(summary, 'contactInfo.emailAddress', '');
                                _this.billingDetailFactory({
                                    accountNumber: selectedAccount.accountNumber,
                                    accountTypeNumber: selectedAccount.accountTypeNumber,
                                    language: _this.lang,
                                    applicationId: 'Rogers.com',
                                    refresh: false
                                }).getBillingDetail()
                                    .then(function (billingDetail) {
                                    billCycleEndDate = _this.deriveBillCycleEndDate(moment(billingDetail.billCycleEndDate, 'MMM-DD-YY'), today);
                                    if (issueDate && issueDate.isValid() &&
                                        billCycleEndDate.isValid() &&
                                        billCycleEndDate.diff(issueDate, 'days') > 0 &&
                                        today.diff(billCycleEndDate, 'days') > 0) {
                                        _this.generateNotification(billCycleEndDate, selectedAccount.accountNumber, selectedAccount.accountTypeNumber, email);
                                    }
                                });
                            }
                        });
                    };
                    this.deriveBillCycleEndDate = function (billCycleEndDate, today) {
                        var todayLastMonth = moment(today).subtract(1, 'month');
                        var targetBillCycleEndDate;
                        if (billCycleEndDate.isAfter(today)) {
                            var prevBillCycleEndDate = void 0;
                            var counter = 0;
                            do {
                                counter++;
                                prevBillCycleEndDate = moment(billCycleEndDate).subtract(counter, 'month');
                            } while (!(prevBillCycleEndDate.isBetween(todayLastMonth, today) || prevBillCycleEndDate.isSame(today)));
                            targetBillCycleEndDate = prevBillCycleEndDate;
                        }
                        else if (billCycleEndDate.isBetween(todayLastMonth, today) || billCycleEndDate.isSame(today)) {
                            targetBillCycleEndDate = billCycleEndDate;
                        }
                        else {
                            // actual condition: billCycleEndDate.isBefore(todayLastMonth) || || billCycleEndDate.isSame(todayLastMonth)
                            var nextBillCycleEndDate = void 0;
                            var counter = 0;
                            do {
                                counter++;
                                nextBillCycleEndDate = moment(billCycleEndDate).add(counter, 'month');
                            } while (!(nextBillCycleEndDate.isBetween(todayLastMonth, today) || nextBillCycleEndDate.isSame(today)));
                            targetBillCycleEndDate = nextBillCycleEndDate;
                        }
                        return targetBillCycleEndDate;
                    };
                    this.generateNotification = function (billCycleEndDate, accountNumber, accountTypeNumber, email) {
                        var billCycleMonth = billCycleEndDate.month();
                        var monthName = _this.util.getMonthsNames()[billCycleMonth];
                        _this.goPaperlessService.getBillingType(accountNumber, accountTypeNumber)
                            .then(function (billingType) {
                            _this.getTranslatedMessage(billingType, monthName, email);
                            _this.languageHandler = 'viewBillControllerLangSub' + _this.$scope.$id;
                            _this.languageService.registerOnDataChangeHandler(function (lang) {
                                monthName = _this.util.getMonthsNames()[billCycleMonth];
                                _this.getTranslatedMessage(billingType, monthName, email);
                                return null;
                            }, _this.languageHandler);
                        });
                    };
                    this.getTranslatedMessage = function (billingType, monthName, email) {
                        if (billingType === 'E_BILL') {
                            if (email) {
                                _this.billingNotification = _this.$translate.instant('ute.rogers.myrViewBill.billNotificationForOnlineBillWithEmail', {
                                    'monthName': monthName,
                                    email: email
                                });
                            }
                            else {
                                _this.billingNotification = _this.$translate.instant('ute.rogers.myrViewBill.billNotificationForOnlineBillNoEmail', { 'monthName': monthName });
                            }
                        }
                        else {
                            // cx on paper bill
                            _this.billingNotification = _this.$translate.instant('ute.rogers.myrViewBill.billNotificationForPaperBill', { 'monthName': monthName });
                        }
                        _this.dataLayerService.trackError({}, 1, '', $($.parseHTML(_this.billingNotification)).text(), 1, undefined, '', false, [0, 1, 4], { mappingKey: 'error.billingNotification' });
                    };
                    // private showBillEnhancementModal = () => {
                    //   let modal = this.$modal.open({
                    //     windowTemplateUrl: 'scripts/modules/myrViewBill/billingEnhancementModal.window.html',
                    //     templateUrl: 'scripts/modules/myrViewBill/billingEnhancementModal.html',
                    //     controller: 'BillingEnhancementModal',
                    //     controllerAs: 'vb',
                    //     size: 'lg',
                    //     backdrop: 'static',
                    //     keyboard: false,
                    //     backdropClass: 'save-bill-promotion-bkdrop bkg-modal',
                    //   });
                    //   modal.result
                    //     .then((result: any) => {
                    //       return;
                    //     })
                    //     .catch((reason: any) => {
                    //       return;
                    //     })
                    //     .finally(() => {
                    //       this.showSaveBillPromotion = false;
                    //       if (this.userService.isSigned) {
                    //         this.ajax.updateUserPreference(this.userService.getUser().userEmail.toLowerCase(), this.userService.getUserType(), 'saveBillPromotion', true);
                    //       }
                    //     });
                    // };
                    this.getBills = function () {
                        return _this.briteBillService.getBills(_this.accountNumber).then(function (bills) {
                            _this.$rootScope.ao.britebill = bills;
                            return bills;
                        });
                    };
                    // private getUserPreferenceCallback = (userPreference: Array<any>): void => {
                    //   let flag: { name: string, value: boolean } = _.find(userPreference, {name: 'saveBillPromotion'});
                    //   this.showSaveBillPromotion = flag && flag.value === true ? false : true;
                    //   if (this.showSaveBillPromotion && !this.showPayNowModal && !this.isInteracFailed) {
                    //     this.showBillEnhancementModal();
                    //   }
                    // };
                    this.messageSubscriber = function (event, data) {
                        if (data.refresh === true) {
                            if (_this.briteBillService.getInvoiceDateSelected(_this.accountNumber) !== _this.invoiceDateArray[0].id) {
                                //select the latest bill
                                _this.invoiceDateSelected = _this.invoiceDateArray[0].id;
                                _this.invoiceDateChange();
                            }
                            else {
                                // need to set src attribute explicitly to get the iframe refreshed because we have same src for iframe
                                var briteBillIframe = angular.element('.bb_iframe');
                                if (briteBillIframe.length) {
                                    briteBillIframe.attr('src', _this.briteBillService.getSRC(_this.accountNumber));
                                    briteBillIframe = null;
                                }
                            }
                        }
                    };
                    this.init = function () {
                        _this.$window.scrollPageToTop();
                        _this.lang = _this.languageService.getCurrentLanguage();
                        _this.isPrepaid = _this.routeData.isPrepaid;
                        _this.isConsumer = _this.userService.isConsumer();
                        _this.accountNumber = _this.routeData.selectedAccount ? String(_this.routeData.selectedAccount.accountNumber) : '';
                        if (_this.isPrepaid) {
                            if (_this.routeData.selectedAccount) {
                                _this.accountNumber = String(_this.routeData.selectedAccount.phoneNumber);
                                _this.ctn = String(_this.routeData.selectedAccount.phoneNumber);
                                _this.pin = _this.routeData.selectedAccount.pinNumber;
                            }
                            $('#prepaidFormToRogers').attr('action', _this.settings.prepaidAccountViewBillUrl);
                            _this.$timeout(function () {
                                $('#prepaidFormToRogers').submit();
                            }, 0);
                        }
                        else {
                            _this.showSaveBillPromotion = null;
                            _this.state = _this.$state.current.name;
                            _this.abdf = _this.myrAccountBalanceDataFactory;
                            _this.supportNumber = _this.getLang() === 'en' ? _this.settings.contactNumbers.billingIssue : _this.settings.contactNumbers.billingIssueFr;
                            _this.dtmService.track('view bill', 'pasv', null);
                            _this.showPayNowModal = _this.$state.params && _this.$state.params.loadPaymentModal;
                            _this.isInteracFailed = _this.$state.params && _this.$state.params.interacFailed;
                            _this.getBills().then(function (bills) {
                                _this.invoiceDateArray = bills;
                                if (bills && bills.length > 0) {
                                    if (_this.routeData.selectedAccount) {
                                        _this.processBillingNotification(bills, _this.routeData.selectedAccount);
                                    }
                                    _this.subscriberResolve = _this.messageService.subscribe('refreshViewBill', _this.messageSubscriber);
                                    _this.invoiceDateSelected = bills[0].id;
                                    if (_this.$state.params.interacFailureModal !== null && _this.isInteracFailed === true) {
                                        _this.$state.params.interacFailureModal.closePromise.then(function (val) {
                                            _this.isInteracFailed = false;
                                            _this.$state.params.interacFailureModal = null;
                                        });
                                    }
                                }
                                if (_this.userService.isConsumer() && !_this.isBriteBillErrorOccurred() && !_this.myrAccountListService.viewBillVisitedAccounts.includes(_this.accountNumber)) {
                                    var fraudTransactionPayload = {
                                        sourceChannel: _this.transactionProp.sourceChannel.rogers,
                                        transactionType: _this.transactionProp.transactionType.billing,
                                        action: _this.transactionProp.action.viewBill,
                                        userEmail: _this.userService.getUser().userEmail,
                                        loginId: _this.userService.getUser().userEmail,
                                        userType: _this.transactionProp.userType.consumer,
                                        franchise: _this.transactionProp.franchise.rogers,
                                        transactionStatus: _this.transactionProp.transactionStatus.success
                                    };
                                    if (_this.accountNumber.length === 12) {
                                        fraudTransactionPayload.can = _this.accountNumber;
                                    }
                                    else if (_this.accountNumber.length === 9) {
                                        fraudTransactionPayload.ban = _this.accountNumber;
                                        fraudTransactionPayload.banSubType = _this.myrAccountListService.selectedAccount.accountSubType;
                                        fraudTransactionPayload.banType = _this.myrAccountListService.selectedAccount.accountType;
                                    }
                                    _this.fraudLoggingService.captureTransaction(fraudTransactionPayload);
                                    _this.myrAccountListService.viewBillVisitedAccounts.push(_this.accountNumber);
                                }
                            });
                            if (_this.$state.params && _this.$state.params.loadPaymentModal) {
                                _this.openMakePaymentModal();
                            }
                            if (_this.$state.params && _this.$state.params.loadPaymentMethodModal && !!_this.routeData.selectedAccount) {
                                _this.routeData.selectedAccount.getAccountOverviewSummary()
                                    .then(function (summary) {
                                    _this.paymentMethodService.openChangePaymentMethodModal(false, summary);
                                });
                            }
                        }
                        _this.languageService.registerOnDataChangeHandler(function (lang) {
                            _this.supportNumber = lang === 'fr' ? _this.settings.contactNumbers.billingIssueFr : _this.settings.contactNumbers.billingIssue;
                            return null;
                        }, 'viewBillControllerLanguageSub_' + _this.$scope.$id);
                        _this.$scope.$on('$destroy', function () {
                            if (_this.subscriberResolve) {
                                _this.subscriberResolve(); // unsubscribe to refresh event
                            }
                            if (_this.languageHandler) {
                                _this.languageService.unregisterOnDataChangeHandler(_this.languageHandler);
                            }
                            _this.languageService.unregisterOnDataChangeHandler('viewBillControllerLanguageSub_' + _this.$scope.$id);
                        });
                    };
                    this.init();
                }
                ViewBillController.prototype.openMakePaymentModal = function () {
                    var _this = this;
                    var selectedAccount = this.routeData.selectedAccount;
                    selectedAccount.getAccountOverviewSummary()
                        .then(function (summary) {
                        _this.billingDetailFactory({
                            accountNumber: selectedAccount.accountNumber,
                            accountTypeNumber: selectedAccount.accountTypeNumber,
                            language: _this.lang,
                            applicationId: 'Rogers.com',
                            refresh: false
                        }).getBillingDetail()
                            .then(function (billingDetail) {
                            var accountBalance = {
                                balanceAmount: billingDetail.balanceAmount,
                                methodOfPayment: {
                                    mopType: billingDetail.methodOfPayment.mopType.toString()
                                }
                            };
                            _this.payNowService.openMakePaymentModal(accountBalance, summary, 'viewbill');
                        });
                    });
                };
                ViewBillController.$inject = [
                    '$state',
                    'ute.dtm.service',
                    'ute.brite.bill.service',
                    'myrAccountBalanceDataFactory',
                    '$rootScope',
                    '$timeout',
                    '$modal',
                    'settings',
                    'routeData',
                    'liveChatSettings',
                    'ute.payment.ui.pay.now.service',
                    'ute.rogers.account.overview.factory',
                    'ajax',
                    'ute.common.user.service',
                    '$window',
                    'ngDialog',
                    'ute.blocks.messages.bus.service',
                    'ute.rogers.account.billing.detail.factory',
                    'ute.blocks.language.switcher',
                    '$translate',
                    'util',
                    'ute.goPaperless.service',
                    'ute.datalayer.common.service',
                    '$scope',
                    'ute.fraud.logging.service',
                    'ute.fraud.logging.TransactionProp',
                    'ute.payment.method.service',
                    'myrAccountListService'
                ];
                return ViewBillController;
            }());
            angular.module('myr.modules.viewBill').controller('MyrViewBillController', ViewBillController);
        })(viewBill = modules.viewBill || (modules.viewBill = {}));
    })(modules = myr.modules || (myr.modules = {}));
})(myr || (myr = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var paymentUI;
        (function (paymentUI) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configurePaymentUI);
                configurePaymentUI.$inject = ['ute.payment.ui.config.serviceProvider'];
                /* @ngInject */
                function configurePaymentUI(paymentUIConfigProvider) {
                    //Configure all initiating view which are likely going to use PaymentUI module
                    paymentUIConfigProvider.configure({
                        basic: {
                            applicationId: 'rogers.com'
                        },
                        advance: {
                            threshHoldPaymentAmount: 1000,
                            defaultState: 'accountOverview',
                            successState: 'paymenthistory'
                        }
                    });
                }
            })(integration = paymentUI.integration || (paymentUI.integration = {}));
        })(paymentUI = rogers.paymentUI || (rogers.paymentUI = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var profileEdit;
        (function (profileEdit) {
            var UsernameAndPassword;
            (function (UsernameAndPassword) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureProfileEditUsernameAndPassword);
                    configureProfileEditUsernameAndPassword.$inject = ['ute.common.profile.edit.serviceProvider'];
                    /* @ngInject */
                    function configureProfileEditUsernameAndPassword(resetVoicemailPasswordServiceProvider) {
                        resetVoicemailPasswordServiceProvider.configure({
                            basic: {
                                applicationId: 'UTERogersOnline'
                            },
                            advanced: {
                                changeUsername: {
                                    success: {
                                        callback: function ($injector, newUsername, isUsernameMigration) {
                                            return $injector.get('user').changeUsername(newUsername, isUsernameMigration);
                                        }
                                    }
                                }
                            }
                        });
                    }
                })(integration = UsernameAndPassword.integration || (UsernameAndPassword.integration = {}));
            })(UsernameAndPassword = profileEdit.UsernameAndPassword || (profileEdit.UsernameAndPassword = {}));
        })(profileEdit = rogers.profileEdit || (rogers.profileEdit = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var reactivateCtn;
        (function (reactivateCtn) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureReactivateCtn) /*.run(configureReactivateCtnInRuntime)*/;
                configureReactivateCtn.$inject = ['ute.common.reactivate.ctn.serviceProvider'];
                /* @ngInject */
                function configureReactivateCtn(reactivateServiceProvider) {
                    reactivateServiceProvider.configure({
                        basic: {
                            applicationId: 'UTERogersOnline',
                            medium: 'WEB'
                        },
                        advanced: {
                            // TODO review after accountoverview refactoring
                            resolve: {
                                /* @ngInject */
                                permissionData: ['permissionResolver', function (permissionResolver) {
                                        return permissionResolver.getPermission('reactivateCtn'); // This is a state name, not a path
                                    }]
                            }
                        }
                    });
                }
            })(integration = reactivateCtn.integration || (reactivateCtn.integration = {}));
        })(reactivateCtn = rogers.reactivateCtn || (rogers.reactivateCtn = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var resetVoicemailPassword;
        (function (resetVoicemailPassword) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureResetVoicemailPassword);
                configureResetVoicemailPassword.$inject = ['ute.common.voicemail.resetPassword.serviceProvider'];
                /* @ngInject */
                function configureResetVoicemailPassword(resetVoicemailPasswordServiceProvider) {
                    resetVoicemailPasswordServiceProvider.configure({
                        basic: {
                            applicationId: 'UTERogersOnline',
                            medium: 'WEB'
                        }
                    });
                }
            })(integration = resetVoicemailPassword.integration || (resetVoicemailPassword.integration = {}));
        })(resetVoicemailPassword = rogers.resetVoicemailPassword || (rogers.resetVoicemailPassword = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var revolution;
        (function (revolution) {
            var data;
            (function (data) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureRevolutionData);
                    configureRevolutionData.$inject = ['settings', 'ute.rogers.revolution.data.offer.factoryProvider',
                        'ute.blocks.environmentProvider'];
                    /* @ngInject */
                    function configureRevolutionData(settings, revolutionDataServiceProvider, environmentProvider) {
                        revolutionDataServiceProvider.configure({
                            basic: {
                                applicationId: environmentProvider.getProperty('applicationId'),
                                revolutionAddNhl: settings.revolutionAddNhl,
                                revolutionGetOffers: settings.revolutionGetOffers,
                                partialApiUrl: settings.revolutionGetOffers,
                                logLevel: 0,
                                logPrefix: 'revolutionData:',
                                isCachableOnBackend: false
                            }
                        });
                    }
                })(integration = data.integration || (data.integration = {}));
            })(data = revolution.data || (revolution.data = {}));
        })(revolution = rogers.revolution || (rogers.revolution = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var rogers;
    (function (rogers) {
        var second;
        (function (second) {
            var level;
            (function (level) {
                var navigation;
                (function (navigation) {
                    var integration;
                    (function (integration) {
                        'use strict';
                        angular.module('totesApp').config(configureSecondLevelNavigation);
                        configureSecondLevelNavigation.$inject = ['ute.rogers.second.level.navigation.serviceProvider'];
                        /* @ngInject */
                        function configureSecondLevelNavigation(rogersNavigationProvider) {
                            rogersNavigationProvider.configure({
                                basic: {
                                    applicationId: 'Rogers.com',
                                    navigation: {
                                        iptvDashboard: {
                                            url: '/web/consumer/#/rogersSecondLevelNavigation'
                                        }
                                    }
                                }
                            });
                        }
                    })(integration = navigation.integration || (navigation.integration = {}));
                })(navigation = level.navigation || (level.navigation = {}));
            })(level = second.level || (second.level = {}));
        })(second = rogers.second || (rogers.second = {}));
    })(rogers = ute.rogers || (ute.rogers = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var semafone;
        (function (semafone) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureSemafoneService);
                configureSemafoneService.$inject = ['ute.semafone.service.configProvider', 'ute.blocks.environmentProvider'];
                /* @ngInject */
                function configureSemafoneService(semafoneServiceConfigProvider, environmentProvider) {
                    semafoneServiceConfigProvider.configure({
                        basic: {
                            semafoneParams: environmentProvider.getProperty('semafoneParams')
                        }
                    });
                }
            })(integration = semafone.integration || (semafone.integration = {}));
        })(semafone = rogers.semafone || (rogers.semafone = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureSimCard);
                    configureSimCard.$inject = ['ute.common.simcard.change.serviceProvider'];
                    /* @ngInject */
                    function configureSimCard(simCardServiceProvider) {
                        simCardServiceProvider.configure({
                            basic: {
                                applicationId: 'UTERogersOnline',
                                medium: 'WEB'
                            },
                            advanced: {
                                // TODO review after accountoverview refactoring
                                resolve: {
                                    /* @ngInject */
                                    permissionData: ['permissionResolver', function (permissionResolver) {
                                            return permissionResolver.getPermission('simCard'); // This is a state name, not a path
                                        }]
                                },
                                simCardChangeDirective: {}
                            }
                        });
                    }
                })(integration = change.integration || (change.integration = {}));
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = rogers.simcard || (rogers.simcard = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var simcard;
        (function (simcard) {
            var change;
            (function (change) {
                'use strict';
                var SimCardChangeUtils = (function () {
                    /* @ngInject */
                    function SimCardChangeUtils(simCardChangeService, accountOverviewFactory, userService, dtmService) {
                        var _this = this;
                        this.simCardChangeService = simCardChangeService;
                        this.accountOverviewFactory = accountOverviewFactory;
                        this.userService = userService;
                        this.dtmService = dtmService;
                        this.launchSimCardChangeModule = function (ban, ctn) {
                            var param;
                            if (_.get(_this.userService.getUser(), 'userType') === ute.common.user.UserType.care) {
                                param = { acctNbr: Number(ban) };
                            }
                            return _this.accountOverviewFactory(param).getSelectedAccount().then(function (selectedAccount) { return selectedAccount.getAccountOverviewSummary(); })
                                .then(function (accountSummary) {
                                var accountEmail = _.get(accountSummary, 'contactInfo.emailAddress', '');
                                _this.simCardChangeService.goToEntryState({
                                    phoneNumber: ctn,
                                    accountNumber: ban,
                                    accountEmail: accountEmail
                                });
                            });
                        };
                    }
                    SimCardChangeUtils.$inject = ['ute.common.simcard.change.service',
                        'ute.rogers.account.overview.factory',
                        'ute.common.user.service',
                        'ute.dtm.service'];
                    return SimCardChangeUtils;
                }());
                angular.module('totesApp').service('my.rogers.simcard.change.utils.service', SimCardChangeUtils);
            })(change = simcard.change || (simcard.change = {}));
        })(simcard = rogers.simcard || (rogers.simcard = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var suspend;
        (function (suspend) {
            var ctn;
            (function (ctn) {
                var integration;
                (function (integration) {
                    'use strict';
                    angular.module('totesApp').config(configureSuspendCtn);
                    configureSuspendCtn.$inject = ['ute.common.suspend.ctn.serviceProvider'];
                    /* @ngInject */
                    function configureSuspendCtn(suspendctnProvider) {
                        suspendctnProvider.configure({
                            basic: {
                                applicationId: 'UTERogersOnline',
                                medium: 'WEB'
                            },
                            advanced: {
                                // TODO review after accountoverview refactoring
                                resolve: {
                                    /* @ngInject */
                                    permissionData: ['permissionResolver', function (permissionResolver) {
                                            return permissionResolver.getPermission('suspendCtn'); // This is a state name, not a path
                                        }]
                                }
                            }
                        });
                    }
                })(integration = ctn.integration || (ctn.integration = {}));
            })(ctn = suspend.ctn || (suspend.ctn = {}));
        })(suspend = rogers.suspend || (rogers.suspend = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var usage;
    (function (usage) {
        var dial;
        (function (dial) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureUsageDial);
                configureUsageDial.$inject = ['ute.usage.dialProvider'];
                /* @ngInject */
                function configureUsageDial(usageDialServiceProvider) {
                    usageDialServiceProvider.configure({
                        basic: {
                            nominalColor: '#00955e',
                            warningColor: '#f2982a',
                            height: 250,
                            width: 250,
                            radius: 105,
                            strokeWidth: 13
                        }
                    });
                }
            })(integration = dial.integration || (dial.integration = {}));
        })(dial = usage.dial || (usage.dial = {}));
    })(usage = ute.usage || (ute.usage = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var user;
        (function (user) {
            var integration;
            (function (integration) {
                'use strict';
                angular.module('totesApp').config(configureUserService);
                configureUserService.$inject = ['ute.common.user.serviceProvider'];
                /* @ngInject */
                function configureUserService(userServiceProvider) {
                    userServiceProvider.configure({
                        advanced: {
                            signoutCallback: function ($injector) {
                                return $injector.get('user').logout(true);
                            }
                        }
                    });
                }
            })(integration = user.integration || (user.integration = {}));
        })(user = rogers.user || (rogers.user = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * Created by Muhammad Zubair on 4/12/2017.
 */
var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var anti;
        (function (anti) {
            var spam;
            (function (spam) {
                var legislation;
                (function (legislation) {
                    var integration;
                    (function (integration) {
                        'use strict';
                        var UteAntiSpamLegislationIntegrationController = (function (_super) {
                            __extends(UteAntiSpamLegislationIntegrationController, _super);
                            /* @ngInject */
                            function UteAntiSpamLegislationIntegrationController(antiSpamLegislationIntegrationService, languageSwitcher, userService, permissionsService, smToGenesisAuthService, $scope, $q) {
                                var _this = this;
                                _super.call(this, antiSpamLegislationIntegrationService);
                                this.antiSpamLegislationIntegrationService = antiSpamLegislationIntegrationService;
                                this.languageSwitcher = languageSwitcher;
                                this.userService = userService;
                                this.permissionsService = permissionsService;
                                this.smToGenesisAuthService = smToGenesisAuthService;
                                this.$scope = $scope;
                                this.$q = $q;
                                this.controllerName = this.antiSpamLegislationIntegrationService.getConfig().advanced.root.controllerName;
                                this.reInitializeAccountNumber = function (accountNumber) {
                                    var self = _this;
                                    var CASL_CEM_ALL = ute.common.permissions.service.UserPermissions.CASL_CEM_ALL;
                                    var CASL_CEM_LIMITED = ute.common.permissions.service.UserPermissions.CASL_CEM_LIMITED;
                                    //Get BRT switch options and based on values, call the API
                                    _this.$q.all({
                                        CASL_CEM_LIMITED: _this.permissionsService
                                            .getUserPermission(CASL_CEM_LIMITED)
                                            .then(function (isPermitted) {
                                            self.brtSwitchConfig.CASL_CEM_LIMITED = isPermitted;
                                        }),
                                        CASL_CEM_ALL: _this.permissionsService
                                            .getUserPermission(CASL_CEM_ALL)
                                            .then(function (isPermitted) {
                                            self.brtSwitchConfig.CASL_CEM_ALL = isPermitted;
                                        })
                                    }).then(function () {
                                        if (!self.brtSwitchConfig.CASL_CEM_LIMITED && !self.brtSwitchConfig.CASL_CEM_ALL) {
                                            self.brtSwitchConfig.CASL_HIDE_CEM_PREFERENCES = true;
                                            return;
                                        }
                                        self.antiSpamLegislationIntegrationService.accountNumber = accountNumber;
                                        self.getElectronicAddressesPreferences();
                                    });
                                };
                                this.languageSwitchHandler = function () {
                                    _this.selectedLanguage = _this.languageSwitcher.getCurrentLanguage();
                                    return null;
                                };
                                var watcher = this.$scope.$watch('accountNumber', function (newValue, oldValue) { _this.reInitializeAccountNumber(newValue); });
                                //This will be used in the service before sending calls to API
                                this.antiSpamLegislationIntegrationService.getXSessionToken = this.smToGenesisAuthService.getXSessionToken;
                                // Set selected language.
                                var self = this;
                                this.selectedLanguage = this.languageSwitcher.getCurrentLanguage();
                                languageSwitcher.registerOnDataChangeHandler(this.languageSwitchHandler, this.controllerName);
                                this.$scope.$on('$destroy', function () {
                                    languageSwitcher.unregisterOnDataChangeHandler(self.controllerName);
                                    watcher(); //n
                                });
                                //Register to sign out handler so we can kill the x-session-token from server as well as sessionstorage
                                this.userService.registerSignoutHandler(this.smToGenesisAuthService.killXSessionToken, this);
                            }
                            UteAntiSpamLegislationIntegrationController.$inject = [
                                'ute.anti.spam.legislation.service',
                                'ute.blocks.language.switcher',
                                'ute.common.user.service',
                                'ute.common.permissions.service',
                                'ute.sm.to.genesis.auth.service',
                                '$scope',
                                '$q'
                            ];
                            return UteAntiSpamLegislationIntegrationController;
                        }(ute.anti.spam.legislation.AntiSpamLegislationController));
                        angular
                            .module('totesApp')
                            .controller('ute.anti.spam.legislation.integration.controller', UteAntiSpamLegislationIntegrationController);
                    })(integration = legislation.integration || (legislation.integration = {}));
                })(legislation = spam.legislation || (spam.legislation = {}));
            })(spam = anti.spam || (anti.spam = {}));
        })(anti = rogers.anti || (rogers.anti = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));

var ute;
(function (ute) {
    var sm;
    (function (sm) {
        var to;
        (function (to) {
            var genesis;
            (function (genesis) {
                var auth;
                (function (auth) {
                    var service;
                    (function (service) {
                        var integration;
                        (function (integration) {
                            'use strict';
                            angular.module('totesApp').config(configureSmToGenesisAuthService);
                            configureSmToGenesisAuthService.$inject = ['ute.sm.to.genesis.auth.serviceProvider'];
                            /* @ngInject */
                            function configureSmToGenesisAuthService(smToGenesisAuthServiceProvider) {
                                smToGenesisAuthServiceProvider.configure({
                                    advanced: {
                                        apiUrl: {
                                            getXSessionToken: '/web/RogersServices.portal/totes/api/v1/siteminder-authc-svc',
                                            deleteXSessionToken: '/web/totes/web/genesis/api/stateservice/v1/'
                                        }
                                    }
                                });
                            }
                        })(integration = service.integration || (service.integration = {}));
                    })(service = auth.service || (auth.service = {}));
                })(auth = genesis.auth || (genesis.auth = {}));
            })(genesis = to.genesis || (to.genesis = {}));
        })(to = sm.to || (sm.to = {}));
    })(sm = ute.sm || (ute.sm = {}));
})(ute || (ute = {}));

var my;
(function (my) {
    var rogers;
    (function (rogers) {
        var anti;
        (function (anti) {
            var spam;
            (function (spam) {
                var legislation;
                (function (legislation) {
                    var integration;
                    (function (integration) {
                        'use strict';
                        angular.module('totesApp').config(configureAntiSpamLegislationProvider);
                        configureAntiSpamLegislationProvider.$inject = ['ute.anti.spam.legislation.serviceProvider'];
                        /* @ngInject */
                        function configureAntiSpamLegislationProvider(antiSpamLegislationProvider) {
                            antiSpamLegislationProvider.configure({
                                basic: {
                                    applicationId: 'Rogers.com',
                                    brand: 'Rogers',
                                    identifierType: 'AccountNumber'
                                },
                                baseApi: {
                                    getPreferences: '/web/totes/web/genesis/api/marketingpreferences-svc/v1/electronicAddressPreferences/',
                                    updatePreferences: '/web/totes/web/genesis/api/marketingpreferences-svc/v1/CEMPreferences?op=update'
                                }
                            });
                        }
                    })(integration = legislation.integration || (legislation.integration = {}));
                })(legislation = spam.legislation || (spam.legislation = {}));
            })(spam = anti.spam || (anti.spam = {}));
        })(anti = rogers.anti || (rogers.anti = {}));
    })(rogers = my.rogers || (my.rogers = {}));
})(my || (my = {}));



angular.module("totesApp").run(["$templateCache", function($templateCache) {$templateCache.put("404.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"utf-8\"><title>Page Not Found :(</title><style>\n      ::-moz-selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      ::selection {\n        background: #b3d4fc;\n        text-shadow: none;\n      }\n\n      html {\n        padding: 30px 10px;\n        font-size: 20px;\n        line-height: 1.4;\n        color: #737373;\n        background: #f0f0f0;\n        -webkit-text-size-adjust: 100%;\n        -ms-text-size-adjust: 100%;\n      }\n\n      html,\n      input {\n        font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n      }\n\n      body {\n        max-width: 500px;\n        _width: 500px;\n        padding: 30px 20px 50px;\n        border: 1px solid #b3b3b3;\n        border-radius: 4px;\n        margin: 0 auto;\n        box-shadow: 0 1px 10px #a7a7a7, inset 0 1px 0 #fff;\n        background: #fcfcfc;\n      }\n\n      h1 {\n        margin: 0 10px;\n        font-size: 50px;\n        text-align: center;\n      }\n\n      h1 span {\n        color: #bbb;\n      }\n\n      h3 {\n        margin: 1.5em 0 0.5em;\n      }\n\n      p {\n        margin: 1em 0;\n      }\n\n      ul {\n        padding: 0 0 0 40px;\n        margin: 1em 0;\n      }\n\n      .container {\n        max-width: 380px;\n        _width: 380px;\n        margin: 0 auto;\n      }\n\n      /* google search */\n\n      #goog-fixurl ul {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n      }\n\n      #goog-fixurl form {\n        margin: 0;\n      }\n\n      #goog-wm-qt,\n      #goog-wm-sb {\n        border: 1px solid #bbb;\n        font-size: 16px;\n        line-height: normal;\n        vertical-align: top;\n        color: #444;\n        border-radius: 2px;\n      }\n\n      #goog-wm-qt {\n        width: 220px;\n        height: 20px;\n        padding: 5px;\n        margin: 5px 10px 0 0;\n        box-shadow: inset 0 1px 1px #ccc;\n      }\n\n      #goog-wm-sb {\n        display: inline-block;\n        height: 32px;\n        padding: 0 10px;\n        margin: 5px 0 0;\n        white-space: nowrap;\n        cursor: pointer;\n        background-color: #f5f5f5;\n        background-image: -webkit-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -moz-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -ms-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        background-image: -o-linear-gradient(rgba(255,255,255,0), #f1f1f1);\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        *overflow: visible;\n        *display: inline;\n        *zoom: 1;\n      }\n\n      #goog-wm-sb:hover,\n      #goog-wm-sb:focus {\n        border-color: #aaa;\n        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n        background-color: #f8f8f8;\n      }\n\n      #goog-wm-qt:hover,\n      #goog-wm-qt:focus {\n        border-color: #105cb6;\n        outline: 0;\n        color: #222;\n      }\n\n      input::-moz-focus-inner {\n        padding: 0;\n        border: 0;\n      }\n    </style></head><body><div class=\"container\"><h1>Not found <span>:(</span></h1><p>Sorry, but the page you were trying to view does not exist.</p><p>It looks like this was the result of either:</p><ul><li>a mistyped address</li><li>an out-of-date link</li></ul><script>\n        var GOOG_FIXURL_LANG = (navigator.language || \'\').slice(0,2),GOOG_FIXURL_SITE = location.host;\n      </script><script src=\"//linkhelp.clients.google.com/tbproxy/lh/wm/fixurl.js\" async=\"\"></script></div></body></html>");
$templateCache.put("views/404.html","<div class=\"container page-not-found\"><div class=\"row\"><div class=\"col-md-12\"><span class=\"headline\" translate=\"myr.pageNotFound.404.headline\"></span> <span class=\"subhead\" translate=\"myr.pageNotFound.404.subhead\"></span><p translate=\"myr.pageNotFound.404.body\"></p><br><br><button data-ng-if=\"vm.isNoHistory\" class=\"cta-round\" data-ng-click=\"vm.gotoSignin()\" tabindex=\"0\"><span translate=\"myr.pageNotFound.404.buttonBackToSignin\"></span></button> <button data-ng-if=\"!vm.isNoHistory\" class=\"cta-round\" onclick=\"window.history.back()\" tabindex=\"0\"><span translate=\"myr.pageNotFound.404.button\"></span></button></div></div></div>");
$templateCache.put("views/editable-content-template.html","<div class=\"editable-content row {{skin}}\"><img ng-if=\"(isCare || isDealer) && !isProfileLoading && !editenable\" class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"><div class=\"heading-container\" ng-hide=\"(isCare || isDealer) && !editenable && !isProfileLoading\"><h1 ng-show=\"!generalError\">{{heading}}</h1><img ng-show=\"loading\" class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"> <span ng-if=\"(!currentPanelOpen && !loading && !generalError && !isReadOnly()) || ((isCare || isDealer) && isProfileLoading && !generalError)\"><span class=\"editButton\" ng-class=\"{\'edit-button-enabled\': repProfileUpdate && !isEditOpen(), \'no-pointer\': !editenable, \'grey-edit-icon\': (isCare || isDealer) && !editenable}\" ng-if=\"!(isCare || isDealer)\" ng-click=\"repProfileUpdate && ((editenable && (isCare || isDealer) && !isEditOpen() && edit()) || (isConsumer && !isEditOpen() && edit()))\"></span> <span class=\"edit-label\" ng-class=\"{\'edit-label-enabled\': repProfileUpdate && !isEditOpen(), \'no-pointer\': !editenable, \'grey-edit-color\': (isCare || isDealer) && !editenable}\" translate=\"_editlabel\" ng-if=\"!(isCare || isDealer)\" ng-click=\"repProfileUpdate && ((editenable && (isCare || isDealer) && !isEditOpen() && edit()) || (isConsumer && !isEditOpen() && edit()))\">Edit</span><span class=\"care-edit-button\" ng-if=\"(isCare || isDealer)\" ng-click=\"repProfileUpdate && (editenable && !isEditOpen() && edit())\"><i class=\"rui-icon-edit disabled-field\"></i> <span translate=\"ute.common.label.edit\"></span></span> <span ng-class=\"{\'grey-edit-color no-pointer\': !repProfileUpdate || (isGuidNotFound && isRepView && (isCare || isDealer) && !editenable)}\" ng-show=\"isRepView && (isCare) && !editenable && isProfileSection\" class=\"reset-pwd-label\" translate=\"one_view_reset_password\" ng-click=\"repProfileUpdate && !isGuidNotFound && !resetPwdSuccessStatus && openResetPasswordModal()\">Reset Password</span></span></div><div class=\"clear-both row info-banner error mts mbm\" style=\"margin-left: 0px;\" data-ng-show=\"generalError\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span translate=\"general_error\"></span></div></div><div ng-show=\"!generalError\" ng-include=\"contentUrl\" class=\"template-container\" ng-class=\"{isEditOpen: isEditOpen()}\"></div></div>");
$templateCache.put("views/genericErrorPopup.html","<div class=\"errorWrapper col-xs-11\"><div class=\"col-xs-1\"><img src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/warning.png\"></div><div class=\"col-xs-11\" style=\"padding-left:10px;\"><div class=\"errorLogo\" ng-if=\"errorTitle\"><span data-ng-bind-html=\"errorTitle\"></span></div><div class=\"errorContent\"><span data-ng-bind-html=\"errorMessage\"></span></div><div class=\"contactInfo\" ng-if=\"showChatCallIcon\" ute-user-hide-if-any-granted=\"care,careRep,dealer\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 phone_icon_parent\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 phone_icon\"><img class=\"phone_icon_img\" src=\"images/wirelessDash-popup_phone_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 phone_number_value\"><span translate=\"toll-free-number\" ng-if=\"!nacSaveStateRequest\"></span> <span translate=\"see_nac_toll-free-number\" ng-if=\"nacSaveStateRequest\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 phone_icon_parent\" ng-if=\"!nacSaveStateRequest\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 live_chat_icon\"><img class=\"live_chat_icon_img\" src=\"images/wirelessDash-popup_live_chat_icon.png\"><span>&nbsp;</span></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 live_chat_text\"><div class=\"live-chat-link\" ng-show=\"lng === \'en\'\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&amp;lctc=707%7C01%7Cws%7CHUP_landing%20en\" translate=\"mu_chat\" target=\"_blank\"></a></div><div class=\"live-chat-link\" ng-show=\"lng === \'fr\'\" target=\"_blank\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr\" translate=\"mu_chat\" target=\"_blank\"></a></div></div></div></div></div><div class=\"buttonWrapper col-xs-12\" ng-if=\"showButtons\"><button type=\"button\" class=\"btn btn-md btn-red\" ng-click=\"closeGenericErrorPopup()\" style=\"background-color:#da291c;color:#FFF;\"><span translate=\"_continue\"></span></button></div></div>");
$templateCache.put("views/greeting.html","<h2>hello!!!!!!!!!</h2>");
$templateCache.put("views/home.html","<div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\">^^^^ use the menu</div></div></div>");
$templateCache.put("views/invalidPath.html","<h1>invalid path</h1>");
$templateCache.put("views/languageSelector.html","<div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select class=\"form-control\" data-ng-model=\"selectedLanguage\" data-ng-change=\"changeLanguage()\" ng-options=\"key as value for (key, value) in languages\"></select></div></div>");
$templateCache.put("views/offers-page.html","<section class=\"page-one-view-dashboard\"><ute-actions-offers></ute-actions-offers></section>");
$templateCache.put("views/oneView.html","<section class=\"page-account-overview\"><div><div class=\"container\"><div class=\"ng-cloak\" data-ng-cloak=\"\"><myr-notification-banner class=\"ng-hide\" data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div><div class=\"ng-cloak\" data-ng-cloak=\"\"><myr-notification-banner class=\"ng-hide\" data-banner-id=\"successMessage\" type=\"success\"></myr-notification-banner></div></div><div class=\"top-bar-ctn\"><div class=\"container\"><div class=\"row pts top-bar\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><myr-account-list loading-brite-bill=\"ao.isLoadingBriteBill()\"></myr-account-list><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 row info-banner one-view-info-banner\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'error\' : \'warning - border\'\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon - alert\'\"></span></div><div ng-show=\"!ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line\" ng-bind-html=\"ao.als.selectedAccount.accountStatusError\" style=\"font-weight:normal\"></span></div><div ng-show=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line mbs\" translate=\"acc_overview_account_limited\" style=\"font-weight:normal\" data-test-id=\"myr-oneView-acc_overview_account_limited\"></span><br><span class=\"mtl\"><a ng-show=\"isbritebillAvailable\" class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\">- <span translate=\"acc_overview_view_bill\"></span></a><br><a ng-click=\"ao.viewHistory()\" class=\"pointer\">- <span translate=\"acc_overview_view_bill_history\"></span></a><br><a ng-hide=\"isDealer || isCare\" ng-click=\"ao.runRogersProfile()\" class=\"pointer\">- <span translate=\"acc_overview_manage_profile\" data-test-id=\"myr-oneView-acc_overview_manage_profile\"></span></a></span></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"acc_overview_my_acc_overview\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div><div ng-if=\"!ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row ptm\"><div data-ng-hide=\"ao.btnSettings.accountBalance === ao.btnStatus.hidden\" class=\"col-xs-12 col-sm-12 col-md-5 col-lg-4\" permission=\"VIEW_ACCOUNT_BALANCE\"><myr-account-balance view-html=\"accountBalance.html\" loading-brite-bill=\"ao.isLoadingBriteBill()\"></myr-account-balance></div></div><div class=\"row my-services-list-ctn\"><div data-ng-hide=\"ao.btnSettings.allSubscriptions === ao.btnStatus.hidden\"><myr-my-services></myr-my-services></div></div></div><div ng-if=\"(ao.mss.selectedAccountDetail.isPrepaid || isPrepaid)\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div ng-show=\"!loadingDataIndicator && !isDetailsNotFound\"><myr-account-balance permission=\"VIEW_ACCOUNT_BALANCE\" view-html=\"accountBalance.html\" loading-brite-bill=\"ao.isLoadingBriteBill()\"></myr-account-balance></div></div><div class=\"col-xs-12 col-sm-12 col-md-1 col-lg-1\"></div><div data-ng-hide=\"loadingDataIndicator || ao.mss.isDetailsNotFound\" nclass=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><h1 class=\"primary-color mbl\"></h1><div><myr-my-services mode=\"\'mobile\'\"></myr-my-services></div></div></div></div><div class=\"container\"><div class=\"row redHeadline mbm ptm\" ng-show=\"!ao.mss.isDetailsNotFound\"><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"title-h2\" data-test-id=\"myr-oneView-acc_overview_other_services\"><span class=\"account-other-services-heading primary-color\" translate=\"acc_overview_other_services\"></span> <span class=\"widget-loader-inline account-other-services\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div><div class=\"row ptm other-services-list-ctn\" ng-show=\"(!ao.mss.loadingData && !ao.mss.isDetailsNotFound)\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in ao.mss.myOtherServicesListFinal| filter:{isVisible:true} track by $index\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-hide=\"msl.id === \'Rogers Bank\' || msl.id === \'NHL (GCL)\' || msl.id === \'Shomi\'\"><div class=\"other-service-title\" data-ng-class=\"btnSettings.otherAvailableServices === btnStatus.disabled ? \'not-active\' : \'\'\" name=\"preCleanCall\"><h5 class=\"get-services-link\"><span translate=\"{{msl.title}}\"></span></h5></div><div ng-show=\"msl.id === \'Rogers Smart Home Monitoring\'\"><span ng-bind-html=\"rhmMsg\"></span></div><div ng-show=\"msl.id === \'CTN\'\"><span translate=\"log_in_to_oasys_or_ssp\"></span></div><div ng-show=\"(msl.id != \'Rogers Smart Home Monitoring\') && (msl.id === \'Hi-Speed Internet\' || msl.id === \'Digital TV\' || msl.id === \'RHPc\')\"><span translate=\"log_in_to_sgi\"></span></div></div></div></div></div></div></div></div></section>");
$templateCache.put("views/oneViewInterface.html","<div class=\"sso-error-page\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"sso-error-container\" ng-show=\"isSSOFailure\"><div class=\"sso-error-heading\"><strong translate=\"unable_to_sign_on\"></strong></div><div class=\"sso-error-description\"><span translate=\"sso_failure_description\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isSessionTimeOut\"><div class=\"sso-error-heading\"><strong translate=\"session_timeout_error_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"session_timeout_error_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isGenericError\"><div class=\"sso-error-heading\"><strong translate=\"generic_error_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"generic_error_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isCareSignout\"><div class=\"sso-error-heading\"><strong translate=\"crm_signout_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"crm_signout_message\"></span></div></div></div></div></div></div>");
$templateCache.put("views/oops.html","<div class=\"page-registration\"><div class=\"container\"><h1 translate=\"_something_went_wrong\"></h1><ul ng-repeat=\"error in $parent.errorsStack track by $index\"><li><strong>{{error.dateTime}} : {{error.message}}</strong></li><li><strong>Account:</strong><ul><li>Account Number: {{error.account.accountNumber}}</li><li>Account Type: {{error.account.accountTypeNumber}}</li><li>Account Status: {{error.account.accountStatus}}</li><li>Account Status Simple: {{error.account.accountStatusSimple}}</li></ul></li><li><strong>System Information:</strong><ul><li>Browser CodeName: {{error.systemInfo.appCodeName}}</li><li>Browser Name: {{error.systemInfo.appName}}</li><li>Browser Version: {{error.systemInfo.appVersion}}</li><li>Cookies Enabled: {{error.systemInfo.cookieEnabled}}</li><li>Platform: {{error.systemInfo.platform}}</li><li>User-agent header: {{error.systemInfo.userAgent}}</li></ul></li><li><strong style=\"color:#FF0000\">URL:</strong>{{error.url}}</li><li><strong>Call stack:</strong><ul ng-repeat=\"call in error.stack track by $index\"><li>{{call}}</li></ul></li></ul></div></div>");
$templateCache.put("views/page.html","<timer end-time=\"agentExpiry\" ng-if=\"agentExpiry\" class=\"ng-hide\" data-ng-cloak=\"\">{{minutes}}:{{seconds}}</timer><section globalloader=\"content\" style=\"margin-botton:90px;\"><div ui-view=\"\"></div><ssp-dashboard></ssp-dashboard><rep-feedback></rep-feedback></section>");
$templateCache.put("views/permissionDenied.html","<div data-ng-controller=\"permissionDeniedCtrl\"><center><h1>Permission Denied</h1><h5>- Detail message here -</h5></center></div>");
$templateCache.put("views/pre-registration.html","<div data-ng-controller=\"preRegistrationCtrl\"><form name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-12\"><label><span translate=\"_first_name\"></span>: <input type=\"text\" name=\"firstName\" data-ng-model=\"firstName\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span translate=\"_last_name\"></span>: <input type=\"text\" name=\"lastName\" data-ng-model=\"lastName\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span translate=\"_email\"></span>: <input type=\"text\" name=\"email\" data-ng-model=\"email\" required=\"\"></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><label><span translate=\"_lang\"></span>:<select name=\"language\" data-ng-model=\"language\" required=\"\" ng-options=\"key as value for (key, value) in languages\"><option></option></select></label></div></div><div class=\"row\"><div class=\"col-lg-12\"><button data-ng-click=\"submit()\"><span translate=\"_submit\"></span></button></div></div></form></div>");
$templateCache.put("views/suspended.html","<div class=\"page-wireless page-registration\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div><validation-error-box error-message=\"\'_suspended_service\' | translate\"></validation-error-box></div></div></div></div></div>");
$templateCache.put("views/track-repair-modal.html","<div class=\"main-modal totes-project track-repair\"><div class=\"close-gray-cross\"><img src=\"ute-common-assets/assets/cross-grey.png\" alt=\"{{ trackRepairClaim.close_alt_text }}\" ng-click=\"close()\" style=\"height: 20px;\" role=\"button\"></div><div><h3 class=\"heading\" data-translate=\"trackRepairClaim.heading\"></h3><p class=\"subheading\" data-translate=\"trackRepairClaim.body\"></p></div><div class=\"buttonWrapper col-xs-12\"><div class=\"repair-modal-close\"><a ng-click=\"close()\"><span translate=\"close\"></span></a></div><button type=\"button\" class=\"btn btn-md btn-red\" ng-click=\"startPhoneRepairClaim()\" style=\"background-color:#da291c;color:#FFF;\"><span translate=\"_continue\"></span></button></div></div>");
$templateCache.put("views/localization/acceptable-use-policy-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">POLITIQUE D\'UTILISATION ACCEPTABLE</p><p>Veuillez présenter toute question ou tout commentaire concernant la présente Politique d\'utilisation acceptable (« <strong>PUA</strong> »), ainsi que vos plaintes pour manquements à la présente Politique d\'utilisation acceptable par des abonnés, à l\'adresse abuse@rogers.com. À moins de mention contraire, « <strong>vous</strong> » et « <strong>votre</strong> » font référence à vous et à toute personne qui utilise le Service par l\'entremise de votre compte.</p><p class=\"tc-headline1\">Introduction</p><p>Lors de l\'utilisation de nos services, de l\'Équipement qui s\'y rattache, de nos installations, de nos réseaux ou de tout produit, contenu, application ou service utilisé en conjonction avec les Services ou l\'Équipement, vous devez respecter toutes les lois en vigueur ainsi que nos politiques, nos règles et nos limites, notamment la présente PUA. La présente Politique d\'utilisation acceptable fait partie intégrante des Modalités de service de Rogers (les « <strong>Modalités</strong> ») qui accompagnent la Politique d’utilisation acceptable. Elle est également disponible sur le site <a href=\"http://www.rogers.com/modalites\">http://www.rogers.com/modalites</a>. À moins de mention contraire définie dans la présente PUA, les termes définis ont la signification qui leur a été donnée dans les Modalités.</p><p><strong>SI VOUS N\'ACCEPTEZ PAS D\'ÊTRE LIÉ PAR LES PRÉSENTES MODALITÉS ET PAR LA PRÉSENTE PUA, TELLES QUE MODIFIÉES DE TEMPS À AUTRE, VOUS DEVREZ IMMÉDIATEMENT CESSER D\'UTILISER LES SERVICES ET AVISER ROGERS QUE VOUS RÉSILIEZ LES SERVICES.</strong></p><p class=\"tc-headline1\">Activités interdites</p><p>Sans limiter la généralité de ce qui précède, vous ne pouvez utiliser (ou permettre à quiconque d\'utiliser) nos Services pour :</p><ol type=\"i\"><li>utiliser, posséder, afficher, télécharger, transmettre, distribuer ou rendre disponible de quelque façon du contenu illégal ou violant des droits d\'auteur ou des droits de propriété intellectuelle d\'autres personnes (tel que décrit plus en détail ci-dessous);</li><li>participer à des activités de sollicitation ou de jeux illégaux;</li><li>tenter d\'utiliser les Services de façon à éviter l\'application des frais d\'utilisation;</li><li>participer à des activités frauduleuses, notamment en se faisant passer pour une autre personne ou entité ou en forgeant la signature numérique ou manuelle d\'une autre personne. C\'est vous qui assumez tous les risques associés à la détermination de l\'appartenance ou non au domaine public de tout matériel;</li><li>accéder à Internet par le biais des Services en utilisant une adresse autre que l\'adresse IP (protocole Internet) que nous vous avons attribuée;</li><li>violer la vie privée d\'une autre personne; recueillir ou enregistrer des données personnelles au sujet des autres utilisateurs; menacer ou harceler une autre personne ou une autre entité;</li><li>accéder à un ordinateur, des logiciels, des données ou tout autre matériel confidentiel, protégé par droit d\'auteur ou par brevet de toute autre personne, sans la connaissance et le consentement d\'une telle personne, ou encore utiliser un outil conçu pour faciliter un tel accès, comme des « <strong>espions de paquets</strong>»;</li><li>télécharger, diffuser, publier, altérer, modifier, transmettre, reproduire ou distribuer de quelque façon que ce soit de l\'information, des logiciels ou d\'autres éléments protégés par droit d\'auteur ou en vertu de droits de propriété ou contractuels (comme une entente de non-divulgation), ou tous travaux dérivés connexes, sans avoir obtenu au préalable la permission du titulaire des droits d\'auteur ou des droits de propriété;</li><li>utiliser, reproduire, distribuer, vendre, revendre ou exploiter les Services ou le contenu que nous offrons ou que vous obtenez en vertu des Services à des fins commerciales;</li><li>copier, distribuer, offrir en sous-licence ou rendre disponible de quelque autre façon un logiciel ou du contenu que nous vous fournissons ou rendu disponible par les Services, à moins d\'avoir obtenu notre autorisation;</li><li>altérer, reproduire ou modifier les Services ou quelque fonction, composante ou élément d\'identification de votre Équipement, comme le numéro de série électronique (NSÉ) ou le code d\'identification d\'équipement sans fil international (IMEI) n\'étant pas destiné à être altéré, reproduit ou modifié;</li><li>restreindre, entraver ou perturber la capacité de quiconque à accéder à Internet, aux Services ou à l\'Équipement utilisés, à les utiliser ou à en profiter pour se raccorder aux Services, ou créer un fardeau inhabituel sur nos réseaux, y compris, sans toutefois s\'y limiter, en diffusant, téléchargeant, transmettant ou rendant disponible de quelque façon que ce soit de l\'information ou des logiciels contenant un virus, un verrou, une clé, une bombe, un ver, un cheval de Troie ou une autre fonction nuisible, contraignante, destructrice ou débilitante; distribuer des courriels de masse non sollicités (« <strong>pourriel</strong> ») ou autres messages; ou générer de quelque autre façon que ce soit un volume de trafic suffisant pour nuire à la capacité des autres à transmettre ou à recevoir de l\'information; ou encore utiliser les Services de façon abusive en liaison avec des forfaits, des options ou des promotions permettant une utilisation illimitée;</li><li>perturber un réseau de dorsale ou un service de réseau, ou restreindre, bloquer, perturber ou entraver de quelque autre façon que ce soit nos transmissions, nos données ou notre capacité à surveiller ou à offrir les Services;</li><li>nuire à un réseau informatique ou à un service de télécommunications d\'un autre utilisateur sur Internet, d\'un système hôte, d\'un fournisseur de service ou d\'un réseau, incluant, sans toutefois s\'y limiter, les attaques par saturation, la surcharge d\'un service, l\'appropriation ou l\'abus des privilèges d\'opérateur (« <strong>piratage</strong>»), ou toute tentative de « <strong>blocage</strong> » d\'un système hôte;</li><li>utiliser les Services à quelque fin autre que des fins personnelles (comme pour la revente des Services, la fourniture d\'un accès Internet ou d\'autres caractéristiques des Services à une tierce personne) ou encore partager ou transférer vos Services à moins d\'avoir obtenu notre consentement explicite à cet effet;</li><li>exploiter un serveur en liaison avec les Services, incluant, sans toutefois s\'y limiter, les serveurs de courriel, de nouvelles, de fichiers, Gopher, Telnet, de clavardage, Web ou autre configuration d\'hôte, la diffusion multimédia continue ou les forums interactifs multiutilisateurs;</li><li>usurper l\'identité d\'une personne ou d\'une entité, y compris celle d’un représentant de Rogers, d’un animateur de forum, d’un guide ou d’un hôte, ou faire des déclarations trompeuses sur les liens qui vous unissent à une personne ou à une entité;</li><li>contrefaire des en-têtes ou manipuler de quelque autre façon que ce soit des éléments d\'identification afin de masquer l\'origine d\'un élément de contenu transmis par le biais des Services; ou</li><li>balayer les ports de l\'ordinateur ou le sans-fil d\'une personne sans le consentement de cette personne, ou utiliser des outils conçus pour favoriser de telles opérations de balayage.</li></ol><p class=\"tc-headline1\">Contenu illégal ou non approprié</p><p>Toute Partie de Rogers se réserve le droit de déplacer, de retirer et de refuser d\'afficher tout élément de contenu, en tout ou en partie, si elle juge, à sa seule discrétion, que ceux-ci sont inacceptables, indésirables ou en contravention avec les Modalités ou la présente PUA. Cela comprend, sans toutefois s’y limiter :</p><ol type=\"i\"><li>le contenu obscène, injurieux ou pornographique;</li><li>les déclarations diffamatoires, frauduleuses ou trompeuses;</li><li>les menaces, l\'intimidation, le langage abusif ou le harcèlement;</li><li>le contenu violant les droits à la vie privée ou les droits de propriété intellectuelle d\'autres personnes;</li><li>le contenu incitant à la haine ou qui en fait la promotion de façon illégale;</li><li>le contenu jugé offensant ou non pertinent de quelque autre façon; ou</li><li>toute transmission représentant ou encourageant une conduite pouvant constituer une infraction criminelle, qui pourrait donner lieu à une poursuite au civil ou qui viole de quelque autre façon une loi, un décret ou un règlement municipal, provincial, fédéral ou international.</li></ol><p>Pour les fins de la présente PUA, « <strong>contenu</strong> » réfère à toutes les formes de communication incluant, sans toutefois s\'y limiter, le texte, les graphiques (y compris les photographies, les illustrations, les images, les dessins, les logos), les programmes exécutables, les enregistrements audiovisuels et les enregistrements audio.</p><p class=\"tc-headline1\">Sécurité</p><p>Tel que stipulé ci-dessus, vous êtes seul responsable de toute mauvaise utilisation des Services, par vous ou par une autre personne ayant accès aux Services au moyen de votre Équipement ou de votre compte. Par conséquent, vous devez prendre des mesures pour vous assurer que personne ne peut avoir un accès non autorisé aux Services par le biais de quelque moyen que ce soit, incluant, sans toutefois s\'y limiter, les réseaux sans fil et les réseaux à fil. Les Services ne peuvent être utilisés pour contourner les mesures de sécurité des autres utilisateurs ou tenter d\'accéder à l\'équipement, aux logiciels ou aux données d\'une autre personne, sans la connaissance et le consentement d\'une telle personne. En outre, les Services ne peuvent être utilisés de quelque façon que ce soit pour se soustraire aux mesures d\'authentification ou de sécurité d\'un système hôte, d\'un réseau ou d\'un compte, y compris, sans toutefois s\'y limiter, pour accéder à des données qui ne vous sont pas destinées, pour faire une ouverture de session sur un serveur ou pour utiliser un serveur ou un compte pour lequel vous n\'avez pas d\'accès expressément autorisé, ou encore pour sonder la vulnérabilité des autres réseaux. L\'utilisation ou la distribution d\'outils pour compromettre la sécurité, comme des programmes de recherche de mots de passe, des outils d\'intrusion, des espions de paquets ou des outils de sondage de réseau, est interdite. Vous ne pouvez pas perturber les Services. Les Services ne peuvent être utilisés non plus pour nuire à un réseau informatique ou à des services de télécommunications offerts à un autre utilisateur, à un serveur ou à un réseau, y compris, sans toutefois s\'y limiter, les attaques de refus de service, l\'engorgement d\'un réseau, la surcharge d\'un service, l\'appropriation ou l\'abus des privilèges d\'opérateur, ou toute tentative de « <strong>blocage</strong> » d\'un système hôte. La transmission ou la dissémination de renseignements ou de logiciels contenant un virus ou une autre fonction nocive est également interdite. Vous êtes seul responsable de la sécurité des dispositifs que vous choisissez de raccorder aux Services, y compris les données qui y sont enregistrées. En particulier, Rogers vous recommande de ne pas activer le partage de fichiers ou d\'imprimante de quelque façon que ce soit. Rogers recommande que tous les fichiers ou les services que vous choisissez de rendre disponibles pour l\'accès à distance soient protégés par un bon mot de passe ou une autre méthode appropriée. Vous acceptez de traiter de façon confidentielle tous les codes d’accès, numéros d’identification personnels et (ou) autres mots de passe que nous vous fournissons pour vous permettre d’utiliser les Services.</p><p class=\"tc-headline1\">Communications non sollicitées</p><p>Comme il est stipulé ci-dessus, les Services ne peuvent être utilisés pour faire parvenir des messages non sollicités, des messages en lots ou des messages commerciaux ou pour transmettre toute autre communication non sollicitée. Ceci comprend, sans toutefois s’y limiter, l’utilisation de dispositifs de composition et d\'annonce automatique (ADAD) pour effectuer des appels téléphoniques et télécopies à des fins de sollicitation, d’envois en lots non sollicités de publicité commerciale, d’annonces d\'information, de demandes de dons de charité, de pétitions et de messages politiques ou religieux. De telles communications peuvent être envoyées uniquement à des personnes qui en ont fait la demande explicite. Les Services ne peuvent être utilisés pour envoyer des messages à toute personne ayant indiqué qu\'elle ne désirait pas recevoir de messages de votre part. Les Services ne peuvent être utilisés pour recueillir des réponses à des courriels non sollicités envoyés à partir de comptes provenant d\'autres serveurs sur Internet ou d\'autres services de courriel qui ne respectent pas la présente Politique d\'utilisation acceptable ou la politique d\'utilisation acceptable d\'un autre fournisseur de service Internet. En outre, les courriels non sollicités ne doivent pas inviter les destinataires à consulter un site Web ou une autre ressource utilisant les Services. La contrefaçon, la modification et le retrait des en-têtes de courriel sont interdits. Vous ne pouvez pas faire référence à un réseau de Rogers (par exemple, en incluant la mention « Organisation : Rogers » dans l\'en-tête de vos messages ou en indiquant une adresse IP appartenant a un réseau de Rogers) dans tout courriel non sollicité, même si ce courriel n\'est pas envoyé par le biais d’un réseau de Rogers. Le « <strong>bombardement de courriel</strong> » est interdit. C\'est-à-dire que vous ne pouvez pas envoyer plusieurs copies d\'un même message ou de messages similaires, ni envoyer de très gros messages ou de très gros fichiers à un destinataire dans le but de perturber un serveur ou un compte. La propagation de chaînes de lettres est également interdite, que le destinataire désire ou non recevoir de tels envois. Rogers n’est pas responsable du réacheminement des courriels envoyés à un compte suspendu ou résilié. De tels courriels seront retournés à l\'expéditeur, ignorés, supprimés ou alors enregistrés temporairement, à la seule discrétion de Rogers.</p><p class=\"tc-headline1\">Services de contenu généré par l\'utilisateur</p><p>Les « <strong>Services de contenu généré par l’utilisateur</strong> » font référence à tout Service qui permet à un utilisateur d’afficher, de télécharger ou de générer du contenu en ligne dans le but de le partager avec un nombre limité ou illimité de destinataires et peut comprendre, sans toutefois s’y limiter, les groupes de discussion, forums en ligne, babillards électroniques, programmes de clavardage, articles wiki, Services de partage de photos, forums de consommateurs, Services de partage de vidéos, carnets et l’hébergement Web.</p><p>Tout accès aux Services de contenu généré par l’utilisateur par l’entremise des Services doit respecter les points suivants :</p><ol type=\"i\"><li>vous devez respecter la charte écrite qui régit les Services de contenu généré par l’utilisateur, les politiques et la liste des questions fréquentes;</li><li>vous pouvez afficher des messages de publicité, de sollicitation ou autres messages commerciaux dans le cadre des Services de contenu généré par l’utilisateur seulement si la charte, les politiques ou la liste des questions fréquentes qui régissent ces services le permettent de façon explicite;</li><li>vous êtes responsable de connaître les politiques relatives aux Services de contenu généré par l’utilisateur avant de les utiliser;</li><li>vous devez vous conformer aux restrictions en matière de volume quotidien, de taille des fichiers et de format de tous les Services de contenu généré par l’utilisateur;</li><li>à moins de mention contraire dans la charte, les politiques ou la liste des questions fréquentes relatives aux Services de contenu généré par l’utilisateur, vous ne pouvez pas contrefaire, modifier ou supprimer quelque information que ce soit d’un Service de contenu généré par l’utilisateur;</li><li>les Parties de Rogers n’ont aucune obligation que ce soit de surveiller le contenu des Services de contenu généré par l’utilisateur et les Parties de Rogers ne peuvent pas être tenues responsables en cas de réclamation, perte, action en justice, procédure, poursuite, responsabilité, dommages, règlements, pénalités, amendes, coûts et dépenses associés de quelque façon que ce soit au contenu de tels Services;</li><li>vous ne pouvez pas utiliser les Services de contenu généré par l’utilisateur pour les « <strong>engorger</strong>», c\'est-à-dire, utiliser l\'application de mesures délibérées et répétitives en succession rapide pour remplir les écrans des autres utilisateurs d\'Internet avec du texte ou autre contenu;</li><li>tout ordinateur ou appareil raccordé par les Services ne peut maintenir plus de deux connexions de clavardage simultanées, et couvre, sans toutefois s’y limiter, l\'utilisation de programmes automatisés, comme des « <strong>robots</strong>» ou des « <strong>clones</strong> ». les programmes automatisés ne peuvent être utilisés lorsque le titulaire du compte n\'est pas présent physiquement à proximité de l\'appareil;</li><li>vous ne pouvez pas utiliser les Services pour envoyer des messages perturbant l\'équipement d\'un autre utilisateur d\'Internet, notamment ses logiciels, son matériel et ses affichages; et</li><li>vous ne pouvez pas contrefaire, modifier ou dissimuler votre identité (autrement que par l\'utilisation d\'un pseudonyme) lors de votre participation aux Services de contenu généré par l’utilisateur.</li></ol><p class=\"tc-headline1\">Bande passante, enregistrement des données et autres limites</p><p>Vous devez respecter les normes de bande passante, d\'enregistrement des données et les autres limites en vigueur pour les Services concernés. Vous devez également vous assurer que vos activités n\'entraînent aucune restriction, limitation ou dégradation indue de l\'utilisation des Services par les autres abonnés, et ne représentent pas (à la seule discrétion de Rogers) un fardeau excessif sur nos réseaux. En outre, vous devez vous assurer que vos activités n\'entraînent pas de restriction, de limitation, de perturbation, de dégradation ou d\'entrave indue à la capacité de Rogers à livrer et à surveiller les Services, et à faire enquête sur les Services, le réseau de base, les nœuds de réseau et (ou) les autres services ou composantes du réseau. Vous ne pouvez pas revendre, partager ou distribuer de quelque autre façon que ce soit les Services ou toute portion de ceux-ci à une tierce partie, à moins d\'avoir obtenu le consentement écrit de Rogers. Par exemple, vous ne pouvez pas offrir un accès Internet à d\'autres au moyen d\'une connexion téléphonique, héberger des comptes regroupés sur Internet, fournir des services de courriel ou des services de nouvelles, ou encore transmettre des fils de presse. Les Services sont des produits destinés au grand public, conçus pour offrir un accès et une utilisation personnels du réseau Internet. Par exemple, les Services n\'offrent pas le type de sécurité, de rendement en amont et de capacité de débit total en aval généralement associés à une utilisation commerciale. Vous ne pouvez pas exploiter un serveur en liaison avec les Services. Vous ne pouvez pas offrir de services de réseau à d\'autres utilisateurs par le biais des Services. En outre, il est interdit d\'exploiter des serveurs de courriel, http, ftp, irc et dhcp, ou encore des forums interactifs multiutilisateurs.</p><p>L’utilisation de vos Services peut être assortie d\'une limite d\'utilisation, telle que définie dans votre Entente de service. Si vous dépassez la limite définie par votre forfait, des frais d\'utilisation supplémentaire pourront être exigés. Consultez <a href=\"http://www.rogers.com/limiteutilisation\">http://www.rogers.com/limiteutilisation</a> pour connaître la limite d’utilisation actuelle de vos Services.</p><p class=\"tc-headline1\">Gestion du réseau</p><p>Nous nous réservons le droit de gérer nos réseaux dans le but d’optimiser leur efficacité au profit de nos abonnés, en prenant notamment des dispositions concernant ce qui suit, sans s’y limiter : limite de débit (vitesse), rejet ou suppression des pourriels ou de tout autre courriel non sollicité, processus antivirus et filtrage des protocoles. Nous pourrons aussi prendre toute autre mesure selon ce que nous jugeons approprié pour assurer à tous les abonnés une expérience sans faille sur notre réseau.<strong></strong>Pour obtenir de plus amples renseignements au sujet de nos pratiques de gestion de réseau, consultez <a href=\"http://www.rogers.com/politiquereseau\">http://www.rogers.com/politiquereseau</a>.</p><p class=\"tc-headline1\">Manquements à la présente Politique d\'utilisation acceptable</p><p>Tel que stipulé dans les Modalités, nous avons le droit, mais non l\'obligation, de surveiller tous les éléments de contenu transmis à l\'aide des Services (à l’exception des Services de transmission de la voix) ou de l\'Équipement, et de faire enquête sur ceux-ci; et d\'accéder au contenu ou à l’information et de les conserver conformément aux Modalités. Nous préférons aviser les abonnés de tout comportement inapproprié pour leur permettre d\'appliquer les mesures correctrices nécessaires. Toutefois, si les Services sont utilisés d\'une façon qui, selon nous et à notre seule discrétion, représente un manquement à la présente Politique d\'utilisation acceptable, toute Partie de Rogers peut prendre des mesures de réaction qu\'elle jugera appropriées. De telles mesures peuvent comprendre, sans toutefois s\'y limiter, le retrait temporaire ou permanent du contenu, l\'annulation des éléments publiés dans les groupes de discussion, le filtrage des transmissions Internet et (ou) la suspension ou la résiliation immédiate de la totalité ou d\'une portion des Services ou de votre compte. Les Parties de Rogers n\'auront aucune responsabilité relativement à de telles mesures de réaction. Les mesures décrites ci-dessus ne sont pas les seuls recours possibles, et les Parties de Rogers peuvent utiliser d\'autres recours légaux ou mesures techniques jugés appropriés. Sur résiliation d\'un compte, toute Partie de Rogers est autorisée à supprimer les fichiers, les programmes, les données et les messages électroniques associés à un tel compte. Notre défaut à faire appliquer la présente Politique d\'utilisation acceptable, pour quelque raison que ce soit, ne doit pas être considéré comme une renonciation de quelque droit que ce soit à le faire par la suite en tout temps. Si une portion de la présente Politique d\'utilisation acceptable s\'avère invalide ou inapplicable, cette portion sera modifiée de façon à être conforme aux lois applicables, de façon aussi fidèle que possible, et les autres portions conserveront leur pleine force et demeureront en vigueur. La présente PUA doit être établie et régie conformément aux dispositions de la loi en vigueur stipulées dans les Modalités.</p><p class=\"tc-headline1\">Plaintes</p><p>Veuillez présenter toute plainte concernant un manquement à la présente Politique d\'utilisation acceptable à l\'adresse abuse@rogers.com ou encore au 1-888-ROGERS1. Les questions ou les plaintes concernant le contenu d\'une tierce partie doivent être adressées au fournisseur de contenu en question.</p><p>MD Rogers Communications inc. © 2007-2015.</p><p>06/10</p>");
$templateCache.put("views/localization/acceptable-use-policy.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">ACCEPTABLE USE POLICY</p><p>Please direct any questions or comments regarding this Acceptable Use Policy (<strong>“AUP”</strong>) and complaints of violations of this AUP by subscribers to <strong>abuse@rogers.com.</strong>Except where otherwise indicated, <strong>“you”</strong>and <strong>“your”</strong>means you and every person who uses the Services through your account.</p><p class=\"tc-headline1\"><strong>Introduction</strong></p><p>When using our services, the Equipment, our facilities or networks and any products, content, applications or services in conjunction with the Services or Equipment, you must comply with all applicable laws, and our policies, rules and limits including this AUP. This AUP supplements and is incorporated into the Rogers Terms of Service (the “<strong>Terms</strong>”), which accompanies this AUP. It is also available at <strong>http://www.rogers.com/terms.</strong>Unless otherwise defined in this AUP, defined terms have the meanings given to them in the Terms. <strong>IF YOU DO NOT AGREE TO BE BOUND BY THE TERMS AND THIS AUP, AS AMENDED FROM TIME TO TIME, YOU SHOULD IMMEDIATELY STOP USING THE SERVICES AND NOTIFY ROGERS THAT YOU ARE TERMINATING THE SERVICES.</strong></p><p class=\"tc-headline1\"><strong>Prohibited Activities</strong></p><p>Without limitation, you may not use (or allow anyone else to use) our Services to:</p><ol type=\"i\"><li>use, possess, post, upload, transmit, disseminate or otherwise make available content that is unlawful or violates the copyright or other intellectual property rights of others (as described in more detail below);</li><li>participate in any illegal soliciting or gaming schemes;</li><li>attempt to use the Services in such a manner so as to avoid incurring charges for usage;</li><li>participate in any fraudulent activities, including impersonating any person or entity or forging anyone else’s digital or manual signature. You assume all risks regarding the determination of whether material is in the public domain;</li><li>access the Internet via the Services using Internet Protocol (IP) addresses other than the IP address(es) assigned to you by us;</li><li>invade another person’s privacy, collect or store personal data about other users, or stalk or harass another person or entity;</li><li>access any computer, software, data or any confidential, copyright-protected or patent-protected material of any other person, without the knowledge and consent of that person, or use any tools designed to facilitate access, such as <strong>“packet sniffers”</strong>;</li><li>upload, post, publish, deface, modify, transmit, reproduce, distribute in any way or otherwise make available information, software or other material protected by copyright or other proprietary or contractual right (such as a non-disclosure agreement) or related derivative works, without obtaining permission of the copyright owner or rightholder;</li><li>use, reproduce, distribute, sell, resell or otherwise exploit the Services or content we provide or which you obtain through the Services for any commercial purposes;</li><li>copy, distribute, sub-license or otherwise make available any software or content we provide or make available to you or which you obtain through the Services, except as authorized by us;</li><li>alter, reproduce, or tamper with the Services or any function, component or identifier of your Equipment, such as the Electronic Serial Number (ESN) or the International Mobile Equipment Identity (IMEI) that is not meant to be altered, reproduced or tampered with;</li><li>restrict, inhibit or interfere with the ability of any person to access, use or enjoy the Internet, the Services or any Equipment used to connect to the Services, or create an unusually large burden on our networks, including, without limitation, posting, uploading, transmitting or otherwise making available information or software containing a virus, lock, key, bomb, worm, Trojan horse or other harmful, limiting, destructive or debilitating feature, distributing mass or unsolicited e-mail (<strong>“spam”</strong>) or other messages, or otherwise generating levels of traffic sufficient to impede others’ ability to send or retrieve information, or to use the Services in an abusive manner in connection with any unlimited packages, options or promotions;</li><li>disrupt any backbone network nodes or network service, or otherwise restrict, inhibit, disrupt or impede our ability to monitor or deliver the Services, any transmissions or data;</li><li>interfere with computer networking or telecommunications service to or from any Internet user, host, provider or network, including, without limitation, denying service attacks, overloading a service, improperly seizing or abusing operator privileges (<strong>“hacking”</strong>), or attempting to <strong>“crash”</strong>a host;</li><li>use the Services for anything other than your own personal purposes (such as reselling the Services, providing Internet access or any other feature of the Services to any third party) or share or transfer your Services without our express consent;</li><li>operate a server in connection with the Services, including, without limitation, mail, news, file, gopher, telnet, chat, Web, or host configuration servers, multimedia streamers or multi-user interactive forums;</li><li>impersonate any person or entity, including, without limitation, a Rogers official, forum leader, guide or host, or falsely state or otherwise misrepresent your affiliation with a person or entity;</li><li>forge headers or otherwise manipulate identifiers in order to disguise the origin of any content transmitted through the Services; or</li><li>port scan a person’s computer or wireless device without that person’s consent, or use any tools designed to facilitate these scans.</li></ol><p class=\"tc-headline1\"><strong>Unlawful or Inappropriate Content</strong></p><p>Any Rogers Party reserves the right to move, remove or refuse to post any content, in whole or in part, that it, in its sole discretion, decide are unacceptable, undesirable or in violation of the Terms or this AUP. This includes, without limitation:</p><ul><li>obscene, profane, pornographic content;</li><li>defamatory, fraudulent or deceptive statements;</li><li>threatening, intimidating, abusive or harassing statements;</li><li>content that violates the privacy rights or intellectual property rights of others;</li><li>content that unlawfully promotes or incites hatred;</li><li>content that is otherwise offensive or objectionable; or</li><li>any transmissions constituting or encouraging conduct that would constitute a criminal offence, give rise to civil liability or otherwise violate any municipal, provincial, federal or international law, order or regulation.</li></ul><p>For purposes of this AUP, <strong>“content”</strong>refers to all forms of communications including, without limitation, text, graphics (including photographs, illustrations, images, drawings, logos), executable programs, audiovisual recordings, and audio recordings.</p><p class=\"tc-headline1\"><strong>Security</strong></p><p>As set out above, you are responsible for any misuse of the Services, by you or by any other person with access to the Services through your Equipment or your account. Therefore, you must take steps to ensure that others do not gain unauthorized access to the Services through any means, including, without limitation, wireless networking and wired networking. The Services may not be used to breach the security of another user or to attempt to gain access to any other person’s equipment, software or data, without the knowledge and consent of such person. Additionally, the Services may not be used in any attempt to circumvent the user authentication or security of any host, network, or account, including, without limitation, accessing data not intended for you, logging into or making use of a server or account you are not expressly authorized to access, or probing the security of other networks. Use or distribution of tools designed for compromising security, such as password guessing programs, cracking tools, packet sniffers or network probing tools, is prohibited. You may not disrupt the Services. The Services also may not be used to interfere with computer networking or telecommunications services to any user, host or network, including, without limitation, denial of service attacks, flooding of a network, overloading a service, improper seizing and abuse of operator privileges and attempts to <strong>“crash”</strong>a host. The transmission or dissemination of any information or software that contains a virus or other harmful feature is also prohibited. You are solely responsible for the security of any device you choose to connect to the Services, including any data stored on that device. In particular, Rogers recommends against enabling file or printer sharing of any sort. Rogers recommends that any files or services you do choose to make available for remote access be protected with a strong password or as otherwise appropriate. You agree to treat as confidential all access codes, personal identification numbers and/or other passwords that we may provide to you for use with the Services.</p><p class=\"tc-headline1\"><strong>Unsolicited Communications</strong></p><p>As set out above, the Services may not be used to send unsolicited, bulk or commercial messages or for any other unsolicited communications. This includes, without limitation, using automatic dialing and announcing devices to or otherwise make unsolicited voice or facsimile calls and bulk mailing of commercial advertising,</p><p>informational announcements, charity requests, petitions for signatures and political or religious messages. Such communications may only be directed to those who have explicitly requested it.</p><p>The Services may not be used to send messages to any individual who has indicated that he/she does not wish to receive messages from you. The Services may not be used to collect responses from unsolicited e-mail messages sent from accounts on other Internet hosts or e-mail services that violate this AUP or the acceptable use policy of any other Internet service provider. Moreover, unsolicited e-mail messages may not direct the recipient to any web site or other resource that uses the Services.</p><p>Forging, altering or removing e-mail headers is prohibited. You may not reference any Rogers network (for example, by including “Organization: Rogers” in the header or by listing an IP address that belongs to a Rogers network) in any unsolicited e-mail even if that e-mail is not sent through a Rogers network. <strong>“Mail bombing”</strong>is prohibited. That is, you may not send numerous copies of the same or substantially similar messages, nor may you send very large messages or files to a recipient with the intent to disrupt a server or account. The propagation of chain letters is similarly prohibited, whether or not the recipient wishes to receive such mailings. Rogers is not responsible for the forwarding of e-mail sent to any account that has been suspended or terminated. Such e-mail will be returned to sender, ignored, deleted, or stored temporarily, at Rogers’ sole discretion.</p><p class=\"tc-headline1\"><strong>User-Generated Content Services</strong></p><p><strong>“User-Generated Content Services”</strong>or <strong>“UGC Services”</strong>refers to any services that allow an end user to post, upload or generate content online to be shared with a limited or unlimited number of recipients and may include, without limitation: newsgroups, online forums, message boards, chat programs, wiki’s, photo sharing services, customer review sites, video sharing services, blogs and web hosting. Any User-Generated Content Services accessed through the Services must be used in accordance with the following:</p><ol type=\"i\"><li>you must comply with the UGC Service’s written charter, policies or FAQs;</li><li>you may only post advertisements, solicitations, or other commercial messages in the UGC Service if that service’s charter, policies or FAQs explicitly permit them;</li><li>you are responsible for determining the policies of the UGC Service before using it;</li><li>you must adhere to daily volume, file size and format restrictions of any UGC Service;</li><li>unless otherwise specified in the UGC Service’s charter, policies or FAQs, you must not forge, alter or remove any information from the UGC Service;</li><li>the Rogers Parties have no obligation to monitor the content of any UGC Service and the Rogers Parties are not liable for any claims, losses, actions, proceedings, suits, liabilities, damages, settlements, penalties, fines, costs and expenses arising out of or relating to the content of any such service;</li><li>you must not use the UGC Service to perform <strong>“flooding”</strong>, which refers to deliberately repeating actions in quick succession in order to fill the screens of other Internet users with text or other content;</li><li>any computer or other device connected through the Services may not maintain more than two simultaneous chat connections including, without limitation, the use of automated programs, such as <strong>“bots”</strong>or <strong>“clones”</strong>. Automated programs may not be used when the account holder is not physically present at the device;</li><li>you must not use the Services to send messages that disrupt another Internet user’s equipment, software, hardware or user display; and</li><li>you must not forge, alter or obscure your identity (other than using a nickname) while participating in the UGC Service.</li></ol><p class=\"tc-headline1\"><strong>Bandwidth, Data Storage and Other Limitations</strong></p><p>You must comply with the then current bandwidth, data storage and other limitations on your applicable Services. You must also ensure that your activity does not improperly restrict, inhibit, or degrade any other subscriber’s use of the Services, nor represent (in the sole judgment of Rogers) an unusually large burden on our networks. In addition, you must ensure that your activity does not improperly restrict, inhibit, disrupt, degrade or impede Rogers’ ability to deliver the Services, and monitor and investigate the Services, backbone, network nodes, and/or other network services or components. You may not resell, share, or otherwise distribute the Services or any portion thereof to any third party without the written consent of Rogers. For example, you cannot provide Internet access to others through a dial up connection, host shell accounts over the Internet, provide e-mail or news service, or send a news feed. The Services are consumer products designed for personal access to and use of the Internet. For example, the Services do not provide the type of security, upstream performance and total downstream throughput capability typically associated with commercial use. You may not run a server in connection with the Services. You may not provide network services to others via the Services. In addition, you are prohibited from running servers for mail, http, ftp, irc, and dhcp, and multi-user interactive forums.</p><p>Your use of the Services may be subject to a usage limit, as set out in your Service Agreement. If you exceed that limit, you may be subject to additional usage charges. See <a href=\"http://www.rogers.com/uselimits\"><strong>http://www.rogers.com/uselimits</strong></a> for the current usage allowance for your Services.</p><p class=\"tc-headline1\"><strong>Network Management</strong></p><p>We reserve the right to manage our networks in order to optimize their efficiency for the benefit of our subscribers, including, without limitation, by way of the following: rate limiting (speed), rejection or removal of spam or otherwise unsolicited bulk e-mail, anti-virus mechanisms, and protocol filtering. We may take any other action we deem appropriate in order to help ensure the integrity of the network experience for all subscribers. For details on our network management practices, visit <a href=\"http://www.rogers.com/networkpolicy\"><strong>http://www.rogers.com/networkpolicy</strong></a>.</p><p class=\"tc-headline1\"><strong>Violation of this Acceptable Use Policy</strong></p><p>As set out in the Terms, we have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment; and to access or preserve content or information in accordance with the Terms. We prefer to advise subscribers of inappropriate behavior and any necessary corrective action. However, if the Services are used in a way that we, in our sole discretion, believe violates this AUP, any of the Rogers Parties may take any responsive actions they deem appropriate. Such actions may include, without limitation, temporary or permanent removal of content, cancellation of newsgroup posts, filtering of Internet transmissions, and/or the immediate suspension or termination of all or any portion of the Services or your account. The Rogers Parties will have no liability for any such responsive actions. The above described actions are not exclusive remedies and the Rogers Parties may take any other legal or technical action deemed appropriate. Upon termination of an account, any of the Rogers Parties are authorized to delete any files, programs, data and e-mail messages associated with such account. The failure to enforce this AUP, for whatever reason, shall not be construed as a waiver of any right to do so at any time. If any portion of this AUP is held invalid or unenforceable, that portion will be construed consistent with applicable law as nearly as possible, and the remaining portions will remain in full force and effect. This AUP shall be exclusively governed by, and construed in accordance with the governing law provision set out in the Terms.</p><p class=\"tc-headline1\"><strong>Complaints</strong></p><p>Please direct any complaints of violations of this AUP to <a href=\"mailto:abuse@rogers.com\"><strong>abuse@rogers.com</strong></a> or contact us at 1-888-ROGERS1. Questions or complaints, concerning third party content should be addressed to the applicable content provider.</p><p>™Rogers Communications Inc. © 2007-2015.</p><p>06/10</p>");
$templateCache.put("views/localization/account-charges-billing-info-fr.html","<div class=\"bold paragraph\">Compte, frais et facturation</div><div class=\"paragraph\"><p>a. Comment Rogers me facture-t-elle mes Services?</p><p>Les frais relatifs aux Services commencent &agrave; vous &ecirc;tre factur&eacute;s &agrave; la Date de mise en service et sont factur&eacute;s &agrave; l&rsquo;avance. &Agrave; moins que Rogers et vous conveniez d&rsquo;un autre arrangement, votre p&eacute;riode de facturation est d&rsquo;une dur&eacute;e d&rsquo;un mois, et se termine &agrave; la date de facturation indiqu&eacute;e au haut de votre facture. Le d&eacute;but de votre p&eacute;riode de facturation ne co&iuml;ncidera pas toujours avec la Date de mise en service initiale. Dans un tel cas, vos frais de Services et votre quota d&rsquo;utilisation seront calcul&eacute;s proportionnellement pour la p&eacute;riode comprise entre votre Date de mise en service et votre date de facturation. Les frais d&rsquo;utilisation, comme les frais d&rsquo;utilisation de donn&eacute;es additionnelles, les frais de temps d&rsquo;antenne, les frais d&rsquo;interurbain, les achats de films ou d&rsquo;&eacute;v&eacute;nements et les frais d&rsquo;itin&eacute;rance, sont factur&eacute;s apr&egrave;s votre utilisation de ces services. Nous pourrons porter des frais &agrave; votre compte jusqu&rsquo;&agrave; <strong>6</strong> mois suivant la date o&ugrave; les frais ont &eacute;t&eacute; engag&eacute;s.</p><p>b. &Agrave; quelle date dois-je payer ma facture? Les frais port&eacute;s &agrave; votre compte sont payables en entier &agrave; la date de votre facture. Si vous payez par la poste ou par l&rsquo;entremise d&rsquo;une institution financi&egrave;re, veuillez pr&eacute;voir des d&eacute;lais suffisants pour que le paiement nous parvienne avant la date d&rsquo;exigibilit&eacute; du paiement. Il vous incombe d&rsquo;acquitter tous les frais imput&eacute;s &agrave; votre compte.</p><p>c. Qu&rsquo;arrive-t-il si je ne paie pas ma facture &agrave; temps?</p><p>Si nous ne recevons pas le montant d&rsquo;une somme due sur votre compte au plus tard &agrave; la date d&rsquo;exigibilit&eacute; pr&eacute;cis&eacute;e, le montant sera soumis &agrave; des frais de paiement en retard de <strong>2 %</strong> par mois, calcul&eacute;s et compos&eacute;s mensuellement sur le montant en souffrance (<strong>26,82 %</strong> par ann&eacute;e) &agrave; compter de la date de la premi&egrave;re facture sur laquelle le montant en souffrance appara&icirc;t, jusqu&rsquo;&agrave; la date de r&eacute;ception d&rsquo;un tel montant au complet. Vous convenez que nous pouvons facturer les montants non pay&eacute;s et en souffrance, y compris les frais de paiement en retard, selon tout mode de paiement pr&eacute;autoris&eacute; li&eacute; &agrave; votre compte (par exemple, en le portant &agrave; votre carte de cr&eacute;dit ou en proc&eacute;dant par retrait direct de votre compte bancaire).</p><p>d. Des frais d&rsquo;administration peuvent-ils m&rsquo;&ecirc;tre factur&eacute;s?</p><p>Nous pourrions imputer des frais d&rsquo;administration &agrave; votre compte, notamment en raison de ce qui suit :</p><p>i. un changement de forfait;<br>ii. un changement de num&eacute;ro de t&eacute;l&eacute;phone (ou de tout autre identifiant);<br>iii.une demande de r&eacute;impression de facture;</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong></p><p>iv. des efforts de recouvrement &agrave; la suite d&rsquo;un non-paiement;<br>v. des paiements retourn&eacute;s ou refus&eacute;s; et (ou)<br>vi. le r&eacute;tablissement du Service.<br>Vous pouvez obtenir une liste de ces frais sur demande, ou la consulter &agrave; l&rsquo;adresse <a href=\"http://rogers.com/frais\">rogers.com/frais</a>. Cette liste fait partie int&eacute;grante des pr&eacute;sentes Modalit&eacute;s.</p><p>e. Que puis-je faire si je ne comprends pas ou que je veux contester des frais figurant sur ma facture?</p><p>Toute question ou erreur pr&eacute;sum&eacute;e concernant les frais doit nous &ecirc;tre signal&eacute;e dans les <strong>90</strong> jours suivant la date de la facture en question, sans quoi vous &ecirc;tes pr&eacute;sum&eacute; avoir accept&eacute; les frais. Si l&rsquo;imputation des frais &agrave; votre compte &eacute;tait effectivement non autoris&eacute;e ou erron&eacute;e, nous annulerons alors ces frais dans les <strong>30</strong> jours suivant la r&eacute;ception de votre avis signalant l&rsquo;erreur.</p><p>f. Comment s&rsquo;appliquent les rabais et les promotions?</p><p>Nous appliquerons tout rabais, toute promotion ou tout avantage &agrave; votre compte tant que vous y demeurez admissible. Nous pouvons v&eacute;rifier votre admissibilit&eacute; &agrave; ce rabais, &agrave; cette promotion ou &agrave; cet avantage de temps &agrave; autre, et si vous cessez d&rsquo;y &ecirc;tre admissible pour quelque raison que ce soit, nous pouvons l&rsquo;annuler et (ou) faire passer votre Service &agrave; un forfait comparable.</p><p>g. Comment les frais de temps d&rsquo;antenne sans fil local et interurbain sont-ils factur&eacute;s?</p><p>Les frais de temps d&rsquo;antenne local et interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel achemin&eacute; (entrant ou sortant). Le temps d&rsquo;antenne pour toute la dur&eacute;e de l&rsquo;appel est factur&eacute; au tarif applicable au d&eacute;but de l&rsquo;appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels achemin&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN, et comprennent le temps de sonnerie. Les frais pour les appels internationaux ou en itin&eacute;rance peuvent vous &ecirc;tre factur&eacute;s, que vous ayez r&eacute;ussi ou non l&rsquo;appel.</p><p>h. Comment Rogers d&eacute;termine-t-elle si j&rsquo;effectue un appel interurbain sans fil?</p><p>Une zone d&rsquo;appels sans fil locaux est une zone o&ugrave; vous pouvez faire et recevoir des appels locaux sans frais d&rsquo;interurbain. Les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d&rsquo;appels locaux. L&rsquo;endroit o&ugrave; vous vous trouvez au moment de l&rsquo;appel, votre num&eacute;ro de sans-fil et le num&eacute;ro de t&eacute;l&eacute;phone que vous composez sont des &eacute;l&eacute;ments importants pour d&eacute;terminer les zones d&rsquo;appels locaux et le traitement des appels interurbains. Votre &laquo; zone d&rsquo;appels locaux entrants &raquo; est d&eacute;termin&eacute;e par l&rsquo;emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;int&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels locaux. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels interurbains. Votre zone d&rsquo;appels locaux sortants est d&eacute;termin&eacute;e par votre emplacement physique. Si vous composez un num&eacute;ro local lorsque vous vous trouvez dans la zone de ce num&eacute;ro, il s&rsquo;agit d&rsquo;un appel local. Si vous composez un num&eacute;ro &agrave; l&rsquo;ext&eacute;rieur de la zone o&ugrave; vous vous trouvez, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le service Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de l&rsquo;emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil, et ce, peu importe o&ugrave; vous vous trouvez. Consultez rogers.com/interurbain pour conna&icirc;tre les tarifs interurbains en vigueur.</p><p>i. Comment sont factur&eacute;s les frais d&rsquo;interurbain &agrave; partir de mon num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel, et comment Rogers d&eacute;termine-t-elle si j&rsquo;effectue un appel interurbain &agrave; partir de mon num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel?</p><p>Les frais d&rsquo;interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel interurbain que vous effectuez. Pour les appels internationaux, des frais d&rsquo;interurbain peuvent &ecirc;tre factur&eacute;s que l&rsquo;appel soit achemin&eacute; ou non. Pour les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle, les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d&rsquo;appels locaux, et votre zone d&rsquo;appels locaux d&eacute;pend de votre num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel. Si vous composez un num&eacute;ro qui est un interurbain &agrave; partir de votre num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux.</p></div>");
$templateCache.put("views/localization/account-charges-billing-info.html","<div class=\"bold paragraph\">ACCOUNT, CHARGES AND BILLING INFORMATION</div><div class=\"paragraph\"><p>a. How does Rogers bill me for Services?</p><p>Service charges will start on the Activation Date and are billed in advance. Unless we both agree to a different arrangement, your billing period runs for one month, and ends on the bill date noted on the top of your bill. Your Activation Date and billing period won&rsquo;t always start on the same day. When this happens, your Service charges and allotted usage are pro-rated for the period between your Activation Date and your bill date. Usage charges, such as additional data, airtime, long distance, movie or event purchases and roaming are billed after you use them. We may bill you for a charge up to <strong>6</strong> months from the date the charge was incurred.</p><p>b. When is my bill payment due?</p><p>Charges on your account are due and payable in full from the date of your bill. If you are paying by mail or through a financial institution, please allow adequate time for your payment to reach us before the required payment date. You are responsible for all charges on your account.</p><p>c. What if I don&rsquo;t pay my bill on time?</p><p>If we do not receive payment of an amount due on your account by the specified required payment date, it will be subject to a late payment charge of <strong>2%</strong> per month, calculated and compounded monthly on the outstanding amount (<strong>26.82%</strong> per year) from the date of the first bill on which it appears until the date we receive that amount in full. You agree that we can charge any unpaid and outstanding amount, including any late payment charges, on any pre-authorized payment method on your account (e.g., a credit card or bank account withdrawal).</p><p>d. Will I be subject to any administrative charges?</p><p>We may apply administrative charges in connection with your account, including as a result of the following:</p><p>i. price plan change;<br>ii. phone number (or other identifier) change;<br>iii.bill reprint requests;</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><p>iv. collection efforts due to non-payment;<br>v. returned or rejected payments; and/or<br>vi. the restoral of Service.<br>A list of these charges is available on request, or at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/charges\">rogers.com/charges</a>, and forms part of these Terms.</p><p>e. What if I do not understand or disagree with a charge on my bill?</p><p>Any questions or discrepancies regarding charges must be reported to us within <strong>90</strong> days of the date of the applicable bill. Failure to notify us within this time period means that you have accepted those charges. If any of those discrepancies resulted in unauthorized or incorrect charges on your account, then we will reverse those charges within <strong>30</strong> days of receiving notice from you.</p><p>f. How do discounts and promotions work?</p><p>We will apply a discount, promotion or benefit to your account as long as you remain eligible for it. We may check your eligibility from time to time, and if you become ineligible to receive that discount, promotion or benefit for any reason, we may remove it, and/or transfer your Service to a comparable Service plan.</p><p>g. How is wireless local and long distance airtime charged?</p><p>Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed or answered calls from the moment you press SEND until you press END and includes the ring time. For international calls or while roaming, you may be charged regardless of whether the call is completed.</p><p>h. How does Rogers determine if I&rsquo;m on a long distance wireless call?</p><p>Wireless local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Wireless calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your &ldquo;Incoming Local Calling Area&rdquo; is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your &ldquo;Outgoing Local Calling Area&rdquo; is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</p><p>i. How is home phone long distance calling charged and how does Rogers determine if I&rsquo;m on a long distance home phone call? Long distance charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed long distance call you make. For international calls, you may be charged regardless of whether the call is completed. For home phone Services, calls are defined as local or long distance based on local calling areas, and your local calling area depends on your home phone number. If you dial a number that is long distance to your home phone number, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside your local calling area.</p></div>");
$templateCache.put("views/localization/account-maintenance-agreement-fr.html","<div class=\"bold paragraph\">RENSEIGNEMENTS IMPORTANTS AU SUJET DE VOTRE SERVICE SANS-FIL</div><div class=\"paragraph\">La pr&eacute;sente information s&rsquo;ajoute &agrave; nos Ententes de service avec vous et en fait partie int&eacute;grante. Elle doit &ecirc;tre lue conjointement avec les Modalit&eacute;s de service, la Politique d&rsquo;utilisation acceptable et la Politique de protection de la vie priv&eacute;e de Rogers en vigueur qui vous ont &eacute;t&eacute; fournies et qui sont accessibles sur le site rogers.com (et qui remplacent les Modalit&eacute;s de service, la Politique d&rsquo;utilisation acceptable et la Politique de protection de la vie priv&eacute;e de Rogers qui vous ont &eacute;t&eacute; transmises ant&eacute;rieurement), avec les brochures ou le mat&eacute;riel en ligne de Rogers en vigueur d&eacute;crivant les forfaits, les fonctions, les services ou les produits que vous avez choisis, ainsi qu&rsquo;avec le Guide de l&rsquo;utilisateur de Rogers en vigueur. Tous les nouveaux changements apport&eacute;s &agrave; vos Ententes de service sont indiqu&eacute;s aux pr&eacute;sentes. Tous les autres aspects de vos Ententes de service demeurent les m&ecirc;mes. Vous reconnaissez que tout Service annul&eacute; &agrave; votre demande ne sera peut-&ecirc;tre plus disponible.</div><div class=\"paragraph\"><ol><li>Description des frais<ol><li>Des frais mensuels exig&eacute;s par le gouvernement pour le service d&rsquo;urgence 9-1-1 peuvent s&rsquo;appliquer : 0,62 $ en Saskatchewan, 0,40 $ au Qu&eacute;bec, 0,43 $ en Nouvelle-&Eacute;cosse, 0,53 $ au Nouveau-Brunswick, 0,70 $ &agrave; l&rsquo;&Icirc;le-du-Prince-&Eacute;douard, 0,44 $ en Alberta, et 0,75 $ &agrave; Terre-Neuve-et-Labrador. Toutefois, il n&rsquo;y a aucuns frais de temps d&rsquo;antenne pour les appels au 9-1-1 &agrave; partir d&rsquo;un appareil sans fil de Rogers.</li><li>Lorsqu&rsquo;ils sont exigibles, des frais de r&eacute;cup&eacute;ration des co&ucirc;ts gouvernementaux et r&eacute;glementaires servent &agrave; r&eacute;cup&eacute;rer les frais d&eacute;bours&eacute;s et &agrave; d&eacute;frayer les co&ucirc;ts de la conformit&eacute; aux exigences, aux mandats et aux programmes f&eacute;d&eacute;raux, provinciaux et (ou) municipaux. Ces frais ne sont pas une taxe ou des frais que Rogers doit percevoir de ses clients pour le gouvernement.</li><li>Les frais de temps d\'antenne additionnel, les frais de transmission de donn&eacute;es, les frais d\'interurbain, les frais d\'itin&eacute;rance, les frais &agrave; l\'utilisation et les taxes sont en sus et factur&eacute;s mensuellement, le cas &eacute;ch&eacute;ant. Pour obtenir de plus amples renseignements sur les Services auxquels vous &ecirc;tes abonn&eacute;, veuillez consulter la brochure de Rogers d&eacute;crivant votre forfait ou vos options ou encore le site rogers.com.</li></ol></li><li>Cat&eacute;gories de Services/Ententes de service. Il est entendu que les Services mentionn&eacute;s aux pr&eacute;sentes sont class&eacute;s selon les cat&eacute;gories suivantes :<ol><li>Services &agrave; dur&eacute;e d&eacute;termin&eacute;e. Les Services &agrave; dur&eacute;e d&eacute;termin&eacute;e correspondent aux Services auxquels vous vous abonnez qui comportent une P&eacute;riode d&rsquo;engagement (indiqu&eacute;e ci-dessus), laquelle est associ&eacute;e &agrave; la dur&eacute;e d&rsquo;une Entente de service ou celle d&rsquo;une P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es. Chaque Service &agrave; dur&eacute;e d&eacute;termin&eacute;e auquel vous vous abonnez constitue une Entente de service distincte avec nous. Nous n&rsquo;augmenterons pas les frais de service mensuels ou le tarif &agrave; la minute pour le temps d&rsquo;antenne local ni ne r&eacute;duirons le nombre de minutes ou le volume de donn&eacute;es compris dans un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e au cours de sa P&eacute;riode d&rsquo;engagement.</li><li>Services mensuels. Les Services mensuels correspondent aux Services auxquels vous vous abonnez de fa&ccedil;on continue, mais qui ne comportent pas de P&eacute;riode d\'engagement. Les Services mensuels sont indiqu&eacute;s ci-dessus comme n&rsquo;&eacute;tant pas associ&eacute;s &agrave; une Entente de service ou &agrave; une P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es. Chaque Service mensuel auquel vous vous abonnez constitue une Entente de service distincte avec nous. Pour obtenir de plus amples renseignements sur les Services mensuels, notamment les tarifs des services optionnels, veuillez consulter les brochures Rogers &agrave; jour ou encore le site rogers.com. Nous pouvons modifier les Services mensuels conform&eacute;ment aux Modalit&eacute;s de service de Rogers.</li><li>Services factur&eacute;s &agrave; l&rsquo;utilisation. Les Services factur&eacute;s &agrave; l\'utilisation correspondent aux Services que vous obtenez de Rogers et qui sont factur&eacute;s &agrave; l\'utilisation (qu\'ils soient utilis&eacute;s une seule fois ou pendant une p&eacute;riode donn&eacute;e, comme un jour ou une semaine), mais qui ne sont pas utilis&eacute;s de fa&ccedil;on continue. Les Services factur&eacute;s &agrave; l&rsquo;utilisation offerts comprennent notamment les suivants. Pour obtenir de plus amples renseignements sur les Services factur&eacute;s &agrave; l\'utilisation, notamment les tarifs, veuillez consulter les brochures Rogers &agrave; jour ou encore le site rogers.com. Nous pouvons modifier les Services factur&eacute;s &agrave; l\'utilisation conform&eacute;ment aux Modalit&eacute;s de service Rogers.<ol><li>Service en itin&eacute;rance. Des frais d&rsquo;itin&eacute;rance substantiels peuvent vous &ecirc;tre factur&eacute;s si vous utilisez votre appareil &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau Rogers, m&ecirc;me si l&rsquo;utilisation n&rsquo;est pas intentionnelle. Quand vous utilisez votre sans-fil hors du r&eacute;seau de Rogers, l&rsquo;utilisation est prise en charge par le r&eacute;seau sans-fil d&rsquo;un autre fournisseur. Des frais d\'itin&eacute;rance s\'appliquent pour toute utilisation faite en dehors du r&eacute;seau de Rogers. Une telle utilisation comprend notamment : les appels, les messages texte, photo et vid&eacute;o ainsi que la transmission de donn&eacute;es (notamment l&rsquo;utilisation d&rsquo;applications, du courriel, de la messagerie instantan&eacute;e, de la messagerie vocale visuelle et de la navigation sur Internet). Consultez rogers.com/itinerance pour conna&icirc;tre les tarifs &agrave; l&rsquo;utilisation en itin&eacute;rance en fonction des options et des destinations.</li><li>Service de messagerie texte, photo et vid&eacute;o factur&eacute; &agrave; l&rsquo;utilisation. Le service de messagerie texte, photo et vid&eacute;o sera activ&eacute; sur les appareils compatibles. Des frais &agrave; l&rsquo;utilisation seront factur&eacute;s pour chaque message sortant ou entrant (sauf dans le cas d\'un abonnement &agrave; une option, une offre group&eacute;e, une trousse ou un forfait comprenant le service de messagerie vis&eacute;).Les messages &agrave; tarification additionnelle entrants et sortants (alertes, messages li&eacute;s &agrave; du contenu et &agrave; des promotions) sont factur&eacute;s aux tarifs en vigueur. Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Service de transmission de donn&eacute;es factur&eacute; &agrave; l&rsquo;utilisation. Le service de transmission de donn&eacute;es sera activ&eacute; sur les appareils compatibles. Des frais quotidiens &agrave; l\'utilisation s\'appliqueront (ne s\'appliquent pas dans le cas d\'un abonnement &agrave; un forfait ou &agrave; une option de transmission de donn&eacute;es).Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Service Appel vid&eacute;o factur&eacute; &agrave; l\'utilisation. Le service Appel vid&eacute;o sera activ&eacute; sur les appareils compatibles. Des frais &agrave; l\'utilisation s\'appliqueront pour chaque minute d&rsquo;Appel vid&eacute;o effectu&eacute; et re&ccedil;u. Le temps d&rsquo;antenne et les frais d&rsquo;interurbain ne sont pas inclus. Des frais d&rsquo;itin&eacute;rance s\'appliquent pour le service en itin&eacute;rance.</li><li>Appel en attente et Appel de groupe. Des frais de temps d&rsquo;antenne s&rsquo;appliquent selon votre forfait (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Renvoi d&rsquo;appel. Le Renvoi d&rsquo;appel peut &ecirc;tre ajout&eacute; &agrave; votre forfait (si ce service n&rsquo;est pas d&eacute;j&agrave; compris).Le service Renvoi d&rsquo;appel vous permet de transf&eacute;rer votre appel vers un autre num&eacute;ro et comprend 2 500 minutes locales de Renvoi d&rsquo;appel par mois. Les minutes de Renvoi d&rsquo;appel additionnelles sont factur&eacute;es au tarif mentionn&eacute; dans votre forfait ou option (plus des frais d\'interurbain ou d\'itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Messagerie vocale. Des frais de temps d&rsquo;antenne, ou des frais de transmission de donn&eacute;es pour la messagerie vocale visuelle, s&rsquo;appliquent selon votre forfait (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s&rsquo;il y a lieu).</li><li>Assistance-annuaire 4 1 1. Des frais de service et de temps d&rsquo;antenne s&rsquo;appliquent (plus des frais d&rsquo;interurbain ou d&rsquo;itin&eacute;rance, s\'il y a lieu), et ce, m&ecirc;me si le num&eacute;ro que vous avez demand&eacute; n&rsquo;est pas inscrit dans l&rsquo;annuaire.</li></ol></li></ol></li><li>Calcul de vos frais de d&eacute;classement (applicables uniquement aux Services &agrave; dur&eacute;e d&eacute;termin&eacute;e). Si, pour quelque raison que ce soit, vous changez de forfait pour un forfait de cat&eacute;gorie inf&eacute;rieure pendant votre P&eacute;riode d&rsquo;abonnement, vous pourriez devoir acquitter des frais de d&eacute;classement de forfait. Les frais de d&eacute;classement correspondent &agrave; la diff&eacute;rence entre le B&eacute;n&eacute;fice &eacute;conomique que vous avez re&ccedil;u et le b&eacute;n&eacute;fice &eacute;conomique offert aux termes du forfait de cat&eacute;gorie inf&eacute;rieure que vous choisissez, multipli&eacute;e par le nombre de mois restant &agrave; la dur&eacute;e de votre Entente de service au moment du d&eacute;classement (taxes exigibles en sus). S&rsquo;il y a lieu, le montant des frais de d&eacute;classement indiqu&eacute; &agrave; la rubrique &laquo; D&eacute;classement de forfait &raquo; de votre entente servira &agrave; calculer tous frais de d&eacute;classement applicables. Si nous lan&ccedil;ons de nouvelles cat&eacute;gories de forfaits, ou modifions nos cat&eacute;gories de forfaits existantes, le b&eacute;n&eacute;fice &eacute;conomique offert aux termes de ces nouvelles cat&eacute;gories de forfaits servira &agrave; calculer tous frais de d&eacute;classement applicables. Si vous payez des frais de d&eacute;classement, le B&eacute;n&eacute;fice &eacute;conomique indiqu&eacute; dans votre plus r&eacute;cente entente sera r&eacute;duit d&rsquo;un montant correspondant aux frais de d&eacute;classement pour le calcul de tous Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l&rsquo;appareil.</li><li>R&eacute;siliation et modification<ol><li>G&eacute;n&eacute;ralit&eacute;s. Vous pouvez r&eacute;silier votre Service en tout temps (conform&eacute;ment aux Modalit&eacute;s de service de Rogers), y compris &agrave; la fin de votre P&eacute;riode d\'engagement, ou y apporter des modifications en communiquant avec nous au 1 888 ROGERS1 (1 888 764 3771). Si vous changez d&rsquo;appareil ou modifiez un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, vous pourriez devoir renouveler votre P&eacute;riode d&rsquo;engagement ou conclure avec nous une nouvelle Entente de service pour une nouvelle P&eacute;riode d&rsquo;engagement.</li><li>Prolongation automatique. &Agrave; la fin de votre P&eacute;riode d&rsquo;engagement, votre forfait passera automatiquement &agrave; un abonnement mensuel. Rogers peut communiquer avec vous en tout temps pour vous proposer de renouveler votre forfait. Si vous ne souhaitez pas renouveler votre forfait au moment o&ugrave; Rogers communique avec vous, vous conserverez votre forfait ainsi que votre entente actuels, inchang&eacute;s, jusqu\'&agrave; ce qu\'un changement y soit apport&eacute; ou que l\'abonnement soit r&eacute;sili&eacute; conform&eacute;ment aux modalit&eacute;s de l\'Entente de service r&eacute;gissant ce forfait.</li><li><p>Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l\'appareil (applicables uniquement aux Services &agrave; dur&eacute;e d&eacute;termin&eacute;e pour tout nouvel abonnement souscrit &agrave; partir du 22 janvier 2012). Des Frais de r&eacute;cup&eacute;ration des &eacute;conomies r&eacute;alis&eacute;es sur l\'appareil (FR&Eacute;A) s&rsquo;appliquent si vous avez obtenu un b&eacute;n&eacute;fice &eacute;conomique en acceptant le nouvel abonnement &agrave; dur&eacute;e d&eacute;termin&eacute;e et que, pour quelque raison que ce soit, votre service sans-fil ou votre nouvel abonnement &agrave; dur&eacute;e d&eacute;termin&eacute;e est annul&eacute; avant la fin de votre Entente de service (P&eacute;riode d&rsquo;abonnement). Les FR&Eacute;A correspondent au b&eacute;n&eacute;fice &eacute;conomique multipli&eacute; par le nombre de mois restant &agrave; votre P&eacute;riode d&rsquo;abonnement, divis&eacute; par le nombre total de mois de la P&eacute;riode d&rsquo;abonnement (taxes exigibles en sus). En d&rsquo;autres mots : FR&Eacute;A = B&eacute;n&eacute;fice &eacute;conomique x nombre de mois restant &agrave; votre P&eacute;riode d\'abonnement &divide; nombre total de mois de votre P&eacute;riode d&rsquo;abonnement + taxes exigibles.</p><p>Des Frais de r&eacute;cup&eacute;ration des &eacute;conomies additionnelles r&eacute;alis&eacute;es sur l\'appareil (FR&Eacute;AA) s\'appliquent &eacute;galement si, pour quelque raison que ce soit, votre service de transmission de donn&eacute;es sans-fil ou votre abonnement au service de transmission de donn&eacute;es (P&eacute;riode d\'abonnement au service de transmission de donn&eacute;es) est annul&eacute; avant la fin de votre P&eacute;riode d\'abonnement au service de transmission de donn&eacute;es. Les FR&Eacute;AA sont fond&eacute;s sur le b&eacute;n&eacute;fice &eacute;conomique additionnel que vous avez re&ccedil;u en vous abonnant au service de transmission de donn&eacute;es. Ils sont calcul&eacute;s &agrave; l&rsquo;aide de la formule qui permet de calculer les FR&Eacute;A (en rempla&ccedil;ant le B&eacute;n&eacute;fice &eacute;conomique par le B&eacute;n&eacute;fice &eacute;conomique additionnel et la P&eacute;riode d&rsquo;abonnement par la P&eacute;riode d&rsquo;abonnement au service de transmission de donn&eacute;es) et ils s&rsquo;ajoutent aux FR&Eacute;A payables &agrave; la r&eacute;siliation de votre Entente de service. Si vous &ecirc;tes abonn&eacute; &agrave; un forfait combinant des services voix et donn&eacute;es, les FR&Eacute;A et les FR&Eacute;AA s\'appliquent tous deux.</p></li><li>Frais d&rsquo;annulation de service (applicable uniquement aux Service &agrave; dur&eacute;e d&eacute;termin&eacute;e pour tout nouvel abonnement souscrit entre le 22 janvier 2012 et le 1er d&eacute;cembre 2013). Ne s&rsquo;applique pas aux r&eacute;sidants du Manitoba, aux r&eacute;sidants de Terre-Neuve ayant souscrit un nouvel abonnement &agrave; partir du 27 septembre 2012, aux r&eacute;sidants de la Nouvelle-&Eacute;cosse ayant souscrit un nouvel abonnement &agrave; partir du 1er mai 2013, ni aux r&eacute;sidants du Qu&eacute;bec : Des frais d&rsquo;annulation de service de 12,50 $ par ligne (taxes exigibles en sus) s&rsquo;appliquent si, pour quelque raison que ce soit, votre service sans-fil est annul&eacute; avant l&rsquo;&eacute;ch&eacute;ance de votre P&eacute;riode d&rsquo;abonnement. Ces frais s\'ajoutent aux FR&Eacute;A ou aux FR&Eacute;A et FR&Eacute;AA.</li><li>P&eacute;riode d&rsquo;essai. Rogers peut permettre la r&eacute;siliation de votre Service sans appliquer de FR&Eacute;A dans les conditions suivantes : 1) l&rsquo;appareil est remis avec toutes ses composantes et en son &eacute;tat d&rsquo;origine tel qu&rsquo;il est indiqu&eacute; dans le document Comment retourner votre sans-fil Rogers, inclus avec votre appareil, 2) l\'annulation est demand&eacute;e dans les 15 jours suivant la date de mise en service et 3) votre compte pr&eacute;sente moins de 30 minutes d\'utilisation de temps d\'antenne. Tous les frais engag&eacute;s jusqu\'au moment de l\'annulation du service vous seront factur&eacute;s.</li></ol></li><li>Renseignements sur l&rsquo;appareil<ol><li>Appareils neufs ou remis &agrave; neuf. Sauf indication contraire, votre appareil est neuf.</li><li>Verrouillage de l&rsquo;appareil. Votre appareil est verrouill&eacute; et ne peut &ecirc;tre utilis&eacute; que sur le r&eacute;seau de Rogers ou encore sur ceux exploit&eacute;s par les fournisseurs avec lesquels nous avons conclu une entente d&rsquo;itin&eacute;rance. Si vous tentez de d&eacute;verrouiller votre appareil, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de votre appareil. Si vous souhaitez d&eacute;verrouiller votre appareil, les Frais de d&eacute;verrouillage mentionn&eacute;s pr&eacute;c&eacute;demment s&rsquo;appliquent. Si vous avez obtenu un B&eacute;n&eacute;fice &eacute;conomique, nous ne d&eacute;verrouillerons pas votre appareil pendant les 90 premiers jours de votre P&eacute;riode d&rsquo;abonnement.</li><li>Garantie. Veuillez consulter les documents remis avec votre appareil pour obtenir des renseignements d&eacute;taill&eacute;s sur la garantie dont il est assorti, notamment l&rsquo;objet de la garantie, la dur&eacute;e de celle-ci et les modalit&eacute;s de r&eacute;clamation.</li><li>Rabais sur les articles. Tout appareil qui vous est offert &agrave; 0 $ est offert &agrave; titre d&rsquo;article vendu au rabais et non d&rsquo;article gratuit.</li></ol></li><li><ol>D&eacute;p&ocirc;t de garantie<li>Conditions du d&eacute;p&ocirc;t de garantie. Nous pouvons exiger un d&eacute;p&ocirc;t de garantie ou imposer d&rsquo;autres exigences de paiement ou de cr&eacute;dit (par exemple, paiements provisoires, pr&eacute;l&egrave;vements automatiques obligatoires, cartes pr&eacute;autoris&eacute;es ou paiements bancaires) &agrave; tout moment et selon des modalit&eacute;s &eacute;tablies &agrave; notre seule discr&eacute;tion. Tout d&eacute;p&ocirc;t de garantie que vous nous fournissez sera conserv&eacute; pendant au moins 12 mois, sauf si vous mettez fin &agrave; vos Services avant la fin de cette p&eacute;riode. Apr&egrave;s 12 mois, nous pouvons lib&eacute;rer le d&eacute;p&ocirc;t de garantie et l&rsquo;appliquer au solde de votre compte si nous jugeons, &agrave; notre gr&eacute;, que votre historique de paiement est satisfaisant ou que vous r&eacute;pondez aux crit&egrave;res financiers pour le remboursement de votre d&eacute;p&ocirc;t de garantie.</li><li>Int&eacute;r&ecirc;ts sur le d&eacute;p&ocirc;t de garantie. Tout d&eacute;p&ocirc;t de garantie que nous d&eacute;tenons portera int&eacute;r&ecirc;t au taux de financement &agrave; un jour de la Banque du Canada en vigueur &agrave; ce moment major&eacute; d&rsquo;un pour cent, selon le nombre r&eacute;el de jours dans l&rsquo;ann&eacute;e, calcul&eacute; chaque mois. Les int&eacute;r&ecirc;ts seront cumul&eacute;s &agrave; partir de la date &agrave; laquelle nous recevons votre d&eacute;p&ocirc;t de garantie (mais pas avant le moment prescrit par la l&eacute;gislation ou la r&eacute;glementation en vigueur) jusqu&rsquo;&agrave; la date &agrave; laquelle nous vous le remettons.</li><li>Utilisation et remboursement du d&eacute;p&ocirc;t de garantie. Nous pouvons appliquer votre d&eacute;p&ocirc;t de garantie en entier &agrave; votre solde si nous n&rsquo;avons pas re&ccedil;u un paiement d&ucirc; aux termes de votre compte &agrave; la date pr&eacute;vue du paiement. Nous pouvons vous demander de r&eacute;approvisionner le d&eacute;p&ocirc;t de garantie apr&egrave;s une telle utilisation. Nous vous aviserons de toute utilisation d&rsquo;une partie ou de la totalit&eacute; du d&eacute;p&ocirc;t de garantie. Nous vous rembourserons le d&eacute;p&ocirc;t de garantie avec les int&eacute;r&ecirc;ts cumul&eacute;s dans les 30 jours suivant la r&eacute;siliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du d&eacute;p&ocirc;t de garantie sont remplies.</li></ol></li><li>Forfaits Partage. Vous consentez &agrave; ce que, si la ligne principale de votre forfait Partage (selon le cas) est annul&eacute;e et que les autres lignes sont maintenues, l\'une de ces lignes soit automatiquement d&eacute;sign&eacute;e comme la ligne principale et qu\'elle soit factur&eacute;e dans le cadre du m&ecirc;me forfait ou d\'un forfait d&rsquo;une valeur &eacute;quivalente au forfait de la ligne de l&rsquo;abonnement initial. Vous consentez en outre &agrave; ce que, si le nombre de lignes mises en service dans le cadre de votre forfait tombe sous le minimum requis, Rogers effectue le transfert de votre ligne ou de vos lignes restantes vers un forfait ayant une valeur semblable &agrave; celle de votre forfait actuel.</li><li>Facturation du temps d&rsquo;antenne et des appels interurbains<ol><li>Frais de temps d\'antenne. Les frais de temps d\'antenne local et interurbain sont arrondis &agrave; la minute compl&egrave;te suivante. Des frais minimums d&rsquo;une minute s&rsquo;appliquent &agrave; chaque appel achemin&eacute; (entrant ou sortant).Le temps d\'antenne pour toute la dur&eacute;e de l\'appel est factur&eacute; au tarif applicable au d&eacute;but de l\'appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels achemin&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN. Les frais pour les appels internationaux ou en itin&eacute;rance peuvent &ecirc;tre factur&eacute;s &agrave; partir du moment o&ugrave; vous appuyez sur ENVOYER, jusqu\'&agrave; ce que vous appuyez sur FIN, que vous ayez termin&eacute; ou non l\'appel. Les frais de temps d&rsquo;antenne (plus les frais d&rsquo;interurbain, s&rsquo;il y a lieu) s&rsquo;appliquent aux appels entrants re&ccedil;us sur l&rsquo;appareil sans fil jusqu&rsquo;&agrave; ce que vous appuyiez sur FIN. Les frais de temps d\'antenne sont factur&eacute;s d&egrave;s que l\'on appuie sur ENVOYER pour effectuer un appel et comprennent le temps de sonnerie.</li><li>Zone d&rsquo;appels locaux et interurbains. Une zone d&rsquo;appels locaux est une zone o&ugrave; vous pouvez faire et recevoir des appels locaux sans frais d&rsquo;interurbain. Les appels peuvent &ecirc;tre soit locaux, soit interurbains, selon les zones d\'appels locaux. L&rsquo;endroit o&ugrave; vous vous trouvez au moment de l&rsquo;appel, votre num&eacute;ro de sans-fil et le num&eacute;ro de t&eacute;l&eacute;phone que vous composez sont des &eacute;l&eacute;ments importants pour d&eacute;terminer les zones d&rsquo;appels locaux et le traitement des appels interurbains. Votre zone d&rsquo;appels locaux entrants est d&eacute;termin&eacute;e par l\'emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;int&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels locaux. Tous les appels re&ccedil;us lorsque vous vous trouvez &agrave; l&rsquo;ext&eacute;rieur de votre zone d&rsquo;appels locaux entrants sont consid&eacute;r&eacute;s comme des appels interurbains. Votre zone d\'appels locaux sortants est d&eacute;termin&eacute;e par votre emplacement physique. Si vous composez un num&eacute;ro local lorsque vous vous trouvez dans la zone de ce num&eacute;ro, il s&rsquo;agit d&rsquo;un appel local. Si vous composez un num&eacute;ro &agrave; l&rsquo;ext&eacute;rieur de la zone o&ugrave; vous vous trouvez, il s&rsquo;agit d&rsquo;un appel interurbain. Lorsque vous utilisez le service Renvoi d&rsquo;appel, des frais d&rsquo;interurbain s&rsquo;appliquent lorsque le num&eacute;ro vers lequel vous transf&eacute;rez l&rsquo;appel se trouve &agrave; l&rsquo;ext&eacute;rieur de l\'emplacement g&eacute;ographique associ&eacute; &agrave; votre num&eacute;ro de sans-fil, et ce, peu importe o&ugrave; vous vous trouvez. Consultez rogers.com/interurbain pour conna&icirc;tre les tarifs interurbains en vigueur.</li></ol></li><li>Couverture &eacute;tendue (ne s&rsquo;applique pas au service pr&eacute;pay&eacute;). Si vous avez acc&egrave;s &agrave; une couverture &eacute;tendue, cette couverture ne devrait servir qu&rsquo;&agrave; une utilisation limit&eacute;e et occasionnelle, et l&rsquo;essentiel de votre utilisation mensuelle doit s&rsquo;effectuer sur le r&eacute;seau de Rogers. Nous pouvons restreindre ou limiter votre acc&egrave;s &agrave; la couverture &eacute;tendue si l&rsquo;essentiel de votre utilisation mensuelle est effectu&eacute;e dans les zones de la couverture &eacute;tendue, et ce de fa&ccedil;on continue. Lorsque vous utilisez la couverture &eacute;tendue, certains services ou certaines fonctionnalit&eacute;s ne sont pas disponibles ou ne fonctionnent pas pleinement. Pour plus de renseignements sur la disponibilit&eacute; limit&eacute;e de certains services ou de certaines fonctionnalit&eacute;s lorsque vous utilisez la couverture &eacute;tendue, consultez le rogers.com/couverture.</li><li>Documents et ressources suppl&eacute;mentaires<ol><li>Documents connexes. En plus d&rsquo;&ecirc;tre r&eacute;gie par vos Ententes de service, votre utilisation des Services est &eacute;galement r&eacute;gie par les documents connexes suivants, dont vous pouvez obtenir un exemplaire au rogers.com :<ul><li>Modalit&eacute;s de service : Nos Modalit&eacute;s de service r&eacute;gissent votre utilisation de tous les Services de Rogers et expliquent certains de nos droits et obligations l&eacute;gaux respectifs. Les Modalit&eacute;s de service comprennent des renseignements sur la fa&ccedil;on dont nous pouvons apporter des changements &agrave; vos Services et Ententes de service, la facturation des Services, la suspension ou la r&eacute;siliation de vos Services et des d&eacute;tails juridiques sur la limitation de la responsabilit&eacute;, les garanties et l&rsquo;indemnisation.</li><li>Politique d\'utilisation acceptable : Notre Politique d\'utilisation acceptable d&eacute;crit les r&egrave;gles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. La Politique d\'utilisation acceptable pr&eacute;voit des exemples d&rsquo;activit&eacute;s interdites et de contenu ill&eacute;gal ou inappropri&eacute; et nous donne le droit de retirer du contenu et de suspendre vos Services ou d&rsquo;y mettre fin si vous contrevenez &agrave; la Politique d&rsquo;utilisation acceptable.</li><li>Politique de protection de la vie priv&eacute;e : Notre Politique de protection de la vie priv&eacute;e d&eacute;crit nos politiques relativement &agrave; la cueillette, &agrave; l&rsquo;utilisation et &agrave; la divulgation de vos renseignements personnels. Notre Politique de protection de la vie priv&eacute;e vous informe des raisons pour lesquelles nous recueillons de l&rsquo;information sur nos clients, de la fa&ccedil;on dont nous utilisons et partageons cette information et de la fa&ccedil;on de communiquer avec nous si vous souhaitez obtenir plus de d&eacute;tails sur nos pratiques de traitement des renseignements personnels.</li><li>Guide de l&rsquo;utilisateur : Notre Guide de l&rsquo;utilisateur vous explique la configuration de votre appareil, le fonctionnement de la facturation, la facturation des services voix et donn&eacute;es sans fil, la facturation des services en itin&eacute;rance et des appels interurbains, le fonctionnement du service d&rsquo;assistance 9-1-1 et la gestion de votre compte.</li></ul></li><li>Gestion de votre facture. Pour conna&icirc;tre les outils qui vous aident &agrave; g&eacute;rer votre facture, notamment les notifications sur l&rsquo;utilisation des donn&eacute;es et l&rsquo;itin&eacute;rance, les plafonds de donn&eacute;es et les outils de surveillance de l&rsquo;utilisation, veuillez visiter le rogers.com ou ouvrir une session dans votre compte Mon Rogers pour obtenir des d&eacute;tails sur votre utilisation r&eacute;elle.</li><li>Zone et cartes de couverture de service. Pour en savoir davantage sur notre zone de couverture de service, y compris nos cartes de couverture de service compl&egrave;tes, visitez le rogers.com/couverture.</li><li>Code sur les services sans fil. Pour consulter le Code sur les services sans fil du Conseil de la radiodiffusion et des t&eacute;l&eacute;communications canadiennes (le &laquo; CRTC &raquo;), visitez le site Web du CRTC au http://crtc.gc.ca/fra/info_sht/t13.htm.</li></ol></li></ol></div><div class=\"paragraph\">En concluant la pr&eacute;sente Entente de service ou les pr&eacute;sentes Ententes de service, vous :<ul><li>autorisez Rogers &agrave; recueillir et &agrave; utiliser vos donn&eacute;es de localisation personnelles courantes et historiques associ&eacute;es &agrave; tout appareil que vous utilisez aux termes de la pr&eacute;sente Entente de service ou des pr&eacute;sentes Ententes de service pour vous fournir des services de g&eacute;olocalisation, &eacute;tant entendu que vous pouvez vous d&eacute;sabonner de ces services en tout temps;</li><li>acceptez de recevoir les documents que nous vous fournissons en format &eacute;lectronique.</li></ul></div><div class=\"paragraph\">AMA 1/15</div>");
$templateCache.put("views/localization/account-maintenance-agreement.html","<div class=\"bold paragraph\">IMPORTANT INFORMATION ABOUT YOUR WIRELESS SERVICE</div><div class=\"paragraph\">This information is in addition to and forms part of our Service Agreement(s) with you and must be read in conjunction with the current Rogers Terms of Service, Acceptable Use Policy and Privacy Policy provided to you and posted on rogers.com (and which replace the Rogers Terms of Service, Acceptable Use Policy and Privacy Policy previously provided to you), and any other Rogers brochure or online material describing the plans, features, services and/or products you have selected and the Starting Up Guide that are currently in effect. Any new changes to your Service Agreement(s) are set out herein. All other aspects of your Service Agreement(s) remain the same. You acknowledge that any Services you have removed may no longer be available.</div><div class=\"paragraph\"><ol><li>Fee Descriptions<ol><li>Where applicable, the following monthly government 9-1-1 fees apply: 62&cent; in Saskatchewan, 40&cent; in Qu&eacute;bec, 43&cent; in Nova Scotia, 53&cent; in New Brunswick, 70&cent; in Prince Edward Island, 44&cent; in Alberta, and 75&cent; in Newfoundland and Labrador. However, there is no airtime charge for calls made to 9-1-1 from your Rogers wireless device.</li><li>Where applicable, the Government Regulatory Recovery Fee will be charged to help fund fees, costs and other amounts related to federal, provincial and/or municipal mandates, programs and requirements. This fee is not a tax or charge the government requires Rogers to collect.</li><li>Where applicable, additional airtime, data, long distance, roaming, pay-per-use charges and taxes are extra and billed monthly. For more information on the Services you have subscribed to, please refer to the Rogers brochure describing your plan or add-on, or visit rogers.com.</li></ol></li><li>Categories of Services/Service Agreements. For greater certainty, the Services referenced herein are categorized as follows:<ol><li>Term Services. Term Services means any Services that you subscribe to for a Commitment Period as identified above with a corresponding Service Agreement Term or Data Term. Every Term Service that you subscribe to constitutes a separate Service Agreement with us. We will not increase the monthly service fee or local per-minute airtime rate for, or decrease the amount of minutes or data included with, a Term Service during its Commitment Period.</li><li>Month-to-Month Services. Month-to-Month Services means any Services that you subscribe to on an ongoing basis, but not with a Commitment Period. Month-to-Month Services are identified above without a corresponding Service Agreement Term or Data Term, and every Month-to-Month Service that you subscribe to constitutes a separate Service Agreement with us. For more information on Month-to-Month Services, including rates for such optional services, please refer to the current Rogers brochures or visit rogers.com. We may change Month-to-Month Services in accordance with the Rogers Terms of Service.</li><li>Pay-Per-Use Services. Pay-Per-Use Services means any Services that you receive from Rogers on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis. Pay-Per-Use Services available to you include the following. For more information on Pay-Per-Use Services, including rates, please refer to the current Rogers brochures or visit rogers.com. We may change Pay-Per-Use Services in accordance with the Rogers Terms of Service.<ol><li>Roaming. Please note that substantial roaming charges may be incurred if your device is taken outside the Rogers network even if no services are intentionally used. Whenever you travel outside the Rogers network, your usage is routed through the wireless network of another carrier. Usage outside the Rogers network will result in roaming charges. Such usage includes (but is not limited to): calling; text, picture and video messaging; and data usage (including, but not limited to, apps usage, email, instant messaging, visual voicemail and web browsing). Visit rogers.com/roaming for roaming pay-per-use rates, options and destinations.</li><li>Text, Picture and Video Messaging Pay-Per-Use Service. Text, Picture and Video messaging service will be enabled on compatible devices. A pay-per-use fee will apply for each message sent or received (not applicable if you subscribe to an add-on, bundle, pack or plan that includes the relevant messaging). Sent/received premium messages (alerts, messages related to content and promotions) are charged at applicable rates. Roaming charges apply while roaming.</li><li>Pay-Per-Use Data. Data service will be enabled on compatible devices. A daily usage fee will apply (not applicable if you subscribe to a data plan or add-on). Roaming charges apply while roaming.</li><li>Video Calling Pay-Per-Use Service. Video Calling service will be enabled on compatible devices. A pay-per-use fee will apply for each minute of Video Calling placed and received. Airtime and long distance charges are not included. Roaming charges apply while roaming.</li><li>Call Waiting and Group Calling. Airtime charges apply as per your price plan (plus long distance or roaming, if applicable).</li><li>Call Forwarding. Call Forwarding can be added to your plan (if not already included). Call Forwarding allows your call to be forwarded to another number and includes 2,500 local Call Forwarding minutes per month. Additional Call Forwarding minutes are charged at the rate described in your price plan or add-on (plus long distance or roaming, if applicable).</li><li>Voicemail. Airtime charges, or data charges for visual voicemail, apply as per your price plan (plus long distance or roaming, if applicable).</li><li>411 Directory Assistance. A service fee and airtime charges apply (plus long distance or roaming, if applicable), even if the number you have requested is unlisted.</li></ol></li></ol></li><li>Calculating Your Downgrade Fee (applicable to Term Services only). If, for any reason, you downgrade to a lower tier plan category during your Term, you may be charged a price plan downgrade fee. The downgrade fee is calculated as the difference between the Economic Inducement you received and the economic inducement available in the lower tier plan category you are downgrading to, multiplied by the number of months remaining in your Service Agreement Term at the time you downgrade (plus applicable taxes). If applicable, the downgrade amount set out in the “Downgrading Your Plan” section of your agreement will be used to calculate any applicable downgrade fee. If we introduce new plan categories or change our existing plan categories, the economic inducement available in these new plan categories will be used to calculate any applicable downgrade fee. If you pay a downgrade fee, the Economic Inducement set out on your most recent agreement will be reduced by the downgrade fee amount for the purpose of calculating any Device Savings Recovery Fee.</li><li>Termination and Amendment<ol><li>General. You may terminate your Service at any time (in accordance with the Rogers Terms of Service), including at the expiry of any Commitment Period, or make changes to your Service, by contacting us at 1 888 ROGERS1 (764-3771). If you upgrade your device or change a Term Service, you may be required to renew your Commitment Period and/or enter into a new Service Agreement with us for a new Commitment Period.</li><li>Automatic Extension. At the end of your Commitment Period, your plan will automatically default to a month-to-month term. Rogers may contact you at any time to propose a renewal of your plan. If you do not wish to renew your plan when contacted, you will retain your existing plan and your existing agreement with us, unchanged, until those are changed or terminated in accordance with the terms of the Service Agreement governing that plan.</li><li><p>Device Savings Recovery Fee (applicable to Term Services only for any new term entered into on or after January 22, 2012). A Device Savings Recovery Fee (DSRF) applies if you were given an economic inducement when you agreed to your new term, and if, for any reason, your wireless service or your new term is terminated prior to the end of the term of your Service Agreement (Service Agreement Term). The DSRF is equal to the economic inducement multiplied by the number of months remaining in your Service Agreement Term divided by the total number of months of your Service Agreement Term (plus applicable taxes). In other words, DSRF = Economic Inducement x # months left in your Service Agreement Term &divide; Total # months in your Service Agreement Term + applicable taxes.</p><p>An Additional Device Savings Recovery Fee (ADSRF) also applies if, for any reason, your wireless data service, or your data plan\'s commitment term (Data Term), is terminated prior to the end of your Data Term. The ADSRF is based on the additional economic inducement you received for subscribing to your wireless data service, is calculated using the same formula used to calculate the DSRF (but substituting Economic Inducement with Additional Economic Inducement and Service Agreement Term with Data Term), and applies in addition to the DSRF for termination of your Service Agreement. If you subscribe to a plan combining both voice and data services, both the DSRF and the ADSRF apply.</p></li><li>Service Deactivation Fee (applicable to Term Services only for any new term entered into between January 22, 2012 and December 1, 2013). Not applicable to Residents of Manitoba, Residents of Newfoundland for any new term entered into on or after September 27, 2012, Residents of Nova Scotia for any new term entered into on or after May 1, 2013, or Residents of Qu&eacute;bec: A Service Deactivation Fee of $12.50 per line (plus applicable taxes) applies if, for any reason, your wireless service is deactivated prior to the end of your Service Agreement Term. This fee is in addition to any applicable DSRF or DSRF and ADSRF.</li><li>Trial Period. Rogers may allow for the cancellation of your Service without any DSRF with the following conditions: 1) the device is returned in complete and original condition as specified in the document entitled How to Return Your Rogers Wireless Purchase, enclosed with your device and 2) cancellation is requested within 15 days from date of activation and 3) your account has incurred less than 30 minutes of airtime usage. You will be billed for all charges incurred up to the point of deactivation.</li></ol></li><li>Device Information<ol><li>New or Refurbished Devices. Your device is new, unless otherwise indicated.</li><li>Device Locking. Your device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your device, the Device Unlock Fee set out above will apply. If you were given an Economic Inducement, we will not unlock your device within the first 90 days of your Service Agreement Term.</li><li>Warranty. Please see the materials accompanying your device for warranty information and details, including coverage, duration and how you may make a claim under any applicable warranty.</li><li>Rebated Goods. Any device provided to you for $0 is provided as a rebated good and not a free good.</li></ol></li><li><ol>Security Deposit<li>Security Deposit Conditions. We may require you to provide us with a security deposit or impose other payment or credit requirements (e.g., interim payments; mandatory pre-payments; pre-approved card or bank payments) at any time and on such terms as determined in our sole discretion. Any security deposit you provide to us will be kept for a minimum of 12 months, unless your Services are terminated sooner. After 12 months, we may release and apply the security deposit against your account balance if we, in our sole discretion, determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit.</li><li>Interest on Security Deposit. You will earn interest on any security deposit held by us, using the Bank of Canada\'s overnight rate in effect at the time, plus one percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</li><li>Use and Return of Security Deposit. We may apply your entire security deposit toward your account if payment of an amount due on your account is not received by us by the required payment date specified by us and we may require you to replenish the security deposit after such use. We will notify you upon applying all or part of any security deposit. We will return to you any security deposit with applicable interest within 30 days of termination of your Services or once we have determined that the conditions for returning the security deposit have been met.</li></ol></li><li>Share Plans. You agree that if the main line under your share plan (as applicable) is cancelled leaving additional lines, one of the additional lines will be automatically assigned as the main line and continue on the same plan as, or a plan similar in value to, the plan that the original main line was subscribed to. You further agree that if the number of lines activated under your plan falls below the required minimum, Rogers may migrate your remaining line(s) to another plan similar in value to your current plan.</li><li>How Airtime and Long Distance Calling Are Charged<ol><li>Airtime Charges. Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed calls from the time you press SEND until you press END. For international calls or while roaming, you may be charged from the time you press SEND until you press END regardless of whether the call is completed. Airtime charges (plus long distance, if applicable) apply to every call you answer on your wireless phone until you press END. Charges will start at the moment the calling party initiates the call by pressing SEND and includes the ring time.</li><li>Local and Long Distance Calling Areas. Local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your Incoming Local Calling Area is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your Outgoing Local Calling Area is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</li></ol></li><li>Extended Coverage (not applicable to prepaid service). If you have access to extended coverage, it is meant for limited and occasional use and the majority of your monthly usage must occur within the Rogers network. We may restrict or limit your access to extended coverage if the majority of your monthly usage occurs within extended coverage areas, on an ongoing basis. While using extended coverage, certain services or features are not available or have limited functionality. For details on limited services or features while using extended coverage, please visit rogers.com/coverage.</li><li>Additional Documents and Resources<ol><li>Related Documents. In addition to your Service Agreement(s), your use of the Services is governed by the following related documents, current copies of which can be accessed at rogers.com:<ul><li>Terms of Service: Our Terms of Service govern your use of all of your Rogers Services and explain some of our respective legal rights and obligations. The Terms of Service include details on how we can make changes to your Services and Service Agreement(s), how you will be charged for Services, how your Services can be suspended or terminated, and legal details on limitation of liability, warranties and indemnification.</li><li>Acceptable Use Policy: Our Acceptable Use Policy sets out the rules, policies and limits you must abide by when using the Services. The Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the Acceptable Use Policy.</li><li>Privacy Policy: Our Privacy Policy sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy provides information on why we collect customer information, how we use and share this information and specifies how to contact us if you would like more information on our personal information handling practices.</li><li>Starting Up Guide: Our Starting Up Guide provides you with information on how to set up your device, how billing works, how wireless voice and data services are charged, how roaming and long distance is charged, how 9-1-1 emergency assistance works and how to manage your account.</li></ul></li><li>Managing Your Bill. For information on tools to help you manage you bill, including notifications on data usage and roaming, data caps and usage monitoring tools, please visit rogers.com or log into your MyRogers account to view details on your actual usage.</li><li>Service Coverage Area and Maps. For information on our service coverage area, including our complete service coverage maps, please visit rogers.com/coverage.</li><li>Wireless Code. For information on the Canadian Radio-television and Telecommunications Commission (CRTC)\'s Wireless Code, please visit the CRTC website at http://crtc.gc.ca/eng/info_sht/t13.htm.</li></ol></li></ol></div><div class=\"paragraph\">By entering into this/these Service Agreement(s), you:<ul><li>authorize Rogers to collect and use your current and historical personal location information associated with any device you use under this/these Service Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.</li><li>agree to receive any Materials we provide to you in electronic format.</li></ul></div><div class=\"paragraph\">AMA 1/15</div>");
$templateCache.put("views/localization/deposit-credit-requirements-fr.html","<div class=\"bold paragraph\">Exigences en mati&egrave;re de d&eacute;p&ocirc;t et de cr&eacute;dit</div><div class=\"paragraph\"><p>Tout d&eacute;p&ocirc;t de garantie que vous nous fournissez sera conserv&eacute; pendant au moins <strong>12</strong> mois, sauf si vous mettez fin &agrave; vos Services avant la fin de cette p&eacute;riode. Apr&egrave;s <strong>12</strong> mois, nous pouvons lib&eacute;rer le d&eacute;p&ocirc;t de garantie et l&rsquo;appliquer au solde de votre compte si nous jugeons que votre historique de paiement est satisfaisant ou que vous r&eacute;pondez aux crit&egrave;res financiers pour le remboursement de votre d&eacute;p&ocirc;t de garantie. Nous pouvons appliquer votre d&eacute;p&ocirc;t de garantie &agrave; votre solde si vous n&rsquo;acquittez pas votre facture, et nous pouvons vous demander de r&eacute;approvisionner le d&eacute;p&ocirc;t de garantie apr&egrave;s une telle utilisation. Nous vous aviserons de toute utilisation d&rsquo;une partie ou de la totalit&eacute; du d&eacute;p&ocirc;t de garantie. Nous vous rembourserons le d&eacute;p&ocirc;t de garantie avec les int&eacute;r&ecirc;ts cumul&eacute;s dans les <strong>30</strong> jours suivant la r&eacute;siliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du d&eacute;p&ocirc;t de garantie sont remplies.</p><p>c. Mon d&eacute;p&ocirc;t de garantie porte-t-il int&eacute;r&ecirc;t?</p><p>Oui, tout d&eacute;p&ocirc;t de garantie que nous d&eacute;tenons portera int&eacute;r&ecirc;t au taux de financement &agrave; un jour de la Banque du Canada en vigueur &agrave; ce moment major&eacute; de <strong>1</strong> pour cent, selon le nombre r&eacute;el de jours dans l&rsquo;ann&eacute;e, calcul&eacute; chaque mois. Les int&eacute;r&ecirc;ts seront cumul&eacute;s &agrave; partir de la date &agrave; laquelle nous recevons votre d&eacute;p&ocirc;t de garantie (mais pas avant le moment prescrit par la l&eacute;gislation ou la r&eacute;glementation en vigueur) jusqu&rsquo;&agrave; la date &agrave; laquelle nous vous le remettons.</p><p>d. Rogers imposera-t-elle une limite de cr&eacute;dit &agrave; mon compte?</p><p>En vous donnant un avis &agrave; cet effet, nous pouvons attribuer ou modifier une limite de cr&eacute;dit &agrave; votre compte, en tout temps. Le Service pourra &ecirc;tre suspendu en tout temps, pour n&rsquo;importe lequel de vos comptes, si votre solde, y compris l&rsquo;utilisation non factur&eacute;e et les frais, les montants et les redressements en attente, d&eacute;passe cette limite. Les frais de service r&eacute;currents continueront de s&rsquo;appliquer pendant toute suspension des Services.</p></div>");
$templateCache.put("views/localization/deposit-credit-requirements.html","<div class=\"bold paragraph\">DEPOSIT AND CREDIT REQUIREMENTS</div><div class=\"paragraph\"><p>a. Does Rogers require security deposits or other payment or credit requirements?</p><p>Yes, we may require a security deposit or impose other payment or credit requirements such as interim payments, mandatory pre-payments, or pre-authorized payments.</p><p>b. How are security deposits used?</p><p>Any security deposit you provide to us will be kept for at least <strong>12</strong> months, unless your Services are cancelled sooner. After <strong>12</strong> months, we may release and apply the security deposit against your account balance if we determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit. We may apply your security deposit toward your account if you do not pay your bill and we may require you to replenish the security deposit after use. We will notify you when we apply all or part of any security deposit. We will return to you any security deposit with applicable interest within <strong>30</strong> days of cancellation of your Services or once we have determined that the conditions for returning the security deposit have been met.</p><p>c. Will I earn any interest on security deposits?</p><p>Yes, you will earn interest on your security deposit with us, using the Bank of Canada&rsquo;s overnight rate in effect at the time, plus <strong>1</strong> percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</p><p>d. Will Rogers impose a credit limit on my account?</p><p>Upon notice to you, we may assign or change a credit limit on your account at any time. Service may be suspended at any time to any and all of your accounts if your balance, including unbilled usage and pending charges, fees and adjustments, exceeds this limit. Recurring service charges continue to apply during any suspension of Services.</p></div>");
$templateCache.put("views/localization/equipment-fr.html","<div class=\"bold paragraph\">&Eacute;quipement</div><div class=\"paragraph\"><p>a. L&rsquo;&Eacute;quipement est-il neuf ou remis &agrave; neuf?</p><p>Sauf indication contraire, l&rsquo;&Eacute;quipement que vous achetez de nous est neuf. Sauf indication contraire, l&rsquo;&Eacute;quipement que vous louez aupr&egrave;s de nous est remis &agrave; neuf et il est fourni selon la disponibilit&eacute;. Si vous avez achet&eacute; de l&rsquo;&Eacute;quipement aupr&egrave;s de nous et que vous avez obtenu une subvention sur cet &Eacute;quipement qui a fait en sorte que vous avez pay&eacute; <strong>0 $</strong> pour cet &Eacute;quipement, veuillez noter que cet &Eacute;quipement vous est fourni &agrave; rabais et non en tant qu&rsquo;&Eacute;quipement gratuit.</p><p>b. Puis-je rehausser mon &Eacute;quipement?</p><p>Vous pouvez rehausser votre &Eacute;quipement &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. Vous pourriez devoir payer des frais d&rsquo;administration conform&eacute;ment au paragraphe 3d) ci-dessus. Si, aux termes de votre rehaussement d&rsquo;&Eacute;quipement, vous concluez une nouvelle P&eacute;riode d&rsquo;abonnement et r&eacute;siliez de fa&ccedil;on anticip&eacute;e une P&eacute;riode d&rsquo;abonnement existante, vous devrez payer des Frais de r&eacute;siliation anticip&eacute;e. Veuillez noter que si vous souhaitez rehausser votre &Eacute;quipement, vous pourriez &eacute;galement devoir passer &agrave; un Service qui est offert &agrave; ce moment-l&agrave;, et que tout Service ou &Eacute;quipement annul&eacute; &agrave; votre demande pourrait ne plus &ecirc;tre disponible.</p><p>c. Mon &Eacute;quipement est-il verrouill&eacute; ou limit&eacute; aux Services ou au r&eacute;seau de Rogers?</p><p><strong>Pour les Services sans fil :</strong><br>Votre appareil sans fil est verrouill&eacute; et ne peut &ecirc;tre utilis&eacute; que sur le r&eacute;seau de Rogers ou encore sur ceux exploit&eacute;s par les fournisseurs avec lesquels nous avons conclu une entente d&rsquo;itin&eacute;rance. Si vous tentez de d&eacute;verrouiller votre appareil, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de votre appareil. Si vous souhaitez d&eacute;verrouiller votre appareil sans fil, les Frais de d&eacute;verrouillage mentionn&eacute;s dans votre entente de service sans fil s&rsquo;appliquent. Si vous avez obtenu une subvention sur votre appareil, nous ne d&eacute;verrouillerons votre appareil qu&rsquo;apr&egrave;s les <strong>90</strong> premiers jours de votre P&eacute;riode d&rsquo;abonnement. Veuillez prendre note que durant les <strong>90</strong> premiers jours suivant la Date de mise en service, si vous &ecirc;tes en itin&eacute;rance &agrave; l&rsquo;ext&eacute;rieur du r&eacute;seau Rogers, votre Service sera restreint et vous ne pourrez pas effectuer d&rsquo;appels sortants vers des destinations autres que celles qui ont un indicatif r&eacute;gional d&rsquo;Am&eacute;rique du Nord (incluant le Canada et les &Eacute;tats-Unis) et &agrave; l&rsquo;endroit o&ugrave; vous vous trouvez lorsque vous effectuez l&rsquo;appel (ne s&rsquo;applique pas au service pr&eacute;pay&eacute;).</p><p><strong>Pour les Services r&eacute;sidentiels :</strong><br>L&rsquo;&Eacute;quipement achet&eacute; ou lou&eacute; ne peut &ecirc;tre utilis&eacute; que dans le cadre des Services de Rogers, &agrave; l&rsquo;adresse de service indiqu&eacute;e dans votre compte. Si vous tentez de modifier l&rsquo;&Eacute;quipement, celui-ci pourrait devenir inutilisable de mani&egrave;re permanente et vous pourriez, ce faisant, contrevenir &agrave; la licence d&rsquo;utilisation du logiciel de l&rsquo;&Eacute;quipement.</p><p>d. Rogers devra-t-elle &eacute;ventuellement avoir acc&egrave;s &agrave; ma propri&eacute;t&eacute;?</p><p>Pour les Services r&eacute;sidentiels, vous nous autorisez, nous et nos repr&eacute;sentants, &agrave; acc&eacute;der &agrave; vos locaux ou &agrave; entrer dans vos locaux, au besoin, &agrave; un moment mutuellement convenu pour l&rsquo;installation, l&rsquo;entretien, l&rsquo;inspection, la r&eacute;paration, le retrait, le remplacement, l&rsquo;examen, la protection, la modification, la mise &agrave; niveau ou l&rsquo;am&eacute;lioration de l&rsquo;exploitation de nos services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux. Si vous r&eacute;siliez un ou plusieurs de vos Services ou comptes, vous nous autorisez, nous et nos repr&eacute;sentants, &agrave; acc&eacute;der &agrave; vos locaux ou &agrave; entrer dans vos locaux pour d&eacute;brancher les Services et retirer l&rsquo;&Eacute;quipement, le cas &eacute;ch&eacute;ant.</p><p>e. Qui est responsable de s&rsquo;assurer que mon &Eacute;quipement est &agrave; jour?</p><p>Il est possible que l&rsquo;&Eacute;quipement et les logiciels qui s&rsquo;y rattachent doivent respecter certaines exigences minimales et &ecirc;tre entretenus d&rsquo;une certaine fa&ccedil;on et &agrave; certains endroits afin d&rsquo;acc&eacute;der aux Services ou pour assurer le bon fonctionnement des Services (par exemple, services 9 1 1). Ces exigences peuvent changer de temps &agrave; autre, et vous &ecirc;tes responsable de la mise &agrave; jour ou de l&rsquo;entretien n&eacute;cessaires de votre &Eacute;quipement et des logiciels pour respecter de telles exigences. Nous pouvons fournir des mises &agrave; jour de logiciels pour l&rsquo;&Eacute;quipement pour les besoins du fonctionnement continu des Services ou de l&rsquo;&Eacute;quipement. De m&ecirc;me, nous pourrions devoir modifier ou d&eacute;sinstaller d&rsquo;anciennes fonctionnalit&eacute;s logicielles afin de fournir de nouvelles fonctionnalit&eacute;s et veiller &agrave; ce que l&rsquo;&Eacute;quipement demeure compatible avec les avanc&eacute;es technologiques. Si votre &Eacute;quipement ou vos logiciels ne sont pas &agrave; jour, nous pourrions ne pas &ecirc;tre en mesure de vous fournir le soutien technique voulu.</p><p>f. Quelles sont mes responsabilit&eacute;s relatives &agrave; l&rsquo;&Eacute;quipement?</p><p>Vous &ecirc;tes le seul responsable :<br>i. de tout acc&egrave;s &agrave; l&rsquo;&Eacute;quipement;<br>ii. de fournir toute connexion suppl&eacute;mentaire, ainsi que le filage interne et l&rsquo;&eacute;quipement du terminal de t&eacute;l&eacute;phonie r&eacute;sidentielle, qui ne sont pas fournis par nous;<br>iii.de la remise en service de votre &eacute;quipement et de vos installations dans la mesure n&eacute;cessaire apr&egrave;s la r&eacute;siliation de vos Services;<br>iv. du maintien de la s&eacute;curit&eacute; et de la confidentialit&eacute; de vos biens et de vos transmissions par l&rsquo;entremise des Services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux;<br>v. de la protection contre les manquements &agrave; la s&eacute;curit&eacute; ou &agrave; la confidentialit&eacute; ou contre les autres risques associ&eacute;s &agrave; l&rsquo;installation, &agrave; l&rsquo;utilisation, au maintien ou au changement des Services ou de l&rsquo;&Eacute;quipement;<br>vi. de vous assurer qu&rsquo;il n&rsquo;existe aucun branchement non autoris&eacute; &agrave; l&rsquo;&Eacute;quipement ou &agrave; notre c&acirc;ble (par exemple, pour l&rsquo;&Eacute;quipement de t&eacute;l&eacute;vision, une (1) seule t&eacute;l&eacute;vision peut &ecirc;tre raccord&eacute;e &agrave; une prise).<br></p><p>Sauf en ce qui concerne l&rsquo;&Eacute;quipement que vous avez pay&eacute; en entier, tout l&rsquo;&Eacute;quipement que nous installons ou que nous vous fournissons demeure notre propri&eacute;t&eacute;. En ce qui concerne tout l&rsquo;&Eacute;quipement dont nous sommes propri&eacute;taires, vous devez :</p><p>i. en prendre un soin raisonnable;<br>ii. ne pas le vendre, le louer, l&rsquo;hypoth&eacute;quer, le transf&eacute;rer, le c&eacute;der ou le grever de quelque fa&ccedil;on que ce soit;<br>iii.ne pas le d&eacute;m&eacute;nager sans notre connaissance et notre permission;<br>iv. nous le retourner &agrave; vos propres frais advenant la r&eacute;siliation des Services auxquels l&rsquo;&Eacute;quipement est rattach&eacute;.</p><p>Si notre &Eacute;quipement est perdu, endommag&eacute;, vol&eacute;, vendu, lou&eacute;, hypoth&eacute;qu&eacute;, transf&eacute;r&eacute;, c&eacute;d&eacute; ou grev&eacute;, ou qu&rsquo;il ne nous est pas retourn&eacute;, vous devez nous en avertir imm&eacute;diatement. Vous convenez de nous payer la valeur au d&eacute;tail non escompt&eacute;e d&rsquo;un tel &Eacute;quipement, ainsi que tous les frais encourus par nous pour reprendre possession d&rsquo;un tel &Eacute;quipement.</p></div>");
$templateCache.put("views/localization/equipment.html","<div class=\"bold paragraph\">EQUIPMENT</div><div class=\"paragraph\"><p>a. Is Equipment new or refurbished?</p><p>Equipment that you purchase from us is new, unless otherwise indicated. Equipment that you rent from us is refurbished, unless otherwise indicated, and is based on availability. If you have purchased Equipment from us and have received a subsidy on that Equipment resulting in a charge of <strong>$0</strong>, please note that that Equipment has been provided to you as a subsidized good and not a free good.</p><p>b. May I upgrade my Equipment?</p><p>You may upgrade your Equipment at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) above. If, in connection with your Equipment upgrade, you are subscribing to a new Term and cancelling a previous Term early, you will be charged an Early Cancellation Fee. Please note that if you wish to upgrade your Equipment, you may also be required to change to a Service that is currently available in market. Also please note that any Service or Equipment you remove may no longer be available.</p><p>c. Is my Equipment locked or restricted to the Rogers network or Services?</p><p><strong>For wireless Services:</strong><br>Your wireless device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your wireless device, the Device Unlock Fee set out in your wireless service agreement will apply. If you were given a device subsidy, we will only unlock your device after the first <strong>90</strong> days of your Term. Please also note that for the first <strong>90</strong> days following the Activation Date, if you are roaming off the Rogers network, your Service will be restricted from placing outgoing calls to destinations other than those that have a North American area code (including Canada and the USA) and the destination at which are located while placing the call (not applicable to prepaid service).</p><p><strong>For residential Services:</strong><br>Purchased and rental Equipment are to be used only with Rogers Services at the service address identified on your account. If you attempt to tamper with any Equipment, it may become permanently unusable and may violate the software licence agreement for that Equipment.</p><p>d. Will Rogers ever need access to my property?</p><p>For residential Services, you authorize us and our representatives to enter or have access to your premises as necessary at mutually agreed upon times to install, maintain, inspect, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of our services, the Equipment or our facilities or networks. If any of your Services or accounts have been cancelled, then you authorize us and our representatives to enter or have access to your premises to disconnect the Services and remove our Equipment, as applicable.</p><p>e. Who is responsible for ensuring that my Equipment is up to date?</p><p>Equipment and related software may have to meet certain minimum requirements and be maintained in certain ways and in certain locations in order to access the Services or for the proper operation of the Services (e.g., 9-1-1 services). Those requirements may change from time to time and you are responsible for updating or maintaining your Equipment and software as necessary to meet those requirements. We may provide software updates for the Equipment for the continued operation of the Services or the Equipment. Likewise, from time to time we may have to modify or remove previous software features in order to introduce new features to ensure that the Equipment remains compatible with technological advancements. If your Equipment or software is not up to date, we may not be able to provide you with applicable customer support.</p><p>f. What are my responsibilities relating to the Equipment?</p><p>You are solely responsible for:</p><p>i. any access to the Equipment;<br>ii. providing any additional connections, as well as inside wiring and home phone terminal equipment, that are not provided by us;<br>iii.reconnecting any of your equipment and facilities as necessary after cancellation of your Services;<br>iv. maintaining the security and privacy of your property and your transmissions using the Services, the Equipment or our facilities or networks;<br>v. protecting against any breaches of security or privacy or other risks involved in installing, using, maintaining or changing the Services or the Equipment; and<br>vi. ensuring that there are no unauthorized attachments to the Equipment or our cable ( e.g., for television Equipment, only <strong>1</strong> television may be attached to any outlet).</p><p>Except for Equipment that you have fully paid for, all Equipment we install or provide to you remains our property. For all Equipment we own, you must:</p><p>i. take reasonable care of it;<br>ii. not sell, lease, mortgage, transfer, assign or encumber it;<br>iii.not re-locate it without our knowledge and permission; and<br>iv. return it to us at your own expense upon cancellation of the Services to which the Equipment is related.<br>If our Equipment is lost, damaged, stolen, sold, leased, mortgaged, transferred, assigned, encumbered or not returned, you must immediately notify us. You agree to pay us the undiscounted retail value of that Equipment, together with any costs we incur in seeking possession of it.</p></div>");
$templateCache.put("views/localization/general-fr.html","<div class=\"bold paragraph\">Dispositions g&eacute;n&eacute;rales</div><div class=\"paragraph\"><p>a. Comment puis-je r&eacute;soudre une plainte ou un diff&eacute;rend avec Rogers?</p><p>Si vous avez une plainte ou une pr&eacute;occupation non r&eacute;solue, nous vous invitons &agrave; remplir et &agrave; soumettre un formulaire Signaler un probl&egrave;me (que vous trouverez &agrave; l&rsquo;adresse <a href=\"http://www.rogers.com/contacteznous\">rogers.com/contacteznous</a>). Nous vous r&eacute;pondrons le jour ouvrable suivant. Si vous n&rsquo;&ecirc;tes pas satisfait de la fa&ccedil;on dont un membre de notre direction a r&eacute;solu votre plainte, vous avez &eacute;galement la possibilit&eacute; de vous adresser au Bureau du President ou directement au bureau de l&rsquo;Ombudsman.</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** : Dans les limites maximales permises par la loi applicable</strong>, &agrave; moins d&rsquo;un accord de notre part, toute r&eacute;clamation ou tout diff&eacute;rend, de nature contractuelle ou d&eacute;lictuelle, en vertu de la loi ou d&rsquo;un r&egrave;glement, ou toute autre r&eacute;clamation ou tout autre diff&eacute;rend, de nature pr&eacute;existante, pr&eacute;sente ou future, d&eacute;coulant de quelque fa&ccedil;on des &eacute;l&eacute;ments suivants ou s&rsquo;y rapportant, sera r&eacute;gl&eacute; par arbitrage final et liant les parties, &agrave; l&rsquo;exclusion des tribunaux :</p><p>i. une Entente;<br>ii. les Services ou l&rsquo;&Eacute;quipement;<br>iii.les d&eacute;clarations verbales ou &eacute;crites, la publicit&eacute; ou les promotions associ&eacute;es &agrave; une Entente, aux Services ou &agrave; l&rsquo;&Eacute;quipement; ou<br>iv. la relation d&eacute;coulant d&rsquo;une Entente.</p><p><strong>Le cas &eacute;ch&eacute;ant</strong>, l&rsquo;arbitrage sera men&eacute; dans la province o&ugrave; vous habitez et sera simplifi&eacute; et men&eacute; de fa&ccedil;on exp&eacute;ditive par <strong>UN</strong> arbitre conform&eacute;ment aux lois et r&egrave;glements en vigueur ayant trait &agrave; l&rsquo;arbitrage commercial dans la province ou dans l&rsquo;administration o&ugrave; vous habitez &agrave; la date de l&rsquo;avis. Rogers paiera tous les frais raisonnables associ&eacute;s &agrave; cet arbitrage. Tout arbitrage sera men&eacute; conform&eacute;ment &agrave; notre Protocole d&rsquo;arbitrage, lequel est disponible &agrave; l&rsquo;adresse <a href=\"\">rogers.com/modalites</a>.</p><p>b. Qu&rsquo;arrive-t-il si une partie d&rsquo;une Entente devient inex&eacute;cutoire ou cesse de s&rsquo;appliquer?</p><p>Si une portion d&rsquo;une Entente est inex&eacute;cutoire, ses autres dispositions demeurent pleinement en vigueur. Notre d&eacute;faut &agrave; faire appliquer de fa&ccedil;on stricte une des dispositions d&rsquo;une Entente ne constitue pas une renonciation &agrave; quelque disposition ou &agrave; quelque droit que ce soit &agrave; l&rsquo;&eacute;gard de la pr&eacute;sente Entente. Ni le cours des affaires entre nous ni les pratiques commerciales ne pourront &ecirc;tre invoqu&eacute;s pour modifier quelque disposition que ce soit d&rsquo;une Entente.</p><p>c. Comment puis-je obtenir une version en anglais des pr&eacute;sentes Modalit&eacute;s?</p><p>Si vous souhaitez obtenir une version en anglais des pr&eacute;sentes Modalit&eacute;s, consultez le site Web &agrave; l&rsquo;adresse <a href=\"http://rogers.com/terms\">rogers.com/terms</a> ou demandez-en une copie en magasin.</p><p>d. Quelles lois s&rsquo;appliquent aux pr&eacute;sentes Modalit&eacute;s et aux autres parties de mon Entente?</p><p>Chaque Entente est r&eacute;gie exclusivement par les lois de la province o&ugrave; se situe votre adresse de facturation, et vous reconnaissez et acceptez la comp&eacute;tence exclusive des tribunaux de cette province. Toutefois, si votre adresse de facturation est situ&eacute;e &agrave; l&rsquo;ext&eacute;rieur du Canada, cette Entente sera r&eacute;gie exclusivement par les lois de la province d&rsquo;Ontario, et vous reconnaissez et acceptez la comp&eacute;tence des tribunaux de l&rsquo;Ontario. <strong>Veuillez noter que vos droits et recours peuvent varier selon chaque province</strong>.</p><p>e. Comment puis-je communiquer avec Rogers?</p><p>Pour communiquer avec nous :</p><p>i. rendez-vous dans un magasin Rogers;<br>ii. composez le 1 888 ROGERS-1 (1-888-764-3771) ou, &agrave; partir de votre sans-fil Rogers, composez *611 (cet appel est sans frais);<br>iii.visitez le <a href=\"http://rogers.com/contacteznous\">rogers.com/contacteznous</a> pour clavarder en direct;<br>iv. envoyer une t&eacute;l&eacute;copie au num&eacute;ro 1-800-219-6473; ou<br>v. &eacute;crivez au Service &agrave; la client&egrave;le de Rogers, &agrave; l&rsquo;adresse au 100, rue Westmorland, Moncton (Nouveau-Brunswick) E1C 0G1.</p><p>Tout avis de r&eacute;clamation doit &ecirc;tre transmis au Service juridique de Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9, et cet avis sera r&eacute;put&eacute; avoir &eacute;t&eacute; donn&eacute; &agrave; la date &agrave; laquelle il est envoy&eacute; par l&rsquo;exp&eacute;diteur.</p><p>* <strong>&laquo; R&eacute;sidents de Terre-Neuve-et-Labrador &raquo;</strong> d&eacute;signe les r&eacute;sidents de Terre-Neuve-et-Labrador qui concluent une Entente &agrave; laquelle s&rsquo;applique la loi intitul&eacute;e <i>Consumer Protection and Business Practices Act</i> (Terre-Neuve-et-Labrador);<br>** <strong>&laquo; R&eacute;sidents du Qu&eacute;bec &raquo;</strong> d&eacute;signe les r&eacute;sidents du Qu&eacute;bec qui concluent une Entente &agrave; laquelle s&rsquo;applique la <i>Loi sur la protection du consommateur</i> (Qu&eacute;bec).</p><p>&copy;2015 06/15</p></div>");
$templateCache.put("views/localization/general.html","<div class=\"bold paragraph\">GENERAL</div><div class=\"paragraph\"><p>a. How can I resolve a complaint or dispute with Rogers?</p><p>If you have a concern that was not resolved, then we invite you to submit a Share a Concern form (located at <a href=\"http://www.rogers.com/contactus\">rogers.com/contactus</a>) and we\'ll respond within <strong>1</strong> business day. If you\'re not satisfied with the resolution by one of our management team members, then you also have the option to speak to our Office of the President or even directly with the Ombudsman office.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**: To the extent permitted by applicable law</strong>, unless we agree otherwise, any claim or dispute, whether in contract or tort, under statute or regulation, or otherwise, and whether pre-existing, present or future, arising out of or relating to the following items will be determined by final and binding arbitration to the exclusion of the courts:</p><p>i. an Agreement;<br>ii. the Services or Equipment;<br>iii.oral or written statements, advertisements or promotions relating to an Agreement, the Services or Equipment; or<br>iv. the relationships that result from an Agreement.</p><p><strong>Where applicable</strong>, arbitration will be conducted in the province in which you reside, on a simplified and expedited basis by <strong>1</strong> arbitrator under the current laws and rules relating to commercial arbitration in the province or jurisdiction in which you reside on the date of the notice. Rogers will pay all reasonable costs associated with that arbitration. Any arbitration will be conducted in accordance with our Arbitration Protocol, which is available at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/terms\">rogers.com/terms</a>.</p><p>b. What happens if part of an Agreement becomes unenforceable or doesn\'t apply?</p><p>If any portion of an Agreement is unenforceable, the remaining provisions continue in full force. Our failure to enforce strict performance of any provision of an Agreement does not mean we have waived any provision or right. Neither the course of conduct between us nor trade practice modifies any provision of an Agreement.</p><p>c. What if I would prefer to have a copy of these Terms in French?</p><p>These Terms have been drawn up in the English language at the express request of the parties. Les pr&eacute;sentes modalit&eacute;s ont &eacute;t&eacute; r&eacute;dig&eacute;es en anglais &agrave; la demande expresse des parties. If you would like a copy of these Terms in French, please visit <a href=\"http://www.rogers.com/modalites\">rogers.com/modalit&eacute;s</a>, or request a copy in store.</p><p>d. What laws apply to these Terms and the rest of my Agreement?</p><p>Each Agreement is governed exclusively by the laws of the province in which your billing address is located and you submit to the exclusive jurisdiction of the courts of that province. However, if your billing address is outside of Canada, that Agreement is governed exclusively by the laws of the province of Ontario and you submit to the jurisdiction of the courts of Ontario. <strong>Please note that your rights and remedies may vary by province</strong>.</p><p>e. How can I contact Rogers?</p><p>To contact us:</p><p>i. visit a Rogers store;<br>ii. call 1-888-ROGERS1 (1-888-764-3771) or, from your Rogers wireless phone, call *611 (it\'s a free call);<br>iii.go online at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/contactus\">rogers.com/contactus</a> to use our live chat;<br>iv. send a fax to 1-800-219-6473; or<br>v. write to Rogers Customer Care, 100 Westmorland Street, Moncton, NB E1C 0G1.</p><p>Any notice of a claim must be given to the Rogers Legal Department, 333 Bloor Street East, Toronto, ON M4W 1G9 and will be deemed to have been given on the date on which it was sent by the party giving the notice.</p><p>* <strong>\"Residents of Newfoundland\"</strong> means residents of Newfoundland and Labrador who enter into an Agreement to which the <i>Consumer Protection and Business Practices Act</i> (Newfoundland and Labrador) applies.<br>** <strong>\"Residents of Qu&eacute;bec\"</strong> means residents of Qu&eacute;bec who enter into an Agreement to which the <i>Consumer Protection Act</i> (Qu&eacute;bec) applies.</p><p>&copy;2015 06/15</p></div>");
$templateCache.put("views/localization/intro-fr.html","<div class=\"bold paragraph\">INTRODUCTION</div><div class=\"paragraph\"><p>a. Comment les Modalit&eacute;s de service Rogers s&rsquo;appliquent-elles &agrave; moi?</p><p>Les pr&eacute;sentes Modalit&eacute;s de service Rogers (les &laquo; Modalit&eacute;s &raquo;) r&eacute;gissent votre utilisation :</p><p>i. des services de Rogers auxquels vous vous abonnez ou que vous achetez aux termes d&rsquo;une entente de service, ou que vous recevez de Rogers ou par son interm&eacute;diaire, y compris les services sans fil et les services r&eacute;sidentiels (les &laquo; Services &raquo;);<br>ii. de tout appareil ou &eacute;quipement dont vous vous servez pour acc&eacute;der aux Services ou que vous utilisez avec les Services (l&rsquo;&laquo; &Eacute;quipement &raquo;).<br>Dans les pr&eacute;sentes Modalit&eacute;s, les expressions &laquo; Rogers &raquo;, &laquo; nous &raquo;, &laquo; nos &raquo; et &laquo; notre &raquo; renvoient &agrave; l&rsquo;entit&eacute; de Rogers dont le nom figure dans l&rsquo;entente de service r&eacute;gissant le Service en particulier auquel vous vous abonnez. Les pr&eacute;sentes Modalit&eacute;s ne s&rsquo;appliquent pas aux services offerts par Rogers M&eacute;dia Inc. ou ses filiales.<br></p><p>b. Comment les Modalit&eacute;s de service Rogers r&eacute;gissent-elles mon entente de service et les autres documents qui me sont fournis?</p><p>Les pr&eacute;sentes Modalit&eacute;s s&rsquo;appliquent conjointement avec les documents suivants pour former ensemble votre entente compl&egrave;te (l&rsquo;&laquo; Entente &raquo;) avec nous, et contiennent des renseignements importants dont vous avez besoin pour bien comprendre vos Services :</p><p>i. Votre entente de service r&eacute;gissant le Service en particulier auquel vous vous abonnez (comme une entente de service sans fil ou une entente de service r&eacute;sidentiel).<br>ii. Notre Politique d&rsquo;utilisation acceptable, qui d&eacute;crit les r&egrave;gles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. Notre Politique d&rsquo;utilisation acceptable pr&eacute;voit des exemples d&rsquo;activit&eacute;s interdites et de contenu ill&eacute;gal ou inappropri&eacute; et nous donne le droit de retirer du contenu et de suspendre vos Services ou d&rsquo;y mettre fin si vous contrevenez &agrave; la Politique.<br>iii. Notre Politique de protection de la vie priv&eacute;e, qui d&eacute;crit nos politiques relativement &agrave; la cueillette, &agrave; l&rsquo;utilisation et &agrave; la divulgation de vos renseignements personnels. Notre Politique de protection de la vie priv&eacute;e vous informe des raisons pour lesquelles nous recueillons de l&rsquo;information sur nos clients, de la fa&ccedil;on dont nous utilisons et partageons cette information et de la fa&ccedil;on de communiquer avec nous si vous souhaitez obtenir plus de d&eacute;tails sur nos pratiques de traitement des renseignements personnels.<br>iv. toutes modalit&eacute;s et conditions suppl&eacute;mentaires pouvant s&rsquo;appliquer &agrave; un Service pr&eacute;cis auquel vous &ecirc;tes abonn&eacute; ou que vous utilisez;<br>v. tout mat&eacute;riel ou brochure de Rogers d&eacute;crivant vos Services ou les produits que vous achetez.<br></p><p>Votre Entente, avec toute modification qui peut y &ecirc;tre apport&eacute;e, constitue l&rsquo;entente int&eacute;grale conclue entre vous et Rogers au sujet des Services pertinents. Chaque Service auquel vous vous abonnez constitue une Entente distincte avec nous. En cas d&rsquo;incoh&eacute;rence entre les documents indiqu&eacute;s ci-dessus et les pr&eacute;sentes Modalit&eacute;s, les pr&eacute;sentes Modalit&eacute;s auront pr&eacute;s&eacute;ance.</p><p>c. Qui est responsable de se conformer &agrave; l&rsquo;Entente?</p><p>En tant que titulaire de compte, vous avez la responsabilit&eacute; de respecter l&rsquo;Entente. Vous &ecirc;tes responsable notamment :</p><p>i. de payer tous les frais imput&eacute;s &agrave; votre compte;<br>ii. de vous assurer que toute personne qui utilise les Services par l&rsquo;entremise de votre compte ou avec votre autorisation le fait en conformit&eacute; avec l&rsquo;Entente;<br>iii. de vous assurer que personne n&rsquo;a acc&egrave;s &agrave; votre compte ou &agrave; vos Services sans votre autorisation, notamment en veillant &agrave; la confidentialit&eacute; de tout nom d&rsquo;utilisateur et mot de passe propre &agrave; votre compte;<br>iv. de vous assurer que tout renseignement que vous nous fournissez est &agrave; jour et exact, et de nous informer de tout changement &agrave; vos renseignements.<br></p><p>d. Puis-je transf&eacute;rer mon Entente &agrave; autrui?</p><p>Vous devez obtenir notre consentement pr&eacute;alable si vous souhaitez c&eacute;der ou transf&eacute;rer une Entente. Nous pouvons c&eacute;der ou transf&eacute;rer une Entente ou l&rsquo;un ou l&rsquo;autre de nos droits et responsabilit&eacute;s qui s&rsquo;y rattachent sans votre consentement.</p></div>");
$templateCache.put("views/localization/intro.html","<div class=\"bold paragraph\">INTRODUCTORY INFORMATION</div><div class=\"paragraph\"><p>a. How do the Rogers Terms of Service apply to me?</p><p>These Rogers Terms of Service (&quot;Terms&quot;) govern your use of:</p><p>i. the Rogers services that you subscribe to or purchase under a service agreement or receive from or through Rogers, including wireless and residential services (&quot;Services&quot;); and<br>ii. any device or equipment used to access the Services or used with the Services (&quot;Equipment&quot;).<br>In these Terms, &quot;Rogers&quot;, &quot;us&quot;, &quot;we&quot; and &quot;our&quot; means the Rogers entity named in the service agreement for the specific Service you subscribe to. These Terms do not apply to services offered by Rogers Media Inc. or its subsidiaries.<br></p><p>b. How do the Rogers Terms of Service work with my service agreement and other materials made available to me?</p><p>These Terms work together with the following materials to form your complete agreement (&quot;Agreement&quot;) with us, and provide you with the important information you need to help you fully understand your Services:</p><p>i. Your service agreement for the specific Service you subscribe to (such as a wireless service agreement or residential service agreement).<br>ii. Our Acceptable Use Policy, which sets out the rules, policies and limits you must abide by when using the Services. Our Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the policy.<br>iii. Our Privacy Policy, which sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy details why we collect customer information, how we use it and how we share it, and specifies how to contact us if you would like more information on our personal information handling practices.<br>iv. Any additional terms and conditions that may apply to a specific Service that you subscribe to or use.<br>v. Any Rogers brochure or material describing your Services or products you purchase.<br></p><p>Your Agreement, with any amendments, is the entire agreement between you and Rogers for the applicable Services. Each Service that you subscribe to is a separate Agreement with us. If there is any inconsistency between the materials listed above and these Terms, these Terms will prevail.</p><p>c. Who is responsible for complying with the Agreement?</p><p>You, as account holder, are responsible to comply with the Agreement. Among other things, you are responsible for:</p><p>i. all charges on your account;<br>ii. ensuring that anyone who uses Services under your account or with your authorization complies with the Agreement;<br>iii. ensuring that others do not gain unauthorized access to your account and your Services, including by protecting the security of any user names or passwords relating to your account;<br>iv. ensuring that any information you have provided to us is up-to-date and accurate, and to let us know if it changes.<br></p><p>d. May I transfer my Agreement to someone else?</p><p>You will need our prior permission if you want to assign or transfer an Agreement. We may assign or transfer an Agreement or any of our rights or responsibilities under an Agreement without your permission.</p></div>");
$templateCache.put("views/localization/prepaid-wireless-service-fr.html","<div class=\"bold paragraph\">Service sans fil pr&eacute;pay&eacute;</div><div class=\"paragraph\"><p>a. En tant que client du service sans fil pr&eacute;pay&eacute; de Rogers, comment puis-je v&eacute;rifier le solde d&rsquo;utilisation de mon service sans fil pr&eacute;pay&eacute;?</p><p>Vous pouvez v&eacute;rifier votre solde d&rsquo;utilisation &agrave; partir de votre appareil sans fil pr&eacute;pay&eacute; en composant *6 1 1 (sans frais).</p><p>b. Si j&rsquo;ajoute des fonds au solde de mon service sans fil pr&eacute;pay&eacute; et que je change d&rsquo;id&eacute;e, puis-je obtenir un remboursement?</p><p>Non, les d&eacute;p&ocirc;ts port&eacute;s &agrave; votre compte pour les services sans fil pr&eacute;pay&eacute;s ne sont pas remboursables.</p><p></p><p>c. Qu&rsquo;arrive-t-il si je n&rsquo;utilise pas r&eacute;guli&egrave;rement mon Service sans fil pr&eacute;pay&eacute;?</p><p>Si votre compte sans fil pr&eacute;pay&eacute; affiche un solde &agrave; <strong>0 $</strong> pendant <strong>6</strong> mois cons&eacute;cutifs ou si les paiements exigibles relatifs &agrave; votre compte ne sont pas effectu&eacute;s ou sont refus&eacute;s, pour une raison quelconque, votre identifiant du service sans fil pr&eacute;pay&eacute; (par exemple, num&eacute;ro de t&eacute;l&eacute;phone ou NIP) sera d&eacute;sactiv&eacute;. Veuillez noter &eacute;galement que tout solde de votre service sans fil pr&eacute;pay&eacute; peut comporter une date d&rsquo;expiration tel qu&rsquo;indiqu&eacute;.</p><p>d. Outre les frais d&rsquo;utilisation, d&rsquo;autres frais sont-ils associ&eacute;s au Service sans fil pr&eacute;pay&eacute;?</p><p>Une fois par mois, nous d&eacute;duirons de votre compte de service sans fil pr&eacute;pay&eacute; les frais d&rsquo;acc&egrave;s au service d&rsquo;urgence 9 1 1 (frais non gouvernementaux) pour l&rsquo;acc&egrave;s au service d&rsquo;urgence 9 1 1 et les frais gouvernementaux applicables au service 9 1 1 selon la province (aucuns frais de temps d&rsquo;antenne ne s&rsquo;appliquent pour les appels effectu&eacute;s au 9 1 1 &agrave; partir de votre appareil sans fil). Pour de plus amples renseignements, visitez le <a href=\"http://www.rogers.com/web/Rogers.portal?_nfpb=true&amp;_pageLabel=NEW_GCT&amp;_nfls=true&amp;setLanguage=fr&amp;template=wireless-911&amp;content10=wireless-911&amp;asc_refid=911\">rogers.com/911.</a></p></div>");
$templateCache.put("views/localization/prepaid-wireless-service.html","<div class=\"bold paragraph\">PREPAID WIRELESS SERVICE</div><div class=\"paragraph\"><p>a. If I am a Rogers prepaid wireless customer, how can I check my prepaid wireless usage balance?</p><p>You can check your usage balance from your prepaid wireless device by calling *611 (it&rsquo;s a free call).</p><p>b. If I change my mind about adding to my prepaid wireless balance, can I get a refund?</p><p>No. Deposits into your account for prepaid wireless Services are non-refundable.</p><p>c. What if I don&rsquo;t use my prepaid wireless Service on a regular basis?</p><p>If your prepaid wireless account balance remains at <strong>$0</strong> for <strong>6</strong> consecutive months or if required payments towards your account are not made or are returned, for any reason, your prepaid wireless identifier (e.g., phone number or PIN number) will be deactivated. Please also note any prepaid wireless balance may have an expiry date as indicated.</p><p>d. Other than usage charges, are there any additional fees associated with prepaid wireless Service?</p><p>We will deduct a 9-1-1 Emergency Access Fee (non-government fee) for the provision of access to 9-1-1 service and any applicable 9-1-1 provincial government fee, once per month from your prepaid wireless account (there is no airtime charge for calls made from your wireless device to 9-1-1). For more information, please visit <a href=\"http://www.rogers.com/911\">rogers.com/911</a>.</p></div>");
$templateCache.put("views/localization/privacy-policy-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><h2 class=\"tc-heading\">POLITIQUE DE CONFIDENTIALITÉ</h2><h3 class=\"tc-subheading\">Politique du Groupe de sociétés Rogers (Rogers) en matière de protection de la vie privée</h3><ol class=\"tc-list-spacing\"><li>Cette politique s’applique à Rogers Communications, à Rogers Câble, à Rogers Sans-fil et à Rogers Média, regroupées dans la présente sous le nom de « Rogers ». Pour le Groupe de sociétés Rogers, la sécurité et l’intégrité des renseignements personnels de ses clients sont importantes. De plus, toutes les mesures nécessaires sont prises afin d’assurer la protection de la vie privée de ses clients tout en leur assurant le niveau de qualité élevée auxquels ils s’attendent pour leurs services de communications.</li><li>Les pratiques de Rogers en matière de protection de la vie privée sont conformes aux lois et règlements fédéraux et provinciaux. Rogers est en conformité avec la Loi sur la protection des renseignements personnels et les documents électroniques (LPRPDE), ainsi qu’avec les règles établies par le Conseil de la radiodiffusion et des télécommunications canadiennes (CRTC), lorsqu’elles s’appliquent.</li><li>Rogers a mis en place des procédures en matière de sécurité et de protection de la vie privée afin de protéger les renseignements personnels de ses clients. Ces procédures sont revues et mises à jour régulièrement. De plus, les employés de Rogers suivent une formation sur la protection de la vie privée et, comme condition d’emploi, s’engagent à respecter les pratiques adoptées par Rogers en matière de protection de la vie privée.</li><li>Les renseignements personnels recueillis par Rogers concernent toujours un individu identifiable et peuvent comprendre le nom, l’adresse électronique, le numéro de téléphone, la date de naissance ainsi que les renseignements financiers du client et, s’il y a lieu, les plaintes inscrites à son dossier.</li><li>Rogers recueille des renseignements pour une ou plusieurs des raisons suivantes :<ul class=\"tc-sublist\"><li>offrir une expérience positive au client, assurer la prestation et la facturation des produits et services ainsi que la collecte du paiement pour les produits et services offerts;</li><li>comprendre les exigences du client et donner accès à l’information sur les produits et services offerts par Rogers, ses représentants, ses concessionnaires et ses sociétés affiliées;</li><li>gérer les activités de Rogers et assurer leur expansion;</li><li>satisfaire aux exigences relatives aux lois et réglementations; et</li><li>obtenir des renseignements sur le crédit et les communiquer à d’autres parties.</li></ul></li><li>Rogers n’utilise ni ne dévoile les renseignements personnels pour des raisons autres que celles pour lesquelles ils ont été recueillis, sauf avec le consentement de la personne concernée ou tel qu’exigé par la loi. Rogers conserve ces renseignements aussi longtemps qu’ils lui sont nécessaires.</li><li>Rogers informe ses clients, lorsqu’ils en font la demande, de l’existence, de l’utilisation et de la diffusion de leurs renseignements personnels et leur donne accès à leurs renseignements.</li><li>Rogers s’assure que les renseignements personnels fournis sont exacts, complets et à jour. Les clients peuvent vérifier l’exactitude et l’exhaustivité des renseignements et demander les modifications nécessaires, au besoin.</li><li>Les membres du Groupe de sociétés Rogers échangent des renseignements personnels avec d’autres sociétés Rogers, des représentants et des concessionnaires autorisés, afin d’offrir à leurs clients des produits et services susceptibles de les intéresser. Des avis sur le partage de renseignements personnels paraissent sur tous les formulaires de demande, les factures et les sites Web. Les clients qui ne souhaitent pas être sollicités au sujet de ces produits et services peuvent communiquer avec Rogers (voir les coordonnées ci-dessous).</li><li>Pour consulter les questions fréquentes sur l’engagement de Rogers en matière de protection de la vie privée, veuillez vous référer à <strong>rogers.com/web/contenu/FAQ-sur-engagement-de-Rogers-aux-politiques</strong></li><li>Un agent de protection de la vie privée a été désigné chez Rogers. Celui-ci est responsable de tous les renseignements personnels recueillis par Rogers. Vous pouvez communiquer avec lui à l’adresse ci-dessous :<br>Par la poste : Agent de protection de la vie privée<br>Groupe de sociétés Rogers<br>333, rue Bloor Est Toronto (Ontario) M4W 1G9</li><li>Les clients qui désirent : obtenir de plus amples renseignements sur cette politique en matière de protection de la vie privée; accéder à leurs renseignements personnels ou obtenir de l’information sur les renseignements dont dispose Rogers; ou formuler une plainte liée à la protection de la vie privée peuvent communiquer avec un représentant du Service à la clientèle qui, au besoin, les mettra en contact avec l’agent de protection de la vie privée de Rogers.</li><li>Le Commissariat à la protection de la vie privée du Canada supervise le traitement de vos renseignements personnels par Rogers. Si vos préoccupations quant à la protection de la vie privée ne sont pas satisfaites par Rogers, vous pouvez communiquer avec le Commissariat à la protection de la vie privée du Canada pour obtenir de plus amples renseignements :<p>Par courriel : <a href=\"mailto:info@privcom.gc.ca\"><strong>info@privcom.gc.ca</strong></a></p><p>Site Web : <a href=\"http://www.privcom.gc.ca/\"><strong>www.privcom.gc.ca</strong></a></p></li></ol>");
$templateCache.put("views/localization/privacy-policy.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><h2 class=\"tc-heading\">PRIVACY POLICY</h2><h3 class=\"tc-subheading\">The Rogers Group of Companies (Rogers) Commitment to Privacy</h3><ol class=\"tc-list-spacing\"><li>This policy applies to Rogers Communications, Rogers Cable, Rogers Wireless and Rogers Media which are referred to here collectively as Rogers. At Rogers, the security and integrity of our customers’ personal information is important to us. We take every reasonable measure necessary to protect the privacy of our customers while providing the high level communication services they expect.</li><li>Rogers’ privacy practices are in accordance with all federal and provincial laws and regulations. We are compliant with the Personal Information Protection and Electronic Documents Act (PIPEDA) and where applicable with the privacy rules established by the Canadian Radio-television and Telecommunications Commission (CRTC).</li><li>Rogers has in place privacy and security practices to safeguard our customers’ personal information. These practices are reviewed, and if necessary revised, on a regular basis. Additionally, Rogers’ employees receive privacy training and must comply with Rogers’ privacy practices as a condition of employment.</li><li>Personal information collected by Rogers is information about an identifiable individual that may include such information as your name, e-mail address, mailing address, phone number, financial information, birth date and any recorded complaints.</li><li>At Rogers, we collect customer information for one or more of the following purposes:<ul class=\"tc-sublist\"><li>To provide a positive customer experience, and deliver, bill for, and collect payment for products and services;</li><li>To understand customer requirements and make information available regarding products and services offered by Rogers and its agents, dealers and related companies;</li><li>To manage and develop Rogers business and operations;</li><li>To meet legal and regulatory requirements; and</li><li>To obtain credit information or provide it to others.</li></ul></li><li>Rogers does not use or disclose personal information for purposes other than those for which it was collected, except with the consent of the individual or as required by law. Rogers retains personal information only as long as necessary for the fulfillment of those purposes.</li><li>Rogers informs customers of the existence, use and disclosure of their personal information upon request and gives them access to their information.</li><li>Rogers ensures that customer information is accurate, complete and up-to-date. Customers can challenge the accuracy and completeness of the information and request amendments as appropriate.</li><li>Rogers companies share information with other Rogers companies or their agents and authorized dealers, in order to offer customers products and services that they may find attractive. Notices on sharing information are contained in each company’s application forms, invoices and web sites. If customers do not want to be marketed with these products and services, they can contact Rogers (see How To Contact Rogers below).</li><li>For FAQs about Rogers Commitment to Privacy, please visit rogers.com/web/content/FAQs-About-Rogers-Commitment-to-Policy.</li><li>A senior company officer has been appointed as the Privacy Officer at Rogers. The Privacy Officer is accountable for all personal information at Rogers. You may contact the Privacy Officer at:<p>By Mail: Chief Privacy Officer<br>Rogers Group of Companies<br>333 Bloor Street East<br>Toronto, Ontario<br>M4W 1G9</p></li><li>Customers that wish to: obtain more information about Rogers Commitment to Privacy; access, or obtain more information about, their personal information held by Rogers; or make a privacy-related complaint; may contact a Rogers customer service representative who, if necessary, will refer the customer to the Rogers Privacy Officer.</li><li>The Office of the Privacy Commissioner of Canada oversees Rogers’ personal information handling practices. If your privacy concerns are not addressed to your satisfaction by Rogers you may contact the Office of the Privacy Commissioner of Canada for further guidance:<p>By E-mail: <a href=\"mailto:info@privcom.gc.ca\">info@privcom.gc.ca</a></p><p>Website: <a href=\"http://www.privcom.gc.ca/\">www.privcom.gc.ca</a></p></li></ol>");
$templateCache.put("views/localization/rogers-terms-of-service-fr.html","<meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"><p class=\"tc-heading\">MODALITÉS DE SERVICE ROGERS</p><ol class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Introduction</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment les Modalités de service Rogers s’appliquent-elles à moi?</strong></li></ol><p>Les présentes Modalités de service Rogers (les « <strong>Modalités</strong> ») régissent votre utilisation :</p><ol type=\"i\"><li>des services de Rogers auxquels vous vous abonnez ou que vous achetez aux termes d’une entente de service, ou que vous recevez de Rogers ou par son intermédiaire, y compris les services sans fil et les services résidentiels (les « <strong>Services</strong>»);</li><li>de tout appareil ou équipement dont vous vous servez pour accéder aux Services ou que vous utilisez avec les Services (l’« <strong>Équipement</strong>»).</li></ol><p>Dans les présentes Modalités, les expressions « <strong>Rogers</strong> », « <strong>nous</strong> », « <strong>nos</strong> » et « <strong>notre</strong> » renvoient à l’entité de Rogers dont le nom figure dans l’entente de service régissant le Service en particulier auquel vous vous abonnez. Les présentes Modalités ne s’appliquent pas aux services offerts par Rogers Média Inc. ou ses filiales.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Comment les Modalités de service Rogers régissent-elles mon entente de service et les autres documents qui me sont fournis?</strong></li></ol><p>Les présentes Modalités s’appliquent conjointement avec les documents suivants pour former ensemble votre entente complète (l’« <strong>Entente</strong> ») avec nous, et contiennent des renseignements importants dont vous avez besoin pour bien comprendre vos Services :</p><ol type=\"i\"><li>Votre <strong>entente de service</strong> régissant le Service en particulier auquel vous vous abonnez (comme une entente de service sans fil ou une entente de service résidentiel).</li><li>Notre <strong>Politique d’utilisation acceptable</strong>, qui décrit les règles, les politiques et les restrictions que vous devez respecter lorsque vous utilisez les Services. Notre Politique d’utilisation acceptable prévoit des exemples d’activités interdites et de contenu illégal ou inapproprié et nous donne le droit de retirer du contenu et de suspendre vos Services ou d’y mettre fin si vous contrevenez à la Politique.</li><li>Notre <strong>Politique de protection de la vie privée</strong>, qui décrit nos politiques relativement à la cueillette, à l’utilisation et à la divulgation de vos renseignements personnels. Notre Politique de protection de la vie privée vous informe des raisons pour lesquelles nous recueillons de l’information sur nos clients, de la façon dont nous utilisons et partageons cette information et de la façon de communiquer avec nous si vous souhaitez obtenir plus de détails sur nos pratiques de traitement des renseignements personnels.</li><li>toutes <strong>modalités et conditions supplémentaires</strong> pouvant s’appliquer à un Service précis auquel vous êtes abonné ou que vous utilisez;</li><li>tout <strong>matériel ou brochure de Rogers décrivant vos Services ou les produits que vous achetez</strong>.</li></ol><p>Votre Entente, avec toute modification qui peut y être apportée, constitue l’entente intégrale conclue entre vous et Rogers au sujet des Services pertinents. Chaque Service auquel vous vous abonnez constitue une Entente distincte avec nous. En cas d’incohérence entre les documents indiqués ci-dessus et les présentes Modalités, les présentes Modalités auront préséance.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qui est responsable de se conformer à l’Entente?</strong></li></ol><p>En tant que titulaire de compte, vous avez la responsabilité de respecter l’Entente. Vous êtes responsable notamment :</p><ol type=\"i\"><li>de payer tous les frais imputés à votre compte;</li><li>de vous assurer que toute personne qui utilise les Services par l’entremise de votre compte ou avec votre autorisation le fait en conformité avec l’Entente;</li><li>de vous assurer que personne n’a accès à votre compte ou à vos Services sans votre autorisation, notamment en veillant à la confidentialité de tout nom d’utilisateur et mot de passe propre à votre compte;</li><li>de vous assurer que tout renseignement que vous nous fournissez est à jour et exact, et de nous informer de tout changement à vos renseignements.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Puis-je transférer mon Entente à autrui?</strong></li></ol><p>Vous devez obtenir notre consentement préalable si vous souhaitez céder ou transférer une Entente. Nous pouvons céder ou transférer une Entente ou l’un ou l’autre de nos droits et responsabilités qui s’y rattachent sans votre consentement.</p><ol class=\"tc-ol-headline\" start=\"2\"><li class=\"tc-headline2\"><strong>Période d’abonnement, modifications et résiliation</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Quelles sont les catégories de Services visées par mon Entente?</strong></li></ol><p>Les Services sont classés selon les catégories suivantes :</p><ol type=\"i\"><li>Les « <strong>Services à durée déterminée</strong>» s’entendent de Services auxquels vous vous abonnez et qui comportent une période d’abonnement prédéterminée, tel qu’il est indiqué dans votre entente de service applicable (la « <strong>Période d’abonnement</strong> »);</li><li>Les « <strong>Services mensuels</strong>» s’entendent de Services auxquels vous vous abonnez de façon continue, mais qui ne comportent pas de Période d’abonnement;</li><li>Les « <strong>Services facturés à l’utilisation</strong>» s’entendent de Services que vous utilisez et qui sont facturés à l’utilisation (qu’ils soient utilisés une seule fois ou pendant une période donnée, comme un jour ou une semaine), mais qui ne sont pas utilisés de façon continue.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Quelle est la durée de mon Entente?</strong></li></ol><p>La durée de chaque Entente débute à la date de mise en service initiale des Services ou de l’Équipement, selon la première date à survenir (la « <strong>Date de mise en service</strong> »). À la fin de la Période d’abonnement d’un Service à durée déterminée, ce Service à durée déterminée deviendra automatiquement un Service mensuel, et votre Entente et votre Service existants auprès de Rogers demeureront inchangés jusqu’à ce qu’ils soient modifiés ou résiliés conformément aux présentes Modalités.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Rogers peut-elle modifier mes Services ou mon Entente?</strong></li></ol><p>Oui, Rogers peut apporter des changements à vos Services et à votre Entente, conformément à ce qui suit.</p><p><strong>Pour les Services sans fil :</strong></p><p>Nous pouvons modifier tout aspect d’un Service mensuel et de l’Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong> jours à l’avance. Nous pouvons également modifier des aspects d’un Service à durée déterminée et de l’Entente qui y est associée, autres que les principales modalités selon ce qui est prévu au Code sur les services sans fil du Conseil de la radiodiffusion et des télécommunications canadiennes (CRTC), en vous en avisant par écrit au moins <strong>30</strong> jours à l’avance. Dans un cas comme dans l’autre, nous vous enverrons l’avis écrit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis comprendra des explications sur la modification ainsi que sa date d’entrée en vigueur.</p><p><strong>Pour les Services résidentiels :</strong></p><p><strong>Non applicable aux Résidents de Terre-Neuve-et-Labrador* ou aux Résidents du Québec** :</strong> Nous pouvons modifier tout aspect d’un Service mensuel ou d’un Service à durée déterminée, ainsi que toute disposition ou modalité d’une Entente, en vous faisant parvenir un préavis écrit par message apparaissant sur votre facture, par message texte, par courrier ou par courriel. Si vous n’acceptez pas ce changement, votre recours consiste à résilier les Services ou l’Entente visés en nous faisant parvenir un avis de résiliation conformément au paragraphe 2e) ci-après dans les <strong>30</strong><strong></strong>jours suivant la réception de notre avis de modification (à moins que nous y indiquions une autre période d’avis ou un autre recours).</p><p><strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* et aux Résidents du Québec** :</strong>Nous pouvons modifier tout aspect d’un Service mensuel et de l’Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong>jours à l’avance. Nous pouvons également modifier un Service à durée déterminée et l’Entente qui y est associée en vous en avisant par écrit au moins <strong>30</strong>jours à l’avance, mais nous ne modifierons pas le prix, la durée, la nature ou tout autre aspect essentiel de ce Service à durée déterminée ou de l’Entente. Dans un cas comme dans l’autre, nous vous enverrons l’avis écrit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis contiendra la nouvelle modalité ou disposition, la modalité ou disposition modifiée, l’ancienne version de cette modalité ou disposition (le cas échéant), la date à laquelle la modification entrera en vigueur et un énoncé de vos droits. Si le changement à un Service mensuel ou à un Service à durée déterminée entraîne une augmentation de vos obligations ou une réduction de nos obligations et que vous n’acceptez pas ce changement, votre recours consiste à résilier les Services ou l’Entente visés sans Frais de résiliation anticipée (tels que définis ci-après) en nous faisant parvenir un avis de résiliation conformément au paragraphe 2e) ci-après au plus tard <strong>30</strong> jours suivant l’entrée en vigueur de la modification.</p><p><strong>Pour les Services facturés à l’utilisation :</strong> Les Services facturés à l’utilisation sont offerts sous réserve de leur disponibilité, et Rogers peut les modifier ou les résilier en tout temps sans vous en aviser au préalable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Puis-je modifier mes Services?</strong></li></ol><p>Vous pouvez modifier vos Services à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. Vous pourriez devoir payer des frais d’administration conformément au paragraphe 3d) ci-après. Vous pourriez également devoir payer des frais pour changer un Service si de tels frais sont indiqués dans votre entente de service applicable à ce Service. Veuillez noter que, si vous souhaitez changer un Service, vous pourriez seulement pouvoir le remplacer par un Service qui est offert à ce moment-là, et que tout Service annulé à votre demande pourrait ne plus être disponible.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Comment puis-je résilier mes Services et à quel moment la résiliation entre-t-elle en vigueur?</strong></li></ol><p>À moins que les lois applicables ne permettent autre chose, vous pouvez résilier la totalité ou une partie de vos Services et toute Entente qui y est associée à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. La résiliation entre en vigueur à la date à laquelle Rogers reçoit l’avis de résiliation ou à une date ultérieure qui est indiquée dans l’avis (le cas échéant), selon la date la plus éloignée. Les frais exigibles continueront de s’appliquer jusqu’à cette date. Cependant, si vous annulez uniquement une option du Service de télévision ou du Service d’accès Internet, les frais applicables pour cette option continueront de s’appliquer jusqu’à votre prochaine date de facturation.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Devrai-je payer des frais de résiliation anticipée si j’annule l’un ou l’autre de mes Services?</strong></li></ol><p>Si vous vous abonnez à un Service à durée déterminée que vous résiliez avant la fin de sa Période d’abonnement, vous devrez payer des frais de résiliation anticipée tel qu’il est décrit dans l’entente de service applicable à ce Service à durée déterminée (les « <strong>Frais de résiliation anticipée</strong> »).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>Que se passe-t-il si je transfère mes Services à un autre fournisseur de service?</strong></li></ol><p>Le transfert de votre ou de vos Services à un autre fournisseur de service constitue une résiliation du ou des Services en question, et des Frais de résiliation anticipée pourront s’appliquer si le transfert entraîne la résiliation d’un Service à durée déterminée avant la fin de sa Période d’abonnement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Rogers peut-elle résilier mes Services et, le cas échéant, à quel moment cette résiliation entre-t-elle en vigueur?</strong></li></ol><p><strong>Non applicable aux Résidents de Terre-Neuve-et-Labrador</strong><strong>* et aux Résidents du Québec** :</strong> À moins que les lois applicables ne permettent autre chose, Rogers peut résilier une partie ou la totalité de vos Services ou de vos comptes, ainsi que toute Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>30</strong> jours à l’avance. Les frais exigibles continuent de s’appliquer jusqu’à la date de résiliation.</p><p><strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* et aux</strong><strong>Résidents du Québec** :</strong> À moins que les lois applicables ne permettent autre chose, Rogers peut résilier une partie ou la totalité de vos Services ou de vos comptes, ainsi que toute Entente qui y est associée, à condition de vous en aviser par écrit au moins <strong>60</strong>jours à l’avance. Si vous vous êtes abonné à un Service à durée déterminée, nous ne pouvons résilier ce Service : (i) (<strong>applicable uniquement aux Résidents de Terre-Neuve-et-Labrador*</strong>) que si n’avons plus la capacité technique de fournir ce Service à durée déterminée, ou (ii) (<strong>applicable uniquement aux Résidents du Québec**</strong>) qu’en vertu des articles 1604, 2126 et 2129 du <em>Code civil du Québec</em>. Les frais exigibles continuent de s’appliquer jusqu’à la date de résiliation. <strong>Applicable uniquement aux Résidents de Terre-Neuve-et-Labrador* :</strong>Si votre compte a un solde créditeur dépassant <strong>10 $</strong> sur votre facture finale, nous vous rembourserons ce solde dans les <strong>60</strong> jours suivant la date de cette facture. Les crédits discrétionnaires ne seront pas remboursés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Rogers peut-elle suspendre ou résilier mes Services sans préavis?</strong></li></ol><p>Nous pouvons limiter, suspendre, bloquer, débrancher ou résilier l’un ou l’autre ou l’ensemble de vos Services, comptes ou identifiants de quelque façon que ce soit, y compris le service 9‑1‑1, sans avis ni responsabilité envers vous, si :</p><ol type=\"i\"><li>vous contrevenez aux modalités d’une Entente, notamment en omettant d’acquitter vos frais;</li><li>vous dépassez votre limite de crédit;</li><li>vous omettez de fournir ou de maintenir un dépôt de garantie raisonnable ou de vous conformer à une autre exigence de crédit lorsque nous vous demandons de le faire;</li><li>vous convenez avec nous d’un arrangement de paiement différé et vous omettez d’en respecter les modalités;</li><li>vous dépassez la limite d’utilisation raisonnable;</li><li>vous donnez de l’information fausse, trompeuse ou périmée;</li><li>nous avons des doutes raisonnables ou nous avons établi qu’un de vos comptes, identifiants, Services ou Équipement est associé à une fraude, une utilisation illégale ou inappropriée, ou est utilisé d’une façon nuisant à notre exploitation ou à l’utilisation de nos services, de nos installations ou de nos réseaux par d’autres;</li><li>vous harcelez, menacez ou faites preuve d’abus envers nous, nos employés ou nos agents;</li><li>vous tentez par des manœuvres frauduleuses ou malhonnêtes de ne pas nous payer;</li><li>nous devons installer, entretenir, inspecter, tester, réparer, retirer, remplacer, enquêter, protéger, modifier, mettre à jour ou améliorer l’exploitation des Services, de l’Équipement, de nos installations ou de nos réseaux;</li><li>un compte ou un service duquel vos Services dépendent est annulé pour quelque raison; ou</li><li>nous croyons raisonnablement qu’une urgence ou des circonstances particulières justifient une telle mesure.</li></ol><p>Si nous limitons, suspendons, bloquons, débranchons ou résilions vos Services ou vos comptes :</p><ol type=\"i\"><li>vous devez nous payer tous les montants que vous nous devez;</li><li>nous pouvons également, sans avis ni responsabilité, limiter, suspendre, bloquer, débrancher ou résilier vos Services aux termes d’une autre entente ou d’un autre compte que vous avez auprès de nous ou d’une société du même groupe que Rogers (incluant les comptes qui pourraient être en règle);</li><li>les frais encourus par nous ou une société du même groupe que Rogers relativement à votre manquement aux présentes Modalités pourraient vous être facturés, incluant, sans toutefois s’y limiter, les frais encourus pour vous obliger à les respecter;</li><li>votre accès aux services d’urgence ou aux services spéciaux (par exemple, le 9‑1‑1) peut également être restreint, suspendu, bloqué, désactivé ou annulé;</li><li>vos tarifs pour les services auprès des sociétés du même groupe que Rogers peuvent changer en fonction des modalités de ces services.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"10\"><li><strong>Les présentes Modalités s’appliqueront-elles toujours après la résiliation de mes Services?</strong></li></ol><p>Certaines dispositions des présentes Modalités peuvent continuer à s’appliquer puisqu’elles peuvent demeurer pertinentes même après la résiliation de tous vos Services. Plus particulièrement, les paragraphes 1b)-d), 2e)-j), 4b)-c), 5c), 6d), 8b)-d), 8f), 9, 10b)-d) et les dispositions en matière d’arbitrage du paragraphe 10a) continueront de s’appliquer à vous malgré la résiliation de votre Entente.</p><ol class=\"tc-ol-headline\" start=\"3\"><li class=\"tc-headline2\"><strong>Compte, frais et facturation</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment Rogers me facture-t-elle mes Services?</strong></li></ol><p>Les frais relatifs aux Services commencent à vous être facturés à la Date de mise en service et sont facturés à l’avance. À moins que Rogers et vous conveniez d’un autre arrangement, votre période de facturation est d’une durée d’un mois, et se termine à la date de facturation indiquée au haut de votre facture. Le début de votre période de facturation ne coïncidera pas toujours avec la Date de mise en service initiale. Dans un tel cas, vos frais de Services et votre quota d’utilisation seront calculés proportionnellement pour la période comprise entre votre Date de mise en service et votre date de facturation. Les frais d’utilisation, comme les frais d’utilisation de données additionnelles, les frais de temps d’antenne, les frais d’interurbain, les achats de films ou d’événements et les frais d’itinérance, sont facturés après votre utilisation de ces services. Nous pourrons porter des frais à votre compte jusqu’à <strong>6</strong> mois suivant la date où les frais ont été engagés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>À quelle date dois-je payer ma facture?</strong></li></ol><p>Les frais portés à votre compte sont payables en entier à la date de votre facture. Si vous payez par la poste ou par l’entremise d’une institution financière, veuillez prévoir des délais suffisants pour que le paiement nous parvienne avant la date d’exigibilité du paiement. Il vous incombe d’acquitter tous les frais imputés à votre compte.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qu’arrive-t-il si je ne paie pas ma facture à temps?</strong></li></ol><p>Si nous ne recevons pas le montant d’une somme due sur votre compte au plus tard à la date d’exigibilité précisée, le montant sera soumis à des frais de paiement en retard de <strong>2 %</strong> par mois, calculés et composés mensuellement sur le montant en souffrance (<strong>26,82 %</strong> par année) à compter de la date de la première facture sur laquelle le montant en souffrance apparaît, jusqu’à la date de réception d’un tel montant au complet. Vous convenez que nous pouvons facturer les montants non payés et en souffrance, y compris les frais de paiement en retard, selon tout mode de paiement préautorisé lié à votre compte (par exemple, en le portant à votre carte de crédit ou en procédant par retrait direct de votre compte bancaire).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Des frais d’administration peuvent-ils m’être facturés?</strong></li></ol><p>Nous pourrions imputer des frais d’administration à votre compte, notamment en raison de ce qui suit :</p><ol type=\"i\"><li>un changement de forfait;</li><li>un changement de numéro de téléphone (ou de tout autre identifiant);</li><li>une demande de réimpression de facture;</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong></p><ol type=\"i\" start=\"4\"><li>des efforts de recouvrement à la suite d’un non-paiement;</li><li>des paiements retournés ou refusés; et (ou)</li><li>le rétablissement du Service.</li></ol><p>Vous pouvez obtenir une liste de ces frais sur demande, ou la consulter à l’adresse <strong>rogers.com/frais</strong>. Cette liste fait partie intégrante des présentes Modalités.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Que puis-je faire si je ne comprends pas ou que je veux contester des frais figurant sur ma facture?</strong></li></ol><p>Toute question ou erreur présumée concernant les frais doit nous être signalée dans les <strong>90</strong> jours suivant la date de la facture en question, sans quoi vous êtes présumé avoir accepté les frais. Si l’imputation des frais à votre compte était effectivement non autorisée ou erronée, nous annulerons alors ces frais dans les <strong>30</strong> jours suivant la réception de votre avis signalant l’erreur.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Comment s’appliquent les rabais et les promotions?</strong></li></ol><p>Nous appliquerons tout rabais, toute promotion ou tout avantage à votre compte tant que vous y demeurez admissible. Nous pouvons vérifier votre admissibilité à ce rabais, à cette promotion ou à cet avantage de temps à autre, et si vous cessez d’y être admissible pour quelque raison que ce soit, nous pouvons l’annuler et (ou) faire passer votre Service à un forfait comparable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>Comment les frais de temps d’antenne sans fil local et interurbain sont-ils facturés?</strong></li></ol><p>Les frais de temps d’antenne local et interurbain sont arrondis à la minute complète suivante. Des frais minimums d’une minute s’appliquent à chaque appel acheminé (entrant ou sortant). Le temps d’antenne pour toute la durée de l’appel est facturé au tarif applicable au début de l’appel. Les frais de temps d’antenne (plus les frais d’interurbain, s’il y a lieu) s’appliquent aux appels acheminés à partir du moment où vous appuyez sur ENVOYER, jusqu’à ce que vous appuyiez sur FIN, et comprennent le temps de sonnerie. Les frais pour les appels internationaux ou en itinérance peuvent vous être facturés, que vous ayez réussi ou non l’appel.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Comment Rogers détermine-t-elle si j’effectue un appel interurbain sans fil?</strong></li></ol><p>Une zone d’appels sans fil locaux est une zone où vous pouvez faire et recevoir des appels locaux sans frais d’interurbain. Les appels peuvent être soit locaux, soit interurbains, selon les zones d’appels locaux. L’endroit où vous vous trouvez au moment de l’appel, votre numéro de sans-fil et le numéro de téléphone que vous composez sont des éléments importants pour déterminer les zones d’appels locaux et le traitement des appels interurbains. Votre « zone d’appels locaux entrants » est déterminée par l’emplacement géographique associé à votre numéro de sans-fil. Tous les appels reçus lorsque vous vous trouvez à l’intérieur de votre zone d’appels locaux entrants sont considérés comme des appels locaux. Tous les appels reçus lorsque vous vous trouvez à l’extérieur de votre zone d’appels locaux entrants sont considérés comme des appels interurbains. Votre zone d’appels locaux sortants est déterminée par votre emplacement physique. Si vous composez un numéro local lorsque vous vous trouvez dans la zone de ce numéro, il s’agit d’un appel local. Si vous composez un numéro à l’extérieur de la zone où vous vous trouvez, il s’agit d’un appel interurbain. Lorsque vous utilisez le service Renvoi d’appel, des frais d’interurbain s’appliquent lorsque le numéro vers lequel vous transférez l’appel se trouve à l’extérieur de l’emplacement géographique associé à votre numéro de sans-fil, et ce, peu importe où vous vous trouvez. Consultez rogers.com/interurbain pour connaître les tarifs interurbains en vigueur.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Comment sont facturés les frais d’interurbain à partir de mon numéro de téléphone résidentiel, et comment Rogers détermine-t-elle si j’effectue un appel interurbain à partir de mon numéro de téléphone résidentiel?</strong></li></ol><p>Les frais d’interurbain sont arrondis à la minute complète suivante. Des frais minimums d’une minute s’appliquent à chaque appel interurbain que vous effectuez. Pour les appels internationaux, des frais d’interurbain peuvent être facturés que l’appel soit acheminé ou non. Pour les Services de téléphonie résidentielle, les appels peuvent être soit locaux, soit interurbains, selon les zones d’appels locaux, et votre zone d’appels locaux dépend de votre numéro de téléphone résidentiel. Si vous composez un numéro qui est un interurbain à partir de votre numéro de téléphone résidentiel, il s’agit d’un appel interurbain. Lorsque vous utilisez le Renvoi d’appel, des frais d’interurbain s’appliquent lorsque le numéro vers lequel vous transférez l’appel se trouve à l’extérieur de votre zone d’appels locaux.</p><ol class=\"tc-ol-headline\" start=\"4\"><li class=\"tc-headline2\"><strong>Exigences en matière de dépôt et de crédit</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Rogers exige-t-elle un dépôt de garantie ou applique-t-elle d’autres exigences en matière de paiement ou de crédit?</strong></li></ol><p>Oui, nous pouvons exiger un dépôt de garantie ou imposer d’autres exigences de paiement ou de crédit, comme des paiements intérimaires, des prélèvements automatiques obligatoires ou des paiements préautorisés.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Comment sont utilisés les dépôts de garantie?</strong></li></ol><p>Tout dépôt de garantie que vous nous fournissez sera conservé pendant au moins <strong>12</strong> mois, sauf si vous mettez fin à vos Services avant la fin de cette période. Après <strong>12</strong> mois, nous pouvons libérer le dépôt de garantie et l’appliquer au solde de votre compte si nous jugeons que votre historique de paiement est satisfaisant ou que vous répondez aux critères financiers pour le remboursement de votre dépôt de garantie. Nous pouvons appliquer votre dépôt de garantie à votre solde si vous n’acquittez pas votre facture, et nous pouvons vous demander de réapprovisionner le dépôt de garantie après une telle utilisation. Nous vous aviserons de toute utilisation d’une partie ou de la totalité du dépôt de garantie. Nous vous rembourserons le dépôt de garantie avec les intérêts cumulés dans les <strong>30</strong> jours suivant la résiliation de vos Services ou lorsque nous jugeons que les conditions du remboursement du dépôt de garantie sont remplies.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Mon dépôt de garantie porte-t-il intérêt?</strong></li></ol><p>Oui, tout dépôt de garantie que nous détenons portera intérêt au taux de financement à un jour de la Banque du Canada en vigueur à ce moment majoré de <strong>1</strong> pour cent, selon le nombre réel de jours dans l’année, calculé chaque mois. Les intérêts seront cumulés à partir de la date à laquelle nous recevons votre dépôt de garantie (mais pas avant le moment prescrit par la législation ou la réglementation en vigueur) jusqu’à la date à laquelle nous vous le remettons.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Rogers imposera-t-elle une limite de crédit à mon compte?</strong></li></ol><p>En vous donnant un avis à cet effet, nous pouvons attribuer ou modifier une limite de crédit à votre compte, en tout temps. Le Service pourra être suspendu en tout temps, pour n’importe lequel de vos comptes, si votre solde, y compris l’utilisation non facturée et les frais, les montants et les redressements en attente, dépasse cette limite. Les frais de service récurrents continueront de s’appliquer pendant toute suspension des Services.</p><ol class=\"tc-ol-headline\" start=\"5\"><li class=\"tc-headline2\"><strong>Votre utilisation des Services</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Suis-je propriétaire de mon numéro de téléphone?</strong></li></ol><p>Vous n’êtes pas propriétaire de tout numéro de téléphone, adresse courriel ou autre identifiant qui vous est attribué. Nous pouvons changer ou supprimer un identifiant à tout moment.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Rogers surveille-t-elle le contenu que je transmets lorsque j’utilise les Services?</strong></li></ol><p>Nous avons le droit, mais non l’obligation, de surveiller tout élément de contenu transmis au moyen des Services (autres que les Services de transmission de la voix) ou de l’Équipement, et de faire enquête sur ceux-ci. Nous pouvons également consulter ou conserver du contenu ou de l’information afin de nous conformer au processus judiciaire en vigueur au Canada et dans des territoires étrangers, d’exploiter les Services, de veiller au respect d’une Entente, ou encore de nous protéger nous-mêmes et de protéger nos clients et le public.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Quelles sont mes responsabilités à l’égard des logiciels ou du contenu de Rogers ou de tierces parties?</strong></li></ol><p>Toutes les marques de commerce et tous les droits d’auteur, concepts de marque, noms, logos et dessins que nous utilisons sont des actifs de propriété intellectuelle, déposés ou autre, de Rogers Communications Inc. ou d’une société membre de son groupe, ou encore sont utilisés en vertu d’une licence de Rogers Communications Inc. ou d’une société membre de son groupe. Tous ces éléments sont reconnus comme des actifs de valeur de leurs propriétaires respectifs, et vous ne pouvez pas les afficher, les copier ni les utiliser de quelque façon que ce soit à des fins commerciales ni pour quelque autre fin que ce soit.</p><p>Tout logiciel ou contenu que vous recevez ou achetez par l’intermédiaire de Rogers ou d’une de nos boutiques tierces ne peut servir qu’à une utilisation personnelle non commerciale. Un tel logiciel ou contenu demeure notre propriété ou celle de nos concédants de licence ou de nos fournisseurs de contenu, le cas échéant. Vous ne pouvez pas :</p><ol type=\"i\"><li>copier, distribuer, transférer ou vendre un tel logiciel ou contenu;</li><li>modifier, changer ou falsifier un tel logiciel ou contenu;</li><li>désosser, décompiler ou désassembler une partie du logiciel;</li><li>tenter de déjouer, éviter, contourner, retirer ou désactiver les mécanismes de protection d’un tel logiciel.</li></ol><p>Vous devez également prendre toutes les mesures raisonnables pour protéger les logiciels ou le contenu contre le vol, la perte et les dommages. Veuillez noter que de tels logiciels ou contenus peuvent, de temps à autre et sans que vous en soyez avisé, faire en sorte que votre Équipement accède à Internet de façon automatique, entraînant des frais de transmission de données et (ou) des frais d’utilisation excédentaire.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Que dois-je savoir à propos des Services Yahoo! qui me sont offerts?</strong></li></ol><p>Yahoo! Inc. et les sociétés membres de son groupe peuvent offrir aux clients du Service d’accès Internet de Rogers l’accès à une gamme de ressources, incluant divers outils de communication et du contenu varié (les « <strong>Services Yahoo!</strong> »). Lorsque vous utilisez les Services Yahoo!, les modalités de service, les lignes directrices et les règlements de Yahoo! (les « <strong>Modalités Yahoo!</strong> ») qui s’appliquent à ces services et qui sont affichés sur les pages où vous accédez à ces services régissent votre utilisation des Services Yahoo! En utilisant les Services Yahoo!, vous acceptez d’être lié par les Modalités Yahoo! intégrées par renvoi à une Entente. En ce qui concerne le Service d’accès Internet de Rogers et les Services Yahoo!, les obligations respectives de Rogers et de Yahoo! sont distinctes et non conjointes. Pour communiquer avec Yahoo! Inc. au sujet des Services Yahoo! seulement, veuillez écrire au Service à la clientèle, 701, First Avenue, Sunnyvale, CA, 94089, États-Unis. Pour obtenir de plus amples renseignements au sujet du traitement de vos renseignements personnels lorsque vous utilisez le Service d’accès Internet de Rogers et les Services Yahoo!, consultez <a href=\"http://www.rogers.yahoo.com/privacy\"><strong>rogers.yahoo.com/privacy</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"6\"><li class=\"tc-headline2\"><strong>Équipement</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>L’Équipement est-il neuf ou remis à neuf?</strong></li></ol><p>Sauf indication contraire, l’Équipement que vous achetez de nous est neuf. Sauf indication contraire, l’Équipement que vous louez auprès de nous est remis à neuf et il est fourni selon la disponibilité. Si vous avez acheté de l’Équipement auprès de nous et que vous avez obtenu une subvention sur cet Équipement qui a fait en sorte que vous avez payé <strong>0</strong> <strong>$</strong> pour cet Équipement, veuillez noter que cet Équipement vous est fourni à rabais et non en tant qu’Équipement gratuit.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Puis-je rehausser mon Équipement?</strong></li></ol><p>Vous pouvez rehausser votre Équipement à tout moment en communiquant avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après. Vous pourriez devoir payer des frais d’administration conformément au paragraphe 3d) ci-dessus. Si, aux termes de votre rehaussement d’Équipement, vous concluez une nouvelle Période d’abonnement et résiliez de façon anticipée une Période d’abonnement existante, vous devrez payer des Frais de résiliation anticipée. Veuillez noter que si vous souhaitez rehausser votre Équipement, vous pourriez également devoir passer à un Service qui est offert à ce moment-là, et que tout Service ou Équipement annulé à votre demande pourrait ne plus être disponible.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Mon Équipement est-il verrouillé ou limité aux Services ou au réseau de Rogers?</strong></li></ol><p><strong>Pour les Services sans fil :</strong></p><p>Votre appareil sans fil est verrouillé et ne peut être utilisé que sur le réseau de Rogers ou encore sur ceux exploités par les fournisseurs avec lesquels nous avons conclu une entente d’itinérance. Si vous tentez de déverrouiller votre appareil, celui-ci pourrait devenir inutilisable de manière permanente et vous pourriez, ce faisant, contrevenir à la licence d’utilisation du logiciel de votre appareil. Si vous souhaitez déverrouiller votre appareil sans fil, les Frais de déverrouillage mentionnés dans votre entente de service sans fil s’appliquent. Si vous avez obtenu une subvention sur votre appareil, nous ne déverrouillerons votre appareil qu’après les <strong>90</strong> premiers jours de votre Période d’abonnement. Veuillez prendre note que durant les <strong>90</strong> premiers jours suivant la Date de mise en service, si vous êtes en itinérance à l’extérieur du réseau Rogers, votre Service sera restreint et vous ne pourrez pas effectuer d’appels sortants vers des destinations autres que celles qui ont un indicatif régional d’Amérique du Nord (incluant le Canada et les États-Unis) et à l’endroit où vous vous trouvez lorsque vous effectuez l’appel (ne s’applique pas au service prépayé).</p><p><strong>Pour les Services résidentiels :</strong></p><p>L’Équipement acheté ou loué ne peut être utilisé que dans le cadre des Services de Rogers, à l’adresse de service indiquée dans votre compte. Si vous tentez de modifier l’Équipement, celui-ci pourrait devenir inutilisable de manière permanente et vous pourriez, ce faisant, contrevenir à la licence d’utilisation du logiciel de l’Équipement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Rogers devra-t-elle éventuellement avoir accès à ma propriété?</strong></li></ol><p>Pour les Services résidentiels, vous nous autorisez, nous et nos représentants, à accéder à vos locaux ou à entrer dans vos locaux, au besoin, à un moment mutuellement convenu pour l’installation, l’entretien, l’inspection, la réparation, le retrait, le remplacement, l’examen, la protection, la modification, la mise à niveau ou l’amélioration de l’exploitation de nos services, de l’Équipement, de nos installations ou de nos réseaux. Si vous résiliez un ou plusieurs de vos Services ou comptes, vous nous autorisez, nous et nos représentants, à accéder à vos locaux ou à entrer dans vos locaux pour débrancher les Services et retirer l’Équipement, le cas échéant.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Qui est responsable de s’assurer que mon Équipement est à jour?</strong></li></ol><p>Il est possible que l’Équipement et les logiciels qui s’y rattachent doivent respecter certaines exigences minimales et être entretenus d’une certaine façon et à certains endroits afin d’accéder aux Services ou pour assurer le bon fonctionnement des Services (par exemple, services 9‑1‑1). Ces exigences peuvent changer de temps à autre, et vous êtes responsable de la mise à jour ou de l’entretien nécessaires de votre Équipement et des logiciels pour respecter de telles exigences. Nous pouvons fournir des mises à jour de logiciels pour l’Équipement pour les besoins du fonctionnement continu des Services ou de l’Équipement. De même, nous pourrions devoir modifier ou désinstaller d’anciennes fonctionnalités logicielles afin de fournir de nouvelles fonctionnalités et veiller à ce que l’Équipement demeure compatible avec les avancées technologiques. Si votre Équipement ou vos logiciels ne sont pas à jour, nous pourrions ne pas être en mesure de vous fournir le soutien technique voulu.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Quelles sont mes responsabilités relatives à l’Équipement?</strong></li></ol><p>Vous êtes le seul responsable :</p><ol type=\"i\"><li>de tout accès à l’Équipement;</li><li>de fournir toute connexion supplémentaire, ainsi que le filage interne et l’équipement du terminal de téléphonie résidentielle, qui ne sont pas fournis par nous;</li><li>de la remise en service de votre équipement et de vos installations dans la mesure nécessaire après la résiliation de vos Services;</li><li>du maintien de la sécurité et de la confidentialité de vos biens et de vos transmissions par l’entremise des Services, de l’Équipement, de nos installations ou de nos réseaux;</li><li>de la protection contre les manquements à la sécurité ou à la confidentialité ou contre les autres risques associés à l’installation, à l’utilisation, au maintien ou au changement des Services ou de l’Équipement;</li><li>de vous assurer qu’il n’existe aucun branchement non autorisé à l’Équipement ou à notre câble (par exemple, pour l’Équipement de télévision, une (<strong>1</strong>) seule télévision peut être raccordée à une prise).</li></ol><p>Sauf en ce qui concerne l’Équipement que vous avez payé en entier, tout l’Équipement que nous installons ou que nous vous fournissons demeure notre propriété. En ce qui concerne tout l’Équipement dont nous sommes propriétaires, vous devez :</p><ol type=\"i\"><li>en prendre un soin raisonnable;</li><li>ne pas le vendre, le louer, l’hypothéquer, le transférer, le céder ou le grever de quelque façon que ce soit;</li><li>ne pas le déménager sans notre connaissance et notre permission;</li><li>nous le retourner à vos propres frais advenant la résiliation des Services auxquels l’Équipement est rattaché.</li></ol><p>Si notre Équipement est perdu, endommagé, volé, vendu, loué, hypothéqué, transféré, cédé ou grevé, ou qu’il ne nous est pas retourné, vous devez nous en avertir immédiatement. Vous convenez de nous payer la valeur au détail non escomptée d’un tel Équipement, ainsi que tous les frais encourus par nous pour reprendre possession d’un tel Équipement.</p><ol class=\"tc-ol-headline\" start=\"7\"><li class=\"tc-headline2\"><strong>Service sans fil prépayé</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>En tant que client du service sans fil prépayé de Rogers, comment puis-je vérifier le solde d’utilisation de mon service sans fil prépayé?</strong></li></ol><p>Vous pouvez vérifier votre solde d’utilisation à partir de votre appareil sans fil prépayé en composant *6‑1‑1 (sans frais).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Si j’ajoute des fonds au solde de mon service sans fil prépayé et que je change d’idée, puis-je obtenir un remboursement?</strong></li></ol><p>Non, les dépôts portés à votre compte pour les services sans fil prépayés ne sont pas remboursables.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Qu’arrive-t-il si je n’utilise pas régulièrement mon Service sans fil prépayé?</strong></li></ol><p>Si votre compte sans fil prépayé affiche un solde à <strong>0 $</strong> pendant <strong>6</strong> mois consécutifs ou si les paiements exigibles relatifs à votre compte ne sont pas effectués ou sont refusés, pour une raison quelconque, votre identifiant du service sans fil prépayé (par exemple, numéro de téléphone ou NIP) sera désactivé. Veuillez noter également que tout solde de votre service sans fil prépayé peut comporter une date d’expiration tel qu’indiqué.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Outre les frais d’utilisation, d’autres frais sont-ils associés au Service sans fil prépayé?</strong></li></ol><p>Une fois par mois, nous déduirons de votre compte de service sans fil prépayé les frais d’accès au service d’urgence 9‑1‑1 (frais non gouvernementaux) pour l’accès au service d’urgence 9‑1‑1 et les frais gouvernementaux applicables au service 9‑1‑1 selon la province (aucuns frais de temps d’antenne ne s’appliquent pour les appels effectués au 9‑1‑1 à partir de votre appareil sans fil). Pour de plus amples renseignements, visitez le <a href=\"http://www.rogers.com/web/Rogers.portal?_nfpb=true&amp;_pageLabel=NEW_GCT&amp;_nfls=true&amp;setLanguage=fr&amp;template=wireless-911&amp;content10=wireless-911&amp;asc_refid=911\"><strong>rogers.com/911</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"8\"><li class=\"tc-headline2\"><strong>Protection de votre vie privée</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Que peut faire Rogers avec les renseignements sur mon compte et mes renseignements personnels?</strong></li></ol><p>En concluant une Entente, vous :</p><ol type=\"i\"><li>autorisez expressément Rogers à recueillir et à utiliser vos données de localisation personnelles courantes et historiques associées à tout appareil que vous utilisez aux termes de votre ou vos Ententes de service pour vous fournir des services de géolocalisation, étant entendu que vous pouvez vous désabonner de ces services en tout temps.</li><li>convenez expressément que les renseignements relatifs à votre compte peuvent être divulgués à d’autres membres de l’organisation de Rogers Communications Inc. et à ses agents, concessionnaires autorisés et distributeurs, afin de gérer votre compte, de répondre à vos questions, de faire le télémarketing (y compris au moyen de composeurs messagers automatiques) et de vous proposer d’autres produits et services offerts par les membres de l’organisation de Rogers Communications Inc. Si vous ne souhaitez pas recevoir de telles offres ou information, veuillez communiquer avec nous de l’une ou l’autre des façons indiquées au paragraphe 10e) ci-après.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Où seront stockés mes renseignements personnels?</strong></li></ol><p>Les renseignements personnels recueillis dans le cadre de la prestation des Services peuvent être enregistrés et traités au Canada ou à l’étranger et être soumis aux lois en vigueur dans d’autres territoires.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Rogers divulguera-t-elle mes renseignements personnels à des tierces parties?</strong></li></ol><p>À moins que vous ne fournissiez votre consentement explicite, ou que cette divulgation soit requise aux termes d’une obligation légale, toute l’information vous concernant que nous détenons, sauf votre nom, votre adresse et votre numéro de téléphone inscrit dans l’annuaire, est confidentielle et ne pourra être divulguée par nous à quiconque autre que :</p><ol type=\"i\"><li>vous;</li><li>une personne qui, selon notre jugement raisonnable, agit comme votre mandataire pour obtenir de l’information;</li><li>une autre compagnie de téléphone, dans la mesure où les renseignements sont requis pour offrir un service de téléphonie résidentielle efficace et rentable, que la divulgation se fait sur une base confidentielle et que l’information est utilisée uniquement à cette fin;</li><li>un fournisseur vous assurant des services reliés aux fonctions de téléphonie ou d’annuaire téléphonique, dans la mesure où une telle divulgation se fait sur une base confidentielle et que l’information est divulguée et utilisée uniquement à cette fin;</li><li>un agent mandaté par nous pour le recouvrement de vos créances ou pour toute autre fonction administrative, dans la mesure où l’information est divulguée et utilisée uniquement à ces fins;</li><li>un agent mandaté par nous pour évaluer votre solvabilité, dans la mesure où l’information est divulguée et utilisée uniquement à cette fin;</li><li>un corps policier lorsque nous avons des motifs raisonnables de croire que vous nous avez sciemment fourni des renseignements faux ou trompeurs ou que vous êtes engagé de quelque autre façon dans des activités illégales;</li><li>une autorité publique ou le mandataire d’une autorité publique si, selon notre jugement raisonnable, nous croyons que la divulgation de vos renseignements pourrait éviter ou atténuer un danger de mort ou de dommage matériel imminent;</li><li>une autorité publique ou le mandataire d’une autorité publique, aux fins des alertes publiques d’urgence, si l’autorité publique a conclu être en présence d’un danger imminent ou sur le point de se produire mettant en danger la vie, la santé ou la sécurité de tout individu et que le danger pourrait être évité ou minimisé par la divulgation de l’information.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>De quelle façon Rogers obtient-elle mon consentement à la divulgation de mes renseignements personnels?</strong></li></ol><p>Le consentement explicite à la divulgation peut être obtenu comme suit :</p><ol type=\"i\"><li>un consentement écrit;</li><li>une confirmation orale vérifiée par une tierce partie indépendante;</li><li>une confirmation électronique par l’utilisation d’un numéro sans frais;</li><li>une confirmation électronique par Internet;</li><li>un consentement oral pour lequel nous avons conservé un enregistrement audio; ou</li><li>un consentement donné par une autre méthode, dans la mesure où il existe un enregistrement documenté objectif de votre consentement créé par vous ou par un tiers indépendant.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Puis-je demander d’avoir un numéro de téléphone résidentiel non inscrit dans l’annuaire?</strong></li></ol><p>Vous pouvez choisir de payer pour avoir un numéro de téléphone résidentiel non inscrit dans l’annuaire; cependant, veuillez noter que les fournisseurs d’annuaires et de services de téléphoniste peuvent obtenir votre numéro de téléphone et votre adresse d’une source autre que nous. Par ailleurs, votre nom, votre adresse et votre numéro de téléphone seront accessibles par les fournisseurs de service 9-1-1, même si vous payez pour avoir un numéro de téléphone non inscrit.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Comment puis-je obtenir de l’information sur la protection de mes renseignements personnels chez Rogers?</strong></li></ol><p>Nos Politiques de protection de la vie privée d’entreprise et en ligne se trouvent à <strong>rogers.com/privee</strong>. Pour communiquer avec notre Agent de protection de la vie privée afin d’accéder à vos renseignements personnels conservés par Rogers, d’obtenir plus d’information à ce sujet, de formuler une plainte au sujet de la protection de la vie privée, ou d’obtenir un exemplaire de nos Politiques de protection de la vie privée, envoyez un courriel à l’adresse <a href=\"mailto:privacy@rci.rogers.com\"><strong>privacy@rci.rogers.com</strong></a> ou écrivez à notre Agent de protection de la vie privée, Groupe de sociétés Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9.</p><ol class=\"tc-ol-headline\" start=\"9\"><li class=\"tc-headline2\"><strong>Garanties et limite de responsabilité</strong></li></ol><p>Veuillez noter que l’expression « <strong>Parties de Rogers</strong> » comprend Rogers et les sociétés membres de son groupe, ses partenaires, ses concédants de licence, ses concessionnaires, ses représentants, ses fournisseurs et ses mandataires (de même que leurs employés, dirigeants, administrateurs, actionnaires et représentants respectifs).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>L’Équipement est-il garanti?</strong></li></ol><p>L’Équipement peut être couvert par une garantie du fabricant ou une autre garantie. Veuillez consulter les documents remis avec votre Équipement pour obtenir des renseignements détaillés sur la garantie dont il est assorti, notamment l’objet de la garantie, la durée de celle-ci et les modalités de réclamation. L’Équipement peut également comporter d’autres programmes de protection facultatifs qui vous sont offerts à l’occasion.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Les Services sont-ils garantis?</strong></li></ol><p>Les Services fournis par Rogers peuvent être touchés par des facteurs indépendants du contrôle raisonnable de Rogers. Pour cette raison, vous reconnaissez et convenez que les Services ou l’accès aux Services, y compris le service d’urgence 9‑1‑1, les alertes publiques ou les services spéciaux, peuvent ne pas fonctionner correctement, ou même ne pas fonctionner du tout, dans les cas suivants :</p><ol type=\"i\"><li>si votre Équipement fait défaut, s’il n’est pas bien configuré, ou s’il ne respecte pas les exigences de Rogers;</li><li>si vous avez installé certaines applications de tiers sur votre Équipement;</li><li>en cas de panne du réseau ou de panne d’électricité prolongée;</li><li>si vous modifiez ou, dans certains cas, si vous déplacez l’Équipement;</li><li>après la suspension ou la résiliation de vos Services ou de votre compte.</li></ol><p>Dans les limites permises par la loi en vigueur :</p><ol type=\"i\"><li>les Parties de Rogers ne donnent aucune garantie ou assurance à l’égard du rendement, de la disponibilité, de la couverture, de l’utilisation sans interruption, de la sécurité, du prix ou du fonctionnement des Services, de l’Équipement <strong>(sauf en faveur des Résidents du Québec** conformément aux garanties légales)</strong> ou de tout produit, contenu, application, logiciel, service, installation, connexion ou réseau utilisé ou fourni par nous ou par des tierces parties (collectivement désignés l’« <strong>Offre</strong> »);</li><li>Rogers peut limiter toute Offre que vous pouvez acheter;</li><li>vous assumez la totalité des risques associés à l’utilisation, à l’accès, à la transmission, à la disponibilité, à la fiabilité, aux délais, à la qualité, à la sécurité et au rendement de l’Offre;</li><li>les Parties de Rogers n’offrent aucune représentation, garantie ni condition expresse ou implicite, y compris des garanties de propriété ou d’absence de contrefaçon et des garanties implicites de qualité marchande ou d’adéquation à un usage particulier, à l’égard de l’Offre.</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong></p><ol type=\"i\" start=\"5\"><li>toutes les représentations, garanties et conditions de quelque type que ce soit, expresses ou implicites, sont exclues;</li><li>aucun conseil ou renseignement, qu’il soit fait verbalement ou par écrit, que vous obtenez de la part de toute Partie de Rogers n’aura pour effet de créer une modalité, une condition, une représentation ou une garantie qui n’est pas expressément énoncée dans une Entente.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>De quelle façon Rogers limite-t-elle sa responsabilité?</strong></li></ol><p>À moins de mention contraire stipulée spécifiquement dans une Entente, dans les limites maximales permises par les lois applicables, <strong>et sauf à l’égard des Résidents du Québec** pour des dommages résultant du fait personnel d’une Partie de Rogers</strong>, les Parties de Rogers ne pourront être tenues responsables envers vous ou une tierce partie pour les éléments suivants :</p><ol type=\"i\"><li><strong>Non applicable aux Résidents du Québec** :</strong>tout dommage direct, indirect, spécial, consécutif, accessoire, économique ou punitif (y compris la perte de profits ou de revenus; les pertes financières; les pertes d’occasions d’affaires; la perte, la destruction ou l’altération de données, de fichiers ou de logiciels; le manquement à la confidentialité ou à la sécurité; les dommages matériels; les blessures corporelles; les décès ou toute autre perte prévisible ou imprévisible, quelle qu’en soit la cause) associés directement ou indirectement à l’Offre ou à la publicité, la promotion ou les déclarations relatives à un des éléments précités, même si nous avons été négligents ou si nous avions été avisés de la possibilité de tels dommages;</li><li><strong>Applicable uniquement aux Résidents du Québec** :</strong> tout dommage (y compris la perte de profits ou de revenus; les pertes financières; les pertes d’occasions d’affaires; la perte, la destruction ou l’altération de données, de fichiers ou de logiciels; le manquement à la confidentialité ou à la sécurité; les dommages matériels) associé directement ou indirectement à l’Offre;</li><li>toute Offre qui vous est fournie ou à laquelle vous avez accès par l’intermédiaire des Services, tous frais engagés relativement à une telle Offre, ou toute action qui est ou qui peut être prise au moyen de cette Offre, même si cette Offre vous a été facturée;</li><li>le rendement, la disponibilité, la fiabilité, les délais, la qualité, la couverture, l’utilisation sans interruption, la sécurité, le prix ou le fonctionnement de l’Offre;</li><li>toute erreur, inclusion ou omission en ce qui a trait aux annuaires ou aux répertoires téléphoniques;</li><li>le refus, la restriction, le blocage, l’interruption ou l’inaccessibilité des Services, y compris le 9-1-1, les alertes publiques ou les services spéciaux, l’Équipement ou les identifiants (y compris les numéros de téléphone);</li><li>la perte, le vol, l’endommagement ou l’expiration de l’Équipement, des identifiants, des mots de passe, des codes, des avantages, des rabais, des remises ou des crédits;</li><li>toute erreur ou omission ou tout délai en rapport avec le transfert des numéros de téléphone à un autre fournisseur de services de télécommunications ou en provenance d’un tel autre fournisseur de services de télécommunications, de même que toute restriction attribuable au transfert ou au fournisseur de services de télécommunications;</li><li>tout acte ou toute omission d’un fournisseur de services de télécommunications dont les installations sont utilisées pour établir une liaison avec des points à l’extérieur de notre zone de desserte; ou</li><li>toute réclamation ou tout dommage attribuable directement ou indirectement à des affirmations selon lesquelles l’utilisation, l’utilisation prévue ou une combinaison de l’Offre ou tout document transmis par l’entremise des Services contreviennent aux droits de propriété intellectuelle, industrielle ou contractuelle, ou au droit à la vie privée ou à quelque autre droit d’une tierce partie.</li></ol><p><strong>Non applicable aux Résidents du Québec** :</strong>Ces limites s’ajoutent à toutes les autres limites à la responsabilité des Parties de Rogers qui sont indiquées dans une Entente et qui s’appliquent à tout acte ou toute omission des Parties de Rogers, peu importe que ces actes ou ces omissions puissent donner lieu à un recours en vertu d’un contrat, d’un délit civil ou de quelque loi ou autre doctrine juridique.</p><p><strong></strong></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>D’autres limites de responsabilité s’appliquent-elles aux services d’urgence 9‑1‑1?</strong></li></ol><p><strong>Pour les Services sans fil :</strong></p><p>Nous ne sommes pas responsables de ce qui suit :</p><ol type=\"i\"><li>diffamation ou atteinte aux droits d’auteur inhérents au matériel ou aux messages transmis par l’intermédiaire de notre réseau à partir de votre propriété ou de vos locaux ou enregistrés à partir de votre équipement ou du nôtre;</li><li>dommages causés par vos actes, par défaut, par négligence ou par omission de votre part dans l’utilisation ou la manipulation de l’équipement que nous fournissons;</li><li>dommages causés par toute transmission illégale, de quelque façon que ce soit, de matériel ou de messages par l’intermédiaire de notre réseau en votre nom; ou</li><li>tout acte, toute omission ou toute négligence de la part d’autres entreprises ou systèmes de télécommunications lorsque leurs installations sont utilisées aux fins d’établir une connexion à partir ou en direction de vos installations et de votre équipement. À l’exception des cas de négligence de notre part entraînant des blessures, la mort ou des dommages à votre propriété ou à vos locaux, notre responsabilité pour cause de négligence relative à la prestation obligatoire de services d’urgence 9-1-1 se limite à un montant de <strong>20 $</strong> ou à <strong>3</strong> fois le montant, s’il y a lieu, auquel vous auriez autrement droit à titre de remboursement pour la prestation de Services défectueux en vertu d’une Entente, selon le montant le plus élevé. Toutefois, notre responsabilité n’est pas limitée par le présent article en cas de faute délibérée, de négligence grave ou de conduite anticoncurrentielle de notre part ou en cas de bris de contrat résultant d’une négligence grossière de notre part.</li></ol><p><strong>Pour les Services de téléphonie résidentielle :</strong></p><p>Pour que les services d’urgence 9‑1‑1 puissent fonctionner convenablement avec les Services de téléphonie résidentielle, vous devez utiliser l’adaptateur qui fait partie de l’Équipement que nous vous avons fourni (l’« <strong>Adaptateur</strong> ») et les autres éléments d’Équipement à votre adresse de service. Nous ne pourrons être tenus responsables envers vous ou une tierce partie pour tout manquement à cette exigence. Les Services de téléphonie résidentielle pourraient ne pas fonctionner normalement, ou ne pas fonctionner du tout, dans les cas suivants :</p><ol type=\"i\"><li>si votre Adaptateur ou les autres éléments de l’Équipement font défaut ou ne sont pas configurés correctement;</li><li>en cas de panne du réseau de câble ou d’une panne d’électricité prolongée;</li><li>si vous modifiez ou déplacez votre Adaptateur ou un autre élément de l’Équipement à un endroit autre que votre adresse de service; ou</li><li>après la suspension ou la résiliation de vos Services ou de votre compte.</li></ol><p>Nous ne pourrons être tenus responsables envers vous ou une tierce partie en cas d’incapacité à utiliser les Services de téléphonie résidentielle ou d’obtenir l’accès aux services d’urgence 9‑1‑1 en raison des limites décrites au présent article.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Existe-t-il des circonstances dans lesquelles je devrai indemniser Rogers?</strong></li></ol><p>Vous indemniserez et tiendrez à couvert les Parties de Rogers de quelque réclamation, perte, dommages, coûts et dépenses que ce soit (y compris, sans limitation, les frais juridiques raisonnables et autres frais de règlement de litiges), encourus par les Parties de Rogers liés à la violation, à la violation présumée ou au détournement par vous du droit de propriété intellectuelle, industrielle ou contractuelle, ou toute atteinte au droit à la vie privée ou à quelque autre droit d’une tierce partie, ou à tout présumé libelle ou à toute présumée diffamation qui serait intenté ou allégué contre vous par une tierce partie.</p><ol class=\"tc-ol-headline\" start=\"10\"><li class=\"tc-headline2\"><strong>Dispositions générales</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Comment puis-je résoudre une plainte ou un différend avec Rogers?</strong></li></ol><p>Si vous avez une plainte ou une préoccupation non résolue, nous vous invitons à remplir et à soumettre un formulaire Signaler un problème (que vous trouverez à l’adresse <a href=\"http://www.rogers.com/contacteznous\"><strong>rogers.com/contacteznous</strong></a>). Nous vous répondrons le jour ouvrable suivant. Si vous n’êtes pas satisfait de la façon dont un membre de notre direction a résolu votre plainte, vous avez également la possibilité de vous adresser au Bureau du President ou directement au bureau de l’Ombudsman.</p><p><strong>Non applicable aux Résidents du Québec** : Dans les limites maximales permises par la loi applicable,</strong>à moins d’un accord de notre part, toute réclamation ou tout différend, de nature contractuelle ou délictuelle, en vertu de la loi ou d’un règlement, ou toute autre réclamation ou tout autre différend, de nature préexistante, présente ou future, découlant de quelque façon des éléments suivants ou s’y rapportant, sera réglé par arbitrage final et liant les parties, à l’exclusion des tribunaux :</p><ol type=\"i\"><li>une Entente;</li><li>les Services ou l’Équipement;</li><li>les déclarations verbales ou écrites, la publicité ou les promotions associées à une Entente, aux Services ou à l’Équipement; ou</li><li>la relation découlant d’une Entente.</li></ol><p><strong>Le cas échéant,</strong>l’arbitrage sera mené dans la province où vous habitez et sera simplifié et mené de façon expéditive par <strong>UN</strong> arbitre conformément aux lois et règlements en vigueur ayant trait à l’arbitrage commercial dans la province ou dans l’administration où vous habitez à la date de l’avis. Rogers paiera tous les frais raisonnables associés à cet arbitrage. Tout arbitrage sera mené conformément à notre Protocole d’arbitrage, lequel est disponible à l’adresse <strong>rogers.com/modalites</strong>.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Qu’arrive-t-il si une partie d’une Entente devient inexécutoire ou cesse de s’appliquer?</strong></li></ol><p>Si une portion d’une Entente est inexécutoire, ses autres dispositions demeurent pleinement en vigueur. Notre défaut à faire appliquer de façon stricte une des dispositions d’une Entente ne constitue pas une renonciation à quelque disposition ou à quelque droit que ce soit à l’égard de la présente Entente. Ni le cours des affaires entre nous ni les pratiques commerciales ne pourront être invoqués pour modifier quelque disposition que ce soit d’une Entente.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Comment puis-je obtenir une version en anglais des présentes Modalités?</strong></li></ol><p>Si vous souhaitez obtenir une version en anglais des présentes Modalités, consultez le site Web à l’adresse <strong>rogers.com/terms</strong> ou demandez-en une copie en magasin.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Quelles lois s’appliquent aux présentes Modalités et aux autres parties de mon Entente?</strong></li></ol><p>Chaque Entente est régie exclusivement par les lois de la province où se situe votre adresse de facturation, et vous reconnaissez et acceptez la compétence exclusive des tribunaux de cette province. Toutefois, si votre adresse de facturation est située à l’extérieur du Canada, cette Entente sera régie exclusivement par les lois de la province d’Ontario, et vous reconnaissez et acceptez la compétence des tribunaux de l’Ontario. <strong>Veuillez noter que vos droits et recours peuvent varier selon chaque province.</strong><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Comment puis-je communiquer avec Rogers?</strong></li></ol></p><p>Pour communiquer avec nous :</p><ol type=\"i\"><li>rendez-vous dans un magasin Rogers;</li><li>composez le 1‑888‑ROGERS-1 (1-888-764-3771) ou, à partir de votre sans-fil Rogers, composez *611 (cet appel est sans frais);</li><li>visitez le <strong>rogers.com/contacteznous</strong> pour clavarder en direct;</li><li>envoyer une télécopie au numéro 1-800-219-6473; ou</li><li>écrivez au Service à la clientèle de Rogers, à l’adresse au 100, rue Westmorland, Moncton (Nouveau-Brunswick) E1C 0G1.</li></ol><p>Tout avis de réclamation doit être transmis au Service juridique de Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9, et cet avis sera réputé avoir été donné à la date à laquelle il est envoyé par l’expéditeur.</p><p><strong>*</strong>« <strong>Résidents de Terre-Neuve-et-Labrador</strong> » désigne les résidents de Terre-Neuve-et-Labrador qui concluent une Entente à laquelle s’applique la loi intitulée <em>Consumer Protection and Business Practices Act</em> (Terre-Neuve-et-Labrador);</p><p>** « <strong>Résidents du Québec</strong> » désigne les résidents du Québec qui concluent une Entente à laquelle s’applique la <em>Loi sur la protection du consommateur</em> (Québec).</p><p>©2015</p><p>06/15</p>");
$templateCache.put("views/localization/rogers-terms-of-service.html","<p class=\"tc-heading\">ROGERS TERMS OF SERVICE</p><ol class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Introductory Information</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How do the Rogers Terms of Service apply to me?</strong></li></ol><p>These Rogers Terms of Service (&ldquo;<strong>Terms</strong>&rdquo;) govern your use of:</p><ol type=\"i\"><li>the Rogers services that you subscribe to or purchase under a service agreement or receive from or through Rogers, including wireless and residential services (&ldquo;<strong>Services</strong>&rdquo;); and</li><li>any device or equipment used to access the Services or used with the Services (&ldquo;<strong>Equipment</strong>&rdquo;).</li></ol><p>In these Terms, &ldquo;<strong>Rogers</strong>&rdquo;, &ldquo;<strong>us</strong>&rdquo;, &ldquo;<strong>we</strong>&rdquo; and &ldquo;<strong>our</strong>&rdquo; means the Rogers entity named in the service agreement for the specific Service you subscribe to. These Terms do not apply to services offered by Rogers Media Inc. or its subsidiaries.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>How do the Rogers Terms of Service work with my service agreement and other materials made available to me?</strong></li></ol><p>These Terms work together with the following materials to form your complete agreement (&ldquo;<strong>Agreement</strong>&rdquo;) with us, and provide you with the important information you need to help you fully understand your Services:</p><ol type=\"i\"><li>Your <strong>service agreement</strong> for the specific Service you subscribe to (such as a wireless service agreement or residential service agreement).</li><li>Our <strong>Acceptable Use Policy</strong>, which sets out the rules, policies and limits you must abide by when using the Services. Our Acceptable Use Policy lists examples of prohibited activities and unlawful or inappropriate content and gives us the right to remove content and/or suspend or terminate your Services if you violate the policy.</li><li>Our <strong>Privacy Policy</strong>, which sets out our policies in relation to the collection, use and disclosure of your personal information. Our Privacy Policy details why we collect customer information, how we use it and how we share it, and specifies how to contact us if you would like more information on our personal information handling practices.</li><li>Any <strong>additional terms and conditions</strong> that may apply to a specific Service that you subscribe to or use.</li><li>Any <strong>Rogers brochure or material describing your Services or products you purchase</strong>.</li></ol><p>Your Agreement, with any amendments, is the entire agreement between you and Rogers for the applicable Services. Each Service that you subscribe to is a separate Agreement with us. If there is any inconsistency between the materials listed above and these Terms, these Terms will prevail.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Who is responsible for complying with the Agreement?</strong></li></ol><p>You, as account holder, are responsible to comply with the Agreement. Among other things, you are responsible for:</p><ol type=\"i\"><li>all charges on your account;</li><li>ensuring that anyone who uses Services under your account or with your authorization complies with the Agreement;</li><li>ensuring that others do not gain unauthorized access to your account and your Services, including by protecting the security of any user names or passwords relating to your account;</li><li>ensuring that any information you have provided to us is up-to-date and accurate, and to let us know if it changes.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>May I transfer my Agreement to someone else?</strong></li></ol><p>You will need our prior permission if you want to assign or transfer an Agreement. We may assign or transfer an Agreement or any of our rights or responsibilities under an Agreement without your permission.</p><p></p><p></p><ol class=\"tc-ol-headline\" start=\"2\"><li class=\"tc-headline2\"><strong>Service Term, Changes and Cancellation</strong></li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>What are the categories of Services covered by my Agreement?</strong></li></ol><p>The Services are categorized as follows:</p><ol type=\"i\"><li>&ldquo;<strong>Term Services</strong>&rdquo; are Services that you subscribe to for a committed period of time as indicated on your applicable service agreement (&ldquo;<strong>Term</strong>&rdquo;);</li><li>&ldquo;<strong>Month-to-Month Services</strong>&rdquo; are Services that you subscribe to on an ongoing basis, but not with a Term; and</li><li>&ldquo;<strong>Pay-Per-Use Services</strong>&rdquo; are Services that you use on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>What is the term of my Agreement?</strong></li></ol><p>The term of each Agreement starts on the initial activation date of the Services or the Equipment, whichever is earlier (&ldquo;<strong>Activation Date</strong>&rdquo;). At the end of the Term for a Term Service, the Service will automatically become a Month-to-Month Service and you will keep your existing Service and Agreement with us, unchanged, until they are changed or cancelled in accordance with these Terms.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Can Rogers change my Services or my Agreement?</strong></li></ol><p>Yes, Rogers may change your Services or Agreement as described below.</p><p><strong>For wireless Services:</strong></p><p>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change aspects of a Term Service and the corresponding Agreement, other than a key term as defined in the Canadian Radio-television and Telecommunications Commission (CRTC)&rsquo;s Wireless Code, upon at least <strong>30</strong> days&rsquo; prior written notice to you. In either case, we will send you the written notice by bill message, text message, letter or e-mail and will explain the change and when it will take effect.</p><p><strong>For residential Services:</strong></p><p><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong>We may change any aspect of a Month-to-Month Service or Term Service as well as any term or provision of an Agreement, upon prior written notice to you by bill message, text message, letter or e-mail. If you do not accept the change, your remedy will be to cancel the affected Services or Agreement by providing us with notice of cancellation under Section 2(e) below within <strong>30</strong> days of receiving our notice of change (unless we specify a different notice period or different remedy).</p><p><strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change a Term Service and the corresponding Agreement upon at least <strong>30</strong> days&rsquo; prior written notice, but will not change the price, term, nature or any other essential elements of that Term Service or that Agreement. In either case, we will send you the written notice by bill message, text message, letter or e-mail and it will contain the new or amended term or provision, the former version of that term or provision (if applicable), the date that the amendment will come into force, and your rights. If a change to a Month-to-Month Service or a Term Service entails an increase in your obligations or a decrease in our obligations and if you do not accept that change, your remedy will be to cancel the affected Services or Agreement without an Early Cancellation Fee (defined below) by providing us with notice of cancellation under Section 2(e) below no later than <strong>30</strong> days after the amendment takes effect.</p><p><strong>For Pay-Per-Use Services:</strong> Pay-Per-Use Services are subject to availability and may be changed or cancelled by Rogers at any time without prior notice to you.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>May I change my Services?</strong></li></ol><p>You may change your Services at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) below. You may also be charged a fee to change your Service if one is specified in your service agreement for that Service. Please note that if you wish to change a Service, you may only be able to change to a Service that is currently available in market. Also please note that any Service you remove may no longer be available.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>How can I cancel my Services and when does cancellation take effect?</strong></li></ol><p>Unless otherwise permitted by applicable law, you may cancel any or all of your Services and any corresponding Agreement at any time by contacting us in any of the ways set out in Section 10(e) below. Cancellation takes effect on the day that Rogers receives notice of the cancellation, or a future date specified in that notice (if applicable), whichever is later. Applicable charges continue until that date. However, if you only cancel a television Service add-on or an internet Service add-on, applicable charges continue to apply until your next billing date for that add-on.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>Will I be charged an early cancellation fee if I cancel my Service(s)?</strong></li></ol><p>If you subscribe to a Term Service that you cancel before the end of its Term, you will be charged an early cancellation fee as described in the service agreement for that Term Service (&ldquo;<strong>Early Cancellation Fee</strong>&rdquo;).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>What happens if I transfer my Service(s) to another service provider?</strong></li></ol><p>Transferring your Service(s) to another service provider is a cancellation of the applicable Service(s) and an Early Cancellation Fee may apply if the transfer results in the cancellation of a Term Service before the end of its Term.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>Can Rogers cancel my Services and when does cancellation take effect?</strong></li></ol><p><strong>Not applicable</strong><strong>to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. Applicable charges continue until the cancellation date.</p><p><strong>Applicable only to Residents of Newfoundland* or</strong><strong>Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>60</strong> days&rsquo; prior written notice. If you have subscribed to a Term Service, then we may cancel that Service: (i) (<strong>applicable only to Residents of Newfoundland*</strong>) only if we no longer have the technical ability to provide that Term Service, or (ii) (<strong>applicable only to Residents of Qu&eacute;bec**</strong>) only pursuant to Sections 1604, 2126 and 2129 of the <em>Civil Code of Qu&eacute;bec</em>. Applicable charges continue until the cancellation date. <strong>Applicable only to Residents of Newfoundland*:</strong>If your account has a credit balance over <strong>$10</strong> on your final bill, then we will refund that balance to you within <strong>60</strong> days of the date of that bill. Discretionary credits will not be refunded.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>Can Rogers suspend or cancel my Services without notice?</strong></li></ol><p>We may restrict, suspend, block, disconnect or cancel any or all of your Services, accounts or identifiers in any way, including 9-1-1 service, without notice or liability to you, if:</p><ol type=\"i\"><li>you are in breach of an Agreement, including for non-payment;</li><li>you exceed your credit limit;</li><li>you fail to provide or maintain a reasonable security deposit or other credit requirement when we ask you to;</li><li>you agree to a deferred payment arrangement with us and fail to comply with its terms;</li><li>you exceed our reasonable usage limits;</li><li>you have given us false, misleading or outdated information;</li><li>we reasonably suspect or determine that any of your account, identifiers, Services or Equipment is the subject of fraudulent, unlawful or improper usage or usage that adversely affects our operations or the use of our services, facilities or networks by others;</li><li>you harass, threaten or abuse us or our employees or agents;</li><li>you fraudulently or improperly seek to avoid payment to us;</li><li>we need to install, maintain, inspect, test, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of the Services, the Equipment or our facilities or networks;</li><li>any account or service on which your Services depend is cancelled for any reason; or</li><li>we reasonably believe that there is an emergency or extreme circumstance that would warrant that action.</li></ol><p>If we restrict, suspend, block, disconnect or cancel your Services or accounts:</p><ol type=\"i\"><li>you must pay any amounts owing;</li><li>we may also restrict, suspend, block, disconnect or cancel, without notice or liability, your Services under any other agreement or account that you may have with us or a related Rogers entity (including accounts that may be in good standing);</li><li>you may be charged for any costs incurred by us or any related Rogers entity in connection with your breach of these Terms, including costs incurred to enforce your compliance;</li><li>your access to emergency or special needs services (e.g., 9-1-1) may also be restricted, suspended, blocked, disconnected or cancelled; and</li><li>your rates for services with related Rogers entities may change in accordance with the terms of those services.</li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"10\"><li><strong>Will these Terms still apply once my Services are cancelled?</strong></li></ol><p>Certain provisions of these Terms may still apply as they may still be relevant even after cancellation of all your Services. Specifically, Sections 1(b)-(d), 2(e)-(j), 4(b)-(c), 5(c), 6(d), 8(b)-(d), 8(f), 9, 10(b)-(d) and the arbitration provisions of Section 10(a) will continue to apply to you after cancellation of your Agreement.</p><p></p><ol start=\"3\" class=\"tc-ol-headline\"><li class=\"tc-headline2\"><strong>Account, Charges and Billing Information</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How does Rogers bill me for Services?</strong></li></ol><p>Service charges will start on the Activation Date and are billed in advance. Unless we both agree to a different arrangement, your billing period runs for one month, and ends on the bill date noted on the top of your bill. Your Activation Date and billing period won&rsquo;t always start on the same day. When this happens, your Service charges and allotted usage are pro-rated for the period between your Activation Date and your bill date. Usage charges, such as additional data, airtime, long distance, movie or event purchases and roaming are billed after you use them. We may bill you for a charge up to <strong>6</strong>months from the date the charge was incurred.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>When is my bill payment due?</strong></li></ol><p>Charges on your account are due and payable in full from the date of your bill. If you are paying by mail or through a financial institution, please allow adequate time for your payment to reach us before the required payment date. You are responsible for all charges on your account.&nbsp;</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I don&rsquo;t pay my bill on time?</strong></li></ol><p>If we do not receive payment of an amount due on your account by the specified required payment date, it will be subject to a late payment charge of <strong>2</strong><strong>%</strong>per month, calculated and compounded monthly on the outstanding amount (<strong>26.82</strong><strong>%</strong>per year) from the date of the first bill on which it appears until the date we receive that amount in full. You agree that we can charge any unpaid and outstanding amount, including any late payment charges, on any pre-authorized payment method on your account (e.g., a credit card or bank account withdrawal).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will I be subject to any administrative charges?</strong></li></ol><p>We may apply administrative charges in connection with your account, including as a result of the following:</p><ol type=\"i\"><li>price plan change;</li><li>phone number (or other identifier) change;</li><li>bill reprint requests;</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><ol type=\"i\" start=\"4\"><li>collection efforts due to non-payment;</li><li>returned or rejected payments; and/or</li><li>the restoral of Service.</li></ol><p>A list of these charges is available on request, or at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/charges\"><strong>rogers.com/charges</strong></a>, and forms part of these Terms.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>What if I do not understand or disagree with a charge on my bill?</strong></li></ol><p>Any questions or discrepancies regarding charges must be reported to us within <strong>90</strong>days of the date of the applicable bill. Failure to notify us within this time period means that you have accepted those charges. If any of those discrepancies resulted in unauthorized or incorrect charges on your account, then we will reverse those charges within <strong>30</strong> days of receiving notice from you.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>How do discounts and promotions work?</strong></li></ol><p>We will apply a discount, promotion or benefit to your account as long as you remain eligible for it. We may check your eligibility from time to time, and if you become ineligible to receive that discount, promotion or benefit for any reason, we may remove it, and/or transfer your Service to a comparable Service plan.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"7\"><li><strong>How is wireless local and long distance airtime charged?</strong></li></ol><p>Local and long distance airtime charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed call (made or received). The airtime for the entire call is charged based on the applicable rate at the beginning of the call. Airtime charges (plus long distance, if applicable) apply to completed or answered calls from the moment you press SEND until you press END and includes the ring time. For international calls or while roaming, you may be charged regardless of whether the call is completed.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"8\"><li><strong>How does Rogers determine if I&rsquo;m on a long distance wireless call?</strong></li></ol><p>Wireless local calling areas are the areas in which you can make or receive calls without incurring long distance charges. Wireless calls are defined as local or long distance based on local calling areas. Your location at the time of the call, your wireless phone number and the phone number called are all important factors in determining local calling areas and wireless long distance. Your &ldquo;Incoming Local Calling Area&rdquo; is based on the geographical location associated with your wireless number. All calls that you receive while you are in your Incoming Local Calling Area are local. All calls that you receive while you are outside your Incoming Local Calling Area are long distance. Your &ldquo;Outgoing Local Calling Area&rdquo; is determined by your physical location. If you dial a number that is local to your physical location, then it is a local call. If you dial a number that is long distance to your physical location, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside the geographical location associated with your wireless number, regardless of your physical location. Visit rogers.com/longdistance for current long distance rates.</p><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"9\"><li><strong>How is home phone long distance calling charged and how does Rogers determine if I&rsquo;m on a long distance home phone call?</strong></li></ol><p>Long distance charges are rounded up to the next full minute. A one-minute minimum charge applies to every completed long distance call you make. For international calls, you may be charged regardless of whether the call is completed. For home phone Services, calls are defined as local or long distance based on local calling areas, and your local calling area depends on your home phone number. If you dial a number that is long distance to your home phone number, then it is a long distance call. When using Call Forwarding, long distance charges apply when the number to which you forward the call is outside your local calling area.</p><ol class=\"tc-ol-headline\" start=\"4\"><li class=\"tc-headline2\"><strong>Deposit and Credit Requirements</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Does Rogers require security deposits or other payment or credit requirements?</strong></li></ol><p>Yes, we may require a security deposit or impose other payment or credit requirements such as interim payments, mandatory pre-payments, or pre-authorized payments.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>How are security deposits used?</strong></li></ol><p>Any security deposit you provide to us will be kept for at least <strong>12</strong> months, unless your Services are cancelled sooner. After <strong>12</strong> months, we may release and apply the security deposit against your account balance if we determine that your payment history has been satisfactory or that you have otherwise met our financial criteria for the return of the security deposit. We may apply your security deposit toward your account if you do not pay your bill and we may require you to replenish the security deposit after use. We will notify you when we apply all or part of any security deposit. We will return to you any security deposit with applicable interest within <strong>30</strong> days of cancellation of your Services or once we have determined that the conditions for returning the security deposit have been met.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Will I earn any interest on security deposits?</strong></li></ol><p>Yes, you will earn interest on your security deposit with us, using the Bank of Canada&rsquo;s overnight rate in effect at the time, plus <strong>1</strong> percent, on the basis of the actual number of days in a year, accruing on a monthly basis. Interest is earned starting from the date we collect a security deposit from you (but no earlier than required under applicable legislation or regulation) until the date we return it to you.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will Rogers impose a credit limit on my account?</strong></li></ol><p>Upon notice to you, we may assign or change a credit limit on your account at any time. Service may be suspended at any time to any and all of your accounts if your balance, including unbilled usage and pending charges, fees and adjustments, exceeds this limit. Recurring service charges continue to apply during any suspension of Services.</p><ol class=\"tc-ol-headline\" start=\"5\"><li class=\"tc-headline2\"><strong>Your Use of the Services</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Do I own my phone number?</strong></li></ol><p>You do not own any phone number, e-mail address or other identifier assigned to you. We may change or remove an identifier at any time.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Does Rogers monitor the content that I transmit when I use the Services?</strong></li></ol><p>We have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment. We may also access or preserve content or information to comply with legal process in Canada or foreign jurisdictions, operate the Services, ensure compliance with an Agreement, or protect ourselves, our customers or the public.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What are my responsibilities relating to Rogers or third party software or content?</strong></li></ol><p>All trademarks, copyright, brand concepts, names, logos and designs that we use are intellectual property assets, registered or otherwise, of or used under license by Rogers Communications Inc. or of one of its affiliates. All are recognized as valuable assets of their respective owners, and you may not display, copy or use them in any manner for commercial or any other purpose.</p><p>Any software or content that you receive or purchase through Rogers or our third party storefronts is for your own personal, non-commercial use. This software or content remains our property or that of our licensors or content providers, as applicable. You may not:</p><ol type=\"i\"><li>copy, distribute, transfer or sell any of this software or content;</li><li>modify, alter or tamper with any of this software or content;</li><li>reverse engineer, decompile or disassemble any of this software;</li><li>attempt to defeat, avoid, by-pass, remove, deactivate or otherwise circumvent any software protection mechanisms.</li></ol><p>You must also take reasonable steps to protect this software or content from theft, loss or damage. Please be aware that software or content may from time to time automatically and, without notice to you, cause your Equipment to access the internet incurring data usage and/or overage charges.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>What do I need to know about the Yahoo! Services available to me?</strong></li></ol><p>Yahoo! Inc. and its affiliates may provide Rogers internet Service customers with access to a collection of resources, including various communications tools and content (the &ldquo;<strong>Yahoo! Services</strong>&rdquo;). When you use the Yahoo! Services, the Yahoo! terms of service, guidelines and rules (&ldquo;<strong>Yahoo! Terms</strong>&rdquo;) applicable to such services that are posted on the pages where you access these services govern your use of the Yahoo! Services. By using the Yahoo! Services you agree to be bound by the Yahoo! Terms which are incorporated by reference into an Agreement. With respect to Rogers internet Services and the Yahoo! Services, the obligations of Rogers and Yahoo! are several and not joint. To contact Yahoo! Inc. regarding the Yahoo! Services only: write to Customer Care, 701 First Avenue, Sunnyvale, CA, 94089, USA. Information about how your personal information is treated when using the Rogers internet Services andYahoo! Services is available at <a href=\"http://www.rogers.yahoo.com/privacy\"><strong>rogers.yahoo.com/privacy</strong></a>.</p><p></p><ol class=\"tc-ol-headline\" start=\"6\"><li class=\"tc-headline2\"><strong>Equipment</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Is Equipment new or refurbished?</strong></li></ol><p>Equipment that you purchase from us is new, unless otherwise indicated. Equipment that you rent from us is refurbished, unless otherwise indicated, and is based on availability. If you have purchased Equipment from us and have received a subsidy on that Equipment resulting in a charge of <strong>$0</strong>, please note that that Equipment has been provided to you as a subsidized good and not a free good.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>May I upgrade my Equipment?</strong></li></ol><p>You may upgrade your Equipment at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) above. If, in connection with your Equipment upgrade, you are subscribing to a new Term and cancelling a previous Term early, you will be charged an Early Cancellation Fee. Please note that if you wish to upgrade your Equipment, you may also be required to change to a Service that is currently available in market. Also please note that any Service or Equipment you remove may no longer be available.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Is my Equipment locked or restricted to the Rogers network or Services?</strong></li></ol><p><strong>For wireless Services:</strong></p><p>Your wireless device is locked and restricted to be used only on the Rogers network, but may also be used on the networks operated by any of the carriers with which we have roaming agreements. If you attempt to unlock your device it may become permanently unusable and may violate the software licence agreement for your device. If you would like to unlock your wireless device, the Device Unlock Fee set out in your wireless service agreement will apply. If you were given a device subsidy, we will only unlock your device after the first <strong>90</strong> days of your Term. Please also note that for the first <strong>90</strong> days following the Activation Date, if you are roaming off the Rogers network, your Service will be restricted from placing outgoing calls to destinations other than those that have a North American area code (including Canada and the USA) and the destination at which are located while placing the call (not applicable to prepaid service).</p><p><strong>For residential Services:</strong></p><p>Purchased and rental Equipment are to be used only with Rogers Services at the service address identified on your account. If you attempt to tamper with any Equipment, it may become permanently unusable and may violate the software licence agreement for that Equipment.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Will Rogers ever need access to my property?</strong></li></ol><p>For residential Services, you authorize us and our representatives to enter or have access to your premises as necessary at mutually agreed upon times to install, maintain, inspect, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of our services, the Equipment or our facilities or networks. If any of your Services or accounts have been cancelled, then you authorize us and our representatives to enter or have access to your premises to disconnect the Services and remove our Equipment, as applicable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Who is responsible for ensuring that my Equipment is up to date?</strong></li></ol><p>Equipment and related software may have to meet certain minimum requirements and be maintained in certain ways and in certain locations in order to access the Services or for the proper operation of the Services (e.g., 9-1-1 services). Those requirements may change from time to time and you are responsible for updating or maintaining your Equipment and software as necessary to meet those requirements. We may provide software updates for the Equipment for the continued operation of the Services or the Equipment. Likewise, from time to time we may have to modify or remove previous software features in order to introduce new features to ensure that the Equipment remains compatible with technological advancements. If your Equipment or software is not up to date, we may not be able to provide you with applicable customer support.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>What are my responsibilities relating to the Equipment?</strong></li></ol><p>You are solely responsible for:</p><ol type=\"i\"><li>any access to the Equipment;</li><li>providing any additional connections, as well as inside wiring and home phone terminal equipment, that are not provided by us;</li><li>reconnecting any of your equipment and facilities as necessary after cancellation of your Services;</li><li>maintaining the security and privacy of your property and your transmissions using the Services, the Equipment or our facilities or networks;</li><li>protecting against any breaches of security or privacy or other risks involved in installing, using, maintaining or changing the Services or the Equipment; and</li><li>ensuring that there are no unauthorized attachments to the Equipment or our cable ( e.g., for television Equipment, only <strong>1</strong> television may be attached to any outlet).</li></ol><p>Except for Equipment that you have fully paid for, all Equipment we install or provide to you remains our property. For all Equipment we own, you must:</p><ol type=\"i\"><li>take reasonable care of it;</li><li>not sell, lease, mortgage, transfer, assign or encumber it;</li><li>not re-locate it without our knowledge and permission; and</li><li>return it to us at your own expense upon cancellation of the Services to which the Equipment is related.</li></ol><p>If our Equipment is lost, damaged, stolen, sold, leased, mortgaged, transferred, assigned, encumbered or not returned, you must immediately notify us. You agree to pay us the undiscounted retail value of that Equipment, together with any costs we incur in seeking possession of it.</p><ol class=\"tc-ol-headline\" start=\"7\"><li class=\"tc-headline2\"><strong>Prepaid Wireless Service</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>If I am a Rogers prepaid wireless customer, how can I check my prepaid wireless usage balance?</strong></li></ol><p>You can check your usage balance from your prepaid wireless device by calling *611 (it&rsquo;s a free call).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>If I change my mind about adding to my prepaid wireless balance, can I get a refund?</strong></li></ol><p>No. Deposits into your account for prepaid wireless Services are non-refundable.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I don&rsquo;t use my prepaid wireless Service on a regular basis?</strong></li></ol><p>If your prepaid wireless account balance remains at <strong>$0</strong> for <strong>6</strong>consecutive months or if required payments towards your account are not made or are returned, for any reason, your prepaid wireless identifier (e.g., phone number or PIN number) will be deactivated. Please also note any prepaid wireless balance may have an expiry date as indicated.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Other than usage charges, are there any additional fees associated with prepaid wireless Service?</strong></li></ol><p>We will deduct a 9-1-1 Emergency Access Fee (non-government fee) for the provision of access to 9-1-1 service and any applicable 9-1-1 provincial government fee, once per month from your prepaid wireless account (there is no airtime charge for calls made from your wireless device to 9-1-1). For more information, please visit <a href=\"http://www.rogers.com/911\"><strong>rogers.com/911</strong></a>.</p><ol class=\"tc-ol-headline\" start=\"8\"><li class=\"tc-headline2\"><strong>Your Privacy</strong></li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>What can Rogers do with my account information and personal information?</strong></li></ol><p>By entering into an Agreement, you expressly:</p><ol type=\"i\"><li>authorize Rogers to collect and use your current and historical personal location information associated with any device you use under your Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.</li><li>agree that your account information may be disclosed to other members of the Rogers Communications Inc. organization, and to our agents, authorized dealers and distributors to service your account, respond to your questions, telemarket (including by way of automatic dialing and announcing devices), and promote additional products and services offered by members of the Rogers Communications Inc. organization. If you do not wish to receive these offers or information, please contact us in any of the ways set out in Section 10(e) below.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Where will my personal information be stored?</strong></li></ol><p>Personal information collected in connection with the provision of the Services may be stored and processed in or outside Canada and may be subject to the laws of other jurisdictions.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>Will Rogers disclose my personal information to any outside parties?</strong></li></ol><p>Unless you provide express consent or disclosure is required pursuant to a legal power, all information regarding you kept by us, other than your name, address and listed phone number, is confidential and may not be disclosed by us to anyone other than:</p><ol type=\"i\"><li>you;</li><li>a person who, in our reasonable judgment, is seeking the information as your agent;</li><li>another telephone company, provided the information is required for the efficient and cost-effective provision of home phone service and disclosure is made on a confidential basis, with the information to be used only for that purpose;</li><li>a company involved in supplying phone or phone directory-related services, provided the information is required for that purpose and disclosure is made on a confidential basis, with the information to be used only for that purpose;</li><li>an agent retained by us in the collection of your account or to perform other administrative functions for us, provided the information is required for and used only for that purpose;</li><li>an agent retained by us to evaluate your creditworthiness, provided the information is required for and is to be used only for that purpose;</li><li>a law enforcement agency whenever we have reasonable grounds to believe that you have knowingly supplied us with false or misleading information or are otherwise involved in unlawful activities;</li><li>a public authority or agent of a public authority if, in our reasonable judgment, it appears that there is imminent danger to life or property which could be avoided or minimized by disclosure of the information; or</li><li>a public authority or agent of a public authority, for emergency public alerting purposes, if a public authority has determined that there is an imminent or unfolding danger that threatens the life, health or security of an individual and that the danger could be avoided or minimized by disclosure of the information.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>How does Rogers obtain consent from me to disclose my personal information?</strong></li></ol><p>Express consent to disclosure may be obtained by:</p><ol type=\"i\"><li>written consent;</li><li>oral confirmation verified by an independent third party;</li><li>electronic confirmation through the use of a toll-free number;</li><li>electronic confirmation via the internet;</li><li>oral consent, where an audio recording of the consent is retained by us; or</li><li>consent through other methods, as long as an objective documented record of your consent is created by you or by an independent third party.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Can I have an unlisted home phone number?</strong></li></ol><p>You may opt to pay for an unlisted home phone number; however, please note that directories or providers of operator services may obtain your phone numbers and address from a source other than us. In addition, your name, address and phone numbers will be accessible by 9-1-1 service providers even if you pay for an unlisted phone number.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"6\"><li><strong>How can I get more information about the protection of my personal information at Rogers?</strong></li></ol><p>Our corporate and online Privacy Policies are available at <a href=\"http://www.rogers.com/privacy\"><strong>rogers.com/privacy</strong></a>. To contact our Privacy Officer in order to access, obtain more information about your personal information held by Rogers, make a privacy-related complaint, or obtain a copy of our Privacy Policies: e-mail us at <a href=\"mailto:privacy@rci.rogers.com\"><strong>privacy@rci.rogers.com</strong></a>; or write to Chief Privacy Officer, Rogers Group of Companies, 333 Bloor Street East, Toronto, ON M4W 1G9.</p><p></p><ol class=\"tc-ol-headline\" start=\"9\"><li class=\"tc-headline2\"><strong>Warranties and Limitation of Liability</strong></li></ol><p>Please note that the term &ldquo;<strong>Rogers Parties</strong>&rdquo; includes Rogers and its affiliates, partners, licensors, dealers, representatives, suppliers and agents (and their respective employees, officers, directors, shareholders and representatives).</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>Are there any warranties on the Equipment?</strong></li></ol><p>The Equipment may be covered by a manufacturer&rsquo;s or other warranty. Please see the materials accompanying your Equipment for warranty information and details, including coverage, duration and how you may make a claim under the warranty. There may also be optional Equipment protection programs made available to you from time to time.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>Are there any warranties on the Services?</strong></li></ol><p>The Services that Rogers provides may be impacted by factors beyond Rogers&rsquo; reasonable control. For this reason, you acknowledge and understand that the Services or access to the Services, including 9-1-1, public alerts or special needs services, may not function correctly or at all in the following circumstances:</p><ol type=\"i\"><li>if your Equipment fails, is not configured correctly or does not meet Rogers&rsquo; requirements;</li><li>if you install certain third party applications on your Equipment;</li><li>in the event of a network outage or extended power failure;</li><li>if you tamper with or, in some cases, move the Equipment; or</li><li>following suspension or cancellation of your Services or account.</li></ol><p>To the maximum extent permitted by applicable law:</p><ol type=\"i\"><li>the Rogers Parties do not guarantee or warrant the performance, availability, coverage, uninterrupted use, security, pricing or operation of the Services, the Equipment <strong>(except towards residents of Qu&eacute;bec** in accordance with statutory warranties)</strong> or any products, content, applications, software, services, facilities, connections or networks used or provided by us or third parties (collectively, the &ldquo;<strong>Offering</strong>&rdquo;);</li><li>Rogers may limit the amount of an Offering that you may purchase;</li><li>you bear the entire risk as to the use, access, transmission, availability, reliability, timeliness, quality, security and performance of the Offering;</li><li>the Rogers Parties do not make any express or implied representations, warranties or conditions, including warranties of title or non-infringement, or implied warranties of merchantable quality or fitness for a particular purpose, with regard to the Offering.</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong></p><ol type=\"i\" start=\"5\"><li>all representations, warranties and conditions of any kind, express or implied, are excluded;</li><li>no advice or information, whether oral or written, that you obtain from the Rogers Parties creates any term, condition, representation or warranty not expressly stated in an Agreement.</li></ol><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>How does Rogers limit its liability?</strong></li></ol><p>Unless otherwise specifically set out in an Agreement, to the maximum extent permitted by applicable law, and <strong>except towards Residents of Qu&eacute;bec** for damages resulting from a Rogers Party&rsquo;s own act</strong>, the Rogers Parties will not be liable to you or to any third party for:</p><ol type=\"i\"><li><strong>Not applicable to Residents of Qu&eacute;bec**:</strong>any direct, indirect, special, consequential, incidental, economic or punitive damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; property damage; personal injury; death; or any other foreseeable or unforeseeable loss, however caused) resulting or relating directly or indirectly from or relating to the Offering or any advertisements, promotions or statements relating to any of the foregoing, even if we were negligent or were advised of the possibility of such damages;</li><li><strong>Applicable only to Residents of Qu&eacute;bec**:</strong> any damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; or property damage) resulting or relating directly or indirectly from or relating to the Offering;</li><li>any Offering provided to you or accessible by you through the Services, any charges incurred in connection with such Offering or anything that is or can be done with such Offering even if you are billed for such Offering;</li><li>the performance, availability, reliability, timeliness, quality, coverage, uninterrupted use, security, pricing or operation of the Offering;</li><li>any error, inclusion or omission relating to any telephone listings or directories;</li><li>the denial, restriction, blocking, disruption or inaccessibility of any Services, including 9-1-1, public alerts or special needs services, Equipment or identifiers (including phone numbers);</li><li>any lost, stolen, damaged or expired Equipment, identifiers, passwords, codes, benefits, discounts, rebates or credits;</li><li>any error, omission or delay in connection with the transfer of phone numbers to or from another telecommunications service provider, or any limitation connected to that transfer or that telecommunications service provider;</li><li>any acts or omissions of a telecommunications carrier whose facilities are used to establish connections to points that we do not serve; or</li><li>any claims or damages resulting directly or indirectly from any claim that the use, intended use or combination of the Offering or any material transmitted through the Services infringes the intellectual property, industrial, contractual, privacy or other rights of a third party.</li></ol><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong>These limits are in addition to any other limits on the Rogers Parties&rsquo; liability set out elsewhere in an Agreement and apply to any act or omission of the Rogers Parties, whether or not the act or omission would otherwise be a cause of action in contract, tort or pursuant to any statute or other doctrine of law.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>Are there any additional limitations of liability that apply to 9-1-1 emergency services?</strong></li></ol><p><strong>For wireless Services:</strong></p><p>We are not liable for:</p><ol type=\"i\"><li>libel, slander, defamation or the infringement of copyright arising from material or messages transmitted over our network from your property or premises or recorded by your equipment or our equipment;</li><li>damages arising out of your act, default, neglect or omission in the use or operation of equipment that we provide;</li><li>damages arising out of the transmission of material or messages over our network on your behalf, which is in any way unlawful; or</li><li>any act, omission or negligence of other companies or telecommunications systems when their facilities are used in establishing connections to or from your facilities and equipment. Except in cases where negligence on our part results in physical injury, death or damage to your property or premises, our liability for negligence related to the provision of 9-1-1 emergency services on a mandatory basis is limited to the greater of <strong>$20</strong> and <strong>3</strong> times the amount, if any, you would otherwise be entitled to receive as a refund for the provision of defective Service under an Agreement. However, our liability is not limited by this Section in cases of deliberate fault, gross negligence or anticompetitive conduct on our part or in cases of breach of contract where the breach results from our gross negligence.</li></ol><p><strong>For home phone Services:</strong></p><p>In order for 9-1-1 emergency services to function properly with home phone Services, you must use the adapter which forms part of the Equipment we have provided you (&ldquo;<strong>Adaptor</strong>&rdquo;) and other Equipment at your service address. We will not be liable to you or to any third party for your failure to comply with this requirement. The home phone Services may not function correctly, or at all, in the following circumstances:</p><ol type=\"i\"><li>if your Adaptor or other Equipment fails or is not configured correctly;</li><li>in the event of a cable network outage or extended power failure;</li><li>if you tamper with or move your Adaptor or other Equipment to a location other than your service address; or</li><li>following suspension or cancellation of your Services or account.</li></ol><p>We will not be liable to you or to any third party for any inability to use the home phone Services or to obtain access to 9-1-1 emergency services as a result of the limitations described in this Section.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>Are there any circumstances under which I would have to compensate Rogers?</strong></li></ol><p>You will indemnify and hold harmless the Rogers Parties from and against any claims, losses, damages, costs and expenses (including, without limitation, reasonable legal fees and other litigation expenses) incurred by the Rogers Parties relating to your violation, alleged violation or misappropriation of any intellectual property, industrial, contractual, privacy or other rights of a third party or any alleged libel or slander by a third party against you.</p><ol class=\"tc-ol-headline\" start=\"10\"><li class=\"tc-headline2\"><strong>General</strong></li></ol><p></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\"><li><strong>How can I resolve a complaint or dispute with Rogers?</strong></li></ol><p>If you have a concern that was not resolved, then we invite you to submit a Share a Concern form (located at <a href=\"http://www.rogers.com/contactus\"><strong>rogers.com/contactus</strong></a>) and we&rsquo;ll respond within <strong>1</strong> business day. If you&rsquo;re not satisfied with the resolution by one of our management team members, then you also have the option to speak to our Office of the President or even directly with the Ombudsman office.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**: To the extent permitted by applicable law,</strong>unless we agree otherwise, any claim or dispute, whether in contract or tort, under statute or regulation, or otherwise, and whether pre-existing, present or future, arising out of or relating to the following items will be determined by final and binding arbitration to the exclusion of the courts:</p><ol type=\"i\"><li>an Agreement;</li><li>the Services or Equipment;</li><li>oral or written statements, advertisements or promotions relating to an Agreement, the Services or Equipment; or</li><li>the relationships that result from an Agreement.</li></ol><p><strong>Where applicable,</strong>arbitration will be conducted in the province in which you reside, on a simplified and expedited basis by <strong>1</strong> arbitrator under the current laws and rules relating to commercial arbitration in the province or jurisdiction in which you reside on the date of the notice. Rogers will pay all reasonable costs associated with that arbitration. Any arbitration will be conducted in accordance with our Arbitration Protocol, which is available at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/terms\"><strong>rogers.com/terms</strong></a>.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"2\"><li><strong>What happens if part of an Agreement becomes unenforceable or doesn&rsquo;t apply?</strong></li></ol><p>If any portion of an Agreement is unenforceable, the remaining provisions continue in full force. Our failure to enforce strict performance of any provision of an Agreement does not mean we have waived any provision or right. Neither the course of conduct between us nor trade practice modifies any provision of an Agreement.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"3\"><li><strong>What if I would prefer to have a copy of these Terms in French?</strong></li></ol><p>These Terms have been drawn up in the English language at the express request of the parties. Les pr&eacute;sentes modalit&eacute;s ont &eacute;t&eacute; r&eacute;dig&eacute;es en anglais &agrave; la demande expresse des parties. If you would like a copy of these Terms in French, please visit <a href=\"http://www.rogers.com/modalites\"><strong>rogers.com/modalit&eacute;s</strong></a>, or request a copy in store.</p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"4\"><li><strong>What laws apply to these Terms and the rest of my Agreement?</strong></li></ol><p>Each Agreement is governed exclusively by the laws of the province in which your billing address is located and you submit to the exclusive jurisdiction of the courts of that province. However, if your billing address is outside of Canada, that Agreement is governed exclusively by the laws of the province of Ontario and you submit to the jurisdiction of the courts of Ontario. <strong>Please note that your rights and remedies may vary by province.</strong></p><ol type=\"a\" class=\"tc-ol-headline tc-headline1\" start=\"5\"><li><strong>How can I contact Rogers?</strong></li></ol><p>To contact us:</p><ol type=\"i\"><li>visit a Rogers store;</li><li>call 1-888-ROGERS1 (1-888-764-3771) or, from your Rogers wireless phone, call *611 (it&rsquo;s a free call);</li><li>go online at <a href=\"http://www.rogersteamspace.com/sites/legaldms/Matter%20Documents/sara.sytsma/Terms%20of%20Service%20Rewrite%202014-LEGAL2014-273/Rogers%20TOS%20Drafts/rogers.com/contactus\"><strong>rogers.com/contactus</strong></a> to use our live chat;</li><li>send a fax to 1-800-219-6473; or</li><li>write to Rogers Customer Care, 100 Westmorland Street, Moncton, NB&nbsp;E1C 0G1.</li></ol><p>Any notice of a claim must be given to the Rogers Legal Department, 333 Bloor Street East, Toronto, ON M4W 1G9 and will be deemed to have been given on the date on which it was sent by the party giving the notice.</p><p></p><p><strong>*</strong>&ldquo;<strong>Residents of Newfoundland</strong>&rdquo; means residents of Newfoundland and Labrador who enter into an Agreement to which the <em>Consumer Protection and Business Practices Act</em>(Newfoundland and Labrador) applies.</p><p>** &ldquo;<strong>Residents of Qu&eacute;bec</strong>&rdquo; means residents of Qu&eacute;bec who enter into an Agreement to which the <em>Consumer Protection Act</em> (Qu&eacute;bec) applies.</p><p>&copy;2015</p><p>06/15</p>");
$templateCache.put("views/localization/service-term-changes-cancellations-fr.html","<div class=\"bold paragraph\">P&eacute;riode d&rsquo;abonnement, modifications et r&eacute;siliation</div><div class=\"paragraph\"><p>a. Quelles sont les cat&eacute;gories de Services vis&eacute;es par mon Entente?</p><p>Les Services sont class&eacute;s selon les cat&eacute;gories suivantes:</p><p>i. Les <strong>&laquo; Services &agrave; dur&eacute;e d&eacute;termin&eacute;e &raquo;</strong> s&rsquo;entendent de Services auxquels vous vous abonnez et qui comportent une p&eacute;riode d&rsquo;abonnement pr&eacute;d&eacute;termin&eacute;e, tel qu&rsquo;il est indiqu&eacute; dans votre entente de service applicable (la <strong>&laquo; P&eacute;riode d&rsquo;abonnement &raquo;</strong>);<br>ii. Les <strong>&laquo; Services mensuels &raquo;</strong> s&rsquo;entendent de Services auxquels vous vous abonnez de fa&ccedil;on continue, mais qui ne comportent pas de P&eacute;riode d&rsquo;abonnement;<br>iii.Les <strong>&laquo; Services factur&eacute;s &agrave; l&rsquo;utilisation &raquo;</strong> s&rsquo;entendent de Services que vous utilisez et qui sont factur&eacute;s &agrave; l&rsquo;utilisation (qu&rsquo;ils soient utilis&eacute;s une seule fois ou pendant une p&eacute;riode donn&eacute;e, comme un jour ou une semaine), mais qui ne sont pas utilis&eacute;s de fa&ccedil;on continue.<br></p><p>b. Quelle est la dur&eacute;e de mon Entente?</p><p>La dur&eacute;e de chaque Entente d&eacute;bute &agrave; la date de mise en service initiale des Services ou de l&rsquo;&Eacute;quipement, selon la premi&egrave;re date &agrave; survenir (la <strong>&laquo; Date de mise en service &raquo;</strong>). &Agrave; la fin de la P&eacute;riode d&rsquo;abonnement d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e deviendra automatiquement un Service mensuel, et votre Entente et votre Service existants aupr&egrave;s de Rogers demeureront inchang&eacute;s jusqu&rsquo;&agrave; ce qu&rsquo;ils soient modifi&eacute;s ou r&eacute;sili&eacute;s conform&eacute;ment aux pr&eacute;sentes Modalit&eacute;s.</p><p>c. Rogers peut-elle modifier mes Services ou mon Entente?</p><p>Oui, Rogers peut apporter des changements &agrave; vos Services et &agrave; votre Entente, conform&eacute;ment &agrave; ce qui suit.</p><p><strong>Pour les Services sans fil:</strong><br>Nous pouvons modifier tout aspect d&rsquo;un Service mensuel et de l&rsquo;Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Nous pouvons &eacute;galement modifier des aspects d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e et de l&rsquo;Entente qui y est associ&eacute;e, autres que les principales modalit&eacute;s selon ce qui est pr&eacute;vu au Code sur les services sans fil du Conseil de la radiodiffusion et des t&eacute;l&eacute;communications canadiennes (CRTC), en vous en avisant par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Dans un cas comme dans l&rsquo;autre, nous vous enverrons l&rsquo;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis comprendra des explications sur la modification ainsi que sa date d&rsquo;entr&eacute;e en vigueur.</p><p><strong>Pour les Services r&eacute;sidentiels:</strong><br><strong>Non applicable aux R&eacute;sidents de Terre-Neuve-et-Labrador* ou aux R&eacute;sidents du Qu&eacute;bec** :</strong> Nous pouvons modifier tout aspect d&rsquo;un Service mensuel ou d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ainsi que toute disposition ou modalit&eacute; d&rsquo;une Entente, en vous faisant parvenir un pr&eacute;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par courrier ou par courriel. Si vous n&rsquo;acceptez pas ce changement, votre recours consiste &agrave; r&eacute;silier les Services ou l&rsquo;Entente vis&eacute;s en nous faisant parvenir un avis de r&eacute;siliation conform&eacute;ment au paragraphe 2e) ci-apr&egrave;s dans les <strong>30</strong> jours suivant la r&eacute;ception de notre avis de modification (&agrave; moins que nous y indiquions une autre p&eacute;riode d&rsquo;avis ou un autre recours). <strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> Nous pouvons modifier tout aspect d&rsquo;un Service mensuel et de l&rsquo;Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Nous pouvons &eacute;galement modifier un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e et l&rsquo;Entente qui y est associ&eacute;e en vous en avisant par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance, mais nous ne modifierons pas le prix, la dur&eacute;e, la nature ou tout autre aspect essentiel de ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e ou de l&rsquo;Entente. Dans un cas comme dans l&rsquo;autre, nous vous enverrons l&rsquo;avis &eacute;crit par message apparaissant sur votre facture, par message texte, par lettre ou par courriel, et cet avis contiendra la nouvelle modalit&eacute; ou disposition, la modalit&eacute; ou disposition modifi&eacute;e, l&rsquo;ancienne version de cette modalit&eacute; ou disposition (le cas &eacute;ch&eacute;ant), la date &agrave; laquelle la modification entrera en vigueur et un &eacute;nonc&eacute; de vos droits. Si le changement &agrave; un Service mensuel ou &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e entra&icirc;ne une augmentation de vos obligations ou une r&eacute;duction de nos obligations et que vous n&rsquo;acceptez pas ce changement, votre recours consiste &agrave; r&eacute;silier les Services ou l&rsquo;Entente vis&eacute;s sans Frais de r&eacute;siliation anticip&eacute;e (tels que d&eacute;finis ci-apr&egrave;s) en nous faisant parvenir un avis de r&eacute;siliation conform&eacute;ment au paragraphe 2e) ci-apr&egrave;s au plus tard <strong>30</strong> jours suivant l&rsquo;entr&eacute;e en vigueur de la modification.</p><p><strong>Pour les Services factur&eacute;s &agrave; l&rsquo;utilisation :</strong> Les Services factur&eacute;s &agrave; l&rsquo;utilisation sont offerts sous r&eacute;serve de leur disponibilit&eacute;, et Rogers peut les modifier ou les r&eacute;silier en tout temps sans vous en aviser au pr&eacute;alable.</p><p>d. Puis-je modifier mes Services?</p><p>Vous pouvez modifier vos Services &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. Vous pourriez devoir payer des frais d&rsquo;administration conform&eacute;ment au paragraphe 3d) ci-apr&egrave;s. Vous pourriez &eacute;galement devoir payer des frais pour changer un Service si de tels frais sont indiqu&eacute;s dans votre entente de service applicable &agrave; ce Service. Veuillez noter que, si vous souhaitez changer un Service, vous pourriez seulement pouvoir le remplacer par un Service qui est offert &agrave; ce moment-l&agrave;, et que tout Service annul&eacute; &agrave; votre demande pourrait ne plus &ecirc;tre disponible.</p><p>e. Comment puis-je r&eacute;silier mes Services et &agrave; quel moment la r&eacute;siliation entre-t-elle en vigueur?</p><p>&Agrave; moins que les lois applicables ne permettent autre chose, vous pouvez r&eacute;silier la totalit&eacute; ou une partie de vos Services et toute Entente qui y est associ&eacute;e &agrave; tout moment en communiquant avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s. La r&eacute;siliation entre en vigueur &agrave; la date &agrave; laquelle Rogers re&ccedil;oit l&rsquo;avis de r&eacute;siliation ou &agrave; une date ult&eacute;rieure qui est indiqu&eacute;e dans l&rsquo;avis (le cas &eacute;ch&eacute;ant), selon la date la plus &eacute;loign&eacute;e. Les frais exigibles continueront de s&rsquo;appliquer jusqu&rsquo;&agrave; cette date. Cependant, si vous annulez uniquement une option du Service de t&eacute;l&eacute;vision ou du Service d&rsquo;acc&egrave;s Internet, les frais applicables pour cette option continueront de s&rsquo;appliquer jusqu&rsquo;&agrave; votre prochaine date de facturation.</p><p>f. Devrai-je payer des frais de r&eacute;siliation anticip&eacute;e si j&rsquo;annule l&rsquo;un ou l&rsquo;autre de mes Services?</p><p>Si vous vous abonnez &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e que vous r&eacute;siliez avant la fin de sa P&eacute;riode d&rsquo;abonnement, vous devrez payer des frais de r&eacute;siliation anticip&eacute;e tel qu&rsquo;il est d&eacute;crit dans l&rsquo;entente de service applicable &agrave; ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e (les <strong>&laquo; Frais de r&eacute;siliation anticip&eacute;e &raquo;</strong>).</p><p>g. Que se passe-t-il si je transf&egrave;re mes Services &agrave; un autre fournisseur de service?</p><p>Le transfert de votre ou de vos Services &agrave; un autre fournisseur de service constitue une r&eacute;siliation du ou des Services en question, et des Frais de r&eacute;siliation anticip&eacute;e pourront s&rsquo;appliquer si le transfert entra&icirc;ne la r&eacute;siliation d&rsquo;un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e avant la fin de sa P&eacute;riode d&rsquo;abonnement.</p><p>h. Rogers peut-elle r&eacute;silier mes Services et, le cas &eacute;ch&eacute;ant, &agrave; quel moment cette r&eacute;siliation entre-t-elle en vigueur?</p><p><strong>Non applicable aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> &Agrave; moins que les lois applicables ne permettent autre chose, Rogers peut r&eacute;silier une partie ou la totalit&eacute; de vos Services ou de vos comptes, ainsi que toute Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>30</strong> jours &agrave; l&rsquo;avance. Les frais exigibles continuent de s&rsquo;appliquer jusqu&rsquo;&agrave; la date de r&eacute;siliation.<br><strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* et aux R&eacute;sidents du Qu&eacute;bec** :</strong> &Agrave; moins que les lois applicables ne permettent autre chose, Rogers peut r&eacute;silier une partie ou la totalit&eacute; de vos Services ou de vos comptes, ainsi que toute Entente qui y est associ&eacute;e, &agrave; condition de vous en aviser par &eacute;crit au moins <strong>60</strong> jours &agrave; l&rsquo;avance. Si vous vous &ecirc;tes abonn&eacute; &agrave; un Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, nous ne pouvons r&eacute;silier ce Service : (i) <strong>(applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador*)</strong> que si n&rsquo;avons plus la capacit&eacute; technique de fournir ce Service &agrave; dur&eacute;e d&eacute;termin&eacute;e, ou (ii) <strong>(applicable uniquement aux R&eacute;sidents du Qu&eacute;bec**)</strong> qu&rsquo;en vertu des articles 1604, 2126 et 2129 du Code civil du Qu&eacute;bec. Les frais exigibles continuent de s&rsquo;appliquer jusqu&rsquo;&agrave; la date de r&eacute;siliation. <strong>Applicable uniquement aux R&eacute;sidents de Terre-Neuve-et-Labrador* :</strong> Si votre compte a un solde cr&eacute;diteur d&eacute;passant <strong>10 $</strong> sur votre facture finale, nous vous rembourserons ce solde dans les <strong>60</strong> jours suivant la date de cette facture. Les cr&eacute;dits discr&eacute;tionnaires ne seront pas rembours&eacute;s.</p><p>i. Rogers peut-elle suspendre ou r&eacute;silier mes Services sans pr&eacute;avis?</p><p>Nous pouvons limiter, suspendre, bloquer, d&eacute;brancher ou r&eacute;silier l&rsquo;un ou l&rsquo;autre ou l&rsquo;ensemble de vos Services, comptes ou identifiants de quelque fa&ccedil;on que ce soit, y compris le service 9 1 1, sans avis ni responsabilit&eacute; envers vous, si :</p><p>i. vous contrevenez aux modalit&eacute;s d&rsquo;une Entente, notamment en omettant d&rsquo;acquitter vos frais; ii. vous d&eacute;passez votre limite de cr&eacute;dit; iii. vous omettez de fournir ou de maintenir un d&eacute;p&ocirc;t de garantie raisonnable ou de vous conformer &agrave; une autre exigence de cr&eacute;dit lorsque nous vous demandons de le faire; iv. vous convenez avec nous d&rsquo;un arrangement de paiement diff&eacute;r&eacute; et vous omettez d&rsquo;en respecter les modalit&eacute;s; v. vous d&eacute;passez la limite d&rsquo;utilisation raisonnable; vi. vous donnez de l&rsquo;information fausse, trompeuse ou p&eacute;rim&eacute;e; vii. nous avons des doutes raisonnables ou nous avons &eacute;tabli qu&rsquo;un de vos comptes, identifiants, Services ou &Eacute;quipement est associ&eacute; &agrave; une fraude, une utilisation ill&eacute;gale ou inappropri&eacute;e, ou est utilis&eacute; d&rsquo;une fa&ccedil;on nuisant &agrave; notre exploitation ou &agrave; l&rsquo;utilisation de nos services, de nos installations ou de nos r&eacute;seaux par d&rsquo;autres; viii. vous harcelez, menacez ou faites preuve d&rsquo;abus envers nous, nos employ&eacute;s ou nos agents; ix. vous tentez par des man&#339;uvres frauduleuses ou malhonn&ecirc;tes de ne pas nous payer; x. nous devons installer, entretenir, inspecter, tester, r&eacute;parer, retirer, remplacer, enqu&ecirc;ter, prot&eacute;ger, modifier, mettre &agrave; jour ou am&eacute;liorer l&rsquo;exploitation des Services, de l&rsquo;&Eacute;quipement, de nos installations ou de nos r&eacute;seaux; xi. un compte ou un service duquel vos Services d&eacute;pendent est annul&eacute; pour quelque raison; ou xii. nous croyons raisonnablement qu&rsquo;une urgence ou des circonstances particuli&egrave;res justifient une telle mesure. Si nous limitons, suspendons, bloquons, d&eacute;branchons ou r&eacute;silions vos Services ou vos comptes : i. vous devez nous payer tous les montants que vous nous devez; ii. nous pouvons &eacute;galement, sans avis ni responsabilit&eacute;, limiter, suspendre, bloquer, d&eacute;brancher ou r&eacute;silier vos Services aux termes d&rsquo;une autre entente ou d&rsquo;un autre compte que vous avez aupr&egrave;s de nous ou d&rsquo;une soci&eacute;t&eacute; du m&ecirc;me groupe que Rogers (incluant les comptes qui pourraient &ecirc;tre en r&egrave;gle); iii. les frais encourus par nous ou une soci&eacute;t&eacute; du m&ecirc;me groupe que Rogers relativement &agrave; votre manquement aux pr&eacute;sentes Modalit&eacute;s pourraient vous &ecirc;tre factur&eacute;s, incluant, sans toutefois s&rsquo;y limiter, les frais encourus pour vous obliger &agrave; les respecter; iv. votre acc&egrave;s aux services d&rsquo;urgence ou aux services sp&eacute;ciaux (par exemple, le 9 1 1) peut &eacute;galement &ecirc;tre restreint, suspendu, bloqu&eacute;, d&eacute;sactiv&eacute; ou annul&eacute;; v. vos tarifs pour les services aupr&egrave;s des soci&eacute;t&eacute;s du m&ecirc;me groupe que Rogers peuvent changer en fonction des modalit&eacute;s de ces services.</p><p>j. Les pr&eacute;sentes Modalit&eacute;s s&rsquo;appliqueront-elles toujours apr&egrave;s la r&eacute;siliation de mes Services?</p><p>Certaines dispositions des pr&eacute;sentes Modalit&eacute;s peuvent continuer &agrave; s&rsquo;appliquer puisqu&rsquo;elles peuvent demeurer pertinentes m&ecirc;me apr&egrave;s la r&eacute;siliation de tous vos Services. Plus particuli&egrave;rement, les paragraphes 1b)-d), 2e)-j), 4b)-c), 5c), 6d), 8b)-d), 8f), 9, 10b)-d) et les dispositions en mati&egrave;re d&rsquo;arbitrage du paragraphe 10a) continueront de s&rsquo;appliquer &agrave; vous malgr&eacute; la r&eacute;siliation de votre Entente.</p></div>");
$templateCache.put("views/localization/service-term-changes-cancellations.html","<div class=\"bold paragraph\">SERVICE TERM, CHANGES AND CANCELLATION</div><div class=\"paragraph\"><p>a. What are the categories of Services covered by my Agreement?</p><p>The Services are categorized as follows:</p><p>i. <strong>&quot;Term Services&quot;</strong> are Services that you subscribe to for a committed period of time as indicated on your applicable service agreement (<strong>&quot;Term&quot;</strong>);<br>ii. <strong>&quot;Month-to-Month Services&quot;</strong> are Services that you subscribe to on an ongoing basis, but not with a Term; and<br>iii. <strong>&quot;Pay-Per-Use Services&quot;</strong> are Services that you use on a per-usage basis (which may be a one-time usage, or usage for a set period of time, such as one day or one week), but not on an ongoing basis.<br></p><p>b. What is the term of my Agreement?</p><p>The term of each Agreement starts on the initial activation date of the Services or the Equipment, whichever is earlier <strong>(&quot;Activation Date&quot;)</strong>. At the end of the Term for a Term Service, the Service will automatically become a Month-to-Month Service and you will keep your existing Service and Agreement with us, unchanged, until they are changed or cancelled in accordance with these Terms.</p><p>c. Can Rogers change my Services or my Agreement?</p><p>Yes, Rogers may change your Services or Agreement as described below.</p><p><strong>For wireless Services:</strong><br>We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change aspects of a Term Service and the corresponding Agreement, other than a key term as defined in the Canadian Radio-television and Telecommunications Commission (CRTC)&rsquo;s Wireless Code, upon at least <strong>30</strong> days&rsquo; prior written notice to you. In either case, we will send you the written notice by bill message, text message, letter or e-mail and will explain the change and when it will take effect.</p><p><strong>For residential Services:</strong><br><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> We may change any aspect of a Month-to-Month Service or Term Service as well as any term or provision of an Agreement, upon prior written notice to you by bill message, text message, letter or e-mail. If you do not accept the change, your remedy will be to cancel the affected Services or Agreement by providing us with notice of cancellation under Section 2(e) below within <strong>30</strong> days of receiving our notice of change (unless we specify a different notice period or different remedy). <strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> We may change any aspect of a Month-to-Month Service and the corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. We may also change a Term Service and the corresponding Agreement upon at least <strong>30</strong> days&rsquo; prior written notice, but will not change the price, term, nature or any other essential elements of that Term Service or that Agreement. In either case, we will send you the written notice by bill message, text message, letter or e-mail and it will contain the new or amended term or provision, the former version of that term or provision (if applicable), the date that the amendment will come into force, and your rights. If a change to a Month-to-Month Service or a Term Service entails an increase in your obligations or a decrease in our obligations and if you do not accept that change, your remedy will be to cancel the affected Services or Agreement without an Early Cancellation Fee (defined below) by providing us with notice of cancellation under Section 2(e) below no later than <strong>30</strong> days after the amendment takes effect.</p><p><strong>For Pay-Per-Use Services:</strong> Pay-Per-Use Services are subject to availability and may be changed or cancelled by Rogers at any time without prior notice to you.</p><p>d. May I change my Services?</p><p>You may change your Services at any time by contacting us in any of the ways set out in Section 10(e) below. You may be subject to an administrative charge in accordance with Section 3(d) below. You may also be charged a fee to change your Service if one is specified in your service agreement for that Service. Please note that if you wish to change a Service, you may only be able to change to a Service that is currently available in market. Also please note that any Service you remove may no longer be available.</p><p>e. How can I cancel my Services and when does cancellation take effect?</p><p>Unless otherwise permitted by applicable law, you may cancel any or all of your Services and any corresponding Agreement at any time by contacting us in any of the ways set out in Section 10(e) below. Cancellation takes effect on the day that Rogers receives notice of the cancellation, or a future date specified in that notice (if applicable), whichever is later. Applicable charges continue until that date. However, if you only cancel a television Service add-on or an internet Service add-on, applicable charges continue to apply until your next billing date for that add-on.</p><p>f. Will I be charged an early cancellation fee if I cancel my Service(s)?</p><p>If you subscribe to a Term Service that you cancel before the end of its Term, you will be charged an early cancellation fee as described in the service agreement for that Term Service <strong>(&quot;Early Cancellation Fee&quot;)</strong>.</p><p>g. What happens if I transfer my Service(s) to another service provider?</p><p>Transferring your Service(s) to another service provider is a cancellation of the applicable Service(s) and an Early Cancellation Fee may apply if the transfer results in the cancellation of a Term Service before the end of its Term.</p><p>h. Can Rogers cancel my Services and when does cancellation take effect?</p><p><strong>Not applicable to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>30</strong> days&rsquo; prior written notice. Applicable charges continue until the cancellation date.<br><strong>Applicable only to Residents of Newfoundland* or Residents of Qu&eacute;bec**:</strong> Unless otherwise permitted by applicable law, Rogers may cancel any or all of your Services or accounts and any corresponding Agreement, as long as we give you at least <strong>60</strong> days&rsquo; prior written notice. If you have subscribed to a Term Service, then we may cancel that Service: (i) <strong>(applicable only to Residents of Newfoundland*)</strong> only if we no longer have the technical ability to provide that Term Service, or (ii) <strong>(applicable only to Residents of Qu&eacute;bec**)</strong> only pursuant to Sections 1604, 2126 and 2129 of the Civil Code of Qu&eacute;bec. Applicable charges continue until the cancellation date. <strong>Applicable only to Residents of Newfoundland*:</strong> If your account has a credit balance over <strong>$10</strong> on your final bill, then we will refund that balance to you within <strong>60</strong> days of the date of that bill. Discretionary credits will not be refunded.</p><p>i. Can Rogers suspend or cancel my Services without notice?</p><p>We may restrict, suspend, block, disconnect or cancel any or all of your Services, accounts or identifiers in any way, including 9-1-1 service, without notice or liability to you, if:</p><p>i. you are in breach of an Agreement, including for non-payment;<br>ii. you exceed your credit limit;<br>iii. you fail to provide or maintain a reasonable security deposit or other credit requirement when we ask you to;<br>iv. you agree to a deferred payment arrangement with us and fail to comply with its terms;<br>v. you exceed our reasonable usage limits;<br>vi. you have given us false, misleading or outdated information;<br>vii. we reasonably suspect or determine that any of your account, identifiers, Services or Equipment is the subject of fraudulent, unlawful or improper usage or usage that adversely affects our operations or the use of our services, facilities or networks by others;<br>viii. you harass, threaten or abuse us or our employees or agents;<br>ix. you fraudulently or improperly seek to avoid payment to us;<br>x. we need to install, maintain, inspect, test, repair, remove, replace, investigate, protect, modify, upgrade or improve the operation of the Services, the Equipment or our facilities or networks;<br>xi. any account or service on which your Services depend is cancelled for any reason; or<br>xii. we reasonably believe that there is an emergency or extreme circumstance that would warrant that action.<br></p><p>If we restrict, suspend, block, disconnect or cancel your Services or accounts:</p><p>i. you must pay any amounts owing;<br>ii. we may also restrict, suspend, block, disconnect or cancel, without notice or liability, your Services under any other agreement or account that you may have with us or a related Rogers entity (including accounts that may be in good standing);<br>iii. you may be charged for any costs incurred by us or any related Rogers entity in connection with your breach of these Terms, including costs incurred to enforce your compliance;<br>iv. your access to emergency or special needs services (e.g., 9-1-1) may also be restricted, suspended, blocked, disconnected or cancelled; and<br>v. your rates for services with related Rogers entities may change in accordance with the terms of those services.<br></p><p>j. Will these Terms still apply once my Services are cancelled?</p><p>Certain provisions of these Terms may still apply as they may still be relevant even after cancellation of all your Services. Specifically, Sections 1(b)-(d), 2(e)-(j), 4(b)-(c), 5(c), 6(d), 8(b)-(d), 8(f), 9, 10(b)-(d) and the arbitration provisions of Section 10(a) will continue to apply to you after cancellation of your Agreement.</p></div>");
$templateCache.put("views/localization/tac-fr.html","<div class=\"bold paragraph\">RENSEIGNEMENTS IMPORTANTS AU SUJET DE VOTRE SERVICE SANS-FIL</div><div class=\"paragraph\">Cette information s’ajoute à notre (nos) Entente(s) de service avec vous et elle en fait partie. Elle doit être lue conjointement avec les Modalités de service de Rogers, la Politique d’utilisation acceptable et la Politique de confidentialité qui vous sont fournies et sont accessibles sur le site rogers.com (et qui remplacent les Modalités de service de Rogers, la Politique d’utilisation acceptable et la Politique de confidentialité que vous avez reçues antérieurement), avec les brochures ou le matériel en ligne de Rogers en vigueur décrivant les forfaits, les caractéristiques, les services et (ou) les produits que vous avez choisis, ainsi qu’avec le Guide de démarrage en vigueur. Tout nouveau changement apporté à votre (vos) Entente(s) de service est énoncé aux présentes. Tous les autres aspects de votre (vos) Entente(s) de service demeurent les mêmes. Vous reconnaissez que tout Service annulé à votre demande ne sera peut-être plus disponible.</div>");
$templateCache.put("views/localization/tac.html","<div class=\"bold paragraph\">IMPORTANT INFORMATION ABOUT YOUR WIRELESS SERVICE</div><div class=\"paragraph\">This information is in addition to and forms part of our Service Agreement(s) with you and must be read in conjunction with the current Rogers Terms of Service, Acceptable Use Policy and Privacy Policy provided to you and posted on rogers.com (and which replace the Rogers Terms of Service, Acceptable Use Policy and Privacy Policy previously provided to you), and any other Rogers brochure or online material describing the plans, features, services and/or products you have selected and the Starting Up Guide that are currently in effect. Any new changes to your Service Agreement(s) are set out herein. All other aspects of your Service Agreement(s) remain the same. You acknowledge that any Services you have removed may no longer be available.</div>");
$templateCache.put("views/localization/warranties-limitation-liability-fr.html","<div class=\"bold paragraph\">Garanties et limite de responsabilit&eacute;</div><div class=\"paragraph\"><p>Veuillez noter que l&rsquo;expression <strong>&laquo; Parties de Rogers &raquo;</strong> comprend Rogers et les soci&eacute;t&eacute;s membres de son groupe, ses partenaires, ses conc&eacute;dants de licence, ses concessionnaires, ses repr&eacute;sentants, ses fournisseurs et ses mandataires (de m&ecirc;me que leurs employ&eacute;s, dirigeants, administrateurs, actionnaires et repr&eacute;sentants respectifs).</p><p>a. L&rsquo;&Eacute;quipement est-il garanti?</p><p>L&rsquo;&Eacute;quipement peut &ecirc;tre couvert par une garantie du fabricant ou une autre garantie. Veuillez consulter les documents remis avec votre &Eacute;quipement pour obtenir des renseignements d&eacute;taill&eacute;s sur la garantie dont il est assorti, notamment l&rsquo;objet de la garantie, la dur&eacute;e de celle-ci et les modalit&eacute;s de r&eacute;clamation. L&rsquo;&Eacute;quipement peut &eacute;galement comporter d&rsquo;autres programmes de protection facultatifs qui vous sont offerts &agrave; l&rsquo;occasion.</p><p></p><p>b. Les Services sont-ils garantis?</p><p>Les Services fournis par Rogers peuvent &ecirc;tre touch&eacute;s par des facteurs ind&eacute;pendants du contr&ocirc;le raisonnable de Rogers. Pour cette raison, vous reconnaissez et convenez que les Services ou l&rsquo;acc&egrave;s aux Services, y compris le service d&rsquo;urgence 9 1 1, les alertes publiques ou les services sp&eacute;ciaux, peuvent ne pas fonctionner correctement, ou m&ecirc;me ne pas fonctionner du tout, dans les cas suivants :</p><p>i. si votre &Eacute;quipement fait d&eacute;faut, s&rsquo;il n&rsquo;est pas bien configur&eacute;, ou s&rsquo;il ne respecte pas les exigences de Rogers;<br>ii. si vous avez install&eacute; certaines applications de tiers sur votre &Eacute;quipement;<br>iii. en cas de panne du r&eacute;seau ou de panne d&rsquo;&eacute;lectricit&eacute; prolong&eacute;e;<br>iv. si vous modifiez ou, dans certains cas, si vous d&eacute;placez l&rsquo;&Eacute;quipement;<br>v. apr&egrave;s la suspension ou la r&eacute;siliation de vos Services ou de votre compte.</p><p>Dans les limites permises par la loi en vigueur :<br>i. les Parties de Rogers ne donnent aucune garantie ou assurance &agrave; l&rsquo;&eacute;gard du rendement, de la disponibilit&eacute;, de la couverture, de l&rsquo;utilisation sans interruption, de la s&eacute;curit&eacute;, du prix ou du fonctionnement des Services, de l&rsquo;&Eacute;quipement <strong>(sauf en faveur des R&eacute;sidents du Qu&eacute;bec** conform&eacute;ment aux garanties l&eacute;gales)</strong> ou de tout produit, contenu, application, logiciel, service, installation, connexion ou r&eacute;seau utilis&eacute; ou fourni par nous ou par des tierces parties (collectivement d&eacute;sign&eacute;s <strong>l&rsquo;&laquo; Offre &raquo;</strong>);<br>ii. Rogers peut limiter toute Offre que vous pouvez acheter;<br>iii.vous assumez la totalit&eacute; des risques associ&eacute;s &agrave; l&rsquo;utilisation, &agrave; l&rsquo;acc&egrave;s, &agrave; la transmission, &agrave; la disponibilit&eacute;, &agrave; la fiabilit&eacute;, aux d&eacute;lais, &agrave; la qualit&eacute;, &agrave; la s&eacute;curit&eacute; et au rendement de l&rsquo;Offre;<br>iv. les Parties de Rogers n&rsquo;offrent aucune repr&eacute;sentation, garantie ni condition expresse ou implicite, y compris des garanties de propri&eacute;t&eacute; ou d&rsquo;absence de contrefa&ccedil;on et des garanties implicites de qualit&eacute; marchande ou d&rsquo;ad&eacute;quation &agrave; un usage particulier, &agrave; l&rsquo;&eacute;gard de l&rsquo;Offre.</p><p><strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong><br>v. toutes les repr&eacute;sentations, garanties et conditions de quelque type que ce soit, expresses ou implicites, sont exclues;<br>vi. aucun conseil ou renseignement, qu&rsquo;il soit fait verbalement ou par &eacute;crit, que vous obtenez de la part de toute Partie de Rogers n&rsquo;aura pour effet de cr&eacute;er une modalit&eacute;, une condition, une repr&eacute;sentation ou une garantie qui n&rsquo;est pas express&eacute;ment &eacute;nonc&eacute;e dans une Entente.</p><p>c. De quelle fa&ccedil;on Rogers limite-t-elle sa responsabilit&eacute;?</p><p>&Agrave; moins de mention contraire stipul&eacute;e sp&eacute;cifiquement dans une Entente, dans les limites maximales permises par les lois applicables, <strong>et sauf &agrave; l&rsquo;&eacute;gard des R&eacute;sidents du Qu&eacute;bec** pour des dommages r&eacute;sultant du fait personnel d&rsquo;une Partie de Rogers</strong>, les Parties de Rogers ne pourront &ecirc;tre tenues responsables envers vous ou une tierce partie pour les &eacute;l&eacute;ments suivants :</p><p>i. <strong>Non applicable aux R&eacute;sidents du Qu&eacute;bec** :</strong> tout dommage direct, indirect, sp&eacute;cial, cons&eacute;cutif, accessoire, &eacute;conomique ou punitif (y compris la perte de profits ou de revenus; les pertes financi&egrave;res; les pertes d&rsquo;occasions d&rsquo;affaires; la perte, la destruction ou l&rsquo;alt&eacute;ration de donn&eacute;es, de fichiers ou de logiciels; le manquement &agrave; la confidentialit&eacute; ou &agrave; la s&eacute;curit&eacute;; les dommages mat&eacute;riels; les blessures corporelles; les d&eacute;c&egrave;s ou toute autre perte pr&eacute;visible ou impr&eacute;visible, quelle qu&rsquo;en soit la cause) associ&eacute;s directement ou indirectement &agrave; l&rsquo;Offre ou &agrave; la publicit&eacute;, la promotion ou les d&eacute;clarations relatives &agrave; un des &eacute;l&eacute;ments pr&eacute;cit&eacute;s, m&ecirc;me si nous avons &eacute;t&eacute; n&eacute;gligents ou si nous avions &eacute;t&eacute; avis&eacute;s de la possibilit&eacute; de tels dommages;<br>ii. <strong>Applicable uniquement aux R&eacute;sidents du Qu&eacute;bec** :</strong> tout dommage (y compris la perte de profits ou de revenus; les pertes financi&egrave;res; les pertes d&rsquo;occasions d&rsquo;affaires; la perte, la destruction ou l&rsquo;alt&eacute;ration de donn&eacute;es, de fichiers ou de logiciels; le manquement &agrave; la confidentialit&eacute; ou &agrave; la s&eacute;curit&eacute;; les dommages mat&eacute;riels) associ&eacute; directement ou indirectement &agrave; l&rsquo;Offre;<br>iii.toute Offre qui vous est fournie ou &agrave; laquelle vous avez acc&egrave;s par l&rsquo;interm&eacute;diaire des Services, tous frais engag&eacute;s relativement &agrave; une telle Offre, ou toute action qui est ou qui peut &ecirc;tre prise au moyen de cette Offre, m&ecirc;me si cette Offre vous a &eacute;t&eacute; factur&eacute;e;<br>iv. le rendement, la disponibilit&eacute;, la fiabilit&eacute;, les d&eacute;lais, la qualit&eacute;, la couverture, l&rsquo;utilisation sans interruption, la s&eacute;curit&eacute;, le prix ou le fonctionnement de l&rsquo;Offre;<br>v. toute erreur, inclusion ou omission en ce qui a trait aux annuaires ou aux r&eacute;pertoires t&eacute;l&eacute;phoniques;<br>vi. le refus, la restriction, le blocage, l&rsquo;interruption ou l&rsquo;inaccessibilit&eacute; des Services, y compris le 9-1-1, les alertes publiques ou les services sp&eacute;ciaux, l&rsquo;&Eacute;quipement ou les identifiants (y compris les num&eacute;ros de t&eacute;l&eacute;phone);<br>vii. la perte, le vol, l&rsquo;endommagement ou l&rsquo;expiration de l&rsquo;&Eacute;quipement, des identifiants, des mots de passe, des codes, des avantages, des rabais, des remises ou des cr&eacute;dits;<br>viii. toute erreur ou omission ou tout d&eacute;lai en rapport avec le transfert des num&eacute;ros de t&eacute;l&eacute;phone &agrave; un autre fournisseur de services de t&eacute;l&eacute;communications ou en provenance d&rsquo;un tel autre fournisseur de services de t&eacute;l&eacute;communications, de m&ecirc;me que toute restriction attribuable au transfert ou au fournisseur de services de t&eacute;l&eacute;communications;<br>ix. tout acte ou toute omission d&rsquo;un fournisseur de services de t&eacute;l&eacute;communications dont les installations sont utilis&eacute;es pour &eacute;tablir une liaison avec des points &agrave; l&rsquo;ext&eacute;rieur de notre zone de desserte; ou<br>x. toute r&eacute;clamation ou tout dommage attribuable directement ou indirectement &agrave; des affirmations selon lesquelles l&rsquo;utilisation, l&rsquo;utilisation pr&eacute;vue ou une combinaison de l&rsquo;Offre ou tout document transmis par l&rsquo;entremise des Services contreviennent aux droits de propri&eacute;t&eacute; intellectuelle, industrielle ou contractuelle, ou au droit &agrave; la vie priv&eacute;e ou &agrave; quelque autre droit d&rsquo;une tierce partie.</p><p>Non applicable aux R&eacute;sidents du Qu&eacute;bec** : Ces limites s&rsquo;ajoutent &agrave; toutes les autres limites &agrave; la responsabilit&eacute; des Parties de Rogers qui sont indiqu&eacute;es dans une Entente et qui s&rsquo;appliquent &agrave; tout acte ou toute omission des Parties de Rogers, peu importe que ces actes ou ces omissions puissent donner lieu &agrave; un recours en vertu d&rsquo;un contrat, d&rsquo;un d&eacute;lit civil ou de quelque loi ou autre doctrine juridique.</p><p>d. D&rsquo;autres limites de responsabilit&eacute; s&rsquo;appliquent-elles aux services d&rsquo;urgence 9 1 1?</p><p><strong>Pour les Services sans fil :</strong></p><p>Nous ne sommes pas responsables de ce qui suit :<br>i. diffamation ou atteinte aux droits d&rsquo;auteur inh&eacute;rents au mat&eacute;riel ou aux messages transmis par l&rsquo;interm&eacute;diaire de notre r&eacute;seau &agrave; partir de votre propri&eacute;t&eacute; ou de vos locaux ou enregistr&eacute;s &agrave; partir de votre &eacute;quipement ou du n&ocirc;tre;<br>ii. dommages caus&eacute;s par vos actes, par d&eacute;faut, par n&eacute;gligence ou par omission de votre part dans l&rsquo;utilisation ou la manipulation de l&rsquo;&eacute;quipement que nous fournissons;<br>iii. dommages caus&eacute;s par toute transmission ill&eacute;gale, de quelque fa&ccedil;on que ce soit, de mat&eacute;riel ou de messages par l&rsquo;interm&eacute;diaire de notre r&eacute;seau en votre nom; ou<br>iv. tout acte, toute omission ou toute n&eacute;gligence de la part d&rsquo;autres entreprises ou syst&egrave;mes de t&eacute;l&eacute;communications lorsque leurs installations sont utilis&eacute;es aux fins d&rsquo;&eacute;tablir une connexion &agrave; partir ou en direction de vos installations et de votre &eacute;quipement. &Agrave; l&rsquo;exception des cas de n&eacute;gligence de notre part entra&icirc;nant des blessures, la mort ou des dommages &agrave; votre propri&eacute;t&eacute; ou &agrave; vos locaux, notre responsabilit&eacute; pour cause de n&eacute;gligence relative &agrave; la prestation obligatoire de services d&rsquo;urgence 9-1-1 se limite &agrave; un montant de <strong>20 $</strong> ou &agrave; <strong>3</strong> fois le montant, s&rsquo;il y a lieu, auquel vous auriez autrement droit &agrave; titre de remboursement pour la prestation de Services d&eacute;fectueux en vertu d&rsquo;une Entente, selon le montant le plus &eacute;lev&eacute;. Toutefois, notre responsabilit&eacute; n&rsquo;est pas limit&eacute;e par le pr&eacute;sent article en cas de faute d&eacute;lib&eacute;r&eacute;e, de n&eacute;gligence grave ou de conduite anticoncurrentielle de notre part ou en cas de bris de contrat r&eacute;sultant d&rsquo;une n&eacute;gligence grossi&egrave;re de notre part.</p><p><strong>Pour les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle :</strong></p><p>Pour que les services d&rsquo;urgence 9 1 1 puissent fonctionner convenablement avec les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle, vous devez utiliser l&rsquo;adaptateur qui fait partie de l&rsquo;&Eacute;quipement que nous vous avons fourni (<strong>l&rsquo;&laquo; Adaptateur &raquo;</strong>) et les autres &eacute;l&eacute;ments d&rsquo;&Eacute;quipement &agrave; votre adresse de service. Nous ne pourrons &ecirc;tre tenus responsables envers vous ou une tierce partie pour tout manquement &agrave; cette exigence. Les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle pourraient ne pas fonctionner normalement, ou ne pas fonctionner du tout, dans les cas suivants :<br>i. si votre Adaptateur ou les autres &eacute;l&eacute;ments de l&rsquo;&Eacute;quipement font d&eacute;faut ou ne sont pas configur&eacute;s correctement;<br>ii. en cas de panne du r&eacute;seau de c&acirc;ble ou d&rsquo;une panne d&rsquo;&eacute;lectricit&eacute; prolong&eacute;e;<br>iii.si vous modifiez ou d&eacute;placez votre Adaptateur ou un autre &eacute;l&eacute;ment de l&rsquo;&Eacute;quipement &agrave; un endroit autre que votre adresse de service; ou<br>iv. apr&egrave;s la suspension ou la r&eacute;siliation de vos Services ou de votre compte.<br>Nous ne pourrons &ecirc;tre tenus responsables envers vous ou une tierce partie en cas d&rsquo;incapacit&eacute; &agrave; utiliser les Services de t&eacute;l&eacute;phonie r&eacute;sidentielle ou d&rsquo;obtenir l&rsquo;acc&egrave;s aux services d&rsquo;urgence 9 1 1 en raison des limites d&eacute;crites au pr&eacute;sent article.</p><p>e. Existe-t-il des circonstances dans lesquelles je devrai indemniser Rogers?</p><p>Vous indemniserez et tiendrez &agrave; couvert les Parties de Rogers de quelque r&eacute;clamation, perte, dommages, co&ucirc;ts et d&eacute;penses que ce soit (y compris, sans limitation, les frais juridiques raisonnables et autres frais de r&egrave;glement de litiges), encourus par les Parties de Rogers li&eacute;s &agrave; la violation, &agrave; la violation pr&eacute;sum&eacute;e ou au d&eacute;tournement par vous du droit de propri&eacute;t&eacute; intellectuelle, industrielle ou contractuelle, ou toute atteinte au droit &agrave; la vie priv&eacute;e ou &agrave; quelque autre droit d&rsquo;une tierce partie, ou &agrave; tout pr&eacute;sum&eacute; libelle ou &agrave; toute pr&eacute;sum&eacute;e diffamation qui serait intent&eacute; ou all&eacute;gu&eacute; contre vous par une tierce partie.</p></div>");
$templateCache.put("views/localization/warranties-limitation-liability.html","<div class=\"bold paragraph\">WARRANTIES AND LIMITATION OF LIABILITY</div><div class=\"paragraph\"><p>Please note that the term <strong>&ldquo;Rogers Parties&rdquo;</strong> includes Rogers and its affiliates, partners, licensors, dealers, representatives, suppliers and agents (and their respective employees, officers, directors, shareholders and representatives).</p><p>a. Are there any warranties on the Equipment?</p><p>The Equipment may be covered by a manufacturer&rsquo;s or other warranty. Please see the materials accompanying your Equipment for warranty information and details, including coverage, duration and how you may make a claim under the warranty. There may also be optional Equipment protection programs made available to you from time to time.</p><p>b. Are there any warranties on the Services?</p><p>The Services that Rogers provides may be impacted by factors beyond Rogers&rsquo; reasonable control. For this reason, you acknowledge and understand that the Services or access to the Services, including 9-1-1, public alerts or special needs services, may not function correctly or at all in the following circumstances:</p><p>i. if your Equipment fails, is not configured correctly or does not meet Rogers&rsquo; requirements;<br>ii. if you install certain third party applications on your Equipment;<br>iii. in the event of a network outage or extended power failure;<br>iv. if you tamper with or, in some cases, move the Equipment; or<br>v. following suspension or cancellation of your Services or account.</p><p>To the maximum extent permitted by applicable law:<br>i. the Rogers Parties do not guarantee or warrant the performance, availability, coverage, uninterrupted use, security, pricing or operation of the Services, the Equipment <strong>(except towards residents of Qu&eacute;bec** in accordance with statutory warranties)</strong> or any products, content, applications, software, services, facilities, connections or networks used or provided by us or third parties (collectively, the <strong>&ldquo;Offering&rdquo;</strong>);<br>ii. Rogers may limit the amount of an Offering that you may purchase;<br>iii.you bear the entire risk as to the use, access, transmission, availability, reliability, timeliness, quality, security and performance of the Offering;<br>iv. the Rogers Parties do not make any express or implied representations, warranties or conditions, including warranties of title or non-infringement, or implied warranties of merchantable quality or fitness for a particular purpose, with regard to the Offering.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong><br>v. all representations, warranties and conditions of any kind, express or implied, are excluded;<br>vi. no advice or information, whether oral or written, that you obtain from the Rogers Parties creates any term, condition, representation or warranty not expressly stated in an Agreement.</p><p>c. How does Rogers limit its liability?</p><p>Unless otherwise specifically set out in an Agreement, to the maximum extent permitted by applicable law, and <strong>except towards Residents of Qu&eacute;bec** for damages resulting from a Rogers Party&rsquo;s own act</strong>, the Rogers Parties will not be liable to you or to any third party for:</p><p>i. <strong>Not applicable to Residents of Qu&eacute;bec**:</strong> any direct, indirect, special, consequential, incidental, economic or punitive damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; property damage; personal injury; death; or any other foreseeable or unforeseeable loss, however caused) resulting or relating directly or indirectly from or relating to the Offering or any advertisements, promotions or statements relating to any of the foregoing, even if we were negligent or were advised of the possibility of such damages;<br>ii. <strong>Applicable only to Residents of Qu&eacute;bec**:</strong> any damages (including loss of profit or revenue; financial loss; loss of business opportunities; loss, destruction or alteration of data, files or software; breach of privacy or security; or property damage) resulting or relating directly or indirectly from or relating to the Offering;<br>iii. any Offering provided to you or accessible by you through the Services, any charges incurred in connection with such Offering or anything that is or can be done with such Offering even if you are billed for such Offering;<br>iv. the performance, availability, reliability, timeliness, quality, coverage, uninterrupted use, security, pricing or operation of the Offering;<br>v. any error, inclusion or omission relating to any telephone listings or directories;<br>vi. the denial, restriction, blocking, disruption or inaccessibility of any Services, including 9-1-1, public alerts or special needs services, Equipment or identifiers (including phone numbers);<br>vii. any lost, stolen, damaged or expired Equipment, identifiers, passwords, codes, benefits, discounts, rebates or credits;<br>viii. any error, omission or delay in connection with the transfer of phone numbers to or from another telecommunications service provider, or any limitation connected to that transfer or that telecommunications service provider;<br>ix. any acts or omissions of a telecommunications carrier whose facilities are used to establish connections to points that we do not serve; or<br>x. any claims or damages resulting directly or indirectly from any claim that the use, intended use or combination of the Offering or any material transmitted through the Services infringes the intellectual property, industrial, contractual, privacy or other rights of a third party.</p><p><strong>Not applicable to Residents of Qu&eacute;bec**:</strong> These limits are in addition to any other limits on the Rogers Parties&rsquo; liability set out elsewhere in an Agreement and apply to any act or omission of the Rogers Parties, whether or not the act or omission would otherwise be a cause of action in contract, tort or pursuant to any statute or other doctrine of law.<br></p><p>d. Are there any additional limitations of liability that apply to 9-1-1 emergency services?</p><p><strong>For wireless Services:</strong></p><p>We are not liable for:<br>i. libel, slander, defamation or the infringement of copyright arising from material or messages transmitted over our network from your property or premises or recorded by your equipment or our equipment;<br>ii. damages arising out of your act, default, neglect or omission in the use or operation of equipment that we provide;<br>iii. damages arising out of the transmission of material or messages over our network on your behalf, which is in any way unlawful; or<br>iv. any act, omission or negligence of other companies or telecommunications systems when their facilities are used in establishing connections to or from your facilities and equipment. Except in cases where negligence on our part results in physical injury, death or damage to your property or premises, our liability for negligence related to the provision of 9-1-1 emergency services on a mandatory basis is limited to the greater of <strong>$20</strong> and <strong>3</strong> times the amount, if any, you would otherwise be entitled to receive as a refund for the provision of defective Service under an Agreement. However, our liability is not limited by this Section in cases of deliberate fault, gross negligence or anticompetitive conduct on our part or in cases of breach of contract where the breach results from our gross negligence.</p><p><strong>For home phone Services:</strong><br>In order for 9-1-1 emergency services to function properly with home phone Services, you must use the adapter which forms part of the Equipment we have provided you (<strong>&ldquo;Adaptor&rdquo;</strong>) and other Equipment at your service address. We will not be liable to you or to any third party for your failure to comply with this requirement. The home phone Services may not function correctly, or at all, in the following circumstances:<br>i. if your Adaptor or other Equipment fails or is not configured correctly;<br>ii. in the event of a cable network outage or extended power failure;<br>iii.if you tamper with or move your Adaptor or other Equipment to a location other than your service address; or<br>iv. following suspension or cancellation of your Services or account.<br>We will not be liable to you or to any third party for any inability to use the home phone Services or to obtain access to 9-1-1 emergency services as a result of the limitations described in this Section.</p><p>e. Are there any circumstances under which I would have to compensate Rogers?</p><p>You will indemnify and hold harmless the Rogers Parties from and against any claims, losses, damages, costs and expenses (including, without limitation, reasonable legal fees and other litigation expenses) incurred by the Rogers Parties relating to your violation, alleged violation or misappropriation of any intellectual property, industrial, contractual, privacy or other rights of a third party or any alleged libel or slander by a third party against you.</p></div>");
$templateCache.put("views/localization/your-privacy-fr.html","<div class=\"bold paragraph\">Protection de votre vie priv&eacute;e</div><div class=\"paragraph\"><p>a. Que peut faire Rogers avec les renseignements sur mon compte et mes renseignements personnels?</p><p>En concluant une Entente, vous :</p><p>i. autorisez express&eacute;ment Rogers &agrave; recueillir et &agrave; utiliser vos donn&eacute;es de localisation personnelles courantes et historiques associ&eacute;es &agrave; tout appareil que vous utilisez aux termes de votre ou vos Ententes de service pour vous fournir des services de g&eacute;olocalisation, &eacute;tant entendu que vous pouvez vous d&eacute;sabonner de ces services en tout temps.<br>ii. convenez express&eacute;ment que les renseignements relatifs &agrave; votre compte peuvent &ecirc;tre divulgu&eacute;s &agrave; d&rsquo;autres membres de l&rsquo;organisation de Rogers Communications Inc. et &agrave; ses agents, concessionnaires autoris&eacute;s et distributeurs, afin de g&eacute;rer votre compte, de r&eacute;pondre &agrave; vos questions, de faire le t&eacute;l&eacute;marketing (y compris au moyen de composeurs messagers automatiques) et de vous proposer d&rsquo;autres produits et services offerts par les membres de l&rsquo;organisation de Rogers Communications Inc. Si vous ne souhaitez pas recevoir de telles offres ou information, veuillez communiquer avec nous de l&rsquo;une ou l&rsquo;autre des fa&ccedil;ons indiqu&eacute;es au paragraphe 10e) ci-apr&egrave;s.</p><p>b. O&ugrave; seront stock&eacute;s mes renseignements personnels?</p><p>Les renseignements personnels recueillis dans le cadre de la prestation des Services peuvent &ecirc;tre enregistr&eacute;s et trait&eacute;s au Canada ou &agrave; l&rsquo;&eacute;tranger et &ecirc;tre soumis aux lois en vigueur dans d&rsquo;autres territoires.</p><p>c. Rogers divulguera-t-elle mes renseignements personnels &agrave; des tierces parties?</p><p>&Agrave; moins que vous ne fournissiez votre consentement explicite, ou que cette divulgation soit requise aux termes d&rsquo;une obligation l&eacute;gale, toute l&rsquo;information vous concernant que nous d&eacute;tenons, sauf votre nom, votre adresse et votre num&eacute;ro de t&eacute;l&eacute;phone inscrit dans l&rsquo;annuaire, est confidentielle et ne pourra &ecirc;tre divulgu&eacute;e par nous &agrave; quiconque autre que :</p><p>i. vous;<br>ii. une personne qui, selon notre jugement raisonnable, agit comme votre mandataire pour obtenir de l&rsquo;information;<br>iii.une autre compagnie de t&eacute;l&eacute;phone, dans la mesure o&ugrave; les renseignements sont requis pour offrir un service de t&eacute;l&eacute;phonie r&eacute;sidentielle efficace et rentable, que la divulgation se fait sur une base confidentielle et que l&rsquo;information est utilis&eacute;e uniquement &agrave; cette fin;<br>iv. un fournisseur vous assurant des services reli&eacute;s aux fonctions de t&eacute;l&eacute;phonie ou d&rsquo;annuaire t&eacute;l&eacute;phonique, dans la mesure o&ugrave; une telle divulgation se fait sur une base confidentielle et que l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; cette fin;<br>v. un agent mandat&eacute; par nous pour le recouvrement de vos cr&eacute;ances ou pour toute autre fonction administrative, dans la mesure o&ugrave; l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; ces fins;<br>vi. un agent mandat&eacute; par nous pour &eacute;valuer votre solvabilit&eacute;, dans la mesure o&ugrave; l&rsquo;information est divulgu&eacute;e et utilis&eacute;e uniquement &agrave; cette fin;<br>vii. un corps policier lorsque nous avons des motifs raisonnables de croire que vous nous avez sciemment fourni des renseignements faux ou trompeurs ou que vous &ecirc;tes engag&eacute; de quelque autre fa&ccedil;on dans des activit&eacute;s ill&eacute;gales;<br>viii. une autorit&eacute; publique ou le mandataire d&rsquo;une autorit&eacute; publique si, selon notre jugement raisonnable, nous croyons que la divulgation de vos renseignements pourrait &eacute;viter ou att&eacute;nuer un danger de mort ou de dommage mat&eacute;riel imminent;<br>ix. une autorit&eacute; publique ou le mandataire d&rsquo;une autorit&eacute; publique, aux fins des alertes publiques d&rsquo;urgence, si l&rsquo;autorit&eacute; publique a conclu &ecirc;tre en pr&eacute;sence d&rsquo;un danger imminent ou sur le point de se produire mettant en danger la vie, la sant&eacute; ou la s&eacute;curit&eacute; de tout individu et que le danger pourrait &ecirc;tre &eacute;vit&eacute; ou minimis&eacute; par la divulgation de l&rsquo;information.</p><p>d. De quelle fa&ccedil;on Rogers obtient-elle mon consentement &agrave; la divulgation de mes renseignements personnels?</p><p>Le consentement explicite &agrave; la divulgation peut &ecirc;tre obtenu comme suit :</p><p>i. un consentement &eacute;crit;<br>ii. une confirmation orale v&eacute;rifi&eacute;e par une tierce partie ind&eacute;pendante;<br>iii.une confirmation &eacute;lectronique par l&rsquo;utilisation d&rsquo;un num&eacute;ro sans frais;<br>iv. une confirmation &eacute;lectronique par Internet;<br>v. un consentement oral pour lequel nous avons conserv&eacute; un enregistrement audio; ou<br>vi. un consentement donn&eacute; par une autre m&eacute;thode, dans la mesure o&ugrave; il existe un enregistrement document&eacute; objectif de votre consentement cr&eacute;&eacute; par vous ou par un tiers ind&eacute;pendant.</p><p>e. Puis-je demander d&rsquo;avoir un num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel non inscrit dans l&rsquo;annuaire?</p><p>Vous pouvez choisir de payer pour avoir un num&eacute;ro de t&eacute;l&eacute;phone r&eacute;sidentiel non inscrit dans l&rsquo;annuaire; cependant, veuillez noter que les fournisseurs d&rsquo;annuaires et de services de t&eacute;l&eacute;phoniste peuvent obtenir votre num&eacute;ro de t&eacute;l&eacute;phone et votre adresse d&rsquo;une source autre que nous. Par ailleurs, votre nom, votre adresse et votre num&eacute;ro de t&eacute;l&eacute;phone seront accessibles par les fournisseurs de service 9-1-1, m&ecirc;me si vous payez pour avoir un num&eacute;ro de t&eacute;l&eacute;phone non inscrit.</p><p>f. Comment puis-je obtenir de l&rsquo;information sur la protection de mes renseignements personnels chez Rogers?</p><p>Nos Politiques de protection de la vie priv&eacute;e d&rsquo;entreprise et en ligne se trouvent &agrave; <a href=\"http://rogers.com/privee\">rogers.com/privee</a>. Pour communiquer avec notre Agent de protection de la vie priv&eacute;e afin d&rsquo;acc&eacute;der &agrave; vos renseignements personnels conserv&eacute;s par Rogers, d&rsquo;obtenir plus d&rsquo;information &agrave; ce sujet, de formuler une plainte au sujet de la protection de la vie priv&eacute;e, ou d&rsquo;obtenir un exemplaire de nos Politiques de protection de la vie priv&eacute;e, envoyez un courriel &agrave; l&rsquo;adresse <a href=\"mailto:privacy@rci.rogers.com\">privacy@rci.rogers.com</a> ou &eacute;crivez &agrave; notre Agent de protection de la vie priv&eacute;e, Groupe de soci&eacute;t&eacute;s Rogers, 333, rue Bloor Est, Toronto (ON) M4W 1G9.</p></div>");
$templateCache.put("views/localization/your-privacy.html","<div class=\"bold paragraph\">YOUR PRIVACY</div><div class=\"paragraph\"><p>a. What can Rogers do with my account information and personal information?</p><p>By entering into an Agreement, you expressly:</p><p>i. authorize Rogers to collect and use your current and historical personal location information associated with any device you use under your Agreement(s) in order to provide geo-location services to you, with the ability to opt-out of these services at any time.<br>ii. agree that your account information may be disclosed to other members of the Rogers Communications Inc. organization, and to our agents, authorized dealers and distributors to service your account, respond to your questions, telemarket (including by way of automatic dialing and announcing devices), and promote additional products and services offered by members of the Rogers Communications Inc. organization. If you do not wish to receive these offers or information, please contact us in any of the ways set out in Section 10(e) below.<br></p><p>b. Where will my personal information be stored?</p><p>Personal information collected in connection with the provision of the Services may be stored and processed in or outside Canada and may be subject to the laws of other jurisdictions.</p><p>c. Will Rogers disclose my personal information to any outside parties?</p><p>Unless you provide express consent or disclosure is required pursuant to a legal power, all information regarding you kept by us, other than your name, address and listed phone number, is confidential and may not be disclosed by us to anyone other than:</p><p>i. you;<br>ii. a person who, in our reasonable judgment, is seeking the information as your agent;<br>iii.another telephone company, provided the information is required for the efficient and cost-effective provision of home phone service and disclosure is made on a confidential basis, with the information to be used only for that purpose;<br>iv. a company involved in supplying phone or phone directory-related services, provided the information is required for that purpose and disclosure is made on a confidential basis, with the information to be used only for that purpose;<br>v. an agent retained by us in the collection of your account or to perform other administrative functions for us, provided the information is required for and used only for that purpose;<br>vi. an agent retained by us to evaluate your creditworthiness, provided the information is required for and is to be used only for that purpose;<br>vii. a law enforcement agency whenever we have reasonable grounds to believe that you have knowingly supplied us with false or misleading information or are otherwise involved in unlawful activities;<br>viii. a public authority or agent of a public authority if, in our reasonable judgment, it appears that there is imminent danger to life or property which could be avoided or minimized by disclosure of the information; or<br>ix. a public authority or agent of a public authority, for emergency public alerting purposes, if a public authority has determined that there is an imminent or unfolding danger that threatens the life, health or security of an individual and that the danger could be avoided or minimized by disclosure of the information.</p><p>d. How does Rogers obtain consent from me to disclose my personal information?</p><p>Express consent to disclosure may be obtained by:</p><p>i. written consent;<br>ii. oral confirmation verified by an independent third party;<br>iii.electronic confirmation through the use of a toll-free number;<br>iv. electronic confirmation via the internet;<br>v. oral consent, where an audio recording of the consent is retained by us; or<br>vi. consent through other methods, as long as an objective documented record of your consent is created by you or by an independent third party.</p><p>e. Can I have an unlisted home phone number?</p><p>You may opt to pay for an unlisted home phone number; however, please note that directories or providers of operator services may obtain your phone numbers and address from a source other than us. In addition, your name, address and phone numbers will be accessible by 9-1-1 service providers even if you pay for an unlisted phone number.</p><p>f. How can I get more information about the protection of my personal information at Rogers?</p><p>Our corporate and online Privacy Policies are available at <a href=\"http://www.rogers.com/privacy\">rogers.com/privacy</a>. To contact our Privacy Officer in order to access, obtain more information about your personal information held by Rogers, make a privacy-related complaint, or obtain a copy of our Privacy Policies: e-mail us at <a href=\"mailto:privacy@rci.rogers.com\">privacy@rci.rogers.com</a>; or write to Chief Privacy Officer, Rogers Group of Companies, 333 Bloor Street East, Toronto, ON M4W 1G9.</p></div>");
$templateCache.put("views/localization/your-use-of-services-fr.html","<div class=\"bold paragraph\">Votre utilisation des Services</div><div class=\"paragraph\"><p>a. Suis-je propri&eacute;taire de mon num&eacute;ro de t&eacute;l&eacute;phone?</p><p>Vous n&rsquo;&ecirc;tes pas propri&eacute;taire de tout num&eacute;ro de t&eacute;l&eacute;phone, adresse courriel ou autre identifiant qui vous est attribu&eacute;. Nous pouvons changer ou supprimer un identifiant &agrave; tout moment.</p><p>b. Rogers surveille-t-elle le contenu que je transmets lorsque j&rsquo;utilise les Services?</p><p>Nous avons le droit, mais non l&rsquo;obligation, de surveiller tout &eacute;l&eacute;ment de contenu transmis au moyen des Services (autres que les Services de transmission de la voix) ou de l&rsquo;&Eacute;quipement, et de faire enqu&ecirc;te sur ceux-ci. Nous pouvons &eacute;galement consulter ou conserver du contenu ou de l&rsquo;information afin de nous conformer au processus judiciaire en vigueur au Canada et dans des territoires &eacute;trangers, d&rsquo;exploiter les Services, de veiller au respect d&rsquo;une Entente, ou encore de nous prot&eacute;ger nous-m&ecirc;mes et de prot&eacute;ger nos clients et le public.</p><p>c. Quelles sont mes responsabilit&eacute;s &agrave; l&rsquo;&eacute;gard des logiciels ou du contenu de Rogers ou de tierces parties?</p><p>Toutes les marques de commerce et tous les droits d&rsquo;auteur, concepts de marque, noms, logos et dessins que nous utilisons sont des actifs de propri&eacute;t&eacute; intellectuelle, d&eacute;pos&eacute;s ou autre, de Rogers Communications Inc. ou d&rsquo;une soci&eacute;t&eacute; membre de son groupe, ou encore sont utilis&eacute;s en vertu d&rsquo;une licence de Rogers Communications Inc. ou d&rsquo;une soci&eacute;t&eacute; membre de son groupe. Tous ces &eacute;l&eacute;ments sont reconnus comme des actifs de valeur de leurs propri&eacute;taires respectifs, et vous ne pouvez pas les afficher, les copier ni les utiliser de quelque fa&ccedil;on que ce soit &agrave; des fins commerciales ni pour quelque autre fin que ce soit.</p><p>Tout logiciel ou contenu que vous recevez ou achetez par l&rsquo;interm&eacute;diaire de Rogers ou d&rsquo;une de nos boutiques tierces ne peut servir qu&rsquo;&agrave; une utilisation personnelle non commerciale. Un tel logiciel ou contenu demeure notre propri&eacute;t&eacute; ou celle de nos conc&eacute;dants de licence ou de nos fournisseurs de contenu, le cas &eacute;ch&eacute;ant. Vous ne pouvez pas :</p><p>i. copier, distribuer, transf&eacute;rer ou vendre un tel logiciel ou contenu;<br>ii. modifier, changer ou falsifier un tel logiciel ou contenu;<br>iii. d&eacute;sosser, d&eacute;compiler ou d&eacute;sassembler une partie du logiciel;<br>iv. tenter de d&eacute;jouer, &eacute;viter, contourner, retirer ou d&eacute;sactiver les m&eacute;canismes de protection d&rsquo;un tel logiciel.</p><p>Vous devez &eacute;galement prendre toutes les mesures raisonnables pour prot&eacute;ger les logiciels ou le contenu contre le vol, la perte et les dommages. Veuillez noter que de tels logiciels ou contenus peuvent, de temps &agrave; autre et sans que vous en soyez avis&eacute;, faire en sorte que votre &Eacute;quipement acc&egrave;de &agrave; Internet de fa&ccedil;on automatique, entra&icirc;nant des frais de transmission de donn&eacute;es et (ou) des frais d&rsquo;utilisation exc&eacute;dentaire.</p><p>d. Que dois-je savoir &agrave; propos des Services Yahoo! qui me sont offerts?</p><p>Yahoo! Inc. et les soci&eacute;t&eacute;s membres de son groupe peuvent offrir aux clients du Service d&rsquo;acc&egrave;s Internet de Rogers l&rsquo;acc&egrave;s &agrave; une gamme de ressources, incluant divers outils de communication et du contenu vari&eacute; (les <strong>&laquo; Services Yahoo! &raquo;</strong>). Lorsque vous utilisez les Services Yahoo!, les modalit&eacute;s de service, les lignes directrices et les r&egrave;glements de Yahoo! (les <strong>&laquo; Modalit&eacute;s Yahoo! &raquo;</strong>) qui s&rsquo;appliquent &agrave; ces services et qui sont affich&eacute;s sur les pages o&ugrave; vous acc&eacute;dez &agrave; ces services r&eacute;gissent votre utilisation des Services Yahoo! En utilisant les Services Yahoo!, vous acceptez d&rsquo;&ecirc;tre li&eacute; par les Modalit&eacute;s Yahoo! int&eacute;gr&eacute;es par renvoi &agrave; une Entente. En ce qui concerne le Service d&rsquo;acc&egrave;s Internet de Rogers et les Services Yahoo!, les obligations respectives de Rogers et de Yahoo! sont distinctes et non conjointes. Pour communiquer avec Yahoo! Inc. au sujet des Services Yahoo! seulement, veuillez &eacute;crire au Service &agrave; la client&egrave;le, 701, First Avenue, Sunnyvale, CA, 94089, &Eacute;tats-Unis. Pour obtenir de plus amples renseignements au sujet du traitement de vos renseignements personnels lorsque vous utilisez le Service d&rsquo;acc&egrave;s Internet de Rogers et les Services Yahoo!, consultez <a href=\"http://www.rogers.yahoo.com/privacy\">rogers.yahoo.com/privacy</a>.</p></div>");
$templateCache.put("views/localization/your-use-of-services.html","<div class=\"bold paragraph\">YOUR USE OF THE SERVICES</div><div class=\"paragraph\"><p>a. Do I own my phone number?</p><p>You do not own any phone number, e-mail address or other identifier assigned to you. We may change or remove an identifier at any time.</p><p>b. Does Rogers monitor the content that I transmit when I use the Services?</p><p>We have the right, but not the obligation, to monitor or investigate any content that is transmitted using the Services (other than voice Services) or the Equipment. We may also access or preserve content or information to comply with legal process in Canada or foreign jurisdictions, operate the Services, ensure compliance with an Agreement, or protect ourselves, our customers or the public.</p><p>c. What are my responsibilities relating to Rogers or third party software or content?</p><p>All trademarks, copyright, brand concepts, names, logos and designs that we use are intellectual property assets, registered or otherwise, of or used under license by Rogers Communications Inc. or of one of its affiliates. All are recognized as valuable assets of their respective owners, and you may not display, copy or use them in any manner for commercial or any other purpose.</p><p>Any software or content that you receive or purchase through Rogers or our third party storefronts is for your own personal, non-commercial use. This software or content remains our property or that of our licensors or content providers, as applicable. You may not:</p><p>i. copy, distribute, transfer or sell any of this software or content;<br>ii. modify, alter or tamper with any of this software or content;<br>iii.reverse engineer, decompile or disassemble any of this software;<br>iv. attempt to defeat, avoid, by-pass, remove, deactivate or otherwise circumvent any software protection mechanisms.</p><p>You must also take reasonable steps to protect this software or content from theft, loss or damage. Please be aware that software or content may from time to time automatically and, without notice to you, cause your Equipment to access the internet incurring data usage and/or overage charges.</p><p>d. What do I need to know about the Yahoo! Services available to me?</p><p>Yahoo! Inc. and its affiliates may provide Rogers internet Service customers with access to a collection of resources, including various communications tools and content (the <strong>&ldquo;Yahoo! Services&rdquo;</strong>). When you use the Yahoo! Services, the Yahoo! terms of service, guidelines and rules <strong>(&ldquo;Yahoo! Terms&rdquo;)</strong> applicable to such services that are posted on the pages where you access these services govern your use of the Yahoo! Services. By using the Yahoo! Services you agree to be bound by the Yahoo! Terms which are incorporated by reference into an Agreement. With respect to Rogers internet Services and the Yahoo! Services, the obligations of Rogers and Yahoo! are several and not joint. To contact Yahoo! Inc. regarding the Yahoo! Services only: write to Customer Care, 701 First Avenue, Sunnyvale, CA, 94089, USA. Information about how your personal information is treated when using the Rogers internet Services and Yahoo! Services is available at <a href=\"http://www.rogers.yahoo.com/privacy\">rogers.yahoo.com/privacy</a>.</p></div>");
$templateCache.put("views/modals/WirelessCTNLinkModal.html","<div class=\"totes-project\"><div class=\"module-account-overview-dialog\" id=\"myModal4\" data-test-id=\"myr-accountOverviewLinkModal-myModal4\"><div class=\"row\"><button type=\"button\" ng-click=\"ctnList.closeThisDialog(\'close\')\" class=\"closemodal\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button></div><div class=\"row\"><div class=\"col-xs-12\"><h4 translate=\"acc_multiCTN_which_wireless_account\"></h4></div></div><div class=\"row\"><div class=\"col-xs-1 col-md-3\"></div><div class=\"col-xs-10 col-md-6\"><div class=\"account-ctn\" ng-class=\"{warning: ctnList.resolvedData.al.accountStatusSimple === \'Warning\', error: ctnList.resolvedData.al.accountStatusSimple === \'Error\'}\"><div class=\"account-name-ctn-text\" data-ng-if=\"!al.nickName\"><span class=\"account-name-txt\">{{::ctnList.resolvedData.al.accountName.firstName| capitalize}}</span></div><div class=\"account-name-ctn-text\" data-ng-if=\"::al.nickName\"><span class=\"account-name-txt\">{{::ctnList.resolvedData.al.nickName}}</span></div><div class=\"account-number-ctn-CTN\"><ul class=\"CTNlist\"><li ng-repeat=\"value in ::ctnList.resolvedData.myServicesList\" ng-click=\"ctnList.selectCTNModal(value)\"><span class=\"account-number-txt\" ng-if=\"::value.isCTN\">{{::value.serviceDetail}} ></span><div class=\"clearboth\"></div></li></ul></div></div></div><div class=\"col-xs-1 col-md-3\"></div></div></div><div class=\"clearboth\"></div><div style=\"display: none;\"><form name=\"formToRogersMultiCTNSim\" id=\"formToRogersMultiCTNSim\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"::ctnList.resolvedData.wpkgclientMultiBAN\" name=\"changeSimBAN\"><br><input type=\"text\" data-ng-value=\"::ctnList.resolvedData.wpkgclientMultiCTN\" name=\"changeSimCTN\"><br><input type=\"text\" value=\"SMART_PHONE\" name=\"simFlowType\"><br></form></div></div>");
$templateCache.put("views/modals/account-removal-confirmation.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-show=\"showRemovalConfirmation\" ng-click=\"close(true)\" src=\"ute-common-assets/assets/close-icon.png\"> <img class=\"close-icon\" ng-show=\"!showRemovalConfirmation\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><h3 class=\"address-heading\" translate=\"_account_removal_confirmation_heading\">Account Removal Confirmation</h3><p class=\"subheading\" ng-show=\"!showRemovalConfirmation\" translate=\"_account_removal_confirmation_message\">You are about to remove the account shown below. You can add or re-link accounts to your profile at any time</p><div ng-show=\"!showRemovalConfirmation\" class=\"gray-border\"></div><div ng-show=\"showRemovalConfirmation\"><span translate=\"_account_removal_success_msg\"></span></div><div ng-show=\"!showRemovalConfirmation\" class=\"account-name customer-info-container\"><span translate=\"_account_removal_confirmation_accountname\">Account Name:</span><div>{{accountName}}</div></div><div ng-show=\"!showRemovalConfirmation\" class=\"account-number customer-info-container\"><span translate=\"_account_removal_confirmation_accountnumber\">Account Number:</span><div>{{accountNumber}}</div><img ng-show=\"loading\" class=\"widget-loader remove-account-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div><div ng-show=\"!showRemovalConfirmation\" class=\"button-container account-removal-button-container\"><button class=\"cancel-button cta-round tertiary large\" translate=\"_cancel\" ng-click=\"close()\">cancel</button> <button class=\"submit-address cta-round primary large\" translate=\"_remove_account\" ng-click=\"removeAccount()\">remove account</button></div></div>");
$templateCache.put("views/modals/billingAndPaymentModal.html","<div class=\"totes-project billingAndPayment-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"submenu_billing_and_payment\"></span></h4><div class=\"prepaid-body-section\"><div><span translate=\"billing_payment_body_agent\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span translate=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/briteBillPromo.html","<div class=\"totes-project\"><section class=\"module-brite-bill-promo-modal\"><img class=\"close-icon\" ng-click=\"cancel()\" src=\"ute-common-assets/assets/close-icon.png\"><div id=\"video-ctn\" class=\"video-ctn\"><iframe class=\"youtube-video\" ng-src=\"{{videoLink}}\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div></section></div>");
$templateCache.put("views/modals/concurrentUpdateModalPopup.html","<div id=\"concurrent-popup\"><div class=\"modal-container\"><div class=\"modal-header\"><div><span class=\"concurrent-alert\"></span> <span class=\"title\" translate=\"concurrent_update_message_title\"></span><div class=\"concurrent-close\" ng-click=\"vm.closeConcurrentUpdate()\">&times;</div></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"modal-body-message\"><p ng-if=\"vm.flowType == \'ppc\'\" translate=\"ppc_concurrent_update_message_text\"></p><p ng-if=\"vm.flowType == \'hup\'\" translate=\"hup_concurrent_update_message_text\"></p></div></div></div><div class=\"row\"><div class=\"col-xs-12 copy\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button type=\"button\" class=\"button-default signout-button\" ng-click=\"vm.onRefresh()\"><span translate=\"concurrent_update_ok\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/contact-care-fr-customers.html","<div class=\"main-modal totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><div class=\"plan-cta-chat\"><div class=\"plan-cta-chat-block\"><div class=\"ute-reactivateCtn-message-box-support\"><div class=\"ute-reactivateCtn-support-phone-box\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"> <span class=\"ute-reactivateCtn-support-phone\" translate=\"tv_french_supportPhoneNumber\"></span></div><bold-chat-static-button style=\"margin-top:20px;\" data-cbid=\"{{\'S_Shop_Resi_Chg_fr1\' | translate}}\" data-dynamic-div=\"chat1\" data-chat-button=\"live-chat-text-content\"></bold-chat-static-button></div></div></div></div>");
$templateCache.put("views/modals/deepLinkModal.html","<div class=\"totes-project deep-link-modal\"><div ng-if=\"!vm.isChangeVoicemailPassword\" class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"moving_to_ssp\"></span></h4><div class=\"prepaid-body-section\"><div ng-if=\"vm.isChangePhoneNumber\"><span translate=\"change_phone_number_desc\"></span></div><div ng-if=\"vm.isChangeSim\"><span translate=\"change_sim_desc\"></span></div><div ng-if=\"vm.isChangePlan\"><span translate=\"change_plan_desc\"></span></div><div ng-if=\"vm.isManageAddon\"><span translate=\"manage_addon_desc\"></span></div><div ng-if=\"vm.isUpgradeDevice\"><span translate=\"upgrade_device_desc\"></span></div><div ng-if=\"vm.isAddaLineIndividual\"><span translate=\"add_a_line_desc\"></span></div><div ng-if=\"vm.isAddaLineShared\"><span translate=\"add_a_line_desc\"></span></div><div ng-if=\"vm.isHupCancellation\"><span translate=\"hup_cancellation_desc\"></span></div><div ng-if=\"vm.isGetWireless\"><span translate=\"get_wireless_desc\"></span></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"vm.dontShowGoToSSPMsgAgain\" ng-click=\"vm.setShowMessage(vm.dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" translate=\"message_do_not_display_ssp_popup\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><a name=\"cancel\" ng-click=\"vm.cancel()\" class=\"link-cancel pull-left pointer cancel-btn-modal\"><span translate=\"_cancel\">Cancel</span></a> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium modal-btn\" ng-click=\"vm.close()\"><span class=\"no-text-transform\" translate=\"_continue\"></span></button></div></div></div></div></div><div ng-if=\"vm.isChangeVoicemailPassword\" style=\"position: relative;\" class=\"modal-body mlm mrm\"><div class=\"dialog module-link-account voicemailCenter\"><div class=\"row mbm voicemailRow\"><div class=\"prepaid-body-section\"><div class=\"voicemailDesc\" ng-if=\"vm.isChangeVoicemailPassword\"><span translate=\"update_voicemail_password_desc\" class=\"voicemailCenter\"></span></div></div></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"vm.dontShowGoToSSPMsgAgain\" ng-click=\"vm.setShowMessage(vm.dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" translate=\"message_do_not_display_ssp_popup\"></span></div><div class=\"ngdialog-buttons mbm voicemailBtnPadding\"><div class=\"row voicemailCenter\"><div class=\"\"><a name=\"cancelVoiceMail\" ng-click=\"vm.cancel()\" class=\"link-cancel pointer cancel-btn-modal\"><span translate=\"_cancel\">Cancel</span></a><button ng-click=\"vm.close()\" class=\"cta-round primary medium resetBtn\" type=\"button\" name=\"button_continue\"><span class=\"no-text-transform\" translate=\"reset\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/disassociateModalFail.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><h3 class=\"address-heading\">Account Add/Removal Error</h3><p class=\"_account_removal_error_msg\">Sorry! It seems something went wrong on our end. A client care rep is available to help on</p><div ng-if=\"language === \'en\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=24\" class=\"live-chat-label\" translate=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div><div ng-if=\"language === \'fr\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?s=74\" class=\"live-chat-label\" translate=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div></div>");
$templateCache.put("views/modals/error-message.html","{{ message }} <button ng-click=\"cancel()\">OK</button>");
$templateCache.put("views/modals/findAccNumberModal.html","<div class=\"totes-project\"><div class=\"modal-body find_accNumber_modal_body\"><div class=\"dialog find_accNumber_modal\"><div class=\"row modal_header\"><div class=\"modal_header_holder\"><h2 class=\"modal-title\" translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_title\"></h2><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><i aria-hidden=\"true\" class=\"rogers-icon-circle-x\"></i></button></div></div><div class=\"find_accNumber_modal_content\" ng-click=\"refocus()\"><h3 class=\"section_intro\" translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_intro\"></h3><accordion close-others=\"oneAtATime\"><accordion-group is-open=\"accordionStatus[0]\"><accordion-heading><i class=\"accordion_opnner ute-icon-arrow-down\"></i> <span translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_1\"></span></accordion-heading><div class=\"panel_body_holder\"><div class=\"img_holder\"><img class=\"img-responsive\" ng-src=\"{{currentLanguage === \'en\' ? \'images/find_acc_number_modal_option_1.png\' : \'images/find_acc_number_modal_option_1_fr.png\'}}\" alt=\"\"></div><div class=\"text_holder\"><p translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_1_intro\"></p></div></div></accordion-group><accordion-group is-open=\"accordionStatus[1]\"><accordion-heading><i class=\"accordion_opnner ute-icon-arrow-down\"></i> <span translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_2\"></span></accordion-heading><div class=\"panel_body_holder\"><div class=\"img_holder\"><img class=\"img-responsive\" ng-src=\"{{currentLanguage === \'en\' ? \'images/find_acc_number_modal_option_2.png\' : \'images/find_acc_number_modal_option_2_fr.png\'}}\" alt=\"\"></div><div class=\"text_holder\"><p translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_2_intro\"></p></div></div></accordion-group><accordion-group is-open=\"accordionStatus[2]\"><accordion-heading><i class=\"accordion_opnner ute-icon-arrow-down\"></i> <span translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_3\"></span></accordion-heading><div class=\"panel_body_holder\"><div class=\"img_holder\"><img class=\"img-responsive\" ng-src=\"{{currentLanguage === \'en\' ? \'images/find_acc_number_modal_option_3.png\' : \'images/find_acc_number_modal_option_3_fr.png\'}}\" alt=\"\"></div><div class=\"text_holder\"><p translate=\"myr.modules.findAccNumberMoal.find_acc_number_modal_option_3_intro\"></p></div></div></accordion-group></accordion></div></div></div></div>");
$templateCache.put("views/modals/fraudCheckModal.html","<div class=\"totes-project\"><div class=\"container-fluid modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 translate=\"modal_thank_you_registration_headline\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 translate=\"modal_thank_you_registration_join\"></h4></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p translate=\"modal_thank_you_registration_info\"></p></div></div><div class=\"row hidden-xs\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-left\"><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" translate=\"modal_thank_you_registration_later\"></a></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" translate=\"modal_thank_you_registration_community\"></button></div></div></div><div class=\"row visible-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 xs-padding\"><center><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" translate=\"modal_thank_you_registration_community\"></button></center></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" translate=\"modal_thank_you_registration_later\"></a></center></div></div></div></div>");
$templateCache.put("views/modals/generalErrorDialog.html","<div class=\"verify-address general-error totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><h3 class=\"errorLogo\" ng-if=\"errorTitle\"><span data-ng-bind-html=\"errorTitle\"></span></h3><div class=\"error-explanation\"><img class=\"error-img\" src=\"images/error-exclamation.png\"><p ng-show=\"verifyAddressFailed\" class=\"subheading error-description\" translate=\"verify_address_general_error\"></p><p ng-hide=\"verifyAddressFailed\" class=\"subheading error-description\" translate=\"general_error\"></p></div><div class=\"live-chat-icon\" ute-user-hide-if-any-granted=\"care,careRep,dealer\"><div ng-if=\"language === \'en\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=24\" class=\"live-chat-label\" translate=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div><div ng-if=\"language === \'fr\'\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?s=74\" class=\"live-chat-label\" translate=\"_live_chat\">Live Chat</a><img src=\"images/black-right-arrow.png\"></div></div></div>");
$templateCache.put("views/modals/genericMessageModal.html","<div class=\"main-modal totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><div><h3 class=\"heading\" data-translate=\"{{message.title}}\"></h3><p class=\"subheading\" data-translate=\"{{message.description}}\"></p></div></div>");
$templateCache.put("views/modals/homephone-contact-care.html","<div class=\"solaris-modal-ui\"><div class=\"solaris-modal-ui-hdr\"><img class=\"solaris-modal-ui-alert-icon\" src=\"ute-common-assets/assets/security-lock.png\"> <span class=\"solaris-modal-ui-hdr-txt\" translate=\"home_phone_contact_care_liveChat.title\">Want to activate Home Phone?</span> <button class=\"solaris-modal-ui-close\" data-ng-click=\"close()\" role=\"button\" tabindex=\"0\"><span class=\"solaris-modal-ui-close-x\">X</span></button></div><div class=\"solaris-modal-ui-body\"><p translate=\"home_phone_contact_care_liveChat.description\">Please contact us and we\'ll help you out.</p><div class=\"solaris-modal-ui-strip\"><div class=\"solaris-modal-ui-strip-ctn\"><div class=\"solaris-modal-ui-strip-box strip-box-left\" ng-if=\"isLanguageEnglish\"><div class=\"solaris-modal-ui-strip-btn\"><bold-chat-static-button data-cbid=\"{{liveChat.cbid | translate}}\" data-dynamic-div=\"{{liveChat.dynamicDiv | translate}}\" data-chat-button=\"{{liveChat.chatButton | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><span class=\"rogers-icon-livechat-v2\" style=\"font-size: 4.3rem;margin: 5px;\"></span> <span class=\"solaris-modal-ui-strip-btn-text\">Live Chat</span></div></div><div class=\"solaris-modal-ui-strip-box strip-box-right\" ng-class=\"{\'single-box\': !isLanguageEnglish}\"><div class=\"solaris-modal-ui-strip-btn\"><span class=\"rogers-icon-phone-v3\"><img class=\"phone-image\" ng-src=\"images\\phone.png\" src=\"images\\phone.png\" style=\"width:35px; height:auto; margin:5px;\"></span> <span class=\"solaris-modal-ui-strip-btn-text\" translate=\"home_phone_contact_care_liveChat.phoneNumber\">1 888 764-3771</span></div></div></div></div></div></div>");
$templateCache.put("views/modals/marketingPermissionsInfo.html","<div class=\"verify-address marketing-permissions-info general-error totes-project\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"ute-common-assets/assets/close-icon.png\"><div><p translate=\"marketing_permissions_info\"></p></div></div>");
$templateCache.put("views/modals/modalEmpty.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\">in development</div></div>");
$templateCache.put("views/modals/myWifiModal.html","<div class=\"totes-project\"><ute-content-injector language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"{{ modalCMSContentUrl }}\"></ute-content-injector></div>");
$templateCache.put("views/modals/netflixFail.html","<div class=\"totes-project\"><div class=\"container-fluid modal-body\" style=\"background-color:#F0F2F5; padding-top: 4px; padding-bottom: 4px; border-top-left-radius: 25px;\"><div class=\"row\"><div class=\"col-xs-8\" style=\"margin-top: -1em;\"><h3><img class=\"error-img\" style=\"height: 20px;\" src=\"images/error-exclamation.png\">&nbsp; System Unavailable</h3></div><div class=\"col-xs-4\" style=\"margin-top: 0.5em;\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon-light.png\"></div></div></div><div class=\"container-fluid modal-body\"><div style=\"font-size:medium;\"><p>We\'re sorry, but we can\'t currently process your selection because of a system error.</p><p>Please try again later.</p></div><div class=\"row\" style=\"margin-bottom: 1em;\"><div class=\"col-xs-12\"><div><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\">CLOSE</button></div></div></div></div></div>");
$templateCache.put("views/modals/noproductmodal.html","<div class=\"totes-project\"><div class=\"module-account-overview-dialog\" id=\"myModal4\" data-test-id=\"myr-accountOverviewLinkModal-myModal4\"><div><img class=\"close-icon\" ng-click=\"alm.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"></div><div class=\"row\"><div class=\"col-xs-9\"><div class=\"warning-sym rui-icon-error warning-msg\"><span class=\"noproduct\" translate=\"acc_overview_no_product\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"panel-body\" translate=\"acc_overview_no_information\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-3\"></div><div class=\"col-xs-12 col-sm-4 visit-shop\"><a href=\"{{::alm.getNoProductUrl()}}\"><button type=\"button\" class=\"cta-round medium full shop-for-product\" translate=\"acc_overview_my_shop_for_products\"></button></a></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 visit-shop\"><button type=\"button\" ng-click=\"alm.cancel()\" class=\"cta-round primary medium full\" translate=\"acc_overview_my_acc_overview_product\"></button></div></div></div></div>");
$templateCache.put("views/modals/paper-billing-modal.html","<div class=\"modal-body modal-password-requirements\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"ute-common-assets/assets/close-icon.png\"><h3>Paper Billing</h3><p>You will receive your bills in the mail at the beginning of the next billing cycle. Please check your Billing Address to make sure we have the correct information.</p><p>You may also select Online Billing, which would directly send your Bills to your email imbox.</p></div>");
$templateCache.put("views/modals/passwordRequirement.html","<div class=\"verify-address general-error totes-project\"><img class=\"close-icon\" ng-click=\"closeModal()\" src=\"ute-common-assets/assets/close-icon.png\"><div><h3 translate=\"_password_requirements_label\">Password Requirements</h3><p translate=\"_password_requirements_text\">Your password must be between 8 and 16 characters. It should contain at least one letter, at least one number and no special characters</p></div></div>");
$templateCache.put("views/modals/paynowCancel.html","<div class=\"totes-project\"><div class=\"page-pay-now\" style=\"padding:15px\"><div class=\"row\"><div class=\"ngdialog-close pull-right\"></div></div><div class=\"row\"><div class=\"dialog link-account\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><span translate=\"paynow_cancel_desc\"></span></div></div><div class=\"row ngdialog-buttons\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><button name=\"paynow_continue\" type=\"button\" tabindex=\"10\" class=\"cta-round primary medium mtm modal-ok-btn\" ng-click=\"cancelOk()\" translate=\"paynow_continue\"></button> <button name=\"cancel\" class=\"cta-round secondary medium btn-redeem dark-gray-btn mtm mrm modal-cancel-btn\" tabindex=\"9\" ng-click=\"cancelCancel()\" data-test-id=\"myr-paynowCancel-paynow_cancel\"><span translate=\"paynow_cancel\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/paynowFailure.html","<div class=\"totes-project page-pay-now\"><div style=\"padding:15px\"><div class=\"row\"><div class=\"ngdialog-close pull-right\"></div></div><div><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1\"><span class=\"message-banner-icon icon-alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 pln prn\" style=\"float:left\"><div><span ng-bind-html=\"sorryMessage\"></span><need-help data-cbid=\"liveChatOptions.boldChatButtonId\" data-cbid-fr=\"liveChatOptions.boldChatButtonIdFr\" data-dynamic-div=\"liveChatOptions.boldChatButtonDiv\" data-chat-button=\"liveChatOptions.boldChatButton\" data-chat-button-fr=\"liveChatOptions.boldChatButtonFr\" data-template-url=\"scripts/directives/needHelp/needHelpInline.html\" data-error-message=\"sorryMessage\" data-lang=\"lang\"></need-help></div></div></div><div class=\"ngdialog-buttons\"><div class=\"row mtl\"><div class=\"col-lg-6 col-md-6\">&nbsp;</div><div class=\"col-xs-6 col-lg-6 col-md-6 col-sm-6\"><button name=\"cancel\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"showBegin()\" translate=\"paynow_select_another\"></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/paynowSuccess.html","<div class=\"totes-project page-pay-now\"><div style=\"padding:15px\"><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12\" ng-class=\"{\'col-md-5 col-lg-5\':isPreAuthorized, \'col-md-12 col-lg-12\':!isPreAuthorized}\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\" style=\"max-width: 45px;\"><span class=\"message-banner-icon icon-success prs\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div><span ng-bind-html=\"thankYouMessage\"></span></div><div class=\"ptm pbm\" ng-class=\"{\'\':isPreAuthorized, \'pull-right\':!isPreAuthorized}\"><button name=\"cancel\" class=\"cta-round secondary medium mts\" ng-click=\"goToOverview()\"><span translate=\"paynow_go_to_overview\"></span></button></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7 mbm mts\" data-ng-hide=\"!isPreAuthorized\"><div class=\"payNowThanks no-border\"><div class=\"myServiceArrow\"></div><div class=\"row ptl\"><div class=\"never-miss-ctn col-xs-10 col-md-10 col-lg-10 col-sm-10 col-md-font-size\"><span class=\"never-miss-1\" translate=\"paynow_never_miss_1\"></span> <span class=\"never-miss-2\" translate=\"paynow_never_miss_2\" ng-click=\"goToChangeMethod()\"></span></div></div></div></div></div></div></div>");
$templateCache.put("views/modals/ppc-modal-template.html","<section class=\"module-ppc-modal\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"><h2>{{title}}</h2><p data-ng-bind-html=\"message\"></p><div class=\"contact\" ng-show=\"showLiveChat\"><p><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></bold-chat-static-button></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span ng-if=\"isSuspendedAccount\" translate=\"800_number_suspended\"></span> <span ng-if=\"!isSuspendedAccount\" translate=\"800_number\"></span></p></div><div class=\"ppc-button-ctn\"><a data-ng-show=\"showCancelBtn\" class=\"cancel-button blue\" ng-click=\"cancel()\" translate=\"CANCEL\"></a> <a data-ng-show=\"showOKBtn\" class=\"modal-button\" ng-click=\"ok()\">OK</a> <a data-ng-show=\"showConfirmBtn\" class=\"modal-button\" ng-click=\"confirm()\" translate=\"CONFIRM\"></a> <a data-ng-show=\"showConfirmPlanChangeBtn\" class=\"modal-button\" ng-click=\"confirm()\" translate=\"CONFIRM_PLAN_CHANGE\"></a> <a data-ng-show=\"showContinueBtn\" class=\"modal-button\" ng-click=\"continue()\" translate=\"_continue\"></a> <a data-ng-show=\"showRemoveAddOnBtn\" class=\"modal-button\" ng-click=\"removeAddOn()\" translate=\"ppc_remove_addon\"></a> <a data-ng-show=\"showGoBackBtn\" class=\"modal-button\" ng-click=\"goBack()\" translate=\"GO_BACK\"></a></div></section>");
$templateCache.put("views/modals/ppc-not-eligible.html","<div class=\"totes-project\" ng-class=\"{\'bot-eligible\': vm.isBOTerror}\"><div class=\"modal-body mlm mrm modal-body-bot\"><div class=\"dialog\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.onContinue()\"><span aria-hidden=\"true\">&times;</span></button><h4 ng-if=\"!vm.isBOTerror\"><span translate=\"ppc_not_eligible_title\">ppc_not_eligible_title</span></h4><div class=\"bot-header\" ng-if=\"vm.isBOTerror\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"> <img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/green-checkbox.png\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"> <span translate=\"ppc_bot_header\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"></span> <span translate=\"case_success\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"></span></div><div class=\"pbm bot-content\" ng-bind-html=\"vm.model.desc\"></div><div class=\"contact\" ng-if=\"vm.isConsumer\"><p><a data-ng-href=\"{{vm.chatHref}}\" target=\"_blank\"><img class=\"live-chat-icon\" src=\"images/live-chat-red-icon.png\"> <span translate=\"_live_chat\"></span></a></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span translate=\"800_number\"></span></p></div></div><div class=\"ngdialog-buttons mbm bot-button-section\"><div class=\"row\"><div class=\"text-center\" ng-if=\"!vm.isBOTerror && vm.isConsumer\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.onContinue()\"><span translate=\"_continue\"></span></button></div><div class=\"text-right\" ng-if=\"!vm.isBOTerror && !vm.isConsumer\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.onContinue()\"><span translate=\"_ok\"></span></button></div><div><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.cancelCase()\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"><span translate=\"yes_change_plan\"></span></button> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.proceedWithPPC()\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"><span translate=\"proceed_ppc\"></span></button><a href=\"\" ng-click=\"vm.onContinue()\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\" translate=\"modified_ppc_wait_complete\" class=\"mal\"></a></div></div></div></div></div></div>");
$templateCache.put("views/modals/prepaidModal.html","<div class=\"totes-project prepaid-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\" ng-hide=\"actionOtherThanTopUp\"><span translate=\"top_up_now\"></span></h4><h4 class=\"link-account-title\" ng-show=\"actionOtherThanTopUp\"><span translate=\"make_account_changes\"></span></h4><div class=\"prepaid-body-section\"><div ng-hide=\"actionOtherThanTopUp\"><span translate=\"top_up_now_body\"></span></div><div ng-show=\"actionOtherThanTopUp\"><span translate=\"make_account_changes_body_agent\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span translate=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/reserveDevice.html","<div class=\"totes-project\"><section class=\"module-wireless-device-reserve-modal\"><img class=\"close-icon\" ng-click=\"vm.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"> <span class=\"rui-icon-warning warning-color\"></span><br><br><span class=\"warning-txt\" translate=\"wireless_device_reservation_warning\"></span><br><a class=\"cta-round primary medium btn-not-activate\" ng-click=\"vm.cancel()\" translate=\"_cancel\"></a> <a class=\"cta-round primary medium btn-activate\" ng-click=\"vm.ok()\" translate=\"wireless_ok\"></a></section></div>");
$templateCache.put("views/modals/reset-voicemail-password.html","<div class=\"rhp-dialog-modal\"><div class=\"modal-header\"><div ng-click=\"close()\" class=\"rhp-dialog-modal-close\" role=\"button\" tabindex=\"0\"><i class=\"rui-icon-mobile-menu-exit\"></i></div><div class=\"modal-title\"><span class=\"rui-icon-alert-i\"></span> <span translate=\"ute.rogers.rhpDashboard.resetVoiceMailPasswordText\"></span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><p translate=\"ute.rogers.rhpDashboard.resetVoiceMailPasswordBody\"></p></div></div></div><div class=\"modal-footer\"><div class=\"\"><div class=\"col-sm-12\"><button class=\"btn red-btn\" ng-click=\"resetVoicemailPassword()\"><span translate=\"ute.rogers.rhpDashboard.resetVoiceMailPasswordButton\"></span></button> <a ng-click=\"close()\" class=\"btn link-btn\"><span translate=\"ute.rogers.rhpDashboard.cancel\"></span></a></div></div></div></div>");
$templateCache.put("views/modals/resetPasswordModal.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"reset_customer_password_title\"></span></h4><div class=\"pbm\"><span translate=\"reset_password_message\"></span></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><a name=\"cancel\" ng-click=\"cancel()\" class=\"link-cancel pull-left pointer cancel-btn-modal\"><span translate=\"_cancel\">Cancel</span></a> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium modal-btn\" ng-click=\"continueProcess()\"><span class=\"no-text-transform\" translate=\"_continue\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/rhp-add-or-remove-feature.html","<div class=\"rhp-dialog-modal\"><div class=\"modal-header\"><div ng-click=\"close()\" class=\"rhp-dialog-modal-close\" role=\"button\" tabindex=\"0\"><i class=\"rui-icon-mobile-menu-exit\"></i></div><div class=\"modal-title\"><span class=\"rui-icon-alert-i\"></span> <span ng-if=\"isManageFeature\" translate=\"ute.rogers.rhpDashboard.manageFeatureHeader\"></span> <span ng-if=\"isResetPassword\" translate=\"ute.rogers.rhpDashboard.resetVoiceMailPasswordHeader\"></span></div></div><div class=\"modal-body rhp-add-remove-feature\"><div class=\"row\"><div class=\"col-xs-12\"><p translate=\"ute.rogers.rhpDashboard.managerFeatureBody\"></p></div></div></div><div class=\"modal-footer row\"><div class=\"contact-options-row\"><div class=\"contact-options\"><div class=\"contact-item col-xs-6 col-sm-offset-2 col-sm-4\"><div class=\"icon-block\"><a ng-href=\"{{rhpContactPhoneNumberUrl}}\" class=\"\"><span class=\"rui-icon-call\"></span><div class=\"icon-block-label\" aria-label=\"\"><span class=\"\" translate=\"ute.rogers.rhpDashboard.home_phone_contact_care_phoneNumber\"></span></div></a></div></div><div class=\"contact-item col-xs-6 col-sm-4\"><div class=\"icon-block\"><div class=\"bold-chat-container\" data-ng-class=\"{\'bold-chat-container-fr\' : lang == \'fr\'}\"><bold-chat-static-button style=\"\" data-cbid=\"{{rhpLiveChatUrl}}\" data-dynamic-div=\"chat\" data-chat-button=\"live-chat-text-content\"></bold-chat-static-button></div></div></div></div></div></div></div>");
$templateCache.put("views/modals/roamEnrollModal.html","<div class=\"totes-project roam-enroll-modal\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"roam_like_home_pop_up_title\"></span></h4><div class=\"prepaid-body-section\"><div><span translate=\"roam_like_home_pop_up_message\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.cancel()\"><span translate=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/see-discount-info-modal.html","<div class=\"totes-project\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"see_discount_info_title\"></span></h4><div class=\"prepaid-body-section\"><div><span translate=\"see_discount_info_message\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"close()\"><span translate=\"close\"></span></button></div></div></div></div></div></div>");
$templateCache.put("views/modals/terms-conditions.html","<style>\n  .terms-title {\n    background:#F0F2F5\n  }\n</style><div class=\"totes-project\"><div class=\"container-fluid modal-body terms-title\" style=\"padding-top: 4px; padding-bottom: 4px; border-top-left-radius: 25px;\"><div class=\"row\"><div class=\"col-xs-6\" style=\"margin-top: -1em;\"><h3>{{lang == \"en\" ? tnc.en.tnc.heading : tnc.fr.tnc.heading }}</h3></div><div class=\"col-xs-6\" style=\"margin-top: 0.5em;\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon-light.png\"></div></div></div><div class=\"container-fluid modal-body\"><div class=\"row\"><div ng-bind-html=\"htmlString\" class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"font-size:medium;\"></div></div><div>&nbsp;</div><div class=\"row\" style=\"margin-bottom: 1em;\"><div class=\"col-xs-12\"><div class=\"text-center\"><button ng-if=\"false\" name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\">{{lang == \"en\" ? tnc.en.tnc.button : tnc.fr.tnc.button }} <i ng-show=\"loadingSpinIcon\" class=\"fa fa-circle-o-notch fa-spin\"></i></button></div></div></div></div></div>");
$templateCache.put("views/modals/thankYouModalCtrl.html","<div class=\"totes-project\"><div class=\"container-fluid modal-body\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"cancel()\"><span aria-hidden=\"true\">&times;</span></button></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 translate=\"modal_thank_you_registration_headline\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h4 translate=\"modal_thank_you_registration_join\"></h4></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p translate=\"modal_thank_you_registration_info\"></p></div></div><div class=\"row hidden-xs\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-left\"><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" translate=\"modal_thank_you_registration_later\"></a></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"pull-right\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" translate=\"modal_thank_you_registration_community\"></button></div></div></div><div class=\"row visible-xs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 xs-padding\"><center><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"ok()\" translate=\"modal_thank_you_registration_community\"></button></center></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><center><a type=\"button\" class=\"title-h5 bold pointer uppercase\" ng-click=\"cancel()\" translate=\"modal_thank_you_registration_later\"></a></center></div></div></div></div>");
$templateCache.put("views/modals/underConstruction.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" translate=\"_under_construction\"></h2></div><div class=\"row mbs\"></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span translate=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("views/modals/update-billing-type.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><div ng-show=\"data.billingType == \'INVOICE\'\"><h3 class=\"address-heading\" translate=\"paper_bill_title\"></h3><p class=\"subheading\" translate=\"paper_bill_success_1\"></p><p class=\"subheading\" translate=\"paper_bill_success_2\"></p></div><div ng-show=\"data.billingType == \'E_BILL\'\"><h3 class=\"address-heading\" translate=\"online_bill_title\"></h3><p class=\"subheading\" translate=\"online_bill_success_1\"></p><p class=\"subheading\" translate=\"online_bill_success_2\"></p></div></div>");
$templateCache.put("views/modals/updateNickNameFail.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><p><div translate=\"_nickname_update_error_msg\"></div></p><button class=\"pull-right cta-round primary large\" ng-click=\"close()\"><span translate=\"close\"></span></button></div>");
$templateCache.put("views/modals/validateOrderPopUp.html","<section class=\"validate-order\"><div><div class=\"Modal-header\"><h4 class=\"Modal-heading\"><img class=\"wireless_warning_logo\" src=\"ute-common-assets/assets/warning_lg.png\"> <span class=\"title\" translate=\"hup_not_eligible_title\"></span></h4><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"close()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"Modal-body\"><span translate=\"invalid_hup_order_error\"></span></div></div></section>");
$templateCache.put("views/modals/verify-billing-address.html","<div class=\"verify-address totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><h3 class=\"address-heading\" translate=\"mailing_address\">Mailing Address</h3><p class=\"subheading billing-address\">&nbsp;</p><div class=\"canada-post-address\"><h3 translate=\"_as_per_canada_post\">As per Canada Post</h3><p>{{data.canadaPostAddress}}</p><button class=\"submit-address cta-round primary large\" ng-click=\"submitCanadaPostAddress()\" translate=\"_submit_canada_post_address\">submit canada post address</button></div><div class=\"gray-border-selfserve\"></div><div class=\"as-entered-address\"><h3 translate=\"_as_entered\">As entered</h3><p>{{data.address}}</p><div class=\"button-container\"><button class=\"cancel-button cta-round tertiary large\" ng-click=\"close()\" translate=\"_cancel\">cancel</button> <button class=\"submit-address cta-round primary large\" ng-disabled=\"data.address.length === 0\" ng-click=\"submit()\" translate=\"_submit_address_as_entered\">submit address as entered</button></div><div class=\"clear-fix\"></div></div></div>");
$templateCache.put("views/modals/wirelessRemovePlan.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" translate=\"wireless_popup_title\"></h2></div><div class=\"row mbs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div translate=\"wireless_popup_title_2\"></div></div></div><div class=\"row mtm\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><bold-chat-static-button data-cbid=\"{{boldChatButtonId}}\" dynamic-div=\"{{boldChatButtonDiv}}\" data-chat-button=\"{{boldChatButton}}\"></bold-chat-static-button></div></div><div class=\"row mts\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img src=\"images/phoneBlack.png\" class=\"mtm plm\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div translate=\"wireless_popup_phone\" class=\"mtl pts\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div translate=\"wireless_popup_not_sure\" class=\"mtm\"></div><a class=\"title-h5\" ng-href=\"{{viewAllPlanslink}}\" target=\"_blank\"><span translate=\"wireless_popup_all_plans\" class=\"bold\"></span></a></div></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span translate=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("views/modals/wirelessSubscriptionPricePlanDetails.modal.html","<div class=\"totes-project\"><section class=\"wireless-subscription-modal\"><div class=\"col-xs-12 modal-header\"><div class=\"col-xs-1\"><span class=\"new-info-icon\">i</span></div><div class=\"col-xs-9 mvn mbn\"><span><span translate=\"wireless_manage-plan_modal_header\"></span> <span ng-bind=\"::vm.modalCurrentPlanName\"></span></span></div><div ng-click=\"vm.close()\" class=\"close-gray-cross\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\" tabindex=\"0\"></div></div><div class=\"price-plan-details-modal-body\"><div class=\"col-xs-12\"><div class=\"col-xs-12 price-plan-details-header\"><div class=\"col-xs-4\"><span translate=\"wireless_manage-plan_description\"></span></div><div class=\"col-xs-3\"><span translate=\"wireless_manage-plan_effective_date\"></span></div><div class=\"col-xs-3\"><span translate=\"wireless_manage-plan_expiration_date\"></span></div><div class=\"col-xs-2\"><span translate=\"wireless_manage-plan_soc_code\"></span></div></div><div class=\"price-plan-details-body\" data-ng-repeat=\"planInfo in ::vm.modalAdditionalPlanInfo\"><div ng-if=\"::vm.lng === \'en\'\" class=\"col-xs-4\"><span ng-bind=\"::planInfo.desc\"></span></div><div ng-if=\"::vm.lng === \'fr\'\" class=\"col-xs-4\"><span ng-bind=\"::planInfo.descFr\"></span></div><div class=\"col-xs-3\"><span ng-bind=\"::planInfo.effectiveDate | date:\'MM/dd/yyyy\'\"></span></div><div ng-if=\"::planInfo.expiryDate.length !== 0\" class=\"col-xs-3\"><span ng-bind=\"::planInfo.expiryDate | date:\'MM/dd/yyyy\'\"></span></div><div ng-if=\"::planInfo.expiryDate.length === 0\" class=\"col-xs-3\"><span translate=\"wireless_manage-plan_wireless-not-applicable\"></span></div><div class=\"col-xs-2\"><span ng-bind=\"::planInfo.code\"></span></div></div><div class=\"price-plan-details-body\" ng-if=\"::vm.modalAdditionalPlanInfo.length === 0\"><span class=\"col-xs-12 text-center\" translate=\"wireless_manage-plan_no_socs_available\"></span></div></div></div></section></div>");
$templateCache.put("views/modals/wirelessTravelPackage.html","<div class=\"totes-project\"><section class=\"module-wireless-travel-package-modal\"><img class=\"close-icon\" ng-click=\"vm.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"><h1 class=\"modal-title\" translate=\"activating_roam_like_home\"></h1><div ng-hide=\"vm.errorMessage\"><div ng-hide=\"vm.hideOldRLH\"><span class=\"roaming-price-txt\" translate=\"go_ahead_roam_on\"></span><p><span class=\"roaming-price-txt\" translate=\"while_you_are_travelling\"></span></p><span class=\"roaming-price-txt\" translate=\"remember_you_will_need_to_enroll\"></span></div><div ng-hide=\"vm.hideNewRLH\"><span class=\"roaming-price-txt\" translate=\"rlh_confirm_modal_msg\"></span></div><span class=\"are-you-sure-txt\" translate=\"are_you_sure_activate_roam\"></span> <a class=\"cta-round primary medium btn-not-activate\" ng-click=\"vm.cancel()\" translate=\"no_dont_activate\"></a> <a class=\"cta-round primary medium btn-activate\" ng-click=\"vm.getPlan()\" translate=\"yes_activate\"></a></div><div ng-show=\"vm.errorMessage\"><span class=\"roaming-price-txt\" translate=\"travel_package_fail_msg\"></span></div></section></div>");
$templateCache.put("views/modals/wirelessTravelPackageLegal.html","<div class=\"totes-project\"><section class=\"module-wireless-travel-package-modal\"><img class=\"close-icon\" ng-click=\"vm.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"><div class=\"legal-content\" ng-bind-html=\"vm.legalContent\"></div></section></div>");
$templateCache.put("views/modals/wirelessUnEnrollTravelPackage.html","<div class=\"totes-project\"><section class=\"\"><div class=\"unenroll_header\"><div class=\"unenroll_heading_section\"><img class=\"unenroll_heading_warning\" src=\"ute-common-assets/assets/warning_yellow.png\" tabindex=\"0\"><div class=\"unenroll_heading\"><h1 class=\"modal-title\" translate=\"opt_out_rlh_reminder\"></h1></div><img class=\"unenroll_heading_close_icon\" ng-click=\"vm.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"></div><div class=\"unenroll_body\"><div ng-if=\"!vm.errorMessage\"><p><span class=\"roaming-price-txt\" translate=\"opt_out_rlh_message_1\"></span></p><p class=\"opt_out_rlh_padding\"><span class=\"roaming-price-txt\" translate=\"opt_out_rlh_message_2\"></span></p><span class=\"roaming-price-txt\" translate=\"opt_out_rlh_refer_nova\"></span><div class=\"opt_out_rlh_padding\"><a class=\"cta-round primary medium col-xs-3\" ng-click=\"vm.unEnrollPlan()\" translate=\"opt_out_rlh_enroll\"></a> <a class=\"link-cancel pointer cancel-btn-modal cancel-btn-align\" ng-click=\"vm.cancel()\" translate=\"_cancel\"></a></div></div></div><div ng-if=\"vm.errorMessage\" class=\"errorMessage_align\"><span class=\"roaming-price-txt\" translate=\"opt_out_rlh_error\"></span></div></div></section></div>");
$templateCache.put("views/modals/wirelessUpgradeDeviceModal.html","<div class=\"totes-project\"><div class=\"row wireless-hup-modal\"><div class=\"row hup-modal-header\"><div class=\"col-xs-11 ptm\"><h5 translate=\"wirless_manager-device_hup\"></h5></div><div ng-click=\"vm.cancel()\" class=\"col-xs-1 hup-modal-header-close\"><div class=\"col-xs-10 close-gray-cross\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div></div><div class=\"row hub-modal-body\"><div class=\"row\"><span translate=\"wireless_manage-device_in_stock_info\"></span> <a class=\"link-cancel pointer\" data-ng-click=\"vm.openSSP()\"><span translate=\"ssp\"></span></a></div><div class=\"row\"><span translate=\"wireless_manage-device_out_of_stock_info\"></span> <a class=\"link-cancel pointer\" data-ng-click=\"vm.openAiselFlow()\"><span translate=\"wireless_manage-device_endless_Aisle\"></span></a></div></div></div></div>");
$templateCache.put("views/selfServe/accountSelect.html","<div class=\"row account-select\"><div class=\"account-container\" style=\"margin-bottom: 15px !important;\"><div class=\"row\"><div class=\"col-lg-5 col-md-7 col-sm-8 col-xs-12\"><div class=\"row\"><div class=\"nick-name\" ng-if=\"!localNickName.nickNameBeingEdited\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><img src=\"images/user-icon.png\"> <span class=\"\">{{getNickName()}}</span><span ng-if=\"localNickName.nickNameTruncated\">...</span></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5\" ng-if=\"accounts.length > 0 && ((!currentPanelOpen && !loading && !generalError && !isReadOnly()) || ((isCare || isDealer) && isProfileLoading && !generalError))\"><span class=\"editButton\" ng-if=\"!(isCare || isDealer)\" ng-class=\"{\'edit-button-enabled\': repProfileUpdate && !isEditOpen() , \'no-pointer\' : isCare || isDealer , \'grey-edit-icon\': (isCare || isDealer)}\" ng-click=\"repProfileUpdate && !isEditOpen() && !localNickName.nickNameBeingEdited && !(isCare || isDealer) && editNickName()\"></span> <span class=\"edit-label\" ng-if=\"!(isCare || isDealer)\" ng-class=\"{\'edit-label-enabled\': repProfileUpdate && !isEditOpen(), \'no-pointer\' : isEditOpen() || isCare || isDealer}\" translate=\"_editlabel\" ng-click=\"repProfileUpdate && !isEditOpen() && !localNickName.nickNameBeingEdited && !(isCare || isDealer) && editNickName()\">Edit</span><span class=\"care-edit-button\" ng-if=\"(isCare || isDealer)\" ng-click=\"profileEditUserNPass.editOnClick()\"><i class=\"rui-icon-edit disabled-field\"></i> <span translate=\"ute.common.label.edit\"></span></span><div class=\"self-serve-direction\" ng-if=\"(isCare||isDealer)\" ng-class=\"{\'greater-width\' : userLanguage === \'fr\' }\"><span class=\"new-line-arrow\"></span> <span translate=\"_self_serve_only\" class=\"self-serve-label\"></span></div></div></div><div class=\"nick-name\" ng-if=\"localNickName.nickNameBeingEdited && accounts.length > 0\"><form name=\"nickNameEditForm\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><img src=\"images/user-icon.png\"> <input type=\"text\" ng-model=\"localNickName.nickName\" data-ng-maxlength=\"14\" maxlength=\"14\" name=\"nickName\"></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5\"><span class=\"save-label\" ng-disabled=\"!(nickNameEditForm.$valid && nickNameEditForm.$dirty)\" ng-class=\"{ inactive : nickNameEditForm.$pristine && !localNickName.nickNameTruncated, \'no-pointer\' : nickNameEditForm.$pristine && !localNickName.nickNameTruncated, \'save-label-enabled\': (nickNameEditForm.$valid && nickNameEditForm.$dirty) || localNickName.nickNameTruncated}\" ng-click=\"((nickNameEditForm.$valid && nickNameEditForm.$dirty) || localNickName.nickNameTruncated) && saveNickNameChanges(nickNameEditForm)\" translate=\"save\"></span> <span class=\"cancel-label cancel-label-enabled\" ng-click=\"cancelNickNameEdit()\" translate=\"_cancel\"></span></div></form></div></div></div><div class=\"col-lg-3 col-md-5 col-sm-4 col-xs-12\"><div class=\"select-drop-down\" ng-if=\"accounts.length === 1\">{{accounts[0].accountNumber}}</div><div rui-dropdown=\"\" class=\"rui-dropdown profile-select-dropdown\" list=\"accounts\" selected=\"selectedAccount\" property=\"accountNumber\" select-action=\"selectedAccountChanged(item)\" ng-if=\"accounts.length > 1\" ng-disabled=\"iscollapsed || isEditOpen()\"></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"small-view-wrapper\" ng-click=\"repProfileUpdate && !(isCare || isDealer) && !isEditOpen() && (iscollapsed = !iscollapsed);\" ng-class=\"{\'small-view-wrapper-enabled\': repProfileUpdate && !isEditOpen(),\'no-pointer\': (isCare || isDealer)}\"><span class=\"add-remove-account-label\" ng-class=\"{\'add-remove-account-label-bottom\': !iscollapsed}\" translate=\"_add_remove_accounts\">ADD/REMOVE ACCOUNTS</span> <img ng-show=\"iscollapsed\" src=\"images/arrow-up.png\" class=\"arrow\" ng-class=\"{\'arrow-enabled\': !isEditOpen(),\'no-pointer\': (isCare || isDealer)}\"> <img ng-hide=\"iscollapsed\" src=\"images/arrow.png\" class=\"arrow\" ng-class=\"{\'arrow-enabled\': !isEditOpen(),\'no-pointer\': (isCare || isDealer)}\"></div><div class=\"self-serve-direction\" ng-if=\"(isCare||isDealer)\"><span class=\"new-line-arrow\"></span> <span translate=\"_self_serve_only\" class=\"self-serve-label\"></span></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"subaccount-container\" ng-show=\"iscollapsed\" style=\"padding-top: 20px !important;\"><ul class=\"subaccount-list\"><li class=\"subaccount-list-item\" ng-repeat=\"account in accounts track by $index\" ng-class=\"{last: $last}\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8 small-view-wrapper-account-number\"><span class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 account-number-label\"><span ng-if=\"account.nickname\">{{account.nickname}}</span> <span ng-if=\"!account.nickname\">{{account.accountName.firstName}} {{account.accountName.lastName}}</span></span> <span class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 sub-account-number\"><span class=\"sub-account-number-title\" translate=\"_account_#\"></span> {{account.accountNumber}}</span></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 remove-button-container\"><img src=\"images/blue-trash-can.png\"><span class=\"remove-account-button\" translate=\"_remove_account\" ng-click=\"disassociateAccount(account)\" adl-event-track=\'{\"action\":\"click\",\"pageView\":true,\"isModalPopup\":true,\"mappingKey\":\"remove-account,event.selfServeStart\"}\'>Remove Account</span></div></li></ul><div class=\"add-account-section\" ng-class=\"noLinkedAccount === true ? \'notLinked\' : \'linked\'\"><p class=\"hidden-xs hidden-sm\" translate=\"_want_add_account\">Want to add an account? Click Add account to link another</p><div class=\"add-account-container\" ng-class=\"noLinkedAccount === true ? \'notLinked\' : \'linked\'\"><img src=\"images/add-user.png\"> <span translate=\"add_account\" ng-click=\"addAccount()\" atm=\"’MyRogers_Profile_Account_Addaccount’\">Add Account</span></div></div></div></div></div></div></div>");
$templateCache.put("views/selfServe/manageData.html","<div class=\"row\"><div class=\"col-md-7 col-sm-8 col-xs-12\"><div class=\"row manage-data-access\"><div class=\"col-xs-2 col-sm-1 col-md-1 col-lg-1 myrRogersBrand-messageBox-info-icon\"><img class=\"\" src=\"images/info-icon-medium.png\"></div><div class=\"col-xs-10 col-sm-11 col-md-11 col-lg-11 data-access-content\"><span class=\"data-access\" translate=\"selfserve_manage_who_can_authorize\"></span><p class=\"restore-data\" translate=\"selfserve_data_access\"></p><a class=\"add-manage-data\" tabindex=\"0\" ng-click=\"redirectToWcocPortal()\" translate=\"selfserve_add_manage_data\"></a></div></div></div></div>");
$templateCache.put("views/selfServe/selfServe.html","<div class=\"self-serve\"><break-point></break-point><div class=\"col-xs-12 view-page-title\"><div class=\"row hidden-xs\"><div class=\"col-xs-12 retail mtop-51\"><div class=\"container\"><div class=\"col-xs-12 reset-pwd-loading-banner mtm mbm\" data-ng-show=\"resetPwdLoading\"><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div><div class=\"row account-unlock-banner\" data-ng-if=\"accountLocked && isRepView && (isCare || isDealer) && !hideUnlockInfo\"><div class=\"col-xs-2 col-sm-1 account-unlock-icon\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/unlock/info_icon.png\" class=\"account-unlock-img\"></div><div class=\"col-xs-8 col-sm-9 account-unlock-msg\"><span class=\"account-unlock-text\" translate=\"acc_overview_account_locked\"></span></div><div class=\"col-xs-2 account-unlock-link\"><div data-ng-show=\"!unlockAccountLoading\"><a data-ng-click=\"unlockAccount()\" class=\"pointer\" name=\"unlock\"><span translate=\"acc_overview_unlock\"></span></a></div><div data-ng-show=\"unlockAccountLoading\"><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div></div></div><div class=\"container banner-container clear-both\" data-ng-if=\"(unlockSuccessStatus || !unlockSuccessStatus) && (unlockMessageType===\'error\' || unlockMessageType===\'success\') && isRepView\"><one-view-banner type=\"unlockMessageType\" message=\"accountUnlockMsg\"></one-view-banner></div><div class=\"container banner-container clear-both\" data-ng-if=\"(resetPwdSuccessStatus || !resetPwdSuccessStatus) && (messageType===\'error\' || messageType===\'success\') && isRepView\"><one-view-banner type=\"messageType\" message=\"resetPwdResponseMsg\"></one-view-banner></div><div class=\"row message-banner clear-both mtm mbm\" data-ng-if=\"isGuidNotFound && isRepView && isCare\"><div class=\"col-xs-2 mtm mls one-view-banner-img-container\"><img class=\"myrRogersBrand-messageBox-icon\" src=\"ute-common-assets/assets/warning_yellow.png\"></div><div class=\"col-xs-9 col-sm-10 one-view-banner-msg\"><div class=\"mbs mts\" translate=\"guid_not_found_message\"></div></div></div><div class=\"rui-heading\"><h1><span translate=\"{{isConsumer() ? \'profile\' : \'ovProfile\'}}\">profile</span></h1></div></div></div></div></div><div class=\"row header-row hidden-sm hidden-md hidden-lg\"><div class=\"col-xs-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"profile\">profile</span></h1></div></div></div></div><ute-if-not-brt key=\"JANRAIN_REGISTRATION\"><div class=\"container\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/userAccount/usernameandpassword.html\" formtemplate=\"scripts/directives/editableContent/userAccount/usernameandpasswordform.html\" formdata=\"userInfo\" formheading=\"CredentialsHeading\" whiteout=\"true\" skin=\"rogers-content-margin\" load-login-security-questions=\"true\" on-submit=\"updateAccountInfo(updates, defer, form)\" readonly=\"!hasEmailUsername()\" editenable=\"false\"></editable-content></div></ute-if-not-brt><ute-if-brt key=\"JANRAIN_REGISTRATION\"><div class=\"container\"><ute-profile-edit-username-and-password data-is-edit-username=\"isEditUsername\" data-user-info=\"userInfo\" data-is-reset-flow=\"isRepView\" data-is-editable=\"!(isCare || isDealer)\" existing-email=\"isCare ? ContactInformation.email : \'\'\" billing-type=\"isCare ? BillingAddress.billingType : \'\'\" auto-reg-access=\"hasAutoRegAccessCare\"></ute-profile-edit-username-and-password></div></ute-if-brt><div class=\"row hidden-xs\"><div class=\"col-xs-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"account\">account</span></h1></div></div></div></div><div class=\"row header-row hidden-sm hidden-md hidden-lg\"><div class=\"col-xs-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"account\">account</span></h1></div></div></div></div><div class=\"container\"><div class=\"editable-content row rogers-content-margin\" data-ng-if=\"accountsFailed\"><div class=\"row info-banner error mts mbm\"><div class=\"col-xs-2 col-md-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-md-11 no-padding\" style=\"float:left\"><span translate=\"general_error\"></span></div></div></div><div data-ng-if=\"accountsFailed === false\"><div class=\"clear-fix\"></div><div data-ng-if=\"assosciatedAccountsExist\"><div class=\"row info-banner error mts mbm\" style=\"margin-left: 0;\" data-ng-if=\"generalError\"><div class=\"col-xs-10 col-md-11 general-error\" style=\"float:left\"><span translate=\"general_error\"></span></div></div><div data-ng-include=\"\'views/selfServe/accountSelect.html\'\" id=\"billingInformation\"></div><div data-ng-include=\"\'views/selfServe/manageData.html\'\" data-ng-if=\"(isConsumer() && hasDataAccess) || (!isConsumer() && hasDataAccessCare) && hasAuthorizedAccess\"></div><div data-ng-if=\"!BillingAddress.noBillingAddress && !prepaidAccount && hasLinkedAccount && repProfileBillingDetailsRead\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/billingInformation/billinginformation.html\" formtemplate=\"scripts/directives/editableContent/billingInformation/billinginformationform.html\" formdata=\"BillingAddress\" formheading=\"BillingAddressHeading\" whiteout=\"true\" skin=\"billing-margin\" billingupdate=\"true\" on-billingtypeupdate=\"updateBillingType(updates, defer)\" on-post-billingtypeupdate=\"postActionAfterGoPaperlessServiceCall(newEmailAddress, newBillingType)\" on-submit=\"updateBillingAddress(updates, defer, form)\" editenable=\"repProfileBillingDetailsUpdate\"></editable-content><div class=\"gray-border-selfserve no-margin-top\"></div></div><div data-ng-if=\"hasLinkedAccount && selectedAccount.accountTypeNumber && selectedAccount.accountTypeNumber !== 9\"><ute-payment-method selected-account=\"selectedAccount.details\"></ute-payment-method></div><div data-ng-if=\"!prepaidAccount && hasLinkedAccount && repProfileContactInfoRead\" id=\"contactInformation\"><editable-content editabletemplateurl=\"scripts/directives/editableContent/contactInformation/contactinformation.html\" formtemplate=\"scripts/directives/editableContent/contactInformation/contactinformationform.html\" formdata=\"ContactInformation\" formheading=\"ContactInformationHeading\" controller=\"contactInformationCtrl(scope)\" whiteout=\"true\" skin=\"rogers-content-margin\" emailupdate=\"true\" on-emailupdate=\"updateEmailAddress(updates, defer, form)\" on-submit=\"updateContactInformation(updates, defer, form)\" data-dtmname=\"contact information\" data-dtmservice=\"dtmService\" editenable=\"repProfileContactInfoUpdate\"></editable-content></div></div><div class=\"no-linked-accounts\" data-ng-if=\"!assosciatedAccountsExist\"><p translate=\"_want_add_account\">Want to add an account?</p><div class=\"add-account-container\"><img src=\"images/blue-user-icon.png\"> <span translate=\"add_account\">Add Account</span></div></div></div></div><div data-ng-show=\"isConsumer()\"><ute-anti-spam-legislation-directive account-number=\"selectedAccount.accountNumber\"></ute-anti-spam-legislation-directive></div></div>");
$templateCache.put("scripts/directives/accountSelector/accountSelector.html","<div class=\"row\"><ul class=\"account-list pln\"><div class=\"col-lg-4 col-md-12 col-sm-12\" ng-repeat=\"value in accountTypes track by $index\" data-ng-hide=\"value.accountTypeNumber === 9\"><li class=\"radius mtm mbm mrm\"><div class=\"radius pam mrm bda-grey account-item\"><div class=\"row\" ng-hide=\"value.accountStatusSimple === \'Error\' || value.accountStatusSimple == \'Warning\'\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 pln prn\"><span class=\"rui-icon-error-icon error-red mrs\" ng-show=\"value.accountStatusSimple === \'Error\'\"></span> <span class=\"rui-icon-warning warning-color mrs\" ng-show=\"value.accountStatusSimple === \'Warning\'\"></span></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11 pln prn\"><div><span class=\"account-owner-name label_blue\">{{value.accountName.firstName| capitalize}}</span></div><div><span class=\"account-owner-number\">{{value.accountNumber}}</span></div><div class=\"\"><a class=\"btn-view-bill\" ng-click=\"postToRogers()\"><span translate=\"acc_balance_view_bill\" class=\"bold pointer\"></span></a></div></div></div><div class=\"row\" ng-show=\"value.accountStatusSimple === \'Error\' || value.accountStatusSimple == \'Warning\'\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 pln prn\"><span ng-class=\"value.accountStatusSimple === \'Error\' ? \'rui-icon-error-icon error-red 2x mrs\' : \'rui-icon-warning warning-color mrs\'\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span translate=\"acc_overview_account_suspended_2\" ng-show=\"value.accountStatusSimple === \'Error\'\"></span> <span translate=\"acc_overview_account_cancelled\" ng-show=\"value.accountStatusSimple === \'Warning\'\"></span><div><span class=\"label_blue mts\">{{value.accountName.firstName| capitalize}}</span></div><div><span class=\"\">{{value.accountNumber}}</span></div><div class=\"\"><a class=\"btn-view-bill\" ng-click=\"postToRogers()\"><span translate=\"acc_balance_view_bill\" class=\"bold pointer\"></span></a></div></div></div></div></li></div></ul><div ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" name=\"accountNumber\"><br></form></div></div>");
$templateCache.put("scripts/directives/attemptsErrorBox/attemptsErrorBox.html","<div class=\"error-box-container\"><div class=\"row info-banner-lock ng-hide\" data-ng-show=\"(isLocked || attempts >= 6) && !errorSummary && !(submitted && (form.USER.$error.required || form.password.$error.required))\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img src=\"ute-common-assets/assets/warning.png\" data-test-id=\"myr-signIn-warningMaxIcon\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" translate=\"sign_maximum_attempts_line_1\" data-test-id=\"myr-signIn-errorMessageMax1\"></span><p class=\"sign-error-line-2\" translate=\"sign_maximum_attempts_line_2\" data-test-id=\"myr-signIn-errorMessageMax2\"></p><div><span class=\"sign-error-line-3\" translate=\"sign_maximum_attempts_line_3\" data-test-id=\"myr-signIn-errorMessageMax3\"></span><div id=\"boldChatDiv1_En\" class=\"attemptDiv1En\" ng-show=\"lang === \'en\'\"></div><div id=\"boldChatDiv1_Fr\" class=\"attemptDiv1Fr\" ng-show=\"lang === \'fr\'\"></div></div></span></div></div></div><div class=\"row info-banner-warning ng-hide\" data-ng-show=\"(attempts > 0 && attempts <= 4) && !errorSummary && !(submitted && (form.USER.$error.required || form.password.$error.required)) && !isLocked\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img src=\"ute-common-assets/assets/warning_yellow.png\" alt=\"\" role=\"presentation\" data-test-id=\"myr-signIn-warningYellowIcon\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" translate=\"sign_warning_msg_line_1\" data-test-id=\"myr-signIn-errorMessage1\"></span><p class=\"sign-error-line-2\" translate=\"sign_warning_msg_line_2\" data-test-id=\"myr-signIn-errorMessage2\"></p><div data-ng-show=\"(attempts > 0)\"><span class=\"sign-error-line-3\" translate=\"sign_warning_msg_line_3\" data-test-id=\"myr-signIn-errorMessage3\"></span><div id=\"boldChatDiv2_En\" class=\"attemptDiv2En\" ng-show=\"lang === \'en\'\"></div><div id=\"boldChatDiv2_Fr\" class=\"attemptDiv2Fr\" ng-show=\"lang === \'fr\'\"></div></div></span></div></div></div></div><div class=\"row info-banner-lock ng-hide\" data-ng-show=\"(attempts > 4 && attempts <= 5) && !errorSummary && !(submitted && (form.USER.$error.required || form.password.$error.required)) && !isLocked\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 pln prn\"><div class=\"col-xs-2 col-sm-1 col-lg-1 pln prn\"><img src=\"ute-common-assets/assets/warning.png\" data-test-id=\"myr-signIn-warningThirdIcon\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pln prn\"><span><span class=\"sign-error-line-1\" translate=\"sign_third_attempts_msg_line_1\" data-test-id=\"myr-signIn-errorMessageThird1\"></span><p class=\"sign-error-line-2\" translate=\"sign_third_attempts_msg_line_2\" data-test-id=\"myr-signIn-errorMessageThird2\"></p><div><span class=\"sign-error-line-3\" translate=\"sign_third_attempts_msg_line_3\" data-test-id=\"myr-signIn-errorMessageThird3\"></span><div id=\"boldChatDiv3_En\" class=\"attemptDiv3En\" ng-show=\"lang === \'en\'\"></div><div id=\"boldChatDiv3_Fr\" class=\"attemptDiv3Fr\" ng-show=\"lang === \'fr\'\"></div></div></span></div></div></div></div></div>");
$templateCache.put("scripts/directives/cartMenu/cartMenu.html","<div class=\"cartMenu\" ng-class=\"(isInactiveBan ? \'disableCart \':\'\') + \'\' + ((isConsumer || !isRepView)?\'consumerCartMenu\':\'\')\"><div ng-show=\"loadingImg\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading\" width=\"40px\"></div><div ng-hide=\"loadingImg && !content\"><consumer-cart-menu content=\"content\" ng-if=\"(isConsumer || !isRepView) && consumerCart && content\"></consumer-cart-menu><rep-cart-menu content=\"content\" ng-if=\"(isDealer || isCare) && permittedShopping && content\"></rep-cart-menu></div></div><ute-has-permission key=\"{{::interactionBRTSwitchName}}\" ng-if=\"(isDealer || isCare)\"><div class=\"col-notes\" style=\"position:relative\" ng-if=\"(!isConsumer)\"><ute-oneview-interaction-notes></ute-oneview-interaction-notes></div></ute-has-permission>");
$templateCache.put("scripts/directives/cartMenu/consumerCartMenu.html","<div class=\"orderList\" ng-show=\"totalOrders>0\" ng-mouseleave=\"clickedOrder = \'\'\"><div class=\"displayBrdr hidden-xs\"></div><div class=\"iconContainer\" tabindex=\"0\"><span class=\"color consumerView\">{{totalOrders}}</span> <img src=\"/web/totes/cms/images/cart-icon.png\" alt=\"cartIcon\" width=\"24px\" height=\"33px\" class=\"cartIcon\"></div><div class=\"showBg\" ng-if=\"totalOrders>0\"></div><ul class=\"dropdown dropdownMaxHeight\" ng-class=\"(totalOrders==0)?\'dropdown_noborder\':\'\'\"><li class=\"title_border order_title\" ng-if=\"orders.length>=1\"><span translate=\"_my_cart\"></span></li><li ng-repeat=\"order in orders track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(order.activityType,order.orderId,\'order\',order.assemblyIds[0], order);\"><div class=\"col-lg-1 col-xs-1\"><i class=\"rui-icon-wireless icon tazo-icon\"></i></div><div class=\"col-lg-10 col-xs-10 pdgLft\"><span class=\"cartTitle\" translate=\"{{order.activityType.toLowerCase()}}\"></span> <span ng-if=\"order.activityType.toLowerCase() != \'nac\'\"><span ng-repeat=\"ctn in order.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtn}}&nbsp;<span ng-if=\"order.assemblyIds.indexOf(ctn)<(order.assemblyIds.length-1)\">,&nbsp;</span></span></span></div><div class=\"col-lg-1 col-xs-1\"><img ng-hide=\"clickedOrder === order.orderId\" ng-click=\"cancelOrder($event, order.orderId)\" src=\"images/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder===order.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-class=\"$last && quotes.length == 0 ?\'\':\'btmBorder\'\"></div></li><li class=\"title_border order_title quote_title\" ng-if=\"quotes.length>=1\"><span translate=\"_saved_quotes\"></span></li><li ng-repeat=\"quote in quotes track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(quote.activityType,quote.orderId,\'quote\',quote.assemblyIds[0], quote);\"><i class=\"rui-icon-wireless icon tazo-icon\"></i></div><div class=\"col-lg-10 col-xs-10 pdgLft\"><span class=\"cartTitle\" translate=\"{{quote.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in quote.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtn}}&nbsp;<span ng-if=\"quote.assemblyIds.indexOf(ctn)<(quote.assemblyIds.length-1)\">,&nbsp;</span></span><div class=\"cartCtn\"><span translate=\"_quote\"></span><span>{{quote.orderId}}</span></div><div class=\"cartExpiry\"><span ng-show=\"quote.quoteExpired\" translate=\"_expired\"></span><span ng-hide=\"quote.quoteExpired\" translate=\"expires\"></span>&nbsp;&nbsp;<span ng-hide=\"quote.quoteExpired\">{{quote.quoteExpiryDate}}</span></div></div><div class=\"col-lg-1 col-xs-1\"><img ng-hide=\"clickedOrder === quote.orderId || !quote.quoteExpired\" ng-click=\"cancelOrder($event, quote.orderId)\" src=\"images/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder === quote.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></li></ul></div><div ng-class=\"$last?\'\':\'btmBorder\'\"></div>");
$templateCache.put("scripts/directives/cartMenu/repCartMenu.html","<div class=\"orderList\" ng-show=\"totalOrders>0\" ng-mouseleave=\"clickedOrder = \'\'\"><div class=\"iconContainer repView\"><span class=\"color\">{{totalOrders}}</span><img src=\"ute-common-assets/assets/shopping_cart_icon_red.png\" alt=\"cartIcon\" class=\"cartIcon\"></div><div class=\"showBg\" ng-if=\"totalOrders>0\"></div><ul class=\"dropdown col-lg-12\" ng-class=\"(totalOrders==0)?\'dropdown_noborder\':\'\'\"><li class=\"title_border order_title\" ng-if=\"quotes.length>=1\"><span translate=\"_saved_quotes\"></span></li><li ng-repeat=\"quote in quotes track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(quote.activityType,quote.orderId,\'quote\',quote.assemblyIds[0],quote);\"><div class=\"col-xs-11 rep-quote\"><span class=\"cartTitle\" translate=\"{{quote.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in quote.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtn}}&nbsp;<span ng-if=\"quote.assemblyIds.indexOf(ctn)<(quote.assemblyIds.length-1)\">,&nbsp;</span></span><div class=\"cartCtn\"><span translate=\"_quote\"></span><span>{{quote.orderId}}</span></div><div class=\"cartExpiry\"><span ng-show=\"quote.quoteExpired\" translate=\"_expired\"></span> <span ng-hide=\"quote.quoteExpired\" translate=\"expires\"></span>&nbsp;&nbsp; <span ng-hide=\"quote.quoteExpired\">{{quote.quoteExpiryDate}}</span></div></div><div class=\"col-xs-1 rep-quote-delete\"><img class=\"pull-right\" ng-hide=\"clickedOrder === quote.orderId || !quote.quoteExpired\" ng-click=\"cancelOrder($event, quote.orderId)\" src=\"images/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder===quote.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-class=\"$last && orders.length == 0?\'\':\'btmBorder\'\"></div></li><li class=\"title_border order_title quote_title\" ng-if=\"orders.length>=1\"><span translate=\"_my_cart\"></span></li><li ng-repeat=\"order in orders track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(order.activityType,order.orderId,\'order\',order.assemblyIds[0],order);\"><span class=\"cartTitle\" translate=\"{{order.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in order.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtn}}&nbsp; <span ng-if=\"order.assemblyIds.indexOf(ctn)<(order.assemblyIds.length-1)\">,&nbsp;</span></span> <img class=\"pull-right\" ng-hide=\"clickedOrder === order.orderId\" ng-click=\"cancelOrder($event, order.orderId)\" src=\"images/cart_delete_icon.png\" alt=\"delete_cart\"> <span class=\"pull-right\" data-ng-show=\"clickedOrder === order.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div><div ng-class=\"$last?\'\':\'btmBorder\'\"></div></li></ul></div>");
$templateCache.put("scripts/directives/confirmDialog/confirmDialog.html","<div class=\"page-layer z4\" ng-show=\"dialog.show\"><div class=\"plxl prxl radius txtL z5 response-dialog\"><div class=\"close-dialog close black desc-font-size-12\">X</div><div><h3 class=\"ptm inline-block\"><span class=\"message-banner-icon icon-{{dialog.icon}} prs\" data-ng-show=\"dialog.icon\"></span>{{dialog.title}}</h3></div><div class=\"ptm desc-font-size-14\" data-ng-show=\"dialog.message\"><span class=\"message-banner-icon icon-{{dialog.iconBody}} prs\" data-ng-show=\"dialog.iconBody\"></span> <span ng-bind-html=\"dialog.message\"></span><div ng-if=\"dialog.liveChatOptions\" need-help=\"\" data-cbid=\"dialog.liveChatOptions.boldChatButtonId\" data-cbid-fr=\"dialog.liveChatOptions.boldChatButtonIdFr\" data-dynamic-div=\"dialog.liveChatOptions.boldChatButtonDiv\" data-chat-button=\"dialog.liveChatOptions.boldChatButton\" data-chat-button-fr=\"dialog.liveChatOptions.boldChatButtonFr\" data-template-url=\"scripts/directives/needHelp/needHelpInline.html\" data-error-message=\"dialog.message\" data-lang=\"dialog.liveChatOptions.lang\"></div></div><div class=\"ptm txtR cta\"><button class=\"close-dialog cta-round {{option.type}} medium mll\" data-ng-repeat=\"option in dialog.buttons track by $index\" data-ng-click=\"option.action()\"><span class=\"inline-block plm prm\" translate=\"{{option.label}}\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/formChequing/formChequing.html","<div class=\"wrapper\" ng-if=\"showDebitForm\"><div class=\"row mtm mbm\"><div class=\"paynow-body-size\"><h3 class=\"mts mrs inline-block black\" translate=\"change_method_secure_debit\"></h3><img class=\"mbs\" src=\"images/lock.png\"><br><span class=\"title-light-h4\" translate=\"change_method_info_secure_debit\"></span>.</div></div><div class=\"row ptm\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.transitNo.$error\" ng-if=\"form.transitNo.$invalid && (form.transitNo.$dirty || form.$submitted)\"><span ng-message=\"required\"><span translate=\"change_method_invalid_transit_code\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"change_method_invalid_transit_code\" class=\"prm\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.bankCode.$error\" ng-if=\"form.bankCode.$invalid && (form.bankCode.$dirty || form.$submitted)\"><span ng-message=\"required\"><span translate=\"change_method_invalid_bank_code\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"change_method_invalid_bank_code\" class=\"prm\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"form.accountNo.$error\" ng-if=\"form.accountNo.$invalid && (form.accountNo.$dirty || form.$submitted)\"><span ng-message=\"required\"><span translate=\"change_method_invalid_account\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"change_method_invalid_account\" class=\"prm\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div></div><div class=\"row ptm\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"transitNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{5}$/\" id=\"transitNo\" maxlength=\"5\" placeholder=\"{{\'change_method_info_transit_code\' | translate}}\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"transitFocused=false;\" ng-focus=\"transitFocused=true;\" data-ng-model=\"chequingObj.transitNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"isCare || isDealer\"> <span ng-if=\"form.transitNo.$dirty && form.transitNo.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-show=\"( form.transitNo.$invalid && (form.transitNo.$dirty || form.$submitted))\"></span></label></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"bankCode\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{3}$/\" id=\"bankCode\" maxlength=\"3\" placeholder=\"{{\'change_method_info_bank_code\' | translate}}\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"bankFocused=false;\" ng-focus=\"bankFocused=true;\" data-ng-model=\"chequingObj.bankCode\" cobrowse=\"false\" required=\"\" ng-disabled=\"isCare || isDealer\"> <span ng-if=\"form.bankCode.$dirty && form.bankCode.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-if=\"( form.bankCode.$invalid && (form.bankCode.$dirty || form.$submitted))\"></span></label></div></div><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm\"><input data-tl-private=\"\" type=\"text\" name=\"accountNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{7,12}$/\" id=\"accountNo\" maxlength=\"12\" placeholder=\"{{\'change_method_account_number\' | translate}}\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"accountFocused=false;\" ng-focus=\"accountFocused=true;\" data-ng-model=\"chequingObj.accountNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"isCare || isDealer\"> <span ng-show=\"form.accountNo.$dirty && form.accountNo.$valid\" class=\"inline-checker icon-checked\"></span> <span class=\"inline-checker icon-error\" data-ng-if=\"( form.accountNo.$invalid && (form.accountNo.$dirty || form.$submitted))\"></span></label></div></div></div><div class=\"row\"><div class=\"hidden-xs\"><div class=\"mtl img-cheque\"><img id=\"overlay\" src=\"images/overlay_cheque_account.png\" data-ng-show=\"accountFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_bank.png\" data-ng-show=\"bankFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_transit.png\" data-ng-show=\"transitFocused\"></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><div class=\"mtl img-cheque-mobile\"><img class=\"default-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"!accountFocused && !bankFocused && !transitFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"accountFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_bank_s.jpg\" data-ng-show=\"bankFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_transit_s.jpg\" data-ng-show=\"transitFocused\"></div></div></div><div class=\"row\"><h3 class=\"ptm pbm black\" translate=\"change_method_terms_debit\"></h3><div><div translate=\"change_method_terms\" class=\"desc-font-size-12 radius textarea_legal pam\" style=\"overflow-y: auto; height:200px\"></div><div class=\"inline_error accept-error\" ng-messages=\"form.isAccepted.$error\" ng-if=\"form.isAccepted.$invalid && form.$submitted\"><span class=\"fa fa-exclamation-circle\"></span> <span ng-message=\"required\"><span translate=\"change_method_not_accepted\" class=\"mbs\"></span><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"form.isAccepted.$invalid && form.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" ng-model=\"isAccepted\" ng-disabled=\"isCare || isDealer\" required=\"\"></span> <span class=\"bold desc-font-size-18\" translate=\"change_method_accept\"></span></div></div></div></div>");
$templateCache.put("scripts/directives/infoDialogModal/infoDialogModal.html","<div class=\"info-dialog-modal\"><div class=\"info-modal-content\"><button aria-label=\"{{ \'close\' | translate }}\" title=\"{{ \'close\' | translate }}\" ng-click=\"close()\" class=\"info-dialog-modal-close\"><i class=\"rui-icon-mobile-menu-exit\"></i></button><ng-include src=\"templateHtml\"></ng-include></div></div>");
$templateCache.put("scripts/directives/liveChat/liveChat.html","<div class=\"row mbm\" style=\"margin-top:40px\"><div style=\"background-color: #dddddd; height:1px; width:100%;position: absolute;left: 0;\"></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\" style=\"margin-top:25px\"><h3 class=\"primary-color\" translate=\"link_account_need_help\">Need Help?xxx</h3><img src=\"images/live-chat.png\"> <a class=\"live-chat-link\" href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701 target=\'_blank\'\" target=\"_blank\"><span translate=\"mu_chat\">Live Chat</span></a></div></div>");
$templateCache.put("scripts/directives/messageInfoBox/messageInfoBox.html","<div class=\"info-box\" ng-bind-html=\"infoMessage\"></div>");
$templateCache.put("scripts/directives/myOffers/myOffers.html","<div class=\"directive-my-offers\" id=\"myOffers\"><div class=\"myr_myoffers_wrap\"><div class=\"myr_myoffers_wrap-left\" data-ng-hide=\"isCare || isDealer\"><div ng-if=\"wirelessimage===true\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/banners/banner_wireless/banner_wireless\"></ute-content-injector></div><div ng-if=\"nonwirelessimage===true\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/banners/banner_top/banner_top\"></ute-content-injector></div></div><div class=\"myr_myoffers_wrap-right\" ng-hide=\"isCare\" data-ng-hide=\"hideRevBanner\"><ute-content-injector language=\"{{lang}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/banners/banner_bottom/banner_bottom\"></ute-content-injector></div></div><div style=\"display: none;\"><form name=\"formToRogersSim\" id=\"formToRogersSim\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpkgclientban\" name=\"changeSimBAN\"><br><input type=\"text\" data-ng-value=\"wpkgclientctn\" name=\"changeSimCTN\"><br><input type=\"text\" value=\"SMART_PHONE\" name=\"simFlowType\"><br></form></div></div>");
$templateCache.put("scripts/directives/myserviceaddbadge/add-badge-modal.html","<div class=\"totes-project\"><div class=\"add-badge-modal\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ctrl.close()\"><img src=\"ute-common-assets/assets/cross-grey.png\"></button><h3 class=\"modal-title\"><span translate=\"addServices_addServices_modal_title\"></span></h3></div><div class=\"modal-body\"><span translate=\"{{\'oneview_\'+ctrl.badgeTitle}}\"></span></div></div></div>");
$templateCache.put("scripts/directives/myserviceaddbadge/ignite-missing-info-modal.html","<div class=\"totes-project\"><div class=\"ignite-error-modal\"><div class=\"modal-header\"><span class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ctrl.close()\"><img src=\"images/close.png\"></span><div class=\"modal-title\"><img class=\"oneview-access-icon\" src=\"images/error_icon.png\"> <span ng-hide=\"ctrl.contactInfoMissing.error\" translate=\"ignite_customer_information_missing\"></span> <span ng-show=\"ctrl.contactInfoMissing.error\" translate=\"_error\"></span></div></div><div class=\"modal-body\"><div ng-hide=\"ctrl.contactInfoMissing.error\"><div translate=\"ignite_nac_contact_info_missing\"></div><ul><li ng-show=\"ctrl.contactInfoMissing.missingFirstName\" translate=\"ignite_missing_info_first_name\"></li><li ng-show=\"ctrl.contactInfoMissing.missingLastName\" translate=\"ignite_missing_info_last_name\"></li><li ng-show=\"ctrl.contactInfoMissing.missingPhoneNumber\" translate=\"ignite_missing_info_phone_number\"></li><li ng-show=\"ctrl.contactInfoMissing.missingEmail\" translate=\"ignite_missing_info_email\"></li><li ng-show=\"ctrl.contactInfoMissing.missingLangPref\" translate=\"ignite_missing_info_language_pref\"></li></ul></div><div class=\"ignite_nac_contact_info_error\" ng-show=\"ctrl.contactInfoMissing.error\"><div translate=\"ignite_nac_generic_error\"></div></div><button ng-click=\"ctrl.close()\"><span translate=\"_ok\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/myserviceaddbadge/myserviceaddbadge.html","<div class=\"myserviceaddbadge\" ng-class=\"{true: \'clickable\', false:\'nonClickable\'}[isClickable()]\" ng-if=\"isVisible\"><div class=\"badge\" ng-click=\"openWindow(title, $event)\" onmouseover=\"this.title=\'\';\" tabindex=\"0\"><div class=\"opacityLayer\"></div><div class=\"badge-icon\"><i class=\"{{::icon}}\"></i> <img ng-if=\"imageIcon\" ng-src=\"images/{{ imageIcon }}.svg\" class=\"myr-{{ imageIcon }}\"></div><div class=\"badge-textContainer\"><div class=\"badge-text\" translate=\"{{title}}\"></div></div><div class=\"badge-arrow\"><i class=\"my-icon\"><i></i></i></div><div class=\"smallArrow\"><span class=\"redCircle\">+</span></div></div></div>");
$templateCache.put("scripts/directives/myservicebadge/myservicebadge.html","<div class=\"myservicebadge\"><md-tooltip ng-if=\"::subType == \'CTN\'\" md-direction=\"top\">{{::firstName}} {{::lastName}}</md-tooltip><div class=\"badge {{::variation}}\" onmouseover=\"this.title=\'\';\"><label><div class=\"badge-hover\" tabindex=\"0\"></div><div class=\"badge-icon\"><i class=\"{{::icon}}\"></i> <img data-ng-if=\"::imageIcon\" data-ng-src=\"images/{{ ::imageIcon }}.png\" class=\"myr-{{ ::imageIcon }}\"></div><div class=\"badge-text\"><div class=\"badge-textContainer\"><span class=\"badgeTextHolder\" ng-if=\"::subType == \'CTN\'\">{{::firstName}}</span> <span class=\"badgeTextHolder\" ng-if=\"!(subType == \'CTN\')\" translate=\"{{serviceType}}\"></span> <span class=\"badgeTextPhone\" ng-if=\"::showPhone == \'true\'\">{{::serviceDetail | phone}}</span><div class=\"badgeTextAddress\" ng-if=\"!(subType == \'CTN\')\">{{::serviceAddress}}</div></div></div><div class=\"badge-arrow\"><i class=\"my-icon\"><i></i></i><div class=\"smallArrow\" ng-if=\"!(serviceName===\'homephone\' && isRepView == \'true\')\"><i class=\"rui-icon-button-arrow-right\"></i><div ng-if=\"serviceName===\'homephone\'\"><span class=\"screen-read-only\">{{label}}</span></div></div><div class=\"linkMsg\" ng-if=\"serviceName===\'homephone\' && isRepView == \'true\'\"><strong><span aria-hidden=\"true\" translate=\"sgi\"></span></strong></div></div></label><div class=\"badgeList-offer\" data-ng-if=\"heroDetails[serviceDetail].hup4BPO || heroDetails[serviceDetail].hupOffer || heroDetails[serviceDetail].tvmBPO || heroDetails[serviceDetail].tvmOffer || heroDetails[serviceDetail].standAloneBPO\"><img class=\"badgeList-promo\" src=\"/web/totes/cms/images/promo.png\"> <span class=\"badgeList-exclusive-offer\" translate=\"exclusive_offer\"></span></div></div><div class=\"numberList {{::variation}}\"><div class=\"oneLine\"><div class=\"userColor\" style=\"background-color: #008FB6;\"></div><div class=\"serviceIcon\"><i class=\"rui-icon-wireless\"></i></div><div class=\"userAndCtn\">Adam, 416 123-4567</div><div class=\"arrowRight rui-icon-button-arrow-right\"></div></div><div class=\"oneLine\"><div class=\"userColor\" style=\"background-color: #E4BC40;\"></div><div class=\"serviceIcon\"><i class=\"rui-icon-wireless\"></i></div><div class=\"userAndCtn\">Adam, 416 123-4567</div><div class=\"arrowRight rui-icon-button-arrow-right\"></div></div><div class=\"oneLine\"><div class=\"userColor\" style=\"background-color: #662D91;\"></div><div class=\"serviceIcon\"><i class=\"rui-icon-wireless\"></i></div><div class=\"userAndCtn\">Adam, 416 123-4567</div><div class=\"arrowRight rui-icon-button-arrow-right\"></div></div></div></div>");
$templateCache.put("scripts/directives/myservicebadgeGroup/myservicebadgeGroup.html","<div class=\"myservicebadgeGroup\"><h2 class=\"myservicebadgeGroup-title\" translate=\"{{::\'share_everything_\'+grouptype}}\">Group Title</h2><div class=\"account-overview-eop-badge serviceBadgeGroup\" data-ng-if=\"grouptype == \'residential\' && $root.eopOfferToShowBadge && $root.eopOfferToShowBadge.hasHideOffer\"><a href=\"javascript:void(0)\" ng-click=\"$parent.$parent.eopRedirectToPage()\" aria-label=\"{{($root.eopOfferToShowBadge.offerType !== \'recommended\' ? \'EOP.CTAS.PROMOTION_OFFER_BADGE.ALT\' : \'EOP.CTAS.RECOMMENDED_OFFER_BADGE.ALT\') |translate}}\"><img class=\"star\" aria-hidden=\"true\" src=\"/web/totes/cms/images/page-specific/eop/star_3x.png\"><span ng-if=\"$root.eopOfferToShowBadge.isLegacy\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.PROMOTION_OFFER_BADGE.LABEL\"></span> <span ng-if=\"!$root.eopOfferToShowBadge.isLegacy\"><span ng-switch=\"$root.eopOfferToShowBadge.offerType\"><span ng-switch-when=\"recommended\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.RECOMMENDED_OFFER_BADGE.LABEL\"></span> <span ng-switch-default=\"\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.PROMOTION_OFFER_BADGE.LABEL\"></span></span></span></a></div><section ng-if=\"grouptype != \'addServices\'\"><div class=\"accountOverview-myServiceBadgeGroupContainer\"><div ng-repeat=\"msl in myrMyServicesService.categorizedServices[grouptype] | filter: notInDataManager track by $index | orderBy:\'sortOrder\'\"><ute-subscription-badge ng-if=\"msl.subscriptionBadgeModule\" ute-subscription-badge-attr-model=\"msl\"></ute-subscription-badge><div ng-if=\"!msl.subscriptionBadgeModule\" class=\"myservicebadgeGroup-clickArea\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled && !(isCare && msl.disabled))? runService(msl.serviceName, msl.serviceDetail) : \'\'\" ng-class=\"{\'pointer\':(btnSettings.allSubscriptions !== btnStatus.disabled), \'no-hover-pointer\':((isDealer || isCare) && msl.serviceName===\'homephone\') || (isCare && msl.disabled), \'shm-disabled\': (isCare && msl.disabled)}\" ,=\"\" tabindex=\"-1\"><myservicebadge variation=\"{{::badgeType}}\" accountnumber=\"{{::msl.accountNumber}}\" firstname=\"{{::msl.firstName}}\" lastname=\"{{::msl.lastName}}\" icon=\"{{::msl.icon}}\" image-icon=\"{{::msl.imageIcon}}\" linktext=\"{{::msl.linkText}}\" linkurl=\"{{::msl.linkURL}}\" paramname=\"{{::msl.paramName}}\" servicedetail=\"{{::msl.serviceDetail}}\" servicename=\"{{::msl.serviceName}}\" servicetype=\"{{::msl.serviceType}}\" showphone=\"{{::msl.showPhone}}\" subtype=\"{{::msl.subType}}\" isdealer=\"{{::isDealer}}\" iscare=\"{{::isCare}}\" serviceaddress=\"{{::msl.serviceAddress}}\"></myservicebadge></div></div></div></section><section ng-if=\"grouptype == \'addServices\'\"><div class=\"row\"><div class=\"col-md-4 col-sm-6 col-xs-12 myServiceBadgeGroupContainer\" ng-repeat=\"mso in myrMyServicesService.myOtherServicesListFinal | filter: isVisible track by $index\"><myserviceaddbadge ng-if=\"!mso.goTo || mso.allowGoto\" addlang=\"{{::mso.addLang}}\" addlangroute=\"{{::mso.addLangRoute}}\" idname=\"{{::mso.id}}\" isvisible=\"{{::mso.isVisible}}\" langfirstparam=\"{{::mso.langFirstParam}}\" langparametername=\"{{::mso.langParameterName}}\" link=\"{{::mso.link}}\" title=\"{{::mso.title}}\" updategamecentrelive=\"{{::mso.updategamecentrelive}}\" icon=\"{{::mso.icon}}\" image-icon=\"{{::mso.imageIcon}}\" goto=\"mso.goto\" allowgoto=\"mso.allowGoto\" isrepview=\"{{isrepview}}\" isdealer=\"{{::isDealer}}\" iscare=\"{{::isCare}}\" serviceaddress=\"{{::msl.serviceAddress}}\"></myserviceaddbadge></div></div></section></div>");
$templateCache.put("scripts/directives/needHelp/needHelp.html","<div class=\"need-help-box\"><h2 class=\"need-help-help-text\" translate=\"{{needHelpTextKey}}\">Need Help?xxx</h2><div class=\"overrite-margin\"><bold-chat-static-button cbid=\"{{cbid}}\" dynamic-div=\"{{boldChatDiv}}\" chat-button=\"{{chatButton}}\" error-message=\"{{errorMessage}}\" alt-text=\"{{altText}}\"></bold-chat-static-button></div></div>");
$templateCache.put("scripts/directives/needHelp/needHelpForgotUsername.html","<div class=\"need-help-box\"><h2 class=\"need-help-help-text\" translate=\"{{needHelpTextKey}}\">Need Help?xxx</h2><div class=\"overrite-margin\"><div id=\"{{boldChatDiv}}\"></div></div></div>");
$templateCache.put("scripts/directives/needHelp/needHelpInline.html","<div class=\"need-help-inline\"><span class=\"need-help-help-text-1\" translate=\"link_account_need_help\"></span><div class=\"need-help-live-chat-1\"><bold-chat-static-button cbid=\"{{cbid}}\" dynamic-div=\"{{boldChatDiv}}\" chat-button=\"{{chatButton}}\" error-message=\"{{errorMessage}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div>");
$templateCache.put("scripts/directives/optionsDialog/optionsDialog.html","<div class=\"page-layer layer-hide z4\"><div class=\"center-all radius z5 option-dialog\"><div class=\"ptm pbm\">{{title}}</div><div class=\"pbm\" ng-bind-html=\"message\"></div><div class=\"txtC cta\"><button class=\"close inline-block cta-round primary medium mll\" data-ng-repeat=\"option in options track by $index\" data-ng-click=\"option.action()\"><span class=\"inline-block plm prm\" translate=\"_continue\"></span></button></div></div></div>");
$templateCache.put("scripts/directives/otherservices/otherservices.html","<div class=\"row directive-other-services\" id=\"myOtherServicesListFinal\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-repeat=\"msl in myOtherServicesListFinal track by $index\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a data-ng-class=\"btnSettings.otherAvailableServices === btnStatus.disabled ? \'not-active\' : \'\'\" href=\"\"><h5 class=\"get-services-link\"><span class=\"greater-than\"><span class=\"get-services-txt\" translate=\"{{msl.title}}\"></span></span></h5><span class=\"rui-icon-button-arrow-right\"></span></a></div></div></div></div>");
$templateCache.put("scripts/directives/pageHeadline/pageHeadline.html","<div class=\"page-headline\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 ng-bind-html=\"pageHeadline.text\"></h1></div></div></div></div>");
$templateCache.put("scripts/directives/paymentHelper/paymentHelper.html","<div class=\"module-payment-helper\"><div class=\"container\"><div class=\"row\"><h2 class=\"bottom-logo-ctn\" translate=\"need_help_with_your_bill\"></h2><div class=\"bottom-btn-ctn\"><div class=\"btn-register\"><a class=\"cta-round secondary medium full\" href=\"https://www.rogers.com/web/content/support?N=42+134\" target=\"_blank\"><span class=\"register-now\" translate=\"visit_billing_support\"></span> <span class=\"rui-icon-button-arrow-right\"></span></a></div></div><div class=\"payment-review-ctn\"><a href=\"{{reviewLink}}\" target=\"_blank\"><span class=\"talk-to-us-txt\" translate=\"paynow_faq\">Talk to us now</span> <span class=\"rui-icon-button-arrow-right\"></span></a></div><div class=\"talk-to-us-ctn\"><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></bold-chat-static-button></div></div></div></div>");
$templateCache.put("scripts/directives/privateBrowsing/privateBrowsingWarning.html","<div class=\"totes-project\" ng-cloak=\"\"><div id=\"dvPrivateBrowsingWarning\" ng-if=\"privateBrowsingOn\" class=\"container-fluid privateBrowsingMsg\"><div class=\"row\"><div class=\"container\"><div class=\"col-xs-2 col-sm-1 col-md-1 col-lg-1\"><img src=\"ute-common-assets/assets/warning_yellow.png\" alt=\"\"></div><div class=\"col-xs-10 col-sm-11 col-md-11 col-lg-11\" translate=\"private_browsing_warning_msg\"></div></div></div></div></div>");
$templateCache.put("scripts/directives/registrationArea/registrationArea.html","<div class=\"registration-area-box\"><h2 class=\"register-myrogers\" translate=\"mu_registration_lg_new\"></h2><p translate=\"mu_registration_line\"></p><ul><li translate=\"mu_registration_list_1\"></li><li translate=\"mu_registration_list_2\"></li><li translate=\"mu_registration_list_3\"></li></ul><a class=\"registration-area-text-sm btn btn-default\" translate=\"mu_registration_sm\" data-ng-click=\"register()\" role=\"button\" ng-keypress=\"keyPressRegister($event)\" data-test-id=\"myr-registrationArea-registerNow\" tabindex=\"0\"></a></div>");
$templateCache.put("scripts/directives/revolution/revolution.html","<div class=\"row mbl\" id=\"dirRevolution\"><div class=\"widget-loader\" data-ng-if=\"loadingDataIndicatorRev\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div class=\"row\" data-ng-if=\"isConsumer && errorMessageR && !(isPageWireless && !hideWirelessTravelPackage)\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessageR\"></validation-error-box></div></div></div><div class=\"row\" ng-hide=\"isCare\" data-ng-if=\"!loadingDataIndicatorRev\"><div class=\"col-lg-{{6+shiftBigCols}} col-md-{{6+shiftBigCols}} col-sm-{{shiftSmColsOut}} col-xs-12 prs\" data-ng-if=\"(isNetflixEligible )|| ( activeOffers.length >0 && !isSegment0() ) || (isPageWireless && !hideWirelessTravelPackage && travelPackageDataHasPlan && !isSegment0())\"><div class=\"row\"><div class=\"no-left-border xs-12\"><div class=\"rui-heading secondary\"><h3 tabindex=\"0\"><span ng-show=\"!spotifyph3\" translate=\"revo_included\"></span> <span ng-show=\"spotifyph3\" translate=\"revo_included_ph3\"></span></h3></div></div></div><div class=\"row\"><div ng-if=\"isPageWireless && hideWirelessTravelPackage === false && travelPackageDataHasPlan && !isSegment0()\" class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} col-sm-{{shiftSmColsInL}} col-xs-12 pls prs widgit-outer-en-roamlikehome\"><div data-ng-if=\"!hideOldRLH\"><div class=\"roam-ctn paddingTop5\" data-ng-if=\"lang === \'en\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-EN-HD-desktop.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-EN-HD-mobile.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"></div><div class=\"roam-ctn paddingTop5\" data-ng-if=\"lang === \'fr\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-FR-HD-desktop.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-FR-HD-mobile.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"></div></div><div data-ng-if=\"!hideNewRLH\"><div class=\"roam-ctn\" data-ng-if=\"lang === \'en\'\"><img class=\"visible-lg visible-md visible-sm pbs\" src=\"images/Roam-Like-Home-EN.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/Roam-Like-Home-EN.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"></div><div class=\"roam-ctn\" data-ng-if=\"lang === \'fr\'\"><img class=\"visible-lg visible-md visible-sm pbs\" src=\"images/Roam-Like-Home-FR.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/Roam-Like-Home-FR.png\" alt=\"{{\'roam_like_home\' | translate}}\" tabindex=\"0\"></div></div><div class=\"roaming mbs mrs visible-lg visible-md visible-sm hidden-xs\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><span translate=\"use_your_phone_like_you_do_at_home\" data-ng-if=\"!hideOldRLH\"></span> <span translate=\"rlh_use_your_phone_like_you_do_at_home\" data-ng-if=\"!hideNewRLH\"></span> <span data-ng-if=\"lang === \'en\'\">${{travelPackageData.us.en.price}}{{travelPackageData.us.en.per.value| escapeHtml}}</span> <span data-ng-if=\"lang === \'fr\'\">{{travelPackageData.us.fr.price}} $ {{travelPackageData.us.fr.per.value| escapeHtml}}</span> <span translate=\"in_the_us\"></span> <span data-ng-if=\"lang === \'en\'\">${{travelPackageData.common.en.price}}{{travelPackageData.common.en.per.value}}</span> <span data-ng-if=\"lang === \'fr\'\">{{travelPackageData.common.fr.price}} $ {{travelPackageData.common.fr.per.value}}</span> <span translate=\"in_other_countries\"></span> <sup class=\"roaming-legal\" data-ng-if=\"lang === \'en\'\" ng-repeat=\"legal in travelPackageData.common.en.per.legal track by $index\"><span ng-click=\"openWirelessTravelPackageLegalContentModalLocal()\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup> <sup class=\"roaming-legal\" data-ng-if=\"lang === \'fr\'\" ng-repeat=\"legal in travelPackageData.common.fr.per.legal track by $index\"><span ng-click=\"openWirelessTravelPackageLegalContentModalLocal()\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup></div><div ng-if=\"isRepView && (isDealer || isCare) && unEnrollPermission\"><a class=\"widgit-inner cta-round primary medium full red-button white-button\" translate=\"opt_out_rlh_enroll\" ng-click=\"unEnrollPackageModal()\"></a></div><div data-ng-if=\"!hideNewRLH\"><div ng-if=\"travelPackageDataHasPlan === false && unEnrollPermission === false\"><a class=\"widgit-inner cta-round primary medium full red-button\" ng-click=\"openWirelesePackageModal()\"><span translate=\"activate_now\"></span></a></div><div ng-if=\"travelPackageDataHasPlan === true && unEnrollPermission === false\"><div class=\"blue-container sm-container\"><div class=\"row\"><div class=\"col-sm-1 col-xs-1\"><i class=\"rui-icon-info\"></i></div><div class=\"col-sm-11 col-xs-11\"><p translate=\"ensure_roaming_is_on\"></p></div></div></div></div></div><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><a class=\"learn headline6-bold details col-xs-12\" target=\"_blank\" href=\"/consumer/wireless/travel\" data-ng-if=\"!(isDealer || isCare || lang !== \'en\')\"><span class=\"hidden-xs\" translate=\"learn_more\"><span class=\"rui-icon-button-arrow-right\"></span></span> <span class=\"visible-xs\" translate=\"learn_more_about_Roam_Like_Home\"><span class=\"rui-icon-button-arrow-right\"></span></span></a> <a class=\"learn headline6-bold details col-xs-12\" target=\"_blank\" href=\"/consumer/wireless/travel\" data-ng-if=\"!(isDealer || isCare || lang !== \'fr\')\"><span translate=\"learn_more\"><span class=\"rui-icon-button-arrow-right\"></span></span></a><div class=\"visible-xs grey-line col-xs-12\">&nbsp;</div></div><div ng-repeat=\"valueAddedOffer in activeOffers | orderBy : \'-isFree\'\" ng-if=\"isConsumer && valueAddedOffer.id === \'netflix\'\" class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} col-sm-{{shiftSmColsInL}} col-xs-12 pls prs widgit-outer-en-roamlikehome\"><div><img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"visible-lg visible-md visible-sm pts pbs img-size\" ng-class=\"valueAddedOffer.id + \'-image\'\" alt=\"{{valueAddedOffer.offerDetails[0].altText}}\" tabindex=\"0\"> <img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrlmb}}\" class=\"visible-xs img-size-mb\" ng-class=\"valueAddedOffer.id + \'-image\'\" alt=\"{{valueAddedOffer.offerDetails[0].altText}}\" tabindex=\"0\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\" ng-bind-html=\"spotifyph3 ? valueAddedOffer.offerDetails[0].offerDesc2 : valueAddedOffer.offerDetails[0].offerDesc\"></div><button class=\"widgit-inner cta-round primary medium full red-button\" ng-class=\"( valueAddedOffer.id !== \'nextissue\' && valueAddedOffer.id !== \'spotify\' && valueAddedOffer.id !== \'netflix\' ) ? \'white-button\' : \'\'\" ng-click=\"startOffer(valueAddedOffer.id, valueAddedOffer.revSpUrl)\" data-ng-disabled=\"disableRevButtons\" tabindex=\"0\"><span style=\"text-transform: none\">{{spotifyph3 ? valueAddedOffer.offerDetails[0].messageMap.buttonLabel2 : valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span> <i ng-show=\"loadingSpinIcon && valueAddedOffer.id == \'netflix\'\" class=\"fa fa-circle-o-notch fa-spin\"></i></button><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div data-ng-if=\"isConsumer && valueAddedOffer.swappable\" class=\"headline6-bold details\" ng-click=\"changeSelection(valueAddedOffer.id)\"><span translate=\"revo_change_selection\"></span> <span class=\"rui-icon-button-arrow-right mls\"></span></div><div data-ng-if=\"isConsumer && valueAddedOffer.swappableDate\" class=\"headline6 change-sel\">{{valueAddedOffer.swappableDate}}</div><div class=\"visible-xs grey-line\">&nbsp;</div></div></div></div><div ng-if=\"!isSegment0()\" class=\"col-lg-{{6-shiftBigCols}} col-md-{{6-shiftBigCols}} col-sm-{{12-shiftSmColsOut}} col-xs-12\" ng-class=\"showMargin?\'value-added-margin\':\'pls no-left-border\'\" data-ng-if=\"(inactiveOffers.length>0 && isChooseYorExperienceVisible) || (isPageWireless && !hideWirelessTravelPackage && !travelPackageDataHasPlan)\" style=\"float:right\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"rui-heading secondary\"><h2 tabindex=\"0\"><span translate=\"revo_value_add\"></span></h2></div></div></div><div class=\"row\"><div ng-if=\"isPageWireless && hideWirelessTravelPackage === false && !travelPackageDataHasPlan\" class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} col-sm-{{shiftSmColsInL}} col-xs-12 pls prs widgit-outer-en-roamlikehome\"><div data-ng-if=\"!hideOldRLH\"><div class=\"roam-ctn paddingTop5\" data-ng-if=\"lang === \'en\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-EN-HD-desktop.png\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-EN-HD-mobile.png\" tabindex=\"0\"></div><div class=\"roam-ctn paddingTop5\" data-ng-if=\"lang === \'fr\'\"><img class=\"visible-lg visible-md visible-sm pbs img-size\" src=\"images/RoamON-FR-HD-desktop.png\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/RoamON-FR-HD-mobile.png\" tabindex=\"0\"></div></div><div data-ng-if=\"!hideNewRLH\"><div class=\"roam-ctn\" data-ng-if=\"lang === \'en\'\"><img class=\"visible-lg visible-md visible-sm pbs\" src=\"images/Roam-Like-Home-EN.png\" alt=\"Roam Like Home\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/Roam-Like-Home-EN.png\" alt=\"Roam Like Home\" tabindex=\"0\"></div><div class=\"roam-ctn\" data-ng-if=\"lang === \'fr\'\"><img class=\"visible-lg visible-md visible-sm pbs\" src=\"images/Roam-Like-Home-FR.png\" alt=\"Partout chez vous\" tabindex=\"0\"> <img class=\"visible-xs pbs img-size\" src=\"images/Roam-Like-Home-FR.png\" alt=\"Partout chez vous\" tabindex=\"0\"></div></div><div class=\"roaming mbs mrs visible-lg visible-md visible-sm hidden-xs\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\"><span translate=\"use_your_phone_like_you_do_at_home\" data-ng-if=\"!hideOldRLH\"></span> <span translate=\"rlh_use_your_phone_like_you_do_at_home\" data-ng-if=\"!hideNewRLH\"></span> <span data-ng-if=\"lang === \'en\'\">${{travelPackageData.us.en.price}}{{travelPackageData.us.en.per.value| escapeHtml}}</span> <span data-ng-if=\"lang === \'fr\'\">{{travelPackageData.us.fr.price}} $ {{travelPackageData.us.fr.per.value| escapeHtml}}</span> <span translate=\"in_the_us\"></span> <span data-ng-if=\"lang === \'en\'\">${{travelPackageData.common.en.price}}{{travelPackageData.common.en.per.value}}</span> <span data-ng-if=\"lang === \'fr\'\">{{travelPackageData.common.fr.price}} $ {{travelPackageData.common.fr.per.value}}</span> <span translate=\"in_other_countries\"></span> <sup class=\"roaming-legal\" data-ng-if=\"lang === \'en\'\" ng-repeat=\"legal in travelPackageData.common.en.per.legal track by $index\"><span ng-click=\"openWirelessTravelPackageLegalContentModalLocal()\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup> <sup class=\"roaming-legal\" data-ng-if=\"lang === \'fr\'\" ng-repeat=\"legal in travelPackageData.common.fr.per.legal track by $index\"><span ng-click=\"openWirelessTravelPackageLegalContentModalLocal()\">{{legal.label}}</span> <span class=\"roaming-legal-content\" ng-bind-html=\"renderHTML(legal.content)\"></span></sup></div><div><a class=\"widgit-inner cta-round primary medium full red-button\" translate=\"activate_now\" ng-click=\"openWirelesePackageModal()\"></a></div><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><a class=\"learn headline6-bold details col-xs-12\" target=\"_blank\" href=\"/consumer/wireless/travel\" data-ng-if=\"!(isDealer || isCare || lang !== \'en\')\"><span class=\"hidden-xs\" translate=\"learn_more\"><span class=\"rui-icon-button-arrow-right\"></span></span> <span class=\"visible-xs\" translate=\"learn_more_about_Roam_Like_Home\"><span class=\"rui-icon-button-arrow-right\"></span></span></a> <a class=\"learn headline6-bold details col-xs-12\" target=\"_blank\" href=\"/consumer/wireless/travel\" data-ng-if=\"!(isDealer || isCare || lang !== \'fr\')\"><span translate=\"learn_more\"><span class=\"rui-icon-button-arrow-right\"></span></span></a><div class=\"visible-xs grey-line col-xs-12\">&nbsp;</div></div><div class=\"col-lg-{{numberRightCols}} col-md-{{numberRightCols}} col-sm-{{shiftSmColsInR}} col-xs-12 prs widgit-outer-right widgit-outer-en-roamlikehome\" ng-repeat=\"valueAddedOffer in inactiveOffers track by $index\"><div ng-if=\"isPageWireless && !hideWirelessTravelPackage\" class=\"visibilityHidden\"><div class=\"roam-ctn\"><span class=\"you-have-this-ctn\" data-ng-if=\"travelPackageDataHasPlan\">&nbsp;</span></div></div><div class=\"rev-inactive-offers-top-image\"><img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"visible-lg visible-md visible-sm pts img-size\" ng-class=\"valueAddedOffer.id + \'-image\'\" alt=\"{{valueAddedOffer.offerDetails[0].altText}}\" tabindex=\"0\"> <img ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrlmb}}\" class=\"visible-xs img-size-mb\" ng-class=\"valueAddedOffer.id + \'-image\'\" alt=\"{{valueAddedOffer.offerDetails[0].altText}}\" tabindex=\"0\"></div><div class=\"mbs mrs visible-lg visible-md visible-sm\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\">{{valueAddedOffer.offerDetails[0].offerDesc}}</div><button ng-click=\"getOffer(valueAddedOffer.id)\" class=\"widgit-inner cta-round primary medium full red-button\" ng-disabled=\"disableRevButtons\" tabindex=\"0\"><span>{{spotifyph3 ? valueAddedOffer.offerDetails[0].messageMap.buttonLabel2 : valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span></button><div class=\"visible-lg visible-sm visible-md grey-line\">&nbsp;</div><div class=\"headline6-bold\">&nbsp;</div><div class=\"visible-xs grey-line\">&nbsp;</div></div></div></div></div></div>");
$templateCache.put("scripts/directives/revolution/revyouhave.html","<div class=\"col-lg-{{6+shiftBigCols}} col-md-{{6+shiftBigCols}} col-sm-12 col-xs-12 prs\" ng-show=\"activeOffers.length>0\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col xs-12\"><div class=\"rui-heading secondary\"><h3><span translate=\"revo_included\"></span></h3></div></div></div><div class=\"row\"><div class=\"col-lg-{{numberInnerCols}} col-md-{{numberInnerCols}} widgit-outer-en col-sm-6 col-xs-6 pls prs\" ng-repeat=\"valueAddedOffer in activeOffers | orderBy : \'-isFree\' track by $index\"><div class=\"headline6 free-empty-div\"><span ng-show=\"valueAddedOffer.isFree\"><span class=\"primary\" translate=\"revo_free\"></span> <span>{{valueAddedOffer.isFreeLabel}}</span></span></div><div><img width=\"100%\" ng-src=\"{{valueAddedOffer.offerDetails[0].logoUrl}}\" class=\"pts pbs\"></div><div class=\"mbs mrs\" ng-class=\"lang === \'fr\' ? \'headline6\' : \'title-h5\'\">{{valueAddedOffer.offerDetails[0].offerDesc}}</div><button class=\"widgit-inner cta-round primary medium full white-button\" ng-class=\"lang === \'fr\' ? \'fr-buttons\' : \'\'\" ng-click=\"getOffer(valueAddedOffer.id)\"><span>{{valueAddedOffer.offerDetails[0].messageMap.buttonLabel}}</span></button><div class=\"grey-line\">&nbsp;</div><div ng-show=\"isConsumer && valueAddedOffer.swappable\" class=\"headline6-bold details\" ng-click=\"changeSelection(valueAddedOffer.id)\"><span translate=\"revo_change_selection\"></span> <span class=\"rui-icon-button-arrow-right mls\"></span></div><div ng-show=\"isConsumer && valueAddedOffer.swappableDate\" class=\"headline6 change-sel\">{{valueAddedOffer.swappableDate}}</div></div></div></div>");
$templateCache.put("scripts/directives/ruiDropdown/ruiDropdown.html","<div class=\"dropdown-container\" ng-class=\"{ show: listVisible }\"><div class=\"dropdown-display\" ng-click=\"toggle();\" ng-class=\"{ clicked: listVisible }\"><span ng-if=\"!isPlaceholder\">{{ filter ? (useFilter(filter,display)) : display }}</span> <span class=\"placeholder font-14\" ng-if=\"isPlaceholder\">{{placeholder}}</span> <i class=\"fa fa-angle-down\"></i></div><div class=\"dropdown-list\"><div><div ng-repeat=\"item in list track by $index\" ng-click=\"select(item)\" ng-class=\"{ selected: isSelected(item) }\"><span ng-if=\"prefix\">{{prefix}}</span> <span ng-show=\"useres\" translate=\"{{item.name}}\"></span> <span ng-hide=\"useres\">{{filter ? (useFilter(filter,getValue(item,property))):getValue(item,property)}}</span> <span ng-if=\"additional\">{{item[additional]}}</span></div></div></div></div>");
$templateCache.put("scripts/directives/subMenu/subMenu.html","<div class=\"redTop navigation directive-sub-menu\" data-ng-hide=\"selfDestructFlag\"><div class=\"center-wrapper\"><div class=\"container sub-menu-ctn\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><nav id=\"navbar-example\" class=\"navbar navbar-default navbar-static\"><div class=\"container-fluid\"><div class=\"navbar-header\"><div class=\"subMenuHeader\" translate=\"_my_rogers_nospace\"></div><div class=\"subMenuRedDot\"><img src=\"images/Red-Dot.png\"></div><div class=\"navbar-control\" ng-click=\"navMainMenuClick($event)\" data-toggle=\"collapse\" data-target=\".bs-example-js-navbar-collapse\"><span class=\"navbar-close\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\" translate=\"more\"></span> <span class=\"navbar-close\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\" translate=\"close\"></span> <span class=\"navbar-icon plus active\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-minus\">-</span></span></div></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse\" ng-class=\"toggleMainPlusMinus ? \'in\' : \'\'\"><ul class=\"nav navbar-nav\"><li ng-class=\"selSubMenuItem === subMenuItems.overview ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" ng-if=\"isConsumer\" ui-sref=\"accountOverview\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" translate=\"submenu_acc_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <a class=\"pointer\" ng-if=\"(isDealer || isCare) && !isConsumer\" ui-sref=\"oneViewDashboard\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" translate=\"submenu_acc_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <span class=\"left-bar\"></span></li><li ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" data-ng-class=\"isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\'\" ng-click=\"viewbill($event)\" role=\"button\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" translate=\"submenu_billing_and_payment\"></span></a>{{isPrepaid}} <span class=\"left-bar\"></span></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\"><a class=\"pointer services-menu\" id=\"drop1\" data-ng-class=\"isSubMenuEnabled(\'services\') ? \'\' : \'not - active\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\" ng-click=\"isSubMenuEnabled(\'services\') && navSubMenuClick($event)\"><span class=\"caret services-right\"></span> <span class=\"subMenu-item services-left\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" translate=\"submenu_services\"></span> <span class=\"navbar-icon plus active\" ng-class=\"!toggleServicesPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"toggleServicesPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-minus\">-</span></span></a> <span class=\"left-bar\"></span><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"drop1\" data-ng-show=\"isDropDownEnabled()\"><li data-ng-repeat=\"msl in subMenuMyServicesList track by $index\" data-ng-hide=\"btnSettings.allSubscriptions === btnStatus.hidden && activeAccountType != \'10\'\"><a ng-if=\"!(isCare && msl.serviceName === \'shmdashboard\')\" ng-hide=\"msl.hide\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\') : \'\'\"><span class=\"service-account-type\" translate=\"{{msl.serviceType}}\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\')\"></span> <span class=\"service-account-number\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\')\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'homephone\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | ute_common_filter_phone2) : \'\'}}</span></a></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" class=\"divider\"></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"linkaccount\"><span class=\"service-account-type\" translate=\"submenu_link_account\"></span></a></li></ul></li><li ng-class=\"selSubMenuItem === subMenuItems.profile ? \'mobile-selected\' : \'\'\"><a ng-click=\"isDisplayPopup() && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" role=\"button\" class=\"pointer\" data-ng-class=\"isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\'\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.profile ? \'selected\' : \'\'\" translate=\"submenu_profile\"></span></a><span class=\"left-bar\"></span></li><li ng-show=\"showCareLink\"><a ng-click=\"runCustomerCare();\" role=\"button\" class=\"pointer\"><span translate=\"_customer_care\" data-test-id=\"myr-subMenu-directive\"></span></a></li></ul></div></div></nav></div></div></div></div></div>");
$templateCache.put("scripts/directives/termsConditions/termsConditions.html","<div><div translate=\"change_method_terms\" class=\"desc-font-size-12 radius textarea_legal pam\" style=\"overflow-y: auto; height:200px\"></div><div class=\"inline_error accept-error\" ng-messages=\"form.isAccepted.$error\" ng-show=\"form.isAccepted.$invalid && form.$submitted\"><span class=\"fa fa-exclamation-circle\"></span> <span ng-message=\"required\"><span translate=\"change_method_not_accepted\" class=\"mbs\"></span></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"form.isAccepted.$invalid && form.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" ng-model=\"isAccepted\" style=\"margin-left:5px;margin-top:2px;\" required=\"\"></span> <span class=\"bold desc-font-size-18\" translate=\"change_method_accept\"></span></div></div>");
$templateCache.put("scripts/directives/validationErrorBox/validationErrorBox.html","<div class=\"row info-banner error module-global-error-message pam ng-hide\" validation-error-box-container=\"\" data-ng-show=\"errorMessage\"><div class=\"col-xs-2 col-md-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-md-11 error-message-container\"><span ng-bind-html=\"errorMessage\"></span><div ng-if=\"liveChatParams\" class=\"live-chat-container\"><bold-chat-static-button data-cbid=\"{{liveChatParams.id | translate}}\" data-dynamic-div=\"{{liveChatParams.div | translate}}\" data-chat-button=\"{{liveChatParams.button | translate}}\"></bold-chat-static-button></div></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessDashPopup.html","<section class=\"wirelessDashPopup\" ng-class=\"hupError ? \'hupError-wirelessDashPopup\': \'\'\"><div class=\"row\"><div ng-class=\"hupError ? \'hupError-bot-header\': \'\'\"><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"vm.wirelessDashPopupclose()\"><span aria-hidden=\"true\">&times;</span></button><h4 ng-if=\"!vm.isBOTEligible\" ng-class=\"hupError ? \'error_title_img\': \'\'\"><img class=\"wireless_warning_logo\" src=\"ute-common-assets/assets/warning_lg.png\" ng-if=\"hupError\"> <span translate=\"hup_not_eligible_title\"></span></h4></div><div class=\"bot-header\" ng-if=\"vm.isBOTEligible\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\" ng-if=\"vm.isBOTEligible && !vm.isCaseClosed\"> <img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/green-checkbox.png\" ng-if=\"vm.isBOTEligible && vm.isCaseClosed\"> <span translate=\"hup_processed_error\" ng-if=\"vm.isBOTEligible && !vm.isCaseClosed\"></span> <span translate=\"case_success\" ng-if=\"vm.isBOTEligible && vm.isCaseClosed\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 elig_error-msg\" ng-hide=\"vm.hupDetails.isMakePaymentAvailable\" data-ng-bind-html=\"vm.hupDetails.errorMessage\"></div><div class=\"col-xs-12 elig_error-msg\" ng-show=\"vm.hupDetails.isMakePaymentAvailable\" ng-class=\"hupError ? \'hupError-elig_error-msg\': \'\'\"><span data-ng-bind-html=\"vm.hupDetails.first\" ng-if=\"!hupError\"></span> <a ng-show=\"\" class=\"link-cancel pointer\" data-ng-click=\"vm.payBill()\" tabindex=\"-1\"><span translate=\"hup_make_a_payment\"></span></a> <span data-ng-bind-html=\"vm.hupDetails.last\" ng-if=\"!hupError\"></span> <span data-ng-bind-html=\"vm.hupDetails.banAddressRep\"></span> <span data-ng-bind-html=\"vm.hupDetails.banAddressCustomer\"></span> <span data-ng-bind-html=\"vm.hupDetails.customer\"></span> <span data-ng-bind-html=\"vm.hupDetails.rep\"></span></div><div class=\"contact\" ng-if=\"vm.isConsumer && !hupError\"><p ng-if=\"vm.hupDetails.nfdb !== \'NFDB\'\"><a data-ng-href=\"{{vm.chatHref}}\" target=\"_blank\"><img class=\"live-chat-icon\" src=\"images/live-chat-red-icon.png\"> <span translate=\"_live_chat\"></span></a></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span data-ng-bind-html=\"vm.hupDetails.contactNumber\"></span></p></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 col-sm-offset-0 col-xs-offset-4 button-section bot-button-section\" ng-if=\"vm.isBOTEligible\"><button adl-event-track=\'{\"mappingKey\":\"hup-sent-to-bot,event.selfServeStart\"}\' name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.cancelCase()\" ng-if=\"vm.isBOTEligible && !vm.isCaseClosed\"><span translate=\"yes_change_hup\"></span></button> <button adl-event-track=\'{\"mappingKey\":\"hup-sent-to-bot,event.selfServeComplete\"}\' name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.proceedWithHUP()\" ng-if=\"vm.isBOTEligible && vm.isCaseClosed\"><span translate=\"proceed_hup\"></span></button> <a href=\"\" ng-click=\"vm.wirelessDashPopupclose()\" ng-if=\"vm.isBOTEligible && !vm.isCaseClosed\" translate=\"modified_hup_wait_complete\" class=\"bot-status\"></a></div></div></section>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessManageMyDevice.partial.html","<section><div ng-class=\"{\'dealer\': (wpController.isDealer && wpController.isRepView)}\"><section class=\"manage-device\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"redHeadline\"><h3 class=\"widget-loader-mod\" translate=\"wireless_manage-device\" data-test-id=\"myr-wirelessPackage-wireless_manage-device\"></h3><div class=\"widget-loader\" ng-if=\"wpController.flags.wpkg_loadingDataIndicatorDevice\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div></div><div class=\"container\" ng-if=\"wpController.wpkg_errorMessageWirelessPackage\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam mtm\"><validation-error-box error-message=\"wpController.wpkg_errorMessageWirelessPackage\"></validation-error-box></div></div></div></div><div class=\"row\" ng-if=\"wpController.flags.wpkg_displayContentDevice\"><div class=\"col-xs-12 col-md-8 col-lg-5\"><div class=\"manageDevice\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-5 col-sm-4\"><div class=\"deviceDetail\"><div class=\"ddImage\"><img ng-src=\"{{wpController.wpkg_client.phoneImageProcessed}}\" data-test-id=\"myr-wirelessPackage-ddImage\" alt=\"\" role=\"presentation\"></div></div></div><div class=\"col-xs-7 col-sm-8\"><div class=\"container-fluid deviceDetail\"><div class=\"row\"><div ng-if=\"wpController.wpkg_client.manufacturer != \'\'\"><span ng-bind-html=\"wpController.wpkg_client.manufacturer\"></span></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-if=\"wpController.wpkg_client.deviceName != \'\'\"><span ng-bind-html=\"wpController.wpkg_client.deviceName\" ng-if=\"wpController.lng !== \'fr\'\"></span> <span ng-bind-html=\"wpController.wpkg_client.deviceNameFr\" ng-if=\"wpController.lng === \'fr\'\"></span></div></div></div><div class=\"row\"><div ng-if=\"wpController.wpkg_client.imei != undefined && wpController.wpkg_client.imei != \'\'\"><span><span translate=\"wireless_manage-device_imei\"></span> <span ng-bind-html=\"wpController.wpkg_client.imei\"></span></span></div></div></div><div class=\"container-fluid\"><div class=\"row mts\"><div class=\"col-xs-12\"><div class=\"clickable-group-div\"><div class=\"mtm\"><div class=\"plan-cta-checkBalance col-xs-12\" ng-click=\"wpController.checkBalance()\" tabindex=\"0\"><span class=\"plan-cta-checkBalance-text\" translate=\"wireless_manage-device_check_balance\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_check_balance\"></span> <img src=\"images/down_arrow_red.png\" ng-class=\"{\'rotate180Deg\':wpController.showBalanceSection}\" data-test-id=\"myr-wirelessPackage-plan-cta-checkBalance-arrow\" alt=\"\" role=\"presentation\"> <img src=\"ute-common-assets/assets/widget-loader.gif\" width=\"35\" height=\"22\" ng-if=\"wpController.checkBalanceloadingIndicator\" alt=\"\"></div></div><div class=\"col-xs-12\" ng-cloak=\"\" collapse=\"wpController.showBalanceSection\"><div ng-if=\"wpController.checkBalanceloadingIndicator\"></div><div class=\"errorMessage\" ng-if=\"wpController.balanceObj.errorMessage !== undefined\"></div><div class=\"balanceSection\" ng-if=\"wpController.balanceObj.errorMessage === undefined\"><div class=\"balanceSectionContent lightText col-xs-12 col-sm-9 paddingTop15\" ng-if=\"wpController.balanceObj.subsidyStartDate\"><span translate=\"last_update_date\"></span> <span class=\"col-xs-12\" ng-cloak=\"\" data-ng-bind-html=\"wpController.balanceObj.subsidyStartDate | date:\'MMM dd, yyyy\'\"></span></div><div class=\"col-xs-12 balance-box-description-wrapper\"><div class=\"balance-box-Wrapper col-xs-12\"><div class=\"col-xs-12\"><div class=\"paddingTop10 balance-today\" translate=\"device_balance_today_checkBalance\" data-test-id=\"myr-wirelessPackage-device_balance_today_checkBalance\"></div></div><div class=\"col-xs-12 paddingBottom10\"><span class=\"balance-today-date\" ng-cloak=\"\">({{wpController.balanceObj.todayDate}}) &nbsp;</span><span class=\"deviceBalanceRed\" ng-cloak=\"\" data-ng-bind-html=\"wpController.showDeviceBalance\"></span><div ng-click=\"return;\" class=\"parent-tip inline-block\"><span class=\"new-info-icon\">i</span><div class=\"toolTip\"><div class=\"ptm plm inline-block description ng-binding\" ng-if=\"wpController.balanceObj.tooltip.showFlexTabInfoBox\"><li translate=\"flextab_balance_desc_checkBalance\"></li><li class=\"paddingTop5\"><span translate=\"flextab_monthly_deduction_checkBalance\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.flexTab1\"></span> <span translate=\"month_checkBalance\"></span></li><li class=\"paddingTop5\"><span translate=\"flextab_term_length_checkBalance\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.flexTab2\"></span> <span translate=\"months_checkBalance\"></span></li><li class=\"paddingTop5\"><span translate=\"flextab_balance_checkBalance\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.flexTab3\"></span></li></div><div class=\"ptm plm inline-block description ng-binding\" ng-if=\"wpController.balanceObj.tooltip.showRogersNextInfoBox\"><li translate=\"financing_balance_desc\"></li><li class=\"paddingTop5\"><span translate=\"financing_monthly_payment\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.rogersNext1\"></span> <span translate=\"month_checkBalance\"></span></li><li class=\"paddingTop5\"><span translate=\"number_of_financing_monthly_payments\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.rogersNext2\"></span> <span translate=\"months_checkBalance\"></span></li><li class=\"paddingTop5\"><span translate=\"outstanding_financing_balance\"></span> <span data-ng-bind-html=\"wpController.balanceObj.tooltip.rogersNext3\"></span></li></div></div></div></div><div class=\"paddingBottom10 lightText col-xs-12\" ng-if=\"wpController.balanceObj.subsidyEndDate\"><div class=\"floatLeft col-xs-12\" translate=\"device_balance_will_be/was\"></div><div class=\"floatLeft col-xs-12\"><span translate=\"zero_dollar_on\"></span> <span ng-cloak=\"\" data-ng-bind-html=\"wpController.balanceObj.subsidyEndDate | date:\'MMM dd, yyyy\'\"></span></div></div></div></div></div></div></div></div></div><div class=\"container-fluid\" data-ng-if=\"::wpController.isConsumer\"><div class=\"row mts\"><div class=\"col-xs-12 col-md-10 upgrade-message\" data-ng-if=\"::wpController.isDealer\"><div><message-info-box info-message=\"wpController.upgradeMessage\"></message-info-box></div><div ng-bind-html=\"wpController.reserveDeviceMsg\" class=\"reserve-msg\"></div></div><div class=\"col-xs-12 col-md-10 two-column-box\" data-ng-if=\"::wpController.isCare\"><div><message-info-box info-message=\"wpController.careUpgradeMessage\"></message-info-box></div></div><div class=\"col-xs-12 col-md-10 two-column-box\" data-ng-if=\"::wpController.isCare\"><div><message-info-box info-message=\"wpController.careCheckMessage\"></message-info-box></div><div class=\"reserve-msg\" ng-bind-html=\"wpController.reserveDeviceMsg\"></div></div></div></div></div><div class=\"container-fluid\" data-ng-if=\"((wpController.isDealer || wpController.isCare) && wpController.isRepView && wpController.repHupAccess)\"><div class=\"row mts\"><div class=\"col-xs-12 two-column-box\"><div class=\"plan-cta\" ng-click=\"(wpController.repHupAccess && (wpController.isCare || (wpController.isDealer && !wpController.hupDisabled))) ? wpController.upgradeDevice(): \'\'\" ng-class=\"{\'no-pointer\' : ((wpController.hupDisabled && wpController.isDealer) || !wpController.repHupAccess)}\" data-ng-disabled=\"(!wpController.repHupAccess || (wpController.wpkg_client.planSuspended && wpController.isCare))\"><span class=\"btn-rep btn-rep-full\" translate=\"wireless_upgrade-my-device\"></span> <span class=\"widget-loader-inline\" ng-if=\"wpController.upgradeDeviceObjloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"plan-cta no-pointer\" data-ng-disabled=\"::wpController.isDealer || wpController.isCare\"><span class=\"btn-rep btn-myr\" translate=\"wireless_manage_device_reserve\"></span> <span class=\"plan-arrow-rep arrow-myr\"><span translate=\"myr\"></span></span></div></div></div></div><div class=\"container-fluid\" data-ng-if=\"(wpController.isDealer && wpController.isRepView && !wpController.repHupAccess)\"><div class=\"row mts\"><div class=\"col-xs-12 col-md-10 two-column-box\"><div class=\"plan-cta\" ng-click=\"wpController.hupDisabled ? \'\' : wpController.upgradeDevice()\" ng-class=\"{\'no-pointer\' : wpController.hupDisabled}\"><span class=\"btn-rep btn-ssp\" translate=\"wireless_upgrade-my-device\"></span> <span class=\"plan-arrow-rep arrow-ssp\"><span translate=\"ssp\"></span></span></div><div class=\"plan-cta no-pointer\" data-ng-disabled=\"::wpController.isDealer\"><span class=\"btn-rep btn-myr\" translate=\"wireless_manage_device_reserve\"></span> <span class=\"plan-arrow-rep arrow-myr\"><span translate=\"myr\"></span></span></div></div></div></div><div class=\"container-fluid\" data-ng-if=\"(wpController.isCare && wpController.isRepView && !wpController.repHupAccess)\"><div class=\"row mts\"><div class=\"col-xs-12 col-md-10 two-column-box\"><div class=\"plan-cta no-pointer\" data-ng-disabled=\"wpController.wpkg_client.planSuspended || wpController.isCare\"><span class=\"btn-rep btn-v21\" translate=\"wireless_upgrade-my-device\"></span> <span class=\"plan-arrow-rep arrow-tel\"><span translate=\"tel\"></span></span></div><div class=\"plan-cta no-pointer\" data-ng-disabled=\"::wpController.isCare\"><span class=\"btn-rep btn-myr\" translate=\"wireless_manage_device_reserve\"></span> <span class=\"plan-arrow-rep arrow-myr\"><span translate=\"myr\"></span></span></div></div></div></div></div><div class=\"col-xs-12 col-md-8 buttonSection\" data-ng-if=\"wpController.isConsumer || ((wpController.isDealer || wpController.isCare) && !wpController.isRepView)\"><div class=\"mtm\"><div ng-class=\"{\'no-pointer\':((wpController.isDealer && wpController.hupDisabled) || (wpController.isCare && !wpController.repHupAccess))}\" ng-click=\"(wpController.isConsumer || (wpController.isCare && wpController.repHupAccess) || (wpController.isDealer && !wpController.hupDisabled)) ? wpController.upgradeDevice() : \'\'\" class=\"plan-cta focus-button\" tabindex=\"0\"><span translate=\"wireless_manage-device_upgrade-device\" class=\"plan-cta-text\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_upgrade-device\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span> <span class=\"widget-loader-inline\" ng-if=\"wpController.upgradeDeviceObjloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div><div class=\"mtm marginBottom89\"><div ng-class=\"::{\'no-pointer\':(wpController.isDealer || wpController.isCare)}\" ng-click=\"(wpController.isDealer || wpController.isCare) ? \'\' : [wpController.reserveDevice(), wpController.onClickWirelessDeviceReservation()]\" class=\"plan-cta focus-button\" tabindex=\"0\"><span translate=\"wireless_manage_device_reserve\" class=\"plan-cta-text\" data-test-id=\"myr-wirelessPackage-wireless_manage_device_reserve\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div class=\"col-xs-12 wireless-package HupFlowSaved\" ng-if=\"wpController.isHupFlowProcessSaved\"><div class=\"col-xs-12 info-box\"><div class=\"col-xs-1 text-center\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-12\" translate=\"hup_have_saved_order\"></div><div class=\"col-xs-12 clickable\" ng-click=\"wpController.openHUP()\" ng-if=\"wpController.isFetchOrderCompleted()\" tabindex=\"0\"><strong translate=\"_continue\"></strong> &gt; <span class=\"widget-loader-inline\" ng-if=\"wpController.restoreCartloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div></div></div></div><div class=\"col-xs-12 col-md-4 col-lg-offset-3 my-device-options-list\"><div class=\"manageDevice manage-my-device-ctas\"><ul class=\"CTAmenu\"><li ng-if=\"!wpController.wpkg_client.planSuspended\"><a ng-click=\"wpController.suspendPhone()\" class=\"pointer\"><span data-ng-if=\"::wpController.isConsumer\"><strong translate=\"wireless_manage-device_suspend-ctn\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></strong></span> <span data-ng-if=\"::wpController.isCare || wpController.isDealer\"><strong data-ng-if=\"!wpController.isRepView\" translate=\"wireless_manage-device_suspend-ctn\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></strong> <strong data-ng-if=\"wpController.isRepView\" translate=\"wireless_manage-device_oneview_suspend-services\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></strong></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"wpController.wpkg_client.planSuspended\" data-ng-class=\"{\'opacity-disabled\': wpController.isReactivateCtnCallInProgress()}\"><a ng-click=\"!wpController.isReactivateCtnCallInProgress() && wpController.reactivatePhone($event)\" data-ng-class=\"(wpController.isReactivateCtnCallInProgress()) ? \'no-pointer\' : \'pointer\'\"><span data-ng-if=\"::wpController.isConsumer\"><strong translate=\"wireless_manage-device_reactivate-service\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_reactivate-service\"></strong></span> <span data-ng-if=\"::wpController.isCare || wpController.isDealer\"><strong data-ng-if=\"!wpController.isRepView\" translate=\"wireless_manage-device_reactivate-service\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_reactivate-service\"></strong> <strong data-ng-if=\"wpController.isRepView\" translate=\"wireless_manage-device_reactivate-services\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_reactivate-services\"></strong></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"wpController.wpkg_client.hasVoiceMail && !wpController.wpkg_client.planSuspended\"><div ng-if=\"(wpController.isConsumer || ((wpController.isDealer || wpController.isCare) && wpController.isRepView))\"><ute-voicemail-reset-password data-account-number=\"{{::wpController.ban}}\" data-ctn=\"{{wpController.ctn}}\"></ute-voicemail-reset-password></div><div ng-if=\"((wpController.isDealer || wpController.isCare) && !wpController.isRepView)\"><a class=\"no-pointer\"><strong translate=\"wireless_manage-device_voicemail-password\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_voicemail-password_isCare\"></strong></a></div></li><li ng-if=\"wpController.wpkg_client.hasVoiceMail && wpController.wpkg_client.planSuspended\" class=\"opacity-disabled\"><a style=\"text-decoration: none\"><strong ng-if=\"(wpController.isDealer || wpController.isCare) && wpController.isRepView\" translate=\"reset_voicemail_password\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_voicemail-password_suspended\"></strong> <strong ng-if=\"wpController.isConsumer || !wpController.isRepView\" translate=\"wireless_manage-device_voicemail-password\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_voicemail-password_suspended\"></strong><span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"wpController.wpkg_client.hasMyFive && !wpController.wpkg_client.planSuspended\"><a ng-click=\"wpController.updateMy5()\" class=\"pointer\" ng-if=\"::wpController.isConsumer\"><strong translate=\"wireless_manage-device_my5-my10\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_my5-my10\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a><div ng-if=\"::wpController.isDealer || wpController.isCare\" class=\"link-text-container\"><strong translate=\"wireless_manage-device_my5-my10\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_my5-my10_isCare\"></strong><span ng-if=\"wpController.isRepView\">:</span><span class=\"\" ng-bind-html=\"wpController.loginMsg\" ng-if=\"wpController.isRepView\"></span></div></li><li ng-if=\"wpController.wpkg_client.hasMyFive && wpController.wpkg_client.planSuspended\" style=\"color:#3d4040\"><strong translate=\"wireless_manage-device_my5-my10\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_my5-my10_suspended\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\" ng-if=\"::wpController.isConsumer\"></span> <span class=\"\" ng-bind-html=\"wpController.loginMsg\" ng-if=\"(wpController.isDealer || wpController.isCare) && wpController.isRepView\"></span></li><li class=\"last\" ng-if=\"!wpController.wpkg_client.planSuspended && wpController.isConsumer\"><a class=\"pointer\" ng-href=\"/web/myrogers/torcom/shopAccessories?setLanguage={{wpController.lng}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_shop-accessories\"><strong translate=\"wireless_manage-device_shop-accessories\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"last\" ng-if=\"!wpController.wpkg_client.planSuspended && (wpController.isDealer || wpController.isCare)\"><a class=\"pointer\" ng-href=\"/web/link/wirelessBuyFlow?forwardTo=AccessoryOnly&setLanguage={{wpController.lng}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_shop-accessories\"><strong translate=\"wireless_manage-device_shop-accessories\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"wpController.wpkg_client.planSuspended\" class=\"opacity-disabled last\"><a style=\"text-decoration: none\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_shop-accessories-suspended\"><strong translate=\"wireless_manage-device_shop-accessories\"></strong> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div></div></section><section class=\"cfa-section\" ng-if=\"(wpController.isDealer && wpController.isRepView)\"><div class=\"container\"><div class=\"row cfa-heading-row\"><div class=\"col-xs-12\"><span class=\"cfa-heading\" translate=\"wireless_cfa-functionality\"></span> <span class=\"widget-loader cfa-loader\" ng-if=\"wpController.flags.wpkg_loadingDataIndicatorPackage\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div><div class=\"row\" ng-if=\"!wpController.flags.wpkg_loadingDataIndicatorPackage\"><div class=\"cfa-col col-xs-12 col-md-4\"><div class=\"row\"><ul class=\"col-xs-12 col-md-10\"><li class=\"cfa-list\"><a data-ng-disabled=\"wpController.wpkg_client.planSuspended\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.goToSingleLinePlanPage()\" ng-class=\"{\'no-pointer\' : wpController.wpkg_client.planSuspended}\"><span translate=\"wireless_cfa-link_change-plan\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"cfa-list cfa-list-border cfa-list-xs\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><a ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddOn()\" data-ng-disabled=\"wpController.wpkg_client.planSuspended\" ng-class=\"{\'no-pointer\' : wpController.wpkg_client.planSuspended}\"><span translate=\"wireless_cfa-link_manage-addons\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"cfa-list cfa-list-border cfa-list-xs\" ng-if=\"!wpController.hupDisabled\"><a data-ng-disabled=\"wpController.wpkg_client.planSuspended\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersHupCancellation()\" ng-class=\"{\'no-pointer\' : wpController.wpkg_client.planSuspended}\"><span translate=\"hup_cancellation\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div><div class=\"cfa-col col-xs-12 col-md-4\"><div class=\"row\"><ul class=\"col-xs-12 col-md-10\"><li class=\"cfa-list\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><a ng-click=\"wpController.onClickWirelessChangeWirelessNumber()\" ng-if=\"wpController.lng === \'en\'\" target=\"_blank\"><span translate=\"wireless_cfa-link_change-phone-number\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a> <a ng-if=\"wpController.lng === \'fr\'\" class=\"my-line-change-number\" href=\"\" target=\"_blank\" ng-click=\"wpController.onClickWirelessChangeWirelessNumber()\"><span translate=\"wireless_cfa-link_change-phone-number\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"cfa-list cfa-list-xs\" ng-class=\"{\'cfa-list-border\': (!wpController.wpkg_errorMessageWirelessPackage)}\"><a data-ng-disabled=\"wpController.wpkg_client.planSuspended\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddaLineIndividual()\"><span translate=\"add_a_line_individual\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li ng-if=\"wpController.wpkg_client.hasVoiceMail && !wpController.wpkg_client.planSuspended\" class=\"cfa-list cfa-list-border cfa-list-xs\"><ute-voicemail-reset-password data-account-number=\"{{::wpController.ban}}\" data-ctn=\"{{wpController.ctn}}\"></ute-voicemail-reset-password></li><li ng-if=\"wpController.wpkg_client.hasVoiceMail && wpController.wpkg_client.planSuspended\" class=\"cfa-list-xs cfa-list cfa-list-border\"><a ng-class=\"{\'no-pointer\' : wpController.wpkg_client.planSuspended}\" data-ng-disabled=\"wpController.wpkg_client.planSuspended\"><span ng-if=\"::wpController.isDealer\" translate=\"wireless_cfa-link_reset-voicemail\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div><div class=\"cfa-col col-xs-12 col-md-4\"><div class=\"row\"><ul class=\"col-xs-12 col-md-11\"><li class=\"cfa-list\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><a ng-click=\"wpController.goToChangeSimCard()\"><span ng-if=\"wpController.isRepView\" class=\"lnk-txt\" translate=\"change_sim\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"cfa-list cfa-list-xs\" ng-class=\"{\'cfa-list-border\': (!wpController.wpkg_errorMessageWirelessPackage)}\"><a data-ng-disabled=\"wpController.wpkg_client.planSuspended\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddaLineShared()\" ng-class=\"{\'no-pointer\' : wpController.wpkg_client.planSuspended}\"><span translate=\"add_a_line_shared\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div></div></section></div></section>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessMyPackage.partial.html","<section><div ng-class=\"{\'dealer\': (wpController.isDealer && wpController.isRepView)}\"><section class=\"wireless-package\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 redHeadline\"><h3 class=\"widget-loader-mod pushDn\" translate=\"wireless_manage-plan_wireless-package\" data-test-id=\"myr-wirelessPackage-wireless_manage-plan_wireless-package\"></h3><div class=\"widget-loader\" ng-if=\"wpController.flags.wpkg_loadingDataIndicatorPackage\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"row\" ng-if=\"wpController.wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"wpController.wpkg_errorMessageWirelessPackage\"></validation-error-box></div></div></div><div class=\"row\" id=\"myPackageRow\" ng-if=\"wpController.flags.wpkg_displayContentPackage\"><div class=\"col-xs-12 col-md-6\"><div class=\"plan-amt-desc\"><span class=\"plan-title\" ng-if=\"wpController.lng === \'en\'\" data-test-id=\"myr-wirelessPackage-plan-amt-desc-en\">{{wpController.wpkg_wd.postPaidPhoneDetails.planDescription}}</span> <span class=\"plan-title\" ng-if=\"wpController.lng === \'fr\'\" data-test-id=\"myr-wirelessPackage-plan-amt-desc-fr\">{{wpController.wpkg_wd.postPaidPhoneDetails.planDescriptionFr}}</span></div><div class=\"minutes-txt\" ng-repeat=\"addon in wpController.wpkg_client.minutes\"><span>{{::addon}}</span></div><div class=\"row my-line-ctn\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12 col-md-10\"><ul class=\"addon-ctn\"><li class=\"addon-column\" ng-repeat=\"addon in wpController.wpkg_client.features\"><div data-ng-if=\"::addon.overAgeRate\"><span class=\"addon-title\" data-translate=\"ute.rogers.wireless.overagetext\"></span> <span class=\"addon-title\">{{::addon.overAgeRate}}</span></div><span data-ng-if=\"::!addon.overAgeRate\" class=\"addon-title\">{{::addon}}</span></li></ul></div></div></div><div class=\"col-xs-12 col-md-6\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage && (wpController.isConsumer || !wpController.isRepView)\"><div class=\"my-line-ctn my-line-number-change\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"row\"><div class=\"col-xs-12 col-md-10\"><div class=\"well well-md well-md change-ctn-link-container\"><div class=\"row change-caller-id\"><div class=\"col-xs-6 col-md-4\"><div change-ctn-caller-id=\"\" show-name=\"true\"></div></div><div class=\"col-xs-6 col-md-8\" style=\"margin-top: -5px;\"><div change-ctn-caller-id=\"\" show-name=\"false\"></div></div></div><div class=\"row\"><div class=\"col-xs-6 col-md-4\"><span class=\"my-line-number\" data-test-id=\"myr-wirelessPackage-my-line-number\">{{wpController.wpkg_client.ctn| ute_common_filter_phone2}}</span></div><div class=\"col-xs-6 col-md-8\" style=\"padding-top:10px;\"><a ng-if=\"(wpController.isDealer || wpController.isCare)&& wpController.isRepView && wpController.lng === \'en\'\" class=\"my-line-change-number\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" target=\"_blank\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"change_phone_number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a> <a ng-if=\"(wpController.isDealer || wpController.isCare) && wpController.isRepView && wpController.lng === \'fr\'\" class=\"my-line-change-number\" href=\"\" target=\"_blank\" ng-class=\"{\'no-pointer\':wpController.isCare}\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"change_phone_number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a> <a ng-if=\"(wpController.isDealer || wpController.isCare)&& !wpController.isRepView && wpController.lng === \'en\'\" class=\"my-line-change-number\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" target=\"_blank\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"wireless_manage-plan_change-number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a> <a ng-if=\"(wpController.isDealer || wpController.isCare) && !wpController.isRepView && wpController.lng === \'fr\'\" class=\"my-line-change-number\" href=\"\" target=\"_blank\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"wireless_manage-plan_change-number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a><div ng-if=\"::wpController.isConsumer\"><bold-chat-static-button data-cbid=\"{{ \'ute.rogers.wireless.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.wireless.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.rogers.wireless.chatButtonClass\' | translate}}\" data-alt-text=\"\'change_number_alt_text\' | translate\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div><div class=\"row\"><div class=\"col-xs-6 col-md-4\"></div><div class=\"col-xs-6 col-md-8 change-my-sim\"><a class=\"my-line-change-sim link_blue\" ng-class=\"{\'no-pointer\':!wpController.isRepView && (wpController.isCare || wpController.isDealer)}\" ng-click=\"!wpController.isRepView && (wpController.isCare || wpController.isDealer) ? \'\' :wpController.goToChangeSimCard()\"><span ng-if=\"wpController.isConsumer || ((wpController.isDealer || wpController.isCare) && !wpController.isRepView)\" class=\"lnk-txt\" translate=\"wireless_manage-plan_change-sim\"></span> <span ng-if=\"((wpController.isDealer || wpController.isCare)&& wpController.isRepView)\" class=\"lnk-txt\" translate=\"change_sim\"></span></a></div></div></div></div></div><div class=\"row my-line-ctn\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12\"><div class=\"my-line-plan-ctn\"><div><div class=\"row\"><div class=\"col-xs-12 wireless-discount-credits\"><span class=\"my-line-left-align mtm\" translate=\"wireless_manage-plan_estimated-values\" data-test-id=\"myr-wirelessPackage-wireless_manage-plan_estimated-values\"></span></div></div></div><div class=\"container-fluid visible-lg visible-md\"><div class=\"row plan-ctn\" ng-repeat=\"addon in wpController.wpkg_client.postPaidAddons| filter:wpController.SOCIsNotSuppressed\"><div ng-if=\"::addon.addonMSF > 0\"><div class=\"col-xs-8 col-md-6 plan-info plan-info-name\"><span class=\"col-xs-12 plan-title pull-left\">{{::addon.socDesc}}</span> <span data-ng-if=\"::addon.socClass === \'UP\'\" class=\"col-xs-12\"><span translate=\"expires\"></span> {{ab.accountBalance.currentExpiryDate | date:\'MMM dd, yyyy\'}}</span></div><div class=\"col-xs-6 col-md-3 plan-info\"><span class=\"plan-cost\"><div class=\"plan-info\" ng-if=\"wpController.isDiscountMode(addon.soc)\"><span class=\"plan-cost\"><span class=\"plan-ammount see-regular-price\">{{::addon.addonMSF | currency}}</span></span> <span class=\"plan-cost\"><span class=\"plan-ammount see-discounted-price\">{{wpController.getDiscountRate(addon.addonMSF)| currency}}</span></span></div><div ng-if=\"!wpController.isDiscountMode(addon.soc)\"><span class=\"plan-ammount\">{{::addon.addonMSF| currency}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\'\" translate=\"wireless_manage-plan_month\"></span></div></span></div><div class=\"col-xs-4 col-md-3 plan-info pull-right\" ng-if=\"::!wpController.isCare\"><button data-ng-disabled=\"wpController.wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click=\"wpController.openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-if=\"$index == 0 && wpController.isFetchOrderCompleted()\"><span translate=\"internet_change\"></span></button><div class=\"widget-loader\" ng-if=\"wpController.changeBtnLoading() && $index == 0\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><span data-ng-if=\"::addon.socClass !== \'UP\'\" ng-class=\"!wpController.wpkg_client.planSuspended ? \'plan-action\' : \'plan-action-disabled\'\" ng-if=\"$index != 0\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddOn()\"><span translate=\"wireless_manage\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-md-6 plan-info plan-info-name\" style=\"top: -20px;\" ng-if=\"wpController.isDiscountMode(addon.soc)\"><span ng-if=\"wpController.lng == \'en\'\"><span translate=\"expires_rebate\"></span> {{wpController.getDiscountExpiryDate() | date : \'MMM dd, yyyy\' : \'UTC\'}}</span> <span ng-if=\"wpController.lng == \'fr\'\"><span translate=\"expires_rebate\"></span> {{wpController.getDiscountExpiryDate() | date : \'dd MMM yyyy\' : \'UTC\'}}</span> <i class=\"fa fa-info-circle see-discount-info\" data-ng-init=\"showToolTip[$index] = false\" data-ng-click=\"showToolTip[$index] = true\"></i><div class=\"ute-md-tooltip\" data-ng-if=\"showToolTip[$index]\"><div class=\"ute-tooltip-close\" data-ng-click=\"showToolTip[$index] = false\"><i class=\"rui-icon-mobile-menu-exit\"></i></div><div class=\"ute-tooltip-arrow\"></div><span translate=\"see_discount_info_message\"></span></div></div><div class=\"col-xs-4 col-md-3 plan-info pull-right\" ng-if=\"::wpController.isCare\"><button data-ng-disabled=\"!wpController.repPpcAccess\" ng-class=\"{\'noAgentPermission\' : !wpController.repPpcAccess}\" ng-click=\"wpController.repPpcAccess && wpController.openPPC()\" class=\"pay-now-btn cta-round primary large\" ng-if=\"$index == 0\"><span translate=\"internet_change\"></span></button><div class=\"widget-loader\" ng-if=\"wpController.changeBtnLoading() && $index == 0\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><span ng-class=\"!wpController.wpkg_client.planSuspended ? \'plan-action\' : \'plan-action-disabled\'\" ng-if=\"$index != 0\"><span translate=\"wireless_manage\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-xs-12 info-box\" ng-if=\"$index == 0 && wpController.hasPPCOrder()\"><div class=\"col-xs-1 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-9\" translate=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"col-xs-3 pull-right clickable\" ng-click=\"wpController.isCare ? \'\' : wpController.openPPC(true)\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" ng-if=\"wpController.isFetchOrderCompleted()\"><strong translate=\"_continue\">_continue</strong> &gt;</div></div></div></div></div></div><div class=\"container-fluid visible-xs visible-sm\"><div class=\"row plan-ctn plm\" ng-repeat=\"addon in wpController.wpkg_client.postPaidAddons\"><div ng-if=\"::addon.addonMSF > 0\"><div class=\"col-xs-7 col-sm-8 plan-info plan-info-name\"><div><span class=\"col-xs-12 plan-title\">{{::addon.socDesc}}</span> <span data-ng-if=\"::addon.socClass === \'UP\'\" class=\"col-xs-12\"><span translate=\"expires\"></span> {{ab.accountBalance.currentExpiryDate | date:\'MMM dd, yyyy\'}}</span></div><div ng-if=\"!wpController.isDiscountMode(addon.soc)\"><span class=\"plan-ammount\">{{::addon.addonMSF| currency}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\'\" translate=\"wireless_manage-plan_month\"></span></div><div ng-if=\"wpController.isDiscountMode(addon.soc)\"><div><span class=\"plan-cost\"><span class=\"plan-ammount see-regular-price\">{{::addon.addonMSF| currency}}</span></span> <span class=\"plan-cost\"><span class=\"plan-ammount see-discounted-price\">{{wpController.getDiscountRate(addon.addonMSF)| currency}}</span></span></div><div class=\"col-md-6 plan-info plan-info-name hidden-xs\"><span translate=\"expires_rebate\"></span> {{wpController.getDiscountExpiryDate() | ute_common_moment_date : \'MMM dd, yyyy\'}} <i class=\"fa fa-info-circle see-discount-info\" tabindex=\"-1\" data-ng-init=\"showToolTip[$index] = false\" data-ng-click=\"showToolTip[$index] = true\"></i><div class=\"ute-md-tooltip\" data-ng-if=\"showToolTip[$index]\"><div class=\"ute-tooltip-close\" data-ng-click=\"showToolTip[$index] = false\"><i class=\"rui-icon-mobile-menu-exit\"></i></div><div class=\"ute-tooltip-arrow\"></div><span translate=\"see_discount_info_message\"></span></div></div></div></div><div class=\"col-xs-5 col-sm-4 plan-info pull-right\" ng-if=\"::!wpController.isCare\"><button data-ng-disabled=\"wpController.wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click-x=\"wpController.wpkg_client.canChangePlan ? wpController.openPPC() : wpController.openChangePlanModal()\" ng-click=\"wpController.openPPC()\" ng-if=\"$index == 0 && wpController.isFetchOrderCompleted()\"><span translate=\"internet_change\"></span></button> <span data-ng-if=\"::addon.socClass !== \'UP\'\" ng-class=\"!wpController.wpkg_client.planSuspended ? \'plan-action\' : \'plan-action-disabled\'\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddOnChange(addon)\" ng-if=\"$index != 0\"><span translate=\"wireless_manage\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"col-xs-4 plan-info pull-right\" ng-if=\"::wpController.isCare\"><button data-ng-disabled=\"!wpController.repPpcAccess\" ng-class=\"{\'noAgentPermission\' : !wpController.repPpcAccess}\" ng-click=\"wpController.repPpcAccess && wpController.openPPC()\" class=\"pay-now-btn cta-round primary large\" ng-if=\"$index == 0\"><span translate=\"internet_change\"></span></button> <span ng-class=\"!wpController.wpkg_client.planSuspended ? \'plan-action\' : \'plan-action-disabled\'\" ng-if=\"$index != 0\"><span translate=\"wireless_manage\"></span> <span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"row\" ng-if=\"wpController.changeBtnLoading() && $index == 0\"><div class=\"col-xs-offset-8 col-xs-4 text-center\"><div class=\"widget-loader\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"col-xs-12 info-box\" ng-if=\"$index == 0 && wpController.hasPPCOrder()\"><div class=\"col-xs-2 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-10 info-box-msg\"><div class=\"row\" translate=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"row clickable\" ng-click=\"wpController.isCare ? \'\' : wpController.openPPC(true)\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" ng-if=\"wpController.isFetchOrderCompleted()\"><strong translate=\"_continue\">_continue</strong> &gt;</div></div></div><div class=\"col-md-6 plan-info plan-info-name visible-xs\" style=\"top:-5px;clear:both\" ng-if=\"wpController.isDiscountMode(addon.soc)\"><span translate=\"expires_rebate\"></span> {{wpController.getDiscountExpiryDate() | ute_common_moment_date : \'MMM dd, yyyy\'}} <i class=\"fa fa-info-circle see-discount-info\" tabindex=\"-1\" data-ng-init=\"showToolTip[$index] = false\" data-ng-click=\"showToolTip[$index] = true\"></i><div class=\"ute-md-tooltip\" data-ng-if=\"showToolTip[$index]\"><div class=\"ute-tooltip-close\" data-ng-click=\"showToolTip[$index] = false\"><i class=\"rui-icon-mobile-menu-exit\"></i></div><div class=\"ute-tooltip-arrow\"></div><span translate=\"see_discount_info_message\"></span></div></div></div></div></div></div></div></div><div><div class=\"plan-cta-ctn clickable-group-div\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage && (!wpController.isCare || (wpController.isCare && !wpController.isRepView))\"><div class=\"plan-cta\" ng-class=\"::{\'no-pointer\': wpController.isCare}\" ng-click=\"wpController.isCare ? \'\' : wpController.postToRogersAddOn()\" ng-if=\"!wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect\" data-test-id=\"myr-wirelessPackage-addNewAddons\" translate=\"wireless_uadd_new_addons\"></span> <span class=\"plan-arrow plan-cta-rect\"><span class=\"rui-icon-button-arrow-right\" ng-if=\"wpController.isConsumer || !wpController.isRepView\"></span> <span ng-if=\"wpController.isDealer && wpController.isRepView\" translate=\"ssp\"></span></span></div><div class=\"plan-cta\" ng-class=\"::{\'no-pointer\': wpController.isCare}\" ng-click=\"wpController.isCare ? \'\' : wpController.postToRogersAddOn()\" ng-if=\"!wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect\" translate=\"wireless_uadd_travel_pack\" data-test-id=\"myr-wirelessPackage-wireless_uadd_travel_pack\"></span> <span class=\"plan-arrow plan-cta-rect\"><span class=\"rui-icon-button-arrow-right\" ng-if=\"wpController.isConsumer || !wpController.isRepView\"></span> <span ng-if=\"wpController.isDealer && wpController.isRepView\" translate=\"ssp\"></span></span></div><div class=\"plan-cta\" ng-class=\"::{\'no-pointer\': wpController.isCare}\" style=\"opacity: 0.6;cursor:auto\" ng-if=\"wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect\" translate=\"wireless_uadd_new_addons\" data-test-id=\"myr-wirelessPackage-addNewAddonsSuspended\"></span> <span class=\"plan-arrow plan-cta-rect\"><span class=\"rui-icon-button-arrow-right\" ng-if=\"wpController.isConsumer || !wpController.isRepView\"></span> <span ng-if=\"wpController.isDealer && wpController.isRepView\" translate=\"ssp\"></span></span></div><div class=\"plan-cta\" ng-class=\"::{\'no-pointer\': wpController.isCare}\" style=\"opacity: 0.6;cursor:auto\" ng-if=\"wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect\" translate=\"wireless_uadd_travel_pack\" data-test-id=\"myr-wirelessPackage-wireless_uadd_travel_pack-suspended\"></span> <span class=\"plan-arrow plan-cta-rect\"><span class=\"rui-icon-button-arrow-right\" ng-if=\"wpController.isConsumer || !wpController.isRepView\"></span> <span ng-if=\"wpController.isDealer && wpController.isRepView\" translate=\"ssp\"></span></span></div></div><div class=\"plan-cta-ctn clickable-group-div\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage && (wpController.isCare && wpController.isRepView)\"><div class=\"plan-cta no-pointer\" data-ng-disabled=\"::wpController.isCare\"><span class=\"btn-rep btn-v21\" translate=\"wireless_uadd_new_addons\"></span> <span class=\"plan-arrow-rep arrow-v21\"><span translate=\"v21\"></span></span></div><div class=\"plan-cta no-pointer\" data-ng-disabled=\"::wpController.isCare\"><span class=\"btn-rep btn-v21\" translate=\"wireless_uadd_travel_pack\"></span> <span class=\"plan-arrow-rep arrow-v21\"><span translate=\"v21\"></span></span></div></div></div></div></div></div><div class=\"cols-xs-12\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage && (!wpController.isConsumer && wpController.isRepView)\"><div data-ng-include=\"::wpController.pathToWirelessSubscriptionDetailsUrl\"></div><div class=\"wireless-paddingTop40\"><ute-wireless-product-discount-details product-discount-details=\"wpController.wpkg_client.discounts\"></ute-wireless-product-discount-details></div></div><div class=\"container no-left-border\"><div class=\"row ptm\"><revolution is-page-wireless-attr=\"true\" open-wirelese-package-modal=\"wpController.openWirelesePackageModal()\" un-enroll-package-modal=\"wpController.unEnrollPackageModal()\" open-wireless-travel-package-legal-content-modal=\"wpController.openWirelessTravelPackageLegalContentModal(ev,size)\" travel-package-data=\"wpController.travelPackageData\" hide-wireless-travel-package=\"wpController.hideWirelessTravelPackage\" travel-package-data-has-plan=\"wpController.travelPackageDataHasPlan\"></revolution></div></div><div class=\"container\"><div style=\"display: none;\"><form name=\"formToRogersAddOn\" id=\"formToRogersAddOn\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"true\" name=\"RONHP_SWITCH_ENABLE_FLAG\"><br><input type=\"text\" value=\"true\" name=\"RONSP_SWITCH_ENABLE_FLAG\"><br></form><form name=\"formToRogersSim\" id=\"formToRogersSim\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"changeSimBAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"changeSimCTN\"><br><input type=\"text\" value=\"SMART_PHONE\" name=\"simFlowType\"><br></form><form name=\"formToRogersSuspend\" id=\"formToRogersSuspend\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersAcc\" id=\"formToRogersAcc\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersUpgrade\" id=\"formToRogersUpgrade\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"selectedCTN\"><br></form><form name=\"formToRogersVoicemail\" id=\"formToRogersVoicemail\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"BAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"CTN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.vmsoc\" name=\"VMSOC\"><br></form><form name=\"formToRogersMy5\" id=\"formToRogersMy5\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.soc\" name=\"SOC\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"BAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"CTN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.socDesc\" name=\"socDesc\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.MAX\" name=\"MAX\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.TYPE\" name=\"TYPE\"><br><input type=\"text\" value=\"false\" name=\"isPrepaidCustomer\"><br><input type=\"text\" value=\"1\" name=\"passCode\"><br></form><form name=\"formToRogersReserveDevice\" id=\"formToRogersReserveDevice\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"NRS_MS\" name=\"sourceNRS\"><br></form></div></div></div></section></div></section>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessPackage.html","<section><div ng-if=\"!wpController.isDealer\"><div class=\"col-xs-12 visible-xs\" data-ng-include=\"\'scripts/directives/wirelessPackage/partials/wirelessMobileLinks.html\'\"></div><div class=\"col-xs-12 col-sm-6\" data-ng-include=\"\'scripts/directives/wirelessPackage/partials/wirelessPlan.html\'\"></div><div class=\"col-xs-12 col-sm-6\" data-ng-include=\"\'scripts/directives/wirelessPackage/partials/wirelessDevice.html\'\"></div><div class=\"col-xs-12\" data-ng-include=\"\'scripts/directives/wirelessPackage/partials/wirelessSupport.html\'\"></div><div class=\"col-xs-12\" ng-hide=\"wpController.isCare\" data-ng-include=\"\'scripts/directives/wirelessPackage/partials/wirelessExtras.html\'\"></div><div class=\"container\"><div style=\"display: none;\"><form name=\"formToRogersAddOn\" id=\"formToRogersAddOn\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"true\" name=\"RONHP_SWITCH_ENABLE_FLAG\"><br><input type=\"text\" value=\"true\" name=\"RONSP_SWITCH_ENABLE_FLAG\"><br></form><form name=\"formToRogersSim\" id=\"formToRogersSim\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"changeSimBAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"changeSimCTN\"><br><input type=\"text\" value=\"SMART_PHONE\" name=\"simFlowType\"><br></form><form name=\"formToRogersSuspend\" id=\"formToRogersSuspend\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersAcc\" id=\"formToRogersAcc\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"ctn\"><br></form><form name=\"formToRogersUpgrade\" id=\"formToRogersUpgrade\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"selectedCTN\"><br></form><form name=\"formToRogersVoicemail\" id=\"formToRogersVoicemail\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"BAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"CTN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.vmsoc\" name=\"VMSOC\"><br></form><form name=\"formToRogersMy5\" id=\"formToRogersMy5\" method=\"post\" novalidate=\"\"><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.soc\" name=\"SOC\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ban\" name=\"BAN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_client.ctn\" name=\"CTN\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.socDesc\" name=\"socDesc\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.MAX\" name=\"MAX\"><br><input type=\"text\" data-ng-value=\"wpController.wpkg_my5.TYPE\" name=\"TYPE\"><br><input type=\"text\" value=\"false\" name=\"isPrepaidCustomer\"><br><input type=\"text\" value=\"1\" name=\"passCode\"><br></form><form name=\"formToRogersReserveDevice\" id=\"formToRogersReserveDevice\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"NRS_MS\" name=\"sourceNRS\"><br></form><form name=\"formForTrackPhoneRepair\" id=\"formForTrackPhoneRepair\" target=\"_blank\" method=\"post\"><input type=\"hidden\" id=\"TOKEN\" name=\"TOKEN\"></form></div></div></div><div ng-if=\"wpController.isDealer\"><div ng-if=\"::!wpController.isShareEverything()\"><div data-ng-include=\"::wpController.pathToWirelessMyPackageSectionUrl\"></div><div data-ng-include=\"::wpController.pathToManageMyDeviceSectionUrl\"></div></div><div class=\"row\" data-ng-if=\"::wpController.isShareEverything()\"><div data-ng-if=\"::!wpController.isIndividualSummary()\" class=\"hidden-xs col-sm-12\"><div data-ng-include=\"::wpController.pathToWirelessMyPackageSectionUrl\"></div><div data-ng-include=\"::wpController.pathToManageMyDeviceSectionUrl\"></div></div><div data-ng-if=\"::wpController.isIndividualSummary()\" class=\"col-xs-12 hidden-sm hidden-md hidden-lg\"><div class=\"container usageDetails-accordionContainer\"><div class=\"usageDetails\"><accordion class=\"usageDetails-accordion\"><div class=\"usageDetails-accordionBorder\"><div accordion-group=\"\" is-open=\"wpController.isOpenPackage\"><accordion-heading><i class=\"usageDetails-accordionHeadingIcon\"></i> <span class=\"usageDetails-accordionHeading\" translate=\"wireless_my_package\"></span></accordion-heading><div data-ng-include=\"::wpController.pathToWirelessMyPackageSectionUrl\"></div></div></div></accordion><accordion class=\"usageDetails-accordion\"><div class=\"usageDetails-accordionBorder\"><div accordion-group=\"\" is-open=\"wpController.isOpenMyDevice\"><accordion-heading><i class=\"usageDetails-accordionHeadingIcon\"></i> <span class=\"usageDetails-accordionHeading\" translate=\"wireless_my_device\"></span></accordion-heading><div data-ng-include=\"::wpController.pathToManageMyDeviceSectionUrl\"></div></div></div></accordion></div></div></div></div></div></section>");
$templateCache.put("scripts/directives/wirelessPackage/wirelessSubscriptionDetails.rep.partial.html","<div class=\"col-xs-12\"><div class=\"my-line-ctn my-line-number-change rep-my-line-number-change\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><div change-ctn-caller-id=\"\" options=\"changeCtnOptions\" show-name=\"true\"></div></div><div class=\"col-xs-12 col-md-9\"><span class=\"my-line-number\" data-test-id=\"myr-wirelessPackage-my-line-number\">{{wpController.wpkg_client.ctn| ute_common_filter_phone2}}</span></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-3\"><div change-ctn-caller-id=\"\" options=\"changeCtnOptions\" show-name=\"false\"></div></div><a class=\"col-xs-12 col-md-3 my-line-change-number\" ng-if=\"wpController.lng === \'en\'\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" target=\"_blank\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"change_phone_number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a> <a class=\"col-xs-12 col-md-3 my-line-change-number\" ng-if=\"wpController.lng === \'fr\'\" href=\"\" target=\"_blank\" ng-class=\"::{\'no-pointer\':wpController.isCare}\" ng-click=\"wpController.isCare ? \'\' : wpController.onClickWirelessChangeWirelessNumber();\"><span class=\"lnk-txt\" translate=\"change_phone_number\"></span> <span ng-if=\"::wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a> <a class=\"col-xs-12 col-md-3 my-line-change-sim link_blue\" ng-click=\"!wpController.isRepView ? \'\' :wpController.goToChangeSimCard()\"><span class=\"lnk-txt\" translate=\"change_sim\"></span> <span ng-if=\"wpController.isDealer\" class=\"rui-icon-button-arrow-right\"></span></a></div></div></div><div class=\"row my-line-ctn\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"subscriptions-section col-xs-12\"><div class=\"\"><div class=\"subscriptions-header\"><div class=\"row\"><h3 class=\"mbn\" translate=\"wireless_manage-plan_current_service\" data-test-id=\"myr-wirelessPackage-wireless_manage-plan_current_service\"></h3></div><div class=\"row\"><h6 class=\"\" translate=\"wireless_manage-plan_estimated-values\" data-test-id=\"myr-wirelessPackage-wireless_manage-plan_estimated-values\"></h6></div></div><div class=\"container-fluid col-xs-12 subscriptions-details-section\"><div class=\"subscriptions-details-header\"><div class=\"col-xs-5\"><span translate=\"wireless_manage-plan_description\"></span></div><div class=\"col-xs-3\"><span translate=\"wireless_manage-plan_price\"></span></div><div class=\"col-xs-4\"><span translate=\"wireless_manage-plan_soc_code\"></span></div></div><div class=\"row subscriptions-details-body\" ng-repeat=\"addon in wpController.wpkg_client.postPaidAddons | filter:wpController.addonFilterWithSOCIsNotSuppressed\"><div class=\"col-xs-5\"><span class=\"col-xs-12\">{{::addon.socDesc}}<span class=\"mlm\" ng-if=\"$index == 0\" ng-click=\"wpController.subscriptionInfoModal()\"><span class=\"new-info-icon\">i</span></span></span><div class=\"mtss col-xs-11\"><span ng-if=\"wpController.hasPropertyValue(addon.effectiveDate)\" class=\"col-xs-12 col-md-5\"><span translate=\"wireless_manage-plan_effective_date\"></span>{{::addon.effectiveDate | date:\'MM/dd/yyyy\'}}</span> <span ng-if=\"wpController.hasPropertyValue(addon.effectiveDate) && wpController.hasPropertyValue(addon.expiryDate)\" class=\"col-xs-1 date-pipe visible-lg visible-md\">&nbsp;|</span> <span ng-if=\"wpController.hasPropertyValue(addon.expiryDate)\" class=\"col-xs-12 col-md-6\"><span translate=\"wireless_manage-plan_expiration_date\"></span>{{::addon.expiryDate | date:\'MM/dd/yyyy\'}}</span></div></div><div class=\"col-xs-3\"><span>{{::addon.addonMSF| currency}}</span> <span translate=\"wireless_manage-plan_month\"></span></div><div class=\"col-xs-4\"><div class=\"col-md-12 col-lg-7\"><span class=\"\">{{::addon.soc}}</span></div><div class=\"col-md-12 col-lg-5\" ng-if=\"::wpController.isDealer\"><button data-ng-disabled=\"wpController.wpkg_client.planSuspended\" class=\"pay-now-btn cta-round primary large\" ng-click=\"wpController.openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-if=\"$index == 0 && wpController.isFetchOrderCompleted()\"><span translate=\"internet_change\"></span></button><div class=\"widget-loader\" ng-if=\"wpController.changeBtnLoading() && $index == 0\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><span ng-if=\"$index != 0 && addon.socClass !== \'UP\'\" ng-class=\"!wpController.wpkg_client.planSuspended ? \'plan-action\' : \'plan-action-disabled\'\" ng-click=\"wpController.wpkg_client.planSuspended ? \'\' : wpController.postToRogersAddOn()\"><span class=\"glyphicon-minus new-circle-minus\"></span> <span class=\"redcolor plan-ammount\" translate=\"internet_remove\"></span></span></div><div class=\"col-lg-5 col-md-12\" ng-if=\"::wpController.isCare\"><button data-ng-disabled=\"!wpController.repPpcAccess\" ng-class=\"{\'noAgentPermission\' : !wpController.repPpcAccess}\" ng-click=\"wpController.repPpcAccess && wpController.openPPC()\" class=\"pay-now-btn cta-round primary large\" ng-if=\"$index == 0\"><span translate=\"internet_change\"></span></button><div class=\"widget-loader\" ng-if=\"wpController.changeBtnLoading() && $index == 0\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-xs-12 info-box mal\" ng-if=\"$index === 0 && wpController.hasPPCOrder()\"><div class=\"col-xs-1 text-center info-box-icon\"><span class=\"rui-icon-info\"></span></div><div class=\"col-xs-11 info-box-msg\"><div class=\"col-xs-9\" translate=\"ppc_have_saved_order\">ppc_have_saved_order</div><div class=\"col-xs-3 pull-right clickable\" ng-click=\"wpController.openPPC(true)\" ng-if=\"wpController.isFetchOrderCompleted()\"><strong translate=\"_continue\">_continue</strong> &gt;</div></div></div></div></div></div></div></div></div><div class=\"col-xs-12\" ng-if=\"!wpController.wpkg_errorMessageWirelessPackage\"><div class=\"col-xs-12 plan-cta-ctn clickable-group-div\" ng-if=\"::wpController.isDealer\"><div class=\"plan-cta col-xs-12 col-md-3\" ng-click=\"wpController.postToRogersAddOn()\" ng-if=\"!wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect rep-blue\" data-test-id=\"myr-wirelessPackage-addNewAddons\" translate=\"wireless_uadd_new_addons\"></span> <span class=\"plan-arrow plan-cta-rect rep-blue pan\"><span class=\"rui-icon-button-arrow-right rep-blue-color\"></span></span></div><div class=\"plan-cta col-xs-12 col-md-3\" ng-click=\"wpController.postToRogersAddOn()\" ng-if=\"!wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect rep-blue\" translate=\"wireless_uadd_travel_pack\" data-test-id=\"myr-wirelessPackage-wireless_uadd_travel_pack\"></span> <span class=\"plan-arrow plan-cta-rect rep-blue pan\"><span class=\"rui-icon-button-arrow-right rep-blue-color\"></span></span></div><div class=\"plan-cta col-xs-12 col-md-3\" ng-if=\"wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect rep-blue\" translate=\"wireless_uadd_new_addons\" data-test-id=\"myr-wirelessPackage-addNewAddonsSuspended\"></span> <span class=\"plan-arrow plan-cta-rect rep-blue pan\"><span class=\"rui-icon-button-arrow-right rep-blue-color\"></span></span></div><div class=\"plan-cta col-xs-12 col-md-3\" ng-if=\"wpController.wpkg_client.planSuspended\"><span class=\"plan-cta-text-sm plan-cta-rect rep-blue\" translate=\"wireless_uadd_travel_pack\" data-test-id=\"myr-wirelessPackage-wireless_uadd_travel_pack-suspended\"></span> <span class=\"plan-arrow plan-cta-rect rep-blue pan\"><span class=\"rui-icon-button-arrow-right rep-blue-color\"></span></span></div></div></div>");
$templateCache.put("scripts/directives/wirelessPlan/wirelessPlan.html","<section class=\"wireless-plan\"><div class=\"container\" ng-controller=\"wirelessPlanCtrl\"><div class=\"row\"><div class=\"col-xs-12\"><h2 class=\"widget-loader-mod pushDn\" translate=\"wirelessPrepaid\" data-test-id=\"myr-wirelessPlan-wirelessPrepaid\"></h2><div class=\"widget-loader mtl\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" ng-show=\"errorMessage\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div><div class=\"row mbm\" ng-show=\"displayContent\"><div class=\"col-xs-12 col-md-3\"><div class=\"plan-info-wrap\"><div class=\"mbm\" ng-bind-html=\"vpd.phoneSelected.planDescHTML\" data-test-id=\"myr-wirelessPlan-phoneSelected_planDescHTML\"></div><h4 ng-show=\"true\"><small><span translate=\"wireless_prepaid_plan-expires\" ng-show=\"dtEn\" data-test-id=\"myr-wirelessPlan-nextPaymentDateText\"></span></small> <small><span ng-show=\"lang === \'en\'\" data-test-id=\"myr-wirelessPlan-nextPaymentDateEn\">{{dtEn}}</span></small> <small><span ng-show=\"lang === \'fr\'\" data-test-id=\"myr-wirelessPlan-nextPaymentDateFr\">{{dtFr | capitalize}}</span></small></h4></div></div><div class=\"col-xs-12 col-md-4 ptl top-now-padding-left\"><button name=\"postToRogersTop\" class=\"plm prm cta-round primary large mtl\" ng-click=\"postToRogers(2)\" data-test-id=\"myr-wirelessPlan-button_postToRogersTop\"><span class=\"white\" translate=\"acc_overview_top_up_now\"></span></button><div class=\"wireless-page my-line-plan-ctn mts pts pbs\"><div ng-click=\"postToRogers(0)\" class=\"pbs\" style=\"width:60%\"><span class=\"plan-title mts mrs pointer\" translate=\"wireless_prepaid_change-plan\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_change-plan\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div class=\"col-xs-12 col-md-5 ptm\"><div class=\"\"><div class=\"plan-cta-ctn mtm\"><div class=\"container-fluid\"><div class=\"row plan-ctn pts pbs\" ng-repeat=\"addon in vpd.phoneSelected.addOns track by $index\" style=\"border-top: 1px solid #dde4e6;\"><div class=\"plan-info plan-info-name\"><span class=\"plan-title pull-left\">{{addon.addonTitle}}</span></div></div></div></div><div class=\"plan-cta\" ng-click=\"postToRogers(1)\"><span class=\"plan-cta-text\" translate=\"wireless_prepaid_manage-add-ons\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_manage-add-ons\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div></div><div class=\"row my-line-ctn my-line-bpd\" ng-if=\"displayContent\"><div class=\"col-xs-12\"><div><span class=\"plan-title\" translate=\"wireless_prepaid_wireless-number\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_wireless-number\"></span></div></div></div><div class=\"row my-line-ctn my-line-bpd0\" ng-if=\"displayContent\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><span class=\"my-line-number\" data-test-id=\"myr-wirelessPlan-my-line-number\">{{::vpd.ctns[0]| ute_common_filter_phone2}}</span><div ng-click=\"postToRogers(3)\" class=\"pbs pts\"><span class=\"plan-title mts mrs pointer\" translate=\"wireless_prepaid_change-number\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_change-number\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-4 top-now-padding-left\"><span class=\"my-line-number\" data-test-id=\"myr-wirelessPlan-my-line-number_isCare\"><span translate=\"wireless_prepaid_pin-code\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_pin-code\"></span> <span ng-if=\"::isConsumer\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_pin-code_number\">{{vpd.phoneSelected.pin}}</span> <span ng-if=\"::(isDealer || isCare)\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_pin-code_number-dealer\">XXXX</span></span><div ng-click=\"postToRogers(4)\" class=\"pbs pts\"><span class=\"plan-title mts mrs pointer\" translate=\"wireless_prepaid_change-pin\" data-test-id=\"myr-wirelessPlan-wireless_prepaid_change-pin\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div class=\"row my-line-ctn my-line-bpd0\" ng-if=\"displayContent && repairDeviceEnabled\"><div class=\"col-xs-12 col-sm-6 col-md-3\"><div ng-click=\"continueToRepairModal()\" class=\"pbs pts\"><span class=\"plan-title mts mrs pointer\" translate=\"start_track_phone_repair\" data-test-id=\"myr-wirelessPlan_prepaid_phone_repair\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div><div style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">flowId: <input type=\"text\" data-ng-model=\"selectedFlow\" name=\"flowId\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.accountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.ctn\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vpd.phoneSelected.pin\" name=\"passCode\"><br><button ng-click=\"postToRogers(0)\">Plan Change</button> <button ng-click=\"postToRogers(1)\">Add-ons</button> <button ng-click=\"postToRogers(2)\">Top-up</button> <button ng-click=\"postToRogers(3)\">Change Number</button> <button ng-click=\"postToRogers(4)\">Change PIN</button></form><form name=\"formForTrackPhoneRepair\" id=\"formForTrackPhoneRepair\" target=\"_blank\" method=\"post\"><input type=\"hidden\" id=\"TOKEN\" name=\"TOKEN\"></form></div></div></section>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.accountOverview.html","<div class=\"welcome-message\"><div class=\"welcome-bar\"></div><div><span translate=\"ute.rogers.account.balance.welcome_back\" ng-if=\"!ab.appState.isLinked\"></span> <span translate=\"ute.rogers.account.balance.welcome\" ng-if=\"ab.appState.isLinked\"></span> <span class=\"capitalize\">{{ab.getName()}}</span></div></div><div ng-if=\"ab.isCLM && ab.usedCLMpercentage > 60 && !ab.isSuspended()\" class=\"credit-limit-overlay\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\"><div class=\"title\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.titleCLM}}\"></div><div class=\"description\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.descCLM}}\"></div></div><div ng-if=\"ab.isDesktopView() || !ab.isSuspended()\" class=\"account-balance-overview row\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60 }\"><div class=\"suspended-warning\" ng-if=\"ab.isSuspended()\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><span class=\"suspended-message\" translate=\"ute.rogers.account.balance.suspended_msg\"></span><div class=\"live-chat-link-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-link-suspended\"></bold-chat-static-button></div></div><div class=\"col-md-4 balance-section\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60, \'with-payment-date\': ab.isCLM && ab.displayPaymentDate() }\"><div class=\"row\"><div class=\"col-xs-6 total-balance\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div><div class=\"col-xs-6 credit-limit\" ng-if=\"ab.isCLM && !ab.isSuspended()\" ng-class=\"{ \'height-pad\': ab.isCCExpiring || ab.isCCExpired, \'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100, \'add-extra-pad-narrow\': !ab.displayPaymentDate() || ab.usedCLMpercentage >= 100 }\"><div class=\"row total-credit-limit\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.credit_limit\" data-test-id=\"myr-accountBalance-total\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" ata-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span></div><div class=\"row used-and-remaining\" ng-if=\"!(ab.usedCLMpercentage >= 100)\"><div><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span> <span translate=\"ute.rogers.account.balance.used_credit\" data-test-id=\"myr-accountBalance-outstanding\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span></div><div ng-class=\"{\'remaining\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100 }\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span></div></div><div class=\"row used-and-remaining recommended-pay\" ng-if=\"ab.usedCLMpercentage >= 100\"><span translate=\"ute.rogers.account.balance.recommended_pay\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.recommendedPaymentAmount) | currencies:ab.lng }}</span></div></div></div><div class=\"payment-date\" ng-if=\"ab.displayPaymentDate()\"><div class=\"payment-date-container\"><span translate=\"ute.rogers.account.balance.required_payment_date\"></span> <span ng-bind-html=\"ab.billDueDate | uteCanadianDate\"></span></div><div ng-if=\"ab.displayCalendarOptions()\" class=\"addtocalendar-container\" ute-data-layer-event=\"\" event-name=\"click\" mapping-key=\"addToCalendar.open\"><ute-add-to-calendar start-date=\"{{ab.formatCalendarDate(ab.billDueDate, 12.5)}}\" end-date=\"{{ab.formatCalendarDate(ab.billDueDate, 13)}}\" title=\"{{\'ute.rogers.account.balance.add_to_calendar.event_title\' | translate}}\" dropdown-title=\"{{\'ute.rogers.account.balance.add_to_calendar.dropdown_title\' | translate}}\" location=\"{{\'ute.rogers.account.balance.add_to_calendar.location\' | translate}}\" btn-text=\"{{\'ute.rogers.account.balance.add_to_calendar.button_label\' | translate}}\" description=\"{{\'ute.rogers.account.balance.add_to_calendar.description\' | translate}}\" class-name=\"ute-add-to-calendar\"></ute-add-to-calendar></div></div></div><div class=\"col-md-5 payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" account-balance=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"col-md-3 action-buttons\" ng-class=\"{\'is-expiring-bg\': ab.isCCExpiring, \'is-expired-bg\': ab.isCCExpired, \'with-payment-date\' : ab.displayPaymentDate()}\"><div><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div></div><div class=\"account-balance-overview row\" ng-if=\"!ab.isDesktopView() && ab.isSuspended()\"><div class=\"suspended-warning suspended-warning-mobile\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><div class=\"row message-section\"><div><span translate=\"ute.rogers.account.balance.suspended_msg\"></span></div><div><div class=\"live-chat-icon-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-icon-suspended\"></bold-chat-static-button></div></div></div><div class=\"balance-section\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div></div><div class=\"payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" account-balance=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"action-buttons\" ng-class=\"{\'is-expiring-bg\': ab.isCCExpiring, \'is-expired-bg\': ab.isCCExpired}\"><div><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.accountOverviewWrapper.html","<div ng-if=\"ab.showLoadingIcon()\" class=\"widget-loader\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div ng-class=\"{\'col-md-5 col-lg-4\' : !isConsumer}\"><div ng-include=\"ab.getTemplateName()\"></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.html","<div class=\"directive-account-balance medium-font-size\"><div class=\"one-view-title-fr\"><h4 class=\"one-view-account-balance-title\" ng-if=\"isDealer || isCare\" translate=\"acc_balance\" data-test-id=\"myr-accountBalance-acc_balance\"></h4><h4 class=\"account-balance-title\" ng-if=\"isConsumer\" translate=\"acc_balance\" data-test-id=\"myr-accountBalance-acc_balance\"></h4></div><span class=\"widget-loader-inline position-abs\" ng-show=\"ab.loadingBalance\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div id=\"wrapper\" data-ng-hide=\"ab.loadingBalance\"><div class=\"account-balance-ctn\"><div class=\"title-h3-light mts lh41\" ng-if=\"isConsumer\"><span ng-show=\"ab.abdf.accountBalance && !ab.abdf.loadingData\" data-test-id=\"myr-accountBalance-balanceAmount-success\">{{ab.abdf.accountBalance.balanceAmount | currencies:ab.lng}}</span> <span ng-show=\"!ab.abdf.accountBalance && !ab.abs.loadingData\" translate=\"acc_balance_not_available\" data-test-id=\"myr-accountBalance-balanceAmount-fail\"></span></div><h4 class=\"one-view-account-balance\" ng-if=\"isDealer || isCare\"><span ng-show=\"ab.abdf.accountBalance && !ab.abs.loadingData\" data-test-id=\"myr-oneViewAccountBalance-balanceAmount-success\">{{ab.abdf.accountBalance.balanceAmount | currencies:ab.lng}}</span> <span ng-show=\"!ab.abdf.accountBalance && !ab.abs.loadingData\" translate=\"acc_balance_not_available\" data-test-id=\"myr-oneViewAccountBalance-balanceAmount-fail\"></span></h4><div ng-if=\"ab.mss.selectedAccountDetail.isPrepaid\"><div ng-show=\"(ab.abdf.accountBalance.balanceAmount*1) >= 0\"><span class=\"\" translate=\"acc_overview_expires_on\" data-test-id=\"myr-accountBalance-expiresOnText\"></span> <span class=\"\" ng-switch=\"\" on=\"ab.mss.selectedAccountDetail.paymentMethod\"><span ng-switch-when=\"D\" translate=\"acc_overview_due_debit\"></span> <span ng-switch-when=\"C\" translate=\"acc_overview_due_credit\"></span> <span ng-switch-when=\"R\" translate=\"acc_overview_due_invoice\"></span> <span ng-switch-default=\"\"></span>:</span> <span class=\"account-balance-amt\" data-test-id=\"myr-accountBalance-expiryDate\">{{ab.mss.selectedAccountDetail.due | date2:ab.mss.selectedAccountDetail.dateDelimiter:\' \':ab.mss.selectedAccountDetail.dateYearPrefix:ab.mss.selectedAccountDetail.dateOrder}}</span></div></div></div></div><div ng-if=\"(isDealer || isCare) && ab.cycleEnd\" class=\"cycle-details\" style=\"min-height:40px;\"><span ng-if=\"ab.cycleEnd\" translate=\"cycle_ends_in\"></span>{{ab.cycleEnd}} <span translate=\"days\"></span></div><div><div class=\"row bill-ctn\"><div ng-if=\"!ab.mss.selectedAccountDetail.isPrepaid\"><div ng-if=\"isDealer || isCare\" class=\"col-xs-8 col-md-6 col-lg-10 pay-now-btn-ctn\" ng-class=\"{\'extraTopMargin\':ab.loadingBalance}\"><button data-ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" ng-click=\"repMakePaymentAccess && ab.payBill()\" data-test-id=\"myr-accountBalance-payBill\" ng-class=\"{\'noAgentPermission\' : !repMakePaymentAccess}\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"make-a-payment,event.selfServeStart\"}\'><span class=\"white\" translate=\"acc_balance_pay_now\"></span></button></div><div ng-if=\"isConsumer\" class=\"col-xs-8 col-sm-4 col-md-6 col-lg-7 pay-now-btn-ctn\" ng-class=\"{\'extraTopMargin\':ab.loadingBalance}\"><button data-ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"make-a-payment,event.selfServeStart\"}\'><span class=\"white\" translate=\"acc_balance_pay_now\"></span></button></div><div ng-show=\"isConsumer && ((ab.rs.isConsumer && !ab.mss.selectedAccountDetail.isPrepaid) || ab.mss.selectedAccountDetail.isViewBillDisplay)\" class=\"col-xs-4 col-sm-4 col-md-6 col-lg-5 pay-bill-ctn\" ng-class=\"{\'extraTopMarginViewBill\':ab.loadingBalance}\"><a class=\"btn-view-bill\" ng-click=\"ab.postToRogers()\" data-ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.isLoadingBriteBill()) ? \'not-active\' : \'\'\" data-ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\"><span translate=\"acc_balance_view_bill\" class=\"bold pointer\" data-test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></a></div></div><div ng-if=\"vm.showTopUpNow()\"><div class=\"col-xs-10 col-sm-10 col-md-8 col-lg-8\"><button data-ng-disabled=\"ab.disableBalance\" data-test-id=\"myr-accountBalance-topUpNowButton\" name=\"postToRogersTop\" class=\"plm prm mbm cta-round primary large\" ng-click=\"ab.postToRogersTop()\"><span class=\"white\" translate=\"acc_overview_top_up_now\"></span></button></div></div></div><div class=\"row credit-limit-ctn\" ng-show=\"(ab.abdf.accountBalance.creditLimit > 0)\"><a class=\"btn-credit-limit-status\" name=\"showPanel\" data-test-id=\"myr-accountBalance-showPanel\"><span translate=\"acc_overview_credit_limit_status\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\" class=\"bold mrs\"></span> <span ng-class=\"ab.isShowPanel == true ? \'fa fa-arrow-circle-o-up\' : \'fa fa-arrow-circle-o-down\'\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\"></span></a><div class=\"check-element credit-limit-info-ctn sample-show-hide\" ng-show=\"ab.isShowPanel\" data-test-id=\"myr-accountBalance-creditLimitInfoCTN\"><div><span translate=\"acc_overview_total_credit_limit\" data-test-id=\"myr-accountBalance-total\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.accountBalance.creditLimit| currencies:ab.lng }} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_outstanding_balance\" data-test-id=\"myr-accountBalance-outstanding\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.accountBalance.balanceAmount| currencies:ab.lng}} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-remainingAmt\">{{(ab.abdf.accountBalance.creditLimit - ab.abdf.accountBalance.balanceAmount) | currencies:ab.lng }} /<span translate=\"_month\"></span></span></div></div></div></div><div id=\"form-view-bill\" ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNumber\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-value=\"ab.getBriteBillInvoiceDates()\" name=\"briteBillInvoiceDates\"></form><form name=\"formToRogersTop\" id=\"formToRogersTop\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.ctnNumber\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.pinNumber\" name=\"passCode\"><br>Flow: <input type=\"text\" value=\"TOP\" name=\"flowId\"><br></form></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.prepaid.html","<div class=\"account-balance-prepaid medium-font-size container\"><div class=\"col-xs-12 col-md-4\"><h4 class=\"one-view-account-balance-title\" ng-if=\"isDealer || isCare\" translate=\"acc_balance\" data-test-id=\"myr-accountBalance-acc_balance\"></h4><h4 class=\"account-balance-title\" ng-if=\"isConsumer\" translate=\"ute.rogers.account.balance.current.account.balance\" data-test-id=\"myr-accountBalance-acc_balance\"></h4><span class=\"widget-loader-inline position-abs\" ng-show=\"ab.loadingBalance\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div id=\"wrapper\" data-ng-hide=\"ab.loadingBalance\"><div class=\"account-balance-ctn\"><div class=\"\" ng-if=\"isConsumer\"><span ng-show=\"!ab.abdf.accountBalance && !ab.abs.loadingData\" translate=\"acc_balance_not_available\" data-test-id=\"myr-accountBalance-balanceAmount-fail\"></span><div class=\"rogers-amount\"><div class=\"price\"><span class=\"price-sign\" ng-hide=\"ab.lng === \'fr\'\">$</span> <span class=\"price-dollars\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span> <span class=\"price-details\"><span class=\"price-cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}} <span ng-hide=\"ab.lng ===\'en\'\">$</span></span> <span class=\"price-period\">&nbsp;</span></span></div></div></div><h4 class=\"one-view-account-balance\" ng-if=\"isDealer || isCare\"><span ng-show=\"ab.abdf.accountBalance && !ab.abs.loadingData\" data-test-id=\"myr-oneViewAccountBalance-balanceAmount-success\">{{ab.abdf.accountBalance.balanceAmount | currencies:ab.lng}}</span> <span ng-show=\"!ab.abdf.accountBalance && !ab.abs.loadingData\" translate=\"acc_balance_not_available\" data-test-id=\"myr-oneViewAccountBalance-balanceAmount-fail\"></span></h4><div ng-if=\"ab.mss.selectedAccountDetail.isPrepaid\"><div ng-show=\"((ab.abdf.accountBalance.balanceAmount*1) >= 0)\"><span class=\"\" translate=\"acc_overview_expires_on\" data-test-id=\"myr-accountBalance-expiresOnText\"></span> <span class=\"\" ng-switch=\"\" on=\"ab.mss.selectedAccountDetail.paymentMethod\"><span ng-switch-when=\"D\" translate=\"acc_overview_due_debit\"></span> <span ng-switch-when=\"C\" translate=\"acc_overview_due_credit\"></span> <span ng-switch-when=\"R\" translate=\"acc_overview_due_invoice\"></span> <span ng-switch-default=\"\"></span>:</span> <span class=\"account-balance-amt\" data-test-id=\"myr-accountBalance-expiryDate\">{{ab.mss.selectedAccountDetail.due | date2:ab.mss.selectedAccountDetail.dateDelimiter:\' \':ab.mss.selectedAccountDetail.dateYearPrefix:ab.mss.selectedAccountDetail.dateOrder}}</span></div></div></div></div><div ng-if=\"(isDealer || isCare) && ab.cycleEnd\" class=\"cycle-details\"><span ng-if=\"ab.cycleEnd\" translate=\"cycle_ends_in\"></span>{{ab.cycleEnd}} <span translate=\"days\"></span></div><div><div class=\"row bill-ctn\"><div ng-if=\"vm.showTopUpNow()\"><div class=\"col-xs-10 col-md-8\"><button data-ng-disabled=\"ab.disableBalance\" data-test-id=\"myr-accountBalance-topUpNowButton\" name=\"postToRogersTop\" class=\"plm prm mbm cta-round primary large\" ng-click=\"ab.postToRogersTop()\"><span class=\"white\" translate=\"acc_overview_top_up_now\"></span></button></div></div></div><div class=\"row credit-limit-ctn\" ng-show=\"(ab.abdf.accountBalance.creditLimit > 0)\"><a class=\"btn-credit-limit-status\" name=\"showPanel\" data-test-id=\"myr-accountBalance-showPanel\"><span translate=\"acc_overview_credit_limit_status\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\" class=\"bold mrs\"></span> <span ng-class=\"ab.isShowPanel == true ? \'fa fa-arrow-circle-o-up\' : \'fa fa-arrow-circle-o-down\'\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\"></span></a><div class=\"check-element credit-limit-info-ctn sample-show-hide\" ng-show=\"ab.isShowPanel\" data-test-id=\"myr-accountBalance-creditLimitInfoCTN\"><div><span translate=\"acc_overview_total_credit_limit\" data-test-id=\"myr-accountBalance-total\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.accountBalance.creditLimit| currencies:ab.lng }} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_outstanding_balance\" data-test-id=\"myr-accountBalance-outstanding\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.accountBalance.balanceAmount| currencies:ab.lng}} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-remainingAmt\">{{(ab.abdf.accountBalance.creditLimit - ab.abdf.accountBalance.balanceAmount) | currencies:ab.lng }} /<span translate=\"_month\"></span></span></div></div></div></div><div id=\"form-view-bill\" style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNumber\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-model=\"ab.rs.briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form><form name=\"formToRogersTop\" id=\"formToRogersTop\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.ctnNumber\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.pinNumber\" name=\"passCode\"><br>Flow: <input type=\"text\" value=\"TOP\" name=\"flowId\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-model=\"ab.rs.briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"><br></form><form name=\"formToRogersPrepaid\" id=\"formToRogersPrepaid\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" id=\"ban\" name=\"ban\"> CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.ctnNumber\" name=\"ctn\"> PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.accountDetails.pinNumber\" name=\"passCode\"> Flow: <input type=\"text\" id=\"flowId\" name=\"flowId\"></form></div></div><div ng-if=\"isConsumer\"><div class=\"col-xs-12 col-md-5\"><div class=\"col-xs-12 extenal-link-container\"><a data-ng-click=\"ab.postToRogersPrepaid(2)\" ng-keypress=\"ab.postToRogersPrepaid(2)\" translate=\"change_method_update\" class=\"extenal-link\"></a> <span class=\"rui-icon-button-arrow-right font-s\"></span></div><div class=\"col-xs-12 extenal-link-container\"><a data-ng-click=\"ab.postToRogersPrepaid(3, \'TRH\')\" ng-keypress=\"ab.postToRogersPrepaid(3, \'TRH\')\" translate=\"ute.rogers.account.balance.view.call\" class=\"extenal-link\"></a> <span class=\"rui-icon-button-arrow-right font-s\"></span></div></div><div class=\"col-xs-12 col-md-3\"><div class=\"col-xs-12\"><button name=\"postToRogersTop\" class=\"cta-round action-button\" data-ng-click=\"ab.postToRogersTop()\"><span class=\"white\" translate=\"acc_overview_top_up_now\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.viewBill.html","<div ng-if=\"ab.isCLM && ab.usedCLMpercentage > 60 && !ab.isSuspended()\" class=\"credit-limit-overlay\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\"><div class=\"title\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.titleCLM}}\"></div><div class=\"description\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.descCLM}}\"></div></div><div ng-if=\"ab.isDesktopView() || !ab.isSuspended()\" class=\"account-balance-overview row\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60}\"><div class=\"suspended-warning\" ng-if=\"ab.isSuspended()\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><span class=\"suspended-message\" translate=\"ute.rogers.account.balance.suspended_msg\"></span><div class=\"live-chat-link-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-link-suspended\"></bold-chat-static-button></div></div><div class=\"col-md-4 balance-section view-bill\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60, \'extra-height\': ab.isCCExpiring || ab.isCCExpired, \'pad-bot\' : ab.isCLM && ab.usedCLMpercentage < 60}\"><div class=\"row\"><div class=\"col-xs-6 total-balance\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div><div class=\"col-xs-6 credit-limit view-bill\" ng-if=\"ab.isCLM && !ab.isSuspended()\" ng-class=\"{ \'height-pad\': ab.isCCExpiring || ab.isCCExpired, \'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100, \'add-extra-pad-narrow\': !ab.displayPaymentDate() || ab.usedCLMpercentage >= 100}\"><div class=\"row total-credit-limit\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.credit_limit\" data-test-id=\"myr-accountBalance-total\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" ata-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span></div><div class=\"row used-and-remaining\" ng-if=\"!(ab.usedCLMpercentage >= 100)\"><div><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span> <span translate=\"ute.rogers.account.balance.used_credit\" data-test-id=\"myr-accountBalance-outstanding\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span></div><div ng-class=\"{\'remaining\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100 }\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span></div></div><div class=\"row used-and-remaining recommended-pay view-bill\" ng-if=\"ab.usedCLMpercentage >= 100\"><span translate=\"ute.rogers.account.balance.recommended_pay\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.recommendedPaymentAmount) | currencies:ab.lng }}</span></div></div></div><div class=\"row\"><div class=\"payment-date view-bill\" ng-if=\"ab.displayPaymentDate()\"><span translate=\"ute.rogers.account.balance.required_payment_date\"></span> <span ng-bind-html=\"ab.billDueDate | uteCanadianDate\"></span></div></div></div><div class=\"col-md-5 payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" view-bill=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"col-md-3 action-buttons\" ng-class=\"{\'is-expiring-bg\': ab.isCCExpiring, \'is-expired-bg\': ab.isCCExpired, \'view-bill\': ab.rs.currentStateName === \'viewbill\', \'payment-history\': ab.rs.currentStateName === \'paymenthistory\'}\"><div ng-if=\"ab.rs.currentStateName === \'paymenthistory\'\"><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"{{ab.rs.currentStateName}}\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div></div><div class=\"account-balance-overview row\" ng-if=\"!ab.isDesktopView() && ab.isSuspended()\"><div class=\"suspended-warning suspended-warning-mobile\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><div class=\"row message-section\"><div><span translate=\"ute.rogers.account.balance.suspended_msg\"></span></div><div><div class=\"live-chat-icon-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-icon-suspended\"></bold-chat-static-button></div></div></div><div class=\"balance-section\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div></div><div class=\"payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" view-bill=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"action-buttons\" ng-class=\"{\'is-expiring-bg\': ab.isCCExpiring, \'is-expired-bg\': ab.isCCExpired, \'view-bill\': ab.rs.currentStateName === \'viewbill\', \'payment-history\': ab.rs.currentStateName === \'paymenthistory\'}\"><div ng-if=\"ab.rs.currentStateName === \'paymenthistory\'\"><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"{{ab.rs.currentStateName}}\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalance.viewBillOneView.html","<div ng-if=\"ab.isCLM && ab.usedCLMpercentage > 60 && !ab.isSuspended()\" class=\"credit-limit-overlay one-view\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\"><div class=\"title\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.titleCLM}}\"></div><div class=\"description\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.descCLM}}\"></div></div><div class=\"account-balance-overview row one-view\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60, \'bottom-left-sharp-corner\': ab.displayPaymentDate()}\"><div class=\"suspended-warning one-view\" ng-if=\"(!isCare && ab.isSuspended())\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><div class=\"suspended-message\"><span translate=\"ute.rogers.account.balance.oneView.suspendedMsg\"></span> <a href=\"#\" ng-click=\"repMakePaymentAccess && ab.payBill()\"><span translate=\"ute.rogers.account.balance.make_a_payment\"></span> <span class=\"rui-icon-arrow-right arrow-icon\"></span></a></div></div><div class=\"account-details-wrapper\"><div class=\"col-md-4 balance-section view-bill\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60, \'extra-height\': ab.isCCExpiring || ab.isCCExpired, \'pad-bot\' : ab.isCLM && ab.usedCLMpercentage < 60}\"><div class=\"row\"><div class=\"total-balance one-view\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.oneView.accountBalance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div><div class=\"credit-limit view-bill one-view\" ng-if=\"ab.isCLM && !ab.isSuspended()\" ng-class=\"{ \'height-pad\': ab.isCCExpiring || ab.isCCExpired, \'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100, \'add-extra-pad-narrow\': !ab.displayPaymentDate() || ab.usedCLMpercentage >= 100}\"><div class=\"row total-credit-limit\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.credit_limit\" data-test-id=\"myr-accountBalance-total\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" ata-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span></div><div class=\"row used-and-remaining\" ng-if=\"!(ab.usedCLMpercentage >= 100)\"><div><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span> <span translate=\"ute.rogers.account.balance.used_credit\" data-test-id=\"myr-accountBalance-outstanding\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span></div><div ng-class=\"{\'remaining\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100 }\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span></div></div><div class=\"row used-and-remaining recommended-pay view-bill\" ng-if=\"ab.usedCLMpercentage >= 100\"><span translate=\"ute.rogers.account.balance.recommended_pay\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.recommendedPaymentAmount) | currencies:ab.lng }}</span></div></div></div><div class=\"row\"><div class=\"payment-date view-bill\" ng-if=\"ab.displayPaymentDate()\"><span translate=\"ute.rogers.account.balance.required_payment_date\"></span> <span ng-bind-html=\"ab.billDueDate | uteCanadianDate\"></span></div></div></div><div class=\"payment-details one-view\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" one-view-account-balance=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method><div class=\"action-buttons\"><button ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" class=\"pay-now-btn\" ng-click=\"repMakePaymentAccess && ab.payBill()\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button> <button name=\"makeAdjustment\" ng-if=\"repCreditManagementAccess && showAdjustmentButton\" class=\"white-btn make-adjustment-btn\" ng-click=\"ab.creditAdjustment()\" tabindex=\"0\"><span>{{ \'creditadjustment_credit_management\' | translate}}</span></button></div></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalanceHorizon.html","<div class=\"directive-account-balance medium-font-size\" ng-cloak=\"\"><div class=\"row\"><div class=\"col-xs-12 prm\"><div class=\"row\"><div data-ng-if=\"(ab.rs.isConsumer && !ab.mss.selectedAccountDetail.isPrepaid) || ab.mss.selectedAccountDetail.isViewBillDisplay\" class=\"col-xs-12 cta-links-sub-ctn\"><button data-ng-hide=\"ab.rs.currentStateName === \'viewbill\' || ab.rs.currentStateName === \'paynow\'\" class=\"cta-round primary large white-btn view-bill-btn-cm3\" data-ng-click=\"ab.postToRogers()\" data-ng-class=\"ab.btnSettings.viewBill === ab.btnStatus.disabled ? \'not-active\' : \'\'\" name=\"viewBill\" tabindex=\"0\"><span class=\"red\" translate=\"acc_balance_view_bill\"></span></button> <button data-ng-hide=\"ab.rs.currentStateName === \'viewbill\' || ab.rs.currentStateName === \'changemethod\' || ab.rs.currentStateName === \'paymenthistory\'\" name=\"payBill\" class=\"cta-round primary large view-bill-btn-cm2\" data-ng-click=\"ab.postToRogers()\" data-test-id=\"myr-accountBalanceHorizon-payBill\" tabindex=\"0\"><span class=\"white\" translate=\"acc_balance_view_bill\"></span></button></div></div><div class=\"pbm\"><div ng-if=\"ab.selectedAccount === 9\"><div><button name=\"postToRogersTop\" class=\"plm prm cta-round primary large\" data-ng-click=\"ab.postToRogersTop()\" tabindex=\"0\"><span class=\"white\" translate=\"acc_overview_top_up_now\"></span></button></div></div></div></div><div id=\"form-view-bill\" style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNumber\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-value=\"ab.getBriteBillInvoiceDates()\" name=\"briteBillInvoiceDates\"></form><form name=\"formToRogersTop\" id=\"formToRogersTop\" method=\"post\" novalidate=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.rs.ao.accountDetails.ctnNumber\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.rs.ao.accountDetails.pinNumber\" name=\"passCode\"><br>Flow: <input type=\"text\" value=\"TOP\" name=\"flowId\"><br></form></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/accountBalancePaymentEnhancements.html","<div class=\"directive-account-balance-payment-enhancements medium-font-size row\"><div class=\"info-section col-xs-12 col-sm-5 col-md-4 col-lg-4\"><div class=\"account-balance-title\"><h2 class=\"account-balance-heading\" data-translate=\"myr.modules.accountBalance.your.account.balance\" data-test-id=\"myr-accountBalance-acc_balance\"></h2></div><div class=\"amount-section\"><span class=\"widget-loader-inline position-abs\" ng-show=\"ab.loadingBalance\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><span class=\"\" ng-hide=\"ab.lng === \'fr\'\">$</span><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><span class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</span><span ng-hide=\"ab.lng ===\'en\'\">$</span></div><span ng-show=\"!ab.abdf.accountBalance && !ab.abs.loadingData\" translate=\"acc_balance_not_available\" data-test-id=\"myr-accountBalance-balanceAmount-fail\"></span></div></div><div class=\"button-section col-xs-12 col-sm-7 col-md-8\"><div class=\"row\"><div class=\"col-xs-12 pay-now-btn-ctn\" data-ng-class=\"{\'col-sm-8 col-md-9\': (ab.lng === \'en\'), \'col-sm-6 col-md-8\': (ab.lng === \'fr\')}\"><button data-ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span class=\"white\" data-translate=\"myr.modules.accountBalance.make.a.payment\"></span></button></div><div class=\"col-xs-12 pay-bill-ctn\" data-ng-class=\"{\' col-sm-4 col-md-3\': (ab.lng === \'en\'), \'col-sm-6 col-md-4\': (ab.lng === \'fr\')}\"><button class=\"btn-view-bill\" ng-click=\"ab.postToRogers()\" data-ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" data-ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span data-translate=\"myr.modules.accountBalance.view.my.bill\" class=\"bold pointer\" data-test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div></div></div><div class=\"row credit-limit-ctn col-xs-12\" ng-if=\"(ab.abdf.accountBalance.creditLimit > 0)\"><a class=\"btn-credit-limit-status\" name=\"showPanel\" data-test-id=\"myr-accountBalance-showPanel\"><span translate=\"acc_overview_credit_limit_status\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\" class=\"bold mrs\"></span> <span ng-class=\"ab.isShowPanel == true ? \'fa fa-arrow-circle-o-up\' : \'fa fa-arrow-circle-o-down\'\" ng-click=\"ab.isShowPanel = !ab.isShowPanel\"></span></a><div class=\"check-element credit-limit-info-ctn sample-show-hide\" ng-show=\"ab.isShowPanel\" data-test-id=\"myr-accountBalance-creditLimitInfoCTN\"><div><span translate=\"acc_overview_total_credit_limit\" data-test-id=\"myr-accountBalance-total\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.accountBalance.creditLimit| currencies:ab.lng }} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_outstanding_balance\" data-test-id=\"myr-accountBalance-outstanding\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.accountBalance.balanceAmount| currencies:ab.lng}} /<span translate=\"_month\"></span></span></div><div><span translate=\"acc_overview_remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span>: <span class=\"bold\" data-test-id=\"myr-accountBalance-remainingAmt\">{{(ab.abdf.accountBalance.creditLimit - ab.abdf.accountBalance.balanceAmount) | currencies:ab.lng }} /<span translate=\"_month\"></span></span></div></div></div><div id=\"form-view-bill\" data-ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNumber\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-model=\"ab.rs.briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form></div></div>");
$templateCache.put("scripts/modules/accountBalance/narrowAccountBalance.accountOverview.html","<div class=\"welcome-message\"><div class=\"welcome-bar\"></div><div><span translate=\"ute.rogers.account.balance.welcome_back\" ng-if=\"!ab.appState.isLinked\"></span> <span translate=\"ute.rogers.account.balance.welcome\" ng-if=\"ab.appState.isLinked\"></span> <span class=\"capitalize\">{{ab.getName()}}</span></div></div><div ng-if=\"ab.isCLM && ab.usedCLMpercentage > 60 && !ab.isSuspended()\" class=\"credit-limit-overlay\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\"><div class=\"title\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.titleCLM}}\"></div><div class=\"description\" ng-class=\"{\'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100}\" translate=\"{{::ab.descCLM}}\"></div></div><div ng-if=\"ab.isDesktopView() || !ab.isSuspended()\" class=\"account-balance-overview narrow-box row\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60}\"><div class=\"suspended-warning\" ng-if=\"ab.isSuspended()\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><span class=\"suspended-message\" translate=\"ute.rogers.account.balance.suspended_msg\"></span><div class=\"live-chat-link-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-link-suspended\"></bold-chat-static-button></div></div><div class=\"col-md-4 balance-section\" ng-class=\"{\'reset-top\': ab.isCLM && ab.usedCLMpercentage > 60, \'pad-bot\' : ab.isCLM && ab.usedCLMpercentage < 60 }\"><div class=\"row\"><div class=\"col-xs-6 total-balance\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div><div class=\"col-xs-6 credit-limit\" ng-if=\"ab.isCLM && !ab.isSuspended()\" ng-class=\"{ \'orange\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 75, \'grey\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100, \'red\': ab.usedCLMpercentage >= 100, \'add-extra-pad-narrow\': !ab.displayPaymentDate() || ab.usedCLMpercentage >= 100}\"><div class=\"row total-credit-limit\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.credit_limit\" data-test-id=\"myr-accountBalance-total\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" ata-test-id=\"myr-accountBalance-totalAmt\">{{ab.abdf.billingDetails.creditLimit| currencies:ab.lng }}</span></div><div class=\"row used-and-remaining\" ng-if=\"!(ab.usedCLMpercentage >= 100)\"><div><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span> <span translate=\"ute.rogers.account.balance.used_credit\" data-test-id=\"myr-accountBalance-outstanding\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-outstandingAmt\">{{ab.abdf.billingDetails.usedCLM | currencies:ab.lng}}</span></div><div ng-class=\"{\'remaining\': ab.usedCLMpercentage > 75 && ab.usedCLMpercentage < 100 }\"><span ng-if=\"ab.lng === \'en\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span> <span translate=\"ute.rogers.account.balance.remaining_credit\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" ng-if=\"ab.lng === \'fr\'\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.availableCreditAmount) | currencies:ab.lng }}</span></div></div><div class=\"row used-and-remaining recommended-pay\" ng-if=\"ab.usedCLMpercentage >= 100\"><span translate=\"ute.rogers.account.balance.recommended_pay\" data-test-id=\"myr-accountBalance-remaining\"></span> <span class=\"fr-amount\" data-test-id=\"myr-accountBalance-remainingAmt\">{{( ab.abdf.billingDetails.recommendedPaymentAmount) | currencies:ab.lng }}</span></div></div></div><div class=\"row\"><div class=\"payment-date\" ng-if=\"ab.displayPaymentDate()\"><span translate=\"ute.rogers.account.balance.required_payment_date\"></span><span ng-bind-html=\"ab.billDueDate | uteCanadianDate\"></span></div></div></div><div class=\"col-md-5 payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" account-balance=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"col-md-3 action-buttons\"><div><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div></div><div class=\"account-balance-overview row\" ng-if=\"!ab.isDesktopView() && ab.isSuspended()\"><div class=\"suspended-warning suspended-warning-mobile\"><div class=\"title\" translate=\"ute.rogers.account.balance.suspended\"></div><div class=\"row message-section\"><div><span translate=\"ute.rogers.account.balance.suspended_msg\"></span></div><div><div class=\"live-chat-icon-suspended-container\"><bold-chat-static-button cbid=\"{{\'ute.rogers.account.balance.boldchat_cbid\' | translate}}\" dynamic-div=\"chat\" chat-button=\"live-chat-icon-suspended\"></bold-chat-static-button></div></div></div><div class=\"balance-section\"><div class=\"balance-label\"><span translate=\"ute.rogers.account.balance.total_balance\"></span></div><div class=\"amount\" data-ng-show=\"!ab.loadingBalance\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div></div><div class=\"action-buttons\"><div><button title=\"{{\'ute.rogers.account.balance.view_current_bill\' | translate}}\" class=\"white-btn\" ng-click=\"ab.postToRogers()\" ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.bb.loadingBriteBill) ? \'not-active\' : \'\'\" ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" tabindex=\"0\"><span translate=\"ute.rogers.account.balance.view_your_bill\" class=\"pointer\" test-id=\"myr-accountBalance-acc_balance_view_bill\"></span></button></div><div ng-class=\"{\'first-button\': !ab.isPaymentBtnWhite()}\"><button title=\"{{\'ute.rogers.account.balance.make_a_payment\' | translate}}\" ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled || ab.btnSettings.payNow === ab.btnStatus.hidden\" name=\"payBill\" ng-class=\"{true:\'white-btn\', false:\'red-btn\'}[ab.isPaymentBtnWhite()]\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.selectedAccountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span ng-class=\"{\'white\': !ab.isPaymentBtnWhite()}\" translate=\"ute.rogers.account.balance.make_a_payment\"></span></button></div></div><div class=\"payment-details\"><ute-payment-method selected-account=\"ab.selectedAccountDetails\" account-balance=\"\" payment-method-changed-callback=\"ab.paymentMethodChangedCallback(method)\"></ute-payment-method></div></div></div>");
$templateCache.put("scripts/modules/accountBalance/ovoPaymentWidgetAccountBalance.html","<div class=\"payment-widget-account-balance-info\" ng-show=\"ab.abdf.accountBalance.balanceAmount\"><div class=\"total-balance\"><div class=\"total-balance-title\" translate=\"ute.rogers.account.balance.ovo_total_balance\" ng-class=\"{\'right-margin\': ab.lng === \'fr\' && ab.agingBucketsDisplayCheck()}\"></div><div class=\"amount\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.balanceAmount.substr(0,ab.abdf.accountBalance.balanceAmount.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.balanceAmount | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></div><sup class=\"aging-bucket-arrow-delinq-indicator-container\"><span ng-if=\"ab.delinquencyIndicatorDisplayCheck()\" class=\"rui-icon-alert-i delinquent-indicator\" aria-hidden=\"false\" style=\"\"></span><div class=\"bucket-arrow-mark\" ng-if=\"ab.agingBucketsDisplayCheck()\" ng-click=\"ab.checkAndPopulateAgingBuckets()\" tabindex=\"0\" role=\"button\" style=\"\"><i id=\"bucket-arrow-mark\" class=\"rui-icon-tick\"></i></div></sup><generic-closable-popup open-popup=\"ab.openBucketsPopup\" popup-open-target=\"bucket-arrow-mark\" popup-close-target=\"close-icon\" popup-class-name=\"buckets-popup\"><div ng-if=\"ab.agingBucketsDisplayCheck()\" class=\"buckets-popup\" id=\"popup-buckets\" ng-class=\"{\'display-buckets-popup\' : ab.openBucketsPopup, \'delinquency-border\': ab.delinquencyIndicatorDisplayCheck(), \'buckets-popup-with-delinquency\': ab.delinquencyIndicatorDisplayCheck()}\"><div id=\"close-icon\" class=\"popup-close-icon\"></div><div class=\"aging-buckets\"><div ng-if=\"ab.delinquencyIndicatorDisplayCheck()\" class=\"bucket-list bucket-list-delinquency-indicator\"><span class=\"rui-icon-alert-i delinquency-icon\"></span> <span translate=\"ute.rogers.account.balance.delinquent\" class=\"delinquency-text\"></span></div><div ng-repeat=\"bucket in ab.pastDueBuckets track by $index\" class=\"bucket-list\"><span class=\"bucket-label\">{{bucket.name | translate}}</span> <span class=\"bucket-amount\"><span ng-if=\"ab.lng === \'en\' && bucket.amount !== \'-\'\">$</span> {{bucket.amount | number: 2}} <span ng-if=\"ab.lng === \'fr\' && bucket.amount !== \'-\'\">$</span></span></div></div></div></generic-closable-popup></div><div class=\"payment-links\"><div ng-if=\"!ab.mss.selectedAccountDetail.isPrepaid\"><div ng-if=\"isDealer || isCare\" ng-class=\"{\'extraTopMargin\':ab.loadingBalance}\"><button data-ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" ng-click=\"repMakePaymentAccess && ab.payBill()\" data-test-id=\"myr-accountBalance-payBill\" ng-class=\"{\'noAgentPermission\' : !repMakePaymentAccess}\"><span class=\"white capitalize\" ng-class=\"{\'btn-text-fr\': (ab.lng ===\'fr\')}\" translate=\"ute.rogers.account.balance.ovo_take_payment\"></span></button></div><div ng-if=\"isConsumer\" ng-class=\"{\'extraTopMargin\':ab.loadingBalance}\"><button data-ng-disabled=\"ab.disableBalance || !ab.abdf.accountBalance\" data-ng-hide=\"ab.btnSettings.payNow === ab.btnStatus.disabled\" name=\"payBill\" class=\"pay-now-btn cta-round primary large\" data-test-id=\"myr-accountBalance-payBill\" ute-pay-now-button=\"\" account-balance=\"ab.abdf.accountBalance\" account-details=\"ab.mss.accountDetails\" parent-state=\"accountOverview\" tabindex=\"0\"><span class=\"white capitalize\" ng-class=\"{\'btn-text-fr\': (ab.lng ===\'fr\')}\" translate=\"ute.rogers.account.balance.ovo_take_payment\"></span></button></div></div><a class=\"btn-view-bill pointer\" ng-click=\"ab.creditAdjustment()\" ng-if=\"repCreditManagementAccess && showAdjustmentButton\"><span translate=\"ute.rogers.account.balance.ovo_make_adjustment\" class=\"bold\">Make Adjustment</span></a></div><div class=\"due-date\" ng-if=\"!!ab.ovobillDueDate || ab.ovoptpDate\"><div class=\"due-date-actual\" ng-if=\"!!ab.ovobillDueDate\"><span translate=\"ute.rogers.account.balance.ovo_due_text\"></span> <span class=\"due-date-value\">: {{ab.ovobillDueDate}}</span></div><div class=\"ptp-date\" ng-class=\"{\'ptp-date-no-req-payment-date\': !ab.ovobillDueDate}\" ng-if=\"!!ab.ovoptpDate\"><span translate=\"ute.rogers.account.balance.ovo_ptp_text\"></span> <span class=\"ptp-date-value\">: {{ab.ovoptpDate}}</span></div></div></div><one-view-last-bill view-html=\"ovoPaymentWidgetLastBill.html\" disable-balance=\"disableBalance\" loading-balance=\"loadingBalance\" loading-brite-bill=\"loadingBriteBill\"></one-view-last-bill>");
$templateCache.put("scripts/modules/accountBalance/ovoPaymentWidgetCreditLimitInfo.html","<div class=\"payment-widget-credit-limit-info\"><div ng-if=\"ab.isCLM && ab.usedCLMpercentage > 60\" class=\"credit-limit\"><div class=\"credit-limit-notification\" ng-class=\"{\'yellow\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 100, \'lightred\': ab.usedCLMpercentage >= 100}\"><div class=\"credit-limit-heading testing-1\"><div class=\"message\"><span class=\"rui-icon-alert-i icon\"></span> <span ng-if=\"ab.lng === \'en\' && ab.abdf.accountBalance.availableCreditAmount == 0\" translate=\"ute.rogers.account.balance.ovo_credit_limit_exceeded_text\"></span> <span ng-if=\"ab.lng === \'en\' && ab.abdf.accountBalance.availableCreditAmount!=0\" translate=\"ute.rogers.account.balance.ovo_credit_limit_text\" translate-values=\"{amount:( ab.abdf.accountBalance.availableCreditAmount | currencies: ab.lng) }\"></span><span ng-if=\"ab.lng === \'fr\' && ab.abdf.accountBalance.availableCreditAmount == 0\" translate=\"ute.rogers.account.balance.ovo_credit_limit_exceeded_text\"></span> <span ng-if=\"ab.lng === \'fr\' && ab.abdf.accountBalance.availableCreditAmount != 0\" translate=\"ute.rogers.account.balance.ovo_credit_limit_text\" translate-values=\"{amount:( ab.abdf.accountBalance.availableCreditAmount | currencies: ab.lng)}\"></span></div><div class=\"details-link\" ng-if=\"ab.abdf.accountBalance.availableCreditAmount != 0\"><a name=\"showPanel\"><span ng-click=\"ab.isShowPanel = !ab.isShowPanel\" ng-class=\"{\'rui-icon-chevron-down\': !ab.isShowPanel, \'rui-icon-chevron-up\': ab.isShowPanel}\"></span></a></div></div><div class=\"credit-limit-details\" ng-if=\"ab.isShowPanel\" ng-class=\"{\'yellow-border\': ab.usedCLMpercentage > 60 && ab.usedCLMpercentage < 100, \'lightred-border\': ab.usedCLMpercentage >= 100}\"><div class=\"total-credit\"><span class=\"amount\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{((ab.abdf.accountBalance.creditLimit+\'\').indexOf(\'.\')>0)? (ab.abdf.accountBalance.creditLimit+\'\').substr(0,(ab.abdf.accountBalance.creditLimit+\'\').indexOf(\'.\')) : ab.abdf.accountBalance.creditLimit}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.creditLimit | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></span> <span translate=\"ute.rogers.account.balance.ovo_credit_limit_total_credit_text\"></span></div><div class=\"credit-used\"><span class=\"amount\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{((ab.usedCLM+\'\').indexOf(\'.\')>0)? (ab.usedCLM+\'\').substr(0,(ab.usedCLM+\'\').indexOf(\'.\')) : (ab.usedCLM+\'\')}}</span><sup class=\"cents\">{{ab.usedCLM | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></span> <span translate=\"ute.rogers.account.balance.ovo_credit_limit_credit_used_text\"></span></div></div></div></div></div>");
$templateCache.put("scripts/modules/accountList/accountOverviewLinkModal.html","<div class=\"totes-project\"><div class=\"module-account-overview-dialog\" id=\"myModal4\" data-test-id=\"myr-accountOverviewLinkModal-myModal4\"><div class=\"row\"><div class=\"col-xs-12\"><h1></h1><h3 translate=\"acc_overview_which_account\"></h3></div></div><div class=\"row\"><ul class=\"list-of-accounts pln\"><li ng-repeat=\"value in ::alm.als.accountTypes\" ng-click=\"alm.selectAccountModal(value); closeThisDialog(\'Cancel\')\" tabindex=\"-1\"><div class=\"account-ctn\" ng-class=\"{warning: value.accountStatusSimple == \'Warning\', error: value.accountStatusSimple === \'Error\'}\" tabindex=\"0\"><div class=\"account-name-ctn\" data-ng-if=\"!value.nickName\"><span class=\"account-name-txt\">{{::value.accountName.firstName| capitalize}}</span></div><div class=\"account-name-ctn\" data-ng-if=\"::value.nickName\"><span class=\"account-name-txt\">{{::value.nickName}}</span></div><div class=\"account-number-ctn\"><span class=\"account-number-txt\"><span class=\"rui-icon-error-icon error-red\" ng-if=\"value.accountStatusSimple === \'Error\'\"></span> <span class=\"rui-icon-warning warning-color\" ng-if=\"value.accountStatusSimple === \'Warning\'\"></span> <span>{{value.accountNumber}}</span></span></div><div class=\"account-txt-warning\" ng-if=\"value.accountStatusSimple === \'Warning\'\"><span translate=\"{{value.accountStatusModalMessage}}\"></span></div><div class=\"account-txt-error\" ng-if=\"value.accountStatusSimple === \'Error\'\"><span translate=\"{{value.accountStatusModalMessage}}\"></span></div></div></li></ul></div></div></div>");
$templateCache.put("scripts/modules/accountOverview/accountOverview.html","<h1 class=\"screen-read-only\" translate=\"account_overview_heading\"></h1><section class=\"page-account-overview\"><div style=\"display: none;\"><myr-account-list></myr-account-list></div><div class=\"container\"><onboarding account-details=\"ao.selectedAccountDetails\" onboarding-emit-status=\"ao.onboardingStatus(status)\" ng-if=\"!!ao.selectedAccountDetails && isConsumer\"></onboarding></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><myr-notification-banner class=\"ng-hide\" data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div></div><div class=\"row\"><div class=\"col-xs-12\"><myr-notification-banner class=\"ng-hide\" data-banner-id=\"successMessage\" type=\"success\"></myr-notification-banner></div></div></div><div class=\"container\"><div class=\"row pbl mtm\" ng-if=\"ao.als.selectedAccount.accountCancelled\"><div class=\"col-xs-12\"><div class=\"row info-banner\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'error\' : \'warning-border\'\" data-ng-if=\"ao.showErrorMessages()\"><div class=\"col-xs-2 col-sm-1\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon-alert\'\"></span></div><div data-ng-if=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-11 col-md-11 col-lg-11\"><span class=\"v-base-line mbs\" translate=\"acc_overview_account_limited\" style=\"font-weight:normal\" data-test-id=\"myr-accountOverview-acc_overview_account_limited\"></span><br><span class=\"mtl\"><a data-ng-if=\"isbritebillAvailable\" class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\">- <span translate=\"acc_overview_view_bill\"></span></a><br><a ng-click=\"ao.viewHistory()\" class=\"pointer\">- <span translate=\"acc_overview_view_bill_history\"></span></a><br><a data-ng-if=\"isConsumer\" ng-click=\"ao.runRogersProfile()\" class=\"pointer\">- <span translate=\"acc_overview_manage_profile\" data-test-id=\"myr-accountOverview-acc_overview_manage_profile\"></span></a></span></div><div class=\"pull-right ptm pbm mrm pay-now-btn-ctn\" data-ng-if=\"ao.abdf.accountBalance.isCLM && ao.als.selectedAccount\"><button name=\"payBill\" class=\"plm prm cta-round primary large\" ng-click=\"ao.payBill()\" data-test-id=\"myr-accountOverview-payBill\"><span class=\"white\" translate=\"acc_overview_pay_now\"></span></button></div></div></div></div><div class=\"row pbl mtm\" data-ng-if=\"ao.mss.selectedAccountDetail.isPrepaid === false && ao.showGoPaperless\"><ute-go-paperless></ute-go-paperless></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><span class=\"widget-loader\" data-ng-show=\"ao.loadingDataIndicator || ao.mss.loadingData\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div><div class=\"container\"><div class=\"row\"><div ng-if=\"ao.errorMessage\"><validation-error-box error-message=\"ao.errorMessage\" live-chat-params=\"ao.maintenanceLiveChatParams\"></validation-error-box></div><div data-ng-show=\"!ao.mss.loadingData && !ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row ptm\"><myr-account-balance view-html=\"accountBalance.accountOverviewWrapper.html\"></myr-account-balance><div class=\"col-xs-12 col-md-5 col-lg-4\"><div class=\"hidden-md hidden-lg\" style=\"height:30px\"></div><div ng-if=\"ao.als.selectedAccount.accountNumber\"><ute-pending-order></ute-pending-order></div></div></div><div class=\"row my-services-list-ctn\" data-ng-hide=\"ao.btnSettings.allSubscriptions === ao.btnStatus.hidden || ao.isShareEverything()\"><div class=\"col-xs-12\"><div class=\"row account-overview-eop-badge\" data-ng-if=\"$root.eopOfferToShowBadge && $root.eopOfferToShowBadge.hasHideOffer\"><a href=\"javascript:void(0)\" class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-click=\"eopRedirectToPage()\" aria-label=\"{{($root.eopOfferToShowBadge.offerType !== \'recommended\' ? \'EOP.CTAS.PROMOTION_OFFER_BADGE.ALT\' : \'EOP.CTAS.RECOMMENDED_OFFER_BADGE.ALT\') | translate}}\"><img class=\"star\" aria-hidden=\"true\" src=\"/web/totes/cms/images/page-specific/eop/star_3x.png\"><span ng-if=\"$root.eopOfferToShowBadge.isLegacy\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.PROMOTION_OFFER_BADGE.LABEL\"></span> <span ng-if=\"!$root.eopOfferToShowBadge.isLegacy\" <span=\"\" ng-switch=\"$root.eopOfferToShowBadge.offerType\"><span ng-switch-when=\"recommended\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.RECOMMENDED_OFFER_BADGE.LABEL\"></span> <span ng-switch-default=\"\" class=\"offerDesc\" aria-hidden=\"true\" translate=\"EOP.CTAS.PROMOTION_OFFER_BADGE.LABEL\"></span></span></a></div><myr-my-services data-test-id=\"myr-accountOverview-myServices\"></myr-my-services></div></div></div><div ng-if=\"!ao.mss.loadingData && ao.mss.selectedAccountDetail.isPrepaid\"><div class=\"row\"><div class=\"col-xs-12\"><div data-ng-if=\"!ao.loadingDataIndicator && !ao.mss.isDetailsNotFound\"><myr-account-balance view-html=\"accountBalance.prepaid.html\" loading-brite-bill=\"ao.bb.loadingBriteBill\"></myr-account-balance></div></div><div class=\"col-xs-12 col-md-11\">&nbsp;</div><div class=\"col-xs-12\" data-ng-if=\"!(ao.loadingDataIndicator || ao.mss.isDetailsNotFound)\"><div><myr-my-services mode=\"\'mobile\'\" data-test-id=\"myr-accountOverview-myServicesMobile\"></myr-my-services></div></div></div></div></div><div class=\"container no-left-border mbm\" data-ng-if=\"!ao.isShareEverything() && !ao.mss.selectedAccountDetail.isPrepaid\"><revolution open-wirelese-package-modal=\"openWirelesePackageModal()\" open-wireless-travel-package-legal-content-modal=\"openWirelessTravelPackageLegalContentModal(ev,size)\" travel-package-data=\"travelPackageData\"></revolution></div><account-preferences ng-if=\"!ao.isShareEverything() && !ao.mss.loadingData\"></account-preferences><div class=\"container\" data-ng-if=\"!(ao.isOtherAvailableServicesHidden() || ao.isShareEverything())\"><div class=\"row redHeadline mbm ptm\" data-ng-if=\"!ao.mss.isDetailsNotFound\"><div class=\"col-xs-12 col-md-7 col-lg-7\"><div class=\"title-h2\" data-ng-if=\"ao.mss.isOtherServicesAvailable\" data-test-id=\"myr-accountOverview-acc_overview_other_services\"><h2 class=\"account-other-services-heading primary-color other-services\" translate=\"acc_overview_other_services\"></h2><span class=\"widget-loader-inline account-other-services\" data-ng-if=\"ao.mss.loadingData\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div><div class=\"row ptm other-services-list-ctn\" data-ng-if=\"(!ao.mss.loadingData && !ao.mss.isDetailsNotFound)\" data-test-id=\"myr-accountOverview-myOtherServices\"><div class=\"col-xs-12 col-md-6 col-lg-4\" ng-repeat=\"msl in ao.mss.myOtherServicesListFinal| filter:{isVisible:true} track by $index\"><div class=\"row\" ng-if=\"isConsumer && (!msl.goTo || msl.allowGoto)\"><div class=\"col-xs-12 get-services-link-container\"><a class=\"get-services-link-ctn\" data-ng-class=\"ao.isOtherAvailableServicesDisabled() ? \'not-active\' : \'\'\" name=\"preCleanCall\" ng-href=\"{{!ao.isOtherAvailableServicesDisabled() && !(msl.id === \'RHPc\' || msl.id === \'RHP Phone Line\') ? (msl.link + (msl.addLangRoute?selectedLanguage:\'\') + (msl.addLang ? (msl.langFirstParam ? \'?\' : \'&\') : \'\') + (msl.addLang ? msl.langParameterName + \'=\' + selectedLanguage : \'\')) : \'\'}}\" target=\"_blank\" ng-click=\"(msl.id === \'RHPc\' || msl.id === \'RHP Phone Line\') ? ao.contactCarePopup(msl.id) : msl.goto($event)\"><span class=\"get-services-link get-services-font\"><span translate=\"{{msl.title}}\"></span> <span class=\"rui-icon-arrow-right float-none preference-arrow\"></span></span></a></div></div><div class=\"row\" ng-if=\"isDealer || isCare\"><div class=\"col-xs-12\"><div class=\"col-xs-12\" data-ng-if=\"!(msl.id === \'Rogers Bank\' || msl.id === \'NHL (GCL)\')\"><div class=\"other-service-title\" name=\"preCleanCall\"><user-if-any-granted ng-if=\"msl.goTo\" data-roles=\"{{:: msl.userRoles }}\"></user-if-any-granted><h5 ng-if=\"!msl.goTo\" class=\"get-services-link\"><span data-ng-if=\"!(msl.id===\'CTN\' && isDealer && ao.als.selectedAccount.accountStatus === \'Active\')\" translate=\"{{msl.title}}\"></span> <a ng-if=\"msl.id===\'CTN\' && isDealer && ao.als.selectedAccount.accountStatus === \'Active\'\" ng-click=\"ao.preCleanCall()\" class=\"get-services-link-ctn cursor-pointer\"><span translate=\"{{msl.title}}\"></span></a></h5></div></div></div></div></div></div></div><div data-ng-if=\"(ao.isShareEverything() && (!ao.mss.loadingData) && (!ao.abs.loadingData))\" class=\"container\"><div class=\"row badgeGroupings\"><div class=\"sharedWireless col-xs-12 col-sm-6 col-md-4\"><h2 class=\"myservicebadgeGroup-title\" translate=\"share_everything_share\" ng-if=\"!ao.isInfinitePlan()\">Shared Wireless</h2><h2 class=\"myservicebadgeGroup-title\" ng-bind-html=\"\'rogers_infinite\' | translate\" ng-if=\"ao.isInfinitePlan()\"></h2><ute-data-manager-badge-list-directive data-account-number=\"{{ao.als.selectedAccount.accountNumber}}\" data-account-status=\"{{ao.als.selectedAccount.accountStatus}}\"></ute-data-manager-badge-list-directive></div><div class=\"col-xs-12 col-sm-6 col-md-4\" data-ng-if=\"(ao.mss.fdmIndividualListAmount > 0) && (ao.wirelessFilteredListLength() > 0)\"><myservicebadge-group grouptype=\"individual\"></myservicebadge-group></div><div class=\"col-xs-12 col-sm-6 col-md-4\" data-ng-if=\"ao.mss.fdmResidentialListAmount > 0\"><myservicebadge-group grouptype=\"residential\"></myservicebadge-group></div><div class=\"col-xs-12 col-sm-6 col-md-4\" data-ng-if=\"ao.mss.fdmOtherListAmount > 0\"><myservicebadge-group grouptype=\"otherServices\"></myservicebadge-group></div></div><div class=\"container no-left-border mbm\" data-ng-if=\"!ao.mss.selectedAccountDetail.isPrepaid\"><revolution open-wirelese-package-modal=\"openWirelesePackageModal()\" open-wireless-travel-package-legal-content-modal=\"openWirelessTravelPackageLegalContentModal(ev,size)\" travel-package-data=\"travelPackageData\"></revolution></div><account-preferences ng-if=\"ao.isShareEverything() && !ao.mss.loadingData\"></account-preferences><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-show=\"ao.mss.myOtherServicesListFinal.length > 0\"><myservicebadge-group grouptype=\"addServices\"></myservicebadge-group></div></div></div></div><div class=\"container\" id=\"myr_myoffers_account-oveview\" ng-if=\"isConsumer\"><div class=\"row ptm\"><div class=\"col-xs-12\"><my-offers></my-offers></div></div></div></section><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"liveChatSettings.floatingAccountOverview.cbid\" data-bold-chat-div=\"liveChatSettings.floatingAccountOverview.boldChatDiv\" data-chat-button=\"liveChatSettings.floatingAccountOverview.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("scripts/modules/accountPreferences/accountPreferences.html","<div class=\"container\"><div class=\"row redHeadline mbm ptm\"><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"title-h2\" data-test-id=\"myr-accountOverview-acc_overview_other_services\"><h2 class=\"account-other-services-heading primary-color\" translate=\"myaccoverview_account_preferences\"></h2></div></div></div><div class=\"row ptm other-services-list-ctn\" data-test-id=\"myr-accountOverview-myOtherServices\"><div ng-repeat=\"accountLink in ap.accountPreferencesList track by $index\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" ng-if=\"ap.showLink(accountLink.label)\"><div class=\"get-services-link-container\"><ng-include src=\"accountLink.template\"></ng-include></div></div></div></div></div>");
$templateCache.put("scripts/modules/accountPreferences/ap.changePaymentLink.html","<div class=\"get-services-link-ctn\"><ute-payment-method selected-account=\"ap.selectedAccountDetails\" account-preference-link=\"\"></ute-payment-method></div>");
$templateCache.put("scripts/modules/accountPreferences/ap.services.links.html","<a ng-if=\"!accountLink.useNgClick\" class=\"get-services-link-ctn\" ng-href=\"{{accountLink.Url}}\" tabindex=\"0\"><span class=\"get-services-link get-services-font\"><span translate=\"{{accountLink.label}}\"></span> <span class=\"rui-icon-arrow-right float-none preference-arrow preference-arrow\"></span></span></a> <a ng-if=\"accountLink.useNgClick\" class=\"get-services-link-ctn\" data-ng-click=\"ap.linkOnClick(accountLink)\" ng-keypress=\"ap.linkOnClick(accountLink)\" tabindex=\"0\"><span class=\"get-services-link clickable-link get-services-font\"><span translate=\"{{accountLink.label}}\"></span> <span class=\"rui-icon-arrow-right float-none preference-arrow preference-arrow\"></span></span></a>");
$templateCache.put("scripts/modules/changePaymentMethod/changePaymentMethod.html","<div class=\"page-change-method\" ng-cloak=\"\" id=\"changeMethod\"><myr-payment-top-bar></myr-payment-top-bar><div class=\"container plm\"><div class=\"row rel\" data-ng-hide=\"!isPreAuthorized\"><div class=\"visible-xs visible-sm col-xs-12 col-sm-12 col-md-0 col-lg-0\"><div class=\"radius\"><div class=\"did-you-know-ctn\" style=\"width:360px;\"><span ng-if=\"isConsumer\" class=\"did-you-know-title\" translate=\"shm_promo_title\"></span> <span ng-if=\"isCare || isDealer\" class=\"did-you-know-title\" translate=\"remind_the_customer\"></span> <span ng-if=\"isConsumer\" class=\"did-you-know-promo-txt\" translate=\"change_method_intro\"></span> <span ng-if=\"isCare || isDealer\" class=\"did-you-know-title\" translate=\"oneview_change_method_intro\"></span></div></div></div><div class=\"visible-md visible-lg col-xs-12 col-sm-12 col-md-12 col-lg-12 rel\"><div class=\"pin-tr radius mtl\"><div class=\"did-you-know-ctn\" style=\"width:360px;margin-top:50px;\"><span ng-if=\"isConsumer\" class=\"did-you-know-title\" translate=\"shm_promo_title\"></span> <span ng-if=\"isCare || isDealer\" class=\"did-you-know-title\" translate=\"remind_the_customer\"></span> <span ng-if=\"isConsumer\" class=\"did-you-know-promo-txt\" translate=\"change_method_intro\"></span> <span ng-if=\"isCare || isDealer\" class=\"did-you-know-promo-txt\" translate=\"oneview_change_method_intro\"></span></div></div></div></div><div class=\"row\"><div ng-if=\"isConsumer || isDealer\" class=\"ptm primary-color pbs title-light-h2\" translate=\"change_method\"></div><div ng-if=\"isCare\" class=\"ptm primary-color pbs title-light-h2\" translate=\"change_method_update\"></div><div class=\"styled-select change-method-select\" style=\"width:329px\"><select name=\"paymentMethod\" id=\"selPaymentMethod\" required=\"\" class=\"change-method-select\" data-ng-model=\"selectedMethodObj\" data-ng-change=\"changemethod(selectedMethodObj)\" ng-options=\"value.resKey for (key, value) in paymentMethods\"></select></div></div><form id=\"form\" name=\"form\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-lg-12 col-md-12 cc-btn-ctn\"><div data-ng-show=\"selectedMethod ===0\"><div data-ng-hide=\"changeInvoiceMethod\"><h3 class=\"black\" translate=\"change_method_ways\"></h3><ul class=\"ptl pbl headline6 invoice-intro\"><li><span translate=\"online\"></span></li><li><span translate=\"change_method_stores\"></span></li><li><span translate=\"change_method_app\"></span></li><li><span translate=\"change_method_banks\"></span></li><li><span translate=\"change_method_mail\"></span></li></ul></div><div data-ng-if=\"changeInvoiceMethod\"><div><h3 class=\"black\" translate=\"change_method_invoice\"></h3><div class=\"ptm pbm\"><span translate=\"change_method_invoice_info\"></span></div></div><div class=\"ptm pbm\"><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></bold-chat-static-button></div></div></div><div><form-chequing show-debit-form=\"showDebitForm\" chequing-obj=\"chequingObj\" debit-form=\"form\" dtm-name=\"dtmName\"></form-chequing></div><div ng-if=\"showCreditCardForm\" id=\"formCreditCard\"><ute-credit-card user-type=\"userType()\" credit-payment-obj=\"creditCardObj\" dtm-name=\"dtmName\" card-time=\"cardTime\"></ute-credit-card></div></div></div><div class=\"ptm\" data-ng-hide=\"changeInvoiceMethod\"><span class=\"inline-block pbl title-note\" translate=\"change_method_note\"></span></div><div class=\"row pbl\" data-ng-hide=\"selectedMethod === 0 || (isDealer && creditCardObj.isCardSwiped)\"><div class=\"col-xs-12 col-sm-12 col-lg-7 col-md-7 cc-btn-ctn\"><div class=\"pts pull-left cc-cancel-btn-ctn pointer\"><a name=\"cancel\" data-ng-click=\"cancel()\" translate=\"_cancel\"></a></div><div class=\"pull-right\"><button name=\"submit\" class=\"cta-round primary medium change-method-update\" tabindex=\"9\" data-ng-click=\"submit()\" ng-class=\"{disabled: isChanging, \'\': !isChanging, disabled: ((isCare || isDealer) && showDebitForm)}\"><span translate=\"change_method_update\"></span></button> <span class=\"widget-loader-inline\" ng-show=\"isChanging\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></form></div></div><payment-helper></payment-helper>");
$templateCache.put("scripts/modules/creditAdjustment/creditAdjustmentModal.html","<div class=\"totes-project creditAdjustment-modal\" id=\"credit-adjustment-modal\"><span class=\"credit-adjustment-close\" ng-click=\"closeCreditAdjustmentModal()\" role=\"button\" tabindex=\"0\"></span><div class=\"creditAdjustment-modal-header\"><h1 class=\"creditAdjustment-modal-title\">{{\'creditadjustment_credit_management\' | translate}}</h1></div><div class=\"creditAdjustment-modal-body\"><div class=\"creditAdjustment-modal-section-primary section-holder\"><div class=\"creditAdjustment-modal-section-primary-title section-title-holder\"><span class=\"number-label\">1</span> <span class=\"title-label\">{{\'creditadjustment_select_service_for_adjustment\' | translate}}</span></div><div class=\"creditAdjustment-modal-section-primary-details section-details-holder\"><div class=\"select-holder\"><div class=\"dropdown\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"ute-mop-select-dropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span ng-if=\"!selectedService\">{{\'creditadjustment_select_service\' | translate}}</span> <span ng-if=\"selectedService\">{{ (!selectedService.subscriptionBadgeModule && !selectedService.hide) ? ((\'creditadjustment_\' + selectedService.serviceType) | translate) : \'\' }} {{ (!((isDealer || isCare) && selectedService.serviceName === \'homephone\') && !selectedService.subscriptionBadgeModule && !selectedService.hide ) && ( selectedService.serviceName === \'wireless\' || selectedService.serviceName === \'shareEverything\' || selectedService.serviceName === \'homephone\' || selectedService.serviceName === \'wirelessPrepaid\' || selectedService.serviceName === \'suspended\' ) ? \' - \' + (selectedService.serviceDetail | ute_common_filter_phone2) : \'\' }} {{ (selectedService.subscriptionBadgeModule && isDealer) ? ((\'creditadjustment_\' + selectedService.serviceType) | translate) : \'\' }}</span></button><ul class=\"dropdown-menu\" aria-labelledby=\"ute-mop-select-dropdown\"><li class=\"dropdown-item\" ng-click=\"clearData()\">{{\'creditadjustment_select_service\' | translate}}</li><li class=\"dropdown-item\" ng-if=\"checkServiceVisibility(subMenuMyServicesList, msl)\" ng-repeat=\"msl in subMenuMyServicesList track by $index\" ng-click=\"fetchPlanDetails($index)\">{{ (!msl.subscriptionBadgeModule && !msl.hide) ? ((\'creditadjustment_\' + msl.serviceType) | translate) : \'\' }} {{ (!((isDealer || isCare) && msl.serviceName === \'homephone\') && !msl.subscriptionBadgeModule && !msl.hide ) && ( msl.serviceName === \'wireless\' || msl.serviceName === \'shareEverything\' || msl.serviceName === \'homephone\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ) ? \' - \' + (msl.serviceDetail | ute_common_filter_phone2) : \'\' }} {{ (msl.subscriptionBadgeModule && isDealer) ? ((\'creditadjustment_\' + msl.serviceType) | translate) : \'\' }} <span class=\"cancelled-msg\" ng-if=\"isCare && msl.status === \'Cancelled\'\" translate=\"creditadjustment_cancelled\"></span></li></ul></div></div><div class=\"user-info-area\" ng-if=\"!selectedService\"><div class=\"user-info_col\"><span class=\"col_name\">{{\'creditadjustment_account_holder\' | translate}}</span> <span class=\"col_title\">{{ accountSummary.accountName.firstName }}&nbsp;{{ accountSummary.accountName.lastName }}</span></div><div class=\"user-info_col text-right\"><span class=\"col_name\">{{\'creditadjustment_total_account_balance\' | translate}}</span><div class=\"amount\"><span class=\"dollar-sign col_title\" ng-if=\"lang === \'en\'\">$</span> <span class=\"col_title\">{{accountBalance.balanceAmount.substr(0,accountBalance.balanceAmount.indexOf(\'.\'))}}</span><span class=\"cents col_title\">{{accountBalance.balanceAmount | decimals: lang}}</span> <span class=\"dollar-sign col_title\" ng-if=\"lang ===\'fr\'\">$</span></div></div></div><div class=\"user-info-area\" ng-if=\"selectedService && (selectedService.serviceType === \'service_wireless\' || selectedService.serviceType === \'WIRELESS\')\"><span class=\"widget-loader-inline\" ng-if=\"loadingPlanDetails\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div ng-if=\"!loadingPlanDetails && selectedService.subStatus === \'Active\'\"><div class=\"user-info_col\"><span class=\"col_name\">{{\'creditadjustment_plan_package\' | translate}}</span> <span class=\"col_title\">{{ lang === \'en\' ? packageDetails.postPaidPhoneDetails.planDescription : packageDetails.postPaidPhoneDetails.planDescriptionFr }}</span></div><div class=\"user-info_col text-right\"><span class=\"col_name\">{{\'creditadjustment_monthly_charge\' | translate}}</span> <span class=\"dollar-sign col_title\" ng-if=\"lang === \'en\'\">$</span> <span class=\"col_title\">{{ packageDetails.postPaidPhoneDetails.planMSF | number: 2 }}</span> <span class=\"dollar-sign col_title\" ng-if=\"lang ===\'fr\'\">$</span></div></div></div></div><div class=\"cancelled-message\" ng-if=\"isCancelledServiceSelected\"><span><img class=\"cancelled-warning-icon\" src=\"images/warning_lg.png\" alt=\"\"></span> <span class=\"cancelled-message-content\" translate=\"creditadjustment_cancelled_message\" translate-values=\"{service: selectedCancelledService, serviceDetail: (cancelledServiceDetail | phone3)}\"></span></div><div class=\"creditAdjustment-modal-section-primary-history\"><div class=\"creditAdjustment-history\" ng-if=\"adjustmentHistory && adjustmentHistory.length > 0\" accordion=\"\"><div accordion-group=\"\" is-open=\"isAdjustmentHistoryShown\" ng-click=\"toggleAdjustmentHistory()\"><accordion-heading><span class=\"panel-opener\"><i ng-class=\"isAdjustmentHistoryShown ? \'fa fa-angle-up\':\'fa fa-angle-down\'\" aria-hidden=\"true\"></i></span> <span class=\"panel-text\"><span class=\"text\">{{\'creditadjustment_recent_adjustments\' | translate}}</span> <span class=\"prize\">{{adjustmentHistory.length}}</span></span> &nbsp;&nbsp;<i class=\"text-divider\"></i>&nbsp; <span class=\"panel-text\"><span class=\"text\">{{\'creditadjustment_goodwill_credit_remaining\' | translate}}</span> <span class=\"prize\" ng-if=\"lang === \'en\'\">${{goodWillCreditRemaining | number: 2}}</span> <span class=\"prize\" ng-if=\"lang === \'fr\'\">{{goodWillCreditRemaining | number: 2}}$</span></span></accordion-heading><div class=\"accordion-body\"><table class=\"adjustment-history-table\"><thead><tr><th><span>{{\'creditadjustment_date\' | translate}}</span></th><th><span>{{\'creditadjustment_amount\' | translate}}</span></th><th><span>{{\'creditadjustment_feature_code\' | translate}}</span></th></tr></thead><tbody><tr data-ng-repeat=\"adjustmentDetails in adjustmentHistory\"><td>{{fixDate(adjustmentDetails.adjustmentDate) | date:\'MM/dd/yy\'}}</td><td><span ng-if=\"lang === \'en\'\">$</span> <span class=\"col_title letter-spacing-custom\" ng-if=\"(adjustmentDetails.adjustmentAmt + \'\' ).indexOf(\'.\') > -1\">{{(adjustmentDetails.adjustmentAmt + \"\").substr(0,(adjustmentDetails.adjustmentAmt + \"\" ).indexOf(\'.\'))}}</span> <span class=\"col_title letter-spacing-custom\" ng-if=\"(adjustmentDetails.adjustmentAmt + \'\' ).indexOf(\'.\') === -1\">{{adjustmentDetails.adjustmentAmt}}</span> <span class=\"cents col_title\">{{adjustmentDetails.adjustmentAmt | decimals: lang}}</span> <span ng-if=\"lang === \'fr\'\">$</span></td><td>{{adjustmentDetails.featureCode}}</td></tr></tbody></table></div></div></div></div></div><div class=\"creditAdjustment-modal-section-secondary section-holder\"><div class=\"creditAdjustment-modal-section-secondary-title section-title-holder\" ng-class=\"selectedService ? \'active-section\' : \'disabled-section\'\"><span class=\"number-label\">2</span> <span class=\"title-label\">{{\'creditadjustment_credit_management\' | translate}}</span></div><div class=\"creditAdjustment-modal-section-secondary-details\" ng-if=\"selectedService\"><div class=\"section-details-holder form-group\"><div class=\"label-holder\"><label for=\"selectedAdjustmentType\">{{\'creditadjustment_adjustment_type\' | translate}}</label><div class=\"tooltip-holder\"><i ng-click=\"toggleTooltip(\'adjustment\', true)\" id=\"tooltip_opnere\" class=\"fa fa-info tooltip_icon\" aria-hidden=\"true\"></i><div id=\"tooltip-text\" class=\"tooltip-text\" ng-if=\"isAdjustmentToolTipVisible\"><a href=\"#\" class=\"close\" id=\"close\" ng-click=\"toggleTooltip(\'adjustment\', false)\">x</a><span>{{\'creditadjustment_tooltip_details\' | translate}}</span></div></div></div><div class=\"select-holder select-adjustment-holder\"><div class=\"dropdown\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"select-dropdown-adjustment-types\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\"><span ng-if=\"!selectedAdjustmentContent\">{{\'creditadjustment_select_adjustment_type\' | translate}}</span> <span ng-if=\"selectedAdjustmentContent\">{{selectedAdjustmentContent.name}}</span></button><ul class=\"dropdown-menu\" aria-labelledby=\"select-dropdown-adjustment-types\"><li class=\"dropdown-item\" ng-click=\"onAdjustmentTypeSelected(null)\">{{\'creditadjustment_select_adjustment_type\' | translate}}</li><li class=\"dropdown-item\" ng-repeat=\"adjustment in adjustmentContent track by $index\" ng-click=\"onAdjustmentTypeSelected(adjustment)\">{{adjustment.name}}</li></ul></div></div></div><div class=\"issue-section-holder\"><div class=\"policy-issue-section issue-section-box\" ng-if=\"selectedAdjustmentContent.name === \'Policy Adjustment\' || selectedAdjustmentContent.name === \'Ajustement de la politique\'\"><div class=\"\" close-others=\"true\" accordion=\"\"><div accordion-group=\"\" is-open=\"accordionsGroup.isPrimaryAccordionOpen\"><accordion-heading><span>{{\'creditadjustment_select_policy\' | translate}}</span></accordion-heading><div class=\"accordion-body accordion-prime-list\"><ul class=\"known-issues-list accordion-list\"><li data-ng-repeat=\"knownAdjustmentSubType in selectedAdjustmentContent[\'knownSubReason\']\" ng-click=\"selectReason($event, knownAdjustmentSubType)\"><div class=\"left_col\"><b ng-bind-html=\"knownAdjustmentSubType.adjustmentTitle\"></b></div><div class=\"right_col\"><span class=\"more-details\"><a target=\"_blank\" href=\"{{knownAdjustmentSubType.detailsLink}}\">{{ \'creditadjustment_details\' | translate }}</a></span><p ng-bind-html=\"knownAdjustmentSubType.adjustmentDesc\"></p></div></li></ul></div></div></div><div class=\"creditAdjustment-form-section accordion-active-section\" ng-if=\"selectedReason\" id=\"subsection-accordion\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\" novalidate=\"\"><div class=\"policy-issue\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-trim=\"false\" ng-change=\"adjustmentTypesWithFields.policyIssue.known.amount = filterNumbers(true, adjustmentTypesWithFields.policyIssue.known.amount)\" class=\"input-fields input-fields_md\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.policyIssue.known.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" class=\"input-fields input-fields_md\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.policyIssue.known.approver)\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.policyIssue.known.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label input-label\" for=\"interaction-form\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"notes-text-area textArea-fields\" name=\"notes\" id=\"interaction-form\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.policyIssue.known.notes\">Enter text here...</textarea></div></div><div class=\"form-footer text-right\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\"><span>{{\'creditadjustment_cancel\' | translate}}</span></button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'policyIssue\', \'known\', interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.policyIssue.known.amount || isLoadingInteraction\"><span>{{\'creditadjustment_create_interaction\' | translate}}</span></button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form><div class=\"system-error-auto-adjustment adjustment-active-sub-section\" ng-if=\"selectedReason.autoAdjustment === \'No-Automatically\'\"><div class=\"auto-adjustment-message form-group\"><img src=\"images/info-icon-blue.png\" alt=\"\"> {{\'creditadjustment_auto_adjustment\' | translate}}</div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><form name=\"interactionForm\" novalidate=\"\"><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.policyIssue.auto.notes\">Enter text here...</textarea></form></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'policyIssue\', \'auto\', interactionForm)\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div><div class=\"system-network-issue-section issue-section-box\" ng-if=\"selectedAdjustmentContent.name === \'Service Network Issue\' || selectedAdjustmentContent.name === \'Problème de système lié au réseau\'\"><div class=\"\" close-others=\"true\" accordion=\"\"><div accordion-group=\"\" is-open=\"accordionsGroup.isPrimaryAccordionOpen\"><accordion-heading><span>{{\'creditadjustment_known_issue\' | translate}}</span></accordion-heading><div class=\"accordion-body accordion-prime-list\"><ul class=\"accordion-list\"><li data-ng-repeat=\"knownAdjustmentSubType in selectedAdjustmentContent[\'knownSubReason\']\" ng-click=\"selectReason($event, knownAdjustmentSubType)\"><div class=\"left_col\"><b ng-bind-html=\"knownAdjustmentSubType.adjustmentTitle\"></b></div><div class=\"right_col\"><span class=\"more-details\"><a target=\"_blank\" href=\"{{knownAdjustmentSubType.detailsLink}}\">{{ \'creditadjustment_details\' | translate }}</a></span><p ng-bind-html=\"knownAdjustmentSubType.adjustmentDesc\"></p></div></li></ul></div></div><div class=\"accordion-active-subSection-holder\" ng-if=\"selectedReason && accordionsGroup.isPrimaryAccordionOpen\" id=\"subsection-accordion\"><div class=\"section-title-holder\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\"><span class=\"number-label number-label_sm\">1</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_create_interaction\' | translate}}</span></div><div class=\"creditAdjustment-form-section adjustment-active-sub-section service-issue-sub\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\" novalidate=\"\"><div class=\"service-network-issue\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_days_affected\' | translate}}</div><input class=\"input-fields\" ng-trim=\"false\" ng-change=\"adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected = filterDecimalNumbers(false, adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected)\" ng-blur=\"adjustmentTypesWithFields.serviceNetworkIssue.known.amount = updateAmount((adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected * (MSF / 30 )))\" type=\"text\" maxlength=\"3\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected\"></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><div class=\"daysAffected-input-holder\"><input name=\"amount\" ng-trim=\"false\" ng-change=\"adjustmentTypesWithFields.serviceNetworkIssue.known.amount = filterNumbers(true, adjustmentTypesWithFields.serviceNetworkIssue.known.amount)\" class=\"input-fields\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.known.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"daysAffected-info-text\" ng-if=\"adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected && selectedService.serviceType === \'service_wireless\'\"><span>{{ \'creditadjustment_recommended_amount\' | translate }}</span> <span class=\"red_text\" ng-if=\"lang === \'en\'\">${{adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected * (MSF / 30 ) | number : 2}}</span> <span class=\"red_text\" ng-if=\"lang === \'fr\'\">{{adjustmentTypesWithFields.serviceNetworkIssue.known.daysAffected * (MSF / 30 ) | number : 2}}$</span></div></div><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input class=\"input-fields input-fields_md\" placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.serviceNetworkIssue.known.approver)\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.known.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea name=\"notes\" class=\"textArea-fields\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.known.notes\">Enter text here...</textarea></div></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\"><span>{{\'creditadjustment_cancel\' | translate}}</span></button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'serviceNetworkIssue\', \'known\', interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.serviceNetworkIssue.known.amount || isLoadingInteraction\"><span>{{\'creditadjustment_create_interaction\' | translate}}</span></button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form><div class=\"system-error-auto-adjustment adjustment-active-sub-section\" ng-if=\"selectedReason.autoAdjustment === \'No-Automatically\'\"><div class=\"auto-adjustment-message form-group\"><img src=\"images/info-icon-blue.png\" alt=\"\"> <i></i> {{\'creditadjustment_auto_adjustment\' | translate}}</div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><form name=\"interactionForm\" novalidate=\"\"><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.auto.notes\">Enter text here...</textarea></form></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'serviceNetworkIssue\', \'auto\', interactionForm)\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div><div class=\"section-title-holder\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\"><span class=\"number-label number-label_sm\">2</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_apply_adjustment_in_v21\' | translate}}</span></div></div><div><div class=\"accordion-active-subSection02\"><div accordion-group=\"\" class=\"panel-sub-opener-holder\" is-open=\"accordionsGroup.isSecondaryAccordionOpen\"><accordion-heading><span><span class=\"panel-sub-opener\"><i ng-class=\"accordionsGroup.isSecondaryAccordionOpen ? \'fa fa-angle-up\':\'fa fa-angle-down\'\" aria-hidden=\"true\"></i></span> <span class=\"panel-sub-text\">{{\'creditadjustment_unknown_issue\' | translate}}</span></span></accordion-heading><div class=\"accordion-body\"><div class=\"section-title-holder\"><span class=\"number-label number-label_sm\">1</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_create_interaction\' | translate}}</span></div><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" novalidate=\"\"><div class=\"service-network-issue-not-in-list accordion-active-sub-section\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_interaction_id\' | translate}}</div><div class=\"tooltip-holder\"><i ng-click=\"toggleTooltip(\'interactionId\', true)\" id=\"tooltip_opnere11\" class=\"fa fa-info tooltip_icon\" aria-hidden=\"true\"></i><div id=\"tooltip-text11\" class=\"tooltip-text\" ng-if=\"isInteractionIdToolTipVisible\"><a href=\"#\" class=\"close\" id=\"close11\" ng-click=\"toggleTooltip(\'interactionId\', false)\">x</a><span>{{\'creditadjustment_interactionIdTooltip\' | translate}}</span></div></div><input class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.interactionId\"></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><div class=\"daysAffected-input-holder\"><input class=\"input-fields daysAffected-input-holder\" name=\"amount\" ng-trim=\"false\" ng-change=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.amount = filterNumbers(true, adjustmentTypesWithFields.serviceNetworkIssue.unknown.amount)\" type=\"text\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.amount\" decimal-price=\"2\" ng-required=\"interactionForm.amount.$touched\"><div class=\"daysAffected-info-text\" ng-if=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected && selectedService.serviceType === \'service_wireless\'\"><span>{{ \'creditadjustment_recommended_amount\' | translate }}</span> <span class=\"red_text\" ng-if=\"lang === \'en\'\">${{adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected * (MSF / 30 ) | number : 2}}</span> <span class=\"red_text\" ng-if=\"lang === \'fr\'\">{{adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected * (MSF / 30 ) | number : 2}}$</span></div></div><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" class=\"input-fields input-fields_md\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.serviceNetworkIssue.unknown.approver)\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_days_affected\' | translate}}</div><input ng-blur=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.amount = updateAmount((adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected * (MSF / 30 )))\" ng-change=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected = filterDecimalNumbers(false, adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected)\" class=\"input-fields\" ng-trim=\"false\" type=\"text\" maxlength=\"3\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.daysAffected\"></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.serviceNetworkIssue.unknown.notes\">Enter text here...</textarea></div></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\"><span>{{\'creditadjustment_cancel\' | translate}}</span></button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'serviceNetworkIssue\', \'unknown\', interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.serviceNetworkIssue.unknown.amount || isLoadingInteraction\"><span>{{\'creditadjustment_create_interaction\' | translate}}</span></button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form></div></div><div class=\"section-title-holder\"><span class=\"number-label number-label_sm\">2</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_apply_adjustment_in_v21\' | translate}}</span></div></div></div></div></div></div></div><div class=\"system-error-section issue-section-box\" ng-if=\"selectedAdjustmentContent.name === \'System Errors\' || selectedAdjustmentContent.name === \'Erreurs de système\'\"><div class=\"\" close-others=\"true\" accordion=\"\"><div accordion-group=\"\" is-open=\"accordionsGroup.isPrimaryAccordionOpen\"><accordion-heading><span>{{\'creditadjustment_known_error\' | translate}}</span></accordion-heading><div class=\"accordion-body accordion-prime-list\"><ul class=\"accordion-list\"><li data-ng-repeat=\"knownAdjustmentSubType in selectedAdjustmentContent[\'knownSubReason\']\" ng-click=\"selectReason($event, knownAdjustmentSubType)\"><div class=\"left_col\"><b ng-bind-html=\"knownAdjustmentSubType.adjustmentTitle\"></b></div><div class=\"right_col\"><span class=\"more-details\"><a target=\"_blank\" href=\"{{knownAdjustmentSubType.detailsLink}}\">{{ \'creditadjustment_details\' | translate }}</a></span><p ng-bind-html=\"knownAdjustmentSubType.adjustmentDesc\"></p></div></li></ul></div></div><div class=\"accordion-active-section\" ng-if=\"selectedReason && accordionsGroup.isPrimaryAccordionOpen\" id=\"subsection-accordion\"><div class=\"section-title-holder\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\"><span class=\"number-label number-label_sm\">1</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_create_interaction\' | translate}}</span></div><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" ng-if=\"selectedReason.autoAdjustment === \'Yes-Manually\'\" novalidate=\"\"><div class=\"system-error accordion-active-sub-section\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-change=\"adjustmentTypesWithFields.systemError.known.amount = filterNumbers(true, adjustmentTypesWithFields.systemError.known.amount)\" class=\"input-fields\" ng-trim=\"false\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.systemError.known.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.systemError.known.approver)\" class=\"input-fields input-fields_md\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.systemError.known.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.systemError.known.notes\">Enter text here...</textarea></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'systemError\', \'known\', interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.systemError.known.amount || isLoadingInteraction\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div><div class=\"section-title-holder\"><span class=\"number-label number-label_sm\">2</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_apply_adjustment_in_v21\' | translate}}</span></div></form><div class=\"system-error-auto-adjustment adjustment-active-sub-section\" ng-if=\"selectedReason.autoAdjustment === \'No-Automatically\'\"><div class=\"auto-adjustment-message form-group\"><img src=\"images/info-icon-blue.png\" alt=\"\"> {{\'creditadjustment_auto_adjustment\' | translate}}</div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><form name=\"interactionForm\" novalidate=\"\"><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.systemError.auto.notes\">Enter text here...</textarea></form></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'systemError\', \'auto\', interactionForm)\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div><div class=\"no-borderPanelBody-section\"><div class=\"panel-sub-opener-holder\" accordion-group=\"\" is-open=\"accordionsGroup.isSecondaryAccordionOpen\"><accordion-heading><span><span class=\"panel-sub-opener\"><i ng-class=\"accordionsGroup.isSecondaryAccordionOpen ? \'fa fa-angle-up\':\'fa fa-angle-down\'\" aria-hidden=\"true\"></i></span> <span class=\"panel-sub-text\">{{\'creditadjustment_unknown_error\' | translate}}</span></span></accordion-heading><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form accordion-active-subSection-holder03\"><form name=\"interactionForm\" novalidate=\"\"><div class=\"section-title-holder\"><span class=\"number-label number-label_sm\">1</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_create_interaction\' | translate}}</span></div><div class=\"system-error-not-in-list\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_icm_case_id\' | translate}}</div><div class=\"tooltip-holder\"><i ng-click=\"toggleTooltip(\'icm\', true)\" id=\"tooltip_opnere11\" class=\"fa fa-info tooltip_icon\" aria-hidden=\"true\"></i><div id=\"tooltip-text11\" class=\"tooltip-text\" ng-if=\"isICMToolTipVisible\"><a href=\"#\" class=\"close\" id=\"close11\" ng-click=\"toggleTooltip(\'icm\', false)\">x</a><span>{{\'creditadjustment_tooltip_icm\' | translate}}</span></div></div><input name=\"icmCase\" class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.systemError.unknown.icmCaseId\" ng-required=\"true\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.icmCase.$touched\"><div ng-show=\"interactionForm.icmCase.$error.required\"><span>{{\'creditadjustment_icm_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-change=\"adjustmentTypesWithFields.systemError.unknown.amount = filterNumbers(true, adjustmentTypesWithFields.systemError.unknown.amount)\" class=\"input-fields\" ng-trim=\"false\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.systemError.unknown.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.systemError.unknown.approver)\" class=\"input-fields input-fields_md\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.systemError.unknown.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.systemError.unknown.notes\">Enter text here...</textarea></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{ \'creditadjustment_cancel\' | translate }}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'systemError\', \'unknown\', interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.systemError.unknown.amount || isLoadingInteraction\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div><div class=\"section-title-holder\"><span class=\"number-label number-label_sm\">2</span> <span class=\"title-label title-label_sm\">{{\'creditadjustment_apply_adjustment_in_v21\' | translate}}</span></div></form></div></div></div></div></div></div><div class=\"goodwill-credit-section\" ng-if=\"selectedAdjustmentContent.name === \'Goodwill Credit\' || selectedAdjustmentContent.name === \'Crédit de bonne entente\'\"><div class=\"right-info-box\"><ul ng-if=\"selectedService.serviceType === \'service_wireless\' || selectedService.serviceType === \'WIRELESS\'\"><li><span class=\"right_col\" ng-if=\"lang === \'en\'\">${{maximumAllowed | number: 2}}</span> <span class=\"right_col\" ng-if=\"lang === \'fr\'\">{{maximumAllowed | number: 2}}$</span> <span class=\"left_col\">{{\'creditadjustment_max_allowed\' | translate}}</span></li><li><span class=\"right_col\" ng-if=\"lang === \'en\'\">-${{recentAdjustments | number: 2}}</span> <span class=\"right_col\" ng-if=\"lang === \'fr\'\">-{{recentAdjustments | number: 2}}$</span> <span class=\"left_col\">{{\'creditadjustment_recent_adjustments_period\' | translate}}</span></li><li><span class=\"right_col\" ng-if=\"lang === \'en\'\">${{goodWillCreditRemaining | number: 2}}</span> <span class=\"right_col\" ng-if=\"lang === \'fr\'\">{{goodWillCreditRemaining | number: 2}}$</span><span class=\"left_col\">{{\'creditadjustment_goodwill_credit_remaining\' | translate}}</span></li></ul><span class=\"non-wireless-info\" ng-if=\"selectedService.serviceType !== \'service_wireless\' && selectedService.serviceType !== \'WIRELESS\'\">{{ \'creditadjustment_goodwill_notes\' | translate }}</span></div><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" novalidate=\"\"><div class=\"goodwill-credit\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-change=\"adjustmentTypesWithFields.goodWillCredit.amount = filterNumbers(true, adjustmentTypesWithFields.goodWillCredit.amount)\" class=\"input-fields\" ng-trim=\"false\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.goodWillCredit.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input name=\"approver\" placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\'}}{{selectedService.serviceType !== \'service_wireless\' ? 100 : goodWillCreditRemaining}}{{ lang === \'fr\' ? \'$\': \'\' }}\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.goodWillCredit.approver)\" class=\"input-fields input-fields_md\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.goodWillCredit.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.goodWillCredit.notes\">Enter text here...</textarea></div></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'goodWillCredit\', null, interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.goodWillCredit.amount || isLoadingInteraction\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form></div></div></div><div class=\"dou-error-broken-promise-section\" ng-if=\"selectedAdjustmentContent.name === \'Transaction Service Error\' || selectedAdjustmentContent.name === \'Erreur de transaction\'\"><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" novalidate=\"\"><div class=\"documented-undocumented-error-or-promise\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_interaction_id\' | translate}}*</div><input name=\"interactionId\" class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.interactionId\" ng-required=\"true\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.interactionId.$touched\"><div ng-show=\"interactionForm.interactionId.$error.required\"><span>{{\'creditadjustment_interactionid_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{ \'creditadjustment_empid_agent\' | translate }}*</div><input name=\"empId\" class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.empId\" ng-required=\"true\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.empId.$touched\"><div ng-show=\"interactionForm.empId.$error.required\"><span>{{\'creditadjustment_empid_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-change=\"adjustmentTypesWithFields.douErrorOrPromise.amount = filterNumbers(true, adjustmentTypesWithFields.douErrorOrPromise.amount)\" class=\"input-fields input-fields_md\" ng-trim=\"false\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input class=\"input-fields input-fields_md\" placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" name=\"approver\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.douErrorOrPromise.approver)\" type=\"text\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.notes\">Enter text here...</textarea></div></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'douErrorOrPromise\', null, interactionForm)\" ng-disabled=\"isLoadingInteraction || !adjustmentTypesWithFields.douErrorOrPromise.amount\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form></div></div></div><div class=\"dou-error-broken-promise-section\" ng-if=\"selectedAdjustmentContent.name === \'Undocumented Error or Promise\' || selectedAdjustmentContent.name === \'Erreur non documentée ou promesse\'\"><div class=\"creditAdjustment-form-section\"><div class=\"creditAdjustment-form\"><form name=\"interactionForm\" novalidate=\"\"><div class=\"documented-undocumented-error-or-promise\"><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_interaction_id\' | translate}}</div><input class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.interactionId\"></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">EmpID of agent who made the error</div><input class=\"input-fields\" type=\"text\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.empId\"></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_amount_mandatory\' | translate}}</div><input name=\"amount\" ng-change=\"adjustmentTypesWithFields.douErrorOrPromise.amount = filterNumbers(true, adjustmentTypesWithFields.douErrorOrPromise.amount)\" class=\"input-fields input-fields_md\" ng-trim=\"false\" type=\"text\" decimal-price=\"2\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.amount\" ng-required=\"interactionForm.amount.$touched\"><div class=\"inline_error\" ng-show=\"interactionForm.$submitted || interactionForm.amount.$touched\"><div ng-show=\"interactionForm.amount.$error.required\"><span>{{\'creditadjustment_amount_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_approver\' | translate}}</div><input name=\"approver\" placeholder=\"{{\'creditadjustment_approver_required_for_amount\' | translate}} {{ lang === \'en\' ? \'$\' : \'\' }}100{{ lang === \'fr\' ? \'$\' : \'\' }}\" class=\"input-fields input-fields_md\" type=\"text\" ng-change=\"updateRequiredStatus(adjustmentTypesWithFields.douErrorOrPromise.approver)\" ng-required=\"isApproverMandatory\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.approver\"><div class=\"inline_error\" ng-show=\"isApproverMandatory\"><div><span>{{\'creditadjustment_approver_is_required\' | translate}}</span></div></div></div><div class=\"form-group\"><div class=\"creditAdjustment-label\">{{\'creditadjustment_notes\' | translate}}</div><textarea class=\"textArea-fields\" name=\"notes\" rows=\"3\" cols=\"50\" ng-model=\"adjustmentTypesWithFields.douErrorOrPromise.notes\">Enter text here...</textarea></div></div><div class=\"form-footer\"><button class=\"creditAdjustment-cancel-button\" ng-click=\"closeCreditAdjustmentModal()\">{{\'creditadjustment_cancel\' | translate}}</button> <button class=\"creditAdjustment-continue-button\" ng-click=\"createInteraction(\'douErrorOrPromise\', null, interactionForm)\" ng-disabled=\"!adjustmentTypesWithFields.douErrorOrPromise.amount || isLoadingInteraction\">{{\'creditadjustment_create_interaction\' | translate}}</button> <span class=\"widget-loader-inline\" ng-if=\"isLoadingInteraction\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></form></div></div></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/creditAdjustment/interactionModal.html","<div class=\"totes-project create-interaction-result-modal\"><span class=\"ute-pay-now-modalClose\" ng-click=\"close()\" role=\"button\" tabindex=\"0\"></span><div class=\"create-interaction-result-header\"></div><div class=\"interaction-success\"><div class=\"interaction-primary-section\"><div class=\"create-interaction-status-icon\"><img class=\"\" ng-click=\"close()\" src=\"ute-common-assets/assets/green-checkbox-alt.png\" role=\"button\" tabindex=\"0\"></div><div class=\"create-interaction-status-heading section-title-holder\"><span class=\"number-label\">1</span> <span class=\"title-label\">{{ \'creditadjustment_interaction_created\' | translate }}</span></div><div class=\"details-header-title\">{{ \'creditadjustment_interaction_created_details\' | translate }}</div><div class=\"details-box\"><table><thead><tr><th>{{ \'creditadjustment_date\' | translate }}</th><th>{{ \'creditadjustment_adjustment_type\' | translate }}</th><th>{{ \'creditadjustment_amount\' | translate }}</th></tr></thead><tbody><tr><td>{{data.date}}</td><td>{{data.selectedAdjustmentType}}</td><td>${{data.amount | number : 2}}</td></tr></tbody></table></div><div class=\"interaction-secondary-section\"><div class=\"create-interaction-status-heading section-title-holder\"><span class=\"number-label number-label-green\">2</span> <span class=\"title-label title-label-green\" ng-if=\"backendService === \'v21\'\">{{ \'creditadjustment_apply_adjustment_in_v21\' | translate}}</span> <span class=\"title-label title-label-green\" ng-if=\"backendService === \'sgi\'\">{{ \'creditadjustment_apply_adjustment_in_sgi\' | translate}}</span></div><div class=\"details-header-title\">{{\'creditadjustment_use_following_codes\' | translate}}</div><div class=\"details-box\"><div><p ng-bind-html=\"data.adjustmentCode\"></p></div></div><div class=\"form-footer text-right\"><button class=\"interaction-continue-button\" ng-click=\"close()\">{{ \'creditadjustment_done\' | translate }}</button></div></div></div></div></div>");
$templateCache.put("scripts/modules/crm/uteOneViewEnvPage.html","<section controlleras=\"vm\"><div class=\"container\" style=\"padding:20px\"><div class=\"row\"><div class=\"col-xs-offset-3 col-xs-6\" style=\"border:solid black 1px; padding:20px; border-radius: 30px\"><div class=\"col-xs-12\" style=\"text-align: center\"><h3>UTE OneView Environment Selection Page</h3></div><div class=\"col-xs-12\" style=\"text-align: center\">Page Expires in :<timer interval=\"1000\" countdown=\"120\">{{countdown}}</timer>Secs</div><div><div style=\"width: 210px;height: 38px;overflow: hidden;border: 1px solid #939598;border-radius: 7px;background-color: #ffffff; margin-top: 10px; margin-bottom: 20px;padding-left: 10px;margin-left:135px;margin-right:25px;float: left;background: url(images/drop_down_background_env.png) no-repeat right;\"><select name=\"envList\" required=\"\" style=\"background: transparent none repeat scroll 0 0;width: 115%;padding: 8px;border-width: 0; margin-left:-10px;\" placeholder=\"Select an ENV\" data-ng-model=\"vm.envSelected\" ng-options=\"value.env for value in vm.envs\"><option value=\"\">Select an ENV</option></select></div><div class=\"col-xs-2\"><form name=\"crmForm\" novalidate=\"\" action=\"{{vm.envSelected.host | srcResolver}}\" method=\"POST\"><input type=\"hidden\" size=\"25\" name=\"data\" value=\"{{vm.postData.data}}\"> <input type=\"hidden\" size=\"25\" name=\"sig\" value=\"{{vm.postData.sig}}\"> <input type=\"hidden\" size=\"25\" name=\"content\" value=\"{{vm.postData.content}}\"> <input type=\"hidden\" size=\"25\" name=\"sourceChannel\" value=\"{{vm.postData.sourceChannel}}\"><div class=\"pull-right\" style=\"margin-top:6px\"><button type=\"submit\" style=\"background-color:#da291c;border:1px solid #da291c;padding: 0px 30px;line-height:41px;height:41px;color:#ffffff;border-radius:8px;font-weight:600;\" class=\"btn\">GO</button></div></form></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/discoveryPageNoLiveContent/discoveryPageNoLiveContent.partial.html","<div class=\"ute-discoveryPage-directive\" style=\"margin: 0 50px 0 50px;\"><div class=\"carousel-wrap\"><carousel id=\"myCarousel\" class=\"slide\" style=\"position: relative;\" no-wrap=\"false\" data-ride=\"carousel\" no-repeat=\"true\" data-interval=\"false\"><div class=\"carousel-inner\" role=\"listbox\"><slide class=\"item\" data-ng-repeat=\"feature in dpnlc.pageContent.body.features.feature track by $index\"><div class=\"ute-discoveryPage-directive-carouselContainer\"><div class=\"ute-discoveryPage-directive-new\"><div class=\"ute-discoveryPage-directive-newText\" translate=\"ute.discoveryPage.directive.modal.newIcon\"></div></div><div data-ng-if=\"dpnlc.lang===\'en\'\" class=\"slidePane ute-discoveryPage-directive\"><div class=\"ute-discoveryPage-directive-heading\" data-ng-bind-html=\"feature.englishContent.featureName\"></div><div class=\"ute-discoveryPage-directive-secondaryCopy\" data-ng-bind-html=\"feature.englishContent.featureDesc1\"></div><div class=\"slidePaneImage ute-discoveryPage-directive-slidePaneImage\"><img data-ng-src=\"http://www.rogers.com/{{feature.englishContent.breakpoints.breakpoint[0].contentRefUrl}}\" alt=\"{{feature.englishContent.featureName}}\"></div><div class=\"ute-discoveryPage-directive-body\" data-ng-bind-html=\"feature.englishContent.featureDesc2\"></div></div><div data-ng-if=\"dpnlc.lang===\'fr\'\" class=\"slidePane ute-discoveryPage-directive\"><div class=\"ute-discoveryPage-directive-heading\" data-ng-bind-html=\"feature.frenchContent.featureName\"></div><div class=\"ute-discoveryPage-directive-secondaryCopy\" data-ng-bind-html=\"feature.frenchContent.featureDesc1\"></div><div class=\"slidePaneImage ute-discoveryPage-directive-slidePaneImage\"><img data-ng-src=\"http://www.rogers.com/{{feature.frenchContent.breakpoints.breakpoint[0].contentRefUrl}}\" alt=\"{{feature.frenchContent.featureName}}\"></div><div class=\"ute-discoveryPage-directive-body\" data-ng-bind-html=\"feature.frenchContent.featureDesc2\"></div></div></div></slide></div></carousel></div><div class=\"row\" data-ng-hide=\"discoveryPageDirectiveModal.tooltipmode\"><div class=\"col-xs-12 col-sm-12 col-md-push-5 col-md-7\"><div class=\"ute-discoveryPage-directive-continueButtonContainer\"><md-button name=\"button_continue\" data-ng-click=\"dpnlc.continue()\" type=\"button\" class=\"ute-md-primary-button ute-discoveryPage-directive-continueButton\" data-ng-bind-html=\"\'ute.discoveryPage.directive.modal.confirmButton\' | translate\"></md-button></div></div><div class=\"col-xs-12 col-sm-12 col-md-pull-7 col-md-5\"><div class=\"ute-discoveryPage-directive-checkboxContainer\"><md-checkbox class=\"ute-discoveryPage-directive-checkbox\" data-ng-model=\"dpnlc.doNotShow\"><span class=\"ute-discoveryPage-directive-checkboxText\" translate=\"ute.discoveryPage.directive.modal.doNotShow\"></span></md-checkbox></div></div></div></div>");
$templateCache.put("scripts/modules/forgotUserName/forgotUserName.html","<section class=\"page-forgot-username\"><div class=\"container\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" translate=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span translate=\"forgot_username\"></span></li></ul></div><h1 class=\"screen-read-only\" translate=\"forgot_username_heading\"></h1><div ng-hide=\"success === true\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"info-banner error mts\" ng-if=\"isError\" data-test-id=\"myr-forgotUserName-bannerError\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1 error-icon-ctn\"><img src=\"ute-common-assets/assets/warning.png\"></div><div class=\"col-xs-10 col-md-11 error-message-ctn\"><row><div class=\"col-lg-12 error-message-ctn\" ng-bind-html=\"errorDescription\"></div></row></div></div></div><h2 class=\"forgot-username-desc\" translate=\"login_forget_username_desc\" data-test-id=\"myr-forgotUserName-description\"></h2></div></div><form name=\"form1\" novalidate=\"\"><div class=\"col-xs-12\"><div class=\"col-xs-12 col-sm-7\"><div class=\"row\"><div class=\"inline_error\" ng-messages=\"form1.email.$error\" ng-if=\"( form1.$submitted || form1.email.$dirty ) && form1.email.$invalid\"><span ng-message=\"required\"><span class=\"message-margin\" translate=\"login_forget_pwd_email_invalid\" data-test-id=\"myr-forgotUserName-emailInvalid\"></span></span> <span ng-message=\"pattern\"><span translate=\"_email_address_not_valid\" class=\"prm\" data-test-id=\"myr-forgotUserName-invalidEmailAddress\" adl-error-track=\'{\"mappingKey\":\"error.forgot-username\",\"category\":\"self_serve\",\"field\":\"f0\"}\'></span></span></div><div class=\"col-xs-12\"><label class=\"screen-read-only\" for=\"email\">{{aria_label_forgot_username}}</label> <input class=\"no-inline-checker overrite-margin-bottom\" tabindex=\"0\" type=\"text\" id=\"email\" name=\"email\" tag-form-name=\"form\" tag-page-name=\"Forget User Name\" data-ng-model=\"email\" ng-model-options=\"{ updateOn: \'blur\' }\" required=\"\" ng-pattern=\"/[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}$/i\" placeholder=\"{{\'_email\' | translate}}\" autocorrect=\"off\" autocapitalize=\"off\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"forgot-username,forgotUserNameNoLivecontent,event.selfServeStart\"}\' data-test-id=\"myr-forgotUserName-emailAddress\"> <i ng-show=\"form1.email.$invalid && (form1.email.$dirty || form1.$submitted)\" class=\"inline-checker icon-error\"></i> <span ng-show=\"form1.email.$dirty && form1.email.$valid\" class=\"inline-checker icon-checked\"></span></div></div><div class=\"row form-action-ctn\"><div class=\"cancel-ctn\"><a ui-sref=\"signin\" class=\"link-cancel link_blue_color\" data-test-id=\"myr-forgotUserName-buttonCancel\"><span translate=\"_cancel\"></span></a></div><span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"btn-continue-ctn\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" class=\"cta-round primary medium full btn-continue\" data-ng-click=\"submit()\" data-test-id=\"myr-forgotUserName-buttonContinue\" tabindex=\"0\"><span class=\"overrite-span\" translate=\"_continue\"></span></button></div></div></div><div class=\"col-xs-12 col-sm-5\"><need-help-forgot-username data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\" data-alt-text=\"boldChatAltText\" need-help-text-key=\"need_help_username\"></need-help-forgot-username></div></div></form></div><div ng-hide=\"success === false\"><div class=\"row\"><div class=\"col-xs-12 col-md-9 col-lg-12 msg-padding\"><span class=\"forgot-username-success\" translate-values=\"{ email: email }\" translate=\"login_forget_username_success\"></span></div></div></div></div></section>");
$templateCache.put("scripts/modules/guestOverview/guestOverview.html","<section class=\"page-link-account\"><div class=\"container\"><div class=\"row top_intro_section\"><h1 class=\"link_section_title col-xs-12\" translate=\"myr.modules.findAccNumberMoal.link_account_intro_tile\"></h1><div class=\"col-xs-12 col-sm-6 col-md-6 mbl gr\"><div class=\"link_intro_section\"><p translate=\"myr.modules.findAccNumberMoal.link_account_intro_02\"></p><div class=\"btn_holder\"><span class=\"link_text\" ng-click=\"openFindAccNumberModal()\" translate=\"myr.modules.findAccNumberMoal.link_account_intro_02_cta_link\"></span></div><a class=\"btn-link-account\" href=\"#linkaccount\" translate=\"myr.modules.findAccNumberMoal.linked_acc_btn_submit\"></a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 gl\" id=\"myr_myoffers_guest-oveview\"><p translate=\"myr.modules.findAccNumberMoal.link_account_intro_03\"></p><ul class=\"list-unstyled link_acc_list\"><li translate=\"myr.modules.findAccNumberMoal.linked_account_desc_item_1\"></li><li translate=\"myr.modules.findAccNumberMoal.linked_account_desc_item_2\"></li><li translate=\"myr.modules.findAccNumberMoal.linked_account_desc_item_3\"></li><li translate=\"myr.modules.findAccNumberMoal.linked_account_desc_item_4\"></li></ul></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"quick_links_holder\"><h2 class=\"link_section_title\" translate=\"myr.modules.findAccNumberMoal.linked_account_quick_links_title\"></h2><ul class=\"quick_links_list row\"><li class=\"col-xs-12 col-sm-6 col-md-4\" translate=\"myr.modules.findAccNumberMoal.linked_account_quick_links_1\"></li><li class=\"col-xs-12 col-sm-6 col-md-4\" translate=\"myr.modules.findAccNumberMoal.linked_account_quick_links_2\"></li><li class=\"col-xs-12 col-sm-6 col-md-4\" translate=\"myr.modules.findAccNumberMoal.linked_account_quick_links_3\"></li><li class=\"col-xs-12 col-sm-6 col-md-4\" translate=\"myr.modules.findAccNumberMoal.linked_account_quick_links_4\"></li></ul></div></div></div></section>");
$templateCache.put("scripts/modules/internetDashboard/internetDashboard.html","<section data-ng-cloak=\"\" class=\"page-internet-dashboard page-wireless\"><div class=\"col-lg-12 view-page-title\"><div class=\"col-lg-12 mtop-51\" ng-class=\"$ctrl.userService.isRepView() && $ctrl.userService.isDealer() ? \'mtop-20 mbm\' : \'retail\'\"><div class=\"container\"><div ng-class=\"{\'rui-heading\': !$ctrl.userService.isRepView() || $ctrl.userService.isCare()}\"><h1><span translate=\"_internet\"></span></h1></div></div></div></div><div class=\"container\"><div data-internet-my-usage=\"\"></div><div data-internet-my-package=\"\"></div><div data-internet-my-modem=\"\"></div><div class=\"container wireless-package\"><div class=\"row ptm\"><div class=\"col-sm-12 col-md-6 col-lg-5 my-offers-ctn-sm\" data-ng-if=\"!appState.isMobile\"><my-offers></my-offers></div></div></div></div><div class=\"ng-hide\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"$ctrl.selectedAccountNumber\" name=\"selectedAccountNumber\"><br></form></div></section><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"$ctrl.liveChatSettings.floatingInternetDash.cbid\" data-bold-chat-div=\"$ctrl.liveChatSettings.floatingInternetDash.boldChatDiv\" data-chat-button=\"$ctrl.liveChatSettings.floatingInternetDash.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("scripts/modules/migrateUser/migrateUser.html","<section class=\"page-signin\"><div class=\"container\" ng-init=\"onClickUserNameMigrationPageLoadUsage()\"><div class=\"body-grey-dark\"><form id=\"signinForm\" name=\"form\" class=\"body-grey-light\" novalidate=\"\"><div class=\"mtl\"><h1 class=\"sign-in-title\"><span class=\"primary-color\" translate=\"mu_your_username_willbe\"></span></h1></div><div class=\"row mbm\"><div class=\"pln sign-intro mbl\"><h4 translate=\"mu_please_confirm\"></h4><h4 translate=\"mu_patience\"></h4></div></div><div class=\"row\" data-ng-show=\"errorCode === \'general\'\"><div class=\"col-xs-12 col-sm-12 col-lg-8 pln prn\"><div class=\"mbm info-banner error mts\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-12 col-md-11\"><span ng-bind-html=\"errorDescription\"></span></div></div></div></div></div><div class=\"row\" data-ng-show=\"errorCode === \'10802\'\"><div class=\"col-xs-12 col-sm-12 col-lg-8 pln prn\"><div class=\"mbm info-banner error reverse-margin\"><div class=\"row\"><div class=\"col-xs-2 col-sm-2 col-md-1\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-9 col-sm-10 col-md-11 col-lg-11 no-padding\"><div class=\"mbs\" translate=\"mu_sorry_email_registered_1\"></div><div class=\"message-error-normal\" translate=\"mu_sorry_email_registered_2\" translate-values=\"{ email: regObj.email }\"></div><h3 class=\"mts mbs\"><span class=\"rui-icon-live-chat-employee\"></span> <a class=\"title-h5\" ng-href=\"{{chatHref}}\" target=\"_blank\"><span translate=\"mu_chat\" class=\"bold\"></span></a></h3></div></div></div></div></div><div class=\"row mbm\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 pln prn\"><div class=\"inline_error\" ng-messages=\"form.email.$error\" ng-if=\"form.email.$invalid && (form.email.$dirty || form.$submitted)\"><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field><span ng-message=\"required\"><span translate=\"mu_email_required\"></span></span> <span ng-message=\"pattern\"><span translate=\"mu_email_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span translate=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" name=\"email\" placeholder=\"{{\'_email\' | translate}}\" maxlength=\"105\" ng-model-options=\"{ updateOn: \'blur\' }\" onpaste=\"return false;\" data-ng-model=\"regObj.email\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.email.$invalid && (form.email.$dirty || form.$submitted)\"></span> <span ng-show=\"form.email.$dirty && form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 pln prn\"><div class=\"inline_error\" ng-messages=\"form.confirmEmail.$error\" ng-if=\"form.confirmEmail.$invalid && (form.confirmEmail.$dirty || form.$submitted)\"><ute-dtm-error-form-field key=\"dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field><span ng-message=\"required\"><span translate=\"mu_please_confirm_email\"></span></span> <span ng-message=\"match\"><span translate=\"mu_email_not_match\"></span></span> <span ng-message=\"pattern\"><span translate=\"mu_email_not_valid\"></span></span> <span ng-message=\"mismatchEmail\"><span translate=\"_email_not_matched\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"confirmEmail\" placeholder=\"{{\'_confirm_email\' | translate}}\" ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" ng-model-options=\"{ updateOn: \'blur\' }\" data-ng-model=\"confirmEmail\" onpaste=\"return false;\" match-email-mu=\"\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.confirmEmail.$invalid && (form.confirmEmail.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmEmail.$dirty && form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"row mbm\" ng-show=\"true\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-4 txtC pln prn\"><div class=\"pull-right\"><span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button class=\"cta-round primary medium full\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\"><span translate=\"_update_2\"></span></button></div></div></div></form></div></div></section>");
$templateCache.put("scripts/modules/myServices/myServices.html","<div class=\"row\" id=\"myServices\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-4\" data-ng-repeat=\"msl in ms.mss.myServicesList | orderBy:[\'sortOrder\',\'serviceAddress\']\"><div ng-if=\"msl.subscriptionBadgeModule\"><ute-subscription-badge ute-subscription-badge-attr-model=\"msl\"></ute-subscription-badge></div><md-tooltip ng-if=\"msl.subType == \'CTN\'\" md-direction=\"top\">{{::msl.firstName}} {{::msl.lastName}}</md-tooltip><div ng-if=\"!msl.subscriptionBadgeModule\" class=\"myServiceWrap\" data-test-id=\"myr-myServices-service{{$index}}\" data-ng-click=\"(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled && !(ms.isCare && msl.disabled)) ? ms.runService(msl.serviceName, msl.serviceDetail) : \'\'\" data-ng-class=\"{\'pointer\':(ms.btnSettings.allSubscriptions !== ms.btnStatus.disabled && !(ms.isCare && msl.disabled)), \'no-hover-pointer\':((ms.isDealer || (ms.isCare && ms.mss.isRHPMigratedFlow === \'false\') || (ms.isCare && msl.disabled)) && msl.serviceName===\'homephone\'), \'shm-disabled\': (isCare && msl.disabled)}\"><div class=\"myServiceName\"><div class=\"textVertical iconHeight col-lg-4 col-md-3 col-sm-3 col-xs-3\"><span data-ng-if=\"msl.icon\" class=\"{{msl.icon}} icon margin-top-23\" data-ng-class=\"{\'margin-top-33\':ms.mss.heroDetails[msl.serviceDetail].hup4BPO || ms.mss.heroDetails[msl.serviceDetail].hupOffer || ms.mss.heroDetails[msl.serviceDetail].tvmBPO || ms.mss.heroDetails[msl.serviceDetail].tvmOffer || ms.mss.heroDetails[msl.serviceDetail].standAloneBPO}\"></span> <span data-ng-if=\"msl.imageIcon\" class=\"myr-image-icon myr-{{ msl.imageIcon }}\"></span></div><div class=\"textVertical title-h5 col-lg-8 col-md-9 col-sm-9 col-xs-9\" data-ng-class=\"{\'text-vertical-tvmOffer\':ms.mss.heroDetails[msl.serviceDetail].hup4BPO || ms.mss.heroDetails[msl.serviceDetail].hupOffer || ms.mss.heroDetails[msl.serviceDetail].tvmBPO || ms.mss.heroDetails[msl.serviceDetail].tvmOffer || ms.mss.heroDetails[msl.serviceDetail].standAloneBPO}\"><span ng-class=\"{\'inline\' : msl.serviceType === \'service_wireless_prepaid\', \'badgeTitle\' : msl.subType !== \'CTN\' && msl.serviceType !== \'service_wireless_prepaid\'}\" data-ng-show=\"msl.subType !== \'CTN\' || msl.serviceType === \'service_wireless_prepaid\'\" translate=\"{{msl.serviceType}}\"></span> <span class=\"badge-ind-wireless-name\" data-ng-show=\"msl.subType === \'CTN\'\">{{ msl.firstName | limitTo : 15}}</span><br><span data-ng-show=\"msl.showPhone\"><div class=\"badge-ind-wireless-phone\">{{::msl.serviceDetail | ute_common_filter_phone2:\'$1-$2-$3\'}}</div></span> <span class=\"badgeTextAddress\" ng-if=\"(msl.subType !== \'CTN\') && (msl.subType !== \'RHPc\')\">{{::msl.serviceAddress}}</span></div><div class=\"badgeList-offer\" data-ng-if=\"ms.mss.heroDetails[msl.serviceDetail].hup4BPO || ms.mss.heroDetails[msl.serviceDetail].hupOffer || ms.mss.heroDetails[msl.serviceDetail].tvmBPO || ms.mss.heroDetails[msl.serviceDetail].tvmOffer || ms.mss.heroDetails[msl.serviceDetail].standAloneBPO\"><img class=\"badgeList-promo\" src=\"/web/totes/cms/images/promo.png\"> <span class=\"badgeList-exclusive-offer\" translate=\"exclusive_offer\"></span></div></div><div class=\"myServiceArrow\"></div><div class=\"myServiceCTA homeMonitoringCTA\"><div class=\"textVertical arrow-ctn\"><a name=\"{{msl.serviceName}}\"><span class=\"rui-icon-button-arrow-right\"></span></a></div></div></div></div></div>");
$templateCache.put("scripts/modules/myrBriteBill/briteBillView.html","<iframe id=\"bb_iframe\" class=\"bb_iframe\" scrolling=\"no\" data-ng-src=\"{{bb.trustSrc(bb.getSRC())}}\"></iframe>");
$templateCache.put("scripts/modules/myrContentExpand/contentExpand.template.html","<accordion class=\"contentExpander\"><div ng-class=\"(isOpen ? \'fadeIn\' : \'fadeOut\') + \' \' + borderType\" class=\"contentBorder\"><div accordion-group=\"\" is-open=\"isOpen\"><accordion-heading></accordion-heading><div ng-class=\"isOpen ? \'fadeInDelay\' : \'fadeOut\'\"><ng-transclude></ng-transclude></div></div></div></accordion>");
$templateCache.put("scripts/modules/myrPaymentTopBar/paymentTopBarRepView.html","<div class=\"top-bar-ctn paynow-body-size ptm payment-top-bar\"><div class=\"mtm radius-three-sides light-gray-bg container plm mtl\"><div class=\"row ptm\"><div class=\"col-xs-12 col-md-3 ptm pbs prs\"><span class=\"title-light-h4 mbs\" style=\"position:relative; top:-5px;\"><span class=\"semi-bold\" translate=\"paynow_acc_balance_today\" data-test-id=\"myr-paymentTopBar-totalAccountBalance\"></span><div class=\"rui-package-pricing title-h3\"><div class=\"price semi-bold\"><span class=\"price-sign\" ng-hide=\"ptb.lang === \'fr\'\">$</span> <span class=\"price-dollars\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceDollars\">{{ptb.abdf.billingDetails.balanceAmount.substr(0,ptb.abdf.billingDetails.balanceAmount.indexOf(\'.\'))}}</span> <span class=\"price-details\"><span class=\"price-cents\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceCents\">{{ptb.abdf.billingDetails.balanceAmount | decimals : ptb.lang}} <span ng-hide=\"ptb.lang ===\'en\'\">$</span></span> <span class=\"price-period\">&nbsp;</span></span></div></div><div ng-if=\"(ptb.abdf.billingDetails.pastDueBalance > 0) && (ptb.abdf.billingDetails.balanceAmount > 0)\" class=\"red overdue-balance\" data-test-id=\"myr-paymentTopBar-includingOverdueText\"><span translate=\"paynow_overdue\"></span></div></span></div><div class=\"col-xs-12 col-md-5 rm ptm pbs\"><div class=\"pay-now-ctn row mbs\" ng-class=\"{\'mtm\': ptb.ptbs.paymentMethod === \'R\'}\"><div class=\"title-light-h1\"><span data-test-id=\"myr-paymentTopBar-paymentMethodLabel\" translate=\"paynow_payment_method2\"></span>: <span class=\"mrm\" data-test-id=\"myr-paymentTopBar-paymentMethod\" ng-switch=\"\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\" translate=\"paynow_method_check\"></span> <span ng-switch-when=\"C\" translate=\"paynow_payment_method_cc\"></span> <span ng-switch-when=\"R\" translate=\"ute.payment.rep.payment_method_manual\"></span> <span ng-switch-when=\"U\" translate=\"change_method_unavailable\"></span></span></div></div><div class=\"row mbs\" ng-if=\"ptb.ptbs.paymentMethod !== \'R\'\"><div class=\"col-xs-12\"><div ng-switch=\"\" data-test-id=\"myr-paymentTopBar-paymentMethodDetails\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\"><span class=\"title-light-h4 semi-bold\" data-test-id=\"myr-paymentTopBar-bankAccountNumber\" translate=\"paynow_bank_account_number\"></span> : {{ ptb.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber | splice:0:1}}XXX XXXX XXXX X{{ptb.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber | splice:1:4}}</span> <span ng-switch-when=\"C\" class=\"payment-method-details semi-bold\"><span data-test-id=\"myr-paymentTopBar-ccType\">{{ ptb.getCreditCardText() }}:</span> <span data-test-id=\"myr-paymentTopBar-ccNumber\">XXXX XXXX XXXX {{ ptb.abdf.billingDetails.methodOfPayment.creditCardDetails.ccNumber | splice:0:4 }}</span></span> <span ng-switch-when=\"R\"></span> <span ng-switch-default=\"\"></span></div></div></div><ute-payment-method one-view-view-bill=\"\" selected-account=\"ptb.selectedAccountDetail\"></ute-payment-method></div><div class=\"col-xs-12 col-md-4 pbs prs\"><div class=\"dotted-left-border\" ng-show=\"ptb.state != \'paynow\'\"><div class=\"row\"><div class=\"col-xs-12\"><myr-account-balance view-html=\"accountBalanceHorizon.html\" permission=\"VIEW_ACCOUNT_BALANCE\"></myr-account-balance></div></div><div class=\"row\"><div class=\"col-xs-6\" ng-class=\"{\'pts\' : ptb.state === \'paymenthistory\'}\"><a class=\"button-view-bill ptm\" ng-click=\"ptb.goToPTP()\" ng-if=\"ptb.ptpReadPermissionAccess\"><span translate=\"ute.payment.rep.schedule_ptp\" data-test-id=\"myr-paymentTopBar-schedulePTP\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-6 pbm\"><button name=\"payBill\" class=\"cta-round primary large pay-now-btn-cm2\" ng-click=\"repMakePaymentAccess && ptb.payBill()\" data-test-id=\"myr-paymentTopbar-payBill\" ng-class=\"{\'noAgentPermission\' : !repMakePaymentAccess}\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"make-a-payment,event.selfServeStart\"}\'><span class=\"white\" translate=\"acc_balance_pay_now\"></span></button></div></div><div class=\"row\"><div class=\"col-xs-6\"><a class=\"button-view-bill\" ng-hide=\"ptb.state === \'paymenthistory\'\" ui-sref=\"paymenthistory\"><span translate=\"history\" data-test-id=\"myr-paymentTopBar-paymentHistory\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-6 pbm\"><button name=\"makeAdjustment\" ng-if=\"repCreditManagementAccess && showAdjustmentButton\" class=\"cta-round primary large pay-now-btn-cm2 make-adjustment-btn\" ng-click=\"ptb.creditAdjustment()\" tabindex=\"0\"><span class=\"white\">{{ \'creditadjustment_credit_management\' | translate}}</span></button></div></div></div></div><div class=\"col-xs-12 pbs txtC\" ng-show=\"ptb.state !=\'paynow\'\"><div ng-show=\"ptb.state != \'paynow\'\"><div ng-show=\"isPaynowPage\" class=\"mbm\">&nbsp;</div></div></div></div></div></div>");
$templateCache.put("scripts/modules/myrPaymentTopBar/paymentTopBarView.html","<div class=\"top-bar-ctn paynow-body-size ptm payment-top-bar\"><div class=\"mtm radius-three-sides light-gray-bg container plm mtl\"><div class=\"row\"><div class=\"col-xs-12 col-md-4 ptm pbs prs\"><span class=\"title-light-h4 mbs\" style=\"position:relative; top:-5px;\"><span class=\"semi-bold\" translate=\"paynow_acc_balance_today\" data-test-id=\"myr-paymentTopBar-totalAccountBalance\"></span><div class=\"rui-package-pricing title-h3\"><div class=\"price semi-bold\"><span class=\"price-sign\" ng-hide=\"ptb.lang === \'fr\'\">$</span> <span class=\"price-dollars\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceDollars\">{{ptb.abdf.billingDetails.balanceAmount.substr(0,ptb.abdf.billingDetails.balanceAmount.indexOf(\'.\'))}}</span> <span class=\"price-details\"><span class=\"price-cents\" data-test-id=\"myr-paymentTopBar-totalAccountBalanceCents\">{{ptb.abdf.billingDetails.balanceAmount | decimals : ptb.lang}} <span ng-hide=\"ptb.lang ===\'en\'\">$</span></span> <span class=\"price-period\">&nbsp;</span></span></div></div><div ng-if=\"(ptb.abdf.billingDetails.pastDueBalance > 0) && (ptb.abdf.billingDetails.balanceAmount > 0)\" class=\"red overdue-balance\" data-test-id=\"myr-paymentTopBar-includingOverdueText\"><span translate=\"paynow_overdue\"></span></div></span></div><div class=\"col-xs-12 col-md-5 rm ptm pbs\"><div class=\"pay-now-ctn row\"><div class=\"title-light-h4 mbs\"><span class=\"semi-bold\" data-test-id=\"myr-paymentTopBar-paymentMethodLabel\" translate=\"paynow_payment_method2\"></span>: <span class=\"mrm light\" data-test-id=\"myr-paymentTopBar-paymentMethod\" ng-switch=\"\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\" translate=\"ute.rogers.paymentTopBar.consumer.method_debit\"></span> <span ng-switch-when=\"C\" translate=\"ute.rogers.paymentTopBar.consumer.method_cc\"></span> <span ng-switch-when=\"R\" translate=\"ute.rogers.paymentTopBar.consumer.method_manual\"></span> <span ng-switch-when=\"U\" translate=\"change_method_unavailable\"></span></span></div></div><div class=\"row\"><div class=\"col-xs-12\"><div ng-switch=\"\" data-test-id=\"myr-paymentTopBar-paymentMethodDetails\" on=\"ptb.ptbs.paymentMethod\"><span ng-switch-when=\"D\"><span class=\"title-light-h4 semi-bold\" data-test-id=\"myr-paymentTopBar-bankAccountNumber\" translate=\"paynow_bank_account_number\"></span> : {{ ptb.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber | splice:0:1}}XXX XXXX XXXX X{{ptb.abdf.billingDetails.methodOfPayment.chequingDetails.accountNumber | splice:1:4 }}</span> <span ng-switch-when=\"C\" class=\"payment-method-details\"><img class=\"payment-method-image\" data-test-id=\"myr-paymentTopBar-ccImage\" ng-src=\"{{ ptb.getCreditCardImage() }}\"> <span data-test-id=\"myr-paymentTopBar-ccType\"><strong>{{ ptb.getCreditCardText() }}</strong></span><br><span data-test-id=\"myr-paymentTopBar-ccNumber\">XXXX XXXX XXXX {{ ptb.abdf.billingDetails.methodOfPayment.creditCardDetails.ccNumber | splice:0:4 }}</span></span> <span ng-switch-when=\"R\"></span> <span ng-switch-default=\"\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\" ng-if=\"ptb.als.getSelectedAccount().accountStatus !== \'Cancelled\'\"><ute-payment-method selected-account=\"ptb.selectedAccountDetail\" payment-top-bar=\"\" payment-method-changed-callback=\"ptb.paymentMethodChangedCallback(method)\"></ute-payment-method></div><div class=\"col-xs-12 col-md-6\" ng-hide=\"ptb.state === \'paymenthistory\'\"><a class=\"button-view-bill\" ui-sref=\"paymenthistory\"><span translate=\"history\" data-test-id=\"myr-paymentTopBar-paymentHistory\" class=\"bold\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div></div><div class=\"col-xs-12 col-md-3 ptm pbs prs\"><myr-account-balance view-html=\"accountBalanceHorizon.html\" permission=\"VIEW_ACCOUNT_BALANCE\"></myr-account-balance><div ng-show=\"ptb.state != \'paynow\'\"><div class=\"brite-bill-pay-now\"><button name=\"payBill\" class=\"cta-round primary large pay-now-btn-cm2\" ng-click=\"repMakePaymentAccess && ptb.payBill()\" data-test-id=\"myr-paymentTopbar-payBill\" ng-class=\"{\'noAgentPermission\' : !repMakePaymentAccess}\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"make-a-payment,event.selfServeStart\"}\'><span class=\"white\" translate=\"acc_balance_pay_now\"></span></button></div></div></div><div class=\"col-xs-12 pbs txtC\" ng-show=\"ptb.state !=\'paynow\'\"><div ng-show=\"ptb.state != \'paynow\'\"><div ng-show=\"isPaynowPage\" class=\"mbm\">&nbsp;</div></div></div></div></div></div>");
$templateCache.put("scripts/modules/myrSecurityQuestion/securityQuestion.html","<div class=\"page-complete-profile\"><div class=\"container\"><form name=\"form\" class=\"profile-form\" novalidate=\"\" label=\"Complete Profile - Security Question\" id=\"completeProfileForm\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 profile-title\"><span translate=\"_security_questions\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-show=\"isError\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span class=\"plm\" ng-bind-html=\"errorDescription\"></span></div></div><div class=\"row info-banner-complete-profile error mts mbm\" data-ng-show=\"(form.$valid == false && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><p class=\"plm\" translate=\"_check_form_errors\"></p></div></div></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.question.$error\" ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"><span ng-message=\"required\"><span translate=\"_require_security_question\"></span></span></div><div class=\"profile-select-wide\"><select name=\"question\" data-ng-model=\"questionId\" required=\"\" ng-options=\"key as value for (key, value) in questions\"><option translate=\"_security_questions\"></option></select></div><span class=\"beside-checker icon-error drop-down\" data-ng-show=\"form.question.$invalid && (form.question.$dirty || form.$submitted)\"></span> <span ng-show=\"form.question.$dirty && form.question.$valid\" class=\"beside-checker icon-checked\"></span></div></div><div class=\"row mbm\"><div class=\"col-md-6\"><div class=\"inline_error\" ng-messages=\"form.answer.$error\" ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"><span ng-message=\"required\"><span translate=\"_require_security_answer\"></span></span></div><label class=\"rel\"><input type=\"text\" name=\"answer\" tag-form-name=\"form\" tag-page-name=\"Registration\" placeholder=\"{{\'_answer\' | translate}}\" ng-model-options=\"{ updateOn: \'blur\' }\" ng-maxlength=\"105\" data-ng-model=\"answer\" required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"form.answer.$invalid && (form.answer.$dirty || form.$submitted)\"></span> <span ng-show=\"form.answer.$dirty && form.answer.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6\"><div class=\"pull-right\" ng-show=\"loadingDataIndicator\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" ng-disabled=\"loadingDataIndicator\" data-ng-click=\"submit()\" class=\"cta-round primary medium full\"><span translate=\"_continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("scripts/modules/myrViewBill/billingEnhancementModal.html","<div><div class=\"britebillenhancement-overlayTop\"><div class=\"britebillenhancement-flex-item\"><div class=\"britebillenhancement-info-icon\"><img src=\"images/warning_yellow_lg.png\" alt=\"\"></div><div class=\"briteBillEnhancement-overlayTopHeading\" translate=\"billing_enhance_overlay_heading\"></div></div><div><img class=\"close-icon\" ng-click=\"vb.cancel($event)\" src=\"ute-common-assets/assets/close-icon.png\"></div></div><div class=\"row-padding britebillenhancement-copy-text\"><p translate=\"billing_enhance_overlay_text\"></p></div></div>");
$templateCache.put("scripts/modules/myrViewBill/billingEnhancementModal.window.html","<div tabindex=\"-1\" role=\"dialog\" class=\"modal briteBill-enhancement-modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog modal-xs\" style=\"max-width: 400px;\"><div class=\"modal-content briteBill-enhancement-overlay animate-bottom-open\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("scripts/modules/myrViewBill/billingVideoModal.html","<div class=\"billing-video-modal-template\"><div class=\"billing-video-header\"><div class=\"billing-video-header-text\" translate=\"ute.rogers.myrViewBill.billing_video_modal_header\"></div><div class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"closeThisDialog()\" tabindex=\"-1\"></div></div><div class=\"billing-video-body\"><div class=\"video-container\"><iframe ng-if=\"vb.lang === \'en\'\" src=\"https://www.youtube.com/embed/SdduKhozahc\" frameborder=\"0\" allowfullscreen=\"\"></iframe><iframe ng-if=\"vb.lang === \'fr\'\" src=\"https://www.youtube.com/embed/Up5CKFxHzdQ\" frameborder=\"0\" allowfullscreen=\"\"></iframe></div><div class=\"how-to\"><div class=\"how-to-header\" translate=\"ute.rogers.myrViewBill.billing_video_modal_how_to_header\"></div><div class=\"how-to-list\"><ul><li translate=\"ute.rogers.myrViewBill.billing_video_modal_how_to_item1\"></li><li translate=\"ute.rogers.myrViewBill.billing_video_modal_how_to_item2\"></li><li translate=\"ute.rogers.myrViewBill.billing_video_modal_how_to_item3\"></li><li translate=\"ute.rogers.myrViewBill.billing_video_modal_how_to_item4\"></li></ul></div></div></div></div>");
$templateCache.put("scripts/modules/myrViewBill/viewBill.html","<h1 class=\"screen-read-only\" translate=\"view_bill_heading\"></h1><div ng-show=\"vb.isPrepaid\"><section globalloader=\"content\"><div ui-view=\"\"><div class=\"largeload\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></div></section><div style=\"display: none;\"><form role=\"form\" name=\"vb.form\" id=\"prepaidFormToRogers\" method=\"post\" novalidate=\"\" action=\"\">BAN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vb.accountNumber\" name=\"ban\"><br>CTN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vb.ctn\" name=\"ctn\"><br>PIN: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"vb.pin\" name=\"passCode\"><br></form></div></div><div class=\"col-xs-12 view-page-title\"><div class=\"col-xs-12 mtop-25\" ng-class=\"::{\'retail\': !isRepView}\"><div class=\"container\"><div><h1><span translate=\"ute.common.label.billAndAccountBalance\" data-test-id=\"myr-billAndPayment\"></span> <span class=\"widget-loader-inline asfadf\" ng-if=\"wdController.loadingDataIndicator || loadingBriteBill\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><section class=\"page-brite-bill\" ng-if=\"!vb.isPrepaid\"><div class=\"container\"><myr-account-balance view-html=\"accountBalance.viewBill.html\"></myr-account-balance></div><div class=\"top-spacer\" ng-class=\"{\'gray-area\': !vb.isNoBillsAvailable() && !vb.isBriteBillErrorOccurred()}\"><div class=\"bills-options\"><div ng-if=\"vb.invoiceDateArray && vb.invoiceDateArray.length > 0\" class=\"bills-control-panel\"><div class=\"title-container hidden-xs hidden-sm\"><div class=\"select-box-wrapper\"><select class=\"ute-input-select services\" id=\"bill-selector\" name=\"invoiceDate\" ng-model=\"vb.invoiceDateSelected\" ng-change=\"vb.invoiceDateChange()\" tabindex=\"0\"><option ng-repeat=\"date in vb.invoiceDateArray\" value=\"{{date.id}}\" ng-selected=\"date.issue_date === selectedDate\">{{date.amount | currencies : vb.getLang()}} - {{date.name | ute_common_filter_language_date | translate}}</option></select><span class=\"select-bill\"><ins translate=\"ute.rogers.myrViewBill.selectBill\"></ins></span><svg class=\"chevron-down\" width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect fill-rule=\"nonzero\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><polygon fill=\"#000000\" fill-rule=\"nonzero\" points=\"16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10\"></polygon></g></svg></div></div><div class=\"title-container visible-xs visible-sm\"><div class=\"select-box-wrapper\"><select class=\"ute-input-select services\" id=\"bill-selector-md\" name=\"invoiceDate\" ng-model=\"vb.invoiceDateSelected\" ng-change=\"vb.invoiceDateChange()\" tabindex=\"0\"><option ng-repeat=\"date in vb.invoiceDateArray\" value=\"{{date.id}}\" ng-selected=\"date.issue_date === selectedDate\">{{date.amount | currencies : vb.getLang()}} - {{date.name | ute_common_filter_language_date | translate}}</option></select><span class=\"select-bill\"><ins translate=\"ute.rogers.myrViewBill.selectBill\"></ins></span><svg class=\"chevron-down\" width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect fill-rule=\"nonzero\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><polygon fill=\"#000000\" fill-rule=\"nonzero\" points=\"16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10\"></polygon></g></svg></div></div><div class=\"save-bill-container clear pull-right\"><ute-save-bill account-number=\"vb.accountNumber\"></ute-save-bill></div><div class=\"billing-notification\" ng-if=\"!!vb.billingNotification\"><div ng-bind-html=\"vb.billingNotification\"></div></div></div></div><div class=\"row\"><div class=\"container error-message\" data-ng-if=\"vb.isNoBillsAvailable() || vb.isBriteBillErrorOccurred()\"><div class=\"col-xs-12\"><div ng-if=\"vb.isNoBillsAvailable() && !vb.isBriteBillErrorOccurred()\"><div class=\"brite-bill-nobill-image\"><img ng-src=\"images/info_notice_lg.png\"></div><div class=\"error-message-title\" translate=\"bb_error_message_header_no_bill\"></div><div class=\"error-message\" translate=\"bb_error_message_no_bill\" translate-value-date=\"{{vb.billingCycleEndDate() | date:\'MM/dd\'}}\"></div></div><div ng-if=\"vb.isBriteBillErrorOccurred()\"><img class=\"brite-bill-error-image\" ng-src=\"images/warning_yellow_lg.png\"><div class=\"information\"></div><div class=\"error-message-title\" translate=\"bb_error_message_header_system_issue\"></div><div translate=\"bb_error_message_system_issue\"></div><div class=\"row brite-bill-live-chat\"><div class=\"col-sm-6 brite-bill-live-chat-right hidden-xs\"><img class=\"phone-image\" ng-src=\"images\\phone.png\">{{vb.supportNumber}}</div><div class=\"col-xs-12 col-sm-6 brite-bill-live-chat-left\"><bold-chat-static-button data-cbid=\"{{vb.liveChatSettings.viewBillError.cbid | translate}}\" data-dynamic-div=\"{{vb.liveChatSettings.viewBillError.boldChatDiv | translate}}\" data-chat-button=\"{{vb.liveChatSettings.viewBillError.chatButton | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><div class=\"col-xs-12 brite-bill-live-chat-right visible-xs\"><img class=\"phone-image\" ng-src=\"images\\phone.png\">{{vb.supportNumber}}</div></div></div></div><div class=\"col-xs-12 cta-round bb-account-overview\" ui-sref=\"accountOverview\" translate=\"return_to_account_overview\" tabindex=\"0\"></div></div></div><div class=\"bb-iframe-wrapper container\" data-ng-if=\"vb.invoiceDateArray && vb.invoiceDateArray.length > 0\"><div data-test-id=\"myr-viewBill-briteBillIFrame\" id=\"bb_iframe_container\" class=\"iframe-ctn bb-iframe-container\" data-myr-brite-bill=\"\" account-number=\"vb.accountNumber\"></div></div></div></section><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"vb.liveChatSettings.floatingViewBill.cbid\" data-bold-chat-div=\"vb.liveChatSettings.floatingViewBill.boldChatDiv\" data-chat-button=\"vb.liveChatSettings.floatingViewBill.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("scripts/modules/notificationBanner/notificationBanner.html","<div class=\"ng-cloak row message-banner notification success mtm mbm\" data-ng-cloak=\"\" data-ng-show=\"nb.isVisible()\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls\" style=\"max-width: 45px;\"><i class=\"fa fa-check-circle fa-2x success-color\"></i></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" style=\"padding: 0 10px 0 5px;\"><div class=\"mbs mts\" translate=\"{{nb.getMessage()}}\"></div></div></div></div>");
$templateCache.put("scripts/modules/onboarding/onboarding.view.html","<div ng-if=\"ctrl.showOnboardingModule\" adl-event-track=\'{\"callBackParam\": {\"mappingKey\":\"onboarding.widget\", \"segmentName\": \"{{ctrl.getAnalyticsSegmentName()}}\"}}\'><div class=\"onBoarding_checklist_holder\" ng-class=\"{\'expanded\': !ctrl.isCollapsed, \'congratulations_block\': ctrl.showCongratsMessage()}\"><div class=\"checklist_col info_box\"><div class=\"progress_info_section\"><h2 translate=\"onBoarding.header\"></h2><div role=\"group\" class=\"progress-bar_holder teaser_view\"><div tabindex=\"0\" class=\"progress\" aria-label=\"{{\'onBoarding.ProgressBarAltText\' | translate:{percent: ctrl.calculateProgress()} }}\"><div tabindex=\"-1\" class=\"progress-bar\" aria-hidden=\"true\" aria-valuenow=\"ctrl.calculateProgress()\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': ctrl.calculateProgress()+\'%\'}\"></div></div><span translate=\"onBoarding.ProgressBarText\" translate-values=\"{percent: ctrl.calculateProgress()}\"></span></div><p class=\"teaser_view\" translate=\"onBoarding.description01\" translate-values=\"{count: ctrl.itemConfigs.length}\"></p></div><div class=\"congratulations_holder\"><div class=\"img_holder\"><img src=\"images/onBoarding_checklist/congratulations_icon.svg\" alt=\"\"></div><div class=\"text_holder\"><h2 translate=\"onBoarding.congratulationsSection.title\"></h2><p translate=\"onBoarding.congratulationsSection.description01\"></p><p translate=\"onBoarding.congratulationsSection.description02\"></p></div></div></div><div class=\"checklist_col ctns_holder\"><div role=\"group\" class=\"progress-bar_holder teaser_expanded_view\"><div tabindex=\"0\" class=\"progress\" aria-label=\"{{\'onBoarding.ProgressBarAltText\' | translate:{percent: ctrl.calculateProgress()} }}\"><div tabindex=\"-1\" class=\"progress-bar\" aria-hidden=\"true\" aria-valuenow=\"ctrl.calculateProgress()\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{\'width\': ctrl.calculateProgress()+\'%\'}\"></div></div><span translate=\"onBoarding.ProgressBarText\" translate-values=\"{percent: ctrl.calculateProgress()}\"></span></div><ul class=\"ctns_box teaser_view\"><li ng-repeat=\"config in ctrl.itemConfigs\"><onboarding-item config=\"config\"></onboarding-item></li></ul></div><a role=\"button\" tabindex=\"0\" ng-click=\"ctrl.closeCongratsMsg()\" ng-keypress=\"($event.which === 32 || $event.which === 13) ? ctrl.closeCongratsMsg() : 0;\" class=\"btn_close rogers-icon-circle-x\" aria-label=\"{{\'onBoarding.closeAltText\' | translate }}\"></a> <a role=\"button\" tabindex=\"0\" class=\"show_more\" ng-click=\"ctrl.onToggle()\" ng-keypress=\"($event.which === 32 || $event.which === 13) ? ctrl.onToggle() : 0;\"><span ng-show=\"!ctrl.isCollapsed\" aria-label=\"{{\'onBoarding.showLessAltText\' | translate:{count: ctrl.itemConfigs.length} }}\" title=\"{{\'onBoarding.showLessAltText\' | translate:{count: ctrl.itemConfigs.length} }}\">{{\'onBoarding.showLessText\' | translate }} <i class=\"rui-icon-chevron-up\"></i></span> <span ng-show=\"ctrl.isCollapsed\" aria-label=\"{{\'onBoarding.showMoreAltText\' | translate:{count: ctrl.itemConfigs.length} }}\" title=\"{{\'onBoarding.showMoreAltText\' | translate:{count: ctrl.itemConfigs.length} }}\">{{\'onBoarding.showMoreText\' | translate }} <i class=\"rui-icon-chevron-down\"></i></span></a></div></div>");
$templateCache.put("scripts/modules/paymentHistory/paymentHistory.html","<h1 class=\"screen-read-only\" translate=\"payment_history_heading\"></h1><div class=\"col-xs-12 view-page-title\" ng-if=\"isConsumer\"><div class=\"col-xs-12 mtop-51\" ng-class=\"::{\'retail\': !isRepView, \'mtop-20\': isRepView, \'mbm\': isRepView}\"><div class=\"container\"><div ng-class=\"::{\'rui-heading\': !isRepView}\"><h1><span translate=\"ute.common.label.billAndPayment\" data-test-id=\"myr-billAndPayment\"></span> <span class=\"widget-loader-inline\" ng-if=\"wdController.loadingDataIndicator || loadingBriteBill\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><section class=\"page-payment-history\"><div><div class=\"container\" ng-if=\"isConsumer\"><myr-account-balance view-html=\"accountBalance.viewBill.html\"></myr-account-balance></div><div class=\"mtl\"><ute-recent-payment-success-message></ute-recent-payment-success-message></div><div class=\"payment-history-container\"><div class=\"container\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-sm-12 col-lg-7\"><div class=\"ptm primary-color pbs title-light-h2\"><span class=\"payment-history-title\" translate=\"history\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"{{\'payment_history_loader\' | translate}}\"></span></div></div></div></div><div class=\"container\" ng-show=\"!loadingDataIndicator\"><div ng-if=\"::isSGIAccount()\" class=\"row history-sgi-disclaimer\" translate=\"history_sgi_account_disclaimer\"></div><div class=\"row\"><div class=\"row info-banner error ptm mbm\" style=\"margin-left: 0;\" data-ng-if=\"errorMessage === \'\' && historyIsEmpty\"><div data-ng-if=\"errorCode > 0\"><div class=\"col-xs-2 col-md-1 no-padding\" style=\"max-width: 45px;\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-md-11 no-padding\" style=\"float:left\"><span translate=\"50001\"></span></div></div><span translate=\"history_empty\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div><div class=\"history-list\" data-ng-if=\"historyIsEmpty === false\"><div><div class=\"hidden-xs\"><div class=\"row title-h3 history-list-head\"><div class=\"col-sm-2\"><div class=\"sorting-column\" tabindex=\"0\" ng-click=\"updateSortMethod(SORT_FIELDS.DATE)\"><span translate=\"history_payment_date\"></span> <span class=\"column-sort-chevron\" ng-class=\"sortField !== SORT_FIELDS.DATE ? \'rui-icon-chevron-down transparent-70\' : sortReverse ? \'rui-icon-chevron-down\' : \'rui-icon-chevron-up\'\" aria-hidden=\"true\"></span></div></div><div class=\"col-sm-2 txtL\"><div class=\"sorting-column\" tabindex=\"0\" ng-click=\"updateSortMethod(SORT_FIELDS.AMOUNT)\"><span translate=\"history_payment_amount\"></span> <span class=\"column-sort-chevron\" ng-class=\"sortField !== SORT_FIELDS.AMOUNT ? \'rui-icon-chevron-down transparent-70\' : sortReverse ? \'rui-icon-chevron-down\' : \'rui-icon-chevron-up\'\" aria-hidden=\"true\"></span></div></div><div class=\"col-sm-3 txtL\"><div class=\"sorting-column\" tabindex=\"0\" ng-click=\"updateSortMethod(SORT_FIELDS.METHOD)\"><span translate=\"history_payment_method\"></span> <span class=\"column-sort-chevron\" ng-class=\"sortField !== SORT_FIELDS.METHOD ? \'rui-icon-chevron-down transparent-70\' : sortReverse ? \'rui-icon-chevron-down\' : \'rui-icon-chevron-up\'\" aria-hidden=\"true\"></span></div></div><div class=\"col-sm-3 txtL\"><div class=\"sorting-column\" tabindex=\"0\" data-ng-click=\"updateSortMethod(SORT_FIELDS.DETAILS)\"><span translate=\"history_payment_details\"></span> <span class=\"column-sort-chevron\" ng-class=\"sortField !== SORT_FIELDS.DETAILS ? \'rui-icon-chevron-down transparent-70\' : sortReverse ? \'rui-icon-chevron-down\' : \'rui-icon-chevron-up\'\" aria-hidden=\"true\"></span></div><span class=\"btn btn-default more-info-circle\" popover-trigger=\"mouseenter\" popover-placement=\"right\" popover-popup-delay=\"300\" popover-template=\"\'popoverSnippet\'\" popover-is-open=\"popoverOptions.isOpen[0]\" type=\"button\">i</span></div><div class=\"col-sm-2 txtL\"><div class=\"sorting-column\" tabindex=\"0\" ng-click=\"updateSortMethod(SORT_FIELDS.REFERENCE)\"><span translate=\"history_payment_reference\"></span> <span class=\"column-sort-chevron\" ng-class=\"sortField !== SORT_FIELDS.REFERENCE ? \'rui-icon-chevron-down transparent-70\' : sortReverse ? \'rui-icon-chevron-down\' : \'rui-icon-chevron-up\'\" aria-hidden=\"true\"></span></div></div></div><div class=\"history-list-body\"><div class=\"row pbm payment-item\" data-ng-repeat=\"payment in histories | orderBy:sortField:sortReverse | slice:pagination.start:pagination.end track by $index\"><div class=\"col-sm-2\"><span class=\"payment-date-item\">{{payment.tranDateForm }}</span></div><div class=\"col-sm-2 txtL\"><span class=\"no-padding\"><span class=\"amount-sign-prefix\">{{payment.amountPrefix}}</span>{{abs(payment.amount) | currency}}</span></div><div class=\"col-sm-3 txtL\"><span>{{payment.paymentCode}}</span></div><div class=\"col-sm-3 txtL\"><span>{{payment.paymentStatusDesc}}</span></div><div class=\"col-sm-2 txtL\"><span>{{payment.refNum}}</span></div></div></div></div><div class=\"visible-xs row title-h4\" ng-if=\"historyIsEmpty === false\"><div class=\"title_14\"><div data-ng-repeat=\"payment in histories | orderBy:sortField:sortReverse | slice:pagination.start:pagination.end track by $index\"><div class=\"row list_head\"><div class=\"left_col\"><span translate=\"history_payment_date\"></span></div><div class=\"right_col\"><span>{{payment.tranDateForm }}</span></div></div><div class=\"row list_body\"><div class=\"left_col\"><span translate=\"history_payment_amount\"></span></div><div class=\"right_col\"><span><span class=\"amount-sign-prefix\">{{payment.amountPrefix}}</span>{{abs(payment.amount) | currency}}</span></div></div><div class=\"row list_body\"><div class=\"left_col\"><span translate=\"history_payment_method\"></span></div><div class=\"right_col\"><span>{{payment.paymentCode}}</span></div></div><div class=\"row list_body\"><div class=\"left_col\"><span translate=\"history_payment_details\"></span> <span popover-trigger=\"click\" popover-placement=\"bottom\" popover-popup-delay=\"1\" popover-template=\"\'popoverSnippet\'\" popover-is-open=\"popoverOptions.isOpen[$index]\" ng-click=\"popoverClickHandler($index)\" type=\"button\" class=\"more-info-circle btn btn-default\">i</span></div><div class=\"right_col\"><span>{{payment.paymentStatusDesc}}</span></div></div><div class=\"row list_body\"><div class=\"left_col\"><span translate=\"history_payment_reference\"></span></div><div class=\"right_col\"><span>{{payment.refNum}}</span></div></div></div></div></div><div class=\"pull-right pagination-ctn\"><span class=\"page-previous\" ng-click=\"goToPrev()\" ng-if=\"grandTotalPages > 0 && currentPage != 1\"><i class=\"rui-icon-chevron icon-chevron02\"></i></span> <span class=\"page-numbers\" data-ng-repeat=\"p in pages track by $index\"><span ng-class=\"p === currentPage ? \'current-page\' : \'\'\" ng-click=\"goToPage(p)\" tabindex=\"0\">{{p}}</span></span> <span class=\"page-previous\" ng-click=\"goToNext()\" ng-if=\"grandTotalPages > 1 && currentPage != grandTotalPages\"><i class=\"rui-icon-chevron\"></i></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"{{\'payment_history_loader\' | translate}}\"></span></div></div></div></div></div></div></section><script type=\"text/ng-template\" id=\"popoverSnippet\"><div class=\"close-btn\" ng-click=\"closePopover()\">X</div> <div class=\"popover-content-container\"> <div translate=\"history_payment_status_desc\"></div> </div></script>");
$templateCache.put("scripts/modules/reserveDevice/nrsform.html","<div ng-show=\"false\"><form name=\"formToSalesForce\" id=\"formToSalesForce\" method=\"post\" target=\"sf_iframe\"><input type=\"hidden\" name=\"UserCustomerBANInfo\" id=\"UserCustomerBANInfo\" data-ng-value=\"rd.encryptedString\"> <input type=\"hidden\" name=\"UserCustomerBANInfoSignature\" id=\"UserCustomerBANInfoSignature\" data-ng-value=\"rd.encryptedSignature\"></form><form name=\"formToRogersReserveDevice\" id=\"formToRogersReserveDevice\" method=\"post\" novalidate=\"\"><input type=\"text\" value=\"NRS_MS\" name=\"sourceNRS\"><br></form></div>");
$templateCache.put("scripts/modules/reserveDevice/reservedevice.html","<section class=\"page-reserve-device\"><myr-reserve-device></myr-reserve-device><div class=\"container error-message\" data-ng-show=\"salesForceFailed\"><span translate=\"maintenance_info\"></span></div><div class=\"iframe-rd bb-iframe-container\"><iframe name=\"sf_iframe\" frameborder=\"0\" scrolling=\"no\" style=\"width: 100%; height: 1200px;\"></iframe></div></section>");
$templateCache.put("scripts/modules/rhpDashboard/rhpDashboard.html","<section class=\"page-rhp-dashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 view-page-title\"><div class=\"col-xs-12 mtop-51 retail\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"ute.rogers.rhpDashboard.homePhone\"></span> <span class=\"widget-loader-inline\" data-ng-show=\"rhpDb.loadingDataIndicatorRhpDashboard\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><div class=\"page-rhp\" data-ng-if=\"rhpDb.displayContentRhpDashboard\"><div class=\"container\"><div class=\"row redHeadline\"><h2 class=\"title-h3 rhp-phone-number\"><span>{{rhpDb.rhpInfo.homePhoneNumber | phone3}}</span></h2><div class=\"title-h4\"><span class=\"package-heading\" translate=\"ute.rogers.rhpDashboard.myPackage\"></span>: <span data-ng-if=\"rhpDb.isPlanAvailable(rhpDb.rhpInfo[rhpDb.lng].planName)\" class=\"rhp-package-name\" data-ng-bind-html=\"rhpDb.rhpInfo[rhpDb.lng].planName\"></span> <span data-ng-if=\"!rhpDb.isPlanAvailable(rhpDb.rhpInfo[rhpDb.lng].planName)\" class=\"rhp-package-name\" data-ng-bind-html=\"rhpDb.defaultPlan[rhpDb.lng].planName\"></span></div><div class=\"visible-xs\"><div class=\"rhp-view-features\" data-ng-click=\"rhpDb.isCollapsed = !rhpDb.isCollapsed\"><span class=\"rhp-collapse-btn\" ng-class=\"rhpDb.isCollapsed ? \'rui-icon-chevron-up\' : \'rui-icon-chevron-down\'\"></span> <span translate=\"ute.rogers.rhpDashboard.viewHomePhoneFeatures\"></span></div></div><div class=\"col-xs-12 col-md-4 col-lg-7\" data-ng-show=\"rhpDb.isCollapsed\"><div ng-if=\"rhpDb.callingFeatures && rhpDb.callingFeatures.length > 0\"><div class=\"title-h4 features-header\"><span translate=\"ute.rogers.rhpDashboard.homePhoneFeatures.title\"></span></div><ul class=\"rhp-features-list\"><li data-ng-repeat=\"feature in rhpDb.callingFeatures | orderBy: \'boosterPoint\'\"><span data-ng-bind-html=\"feature.featureName\"></span> <span data-ng-if=\"rhpDb.rhpIsToolTipExists(feature.featureCode) && rhpDb.isConsumer()\"><span class=\"rui-icon-info-v2 rhpTooltip\" ng-click=\"rhpDb.showTooltip = !rhpDb.showTooltip\"></span><div class=\"rhpTooltipText\" ng-show=\"rhpDb.showTooltip\"><span class=\"tooltipClose\" ng-click=\"rhpDb.showTooltip = false\">x</span> <span translate=\"ute.rogers.rhpDashboard.OnlineManager_RHP.tooltip\"></span></div></span></li></ul></div><div class=\"col-xs-12\" ng-if=\"rhpDb.additionalFeatures && rhpDb.additionalFeatures.length > 0\"><div class=\"title-h4 features-header\"><span translate=\"ute.rogers.rhpDashboard.additionalFeatures\"></span></div><ul class=\"rhp-features-list\"><li class=\"\" data-ng-repeat=\"addon in rhpDb.additionalFeatures | orderBy: \'boosterPoint\'\"><span data-ng-bind-html=\"addon.featureName\"></span></li></ul></div></div><div class=\"col-xs-12 col-md-7 col-lg-4\" data-ng-if=\"rhpDb.isConsumer()\"><div><h3><span translate=\"ute.rogers.rhpDashboard.manageYourHomePhone\"></span></h3></div><div class=\"manageDevice\"><ul class=\"CTAmenu\"><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayOnlineManager\"><a data-test-id=\"myr-rhmDashboard-configureYourFeatures\" tabindex=\"0\" target=\"_blank\" aria-label=\"\" data-ng-click=\"rhpDb.configureFeaturesClicked()\"><span data-test-id=\"myr-rhmDashboard-configureYourFeaturesText\" translate=\"ute.rogers.rhpDashboard.configureYourFeatures\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-chevron-right\"></span></a></li><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayVoiceMailSettings\" data-ng-click=\"rhpDb.voiceMailSettingsAnalytics()\"><a ng-if=\"rhpDb.lng === \'en\'\" data-test-id=\"myr-rhmDashboard-voiceMailSettings\" tabindex=\"0\" aria-label=\"\" href=\"https://onlinevoicemail.rogers.com/webvi/loginPageAction.do?lang=en_US&silent=\" target=\"_blank\"><span data-test-id=\"myr-rhmDashboard-voiceMailSettingsText\" translate=\"ute.rogers.rhpDashboard.voiceMailSettings\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-chevron-right\"></span></a> <a ng-if=\"rhpDb.lng === \'fr\'\" data-test-id=\"myr-rhmDashboard-voiceMailSettings\" tabindex=\"0\" aria-label=\"\" href=\"https://onlinevoicemail.rogers.com/webvi/loginPageAction.do?lang=fr_CA&silent=\" target=\"_blank\"><span data-test-id=\"myr-rhmDashboard-voiceMailSettingsText\" translate=\"ute.rogers.rhpDashboard.voiceMailSettings\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-chevron-right\"></span></a></li><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayVoiceMailPassword\"><a data-test-id=\"myr-rhmDashboard-resetVoiceMailPassword\" aria-label=\"\" tabindex=\"0\" data-ng-click=\"rhpDb.resetPasswordOpenModal()\"><span data-test-id=\"myr-rhmDashboard-resetVoiceMailPasswordText\" translate=\"ute.rogers.rhpDashboard.resetVoiceMailPassword\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-chevron-right\"></span></a></li><li><a data-test-id=\"myr-rhmDashboard-contactMangerFeatures\" aria-label=\"\" tabindex=\"0\" data-ng-click=\"rhpDb.manageFeaturesOpenModal()\"><span data-test-id=\"myr-rhmDashboard-contactMangerFeaturesText\" translate=\"ute.rogers.rhpDashboard.contactMangerFeatures\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-chevron-right\"></span></a></li></ul></div></div><div class=\"col-xs-12 col-md-7 col-lg-5\" data-ng-if=\"rhpDb.isCare()\"><div><h3><span translate=\"ute.rogers.rhpDashboard.manageYourHomePhoneRep\"></span></h3></div><div class=\"manageDevice\"><ul class=\"CTAmenu\"><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayOnlineManager\"><div class=\"rhp-repview\" data-test-id=\"myr-rhmDashboard-configureYourFeatures\" target=\"_blank\" aria-label=\"\"><span data-test-id=\"myr-rhmDashboard-configureYourFeaturesText\" translate=\"ute.rogers.rhpDashboard.configureYourFeaturesRep\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.rhpDashboard.selfServeOnly\"></span></div></li><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayVoiceMailSettings\"><div class=\"rhp-repview\" ng-if=\"rhpDb.lng === \'en\'\" data-test-id=\"myr-rhmDashboard-voiceMailSettings\" aria-label=\"\"><span data-test-id=\"myr-rhmDashboard-voiceMailSettingsText\" translate=\"ute.rogers.rhpDashboard.voiceMailSettingsRep\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.rhpDashboard.selfServeOnly\"></span></div><div class=\"rhp-repview\" ng-if=\"rhpDb.lng === \'fr\'\" data-test-id=\"myr-rhmDashboard-voiceMailSettings\" aria-label=\"\"><span data-test-id=\"myr-rhmDashboard-voiceMailSettingsText\" translate=\"ute.rogers.rhpDashboard.voiceMailSettingsRep\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.rhpDashboard.selfServeOnly\"></span></div></li><li data-ng-if=\"rhpDb.rhpInfo && rhpDb.rhpInfo.displayVoiceMailPassword\"><div class=\"rhp-repview\" data-test-id=\"myr-rhmDashboard-resetVoiceMailPassword\" aria-label=\"\"><span data-test-id=\"myr-rhmDashboard-resetVoiceMailPasswordText\" translate=\"ute.rogers.rhpDashboard.resetVoiceMailPasswordRep\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.rhpDashboard.goToNova\"></span></div></li><li><div class=\"rhp-repview\" data-test-id=\"myr-rhmDashboard-contactMangerFeatures\" aria-label=\"\"><span data-test-id=\"myr-rhmDashboard-contactMangerFeaturesText\" translate=\"ute.rogers.rhpDashboard.contactMangerFeaturesRep\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.rhpDashboard.goToSGI\"></span></div></li></ul></div></div></div><div class=\"ng-hide\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"rhpDb.selectedAccount.ban\" name=\"selectedAccountNumber\"><br></form></div></div></div><div class=\"container\" ng-if=\"rhpDb.errorMessage\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"\"><validation-error-box error-message=\"rhpDb.errorMessage\"></validation-error-box></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/rogersForm/formToRogers.html","<div style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"ProfileAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"selectedAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNum\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNumber\"><br><input type=\"text\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form></div>");
$templateCache.put("scripts/modules/signin/signin.html","<h1 class=\"screen-read-only\" translate=\"signin_heading\"></h1><section class=\"page-signin\"><div class=\"container\"><div class=\"body-grey-dark\"><form id=\"signinForm\" name=\"form\" class=\"body-grey-light\" novalidate=\"\" data-ng-show=\"myRogersPermission\" method=\"post\"><div class=\"row message-margin\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" translate=\"_my_rogers_nospace\"></a></li><li class=\"child-1\"><span translate=\"_signin\"></span></li><li class=\"widget-loader sign-in\" data-ng-show=\"loginWaiting\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></li></ul></div><div class=\"row\" data-ng-if=\"isResetPassword()\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row message-banner notification success mtm mbm\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls\" style=\"max-width: 45px;\"><i class=\"fa fa-check-circle fa-2x success-color\"></i></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" style=\"padding: 0 10px 0 5px;\"><div class=\"mbs mts\" translate=\"login_reset_success\"></div></div></div></div></div></div><div class=\"row sign-intro\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><p class=\"overrite-margin\" data-translate=\"ute.rogers.signin.intro\"></p></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 pln prn\"><div class=\"message-banner error\" data-ng-show=\"submitted && (form.USER.$error.required || form.password.$error.required)\"><div class=\"row\"><div class=\"sigin-error-icon-ctn col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding\"><span class=\"fa fa-exclamation-circle fa-2x txtM\"></span></div><div class=\"col-xs-9 col-sm-10 col-md-11 col-lg-11 no-padding\"><span class=\"v-base-line\" data-test-id=\"myr-signin-requireUsernamePassword\" translate=\"_require_username_password\"></span><div class=\"bc-signin\"><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\" error-message=\"errorDescription\" data-ng-if=\"submitted && (form.USER.$error.required || form.password.$error.required)\"></bold-chat-static-button></div></div></div></div></div></div><div class=\"row sign-error-box\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><attempts-error-box></attempts-error-box></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"><div class=\"page-signin-form-wrap\"><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h2 class=\"signin-myrogers\" translate=\"sign_in_to_myrogers\"></h2></div></div><fieldset class=\"bdn pan\"><legend class=\"lgnd-signin screen-read-only\">{{aria_label_plsSignin}}</legend><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"USER\" class=\"screen-read-only\">{{ aria_label_username }}</label> <input class=\"no-inline-checker\" tabindex=\"0\" type=\"text\" id=\"USER\" name=\"USER\" placeholder=\"{{\'_username_email\' | translate}}\" data-ng-model=\"email\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\" data-test-id=\"myr-signIn-emailAddress\"> <span class=\"inline-checker icon-error sign-in\" data-ng-show=\"submitted && form.USER.$error.required\"></span></div></div><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label for=\"password\" class=\"screen-read-only\">{{ aria_label_password }}</label> <input data-tl-private=\"\" class=\"no-inline-checker\" tabindex=\"0\" type=\"password\" id=\"password\" name=\"password\" placeholder=\"{{\'_password_txt\' | translate}}\" data-ng-model=\"password\" required=\"\" data-autocorrect=\"off\" autocomplete=\"off\" data-autocapitalize=\"off\" data-test-id=\"myr-signIn-password\" trim-on-paste=\"\" data-top-trim-start=\"true\" data-top-trim-end=\"true\" data-top-property-to-trim=\"password\"> <span class=\"inline-checker icon-error sign-in\" data-ng-show=\"submitted && form.password.$error.required\"></span></div></div><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"myr-remember-me row\"><span data-test-id=\"myr-singin-rememberMe\" class=\"myr-checkbox col-xs-1\"><input data-ng-model=\"rememberMe\" type=\"checkbox\" name=\"rememberMe\" id=\"rememberMe\" class=\"myr-checkbox-input myr-signin-checkbox-input\" tabindex=\"0\"> <label for=\"rememberMe\" class=\"myr-checkbox-box\" tabindex=\"-1\"><span class=\"signin-screen-read-only\">{{aria_label_rememberMe}}</span></label></span> <span class=\"myr-checkbox-text desc-font-size-16 col-xs-11\" translate=\"_remember_me\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><div class=\"btn-parent btn-std btn-signin\"><button class=\"cta-round primary medium full overrite\" data-ng-click=\"submit()\" data-ng-class=\"isWaitingClass\" data-test-id=\"myr-signIn-buttonSignIn\" tabindex=\"0\"><span class=\"overrite-span\" translate=\"_signin\"></span></button></div><input type=\"hidden\" name=\"TARGET\" id=\"target\" value=\"\"> <input type=\"hidden\" name=\"SMAUTHREASON\" value=\"0\"></div></div></fieldset><div class=\"row overrite-margin\"><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"><div class=\"forgot-txt-ctn body-grey-light\"><span translate=\"_forgot\"></span> <a data-ui-sref=\"forgotUserName\" data-test-id=\"myr-signIn-forgotUserName\"><span class=\"lowercase pointer\" translate=\"_username_no_col\"></span></a> <span translate=\"_or\"></span><ute-if-not-brt key=\"JANRAIN_REGISTRATION\"><a data-ui-sref=\"forgotPassword\" data-test-id=\"myr-signIn-forgotPassword\"><span class=\"lowercase pointer\" translate=\"_password_txt\"></span></a></ute-if-not-brt><ute-if-brt key=\"JANRAIN_REGISTRATION\"><a data-ui-sref=\"sso/forgotPassword\" data-test-id=\"myr-signIn-forgotPassword\"><span class=\"lowercase pointer\" translate=\"_password_txt\"></span></a></ute-if-brt>?</div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-5\"><div class=\"page-signin-box-wrap\"><registration-area></registration-area></div></div></div></form></div></div></section><div class=\"ng-hide\" id=\"form-view-bill\" data-ng-show=\"false\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\">Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"ProfileAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"selectedAccountNumber\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNum\"><br>Account: <input data-tl-private=\"\" type=\"text\" data-ng-model=\"ab.mss.selectedAccountDetail.billableAccountNumber\" name=\"accountNumber\"><br>briteBillInvoiceDates: <input type=\"text\" data-ng-show=\"ab.getBriteBillInvoiceDates()\" data-ng-value=\"ab.getBriteBillInvoiceDates()\" name=\"briteBillInvoiceDates\"></form></div>");
$templateCache.put("scripts/modules/smartHomeMonitoring/shmDashboard.html","<section class=\"page-wireless page-home-monitoring\"><div ng-cloak=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span data-test-id=\"myr-shmDashboard-SHMPage\" translate=\"shm_title\"></span> <span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div><div class=\"container\" ng-if=\"!isDealer && !isCare\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-content-injector language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/decommission-message/shm_decommission_message/shm_decommission_message\"></ute-content-injector></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div></div></div></div>`<div class=\"container rshm\"><div class=\"row mbl\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"mtl mlm\"><img data-test-i=\"myr-shmDashboard-shmImage\" ng-src=\"/cms/rogers/page-specific/bundles/images/shm_{{lng}}.png\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 did-you-know-ctn-desktop\"><div class=\"rsmh_did-you-know-ctn\"><span class=\"did-you-know-title\" translate=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" translate=\"shm_promo\"></span><div ng-show=\"isDealer || isCare\" class=\"learn-link-text-container\"><span translate=\"learn_more\"></span></div></div></div><div class=\"rshm_manage-device col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"manageDevice semi-bold\"><ul class=\"CTAmenu\"><li><a data-test-id=\"myr-shmDashboard-insurCert\" aria-label=\"{{\'shm_insur_cert_alt\' | translate}}\" href=\"javascript:void(0);\" ng-click=\"printCertificate()\" ng-if=\"!isDealer && !isCare\"><span aria-hidden=\"true\" data-test-id=\"myr-shmDashboard-insurCertText\" translate=\"shm_insur_cert\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a data-test-id=\"myr-shmDashboard-municipalInfo\" aria-label=\"{{\'shm_get_started_alt\' | translate}}\" href=\"https://www.rogers.com/customer/support/article/home-monitoring-first-steps\" target=\"_blank\"><span aria-hidden=\"true\" data-test-id=\"myr-shmDashboard-municipalInfoText\" translate=\"shm_get_started\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"last\"><a data-test-id=\"myr-shmDashboard-serviceAgree\" aria-label=\"{{\'shm_learn_more_alt\' | translate}}\" href=\"https://www.rogers.com/consumer/support/homemonitoring\" target=\"_blank\"><span aria-hidden=\"true\" data-test-id=\"myr-shmDashboard-serviceAgreeText\" translate=\"shm_learn_more\"></span> <span role=\"presentation\" class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 did-you-know-ctn-mobile\"><div class=\"rsmh_did-you-know-ctn\"><span class=\"did-you-know-title\" translate=\"shm_promo_title\"></span> <span class=\"did-you-know-promo-txt\" translate=\"shm_promo\"></span><div ng-show=\"isDealer || isCare\" style=\"font-size: 18px;font-weight: 600;padding-left: 13px;\"><span translate=\"learn_more\"></span></div></div></div></div><div class=\"container-fluid mtl\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><hr class=\"divider\"></div></div></div><div class=\"row ptm\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-5 my-offers-ctn-sm\" data-ng-hide=\"appState.isMobile\"><my-offers></my-offers></div></div></div></div></section><div ng-include=\"formToRogersTemplate\"></div>");
$templateCache.put("scripts/modules/subMenu/subMenu.html","<div class=\"redTop navigation directive-sub-menu\" data-ng-hide=\"selfDestructFlag\"><div class=\"center-wrapper\"><div class=\"container sub-menu-ctn\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><nav id=\"navbar-example\" class=\"navbar navbar-default navbar-static\" ng-class=\"{\'navbar-default-rep\':(isDealer||isCare)}\"><div class=\"container-fluid\"><div class=\"navbar-header\"><div class=\"subMenuHeader\" data-test-id=\"myr-subMenu-myRogers\" translate=\"_my_rogers_nospace\"></div><div class=\"subMenuRedDot\"><img src=\"images/Red-Dot.png\"></div><div class=\"navbar-control\" ng-click=\"navMainMenuClick($event)\"><span class=\"navbar-close\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\" translate=\"more\"></span> <span class=\"navbar-close\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\" translate=\"close\"></span> <span class=\"navbar-icon plus active\" ng-class=\"!toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-plus\">+</span></span> <span class=\"navbar-icon minus\" ng-class=\"toggleMainPlusMinus ? \'active\' : \'\'\"><span class=\"navbar-minus\">-</span></span></div></div><div class=\"collapse navbar-collapse bs-example-js-navbar-collapse\" ng-class=\"toggleMainPlusMinus ? \'in\' : \'\'\"><ul class=\"nav navbar-nav\"><li ng-class=\"selSubMenuItem === subMenuItems.overview ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" ng-if=\"isConsumer\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\" data-ng-click=\"accountOverview($event)\"><span class=\"subMenu-item\" data-test-id=\"myr-subMenu-accOverviewConsumer\" translate=\"submenu_acc_overview\" ng-class=\"selSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <a class=\"pointer\" ng-if=\"(isDealer || isCare) && !isConsumer\" ng-click=\"oneViewAccountOverview($event)\" role=\"button\" data-ng-class=\"isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\'\"><span class=\"subMenu-item\" data-test-id=\"myr-subMenu-accOverview\" translate=\"submenu_acc_overview\" ng-class=\"selectedSubMenuItem === subMenuItems.overview ? \'selected\' : \'\'\"></span></a> <span class=\"left-bar\"></span></li><li ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'mobile-selected\' : \'\'\"><a class=\"pointer\" data-ng-class=\"(!repPaymentStart ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\')\" ng-click=\"repPaymentStart && viewbill($event)\" role=\"button\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.billingAndPayment ? \'selected\' : \'\'\" translate=\"submenu_billing_and_payment\"></span></a> <span class=\"left-bar\"></span></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\"><a class=\"pointer services-menu\" id=\"drop1\" data-ng-class=\"isSubMenuEnabled(\'services\') ? \'\' : \'disabled\'\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\"><span class=\"caret services-right\"></span> <span class=\"subMenu-item services-left\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\" data-test-id=\"myr-subMenu-services\" translate=\"submenu_services\"></span> <span class=\"navbar-icon myr-toggle-plus\"></span></a> <span class=\"left-bar\"></span><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"drop1\" data-ng-show=\"isDropDownEnabled()\"><li ng-if=\"(getSubMenuServicesShareItem.length) && !(getSubMenuServicesShareItem[0].subscriptionBadgeModule)\" data-ng-hide=\"hideDropDown()\"><a ng-hide=\"getSubMenuServicesShareItem[0].hide\" data-test-id=\"myr-subMenu-serviceListItem{{$index}}\" class=\"pointer services-dropdown\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{getSubMenuServicesShareItem[0].serviceName}}\', \'{{getSubMenuServicesShareItem[0].serviceDetail}}\') : \'\'\"><span class=\"service-account-type\" translate=\"share_everything_share\"></span></a></li><li data-ng-repeat=\"msl in subMenuMyServicesList | filter : notInDataManager track by $index\" data-ng-hide=\"hideDropDown()\"><a ng-if=\"!msl.subscriptionBadgeModule && !(isCare && msl.serviceName === \'shmdashboard\')\" ng-hide=\"msl.hide\" data-test-id=\"myr-subMenu-serviceListItem{{$index}}\" class=\"pointer services-dropdown\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\') : \'\'\"><span class=\"service-account-type\" ng-hide=\"(isDealer || isCare) || msl.subType !== \'CTN\'\">{{msl.firstName | limitTo : 9}}<span ng-if=\"msl.firstName.length > 10\">...</span></span> <span class=\"service-account-type\" translate=\"{{msl.serviceType}}\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\' || msl.serviceName === \'suspended\') || (msl.isCTN === true && msl.serviceType !== \'service_wireless_prepaid\' && msl.serviceType !== \'service_wireless\')\"></span><span>&nbsp;&nbsp;</span> <span class=\"service-account-number\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\')\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'homephone\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | ute_common_filter_phone2) : \'\'}}</span></a> <a ng-if=\"msl.subscriptionBadgeModule\" ng-click=\"resolveService(msl)\"><span class=\"service-account-type\" translate=\"{{msl.serviceType}}\"></span></a></li></ul></li><li ng-class=\"selSubMenuItem === subMenuItems.profile ? \'mobile-selected\' : \'\'\"><a ng-click=\"repProfileRead && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" data-test-id=\"myr-subMenu-profile\" role=\"button\" class=\"pointer\" data-ng-class=\"(!repProfileRead ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\')\"><span class=\"subMenu-item\" ng-class=\"selSubMenuItem === subMenuItems.profile ? \'selected\' : \'\'\" translate=\"submenu_profile\"></span></a><span class=\"left-bar\"></span></li><li ng-show=\"showCareLink\"><a ng-click=\"runCustomerCare();\" role=\"button\" class=\"pointer\"><span translate=\"_customer_care\" data-test-id=\"myr-subMenu-module\"></span></a></li></ul></div><div class=\"cart-menu-container\" ng-class=\"lang==\'fr\'?\'cart-menu-fr-container\':\'cart-menu-en-container\'\" ng-if=\"isConsumer\"><cart-menu></cart-menu></div></div></nav></div></div></div></div></div>");
$templateCache.put("scripts/modules/tvDashboard/tvdashboard.html","<section class=\"page-tvdashboard\"><div ng-cloak=\"\"><div class=\"col-xs-12 view-page-title\"><div class=\"col-xs-12 mtop-51\" data-ng-class=\"tvDb.isRepView() && tvDb.isDealer() ? \'mtop-20mbm\': \'retail\'\"><div class=\"container\"><div data-ng-class=\"{\'rui-heading\': !tvDb.isRepView() || tvDb.isCare()}\"><h1><span translate=\"_tv\"></span> <span class=\"widget-loader-inline\" data-ng-show=\"loadingDataIndicator || loadingBriteBill\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><div class=\"container page-wireless tv-package-ctn\"><div class=\"container\"><div class=\"row redHeadline\" data-ng-if=\"!tvDb.isCareRepView() && tvDb.province===\'ON\'\"><div class=\"col-xs-12 col-md-8 col-lg-6\"><div class=\"widget-loader\" data-ng-show=\"tvDb.loadingDataIndicatorTvFeed\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" data-ng-if=\"!tvDb.isCareRepView()\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessageTvFeed\"></validation-error-box></div></div></div></div></div><div class=\"container\"><div class=\"container page-tvdashboard tv-package-spacing\" data-ng-class=\"tvDb.province !==\'ON\' ? \'my-tv-package-margin-top-zero\':\'\'\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-md-8 col-lg-6\"><h2 data-ng-if=\"tvDb.isCareRepView()\" class=\"widget-loader-mod\" translate=\"tv_package\" data-test-id=\"myr-tvDashboard-myrTVPackageHeader\" data-ng-class=\"tvDb.province !==\'ON\' ? \'my-tv-package-margin-top-zero\':\'\'\"></h2><h2 data-ng-if=\"!tvDb.isCareRepView()\" class=\"widget-loader-mod\" translate=\"tv_my_package\" data-test-id=\"myr-tvDashboard-myrTVPackageHeader\" data-ng-class=\"tvDb.province !==\'ON\' ? \'my-tv-package-margin-top-zero\':\'\'\"></h2><div class=\"widget-loader tv\" data-ng-show=\"tvDb.loadingDataIndicatorTvDashboard && !tvDb.finalDataReceived\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"tvDb.errorMessage\"></validation-error-box></div></div></div></div><div data-ng-if=\"tvDb.displayContentTvDashboard\" class=\"row\"><div class=\"col-xs-12 col-md-6 col-lg-3 semi-bold mbl\"><div class=\"widget-loader tv\" data-ng-show=\"tvDb.loadingDataIndicatorTvDashboard && !tvDb.finalDataReceived\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div class=\"title-h5 semi-bold mbs my-package-name\">{{tvDb.tvObj.myPlan.packageDescription}}</div></div><div class=\"col-xs-12 col-sm-8 col-md-9\" data-ng-class=\"tvDb.isRepViewInOneview()? \'col-lg-5\': \'col-lg-6\'\"><div data-ng-if=\"tvDb.hasExtras || tvDb.hasThemes\"><div data-ng-if=\"tvDb.isCareRepView()\" class=\"title-h5 semi-bold\" data-test-id=\"myr-tvDashboard-myExtras\" translate=\"internet_extras\"></div><div data-ng-if=\"!tvDb.isCareRepView()\" class=\"title-h5 semi-bold\" data-test-id=\"myr-tvDashboard-myExtras\" translate=\"internet_my_extras\"></div><div class=\"mts myextras-line pbs\"></div><div class=\"my-line-plan-ctn\"><div class=\"container-fluid\"><div class=\"headline6 myextras-line pbs pts\" ng-repeat=\"addon in tvDb.tvObj.myExtras track by $index\"><div class=\"row\"><div class=\"col-xs-7 col-md-8\"><span><strong>{{addon}}</strong></span></div></div></div><div class=\"headline6 myextras-line pbs pts\" data-ng-if=\"tvDb.hasExtras\"><div class=\"row\"><div class=\"col-xs-7 col-md-8\"><span translate=\"tv_channels_extra\"></span></div></div><div class=\"row\"><div class=\"sample-show-hide\" ng-init=\"addOnLimit=5\"><div class=\"medium-font-size mls\" ng-repeat=\"addon in tvDb.tvObj.extraChannelList | limitTo:addOnLimit track by $index\"><span>{{addon}}</span></div><span class=\"show-more\" ng-click=\"addOnLimit=addOnLimit==5?1000:5\" translate=\"more\" data-ng-show=\"tvDb.tvObj.extraChannelList.length > 5 && addOnLimit < 500\"></span> <span class=\"show-more-chevron rui-icon-chevron-down\" ng-click=\"addOnLimit=addOnLimit==5?1000:5\" data-ng-show=\"tvDb.tvObj.extraChannelList.length > 5 && addOnLimit < 500\">&nbsp;</span></div></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-3 col-lg-3\" data-ng-if=\"!tvDb.isRepViewInOneview()\"><div><div class=\"plan-cta-ctn\" data-ng-if=\"tvDb.showCallBanner === \'false\'\"><div class=\"plan-cta\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\" atm=\"myrogers:tvdashboard:changemypackage\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.postToRogers(1)\"><span class=\"plan-cta-text\" data-test-id=\"myr-tvDashboard-changeMyTvPackage\" translate=\"tv_package_change\"></span></div><div class=\"plan-cta\" data-ng-if=\"tvDb.tvObj.withBonus === false\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.onOmnitureClickTv([\'_trackPageView\',{eVar13:\'MyRogers tv change bonus channel\'},{event5:\'\'}]);tvDb.postToRogers(8);\"><span class=\"plan-cta-text\" data-test-id=\"myr-tvDashboard-addChannels\" translate=\"tv_change_bonus_channel\"></span></div><div class=\"plan-cta\" data-ng-if=\"tvDb.tvObj.oldTvPackage === false\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\" atm=\"myrogers:tvdashboard:addthemepacks\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.postToRogers(0)\"><span class=\"plan-cta-text\" data-test-id=\"myr-tvDashboard-addThemePacks\" translate=\"tv_add_themes\"></span></div><div class=\"plan-cta\" data-ng-if=\"tvDb.tvObj.oldTvPackage === false\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\" atm=\"myrogers:tvdashboard:addchannels\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.onOmnitureClickTv([\'_trackPageView\',{eVar13:\'MyRogers tv add more channels\'},{event5:\'\'}]);tvDb.postToRogers(0);\"><span class=\"plan-cta-text\" data-test-id=\"myr-tvDashboard-addChannels\" translate=\"tv_add_channels\"></span></div></div><div class=\"plan-cta-chat plan-cta-chat-box\" data-ng-if=\"tvDb.tvObj.oldTvPackage || tvDb.showCallBanner === \'true\'\"><div class=\"plan-cta-chat-block\"><div translate=\"tv_add_channels_message_01\"></div><div translate=\"tv_add_channels_message_02\"></div><div class=\"ute-reactivateCtn-message-box-support\"><div class=\"ute-reactivateCtn-support-phone-box\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"> <span class=\"ute-reactivateCtn-support-phone\" translate=\"tv_add_channels_supportPhoneNumber\"></span></div><bold-chat-static-button style=\"margin-top:20px;\" data-cbid=\"{{\'boldchat_cbid_existing_customers\' | translate}}\" data-dynamic-div=\"chat\" data-chat-button=\"live-chat-text-content\"></bold-chat-static-button></div></div></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-5 col-lg-4\" data-ng-if=\"tvDb.isRepViewInOneview()\"><div class=\"\" data-ng-class=\"tvDb.isCareRepView() ? \'plm\': \'plan-cta-ctn no-padding\'\"><div class=\"ov-hint myextras-line\" data-ng-class=\"{\'ptxs\':tvDb.isCareRepView()}\"><span translate=\"ute.rogers.tvDashboard.toChangePackage\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div><div class=\"ov-hint myextras-line\"><span translate=\"ute.rogers.tvDashboard.toAddThemePacks\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toAddChannels\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div></div></div></div></div><div class=\"container my-digital-box\"><div class=\"row redHeadline\"><div class=\"col-xs-12 redHeadline\"><h2 data-ng-if=\"tvDb.isCareRepView()\" class=\"widget-loader-mod\" translate=\"tv_box\" data-test-id=\"myr-tvDashboard-myDigitalBoxesHeader\"></h2><h2 data-ng-if=\"!tvDb.isCareRepView()\" class=\"widget-loader-mod\" translate=\"tv_my_box\" data-test-id=\"myr-tvDashboard-myDigitalBoxesHeader\"></h2><div class=\"widget-loader tv\" data-ng-show=\"tvDb.loadingDataIndicatorTvDashboard && !tvDb.finalDataReceived\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"container\" data-ng-if=\"tvDb.errorMessage\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"tvDb.errorMessage\"></validation-error-box></div></div></div></div><div data-ng-if=\"tvDb.displayContentTvDashboard\" class=\"row mbl\"><div class=\"col-xs-12 col-md-6 col-lg-4 mtl prs\"><div class=\"styled-select\" data-ng-if=\"tvDb.showHardwareDD\"><select name=\"hardware\" data-ng-model=\"tvDb.tvObj.selectedHardwareId\" style=\"width:320px;\" ng-change=\"tvDb.changeDeviceImage()\" ng-options=\"value for value in tvDb.tvObj.hardwareList\"></select></div><div class=\"headline6 semi-bold mbm\" data-ng-if=\"!tvDb.showHardwareDD\" data-test-id=\"myr-tvDashboard-digitalBoxName\">{{tvDb.tvObj.selectedHardwareName}}</div><div class=\"mtl\"><img ng-src=\"{{tvDb.tvObj.myModem.image}}\" class=\"default-image\" data-test-id=\"myr-tvDashboard-digitalBoxImage\"></div></div><div class=\"col-xs-12 col-md-6 col-lg-4\" data-ng-if=\"tvDb.isRepViewInOneview() && !tvDb.isCareRepView()\"><div class=\"ov-hint myextras-line\"><span translate=\"ute.rogers.tvDashboard.toAddDigitalBox\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toResetDigitalBox\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToTSP\"></span></div></div><div data-ng-if=\"tvDb.tvObj.rtoIndicator == true\" class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4\"><div class=\"did-you-know-ctn\" style=\"margin-left:0px;\"><span class=\"did-you-know-title\" translate=\"rto_Title\"></span> <span class=\"did-you-know-promo-txt\" translate=\"rto_Message\"></span></div></div><div class=\"tv-services col-xs-12 col-sm-12 col-md-9 col-lg-4 mts\" data-ng-if=\"!tvDb.isRepViewInOneview()\"><div class=\"TVmanageDevice semi-bold\"><div class=\"CTAmenu\"><div class=\"CTAmenuRow pointer\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\"><div class=\"linkBlock\" data-test-id=\"myr-tvDashboard-resetDigBoxPage\" atm=\"myrogers:tvdashboard:resetdigitalbox\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.onOmnitureClickTv([\'_trackPageView\',{eVar13:\'MyRogers tv reset digital box\'},{event5:\'\'}]);tvDb.postToRogersBottom(3);\"><div class=\"linkBlockText\" data-test-id=\"myr-tvDashboard-resetDigBox\" translate=\"tv_reset_digital_box\"></div><div class=\"linkBlockArrow rui-cta-link\"></div></div></div><div class=\"CTAmenuRow pointer last\" data-ng-class=\"{\'no-pointer\':tvDb.isOneview}\"><div class=\"linkBlock\" data-test-id=\"myr-tvDashboard-resetPinPage\" atm=\"myrogers:tvdashboard:resetdigitalpin\" ng-click=\"tvDb.isOneview ? \'\' : tvDb.onOmnitureClickTv([\'_trackPageView\',{eVar13:\'MyRogers tv reset digital pin\'},{event5:\'\'}]);tvDb.postToRogersBottom(4);\"><div class=\"linkBlockText\" data-test-id=\"myr-tvDashboard-resetPin\" translate=\"tv_reset_pin\"></div><div class=\"linkBlockArrow rui-cta-link\"></div></div></div></div></div></div><div class=\"col-xs-12\" data-ng-if=\"!tvDb.isCareRepView()\"><div class=\"col-xs-12 col-sm-12 col-md-9 col-lg-7\"><div class=\"tv-hardware-findStore-container\"><div class=\"tv-hardware-findStore-heading\" translate=\"tv_add_box\"></div><i class=\"tv-hardware-findStore-icon rui-icon-locator\"></i> <a href=\"/web/content/store-locator?tv=repair-device\" class=\"tv-hardware-findStore-link\" translate=\"tv_find_store\"></a></div></div></div><div class=\"col-xs-12 tv-services tv-services-ov\" data-ng-if=\"tvDb.isRepViewInOneview()\"><div class=\"col-md-4\"><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toAddDigitalBox\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toResetDigitalBox\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToTSP\"></span></div></div><div class=\"col-md-4\"><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toResetDigitalPin\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToTSP\"></span></div><div class=\"ov-hint\"><span translate=\"ute.rogers.tvDashboard.toAddOutlets\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.tvDashboard.goToSGI\"></span></div></div><div class=\"col-md-4\" data-ng-if=\"!tvDb.isCareRepView()\"><a class=\"pbs pts\" data-test-id=\"myr-tvDashboard-rogersTvOnDemandHomepage\" ng-href=\"http://www.rogers.com/web/Rogers.portal?_nfpb=true&_pageLabel=onDemandOverview&setLanguage={{tvDb.lng}}\" target=\"_blank\"><div class=\"rogers-on-demand\"><span translate=\"tv_browse\"></span> <span class=\"rui-cta-link\"></span></div></a></div></div></div></div></div><div class=\"row ptm\"></div><div style=\"display: none !important;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"tvDb.selectedAccount.accountNumber\" name=\"selectedAccountNumber\"><br><input type=\"text\" data-ng-model=\"tvDb.selectedFlow\" name=\"flowType\"><br><input type=\"text\" data-ng-model=\"tvDb.tvObj.myPlan.packageName\" name=\"pkgName\"><br><button ng-click=\"tvDb.postToRogers(0)\">Add/Change themes</button> <button ng-click=\"tvDb.postToRogers(1)\">change package</button></form><form name=\"formToRogersBottom\" id=\"formToRogersBottom\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"tvDb.selectedAccount.accountNumber\" name=\"acctNum\"><br></form></div></div></div></section><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"tvDb.liveChatSettings.floatingTvDashboard.cbid\" data-bold-chat-div=\"tvDb.liveChatSettings.floatingTvDashboard.boldChatDiv\" data-chat-button=\"tvDb.liveChatSettings.floatingTvDashboard.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("scripts/modules/underMaintenance/underMaintenance.html","<section class=\"page-maintenance\" data-ng-controller=\"MyrUnderMaintenanceController\"><div class=\"top-bar-ctn\"><div class=\"pbm container\"><div><div class=\"row\" data-ng-show=\"maintenanceInfo\"><div class=\"col-xs-12\"><div class=\"page-top-block\"><div class=\"bg-block-left\"><div class=\"bg-block-inner\" ng-bind-html=\"maintenanceHeader\"></div></div><div class=\"bg-block-red hidden-xs\"></div></div><div class=\"page-bottom-block\"><div class=\"bg-block-grey-outline hidden-xs\"></div><div class=\"bg-block-grey\"><div class=\"bg-block-inner\" ng-bind-html=\"maintenanceInfo\"></div></div></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/winOnline/pastInvoice.html","<div id=\"iframe_wrapper\"><div id=\"iframe_container\" class=\"container\"><iframe ng-src=\"{{iframeurl}}\" width=\"100%\" height=\"600px\" frameborder=\"0\"></iframe></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboard.html","<section class=\"page-wireless\"><div><div class=\"wireless-usage\" ng-if=\"::!wdController.isShareEverything\"><div class=\"container\" ng-if=\"wdController.showInfinitePlanAlert()\"><rogers-alert alert-data=\"wdController.alertData\"></rogers-alert></div><div class=\"col-xs-12 view-page-title\"><div class=\"col-xs-12 mtop-51\" ng-class=\"::{\'retail\': !isRepView, \'mtop-20\': isRepView, \'mbm\': isRepView}\"><div class=\"container\"><div ng-class=\"::{\'rui-heading\': !isRepView}\"><h1><span translate=\"wireless\" data-test-id=\"myr-wirelessDashboard-wireless_headline\"></span> <span class=\"widget-loader-inline\" ng-if=\"wdController.loadingDataIndicator || loadingBriteBill\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></h1></div></div></div></div><div class=\"container\"><div class=\"row\" ng-if=\"wdController.wirelessDashData.length > 1\"><div class=\"row col-xs-12 col-sm-8\"><div class=\"h3 col-xs-12 col-sm-6 col-md-4\" translate=\"wireless_number\" data-test-id=\"myr-wirelessDashboard-wireless_number\"></div><div class=\"styled-select wireless-account-select col-xs-12 col-sm-6 col-md-7\"><select name=\"accountType\" required=\"\" data-ng-model=\"wdController.ctn\" data-ng-change=\"wdController.changeComboCTN(wdController.ctn)\" data-test-id=\"myr-wirelessDashboard-select_accountType\" tabindex=\"-1\"><option data-ng-repeat=\"wirelessLine in wdController.wirelessDashData\" data-ng-value=\"wirelessLine.ctn\" data-ng-selected=\"wirelessLine.ctn.toString() === (wdController.ctn).toString()\">{{::wirelessLine.firstname + \' - \' + wirelessLine.ctn}}</option></select></div></div></div></div><div class=\"container fraudMessage\" ng-if=\"wdController.isFraudSocAvailable\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"pam\"><validation-error-box error-message=\"wdController.fraudSocErrorMessage\"></validation-error-box></div></div></div></div><div ng-if=\"wdController.showReactivateCtn(wdController.modelForReactivateCtn) && (!wdController.isDealer && !wdController.isCare)\"><ute-reactivate-ctn-message-box data-input-model=\"wdController.modelForReactivateCtn\"></ute-reactivate-ctn-message-box></div><div ng-if=\"wdController.showReactivateCtn(wdController.modelForReactivateCtn) && (wdController.isDealer || wdController.isCare)\"><ute-repview-reactivate-ctn-message-box data-input-model=\"wdController.modelForReactivateCtn\"></ute-repview-reactivate-ctn-message-box></div><div class=\"container\" ng-if=\"!wdController.isFraudSocAvailable && !wdController.isShareEverything\"><div class=\"row redHeadline\"><div class=\"col-xs-12 col-md-8 col-lg-6\"><h2 class=\"widget-loader-mod\" translate=\"wireless_my-wireless-usage\" data-test-id=\"myr-wirelessDashboard-wireless_my-wireless-usage\"></h2><div class=\"widget-loader\" ng-if=\"wdController.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-xs-12 col-md-4 col-lg-6\" data-ng-if=\"wdController.displayContent\"><div class=\"dtm-days-remaining-bill-cycle\"><span class=\"wireless-next-billing-days\" data-ng-bind-html=\"wdController.getNextBillDaysUntil()\" data-test-id=\"myr-wirelessDashboard-wireless_new-usage-cycle\"></span> <span class=\"wireless-next-billing-start-date\" data-ng-bind-html=\"wdController.getNextStartMonth()\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><validation-error-box error-message=\"wdController.errorMessage\" live-chat-params=\"wdController.wirelessUsageLiveChatParams\"></validation-error-box></div></div><div class=\"row\" ng-if=\"wdController.loadingDataIndicator\"><div class=\"col-xs-offset-3 col-xs-6 largeload\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"row\" cloaker=\"\" ng-if=\"wdController.showDials()\" ng-include=\"wdController.dial_template\"></div><div class=\"row refresh-row-padding\" ng-if=\"(wdController.disableAllUsageSwitch || wdController.displayDataUsageSwitch) && !wdController.usageRefreshed\"><div class=\"refresh-dashboard\" ng-click=\"wdController.refreshUsage()\"><span translate=\"wireless_dashboard_usage\"></span> <span class=\"refresh-usage\"><img class=\"refresh-icon\" src=\"/web/totes/cms/images/ic_refresh.svg\"> <a type=\"button\" class=\"refresh-text\" translate=\"wireless_dashboard_refresh\"></a> <span class=\"refresh-icon rui-icon-arrow-right\"></span></span></div></div><div class=\"row\" ng-if=\"!wdController.showInfinitePlanAlert() && (wdController.wdEmpty || wdController.wdMidCycle || wdController.wdMCPPCrerating)\"><div class=\"col-xs-12\"><div class=\"text-center\" ng-if=\"((wdController.disableAllUsageSwitch || wdController.displayDataUsageSwitch) && !wdController.loadingDataIndicator && wdController.wdEmpty && wdController.usageRefreshed) || ((!wdController.disableAllUsageSwitch && !wdController.displayDataUsageSwitch) && wdController.wdEmpty)\" data-test-id=\"myr-wirelessDashboard-missingUsageText\"><h3 translate=\"wireless_missing_usage\"></h3></div><div class=\"text-center wireless-midcycle-message\" ng-if=\"wdController.wdMidCycle\" data-test-id=\"myr-wirelessDashboard-midCycleErrorMessage\"><h3 translate=\"wireless_midcycle_message\"></h3></div><div class=\"text-center wireless-midcycle-message\" ng-if=\"wdController.wdMCPPCrerating\" data-test-id=\"myr-wirelessDashboard-reratingErrorMessage\"><h3 translate=\"wireless_rerating_message\"></h3></div></div></div></div></div><div ng-if=\"!wdController.isFraudSocAvailable && wdController.ban && wdController.isDealer\"><wireless-package ban=\"wdController.ban\" ctn=\"wdController.ctn\" wireless-dash-active=\"wdController.wirelessDashActive\" fraud-soc-error-message=\"wdController.fraudSocErrorMessage\" is-fraud-soc-available=\"wdController.isFraudSocAvailable\" show-reactivate-ctn=\"wdController.showReactivateCtn\" flags=\"wdController.flags\" model-for-reactivate-ctn=\"wdController.modelForReactivateCtn\" error-message=\"wdController.errorMessage\"></wireless-package></div><div data-ng-include=\"\'scripts/modules/wirelessDashboard/partials/wirelessDashboardNew.html\'\" ng-if=\"!wdController.isFraudSocAvailable && wdController.ban && !wdController.isDealer\"></div><div ng-if=\"::wdController.isShareEverything && wdController.isDealer\" class=\"container SEUsageDetailsContainer\"><div class=\"usageDetails\"><accordion class=\"usageDetails-accordion\"><div class=\"usageDetails-accordionBorder\"><div accordion-group=\"\" is-open=\"wdController.isOpenDetails\" ng-click=\"wdController.toggleAccordian()\" tabindex=\"-1\"><accordion-heading><span class=\"SEUsageDetailsHeading hidden-xs\">{{wdController.displayName()}}</span> <span class=\"SEUsageDetailsHeading\" translate=\"wireless_usage_usage-details\"></span> <i class=\"rui-icon-arrow-down usageDetails-accordionHeadingIcon usageDetails-accordionHeadingIconDesktop\"></i></accordion-heading><div class=\"SEUsageDetailsBillingContainer\"><span class=\"SEUsageDetailsBillingHeading\" translate=\"_billing_cycle\"><span class=\"ute-icon-arrow-down\"></span></span> <span class=\"SEUsageDetailsBillingCycle\">{{::\'ute.dataManager.months.\' + wdController.getStartMonth() | translate}} {{wdController.getStartDay()}} - {{::\'ute.dataManager.months.\' + wdController.getEndMonth() | translate}} {{wdController.getEndDay()}}</span></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6\"><div class=\"SEUsageDetailsTalkUsage\" translate=\"wireless_usage_talk-usage\"></div><div class=\"SEUsageDetailsTalkUsageBody\"><div data-ng-include=\"::wdController.pathToTalkSectionUrl\"></div></div></div><div class=\"col-xs-12 col-sm-6\"><div class=\"SEUsageDetailsTextUsage\" translate=\"wireless_usage_text-usage\"></div><div class=\"SEUsageDetailsTextUsageBody\"><div data-ng-include=\"::wdController.pathToTextSectionUrl\"></div><div data-ng-include=\"::wdController.pathToSMSSectionUrl\"></div></div></div></div></div></div></accordion></div></div></div></section><div ng-include=\"::wdController.formToRogersTemplate\"></div><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"wdController.liveChatSettings.floatingWirelessLanding.cbid\" data-bold-chat-div=\"wdController.liveChatSettings.floatingWirelessLanding.boldChatDiv\" data-chat-button=\"wdController.liveChatSettings.floatingWirelessLanding.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboardDataSection.html","<section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wddsum in wdController.wd.dataArr\"><div class=\"col-xs-12\"><h4 class=\"type-title\" ng-if=\"::wddsum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-if=\"::wddsum.usageType !== \'extras_summary\'\">&nbsp;</h4></div><div class=\"col-xs-12\" ng-if=\"::wddsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wddsumSet in ::wddsum.usageSets\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{::wddsumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"::((wddsumSet.used - wddsumSet.total) / 1024) >= 1024\">{{((wddsumSet.used - wddsumSet.total) / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::((wddsumSet.used - wddsumSet.total) / 1024) < 1024\">{{((wddsumSet.used - wddsumSet.total) / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div></div></div><div class=\"col-xs-12 margin-top-10\" ng-if=\"::wddsum.usageType !== \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row overage-text\" ng-if=\"(wddsum.remaining >= 0 && wddsum.overage > 0)\"><div ng-if=\"!wdController.isInfiniteThrottled()\" class=\"col-xs-6 col-lg-7 usage-info overage-border-top\"><span class=\"overage-usuage-title\" translate=\"dataOverage\"></span></div><div ng-if=\"!wdController.isInfiniteThrottled()\" class=\"col-xs-6 col-lg-5 usage-info overage-border-top\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.overage / 1024) >= 1024\">{{(wddsum.overage / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.overage / 1024) < 1024\">{{(wddsum.overage / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wddsum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_data_usage_included\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_included\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span ng-if=\"::wddsum.usageType === \'unlimited\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_unlimited\"></span></strong></span><span ng-if=\"::wddsum.usageType === \'limited\'\"><span class=\"usuage-ammount\" ng-if=\"(wddsum.total / 1024) >= 1024\">{{(wddsum.total / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"(wddsum.total / 1024) < 1024\">{{(wddsum.total / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></span></div></div><div class=\"row\" ng-if=\"::wddsum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_my-usage\" ng-if=\"::wddsum.usageType !== \'unlimited\'\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_my-usage\"></span> <span class=\"usuage-title\" translate=\"wireless_usage_total-usage\" ng-if=\"::wddsum.usageType === \'unlimited\'\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wddsum.isFamilySharing === true\"><span class=\"usuage-ammount\" ng-if=\"::(wddsum.subscriberUsage / 1024) >= 1024\">{{(wddsum.subscriberUsage / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::(wddsum.subscriberUsage / 1024) < 1024\">{{(wddsum.subscriberUsage / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wddsum.isFamilySharing === false\"><span class=\"usuage-ammount\" ng-if=\"::(wddsum.used / 1024) >= 1024\">{{(wddsum.used / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::(wddsum.used / 1024) < 1024\">{{(wddsum.used / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wddsum.usageType === \'limited\' && wddsum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_others-usage\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"::(wddsum.othersUsage / 1024) >= 1024\">{{(wddsum.othersUsage / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::(wddsum.othersUsage / 1024) < 1024\">{{(wddsum.othersUsage / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wddsum.usageType === \'limited\' && wddsum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_total-usage\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_total-usage-limited\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"::(wddsum.used / 1024) >= 1024\">{{(wddsum.used / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::(wddsum.used / 1024) < 1024\">{{(wddsum.used / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wddsum.usageType === \'limited\' && wddsum.remaining > 0\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_remaining\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\" ng-if=\"::(wddsum.remaining / 1024) >= 1024\">{{(wddsum.remaining / 1048576) | number:2}} <span translate=\"wireless_usage_gb\"></span></span> <span class=\"usuage-ammount\" ng-if=\"::(wddsum.remaining / 1024) < 1024\">{{(wddsum.remaining / 1024) | number:0}} <span translate=\"wireless_usage_mb\"></span></span></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboardSMSSection.html","<section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdssum in wdController.wd.smsArr\"><div class=\"col-xs-12\"><h4 class=\"type-title\" ng-if=\"::wdssum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-if=\"::wdssum.usageType !== \'extras_summary\'\">{{::wdssum.periodGroup}}</h4></div><div class=\"col-xs-12\" ng-if=\"::wdssum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdssumSet in ::wdssum.usageSets\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{::wdssumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::(wdssumSet.used - wdssumSet.total) | number}} {{::wdController.textsLbl}}</span></div></div></div></div><div class=\"col-xs-12\" ng-if=\"::wdssum.usageType !== \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"::wdssum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span ng-if=\"::wdssum.usageType === \'unlimited\'\"><strong><span class=\"usuage-ammount\" translate=\"text_unlimited\"></span></strong></span> <span ng-if=\"::wdssum.usageType === \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"::wdssum.usageType === \'limited\'\"><span class=\"usuage-ammount\">{{::wdssum.total| number}} {{::wdController.textsLbl}}</span></span></div></div><div class=\"row\" ng-if=\"::wdssum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\" ng-if=\"::wdssum.usageType === \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"::wdssum.action == 0\" translate=\"wireless_usage_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 1\" translate=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 2\" translate=\"wireless_usage-text_total-usage_out\"></span></div><div class=\"col-xs-6 col-lg-7 usage-info\" ng-if=\"::wdssum.usageType !== \'unlimited\'\"><span class=\"usuage-title\" ng-if=\"::wdssum.action == 0\" translate=\"wireless_usage-text_my-usage\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 1\" translate=\"wireless_usage-text_my-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 2\" translate=\"wireless_usage-text_my-usage_out\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdssum.isFamilySharing === true\"><span class=\"usuage-ammount\">{{::wdssum.subscriberUsage| number}} {{::wdController.textsLbl}}</span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdssum.isFamilySharing === false\"><span class=\"usuage-ammount\">{{::wdssum.used| number}} {{::wdController.textsLbl}}</span></div></div><div class=\"row\" ng-if=\"::wdssum.usageType == \'limited\' && wdssum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" ng-if=\"::wdssum.action == 0\" translate=\"wireless_usage-text_others-usage\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 1\" translate=\"wireless_usage-text_others-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 2\" translate=\"wireless_usage-text_others-usage_out\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdssum.othersUsage| number}} {{::wdController.textsLbl}}</span></div></div><div class=\"row\" ng-if=\"::wdssum.usageType === \'limited\' && wdssum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" ng-if=\"::wdssum.action == 0\" translate=\"wireless_usage-text_total-usage\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 1\" translate=\"wireless_usage-text_total-usage_in\"></span> <span class=\"usuage-title\" ng-if=\"::wdssum.action == 2\" translate=\"wireless_usage-text_total-usage_out\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdssum.used| number}} {{::wdController.textsLbl}}</span></div></div><div class=\"row\" ng-if=\"::wdssum.usageType === \'limited\' && wdssum.remaining > 0\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage-text_remaining\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdssum.remaining| number}} {{::wdController.textsLbl}}</span></div></div><div class=\"row extraSum\" ng-if=\"::wdssum.usageType !== \'unlimited\' && wdssum.remaining <= 0\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" translate=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::(wdssum.used - wdssum.total) | number}} {{::wdController.textsLbl}}</span></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboardTalkSection.html","<section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdtsum in wdController.wd.talkArr\"><div class=\"col-xs-12\"><h4 class=\"type-title\" ng-if=\"::wdtsum.usageType === \'extras_summary\'\">Extras</h4><h4 class=\"type-title\" ng-if=\"::wdtsum.usageType !== \'extras_summary\'\">{{::wdtsum.periodGroup}}</h4></div><div class=\"col-xs-12\" ng-if=\"::wdtsum.usageType === \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row extraSum\" ng-repeat=\"wdtsumSet in ::wdtsum.usageSets\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\">{{::wdtsumSet.periodGroup}}</span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::(wdtsumSet.used - wdtsumSet.total) | number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div></div></div><div class=\"col-xs-12\" ng-if=\"::wdtsum.usageType !== \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"::wdtsum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span ng-if=\"::wdtsum.usageType === \'unlimited\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_unlimited\"></span></strong></span> <span ng-if=\"::wdtsum.usageType === \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"::wdtsum.usageType === \'limited\'\"><span class=\"usuage-ammount\">{{::wdtsum.total| number}} <span translate=\"wireless_usage_minutes\"></span></span></span></div></div><div class=\"row\" ng-if=\"::wdtsum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_my-usage\" ng-if=\"wddsum.usageType !== \'unlimited\'\"></span> <span class=\"usuage-title\" translate=\"wireless_usage_total-usage\" ng-if=\"wddsum.usageType === \'unlimited\'\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdtsum.isFamilySharing === true\"><span class=\"usuage-ammount\">{{::wdtsum.subscriberUsage| unlimitedUsage}} <span ng-if=\"::wdtsum.subscriberUsage >= 0\" translate=\"wireless_usage_minutes\"></span></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdtsum.isFamilySharing === false\"><span class=\"usuage-ammount\">{{::wdtsum.used| number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"::wdtsum.usageType === \'limited\' && wdtsum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdtsum.othersUsage| number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"::wdtsum.usageType === \'limited\' && wdtsum.isFamilySharing === true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdtsum.used| number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row\" ng-if=\"::wdtsum.usageType === \'limited\' && wdtsum.remaining > 0\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdtsum.remaining| number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"::wdtsum.usageType !== \'unlimited\' && wdtsum.remaining <= 0\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" translate=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::(wdtsum.used - wdtsum.total) | number}} <span translate=\"wireless_usage_minutes\"></span></span></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/wirelessDashboard/wirelessDashboardTextSection.html","<section class=\"usage\"><div class=\"container-fluid\"><div class=\"row\" ng-repeat=\"wdrsum in wdController.wd.roamingArr\"><div class=\"col-xs-12\"><h4 class=\"type-title\" ng-if=\"::wdrsum.usageType !== \'extras_summary\'\">{{::wdrsum.periodGroup}}</h4></div><div class=\"col-xs-12\" ng-if=\"::wdrsum.usageType !== \'extras_summary\'\"><div class=\"container-fluid\"><div class=\"row\" ng-if=\"::wdrsum.usageType !== \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_included\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span ng-if=\"::wdrsum.usageType === \'unlimited\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_unlimited\"></span></strong></span> <span ng-if=\"::wdrsum.usageType === \'pay-per-use\'\"><strong><span class=\"usuage-ammount\" translate=\"wireless_extra-usage\"></span></strong></span> <span ng-if=\"::wdrsum.usageType === \'limited\'\"><span class=\"usuage-ammount\">{{::wdrsum.total| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></span></div></div><div class=\"row\" ng-if=\"::wdrsum.usageType != \'pay-per-use\'\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_my-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdrsum.isFamilySharing == true\"><span class=\"usuage-ammount\">{{::wdrsum.subscriberUsage| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div><div class=\"col-xs-6 col-lg-5 usage-info\" ng-if=\"::wdrsum.isFamilySharing == false\"><span class=\"usuage-ammount\">{{::wdrsum.used| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wdrsum.usageType == \'limited\' && wdrsum.isFamilySharing == true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_others-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdrsum.othersUsage| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wdrsum.usageType == \'limited\' && wdrsum.isFamilySharing == true\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_total-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdrsum.used| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row\" ng-if=\"::wdrsum.usageType == \'limited\' && wdrsum.remaining > 0\"><div class=\"col-xs-6 col-lg-7 usage-info\"><span class=\"usuage-title\" translate=\"wireless_usage_remaining\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::wdrsum.remaining| number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div></div><div class=\"row extraSum\" ng-if=\"::wdrsum.usageType != \'unlimited\' && wdrsum.remaining <= 0\"><div class=\"col-xs-6 col-lg-7 usage-info extraSumWhite\"><span class=\"usuage-title\" translate=\"wireless_extra-usage\"></span></div><div class=\"col-xs-6 col-lg-5 usage-info\"><span class=\"usuage-ammount\">{{::(wdrsum.used - wdrsum.total) | number}} <span ng-if=\"::wdrsum.usageSummaryType == \'VR\'\" translate=\"wireless_usage_minutes\"></span> <span ng-if=\"::wdrsum.usageSummaryType == \'SR\'\">{{::wdController.textsLbl}}</span> <span ng-if=\"::wdrsum.usageSummaryType == \'DR\'\" translate=\"wireless_usage_mb\"></span></span></div></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/wirelessPrepaid/wirelessPrepaid.html","<section class=\"page-wireless\"><div><div class=\"wrap-overview\" data-ng-show=\"true\"><div class=\"\"><myr-notification-banner class=\"ng-hide\" data-banner-id=\"linkedMessage\" type=\"success\"></myr-notification-banner></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 retail mtop-51\"><div class=\"container\"><div class=\"rui-heading\"><h1><span translate=\"wirelessPrepaidHeader\" data-test-id=\"myr-wirelessPrepaid-wirelessPrepaidHeader\"></span></h1></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"errorMessage\"></validation-error-box></div><div class=\"row info-banner\" ng-class=\"accountStatusSimple === \'Error\' ? \'error\' : \'warning - border\'\" data-ng-show=\"selAccountStatusError\"><div class=\"col-xs-2 col-sm-2 col-md-2 pln prn\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon - alert\'\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 pln prn\" style=\"float:left\"><span class=\"v-base-line\" ng-bind-html=\"selAccountStatusError\" style=\"font-weight:normal\"></span></div></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><select data-ng-show=\"wirelessDashData.length > 1\" class=\"account-type\" name=\"accountType\" required=\"\" data-ng-model=\"wirelessDashActive\" ng-change=\"changeAccount()\" ng-options=\"value as value.firstname + \' - \' + value.ctn for value in wirelessDashData\"></select></div></div></div><div><wireless-plan mode=\"1\"></wireless-plan></div></div></section>");
$templateCache.put("views/modals/EOP/eop-existing-plan-offer-modal.html","<div ng-show=\"!loading\" class=\"row margin-L-R-0 eop-existing-plan-offer-modal\"><div class=\"col-xs-12 modal-header\"><button type=\"button\" ng-click=\"cancel()\" class=\"close\" data-dismiss=\"modal\" aria-label=\"{{ \'EOP.CTAS.CLOSE.ALT\' | translate }}\"><span aria-hidden=\"true\" class=\"rogers-icon-circle-x\"></span></button><h2 class=\"modal-title\" translate=\"{{\'EOP.NEW_OFFER.HEADER\'}}\"></h2></div><div class=\"col-xs-12 modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><p class=\"eligible-message\" translate=\"{{\'EOP.NEW_OFFER.BODY\'}}\"></p></div></div><div class=\"row current-plan-container margin-L-R-0 feature-count-{{existingPlanSectionView.packageFeatures.length}}\"><div class=\"col-xs-12\"><h3 translate=\"{{\'EOP.CURRENT_PLAN.title\'}}\"></h3></div><div class=\"features-container\"><div class=\"row-eq-height xs-display-block\"><div class=\"features\" data-ng-repeat=\"obj in existingPlanSectionView.packageFeatures\"><p class=\"featureTitle\" translate=\"{{\'EOP.CURRENT_PLAN.features.\'+obj.label}}\" ng-if=\"obj.label !== \'tv\'\"></p><p class=\"featureTitle\" ng-bind-html=\"existingPlanSectionView.title\" ng-if=\"obj.label ==\'tv\'\"></p><p class=\"featureDescription\" ng-bind-html=\"obj.value\"></p><p class=\"featureTitle\" ng-if=\"obj.value_desc\" translate=\"{{\'EOP.CURRENT_PLAN.features.\'+obj.value_desc}}\"></p></div></div></div></div><div class=\"row new-plan-container margin-L-R-0\"><div class=\"col-xs-12\"><h3 class=\"exclusive-badge xs-text-center\" translate=\"EOP.NEW_OFFER.newPromo.exclusiveOffer\"></h3></div><div class=\"col-xs-12 new-package-content xs-text-center\"><div class=\"row row-eq-height xs-display-block\"><div class=\"col-xs-12 col-sm-5\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"new-package-name\" ng-bind-html=\"offerPlanSectionView.title\"></h4></div><div class=\"col-xs-12 hidden-xs\"><img class=\"offer-discount-msg\" ng-src=\"{{offerPlanSectionView.img}}\" alt=\"{{ \'EOP.NEW_OFFER.newPromo.image_alt\' |translate}} {{lob===\'bundle\' ? (\'EOP.NEW_OFFER.newPromo.exclusiveOffer\' | translate) : offerPlanSectionView.title}}\"></div><div class=\"col-xs-12 special-offer-section color-red font-bold\" ng-bind-html=\"offerPlanSectionView.additionalOffer\"></div></div></div><div class=\"col-xs-12 col-sm-3 display-flex-md\"><div class=\"features-section xs-margin-0-5 feature-count-{{offerPlanSectionView.packageFeatures.length}}\"><div class=\"features\" data-ng-repeat=\"obj in offerPlanSectionView.packageFeatures\" ng-class=\"{\'no-rhp\' : !offerPlanSectionView.includesRHP}\"><p class=\"featureTitle\" translate=\"{{\'EOP.NEW_OFFER.newPromo.features.\'+obj.label}}\" ng-if=\"obj.label !== \'tv\'\"></p><p class=\"featureTitle\" translate-values=\"{bundleName : obj.title}\" translate=\"EOP.NEW_OFFER.newOfferTitle\" ng-if=\"obj.label == \'tv\'\"></p><p><span class=\"featureDescription\" ng-bind-html=\"obj.value\"></span> <span class=\"featureDescription_unit\" ng-bind-html=\"obj.valueDesc\"></span></p></div><div class=\"phone-desc\" data-ng-if=\"offerPlanSectionView.includesRHP\"><div class=\"home-phone-section\" translate=\"EOP.NEW_OFFER.newPromo.includes_rhp\"></div></div></div></div><div class=\"col-xs-12 col-sm-4 price-section xs-padding-15-0 price-left\"><p class=\"marketPriceSection\" data-ng-if=\"language === \'en\'\"><sup class=\"price-dollars\">$</sup> <span class=\"price-amount\">{{offerPlanSectionView.price.discountedPrice.dollar}}</span> <sup class=\"price-cents\">.{{offerPlanSectionView.price.discountedPrice.cents}}</sup> <sub class=\"price-period\" translate=\"EOP./mo*\">/mo</sub></p><p class=\"marketPriceSection\" data-ng-if=\"language === \'fr\'\"><span class=\"price-amount\">{{offerPlanSectionView.price.discountedPrice.dollar}}</span> <sup class=\"price-cents\">,{{offerPlanSectionView.price.discountedPrice.cents}}</sup> <sup class=\"price-dollars\">$</sup> <sub class=\"price-period\" translate=\"EOP./mo*\"></sub></p><p class=\"savings-desc\" ng-if=\"lob !== \'internet\'\" translate-values=\"{ discount: offerPlanSectionView.price.discount, term: offerPlanSectionView.price.term, originalMsf: offerPlanSectionView.price.msf }\" translate=\"EOP.NEW_OFFER.newPromo.SAVINGS\"></p><p class=\"savings-desc\" ng-if=\"lob === \'internet\'\" translate-values=\"{ discount: offerPlanSectionView.price.discount, term: offerPlanSectionView.price.term, originalMsf: offerPlanSectionView.price.msf }\" translate=\"EOP.NEW_OFFER.newPromo.SAVINGS_with_month_term\"></p><p class=\"not-included-desc\" translate=\"EOP.NEW_OFFER.newPromo.notIncluded\"></p><p class=\"installation-desc\"><span translate=\"EOP.NEW_OFFER.newPromo.installation_fee\"></span> <span class=\"color-red\">{{offerPlanSectionView.installationFee}}</span></p></div></div><div class=\"disclaimer-section text-left\" translate=\"{{\'EOP.NEW_OFFER.newPromo.disclaimer.\'+lob}}\"></div></div></div></div><div class=\"col-xs-12 modal-footer xs-text-center xs-margin-top-10 {{lob}}\"><a class=\"dismiss-offer hidden-xs\" ng-click=\"cancel(true)\" title=\"{{ \'EOP.CTAS.DISMISS_OFFER.ALT\' | translate }}\"><span translate=\"EOP.CTAS.DISMISS_OFFER.LABEL\" aria-hidden=\"true\"></span></a><div ng-if=\"lob !== \'bundle\'\"><div class=\"sm-display-inline-block\"><button class=\"btn btn-primary cta-upgrade-now xs-full-width xs-margin-bottom-15\" ng-click=\"upgradeNow($event, \'upgrade\')\" title=\"{{ \'EOP.CTAS.UPGRADE_NOW.ALT\' | translate }}\"><span translate=\"EOP.CTAS.UPGRADE_NOW.LABEL\" aria-hidden=\"true\"></span></button></div></div><div class=\"ways-to-buy-section\" ng-if=\"lob === \'bundle\'\"><span class=\"xs-display-block ways-to-buy\" translate=\"EOP.ways_to_buy\"></span> <a href=\"#\" class=\"xs-display-block call-care\" title=\"{{\'EOP.call_care_alt_text\' | translate}} {{\'EOP.call_care\' |translate}}\"><i class=\"rui-icon-person-call-v2\"></i><span translate=\"EOP.call_care\" aria-hidden=\"true\"></span></a><div class=\"xs-display-block live-chat rui-icon-\"><bold-chat-static-button style=\"margin-top:20px;\" data-cbid=\"{{\'EOP.liveChat_ID\'| translate}}\" data-dynamic-div=\"chat-eop-{{language+\'-\'+$id}}\" data-chat-=\"live-chat-eop-text-content\"></bold-chat-static-button></div></div><a class=\"dismiss-offer visible-xs xs-full-width xs-dismiss-offer {{lob}}\" ng-click=\"cancel(true)\" title=\"{{ \'EOP.CTAS.DISMISS_OFFER.ALT\' | translate }}\"><span translate=\"EOP.CTAS.DISMISS_OFFER.LABEL\"></span></a></div></div><div ng-show=\"loading\"><div class=\"row\"><div class=\"col-xs-12 text-center\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading\"></div></div></div>");
$templateCache.put("views/modals/EOP/eop-notification-modal.html","<div class=\"modal-header\" ng-switch=\"eopSubType\"><button type=\"button\" ng-switch-when=\"IGNITE\" data-dtname=\"{{ \'EOP.DYNATRACE.\'+offerType+\'.CLOSE\' | translate }}\" class=\"close\" ng-click=\"cancel()\" data-dismiss=\"modal\" title=\"{{ \'EOP.CTAS.CLOSE.ALT\' | translate }}\"><span aria-hidden=\"true\" class=\"rogers-icon-circle-x\"></span></button> <button type=\"button\" ng-switch-when=\"LEGACY\" class=\"close\" ng-click=\"cancel()\" data-dismiss=\"modal\" title=\"{{ \'EOP.CTAS.CLOSE.ALT\' | translate }}\"><span aria-hidden=\"true\" class=\"rogers-icon-circle-x\"></span></button><div><h2 ng-switch-when=\"IGNITE\" class=\"modal-title\" translate=\"{{ \'EOP.\'+type+\'.IGNITE.TITLE.\'+offerType }}\"></h2><h2 ng-switch-when=\"LEGACY\" class=\"modal-title\" translate=\"{{ type === \'NEW_OFFER_NOTIFICATION\' ? \'EOP.\'+type+\'.LEGACY.TITLE\' : \'EOP.\'+type+\'.TITLE\' }}\"></h2></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div><span ng-switch=\"eopSubType\"><span ng-switch-when=\"IGNITE\" translate=\"{{ \'EOP.\'+type+\'.IGNITE.BODY.\'+offerType }}\"></span> <span ng-switch-when=\"LEGACY\" translate=\"{{type === \'NEW_OFFER_NOTIFICATION\' ? \'EOP.\'+type+\'.LEGACY.BODY\' : \'EOP.\'+type+\'.BODY\' }}\"></span></span></div></div></div></div><div class=\"modal-footer\" ng-show=\"type === \'NEW_OFFER_NOTIFICATION\'\"><div class=\"row\"><div class=\"col-xs-12 text-right xs-text-center\" ng-switch=\"eopSubType\"><button ng-switch-when=\"IGNITE\" data-dtname=\"{{ \'EOP.DYNATRACE.\'+offerType+\'.LEARNMORE\' | translate }}\" ng-click=\"ok()\" class=\"btn btn-primary xs-margin-bottom-15 xs-full-width\" title=\"{{ \'EOP.CTAS.IGNITE.\'+offerType+\'.ALT\' | translate }}\" translate=\"{{\'EOP.CTAS.IGNITE.\'+offerType+\'.LABEL\'}}\"></button> <button ng-switch-when=\"LEGACY\" ng-click=\"ok()\" class=\"btn btn-primary xs-margin-bottom-15 xs-full-width\" title=\"{{ \'EOP.CTAS.TAKE_ACTION.ALT\' | translate }}\" translate=\"{{ \'EOP.CTAS.TAKE_ACTION.LABEL\' }}\"></button></div></div></div>");
$templateCache.put("views/modals/tupelo/first-time-offer-modal.html","<div class=\"modal-header\" ng-switch=\"eopSubType\"><button type=\"button\" data-dtname=\"{{ \'EOP.DYNATRACE.\'+offerType+\'.CLOSE\' | translate }}\" class=\"close\" ng-click=\"cancel()\" data-dismiss=\"modal\" aria-label=\"{{ \'EOP.CTAS.CLOSE.ALT\' | translate }}\"><span aria-hidden=\"true\" class=\"rogers-icon-circle-x\"></span></button><div><span ng-switch=\"eopSubType\"><h2 ng-switch-when=\"SAI\" class=\"modal-title\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.sai.header\' }}\"></h2><h2 ng-switch-when=\"TUPELO\" class=\"modal-title\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.tupelo.header\' }}\"></h2><h2 ng-switch-when=\"IGNITE\" class=\"modal-title\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.ignite.header\' }}\"></h2></span></div></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-xs-12\"><div ng-switch=\"eopSubType\"><div ng-switch-when=\"SAI\"><img class=\"modal-img\" alt=\"{{ \'EOP.saiImageAlt\' | translate }}\" src=\"images/eop/sai-modal-img.png\"><p class=\"pt-20\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.sai.body1\' }}\"></p><span class=\"font-bold\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.sai.subheader\' }}\"></span><br><span translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.sai.body2\' }}\"></span></div><div ng-switch-when=\"IGNITE\"><img class=\"modal-img\" alt=\"{{ \'EOP.igniteImageAlt\' | translate }}\" src=\"images/eop/ignite-modal-img.png\"><p class=\"pt-20\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.ignite.body1\' }}\"></p><span class=\"font-bold\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.ignite.subheader\' }}\"></span><br><span translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.ignite.body2\' }}\"></span></div><div ng-switch-when=\"TUPELO\"><video aria-labelledby=\"vjs-dock-title-11\" aria-describedby=\"vjs-dock-description-12\" class=\"video-js bc-vid\" data-account=\"{{\'EOP.NEW_OFFER_NOTIFICATION.video.accountId\' | translate}}\" data-video-id=\"{{\'EOP.NEW_OFFER_NOTIFICATION.video.videoId\' | translate}}\" data-player=\"{{\'EOP.NEW_OFFER_NOTIFICATION.video.playerId\' | translate}}\" data-embed=\"default\" controls=\"\" data-playlist-id=\"\" data-application-id=\"\"></video><div ng-if=\"(\'EOP.NEW_OFFER_NOTIFICATION.video.lang\' | translate) === \'en\'\"><script src=\"//players.brightcove.net/1275380481001/NC2EcBXc7_default/index.min.js\"></script></div><div ng-if=\"(\'EOP.NEW_OFFER_NOTIFICATION.video.lang\' | translate) === \'fr\'\"><script src=\"//players.brightcove.net/1275380481001/NC2EcBXc7_default/index.min.js\"></script></div><p class=\"pt-20\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.tupelo.body\' }}\"></p></div></div></div></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col-xs-12 text-left xs-text-center\" ng-switch=\"eopSubType\"><div ng-switch-when=\"SAI\" class=\"button-row\"><div><button ng-click=\"ok()\" class=\"btn btn-primary xs-margin-bottom-15 xs-full-width\" aria-label=\"{{ \'EOP.CTAS.takeMeThere.alt\' | translate }}\" translate=\"{{ \'EOP.CTAS.takeMeThere.label\' }}\"></button></div><div><a aria-label=\"{{ \'EOP.CTAS.dismiss.alt\' | translate }}\" role=\"button\" class=\"dismiss-link\" ng-click=\"cancel()\" data-dismiss=\"modal\" translate=\"{{ \'EOP.CTAS.dismiss.label\' }}\"></a></div></div><div ng-switch-when=\"IGNITE\" class=\"button-row\"><div><button ng-click=\"ok()\" class=\"btn btn-primary xs-margin-bottom-15 xs-full-width\" aria-label=\"{{ \'EOP.CTAS.takeMeThere.alt\' | translate }}\" translate=\"{{ \'EOP.CTAS.takeMeThere.label\' }}\"></button></div><div><a aria-label=\"{{ \'EOP.CTAS.dismiss.alt\' | translate }}\" role=\"button\" class=\"dismiss-link\" ng-click=\"cancel()\" data-dismiss=\"modal\" translate=\"{{ \'EOP.CTAS.dismiss.label\' }}\"></a></div></div><div ng-switch-when=\"TUPELO\" class=\"button-row\"><div class=\"row\"><div class=\"col-md-5 col-sm-5 col-xs-12\"><button ng-click=\"ok()\" class=\"btn btn-primary xs-margin-bottom-15 xs-full-width\" aria-label=\"{{ \'EOP.CTAS.takeMeThere.smartStreamAlt\' | translate }}\" translate=\"{{ \'EOP.CTAS.takeMeThere.smartStreamLabel\' }}\"></button></div><div class=\"col-md-7 col-sm-7 col-xs-12\"><a aria-label=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.tupelo.learnPage.alt\' | translate }}\" style=\"margin:0; text-align:left;\" role=\"button\" class=\"dismiss-link\" translate=\"{{ \'EOP.NEW_OFFER_NOTIFICATION.tupelo.learnPage.label\' }}\" href=\"/tv-streaming\" target=\"_blank\"></a> <i class=\"rui-icon-share\"></i></div></div></div></div></div></div>");
$templateCache.put("environments/proxy/urlMappings/shiva/local.html","<html><head><meta http-equiv=\"Content-Type\" content=\"text/html; charset=UTF-8\"></head><body><form action=\"https://localhost.rogers.com:3000/web/totes/api/v1/oneviewSSO\" method=\"post\"><button type=\"submit\">Launch One View</button></form></body></html>");
$templateCache.put("scripts/directives/editableContent/billingInformation/billinginformation.html","<div class=\"non-editable-row\"><span class=\"row-label\" translate=\"BillingType\">Billing Type:</span> <span class=\"value\" type=\"text\"><span data-ng-if=\"!(nonEditableData.paper || nonEditableData.ebill)\"><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span data-ng-if=\"nonEditableData.paper && ! nonEditableData.ebill\" translate=\"_paper\"></span> <span data-ng-if=\"nonEditableData.ebill && ! nonEditableData.paper\" translate=\"_online\"></span></span></div><div class=\"non-editable-row\"><span class=\"row-label\" translate=\"billing_address\">Billing Address:</span><span class=\"value\">{{nonEditableData.billing_streetAddress}}</span></div><div class=\"non-editable-row\" style=\"padding-top:10px;\" data-ng-if=\"nonEditableData.country!==\'CA\' && nonEditableData.country!==\'CAN\'\"><div class=\"col-md-6\"><alert><span translate=\"billing_us_address_warning\">This is an US address. You can only change the billing method.</span></alert></div></div>");
$templateCache.put("scripts/directives/editableContent/billingInformation/billinginformationform.html","<form name=\"updateBillingTypeForm\" form-locator=\"\" novalidate=\"\" adl-event-track=\'{\"mappingKey\":\"edit-billing-information,event.selfServeStart\"}\'><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><div class=\"billing-btn-ctn\" data-ng-class=\"repUpdateBillingType && isRepView === true ? \'col-xs-12\' : \'col-xs-5 col-md-12 col-lg-5\'\"><span translate=\"BillingType\">translate</span> <span data-ng-if=\"isBillingTypeDefined()\"><div data-ng-if=\"repUpdateBillingType && isRepView === true\"><div class=\"checkbox-line online\"><label><input type=\"radio\" name=\"billingType\" class=\"rogers-checkbox billing\" data-ng-model=\"editableData.billingType\" data-ng-true-value=\"\'E_BILL\'\" value=\"E_BILL\"> <span class=\"selfserve-checkbox-label\" translate=\"_online\"></span></label></div><div class=\"checkbox-line paper\"><label><input type=\"radio\" name=\"billingType\" class=\"rogers-checkbox billing\" data-ng-model=\"editableData.billingType\" data-ng-true-value=\"\'INVOICE\'\" value=\"INVOICE\"> <span class=\"selfserve-checkbox-label\" translate=\"_paper\"></span></label></div></div><span class=\"value billing-type\" type=\"text\" data-ng-if=\"repUpdateBillingType === false ||!isRepView\"><span data-ng-if=\"nonEditableData.paper && ! nonEditableData.ebill\" translate=\"_paper\"></span> <span data-ng-if=\"nonEditableData.ebill && ! nonEditableData.paper\" translate=\"_online\"></span></span></span></div><div data-ng-if=\"isBillingTypeDefined()\" class=\"billing-btn-ctn\" data-ng-class=\"repUpdateBillingType && isRepView === true ? \'col-xs-12\' : \'col-xs-7 col-md-12 col-lg-7\'\"><div data-ng-if=\"repUpdateBillingType && isRepView === true\"><button data-ng-disabled=\"!updateBillingTypeForm.$dirty || !updateBillingTypeForm.$valid || (editableData.billingType === nonEditableData.billingType) || (updatingBillingType === true)\" class=\"save-changes cta-round primary large\" data-ng-click=\"saveBillingChanges(updateBillingTypeForm)\"><span class=\"inline-loader-button-label\" translate=\"_save_changes\"></span></button> <button class=\"cancel cta-round tertiary large\" data-ng-click=\"cancel()\" translate=\"_cancel\"></button></div><div data-ng-if=\"editableData.initialBillingType===\'INVOICE\' && (repUpdateBillingType === false || isRepView === false )\"><button data-ng-disabled=\"::isGuidNotFound\" class=\"save-changes cta-round primary large\" data-ng-click=\"switchToOnlineBilling(updateBillingTypeForm)\"><span class=\"inline-loader-button-label\" translate=\"myaccoverview_switch_to_online_bill\"></span></button> <button class=\"cancel cta-round tertiary large\" data-ng-click=\"cancel()\" translate=\"_cancel\"></button></div></div></div></div></form><div class=\"gray-border-selfserve no-margin-top small-margin-bottom col-md-6\"></div><div class=\"non-editable-row pull-left\" data-ng-if=\"nonEditableData.country!==\'CA\' && nonEditableData.country!==\'CAN\'\"><div class=\"col-md-8\"><alert><span translate=\"billing_us_address_warning\"></span></alert></div></div><div class=\"col-xs-12 guideline-container\" data-ng-if=\"isConsumer && nonEditableData.hasActiveResidentialServices\"><div class=\"col-xs-12 col-sm-6 move_your_services_container\"><span translate=\"billing_move_your_services_warning\"></span></div></div><form name=\"form\" novalidate=\"\" form-locator=\"\"><div class=\"col-lg-6 col-md-6 editable-row row large-view-margin-only\" style=\"clear:both\"><div class=\"col-lg-12 col-md-12\"><div class=\"col-md-3 col-lg-3 row small-view-margin\" style=\"margin-right:20px\"><span translate=\"StreetNumber\"></span><div class=\"inline_error\" data-ng-if=\"form.StreetNumber.$dirty && form.StreetNumber.$error.required\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"street number\"}\'><span translate=\"street_number_error\"></span></div><div class=\"inline_error\" data-ng-if=\"form.StreetNumber.$dirty && form.StreetNumber.$error.pattern\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"street number\"}\'><span translate=\"street_number_error_char\"></span></div><input name=\"StreetNumber\" type=\"text\" data-ng-model=\"editableData.Street_number\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-pattern=\"/^[0-9A-Za-z]{1,6}$/\" data-ng-change=\"checkIfPreviousAddress()\" required=\"\"></div><div class=\"col-md-4 col-lg-4 row small-view-margin\" style=\"margin-right:20px\"><span class=\"label-name\" translate=\"StreetName\">Street Name:</span><div class=\"inline_error\" data-ng-if=\"form.StreetName.$dirty && (form.StreetName.$error.pattern || form.StreetName.$error.required)\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"street name\"}\'><span translate=\"street_name_error\"></span></div><input class=\"french-extra-margin\" name=\"StreetName\" type=\"text\" maxlength=\"30\" data-ng-model=\"editableData.Street_name\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-pattern=\"/^[-A-Za-z0-9. ]{1,30}$/\" data-ng-change=\"checkIfPreviousAddress()\" required=\"\"></div><div class=\"col-md-3 col-lg-3 row\"><span class=\"label-name\" translate=\"StreetType\">Street Type:</span><select class=\"streettype french-extra-margin\" data-ng-model=\"editableData.Street_type\" data-ng-change=\"checkIfPreviousAddress()\"><option value=\"ABBEY\" translate=\"ABBEY\"></option><option value=\"ACRE\" translate=\"ACRE\"></option><option value=\"ALLEY\" translate=\"ALLEY\"></option><option value=\"ANNEX\" translate=\"ANNEX\"></option><option value=\"AVE\" translate=\"AVE\"></option><option value=\"BAY\" translate=\"BAY\"></option><option value=\"BEACH\" translate=\"BEACH\"></option><option value=\"BEND\" translate=\"BEND\"></option><option value=\"BLDNG\" translate=\"BLDNG\"></option><option value=\"BLOCK\" translate=\"BLOCK\"></option><option value=\"BLVD\" translate=\"BLVD\"></option><option value=\"BRDG\" translate=\"BRDG\"></option><option value=\"BURN\" translate=\"BURN\"></option><option value=\"BYPASS\" translate=\"BYPASS\"></option><option value=\"BYRON\" translate=\"BYRON\"></option><option value=\"BYWAY\" translate=\"BYWAY\"></option><option value=\"CAMPU\" translate=\"CAMPU\"></option><option value=\"CAPE\" translate=\"CAPE\"></option><option value=\"CHASE\" translate=\"CHASE\"></option><option value=\"CIR\" translate=\"CIR\"></option><option value=\"CIRCT\" translate=\"CIRCT\"></option><option value=\"CLIFF\" translate=\"CLIFF\"></option><option value=\"CLOSE\" translate=\"CLOSE\"></option><option value=\"COMMO\" translate=\"COMMO\"></option><option value=\"CONN\" translate=\"CONN\"></option><option value=\"COURT\" translate=\"COURT\"></option><option value=\"COVE\" translate=\"COVE\"></option><option value=\"CRES\" translate=\"CRES\"></option><option value=\"CRNRS\" translate=\"CRNRS\"></option><option value=\"CROSS\" translate=\"CROSS\"></option><option value=\"CTR\" translate=\"CTR\"></option><option value=\"CURVE\" translate=\"CURVE\"></option><option value=\"DALE\" translate=\"DALE\"></option><option value=\"DELL\" translate=\"DELL\"></option><option value=\"DIVER\" translate=\"DIVER\"></option><option value=\"DOWN\" translate=\"DOWN\"></option><option value=\"DR\" translate=\"DR\"></option><option value=\"END\" translate=\"END\"></option><option value=\"ESPL\" translate=\"ESPL\"></option><option value=\"ESTAT\" translate=\"ESTAT\"></option><option value=\"EXPY\" translate=\"EXPY\"></option><option value=\"EXTEN\" translate=\"EXTEN\"></option><option value=\"FARM\" translate=\"FARM\"></option><option value=\"FIELD\" translate=\"FIELD\"></option><option value=\"FORES\" translate=\"FORES\"></option><option value=\"FRONT\" translate=\"FRONT\"></option><option value=\"FWY\" translate=\"FWY\"></option><option value=\"GARD\" translate=\"GARD\"></option><option value=\"GATE\" translate=\"GATE\"></option><option value=\"GDNS\" translate=\"GDNS\"></option><option value=\"GLADE\" translate=\"GLADE\"></option><option value=\"GLEN\" translate=\"GLEN\"></option><option value=\"GREEN\" translate=\"GREEN\"></option><option value=\"GRNDS\" translate=\"GRNDS\"></option><option value=\"GROVE\" translate=\"GROVE\"></option><option value=\"GTWAY\" translate=\"GTWAY\"></option><option value=\"HALL\" translate=\"HALL\"></option><option value=\"HARBR\" translate=\"HARBR\"></option><option value=\"HEATH\" translate=\"HEATH\"></option><option value=\"HEIGH\" translate=\"HEIGH\"></option><option value=\"HGHLD\" translate=\"HGHLD\"></option><option value=\"HILL\" translate=\"HILL\"></option><option value=\"HOLLO\" translate=\"HOLLO\"></option><option value=\"HTS\" translate=\"HTS\"></option><option value=\"HWY\" translate=\"HWY\"></option><option value=\"IMP\" translate=\"IMP\"></option><option value=\"ISLAN\" translate=\"ISLAN\"></option><option value=\"JARD\" translate=\"JARD\"></option><option value=\"KEEP\" translate=\"KEEP\"></option><option value=\"KEY\" translate=\"KEY\"></option><option value=\"KNOLL\" translate=\"KNOLL\"></option><option value=\"LAKE\" translate=\"LAKE\"></option><option value=\"LANDN\" translate=\"LANDN\"></option><option value=\"LANE\" translate=\"LANE\"></option><option value=\"LAWN\" translate=\"LAWN\"></option><option value=\"LINE\" translate=\"LINE\"></option><option value=\"LINK\" translate=\"LINK\"></option><option value=\"LKOUT\" translate=\"LKOUT\"></option><option value=\"LMTS\" translate=\"LMTS\"></option><option value=\"LOOP\" translate=\"LOOP\"></option><option value=\"MAIN\" translate=\"MAIN\"></option><option value=\"MALL\" translate=\"MALL\"></option><option value=\"MANOR\" translate=\"MANOR\"></option><option value=\"MARKE\" translate=\"MARKE\"></option><option value=\"MAZE\" translate=\"MAZE\"></option><option value=\"MEADO\" translate=\"MEADO\"></option><option value=\"MEWS\" translate=\"MEWS\"></option><option value=\"MIN12\" translate=\"MIN12\"></option><option value=\"MOOR\" translate=\"MOOR\"></option><option value=\"MOUNT\" translate=\"MOUNT\"></option><option value=\"MTN\" translate=\"MTN\"></option><option value=\"ORCH\" translate=\"ORCH\"></option><option value=\"PARAD\" translate=\"PARAD\"></option><option value=\"PARC\" translate=\"PARC\"></option><option value=\"PARK\" translate=\"PARK\"></option><option value=\"PASS\" translate=\"PASS\"></option><option value=\"PATH\" translate=\"PATH\"></option><option value=\"PINES\" translate=\"PINES\"></option><option value=\"PKY\" translate=\"PKY\"></option><option value=\"PL\" translate=\"PLACE\"></option><option value=\"PLAT\" translate=\"PLAT\"></option><option value=\"PLAZA\" translate=\"PLAZA\"></option><option value=\"PLWAY\" translate=\"PLWAY\"></option><option value=\"POINT\" translate=\"POINT\"></option><option value=\"PRKRD\" translate=\"PRKRD\"></option><option value=\"PROM\" translate=\"PROM\"></option><option value=\"PTWAY\" translate=\"PTWAY\"></option><option value=\"PVT\" translate=\"PVT\"></option><option value=\"QUAY\" translate=\"QUAY\"></option><option value=\"RANG\" translate=\"RANG\"></option><option value=\"RANGE\" translate=\"RANGE\"></option><option value=\"RDPT\" translate=\"RDPT\"></option><option value=\"RIDGE\" translate=\"RIDGE\"></option><option value=\"RISE\" translate=\"RISE\"></option><option value=\"RD\" translate=\"ROAD\"></option><option value=\"ROUTE\" translate=\"ROUTE\"></option><option value=\"ROW\" translate=\"ROW\"></option><option value=\"RUE\" translate=\"RUE\"></option><option value=\"RUN\" translate=\"RUN\"></option><option value=\"SEAWK\" translate=\"SEAWK\"></option><option value=\"SQ\" translate=\"SQ\"></option><option value=\"ST\" translate=\"ST\"></option><option value=\"SUBDI\" translate=\"SUBDI\"></option><option value=\"TERR\" translate=\"TERR\"></option><option value=\"THICK\" translate=\"THICK\"></option><option value=\"TLINE\" translate=\"TLINE\"></option><option value=\"TOWER\" translate=\"TOWER\"></option><option value=\"TRAIL\" translate=\"TRAIL\"></option><option value=\"TRLWA\" translate=\"TRLWA\"></option><option value=\"TRNAB\" translate=\"TRNAB\"></option><option value=\"VALE\" translate=\"VALE\"></option><option value=\"VALLE\" translate=\"VALLE\"></option><option value=\"VIEW\" translate=\"VIEW\"></option><option value=\"VILLA\" translate=\"VILLA\"></option><option value=\"VILLG\" translate=\"VILLG\"></option><option value=\"VISTA\" translate=\"VISTA\"></option><option value=\"WALK\" translate=\"WALK\"></option><option value=\"WAY\" translate=\"WAY\"></option><option value=\"WHARF\" translate=\"WHARF\"></option><option value=\"WKWAY\" translate=\"WKWAY\"></option><option value=\"WOOD\" translate=\"WOOD\"></option><option value=\"WYND\" translate=\"WYND\"></option></select></div></div></div><div class=\"col-lg-6 col-md-6 editable-row large-view-margin-only\" style=\"clear:both\"><div class=\"col-lg-12 col-md-12\"><div class=\"col-md-3 col-lg-3 row\" style=\"margin-right:20px; margin-bottom:30px\"><span translate=\"AptNumber\">Apt Number:</span><div class=\"inline_error\" data-ng-if=\"form.AptNumber.$dirty && form.AptNumber.$error.pattern\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"apartment number\"}\'><span translate=\"apartment_number_error_char\"></span></div><input name=\"AptNumber\" type=\"text\" data-ng-model=\"editableData.AptNo\" data-ng-pattern=\"/^[0-9A-Za-z]{1,6}$/\" data-ng-change=\"checkIfPreviousAddress()\"></div><div class=\"col-md-4 col-lg-4 row\" style=\"margin-bottom:30px\"><span class=\"label-name\" translate=\"_Type\">Type:</span><select class=\"streettype french-extra-margin\" data-ng-model=\"editableData.AptType\" data-ng-change=\"checkIfPreviousAddress()\"><option value=\"APT\" translate=\"Apartment\"></option><option value=\"BUREAU\" translate=\"Bureau\"></option><option value=\"FLR\" translate=\"Floor\"></option><option value=\"PH\" translate=\"Penthouse\"></option><option value=\"SUITE\" translate=\"Suite\"></option><option value=\"UNIT\" translate=\"Unit\"></option></select></div></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span translate=\"_city\">City</span><div class=\"inline_error\" data-ng-if=\"form.BillingCity.$dirty && (form.BillingCity.$error.pattern || form.BillingCity.$error.required)\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"city\"}\'><span translate=\"valid_city_name\"></span></div><input name=\"BillingCity\" type=\"text\" maxlength=\"30\" data-ng-model=\"editableData.city\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-pattern=\"/^[A-Za-z0-9 ]{1,30}$/\" data-ng-change=\"checkIfPreviousAddress()\" required=\"\"></div></div><div class=\"editable-row row\"><div class=\"col-md-3 col-lg-3 row\" style=\"margin-right:20px; margin-bottom:30px\"><span translate=\"_province\"></span><select name=\"province\" data-ng-model=\"editableData.province\" data-ng-change=\"checkIfPreviousAddress()\"><option value=\"AB\" translate=\"alberta\"></option><option value=\"BC\" translate=\"british_columbia\"></option><option value=\"MB\" translate=\"manitoba\"></option><option value=\"NB\" translate=\"new_brunswick\"></option><option value=\"NF\" translate=\"newfoundland\"></option><option value=\"NW\" translate=\"northwest\"></option><option value=\"NS\" translate=\"nova_scotia\"></option><option value=\"NU\" translate=\"nunavut\"></option><option value=\"ON\" translate=\"ontario\"></option><option value=\"PE\" translate=\"prince_edward_island\"></option><option value=\"QC\" translate=\"quebec\"></option><option value=\"SK\" translate=\"saskatchewan\"></option><option value=\"YK\" translate=\"yukon\"></option></select></div><div class=\"col-md-4 col-lg-4 row\" style=\"margin-bottom:30px\"><span translate=\"_postal_code\" class=\"postal-code-title\">Postal Code</span><div class=\"inline_error\" data-ng-if=\"form.PostalCode.$dirty && (form.PostalCode.$error.pattern || form.PostalCode.$error.required)\" style=\"clear:both\" adl-error-track=\'{\"mappingKey\":\"edit-billing-information\",\"field\":\"postal code\"}\'><span translate=\"valid_postal_code\"></span></div><div class=\"col-md-4\"><input type=\"text\" name=\"PostalCode\" maxlength=\"7\" data-ng-model=\"editableData.postalCode\" data-ng-pattern=\"/^[a-z]{1}\\d{1}[a-z]{1} ?\\d{1}[a-z]{1}\\d{1}$/i\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-trim=\"true\" data-ng-change=\"checkIfPreviousAddress()\" required=\"\"></div></div><div class=\"billing_info_row row\"><div class=\"col-md-6 col-xs-12\" translate=\"billing_bottom_info\"></div></div></div><div class=\"col-md-6 billing-btn-ctn\"><button class=\"save-changes cta-round primary large\" data-ng-disabled=\"!(form.$valid && form.$dirty && isNotPreviousAddress)\" data-ng-class=\"{ inactive :form.$pristine }\" data-ng-click=\"isNotPreviousAddress && saveChanges(form)\" translate=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" data-ng-click=\"cancel()\" translate=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/editableContent/contactInformation/contactinformation.html","<span ng-hide=\"nonEditableData.isloaded\"><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></span><div ng-show=\"nonEditableData.isloaded\"><div class=\"non-editable-row\" ng-show=\"nonEditableData.email\"><span class=\"row-label\" translate=\"_email_label\" ng-show=\"nonEditableData.email\">Email:</span><span class=\"value\" ng-show=\"nonEditableData.email\">{{nonEditableData.email}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.contactNumber1\"><span class=\"row-label\" translate=\"_contact_number_1\" ng-show=\"nonEditableData.contactNumber1\">Contact Number 1:</span><span class=\"value\" ng-show=\"nonEditableData.contactNumber1\" type=\"text\">{{::nonEditableData.contactNumber1 | ute_common_filter_phone4_masked}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.contactNumber2\"><span class=\"row-label\" translate=\"_contact_number_2\" ng-show=\"nonEditableData.contactNumber2\">Contact Number 2:</span><span show-when=\"fr\"></span><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.contactNumber2\">{{::nonEditableData.contactNumber2 | ute_common_filter_phone4_masked}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.extension\"><span class=\"row-label\" translate=\"_ext\" ng-show=\"nonEditableData.extension\">Ext:</span><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.extension\">{{nonEditableData.extension}}</span></div><div class=\"non-editable-row\" ng-show=\"nonEditableData.language\"><span class=\"row-label\" translate=\"_lang\" ng-show=\"nonEditableData.language\">Language</span><span class=\"value\" type=\"text\" ng-show=\"nonEditableData.language\">{{nonEditableData.language}}</span></div></div>");
$templateCache.put("scripts/directives/editableContent/contactInformation/contactinformationform.html","<form name=\"updateEmailForm\" form-locator=\"\" novalidate=\"\" adl-event-track=\'{\"mappingKey\":\"edit-contact-information,event.selfServeStart\"}\'><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span translate=\"_email_ppc\">Email:</span><div class=\"inline_error\" ng-if=\"updateEmailForm.Email.$error.pattern\" adl-error-track=\'{\"mappingKey\":\"edit-contact-information\",\"field\":\"email\"}\'><span translate=\"email_validation\"></span></div><input type=\"email\" name=\"Email\" required=\"\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" ng-model=\"editableData.email\" ng-change=\"checkIfPreviousEmail()\"></div></div><div class=\"editable-row row\" ng-if=\"updateEmailForm.Email.$dirty && updateEmailForm.Email.$valid && isNotPreviousEmail\"><div class=\"col-md-6\"><span translate=\"_email_confirm\">Confirm Email:</span><div class=\"inline_error\" ng-messages=\"updateEmailForm.confirmEmail.$error\" ng-if=\"updateEmailForm.confirmEmail.$invalid && updateEmailForm.confirmEmail.$dirty\" adl-error-track=\'{\"mappingKey\":\"edit-contact-information\",\"field\":\"confirm email\"}\'><span translate=\"_email_not_matched\"></span></div><input type=\"email\" name=\"confirmEmail\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" ng-model=\"editableData.emailconfirmation\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" compare-to=\"editableData.email\" ng-required=\"updateEmailForm.Email.$touched\"></div></div><div class=\"editable-row row\"><div class=\"col-md-6 col-lg-6\"><div class=\"button-container-email-update\"><button ng-disabled=\"!(updateEmailForm.$dirty && updateEmailForm.$valid && isNotPreviousEmail)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :updateEmailForm.$pristine }\" ng-click=\"isNotPreviousEmail && updateEmail(updateEmailForm)\"><img class=\"inline-loader\" src=\"ute-common-assets/assets/widget-loader.gif\" ng-show=\"updatingBillingType\"><span class=\"inline-loader-button-label\" translate=\"_save_changes\"></span></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" translate=\"_cancel\"></button></div></div></div></form><form name=\"form\" novalidate=\"\" form-locator=\"\"><div class=\"gray-border-selfserve small-margin-bottom no-margin-top col-md-6\"></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-3\"><span translate=\"_contact_number_1\"></span><div class=\"inline_error\" ng-if=\"form.ContactNumber1.$error.pattern || form.ContactNumber1.$error.required\" adl-error-track=\'{\"mappingKey\":\"edit-contact-information\",\"field\":\"contact number 1\"}\'><span translate=\"contact_number_1_validation\"></span></div><input type=\"text\" name=\"ContactNumber1\" maxlength=\"10\" ng-model=\"editableData.contactNumber1\" ng-click=\"editableData.contactNumber1 = \'\'\" autocomplete=\"off\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" ng-pattern=\"/[0-9]{1}(•){5}[0-9]{4}|[0-9]{10}/\" ng-change=\"checkIfPreviousContactInfo()\" required=\"\"></div></div><div class=\"editable-row row\"><div class=\"col-md-6\"><div class=\"col-xs-12 col-md-6\"><span translate=\"_contact_number_2\"></span><div class=\"inline_error hidden-xs hidden-sm hidden-md\" ng-if=\"form.ContactNumber2.$error.required || form.ContactNumber2.$error.pattern || form.Extension.$error.pattern\" adl-error-track=\'{\"mappingKey\":\"edit-contact-information\",\"field\":\"contact number 2\"}\'><span translate=\"contact_number_2_validation\"></span></div><div class=\"col-md-12\"><div class=\"inline_error hidden-lg\" ng-if=\"form.ContactNumber2.$error.required || form.ContactNumber2.$error.pattern || form.Extension.$error.pattern\"><span translate=\"contact_number_2_validation\"></span></div><input type=\"text\" name=\"ContactNumber2\" maxlength=\"10\" ng-pattern=\"/[0-9]{1}(•){5}[0-9]{4}|[0-9]{10}/\" ng-model=\"editableData.contactNumber2\" ng-click=\"editableData.contactNumber2 = \'\'\" autocomplete=\"off\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" ng-change=\"checkIfPreviousContactInfo()\" ng-required=\"editableData.extension\"></div></div><div class=\"col-xs-12 col-md-2 extension\"><span translate=\"_extension\"></span><div class=\"col-md-12\"><div class=\"inline_error hidden-lg\" ng-if=\"form.Extension.$error.pattern\" adl-error-track=\'{\"mappingKey\":\"edit-contact-information\",\"field\":\"extension\"}\'><span translate=\"contact_number_2_extension_validation\"></span></div><input type=\"text\" name=\"Extension\" maxlength=\"4\" ng-model=\"editableData.extension\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" ng-change=\"checkIfPreviousContactInfo()\" ng-pattern=\"/^[0-9]{1,5}$/\"></div></div></div></div><div class=\"editable-row row\" style=\"clear:both\"><div class=\"col-md-6\"><span translate=\"_lang\">Language:</span><div class=\"checkbox-line english\"><label><input type=\"radio\" value=\"EN\" name=\"language\" class=\"rogers-checkbox billing\" ng-model=\"editableData.language\" ng-true-value=\"\'EN\'\" ng-change=\"checkIfPreviousContactInfo()\"> <span class=\"selfserve-checkbox-label\" translate=\"_english\">English</span></label></div><div class=\"checkbox-line french\"><label><input type=\"radio\" value=\"FR\" name=\"language\" class=\"rogers-checkbox billing paper\" ng-model=\"editableData.language\" ng-true-value=\"\'FR\'\" ng-change=\"checkIfPreviousContactInfo()\"> <span class=\"selfserve-checkbox-label\" translate=\"_french\">French</span></label></div></div></div><div class=\"col-md-6 billing-btn-ctn\"><button ng-disabled=\"!(form.$dirty && form.$valid && isNotPreviousContactInfo)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :form.$pristine }\" ng-click=\"isNotPreviousContactInfo && saveChanges(form)\" translate=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" translate=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketingPermissionsSmall.html","<div class=\"marketing-permissions-small\"><div class=\"col-sm-10\"><p class=\"inline\" translate=\"let_us_know_how_you\"></p><img src=\"images/blueicon-with-text.png\" alt=\"info\" class=\"info-icon\" ng-click=\"openModal()\"></div><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (wirelessExpanded = !wirelessExpanded)\"><span translate=\"wireless\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"wirelessExpanded\" class=\"plus-sign\">+</div><div ng-show=\"wirelessExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"wirelessExpanded\" class=\"marketing-options\" id=\"expandWireless\"><td class=\"checkbox-ctn\"></td><li ng-repeat=\"marketingChannel in marketingChannels track by $index\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'WIRELESS\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (tvExpanded = !tvExpanded)\"><span translate=\"tv\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"tvExpanded\" class=\"plus-sign\">+</div><div ng-show=\"tvExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"tvExpanded\" class=\"marketing-options\" id=\"expandTv\"><li ng-repeat=\"marketingChannel in marketingChannels track by $index\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'CABLE\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (internetExpanded = !internetExpanded)\"><span translate=\"_internet\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"internetExpanded\" class=\"plus-sign\">+</div><div ng-show=\"internetExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"internetExpanded\" class=\"marketing-options\" id=\"expandInternet\"><li ng-repeat=\"marketingChannel in marketingChannels track by $index\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'INTERNET\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul><ul class=\"col-sm-12 marketing-ctn\"><li class=\"marketing-heading\" ng-click=\"!isEditOpen() && (homePhoneExpanded = !homePhoneExpanded)\"><span translate=\"rogers_home_phone\"></span><div class=\"details-button\" ng-class=\"{clickable: !isEditOpen()}\"><div ng-hide=\"homePhoneExpanded\" class=\"plus-sign\">+</div><div ng-show=\"homePhoneExpanded\" class=\"minus-sign\"></div></div></li><ul ng-show=\"homePhoneExpanded\" class=\"marketing-options\" id=\"expandHomePhone\"><li ng-repeat=\"marketingChannel in marketingChannels track by $index\"><span class=\"bold yes-no\">{{getYesNo(nonEditableData[\'HOME PHONE\'][marketingChannel.id])}}</span> <span class=\"channel-name\">{{getResource(marketingChannel.resource)}}</span></li></ul></ul></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketingPermissionsSmallForm.html","<div class=\"marketing-permissions-small\"><p>Let us know how you\'d like to be contacted</p><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandWireless\" aria-expanded=\"false\" aria-controls=\"expandWireless\"><span>Wireless</span><details-button expanded=\"detailsExpanded\"></details-button></li><ul class=\"collapse marketing-options\" id=\"expandWireless\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.wireless\" ng-click=\"alert(\'HI\')\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.wireless\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.wireless\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.wireless\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedWireless\" ng-change=\"clearSelections(\'wireless\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"wirelessCopySelection\" ng-change=\"copySelections()\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandTv\" aria-expanded=\"false\" aria-controls=\"expandTv\"><span>TV</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandTv\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.cable\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.cable\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.cable\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.cable\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedCable\" ng-change=\"clearSelections(\'cable\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"cableCopySelection\" ng-change=\"copySelections()\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandInternet\" aria-expanded=\"false\" aria-controls=\"expandInternet\"><span>Internet</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandInternet\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.internet\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.internet\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.internet\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.internet\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedInternet\" ng-change=\"clearSelections(\'internet\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandHomePhone\" aria-expanded=\"false\" aria-controls=\"expandHomePhone\"><span>Rogers Home Phone</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandHomePhone\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.homephone\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homephone\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homephone\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homephone\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedHomePhone\" ng-change=\"clearSelections(\'homephone\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul><ul class=\"col-sm-12\"><li class=\"marketing-heading\" data-toggle=\"collapse\" href=\"#expandHomeMonitoring\" aria-expanded=\"false\" aria-controls=\"expandHomeMonitoring\"><span>Smart Home Monitoring</span><details-button></details-button></li><ul class=\"collapse marketing-options\" id=\"expandHomeMonitoring\"><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.EMAIL.Permissions.homemonitoring\"><span>Email</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homemonitoring\"><span>Direct Mail</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homemonitoring\"><span>Telemarketing</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homemonitoring\"><span>Text messages</span></li><li><input type=\"checkbox\" class=\"rogers-checkbox\" ng-model=\"clearSelectedHomeMonitoring\" ng-change=\"clearSelections(\'homemonitoring\')\"><span>None</span></li><li class=\"bottom-border\"></li><li><input type=\"checkbox\" class=\"rogers-checkbox\"><span>Apply these settings to all services</span></li></ul></ul></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketinginformation.html","<div class=\"marketing-permissions\"><div class=\"col-md-12 col-lg-12\"><p class=\"let-us-know\" translate=\"let_us_know_how_you\"></p><img src=\"images/blueicon-with-text.png\" alt=\"info\" class=\"info-icon\" style=\"display: inline;\" ng-click=\"openModal()\"></div><div class=\"col-md-12 col-lg-12\"><table><tr class=\"columns\"><td class=\"left-border\"></td><td ng-repeat=\"marketingChannel in marketingChannels track by $index\">{{getResource(marketingChannel.resource)}}</td></tr><tr class=\"filler-height\"></tr><tr ng-repeat=\"productCategory in productCategories track by $index\" class=\"bottom-border\"><td class=\"category first-category\">{{getResource(productCategory.resource)}}</td><td class=\"checkbox-ctn\" ng-repeat=\"marketingChannel in marketingChannels track by $index\">{{getYesNo(nonEditableData[productCategory.id][marketingChannel.id])}}</td></tr></table></div></div>");
$templateCache.put("scripts/directives/editableContent/marketingPermission/marketinginformationform.html","<div class=\"marketing-permissions\" disable-whiteout=\"\"><p translate=\"editableDataSubheading\">Let us know how you\'d like to be contacted</p><table><tr class=\"columns\"><td class=\"left-border\"></td><td class=\"email-column-heading\">Email</td><td>Direct Mail</td><td>Telemarketing</td><td>Text messages</td><td class=\"right-border\">None</td></tr><tr class=\"filler-height\"></tr><tr><td class=\"category first-category\">Wireless</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.wireless\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_MAIL.Permissions.wireless\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.wireless\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.wireless\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedWireless\" ng-change=\"clearSelections(\'wireless\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">TV</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.cable\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_MAIL.cable\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.cable\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.cable\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedCable\" ng-change=\"clearSelections(\'cable\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Internet</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.internet\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.internet\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.internet\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.internet\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedInternet\" ng-change=\"clearSelections(\'internet\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Rogers Home Phone</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.homephone\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homephone\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homephone\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homephone\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedHomePhone\" ng-change=\"clearSelections(\'homephone\')\"></td></tr><tr class=\"bottom-border\"><td></td><td></td><td></td><td></td><td></td><td></td></tr><tr><td class=\"category\">Smart Home Monitoring</td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.EMAIL.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"editableData.DIRECT_EMAIL.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TELE_MARKETING.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox large-input-padding\" type=\"checkbox\" ng-model=\"editableData.TEXT_MESSAGING.Permissions.homemonitoring\"></td><td><input class=\"rogers-checkbox\" type=\"checkbox\" ng-model=\"clearSelectedHomeMonitoring\" ng-change=\"clearSelections(\'homemonitoring\')\"></td></tr></table></div>");
$templateCache.put("scripts/directives/editableContent/serviceAddress/serviceaddress.html","<div class=\"non-editable-row\"><span class=\"value\">{{nonEditableData.address}}</span></div>");
$templateCache.put("scripts/directives/editableContent/serviceAddress/serviceaddressform.html","<form novalidate=\"\"><div class=\"editable-row row\"><div class=\"col-md-6\"><span translate=\"_address\">Address</span> <label class=\"rel\"><input type=\"text\" ng-model=\"editableData.address\" required=\"\"></label></div></div></form>");
$templateCache.put("scripts/directives/editableContent/userAccount/usernameandpassword.html","<div class=\"non-editable-row\" ng-show=\"isConsumer || ((isCare || isDealer) && isProfileLoading)\"><span class=\"row-label nowrap\"><span translate=\"_username\">Username:</span></span> <span ng-show=\"!isGuidNotFound\" class=\"value\">{{nonEditableData.userName}}</span> <input ng-show=\"isGuidNotFound\" class=\"value\" type=\"password\" ng-value=\"12345678\" readonly=\"\"></div><div class=\"non-editable-row\" ng-show=\"isConsumer || ((isCare || isDealer) && isProfileLoading)\"><span class=\"row-label nowrap\"><span translate=\"_password\">Password:</span></span> <input ng-hide=\"(isCare || isDealer)\" class=\"value\" type=\"password\" ng-value=\"123456\" readonly=\"\"> <input ng-show=\"(isCare || isDealer)\" class=\"value\" type=\"password\" ng-value=\"12345678\" readonly=\"\"></div><div class=\"non-editable-row\" ng-show=\"isConsumer || ((isCare || isDealer) && isProfileLoading)\"><span class=\"row-label nowrap\" translate=\"ReminderQuestion\">Reminder Question</span> <span ng-hide=\"(isCare || isDealer)\"><span class=\"value\" ng-show=\"nonEditableData.questionNo == 1\" translate=\"login_security_questions_1\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 2\" translate=\"login_security_questions_2\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 3\" translate=\"login_security_questions_3\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 4\" translate=\"login_security_questions_4\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 5\" translate=\"login_security_questions_5\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 6\" translate=\"login_security_questions_6\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 7\" translate=\"login_security_questions_7\"></span> <span class=\"value\" ng-show=\"nonEditableData.questionNo == 8\" translate=\"login_security_questions_8\"></span></span> <input ng-show=\"(isCare || isDealer)\" class=\"value\" type=\"password\" ng-value=\"12345678\" readonly=\"\"></div><div class=\"non-editable-row\" ng-show=\"isConsumer || ((isCare || isDealer) && isProfileLoading)\"><span class=\"row-label nowrap\" translate=\"ReminderAnswer\">Reminder Answer</span> <input ng-hide=\"(isCare || isDealer)\" type=\"password\" maxlength=\"250\" class=\"value reminder-answer\" ng-model=\"nonEditableData.answer\" readonly=\"\"> <input ng-show=\"(isCare || isDealer)\" type=\"password\" maxlength=\"250\" class=\"value reminder-answer\" ng-value=\"12345678\" readonly=\"\"></div>");
$templateCache.put("scripts/directives/editableContent/userAccount/usernameandpasswordform.html","<form name=\"form\" form-locator=\"\" novalidate=\"\" ng-submit=\"form.$valid && form.submit()\" method=\"post\"><div class=\"row info-banner error mts\" style=\"margin-left: 0px;\" data-ng-show=\"(!form.$valid && form.$submitted)\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div ng-if=\"form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 general-error\" style=\"float:left\"><span translate=\"general_error\"></span></div><div ng-if=\"form.errorMsg && !form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span translate=\"_check_form_errors\">{{form.errorMsg}}</span></div><div ng-if=\"!form.errorMsg && !form.generalError\" class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 no-padding\" style=\"float:left\"><span translate=\"_check_form_errors\"></span></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span translate=\"_username_no_col\">Username</span><span class=\"user-name\">{{editableData.userName}}</span></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span translate=\"OldPassword\">Old Password</span><div class=\"inline_error\" ng-show=\"form.$submitted && form.oldpasswordwrong && !form.oldPassword.$touched\"><span translate=\"registration_password_incorrect\"></span></div><div class=\"inline_error\" ng-show=\"form.oldPassword.$error.required\"><span translate=\"login_re_enter\"></span></div><input type=\"password\" ng-change=\"form.$setValidity(\'oldPassword\', true, form)\" name=\"oldPassword\" ng-model=\"editableData.oldPassword\" autocomplete=\"off\" ng-required=\"form.password.$touched && form.password.length > 0\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"></div></div><div class=\"editable-row row mbm new-password-section\"><div class=\"col-md-6\"><span translate=\"temp_password_dew_pass_field\">New Password</span><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"inline_error\" ng-messages=\"form.password.$error\" ng-show=\"form.password.$invalid && form.password.$dirty && form.confirmPassword !== \'\'\"><span ng-message=\"required\"><span translate=\"login_invalid_password\"></span></span><span ng-message=\"minlength\"><span translate=\"registration_too_short\"></span></span> <span ng-message=\"maxlength\"><span translate=\"registration_too_long\"></span></span> <span ng-message=\"pattern\"><span ng-if=\"isNumericOnly(form.password.$viewValue)\" translate=\"registration_number_only\"></span> <span ng-if=\"isAlphabetOnly(form.password.$viewValue)\" translate=\"registration_alphabet_only\"></span> <span ng-if=\"!isAlphanumeric(form.password.$viewValue)\" translate=\"registration_wrong_password\"></span></span> <span ng-message=\"match\"><span translate=\"registration_password_must_differ\"></span></span></div></div></div></div></div><label class=\"rel\"><input type=\"password\" ng-model=\"editableData.newPassword\" name=\"password\" maxlength=\"16\" minlength=\"7\" ng-required=\"form.password.$touched && form.password.$isEmpty()\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/\" autocorrect=\"off\" autocomplete=\"off\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" autocapitalize=\"off\" ng-change=\"editableData.checkPassword(form.password)\" match=\"form.oldPassword\" un-match=\"true\"> <span class=\"inline-checker icon-error rui-icon-error-icon\" data-ng-show=\"form.password.$dirty && form.password.$invalid\"></span> <i ng-show=\"form.password.$dirty && form.password.$valid\" class=\"inline-checker icon-checked\"></i></label><div class=\"col-md-12 col-lg-12\"><span translate=\"_confirm_new_password\">Confirm New Password</span><div class=\"inline_error\" ng-show=\"form.$submitted || form.confirmPassword.$touched\"><div ng-show=\"form.confirmPassword.$error.required\"><span translate=\"login_re_enter\"></span></div><div ng-show=\"form.confirmPassword.$error.match\"><span translate=\"_password_not_matched\"></span></div></div><label class=\"rel\"><input maxlength=\"16\" minlength=\"7\" ng-required=\"form.password.$touched && form.confirmPassword.$isEmpty()\" ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/\" type=\"password\" ng-model=\"editableData.confirmPassword\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" name=\"confirmPassword\" match=\"form.password\"> <span class=\"inline-checker icon-error rui-icon-error-icon\" data-ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"col-md-6 col-lg-6 new-password-right\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 password-guidelines\"><span class=\"password-guidelines-title\" translate=\"temp_password_guildeline\"></span> <span translate=\"temp_password_list_of_guildeline\"></span></div></div></div><div class=\"gray-border-selfserve small-margin-bottom small-margin-top col-md-6\" style=\"clear:both\"></div><div class=\"editable-row row mbm\" style=\"clear:both\" ng-hide=\"\"><div class=\"col-md-6\"><span translate=\"SecretQuestion\"></span><div class=\"inline_error\" ng-messages=\"form.ReminderQuestion.$error\"><div ng-message=\"required\"><span translate=\"secret_question_select\"></span></div></div><div rui-dropdown=\"\" class=\"rui-dropdown\" list=\"loginSecurityQuestions\" selected=\"selectedSecurityQuestion\" property=\"label\" select-action=\"selectSecurityQuestion(item)\" listen-for-language-change=\"true\"></div></div></div><div class=\"editable-row row mbm\"><div class=\"col-md-6\"><span translate=\"_answer\">Answer:</span><div class=\"inline_error\" ng-show=\"(form.SecretAnswer.$error.pattern || form.SecretAnswer.$error.required) && form.SecretAnswer.$dirty\"><div><span translate=\"secret_answer_validation\">Please answer your password reminder question. Your answer can contain letters, numbers, and special characters.</span></div></div><input type=\"text\" name=\"SecretAnswer\" ng-model=\"editableData.answer\" maxlength=\"200\" ng-required=\"form.SecretAnswer.$touched\" ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\"></div></div><div class=\"col-md-6 billing-btn-ctn\"><button ng-disabled=\"!(form.$valid && form.$dirty)\" class=\"save-changes cta-round primary large\" ng-class=\"{ inactive :form.$pristine }\" ng-click=\"saveChanges(form)\" translate=\"_save_changes\"></button> <button class=\"cancel cta-round tertiary large\" ng-click=\"cancel()\" translate=\"_cancel\"></button></div></form>");
$templateCache.put("scripts/directives/hup/deviceBalance/checkBalancePopup.html","<section class=\"wirelessDashPopup\"><div class=\"row\"><div class=\"col-lg-1 col-md-1 col-sm-1 col-xs-2 error_logo_margin\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-lg-4 col-md-4 col-sm-4 col-sm-offset-1 col-xs-4 sorry_error\"><span translate=\"sorry_error\"></span></div><ute-user-if-any-granted data-roles=\"care,dealer\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 wireless_error_content\"><span translate=\"wireless_checkBalance_error_care\"></span></div></ute-user-if-any-granted><ute-user-if-any-granted data-roles=\"consumer\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 wireless_error_content\"><span translate=\"wireless_checkBalance_error\"></span></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 phone_icon_parent\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 live_chat_icon\"><img class=\"live_chat_icon_img\" src=\"images/wirelessDash-popup_live_chat_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 live_chat_text\"><div class=\"live-chat-link\" target=\"_blank\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&amp;lctc=707%7C01%7Cws%7CHUP_landing%20en\" translate=\"mu_chat\" target=\"_blank\" ng-show=\"vm.lng === \'en\'\"></a> <a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr\" translate=\"mu_chat\" target=\"_blank\" ng-show=\"vm.lng === \'fr\'\"></a></div></div></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 phone_icon_parent\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 phone_icon\"><img class=\"phone_icon_img\" src=\"images/wirelessDash-popup_phone_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 phone_number_value\" translate=\"check_balance_toll_number\"></div></div></ute-user-if-any-granted><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 col-sm-offset-0 col-xs-offset-4 wireless_error_content\"><button type=\"button\" class=\"btn btn-primary btn-md button_close\" ng-click=\"closeThisDialog()\"><span translate=\"close\"></span></button></div></div></section>");
$templateCache.put("scripts/directives/hup/deviceBalance/wirelessDashPopup.html","<section class=\"wirelessDashPopup\"><div class=\"row\"><div class=\"col-sm-1 col-xs-2\" ng-if=\"!isBOTEligible\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-sm-10 col-sm-push-1 col-xs-10 sorry_error\" ng-if=\"!isBOTEligible\"><span translate=\"sorry_error\"></span></div><div class=\"bot-header\" ng-if=\"isBOTEligible\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\" ng-if=\"isBOTEligible && !isCaseClosed\"> <img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/green-checkbox.png\" ng-if=\"isBOTEligible && isCaseClosed\"> <span translate=\"hup_processed_error\" ng-if=\"isBOTEligible && !isCaseClosed\"></span> <span translate=\"case_success\" ng-if=\"isBOTEligible && isCaseClosed\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 wireless_error_content bot-content\" ng-hide=\"hupDetails.isMakePaymentAvailable\" data-ng-bind-html=\"hupDetails.errorMessage\"></div><div class=\"col-xs-12 wireless_error_content bot-content\" ng-show=\"hupDetails.isMakePaymentAvailable\"><span data-ng-bind-html=\"hupDetails.first\"></span> <a class=\"link-cancel pointer\" data-ng-click=\"payBill()\" tabindex=\"-1\"><span translate=\"hup_make_a_payment\"></span></a> <span data-ng-bind-html=\"hupDetails.last\"></span></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 phone_icon_parent\" ng-if=\"isConsumer\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 phone_icon\"><img class=\"phone_icon_img\" src=\"images/wirelessDash-popup_phone_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 phone_number_value\"><a href=\"tel:{{hupDetails.contactNumber}}\">{{hupDetails.contactNumber}}</a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 phone_icon_parent\" ng-if=\"hupDetails.nfdb != \'NFDB\' && isConsumer\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 live_chat_icon\"><img class=\"live_chat_icon_img\" src=\"images/wirelessDash-popup_live_chat_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 live_chat_text\"><div class=\"live-chat-link\" ng-show=\"lng === \'en\'\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&amp;lctc=707%7C01%7Cws%7CHUP_landing%20en\" translate=\"mu_chat\" target=\"_blank\"></a></div><div class=\"live-chat-link\" ng-show=\"lng === \'fr\'\" target=\"_blank\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr\" translate=\"mu_chat\" target=\"_blank\"></a></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 col-sm-offset-0 col-xs-offset-4 button-section bot-button-section\"><button type=\"button\" class=\"btn btn-primary btn-md button_close\" ng-click=\"wirelessDashPopupclose()\" ng-if=\"!isBOTEligible\"><span translate=\"close\"></span></button><button adl-event-track=\'{\"mappingKey\":\"hup-sent-to-bot,event.selfServeStart\"}\' name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"cancelCase()\" ng-if=\"isBOTEligible && !isCaseClosed\"><span translate=\"yes_change_hup\"></span></button> <button adl-event-track=\'{\"mappingKey\":\"hup-sent-to-bot,event.selfServeComplete\"}\' name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"proceedWithHUP()\" ng-if=\"isBOTEligible && isCaseClosed\"><span translate=\"proceed_hup\"></span></button><a href=\"\" ng-click=\"wirelessDashPopupclose()\" ng-if=\"isBOTEligible && !isCaseClosed\" translate=\"modified_hup_wait_complete\" class=\"bot-status\"></a></div></div></section>");
$templateCache.put("scripts/directives/widgets/details-button/details-button.html","<div class=\"details-button clickable\" ng-class=\"{\'expanded\': expanded}\" ng-click=\"handleClick(); expanded = !expanded\" atm=\"ppc_choose_a_plan_details_{{buttonId}}\"><div ng-if=\"!expanded\" class=\"plus-sign\">+</div><div ng-if=\"expanded\" class=\"minus-sign\"></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/rogersGeoTextModal.html","<div class=\"modal-header\"><h5 class=\"link-account-title\" translate=\"ute.rogers.wireless.geotxt_access_modal_title\"></h5><button type=\"button\" class=\"btn_close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.cancel()\">&times;</button></div><div class=\"modal-body\"><p class=\"intro\" translate=\"ute.rogers.wireless.geotxt_access_modal_intro\"></p><div class=\"learn_more_section\"><span class=\"btn_opener\"><span data-ng-click=\"vm.toggleTooltip()\" data-ng-class=\"vm.showMoreOptions ? \'rogers-icon-chevron-up\' : \'rogers-icon-chevron-down\'\" class=\"opener-icon\"></span> <span data-ng-click=\"vm.toggleTooltip()\" class=\"opener-text\" translate=\"ute.rogers.wireless.geotxt_access_modal_cta_learnMore\"></span></span><div class=\"showMoreOptions_holder\" data-ng-if=\"vm.showMoreOptions\"><p translate=\"ute.rogers.wireless.geotxt_access_modal_learnMore_desc\"></p><ul class=\"learn_more_list\"><li translate=\"ute.rogers.wireless.geotxt_access_modal_learnMore_option1\"></li><li translate=\"ute.rogers.wireless.geotxt_access_modal_learnMore_option3\"></li><li translate=\"ute.rogers.wireless.geotxt_access_modal_learnMore_option2\"></li><li translate=\"ute.rogers.wireless.geotxt_access_modal_learnMore_option4\"></li></ul></div></div><div class=\"cta_holder\"><div data-ng-click=\"vm.redirectToRogersGeoAuth(\'https://rogersgeotxt.ca/sho/rogers/sign-in.html\')\" class=\"cta ute-md-secondary-button\" translate=\"ute.rogers.wireless.geotxt_access_modal_cta_sigIn\"></div><div data-ng-click=\"vm.redirectToRogersGeoAuth(\'https://rogersgeotxt.ca/sho/rogers/register.html\')\" class=\"cta ute-md-primary-button\" translate=\"ute.rogers.wireless.geotxt_access_modal_cta_register\"></div></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/wirelessDevice.html","<div class=\"wd-card-container wd-right-card\" id=\"rogers-device\"><div class=\"wd-card-heading-section\"><div class=\"wd-card-heading\" translate=\"wireless_manage-device\" data-test-id=\"myr-wirelessPackage-wireless_manage-device\"></div><div class=\"wd-card-subheading\" ng-if=\"wpController.wpkg_client.deviceName\"><span ng-if=\"wpController.lng !== \'fr\'\" ng-bind-html=\"wpController.wpkg_client.deviceName\"></span> <span ng-if=\"wpController.lng === \'fr\'\" ng-bind-html=\"wpController.wpkg_client.deviceNameFr\"></span></div><div class=\"wd-details-link\"></div></div><div ng-show=\"wpController.isUFA\"><div class=\"wd-warning-alert-first\" ng-show=\"wpController.isUpFrontRvAmount && wpController.ufaWarning === \'warning-1\'\"><span><img class=\"wd-warning-alert-icon\" src=\"images/info.svg\" alt=\"{{\'ute.rogers.wireless.warning_alt_tag\' | translate}}\"></span> <span class=\"wd-warning-alert-text\"><span translate=\"ute.rogers.wireless.warning_rv_amount_content\"></span> <span class=\"wd-warning-alert-text-date\">{{wpController.balanceObj.ufa.rvExpectedReturnDate | date:\'MMM d, y\'}}<ins class=\"wd-warning-alert-text-end\">.</ins></span> <span translate=\"ute.rogers.wireless.warning_rv_amount_content_sec\"></span> <span class=\"wd-warning-alert-text-date\">{{wpController.balanceObj.ufa.rvAmount | currency}}<ins class=\"wd-warning-alert-text-end\">.</ins></span></span></div><div class=\"wd-warning-alert-second\" ng-show=\"wpController.isUpFrontRvAmount && wpController.ufaWarning === \'warning-2\'\"><span><img class=\"wd-warning-alert-icon\" src=\"images/info.svg\" alt=\"{{\'ute.rogers.wireless.warning_alt_tag\' | translate}}\"></span> <span class=\"wd-warning-alert-text\"><span translate=\"ute.rogers.wireless.warning_rv_amount_content\"></span> <span class=\"wd-warning-alert-text-date\">{{wpController.balanceObj.ufa.rvExpectedReturnDate | date:\'MMM d, y\'}}<ins class=\"wd-warning-alert-text-end\">.</ins></span> <span translate=\"ute.rogers.wireless.warning_two_rv_amount_content\"></span> <span class=\"wd-warning-alert-text-date\">{{wpController.balanceObj.ufa.rvAmount | currency}}</span> <span translate=\"ute.rogers.wireless.warning_two_rv_amount_content_sec\"></span></span></div></div><div class=\"wd-card-dark-section\"><div class=\"wd-device-balance-heading\" data-test-id=\"myr-wirelessPackage-device_balance_today_checkBalance\"><span translate=\"ute.rogers.wireless.balance\"></span> <span ng-show=\"!wpController.isUpFrontRvAmount\" translate=\"ute.rogers.wireless.balanceToday\" class=\"wd-device-balance-heading-sub\"></span> <span ng-show=\"wpController.isUpFrontRvAmount\" translate=\"ute.rogers.wireless.exUpfrontAmount\" class=\"wd-device-balance-heading-sub\" style=\"font-weight: 500\"></span> <span ng-show=\"wpController.rvCustomer\" class=\"wd-tootTip\" ng-click=\"showToolTip=!showToolTip\" style=\"outline: none;\"><img class=\"wd-info-icon\" src=\"images/info_notice_lg.png\" alt=\"\"><div ng-show=\"showToolTip\" class=\"wd-warning-tooltip_box\" translate=\"ute.rogers.wireless.warning_alert_tooltip\"></div></span></div><div class=\"wd-phone-img hidden-xs\"><img data-ng-src=\"{{wpController.wpkg_wd.postPaidPhoneDetails.phoneImageProcessed}}\" alt=\"phone\"></div><div class=\"wd-card-amount wd-widget-loader\" data-ng-if=\"wpController.checkBalanceloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div class=\"wd-card-amount\" ng-cloak=\"\" ng-if=\"!wpController.checkBalanceloadingIndicator\"><sup class=\"wd-sup-dollar-en\">$</sup> <span ng-if=\"wpController.balanceObj.subsidyBalanceSplit[0]\">{{::wpController.balanceObj.subsidyBalanceSplit[0]}}</span> <span ng-if=\"::!wpController.balanceObj.subsidyBalanceSplit[0]\">0</span> <sup ng-if=\"::wpController.balanceObj.subsidyBalanceSplit[1]\" class=\"wd-sup-cents\"><sup class=\"wd-sup-price-en\">.</sup> <sup class=\"wd-sup-price-fr\">,</sup> {{wpController.balanceObj.subsidyBalanceSplit[1] | number:2 | limitTo:-2}}</sup> <sup ng-if=\"::!wpController.balanceObj.subsidyBalanceSplit[1]\" class=\"wd-sup-cents\"><sup class=\"wd-sup-price-en\">.</sup> <sup class=\"wd-sup-price-fr\">,</sup> 00</sup> <sup class=\"wd-sup-dollar-fr\">$</sup></div><div ng-if=\"wpController.rvCustomer\" class=\"wd-rv-customer-cost-excluded\" translate=\"wireless_dashboard_rv_customer_cost_excluded\"></div><div ng-class=\"(wpController.rvCustomer) ? \'wd-rv-device-info-link\' : \'wd-device-info-link\'\" info=\"wpController.deviceInfoModal\" ng-if=\"wpController.showDeviceDetails()\" info-dialog-modal=\"\" analytics-key=\"deviceDetails\" rv-customer-info=\"wpController.rvCustomerModalInfo\" is-share-everything=\"{{wpController.isShareEverything()}}\" template-html=\"{{ wpController.infoModalPaths[0] }}\" tabindex=\"0\" role=\"link\"><span translate=\"ute.rogers.wireless.viewDetails\"></span></div><div ng-class=\"\'wd-device-info-link\'\" info=\"wpController.deviceInfoModal\" ng-if=\"wpController.showFinancedDeviceDetails()\" info-dialog-modal=\"\" analytics-key=\"deviceDetails\" is-share-everything=\"{{wpController.isShareEverything()}}\" template-html=\"{{ wpController.infoModalPaths[2] }}\" tabindex=\"0\" role=\"link\"><span translate=\"ute.rogers.wireless.viewDetails\"></span></div><div ng-if=\"wpController.balanceObj.subsidyEndDate\" ng-class=\"(wpController.rvCustomer) ? \'rv-customer-device-eligiblity\' : \'\'\"><div class=\"wd-device-eligiblity\"><span ng-if=\"!wpController.rvCustomer\" translate=\"device_balance_will_be/was\"></span> <span ng-if=\"wpController.rvCustomer\" class=\"wd-rv-customer-message-balance\" translate=\"wireless_dashboard_rv_customer_message\"></span></div><div class=\"wd-device-eligiblity-date\"><span translate=\"zero_dollar_on\"></span> <span>{{wpController.balanceObj.subsidyEndDate | date:\'MMM dd, yyyy\'}}</span></div></div><div ng-if=\"wpController.rvCustomer\" class=\"col-xs-12 wd-rv-customer-upfront-message\" ng-class=\"(!wpController.balanceObj.subsidyEndDate)? \'wd-rv-no-subsidy-wrap\':\'\'\"><span class=\"wd-rv-customer-message\" translate=\"wireless_dashboard_rv_customer_message_one\"></span></div><div ng-show=\"wpController.isUpFrontRvAmount\" class=\"col-xs-12 wd-rv-customer-upfront-message\"><span translate=\"wireless_dashboard_rv_amount_message\"></span> <span><strong style=\"font-weight: 600\">{{wpController.balanceObj.ufa.rvAmount | currency}}</strong></span></div><div class=\"visible-xs\" style=\"padding-top:35px\" ng-if=\"!wpController.balanceObj.subsidyEndDate && !wpController.rvCustomer\"></div><div data-ng-if=\"wpController.isConsumer || wpController.isDealer || (wpController.isCare && wpController.repHupAccess)\"><div ng-if=\"!wpController.hasTargetedHupOffer\" ng-class=\"{\'no-pointer\': (wpController.isDealer && wpController.hupDisabled)}\" ng-click=\"(wpController.isConsumer || (wpController.isCare && wpController.repHupAccess) || (wpController.isDealer && !wpController.hupDisabled)) ? wpController.upgradeDevice() : \'\'\" class=\"wd-upgrade-device-button\"><span translate=\"wireless_manage-device_upgrade-device\" class=\"plan-cta-text\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_upgrade-device\"></span></div><div class=\"exclusive-offer-section\" ng-if=\"wpController.hasTargetedHupOffer\"><div class=\"row\"><div ng-class=\"{\'height60px\' : wpController.lng === \'fr\'}\" class=\"exclusive-offer-banner col-md-3 col-xs-6\"><div ng-class=\"{\'offer-font-fr\' : wpController.lng === \'fr\'}\" class=\"offer-font\" translate=\"offers_for_you\"></div></div><div ng-click=\"(wpController.isConsumer) ? wpController.openTargetedHeroOffersModal() : \'\'\" ng-class=\"{\'height60px\' : wpController.lng === \'fr\' , \'paddingTop3\': wpController.lng === \'en\'}\" class=\"exclusive-offer-nav col-md-4 col-xs-5\"><div class=\"exclusive-offer-link\"><span translate=\"upgrade_your_device\"></span> <i class=\"rui-icon-arrow-right\"></i></div></div></div></div><span class=\"wd-widget-loader\" ng-if=\"wpController.upgradeDeviceObjloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"wd-card-rep-cta-link\" ng-if=\"wpController.isCare && !wpController.repHupAccess\"><span translate=\"ute.rogers.wireless.toUpgradeDevice\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.telli\"></span></div><div ng-if=\"wpController.isHupFlowProcessSaved && (!wpController.isCare || wpController.repHupAccess)\"><div class=\"wd-device-hup-continue\"><div ng-click=\"wpController.openHUP()\" ng-keydown=\"($event.which === 13)?wpController.openHUP():0\" ng-if=\"wpController.isFetchOrderCompleted()\"><span><div class=\"wd-device-hup-continue-icon\"><span class=\"rui-icon-info\"></span></div><span translate=\"hup_have_saved_order\"></span></span> <span translate=\"_continue\"></span> <i class=\"rui-icon-arrow-right\"></i></div><span class=\"wd-widget-loader\" ng-if=\"wpController.restoreCartloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div><div class=\"wd-card-feature-links\"><div ng-if=\"!wpController.isCare\" class=\"wd-feature-link\"><span class=\"wd-sim-link\" ng-click=\"wpController.goToChangeSimCard()\" ng-keydown=\"($event.which === 13)?wpController.goToChangeSimCard():0\" tabindex=\"0\" role=\"link\"><span ng-if=\"wpController.isConsumer || ((wpController.isDealer) && !wpController.isRepView)\" class=\"lnk-txt\" translate=\"wireless_manage-plan_change-sim\"></span> <span ng-if=\"((wpController.isDealer) && wpController.isRepView)\" class=\"lnk-txt\" translate=\"change_sim\"></span> <i class=\"rui-icon-arrow-right\"></i></span></div><div ng-if=\"wpController.isCare && (wpController.repChangeSIMUpdate)\" class=\"wd-feature-link\"><span ng-if=\"wpController.repChangeSIMUpdate\" class=\"wd-sim-link\" ng-click=\"wpController.goToChangeSimCard()\" ng-keydown=\"($event.which === 13)?wpController.goToChangeSimCard():0\" tabindex=\"0\" role=\"link\"><span ng-if=\"((wpController.isCare) && !wpController.isRepView)\" class=\"lnk-txt\" translate=\"wireless_manage-plan_change-sim\"></span> <span ng-if=\"((wpController.isCare) && wpController.isRepView)\" class=\"lnk-txt\" translate=\"change_sim\"></span> <i class=\"rui-icon-arrow-right\"></i></span></div><div ng-if=\"wpController.isCare && (wpController.repChangeSIMRead && !wpController.repChangeSIMUpdate)\" class=\"changesim-disabled-link wd-feature-link\"><span ng-if=\"((wpController.isCare) && !wpController.isRepView)\" translate=\"wireless_manage-plan_change-sim\"></span> <span ng-if=\"((wpController.isCare) && wpController.isRepView)\" translate=\"change_sim\"></span> <i class=\"rui-icon-arrow-right\"></i></div><div class=\"wd-feature-link\"><a href=\"/customer/support/article/unlocking-devices\"><span translate=\"ute.rogers.wireless.unlockMyDevice\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div><div class=\"wd-feature-link\" ng-if=\"!wpController.wpkg_client.planSuspended\"><a ng-if=\"::wpController.isConsumer\" ng-href=\"/web/myrogers/torcom/shopAccessories?setLanguage={{wpController.lng}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_shop-accessories\"><span translate=\"wireless_manage-device_shop-accessories\"></span> <i class=\"rui-icon-arrow-right\"></i></a> <a ng-if=\"::wpController.isCare || wpController.isDealer\" ng-href=\"/web/link/wirelessBuyFlow?forwardTo=AccessoryOnly&setLanguage={{wpController.lng}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_shop-accessories\"><span translate=\"wireless_manage-device_shop-accessories\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div><div class=\"wd-feature-link\" ng-class=\"::{\'no-pointer\':(wpController.isDealer || wpController.isCare)}\"><a ng-class=\"::{\'no-pointer\':(wpController.isDealer || wpController.isCare)}\" data-ng-disabled=\"(wpController.isDealer || wpController.isCare)\" ng-keypress=\"($event.which === 13) && (wpController.isDealer || wpController.isCare) ? \'\' : wpController.redirectToNrs()\" ng-click=\"(wpController.isDealer || wpController.isCare) ? \'\' : wpController.redirectToNrs()\" data-test-id=\"myr-wirelessPackage-wireless_manage_device_reserve\"><span translate=\"wireless_manage_device_reserve\"></span> <i class=\"rui-icon-arrow-right\"></i></a> <span class=\"wd-card-rep-cta-location new-line-arrow\" ng-if=\"(wpController.isDealer || wpController.isCare)\" translate=\"ute.rogers.wireless.myRogers\"></span></div><div ng-if=\"wpController.repairDeviceEnabled\" class=\"wd-feature-link\"><a ng-click=\"wpController.continueToRepairModal()\"><span translate=\"start_track_phone_repair\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/wirelessExtras.html","<div class=\"wd-extras-container col-xs-12\" id=\"rogers-extras\"><div ng-show=\"!wpController.isCare\" class=\"wd-extras-heading\" translate=\"ute.rogers.wireless.myExtras\"></div><div ng-show=\"!wpController.isCare\" class=\"extras-container\"><div class=\"extras_col\"><div class=\"wd-extras-img\"><img ng-src=\"images/value-added-offers/RogersGeo.png\" alt=\"Rogers GeoTxt\"></div><span title=\"{{\'ute.rogers.wireless.geotxt_extras_cta_title\' | translate}}\" data-ng-click=\"wpController.showRogersGeoTextPopUp()\"><span class=\"extras-listen-link\" translate=\"ute.rogers.wireless.geotxt_access\"></span></span></div></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/wirelessMobileLinks.html","<div class=\"wd-key-links-container\"><div class=\"wd-key-link\" ng-click=\"wpController.scrollToSection(\'rogers-plan\')\" translate=\"ute.rogers.wireless.rogersPlan\"></div><div class=\"wd-key-link\" ng-click=\"wpController.scrollToSection(\'rogers-device\')\" translate=\"ute.rogers.wireless.yourDevice\"></div><div class=\"wd-key-link\" ng-click=\"wpController.scrollToSection(\'rogers-support\')\" translate=\"ute.rogers.wireless.support\"></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/wirelessPlan.html","<div class=\"wd-card-container\" id=\"rogers-plan\"><div class=\"wd-card-heading-section\"><div class=\"wd-card-heading\" translate=\"wireless_manage-plan_wireless-package\"></div><div class=\"wd-card-subheading\"><span ng-if=\"wpController.lng === \'en\'\" data-test-id=\"myr-wirelessPackage-plan-amt-desc-en\">{{wpController.wpkg_wd.postPaidPhoneDetails.planDescription}}</span> <span ng-if=\"wpController.lng === \'fr\'\" data-test-id=\"myr-wirelessPackage-plan-amt-desc-fr\">{{wpController.wpkg_wd.postPaidPhoneDetails.planDescriptionFr}}</span> <span class=\"wd-card-planCode\" ng-if=\"(wpController.isCare || wpController.isDealer) && wpController.isRepView && wpController.wpkg_client.planCode\">({{ wpController.wpkg_client.planCode }})</span></div><div class=\"wd-details-link\" info-dialog-modal=\"\" analytics-key=\"planDetails\" info=\"wpController.planInfoModal\" is-share-everything=\"{{wpController.isShareEverything()}}\" template-html=\"{{ wpController.infoModalPaths[1] }}\" tabindex=\"0\" role=\"link\"><span translate=\"ute.rogers.wireless.viewDetails\"></span></div></div><div class=\"wd-card-dark-section\"><div class=\"wd-plan-name\"><div class=\"wd-plan-pool-info\" ng-if=\"wpController.showPoolingInfo\"><span ng-if=\"wpController.wpkg_client.isPooling\">{{wpController.wpkg_client.includedData[0][\"desc\"+ ((wpController.lng === \'fr\')?\'Fr\':\'\')] + wpController.wpkg_client.includedData[0][\"unit\"+ ((wpController.lng === \'fr\')?\'Fr\':\'\')] }}</span> <span ng-class=\"{fnormal: (wpController.wpkg_client.isPooling)}\">{{\'ute.rogers.wireless.plan_info.\'+ wpController.wpkg_wd.postPaidPhoneDetails.planType | translate }}</span></div><div ng-repeat=\"addon in wpController.wpkg_client.minutes\"><span>{{::addon}}</span></div></div><div class=\"rlh-container\"><div ng-if=\"wpController.wpkg_client.planMSF != 0\"><div ng-if=\"(wpController.isConsumer || !wpController.isRepView) && !wpController.hideWirelessTravelPackage && wpController.travelPackageDataHasPlan\"><div translate=\"ute.rogers.wireless.youGet\" class=\"wd-plan-rlh-lead\"></div><a href=\"/consumer/wireless/travel#roaming-map\"><div class=\"wd-plan-rlh\" translate=\"roam_like_home\"></div></a></div><div ng-if=\"(wpController.isCare && wpController.isRepView) && !wpController.hideWirelessTravelPackage\"><div class=\"wd-plan-rlh-ov\" ng-if=\"wpController.travelPackageDataHasPlan && wpController.unEnrollPermission\"><span translate=\"roam_like_home\"></span> <span translate=\"opt_out_rlh_enroll\" class=\"wd-plan-rlh\" ng-click=\"wpController.unEnrollPackageModal()\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"rlh-un-enroll,oneViewDashboard,event.selfServeStart\"}\'></span></div><div class=\"wd-plan-rlh-ov\" ng-if=\"!wpController.travelPackageDataHasPlan\"><span translate=\"roam_like_home\"></span> <span translate=\"activate_now\" class=\"wd-plan-rlh\" ng-click=\"wpController.openWirelesePackageModal()\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"rlh-activated,oneViewDashboard,event.selfServeStart\"}\'></span></div></div></div></div><div class=\"wd-card-amount\" ng-cloak=\"\"><sup class=\"wd-sup-dollar-en\">$</sup> <span>{{ wpController.wpkg_client.planMSF }}</span> <sup class=\"wd-sup-cents\"><sup class=\"wd-sup-price-en\">.</sup> <sup class=\"wd-sup-price-fr\">,</sup> 00</sup> <sub class=\"wd-sub-items\" translate=\"ute.rogers.wireless.mo\"></sub> <sup class=\"wd-sup-dollar-fr\">$</sup></div><div class=\"wd-talk-text-usage-link-package\" info-dialog-modal=\"\" analytics-key=\"talkTextUsage\" info=\"wpController.talkTextModalInfo\" is-share-everything=\"{{wpController.isShareEverything()}}\" template-html=\"{{ wpController.talkTextModalInfo.template }}\" tabindex=\"0\" role=\"link\" ng-click=\"wpController.wirelessDashboardCall()\" data-ng-class=\"{\'viewUsage-disable\': !wpController.isRefreshedDial()}\"><span translate=\"ute.rogers.wireless.talkTextLink\"></span></div><div><button data-ng-disabled=\"wpController.wpkg_client.planSuspended\" class=\"wd-change-plan-button\" ng-click=\"wpController.openPPC()\" data-test-id=\"myr-wirelessPackage-changePlanButton\" ng-if=\"wpController.isFetchOrderCompleted() && !wpController.isCare && !wpController.hasTargetedTvmOffer\"><span translate=\"internet_change\"></span></button><div class=\"exclusive-offer-section\" ng-if=\"wpController.hasTargetedTvmOffer\"><div class=\"row\"><div ng-class=\"{\'height60px\' : wpController.lng == \'fr\'}\" class=\"exclusive-offer-banner col-md-4 col-xs-6\"><div class=\"offer-font\" translate=\"offers_for_you\"></div></div><div ng-click=\"wpController.openTargetedHeroOffersModal()\" ng-class=\"{\'height60px\' : wpController.lng == \'fr\'}\" class=\"exclusive-offer-nav col-md-4 col-xs-5\"><div class=\"exclusive-offer-link\"><span translate=\"mppc_entry_3_change_wireless_plan\"></span> <i class=\"rui-icon-arrow-right\"></i></div></div></div></div><button ng-click=\"wpController.repPpcAccess && wpController.openPPC()\" class=\"wd-change-plan-button\" ng-if=\"wpController.isCare && wpController.repPpcAccess\"><span translate=\"internet_change\"></span></button><div class=\"wd-card-rep-cta-link\" ng-if=\"wpController.isCare && !wpController.repPpcAccess\"><span translate=\"ute.rogers.wireless.toChangePlan\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.telli\"></span></div><span class=\"wd-widget-loader\" ng-if=\"wpController.changeBtnLoading()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div ng-if=\"wpController.hasPPCOrder() && (!wpController.isCare || wpController.repPpcAccess)\"><div class=\"wd-device-hup-continue\"><div ng-click=\"wpController.openPPC(true)\" ng-keydown=\"($event.which === 13)?wpController.openPPC(true):0\" ng-if=\"wpController.isFetchOrderCompleted()\"><span><div class=\"wd-plan-ppc-continue-icon\"><span class=\"rui-icon-info\"></span></div><span translate=\"ppc_have_saved_order\"></span></span> <span translate=\"_continue\"></span> <i class=\"rui-icon-arrow-right\"></i></div><span class=\"wd-widget-loader\" ng-if=\"wpController.restoreCartloadingIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div><div class=\"wd-card-addons-section\"><div class=\"wd-card-addon-heading-container\"><div ng-if=\"::!wpController.wpkg_errorMessageWirelessPackage && wpController.isConsumer && !wpController.wpkg_client.planSuspended\" class=\"wd-add-manage-link\" ng-click=\"wpController.postToRogersAddOn()\" ng-keydown=\"($event.which === 13)?wpController.postToRogersAddOn():0\" role=\"link\"><span translate=\"wireless_uadd_new_addons\"></span> <i class=\"rui-icon-arrow-right\"></i></div><div class=\"wd-card-rep-cta\" ng-if=\"::wpController.isCare || wpController.isDealer\"><span translate=\"ute.rogers.wireless.toManageAddons\"></span> <span class=\"wd-card-rep-cta-location inline-arrow\" ng-if=\"::wpController.isCare || wpController.isDealer\" translate=\"ute.rogers.wireless.v21\"></span></div></div><div class=\"wd-card-addon-container\"><div ng-repeat=\"addon in wpController.wpkg_client.postPaidAddons\"><div ng-if=\"addon.addonMSF > 0 && $index != 0 && !wpController.isCare\"><div class=\"col-xs-9 wd-card-addon\"><span ng-if=\"wpController.lng == \'en\' || !addon.socDescFr\">{{addon.socDesc}}</span> <span ng-if=\"wpController.lng == \'fr\' && !!addon.socDescFr\">{{addon.socDescFr}}</span><div class=\"wd-card-addon-info\" ng-if=\"wpController.isConsumer && !wpController.isRepView && addon.expiryDate\"><span translate=\"expires\"></span> <span>{{::addon.expiryDate | date:\'MMM dd, yyyy\'}}</span></div><div class=\"wd-card-addon-info\" ng-if=\"(wpController.isCare || wpController.isDealer) && wpController.isRepView\"><div translate=\"ute.rogers.wireless.soc\">SOC Code</div><div class=\"wd-card-addon-rep-soc\">{{::addon.soc}}</div><div translate=\"ute.rogers.wireless.effectiveDate\"></div><div>{{::addon.effectiveDate | date:\'MMM dd, yyyy\'}}</div></div></div><div class=\"col-xs-3 wd-card-addon-price\"><div ng-if=\"::wpController.isDiscountMode(addon.soc)\"><span>{{::addon.addonMSF | currency:undefined:0}}</span> <span>{{::wpController.getDiscountRate(addon.addonMSF)| currency:undefined:0}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\' && addon.soc !== \'APLSRA000\'\" translate=\"ute.rogers.wireless.mo\"></span></div><div ng-if=\"::!wpController.isDiscountMode(addon.soc)\"><span>{{::addon.addonMSF | currency:undefined:0}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\' && addon.soc !== \'APLSRA000\'\" translate=\"ute.rogers.wireless.mo\"></span></div></div></div><div style=\"clear: both;\"></div></div><div ng-show=\"!wpController.isShareEverything() && !wpController.isInfinitePlan() && wpController.wpkg_client.postPaidAddons.length > 0 && wpController.hasAddonMSF()\" class=\"addOnCancelMessage\">{{ \'ute.rogers.wireless.monthlyDataAddOnCancelMessage\' | translate }}</div></div><div class=\"wd-card-addon-disc-container wd-card-addons-container\" ng-if=\"wpController.isCare && wpController.isRepView\"><div class=\"row\" style=\"padding-top: 2%; padding-bottom: 2%;\"><div class=\"wd-card-addon-disc-heading col-xs-11\">{{\'ute.rogers.wireless.addons\' | translate | uppercase}}</div><div class=\"rui-icon-tick col-xs-1 addon-toggle-icon\" ng-click=\"wpController.toggleDiscountsAndAddonsSection(\'addon\')\"></div></div><div class=\"wd-card-addon-table wd-card-section-toggle\"><div class=\"row wd-card-addon-disc-table-heading-row\"><div class=\"col-xs-4\"><span>{{\'ute.rogers.wireless.addonsAdded\' | translate}}</span></div><div class=\"col-xs-3\" style=\"text-align:center\"><span>{{\'ute.rogers.wireless.effectiveDate\' | translate}}</span></div><div class=\"col-xs-3\" style=\"text-align:center\"><span>{{\'ute.rogers.wireless.expirationDate\' | translate}}</span></div><div class=\"col-xs-2\" style=\"text-align:center\"></div></div><div class=\"wd-card-addon-disc-table-body\" id=\"scrollbar-container\"><div class=\"row wd-card-addon-disc-table-body-rows\" ng-repeat=\"addon in wpController.wpkg_client.totalAddons\"><div class=\"col-xs-4 vcenter\"><span ng-if=\"wpController.lng === \'en\' && !addon.socDesc\">{{addon.desc}}</span> <span ng-if=\"wpController.lng === \'fr\' && !addon.socDescFr\">{{addon.descFr}}</span> <span ng-if=\"wpController.lng === \'en\' && addon.socDesc\">{{addon.socDesc}}</span> <span ng-if=\"wpController.lng === \'fr\' && addon.socDescFr\">{{addon.socDescFr}}</span><div><span translate=\"ute.rogers.wireless.soc\"></span> <span ng-if=\"!addon.soc\">{{addon.code}}</span> <span ng-if=\"addon.soc\">{{addon.soc}}</span></div></div><div class=\"col-xs-3 wd-card-addon-disc-table-body-effective-date vcenter\"><span>{{addon.effectiveDate | date:\'MMM dd, yyyy\'}}</span></div><div class=\"col-xs-3 wd-card-addon-disc-table-body-expiry-date vcenter\"><span ng-if=\"addon.expiryDate !== \'\'\">{{ addon.expiryDate.trim() | date:\'MMM dd, yyyy\' }}</span> <span ng-if=\"addon.expiryDate === \'\'\">-</span></div><div class=\"col-xs-2 wd-card-addon-disc-table-body-applies-soc vcenter\"><span ng-if=\"!addon.addonMSF || !(addon.addonMSF > 0)\">$ -</span> <span ng-if=\"addon.addonMSF && addon.addonMSF > 0\"><span>{{addon.addonMSF| currency:undefined:0}}</span> <span ng-if=\"addon.soc && wpController.isDiscountMode(addon.soc)\">{{wpController.getDiscountRate(addon.addonMSF)| currency:undefined:0}}</span></span> <span ng-if=\"addon.addonMSF > 0 && addon.socClass !== \'UP\' && addon.soc !== \'APLSRA000\'\" translate=\"ute.rogers.wireless.mo\"></span></div></div><div style=\"clear: both;\"></div></div></div></div><div class=\"wd-card-addon-disc-container wd-card-discount-contianer\" ng-if=\"wpController.isCare && wpController.isRepView\"><div class=\"row\" style=\"padding-top: 2%; padding-bottom: 2%\"><div class=\"wd-card-addon-disc-heading col-xs-11\">{{\'ute.rogers.wireless.discounts\' | translate | uppercase}}</div><div class=\"rui-icon-tick col-xs-1 disc-toggle-icon\" ng-click=\"wpController.toggleDiscountsAndAddonsSection(\'discount\')\"></div></div><div class=\"wd-card-discount-table wd-card-section-toggle\"><div class=\"row wd-card-addon-disc-table-heading-row\" ng-if=\"wpController.wpkg_client.discounts.length > 0\"><div class=\"col-xs-4\"><span>{{\'ute.rogers.wireless.discounts\' | translate}}</span></div><div class=\"col-xs-3\" style=\"text-align:center;width: 22%;\"><span>{{\'ute.rogers.wireless.effectiveDate\' | translate}}</span></div><div class=\"col-xs-3\" style=\"text-align:center\"><span>{{\'ute.rogers.wireless.expirationDate\' | translate}}</span></div><div class=\"col-xs-2\"><span>{{\'ute.rogers.wireless.appliesSoc\' | translate}}</span></div></div><div class=\"wd-card-addon-disc-table-body\" ng-class=\"{\'wd-card-discount-section-empty\' : wpController.wpkg_client.discounts.length === 0}\"><div class=\"row wd-card-addon-disc-table-body-rows\" ng-if=\"wpController.wpkg_client.discounts.length > 0\" ng-repeat=\"disc in wpController.wpkg_client.totalDiscounts\"><div class=\"col-xs-4 vcenter\"><span ng-if=\"wpController.lng === \'en\'\">{{disc.desc}}</span> <span ng-if=\"wpController.lng === \'fr\'\">{{disc.descFr}}</span><div><span translate=\"ute.rogers.wireless.soc\"></span> <span>{{::disc.code}}</span></div></div><div class=\"col-xs-3 wd-card-addon-disc-table-body-effective-date vcenter\" style=\"width:22%;\"><span>{{disc.effectiveDate | date:\'MMM dd, yyyy\'}}</span></div><div class=\"col-xs-3 wd-card-addon-disc-table-body-expiry-date vcenter\"><span ng-if=\"disc.expiryDate!== \'\'\">{{disc.expiryDate | date:\'MMM dd, yyyy\'}}</span> <span ng-if=\"disc.expiryDate.length === 0\">-</span></div><div class=\"col-xs-2 wd-card-addon-disc-table-body-applies-soc vcenter\"><span ng-if=\"disc.discountSoc && disc.discountSoc!== \'\'\">{{disc.discountSoc}}</span> <span ng-if=\"disc.discountSoc.length === 0\">-</span></div></div><div style=\"clear: both;\"></div></div></div></div></div><div class=\"wd-card-feature-links\"><div class=\"wd-feature-link wd-feature-link-change-number\" ng-if=\"::wpController.isConsumer\"><bold-chat-static-button data-cbid=\"{{ \'ute.rogers.wireless.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.wireless.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.rogers.wireless.chatButtonClass\' | translate}}\" aria-label=\"{{\'change_number_alt_text\' | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><div class=\"wd-card-rep-cta-link\" ng-if=\"::wpController.isDealer || wpController.isCare\"><span translate=\"ute.rogers.wireless.toChangePhoneNumber\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.v21\"></span></div><div class=\"wd-feature-link\" ng-if=\"::wpController.isConsumer\"><div change-ctn-caller-id=\"\" show-name=\"false\"></div></div><div class=\"wd-card-rep-cta-link\" ng-if=\"::wpController.isCare && !wpController.canChangeCallerId\"><span translate=\"ute.rogers.wireless.toChangeCallerID\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.v21\"></span></div><div class=\"wd-feature-link\" ng-if=\"::wpController.isCare && wpController.canChangeCallerId\"><div change-ctn-caller-id=\"\" show-name=\"false\"></div></div><div class=\"wd-feature-link\" ng-if=\"wpController.isConsumer && wpController.wpkg_client.hasMyFive && !wpController.wpkg_client.planSuspended\"><a ng-click=\"wpController.updateMy5()\" class=\"pointer\"><strong translate=\"wireless_manage-device_my5-my10\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_my5-my10\"></strong> <i class=\"rui-icon-arrow-right\"></i></a></div><div class=\"wd-card-rep-cta-link\" ng-if=\"::wpController.isDealer\"><span translate=\"ute.rogers.wireless.toChangeCallerID\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.v21\"></span></div><div class=\"wd-card-rep-cta-link\" ng-if=\"(wpController.isDealer || wpController.isCare) && (wpController.wpkg_client.hasMyFive && !wpController.wpkg_client.planSuspended)\"><span translate=\"ute.rogers.wireless.toManageMY5M10\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_my5-my10_isCare\"></span> <span class=\"wd-card-rep-cta-location new-line-arrow\" translate=\"ute.rogers.wireless.v21\"></span></div><div class=\"wd-feature-link\" ng-if=\"wpController.wpkg_client.hasVoiceMail && !wpController.wpkg_client.planSuspended\"><ute-voicemail-reset-password data-account-number=\"{{wpController.ban}}\" data-ctn=\"{{wpController.ctn}}\"></ute-voicemail-reset-password></div></div></div>");
$templateCache.put("scripts/directives/wirelessPackage/partials/wirelessSupport.html","<div class=\"wd-support-card\" id=\"rogers-support\"><div class=\"wd-support-heading\" translate=\"ute.rogers.wireless.support\"></div><div class=\"row\"><div class=\"wd-missing-device-link\" ng-click=\"wpController.suspendPhone()\" ng-if=\"!wpController.wpkg_client.planSuspended\" ng-keydown=\"($event.which === 13)?wpController.suspendPhone():0\" tabindex=\"0\" role=\"link\"><span data-ng-if=\"wpController.isConsumer || !wpController.isRepView\" translate=\"wireless_manage-device_suspend-ctn\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></span> <span data-ng-if=\"(wpController.isCare || wpController.isDealer) && wpController.isRepView\" translate=\"wireless_manage-device_oneview_suspend-services\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></span> <i class=\"rui-icon-arrow-right\"></i></div><div class=\"wd-missing-device-link\" ng-if=\"wpController.wpkg_client.planSuspended\" ng-click=\"!wpController.isReactivateCtnCallInProgress() && wpController.reactivatePhone($event)\" data-ng-class=\"(wpController.isReactivateCtnCallInProgress()) ? \'no-pointer\' : \'pointer\'\"><span data-ng-if=\"wpController.isConsumer || !wpController.isRepView\" translate=\"wireless_manage-device_reactivate-service\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></span> <span data-ng-if=\"(wpController.isCare || wpController.isDealer) && wpController.isRepView\" translate=\"wireless_manage-device_reactivate-services\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_suspend-ctn\"></span> <i class=\"rui-icon-arrow-right\"></i></div><div class=\"wd-widget-loader\" data-ng-if=\"wpController.isReactivateCtnCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"row\"><div class=\"wd-support-sub-heading\" translate=\"ute.rogers.wireless.otherSupport\"></div><div class=\"wd-support-link\"><a href=\"/customer/support/article/wireless-network-aid\"><span translate=\"ute.rogers.wireless.networkAid\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div><div class=\"wd-support-link\"><a href=\"/web/content/handset-protection?ipn=1#,handset-protection--1\"><span ng-if=\"wpController.repairDeviceEnabled\" translate=\"ute.rogers.wireless.deviceProtection\"></span> <span ng-if=\"!wpController.repairDeviceEnabled\" translate=\"ute.rogers.wireless.deviceRepair\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div></div></div>");
$templateCache.put("scripts/modules/internetDashboard/internetMyModem/internetMyModem.html","<section class=\"internet-my-modem\"><div class=\"container wireless-package\"><div class=\"row\"><div class=\"col-sm-12 col-lg-7\"><div class=\"row ptm\"><div class=\"col-lg-12\"><h2 data-ng-if=\"$ctrl.isCareRepView()\" class=\"mtn widget-loader-mod\" data-test-id=\"myr-internetMyModem-modemTxt\" translate=\"internet_modem\"></h2><h2 data-ng-if=\"!$ctrl.isCareRepView()\" class=\"mtn widget-loader-mod\" data-test-id=\"myr-internetMyModem-modemTxt\" translate=\"internet_my_modem\"></h2><div class=\"widget-loader\" data-ng-if=\"$ctrl.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"container\" data-ng-if=\"$ctrl.errorMessage\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"$ctrl.serverError ? $ctrl.errorMessage : ($ctrl.errorMessage | translate)\"></validation-error-box></div></div></div></div><div call=\"row mbl\" data-ng-if=\"$ctrl.displayContent\"><div class=\"col-xs-12 col-md-6 col-lg-4\"><div class=\"row mbl mtm\"><div class=\"col-sm-12 col-lg-5 ptm\"><div class=\"visible-xs visible-sm mbm\"><div data-ng-if=\"$ctrl.isCareRepView()\" class=\"semi-bold\" translate=\"internet_modem\">:</div><div data-ng-if=\"!$ctrl.isCareRepView()\" class=\"semi-bold\" translate=\"internet_my_modem\">:</div><div data-test-id=\"myr-internetMyModem-internetModemNameSmall\" data-ng-ht=\"\">{{$ctrl.internetObj.myModem.name}}</div></div><div class=\"mlm internetMyModem_mod1\"><img data-ng-src=\"{{$ctrl.internetObj.myModem.image}}\" class=\"modem-image\"></div></div><div class=\"col-sm-12 col-lg-7\"><div class=\"visible-md visible-lg\"><div data-ng-if=\"$ctrl.isCareRepView()\" class=\"semi-bold internetMyModem_mod4\" translate=\"internet_modem\">:</div><div data-ng-if=\"!$ctrl.isCareRepView()\" class=\"semi-bold internetMyModem_mod4\" translate=\"internet_my_modem\">:</div><div data-test-id=\"myr-internetMyModem-internetModemNameLarge\" data-ng-bind-html=\"$ctrl.internetObj.myModem.name\"></div></div><div class=\"ov-hint ov-change-modem\" ng-if=\"(($ctrl.isDealer() || $ctrl.isCare()) && $ctrl.isRepView())\"><span translate=\"ute.rogers.internetDashboard.toChangeModem\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.internetDashboard.goToSGI\"></span></div><div ng-if=\"(($ctrl.isDealer() || $ctrl.isCare()) && !$ctrl.isRepView())\" class=\"xs-left-margin-cta\" style=\"text-align: center;\"><div class=\"plan-cta no-pointer\"><span class=\"plan-cta-text-sm\" translate=\"internet_change_my_modem\" style=\"width: 182px;\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div></div></div></div></div><div class=\"manage-device email-setup-link-ctn col-xs-12 col-md-6 col-lg-offset-1 col-lg-4\" data-ng-if=\"$ctrl.displayYahooMailButton && !$ctrl.isMyWifiBadgeEligible && !$ctrl.isCareRepView()\"><div class=\"manageDevice yahoo-email semi-bold\"><ul class=\"CTAmenu\"><li><a data-test-id=\"myr-internetMyModem-changeWifiPassword\" href=\"{{$ctrl.wifiTargetUrl}}\" target=\"_blank\"><span translate=\"change_wifi_password\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li><a data-test-id=\"myr-internetMyModem-setMailLink\" href=\"https://rogersmembercentre.com/rmcapp/remc.html#/registration\" target=\"_blank\"><span translate=\"internet_yahoo_email\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"last\"><a class=\"pointer\" data-test-id=\"myr-internetMyModem-checkMailLinkEn\" ng-click=\"$ctrl.goToYahooChackMail()\"><span translate=\"internet_yahoo_email_check\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div><div class=\"my-wifi-badge-content col-xs-12 col-md-6 col-lg-offset-2 col-lg-6\" data-ng-if=\"$ctrl.isMyWifiBadgeEligible && !$ctrl.isCareRepView()\"><ute-content-injector language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/my-wifi-badge/my-wifi-badge/my-wifi-badge\"></ute-content-injector></div></div></div></section>");
$templateCache.put("scripts/modules/internetDashboard/internetMyPackage/internetMyPackage.html","<section class=\"internet-my-package\"><div class=\"container wireless-package\" style=\"padding-top: 40px;\"><div class=\"row redHeadline mbm\"><div class=\"col-sm-12 col-lg-7\"><div class=\"row\"><div class=\"col-lg-12\"><h2 data-ng-if=\"$ctrl.isCareRepView()\" class=\"widget-loader-mod\" data-test-id=\"myr-internetMyPackage-intPkgTxt\" translate=\"internet_internet_package\"></h2><h2 data-ng-if=\"!$ctrl.isCareRepView()\" class=\"widget-loader-mod\" data-test-id=\"myr-internetMyPackage-intPkgTxt\" translate=\"internet_my_internet_package\"></h2><div class=\"widget-loader\" data-ng-if=\"$ctrl.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div></div></div><div class=\"container\" data-ng-if=\"$ctrl.errorMessage\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"$ctrl.errorMessage\"></validation-error-box></div></div></div></div><div class=\"row internet-package-ctn\" data-ng-if=\"$ctrl.displayContent\"><div class=\"col-md-12 col-lg-3 semi-bold\"><div class=\"headline6 semi-bold my-package-name\" data-test-id=\"myr-internetMyPackage-packageName\">{{$ctrl.internetObj.myPlan.package}}</div><div class=\"title-large\" data-ng-if=\"!internetUsageEmpty\"><span class=\"semi-bold\">{{$ctrl.internetObj.myPlan.totalGB| replace : \'\\.00\' : \'\'}}</span></div></div><div class=\"col-xs-12 col-md-6 col-lg-3\"><div class=\"plan-cta-ctn xs-left-margin-cta\" style=\"text-align:center\"><div class=\"plan-cta clickable-group-div\" ng-if=\"::$ctrl.isConsumer()\" data-ng-click=\"$ctrl.changePlan()\"><span class=\"plan-cta-text-sm\" data-test-id=\"myr-internetMyPackage-managePackage\" translate=\"internet_manage_package\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"plan-cta\" ng-class=\"::{\'no-pointer\':(($ctrl.isDealer() || $ctrl.isCare()))}\" ng-if=\"(($ctrl.isDealer() || $ctrl.isCare()) && !$ctrl.isRepView())\"><span class=\"plan-cta-text-sm\" data-test-id=\"myr-internetMyPackage-managePackage\" translate=\"internet_manage_package\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></div><div class=\"ov-hint ov-change-package\" ng-if=\"(($ctrl.isDealer() || $ctrl.isCare()) && $ctrl.isRepView())\"><span translate=\"ute.rogers.internetDashboard.toChangePackage\"></span> <span class=\"ov-go-to new-line-arrow\" translate=\"ute.rogers.internetDashboard.goToSGI\"></span></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/internetDashboard/internetMyUsage/internetMyUsage.html","<section class=\"internet-my-usage\"><div class=\"container\"><div class=\"row redHeadline\"><div class=\"col-sm-12 col-lg-6\"><h2 data-ng-if=\"$ctrl.isCareRepView()\" class=\"widget-loader-mod\" data-test-id=\"myr-internetMyUsage-usageTxt\" data-translate=\"internet_usage\"></h2><h2 data-ng-if=\"!$ctrl.isCareRepView()\" class=\"widget-loader-mod\" data-test-id=\"myr-internetMyUsage-usageTxt\" data-translate=\"internet_my_usage\"></h2><div class=\"widget-loader internet\" data-ng-if=\"$ctrl.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"col-sm-12 col-lg-6\" data-ng-if=\"!$ctrl.loadingDataIndicator\"><h5 class=\"legend\" data-test-id=\"myr-internetMyUsage-cycleTxt\" translate=\"internet_new_usage\" translate-values=\"{ days: $ctrl.internetObj.days }\" data-ng-if=\"$ctrl.internetObj.days > 0\"></h5></div></div><div class=\"row\" data-ng-if=\"$ctrl.errorMessage\"><div class=\"col-lg-12\"><div class=\"pam\"><validation-error-box error-message=\"$ctrl.errorMessage\"></validation-error-box></div></div></div><div class=\"row usage-ctn\" data-ng-if=\"$ctrl.displayContent && !$ctrl.internetUsageEmpty\"><div class=\"col-sm-12 col-md-6 col-lg-4\"><table class=\"hsi-usage-details-table\"><tbody><tr><th ng-class=\"$ctrl.isOverage ? \'usage-block-overage\' : \'\'\"><span data-translate=\"internet_usage\"></span></th><th colspan=\"2\" ng-class=\"$ctrl.isOverage ? \'usage-data-overage\' : \'\'\"><div class=\"row\" data-ng-if=\"$ctrl.unlimitedShow\"><div><div><div><span data-ng-if=\"!$ctrl.isOverage\"><strong data-translate=\"internet_unlimited\"></strong></span></div></div></div></div><div class=\"row\" data-ng-if=\"!$ctrl.unlimitedShow\"><div><div><div><span data-ng-if=\"!$ctrl.isOverage\"><strong>{{$ctrl.lbGB}} <span data-translate=\"internet_GB\"></span> <span data-translate=\"internet_remaining\"></span></strong> <span class=\"plan-limit\" data-translate=\"internet_plan_limit\" data-translate-values=\"{ totalLimit: $ctrl.lbTotal }\"></span></span> <span data-ng-if=\"$ctrl.isOverage\"><img class=\"data-overage-icon\" src=\"images/icon-exclamation-circle.png\" alt=\"\"> <strong class=\"overage-color\"><span data-translate=\"internet_overage_new\" data-translate-values=\"{ totalOverage: $ctrl.internetObj.extraUsage }\"></span></strong> <span class=\"plan-limit\" data-translate=\"internet_overage_plan_limit\" data-translate-values=\"{ totalLimit: $ctrl.lblTotalOvrPlan }\"></span></span></div></div></div></div></th></tr></tbody></table></div><div class=\"col-sm-12 col-md-6 col-lg-4\"></div><div class=\"manage-device col-sm-12 col-md-6 col-lg-4\"><div class=\"manageDevice semi-bold mtm\"><ul class=\"CTAmenu semi-bold pointer\"><li class=\"pointer int-dash-CTAmenu-list-item\" ng-class=\"{\'no-pointer\' : $ctrl.isCareRepView()}\"><a data-ng-click=\"$ctrl.postToConsumer(\'daily-usage\')\" ng-if=\"::!($ctrl.isDealer() || $ctrl.isCare())\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"internetdash,internetdash-daily-usage,event.selfServeComplete\"}\'><span data-translate=\"internet_daily_usage\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"pointer int-dash-CTAmenu-list-item\" ng-class=\"{\'no-pointer\' : $ctrl.isCareRepView()}\"><a data-ng-click=\"$ctrl.postToConsumer(\'monthly-usage\')\" ng-if=\"::!($ctrl.isDealer() || $ctrl.isCare())\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"internetdash,internetdash-monthly_usage,event.selfServeComplete\"}\'><span data-translate=\"internet_monthly_usage\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li><li class=\"pointer int-dash-CTAmenu-list-item\" ng-class=\"{\'no-pointer\' : $ctrl.isCareRepView()}\"><a data-ng-click=\"$ctrl.postToConsumer(\'usage-alerts\')\" ng-if=\"::!($ctrl.isDealer() || $ctrl.isCare())\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"internetdash,internetdash-usage-alerts,event.selfServeComplete\"}\'><span data-translate=\"internet_usage_alerts\"></span> <span class=\"right-arrow rui-icon-button-arrow-right\"></span></a></li></ul></div></div></div><div class=\"row\" data-ng-if=\"$ctrl.internetUsageEmpty\"><div class=\"col-lg-12\"><center><h3 translate=\"internet_missing_usage\"></h3></center></div></div></div></section>");
$templateCache.put("scripts/modules/onboarding/onboarding-item/onboarding-item.view.html","<a role=\"button\" tabindex=\"{{ctrl.config.completed ? -1 : 0}}\" ng-click=\"ctrl.openModal($event);\" ng-keypress=\"($event.which === 32 || $event.which === 13) ? ctrl.openModal($event) : 0;\" aria-label=\"{{ctrl.getTaskAltTranslationKey() | translate}}\" ng-class=\"{\'completed\': ctrl.config.completed}\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"onboarding.{{ctrl.config.itemKey}}.step1\"}\'><span class=\"icon_holder\"><img ng-src=\"{{ctrl.getBackgroundUrl()}}\" alt=\"\"> <i class=\"check_icon\"></i></span> <span class=\"text_holder\" ng-class=\"{\'completed_text\': ctrl.config.completed}\" translate=\"onBoarding.tasks.{{ctrl.config.itemKey}}.title.{{ctrl.config.completed? \'completed\' : \'pending\'}}\"></span></a>");
$templateCache.put("scripts/modules/onboarding/onboarding-item/onboarding-modal.html","<div class=\"modal-body\"><a role=\"button\" tabindex=\"0\" class=\"model_btn_close rogers-icon-circle-x\" aria-label=\"{{\'onBoarding.closeAltText\' | translate }}\" ng-click=\"ctrl.close()\" ng-keypress=\"($event.which === 32 || $event.which === 13) ? ctrl.close() : 0;\"></a><div class=\"text_holder\"><h2 class=\"link-account-title\" translate=\"{{ctrl.titleKey}}\"></h2><div class=\"text_block\" translate=\"{{ctrl.descriptionKey}}\"></div></div><div class=\"btn_holder\"><button class=\"btn_primary\" translate=\"onBoarding.closeText\" aria-label=\"{{ \'onBoarding.closeAltText\' | translate }}\" ng-click=\"ctrl.close()\"></button> <button aria-label=\"{{ctrl.buttons.primary.altTranslationKey | translate}}\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"pageView\":false,\"mappingKey\":\"onboarding.{{ctrl.itemKey}}.step2\"}\' ng-class=\"ctrl.buttons.primary.cssClass\" ng-click=\"ctrl.buttons.primary.callback();$close();\">{{ctrl.buttons.primary.labelTranslationKey | translate}}</button></div></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/captureDealerCodeErrorModal.html","<div class=\"totes-project ml-zero\"><div class=\"oneview-dealerCode\"><div class=\"dialog\"><div class=\"row dealer-code-modal-header\"><div class=\"col-xs-11\"><div class=\"col-xs-2 col-sm-2 col-md-1 ptxs\"><img src=\"ute-common-assets/assets/warning.png\"></div><div class=\"col-xs-8 col-sm-8 col-md-8\"><h5 translate=\"dealer-code_oops\"></h5></div></div><div class=\"close-gray-cross\" ng-click=\"cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"dealer-code-modal-body\"><div class=\"row mbl\"><span translate=\"general_error\"></span></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/captureDealerCodeForm.partial.html","<div class=\"totes-project\"><form name=\"captureDealerForm\" class=\"oneview-dealerCode\" novalidate=\"\"><div class=\"row\"><span ng-show=\"isDealerCodeError\" class=\"invalid-error-font\" translate=\"dealer-code_error\"></span></div><div class=\"form-group\"><div class=\"col-xs-7\"><input name=\"formDealerCode\" data-ng-class=\"isDealerCodeError ? \'invalid-input-style\' : \'\'\" data-ng-change=\"onDealerCodeInputChange()\" type=\"text\" ng-model=\"dealerCode\" placeholder=\"{{dealerCodePlaceholder}}\"> <span ng-show=\"isDealerCodeSuccess\" class=\"inline-checker icon-checked\" style=\"\"></span></div><div class=\"col-xs-4 mlm\"><button class=\"cta-round large\" name=\"submit\" type=\"button\" translate=\"_submit\" data-ng-click=\"submit()\"></button></div></div></form></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/captureDealerCodeModal.html","<div class=\"totes-project ml-zero\"><div class=\"oneview-dealerCode\"><div class=\"dialog\"><div class=\"row dealer-code-modal-header\"><div class=\"col-xs-11\"><h5 translate=\"dealer-code_your_enter\"></h5></div><div class=\"close-gray-cross\" ng-click=\"cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"dealer-code-modal-body\"><div class=\"row mbm\"><div class=\"pbm\"><span translate=\"dealer-code_info\"></span></div></div><div class=\"row\"><div class=\"pull-right\" ng-class=\"lang==\'fr\'?\'col-xs-12\':\'col-xs-8\'\"><dealer-code-form></dealer-code-form></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/dsgCaptureDealerCodeModal.html","<div class=\"totes-project ml-zero\"><div class=\"oneview-dealerCode\"><div class=\"dialog\"><div class=\"row dealer-code-modal-header pal\"><div class=\"col-xs-5 pls\"><div class=\"row\"><h5 data-ng-bind=\"customerName\"></h5></div><div class=\"row\"><div class=\"col-xs-5\"><span data-ng-bind=\"accountNumber\"></span></div><span class=\"col-xs-1\" style=\"text-align:center\">|</span><div class=\"col-xs-6\"><span data-ng-bind=\"customerType\"></span></div></div></div><div class=\"col-xs-6 rui-icon-style ptm\"><div class=\"col-xs-2\"><span class=\"rui-icon-wireless icon\"></span></div><div class=\"col-xs-3\"><span class=\"rui-icon-internet icon\"></span></div><div class=\"col-xs-3\"><span class=\"rui-icon-tv icon\"></span></div><div class=\"col-xs-2 up10\"><span class=\"rui-icon-home-phone icon\"></span></div><div class=\"col-xs-2\"><span class=\"ute-icon-home-security icon\"></span></div></div><div class=\"close-gray-cross close-gray-cross-abs-position\" ng-click=\"cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"row dealer-code-modal-body\"><div class=\"col-xs-12 mbl\"><span translate=\"dealer-code_dsg_enter_dealer_code\"></span></div><div class=\"mtm\" ng-class=\"lang==\'fr\'?\'col-xs-12\':\'col-xs-7\'\"><div class=\"row\"><form name=\"captureDealerForm\" class=\"\" novalidate=\"\"><div class=\"row\"><span ng-show=\"isDealerCodeError\" class=\"invalid-error-font\" translate=\"dealer-code_error\"></span></div><div class=\"form-group\"><div class=\"col-xs-7\"><input name=\"formDealerCode\" data-ng-class=\"isDealerCodeError ? \'invalid-input-style\' : \'\'\" data-ng-change=\"onDealerCodeInputChange()\" type=\"text\" ng-model=\"dealerCode\" placeholder=\"{{dealerCodePlaceholder}}\"><span ng-show=\"isDealerCodeSuccess\" class=\"inline-checker icon-checked\" style=\"\"></span></div><div class=\"col-xs-4 mlm\"><button class=\"cta-round large\" name=\"submit\" type=\"button\" translate=\"_submit\" data-ng-click=\"submit()\"></button></div></div></form></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/onBehalfOfdealerCode.html","<div class=\"oneview-dealerCode\"><div class=\"col-xs-12\" ng-hide=\"isDealerCodeModalEntered\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div><div ng-show=\"isDealerCodeModalEntered\" class=\"oneview-behalf-dealerCode-section\"><div class=\"col-xs-12 oneview-behalf-dealerCode\" ng-hide=\"isBehalfOfDealerCode\"><div class=\"row\"><div class=\"col-xs-6 col-sm-4 dealer-code-text-gap\" ng-class=\"lang == \'fr\'?\'col-md-5\':\'col-md-6\'\"><span translate=\"dealer-code_on_behalf_dealer_code\"></span></div><div class=\"col-xs-6 col-sm-8 pull-right\" ng-class=\"lang == \'fr\'?\'col-md-7\':\'col-md-6\'\"><form name=\"captureDealerForm\" class=\"\" novalidate=\"\"><div class=\"\"><span class=\"invalid-error-font\" ng-show=\"isDealerCodeError\" translate=\"dealer-code_error\"></span></div><div class=\"form-group\"><div class=\"col-xs-11\" ng-class=\"lang == \'fr\'?\'col-lg-8 col-md-7\':\'col-md-6\'\"><input class=\"col-xs-12\" data-ng-class=\"isDealerCodeError ? \'invalid-input-style\' : \'\'\" data-ng-change=\"enableSubmitButton()\" name=\"formDealerCode\" type=\"text\" ng-model=\"behalfDealerCode\" placeholder=\"{{dealerCodePlaceholder}}\"></div><div class=\"col-xs-11 dealer-code-button-gap\" ng-class=\"lang == \'fr\'?\'col-lg-3 col-md-4\':\'col-md-5\'\"><button class=\"cta-round cta-round-colored-button\" data-ng-disabled=\"isDealerCodeSubmitted\" ng-class=\"\" name=\"submit\" type=\"button\" data-ng-click=\"submitBehalfDealerCode()\"><span translate=\"_submit\"></span></button></div></div></form></div></div></div><div class=\"col-xs-12 col-md-11 oneview-behalf-dealerCode middle-section-fr\" ng-show=\"isBehalfOfDealerCode && !isDSGDealerCode\"><div class=\"row\"><div class=\"col-xs-12 col-md-5 text-middle-section dealer-code-text-gap\"><span translate=\"dealer-code_now_behalf_of_agent\"></span></div><div class=\"col-xs-7 col-md-3 behalf-edit-section\"><div class=\"col-xs-11 col-md-12 pull-right\"><span class=\"col-xs-6 behalf-dealer-code\" ng-bind=\"behalfDealerCode\"></span> <span class=\"col-xs-6\"><button name=\"edit\" type=\"button\" class=\"cta-round cta-round-colorless\" data-ng-click=\"edit()\"><span translate=\"_editlabel\"></span></button></span></div></div><div class=\"col-xs-5 col-md-4 behalf-edit-section\"><div class=\"col-xs-11 pull-right bdl\"><div class=\"col-xs-12\"><button name=\"useMyCode\" type=\"button\" class=\"cta-round-colored-button pull-right use-my-code-button\" data-ng-click=\"useMyCode()\"><span translate=\"dealer-code_use_my-code\"></span></button></div></div></div></div></div><div class=\"col-xs-12 col-md-11 oneview-behalf-dealerCode middle-section-en\" ng-show=\"isBehalfOfDealerCode && isDSGDealerCode\"><div class=\"row\"><div class=\"col-xs-7 text-middle-section dealer-code-text-gap\"><span translate=\"dealer-code_now_behalf_of_agent\"></span></div><div class=\"col-xs-2 behalf-edit-section text-middle-section\"><span class=\"behalf-dealer-code\" ng-bind=\"behalfDealerCode\"></span></div><div class=\"col-xs-3\"><div class=\"col-xs-10 behalf-edit-section\"><button name=\"edit\" type=\"button\" class=\"cta-round cta-round-colorless\" data-ng-click=\"edit()\"><span translate=\"_editlabel\"></span></button></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/captureDealerCode/proceedWithoutDealerCodeModal.html","<div class=\"totes-project ml-zero\"><div class=\"oneview-dealerCode\"><div class=\"dialog\"><div class=\"row dealer-code-modal-header\"><div class=\"col-xs-11\"><div class=\"col-xs-2 col-sm-2 col-md-1 ptxs\"><img src=\"ute-common-assets/assets/warning.png\"></div><div class=\"col-xs-8 col-sm-8 col-md-8\"><h5 translate=\"dealer-code_oops\"></h5></div></div><div class=\"close-gray-cross\" ng-click=\"cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"dealer-code-modal-body\"><div class=\"row mbl\"><span translate=\"dealer-code_warning_description\"></span></div><div class=\"row ptm\"><div ng-class=\"lang==\'fr\'?\'col-xs-12\':\'col-xs-7\'\"><dealer-code-form></dealer-code-form></div><div class=\"plxs\" ng-class=\"lang==\'fr\'?\'col-xs-12\':\'col-xs-5\'\"><h5><a class=\"pointer\" data-ng-click=\"cancel()\"><span translate=\"dealer-code_without_dealer_code\"></span></a></h5></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/consumerAccountStatusDetails.ignore/consumerAccountStatusDetails.html","<div class=\"directive-consumer-account-status-details\"><div class=\"account-status-container\" style=\"\"><div><span style=\"\"><strong>14.5 years</strong></span></div></div></div>");
$templateCache.put("scripts/modules/oneView/consumerDetails/consumerDetails.html","<div class=\"directive-oneview-consumer-details col-lg-12\" href=\"javascript:void(0)\"><div class=\"col-lg-12 consumer-details-wrapper\"><span class=\"widget-loader-inline\" ng-hide=\"al.isConsumerBriefInfoReady\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span><div class=\"consumer-details-container\"><div class=\"consumer-details-name\"><span class=\"consumer-name\">{{al.fullName}}</span><span class=\"ban-number\">{{al.accountDetails.accountNumber}}</span></div></div><div class=\"consumer-address-container\">{{al.customerAddressOneLine}}</div></div><div class=\"col-xs-12 visible-xs show-more-container\"><a id=\"showMoreLink\" data-target=\"#consumer-details-collapsible\" href=\"javascript:void(0)\" aria-expanded=\"true\" class=\"rui-cta-link details-expander\" ng-click=\"getConsumerDetailsForMobile()\"><span translate=\"show_more\"></span></a></div><div class=\"col-xs-12 consumer-details-collapsible consumer-details-collapsible-expanded\" id=\"consumer-details-collapsible\"><div class=\"col-xs-12 visible-xs show-less-container\"><a id=\"showLessLink\" href=\"javascript:void(0)\" class=\"rui-cta-link\" aria-expanded=\"false\" ng-click=\"closeConsumerDetails()\"><span translate=\"show_less\"></span></a></div><div><div ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\">{{al.accountStatus}}</div><div class=\"hidden-xs\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div ng-if=\"!(al.isCable)\" class=\"credit-wrapper\"><span>{{al.accountType +\' - \'+ al.accountSubType }} <span class=\"details-divider\" ng-if=\"al.isCreditClass\">|</span></span> <span ng-if=\"al.isCreditClass\"><span translate=\"c_class\"></span> <span>{{al.customerInfo.creditClass}} <span ng-if=\"al.isC_LimitDisplay\" class=\"hidden-xs details-divider\">|</span></span></span> <span ng-if=\"al.isC_LimitDisplay\"><span translate=\"c_limit\"></span> <span class=\"credit-limit\">{{al.customerInfo.creditLimit | currencies:al.lng}}</span> <span class=\"details-divider hidden-xs\" ng-if=\"al.isC_LimitDisplay\">|</span></span> <span ng-if=\"al.isC_LimitDisplay\"><span translate=\"c_available\"></span> <span class=\"c-balance\">{{(al.customerInfo.creditLimit - al.customerInfo.balanceAmount) | currencies:al.lng }}</span></span></div></div><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-12 visible-xs credit-wrapper\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div ng-if=\"!al.isCable\"><span class=\"col-lg-2 col-md-2 col-sm-2\">{{al.accountType +\' - \'+ al.accountSubType }} <span class=\"details-divider\" ng-if=\"al.isCreditClass || al.isC_LimitDisplay\">|</span></span> <span class=\"col-lg-4 col-md-4 col-sm-4\" ng-if=\"al.isCreditClass\"><span translate=\"c_class\"></span> <span>{{al.customerInfo.creditClass}} <span class=\"hidden-xs details-divider\">|</span></span></span> <span ng-if=\"al.isC_LimitDisplay\" class=\"col-xs-12 col-xs-12 col-lg-4 col-md-4 col-sm-4\"><span translate=\"c_limit\"></span> <span class=\"credit-limit\">{{al.customerInfo.creditLimit | currencies:al.lng}} <span class=\"details-divider hidden-xs\" ng-show=\"al.isC_LimitDisplay\">|</span></span></span> <span ng-if=\"al.isC_LimitDisplay\" class=\"col-xs-12 col-xs-12 col-lg-2 col-md-2 col-sm-2\"><span translate=\"c_available\"></span> <span class=\"c-balance\">{{(al.customerInfo.creditLimit - al.customerInfo.balanceAmount) | currencies:al.lng }}</span></span></div></div><div class=\"anniversary_container co-xs-12\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><span class=\"account-type\" ng-if=\"al.isCable\">{{al.customerInfo.accountType }}</span> <span translate=\"anniversary\"></span><span>{{al.accountEffectiveDate}}</span></div></div><div class=\"hr-line\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"></div><span class=\"widget-loader-inline consumer-overlay-loader\" ng-if=\"al.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span class=\"widget-loader-inline consumer-overlay-empty-content\" ng-if=\"al.customerInfoFailure\"><span translate=\"content_currently_unavailable\"></span></span><div class=\"transaction-details\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div class=\"sub-title\" translate=\"interactions_in_the_last_30_days\"></div><div class=\"col-xs-12\"><div class=\"col-xs-2 mtop\"><div class=\"number\">{{al.customerInfo.totalInteractionsAndCases}}</div><div translate=\"c_interactions\"></div></div><div class=\"col-xs-2\"><div class=\"number\" ng-if=\"al.customerInfo.totalCases > 0\"><a ui-sref=\"interaction({filter:\'Ticket\'})\">{{al.customerInfo.totalCases}}</a></div><div class=\"number\" ng-if=\"al.customerInfo.totalCases === 0\">{{al.customerInfo.totalCases}}</div><div translate=\"filer_tickets\"></div></div></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/interaction/interaction.html","<div class=\"directive-interaction col-xs-12 interactionOffset\"><div class=\"interactionHeading redcolor row\"><div class=\"col-xs-8\"><h4><span translate=\"interaction\"></span> <span class=\"widget-loader-inline\" ng-show=\"loading\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></h4></div><button ng-click=\"redirectToInteraction()\" class=\"filter-btn filterAll col-xs-4\" type=\"button\" name=\"button_continue\" ng-show=\"!interactionNotAvailable && !loading\"><span translate=\"filter_all\"></span></button></div><div ng-show=\"!interactionNotAvailable && !loading\"><div ng-repeat=\"i in interactionAndCaseList | limitTo: limitCount track by $index\"><div class=\"newborder interactionPointer\" ng-click=\"redirectToInteraction()\"><div class=\"newmargin\"><div class=\"row\"><div class=\"col-md-2 col-xs-3 iconPadding {{getIcon(i.media,i.itemType);}}\"></div><div class=\"col-md-10 col-xs-9 contentPadding\" ng-class=\"{\'newborder-xs\': $index != (limitCount-1)}\"><div ng-if=\"isInteraction(i.itemType)\"><span>{{getInteractionText(i)}}</span><div ng-show=\"i.isActive && isInteraction(i.itemType)\" class=\"innermargin redcolor\"><span translate=\"interaction_started\"></span> <span>{{getChannel(i.channel)}}</span><div><span>{{getTimeStamp(i.topics[0].itemTimeStamp);}}</span></div></div><div ng-hide=\"i.isActive\" class=\"innermargin\"><span>{{getChannel(i.channel)}}</span><div><span ng-class=\"{\'redcolor\':isDays(i.topics[0].itemTimeStamp)}\">{{getDate(i.topics[0].itemTimeStamp)}}</span> <span><span translate=\"interaction_at\"></span> {{getTimeStamp(i.topics[0].itemTimeStamp);}}</span></div></div></div><div ng-if=\"isCase(i.itemType)\"><span>{{i.caseTypeLevel1}}</span><div class=\"innermargin\"><span class=\"redcolor\"><span translate=\"interaction_ticket\"></span>: {{i.caseID}}</span><div><span>{{getDate(i.itemTimeStamp);}} <span translate=\"interaction_at\"></span> {{getTimeStamp(i.itemTimeStamp);}}</span></div></div></div></div></div></div></div></div></div><div class=\"interactionError\" ng-show=\"interactionNotAvailable && !loading\"><span translate=\"error_In_Retrieving\" ng-show=\"errorInRetrieving\"></span> <span translate=\"content_currently_unavailable\" ng-show=\"noPermission\"></span></div></div>");
$templateCache.put("scripts/modules/oneView/interaction/interactionDetails.html","<section class=\"page-one-view-dashboard\"><div class=\"container interactionContainer\"><div class=\"row\"><interaction-history data-interaction-id=\"interaction\"></interaction-history></div></div></section>");
$templateCache.put("scripts/modules/oneView/interaction/interactionHistory.html","<div class=\"container\"><div class=\"row interactions-history-page\"><div class=\"col-xs-12 col-sm-12 col-md-12 interactions-dropdown-search\"><span class=\"col-xs-12 col-sm-3 col-md-3 interactions-title\"><span class=\"col-sm-9 col-md-9\" translate=\"interaction\"></span> <span class=\"widget-loader-inline col-sm-3 col-md-3\" ng-show=\"loading\"><img src=\"images/widget-loader.gif\" alt=\"\"></span></span><div class=\"dropdown-search col-sm-9 col-md-offset-1 col-md-8\" ng-show=\"!errorInRetrieving && !noPermission && !loading\"><div class=\"styled-select col-xs-12 col-sm-5 col-md-4\"><select class=\"rui-dropdown col-xs-12\" ng-model=\"searchTagDropdown\" ng-change=\"searchTagField=\' \';searchHint=null\" ng-options=\"topic.callReason1 as topic.callReason1 for topic in topics\"><option value=\"\" translate=\"filter_all\"></option></select></div><div class=\"search-field col-xs-12 col-sm-6 col-sm-offset-1 col-md-7 col-md-offset-1\"><div class=\"search-cancel-button\"><button type=\"button\" class=\"btn btn-default cancel-button\" ng-click=\"setSearch(null)\">&#10005;</button> <button type=\"button\" class=\"btn btn-default search-button\" ng-click=\"setSearch(searchHint)\" translate=\"search-interaction\"></button></div><input type=\"text\" name=\"interactionInput\" class=\"search-box form-control\" placeholder=\"{{\'interaction_search_placeholder\' | translate}}\" ng-keyup=\"$event.keyCode==13 ? setSearch(searchHint) : angular.noop()\" ng-model=\"searchHint\" typeahead=\"items for items in typeaheadItems | filter:$viewValue | unique | limitTo:10\"> <span class=\"searchError\" ng-if=\"totalItems.length <= 0\" translate=\"interaction_search_error\"></span></div></div></div><div class=\"interaction-table col-xs-12\" ng-show=\"!errorInRetrieving && !noPermission && !loading\"><table class=\"table table-tag hidden-xs\"><thead class=\"table-head\"><tr><th class=\"col-xs-3\"><div class=\"col-xs-6 col-sm-8 col-md-6\"><span translate=\"interaction_medium_dept\"></span></div><div class=\"col-xs-6 col-sm-4 col-md-6\"><span translate=\"interaction_date\"></span></div></th><th class=\"col-xs-4\"><span translate=\"interaction_product_line\" class=\"col-xs-4\"></span> <span class=\"col-xs-1\"></span> <span class=\"col-xs-7\"><span translate=\"interaction_topic\"></span>&nbsp;| <span translate=\"interaction_activities\"></span>&nbsp;| <span translate=\"interaction_results\"></span></span></th><th class=\"col-xs-2\"><span class=\"col-xs-1\"></span> <span class=\"col-xs-11\" translate=\"interaction_notes\"></span></th><th class=\"col-xs-3 text-right\"><span translate=\"interaction_rep_interaction_id\"></span></th></tr></thead><tbody class=\"table-body\"><tr ng-repeat=\"interaction in interactionAndCaseList | interactionHistoryFilter:searchTagDropdown:this | filter:searchTagField | interactionPagination:currentPage:this track by $index\"><td class=\"col-xs-3 col-sm-4 col-md-4\"><div class=\"col-xs-6 col-sm-8 col-md-6 text-center\"><div class=\"{{getIcon(interaction.media,interaction.itemType);}} col-xs-10\"></div><div class=\"channelText col-xs-10\" ng-if=\"isInteraction(interaction.itemType)\" ng-bind-html=\"getChannel(interaction.channel) | highlightText:searchTagField\"></div><div class=\"channelText col-xs-10\" ng-if=\"isCase(interaction.itemType)\" ng-bind-html=\"interaction_ticket | highlightText:searchTagField\"></div></div><div class=\"col-xs-6 col-sm-4 col-md-4\"><div ng-if=\"interaction.isActive && isInteraction(interaction.itemType)\" class=\"redcolor\"><span translate=\"interaction_started\"></span><div><span ng-bind-html=\"getTimeStamp(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div></div><div ng-if=\"!interaction.isActive && isInteraction(interaction.itemType)\"><div ng-class=\"{\'redcolor\':isDays(interaction.topics[0].itemTimeStamp)}\"><span ng-bind-html=\"getDate(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div><div><span translate=\"interaction_at\"></span>&nbsp; <span ng-bind-html=\"getTimeStamp(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div></div><div ng-if=\"isCase(interaction.itemType)\"><div ng-class=\"{\'redcolor\':isDays(interaction.itemTimeStamp)}\"><span ng-bind-html=\"getDate(interaction.itemTimeStamp) | highlightText:searchTagField\"></span></div><div><span translate=\"interaction_at\"></span> &nbsp;<span ng-bind-html=\"getTimeStamp(interaction.itemTimeStamp) | highlightText:searchTagField\"></span></div></div></div></td><td class=\"col-xs-3 col-sm-3 col-md-3\" ng-if=\"isInteraction(interaction.itemType)\"><div ng-repeat=\"topic in interaction.topics track by $index\"><p class=\"col-xs-4 col-sm-5 col-md-4\" ng-bind-html=\"topic.lob | uppercase | highlightText:searchTagField\"></p><p class=\"col-xs-1 col-sm-1 col-md-1\"><span></span></p><p class=\"col-xs-7 col-sm-6 col-md-7\"><span ng-bind-html=\"topic.callReason1 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.callReason2 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.callReason3 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.result | highlightText:searchTagField\"></span></p></div></td><td class=\"col-xs-3 col-sm-2 col-md-3\" ng-if=\"isCase(interaction.itemType)\"><p class=\"col-xs-4\"><span ng-bind-html=\"interaction.LOB | uppercase | highlightText:searchTagField\"></span></p><p class=\"col-xs-1\"><span></span></p><p class=\"col-xs-7\"><span ng-bind-html=\"getCaseText(interaction) | highlightText:searchTagField\"></span></p></td><td class=\"col-xs-3 col-sm-2 col-md-3 word-break\"><span class=\"col-xs-1\"></span> <span class=\"col-xs-11\"><span class=\"read-more-less-ellipis-{{$index}}\" ng-bind-html=\"isInteraction(interaction.itemType)? (interaction.notes | characters:notesLength):\' \' | highlightText:searchTagField\"></span> <span class=\"read-more-less-fulltext-{{$index}} ng-hide\" ng-bind-html=\"isInteraction(interaction.itemType)? interaction.notes :\' \' | highlightText:searchTagField\" style=\"white-space: pre-wrap;\"></span> <span ng-if=\"interaction.notes.length > notesLength\"><img class=\"read-more-{{$index}}\" ng-click=\"setCharacter(interaction.notes,interaction.notes.length,$index)\" alt=\"More\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/interaction/notesDown.png\" width=\"18\" height=\"13\"> <img class=\"read-less-{{$index}} ng-hide\" ng-click=\"setCharacter(interaction.notes,notesLength,$index)\" alt=\"Less\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/interaction/notesUp.png\" width=\"18\" height=\"13\"></span></span></td><td class=\"col-xs-3 col-sm-3 col-md-3\"><span ng-bind-html=\"isInteraction(interaction.itemType)?interaction.interactionID:interaction.caseID | highlightText:searchTagField\"></span></td><div class=\"clearfix\"></div></tr></tbody></table><table class=\"table table-tag visible-xs\"><thead class=\"table-head\"><tr><th class=\"col-xs-6\"><span translate=\"interaction_medium_dept\"></span></th><th class=\"col-xs-6\"><span translate=\"interaction_date\"></span></th><div class=\"clearfix\"></div></tr></thead><tbody class=\"table-body\"><tr ng-repeat=\"interaction in interactionAndCaseList | interactionHistoryFilter:searchTagDropdown:this | filter:searchTagField | interactionPagination:currentPage:this track by $index\"><td class=\"col-xs-6\"><div class=\"{{getIcon(interaction.media,interaction.itemType);}}\"></div><div ng-if=\"isInteraction(interaction.itemType)\" ng-bind-html=\"getChannel(interaction.channel) | highlightText:searchTagField\"></div><div ng-if=\"isCase(interaction.itemType)\" ng-bind-html=\"interaction_ticket | highlightText:searchTagField\"></div></td><td class=\"col-xs-6\"><div ng-if=\"interaction.isActive && isInteraction(interaction.itemType)\" class=\"innermargin redcolor\"><span translate=\"interaction_started\"></span><div><span ng-bind-html=\"getTimeStamp(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div></div><div ng-if=\"!interaction.isActive && isInteraction(interaction.itemType)\" class=\"innermargin\"><div ng-class=\"{\'redcolor\':isDays(interaction.topics[0].itemTimeStamp)}\"><span ng-bind-html=\"getDate(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div><div><span translate=\"interaction_at\"></span>&nbsp; <span ng-bind-html=\"getTimeStamp(interaction.topics[0].itemTimeStamp) | highlightText:searchTagField\"></span></div></div><div ng-if=\"isCase(interaction.itemType)\"><div ng-class=\"{\'redcolor\':isDays(interaction.itemTimeStamp)}\"><span ng-bind-html=\"getDate(interaction.itemTimeStamp) | highlightText:searchTagField\"></span></div><div><span translate=\"interaction_at\"></span> &nbsp;<span ng-bind-html=\"getTimeStamp(interaction.itemTimeStamp) | highlightText:searchTagField\"></span></div></div></td><div class=\"clearfix\"></div></tr></tbody></table><table class=\"table table-tag visible-xs\"><thead class=\"table-head\"><tr><th class=\"col-xs-12\"><span class=\"col-xs-5\" translate=\"interaction_product_line\"></span> <span class=\"col-xs-7\"><span translate=\"interaction_topic\"></span>&nbsp;| <span translate=\"interaction_activities\"></span>&nbsp;| <span translate=\"interaction_results\"></span></span></th><div class=\"clearfix\"></div></tr></thead><tbody class=\"table-body\"><tr ng-repeat=\"interaction in interactionAndCaseList | interactionHistoryFilter:searchTagDropdown:this | filter:searchTagField | interactionPagination:currentPage:this track by $index\"><td class=\"col-xs-12\" ng-if=\"isInteraction(interaction.itemType)\"><div ng-repeat=\"topic in interaction.topics track by $index\"><p class=\"col-xs-5 textAlign\" ng-bind-html=\"topic.lob | uppercase | highlightText:searchTagField\"></p><p class=\"col-xs-7\"><span ng-bind-html=\"topic.callReason1 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.callReason2 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.callReason3 | highlightText:searchTagField\"></span> | <span ng-bind-html=\"topic.result | highlightText:searchTagField\"></span></p></div></td><td class=\"col-xs-12\" ng-if=\"isCase(interaction.itemType)\"><p class=\"col-xs-5\"><span ng-bind-html=\"interaction.LOB | uppercase | highlightText:searchTagField\"></span></p><p class=\"col-xs-7\"><span ng-bind-html=\"getCaseText(interaction) | highlightText:searchTagField\"></span></p></td><div class=\"clearfix\"></div></tr></tbody></table><table class=\"table table-tag visible-xs\"><thead class=\"table-head\"><tr><th class=\"col-xs-6\"><span translate=\"interaction_notes\"></span></th><th class=\"col-xs-6 text-right\"><span translate=\"interaction_rep_interaction_id\"></span></th><div class=\"clearfix\"></div></tr></thead><tbody class=\"table-body\"><tr ng-repeat=\"interaction in interactionAndCaseList | interactionHistoryFilter:searchTagDropdown:this | filter:searchTagField | interactionPagination:currentPage:this track by $index\"><td class=\"col-xs-6 word-break\"><span class=\"read-more-less-ellipis-{{$index}}\" ng-bind-html=\"isInteraction(interaction.itemType)? (interaction.notes | characters:notesLength):\' \' | highlightText:searchTagField\"></span> <span class=\"read-more-less-fulltext-{{$index}} ng-hide\" ng-bind-html=\"isInteraction(interaction.itemType)? interaction.notes :\' \' | highlightText:searchTagField\"></span> <span ng-if=\"interaction.notes.length > notesLength\"><img class=\"read-more-{{$index}}\" ng-click=\"setCharacter(interaction.notes,interaction.notes.length,$index)\" alt=\"More\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/interaction/notesDown.png\" width=\"20\" height=\"20\"> <img class=\"read-less-{{$index}} ng-hide\" ng-click=\"setCharacter(interaction.notes,notesLength,$index)\" alt=\"Less\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/interaction/notesUp.png\" width=\"20\" height=\"20\"></span></td><td class=\"col-xs-6 rightAlign\"><span ng-bind-html=\"isInteraction(interaction.itemType)?interaction.interactionID:interaction.caseID | highlightText:searchTagField\"></span></td><div class=\"clearfix\"></div></tr></tbody></table></div><div class=\"table-pagination\" ng-show=\"!errorInRetrieving && !noPermission && !loading\"><pagination boundary-links=\"true\" max-size=\"1\" num-pages=\"numPages\" rotate=\"true\" total-items=\"totalItems.length\" items-per-page=\"6\" ng-model=\"currentPage\" class=\"pagination-sm\" previous-text=\"&lsaquo;\" next-text=\"&rsaquo;\" first-text=\"&laquo;\" last-text=\"&raquo;\"></pagination></div><div class=\"interactionError col-xs-12\" ng-show=\"errorInRetrieving && !loading\"><span translate=\"error_In_Retrieving\"></span></div><div class=\"interactionError col-xs-12\" ng-show=\"noPermission && !loading\"><span translate=\"content_currently_unavailable\"></span></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewAccountUnlock/oneViewAccountUnlock.html","<div class=\"row info-banner unlock-account-banner\" data-ng-show=\"ao.accountLockStatus && !ao.loadingDataIndicator && isRepView && ( isCare || isDealer)\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2 unlock-account-icon\"><img class=\"unlock-account-info\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/unlock/info_icon.png\"></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 unlock-account-text\"><span translate=\"acc_overview_account_locked\"></span><br></div><div class=\"pull-right unlock-account-click\"><a name=\"unlock\" class=\"pointer\" ng-click=\"ao.unlockAccount()\"><span translate=\"acc_overview_unlock\"></span></a></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewBanner/oneViewBanner.html","<div class=\"row message-banner error mtm mbm\" data-ng-show=\"(type===\'error\')\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls one-view-banner-img-container\"><div style=\"\" class=\"one-view-error-image\"></div></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 one-view-banner-msg\"><div class=\"mbs mts\" ng-bind-html=\"message\"></div></div></div></div><div class=\"row message-banner success mtm mbm\" data-ng-show=\"(type===\'success\')\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls one-view-banner-img-container\"><div class=\"one-view-success-image\"></div></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 one-view-banner-msg\"><div class=\"mbs mts\" ng-bind-html=\"message\"></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewCancelledAndSuspendAccount/oneViewCancelledAndSuspendAccount.html","<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 one-view-cancelled-account\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 one-view-border\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row info-banner\" style=\"margin-top:unset !important;\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'errorCare\' : \'warning-border-care\'\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 icon-align\"><img class=\"cancelled-icon\" ng-if=\"!ao.als.selectedAccount.accountCancelled\" src=\"images/account-suspended.png\"> <img class=\"cancelled-icon\" ng-if=\"ao.als.selectedAccount.accountCancelled\" src=\"images/account-cancelled.png\"></div><div ng-show=\"!ao.als.selectedAccount.accountCancelled\" class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9\"><span class=\"v-base-line\" compile=\"ao.als.selectedAccount.accountStatusError\" style=\"font-weight:normal\"></span></div><div ng-show=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9\"><span class=\"v-base-line mbs\" translate=\"acc_overview_account_limited_care\" style=\"font-weight:normal\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-acc_overview_account_limited_care\"></span><br><span class=\"mtl\"><a ng-show=\"bb.getIsbritebillAvailable()\" class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\"></a></span></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"></div><div class=\"pull-right ptm pbm mrm pay-now-btn-ctn\" data-ng-show=\"ao.abs.accountBalance.isCLM && ao.als.selectedAccount\"><button name=\"payBill\" class=\"plm prm cta-round primary large\" ng-click=\"ao.payBill()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\"><span class=\"white\" translate=\"acc_overview_pay_now\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewCancelledAndSuspendAccount/oneViewCancelledAndSuspendAccountConsumer.html","<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 one-view-cancelled-account\"><div class=\"col-xs-12 col-sm-11 col-md-11 col-lg-11 one-view-border\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"row info-banner\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'error\' : \'warning-border\'\" data-ng-show=\"ao.als.selectedAccount.accountStatusError && !ao.loadingDataIndicator\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><span class=\"message-banner-icon error-sign-big\" ng-class=\"ao.als.selectedAccount.accountStatusSimple === \'Error\' ? \'icon-error\' : \'icon-alert\'\"></span></div><div ng-show=\"!ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line\" ng-bind-html=\"ao.als.selectedAccount.accountStatusError\" style=\"font-weight:normal\"></span></div><div ng-show=\"ao.als.selectedAccount.accountCancelled\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span class=\"v-base-line mbs\" translate=\"acc_overview_account_limited\" style=\"font-weight:normal\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-acc_overview_account_limited\"></span><br><span class=\"mtl\"><a ng-show=\"bb.getIsbritebillAvailable()\" class=\"pointer\" ng-click=\"ao.postToRogersCancelled()\">- <span translate=\"acc_overview_view_bill\"></span></a><br><a ng-click=\"ao.viewHistory()\" class=\"pointer\">- <span translate=\"acc_overview_view_bill_history\"></span></a><br><a ng-hide=\"isDealer || isCare\" ng-click=\"ao.runRogersProfile()\" class=\"pointer\">- <span translate=\"acc_overview_manage_profile\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-acc_overview_manage_profile\"></span></a></span></div><div class=\"pull-right ptm pbm mrm pay-now-btn-ctn\" data-ng-show=\"ao.abs.accountBalance.isCLM && ao.als.selectedAccount\"><button name=\"payBill\" class=\"plm prm cta-round primary large\" ng-click=\"ao.payBill()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\"><span class=\"white\" translate=\"acc_overview_pay_now\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewDashboard/oneViewDashboard.html","<span id=\"dynatrace-user-tag\" style=\"visibility:hidden;font-size:0\">{{ao.repNameAccountNumber}}</span><section class=\"page-one-view-dashboard\"><div ng-if=\"isCare\" class=\"col-xs-12 mtm\" style=\"margin-top:0 !important\"><div data-ng-include=\"\'scripts/modules/oneView/oneViewCancelledAndSuspendAccount/oneViewCancelledAndSuspendAccount.html\'\"></div></div><div class=\"container banner-container clear-both\"><one-view-banner type=\"messageType\" message=\"backFromSSPMessage\"></one-view-banner></div><one-view-fraud-indicator></one-view-fraud-indicator><div class=\"container one-view-acbl-container\"><div class=\"col-xs-12 col-sm-4 col-md-4\"><div class=\"col-xs-12\"><div class=\"one-view-payment-widget\" ng-include=\"\" src=\"\'scripts/modules/oneView/oneViewDashboard/oneViewPaymentWidget.html\'\"></div></div><div class=\"col-xs-11\"><div class=\"one-view-border one-view-pendingOrder\" ng-if=\"ao.als.selectedAccount.accountNumber\"><ute-pending-order></ute-pending-order></div></div><div ng-if=\"!isCare\" class=\"col-xs-12 mtm\"><div data-ng-include=\"\'scripts/modules/oneView/oneViewCancelledAndSuspendAccount/oneViewCancelledAndSuspendAccountConsumer.html\'\"></div></div><div class=\"col-xs-12 mtm\"><div data-ng-include=\"\'scripts/modules/oneView/oneViewAccountUnlock/oneViewAccountUnlock.html\'\"></div></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 one-view-interaction-container\"><rep-interaction data-interaction-id=\"oneview\"></rep-interaction></div><div ng-if=\"(isCare && ao.repActionOffersUpdate)\" class=\"col-xs-12 col-sm-4 col-md-4 one-view-actions-container\"><rep-offers data-interaction-id=\"oneview\"></rep-offers></div><div ng-if=\"(isCare && !ao.repActionOffersUpdate) || !isCare\" class=\"col-xs-12 col-sm-4 col-md-4 one-view-actions-container\"><div class=\"ute-ao-directive-widget col-xs-12\"><div class=\"offersHeading redcolor row ute-ao-border-line\"><h4><span translate=\"actions_and_offers\"></span></h4></div><div class=\"one-view-actions-content\"><span translate=\"content_currently_unavailable\"></span></div></div></div></div><div class=\"page-account-overview\"><div class=\"container\"><div class=\"row my-services-list-ctn\" ng-if=\"!ao.isShareEverything()\"><div ng-if=\"ao.btnSettings.allSubscriptions !== ao.btnStatus.hidden\"><myr-my-services></myr-my-services></div></div></div><div class=\"container no-left-border mbm\" ng-if=\"!ao.isShareEverything()\"><myr-rgcl></myr-rgcl><revolution open-wirelese-package-modal=\"openWirelesePackageModal()\" open-wireless-travel-package-legal-content-modal=\"openWirelessTravelPackageLegalContentModal(ev,size)\" travel-package-data=\"travelPackageData\"></revolution></div><div class=\"container\"><div ng-if=\"((ao.isShareEverything()) && (!ao.mss.loadingData) && (!ao.abs.loadingData))\"><br><br><br><div class=\"row badgeGroupings\"><div ng-if=\"(ao.isShareEverything())\"><div class=\"sharedWireless col-xs-12 col-sm-6 col-md-4\"><h2 class=\"myservicebadgeGroup-title\" translate=\"share_everything_share\">Shared Wireless</h2><ute-data-manager-badge-list-directive data-account-number=\"{{ao.als.selectedAccount.accountNumber}}\" data-account-status=\"{{ao.als.selectedAccount.accountStatus}}\"></ute-data-manager-badge-list-directive></div></div><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=\"(ao.mss.fdmIndividualListAmount > 0) && (ao.wirelessFilteredListLength() > 0)\"><myservicebadge-group grouptype=\"individual\"></myservicebadge-group></div><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=\"ao.mss.fdmResidentialListAmount > 0\"><myservicebadge-group grouptype=\"residential\"></myservicebadge-group></div><div class=\"col-xs-12 col-sm-6 col-md-4\" ng-if=\"ao.mss.fdmOtherListAmount > 0\"><myservicebadge-group grouptype=\"otherServices\"></myservicebadge-group></div></div><div class=\"container no-left-border mbm\"><myr-rgcl></myr-rgcl><revolution open-wirelese-package-modal=\"openWirelesePackageModal()\" open-wireless-travel-package-legal-content-modal=\"openWirelessTravelPackageLegalContentModal(ev,size)\" travel-package-data=\"travelPackageData\"></revolution></div></div><div class=\"row\"><div class=\"col-xs-12\" ng-if=\"ao.mss.myOtherServicesListFinal.length > 0\"><myservicebadge-group grouptype=\"addServices\" isrepview=\"{{::!!isRepView}}\"></myservicebadge-group></div></div></div><div class=\"container\" ng-if=\"!(ao.isOtherAvailableServicesHidden() || ao.isShareEverything() || isCare)\"><div class=\"row redHeadline mbm ptm\" ng-if=\"!ao.mss.isDetailsNotFound\"><div class=\"col-xs-12 col-md-7\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"title-h2\" ng-if=\"ao.mss.isOtherServicesAvailable\" data-test-id=\"myr-oneViewDashboard-acc_overview_other_services\"><span class=\"account-other-services-heading primary-color\" translate=\"acc_overview_other_services\"></span> <span class=\"widget-loader-inline account-other-services\" ng-if=\"ao.mss.loadingData\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div></div></div></div></div><div class=\"row ptm other-services-list-ctn\" ng-if=\"(!ao.mss.loadingData && !ao.mss.isDetailsNotFound)\"><div class=\"col-xs-12 col-md-6 col-lg-4\" ng-repeat=\"msl in ao.mss.myOtherServicesListFinal | filter:{isVisible:true} track by $index\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12\"><div class=\"other-service-title\" name=\"preCleanCall\"><div ng-if=\"msl.goTo\"><a ng-click=\"msl.goTo()\" name=\"preCleanCall\" class=\"get-services-h-link\"><h5><span translate=\"{{:: msl.title}}\"></span> <span class=\"rui-icon-button-arrow-right float-none\"></span></h5></a></div><h5 ng-if=\"!msl.goTo\" class=\"get-services-link\"><span ng-if=\"!(msl.id===\'CTN\' && isDealer && ao.als.selectedAccount.accountStatus === \'Active\')\" translate=\"{{msl.title}}\"></span> <a ng-if=\"msl.id===\'CTN\' && isDealer && ao.als.selectedAccount.accountStatus === \'Active\'\" ng-click=\"ao.preCleanCall()\" class=\"get-services-link-ctn cursor-pointer\"><span translate=\"{{msl.title}}\"></span></a></h5></div><div ng-if=\"msl.id===\'Rogers Smart Home Monitoring\'\"><span translate=\"shm_msg\"></span></div><div ng-if=\"(msl.id===\'CTN\' && isDealer && !(ao.als.selectedAccount.accountStatus === \'Active\')) || (msl.id===\'CTN\' && isCare)\"><span translate=\"log_in_to_oasys_or_ssp\"></span></div><div ng-if=\"(msl.id!=\'Rogers Smart Home Monitoring\')&& (msl.id===\'Hi-Speed Internet\' || msl.id===\'Digital TV\' || msl.id===\'RHPc\')\"><span translate=\"log_in_to_sgi\"></span></div></div></div></div></div></div></div></div><div class=\"container\" id=\"myr_myoffers_account-oveview\"><div class=\"row ptm\"><div class=\"col-xs-12\"><my-offers></my-offers></div></div></div></section>");
$templateCache.put("scripts/modules/oneView/oneViewDashboard/oneViewPaymentWidget.html","<div class=\"one-view-creditlimit-availability\" ng-show=\"$root.showCreditLimitError\"><span translate=\"\">{{\'available_credit_limit_error\'}}</span></div><myr-account-balance view-html=\"ovoPaymentWidgetCreditLimitInfo.html\" loading-brite-bill=\"ao.isLoadingBriteBill()\"></myr-account-balance><ute-payment-method ovo-payment-widget-cc-information=\"\" selected-account=\"ao.selectedAccountDetails\"></ute-payment-method><myr-account-balance view-html=\"ovoPaymentWidgetAccountBalance.html\" loading-brite-bill=\"ao.isLoadingBriteBill()\"></myr-account-balance><div class=\"payment-widget-postdated-ppc-info\" ng-if=\"!!ao.mss.accountDetails.ppcList && ao.mss.accountDetails.ppcList.length>0\"><div class=\"ppc-info-heading\" translate=\"ovo_payment_widget_ppc_heading\"></div><carousel id=\"ppccarousel\" class=\"slide\" data-ride=\"carousel\" data-interval=\"false\"><div class=\"carousel-inner\" ng-class=\"{\'height140\':(ao.mss.accountDetails.ppcList.length>1)}\"><slide class=\"item\" ng-repeat=\"ppc in ao.mss.accountDetails.ppcList track by $index\"><div class=\"detail\"><div class=\"mobile\"><span class=\"icon rui-icon-basic-phone\"></span> <span class=\"text\">{{ppc.subNumber | ute_common_filter_phone : \'$1-$2-$3\'}}</span></div><div class=\"date\"><span class=\"icon rui-icon-calendar-v3\"></span> <span class=\"text\" translate=\"ovo_payment_widget_effective_date\"></span> <span class=\"date-value\">{{ ppc.futurePlanDate | date : ( (ao.appState.language===\'en\')?\'MMM dd, yyyy\': \'dd MMM yyyy\')}}</span></div></div><div class=\"message\" translate-values=\"{ fromPlan: ppc.currentPlanName,toPlan:ppc.futurePlanName }\" translate=\"ovo_payment_widget_ppc_change_text\"></div></slide></div></carousel></div>");
$templateCache.put("scripts/modules/oneView/oneViewFooter/oneViewFooter.html","<div class=\"col-sm-12 col-md-12 col-lg-12 one-view-footer-section\"><div class=\"container one-view-footer-container\"><div class=\"pdt-10 float-left\"><a href=\"/web/content/network-coverage#/map\" target=\"_blank\"><span translate=\"coverage_maps\"></span></a> <a href=\"/consumer/home\"><span class=\"border-right\" target=\"_blank\">Rogers.com</span></a></div><div class=\"float-right\"><div class=\"pdt-10 float-left\"><rep-feedback></rep-feedback></div><a class=\"float-left\" href=\"https://www.yammer.com/rci.rogers.com/#/threads/inGroup?type=in_group&amp;feedId=6316193\" target=\"_blank\"><div class=\"yammer-icon-container border-right\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/yammer/yammerIcon.png\" class=\"yammer-icon\"></div></a></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewFraudIndicator/oneViewFraudIndicator.html","<div class=\"container one-view-fraud-indicator\" ng-if=\"ofi.fraudIndicator===\'Y\'\"><div class=\"message-container\"><div class=\"title\"><span class=\"rui-icon-alert-i icon\"></span><span translate=\"\" ng-click=\"ofi.redirectToInteraction($event)\">{{\'fraud_indicator_title_text\'}}</span></div><div class=\"message\"><span translate=\"\">{{\'fraud_indicator_message\'}}</span></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewHeader/oneViewHeader.html","<div class=\"directive-repview-header\" data-ng-show=\"selfDestructFlag\"><div class=\"rep-view-top-header col-sm-12\" style=\"position: fixed\" role=\"banner\" id=\"header\"><div class=\"container\"><div class=\"navbar-header hidden-xs col-sm-2\"><a title=\"Rogers\" class=\"navbar-brand\" href=\"/\">Rogers</a></div><div class=\"rep-header-right-container col-sm-5\"><div class=\"hidden-xs col-sm-10 logout-container\"><a class=\"col-xs-5\" href=\"#\" id=\"logoutAction\"><span translate=\"sign_out\"></span> <span class=\"plan-arrow\"><span class=\"rui-icon-button-arrow-right\"></span></span></a><div class=\"col-xs-2 pull-right\" id=\"dealerCodeSection\" ng-show=\"displayDealerCodeSection\"><ute-update-dealer-code></ute-update-dealer-code></div><div class=\"col-xs-4 rep-name-container\" ng-class=\"{\'rep-name-container-withDC\' : displayDealerCodeSection && lang===\'fr\'}\" ng-if=\"!repName\"><span translate=\"welcome\"></span></div><div class=\"col-xs-7 col-sm-6 col-md-7 rep-name-container rep-container-right\" ng-class=\"{\'rep-name-container-withDC\' : displayDealerCodeSection && lang===\'fr\'}\" ng-if=\"repName\"><span translate=\"welcome_comma\"></span><span class=\"rep-name\" onselectstart=\"onRepNameSelect()\" data-ng-bind=\"repName\"></span></div></div><div id=\"nav-context-bar\" class=\"hidden-xs col-sm-2\"><a ng-click=\"changeLanguage()\"><span translate=\"language_toggle\"></span></a></div><ssp-dashboard></ssp-dashboard></div></div></div><div class=\"container\"><div class=\"new-header\"><div class=\"consumer-details-section\"><consumer-details></consumer-details></div><div class=\"dealer-code-section\"><div ng-if=\"displayDealerCodeSection\"><ute-capture-behalf-of-dealer-code></ute-capture-behalf-of-dealer-code></div></div></div></div><div class=\"col-xs-12 ov-sub-menu\"><one-view-submenu one-view-interface-flag=\"{{isOneViewInterface}}\"></one-view-submenu></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewLastBill/oneViewLastBill.html","<div class=\"directive-one-view-account-balance\" ng-show=\"(!ab.mss.selectedAccountDetail.isPrepaid) && ab.mss.selectedAccountDetail.isViewBillDisplay\"><div class=\"one-view-last-bill-title\"><h4 class=\"account-balance-title\" translate=\"last_bill_colon\"></h4><span class=\"widget-loader-inline position-abs\" ng-show=\"ab.loadingBalance\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div ng-show=\"(!ab.mss.selectedAccountDetail.isPrepaid) && ab.mss.selectedAccountDetail.isViewBillDisplay && !ab.loadingBalance\"><div><h4 class=\"account-balance\">{{ab.briteBillAccountBalance | currencies:ab.lng}}</h4></div><div style=\"font-size: 15px;color: #959797; min-height:40px;\"><span translate=\"ending\"></span> {{ab.briteBillReceivedDate}}</div><div class=\"row bill-ctn\" style=\"margin-top:18px\"><div class=\"pay-bill-ctn\" ng-class=\"{\'extraTopMarginViewBill\':ab.loadingBalance}\"><a class=\"btn-view-bill pointer\" ng-click=\"ab.postToRogers()\" data-ng-class=\"((ab.btnSettings.viewBill === ab.btnStatus.disabled) || ab.loadingBalance || ab.loadingBriteBill) ? \'not-active\' : \'\'\" data-ng-hide=\"ab.btnSettings.viewBill === ab.btnStatus.hidden\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"viewbill-account-overview,oneViewDashboard\"}\'><span translate=\"acc_balance_view_bill\" class=\"bold\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewLastBill/ovoPaymentWidgetLastBill.html","<div class=\"payment-widget-last-bill-past-due\" ng-class=\"{\'widget-last-bill-no-past-due\': (ab.abdf.accountBalance.pastDueBalance == 0.00)}\" ng-hide=\"(ab.mss.selectedAccountDetail.isPrepaid) && !ab.lastBill && (ab.abdf.accountBalance.pastDueBalance == 0.00)\"><div class=\"last-bill\" ng-class=\"{\'last-bill-noDate\': (ab.bcStartDate == undefined), \'last-bill-no-past-due\': (ab.abdf.accountBalance.pastDueBalance == 0.00) }\" ng-show=\"(!ab.mss.selectedAccountDetail.isPrepaid) && ab.lastBill && !ab.loadingBalance\"><a class=\"last-bill-title\" ng-class=\"{\'last-bill-disabled\':(!ab.IsClickEnable),\'text-fr-100\':(ab.lng===\'fr\')}\" ng-click=\"ab.IsClickEnable && ab.postToRogers()\" translate=\"{{(ab.IsClickEnable ? \'ovo_payment_widget_Last_bill\' : \'ovo_payment_widget_Last_bill_disabled\')}}\"></a> <span class=\"last-bill-amount\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.briteBillAccountBalance.substr(0,ab.briteBillAccountBalance.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.briteBillAccountBalance | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></span><div ng-if=\"(!!ab.bcStartDate && !!ab.bcEndDate )\"><span class=\"last-bill-dates\">{{ab.bcStartDate}}</span> <span class=\"last-bill-dates\">-</span> <span class=\"last-bill-dates\">{{ab.bcEndDate}}</span></div></div><div class=\"past-due\" ng-class=\"{\'past-due-no-balance\': (ab.abdf.accountBalance.pastDueBalance == 0.00), \'past-due-no-last-bill\': !ab.lastBill}\" ng-show=\"(!ab.mss.selectedAccountDetail.isPrepaid) && (!ab.abdf.accountBalance.pastDueBalance == 0.00)\"><span translate=\"ovo_payment_widget_past_due\" class=\"past-due-title\"></span> <span class=\"past-due-amount\"><sup class=\"dollar-sign\" ng-if=\"ab.lng === \'en\'\">$</sup><span class=\"\">{{ab.abdf.accountBalance.pastDueBalance.substr(0,ab.abdf.accountBalance.pastDueBalance.indexOf(\'.\'))}}</span><sup class=\"cents\">{{ab.abdf.accountBalance.pastDueBalance | decimals : ab.lng}}</sup><sup class=\"dollar-sign\" ng-if=\"ab.lng ===\'fr\'\">$</sup></span></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewInterface/oneViewInterface.html","<div class=\"sso-error-page\"><div class=\"sso-error-container\" ng-show=\"isBusinessAccessFailure\"><div class=\"row oneview-access-fail\" style=\"margin-top:unset !important;\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 icon-align\"><img class=\"oneview-access-icon\" src=\"images/account-cancelled.png\"> <span class=\"oneview-alert-message\" translate=\"business_access_failure_alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 oneview-message-align\"><span class=\"v-base-line mbs oneview-message\" translate=\"business_access_failure_message\" style=\"font-weight:normal\"></span><br></div></div></div><div class=\"sso-error-container\" ng-show=\"isFidoAccessFailure\"><div class=\"row oneview-access-fail\" style=\"margin-top:unset !important;\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 icon-align\"><img class=\"oneview-access-icon\" src=\"images/account-cancelled.png\"> <span class=\"oneview-alert-message\" translate=\"fido_access_failure_alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 oneview-message-align\"><span class=\"v-base-line mbs oneview-message\" translate=\"fido_access_failure_message\" style=\"font-weight:normal\"></span><br></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"sso-error-container\" ng-show=\"isSSOFailure\"><div class=\"sso-error-heading\"><strong translate=\"unable_to_sign_on\"></strong></div><div class=\"sso-error-description\"><span translate=\"sso_failure_description\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isAccessFailure\"><div class=\"sso-error-heading\"><strong translate=\"access_error_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"access_error_msg\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isServiceFailure\"><div class=\"sso-error-heading\"><strong translate=\"service_error\"></strong></div></div><div class=\"sso-error-container\" ng-show=\"isSessionTimeOut\"><div class=\"sso-error-heading\"><strong translate=\"session_timeout_error_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"session_timeout_error_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isGenericError\"><div class=\"sso-error-heading\"><strong translate=\"generic_error_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"generic_error_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isCareSignout\"><div class=\"sso-error-heading\"><strong translate=\"crm_signout_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"crm_signout_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isFraudCheck\"><div class=\"sso-error-heading\"><strong translate=\"oneview_fraud_credit_ops_message_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"oneview_fraud_message\"></span></div></div><div class=\"sso-error-container\" ng-show=\"isCreditOps\"><div class=\"sso-error-heading\"><strong translate=\"oneview_fraud_credit_ops_message_title\"></strong></div><div class=\"sso-error-description\"><span translate=\"oneview_credit_ops_message\"></span></div></div></div></div></div><div class=\"sso-error-container-ignite\" ng-show=\"igniteNACAccessFailure\"><div class=\"row oneview-access-fail\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 icon-align\"><img class=\"oneview-access-icon\" src=\"images/account-cancelled.png\"> <span class=\"oneview-alert-message\" translate=\"_alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 oneview-message-align\"><span class=\"oneview-message\" translate=\"ignite_nac_ram_permission_missing\"></span></div></div></div><div class=\"sso-error-container-ignite\" ng-show=\"igniteNACContactInfoMissing\"><div class=\"row oneview-access-fail\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 icon-align\"><img class=\"oneview-access-icon\" src=\"images/account-cancelled.png\"> <span class=\"oneview-alert-message\" translate=\"_alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 oneview-message-align\"><span class=\"oneview-message\" translate=\"ignite_nac_contact_info_missing\"></span> <span ng-show=\"missingFirstName\" class=\"oneview-message\" translate=\"ignite_missing_info_first_name\"></span> <span ng-show=\"missingLastName\" class=\"oneview-message\" translate=\"ignite_missing_info_last_name\"></span> <span ng-show=\"missingPhoneNumber\" class=\"oneview-message\" translate=\"ignite_missing_info_phone_number\"></span> <span ng-show=\"missingEmail\" class=\"oneview-message\" translate=\"ignite_missing_info_email\"></span> <span ng-show=\"missingLangPref\" class=\"oneview-message\" translate=\"ignite_missing_info_language_pref\"></span></div></div></div><div class=\"sso-error-container-ignite\" ng-show=\"igniteNACGenericError\"><div class=\"row oneview-access-fail\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 icon-align\"><img class=\"oneview-access-icon\" src=\"images/account-cancelled.png\"> <span class=\"oneview-alert-message\" translate=\"_alert\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 oneview-message-align\"><span class=\"oneview-message\" translate=\"ignite_nac_generic_error\"></span></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewOrders/oneViewOrders.html","<section class=\"page-one-view-dashboard\"><div class=\"container ordersContainer\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-12 orders-title\" translate=\"orders\"></div></div></div><div class=\"orders-page-content\"><div class=\"orders-filter-section\"><span class=\"filter-text\" translate=\"order_filter\"></span> <span ng-repeat=\"filter in ord.filters\"><span class=\"order-filter-checkbox\"><input type=\"checkbox\" name=\"{{filter.name}}\" id=\"{{filter.name}}-checkbox\" class=\"checkBoxClass\"> <label for=\"{{filter.name}}-checkbox\" role=\"checkbox\" aria-checked=\"{{filter.checked}}\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\": \"{{ord.ordersMappingKey}}\"}\' class=\"order-custom-checkbox\" ng-click=\"ord.fetchOrderDetails(filter)\"></label> <span class=\"pointer-class\" ng-click=\"ord.fetchOrderDetails(filter)\" tabindex=\"0\">{{filter.translateText| translate}}</span></span></span> <span class=\"clear-filter\"><a href=\"javascript:void(0)\" translate=\"order_clear_filter\" ng-click=\"ord.deselectAllFilters()\"></a></span></div><div class=\"col-xs-12 orders-table\"><div class=\"row heading-row\"><div class=\"col-xs-3 heading-column\"><div class=\"col-xs-6\"><span class=\"order-creation-date\" translate=\"order_creation_date\"></span></div><div class=\"col-xs-1\"></div><div class=\"col-xs-5\" translate=\"order_type\"></div></div><div class=\"col-xs-3 heading-column\"><div class=\"col-xs-6\"><div translate=\"order_product\"></div><div translate=\"order_product_type\"></div></div><div class=\"col-xs-6\"><span translate=\"order_service_num\"></span> <span translate=\"order_service_addr\"></span></div></div><div class=\"col-xs-4 heading-column\"><div class=\"col-xs-4\"><span translate=\"order_plan_sku\"></span> <span translate=\"order_plan_product_num\"></span></div><div class=\"col-xs-1\"></div><div class=\"col-xs-7\" translate=\"order_description\"></div></div><div class=\"col-xs-2 heading-column\"><div class=\"col-xs-5\" translate=\"order_status\"></div><div class=\"col-xs-1\"></div><div class=\"col-xs-6\"><div><span class=\"order-start-date\" translate=\"order_effective_date\"></span> <span tabindex=\"0\" class=\"sorting-icon\" ng-click=\"(ord.sortingOrder === \'ascending\') ? ord.sortOrdersBasedOnStartDate(\'descending\') : ord.sortOrdersBasedOnStartDate(\'ascending\')\"></span></div></div></div></div><div class=\"order-loading-img\" ng-if=\"ord.loading\"><img src=\"ute-common-assets/assets/widget-loader-lg_no-lang.gif\" alt=\"Page loading...\"></div><div ng-if=\"!ord.loading && !ord.noTotalOrders && !ord.noFilterSelected\"><div ng-repeat=\"orders in ord.totalOrders track by $index\"><div class=\"row body-row\"><div class=\"col-xs-3 body-column\"><div class=\"col-xs-6 black-color-text capitalize-text\" ng-if=\"orders.creationDate\" ng-bind-html=\"(ord.convertCreationDate(orders.creationDate) | date: \'longDate\')\"></div><div class=\"col-xs-6\" ng-if=\"!orders.creationDate\">–</div><div class=\"col-xs-1\"></div><div class=\"col-xs-5\" translate=\"order_price_plan\" ng-if=\"orders.orderType === \'Price Plan Change\'\"></div><div class=\"col-xs-5\" translate=\"order_wireless\" ng-if=\"orders.orderType === \'Hardware Upgrade\'\"></div></div><div class=\"col-xs-3 body-column\"><div class=\"col-xs-6 uppercase-text\" translate=\"order_wireless\"></div><div class=\"col-xs-6\" ng-if=\"orders.serviceLine\" ng-bind-html=\"(orders.serviceLine | phoneWithSpaces)\"></div></div><div class=\"col-xs-4 body-column\"><div ng-if=\"orders.orderType === \'Price Plan Change\'\"><div class=\"col-xs-4\" ng-if=\"orders.futureSoc\" ng-bind-html=\"orders.futureSoc\"></div><div class=\"col-xs-1\"></div><div class=\"col-xs-7\" translate=\"order_description_text\" translate-values=\"{oldSOCCode: orders.existingSoc, newSOCCode: orders.futureSoc, productDescription: (ord.lang === \'en\') ? orders.productDescription : orders.productionDescriptionFrench }\"></div></div><div ng-if=\"orders.orderType === \'Hardware Upgrade\'\" ng-repeat=\"plan in orders.orderLineItemsList\" class=\"wireless-plan-details\"><div class=\"col-xs-4\" ng-bind-html=\"plan.itemNumber\"></div><div class=\"col-xs-1\"></div><div class=\"col-xs-7\" ng-bind-html=\"plan.description\"></div><div class=\"col-xs-12 common-border\"></div></div></div><div class=\"col-xs-2 body-column\"><div class=\"col-xs-5 bold-font\" translate=\"order_pending\" ng-if=\"orders.orderType === \'Price Plan Change\'\"></div><div class=\"col-xs-5\" ng-if=\"orders.orderType === \'Hardware Upgrade\'\"><a href=\"javascript:void(0)\" ng-click=\"ord.togglePopover($index)\">{{orders.orderStatus|translate}}</a></div><div class=\"col-xs-1\"></div><div class=\"col-xs-6 capitalize-text\" ng-if=\"orders.effectiveDate\" ng-bind-html=\"ord.decideDateFilter(orders.effectiveDate)\"></div><div class=\"col-xs-6\" ng-if=\"!orders.effectiveDate\">–</div></div></div><div class=\"row relative-position\" ng-if=\"orders.orderType === \'Hardware Upgrade\' && ord.displayWirelessOrderPopup[$index]\"><div class=\"wireless-order-popup arrow-top\"><wireless-orders-popup index=\"{{$index}}\" close-popover=\"ord.togglePopover\" item-details=\"orders.orderLineItemsList\"></wireless-orders-popup></div></div></div></div></div><div ng-if=\"ord.noFilterSelected && !ord.loading\"><div class=\"row select-filter-section\"><div class=\"col-xs-1 info-section\"></div><div class=\"col-xs-11 select-filter-text\"><span translate=\"order_msg_on_empty_filters\"></span></div></div></div><div ng-if=\"!ord.noFilterSelected && ord.noTotalOrders && !ord.loading\" class=\"\"><div class=\"row no-orders-section\"><div class=\"col-xs-1 no-orders-image-section\"></div><div class=\"col-xs-11 no-orders-text\"><span translate=\"order_no_orders\" adl-event-track=\'{\"mappingKey\":\"{{ord.noOrdersMappingKey}}\"}\'></span></div></div></div></div></div></section>");
$templateCache.put("scripts/modules/oneView/oneViewNews/oneViewNews.html","<div class=\"oneview-news-directive\"><div class=\"row news-section\" ng-show=\"isResponseAvailable\"><div class=\"news-tab-container\"><div id=\"newsCarousel\" class=\"owl-carousel owl-theme\"><div class=\"item\" ng-repeat=\"i in ovn.newsInfo.items\"><a href=\"{{i.link}}\" target=\"_blank\"><div class=\"ellipsis-content\" data-ellipsis=\"\" data-ng-bind=\"i.title\"></div><div class=\"pub-date\">{{getTimeStamp(i.pub_date)}}</div></a></div></div><div class=\"news-content\"><ul class=\"title-section\"><li ng-repeat=\"i in ovn.newsInfo.items track by $index\"><a href=\"{{i.link}}\" target=\"_blank\"><div class=\"news-number\">{{$index+1}}</div><div class=\"news-title\"><div>{{i.title}}</div><div class=\"pub-date\">{{getTimeStamp(i.pub_date)}}</div></div></a></li></ul></div></div></div><div ng-show=\"!isResponseAvailable && isNewsInfoNotReady\" style=\"padding-top:30px\" translate=\"content_currently_unavailable\"></div><div class=\"newsLoader\" ng-hide=\"isResponseAvailable || isNewsInfoNotReady\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewSubmenu/oneViewSubmenu.html","<div class=\"cart-menu-directive\" ng-if=\"!isConsumer\"><div class=\"container\" style=\"height: 54px;\"><cart-menu></cart-menu></div></div><div class=\"directive-repview-submenu\"><div class=\"menu-container\"><div class=\"container\"><header class=\"navbar navbar-header navbar-fixed-top status-post\" role=\"banner\" id=\"header\"><div class=\"navbar-header visible-xs\"><button title=\"Menu\" class=\"navbar-toggle collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#rep-view-menu\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <i class=\"rui-icon-menu\"></i></button> <a title=\"Rogers\" class=\"navbar-brand\" href=\"/\">Rogers</a></div><div class=\"shadow\" ng-click=\"menuClick()\"></div><nav id=\"rep-view-menu\" class=\"navbar-collapse bs-navbar-collapse collapse\" aria-expanded=\"false\" style=\"height: 4px;\"><ul class=\"nav navbar-nav\"><li id=\"username\"><span class=\"signedin\"><i class=\"rui-icon-lock-small\"></i> <span>Welcome</span> <span id=\"user-name\"></span></span> <a href=\"#\" id=\"logoutAction\">Sign out <i class=\"rui-icon-arrow-right\"></i></a></li><li class=\"\"><a ui-sref=\"oneViewDashboard\" class=\"overview-mobile\" role=\"button\" data-ng-class=\"(isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.overview ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"acc_overview_my_account_overview\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li ng-if=\"(isDealer || isCare) && isPrepaid\"><a class=\"pointer\" data-ng-class=\"(!repPaymentStart ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.billingAndPayment ? \'oneViewSelectedTab\' : \'\')\" ng-click=\"repPaymentStart && isSubMenuEnabled(\'billingAndPayment\') && rogersORpaybill()\" role=\"button\"><div><span translate=\"submenu_billing_and_payment\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"dropdown\" ng-if=\"(isDealer || isCare) && !isPrepaid\"><a class=\"pointer services-menu\" data-ng-class=\"(isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.billingAndPayment ? \'oneViewSelectedTab\' : \'\')\" data-toggle=\"dropdown\" role=\"button\" ng-click=\"postToRogers()\"><div><span translate=\"submenu_billing_and_payment\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"viewbill-billing-and-payment,oneViewDashboard\"}\'></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\"><a class=\"pointer services-menu\" id=\"servicesDropDown\" data-ng-class=\"(isSubMenuEnabled(\'services\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.services ? \'oneViewSelectedTab\' : \'\')\" ng-click=\"isSubMenuEnabled(\'services\') && navSubMenuClick($event)\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\"><div><span translate=\"submenu_services\"></span> <span class=\"rui-icon-arrow-down\"></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"servicesDropDown\" data-ng-show=\"isDropDownEnabled()\"><li data-ng-repeat=\"msl in subMenuMyServicesList track by $index\" data-ng-hide=\"hideDropDown()\"><a ng-if=\"!msl.subscriptionBadgeModule && !(isCare && msl.serviceName === \'shmdashboard\')\" ng-hide=\"msl.hide\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\') : \'\'\"><span class=\"service-account-type\" translate=\"{{msl.serviceType}}\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\')\"></span> <span class=\"service-account-number\" ng-hide=\"((isDealer || isCare) && msl.serviceName === \'homephone\')\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'shareEverything\' || msl.serviceName === \'homephone\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | ute_common_filter_phone2) : \'\'}}</span></a> <a ng-if=\"msl.subscriptionBadgeModule\" ng-click=\"resolveService(msl)\"><span class=\"service-account-type\" translate=\"{{msl.serviceType}}\"></span></a></li><li ng-show=\"isWireless\"><a role=\"menuitem\" tabindex=\"-1\"><span translate=\"service_wireless\"></span></a></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" class=\"divider\"></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"linkaccount\"><span class=\"service-account-type\" translate=\"submenu_link_account\"></span></a></li><li ng-show=\"isWirelessAccount && repTransferOfResponsibilityStart\"><a ng-class=\"(!isAccountCancelledOrSuspended) ? \'pointer\' : \'disabled-link\'\" role=\"menuitem\" tabindex=\"-1\" ng-click=\"!isAccountCancelledOrSuspended ? goToTransferOfResponsibility() : \'\'\"><span class=\"service-account-type\" translate=\"transfer_of_responsibility\"></span></a></li><li ng-if=\"repBundleBuilderAccess\"><a class=\"pointer\" ng-click=\"redirectToOASYS()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oasys-bundle\"}\'>{{ \'oneview_bundlebuilder\' | translate }}&nbsp;&nbsp;<i class=\"fa fa-external-link\"></i></a></li></ul></li><li class=\"\"><a ng-click=\"repProfileRead && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" role=\"button\" class=\"pointer\" data-ng-class=\"(!repProfileRead ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.profile ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"submenu_profile\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li><a ng-click=\"repInteractionRead && redirectToInteraction()\" href=\"\" ng-class=\"(!repInteractionRead ? \'noAgentPermission\' : \'\')+\' \'+(selSubMenuItem === subMenuItems.interaction ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"interaction\"></span> <span class=\"interaction-count\">({{interactionLength}})</span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li ng-if=\"isCare && repActionOffersUpdate\" class=\"\"><a ng-click=\"redirectToActionsOffers()\" href=\"\" role=\"button\" ng-class=\"(selSubMenuItem === subMenuItems.actionsOffers ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"actions_and_offers\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"visible-xs\" id=\"languageToggle\"><div id=\"nav-context-bar\" class=\"\"><a ng-click=\"changeLanguage()\"><span translate=\"language_toggle\"></span></a></div></li></ul></nav><div id=\"nav-actions\" class=\"visible-xs\"><div id=\"search\"><a title=\"Search\" href=\"http://nova.rogers.com\" data-toggle=\"modal\" target=\"_blank\"><i class=\"rui-icon-search\"></i></a></div></div></header></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewSubmenu/oneViewSubmenuForInterface.html","<div class=\"directive-repview-submenu\"><div class=\"menu-container\"><div class=\"container\"><header class=\"navbar navbar-header navbar-fixed-top status-post\" role=\"banner\" id=\"header\"><div class=\"navbar-header visible-xs\"><button title=\"Menu\" class=\"navbar-toggle collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#rep-view-menu\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <i class=\"rui-icon-menu\"></i></button> <a title=\"Rogers\" class=\"navbar-brand\" href=\"/\">Rogers</a></div><div class=\"shadow\" ng-click=\"menuClick()\"></div><nav id=\"rep-view-menu\" class=\"navbar-collapse bs-navbar-collapse collapse\" aria-expanded=\"false\" style=\"height: 4px;\"><ul class=\"nav navbar-nav\"><li id=\"username\"><span class=\"signedin\"><i class=\"rui-icon-lock-small\"></i> <span>Welcome</span> <span id=\"user-name\"></span></span> <a href=\"#\" id=\"logoutAction\">Sign out <i class=\"rui-icon-arrow-right\"></i></a></li><li class=\"\"><a class=\"no-pointer\" role=\"button\"><div><span translate=\"acc_overview_my_account_overview\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"\"><a class=\"no-pointer\" role=\"button\"><div><span translate=\"submenu_billing_and_payment\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"\"><a class=\"no-pointer services-menu\" id=\"drop1\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\"><div><span translate=\"submenu_services\"></span> <span class=\"rui-icon-arrow-down\"></span></div></a></li><li class=\"\"><a role=\"button\" class=\"no-pointer\"><div><span translate=\"submenu_profile\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li><a class=\"no-pointer\"><div><span translate=\"interaction\"></span> <span class=\"interaction-count\">({{interactionLength}})</span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li><a class=\"no-pointer\"><div><span translate=\"actions_and_offers\"></span> <span class=\"rui-icon-arrow-down hidden-xs\"></span></div></a></li><li class=\"visible-xs\" id=\"languageToggle\"><div id=\"nav-context-bar\" class=\"\"><a ng-click=\"changeLanguage()\"><span translate=\"language_toggle\"></span></a></div></li></ul></nav><div id=\"nav-actions\" class=\"visible-xs\"><div id=\"search\"><a title=\"Search\" href=\"http://nova.rogers.com\" data-toggle=\"modal\" target=\"_blank\"><i class=\"rui-icon-search\"></i></a></div></div></header></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewSwitch/oneViewSwitch.html","<div class=\"one-view-switch\" data-ng-show=\"selfDestructFlag\"><div class=\"switch-container\"><a class=\"red-border-btn\" ng-click=\"!isToggleSwitchDisabled && runRepView()\" ng-disabled=\"isToggleSwitchDisabled\" ng-class=\"{\'red-btn-padding\': (lang===\'fr\'),\'no-pointer\': (isToggleSwitchDisabled)}\"><span class=\"bold pointer\" translate=\"rep_view\"></span></a> <a class=\"border-less-btn\" ng-click=\"!isToggleSwitchDisabled && runUserView()\" ng-disabled=\"isToggleSwitchDisabled\" ng-class=\"{\'no-pointer\': (isToggleSwitchDisabled),\'red-btn-padding\':(lang===\'fr\')}\"><span class=\"bold pointer\" translate=\"customer_view\"></span></a></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewToggle/oneViewToggle.html","<div class=\"toggle-context-container col-sm-12 col-md-12 col-lg-12\" id=\"toggleSwitch\"><div style=\"padding-top:10px\"><a class=\"border-less-btn\" ng-click=\"!isToggleSwitchDisabled && runRepView()\" ng-disabled=\"isToggleSwitchDisabled\" ng-class=\"{\'no-pointer\': (isToggleSwitchDisabled)}\"><span class=\"bold pointer\" translate=\"rep_view\"></span></a> <a class=\"red-border-btn\" ng-click=\"!isToggleSwitchDisabled && runUserView()\" ng-disabled=\"isToggleSwitchDisabled\" ng-class=\"{\'no-pointer\': (isToggleSwitchDisabled)}\"><span class=\"bold pointer\" translate=\"customer_view\"></span></a></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewWeather/oneViewWeather.html","<div class=\"row directive-oneview-weather\"><div class=\"col-xs-12 textCenter\" ng-show=\"!isWeatherInfoReady\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div><div class=\"col-xs-12\" ng-show=\"isWeatherInfoReady && !addressUnavailable\"><div class=\"col-sm-7 col-xs-4 weatherAddressDiv\"><div class=\"weatherStreetAddress\">{{weatherInformation.streetAddress}}</div><div>{{weatherInformation.cityProvince}}</div><div>{{weatherInformation.postalCode}}</div></div></div><div class=\"col-xs-12 text-center address-Unavailable\" ng-show=\"isWeatherInfoReady && addressUnavailable\"><span class=\"col-xs-12\" translate=\"content_currently_unavailable\"></span></div></div>");
$templateCache.put("scripts/modules/oneView/repFeedback/repFeedback.html","<a ng-click=\"openSurveyLink()\"><span translate=\"report_issue\" class=\"border-right\"></span></a>");
$templateCache.put("scripts/modules/oneView/sspDashBoard/sspDashBoard.html","<div ng-show=\"userTypeDealer\"><div ng-show=\"false\"><form name=\"formToSSP\" id=\"formToSSP\" method=\"post\" novalidate=\"\"><input type=\"hidden\" name=\"data\" id=\"sharedKey\"><br><input type=\"hidden\" name=\"sig\" id=\"signature\"><br><input type=\"hidden\" name=\"content\" id=\"content\"><br></form></div></div>");
$templateCache.put("scripts/modules/oneView/successBanner/successBanner.html","<div class=\"row message-banner success mtm mbm\" data-ng-show=\"message\"><div class=\"pln prn\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 mls\" style=\"max-width: 45px;\"><i class=\"fa fa-check-circle-o fa-2x success-color\"></i></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10\" style=\"padding: 5px 10px 0 5px;font-weight:normal;\"><div class=\"mbs mts\" ng-bind-html=\"message\"></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/employeePlanErrorModal.html","<section><div class=\"errorHeader\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"errorlogo col-xs-2 col-lg-1\"><img src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/warning.png\"></div><div class=\"errortext col-xs-9 col-lg-10\" translate=\"cant_process_request\"></div><div class=\"exitclose\"><div class=\"existClose\" ng-click=\"continue()\"></div></div></div></div></div><div class=\"errorBody\"><div class=\"row\"><div class=\"col-xs-12 marginTop\"><p translate=\"employee_discount_line\"></p></div></div></div></section>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcAdditionalLineErrorModal.html","<div class=\"totes-project mppc-modal\"><div class=\"modal-header\"><div class=\"col-xs-1\"><img src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/warning.png\"></div><div class=\"col-xs-11\" style=\"padding-top:10px;\"><div class=\"modal-title\"><span translate=\"_something_went_wrong\"></span></div></div></div><div class=\"modal-body\"><div class=\"col-xs-12\"><span translate=\"add_additional_line_error\"></span></div></div><div class=\"row\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\"><span translate=\"_continue\"></span></button></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcEntry1Modal.html","<div class=\"totes-project mppc-modal entry-1\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\"><div class=\"row\"><div class=\"col-xs-12 col-sm-5 vcenter\" ng-click=\"changeCurrentPlan()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/edit-current-ctn.png\"></div><span translate=\"mppc_entry_1_change_current_plan\"></span></div></div><div class=\"col-xs-12 col-sm-2 vcenter or-div text-center\"><span translate=\"mppc_entry_3_or\"></span></div><div class=\"col-xs-12 col-sm-5 vcenter\" ng-click=\"createSharedGroup()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/create-shared-group.png\"></div><span translate=\"mppc_entry_1_create_shared_plan\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"back-button\" href=\"\" ng-click=\"cancel()\"><span translate=\"mppc_entry_1_cancel\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcEntry3Modal.html","<div class=\"totes-project mppc-modal entry-3\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\"><h3 class=\"modal-title\"><span translate=\"mppc_entry_3_change_wireless_plan\"></span></h3><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\"><span translate=\"mppc_entry_3_change_current_plan\"></span></div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"changeCurrentPlan()\"><span translate=\"_continue\"></span></button></div></div></div><div class=\"text-center or-div\"><span translate=\"mppc_entry_3_or\"></span></div><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\"><span translate=\"mppc_entry_3_add_to_share_plan\"></span></div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"addToSharedGroup()\"><span translate=\"_continue\"></span></button></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"back-button\" href=\"\" ng-click=\"cancel()\"><span translate=\"mppc_entry_3_cancel\"></span></a></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupIndividualModal.html","<div class=\"totes-project mppc-modal\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"modal-title\"><span translate=\"mppc_shared_group_indiv_title\"></span></h3><div class=\"benefit-link\" ng-click=\"toggleBenefits()\"><span translate=\"mppc_shared_group_indiv_benefits\"></span> <i class=\"fa\" ng-class=\"{\'fa-chevron-down\':!model.showBenefits, \'fa-chevron-up\':model.showBenefits}\"></i></div><div ng-show=\"model.showBenefits\" class=\"benefits\"><span translate=\"mppc_shared_group_indiv_switch_reason_intro\"></span><ul><li><span translate=\"mppc_shared_group_indiv_switch_reason_1\"></span></li><li><span translate=\"mppc_shared_group_indiv_switch_reason_2\"></span></li><li><span translate=\"mppc_shared_group_indiv_switch_reason_3\"></span></li></ul></div><div ng-show=\"!model.isCtnSelected\"><span translate=\"select_a_number\"></span></div><div ng-show=\"model.isCtnSelected\"><span translate=\"add_additional_line_error\" class=\"selectCtnError\"></span></div><div class=\"panel panel-default panel-individual\"><div class=\"panel-body\"><div class=\"individual-line row\" ng-repeat=\"individualLine in model.subscribers | filter: filterSubscribers track by $index\" ng-class=\"{\'last\': $last}\"><input type=\"checkbox\" ng-model=\"model.selectedSubscribersCheckBox[individualLine.subscriberNumber]\" data-icheck=\"\"> {{::individualLine.subscriberNumber | ute_common_filter_phone2}}</div></div></div><div class=\"row\"><div class=\"col-xs-6\"><a class=\"back-button\" href=\"\" ng-click=\"cancel()\"><span translate=\"_cancel\"></span></a></div><div class=\"col-xs-6\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\"><span translate=\"_add\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/bfappc/mppcSharedGroupPrimaryModal.html","<div class=\"totes-project mppc-modal\"><div class=\"modal-header\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"modal-title\"><span translate=\"mppc_shared_group_primary_title\"></span></h3><div class=\"panel panel-default panel-individual\"><div class=\"panel-body\"><div class=\"individual-line row\"><input type=\"radio\" ng-model=\"model.selectedPrimaryCtn\" data-icheck=\"\" value=\"{{model.currentCtn}}\"> {{model.currentCtn | ute_common_filter_phone2}}</div><div class=\"individual-line row\" ng-repeat=\"ctn in model.selectedAdditionalSubscribers track by $index\" ng-class=\"{\'last\': $last}\"><input type=\"radio\" ng-model=\"model.selectedPrimaryCtn\" data-icheck=\"\" value=\"{{ctn}}\"> {{ctn | ute_common_filter_phone2}}</div></div></div><div class=\"row\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\"><span translate=\"_continue\"></span></button></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/deviceDetailsModal.html","<div class=\"info-modal-top-banner\"><div class=\"info-modal-heading\" translate=\"ute.rogers.wireless.deviceModalHeading\"></div></div><div ng-if=\"!info.isUpFrontRvAmount\"><div class=\"info-modal-device-dates\"><div ng-if=\"::info.balanceObj.subsidyStartDate\"><div class=\"info-modal-device-bottom-heading\"><span ng-if=\"!rvCustomerInfo.rvCustomer\" translate=\"last_update_date\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_last_upgarde\"></span></div><div class=\"info-modal-device-bottom-info\">{{::info.balanceObj.subsidyStartDate | date:\'MMM dd, yyyy\'}}</div></div><div ng-if=\"::info.balanceObj.subsidyEndDate\"><div class=\"info-modal-device-bottom-heading\"><span ng-if=\"!rvCustomerInfo.rvCustomer\" translate=\"device_balance_will_be/was\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_device_balance_will_be/was\"></span></div><div class=\"info-modal-device-bottom-info\"><span translate=\"zero_dollar_on\"></span> <span>{{::info.balanceObj.subsidyEndDate | date:\'MMM dd, yyyy\'}}</span></div></div><div class=\"info-modal-device-bottom-heading\"><span ng-if=\"!rvCustomerInfo.rvCustomer\" translate=\"device_balance_today_checkBalance\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_device_balance_today_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.finance\">{{::(info.balance[0] + info.balance[1]) | currency}}</span> <span ng-if=\"::info.balanceObj.subsidyBalance && !info.finance\">{{::info.balanceObj.subsidyBalance | currency:undefined:2}}</span> <span ng-if=\"::!info.balanceObj.subsidyBalance && !info.finance\">{{::0 | currency}}</span></div></div><div class=\"info-modal-device-instructions\" ng-if=\"info.finance || info.balanceObj.subsidyAmount != 0\"><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-body\" ng-class=\"(rvCustomerInfo.rvCustomer)? \'rv-customer-message-body\' : \'\'\"><span ng-if=\"!info.finance && !rvCustomerInfo.rvCustomer\" translate=\"flextab_balance_desc_checkBalance\"></span> <span ng-if=\"info.finance && !rvCustomerInfo.rvCustomer\" translate=\"financing_balance_desc\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_balance_desc_checkBalance\"></span></div><span ng-if=\"!info.finance && !rvCustomerInfo.rvCustomer\" translate=\"flextab_monthly_deduction_checkBalance\"></span> <span ng-if=\"info.finance && !rvCustomerInfo.rvCustomer\" translate=\"financing_monthly_payment\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_monthly_deduction_checkBalance\"></span> <strong><span ng-if=\"::info.balanceObj.subsidyAmount && !info.finance\">{{::(info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | currency}}</span> <span ng-if=\"::info.finance\">{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span> <span ng-if=\"::info.balanceObj.subsidyAmount || info.finance\" translate=\"month_checkBalance\"></span></strong></div><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-heading\"><span ng-if=\"!info.finance && !rvCustomerInfo.rvCustomer\" translate=\"flextab_term_length_checkBalance\"></span> <span ng-if=\"info.finance && !rvCustomerInfo.rvCustomer\" translate=\"number_of_financing_monthly_payments\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_term_length_checkBalance\"></span></div><strong><span ng-if=\"::info.balanceObj.subsidyTerm\" data-ng-bind-html=\"info.balanceObj.subsidyTerm\"></span> <span ng-if=\"::info.balanceObj.subsidyTerm\" translate=\"months_checkBalance\"></span></strong></div><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-heading\"><span ng-if=\"!info.finance && !rvCustomerInfo.rvCustomer\" translate=\"flextab_balance_checkBalance\"></span> <span ng-if=\"info.finance && !rvCustomerInfo.rvCustomer\" translate=\"outstanding_financing_balance\"></span> <span ng-if=\"rvCustomerInfo.rvCustomer\" translate=\"rv_customer_balance_checkBalance\"></span></div><strong ng-if=\"::info.balanceObj.subsidyBalance && !info.finance\">{<span>{{::(info.balanceObj.subsidyBalance / (info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | number:0)}}</span>} x {<span>{{::(info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | currency}}</span>}</strong> <strong ng-if=\"::info.finance\">{<span>{{::(info.balanceObj.remainingInstallmentBalance / info.balanceObj.monthlyInstallmentAmount) | number:0}}</span>} x {<span>{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span>}</strong></div></div></div><div ng-if=\"info.isUpFrontRvAmount\"><div class=\"info-modal-device-dates\"><div ng-if=\"::info.balanceObj.subsidyStartDate\"><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_customer_last_upgarde\"></span></div><div class=\"info-modal-device-bottom-info\">{{::info.balanceObj.subsidyStartDate | date:\'MMM dd, yyyy\'}}</div></div><div ng-if=\"::info.balanceObj.subsidyEndDate\"><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_customer_device_balance_will_be/was\"></span></div><div class=\"info-modal-device-bottom-info\"><span translate=\"zero_dollar_on\"></span> <span>{{::info.balanceObj.subsidyEndDate | date:\'MMM dd, yyyy\'}}</span></div></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_customer_device_balance_today_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.finance\">{{::(info.balance[0] + info.balance[1]) | currency}}</span> <span ng-if=\"::info.balanceObj.subsidyBalance && !info.finance\">{{::info.balanceObj.subsidyBalance | currency:undefined:2}}</span> <span ng-if=\"::!info.balanceObj.subsidyBalance && !info.finance\">{{::0 | currency}}</span></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_upfrontAmount_monthly_deduction_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.balanceObj.subsidyAmount && !info.finance\">{{::(info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | currency}}</span> <span ng-if=\"::info.finance\">{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span> <span ng-if=\"::info.balanceObj.subsidyAmount || info.finance\" translate=\"month_checkBalance\"></span></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_customer_term_length_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.balanceObj.subsidyTerm\" data-ng-bind-html=\"info.balanceObj.subsidyTerm\"></span> <span ng-if=\"::info.balanceObj.subsidyTerm\" translate=\"months_checkBalance\"></span></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_customer_balance_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.balanceObj.subsidyBalance && !info.finance\">{<span>{{::(info.balanceObj.subsidyBalance / (info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | number:0)}}</span>} x {<span>{{::(info.balanceObj.subsidyAmount / info.balanceObj.subsidyTerm) | currency}}</span>}</span> <span ng-if=\"::info.finance\">{<span>{{::(info.balanceObj.remainingInstallmentBalance / info.balanceObj.monthlyInstallmentAmount) | number:0}}</span>} x {<span>{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span>}</span></div><div class=\"info-modal-device-instructions\"><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-body\" ng-class=\"(rvCustomerInfo.rvCustomer)? \'rv-customer-message-body\' : \'\'\"><span translate=\"rv_upfrontAmount_desc\"></span></div></div></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"rv_upfront_edge_amount\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.balanceObj.rvInformation.rvAmount\">{{::info.balanceObj.rvInformation.rvAmount | currency}}</span></div><div class=\"info-modal-device-instructions\"><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-body\" ng-class=\"(rvCustomerInfo.rvCustomer)? \'rv-customer-message-body\' : \'\'\"><span translate=\"rv_upfrontAmount_desc_sec\"></span></div></div></div></div></div><div class=\"info-modal-upfront-faq\" ng-if=\"rvCustomerInfo.rvCustomer || info.isUpFrontRvAmount\"><a href=\"/customer/support/article/upfront-edge\"><span class=\"upfront-advantage\" translate=\"wireless_dashboard_rv_customer_upfront_faq\"></span></a></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/financedDeviceDetailsModal.html","<div class=\"info-modal-top-banner\"><div class=\"info-modal-heading\" translate=\"ute.rogers.wireless.deviceModalHeading\"></div></div><div class=\"info-modal-device-dates\"><div ng-if=\"::info.balanceObj.subsidyStartDate\"><div class=\"info-modal-device-bottom-heading\"><span translate=\"last_update_date\"></span><div class=\"info-modal-device-bottom-info\">{{::info.balanceObj.subsidyStartDate | date:\'MMM dd, yyyy\'}}</div></div></div><div ng-if=\"::info.balanceObj.subsidyEndDate\"><div class=\"info-modal-device-bottom-heading\"><span translate=\"device_balance_will_be/was\"></span></div><div class=\"info-modal-device-bottom-info\"><span translate=\"zero_dollar_on\"></span> <span>{{::info.balanceObj.subsidyEndDate | date:\'MMM dd, yyyy\'}}</span></div></div><div class=\"info-modal-device-bottom-heading\"><span translate=\"device_balance_today_checkBalance\"></span></div><div class=\"info-modal-device-bottom-info\"><span ng-if=\"::info.finance\">{{::(info.balance[0] + info.balance[1]) | currency}}</span> <span ng-if=\"::!info.balanceObj.subsidyBalance && !info.finance\">{{::0 | currency}}</span></div></div><div class=\"info-modal-device-instructions\"><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-body\"><span translate=\"financing_balance_desc_new\"></span></div><span translate=\"financing_monthly_payment\"></span> <strong><span>{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span> <span translate=\"month_checkBalance\"></span></strong></div><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-heading\"><span translate=\"number_of_financing_monthly_payments\"></span></div><strong ng-if=\"::info.balanceObj.subsidyTerm\"><span data-ng-bind-html=\"info.balanceObj.subsidyTerm\"></span> <span translate=\"months_checkBalance\"></span></strong></div><div class=\"info-modal-device-row\"><div class=\"info-modal-device-instructions-heading\"><span translate=\"outstanding_financing_balance\"></span></div><strong>{<span>{{::(info.balanceObj.remainingInstallmentBalance / info.balanceObj.monthlyInstallmentAmount) | number:0}}</span>} x {<span>{{::info.balanceObj.monthlyInstallmentAmount | currency}}</span>}</strong></div></div><div class=\"info-modal-edge-faq\"><a href=\"/customer/support/article/edge-financing\" title=\"{{\'wireless_dashboard_device_financing_faq\' | translate}}\"><span class=\"edge-advantage\" translate=\"wireless_dashboard_device_financing_faq\"></span> <i class=\"rui-icon-arrow-right\"></i></a></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/planDetailsModal.html","<div class=\"info-modal-top-banner\"><div class=\"info-modal-heading\" translate=\"ute.rogers.wireless.planDetails\"></div></div><div class=\"info-modal-plan-feature-list\"><ul><li ng-repeat=\"addon in info.wp.features track by $index\"><div data-ng-if=\"::addon.overAgeRate\"><span class=\"info-modal-plan-feature\" data-translate=\"ute.rogers.wireless.overagetext\"></span> <span class=\"info-modal-plan-feature\">{{::addon.overAgeRate}}</span></div><span data-ng-if=\"::!addon.overAgeRate\" class=\"info-modal-plan-feature\">{{::addon}}</span></li><div style=\"clear:both\"></div></ul></div><div class=\"info-modal-plan-addon-container\"><div class=\"row info-modal-plan-row\" ng-repeat=\"addon in info.wp.postPaidAddons\"><div ng-if=\"::addon.addonMSF > 0 && $index != 0\"><div class=\"col-xs-9 info-modal-plan-addon\"><span ng-if=\"info.lng == \'en\' || addon.socDescFr != \'\'\">{{::addon.socDesc}}</span> <span ng-if=\"info.lng == \'fr\'\">{{::addon.socDescFr}}</span><div class=\"info-modal-plan-addon-info\" ng-if=\"addon.expiryDate\"><span translate=\"expires\"></span> <span>{{::addon.expiryDate | date:\'MMM dd, yyyy\'}}</span></div></div><div class=\"col-xs-3 info-modal-plan-addon-cost\"><div ng-if=\"info.isDiscountMode(addon.soc)\"><span>{{::addon.addonMSF | currency}}</span> <span>{{::info.getDiscountRate(addon.addonMSF)| currency}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\' && addon.soc !== \'APLSRA000\'\" translate=\"ute.rogers.wireless.mo\"></span></div><div ng-if=\"::!info.isDiscountMode(addon.soc)\"><span>{{::addon.addonMSF| currency}}</span> <span data-ng-if=\"::addon.socClass !== \'UP\' && addon.soc !== \'APLSRA000\'\" translate=\"ute.rogers.wireless.mo\"></span></div></div></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/talkAndTextModal.html","<div class=\"info-modal-top-banner\"><div role=\"heading\" class=\"info-modal-heading\" translate=\"ute.rogers.wireless.talkTextModalHeading\"></div></div><div class=\"info-modal-body\"><div class=\"info-modal-bill-cycle\" data-ng-if=\"info.displayContent\"><div class=\"info-modal-bill-cycle-date\" translate=\"wireless_new-usage-cycle\" translate-value-nextbilldaysuntil=\"{{:: info.nextCycle.accountBalance.nextBillDate| date3 }}\" data-test-id=\"myr-wirelessDashboard-wireless_new-usage-cycle\"></div></div><table role=\"table\" class=\"info-modal-talk-table container\"><div role=\"heading\" aria-level=\"3\" class=\"info-modal-sub-banner-heading\" translate=\"wireless_talk\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_talk-limited\"></div><tbody><tr class=\"row info-modal-table-divide\"><th scope=\"col\"></th><th scope=\"col\" class=\"col-xs-4 col-xs-push-4 info-modal-table-head\" translate=\"wireless_usage_included\"></th><th scope=\"col\" class=\"col-xs-4 col-xs-push-4 info-modal-table-head\"><span translate=\"wireless_usage_my-usage\" ng-if=\"::info.wd.talkArr[0].usageType !== \'unlimited\'\"></span> <span translate=\"wireless_usage_total-usage\" ng-if=\"::info.wd.talkArr[0].usageType === \'unlimited\'\"></span></th></tr><tr class=\"row info-modal-table-row\" ng-repeat=\"wdtsum in info.wd.talkArr\" ng-if=\"::wdtsum.usageType !== \'pay-per-use\'\"><th scope=\"row\" class=\"col-xs-4 info-modal-table-head-row\"><span ng-if=\"::wdtsum.usageType === \'extras_summary\'\">Extras</span> <span ng-if=\"::wdtsum.usageType !== \'extras_summary\'\"><span ng-if=\"::wdtsum.periodGroup !== \'Weeknight/Weekend\' && wdtsum.periodGroup !== \'Soirs/w-end\'\">{{wdtsum.periodGroup}}</span><span ng-if=\"::wdtsum.periodGroup === \'Weeknight/Weekend\'\">Weeknight/ Weekend</span> <span ng-if=\"::wdtsum.periodGroup === \'Soirs/w-end\'\">Soirs/ w-end</span></span></th><td class=\"col-xs-4 info-modal-table-cell\"><span ng-if=\"::wdtsum.usageType === \'unlimited\'\" class=\"usuage-ammount\" translate=\"wireless_unlimited\"></span> <span ng-if=\"::wdtsum.usageType === \'pay-per-use\'\" class=\"usuage-ammount\" translate=\"wireless_extra-usage\"></span> <span ng-if=\"::wdtsum.usageType === \'limited\'\" class=\"usuage-ammount\">{{::wdtsum.total | number}} <span translate=\"wireless_usage_minutes\"></span></span></td><td class=\"col-xs-4 info-modal-table-cell\"><div ng-if=\"::wdtsum.isFamilySharing === true\"><span>{{::wdtsum.subscriberUsage| unlimitedUsage}} <span ng-if=\"::wdtsum.subscriberUsage >= 0\" translate=\"wireless_usage_minutes\"></span></span></div><div ng-if=\"::wdtsum.isFamilySharing === false\"><span class=\"usuage-ammount\">{{::wdtsum.used| number}} <span translate=\"wireless_usage_minutes\"></span></span></div></td></tr></tbody></table><table role=\"table\" class=\"info-modal-text-table container\"><div role=\"heading\" aria-level=\"3\" class=\"info-modal-sub-banner-heading\" translate=\"wireless_text\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_text-limited_en\"></div><tbody><tr class=\"row info-modal-table-divide\"><th scope=\"col\"></th><th scope=\"col\" class=\"col-xs-4 col-xs-push-4 info-modal-table-head\" translate=\"wireless_usage_included\"></th><th scope=\"col\" class=\"col-xs-4 col-xs-push-4 info-modal-table-head\"><span ng-if=\"::info.wd.smsArr[0].action == 0\" translate=\"wireless_usage_total-usage\"></span> <span ng-if=\"::info.wd.smsArr[0].action == 1\" translate=\"wireless_usage-text_total-usage_in\"></span> <span ng-if=\"::info.wd.smsArr[0].action == 2\" translate=\"wireless_usage-text_total-usage_out\"></span></th></tr><tr class=\"row info-modal-table-row\" ng-repeat=\"wdssum in info.wd.smsArr\" ng-if=\"::wdssum.usageType !== \'pay-per-use\'\"><th scope=\"row\" class=\"col-xs-4 info-modal-table-head-row\"><span ng-show=\"::wdssum.usageType === \'extras_summary\'\">Extras</span> <span ng-hide=\"::wdssum.usageType === \'extras_summary\'\">{{wdssum.periodGroup}}</span></th><td class=\"col-xs-4 info-modal-table-cell\"><span ng-if=\"::wdssum.usageType === \'unlimited\'\" class=\"usuage-ammount\" translate=\"wireless_unlimited\"></span> <span ng-if=\"::wdssum.usageType === \'pay-per-use\'\" class=\"usuage-ammount\" translate=\"wireless_extra-usage\"></span> <span ng-if=\"::wdssum.usageType === \'limited\'\" class=\"usuage-ammount\">{{::wdssum.total | number}} <span translate=\"wireless_usage_minutes\"></span></span></td><td class=\"col-xs-4 info-modal-table-cell\"><span ng-if=\"::wdssum.isFamilySharing === true\">{{::wdssum.subscriberUsage| number}} {{::info.textsLbl}}</span> <span ng-if=\"::wdssum.isFamilySharing === false\">{{::wdssum.used| number}} {{::info.textsLbl}}</span></td></tr></tbody></table></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/upfrontAdvantageDetails.html","<div class=\"info-modal-top-banner\"><div class=\"info-modal-heading\">Upfront Advantage FAQ</div></div><div class=\"info-modal-device-dates\">Upfront Advantage lowers the upfront cost of devices. You then settle this amount at a later date by returning your device or repaying the Upfront Advantage amount.</div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wireless.dial.showData.html","<div class=\"serviceWrap\" ng-click=\"wdController.onClickViewMyWirelessDataUsage();\"><ute-purchase-data-directive ng-if=\"wdController.isAddTopUpEnabled && wdController.showAddData\" class=\"ute-purchase-data-non-se\"></ute-purchase-data-directive><div class=\"usageNormal inner-content text-center {{wdController.wd.data.globalColor}} {{wdController.wd.data.unlimitedClass}}\"><div class=\"center c100\" ng-class=\"\'p\' + wdController.wd.data.globalPercentage\" ng-if=\"!wdController.wd.data.unlimitedShow\"><span class=\"inner-circle data\" ng-if=\"(wdController.displayDataUsageSwitch || wdController.displayAllUsage || wdController.usageRefreshed) && !wdController.staticForTalkAndTextOnly\"><div class=\"h3\"><span class=\"txt\" ng-if=\"!wdController.isInfiniteThrottled()\" translate=\"wireless_data\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_data-limited\"></span> <span class=\"txt-ultd\" ng-if=\"wdController.isInfiniteThrottled()\" translate=\"wireless_unlimited_data\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_data-limited\"></span></div><span class=\"ammount\" ng-if=\"((wdController.wd.data.globalDisplayRemain > 0 && wdController.wd.data.globalDisplayOverage > 0) || (wdController.wd.data.globalDisplayRemain >= 0 && wdController.wd.data.globalDisplayOverage <= 0)) && (wdController.wd.data.globalDisplayRemain / 1024) >= 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-lg\">{{(wdController.wd.data.globalDisplayRemain / 1048576) | bilingualnumber:2}} <strong class=\"usage-unit\" translate=\"wireless_usage_gb\"></strong></span><span class=\"ammount\" ng-if=\"!wdController.isInfiniteThrottled() && ((wdController.wd.data.globalDisplayRemain > 0 && wdController.wd.data.globalDisplayOverage > 0) || (wdController.wd.data.globalDisplayRemain >= 0 && wdController.wd.data.globalDisplayOverage <= 0)) && (((wdController.wd.data.globalDisplayRemain / 1024) < 1024) && ((wdController.wd.data.globalDisplayRemain / 1024) >= 0))\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\">{{(wdController.wd.data.globalDisplayRemain / 1024) | number:0}} <strong class=\"usage-unit\" translate=\"wireless_usage_mb\"></strong></span><span class=\"ammount\" ng-if=\"!wdController.isInfiniteThrottled() && (wdController.wd.data.globalDisplayRemain <= 0 && wdController.wd.data.globalDisplayOverage > 0) && ((wdController.wd.data.globalDisplayOverage / 1024) >= 1024)\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-lg\">{{(wdController.wd.data.globalDisplayOverage / 1048576) | bilingualnumber:2}} <strong class=\"usage-unit\" translate=\"wireless_usage_gb\"></strong></span><span class=\"ammount\" ng-if=\"!wdController.isInfiniteThrottled() && (wdController.wd.data.globalDisplayRemain <= 0 && wdController.wd.data.globalDisplayOverage > 0) && ((wdController.wd.data.globalDisplayOverage / 1024) < 1024)\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\">{{(wdController.wd.data.globalDisplayOverage / 1024) | number:0}} <strong class=\"usage-unit\" translate=\"wireless_usage_mb\"></strong></span><span class=\"ammount infinite-logo\" ng-if=\"wdController.isInfiniteThrottled() && (wdController.wd.data.globalDisplayRemain <= 0 && wdController.wd.data.globalDisplayOverage >= 0)\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\"><img src=\"ute-common-assets/assets/infinite/rogers-infinite.svg\" alt=\"\"></span> <span class=\"remaining\" ng-if=\"::wdController.globalDataDisplayRemainPlural && ((wdController.wd.data.globalDisplayRemain > 0 && wdController.wd.data.globalDisplayOverage > 0) || (wdController.wd.data.globalDisplayRemain >= 0 && wdController.wd.data.globalDisplayOverage <= 0))\" translate=\"wireless_remaining_plural\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_remaining_plural\"></span> <span class=\"remaining\" ng-if=\"::!wdController.globalDataDisplayRemainPlural && !wdController.isInfiniteThrottled() && ((wdController.wd.data.globalDisplayRemain > 0 && wdController.wd.data.globalDisplayOverage > 0) || (wdController.wd.data.globalDisplayRemain >= 0 && wdController.wd.data.globalDisplayOverage <= 0))\" translate=\"wireless_remaining\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_remaining\"></span><span class=\"remaining\" ng-if=\"!wdController.isInfiniteThrottled() && (wdController.wd.data.globalDisplayRemain <= 0 && wdController.wd.data.globalDisplayOverage > 0)\" translate=\"wireless_overage\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_overage\"></span><span class=\"remaining\" ng-if=\"wdController.isInfiniteThrottled()\" translate=\"wireless_infinite_reduced_speed\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_overage\"></span> <span class=\"delayed\" ng-if=\"!wdController.isInfiniteThrottled()\" translate=\"wireless_delayed_12_hours\"></span><ute-usage-dial-animated-stroke data-percent-remaining=\"{{ 100 - wdController.wd.data.globalPercentage }}\" class=\"ute-animatedStrokeContainer\" ng-class=\"::{\'safari_only\' : wdController.isSafari(), \'chrome_ios\' : wdController.isChromeIOS(), \'old_chrome_browser\' : wdController.getChromeVersion() < 49 }\" ng-if=\"!wdController.wd.data.unlimitedShow\"></ute-usage-dial-animated-stroke><span class=\"cta\" ng-if=\"wdController.dataIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_view\"></span> <span class=\"cta\" ng-if=\"!wdController.dataIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_close\"></span></span><span class=\"inner-circle data\" ng-if=\"(wdController.disableAllUsageSwitch && !wdController.usageRefreshed) || (wdController.staticForTalkAndTextOnly && wdController.displayDataUsageSwitch)\"><div class=\"h3\"><span class=\"txt\" translate=\"wireless_data\"></span></div><span class=\"ammount\"><sub style=\"font-size: 38px !important;margin: 0 !important;\">&#45;&nbsp;&#45;</sub></span> <span class=\"remaining\" translate=\"wireless_remaining\"></span></span></div><div class=\"unlimited center\" ng-if=\"wdController.wd.data.unlimitedShow\"><div class=\"h3\"><span class=\"txt\" translate=\"wireless_data\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_data-unlimited\"></span><br><span class=\"subtxt\" translate=\"wireless_unlimited\" ng-if=\"!wdController.wd.data.globalOnlyExtras\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_unlimited\"></span> <span class=\"subtxt\" ng-if=\"wdController.wd.data.globalOnlyExtras\">&nbsp;</span> <span class=\"extras\" ng-if=\"wdController.wd.data.globalHaveExtras && wdController.dataIsCollapsed\"><strong>+</strong><br>extras</span></div></div></div></div><div collapse=\"wdController.dataIsCollapsed\" class=\"colDataWrap paddbot60\" ng-if=\"(wdController.displayDataUsageSwitch || wdController.displayAllUsage || wdController.usageRefreshed)\"><div data-ng-include=\"::wdController.pathToDataSectionUrl\"></div><div class=\"closingTongue {{wdController.wd.talk.globalColor}}\" ng-click=\"wdController.onClickViewMyWirelessDataUsage();\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-if=\"wdController.dataIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_talk_bottom-wireless_view-limited\"></span> <span ng-if=\"!wdController.dataIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_talk_bottom-wireless_close-limited\"></span></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wireless.dial.showSms.html","<div class=\"serviceWrap\" ng-click=\"wdController.onClickViewMyWirelessTextUsage();\"><div class=\"inner-content text-center {{wdController.wd.sms.globalColor}} normal usageNormal\"><div class=\"center c100\" ng-class=\"\'p\' + wdController.wd.sms.globalPercentage\"><span class=\"inner-circle data\" ng-if=\"wdController.displayAllUsage || wdController.usageRefreshed\"><div class=\"h3\"><span class=\"txt\" ng-if=\"wdController.lng === \'en\'\" translate=\"wireless_text\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_text-limited_en\"></span> <span class=\"txt\" ng-if=\"wdController.lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500\" translate=\"wireless_text\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_text-limited_fr\"></span></div><span class=\"txt\" ng-if=\"wdController.lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500;text-transform:uppercase\" translate=\"wireless_text_2\"></span> <span class=\"ammount unlimit unlimit-text\" ng-if=\"wdController.wd.sms.unlimitedShow\" translate=\"wireless_unlimited\"></span> <span class=\"ammount limit-text\" ng-if=\"wdController.lng === \'en\' && !wdController.wd.sms.unlimitedShow\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_amount-en\">{{wdController.wd.sms.globalDisplayRemain}}</span> <span class=\"ammount\" style=\"margin-top:10px\" ng-if=\"wdController.lng === \'fr\' && !wdController.wd.sms.unlimitedShow\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_amount-fr\">{{wdController.wd.sms.globalDisplayRemain}}</span> <span class=\"remaining\" ng-if=\"!wdController.wd.sms.unlimitedShow\" translate=\"text_remaining\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_remaining\"></span> <span class=\"delayed\" ng-if=\"!wdController.wd.sms.unlimitedShow\" translate=\"wireless_delayed_4_hours\"></span><ute-usage-dial-animated-stroke data-percent-remaining=\"{{ 100 - wdController.wd.sms.globalPercentage }}\" class=\"ute-animatedStrokeContainer\" ng-class=\"::{\'safari_only\' : wdController.isSafari(), \'chrome_ios\' : wdController.isChromeIOS(), \'old_chrome_browser\' : wdController.getChromeVersion() < 49 }\" ng-if=\"!wdController.wd.sms.unlimitedShow\"></ute-usage-dial-animated-stroke><span class=\"extras\" ng-if=\"wdController.wd.sms.globalHaveExtras\"><strong>+</strong><br>extras</span> <span class=\"cta\" ng-if=\"wdController.smsIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_view\"></span> <span class=\"cta\" ng-if=\"!wdController.smsIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_close\"></span></span><span class=\"inner-circle data\" ng-if=\"((wdController.displayDataUsageSwitch || wdController.disableAllUsageSwitch) && !wdController.usageRefreshed) || (wdController.staticForTalkAndTextOnly && wdController.displayDataUsageSwitch)\"><div class=\"h3\"><span class=\"txt\" ng-if=\"wdController.lng === \'en\'\" translate=\"wireless_text\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_text-limited_en\"></span> <span class=\"txt\" ng-if=\"wdController.lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500\" translate=\"wireless_text\" data-test-id=\"myr-wirelessDashboard-meter_text-wireless_text-limited_fr\"></span></div><span class=\"txt\" ng-if=\"wdController.lng === \'fr\'\" style=\"font-size:14pt;font-weight: 500;text-transform:uppercase\" translate=\"wireless_text_2\"></span> <span class=\"ammount\">&#45;&nbsp;&#45;</span> <span class=\"remaining\" translate=\"wireless_remaining\"></span></span></div></div></div><div collapse=\"wdController.smsIsCollapsed\" class=\"colDataWrap paddbot60\" ng-if=\"wdController.displayAllUsage || wdController.usageRefreshed\"><div data-ng-include=\"::wdController.pathToSMSSectionUrl\"></div><div class=\"closingTongue {{wdController.wd.sms.globalColor}}\" ng-click=\"wdController.onClickViewMyWirelessTextUsage();\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-if=\"wdController.smsIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_text_view\"></span> <span ng-if=\"!wdController.smsIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_text_close\"></span></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wireless.dial.showTalk.html","<div class=\"serviceWrap\" ng-click=\"wdController.onClickViewMyWirelessTalkUsage();\"><div class=\"inner-content text-center {{wdController.wd.talk.globalColor}} normal usageNormal\"><div class=\"center c100\" ng-class=\"\'p\' + wdController.wd.talk.globalPercentage\"><span class=\"inner-circle data\" ng-if=\"wdController.displayAllUsage || wdController.usageRefreshed\"><div class=\"h3\"><span class=\"txt\" translate=\"wireless_talk\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_talk-limited\"></span></div><span class=\"ammount\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_amount\" ng-if=\"!wdController.wd.talk.unlimitedShow\">{{wdController.wd.talk.globalDisplayRemain}}<ng-pluralize class=\"usage-unit usage-talk\" count=\"wdController.wd.talk.globalDisplayRemain\" when=\"{\'0\': \'min\', \'1\': \'min\', \'other\': \'min\'}\"></ng-pluralize></span> <span class=\"ammount unlimit\" ng-if=\"wdController.wd.talk.unlimitedShow\" translate=\"wireless_unlimited\"></span> <span class=\"remaining\" ng-if=\"::wdController.globalTalkDisplayRemainPlural\" translate=\"wireless_remaining_plural\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_remaining_plural\"></span> <span class=\"remaining\" ng-if=\"!(wdController.globalTalkDisplayRemainPlural || wdController.wd.talk.unlimitedShow)\" translate=\"wireless_remaining\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_remaining\"></span> <span class=\"remaining calling\" ng-if=\"wdController.UnlimitedTalkLocalCalling\" translate=\"wireless_local_calling\" data-test-id=\"\"></span> <span class=\"remaining calling\" ng-if=\"wdController.isCanadaWide && wdController.wd.talk.unlimitedShow\" translate=\"wireless_canada_wide_calling\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_remaining_plural\"></span> <span class=\"delayed\" ng-if=\"!wdController.wd.talk.unlimitedShow\" translate=\"wireless_delayed_4_hours\"></span><ute-usage-dial-animated-stroke data-percent-remaining=\"{{ 100 - wdController.wd.talk.globalPercentage }}\" class=\"ute-animatedStrokeContainer\" ng-class=\"::{\'safari_only\' : wdController.isSafari(), \'chrome_ios\' : wdController.isChromeIOS(), \'old_chrome_browser\' : wdController.getChromeVersion() < 49 }\" ng-if=\"!wdController.wd.talk.unlimitedShow\"></ute-usage-dial-animated-stroke><span class=\"extras\" ng-if=\"wdController.wd.talk.globalHaveExtras\"><strong>+</strong><br>extras</span> <span class=\"cta\" ng-if=\"wdController.talkIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_view\"></span> <span class=\"cta\" ng-if=\"!wdController.talkIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_close\"></span></span><span class=\"inner-circle data\" ng-if=\"((wdController.displayDataUsageSwitch || wdController.disableAllUsageSwitch) && !wdController.usageRefreshed) || (wdController.staticForTalkAndTextOnly && wdController.displayDataUsageSwitch)\"><div class=\"h3\"><span class=\"txt\" translate=\"wireless_talk\" data-test-id=\"myr-wirelessDashboard-meter_talk-wireless_talk-limited\"></span></div><span class=\"ammount\"><sub style=\"font-size: 38px !important;margin: 0 !important;\">&#45;&nbsp;&#45;</sub><ins class=\"usage-unit usage-talk usage-min\" translate=\"usage-unit-text\"></ins></span> <span class=\"remaining\" translate=\"wireless_remaining_plural_talk\"></span></span></div></div></div><div collapse=\"wdController.talkIsCollapsed\" class=\"colDataWrap paddbot60\" ng-if=\"wdController.displayAllUsage || wdController.usageRefreshed\"><div data-ng-include=\"::wdController.pathToTalkSectionUrl\"></div><div class=\"closingTongue {{wdController.wd.talk.globalColor}}\" ng-click=\"wdController.onClickViewMyWirelessTalkUsage();\"><div class=\"semicircle\"></div><div class=\"text\"><span ng-if=\"wdController.talkIsCollapsed\" translate=\"wireless_view\" data-test-id=\"myr-wirelessDashboard-meter_talk_bottom-wireless_view-limited\"></span> <span ng-if=\"!wdController.talkIsCollapsed\" translate=\"wireless_close\" data-test-id=\"myr-wirelessDashboard-meter_talk_bottom-wireless_close-limited\"></span></div></div></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wirelessDashboard.desktop.html","<div class=\"col-sm-4\" ng-repeat=\"slide in wdController.carouselSettings.slides\" ng-include=\"slide.template\"></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wirelessDashboard.mobile.html","<div class=\"wireless-dashboard-carousel\" ng-if=\"wdController.carouselSettings.slides.length > 0\"><carousel id=\"myWirelessCarousel\" no-wrap=\"wdController.carouselSettings.noWrapSlides\"><slide class=\"item\" ng-repeat=\"slide in wdController.carouselSettings.slides track by $index\" active=\"slide.active\"><div class=\"wirless-dial-slide-inner\" ng-include=\"slide.template\"></div></slide></carousel></div>");
$templateCache.put("scripts/modules/wirelessDashboard/partials/wirelessDashboardNew.html","<section class=\"page-wireless-new\"><div class=\"wd-top-banner visible-xs\" data-ng-style=\"{\'background\': wdController.indexColor}\"></div><div class=\"container\"><div class=\"wd-key-info-container visible-xs\"><div class=\"wd-selected-user-dropdown\"><select name=\"accountType\" required=\"\" data-ng-model=\"wdController.ctn\" data-ng-change=\"wdController.changeComboCTN(wdController.ctn)\" data-test-id=\"myr-wirelessDashboard-select_accountType\" tabindex=\"-1\"><option data-ng-repeat=\"wirelessLine in wdController.wirelessDashData\" data-ng-value=\"wirelessLine.ctn\" data-ng-selected=\"wirelessLine.ctn.toString() === (wdController.ctn).toString()\">{{::wirelessLine.firstname + \' - \' + wirelessLine.ctn}}</option></select><div data-ng-repeat=\"wirelessLine in wdController.wirelessDashData track by $index\" ng-if=\"wirelessLine.ctn.toString() === (wdController.ctn).toString()\"><div class=\"wd-selected-user\" data-ng-style=\"{\'color\': wdController.indexColor}\">{{ wirelessLine.firstname }}</div><div class=\"wd-selected-user-ban\">{{ wirelessLine.ctn | ute_common_filter_phone : \'$1-$2-$3\'}}</div></div><i class=\"rui-icon-chevron-down\"></i></div><div class=\"wd-key-info-section\" ng-if=\"wdController.isShareEverything === false\" data-ng-repeat=\"wddata in wdController.wd.dataArr\"><div class=\"col-xs-6\"><div class=\"wd-total-plan-data\"><span ng-if=\"::(wddata.total / 1024) >= 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-lg\">{{(wddata.total / 1048576) | number:2}}<span translate=\"wireless_usage_gb\"></span></span> <span ng-if=\"::(wddata.total / 1024) < 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\">{{(wddata.total / 1024) | number:0}}<span translate=\"wireless_usage_mb\"></span></span></div><div class=\"wd-data-details\" translate=\"wireless_usage_included\"></div></div><div class=\"col-xs-6\" ng-if=\"wdController.isShareEverything === false\"><div class=\"wd-selected-user-used-data\" data-ng-style=\"{\'color\': wdController.indexColor}\"><span ng-if=\"::(wddata.used / 1024) >= 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-lg\">{{(wddata.used / 1048576) | number:2}}<span translate=\"wireless_usage_gb\"></span></span> <span ng-if=\"::(wddata.used / 1024) < 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\">{{(wddata.used / 1024) | number:0}}<span translate=\"wireless_usage_mb\"></span></span></div><div class=\"wd-selected-data-details\" data-ng-style=\"{\'color\': wdController.indexColor}\" translate=\"wireless_usage_my-usage\" ng-if=\"wddata.usageType != \'unlimited\'\"></div></div><div class=\"col-xs-6\" ng-if=\"wdController.isShareEverything === false\"><div class=\"wd-data-remaining\"><span ng-if=\"::(wddata.remaining / 1024) >= 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-lg\">{{(wddata.remaining / 1048576) | number:2}}<span translate=\"wireless_usage_gb\"></span></span> <span ng-if=\"::(wddata.remaining / 1024) < 1024\" data-test-id=\"myr-wirelessDashboard-meter_data-wireless_amount-sm\">{{(wddata.remaining / 1024) | number:0}}<span translate=\"wireless_usage_mb\"></span></span></div><div class=\"wd-data-details\" translate=\"wireless_usage_remaining\" data-test-id=\"myr-wirelessDashboard-meter_data_body-wireless_usage_remaining\"></div></div><div ng-if=\"wdController.ab\" class=\"wd-talk-text-usage-link\" info-dialog-modal=\"\" analytics-key=\"talkTextUsage\" info=\"wdController.talkTextInfoModal\" is-share-everything=\"{{wdController.isShareEverything}}\" template-html=\"{{ wdController.talkTextInfoModal.template }}\" ng-click=\"wdController.wirelessDashboardCallMobile()\" data-ng-class=\"{\'viewUsage-disable\': !wdController.isRefreshUsageMobile()}\"><span translate=\"ute.rogers.wireless.talkTextLink\"></span></div></div><div ng-if=\"wdController.isShareEverything\" class=\"wd-key-info-section\"><div class=\"col-xs-6\" ng-if=\"::wdController.isBucketSizeUnavailableUntilNextBillCycle\"><div class=\"wd-total-plan-data\"><span>{{ wdController.getTotalUsedData }}</span></div><div class=\"wd-data-details\" translate=\"wireless_usage_used\"></div></div><div class=\"col-xs-6\" ng-if=\"!wdController.isBucketSizeUnavailableUntilNextBillCycle\"><div class=\"wd-total-plan-data\"><span>{{ wdController.fdmTotalIncluded }}</span></div><div class=\"wd-data-details\" translate=\"wireless_usage_included\"></div></div><div class=\"col-xs-6\" data-ng-style=\"{\'color\': wdController.indexColor}\"><div class=\"wd-others-used-data\"><span>{{wdController.fdmMyUsage}}</span></div><div class=\"wd-data-details-right\" translate=\"wireless_usage-text_my-usage\"></div></div><div class=\"col-xs-6\" ng-if=\"!wdController.isBucketSizeUnavailableUntilNextBillCycle\"><div class=\"wd-total-plan-data\"><span>{{ wdController.fdmRemaining }}</span></div><div class=\"wd-data-details\" translate=\"wireless_usage_remaining\"></div></div><div class=\"col-xs-6\" ng-class=\"{\'col-xs-offset-6\': wdController.isBucketSizeUnavailableUntilNextBillCycle}\"><div class=\"wd-others-used-data\"><span>{{wdController.fdmOthersUsage}}</span></div><div class=\"wd-data-details-right\" translate=\"wireless_usage-text_others-usage\"></div></div><div ng-if=\"wdController.ab\" class=\"wd-talk-text-usage-link\" info-dialog-modal=\"\" analytics-key=\"talkTextUsage\" info=\"wdController.talkTextInfoModal\" is-share-everything=\"{{wdController.isShareEverything}}\" template-html=\"{{ wdController.talkTextInfoModal.template }}\" ng-click=\"wdController.wirelessDashboardCallMobile()\" data-ng-class=\"{\'viewUsage-disable\': !wdController.isRefreshUsageMobile()}\"><span translate=\"ute.rogers.wireless.talkTextLink\"></span></div></div><div class=\"wd-fdm-alert-section\" ng-if=\"wdController.isShareEverything\"><div class=\"wd-fdm-alert-info-1\" data-ng-style=\"{\'color\': wdController.indexColor}\"><span translate=\"ute.rogers.wireless.data\"></span> <span ng-if=\"wdController.getSavedAlertValue() >= 0 && wdController.getDataAccess()\" translate=\"ute.rogers.wireless.on\"></span> <span ng-if=\"wdController.getSavedAlertValue() < 0 || !wdController.getDataAccess()\" translate=\"ute.rogers.wireless.off\"></span></div><div class=\"wd-fdm-alert-info-2\" data-ng-style=\"{\'color\': wdController.indexColor}\"><span translate=\"ute.rogers.wireless.alerts\"></span> <span ng-if=\"::wdController.getDataAccess()\" translate=\"ute.rogers.wireless.on\"></span> <span ng-if=\"::!wdController.getDataAccess()\" translate=\"ute.rogers.wireless.off\"></span></div><div class=\"wd-fdm-alert-info-3\" ng-if=\"::wdController.getIsVideoThrottlePermitted()\" data-ng-style=\"{\'color\': wdController.indexColor}\"><span translate=\"ute.rogers.wireless.video\"></span> <span ng-if=\"wdController.getReducedVideoQuality()\" translate=\"ute.rogers.wireless.videoSD\"></span> <span ng-if=\"!wdController.getReducedVideoQuality()\" translate=\"ute.rogers.wireless.videoHD\"></span></div><div class=\"wd-manage-fdm-alerts-button\" ng-click=\"wdController.goToManageAlerts(0)\" data-ng-style=\"{\'background\': wdController.indexColor}\"><span translate=\"ute.dataManager.dataAlerts.manageAlerts\"></span> <i class=\"rui-icon-arrow-right\"></i></div></div></div><div class=\"widget-loader\" ng-if=\"!wdController.ban\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div ng-if=\"wdController.ban\"><wireless-package ban=\"wdController.ban\" ctn=\"wdController.ctn\" wireless-dash-active=\"wdController.wirelessDashActive\" fraud-soc-error-message=\"wdController.fraudSocErrorMessage\" is-fraud-soc-available=\"wdController.isFraudSocAvailable\" show-reactivate-ctn=\"wdController.showReactivateCtn\" flags=\"wdController.flags\" model-for-reactivate-ctn=\"wdController.modelForReactivateCtn\" error-message=\"wdController.errorMessage\" talk-text-modal-info=\"wdController.talkTextInfoModal\"></wireless-package></div></div></section>");
$templateCache.put("scripts/modules/wirelessPrepaid/prepaidCtnCount/prepaidCtnCount.html","<div class=\"totes-project\"><div class=\"prepaidCtnModal\"><div class=\"row prepaiderrorHeader\"><div class=\"errorLogo col-xs-1\"><img height=\"29px\" width=\"32px\" src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/Warning_red.png\"></div><div class=\"col-xs-11 headerDesc\" translate=\"ctn_excceded_header\"></div></div><div class=\"row prepaidErrorBody\"><div class=\"col-xs-12 bodyDesc\" translate=\"ctn_change_excceded\"></div><div><button name=\"button_continue\" type=\"button\" class=\"closeButton\" ng-click=\"close()\"><span translate=\"close\"></span></button></div></div></div></div>");
$templateCache.put("scripts/modules/oneView/oneViewOrders/wirelessOrdersDetailsPopup/wirelessOrdersPopup.html","<div class=\"row\"><span class=\"wireless-order-close-icon\" ng-click=\"word.closePopover()(word.index)\"></span></div><div class=\"wireless-order-outer-layer\"><div class=\"wireless-order-inner-layer\"><table class=\"wireless-order-table fixed_header\"><thead><tr class=\"heading-row\"><th class=\"ctn-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\"><span translate=\"wireless_order_ctn\"></span> <span translate=\"wireless_order_ctn_expand\"></span></th><th class=\"item-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_itemno\"></th><th class=\"desc-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_description\"></th><th class=\"status-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_line_status\"></th><th class=\"on-hold-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_on_hold\"></th><th class=\"amt-ord-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_amount_ordered\"></th><th class=\"amt-ship-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_amount_shipped\"></th><th class=\"imei-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\"><span translate=\"wireless_order_serialno\"></span> <span translate=\"wireless_order_imei\"></span></th><th class=\"updated-date-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_last_updated\"></th><th class=\"ship-date-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_ship_date\"></th><th class=\"way-bill-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" translate=\"wireless_order_way_bill\"></th></tr></thead><tbody ng-if=\"!word.loading\"><tr class=\"body-row\" ng-repeat=\"order in word.itemDetails track by $index\" ng-if=\"!word.loading\"><td class=\"ctn-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" ng-bind-html=\"(order.ctn| phoneWithSpaces)\"></td><td class=\"item-col\" ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" ng-bind-html=\"order.itemNumber\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"desc-col\" ng-bind-html=\"order.description\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"status-col\">{{order.lineStatus|translate}}</td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"on-hold-col\"><div class=\"uppercase-text\" ng-bind-html=\"order.holdReason.trim() ? (order.hold + \'.\') : order.hold\"></div><div ng-bind-html=\"order.holdReason\"></div></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"amt-ord-col\" ng-bind-html=\"order.quantityOrdered\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"amt-ship-col\" ng-bind-html=\"order.quantityShipped\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"imei-col\" ng-bind-html=\"order.serialNumber\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"updated-date-col\" ng-bind-html=\"word.decideDateFilter(order.lastUpdatedDate)\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"ship-date-col\" ng-bind-html=\"word.decideDateFilter(order.shippedDate)\"></td><td ng-class=\"{\'fr-col\': word.lang === \'fr\'}\" class=\"way-bill-col\" ng-bind-html=\"order.wayBill\"></td></tr></tbody></table><div class=\"wireless-order-loading-img\" ng-if=\"word.loading\"><img src=\"ute-common-assets/assets/widget-loader-lg_no-lang.gif\" alt=\"Page loading...\"></div></div></div>");
$templateCache.put("module/goPaperless.view.html","<ute-user-if-any-granted data-roles=\"consumer\"><div class=\"row ute-go-paperless\"><ute-content-injector data-ng-show=\"gp.isBannerVisible()\" language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/switch-to-online-bill/switch-to-online-bill/switch-to-online-bill\"></ute-content-injector><ute-content-injector data-ng-hide=\"gp.isBannerVisible()\" language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/existing-online-bill/existing-online-bill/existing-online-bill\"></ute-content-injector></div></ute-user-if-any-granted>");
$templateCache.put("module/goPaperlessModalWindow.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}} ute-goPaperless-modalDialog\"><div class=\"ute-goPaperless-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/accountSeletionModal/accountSeletion.modal.view.html","<div class=\"ute-account-selection-modal\"><div class=\"HeadingGroup row\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1></h1><h3>Which account would you like to view today?</h3></div></div></div><div class=\"BodyGroup row\"><div class=\"row\"><ul class=\"list-of-accounts pln\"><li ng-repeat=\"account in accountSelectionModal.accountList\"><div data-ng-click=\"accountSelectionModal.selectAccount(account)\" class=\"account-ctn\" ng-class=\"{warning: account.accountStatusSimple == \'Warning\', error: account.accountStatusSimple === \'Error\'}\"><div class=\"account-name-ctn\" data-ng-show=\"!account.nickName\"><span class=\"account-name-txt\">{{account.accountName.firstName | capitalize}}</span></div><div class=\"account-name-ctn\" data-ng-show=\"account.nickName\"><span class=\"account-name-txt\">{{account.nickName}}</span></div><div class=\"account-number-ctn\"><span class=\"account-number-txt\"><span class=\"rui-icon-error-icon error-red\" ng-show=\"account.accountStatusSimple === \'Error\'\"></span> <span class=\"rui-icon-warning warning-color\" ng-show=\"account.accountStatusSimple === \'Warning\'\"></span> <span>{{account.accountNumber}}</span></span></div><div class=\"account-txt-warning\" ng-show=\"account.accountStatusSimple === \'Warning\'\"><span res=\"{{account.accountStatusModalMessage}}\"></span></div><div class=\"account-txt-error\" ng-show=\"account.accountStatusSimple === \'Error\'\"><span res=\"{{account.accountStatusModalMessage}}\"></span></div></div></li></ul></div></div></div>");
$templateCache.put("module/actionsOffers/actionsOffersMain.view.html","<ui-view></ui-view>");
$templateCache.put("module/antiSpamLegislation/antiSpamLegislation.view.html","<div class=\"ute-antiSpamLegislation container\" data-ng-if=\"!vm.brtSwitchConfig.CASL_HIDE_CEM_PREFERENCES\" role=\"main\"><div class=\"messaging-container\"><div class=\"rui-heading\" role=\"heading\"><h1 role=\"heading\"><span translate=\"ute.casl.electronicAddresses.mainHeading\"></span></h1></div></div><div class=\"electronic-marketing-container\" role=\"\"><div class=\"row\"><h3 class=\"electronic-marketing-sms-title\" role=\"heading\" translate=\"ute.casl.electronicAddresses.addressheading\"></h3><img class=\"ute-casl-loader\" ng-src=\"{{vm.loadingImgPath}}\" alt=\"loading fingers\" data-ng-show=\"vm.loadingState\"></div></div><div class=\"electronic-marketing-container\" role=\"contentinfo\" data-ng-if=\"!vm.loadingState\"><div class=\"row\" role=\"row\"><div class=\"panel panel-success sms-marketing-pref-panel\"><div class=\"panel-heading sms-marketing-pref-heading\" aria-describedby=\"txt-msgs-marketing\"><h3 translate=\"ute.casl.electronicAddresses.sms.prefHeading\" role=\"heading\" id=\"txt-msgs-marketing\"></h3></div><div class=\"panel-body sms-marketing-pref-panel-body\"><p class=\"preference-error\" ng-if=\"vm.getCEMPreferenceError\" translate=\"ute.casl.electronicAddresses.getErrorDetail\"></p><ul class=\"list-group sms-marketing-pref-list\" role=\"listbox\"><li class=\"list-group-item sms-market-pref-list-item\" role=\"listitem\" data-ng-repeat=\"address in vm.electronicAddressesAndCEMPreferencesList.sms.electronicAddresses track by $index\"><div class=\"bs-example\"><div class=\"panel-group\" id=\"accordion3\" role=\"group\"><div class=\"panel panel-default pref-list-panel\"><div class=\"panel-heading pref-list-panel-heading\"><div class=\"panel-title\"><div class=\"row\"><div class=\"col-lg-8 col-xs-12\"><h4 class=\"list-group-item-heading\">{{address.value}}</h4></div><div class=\"col-lg-4 toggle-lock\"><div class=\"lockWrapper hide-updateLoader\"></div><div class=\"toggle-container\" ng-if=\"address.isPreferencesExists && address.isPreferencesExists > 0\"><a class=\"manage-msgs-link collapsed\" data-accordion-id=\"{{address.type + \'-\' + $index}}\" role=\"button\" aria-labelledby=\"manage messages link\" ng-click=\"vm.toggleAccordion(address.type + \'-\' + $index)\" ng-show=\"address.showManagePrefLink && vm.brtSwitchConfig.CASL_CEM_ALL === true\"><span translate=\"ute.casl.electronicAddresses.preference.linkTitle\"></span> <span>({{address.selectedCheckbox}})</span> <span class=\"arrow-up-manage-pref\"><img class=\"manage-pref-arrow-down\" ng-src=\"{{vm.imgPath}}/arrow-down-pref.png\" alt=\"\"> <img class=\"manage-pref-arrow-up\" ng-src=\"{{vm.imgPath}}/arrow-up-pref.png\" alt=\"\"></span></a><div class=\"save-button-container\"><img class=\"toggle-btn-loader hide-updateLoader\" data-loader=\"{{address.type +\'-\'+$index}}\" ng-src=\"{{vm.loadingImgPath}}\" alt=\"loading fingers\"> <label class=\"label-switch switch-primary\" role=\"button\" aria-labelledby=\"toggle switch for show manage messages link\"><input type=\"checkbox\" role=\"checkbox\" class=\"custom-switch switch-bootstrap status\" name=\"status\" id=\"toggleBtn\" ng-model=\"address.optOutToggleOn\" data-ng-change=\"vm.makeToggleOffandHidePreferences(address.type +\'-\'+$index, address.optOutToggleOn, address, \'SMS\')\"> <span class=\"lable\" ng-class=\"address.optOutToggleOn ? \'yes\':\'no\'\"><span class=\"lable-yes\" translate=\"ute.casl.electronicAddresses.preference.toggleYes\"></span> <span class=\"lable-no\" translate=\"ute.casl.electronicAddresses.preference.toggleNo\"></span></span></label></div></div><div class=\"preference-not-found pref-update-error-toggle hide-updateLoader\" data-loader=\"{{address.type +\'-\'+$index}}\"><img ng-src=\"{{vm.imgPath}}/error_warning.png\" alt=\"\" class=\"toggle-error-icon\"><p class=\"pref-update-error-toggle-p\" translate=\"ute.casl.electronicAddresses.updateErrorDetail\"></p></div><p class=\"preference-not-found\" ng-if=\"!address.isPreferencesExists\" translate=\"ute.casl.electronicAddresses.prefNotFoundMsg\"></p></div></div></div></div><div id=\"{{address.type}}-{{$index}}\" class=\"panel-collapse collapse\" role=\"region\" aria-hidden=\"true\"><div class=\"panel-body pref-list-panel-body\"><div class=\"level-cat-container\"><div class=\"channelList\" ng-repeat=\"brand in address.cemPreferencesList.BrandList\" ng-if=\"brand.Brand.RefID.toLowerCase() === vm.selectedBrand\"><div class=\"container level-cat-content\"><div class=\"row\" ng-repeat=\"channel in brand.Brand.ChannelList\"><div class=\"level-cat-title-container\"><h4 class=\"level-cat-title pull-left\">{{vm.selectedLanguage === \'en\'? channel.Channel.DisplayNameEn: channel.Channel.DisplayNameFr}}</h4><h4 class=\"level-cat-msg-counter pull-right\">{{channel.Channel.PreferenceList.length}} Items</h4></div><div class=\"control-group custom-checkbox-container\"><div class=\"col-lg-6 col-xs-12\" ng-repeat=\"prefItem in channel.Channel.PreferenceList\"><label class=\"control control-checkbox\" ng-class=\"prefItem.Preference.PreferenceValue ? \'custom-checkbox-checked\':\'custom-checkbox\'\">{{vm.selectedLanguage === \'en\'? prefItem.Preference.Class.DisplayNameEn: prefItem.Preference.Class.DisplayNameFr}} <input type=\"checkbox\" ng-model=\"prefItem.Preference.PreferenceValue\" data-ng-click=\"vm.checkboxesCheckUncheckForSelectedPreferences(address, true)\"><div class=\"control_indicator\"></div></label></div></div></div></div></div></div><div class=\"save-selection-container\"><div class=\"col-lg-3\"><button class=\"save-selection-btn\" type=\"button\" data-ng-click=\"vm.updateCEMPreferences(address, \'SMS\', false, address.value, address.type +\'-\'+$index, \'button\')\"><span ng-show=\"!vm.isUpdatedSelection\" translate=\"ute.casl.electronicAddresses.saveSelectionBtn\"></span> <span ng-show=\"vm.isUpdatedSelection\" translate=\"ute.casl.electronicAddresses.updatedSelectionBtn\"></span></button> <img class=\"save-btn-loader hide-updateLoader\" data-loader=\"{{address.value}}\" ng-src=\"{{vm.loadingImgPath}}\" alt=\"loading fingers\"></div><div class=\"col-lg-9\" ng-if=\"vm.updateCEMPreferenceError\"><div class=\"danger-message-alert\"><img ng-src=\"{{vm.imgPath}}/error_warning.png\" alt=\"\" class=\"ute-ctn-alert-icon\"><div class=\"alert-desc\"><p class=\"what-do-mean\" translate=\"ute.casl.electronicAddresses.updateErrorDetail\"></p></div></div></div></div></div></div></div></div></div><div class=\"border-bottom-line\"></div></li></ul></div></div></div></div><div class=\"electronic-marketing-container\" role=\"contentinfo\" data-ng-if=\"!vm.loadingState\"><div class=\"row\" role=\"row\"><div class=\"panel panel-success sms-marketing-pref-panel\"><div class=\"panel-heading sms-marketing-pref-heading\" aria-describedby=\"email-marketing\"><h3 translate=\"ute.casl.electronicAddresses.email.prefHeading\" role=\"heading\" id=\"email-marketing\"></h3></div><div class=\"panel-body sms-marketing-pref-panel-body\"><p class=\"preference-error\" ng-if=\"vm.getCEMPreferenceError\" translate=\"ute.casl.electronicAddresses.getErrorDetail\"></p><ul class=\"list-group sms-marketing-pref-list\" role=\"listbox\"><li class=\"list-group-item sms-market-pref-list-item\" role=\"listitem\" data-ng-repeat=\"email in vm.electronicAddressesAndCEMPreferencesList.email.electronicAddresses\"><div class=\"bs-example\"><div class=\"panel-group\" id=\"accordion2\" role=\"group\"><div class=\"panel panel-default pref-list-panel\"><div class=\"panel-heading pref-list-panel-heading\"><div class=\"panel-title\"><div class=\"row\"><div class=\"col-lg-8 col-xs-12\"><h4 class=\"list-group-item-heading\">{{email.value}}</h4></div><div class=\"col-lg-4 toggle-lock\"><div class=\"lockWrapper hide-updateLoader\"></div><div class=\"toggle-container\" ng-if=\"email.isPreferencesExists && email.isPreferencesExists > 0\"><a class=\"manage-msgs-link collapsed\" data-accordion-id=\"{{email.type + \'-\' + $index}}\" aria-labelledby=\"manage messages link\" role=\"link\" ng-click=\"vm.toggleAccordion(email.type + \'-\' + $index)\" ng-if=\"email.showManagePrefLink && vm.brtSwitchConfig.CASL_CEM_ALL === true\"><span translate=\"ute.casl.electronicAddresses.preference.linkTitle\"></span> <span>({{email.selectedCheckbox}})</span> <span class=\"arrow-up-manage-pref\"><img class=\"manage-pref-arrow-down\" ng-src=\"{{vm.imgPath}}/arrow-down-pref.png\" alt=\"\"> <img class=\"manage-pref-arrow-up\" ng-src=\"{{vm.imgPath}}/arrow-up-pref.png\" alt=\"\"></span></a><div class=\"save-button-container\"><img class=\"toggle-btn-loader hide-updateLoader\" data-loader=\"{{email.type +\'-\'+$index}}\" ng-src=\"{{vm.loadingImgPath}}\" alt=\"loading fingers\"> <label class=\"label-switch switch-primary\" role=\"button\" aria-labelledby=\"toggle switch for show manage messages link\"><input type=\"checkbox\" role=\"button\" class=\"custom-switch switch-bootstrap status\" name=\"status\" id=\"statss;\" value=\"1\" ng-model=\"email.optOutToggleOn\" data-ng-change=\"vm.makeToggleOffandHidePreferences(email.type +\'-\'+$index, email.optOutToggleOn, email, \'email\')\"> <span class=\"lable\" ng-class=\"email.optOutToggleOn ? \'yes\':\'no\'\"><span class=\"lable-yes\" translate=\"ute.casl.electronicAddresses.preference.toggleYes\"></span> <span class=\"lable-no\" translate=\"ute.casl.electronicAddresses.preference.toggleNo\"></span></span></label></div></div><div class=\"preference-not-found pref-update-error-toggle hide-updateLoader\" data-loader=\"{{email.type +\'-\'+$index}}\"><img ng-src=\"{{vm.imgPath}}/error_warning.png\" alt=\"\" class=\"toggle-error-icon\"><p class=\"pref-update-error-toggle-p\" translate=\"ute.casl.electronicAddresses.updateErrorDetail\"></p></div><p class=\"preference-not-found\" ng-if=\"!email.isPreferencesExists\" translate=\"ute.casl.electronicAddresses.prefNotFoundMsg\"></p></div></div></div></div><div id=\"{{email.type}}-{{$index}}\" class=\"panel-collapse collapse\" role=\"presentation\" aria-hidden=\"true\"><div class=\"panel-body pref-list-panel-body\"><div class=\"level-cat-container\"><div class=\"channelList\" ng-repeat=\"brand in email.cemPreferencesList.BrandList\" ng-if=\"brand.Brand.RefID.toLowerCase() === vm.selectedBrand\"><div class=\"container level-cat-content\"><div class=\"row\" ng-repeat=\"channel in brand.Brand.ChannelList\"><div class=\"level-cat-title-container\"><h4 class=\"level-cat-title pull-left\">{{channel.Channel.DisplayNameEn}}</h4><h4 class=\"level-cat-msg-counter pull-right\">{{channel.Channel.PreferenceList.length}} Items</h4></div><div class=\"control-group custom-checkbox-container\"><div class=\"col-lg-6 col-xs-12\" ng-repeat=\"prefItem in channel.Channel.PreferenceList\"><label class=\"control control-checkbox\" ng-class=\"prefItem.Preference.PreferenceValue ? \'custom-checkbox-checked\':\'custom-checkbox\'\">{{vm.selectedLanguage === \'en\'? prefItem.Preference.Class.DisplayNameEn: prefItem.Preference.Class.DisplayNameFr}} <input type=\"checkbox\" ng-model=\"prefItem.Preference.PreferenceValue\" data-ng-click=\"vm.checkboxesCheckUncheckForSelectedPreferences(email, true)\"><div class=\"control_indicator\"></div></label></div></div></div></div></div></div><div class=\"save-selection-container\"><div class=\"col-lg-3\"><button class=\"save-selection-btn\" type=\"button\" data-ng-click=\"vm.updateCEMPreferences(email, \'email\', false, email.value, email.type +\'-\'+$index, \'button\')\"><span ng-show=\"!vm.isUpdatedSelection\" translate=\"ute.casl.electronicAddresses.saveSelectionBtn\"></span> <span ng-show=\"vm.isUpdatedSelection\" translate=\"ute.casl.electronicAddresses.updatedSelectionBtn\"></span></button> <img class=\"save-btn-loader hide-updateLoader\" data-loader=\"{{email.value}}\" ng-src=\"{{vm.loadingImgPath}}\" alt=\"loading fingers\"></div><div class=\"col-lg-9\" ng-if=\"vm.updateCEMPreferenceError\"><div class=\"danger-message-alert\"><img ng-src=\"{{vm.imgPath}}/error_warning.png\" alt=\"\" class=\"ute-ctn-alert-icon\"><div class=\"alert-desc\"><p class=\"what-do-mean\" translate=\"ute.casl.electronicAddresses.updateErrorDetail\"></p></div></div></div></div></div></div></div></div></div><div class=\"border-bottom-line\"></div></li></ul></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeWindow.modal.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-captureDC-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/boldChat/boldChatStaticButton.html","<div id=\"{{boldChatDiv}}\"></div>");
$templateCache.put("module/floatingLiveChat/floatingLiveChat.view.html","<div class=\"ute-floating-live-chat\" data-ng-class=\"(snapMobileTo !== undefined) ? ((snapMobileTo === \'left\') ? \'ute-floating-live-chat-left-on-mobile\' : ((snapMobileTo === \'right\') ? \'\' : \'ute-floating-live-chat-bottom-on-mobile\')) : \'ute-floating-live-chat-bottom-on-mobile\'\"><bold-chat-static-button data-cbid=\"{{cbid | translate}}\" data-dynamic-div=\"{{boldChatDiv | translate}}\" data-chat-button=\"{{chatButton | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div>");
$templateCache.put("module/notificationBanner/notificationBanner.view.html","<div class=\"ute-notification-banner\"><div ng-repeat=\"message in notificationBanner.getMessages() track by message.id\" ng-include=\"\'module/notificationBanner/typeViews/\'+message.template+\'.view.html\'\"></div></div>");
$templateCache.put("module/uteAddToCalendar/uteAddToCalendar.view.html","<div class=\"btn-group dropdown\" dropdown=\"\" on-toggle=\"toggled(open)\" title=\"{{(hoverText == undefined) ? title : hoverText}}\"><span ng-class=\"className || \'btn btn-sm btn-default dropdown-toggle\'\" dropdown-toggle=\"\">{{(btnText == undefined) ? \'Add to calendar\' : btnText}} <span ng-if=\"caret != \'false\'\" class=\"caret\"></span></span><ul class=\"dropdown-menu\"><li class=\"calendars-title\">{{dropdownTitle}} <img src=\"ute-common-assets/assets/cross-grey.png\"></li><li ng-repeat=\"item in ctrl.calendarUrl\"><a href=\"#\" ng-click=\"ctrl.trackCalType(item)\">{{::item.label}}</a></li></ul></div>");
$templateCache.put("module/commonSeletionModal/common.seletion.modal.view.html","<div class=\"ute-common-selection-modal\"><div class=\"HeadingGroup\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span data-translate=\"{{commonSelectionModal.selectionData.title}}\"></span></div></div></div><div class=\"BodyGroup\"><div class=\"selection-box\"><div class=\"selection-title\" aria-hidden=\"false\"><span class=\"\">{{commonSelectionModal.selectionData.selections.title}}</span></div><div class=\"\"><ul class=\"\"><li ng-repeat=\"item in commonSelectionModal.selectionData.selections.options\" ng-click=\"commonSelectionModal.actionOnClick(item)\" class=\"\" role=\"button\" tabindex=\"0\"><span class=\"\">{{item.display}}</span><div class=\"\"></div></li></ul></div></div></div></div><div class=\"modal-close\"><button type=\"button\" ng-click=\"commonSelectionModal.cancel(\'close\')\" class=\"closemodal\" data-dismiss=\"modal\" aria-hidden=\"true\" tabindex=\"0\">×</button></div>");
$templateCache.put("module/contentExpand/contentExpand.template.html","<accordion class=\"contentExpander\"><div ng-class=\"ce.getBorderBehaviour()\" class=\"contentBorder\"><div accordion-group=\"\" is-open=\"isOpen\"><accordion-heading></accordion-heading><div ng-class=\"ce.getContentBehaviour()\"><ng-transclude></ng-transclude></div></div></div></accordion>");
$templateCache.put("module/customerCreditManagement/customerCreditManagementMain.view.html","<section><ui-view></ui-view></section>");
$templateCache.put("module/dataManager/dataManager.windowTemplate.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"ute-dataManager-dataControlList-modal modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-dataManager-dataControlList-modal ute-dataManager-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/dataManager/dataManagerMain.view.html","<div><ui-view></ui-view></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottle.windowTemplate.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"ute-dataManager-dataControlList-modal modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-dataManager-dataControlList-modal ute-dataManager-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/language.switcher/languageSwitch.html","<ul class=\"nav navbar-nav pull-right\"><li><a href=\"\" data-ng-click=\"languageSwitch.changeLanguage()\" translate=\"ute.blocks.language.switcher.label\"></a></li></ul>");
$templateCache.put("module/emailModal/currentEmailModal.view.html","<div class=\"ute-go-paperless\"><div class=\"ute-goPaperless-modalHeadingGroup\"><div class=\"ute-goPaperless-modalHeading\"><span translate=\"ute.goPaperless.emailModal.withContactEmail.title\"></span> <button class=\"recovery-btn-close\" data-ng-click=\"goPaperlessCurrentEmailModal.closeModal()\"><i class=\"rogers-icon-circle-x\"></i></button></div></div><div class=\"ute-goPaperless-modalTypeGroup\"><div class=\"ute-goPaperless-modalTypeBody\"><div class=\"email-message\" translate=\"ute.goPaperless.emailModal.currentEmailMessage\"></div><div class=\"email-address\">{{goPaperlessCurrentEmailModal.email}}</div><span ng-click=\"goPaperlessCurrentEmailModal.updateEmail()\" class=\"update-email\" translate=\"ute.goPaperless.emailModal.updateEmail\"></span><div ng-if=\"goPaperlessCurrentEmailModal.isProcessing\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"ute-goPaperless-modalButtonGroup\"><button class=\"ute-goPaperless-modalCancelButton\" ng-click=\"goPaperlessCurrentEmailModal.closeModal()\" translate=\"ute.goPaperless.emailModal.cancel\"></button> <button class=\"ute-goPaperless-modalContinueButton\" ng-disabled=\"goPaperlessCurrentEmailModal.isProcessing\" data-ng-click=\"goPaperlessCurrentEmailModal.switchBillingType()\"><span translate=\"ute.goPaperless.emailModal.switch\"></span></button></div></div>");
$templateCache.put("module/emailModal/saveEmailModal.view.html","<div class=\"ute-go-paperless\"><div class=\"ute-goPaperless-modalHeadingGroup\"><div class=\"ute-goPaperless-modalHeading\"><span translate=\"{{goPaperlessSaveEmailModal.customerHasContactEmail ? \'ute.goPaperless.emailModal.withContactEmail.title\' : \'ute.goPaperless.emailModal.withoutContactEmail.title\'}}\"></span></div></div><form name=\"form\" ng-submit=\"goPaperlessSaveEmailModal.updateAndSwitch(form)\" novalidate=\"\"><div class=\"ute-goPaperless-modalTypeGroup\"><div class=\"ute-goPaperless-modalTypeBody\"><div class=\"body-row\" translate=\"{{goPaperlessSaveEmailModal.customerHasContactEmail ? \'ute.goPaperless.emailModal.withContactEmail.saveEmailMessage\' : \'ute.goPaperless.emailModal.withoutContactEmail.saveEmailMessage\'}}\"></div><div translate=\"{{goPaperlessSaveEmailModal.customerHasContactEmail ? \'ute.goPaperless.emailModal.withContactEmail.newEmail\' : \'ute.goPaperless.emailModal.withoutContactEmail.newEmail\'}}\"></div><div class=\"body-row\"><input type=\"email\" validation-tag=\"\" tag-form-name=\"form\" name=\"email\" id=\"email\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" maxlength=\"105\" ng-model-options=\"{updateOn: \'blur form.$submitted\', debounce: {\'default\': 200, blur: 0, \'form.$submitted\': 0}}\" ng-model=\"goPaperlessSaveEmailModal.formModel.email\" ng-focus=\"form.email.isFocused = true\" ng-blur=\"form.email.isFocused = false\" required=\"\" ng-class=\"{\'ng-focused\': form.email.isFocused}\" autocorrect=\"off\" autocapitalize=\"off\" autocomplete=\"off\"> <span ng-show=\"form.email.$valid\" class=\"inline-checker icon-checked ute-icon-checkmark-1 validation-icon\"></span><div class=\"inline_error\" ng-messages=\"form.email.$error\" ng-if=\"(( form.$submitted || form.email.$dirty ) && form.email.$invalid) && !form.email.isFocused\"><span ng-message=\"required\"><span translate=\"ute.goPaperless.emailModal.validEmailError\" adl-error-track=\'{\"mappingKey\":\"update-email\",\"field\":\"email\",\"callBackParam\": \"switch-to-online-billing\"}\'></span></span> <span ng-message=\"pattern\"><span translate=\"ute.goPaperless.emailModal.validEmailError\" adl-error-track=\'{\"mappingKey\":\"update-email\",\"field\":\"email\",\"callBackParam\": \"switch-to-online-billing\"}\'></span></span></div></div><div><div translate=\"{{goPaperlessSaveEmailModal.customerHasContactEmail ? \'ute.goPaperless.emailModal.withContactEmail.newEmailConfirm\' : \'ute.goPaperless.emailModal.withoutContactEmail.newEmailConfirm\'}}\"></div><div class=\"body-row\"><input type=\"email\" name=\"confirmEmail\" tag-form-name=\"form\" ng-model-options=\"{updateOn: \'blur form.$submitted\', debounce: {\'default\': 200, blur: 0, \'form.$submitted\': 0}}\" data-ute-match=\"form.email\" maxlength=\"105\" ng-model=\"goPaperlessSaveEmailModal.formModel.emailConfirmation\" autocorrect=\"off\" autocapitalize=\"off\" ng-focus=\"form.confirmEmail.isFocused = true\" ng-blur=\"form.confirmEmail.isFocused = false\" ng-class=\"{\'ng-focused\': form.confirmEmail.isFocused}\" ng-paste=\"$event.preventDefault()\" autocomplete=\"off\"> <span ng-show=\"form.confirmEmail.$dirty && form.confirmEmail.$valid\" class=\"inline-checker icon-checked ute-icon-checkmark-1 validation-icon\"></span><div class=\"inline_error\" ng-messages=\"form.confirmEmail.$error\" ng-if=\"(( form.$submitted || form.confirmEmail.$dirty ) && form.confirmEmail.$invalid) && !form.confirmEmail.isFocused\"><span ng-message=\"match\"><span translate=\"ute.goPaperless.emailModal.matchEmailError\" adl-error-track=\'{\"mappingKey\":\"update-email\",\"field\":\"confirm email\",\"callBackParam\": \"switch-to-online-billing\"}\'></span></span></div></div></div><div ng-if=\"goPaperlessSaveEmailModal.isProcessing\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div><div class=\"ute-goPaperless-modalButtonGroup\"><button type=\"submit\" class=\"ute-goPaperless-modalContinueButton\" name=\"button_continue\" ng-class=\"{\'disable\': !form.$valid}\" ng-disabled=\"goPaperlessSaveEmailModal.isProcessing\"><span translate=\"{{goPaperlessSaveEmailModal.customerHasContactEmail ? \'ute.goPaperless.emailModal.withContactEmail.saveAndSwitch\' : \'ute.goPaperless.emailModal.withoutContactEmail.saveAndSwitch\'}}\"></span></button> <button type=\"button\" class=\"ute-goPaperless-modalCancelButton\" ng-click=\"goPaperlessSaveEmailModal.closeModal()\" translate=\"ute.goPaperless.emailModal.cancel\"></button></div></form><img class=\"ute-goPaperless-modalClose\" data-ng-click=\"goPaperlessSaveEmailModal.closeModal()\" src=\"ute-common-assets/assets/close-icon.png\"></div>");
$templateCache.put("module/failedModal/view.html","<div class=\"ute-go-paperless\"><div class=\"ute-goPaperless-modalHeadingGroup\"><div class=\"ute-goPaperless-modalHeading\"><div class=\"row\"><div class=\"col-xs-2 col-sm-1\"><img src=\"ute-common-assets/assets/warning.png\"></div><div class=\"col-xs-10 col-sm-11\"><span translate=\"ute.goPaperless.errorTitle\"></span></div></div></div></div><div class=\"ute-goPaperless-modalTypeGroup\"><div class=\"ute-goPaperless-modalTypeBody\"><div translate=\"{{goPaperlessFailedModal.errorMessageKey}}\"></div><div class=\"row contact-info\"><div class=\"col-xs-12 col-sm-6\"><bold-chat-static-button data-cbid=\"{{\'ute.goPaperless.liveChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.goPaperless.liveChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.goPaperless.liveChat.chatButtonClass\' | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-6\"><div class=\"phone-number\">1-877 559-5202</div></div></div></div></div><img class=\"ute-goPaperless-modalClose\" data-ng-click=\"goPaperlessFailedModal.ok()\" src=\"ute-common-assets/assets/close-icon.png\"></div>");
$templateCache.put("module/learnMoreModal/view.html","<div class=\"ute-go-paperless learn-more\"><ute-content-injector language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/learn-more/learn-more/learn-more\"></ute-content-injector><div class=\"ute-goPaperless-modalButtonGroup\"><button ng-click=\"goPaperlessLearnMore.cancel()\" class=\"ute-goPaperless-modalCancelButton\" type=\"button\"><span translate=\"ute.goPaperless.learnMoreCancel\"></span></button> <button ng-click=\"goPaperlessLearnMore.switchToPaperless()\" type=\"button\" class=\"ute-goPaperless-modalContinueButton\"><span translate=\"ute.goPaperless.learnMoreSwitch\"></span></button></div><img class=\"ute-goPaperless-modalClose\" data-ng-click=\"goPaperlessLearnMore.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"></div>");
$templateCache.put("module/successModal/view.html","<div class=\"ute-go-paperless\"><ute-content-injector language=\"{{\'ute.common.label.currentLang\' | translate}}\" compile=\"true\" content-id=\"cms/content/ute/rogers/views/go-paperless-success/go-paperless-success/go-paperless-success\"></ute-content-injector><div class=\"ute-goPaperless-modalButtonGroup\"><button ng-click=\"goPaperlessSuccessModal.cancel()\" type=\"button\" class=\"ute-goPaperless-modalContinueButton\" name=\"button_continue\"><span translate=\"ute.goPaperless.modalDone\"></span></button></div><img class=\"ute-goPaperless-modalClose\" data-ng-click=\"goPaperlessSuccessModal.cancel()\" src=\"ute-common-assets/assets/close-icon.png\"></div>");
$templateCache.put("module/novaContentDirective/novaContent.directive.view.html","<section><div class=\"ute-nova-content-container col-xs-12\"><div class=\"row ute-nova-content-body\"><div class=\"ute-nova-content-heading\"><h4><span ng-bind=\"nc.model.novaContent.primaryHeading\"></span> <span></span> <span ng-bind=\"nc.model.novaContent.secondaryHeading\"></span></h4></div><div class=\"ute-nova-content-link\" ng-repeat=\"linkItem in nc.model.novaContent.linkItems\"><a href=\"{{linkItem.link}}\" target=\"_blank\"><span ng-bind=\"linkItem.linkText\"></span> <span class=\"spacing rui-icon-share\"></span></a></div></div></div></section>");
$templateCache.put("module/oneviewFooterDirective/oneviewFooter.directive.view.html","<div class=\"one-view-repview-footer\" ng-hide=\"oneviewFooter.disableFooter\"><div ng-class=\"oneviewFooter.showQuickLinks? \'one-view-footer-large-height\': \'one-view-footer-small-height\'\"></div><div class=\"one-view-footer-timer-container\"><ute-oneview-footer-session-popup></ute-oneview-footer-session-popup><div class=\"col-sm-12 col-md-12 col-lg-12 one-view-footer-section\"><ute-oneview-footer-session-timer></ute-oneview-footer-session-timer><div class=\"container one-view-footer-container\"><span class=\"pointer one-view-footer-small-width one-view-footer-dropdown-container\" data-ng-click=\"oneviewFooter.toggleQuickLinksSection()\" data-ng-class=\"oneviewFooter.showQuickLinks? \'one-view-footer-rotate-span\' : \'\'\"><a class=\"pointer one-view-footer-link one-view-footer-container-dropdown\" ng-hide=\"oneviewFooter.showQuickLinks\"><div><span class=\"rui-icon-arrow-down one-view-footer-dropdown-icon\"></span></div></a> <a class=\"pointer one-view-footer-link one-view-footer-container-dropdown\" ng-show=\"oneviewFooter.showQuickLinks\"><div><span class=\"rui-icon-arrow-down one-view-footer-dropdown-icon\"></span></div></a></span> <span class=\"one-view-footer-fixed-width-dealer\" ng-if=\"oneviewFooter.isDealer\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-border-right\' : \'\'\"><form name=\"footerFormToSSP\" id=\"footerFormToSSP\" method=\"post\" novalidate=\"\" ng-show=\"false\"><input type=\"hidden\" name=\"data\" id=\"sharedKey\"> <input type=\"hidden\" name=\"sig\" id=\"signature\"> <input type=\"hidden\" name=\"content\" id=\"content\"></form><a class=\"pointer one-view-footer-link one-view-footer-placeholder-link\" href=\"\" target=\"_blank\" data-ng-click=\"oneviewFooter.goToSsp()\"><span translate=\"ute.oneview.footer.directive.goToSsp\"></span></a></span> <span ng-if=\"oneviewFooter.isCare && oneviewFooter.$state.current.name\" adl-event-track=\'{\"action\":\"click\",\"callBackParam\":{\"mappingKey\":\"footerLinks\", \"linkId\":\"Nova\"}}\' class=\"\" data-ng-class=\"{\'one-view-footer-border-right\' : oneviewFooter.editQuickLinks, \'one-view-footer-fixed-width-dealer\' : oneviewFooter.isDealer, \'one-view-footer-fixed-width-care\' : oneviewFooter.isCare}\"><a class=\"pointer one-view-footer-link\" ng-href=\"{{oneviewFooter.novaLink}}\" target=\"_blank\"><span translate=\"ute.oneview.footer.directive.goToNova\"></span></a></span> <span ng-if=\"oneviewFooter.$state.current.name\" ng-repeat=\"link in oneviewFooter.placeQuickLinks track by $index\" data-ng-class=\"{\'one-view-footer-border-right\' : oneviewFooter.editQuickLinks, \'one-view-footer-large-width-dealer\' : oneviewFooter.isDealer, \'one-view-footer-large-width-care\' : oneviewFooter.isCare}\" ad-drop=\"true\" ad-drop-over=\"oneviewFooter.onDragOver($data, $dragElement, $dropElement, $event);\" ad-drop-leave=\"oneviewFooter.onDragLeave($data, $dragElement, $dropElement, $event)\" ad-drop-end=\"oneviewFooter.onDrop($data, $index, $dragElement, $dropElement, $event);\" class=\"ad-droppable\"><span ad-drag=\"{{oneviewFooter.editQuickLinks}}\" ad-drag-data=\"link\" ad-drag-end=\"oneviewFooter.onDragEnd($data, $index, $dragElement, $lastDropElement, $event);\" ad-drag-begin=\"oneviewFooter.onDragStart($data, $index, $dragElement, $event);\" class=\"one-view-footer-pinned-link-container\"><a adl-event-track=\'{\"action\":\"click\",\"callBackParam\":{\"mappingKey\":\"footerLinks\", \"linkId\":\"{{link.id.toLowerCase()}}\"}}\' class=\"one-view-footer-placeholder-link one-view-footer-link\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-disable-link\' : \'pointer\'\" ng-href=\"{{oneviewFooter.editQuickLinks ? \'\' : link.link }}\" target=\"_blank\"><span ng-bind=\"link.label\"></span></a></span></span><span ng-if=\"oneviewFooter.$state.current.name\" data-ng-class=\"{\'one-view-footer-fixed-width-dealer\' : oneviewFooter.isDealer, \'one-view-footer-fixed-width-care\' : oneviewFooter.isCare}\"></span> <span ng-if=\"oneviewFooter.$state.current.name\" adl-event-track=\'{\"action\":\"click\",\"callBackParam\":{\"mappingKey\":\"footerLinks\", \"linkId\":\"Yammer\"}}\' class=\"one-view-footer-small-width\" ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-border\' : \'\'\"><a class=\"pointer one-view-footer-link\" href=\"https://www.yammer.com/rci.rogers.com/#/threads/inGroup?type=in_group&amp;feedId=6316193\" target=\"_blank\"><span class=\"one-view-footer-yammer-icon-container\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/yammer/yammerIcon.png\" class=\"one-view-footer-yammer-icon\"></span></a></span></div><div class=\"one-view-footer-quicklinks-container\" ng-show=\"oneviewFooter.showQuickLinks\"><div ng-if=\"oneviewFooter.$state.current.name\" class=\"container\"><div class=\"col-lg-2 col-xs-12 one-view-footer-quicklinks-header float-left\"><div class=\"one-view-footer-quicklinks-heading\" translate=\"ute.oneview.footer.directive.quickLinks\"></div><span class=\"one-view-footer-edit-icon-container pointer\" data-ng-click=\"oneviewFooter.editQuickLinksSection()\" ng-hide=\"oneviewFooter.editQuickLinks\"><img ng-hide=\"oneviewFooter.editQuickLinks\" class=\"one-view-footer-my-links-edit-icon\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"quicklinks-customization,event.selfServeStart\"}\' src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/footer/edit_icon.png\"></span><div class=\"one-view-footer-my-links-save-button\"><button class=\"one-view-footer-save-button\" data-ng-click=\"oneviewFooter.saveQuickLinksSection()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"quicklinks-customization,event.selfServeComplete\"}\' ng-show=\"oneviewFooter.editQuickLinks\"><span translate=\"ute.oneview.footer.directive.save\"></span></button></div></div><div class=\"col-xs-12 col-lg-9 one-view-footer-quicklinks-list float-left\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-border-left\' : \'\'\"><div class=\"one-view-footer-quicklinks-table\"><div class=\"one-view-footer-quicklinks-list-container\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-cursor-move\' : \'\'\" ng-repeat=\"link in oneviewFooter.quickLinksList | orderBy:displayOrder\" ad-drag=\"{{oneviewFooter.editQuickLinks}}\" ad-drag-clone-element=\"true\" ad-drag-data=\"link\" ad-drop=\"true\" ad-drop-end=\"oneviewFooter.onDropPinnedLink($data, $index, $dragElement, $dropElement, $event);\" ad-drop-leave=\"oneviewFooter.onDragOverLinks($data, $index, $dragElement, $dropElement, $event)\"><div ng-show=\"oneviewFooter.editQuickLinks\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-move-icon-container\' : \'one-view-footer-disable-link\'\"><img class=\"one-view-footer-move-icon\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/footer/moving_icon.png\"></div><div class=\"one-view-footer-links-div-container\"><a adl-event-track=\'{\"action\":\"click\",\"callBackParam\":{\"mappingKey\":\"footerLinks\", \"linkId\":\"{{link.id}}\"}}\' ng-href=\"{{link.link}}\" data-ng-class=\"oneviewFooter.editQuickLinks ? \'one-view-footer-disable-link\' : \'pointer\'\" target=\"_blank\" class=\"one-view-footer-load-links-container\"><span ng-bind=\"link.label\"></span></a></div></div></div></div></div></div></div></div></div><div class=\"one-view-consumer-footer\" ng-hide=\"oneviewFooter.disableFooter\"><div data-uteoneviewconsumerfooter=\"\"></div></div>");
$templateCache.put("module/oneviewFooterDirective/oneviewFooter.rep.feedback.directive.view.html","");
$templateCache.put("module/oneviewFooterSession/oneviewFooter.session.directive.view.html","<div class=\"one-view-footer-timer\"><div class=\"container\"><div ng-show=\"oneviewFooterSession.editQuickLinks\" class=\"one-view-footer-quicklink-message float-left\"><img width=\"20\" height=\"20\" class=\"one-view-footer-handler-icon\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/footer/handler.png\"> <span class=\"one-view-footer-move-link-message\" translate=\"ute.oneview.footer.directive.moveLinkMessage\"></span></div><div class=\"one-view-footer-timer-display float-right\"><img class=\"one-view-footer-session-info-icon\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/common/info_icon.png\"> <span translate=\"ute.oneview.footer.directive.timeRemaining\"></span> <span ng-bind=\"oneviewFooterSession.minutes + \':\' + oneviewFooterSession.seconds\"></span></div></div></div>");
$templateCache.put("module/oneviewFooterSession/oneviewFooter.session.popup.directive.view.html","<div class=\"container\"><div class=\"one-view-footer-timer-area-box pull-right col-xs-12\" ng-show=\"oneviewFooterSession.showPopup\"><div class=\"one-view-footer-warning-img col-xs-2\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/common/info_icon.png\"></div><div class=\"one-view-footer-message-box col-xs-10\"><span class=\"one-view-footer-signout-message\" translate=\"ute.oneview.footer.directive.willSignOut\"></span> <span class=\"one-view-footer-signout-message\" ng-bind=\"oneviewFooterSession.minutes + \':\' + oneviewFooterSession.seconds\"></span><p class=\"one-view-footer-continue-message\" translate=\"ute.oneview.footer.directive.wantToStaySignin\"></p></div><div class=\"one-view-footer-button-container col-xs-12\"><button ng-click=\"\" class=\"one-view-footer-stay-signed\" translate=\"ute.oneview.footer.directive.staySignedIn\"></button> <button ng-click=\"oneviewFooterSessionPopup.signedOut($event)\" class=\"one-view-footer-sign-out pointer\" translate=\"ute.oneview.footer.directive.signOut\"></button></div></div></div>");
$templateCache.put("module/cartMenu/cartMenu.html","<div class=\"cartMenu\" ng-class=\"(isConsumer || !isRepView)?\'consumerCartMenu\':\'\'\"><div ng-show=\"loadingImg\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading\" width=\"40px\"></div><div ng-hide=\"loadingImg && !content\"><consumer-cart-menu content=\"content\" ng-if=\"(isConsumer ) && consumerCart && content\"></consumer-cart-menu><rep-cart-menu content=\"content\" ng-if=\"(isDealer || isCare) && permittedShopping && content\"></rep-cart-menu></div></div><ute-has-permission key=\"{{::interactionBRTSwitchName}}\" ng-if=\"(isDealer || isCare)\"><div class=\"col-notes\" style=\"position:relative\" ng-if=\"(!isConsumer)\"><ute-oneview-interaction-notes></ute-oneview-interaction-notes></div></ute-has-permission>");
$templateCache.put("module/cartMenu/consumerCartMenu.html","<div class=\"orderList\" ng-show=\"totalOrders>0\" ng-mouseleave=\"clickedOrder = \'\'\"><div class=\"displayBrdr hidden-xs\"></div><div class=\"iconContainer\" tabindex=\"0\"><span class=\"color consumerView\">{{totalOrders}}</span> <img src=\"/web/totes/cms/images/cart-icon.png\" alt=\"cartIcon\" width=\"24px\" height=\"33px\" class=\"cartIcon\"></div><div class=\"showBg\" ng-if=\"totalOrders>0\"></div><ul class=\"dropdown dropdownMaxHeight\" ng-class=\"(totalOrders==0)?\'dropdown_noborder\':\'\'\"><li class=\"title_border order_title\" ng-if=\"orders.length>=1\"><span translate=\"ute.common.oneview.header.consumerCart._my_cart\"></span></li><li ng-repeat=\"order in orders track by $index\"><div ng-if=\"order.activityType.toLowerCase() !== \'ignite\'\" class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(order.activityType,order.orderId,\'order\',order.assemblyIds[0], order);\"><div class=\"col-lg-1 col-xs-1\"><i class=\"rui-icon-wireless icon tazo-icon\"></i></div><div class=\"col-lg-10 col-xs-10 pdgLft\"><span class=\"cartTitle\" translate=\"{{\'ute.common.oneview.header.consumerCart.\'+order.activityType.toLowerCase()}}\"></span> <span ng-if=\"order.activityType.toLowerCase() != \'nac\'\"><span ng-repeat=\"ctn in order.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtnInHeader}}&nbsp;<span ng-if=\"order.assemblyIds.indexOf(ctn)<(order.assemblyIds.length-1)\">,&nbsp;</span></span></span></div><div class=\"col-lg-1 col-xs-1\"><img ng-hide=\"clickedOrder === order.orderId\" ng-click=\"cancelOrder($event, order.orderId)\" src=\"ute-common-assets/assets/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder===order.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-if=\"order.activityType.toLowerCase() === \'ignite\'\" class=\"col-lg-12 col-xs-12 orderContainer\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"cart-abandonment-ignite-bundle\"}\' ng-click=\"redirectToPage(order.activityType,order.orderId,\'order\',order.assemblyIds[0], order);\"><div class=\"col-lg-1 col-xs-1\"><i class=\"rui-icon-ignite-box-2 icon tazo-icon\" alt=\"null\"></i></div><div class=\"col-lg-10 col-xs-10 pdgLft\"><span class=\"cartTitle\" translate=\"{{\'ute.common.oneview.header.consumerCart.\'+order.activityType.toLowerCase()}}\"></span></div><div class=\"col-lg-1 col-xs-1\"><img ng-hide=\"clickedOrder === order.orderId\" ng-click=\"cancelOrder($event, order.orderId)\" src=\"ute-common-assets/assets/cart_delete_icon.png\" alt=\"{{\'ute.common.oneview.header.consumerCart.igniteDeleteAlt\' | translate}}\"> <span data-ng-show=\"clickedOrder===order.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-class=\"$last && quotes.length == 0 ?\'\':\'btmBorder\'\"></div></li><li class=\"title_border order_title quote_title\" ng-if=\"quotes.length>=1\"><span translate=\"ute.common.oneview.header.consumerCart._saved_quotes\"></span></li><li ng-repeat=\"quote in quotes track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(quote.activityType,quote.orderId,\'quote\',quote.assemblyIds[0], quote);\"><div class=\"col-lg-1 col-xs-1\"><i class=\"rui-icon-wireless icon tazo-icon\"></i></div><div class=\"col-lg-10 col-xs-10 pdgLft\"><span class=\"cartTitle\" translate=\"{{\'ute.common.oneview.header.consumerCart.\' +quote.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in quote.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtnInHeader}}&nbsp;<span ng-if=\"quote.assemblyIds.indexOf(ctn)<(quote.assemblyIds.length-1)\">,&nbsp;</span></span><div class=\"cartCtn\"><span translate=\"ute.common.oneview.header.consumerCart._quote\"></span><span>{{quote.orderId}}</span></div><div class=\"cartExpiry\"><span ng-show=\"quote.quoteExpired\" translate=\"ute.common.oneview.header.consumerCart._expired\"></span><span ng-hide=\"quote.quoteExpired\" translate=\"ute.common.oneview.header.consumerCart.expires\"></span>&nbsp;&nbsp;<span ng-hide=\"quote.quoteExpired\">{{quote.quoteExpiryDate}}</span></div></div><div class=\"col-lg-1 col-xs-1\"><img ng-hide=\"clickedOrder === quote.orderId || !quote.quoteExpired\" ng-click=\"cancelOrder($event, quote.orderId)\" src=\"ute-common-assets/assets/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder === quote.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-class=\"$last?\'\':\'btmBorder\'\"></div></li></ul></div>");
$templateCache.put("module/cartMenu/repCartMenu.html","<div class=\"orderList\" ng-show=\"totalOrders>0\" ng-mouseleave=\"clickedOrder = \'\'\"><div class=\"iconContainer repView\"><span class=\"color\">{{totalOrders}}</span><img src=\"ute-common-assets/assets/shopping_cart_icon_red.png\" alt=\"cartIcon\" class=\"cartIcon\"></div><div class=\"showBg\" ng-if=\"totalOrders>0\"></div><ul class=\"dropdown col-lg-12\" ng-class=\"(totalOrders==0)?\'dropdown_noborder\':\'\'\"><li class=\"title_border order_title\" ng-if=\"quotes.length>=1\"><span translate=\"ute.common.oneview.header.repCart._saved_quotes\"></span></li><li ng-repeat=\"quote in quotes track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(quote.activityType,quote.orderId,\'quote\',quote.assemblyIds[0],quote);\"><div class=\"col-xs-11 rep-quote\"><span class=\"cartTitle\" translate=\"{{\'ute.common.oneview.header.repCart.\' + quote.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in quote.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtnInHeader}}&nbsp;<span ng-if=\"quote.assemblyIds.indexOf(ctn)<(quote.assemblyIds.length-1)\">,&nbsp;</span></span><div class=\"cartCtn\"><span translate=\"ute.common.oneview.header.repCart._quote\"></span><span>{{quote.orderId}}</span></div><div class=\"cartExpiry\"><span ng-show=\"quote.quoteExpired\" translate=\"ute.common.oneview.header.repCart._expired\"></span> <span ng-hide=\"quote.quoteExpired\" translate=\"ute.common.oneview.header.repCart.expires\"></span>&nbsp;&nbsp; <span ng-hide=\"quote.quoteExpired\">{{quote.quoteExpiryDate}}</span></div></div><div class=\"col-xs-1 rep-quote-delete\"><img class=\"pull-right\" ng-hide=\"clickedOrder === quote.orderId || !quote.quoteExpired\" ng-click=\"cancelOrder($event, quote.orderId)\" src=\"ute-common-assets/assets/cart_delete_icon.png\" alt=\"delete_cart\"> <span data-ng-show=\"clickedOrder===quote.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div></div><div ng-class=\"$last && orders.length == 0?\'\':\'btmBorder\'\"></div></li><li class=\"title_border order_title quote_title\" ng-if=\"orders.length>=1\"><span translate=\"ute.common.oneview.header.repCart._my_cart\"></span></li><li ng-repeat=\"order in orders track by $index\"><div class=\"col-lg-12 col-xs-12 orderContainer\" ng-click=\"redirectToPage(order.activityType,order.orderId,\'order\',order.assemblyIds[0],order);\"><span class=\"cartTitle\" translate=\"{{\'ute.common.oneview.header.repCart.\' + order.activityType.toLowerCase()}}\"></span><span ng-repeat=\"ctn in order.assemblyIds track by $index\" class=\"ctnformat\">{{ctn | formatCtnInHeader}}&nbsp; <span ng-if=\"order.assemblyIds.indexOf(ctn)<(order.assemblyIds.length-1)\">,&nbsp;</span></span> <img class=\"pull-right\" ng-hide=\"clickedOrder === order.orderId\" ng-click=\"cancelOrder($event, order.orderId)\" src=\"ute-common-assets/assets/cart_delete_icon.png\" alt=\"delete_cart\"> <span class=\"pull-right\" data-ng-show=\"clickedOrder === order.orderId\"><img src=\"/web/totes/cms/images/widget-loader.gif\" alt=\"loading\" width=\"20px\" height=\"28px\"></span></div><div ng-class=\"$last?\'\':\'btmBorder\'\"></div></li></ul></div>");
$templateCache.put("module/consumerDetails/consumerDetails.html","<div ng-class=\"{\'is-open\': al.isOpen}\" class=\"directive-oneview-consumer-details col-lg-12\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":\"true\",\"mappingKey\":\"customer-flyout\"}\'><div role=\"button\" ng-click=\"al.toggleIsOpen()\" class=\"col-lg-12 consumer-details-wrapper\"><div class=\"before-chevron\"><span class=\"widget-loader-inline\" ng-hide=\"al.isConsumerBriefInfoReady\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span><div class=\"consumer-details-container\"><div class=\"idv-flag-section\" ng-if=\"al.idvStatusCheck || al.unknownIDVStatus\"><div ng-if=\"al.idvStatusCheck\" class=\"idv-flag\">IDV</div><div ng-if=\"al.unknownIDVStatus\" class=\"unknown-idv-flag\">?</div></div><div class=\"consumer-details-name\"><span class=\"consumer-name\">{{al.fullName}}</span><span class=\"ban-number\">{{al.accountDetails.accountNumber}}</span></div></div><div class=\"consumer-address-container\">{{al.customerAddressOneLine}}</div></div><div ng-class=\"{\'is-open\': al.isOpen}\" class=\"toggle-circle\"><div class=\"ute-icon-chevron-down\"></div></div></div><div class=\"col-xs-12 visible-xs show-more-container\"><a id=\"showMoreLink\" href=\"javascript:void(0)\" aria-expanded=\"al.isC_LimitDisplay\" class=\"rui-cta-link details-expander\" ng-click=\"getConsumerDetailsForMobile()\"><span translate=\"ute.common.oneview.header.consumerDetails.show_more\"></span></a></div><div ng-class=\"{\'is-open\': al.isOpen}\" class=\"col-xs-12 consumer-details-collapsible consumer-details-collapsible-expanded\" id=\"consumer-details-collapsible\"><div class=\"col-xs-12 visible-xs show-less-container\"><a id=\"showLessLink\" href=\"javascript:void(0)\" class=\"rui-cta-link\" aria-expanded=\"false\" ng-click=\"closeConsumerDetails()\"><span translate=\"ute.common.oneview.header.consumerDetails.show_less\"></span></a></div><div class=\"row\"><div class=\"active-account-info no-left-margin\"><div class=\"active-account-info-header no-left-margin\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\">{{al.accountStatus}}</div><div class=\"hidden-xs bold-font no-left-margin\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div ng-if=\"!(al.isCable)\" class=\"credit-wrapper\"><span class=\"ted-next-semi-bold\">{{al.accountType}}: <span class=\"ted-next-regular\">{{al.accountSubType}}</span></span><div ng-if=\"al.isCreditClass\" class=\"no-h-margin\"><span class=\"ted-next-semi-bold\" translate=\"ute.common.oneview.header.consumerDetails.c_class\"></span> <span class=\"ted-next-regular\">{{al.customerInfo.creditClass}}</span></div><div ng-if=\"al.isC_LimitDisplay\" class=\"no-h-margin\"><span translate=\"ute.common.oneview.header.consumerDetails.c_limit\"></span> <span class=\"credit-limit\">{{al.customerInfo.creditLimit | currenciesHeader:al.lng.getCurrentLanguage()}}</span></div><div ng-if=\"al.isC_LimitDisplay && al.customerInfo.creditAvailable && al.customerInfo.creditAvailable != 0\" class=\"no-h-margin\"><span translate=\"ute.common.oneview.header.consumerDetails.c_available\"></span> <span class=\"c-balance\">{{al.customerInfo.creditAvailable | currenciesHeader:al.lng.getCurrentLanguage()}}</span></div></div></div><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-12 visible-xs credit-wrapper\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div ng-if=\"!al.isCable\"><span class=\"col-lg-2 col-md-2 col-sm-2\">{{al.accountType +\' - \'+ al.accountSubType }}</span> <span class=\"col-lg-4 col-md-4 col-sm-4\" ng-if=\"al.isCreditClass\"><span translate=\"ute.common.oneview.header.consumerDetails.c_class\"></span> <span>{{al.customerInfo.creditClass}}</span></span> <span ng-if=\"al.isC_LimitDisplay\" class=\"col-xs-12 col-xs-12 col-lg-4 col-md-4 col-sm-4\"><span translate=\"ute.common.oneview.header.consumerDetails.c_limit\"></span> <span class=\"credit-limit\">{{al.customerInfo.creditLimit | currenciesHeader:al.lng.getCurrentLanguage()}}</span></span> <span ng-if=\"al.isC_LimitDisplay\" class=\"col-xs-12 col-xs-12 col-lg-2 col-md-2 col-sm-2\"><span translate=\"ute.common.oneview.header.consumerDetails.c_available\"></span> <span class=\"c-balance\">{{(al.customerInfo.creditLimit - al.customerInfo.balanceAmount) | currenciesHeader:al.lng.getCurrentLanguage() }}</span></span></div></div></div><div class=\"tenure-info\"><div><div class=\"tenure-container\" translate=\"ute.common.oneview.header.consumerDetails.tenure\"></div><div class=\"small-text margin-left10\">{{al.duration}}</div><div class=\"small-text margin-left10\"><span class=\"ted-next-semi-bold\" translate=\"ute.common.oneview.header.consumerDetails.since\"></span>: <span class=\"ted-next-regular\">{{al.accountEffectiveDate}}</span></div></div></div></div><div class=\"dotted-hr-line\" ng-if=\"al.isARPAPermitted\"></div><div class=\"arpa-section\" ng-if=\"al.isARPAPermitted\"><div class=\"row\"><div class=\"arpa-heading\"><div class=\"arpa-label\" translate=\"ute.common.oneview.header.consumerDetails.arpa\"></div><div class=\"arpa-info-section\"><img class=\"arpa-info-icon\" src=\"ute-common-assets/assets/info_notice.png\" alt=\"info-icon\"><div class=\"arpa-info-content\"><span class=\"arrow-left\"></span> <span translate=\"ute.common.oneview.header.consumerDetails.arpa_info\"></span></div></div></div><div class=\"arpa-value\"><span ng-if=\"al.lang === \'en\'\">$</span> <span ng-if=\"al.arpa.arpaValue != \'-\'\">{{al.arpa.arpaValue.substr(0, al.arpa.arpaValue.indexOf(\'.\'))}}</span> <span ng-if=\"al.arpa.arpaValue === \'-\'\">-</span> <span ng-if=\"al.lang === \'fr\'\">$</span></div></div><div ng-if=\"al.arpa.arpaError\" class=\"row\"><div class=\"col-xs-12 arpa-error-msg\" translate=\"ute.common.oneview.header.consumerDetails.arpa_error_msg\"></div></div></div><div class=\"idv-account-info col-xs-12\"><div class=\"row idv-status-section\" ng-class=\"{\'add-padding-bottom\' : (al.unknownIDVStatus || !al.isIDVAccount)}\"><div class=\"col-xs-6 idv-status\" ng-if=\"!al.unknownIDVStatus\">{{al.displayIDVStatus|translate}}</div><div class=\"col-xs-12 idv-status\" ng-if=\"al.unknownIDVStatus\">{{al.displayIDVStatus|translate}}</div><div class=\"col-xs-6 idv-button-section\" ng-if=\"!al.statusIDVLoading && !al.unknownIDVStatus && al.idvAccountButtonText\"><span class=\"btn idv-button\" ng-click=\"al.toggleIsOpen();showEnableIDV();\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"enable-IDV-account,event.selfServeStart\"}\'>{{al.idvAccountButtonText | translate}}</span></div></div><div ng-if=\"!al.statusIDVLoading && !al.unknownIDVStatus && al.isIDVAccount && al.idvDetails\"><div class=\"row company-name-section\" ng-if=\"al.idvDetails.idvCompanyName\"><div class=\"col-xs-12\"><span translate=\"ute.common.oneview.header.idvDetails.company_name\"></span> <span ng-bind-html=\"al.idvDetails.idvCompanyName\"></span></div></div><div class=\"idv-details-section collapse\" id=\"idv-details\"><div ng-if=\"al.idvDetails.idvCompanyCode\"><span translate=\"ute.common.oneview.header.idvDetails.company_code\"></span> <span ng-bind-html=\"al.idvDetails.idvCompanyCode | uppercase\"></span></div><div ng-if=\"al.idvDetails.idvStatusDate\"><span translate=\"ute.common.oneview.header.idvDetails.idv_status_date\"></span> <span ng-bind-html=\"al.idvDetails.idvStatusDate | date : \'dd/MM/yyyy\'\"></span></div><div ng-if=\"al.idvDetails.discountFallOffDate\"><span translate=\"ute.common.oneview.header.idvDetails.idv_falloff_date\"></span> <span ng-bind-html=\"al.idvDetails.discountFallOffDate | date : \'dd/MM/yyyy\'\"></span></div><div ng-if=\"al.idvDetails.lastValidationValidDate\"><span translate=\"ute.common.oneview.header.idvDetails.last_validation_date\"></span> <span ng-bind-html=\"al.idvDetails.lastValidationValidDate | date : \'dd/MM/yyyy\'\"></span></div></div><div class=\"show-idv-details col-xs-12\"><a href=\"javascript:void(0)\" aria-expanded=\"vm.expandIDVDetails\" data-toggle=\"collapse\" data-target=\"#idv-details\" ng-click=\"al.expandAndCollapseDetails()\"><span>{{al.expandCollapseText | translate}}</span> <span class=\"expand-icon\" ng-class=\"{\'rui-icon-chevron-up\' : al.expandCollapseText.indexOf(\'hide\') > 0, \'rui-icon-chevron-down\' : al.expandCollapseText.indexOf(\'show\') > 0}\"></span></a></div></div></div><span class=\"widget-loader-inline consumer-overlay-loader\" ng-if=\"al.loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span class=\"widget-loader-inline consumer-overlay-empty-content\" ng-if=\"al.customerInfoFailure\"><span translate=\"ute.common.oneview.header.consumerDetails.content_currently_unavailable\"></span></span><div class=\"transaction-details col-xs-12\" ng-if=\"!al.loadingDataIndicator && !al.customerInfoFailure\"><div class=\"sub-title\" translate=\"ute.common.oneview.header.consumerDetails.interactions_in_the_last_30_days\"></div><div class=\"col-xs-12 interaction-section\"><div class=\"interaction-container mtop\"><div class=\"outer-circle\"><div class=\"inner-circle number\">{{al.customerInfo.totalInteractionsAndCases}}</div></div><div class=\"interaction-label ted-next-semi-bold\" translate=\"ute.common.oneview.header.consumerDetails.c_interactions\"></div></div><div class=\"interaction-container\"><div class=\"outer-circle\" ng-if=\"al.customerInfo.totalCases >= 0\"><div class=\"inner-circle number\" ng-if=\"al.customerInfo.totalCases > 0\"><a ui-sref=\"interaction({filter:\'Ticket\'})\">{{al.customerInfo.totalCases}}</a></div><div class=\"inner-circle number\" ng-if=\"al.customerInfo.totalCases === 0\">{{al.customerInfo.totalCases}}</div></div><div class=\"interaction-label ted-next-semi-bold\" translate=\"ute.common.oneview.header.consumerDetails.filer_tickets\"></div></div></div></div></div></div>");
$templateCache.put("module/oneViewHeaderDirective/oneViewHeader.html","<div class=\"page-one-view-dashboard clear-both one-view-header-module\"><div class=\"directive-repview-header\" data-ng-show=\"selfDestructFlag\"><div class=\"rep-view-top-header\" style=\"position: fixed\" role=\"banner\" id=\"header\"><div class=\"container\"><div class=\"navbar-header hidden-xs col-sm-2\"><a title=\"Rogers\" class=\"navbar-brand\" target=\"_blank\" href=\"/\">Rogers</a></div><div class=\"context-container col-sm-5\"></div><div class=\"rep-header-right-container col-sm-5\"><div class=\"hidden-xs col-sm-10 logout-container\"><a class=\"col-xs-5\" ng-click=\"executeLogOut()\" id=\"oneViewLogoutAction\"><span translate=\"ute.common.oneview.header.global.sign_out\"></span> <span class=\"plan-arrow\"><span class=\"ute-icon-arrow-right\"></span></span></a><div class=\"col-xs-2 pull-right\" id=\"dealerCodeSection\" ng-show=\"displayDealerCodeSection\"><ute-update-dealer-code></ute-update-dealer-code></div><div class=\"col-xs-4 rep-name-container\" ng-class=\"{\'rep-name-container-withDC\' : displayDealerCodeSection && lang===\'fr\'}\" ng-if=\"!repName\"><span translate=\"ute.common.oneview.header.global.welcome\"></span></div><div class=\"col-xs-7 col-sm-5 col-md-6 rep-name-container rep-container-right\" ng-class=\"{\'rep-name-container-withDC\' : displayDealerCodeSection && lang===\'fr\'}\" ng-if=\"repName\"><span translate=\"ute.common.oneview.header.global.welcome_comma\"></span><span class=\"rep-name\" onselectstart=\"onRepNameSelect()\" data-ng-bind=\"repName\"></span></div></div><div id=\"nav-context-bar\" class=\"hidden-xs col-sm-2\"><a ng-click=\"changeLanguage()\"><span translate=\"ute.common.oneview.header.global.language_toggle\"></span></a></div><ssp-dashboard></ssp-dashboard></div></div></div><div class=\"container\"><div class=\"new-header\"><div class=\"consumer-details-section\"><consumer-details></consumer-details></div><div class=\"dealer-code-section\"><div ng-if=\"displayDealerCodeSection\"><ute-capture-behalf-of-dealer-code></ute-capture-behalf-of-dealer-code></div></div></div></div><div class=\"ov-sub-menu\"><one-view-submenu one-view-interface-flag=\"{{isOneViewInterface}}\"></one-view-submenu></div></div></div>");
$templateCache.put("module/oneViewSubmenu/oneViewSubmenu.html","<div class=\"cart-menu-directive\" ng-if=\"!isConsumer\"><div class=\"container\" style=\"height: 54px; position: relative; left:70px;\"><cart-menu></cart-menu></div></div><div class=\"directive-repview-submenu\"><div class=\"menu-container\"><div class=\"container\"><header class=\"navbar navbar-header navbar-fixed-top status-post\" role=\"banner\" id=\"header\"><div class=\"navbar-header visible-xs\"><button title=\"Menu\" class=\"navbar-toggle collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#rep-view-menu\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <i class=\"rui-icon-menu\"></i></button> <a title=\"Rogers\" class=\"navbar-brand\" href=\"/\">Rogers</a></div><div class=\"shadow\" ng-click=\"menuClick()\"></div><nav id=\"rep-view-menu\" class=\"navbar-collapse bs-navbar-collapse collapse\" aria-expanded=\"false\" style=\"height: 4px;\"><ul class=\"nav navbar-nav\"><li id=\"username\"><span class=\"signedin\"><i class=\"rui-icon-lock-small\"></i> <span>Welcome</span> <span id=\"user-name\"></span></span> <a href=\"#\" id=\"logoutAction\">Sign out <i class=\"rui-icon-arrow-right\"></i></a></li><li class=\"\"><a href=\"{{BASEURL}}/web/totes/#/oneViewDashboard\" class=\"overview-mobile\" role=\"button\" data-ng-class=\"(isSubMenuEnabled(\'accountOverview\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.overview ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"ute.common.oneview.header.subMenu.acc_overview_my_account_overview\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li ng-if=\"(isDealer || isCare) && isPrepaid\"><a class=\"pointer\" data-ng-class=\"(!repPaymentStart ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.billingAndPayment ? \'oneViewSelectedTab\' : \'\')\" ng-click=\"repPaymentStart && isSubMenuEnabled(\'billingAndPayment\') && rogersORpaybill()\" role=\"button\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_billing_and_payment\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li class=\"dropdown\" ng-if=\"(isDealer || isCare) && !isPrepaid\"><a class=\"pointer services-menu\" data-ng-class=\"(isSubMenuEnabled(\'billingAndPayment\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.billingAndPayment ? \'oneViewSelectedTab\' : \'\')\" data-toggle=\"dropdown\" role=\"button\" ng-click=\"postToRogers()\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_billing_and_payment\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"viewbill-billing-and-payment,oneViewDashboard\"}\'></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li class=\"dropdown\" ng-class=\"selSubMenuItem === subMenuItems.services ? \'selected\' : \'\'\"><a class=\"pointer services-menu\" id=\"servicesDropDown\" data-ng-class=\"(isSubMenuEnabled(\'services\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.services ? \'oneViewSelectedTab\' : \'\')\" ng-click=\"isSubMenuEnabled(\'services\') && navSubMenuClick($event)\" data-toggle=\"dropdown\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_services\"></span> <span class=\"ute-icon-chevron-down\"></span></div></a><ul class=\"dropdown-menu\" role=\"menu\" aria-labelledby=\"servicesDropDown\" data-ng-show=\"isDropDownEnabled()\"><li data-ng-repeat=\"msl in subMenuMyServicesList track by $index\" data-ng-hide=\"hideDropDown()\"><a ng-if=\"!msl.subscriptionBadgeModule\" ng-hide=\"isCare && (msl.hide || (isAccountSuspended && msl.serviceName === \'shmdashboard\'))\" class=\"pointer\" ng-click=\"(btnSettings.allSubscriptions !== btnStatus.disabled) ? runService(\'{{msl.serviceName}}\', \'{{msl.serviceDetail}}\') : \'\'\"><span class=\"service-account-type\" translate=\"{{\'ute.common.oneview.header.subMenu.\' + msl.serviceType}}\" ng-hide=\"(isDealer || hideRHPFlowForCare()) && msl.serviceName === \'homephone\'\"></span> <span class=\"service-account-number\" ng-hide=\"(isDealer || hideRHPFlowForCare()) && msl.serviceName === \'homephone\'\">{{ msl.serviceName === \'wireless\' || msl.serviceName === \'shareEverything\' || msl.serviceName === \'homephone\' || msl.serviceName === \'wirelessPrepaid\' || msl.serviceName === \'suspended\' ? \' \' + (msl.serviceDetail | ute_common_filter_phone2) : \'\'}}</span></a> <a ng-if=\"msl.subscriptionBadgeModule && !msl.disabled\" ng-click=\"resolveService(msl)\"><span class=\"service-account-type\" translate=\"{{\'ute.common.oneview.header.subMenu.\' + msl.serviceType}}\"></span></a></li><li ng-show=\"isWireless\"><a role=\"menuitem\" tabindex=\"-1\"><span translate=\"ute.common.oneview.header.subMenu.service_wireless\"></span></a></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\" class=\"divider\"></li><li role=\"presentation\" data-ng-hide=\"isDealer || isCare\"><a role=\"menuitem\" tabindex=\"-1\" ui-sref=\"linkaccount\"><span class=\"service-account-type\" translate=\"ute.common.oneview.header.subMenu.submenu_link_account\"></span></a></li><li ng-show=\"isWirelessAccount && repTransferOfResponsibilityStart\"><a ng-class=\"(!isAccountCancelledOrSuspended) ? \'pointer\' : \'disabled-link\'\" role=\"menuitem\" tabindex=\"-1\" ng-click=\"!isAccountCancelledOrSuspended ? goToTransferOfResponsibility() : \'\'\"><span class=\"service-account-type\" translate=\"ute.common.oneview.header.subMenu.transfer_of_responsibility\"></span></a></li><li ng-if=\"repBundleBuilderAccess\"><a class=\"pointer\" ng-click=\"redirectToOASYS()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oasys-bundle\"}\'>{{ \'ute.common.oneview.header.subMenu.oneview_bundlebuilder\' | translate }}&nbsp;&nbsp;<i class=\"fa fa-external-link\"></i></a></li></ul></li><li class=\"\"><a ng-click=\"repProfileRead && isSubMenuEnabled(\'profile\') && runRogersProfile($event);\" role=\"button\" class=\"pointer\" data-ng-class=\"(!repProfileRead ? \'noAgentPermission\' : \'\')+\' \'+(isSubMenuEnabled(\'profile\') ? \'\' : \'not - active\')+\' \'+(selSubMenuItem === subMenuItems.profile ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_profile\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li><a ng-click=\"repInteractionRead && redirectToInteraction()\" ng-class=\"(!repInteractionRead ? \'noAgentPermission\' : \'\')+\' \'+(selSubMenuItem === subMenuItems.interaction ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"ute.common.oneview.header.subMenu.interaction\"></span> <span class=\"interaction-count\">({{interactionLength}})</span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li ng-if=\"(isCare && repActionOffersUpdate)\" class=\"\"><a ng-click=\"redirectToActionsOffers()\" role=\"button\" ng-class=\"(selSubMenuItem === subMenuItems.actionsOffers ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"ute.common.oneview.header.subMenu.actions_and_offers\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li ng-if=\"(isCare)\" class=\"\"><a ng-click=\"redirectToOrders()\" role=\"button\" ng-class=\"(selSubMenuItem === subMenuItems.orders ? \'oneViewSelectedTab\' : \'\')\"><div><span translate=\"ute.common.oneview.header.subMenu.orders\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"orders-click\"}\'></span></div></a></li><li class=\"visible-xs\" id=\"languageToggle\"><div id=\"nav-context-bar\" class=\"\"><a ng-click=\"changeLanguage()\"><span translate=\"ute.common.oneview.header.global.language_toggle\"></span></a></div></li></ul></nav><div id=\"nav-actions\" class=\"visible-xs\"><div id=\"search\"><a title=\"Search\" href=\"http://nova.rogers.com\" data-toggle=\"modal\" target=\"_blank\"><i class=\"rui-icon-search\"></i></a></div></div></header></div></div></div>");
$templateCache.put("module/oneViewSubmenu/oneViewSubmenuForInterface.html","<div class=\"directive-repview-submenu\"><div class=\"menu-container\"><div class=\"container\"><header class=\"navbar navbar-header navbar-fixed-top status-post\" role=\"banner\" id=\"header\"><div class=\"navbar-header visible-xs\"><button title=\"Menu\" class=\"navbar-toggle collapsed\" type=\"button\" data-toggle=\"collapse\" data-target=\"#rep-view-menu\" aria-expanded=\"false\"><span class=\"sr-only\">Toggle navigation</span> <i class=\"rui-icon-menu\"></i></button> <a title=\"Rogers\" class=\"navbar-brand\" href=\"/\">Rogers</a></div><div class=\"shadow\" ng-click=\"menuClick()\"></div><nav id=\"rep-view-menu\" class=\"navbar-collapse bs-navbar-collapse collapse\" aria-expanded=\"false\" style=\"height: 4px;\"><ul class=\"nav navbar-nav\"><li id=\"username\"><span class=\"signedin\"><i class=\"rui-icon-lock-small\"></i> <span>Welcome</span> <span id=\"user-name\"></span></span> <a href=\"#\" id=\"logoutAction\">Sign out <i class=\"rui-icon-arrow-right\"></i></a></li><li class=\"\"><a class=\"no-pointer\" role=\"button\" href=\"{{BASEURL}}/web/totes/#/oneViewDashboard\"><div><span translate=\"ute.common.oneview.header.subMenu.acc_overview_my_account_overview\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li class=\"\"><a class=\"no-pointer\" role=\"button\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_billing_and_payment\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li class=\"\"><a class=\"no-pointer services-menu\" id=\"drop1\" aria-haspopup=\"true\" role=\"button\" aria-expanded=\"false\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_services\"></span> <span class=\"ute-icon-chevron-down\"></span></div></a></li><li class=\"\"><a role=\"button\" class=\"no-pointer\"><div><span translate=\"ute.common.oneview.header.subMenu.submenu_profile\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li><a class=\"no-pointer\"><div><span translate=\"ute.common.oneview.header.subMenu.interaction\"></span> <span class=\"interaction-count\">({{interactionLength}})</span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li><a class=\"no-pointer\"><div><span translate=\"ute.common.oneview.header.subMenu.actions_and_offers\"></span> <span class=\"ute-icon-chevron-down hidden-xs\"></span></div></a></li><li class=\"visible-xs\" id=\"languageToggle\"><div id=\"nav-context-bar\" class=\"\"><a ng-click=\"changeLanguage()\"><span translate=\"ute.common.oneview.header.global.language_toggle\"></span></a></div></li></ul></nav><div id=\"nav-actions\" class=\"visible-xs\"><div id=\"search\"><a title=\"Search\" href=\"http://nova.rogers.com\" data-toggle=\"modal\" target=\"_blank\"><i class=\"rui-icon-search\"></i></a></div></div></header></div></div></div>");
$templateCache.put("module/sspDashBoard/sspDashBoard.html","<div ng-show=\"userTypeDealer\"><div ng-show=\"false\"><form name=\"formToSSP\" id=\"formToSSP\" method=\"post\" novalidate=\"\"><input type=\"hidden\" name=\"data\" id=\"sharedKey\"><br><input type=\"hidden\" name=\"sig\" id=\"signature\"><br><input type=\"hidden\" name=\"content\" id=\"content\"><br></form></div></div>");
$templateCache.put("module/views/genericErrorPopup.html","<div class=\"errorWrapper col-xs-11\"><div class=\"col-xs-1\"><img src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/warning.png\"></div><div class=\"col-xs-11\" style=\"padding-left:10px;\"><div class=\"errorLogo\" ng-if=\"errorTitle\"><span data-ng-bund-html=\"errorTitle\"></span></div><div class=\"errorContent\"><span data-ng-bind-html=\"errorMessage\"></span></div><div class=\"contactInfo\" ng-if=\"showChatCallIcon\" ute-user-hide-if-any-granted=\"care,careRep,dealer\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 phone_icon_parent\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 phone_icon\"><img class=\"phone_icon_img\" src=\"images/wirelessDash-popup_phone_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 phone_number_value\"><span translate=\"toll-free-number\" ng-if=\"!nacSaveStateRequest\"></span> <span translate=\"see_nac_toll-free-number\" ng-if=\"nacSaveStateRequest\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 phone_icon_parent\" ng-if=\"!nacSaveStateRequest\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 live_chat_icon\"><img class=\"live_chat_icon_img\" src=\"images/wirelessDash-popup_live_chat_icon.png\"><span>&nbsp;</span></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 live_chat_text\"><div class=\"live-chat-link\" ng-show=\"lng === \'en\'\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&amp;lctc=707%7C01%7Cws%7CHUP_landing%20en\" translate=\"mu_chat\" target=\"_blank\"></a></div><div class=\"live-chat-link\" ng-show=\"lng === \'fr\'\" target=\"_blank\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr\" translate=\"mu_chat\" target=\"_blank\"></a></div></div></div></div></div><div class=\"buttonWrapper col-xs-12\" ng-if=\"showButtons\"><button type=\"button\" class=\"btn btn-md btn-red\" ng-click=\"closeGenericErrorPopup()\" style=\"background-color:#da291c;color:#FFF;\"><span translate=\"_continue\"></span></button></div></div>");
$templateCache.put("module/oneviewInteractionNotesDirective/oneviewInteractionNotes.directive.view.html","<div><div class=\"ute-note-icon\"><a data-ng-click=\"oneviewInteractionNotes.openNotepad()\" data-ng-class=\"oneviewInteractionNotes.displayNotePad ? \'ute-add-note-icon-link\' : \'ute-add-note-icon-link-hidden\'\"><img alt=\"notes_icon_img\" class=\"notes_icon_img\" src=\"ute-common-assets/assets/notes_icon_red.png\"></a></div><div class=\"ute-notepad-container\" data-ng-class=\"oneviewInteractionNotes.displayNotePad ? \'ute-show-notepad\' : \'ute-hide-notepad\'\"><ul class=\"ute-notepad-section\"><li style=\"\" class=\"ute-notepad-heading\"><span translate=\"ute.oneview.interactionNotes.directive.notepad.interactionNote\"></span></li><li ng-show=\"oneviewInteractionNotes.isAPIError\" class=\"col-lg-12 ute-notepad-error-message-container\"><span class=\"col-lg-1\"><img height=\"25\" src=\"ute-common-assets/assets/warning.png\"></span> <span class=\"col-lg-10\" translate=\"ute.oneview.interactionNotes.directive.notepad.{{oneviewInteractionNotes.errorMessageKey}}\"></span></li><li style=\"\" class=\"ute-notepad-text-holder\"><textarea data-ng-click=\"oneviewInteractionNotes.editNotes()\" class=\"ute-notepad-text-area\" cols=\"35\" rows=\"35\" data-ng-model=\"oneviewInteractionNotes.model.interactionNotepadContent\" maxlength=\"4000\">\n        </textarea><div class=\"ute-notepad-text-area-overlay\" ng-show=\"oneviewInteractionNotes.disableTextArea\" data-ng-click=\"oneviewInteractionNotes.editNotes()\"></div></li><li style=\"margin-bottom:10px\"><span class=\"ute-notepad-loader-inline\" ng-show=\"oneviewInteractionNotes.callInProgress\"><img class=\"ute-notepad-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <button id=\"saveNote\" class=\"pull-right ute-notepad-button\" data-ng-click=\"oneviewInteractionNotes.saveNotes()\" ng-show=\"oneviewInteractionNotes.displaySaveNoteButton\"><span translate=\"ute.oneview.interactionNotes.directive.notepad.saveNote\"></span></button> <button id=\"editNote\" class=\"pull-right ute-notepad-button\" data-ng-click=\"oneviewInteractionNotes.editNotes()\" ng-show=\"!oneviewInteractionNotes.displaySaveNoteButton\"><span translate=\"ute.oneview.interactionNotes.directive.notepad.editNote\"></span></button></li></ul></div></div>");
$templateCache.put("module/oneviewRepFeedbackDirective/oneviewRepFeedback.html","<form name=\"feedback-agent-info-hidden-form\"><input id=\"feedback_agent_first_name\" type=\"hidden\" value=\"{{feedback.agentDetails.agentFirstName}}\"> <input id=\"feedback_agent_last_name\" type=\"hidden\" value=\"{{feedback.agentDetails.agentLastName}}\"> <input id=\"feedback_agent_email\" type=\"hidden\" value=\"{{feedback.agentDetails.agentRciEmailId}}\"> <input id=\"feedback_agent_id\" type=\"hidden\" value=\"{{feedback.agentDetails.agentId}}\"> <input id=\"feedback_agent_role\" type=\"hidden\" value=\"{{feedback.agentDetails.agentRole}}\"> <input id=\"feedback_agent_timestamp\" type=\"hidden\" value=\"{{feedback.agentDetails.timeStamp}}\"> <input id=\"feedback_agent_sessionId\" type=\"hidden\" value=\"{{feedback.agentDetails.sessionId}}\"> <input id=\"feedback_customer_account_number\" type=\"hidden\" value=\"{{feedback.agentDetails.customerAcctNo}}\"> <input id=\"feedback_language\" type=\"hidden\" value=\"{{feedback.lang}}\"></form><div id=\"ZN_cI39qiLcUmKR0dn\"></div>");
$templateCache.put("module/myrPaymentHelper/paymentHelper.view.html","<div class=\"ute-paymentHelper\"><div class=\"container\"><div class=\"ute-paymentHelper-heading-group\"><div class=\"ute-paymentHelper-heading\"><span translate=\"ute.rogers.myrPaymentHelper.need_help_with_your_bill\"></span></div></div><a class=\"ute-paymentHelper-button\" href=\"https://www.rogers.com/web/content/support?N=42+134\" target=\"_blank\"><span translate=\"ute.rogers.myrPaymentHelper.visit_billing_support\"></span> <span class=\"ute-paymentHelper-icon-arrow-right\"></span></a> <a class=\"ute-paymentHelper-link\" ng-href=\"{{\'ute.rogers.myrPaymentHelper.reviewLink\' | translate}}\" target=\"_blank\"><span translate=\"ute.rogers.myrPaymentHelper.paynow_faq\"></span> <span class=\"ute-paymentHelper-icon-arrow-right\"></span></a><div class=\"ute-paymentHelper-chat\"><bold-chat-static-button data-cbid=\"{{\'ute.rogers.myrPaymentHelper.boldChatButtonId\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.myrPaymentHelper.boldChatButtonDiv\' | translate}}\" data-chat-button=\"{{\'ute.rogers.myrPaymentHelper.boldChatButton\' | translate}}\"></bold-chat-static-button></div></div></div>");
$templateCache.put("module/ignore/paymentMethod.modal.html","<div class=\"mop-container change-update-payment-group\"><section class=\"mop\" ng-if=\"ctrl.step === ctrl.STEP.CHANGE_MOP\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_title\" class=\"mop-title\"></h2></header><div class=\"change-mop-overlay-summary\" ng-if=\"!ctrl.showDebitForm\"><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_from\"></span><br class=\"visible-xs\"><span>{{ctrl.overlayModel.oldPaymentMethod.translationId | translate}}</span></div><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_to\"></span><br class=\"visible-xs\">{{ctrl.overlayModel.newPaymentMethod.translationId | translate}}</div></div><div></div><credit-card-ui ng-if=\"ctrl.isCredit\"></credit-card-ui><debit-card-ui ng-if=\"ctrl.showDebitForm\"></debit-card-ui><section ng-if=\"ctrl.isInvoice\" style=\"margin-top:20px;\"><div ng-if=\"ctrl.overlayModel.billingDetail.balanceAmount > 0 && ctrl.billDueDate\" translate=\"ute.payment.method.mop_summary_explanation_with_balance\" data-translate-values=\"{date:(ctrl.billDueDate | date:\'MMMM dd, yyyy\')}\" style=\"margin-bottom: 30px;\"></div><div ng-if=\"ctrl.overlayModel.billingDetail.balanceAmount <= 0 || !ctrl.billDueDate\" translate=\"ute.payment.method.mop_summary_explanation_no_balance\" style=\"margin-bottom: 30px;\"></div><div class=\"flex\"><button translate=\"ute.payment.method.mop_update_payment_method_button\" ng-click=\"ctrl.submit()\" class=\"change-mop-update-action\"></button> <span class=\"widget-loader-inline\" ng-if=\"ctrl.isPaymentMethodChanging\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span> <button translate=\"ute.common.label.cancel\" ng-click=\"ctrl.close()\" class=\"change-mop-cancel-action\"></button></div></section></section><section ng-if=\"ctrl.step === ctrl.STEP.SUCCESS\" class=\"change-mop-done change-mop-success mop\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_success_title\"></h2></header><div translate=\"ute.payment.method.mop_success_message_{{ctrl.overlayModel.newPaymentMethod.type}}\"></div><div><button class=\"change-mop-close-action\" translate=\"ute.payment.method.mop_close\" ng-click=\"ctrl.close()\"></button></div></section><section ng-if=\"ctrl.step === ctrl.STEP.FAILURE\" class=\"change-mop-done change-mop-failure mop\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_failure_title\"></h2></header><div translate=\"ute.payment.method.mop_failure_message\"></div><div class=\"mop-need-help\"><bold-chat-static-button data-cbid=\"{{ctrl.livechat.cbid | translate}}\" data-dynamic-div=\"{{ctrl.livechat.dynamicDivId | translate}}\" data-chat-button=\"{{ctrl.livechat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><div><div></div><button class=\"change-mop-close-action\" translate=\"ute.payment.method.mop_close\" ng-click=\"ctrl.close()\"></button></div></section></div>");
$templateCache.put("module/pendingOrder/pendingOrder.view.html","<div ng-if=\"pendingOrder.carousel.length > 0\" class=\"ute-pending-order\"><carousel interval=\"myInterval\" disable-ng-animate=\"\"><slide ng-repeat=\"slide in pendingOrder.carousel\" active=\"slide.active\"><div class=\"ute-pending-order-heading\"><span translate=\"ute.pending.order.label.pending\"></span></div><div class=\"ute-pending-order-number\"><span translate=\"ute.pending.order.label.orderNumber\"></span><span ng-bind=\"slide.orderID\"></span></div><div class=\"ute-pending-order-link-group\"><a class=\"ute-pending-order-link pull-left\" ng-click=\"pendingOrder.termsConditionModal()\"><span translate=\"ute.pending.order.label.termsConditions\"></span> <span class=\"ute-icon-arrow-right\"></span></a> <a class=\"ute-pending-order-link pull-right\" ng-click=\"pendingOrder.orderDetailModal(slide.orderID)\" ute-tracking=\"internet:home:myaccount:orderdetails\"><span translate=\"ute.pending.order.cta.orderDetails\"></span> <span class=\"ute-icon-arrow-right\"></span></a></div></slide></carousel></div>");
$templateCache.put("module/profileCreateMyRogersProfileModal/profile.create.error.modal.html","<div class=\"ute-profileCreateError-modal\"><div class=\"ute-auto-reg-modals-heading border-bottom-color row\"><span class=\"col-xs-11 no-padding\"><span class=\"rui-icon-alert-i ute-profile-error-icon\"></span> <span data-translate=\"ute.noProfile.profileNotCreatedModal.modalTitle\" adl-error-track=\'{\"action\":\"click\",\"mappingKey\":\"create-my-rogers-profile\",\"type\":\"user\",\"field\":\" \"}\'></span></span> <span class=\"col-xs-1\" data-ng-click=\"$dismiss()\"><img src=\"ute-common-assets/assets/cross-grey.png\" class=\"autoreg-modals-close-icon\" alt=\"close-modal\"></span></div><div class=\"ute-auto-reg-modals-body row\"><div class=\"col-xs-12 ute-profile-create-content-container\"><div class=\"ute-create-profile-content-success\" data-translate=\"ute.noProfile.profileNotCreatedModal.modalMsg\"></div></div><div class=\"col-xs-12\"><button class=\"ute-create-profile-primary-button\" data-translate=\"ute.noProfile.profileNotCreatedModal.tryAgainButton\" ng-click=\"$close()\"></button></div></div></div>");
$templateCache.put("module/profileCreateMyRogersProfileModal/profile.create.link.modal.html","<div class=\"ute-profileCreateLink-modal\"><div class=\"ute-auto-reg-modals-heading border-bottom-color row\"><span class=\"col-xs-11 no-padding\"><span class=\"rui-icon-alert-i ute-profile-alert-icon\"></span> <span data-translate=\"ute.noProfile.profileAlreadyExistsModal.modalTitle\"></span></span> <span class=\"col-xs-1\" data-ng-click=\"$dismiss()\"><img src=\"ute-common-assets/assets/cross-grey.png\" class=\"autoreg-modals-close-icon\" alt=\"close-modal\"></span></div><div class=\"ute-auto-reg-modals-body row\"><div class=\"col-xs-12 ute-profile-create-content-container\"><span data-translate=\"ute.noProfile.profileAlreadyExistsModal.modalMsg\"></span></div><div class=\"col-xs-12\"><button class=\"ute-create-profile-primary-button\" data-translate=\"ute.noProfile.profileAlreadyExistsModal.doneButton\" ng-click=\"$close()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"create-my-rogers-profile,event.selfServeComplete\"}\'></button></div></div></div>");
$templateCache.put("module/profileCreateMyRogersProfileModal/profile.create.modal.html","<div class=\"ute-profileCreate-modal\"><div class=\"ute-auto-reg-modals-heading border-bottom-color row\"><span data-translate=\"ute.noProfile.createProfileModal.modalTitle\" class=\"col-xs-11 no-padding\"></span> <span class=\"col-xs-1\" data-ng-click=\"createMyRogersProfileModal.cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" class=\"autoreg-modals-close-icon\" alt=\"close-modal\"></span></div><div class=\"ute-auto-reg-modals-body row\"><div class=\"col-xs-12 ute-profile-create-existing-email-button\" ng-if=\"createMyRogersProfileModal.isEmailExists\"><button class=\"ute-profile-create-existing-email\" ng-click=\"createMyRogersProfileModal.closeModal(true)\"><span data-translate=\"ute.noProfile.createProfileModal.createUsingExistingMail\" translate-values=\"{existingMail : createMyRogersProfileModal.existingEmail.email }\"></span></button></div><div class=\"col-xs-12\" ng-if=\"createMyRogersProfileModal.isEmailExists\"><div class=\"col-xs-5 ute-profile-create-separator\"></div><span data-translate=\"ute.noProfile.createProfileModal.or\" class=\"col-xs-2 ute-profile-create-or-separator\"></span><div class=\"col-xs-5 ute-profile-create-separator\"></div></div><div class=\"col-xs-12 email-form\"><form name=\"emailForm\"><div class=\"col-xs-8 no-padding\"><div class=\"relative-position\"><label for=\"email-input\" ng-class=\"{\'color-on-error\': createMyRogersProfileModal.isInvalidFormat}\" class=\"email-input-label\">{{\'ute.noProfile.createProfileModal.enterMailIdPlaceholder\'| translate}}</label> <input class=\"email-input\" type=\"email\" id=\"email-input\" name=\"emailInput\" required=\"\" ng-focus=\"createMyRogersProfileModal.setLabelAnimation($event)\" ng-blur=\"createMyRogersProfileModal.checkEmailFormat(emailForm) && createMyRogersProfileModal.resetLabelAnimationAndProcessInput($event,emailForm)\" ng-model=\"createMyRogersProfileModal.enteredEmailId\" ng-class=\"{\'border-bottom-on-error\': createMyRogersProfileModal.isInvalidFormat}\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\"> <span class=\"rui-icon-alert-i ute-profile-error-icon position-error-icon-on-focus\" ng-if=\"createMyRogersProfileModal.isInvalidFormat\"></span></div><ul class=\"info-error-msg\" ng-class=\"{\'color-on-error\': createMyRogersProfileModal.isInvalidFormat}\"><li translate=\"ute.noProfile.createProfileModal.infoMsg\"></li></ul></div><div class=\"col-xs-12 no-padding test12\"><div class=\"col-xs-8 no-padding\"><div class=\"relative-position\"><label for=\"confirm-email-input\" class=\"confirm-email-input-label\" ng-class=\"{\'color-on-error\': createMyRogersProfileModal.showErrorMessage}\">{{\'ute.noProfile.createProfileModal.confirmMailIdPlaceholder\'| translate}}</label> <input class=\"confirm-email-input\" id=\"confirm-email-input\" type=\"email\" name=\"confirmEmailInput\" ng-focus=\"createMyRogersProfileModal.setLabelAnimation($event)\" ng-blur=\"createMyRogersProfileModal.resetLabelAnimationAndProcessInput($event, emailForm)\" required=\"\" ng-model=\"createMyRogersProfileModal.enteredConfirmEmailId\" ng-pattern=\"/^([\\w-]+(?:\\.[\\w-]+)*)@((?:[\\w-]+\\.)*\\w[\\w-]{0,66})\\.([a-z]{2,6}(?:\\.[a-z]{2})?)$/\" ng-class=\"{\'border-bottom-on-error\': createMyRogersProfileModal.showErrorMessage}\"> <span class=\"rui-icon-alert-i ute-profile-error-icon position-error-icon-on-focus\" ng-if=\"createMyRogersProfileModal.showErrorMessage\"></span></div><div class=\"info-error-msg error-msg\" data-translate=\"ute.noProfile.createProfileModal.emailsMismatchMsg\" ng-if=\"createMyRogersProfileModal.showErrorMessage\"></div></div><div class=\"col-xs-4\"><button class=\"ute-create-profile-button\" translate=\"ute.noProfile.createProfileModal.createButton\" ng-click=\"createMyRogersProfileModal.checkForFormValidity(emailForm) && createMyRogersProfileModal.closeModal(false)\"></button></div></div></form></div></div></div>");
$templateCache.put("module/profileCreateMyRogersProfileModal/profile.create.success.modal.html","<div class=\"ute-profileCreateSuccess-modal\"><div class=\"ute-auto-reg-modals-heading border-bottom-color row\"><span class=\"col-xs-11 no-padding\"><span class=\"rui-icon-circle-solid-check ute-profile-success-icon\"></span> <span data-translate=\"ute.noProfile.profileCreatedModal.modalTitle\"></span></span> <span class=\"col-xs-1\" data-ng-click=\"$dismiss()\"><img src=\"ute-common-assets/assets/cross-grey.png\" class=\"autoreg-modals-close-icon\" alt=\"close-modal\"></span></div><div class=\"ute-auto-reg-modals-body row\"><div class=\"col-xs-12 ute-profile-create-content-container\"><div class=\"ute-create-profile-content-success\"><span data-translate=\"ute.noProfile.profileCreatedModal.modalMsgPartOne\"></span> <span class=\"bold-content\" data-translate=\"ute.noProfile.profileCreatedModal.modalMsgPartTwo\" translate-values=\"{enteredMailId: existingEmail}\"></span> <span data-translate=\"ute.noProfile.profileCreatedModal.modalMsgPartThree\"></span></div><div data-translate=\"ute.noProfile.profileCreatedModal.modalMsgPartFour\"></div></div><div class=\"col-xs-12\"><button class=\"ute-create-profile-primary-button\" data-translate=\"ute.noProfile.profileCreatedModal.doneButton\" ng-click=\"$close()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"create-my-rogers-profile,event.selfServeComplete\"}\'></button></div></div></div>");
$templateCache.put("module/profileEditDirective/profile.edit.directive.form.view.pass.html","<div class=\"row\"><div class=\"heading-container\" aria-hidden=\"false\"><h1 aria-hidden=\"false\" data-translate=\"ute.common.label.password.edit\"></h1><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\" data-ng-hide=\"true\"></div><div class=\"row error-box\" data-ng-hide=\"true\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 error-left\"><span class=\"message-banner-icon error-icon\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 error-txt general-error\"><span data-translate=\"ute.profile.edit.directive.general.error\"></span></div></div><div class=\"\"><form name=\"form\" form-locator=\"\" novalidate=\"\" method=\"post\" ng-submit=\"form.$valid && form.submit()\" class=\"\"><div class=\"row error-box\" data-ng-hide=\"true\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 error-left\"><span class=\"message-banner-icon error-icon\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 error-txt general-error\"><span data-translate=\"ute.profile.edit.directive.check.form.errors\"></span></div></div><div class=\"row hidden\"><input id=\"username1\" name=\"username1\" type=\"text\" style=\"position: absolute; left: -9999px;\" value=\"{{ profileEditUserNPass.userInfo.userName }}\" autocomplete=\"{{ profileEditUserNPass.isIE ? \'off\' : \'on\' }}\" tabindex=\"-1\"></div><div class=\"row\"><div class=\"col-md-6\"><span class=\"input-label\" data-translate=\"ute.common.label.password.old\"></span><div class=\"inline_error\" ng-if=\"form.$submitted && form.oldpasswordwrong && !form.oldPassword.$touched\"><span data-translate=\"ute.common.label.password.incorrect\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f1\",\"callBackParam\":\"change-password\"}\'></span></div><div class=\"inline_error\" ng-if=\"form.oldPassword.$error.required\"><span data-translate=\"ute.common.label.password.reenter\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f1\",\"callBackParam\":\"change-password\"}\'></span></div><input id=\"oldPassword\" name=\"oldPassword\" type=\"{{ profileEditUserNPass.isIE ? \'text\' : \'password\' }}\" autocomplete=\"{{ profileEditUserNPass.isIE ? \'off\' : \'on\' }}\" data-ng-class=\"{ \'conceal\' : profileEditUserNPass.isIE }\" data-ng-model=\"profileEditUserNPass.serviceModel().form.changePassword.oldPassword\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-required=\"form.newPassword.$touched && form.newPassword.length > 0\" data-ng-change=\"form.$setValidity(\'oldPassword\', true, form)\" tabindex=\"10\" aria-required=\"false\" aria-invalid=\"false\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"change-password,event.selfServeStart\"}\'></div></div><div class=\"row\"><div class=\"col-md-6\"><span class=\"input-label\" data-translate=\"ute.common.label.password.new\"></span><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"inline_error\" ng-if=\"form.newPassword.$invalid && form.newPassword.$dirty && form.confirmPassword !== \'\'\"><span ng-if=\"form.newPassword.$error.required\" data-translate=\"ute.common.label.password.invalid\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"callBackParam\":\"change-password\"}\'></span> <span ng-if=\"form.newPassword.$error.pattern\" data-translate=\"ute.profile.password.guideline.passwordInlineError\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"callBackParam\":\"change-password\"}\'></span> <span ng-if=\"form.newPassword.$error.match && form.oldPassword.$dirty\" data-translate=\"registration_password_must_differ\"></span></div></div></div></div></div><label class=\"input-field\"><input id=\"newPassword\" name=\"newPassword\" type=\"password\" autocomplete=\"off\" minlength=\"8\" maxlength=\"20\" data-ng-model=\"profileEditUserNPass.serviceModel().form.changePassword.newPassword\" data-ng-required=\"form.newPassword.$touched && form.newPassword.$isEmpty()\" data-ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#\\$]+)$/\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-change=\"editableData.checkPassword(form.newPassword)\" autocapitalize=\"off\" autocorrect=\"off\" data-ute-match=\"form.oldPassword\" un-match=\"true\" tabindex=\"11\" aria-required=\"false\" aria-invalid=\"false\" ng-focus=\"profileEditUserNPass.showPasswordTips=true\" ng-blur=\"profileEditUserNPass.showPasswordTips=false\"> <span class=\"inline-checker error-icon\" data-ng-show=\"form.newPassword.$dirty && form.newPassword.$invalid\"></span> <i data-ng-show=\"form.newPassword.$dirty && form.newPassword.$valid\" class=\"inline-checker icon-checked\"></i></label><div class=\"change-password-tips\" ng-if=\"profileEditUserNPass.showPasswordTips\"><div class=\"change-password-tips-red\" ng-class=\"{\'change-password-tips-green\': profileEditUserNPass.isPwAtLeastOneLetterNOneNum(form.newPassword.$viewValue) && profileEditUserNPass.isPwdAtLeastEightCharacters(form.newPassword.$viewValue)}\"><span data-translate=\"ute.profile.password.guideline.passwordMustHave\"></span></div><div class=\"change-password-tips-red\" ng-class=\"{\'change-password-tips-green\': profileEditUserNPass.isPwAtLeastOneLetterNOneNum(form.newPassword.$viewValue)}\"><i ng-class=\"profileEditUserNPass.isPwAtLeastOneLetterNOneNum(form.newPassword.$viewValue) ? \'rogers-icon-circle-solid-check\' : \'rogers-icon-circle-solid-minus\'\"></i> <span data-translate=\"ute.profile.password.guideline.passwordAtLeast\"></span></div><div class=\"change-password-tips-red\" ng-class=\"{\'change-password-tips-green\': profileEditUserNPass.isPwdAtLeastEightCharacters(form.newPassword.$viewValue)}\"><i ng-class=\"profileEditUserNPass.isPwdAtLeastEightCharacters(form.newPassword.$viewValue) ? \'rogers-icon-circle-solid-check\' : \'rogers-icon-circle-solid-minus\'\"></i> <span data-translate=\"ute.profile.password.guideline.passwordMinimum\"></span></div><div class=\"change-password-tips-color\"><span data-translate=\"ute.profile.password.guideline.passwordCanInclude\"></span></div></div><div class=\"col-md-12 col-lg-12\"><span class=\"input-label\" data-translate=\"ute.common.label.password.confirm.new\"></span><div class=\"inline_error\" ng-if=\"form.$submitted || form.confirmPassword.$touched\"><span ng-if=\"form.confirmPassword.$error.required\" data-translate=\"ute.common.label.password.reenter\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f3\",\"callBackParam\":\"change-password\"}\'></span> <span ng-if=\"form.confirmPassword.$error.match && !form.confirmPassword.$error.required\" data-translate=\"ute.common.label.password.notmatch\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f3\",\"callBackParam\":\"change-password\"}\'></span></div><label class=\"input-field\"><input id=\"confirmPassword\" name=\"confirmPassword\" type=\"{{ profileEditUserNPass.isIE ? \'text\' : \'password\' }}\" autocomplete=\"{{ profileEditUserNPass.isIE ? \'off\' : \'new-password\' }}\" minlength=\"8\" maxlength=\"20\" data-ng-class=\"{ \'conceal\' : profileEditUserNPass.isIE }\" data-ute-match=\"form.newPassword\" data-ng-model=\"profileEditUserNPass.serviceModel().form.changePassword.confirmPassword\" data-ng-model-options=\"{ debounce: { \'default\': 500, \'blur\': 0 } }\" data-ng-required=\"form.newPassword.$touched && form.confirmPassword.$isEmpty()\" data-ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9!@#\\$]+)$/\" tabindex=\"12\" aria-required=\"false\" aria-invalid=\"false\" ng-focus=\"profileEditUserNPass.showConfirmPasswordTips=true\" ng-blur=\"profileEditUserNPass.showConfirmPasswordTips=false\"> <span class=\"inline-checker error-icon\" data-ng-show=\"form.confirmPassword.$invalid && (form.confirmPassword.$dirty || form.$submitted)\"></span> <i ng-show=\"form.confirmPassword.$dirty && form.confirmPassword.$valid\" class=\"inline-checker icon-checked\"></i></label><div ng-if=\"profileEditUserNPass.showConfirmPasswordTips\" class=\"change-password-tips\"><div class=\"change-password-tips-red\" ng-class=\"{\'change-password-tips-green\': !form.confirmPassword.$error.match}\"><i ng-class=\"form.confirmPassword.$error.match? \'rogers-icon-circle-solid-minus\': \'rogers-icon-circle-solid-check\'\"></i> <span data-translate=\"ute.profile.password.guideline.bothPasswordMatch\"></span></div></div></div></div><div class=\"col-md-6 col-lg-6 guideline-container\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 guideline-box\"><span data-translate=\"ute.common.label.password.guildeline\"></span> <span class=\"guideline-list\" data-translate=\"ute.profile.password.guideline.list\"></span></div></div></div><div class=\"col-md-6 button-container\"><input class=\"save-button\" type=\"submit\" value=\"{{\'ute.common.label.save.changes\' | translate }}\" data-ng-class=\"{ inactive : form.$pristine || profileEditUserNPass.UIModel().isUpdatePasswordCallInProgress }\" data-ng-disabled=\"!(form.$valid && form.$dirty) || profileEditUserNPass.UIModel().isUpdatePasswordCallInProgress\" data-ng-click=\"profileEditUserNPass.changePasswordOnClick(form)\"> <input class=\"cancel-button\" data-ng-click=\"profileEditUserNPass.cancelEditOnClick()\" data-translate=\"ute.common.label.cancel\" tabindex=\"0\"></div></form></div></div>");
$templateCache.put("module/profileEditDirective/profile.edit.directive.form.view.user.html","<div class=\"row\"><div class=\"heading-container\"><form name=\"formChangeUsername\" ng-submit=\"formChangeUsername.$valid\" class=\"\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 row error-box\" data-ng-hide=\"true\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 error-left\"><span class=\"message-banner-icon error-icon\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 error-txt general-error\"><span data-translate=\"ute.profile.edit.directive.check_forcheck.form.errorsm_errors\"></span></div></div><div class=\"row\"><div class=\"col-md-6\"><h1 aria-hidden=\"false\" data-translate=\"ute.common.label.username.edit\"></h1><br><span class=\"input-label\" data-translate=\"ute.common.label.username\"></span>: <label class=\"input-field\"><input id=\"username\" name=\"username\" type=\"email\" required=\"\" data-ng-model=\"profileEditUserNPass.serviceModel().form.changeUsername.username\" data-ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" maxlength=\"105\" placeholder=\"Username\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"change-username,event.selfServeStart\"}\'> <span class=\"inline-checker\"></span> <i class=\"inline-checker checker-icon\" data-ng-show=\"(formChangeUsername.$valid && formChangeUsername.$dirty)\"></i></label></div><div class=\"col-md-6 col-lg-6 guideline-container\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 guideline-box\"><span data-translate=\"ute.common.label.username.guildeline\"></span> <span class=\"guideline-list\" data-translate=\"ute.common.label.username.guildeline.list\"></span></div></div></div><div class=\"col-md-6 button-container\"><button class=\"save-button\" data-ng-class=\"{ inactive :!(formChangeUsername.$valid && formChangeUsername.$dirty) || profileEditUserNPass.UIModel().isUpdateUsernameCallInProgress }\" data-ng-disabled=\"!(formChangeUsername.$valid && formChangeUsername.$dirty) || profileEditUserNPass.UIModel().isUpdateUsernameCallInProgress\" data-ng-click=\"profileEditUserNPass.changeUsernameOnClick()\" data-translate=\"ute.common.label.username.change\" tabindex=\"0\"></button> <button class=\"cancel-button\" data-ng-click=\"profileEditUserNPass.cancelEditOnClick()\" data-translate=\"ute.common.label.cancel\" tabindex=\"0\"></button></div></form></div></div>");
$templateCache.put("module/profileEditDirective/profile.edit.directive.view.html","<div data-ng-show=\"profileEditUserNPass.isCare && !profileEditUserNPass.myRogersProfileExists()\"><h1 data-translate=\"ute.smsRecoveryRogers.profile.usernameAndPassword\"></h1><div class=\"ute-profileEdit-no-profile\"><div class=\"ute-profileEdit-info-icon\"></div><div class=\"ute-profileEdit-noProfile-msg\"><div class=\"ute-profileEdit-noProfile-title\" data-translate=\"ute.noProfile.title\"></div><div ng-if=\"!profileEditUserNPass.hasAutoRegAccess\" class=\"ute-profileEdit-noProfile-body\" data-translate=\"ute.noProfile.customerActionMessage\"></div><div ng-if=\"profileEditUserNPass.hasAutoRegAccess\" class=\"ute-profileEdit-noProfile-body\" data-translate=\"ute.noProfile.repActionMessage\"></div><div ng-if=\"profileEditUserNPass.hasAutoRegAccess\"><a class=\"ute-create-new-profile-link\" data-ng-click=\"profileEditUserNPass.createMyRogersProfile()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"create-my-rogers-profile,event.selfServeStart\"}\'><span translate=\"ute.noProfile.link\" tabindex=\"0\"></span> <span class=\"right-arrow\"><i class=\"rui-icon-tick\"></i></span></a></div></div></div></div><div class=\"ute-profileEdit row\" ng-class=\"{\'no-height-no-margin\' : profileEditUserNPass.isCare && !profileEditUserNPass.myRogersProfileExists()}\"><div data-ng-show=\"profileEditUserNPass.myRogersProfileExists() && !profileEditUserNPass.UIModel().isEditMode\"><div class=\"ute-profileEdit-header\"><div class=\"ute-profileEdit-message\" data-ng-show=\"profileEditUserNPass.UIModel().showOneviewResetPasswordSuccess || profileEditUserNPass.UIModel().showOneviewResetPasswordFailure\"><div class=\"ute-profileEdit-message-success row\" data-ng-show=\"profileEditUserNPass.UIModel().showOneviewResetPasswordSuccess\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 ute-profileEdit-message-icon\"><img class=\"\" src=\"ute-common-assets/assets/green-checkbox.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 ute-profileEdit-message-text\"><span data-translate=\"ute.profile.edit.resetPassword.response.sucess\"></span> {{profileEditUserNPass.userInfo.userName}}</div></div><div class=\"ute-profileEdit-message-error row\" data-ng-show=\"profileEditUserNPass.UIModel().showOneviewResetPasswordFailure\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 ute-profileEdit-message-icon\"><img class=\"\" src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 ute-profileEdit-message-text\"><span class=\"\" data-translate=\"ute.profile.edit.resetPassword.response.error\"></span></div></div></div><h1 data-translate=\"ute.smsRecoveryRogers.profile.usernameAndPassword\"></h1><span class=\"ute-profile-edit-uap-button-edit ute-profileEdit-disable disabled-field no-margin-left hidden-xs\" data-ng-if=\"!profileEditUserNPass.isEditable\" data-ng-click=\"profileEditUserNPass.editOnClick()\"><i class=\"rui-icon-edit disabled-field\"></i> <span data-translate=\"ute.common.label.edit\"></span></span> <span data-ng-if=\"!profileEditUserNPass.isEditable\" class=\"self-serve-direction\"><span class=\"inline-arrow\"></span> <span class=\"self-serve-label\" data-translate=\"ute.profile.edit.selfServeDirection\"></span></span></div><div class=\"row error-box\" data-ng-hide=\"true\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 error-left\"><span class=\"message-banner-icon error-icon\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 error-txt general-error\"><span data-translate=\"ute.profile.edit.directive.general.error\"></span></div></div><div class=\"display-form\"><div class=\"display-row\"><span class=\"display-label\"><span data-translate=\"ute.common.label.username\"></span></span> <span class=\"ute-profile-edit-uap-button-edit visible-xs-inline-block\" data-ng-click=\"profileEditUserNPass.editOnClick()\" data-ng-class=\"{ \'ute-profileEdit-disable\': !profileEditUserNPass.isEditable }\"><i class=\"rui-icon-edit\"></i> <span data-translate=\"ute.common.label.edit\"></span></span> <span class=\"display-value\">{{profileEditUserNPass.userInfo.userName}}</span> <span class=\"ute-profile-edit-uap-button-edit hidden-xs\" data-ng-click=\"profileEditUserNPass.editOnClick()\" data-ng-if=\"profileEditUserNPass.isEditable\"><i class=\"rui-icon-edit\"></i> <span data-translate=\"ute.common.label.edit\"></span></span></div><div class=\"display-row\"><span class=\"display-label\"><span data-translate=\"ute.common.label.password\"></span></span> <span class=\"ute-profile-edit-uap-button-edit visible-xs-inline-block\" data-ng-click=\"profileEditUserNPass.editOnClick()\" data-ng-class=\"{ \'ute-profileEdit-disable\': !profileEditUserNPass.isEditable }\"><i class=\"rui-icon-edit\"></i> <span data-translate=\"ute.common.label.edit\"></span></span> <input class=\"display-value display-input-value\" type=\"password\" ng-value=\"123456\" readonly=\"\" value=\"123456\"> <span class=\"ute-profile-edit-uap-button-edit hidden-xs\" data-ng-if=\"profileEditUserNPass.isEditable\" data-ng-click=\"profileEditUserNPass.editOnClick()\"><i class=\"rui-icon-edit\"></i> <span data-translate=\"ute.common.label.edit\"></span></span> <span class=\"reset-password-label\" data-ng-click=\"profileEditUserNPass.resetPassword()\" data-ng-if=\"profileEditUserNPass.isResetFlow\"><i class=\"rui-icon-edit\"></i><span data-translate=\"ute.common.label.password.reset\" role=\"button\" tabindex=\"0\"></span></span></div><div class=\"display-row\" data-ng-if=\"profileEditUserNPass.isCare\"><span class=\"display-label\"><span data-translate=\"ute.profile.wirelessRecoveryNumber\"></span></span> <span class=\"display-value\" data-ng-if=\"(profileEditUserNPass.wirelessRecoveryNumberValue().length > 0)\">{{profileEditUserNPass.wirelessRecoveryNumberValue() | ute_common_filter_phone}}</span> <span class=\"display-value empty-wireless-recovery-number\" data-ng-if=\"!(profileEditUserNPass.wirelessRecoveryNumberValue().length > 0)\">{{profileEditUserNPass.emptyWirelessRecoveryNumber}}</span></div></div></div><div data-ng-if=\"profileEditUserNPass.UIModel().isEditMode\" class=\"editable-content row rogers-content-margin\"><div class=\"heading-container\"><h1 data-ng-if=\"profileEditUserNPass.isEditUsername\" data-translate=\"ute.smsRecoveryRogers.profile.usernameAndPassword\"></h1><img class=\"widget-loader\" src=\"ute-common-assets/assets/widget-loader.gif\" data-ng-hide=\"true\"></div><div data-ng-if=\"profileEditUserNPass.isEditUsername\" data-ng-include=\"\'module/profileEditDirective/profile.edit.directive.form.view.user.html\'\"></div><div data-ng-include=\"\'module/profileEditDirective/profile.edit.directive.form.view.pass.html\'\"></div></div><div class=\"row\" data-ng-if=\"!profileEditUserNPass.isCare\"><div class=\"display-form\"><ute-sms-recovery-rogers></ute-sms-recovery-rogers></div></div></div>");
$templateCache.put("module/profileEditModal/profile.edit.modal.fail.view.html","<div class=\"ute-profileEdit-modal\"><div class=\"HeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img data-ng-src=\"{{profileEditModal.modalIcon | translate}}\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-profileEdit-vertical-align-middle\" data-translate=\"{{profileEditModal.errorMessage}}\" data-translate-values=\"{ email: profileEditModal.email }\"></div></div><div class=\"BodyGroup row\"><div class=\"live-chat-icon col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"pull-right\"><img src=\"images/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=24\" class=\"live-chat-label\" data-translate=\"ute.common.label.chat.live\"></a><img src=\"images/black-right-arrow.png\"></div></div></div></div><img class=\"ute-profileEdit-modalClose\" data-ng-click=\"profileEditModal.cancel()\" data-ng-src=\"{{\'ute.common.reactivate.ctn.images.close\' | translate}}\">");
$templateCache.put("module/profileEditUsername/profile.edit.username.success.view.html","<div class=\"ute-change-username-success\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.common.label.email.verification\"></span></li></ul></div><div class=\"email-verfication-body row\"><div class=\"col-xs-12 email-verfication-message\"><span data-translate=\"ute.profile.edit.directive.email.verification.msg\"></span></div></div></div></div>");
$templateCache.put("module/profileResetPasswordModal/profile.reset.password.modal.view.html","<div class=\"ute-profileResetPassword-modal\"><div class=\"HeadingGroup row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 ute-profileEdit-vertical-align-middle\" data-translate=\"ute.profile.edit.resetPassword.modalHeader\"></div></div><div class=\"BodyGroup row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 ute-profileEdit-vertical-align-middle\" data-translate=\"ute.profile.edit.resetPassword.modalContent\"></div></div><div class=\"ActionGroup row\"><div class=\"pull-right\"><a name=\"cancel\" ng-click=\"profileResetPasswordModal.cancel()\" class=\"pull-left ute-profileEdit-modal-cancel-button\"><span data-translate=\"ute.common.label.cancel\"></span></a> <button name=\"button_continue\" type=\"button\" class=\"ute-profileEdit-modal-continue-button\" ng-click=\"profileResetPasswordModal.continueProcess()\"><span class=\"no-text-transform\" data-translate=\"ute.common.label.continue\"></span></button></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayMain.view.html","<ui-view></ui-view>");
$templateCache.put("module/purchaseData/purchase-data.html","<md-button tabindex=\"0\" data-ng-click=\"ctrl.openPurchaseDataSelectorModal()\" data-ng-keypress=\"($event.which === 13) ? ctrl.openPurchaseDataSelectorModal() : 0;\" class=\"purchase-data-btn\" aria-label=\"{{ \'ute.purchaseData.addData\' | translate}}\"><md-icon ng-if=\"ctrl.selectedBrand === \'rogers\'\" class=\"ute-icon-plus ute-increasePlan-icon\"></md-icon><md-icon ng-if=\"ctrl.selectedBrand === \'fido\'\" class=\"icon-adddata\"></md-icon></md-button><div class=\"add-data-title\" translate=\"{{ctrl.getAddDataTranslationKey()}}\"></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnMain.view.html","<ui-view></ui-view>");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPassword.directive.view.html","<a data-ng-click=\"voicemailResetPassword.openModalPopup(\'md\', \'\')\" data-ng-keypress=\"($event.which === 13) ? voicemailResetPassword.openModalPopup(\'md\', \'\') : \'\'\" class=\"ute-resetVoicemailPassword-link\"><strong class=\"ute-resetVoicemailPassword-link_text\" translate=\"ute.voicemail.resetPassword.directive.updateVoicemailPassword.{{voicemailResetPassword.userType}}\" data-test-id=\"myr-wirelessPackage-wireless_manage-device_voicemail-password\"></strong></a>");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPassword.modal.view.html","<div class=\"ute-resetVoicemailPassword-modal\" data-ng-show=\"!resetPasswordModal.updateSuccessful\"><form name=\"resetVoicemailPasswordForm\" novalidate=\"\"><div class=\"ute-resetVoicemailPassword-headingGroup\"><div class=\"ute-resetVoicemailPassword-heading\"><span translate=\"ute.voicemail.resetPassword.modalPopup.title\"></span></div></div><div class=\"ute-resetVoicemailPassword-typeGroup\"><div class=\"ute-resetVoicemailPassword-typeBody\"><span translate=\"ute.voicemail.resetPassword.modalPopup.subTitle\"></span></div></div><div data-ng-if=\"resetPasswordModal.errorMessagePath().length > 0\" class=\"ute-resetVoicemailPassword-errorMessage\"><img class=\"ute-resetVoicemailPassword-messageIcon\" src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-resetVoicemailPassword-messageBody\"><span translate=\"{{resetPasswordModal.errorMessagePath()}}\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"new or confirm password\",\"callBackParam\":\"change-voicemail-password\"}\'></span></div></div><div data-ng-if=\"resetPasswordModal.showChatOption()\" class=\"ute-resetVoicemailPassword-boldChatLink\"><span translate=\"ute.voicemail.resetPassword.responseMessage.contactUs01\"></span><bold-chat-static-button data-cbid=\"{{\'ute.voicemail.resetPassword.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.voicemail.resetPassword.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.voicemail.resetPassword.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button><span translate=\"ute.voicemail.resetPassword.responseMessage.contactUs02\"></span></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"><div class=\"ute-resetVoicemailPassword-footnote\"><br class=\"hidden-xs\"><span translate=\"ute.voicemail.resetPassword.modalPopup.passwordInstruction\"></span></div></div><div class=\"col-xs-12 col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6 col-lg-6 col-lg-pull-6\"><div class=\"ute-resetVoicemailPassword-inputGroup\"><div class=\"ute-resetVoicemailPassword-inputTextLabel\"><span translate=\"ute.voicemail.resetPassword.modalPopup.newPassword\"></span></div><input data-ng-class=\"(resetVoicemailPasswordForm.newVoicemailPassword.$invalid && resetVoicemailPasswordForm.$submitted) ? \'ute-resetVoicemailPassword-inputTextError\' : \'ute-resetVoicemailPassword-inputText\'\" type=\"text\" name=\"newVoicemailPassword\" id=\"newVoicemailPassword\" data-ng-model=\"resetPasswordModal.model.newVoicemailPassword\" maxlength=\"5\" data-minlength=\"4\" required=\"\" data-ng-minlength=\"4\" data-ng-maxlength=\"5\" data-ng-required=\"true\" data-ng-pattern=\"/^[0-9]{1,5}$/\" data-ng-click=\"resetPasswordModal.inputOnClick($event)\" ute-numbers-only-input=\"\"></div><div class=\"ute-resetVoicemailPassword-inputGroup\"><div class=\"ute-resetVoicemailPassword-inputTextLabel\"><span translate=\"ute.voicemail.resetPassword.modalPopup.confirmPassword\"></span></div><input data-ng-class=\"(resetVoicemailPasswordForm.confirmVoicemailPassword.$invalid && resetVoicemailPasswordForm.$submitted) ? \'ute-resetVoicemailPassword-inputTextError\' : \'ute-resetVoicemailPassword-inputText\'\" type=\"text\" name=\"confirmVoicemailPassword\" id=\"confirmVoicemailPassword\" data-ng-model=\"resetPasswordModal.model.confirmVoicemailPassword\" maxlength=\"5\" data-minlength=\"4\" required=\"\" data-ng-minlength=\"4\" data-ng-maxlength=\"5\" data-ng-required=\"true\" data-ng-pattern=\"/^[0-9]{1,5}$/\" data-ng-click=\"resetPasswordModal.inputOnClick($event)\" ute-numbers-only-input=\"\"></div><div class=\"ute-resetVoicemailPassword-buttonGroupFlush\"><button name=\"button_continue\" class=\"ute-resetVoicemailPassword-submit\" data-ng-click=\"resetPasswordModal.submit(resetVoicemailPasswordForm)\" data-ng-disabled=\"resetPasswordModal.isCallInProgress()\"><span translate=\"ute.voicemail.resetPassword.modalPopup.submit\"></span></button> <span class=\"ute-resetVoicemailPassword-buttonLoader\" data-ng-show=\"resetPasswordModal.isCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"resetPasswordModal.updateSuccessful\"><div class=\"ute-resetVoicemailPassword-modalHeadingGroup\"><img class=\"ute-resetVoicemailPassword-modalHeadingIcon\" src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-resetVoicemailPassword-modalHeading\" translate=\"ute.voicemail.resetPassword.responseMessage.successTitle\"></div></div><div class=\"ute-resetVoicemailPassword-modalTypeGroup\"><div class=\"ute-resetVoicemailPassword-modalTypeBody\"><span translate=\"ute.voicemail.resetPassword.responseMessage.successMessage\"></span></div></div></div><img alt=\"{{ \'ute.voicemail.resetPassword.modalPopup.close\' | translate }}\" class=\"ute-resetVoicemailPassword-modalClose\" data-ng-click=\"resetPasswordModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/resetVoicemailPasswordDirective/resetVoicemailPasswordWindow.modal.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-resetVoicemailPassword-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/hero/heroModal.errorModal.html","<div class=\"row\"><div class=\"model-header\"><div class=\"row showErrorModal\"><div class=\"col-xs-1\"><div class=\"failureCircle\"><img class=\"fail_success_circle\" src=\"cms/images/close_red_icon.png\" &nbsp;=\"\" alt=\"\"></div></div><div class=\"col-xs-10\"><div translate=\"ute.bpoHeroValidationModal.errorTitle\" class=\"model-header-content\"></div></div><div class=\"col-xs-1\"><div class=\"heroClose\" ng-click=\"vm.closeSuccessOrErrorDialog()\"><img class=\"close-circle\" src=\"cms/images/close_black_icon.png\" &nbsp;=\"\" alt=\"\"></div></div></div></div><div class=\"body-container-plan\"><div class=\"col-sm-12 pad0\"><div class=\"plans-header\" translate=\"ute.bpoHeroValidationModal.errorPlanHeader\"></div></div></div></div>");
$templateCache.put("module/hero/heroModal.offerContent.body.html","<div class=\"offers col-xs-12\" ng-show=\"sl.offerType==\'hupOffer\'\"><div class=\"offerContentHeader\"><span ng-if=\"showCheckbox\" class=\"offerHeaderCheckbox\" ng-click=\"sl.offerSelected = !sl.offerSelected\" ng-class=\"sl.offerSelected ? \'active\' : \'\'\"><i class=\"fa fa-check\"></i></span> <span class=\"offerHeaderText\" translate=\"ute.bpoHeroModal.subHead.DeviceOffer.title\"></span></div><div class=\"heroContentBox\"><div class=\"heroContentOne col-xs-12\"><div class=\"col-xs-5 heroDeviceImage\"><img ng-src=\"{{sl.deviceImageUrl}}\" alt=\"{{sl.deviceDisplayName}}\" role=\"presentation\"></div><div class=\"col-xs-7 heroPriceSection\"><div class=\"heroPrice\"><span class=\"dollarSymbol\" ng-if=\"vm.getLang() == \'en\'\"><sup style=\"font-size: 20px;\">$</sup></span> <span class=\"heroPriceContent\">{{sl.devicePrice}}<sup ng-if=\"sl.devicePriceDecimal != \'\'\" style=\"font-size: 20px;\">{{sl.devicePriceDecimal}}</sup></span> <span class=\"dollarSymbolFr\" ng-if=\"vm.getLang() == \'fr\'\"><sup ng-class=\"sl.devicePriceDecimal != \'\' ? \'marginLeft5\' : \'\'\" style=\"font-size: 20px;\">$</sup></span></div><div class=\"heroDeviceName\" ng-if=\"vm.getLang() == \'en\'\">{{sl.deviceDisplayName}}</div><div class=\"heroDeviceName\" ng-if=\"vm.getLang() == \'fr\'\">{{sl.deviceDisplayNameFr}}</div><div class=\"heroPlanDesc\"><span translate=\"ute.bpoHeroModal.offerDetail.heroPlanDesc\" translate-values=\"{hupOfferCategoryValueEn: \'{{sl.hupOfferCategoryValueEn}}\', hupOfferCategoryValueFr: \'{{sl.hupOfferCategoryValueFr}}\', term: \'{{sl.term/12}}\'}\"></span></div></div></div><div class=\"col-xs-12\" ng-if=\"sl.bpoDetails.bpoCategory == \'hupBpo\'\"><div class=\"bpoDivision\"></div></div><div class=\"heroContentTwo col-xs-12\" ng-if=\"sl.bpoDetails.bpoCategory == \'hupBpo\'\"><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'fixedCredit\'\"><div class=\"heroPrice col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTimeContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'uptoCredit\'\"><div class=\"heroPrice col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div><span translate=\"ute.bpoHeroModal.offerDetail.hupUptoBonusCredit\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupUptoContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'bonusMinutes\'\"><div class=\"heroPrice col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupLongMinutes\" translate-values=\"{bpoBonusMinutes: \'{{sl.bpoDetails.bpoFeaturevalue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupLongMinutesContent\" translate-values=\"{bpoBonusMinutes: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'msfDiscount\'\"><div class=\"heroPrice col-sm-6\" ng-class=\"sl.bpoDetails.bpoType == \'msfDiscount\' && vm.getLang() == \'en\' ? \'msfHeroPriceHup\': \'msfHeroPriceHupFr\'\"><span translate=\"ute.bpoHeroModal.offerDetail.hupBpoMSF\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-6\" ng-class=\"sl.bpoDetails.bpoType == \'msfDiscount\' && vm.getLang() == \'en\' ? \'msfHeroDiscountContentHup\': \'msfHeroDiscountContentHup\'\"><span translate=\"ute.bpoHeroModal.offerDetail.hupBpoMSFTimeContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'dataBonus\'\"><div class=\"heroPrice col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupDataBonus\" translate-values=\"{bpoBonusData: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{sl.bpoDetails.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{sl.bpoDetails.bpoFeatureUnitFr}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupDataBonusConTent\" translate-values=\"{bpoBonusData: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{sl.bpoDetails.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{sl.bpoDetails.bpoFeatureUnitFr}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div></div></div></div><div class=\"offers col-xs-12\" ng-show=\"sl.offerType ==\'tvmOffer\'\"><div class=\"offerContentHeader\"><span ng-if=\"showCheckbox\" class=\"offerHeaderCheckbox\" ng-click=\"sl.offerSelected = !sl.offerSelected\" ng-class=\"sl.offerSelected ? \'active\' : \'\'\"><i class=\"fa fa-check\"></i></span> <span class=\"offerHeaderText\" translate=\"ute.bpoHeroModal.subHead.planOffer.title\"></span></div><div class=\"heroContentBox\"><div class=\"heroContentOne col-xs-12\"><div class=\"tvmOfferBox\"><div class=\"tvmOfferName col-xs-4\" translate=\"ute.bpoHeroModal.offerDetail.heroPlanDetail\" translate-values=\"{dataDisplayNameEn: \'{{sl.dataDisplayNameEn}}\', dataDisplayUnitEn: \'{{sl.dataDisplayUnitEn}}\', dataDisplayUnitFr: \'{{sl.dataDisplayUnitFr}}\'}\"></div><div class=\"tvmOfferBorder col-xs-1\"><div class=\"tvmOfferBorderContent\"></div></div><div class=\"priceSymbol col-xs-7\"><div class=\"heroPrice\"><span class=\"dollarSymbol\" ng-if=\"vm.getLang() == \'en\'\"><sup style=\"font-size: 20px;\">$</sup></span> <span class=\"heroPriceContent\">{{sl.planPrice}}</span> <span class=\"dollarSymbolFr\" ng-if=\"vm.getLang() == \'fr\'\"><sup style=\"font-size: 20px;\">$</sup></span> <span style=\"font-size:20px; margin-left: -8px;\" translate=\"ute.bpoHeroModal.offerDetail.mo\"></span></div></div></div><div class=\"\" ng-if=\"vm.getLang() == \'en\'\"><div class=\"__bpoOfferPlanName col-xs-12\"><span>{{sl.tvmDisplayName}}</span></div></div><div class=\"\" ng-if=\"vm.getLang() == \'fr\'\"><div class=\"__bpoOfferPlanName col-xs-12\"><span>{{sl.tvmDisplayNameFr}}</span></div></div><div ng-if=\"vm.getLang() == \'en\'\"><div class=\"col-xs-12 tvmOfferTalk\" ng-show=\"sl.talkDisplayNameEn\"><span class=\"tvmOfferTalkContent\" translate=\"ute.bpoHeroModal.offerDetail.talk\"></span><span style=\"padding-left: 3px;\">{{sl.talkDisplayNameEn}}</span></div><div class=\"col-xs-12 tvmOfferText\" ng-show=\"sl.textDisplayNameEn\"><span class=\"tvmOfferTextContent\" translate=\"ute.bpoHeroModal.offerDetail.text\"></span><span style=\"padding-left: 3px;\">{{sl.textDisplayNameEn}}</span></div></div><div ng-if=\"vm.getLang() == \'fr\'\"><div class=\"col-xs-12 tvmOfferTalk\" ng-show=\"sl.talkDisplayNameFr\"><span class=\"tvmOfferTalkContent\" translate=\"ute.bpoHeroModal.offerDetail.talk\"></span><span style=\"padding-left: 3px;\">{{sl.talkDisplayNameFr}}</span></div><div class=\"col-xs-12 tvmOfferText\" ng-show=\"sl.textDisplayNameFr\"><span class=\"tvmOfferTextContent\" translate=\"ute.bpoHeroModal.offerDetail.text\"></span><span style=\"padding-left: 3px;\">{{sl.textDisplayNameFr}}</span></div></div></div><div class=\"col-xs-12\" ng-if=\"sl.bpoDetails.bpoCategory == \'tvmBpo\'\"><div class=\"bpoDivision\"></div></div><div class=\"heroContentTwo col-xs-12\" ng-if=\"sl.bpoDetails.bpoCategory == \'tvmBpo\'\"><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'fixedCredit\'\"><div class=\"heroPrice col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTimeContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'uptoCredit\'\"><div class=\"heroPrice col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div><span translate=\"ute.bpoHeroModal.offerDetail.hupUptoBonusCredit\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupUptoContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'bonusMinutes\'\"><div class=\"heroPrice col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupLongMinutes\" translate-values=\"{bpoBonusMinutes: \'{{sl.bpoDetails.bpoFeaturevalue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupLongMinutesContent\" translate-values=\"{bpoBonusMinutes: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'msfDiscount\'\"><div class=\"heroPrice col-sm-6\" ng-class=\"sl.bpoDetails.bpoType == \'msfDiscount\' ? \'msfHeroPrice\': \'\'\"><span translate=\"ute.bpoHeroModal.offerDetail.hupMSF\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-6\" ng-class=\"sl.bpoDetails.bpoType == \'msfDiscount\' ? \'msfHeroDiscountContent\': \'\'\"><span translate=\"ute.bpoHeroModal.offerDetail.hupMSFTimeContent\" translate-values=\"{bpoDiscountValue: \'{{sl.bpoDetails.bpoDiscountValue}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"sl.bpoDetails.bpoType == \'dataBonus\'\"><div class=\"heroPrice col-sm-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.offerDetail.hupDataBonus\" translate-values=\"{bpoBonusData: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{sl.bpoDetails.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{sl.bpoDetails.bpoFeatureUnitFr}}\'}\"></span></div><div class=\"heroDiscountContent col-sm-12\"><span translate=\"ute.bpoHeroModal.offerDetail.hupDataBonusConTent\" translate-values=\"{bpoBonusData: \'{{sl.bpoDetails.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{sl.bpoDetails.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{sl.bpoDetails.bpoFeatureUnitFr}}\', bpoDuration: \'{{sl.bpoDetails.bpoDuration}}\'}\"></span></div></div></div></div></div>");
$templateCache.put("module/hero/heroModal.offerContent.bpoonly.body.html","<div class=\"offers col-xs-12\" ng-if=\"bpo.bpoCategory == \'hupBpo\'\"><div class=\"offerContentHeader\"><span ng-if=\"showCheckbox\" class=\"offerHeaderCheckbox\" ng-click=\"bpo.offerSelected = !bpo.offerSelected\" ng-class=\"bpo.offerSelected ? \'active\' : \'\'\"><i class=\"fa fa-check\"></i></span> <span class=\"offerHeaderText\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyDeviceOffer.title\"></span></div><div class=\"heroContentBox\"><div class=\"heroContentTwo col-xs-12\"><div class=\"\" ng-show=\"bpo.bpoType == \'fixedCredit\'\"><div class=\"heroPrice col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTimeContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'uptoCredit\'\"><div class=\"heroPrice col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div><div class=\"plans-title col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupUptoBonusCredit\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupUptoContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'bonusMinutes\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupLongMinutes\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupLongMinutesContent\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'msfDiscount\'\"><div class=\"heroPrice col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' && vm.getLang() == \'en\' ? \'msfHeroPriceHupEn\': \'msfHeroPriceHupFr\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupBpoMSF\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' && vm.getLang() == \'en\' ? \'msfHeroDiscountContentHupEn\': \'msfHeroDiscountContentHup\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupBpoMSFTimeContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'dataBonus\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupDataBonus\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupDataBonusConTent\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div></div></div></div><div class=\"offers col-xs-12\" ng-if=\"bpo.bpoCategory == \'tvmBpo\'\"><div class=\"offerContentHeader\"><span ng-if=\"showCheckbox\" class=\"offerHeaderCheckbox\" ng-click=\"bpo.offerSelected = !bpo.offerSelected\" ng-class=\"bpo.offerSelected ? \'active\' : \'\'\"><i class=\"fa fa-check\"></i></span> <span class=\"offerHeaderText\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyPlanOffer.title\"></span></div><div class=\"heroContentBox\"><div class=\"heroContentTwo col-xs-12\"><div class=\"\" ng-show=\"bpo.bpoType == \'fixedCredit\'\"><div class=\"heroPrice col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTimeContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'uptoCredit\'\"><div class=\"heroPrice col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div><div class=\"plans-title col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupUptoBonusCredit\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupUptoContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'bonusMinutes\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupLongMinutes\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupLongMinutesContent\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'msfDiscount\'\"><div class=\"heroPrice col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' ? \'msfHeroPrice\': \'\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupMSF\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' ? \'msfHeroDiscountContent\': \'\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupMSFTimeContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'dataBonus\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.hupDataBonus\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupDataBonusConTent\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div></div></div></div><div class=\"offers col-xs-12\" ng-if=\"bpo.bpoCategory == \'noTransactionalBPO\'\"><div class=\"offerContentHeader\"><span class=\"offerHeaderText\" ng-if=\"bpo.bpoType == \'dataBonus\'\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyPlanOffer.noTxnDbTitle\"></span> <span class=\"offerHeaderText\" ng-if=\"bpo.bpoType == \'msfDiscount\'\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyPlanOffer.noTxnMsfTitle\"></span> <span class=\"offerHeaderText\" ng-if=\"bpo.bpoType == \'bonusMinutes\'\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyPlanOffer.noTxnLdTitle\"></span> <span class=\"offerHeaderText\" ng-if=\"bpo.bpoType != \'dataBonus\' && bpo.bpoType != \'msfDiscount\' && bpo.bpoType != \'bonusMinutes\'\" translate=\"ute.bpoHeroModal.subHead.bpoOnlyPlanOffer.title\"></span></div><div class=\"heroContentBox\"><div class=\"heroContentTwo col-xs-12\"><div class=\"\" ng-show=\"bpo.bpoType == \'oneTimeCredit\'\"><div class=\"heroPrice col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTime\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.hupOneTimeContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'bonusMinutes\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.noTxnLd\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.noTxnLdContent\" translate-values=\"{bpoBonusMinutes: \'{{bpo.bpoFeaturevalue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'msfDiscount\'\"><div class=\"heroPrice col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' ? \'msfHeroPrice\': \'\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.noTxnMsf\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-6\" ng-class=\"bpo.bpoType == \'msfDiscount\' ? \'msfHeroDiscountContent\': \'\'\"><span translate=\"ute.bpoHeroModal.bpoDetail.noTxnMsfContent\" translate-values=\"{bpoDiscountValue: \'{{bpo.bpoDiscountValue}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div><div class=\"\" ng-show=\"bpo.bpoType == \'dataBonus\'\"><div class=\"heroPrice col-xs-12\"><span class=\"tvmBpoPlus\" translate=\"ute.bpoHeroModal.bpoDetail.noTxnDataBonus\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div><div class=\"heroDiscountContent col-xs-12\"><span translate=\"ute.bpoHeroModal.bpoDetail.noTxnDataBonusConTent\" translate-values=\"{bpoBonusData: \'{{bpo.bpoFeaturevalue}}\', bpoBonusDataUnit: \'{{bpo.bpoFeatureUnit}}\', bpoBonusDataUnitFr: \'{{bpo.bpoFeatureUnitFr}}\', bpoDuration: \'{{bpo.bpoDuration}}\'}\"></span></div></div></div></div></div>");
$templateCache.put("module/hero/heroModal.successModal.html","<div class=\"row\"><div class=\"model-header\"><div class=\"row showSuccessModal\"><div class=\"col-xs-1\"><div class=\"successCircle\"><img class=\"fail_success_circle\" src=\"cms/images/tick-circle.png\" &nbsp;=\"\" alt=\"\"></div></div><div class=\"col-xs-10 fail-success-header\"><div translate=\"ute.bpoHeroValidationModal.successTitle\" class=\"model-header-content\"></div></div><div class=\"col-xs-1\"><div class=\"heroClose\" ng-click=\"vm.closeSuccessOrErrorDialog()\"><img class=\"close-circle\" src=\"cms/images/close_black_icon.png\" &nbsp;=\"\" alt=\"\"></div></div></div></div><div class=\"body-container-plan\"><div class=\"col-sm-12 pad0\"><div class=\"plans-header\"><div ng-if=\"vm.noTransactionalBpoPresent\"><span translate=\"ute.bpoHeroValidationModal.successPlan.offerHeader\" translate-values=\"{dataEn: \'{{vm.noTransactionalBpoOfferDetails.bpoDisplayName}}\', dataFr: \'{{vm.noTransactionalBpoOfferDetails.bpoDisplayNameFr}}\'}\"></span></div></div></div></div></div>");
$templateCache.put("module/hero/heroModal.view.html","<div class=\"row\"><div class=\"model-header\"><div class=\"model-header-content\" ng-if=\"!vm.isSingleHeroOffer()\" translate=\"ute.bpoHeroModal.heading.title\"></div><div class=\"model-header-content\" ng-if=\"vm.isSingleHeroOffer()\" translate=\"ute.bpoHeroModal.heading.title2\"></div><div class=\"heroClose\" ng-click=\"vm.closeDialog()\"><img src=\"cms/images/close_back_slash.png\"  alt=\"\" style=\"position: absolute; top: 10px;\"> <img src=\"cms/images/close_fwd_slash.png\"  alt=\"\" style=\"position: absolute; top: 10px;\"></div></div><div class=\"body-container-plan\"><div class=\"shareEverything\" ng-show=\"vm.isShareEveryThing()\"><div class=\"col-sm-12 pad0\"><div class=\"plans-header\" ng-if=\"!vm.isSingleHeroOffer()\" translate=\"ute.bpoHeroModal.heading.planHeader\"></div><div class=\"plans-header\" ng-if=\"vm.isSingleHeroOffer()\" translate=\"ute.bpoHeroModal.heading.planHeader2\"></div><div class=\"plans-title\" ng-if=\"!vm.isOfferPresentForSingleCtn()\" translate=\"ute.bpoHeroModal.heading.planTitle\"></div><div class=\"plans-title\" ng-if=\"vm.isOfferPresentForSingleCtn()\" translate=\"ute.bpoHeroModal.heading.planTitleForCtn\" translate-values=\"{onlyctn: \'{{ShareEveythingheroCtnsformed[0].ctn | ute_common_filter_phone2}}\'}\"></div><div class=\"ctnContainer hidden-xs\"><div class=\"ctndiv col-sm-5\" ng-repeat-start=\"sl in vm.getShareEverythingCtnList()\"><div class=\"col-sm-12 pad0\" ng-if=\"!vm.isOfferPresentForSingleCtn()\"><div class=\"shareEverythingctnbutton\" ng-click=\"vm.openOfferDetails($index)\" ng-class=\"ShareEveythingheroCtnsformed[$index].showContent ? \'activeLine\': \'\'\"><div></div><div class=\"ctndisplay\" ng-style=\"{\'border-color\': sl.colorCode}\"><span style=\"padding-left:15px;\" translate=\"ute.bpoHeroModal.heading.line\"></span><span style=\"padding-left:5px;\">{{$index+1}}</span><span style=\"padding-left:5px;\">-</span><span style=\"padding-left:5px;\">{{sl.ctn | ute_common_filter_phone2}}</span> <i class=\"fa fa-angle-up\" ng-show=\"ShareEveythingheroCtnsformed[$index].showContent\"></i> <i class=\"fa fa-angle-down\" ng-show=\"!ShareEveythingheroCtnsformed[$index].showContent\"></i></div></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index+1 == vm.getShareEverythingCtnList().length && vm.getShareEverythingCtnList().length % 2 != 0\" ng-class=\"ShareEveythingheroCtnsformed[$index].showContent?\'\':\'dis\'\"><div class=\"offerHeader\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"ShareEveythingheroCtnsformed[$index].tvmPresent || ShareEveythingheroCtnsformed[$index].hupPresent\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getCtnOffers($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.shareCtnHasBpoOnly($index)\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getShareEverythingCtnBpos($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherPlanOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherDeviceOffers($index)\" ng-click=\"vm.redirectUrl(\'hup\', $index, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherDeviceOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherPlanOffers($index)\" ng-click=\"vm.redirectUrl(\'tvm\', $index, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index % 2 == 1\" ng-class=\"ShareEveythingheroCtnsformed[$index-1].showContent ? \'\' : \'dis\'\"><div class=\"offerHeader\" ng-if=\"ShareEveythingheroCtnsformed[$index-1].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"ShareEveythingheroCtnsformed[$index-1].tvmPresent || ShareEveythingheroCtnsformed[$index-1].hupPresent\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index-1].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getCtnOffers($index-1)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.shareCtnHasBpoOnly($index-1)\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index-1].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getShareEverythingCtnBpos($index-1)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"ShareEveythingheroCtnsformed[$index-1].showCheckbox\" ng-disabled=\"!vm.isDisabled($index-1, true)\" ng-click=\"vm.setSelectedHeroOffers($index-1, true)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index-1].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index-1, true)\" ng-click=\"vm.setSelectedHeroOffers($index-1, true)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index-1].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index-1, true)\" ng-click=\"vm.setSelectedHeroOffers($index-1, true)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherPlanOffers($index - 1) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherDeviceOffers($index-1)\" ng-click=\"vm.redirectUrl(\'hup\', $index-1, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherDeviceOffers($index - 1) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherPlanOffers($index-1)\" ng-click=\"vm.redirectUrl(\'tvm\', $index-1, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index % 2 == 1\" ng-class=\"ShareEveythingheroCtnsformed[$index].showContent?\'\':\'dis\'\" ng-repeat-end=\"\"><div class=\"offerHeader\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"ShareEveythingheroCtnsformed[$index].tvmPresent || ShareEveythingheroCtnsformed[$index].hupPresent\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getCtnOffers($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.shareCtnHasBpoOnly($index)\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getShareEverythingCtnBpos($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherPlanOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherDeviceOffers($index)\" ng-click=\"vm.redirectUrl(\'hup\', $index, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayShareCtnOtherDeviceOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayShareCtnOtherPlanOffers($index)\" ng-click=\"vm.redirectUrl(\'tvm\', $index, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div></div><div class=\"ctnContainer visible-xs\"><div class=\"ctndiv col-xs-12\" ng-repeat=\"sl in vm.getShareEverythingCtnList()\"><div class=\"col-xs-12 pad0\" ng-if=\"!vm.isOfferPresentForSingleCtn()\"><div class=\"shareEverythingctnbutton\" ng-click=\"vm.openOfferDetails($index)\" ng-class=\"ShareEveythingheroCtnsformed[$index].showContent ? \'activeLine\': \'\'\"><div></div><div class=\"ctndisplay\" ng-style=\"{\'border-color\': sl.colorCode}\"><span style=\"padding-left:15px;\" translate=\"ute.bpoHeroModal.heading.line\"></span><span style=\"padding-left:5px;\">{{$index+1}}</span><span style=\"padding-left:5px;\">-</span><span style=\"padding-left:5px;\">{{sl.ctn | ute_common_filter_phone2}}</span> <i class=\"fa fa-angle-up\" ng-show=\"ShareEveythingheroCtnsformed[$index].showContent\"></i> <i class=\"fa fa-angle-down\" ng-show=\"!ShareEveythingheroCtnsformed[$index].showContent\"></i></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-class=\"ShareEveythingheroCtnsformed[$index].showContent?\'\':\'dis\'\"><div class=\"offerHeader\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"ShareEveythingheroCtnsformed[$index].tvmPresent || ShareEveythingheroCtnsformed[$index].hupPresent\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getCtnOffers($index)\"><div style=\"width:100%;\" ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.shareCtnHasBpoOnly($index)\" ng-init=\"showCheckbox=ShareEveythingheroCtnsformed[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getShareEverythingCtnBpos($index)\"><div style=\"width:100%;\" ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-xs-12 offerFooterSection\"><div class=\"col-xs-12 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"ShareEveythingheroCtnsformed[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!ShareEveythingheroCtnsformed[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, true)\" ng-click=\"vm.setSelectedHeroOffers($index, true)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"col-xs-12 pad0 offerFooterLink\" ng-show=\"vm.displayShareCtnOtherDeviceOffers($index)\" ng-click=\"vm.redirectUrl(\'hup\', $index, \'share\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"col-xs-12 pad0 offerFooterLink\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\" ng-show=\"vm.displayShareCtnOtherPlanOffers($index)\" ng-click=\"vm.redirectUrl(\'tvm\', $index, \'share\')\"></div></div></div></div></div></div></div><div class=\"individual\" ng-show=\"vm.isIndividual()\" ng-style=\"vm.isShareEveryThing() && {\'padding-top\': \'20px\'}\"><div class=\"col-xs-12 pad0\"><div class=\"plans-header\" ng-if=\"!vm.isSingleHeroOffer() && !vm.isShareEveryThing()\" translate=\"ute.bpoHeroModal.heading.planHeader\"></div><div class=\"plans-header\" ng-if=\"vm.isSingleHeroOffer() && !vm.isShareEveryThing()\" translate=\"ute.bpoHeroModal.heading.planHeader2\"></div><div class=\"plans-title\" ng-style=\"!vm.isShareEveryThing() && {\'padding-top\': \'20px\'}\" ng-if=\"!vm.isOfferPresentForSingleCtn()\" translate=\"ute.bpoHeroModal.heading.individualTitle\"></div><div class=\"plans-title\" ng-if=\"vm.isOfferPresentForSingleCtn()\" translate=\"ute.bpoHeroModal.heading.planTitleForCtn\" translate-values=\"{onlyctn: \'{{indHeroCtn[0].ctn | ute_common_filter_phone2}}\'}\"></div><div class=\"ctnContainer hidden-xs\"><div class=\"ctndiv col-sm-5\" ng-repeat-start=\"sl in vm.getIndCtnList()\"><div class=\"col-sm-12 pad0\" ng-if=\"!vm.isOfferPresentForSingleCtn()\"><div class=\"shareEverythingctnbutton\" ng-click=\"vm.openIndOfferDetails($index)\" ng-class=\"indHeroCtn[$index].showContent ? \'activeLine\': \'\'\"><div></div><div class=\"ctndisplay\" style=\"border-left: none;\"><span style=\"padding-left:15px;\" translate=\"ute.bpoHeroModal.heading.line\"></span><span style=\"padding-left:5px;\">{{$index+1}}</span><span style=\"padding-left:5px;\">-</span><span style=\"padding-left:5px;\">{{sl.ctn | ute_common_filter_phone2}}</span> <i class=\"fa fa-angle-up\" ng-show=\"indHeroCtn[$index].showContent\"></i> <i class=\"fa fa-angle-down\" ng-show=\"!indHeroCtn[$index].showContent\"></i></div></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index+1 == vm.getIndCtnList().length && vm.getIndCtnList().length % 2 != 0\" ng-class=\"indHeroCtn[$index].showContent?\'\':\'dis\'\"><div class=\"offerHeader\" ng-if=\"indHeroCtn[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"indHeroCtn[$index].tvmPresent || indHeroCtn[$index].hupPresent\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getIndCtnOffers($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.indHasBpoOnly($index)\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getIndCtnBpos($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"indHeroCtn[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherPlanOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherDeviceOffers($index)\" ng-click=\"vm.redirectUrl(\'hup\', $index, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherDeviceOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherPlanOffers($index)\" ng-click=\"vm.redirectUrl(\'tvm\', $index, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index % 2 == 1\" ng-class=\"indHeroCtn[$index-1].showContent ? \'\' : \'dis\'\"><div class=\"offerHeader\" ng-if=\"indHeroCtn[$index-1].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"indHeroCtn[$index-1].tvmPresent || indHeroCtn[$index-1].hupPresent\" ng-init=\"showCheckbox=indHeroCtn[$index-1].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getIndCtnOffers($index-1)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.indHasBpoOnly($index-1)\" ng-init=\"showCheckbox=indHeroCtn[$index-1].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getIndCtnBpos($index-1)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"indHeroCtn[$index-1].showCheckbox\" ng-disabled=\"!vm.isDisabled($index-1, false)\" ng-click=\"vm.setSelectedHeroOffers($index-1, false)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index-1].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index-1, false)\" ng-click=\"vm.setSelectedHeroOffers($index-1, false)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index-1].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index-1, false)\" ng-click=\"vm.setSelectedHeroOffers($index-1, false)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherPlanOffers($index - 1) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherDeviceOffers($index-1)\" ng-click=\"vm.redirectUrl(\'hup\', $index-1, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherDeviceOffers($index - 1) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherPlanOffers($index-1)\" ng-click=\"vm.redirectUrl(\'tvm\', $index-1, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div><div class=\"col-sm-12 pad0 offerContainer\" ng-if=\"$index % 2 == 1\" ng-class=\"indHeroCtn[$index].showContent?\'\':\'dis\'\" ng-repeat-end=\"\"><div class=\"offerHeader\" ng-if=\"indHeroCtn[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"indHeroCtn[$index].tvmPresent || indHeroCtn[$index].hupPresent\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getIndCtnOffers($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.indHasBpoOnly($index)\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getIndCtnBpos($index)\"><div ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-sm-12 row offerFooterSection\"><div class=\"col-sm-4 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"indHeroCtn[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherPlanOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherDeviceOffers($index)\" ng-click=\"vm.redirectUrl(\'hup\', $index, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"offerFooterLink\" ng-class=\"vm.displayIndCtnOtherDeviceOffers($index) ? \'col-sm-4\' : \'col-sm-7\'\" ng-show=\"vm.displayIndCtnOtherPlanOffers($index)\" ng-click=\"vm.redirectUrl(\'tvm\', $index, \'ind\')\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div></div><div class=\"ctnContainer visible-xs\"><div class=\"ctndiv col-xs-12\" ng-repeat=\"sl in vm.getIndCtnList()\"><div class=\"col-xs-12 pad0\" ng-if=\"!vm.isOfferPresentForSingleCtn()\"><div class=\"shareEverythingctnbutton\" ng-click=\"vm.openIndOfferDetails($index)\" ng-class=\"indHeroCtn[$index].showContent ? \'activeLine\': \'\'\"><div></div><div class=\"ctndisplay\" style=\"border-left: none;\"><span style=\"padding-left:15px;\" translate=\"ute.bpoHeroModal.heading.line\"></span><span style=\"padding-left:5px;\">{{$index+1}}</span><span style=\"padding-left:5px;\">-</span><span style=\"padding-left:5px;\">{{sl.ctn | ute_common_filter_phone2}}</span> <i class=\"fa fa-angle-up\" ng-show=\"indHeroCtn[$index].showContent\"></i> <i class=\"fa fa-angle-down\" ng-show=\"!indHeroCtn[$index].showContent\"></i></div></div></div><div class=\"col-xs-12 pad0 offerContainer\" ng-class=\"indHeroCtn[$index].showContent?\'\':\'dis\'\"><div class=\"offerHeader\" ng-if=\"indHeroCtn[$index].showCheckbox\" translate=\"ute.bpoHeroModal.subHead.heroOffer.offerHeader\"></div><div class=\"offerContentConatiner\"><div ng-if=\"indHeroCtn[$index].tvmPresent || indHeroCtn[$index].hupPresent\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"sl in vm.getIndCtnOffers($index)\" ng-class=\"(sl.offerType ==\'tvmOffer\' && indHeroCtn[$index].hupPresent ) ? \'appendPadding\': \'\'\"><div style=\"width:100%;\" ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.body.html\'\"></div></div></div><div ng-if=\"vm.indHasBpoOnly($index)\" ng-init=\"showCheckbox=indHeroCtn[$index].showCheckbox\" class=\"col-xs-12 d-flex\"><div class=\"offerContentBody\" ng-repeat=\"bpo in vm.getIndCtnBpos($index)\"><div style=\"width:100%;\" ng-include=\"\" src=\"\'module/hero/heroModal.offerContent.bpoonly.body.html\'\"></div></div></div></div><div class=\"col-xs-12 offerFooterSection\"><div class=\"col-xs-12 pad0\"><button class=\"offerFooterBtn\" type=\"button\" ng-if=\"indHeroCtn[$index].showCheckbox\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOffersLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && !vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getOfferLink\"></button> <button class=\"offerFooterBtn\" type=\"button\" ng-if=\"!indHeroCtn[$index].showCheckbox && vm.noTransactionalBpoPresent\" ng-disabled=\"!vm.isDisabled($index, false)\" ng-click=\"vm.setSelectedHeroOffers($index, false)\" translate=\"ute.bpoHeroModal.footer.getNoTxnOfferLink\"></button></div><div class=\"col-xs-12 offerFooterLink\" ng-show=\"vm.displayIndCtnOtherDeviceOffers($index)\" translate=\"ute.bpoHeroModal.footer.seeMoreDevices\"></div><div class=\"col-xs-12 offerFooterLink\" ng-show=\"vm.displayIndCtnOtherPlanOffers($index)\" translate=\"ute.bpoHeroModal.footer.seeMorePlans\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("module/rogersSecondLevelNavigation/navigationBar.directive.view.html","<ute-user-if-any-granted data-roles=\"consumer\"><ute-rogers-second-level-navigation-consumer data-ng-show=\"$ctrl.showSecondLevelNavigationConsumer\"></ute-rogers-second-level-navigation-consumer></ute-user-if-any-granted><ute-user-if-any-granted data-roles=\"dealer,care,careRep\"><ute-rogers-second-level-navigation-dealer></ute-rogers-second-level-navigation-dealer></ute-user-if-any-granted>");
$templateCache.put("module/forgotPassword/forgotPassword.html","<h1 class=\"sr-only\" data-translate=\"ute.rogers.forgotPassword.heading\"></h1><div class=\"ute-rogers-forgot-password\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.common.label.password.forgot\"></span></li><li class=\"widget-loader sign-in\" data-ng-show=\"forgotPasswordCtrl.isRogersForgotPasswordCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></li></ul></div><div id=\"forgotPassword-success\" class=\"row\" data-ng-if=\"forgotPasswordCtrl.model.isServiceCallSuccess\"><div class=\"col-xs-12 check-email\"><span data-translate=\"ute.rogers.forgotPassword.check.your.email\"></span></div><div class=\"col-xs-12 check-email-message\"><span data-translate=\"ute.rogers.forgotPassword.check.email.message\" data-translate-values=\"{email: \'{{forgotPasswordCtrl.model.email}}\'}\"></span></div></div><form name=\"forgotPasswordCtrl.form\" novalidate=\"\" data-ng-if=\"!forgotPasswordCtrl.model.isServiceCallSuccess\"><div class=\"row\"><div class=\"col-lg-12\"><span class=\"password-help-txt black\" data-translate=\"ute.rogers.forgotPassword.description\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 forgot-password-section\"><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7\"><div class=\"col-xs-12 col-sm-12 col-md-11 col-lg-11\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"rel\"><span class=\"sr-only\" data-translate=\"ute.rogers.forgotPassword.enterEmailAddress\"></span> <input id=\"email\" name=\"email\" type=\"text\" class=\"forgot-password-email\" required=\"\" translate=\"\" data-ng-model=\"forgotPasswordCtrl.model.email\" data-ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" data-translate-attr-placeholder=\"ute.common.label.email.address\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"forgot-password,forgotPasswordNoLivecontent,event.selfServeStart\"}\' maxlength=\"105\"> <span class=\"inline-checker icon-error\" data-ng-show=\"(forgotPasswordCtrl.form.email.$invalid && (forgotPasswordCtrl.form.email.$dirty || forgotPasswordCtrl.form.$submitted))\"></span> <i data-ng-show=\"forgotPasswordCtrl.form.email.$dirty && forgotPasswordCtrl.form.email.$valid && forgotPasswordCtrl.model.email == forgotPasswordCtrl.model.newPassword\" class=\"inline-checker icon-checked\"></i></label></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-11 col-lg-11\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 action-button\"><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6 pull-right\"><button name=\"button_continue\" data-ng-click=\"forgotPasswordCtrl.submit()\" data-ng-disabled=\"!forgotPasswordCtrl.isSubmitButtonEnable()\" class=\"primary medium btn-continue\"><span data-translate=\"ute.common.label.continue\"></span></button></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-6\"><button name=\"button_cancel\" data-ng-click=\"forgotPasswordCtrl.cancel()\" class=\"btn btn-link link-cancel btn-cancel\"><span data-translate=\"ute.common.label.cancel\"></span></button></div></div></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 forgot-password-right\"><div class=\"col-xs-11 col-sm-11 col-md-12 col-lg-12\"><span class=\"need-help-text\" data-translate=\"ute.common.label.need.help\"></span><br><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.rogers.forgotPassword.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.rogers.forgotPassword.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.rogers.forgotPassword.boldChat.chatButtonClass\' | translate}}\" data-alt-text=\"\'ute.rogers.forgotPassword.liveChat\' | translate\"></bold-chat-static-button></div></div></div><div class=\"row input-password\"><div class=\"col-md-6 col-lg-6\"></div></div></div></form></div></div>");
$templateCache.put("module/setPassword/setPassword.html","<div class=\"ute-rogers-setpassword\"><div class=\"container\"><form name=\"setPasswordCtrl.form\" novalidate=\"\"><div class=\"row\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.setPassword.register\"></span></li><li class=\"widget-loader sign-in\" data-ng-show=\"setPasswordCtrl.isJanrainVerificationCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></li></ul></div><div class=\"col-lg-12\"><h1 class=\"temp-password-title primary-color\" data-translate=\"ute.rogers.setPassword.page_title\"></h1><h5 class=\"password-help-txt black\" data-translate=\"ute.rogers.setPassword.page_description\"></h5></div></div><div class=\"row input-password\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 new-password-section\"><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5\"><div class=\"row\"><div class=\"col-md-11 col-lg-11\"><div class=\"inline_error\" data-ng-messages=\"setPasswordCtrl.form.newPassword.$error\" data-ng-if=\"( setPasswordCtrl.form.$submitted || setPasswordCtrl.form.newPassword.$dirty ) && setPasswordCtrl.form.newPassword.$invalid\"><span data-ng-message=\"required\"><span data-translate=\"ute.rogers.setPassword.login_invalid_password\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span> <span data-ng-message=\"minlength\"><span data-translate=\"ute.rogers.setPassword.registration_too_short\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span> <span data-ng-message=\"maxlength\"><span data-translate=\"ute.rogers.setPassword.registration_too_long\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span> <span data-ng-message=\"pattern\"><span data-ng-if=\"setPasswordCtrl.isNumericOnly(setPasswordCtrl.form.newPassword.$viewValue)\" data-translate=\"ute.rogers.setPassword.registration_number_only\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span> <span data-ng-if=\"setPasswordCtrl.isAlphabetOnly(setPasswordCtrl.form.newPassword.$viewValue)\" data-translate=\"ute.rogers.setPassword.registration_alphabet_only\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span> <span data-ng-if=\"!setPasswordCtrl.isAlphanumeric(setPasswordCtrl.form.newPassword.$viewValue)\" data-translate=\"ute.rogers.setPassword.registration_wrong_password\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f2\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span></div></div></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11 password-input-field\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"newPassword\" translate=\"\" data-translate-attr-placeholder=\"ute.rogers.setPassword.new_password_placeholder\" data-ng-minlength=\"7\" data-ng-maxlength=\"16\" data-ng-pattern=\"/^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9]+)$/\" data-ng-model-options=\"{ debounce: 500, allowInvalid: true }\" data-onpaste=\"return false;\" data-ng-model=\"setPasswordCtrl.model.newPassword\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"reset-password,event.selfServeStart\"}\' required=\"\"> <span class=\"inline-checker icon-error\" data-ng-show=\"setPasswordCtrl.form.newPassword.$invalid && (setPasswordCtrl.form.newPassword.$dirty || setPasswordCtrl.form.$submitted)\"></span> <i data-ng-show=\"setPasswordCtrl.form.newPassword.$dirty && setPasswordCtrl.form.newPassword.$valid\" class=\"inline-checker icon-checked\"></i></label></div><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-11\"><div class=\"inline_error\" data-ng-messages=\"setPasswordCtrl.form.confirmPassword.$error\" data-ng-if=\"( setPasswordCtrl.form.$submitted || setPasswordCtrl.form.confirmPassword.$dirty ) && setPasswordCtrl.form.confirmPassword.$invalid\"><span data-ng-message=\"required\"><span data-translate=\"ute.common.label.password.reenter\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f3\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span><span data-ng-message=\"matches\"><span data-translate=\"ute.common.label.password.notmatch\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f3\",\"mappingKey\":\"sso/resetPassword\"}\'></span></span></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><label class=\"rel\"><input data-tl-private=\"\" type=\"password\" name=\"confirmPassword\" translate=\"\" data-translate-attr-placeholder=\"ute.rogers.setPassword.confirm_password_placeholder\" data-ng-model-options=\"{ debounce: 500, allowInvalid: true }\" data-onpaste=\"return false;\" data-ng-model=\"setPasswordCtrl.model.confirmPassword\" required=\"\" matches=\"setPasswordCtrl.form.newPassword\"> <span class=\"inline-checker icon-error\" data-ng-show=\"(setPasswordCtrl.form.confirmPassword.$invalid && (setPasswordCtrl.form.confirmPassword.$dirty || setPasswordCtrl.form.$submitted)) || (setPasswordCtrl.mismatchPasswordError && setPasswordCtrl.model.confirmPassword != setPasswordCtrl.model.newPassword)\"></span> <i data-ng-show=\"setPasswordCtrl.form.confirmPassword.$dirty && setPasswordCtrl.form.confirmPassword.$valid && setPasswordCtrl.model.confirmPassword == setPasswordCtrl.model.newPassword\" class=\"inline-checker icon-checked\"></i></label></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-7 col-lg-7 new-password-right\"><div class=\"col-xs-11 col-sm-11 col-md-12 col-lg-12 password-guidelines\"><span class=\"password-guidelines-title\" data-translate=\"ute.rogers.setPassword.temp_password_guildeline\"></span> <span data-translate=\"ute.rogers.setPassword.temp_password_list_of_guildeline\"></span></div></div></div><div class=\"row input-password\"><div class=\"col-md-6 col-lg-6\"></div></div><div class=\"row input-password\"><div class=\"col-xs-11 col-sm-12 col-md-5 col-lg-5\"><div class=\"col-lg-11 col-md-11 col-sm-11 col-xs-12 cancel-continue-ctn\"><button name=\"button_continue\" data-ng-click=\"setPasswordCtrl.submit()\" data-ng-disabled=\"!setPasswordCtrl.isSubmitButtonEnable()\" class=\"cta-round primary medium full btn-continue\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"reset-password,event.selfServeComplete\"}\'><span data-translate=\"ute.rogers.setPassword.setAndContinueBtn\"></span></button></div></div></div></div></form></div></div>");
$templateCache.put("module/setPassword/setPasswordErrorMessageWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/setPassword/setPasswordGenericErrorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.errorHandler.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" data-translate=\"{{errorModal.errorHandler.frontendMessageKey}}\"></div><bold-chat-static-button data-cbid=\"{{errorModal.errorHandler.boldChat.cbid | translate}}\" data-dynamic-div=\"{{errorModal.errorHandler.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{errorModal.errorHandler.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" data-translate=\"{{errorModal.errorHandler.errorHandler.frontendMessageP2Key}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/registrationConfirmation/registrationConfirmation.html","<div class=\"myrRegistration-confirmation\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.email.verification\"></span></li></ul></div><div class=\"mbl\"></div><div class=\"row desc-font-size-18\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div data-translate=\"ute.rogers.user.registration.email.verification.msg\"></div><p><span data-translate=\"ute.rogers.user.registration.email.verfication.your.email\"></span> <strong data-ng-bind=\"::registration.emailAddress\"></strong></p></div></div></div></div>");
$templateCache.put("module/registrationStart/userRegistration.html","<div class=\"page-registration\"><div class=\"container\"><form name=\"registration.form\" novalidate=\"\" data-label=\"Registration\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.registration\"></span></li></ul></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 mtm\"><div class=\"row info-banner error mts mbm\" data-ng-if=\"registration.errorCode.frontendMessageKey\" style=\"margin-left: 0;\"><ute-dtm-error-form-field key=\"registration.dtmName\" error-prefix=\"SS\" error-code=\"{{registration.errorCode.backendCode}}\" error-message=\"{{backendErrorText}}\" error-url=\"profile/create\"></ute-dtm-error-form-field><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\" style=\"float:left\"><span data-translate=\"{{registration.errorCode.frontendMessageKey}}\"></span><div id=\"myr-registration\"><bold-chat-static-button data-cbid=\"{{registration.errorCode.boldChat.cbid | translate}}\" data-dynamic-div=\"{{registration.errorCode.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{registration.errorCode.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div><div class=\"row info-banner error mts mbm\" data-ng-if=\"( registration.form.$submitted && !registration.form.$valid )\" style=\"margin-left: 0;\"><ute-dtm-error-form-field key=\"registration.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 no-padding error-icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11 emp\"><span data-translate=\"ute.common.label.check.form.errors\"></span></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><h4><span data-translate=\"ute.common.label.contact.info\"></span></h4></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.email.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.email.$dirty ) && registration.form.email.$invalid\"><ute-dtm-error-form-field key=\"registration.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field><span data-ng-message=\"required\"><span data-translate=\"ute.rogers.user.registration.require.email\"></span></span> <span data-ng-message=\"pattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span></div><label class=\"rel\"><input type=\"email\" xvalidation-tag=\"\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" name=\"email\" id=\"email\" data-ng-pattern=\"/^\\w+([-+.\']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$/\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.address\" maxlength=\"105\" data-ng-model-options=\"registration.modelOptions\" data-onpaste=\"return false;\" data-ng-model=\"registration.model.email\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.email.$invalid && (registration.form.email.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.email.$dirty && registration.form.email.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-lg-6 col-md-5\"><div class=\"inline_error\" data-ng-messages=\"registration.form.confirmEmail.$error\" data-ng-if=\"( registration.form.$submitted || registration.form.confirmEmail.$dirty ) && registration.form.confirmEmail.$invalid\"><ute-dtm-error-form-field key=\"registration.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field><span data-ng-message=\"required\"><span data-translate=\"ute.rogers.user.registration.require.confirm.email\"></span></span> <span data-ng-message=\"pattern\"><span data-translate=\"ute.rogers.user.registration.email.address.not.valid\"></span></span> <span data-ng-message=\"match\"><span data-translate=\"ute.rogers.user.registration.email.not.matched\"></span></span></div><label class=\"rel\"><input type=\"email\" name=\"confirmEmail\" data-tag-form-name=\"registration.form\" data-tag-page-name=\"Registration\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.confirm\" data-ng-model-options=\"registration.modelOptions\" data-ute-match=\"registration.form.email\" data-ute-match-real-time=\"true\" data-ng-model=\"registration.model.confirmEmail\" data-onpaste=\"return false;\" required=\"\" data-autocorrect=\"off\" data-autocapitalize=\"off\"> <span class=\"inline-checker icon-error\" data-ng-show=\"registration.form.confirmEmail.$invalid && (registration.form.confirmEmail.$dirty || registration.form.$submitted)\"></span> <span data-ng-show=\"registration.form.confirmEmail.$dirty && registration.form.confirmEmail.$valid\" class=\"inline-checker icon-checked\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-md-6 col-lg-6 col-sm-12 col-xs-12 lang-btn-ctn mbm\"><div class=\"rui-content-block intro mtm\"><span class=\"content\"><p data-translate=\"ute.common.label.language.preference\"></p></span></div><label class=\"btn btn-default left\" data-ng-class=\"registration.model.lang == lang ? \'box_selected\' : \'radio_unselected\'\" data-ng-repeat=\"(lang, title) in registration.languages\"><input type=\"radio\" data-ng-model=\"registration.model.lang\" data-ng-value=\"lang\" value=\"{{::title}}\"> <span class=\"prm\" data-ng-bind=\"::title\"></span></label></div></div><div class=\"row mbm\"><div class=\"col-md-6 col-sm-12 col-xs-12 lang-btn-ctn mbm\"><br><div ng-if=\"!registration.useRecaptchaV3\"><div ng-if=\"registration.lang===\'en\'\" vc-recaptcha=\"\" data-key=\"registration.recaptchaSiteKey\" data-lang=\"en\" data-response=\"res\" data-on-success=\"registration.verifyReCaptchaCallback(response)\"></div><div ng-if=\"registration.lang===\'fr\'\" vc-recaptcha=\"\" data-key=\"registration.recaptchaSiteKey\" data-lang=\"fr\" data-response=\"res\" data-on-success=\"registration.verifyReCaptchaCallback(response)\"></div></div><div id=\"renderV3Recaptcha\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 mtm\"><div class=\"pull-left mtm\"><a data-ui-sref=\"{{::registration.getCancelStateName()}}\" class=\"link-cancel\" data-translate=\"ute.common.label.cancel\"></a></div><div class=\"pull-right\" data-ng-show=\"registration.isUserRegistrationCallInProgress()\"><span class=\"widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"pull-right\"><button name=\"button_continue\" data-ng-disabled=\"!registration.isSubmitButtonEnabled()\" data-ng-click=\"registration.submit()\" class=\"cta-round primary medium full\"><span data-translate=\"ute.common.label.continue\"></span></button></div></div></div></form></div></div>");
$templateCache.put("module/savebill/savebill-banner.partial.html","<div class=\"save-bill-banner\"><ul class=\"list-inline blue-text hidden-sm hidden-xs\"><li ng-click=\"saveBillBanner.printBill()\"><svg width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect fill-rule=\"nonzero\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><path d=\"M19,8 L5,8 C3.34,8 2,9.34 2,11 L2,15 C2,16.1 2.9,17 4,17 L6,17 L6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,17 L20,17 C21.1,17 22,16.1 22,15 L22,11 C22,9.34 20.66,8 19,8 Z M15,19 L9,19 C8.45,19 8,18.55 8,18 L8,14 L16,14 L16,18 C16,18.55 15.55,19 15,19 Z M19,12 C18.45,12 18,11.55 18,11 C18,10.45 18.45,10 19,10 C19.55,10 20,10.45 20,11 C20,11.55 19.55,12 19,12 Z M17,3 L7,3 C6.45,3 6,3.45 6,4 L6,6 C6,6.55 6.45,7 7,7 L17,7 C17.55,7 18,6.55 18,6 L18,4 C18,3.45 17.55,3 17,3 Z\" fill=\"#2f6fa7\" fill-rule=\"nonzero\"></path></g></svg><span><ins translate=\"ute.saveBillBanner.printPDF\"></ins></span></li><li class=\"\" ng-click=\"saveBillBanner.downloadMutiplePDFConfirmationBox()\"><svg width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g><polygon points=\"0 0 24 0 24 24 0 24\"></polygon><path d=\"M19,13 L19,18 C19,18.55 18.55,19 18,19 L6,19 C5.45,19 5,18.55 5,18 L5,13 C5,12.45 4.55,12 4,12 C3.45,12 3,12.45 3,13 L3,19 C3,20.1 3.9,21 5,21 L19,21 C20.1,21 21,20.1 21,19 L21,13 C21,12.45 20.55,12 20,12 C19.45,12 19,12.45 19,13 Z M13,12.67 L14.88,10.79 C15.27,10.4 15.9,10.4 16.29,10.79 C16.68,11.18 16.68,11.81 16.29,12.2 L12.7,15.79 C12.31,16.18 11.68,16.18 11.29,15.79 L7.7,12.2 C7.31,11.81 7.31,11.18 7.7,10.79 C8.09,10.4 8.72,10.4 9.11,10.79 L11,12.67 L11,4 C11,3.45 11.45,3 12,3 C12.55,3 13,3.45 13,4 L13,12.67 Z\" fill=\"#2f6fa7\" fill-rule=\"nonzero\"></path></g></g></svg><span><ins translate=\"ute.saveBillBanner.savePDF\"></ins></span></li><li class=\"\" ng-click=\"saveBillBanner.downloadAsExcel()\"><svg width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><rect fill-rule=\"nonzero\" x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><path d=\"M5,9.2 L8,9.2 L8,19 L5,19 L5,9.2 Z M10.6,5 L13.4,5 L13.4,19 L10.6,19 L10.6,5 Z M16.2,13 L19,13 L19,19 L16.2,19 L16.2,13 Z\" fill=\"#2f6fa7\" fill-rule=\"nonzero\"></path></g></svg><span><ins translate=\"ute.saveBillBanner.downloadUsageAsExcelCSV\"></ins></span></li></ul><div class=\"blue-text visible-xs visible-sm\" ng-click=\"saveBillBanner.downloadMutiplePDFConfirmationBox()\"><span translate=\"ute.saveBillBanner.saveOrDownloadBill\"></span><svg width=\"24px\" height=\"24px\" viewbox=\"0 0 24 24\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g fill-rule=\"nonzero\"><rect x=\"0\" y=\"0\" width=\"24\" height=\"24\"></rect><polygon fill=\"#035D67\" transform=\"translate(12.000000, 12.295000) rotate(-90.000000) translate(-12.000000, -12.295000)\" points=\"16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10\"></polygon></g></g></svg></div></div>");
$templateCache.put("module/savebill/savebill.partial.html","<div class=\"ute-savebill\"><ute-save-bill-banner ng-if=\"!saveBillButton.isLoadingBriteBill()\" account-number=\"saveBillButton.accountNumber\"></ute-save-bill-banner></div>");
$templateCache.put("module/savebillModal/savebillModal.windowTemplate.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"ute-savebillModal-window modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-saveBillModal ute-saveBill-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/secondLevelNavigation/secondLevelNavigation.main.view.html","<ui-view></ui-view>");
$templateCache.put("module/simCard/simCardHeader.partial.html","<div class=\"container\"><div class=\"ute-simCard-identity\"><div class=\"ute-icon-wireless ute-simCard-identity-icon\"></div><div class=\"ute-simCard-identity-text\">{{sc.getCtn() | ute_common_filter_phone}}</div></div></div>");
$templateCache.put("module/simCard/simCardMain.view.html","<section><div data-ng-include=\"sc.simCardHeaderPartialPath\"></div><ui-view></ui-view></section><myr-payment-helper></myr-payment-helper><div style=\"display: none;\"><form name=\"formToRogers\" id=\"formToRogers\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"ProfileAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"selectedAccountNumber\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNum\"><br><input data-tl-private=\"\" type=\"text\" data-ng-model=\"accountNumber\" name=\"accountNumber\"><br><input type=\"text\" data-ng-model=\"briteBillInvoiceDates\" name=\"briteBillInvoiceDates\"></form></div><ute-user-if-any-granted data-roles=\"consumer\"><ute-floating-live-chat data-cbid=\"sc.floatingLiveChatSetting.cbid\" data-bold-chat-div=\"sc.floatingLiveChatSetting.boldChatDiv\" data-chat-button=\"sc.floatingLiveChatSetting.chatButton\"></ute-floating-live-chat></ute-user-if-any-granted>");
$templateCache.put("module/uteSmsRecoveryRogers/uteSmsRecoveryRogers.view.html","<div class=\"display-row ute-sms-recovery-rogers\" ng-if=\"$ctrl.isRecoveryApiFetched\"><span class=\"display-label\" data-ng-bind-html=\"\'ute.smsRecoveryRogers.root.loginRecoveryMobileNumber\' | translate\"></span><span class=\"ute-profile-edit-uap-button-edit recovery-interceptor visible-xs-inline-block\" data-ng-if=\"$ctrl.data.phone\"><i class=\"rui-icon-edit hidden-xs\"></i> <span data-translate=\"ute.common.label.edit\"></span></span> <span class=\"display-value\" data-ng-if=\"$ctrl.data.phone\">{{$ctrl.data.phone | phone}}</span><a href=\"javascript:\" data-ng-if=\"$ctrl.data.noPhone\" class=\"ute-sms-recovery-rogers-setup recovery-interceptor visible-xs-inline-block\">{{\'ute.smsRecoveryRogers.root.setupNow\' | translate }}</a> <span class=\"display-value\" data-ng-if=\"$ctrl.data.noPhone\">{{\'ute.smsRecoveryRogers.root.none\' | translate}}</span> <span class=\"ute-profile-edit-uap-button-edit recovery-interceptor hidden-xs\" data-ng-if=\"$ctrl.data.phone\"><i class=\"rui-icon-edit hidden-xs\"></i> <span data-translate=\"ute.common.label.edit\"></span></span><a href=\"javascript:\" data-ng-if=\"$ctrl.data.noPhone\" class=\"ute-sms-recovery-rogers-setup recovery-interceptor hidden-xs\">{{\'ute.smsRecoveryRogers.root.setupNow\' | translate }}</a></div>");
$templateCache.put("module/subscriptionBadge/subscriptionBadge.view.html","<div ng-include=\"subscriptionBadge.viewModel.template\"></div>");
$templateCache.put("module/suspendCtn/suspendCtnMain.RepView.view.html","<section><ui-view></ui-view><section class=\"ute-suspendCtnSuccess-faq\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 data-translate=\"ute.common.suspend.ctn.success.faq.title\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-suspendCtnSuccess-faq-question\" data-translate=\"ute.common.suspend.ctn.success.faq.question01_repview\"></div><div class=\"ute-suspendCtnSuccess-faq-answer\" data-translate=\"ute.common.suspend.ctn.success.faq.answer01\"></div><a data-ng-href=\"{{\'ute.common.suspend.ctn.success.faq.learnHowUrl\' | translate}}\" data-translate=\"ute.common.suspend.ctn.success.faq.learnHow\" target=\"_blank\"></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-suspendCtnSuccess-faq-question\" data-translate=\"ute.common.suspend.ctn.success.faq.question02_repview\"></div><div class=\"ute-suspendCtnSuccess-faq-answer\" data-translate=\"ute.common.suspend.ctn.success.faq.answer02\"></div></div></div></div></section></section>");
$templateCache.put("module/suspendCtn/suspendCtnMain.view.html","<section><ui-view></ui-view><ute-suspend-ctn-faq></ute-suspend-ctn-faq></section>");
$templateCache.put("module/transferOfResponsibility/transferOfResponsibilityMain.view.html","<section class=\"col-xs-12 ute-tor-margin-top ute-tor-margin-bottom\"><div class=\"container\"><ui-view class=\"col-xs-8\"></ui-view><div class=\"col-xs-4 col-sm-4\"><ute-nova-content screen-name=\"tor.screenName\"></ute-nova-content></div></div></section>");
$templateCache.put("module/uteUsageDial/usageDial.partial.html","<div class=\"ute-usageDial-container\" data-ng-style=\"{\'width\' : width + \'px\', \'height\': height + \'px\'}\"><div class=\"ute-usageDial-content\" data-ng-style=\"{\'width\' : width + \'px\', \'height\': height + \'px\'}\"><div class=\"ute-usageDial-contentContainer\"><div class=\"ute-usageDialContent-sharedData\" translate=\"ute.usageDial.sharedData\"></div><div class=\"ute-usageDialContent-remaining\" data-ng-bind-html=\"usageDial.getDialCopy() | translate : {overage : (usageDial.getDisplayData() + \' \' + (\'ute.usageDial.gb\' | translate))}\"></div><div class=\"ute-usageDialContent-realTime\" ng-if=\"!usageDial.isOverage()\" translate=\"ute.usageDial.realTime\"></div></div></div><ute-usage-dial-animated-stroke class=\"ute-animatedStrokeContainer\" data-ng-style=\"{\'width\' : width + \'px\', \'height\': height + \'px\'}\" data-percent-remaining=\"{{percentageRemaining}}\"></ute-usage-dial-animated-stroke></div>");
$templateCache.put("module/uteUsageDial/usageDialAnimatedStroke.partial.html","<canvas class=\"ute-usageDialChart\" width=\"{{width}}px\" height=\"{{height}}px\"></canvas>");
$templateCache.put("module/wirelessProductDiscountDetailsDirective/wirelessProductDiscountDetails.html","<div class=\"row\"><div class=\"col-xs-12 discounts-section\"><div class=\"col-xs-12\"><div class=\"discount-details\"><div class=\"col-xs-12 discount-header\"><div class=\"col-xs-12\"><h3 translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.discounts\"></h3></div></div><div class=\"col-xs-12 discount-details-section\"><div class=\"discount-details-header\"><div class=\"col-xs-5\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.description\"></span></div><div class=\"col-xs-3\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.discountCode\"></span></div><div class=\"col-xs-4\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.appliesSocCode\"></span></div></div><div class=\"row discount-details-body\" ng-repeat=\"discount in productDiscountDetails | filter: wirelessProductDiscountDetails.discountsFilter\"><span ng-show=\"false\" ng-init=\"wirelessProductDiscountDetails.hasWirelessDiscounts = $index\"></span><div class=\"col-xs-5\"><span ng-if=\"wirelessProductDiscountDetails.lang === \'en\'\" class=\"col-xs-12\">{{::discount.desc}}</span> <span ng-if=\"wirelessProductDiscountDetails.lang === \'fr\'\" class=\"col-xs-12\">{{::discount.descFr}}</span><div class=\"col-xs-11 details-marginTop5\"><span ng-if=\"wirelessProductDiscountDetails.hasEffectiveDate(discount)\" class=\"col-xs-12 col-md-5 col-lg-5\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.effectiveDate\"></span>{{::discount.effectiveDate| date:\'MM/dd/yyyy\'}}</span> <span ng-if=\"wirelessProductDiscountDetails.hasEffectiveDate(discount) && wirelessProductDiscountDetails.hasExpiryDate(discount)\" class=\"visible-lg visible-md col-xs-1 date-pipe\">&nbsp;|</span> <span ng-if=\"wirelessProductDiscountDetails.hasExpiryDate(discount)\" class=\"col-xs-12 col-md-6 col-lg-6\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.expirationDate\"></span>{{::discount.expiryDate | date:\'MM/dd/yyyy\'}}</span></div></div><div class=\"col-xs-3\"><span>{{::discount.code}}</span></div><div class=\"col-xs-4\"><span ng-hide=\"discount.discountSoc.length === 0\" class=\"\">{{::discount.discountSoc}}</span> <span ng-show=\"discount.discountSoc.length === 0\" translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.notApplicable\"></span></div></div><div class=\"discount-details-not-available\" ng-if=\"wirelessProductDiscountDetails.hasWirelessDiscounts === -1\"><div class=\"col-xs-12 text-center\"><span translate=\"ute.rogers.wireless.wirelessProductDiscountDetails.noSocAvailable\"></span></div></div></div></div></div></div></div>");
$templateCache.put("module/actionsOffers/actionsOffersBounds/in-out-bounds-tabs.html","<div class=\"container\"><div class=\"relative-align tab-section\"><div class=\"row\"><div class=\"col-xs-2 pull-left top-margin heading-styles\"><span ng-if=\"$parent.actionsOffers.inboundsCopyList.length>0 || $parent.actionsOffers.outboundsCopyList.length>0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.offers\"></span></span> <span ng-if=\"$parent.actionsOffers.inboundsCopyList.length === 0 && $parent.actionsOffers.outboundsCopyList.length === 0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.offers\"></span> (0)</span></div><div ng-show=\"$parent.actionsOffers.inboundsCopyList.length>0 || $parent.actionsOffers.outboundsCopyList.length>0\"><div class=\"col-xs-9 pull-right top-margin srchBxLtAlign\"><div class=\"col-xs-6 searchBoxWidth\"><input type=\"text\" class=\"search-box\" placeholder=\"{{\'ute.rogers.actionsOffers.actionsOffersBounds.searchPlaceholder\'| translate}}\" ng-keyup=\"$parent.actionsOffers.searchedValue ? ($event.keyCode==13 ? $parent.actionsOffers.searchOffers($parent.actionsOffers.searchedValue) : angular.noop()): $parent.actionsOffers.searchNothingDefault()\" ng-model=\"$parent.actionsOffers.searchedValue\"></div><div class=\"col-xs-offset-1 col-xs-2 srchBtnDiv srchBxNBtnGap\"><div class=\"search-offers searchButtonWidth\" ng-click=\"$parent.actionsOffers.searchOffers($parent.actionsOffers.searchedValue)\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.searchOffers\"></span></div></div></div><span ng-show=\"false\">{{ibCount = $parent.actionsOffers.inboundsCopyList.length}} {{obCount = $parent.actionsOffers.outboundsCopyList.length}} {{inbounds = $parent.actionsOffers.actionsOffersService.getConfig().constants.inbounds}}</span><div ng-show=\"!$parent.actionsOffers.loadingOffers\" ng-click=\"$parent.actionsOffers.clearSearchbox()\"><tabset class=\"col-xs-12 tab-container custom-tabs\" type=\"{{type}}\" vertical=\"{{vertical}}\" justified=\"{{justified}}\"><tab class=\"tab\" ng-repeat=\"tab in tabs\" heading=\"{{tab.route === inbounds ? (tab.content + \' (\'+ibCount+\')\') : (tab.content + \' (\'+obCount+\')\')}}\" active=\"tab.active\" ng-click=\"go(tab.route, tab.params, tab.options)\"></tab></tabset></div></div></div><div class=\"widget-loader-inline\" ng-show=\"$parent.actionsOffers.loadingOffers\"><img src=\"ute-actions-offers/assets/widget-loader.gif\" alt=\"\"></div><div ng-if=\"($parent.actionsOffers.inboundsCopyList.length === 0 && $parent.actionsOffers.outboundsCopyList.length === 0 && !$parent.actionsOffers.loadingOffers)\"><div class=\"col-md-4 noActionsOffersContentBorder\"><div class=\"col-md-2\"><img class=\"actionsWidgetContent\" src=\"ute-actions-offers/assets/no-action-offers.png\"></div><div class=\"col-md-10 actionsWidgetError\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.noOffers\"></span></div></div></div></div></div>");
$templateCache.put("module/actionsOffers/actionsOffersBounds/offers-inbounds.html","<section ng-show=\"!actionsOffers.loadingOffers && actionsOffers.inboundsCopyList.length > 0\"><div class=\"container boundsMainDiv\"><div class=\"statusClass\"><div class=\"col-sm-8\"><div class=\"row statusLobHead\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.byStatus\"></span></div><div class=\"row checkRow\"><label class=\"checkbox-inline checkbox-all-padding\"><input type=\"checkbox\" class=\"checkBoxClass\" id=\"allInbound\" ng-click=\"actionsOffers.toggleAll()\" ng-model=\"actionsOffers.isAllSelected\"> <label for=\"allInbound\" class=\"checkBoxLabel\"></label> <span class=\"checkText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.all\"></span></span></label> <label ng-repeat=\"checkboxItem in actionsOffers.checkboxItems\" class=\"checkbox-inline\"><input type=\"checkbox\" class=\"checkBoxClass\" value=\"{{checkboxItem}}\" id=\"{{checkboxItem}}Box\" ng-change=\"actionsOffers.optionToggled()\" ng-model=\"actionsOffers.checkBoxModel[checkboxItem]\"> <label for=\"{{checkboxItem}}Box\" class=\"checkBoxLabel\"></label> <span class=\"checkText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{checkboxItem.toLowerCase()}}\"></span></span></label></div></div><div class=\"col-sm-4\"><div class=\"row statusLobHead lobStatusHeadAlign\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.lineOfBusiness\"></span></div><div class=\"row ddRow\"><div class=\"dropdown-search col-sm-9 col-md-8\"><div class=\"styled-select col-xs-12 col-sm-5 col-md-4 filterBoxWd\"><select class=\"rui-dropdown col-xs-12 filterFont\" ng-model=\"offersDropdown\" ng-options=\"eachInboundList as eachInboundList.lobDescription for eachInboundList in actionsOffers.filterLobDescList(actionsOffers.inboundsCopyList) | unique:\'lobDescription\'\"><option value=\"\" translate=\"filter_all\"></option></select></div></div></div></div></div><div ng-repeat=\"inBoundOffersListDetails in actionsOffers.displayInboundsList\" ng-show=\"false\"><div ng-if=\"inBoundOffersListDetails.lastDispositionCode && inBoundOffersListDetails.lastDispositionCode.toLowerCase() === actionsOffers.actionsOffersService.getConfig().constants.interested && inBoundOffersListDetails.expired\">{{actionsOffers.expiredInt=true}}</div><div ng-if=\"inBoundOffersListDetails.lastDispositionCode.toLowerCase() === actionsOffers.actionsOffersService.getConfig().constants.accepted && inBoundOffersListDetails.expired\">{{actionsOffers.expiredAcc=true}}</div><div ng-if=\"inBoundOffersListDetails.lastDispositionCode.toLowerCase() === actionsOffers.actionsOffersService.getConfig().constants.declined && inBoundOffersListDetails.expired\">{{actionsOffers.expiredDec=true}}</div></div><div class=\"offers-scroll\" id=\"style-1\"><div ng-repeat=\"offerType in actionsOffers.checkboxItems\" ng-if=\"$index < actionsOffers.checkboxItems.length-1\"><div class=\"panel-group offersSection\" ng-if=\"actionsOffers.checkBoxModel[offerType] || (actionsOffers.checkBoxModel[actionsOffers.actionsOffersService.getConfig().constants.expiredCase]? (actionsOffers.isHavingExpired(offerType)) : false)\"><div class=\"panel\" ng-show=\"actionsOffers.hidePanels(actionsOffers.displayInboundsList,offerType,offersDropdown.lobDescription)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a data-toggle=\"collapse\" href=\"#{{offerType}}\" target=\"_blank\" class=\"offersNav\"><img alt=\"Image\" class=\"offersNavIcon\" src=\"ute-actions-offers/assets/offers-nav.png\"> <span class=\"offersNavText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{offerType.toLowerCase()}}\"></span></span></a></h4></div><div ng-attr-id=\"{{offerType}}\" class=\"panel-collapse collapse in\"><div class=\"list-group\"><div ng-repeat=\"inBoundOffersListDetails in actionsOffers.displayInboundsList | filter : {lobDescription : offersDropdown.lobDescription}: true\"><div ng-if=\"inBoundOffersListDetails.lastDispositionCode.toLowerCase() === offerType.toLowerCase() ? (inBoundOffersListDetails.expired ? actionsOffers.checkBoxModel[actionsOffers.actionsOffersService.getConfig().constants.expiredCase] : actionsOffers.checkBoxModel[offerType] ):false\"><span ng-if=\"actionsOffers.getDispStatus(inBoundOffersListDetails.treatmentId) != null ? updatedDispValue = actionsOffers.getDispStatus(inBoundOffersListDetails.treatmentId).toLowerCase() : updatedDispValue = inBoundOffersListDetails.lastDispositionCode.toLowerCase()\"></span><div class=\"offersData\" ng-click=\"actionsOffers.selectPanel($index, inBoundOffersListDetails)\" ng-class=\"{\'applyRed\' : actionsOffers.displayDiv($index) === true}\"><span class=\"widget-loader-inline dispLoadingOffers\" ng-show=\"actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId]\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"offersTextSection1\" ng-class=\"{\'aoShowOpacity\':actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId]}\"><div class=\"col-sm-1 offerIcon\" ng-if=\"inBoundOffersListDetails.treatmentImageFile.length>0\"><img alt=\"Image\" class=\"offer-img\" ng-src=\"{{inBoundOffersListDetails.treatmentImageFile}}\"></div><div class=\"col-sm-10 offerHeadClass\"><div class=\"offerHeadTitle\"><span class=\"offerTypeClass\" ng-class=\'inBoundOffersListDetails.treatmentTypeColor.toLowerCase()+\"Offer\"\'>{{inBoundOffersListDetails.treatmentType}}</span> <span class=\"pipe-grey\">&#124;</span> <span class=\"offerNameClass\">{{inBoundOffersListDetails.treatmentTitle}}</span></div><div ng-if=\"inBoundOffersListDetails.lastDispositionCode.toLowerCase() !== actionsOffers.actionsOffersService.getConfig().constants.available\"><div class=\"expireClass\"><span ng-if=\"inBoundOffersListDetails.displayDisposition && inBoundOffersListDetails.transactionDate\"><span ng-if=\"inBoundOffersListDetails.dynamicValue\">{{inBoundOffersListDetails.displayDisposition}}</span> <span ng-if=\"!inBoundOffersListDetails.dynamicValue\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{inBoundOffersListDetails.displayDisposition.toLowerCase()}}\"></span></span> <span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.on\"></span> {{inBoundOffersListDetails.transactionDate | date:\'MMMM d, yyyy\'}}.</span> <span ng-if=\"inBoundOffersListDetails.expired && inBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiredOn\"></span> {{inBoundOffersListDetails.offerExpiryDate}}</span> <span ng-if=\"(!inBoundOffersListDetails.expired) && inBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiresOn\"></span> {{inBoundOffersListDetails.offerExpiryDate}}</span></div></div><div ng-if=\"inBoundOffersListDetails.lastDispositionCode.toLowerCase() === actionsOffers.actionsOffersService.getConfig().constants.available\"><div class=\"expireClass\" ng-if=\"(!inBoundOffersListDetails.expired) && inBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiresOn\"></span> {{inBoundOffersListDetails.offerExpiryDate}}</div><div class=\"expireClass\" ng-if=\"inBoundOffersListDetails.expired && inBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiredOn\"></span> {{inBoundOffersListDetails.offerExpiryDate}}</div></div></div></div><div class=\"offersTextSection2\" ng-class=\"{\'aoShowOpacity\':actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId]}\"><span ng-bind-html=\"inBoundOffersListDetails.treatmentDescription\"></span></div><div class=\"offersDispositions pull-right\"><div ng-if=\"!inBoundOffersListDetails.expired || inBoundOffersListDetails.expired === null || inBoundOffersListDetails.expired === \'\'\" class=\"dispositionButtonsMargin\"><span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffers.actionsOffersService.getConfig().constants.available\"><span class=\"offerAccept\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.accepted) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.interested) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.declined) >= 0\" ng-click=\"$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.showDeclineDiv($index, inBoundOffersListDetails.treatmentId)\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffers.actionsOffersService.getConfig().constants.interested\"><span class=\"offerAccept\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.accepted) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.accepted}}</md-tooltip></span> <span class=\"offerInterested\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.interested) >= 0\" ng-click=\"$event.stopPropagation()\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.declined) >= 0\" ng-click=\"$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.showDeclineDiv($index, inBoundOffersListDetails.treatmentId)\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffers.actionsOffersService.getConfig().constants.accepted\"><span ng-if=\"offerType === actionsOffers.actionsOffersService.getConfig().constants.availableCase || offerType === actionsOffers.actionsOffersService.getConfig().constants.interestedCase\"><span class=\"offerAccepted\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.accepted) >= 0\" ng-click=\"$event.stopPropagation()\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.interested) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.declined) >= 0\" ng-click=\"$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.showDeclineDiv($index, inBoundOffersListDetails.treatmentId)\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.declined}}</md-tooltip></span></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffers.actionsOffersService.getConfig().constants.declined\"><span ng-if=\"offerType === actionsOffers.actionsOffersService.getConfig().constants.availableCase || offerType === actionsOffers.actionsOffersService.getConfig().constants.interestedCase\"><span class=\"offerAccept\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.accepted) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.interested) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.interested}}</md-tooltip></span> <span class=\"offerDeclined\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.declined) >= 0\" ng-click=\"$event.stopPropagation()\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.declined}}</md-tooltip></span></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffers.actionsOffersService.getConfig().constants.tempdeclined\"><span ng-if=\"offerType === actionsOffers.actionsOffersService.getConfig().constants.availableCase || offerType === actionsOffers.actionsOffersService.getConfig().constants.interestedCase\"><span class=\"offerAccept\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.accepted) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.interested) >= 0\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.interested}}</md-tooltip></span> <span class=\"offerDeclined\" ng-show=\"inBoundOffersListDetails.dispositionsInbound.indexOf(actionsOffers.declined) >= 0\" ng-click=\"$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreDispState(inBoundOffersListDetails.treatmentId)\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffers.declined}}</md-tooltip></span></span></span><span ng-repeat=\"eachValue in inBoundOffersListDetails.dynamicValues\"><span class=\"dynamic-buttons\" ng-class=\"{\'ao-removeMarginRight\': inBoundOffersListDetails.dynamicValues.length - 1 == $index}\" ng-if=\"updatedDispValue !== inBoundOffersListDetails.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\'$event.stopPropagation(); !actionsOffers.loadingDisposition[inBoundOffersListDetails.treatmentId] && actionsOffers.restoreAndUpdateDisposition(inBoundOffersListDetails, inBoundOffersListDetails.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</span> <span class=\"dynamic-buttons-selected\" ng-class=\"{\'ao-removeMarginRight\': inBoundOffersListDetails.dynamicValues.length - 1 == $index}\" ng-if=\"updatedDispValue === inBoundOffersListDetails.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\"$event.stopPropagation()\">{{eachValue}}</span></span></div></div><div class=\"declineReasonDiv\" ng-if=\"actionsOffers.displayDiv($index)\" ng-click=\"$event.stopPropagation()\"><div class=\"offersTextSection1\"><div class=\"textareaHead\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclined\"></span></div><div class=\"row col-md-12 col-lg-12\"><div class=\"textareaReason row col-md-9 col-lg-9\"><textarea placeholder=\"{{\'ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclinedPlaceHolder\' | translate}}\" class=\"declineReasonText\" ng-model=\"declineReason\" [name=\"declineReason\" ]=\"\" [ng-minlength=\"1\" [ng-maxlength=\"500\"></textarea></div><div class=\"offersDeclineBtns row col-md-2 col-lg-2\"><a class=\"cancelBtn\" ng-click=\"$event.stopPropagation(); actionsOffers.restoreDispState()\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.cancel\"></span></a> <span class=\"declineBtn\" ng-click=\"$event.stopPropagation(); actionsOffers.declineDisposition(inBoundOffersListDetails, actionsOffers.actionsOffersService.getConfig().constants.declinedCase, declineReason)\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.declined\"></span></span></div></div></div></div></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("module/actionsOffers/actionsOffersBounds/offers-outbounds.html","<section ng-show=\"!actionsOffers.loadingOffers && actionsOffers.outboundsCopyList.length > 0\"><div class=\"container boundsMainDiv\"><div class=\"statusClass\"><div class=\"col-sm-8\"><div class=\"row statusLobHead\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.byStatus\"></span></div><div class=\"row checkRow\"><label class=\"checkbox-inline checkbox-all-padding\"><input type=\"checkbox\" class=\"checkBoxClass\" id=\"allOutbound\" ng-click=\"actionsOffers.toggleAllOutbound()\" ng-model=\"actionsOffers.isAllSelectedOutbound\"> <label for=\"allOutbound\" class=\"checkBoxLabel\"></label> <span class=\"checkText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.all\"></span></span></label> <label ng-repeat=\"checkboxItem in actionsOffers.outboundCheckboxItems\" class=\"checkbox-inline\"><input type=\"checkbox\" class=\"checkBoxClass\" value=\"{{checkboxItem}}\" id=\"{{checkboxItem}}Box\" ng-change=\"actionsOffers.optionToggledOutbound()\" ng-model=\"actionsOffers.outboundCheckBoxModel[checkboxItem]\"> <label for=\"{{checkboxItem}}Box\" class=\"checkBoxLabel\"></label> <span class=\"checkText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{checkboxItem.toLowerCase() | remove_spaces}}\"></span></span></label></div></div><div class=\"col-sm-4\"><div class=\"row statusLobHead lobStatusHeadAlign\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.lineOfBusiness\"></span></div><div class=\"row ddRow\"><div class=\"dropdown-search col-sm-9 col-md-8\"><div class=\"styled-select col-xs-12 col-sm-5 col-md-4 filterBoxWd\"><select class=\"rui-dropdown col-xs-12 filterFont\" ng-model=\"offersDropdown\" ng-options=\"eachOutboundList as eachOutboundList.lobDescription for eachOutboundList in actionsOffers.filterLobDescList(actionsOffers.outboundsCopyList) | unique:\'lobDescription\'\"><option value=\"\" translate=\"filter_all\"></option></select></div></div></div></div></div><div ng-repeat=\"outBoundOffersListDetails in actionsOffers.displayOutboundsList\" ng-show=\"false\"><div ng-if=\"outBoundOffersListDetails.channelName.toLowerCase() == actionsOffers.actionsOffersService.getConfig().constants.sms.toLowerCase() && outBoundOffersListDetails.expired\">{{actionsOffers.expiredSMS=true}}</div><div ng-if=\"outBoundOffersListDetails.channelName.toLowerCase() == actionsOffers.actionsOffersService.getConfig().constants.email.toLowerCase() && outBoundOffersListDetails.expired\">{{actionsOffers.expiredEmail=true}}</div><div ng-if=\"outBoundOffersListDetails.channelName.toLowerCase() == actionsOffers.actionsOffersService.getConfig().constants.directmail.toLowerCase() && outBoundOffersListDetails.expired\">{{actionsOffers.expiredDirectMail=true}}</div><div ng-if=\"outBoundOffersListDetails.channelName.toLowerCase() == actionsOffers.actionsOffersService.getConfig().constants.telemarketing.toLowerCase() && outBoundOffersListDetails.expired\">{{actionsOffers.expiredTeleMar=true}}</div></div><div class=\"offers-scroll\" id=\"style-1\"><div ng-repeat=\"offerType in actionsOffers.outboundCheckboxItems\" ng-if=\"$index < actionsOffers.outboundCheckboxItems.length-1\"><div class=\"panel-group offersSection\" ng-if=\"actionsOffers.outboundCheckBoxModel[offerType] || (actionsOffers.outboundCheckBoxModel[actionsOffers.actionsOffersService.getConfig().constants.expiredCase]? (actionsOffers.isHavingExpiredOutbound(offerType)) : false)\"><div class=\"panel\" ng-show=\"actionsOffers.hidePanels(actionsOffers.displayOutboundsList,offerType,offersDropdown.lobDescription)\"><div class=\"panel-heading\"><h4 class=\"panel-title\"><a data-toggle=\"collapse\" href=\"#{{offerType | remove_spaces}}\" target=\"_blank\" class=\"offersNav\"><img alt=\"Image\" class=\"offersNavIcon\" src=\"ute-actions-offers/assets/offers-nav.png\"> <span class=\"offersNavText\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{offerType.toLowerCase() | remove_spaces}}\"></span></span></a></h4></div><div ng-attr-id=\"{{offerType | remove_spaces}}\" class=\"panel-collapse collapse in\"><div class=\"list-group\"><div ng-repeat=\"outBoundOffersListDetails in actionsOffers.displayOutboundsList | filter : {lobDescription : offersDropdown.lobDescription}: true\"><div ng-if=\"outBoundOffersListDetails.channelName.toLowerCase() == offerType.toLowerCase() ? (outBoundOffersListDetails.expired ? actionsOffers.outboundCheckBoxModel[actionsOffers.actionsOffersService.getConfig().constants.expiredCase] : actionsOffers.outboundCheckBoxModel[offerType] ):false\"><div class=\"offersData\"><div class=\"offersTextSection1\"><div class=\"col-sm-1 offerIcon\" ng-if=\"outBoundOffersListDetails.treatmentImageFile.length>0\"><img alt=\"Image\" class=\"offer-img\" ng-src=\"{{outBoundOffersListDetails.treatmentImageFile}}\"></div><div class=\"col-sm-10 offerHeadClass\"><div class=\"offerHeadTitle\"><span class=\"offerTypeClass\" ng-class=\'outBoundOffersListDetails.treatmentTypeColor.toLowerCase()+\"Offer\"\'>{{outBoundOffersListDetails.treatmentType}}</span> <span class=\"pipe-grey\">&#124;</span> <span class=\"offerNameClass\">{{outBoundOffersListDetails.treatmentTitle}}</span></div><div class=\"expireClass\" ng-if=\"!outBoundOffersListDetails.expired\"><span ng-if=\"outBoundOffersListDetails.transactionDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{outBoundOffersListDetails.channelName.toLowerCase() | remove_spaces}}\"></span> <span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.on\"></span> {{outBoundOffersListDetails.transactionDate | date:\'MMMM d, yyyy\'}}.</span> <span ng-if=\"outBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiresOn\"></span> {{outBoundOffersListDetails.offerExpiryDate}}</span></div><div class=\"expireClass\" ng-if=\"outBoundOffersListDetails.expired\"><span ng-if=\"outBoundOffersListDetails.transactionDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.{{outBoundOffersListDetails.channelName.toLowerCase() | remove_spaces}}\"></span> <span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.on\"></span> {{outBoundOffersListDetails.transactionDate | date:\'MMMM d, yyyy\'}}.</span> <span ng-if=\"outBoundOffersListDetails.offerExpiryDate\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.expiredOn\"></span> {{outBoundOffersListDetails.offerExpiryDate}}</span></div></div></div><div class=\"offersTextSection2\"><span ng-bind-html=\"outBoundOffersListDetails.treatmentDescription\"></span></div></div></div></div></div></div></div></div></div></div></div></section>");
$templateCache.put("module/actionsOffers/actionsOffersDirective/actionsOffers.html","<div ng-show=\"!(actionsOffers.activeTreatmnentsFailed && actionsOffers.treatmentHistoryFailed)\"><section class=\"container actions-section\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"col-xs-2 pull-left top-margin heading-styles\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.actions\"></span>&nbsp;({{actionsOffers.displayActionsList.length}})</div><div ng-show=\"actionsOffers.displayActionsList.length !== 0\" class=\"actionBlockAlign\"><div class=\"owl-carousel col-xs-12\" ng-if=\"actionsOffers.displayActionsList.length !==0\"><div custom-owl-carousel-item=\"\" ng-repeat=\"eachAction in actionsOffers.displayActionsList\" class=\"item eachActionBlock\"><span class=\"widget-loader-inline dispLoadingActions\" ng-show=\"actionsOffers.loadingDisposition[eachAction.treatmentId]\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"actions-container-box\"><div ng-attr-id=\"{{\'action-block-\' + eachAction.treatmentId}}\" class=\"action-block\"><div class=\"row action-block-content\" ng-attr-id=\"{{\'action-block-content-\' + eachAction.treatmentId}}\"><div class=\"col-xs-12 action-description\" ng-class=\"{\'aoShowOpacity\':actionsOffers.loadingDisposition[eachAction.treatmentId]}\"><div class=\"col-xs-1\" ng-if=\"eachAction.treatmentImageFile.length > 0\"><img class=\"action-img-width\" ng-src=\"{{eachAction.treatmentImageFile}}\"></div><div class=\"col-xs-11 header-margin-bottom\"><span class=\"action-header\" ng-class=\'eachAction.treatmentTypeColor.toLowerCase()+\"Action\"\'>{{eachAction.treatmentType}}</span> <span class=\"pipe-grey\">&#124;</span> <span class=\"action-short-desc\">{{eachAction.treatmentTitle}}</span></div></div><div ng-attr-id=\"{{\'action-content-\' + eachAction.treatmentId}}\" class=\"col-xs-12 action-content\" ng-class=\"{\'aoShowOpacity\':actionsOffers.loadingDisposition[eachAction.treatmentId]}\"><span ng-bind-html=\"eachAction.treatmentDescription\"></span></div></div><div class=\"row show-more-detail\" ng-attr-id=\"{{\'show-more-\' + eachAction.treatmentId}}\" ng-if=\"actionsOffers.haveMoreActionContent(eachAction.treatmentId)\" ng-click=\"actionsOffers.toggleDetails(eachAction.treatmentId, true)\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.showFullDetails\"></span> <span class=\"more-less-icon\"><i class=\"rui-icon-chevron-down\"></i></span></div><div class=\"row show-more-detail\" ng-attr-id=\"{{\'show-less-\' + eachAction.treatmentId}}\" ng-click=\"actionsOffers.toggleDetails(eachAction.treatmentId, false)\"></div></div><div class=\"col-xs-3 pull-right confirmation-block actionsDispositions\"><span ng-show=\"false\">{{updatedAction = actionsOffers.getDispStatus(eachAction.treatmentId) ? actionsOffers.getDispStatus(eachAction.treatmentId).toLowerCase() : eachAction.lastDispositionCode.toLowerCase()}}</span><span ng-repeat=\"eachValue in eachAction.dynamicValues\"><span class=\"dynamic-buttons\" ng-class=\"{\'ao-removeMarginRight\': eachAction.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction !== eachAction.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\'!actionsOffers.loadingDisposition[eachAction.treatmentId] && actionsOffers.updateDispositionMethod(eachAction, eachAction.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</span> <span class=\"dynamic-buttons-selected\" ng-class=\"{\'ao-removeMarginRight\': eachAction.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction === eachAction.dispositionsInboundCodes[eachValue].toLowerCase()\">{{eachValue}}</span></span></div></div></div></div></div><div class=\"widget-loader-inline\" ng-show=\"actionsOffers.loadingActions\"><img src=\"ute-actions-offers/assets/widget-loader.gif\" alt=\"\"></div></div><div ng-show=\"actionsOffers.displayActionsList.length === 0 && !actionsOffers.loadingActions\"><div class=\"col-md-4 noActionsOffersContentBorder\"><div class=\"col-md-2\"><img class=\"actionsWidgetContent\" src=\"ute-actions-offers/assets/no-action-offers.png\"></div><div class=\"col-md-10 actionsWidgetError\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.noActions\"></span></div></div></div></div></section><div class=\"row tab-section-grey\" ng-class=\"{\'tab-section-none\':actionsOffers.inboundsCopyList.length === 0 && actionsOffers.outboundsCopyList.length === 0}\"><tabs data=\"actionsOffers.tabData\" type=\"tabs\" justified=\"true\" template-url=\"module/actionsOffers/actionsOffersBounds/in-out-bounds-tabs.html\"></tabs></div><div class=\"container offers-section\"><div class=\"row\" ui-view=\"bounds\"></div></div></div><div ng-show=\"actionsOffers.activeTreatmnentsFailed && actionsOffers.treatmentHistoryFailed\"><section class=\"container\"><div class=\"col-md-10 actionOffersErrorBorder\"><div class=\"col-md-3 actionsWidgetErrorContent\"><img class=\"errorImg\" src=\"ute-actions-offers/assets/alert.png\"></div><div class=\"col-md-11\"><span ng-if=\"actionsOffers.errorDesc.length > 0\">{{actionsOffers.errorDesc}}</span> <span ng-if=\"actionsOffers.errorDesc.length === 0\"><span ng-if=\"actionsOffers.errorCode.length > 0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.genericErrorNoCode\"></span>&nbsp;{{actionsOffers.errorCode}}</span> <span ng-if=\"actionsOffers.errorCode.length === 0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.genericError\"></span></span></span></div></div></section></div>");
$templateCache.put("module/actionsOffers/actionsOffersWidgetDirective/actionsOffersWidget.html","<div class=\"ute-ao-directive-widget col-xs-12\"><div class=\"offersHeading redcolor row ute-ao-border-line\"><div class=\"col-xs-8\"><h4><span translate=\"actions_and_offers\"></span></h4></div><div class=\"seeAllPad\"><button ng-click=\"actionsOffersWidget.seeAll()\" class=\"filter-btn filterAll filterAllFont col-xs-4\" type=\"button\" name=\"button_continue\" ng-show=\"!actionsOffersWidget.loading\"><span translate=\"filter_all\"></span></button></div><span class=\"widget-loader-inline\" ng-show=\"actionsOffersWidget.loading\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div ng-if=\"true\" ng-show=\"!actionsOffersWidget.treatmentsNotAvailable && !actionsOffersWidget.loading\"><div ng-show=\"!actionsOffersWidget.getProductTreatmentResponse.getProductTreatmentDetailsList.length==0\"><div class=\"mt-10\" ng-class=\"{\'ute-ao-panel-scroll\': actionsOffersWidget.getProductTreatmentResponse.getProductTreatmentDetailsList.length > 5}\"><div class=\"panel-group row col-lg-12 col-md-12 col-sm-12 treatmentPanel-group\" id=\"accordion\"><div class=\"panel interactionPointer\" ng-repeat=\"treatment in actionsOffersWidget.getProductTreatmentResponse.getProductTreatmentDetailsList\" ng-class=\"{\'applyRed\' : actionsOffersWidget.displayDiv($index) === true , \'treatment-panel-selected\' : actionsOffersWidget.isPanelSelected($index), \'treatment-panel\' : !actionsOffersWidget.isPanelSelected($index)}\"><span class=\"widget-loader-inline dispLoaderWidget\" ng-show=\"actionsOffersWidget.loadingDisposition[treatment.treatmentId]\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"row ute-ao-treatment-content\" ng-class=\"{\'disabled\' : actionsOffersWidget.loadingDisposition[treatment.treatmentId]}\"><div ng-if=\"treatment.treatmentImageFile.length > 0\" class=\"col-md-1 col-xs-3 ute-ao-iconPadding {{getIcon(i.media,i.itemType);}}\"><img class=\"treatmentsImg\" ng-src=\"{{treatment.treatmentImageFile}}\"></div><div class=\"col-md-11 col-xs-9 contentPadding\" id=\"accHdr{{treatment.treatmentId}}\" ng-class=\"{\'\': $index !== (limitCount-1), \'aoShowOpacity\':actionsOffersWidget.loadingDisposition[treatment.treatmentId], \'contentPaddingNoImage\':!treatment.treatmentImageFile}\" ng-click=\"actionsOffersWidget.selectPanel($index, treatment)\" data-parent=\"#accordion\" data-toggle=\"collapse\" ng-href=\"#{{treatment.treatmentId}}\"><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oneview rep selects actions and offers - \"+treatment.treatmentId+\" - buttonType,event.inquiry\"}\'><div class=\"title-wrapper\"><span class=\"ute-ao-treatment-type\" ng-class=\'treatment.treatmentTypeColor.toLowerCase()+\"Offer\"\'>{{treatment.treatmentType}}</span> <span class=\"pipe-grey\">&#124;</span> <span class=\"ute-ao-treatment-title\" ng-bind-html=\"treatment.treatmentTitle\"></span></div><div class=\"ute-ao-treatment-desc\" ng-bind-html=\"actionsOffersWidget.trustHTML(treatment.treatmentDescription)\"></div><span ng-show=\"actionsOffersWidget.isPanelSelected($index)\" ng-if=\"(treatment.treatmentGroup | lowercase) === actionsOffersWidget.actionsOffersService.getConfig().constants.action\"><span class=\"close-icon\" aria-label=\"Close\"><span class=\"close-class\" aria-hidden=\"true\">&times;</span></span></span></span></div></div><div ng-show=\"!actionsOffersWidget.isPanelSelected($index)\" ng-if=\"(treatment.treatmentGroup | lowercase) == actionsOffersWidget.actionsOffersService.getConfig().constants.action\" class=\"col-xs-3 pull-right ute-ao-confirmation-block ute-ao-actionsDispositionsWidget\"><span ng-show=\"false\">{{updatedAction = actionsOffersWidget.getDispStatus(treatment.treatmentId) ? actionsOffersWidget.getDispStatus(treatment.treatmentId).toLowerCase() : treatment.lastDispositionCode.toLowerCase()}}</span><span ng-repeat=\"eachValue in treatment.dynamicValues\"><span class=\"dynamic-buttons\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction !== treatment.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.updateDispositionMethod(treatment, treatment.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</span> <span class=\"dynamic-buttons-selected\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction === treatment.dispositionsInboundCodes[eachValue].toLowerCase()\">{{eachValue}}</span></span></div><div ng-if=\"treatment.treatmentGroup && (treatment.treatmentGroup.toLowerCase() === actionsOffersWidget.actionsOffersService.getConfig().constants.offer || treatment.treatmentGroup.toLowerCase() == actionsOffersWidget.actionsOffersService.getConfig().constants.treatment) && treatment.offerExpiresIn\" class=\"expired-content pull-left col-xs-5 ng-binding ng-scope\" ng-class=\"{\'selectedPanelButtons\':actionsOffersWidget.displayDiv($index)}\">{{treatment.offerExpiresIn}}</div><div ng-show=\"!actionsOffersWidget.isPanelSelected($index)\" class=\"ute-ao-offersDispositionsWidget pull-right\" ng-class=\"{\'selectedPanelButtons\':actionsOffersWidget.displayDiv($index)}\" ng-if=\"(treatment.treatmentGroup | lowercase) === actionsOffersWidget.actionsOffersService.getConfig().constants.offer || treatment.treatmentGroup.toLowerCase() == actionsOffersWidget.actionsOffersService.getConfig().constants.treatment\"><span ng-if=\"actionsOffersWidget.getDispStatus(treatment.treatmentId) != null ? updatedDispValue = actionsOffersWidget.getDispStatus(treatment.treatmentId).toLowerCase() : updatedDispValue = (treatment.lastDispositionCode | lowercase)\"></span><div><span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffersWidget.actionsOffersService.getConfig().constants.available\"><span class=\"offerAccept\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.accepted) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.interested) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.declined) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.showDeclineDiv($index, treatment.treatmentId,\"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffersWidget.actionsOffersService.getConfig().constants.interested\"><span class=\"offerAccept\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.accepted) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.accepted}}</md-tooltip></span> <span class=\"offerInterested\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.interested) >= 0\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.declined) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.showDeclineDiv($index, treatment.treatmentId,\"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffersWidget.actionsOffersService.getConfig().constants.accepted\"><span class=\"offerAccepted\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.accepted) >= 0\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.interested) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.interested}}</md-tooltip></span> <span class=\"offerDecline\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.declined) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.showDeclineDiv($index, treatment.treatmentId,\"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffersWidget.actionsOffersService.getConfig().constants.declined\"><span class=\"offerAccept\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.accepted) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.interested) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.interested}}</md-tooltip></span> <span class=\"offerDeclined\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.declined) >= 0\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.declined}}</md-tooltip></span></span> <span class=\"dispSpacing\" ng-if=\"updatedDispValue === actionsOffersWidget.actionsOffersService.getConfig().constants.tempdeclined\"><span class=\"offerAccept\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.accepted) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.accepted}}</md-tooltip></span> <span class=\"offerInterest\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.interested) >= 0\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.interested}}</md-tooltip></span> <span class=\"offerDeclined\" ng-show=\"treatment.dispositionsInbound.indexOf(actionsOffersWidget.declined) >= 0\" ng-click=\"!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreDispState()\"><md-tooltip class=\"dispTooltip\" md-direction=\"bottom\">{{actionsOffersWidget.declined}}</md-tooltip></span></span><span class=\"displayDynamicButtons\"><span ng-repeat=\"eachValue in treatment.dynamicValues\"><span class=\"dynamic-buttons\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedDispValue !== treatment.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.restoreAndUpdateDisposition(treatment, treatment.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</span> <span class=\"dynamic-buttons-selected\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedDispValue === treatment.dispositionsInboundCodes[eachValue].toLowerCase()\">{{eachValue}}</span></span></span></div></div><div class=\"ute-ao-declineReasonDivWidget\" ng-if=\"actionsOffersWidget.displayDiv($index)\" ng-class=\"{\'declineBlockAlign\' : actionsOffersWidget.actionsOffersService.declineClickState === \'panel\'}\"><div class=\"offersTextSection1\"><div class=\"textareaHead\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclined\"></span></div><div class=\"row col-md-12 col-lg-12\"><div class=\"ute-offer-textareaReasonWidth row col-md-11 col-lg-11\"><textarea placeholder=\"{{\'ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclinedPlaceHolder\' | translate}}\" class=\"declineReasonText\" ng-model=\"declineReason\" [name=\"declineReason\" ]=\"\" [ng-minlength=\"1\" [ng-maxlength=\"500\"></textarea></div><div class=\"widgetDeclineBtns row col-md-6 col-lg-6\"><a class=\"cancelBtn\" ng-click=\"actionsOffersWidget.restoreDispState()\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.cancel\"></span></a> <span class=\"declineBtn\" ng-click=\"actionsOffersWidget.declineDisposition(treatment, actionsOffersWidget.actionsOffersService.getConfig().constants.declinedCase, declineReason)\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.declined\"></span></span></div></div></div></div><div ng-click=\"$event.stopPropagation()\" ng-if=\"(treatment.treatmentGroup | lowercase) === actionsOffersWidget.actionsOffersService.getConfig().constants.action\" id=\"{{treatment.treatmentId}}\" class=\"panel-collapse collapse ute-ao-treatment-collapse\"><div class=\"panel-body ute-ao-treatment-description\" ng-bind-html=\"treatment.treatmentDescription\"></div><div ng-if=\"(treatment.treatmentGroup | lowercase) === actionsOffersWidget.actionsOffersService.getConfig().constants.action\" class=\"col-xs-3 pull-right ute-ao-confirmation-block ute-ao-actionsDispositionsWidget expanded-confirmation\"><span ng-show=\"false\">{{updatedAction = actionsOffersWidget.getDispStatus(treatment.treatmentId) ? actionsOffersWidget.getDispStatus(treatment.treatmentId).toLowerCase() : treatment.lastDispositionCode.toLowerCase()}}</span><span ng-repeat=\"eachValue in treatment.dynamicValues\"><span class=\"dynamic-buttons\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction !== treatment.dispositionsInboundCodes[eachValue].toLowerCase()\" ng-click=\'!actionsOffersWidget.loadingDisposition[treatment.treatmentId] && actionsOffersWidget.updateDispositionMethod(treatment, treatment.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</span> <span class=\"dynamic-buttons-selected\" ng-class=\"{\'ao-removeMarginRight\': treatment.dynamicValues.length - 1 == $index}\" ng-if=\"updatedAction === treatment.dispositionsInboundCodes[eachValue].toLowerCase()\">{{eachValue}}</span></span></div></div><div ng-click=\"$event.stopPropagation()\" ng-if=\"(treatment.treatmentGroup | lowercase) === actionsOffersWidget.actionsOffersService.getConfig().constants.offer || treatment.treatmentGroup.toLowerCase() == actionsOffersWidget.actionsOffersService.getConfig().constants.treatment\" id=\"{{treatment.treatmentId}}\"></div></div></div></div></div><div class=\"actionsWidgetErrorBlock\" ng-show=\"actionsOffersWidget.getProductTreatmentResponse.getProductTreatmentDetailsList.length==0\"><div class=\"col-md-12 noActionsOffersWidgetBorder\"><div class=\"col-md-2 actionsWidgetContent\"><img class=\"errorImg\" src=\"ute-actions-offers/assets/no-action-offers.png\"></div><div class=\"col-md-10 actionsWidgetError\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.noActionsOffers\"></span></div></div></div></div><div class=\"actionsWidgetErrorBlock\" ng-show=\"actionsOffersWidget.treatmentsNotAvailable && !actionsOffersWidget.loading\"><div class=\"col-md-12 errorBorder\"><div class=\"col-md-3 actionsWidgetErrorContent\"><img class=\"errorImg\" src=\"ute-actions-offers/assets/alert.png\"></div><div class=\"col-md-9\"><span ng-if=\"actionsOffersWidget.errorDesc.length > 0\">{{actionsOffersWidget.errorDesc}}</span> <span ng-if=\"actionsOffersWidget.errorDesc.length === 0\"><span ng-if=\"actionsOffersWidget.errorCode.length > 0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.genericErrorNoCode\"></span> {{actionsOffersWidget.errorCode}}</span> <span ng-if=\"actionsOffersWidget.errorCode.length === 0\"><span translate=\"ute.rogers.actionsOffers.actionsOffersPanel.genericError\"></span></span></span></div></div></div></div>");
$templateCache.put("module/actionsOffers/actionsOffersWidgetDirective/offersWidgetPanel.html","<div class=\"container ute-offer-panel-container\"><div class=\"ute-ao-offer-panel modal-top\"><div class=\"ute-ao-offer-panel-grey\"><div><div><span class=\"ute-ao-panel-lobDesc\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.lobDescription\"></span> <span class=\"pipe-grey\">&#124;</span> <span class=\"ute-ao-panel-treatmentCode\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentCode\"></span> <span class=\"ute-ao-close-bg\" ng-click=\"offersWidgetPanel.close()\"><span class=\"ute-ao-close-text\">&times;</span></span></div><div><div class=\"title-desc\"><div id=\"ao-header\" class=\"ao-title\" ng-class=\"{\'ute-header-align\' : !toggle}\"><span class=\"ute-ao-panel-treatmentType\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentType\"></span> <span class=\"pipe-grey\">&#124;</span> <span class=\"ute-ao-panel-title\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentTitle\"></span></div><div id=\"ao-desc\" class=\"ute-ao-panel-desc overflow\" ng-class=\"{\'overflow\' : !toggle}\" ng-bind-html=\"offersWidgetPanel.trustHTML(offersWidgetPanel.selectedTreatment.treatmentDescription)\"></div><span ng-show=\"::offersWidgetPanel.checkOverflow()\" ng-click=\"toggle = !toggle\" ng-class=\"{\'expand-button\': !toggle, \'collapse-button\': toggle}\"></span></div><div class=\"ute-ao-offerExpiresIn\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.offerExpiresIn\"></div></div></div></div><div class=\"col-xs-12 ute-ao-circles\"><span class=\"ute-ao-circle-1 col-xs-2\" ng-show=\"offersWidgetPanel.selectedTreatment.offerExpiryDate\"><span class=\"ute-ao-circle-content\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.{{offersWidgetPanel.selectedTreatment.offerExpiryDate.toLowerCase() | first_word}}\"></span>&nbsp;{{offersWidgetPanel.selectedTreatment.offerExpiryDate | filter_date}}</span></span> <span class=\"ute-ao-circle-1 ute-ao-circle-image col-xs-2\" ng-show=\"offersWidgetPanel.selectedTreatment.treatmentImageFile\"><img alt=\"Image\" class=\"ute-ao-offer-image\" ng-src=\"{{offersWidgetPanel.selectedTreatment.treatmentImageFile}}\"></span> <span class=\"ute-ao-circle-1 col-xs-2\" ng-show=\"offersWidgetPanel.circleContent.indexOf(offersWidgetPanel.selectedTreatment.lastCommunicationChannel.toLowerCase())>=0\"><span ng-if=\"offersWidgetPanel.selectedTreatment.lastCommunicationChannel.toLowerCase() === offersWidgetPanel.actionsOffersService.getConfig().constants.sms.toLowerCase()\" class=\"ute-ao-circle-comm-channel\"><i class=\"rui-icon-live-chat\"></i></span> <span ng-if=\"offersWidgetPanel.selectedTreatment.lastCommunicationChannel.toLowerCase() === offersWidgetPanel.actionsOffersService.getConfig().constants.email.toLowerCase()\" class=\"ute-ao-circle-comm-channel\"><i class=\"rui-icon-email-v2\"></i></span> <span ng-if=\"offersWidgetPanel.selectedTreatment.lastCommunicationChannel.toLowerCase() === offersWidgetPanel.actionsOffersService.getConfig().constants.directmail.toLowerCase()\" class=\"ute-ao-circle-comm-channel\"><i class=\"rui-icon-letter-of-resignation\"></i></span> <span ng-if=\"offersWidgetPanel.selectedTreatment.lastCommunicationChannel.toLowerCase() === offersWidgetPanel.actionsOffersService.getConfig().constants.telemarketing.toLowerCase()\" class=\"ute-ao-circle-comm-channel\"><i class=\"rui-icon-person-call-v2\"></i></span></span> <span class=\"col-xs-4 pull-right savingAmtAlign\"><span class=\"ute-ao-savingsAmt\" ng-class=\'offersWidgetPanel.selectedTreatment.savingsAmountColor.toLowerCase()+\"Offer\"\' ng-bind-html=\"offersWidgetPanel.selectedTreatment.savingsAmount\"></span> <span class=\"ute-ao-savingsAmountText\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.savingsAmountText\"></span></span></div><span ng-if=\"offersWidgetPanel.getDispStatus(offersWidgetPanel.selectedTreatment.treatmentId) != null ? updatedDispValue = offersWidgetPanel.getDispStatus(offersWidgetPanel.selectedTreatment.treatmentId).toLowerCase() : updatedDispValue = offersWidgetPanel.selectedTreatment.lastDispositionCode.toLowerCase()\"></span><div class=\"col-xs-12 ute-ao-panel-btns\"><span ng-show=\"offersWidgetPanel.selectedTreatment.dispositionsInbound.indexOf(offersWidgetPanel.accepted) >= 0\"><span ng-if=\"updatedDispValue === offersWidgetPanel.actionsOffersService.getConfig().constants.accepted\"><button class=\"offerWidgetButtonClicked col-xs-4\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.accepted\"></span></button></span> <span ng-if=\"updatedDispValue !== offersWidgetPanel.actionsOffersService.getConfig().constants.accepted\"><button class=\"offerWidgetButton col-xs-4\" ng-click=\'offersWidgetPanel.updateDispositionMethod(offersWidgetPanel.selectedTreatment, offersWidgetPanel.actionsOffersService.getConfig().constants.acceptedCase, \"\")\'><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oneview rep selects actions and offers - \"+offersWidgetPanel.selectedTreatment.treatmentId+\" - accepted,event.inquiry\"}\' translate=\"ute.rogers.actionsOffers.actionsOffersBounds.accepted\"></span></button></span></span> <span ng-show=\"offersWidgetPanel.selectedTreatment.dispositionsInbound.indexOf(offersWidgetPanel.interested) >= 0\"><span ng-if=\"updatedDispValue === offersWidgetPanel.actionsOffersService.getConfig().constants.interested\"><button class=\"offerWidgetButtonClicked col-xs-4\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.interested\"></span></button></span> <span ng-if=\"updatedDispValue !== offersWidgetPanel.actionsOffersService.getConfig().constants.interested\"><button class=\"offerWidgetButton col-xs-4\" ng-click=\'offersWidgetPanel.updateDispositionMethod(offersWidgetPanel.selectedTreatment, offersWidgetPanel.actionsOffersService.getConfig().constants.interestedCase, \"\")\'><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oneview rep selects actions and offers - \"+offersWidgetPanel.selectedTreatment.treatmentId+\" - interested,event.inquiry\"}\' translate=\"ute.rogers.actionsOffers.actionsOffersBounds.interested\"></span></button></span></span> <span ng-show=\"offersWidgetPanel.selectedTreatment.dispositionsInbound.indexOf(offersWidgetPanel.declined) >= 0\"><span ng-if=\"updatedDispValue === offersWidgetPanel.actionsOffersService.getConfig().constants.declined\"><button class=\"offerWidgetButtonClicked col-xs-4\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.declined\"></span></button></span> <span ng-if=\"updatedDispValue !== offersWidgetPanel.actionsOffersService.getConfig().constants.declined\"><button class=\"offerWidgetButton col-xs-4\" ng-click=\"offersWidgetPanel.showDeclineDiv()\"><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"oneview rep selects actions and offers - \"+offersWidgetPanel.selectedTreatment.treatmentId+\" - declined,event.inquiry\"}\' translate=\"ute.rogers.actionsOffers.actionsOffersBounds.declined\"></span></button></span></span> <span ng-repeat=\"eachValue in offersWidgetPanel.selectedTreatment.dynamicValues\"><span ng-if=\"updatedDispValue === offersWidgetPanel.selectedTreatment.dispositionsInboundCodes[eachValue].toLowerCase()\"><button class=\"offerWidgetButtonClicked dynamic-width col-xs-4\">{{eachValue}}</button></span> <span ng-if=\"updatedDispValue !== offersWidgetPanel.selectedTreatment.dispositionsInboundCodes[eachValue].toLowerCase()\"><button class=\"offerWidgetButton dynamic-width col-xs-4\" ng-click=\'offersWidgetPanel.updateDispositionMethod(offersWidgetPanel.selectedTreatment, offersWidgetPanel.selectedTreatment.dispositionsInboundCodes[eachValue], \"\")\'>{{eachValue}}</button></span></span></div><div class=\"offerPanelDecline\" ng-if=\"offersWidgetPanel.displayDiv()\"><div class=\"offersTextSection1\"><div class=\"textareaHead\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclined\"></span> <span class=\"ute-ao-close-bg closeIconPanel\" ng-click=\"offersWidgetPanel.hideDeclineDiv()\"><span class=\"ute-ao-close-text decPanelTimes\">&times;</span></span></div><div class=\"row col-xs-11 col-sm-11 col-md-12 col-lg-12 declineDivPadding\"><div class=\"textareaReasonPanel row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><textarea placeholder=\"{{\'ute.rogers.actionsOffers.actionsOffersBounds.reasonDeclinedPlaceHolder\' | translate}}\" class=\"declineReasonText\" ng-model=\"declineReason\" [name=\"declineReason\" ]=\"\" [ng-minlength=\"1\" [ng-maxlength=\"500\"></textarea></div><div class=\"offerPanelButtons row col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><a class=\"cancelBtn\" ng-click=\"offersWidgetPanel.hideDeclineDiv()\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.cancel\"></span></a></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><span class=\"declineBtn declinebtnPanel\" ng-click=\"offersWidgetPanel.declineDisposition(offersWidgetPanel.selectedTreatment, offersWidgetPanel.actionsOffersService.getConfig().constants.declinedCase, declineReason)\"><span translate=\"ute.rogers.actionsOffers.actionsOffersBounds.declined\"></span></span></div></div></div></div></div><div class=\"row row-content tab-content\"><div class=\"col-xs-12 col-xs-offset-0\"><div class=\"offersPanelTab\"><md-content><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" md-no-pagination=\"true\" md-no-ink=\"\"><md-tab label=\"{{offersWidgetPanel.valueContent}}\"><md-content class=\"md-padding panel-scroll-ctn-auto\"><span class=\"value-cms\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.offerPanelValueDescCMS\"></span> <span class=\"value-cms\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.offerPanelValueDescMW\"></span></md-content></md-tab><md-tab label=\"{{offersWidgetPanel.detailContent}}\"><md-content ng-if=\"!offersWidgetPanel.showTerms\" class=\"md-padding panel-scroll-ctn-auto\"><span class=\"treatment-details\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentDetails\"></span><div class=\"treatment-tnc\" ng-click=\"offersWidgetPanel.showTermAndCondn()\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.termsConditions\"></span></div><div class=\"nova-btn\" ng-if=\"offersWidgetPanel.selectedTreatment.treatmentKnowledgeManagementUrl.length > 0\"><a class=\"nova-content\" ng-href=\"{{offersWidgetPanel.selectedTreatment.treatmentKnowledgeManagementUrl}}\" target=\"_blank\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.viewNova\"></span></a></div></md-content><md-content ng-if=\"offersWidgetPanel.showTerms\" class=\"md-padding\"><div class=\"termsAndCondnSection\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.termsConditions\"></span> <span class=\"termsAndCondnClose\" ng-click=\"offersWidgetPanel.hideTermAndCondn()\"><span translate=\"ute.rogers.actionsOffers.actionsOffersWidget.close\"></span></span></div><div class=\"termsAndCondnBorder termsAndCondnScroll\"><span ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentTermsAndCond\"></span></div></md-content></md-tab><md-tab label=\"{{offersWidgetPanel.howToContent}}\"><md-content class=\"md-padding panel-scroll-ctn-auto\"><span ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentFulfillmentInst\"></span></md-content></md-tab><md-tab label=\"{{offersWidgetPanel.eligibilityContent}}\"><md-content class=\"md-padding\" ng-class=\"{\'panel-scroll-ctn\' : offersWidgetPanel.selectedTreatment.eligibleSubscriptions.length > 5}\"><div ng-if=\"offersWidgetPanel.selectedTreatment.eligibleSubscriptions && offersWidgetPanel.selectedTreatment.eligibleSubscriptions.length > 0\"><div><span class=\"treatment-eligibility\" ng-bind-html=\"offersWidgetPanel.selectedTreatment.treatmentEligibility\"></span></div><div><div ng-repeat=\"eachSubscription in offersWidgetPanel.selectedTreatment.eligibleSubscriptions\"><div ng-if=\"eachSubscription\" class=\"offersWidgetPanel-individualBadge\"><div class=\"offersWidgetPanel-individualBadgeColor\" ng-style=\"{\'backgroundColor\': offersWidgetPanel.colorHex[$index]}\"></div><i class=\"rui-icon-wireless offersWidgetPanel-individualBadgeIcon\"></i><div class=\"offersWidgetPanel-individualBadgeInfo\"><span class=\"ctn-no\">{{eachSubscription}}</span></div></div></div></div></div></md-content></md-tab></md-tabs></md-content></div></div></div></div></div>");
$templateCache.put("module/BFA-PPC/wirelessDashboard/bfaPpcAddAditionalDataModal.view.html","<div class=\"ute-bfa-ppc-modal ute-bfa-ppc-modal-entry-3\"><div class=\"ute-bfa-ppc-modal-header\"><img class=\"ute-bfa-ppc-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"ute-bfa-ppc-modal-body share-everything-modal\"><h3 class=\"ute-bfa-ppc-modal-title\">{{\'mppc_entry_3_title\' | translate}}</h3><div class=\"row\"><div class=\"col-xs-12\"><a class=\"ute-bfa-ppc-modal-red-button\" href=\"\" ng-click=\"yes()\">{{\'mppc_entry_3_yes\' | translate}}</a> <a class=\"ute-bfa-ppc-modal-white-button\" href=\"\" ng-click=\"no()\">{{\'mppc_entry_3_no\' | translate}}</a></div></div></div></div>");
$templateCache.put("module/BFA-PPC/wirelessDashboard/bfaPpcEntry1Modal.view.html","<div class=\"ute-bfa-ppc-modal ute-bfa-ppc-modal-entry-1\"><div class=\"ute-bfa-ppc-modal-header\"><img class=\"ute-bfa-ppc-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"ute-bfa-ppc-modal-body share-everything-modal\"><div class=\"row\"><div class=\"col-xs-12 col-sm-5 vcenter\" ng-click=\"changeCurrentPlan()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/edit-current-ctn.png\"></div>{{\'mppc_entry_1_change_current_plan\'| translate}}</div></div><div class=\"col-xs-12 col-sm-2 vcenter or-div text-center\">{{\'mppc_entry_3_or\'| translate}}</div><div class=\"col-xs-12 col-sm-5 vcenter\" ng-click=\"createSharedGroup()\"><div class=\"well\"><div><img src=\"images/price-plan-changes/create-shared-group.png\"></div>{{\'mppc_entry_1_create_shared_plan\' | translate}}</div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"ute-bfa-ppc-modal-back-button\" href=\"\" ng-click=\"cancel()\">{{\'mppc_entry_1_cancel\' | translate}}</a></div></div></div></div>");
$templateCache.put("module/BFA-PPC/wirelessDashboard/bfaPpcEntry3Modal.view.html","<div class=\"ute-bfa-ppc-modal ute-bfa-ppc-modal-entry-3\"><div class=\"ute-bfa-ppc-modal-header\"><img class=\"ute-bfa-ppc-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"ute-bfa-ppc-modal-body share-everything-modal\"><h3 class=\"ute-bfa-ppc-modal-title\">{{\'mppc_entry_3_change_wireless_plan\' | translate}}</h3><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\">{{\'mppc_entry_3_change_current_plan\' | translate}}</div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"changeCurrentPlan()\">{{\'_continue\' | translate}}</button></div></div></div><div class=\"text-center or-div\">{{\'mppc_entry_3_or\' | translate}}</div><div class=\"well\"><div class=\"row\"><div class=\"col-sm-8\">{{\'mppc_entry_3_add_to_share_plan\'| translate}}</div><div class=\"col-sm-4\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"addToSharedGroup()\">{{\'_continue\' | translate}}</button></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><a class=\"ute-bfa-ppc-modal-back-button\" href=\"\" ng-click=\"cancel()\">{{\'mppc_entry_3_cancel\'| translate}}</a></div></div></div></div>");
$templateCache.put("module/BFA-PPC/wirelessDashboard/bfaPpcSharedGroupIndividualModal.view.html","<div class=\"ute-bfa-ppc-modal\"><div class=\"ute-bfa-ppc-modal-header\"><img class=\"ute-bfa-ppc-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"ute-bfa-ppc-modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"ute-bfa-ppc-modal-title\">{{\'mppc_shared_group_indiv_title\' | translate}}</h3><div class=\"benefit-link\" ng-click=\"toggleBenefits()\">{{\'mppc_shared_group_indiv_benefits\' | translate}} <i class=\"fa\" ng-class=\"{\'fa-chevron-down\':!showBenefits, \'fa-chevron-up\':showBenefits}\"></i></div><div ng-show=\"showBenefits\" class=\"benefits\">{{\'mppc_shared_group_indiv_switch_reason_intro\' | translate}}<ul><li>{{\'mppc_shared_group_indiv_switch_reason_1\' |translate}}</li><li>{{\'mppc_shared_group_indiv_switch_reason_2\' | translate}}</li><li>{{\'mppc_shared_group_indiv_switch_reason_3\' | translate}}</li><li>{{\'mppc_shared_group_indiv_switch_reason_4\' | translate}}</li></ul></div><div class=\"ute-bfa-ppc-modal-panel panel-default panel-individual\"><div class=\"ute-bfa-ppc-modal-panel-body\"><div class=\"ute-bfa-ppc-modal-panel-individual-line row\" ng-repeat=\"individualLine in subscribers | filter: filterSubscribers\" ng-class=\"{\'last\': $last}\"><input type=\"checkbox\" ng-model=\"selectedSubscribersCheckBox[individualLine.subscriberNumber]\" data-icheck=\"\"> {{::individualLine.subscriberNumber | ute_common_filter_phone2}}</div></div></div><div class=\"row\"><div class=\"col-xs-6\"><a class=\"ute-bfa-ppc-modal-back-button\" href=\"\" ng-click=\"cancel()\">{{\'_cancel\' | translate}}</a></div><div class=\"col-xs-6\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\">{{\'_add\' | translate}}</button></div></div></div></div>");
$templateCache.put("module/BFA-PPC/wirelessDashboard/bfaPpcSharedGroupPrimaryModal.view.html","<div class=\"ute-bfa-ppc-modal\"><div class=\"ute-bfa-ppc-modal-header\"><img class=\"ute-bfa-ppc-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"></div><div class=\"ute-bfa-ppc-modal-body share-everything-modal\" bfa-stop-event=\"touchend\"><h3 class=\"ute-bfa-ppc-modal-title\">{{\'mppc_shared_group_primary_title\' | translate}}</h3><div class=\"panel panel-default panel-individual\"><div class=\"ute-bfa-ppc-modal-panel-body\"><div class=\"individual-line row\"><input type=\"radio\" ng-model=\"selectedPrimaryCtn\" data-icheck=\"\" value=\"{{currentCtn}}\"> {{currentCtn | ute_common_filter_phone2}}</div><div class=\"individual-line row\" ng-repeat=\"ctn in selectedAdditionalSubscribers\" ng-class=\"{\'last\': $last}\"><input type=\"radio\" ng-model=\"selectedPrimaryCtn\" data-icheck=\"\" value=\"{{ctn}}\"> {{ctn | ute_common_filter_phone2}}</div></div></div><div class=\"row\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium pull-right\" ng-click=\"continue()\">{{\'_continue\' | translate}}</button></div></div></div>");
$templateCache.put("module/changeCtnCallerId/views/changeCallerId.html","<div class=\"ute-change-ctn-caller-id-modal\"><div id=\"uteChangeCallerIDLiveChat\"><bold-chat-static-button data-cbid=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.boldChatDiv\' | translate}}\" data-chat-button=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.chatButton\' | translate}}\"></bold-chat-static-button></div><div class=\"modal-header callerId-modal-header\"><div ng-if=\"vm.step !== vm.STEP.SUCCESS && vm.step !== vm.STEP.FAILURE\" class=\"ute-change-ctn-caller-id-header\" translate=\"ute.changeCtnCallerId.initial.heading\"></div><div ng-if=\"vm.step === vm.STEP.SUCCESS || vm.step === vm.STEP.FAILURE\" style=\"min-height: 70px;\"></div><div class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></div></div><div class=\"vector-image\" ng-if=\"vm.step === vm.STEP.SUCCESS\"><div class=\"middle-aligner\"><img ng-src=\"ute-common-assets/assets/success.png\"></div></div><div class=\"vector-image\" ng-if=\"vm.step === vm.STEP.FAILURE\"><div class=\"middle-aligner\"><img ng-src=\"ute-common-assets/assets/warning_lg.png\"></div></div><div class=\"ute-change-ctn-caller-id-modal-body\"><div class=\"ute-change-ctn-caller-id-initial-step\" ng-if=\"vm.step === vm.STEP.INITIAL\"><div class=\"ute-change-ctn-caller-id-subHeader\" translate=\"ute.changeCtnCallerId.initial.sub_heading\"></div><div class=\"ute-change-ctn-caller-id-note-block\"><div class=\"note-header\"><div class=\"row pad-25\"><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.initial.your_number\"></div><span>{{::vm.getFormattedCtn()}}</span></div><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.initial.current_caller_id_name\"></div><div class=\"note-change-to text-capitalize\"><span>{{::vm.getExistingDisplayName()}}</span></div></div></div></div></div><div class=\"note-text\" translate=\"ute.changeCtnCallerId.initial.note_text\"></div><div class=\"ute-change-ctn-caller-id-form-step\"><form name=\"changeCtnCallerIdForm\" novalidate=\"\"><div class=\"ute-change-ctn-caller-id-form\" ng-init=\"vm.$scope.changeCtnCallerIdForm = changeCtnCallerIdForm\"><div class=\"firstName\"><div class=\"caller-label\"><label for=\"firstName\" translate=\"ute.changeCtnCallerId.initial.labelFirstName\"></label></div><div class=\"input-container\"><div class=\"error-icon\" data-ng-class=\"changeCtnCallerIdForm.firstName.$invalid && !vm.sendingState && changeCtnCallerIdForm.firstName.$touched ? \'ute-icon-error-icon\' : (changeCtnCallerIdForm.firstName.$valid && changeCtnCallerIdForm.firstName.$touched) ? \'ute-icon-checkmark-1\' : \'\'\"></div><input type=\"text\" name=\"firstName\" id=\"firstName\" ng-pattern=\"/^[a-zA-Z\\s\\-\']*$/\" data-ng-class=\"{\'error\': changeCtnCallerIdForm.firstName.$invalid && !vm.sendingState && changeCtnCallerIdForm.firstName.$touched}\" data-ng-model=\"vm.data.newFirstName\" maxlength=\"15\" required=\"\" data-ng-change=\"vm.inputChanged(vm.data.newFirstName, \'firstName\', changeCtnCallerIdForm)\" data-ng-blur=\"vm.checkForBadWord(vm.data.newFirstName, \'firstName\', changeCtnCallerIdForm)\" stop-event=\"touchstart\" data-test-id=\"ute-change-ctn-caller-id-first_name_input\"></div><div class=\"error-container\" ng-messages=\"changeCtnCallerIdForm.firstName.$error\" role=\"alert\" ng-if=\"changeCtnCallerIdForm.firstName.$touched && !vm.sendingState && changeCtnCallerIdForm.firstName.$invalid\" data-test-id=\"ute-change-ctn-caller-id-first_name_input_validation_message\"><div ng-message=\"required\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f11\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.required\' | translate}}</span></div><div ng-message=\"badWordCheck\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f11\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.badWords\' | translate}}</span></div><div ng-message=\"maxlength\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f11\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.firstName.invalid\' | translate}}</span></div><div ng-message=\"pattern\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f11\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.specialCharacters\' | translate}}</span></div><div ng-message=\"moreThanTwoWords\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f11\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.firstName.moreThanTwoWords\' | translate}}</span></div></div></div><div class=\"lastName\"><div class=\"caller-label\"><label for=\"lastName\" translate=\"ute.changeCtnCallerId.initial.labelLastName\"></label></div><div class=\"input-container\"><div class=\"error-icon\" data-ng-class=\"changeCtnCallerIdForm.lastName.$invalid && !vm.sendingState && changeCtnCallerIdForm.lastName.$touched ? \'ute-icon-error-icon\' : (changeCtnCallerIdForm.lastName.$valid && changeCtnCallerIdForm.lastName.$touched) ? \'ute-icon-checkmark-1\' : \'\'\"></div><input type=\"text\" name=\"lastName\" id=\"lastName\" ng-pattern=\"/^[a-zA-Z\\s\\-\']*$/\" data-ng-class=\"{\'error\': changeCtnCallerIdForm.lastName.$invalid && !vm.sendingState && changeCtnCallerIdForm.lastName.$touched}\" data-ng-model=\"vm.data.newLastName\" maxlength=\"30\" required=\"\" data-ng-change=\"vm.inputChanged(vm.data.newLastName, \'lastName\', changeCtnCallerIdForm)\" data-ng-blur=\"vm.checkForBadWord(vm.data.newLastName, \'lastName\', changeCtnCallerIdForm)\" stop-event=\"touchstart\" data-test-id=\"ute-change-ctn-caller-id-last_name_input\"></div><div class=\"error-container\" ng-messages=\"changeCtnCallerIdForm.lastName.$error\" role=\"alert\" ng-if=\"changeCtnCallerIdForm.lastName.$touched && !vm.sendingState && changeCtnCallerIdForm.lastName.$invalid\" data-test-id=\"ute-change-ctn-caller-id-last_name_input_validation_message\"><div ng-message=\"required\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f12\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.required\' | translate}}</span></div><div ng-message=\"badWordCheck\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f12\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.badWords\' | translate}}</span></div><div ng-message=\"maxlength\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f12\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.lastName.invalid\' | translate}}</span></div><div ng-message=\"pattern\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f12\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.common.specialCharacters\' | translate}}</span></div><div ng-message=\"moreThanTwoWords\"><span adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f12\",\"mappingKey\":\"error.changeCallerID\"}\'>{{\'ute.changeCtnCallerId.initial.validationErrors.lastName.moreThanTwoWords\' | translate}}</span></div></div></div></div><div class=\"ute-change-ctn-caller-id-button-container\"><div class=\"cancel-button\"><button ng-click=\"vm.closeModal($event)\" translate=\"ute.changeCtnCallerId.initial.cancelButton\"></button></div><div class=\"continue-button\"><div class=\"processing-button\" data-ng-class=\"changeCtnCallerIdForm.$invalid ? \'disabled\' : vm.changeNameInProgess ? \'processing\' : \'\'\" data-ng-click=\"vm.gotoChangeForm(changeCtnCallerIdForm)\"><div translate=\"ute.changeCtnCallerId.initial.continueButton\"></div></div></div></div></form></div></div><div class=\"ute-change-ctn-caller-id-form-step\" ng-if=\"vm.step === vm.STEP.CHANGE_FORM\"><div class=\"ute-change-ctn-caller-id-subHeader\" translate=\"ute.changeCtnCallerId.change.sub_heading\"></div><div class=\"ute-change-ctn-caller-id-note-block\"><div class=\"note-header\"><div class=\"row pad-25\"><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.initial.your_number\"></div><span>{{vm.getFormattedCtn()}}</span></div><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.change.old_caller_id_name\"></div><div class=\"note-change-to text-capitalize\"><span>{{vm.getExistingDisplayName()}}</span></div></div></div><div class=\"row pad-25 white-bg\"><div class=\"cc-id-text\" translate=\"ute.changeCtnCallerId.change.new_caller_id_name\"></div><div class=\"cc-id-new-name text-capitalize green-text\">{{::(vm.getNewFirstName() + \' \' + vm.getNewLastName())}}</div></div></div></div><div class=\"note-text\"><span translate=\"ute.changeCtnCallerId.change.disclaimer_one\"></span> <a target=\"_blank\" ng-click=\"vm.openPolicyLink()\"><span translate=\"ute.changeCtnCallerId.change.disclaimer_link_text\"></span></a> <span translate=\"ute.changeCtnCallerId.change.disclaimer_two\"></span></div><div class=\"ute-change-ctn-caller-id-button-container\"><div class=\"cancel-button\"><button ng-click=\"vm.closeModal($event)\" translate=\"ute.changeCtnCallerId.initial.cancelButton\"></button></div><div class=\"continue-button\"><div class=\"processing-button\" data-ng-class=\"changeCtnCallerIdForm.$invalid ? \'disabled\' : vm.changeNameInProgess ? \'processing\' : \'\'\" data-ng-click=\"changeCtnCallerIdForm.$setSubmitted(); vm.changeSubscriberName();\"><div>{{vm.getSubmitButtonText()}}</div><div ng-if=\"vm.changeNameInProgess && !vm.changeFailed\"><div class=\"loader\"></div></div></div></div></div></div><div class=\"ute-change-ctn-caller-id-success-step\" ng-if=\"vm.step === vm.STEP.SUCCESS\"><div class=\"ute-change-ctn-success-text\" translate=\"ute.changeCtnCallerId.success.heading\"></div><div class=\"ute-cc-id-new-name-container\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"cc-id-text\" translate=\"ute.changeCtnCallerId.initial.your_number\"></div><div class=\"cc-id-number\">{{::vm.getFormattedCtn()}}</div></div><div class=\"col-md-6\"><div class=\"cc-id-text\" translate=\"ute.changeCtnCallerId.change.new_caller_id_name\"></div><div class=\"cc-id-new-name text-capitalize\">{{::(vm.getNewFirstName() + \' \' + vm.getNewLastName())}}</div></div></div></div><div class=\"ute-change-ctn-caller-id-subHeader\" translate=\"ute.changeCtnCallerId.success.sub_heading\" data-translate-values=\"{email:(vm.getEmail())}\"></div><div class=\"ute-cc-id-done-button\"><button ng-click=\"vm.closeModal($event)\" translate=\"ute.changeCtnCallerId.success.done_button\"></button></div></div><div class=\"ute-chnage-ctn-caller-id-failure-step\" ng-if=\"vm.step === vm.STEP.FAILURE\"><div class=\"ute-change-ctn-caller-id-header\" translate=\"ute.changeCtnCallerId.failure.heading\"></div><div class=\"ute-cc-id-new-name-container\"><div class=\"cc-id-number\">{{::vm.getFormattedCtn()}}</div><div class=\"cc-id-text\" translate=\"ute.changeCtnCallerId.failure.is_still_known_text\"></div><div class=\"cc-id-new-name text-capitalize\">{{::vm.getExistingDisplayName()}}</div></div><div class=\"ute-change-ctn-caller-id-subHeader\" translate=\"ute.changeCtnCallerId.failure.serverError\"></div><div class=\"ute-cc-id-support-container\"><div class=\"cc-id-live-chat-container\"><div class=\"live-chat-btn\" data-test-id=\"ute-change-ctn-caller-id-default_chat_button\" stop-event=\"click\" data-ng-click=\"vm.triggerChat($event)\" name=\"liveChatButton\"><div><img src=\"ute-common-assets/assets/live-chat-icon.png\" alt=\"\"></div><div title=\"{{\'ute.changeCtnCallerId.common.liveChatButton\' | translate}}\" translate=\"ute.changeCtnCallerId.common.liveChatButton\"></div></div></div><div class=\"cc-id-call-container\"><div class=\"cc-id-support-number\"><div class=\"icon ute-icon-phone-v3\"></div><div class=\"cc-id-call-number\" translate=\"ute.changeCtnCallerId.failure.helpNumber\"></div></div></div></div></div></div></div>");
$templateCache.put("module/changeCtnCallerId/views/changeCallerIdError.html","<div class=\"modal-container-flex\"><div class=\"modal-header callerID-modal-header\"><a data-ng-click=\"$dismiss()\" class=\"modal-close\" data-dismiss=\"modal\"><i class=\"rui-icon-mobile-menu-exit\"></i></a><div class=\"caller-id-title-container\"><i class=\"rui-icon-error header-error-icon\" data-test-id=\"ute-change-ctn-caller-id-error_icon\"></i><h2 class=\"modal-title\" translate=\"ute.changeCtnCallerId.error.heading\" data-test-id=\"ute-change-ctn-caller-id-error_heading\"></h2></div></div><div class=\"modal-body\"><div class=\"widget-loader-xs pull-left hidden-sm hidden-md hidden-lg\" data-ng-show=\"vm.sendingState\"><img src=\"ute-change-ctn-caller-id/assets/widget-loader.gif\" alt=\"\"></div><div class=\"container-fluid change-cid-err-container\"><div class=\"row\"><div class=\"col-xs-12 col-md-12\"><p data-ng-bind-html=\"\'ute.changeCtnCallerId.error.description\' | translate\" data-test-id=\"ute-change-ctn-caller-id-error_description\"></p><div class=\"row\"><div class=\"col-md-10 col-xs-12 chat-info-container\"><ul class=\"row\"><li class=\"col-xs-12 col-md-4\"><div class=\"live-chat-info\"><a stop-event=\"click\" data-ng-click=\"triggerChat()\" name=\"liveChatButton\" title=\"{{\'ute.changeCtnCallerId.error.chatLinkText\' | translate}}\" data-test-id=\"ute-change-ctn-caller-id-error_chat_button\"><i class=\"rui-icon-live-chat call-img ctn-chat-icon\"></i> <span translate=\"ute.changeCtnCallerId.error.chatLinkText\"></span></a><div class=\"chat-box-container\"><bold-chat-static-button data-cbid=\"{{\'ute.changeCtnCallerId.error.boldChatButton.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.changeCtnCallerId.error.boldChatButton.boldChatDiv\' | translate}}\" data-chat-button=\"{{\'ute.changeCtnCallerId.error.boldChatButton.chatButton\' | translate}}\"></bold-chat-static-button></div></div></li><li class=\"col-xs-12 col-md-4\"><div class=\"help-line\"><a href=\"tel:{{::\'ute.changeCtnCallerId.error.helpNumber\' | translate}}\" data-test-id=\"ute-change-ctn-caller-id-error_help_number\"><i class=\"rui-icon-phonea-not-service-related ctn-call-icon\"></i> <span translate=\"ute.changeCtnCallerId.error.helpNumberToDisplay\"></span></a></div></li></ul></div></div><a data-ng-click=\"$dismiss()\" class=\"done-btn hidden-lg\" translate=\"ute.changeCtnCallerId.common.doneButton\" data-test-id=\"ute-change-ctn-caller-id-error_done_button\"></a></div></div></div></div></div>");
$templateCache.put("module/changeCtnCallerId/views/changeCallerIdSuccess.html","<div class=\"modal-container-flex\"><div class=\"modal-header callerID-modal-header\"><a data-ng-click=\"$dismiss()\" class=\"modal-close\" data-dismiss=\"modal\"><i class=\"rui-icon-mobile-menu-exit\"></i></a><div class=\"caller-id-title-container\"><i class=\"rui-icon-success header-success-icon\" data-test-id=\"ute-change-ctn-caller-id-success_icon\"></i><h2 class=\"modal-title\" data-test-id=\"ute-change-ctn-caller-id-success_heading\"><span translate=\"ute.changeCtnCallerId.success.headingTitle\"></span><br><span class=\"heading-desc\" translate=\"ute.changeCtnCallerId.success.headingDesc\"></span></h2></div></div><div class=\"modal-body\"><div class=\"widget-loader-xs pull-left hidden-sm hidden-md hidden-lg\" data-ng-show=\"vm.sendingState\"><img src=\"ute-change-ctn-caller-id/assets/widget-loader.gif\" alt=\"\"></div><div class=\"container-fluid change-cid-success-container\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"new-callerID\"><h2 translate=\"ute.changeCtnCallerId.success.yourNewCallerID\" data-test-id=\"ute-change-ctn-caller-id-new_caller_id_label\"></h2><p data-test-id=\"ute-change-ctn-caller-id-new_caller_id\">{{vm.getNewFirstName() + \' \' + vm.getNewLastName()}}</p></div><p class=\"confirm-email-container\" data-test-id=\"ute-change-ctn-caller-id-email\"><span translate=\"ute.changeCtnCallerId.success.description\"></span> <span class=\"confirmation-email\">{{vm.getEmail()}}</span></p><div class=\"updated-alert\"><i class=\"rui-icon-info ute-ctn-alert-icon\" data-test-id=\"ute-change-ctn-caller-id-success_icon_alert\"></i><div class=\"alert-desc\"><p translate=\"ute.changeCtnCallerId.success.infoDesc\" data-test-id=\"ute-change-ctn-caller-id-success_description\"></p></div></div><a data-ng-click=\"$dismiss()\" class=\"done-btn\" translate=\"ute.changeCtnCallerId.common.doneButton\" data-test-id=\"ute-change-ctn-caller-id-success_done_button\"></a></div></div></div></div></div>");
$templateCache.put("module/changeCtnCallerId/views/changeCtnCallerId.directive.html","<div data-ng-if=\"vm.canChangeCallerId\"><span ng-if=\"vm.showName === true\" class=\"my-line-number text-capitalize\" data-test-id=\"ute-change-ctn-caller-id-display_name\">{{vm.getFirstName() | lowercase | limitTo : 15}}</span> <a ng-if=\"vm.showName === false\" tabindex=\"0\" class=\"my-line-change-number\" data-ng-click=\"vm.openChangeCallerIdModal()\" data-ng-keypress=\"($event.which === 13)?vm.openChangeCallerIdModal():0\" data-test-id=\"ute-change-ctn-caller-id-link\" adl-event-track=\'{\"action\":\"click\",\"isModalPopup\":true,\"pageView\":true,\"mappingKey\":\"change-caller-id,event.selfServeStart\"}\'><span class=\"lnk-txt\" ng-bind=\"(vm.getIsRep() ? \'ute.changeCtnCallerId.core.linkTextForRep\': \'ute.changeCtnCallerId.core.linkText\') | translate\"></span> <span class=\"rui-icon-arrow-right\"></span></a></div>");
$templateCache.put("module/changeCtnCallerId/views/eligibilityFail.html","<div class=\"ute-change-ctn-caller-id-modal\"><div id=\"uteChangeCallerIDLiveChat\"><bold-chat-static-button data-cbid=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.boldChatDiv\' | translate}}\" data-chat-button=\"{{\'ute.changeCtnCallerId.failure.boldChatButton.chatButton\' | translate}}\"></bold-chat-static-button></div><div class=\"modal-header callerId-modal-header\"><div class=\"ute-change-ctn-caller-id-header\" translate=\"ute.changeCtnCallerId.initial.heading\"></div><div class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></div></div><div class=\"ute-change-ctn-caller-id-modal-body\"><div class=\"ute-change-ctn-caller-id-not-eligible-step\"><div class=\"ute-change-ctn-caller-id-error-mess\" translate=\"ute.changeCtnCallerId.notEligible.heading\" adl-error-track=\'{\"category\":\"self_serve\",\"isModalPopup\":true,\"field\":\"f13\",\"mappingKey\":\"error.changeCallerIDNotEligible\"}\'></div><div class=\"ute-change-ctn-caller-id-note-block\"><div class=\"note-header\"><div class=\"row pad-25\"><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.initial.your_number\"></div><span>{{::vm.getFormattedCtn()}}</span></div><div class=\"col-md-6\"><div class=\"note-change-text\" translate=\"ute.changeCtnCallerId.notEligible.original_caller_id_name\"></div><div class=\"note-change-to text-capitalize\"><span>{{::vm.getExistingDisplayName()}}</span></div></div></div></div></div><div class=\"ute-cc-id-support-container\"><span translate=\"ute.changeCtnCallerId.notEligible.contact_us\"></span><div class=\"cc-id-live-chat-container\"><div class=\"live-chat-btn\" data-test-id=\"ute-change-ctn-caller-id-default_chat_button\" stop-event=\"click\" data-ng-click=\"vm.triggerChat($event)\" name=\"liveChatButton\"><div><img src=\"ute-common-assets/assets/live-chat-icon.png\" alt=\"\"></div><div title=\"{{\'ute.changeCtnCallerId.common.liveChatButton\' | translate}}\" translate=\"ute.changeCtnCallerId.common.liveChatButton\"></div></div></div><span translate=\"ute.changeCtnCallerId.notEligible.phone_no\"></span></div></div></div></div>");
$templateCache.put("module/notificationBanner/typeViews/ERROR.view.html","<div class=\"ute-notification-banner-message-error\"><span class=\"ute-icon-error-icon\"></span> <span translate=\"{{ message.translationKey }}\"></span></div>");
$templateCache.put("module/notificationBanner/typeViews/SUCCESS.view.html","<div class=\"ute-notification-banner-message-success\"><span class=\"ute-icon-checkmark-1\"></span> <span translate=\"{{ message.translationKey }}\"></span></div>");
$templateCache.put("module/customerCreditManagement/creditManagement/creditManagement.view.html","<section class=\"ute-creditManagement-section {{\'ute.common.customer.credit.management.service.alignmentClass\' | translate}}\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-creditManagement-primary-header\"><span translate=\"ute.common.customer.credit.management.service.manageAdjustments\"></span></div></div><div class=\"col-xs-12\"><div class=\"ute-creditManagement-secondary-content\"><span translate=\"ute.common.customer.credit.management.service.unsatisfactoryCompensationContent1\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-creditManagement-height-align\"><div class=\"col-xs-12 ute-creditManagement-primary-box\"><div class=\"ute-creditManagement-primary-box-header\"><span class=\"ute-ribbon-step-one\" translate=\"ute.common.customer.credit.management.service.stepOne\"></span> <span class=\"ute-creditManagement-right-align\" translate=\"ute.common.customer.credit.management.service.determineAmountAllowed\"></span></div><div class=\"ute-creditManagement-margin-top-2-5\"><div class=\"ute-creditManagement-styled-select ute-creditManagement-account-select\"><select name=\"subscriberNumber\" data-ng-model=\"displayCustomerCreditManagement.model.selectedSubscriberNumber\" ng-change=\"displayCustomerCreditManagement.reloadCreditAdjustmentDetails()\"><option ng-repeat=\"(key, value) in displayCustomerCreditManagement.getSubscriberDetails()\" value=\"{{value.subscriberNumber}}\">{{::value.subscriberName}} {{::value.subscriberNumber | ute_common_filter_phone3}}</option></select></div></div><div class=\"ute-creditManagement-secondary-content\"><div><span translate=\"ute.common.customer.credit.management.service.maxAllowedPeriod\"></span> <span class=\"ute-creditManagement-float-right\" ng-bind=\"displayCustomerCreditManagement.getMaxAllowedAmount() | currency | display_if_empty: \'N/A\'\"></span></div><div class=\"ute-creditManagement-margin-top-1-5\"><span translate=\"ute.common.customer.credit.management.service.recentAdjustments\"></span> <span class=\"ute-creditManagement-float-right\"><span ng-show=\"!displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed && displayCustomerCreditManagement.getRecentCreditAdjustments() > 0\">-</span> <span ng-show=\"!displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" ng-bind=\"displayCustomerCreditManagement.getRecentCreditAdjustments() | currency | display_if_empty: \'N/A\'\"></span> <span ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" translate=\"ute.common.customer.credit.management.service.notAvailable\"></span></span></div></div><div class=\"ute-creditManagement-total-allowed\"><span translate=\"ute.common.customer.credit.management.service.totalAllowed\"></span> <span ng-show=\"!displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" class=\"ute-creditManagement-float-right\" ng-bind=\"displayCustomerCreditManagement.getTotalAllowedCreditAdjustments() | currency | display_if_empty: \'N/A\'\"></span> <span ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" class=\"ute-creditManagement-float-right\" translate=\"ute.common.customer.credit.management.service.notAvailable\"></span></div></div><div class=\"col-xs-12 ute-creditManagement-primary-box\"><div class=\"ute-creditManagement-primary-box-header\"><span class=\"ute-ribbon-step-two\" translate=\"ute.common.customer.credit.management.service.stepTwo\"></span> <span translate=\"ute.common.customer.credit.management.service.makeCAPOffer\"></span></div><div class=\"ute-creditManagement-secondary-content\"><span translate=\"ute.common.customer.credit.management.service.unsatisfactoryCompensationContent2\"></span></div><div class=\"ute-creditManagement-primary-buttons\"><a href=\"http://nova.rogers.com/infocenter/index?page=content&id=POL125\" target=\"_blank\"><button class=\"\" data-ng-click=\"\"><span translate=\"ute.common.customer.credit.management.service.viewCAPOffersInNova\"></span></button></a></div></div><div class=\"col-xs-12 ute-creditManagement-secondary-box\"><div class=\"ute-creditManagement-secondary-box-header\"><span translate=\"ute.common.customer.credit.management.service.unsatisfactoryCompensationContent3\"></span></div><div class=\"ute-creditManagement-primary-content\"><i class=\"rui-icon-wireless\"></i> <span class=\"ute-creditManagement-padding-left-2-0\"><span translate=\"ute.common.customer.credit.management.service.customerPhoneNumber\"></span><br><span class=\"ute-creditManagement-secondary-content\" ng-bind=\"displayCustomerCreditManagement.model.selectedSubscriberNumber | ute_common_filter_phone3\"></span></span></div><div class=\"ute-creditManagement-hr-line\"></div><div class=\"ute-creditManagement-cap-offer-percent\"><p><span translate=\"ute.common.customer.credit.management.service.totalAllowed\"></span></p><div class=\"ute-creditManagement-line-height\"><div class=\"ute-creditManagement-cap-offer-left-content\"><span translate=\"ute.common.customer.credit.management.service.totalAllowed50Percent\"></span></div><div class=\"ute-creditManagement-cap-offer-middle-content\"></div><div class=\"ute-creditManagement-cap-offer-right-content\"><span ng-show=\"!displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" ng-bind=\"(displayCustomerCreditManagement.getTotalAllowedCreditAdjustments()/2) | currency | display_if_empty: \'N/A\'\"></span> <span ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" translate=\"ute.common.customer.credit.management.service.notAvailable\"></span></div></div><div class=\"ute-creditManagement-cap-offer-clear-both\"></div><div class=\"ute-creditManagement-line-height\"><div class=\"ute-creditManagement-cap-offer-left-content\"><span translate=\"ute.common.customer.credit.management.service.totalAllowed100Percent\"></span></div><div class=\"ute-creditManagement-cap-offer-middle-content\"></div><div class=\"ute-creditManagement-cap-offer-right-content\"><span ng-show=\"!displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" ng-bind=\"displayCustomerCreditManagement.getTotalAllowedCreditAdjustments() | currency | display_if_empty: \'N/A\'\"></span> <span ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\" translate=\"ute.common.customer.credit.management.service.notAvailable\"></span></div></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"ute-creditManagement-secondary-header\"><span translate=\"ute.common.customer.credit.management.service.discretionaryCreditAdjustmentsPeriod\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-creditManagement-row-header\"><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.date\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.count\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.code\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.amount\"></span></div></div><div class=\"col-xs-4\"><div><span translate=\"ute.common.customer.credit.management.service.description\"></span></div></div></div><div class=\"row ute-creditManagement-error-content\" ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallFailed\"><span class=\"ute-creditManagement-warning-symbol\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/common/warning.png\"></span><div class=\"col-xs-6\"><span translate=\"ute.common.customer.credit.management.service.systemUnavailableMessage\"></span></div></div><div class=\"row ute-creditManagement-error-content\" ng-show=\"displayCustomerCreditManagement.model.noDiscCreditAdjustmentRecordsFound\"><div class=\"col-xs-6\"><span translate=\"ute.common.customer.credit.management.service.noDiscretionaryCreditsFound\"></span></div></div><div class=\"row ute-creditManagement-loading-content\" ng-show=\"displayCustomerCreditManagement.model.isDiscCreditAdjustmentCallInProgress\"><div class=\"col-xs-6\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></div></div><div class=\"row ute-creditManagement-row-content\" ng-show=\"displayCustomerCreditManagement.model.isValidDiscCreditAdjustmentList\" ng-repeat=\"creditAdjustment in displayCustomerCreditManagement.getDiscCreditAdjustmentList() | orderBy: \'date\'\"><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.date | display_if_empty: \'N/A\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.count | display_if_empty: \'1\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.code | display_if_empty: \'N/A\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.amount | display_if_empty: \'0\' | currency\"></span></div></div><div class=\"col-xs-4\"><div><span translate=\"ute.common.customer.credit.management.service.discretionaryDescription{{creditAdjustment.code}}\"></span></div></div></div></div><div class=\"col-xs-12\"><div class=\"ute-creditManagement-secondary-header\"><span translate=\"ute.common.customer.credit.management.service.nonDiscretionaryCreditAdjustmentsPeriod\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-creditManagement-row-header\"><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.date\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.count\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.code\"></span></div></div><div class=\"col-xs-2\"><div><span translate=\"ute.common.customer.credit.management.service.amount\"></span></div></div><div class=\"col-xs-4\"><div><span translate=\"ute.common.customer.credit.management.service.description\"></span></div></div></div><div class=\"row ute-creditManagement-error-content\" ng-show=\"displayCustomerCreditManagement.model.isNonDiscCreditAdjustmentCallFailed\"><span class=\"ute-creditManagement-warning-symbol\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/common/warning.png\"></span><div class=\"col-xs-6\"><span translate=\"ute.common.customer.credit.management.service.systemUnavailableMessage\"></span></div></div><div class=\"row ute-creditManagement-error-content\" ng-show=\"displayCustomerCreditManagement.model.noNonDiscCreditAdjustmentRecordsFound\"><div class=\"col-xs-6\"><span translate=\"ute.common.customer.credit.management.service.noNonDiscretionaryCreditsFound\"></span></div></div><div class=\"row ute-creditManagement-loading-content\" ng-show=\"displayCustomerCreditManagement.model.isNonDiscCreditAdjustmentCallInProgress\"><div class=\"col-xs-6\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></div></div><div class=\"row ute-creditManagement-row-content\" ng-show=\"displayCustomerCreditManagement.model.isValidNonDiscCreditAdjustmentList\" ng-repeat=\"creditAdjustment in displayCustomerCreditManagement.getNonDiscCreditAdjustmentList() | orderBy: \'date\'\"><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.date | display_if_empty: \'N/A\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.count | display_if_empty: \'1\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.code | display_if_empty: \'N/A\'\"></span></div></div><div class=\"col-xs-2\"><div><span ng-bind=\"creditAdjustment.amount | display_if_empty: \'0\' | currency\"></span></div></div><div class=\"col-xs-4\"><div><span ng-bind=\"creditAdjustment.description | display_if_empty: \'N/A\'\"></span></div></div></div></div></div></div></section>");
$templateCache.put("module/dataManager/alert/alert.view.html","<section class=\"dsat-alert_main\" ng-if=\"ctrl.alertShow\"><div class=\"dsat-alert\"><div class=\"dsat-alert__wrapper\"><div class=\"dsat-alert__copy\"><span class=\"dsat-icon-wrapper\"><span class=\"dsat-icon rds-icon-{{ctrl.alertData.copy.icon}}\" aria-hidden=\"true\"></span></span><p class=\"text-body\"><span ng-bind-html=\"ctrl.alertData.copy.body\"></span> <a href=\"javascript:void(0)\" ng-repeat=\"item in ctrl.alertData.cta\" class=\"dsat-rdsLink -text text-copy d-inline-flex align-items-center\" data-url=\"https://www.rogers.com\" title=\"{{ item.alt }}\"><span class=\"dsat-rdsLink__wrapper\" role=\"text\"><span class=\"dsat-rdsLink__content\">{{ item.copy }}</span></span></a></p></div></div></div></section>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummary.html","<div class=\"ute-dataManager\" ng-if=\"familyDataManagerAccountsSummary.getUsageDetailsCallInProgress()\"><div class=\"container\"><div class=\"row\"><div class=\"largeload\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></div></div></div><div class=\"ute-dataManager-accountsSummary-loading\" ng-if=\"familyDataManagerAccountsSummary.getPurchaseDataProductCallInProgress()\"><div class=\"ute-dataManager-accountsSummary-loaderContainer\"><div class=\"ute-dataManager-accountsSummary-loader\"><img src=\"ute-common-assets/assets/widget-loader-lg_no-lang.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div><div class=\"ute-dataManager-accountsSummary-loaderCopy\">{{:: \'ute.dataManager.accountsSummary.loader\' | translate}}</div></div><div class=\"ute-dataManager-accountsSummary-loaderBackground\"></div></div><div class=\"ute-dataManager\" ng-if=\"!familyDataManagerAccountsSummary.getUsageDetailsCallInProgress()\"><div class=\"ute-dataManager-accountsSummary\" data-ng-style=\"familyDataManagerAccountsSummary.getAccountsSummaryChartHeight()\"><ute-data-manager-accounts-summary></ute-data-manager-accounts-summary></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryBarContainer.partial.html","<div id=\"bar{{:: $index}}\" data-ng-mousemove=\"dataManagerAccountsSummaryBarContainer.chartMove($event, $index)\" data-ng-repeat=\"accountLine in dataManagerAccountsSummaryBarContainer.getFilteredList()\" data-ng-style=\"dataManagerAccountsSummaryBarContainer.getBarStyle($index)\" class=\"ute-dataManager-accountsSummary-barContainer ute-dataManager-accountsSummary-barContainer{{$index}}\" data-md-swipe-left=\"!dataManagerAccountsSummaryBarContainer.getSummaryMode() ? dataManagerAccountsSummaryBarContainer.swipeLeft() : null\" data-md-swipe-right=\"!dataManagerAccountsSummaryBarContainer.getSummaryMode() ? dataManagerAccountsSummaryBarContainer.swipeRight() : null\" data-ng-mouseup=\"dataManagerAccountsSummaryBarContainer.thumbUp()\"><div class=\"ute-data-manager-accounts-summary-swipe-instructions-container\" data-ng-show=\"dataManagerAccountsSummaryBarContainer.showSwipeInstructions(accountLine)\"><ute-data-manager-accounts-summary-swipe-instructions fade=\"!swipeInstructionsVisible\"></ute-data-manager-accounts-summary-swipe-instructions></div><div class=\"ute-data-manager-accounts-summary-data-alert-at-container\" data-ng-class=\"dataManagerAccountsSummaryBarContainer.alertAtContainerClass($index)\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideAlertAt(accountLine)\"><ute-data-manager-accounts-summary-data-alert-at data-ctn=\"{{:: accountLine.ctn}}\" data-data-alert-at=\"{{ dataManagerAccountsSummaryBarContainer.isBucketSizeUnavailableUntilNextBillCycle() ? accountLine.savedAlertValue : accountLine.dataAlertAt}}\" data-saved-alert-value=\"{{:: accountLine.savedAlertValue}}\" data-use-alert=\"accountLine.useAlert\" data-data-access=\"accountLine.dataAccess\"></ute-data-manager-accounts-summary-data-alert-at></div><div class=\"ute-dataManager-accountsSummary-groupStatusContainer\" ng-if=\"dataManagerAccountsSummaryBarContainer.showStatusContainer(accountLine)\"><div class=\"ute-dataManager-accountsSummary-groupStatus\" translate=\"ute.dataManager.accountsSummary.leftGroupStillSharing\"></div><div class=\"ute-dataManager-accountsSummary-wirelessLink\" ng-click=\"dataManagerAccountsSummaryBarContainer.goToWireless(accountLine.ctn)\" data-ng-bind-html=\"\'ute.dataManager.accountsSummary.joinedGroup\' | translate : { displayCTN: dataManagerAccountsSummaryBarContainer.getDisplayNameCTN(accountLine.ctn) }\"></div></div><div class=\"ute-dataManager-accountsSummary-dataAlertBarContainer\" data-ng-style=\"{\'bottom\': (dataManagerAccountsSummaryBarContainer.getBarPosition(accountLine.dataAlertAt) + 1 ) + \'px\'}\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideAlertAt(accountLine)\" data-ng-class=\":: \'ute-dataManager-accountsSummary-dataAlertBarContainer\' + $index\" data-ng-mousedown=\"dataManagerAccountsSummaryBarContainer.thumbDown()\" data-ng-mouseup=\"dataManagerAccountsSummaryBarContainer.thumbUp()\"><ute-data-manager-accounts-summary-data-alert-bar data-index=\"{{:: $index}}\" data-max-limit=\"{{:: dataManagerAccountsSummaryBarContainer.getMaxLimit()}}\" data-max-height=\"{{dataManagerAccountsSummaryBarContainer.getSummaryChartHeight()}}\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideAlertAtBar(accountLine)\"></ute-data-manager-accounts-summary-data-alert-bar></div><md-button class=\"ute-dataManager-accountsSummary-buttonArea\" aria-label=\"set usage\" data-ng-hide=\"!dataManagerAccountsSummaryBarContainer.getSummaryMode()\" data-ng-style=\"{\'opacity\': (dataManagerAccountsSummaryBarContainer.getSummaryMode() ? 1 : 0), \'height\': dataManagerAccountsSummaryBarContainer.getButtonHeight(accountLine.savedAlertValue, accountLine.dataUsed, accountLine.useAlert) + \'px\'}\" data-ng-click=\"dataManagerAccountsSummaryBarContainer.barClicked($index)\"></md-button><div class=\"ute-dataManager-accountsSummary-bar\"><ute-vertical-stack-bar-graph data-color-code=\"{{:: accountLine.colorCode }}\" data-base-copy=\"{{ dataManagerAccountsSummaryBarContainer.graphBaseCopy(accountLine) }}\" data-max-limit=\"{{:: dataManagerAccountsSummaryBarContainer.getMaxLimit()}}\" data-primary-value=\"{{:: dataManagerAccountsSummaryBarContainer.graphPrimaryValue(accountLine) }}\" data-secondary-value=\"{{ dataManagerAccountsSummaryBarContainer.graphSecondaryValue(accountLine) }}\" data-flip-height=\"40\" data-max-height=\"{{dataManagerAccountsSummaryBarContainer.getSummaryChartHeight()}}\" data-secondary-copy=\"{{ dataManagerAccountsSummaryBarContainer.graphSecondaryCopy(accountLine) }}\" data-index=\"{{:: $index}}\" data-base-flip-hidden=\"true\"></ute-vertical-stack-bar-graph></div><div class=\"ute-dataManager-accountsSummary-mainUsageContainer\"><div class=\"ute-dataManager-accountsSummary-mainUsage\" data-ng-style=\"{ opacity : dataManagerAccountsSummaryBarContainer.getOpacity($index), height : dataManagerAccountsSummaryBarContainer.getDarkUsageHeight(accountLine.dataUsed), bottom : dataManagerAccountsSummaryBarContainer.getDarkBottomOffset(accountLine.dataUsed) }\">{{:: \'ute.dataManager.accountsSummary.used\' | translate}} {{:: accountLine.dataUsed | ute_common_filter_data_conversion: \'mb\': 1024: (accountLine.dataUsed >= 1024 ? 2 : 0): false: false}} <span class=\"ute-dataManager-accountsSummary-mainUsageUnit\">{{:: accountLine.dataUsed | ute_common_filter_data_conversion: \'mb\': 1024: 0: true: true}}</span></div></div><div class=\"ute-dataManager-accountsSummary-mainUsageWhiteContainer\" data-ng-style=\"{ \'height\' : ((accountLine.dataUsed * (dataManagerAccountsSummaryBarContainer.getSummaryChartHeight() / dataManagerAccountsSummaryBarContainer.getMaxLimit())) > 30 ? 30 : (accountLine.dataUsed * (dataManagerAccountsSummaryBarContainer.getSummaryChartHeight() / dataManagerAccountsSummaryBarContainer.getMaxLimit()) )) + \'px\' }\"><divmainusage data-ng-style=\"{opacity : dataManagerAccountsSummaryBarContainer.getOpacity($index) }\" class=\"ute-dataManager-accountsSummary-mainUsageWhite\">{{:: \'ute.dataManager.accountsSummary.used\' | translate}} {{:: accountLine.dataUsed | ute_common_filter_data_conversion: \'mb\': 1024 : (accountLine.dataUsed >= 1024 ? 2 : 0): false: false}} <span class=\"ute-dataManager-accountsSummary-mainUsageUnit\">{{:: accountLine.dataUsed | ute_common_filter_data_conversion: \'mb\': 1024 : 0: true: true}}</span></divmainusage></div><div class=\"ute-dataManager-accountsSummary-dataNoAlertsSetContainer\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideNoAlertSetContainer(accountLine)\"><ute-data-manager-accounts-summary-no-data-alerts-set data-use-alert=\"accountLine.useAlert\" data-index=\"{{:: $index}}\" data-saved-alert-value=\"{{:: accountLine.savedAlertValue}}\" data-data-alert-at=\"{{ dataManagerAccountsSummaryBarContainer.isBucketSizeUnavailableUntilNextBillCycle() ? accountLine.savedAlertValue : accountLine.dataAlertAt}}\"></ute-data-manager-accounts-summary-no-data-alerts-set></div><div class=\"ute-dataManager-accountsSummary-dataAccessOffContainer\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideDataAccessOffContainer(accountLine)\"><ute-data-manager-accounts-summary-data-access-off></ute-data-manager-accounts-summary-data-access-off></div><div class=\"ute-dataManager-accountsSummary-noDataPlanContainer\" data-ng-hide=\"dataManagerAccountsSummaryBarContainer.hideNoDataPlanContainer(accountLine)\"><ute-data-manager-accounts-summary-no-data-plan></ute-data-manager-accounts-summary-no-data-plan></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDirective.view.html","<div class=\"ute-data-manager-accounts-summary-header-container\"><div data-ng-if=\"dataManagerAccountsSummaryDirective.getSummaryMode()\"><ute-data-manager-accounts-summary-header></ute-data-manager-accounts-summary-header></div><ute-data-manager-accounts-summary-individual-header data-ng-if=\"!dataManagerAccountsSummaryDirective.getSummaryMode()\" data-index=\"{{dataManagerAccountsSummaryDirective.getIndividualCTNView()}}\" data-display-name=\"{{dataManagerAccountsSummaryDirective.getIndividualCTNLine().displayName}}\" data-ctn=\"{{dataManagerAccountsSummaryDirective.getIndividualCTNLine().ctn}}\" data-color-code=\"{{dataManagerAccountsSummaryDirective.getIndividualCTNLine().colorCode}}\" data-data-access=\"dataManagerAccountsSummaryDirective.getIndividualCTNLine().dataAccess\"></ute-data-manager-accounts-summary-individual-header></div><div data-ng-class=\"!dataManagerAccountsSummaryDirective.getIsVideoThrottlePermitted() ? \'ute-datamanager-accountsSummary-chartContainer\' : \'ute-dtm-accountsSummary-chartContainer-video-streaming\'\" data-ng-style=\"{\'height\': dataManagerAccountsSummaryDirective.getSummaryChartHeight() + \'px\'}\" data-ng-if=\"dataManagerActiveTabIndex === 0\"><div class=\"ute-datamanager-accountsSummary-chart\"><ute-data-manager-accounts-summary-bar-container></ute-data-manager-accounts-summary-bar-container><ute-data-manager-summary-data-meter data-ng-hide=\":: dataManagerAccountsSummaryDirective.isBucketSizeUnavailableUntilNextBillCycle()\" data-primary-height=\"{{ dataManagerAccountsSummaryDirective.getPrimaryMeterHeight()}}\" data-secondary-height=\"{{ dataManagerAccountsSummaryDirective.getSecondaryMeterHeight()}}\" data-tertiary-height=\"{{ dataManagerAccountsSummaryDirective.getTertiaryMeterHeight()}}\"></ute-data-manager-summary-data-meter><div class=\"ute-dataManager-accountsSummary-overageCoverageContainer\" data-ng-show=\":: dataManagerAccountsSummaryDirective.inOverage()\" data-ng-style=\"{\'bottom\': dataManagerAccountsSummaryDirective.getOverageCoverageBottomPosition() + \'px\'}\"><ute-data-manager-accounts-summary-overage-coverage data-height=\"{{ dataManagerAccountsSummaryDirective.getOverageCoverageHeight()}}\"></ute-data-manager-accounts-summary-overage-coverage></div><div class=\"ute-dataManager-accountsSummary-overageBarContainer\" data-ng-show=\":: dataManagerAccountsSummaryDirective.inOverage()\" data-ng-style=\"{\'bottom\': dataManagerAccountsSummaryDirective.getOverageBottomPosition() + \'px\'}\"><ute-data-manager-accounts-summary-overage-bar></ute-data-manager-accounts-summary-overage-bar></div><div class=\"ute-dataManager-accountsSummary-dataAddedBarContainer\" data-ng-show=\":: dataManagerAccountsSummaryDirective.hasAddedData()\" data-ng-style=\"{ \'bottom\': dataManagerAccountsSummaryDirective.getDataAddedBottomPosition() + \'px\'}\"><ute-data-manager-accounts-summary-data-added-bar data-height=\"{{dataManagerAccountsSummaryDirective.getDataAddedBarHeight()}}\"></ute-data-manager-accounts-summary-data-added-bar></div></div><div class=\"ute-data-manager-accounts-summary-footer-container\"><ute-data-manager-accounts-summary-footer></ute-data-manager-accounts-summary-footer></div></div><div class=\"video-throttle-tag-list-container\"><ute-data-manager-video-throttle-control-tag-list data-ng-if=\"dataManagerActiveTabIndex === 1\"></ute-data-manager-video-throttle-control-tag-list></div>");
$templateCache.put("module/dataManager/dataManagerBadgeList/dataManagerBadgeList.partial.html","<div class=\"ute-dataManager-badgeList\"><div class=\"ute-dataManager-badgeList-headBadge\">{{dataManagerBadgeListDirective.getBadgeList()[0].ctn}} <label><span class=\"ute-dataManager-badegeList-screenReaderOnly\">{{\'ute.dataManager.badge.list.headBadgeLabel\' | translate}}</span><md-button class=\"ute-dataManager-badegeList-clickArea\" data-ng-click=\"dataManagerBadgeListDirective.badgeClick()\" data-ng-disabled=\"!dataManagerBadgeListDirective.checkBadgeEnabled()\"></md-button><div class=\"ute-dataManager-badgeList-badgeTextContainer\"><span class=\"ute-dataManager-badgeList-planName\" ng-if=\"!dataManagerBadgeListDirective.isInfinitePlan()\" data-ng-bind-html=\"dataManagerBadgeListDirective.getBadgeList().planName | translate\"></span> <span class=\"ute-dataManager-badgeList-planName\" ng-if=\"dataManagerBadgeListDirective.isInfinitePlan()\" ng-bind-html=\"\'ute.dataManager.badge.list.infinitePlan\' | translate\"></span><div class=\"ute-dataManager-badgeList-linesCopy\" data-ng-bind-html=\"\'ute.dataManager.badge.list.linesInGroup\' | translate : { \'lines\' : dataManagerBadgeListDirective.getBadgeListSubscribers().length - dataManagerBadgeListDirective.getSeeAddLineLinks().length }\"></div><div ng-if=\"dataManagerBadgeListDirective.isTargetHeroOffer\" class=\"ute-dataManager-badgeList-offer\"><img class=\"ute-dataManager-badgeList-promo\" src=\"/web/totes/cms/images/promo.png\"> <span class=\"ute-dataManager-badgeList-exclusive-offer\" data-ng-bind-html=\"\'ute.dataManager.badge.list.exclusiveOffer\' | translate\"></span></div></div><i class=\"ute-dataManager-badgeList-headBadgeArrow\"></i></label></div><div class=\"ute-dataManager-badgeList-individualBadgeContainer\"><div ng-repeat=\"sl in dataManagerBadgeListDirective.getBadgeListSubscribers()\"><div class=\"ute-dataManager-badgeList-individualBadge\" ng-if=\"!sl.isLink\"><md-button class=\"ute-dataManager-badegeList-clickArea\" aria-label=\"{{sl.displayName}}\" data-ng-click=\"dataManagerBadgeListDirective.goToDashboard(sl.ctn)\" data-ng-disabled=\"!dataManagerBadgeListDirective.checkBadgeEnabled()\"></md-button><div class=\"ute-dataManager-badgeList-individualBadgeColor\" data-ng-style=\"{\'backgroundColor\': sl.colorCode}\"></div><i class=\"ute-dataManager-badgeList-individualBadgeIcon\"></i><div class=\"ute-dataManager-badgeList-individualBadgeInfo\">{{sl.displayName}}, {{sl.ctn | ute_common_filter_phone : \'$1-$2-$3\'}}</div><i class=\"ute-dataManager-badgeList-individualBadgeArrow\"></i></div><div class=\"ute-dataManager-badgeList-SEEBadge\" data-ng-class=\"ute-dataManager-badgeList-seeLink-container\" ng-if=\"sl.isLink\" data-ng-style=\"{\'color\': sl.colorCode}\"><md-button class=\"ute-dataManager-badegeList-clickArea\" aria-label=\"{{sl.displayNameAtr}}\" data-ng-click=\"dataManagerBadgeListDirective.goToAddLine()\"></md-button><div class=\"ute-dataManager-badgeList-individualBadgeColor\" data-ng-style=\"{\'backgroundColor\': sl.colorCode}\"></div><div data-ng-style=\"{\'backgroundColor\': sl.colorCode}\" class=\"ute-dataManager-badgeList-seeLink-circle account-overview-page\"><md-icon class=\"ute-icon-plus ute-dataManager-badgeList-seeLink-plus-icon\"></md-icon></div><div class=\"row\" layout-align=\"center center\"><div class=\"ute-dataManager-badgeList-individualBadgeInfo ute-dataManager-badgeList-seeLink-individualBadgeInfo account-overview-page\"><div ng-bind-html=\"sl.displayName\"></div><div><span class=\"ute-dataManager-badgeList-seeLink-discount\" style=\"padding: 0;\" data-ng-if=\"sl.discount.rateType===\'D\'\"><span ng-if=\"sl.language === \'en\'\">Save</span><span ng-if=\"sl.language === \'fr\'\">&#201;conomisez</span> {{sl.discount.getDiscountAmount() | currency : \'$\' : 0}} {{sl.language == \'en\' ? \'more\' : \'de plus\'}}</span> <span class=\"ute-dataManager-badgeList-seeLink-discount\" style=\"padding: 0;\" data-ng-if=\"sl.discount.rateType===\'P\'\"><span ng-if=\"sl.language === \'en\'\">Save</span><span ng-if=\"sl.language === \'fr\'\">&#201;conomisez</span> %{{sl.discount.rate}} {{sl.language == \'en\' ? \'more\' : \'de plus\'}}</span></div></div><div></div></div></div></div></div><div class=\"ute-dataManager-badgeList-individualBadgeLoading\" ng-if=\"dataManagerBadgeListDirective.isDiscountLoading()\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading\" width=\"40px\"></div></div>");
$templateCache.put("module/dataManager/dataManagerDashboard/dataManagerDashboard.partial.html","<div class=\"ute-dataManager\"><div class=\"ute-dataManager-dashboard-usageDialContainer\"><ute-data-manager-usage-dial></ute-data-manager-usage-dial></div><div class=\"ute-dataManager-dashboard-sharedUsageBar hidden-xs\"><ute-data-manager-shared-usage-bar></ute-data-manager-shared-usage-bar></div><div class=\"ute-dataManager-dashboard-dataAlertsContainer col-xs-12 hidden-sm hidden-md hidden-lg\"><ute-data-manager-data-alerts></ute-data-manager-data-alerts></div><br><br><br><br><br><br><div class=\"ute-dataManager-dashboard-controlListContainer hidden-xs\" ng-if=\"!dataManagerDashboard.getIsVideoQualityAPICallInProgress()\"><ute-data-manager-data-video-throttle-wrapper></ute-data-manager-data-video-throttle-wrapper></div><div class=\"col-xs-12 hidden-sm hidden-md hidden-lg ute-dataManager-dashboard-dataControlTagList-container\" ng-if=\"!dataManagerDashboard.getIsVideoQualityAPICallInProgress()\"><ute-data-manager-data-control-tag-list></ute-data-manager-data-control-tag-list></div><br><br><br><br><br><br><div class=\"hidden-xs\"><div class=\"ute-dataManager-dashboard-tabsContainer\" data-ng-if=\"!dataManagerDashboard.getUsageDetailsCallInProgress()\"><ute-data-manager-tabs></ute-data-manager-tabs></div><div class=\"ute-dataManager-dashboard-tabsContentContainer\" data-ng-if=\"dataManagerDashboard.tabsContentOkayToLoad()\"><ute-data-manager-tabs-content></ute-data-manager-tabs-content></div></div></div>");
$templateCache.put("module/dataManager/dataManagerDashboard/dataManagerEnterMain.view.html","<div class=\"ute-dataManager\"><div class=\"container\" ng-if=\"showInfinitePlanAlert()\"><rogers-alert alert-data=\"alertData\"></rogers-alert></div><h1 class=\"ute-data-manager-screen-read-only\" data-ng-bind-html=\"\'ute.dataManager.dashboard.heading\' | translate\"></h1><ute-data-manager-dasboard></ute-data-manager-dasboard></div>");
$templateCache.put("module/dataManager/dataManagerDataAccess/dataManagerDataAccess.partial.html","<div class=\"ute-dataManager-dataAccess ute-dataManager-dataAccess-left\"><div class=\"ute-dataManager-dataAccess-md-switch-container\"><md-switch data-ng-model=\"dataManagerDataAccessDirective.dataAccess\" data-ng-disabled=\"dataManagerDataAccessDirective.getSetBlockCallInProgress()\" data-ng-change=\"dataManagerDataAccessDirective.dataAccessChange(dataManagerDataAccessDirective.dataAccess)\" ng-swipe-left=\"dataManagerDataAccessDirective.swipeLeft()\" ng-swipe-right=\"dataManagerDataAccessDirective.swipeRight()\" class=\"ute-dataManager-dataAccess-md-switch\" aria-label=\"Data Access\">{{ (dataManagerDataAccessDirective.dataAccess ? (onCopy | translate) : (offCopy | translate)) }}</md-switch></div><div style=\"position:absolute; left:-50000px;\"><ute-data-manager-increase-plan-directive data-id=\"dataAccess\"></ute-data-manager-increase-plan-directive></div></div>");
$templateCache.put("module/dataManager/dataManagerDataAlerts/dataManagerDataAlerts.view.html","<div class=\"row ute-dataManager-dataAlerts ute-dataManager-dataAlerts2\"><div class=\"col-xs-6\"><span class=\"ute-dataManager-dataAlerts-title\">{{dataManagerDataAlerts.getAlertTagCopy() | translate}}</span></div><div class=\"col-xs-6\"><md-button class=\"dataManager-with-new-label ute-button-cancel ute-dataManager-dataAlerts-manageButton fdm-phase-ii-set-video-quality ute-data-Manager-text-styling\" data-ng-class=\"dataManagerDataAlerts.getIsVideoThrottlePermitted() ? \'ute-data-manager-set-video-quality-color\' : \'ute-data-manager-manage-data-alerts-color\'\" data-ng-click=\"dataManagerDataAlerts.getIsVideoThrottlePermitted() ? dataManagerDataAlerts.goToManageAlerts(1):dataManagerDataAlerts.goToManageAlerts(0)\"><span class=\"\" data-ng-bind-html=\"dataManagerDataAlerts.getManageButtonCopy() | translate\"></span></md-button></div></div><br><div class=\"ute-dataManager-dataAlertsGraphContainer\" data-ng-click=\"dataManagerDataAlerts.goToManageAlerts(0)\"><div ng-repeat=\"line in dataManagerDataAlerts.getFilteredList()\" class=\"ute-dataManager-dataAlerts-barContainer\" data-ng-style=\":: {\'width\': dataManagerDataAlerts.getBarsWidth() + \'%\'}\"><ute-vertical-stack-bar-graph data-color-code=\"{{:: line.colorCode}}\" data-base-copy=\"{{ dataManagerDataAlerts.graphBaseCopy(line) }}\" data-max-limit=\"{{:: dataManagerDataAlerts.getHighestDataPoint() }}\" data-primary-value=\"{{:: line.dataUsed }}\" data-secondary-value=\"{{ dataManagerDataAlerts.graphSecondaryValue(line) }}\" data-flip-height=\"20\" data-max-height=\"50\" data-button-mode=\"false\" data-base-flip-hidden=\"false\"></ute-vertical-stack-bar-graph></div></div><div class=\"container ute-dataManager-dataAlerts-manageDataAlertsButtonContainer ute-data-manager-font-wrap-xs\"><md-button class=\"ute-md-primary-button ute-dataManager-dataAlerts-manageDataAlertsButton\" data-ng-click=\"dataManagerDataAlerts.goToManageAlerts(0)\">{{:: \'ute.dataManager.dataAlerts.manageAlerts\' | translate}}</md-button></div>");
$templateCache.put("module/dataManager/dataManagerDataAndVideoThrottleWrapper/dataManagerDataAndVideoThrottleWrapper.partial.html","<div class=\"ute-dataManager-dataControlList\"><div class=\"container\" data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getIsVideoThrottlePermitted()\"><h2 class=\"ute-dataManager-dataControlList-myDataAlertsTitle ute-dataManager-dataControlList-myDataAlertsTitle-heading\">{{:: \'ute.dataManager.dataControlList.sharedLines\' | translate}}<div data-ng-if=\"dataManagerDataVideoThrottleWrapper.getUsageDetailsCallInProgress()\" class=\"ute-data-manager-vt-loading-widget\" style=\"\">&nbsp; <img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></h2><md-button data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getUsageDetailsCallInProgress()\" class=\"ute-md-secondary-button ute-dataManager-dataControlList-closeDataAlertsButton manage-data-usage-alert-btn\" data-ng-click=\"dataManagerDataVideoThrottleWrapper.toggleDataAlertsTab(0)\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"shareEverythingDashboard.manageDataAlerts,event.selfServeComplete\",\"suppressTracking\":{{dataManagerDataVideoThrottleWrapper.getButtonCopy().indexOf(\"close\") === -1}}}\'>{{dataManagerDataVideoThrottleWrapper.getButtonCopy() | translate}} <span class=\"ute-icon-arrow-down\" data-ng-class=\"dataManagerDataVideoThrottleWrapper.getButtonArrowClass()\"></span></md-button></div><div class=\"container data-alert-and-set-video-quality-link-wrapper\" data-ng-if=\"dataManagerDataVideoThrottleWrapper.getIsVideoThrottlePermitted()\"><h2 class=\"ute-dataManager-dataControlList-myDataAlertsTitle ute-dataManager-dataControlList-myDataAlertsTitle-heading\" data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getDataAlertsOpen()\">{{:: \'ute.dataManager.dataControlList.sharedLines\' | translate}}<div data-ng-if=\"dataManagerDataVideoThrottleWrapper.getUsageDetailsCallInProgress()\" class=\"ute-data-manager-vt-loading-widget\" style=\"\">&nbsp; <img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></h2><div class=\"btn_holder\"><md-button data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getUsageDetailsCallInProgress()\" class=\"ute-md-secondary-button ute-dataManager-dataControlList-closeDataAlertsButton manage-data-usage-alert-btn\" data-ng-click=\"dataManagerDataVideoThrottleWrapper.toggleDataAlertsTab(0)\" tabindex=\"0\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"shareEverythingDashboard.manageDataAlerts,event.selfServeComplete\",\"suppressTracking\":{{dataManagerDataVideoThrottleWrapper.getButtonCopy().indexOf(\"close\") === -1}}}\'>{{dataManagerDataVideoThrottleWrapper.getButtonCopy() | translate}}</md-button><a data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getUsageDetailsCallInProgress() && !dataManagerDataVideoThrottleWrapper.getDataAlertsOpen()\" data-ng-click=\"dataManagerDataVideoThrottleWrapper.toggleDataAlertsTab(1)\" data-ng-keypress=\"($event.which === 13)?dataManagerDataVideoThrottleWrapper.toggleDataAlertsTab(1):0\" class=\"set-video-quality-btn-link wd-upgrade-device-button\"><span data-ng-bind-html=\"\'ute.dataManager.dataAndVideoThrottleWrapper.setVideoQuality\' | translate\"></span></a></div></div></div><ute-content-expand data-is-open=\"dataManagerDataVideoThrottleWrapper.getDataAlertsOpen()\" data-border-type=\"\"><ute-data-manager-data-control-list data-ng-if=\"!dataManagerDataVideoThrottleWrapper.getIsVideoThrottlePermitted()\"></ute-data-manager-data-control-list><md-tabs class=\"md-dynamic-height ute-dataManager-dataControl-tabs md-tabs-set-video-quality\" md-swipe-content=\"false\" md-selected=\"dataManagerDataVideoThrottleWrapper.dataManagerActiveTabIndex\" data-ng-if=\"dataManagerDataVideoThrottleWrapper.getIsVideoThrottlePermitted()\"><md-tab md-on-select=\"dataManagerDataVideoThrottleWrapper.setDataAlertsActiveTabIndex(0)\"><md-tab-label class=\"md-label-font-bold\">{{:: \'ute.dataManager.dataControlList.manageDataAlerts\' | translate}}</md-tab-label><md-tab-body><ute-data-manager-data-control-list></ute-data-manager-data-control-list></md-tab-body></md-tab><md-tab md-on-select=\"dataManagerDataVideoThrottleWrapper.setDataAlertsActiveTabIndex(1)\"><md-tab-label><span data-ng-bind-html=\"\'ute.dataManager.dataControlList.videoAndStreaming\' | translate\"></span></md-tab-label><md-tab-body><ute-data-manager-video-throttle-control-list></ute-data-manager-video-throttle-control-list></md-tab-body></md-tab></md-tabs></ute-content-expand>");
$templateCache.put("module/dataManager/dataManagerDataControlList/dataManagerDataControlList.partial.html","<div class=\"ute-dataManager-dataControlList-titleBar\" data-ng-if=\"!dataManagerDataControlList.getUsageDetailsCallInProgress() && (dataManagerDataControlList.getDataAlertsOpen() || dataManagerDataControlList.isConsoleLoaded())\"><div class=\"container ute-dataManager-dataControlList-titleBarContainer\"><div class=\"row\"><div class=\"col-lg-3 col-md-3 col-sm-3\"><div class=\"ute-dataManager-dataControlList-titleCopy ute-dataManager-dataControlList-sharedLinesHeader\">{{:: \'ute.dataManager.dataControlList.mySharedLines\' | translate}}</div></div><div data-ng-class=\"dataManagerDataControlList.getTitleBarClass()\"><div class=\"ute-dataManager-dataControlList-titleCopy ute-dataManager-dataControlList-PersonalizedDataHeader\">{{::\'ute.dataManager.dataControlList.dataAlertsByLine\' | translate}}</div></div><div class=\"col-lg-3 col-md-3 col-sm-3\" data-ng-if=\":: !dataManagerDataControlList.isBucketSizeUnavailableUntilNextBillCycle()\"><div class=\"ute-dataManager-dataControlList-titleCopy ute-dataManager-dataControlList-alertedDataHeaderContainer\"><span class=\"ute-dataManager-dataControlList-alertedDataHeader\" data-ng-bind-html=\":: \'ute.dataManager.dataControlList.alertedDataTotal\' | translate\"></span> <span class=\"ute-dataManager-dataControlList-alertedDataHeaderValue\">{{ dataManagerDataControlList.getSavedAlertedDataValue() | number : dataManagerDataControlList.getPrecisionPlace()}}</span> <span class=\"ute-dataManager-dataControlList-alertedDataHeaderSlash\">/&nbsp;</span><div class=\"ute-dataManager-dataControlList-alertedDataHeaderTotalContainer\"><span class=\"ute-dataManager-dataControlList-alertedDataHeaderTotal\">{{:: dataManagerDataControlList.getTotalDataLimit() | ute_common_filter_data_conversion: \'mb\' : 1024 : 1 : true: false | translate}}</span></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-2\"><div class=\"ute-dataManager-dataControlList-titleAdd\" ng-if=\"!dataManagerDataControlList.isInfinitePlan()\"><div class=\"ute-dataManager-dataControlList-titleAddMore\"><div class=\"ute-dataManager-increasePlan-increaseContainer\"><md-button data-ng-click=\"dataManagerDataControlList.buttonClick()\" class=\"hidden-xs md-fab ute-dataManager-usageDial-mdIconButton\" style=\"box-shadow:none;\" data-ng-disabled=\":: !dataManagerDataControlList.isAllowedToPurchaseData()\"><md-icon class=\"ute-icon-plus ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-increasePlan-icon\"></md-icon><span class=\"sr-only\">{{dataManagerDataControlList.getAddDataTranslationKey() | translate}}</span></md-button></div></div><div class=\"ute-dataManager-dataControlList-titleAddData hidden-xs\">{{dataManagerDataControlList.getAddDataTranslationKey() | translate}}</div></div></div><div class=\"col-lg-2 col-md-2 col-sm-2\"><div class=\"ute-dataManager-dataControlList-titleCopy ute-dataManager-dataControlList-dataAccessHeader\" data-ng-bind-html=\":: \'ute.dataManager.dataControlList.dataAccess\' | translate\"></div></div></div></div></div><div class=\"container\" data-ng-if=\"!dataManagerDataControlList.getUsageDetailsCallInProgress() && (dataManagerDataControlList.getDataAlertsOpen() || dataManagerDataControlList.isConsoleLoaded())\"><div data-ng-repeat=\"line in dataManagerDataControlList.getDataControlList()\"><ute-data-manager-data-control data-line-index=\"{{:: $index}}\" data-display-name=\"{{:: line.displayName}}\" data-ctn=\"{{:: line.ctn}}\" data-data-limit=\"{{:: dataManagerDataControlList.getTotalDataLimit()}}\" data-color-code=\"{{:: line.colorCode}}\" data-data-used=\"{{:: line.dataUsed}}\" data-data-alert-at=\"{{line.dataAlertAt}}\" data-saved-alert-value=\"{{:: line.savedAlertValue}}\" data-is-alerts-recipient=\"{{ (dataManagerDataControlList.getAlertsRecipientCTN() === line.ctn)}}\" data-has-data=\"{{:: line.hasData}}\" data-use-alert=\"line.useAlert\" data-data-access=\"{{line.dataAccess}}\" data-status=\"{{:: line.status}}\" data-group-status=\"{{:: line.groupStatus}}\"></ute-data-manager-data-control></div><div class=\"row\"><div class=\"col-lg-10 col-md-10 col-sm-10\"><div class=\"ute-dataManager-dataControlList-myDataAlertsFooter\">{{:: \'ute.dataManager.dataControlList.alertedDataTotalFooter\' | translate}} <span class=\"ute-dataManager-dataControlList-myDataAlertsFooterValue\">{{ dataManagerDataControlList.getSavedAlertedDataValue() | number : dataManagerDataControlList.getPrecisionPlace()}}</span> <span class=\"ute-dataManager-dataControlList-myDataAlertsFooterSlash\">/</span> {{:: dataManagerDataControlList.getTotalDataLimit() | ute_common_filter_data_conversion: \'mb\' : 1024 : 1 : true: false | translate}}</div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerDataControlTagList/dataManagerDataControlTagList.view.html","<div class=\"ute-dataManager-dataControlTagList\"><div data-ng-repeat=\"tag in dataManagerDataControlTagList.getDataControlList()\"><ute-data-manager-data-control-tag data-color-code=\"{{:: tag.colorCode}}\" data-display-name=\"{{:: tag.displayName}}\" data-ctn=\"{{:: tag.ctn}}\" data-is-alerts-recipient=\"{{ dataManagerDataControlTagList.isAlertsRecipient(tag.ctn)}}\" data-data-used=\"{{:: tag.dataUsed}}\" data-data-alert-at=\"{{:: tag.savedAlertValue}}\" data-use-alert=\"{{:: tag.useAlert}}\" data-data-access=\"{{:: tag.dataAccess}}\" data-button-mode=\"{{:: true}}\" data-status=\"{{:: tag.status}}\" data-group-status=\"{{:: tag.groupStatus}}\" data-index=\"{{:: $index}}\" data-video-quality-reduced=\"{{:: tag.videoQualityReduced}}\"></ute-data-manager-data-control-tag></div><div data-ng-repeat=\"tab in dataManagerDataControlTagList.getSeeLinks()\"><div class=\"ute-dataManager-dataControlTag\" data-ng-style=\":: {\'background\': colorCode}\" data-ng-click=\"dataManagerDataControlTagList.seeAddLine()\"><div class=\"ute-dataManager-dataControlTag-container\" style=\"border-color:#F1F3F5;\"><div class=\"row ute-dataManager-dataControlTag-row\" style=\"min-height: 103px; padding-top: 25px;\"><div class=\"col-xs-11 ute-dataManager-dataControlTag-leftCol\"><div data-ng-style=\"{\'backgroundColor\': tab.colorCode}\" class=\"ute-dataManager-badgeList-seeLink-circle fdm-dashboard\"><md-icon class=\"ute-icon-plus ute-dataManager-badgeList-seeLink-plus-icon material-icons\" style=\"padding-left:5px;padding-right:5px\"></md-icon></div><div calss=\"add-a-line-desc\" style=\"float:left;line-height: 1.6;\" data-ng-style=\"{\'color\': tab.colorCode}\"><div class=\"ute-dataManager-dataControlTag-displayName\" data-ng-style=\"{\'color\': tab.colorCode}\" data-ng-bind-html=\":: tab.displayName\"></div><div class=\"ute-dataManager-tabs-seeLink-discount\" data-ng-if=\"tab.discount.rateType===\'D\'\"><span ng-if=\"tab.language === \'en\'\">Save</span><span ng-if=\"tab.language === \'fr\'\">&#201;conomisez</span> {{:: tab.discount.getDiscountAmount() | currency : \'$\' : 0}} {{tab.language == \'en\' ? \'more\' : \'de plus\'}}</div><div class=\"ute-dataManager-tabs-seeLink-discount\" data-ng-if=\"tab.discount.rateType===\'P\'\"><span ng-if=\"tab.language === \'en\'\">Save</span><span ng-if=\"tab.language === \'fr\'\">&#201;conomisez</span> %{{:: tab.discount.rate}} {{tab.language == \'en\' ? \'more\' : \'de plus\'}}</div></div></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerErrorPage/dataManagerErrorPage.view.html","<div class=\"ute-dataManager-errorPage-background\"><div class=\"ute-dataManager-errorPage-iconContainer\"><i class=\"ute-dataManager-errorPage-icon ute-icon-error\"></i></div><div class=\"ute-dataManager-errorPage-heading\" data-ng-bind-html=\"\'ute.dataManager.errorPage.heading\' | translate\"></div><div class=\"ute-dataManager-errorPage-suggestion\" data-ng-bind-html=\"\'ute.dataManager.errorPage.suggestion\' | translate\"></div><md-button class=\"ute-dataManager-errorPage-button ute-button-secondary ute-md-secondary-button\" data-ng-bind-html=\"\'ute.dataManager.errorPage.button\' | translate\" data-ng-click=\"familyDataManagerErrorPage.backToDashboard()\"></md-button></div>");
$templateCache.put("module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlan.partial.html","<div class=\"ute-dataManager-increasePlan-increaseContainer\"><md-button data-ng-if=\"!dataManagerIncreasePlanDirective.isAddDataVisible() || !dataManagerIncreasePlanDirective.isAllowedToPurchaseData()\" data-ng-click=\"dataManagerIncreasePlanDirective.addMoreTagSwitch()\" class=\"hidden-xs md-fab ute-dataManager-usageDial-mdIconButton ute-dataManager-increasePlan-button\" style=\"box-shadow:none;\" data-ng-disabled=\"(!disabledOverride && !dataManagerIncreasePlanDirective.isStrokeHidden())\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":false,\"mappingKey\":\"fdmAddData.open,shareEverything.dashboard\"}\'><span class=\"sr-only\">{{ :: \'ute.dataManager.usageDial.increaseData\' | translate}}</span><md-icon class=\"ute-icon-plus ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-increasePlan-icon\"></md-icon></md-button><md-button data-ng-if=\"!dataManagerIncreasePlanDirective.isAddDataVisible() || !dataManagerIncreasePlanDirective.isAllowedToPurchaseData()\" data-ng-click=\"dataManagerIncreasePlanDirective.addMoreModalMobile()\" class=\"visible-xs md-fab ute-dataManager-usageDial-mdIconButton ute-dataManager-increasePlan-button\" style=\"box-shadow:none;\" data-ng-disabled=\"!dataManagerIncreasePlanDirective.isAllowedToPurchaseData() && !dataManagerIncreasePlanDirective.isOverage()\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":false,\"isModalPopup\":true,\"pageView\":true,\"mappingKey\":\"fdmAddData.open,shareEverything.dashboard\"}\'><md-icon class=\"ute-icon-plus ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-increasePlan-icon\"></md-icon></md-button></div><div class=\"hidden-xs ute-dataManager-increasePlan-additionalTag\" data-ng-show=\"dataManagerIncreasePlanDirective.addMoreTag\" ng-class=\"dataManagerIncreasePlanDirective.expandAnimation\"><div data-ng-include=\"dataManagerIncreasePlanDirective.getSharedIncreasePartial()\"></div></div>");
$templateCache.put("module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlan.partial.popup.html","<div data-ng-if=\"!dataManagerIncreasePlanDirective.showWcocConsent\"><div class=\"ute-dataManager-increasePlan-additionalTag-topSpacer\" ng-bind-html=\"\'ute.dataManager.increasePlan.increaseData\' | translate\"></div><div class=\"ute-dataManager-increasePlan-additionalTag-firstBody\" data-ng-bind-html=\"\'ute.dataManager.increasePlan.firstBody\' | translate\"></div><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-dataManager-increasePlanModal-modalClose\" data-ng-click=\"dataManagerIncreasePlanDirective.noSelection()\"></div>");
$templateCache.put("module/dataManager/dataManagerIndividualSummary/dataManagerIndividualSummary.html","<div class=\"ute-dataManager\" ng-if=\"familyDataManagerIndividualSummary.getUsageDetailsCallInProgress()\"><div class=\"container\"><div class=\"row\"><div class=\"largeload\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></div></div></div><div class=\"ute-dataManager\" ng-if=\"!familyDataManagerIndividualSummary.getUsageDetailsCallInProgress()\"><ute-data-manager-individual-summary></ute-data-manager-individual-summary></div>");
$templateCache.put("module/dataManager/dataManagerIndividualSummary/dataManagerIndividualSummary.partial.html","<md-button class=\"ute-dataManager-individualSummary-clickArea\" aria-label=\"Back to share everything plan page\" data-ng-click=\"dataManagerIndividualSummary.goToDashboard()\"><i class=\"ute-icon-arrow-right ute-dataManager-individualSummary-chevronIcon\"></i> {{\'ute.dataManager.individualSummary.back\' | translate}}</md-button><ute-data-manager-tabs-content></ute-data-manager-tabs-content>");
$templateCache.put("module/dataManager/dataManagerInfoBlock/dataManagerInfoBlock.view.html","<div class=\"ute-data-manager-info-block\" data-ng-class=\"dataManagerInfoBlock.infoBlock.blockType\"><div class=\"info-block-wrap\" data-ng-class=\"dataManagerInfoBlock.infoBlock.blockShow ? \'active\': \'\'\"><div class=\"info-block-icon\"><i ng-class=\"dataManagerInfoBlock.infoBlock.blockIcon\"></i></div><div class=\"info-block-info-text\" data-ng-class=\"dataManagerInfoBlock.infoBlock.blockMessage.liveChat ? \'livechatLink\': \'\'\"><div class=\"info-block-info-text-headline\" data-ng-if=\"(dataManagerInfoBlock.infoBlock.blockMessage.messageHead | translate) !== \'\'\">{{dataManagerInfoBlock.infoBlock.blockMessage.messageHead | translate}}</div><div class=\"info-block-info-text-message\"><p>{{dataManagerInfoBlock.infoBlock.blockMessage.messageBody | translate}}</p></div></div><div data-ng-if=\"dataManagerInfoBlock.infoBlock.blockMessage.liveChat\" class=\"info-block-live-chat\"><md-button class=\"ute-button-secondary ute-md-secondary-button ute-dataManager-dataControl-addLineButton md-button md-ink-ripple\" type=\"button\" ng-transclude=\"\" aria-label=\"Add Data to Line\"></md-button></div></div></div>");
$templateCache.put("module/dataManager/dataManagerProfileAlert/dataManagerProfileAlert.partial.html","<div class=\"ute-dataManager-profileAlert\" data-ng-init=\"dataManagerProfileAlertDirective.initialize()\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-dataManager-profileAlert-heading\">{{\'ute.dataManager.profile.alert.headline\' | translate}}</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-dataManager-profileAlert-secondaryContainer\"><div class=\"ute-dataManager-profileAlert-secondaryHeading\">{{\'ute.dataManager.profile.alert.doubleRainbow\' | translate}}</div><div class=\"ute-dataManager-profileAlert-secondaryContent\">{{\'ute.dataManager.profile.alert.description\' | translate}}</div></div></div></div><div class=\"row ute-dataManager-profileAlert-bottomRow\"><div class=\"ute-dataManager-profileAlert-selectLabel\">{{\'ute.dataManager.profile.alert.sendTo\' | translate}}</div><div class=\"ute-dataManager-profileAlert-selectContainer\"><md-select class=\"ute-dataManager-profileAlert-select\" md-container-class=\"ute-dataManager-profileAlert-selectMenu\" name=\"repeatSelect\" id=\"repeatSelect\" data-ng-model=\"dataManagerProfileAlertDirective.selectedIndex\" data-ng-change=\"dataManagerProfileAlertDirective.changeAlert()\"><md-option value=\"-1\" disabled=\"\">{{\'ute.dataManager.profile.alert.selectOne\' | translate}}</md-option><md-option ng-repeat=\"option in dataManagerProfileAlertDirective.getOptions()\" ng-default=\"dataManagerProfileAlertDirective.selectedIndex === $index\" data-ng-disabled=\"!option.isAllowedToBeDataManager\" value=\"{{$index}}\">{{option.displayName}}<span class=\"ute-dataManager-profileAlert-selectContainerSpace\">&nbsp;</span>: {{option.ctn | ute_common_filter_phone}}</md-option></md-select></div><md-button class=\"ute-md-primary-button ute-dataManager-profileAlert-saveButton md-button md-ink-ripple\" type=\"button\" name=\"button_save\" data-ng-if=\"dataManagerProfileAlertDirective.confirmChange\" data-ng-click=\"dataManagerProfileAlertDirective.changeSave()\" adl-event-track=\'{\"mappingKey\":\"set-recipient,event.selfServeStart\"}\'>{{\'ute.dataManager.profile.alert.saveButton\' | translate}}</md-button></div></div></div>");
$templateCache.put("module/dataManager/dataManagerSharedUsageBar/dataManagerSharedUsageBar.partial.html","<div class=\"ute-dataManager-sharedUsageBar\"><div class=\"container\"><span class=\"ute-dataManager-sharedUsageBar-title\">{{dataManagerSharedUsageBar.getSharedUsageBarTranslationKey() | translate}}<div data-ng-if=\"dataManagerSharedUsageBar.getUsageDetailsCallInProgress()\" style=\"display:inline; position: relative; top: -15px;\">&nbsp;<img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></span><div class=\"row\" data-ng-if=\"!dataManagerSharedUsageBar.getUsageDetailsCallInProgress()\"><div class=\"xs-col-12\"><div class=\"ute-dataManager-sharedUsageBar-meterContainer\"><div class=\"ute-dataManager-sharedUsageBar-meter\"><div ng-repeat=\"usage in dataManagerSharedUsageBar.getFilteredList()\"><ute-data-manager-shared-usage-bar-segment data-color-code=\"{{:: usage.colorCode}}\" data-data-used=\"{{:: usage.dataUsed}}\" data-data-limit=\"{{:: dataManagerSharedUsageBar.getDataLimitWithOverage()}}\" data-index=\"{{:: $index}}\" data-total-lines=\"{{:: dataManagerSharedUsageBar.getDataControlList().length}}\" data-last-item=\"{{:: $last}}\"></ute-data-manager-shared-usage-bar-segment></div></div><div class=\"ute-dataManager-sharedUsageBar-dataMeter\" ng-if=\"!dataManagerSharedUsageBar.isCare\"><div class=\"ute-dataManager-sharedUsageBar-indicator\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLine\"></div><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy ute-dataManager-sharedUsageBar-indicatorCopyFirst\">{{:: 0 | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): 0: true: false | translate}}</span></div><div class=\"hidden ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-mid\" data-ng-style=\"{ left : dataManagerSharedUsageBar.getMidPointPercentage() + \'%\' }\" data-ng-if=\"dataManagerSharedUsageBar.getMidPointValue() > 0\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLineMiddle\"></div><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy ute-dataManager-sharedUsageBar-indicatorCopySecond\">{{ dataManagerSharedUsageBar.getMidPointValue() | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): (dataManagerSharedUsageBar.getMidPointValue() > dataManagerSharedUsageBar.getBase() ? 1 : 0): true: false | translate}}</span></div><div class=\"hidden ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-limit\" data-ng-style=\"{ left : dataManagerSharedUsageBar.getBaseDataLimitPosition() + \'%\' }\" data-ng-if=\"dataManagerSharedUsageBar.getDataLimit() > 0\"><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy\" data-ng-class=\":: dataManagerSharedUsageBar.getIndicatorCopy()\">{{:: dataManagerSharedUsageBar.getDataLimit() | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): (dataManagerSharedUsageBar.getDataLimit() > dataManagerSharedUsageBar.getBase() ? 1 : 0): true: false | translate}}</span></div><div class=\"ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-overage\" data-ng-if=\"dataManagerSharedUsageBar.getOverage() > 0\"><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy ute-dataManager-sharedUsageBar-indicatorCopyOverage\">{{:: dataManagerSharedUsageBar.getTotalDataUsage() | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): (dataManagerSharedUsageBar.getTotalDataUsage() > dataManagerSharedUsageBar.getBase() ? 1 : 0): true: false | translate}}<br>{{:: \'ute.dataManager.sharedUsageBar.used\' | translate}}</span></div><div class=\"ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-addedExtra\" data-ng-style=\"{ left : dataManagerSharedUsageBar.getDataLimitWithAddedExtraPercentage() + \'%\' }\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLine\"></div><span class=\"ute-dataManager-sharedUsageBar-extraAddedCopy\">{{ dataManagerSharedUsageBar.getDataLimitIncBonuses() | ute_common_filter_data_conversion: \'mb\': 1024 : 1: true: false | translate}}</span></div></div><div class=\"ute-dataManager-sharedUsageBar-dataMeter\" ng-if=\"dataManagerSharedUsageBar.isCare\"><div class=\"ute-dataManager-sharedUsageBar-indicator\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLine\"></div><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy ute-dataManager-sharedUsageBar-indicatorCopyFirst\">{{:: 0 | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): 0: true: false | translate}}</span></div><div class=\"ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-limit\" data-ng-style=\"{ left : dataManagerSharedUsageBar.getDataLimitWithAddedExtraPercentage()+\'%\' }\" data-ng-if=\"dataManagerSharedUsageBar.getDataLimit() > 0\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLine\"></div><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy\" data-ng-class=\":: dataManagerSharedUsageBar.getIndicatorCopy()\">{{:: (dataManagerSharedUsageBar.getDataLimitIncBonuses()) | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): (dataManagerSharedUsageBar.getDataLimitIncBonuses() > dataManagerSharedUsageBar.getBase() ? 1 : 0): true: false | translate}}</span></div><div class=\"ute-dataManager-sharedUsageBar-indicator ute-dataManager-sharedUsageBar-indicator-overage\" data-ng-if=\"dataManagerSharedUsageBar.getOverage() > 0\" data-ng-style=\"{ left : \'100%\' }\"><div class=\"ute-dataManager-sharedUsageBar-indicatorLine\"></div><span class=\"ute-dataManager-sharedUsageBar-indicatorCopy ute-dataManager-sharedUsageBar-indicatorCopyOverage\">{{:: ( dataManagerSharedUsageBar.getTotalDataUsage()) | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBar.getBase(): (dataManagerSharedUsageBar.getTotalDataUsage() > dataManagerSharedUsageBar.getBase() ? 1 : 0): true: false | translate}}<br>{{:: \'ute.dataManager.sharedUsageBar.used\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerSharedUsageBar/dataManagerSharedUsageBarSegment.partial.html","<div class=\"ute-dataManager-sharedUsageBar-usage\" ng-class=\":: dataManagerSharedUsageBarSegment.getUsageClass()\"><span data-ng-show=\":: dataManagerSharedUsageBarSegment.isUsageVisible()\" class=\"ute-dataManager-sharedUsageBar-usageValue\">{{:: dataUsed | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBarSegment.getBase(): (dataUsed > dataManagerSharedUsageBarSegment.getBase() ? 1 : 0): true: false}}</span><md-tooltip data-ng-if=\"!dataManagerSharedUsageBarSegment.isUsageVisible()\" md-direction=\"top\">{{:: dataUsed | ute_common_filter_data_conversion: \'mb\': dataManagerSharedUsageBarSegment.getBase(): (dataUsed > dataManagerSharedUsageBarSegment.getBase() ? 1 : 0): true: false}}</md-tooltip></div>");
$templateCache.put("module/dataManager/dataManagerTabs/dataManagerTabs.partial.html","<div data-ng-class=\"dataManagerTabs.getTabsClass()\" data-ng-if=\"!dataManagerTabs.getUsageDetailsCallInProgress()\"><div class=\"container\"><md-content style=\"z-index: 2;\"><md-tabs class=\"aaaa\" md-dynamic-height=\"\" md-border-bottom=\"\" md-stretch-tabs=\"always\" md-selected=\"activeTabIndex\"><md-tab data-ng-disabled=\"dataManagerTabs.isTabDisabled(tab.ctn)\" data-ng-repeat=\"tab in dataManagerTabs.getDataControlList()\" data-ng-click=\"dataManagerTabs.changeTab($index)\" tabindex=\"-1\"><md-tab-label><span class=\"top-box-border\"></span><div data-ng-class=\"dataManagerTabs.getTabLabelClass(tab)\" id=\"{{dataManagerTabs.getElementID(tab, $index)}}\"><span class=\"ute-dataManager-tabs-displayName\">{{tab.displayName | ute_common_filter_string_limit_to: 9}}</span><div class=\"ute-dataManager-tabs-ctn\" data-ng-class=\"dataManagerTabs.getCTNClass()\">{{:: tab.ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</div><div class=\"ute-dataManager-tabs-primary\">{{:: dataManagerTabs.getPrimaryCopy(tab)}}</div><div class=\"ute-dataManager-tabs-status\"><div>{{:: dataManagerTabs.isAccountLeftGroup(tab.ctn) ? (\'ute.dataManager.tabs.leftGroupStillSharing\' | translate) : \'\'}}</div><div>{{:: dataManagerTabs.isAccountCancelled(tab.ctn) ? (\'ute.dataManager.tabs.cancelled\' | translate) : \'\'}}</div><div>{{:: dataManagerTabs.isAccountSuspended(tab.ctn) ? (\'ute.dataManager.tabs.suspended\' | translate) : \'\'}}</div><div>{{:: dataManagerTabs.isAccountJoined(tab.ctn) ? (\'ute.dataManager.tabs.joinedGroupNotSharing\' | translate) : \'\'}}</div></div></div></md-tab-label></md-tab><div class=\"ute-dataManager-tabs-seeLink-container\"><md-tab data-ng-repeat=\"tab in dataManagerTabs.getSeeLinks()\" data-ng-click=\"dataManagerTabs.changeTab(tab.ctn,tab.isLink)\" tabindex=\"-1\"><md-tab-label><div layout=\"row\" layout-align=\"center center\"><div data-ng-style=\"{\'backgroundColor\': tab.colorCode}\" class=\"ute-dataManager-tabs-seeLink-circle\"><md-icon class=\"ute-icon-plus ute-dataManager-tabs-seeLink-plus-icon\"></md-icon></div><div><div layout=\"column\" layout-align=\"center start\"><div class=\"margin-bottom-5px-important\"><span class=\"ute-dataManager-tabs-seeLink-displayName\" data-ng-bind-html=\":: tab.displayName\"></span></div><div class=\"ute-dataManager-tabs-seeLink-discount\" data-ng-if=\"tab.discount.rateType===\'D\'\"><span ng-if=\"tab.language === \'en\'\">Save</span><span ng-if=\"tab.language === \'fr\'\">&#201;conomisez</span> {{:: tab.discount.getDiscountAmount() | currency : \'$\' : 0}} {{tab.language == \'en\' ? \'more\' : \'de plus\'}}</div><div class=\"ute-dataManager-tabs-seeLink-discount\" data-ng-if=\"tab.discount.rateType===\'P\'\"><span ng-if=\"tab.language === \'en\'\">Save</span><span ng-if=\"tab.language === \'fr\'\">&#201;conomisez</span> %{{:: tab.discount.rate}} {{tab.language == \'en\' ? \'more\' : \'de plus\'}}</div></div></div></div></md-tab-label></md-tab></div></md-tabs></md-content><div class=\"ute-dataManager-tabs-underline\" data-ng-style=\"dataManagerTabs.getUnderlineStyle()\"></div></div></div>");
$templateCache.put("module/dataManager/dataManagerTabsContent/dataManagerTabsContent.partial.html","<div>Wireless content</div>");
$templateCache.put("module/dataManager/dataManagerUpgradePlan/dataManagerUpgradePlan.partial.html","<div class=\"ute-dataManager-upgradePlan\"><md-button class=\"md-fab ute-dataManager-usageDial-mdIconButton ute-dataManager-upgradePlan-button\" style=\"box-shadow:none;\" data-ng-click=\"dataManagerUpgradePlanDirective.upgradeClick()\" data-ng-keypress=\"($event.which === 13)?dataManagerUpgradePlanDirective.upgradeClick():0\" data-ng-disabled=\"::!dataManagerUpgradePlanDirective.canChangePlan\"><span class=\"sr-only\">{{ :: \'ute.dataManager.usageDial.upgradePlan\' | translate}}</span><md-icon class=\"ute-icon-arrow-down ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-usageDial-upgradePlanIcon1\"></md-icon><md-icon class=\"ute-icon-arrow-down ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-usageDial-upgradePlanIcon2\"></md-icon></md-button></div>");
$templateCache.put("module/dataManager/dataManagerUsageDial/dataManagerUsageDial.partial.html","<div class=\"ute-dataManager-usageDial\" data-ng-style=\"dataManagerUsageDial.getUsageDialStyle()\" data-ng-class=\"dataManagerUsageDial.getUsageDialClass()\"><div class=\"container\"><div class=\"row\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 ute-dataManager-topSpacer\"><div class=\"ute-dataManager-headText-container\"><h2 class=\"ute-dataManager-headText\">{{:: \'ute.dataManager.usageDial.myWirelessUsage\' | translate}}<div data-ng-if=\"dataManagerUsageDial.getUsageDetailsCallInProgress()\" style=\"display:inline; top: -15px; position: relative;\">&nbsp;<img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div></h2></div><div class=\"ute-dataManager-headTextSecondary-container\" data-ng-if=\"dataManagerUsageDial.validateDateData() && !dataManagerUsageDial.getUsageDetailsCallInProgress()\"><span class=\"ute-dataManager-headTextSecondary\" data-ng-hide=\"dataManagerUsageDial.getUsageDetailsCallInProgress()\" data-ng-bind-html=\":: \'ute.dataManager.usageDial.daysRemaining\' | translate : { \'daysRemaining\' : dataManagerUsageDial.getDaysUntilEnd() }\"></span> <span class=\"ute-dataManager-headTextSecondaryReminder\" data-ng-show=\"dataManagerUsageDial.showSecondaryReminder()\" data-ng-bind-html=\":: (\'ute.dataManager.usageDial.months.\' + dataManagerUsageDial.getNextStartMonth()) | translate : { \'startDay\' : dataManagerUsageDial.getNextStartDay() }\"></span><br><ute-user-if-any-granted data-roles=\"care,dealer\"><ute-has-permission key=\"ONEVIEW_HISTORICAL_USAGE\"><a href=\"javascript:void(0)\" class=\"historical-usage-link\" ng-class=\"{\'historical-usage-new-badge\': dataManagerUsageDial.showHistoricalUsageNewBadge()}\"><span><ute-historical-usage translate-key=\"\'ute.dataManager.historical.link\'\"></ute-historical-usage></span> <span class=\"rui-icon-arrow-right\"></span></a></ute-has-permission></ute-user-if-any-granted></div></div></div><div class=\"container\" data-ng-if=\"!dataManagerUsageDial.getUsageDetailsCallInProgress()\"><div class=\"row\"><div class=\"ute-dataManager-dashboard-infoBlockContainer col-xs-12 col-sm-12 col-md-12 col-lg-12\" data-ng-repeat=\"infoBlock in dataManagerUsageDial.getInfoBlock()\"><ute-data-manager-info-block data-info-block=\"infoBlock\"></ute-data-manager-info-block></div></div></div><div class=\"row\" data-ng-if=\"!dataManagerUsageDial.getUsageDetailsCallInProgress()\"><div class=\"col-xs-12 hidden-sm hidden-md hidden-lg ute-dataManager-usageCarouselContainer\" data-ng-if=\"dataManagerUsageDial.isMobile\" data-ng-class=\"dataManagerUsageDial.getUsageDialStyling()\"><carousel id=\"myCarousel\" class=\"ute-dataManager-usageCarousel slide\" no-wrap=\"false\" data-ride=\"carousel\" interval=\"0\"><div class=\"carousel-inner\" role=\"listbox\"><slide class=\"item active\"><div data-ng-include=\"dataManagerUsageDial.getSharedDataPartial()\"></div></slide><slide class=\"item\"><div data-ng-include=\"dataManagerUsageDial.getSharedTalkPartial()\"></div></slide><slide class=\"item\"><div data-ng-include=\"dataManagerUsageDial.getSharedTextPartial()\"></div></slide></div></carousel></div><div class=\"ute-dataManager-usageDial-dialContainer\" data-ng-if=\"!dataManagerUsageDial.isMobile\"><div class=\"hidden-xs col-sm-4 ute-dataManager-usageDial-dialContainers\"><div data-ng-include=\"dataManagerUsageDial.getSharedDataPartial()\"></div></div><div class=\"hidden-xs col-sm-4 ute-dataManager-usageDial-dialContainers\"><div data-ng-include=\"dataManagerUsageDial.getSharedTalkPartial()\"></div></div><div class=\"hidden-xs col-sm-4 ute-dataManager-usageDial-dialContainers\"><div data-ng-include=\"dataManagerUsageDial.getSharedTextPartial()\"></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedData.partial.html","<div class=\"ute-dataManager-usageDial-container\"><div class=\"ute-dataManager-usageDialContent\" data-ng-class=\"{\'ute-dataManager-usageDialContent-infinite-throttled\': dataManagerUsageDial.isInfiniteThrottled()}\"><div class=\"ute-dataManager-usageDial-contentContainer\"><div class=\"ute-dataManager-usageDialContent-sharedData\">{{dataManagerUsageDial.getSharedDataTranslationKey()| translate}}</div><div data-ng-cloak=\"\" data-ng-if=\"!dataManagerUsageDial.isInfiniteThrottled()\" data-ng-show=\"!dataManagerUsageDial.getUsageDetailsCallInProgress()\" class=\"ute-dataManager-usageDialContent-remaining\" data-ng-bind-html=\"dataManagerUsageDial.getDialRemainingCopy()\"></div><div data-ng-cloak=\"\" data-ng-if=\"dataManagerUsageDial.isInfiniteThrottled()\" data-ng-show=\"!dataManagerUsageDial.getUsageDetailsCallInProgress()\" class=\"ute-dataManager-usageDialContent-remaining\"><span class=\"ute-dataManager-infinte-logo\"><img src=\"ute-common-assets/assets/infinite/rogers-infinite.svg\" alt=\"\"></span><div>{{:: \'ute.dataManager.usageDial.usageReduced\' | translate}}</div></div><div data-ng-cloak=\"\" data-ng-hide=\"dataManagerUsageDial.hideRealTime()\" class=\"ute-dataManager-usageDialContent-realTime\">{{::\'ute.dataManager.usageDial.realTime\' | translate}}</div><div data-ng-cloak=\"\" data-ng-hide=\"dataManagerUsageDial.hideOneHourDelay()\" class=\"ute-dataManager-usageDialContent-delayedTime\">{{:: \'ute.dataManager.usageDial.oneHourDelay\' | translate}}</div></div></div><ute-data-manager-usage-dial-animate-stroke data-ng-cloak=\"\" class=\"ute-dataManager-animatedStrokeContainer\" data-ng-hide=\"dataManagerUsageDial.isStrokeHidden()\" data-percent-remaining=\"{{:: dataManagerUsageDial.getRemainingTotalDataPercentage()}}\" data-height=\"210\" data-width=\"210\" data-radius=\"95\" data-stroke-width=\"10\" data-nominal-color=\"#00955E\" data-warning-color=\"#F59829\" data-overage-color=\"#FFE957\" data-animation-complete=\"animationComplete\"></ute-data-manager-usage-dial-animate-stroke><div class=\"ute-dataManager-usageDial-loaderContainer\" ng-if=\"dataManagerUsageDial.getPurchaseDataProductCallInProgress()\"><div class=\"ute-dataManager-usageDial-loader\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Page loading... / Chargement de la page en cours...\"></div><div class=\"ute-dataManager-usageDial-loaderCopy\">{{ :: \'ute.dataManager.usageDial.loader\' | translate}}</div></div><div class=\"ute-dataManager-usageDial-upgradePlan\" data-ng-class=\"dataManagerUsageDial.getUpgradePlanClass()\"><ute-data-manager-upgrade-plan-directive></ute-data-manager-upgrade-plan-directive><span class=\"ute-dataManager-usageDial-upgradePlanCopy\">{{ :: \'ute.dataManager.usageDial.upgradePlan\' | translate}}</span><p class=\"ute-dataManager-usageDial-overageWarningUpgrade\" data-ng-show=\"dataManagerUsageDial.isOverageWarningUpgradeVisible()\" data-ng-bind-html=\":: \'ute.dataManager.usageDial.override\' | translate\"></p></div><ute-purchase-data-directive data-ng-if=\"dataManagerUsageDial.isAddDataVisible() && dataManagerUsageDial.isAllowedToPurchaseData() && !dataManagerUsageDial.isInfintePlanFirstCycle()\"></ute-purchase-data-directive><div data-ng-if=\"!dataManagerUsageDial.isAddDataVisible() || !dataManagerUsageDial.isAllowedToPurchaseData()\" data-ng-class=\"dataManagerUsageDial.getIncreasePlanClass()\" data-ng-disabled=\"!dataManagerUsageDial.isAllowedToPurchaseData() && !dataManagerUsageDial.isOverage()\"><ute-data-manager-increase-plan-directive data-id=\"usageDial\" data-disabled-override=\"animationComplete\"></ute-data-manager-increase-plan-directive><span data-ng-if=\"!dataManagerUsageDial.isInfinitePlan()\" class=\"ute-dataManager-usageDial-increaseDataCopy\">{{ :: \'ute.dataManager.usageDial.increaseData\' | translate}}</span> <span data-ng-if=\"dataManagerUsageDial.isInfinitePlan()\" class=\"ute-dataManager-usageDial-increaseDataCopy\">{{ :: \'ute.dataManager.usageDial.addSpeedPass\' | translate}}</span><p class=\"ute-dataManager-usageDial-overageWarningIncrease\" data-ng-show=\"dataManagerUsageDial.isOverageWarningIncreaseVisible()\" data-ng-bind-html=\":: \'ute.dataManager.usageDial.cannotAddMoreData\' | translate\"></p></div></div><div class=\"row ute-dataManager-usageDial-subDialContent\" ng-if=\"!dataManagerUsageDial.isInfinitePlan()\"><div class=\"col-xs-12 ute-dataManager-usageDial-overagePlanLimitDetails\" ng-if=\"::dataManagerUsageDial.hasOverageCharge\"><span class=\"bold-text overage-text-style\" ng-class=\"{\'col-xs-5\':dataManagerUsageDial.getLanguage() === \'en\', \'col-xs-6\': dataManagerUsageDial.getLanguage() === \'fr\'}\">{{:: \'ute.dataManager.usageDial.dataOverage\' | translate}}</span> <span class=\"col-xs-6 overage-charge-padding\" ng-bind-html=\"dataManagerUsageDial.overageChargeDetailKey | translate\"></span></div><div class=\"col-xs-12 ute-dataManager-usageDial-purchasedCopyContainer\" ng-if=\"!dataManagerUsageDial.getPurchaseDataProductCallInProgress()\"><div class=\"ute-dataManager-usageDial-purchasedCopy\" data-ng-cloak=\"\" data-ng-show=\"dataManagerUsageDial.isPurchasedCopyVisible()\"><div class=\"ute-data-manager-added-data\" ng-class=\"(dataManagerUsageDial.getPurchaseDataIncreases().length === 1) ? \'single-mdt-padding\' : (dataManagerUsageDial.getPurchaseDataIncreases().length > 1 && dataManagerUsageDial.hasMultipleMDT) ? \'close-padding-left\' : \'\'\"><span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length === 1 && dataManagerUsageDial.getPurchaseDataIncreases()[0].value > 0\">{{ \'ute.dataManager.usageDial.addedData\' | translate}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length === 1 && dataManagerUsageDial.getPurchaseDataIncreases()[0].value === 0\">{{ \'ute.dataManager.usageDial.bonusData\' | translate}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length > 1\">{{::dataManagerUsageDial.isAddedOrBonusMDT() | translate }}</span> <span ng-class=\"{\'spacer-medium\': dataManagerUsageDial.getPurchaseDataIncreases().length === 1 , \'spacer-big\' : dataManagerUsageDial.getPurchaseDataIncreases().length > 1,\'spacer-big-fr\' : (dataManagerUsageDial.getPurchaseDataIncreases().length > 1 && dataManagerUsageDial.hasMultipleMDT) }\"></span> <span ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length === 1\" class=\"single-mdt-fr\"><span class=\"bold-text\" ng-if=\"(dataManagerUsageDial.getPurchaseDataIncreases()[0].multiplier > 0)\">{{:: dataManagerUsageDial.getPurchaseDataIncreases()[0].multiplier}}&nbsp;X</span> <span class=\"bold-text\">{{:: dataManagerUsageDial.getPurchaseDataIncreases()[0].amount | ute_common_filter_data_conversion: \'mb\': dataManagerUsageDial.getBase(): (dataManagerUsageDial.getPurchaseDataIncreases()[0].amount > dataManagerUsageDial.getBase() ? 1 : 0): true : false }}</span> <span class=\"added-for-font\" ng-if=\"dataManagerUsageDial.getLanguage() === \'en\'\">{{:: \'ute.dataManager.usageDial.addedFor\' | translate}}</span> <span class=\"bold-text\">{{:: dataManagerUsageDial.getPurchaseDataIncreases()[0].value / 100 | currency : \'$\' : 0}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getLanguage() === \'en\'\">{{:: \'ute.dataManager.usageDial.each\' | translate}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getLanguage() === \'fr\'\">{{:: \'ute.dataManager.usageDial.addedFor\' | translate}}</span></span> <span><a ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length > 1 && !dataManagerUsageDial.hasMultipleMDT\" ng-click=\"dataManagerUsageDial.hasMultipleMDT = !dataManagerUsageDial.hasMultipleMDT;\" class=\"view-close-font\">{{:: \'ute.dataManager.usageDial.view\' | translate}} <i class=\"ute-icon-chevron-down icon-padding\"></i></a> <a ng-if=\"dataManagerUsageDial.getPurchaseDataIncreases().length > 1 && dataManagerUsageDial.hasMultipleMDT\" ng-click=\"dataManagerUsageDial.hasMultipleMDT = !dataManagerUsageDial.hasMultipleMDT;\" class=\"view-close-font\">{{:: \'ute.dataManager.usageDial.close\' | translate}} <i class=\"ute-icon-chevron-down icon-flipped\" style=\"display: inline-block !important;\"></i></a></span></div><div ng-if=\"dataManagerUsageDial.hasMultipleMDT\"><div class=\"ute-purchased-data-list\" data-ng-repeat=\"purchase in dataManagerUsageDial.getPurchaseDataIncreases()\" data-ng-class=\"{\'no-bottom-border\': $last, \'first-border-top\': $first}\"><span class=\"bold-text\" ng-if=\"(purchase.multiplier > 0)\">{{:: purchase.multiplier}}&nbsp;X</span> <span class=\"bold-text\">{{:: purchase.amount | ute_common_filter_data_conversion: \'mb\': dataManagerUsageDial.getBase(): (purchase.amount > dataManagerUsageDial.getBase() ? 1 : 0): true : false }}</span> &nbsp; <span ng-if=\"(purchase.amount/dataManagerUsageDial.getBase()) < 10 && (purchase.amount/dataManagerUsageDial.getBase()) >= 1\">&nbsp;</span> <span class=\"added-for-font\" ng-if=\"dataManagerUsageDial.getLanguage() === \'en\'\">{{:: \'ute.dataManager.usageDial.addedFor\' | translate}}</span> <span class=\"bold-text\">{{:: purchase.value / 100 | currency : \'$\' : 0}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getLanguage() === \'en\'\">{{:: \'ute.dataManager.usageDial.each\' | translate}}</span> <span class=\"bold-text\" ng-if=\"dataManagerUsageDial.getLanguage() === \'fr\'\">{{:: \'ute.dataManager.usageDial.addedFor\' | translate}}</span></div></div><div class=\"ute-cancel-mdt-copy\" ng-class=\"{\'single-mdt-cancel-padding\': dataManagerUsageDial.getPurchaseDataIncreases().length === 1}\"><span translate=\"ute.dataManager.usageDial.cancelAddon\"></span></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedTalk.partial.html","<div class=\"ute-dataManager-usageDial-container\"><div class=\"ute-dataManager-usageDialContentNoCanvas\"><div class=\"ute-dataManager-usageDial-contentContainerTop\"><span class=\"ute-dataManager-usageDialContent-sharedData\">{{:: \'ute.dataManager.usageDial.sharedTalk\' | translate}}</span></div><div class=\"ute-dataManager-usageDial-contentContainerBottom\"><span class=\"ute-dataManager-usageDialContent-remaining ute-dataManager-usageDialContentNoCanvasRemaing\"><span class=\"ute-dataManager-usageDialContent-viewUsage hidden-xs visible-md visible-lg visible-sm\" ng-click=\"dataManagerUsageDial.navigateToPrimaryCtnSummary(true)\" translate=\"ute.dataManager.usageDial.viewUsage\"></span> <span class=\"ute-dataManager-usageDialContent-viewUsage visible-xs hidden-md hidden-lg hidden-sm\" ng-click=\"dataManagerUsageDial.navigateToPrimaryCtnSummary()\" translate=\"ute.dataManager.usageDial.viewUsage\"></span></span></div></div></div>");
$templateCache.put("module/dataManager/dataManagerUsageDial/dataManagerUsageDialSharedText.partial.html","<div class=\"ute-dataManager-usageDial-container\"><div class=\"ute-dataManager-usageDialContentNoCanvas ute-dataManager-usageDialContentNoCanvas2\"><div class=\"ute-dataManager-usageDial-contentContainerTop\"><span class=\"ute-dataManager-usageDialContent-sharedData\">{{:: \'ute.dataManager.usageDial.sharedText\' | translate}}</span></div><div class=\"ute-dataManager-usageDial-contentContainerBottom\"><span class=\"ute-dataManager-usageDialContent-remaining ute-dataManager-usageDialContentNoCanvasRemaing\">{{:: \'ute.dataManager.usageDial.unlimited\' | translate}}</span></div></div></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottleControlList/dataManagerVideoThrottleControlList.partial.html","<div class=\"ute-dataManager-videoThrottleControlList-titleBar\"><div class=\"container ute-dataManager-videoThrottleControlList-titleBarContainer\"><div class=\"row\"><div class=\"col-lg-2 col-md-2 col-sm-2\"><div class=\"ute-dataManager-videoThrottleControlList-titleCopy ute-dataManager-videoThrottleControlList-sharedLinesHeader\">{{:: \'ute.dataManager.videoThrottleControlList.sharedLines\' | translate}}</div></div><div data-ng-class=\"dataManagerVideoThrottleControlList.getTitleBarClass()\" class=\"col-lg-3 col-md-3 col-sm-3\"><div class=\"ute-dataManager-videoThrottleControlList-titleCopy ute-dataManager-videoThrottleControlList-PersonalizedDataHeader\">{{::\'ute.dataManager.videoThrottleControlList.reduceVideoQuality\' | translate}}</div></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-lg-5 col-md-5 col-sm-6\"><div data-ng-repeat=\"line in dataManagerVideoThrottleControlList.getDataControlList()\"><ute-data-manager-video-throttle-control data-line-index=\"{{:: $index}}\" data-display-name=\"{{:: line.displayName}}\" data-ctn=\"{{:: line.ctn}}\" data-data-limit=\"{{:: dataManagerVideoThrottleControlList.getDataLimit()}}\" data-color-code=\"{{:: line.colorCode}}\" data-data-used=\"{{:: line.dataUsed}}\" data-data-alert-at=\"{{line.dataAlertAt}}\" data-saved-alert-value=\"{{:: line.savedAlertValue}}\" data-is-alerts-recipient=\"{{ (dataManagerVideoThrottleControlList.getAlertsRecipientCTN() === line.ctn)}}\" data-has-data=\"{{:: line.hasData}}\" data-video-quality-reduced=\"{{line.videoQualityReduced}}\" data-use-alert=\"line.useAlert\" data-data-access=\"{{line.dataAccess}}\" data-status=\"{{:: line.status}}\" data-group-status=\"{{:: line.groupStatus}}\"></ute-data-manager-video-throttle-control></div></div><div class=\"col-lg-7 col-md-7 col-sm-6 ute-dataManager-videoThrottleControl-rightContainer\"><h4 class=\"ute-dataManager-videoThrottleControl-rightContainer-heading\">{{\'ute.dataManager.videoThrottleControlList.saveData\' | translate}}</h4><ul class=\"learn-more-content-list\"><li>{{\'ute.dataManager.videoThrottleControlList.benefitOne\' | translate}}</li><li><span data-ng-bind-html=\"\'ute.dataManager.videoThrottleControlList.benefitTwo\' | translate\"></span></li></ul><a aria-label=\"This will open in a new tab.\" data-ng-href=\"http://www.rogers.com/web/support/wireless/data-usage/9098?setLanguage={{currentLanguage}}\" target=\"_blank\" class=\"ute-dataManager-videoThrottleControl-rightContainer-link\">{{\'ute.dataManager.videoThrottleControlList.learnMore\' | translate}}</a></div></div></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottleControlTagList/dataManagerVideoThrottleControlTagList.view.html","<div class=\"container ute-dataManager-videoThrottleControlTagList-main\" data-ng-if=\"dataManagerVideoThrottleControlTagList.getIsVideoThrottlePermitted()\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"reduce-video-quality-list-desc video-throttle-heading\"><h3 class=\"reduce-video-quality-list-heading\">{{\'ute.dataManager.videoThrottleControlTagList.reduceVideoQuality\' |translate}}</h3><p class=\"ute-dataManager-accountsSummary-help\" style=\"display: inline;\">{{\'ute.dataManager.accountsSummary.help\' |translate}}</p></div></div></div></div><div class=\"ute-dataManager-videoThrottleControlTagList\" data-ng-if=\"dataManagerVideoThrottleControlTagList.getIsVideoThrottlePermitted()\"><div data-ng-repeat=\"tag in dataManagerVideoThrottleControlTagList.getDataControlList()\"><ute-data-manager-video-throttle-control-tag data-color-code=\"{{:: tag.colorCode}}\" data-display-name=\"{{:: tag.displayName}}\" data-ctn=\"{{:: tag.ctn}}\" data-is-alerts-recipient=\"{{ dataManagerVideoThrottleControlTagList.isAlertsRecipient(tag.ctn)}}\" data-data-used=\"{{:: tag.dataUsed}}\" data-data-alert-at=\"{{:: tag.savedAlertValue}}\" data-use-alert=\"{{:: tag.useAlert}}\" data-data-access=\"{{:: tag.dataAccess}}\" data-button-mode=\"{{:: true}}\" data-status=\"{{:: tag.status}}\" data-group-status=\"{{:: tag.groupStatus}}\" data-index=\"{{:: $index}}\" data-has-data=\"{{:: tag.hasData}}\" data-video-quality-reduced=\"{{tag.videoQualityReduced}}\"></ute-data-manager-video-throttle-control-tag></div></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottleToggleSwitch/dataManagerVideoThrottleToggleSwitch.partial.html","<div class=\"ute-dataManager-dataAccess ute-dataManager-dataAccess-left ute-dataManager-VideoToggle-Switch\"><div class=\"ute-dataManager-dataAccess-md-switch-container\"><md-switch data-ng-model=\"dataManagerVideoThrottleDirective.videoQualityReduced\" data-ng-disabled=\"dataManagerVideoThrottleDirective.isSetVideoQualityAPICallInProgress\" data-ng-change=\"dataManagerVideoThrottleDirective.videoQualityReducedChange(dataManagerVideoThrottleDirective.videoQualityReduced)\" ng-swipe-left=\"dataManagerVideoThrottleDirective.swipeLeft()\" ng-swipe-right=\"dataManagerVideoThrottleDirective.swipeRight()\" class=\"ute-dataManager-dataAccess-md-switch\" aria-label=\"Video Quality\"><span data-ng-if=\"!dataManagerVideoThrottleDirective.isSetVideoQualityAPICallInProgress\" class=\"ute-dataManager-vt-switch-label\">{{ (dataManagerVideoThrottleDirective.videoQualityReduced ? (onCopy | translate) : (offCopy | translate)) }}</span> <span class=\"widget-loader-vt\" data-ng-if=\"dataManagerVideoThrottleDirective.isSetVideoQualityAPICallInProgress\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></md-switch></div></div>");
$templateCache.put("module/dataManager/uteAppBanner/appBanner.partial.html","<div class=\"ute-appBanner\" ng-show=\"appBanner.isAndroid() && isOpen\"><md-button aria-label=\"close tab\" class=\"ute-apBanner-closeButton\" data-ng-click=\"appBanner.closeBannerClick()\"><span class=\"ute-appBanner-x\">X</span></md-button><div class=\"ute-appBanner-logoContainer\"><img src=\"ute-data-manager/assets/rogers_logo.png\"></div><div class=\"ute-appBanner-contentContainer\"><span class=\"ute-appBanner-title\">{{\'ute.appBanner.title\' | translate}}</span><div class=\"ute-appBanner-callToAction\">{{\'ute.appBanner.callToAction\' | translate}}</div></div><md-button class=\"ute-button-secondary ute-md-secondary-button ute-appBanner-getApp-button\" aria-label=\"Get App\" data-ng-click=\"appBanner.getAppClick()\">{{\'ute.appBanner.buttonCopy\' | translate}}</md-button></div>");
$templateCache.put("module/dataManager/verticalStackBarGraph/verticalStackBarGraph.view.html","<div class=\"ute-verticalStackBarGraph\"><div class=\"ute-verticalStackBarGraph-baseCopy\" data-ng-class=\"verticalStackBarGraph.getCopyType()\" data-ng-hide=\"verticalStackBarGraph.showBaseCopy()\"><span class=\"ute-verticalStackBarGraph-baseCopyStyle\" ng-bind-html=\"baseCopy\"></span></div><div class=\"ute-verticalStackBarGraph-primaryBar\"></div><div class=\"ute-verticalStackBarGraph-secondaryBar\"></div><div class=\"ute-verticalStackBarGraph-secondaryCopyContainer\"><md-button type=\"button\" data-ng-click=\"verticalStackBarGraph.copyClick()\" class=\"ute-verticalStackBarGraph-secondaryCopy md-button md-ink-ripple\" ng-bind-html=\"secondaryCopy\"></md-button></div></div>");
$templateCache.put("module/discoveryPage/discoveryPageDirective/discoveryPageDirective.partial.html","<div class=\"ute-discoveryPage-directive\"><div class=\"ute-discoveryPage-directive-button-wrap\" data-ng-show=\"discoveryPageDirective.tooltipmode\"><a data-ng-click=\"discoveryPageDirective.openDiscoveryModal()\" data-ng-keydown=\"($event.which === 13)?discoveryPageDirective.openDiscoveryModal():0\">{{ discoveryPageDirective.getLinkText() | translate }}</a></div></div>");
$templateCache.put("module/discoveryPage/discoveryPageDirective/discoveryPageDirective.window.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"ute-discoveryPage-dataControlList-modal modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-discoveryPage-dataControlList-modal ute-discoveryPage-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/eclipseRemoteApi/eclipseRemoteAPiViews/errorModal.view.html","<div class=\"verify-address general-error totes-project\"><img class=\"close-icon\" ng-click=\"close()\" src=\"ute-common-assets/assets/close-icon.png\"><div class=\"error-explanation\"><img class=\"error-img\" src=\"assets/error-exclamation.png\"><p class=\"subheading error-description\" translate=\"ute.eclipseRemote.error\"></p></div><div class=\"live-chat-icon\"><div ng-if=\"language === \'en\'\"><img src=\"assets/red-chat-icon.png\"> <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=24\" class=\"live-chat-label\" translate=\"ute.eclipseRemote.error.liveChat\"></a> <img src=\"assets/black-right-arrow.png\"></div><div ng-if=\"language === \'fr\'\"><img src=\"assets/red-chat-icon.png\"><a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?s=74\" class=\"live-chat-label\" translate=\"ute.eclipseRemote.error.liveChat\"></a><img src=\"assets/black-right-arrow.png\"></div></div></div>");
$templateCache.put("module/historicalUsage/templates/data.html","<div class=\"hu-primary-plan\">{{$ctrl.primaryLinePlanName}}</div><div class=\"hu-table-container\"><table><tr ng-repeat=\"row in $ctrl.usageTable\" ng-class=\"row.classList\"><td ng-repeat=\"cell in row.col\"><ute-historical-usage-cell cell-model=\"cell\"></ute-historical-usage-cell></td></tr></table></div><div class=\"hu-note-points\"><div translate=\"ute.historical.usage.note1\"></div><div translate=\"ute.historical.usage.note2\"></div></div>");
$templateCache.put("module/historicalUsage/templates/error.html","<div class=\"hu-error ute-grid g-h-mid\"><span><div class=\"ute-grid g-h-mid\"><img src=\"ute-historical-usage/assets/warning_white_back.png\" alt=\"\"></div><div class=\"fbold\" translate=\"ute.historical.usage.error_header\"></div><div translate=\"ute.historical.usage.error_desc\"></div></span></div>");
$templateCache.put("module/historicalUsage/templates/hu.directive.html","<span translate=\"{{$ctrl.translateKey}}\" ng-click=\"$ctrl.viewHistoryUsage()\"></span>");
$templateCache.put("module/historicalUsage/templates/hu.fdmline.html","<div><span class=\"fbold f16\">{{$ctrl.cellModel.ctn}}</span><br><span ng-bind-html=\"$ctrl.cellModel.planName\"></span></div>");
$templateCache.put("module/historicalUsage/templates/hu.modal.html","<div class=\"hu-modal-body\"><div class=\"hu-modal-header\"><div class=\"ute-grid g-v-mid g-h-space-between\" ng-if=\"$ctrl.state === $ctrl.STATE.data\"><div class=\"hu-header f22 fbold\" translate=\"ute.historical.usage.header\">Historical data usage</div><div class=\"hu-ban f18 fbold\"><span translate=\"ute.historical.usage.ban\"></span> <strong class=\"\">{{$ctrl.getCurrentBan()}}</strong></div></div><div class=\"hu-button-close\" ng-click=\"$ctrl.close()\"><img src=\"ute-common-assets/assets/close-icon-light.png\" alt=\"\"></div></div><div class=\"hu-modal-content\"><ng-include src=\"$ctrl.getCurrentStateTemplate()\"></ng-include></div></div>");
$templateCache.put("module/historicalUsage/templates/hu.topup.html","<strong class=\"hu-top-up-block\"><div class=\"ute-grid g-h-mid\"><div>{{$ctrl.cellModel.usage.value}}</div><div class=\"hu-topup\"><span>&nbsp;+&nbsp;{{$ctrl.cellModel.usage.topup}}**</span></div></div></strong>");
$templateCache.put("module/historicalUsage/templates/hu.usage.cell.html","<strong><div ng-class=\"$ctrl.cellModel.classList\">{{$ctrl.cellModel.usage.value}}</div></strong>");
$templateCache.put("module/historicalUsage/templates/hu.usage.header.html","<div class=\"{{$ctrl.cellModel.classList}}\" ng-bind-html=\"$ctrl.cellModel.usage.header\"></div>");
$templateCache.put("module/historicalUsage/templates/hu.usageOverview.cell.html","<div><span translate=\"{{\'ute.historical.usage.\' + $ctrl.cellModel.translateKey}}\"></span></div>");
$templateCache.put("module/historicalUsage/templates/modal.window.html","<div modal-render=\"true\" tabindex=\"-1\" role=\"dialog\" class=\"modal ute-historical-usage ute-historical-usage-modal\" ng-class=\"$ctrl.STATE[0]\" modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\" animate=\"animate\" modal-animation=\"true\" style=\"z-index: 1050; display: block;\"><div class=\"modal-dialog {{$parent.$ctrl.state === $parent.$ctrl.STATE.data ? \'modal-lg\' : \'modal-md\'}}\"><div class=\"modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/historicalUsage/templates/processing.html","<div class=\"hu-processing ute-grid g-h-mid\"><span><img src=\"ute-common-assets/assets/widget-loader-lg_plain.gif\" alt=\"\"><div translate=\"ute.historical.usage.loading\">Loading historical data</div></span></div>");
$templateCache.put("module/janrainVerification/genericError/errorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.getModalIcon()}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" translate=\"{{errorModal.getFrontendMessageKey()}}\"></div><bold-chat-static-button data-cbid=\"{{errorModal.getBoldChat().cbid | translate}}\" data-dynamic-div=\"{{errorModal.getBoldChat().dynamicDivId | translate}}\" data-chat-button=\"{{errorModal.getBoldChat().chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" data-translate=\"{{errorModal.getFrontendMessageP2Key()}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" data-dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/genericError/errorWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/invalidForgotPassword/invalidForgotPasswordModal.view.html","<div class=\"ute-janrain-resend-email-modal-content\" data-ng-show=\"!errorModal.updateSuccessful\"><form name=\"errorModal.form\" novalidate=\"\"><div class=\"ute-janrain-resend-email-modal-headingGroup\"><div class=\"ute-janrain-resend-email-modal-heading\"><span data-translate=\"{{errorModal.errorCode.errorTitleMessageKey}}\"></span></div></div><div class=\"ute-janrain-resend-email-modal-typeGroup\"><div class=\"ute-janrain-resend-email-modal-typeBody\"><span data-translate=\"{{errorModal.errorCode.errorSubTitleMessageKey}}\"></span></div></div><div data-ng-if=\"errorModal.errorMessageKey\" class=\"ute-janrain-resend-email-modal-errorMessage\"><img class=\"ute-janrain-resend-email-modal-messageIcon\" src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-janrain-resend-email-modal-messageBody\"><span data-translate=\"{{errorModal.errorMessageKey}}\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"></div><div class=\"col-xs-12 col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6 col-lg-6 col-lg-pull-6\"><div class=\"ute-janrain-resend-email-modal-inputGroup\"></div><div class=\"ute-janrain-resend-email-modal-buttonGroupFlush\"><button name=\"button_cancel\" class=\"ute-janrain-resend-email-modal-cancel\" data-ng-click=\"errorModal.cancel()\"><span data-translate=\"ute.janrain.verification.modalPopup.cancel\"></span></button> <button name=\"button_continue\" class=\"ute-janrain-resend-email-modal-submit\" data-ng-click=\"errorModal.tryAgain()\" data-ng-disabled=\"errorModal.isCallInProgress()\"><span data-translate=\"ute.common.label.continue\"></span></button> <span class=\"ute-janrain-resend-email-modal-buttonLoader\" data-ng-show=\"errorModal.isCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"errorModal.updateSuccessful\"><div class=\"ute-janrain-resend-email-modal-modalHeadingGroup\"><img class=\"ute-janrain-resend-email-modal-modalHeadingIcon\" src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-janrain-resend-email-modal-modalHeading\" data-translate=\"ute.janrain.verification.responseMessage.successTitle\"></div></div><div class=\"ute-janrain-resend-email-modal-modalTypeGroup\"><div class=\"ute-janrain-resend-email-modal-modalTypeBody\"><span data-translate=\"ute.janrain.verification.responseMessage.successMessage\"></span></div></div></div><img class=\"ute-janrain-resend-email-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/invalidForgotPassword/invalidForgotPasswordWindow.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-janrain-resend-email-modal-container modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.success.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-register-modalContent modal-content\"><div id=\"register-modal\" class=\"row\"><div class=\"col-xs-12 register-modal-top\"><img src=\"ute-common-assets/assets/security-lock.png\" alt=\"loading...\"> <span class=\"register-modal-top-txt\" data-translate=\"ute.common.form.secured\"></span></div><div class=\"col-xs-12 register-modal-bottom\"><div class=\"register-modal-valid-icon\"><img src=\"ute-common-assets/assets/code_valid.png\" alt=\"loading...\"></div><div class=\"register-modal-waiting-txt\"><span data-translate=\"ute.janrain.verification.modalPopup.codeValid\"></span></div></div></div></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.validating.view.html","<div id=\"register-modal\" class=\"row\"><div class=\"col-xs-12 register-modal-top\"><img src=\"ute-common-assets/assets/security-lock.png\" alt=\"loading...\"> <span class=\"register-modal-top-txt\" data-translate=\"ute.common.form.secured\"></span></div><div class=\"col-xs-12 register-modal-bottom\"><div class=\"register-modal-waiting-icon\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"loading...\"></div><div class=\"register-modal-waiting-txt\"><span data-translate=\"ute.janrain.verification.modalPopup.validatingCode\"></span></div></div></div>");
$templateCache.put("module/janrainVerification/verificationModal/janrainVerification.modal.window.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-register-modalContent modal-content\"><div data-ng-include=\"\'module/janrainVerification/verificationModal/janrainVerification.modal.validating.view.html\'\"></div></div></div></div>");
$templateCache.put("module/views/modals/confirmFee.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container\"><span class=\"confirm rui-icon-error icon-error\"></span><h4><span class=\"modal-title\" ng-bind=\"header_message\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" ng-bind-html=\"message\"></div><br><b translate=\"ute.common.oneview.header.modals.confirm_confirmation_msg\"></b></div><div class=\"footer\"><button class=\"btn cancel\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.cancel\"></button> <button class=\"modal-submit-button\" ng-click=\"closeModal()\" translate=\"ute.common.oneview.header.modals.continue\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"enable-IDV-interaction,oneViewDashboard\"}\'></button></div></div>");
$templateCache.put("module/views/modals/deepLinkModal.html","<div class=\"totes-project deep-link-modal\"><div ng-if=\"!vm.isChangeVoicemailPassword\" class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span translate=\"moving_to_ssp\"></span></h4><div class=\"prepaid-body-section\"><div ng-if=\"vm.isChangePhoneNumber\"><span translate=\"change_phone_number_desc\"></span></div><div ng-if=\"vm.isChangeSim\"><span translate=\"change_sim_desc\"></span></div><div ng-if=\"vm.isChangePlan\"><span translate=\"change_plan_desc\"></span></div><div ng-if=\"vm.isManageAddon\"><span translate=\"manage_addon_desc\"></span></div><div ng-if=\"vm.isUpgradeDevice\"><span translate=\"upgrade_device_desc\"></span></div><div ng-if=\"vm.isAddaLineIndividual\"><span translate=\"add_a_line_desc\"></span></div><div ng-if=\"vm.isAddaLineShared\"><span translate=\"add_a_line_desc\"></span></div><div ng-if=\"vm.isHupCancellation\"><span translate=\"hup_cancellation_desc\"></span></div><div ng-if=\"vm.isGetWireless\"><span translate=\"get_wireless_desc\"></span></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"vm.dontShowGoToSSPMsgAgain\" ng-click=\"vm.setShowMessage(vm.dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" translate=\"message_do_not_display_ssp_popup\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><a name=\"cancel\" ng-click=\"vm.cancel()\" class=\"link-cancel pull-left pointer cancel-btn-modal\"><span translate=\"_cancel\">Cancel</span></a> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium modal-btn\" ng-click=\"vm.close()\"><span class=\"no-text-transform\" translate=\"_continue\"></span></button></div></div></div></div></div><div ng-if=\"vm.isChangeVoicemailPassword\" style=\"position: relative;\" class=\"modal-body mlm mrm\"><div class=\"dialog module-link-account voicemailCenter\"><div class=\"row mbm voicemailRow\"><div class=\"prepaid-body-section\"><div class=\"voicemailDesc\" ng-if=\"vm.isChangeVoicemailPassword\"><span translate=\"update_voicemail_password_desc\" class=\"voicemailCenter\"></span></div></div></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"vm.dontShowGoToSSPMsgAgain\" ng-click=\"vm.setShowMessage(vm.dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" translate=\"message_do_not_display_ssp_popup\"></span></div><div class=\"ngdialog-buttons mbm voicemailBtnPadding\"><div class=\"row voicemailCenter\"><div class=\"\"><a name=\"cancelVoiceMail\" ng-click=\"vm.cancel()\" class=\"link-cancel pointer cancel-btn-modal\"><span translate=\"_cancel\">Cancel</span></a><button ng-click=\"vm.close()\" class=\"cta-round primary medium resetBtn\" type=\"button\" name=\"button_continue\"><span class=\"no-text-transform\" translate=\"reset\"></span></button></div></div></div></div></div></div>");
$templateCache.put("module/views/modals/eclipseMsgModal.html","<div class=\"totes-project\"><div class=\"container-fluid modal-body\"><h3 translate=\"eclipse_msg_header\">Leaving OneView</h3><p translate=\"eclipse_msg_desc\">To view or make changes to the requested details, you\'ll need to leave OneView and access one of the following Systems:</p><h4 translate=\"myaccoverview_get_ignite\">Ignite TV & Internet Package</h4><p translate=\"eclipse_msg_igniteTv_details\">If you are not trained to manage Ignite TV & Internet Package, you\'ll need to transfer the customer to the appropriate team. If you are, you\'ll need to head over to Maestro.</p><p></p><h4 translate=\"eclipse_msg_wireless_header\">Wireless</h4><div translate=\"eclipse_msg_wirless_details\">You\'ll need to head over to v21 or SSP.</div><p></p><p></p><h4 translate=\"eclipse_msg_tv_header\">TV, interent and Hope Phone</h4><div translate=\"eclipse_msg_tv_details\">You\'ll need to head over to SGI</div><p></p><p></p><h4 translate=\"eclipse_msg_smart_home_header\">Smart Home Monitoring</h4><div translate=\"eclipse_msg_smart_home_details\">You\'ll need to head over to Maestro</div><p></p></div></div>");
$templateCache.put("module/views/modals/enableIDV.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container offset\"><h4><span class=\"modal-title\" translate=\"ute.common.oneview.header.idvDetails.enable_idv_account\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" translate=\"ute.common.oneview.header.modals.enable_idv_msg\"></div><br><div class=\"passcode\" translate=\"ute.common.oneview.header.modals.passcode\"></div><form name=\"myForm\"><input class=\"entry\" name=\"myInput\" ng-model=\"myInput.passcode\" ng-change=\"myInput.passcode=(myInput.passcode|uppercase)\" required=\"\" minlength=\"1\"></form><div class=\"evp_portal_msg\"><span class=\"evp_title\" translate=\"ute.common.oneview.header.modals.evp_portal_msg\"></span> <span class=\"rui-icon-arrow-right\"></span></div></div><div class=\"footer\"><button class=\"btn cancel\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.cancel\"></button> <button class=\"modal-submit-button\" ng-disabled=\"!myForm.myInput.$valid\" ng-click=\"closeModal()\" translate=\"ute.common.oneview.header.modals.enter\" adl-event-track=\'{\"action\":\"click\",\"oneTimeAction\":true,\"mappingKey\":\"enable-IDV-account,event.selfServeComplete\"}\'></button></div></div>");
$templateCache.put("module/views/modals/invalidPasscode.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container\"><span class=\"warning rui-icon-error icon-error\"></span><h4><span class=\"modal-title\" translate=\"ute.common.oneview.header.modals.invalid_passcode\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" translate=\"ute.common.oneview.header.modals.invalid_passcode_msg\"></div><br></div><div class=\"footer\"><button class=\"btn cancel\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.cancel\"></button> <button class=\"modal-submit-button\" ng-click=\"closeModal()\" translate=\"ute.common.oneview.header.modals.try_again\"></button></div></div>");
$templateCache.put("module/views/modals/ppc-modal-template.html","<section class=\"module-ppc-modal\"><img class=\"close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"cancel()\"><h2>{{title}}</h2><p data-ng-bind-html=\"message\"></p><div class=\"contact\" ng-show=\"showLiveChat\"><p><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></bold-chat-static-button></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span ng-if=\"isSuspendedAccount\" translate=\"800_number_suspended\"></span> <span ng-if=\"!isSuspendedAccount\" translate=\"800_number\"></span></p></div><div class=\"ppc-button-ctn\"><a data-ng-show=\"showCancelBtn\" class=\"cancel-button blue\" ng-click=\"cancel()\" translate=\"CANCEL\"></a> <a data-ng-show=\"showOKBtn\" class=\"modal-button\" ng-click=\"ok()\">OK</a> <a data-ng-show=\"showConfirmBtn\" class=\"modal-button\" ng-click=\"confirm()\" translate=\"CONFIRM\"></a> <a data-ng-show=\"showConfirmPlanChangeBtn\" class=\"modal-button\" ng-click=\"confirm()\" translate=\"CONFIRM_PLAN_CHANGE\"></a> <a data-ng-show=\"showContinueBtn\" class=\"modal-button\" ng-click=\"continue()\" translate=\"_continue\"></a> <a data-ng-show=\"showRemoveAddOnBtn\" class=\"modal-button\" ng-click=\"removeAddOn()\" translate=\"ppc_remove_addon\"></a> <a data-ng-show=\"showGoBackBtn\" class=\"modal-button\" ng-click=\"goBack()\" translate=\"GO_BACK\"></a></div></section>");
$templateCache.put("module/views/modals/ppc-not-eligible.html","<div class=\"totes-project\" ng-class=\"{\'bot-eligible\': vm.isBOTerror}\"><div class=\"modal-body mlm mrm modal-body-bot\"><div class=\"dialog\"><div class=\"row mbm\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"vm.onContinue()\"><span aria-hidden=\"true\">&times;</span></button><h4 ng-if=\"!vm.isBOTerror\"><span translate=\"ppc_not_eligible_title\">ppc_not_eligible_title</span></h4><div class=\"bot-header\" ng-if=\"vm.isBOTerror\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"> <img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/green-checkbox.png\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"> <span translate=\"ppc_bot_header\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"></span> <span translate=\"case_success\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"></span></div><div class=\"pbm bot-content\" ng-bind-html=\"vm.model.desc\"></div><div class=\"contact\" ng-if=\"vm.isConsumer\"><p><a data-ng-href=\"{{vm.chatHref}}\" target=\"_blank\"><img class=\"live-chat-icon\" src=\"images/live-chat-red-icon.png\"> <span translate=\"_live_chat\"></span></a></p><p><img class=\"phone-icon\" src=\"images/phone-red-icon.png\"> <span translate=\"800_number\"></span></p></div></div><div class=\"ngdialog-buttons mbm bot-button-section\"><div class=\"row\"><div class=\"text-center\" ng-if=\"!vm.isBOTerror && vm.isConsumer\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.onContinue()\"><span translate=\"_continue\"></span></button></div><div class=\"text-right\" ng-if=\"!vm.isBOTerror && !vm.isConsumer\"><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.onContinue()\"><span translate=\"_ok\"></span></button></div><div><button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.cancelCase()\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\"><span translate=\"yes_change_plan\"></span></button> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"vm.proceedWithPPC()\" ng-if=\"vm.isBOTerror && vm.isCaseClosed\"><span translate=\"proceed_ppc\"></span></button><a href=\"\" ng-click=\"vm.onContinue()\" ng-if=\"vm.isBOTerror && !vm.isCaseClosed\" translate=\"modified_ppc_wait_complete\" class=\"mal\"></a></div></div></div></div></div></div>");
$templateCache.put("module/views/modals/successDiscount.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container\"><span class=\"ute-icon-checkmark-1 icon-checkmark-1\"></span><h4><span class=\"modal-title\" translate=\"ute.common.oneview.header.modals.success_msg\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" translate=\"ute.common.oneview.header.modals.success_discount_msg\"></div><br></div><div class=\"footer\"><button class=\"success-button\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.okay\"></button></div></div>");
$templateCache.put("module/views/modals/successPasscode.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container\"><span class=\"success ute-icon-checkmark-1 icon-checkmark-1\"></span><h4><span class=\"modal-title\" translate=\"ute.common.oneview.header.modals.success_passcode\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" translate=\"ute.common.oneview.header.modals.success_passcode_msg\"></div><br></div><div class=\"footer\"><button class=\"success-button\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.okay\"></button></div></div>");
$templateCache.put("module/views/modals/systemError.html","<div class=\"idv-modal\"><div class=\"modal-header-idv\"><div class=\"modal-header-container\"><span class=\"warning rui-icon-error icon-error\"></span><h4><span class=\"modal-title\" translate=\"ute.common.oneview.header.modals.system_error\"></span></h4><button type=\"button\" class=\"close-button rui-icon-mobile-menu-exit\" ng-click=\"$dismiss()\"></button></div></div><div class=\"modal-body\"><div class=\"idv-body-header\" translate=\"ute.common.oneview.header.modals.system_error_msg\"></div><br></div><div class=\"footer\"><button class=\"btn cancel\" ng-click=\"$dismiss()\" translate=\"ute.common.oneview.header.modals.cancel\"></button> <button class=\"modal-submit-button\" ng-click=\"closeModal()\" translate=\"ute.common.oneview.header.modals.try_again\"></button></div></div>");
$templateCache.put("module/views/modals/validateOrderPopUp.html","<section class=\"validate-order\"><div><div class=\"Modal-header\"><h4 class=\"Modal-heading\"><img class=\"wireless_warning_logo\" src=\"ute-common-assets/assets/warning_lg.png\"> <span class=\"title\" translate=\"hup_not_eligible_title\"></span></h4><button type=\"button\" class=\"close\" aria-label=\"Close\" ng-click=\"close()\"><span aria-hidden=\"true\">&times;</span></button></div><div class=\"Modal-body\"><span translate=\"invalid_hup_order_error\"></span></div></div></section>");
$templateCache.put("module/views/modals/wirelessRemovePlan.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" translate=\"wireless_popup_title\"></h2></div><div class=\"row mbs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div translate=\"wireless_popup_title_2\"></div></div></div><div class=\"row mtm\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><bold-chat-static-button data-cbid=\"{{boldChatButtonId}}\" dynamic-div=\"{{boldChatButtonDiv}}\" data-chat-button=\"{{boldChatButton}}\"></bold-chat-static-button></div></div><div class=\"row mts\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img src=\"images/phoneBlack.png\" class=\"mtm plm\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div translate=\"wireless_popup_phone\" class=\"mtl pts\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div translate=\"wireless_popup_not_sure\" class=\"mtm\"></div><a class=\"title-h5\" ng-href=\"{{viewAllPlanslink}}\" target=\"_blank\"><span translate=\"wireless_popup_all_plans\" class=\"bold\"></span></a></div></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span translate=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("module/formChequing/templates/formChequing.modal.html","<div class=\"wrapper ute-form-chequing\" ng-if=\"formChequing.showDebitForm\"><div class=\"myr-mop-debit-left-body\"><div class=\"change-mop-overlay-summary debit\"><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_from\"></span><br class=\"visible-sm\"><span>{{formChequing.mopObj.oldPaymentMethod.translationId | translate}}</span></div><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_to\"></span><br class=\"visible-sm\"><span>{{formChequing.mopObj.newPaymentMethod.translationId | translate}}</span></div></div><div class=\"mtm mbm\"><div class=\"paynow-body-size\"><div class=\"secure-pay-container\"><h3 class=\"secure-pay-header\" translate=\"ute.payment.method.change_method_secure_debit\"></h3><img class=\"mbs\" src=\"images/lock.png\"><br></div><div class=\"secure-pay-title\" translate=\"ute.payment.method.change_method_info_secure_debit\"></div><div class=\"debit-info-header ptl\" translate=\"ute.payment.method.change_method_cheque_header\"></div></div></div><div class=\"row cheque-label-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_transit_code\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_bank_code\"></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_account_number\"></div></div></div><div class=\"row cheque-form-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_transit_code\"></div><input data-tl-private=\"\" type=\"text\" name=\"transitNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{5}$/\" id=\"transitNo\" maxlength=\"5\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.transitFocused=false\" ng-focus=\"formChequing.transitFocused=true\" data-ng-model=\"formChequing.chequingObj.transitNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-if=\"formChequing.debitForm.transitNo.$dirty && formChequing.debitForm.transitNo.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-show=\"( formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.transitNo.$error\" ng-if=\"formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\" class=\"prm\"></span></span></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_bank_code\"></div><input data-tl-private=\"\" type=\"text\" name=\"bankCode\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{3}$/\" id=\"bankCode\" maxlength=\"3\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.bankFocused=false;\" ng-focus=\"formChequing.bankFocused=true;\" data-ng-model=\"formChequing.chequingObj.bankCode\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-if=\"formChequing.debitForm.bankCode.$dirty && formChequing.debitForm.bankCode.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-if=\"( formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.bankCode.$error\" ng-if=\"formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\" class=\"prm\"></span></span></div></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_account_number\"></div><input data-tl-private=\"\" type=\"text\" name=\"accountNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{7,12}$/\" id=\"accountNo\" maxlength=\"12\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.accountFocused=false;\" ng-focus=\"formChequing.accountFocused=true;\" data-ng-model=\"formChequing.chequingObj.accountNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-show=\"formChequing.debitForm.accountNo.$dirty && formChequing.debitForm.accountNo.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-if=\"( formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.accountNo.$error\" ng-if=\"formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_account\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_account\" class=\"prm\"></span></span></div></div></div></div></div><div class=\"row cheque-form-error-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.transitNo.$error\" ng-if=\"formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\" class=\"prm\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.bankCode.$error\" ng-if=\"formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\" class=\"prm\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.accountNo.$error\" ng-if=\"formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_account\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_account\" class=\"prm\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div></div></div><div class=\"ptm\"><div class=\"hidden-xs\"><div class=\"img-cheque\"><img id=\"overlay\" src=\"images/overlay_cheque_account.png\" data-ng-show=\"formChequing.accountFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_bank.png\" data-ng-show=\"formChequing.bankFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_transit.png\" data-ng-show=\"formChequing.transitFocused\"></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><div class=\"img-cheque-mobile\"><img class=\"default-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"!formChequing.accountFocused && !formChequing.bankFocused && !formChequing.transitFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"formChequing.accountFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_bank_s.jpg\" data-ng-show=\"formChequing.bankFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_transit_s.jpg\" data-ng-show=\"formChequing.transitFocused\"></div></div></div></div><div class=\"myr-mop-debit-right-body\"><h3 class=\"ptm pbm black tandc-header\" translate=\"ute.payment.method.change_method_terms_debit\"></h3><div><div class=\"legal-text-container\"><textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\" class=\"legal-text\" readonly=\"\" ng-model=\"formChequing.tandcText\">\n      </textarea></div><div class=\"inline_error accept-error\" ng-messages=\"formChequing.debitForm.isAccepted.$error\" ng-if=\"formChequing.debitForm.isAccepted.$invalid && formChequing.debitForm.$submitted\"><span class=\"fa fa-exclamation-circle ute-icon-error-icon\"></span> <span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_not_accepted\" class=\"mbs\"></span><ute-dtm-error-form-field key=\"formChequing.dtmName\" error-prefix=\"CS\"></ute-dtm-error-form-field></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"formChequing.debitForm.isAccepted.$invalid && formChequing.debitForm.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" id=\"isAccepted\" ng-model=\"formChequing.isAccepted\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\" required=\"\"> <label for=\"isAccepted\" class=\"mop-debit-checkbox\"></label></span> <span class=\"tandc-check-text\" translate=\"ute.payment.method.change_method_accept\"></span></div><div class=\"change-mop-debit-card-actions\"><div class=\"mop-update-button-container\"><button translate=\"ute.payment.method.mop_update_payment_method_button\" type=\"submit\" ng-click=\"formChequing.update($event)\" class=\"action change-mop-update-action\">Update payment method</button> <span class=\"widget-loader-inline\" ng-if=\"formChequing.isPaymentUpdating\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><a translate=\"ute.common.label.cancel\" ng-click=\"formChequing.cancel($event)\" class=\"action change-mop-cancel-action\"></a></div></div></div></div>");
$templateCache.put("module/formChequing/templates/pm.formChequing.html","<div class=\"ute-form-chequing-pm\"><div ng-if=\"formChequing.currentStep === formChequing.STEP.ACCOUNT\"><div class=\"pm-bank-text\" translate=\"ute.payment.method.pm_bank_secure_text\"></div><div class=\"pm-bank-form\"><div class=\"pm-bank-transit\"><label><input type=\"text\" data-tl-private=\"\" name=\"transitNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{5}$/\" id=\"transitNo\" maxlength=\"5\" ng-blur=\"formChequing.selectFormField(4)\" ng-focus=\"formChequing.selectFormField(1)\" data-ng-model=\"formChequing.chequingObj.transitNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"><div class=\"label-error-group\"><span translate=\"ute.payment.method.change_method_info_transit_code\"></span> <span class=\"cheque-secondary-label\" translate=\"ute.payment.method.pm_sub_label_transit\"></span></div><div class=\"ute-icon-error-icon\"></div><div class=\"ute-icon-checkmark-1\"></div></label></div><div class=\"pm-bank-institution\"><label><input type=\"text\" data-tl-private=\"\" name=\"bankCode\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{3}$/\" id=\"bankCode\" maxlength=\"3\" data-ng-model=\"formChequing.chequingObj.bankCode\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\" ng-blur=\"formChequing.selectFormField(4)\" ng-focus=\"formChequing.selectFormField(2)\"><div class=\"label-error-group\"><span translate=\"ute.payment.method.change_method_info_bank_code\"></span> <span class=\"cheque-secondary-label\" translate=\"ute.payment.method.pm_sub_label_institution\"></span></div><div class=\"ute-icon-error-icon\"></div><div class=\"ute-icon-checkmark-1\"></div></label></div><div class=\"pm-bank-account\"><label><input type=\"text\" data-tl-private=\"\" name=\"accountNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{7,12}$/\" id=\"accountNo\" maxlength=\"12\" data-ng-model=\"formChequing.chequingObj.accountNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\" ng-blur=\"formChequing.selectFormField(4)\" ng-focus=\"formChequing.selectFormField(3)\"><div class=\"label-error-group\"><span translate=\"ute.payment.method.change_method_account_number\"></span> <span class=\"cheque-secondary-label\" translate=\"ute.payment.method.pm_sub_label_account\"></span></div><div class=\"ute-icon-error-icon\"></div><div class=\"ute-icon-checkmark-1\"></div></label></div></div><div class=\"pm-bank-cheque\"><img ng-src=\"{{formChequing.getBankImage()}}\" alt=\"\"></div></div><div ng-if=\"formChequing.currentStep === formChequing.STEP.REVIEW\"><div class=\"tandc-header\" translate=\"ute.payment.method.change_method_terms_debit\"></div><div class=\"tandc-container\"><textarea name=\"\" id=\"\" cols=\"30\" rows=\"6\" class=\"legal-text\" readonly=\"\" ng-model=\"formChequing.tandcText\">\n    </textarea></div><div class=\"accept-error\" ng-messages=\"formChequing.debitForm.isAccepted.$error\" ng-if=\"formChequing.debitForm.isAccepted.$invalid && formChequing.debitForm.$submitted\"><div class=\"ute-icon-error-icon\"></div><div class=\"accept-error-text\" translate=\"ute.payment.method.change_method_not_accepted\" data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"true\" data-form-field-name=\"terms and condition checkbox\" data-mapping-key=\"paymentMethod.errorDebit,errors:paymentMethod.errorCategory\"></div></div><div class=\"tandc-accept\"><md-checkbox ng-model=\"formChequing.isAccepted\" ng-required=\"true\" md-no-ink=\"\" name=\"isAccepted\" aria-label=\"Finished?\">{{ \'ute.payment.method.change_method_accept\' | translate }}</md-checkbox></div></div></div>");
$templateCache.put("module/formChequing/templates/updateDebit.modal.html","<div class=\"wrapper ute-form-chequing update-debit-payment\" ng-if=\"formChequing.showDebitForm\" adl-event-track=\'{\"mappingKey\":\"event.selfServeStart\",\"pageView\":\"true\",\"callBackParam\":{\"pageKey\":\"preAuthPaymentMethod-bank\"}}\'><div class=\"myr-mop-debit-left-body\"><div class=\"mbm\"><div class=\"paynow-body-size\"><div class=\"secure-pay-title\" translate=\"ute.payment.method.change_method_info_secure_debit\"></div><div class=\"debit-info-header ptl\" translate=\"ute.payment.method.change_method_cheque_header\"></div></div></div><div class=\"row cheque-label-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_transit_code\"></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_bank_code\"></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_account_number\"></div></div></div><div class=\"row cheque-form-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_transit_code\"></div><input data-tl-private=\"\" type=\"text\" name=\"transitNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{5}$/\" id=\"transitNo\" maxlength=\"5\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.transitFocused=false\" ng-focus=\"formChequing.transitFocused=true\" data-ng-model=\"formChequing.chequingObj.transitNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-if=\"formChequing.debitForm.transitNo.$dirty && formChequing.debitForm.transitNo.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-show=\"( formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.transitNo.$error\" ng-if=\"formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\" class=\"prm\"></span></span></div></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_info_bank_code\"></div><input data-tl-private=\"\" type=\"text\" name=\"bankCode\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{3}$/\" id=\"bankCode\" maxlength=\"3\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.bankFocused=false;\" ng-focus=\"formChequing.bankFocused=true;\" data-ng-model=\"formChequing.chequingObj.bankCode\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-if=\"formChequing.debitForm.bankCode.$dirty && formChequing.debitForm.bankCode.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-if=\"( formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.bankCode.$error\" ng-if=\"formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\" class=\"prm\"></span></span></div></div></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"prl\"><label class=\"rel pbm cheque-label-container\"><div class=\"cheque-data-label\" translate=\"ute.payment.method.change_method_account_number\"></div><input data-tl-private=\"\" type=\"text\" name=\"accountNo\" tag-form-name=\"form\" tag-page-name=\"Cheque Form\" ng-pattern=\"/^\\d{7,12}$/\" id=\"accountNo\" maxlength=\"12\" ng-model-options=\"{ updateOn: \'blur\'}\" ng-blur=\"formChequing.accountFocused=false;\" ng-focus=\"formChequing.accountFocused=true;\" data-ng-model=\"formChequing.chequingObj.accountNo\" cobrowse=\"false\" required=\"\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\"> <span ng-show=\"formChequing.debitForm.accountNo.$dirty && formChequing.debitForm.accountNo.$valid\" class=\"inline-checker ute-icon-checkmark-1\"></span> <span class=\"inline-checker icon-error ute-icon-error-icon\" data-ng-if=\"( formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted))\"></span></label><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12 visible-sm visible-xs\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.accountNo.$error\" ng-if=\"formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_account\"></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_account\" class=\"prm\"></span></span></div></div></div></div></div><div class=\"row cheque-form-error-container\"><div class=\"col-lg-4 col-md-4 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.transitNo.$error\" ng-if=\"formChequing.debitForm.transitNo.$invalid && (formChequing.debitForm.transitNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"transit code\"}\'></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_transit_code\" class=\"prm\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"transit code\"}\'></span></span></div></div><div class=\"col-lg-3 col-md-3 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.bankCode.$error\" ng-if=\"formChequing.debitForm.bankCode.$invalid && (formChequing.debitForm.bankCode.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"bank code\"}\'></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_bank_code\" class=\"prm\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"bank code\"}\'></span></span></div></div><div class=\"col-lg-5 col-md-5 col-sm-12 col-xs-12\"><div class=\"inline_error\" ng-messages=\"formChequing.debitForm.accountNo.$error\" ng-if=\"formChequing.debitForm.accountNo.$invalid && (formChequing.debitForm.accountNo.$dirty || formChequing.debitForm.$submitted)\"><span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_invalid_account\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"account number\"}\'></span></span> <span ng-message=\"pattern\"><span translate=\"ute.payment.method.change_method_invalid_account\" class=\"prm\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"account number\"}\'></span></span></div></div></div><div class=\"ptm\"><div class=\"hidden-xs\"><div class=\"img-cheque\"><img id=\"overlay\" src=\"images/overlay_cheque_account.png\" data-ng-show=\"formChequing.accountFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_bank.png\" data-ng-show=\"formChequing.bankFocused\"> <img id=\"overlay\" src=\"images/overlay_cheque_transit.png\" data-ng-show=\"formChequing.transitFocused\"></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><div class=\"img-cheque-mobile\"><img class=\"default-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"!formChequing.accountFocused && !formChequing.bankFocused && !formChequing.transitFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_account_s.jpg\" data-ng-show=\"formChequing.accountFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_bank_s.jpg\" data-ng-show=\"formChequing.bankFocused\"> <img class=\"check-image\" id=\"overlay\" src=\"images/overlay_cheque_transit_s.jpg\" data-ng-show=\"formChequing.transitFocused\"></div></div></div></div><div class=\"myr-mop-debit-right-body\"><h3 class=\"ptm pbm black tandc-header\" translate=\"ute.payment.method.change_method_terms_debit\"></h3><div><div class=\"legal-text-container\"><textarea name=\"\" id=\"\" cols=\"30\" rows=\"10\" class=\"legal-text\" readonly=\"\" ng-model=\"formChequing.tandcText\"></textarea></div><div class=\"inline_error accept-error\" ng-messages=\"formChequing.debitForm.isAccepted.$error\" ng-if=\"formChequing.debitForm.isAccepted.$invalid && formChequing.debitForm.$submitted\"><span class=\"fa fa-exclamation-circle ute-icon-error-icon\"></span> <span ng-message=\"required\"><span translate=\"ute.payment.method.change_method_not_accepted\" class=\"mbs\" adl-error-track=\'{\"mappingKey\":\"preAuthPaymentMethod-bank\",\"field\":\"terms & conditions\"}\'></span></span></div><div class=\"check-box-label ptm pbm\"><span ng-class=\"formChequing.debitForm.isAccepted.$invalid && formChequing.debitForm.$submitted ? \'checkbox_error\' : \'\'\" class=\"mrs\"><input class=\"check-terms\" type=\"checkbox\" name=\"isAccepted\" id=\"isAccepted\" ng-model=\"formChequing.isAccepted\" ng-disabled=\"formChequing.isCare || formChequing.isDealer\" required=\"\"> <label for=\"isAccepted\" class=\"mop-debit-checkbox\"></label></span> <span class=\"tandc-check-text\" translate=\"ute.payment.method.change_method_accept\"></span></div><div class=\"change-mop-debit-card-actions\"><div class=\"mop-update-button-container\"><button translate=\"ute.payment.method.update_debit_button\" type=\"submit\" ng-click=\"formChequing.update($event)\" class=\"action pm-ute-primary-button change-mop-update-action\">Update payment method</button> <span class=\"widget-loader-inline\" ng-if=\"formChequing.isPaymentUpdating\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><a translate=\"ute.common.label.cancel\" ng-click=\"formChequing.cancel($event)\" class=\"action change-mop-cancel-action\"></a></div></div></div></div>");
$templateCache.put("module/paymentMethod/templates/ap.link.html","<span class=\"get-services-link get-services-font\" ng-if=\"paymentMethod.accountPreferenceLinkText !== \'\'\" ng-click=\"paymentMethod.aoChangePayment()\"><span translate=\"{{paymentMethod.accountPreferenceLinkText}}\"></span> <span class=\"rui-icon-arrow-right float-none preference-arrow preference-arrow\"></span></span>");
$templateCache.put("module/paymentMethod/templates/paymentMethod.html","<div class=\"ute-payment-method\"><div id=\"self-serve-payment-info\"><div class=\"flex flex-v-center\"><div class=\"payment-method-header\" translate=\"ute.payment.method.payment_information\"></div><div class=\"widget-loader\" ng-if=\"paymentMethod.isPaymentMethodLoading\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div ng-if=\"!(paymentMethod.isPaymentMethodLoading || paymentMethod.isMethodOfPaymentUnavailable)\"><div ng-if=\"paymentMethod.desktopView\" id=\"desktopTemplate\" ng-class=\"\'pm_current_payment_method_\' + paymentMethod.PaymentMethodType[paymentMethod.currentPaymentMethodType]\"><div class=\"pay-info-header-container\" ng-if=\"!paymentMethod.showInvoicePaymentMethodInformation()\" ng-class=\"{\'pm-one-view\': paymentMethod.isOneView()}\"><div class=\"pay-info-label\"><div class=\"pay-info-text\" translate=\"ute.payment.method.payment_method\"></div><div class=\"pay-info-type\">{{paymentMethod.currentPaymentMethod.translationId | translate}}</div></div><div class=\"payment-method-change-container\" ng-if=\"!paymentMethod.isPaymentMethodLoading && paymentMethod.canChangePayment\"><div class=\"change-payment-method-link\" ng-if=\"!paymentMethod.isPaymentMethodChanging\"><a class=\"edit-icon\" ng-click=\"paymentMethod.onChangePayment($event)\" translate=\"ute.payment.method.change_payment_method\"></a></div><div class=\"change-payment-select-group flex flex-v-center\" ng-if=\"paymentMethod.isPaymentMethodChanging\"><div class=\"change-payment-label hidden-xs hidden-s\" translate=\"ute.payment.method.mop_change_to\"></div><div class=\"change-payment-select-container\"><div class=\"dropdown\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"ute-mop-select-dropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">{{paymentMethod.selectedPaymentMethod.translationId | translate}}</button><ul class=\"dropdown-menu\" aria-labelledby=\"ute-mop-select-dropdown\"><li class=\"dropdown-item\" ng-repeat=\"mop in paymentMethod.getPaymentMethods()\" ng-click=\"paymentMethod.selectMethodOfPayment(mop)\">{{mop.translationId | translate}}</li></ul></div></div><div class=\"change-payment-cancel\"><a ng-click=\"paymentMethod.onPaymentCancel($event)\" translate=\"ute.common.label.cancel\"></a></div></div></div></div><div class=\"pay-info-header-container pm-manual-to-auto-conatainer flex\" ng-if=\"paymentMethod.showInvoicePaymentMethodInformation()\" ng-class=\"{\'pm-one-view\': paymentMethod.isOneView()}\"><div class=\"pay-info-text\" translate=\"ute.payment.method.payment_method\"></div><div class=\"pay-info-type\">{{paymentMethod.currentPaymentMethod.translationId | translate}}</div><div class=\"setup-payment-method-link\" ng-click=\"paymentMethod.onSetupAutoPayment($event)\" ng-if=\"(!paymentMethod.isPaymentMethodChanging && paymentMethod.isOneView()) || !paymentMethod.isOneView()\"><a class=\"edit-icon\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\' translate=\"ute.payment.method.setup_automatic_payment_link\"></a></div><div class=\"change-payment-select-group flex flex-v-center\" ng-if=\"paymentMethod.isPaymentMethodChanging\"><div class=\"change-payment-label hidden-xs hidden-s\" translate=\"ute.payment.method.mop_change_to\"></div><div class=\"change-payment-select-container\"><div class=\"dropdown\"><button class=\"btn btn-default dropdown-toggle\" type=\"button\" id=\"ute-mop-select-dropdown\" data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"true\">{{paymentMethod.selectedPaymentMethod.translationId | translate}}</button><ul class=\"dropdown-menu\" aria-labelledby=\"ute-mop-select-dropdown\"><li class=\"dropdown-item\" ng-repeat=\"mop in paymentMethod.getPaymentMethods()\" ng-click=\"paymentMethod.selectMethodOfPayment(mop)\">{{mop.translationId | translate}}</li></ul></div></div><div class=\"change-payment-cancel\"><a ng-click=\"paymentMethod.onPaymentCancel($event)\" translate=\"ute.common.label.cancel\"></a></div></div></div><div class=\"payment-information-container\"><div class=\"pay-info-details-container\"><div ng-if=\"paymentMethod.showCreditPaymentMethodInformation()\"><div class=\"card-wrapper\"><div class=\"warning flex flex-v-center\" ng-if=\"paymentMethod.isCCExpiring && !paymentMethod.isCCExpired\"><div class=\"warning-image\"><img src=\"ute-payment-method/assets/error-white.png\" alt=\"warning\"></div><div class=\"message-text\" translate=\"ute.payment.method.credit_card_expiry_warning\"></div></div><div class=\"error-container flex flex-v-center\" ng-if=\"paymentMethod.isCCExpired\"><div class=\"error-image\"><img src=\"ute-payment-method/assets/error-white.png\" alt=\"error\"></div><div class=\"message-text\" translate=\"ute.payment.method.credit_card_invalid\"></div></div><div ng-class=\"{ \'cc-pay-error\' : paymentMethod.isCCExpired, \'cc-pay-expiring\' : paymentMethod.isCCExpiring }\" class=\"cc-pay-details\"><div class=\"cc-header\"><div class=\"cc-header-text\" translate=\"ute.payment.method.credit_card_type_number\"></div><div class=\"cc-expiry-text\" translate=\"ute.payment.method.expiry_on\"></div><div></div></div><div class=\"cc-footer\"><div class=\"cc-image\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"\"><div class=\"cc-type-number-group\"><div class=\"cc-type\" translate=\"ute.payment.method.{{paymentMethod.creditCardDetail.type | lowercase}}\"></div><div class=\"cc-number\">{{paymentMethod.creditCardDetail.number}}</div></div></div><div class=\"cc-expiry-date\">{{paymentMethod.creditCardDetail.expiry}}</div><div class=\"cc_update\"><a class=\"edit-icon\" ng-click=\"paymentMethod.updatePaymentMethod(true)\"><span translate=\"ute.payment.method.update_credit_card\"></span></a></div></div></div></div></div><div ng-if=\"paymentMethod.showDebitPaymentMethodInformation()\"><div class=\"gray-border-selfserve\"></div><div class=\"debit-pay-details flex\"><div class=\"debit-icon\"><img ng-src=\"ute-common-assets/assets/building-icon.png\" alt=\"\" class=\"debit-card\"></div><div class=\"db-pay-details-group1\"><div class=\"db-header-container\" translate=\"ute.payment.method.bank_account_label\"></div><div class=\"db-details\">{{ paymentMethod.getChequingAccountNumber()}}</div></div><div class=\"db-pay-details-group2\"><div class=\"update-db-link\"><a class=\"edit-icon\" ng-if=\"::paymentMethod.userService.isConsumer()\" ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update_bank_account\"></span></a> <a class=\"edit-icon\" ng-if=\"::!paymentMethod.userService.isConsumer()\"><span translate=\"ute.payment.method.update_bank_account\"></span></a></div></div></div></div><div ng-if=\"paymentMethod.showInvoicePaymentMethodInformation()\"><div class=\"other-ways-to-pay\" translate=\"ute.payment.method.ways_to_pay_bill_label\"></div><div class=\"invoice-pay-details\"><div class=\"invoice-pay-item icon-pay-online\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.add_rogers_as_payee\"></p><p><span translate=\"ute.payment.method.payee_name\"></span> <span ng-if=\"paymentMethod.isSGI\" translate=\"ute.payment.method.twelve_digit_account\"></span> <span ng-if=\"!paymentMethod.isSGI\" translate=\"ute.payment.method.nine_digit_account\"></span><br><span class=\"invoice-heading\" translate=\"ute.payment.method.pm_invoice_heading_account_number\"></span> {{paymentMethod.selectedAccount.accountNumber}}</p></div></div><div class=\"invoice-pay-item icon-pay-app\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.rogers_app\"></p></div></div><div class=\"invoice-pay-item icon-pay-call\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.call_rogers\"></p></div></div><div class=\"invoice-pay-item icon-pay-locator\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.self_serve_pay_in_store\"></p></div></div><div class=\"invoice-pay-item icon-pay-bank\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.pay_at_bank\"></p></div></div><div class=\"invoice-pay-item icon-pay-mail\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.mail_cheques\"></p></div></div></div><p class=\"how-to-pay\" translate=\"ute.payment.method.invoice_more_info\"></p></div></div></div></div><div ng-if=\"!paymentMethod.desktopView\" id=\"mobileTemplate\"><div class=\"pay-info-header-container pay-info-bank\" ng-if=\"paymentMethod.showDebitPaymentMethodInformation()\"><div class=\"pay-info-text\" translate=\"ute.payment.method.payment_method\"></div><div class=\"update-block\"><div class=\"pay-info-type\">{{paymentMethod.currentPaymentMethod.translationId | translate}}</div><div class=\"change-payment-method-link\" ng-if=\"!paymentMethod.isPaymentMethodChanging\"><a ng-click=\"paymentMethod.onChangePayment($event)\" translate=\"ute.payment.method.change_payment_method\"></a></div></div></div><div class=\"pay-info-header-container flex\" ng-if=\"paymentMethod.showCreditPaymentMethodInformation()\"><div class=\"pay-info-text\" translate=\"ute.payment.method.payment_method\"></div><div class=\"update-block\"><div class=\"pay-info-type\">{{paymentMethod.currentPaymentMethod.translationId | translate}}</div><div class=\"cc_update\"><a ng-click=\"paymentMethod.onChangePayment($event)\" translate=\"ute.payment.method.change_payment_method\"></a></div></div></div><div class=\"pay-info-header-container flex\" ng-if=\"paymentMethod.showInvoicePaymentMethodInformation()\"><div class=\"pay-info-text\" translate=\"ute.payment.method.payment_method\"></div><div class=\"pay-info-type\">{{paymentMethod.currentPaymentMethod.translationId | translate}}</div><div class=\"setup-payment-method-link\" ng-click=\"paymentMethod.onSetupAutoPayment($event)\"><a adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\' translate=\"ute.payment.method.setup_automatic_payment_link\"></a></div><div class=\"other-ways-to-pay\" translate=\"ute.payment.method.ways_to_pay_bill_label\"></div></div><div class=\"payment-information-container\"><div class=\"pay-info-details-container\"><div ng-if=\"paymentMethod.showCreditPaymentMethodInformation()\"><div class=\"warning flex flex-v-center\" ng-if=\"paymentMethod.isCCExpiring && !paymentMethod.isCCExpired\"><div class=\"warning-image\"><img src=\"ute-payment-method/assets/error-white.png\" alt=\"warning\"></div><div class=\"message-text\" translate=\"ute.payment.method.credit_card_expiry_warning\"></div></div><div class=\"error-container flex flex-v-center\" ng-if=\"paymentMethod.isCCExpired\"><div class=\"error-image\"><img src=\"ute-payment-method/assets/error-white.png\" alt=\"error\"></div><div class=\"message-text\" translate=\"ute.payment.method.credit_card_invalid\"></div></div><div ng-class=\"{ \'cc-pay-error\' : paymentMethod.isCCExpired, \'cc-pay-expiring\' : paymentMethod.isCCExpiring }\" class=\"cc-pay-details\"><div class=\"cc-header\"><div class=\"cc-header-text\" translate=\"ute.payment.method.credit_card_type_number\"></div></div><div class=\"cc-footer\"><div class=\"cc-image\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"\"><div class=\"cc-type-number-group\"><div class=\"cc-type\" translate=\"ute.payment.method.{{paymentMethod.creditCardDetail.type | lowercase}}\"></div><div class=\"cc-number\">{{paymentMethod.creditCardDetail.number}}</div></div></div><div class=\"cc-expiry\"><div class=\"cc-expiry-text\" translate=\"ute.payment.method.expiry_on\"></div><div class=\"cc-expiry-date\">{{paymentMethod.creditCardDetail.expiry}}</div></div><div class=\"change-payment-method-link\" ng-if=\"!paymentMethod.isPaymentMethodChanging\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update_credit_card\"></span></a></div></div></div></div><div ng-if=\"paymentMethod.showDebitPaymentMethodInformation()\"><div class=\"debit-pay-details flex\"><div class=\"db-pay-details-group1 flex\"><div class=\"db-header-container\" translate=\"ute.payment.method.bank_account_label\"></div><div class=\"db-details flex\">{{paymentMethod.getChequingAccountNumber()}}</div></div><div class=\"db-pay-details-group2\"><div class=\"update-db-link flex flex-v-center\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update_bank_account\"></span></a></div></div></div></div><div ng-if=\"paymentMethod.showInvoicePaymentMethodInformation()\"><div class=\"invoice-pay-details\"><div class=\"invoice-pay-item icon-pay-online multi-line\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.add_rogers_as_payee\"></p><div class=\"\"><div><span class=\"invoice-heading\" translate=\"ute.payment.method.payee_name\"></span></div><div ng-if=\"paymentMethod.isSGI\" translate=\"ute.payment.method.twelve_digit_account\"></div><div ng-if=\"!paymentMethod.isSGI\" translate=\"ute.payment.method.nine_digit_account\"></div><div><span class=\"invoice-heading\" translate=\"ute.payment.method.pm_invoice_heading_account_number\"></span> {{paymentMethod.selectedAccount.accountNumber}}</div></div></div></div><div class=\"invoice-pay-item icon-pay-bank\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.pay_at_bank\"></p></div></div><div class=\"invoice-pay-item icon-pay-app\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"{{paymentMethod.showAppLink}}\"></p></div></div><div class=\"invoice-pay-item icon-pay-mail multi-line\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.mail_cheques\"></p></div></div><div class=\"invoice-pay-item icon-pay-call\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.call_rogers\"></p></div></div><div class=\"invoice-pay-item icon-pay-locator\"><div class=\"invoice-item-content\"><p class=\"invoice-heading\" translate=\"ute.payment.method.self_serve_pay_in_store\"></p></div></div></div><p class=\"how-to-pay\" translate=\"ute.payment.method.invoice_more_info\"></p></div></div></div></div></div></div><div class=\"gray-border-selfserve no-margin-top\"></div></div>");
$templateCache.put("module/paymentMethod/templates/paymentMethodAccountBalance.html","<div class=\"ute-payment-method-container\"><div class=\"text-center\" ng-if=\"paymentMethod.isPaymentMethodLoading && !paymentMethod.isMethodOfPaymentUnavailable\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div ng-class=\"{\'red-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpired, \'yellow-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpiring}\" ng-if=\"!paymentMethod.isPaymentMethodLoading || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"expire_messages\" ng-class=\"{\'invisible\': !(paymentMethod.showCreditPaymentMethodInformation() && (paymentMethod.isCCExpiring || paymentMethod.isCCExpired))}\"><div class=\"isExpiringBanner row\" ng-if=\"!paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpiring\"><div class=\"isExpiringLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expiring\"></div><div class=\"isExpiringMsg\" translate=\"ute.payment.method.will_expire_days\" translate-values=\"{days:paymentMethod.getDaysToExpire()}\"></div></div><div class=\"isExpiredBanner row\" ng-if=\"!paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpired\"><div class=\"isExpiredLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expired\"></div><div class=\"isExpiredMsg\" translate=\"ute.payment.method.is_expired_msg\"></div></div></div><div class=\"account-balance-payment-info acct-ovw\"><div class=\"payment-information-container\"><div class=\"pay-info-details-container\"><div class=\"credit-auto-pay-details\" ng-if=\"paymentMethod.showCreditPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\" class=\"auto-title\"></div><div class=\"row\" ng-if=\"!(paymentMethod.isCCExpiring || paymentMethod.isCCExpired)\" style=\"padding-top: 14px;\"><div class=\"col-xs-8 col-sm-7\"><div class=\"cc-image\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"{{\'ute.payment.method.alt_\' + paymentMethod.creditCardDetail.type.toLowerCase() | translate}}\"> <span class=\"cc-number\" ng-class=\"{\'red-color\': paymentMethod.isCCExpired}\"><span translate=\"ute.payment.method.ending_number\"></span> {{paymentMethod.getLast4Digits();}}</span> <span class=\"update-method\" ng-if=\"paymentMethod.isCCExpired || paymentMethod.isCCExpiring\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span></a></span></div></div><div class=\"col-xs-4 col-sm-5\"><div class=\"text-right payment-history\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div><div class=\"row\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><div><div class=\"cc-image\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"{{\'ute.payment.method.alt_\' + paymentMethod.creditCardDetail.type.toLowerCase() | translate}}\"> <span class=\"cc-number\" ng-class=\"{\'red-color\': paymentMethod.isCCExpired}\"><span translate=\"ute.payment.method.ending_number\"></span> {{paymentMethod.getLast4Digits();}}</span> <span class=\"update-method\" ng-if=\"paymentMethod.isCCExpired || paymentMethod.isCCExpiring\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span></a></span></div></div><div><div class=\"col-md-6\"><div class=\"cc-pay-details-expiry-details-group red-color\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><span class=\"cc-expiry-text\" translate=\"ute.payment.method.expires_on\" ng-if=\"paymentMethod.isCCExpiring\"></span> <span class=\"cc-expiry-text\" translate=\"ute.payment.method.expired_on\" ng-if=\"paymentMethod.isCCExpired\"></span> <span class=\"cc-expiry-date\">{{paymentMethod.getFullExpiryDate() | date : \'MMM dd, yyyy\'}}</span></div></div><div class=\"col-md-6\"><div class=\"payment-history\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div></div></div><div class=\"debit-auto-pay-details\" ng-if=\"paymentMethod.showDebitPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div><div><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\"></div><div class=\"row debit-info\"><div class=\"col-xs-8\"><div class=\"debit-icon\"><img ng-src=\"ute-common-assets/assets/building-icon.png\" alt=\"\" class=\"debit-card\"></div><div class=\"account-number\"><div translate=\"ute.payment.method.account_prefix\"></div><div>{{paymentMethod.getChequingAccountNumber()}}</div></div></div><div class=\"col-xs-4 payment-history\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div><div></div></div></div><div class=\"invoice-pay-details\" ng-if=\"paymentMethod.showInvoicePaymentMethodInformation() || paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"row\"><div class=\"col-xs-8 col-md-12 auto-payment\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><a href=\"#\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\' translate=\"ute.payment.method.setup_auto_payment\"></span></a></div><div class=\"col-xs-4 col-md-12\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div></div></div></div><div class=\"gray-border-selfserve no-margin-top\"></div></div></div>");
$templateCache.put("module/paymentMethod/templates/paymentMethodAccountBalanceViewBill.html","<div class=\"ute-payment-method-container\"><div class=\"text-center\" ng-if=\"paymentMethod.isPaymentMethodLoading && !paymentMethod.isMethodOfPaymentUnavailable\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div ng-class=\"{\'red-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpired, \'yellow-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpiring}\" ng-if=\"!paymentMethod.isPaymentMethodLoading || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"expire_messages\" ng-class=\"{\'invisible view-bill\': !(paymentMethod.showCreditPaymentMethodInformation() && (paymentMethod.isCCExpiring || paymentMethod.isCCExpired))}\"><div class=\"isExpiringBanner row\" ng-if=\"!paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpiring\"><div class=\"isExpiringLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expiring\"></div><div class=\"isExpiringMsg\" translate=\"ute.payment.method.will_expire_days\" translate-values=\"{days:paymentMethod.getDaysToExpire()}\"></div></div><div class=\"isExpiredBanner row\" ng-if=\"!paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpired\"><div class=\"isExpiredLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expired\"></div><div class=\"isExpiredMsg\" translate=\"ute.payment.method.is_expired_msg\"></div></div></div><div class=\"account-balance-payment-info\" ng-class=\"{\'pad-top\':!(paymentMethod.isCCExpiring || paymentMethod.isCCExpired) || paymentMethod.showDebitPaymentMethodInformation()}\"><div class=\"payment-information-container\"><div class=\"pay-info-details-container\"><div class=\"credit-auto-pay-details\" ng-if=\"paymentMethod.showCreditPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\" class=\"auto-title view-bill\"></div><div class=\"row\" ng-if=\"!(paymentMethod.isCCExpiring || paymentMethod.isCCExpired)\"><div class=\"col-xs-12 col-lg-7\"><div class=\"cc-image viewbill\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"{{\'ute.payment.method.alt_\' + paymentMethod.creditCardDetail.type.toLowerCase() | translate}}\"> <span class=\"cc-number\" ng-class=\"{\'red-color\': paymentMethod.isCCExpired}\"><span translate=\"ute.payment.method.ending_number\"></span> {{paymentMethod.getLast4Digits();}}</span></div></div><div class=\"col-xs-12 col-lg-5\"></div><div class=\"row bottom-links\"><div class=\"col-xs-12 auto-payment\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\" ng-class=\"{\'col-md-7\': paymentMethod.rs.currentStateName !==\'paymenthistory\'}\"><a href=\"#\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span translate=\"ute.payment.method.mop_title\"></span></a></div><div class=\"col-xs-12 col-md-5\" ng-if=\"paymentMethod.rs.currentStateName !==\'paymenthistory\'\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div><div class=\"row\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><div class=\"row\"><div class=\"col-xs-12 col-md-9\"><div class=\"view-bill-cc-img\"><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"{{\'ute.payment.method.alt_\' + paymentMethod.creditCardDetail.type.toLowerCase() | translate}}\"></div><div class=\"view-bill-cc-text red-color\"><span translate=\"ute.payment.method.ending_number\"></span> <span>{{paymentMethod.getLast4Digits();}}</span> <span class=\"update-link hidden-md hidden-lg\" ng-if=\"paymentMethod.isCCExpired || paymentMethod.isCCExpiring\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span></a></span><div class=\"red-color visible-md visible-lg\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><span class=\"cc-expiry-text\" translate=\"ute.payment.method.expires_on\" ng-if=\"paymentMethod.isCCExpiring\"></span> <span class=\"cc-expiry-text\" translate=\"ute.payment.method.expired_on\" ng-if=\"paymentMethod.isCCExpired\"></span> <span class=\"cc-expiry-date\">{{paymentMethod.getFullExpiryDate() | date : \'MMM dd, yyyy\'}}</span></div></div></div><div class=\"col-xs-12 col-md-3 visible-md visible-lg\"><span class=\"update-method\" ng-if=\"paymentMethod.isCCExpired || paymentMethod.isCCExpiring\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span></a></span></div></div><div class=\"row expiry-links-mob\"><div class=\"red-color hidden-md hidden-lg\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><span class=\"cc-expiry-text\" translate=\"ute.payment.method.expires_on\" ng-if=\"paymentMethod.isCCExpiring\"></span> <span class=\"cc-expiry-text\" translate=\"ute.payment.method.expired_on\" ng-if=\"paymentMethod.isCCExpired\"></span> <span class=\"cc-expiry-date\">{{paymentMethod.getFullExpiryDate() | date : \'MMM dd, yyyy\'}}</span></div></div><div class=\"row bottom-links\"><div class=\"col-md-6 auto-payment payment-method-link\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><a href=\"#\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span translate=\"ute.payment.method.mop_title\"></span></a></div><div class=\"col-md-6 payment-history-link\" ng-if=\"paymentMethod.rs.currentStateName !==\'paymenthistory\'\"><div class=\"payment-history view-bill\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div></div></div><div class=\"debit-auto-pay-details\" ng-if=\"paymentMethod.showDebitPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div><div><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\"></div><div class=\"row debit-info\"><div class=\"debit-icon view-bill\"><img ng-src=\"ute-common-assets/assets/building-icon.png\" alt=\"\" class=\"debit-card view-bill\"></div><div class=\"account-number view-bill\"><div translate=\"ute.payment.method.account_prefix\"></div><div>{{paymentMethod.getChequingAccountNumber()}}</div></div></div><div class=\"row view-bill-links\"><div class=\"col-xs-12 auto-payment\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\" ng-class=\"{\'col-md-7\': paymentMethod.rs.currentStateName !==\'paymenthistory\'}\"><a href=\"#\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span translate=\"ute.payment.method.mop_title\"></span></a></div><div class=\"col-xs-12 col-md-5\" ng-if=\"paymentMethod.rs.currentStateName !==\'paymenthistory\'\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div><div></div></div></div><div class=\"invoice-pay-details view-bill white-space-center\" ng-class=\"{\'cancelled-act\': paymentMethod.isAccountCancelled()}\" ng-if=\"paymentMethod.showInvoicePaymentMethodInformation() || paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"row\"><div class=\"col-xs-12 auto-payment\" ng-class=\"{\'col-md-7\': paymentMethod.rs.currentStateName !==\'paymenthistory\'}\"><div ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><a href=\"#\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\' translate=\"ute.payment.method.setup_auto_payment\"></span></a></div></div><div class=\"col-xs-12 col-md-5\" ng-if=\"paymentMethod.rs.currentStateName !==\'paymenthistory\'\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a></div></div></div></div></div></div><div class=\"gray-border-selfserve no-margin-top\"></div></div></div>");
$templateCache.put("module/paymentMethod/templates/paymentMethodOneviewAccountBalance.html","<div class=\"ute-payment-method-container one-view\"><div class=\"text-center loading-icon\" ng-if=\"paymentMethod.isPaymentMethodLoading && !paymentMethod.isMethodOfPaymentUnavailable\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div class=\"ute-payment-method-wrapper\" ng-class=\"{\'red-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpired, \'yellow-bg\': !paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && paymentMethod.isCCExpiring}\" ng-if=\"!paymentMethod.isPaymentMethodLoading || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"expire_messages\" ng-if=\"!paymentMethod.isAccountCancelled() && paymentMethod.showCreditPaymentMethodInformation() && (paymentMethod.isCCExpiring || paymentMethod.isCCExpired)\"><div class=\"isExpiringBanner\" ng-if=\"paymentMethod.isCCExpiring\"><div class=\"isExpiringLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expiring\"></div><div class=\"isExpiringMsgContainer\"><div class=\"isExpiringMsg\" translate=\"ute.payment.rep.will_expire_days\" translate-values=\"{days:paymentMethod.getDaysToExpire()}\"></div><span class=\"update-method\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span> <span class=\"rui-icon-arrow-right arrow-icon\"></span></a></span></div></div><div class=\"isExpiredBanner\" ng-if=\"paymentMethod.isCCExpired\"><div class=\"isExpiredLabel {{paymentMethod.languageService.getCurrentLanguage()}}\" translate=\"ute.payment.method.card_expired\"></div><div class=\"isExpiredMsgContainer\"><div class=\"isExpiredMsg\" translate=\"ute.payment.rep.is_expired_msg\"></div><span class=\"update-method\"><a ng-click=\"paymentMethod.updatePaymentMethod()\"><span translate=\"ute.payment.method.update\"></span> <span class=\"rui-icon-arrow-right arrow-icon\"></span></a></span></div></div></div><div class=\"account-balance-payment-info\"><div class=\"payment-information-container\"><div class=\"pay-info-details-container\"><div class=\"credit-auto-pay-details\" ng-if=\"paymentMethod.showCreditPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"no-flex-children credit-info-container\"><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\" class=\"auto-title view-bill\"></div><div><div class=\"cc-image viewbill\"><div><img ng-src=\"{{paymentMethod.creditCardImage}}\" alt=\"{{\'ute.payment.method.alt_\' + paymentMethod.creditCardDetail.type.toLowerCase() | translate}}\"><div class=\"red-color\" ng-if=\"paymentMethod.isCCExpiring || paymentMethod.isCCExpired\"><div class=\"cc-expiry-text\" translate=\"ute.payment.method.expires_on\" ng-if=\"paymentMethod.isCCExpiring\"></div><div class=\"cc-expiry-text\" translate=\"ute.payment.method.expired_on\" ng-if=\"paymentMethod.isCCExpired\"></div><div class=\"cc-expiry-date\">{{paymentMethod.getFullExpiryDate() | date : \'MMM dd, yyyy\'}}</div></div><div class=\"clearfix\"></div></div><div class=\"cc-number\"><span translate=\"ute.payment.method.ending_number\"></span> {{paymentMethod.getLast4Digits();}}</div></div></div></div><div class=\"payment-links\" ng-class=\"{\'two-links\': !paymentMethod.ptpReadPermissionAccess}\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a> <a href=\"#\" ng-click=\"paymentMethod.changeToAutomaticPayment(false)\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><span translate=\"ute.payment.method.mop_title\"></span></a> <a href=\"#\" ng-click=\"paymentMethod.goToPTP()\" ng-if=\"paymentMethod.ptpReadPermissionAccess\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"schedule-ptp,event.selfServeStart\"}\'><span translate=\"ute.payment.rep.schedule_ptp\"></span></a></div></div><div class=\"debit-auto-pay-details\" ng-if=\"paymentMethod.showDebitPaymentMethodInformation() && !paymentMethod.isAccountCancelled() && !paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"no-flex-children debit-info-container\"><div translate=\"{{paymentMethod.getPaymentMethodTitleKey()}}\"></div><div class=\"row debit-info\"><div class=\"debit-icon view-bill\"><img ng-src=\"ute-common-assets/assets/building-icon.png\" alt=\"\" class=\"debit-card view-bill\"></div><div class=\"account-number view-bill\"><div translate=\"ute.payment.method.account_prefix\"></div><div>{{paymentMethod.getChequingAccountNumber()}}</div></div></div></div><div class=\"payment-links\" ng-class=\"{\'two-links\': !paymentMethod.ptpReadPermissionAccess}\"><a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a> <a href=\"#\" ng-click=\"paymentMethod.changeToAutomaticPayment(false)\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><span translate=\"ute.payment.method.mop_title\"></span></a> <a href=\"#\" ng-click=\"paymentMethod.goToPTP()\" ng-if=\"paymentMethod.ptpReadPermissionAccess\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"schedule-ptp,event.selfServeStart\"}\'><span translate=\"ute.payment.rep.schedule_ptp\"></span></a></div></div><div class=\"invoice-pay-details\" ng-class=\"{\'cancelled-act\': paymentMethod.isAccountCancelled()}\" ng-if=\"paymentMethod.showInvoicePaymentMethodInformation() || paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable\"><div class=\"payment-links\" ng-class=\"{\'two-links\': !paymentMethod.ptpReadPermissionAccess}\"><a href=\"#\" ng-click=\"paymentMethod.changeToAutomaticPayment(true)\" ng-if=\"!(paymentMethod.isAccountCancelled() || paymentMethod.isMethodOfPaymentUnavailable)\"><span adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\' translate=\"ute.payment.method.setup_auto_payment\"></span></a> <a href=\"#/paymenthistory\"><span translate=\"ute.payment.method.history\"></span></a> <a href=\"#\" ng-click=\"paymentMethod.goToPTP()\" ng-if=\"paymentMethod.ptpReadPermissionAccess\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"schedule-ptp,event.selfServeStart\"}\'><span translate=\"ute.payment.rep.schedule_ptp\"></span></a></div></div></div></div></div></div></div>");
$templateCache.put("module/paymentMethod/templates/paymentMethodOneviewViewbill.html","<div class=\"ute-payment-method row\"><div ng-if=\"paymentMethod.showCreditPaymentMethodInformation() || paymentMethod.showDebitPaymentMethodInformation()\"><div class=\"col-xs-12 col-md-5\"><a class=\"button-view-bill\" ng-click=\"paymentMethod.updatePaymentMethod()\"><span class=\"bold\" translate=\"ute.payment.method.update_account\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div><div class=\"col-xs-12 col-md-7\"><a class=\"mrm button-view-bill\" ng-click=\"paymentMethod.changeToAutomaticPayment(false)\"><span class=\"bold\" translate=\"ute.payment.method.change_to_manual_payment_link\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div><div ng-if=\"paymentMethod.showInvoicePaymentMethodInformation()\" class=\"col-xs-12 col-md-5\" ng-click=\"paymentMethod.changeToAutomaticPayment(true)\"><a class=\"button-view-bill\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"automatic-payment-setup,event.selfServeStart\"}\'><span class=\"bold\" translate=\"ute.payment.method.setup_automatic_payment_link\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div></div>");
$templateCache.put("module/paymentMethod/templates/paymentMethodPaymentTopBar.html","<div class=\"ute-payment-method\"><a class=\"mrm button-view-bill\" ng-click=\"paymentMethod.changePaymentMethod(false)\"><span class=\"bold\" translate=\"ute.payment.method.mop_title\"></span> <span class=\"rui-icon-button-arrow-right font-s\"></span></a></div>");
$templateCache.put("module/paymentMethodModal/templates/paymentMethod.modal.creditCard.html","<form class=\"\" id=\"formCreditCard\" name=\"$ctrl.form\" novalidate=\"\"><div ng-include=\"::((!$ctrl.overlayModel.isPaymentMethodUpdating) ? \'module/paymentMethodModal/templates/pm.change.creditCard.partial.html\' : \'module/paymentMethodModal/templates/pm.update.creditCard.partial.html\')\" class=\"pm-body-left-include\"></div></form>");
$templateCache.put("module/paymentMethodModal/templates/paymentMethod.modal.debitCard.html","<form id=\"form\" name=\"$ctrl.bankForm\" novalidate=\"\" class=\"pm-debit-form\"><div ng-if=\"$ctrl.overlayModel.isPaymentMethodUpdating\"><ute-form-chequing show-debit-form=\"$ctrl.showDebitForm\" mop-obj=\"$ctrl.mopObj\" chequing-obj=\"$ctrl.chequingObj\" debit-form=\"$ctrl.bankForm\" submit-form=\"$ctrl.submit()\" dtm-name=\"$ctrl.dtmName\" template-url=\"module/formChequing/templates/updateDebit.modal.html\"></ute-form-chequing></div><span ng-if=\"!$ctrl.overlayModel.isPaymentMethodUpdating\"><ute-form-chequing show-debit-form=\"$ctrl.showDebitForm\" mop-obj=\"$ctrl.mopObj\" chequing-obj=\"$ctrl.chequingObj\" debit-form=\"$ctrl.bankForm\" submit-form=\"$ctrl.submit()\" dtm-name=\"$ctrl.dtmName\" template-url=\"module/formChequing/templates/pm.formChequing.html\" current-step=\"$ctrl.step\"></ute-form-chequing><div class=\"pm-bank-continue\" ng-if=\"!$ctrl.showBalanceBanner()\"><button class=\"continue-button pm-button-semi-wide pm-sm-button-wide\" ng-click=\"$ctrl.debitNextStep($ctrl.bankForm)\" translate=\"ute.payment.method.manual_payment_continue\" ng-if=\"$ctrl.step === $ctrl.STEP.ACCOUNT\" ng-disabled=\"($ctrl.bankForm.$valid !== true && $ctrl.bankForm.$invalid !== false)\"></button> <button class=\"continue-button pm-button-semi-wide pm-sm-button-wide\" ng-click=\"$ctrl.checkTermsAndSubmit($ctrl.bankForm)\" translate=\"ute.payment.method.pm_submit\" ng-if=\"$ctrl.step === $ctrl.STEP.REVIEW\"></button> <button class=\"continue-button debit-close-button pm-button-semi-wide pm-sm-button-wide\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_done\" ng-if=\"$ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.billingDetail.balanceAmount > 0\"></button></div></span><div class=\"\" ng-if=\"$ctrl.isPaymentSuccess && $ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.selectedPaymentMethod === \'D\'\" ng-include=\"\'module/paymentMethodModal/templates/pm.modal.cpm.confirmation.message.html\'\"></div></form>");
$templateCache.put("module/paymentMethodModal/templates/paymentMethod.modal.html","<div class=\"mop-container change-update-payment-group\"><div ng-include=\"\'module/paymentMethodModal/templates/pm.modal.header.partial.html\'\"></div><div ng-if=\"$ctrl.step === $ctrl.STEP.ACCOUNT || $ctrl.step === $ctrl.STEP.REVIEW || $ctrl.step === $ctrl.STEP.CONFIRMATION\" ng-class=\"{\'pm-sel-met-R\': $ctrl.selectedPaymentMethod === \'R\' && $ctrl.step === $ctrl.STEP.CONFIRMATION}\"><div class=\"step-rail\" ng-class=\"{\'pm-confirmation-step\': $ctrl.step === $ctrl.STEP.CONFIRMATION}\"><div class=\"step-container\"><div class=\"step\" data-ng-repeat=\"step in $ctrl.stepManager\" data-ng-class=\"{\'active\' : step.active, \'complete\': step.complete}\"><div class=\"step-circle\">{{step.number}}</div><div class=\"step-text\" translate=\"ute.payment.method.{{step.text}}\"></div><div class=\"step-divider\" ng-class=\"step.text\" style=\"position: absolute;\"><div></div><div></div></div></div></div></div><div class=\"container-fluid success-content-wrapper\" ng-if=\"$ctrl.isPaymentSuccess && $ctrl.step === $ctrl.STEP.CONFIRMATION\"><div class=\"success-content\"><div class=\"success-logo\"><img src=\"ute-common-assets/assets/success.png\" alt=\"\"></div><div class=\"pm-success-text-content\"><div class=\"success-header-text\">{{($ctrl.currentPaymentMethod === \'R\' ? \'ute.payment.method.pm_success_change_payment_text\' : \'ute.payment.method.pm_success_update_payment_text\') | translate}}</div><div class=\"success-email-text\" translate=\"ute.payment.method.pm_email_confirmation_text\"></div></div></div></div><div class=\"pm-content pm-content-body pm-sm-flex\"><div ng-include=\"\'module/paymentMethodModal/templates/pm.modal.body.left.html\'\" class=\"pm-body-left-include\"></div><div ng-include=\"\'module/paymentMethodModal/templates/pm.modal.body.right.html\'\" class=\"pm-body-right-include\" id=\"pm-right-body\"></div></div><div class=\"pm-merchant\" ng-class=\"{\'item-selected\': $ctrl.selectedPaymentMethod !== \'\'}\"><ng-include src=\"\'module/paymentMethodModal/templates/pm.merchant.partial.html\'\"></ng-include></div></div><div ng-if=\"$ctrl.step === $ctrl.STEP.MOP_IS_CHANGING\" class=\"pm-is-changing\"><div class=\"pm-loader\"><img src=\"ute-common-assets/assets/widget-loader-lg_plain.gif\" alt=\"\"></div><div class=\"pm-processing-text\" translate=\"ute.payment.method.pm_processing\"></div></div><div ng-if=\"$ctrl.step === $ctrl.STEP.SUCCESS || $ctrl.step === $ctrl.STEP.NO_CHANGE_MADE\" class=\"pm-is-success\"><div class=\"pm-loader\"><img src=\"ute-payment-method/assets/success_lg.png\" alt=\"\"></div><div class=\"pm-success-text\">{{\"ute.payment.method.\" + $ctrl.STEP[$ctrl.step] | translate}}</div></div><div ng-if=\"$ctrl.step === $ctrl.STEP.FAILURE\" class=\"pm-is-failure\"><div class=\"pm-failure-text\">{{\"ute.payment.method.failure.\" + $ctrl.selectedPaymentMethod + \".header\" | translate}}</div><div class=\"pm-failure-help-text\" translate=\"ute.payment.method.help_text\" ng-if=\"$ctrl.selectedPaymentMethod !== \'R\'\"></div><div class=\"pm-failure-blue-banner\"><div class=\"pm-failure-chat-inner\"><div class=\"pm-live-chat\"><div class=\"live-chat\"><bold-chat-static-button data-cbid=\"{{$ctrl.livechat.cbid | translate}}\" data-dynamic-div=\"{{$ctrl.livechat.dynamicDivId | translate}}\" data-chat-button=\"{{$ctrl.livechat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div></div><div ng-if=\"!$ctrl.firstAttempt\" class=\"pm_done_try_again\"><button class=\"pm-ute-button-no-decor\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_done\"></button> <button class=\"pm-ute-primary-button\" ng-click=\"$ctrl.tryAgain()\" translate=\"ute.payment.method.pm_try_again\"></button></div><div class=\"pm_done_try_again_attempt-two\" ng-if=\"$ctrl.firstAttempt\"><button class=\"pm-ute-primary-button\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_done\"></button></div></div></div>");
$templateCache.put("module/paymentMethodModal/templates/paymentMethod.modal.window.html","<div tabindex=\"-1\" role=\"dialog\" class=\"modal pm-modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 9999999999 + index*10}\"><div class=\"modal-dialog change-payment-modal {{size ? \'modal-\' + size : \'\'}}\"><div class=\"modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/paymentMethodModal/templates/paymentMethod.rep.invoice.html","<div class=\"mop-container change-update-payment-group\"><section class=\"mop\" ng-if=\"$ctrl.step === $ctrl.STEP.CHANGE_MOP\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"$ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_title\" class=\"mop-title\"></h2></header><div class=\"change-mop-overlay-summary\" ng-if=\"!$ctrl.showDebitForm\"><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_from\"></span><br class=\"visible-xs\"><span>{{$ctrl.overlayModel.oldPaymentMethod.translationId | translate}}</span></div><div><span class=\"row-label\" translate=\"ute.payment.method.mop_change_to\"></span><br class=\"visible-xs\">{{$ctrl.overlayModel.newPaymentMethod.translationId | translate}}</div></div><div></div><section ng-if=\"$ctrl.isInvoice\" style=\"margin-top:20px;\"><div ng-if=\"$ctrl.overlayModel.billingDetail.balanceAmount > 0 && $ctrl.billDueDate\" translate=\"ute.payment.method.mop_summary_explanation_with_balance\" data-translate-values=\"{date:($ctrl.billDueDate | date:\'MMMM dd, yyyy\')}\" style=\"margin-bottom: 30px;\"></div><div ng-if=\"$ctrl.overlayModel.billingDetail.balanceAmount <= 0 || !$ctrl.billDueDate\" translate=\"ute.payment.method.mop_summary_explanation_no_balance\" style=\"margin-bottom: 30px;\"></div><div class=\"flex\"><button translate=\"ute.payment.method.mop_update_payment_method_button\" ng-click=\"$ctrl.submit()\" class=\"change-mop-update-action\"></button> <span class=\"widget-loader-inline\" ng-if=\"$ctrl.isPaymentMethodChanging\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span> <button translate=\"ute.common.label.cancel\" ng-click=\"$ctrl.close()\" class=\"change-mop-cancel-action\"></button></div></section></section><section ng-if=\"$ctrl.step === $ctrl.STEP.SUCCESS\" class=\"change-mop-done change-mop-success mop\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"$ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_success_title\"></h2></header><div translate=\"ute.payment.method.mop_success_message_{{$ctrl.overlayModel.newPaymentMethod.type}}\"></div><div><button class=\"change-mop-close-action\" translate=\"ute.payment.method.mop_close\" ng-click=\"$ctrl.close()\"></button></div></section><section ng-if=\"$ctrl.step === $ctrl.STEP.FAILURE\" class=\"change-mop-done change-mop-failure mop\"><header class=\"change-mop-overlay-header\"><div class=\"change-mop-overlay-header-logo\"></div><img class=\"close-icon\" ng-click=\"$ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.mop_failure_title\"></h2></header><div translate=\"ute.payment.method.mop_failure_message\"></div><div class=\"mop-need-help\"><bold-chat-static-button data-cbid=\"{{$ctrl.livechat.cbid | translate}}\" data-dynamic-div=\"{{$ctrl.livechat.dynamicDivId | translate}}\" data-chat-button=\"{{$ctrl.livechat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div><div><div></div><button class=\"change-mop-close-action\" translate=\"ute.payment.method.mop_close\" ng-click=\"$ctrl.close()\"></button></div></section><section class=\"pm-rep-merchant-invoice\" ng-class=\"{\'ov-merchant-address\': $ctrl.userType !== \'consumer\'}\"><ng-include src=\"\'module/paymentMethodModal/templates/pm.merchant.partial.html\'\"></ng-include></section></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.change.creditCard.partial.html","<span><span ng-class=\"{\'pm-credit-card-ui-step-account\': $ctrl.step === $ctrl.STEP.ACCOUNT}\" class=\"pm-credit-card-ui-step-no-account\"><ute-credit-card user-type=\"$ctrl.userType\" credit-payment-obj=\"$ctrl.creditCard\" card-time=\"$ctrl.cardTime\" dtm-name=\"$ctrl.dtmName\" fire-data-layer=\"true\" is-modal-popup=\"true\" mapping-key=\"$ctrl.dataLayerMappingKey\"></ute-credit-card><div class=\"flex flex-v-center mt-30\"><button type=\"button\" ng-if=\"!$ctrl.overlayModel.isPaymentMethodUpdating && !$ctrl.paymentOptionSelected\" translate=\"ute.payment.method.manual_payment_continue\" ng-click=\"$ctrl.submit($ctrl.form, $ctrl.PaymentMethodType.C)\" ng-disabled=\"($ctrl.form.$valid !== true && $ctrl.form.$invalid !== false)\" class=\"change-mop-update-action\"></button> <button type=\"button\" ng-if=\"$ctrl.overlayModel.isPaymentMethodUpdating && !$ctrl.paymentOptionSelected\" translate=\"ute.payment.method.{{$ctrl.overlayModel.newType === $ctrl.PaymentMethodType.CREDIT ? \'update_credit_card_button\' : \'\'}}\" ng-click=\"$ctrl.submit($ctrl.form)\" class=\"change-mop-update-action\" style=\"margin-top:30px;\"></button> <span class=\"widget-loader-inline\" ng-if=\"$ctrl.isPaymentMethodChanging\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span><div class=\"pull-right col-xs-5 one-view-section\"  =\"\" ng-if=\"$ctrl.paymentOptionSelected && $ctrl.user.userType !== \'consumer\'\"><button type=\"button\" translate=\"ute.common.label.cancel\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-link col-xs-3 col-xs-offset-1 ute-payment-method-ov-cancel\"></button> <button type=\"button\" translate=\"ute.common.label.continue\" ng-click=\"$ctrl.submit($ctrl.form)\" class=\"col-xs-offset-1 col-xs-3 update-button\"></button></div></div></span><div ng-if=\"($ctrl.step === $ctrl.STEP.REVIEW)\" ng-include=\"\'module/paymentMethodModal/templates/pm.modal.cc_Info.html\'\"></div><div class=\"\" ng-if=\"$ctrl.isPaymentSuccess && $ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.selectedPaymentMethod === \'C\'\" ng-include=\"\'module/paymentMethodModal/templates/pm.modal.cpm.confirmation.message.html\'\"></div></span>");
$templateCache.put("module/paymentMethodModal/templates/pm.merchant.partial.html","<div class=\"pm-merchant-header\" translate=\"ute.payment.method.merchant.header\">MERCHANT</div><div class=\"pm-merchant-address\"><div translate=\"ute.payment.method.merchant.name\">ROGERS COMMUNICATIONS CANADA INC.</div><div translate=\"ute.payment.method.merchant.street\">333 BLOOR STREET EAST</div><div translate=\"ute.payment.method.merchant.city\">TORONTO, ONTARIO</div><div translate=\"ute.payment.method.merchant.postal\">M4W 1G9</div><div translate=\"ute.payment.method.merchant.country\">CANADA</div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.body.left.html","<div class=\"modal-body-content-left pm-content\"><div class=\"current-pm\"><div class=\"pm-inner-content\"><div class=\"current-pm-header\">{{($ctrl.step === $ctrl.STEP.CONFIRMATION ? \'ute.payment.method.payment_method\' : \'ute.payment.method.pm_current_payment_method\') | translate}}</div><div class=\"current-pm-value\"><span translate=\"ute.payment.method.pm_auto_payment\" ng-if=\"$ctrl.currentPaymentMethod !== \'R\'\"></span> <span>{{$ctrl.getCurrentPaymentMethodText() | translate}}</span></div></div></div><div ng-if=\"$ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.selectedPaymentMethod !== \'R\'\" ng-include=\"\'module/paymentMethodModal/templates/pm.modal.cc_Info.html\'\"></div><div ng-if=\"$ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.selectedPaymentMethod === \'R\'\" style=\"margin-top: 25px;\"><button class=\"pm-ute-primary-button\" style=\"width:100%;\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_done\"></button></div><div class=\"change-pm-selector\" ng-if=\"!$ctrl.isPaymentSuccess && $ctrl.step !== $ctrl.STEP.CONFIRMATION\"><div class=\"change-header-text\" translate=\"ute.payment.method.pm_what_like_do\"></div><div class=\"change-selection\" tabindex=\"-1\" ng-class=\"{\'hide-outline\': $ctrl.hideOutline}\" ng-mousedown=\"$ctrl.hideOutline = true\" ng-keydown=\"$ctrl.hideOutline = false\"><md-radio-group ng-model=\"$ctrl.selectedPaymentMethod\" md-no-ink=\"\"><md-radio-button value=\"D\" ng-click=\"$ctrl.selectPaymentType(\'D\')\">{{ $ctrl.currentPaymentMethod === \'D\' ? \'ute.payment.method.pm_current_radio_bank\' : $ctrl.currentPaymentMethod === \'R\' ? \'ute.payment.method.pm_manual_to_automatic_bank\' : \'ute.payment.method.pm_change_radio_bank\' | translate}}</md-radio-button><md-radio-button value=\"C\" ng-click=\"$ctrl.selectPaymentType(\'C\')\">{{ $ctrl.currentPaymentMethod !== \'C\' ? \'ute.payment.method.pm_change_radio_cc\' : \'ute.payment.method.pm_current_radio_cc\' | translate}}<div class=\"cc-acceptance-text\">{{\'ute.payment.method.pm_radio_cc_subtext\' | translate}}</div></md-radio-button><md-radio-button value=\"R\" ng-if=\"$ctrl.currentPaymentMethod !== \'R\'\" ng-click=\"$ctrl.selectPaymentType(\'R\')\">{{\'ute.payment.method.pm_manual_pay\' | translate}}</md-radio-button></md-radio-group></div></div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.body.right.html","<div class=\"modal-body-content-right pm-content\" ng-if=\"$ctrl.selectedPaymentMethod !== \'\'\"><credit-card-ui ng-if=\"$ctrl.selectedPaymentMethod === \'C\'\" on-success=\"$ctrl.onCreditCardSaved(data)\" on-error=\"$ctrl.onCreditCardFailed(error)\" on-cancel=\"ctrl.close()\" ng-class=\"{\'pm-content-confirmation\': $ctrl.step === $ctrl.STEP.CONFIRMATION}\"></credit-card-ui><debit-card-ui ng-if=\"$ctrl.selectedPaymentMethod === \'D\'\"></debit-card-ui><div ng-if=\"$ctrl.selectedPaymentMethod === \'R\' && $ctrl.step !== $ctrl.STEP.CONFIRMATION\" ng-include=\"\'module/paymentMethodModal/templates/pm.modal.invoice.html\'\"></div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.cc_Info.html","<div class=\"cc-review-section\"><div class=\"cc-info-text\" ng-if=\"$ctrl.step !== $ctrl.STEP.CONFIRMATION\" translate=\"ute.payment.method.pm_cc_secure_message\"></div><div class=\"mask-bank-acc-number-wrapper\" ng-if=\"$ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.selectedPaymentMethod === \'D\'\"><div class=\"pm-conf-bank-header\" translate=\"ute.payment.method.bank_account_label\"></div><div class=\"pm-bank-masked-number\">{{$ctrl.getMaskedBankAccount()}}</div></div><div class=\"cc-summary\" ng-class=\"{\'cc-summary-confirmation\': $ctrl.step === $ctrl.STEP.CONFIRMATION}\" ng-if=\"$ctrl.selectedPaymentMethod === \'C\'\"><div class=\"cc-text-edit\"><div class=\"cc-header-text\" translate=\"ute.payment.method.pm_cc_header\"></div><div class=\"cc-edit-link\" ng-if=\"$ctrl.step !== $ctrl.STEP.CONFIRMATION\" ng-click=\"$ctrl.goBackToAccount()\" translate=\"ute.payment.method.pm_edit\"></div></div><div class=\"cc-image-number\"><div class=\"cc-image\"><img ng-src=\"{{$ctrl.savedCreditCardObject.creditCardType.image}}\" alt=\"\"></div><div class=\"cc-number\">{{$ctrl.getCreditCardMaskedText()}}</div></div><div class=\"cc-expiry-section\"><div class=\"cc-expiry-header\" translate=\"ute.payment.method.pm_expiry\"></div><div class=\"cc-expiry-text\">{{$ctrl.savedExpriyDate}}</div></div></div><div class=\"confirm-review\" ng-if=\"!$ctrl.showBalanceBanner()\"><button class=\"change-mop-update-action pm-sm-button-wide\" ng-if=\"$ctrl.step === $ctrl.STEP.REVIEW\" ng-click=\"$ctrl.creditNextStep()\" translate=\"ute.payment.method.manual_payment_continue\"></button> <button class=\"change-mop-update-action pm-sm-button-wide\" ng-if=\"$ctrl.step === $ctrl.STEP.CONFIRMATION && $ctrl.billingDetail.balanceAmount && $ctrl.billingDetail.balanceAmount > 0\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_done\"></button></div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.cpm.confirmation.message.html","<div class=\"confirmation-payment-info-wrapper\"><div class=\"success-content\"><div class=\"confirmation-payment-info-icon ute-semafone-info-icon\"></div><div class=\"pm-success-text-content\"><div class=\"pm-confirmation-header-text\" translate=\"ute.payment.method.pm_payment_for_next_billing_month_heading\"></div><div><div class=\"pm-pay-balance-button\" data-ng-if=\"$ctrl.billingDetail.balanceAmount && $ctrl.billingDetail.balanceAmount > 0\"><button name=\"payBill\" ng-click=\"$ctrl.close()\" ute-pay-now-button=\"\" account-balance=\"$ctrl.billingDetail\" account-details=\"$ctrl.accountDetails\" parent-state=\"{{$ctrl.toStateName}}\" tabindex=\"0\"><span class=\"white\" translate=\"ute.payment.method.pm_make_a_payment_balance\" translate-values=\"{amount:($ctrl.billingDetail.balanceAmount | currency)}\"></span></button></div><div class=\"pm-balance-close-button\"><button ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.close_button\"></button></div></div></div></div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.header.partial.html","<div class=\"pm-modal-header\"><div class=\"close-button\"><button ng-if=\"$ctrl.step === $ctrl.STEP.ACCOUNT || $ctrl.step === $ctrl.STEP.FAILURE || $ctrl.step === $ctrl.STEP.REVIEW || $ctrl.step === $ctrl.STEP.CONFIRMATION\" type=\"button\" class=\"close-button\" ng-click=\"$ctrl.close()\"><img src=\"ute-common-assets/assets/close-icon-light.png\" alt=\"\"></button></div><span ng-if=\"$ctrl.step !== $ctrl.STEP.FAILURE\"><div class=\"pm-secure-content\"><div class=\"pm-secure-icon\"><img src=\"ute-payment-method/assets/security-lock.png\" alt=\"Secure Form\"></div><div class=\"pm-secure-text\" translate=\"ute.payment.method.pm_secured\"></div></div><div ng-if=\"$ctrl.step === $ctrl.STEP.ACCOUNT || $ctrl.step === $ctrl.STEP.REVIEW || $ctrl.step === $ctrl.STEP.CONFIRMATION\" class=\"pm-modal-header-text\">{{($ctrl.originalPaymentMethod === \'R\' ? \'ute.payment.method.pm_setup_automatic_payments\' : \'ute.payment.method.change_payment_method\') | translate}}</div></span> <span ng-if=\"$ctrl.step === $ctrl.STEP.FAILURE\"><div class=\"pm-failure-header\"><div class=\"pm-failure-icon\"><img src=\"ute-common-assets/assets/warning_yellow_lg.png\" alt=\"\"></div><div class=\"pm-failure-text\" translate=\"ute.payment.method.pm_error_modal_header\"></div></div></span></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.inprocess.html","<div class=\"change-pm-in-progress\"></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.modal.invoice.html","<div class=\"pm-modal-invoice\"><div class=\"pm-invoice-header\" translate=\"ute.payment.method.pm_invoice_header\"></div><div class=\"pm-invoice-change-text\" translate=\"ute.payment.method.pm_invoice_subtext\"></div><div class=\"pm-flex pm-sm-flex pm-sm-reverse\"><button class=\"ute-secondary-button\" ng-click=\"$ctrl.callServer()\" translate=\"ute.payment.method.pm_invoice_yes\"></button> <button class=\"ute-primary-button\" ng-click=\"$ctrl.close()\" translate=\"ute.payment.method.pm_invoice_no\"></button></div></div>");
$templateCache.put("module/paymentMethodModal/templates/pm.update.creditCard.partial.html","<span adl-event-track=\'{\"mappingKey\":\"event.selfServeStart\",\"pageView\": \"true\",\"callBackParam\":{\"pageKey\":\"preAuthPaymentMethod-credit\",\"selfServeKey\":\"selfServe-{{$ctrl.overlayModel.methodOfPaymentData.creditCardDetails.ccType}}\"}}\'><ute-credit-card user-type=\"$ctrl.userType\" credit-payment-obj=\"$ctrl.creditCard\" card-time=\"$ctrl.cardTime\" dtm-name=\"$ctrl.dtmName\" fire-data-layer=\"true\" is-modal-popup=\"true\" mapping-key=\"$ctrl.preAuthPaymentCreditMappingKey\"></ute-credit-card><div class=\"flex flex-v-center mt-30\"><button type=\"button\" ng-if=\"!$ctrl.overlayModel.isPaymentMethodUpdating && !$ctrl.paymentOptionSelected\" translate=\"ute.payment.method.mop_update_payment_method_button\" ng-click=\"$ctrl.submit($ctrl.form, $ctrl.PaymentMethodType.C)\" class=\"change-mop-update-action\"></button> <button type=\"button\" ng-if=\"$ctrl.overlayModel.isPaymentMethodUpdating && !$ctrl.paymentOptionSelected\" translate=\"ute.payment.method.{{$ctrl.overlayModel.newType === $ctrl.PaymentMethodType.CREDIT ? \'update_credit_card_button\' : \'\'}}\" ng-click=\"$ctrl.submit($ctrl.form, $ctrl.PaymentMethodType.C)\" class=\"change-mop-update-action\"></button> <span class=\"widget-loader-inline\" ng-if=\"$ctrl.isPaymentMethodChanging\" aria-hidden=\"false\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span> <button type=\"button\" translate=\"ute.common.label.cancel\" ng-if=\"!$ctrl.paymentOptionSelected\" ng-click=\"$ctrl.cancel()\" class=\"change-mop-cancel-action\"></button><div class=\"pull-right col-xs-5 one-view-section\" ng-if=\"$ctrl.paymentOptionSelected && $ctrl.user.userType !== \'consumer\'\"><button type=\"button\" translate=\"ute.common.label.cancel\" ng-click=\"$ctrl.cancel()\" class=\"btn btn-link col-xs-3 col-xs-offset-1 ute-payment-method-ov-cancel\"></button> <button type=\"button\" translate=\"ute.common.label.continue\" ng-click=\"$ctrl.submit($ctrl.form, $ctrl.PaymentMethodType.C)\" class=\"col-xs-offset-1 col-xs-3 update-button\"></button></div></div></span>");
$templateCache.put("module/paymentMethodModal/templates/updatePayment.modal.html","<div class=\"mop-container change-update-payment-group\"><section class=\"mop\" ng-if=\"$ctrl.step === $ctrl.STEP.CHANGE_MOP\"><div class=\"update-payment-header-container\"><header class=\"change-mop-overlay-header\"><img class=\"close-icon\" ng-click=\"$ctrl.close()\" ng-src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><h2 translate=\"ute.payment.method.update_credit_card_header\" ng-if=\"$ctrl.isCredit\" class=\"mop-title\"></h2><h2 translate=\"ute.payment.method.update_debit_header\" ng-if=\"$ctrl.showDebitForm\" class=\"mop-title\"></h2></header></div><credit-card-ui ng-if=\"$ctrl.isCredit\" on-success=\"$ctrl.onCreditCardSaved(data)\" on-error=\"$ctrl.onCreditCardFailed(error)\" on-cancel=\"$ctrl.close()\"></credit-card-ui><debit-card-ui ng-if=\"$ctrl.showDebitForm\" on-success=\"$ctrl.onDebitCardSaved(data)\" on-error=\"$ctrl.onDebitCardFailed(error)\" on-cancel=\"$ctrl.close()\"></debit-card-ui></section><section ng-if=\"$ctrl.step === $ctrl.STEP.SUCCESS\" class=\"change-mop-done change-mop-success mop\"><div class=\"update-payment-header-container\"><header class=\"change-mop-overlay-header\"><img class=\"close-icon\" ng-click=\"$ctrl.close()\" ng-src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><div class=\"flex flex-v-center update-text-container\"><div class=\"ute-icon-check flex flex-v-center\"></div><h2 ng-if=\"$ctrl.isCredit\" translate=\"ute.payment.method.update_credit_card_header\" class=\"mop-title\"></h2><h2 ng-if=\"$ctrl.showDebitForm\" translate=\"ute.payment.method.update_debit_header\" class=\"mop-title\"></h2></div></header></div><div ng-if=\"$ctrl.isCredit\" class=\"credit-update-success-container\"><div class=\"update-success-text\" translate=\"ute.payment.method.update_cc_success_header\"></div><div class=\"cc-pay-details-group1\"><div class=\"cc-label-number-group flex\"><div class=\"cc-label\" translate=\"ute.payment.method.credit_card_type_number\"></div><div class=\"cc-details flex\"><div class=\"cc-image\"><img ng-src=\"{{$ctrl.getCreditCardImages()}}\" alt=\"\"></div><div class=\"cc-type-number-group\"><div class=\"cc-type\">{{$ctrl.getCreditCardType($ctrl.creditCard.creditCardType.name)}}</div><div class=\"cc-number\">{{$ctrl.creditCard.maskedCardNumber}}</div></div></div><div></div></div><div class=\"cc-expiry-group\"><div class=\"cc-pay-details-expiry-details-group flex\"><div class=\"cc-expiry-text\" translate=\"ute.payment.method.update_cc_expiry\"></div><div class=\"cc-expiry-date\">{{$ctrl.creditCard.expireDate.month}}/{{$ctrl.creditCard.expireDate.year}}</div></div></div></div><div class=\"done-button\"><button ng-click=\"$ctrl.close()\" class=\"change-mop-done-action\" translate=\"ute.payment.method.close_button\"></button></div></div><div ng-if=\"$ctrl.showDebitForm\" class=\"debit-update-success-container\"><div class=\"update-success-text\" translate=\"ute.payment.method.update_debit_success_header\"></div><div class=\"debit-details flex\"><div class=\"debit-label\" translate=\"ute.payment.method.update_debit_success_bank_account\"></div><div class=\"debit-number\">{{$ctrl.getDebitAccountNumberString($ctrl.chequingObj.accountNo)}}</div></div><div class=\"done-button\"><button ng-click=\"$ctrl.close()\" class=\"change-mop-done-action\" translate=\"ute.payment.method.close_button\"></button></div></div></section><section ng-if=\"$ctrl.step === $ctrl.STEP.FAILURE\" class=\"change-mop-done change-mop-failure mop\"><div class=\"update-payment-header-container\"><header ng-if=\"($ctrl.updateCreditCardFailed && $ctrl.isCredit)\" class=\"change-mop-overlay-header\"><img class=\"close-icon\" ng-click=\"$ctrl.close()\" ng-src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><div class=\"flex update-text-container\"><div class=\"flex flex-v-center header-img-container\"><img ng-src=\"ute-payment-method/assets/error.png\" style=\"width:30px;margin-bottom:5px;margin-right:10px;\" alt=\"\"></div><h2 translate=\"ute.payment.method.update_cc_invalid_header\" class=\"mop-title\"></h2></div></header><header ng-if=\"!$ctrl.updateCreditCardFailed\" class=\"change-mop-overlay-header\"><img class=\"close-icon\" ng-click=\"$ctrl.close()\" ng-src=\"ute-common-assets/assets/close-icon.png\" role=\"button\" tabindex=\"0\"><div class=\"flex update-text-container\"><div class=\"flex flex-v-center header-img-container\"><img ng-src=\"ute-payment-method/assets/error.png\" style=\"width:30px;margin-bottom:5px;margin-right:10px;\" alt=\"\"></div><h2 ng-if=\"$ctrl.isCredit\" translate=\"ute.payment.method.update_cc_system_header\" class=\"mop-title\"></h2><h2 ng-if=\"$ctrl.showDebitForm\" translate=\"ute.payment.method.update_debit_system_header\" class=\"mop-title\"></h2></div></header></div><div class=\"update-credit-card-failed update-debit-failed\" ng-if=\"!$ctrl.updateCreditCardFailed\"><div class=\"update-cc-failed-container\" ng-if=\"$ctrl.isCredit\"><div class=\"update-cc-failed-text\" translate=\"ute.payment.method.update_cc_system_explanation\"></div></div><div class=\"update-cc-failed-container\" ng-if=\"$ctrl.showDebitForm\"><div class=\"update-cc-failed-text\" translate=\"ute.payment.method.update_debit_system_explanation\"></div></div><div class=\"cantact-container flex\"><div class=\"speak-agent-container\"><div class=\"chat-container\"><bold-chat-static-button data-cbid=\"{{$ctrl.livechat.cbid | translate}}\" data-dynamic-div=\"{{$ctrl.livechat.dynamicDivId | translate}}\" data-chat-button=\"{{$ctrl.livechat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div></div><div class=\"update-credit-card-failed\" ng-if=\"$ctrl.updateCreditCardFailed\"><div class=\"update-cc-failed-container\"><div class=\"update-cc-failed-text\" translate=\"ute.payment.method.update_cc_invalid_explanation\"></div><div class=\"cc-pay-details-group1\"><div class=\"cc-label-number-group flex\"><div class=\"cc-label\" translate=\"ute.payment.method.credit_card_type_number\"></div><div class=\"cc-details flex\"><div class=\"cc-image\"><img ng-src=\"{{$ctrl.getCreditCardImages()}}\" alt=\"\"></div><div class=\"cc-type-number-group\"><div class=\"cc-type\">{{$ctrl.getCreditCardType($ctrl.creditCard.creditCardType.name)}}</div><div class=\"cc-number\">{{$ctrl.creditCard.maskedCardNumber}}</div></div><div class=\"cc-edit\" ng-click=\"$ctrl.edit()\"><span><img ng-src=\"{{\'ute-payment-method/assets/edit.png\'}}\" alt=\"\"></span><span class=\"cc-edit-link\">Edit</span></div></div><div></div></div><div class=\"cc-expiry-group\"><div class=\"cc-pay-details-expiry-details-group flex\"><div class=\"cc-expiry-text\" translate=\"ute.payment.method.update_cc_expiry\"></div><div class=\"cc-expiry-date\">{{$ctrl.creditCard.expireDate.month}}/{{$ctrl.creditCard.expireDate.year}}</div><div class=\"cc-edit\" ng-click=\"$ctrl.edit()\"><span><img ng-src=\"{{\'ute-payment-method/assets/edit.png\'}}\" alt=\"\"></span><span class=\"cc-edit-link\">Edit</span></div></div></div></div><div class=\"update-cc-failed-help\" translate=\"ute.payment.method.update_cc_invlaid_help\"></div><div class=\"cantact-container flex\"><div class=\"speak-agent-container\"><div class=\"chat-container\"><bold-chat-static-button data-cbid=\"{{$ctrl.livechat.cbid | translate}}\" data-dynamic-div=\"{{$ctrl.livechat.dynamicDivId | translate}}\" data-chat-button=\"{{$ctrl.livechat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div></div></div></section><section class=\"up-merchant-address\"><ng-include src=\"\'module/paymentMethodModal/templates/pm.merchant.partial.html\'\"></ng-include></section></div>");
$templateCache.put("module/paymentMethodModal/templates/updatePayment.modal.window.html","<div tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog modal-lg\"><div class=\"modal-content update-payment-debit-credit\" style=\"border-radius: 0px;-webkit-animation-name: animatetop;-webkit-animation-duration: 0.8s;-moz-animation-name: animatetop;-moz-animation-duration: 0.8s;-o-animation-name: animatetop;-o-animation-duration: 0.8s;animation-name: animatetop;animation-duration: 0.8s;\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/paymentMethodModal/templates/updatePaymentRep.modal.html","<section class=\"update-payment-section ute-payment-method-oneView\"><div class=\"modal-header\" ng-class=\"{\'modal-header-oneview\':$ctrl.isPaymentMethodChanging || $ctrl.isPaymentSuccess}\"><h5 class=\"secured-content\" translate=\"ute.payment.rep.securedform\"></h5><button type=\"button\" class=\"close\" ng-click=\"$ctrl.close()\"><span aria-hidden=\"true\">×</span></button><div ng-if=\"$ctrl.isPaymentMethodChanging && !$ctrl.isPaymentSuccess\" class=\"ute-payment-method-success-container status-aligin-center\"><span class=\"widget-loader-inline\" aria-hidden=\"false\"><img class=\"ute-payment-method-loading-img\" src=\"ute-common-assets/assets/widget-loader-lg_plain.gif\" alt=\"\"></span><div translate=\"ute.payment.rep.processpayment\" class=\"process-payment padding-success\"></div></div><div ng-if=\"$ctrl.isPaymentSuccess\" class=\"status-aligin-center ute-payment-method-success-container\"><span aria-hidden=\"false\"><img class=\"ute-payment-method-success-img\" src=\"ute-common-assets/assets/success.png\" alt=\"\"></span><div translate=\"ute.payment.rep.automatic\" class=\"process-payment padding-success\"></div></div><h2 class=\"update-content\" ng-if=\"!$ctrl.isPaymentMethodChanging && !$ctrl.isPaymentSuccess && !$ctrl.selectionType\" translate=\"ute.payment.rep.updatepayment\"></h2><h2 class=\"update-content\" ng-if=\"!$ctrl.isPaymentMethodChanging && !$ctrl.isPaymentSuccess && $ctrl.selectionType\" translate=\"ute.payment.rep.setup_automatic_payment\"></h2></div><div class=\"modal-body min-hight-oneview\" ng-class=\"{\'row\':$ctrl.paymentOptionSelected}\"><div class=\"ute-payment-method-options-container\" ng-if=\"!$ctrl.isPaymentMethodChanging && !$ctrl.isPaymentSuccess\"><h5 ng-if=\"$ctrl.selectionType\" class=\"question-content\" translate=\"ute.payment.rep.question\"></h5><h5 ng-if=\"!$ctrl.selectionType\" class=\"question-content\" translate=\"ute.payment.rep.question_update\"></h5><div class=\"payment-options border-top-line\"><input type=\"radio\" name=\"payment_options\" id=\"creditcard\" ng-model=\"$ctrl.paymentOptionSelected\" value=\"creditcard\"> <label class=\"label-content\" for=\"creditcard\"><div><i class=\"col-xs-1 label-padding pt-3 fa fa-circle-thin label-content\" aria-hidden=\"true\" ng-class=\"{\'selected\':$ctrl.paymentOptionSelected === \'creditcard\'}\" data-ng-if=\"$ctrl.paymentOptionSelected != \'creditcard\'\"></i> <i class=\"col-xs-1 label-padding pt-3 fa fa-dot-circle-o label-content bank-radio-width\" aria-hidden=\"true\" data-ng-if=\"$ctrl.paymentOptionSelected == \'creditcard\'\"></i><div class=\"ute-payment-method-radio-content label-padding padding-left\"><span ng-if=\"$ctrl.this.overlayModel.oldPaymentMethod.paymentMethodType === 0 || 3\" translate=\"ute.payment.method.credit_card_type_number\"></span> <span ng-if=\"$ctrl.this.overlayModel.oldPaymentMethod.paymentMethodType === 1\" translate=\"ute.payment.rep.switch_credit_card\"></span> <span ng-if=\"$ctrl.this.overlayModel.oldPaymentMethod.paymentMethodType === 2\" translate=\"ute.payment.rep.change_to_credit_card\"></span><h5 class=\"margin-sub-txt\" translate=\"ute.payment.rep.accepted_variants\"></h5></div></div></label> <input type=\"radio\" name=\"payment_options\" disabled=\"disabled\" id=\"bankaccount\" ng-model=\"$ctrl.paymentOptionSelected\" value=\"bankaccount\"> <label class=\"label-content\" for=\"bankaccount\" role=\"button\" tabindex=\"0\"><div><i class=\"col-xs-1 label-padding pt-3 fa fa-circle-thin label-content bank-radio-width\" aria-hidden=\"true\" data-ng-if=\"$ctrl.paymentOptionSelected != \'bankaccount\'\"></i> <i class=\"col-xs-1 label-padding pt-3 fa fa-dot-circle-o label-content bank-radio-width\" aria-hidden=\"true\" data-ng-if=\"$ctrl.paymentOptionSelected == \'bankaccount\'\"></i><div class=\"col-xs-11 label-padding padding-left\"><span ng-if=\"$ctrl.selectionType\" translate=\"ute.payment.rep.bankaccount\" class=\"ng-scope\"></span> <span ng-if=\"!$ctrl.selectionType\" translate=\"ute.payment.rep.changebankaccount\" class=\"ng-scope\"></span> <span class=\"only-available ng-scope\" translate=\"ute.payment.rep.onlyavailable\"></span><h5 class=\"margin-sub-txt\" translate=\"ute.payment.rep.notify\"></h5></div></div></label></div></div><div class=\"ute-payment-method-semafone-container\" ng-if=\"$ctrl.paymentOptionSelected && !$ctrl.isPaymentMethodChanging && !$ctrl.isPaymentSuccess\"><credit-card-ui></credit-card-ui></div></div><section class=\"pm-rep-merchant\"><ng-include src=\"\'module/paymentMethodModal/templates/pm.merchant.partial.html\'\"></ng-include></section></section>");
$templateCache.put("module/paymentMethodModal/templates/updatePaymentRep.modal.window.html","<div tabindex=\"-1\" role=\"dialog\" class=\"modal rep-modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog\" ng-class=\"{\'cc-selected\': $parent.$ctrl.paymentOptionSelected === \'creditcard\', \'process-success\': ($parent.$ctrl.step === 2 || $parent.$ctrl.isPaymentMethodChanging)}\"><div class=\"modal-content\" style=\"-webkit-animation-name: animatetop;-webkit-animation-duration: 0.8s;-moz-animation-name: animatetop;-moz-animation-duration: 0.8s;-o-animation-name: animatetop;-o-animation-duration: 0.8s;animation-name: animatetop;animation-duration: 0.8s;\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/pendingOrder/pendingOrderModal/modalWindow.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-pending-order-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/pendingOrder/pendingOrderModal/orderDetail.view.html","<div class=\"ute-pending-order\"><div class=\"ute-pending-order-modal\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"$close()\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"orderVMdetail:modal:close\"><span aria-hidden=\"true\"><span class=\"ute-icon-close-button-v3\"></span></span></button><div class=\"modal-title\"><span translate=\"ute.pending.order.label.orderDetails\"></span></div></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"orderVM.hasError\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row info-banner error module-global-error-message pam\" aria-hidden=\"false\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\"><div class=\"alert alert-danger\" role=\"alert\"><div class=\"alert-img\"><img src=\"http://www.rogers.com/cms/rogers/images/homepage/whats-new/whats-new-warning.png\" alt=\"Alert\"></div><div><div ng-if=\"!appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cxOopsWithSubheading\"></div><div ng-if=\"appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cfaOopsWithSubheading\"></div></div><div class=\"row info-banner error module-global-error-message pam\" aria-hidden=\"false\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\"></div></div></div></div></div></div></div><div ng-if=\"!orderVM.hasError\"><div class=\"row\"><div class=\"col-sm-12 ute-pending-order-details\"><span translate=\"ute.pending.order.message.orderDetails\"></span></div><div class=\"ute-pending-order-table\"><table class=\"table ute-table table-centred mobile-stacked\"><thead><tr><th><span translate=\"ute.pending.order.label.servicesOrdered\"></span></th><th><span translate=\"ute.pending.order.label.orderDate\"></span></th><th><span translate=\"ute.pending.order.label.actionType\"></span></th><th><span translate=\"ute.pending.order.label.dueDate\"></span></th><th><span translate=\"ute.pending.order.label.fulfillmentOption\"></span></th></tr></thead><tbody><tr ng-repeat=\"order in orderVM.orderDetails\"><td><span translate=\"ute.pending.order.dynamic.{{order.productName}}\" translate-default=\"{{order.productName}}\" class=\"td-content\"></span></td><td><span ng-bind=\"order.orderDate | date:\'longDate\'\" class=\"td-content\"></span></td><td><span translate=\"ute.pending.order.dynamic.request.{{order.actionType}}\" translate-default=\"\" class=\"td-content\"></span></td><td><span ng-bind=\"order.dueDate | date:\'longDate\'\" class=\"td-content\"></span></td><td><span><ins translate=\"ute.pending.order.retail.label.{{order.fulfillmentOptionData}}\" ng-show=\"orderVM.isAgent\" translate-default=\"\"></ins><ins translate=\"ute.pending.order.label.{{order.fulfillmentOptionData}}\" ng-show=\"!orderVM.isAgent\" translate-default=\"\"></ins></span></td></tr></tbody></table></div></div></div><div class=\"row\" ng-if=\"orderVM.hasTechInstallAppointment == \'LOADING\'\"><div class=\"col-xs-12\"><div ng-show=\"!orderVM.hasError\"><img class=\"ute-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div><div ng-show=\"orderVM.hasError\" class=\"preloader loading text-center\" translate=\"ute.pending.order.cta.technicalError\"></div></div></div><div><p ng-switch=\"orderVM.hasTechInstallAppointment\"><span ng-switch-when=\"ERROR\"><ins ng-show=\"orderVM.canViewChangeAppointment && !orderVM.hasError\" translate=\"ute.pending.order.cta.technicalError\"></ins></span> <span ng-switch-when=\"CANT_CHANGE\"><ins ng-show=\"orderVM.canViewChangeAppointment\" translate=\"ute.pending.order.cta.cannotViewChange\"></ins></span> <span ng-switch-when=\"TRUE\"><button type=\"button\" ng-click=\"$close(); orderVM.viewAppointment();\" class=\"ute-pending-order-button-primary\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"orderVMdetail:modal:viewandchangeappointment\"><span translate=\"ute.pending.order.label.viewAndChangeAppointment\"></span></button></span></p></div></div></div></div>");
$templateCache.put("module/pendingOrder/pendingOrderModal/termsCondition.view.html","<div class=\"ute-pending-order\"><div class=\"ute-pending-order-modal\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"$close()\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"termscondition:modal:close\"><span aria-hidden=\"true\"><span class=\"ute-icon-close-button-v3\"></span></span></button></div><div class=\"modal-body ute-pending-order-terms-modal-body\"><span ute-content-injector=\"\" language=\"{{termsVM.currentLanguage}}\" content-id=\"cms/content/ute/rogers/eclipse/views/iptv/order-terms-and-conditions/order-terms-and-conditions\"></span></div><div class=\"modal-footer\"><button type=\"button\" ng-click=\"$close()\" class=\"ute-pending-order-terms-button-primary\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"termscondition:modal:close\"><span translate=\"ute.pending.order.cta.close\"></span></button></div></div></div>");
$templateCache.put("module/pendingOrder/pendingOrderModal/viewAppointment.view.html","<div class=\"ute-pending-order\"><div class=\"ute-pending-order-modal\"><div class=\"modal-header\"><button type=\"button\" ng-click=\"$close()\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"orderVMAppointment:modal:close\"><span aria-hidden=\"true\"><span class=\"ute-icon-close-button-v3\"></span></span></button><div class=\"modal-title\"><span translate=\"ute.pending.order.label.viewAndChangeAppointment\"></span></div></div><div class=\"modal-body\"><div class=\"row\" ng-if=\"appointmentVM.hasError\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"row info-banner error module-global-error-message pam\" aria-hidden=\"false\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\"><div class=\"alert alert-danger\" role=\"alert\"><div class=\"alert-img\"><img src=\"http://www.rogers.com/cms/rogers/images/homepage/whats-new/whats-new-warning.png\" alt=\"Alert\"></div><div ng-if=\"appointmentVM.errorType === \'\'\"><div ng-if=\"!appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cxOopsWithSubheading\"></div><div ng-if=\"appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cfaOopsWithSubheading\"></div></div><div ng-if=\"appointmentVM.errorType === \'DUPLICATE\'\"><div ng-if=\"!appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cxCantReschedule\"></div><div ng-if=\"appointmentVM.isAgent\" translate=\"ute.pending.order.cta.cfaCantReschedule\"></div></div><div class=\"row info-banner error module-global-error-message pam\" aria-hidden=\"false\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 icon-ctn\"><span class=\"message-banner-icon icon-error txtM\"></span></div><div class=\"col-xs-10 col-sm-10 col-md-11 col-lg-11\"></div></div></div></div></div></div></div><div ng-if=\"!appointmentVM.hasError && appointmentVM.hasTechInstallAppointment == \'TRUE\'\"><div class=\"row\"><div class=\"col-sm-12 ute-pending-order-details\"><span translate=\"ute.pending.order.message.viewAndChangeAppointment\"></span></div></div><br><div class=\"ute-pending-order-heading-sub\"><span translate=\"ute.pending.order.label.currentAppointmentIs\"></span></div><div class=\"row\"><div class=\"ute-pending-order-details col-sm-12\"><span ng-bind=\"appointmentVM.appointment.appointmentDate | date:\'EEEE MMMM dd, yyyy\'\"></span><br><span ng-bind=\"appointmentVM.appointment.startTime | date:\'hh\'\"></span> <span translate=\"ute.pending.order.cta.hyphen\"></span> <span ng-bind=\"appointmentVM.appointment.endTime | date:\'hh a\'\"></span></div></div></div><div class=\"row\" ng-if=\"appointmentVM.hasTechInstallAppointment == \'LOADING\'\"><div class=\"col-xs-12\"><div ng-show=\"!appointmentVM.hasError\"><img class=\"ute-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div><div ng-show=\"appointmentVM.hasError\" class=\"preloader loading text-center\" translate=\"ute.pending.order.cta.technicalError\"></div></div></div></div><div class=\"modal-footer\"><div class=\"row\" ng-if=\"!appointmentVM.hasError && appointmentVM.hasTechInstallAppointment == \'GOTO_PENDING_ORDERS\'\"><img class=\"ute-loader\" src=\"ute-common-assets/assets/widget-loader.gif\"></div><div class=\"row\" ng-if=\"!appointmentVM.hasError && appointmentVM.hasTechInstallAppointment == \'TRUE\'\"><div class=\"col-xs-6\"><button type=\"button\" ng-click=\"appointmentVM.reScheduleAppointment()\" class=\"pull-left ute-pending-order-button-primary\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"changeappointment:modal:close\"><span translate=\"ute.pending.order.cta.reScheduleAppointment\"></span></button></div><div class=\"col-xs-6\"><a type=\"button\" ng-click=\"$close();\" class=\"pull-right ute-pending-order-button-cancel\" data-dismiss=\"modal\" aria-label=\"Close\" ute-tracking=\"changeappointment:modal:close\"><span translate=\"ute.pending.order.cta.cancel\"></span></a></div></div></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPay.html","<div class=\"container\"><div class=\"row\"><ute-promise-to-pay-check-eligibility></ute-promise-to-pay-check-eligibility></div><div class=\"ute-mt-50\"><ute-promise-to-pay-message-banner></ute-promise-to-pay-message-banner></div><div class=\"col-xs-12\"><div class=\"col-xs-12 col-md-7\"><ute-promise-to-pay-schedule-ptp></ute-promise-to-pay-schedule-ptp></div><div class=\"col-xs-12 col-md-5 ute-mt-50\"><ute-nova-content screen-name=\"promiseToPayCheckEligibility.screenName\"></ute-nova-content></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPayGeneralErrorModal.html","<div class=\"modal-header ute-ptp-modal-header\"><img class=\"pull-right ute-ptp-modal-close\" ng-click=\"modalContoller.cancelModal()\" data-dismiss=\"modal\" src=\"ute-common-assets/assets/close-icon.png\"><div class=\"row ute-ptp-modal-title\"><div class=\"float-left ute-ptp-error-modal\"><div class=\"ute-ptp-modal-error-image\"></div></div><div class=\"float-left\"><h4><span class=\"ute-ptp-modal-fw\" data-translate=\"ute.rogers.promiseToPay.systemUnavailable\"></span></h4></div></div></div><div class=\"modal-body ute-ptp-modal-body\"><div class=\"row ute-ptp-modal-content\"><div data-translate=\"ute.rogers.promiseToPay.sorryMsg\"></div><div data-translate=\"ute.rogers.promiseToPay.tryLater\"></div></div><div class=\"row ute-ptp-mt-10\"><button class=\"ute-ptp-modal-closeBtn\" ng-click=\"modalContoller.cancelModal()\" data-dismiss=\"modal\"><span data-translate=\"ute.rogers.promiseToPay.close\"></span></button></div></div>");
$templateCache.put("module/purchaseData/views/ute-purchase-data-error-modal.html","<div class=\"purchase-data-options-wrapper rogers\"><div class=\"modal-header\"><a data-ng-click=\"$dismiss()\" class=\"modal-close\" data-dismiss=\"modal\"><i class=\"rui-icon-mobile-menu-exit\"></i></a><div class=\"purchase-data-options-modal-heading\"><h2 class=\"modal-title\">Add Data</h2></div></div><div class=\"modal-body\"><div class=\"container-fluid\"><div class=\"row\"><div class=\"col-md-12\"><p>A one-time data top-up that can be used until the end of this bill cycle.</p><strong>OR</strong><p>A monthly data add-on that will be added to your plan every month until you choose to cancel it.</p><h2>One-Time Data Top-Up</h2><a class=\"ute-link\" ng-click=\"ctrl.openPurchaseDataSelectorModal(\'purchaseDataOptionsType\')\">One Time top up</a><br><a class=\"ute-link\" ng-click=\"ctrl.openPurchaseDataSelectorModal(\'purchaseDataOptionsTypee\')\">Monthly Top-Up</a></div></div></div></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.device.directive.view.html","<div data-ng-if=\"reactivateCtnDevice.hasDeviceName()\"><h5 data-translate=\"ute.common.reactivate.ctn.device\"></h5><div data-translate=\"ute.common.reactivate.ctn.deviceName\"></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.RepView.view.html","<div class=\"container ute-reactivateCtn-message-box\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-reactivateCtn-message-box-container col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-reactivateCtn-message-box-title\" data-translate=\"ute.common.reactivate.ctn.messageBox.repviewTitle\"></div><div data-translate=\"ute.common.reactivate.ctn.messageBox.repviewMessageLeft\"></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pull-right\"><div data-ng-if=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" class=\"ute-reactivateCtn-confirmation-loader-container col-xs-12 col-sm-12 col-md-6 col-lg-6 pull-left\" style=\"margin-left:200px;\"><img class=\"ute-reactivateCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Reactivating Device...\"></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 pull-right\"><button name=\"button_continue\" data-ng-disabled=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" data-ng-click=\"reactivateCtnMessageBox.reactivateDevice($event)\" class=\"ute-reactivateCtn-repView-button col-xs-9 col-sm-9\" data-ng-class=\"(reactivateCtnMessageBox.isReactivateCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.reactivate.ctn.messageBox.repviewButtonText\"></span></button></div></div></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.messageBox.directive.view.html","<div class=\"container ute-reactivateCtn-message-box\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-reactivateCtn-message-box-title\" data-translate=\"ute.common.reactivate.ctn.messageBox.title\"></div><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageLeft\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><button name=\"button_continue\" data-ng-disabled=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" data-ng-click=\"reactivateCtnMessageBox.reactivateDevice($event)\" class=\"ute-reactivateCtn-button col-xs-9 col-sm-9\" data-ng-class=\"(reactivateCtnMessageBox.isReactivateCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.reactivate.ctn.messageBox.buttonText\"></span></button><div data-ng-if=\"reactivateCtnMessageBox.isReactivateCtnCallInProgress()\" class=\"ute-reactivateCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-reactivateCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Reactivating Device...\"></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageRight01\"></div><div data-translate=\"ute.common.reactivate.ctn.messageBox.messageRight02\"></div><div class=\"ute-reactivateCtn-message-box-support col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"ute-reactivateCtn-support-phone-box col-xs-12 col-sm-5 col-md-5 col-lg-5\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"> <span class=\"ute-reactivateCtn-support-phone\" data-translate=\"ute.common.reactivate.ctn.supportPhoneNumber\"></span></div></div></div></div></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnDirective/reactivateCtn.wirelessNumber.directive.view.html","<div><h5 data-translate=\"ute.common.reactivate.ctn.wirelessNumber\"></h5><div>{{::reactivateCtnWirelessNumber.getFirstName()}} {{::reactivateCtnWirelessNumber.getPhoneNumber() | ute_common_filter_phone3}}</div><a class=\"ute-suspendCtn-link\" data-ng-click=\"reactivateCtnWirelessNumber.backToDevicePage()\" data-translate=\"ute.common.reactivate.ctn.backToDevice\"></a></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnError/reactivateCtn.error.RepView.view.html","<div class=\"ute-reactivateCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img data-ng-src=\"{{reactivateCtnErrorModal.modalIcon | translate}}\"></div><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9\" data-translate=\"ute.common.reactivate.ctn.fail.repview_title\" style=\"padding-left:20px\"></div></div><div class=\"ute-reactivateCtn-modalBodyGroup row\"><div class=\"ute-reactivateCtn-repView-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span data-translate=\"ute.common.reactivate.ctn.fail.repview_possible_reasons\" class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12\"></span><ul><li data-translate=\"ute.common.reactivate.ctn.fail.repview_pending_cancellation\"></li><li data-translate=\"ute.common.reactivate.ctn.fail.repview_fraud\"></li><li data-translate=\"ute.common.reactivate.ctn.fail.repview_credit_limit\"></li></ul></div><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"padding-left:28px\"><div style=\"display: inline;\" data-translate=\"ute.common.reactivate.ctn.fail.repview_message\"></div></div><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\" style=\"padding-left:28px\"><a class=\"ute-reactivateCtn-link\" data-ng-click=\"reactivateCtnErrorModal.backToDevicePage()\" data-translate=\"ute.common.reactivate.ctn.backToDevice\"></a></div></div><img class=\"ute-reactivateCtn-modalClose\" data-ng-click=\"reactivateCtnErrorModal.cancel()\" data-ng-src=\"{{\'ute.common.reactivate.ctn.images.close\' | translate}}\">");
$templateCache.put("module/reactivateCtn/reactivateCtnError/reactivateCtn.error.view.html","<div class=\"ute-reactivateCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img data-ng-src=\"{{reactivateCtnErrorModal.modalIcon | translate}}\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-reactivateCtn-vertical-align-middle\" data-translate=\"ute.common.reactivate.ctn.fail.title\"></div></div><div class=\"ute-reactivateCtn-modalBodyGroup row\"><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div style=\"display: inline;\" data-translate=\"{{reactivateCtnErrorModal.errorMessage}}\"></div></div><div class=\"ute-reactivateCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a class=\"ute-reactivateCtn-link\" data-ng-click=\"reactivateCtnErrorModal.backToDevicePage()\" data-translate=\"ute.common.reactivate.ctn.backToDevice\"></a></div><div class=\"ute-reactivateCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-7 col-md-7 col-lg-7\"><bold-chat-static-button class=\"col-md-3 col-lg-3 col-xs-12 col-sm-12\" data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}_Modal\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}_Modal\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 ute-reactivateCtn-support-phone-box-modal\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"><div class=\"ute-reactivateCtn-support-phone-modal\" data-translate=\"ute.common.reactivate.ctn.supportPhoneNumber\"></div></div></div></div><img class=\"ute-reactivateCtn-modalClose\" data-ng-click=\"reactivateCtnErrorModal.cancel()\" data-ng-src=\"{{\'ute.common.reactivate.ctn.images.close\' | translate}}\">");
$templateCache.put("module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.RepView.view.html","<div><section><section class=\"ute-reactivateCtn-Success-header\"><div class=\"container\"><div class=\"row\" style=\"margin: 25px 0 5px 0;border-bottom: 1px solid #e9e9e9;padding-bottom: 50px;\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-wireless-number></ute-reactivate-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-device></ute-reactivate-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-reactivateCtn-Success-header-title\" style=\"padding-top:20px;font-weight:500;font-size:50px;max-width:450px;\" data-translate=\"ute.common.reactivate.ctn.success.header.title\"></h1><div class=\"ute-reactivateCtn-Success-header-message\" style=\"font-size:20px;max-width:550px;\" data-translate=\"ute.common.reactivate.ctn.success.header.repview_message\"></div></div></div></div></section><section class=\"ute-reactivateCtn-Success-body\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-reactivateCtn-Success-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span data-translate=\"ute.common.reactivate.ctn.success.body.repview_header\" style=\"font-size:30px;\"></span></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message01Icon\' | translate}}\" alt=\"\"></div></div><div style=\"margin-left:-30px;font-size:20px;font-weight:500;margin-top:-20px\" class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.repview_message01\"></div></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message02Icon\' | translate}}\" alt=\"\"></div></div><div style=\"margin-left:-30px;font-size:20px;font-weight:500;margin-top:-20px\" class=\"col-xs-8 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.repview_message02\"></div></div></div></div></div></section></section></div>");
$templateCache.put("module/reactivateCtn/reactivateCtnSuccess/reactivateCtnSuccess.view.html","<div><section><section class=\"ute-reactivateCtn-Success-header\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-wireless-number></ute-reactivate-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-reactivate-ctn-device></ute-reactivate-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-reactivateCtn-Success-header-title\" data-translate=\"ute.common.reactivate.ctn.success.header.title\"></h1><div class=\"ute-reactivateCtn-Success-header-message\" data-translate=\"ute.common.reactivate.ctn.success.header.message\"></div></div></div></div></section><section class=\"ute-reactivateCtn-Success-body\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-reactivateCtn-Success-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span data-translate=\"ute.common.reactivate.ctn.success.body.header\"></span></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message01Icon\' | translate}}\" alt=\"\"></div></div><div class=\"col-xs-9 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.message01\"></div></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"col-xs-3 col-sm-2 col-md-2 col-lg-2\"><div><img data-ng-src=\"{{\'ute.common.reactivate.ctn.success.body.message02Icon\' | translate}}\" alt=\"\"></div></div><div class=\"col-xs-8 col-sm-10 col-md-10 col-lg-10 ute-reactivateCtn-Success-body-text\"><div data-translate=\"ute.common.reactivate.ctn.success.body.message02\"></div></div></div></div></div></section><section class=\"ute-reactivateCtn-Success-support\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-reactivateCtn-Success-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span class=\"ute-reactivateCtn-Success-support-question\" data-translate=\"ute.common.reactivate.ctn.success.body.question\"></span> <span class=\"ute-reactivateCtn-Success-support-question\" data-translate=\"ute.common.reactivate.ctn.success.body.answer\"></span></div></div><div class=\"row ute-reactivateCtn-Success-body-section\"><div class=\"ute-suspendCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-4 col-md-6 col-lg-6\"><bold-chat-static-button data-cbid=\"{{\'ute.common.reactivate.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.reactivate.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.reactivate.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6\"><img data-ng-src=\"{{\'ute.common.reactivate.ctn.images.call\' | translate}}\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.reactivate.ctn.fail.supportPhoneNumber\"></div></div></div></div></div></div></section></section></div>");
$templateCache.put("module/rogersSecondLevelNavigation/navigationBarConsumer/navigationBarConsumer.directive.view.html","<div><ute-second-level-navigation data-navigation-model=\"rogersNavigationBar.secondLevelNavDataModel\"></ute-second-level-navigation></div>");
$templateCache.put("module/rogersSecondLevelNavigation/navigationBarDealer/navigationBarDealer.directive.view.html","<div class=\"ute-secondLevelNav-rep\"><div class=\"row ute-secondLevelNav-rep-info\"><div class=\"col-xs-3\"><div class=\"ute-secondLevelNav-rep-info-heading\"><span>{{ rogersNavigationBar.getCustomerName() }}</span></div><span class=\"ute-secondLevelNav-rep-info-text\">{{ rogersNavigationBar.secondLevelNavDataModel.selectedAccount.accountNumber }}</span> <span class=\"ute-secondLevelNav-rep-info-text\">&nbsp;&nbsp;|&nbsp;&nbsp;</span> <span class=\"ute-secondLevelNav-rep-info-text\">{{ rogersNavigationBar.secondLevelNavDataModel.selectedAccount.accountInfo.accType }}</span></div><div class=\"col-xs-3\"><div class=\"ute-secondLevelNav-rep-info-text-medium\">{{ rogersNavigationBar.getCustomerStreetAddress() }}</div><div class=\"ute-secondLevelNav-rep-info-text-small\">{{ rogersNavigationBar.secondLevelNavDataModel.selectedAccount.billingAddress.city }}&nbsp;&nbsp; {{ rogersNavigationBar.secondLevelNavDataModel.selectedAccount.billingAddress.province }}&nbsp;&nbsp; {{ rogersNavigationBar.secondLevelNavDataModel.selectedAccount.billingAddress.postalCode }}</div></div></div><div class=\"ute-secondLevelNav-rep-bar navbar\"><ul class=\"nav navbar-nav\"><li ng-repeat=\"navItem in rogersNavigationBar.secondLevelNavDataModel.navigationBar\" class=\"ute-secondLevelNav-rep-bar-item\" ng-class=\"{ \'dropdown\': navItem.dropdown }\"><div ng-if=\"!navItem.dropdown\" data-translate=\"{{ navItem.name }}\" ng-click=\"rogersNavigationBar.itemOnClick(navItem.callback)\"></div><div ng-if=\"navItem.dropdown\" data-toggle=\"dropdown\" data-translate=\"{{ navItem.name }}\"></div><ul ng-if=\"navItem.dropdown\" class=\"dropdown-menu\"><li class=\"ute-secondLevelNav-rep-bar-dropdown-item\" ng-repeat=\"dropdownItem in navItem.dropdown\" ng-click=\"rogersNavigationBar.childOnClick(dropdownItem)\"><span data-translate=\"{{ dropdownItem.name }}\"></span> <span data-ng-if=\"dropdownItem.displayValue\"><span data-ng-if=\"dropdownItem.name\">:</span> <span data-translate=\"{{dropdownItem.displayValue.translateId}}\" data-translate-values=\"{{dropdownItem.displayValue.translateValues}}\"></span></span></li></ul></li></ul></div></div>");
$templateCache.put("module/savebillModal/saveBillGenericModal/saveBillGenericErrorModal.partial.html","<div class=\"ute-saveBill-genericModal-container\" style=\"padding-left: 0px; padding-top: 0px; padding-right: 0px;\"><div class=\"row\" style=\"margin-bottom: 100px;\"><div class=\"col-xs-12\"><div class=\"ute-saveBill-modal-grey\"></div><div class=\"ute-saveBill-modal-circle\"><i class=\"ute-saveBill-noData-icon rui-icon-error\"></i></div><div class=\"ute-savebill-modal-errorCopy\"><div class=\"ute-saveBill-genericModal-errorHeading\" ng-if=\"params.primary\">{{params.primary | translate}}</div><div class=\"ute-saveBill-genericModal-secondary\">{{params.secondary | translate}}</div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-6\" style=\"text-align: center;\"><md-button data-ng-if=\"saveBillGenericModal.isMobile\" class=\"md-primary ute-saveBill-genericModal-button\" style=\"text-align: center;\" href=\"tel:+1-800-555-5555\"><i class=\"rui-icon-phonea-not-service-related\"></i> {{\'ute.saveBill.genericModal.phone\' | translate}}</md-button><div data-ng-if=\"!saveBillGenericModal.isMobile\" class=\"ute-saveBill-genericModal-button\" style=\"text-align: center; padding-top: 10px;\"><i class=\"rui-icon-phonea-not-service-related\"></i> {{\'ute.saveBill.genericModal.phone\' | translate}}</div></div><div class=\"col-xs-12 col-md-6\" style=\"text-align: center;\"><md-button class=\"md-primary ute-saveBill-genericModal-button\" data-ng-click=\"saveBillGenericModal.contactUs()\"><i class=\"rui-icon-live-chat\"></i> <span class=\"ute-saveBill-genericModal-liveChat\">{{\'ute.saveBill.genericModal.liveChat\' | translate}}</span></md-button></div></div></div><img class=\"ute-saveBill-genericModal-modalClose\" data-ng-click=\"saveBillGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/savebillModal/saveBillGenericModal/saveBillGenericModal.partial.html","<div class=\"ute-saveBill-genericModal-container\"><i class=\"ute-saveBill-genericModal-icon ute-icon-error\"></i><div class=\"ute-saveBill-genericModal-heading\">{{params.primary | translate}}</div><div class=\"ute-saveBill-genericModal-secondary\">{{params.secondary | translate}}</div><div class=\"row\"><div class=\"col-xs-12\"><md-button data-ng-if=\"saveBillGenericModal.isMobile\" class=\"md-primary ute-saveBill-genericModal-button\" style=\"text-align: center;\" href=\"tel:+1-800-555-5555\"><i class=\"rui-icon-phonea-not-service-related\"></i> {{\'ute.saveBill.genericModal.phone\' | translate}}</md-button><div data-ng-if=\"!saveBillGenericModal.isMobile\" class=\"ute-saveBill-genericModal-button\" style=\"text-align: center; padding-top: 10px;\"><i class=\"rui-icon-phonea-not-service-related\"></i> {{\'ute.saveBill.genericModal.phone\' | translate}}</div></div></div><div class=\"ute-saveBill-genericModal-ButtonGroup\"><md-button name=\"button_continue\" data-ng-click=\"saveBillGenericModal.continue()\" type=\"button\" class=\"ute-md-primary-button ute-saveBill-genericModal-continueButton\"><span translate=\"ute.saveBill.genericModal.button\"></span></md-button></div></div><img class=\"ute-saveBill-genericModal-modalClose\" data-ng-click=\"saveBillGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/savebillModal/saveBillGenericModal/saveBillLoadingModal.partial.html","<div><div class=\"row\"><div class=\"ute-savebill-loading\"><div class=\"ute-savebill-loaderContainer\"><div class=\"ute-savebill-loader\"><img src=\"ute-common-assets/assets/widget-loader-lg_no-lang.gif\" alt=\"Data Loading...\"></div></div><div class=\"ute-savebill-loaderBackground\"></div></div></div></div>");
$templateCache.put("module/savebillModal/saveBillGenericModal/saveBillNoDataModal.partial.html","<div class=\"ute-saveBill-genericModal-container\" style=\"padding-left: 0px; padding-top: 0px; padding-right: 0px;\"><div class=\"row\" style=\"height: 300px;\"><div class=\"col-xs-12\" style=\"height: 100%\"><div class=\"ute-saveBill-modal-grey\"></div><div class=\"ute-saveBill-modal-circle\"><i class=\"ute-saveBill-noData-icon ute-icon-error\"></i></div><div class=\"ute-savebill-modal-copy\" translate=\"ute.saveBill.noData\"></div></div></div></div><img class=\"ute-saveBill-genericModal-modalClose\" data-ng-click=\"saveBillGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/savebillModal/saveBillGenericModal/saveBillSuccessModal.partial.html","<div class=\"ute-saveBill-genericModal-container\" style=\"padding-left: 0px; padding-top: 0px; padding-right: 0px;\"><div class=\"row\" style=\"height: 300px;\"><div class=\"col-xs-12\" style=\"height: 100%\"><div class=\"ute-saveBill-modal-grey\"></div><div class=\"ute-saveBill-modal-circle\"><i class=\"ute-saveBill-success-icon ute-icon-success\"></i></div><div class=\"ute-savebill-modal-copy\">{{\'ute.saveBillModal.success.\' + params.type | translate}}</div></div></div></div><img class=\"ute-saveBill-genericModal-modalClose\" data-ng-click=\"saveBillGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/savebillModal/savebillPrintModal/confirmationModal.partial.html","<div class=\"ute-saveMultipleBillModal\"><div class=\"ute-saveBillModal-heading\"><button data-ng-click=\"ctrl.close()\" class=\"ute-saveBillModal-modalClose\"><i aria-label=\"Close Button\" class=\"rogers-icon-circle-x\"></i></button><div class=\"ute-saveBillPrintModal-title\" translate=\"ute.saveBill.confirmationModal.title\"></div><div class=\"ute-checkbox-holder\"><em><input id=\"CheckboxAll\" class=\"terms-checkbox\" ng-click=\"ctrl.selectAllCheckbox(ctrl.selectAll)\" ng-model=\"ctrl.selectAll\" type=\"checkbox\"> <span class=\"fake-check\"></span></em> <label class=\"terms-label\" translate=\"ute.saveBill.confirmationModal.selectAll\" for=\"CheckboxAll\"></label></div></div><div class=\"ute-saveBillPrintModal-body\"><div ng-repeat=\"bill in ::ctrl.bills\" class=\"ute-checkbox-holder\"><em><input id=\"Checkbox{{$index}}\" type=\"checkbox\" ng-model=\"bill.selected\" [value]=\"bill.id\" ng-click=\"ctrl.selectedDates(bill.link, bill.issue_date, bill.selected, $index)\"> <span class=\"fake-check\"></span></em> <label class=\"terms-label\" for=\"Checkbox{{$index}}\">{{bill.issue_date | ute_common_filter_language_date | translate}}</label></div></div><div class=\"ute-saveBillModal-footer\"><div class=\"btn-group\"><button data-ng-click=\"ctrl.saveMultipleBills()\" class=\"primary-button\"><span translate=\"ute.saveBill.confirmationModal.confirm\"></span></button> <button data-ng-click=\"ctrl.close()\" class=\"cancel\"><span translate=\"ute.saveBill.confirmationModal.close\"></span></button></div></div></div>");
$templateCache.put("module/savebillModal/savebillPrintModal/savebillPrintModal.partial.html","<div class=\"ute-saveBillPrintModal\"><div class=\"ute-saveBillModal-heading\"><div class=\"ute-saveBillPrintModal-title\" translate=\"ute.saveBillPrintModal.title\"></div></div><div class=\"ute-saveBillPrintModal-body\"><iframe id=\"iFramePrintFile\" ng-if=\"ctrl.getPrintBillSRC() !== \'\'\" ng-src=\"{{ctrl.getPrintBillSRC()}}\" type=\"application/pdf\" ute-save-bill-modal-i-frame-on-load=\"ctrl.iFrameLoadedCallback()\"></iframe></div><img class=\"ute-saveBillModal-modalClose\" data-ng-click=\"ctrl.close()\" src=\"ute-common-assets/assets/close-icon.png\"></div>");
$templateCache.put("module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.mobile.menu.view.html","<div id=\"overview\" class=\"ute-secondLevelNav-menu-accounts ute-secondLevelNav-vertical-scroll hidden-sm hidden-md hidden-lg\" ng-cloak=\"\"><md-content><md-toolbar class=\"ute-secondLevelNav-menu-accounts-header\"><div class=\"md-toolbar-tools\"><h2><span data-translate=\"ute.common.second.level.navigation.header\"></span></h2><span flex=\"\"></span> <img data-ng-click=\"navigationBar.MobileViewHideAllMenu()\" alt=\"\" src=\"ute-common-assets/assets/cross-grey.png\" class=\"md-avatar\"></div></md-toolbar><md-list ng-cloak=\"\"><md-divider></md-divider><div ng-repeat=\"item in navigationBar.mobileOptionLIst\" ng-class=\"{\'last-item\': $last}\"><md-list-item ng-click=\"navigationBar.childOnClick(item)\" ng-class=\"item.className\" aria-label=\"{{item.name}}\"><span data-ng-if=\"$last && (navigationBar.mobileOptionType===\'account\')\" class=\"ute-secondLevelNav-border-circle\">+</span><h2><span class=\"ute-secondLevelNav-child-item-name ute-secondLevelNav-bar-nickname\" data-translate=\"{{item.name}}\"></span><span data-ng-if=\"item.displayValue\"><span data-ng-if=\"item.name\">:</span> <span data-translate=\"{{item.displayValue.translateId}}\" data-translate-values=\"{{item.displayValue.translateValues}}\"></span></span></h2><ute-navigation-account-status ng-if=\"::navigationBar.isAccountSuspended(item) || navigationBar.isAccountCancelled(item)\" account-status=\"{{item.accountStatus}}\"></ute-navigation-account-status><img class=\"account-checkmark\" data-ng-if=\"!item.dropdown && navigationBar.isStatusActive(item.status)\" alt=\"\" src=\"ute-common-assets/assets/checkmark-grey.png\"> <img data-ng-if=\"item.dropdown\" alt=\"\" src=\"ute-common-assets/assets/right-arrow-grey.png\"></md-list-item></div></md-list></md-content></div>");
$templateCache.put("module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.mobile.services.view.html","<div id=\"services\" class=\"ute-secondLevelNav-menu-accounts ute-secondLevelNav-vertical-scroll hidden-sm hidden-md hidden-lg\" ng-cloak=\"\"><md-content><md-toolbar class=\"ute-secondLevelNav-menu-accounts-header\"><div class=\"md-toolbar-tools\"><h2><span data-translate=\"ute.common.second.level.navigation.header\"></span></h2><span flex=\"\"></span> <img data-ng-click=\"navigationBar.MobileViewHideAllMenu()\" alt=\"\" src=\"ute-common-assets/assets/cross-grey.png\" class=\"md-avatar\"></div></md-toolbar><md-list ng-cloak=\"\"><md-divider></md-divider><md-list-item ng-repeat=\"item in navigationBar.inputModel().navigationBar | filter: {status:\'!0\'}\" ng-click=\"item.dropdown?navigationBar.mobileViewBottomMenuOnClick(item):navigationBar.childOnClick(item)\" aria-label=\"{{item.name}}\"><h2><span data-ng-class=\"{\'ute-secondLevelNav-menu-txt-active\' : navigationBar.isStatusActive(item.status)}\" data-translate=\"{{item.name}}\"></span></h2><span flex=\"\"></span> <img data-ng-if=\"!item.dropdown && navigationBar.isStatusActive(item.status)\" alt=\"\" src=\"ute-common-assets/assets/checkmark-grey.png\"> <img data-ng-if=\"item.dropdown\" alt=\"\" src=\"ute-common-assets/assets/right-arrow-grey.png\"></md-list-item></md-list></md-content></div>");
$templateCache.put("module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.view.html","<div class=\"ute-secondLevelNav\" data-ng-show=\"navigationBar.showMenu()\" data-spy=\"{{navigationBar.secondNavBarAffix.dataSpy}}\" data-offset-top=\"{{navigationBar.secondNavBarAffix.dataOffsetTop}}\"><div class=\"ute-secondLevelNav-inner container\"><div class=\"ute-secondLevelNav-dropshadow\"><div class=\"hidden-xs\"><div class=\"ute-secondLevelNav-header\"><div class=\"ute-secondLevelNav-header-txt\" data-translate=\"{{::navigationBar.inputModel().title}}\"></div></div><div class=\"ute-secondLevelNav-bar\"><md-toolbar class=\"md-menu-toolbar\"><div class=\"ute-secondLevelNav-menu\"><md-menu-bar><md-menu class=\"ute-secondLevelNav-item\" data-ng-repeat=\"(rootIndex, nav) in navigationBar.inputModel().navigationBar\" data-ng-class=\"{ \'ute-secondLevelNav-account\': navigationBar.isAccountDropdownStyle(nav.status),\'ute-secondLevelNav-menu-active\' : navigationBar.isStatusActive(nav.status), \'ute-secondLevelNav-menu-second\' : ($index===1) }\" tabindex=\"0\" ng-keypress=\"($event.which === 13)?((nav.dropdown)?$mdOpenMenu():navigationBar.itemOnClick(nav.callback)):0\"><button class=\"ute-secondLevelNav-bar-txt\" data-ng-class=\"{\'ute-secondLevelNav-bar-txt_1\': !navigationBar.isAccountDropdownStyle(nav.status)}\" ng-click=\"(nav.dropdown)?$mdOpenMenu():navigationBar.itemOnClick(nav.callback)\" tabindex=\"-1\" data-ng-disabled=\"navigationBar.isStatusShowDisable(nav.status)\"><div><div data-ng-if=\"navigationBar.isAccountDropdownStyle(nav.status)\"><span data-ng-if=\"!navigationBar.selectedAccount().display\"><span class=\"ute-secondLevelNav-bar-account\" data-translate=\"ute.common.label.account\"></span> :</span><span class=\"ute-secondLevelNav-bar-nickname\">{{navigationBar.selectedAccount().display | ute_common_filter_string_limit_to : 10}}</span><br><span data-translate=\"{{navigationBar.selectedAccount().accountNumber}}\"></span></div><div data-ng-if=\"!navigationBar.isAccountDropdownStyle(nav.status)\" class=\"ute-secondLevelNav-bar-text\"><span data-ng-class=\"{\'ute-secondLevelNav-menu-txt-active\' : navigationBar.isStatusActive(nav.status)}\" data-translate=\"{{nav.name}}\"></span></div><div data-ng-if=\"$first\" class=\"ute-secondLevelNav-triangle\"></div></div><span data-ng-if=\"nav.dropdown\" class=\"ute-secondLevelNav-arrow-down\" data-ng-class=\"{\'ute-secondLevelNav-arrow-down-active\' : navigationBar.isStatusActive(nav.status),\'ute-secondLevelNav-arrow-down-account\' : navigationBar.isAccountDropdownStyle(nav.status)}\"></span></button><md-menu-content data-ng-show=\"nav.dropdown\" class=\"ute-secondLevelNav-dropdown hidden-xs\"><md-menu-item ng-repeat-start=\"childDropdown in nav.dropdown\"><md-button data-ng-click=\"navigationBar.childOnClick(childDropdown)\" data-ng-disabled=\"navigationBar.isStatusShowDisable(childDropdown.status)\" ng-class=\"::{ \'suspended-status\': navigationBar.isAccountSuspended(childDropdown), \'cancelled-status\': navigationBar.isAccountCancelled(childDropdown) }\" aria-label=\"{{childDropdown.status}}\"><span data-ng-if=\"(rootIndex===0) && $last\" class=\"ute-secondLevelNav-border-circle\">+</span> <span class=\"ute-secondLevelNav-child-item-name\" data-translate=\"{{childDropdown.name}}\"></span><span data-ng-if=\"childDropdown.displayValue\"><span data-ng-if=\"childDropdown.name\">:</span> <span data-translate=\"{{childDropdown.displayValue.translateId}}\" data-translate-values=\"{{childDropdown.displayValue.translateValues}}\" data-ng-class=\"{ \'ute-secondLevelNav-black-txt\': navigationBar.isStatusShowDisable(childDropdown.status) }\"></span></span><ute-navigation-account-status ng-if=\"::navigationBar.isAccountSuspended(childDropdown) || navigationBar.isAccountCancelled(childDropdown)\" account-status=\"{{childDropdown.accountStatus}}\"></ute-navigation-account-status></md-button></md-menu-item><md-menu-divider ng-repeat-end=\"\" data-ng-if=\"!$last\"></md-menu-divider></md-menu-content></md-menu></md-menu-bar></div></md-toolbar></div></div><div class=\"hidden-sm hidden-md hidden-lg\"><div class=\"ute-secondLevelNav-header-m-bg\"><div class=\"ute-secondLevelNav-header-m\"><div class=\"ute-secondLevelNav-header-txt-m\" data-translate=\"{{::navigationBar.inputModel().titleMobile}}\"></div></div></div><div class=\"ute-secondLevelNav-bar-m\"><md-toolbar class=\"md-menu-toolbar\"><div class=\"ute-secondLevelNav-menu\"><md-menu-bar style=\"display: inline-flex;\"><md-menu data-ng-repeat=\"nav in navigationBar.inputModel().navigationBar | filter: navigationBar.mobileViewFilter\" ng-class=\"{ \'ute-secondLevelNav-account\': navigationBar.isAccountDropdownStyle(nav.status), \'ute-secondLevelNav-menu-second\' : ($index===1) }\" style=\"height: 100%;\" tabindex=\"0\"><button class=\"ute-secondLevelNav-bar-txt\" ng-click=\"navigationBar.MobileViewOnClick(nav)\" tabindex=\"-1\" data-ng-disabled=\"navigationBar.isStatusShowDisable(nav.status)\"><div><div data-ng-if=\"navigationBar.isAccountDropdownStyle(nav.status)\"><span data-ng-if=\"!navigationBar.selectedAccount().display\"><span class=\"ute-secondLevelNav-bar-account\" data-translate=\"ute.common.label.account\"></span><span class=\"ute-secondLevelNav-colon\">:</span><br class=\"visible-xs-inline\"></span><span class=\"ute-secondLevelNav-bar-nickname\" data-translate=\"{{navigationBar.selectedAccount().display | ute_common_filter_string_limit_to : 10}}\"></span><br data-ng-if=\"navigationBar.selectedAccount().display\"><span data-translate=\"{{navigationBar.selectedAccount().accountNumber}}\"></span></div><div data-ng-if=\"!navigationBar.isAccountDropdownStyle(nav.status)\"><span data-translate=\"{{nav.name}}\"></span></div><div data-ng-if=\"$first\" class=\"ute-secondLevelNav-triangle\"></div></div><span class=\"ute-secondLevelNav-arrow-down\" data-ng-class=\"{\'ute-secondLevelNav-arrow-down-account\' : (navigationBar.isAccountDropdownStyle(nav.status) && navigationBar.selectedAccount().display)}\"></span></button><md-menu-content></md-menu-content></md-menu></md-menu-bar></div></md-toolbar></div></div></div><div class=\"cart-menu-container\"><cart-menu></cart-menu></div></div></div><div data-ng-show=\"navigationBar.isMobileViewActive()\" class=\"ute-secondLevelNav-modal-background\" data-ng-click=\"navigationBar.MobileViewHideAllMenu()\"></div><div data-ng-if=\"navigationBar.showServiceMenu\" data-ng-include=\"\'module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.mobile.services.view.html\'\"></div><div data-ng-if=\"navigationBar.showDynamicMenu\" data-ng-include=\"\'module/secondLevelNavigationDirective/navigationBar/navigationBar.directive.mobile.menu.view.html\'\"></div>");
$templateCache.put("module/semafone/directive/semafone.carerep.template.html","<div class=\"container ute-semafone-care\"><div class=\"col-lg-12\"><div class=\"ute-semafone-care-box\"><div class=\"ute-semafone-care-box-heading\" translate=\"ute.rogers.myrSemafone.ovPaymentHeading\"></div><div class=\"note ute-semafone-care-info\"><div translate=\"ute.rogers.myrSemafone.ovInstructions\" class=\"ute-semafone-care-instructions\"></div></div><div name=\"semafoneCareRep\" class=\"semafone-care-holder\"></div><div class=\"status-message\"><i ng-show=\"getValidToken\" class=\"inline-checker ute-icon-checkmark-1 iprs\"></i> <span ng-show=\"getValidToken\" class=\"success\" translate=\"ute.rogers.myrSemafone.token_accepted\"></span> <i ng-show=\"creditCardData.isDisplayTokenErrorStatus\" class=\"inline-checker ute-icon-error-icon icon-error iprs\"></i> <span ng-show=\"creditCardData.isDisplayTokenErrorStatus\" class=\"error\" translate=\"ute.rogers.myrSemafone.token_rejected\"></span></div></div></div></div>");
$templateCache.put("module/semafone/directive/semafone.dealer.template.html","<div class=\"container ute-semafone-dealer\"><div class=\"row\"><div class=\"col-lg-12 dealer-note\"><span ng-bind-html=\"\'ute.rogers.myrSemafone.dealer_note\' | translate | htmlSafe\"></span></div><div class=\"col-lg-12\" ng-show=\"!isCardSwiped\"><div class=\"col-md-10 col-xs-12 margin-bottom\"><span class=\"pay-now-sub-title pts\" translate=\"ute.rogers.myrSemafone.creditCard_dealer\"></span></div><div class=\"col-xs-6 prl\"><input type=\"text\" class=\"cardInput\" ng-keyup=\"onCardSwiped()\" ng-click=\"resetMessage()\" ng-model=\"swipedCardNumber\"></div><div class=\"col-lg-4 col-md-4 col-xs-12 pls cc-images-group\"><img ng-src=\"{{cards.visa.image}}\" id=\"imgVisa\" ng-class=\"creditCardData.cardScheme == cards.visa.dealerName ? \'card_selected\' : \'card_not_selected\'\"> <img ng-src=\"{{cards.mc.image}}\" id=\"imgMc\" ng-class=\"creditCardData.cardScheme == cards.mc.dealerName ? \'card_selected\' : \'card_not_selected\'\"> <img ng-src=\"{{cards.amex.image}}\" id=\"imgAmex\" ng-class=\"creditCardData.cardScheme == cards.amex.dealerName ? \'card_selected\' : \'card_not_selected\'\"></div></div><div class=\"col-lg-12 status-message\" ng-show=\"getValidToken\"><i class=\"inline-checker ute-icon-checkmark-1 iprs\"></i><div class=\"success\" translate=\"ute.rogers.myrSemafone.token_accepted\"></div></div><div class=\"col-lg-7 dealer-encrypted-text-container\" ng-show=\"isCardSwiped\"><div class=\"col-lg-12 encrypted-title\"><span translate=\"ute.rogers.myrSemafone.encrypted_credit_card\"></span></div><div class=\"col-lg-12\"><div class=\"encrypted-text\">{{swipedCardNumber}}</div><div class=\"rejected-message\" ng-if=\"isDisplayTokenErrorStatus\"><i class=\"inline-checker ute-icon-error-icon icon-error iprs\"></i> <span translate=\"ute.rogers.myrSemafone.token_rejected\"></span></div></div><div class=\"row\"><div class=\"col-lg-12 buttons-holder\"><div class=\"ute-semafone-reader-loader\"><span class=\"widget-loader-inline\" ng-show=\"loadingDataIndicator\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></span></div><div class=\"ute-semafone-reader-confirm-button\"><button id=\"ok\" type=\"button\" class=\"cta-round primary large full pay-now-pay-bill\" data-ng-click=\"creditCardData.processRetailCard()\"><span translate=\"ute.rogers.myrSemafone.ok\"></span></button></div><div class=\"ute-semafone-reader-cancel-button\"><button id=\"cancel\" type=\"button\" class=\"cta-round primary large full pay-now-pay-bill\" data-ng-click=\"getCancel()\"><span translate=\"ute.common.label.cancel\"></span></button></div></div></div></div></div></div>");
$templateCache.put("module/simCard/simCardChange/simCardChangeNumberForm.partial.html","<form name=\"simCardForm\" novalidate=\"\"><div data-ng-if=\"(simCardForm.currentSim.$invalid || simCardForm.newSim.$invalid) && simCardForm.$submitted\"><myr-error-message><div data-ng-messages=\"simCardForm.currentSim.$error\" data-ng-if=\"simCardForm.currentSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_currentSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p ng-if=\"!simCardForm.currentSim.$error.required\" data-ng-message=\"parse\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_currentSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f9\",\"mappingKey\":\"error.changeSIM\"}\'></span></p></div><div data-ng-messages=\"simCardForm.newSim.$error\" data-ng-if=\"simCardForm.currentSim.$valid && simCardForm.newSim.$invalid\"><p data-ng-message=\"minlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"maxlength\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_not20Digits\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p data-ng-message=\"required\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_newSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p><p ng-if=\"!simCardForm.newSim.$error.required\" data-ng-message=\"parse\"><span translate=\"ute.rogers.myrSimCard.simCardChange.inputError_newSim_notFound\" adl-error-track=\'{\"category\":\"self_serve\",\"field\":\"f10\",\"mappingKey\":\"error.changeSIM\"}\'></span></p></div></myr-error-message></div><div class=\"ute-simCard-inputCollection\"><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><label for=\"currentSim\" data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.currentSim.$error && simCardForm.currentSim.$dirty || (simCardForm.currentSim.$invalid && simCardChange.hasInputFocus)) ? \'ute-simCard-inputTextError\' : \'\'\" translate=\"ute.rogers.myrSimCard.simCardChange.currentSim\"></label></div><div class=\"input_holder\"><input data-ng-focus=\"simCardChange.setCurrentSimInputFocus(true)\" data-ng-class=\"(simCardForm.currentSim.$invalid && simCardForm.$submitted || (simCardForm.currentSim.$invalid && simCardChange.hasInputFocus)) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" aria-label=\"{{\'ute.rogers.myrSimCard.simCardChange.currentSimAlt\' | translate}}\" name=\"currentSim\" id=\"currentSim\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.currentSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" data-ute-enter-as-tab=\"\" data-next-element=\"newSim\" required=\"\"> <span class=\"ute-input-error\" data-ng-show=\"simCardForm.currentSim.$invalid && simCardForm.$submitted || (simCardForm.currentSim.$invalid && simCardChange.hasInputFocus)\"></span></div></div><div class=\"ute-simCard-inputGroup\"><div data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted || $dirty) ? \'ute-simCard-inputTextLabelError\' : \'ute-simCard-inputTextLabel\'\"><label for=\"newSim\" data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.newSim.$error && simCardForm.newSim.$dirty || (simCardForm.newSim.$invalid && simCardChange.hasNewInputFocus)) ? \'ute-simCard-inputTextError\' : \'\'\" translate=\"ute.rogers.myrSimCard.simCardChange.newSim\"></label></div><div class=\"input_holder\"><input data-ng-focus=\"simCardChange.setCurrentSimInputFocus(false)\" data-ng-class=\"(simCardForm.newSim.$invalid && simCardForm.$submitted || (simCardForm.newSim.$invalid && simCardChange.hasNewInputFocus)) ? \'ute-simCard-inputTextError\' : \'ute-simCard-inputText\'\" type=\"text\" name=\"newSim\" id=\"newSim\" aria-label=\"{{\'ute.rogers.myrSimCard.simCardChange.newSimAlt\' | translate}}\" maxlength=\"20\" data-minlength=\"20\" data-ng-model=\"simCardChange.model.newSimCardNumber\" ute-numbers-only-input=\"\" ng-model-options=\"{ allowInvalid: true }\" required=\"\"> <span class=\"ute-input-error\" data-ng-show=\"simCardForm.newSim.$invalid && simCardForm.$submitted || (simCardForm.newSim.$invalid && simCardChange.hasNewInputFocus)\"></span></div></div></div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-cancelButton\" type=\"button\" data-ng-click=\"simCardChange.cancel($event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.cancel\"></span></button> <button class=\"ute-simCard-continueButton\" data-ng-click=\"simCardChange.submit(simCardForm, $event)\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardChange.continue\"></span></button></div></form>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmation.html","<div class=\"container\"><myr-sim-card-confirmation></myr-sim-card-confirmation></div>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmation.view.html","<div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.changeMySim\"></div></div><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sub\"></div><div class=\"ute-simCard-typeBodyGroup ute-simCard-typeMedium\"><span data-ng-bind=\"simCardConfirmation.getNewSimCardNumber()\"></span> &nbsp;&nbsp;&nbsp;&nbsp; <a class=\"ute-link\" data-ng-click=\"simCardConfirmation.backToUpdateSimCard()\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.update\"></span></a></div><div class=\"ute-simCard-messageBox-container\"><div class=\"ute-simCard-messageBox-warning\"><div class=\"row\"><div class=\"col-xs-2 col-sm-1 col-lg-1\"><img class=\"ute-simCard-messageBox-icon\" src=\"ute-common-assets/assets/warning_yellow.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10\"><span><span class=\"ute-simCard-messageBox-heading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.messageBox_heading\"></span><p class=\"ute-simCard-messageBox-body\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.messageBox_body\"></p></span></div></div></div></div><div data-ng-if=\"simCardConfirmation.isChangeSimCallInProgress()\" class=\"ute-simCard-confirmation-loader-container\"><img class=\"ute-simCard-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Changing Sim...\">&nbsp;</div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-cancelButton\" data-ng-click=\"simCardConfirmation.cancelConfirmation()\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.cancel\"></span></button> <button class=\"ute-simCard-continueButton\" data-ng-disabled=\"simCardConfirmation.isChangeSimCallInProgress()\" data-ng-click=\"simCardConfirmation.submitConfirmation()\"><span class=\"overrite-span\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.submit\"></span></button></div>");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationErrorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{simCardConfirmationModal.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" translate=\"{{simCardConfirmationModal.modalTitle}}\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><span translate=\"{{simCardConfirmationModal.errorMessage}}\"></span></div></div><div class=\"ute-simCard-modalButtonGroup\"><button name=\"button_continue\" data-ng-click=\"simCardConfirmationModal.cancel()\" class=\"ute-simCard-modalContinueButton\" type=\"button\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.ok\"></span></button></div><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationGenericModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{simCardConfirmationModal.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" translate=\"{{simCardConfirmationModal.errorMessage}}\"></div><bold-chat-static-button data-cbid=\"{{simCardConfirmationModal.boldChat.cbid | translate}}\" data-dynamic-div=\"{{simCardConfirmationModal.boldChat.dynamicDivId | translate}}\" data-chat-button=\"{{simCardConfirmationModal.boldChat.chatButtonClass | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button><div style=\"display: inline;\" translate=\"{{simCardConfirmationModal.errorMessage_p2}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" src=\"ute-common-assets/assets/warning_yellow.png\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.popup_heading\"></div></div><div class=\"ute-simCard-modalButtonGroup\"><button name=\"button_continue\" data-ng-click=\"simCardConfirmationModal.cancel()\" class=\"ute-simCard-modalCancelButton\" type=\"button\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.resume\"></span></button> <button data-ng-click=\"simCardConfirmationModal.continue()\" type=\"button\" class=\"ute-simCard-modalContinueButton\" name=\"button_continue\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.cancel_changes\"></span></button></div><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardConfirmation/simCardConfirmationNFDBErrorModal.view.html","<div class=\"ute-simCard-modalHeadingGroup\"><img class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{simCardConfirmationModal.modalIcon}}\"><div class=\"ute-simCard-modalHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><span translate=\"{{simCardConfirmationModal.errorMessage}}\"></span></div><ute-user-if-any-granted data-roles=\"care,dealer\"><div class=\"ute-simCard-modalTypeBody\"><div class=\"ute-simCard-nfdb-modal-subHeading\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.please_follow_these_steps\"></div><ul><li><div x-ms-format-detection=\"none\" translate=\"ute.rogers.myrSimCard.simCardConfirmation.ask_customer_message\"></div></li><li><div translate=\"ute.rogers.myrSimCard.simCardConfirmation.tell_the_customer_message\"></div></li></ul></div></ute-user-if-any-granted></div><div class=\"ute-simCard-modalButtonGroup\"><button name=\"button_continue\" data-ng-click=\"simCardConfirmationModal.cancel()\" class=\"ute-simCard-modalContinueButton\" type=\"button\"><span translate=\"ute.rogers.myrSimCard.simCardConfirmation.ok\"></span></button></div><img class=\"ute-simCard-modalClose\" data-ng-click=\"simCardConfirmationModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/simCard/simCardEnterSimCard/simCardEnterSimCard.view.html","<div class=\"container\"><div class=\"row\"><div class=\"hidden-xs hidden-sm col-md-5 col-lg-5\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.changeMySim\"></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.directions\"></div></div><myr-sim-card-change is-desktop-view=\"true\" submit-function=\"sc.submitFunction()\" cancel-function=\"sc.cancelFunction()\"></myr-sim-card-change></div><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6 pull-right\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-headingSecondary\" translate=\"ute.rogers.myrSimCard.howToFindSerial\"></div></div></div><div class=\"hidden-xs hidden-sm col-md-6 col-lg-6 pull-right\" data-ng-include=\"sc.howToFindNumberPartialPath\"></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\" translate=\"ute.rogers.myrSimCard.changeMySim\"></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.directions\"></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg ute-simcard-accordion\" data-accordion=\"\"><div data-accordion-group=\"\" data-is-open=\"mobileAccordionIsOpen\"><accordion-heading><span translate=\"ute.rogers.myrSimCard.howToFindSerial\"></span> <i class=\"ute-icon-chevron-down ute-simCard-accordionIcon\" data-ng-class=\"{\'\': !mobileAccordionIsOpen, \'ute-simCard-accordionIconUp\': mobileAccordionIsOpen}\"></i></accordion-heading><div class=\"container\" data-ng-include=\"sc.howToFindNumberPartialPath\"></div></div></div></div><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 hidden-md hidden-lg\"><myr-sim-card-change is-desktop-view=\"false\"></myr-sim-card-change></div></div></div>");
$templateCache.put("module/simCard/simCardEnterSimCard/simCardHowToFindNumber.partial.html","<div class=\"ute-simCard-typeBodyGroup\"><div class=\"row\"><div class=\"ute_simCard_findSimNumber_holder col-xs-12 col-sm-6 col-md-4 col-lg-3\"><img src=\"ute-common-assets/assets/simCardSerial.png\" tabindex=\"0\" title=\"{{\'ute.rogers.myrSimCard.serialNumberLocationLabel\' | translate}}\" alt=\"{{\'ute.rogers.myrSimCard.serialNumberLocationLabel\' | translate}}\"></div><div class=\"col-xs-12 col-sm-6 col-md-7 col-lg-7\"><span class=\"ute-simCard-typeBody\" translate=\"ute.rogers.myrSimCard.serialNumberLocation\"></span></div></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><div translate=\"ute.rogers.myrSimCard.firstWay\"></div><div translate=\"ute.rogers.myrSimCard.ios.osName\"></div><ol><li translate=\"ute.rogers.myrSimCard.ios.firstBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.secondBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.thirdBullet\"></li><li translate=\"ute.rogers.myrSimCard.ios.forthBullet\"></li></ol><div translate=\"ute.rogers.myrSimCard.android.osName\"></div><ol><li translate=\"ute.rogers.myrSimCard.android.firstBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.secondBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.thirdBullet\"></li><li translate=\"ute.rogers.myrSimCard.android.forthBullet\"></li></ol><div translate=\"ute.rogers.myrSimCard.findSerialParagraph\"></div></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><div translate=\"ute.rogers.myrSimCard.secondWay\"></div><div translate=\"ute.rogers.myrSimCard.onSimCard\"></div></div></div>");
$templateCache.put("module/simCard/simCardErrorMessage/simCardErrorMessage.template.html","<div class=\"ute-simCard-messageBox-container\"><div class=\"row ute-simCard-messageBox-error\"><div class=\"col-xs-2 col-sm-2 col-lg-2\"><img class=\"ute-simCard-messageBox-icon\" src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-10 col-sm-10 col-lg-10 pull-right\"><div class=\"ute-simCard-messageBox-body\" style=\"margin-top: 10px;\"><ng-transclude></ng-transclude></div></div></div></div>");
$templateCache.put("module/simCard/simCardErrorMessage/simCardErrorMessageWindow.view.html","<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" uib-modal-animation-class=\"fade\" modal-in-class=\"in\" ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-simCard-modalContent modal-content\" ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/simCard/simCardSuccess/simCardSuccess.html","<div class=\"container\"><myr-sim-card-success></myr-sim-card-success></div>");
$templateCache.put("module/simCard/simCardSuccess/simCardSuccess.view.html","<div class=\"container\"><div class=\"row\"><div class=\"col-lg-11\"><div class=\"ute-simCard-headingGroup\"><div class=\"ute-simCard-heading\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.heading\"></span></div></div><div class=\"ute-simCard-typeBodyGroup\"><div class=\"ute-simCard-typeBody\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.body\"></span></div></div><div class=\"ute-simCard-buttonGroup\"><button class=\"ute-simCard-continueButton\" data-ng-click=\"simCardSuccess.finishedRoute()\"><span translate=\"ute.rogers.myrSimCard.simCardSuccess.backToAccount\"></span></button></div></div></div></div>");
$templateCache.put("module/subscriptionBadge/subscriptionBadgeViews/basic.view.html","<div class=\"ute-subscription-badge\" ng-click=\"subscriptionBadge.viewModel.resolveAll(subscriptionBadge.viewModel)\" ng-class=\"{ \'ute-subscriptionBadge-disabled\': subscriptionBadge.viewModel.disabled }\"><div class=\"ute-subscription-badge-icon\"><span class=\"{{:: subscriptionBadge.viewModel.icon }}\"></span></div><div class=\"ute-subscription-badge-labels\"><div ng-repeat=\"label in subscriptionBadge.viewModel.labels track by label.key\" ng-class=\"label.class\"><span ng-if=\"label.translationKey\" translate=\"{{ label.translationKey }}\"></span> <span ng-if=\"!label.translationKey\" ng-bind-html=\"label.text\"></span> <span ng-if=\"!label.translationKey\" ng-bind-html=\"label.subAddress\"></span></div></div><div class=\"ute-subscription-badge-background\"><div class=\"ute-subscription-badge-arrow\"></div></div><div class=\"ute-subscription-badge-icon-secondary\"><span class=\"ute-icon-button-arrow-right\"></span></div><div ng-if=\"subscriptionBadge.viewModel.suspended\" class=\"ute-subscription-badge-suspended\"><div class=\"ute-subscription-badge-suspended-content\"><span class=\"ute-icon-warning\"></span> <span translate=\"ute.subscriptionBadge.serviceSuspended\"></span><div class=\"ute-subscription-badge-suspended-text\"><span>Effective:</span> {{ subscriptionBadge.viewModel.suspended }}</div></div></div></div>");
$templateCache.put("module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.RepView.view.html","<section class=\"ute-repView-suspendCtnConfirm-page\"><div class=\"container\"><div class=\"row ute-suspendCtnConfirm-header\"><div class=\"col-xs-12 col-md-3 col-md-push-9\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number><ute-suspend-ctn-device></ute-suspend-ctn-device></div><div class=\"col-xs-12 col-md-9 col-md-pull-3\"><h1 data-translate=\"ute.common.suspend.ctn.confirm.repview_customer\" class=\"ute-suspendCtnSuccess-title-padding\"></h1><p data-translate=\"ute.common.suspend.ctn.confirm.repview_steps\" style=\"font-size:28px\"></p></div></div><div class=\"row\"><div class=\"col-md-12\"><p class=\"ute-suspendCtnConfirm-steps ute-suspendCtnConfirm-repview-steps\" data-translate=\"ute.common.suspend.ctn.confirm.repview_firstStep\"></p><div><span data-translate=\"ute.common.suspend.ctn.confirm.repview_findIphone\" style=\"font-size:22px\"></span> <a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findIphoneUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue\" style=\"display:inline;font-size:20px;padding-left:15px\" data-translate=\"ute.common.suspend.ctn.confirm.findIphoneUrl\"></p></a></div><div><span data-translate=\"ute.common.suspend.ctn.confirm.repview_findAndroid\" style=\"font-size:22px\"></span> <a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findAndroidUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue\" style=\"display:inline;font-size:20px;padding-left:15px\" data-translate=\"ute.common.suspend.ctn.confirm.findAndroidUrl\"></p></a></div></div><div class=\"col-md-12\"><p class=\"ute-suspendCtnConfirm-steps ute-suspendCtnConfirm-repview-steps\" data-translate=\"ute.common.suspend.ctn.confirm.repview_secondStep\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.repview_ifFind\" class=\"ute-repView-suspendCtnConfirm-font\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.repview_turnoff\" class=\"ute-repView-suspendCtnConfirm-font\"></p><ul class=\"ute-suspendCtnConfirm-service-list\"><li class=\"ute-suspendCtnConfirm-bold ute-repView-suspendCtnConfirm-li-font\" data-translate=\"ute.common.suspend.ctn.confirm.data\"></li><li class=\"ute-suspendCtnConfirm-bold ute-repView-suspendCtnConfirm-li-font\" data-translate=\"ute.common.suspend.ctn.confirm.repview_talk\"></li><li class=\"ute-suspendCtnConfirm-bold ute-repView-suspendCtnConfirm-li-font\" data-translate=\"ute.common.suspend.ctn.confirm.repview_text\"></li></ul></div><div class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12 row\"><button name=\"button_continue\" data-ng-disabled=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" data-ng-click=\"confirmSuspendDevice.switchOffService($event)\" class=\"ute-suspendCtnConfirm-switch col-xs-9 col-sm-9\" data-ng-class=\"(confirmSuspendDevice.isSuspendCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.suspend.ctn.confirm.repview_switchOffService\" class=\"ute-repView-suspendCtnConfirm-font\" style=\"font-weight:600;\"></span></button><div data-ng-if=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" class=\"ute-suspendCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-suspendCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Suspending Device...\">&nbsp;</div></div><div class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 ute-suspendCtnConfirm-padding\"><p class=\"ute-suspendCtnConfirm-switch-left-margin\" data-translate=\"ute.common.suspend.ctn.confirm.confirmEmail\" data-translate-values=\"{accountEmail:confirmSuspendDevice.getAccountEmail()}\" style=\"font-size:18px\"></p></div><div class=\"col-md-12 col-xs-12 col-lg-12 col-sm-12 ute-suspendConfirm-bottom-border\"><p class=\"ute-suspendCtnConfirm-steps ute-suspendCtnConfirm-step-three ute-suspendCtnConfirm-repview-steps\" data-translate=\"ute.common.suspend.ctn.confirm.repview_thirdStep\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.repview_note\" class=\"ute-suspendCtnConfirm-repview-note\"></p><div class=\"col-md-12 col-xs-12 col-lg-12 col-sm-12 ute-suspendCtn-offer-banner\"><div class=\"col-xs-2 col-sm-1 col-md-1 col-lg-1 ute-suspendCtn-offer-icon\"><img src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/unlock/info_icon.png\" class=\"ute-suspendCtn-offer-img\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><span data-translate=\"ute.common.suspend.ctn.confirm.repview_offering\"></span></div></div></div></div></div></section>");
$templateCache.put("module/suspendCtn/suspendCtnConfirm/suspendCtnConfirm.view.html","<section><div class=\"container\"><div class=\"row ute-suspendCtnConfirm-header\"><div class=\"col-xs-12 col-md-3 col-md-push-9\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number><ute-suspend-ctn-device></ute-suspend-ctn-device></div><div class=\"col-xs-12 col-md-9 col-md-pull-3\"><h1 data-translate=\"ute.common.suspend.ctn.confirm.sorryToHear\">Sorry to hear<br>you\'ve lost your phone</h1><p data-translate=\"ute.common.suspend.ctn.confirm.rightPlace\">You\'re in the right place to find a solution.</p></div></div><div class=\"row\"><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.firstStep\"></h3><a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findIphoneUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findIphone\"></p></a> <a data-ng-href=\"{{\'ute.common.suspend.ctn.confirm.findAndroidUrl\' | translate}}\" target=\"_blank\"><p class=\"ute-suspendCtnConfirm-blue ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.findAndroid\"></p></a></div><div class=\"col-md-12\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.secondStep\"></h3><p data-translate=\"ute.common.suspend.ctn.confirm.ifFind\"></p><p data-translate=\"ute.common.suspend.ctn.confirm.turnOff\"></p><ul class=\"ute-suspendCtnConfirm-service-list\"><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.data\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.talk\"></li><li class=\"ute-suspendCtnConfirm-bold\" data-translate=\"ute.common.suspend.ctn.confirm.text\"></li></ul></div><div class=\"col-lg-3 col-md-3 col-xs-12 col-sm-12 row\"><button name=\"button_continue\" data-ng-disabled=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" data-ng-click=\"confirmSuspendDevice.switchOffService($event)\" class=\"ute-suspendCtnConfirm-switch col-xs-9 col-sm-9\" data-ng-class=\"(confirmSuspendDevice.isSuspendCtnCallInProgress()) ? \'\' : \'full\'\" type=\"button\"><span data-translate=\"ute.common.suspend.ctn.confirm.switchOffService\"></span></button><div data-ng-if=\"confirmSuspendDevice.isSuspendCtnCallInProgress()\" class=\"ute-suspendCtn-confirmation-loader-container col-xs-3 col-sm-3\"><img class=\"ute-suspendCtn-loading-img\" src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"Suspending Device...\">&nbsp;</div></div><div data-ng-show=\"confirmSuspendDevice.getAccountEmail()\" class=\"col-lg-9 col-md-9 col-xs-12 col-sm-12 ute-suspendCtnConfirm-padding\"><p class=\"ute-suspendCtnConfirm-switch-left-margin\" data-translate=\"ute.common.suspend.ctn.confirm.confirmEmail\" data-translate-values=\"{accountEmail:confirmSuspendDevice.getAccountEmail()}\"></p><a data-ui-sref=\"{{::confirmSuspendDevice.getUpdateProfileState()}}\"><p class=\"ute-suspendCtnConfirm-switch-left-margin ute-suspendCtnConfirm-blue\" data-translate=\"ute.common.suspend.ctn.confirm.updateEmail\"></p></a></div><div class=\"col-md-12 col-xs-12 col-lg-12 col-sm-12 ute-suspendConfirm-bottom-border\"><h3 class=\"ute-suspendCtnConfirm-steps\" data-translate=\"ute.common.suspend.ctn.confirm.thirdStep\"></h3><bold-chat-static-button class=\"col-md-4 col-lg-4 col-xs-12 col-sm-12 ute-suspendCtnConfirm-live-chat\" data-cbid=\"{{\'ute.common.suspend.ctn.boldChat.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.suspend.ctn.boldChat.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.suspend.ctn.boldChat.chatButtonClass\' | translate}}\"></bold-chat-static-button><img src=\"ute-common-assets/assets/call.png\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.suspend.ctn.fail.supportPhoneNumber\"></div></div></div></div></section>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.device.directive.html","<div data-ng-if=\"suspendCtnDevice.hasDeviceName()\"><h5 data-translate=\"ute.common.suspend.ctn.success.header.device\"></h5><div data-translate=\"ute.common.suspend.ctn.success.header.deviceName\"></div></div>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.faq.directive.html","<section class=\"ute-suspendCtnSuccess-faq\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 data-translate=\"ute.common.suspend.ctn.success.faq.title\"></h1></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-suspendCtnSuccess-faq-question\" data-translate=\"ute.common.suspend.ctn.success.faq.question01\"></div><div class=\"ute-suspendCtnSuccess-faq-answer\" data-translate=\"ute.common.suspend.ctn.success.faq.answer01\"></div><a data-ng-href=\"{{\'ute.common.suspend.ctn.success.faq.learnHowUrl\' | translate}}\" data-translate=\"ute.common.suspend.ctn.success.faq.learnHow\" target=\"_blank\"></a></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"ute-suspendCtnSuccess-faq-question\" data-translate=\"ute.common.suspend.ctn.success.faq.question02\"></div><div class=\"ute-suspendCtnSuccess-faq-answer\" data-translate=\"ute.common.suspend.ctn.success.faq.answer02\"></div></div></div></div></section>");
$templateCache.put("module/suspendCtn/suspendCtnDirective/suspendCtn.wirelessNumber.directive.html","<div class=\"ute-suspendCtn-wirelessNumber\"><h5 data-translate=\"ute.common.suspend.ctn.success.header.wirelessNumber\"></h5><div>{{::suspendCtnWirelessNumber.getFirstName()}} {{::suspendCtnWirelessNumber.getPhoneNumber() | ute_common_filter_phone3}}</div><a class=\"ute-suspendCtn-link\" data-ng-click=\"suspendCtnWirelessNumber.backToDevicePage()\" data-translate=\"ute.common.suspend.ctn.success.header.backToDevice\"></a></div>");
$templateCache.put("module/suspendCtn/suspendCtnError/suspendCtnError.RepView.view.html","<div class=\"ute-suspendCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-suspendCtn-vertical-align-middle ute-suspendCtn-repview-error-title\" data-translate=\"ute.common.suspend.ctn.fail.repview_title\" style=\"padding-left:0px\"></div></div><div class=\"ute-suspendCtn-modalBodyGroup row\"><div class=\"ute-suspendCtn-repView-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12 ute-suspendCtn-repview-padding-left\"><span data-translate=\"ute.common.reactivate.ctn.fail.repview_possible_reasons\" class=\"row col-xs-12 col-sm-12 col-md-12 col-lg-12\"></span><ul><li data-translate=\"ute.common.suspend.ctn.fail.repview_pending_cancellation\"></li><li data-translate=\"ute.common.suspend.ctn.fail.repview_fraud\"></li><li data-translate=\"ute.common.suspend.ctn.fail.repview_credit_limit\"></li><li data-translate=\"ute.common.suspend.ctn.fail.repview_update_soc\"></li></ul></div><div class=\"ute-suspendCtn-repview-padding-left\" data-translate=\"ute.common.suspend.ctn.fail.repview_sorry_msg\" style=\"padding-left:20px;font-size:18px;\"></div><div class=\"ute-suspendCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12 ute-suspendCtn-repview-padding-left\" style=\"padding-left:20px\"><a class=\"ute-suspendCtn-link\" data-ng-click=\"simCardErrorModal.backToDevicePage()\" data-translate=\"ute.common.suspend.ctn.success.header.backToDevice\"></a></div></div><img class=\"ute-suspendCtn-modalClose\" data-ng-click=\"simCardErrorModal.cancel()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/suspendCtn/suspendCtnError/suspendCtnError.view.html","<div class=\"ute-suspendCtn-modalHeadingGroup row\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1\"><img src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-xs-offset-1 col-xs-9 col-sm-offset-1 col-sm-9 col-md-offset-1 col-md-9 col-lg-offset-1col-lg-9 ute-suspendCtn-vertical-align-middle\" data-translate=\"ute.common.suspend.ctn.fail.title\"></div></div><div class=\"ute-suspendCtn-modalBodyGroup row\"><div class=\"ute-suspendCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div style=\"display: inline;\" data-translate=\"ute.common.suspend.ctn.fail.message\"></div></div><div class=\"ute-suspendCtn-modalBody col-xs-12 col-sm-12 col-md-12 col-lg-12\"><a class=\"ute-suspendCtn-link\" data-ng-click=\"simCardErrorModal.backToDevicePage()\" data-translate=\"ute.common.suspend.ctn.success.header.backToDevice\"></a></div><div class=\"ute-suspendCtn-modalBody row col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-7\"><bold-chat-static-button data-cbid=\"{{\'ute.common.suspend.ctn.boldChatError.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.common.suspend.ctn.boldChatError.dynamicDivId\' | translate}}\" data-chat-button=\"{{\'ute.common.suspend.ctn.boldChatError.chatButtonClass\' | translate}}\"></bold-chat-static-button></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5\"><img src=\"ute-common-assets/assets/call.png\"><div class=\"ute-suspendCtn-support-phone\" data-translate=\"ute.common.suspend.ctn.fail.supportPhoneNumber\"></div></div></div></div><img class=\"ute-suspendCtn-modalClose\" data-ng-click=\"simCardErrorModal.cancel()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.RepView.view.html","<div class=\"ute-repView-suspendCtnSuccess-page\"><section><section class=\"ute-suspendCtnSuccess-header\"><div class=\"container\"><div class=\"row\" style=\"margin: 25px 0 5px 0;border-bottom: 1px solid #e9e9e9;padding-bottom: 50px;\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-device></ute-suspend-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-suspendCtnSuccess-title\" style=\"padding-top:20px;font-weight:500;font-size:50px;max-width:450px;\" data-translate=\"ute.common.suspend.ctn.success.header.title\"></h1><div class=\"ute-suspendCtnSuccess-header-message\" style=\"font-size:20px;max-width:550px;\" data-translate=\"ute.common.suspend.ctn.success.header.repview_message\"></div></div></div></div></section><section class=\"ute-suspendCtnSuccess-body\"><div class=\"container ute-suspendConfirm-bottom-border\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-suspendCtnSuccess-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><span class=\"ute-suspendCtnSuccess-title\" style=\"font-size:30px;\" data-translate=\"ute.common.suspend.ctn.success.body.repview_title\"></span></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img src=\"ute-common-assets/assets/wireless/mobile_phone.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message01_repview\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img src=\"ute-common-assets/assets/wireless/dollar.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message02_repview\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img src=\"ute-common-assets/assets/wireless/mobile_phone_cancel.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message03_repview\"></div></div></div></div></div><div><div></div></div></section></section></div>");
$templateCache.put("module/suspendCtn/suspendCtnSuccess/suspendCtnSuccess.view.html","<div><section><section class=\"ute-suspendCtnSuccess-header\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-4 col-md-push-8 col-lg-4 col-lg-push-8\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-wireless-number></ute-suspend-ctn-wireless-number></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><ute-suspend-ctn-device></ute-suspend-ctn-device></div></div><div class=\"col-xs-12 col-sm-12 col-md-8 col-md-pull-4 col-lg-8 col-md-pull-4\"><h1 class=\"ute-suspendCtnSuccess-title\" data-translate=\"ute.common.suspend.ctn.success.header.title\"></h1><div class=\"ute-suspendCtnSuccess-header-message\" data-translate=\"ute.common.suspend.ctn.success.header.message\"></div></div></div></div></section><section class=\"ute-suspendCtnSuccess-body\"><div class=\"container\"><div class=\"col-xs-12 col-sm-8 col-md-8 col-lg-8\"><div class=\"row ute-suspendCtnSuccess-body-title\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><h1 class=\"ute-suspendCtnSuccess-title\" data-translate=\"ute.common.suspend.ctn.success.body.title\"></h1></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/mobile_phone.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message01\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/dollar.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message02\"></div></div></div><div class=\"row ute-suspendCtnSuccess-body-section\"><div class=\"col-xs-3 col-sm-3 col-md-2 col-lg-2\"><img data-ng-src=\"ute-common-assets/assets/wireless/mobile_phone_cancel.png\" alt=\"\"></div><div class=\"col-xs-9 col-sm-9 col-md-10 col-lg-10 ute-suspendCtnSuccess-body-text\"><div data-translate=\"ute.common.suspend.ctn.success.body.message03\"></div></div></div></div></div><div><div></div></div></section></section></div>");
$templateCache.put("module/transferOfResponsibility/stepFour/stepFour.view.html","<section class=\"ute-tor-destination-customer\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-8\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"transfer-of-responsibility-title-owner\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.futureOwner\" class=\"ute-tor-owner-title\"></span></div></div><div class=\"ute-tor-clear-both\" data-ng-include=\"stepFour.config.advanced.futureOwnerFinalConfirmation.templateUrl\"></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/futureOwnerInfoForm.html","<section class=\"ute-tor-assign-destination-form\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-7 ute-tor-future-owner-container\"><div class=\"row\"><div class=\"col-xs-12 ute-tor-select-subscriber ute-tor-heading-border-bottom\"><div class=\"col-xs-11\"><span data-translate=\"ute.tor.currentCustomer.selectTORSubscriber\"></span></div><span class=\"col-xs-1\"><span aria-hidden=\"false\" style=\"float: right;\"><span class=\"rui-icon-success ute-tor-success-icon\"></span></span></span></div><div class=\"col-xs-12 ute-tor-future-owner-first-title ute-tor-current-heading\"><span data-translate=\"ute.tor.currentCustomer.obtainFutureOwnerInfo\"></span></div><div class=\"ute-tor-content\"><span data-translate=\"ute.tor.currentCustomer.formFillingInstruction\"></span></div><form name=\"torDestinationCustomerForm\" novalidate=\"\"><div class=\"col-xs-12\"><div class=\"row ute-tor-input\"><div class=\"col-xs-4\"><label for=\"ute-tor-future-owner-first-name\" class=\"ute-tor-future-owner-first-name\"><input placeholder=\"&nbsp;\" id=\"ute-tor-future-owner-first-name\" class=\"ute-tor-future-owner-first-name tor-input-dest\" type=\"text\" data-ng-model=\"futureOwnerInfo.model.sourceAccountInfo.firstName\" maxlength=\"20\" data-ng-maxlength=\"20\" data-ng-required=\"true\" data-minlength=\"1\"> <span class=\"ute-tor-future-owner-first-name-label\" data-translate=\"ute.tor.currentCustomer.firstName\"></span> <span class=\"ute-tor-future-owner-first-name-border\"></span></label></div><div class=\"col-xs-4\"><label for=\"ute-tor-future-owner-last-name\" class=\"ute-tor-future-owner-last-name\"><input placeholder=\"&nbsp;\" id=\"ute-tor-future-owner-last-name\" class=\"ute-tor-future-owner-last-name tor-input-dest\" type=\"text\" data-ng-model=\"futureOwnerInfo.model.sourceAccountInfo.lastName\" maxlength=\"20\" data-ng-maxlength=\"20\" data-ng-required=\"true\" data-minlength=\"1\"> <span class=\"ute-tor-future-owner-last-name-label\" data-translate=\"ute.tor.currentCustomer.lastName\"></span> <span class=\"ute-tor-future-owner-last-name-border\"></span></label></div><div class=\"col-xs-4\"><label for=\"ute-tor-future-owner-security-word\" class=\"ute-tor-future-owner-security-word\"><input placeholder=\"&nbsp;\" id=\"ute-tor-future-owner-security-word\" class=\"ute-tor-future-owner-security-word tor-input-dest\" type=\"text\" data-ng-model=\"futureOwnerInfo.model.sourceAccountInfo.securityCode\" maxlength=\"20\" data-ng-maxlength=\"20\" data-ng-required=\"true\" data-minlength=\"1\"> <span class=\"ute-tor-future-owner-security-word-label\" data-translate=\"ute.tor.currentCustomer.securityWord\"></span> <span class=\"ute-tor-future-owner-security-word-border\"></span></label></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-interaction-note-content\"><div class=\"col-xs-1\"><span class=\"ute-tor-small-info-icon rui-icon-info\"></span></div><div class=\"col-xs-10\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-eligibility-buttons\"><div class=\"col-xs-5 ute-tor-cancel-tor-link\" ng-class=\"lng === \'en\' ? \'col-xs-offset-2\': \'col-xs-offset-1\'\"><a ng-click=\"futureOwnerInfo.backToTor()\" data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link\"></a></div><div class=\"col-xs-3 ute-tor-primary-disable-buttons\" ng-class=\"{\'ute-tor-primary-buttons\': torDestinationCustomerForm.$valid, \'ute-tor-primary-disable-buttons\': torDestinationCustomerForm.$invalid}\"><button data-ng-disabled=\"torDestinationCustomerForm.$invalid\" data-ng-click=\"futureOwnerInfo.formSaveAndProceed()\"><span translate=\"ute.tor.saveAndProceed\"></span></button></div><div class=\"col-xs-1\" ng-show=\"futureOwnerInfo.sourceSubmitCallInProgress\"><span><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.currentOwnerConfirmation.html","<section class=\"col-xs-11 ute-tor-confirmation-status\"><div class=\"row ute-tor-border-outline\"><div class=\"col-xs-12 ute-tor-select-subscriber\" style=\"font-weight: 300;border-bottom: 1px solid lightgray;border-radius: 0;\"><div class=\"col-xs-11\"><span data-translate=\"ute.tor.currentCustomer.selectTORSubscriber\"></span></div><span class=\"col-xs-1\"><span aria-hidden=\"false\" style=\"float: right;\"><span class=\"rui-icon-circle-solid-check\" style=\"font-size: 3rem;color: green;\"></span></span></span></div><div class=\"col-xs-12 ute-tor-secondary-title\" style=\"font-weight: 600;\"><span data-translate=\"ute.tor.currentCustomer.obtainFutureOwnerInfo\"></span></div><div class=\"col-xs-11 ute-green-header-outline ute-tor-completion-note\"><div class=\"col-xs-1\" style=\"width: fit-content;margin: 0.75rem;\"><span class=\"rui-icon-circle-solid-check\" style=\"font-size: 2rem;color: green;\"></span></div><div class=\"col-xs-10\"><span data-translate=\"ute.tor.confirmation.torAuthorizationInProgress\"></span> <span>{{confirmation.TORService.getDate(30) | date:\'MMM dd, yyyy\'}}</span> <span>.</span> <span data-translate=\"ute.tor.confirmation.askFutureOwnerToContact\"></span></div></div><div class=\"col-xs-5 ute-tor-select-number\" style=\"margin-left: 2rem;\"><span data-translate=\"ute.tor.confirmation.title\"></span></div><div class=\"col-xs-11 ute-tor-select-subscriber-container\"><div class=\"row\" style=\"border-bottom: 1px solid gray; padding: 10px 0px 10px 0px;margin-left: 10px;margin-right: 10px;\"><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.futureOwnerName\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.customerTelephoneNo\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.securityWord\"></span></div></div><div class=\"row\" style=\"padding: 10px 0px 10px 0px;margin-left: 10px;margin-right: 10px;\"><div class=\"col-xs-4 ute-tor-confirmation-info\"><span ng-bind=\"confirmation.TORService.getModel().sourceAccountInfo.firstName\"></span> <span ng-bind=\"confirmation.TORService.getModel().sourceAccountInfo.lastName\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-info\"><div ng-repeat=\"ctn in confirmation.ctnList\" ng-if=\"ctn.isEligible\"><span ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></div></div><div class=\"col-xs-4 ute-tor-confirmation-info\" ng-bind=\"confirmation.TORService.getModel().sourceAccountInfo.securityCode\"></div></div></div><div class=\"col-xs-12\" style=\"padding-right: 5rem;\"><div class=\"row ute-tor-interaction-note-content\"><div class=\"col-xs-1\"><span class=\"ute-tor-small-info-icon rui-icon-info\"></span></div><div class=\"col-xs-10\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-eligibility-buttons\"><div class=\"col-xs-offset-2 col-xs-5\" style=\"margin-top: 3.5rem;\"><a data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link\" ng-click=\"confirmation.backToTor()\" tabindex=\"0\"></a></div><div class=\"col-xs-3 ute-tor-primary-buttons\"><button ng-click=\"confirmation.backToTor()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"tor-current-owner,event.selfServeComplete\"}\'><span translate=\"ute.tor.saveAndProceed\"></span></button></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.currentOwnerEligibilityResults.html","<section class=\"ute-tor-eligibility-results\"><div class=\"col-xs-11 row ute-tor-select-subscriber-result\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\"><span data-translate=\"ute.tor.currentCustomer.selectTORSubscriber\"></span></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-header\"><div class=\"col-xs-5 ute-tor-select-number\"><span data-translate=\"ute.tor.eligibilityResults.numbers\"></span></div><div class=\"col-xs-5 ute-tor-cta-link\" style=\"margin-left: 10px;margin: 0;margin-left: 1rem;margin-top: 0.5rem;\"><a ng-click=\"currentOwnerEligibility.addAnotherNumber()\"><span data-translate=\"ute.tor.eligibilityResults.addAnother\"></span></a></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\" ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-if=\"ctn.isSelected\" ng-class=\"{\'ute-tor-ctn-separator\': !$first}\" style=\"padding: 1rem;\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span style=\"font-size: 18px;font-weight: 500;\" ng-bind=\"ctn.firstName\"></span> <span style=\"font-size: 18px;margin-left: 5px; color: gray;\" ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\" style=\"font-size: 1.7rem;font-weight: 400;padding-left: 1rem;\"><span class=\"col-xs-2\"><span ng-show=\"ctn.isEligible\" style=\"color: #62BB96;\" class=\"rui-icon-circle-solid-check\"></span> <span ng-show=\"ctn.isEligible==false\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"ctn.isEligible === null || ctn.isEligible === undefined\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"ctn.isStatusFailure\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"ctn.isEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span> <span ng-show=\"ctn.isEligible\" data-translate=\"ute.tor.eligibilityResults.eligible\"></span> <span ng-show=\"ctn.isStatusFailure\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span></span></div><div ng-show=\"ctn.isEligible==false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in ctn.reasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\"></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-11 ute-tor-select-subscriber-container\"><div class=\"row\"><div class=\"col-xs-12 tor-ctn-list\" ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-if=\"ctn.isSelected\" ng-class=\"{\'ute-tor-ctn-separator\': !$first}\"><span class=\"col-xs-12\"><div class=\"col-xs-6\"><span style=\"font-size: 18px;font-weight: 500;\" ng-bind=\"ctn.firstName\"></span> <span style=\"font-size: 18px;margin-left: 5px; color: gray;\" ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"ctn.isEligible\" style=\"color: #62BB96;\" class=\"rui-icon-circle-solid-check\"></span> <span ng-show=\"ctn.isEligible==false || ctn.isStatusFailure\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"ctn.isEligible === null || ctn.isEligible === undefined\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"ctn.isEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span> <span ng-show=\"ctn.isEligible\" data-translate=\"ute.tor.eligibilityResults.eligible\"></span> <span ng-show=\"ctn.isStatusFailure\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span></span></div></div></span></div></div></div><div ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-show=\"ctn.isEligible==false || ctn.isStatusFailure\" class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;font-size: 1.4rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 0.5rem;\"><span ng-show=\"ctn.isEligible == false || ctn.isStatusFailure\" style=\"color: #DA2C1F;\" class=\"rui-icon-alert-i\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"ctn.isEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"ctn.isStatusFailure==true\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-header\"><div class=\"col-xs-5 ute-tor-select-number\"><span data-translate=\"ute.tor.eligibilityResults.accountNumbers\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span class=\"\" ng-bind=\"currentOwnerEligibility.model.accountNumber\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible\" style=\"color: #62BB96;\" class=\"rui-icon-circle-solid-check\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"currentOwnerEligibility.isModalShown\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible === null && !currentOwnerEligibility.isModalShown\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span></span> <span class=\"col-xs-10\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false || currentOwnerEligibility.isModalShown\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible\" data-translate=\"ute.tor.eligibilityResults.eligible\"></span></span></div><div ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in currentOwnerEligibility.model.banReasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\" adl-error-track=\'{\"mappingKey\":\"tor-current-owner\",\"type\":\"user\",\"category\":\"self serve\"}\'></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;font-size: 1.4rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 1rem;\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false || currentOwnerEligibility.model.isBANEligible === null || currentOwnerEligibility.isModalShown\" style=\"color: #DA2C1F;\" class=\"rui-icon-alert-i\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"currentOwnerEligibility.isModalShown\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div></div><div class=\"col-xs-11 ute-tor-note-container\"><div class=\"ute-tor-note-title\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPointsTitle\"></span></div><ul class=\"ute-tor-notes-list\"><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint1\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint2\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint3\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint4\"></span></li></ul></div><div class=\"col-xs-11 ute-yellow-header-outline\" ng-show=\"(currentOwnerEligibility.model.isBANEligible==false) || (!currentOwnerEligibility.model.isBANEligible && !currentOwnerEligibility.isOneCtnEligible)\"><div class=\"col-xs-1\" style=\"width: fit-content;margin: 0.75rem;\"><span style=\"color: #FFD76F;\" class=\"rui-icon-alert-i\"></span></div><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.notEligibleErrorMessage\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-interaction-note-content\"><span class=\"rui-icon-info ute-tor-current-owner-note\"></span><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-eligibility-buttons\"><div class=\"col-xs-offset-2 col-xs-6\"><a ng-click=\"currentOwnerEligibility.backToTor()\" data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link\"></a></div><div class=\"col-xs-3 ute-tor-primary-disable-buttons\" data-ng-class=\"{\'ute-tor-primary-disable-buttons\': (!currentOwnerEligibility.model.isBANEligible || !currentOwnerEligibility.isOneCtnEligible ), \'ute-tor-primary-buttons\': (currentOwnerEligibility.model.isBANEligible && currentOwnerEligibility.isOneCtnEligible)}\"><button data-ng-disabled=\"(!currentOwnerEligibility.model.isBANEligible || !currentOwnerEligibility.isOneCtnEligible)\" data-ng-click=\"currentOwnerEligibility.eligibitySaveAndProceed()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"tor-future-owner,event.selfServeComplete\"}\'><span data-translate=\"ute.tor.saveAndProceed\"></span></button></div></div></div><div class=\"col-xs-12 ute-tor-obtain-future-owner-info\"><div class=\"col-xs-12 ute-tor-select-subscriber\"><span data-translate=\"ute.tor.currentCustomer.obtainFutureOwnerInfo\"></span></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.currentOwnerInformation.html","<section class=\"ute-tor-destination-customer\" style=\"padding-top: 1rem;\"><div><div class=\"row ute-tor-border-outline\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\" style=\"font-weight: 600;\"><span data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></div><div class=\"col-xs-12\"><div class=\"row ute-yellow-header-outline\"><div class=\"col-xs-1\"><span style=\"color: #FFD76F;\" class=\"rui-icon-alert-i ute-tor-current-owner-note\"></span></div><div class=\"col-xs-10\"><span data-translate=\"ute.tor.confirmation.torAuthorizationInProgress\"></span> <span>{{currentOwnerInfo.model.sourceAccountInfo.expiryDate | date:\'MMM dd, yyyy\'}}</span> <span>.</span> <span data-translate=\"ute.tor.confirmation.confirmSecurityWordMessage\"></span> <span>.</span></div></div></div><div class=\"col-xs-12 ute-tor-select-number\" style=\"margin-left: 2rem; padding: 1rem 3rem 1rem 3rem;\"><span data-translate=\"ute.tor.confirmation.title\"></span></div><div class=\"col-xs-11 ute-tor-select-subscriber-container\"><div class=\"row\" style=\"border-bottom: 1px solid gray; padding: 10px 0px 10px 0px;margin-left: 10px;margin-right: 10px;\"><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.futureOwnerName\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.customerTelephoneNo\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.securityWord\"></span></div></div><div class=\"row\" style=\"padding: 10px 0px 10px 0px;margin-left: 10px;margin-right: 10px;\"><div class=\"col-xs-4 ute-tor-confirmation-info\"><span ng-bind=\"currentOwnerInfo.TORService.getModel().sourceAccountInfo.firstName\"></span> <span ng-bind=\"currentOwnerInfo.TORService.getModel().sourceAccountInfo.lastName\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-info\"><span ng-bind=\"currentOwnerInfo.TORService.getModel().sourceAccountInfo.subscriberNumber | ute_common_filter_phone3\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-info\" ng-bind=\"currentOwnerInfo.TORService.getModel().sourceAccountInfo.securityCode\"></div></div></div><div class=\"col-xs-12\" style=\"margin-top: 2rem; margin-bottom: 2rem;\"><div class=\"col-xs-offset-2 col-xs-6 ute-tor-cancel-container\"><a ng-click=\"currentOwnerInfo.backToTor()\" data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link ng-scope\" tabindex=\"0\"></a></div><div class=\"col-xs-3 ute-tor-primary-buttons\"><button class=\"\" data-ng-click=\"currentOwnerInfo.runEligibilityCheck()\"><span data-translate=\"ute.tor.confirmation.continue\"></span></button></div></div><div class=\"col-xs-12 ute-tor-obtain-future-owner-info\"><div class=\"col-xs-12 ute-tor-select-subscriber\" style=\"font-weight: 400;\"><span data-translate=\"ute.tor.destinationCustomer.secondInstructionHeading\"></span></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.currentOwnerStepTracker.html","<section class=\"ute-tor-step-tracker\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li data-ng-class=\"(stepOne.stepTrackerIndex == 1) ? \'ute-tor-step-tracker-selected\' : \'ute-tor-step-tracker-completed\'\" class=\"\"><span class=\"ute-tor-step-tracker-number\">1</span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel1\"></span></li><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepTwo.stepTrackerIndex == 2, \'ute-tor-step-tracker-completed\': stepTwo.stepTrackerIndex > 2}\"><span class=\"ute-tor-step-tracker-number\">2</span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel2\"></span></li></ul></div></div><div class=\"col-xs-1\"><div class=\"row ute-tor-center-align\"><div class=\"col-xs-6\"><div class=\"ute-tor-step-tracker-wrapper\"><ul class=\"ute-tor-step-tracker-list\"><div class=\"ute-tor-step-tracker-border\"></div></ul></div></div></div></div><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li class=\"ute-tor-step-tracker-inactive\"><span class=\"ute-tor-step-tracker-number\">3</span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></li><li class=\"ute-tor-step-tracker-inactive\"><span class=\"ute-tor-step-tracker-number\">4</span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel4\"></span></li></ul></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.futureOwnerEligibilityResults.html","<section class=\"col-xs-11 ute-tor-destination-customer\"><div class=\"container\"><div class=\"col-xs-7\"><div class=\"row ute-tor-border-outline\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\"><span data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></div><div class=\"col-xs-12 ute-tor-select-number ute-tor-select-number-future-owner\" data-translate=\"ute.tor.eligibilityResults.futureOwnerAccountNumber\"></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span ng-bind=\"futureOwnerEligibility.model.accountNumber\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"futureOwnerEligibility.model.isBANEligible\" class=\"rui-icon-circle-solid-check ute-tor-success-color\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === false\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === null && !futureOwnerEligibility.isErrorPopupOpen\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"futureOwnerEligibility.model.isBANEligible\" data-translate=\"ute.tor.eligibilityResults.validated\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === false\" data-translate=\"ute.tor.eligibilityResults.notValidated\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.eligibilityResults.notValidated\"></span></span></div><div ng-show=\"futureOwnerEligibility.model.isBANEligible === false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in futureOwnerEligibility.model.banReasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\"></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 1rem;\"><span ng-show=\"futureOwnerEligibility.model.isBANEligible === false\" class=\"rui-icon-alert-i ute-tor-error-color\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-alert-i ute-tor-error-color\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"futureOwnerEligibility.model.isBANEligible === false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"futureOwnerEligibility.model.isBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div><div class=\"col-xs-12 ute-tor-select-number\" data-translate=\"ute.tor.eligibilityResults.cutureOwnerTelephoneNumber\" style=\"margin-left: 2rem;\"></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span class=\"\" ng-bind=\"futureOwnerEligibility.model.sourceAccountInfo.subscriberNumber | ute_common_filter_phone3\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible\" class=\"rui-icon-circle-solid-check ute-tor-success-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === false\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === null && !futureOwnerEligibility.isErrorPopupOpen\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible\" data-translate=\"ute.tor.eligibilityResults.eligible\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible==null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span></span></div><div ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in futureOwnerEligibility.model.banReasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\"></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 1rem;\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === false\" class=\"rui-icon-alert-i ute-tor-error-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === null && !futureOwnerEligibility.isErrorPopupOpen\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-alert-i ute-tor-error-color\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceCtnEligible === null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div><div class=\"col-xs-12 ute-tor-select-number\" data-translate=\"ute.tor.eligibilityResults.cutureOwnerAccountNumber\" style=\"margin-left: 2rem;\"></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span class=\"\" ng-bind=\"futureOwnerEligibility.model.sourceAccountInfo.accountNumber\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible\" class=\"rui-icon-circle-solid-check ute-tor-success-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible == false\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === null && !futureOwnerEligibility.isErrorPopupOpen\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-circle-x ute-tor-invalid-color\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible==false\" data-translate=\"ute.tor.eligibilityResults.notValidated\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible\" data-translate=\"ute.tor.eligibilityResults.validated\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible==null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.eligibilityResults.notValidated\"></span></span></div><div ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in futureOwnerEligibility.model.banReasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\"></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 1rem;\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === false\" class=\"rui-icon-alert-i ute-tor-error-color\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === null && !futureOwnerEligibility.isErrorPopupOpen\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" class=\"rui-icon-alert-i ute-tor-error-color\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"futureOwnerEligibility.model.sourceAccountInfo.isSourceBANEligible === null && futureOwnerEligibility.isErrorPopupOpen\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div><div class=\"col-xs-10 ute-tor-note-container\" style=\"margin-top: 0;\"><div class=\"ute-tor-note-title\" style=\"margin-top: 0;\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPointsTitle\"></span></div><ul class=\"ute-tor-notes-list\"><li><span data-translate=\"ute.tor.eligibilityResults.futureOwnerPoint\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.futureOwnerPoint2\"></span></li></ul></div><div class=\"col-xs-12\"><div class=\"row ute-tor-interaction-note-content\"><span class=\"rui-icon-info ute-tor-current-owner-note\"></span><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-eligibility-buttons\"><div class=\"col-xs-5 ute-tor-cancel-tor-link\" ng-class=\"lng === \'en\' ? \'col-xs-offset-2\': \'col-xs-offset-1\'\"><a ng-click=\"futureOwnerEligibility.backToTor()\" data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link\" tabindex=\"0\"></a></div><div class=\"col-xs-3 ute-tor-primary-buttons\" data-ng-class=\"{\'ute-tor-primary-disable-buttons\': futureOwnerEligibility.checkApiCount !== 3, \'ute-tor-primary-buttons\': futureOwnerEligibility.checkApiCount === 3}\"><button data-ng-disabled=\"futureOwnerEligibility.checkApiCount !== 3\" data-ng-click=\"futureOwnerEligibility.checkApiCount === 3 ? futureOwnerEligibility.destinationSubmit(): \'\'\" tabindex=\"0\" aria-disabled=\"false\" class=\"ng-click-active\"><span data-translate=\"ute.tor.saveAndProceed\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"tor-future-owner,event.selfServeComplete\"}\'></span></button></div></div></div><div class=\"col-xs-12 ute-tor-obtain-future-owner-info\"><div class=\"col-xs-12 ute-tor-secondary-title\"><span data-translate=\"ute.tor.destinationCustomer.secondInstructionHeading\"></span></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.futureOwnerFinalConfirmation.html","<section class=\"col-xs-11 ute-tor-confirmation-status\"><div class=\"row ute-tor-border-outline\"><div class=\"col-xs-12 ute-tor-select-subscriber\" style=\"border-radius: 0;border-bottom: 1px solid lightgray;\"><div class=\"col-xs-11\" style=\"font-weight: 400;\"><span data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></div><span class=\"col-xs-1\"><span aria-hidden=\"false\" style=\"float: right;\"><span class=\"rui-icon-circle-solid-check\" style=\"font-size: 3rem;color: green;\"></span></span></span></div><div class=\"col-xs-12 ute-tor-future-owner-first-title\"><span data-translate=\"ute.tor.confirmation.secondTitle\"></span></div><div class=\"col-xs-11 ute-green-header-outline ute-tor-completion-note\"><div class=\"col-xs-1\" style=\"width: fit-content;margin: 0.75rem;\"><span class=\"rui-icon-circle-solid-check\" style=\"font-size: 2rem;color: green;\"></span></div><div class=\"col-xs-10\" style=\"margin: 0.5rem;\"><span data-translate=\"ute.tor.confirmation.torAuthorized\"></span> <span>{{stepFour.TORService.getDate() | date:\'MMM dd, yyyy\'}}</span> <span>.</span> <span data-translate=\"ute.tor.confirmation.proceedToVision21\"></span></div></div><div class=\"col-xs-12 ute-tor-select-number\" style=\"margin-left: 2rem; padding: 1rem 3rem 1rem 3rem;\"><span data-translate=\"ute.tor.confirmation.title\"></span></div><div class=\"col-xs-12\"><div class=\"col-xs-11 ute-tor-select-subscriber-container\"><div class=\"row\"><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.futureOwnerName\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.customerTelephoneNo\"></span></div><div class=\"col-xs-4 ute-tor-confirmation-heading\"><span data-translate=\"ute.tor.confirmation.securityWord\"></span></div></div><div class=\"row\"><div class=\"row ute-tor-hr-line\" style=\"margin: 1.5rem;\"></div></div><div class=\"row\"><div class=\"col-xs-4 ute-tor-confirmation-info\"><span id=\"\" ng-bind=\"stepFour.model.sourceAccountInfo.firstName\"></span> <span ng-bind=\"stepFour.model.sourceAccountInfo.lastName\"></span></div><div class=\"col-xs-4 subscriberNumber ute-tor-confirmation-info\" id=\"subscriberNumber\" ng-bind=\"stepFour.TORService.getModel().sourceAccountInfo.subscriberNumber | ute_common_filter_phone3\"></div><div class=\"col-xs-4 ute-tor-confirmation-info\" ng-bind=\"stepFour.TORService.getModel().sourceAccountInfo.securityCode\"></div></div></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-interaction-note-content\" style=\"margin: 0;margin-right: 5rem; padding: 1rem;\"><div class=\"col-xs-1\"><span class=\"ute-tor-small-info-icon rui-icon-info\"></span></div><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12 ute-tor-copy-wrapper\"><div class=\"col-xs-4 ute-tor-primary-buttons\" style=\"float: right; margin-right: 4rem;\"><button ute-copy-to-clipboard=\"stepFour.model.sourceAccountInfo.subscriberNumber\" data-ng-click=\"stepFour.copyNumber()\" ngclipboard=\"\" data-clipboard-target=\"#subscriberNumber\"><span data-translate=\"ute.tor.confirmation.copyCustomerNumber\"></span></button></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/torTemplates/tor.futureOwnerStepTracker.html","<section class=\"ute-tor-step-tracker\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li class=\"ute-tor-step-tracker-completed\"><span class=\"ute-tor-step-tracker-number\" ng-bind-html=\"1\"></span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel1\"></span></li><li class=\"ute-tor-step-tracker-completed\"><span class=\"ute-tor-step-tracker-number\" ng-bind-html=\"2\"></span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel2\"></span></li></ul></div></div><div class=\"col-xs-1\"><div class=\"row ute-tor-center-align\"><div class=\"col-xs-6\"><div class=\"ute-tor-step-tracker-wrapper\"><ul class=\"ute-tor-step-tracker-list\"><div class=\"ute-tor-step-tracker-border\"></div></ul></div></div></div></div><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepThree.stepTrackerIndex == 3, \'ute-tor-step-tracker-completed\': stepThree.stepTrackerIndex > 3}\" class=\"ute-tor-step-tracker-inactive\"><span class=\"ute-tor-step-tracker-number\" ng-bind-html=\"3\"></span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></li><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepFour.stepTrackerIndex == 4, \'ute-tor-step-tracker-inactive\' : stepFour.stepTrackerIndex < 3}\"><span class=\"ute-tor-step-tracker-number\" ng-bind-html=\"4\"></span> <span class=\"ute-tor-step-tracker-label margin-top-10\" data-translate=\"ute.tor.stepTracker.stepLabel4\"></span></li></ul></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/transferOfResponsibilityDirective/tor.addAnotherCtn.modal.view.html","<div class=\"ute-modal-dialog\"><div class=\"row\"><div class=\"col-xs-12\" ng-repeat=\"ctn in addAnotherCtnModal.model.ctnList\" ng-show=\"((ctn.isSelected === null || ctn.isSelected === undefined )|| (ctn.isEligible === null || ctn.isEligible === undefined ) && (!ctn.isStatusFailure || ctn.isStatusFailure === undefined))\"><div class=\"ute-tor-container-row-content\"><div class=\"col-xs-10\" style=\"padding-left:0px\"><div class=\"col-xs-12 ute-modal-ctn-row\"><span class=\"col-xs-1 ute-tor-checkbox\"><input type=\"checkbox\" id=\"{{ctn.subscriberNumber}}+\'modal\'\" data-ng-model=\"ctn.isSelected\" data-ng-click=\"addAnotherCtnModal.updateModalSelectedCtnList(ctn)\"> <label for=\"{{ctn.subscriberNumber}}+\'modal\'\" class=\"ute-tor-checkbox-label\"></label></span> <span class=\"col-xs-10\"><span class=\"\" ng-bind=\"ctn.firstName\"></span> <span class=\"\" ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></span></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-4 ute-tor-primary-buttons\"><button data-ng-disabled=\"addAnotherCtnModal.selectedCtnsValue.length==0\" data-ng-click=\"addAnotherCtnModal.addToEligibilityCheck()\" tabindex=\"0\"><span data-translate=\"ute.tor.currentCustomer.addToEligibilityCheck\" class=\"ng-scope\"></span></button></div></div></div><img class=\"ute-tor-modalClose\" data-ng-click=\"addAnotherCtnModal.cancel()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/transferOfResponsibility/transferOfResponsibilityDirective/tor.stepTracker.directive.html","<section class=\"ute-tor-step-tracker\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"row\"><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li data-ng-class=\"(stepTracker.model.stepTrackerIndex == 1) ? \'ute-tor-step-tracker-selected\' : \'ute-tor-step-tracker-completed\'\" class=\"\"><div class=\"ute-tor-step-tracker-number\" style=\"margin-left: 3rem\">1</div><div class=\"ute-tor-step-tracker-label ute-tor-step-tracker-label1\" data-translate=\"ute.tor.stepTracker.stepLabel1\"></div></li><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepTracker.model.stepTrackerIndex == 2, \'ute-tor-step-tracker-completed\': stepTracker.model.stepTrackerIndex > 2}\"><div class=\"ute-tor-step-tracker-number\" style=\"margin-right: 3rem\">2</div><div class=\"ute-tor-step-tracker-label ute-tor-step-tracker-label2\" data-translate=\"ute.tor.stepTracker.stepLabel2\"></div></li></ul></div></div><div class=\"col-xs-1\"><div class=\"row ute-tor-center-align\"><div class=\"col-xs-6\"><div class=\"ute-tor-step-tracker-wrapper\"><ul class=\"ute-tor-step-tracker-list\"><div class=\"ute-tor-step-tracker-border\"></div></ul></div></div></div></div><div class=\"col-xs-5\"><div class=\"ute-tor-step-tracker-wrapper\"><div class=\"ute-tor-step-tracker-strip\"></div><ul class=\"ute-tor-step-tracker-list\"><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepTracker.model.stepTrackerIndex == 3, \'ute-tor-step-tracker-completed\': stepTracker.model.stepTrackerIndex > 3}\" class=\"ute-tor-step-tracker-inactive\"><div class=\"ute-tor-step-tracker-number\" style=\"margin-left: 3rem\">3</div><div class=\"ute-tor-step-tracker-label ute-tor-step-tracker-label3\" data-translate=\"ute.tor.stepTracker.stepLabel3\"></div></li><li ng-class=\"{\'ute-tor-step-tracker-selected\': stepTracker.model.stepTrackerIndex == 4, \'ute-tor-step-tracker-inactive\' : stepTracker.model.stepTrackerIndex < 3}\" class=\"\"><div class=\"ute-tor-step-tracker-number\" style=\"margin-right: 3rem\">4</div><div class=\"ute-tor-step-tracker-label ute-tor-step-tracker-label4\" data-translate=\"ute.tor.stepTracker.stepLabel4\"></div></li></ul></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/transferOfResponsibilityDirective/tor.systemException.modal.view.html","<div class=\"row ute-modal-dialog\"><div class=\"ute-tor-container-row-content\"><div style=\"padding-left: 28px;\"><div class=\"ute-modal-exception-heading\"><div class=\"col-xs-1\"><img class=\"\" src=\"/web/totes/cms/ute/rogers/consumer/oneview/images/deeplink/one-view-warning.png\"></div><div class=\"col-xs-11\"><p><span data-translate=\"ute.tor.systemUnavailable\"></span></p></div></div><div class=\"col-xs-12 ute-modal-exception-body-msg\"><span data-translate=\"ute.tor.systemExceptionMessage\"></span></div><div class=\"col-xs-12 ute-modal-exception-body-msg\"><span data-translate=\"ute.tor.pleaseTryAgainLater\"></span></div><div class=\"col-xs-4 ute-tor-primary-buttons\"><button data-ng-click=\"errorModal.close()\" tabindex=\"0\" aria-disabled=\"false\"><span data-translate=\"ute.tor.close\" class=\"ng-scope\"></span></button></div></div></div></div><img class=\"ute-tor-modalClose\" data-ng-click=\"errorModal.close()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/transferOfResponsibility/transferOfResponsibilitySelection/transferOfResponsibilitySelection.view.html","<section><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"row\"><div class=\"col-xs-12\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span></div><div class=\"col-xs-12 ute-tor-description\"><span data-translate=\"ute.tor.selection.checkForTransferMessage\"></span></div><div class=\"col-xs-12 ute-tor-main-note-container\"><div class=\"ute-tor-note-title\"><span data-translate=\"ute.tor.selection.pleaseNote\"></span></div><ul class=\"ute-tor-notes-list\"><li><span data-translate=\"ute.tor.selection.pleaseNotePoint1\"></span></li><li><span data-translate=\"ute.tor.selection.pleaseNotePoint2\"></span></li><li><span data-translate=\"ute.tor.selection.pleaseNotePoint3\"></span></li></ul></div><div class=\"col-xs-12 ute-tor-select-question\"><span data-translate=\"ute.tor.selection.torQuestion\"></span></div><div class=\"col-xs-12\"><div class=\"col-xs-2 ute-tor-secondary-disable-buttons\" style=\"margin-left:0px\" data-ng-class=\"{\'ute-tor-secondary-disable-buttons\': !torSelection.isCurrentOwnerPemitted, \'ute-tor-secondary-buttons\': torSelection.isCurrentOwnerPemitted}\"><button data-ng-click=\"torSelection.goToCurrentOwner()\" data-ng-disabled=\"!torSelection.isCurrentOwnerPemitted\"><span class=\"overrite-span\" style=\"font-weight: 600;\" translate=\"ute.tor.selection.currentOwner\"></span></button></div><div class=\"col-xs-2 ute-tor-secondary-disable-buttons\" data-ng-class=\"{\'ute-tor-secondary-disable-buttons\': !torSelection.isFutureOwnerPemitted, \'ute-tor-secondary-buttons\': torSelection.isFutureOwnerPemitted}\"><button data-ng-click=\"torSelection.goToFutureOwner()\" data-ng-disabled=\"!torSelection.isFutureOwnerPemitted\"><span class=\"overrite-span\" style=\"font-weight: 600;\" translate=\"ute.tor.selection.futureOwner\"></span></button></div></div></div></div></div></div></section>");
$templateCache.put("module/BFA-PPC/bfaPpcErrors/bfaPpcErrorsModal/bfaPpcErrorsModal.view.html","<section class=\"ute-bfa-ppc-errors-modal-module-ppc-modal\"><img class=\"ute-bfa-ppc-errors-modal-close-icon\" src=\"ute-common-assets/assets/close-icon.png\" ng-click=\"modal.cancel()\"><div class=\"ute-bfa-ppc-errors-modal-h2\">{{title}}</div><p data-ng-bind-html=\"message\"></p><div class=\"contact\" ng-show=\"showLiveChat\"><p><bold-chat-static-button data-cbid=\"boldChatButtonId\" dynamic-div=\"boldChatButtonDiv\" data-chat-button=\"boldChatButton\"></bold-chat-static-button></p><p><img class=\"ute-bfa-ppc-errors-modal-phone-icon\" src=\"images/phone-red-icon.png\"> <span ng-if=\"isSuspendedAccount\">{{\'ute.bfa.ppc.errors.modal.800NumberSuspended\' | translate}}</span> <span ng-if=\"!isSuspendedAccount\">{{\'ute.bfa.ppc.errors.modal.800Number\' | translate}}</span></p></div><div class=\"ute-bfa-ppc-errors-modal-ppc-button-ctn\"><a data-ng-show=\"showCancelBtn\" class=\"ute-bfa-ppc-errors-modal-cancel-button blue\" ng-click=\"modal.cancel()\">{{\'ute.bfa.ppc.errors.modal.cancel\' | translate}}</a> <a data-ng-show=\"showOKBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.ok()\">{{\'ute.bfa.ppc.errors.modal.ok\' | translate}}</a> <a data-ng-show=\"showConfirmBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.confirm()\">{{\'ute.bfa.ppc.errors.modal.confirm\' | translate}}</a> <a data-ng-show=\"showConfirmPlanChangeBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.confirm()\">{{\'ute.bfa.ppc.errors.modal.confirmPlanChange\' | translate}}</a> <a data-ng-show=\"showContinueBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.continue()\">{{\'ute.bfa.ppc.errors.modal.continue\' | translate}}</a> <a data-ng-show=\"showRemoveAddOnBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.removeAddOn()\">{{\'ute.bfa.ppc.errors.modal.removeAddon\' | translate}}</a> <a data-ng-show=\"showGoBackBtn\" class=\"ute-bfa-ppc-errors-modal-modal-button\" ng-click=\"modal.goBack()\">{{\'ute.bfa.ppc.errors.modal.goBack\' | translate}}</a></div></section>");
$templateCache.put("module/captureDealerCode/captureDealerCodeDirective/captureDealerCodeForm/captureDealerCodeForm.partial.html","<div class=\"ute-dealer-code\"><form name=\"captureDealerCodeForm\" ng-submit=\"submit()\" class=\"ute-dealer-code-form\" novalidate=\"\"><div class=\"\"><span ng-show=\"isDealerCodeError\" class=\"ute-dc-error-font\" translate=\"ute.rogers.captureDealerCode.error\"></span></div><div class=\"form-group\"><div class=\"col-xs-7 ute-dc-padding-zero\"><input class=\"ute-dc-text-box\" data-ng-class=\"isDealerCodeError ? \'ute-dc-invalid-border\' : \'\'\" name=\"formDealerCode\" data-ng-change=\"onDealerCodeInputChange()\" type=\"text\" ng-model=\"dealerCode\" placeholder=\"{{dealerCodePlaceholder | translate}}\"> <span ng-show=\"isDealerCodeSuccess\" class=\"ute-dealer-code-inline-checker icon-checked\" style=\"\"></span></div><div class=\"col-xs-4 ute-dc-mlm ute-dc-padding-zero\"><button class=\"ute-dc-cta-round large\" name=\"submit\" type=\"submit\" data-ng-disabled=\"isDealerCodeError\" translate=\"ute.rogers.captureDealerCode.submit\"></button></div></div></form></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeDirective/onBehalfOfDealerCode/onBehalfOfdealerCode.html","<div class=\"ute-dealer-code\"><div class=\"col-xs-12\" ng-hide=\"behalfOfDC.isDealerCodeModalEntered\"><span class=\"ute-dc-widget-loader-inline\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div><div ng-show=\"behalfOfDC.isDealerCodeModalEntered\" class=\"ute-dc-behalf-section\"><div class=\"col-xs-12 ute-dc-behalf\" ng-hide=\"behalfOfDC.isBehalfOfDealerCode\"><div class=\"row ute-dc-mlr\"><div class=\"change-dealer-text col-md-6\"><div class=\"change-text\"><span translate=\"ute.rogers.captureDealerCode.onBehalfDealerCodeOne\"></span> <span class=\"rui-icon-infotip\" ng-click=\"behalfOfDC.toggleToolTip()\"><div class=\"dealer-code-tool-tip\" ng-if=\"behalfOfDC.showToolTip\"><span class=\"tooltip-close-btn\"><img src=\"ute-common-assets/assets/tooltip-close-icon.png\"></span><div class=\"tool-tip-text\"><span translate=\"ute.rogers.captureDealerCode.toolTip\"></span></div></div></span> <span class=\"split-text\" translate=\"ute.rogers.captureDealerCode.onBehalfDealerCodeTwo\"></span></div></div><div class=\"ute-dc-pull-right col-md-6\"><form name=\"captureDealerForm\" ng-submit=\"behalfOfDC.submitBehalfDealerCode()\" class=\"\" novalidate=\"\"><div class=\"\"><span class=\"ute-dc-error-font\" ng-show=\"behalfOfDC.isDealerCodeError\" translate=\"ute.rogers.captureDealerCode.error\"></span></div><div class=\"form-group\"><div class=\"col-xs-11 col-md-7\"><input ng-class=\"{ \'has-error\' : captureDealerForm.formDealerCode.$invalid && !captureDealerForm.formDealerCode.$pristine,\'no-error\' :!captureDealerForm.formDealerCode.$invalid, \'ute-dc-invalid-border\' : behalfOfDC.isDealerCodeError }\" class=\"col-xs-12 ute-dc-text-input\" ng-change=\"behalfOfDC.enableSubmitButton()\" name=\"formDealerCode\" type=\"text\" ng-model=\"behalfOfDC.behalfDealerCode\" placeholder=\"{{\'ute.rogers.captureDealerCode.dealerCode\' | translate}}\"><p ng-show=\"captureDealerForm.formDealerCode.$invalid && !captureDealerForm.formDealerCode.$pristine\" class=\"help-block\">Sree</p></div><div class=\"col-xs-11 ute-dc-button-gap col-md-4\"><button class=\"ute-dc-colored-button\" ng-disabled=\"behalfOfDC.isDealerCodeSubmitted\" ng-class=\"\" name=\"submit\" type=\"submit\"><span translate=\"ute.rogers.captureDealerCode.submit\"></span></button></div></div></form></div></div></div><div class=\"col-xs-12 col-md-12 ute-dc-edit\" ng-show=\"behalfOfDC.isBehalfOfDealerCode\"><div class=\"row ute-dc-mlr\"><div class=\"col-md-4 ute-dc-pdt\"><span translate=\"ute.rogers.captureDealerCode.nowBehalfOfAgent\"></span></div><div class=\"col-md-4 dealer-code-edit\"><span class=\"col-md-6 dealer-code\" ng-bind=\"behalfOfDC.behalfDealerCode\"></span> <span class=\"col-md-6\"><button name=\"edit\" type=\"button\" class=\"ute-dc-edit-btn\" data-ng-click=\"behalfOfDC.edit()\"><span translate=\"ute.rogers.captureDealerCode.edit\"></span></button></span></div><div class=\"col-md-4 behalf-edit-section\"><div class=\"ute-dc-bdl\"><button name=\"useMyCode\" type=\"button\" class=\"ute-dc-colored-button\" data-ng-click=\"behalfOfDC.useMyCode()\"><span translate=\"ute.rogers.captureDealerCode.useMyCode\"></span></button></div></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeDirective/updateDealerCode/updateDealerCode.html","<div ng-show=\"updateDealerCode.isDCModalEntered\"><div class=\"ute-dc-section\"><span class=\"col-xs-1\">|</span> <a class=\"col-xs-11\" href=\"#\" data-ng-click=\"updateDealerCode.openChangeDC()\"><span ng-hide=\"updateDealerCode.updatedDealerCode\" translate=\"ute.rogers.captureDealerCode.noCode\"></span> <span ng-show=\"updateDealerCode.updatedDealerCode\" ng-bind=\"updateDealerCode.updatedDealerCode\"></span></a></div><div data-ng-class=\"updateDealerCode.displayChangeDC ? \'ute-show-change-DC\' : \'ute-hide-change-DC\'\"><div class=\"ute-dc-pull-right\" ng-class=\"updateDealerCode.lang===\'fr\' ? \'ute-dc-container-fr\':\'ute-dc-container\'\"><span class=\"rui-icon-arrow-up\"></span><div class=\"ute-dc-update\"><div class=\"ute-dc-changeDC\"><span translate=\"ute.rogers.captureDealerCode.changeDealerCode\"></span></div><div class=\"\"><ute-capture-dealer-code-form submit=\"updateDealerCode.submit()\" is-dealer-code-error=\"updateDealerCode.isDealerCodeError\" dealer-code=\"updateDealerCode.dealerCode\" on-dealer-code-input-change=\"updateDealerCode.onDealerCodeInputChange()\" dealer-code-placeholder=\"ute.rogers.captureDealerCode.dealerCode\"></ute-capture-dealer-code-form></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeModals/CaptureNacDealerCodeModal/CaptureNacDealerCodeModal.html","<div class=\"ute-dealer-code ml-zero\"><div class=\"ute-dealer-code-modal\"><div class=\"dialog\"><div class=\"container-fluid\"><div class=\"row ute-dc-modal-header\"><div class=\"col-xs-11\"><h4 translate=\"ute.rogers.captureDealerCode.enterYourDealerCode\"></h4></div></div><div class=\"row ute-dc-modal-body ute-dc-nac-modal\"><div class=\"row ute-dc-mbm\"><div data-ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-6\':\'col-xs-7 ute-dc-pdt\'\"><span translate=\"ute.rogers.captureDealerCode.proceedWithSavedDc\"></span></div><div class=\"ute-dc-padding-zero ute-dc-saved-code\" data-ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-6\':\'col-xs-5\'\"><div class=\"ute-dc-pdt\" data-ng-bind=\"nacDCModalController.storedDealerCode\" data-ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-8\':\'col-xs-6\'\"></div><div class=\"ute-dc-pdt\" data-ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-3 ute-dc-pl\':\'ute-dc-pdl col-xs-5\'\" data-ng-click=\"nacDCModalController.onEnter()\"><span class=\"ute-dc-nac-btn\" translate=\"ute.rogers.captureDealerCode.submit\"></span></div></div></div><div class=\"row\"><div class=\"ute-dc-pdt\" data-ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-6\':\'col-xs-7\'\"><span translate=\"ute.rogers.captureDealerCode.onBehalfDealerCode\"></span></div><div class=\"ute-dc-pull-right ute-dc-padding-zero ute-dc-mt\" ng-class=\"nacDCModalController.lang==\'fr\'?\'col-xs-6\':\'col-xs-5\'\"><form name=\"captureDealerCodeForm\" ng-submit=\"nacDCModalController.submit()\" class=\"ute-dealer-code-form\" novalidate=\"\"><div class=\"form-group\"><div class=\"col-xs-7 ute-dc-padding-zero\"><input data-ng-class=\"{\'ute-dc-invalid-border\': nacDCModalController.isDealerCodeError, \'ute-dc-text-box-nac\': nacDCModalController.lang==\'fr\'}\" name=\"formDealerCode\" class=\"ute-dc-text-box ute-dc-nac-placeholder\" data-ng-change=\"nacDCModalController.onDealerCodeInputChange()\" type=\"text\" ng-model=\"nacDCModalController.dealerCode\" placeholder=\"{{\'ute.rogers.captureDealerCode.dealerCode\' | translate}}\"></div><div class=\"col-xs-offset-1 col-xs-4 ute-dc-padding-zero\"><button class=\"ute-dc-cta-round large\" name=\"submit\" type=\"submit\" data-ng-disabled=\"nacDCModalController.isDealerCodeSubmitted || nacDCModalController.isDealerCodeError\" translate=\"ute.rogers.captureDealerCode.submit\"></button></div></div><div class=\"\"><span ng-show=\"nacDCModalController.isDealerCodeError\" class=\"ute-dc-error-font\" translate=\"ute.rogers.captureDealerCode.error\"></span></div></form></div></div></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeModals/captureDealerCodeErrorModal/captureDealerCodeErrorModal.html","<div class=\"ute-dealer-code ml-zero\"><div class=\"ute-dealer-code-modal\"><div class=\"dialog\"><div class=\"container-fluid\"><div class=\"row ute-dc-modal-header\"><div class=\"col-xs-11\"><div class=\"col-xs-1 col-sm-2 col-md-1 ute-dc-padding-zero\"><img src=\"ute-common-assets/assets/warning.png\" ng-hide=\"errorModalController.isNacFlow()\"> <img src=\"/web/totes/cms/images/page-specific/BFA/HUP/images/warning.png\" ng-show=\"errorModalController.isNacFlow()\"></div><div class=\"col-xs-8 ute-dc-padding-zero\"><h4 translate=\"ute.rogers.captureDealerCode.oops\"></h4></div></div><div class=\"ute-dc-close-gray-cross\" ng-click=\"errorModalController.cancel()\" ng-hide=\"errorModalController.isNacFlow()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"row ute-dc-modal-body\"><div class=\"\"><span translate=\"ute.rogers.captureDealerCode.generalError\"></span></div></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeModals/captureDealerCodeModal/captureDealerCodeModal.html","<div class=\"ute-dealer-code ml-zero\"><div class=\"ute-dealer-code-modal\"><div class=\"dialog\"><div class=\"container-fluid\"><div class=\"row ute-dc-modal-header\"><div class=\"col-xs-11\"><h4 translate=\"ute.rogers.captureDealerCode.enterYourDealerCode\"></h4></div><div class=\"ute-dc-close-gray-cross\" ng-click=\"DCModalController.cancel()\" ng-hide=\"DCModalController.isNacFlow()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"row ute-dc-modal-body\"><div class=\"ute-dc-pbm\"><span translate=\"ute.rogers.captureDealerCode.info\"></span><span ng-show=\"DCModalController.isNacFlow()\" translate=\"ute.rogers.captureDealerCode.warningDescription\"></span></div><div class=\"ute-dc-padding-zero\" ng-class=\"DCModalController.lang==\'fr\'?\'col-xs-12\':\'col-xs-8\'\"><ute-capture-dealer-code-form submit=\"DCModalController.submit()\" is-dealer-code-error=\"DCModalController.isDealerCodeError\" dealer-code=\"DCModalController.dealerCode\" is-dealer-code-success=\"DCModalController.isDealerCodeSuccess\" on-dealer-code-input-change=\"DCModalController.onDealerCodeInputChange()\" dealer-code-placeholder=\"ute.rogers.captureDealerCode.enterDealerCode\"></ute-capture-dealer-code-form></div><div class=\"col-xs-12 ute-dc-padding-zero ute-dc-pdt\" ng-if=\"!DCModalController.isNacFlow()\"><input class=\"ute-dc-show-checkbox\" type=\"checkbox\" ng-model=\"doNotShowDCModalAgain\" ng-click=\"DCModalController.showMessage(doNotShowDCModalAgain)\"> <span class=\"showMessageText\" translate=\"ute.rogers.captureDealerCode.messageDoNotDisplayPopUp\"></span></div></div></div></div></div></div>");
$templateCache.put("module/captureDealerCode/captureDealerCodeModals/proceedWithoutDealerCodeModal/proceedWithoutDealerCodeModal.html","<div class=\"ute-dealer-code ml-zero\"><div class=\"oute-dealer-code-modal\"><div class=\"dialog\"><div class=\"container-fluid\"><div class=\"row ute-dc-modal-header\"><div class=\"col-xs-11\"><div class=\"col-xs-1 col-md-1 ute-dc-padding-zero\"><img src=\"ute-common-assets/assets/warning.png\"></div><div class=\"col-xs-8 ute-dc-padding-zero\"><h4 translate=\"ute.rogers.captureDealerCode.oops\"></h4></div></div><div class=\"ute-dc-close-gray-cross\" ng-click=\"withoutDCModalController.cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"row ute-dc-modal-body\"><div class=\"ute-dc-pbm\"><span translate=\"ute.rogers.captureDealerCode.warningDescription\"></span></div><div class=\"row\"><div ng-class=\"withoutDCModalController.lang==\'fr\'?\'col-xs-12\':\'col-xs-7\'\"><ute-capture-dealer-code-form submit=\"withoutDCModalController.submit()\" is-dealer-code-error=\"withoutDCModalController.isDealerCodeError\" dealer-code=\"withoutDCModalController.dealerCode\" on-dealer-code-input-change=\"withoutDCModalController.onDealerCodeInputChange()\" dealer-code-placeholder=\"ute.rogers.captureDealerCode.enterDealerCode\"></ute-capture-dealer-code-form></div><div class=\"\" ng-class=\"withoutDCModalController.lang==\'fr\'?\'col-xs-12 ute-dc-pdt\':\'col-xs-5 ute-dc-padding-zero ute-dc-pdt-more\'\"><h5><a class=\"pointer\" data-ng-click=\"withoutDCModalController.cancel()\"><span translate=\"ute.rogers.captureDealerCode.withOutDealerCode\"></span></a></h5></div></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAccessOff/dataManagerAccountsSummaryDataAccessOff.partial.html","<div class=\"ute-dataManager-accountsSummary-dataAccessOff\"><div class=\"ute-dataManager-accountsSummary-dataAccessOffIcon\"><i class=\"ute-icon-error\"></i></div><div class=\"ute-dataManager-accountsSummary-dataAccessOffCopy\" data-ng-bind-html=\":: \'ute.dataManager.accountsSummary.dataAccessOff.accessOff\' | translate\"></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAddedBar/dataManagerAccountsSummaryDataAddedBar.partial.html","<div class=\"ute-dataManager-accountsSummary-dataAddedBar\" data-ng-style=\"{height: height + \'px\'}\"><div class=\"ute-dataManager-accountsSummary-dataAddedBarCopy\" data-ng-bind-html=\":: \'ute.dataManager.accountsSummary.addedBar.dataAdded\' | translate\"></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAlertAt/dataManagerAccountsSummaryDataAlertAt.partial.html","<div data-ng-class=\"dataAccess ? \'ute-dataManager-accountsSummary-dataAlertAt\' : \'ute-dataManager-accountsSummary-dataAlertAtOff\'\"><div class=\"ute-dataManager-accountsSummary-dataAlertAt-topContainer\"><div class=\"ute-dataManager-accountsSummary-dataAlertAt-checkbox\"><md-checkbox ng-disabled=\"!dataAccess\" data-ng-model=\"dataManagerAccountsSummaryDataAlertAt.useAlert\" data-ng-disabled=\"dataManagerAccountsSummaryDataAlertAt.getSaveAlertCallInProgress()\" data-ng-change=\"dataManagerAccountsSummaryDataAlertAt.useAlertChange()\" aria-label=\"Set Alert\"></md-checkbox></div><div class=\"ute-dataManager-accountsSummary-dataAlertAt-alertAtCopy\" data-ng-bind-html=\":: \'ute.dataManager.accountsSummary.dataAlertAt.alertAt\' | translate\"></div></div><div data-ng-show=\"dataManagerAccountsSummaryDataAlertAt.showSaveButton()\" data-ng-if=\"!dataManagerAccountsSummaryDataAlertAt.isBucketSizeUnavailableUntilNextBillCycle()\" class=\"ute-dataManager-accountsSummary-dataAlertAt-saveButtonContainer\"><md-button class=\"ute-md-primary-button ute-dataManager-accountsSummary-dataAlertAt-saveButton\" data-ng-click=\"dataManagerAccountsSummaryDataAlertAt.saveAlertChange()\">{{:: \'ute.dataManager.accountsSummary.dataAlertAt.saveButton\' | translate}}</md-button></div><div class=\"ute-dataManager-accountsSummary-dataAlertAt-dataValue\"><span data-ng-show=\"dataManagerAccountsSummaryDataAlertAt.showDataValue()\">{{dataAlertAt | ute_common_filter_data_conversion: \'mb\': 1024: (dataAlertAt >= 1024 ? 2 : 0): false: false}}</span> <span class=\"ute-dataManager-accountsSummary-dataAlertAt-negative\" data-ng-show=\"dataManagerAccountsSummaryDataAlertAt.showDashNegativeAlert()\">-</span> <span class=\"ute-dataManager-accountsSummary-dataAlertAt-gb\">{{dataAlertAt | ute_common_filter_data_conversion: \'mb\': 1024 : 0: true: true}}</span></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataAlertBar/dataManagerAccountsSummaryDataAlertBar.partial.html","<div class=\"ute-dataManager-accountsSummary-dataAlertBar\" data-ng-if=\"!dataManagerAccountsSummaryDataAlertBar.isBucketSizeUnavailableUntilNextBillCycle()\"><div class=\"ute-dataManager-accountsSummary-thumb\"><md-button class=\"md-fab md-primary ute-dataManager-accountsSummary-iconButton\" aria-label=\"Use Android\"><div class=\"ute-dataManager-accountsSummary-iconUpContainer\"><i class=\"ute-icon-chevron ute-dataManager-accountsSummary-arrowUp\"></i></div><div class=\"ute-dataManager-accountsSummary-iconDownContainer\"><i class=\"ute-icon-chevron ute-dataManager-accountsSummary-arrowDown\"></i></div><md-icon md-svg-src=\"ute-data-manager/assets/alert.svg\"></md-icon></md-button></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataMeter/dataManagerAccountsSummaryDataMeter.partial.html","<div class=\"ute-dataManager-accountsSummary-dataMeter-container\" data-ng-style=\"{\'height\': primaryHeight + \'px\', \'bottom\': \'0px\'}\"><div class=\"ute-dataManager-accountsSummary-dataMeter\" data-ng-style=\":: {\'bottom\': \'0px\'}\"><div data-ng-repeat=\"tick in uteDataManagerSummaryDataMeter.getDataTicks()\"><ute-data-manager-summary-data-meter-tick data-value=\"{{:: tick}}\" data-tick-height=\"{{uteDataManagerSummaryDataMeter.getTickHeight()}}\" data-top-tick=\":: $first\" data-mid-tick=\":: $middle\" data-meter-color=\"#FFFFFF\" data-bottom-tick=\":: $last\" data-second-tick-value=\"{{:: uteDataManagerSummaryDataMeter.getSecondTickValue()}}\"></ute-data-manager-summary-data-meter-tick></div></div></div><div class=\"ute-dataManager-accountsSummary-dataMeter-container\" data-ng-style=\"{\'height\': secondaryHeight + \'px\', \'bottom\': primaryHeight + \'px\'}\"><div class=\"ute-dataManager-accountsSummary-dataMeter\" data-ng-style=\"{\'bottom\': (primaryHeight * -1) + \'px\'}\"><div data-ng-repeat=\"tick in uteDataManagerSummaryDataMeter.getDataTicks()\"><ute-data-manager-summary-data-meter-tick data-value=\"{{:: tick}}\" data-tick-height=\"{{uteDataManagerSummaryDataMeter.getTickHeight()}}\" data-top-tick=\":: $first\" data-mid-tick=\":: $middle\" data-meter-color=\"#000000\" data-bottom-tick=\":: $last\" data-second-tick-value=\"{{:: uteDataManagerSummaryDataMeter.getSecondTickValue()}}\"></ute-data-manager-summary-data-meter-tick></div></div></div><div class=\"ute-dataManager-accountsSummary-dataMeter-container\" data-ng-style=\"{\'height\': tertiaryHeight + \'px\', \'bottom\': ((primaryHeight * 1) + (secondaryHeight * 1)) + \'px\'}\"><div class=\"ute-dataManager-accountsSummary-dataMeter\" data-ng-style=\"{\'bottom\': (((primaryHeight * 1) + (secondaryHeight * 1)) * -1) + \'px\'}\"><div data-ng-repeat=\"tick in uteDataManagerSummaryDataMeter.getDataTicks()\"><ute-data-manager-summary-data-meter-tick data-value=\"{{:: tick}}\" data-tick-height=\"{{uteDataManagerSummaryDataMeter.getTickHeight()}}\" data-top-tick=\":: $first\" data-mid-tick=\":: $middle\" data-meter-color=\"#F5A544\" data-bottom-tick=\":: $last\" data-second-tick-value=\"{{:: uteDataManagerSummaryDataMeter.getSecondTickValue()}}\"></ute-data-manager-summary-data-meter-tick></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryDataMeter/dataManagerAccountsSummaryDataMeterTick.partial.html","<div class=\"ute-dataManager-accountsSummary-dataMeter-tick\" data-ng-style=\"{height: (topTick ? \'0\' : tickHeight) + \'px\'}\"><div class=\"ute-dataManager-accountsSummary-dataMeterTick-minor\" data-ng-style=\":: uteDataManagerSummaryDataMeterTick.getMinorTickStyle()\"></div><div class=\"ute-dataManager-accountsSummary-dataMeterTick-minor\" data-ng-style=\":: uteDataManagerSummaryDataMeterTick.getMinorTickStyle()\"></div><div class=\"ute-dataManager-accountsSummary-dataMeterTick-minor\" data-ng-style=\":: uteDataManagerSummaryDataMeterTick.getMinorTickStyle()\"></div><div class=\"ute-dataManager-accountsSummary-dataMeterTick-major\" data-ng-style=\":: uteDataManagerSummaryDataMeterTick.getMajorTickStyle()\"></div><div class=\"ute-dataManager-accountsSummary-dataMeter-value\" data-ng-style=\":: uteDataManagerSummaryDataMeterTick.getDataMeterValueStyle()\" data-ng-class=\":: (topTick ? \'ute-dataManager-accountsSummary-dataMeter-topTickValue\' : \'\') || (midTick ? \'ute-dataManager-accountsSummary-dataMeter-midTickValue\' : \'\') || (bottomTick ? \'ute-dataManager-accountsSummary-dataMeter-bottomTickValue\' : \'\')\">{{:: value | ute_common_filter_data_conversion: \'mb\': 1000: (value > 1000 ? 1 : 0): false: false}} {{:: midTick ? \'\' : ( ( topTick ? value : secondTickValue ) | ute_common_filter_data_conversion: \'mb\': 1000: 0: true: true)}}</div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryFooter/dataManagerAccountsSummaryFooter.partial.html","<div class=\"container ute-dataManager-accountsSummaryFooter-container\"><div class=\"row ute-dataManager-accountsSummaryFooter-row\"><div class=\"col-xs-3 ute-dataManager-accountsSummaryFooter-cellBlock\"><md-button class=\"ute-dataManager-accountsSummaryFooter-acctSummaryButton\" data-ng-disabled=\"uteDataManagerAccountsSummaryFooter.summaryMode()\" data-ng-click=\"uteDataManagerAccountsSummaryFooter.footerButtonClick()\" data-ng-class=\"uteDataManagerAccountsSummaryFooter.buttonClass()\"><div class=\"ute-dataManager-accountsSummaryFooter-summaryIcon\"></div><div class=\"ute-dataManager-accountsSummaryFooter-summaryContainer\"><div class=\"ute-dataManager-accountsSummaryFooter-summary\">{{:: \'ute.dataManager.accountsSummary.footer.dataSummary\' | translate}}</div></div></md-button><div class=\"ute-dataManager-accountsSummaryFooter-barRight\"></div></div><div class=\"col-xs-3 ute-dataManager-accountsSummaryFooter-cellBlock\"><span class=\"ute-dataManager-accountsSummaryFooter-valueAmount\">{{:: (uteDataManagerAccountsSummaryFooter.isBucketSizeUnavailableUntilNextBillCycle() ? \'--\' : (uteDataManagerAccountsSummaryFooter.getDataLimit() | ute_common_filter_data_conversion: \'mb\': uteDataManagerAccountsSummaryFooter.getBase(): (uteDataManagerAccountsSummaryFooter.getDataLimit() > uteDataManagerAccountsSummaryFooter.getBase() ? 2 : 0): false: false) )}}</span> <span class=\"ute-dataManager-accountsSummaryFooter-gb\">{{:: uteDataManagerAccountsSummaryFooter.getDataLimit() | ute_common_filter_data_conversion: \'mb\': uteDataManagerAccountsSummaryFooter.getBase(): 0: true: true | translate}}</span><div class=\"ute-dataManager-accountsSummaryFooter-valueLabel\">{{::\'ute.dataManager.accountsSummary.footer.totalPlan\' | translate}}</div></div><div class=\"col-xs-3 ute-dataManager-accountsSummaryFooter-cellBlock\"><span class=\"ute-dataManager-accountsSummaryFooter-valueAmount\">{{:: uteDataManagerAccountsSummaryFooter.getTotalUsedData() | ute_common_filter_data_conversion: \'mb\': uteDataManagerAccountsSummaryFooter.getBase(): (uteDataManagerAccountsSummaryFooter.getTotalUsedData() > uteDataManagerAccountsSummaryFooter.getBase() ? 2 : 0): false: false}}</span> <span class=\"ute-dataManager-accountsSummaryFooter-gb\">{{:: uteDataManagerAccountsSummaryFooter.getTotalUsedData() | ute_common_filter_data_conversion: \'mb\': uteDataManagerAccountsSummaryFooter.getBase(): 0: true: true | translate}}</span><div class=\"ute-dataManager-accountsSummaryFooter-valueLabel\">{{::\'ute.dataManager.accountsSummary.footer.totalUsed\' | translate}}</div></div><div class=\"col-xs-3 ute-dataManager-accountsSummaryFooter-cellBlock\"><span class=\"ute-dataManager-accountsSummaryFooter-valueAmount\">{{uteDataManagerAccountsSummaryFooter.getSavedAlertDataTotal() | ute_common_filter_data_conversion: \'mb\': 1024: (uteDataManagerAccountsSummaryFooter.getSavedAlertDataTotal() >= 1024 ? 2 : 0): false: false}}</span> <span class=\"ute-dataManager-accountsSummaryFooter-gb\">{{uteDataManagerAccountsSummaryFooter.getSavedAlertDataTotal() | ute_common_filter_data_conversion: \'mb\': 1024: 0: true: true | translate}}</span><div class=\"ute-dataManager-accountsSummaryFooter-valueLabel\">{{::\'ute.dataManager.accountsSummary.footer.totalAlerts\' | translate}}</div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryHeader/dataManagerAccountsSummaryHeader.partial.html","<div class=\"ute-dataManager-accountsSummaryHeader-noGutters\" data-ng-if=\"!dataManagerAccountsSummaryHeader.getIsVideoThrottlePermitted()\"><div class=\"ute-dataManager-accountsSummaryHeader-leftContainer\"><md-button class=\"ute-dataManager-accountsSummaryHeader-clickArea\" aria-label=\"Back to shared data usage and alerts\" data-ng-click=\"dataManagerAccountsSummaryHeader.goToDashboard()\"></md-button><i class=\"ute-icon-arrow-right ute-dataManager-accountsSummaryHeader-arrowIcon\"></i><div class=\"ute-dataManager-accountsSummaryHeader-headingContainer\"><div class=\"ute-dataManager-accountsSummaryHeader-heading\">{{:: \'ute.dataManager.accountsSummary.header.title\' | translate}}</div></div></div><div class=\"ute-dataManager-accountsSummaryHeader-increaseContainer\"><ute-data-manager-increase-plan-directive data-id=\"summaryHeader\"></ute-data-manager-increase-plan-directive><div class=\"ute-dataManager-accountsSummaryHeader-increaseCopy\">{{:: \'ute.dataManager.accountsSummary.header.addData\' | translate}}</div><div class=\"ute-data-manager-tooltip-container\" data-ng-if=\"dataManagerAccountsSummaryHeader.isPurchasedCopyVisible()\"><div class=\"ute-data-manager-tooltip-icon\">i</div><div class=\"ute-data-manager-tooltip-content\"><strong>{{ \"ute.dataManager.accountsSummary.header.dataDelayHeader\" | translate }}</strong><br><div>{{ \"ute.dataManager.accountsSummary.header.dataDelayBody\" | translate }}</div></div></div></div><div class=\"ute-dataManager-accountsSummaryHeader-upgradeContainer\"><ute-data-manager-upgrade-plan-directive></ute-data-manager-upgrade-plan-directive><div class=\"ute-dataManager-accountsSummaryHeader-upgradeCopy\">{{:: \'ute.dataManager.accountsSummary.header.upgrade\' | translate}}</div></div><div class=\"ute-datamanager-summary-select-text\">{{dataManagerAccountsSummaryHeader.getSelectYourLineMessageKey() | translate}}</div></div><div class=\"ute-dataManager-accountsSummaryHeader-noGutters\" data-ng-if=\"dataManagerAccountsSummaryHeader.getIsVideoThrottlePermitted()\"><div class=\"row\"><div class=\"col-xs-2\"><md-button class=\"ute-dataManager-accountsSummaryHeader-clickArea\" aria-label=\"Back to shared data usage and alerts\" data-ng-click=\"dataManagerAccountsSummaryHeader.goToDashboard()\" style=\"width: 100%; min-width: 100%; height: 55px;\"><i class=\"ute-icon-arrow-right ute-dataManager-accountsSummaryHeader-arrowIcon\"></i></md-button></div><div class=\"col-xs-10\"><ute-data-manager-accounts-summary-tabs></ute-data-manager-accounts-summary-tabs></div></div><div class=\"row\" data-ng-if=\"dataManagerActiveTabIndex === 0\" data-ng-class=\"dataManagerAccountsSummaryHeader.getIsVideoThrottlePermitted() ? \'ute-dataManager-accountsSummaryHeader-upgradeCopy-video-streaming\':\'\'\"><div class=\"col-xs-12\"><div class=\"ute-dataManager-accountsSummaryHeader-increaseContainer\" style=\"margin-top: -55px;\"><ute-data-manager-increase-plan-directive data-id=\"summaryHeader\"></ute-data-manager-increase-plan-directive><div class=\"ute-dataManager-accountsSummaryHeader-increaseCopy\">{{:: \'ute.dataManager.accountsSummary.header.addData\' | translate}}</div><div class=\"ute-data-manager-tooltip-container\" data-ng-if=\"dataManagerAccountsSummaryHeader.isPurchasedCopyVisible()\"><div class=\"ute-data-manager-tooltip-icon\">i</div><div class=\"ute-data-manager-tooltip-content\"><strong>{{ \"ute.dataManager.accountsSummary.header.dataDelayHeader\" | translate }}</strong><br><div>{{ \"ute.dataManager.accountsSummary.header.dataDelayBody\" | translate }}</div></div></div></div><div class=\"ute-dataManager-accountsSummaryHeader-upgradeContainer\" style=\"margin-top: -55px; margin-right: 0px;\"><ute-data-manager-upgrade-plan-directive></ute-data-manager-upgrade-plan-directive><div class=\"ute-dataManager-accountsSummaryHeader-upgradeCopy\">{{:: \'ute.dataManager.accountsSummary.header.upgrade\' | translate}}</div></div></div></div><div class=\"row\" data-ng-if=\"!dataManagerAccountsSummaryHeader.getIsVideoThrottlePermitted()\"><div class=\"col-xs-12\"><div class=\"ute-datamanager-summary-select-text\">{{dataManagerAccountsSummaryHeader.getSelectYourLineMessageKey() | translate}}</div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryIndividualHeader/dataManagerAccountsSummaryIndividualHeader.partial.html","<div class=\"container ute-dataManager-accountsSummaryIndividualHeader\" data-ng-if=\"!dataManagerAccountsSummaryIndividualHeader.getIsVideoThrottlePermitted()\"><div class=\"row ute-dataManager-accountsSummaryIndividualHeaderRow\"><div class=\"col-xs-6 ute-dataManager-accountsSummaryIndividualHeader-leftCol\"><md-button class=\"ute-dataManager-accountsSummaryIndividualHeader-clickArea\" data-ng-click=\"dataManagerAccountsSummaryIndividualHeader.goToDashboard()\" aria-label=\"Back to shared data summary\"></md-button><div class=\"ute-dataManager-accountsSummaryIndividualHeader-leftContentContainer\"><i class=\"ute-icon-chevron ute-dataManager-accountsSummaryIndividualHeader-chevronIcon\"></i><div class=\"ute-dataManager-accountsSummaryIndividualHeader-colorBlock ute-tab-color-label-mobile\" data-ng-style=\"{ \'background-color\': colorCode}\">&nbsp;</div><div class=\"ute-dataManager-accountsSummaryIndividualHeader-profileCopy ute-dataManager-accountsSummaryIndividualHeader-profileCopy-phase-ii\"><span class=\"ute-dataManager-accountsSummaryIndividualHeader-displayName\"><span class=\"hidden-xs\">{{displayName}}</span> <span class=\"visible-xs\">{{displayName | ute_common_filter_string_limit_to: 9}}</span></span> <span class=\"ute-dataManager-accountsSummaryIndividualHeader-ctn\">{{ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</span></div></div></div><div class=\"col-xs-6 ute-dataManager-accountsSummaryIndividualHeader-rightCol\" ng-show=\"dataManagerAccountsSummaryIndividualHeader.showRightCol(ctn)\"><div class=\"ute-dataManager-accountsSummaryIndividualHeader-md-switch\"><ute-data-manager-data-access-directive data-ctn=\"{{ctn}}\" data-color-code=\"{{colorCode}}\" data-on-copy=\"\" data-off-copy=\"\" data-top-up-target=\"dataAccess\"></ute-data-manager-data-access-directive></div><div class=\"ute-dataManger-accountsSummaryIndividualHeader-dataAccessCopyContainer\"><span class=\"ute-dataManger-accountsSummaryIndividualHeader-dataAccessCopy\" data-ng-bind-html=\"\'ute.dataManager.accountsSummary.individualHeader.data\' | translate\"></span></div></div><div class=\"col-xs-5 ute-dataManager-accountsSummaryIndividualHeader-rightCol-noData\" ng-hide=\"dataManagerAccountsSummaryIndividualHeader.hasDataCTN(ctn)\"><svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 90.5 55.9\"><defs><style>\n            .cls-1 {\n              fill: #fff;\n              fill-rule: evenodd;\n            }\n          </style></defs><title>data-off</title><path class=\"ute-dataManager-accountsSummary-individualHeader-noDataIcon\" d=\"M20.8 21.3a10.9 10.9 0 0 0-5.1-3.9A19.5 19.5 0 0 0 9.6 16.3H0.8V40.7H9.9a16.8 16.8 0 0 0 6.7-1.3 11.3 11.3 0 0 0 7-10.9A11.8 11.8 0 0 0 21.6 21.4ZM15.2 33.9a9.5 9.5 0 0 1-5.8 1.7H6.6V21.3H9.5A9.4 9.4 0 0 1 15.2 23q2.2 1.7 2.2 5.4T15.2 33.9Zm17 1.1h4.6l7.5-7.5L39.6 16.3H33.9L23.6 40.7H30Zm4.4-12.2 2.7 7.4H33.9ZM55.4 16.3H47.6l-0.7 5h3.5Zm11.8 0.2-4.8 4.9h4.2Zm14-0.2H75.5L65.3 40.7h6.4L73.8 35h8.8l2.2 5.7h6.5ZM75.5 30.3l2.8-7.4 2.7 7.4H75.5ZM43.1 40.6l0 0.1h6.5l-2-4.7Zm11 0.1H60v-17l-5.9 5.9v11.1ZM74 0L21.8 52.2l3.7 3.7L77.7 3.7Z\" transform=\"translate(-0.81 -0.01)\"></path></svg></div></div></div><div class=\"container ute-dataManager-accountsSummaryIndividualHeader\" data-ng-if=\"dataManagerAccountsSummaryIndividualHeader.getIsVideoThrottlePermitted()\"><div class=\"row ute-dataManager-accountsSummaryIndividualHeaderRow\"><div class=\"row\"><div class=\"col-xs-2\"><md-button class=\"ute-dataManager-accountsSummaryHeader-clickArea ute-dataManager-accountsSummaryHeader-clickArea-video-streaming\" aria-label=\"Back to shared data usage and alerts\" data-ng-click=\"dataManagerAccountsSummaryIndividualHeader.goToDashboard()\" style=\"width: 100%; min-width: 100%; height: 55px;\"><i class=\"ute-icon-arrow-right ute-dataManager-accountsSummaryHeader-arrowIcon\" style=\"top: 20px !important;\"></i></md-button></div><div class=\"col-xs-10\"><ute-data-manager-accounts-summary-tabs></ute-data-manager-accounts-summary-tabs></div></div><div class=\"row ute-dataManager-alert-tab-view\" data-ng-if=\"dataManagerActiveTabIndex === 0\"><div class=\"col-xs-6 ute-dataManager-accountsSummaryIndividualHeader-leftCol\"><div class=\"ute-dataManager-accountsSummaryIndividualHeader-leftContentContainer\"><div class=\"ute-dataManager-accountsSummaryIndividualHeader-colorBlock\" data-ng-style=\"{ \'background-color\': colorCode}\">&nbsp;</div><div class=\"ute-dataManager-accountsSummaryIndividualHeader-profileCopy\"><span class=\"ute-dataManager-accountsSummaryIndividualHeader-displayName\"><span class=\"hidden-xs\">{{displayName}}</span> <span class=\"visible-xs\">{{displayName | ute_common_filter_string_limit_to: 9}}</span></span> <span class=\"ute-dataManager-accountsSummaryIndividualHeader-ctn\">{{ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</span></div></div></div><div class=\"col-xs-6 ute-dataManager-accountsSummaryIndividualHeader-rightCol\" ng-show=\"dataManagerAccountsSummaryIndividualHeader.showRightCol(ctn)\"><div class=\"ute-dataManager-accountsSummaryIndividualHeader-md-switch\"><ute-data-manager-data-access-directive data-ctn=\"{{ctn}}\" data-color-code=\"{{colorCode}}\" data-on-copy=\"\" data-off-copy=\"\" data-top-up-target=\"dataAccess\"></ute-data-manager-data-access-directive></div><div class=\"ute-dataManger-accountsSummaryIndividualHeader-dataAccessCopyContainer\"><span class=\"ute-dataManger-accountsSummaryIndividualHeader-dataAccessCopy\" data-ng-bind-html=\"\'ute.dataManager.accountsSummary.individualHeader.data\' | translate\"></span></div></div><div class=\"col-xs-5 ute-dataManager-accountsSummaryIndividualHeader-rightCol-noData\" ng-hide=\"dataManagerAccountsSummaryIndividualHeader.hasDataCTN(ctn)\"><svg data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 90.5 55.9\"><defs><style>\n              .cls-1 {\n                fill: #fff;\n                fill-rule: evenodd;\n              }\n            </style></defs><title>data-off</title><path class=\"ute-dataManager-accountsSummary-individualHeader-noDataIcon\" d=\"M20.8 21.3a10.9 10.9 0 0 0-5.1-3.9A19.5 19.5 0 0 0 9.6 16.3H0.8V40.7H9.9a16.8 16.8 0 0 0 6.7-1.3 11.3 11.3 0 0 0 7-10.9A11.8 11.8 0 0 0 21.6 21.4ZM15.2 33.9a9.5 9.5 0 0 1-5.8 1.7H6.6V21.3H9.5A9.4 9.4 0 0 1 15.2 23q2.2 1.7 2.2 5.4T15.2 33.9Zm17 1.1h4.6l7.5-7.5L39.6 16.3H33.9L23.6 40.7H30Zm4.4-12.2 2.7 7.4H33.9ZM55.4 16.3H47.6l-0.7 5h3.5Zm11.8 0.2-4.8 4.9h4.2Zm14-0.2H75.5L65.3 40.7h6.4L73.8 35h8.8l2.2 5.7h6.5ZM75.5 30.3l2.8-7.4 2.7 7.4H75.5ZM43.1 40.6l0 0.1h6.5l-2-4.7Zm11 0.1H60v-17l-5.9 5.9v11.1ZM74 0L21.8 52.2l3.7 3.7L77.7 3.7Z\" transform=\"translate(-0.81 -0.01)\"></path></svg></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryNoDataAlertsSet/dataManagerAccountsSummaryNoDataAlertsSet.partial.html","<div class=\"ute-dataManager-accountsSummary-noDataAlertsSet\"><div class=\"ute-dataManager-accountsSummary-noDataAlertsSet-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" viewbox=\"0 0 194 202\"><path d=\"M162.8 37.5c-17.6-17.6-41-27.3-65.9-27.3 -24.9 0-48.3 9.7-65.9 27.3 -36.3 36.3-36.3 95.4 0 131.7 17.6 17.6 41 27.3 65.9 27.3 24.9 0 48.3-9.7 65.9-27.3C199.2 132.8 199.2 73.8 162.8 37.5zM36.4 153.8c-25.9-31-24.3-77.3 4.8-106.3C56.1 32.6 75.9 24.4 97 24.4c18.7 0 36.4 6.5 50.6 18.3l-21.4 21.3 -11.5 11.5L77.9 64.2c-1.1-0.3-2.3-0.2-3.4 0.3 -1 0.6-1.8 1.5-2.2 2.6 -4.2 13.6-5.7 27.6-4.5 41.5l8.5-8.5c-0.1-8.8 1-17.5 3.2-26.1l28 8.6 -3.2 3.2 -8 8 -6.1 6.1 -5.7 5.7 -1.4 1.4 -5.5 5.5 -0.8 0.8 -14.1 14.1 -13.4 13.4 -4.6 4.6L36.4 153.8zM152.8 159.1c-14.9 14.9-34.7 23.1-55.8 23.1 -18.7 0-36.4-6.5-50.6-18.3l29.3-29.3c0.3 0.1 0.6 0.1 0.8 0.1 0.4 0 0.9-0.1 1.3-0.2l36.6-11.2c12.4-1 17.9 7.3 22.9 16.7 0.6 1.1 1.6 1.9 2.9 2.2 0.3 0.1 0.7 0.1 1 0.1 0.9 0 1.8-0.3 2.6-0.8l11.7-8.2c1.8-1.2 2.4-3.6 1.5-5.5l-9.2-19.7c-1.7-5.8-1.7-11.9 0.1-17.7 0.7-2.3-0.6-4.8-2.9-5.6l-4.3-1.3 -7.1 7.1 4.8 1.5c-0.9 4.8-0.9 9.7 0 14.5L88.4 122l8.8-8.8 0.5-0.5 11-11 3.4-3.4 14.2-14.2 4.8-4.8 26.6-26.6C183.5 83.7 181.9 130 152.8 159.1zM130.7 118.2l10.5-3.2 6.1 13.2 -4.6 3.2C140.2 127 136.4 121.8 130.7 118.2zM62.9 71.5l-21.5-4.8 -1.9 8.7 21.5 4.8L62.9 71.5zM59.6 94.9H36.7v8.9h22.9V94.9zM39.4 123.4l1.9 8.7 3.9-0.9L57 119.5 39.4 123.4z\" fill=\"#7F8183\"></path></svg></div><div class=\"ute-dataManager-accountsSummary-noDataAlertsSet-notAlertsSetCopy\">{{:: \'ute.dataManager.accountsSummary.noDataAlert.noAlerts\' | translate}}</div><div class=\"ute-dataManager-accountsSummary-noDataAlertsSet-bottomContainer\" data-ng-if=\"!dataManagerAccountsSummaryNoDataAlertsSet.isBucketSizeUnavailableUntilNextBillCycle()\"><div class=\"ute-dataManager-accountsSummary-noDataAlertsSet-checkbox\"><md-checkbox data-ng-model=\"dataManagerAccountsSummaryNoDataAlertsSet.useAlert\" data-ng-disabled=\"dataManagerAccountsSummaryNoDataAlertsSet.getSaveAlertCallInProgress()\" data-ng-change=\"dataManagerAccountsSummaryNoDataAlertsSet.useAlertChange()\" aria-label=\"Set Alert\"></md-checkbox></div><div class=\"ute-dataManager-accountsSummary-noDataAlertsSet-turnAlertsOnCopy\">{{:: \'ute.dataManager.accountsSummary.noDataAlert.turnAlertsOn\' | translate}}</div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryNoDataPlan/dataManagerAccountsSummaryNoDataPlan.partial.html","<div class=\"ute-dataManager-accountsSummary-noDataPlan\"><div class=\"ute-dataManager-accountsSummary-noDataPlan-topContainer\"><div class=\"ute-dataManager-accountsSummary-noDataIcon\"><i class=\"ute-icon-error\"></i></div><div class=\"ute-dataManager-accountsSummary-noDataCopy\">{{:: \'ute.dataManager.accountsSummary.noDataPlan.noDataPlan\' | translate}}</div></div><md-button class=\"ute-button-secondary ute-md-secondary-button ute-dataManager-accountsSummary-noDataButton\" aria-label=\"Add Data to Line\" data-ng-click=\"dataManagerAccountsSummaryNoDataPlan.addDataToLine()\">{{:: \'ute.dataManager.accountsSummary.noDataPlan.addData\' | translate}}</md-button></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryOverageBar/dataManagerAccountsSummaryOverageBar.partial.html","<div class=\"ute-dataManager-accountsSummary-overageBar\"><div class=\"ute-dataManager-accountsSummary-overageBarCopy\" data-ng-bind-html=\":: \'ute.dataManager.accountsSummary.overageBar.overUsage\' | translate\"></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryOverageCoverage/dataManagerAccountsSummaryOverageCoverage.partial.html","<div class=\"ute-dataManager-accountsSummary-overageCoverage\" data-ng-style=\"{height: height + \'px\'}\"></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummarySwipeInstructions/dataManagerAccountsSummarySwipe.partial.html","<div class=\"ute-dataManager-accountsSummary-swipe\" data-ng-class=\"fade ? \'ute-dataManager-accountsSummary-swipe-hidden\' : \'ute-dataManager-accountsSummary-swipe-visible\'\"><div class=\"row\"><div class=\"col-xs-2 ute-dataManager-accountsSummary-swipe-leftCaret rui-icon-arrow-left-v2\" data-ng-class=\"fade ? \'ute-dataManager-accountsSummary-swipe-leftArrowOut\' : \'ute-dataManager-accountsSummary-swipe-leftArrowNormal\'\"></div><div class=\"col-xs-8 ute-dataManager-accountsSummary-swipe-topInstructions\" translate=\"ute.dataManager.accountsSummary.swipe.instructions\"></div><div class=\"col-xs-2 ute-dataManager-accountsSummary-swipe-rightCaret rui-icon-chevron-right\" data-ng-class=\"fade ? \'ute-dataManager-accountsSummary-swipe-rightArrowOut\' : \'ute-dataManager-accountsSummary-swipe-rightArrowNormal\'\"></div></div><div class=\"row\"><div class=\"col-xs-12 ute-dataManager-accountsSummary-swipe-bottomInstructions\" translate=\"ute.dataManager.accountsSummary.swipe.instructions2\"></div></div></div>");
$templateCache.put("module/dataManager/dataManagerAccountsSummary/dataManagerAccountsSummaryTabs/dataManagerAccountsSummaryTabs.partial.html","<div class=\"dataManager-summary-tabs-sm\"><a class=\"dataManager-summary-tabs-item\" data-ng-class=\"{\'active\': dataManagerActiveTabIndex === 0}\" data-ng-click=\"dataManagerAccountsSummaryTabs.setDataManagerActiveTabIndex(0)\">{{\'ute.dataManager.accountsSummary.tabs.alerts\'|translate}}</a> <a class=\"dataManager-summary-tabs-item\" data-ng-class=\"{\'active\': dataManagerActiveTabIndex === 1}\" data-ng-click=\"dataManagerAccountsSummaryTabs.setDataManagerActiveTabIndex(1)\"><span data-ng-bind-html=\"\'ute.dataManager.accountsSummary.tabs.videoAndStreaming\' | translate\"></span></a></div>");
$templateCache.put("module/dataManager/dataManagerDataAccess/dataManagerDataAccessModal/dataManagerDataOnOffModal.partial.html","<div class=\"ute-dataManager-dataAccess-dataOnOffModal\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-heading\">{{\'ute.dataManager.dataAccess.modal.heading\' | translate}}</div><div class=\"ute-dataManager-dataAccess-dataOnOffModal-blockInfo\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-colorBlock\" data-ng-style=\"{\'background-color\': dataManagerDataAccessModal.getColorCodeCTN()}\"></div><div class=\"ute-dataManager-dataAccess-dataOnOffModal-idContent\"><span class=\"ute-dataManager-dataAccess-dataOnOffModal-displayName\">{{dataManagerDataAccessModal.getDisplayNameCTN()}}</span><br class=\"hidden-xs\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-ctn\">{{ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</div><br></div></div><div class=\"ute-dataManager-dataAccess-dataOnOffModal-secondaryCopy\">{{\'ute.dataManager.dataAccess.modal.secondaryCopy\' | translate}} <span class=\"ute-dataManager-dataAccess-dataOnOffModal-body\" data-ng-bind=\"\'ute.dataManager.dataAccess.modal.body\' | translate : { displayCTN: dataManagerDataAccessModal.getDisplayNameCTN() }\"></span></div><div class=\"ute-dataManager-dataAccess-dataOnOffModal-optionContainer\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-option\">{{\'ute.dataManager.dataAccess.modal.option\' | translate}}</div><div class=\"row\"><div class=\"col-xs-12 col-sm-5 ute-dataManager-dataAccess-dataOnOffModal-noGutters\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-upgradeContainer\"><ute-data-manager-upgrade-plan-directive></ute-data-manager-upgrade-plan-directive><div class=\"ute-dataManager-dataAccess-dataOnOffModal-upgradeCopyContainer\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-upgradeCopy\">{{\'ute.dataManager.dataAccess.modal.upgrade\' | translate}}</div></div></div></div><div class=\"col-xs-12 col-sm-7 ute-dataManager-dataAccess-dataOnOffModal-noGutters\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-increaseContainer\"><div class=\"ute-dataManager-increasePlan-increaseContainer\"><md-button data-ng-click=\"dataManagerDataAccessModal.addDataClick()\" data-ng-keypress=\"($event.which === 13)?dataManagerDataAccessModal.addDataClick():0\" class=\"md-fab ute-dataManager-usageDial-mdIconButton\" data-ng-disabled=\"!dataManagerDataAccessModal.isAllowedToPurchaseData()\" aria-label=\"Increase Data this month\" tabindex=\"0\"><span class=\"sr-only\">{{\'ute.dataManager.dataAccess.modal.upgrade\' | translate}}</span><md-icon class=\"ute-icon-plus ute-dataManager-usageDial-mdIconButtonIcon ute-dataManager-increasePlan-icon\"></md-icon></md-button></div><div class=\"ute-dataManager-dataAccess-dataOnOffModal-increaseCopyContainer\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-increaseCopy\">{{\'ute.dataManager.dataAccess.modal.increase\' | translate}}</div></div></div></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-dataManager-dataAccess-dataOnOffModal-continueButtonContainer\"><md-button name=\"button_continue\" data-ng-click=\"dataManagerDataAccessModal.continue()\" data-ng-keypress=\"($event.which === 13)?dataManagerDataAccessModal.continue():0\" type=\"button\" class=\"ute-md-primary-button ute-dataManager-dataAccess-dataOnOffModal-continueButton\" tabindex=\"0\"><span translate=\"ute.dataManager.dataAccess.modal.confirmButton\"></span></md-button></div></div></div><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-dataManager-dataAccess-dataOnOffModal-modalClose\" data-ng-click=\"dataManagerDataAccessModal.noSelection()\" data-ng-keypress=\"($event.which === 13)?dataManagerDataAccessModal.noSelection():0\" tabindex=\"0\"></div>");
$templateCache.put("module/dataManager/dataManagerDataControlList/dataManagerDataControl/dataManagerDataControl.partial.html","<div class=\"ute-dataManager-dataControl\"><div class=\"row ute-dataManager-dataControl-midBlock\"><div class=\"col-sm-3 ute-dataManager-dataControl-leftContainer\"><div class=\"ute-dataManager-dataControl-colorBlock\">&nbsp;</div><div class=\"ute-dataManager-dataControl-contact\"><span class=\"ute-dataManager-dataControl-displayName visible-sm\" data-ng-class=\":: dataManagerDataControl.getDisplayNameClass(ctn)\">{{:: displayName | ute_common_filter_string_limit_to: 7}}</span> <span class=\"ute-dataManager-dataControl-displayName hidden-sm\" data-ng-class=\":: dataManagerDataControl.getDisplayNameMediumClass(ctn)\">{{:: displayName | ute_common_filter_string_limit_to: 12}}</span> <span data-ng-class=\":: dataManagerDataControl.getCTNClass(ctn)\" style=\"x-ms-format-detection: none;\">{{:: ctn | ute_common_filter_phone : \'$1 $2-$3\' }}</span><br><div class=\"ute-dataManager-dataControl-manage\" ng-if=\"isAlertsRecipient === \'true\'\">{{:: \'ute.dataManager.dataControl.alertsRecipientChange\' | translate}} <span class=\"ute-dataManager-dataControl-change\" data-ng-click=\"dataManagerDataControl.requestChangeModal()\" data-ng-keydown=\"($event.which === 13)?dataManagerDataControl.requestChangeModal():0\" role=\"link\">{{:: \'ute.dataManager.dataControl.alertsRecipientButton\' | translate}}</span></div><div class=\"ute-dataManager-dataControl-status\"><div ng-if=\"dataManagerDataControl.isAccountSuspended(ctn)\">{{:: \'ute.dataManager.dataControl.suspendedService\' | translate}}</div><div ng-if=\"dataManagerDataControl.isAccountCancelled(ctn)\">{{:: \'ute.dataManager.dataControl.cancelledService\' | translate}}</div><div class=\"ute-dataManager-dataControl-groupStatus\" ng-if=\"dataManagerDataControl.isAccountLeftGroup(ctn)\">{{:: \'ute.dataManager.dataControl.leftGroupStillSharing\' | translate}}<div class=\"ute-dataManager-dataControl-Manage\" data-ng-click=\"dataManagerDataControl.goToWireless(ctn)\" data-ng-bind=\"\'ute.dataManager.dataControl.leftGroup\' | translate : { displayCTN: dataManagerDataControl.getDisplayNameCTN() }\"></div></div><div class=\"ute-dataManager-dataControl-groupStatus\" ng-if=\"dataManagerDataControl.getGroupStatus(ctn) === dataManagerDataControl.getGroupStatusCode().JOINED\">{{:: \'ute.dataManager.dataControl.joinedGroup\' | translate}}<div class=\"ute-dataManager-dataControl-Manage\" data-ng-click=\"dataManagerDataControl.goToWireless(ctn)\" data-ng-bind=\"\'ute.dataManager.dataControl.viewUsage\' | translate : { displayCTN: dataManagerDataControl.getDisplayNameCTN() }\"></div></div></div></div></div><div class=\"col-sm-7 col-sm-push-3 ute-dataManager-dataControl-midSection\" data-ng-class=\":: dataManagerDataControl.getMidSectionClass(ctn)\"><div data-ng-show=\":: hasData === \'true\' && groupStatus !== dataManagerDataControl.getGroupStatusCode().JOINED\"><div data-ng-show=\"dataManagerDataControl.showMidSection(ctn)\"><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"ute-dataManager-dataControl-statusCopy\" data-ng-show=\":: status === dataManagerDataControl.getStatusCode().SUSPENDED\">{{:: \'ute.dataManager.dataControl.cannotSetForSuspended\' | translate}}</div><div class=\"ute-dataManager-dataControl-statusCopy\" data-ng-show=\":: status === dataManagerDataControl.getStatusCode().CANCELLED\">{{:: \'ute.dataManager.dataControl.cannotSetForCancelled\' | translate}}</div></div></div></div><div data-ng-show=\":: dataManagerDataControl.showUpperMidSection(ctn)\"><div class=\"row\"><div class=\"col-xs-1\"><div class=\"ute-dataManager-dataControl-md-switch\" data-ng-show=\"(dataAccess === \'true\')\"><md-switch class=\"dataManagerDataControlEnableAlert\" data-ng-change=\"dataManagerDataControl.setDataUseAlerts()\" data-ng-model=\"useAlert\" data-ng-disabled=\"dataManagerDataControl.getSaveAlertCallInProgress()\" ng-swipe-left=\"dataManagerDataControl.swipeLeft()\" ng-swipe-right=\"dataManagerDataControl.swipeRight()\" role=\"checkbox\" aria-label=\"Toggle Alert\"></md-switch></div></div><div class=\"col-sm-8 col-md-6 col-lg-7 ute-dataManager-dataControl-alert\" data-ng-show=\"dataManagerDataControl.showAlertCopy()\"><div class=\"ute-dataManager-dataControl-alertCopy\">{{:: \'ute.dataManager.dataControl.alertMeWhen\' | translate}}</div></div><div class=\"col-sm-11 col-md-11 col-lg-11 ute-dataManager-dataControl-alert\" data-ng-show=\"dataManagerDataControl.showAlertOffCopy()\"><div class=\"ute-dataManager-dataControl-alertCopy\">{{:: \'ute.dataManager.dataControl.alertsOff\' | translate}}</div></div><div class=\"col-sm-3 col-md-5 col-lg-4 ute-dataManager-dataControl-buttonContainer\"><span data-ng-hide=\":: dataManagerDataControl.isBucketSizeUnavailableUntilNextBillCycle()\"><md-button class=\"ute-md-primary-button ute-dataManager-dataControl-saveButton hidden-sm\" data-ng-click=\"dataManagerDataControl.saveAlertChange()\" data-ng-show=\"dataManagerDataControl.showSaveCheck(dataManagerDataControl.dataAlertAt)\" data-ng-disabled=\"dataManagerDataControl.getSaveAlertCallInProgress()\">{{:: \'ute.dataManager.dataControl.saveButton\' | translate}}</md-button></span><div class=\"ute-dataManager-dataControl-dataAlertInputLabel\" data-ng-show=\"dataManagerDataControl.showInputLabel()\"><span class=\"ute-dataManager-dataControl-input\"><span data-ng-hide=\":: dataManagerDataControl.isBucketSizeUnavailableUntilNextBillCycle()\" role=\"alert\">{{dataManagerDataControl.dataAlertAt | ute_common_filter_data_conversion: \'mb\': 1024 : dataManagerDataControl.getDataAlertPrecisionValue() : true : false}}</span> <span data-ng-show=\":: dataManagerDataControl.isBucketSizeUnavailableUntilNextBillCycle()\">{{dataManagerDataControl.MCPPCAlert() | ute_common_filter_data_conversion: \'mb\': 1024 : dataManagerDataControl.getSavedAlertPrecisionValue() : true : false}}</span></span></div></div><div class=\"row\"><div class=\"col-sm-3 col-push-sm visible-sm\"><span data-ng-hide=\":: dataManagerDataControl.isBucketSizeUnavailableUntilNextBillCycle()\"><md-button class=\"ute-md-primary-button ute-dataManager-dataControl-saveButtonSm\" data-ng-click=\"dataManagerDataControl.saveAlertChange()\" ng-if=\"dataManagerDataControl.showSaveCheck(dataManagerDataControl.dataAlertAt)\" data-ng-disabled=\"dataManagerDataControl.getSaveAlertCallInProgress()\">{{:: \'ute.dataManager.dataControl.saveButton\' | translate}}</md-button></span></div></div></div><div class=\"col-sm-10 col-md-10 col-lg-10 ute-dataManager-dataControl-alert\"><div class=\"ute-dataManager-dataControl-dataDisabledCopy\" data-ng-show=\"dataManagerDataControl.showDisabledCopy()\" data-ng-bind-html=\":: \'ute.dataManager.dataControl.dataDisabled\' | translate\"></div></div></div><div class=\"row ute-dataManager-dataControl-tabFocus\"><div class=\"col-sm-10 col-sm-push-1 ute-dataManager-dataControl-noGutters\"><div class=\"ute-dataManager-dataControl-md-sliderContainer\" data-ng-hide=\":: dataManagerDataControl.isBucketSizeUnavailableUntilNextBillCycle()\"><div class=\"ute-dataManager-dataControl-md-slider\" data-ng-class=\":: dataManagerDataControl.getSliderClass()\"><div class=\"ute-dataManager-dataControl-md-slider-leftIndicator\">&nbsp;</div><div class=\"ute-dataManager-dataControl-md-slider-rightIndicator\">&nbsp;</div><div class=\"ute-dataManager-dataControl-dataIndicator\" data-ng-class=\"dataManagerDataControl.getDataIndicatorClasses()\" data-ng-style=\"dataManagerDataControl.getDataIndicatorStyles()\">{{:: dataUsed | ute_common_filter_data_conversion: \'mb\': dataManagerDataControl.getDataUsedBase(): dataManagerDataControl.getDataUsedPrecisionValue(): true: false | translate}}</div><md-slider tabindex=\"-1\" flex=\"\" min=\"0\" max=\"{{:: dataManagerDataControl.getTotalDataLimit()}}\" data-ng-disabled=\"dataManagerDataControl.isSliderDisabled()\" data-ng-change=\"dataManagerDataControl.changeDisplayAlertedAmount()\" ng-model=\"dataManagerDataControl.dataAlertAt\" step=\"{{:: dataManagerDataControl.getSliderStep()}}\" aria-label=\"Alotted Data Slider\" class=\"dataManagerDataControlDataSlider ute-dataManager-dataControl-dataSlider\"></md-slider></div><div class=\"ute-dataManager-dataControl-leftIndicator\">0{{:: \'ute.dataManager.dataControl.space\' | translate}}{{:: dataLimit | ute_common_filter_data_conversion: \'mb\': dataManagerDataControl.getDataLimitBase(): 0: true: true | translate}}</div><div class=\"ute-dataManager-dataControl-rightIndicator\">{{:: dataManagerDataControl.getTotalDataLimit() | ute_common_filter_data_conversion: \'mb\': dataManagerDataControl.getDataLimitBase() : dataManagerDataControl.getDataLimitPrecision(): true: false | translate}}</div></div></div></div></div></div><div class=\"col-sm-2 col-md-2 col-lg-2 ute-dataManager-dataControl-dataAccessSwitchContainer\"><div ng-show=\":: (hasData === \'true\') && (status !== dataManagerDataControl.getStatusCode().SUSPENDED) && (groupStatus !== dataManagerDataControl.getGroupStatusCode().JOINED) && (status !== dataManagerDataControl.getStatusCode().CANCELLED)\"><ute-data-manager-data-access-directive data-ctn=\"{{:: ctn}}\" data-color-code=\"#4c4c4c\" data-on-copy=\"ute.dataManager.dataAccess.on\" data-off-copy=\"ute.dataManager.dataAccess.off\" data-top-up-target=\"usageDial\"></ute-data-manager-data-access-directive></div><div ng-show=\":: !(hasData === \'true\') && (status !== dataManagerDataControl.getStatusCode().SUSPENDED) && (groupStatus !== dataManagerDataControl.getGroupStatusCode().JOINED) && (status !== dataManagerDataControl.getStatusCode().CANCELLED)\"><div class=\"ute-dataManager-dataControl-noDataContainer\"><span class=\"ute-dataManager-dataControl-noData\">{{::\'ute.dataManager.dataControl.noData\' | translate}}</span><md-button class=\"ute-button-secondary ute-md-secondary-button ute-dataManager-dataControl-addLineButton\" aria-label=\"Add Data to Line\" data-ng-click=\"dataManagerDataControl.addDataToLine(ctn)\">{{:: \'ute.dataManager.dataControl.addData\' | translate}} <span class=\"hidden-sm hidden-md\">{{:: \'ute.dataManager.dataControl.toLine\' | translate}}</span></md-button></div></div><div ng-if=\"false\" ng-show=\":: dataManagerDataControl.isAccountJoined(ctn)\"><div class=\"ute-dataManager-dataControl-noDataContainer\"><span class=\"ute-dataManager-dataControl-notSharing\">{{:: \'ute.dataManager.dataControl.notSharing\' | translate}}</span></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerDataControlTagList/dataManagerDataControlTag/dataManagerDataControlTag.view.html","<div class=\"ute-dataManager-dataControlTag-container\" data-ng-style=\":: {\'border-top-color\': colorCode}\"><div class=\"ute-dataManager-dataControlTag-row\"><div class=\"col-xs-6 ute-dataManager-dataControlTag-leftCol\"><div class=\"ute-dataManager-dataControlTag-displayName\" data-ng-class=\":: dataManagerDataControlTag.getDisplayNameClass(ctn)\" data-ng-style=\":: {\'color\': colorCode}\">{{displayName | ute_common_filter_string_limit_to: 17}}</div><span class=\"ute-dataManager-dataControlTag-alert\" data-ng-show=\"isAlertsRecipient === \'true\'\" data-ng-style=\":: {\'color\': colorCode}\" data-ng-class=\":: dataManagerDataControlTag.getAlertClass(ctn)\">{{:: \'ute.dataManager.dataControlTag.alertsRecipientChange\' | translate}} <span class=\"ute-dataManager-dataControlTag-change\" data-ng-click=\"dataManagerDataControlTag.requestChangeModal()\">{{:: \'ute.dataManager.dataControlTag.alertsRecipientButton\' | translate}}</span></span><div class=\"ute-dataManager-dataControlTag-ctn\" data-ng-class=\":: dataManagerDataControlTag.getCTNClass(ctn)\">{{:: ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</div><div class=\"ute-dataManager-dataControlTag-status-leftGroup\" ng-show=\":: dataManagerDataControlTag.isAccountLeftGroup(ctn)\">{{:: \'ute.dataManager.dataControlTag.leftGroupStillSharing\' | translate}}</div><div class=\"ute-dataManager-dataControlTag-status-joinedGroup\" ng-show=\":: dataManagerDataControlTag.isAccountJoined(ctn)\" data-ng-class=\":: dataManagerDataControlTag.getJoinedGroupClass(ctn)\">{{:: \'ute.dataManager.dataControlTag.joinedGroupNotSharing\' | translate}}</div><div class=\"ute-dataManager-dataControlTag-bottomContainer\" data-ng-class=\":: dataManagerDataControlTag.getBottomContainerClass(ctn)\"><span class=\"ute-dataManager-dataControlTag-dataUsed\">{{:: dataUsed | ute_common_filter_data_conversion: \'mb\': dataManagerDataControlTag.getBase(): dataManagerDataControlTag.getDataUsedPrecision(): true: false | translate}} {{:: \'ute.dataManager.dataControlTag.dataUsed\' | translate}} /</span> <span class=\"ute-dataManager-dataControlTag-dataAlert\" data-ng-show=\"dataAccess === \'true\'\">{{dataManagerDataControlTag.getDataAlertsOpen()}} {{:: \'ute.dataManager.dataControlTag.alertAt\' | translate}} &nbsp;<div class=\"ute-dataManager-dataControlTag-dataAlertUsage\" data-ng-show=\"(dataAlertAt >= 0)\">{{:: (dataAlertAt < 0 ? 0 : dataAlertAt) | ute_common_filter_data_conversion: \'mb\': dataManagerDataControlTag.getBase(): dataManagerDataControlTag.getDataAlertAtPrecision(): true: false | translate}}</div><div class=\"ute-dataManager-dataControlTag-dataAlertUsage\" data-ng-show=\"(dataAlertAt < 0)\">&#126; <span class=\"ute-dataManager-dataControlTag-dataAlertTilda\">{{::dataAlertAt|ute_common_filter_data_conversion: \'mb\': dataManagerDataControlTag.getBase(): dataManagerDataControlTag.getDataAlertAtPrecision(): true: true |translate}}</span></div></span> <span class=\"ute-dataManager-dataControlTag-dataAlertOff\" data-ng-show=\"dataAccess === \'false\'\">{{:: \'ute.dataManager.dataControlTag.dataAccessOff\' | translate}}</span></div></div><div class=\"col-xs-6 ute-dataManager-dataControlTag-rightCol\"><div data-ng-class=\":: dataManagerDataControlTag.getClickAreaClass(ctn)\"></div><md-button class=\"ute-dataManager-dataControlTag-clickArea\" aria-label=\"{{:: displayName}}\" ng-show=\":: buttonMode === \'true\'\" data-ng-disabled=\":: (dataManagerDataControlTag.isAccountCancelled(ctn) || dataManagerDataControlTag.isIndividualSuspended(ctn) || dataManagerDataControlTag.isAccountLeftGroup(ctn))\" data-ng-click=\"dataManagerDataControlTag.goToIndividualSummary(ctn)\"></md-button><div class=\"ute-dataManager-dataControlTag-status-suspended\" ng-show=\":: dataManagerDataControlTag.isAccountSuspended(ctn) && dataManagerDataControlTag.isAccountActiveInGroup(ctn)\">{{::\'ute.dataManager.dataControlTag.suspendedService\' | translate}}</div><div class=\"ute-dataManager-dataControlTag-status-cancelled\" ng-show=\":: dataManagerDataControlTag.isAccountCancelled(ctn) && dataManagerDataControlTag.isAccountActiveInGroup(ctn)\">{{::\'ute.dataManager.dataControlTag.cancelledService\' | translate}}</div><div data-ng-class=\"dataManagerDataControlTag.isAccountActiveInGroup(ctn) ? dataManagerDataControlTag.getTagIconClass(ctn) : \'ute-dataManager-dataControlTag-tagIcon-leftGroup\'\" data-ng-show=\":: !dataManagerDataControlTag.isAccountCancelled(ctn)\" ng-switch=\"dataManagerDataControlTag.getTagIcon()\"></div><div class=\"ute-dataManager-dataControlTag-groupStatus-joinedGroup\" data-ng-show=\":: dataManagerDataControlTag.isAccountJoined(ctn)\" ng-click=\"dataManagerDataControlTag.goToWireless(ctn)\" data-ng-bind=\"\'ute.dataManager.dataControlTag.joinedGroup\' | translate : { displayCTN: dataManagerDataControlTag.getDisplayNameCTN() }\"></div><i data-ng-show=\":: dataManagerDataControlTag.isAccountJoined(ctn)\" class=\"ute-icon-chevron ute-dataManager-dataControlTag-chevron-joinedGroup\" ng-show=\":: buttonMode === \'true\'\"></i><div class=\"ute-dataManager-dataControlTag-groupStatus-leftGroup\" data-ng-show=\":: dataManagerDataControlTag.isAccountLeftGroup(ctn)\" ng-click=\"dataManagerDataControlTag.goToWireless(ctn)\" data-ng-bind=\"\'ute.dataManager.dataControlTag.leftGroup\' | translate : { displayCTN: dataManagerDataControlTag.getDisplayNameCTN() }\"></div><i class=\"ute-icon-chevron ute-dataManager-dataControlTag-chevron-leftGroup\" ng-show=\":: buttonMode === \'true\' && !dataManagerDataControlTag.isAccountCancelled(ctn) && dataManagerDataControlTag.isAccountLeftGroup(ctn)\"></i> <i class=\"ute-icon-chevron\" data-ng-style=\":: {\'color\': colorCode}\" data-ng-class=\"dataManagerDataControlTag.getChevronIconClass(ctn)\" ng-show=\":: dataManagerDataControlTag.showChevronIcon(ctn) && dataManagerDataControlTag.isAccountActiveInGroup(ctn)\"></i></div><div style=\"clear:both;\"></div></div><div class=\"row\"><div class=\"ute-dataManager-dataControlTag-alert-section col-xs-12\"><div data-ng-style=\":: {\'color\': colorCode}\" class=\"ute-dataManager-dataControlTag-data\"><span>{{ dataManagerDataControlTag.getLabelCopy(\'data\')| translate}}</span> <span ng-if=\"::dataAccess === \'true\'\">{{ dataManagerDataControlTag.getLabelCopy(\'on\')| translate}}</span> <span ng-if=\"::dataAccess === \'false\'\">{{ dataManagerDataControlTag.getLabelCopy(\'off\')| translate}}</span></div><div data-ng-style=\":: {\'color\': colorCode}\" class=\"ute-dataManager-dataControlTag-alerts\"><span>{{ dataManagerDataControlTag.getLabelCopy(\'alerts\')| translate}}</span> <span ng-if=\"::dataAccess === \'true\' && (dataAlertAt >= 0)\">{{ dataManagerDataControlTag.getLabelCopy(\'on\')| translate}}</span> <span ng-if=\"::dataAccess === \'false\' || (dataAlertAt < 0)\">{{ dataManagerDataControlTag.getLabelCopy(\'off\')| translate}}</span><div data-ng-style=\":: {\'color\': colorCode}\" data-ng-class=\"dataManagerDataControlTag.getIsVideoThrottlePermitted() ? \'\':\'ng-hide\'\" class=\"ute-dataManager-dataControlTag-video\"><span>{{ \'ute.dataManager.dataControlTag.video\'| translate}}</span> <span ng-if=\"::videoQualityReduced === \'true\'\">{{ \'ute.dataManager.dataControlTag.videoSD\'| translate}}</span> <span ng-if=\"::videoQualityReduced === \'false\'\">{{ \'ute.dataManager.dataControlTag.videoHD\'| translate}}</span></div></div><div class=\"ute-dataManager-dataControlTag-manage-link\" data-ng-style=\":: {\'background\': colorCode}\" ng-click=\"dataManagerDataControlTag.goToManageAlerts(0)\"><span translate=\"ute.dataManager.dataAlerts.manageAlerts\"></span> <i class=\"rui-icon-arrow-right\"></i></div></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-dataManager-dataControlTag-links-container visible-xs\"><div class=\"ute-dataManager-dataControlTag-key-link\" ng-click=\"dataManagerDataControlTag.goToIndividualSummary(ctn, \'rogers-plan\')\">{{ dataManagerDataControlTag.getLabelCopy(\'rogersPlan\')| translate}}</div><div class=\"ute-dataManager-dataControlTag-key-link\" ng-click=\"dataManagerDataControlTag.goToIndividualSummary(ctn, \'rogers-device\')\">{{ dataManagerDataControlTag.getLabelCopy(\'yourDevice\')| translate}}</div><div class=\"ute-dataManager-dataControlTag-key-link\" ng-click=\"dataManagerDataControlTag.goToIndividualSummary(ctn, \'rogers-support\')\">{{ dataManagerDataControlTag.getLabelCopy(\'support\')| translate}}</div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerIncreasePlan/dataManagerIncreasePlanModal/dataManagerIncreasePlanModal.partial.html","<div class=\"ute-dataManager-increasePlanModal\"><div data-ng-if=\"!dataManagerIncreasePlanDirectiveModal.showWcocConsent\"><div class=\"ute-dataManager-increasePlanModal-topSpacer\" ng-bind-html=\":: \'ute.dataManager.increasePlanModal.increaseData\' | translate\"></div><div class=\"ute-dataManager-increasePlanModal-firstBody\" data-ng-bind-html=\":: \'ute.dataManager.increasePlanModal.firstBody\' | translate\"></div></div></div><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-dataManager-increasePlanModal-modalClose\" data-ng-click=\"dataManagerIncreasePlanDirectiveModal.noSelection()\">");
$templateCache.put("module/dataManager/dataManagerModals/dataManagerAlertsRecipientModal/dataManagerAlertsRecipientModal.partial.html","<div class=\"ute-dataManager-alertsRecipientModal-heading\">{{\'ute.dataManager.alertRecipientModal.setData\' | translate}}</div><div class=\"ute-dataManager-alertsRecipientModal-secondary\">{{\'ute.dataManager.alertRecipientModal.description\' | translate}}</div><div class=\"ute-dataManager-alertsRecipientModal-selectContainer\"><md-input-container><md-select class=\"ute-dataManager-alertsRecipientModal-select\" md-container-class=\"ute-dataManager-alertsRecipientModal-selectMenu\" data-ng-model=\"dataManagerAlertsRecipientModal.selectedCTN\" placeholder=\"{{dataManagerAlertsRecipientModal.getDefaultDisplayCTN()}}\" data-ng-disabled=\"dataManagerAlertsRecipientModal.getSetDataManagerCallInProgress()\" adl-event-track=\'{\"isModalPopup\":true,\"pageView\":true,\"mappingKey\":\"set-recipient,event.selfServeStart\"}\'><md-option value=\"-1\" disabled=\"\">{{\'ute.dataManager.alertRecipientModal.selectOne\' | translate}}</md-option><md-option ng-repeat=\"line in dataManagerAlertsRecipientModal.getDataControlList()\" ng-default=\"dataManagerAlertsRecipientModal.selectedIndex === $index\" data-ng-disabled=\"!line.isAllowedToBeDataManager\" value=\"{{line.ctn}}\" label=\"{{dataManagerAlertsRecipientModal.getDataManagerOptionLabel(line)}}\">{{dataManagerAlertsRecipientModal.getDataManagerOptionLabel(line)}}</md-option></md-select></md-input-container></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-dataManager-alertsRecipientModal-continueButtonContainer\"><md-button data-ng-click=\"dataManagerAlertsRecipientModal.continueVerified(dataManagerAlertsRecipientModal.selectedCTN)\" type=\"button\" data-ng-disabled=\"dataManagerAlertsRecipientModal.getSetDataManagerCallInProgress()\" class=\"ute-md-primary-button ute-dataManager-alertsRecipientModal-continueButton\" aria-label=\"{{dataManagerAlertsRecipientModal.continueBtnText}}\" title=\"{{dataManagerAlertsRecipientModal.continueBtnText}}\" name=\"button_continue\"><span translate=\"ute.dataManager.alertRecipientModal.continueButton\"></span></md-button></div></div></div><img class=\"ute-dataManager-modals-alertsRecipientModal-modalClose\" data-ng-click=\"dataManagerAlertsRecipientModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/dataManager/dataManagerModals/dataManagerGenericModal/dataManagerGenericModal.partial.html","<div class=\"ute-dataManager-genericModal-container\"><i class=\"ute-dataManager-genericModal-icon ute-icon-error\"></i><div class=\"ute-dataManager-genericModal-heading\">{{params.primary | translate}}</div><div class=\"ute-dataManager-genericModal-secondary\" data-ng-bind-html=\"params.secondary | translate\"></div><div class=\"ute-dataManager-genericModal-ButtonGroup\"><md-button name=\"button_continue\" data-ng-click=\"dataManagerGenericModal.continue()\" type=\"button\" class=\"ute-md-primary-button ute-dataManager-genericModal-continueButton\"><span>{{ dataManagerGenericModal.getOkButtonCopy() | translate }}</span></md-button></div></div><img class=\"ute-dataManager-genericModal-modalClose\" data-ng-click=\"dataManagerGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/dataManager/dataManagerModals/dataManagerGenericModal/dataManagerGenericModalNoIcon.partial.html","<div class=\"ute-dataManager-genericModal-container\"><div class=\"ute-dataManager-genericModal-heading-noMargin\">{{params.primary | translate}}</div><div class=\"ute-dataManager-genericModal-secondary\">{{params.secondary | translate}}</div><div class=\"ute-dataManager-genericModal-ButtonGroup\"><md-button name=\"button_continue\" data-ng-click=\"dataManagerGenericModal.continue()\" type=\"button\" class=\"ute-md-primary-button ute-dataManager-genericModal-continueButton\"><span translate=\"ute.dataManager.genericModal.button\"></span></md-button></div></div><img class=\"ute-dataManager-genericModal-modalClose\" data-ng-click=\"dataManagerGenericModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/dataManager/dataManagerModals/dataManagerModalAlertsOverDataLimit/dataManagerModalAlertsOverDataLimit.partial.html","<div class=\"ute-dataManager-modals-alertsOverDataLimit-heading\">{{\'ute.dataManager.modals.alertsOverDataLimit.heading\' | translate}}</div><div class=\"ute-dataManager-modals-alertsOverDataLimit-firstBody\" data-ng-bind-html=\"\'ute.dataManager.modals.alertsOverDataLimit.firstBody\' | translate\"></div><div class=\"ute-dataManager-modals-alertsOverDataLimit-secondBody\" data-ng-bind-html=\"\'ute.dataManager.modals.alertsOverDataLimit.secondBody\' | translate\"></div><div class=\"ute-dataManager-modals-alertsOverDataLimit-thirdBody\" data-ng-bind-html=\"\'ute.dataManager.modals.alertsOverDataLimit.thirdBody\' | translate\"></div><div class=\"ute-dataManager-modals-alertsOverDataLimit-ButtonGroup\"><md-button name=\"button_continue\" data-ng-click=\"dataManagerAlertsOverDataLimitModal.continue()\" type=\"button\" class=\"ute-md-primary-button ute-dataManager-modals-alertsOverDataLimit-continueButton\"><span translate=\"ute.dataManager.modals.alertsOverDataLimit.button\"></span></md-button></div><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-dataManager-modals-alertsOverDataLimit-modalClose\" data-ng-click=\"dataManagerAlertsOverDataLimitModal.noSelection()\">");
$templateCache.put("module/dataManager/dataManagerModals/dataManagerVideoThrottleModal/dataManagerVideoThrottleModal.partial.html","<div class=\"ute-dataManager-videoThrottle-dataOnOffModal\"><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-heading\">{{\'ute.dataManager.videoThrottle.modal.heading\' | translate}}</div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-blockInfo\"><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-colorBlock\" data-ng-style=\"{\'background-color\': dataManagerVideoThrottleModal.getColorCodeCTN()}\"></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-idContent\"><span class=\"ute-dataManager-videoThrottle-dataOnOffModal-displayName\">{{dataManagerVideoThrottleModal.getDisplayNameCTN()}}</span><br class=\"hidden-xs\"><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-ctn\">{{ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</div><br></div></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-secondaryCopy\"><span data-ng-bind-html=\"\'ute.dataManager.videoThrottle.modal.secondaryCopy\' | translate\"></span></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-body\" data-ng-bind=\"\'ute.dataManager.videoThrottle.modal.body\' | translate : { displayCTN: dataManagerVideoThrottleModal.getDisplayNameCTN() }\"></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-note\">{{\'ute.dataManager.videoThrottle.modal.note\' | translate}} <span class=\"ute-dataManager-videoThrottle-modal-link hidden-sm hidden-md hidden-lg\"><a href=\"http://www.rogers.com/web/support/wireless/data-usage/9098?setLanguage={{currentLanguage}}\" target=\"_blank\">{{\'ute.dataManager.videoThrottle.modal.link\' | translate}}</a></span></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-link hidden-xs\"><a href=\"http://www.rogers.com/web/support/wireless/data-usage/9098?setLanguage={{currentLanguage}}\" target=\"_blank\">{{\'ute.dataManager.videoThrottle.modal.link\' | translate}}</a></div><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-vtr-doNotShowModal ute-dataManager-videoThrottle-dataOnOffModal-vtr-rememberMe\"><span data-test-id=\"myr-singin-doNotShowModal\" class=\"vtr-checkbox\" tabindex=\"0\"><input data-ng-model=\"dataManagerVideoThrottleModal.doNotShowModal\" type=\"checkbox\" name=\"doNotShowModal\" id=\"doNotShowModal\" class=\"vtr-checkbox-input ng-pristine ng-untouched ng-valid\" tabindex=\"0\" aria-checked=\"false\" aria-invalid=\"false\"> <label for=\"doNotShowModal\" class=\"vtr-checkbox-box\"></label></span> <span class=\"myr-checkbox-text\">{{\'ute.dataManager.videoThrottle.modal.confirmationLabel\' | translate}}</span></div><div><div class=\"col-xs-12\"><div class=\"ute-dataManager-videoThrottle-dataOnOffModal-continueButtonContainer\"><md-button name=\"button_continue\" data-ng-click=\"dataManagerVideoThrottleModal.continue()\" type=\"button\" class=\"ute-md-primary-button ute-dataManager-videoThrottle-dataOnOffModal-continueButton\"><span translate=\"ute.dataManager.videoThrottle.modal.confirmButton\"></span></md-button></div></div></div><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-dataManager-videoThrottle-dataOnOffModal-modalClose\" data-ng-click=\"dataManagerVideoThrottleModal.noSelection()\"></div>");
$templateCache.put("module/dataManager/dataManagerUpgradePlan/modals/captureDealerCodeModal.html","<div class=\"totes-project ml-zero\"><div class=\"oneview-dealerCode\"><div class=\"dialog\"><div class=\"row dealer-code-modal-header\"><div class=\"col-xs-11\"><h5 res=\"dealer-code_your_enter\"></h5></div><div class=\"close-gray-cross\" ng-click=\"cancel()\"><img src=\"ute-common-assets/assets/cross-grey.png\" role=\"button\"></div></div><div class=\"dealer-code-modal-body\"><div class=\"row mbm\"><div class=\"pbm\"><span res=\"dealer-code_info\"></span></div></div><div class=\"row\"><div class=\"pull-right\" ng-class=\"lang==\'fr\'?\'col-xs-12\':\'col-xs-8\'\"><dealer-code-form></dealer-code-form></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerUpgradePlan/modals/deepLinkModal.html","<div class=\"totes-project deep-link-modal\"><div ng-if=\"!isChangeVoicemailPassword\" class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row mbm\"><h4 class=\"link-account-title\"><span res=\"moving_to_ssp\"></span></h4><div class=\"prepaid-body-section\"><div ng-if=\"isChangePhoneNumber\"><span res=\"change_phone_number_desc\"></span></div><div ng-if=\"isChangeSim\"><span res=\"change_sim_desc\"></span></div><div ng-if=\"isChangePlan\"><span res=\"change_plan_desc\"></span></div><div ng-if=\"isManageAddon\"><span res=\"manage_addon_desc\"></span></div><div ng-if=\"isUpgradeDevice\"><span res=\"upgrade_device_desc\"></span></div><div ng-if=\"isAddaLineIndividual\"><span res=\"add_a_line_desc\"></span></div><div ng-if=\"isAddaLineShared\"><span res=\"add_a_line_desc\"></span></div><div ng-if=\"isHupCancellation\"><span res=\"hup_cancellation_desc\"></span></div><div ng-if=\"isGetWireless\"><span res=\"get_wireless_desc\"></span></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"dontShowGoToSSPMsgAgain\" ng-click=\"setShowMessage(dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" res=\"message_do_not_display_ssp_popup\"></span></div></div></div><div class=\"ngdialog-buttons mbm\"><div class=\"row\"><div class=\"pull-right\"><a name=\"cancel\" ng-click=\"cancel()\" class=\"link-cancel pull-left pointer cancel-btn-modal\"><span res=\"_cancel\">Cancel</span></a> <button name=\"button_continue\" type=\"button\" class=\"cta-round primary medium modal-btn\" ng-click=\"close()\"><span class=\"no-text-transform\" res=\"_continue\"></span></button></div></div></div></div></div><div ng-if=\"isChangeVoicemailPassword\" style=\"position: relative;\" class=\"modal-body mlm mrm\"><div class=\"dialog module-link-account voicemailCenter\"><div class=\"row mbm voicemailRow\"><div class=\"prepaid-body-section\"><div class=\"voicemailDesc\" ng-if=\"isChangeVoicemailPassword\"><span res=\"update_voicemail_password_desc\" class=\"voicemailCenter\"></span></div></div></div><div class=\"checkboxContainer\"><input class=\"showMessageCheckbox\" type=\"checkbox\" ng-model=\"dontShowGoToSSPMsgAgain\" ng-click=\"setShowMessage(dontShowGoToSSPMsgAgain)\"> <span class=\"showMessageText\" res=\"message_do_not_display_ssp_popup\"></span></div><div class=\"ngdialog-buttons mbm voicemailBtnPadding\"><div class=\"row voicemailCenter\"><div class=\"\"><a name=\"cancelVoiceMail\" ng-click=\"cancel()\" class=\"link-cancel pointer cancel-btn-modal\"><span res=\"_cancel\">Cancel</span></a><button ng-click=\"close()\" class=\"cta-round primary medium resetBtn\" type=\"button\" name=\"button_continue\"><span class=\"no-text-transform\" res=\"reset\"></span></button></div></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerUpgradePlan/modals/wirelessRemovePlanModal.html","<div class=\"totes-project\"><section class=\"wireless-plan\"><div class=\"modal-body mlm mrm\" style=\"position:relative;top:10px\"><div class=\"dialog module-link-account\"><div class=\"row\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" ng-click=\"ok()\"><span aria-hidden=\"true\">&times;</span></button><h2 class=\"widget-loader-mod pushDn\" res=\"wireless_popup_title\"></h2></div><div class=\"row mbs\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div res=\"wireless_popup_title_2\"></div></div></div><div class=\"row mtm\"><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><bold-chat-static-button data-cbid=\"{{\'ute.data.manager.upgrade.plan.modals.boldChatButtonId\' | translate}}\" dynamic-div=\"{{\'ute.data.manager.upgrade.plan.modals.boldChatButtonDiv\' | translate}}\" data-chat-button=\"{{\'ute.data.manager.upgrade.plan.modals.boldChatButton\' | translate}}\"></bold-chat-static-button></div></div><div class=\"row mts\"><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\"><img src=\"images/phoneBlack.png\" class=\"mtm plm\"></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10\"><div res=\"wireless_popup_phone\" class=\"mtl pts\"></div></div></div><div class=\"row\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div res=\"wireless_popup_not_sure\" class=\"mtm\"></div><a class=\"title-h5\" ng-href=\"getViewAllPlansLink()\" target=\"_blank\"><span res=\"wireless_popup_all_plans\" class=\"bold\"></span></a></div></div><div class=\"row\"><button type=\"button\" class=\"cta-round primary medium pull-right mtm mbm\" ng-click=\"ok()\"><span res=\"internet_usage_close\"></span></button></div></div></div></section></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottleControlList/dataManagerVideoThrottleControl/dataManagerVideoThrottleControl.partial.html","<div class=\"ute-dataManager-videoThrottleControl\"><div class=\"row ute-dataManager-videoThrottleControl-midBlock\"><div class=\"col-sm-6 col-lg-6 ute-dataManager-videoThrottleControl-leftContainer\"><div class=\"ute-dataManager-videoThrottleControl-colorBlock\">&nbsp;</div><div class=\"ute-dataManager-videoThrottleControl-contact\"><span class=\"ute-dataManager-videoThrottleControl-displayName visible-sm\" data-ng-class=\":: dataManagerVideoThrottleControl.getDisplayNameClass(ctn)\">{{:: displayName | ute_common_filter_string_limit_to: 7}}</span> <span class=\"ute-dataManager-videoThrottleControl-displayName hidden-sm\" data-ng-class=\":: dataManagerVideoThrottleControl.getDisplayNameMediumClass(ctn)\">{{:: displayName | ute_common_filter_string_limit_to: 12}}</span> <span data-ng-class=\":: dataManagerVideoThrottleControl.getCTNClass(ctn)\" style=\"x-ms-format-detection: none;\">{{:: ctn | ute_common_filter_phone : \'$1 $2-$3\' }}</span><br><div class=\"ute-dataManager-videoThrottleControl-manage\" ng-if=\"isAlertsRecipient === \'true\'\">{{:: \'ute.dataManager.dataControl.alertsRecipientChange\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControl-status\"><div ng-if=\"dataManagerVideoThrottleControl.isAccountSuspended(ctn)\">{{:: \'ute.dataManager.dataControl.suspendedService\' | translate}}</div><div ng-if=\"dataManagerVideoThrottleControl.isAccountCancelled(ctn)\">{{:: \'ute.dataManager.dataControl.cancelledService\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControl-groupStatus\" ng-if=\"dataManagerVideoThrottleControl.isAccountLeftGroup(ctn)\">{{:: \'ute.dataManager.dataControl.leftGroupStillSharing\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControl-groupStatus\" ng-if=\"dataManagerVideoThrottleControl.getGroupStatus(ctn) === dataManagerVideoThrottleControl.getGroupStatusCode().JOINED\">{{:: \'ute.dataManager.dataControl.joinedGroup\' | translate}}</div></div></div></div><div class=\"ute-dataManager-videoThrottleControl-midSection ute-dataManager-videoThrottleControl-midSection-with-white-bg\"></div><div class=\"col-sm-6 col-md-6 col-lg-6 ute-dataManager-videoThrottleControl-dataAccessSwitchContainer\"><div ng-show=\":: (hasData === \'true\') && (status !== dataManagerVideoThrottleControl.getStatusCode().SUSPENDED) && (groupStatus !== dataManagerVideoThrottleControl.getGroupStatusCode().JOINED) && (status !== dataManagerVideoThrottleControl.getStatusCode().CANCELLED)\"><ute-data-manager-video-throttle-directive data-ctn=\"{{:: ctn}}\" data-color-code=\"{{:: colorCode}}\" data-video-quality-reduced=\"{{:: videoQualityReduced}}\" data-on-copy=\"ute.dataManager.dataAccess.on\" data-off-copy=\"ute.dataManager.dataAccess.off\" data-top-up-target=\"usageDial\"></ute-data-manager-video-throttle-directive><div class=\"ute-data-manager-video-throttle-icon\" ng-if=\"videoQualityReduced === \'true\'\"><span ng-class=\"dataManagerVideoThrottleControl.getIconClass(colorCode)\" class=\"ute-data-manager-vt-icon-sprite\"></span></div></div><div ng-show=\":: !(hasData === \'true\') && (status !== dataManagerVideoThrottleControl.getStatusCode().SUSPENDED) && (groupStatus !== dataManagerVideoThrottleControl.getGroupStatusCode().JOINED) && (status !== dataManagerVideoThrottleControl.getStatusCode().CANCELLED)\"><div class=\"ute-dataManager-dataControl-noDataContainer\"><span class=\"ute-dataManager-dataControl-noData\">{{::\'ute.dataManager.dataControl.noData\' | translate}}</span><md-button class=\"ute-button-secondary ute-md-secondary-button ute-dataManager-dataControl-addLineButton\" aria-label=\"Add Data to Line\" data-ng-click=\"dataManagerVideoThrottleControl.addDataToLine(ctn)\">{{:: \'ute.dataManager.dataControl.addData\' | translate}} <span class=\"hidden-sm hidden-md\">{{:: \'ute.dataManager.dataControl.toLine\' | translate}}</span></md-button></div></div></div></div></div>");
$templateCache.put("module/dataManager/dataManagerVideoThrottleControlTagList/dataManagerVideoThrottleControlTag/dataManagerVideoThrottleControlTag.view.html","<div class=\"ute-dataManager-videoThrottleControlTag\"><div class=\"ute-dataManager-videoThrottleControlTag-container\"><div class=\"row ute-dataManager-videoThrottleControlTag-row\"><div class=\"col-xs-1 ute-dataManager-videoThrottleControlTag-colorBlockContainer\"><div class=\"ute-dataManager-videoThrottleControlTag-colorBlock\" data-ng-style=\":: {\'background-color\': colorCode}\" data-ng-class=\":: dataManagerVideoThrottleControlTag.getColorBlockClass(ctn)\">&nbsp;</div></div><div class=\"col-xs-6 ute-dataManager-videoThrottleControlTag-leftCol\"><div class=\"ute-dataManager-videoThrottleControlTag-displayName\" data-ng-class=\":: dataManagerVideoThrottleControlTag.getDisplayNameClass(ctn)\">{{displayName | ute_common_filter_string_limit_to: 17}}</div><span class=\"ute-dataManager-videoThrottleControlTag-alert\" data-ng-show=\"isAlertsRecipient === \'true\'\" data-ng-class=\":: dataManagerVideoThrottleControlTag.getAlertClass(ctn)\">{{:: \'ute.dataManager.dataControlTag.alertsRecipient\' | translate}}</span><div class=\"ute-dataManager-videoThrottleControlTag-ctn\" data-ng-class=\":: dataManagerVideoThrottleControlTag.getCTNClass(ctn)\">{{:: ctn | ute_common_filter_phone : \'$1 $2-$3\'}}</div><br><div class=\"ute-dataManager-videoThrottleControlTag-status-leftGroup\" ng-show=\":: dataManagerVideoThrottleControlTag.isAccountLeftGroup(ctn)\">{{:: \'ute.dataManager.dataControlTag.leftGroupStillSharing\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControlTag-status-joinedGroup\" ng-show=\":: dataManagerVideoThrottleControlTag.isAccountJoined(ctn)\" data-ng-class=\":: dataManagerVideoThrottleControlTag.getJoinedGroupClass(ctn)\">{{:: \'ute.dataManager.dataControlTag.joinedGroupNotSharing\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControlTag-status-leftGroup\" ng-show=\":: dataManagerVideoThrottleControlTag.isAccountSuspended(ctn)\">{{:: \'ute.dataManager.dataControl.suspendedService\' | translate}}</div><div class=\"ute-dataManager-videoThrottleControlTag-status-leftGroup\" ng-show=\":: dataManagerVideoThrottleControlTag.isAccountCancelled(ctn)\">{{:: \'ute.dataManager.dataControl.cancelledService\' | translate}}</div></div><div class=\"col-xs-2 ute-dataManager-videoThrottleControlTag-rightCol\"></div><div class=\"col-xs-4 ute-dataManager-videoThrottleControlTag-rightCol\"><div ng-show=\":: (hasData === \'true\') && (status !== dataManagerVideoThrottleControlTag.getStatusCode().SUSPENDED) && (groupStatus !== dataManagerVideoThrottleControlTag.getGroupStatusCode().JOINED) && (status !== dataManagerVideoThrottleControlTag.getStatusCode().CANCELLED)\"><ute-data-manager-video-throttle-directive data-ctn=\"{{:: ctn}}\" data-color-code=\"{{:: colorCode}}\" data-video-quality-reduced=\"{{:: videoQualityReduced}}\" data-on-copy=\"ute.dataManager.dataAccess.on\" data-off-copy=\"ute.dataManager.dataAccess.off\" data-top-up-target=\"usageDial\"></ute-data-manager-video-throttle-directive></div></div></div></div></div>");
$templateCache.put("module/discoveryPage/discoveryPageDirective/discoveryPageDirectiveModal/discoveryPageDirectiveModal.partial.html","<div class=\"ute-discoveryPage-directive\"><img src=\"ute-common-assets/assets/close-icon.png\" class=\"ute-discoveryPage-directive-modalClose\" data-ng-click=\"discoveryPageDirectiveModal.noSelection()\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.noSelection():0\"><div class=\"carousel-wrap\"><carousel id=\"myCarousel\" class=\"slide\" no-wrap=\"false\" data-ride=\"carousel\" no-repeat=\"true\" interval=\"0\"><div class=\"carousel-inner\" role=\"listbox\"><slide class=\"item\" data-ng-repeat=\"feature in discoveryPageDirectiveModal.serverData.features.feature\"><div class=\"ute-discoveryPage-directive-carouselContainer\"><div class=\"ute-discoveryPage-directive-new\"><div class=\"ute-discoveryPage-directive-newText\">{{::\'ute.discoveryPage.directive.modal.newIcon\' | translate}}</div></div><div data-ng-if=\"discoveryPageDirectiveModal.selectedLanguage === \'en\'\" class=\"slidePane ute-discoveryPage-directive\"><div class=\"ute-discoveryPage-directive-heading\" style=\"margin-top: 50px;\" data-ng-bind-html=\"feature.englishContent.featureName\"></div><div class=\"ute-discoveryPage-directive-secondaryCopy\" data-ng-bind-html=\"feature.englishContent.featureDesc1\">{{::feature.englishContent.featureDesc1}}</div><div class=\"slidePaneImage ute-discoveryPage-directive-slidePaneImage\"><img data-ng-src=\"{{discoveryPageDirectiveModal.pointToRelativePath(feature.englishContent.breakpoints.breakpoint[0].contentRefUrl)}}\" alt=\"{{feature.englishContent.featureName}}\"></div><div class=\"ute-discoveryPage-directive-leftNavMobile visible-xs\" data-ng-show=\"!$first\" data-ng-click=\"discoveryPageDirectiveModal.prevSlide()\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.prevSlide():0\">{{::\'ute.discoveryPage.directive.modal.leftNav\' | translate}}</div><div class=\"ute-discoveryPage-directive-rightNavMobile visible-xs\" data-ng-show=\"!$last\" data-ng-click=\"discoveryPageDirectiveModal.nextSlide()\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.nextSlide():0\">{{::\'ute.discoveryPage.directive.modal.rightNav\' | translate}}</div><div class=\"ute-discoveryPage-directive-body\" data-ng-bind-html=\"feature.englishContent.featureDesc2\">{{::feature.englishContent.featureDesc2}}</div></div><div data-ng-if=\"discoveryPageDirectiveModal.selectedLanguage === \'fr\'\" class=\"slidePane ute-discoveryPage-directive\"><div class=\"ute-discoveryPage-directive-heading\" style=\"margin-top: 50px;\" data-ng-bind-html=\"feature.frenchContent.featureName\"></div><div class=\"ute-discoveryPage-directive-secondaryCopy\" data-ng-bind-html=\"feature.frenchContent.featureDesc1\">{{::feature.frenchContent.featureDesc1}}</div><div class=\"slidePaneImage ute-discoveryPage-directive-slidePaneImage\"><img ng-src=\"{{discoveryPageDirectiveModal.pointToRelativePath(feature.frenchContent.breakpoints.breakpoint[0].contentRefUrl)}}\" alt=\"{{feature.frenchContent.featureName}}\"></div><div class=\"ute-discoveryPage-directive-leftNavMobile visible-xs\" data-ng-show=\"!$first\" data-ng-click=\"discoveryPageDirectiveModal.prevSlide()\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.prevSlide():0\">{{::\'ute.discoveryPage.directive.modal.leftNav\' | translate}}</div><div class=\"ute-discoveryPage-directive-rightNavMobile visible-xs\" data-ng-show=\"!$last\" data-ng-click=\"discoveryPageDirectiveModal.nextSlide()\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.nextSlide():0\">{{::\'ute.discoveryPage.directive.modal.rightNav\' | translate}}</div><div class=\"ute-discoveryPage-directive-body\" data-ng-bind-html=\"feature.frenchContent.featureDesc2\">{{::feature.frenchContent.featureDesc2}}</div></div></div></slide></div></carousel></div><div class=\"row ute-discoveryPage-directive-buttonRow\" data-ng-hide=\"discoveryPageDirectiveModal.tooltipmode\"><div class=\"col-xs-12 col-sm-12 col-md-push-5 col-md-7\"><div class=\"ute-discoveryPage-directive-continueButtonContainer\"><md-button data-ng-if=\"discoveryPageDirectiveModal.selectedLanguage === \'en\'\" name=\"button_continue\" type=\"button\" class=\"ute-md-primary-button ute-discoveryPage-directive-continueButton\" alt=\"discoveryPageDirectiveModal.serverData.englishContent.topicDesc\" data-ng-click=\"discoveryPageDirectiveModal.continue(discoveryPageDirectiveModal.serverData.englishContent.topicButtonUrl[discoveryPageDirectiveModal.getResponsiveTopicUrlIndex()])\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.continue(discoveryPageDirectiveModal.serverData.englishContent.topicButtonUrl[discoveryPageDirectiveModal.getResponsiveTopicUrlIndex()]):0\" data-ng-bind-html=\"discoveryPageDirectiveModal.serverData.englishContent.topicButtonLabel\" tabindex=\"0\"></md-button><md-button data-ng-if=\"discoveryPageDirectiveModal.selectedLanguage === \'fr\'\" name=\"button_continue\" type=\"button\" class=\"ute-md-primary-button ute-discoveryPage-directive-continueButton\" alt=\"discoveryPageDirectiveModal.serverData.frenchContent.topicDesc\" data-ng-click=\"discoveryPageDirectiveModal.continue(discoveryPageDirectiveModal.serverData.frenchContent.topicButtonUrl[discoveryPageDirectiveModal.getResponsiveTopicUrlIndex()])\" data-ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.continue(discoveryPageDirectiveModal.serverData.frenchContent.topicButtonUrl[discoveryPageDirectiveModal.getResponsiveTopicUrlIndex()]):0\" data-ng-bind-html=\"discoveryPageDirectiveModal.serverData.frenchContent.topicButtonLabel\" tabindex=\"0\"></md-button></div></div><div class=\"col-xs-12 col-sm-12 col-md-pull-7 col-md-5\"><div class=\"ute-discoveryPage-directive-checkboxContainer\"><md-checkbox class=\"ute-discoveryPage-directive-checkbox\" ng-checked=\"discoveryPageDirectiveModal.doNotShow\" ng-click=\"discoveryPageDirectiveModal.doNotShowToggle()\" ng-keypress=\"($event.which === 13)?discoveryPageDirectiveModal.doNotShowToggle():0\" tabindex=\"0\"><span class=\"ute-discoveryPage-directive-checkboxText\">{{::\'ute.discoveryPage.directive.modal.doNotShow\' | translate}}</span></md-checkbox></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-account.html","<div class=\"ute-elr-account\" ng-if=\"!$ctrl.isSubscriberFlow\"><div ng-if=\"!$ctrl.isAutoRegistrationStarted\"><div class=\"recovery-error\" ng-if=\"$ctrl.accountModel.generalError !== \'\' && $ctrl.accountModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.generalError}}\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" style=\"overflow: hidden\"></div></div></div><div class=\"elr-account-form\"><form name=\"$ctrl.accountForm\"><div class=\"account-number\"><label for=\"accountNumber\"><span translate=\"ute.easy.login.registration.account.AccountNo\"></span> <span class=\"dk-hidden\" ng-click=\"infoShowHide = !infoShowHide\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/icon-info-blue.png\" alt=\"\"></span></label><div class=\"information-tooltip dk-hidden\" ng-if=\"infoShowHide\"><span translate=\"ute.easy.login.registration.account.whereToFind\"></span><ul><li translate=\"ute.easy.login.registration.account.monthlyPaperBill\"></li><li translate=\"ute.easy.login.registration.account.monthlyEmailMessage\"></li><li translate=\"ute.easy.login.registration.account.serviceAgreement\"></li></ul></div><div class=\"information-container\"><div class=\"account-input\"><input class=\"accountNumber\" type=\"tel\" ute-account-number-input=\"\" ng-model=\"$ctrl.accountModel.accountNumber\" name=\"accountNumber\" required=\"\" ng-pattern=\"/^(?:\\d{9}|\\d{12})$/\" ng-keyup=\"$ctrl.setInputFocusForMobileEnterKeyPress($event)\" id=\"accountNumber-field\" autofocus=\"\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" placeholder=\"{{\'ute.easy.login.registration.account.AccountNoPlaceHolder\' | translate}}\"><div class=\"information-tooltip mb-hidden\"><span translate=\"ute.easy.login.registration.account.whereToFind\"></span><ul><li translate=\"ute.easy.login.registration.account.monthlyPaperBill\"></li><li translate=\"ute.easy.login.registration.account.monthlyEmailMessage\"></li><li translate=\"ute.easy.login.registration.account.serviceAgreement\"></li></ul></div></div></div><div class=\"inline-error\" translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.accountError}}\"></div></div><div class=\"postal-code\"><label for=\"postalCode-field\" translate=\"ute.easy.login.registration.account.postalCodeAddress\"></label><div class=\"postal-code-input\"><input type=\"text\" ute-postal-code-input=\"\" placeholder=\"\" ng-model=\"$ctrl.accountModel.postalCode\" required=\"\" ng-pattern=\"/^[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]$/\" ng-keyup=\"$ctrl.setInputFocusForMobileEnterKeyPress($event)\" name=\"postalCode\" id=\"postalCode-field\" maxlength=\"7\"></div><div class=\"inline-error\" translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.postalError}}\"></div></div><div class=\"captcha\"><div ng-if=\"$ctrl.getCurrentLanguage()===\'en\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"en\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.captchaVerified(response)\"></div><div ng-if=\"$ctrl.getCurrentLanguage()===\'fr\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"fr\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.captchaVerified(response)\"></div></div><div class=\"buttons\"><button class=\"ute-secondary-button\" type=\"button\" ng-click=\"$ctrl.validateAccountForm()\" ng-class=\"$ctrl.getLoadingClass()\" translate=\"ute.easy.login.common.continue\"></button> <button class=\"ute-text-button\" type=\"button\" ng-click=\"$ctrl.backStep($ctrl.STEP.MAIN)\" translate=\"ute.easy.login.common.back\"></button></div></form></div></div><div class=\"ute-elr-email-verify\" ng-if=\"$ctrl.isAutoRegistrationStarted\"><div class=\"recovery-error\" ng-if=\"$ctrl.accountModel.generalError !== \'\' && $ctrl.accountModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.generalError}}\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\"></div></div></div><div class=\"elr-header\"><strong class=\"elr-strong\" ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.header\' | translate\"></strong></div><div class=\"elr-header-info\"><span translate=\"ute.easy.login.registration.accountRegistered.message\"></span></div><div class=\"elr-email-verify-info\"><div class=\"verify-text-container\"><span class=\"elr-sub-header\" translate=\"ute.easy.login.registration.accountRegistered.completeRegistration\"></span><div translate=\"ute.easy.login.registration.accountRegistered.sendEmailmessage\"></div><div class=\"icon-holder\"><span class=\"ute-email-icon\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/email-icon-blue.png\" alt=\"\"></span> <span class=\"elr-strong\" translate=\"ute.easy.login.registration.accountRegistered.emailSentTo\"></span> <span class=\"elr-strong\">{{$ctrl.maskEmailAddress($ctrl.emailModel.email)}}</span></div><button class=\"ute-primary-button state-btn\" type=\"button\" ng-click=\"$ctrl.isResendEmail = false; $ctrl.resendEmail($ctrl.accountModel.emailGenerationToken,\'resend\')\" ng-class=\"$ctrl.getLoadingClass()\" ng-disabled=\"$ctrl.accountModel.disableState\">{{$ctrl.accountModel.sendEmailButtonText| translate}}<i></i></button></div></div><div class=\"resend-collapse accordion\"><button class=\"ute-text-button\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\" translate=\"ute.easy.login.registration.verify.didntGetEmail\"></button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><div class=\"resend-collapse-panel-holder two-btn-columns\"><ul><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.checkSpam\"></li><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.giveFewMinutes\"></li></ul><button class=\"ute-secondary-button state-btn\" ng-click=\"$ctrl.isResendEmail = true; $ctrl.resendEmail($ctrl.accountModel.emailGenerationToken,\'resend\')\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" ng-disabled=\"$ctrl.resendState\">{{$ctrl.accountModel.reSendButtonText | translate}} <i></i></button> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.sendToDifferentEmail()\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.sendToDifferentEmail\"></button><div class=\"need-help\"><span translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.stillNeedHelp\"></span><span><button class=\"ute-text-button\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.contactUs\" ng-click=\"$ctrl.redirectToNewTab(\'/consumer/contact-us\')\"></button></span></div></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-complete.html","<div class=\"ute-elr-complete\"><div class=\"elr-header\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/icon-done.png\"> <span translate=\"ute.easy.login.registration.complete.header\"></span></div><div class=\"elr-info-header\" ng-bind-html=\"\'ute.easy.login.registration.complete.message\' | translate\"></div><button class=\"ute-primary-button\" translate=\"ute.easy.login.registration.complete.goToOverview\" ng-class=\"$ctrl.getLoadingClass()\" ng-click=\"$ctrl.gotoAccountOverview(true)\"></button></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-email.html","<div class=\"ute-elr-email\"><div class=\"elr-header elr-header-caps\" translate=\"ute.easy.login.registration.email.header\"></div><div class=\"recovery-error\" ng-if=\"$ctrl.emailModel.generalError !== \'\' && $ctrl.emailModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate=\"ute.easy.login.registration.email.{{$ctrl.emailModel.generalError}}\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" style=\"overflow: hidden\"></div></div></div><div class=\"email-form\"><form novalidate=\"\" name=\"$ctrl.emailForm\"><div class=\"email\"><label for=\"email\" translate=\"ute.easy.login.registration.email.enterEmail\">{{\'ute.easy.login.registration.email.enterEmail\' | translate}}</label> <input type=\"email\" name=\"email\" ng-model=\"$ctrl.emailModel.email\" required=\"\"><div class=\"inline-error\" translate=\"ute.easy.login.error.{{$ctrl.emailModel.emailError}}\"></div></div><div class=\"confirm-email\"><label for=\"confirmEmail\" translate=\"ute.easy.login.registration.email.reEnterEmail\">{{\'ute.easy.login.registration.email.reEnterEmail\' | translate}}</label><div class=\"confirm-email-input\"><input type=\"email\" name=\"confirmEmail\" ng-model=\"$ctrl.emailModel.confirmEmail\" ng-change=\"$ctrl.onConfirmEmailInputChange()\" required=\"\"><div class=\"information-tooltip\"><span class=\"info-header\" translate=\"ute.easy.login.registration.email.bothEmailMatch\" ng-class=\"{\'success\': $ctrl.emailModel.confirmEmailIsValid}\"></span></div></div></div><div class=\"buttons\"><button class=\"ute-secondary-button\" type=\"button\" ng-click=\"$ctrl.emailFormValidation($ctrl.emailForm)\" ng-class=\"$ctrl.getLoadingClass()\" translate=\"ute.easy.login.common.continue\"></button> <button class=\"ute-text-button\" type=\"button\" ng-if=\"!$ctrl.isSubscriberFlow\" ng-click=\"$ctrl.backStep($ctrl.STEP.ACCOUNT)\" translate=\"ute.easy.login.common.back\"></button> <button class=\"ute-text-button\" type=\"button\" ng-if=\"$ctrl.isSubscriberFlow\" ng-click=\"$ctrl.backStep($ctrl.STEP.VERIFY_SMS)\" translate=\"ute.easy.login.common.cancel\"></button></div></form></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-main.html","<div class=\"ute-elr-selection\"><div class=\"elr-selection\"><div class=\"elr-header\" translate=\"ute.easy.login.registration.header\"></div><div class=\"elr-selection-plan\"><div class=\"elr-plan-header\" translate=\"ute.easy.login.registration.monthlyMobileOrInternetService\"></div><div class=\"elr-plan-info\"><span class=\"text\" translate=\"ute.easy.login.registration.registerHere\"></span> <button class=\"ute-primary-button\" ng-click=\"$ctrl.startAccountFlow()\" translate=\"ute.easy.login.registration.accountHolder\"></button> <span class=\"elr-divider\"></span> <span class=\"text\" translate=\"ute.easy.login.registration.notAccountHolder\"></span> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.startSubscriberFlow()\" translate=\"ute.easy.login.registration.subscriber\"></button></div></div><div class=\"elr-selection-plan\"><div class=\"elr-plan-header\" translate=\"ute.easy.login.registration.prepaidMobileService\"></div><div class=\"elr-plan-info\"><span class=\"text\" translate=\"ute.easy.login.registration.prePayForYourPlan\"></span> <button class=\"ute-primary-button\" translate=\"ute.easy.login.registration.prepaidCustomers\" ng-click=\"$ctrl.openJanrainRegistrationModal()\"></button></div></div></div><div class=\"ute-elr-shop\"><div class=\"elr-shop-info\"><span class=\"elr-shop-header\" translate=\"ute.easy.login.registration.noFidoServices\"></span> <span class=\"text\" translate=\"ute.easy.login.registration.fidoServicesAvailableTo\"></span></div><div class=\"elr-shop-button\"><span class=\"elr-button-info\" translate=\"ute.easy.login.registration.seeWhatWeCanDo\"></span> <button class=\"ute-shop-button\" ng-click=\"$ctrl.redirect(\'/consumer/mobile\')\"><span class=\"button-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/buy-online-icon.png\" alt=\"\"></span> <span class=\"button-text\" translate=\"ute.easy.login.registration.shop\"></span></button></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-number.html","<div class=\"ute-elr-account elr-subscriber\" ng-if=\"$ctrl.isSubscriberFlow\"><div ng-if=\"!$ctrl.isAutoRegistrationStarted\"><div class=\"elr-header elr-header-caps\" translate=\"ute.easy.login.registration.retrieveProfile.number.message\"></div><div class=\"recovery-error\" ng-if=\"$ctrl.accountModel.generalError !== \'\' && $ctrl.accountModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate=\"ute.easy.login.error.{{$ctrl.accountModel.generalError}}\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" style=\"overflow: hidden\"></div></div></div><div class=\"elr-account-form\"><form name=\"$ctrl.accountForm\"><div class=\"account-number\"><label for=\"accountNumber\" translate=\"ute.easy.login.registration.retrieveProfile.number.mobilePhoneNumber\"><i class=\"\"></i></label><div class=\"information-container\"><div class=\"account-input\"><input class=\"accountNumber\" type=\"tel\" ng-model=\"$ctrl.accountModel.phoneNumber\" name=\"phoneNumber\" required=\"\" ng-pattern=\"/[0-9]{3}-?[0-9]{3}-?[0-9]{4}/\" placeholder=\"123-456-7890\" phone-number-masking=\"\"></div></div><div class=\"inline-error\" translate=\"ute.easy.login.error.{{$ctrl.accountModel.phoneError}}\"></div></div><div class=\"captcha\"><div ng-if=\"$ctrl.getCurrentLanguage()===\'en\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"en\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.captchaVerified(response)\"></div><div ng-if=\"$ctrl.getCurrentLanguage()===\'fr\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"fr\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.captchaVerified(response)\"></div></div><div class=\"buttons\"><button class=\"ute-secondary-button\" type=\"button\" ng-click=\"$ctrl.validateSubAccountForm($ctrl.accountForm)\" ng-class=\"$ctrl.getLoadingClass()\" translate=\"ute.easy.login.common.continue\"></button> <button class=\"ute-text-button\" type=\"button\" ng-click=\"$ctrl.backStep($ctrl.STEP.MAIN)\" translate=\"ute.easy.login.common.back\"></button></div></form></div></div><div class=\"ute-elr-account\" ng-if=\"$ctrl.isAutoRegistrationStarted\"><div class=\"elr-header\"><span class=\"bg-header\" ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.header\' | translate\"></span><br><span translate=\"ute.easy.login.registration.accountRegistered.message\"></span></div><div><strong translate=\"ute.easy.login.registration.accountRegistered.completeRegistration\"></strong></div><div translate=\"ute.easy.login.registration.accountRegistered.sendEmailmessage\"></div><div><div class=\"icon\"></div><div translate=\"ute.easy.login.registration.accountRegistered.emailSentTo\"></div><strong>{{$ctrl.maskEmailAddress($ctrl.emailModel.email)}}</strong></div><button class=\"ute-secondary-button\" type=\"button\" ng-click=\"$ctrl.resendEmail($ctrl.accountModel.emailGenerationToken, \'resend\')\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" translate=\"ute.easy.login.registration.accountRegistered.sendEmail\"></button><div class=\"resend-collapse accordion\"><div class=\"collapse-icon\"><img src=\"ute-easy-login-registration/assets/arrow_drop.png\" alt=\"\"></div><button class=\"ute-button-blue-no-decor\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\" translate=\"ute.easy.login.registration.verify.didntGetEmail\"></button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><ul><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.checkSpam\"></li><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.giveFewMinutes\"></li></ul><button class=\"ute-secondary-button\" ng-click=\"$ctrl.resendEmail($ctrl.accountModel.emailGenerationToken , \'resend\')\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.resendCode\"></button><div class=\"need-help\"><span translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.stillNeedHelp\"></span><span><button class=\"ute-button-blue-no-decor\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.contactUs\" ng-click=\"$ctrl.redirectToNewTab(\'/consumer/contact-us\')\"></button></span></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-password.html","<div class=\"ute-elr-password\"><div class=\"elr-header elr-header-caps\" translate=\"ute.easy.login.registration.password.header\"></div><div class=\"recovery-error\" ng-if=\"$ctrl.passwordModel.generalError !== \'\' && $ctrl.passwordModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate-compile=\"\" translate=\"ute.easy.login.error.{{$ctrl.passwordModel.generalError}}\"></div></div></div><div class=\"password-form\"><form name=\"$ctrl.passwordForm\" method=\"post\" autocomplete=\"on\"><div class=\"password\"><div class=\"label-content\"><label for=\"password\" translate=\"ute.easy.login.registration.password.enterPassword\"></label></div><div class=\"rest-password ute-show-hide-box\"><button class=\"ute-btn-show-hide\" type=\"button\" ng-click=\"$ctrl.setPasswordInputType(\'passwordType\')\" translate=\"ute.easy.login.common.{{$ctrl.passwordModel.passwordType}}\"></button> <input type=\"text\" style=\"display:none\" name=\"username\" id=\"username\" ng-model=\"$ctrl.emailModel.email\" autocomplete=\"on\"> <input type=\"{{$ctrl.passwordModel.passwordType}}\" ng-change=\"$ctrl.onPasswordInputChange()\" class=\"password-field\" maxlength=\"64\" name=\"password\" id=\"password\" ng-model=\"$ctrl.passwordModel.password\" required=\"\" autocapitalize=\"off\" spellcheck=\"false\" autocorrect=\"off\" autocomplete=\"new-password\"><div class=\"inline-error\" translate=\"ute.easy.login.registration.password.{{$ctrl.passwordModel.passwordError}}\"></div><div class=\"information-tooltip\"><strong class=\"info-header\" translate=\"ute.easy.login.registration.password.passwordMustHave\"></strong> <span class=\"info-list\" ng-class=\"{\'success\': $ctrl.passwordModel.passwordIsValid}\" translate=\"ute.easy.login.registration.password.passwordAtLeast\"></span> <span class=\"info-list\" ng-class=\"{\'success\': $ctrl.passwordModel.passwordIsEnough}\" translate=\"ute.easy.login.registration.password.passwordMinimum\"></span><div class=\"text-holder\" translate=\"ute.easy.login.registration.password.passwordCanInclude\"></div></div></div></div><div class=\"confirm-password\"><label for=\"confirmPassword\" translate=\"ute.easy.login.registration.password.reEnterPassword\"></label><div class=\"confirm-password-input ute-show-hide-box\"><button class=\"ute-btn-show-hide\" type=\"button\" ng-click=\"$ctrl.setPasswordInputType(\'confirmPasswordType\')\" translate=\"ute.easy.login.common.{{$ctrl.passwordModel.confirmPasswordType}}\"></button> <input type=\"{{$ctrl.passwordModel.confirmPasswordType}}\" class=\"password-field input-error\" ng-change=\"$ctrl.onConfirmPasswordInputChange()\" name=\"confirmPassword\" id=\"confirmPassword\" ng-model=\"$ctrl.passwordModel.confirmPassword\" required=\"\" autocapitalize=\"off\" spellcheck=\"false\" autocorrect=\"off\" autocomplete=\"new-password\"><div class=\"information-tooltip\"><span class=\"info-header\" ng-class=\"{\'success\': $ctrl.passwordModel.confirmPasswordIsValid}\">{{\'ute.easy.login.registration.password.bothPasswordMatch\' | translate}}</span></div></div></div><div class=\"set-password mb-wide\"><button class=\"ute-primary-button\" type=\"submit\" ng-click=\"$ctrl.validatePassword($ctrl.passwordForm)\" ng-class=\"$ctrl.getLoadingClass()\" translate=\"ute.easy.login.registration.password.setPassword\"></button></div></form></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-sms_verify.html","");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-verify.html","<div class=\"ute-elr-verify\"><div class=\"elr-header elr-header-caps\" translate=\"ute.easy.login.registration.verify.header\"></div><div class=\"elr-verify-info\"><div class=\"verify-text-container\"><div ng-if=\"!$ctrl.isSubscriberFlow\" ng-bind-html=\"\'ute.easy.login.registration.verify.message\' | translate\"></div><div ng-if=\"$ctrl.isSubscriberFlow\" ng-bind-html=\"\'ute.easy.login.registration.verify.messageSubscriber\' | translate\"></div><div class=\"icon-holder\"><span class=\"ute-email-icon\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/email-icon-blue.png\" alt=\"\"></span> <span translate=\"ute.easy.login.registration.verify.messageSentTo\"></span> <strong>{{$ctrl.maskEmailAddress($ctrl.emailModel.email)}}</strong></div></div></div><div class=\"resend-collapse accordion\"><button class=\"ute-text-button\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\" translate=\"ute.easy.login.registration.verify.didntGetEmail\"></button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><div class=\"resend-collapse-panel-holder two-btn-columns\"><ul><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.checkSpam\"></li><li translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.giveFewMinutes\"></li></ul><button class=\"ute-secondary-button state-btn\" ng-click=\"$ctrl.isResendEmail = true; $ctrl.resendEmail($ctrl.accountModel.emailGenerationToken,\'resend\')\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" ng-disabled=\"$ctrl.resendState\">{{$ctrl.accountModel.reSendButtonText | translate}} <i></i></button> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.sendToDifferentEmail()\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.sendToDifferentEmail\"></button><div class=\"need-help\"><span translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.stillNeedHelp\"></span> <button class=\"ute-text-button\" translate=\"ute.easy.login.registration.verify.didntGetEmailExpanded.contactUs\" ng-click=\"$ctrl.redirectToNewTab(\'/consumer/contact-us\')\"></button></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLogin-step-verify_sms.html","<div class=\"ute-elr-pin-verify\"><div class=\"elr-header elr-header-caps\"><strong class=\"elr-strong\" translate=\"ute.easy.login.registration.retrieveProfile.email.message\"></strong></div><div class=\"recovery-error\" ng-if=\"$ctrl.smsModel.generalError !== \'\' && $ctrl.smsModel.generalError !== \'error_null\'\"><div class=\"recovery-error-img\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error_warning.png\"><div translate=\"ute.easy.login.error.{{$ctrl.smsModel.generalError}}\" data-translate-values=\"{maskedEmail: $ctrl.accountModel.maskedEmail, remainingAttempts: $ctrl.smsModel.remainingAttempts}\" style=\"overflow: hidden\"></div></div></div><div class=\"elr-pin-verify-form\"><form name=\"$ctrl.pinCodeForm\"><div class=\"elr-pin-verify\"><div class=\"pin-number-input\"><label for=\"pin\" translate=\"ute.easy.login.registration.retrieveProfile.email.code\"></label> <input class=\"pinNumber\" type=\"text\" name=\"pin\" ng-model=\"$ctrl.smsModel.pin\" required=\"\" ng-pattern=\"/^\\d{7}$/\"><div class=\"inline-error\" translate=\"ute.easy.login.error.{{$ctrl.smsModel.pinError}}\"></div></div><div class=\"pin-number-icon\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/Phone-icons.png\" alt=\"\"><div class=\"text\"><div translate=\"ute.easy.login.registration.retrieveProfile.email.codeSentTo\"></div><span>{{ $ctrl.maskPhonenumber($ctrl.accountModel.phoneNumber) | ute_common_filter_phone}}</span></div></div></div><div class=\"buttons\"><button class=\"ute-secondary-button\" type=\"button\" ng-click=\"$ctrl.validatePinCodeForm($ctrl.pinCodeForm)\" ng-class=\"$ctrl.getLoadingClass()\" translate=\"ute.easy.login.registration.retrieveProfile.email.verifyMe\"></button> <button class=\"ute-text-button\" type=\"button\" ng-click=\"$ctrl.backStep($ctrl.STEP.NUMBER)\" translate=\"ute.easy.login.common.back\"></button></div></form><div class=\"resend-collapse accordion\"><button class=\"ute-text-button\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\" translate=\"ute.easy.login.registration.retrieveProfile.email.didntGetText\"></button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><div class=\"resend-collapse-panel-holder\"><button class=\"ute-secondary-button state-btn\" ng-click=\"$ctrl.resendSms($ctrl.accountForm)\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" ng-disabled=\"$ctrl.smsModel.smsCounter >= 2\">{{$ctrl.smsModel.reSendButtonText | translate}} <i></i></button> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.backStep($ctrl.STEP.NUMBER)\" translate=\"ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.sendToDifferentNo\"></button><div class=\"need-help\"><span translate=\"ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.stillNeedHelp\"></span> <button class=\"ute-button-blue-no-decor\" translate=\"ute.easy.login.registration.retrieveProfile.email.didntGetTextExpanded.contactUs\" ng-click=\"$ctrl.redirectToNewTab(\'/consumer/contact-us\')\"></button></div></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLoginRegistration.html","<div class=\"ute-easy-login-registration\" ng-if=\"$ctrl.step === $ctrl.STEP.PASSWORD\" ng-show=\"$ctrl.showTransitionScreen\"><ng-include class=\"transition-screen-wrapper\" src=\"$ctrl.getTransitionScreenTemplate()\"></ng-include></div><div class=\"ute-easy-login-registration ute-elr-registration-page\" ng-show=\"!$ctrl.showTransitionScreen\"><ng-include ng-if=\"$ctrl.step !== $ctrl.STEP.MAIN\" class=\"step-indicator\" src=\"\'module/easyLoginRegistration/templates/fido/easyLoginRegistrationNav.html\'\"></ng-include><ng-include ng-if=\"$ctrl.step !== $ctrl.STEP.MAIN\" class=\"step-indicator\" src=\"\'module/easyLoginRegistration/templates/fido/step.partial.html\'\"></ng-include><div class=\"container\"><ng-include src=\"$ctrl.getCurrentStepTemplate()\"></ng-include></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/easyLoginRegistrationNav.html","<div class=\"ute-elr-navigation flex-container v-middle\"><div class=\"container\"><div class=\"nav-inner flex-container v-middle\"><div class=\"elr-brand\" translate=\"ute.easy.login.common.myAccount\"></div><div class=\"elr-page flex-container v-middle\" translate=\"ute.easy.login.common.register\"></div><div class=\"elr-page flex-container v-middle\" ng-if=\"$ctrl.isAutoRegistrationStarted\" translate=\"ute.easy.login.common.account\"><span>{{$ctrl.accountModel.accountNumber}}</span></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/emailVerificationModal.html","<div class=\"ute-easy-login-registration\"><div class=\"validate-token-holder\" ng-class=\"{\'state-screen-fail\' : $ctrl.step === $ctrl.MODAL_STEP.invalid, \'state-screen-processing\' : $ctrl.step === $ctrl.MODAL_STEP.processing ,\'state-screen-success\' : $ctrl.step === $ctrl.MODAL_STEP.success}\"><span class=\"recovery-secure-icon\"><img src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/icon-lock.png\" alt=\"\"> <span translate=\"ute.easy.login.common.secure\"></span></span><div class=\"popup-holder error-popup\" ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.invalid\"><img class=\"popup-icon\" src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/error-icon.png\" alt=\"\"> <span class=\"popup-text\" translate=\"ute.easy.login.registration.email.verify.linkExpired\"></span></div><div class=\"popup-holder validating-popup\" ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.processing\"><img class=\"popup-icon\" src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/validating-icon.png\" alt=\"\"> <span class=\"popup-text\" translate=\"ute.easy.login.registration.email.verify.verifyingLink\"></span></div><div class=\"popup-holder success-popup\" ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.success\"><img class=\"popup-icon\" src=\"/html-fido/cms/ute/fido/resource/Images/easylogin/successful-icon.png\" alt=\"\"> <span class=\"popup-text\" translate=\"ute.easy.login.registration.email.verify.linkVerified\"></span></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/step.partial.html","<div class=\"container\" ng-if=\"!$ctrl.isAutoRegistrationStarted\" style=\"margin-bottom: 0px;\"><div class=\"steps-container\" id=\"elr_fido_steps\"><div ng-repeat=\"step in $ctrl.stepManager\" ng-if=\"$index !== 0\" ng-class=\"$ctrl.getStepClasses($index)\"><div class=\"step-indicator\">{{$index}}</div><div class=\"step-text\" translate=\"ute.easy.login.registration.step.{{$ctrl.getStepLowerCase($index)}}\"></div></div><div class=\"step-rail\"></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/fido/transition-loading-screen.html","<div class=\"container\"><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"transition-heading-background\"><img class=\"responsive yellow-background-img\" src=\"/html-fido/cms/ute/fido/images/yellow-background.jpg\" alt=\"Yellow background image\"> <span class=\"transition-screen-loading-text\"><ins translate=\"ute.easy.login.registration.transitionScreenHeading\"></ins></span></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12\"><div class=\"loading-secondary\"></div></div></div><div class=\"row\"><div class=\"col-md-12 col-xs-12 transition-screen-desc\"><span class=\"transition-screen-loading-message\"><ins translate=\"ute.easy.login.registration.transitionScreenDescription\"></ins></span></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-account.html","<div class=\"ute-elr-account\" ng-if=\"!$ctrl.isAutoRegistrationStarted\"><div class=\"contest_bannerstep1\" ng-if=\"$ctrl.showContestBanner\"><p translate=\"ute.easy.login.registration.contest_banner_desc\"></p></div><div class=\"elr-header\">{{\'ute.easy.login.registration.account.header\' | translate}}</div><div class=\"inline-error\" ng-if=\"$ctrl.accountModel.generalError !== \'\' && $ctrl.accountModel.generalError !== \'error_null\'\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" translate-compile=\"\" translate=\"ute.easy.login.error.{{$ctrl.accountModel.generalError}}\"></div><div class=\"elr-account-form\"><form name=\"$ctrl.accountForm\"><div class=\"account-number\"><label for=\"accountNumber\">{{\'ute.easy.login.registration.account.rogersAccountNo\' | translate}} <span class=\"info-help dk-hidden\" ng-click=\"infoShowHide = !infoShowHide\">?</span></label><div class=\"information-container\"><div class=\"information-tooltip dk-hidden\" ng-if=\"infoShowHide\"><div class=\"info-icon\"><img src=\"ute-easy-login-registration/assets/info-icon-blue.png\" alt=\"\"></div><div class=\"info-text-container\"><div class=\"info-header\">{{\'ute.easy.login.registration.account.whereToFind\' | translate}}</div><ul><li>{{\'ute.easy.login.registration.account.monthlyPaperBill\' | translate}}</li><li>{{\'ute.easy.login.registration.account.monthlyEmailMessage\' | translate}}</li><li>{{\'ute.easy.login.registration.account.serviceAgreement\' | translate}}</li></ul></div></div><div class=\"information-tooltip mb-hidden\"><div class=\"info-icon\"><img src=\"ute-easy-login-registration/assets/info-icon-blue.png\" alt=\"\"></div><div class=\"info-text-container\"><div class=\"info-header\">{{\'ute.easy.login.registration.account.whereToFind\' | translate}}</div><ul><li>{{\'ute.easy.login.registration.account.monthlyPaperBill\' | translate}}</li><li>{{\'ute.easy.login.registration.account.monthlyEmailMessage\' | translate}}</li><li>{{\'ute.easy.login.registration.account.serviceAgreement\' | translate}}</li></ul></div></div><div class=\"account-input\"><input type=\"text\" ute-account-number-input=\"\" ng-model=\"$ctrl.accountModel.accountNumber\" name=\"accountNumber\" id=\"accountNumber-field\" required=\"\" ng-pattern=\"/^(?:\\d{9}|\\d{12})$/\" autofocus=\"\" placeholder=\"{{\'ute.easy.login.registration.account.rogersAccountNoPlaceHolder\' | translate}}\"></div></div><div class=\"inline-error\" translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.accountError}}\"></div></div><div class=\"postal-code\"><label for=\"postalCode\">{{\'ute.easy.login.registration.account.postalCodeAddress\' | translate}}</label> <input type=\"text\" ute-postal-code-input=\"\" ng-model=\"$ctrl.accountModel.postalCode\" required=\"\" ng-pattern=\"/[A-Za-z][0-9][A-Za-z] ?[0-9][A-Za-z][0-9]/\" name=\"postalCode\" placeholder=\"A1A1A1\" maxlength=\"6\"><div class=\"inline-error\" translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.postalError}}\"></div></div><div class=\"captcha\" ng-if=\"!$ctrl.blockRecaptcha\"><div ng-if=\"$ctrl.getCurrentLanguage()===\'en\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"en\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.rogerscaptchaVerified(response)\"></div><div ng-if=\"$ctrl.getCurrentLanguage()===\'fr\'\" vc-recaptcha=\"\" data-key=\"$ctrl.captchaKey\" data-size=\"invisible\" data-badge=\"inline\" data-lang=\"fr\" required=\"false\" on-expire=\"$ctrl.onCaptchaExpire()\" on-success=\"$ctrl.rogerscaptchaVerified(response)\"></div></div><div class=\"buttons flex-container v-middle sm-wrap-reverse\"><button class=\"ute-button-blue-no-decor\" type=\"button\" ng-click=\"$ctrl.backStep($ctrl.STEP.MAIN)\">{{\'ute.easy.login.common.back\' | translate}}</button> <button class=\"ute-primary-button mb-wide\" type=\"button\" ng-class=\"$ctrl.getLoadingClass()\" ng-click=\"$ctrl.rogersAccountForm()\">{{\'ute.easy.login.common.continue\' | translate}}</button></div></form></div></div><div class=\"ute-elr-account ute-elr-auto-registration\" ng-if=\"$ctrl.isAutoRegistrationStarted\"><div class=\"elr-header\"><span class=\"bg-header\" ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.header\' | translate\"></span><br><span ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.message\' | translate\"></span></div><div class=\"inline-error\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" translate-compile=\"\" translate=\"ute.easy.login.registration.account.{{$ctrl.accountModel.generalError}}\"></div><div class=\"elr-verify-info\"><div class=\"verify-icon\"><img src=\"ute-easy-login-registration/assets/mail.png\" alt=\"\"></div><div class=\"verify-text-container\"><div class=\"rogers-red-header\">{{\'ute.easy.login.registration.accountRegistered.completeRegistration\' | translate}}</div><div ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.sendEmailmessage\' | translate\"></div><div><span ng-bind-html=\"\'ute.easy.login.registration.accountRegistered.emailSentTo\' | translate\"></span> &nbsp; <span>{{$ctrl.maskEmailAddress($ctrl.emailModel.email)}}</span></div></div></div><button ng-click=\"$ctrl.isResendEmail = false; $ctrl.rogersResendEmail($ctrl.accountModel.emailGenerationToken,\'resend\')\" class=\"ute-primary-button\" style=\"margin-top: 30px;\" ng-class=\"$ctrl.getLoadingClass()\" ng-disabled=\"$ctrl.accountModel.disableState\">{{$ctrl.accountModel.sendEmailButtonText| translate}}<i></i></button><div class=\"resend-collapse accordion\"><div class=\"collapse-icon\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\"><img src=\"ute-easy-login-registration/assets/arrow_drop.png\" alt=\"\"></div><button class=\"ute-button-blue-no-decor\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\">{{\'ute.easy.login.registration.verify.didntGetEmail\' | translate}}</button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><ul><li>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.checkSpam\' | translate}}</li><li>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.giveFewMinutes\' | translate}}</li></ul><button class=\"ute-secondary-button state-btn\" ng-click=\"$ctrl.isResendEmail = true; $ctrl.rogersResendEmail($ctrl.accountModel.emailGenerationToken, \'resend\')\" ng-class=\"$ctrl.getLoadingClass(\'secondary\')\" ng-disabled=\"$ctrl.resendState\">{{$ctrl.accountModel.reSendButtonText| translate}}<i></i></button> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.sendToDifferentEmail()\">{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.sendToDifferentEmail\'| translate}}</button><div class=\"need-help\"><span>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.stillNeedHelp\' | translate}}</span> <span translate-compile=\"\" translate=\"ute.easy.login.common.liveChat\"></span></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-complete.html","<div class=\"ute-elr-complete\"><div class=\"elr-header mb-hidden\">{{\'ute.easy.login.registration.complete.header\' | translate}}</div><div class=\"contest_bannerstep5\" ng-if=\"$ctrl.showContestBanner\"><div class=\"contest_banner_holder\"><div class=\"img_holder\"><img src=\"ute-easy-login-registration/assets/rogers_visa_card.png\" alt=\"\" class=\"img-responsive\"></div><div class=\"text_holder\" ng-if=\"$ctrl.showContestBanner\"><p translate=\"ute.easy.login.registration.contest_banner_step5_desc\"></p></div></div><span translate=\"ute.easy.login.registration.contest_banner_step5_subtext1\"></span> <span translate=\"ute.easy.login.registration.contest_banner_step5_subtext2\"></span></div><div class=\"elr-info-header\" ng-bind-html=\"\'ute.easy.login.registration.complete.message\' | translate\"></div><button class=\"ute-primary-button mb-wide\" ng-click=\"$ctrl.loginRogers(\'accountOverview\');\">{{ \'ute.easy.login.registration.complete.goToSignin\' | translate }}</button><div class=\"other-account-text\">{{\'ute.easy.login.registration.complete.haveOtherAccounts\' | translate}}</div><button class=\"ute-button-blue-no-decor\" ng-click=\"$ctrl.loginRogers(\'linkaccount\')\">{{\'ute.easy.login.registration.complete.linkAccounts\' | translate}}</button></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-email.html","<div class=\"ute-elr-email\"><div class=\"elr-header mb-hidden\">{{\'ute.easy.login.registration.email.header\' | translate}}</div><div class=\"inline-error\" translate-compile=\"\" data-translate-values=\"{maskedEmail: $ctrl.emailModel.maskedEmail}\" translate=\"ute.easy.login.error.{{$ctrl.emailModel.generalError}}\"></div><div class=\"email-form\"><form novalidate=\"\" name=\"$ctrl.emailForm\"><div class=\"email\"><label for=\"email\">{{\'ute.easy.login.registration.email.enterEmail\' | translate}}</label> <input type=\"email\" name=\"email\" ng-model=\"$ctrl.emailModel.email\" required=\"\"><div class=\"inline-error\" translate=\"ute.easy.login.error.{{$ctrl.emailModel.emailError}}\"></div></div><div class=\"confirm-email\"><label for=\"confirmEmail\">{{\'ute.easy.login.registration.email.reEnterEmail\' | translate}}</label> <input type=\"email\" name=\"confirmEmail\" ng-model=\"$ctrl.emailModel.confirmEmail\" required=\"\"></div><div class=\"buttons flex-container v-middle sm-wrap-reverse\"><button class=\"ute-button-blue-no-decor\" type=\"button\" ng-click=\"$ctrl.backStep($ctrl.STEP.ACCOUNT)\">{{\'ute.easy.login.common.back\' | translate}}</button> <button class=\"ute-primary-button mb-wide\" type=\"button\" ng-class=\"$ctrl.getLoadingClass()\" ng-click=\"$ctrl.rogersEmailFormValidation($ctrl.emailForm)\">{{\'ute.easy.login.common.continue\' | translate}}</button></div></form></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-main.html","<div class=\"elr-header\">{{\'ute.easy.login.registration.header\' | translate}}</div><div class=\"flex-container h-space-between sm-flex-wrap main-content\"><div class=\"one-or-more mb-wide\"><div class=\"rogers-red-header\">{{\'ute.easy.login.registration.oneOrMore\' | translate}}</div><div class=\"product-glyph\"><ul class=\"icons\"><li class=\"i-wireless\"></li><li class=\"i-internet\"></li><li class=\"i-tv\"></li><li class=\"i-home\"></li><li class=\"i-landline\"></li></ul></div><div class=\"product-list\"><ul><li>{{\'ute.easy.login.registration.wireLess\' | translate}}</li><li>{{\'ute.easy.login.registration.internet\' | translate}}</li><li>{{\'ute.easy.login.registration.tv\' | translate}}</li><li>{{\'ute.easy.login.registration.homeMonitoring\' | translate}}</li><li>{{\'ute.easy.login.registration.homePhone\' | translate}}</li></ul></div><button class=\"ute-primary-button mb-wide\" ng-click=\"$ctrl.changeStep($ctrl.STEP.ACCOUNT)\">{{\'ute.easy.login.registration.services\' | translate}}</button> <button class=\"$ctrl.tempSetFidoLoginParams(\'leo.leona123@mailinator.com\', \'canada123\')\" style=\"display:none;\">SIGNIN</button></div><div class=\"prepaid mb-wide\"><div class=\"rogers-red-header\" ng-bind-html=\"\'ute.easy.login.registration.payAsYouGoWireless\' | translate\"></div><div class=\"product-glyph\"><ul class=\"icons\"><li class=\"i-wireless\"></li></ul></div><button class=\"ute-primary-button mb-wide\" ng-click=\"$ctrl.redirect(\'#/sso/registration\')\">{{\'ute.easy.login.registration.payAsYouGoService\' | translate}}</button></div><div class=\"business-misc mb-wide\"><div class=\"not-a-customer-widget\"><div class=\"nc-header\">{{\'ute.easy.login.registration.noRogersServices\' | translate}}</div><div class=\"nc-body\"><div class=\"nc-text1\">{{\'ute.easy.login.registration.rogersServicesNotAvailable\' | translate}}</div><div class=\"nc-text2\">{{\'ute.easy.login.registration.seeWhatWeCanDo\' | translate}}</div><button class=\"ute-secondary-button mb-wide\" ng-click=\"$ctrl.redirect(\'/consumer/shop\')\">{{\'ute.easy.login.registration.shop\' | translate}}</button></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-password.html","<div class=\"ute-elr-password\"><div class=\"elr-header mb-hidden\">{{\'ute.easy.login.registration.password.header\' | translate}}</div><div class=\"inline-error\" translate-compile=\"\" translate=\"ute.easy.login.error.{{$ctrl.passwordModel.generalError}}\"></div><div class=\"password-form\"><form name=\"$ctrl.passwordForm\"><div class=\"password\"><div class=\"label-content\"><label for=\"password\">{{\'ute.easy.login.registration.password.enterPassword\' | translate}}</label> <button class=\"ute-button-blue-no-decor\" type=\"button\" ng-click=\"$ctrl.setPasswordInputType(\'passwordType\')\" translate=\"ute.easy.login.common.{{$ctrl.passwordModel.passwordType}}\"></button></div><input type=\"{{$ctrl.passwordModel.passwordType}}\" ng-change=\"$ctrl.onPasswordInputChange()\" maxlength=\"64\" class=\"password-field\" name=\"password\" id=\"password\" ng-model=\"$ctrl.passwordModel.password\" required=\"\" autocapitalize=\"off\" spellcheck=\"false\" autocorrect=\"off\"><div class=\"inline-error\" translate=\"ute.easy.login.registration.password.{{$ctrl.passwordModel.passwordError}}\"></div><div class=\"password-validator\"><div class=\"pss-header\">{{\'ute.easy.login.registration.password.passwordMustHave\' | translate}}</div><div class=\"invalid-red\" ng-class=\"{\'success-green\': $ctrl.passwordModel.passwordIsValid}\"><span ng-if=\"$ctrl.passwordModel.passwordIsValid\"><i class=\"rogers-icon-circle-solid-check\"></i></span> <span ng-if=\"!$ctrl.passwordModel.passwordIsValid\"><i class=\"rogers-icon-circle-solid-minus\"></i></span> {{\'ute.easy.login.registration.password.passwordAtLeast\' | translate}}</div><div class=\"invalid-red\" ng-class=\"{\'success-green\': $ctrl.passwordModel.passwordIsEnough}\"><span ng-if=\"$ctrl.passwordModel.passwordIsEnough\"><i class=\"rogers-icon-circle-solid-check\"></i></span> <span ng-if=\"!$ctrl.passwordModel.passwordIsEnough\"><i class=\"rogers-icon-circle-solid-minus\"></i></span> {{\'ute.easy.login.registration.password.passwordMinimum\' | translate}}</div><div>{{\'ute.easy.login.registration.password.passwordCanInclude\' | translate}}</div></div></div><div class=\"confirm-password\"><div class=\"label-content\"><label for=\"confirmPassword\">{{\'ute.easy.login.registration.password.reEnterPassword\' | translate}}</label> <button class=\"ute-button-blue-no-decor\" type=\"button\" ng-click=\"$ctrl.setPasswordInputType(\'confirmPasswordType\')\" translate=\"ute.easy.login.common.{{$ctrl.passwordModel.confirmPasswordType}}\"></button></div><input type=\"{{$ctrl.passwordModel.confirmPasswordType}}\" class=\"password-field\" ng-change=\"$ctrl.onConfirmPasswordInputChange()\" name=\"confirmPassword\" id=\"confirmPassword\" ng-model=\"$ctrl.passwordModel.confirmPassword\" required=\"\" autocapitalize=\"off\" spellcheck=\"false\" autocorrect=\"off\"><div class=\"password-validator\" ng-class=\"{\'success-green\': $ctrl.passwordModel.confirmPasswordType}\"><div class=\"invalid-red\" ng-class=\"{\'success-green\': $ctrl.passwordModel.confirmPasswordIsValid}\"><span ng-if=\"$ctrl.passwordModel.confirmPasswordIsValid\"><i class=\"rogers-icon-circle-solid-check\"></i></span> <span ng-if=\"!$ctrl.passwordModel.confirmPasswordIsValid\"><i class=\"rogers-icon-circle-solid-minus\"></i></span> {{\'ute.easy.login.registration.password.bothPasswordMatch\' | translate}}</div></div></div><div class=\"set-password mb-wide\"><button class=\"ute-primary-button mb-wide\" ng-class=\"$ctrl.getLoadingClass()\" type=\"button\" ng-click=\"$ctrl.rogersValidatePassword($ctrl.passwordForm)\">{{\'ute.easy.login.registration.password.setPassword\' | translate}}</button></div></form></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLogin-step-verify.html","<div class=\"ute-elr-verify\"><div class=\"elr-header mb-hidden\">{{\'ute.easy.login.registration.verify.header\' | translate}}</div><div class=\"elr-verify-info\"><div class=\"verify-icon\"><img src=\"ute-easy-login-registration/assets/mail.png\" alt=\"\"></div><div class=\"verify-text-container\"><div ng-bind-html=\"\'ute.easy.login.registration.verify.message\' | translate\"></div><div><span ng-bind-html=\"\'ute.easy.login.registration.verify.messageSentTo\' | translate\"></span> &nbsp; <span>{{$ctrl.maskEmailAddress($ctrl.emailModel.email)}}</span></div></div></div><div class=\"resend-collapse accordion\"><div class=\"collapse-icon\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\"><img src=\"ute-easy-login-registration/assets/arrow_drop.png\" alt=\"\"></div><button class=\"ute-button-blue-no-decor\" ng-click=\"$ctrl.isResendWidgetCollapsed = !$ctrl.isResendWidgetCollapsed\">{{\'ute.easy.login.registration.verify.didntGetEmail\' | translate}}</button></div><div class=\"resend-collapse-panel\" collapse=\"$ctrl.isResendWidgetCollapsed\"><ul><li>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.checkSpam\' | translate}}</li><li>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.giveFewMinutes\' | translate}}</li></ul><button class=\"ute-secondary-button state-btn\" ng-click=\"$ctrl.isResendEmail = true; $ctrl.rogersResendEmail($ctrl.accountModel.emailGenerationToken, \'resend\')\" ng-disabled=\"$ctrl.resendState\">{{$ctrl.accountModel.reSendButtonText | translate}}<i></i></button> <button class=\"ute-secondary-button\" ng-click=\"$ctrl.sendToDifferentEmail()\">{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.sendToDifferentEmail\'| translate}}</button><div class=\"need-help\"><span>{{\'ute.easy.login.registration.verify.didntGetEmailExpanded.stillNeedHelp\' | translate}}</span> <span translate-compile=\"\" translate=\"ute.easy.login.common.liveChat\"></span></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLoginRegistration.html","<div class=\"ute-easy-login-registration ute-elr-registration-page\"><ng-include class=\"mb-hidden\" src=\"\'module/easyLoginRegistration/templates/rogers/easyLoginRegistrationNav.html\'\"></ng-include><div class=\"dk-hidden elr-header\" translate=\"ute.easy.login.registration.step_{{$ctrl.getStepLowerCase($ctrl.step)}}_header\"></div><ng-include ng-if=\"$ctrl.step !== $ctrl.STEP.MAIN\" src=\"\'module/easyLoginRegistration/templates/rogers/step.partial.html\'\"></ng-include><div class=\"container\"><ng-include src=\"$ctrl.getCurrentStepTemplate()\"></ng-include></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/easyLoginRegistrationNav.html","<div class=\"ute-elr-navigation flex-container v-middle\"><div class=\"container\"><div class=\"nav-inner flex-container v-middle\"><div class=\"elr-brand\">{{\'ute.easy.login.common.myRogers\' | translate}}</div><div class=\"elr-page flex-container v-middle\">{{\'ute.easy.login.common.register\' | translate}}</div><div class=\"elr-account\" ng-if=\"$ctrl.isAutoRegistrationStarted\">{{\'ute.easy.login.common.account\' | translate}} <span>{{$ctrl.accountModel.accountNumber}}</span></div><div class=\"elr-route\"></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/emailVerificationModal.html","<div class=\"ute-easy-login-registration\"><div class=\"ute-elr-email-verification-modal\"><div class=\"elr-modal-header flex-container v-middle\"><div class=\"secure-content flex-container v-middle\"><div class=\"secure-icon\"><img src=\"ute-easy-login-registration/assets/security-lock.png\" alt=\"\"></div><div class=\"secure-text\">{{\'ute.easy.login.common.secure\' | translate}}</div></div></div><div class=\"ute-elr-modal-body\"><div ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.processing\"><div class=\"image-aligner\"><img src=\"ute-common-assets/assets/widget-loader-lg_plain.gif\" alt=\"\"></div><div class=\"ute-elr-modal-flow-text\">{{\'ute.easy.login.registration.email.verify.verifyingLink\' | translate}}</div></div><div ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.success\"><div class=\"image-aligner flex-container h-middle\"><img src=\"ute-easy-login-registration/assets/success_lg.png\" style=\"background: white; border-radius:100%;\" alt=\"\"></div><div class=\"ute-elr-modal-flow-text\">{{\'ute.easy.login.registration.email.verify.linkVerified\' | translate}}</div></div><div ng-if=\"$ctrl.step === $ctrl.MODAL_STEP.invalid\"><div class=\"image-aligner flex-container h-middle\"><img src=\"ute-common-assets/assets/warning_yellow_lg.png\" alt=\"\"></div><div class=\"ute-elr-modal-flow-text\">{{\'ute.easy.login.registration.email.verify.linkExpired\' | translate}}</div></div></div></div></div>");
$templateCache.put("module/easyLoginRegistration/templates/rogers/step.partial.html","<div class=\"container\" ng-if=\"!$ctrl.isAutoRegistrationStarted\" style=\"margin-bottom: 0px;\"><div class=\"steps-container\"><div ng-repeat=\"step in $ctrl.stepManager\" ng-if=\"$index !== 0\" ng-class=\"$ctrl.getStepClasses($index)\"><div class=\"step-rail\"><div></div><div></div></div><div class=\"step-indicator\">{{$index}}</div><div class=\"step-text\" translate=\"ute.easy.login.registration.step.{{$ctrl.getStepLowerCase($index)}}\"></div></div></div></div>");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/modal.view.html","<div class=\"ute-janrain-resend-email-modal-content\" ng-if=\"!errorModal.updateSuccessful\"><form name=\"errorModal.form\" novalidate=\"\"><div data-ng-if=\"!errorModal.successMessageKey\"><div class=\"ute-janrain-resend-email-modal-headingGroup\"><div class=\"ute-janrain-resend-email-modal-heading\"><span data-translate=\"{{errorModal.errorCode.errorTitleMessageKey}}\"></span></div></div><div class=\"ute-janrain-resend-email-modal-typeGroup\"><div class=\"ute-janrain-resend-email-modal-typeBody\"><span data-translate=\"{{errorModal.errorCode.errorSubTitleMessageKey}}\"></span></div></div></div><div data-ng-if=\"errorModal.successMessageKey\" class=\"ute-janrain-success\"><img class=\"ute-janrain-success-icon\" src=\"ute-common-assets/assets/success.png\"> <span class=\"ute-janrain-success-messageBody\" data-translate=\"{{errorModal.successMessageKey}}\" data-translate-values=\"{email: \'{{errorModal.model.email}}\'}\"></span></div><div data-ng-if=\"errorModal.errorMessageKey\" class=\"ute-janrain-resend-email-modal-errorMessage\"><img class=\"ute-janrain-resend-email-modal-messageIcon\" src=\"ute-common-assets/assets/error_warning.png\"><div class=\"ute-janrain-resend-email-modal-messageBody\"><ute-dtm-error-form-field key=\"errorModal.tagName\" error-prefix=\"SS\"></ute-dtm-error-form-field><span data-translate=\"{{errorModal.errorMessageKey}}\"></span></div></div><div ng-if=\"!errorModal.successMessageKey\" class=\"row\"><div class=\"col-xs-12 col-sm-6 col-sm-push-6 col-md-6 col-md-push-6 col-lg-6 col-lg-push-6\"></div><div class=\"col-xs-12 col-sm-6 col-sm-pull-6 col-md-6 col-md-pull-6 col-lg-6 col-lg-pull-6\"><div class=\"ute-janrain-resend-email-modal-inputGroup\"><input data-ng-class=\"(errorModal.form.email.$invalid && errorModal.form.$submitted) ? \'ute-janrain-resend-email-modal-inputTextError\' : \'ute-janrain-resend-email-modal-inputText\'\" type=\"text\" name=\"email\" id=\"email\" data-ng-model=\"errorModal.model.email\" required=\"\" data-ng-required=\"true\" data-ng-click=\"errorModal.inputOnClick($event)\" data-ng-pattern=\"/^[a-z0-9!#$%&\'*+\\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i\" translate=\"\" data-translate-attr-placeholder=\"ute.common.label.email.address\" maxlength=\"105\" data-onpaste=\"return false;\" data-autocorrect=\"off\" data-autocapitalize=\"off\"></div><div class=\"ute-janrain-resend-email-modal-buttonGroupFlush\"><button name=\"button_cancel\" class=\"ute-janrain-resend-email-modal-cancel\" data-ng-click=\"errorModal.cancel()\"><span data-translate=\"ute.janrain.verification.modalPopup.cancel\"></span></button> <button name=\"button_continue\" class=\"ute-janrain-resend-email-modal-submit\" data-ng-click=\"errorModal.submit(errorModal.errorCode.backendCode)\" data-ng-disabled=\"errorModal.isCallInProgress()\"><span data-translate=\"ute.janrain.verification.modalPopup.submit\"></span></button> <span class=\"ute-janrain-resend-email-modal-buttonLoader\" data-ng-show=\"errorModal.isCallInProgress()\"><img src=\"ute-common-assets/assets/widget-loader.gif\"></span></div></div></div></form></div><div data-ng-show=\"errorModal.updateSuccessful\"><div class=\"ute-janrain-resend-email-modal-modalHeadingGroup\"><img class=\"ute-janrain-resend-email-modal-modalHeadingIcon\" src=\"ute-common-assets/assets/green-checkbox.png\"><div class=\"ute-janrain-resend-email-modal-modalHeading\" data-translate=\"ute.janrain.verification.responseMessage.successTitle\"></div></div><div class=\"ute-janrain-resend-email-modal-modalTypeGroup\"><div class=\"ute-janrain-resend-email-modal-modalTypeBody\"><span data-translate=\"ute.janrain.verification.responseMessage.successMessage\"></span></div></div></div><img class=\"ute-janrain-resend-email-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/modal.view.ignore.html","<div class=\"ute-simCard-modalHeadingGroup\"><img src=\"\" class=\"ute-simCard-modalHeadingIcon\" data-ng-src=\"{{errorModal.getModalIcon()}}\"><div class=\"ute-simCard-modalHeading\" data-translate=\"ute.rogers.myrSimCard.simCardConfirmation.sorry\"></div></div><div class=\"ute-simCard-modalTypeGroup\"><div class=\"ute-simCard-modalTypeBody\"><div style=\"font-size:22px;\"><div style=\"display: inline;\" data-translate=\"{{errorModal.getFrontendMessageKey()}}\"></div></div></div></div><bold-chat-static-button data-cbid=\"\'string\'\" dynamic-div=\"\'string\'\" data-chat-button=\"\'string\'\"></bold-chat-static-button><img class=\"ute-simCard-modalClose\" data-ng-click=\"errorModal.noSelection()\" src=\"ute-common-assets/assets/close-icon.png\">");
$templateCache.put("module/janrainVerification/resendEmail/askEmail/window.view.html","<div data-modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\" data-uib-modal-animation-class=\"fade\" data-modal-in-class=\"in\" data-ng-style=\"{\'z-index\': 1050 + index*10, display: \'block\'}\"><div class=\"modal-dialog {{size ? \'modal-\' + size : \'\'}}\"><div class=\"ute-janrain-resend-email-modal-container modal-content\" data-ng-transclude=\"\"></div></div></div>");
$templateCache.put("module/janrainVerification/resendEmail/confirmation/view.html","<div class=\"resendEmail-confirmation\"><div class=\"container\"><div class=\"row\"><ul class=\"my-rogers-breadcrumb\"><li class=\"parent\"><a href=\"/\" data-translate=\"ute.common.label.myRogers\"></a></li><li class=\"child-1\"><span data-translate=\"ute.rogers.user.registration.email.verification\"></span></li></ul></div><div class=\"mbl\"></div><div class=\"row desc-font-size-18\"><div class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\"><div data-translate=\"ute.rogers.user.registration.email.verification.msg\"></div><p><span data-translate=\"ute.rogers.user.registration.email.verfication.your.email\"></span> <strong data-ng-bind=\"::resendEmail.getEmail()\"></strong></p></div></div></div></div>");
$templateCache.put("module/paymentMethod/templates/ovoPaymentWidget/paymentMethodCCInformation.html","<div class=\"ute-payment-method\"><div class=\"ovo-payment-widget-credit-card-info\"><div class=\"widget-loader\" ng-if=\"paymentMethod.isPaymentMethodLoading\"><img ng-src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div><div ng-if=\"!(paymentMethod.isPaymentMethodLoading || paymentMethod.isMethodOfPaymentUnavailable)\"><div ng-if=\"paymentMethod.showCreditPaymentMethodInformation()\"><div class=\"cc-expiring\" ng-if=\"paymentMethod.isCCExpiring && !paymentMethod.isCCExpired\"><div class=\"message-text\"><span class=\"rui-icon-alert-i icon\"></span><span translate=\"ute.payment.method.ovo_pw_cc_info.will_expire_days\" translate-values=\"{days:paymentMethod.getDaysToExpire()}\"></span></div><div class=\"update-link\"><a class=\"edit-icon\" ng-click=\"paymentMethod.updatePaymentMethod(true)\"><span translate=\"ute.payment.method.ovo_pw_cc_info.cc_link_text\"></span></a></div></div><div class=\"cc-expired\" ng-if=\"paymentMethod.isCCExpired\"><div class=\"message-text\"><span class=\"rui-icon-alert-i icon\"></span><span translate=\"ute.payment.method.ovo_pw_cc_info.is_expired_msg\"></span></div><div class=\"update-link\"><a class=\"edit-icon\" ng-click=\"paymentMethod.updatePaymentMethod(true)\"><span translate=\"ute.payment.method.ovo_pw_cc_info.cc_link_text\"></span></a></div></div></div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/recent.payment.success.message/recent.payment.success.message.view.html","<div data-ng-if=\"lastPayment.lastPaymentDetails.showSuccessfulMessage\" class=\"ute-pay-now-recent-payment-success-message container\"><div class=\"col-xs-2 col-sm-2 col-md-1 col-lg-1 ute-pay-now-recent-payment-success-message-left\"><img src=\"ute-common-assets/assets/green-checkbox-alt.png\"></div><div class=\"col-lg-11 col-md-11 col-sm-10 col-xs-10 ute-pay-now-recent-payment-success-message-right row\"><div class=\"col-lg-9 col-md-9 col-sm-12 col-xs-12\"><span class=\"first-line\" data-translate=\"ute.payment.ui.payNow.thankYouMessage\"></span> <span class=\"first-line\">{{lastPayment.lastPaymentDetails.paymentAmount | currency}}</span><br><span data-translate=\"ute.payment.ui.payNow.confirmationMessage\"></span></div><div data-ng-if=\"lastPayment.lastPaymentDetails.paymentReferenceId\" class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3\"><div class=\"reference-number-label\" data-translate=\"ute.payment.ui.payNow.paymentReferenceId\"></div><div class=\"reference-number\">{{lastPayment.lastPaymentDetails.paymentReferenceId}}</div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/merchantAddressFooter.partial.html","<div class=\"col-xs-12\"><div class=\"ute-pay-now-modalTypeBody-bottom\"><div class=\"ute-pay-now-merchant-address-container\"><span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.merchantDetails\"></span> <span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.companyName\"></span> <span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.streetAddress\"></span> <span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.cityAndProv\"></span> <span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.postalCode\"></span> <span class=\"ute-pay-now-merchant-address\" translate=\"ute.payment.ui.payNow.country\"></span></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/payNowBank.partial.html","<div class=\"ute-pay-now-row-container paynow-bank-block\"><div class=\"bank-pay-information-block\"><div class=\"bpi-header\" translate=\"ute.payment.ui.payNow.bank_pay_header\"></div><div class=\"flex-container v-middle v-start inst-list-item\"><div class=\"bpi-inst-list-item flex-container v-middle h-middle\">1</div><div class=\"bpi-inst-list-item-text\" translate=\"ute.payment.ui.payNow.bp_inst_item1\"></div></div><div class=\"flex-container v-middle v-start inst-list-item\"><div class=\"bpi-inst-list-item flex-container v-middle h-middle\">2</div><div class=\"bpi-inst-list-item-text\" translate=\"ute.payment.ui.payNow.bp_inst_item2\"></div></div><div class=\"flex-container v-middle v-start inst-list-item\"><div class=\"bpi-inst-list-item flex-container v-middle h-middle\">3</div><div class=\"bpi-inst-list-item-text\" translate=\"ute.payment.ui.payNow.bp_inst_item3\"></div></div><div class=\"bpi-rogers-payee-info\"><div class=\"rogers-payee-name\"><div class=\"rogers-payee-headear\" translate=\"ute.payment.ui.payNow.bp_payee_header\"></div><div class=\"rogers-payee-text\" translate-values=\"{length:utePayNowModal.getAccountNumber().length}\" translate=\"ute.payment.ui.payNow.bp_payee_name\"></div></div><div class=\"rogers-payee-account\"><div class=\"rogers-payee-headear\" translate=\"ute.payment.ui.payNow.bp_payee_account_header\"></div><div class=\"rogers-payee-text\">{{utePayNowModal.getAccountNumber()}}</div></div></div></div><div class=\"bank-selection-block\"><div class=\"bsb-header\" translate=\"ute.payment.ui.payNow.bp_bank_selection_header\"></div><div class=\"bank-sprite flex-container h-middle\"><img src=\"/cms/images/banks/banks.png\" usemap=\"#paynowBankMapping\"><map name=\"paynowBankMapping\"><area alt=\"{{\'ute.payment.ui.payNow.banks.td\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.td\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.TD)\" shape=\"poly\" coords=\"7,7,84,7,84,57,7,57\"><area alt=\"{{\'ute.payment.ui.payNow.banks.atb\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.atb\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.ATB)\" shape=\"poly\" coords=\"107,7,185,7,183,56,108,56\"><area alt=\"{{\'ute.payment.ui.payNow.banks.rbc\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.rbc\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.RBC)\" shape=\"poly\" coords=\"206,5,286,5,286,57,207,56\"><area alt=\"{{\'ute.payment.ui.payNow.banks.bmo\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.bmo\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.BMO)\" shape=\"poly\" coords=\"7,72,85,72,86,122,6,122\"><area alt=\"{{\'ute.payment.ui.payNow.banks.scotiabank\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.scotiabank\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.SCOTIABANK)\" shape=\"poly\" coords=\"106,74,185,74,183,124,107,123\"><area alt=\"{{\'ute.payment.ui.payNow.banks.cibc\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.cibc\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.CIBC)\" shape=\"poly\" coords=\"204,73,286,73,286,124,205,123\"><area alt=\"{{\'ute.payment.ui.payNow.banks.desjardins\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.desjardins\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.DESJARDINS)\" shape=\"poly\" coords=\"7,140,86,139,85,190,6,191\"><area alt=\"{{\'ute.payment.ui.payNow.banks.nationalbank\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.nationalbank\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.NATIONALBANK)\" shape=\"poly\" coords=\"106,139,184,139,186,189,106,189\"><area alt=\"{{\'ute.payment.ui.payNow.banks.tangerine\' | translate}}\" title=\"{{\'ute.payment.ui.payNow.banks.tangerine\' | translate}}\" ng-click=\"utePayNowModal.selectBank(utePayNowModal.BANK.TANGERINE)\" shape=\"poly\" coords=\"206,139,286,140,287,191,206,191\"></map></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/payNowInterac.partial.html","<div class=\"ute-pay-now-row-container\"><div class=\"row\"><div class=\"col-md-4 col-xs-12 interacImage\" style=\"padding: 0;\"><img src=\"ute-common-assets/assets/payment/interac.png\" class=\"interac-image\"></div><div class=\"col-md-8 col-xs-12 interac-message1\" translate=\"ute.payment.ui.payNow.payNowWithInterac\"></div></div><div class=\"interac-message2\" translate=\"ute.payment.ui.payNow.interacFirstPageMessage1\"></div><button class=\"ute-pay-now-continueButton\" data-ng-click=\"utePayNowModal.processInteracPayment()\" data-ng-disabled=\"!utePayNowModal.canProcessPayment()\" translate=\"ute.payment.ui.payNow.goToInteracButton\" title=\"{{\'ute.payment.ui.payNow.interacButtonTitle\' | translate}}\"></button><br><div class=\"interac-message2\"><span translate=\"ute.payment.ui.payNow.interacFirstPageMessage2\"></span> <a data-ng-click=\"utePayNowModal.switchToCreditOrDebit()\" translate=\"ute.payment.ui.payNow.interacCreditOrDebitLink\"></a></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/payNowMain.modal.html","<div class=\"modal-dialog\" ng-class=\"utePayNowModal.getModalDialogClass()\"><div class=\"ute-pay-now-modal modal-content\"><div class=\"{{utePayNowModal.getModalContentClass()}}\"><img class=\"ute-pay-now-modalClose\" data-ng-click=\"utePayNowModal.close()\" src=\"ute-common-assets/assets/close-icon.png\" ng-if=\"utePayNowModal.showCancelButton() === true\"><div class=\"ute-pay-now-modal-header-overlay-header\" ng-if=\"utePayNowModal.isDuplicate() === false\"><div class=\"{{utePayNowModal.getHeaderLogoClass()}}\"><img class=\"ute-pay-now-modalHeadingIcon\" src=\"ute-common-assets/assets/security-lock.png\" style=\"width: 30px\"><div class=\"ute-pay-now-modalTopHeading\" translate=\"ute.common.form.secured\"></div><div class=\"ute-pay-now-heading\" translate=\"ute.payment.ui.payNow.makeAPayment\"></div></div></div><div data-ng-include=\"\'module/paymentUI/payNow/templates/shared/paymentError.partial.html\'\"></div><div class=\"ute-pay-now-status-text pn-pay-received\" ng-if=\"utePayNowModal.isPaymentReceived()\" translate=\"ute.payment.ui.payNow.paymentReceived\"></div><div class=\"ute-pay-now-status-text\" ng-if=\"utePayNowModal.isPaymentMethodCard() && utePayNowModal.isProcessing()\" translate=\"ute.payment.ui.payNow.processingPayment\"></div><div ng-if=\"utePayNowModal.isPaymentMethodInterac() && utePayNowModal.isProcessing()\"><div class=\"ute-pay-now-status-text\" translate=\"ute.payment.ui.payNow.processingInteracPayment\"></div><div style=\"display: none;\"><form name=\"utePayNowModal.interacPaymentForm\" id=\"formToRogersInteracPayment\" method=\"post\" novalidate=\"\"><input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHNUM\" data-ng-model=\"utePayNowModal.formData.merchantNumber\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_TERMID\" data-ng-model=\"utePayNowModal.formData.termId\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_AMOUNT\" data-ng-model=\"utePayNowModal.formData.amount\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_CURRENCY\" data-ng-model=\"utePayNowModal.formData.currency\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_INVOICE\" data-ng-model=\"utePayNowModal.formData.invoice\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHDATA\" data-ng-model=\"utePayNowModal.formData.merchantData\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_FUNDEDURL\" data-ng-model=\"utePayNowModal.formData.fundedUrl\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_NOTFUNDEDURL\" data-ng-model=\"utePayNowModal.formData.nonFundedUrl\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_MERCHLANG\" data-ng-model=\"utePayNowModal.formData.merchantLanguage\"> <input data-tl-private=\"\" type=\"text\" name=\"IDEBIT_VERSION\" data-ng-model=\"utePayNowModal.formData.version\"></form></div></div><div class=\"ute-pay-now-modalTypeGroup\" ng-if=\"utePayNowModal.showContents() === true\"><div class=\"row\"><div class=\"ute-pn-left-body\"><div class=\"ute-pay-now-modalTypeBody-left\" data-ng-class=\"{\'ute-pay-now-modalTypeBody-review\' : utePayNowModal.isReviewStep(), \'ute-pay-now-no-border\': !utePayNowModal.isPaymentChannelSelected()}\" data-ng-include=\"\'module/paymentUI/payNow/templates/payNowMain.partial.html\'\"></div></div><div class=\"ute-pn-right-body\" id=\"payNowRightBody\"><div class=\"ute-pay-now-modalTypeBody-right\" data-ng-include=\"\'module/paymentUI/payNow/templates/payNowRightPane.partial.html\'\"></div></div></div><div class=\"hidden-xs\" ng-if=\"utePayNowModal.isConfirmationStep() && utePayNowModal.paymentReferenceId\" data-ng-include=\"\'module/paymentUI/payNow/templates/rogersPromoBanner.partial.html\'\"></div></div></div><div class=\"row ute-pay-now-footer\"><div data-ng-include=\"\'module/paymentUI/payNow/templates/merchantAddressFooter.partial.html\'\"></div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/payNowMain.partial.html","<div class=\"ute-pay-now-step-tracker-block\"><div class=\"row\"><div class=\"ute-pay-now-step-tracker\"><div ng-repeat=\"step in utePayNowModal.paymentSteps track by $index\" ng-if=\"step !== undefined\" ng-class=\"utePayNowModal.getStepGridClass()\" class=\"flex-container h-middle\"><div><div class=\"{{utePayNowModal.getStepClassName(step)}}\">{{step.index}}</div></div></div></div></div><div class=\"row\"><div ng-repeat=\"step in utePayNowModal.paymentSteps track by $index\" ng-if=\"step !== undefined\" ng-class=\"utePayNowModal.getStepGridClass()\" class=\"flex-container h-middle\"><div ng-class=\"{\'ute-pay-now-step-tracker-label-active\': (step.status === 0), \'ute-pay-now-step-tracker-label\': (step.status !== 0)}\" translate=\"{{step.name}}\"></div></div></div></div><div class=\"ute-pay-now-content\"><div ng-show=\"utePayNowModal.isPaymentStep() || utePayNowModal.isPayViaBankStep()\"><div class=\"ute-pn-balance-widget\"><div class=\"widget-inner-block\"><div ng-if=\"!utePayNowModal.isPaymentMethodBank()\"><div translate=\"ute.payment.ui.payNow.bp_account_balance\"></div><div>{{utePayNowModal.getCurrentBalance() | currency}}</div></div><div ng-if=\"utePayNowModal.isPaymentChannelSelected() && utePayNowModal.isPaymentMethodBank()\"><div><div translate=\"ute.payment.ui.payNow.bp_account_balance\"></div><div>{{utePayNowModal.getCurrentBalance() | currency}}</div></div><div><div translate=\"ute.payment.ui.payNow.bp_payment_amount\"></div><div>{{utePayNowModal.paymentAmount | currency}}</div></div></div></div></div><form name=\"utePayNowModal.payNowForm\" ng-if=\"utePayNowModal.showBalanceForm()\" novalidate=\"\"><div><div><label for=\"paymentAmount\" class=\"ute-pay-now-payment-amount-label\" translate=\"ute.payment.ui.payNow.paymentAmount\"></label></div><div><input type=\"text\" tabindex=\"1\" ute-currency=\"\" class=\"ute-pay-now-inputText payment-amount-input\" name=\"paymentAmount\" id=\"paymentAmount\" maxlength=\"10\" required=\"\" ng-min=\"0\" ng-blur=\"utePayNowModal.validateAmount()\" ng-focus=\"utePayNowModal.paymentAmountFocused()\" ng-model=\"utePayNowModal.paymentAmount\" autocomplete=\"off\" ng-model-options=\"{ debounce: 200 }\" ng-class=\"{\'ng-focused\': utePayNowModal.isPaymentAmountFocused}\"><div class=\"col-xs-12 ute-pay-now-inputTextLabelError\" ng-if=\"!utePayNowModal.isPaymentAmountFocused && utePayNowModal.amountErrors.inlineError !== \'overPaying\'\" translate=\"ute.payment.ui.payNow.{{utePayNowModal.amountErrors.inlineError}}\" translate-values=\"{threshHoldPaymentAmount: utePayNowModal.amountErrors.translateValue}\"></div><div class=\"col-xs-12 over-limit-message\" ng-if=\"!utePayNowModal.isPaymentAmountFocused && utePayNowModal.amountErrors.inlineError === \'overPaying\' && utePayNowModal.showOverLimitMessage\"><a class=\"close-messae-icon\" ng-click=\"utePayNowModal.closeOverLimitMessage()\"><img class=\"close-icon\" ng-click=\"vb.cancel($event)\" src=\"ute-common-assets/assets/close-icon-light.png\"></a><div class=\"message\" translate=\"ute.payment.ui.payNow.{{utePayNowModal.amountErrors.inlineError}}\" translate-values=\"{threshHoldPaymentAmount: utePayNowModal.amountErrors.translateValue}\"></div></div></div></div></form><div class=\"ute-pay-now-content-payment-method\"><div class=\"title\" translate=\"ute.payment.ui.payNow.paymentMethod\"></div><span class=\"hr-line\"></span><div ng-repeat=\"channel in utePayNowModal.paymentChannels\" class=\"payment-channel-radio-buttons\"><div class=\"ute-payment-method-radio-container\"><div class=\"radio-container myr-radio\"><input type=\"radio\" class=\"myr-radio-input\" ng-click=\"utePayNowModal.changePaymentChannel(channel)\" ng-model=\"utePayNowModal.paymentChannel\" value=\"{{channel.value}}\" id=\"{{channel.name}}\" ute-scroll=\"\" ute-scroll-is-active=\"utePayNowModal.isMobile()\" ute-scroll-selector=\"{{utePayNowModal.uteScrollSelector}}\" ute-scroll-target=\"utePayNowModal.uteScrollTarget\" ute-scroll-speed=\"slow\" name=\"paymentMethod\"> <label for=\"{{channel.name}}\" class=\"myr-radio\"></label></div><div class=\"text-container no-outline hover-hand\" ng-click=\"utePayNowModal.changePaymentChannel(channel)\"><span class=\"myr-radio-text\" translate=\"{{channel.copyResource}}\"></span></div><div ng-if=\"channel.messageResource\" class=\"text-container no-outline\"><span class=\"myr-radio-text\"><span class=\"cc-text radio-text-message\" translate=\"{{channel.messageResource}}\"></span></span></div><div class=\"float-clear\"></div></div></div></div><div class=\"bp-need-help\"><span translate=\"ute.payment.ui.payNow.need_help\"></span> <span><a href=\"https://www.rogers.com/customer/support/article/how-to-make-a-payment\" target=\"_blank\" translate=\"ute.payment.ui.payNow.how_to_pay\"></a></span></div></div><div class=\"ute-pay-now-payment-amount-section-desktop\" ng-if=\"utePayNowModal.isReviewStep()\"><div class=\"ute-pay-now-payment-amount-label\" translate=\"ute.payment.ui.payNow.paymentAmount\"></div><div class=\"row ute-pay-now-payment-amount-row\"><div class=\"ute-pay-now-payment-amount\">{{utePayNowModal.paymentAmount | currency}}</div><div class=\"ute-pay-now-payment-edit-link\" translate=\"ute.payment.ui.payNow.editPayment\" ng-click=\"utePayNowModal.goToStep(utePayNowModal.paymentStep)\"></div></div></div><div class=\"ute-pay-now-payment-success-message-box\" ng-if=\"utePayNowModal.isConfirmationStep()\"><div class=\"row\"><div class=\"col-xs-2 col-sm-1 col-md-2\" style=\"max-width: 47px; padding-top: 5px; margin-right: 5px;\"><img width=\"32px\" ng-src=\"ute-common-assets/assets/green-checkbox-alt.png\"></div><div class=\"col-xs-9 col-sm-10 col-md-9 headline\" translate=\"ute.payment.ui.payNow.paymentSuccessHeadline\"></div></div><div class=\"text\" translate=\"ute.payment.ui.payNow.confirmationMessage\"></div><div class=\"text\" ng-if=\"utePayNowModal.isSGIAccount()\" translate=\"ute.payment.ui.payNow.sgi_account_disclaimer\"></div><div class=\"text\" ng-if=\"utePayNowModal.wasPaymentMethodUpdated()\" translate=\"ute.payment.ui.payNow.paymentMethodUpdated\"></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/payNowRightPane.partial.html","<div ng-if=\"utePayNowModal.isPaymentChannelSelected() && (utePayNowModal.isPaymentStep() || utePayNowModal.isReviewStep() || utePayNowModal.isPayViaBankStep())\"><div ng-show=\"utePayNowModal.isPaymentMethodBank() && utePayNowModal.isPaymentStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/payNowBank.partial.html\'\"></div><div ng-show=\"utePayNowModal.isPaymentMethodBank() && utePayNowModal.isPayViaBankStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/payViaBank.partial.html\'\"></div><div ng-if=\"utePayNowModal.isCCAlreadySelected\" ng-show=\"utePayNowModal.isPaymentMethodCard() && utePayNowModal.isPaymentStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/shared/payNowCard.partial.html\'\"></div><div ng-show=\"utePayNowModal.isPaymentMethodInterac() && utePayNowModal.isPaymentStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/payNowInterac.partial.html\'\"></div></div><div ng-if=\"utePayNowModal.isReviewStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/reviewPayment.partial.html\'\"></div><div ng-if=\"utePayNowModal.isConfirmationStep()\" class=\"ute-pay-now-modalTypeBody\" ng-include=\"\'module/paymentUI/payNow/templates/successfulPayment.partial.html\'\"></div>");
$templateCache.put("module/paymentUI/payNow/templates/payViaBank.partial.html","<div class=\"ute-pay-now-row-container paynow-bank-block\"><div class=\"bank-pay-information-block\"><div class=\"bpi-header\" translate=\"ute.payment.ui.payNow.bp_pay_via_header\"></div><div class=\"flex-container v-middle inst-list-item\"><div class=\"bpi-bank-image\"><div class=\"bank-image-sprite\" ng-class=\"utePayNowModal.getBankImageClass()\"></div></div><div ng-click=\"utePayNowModal.bankReturnPreviousStep()\" translate=\"ute.payment.ui.payNow.bp_previous_step\">Return to previous step</div></div><div class=\"bpi-rogers-payee-info\"><div class=\"rogers-payee-name\"><div class=\"rogers-payee-headear\" translate=\"ute.payment.ui.payNow.bp_payee_header\"></div><div class=\"rogers-payee-text\" translate-values=\"{length:utePayNowModal.getAccountNumber().length}\" translate=\"ute.payment.ui.payNow.bp_payee_name\"></div></div><div class=\"rogers-payee-account\"><div class=\"rogers-payee-headear\" translate=\"ute.payment.ui.payNow.bp_payee_account_header\"></div><div class=\"rogers-payee-text\">{{utePayNowModal.getAccountNumber()}}</div></div></div></div><div class=\"how-to-bank-info\" translate=\"ute.payment.ui.payNow.bp_pay_complete_info\"></div><div class=\"bpi-divider\"></div><div class=\"bpi-support\"><div class=\"bpi-support-header\" translate=\"ute.payment.ui.payNow.need_help\"></div><div class=\"bpi-support-help-text\"><a href=\"https://www.rogers.com/customer/support/article/how-to-make-a-payment\" target=\"_blank\" translate=\"ute.payment.ui.payNow.bp_get_billing_support\"></a></div><div class=\"bpi-chat-block\"><div translate=\"ute.payment.ui.payNow.contact_us\"></div><div class=\"flex-container\"><div class=\"bpi-support-contact-number flex-container\"><div class=\"ute-icon-phone-v3\"></div><div class=\"mop-phone\" translate=\"ute.payment.ui.payNow.supportNumber\"></div></div><div class=\"bpi-live-chat\"><bold-chat-static-button data-cbid=\"{{\'ute.payment.ui.payNow.liveChatBank.cbid\' | translate}}\" data-dynamic-div=\"{{\'ute.payment.ui.payNow.liveChatBank.dynamicDiv\' | translate}}\" data-chat-button=\"{{\'ute.payment.ui.payNow.liveChatBank.chatButton\' | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/reviewPayment.partial.html","<div class=\"ute-pay-now-secure-cc-payment\" translate=\"ute.payment.ui.payNow.secureCCPayment\"></div><div class=\"ute-pay-now-secure-cc-payment-desc\" translate=\"ute.payment.ui.payNow.secureCCPaymentDesc\"></div><div class=\"ute-pay-now-payment-amount-section-devices\"><div class=\"ute-pay-now-payment-amount-label\" translate=\"ute.payment.ui.payNow.paymentAmount\"></div><div class=\"row ute-pay-now-payment-amount-row\"><div class=\"ute-pay-now-payment-amount\">{{utePayNowModal.paymentAmount | currency}}</div><div class=\"ute-pay-now-payment-edit-link\" translate=\"ute.payment.ui.payNow.editPayment\" ng-click=\"utePayNowModal.goToStep(utePayNowModal.paymentStep)\"></div></div></div><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.cardNumber\"></div><div class=\"ute-pay-now-text-small\"><img ng-src=\"{{utePayNowModal.paymentData.creditCardDetails.creditCardType.image}}\" style=\"width:36px;\"> {{utePayNowModal.paymentData.creditCardDetails.maskedCardNumber}}</div><div class=\"row ute-pay-now-label\"><div class=\"col-xs-6\" translate=\"ute.payment.ui.payNow.expiryDate\"></div><div class=\"col-xs-6\" translate=\"ute.payment.ui.payNow.paymentDate\"></div></div><div class=\"row ute-pay-now-text-small\"><div class=\"col-xs-6\">{{utePayNowModal.paymentData.creditCardDetails.expireDate.month}}/{{utePayNowModal.paymentData.creditCardDetails.expireDate.year}}</div><div class=\"col-xs-6 payment-date\"><span ng-bind-html=\"utePayNowModal.paymentDate | uteCanadianDate\"></span></div></div><div ng-if=\"utePayNowModal.paymentMethod === \'R\'\" class=\"ute-pay-now-use-card-for-auto-payment\"><div class=\"row\"><span data-test-id=\"ute-pay-now-pre-auth-credit\" class=\"col-xs-1 ute-pay-now-checkbox\"><input ng-model=\"utePayNowModal.setAutoPayment\" type=\"checkbox\" name=\"setAutoPayment\" id=\"setAutoPayment\" class=\"ute-pay-now-checkbox-input\"> <label for=\"setAutoPayment\" class=\"ute-pay-now-checkbox-box\"></label></span> <span class=\"col-xs-11 ute-pay-now-checkbox-text\" translate=\"ute.payment.ui.payNow.autoPaymentText\"></span></div></div><div class=\"row\"><div class=\"col-xs-12 col-md-7\"><button class=\"ute-pay-now-continueButton\" translate=\"ute.payment.ui.payNow.payNowButtonLabel\" ng-click=\"utePayNowModal.processCardPayment()\"></button></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/rogersPromoBanner.partial.html","<div class=\"pay-now-mastercard-container\"><div class=\"pay-now-mastercard-image-box\"><img alt=\"\" ng-if=\"utePayNowModal.language === \'en\'\" role=\"presentation\" src=\"ute-payment-ui/assets/images/rogers_mastercard_en.png\"> <img alt=\"\" ng-if=\"utePayNowModal.language === \'fr\'\" role=\"presentation\" src=\"ute-payment-ui/assets/images/rogers_mastercard_fr.png\"></div><div class=\"pay-now-mastercard-desc\" translate=\"ute.payment.ui.payNow.promoBanner\"></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/successfulPayment.partial.html","<div ng-if=\"utePayNowModal.isConfirmationStep()\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.paymentAmount\"></div><div class=\"ute-pay-now-payment-amount-green\">{{utePayNowModal.paymentAmount | currency}}</div></div><div ng-if=\"utePayNowModal.isConfirmationStep() && utePayNowModal.paymentReferenceId\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.paymentReferenceId\"></div><div class=\"ute-pay-now-text-small\">{{utePayNowModal.paymentReferenceId}}</div></div><div ng-if=\"utePayNowModal.isPaymentMethodCard()\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.cardNumber\"></div><div class=\"ute-pay-now-text-small\"><img style=\"width:32px;\" ng-src=\"{{utePayNowModal.creditCardDetails.creditCardType.image}}\"> {{utePayNowModal.creditCardDetails.maskedCardNumber}}</div></div><div ng-if=\"utePayNowModal.isPaymentMethodInterac()\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.paymentTypeLabel\"></div><div class=\"ute-pay-now-text-small\">Interac</div></div><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.paymentDate\"></div><div class=\"ute-pay-now-text-small extra-padding-bottom payment-date\"><span ng-bind-html=\"utePayNowModal.paymentDate | uteCanadianDate\"></span></div><div class=\"visible-xs\" ng-if=\"utePayNowModal.isConfirmationStep()\" data-ng-include=\"\'module/paymentUI/payNow/templates/rogersPromoBanner.partial.html\'\"></div><div class=\"row\"><div class=\"col-xs-12 col-md-7\"><button class=\"ute-pay-now-doneButton\" translate=\"ute.payment.ui.payNow.done\" ng-click=\"utePayNowModal.navigateToSuccessState()\"></button></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/autoBilling.partial.html","<div class=\"ute-pay-now-use-card-for-auto-payment\"><div class=\"row\"><span data-test-id=\"ute-pay-now-pre-auth-credit\" class=\"ute-pay-now-checkbox\"><input ng-model=\"utePayNowModal.setAutoPayment\" type=\"checkbox\" name=\"setAutoPayment\" id=\"setAutoPayment\" class=\"ute-pay-now-checkbox-input\"> <label for=\"setAutoPayment\" class=\"ute-pay-now-checkbox-box\"></label></span> <span class=\"ute-pay-now-checkbox-text\" translate=\"ute.payment.ui.payNow.ovPreAuthCheck\"></span></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/confirmation.partial.html","<div ng-class=\"utePayNowModal.wasPaymentMethodUpdated() ? \'ute-pay-now-confirmation-auto-payment-on\' : \'ute-pay-now-confirmation-auto-payment-off\'\"><div class=\"ute-pay-now-payment-success-message-box\"><div class=\"row\"><div class=\"ute-pay-now-confirmation-check-icon\"><img ng-src=\"ute-common-assets/assets/green-checkbox-alt.png\"></div><div class=\"ute-pay-now-confirmation-headline headline\" translate=\"ute.payment.ui.payNow.ovSuccess\"></div></div><div class=\"ute-pay-now-confirmation-email-msg\" translate=\"ute.payment.ui.payNow.ovDirections\"></div><div class=\"text\" ng-if=\"utePayNowModal.isSGIAccount()\" translate=\"ute.payment.ui.payNow.sgi_account_disclaimer\"></div><div class=\"ute-pay-now-confirmation-reference\"><span translate=\"ute.payment.ui.payNow.ovReference\"></span> {{ utePayNowModal.paymentReferenceId }}</div></div><div class=\"ute-pay-now-monthly-payment\" ng-if=\"utePayNowModal.wasPaymentMethodUpdated() || utePayNowModal.setAutoPayment\"><div class=\"ute-pay-now-monthly-payment-confirmation\" translate=\"ute.payment.ui.payNow.ovPreAuth\"></div><div class=\"ute-pay-now-monthly-payment-start\" translate=\"ute.payment.ui.payNow.ovPreAuthDirections\"></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/confirmationDetails.partial.html","<div class=\"ute-pay-now-confirmation-details\"><div class=\"ute-pay-now-confirmation-details-heading\" translate=\"ute.payment.ui.payNow.ovSecure\"></div><div class=\"ute-pay-now-confirmation-details-pay\"><div class=\"ute-pay-now-confirmation-details-pay-due\"><div class=\"ute-pay-now-confirmation-details-pay-due-heading\" translate=\"ute.payment.ui.payNow.ovPaymentAmount\"></div><div class=\"ute-pay-now-confirmation-due-amount\" ng-class=\"{\'ute-pay-now-sufficient-payment\': (utePayNowModal.remainingBalance <= 0)}\">{{ utePayNowModal.paymentAmount | currency }}</div></div><div class=\"ute-pay-now-confirmation-details-pay-remaining {{ utePayNowModal.getBalanceRemainingClass() }}\"><div class=\"ute-pay-now-confirmation-remaining-heading\" translate=\"ute.payment.ui.payNow.ovPaymentRemaining\"></div><div class=\"ute-pay-now-confirmation-remaining-amount {{ utePayNowModal.getBalanceRemainingClass() }}\">{{ utePayNowModal.remainingBalance | currency }}</div></div></div><div class=\"ute-pay-now-confirmation-details-cc-heading\" translate=\"ute.payment.ui.payNow.cardNumber\"></div><img ng-src=\"{{utePayNowModal.paymentData.creditCardDetails.creditCardType.image}}\" class=\"ute-pay-now-confirmation-details-cc-img\"><div class=\"ute-pay-now-confirmation-details-cc\">XXXX&nbsp;XXXX&nbsp;XXXX&nbsp;{{utePayNowModal.creditCardLastFour}}</div><div class=\"ute-pay-now-confirmation-details-expiry-heading\" translate=\"ute.payment.ui.payNow.expiryDate\"></div><div class=\"ute-pay-now-confirmation-details-expiry-date\">{{utePayNowModal.paymentData.creditCardDetails.expireDate.month}}/{{utePayNowModal.paymentData.creditCardDetails.expireDate.year}}</div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/modalHeader.partial.html","<div class=\"ute-pay-now-modal-header-overlay-header\"><div class=\"{{utePayNowModal.getHeaderLogoClass()}}\"><img class=\"ute-pay-now-modalHeadingIcon\" src=\"ute-common-assets/assets/security-lock.png\" style=\"width: 30px\"><div class=\"ute-pay-now-modalTopHeading\" translate=\"ute.common.form.secured\"></div><div class=\"ute-pay-now-modalTypeHeading\" translate=\"ute.payment.ui.payNow.oneViewTitle\"></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/payNowMainOv.modal.html","<div class=\"{{utePayNowModal.getModalContentClass()}} modal-dialog ute-pay-now-ov\"><img class=\"ute-pay-now-modalClose\" data-ng-click=\"utePayNowModal.close()\" src=\"ute-common-assets/assets/close-icon.png\" ng-if=\"utePayNowModal.showCancelButton() === true\"><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/modalHeader.partial.html\'\"></div><div ng-if=\"utePayNowModal.showContents() === true\" data-ng-include=\"\'module/paymentUI/payNow/templatesOv/paymentSteps.partial.html\'\"></div><div data-ng-include=\"\'module/paymentUI/payNow/templates/shared/paymentError.partial.html\'\"></div><div class=\"ute-pay-now-status-text\" ng-if=\"utePayNowModal.isPaymentReceived()\" translate=\"ute.payment.ui.payNow.paymentReceived\"></div><div class=\"ute-pay-now-status-text\" ng-if=\"utePayNowModal.isProcessing()\" translate=\"ute.payment.ui.payNow.processingPayment\"></div><div class=\"ute-pay-now-modalTypeGroup ute-pay-now-body-payment\" ng-show=\"utePayNowModal.isPaymentStep() && utePayNowModal.showContents() === true\"><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/paymentInput.partial.html\'\"></div><div ng-if=\"!utePayNowModal.isServerError()\" class=\"ute-pay-now-body-manual-entry\" data-ng-include=\"\'module/paymentUI/payNow/templates/shared/payNowCard.partial.html\'\"></div><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/autoBilling.partial.html\'\"></div></div><div class=\"ute-pay-now-modalTypeGroup ute-pay-now-body-review\" ng-show=\"utePayNowModal.isReviewStep() && utePayNowModal.showContents() === true\"><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/paymentInput.partial.html\'\"></div><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/review.partial.html\'\"></div></div><div class=\"ute-pay-now-body-confirm\" ng-show=\"utePayNowModal.isConfirmationStep() && utePayNowModal.showContents() === true\"><div class=\"col-xs-6\" data-ng-include=\"\'module/paymentUI/payNow/templatesOv/confirmation.partial.html\'\"></div><div class=\"col-xs-6\" data-ng-include=\"\'module/paymentUI/payNow/templatesOv/confirmationDetails.partial.html\'\"></div><div class=\"row\"><div class=\"ute-pay-now-continueButton\" translate=\"ute.payment.ui.payNow.done\" ng-click=\"utePayNowModal.close()\"></div><div class=\"ute-pay-now-returnButton\" translate=\"ute.payment.ui.payNow.ovPayAgain\" ng-click=\"utePayNowModal.makeAnotherPayment()\"></div></div></div><div class=\"row ute-pay-now-footer\"><div data-ng-include=\"\'module/paymentUI/payNow/templates/merchantAddressFooter.partial.html\'\"></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/paymentInput.partial.html","<div class=\"ute-pay-now-content\"><div ng-show=\"utePayNowModal.isPaymentStep() || utePayNowModal.isReviewStep()\"><form name=\"utePayNowModal.payNowForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-xs-12\"><label for=\"paymentAmount\" class=\"ute-pay-now-payment-amount-label\"><span class=\"ute-pay-now-payment-amount-lead\" translate=\"ute.payment.ui.payNow.ovPaymentAmount\"></span> <span translate=\"ute.payment.ui.payNow.total\" data-translate-values=\"{ accountBalance: utePayNowModal.updatedBalance }\"></span></label></div><div ng-if=\"utePayNowModal.isPaymentStep()\" class=\"col-xs-12\"><input type=\"text\" tabindex=\"1\" ute-currency=\"\" class=\"ute-pay-now-inputText payment-amount-input\" name=\"paymentAmount\" id=\"paymentAmount\" maxlength=\"10\" required=\"\" ng-min=\"0\" data-ng-blur=\"utePayNowModal.validateAmount()\" data-ng-model=\"utePayNowModal.paymentAmount\" autocomplete=\"off\"><div class=\"col-xs-12\" ng-if=\"utePayNowModal.isOverThreshhold() && (utePayNowModal.payNowForm.paymentAmount.$dirty || utePayNowModal.payNowForm.$submitted)\" data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"true\" data-mapping-key=\"makeAPayment.error,errors:makeAPayment.errorCategory\" data-form-field-name=\"payment amount\"><div><span class=\"ute-pay-now-inputTextLabelError\" translate=\"ute.payment.ui.payNow.overThreshhold\" translate-values=\"{threshHoldPaymentAmount : utePayNowModal.threshHoldPaymentAmount}\"></span></div></div><div class=\"col-xs-12\" ng-if=\"!utePayNowModal.isOverThreshhold() && utePayNowModal.paymentAmount > 0 && utePayNowModal.paymentAmount > utePayNowModal.updatedBalance && (utePayNowModal.payNowForm.paymentAmount.$dirty || utePayNowModal.payNowForm.$submitted)\" data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"true\" data-mapping-key=\"makeAPayment.error,errors:makeAPayment.errorCategory\" data-form-field-name=\"payment amount\"><div class=\"ute-pay-now-inputTextLabelError\" translate=\"ute.payment.ui.payNow.overPaying\"></div></div><div class=\"col-xs-12\" ng-if=\"utePayNowModal.showInvalidPaymentAmountError()\" data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"true\" data-mapping-key=\"makeAPayment.error,errors:makeAPayment.errorCategory\" data-form-field-name=\"payment amount\"><div class=\"ute-pay-now-inputTextLabelError\" translate=\"ute.payment.ui.payNow.invalidPaymentAmount\"></div></div></div><div ng-if=\"utePayNowModal.isReviewStep()\" class=\"col-xs-12 ute-pay-now-review-total\">{{ utePayNowModal.paymentAmount | currency}}</div></div></form></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/paymentSteps.partial.html","<div class=\"ute-pay-now-step-tracker-block\"><div class=\"row\"><div class=\"ute-pay-now-step-tracker\"><div ng-repeat=\"step in utePayNowModal.paymentSteps\"><div class=\"col-xs-4 center-block\"><div class=\"{{utePayNowModal.getStepClassName(step)}}\">{{step.index}}</div></div></div></div></div><div class=\"row\"><div ng-repeat=\"step in utePayNowModal.paymentSteps\"><div class=\"col-xs-4 center-block\" ng-class=\"{\'ute-pay-now-step-tracker-label-active\': (step.status === 0), \'ute-pay-now-step-tracker-label\': (step.status !== 0)}\" translate=\"{{step.name}}\"></div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templatesOv/review.partial.html","<div class=\"ute-pay-now-review-page\"><div class=\"ute-pay-now-review-box\"><div class=\"ute-pay-now-review-box-secure\" translate=\"ute.payment.ui.payNow.secureCCPayment\"></div><div class=\"ute-pay-now-review-box-container\"><div class=\"ute-pay-now-review-cc-container\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.cardNumber\"></div><img ng-src=\"{{utePayNowModal.paymentData.creditCardDetails.creditCardType.image}}\" class=\"ute-pay-now-review-cc-img\"> &nbsp;&nbsp;XXXX&nbsp;XXXX&nbsp;XXXX&nbsp;{{utePayNowModal.creditCardLastFour}}</div><div class=\"ute-pay-now-review-expiry-container\"><div class=\"ute-pay-now-label\" translate=\"ute.payment.ui.payNow.expiryDate\"></div>{{utePayNowModal.paymentData.creditCardDetails.expireDate.month}}/{{utePayNowModal.paymentData.creditCardDetails.expireDate.year}}</div><div class=\"ute-pay-now-review-edit\" translate=\"ute.common.label.edit\" ng-click=\"utePayNowModal.goToStep(utePayNowModal.paymentStep)\"></div></div><div data-ng-include=\"\'module/paymentUI/payNow/templatesOv/autoBilling.partial.html\'\"></div></div><div class=\"ute-pay-now-review-button-container\"><div class=\"col-xs-12\"><button class=\"ute-pay-now-continueButton\" translate=\"ute.payment.ui.payNow.payNowButtonLabel\" ng-click=\"utePayNowModal.processCardPayment()\"></button> <a class=\"ute-pay-now-cancelButton\" data-ng-click=\"utePayNowModal.close()\" ng-if=\"utePayNowModal.showCancelButton() === true\" translate=\"ute.common.label.cancel\"></a></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPayCheckEligibility/promiseToPayCheckEligibility.partial.html","<div class=\"ute-mt-6\" ng-if=\"!promiseToPayCheckEligibility.showCheckEligibilityContainer\"><div class=\"ute-ptp-title-height\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div><div class=\"ute-mt-6\" ng-if=\"promiseToPayCheckEligibility.showCheckEligibilityContainer\"><div class=\"ute-ptp-three-sides ute-ptp-light-grey-bg container\"><div class=\"row\"><div class=\"col-xs-2 ute-ptp-account-balance-container\"><span class=\"ute-ptp-title-light ute-ptp-account-balance-span\"><div class=\"ute-ptp-semi-bold ute-ptp-title-height\" data-translate=\"ute.rogers.promiseToPay.checkEligibility.totalAccountBalance\"></div><div class=\"ute-ptp-rui-package-pricing ute-ptp-title\"><div class=\"ute-ptp-price ute-ptp-semi-bold\"><span class=\"ute-ptp-price-en-sign\" ng-hide=\"promiseToPayCheckEligibility.lang === \'fr\'\">$</span> <span class=\"ute-ptp-price-dollars\" ng-bind=\"promiseToPayCheckEligibility.accountBalance | ptp_integer_part\"></span> <span class=\"ute-ptp-price-details\"><span class=\"ute-ptp-price-cents\"><span ng-bind=\"promiseToPayCheckEligibility.accountBalance | ptp_fraction_part : promiseToPayCheckEligibility.lang\"></span> <span ng-hide=\"promiseToPayCheckEligibility.lang ===\'en\'\">$</span></span> <span class=\"ute-ptp-price-period\">&nbsp;</span></span></div></div></span></div><div class=\"col-xs-3 col-sm-3 col-lg-3 col-md-3 ute-ptp-pending-amount-container\" ng-show=\"promiseToPayCheckEligibility.showPendingPTP\"><span class=\"ute-ptp-title-light ute-ptp-pending-amount-span\"><div ng-show=\"promiseToPayCheckEligibility.showPendingPTP\" data-translate=\"ute.rogers.promiseToPay.checkEligibility.pendingPromiseToPay\" class=\"ute-ptp-semi-bold ute-ptp-title-align\"></div><span ng-show=\"promiseToPayCheckEligibility.showLastPaidPTP\" data-translate=\"ute.rogers.promiseToPay.lastPromiseToPay\" class=\"ute-ptp-semi-bold\"></span><div class=\"ute-ptp-pending-ptp-pricing ute-ptp-title\"><div class=\"ute-ptp-price ute-ptp-semi-bold ute-ptp-pending-price-align\"><div class=\"ute-ptp-pending-amount-align\"><span ng-hide=\"promiseToPayCheckEligibility.lang === \'fr\'\" class=\"ute-ptp-price-en-sign\">$</span> <span class=\"ute-ptp-price-dollars\" ng-bind=\"promiseToPayCheckEligibility.ptpPendingAmount | ptp_integer_part\"></span> <span class=\"ute-ptp-price-details\"><span class=\"ute-ptp-price-cents\"><span ng-bind=\"promiseToPayCheckEligibility.ptpPendingAmount| ptp_fraction_part : promiseToPayCheckEligibility.lang\"></span> <span ng-hide=\"promiseToPayCheckEligibility.lang ===\'en\'\">$</span></span> <span class=\"ute-ptp-price-period\">&nbsp;</span></span></div><div class=\"ute-ptp-pending-amount-date\"><h6><span ng-bind=\"promiseToPayCheckEligibility.ptpPendingDate | date:\'MM/dd/yyyy\'\"></span><br><span data-translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.{{promiseToPayCheckEligibility.ptpPendingMOP}}\"></span></h6></div></div></div></span></div><div class=\"ute-ptp-check-eligibility-btn-container\"><button class=\"ute-ptp-cta-round\" data-ng-click=\"promiseToPayCheckEligibility.enableCheckEligibiltyFlag ? promiseToPayCheckEligibility.checkPTPEligibility():\'\'\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"check-schedule-ptp-eligibility-2,event.selfServeStart\"}\' ng-class=\"(!promiseToPayCheckEligibility.enableCheckEligibiltyFlag) ? \'ute-ptp-button-grey\' : \'\'\"><span data-translate=\"ute.rogers.promiseToPay.checkEligibility.checkEligibility\"></span></button></div><div class=\"ute-ptp-loading\" ng-show=\"promiseToPayCheckEligibility.checkEligibilityLoading\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPayCheckEligibility/promiseToPayCheckEligibilitySuccessError.html","<div class=\"row ute-ptp-check-eligibility-container\"><div class=\"col-md-6 col-xs-12 utp-border-right\"><div class=\"row ute-font-size-16 ute-ptp-semi-bold\"><span data-translate=\"ute.rogers.promiseToPay.checkEligibility.pleaseInfo\"></span></div><div class=\"row ute-mt-20 ute-pr-50\"><ul><li data-translate=\"ute.rogers.promiseToPay.latePayment\" class=\"ute-pb-25\"></li><li data-translate=\"ute.rogers.promiseToPay.serviceRestored\" class=\"ute-pb-25\"></li><li data-translate=\"ute.rogers.promiseToPay.collectionActivities\" class=\"ute-pb-25\"></li><li data-translate=\"ute.rogers.promiseToPay.downgradeService\" class=\"ute-pb-25\"></li></ul></div></div><div class=\"col-md-5 col-md-offset-1 col-xs-12\"><div class=\"row ute-font-size-16 ute-ptp-semi-bold\"><span data-translate=\"ute.rogers.promiseToPay.checkEligibility.transferToCredit\"></span></div><div class=\"row ute-mt-20\"><ol><li data-translate=\"ute.rogers.promiseToPay.checkEligibility.transferToCreditOption1\" class=\"ute-pb-25\"></li><li data-translate=\"ute.rogers.promiseToPay.checkEligibility.transferToCreditOption2\" class=\"ute-pb-25\"></li><li data-translate=\"ute.rogers.promiseToPay.checkEligibility.transferToCreditOption3\" class=\"ute-pb-25\"></li></ol></div></div></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPayMessageBanner/promiseToPayMessageBanner.html","<div class=\"row\" data-ng-show=\"(promiseToPayMessageBanner.type===\'error\')\"><div class=\"col-xs-12 col-md-12 col-lg-12 col-sm-12 ute-message-banner ute-error\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 ute-ptp-image-container\"><div class=\"ute-ptp-error-image\"></div></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 ute-pt-10 ute-font-size-18\"><div data-translate=\"{{promiseToPayMessageBanner.message}}\"></div><div class=\"ute-ptp-mt-10\" ng-show=\"promiseToPayMessageBanner.displayInEligibleReasons\"><ul><li ng-repeat=\"reasonCode in promiseToPayMessageBanner.inEligibleReasons\"><span data-translate=\"ute.rogers.promiseToPay.messageBanner.{{reasonCode}}\"></span></li></ul></div></div></div></div><div class=\"row\" data-ng-show=\"(promiseToPayMessageBanner.type===\'success\')\"><div class=\"col-xs-12 col-md-12 col-lg-12 col-sm-12 ute-message-banner ute-success\"><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 ute-ptp-image-container\"><div class=\"ute-ptp-success-image\"></div></div><div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 ute-pt-10 ute-font-size-18\"><div data-translate=\"{{promiseToPayMessageBanner.message}}\"></div></div></div></div><div ng-show=\"promiseToPayMessageBanner.displayCheckEligibleSuccessBanner\" ng-include=\"promiseToPayMessageBanner.checkEligibilitySuccessMessageUrl\"></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPaySchedulePTP/promiseToPaySchedulePTPForm.partial.html","<div class=\"col-xs-12 ute-mt-20\"><form name=\"schedulePTPForm\" novalidate=\"\"><div class=\"col-xs-12 ute-pt-20\" ng-class=\"promiseToPaySchedulePTP.lang === \'en\'?\'ute-ptp-form-en-payment\':\'ute-ptp-form-fr-payment\'\"><div class=\"col-md-3 col-sm-4 col-xs-7\"><span class=\"ute-font-size-16 ute-ptp-semi-bold\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentAmount\"></span><div class=\"row ute-ptp-input-disable\"><div class=\"input-group ute-ptp-form-input\" ng-class=\"(!promiseToPaySchedulePTP.enableForm)? \'ute-ptp-disable\' : \'\'\"><span class=\"input-group-addon\" ng-hide=\"promiseToPaySchedulePTP.lang === \'fr\'\">$</span> <input class=\"ute-ptp-semi-bold\" name=\"formPaymentAmount\" ute-ptp-currency=\"\" type=\"text\" data-ng-change=\"promiseToPaySchedulePTP.validateAmount()\" data-ng-model=\"promiseToPaySchedulePTP.formPaymentAmount\" placeholder=\"{{promiseToPaySchedulePTP.placeHolderValue}}\"> <span class=\"input-group-addon\" ng-hide=\"promiseToPaySchedulePTP.lang === \'en\'\">$</span></div></div></div></div><div class=\"col-xs-12 ute-pt-30\"><div class=\"col-md-4 col-xs-12\"><span class=\"ute-font-size-16 ute-ptp-semi-bold\" translate=\"ute.rogers.promiseToPay.schedulePTP.selectPaymentDate\"></span><div class=\"row\"><div class=\"col-md-9 col-sm-4 col-xs-7\"><input class=\"ute-text-box ute-ptp-semi-bold\" type=\"text\" placeholder=\"MM/DD/YYYY\" data-ng-model=\"promiseToPaySchedulePTP.formPromiseDate\" disabled=\"disabled\"></div><div class=\"col-md-3 col-xs-3 ute-date-picker-image\"><input name=\"formPromiseDate\" ng-hide=\"true\" type=\"text\" data-ng-model=\"promiseToPaySchedulePTP.formPromiseDate\" ute-ptp-date-picker=\"\" ng-change=\"promiseToPaySchedulePTP.setPromiseDate()\"></div></div></div></div><div class=\"col-xs-12 ute-pt-20 ute-ptp-font-14\"><div class=\"col-xs-12\"><span class=\"ute-ptp-semi-bold float-left\" translate=\"ute.rogers.promiseToPay.schedulePTP.postingDate\"></span> <span class=\"float-left ute-ptp-semi-bold\" ng-bind=\"promiseToPaySchedulePTP.estimatedPostingDate | date:\'MM/dd/yyyy\'\"></span></div></div><div class=\"col-xs-12 ute-ptp-font-14 ute-ptp-error-font\" ng-if=\"promiseToPaySchedulePTP.collectionNotPaused\"><div class=\"col-xs-12 col-md-12\"><span translate=\"ute.rogers.promiseToPay.schedulePTP.pauseCollection\" adl-error-track=\'{\"mappingKey\":\"collection-not-paused\",\"field\":\"select-payment-date\"}\'></span></div></div><div class=\"col-xs-12 ute-pt-20\"><div class=\"col-xs-12 col-md-6\"><span class=\"ute-font-size-16 ute-ptp-semi-bold\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethod\"></span><div class=\"row ptp-payment-select ute-styled-select\"><select ng-init=\"promiseToPaySchedulePTP.formPaymentMethod = \'CC/InteracDebit\'\" data-ng-model=\"promiseToPaySchedulePTP.formPaymentMethod\" ng-change=\"promiseToPaySchedulePTP.setPaymentMethod()\" class=\"ute-ptp-form-select ute-ptp-semi-bold\"><option value=\"Internet/PhoneBanking\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.0\"></option><option value=\"RogersStore\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.1\"></option><option value=\"NRPC\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.2\"></option><option ng-selected=\"true\" value=\"CC/InteracDebit\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.3\"></option><option value=\"Bank\" translate=\"ute.rogers.promiseToPay.schedulePTP.paymentMethods.4\"></option></select></div></div></div><div class=\"ute-pt-40 col-xs-12 ute-pt-40\"><div class=\"col-md-4 col-xs-8\"><button class=\"ute-ptp-cta-round\" data-ng-click=\"(promiseToPaySchedulePTP.schedulePromisePermission && promiseToPaySchedulePTP.isValidPromiseAmount) ? promiseToPaySchedulePTP.schedulePTP():\'\'\" ng-class=\"(!promiseToPaySchedulePTP.schedulePromisePermission || !promiseToPaySchedulePTP.isValidPromiseAmount)? \'ute-ptp-button-grey \' : \'\'\"><span translate=\"ute.rogers.promiseToPay.schedulePTP.schedulePTPBtn\"></span></button></div><div class=\"col-md-1 col-md-offset-1 col-xs-2\"><button data-ng-click=\"promiseToPaySchedulePTP.cancelPTP()\" class=\"ute-cancel-btn\"><strong><span translate=\"ute.rogers.promiseToPay.schedulePTP.cancel\"></span></strong></button></div><div class=\"col-md-1 col-md-offset-1 col-xs-2 ute-ptp-form-loading\" ng-show=\"promiseToPaySchedulePTP.scheduleFormLoad\"><img src=\"ute-common-assets/assets/widget-loader.gif\" alt=\"\"></div></div></form></div>");
$templateCache.put("module/promiseToPay/promiseToPayDirective/promiseToPayTabs/promiseToPayTabs.html","<div class=\"container\"><div class=\"row\"><div class=\"ute-ptp-tab-content\"><ul class=\"col-sm-12 nav nav-tabs\"><li ng-cloak=\"\" ng-class=\"{\'active-tab\':promiseToPayTabs.takePayment}\"><a class=\"ute-ptp-semi-bold\" data-toggle=\"tab\" ng-click=\"promiseToPayTabs.takePaymentTab()\"><span data-translate=\"ute.rogers.promiseToPay.tabs.takePayment\"></span></a></li><li ng-cloak=\"\" ng-class=\"{\'active-tab\':!promiseToPayTabs.takePayment}\"><a class=\"ute-ptp-semi-bold\" data-toggle=\"tab\" ng-click=\"promiseToPayTabs.promiseToPayTab()\"><span data-translate=\"ute.rogers.promiseToPay.tabs.promiseToPay\"></span></a></li></ul></div></div></div>");
$templateCache.put("module/purchaseData/views/fido/ute-purchase-data-modal.html","<div class=\"purchase-data-options-wrapper fido\" role=\"document\" aria-labelledby=\"purchase-data\"><div class=\"modal-header purchase-data-modal-header\"><a href=\"javascript:\" aria-label=\"{{\'ute.purchaseData.closeBtn\' | translate }}\" data-ng-click=\"$dismiss()\" class=\"modal-close\" data-dismiss=\"modal\"><img class=\"close-btn\" src=\"images/purchase-data/close.svg\" alt=\"\"></a><h2 class=\"col-xs-12 modal-title\" ng-class=\"{ \'text-success\': ctrl.apiResponse.success, \'text-error\': (ctrl.isGenericError || ctrl.isLimitExceeded), \'text-danger\': ctrl.isConsentAPIError }\"><img data-ng-if=\"ctrl.apiResponse.success\" src=\"images/purchase-data/success-icon.png\" class=\"success-img\"><ins ng-bind=\"ctrl.modalTitle\"></ins></h2></div><div class=\"modal-body\"><div class=\"container-fluid purchased-plans-options\" ng-if=\"ctrl.isPurchasedPlansOptionsFLow && !ctrl.isGenericError\"><div class=\"row\"><div class=\"col-md-12\"><p translate=\"ute.purchaseData.selectPlanOption.desc1\"></p><p translate=\"ute.purchaseData.selectPlanOption.desc2\"></p><p class=\"col-xs-12 center-text\"><strong><ins translate=\"ute.purchaseData.selectPlanOption.or\"></ins></strong></p><p class=\"plan-option-desc3\" translate=\"ute.purchaseData.selectPlanOption.desc3\"></p><ul class=\"list-group\"><li class=\"list-group-item\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime\"><a href=\"javascript:\" class=\"ute-link\" ng-click=\"ctrl.selectPurchaseDataPlanType(\'oneTime\')\"><img src=\"images/purchase-data/one-time.png\" alt=\"\" class=\"pull-left\"><ins translate=\"ute.purchaseData.selectPlanOption.option1\"></ins><img src=\"images/purchase-data/arrow_re.png\" class=\"ute-icon-arrow-right\" alt=\"\"></a></li><li class=\"list-group-item\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly\"><a href=\"javascript:\" class=\"ute-link\" ng-click=\"ctrl.selectPurchaseDataPlanType(\'monthly\')\"><img src=\"images/purchase-data/monthly.png\" alt=\"\" class=\"pull-left\"><ins translate=\"ute.purchaseData.selectPlanOption.option2\"></ins><img src=\"images/purchase-data/arrow_re.png\" class=\"ute-icon-arrow-right\" alt=\"\"></a></li></ul></div></div></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.isSelectedPlanTypeFLow && !ctrl.isGenericError\"><p class=\"selected-plan-desc\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.selectedPlansType.descriptionOTT\" translate-values=\"{endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></p><p class=\"selected-plan-desc\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.selectedPlansType.descriptionMDT\"></p><div class=\"row col-xs-12 options-container\"><a href=\"javascript:void(0)\" class=\"col col-md-4 custom-padding text-center btn_block\" ng-if=\"ctrl.availableTopupPlansList.length > 0 && ctrl.availableTopupPlansList.length <= 3\" ng-repeat=\"plan in ctrl.availableTopupPlansList | orderBy: \'price.value\'\" data-ng-click=\"ctrl.selectPurchaseDataPlan(plan, $index)\" aria-label=\"{{ctrl.selectedPlanIndex === $index ? ctrl.getSelectedAltText() : \'\' }}\"><div class=\"btn_holder\" ng-class=\"{\'selected_holder\': ctrl.selectedPlanIndex === $index}\" aria-label=\"{{ctrl.selectedPlanIndex === $index ? ctrl.getSelectedAltText() : \'\' }}\" role=\"alert\"><div class=\"selected-plan-details-item\" ng-class=\"{\'selected\': ctrl.selectedPlanIndex === $index}\"><img src=\"images/purchase-data/ic-check.svg\" class=\"selected-tick-icon\" alt=\"{{\'ute.purchaseData.altTextSelected\' | translate}}\"><h2>{{plan.size.value | number}} {{ctrl.setDataPlanUnitFormat(plan.size.unit)}}</h2><hr><ute-currency class=\"ute-plan-price\" font-size=\"2.8rem\" price=\"{{plan.price.value / 100}}\"></ute-currency></div></div></a><div class=\"col col-md-10\" ng-if=\"ctrl.availableTopupPlansList.length > 3\"><div class=\"row addon-dropdown-row\"><div ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" class=\"col col-md-3 no-padding\"><p class=\"dropdown-label\" translate=\"ute.purchaseData.selectedPlansType.addonDropdownLabel\"></p></div><div ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" class=\"col col-md-3 no-padding\"><p class=\"dropdown-label\" translate=\"ute.purchaseData.selectedPlansType.addonDropdownLabel2\"></p></div><div class=\"row col col-md-4 no-padding\"><ui-select theme=\"bootstrap\" ng-model=\"ctrl.selectedPlan\" on-select=\"ctrl.selectPurchaseDataPlan(ctrl.selectedPlan, $index)\" tabindex=\"2\"><ui-select-match placeholder=\"{{\'ute.purchaseData.selectedPlansType.addonDropdownPlaceholder\' | translate}}\">{{($select.selected.size.value | number) + \' \' + ctrl.setDataPlanUnitFormat($select.selected.size.unit)}}</ui-select-match><ui-select-choices data-id=\"$index\" repeat=\"plan in ctrl.availableTopupPlansList | orderBy: \'price.value\'\"><div>{{plan.size.value | number}} {{ \' \' + ctrl.setDataPlanUnitFormat(plan.size.unit)}}</div><small><ins ng-bind-html=\"ctrl.setPriceFormat(plan.price.value)\"></ins><ins translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel2\"></ins></small> <span class=\"glyphicon glyphicon-menu-down\"></span></ui-select-choices></ui-select></div></div></div></div></div><div class=\"container-fluid purchasing-plans-confirmation\" ng-class=\"{\'no-padding\': ctrl.isLimitExceeded}\" ng-if=\"ctrl.isPurchasingPlanConfirmationFLow\"><div ng-if=\"ctrl.consentError\"><div ng-class=\"{\'col-xs-12\': ctrl.consentError && !(ctrl.isWCOCFlag || ctrl.isConsentAPIError)}\" ng-bind-html=\"ctrl.consentError\"></div></div><div ng-if=\"!ctrl.apiResponse.success && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isGenericError && !ctrl.consentError\"><p><ins ng-bind-html=\"ctrl.selectedFlowType\"></ins></p><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc1\" translate-values=\"{dataPlan: \'{{ ctrl.selectedPlan.size.value | number }} {{ \' \' + ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit) }}\'}\"></p><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\"><ins translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc2\" translate-values=\"{dataPlan: \'{{ ctrl.selectedPlan.size.value | number }} {{ \' \' + ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit) }}\', endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></ins></p><p><ins translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc3\"></ins></p></div><div class=\"row plans-details\" ng-if=\"!ctrl.apiResponse.success && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isGenericError\"><div class=\"col col-md-12\"><h2><span>{{ctrl.selectedPlan.size.value | number}} {{ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit)}}</span> <span translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel\"></span> <span>{{(ctrl.selectedPlan.price.value / 100) | currency:CAD:2}}<ins class=\"priceLabel2\" data-ng-if=\"ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel2\"></ins></span></h2></div></div></div><div class=\"container-fluid purchasing-plans-confirmation\" ng-if=\"ctrl.limitCycleError\"><p ng-bind-html=\"ctrl.limitCycleError\"></p></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.apiResponse.success\"><p class=\"margin-align\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansSuccess.desc1\" translate-values=\"{endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></p><p class=\"margin-align\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansSuccess.desc2\"></p></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.isGenericError\"><p translate=\"ute.purchaseData.purchasingPlansError.generic.desc1\"></p></div></div><div class=\"modal-footer\"><div class=\"row\"><div class=\"col col-md-12\"><div class=\"col col-md-5 col-xs-12\"><p class=\"text-left error-warning\" ng-if=\"ctrl.isSelectedPlanTypeFLow && ctrl.planSelectionError\"><img src=\"images/purchase-data/alert.svg\" alt=\"{{\'ute.purchaseData.altTextWarning\' | translate}}\" class=\"plans-selection-error\"><ins translate=\"ute.purchaseData.warning.desc\"></ins></p></div><div class=\"col col-md-7 no-padding\"><div ng-if=\"ctrl.isPurchasingPlanConfirmationFLow && !ctrl.isGenericError && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isWCOCFlag\" class=\"confirmation-btn-container\"><a href=\"javascript:void(0)\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\" class=\"ute-link visible-lg\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a> <button role=\"button\" class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.proceedWithPurchaseDataPopup()\"><ins translate=\"ute.purchaseData.purchaseBtn\"></ins></button></div><div ng-if=\"ctrl.isSelectedPlanTypeFLow && !ctrl.isWCOCFlag\" class=\"planType-btn-container\"><a href=\"javascript:void(0)\" class=\"ute-link visible-lg\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a> <button role=\"button\" class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.gotoConfirmation()\"><ins translate=\"ute.purchaseData.continue\"></ins></button></div><div ng-if=\"ctrl.isPurchasingPlanConfirmationFLow && !ctrl.isGenericError && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && ctrl.isWCOCFlag\" class=\"planType-btn-container\"><a href=\"javascript:void(0)\" class=\"ute-link visible-lg\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a> <button role=\"button\" class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.proceedWithConsent()\"><ins translate=\"ute.purchaseData.continue\"></ins></button></div><a href=\"javascript:void(0)\" data-ng-if=\"(ctrl.isSelectedPlanTypeFLow || ctrl.isPurchasingPlanConfirmationFLow) && !ctrl.isGenericError && !ctrl.isConsentAPIError && ctrl.isMobileDevice && !ctrl.isLimitExceeded\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\" class=\"ute-link btn-link visible-xs\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a></div></div></div></div></div>");
$templateCache.put("module/purchaseData/views/rogers/ute-purchase-data-modal.html","<div class=\"purchase-data-options-wrapper rogers\" role=\"document\" aria-labelledby=\"purchase-data\"><div class=\"modal-header purchase-data-modal-header\"><a href=\"\" data-ng-click=\"$dismiss()\" aria-label=\"{{\'ute.purchaseData.closeBtn\' | translate }}\" class=\"modal-close\" data-dismiss=\"modal\"><i class=\"rui-icon-mobile-menu-exit\"></i></a><div class=\"\"><h2 class=\"modal-title\" ng-class=\"{\'header-success\': ctrl.apiResponse.success, \'header-error\': (ctrl.isGenericError || ctrl.isSpeedPassError || ctrl.isConsentAPIError)}\"><i class=\"glyphicon glyphicon-ok\" ng-if=\"ctrl.apiResponse.success\"></i><ins ng-bind=\"ctrl.modalTitle\"></ins></h2></div></div><div class=\"modal-body\"><div class=\"container-fluid purchased-plans-options\" ng-if=\"ctrl.isPurchasedPlansOptionsFLow && !ctrl.isGenericError && !ctrl.isSpeedPassError\"><div class=\"row plan-desc-row\"><div class=\"col-md-12\"><p translate=\"ute.purchaseData.selectPlanOption.desc1\"></p><p translate=\"ute.purchaseData.selectPlanOption.desc2\"></p><p class=\"col-xs-12 center-text\"><strong><ins translate=\"ute.purchaseData.selectPlanOption.or\"></ins></strong></p><p class=\"plan-option-desc3\" translate=\"ute.purchaseData.selectPlanOption.desc3\"></p><ul class=\"list-group\"><li class=\"list-group-item\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime\"><a href=\"javascript:\" class=\"ute-link\" ng-click=\"ctrl.selectPurchaseDataPlanType(\'oneTime\')\"><img src=\"images/purchase-data/one-time.png\" class=\"pull-left\" alt=\"\"><ins translate=\"ute.purchaseData.selectPlanOption.optionSP\"></ins><i class=\"glyphicon glyphicon-chevron-right pull-right\"></i></a></li><li class=\"list-group-item\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly\"><a href=\"javascript:\" class=\"ute-link\" ng-click=\"ctrl.selectPurchaseDataPlanType(\'monthly\')\"><img src=\"images/purchase-data/monthly.png\" class=\"pull-left\" alt=\"\"><ins translate=\"ute.purchaseData.selectPlanOption.option2\"></ins><i class=\"glyphicon glyphicon-chevron-right pull-right\"></i></a></li></ul></div></div></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.isSelectedPlanTypeFLow && !ctrl.isGenericError && !ctrl.isSpeedPassError\"><p class=\"selected-plan-desc\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.selectedPlansType.descriptionSP\" translate-values=\"{endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></p><p class=\"selected-plan-desc\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.selectedPlansType.descriptionMDT\"></p><div class=\"row\"><div class=\"col col-md-4 text-center btn_block\" ng-if=\"ctrl.availableTopupPlansList.length > 0 && ctrl.availableTopupPlansList.length <= 3\" ng-repeat=\"plan in ctrl.availableTopupPlansList | orderBy: \'price.value\'\" role=\"button\" data-ng-click=\"ctrl.selectPurchaseDataPlan(plan, $index)\" aria-label=\"{{ctrl.selectedPlanIndex === $index ? ctrl.getSelectedAltText(): \'\' }}\"><div class=\"btn_holder\" ng-class=\"{\'selected_holder\': ctrl.selectedPlanIndex === $index}\"><div class=\"selected-plan-details-item\" ng-class=\"{\'selected\': ctrl.selectedPlanIndex === $index}\"><i class=\"glyphicon glyphicon-ok\"></i><h2>{{plan.size.value | number}} {{ctrl.setDataPlanUnitFormat(plan.size.unit)}}</h2><span class=\"at-max-speed\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.atMaxSpeed\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\"></span><hr><span><ins ng-bind-html=\"\' \'+ ctrl.setPriceFormat(plan.price.value)\"></ins><ins class=\"priceLabel2\" data-ng-if=\"ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel2\"></ins></span></div></div></div><div class=\"col col-md-10\" ng-if=\"ctrl.availableTopupPlansList.length > 3\"><div class=\"row addon-dropdown-row\"><div ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" class=\"col col-md-3\"><p class=\"dropdown-label\" translate=\"ute.purchaseData.selectedPlansType.addonDropdownLabel\"></p></div><div ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" class=\"col col-md-4\"><p class=\"dropdown-label\" translate=\"ute.purchaseData.selectedPlansType.addonDropdownLabelSP\"></p></div><div class=\"col col-md-4\"><ui-select theme=\"bootstrap\" ng-model=\"ctrl.selectedPlan\" on-select=\"ctrl.selectPurchaseDataPlan(ctrl.selectedPlan, $index)\" aria-label=\"{{\'ute.purchaseData.altTextavailableTopupPlansList\' | translate }}\"><ui-select-match placeholder=\"{{\'ute.purchaseData.selectedPlansType.addonDropdownPlaceholder\' | translate}}\">{{($select.selected.size.value | number) + \' \' + ctrl.setDataPlanUnitFormat($select.selected.size.unit)}}</ui-select-match><ui-select-choices data-id=\"$index\" repeat=\"plan in ctrl.availableTopupPlansList | orderBy: \'price.value\'\"><div>{{plan.size.value | number}} {{ \' \' + ctrl.setDataPlanUnitFormat(plan.size.unit)}}</div><small ng-bind-html=\"ctrl.setPriceFormat(plan.price.value)\"></small></ui-select-choices></ui-select></div></div></div></div></div><div class=\"container-fluid purchasing-plans-confirmation\" ng-if=\"ctrl.isPurchasingPlanConfirmationFLow\"><div ng-if=\"ctrl.consentError\"><p ng-bind-html=\"ctrl.consentError\"></p></div><div ng-if=\"!ctrl.apiResponse.success && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isGenericError && !ctrl.isSpeedPassError && !ctrl.consentError\"><p><ins ng-bind-html=\"ctrl.selectedFlowType\"></ins></p><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc1\" translate-values=\"{dataPlan: \'{{ctrl.selectedPlan.size.value | number }} {{\' \' + ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit) }}\'}\"></p><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc2SP\" translate-values=\"{dataPlan: \'{{ctrl.selectedPlan.size.value | number }} {{\' \' + ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit) }}\', endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></p><p><ins translate=\"ute.purchaseData.purchasingPlansConfirmationModal.desc3\" ng-if=\"!ctrl.isOneTimeOrMonthlyTopUpExists.oneTime\"></ins></p></div><div class=\"row plans-details\" ng-if=\"!ctrl.apiResponse.success && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isGenericError && !ctrl.isSpeedPassError\"><div class=\"col col-md-12\"><h2><span>{{ctrl.selectedPlan.size.value | number}} {{ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit)}}</span> <span><span translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabelSP\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\"></span> <span translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel\" ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\"></span></span> <span class=\"price-container hidden-xs\" ng-class=\"{\'english\': ctrl.lang === \'en\', \'french\': ctrl.lang === \'fr\'}\"><ins ng-bind-html=\"ctrl.setPriceFormat(ctrl.selectedPlan.price.value)\"></ins><ins class=\"priceLabel2\" data-ng-if=\"ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel2\"></ins></span> <span class=\"visible-xs\">{{(ctrl.selectedPlan.price.value / 100) | currency:CAD:2}}<ins class=\"priceLabel2\" data-ng-if=\"ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansConfirmationModal.priceLabel2\"></ins></span></h2></div></div></div><div class=\"container-fluid purchasing-plans-confirmation\" ng-if=\"ctrl.limitCycleError\"><p ng-bind-html=\"ctrl.limitCycleError\"></p></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.apiResponse.success\"><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansSuccess.desc1SP\" translate-values=\"{dataPlan: \'{{ctrl.selectedPlan.size.value | number }} {{\' \' + ctrl.setDataPlanUnitFormat(ctrl.selectedPlan.size.unit) }}\', endDate: \'{{ctrl.billingCyclEndeDate}}\'}\"></p><p ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.purchasingPlansSuccess.desc2\"></p></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.isGenericError\"><p translate=\"ute.purchaseData.purchasingPlansError.generic.desc1\"></p></div><div class=\"container-fluid selected-plans-type\" ng-if=\"ctrl.isSpeedPassError\"><p translate=\"ute.purchaseData.purchasingPlansError.speedpass.desc1\"></p></div></div><div class=\"modal-footer\"><div class=\"row footer-btn-wrapper\"><div class=\"col col-md-12\"><div class=\"col col-md-6\"><p class=\"text-left error-warning\" ng-if=\"ctrl.isSelectedPlanTypeFLow && ctrl.planSelectionError\"><i aria-label=\"{{\'ute.purchaseData.altTextWarning\' | translate }}\" class=\"glyphicon glyphicon-exclamation-sign\"></i><ins ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.monthly && ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.warning.desc\"></ins><ins ng-if=\"ctrl.isOneTimeOrMonthlyTopUpExists.oneTime && !ctrl.isSelectedPlanMonthly\" translate=\"ute.purchaseData.warning.descSP\"></ins></p></div><div class=\"col col-md-6\"><div ng-if=\"ctrl.isPurchasingPlanConfirmationFLow && !ctrl.isGenericError && !ctrl.isSpeedPassError && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && !ctrl.isWCOCFlag\"><a href=\"javascript:void(0)\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\" class=\"ute-link visible-lg\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a><md-button class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.proceedWithPurchaseDataPopup()\"><ins translate=\"ute.purchaseData.purchaseBtn\"></ins></md-button></div><div ng-if=\"ctrl.isSelectedPlanTypeFLow && !ctrl.isWCOCFlag && !ctrl.isGenericError && !ctrl.isSpeedPassError\"><a href=\"javascript:void(0)\" class=\"ute-link visible-lg\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a><md-button class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.gotoConfirmation()\"><ins translate=\"ute.purchaseData.continue\"></ins></md-button></div><div ng-if=\"ctrl.isPurchasingPlanConfirmationFLow && !ctrl.isGenericError && !ctrl.isSpeedPassError && !ctrl.isConsentAPIError && !ctrl.isLimitExceeded && ctrl.isWCOCFlag\" class=\"planType-btn-container\"><a href=\"javascript:void(0)\" class=\"ute-link visible-lg\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a><md-button class=\"ute-purchase-data-continue-btn\" data-ng-click=\"ctrl.proceedWithConsent()\"><ins translate=\"ute.purchaseData.continue\"></ins></md-button></div><a data-ng-if=\"(ctrl.isSelectedPlanTypeFLow || ctrl.isPurchasingPlanConfirmationFLow) && !ctrl.isGenericError && !ctrl.isSpeedPassError && !ctrl.isConsentAPIError && ctrl.isMobileDevice && !ctrl.isLimitExceeded\" href=\"javascript:void(0)\" data-ng-click=\"$dismiss()\" data-dismiss=\"modal\" class=\"ute-link btn-link visible-xs\"><ins translate=\"ute.purchaseData.backBtn\"></ins></a></div></div></div></div></div>");
$templateCache.put("module/secondLevelNavigationDirective/navigationBar/ignore/navigationBar.directive.mobile.accounts.view.html","<div id=\"account\" class=\"ute-secondLevelNav-menu-accounts hidden-sm hidden-md hidden-lg\" ng-cloak=\"\"><md-content><md-toolbar class=\"ute-secondLevelNav-menu-accounts-header\"><div class=\"md-toolbar-tools\"><h2><span data-translate=\"ute.common.second.level.navigation.header\"></span></h2><span flex=\"\"></span> <img alt=\"\" src=\"ute-common-assets/assets/cross-grey.png\" class=\"md-avatar\"></div></md-toolbar><md-list ng-cloak=\"\"><md-divider></md-divider><md-list-item ng-repeat=\"item in navigationBar.accountsDropdown() | filter: {status:\'!0\'}\" ng-click=\"navigationBar.childOnClick(item)\"><md-button data-ng-disabled=\"navigationBar.isStatusShowDisable(item.status)\" aria-label=\"{{item.status}}\"><h2><span class=\"ute-secondLevelNav-child-item-name ute-secondLevelNav-bar-nickname\" data-translate=\"{{item.name}}\"></span> <span data-ng-if=\"item.displayValue\"><span data-ng-if=\"item.name\">:</span> <span data-translate=\"{{item.displayValue}}\"></span></span></h2><span flex=\"\"></span> <img data-ng-if=\"item.dropdown\" alt=\"\" src=\"ute-common-assets/assets/right-arrow-grey.png\"></md-button></md-list-item></md-list></md-content></div>");
$templateCache.put("module/creditcard/directive/templates/consumer.template.html","<div ng-form=\"frmCreditCard\" novalidate=\"\" ng-if=\"showSemafone\"><div class=\"ute-semafone-credit-card\"><div class=\"ute-semafone-spacer20\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"ute-semafone-heading-3\"><span translate=\"ute.rogers.myrCreditCard.change_method_secure\"></span></div></div></div><div class=\"row\"><div class=\"col-xs-12 ute-semafone-type-body\" translate=\"ute.rogers.myrCreditCard.change_method_info_secure_credit\"></div></div></div><div class=\"ute-semafone-cc-group\"><div class=\"cc-heading ute-semafone-input-text-label\" translate=\"ute.rogers.myrCreditCard.paynow_card_number\"></div><div ng-if=\"!isRep()\" class=\"cc-placeholder ute-semafone-cc-placeholder\" translate=\"ute.rogers.myrCreditCard.paynow_cc_placeholder\"></div><div ng-if=\"isRep()\" class=\"cc-placeholder ute-semafone-cc-placeholder\" translate=\"ute.rogers.myrCreditCard.paynow_cc_placeholder_ov\"></div><div class=\"cc-input-images-group\"><div class=\"cc-input-container ute-semafone-consumer-input\"><semafone-component update-result=\"update(result)\" credit-card-data=\"creditCardData\" user-type=\"userType\" retail-card=\"tokenizeRetailCard\"></semafone-component></div><div ng-include=\"\'module/creditcard/directive/templates/partials/ccImages.partial.html\'\"></div><div ng-include=\"\'module/creditcard/directive/templates/partials/ccErrors.partial.html\'\"></div><div class=\"cc-info-group\"><div class=\"secondary-label-container\"><div class=\"secondary-label\" translate=\"ute.rogers.myrCreditCard.paynow_how_do_i_pay\"></div><div class=\"cc-tooltip-fixed-container\"><div class=\"ute-semafone-info-icon card-info-icon\"><div class=\"ute-semafone-toolTip card-info-details\"><span translate=\"ute.rogers.myrCreditCard.paynow_cc_info_tooltop\"></span></div></div></div><div class=\"clear-float\"></div></div></div></div><div class=\"row ptm semfone-date-security-group ute-semafone-spacer20\"><div class=\"col-md-4 col-sm-6 col-xs-12 ute-semafone-date-select-container\" ng-include=\"\'module/creditcard/directive/templates/partials/dateSelects.partial.html\'\"></div><div class=\"col-xs-12 ute-semafone-cv-container\" ng-include=\"\'module/creditcard/directive/templates/partials/cvInput.partial.html\'\"></div></div></div></div></div><moneris-component update-result=\"update(result)\" credit-card-data=\"creditCardData\" user-type=\"userType\" retail-card=\"tokenizeRetailCard\" ng-if=\"showMoneris\"></moneris-component>");
$templateCache.put("module/creditcard/directive/templates/ov.template.html","<div ng-form=\"frmCreditCard\" novalidate=\"\"><div class=\"ute-semafone-credit-card\"><div class=\"ute-semafone-care\" ng-class=\"{\'ute-semafone-dealer-alignment\': isDealer()}\"><div class=\"ute-semafone-cc-group\"><div class=\"cc-input-images-group\"><div class=\"cc-input-container\" ng-class=\"{\'ute-semafone-dealer-input\': isDealer(), \'ute-semafone-care-input\': isCareRep()}\"><semafone-component update-result=\"update(result)\" credit-card-data=\"creditCardData\" user-type=\"userType\" retail-card=\"tokenizeRetailCard\"></semafone-component></div></div><div ng-include=\"\'module/creditcard/directive/templates/partials/ccErrors.partial.html\'\"></div></div><div class=\"ute-semafone-care-inputs\" ng-class=\"{\'ute-semafone-dealer-inputs\': isDealer()}\"><div class=\"row ptm semfone-date-security-group ute-semafone-spacer20\" ng-hide=\"isDealer() && creditCardData.isCardSwiped\"><div class=\"col-xs-12 ute-semafone-care-expiryDate-container ute-semafone-select-view\"><div class=\"col-sm-5 col-xs-12 ute-semafone-date-select-container\" ng-include=\"\'module/creditcard/directive/templates/partials/dateSelects.partial.html\'\"></div><div class=\"col-sm-5 xol-xs-12 ute-semafone-cv-container\" ng-include=\"\'module/creditcard/directive/templates/partials/cvInput.partial.html\'\"></div></div></div></div></div></div></div>");
$templateCache.put("module/transferOfResponsibility/stepOne/ctnSelection/ctnSelection.view.html","<section><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-7\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"transfer-of-responsibility-title-owner\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.currentOwner\" class=\"ute-tor-owner-title\"></span></div></div><div class=\"col-xs-12\" style=\"border: 1px solid lightgray; margin-top: 45px;\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\"><span data-translate=\"ute.tor.currentCustomer.selectTORSubscriber\"></span></div><div data-translate=\"ute.tor.selectNumber\" class=\"col-xs-12 ute-tor-select-number\" style=\"margin-left: 2rem;\"></div><div class=\"col-xs-12\"><div class=\"col-xs-11 ute-tor-select-subscriber-container\"><form name=\"ctnSelectionForm\"><div class=\"row\"><div class=\"col-xs-12 tor-ctn-list\" ng-repeat=\"ctn in ctnSelection.ctnList\" ng-class=\"{\'ute-tor-ctn-separator\': !$first}\"><span class=\"col-xs-12\"><span class=\"ute-tor-checkbox col-xs-1\"><input type=\"checkbox\" id=\"{{ctn.subscriberNumber}}\" data-ng-model=\"ctn.isSelected\" data-ng-click=\"ctnSelection.updateSelectedCtnList(ctn)\"> <label for=\"{{ctn.subscriberNumber}}\" class=\"ute-tor-checkbox-label\" ng-class=\"{\'ute-tor-checkbox-black\': ctn.isSelected}\"></label></span> <span class=\"col-xs-10\"><span style=\"font-size: 18px;font-weight: 500;\" ng-bind=\"ctn.firstName\"></span> <span style=\"font-size: 18px;margin-left: 5px; color: gray;\" ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></span></span></div></div></form></div><div class=\"col-xs-4 ute-tor-primary-disable-buttons\" style=\"margin-left:0rem;float:right;\" ng-class=\"ctnSelection.selectedCtnsValue.length==0 ? \'ute-tor-primary-disable-buttons\' : \'ute-tor-primary-buttons\'\"><button class=\"\" data-ng-disabled=\"ctnSelection.selectedCtnsValue.length==0\" data-ng-click=\"ctnSelection.goToEligibilityResults()\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"tor-current-owner,event.selfServeStart\"}\'><span translate=\"ute.tor.currentCustomer.runEligibilityCheck\"></span></button></div></div><div class=\"col-xs-12 ute-tor-obtain-future-owner-info\"><div class=\"col-xs-12 ute-tor-select-subscriber\"><span data-translate=\"ute.tor.currentCustomer.obtainFutureOwnerInfo\"></span></div></div></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepOne/currentOwnerEligibilityCheck/currentOwnerEligibilityCheck.view.html","<section><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-7\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"transfer-of-responsibility-title-owner\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.currentOwner\" class=\"ute-tor-owner-title\"></span></div></div><div class=\"col-xs-12\" style=\"border: 1px solid lightgray; margin-top: 45px;\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\"><span data-translate=\"ute.tor.currentCustomer.selectTORSubscriber\"></span></div><div class=\"col-xs-12\"><div class=\"ute-tor-container-row-header\"><div class=\"col-xs-5 ute-tor-select-number\"><span data-translate=\"ute.tor.eligibilityResults.numbers\"></span></div><div class=\"col-xs-5 ute-tor-cta-link\" style=\"margin: 0;margin-left: 0.5rem;\"><a ng-click=\"currentOwnerEligibility.addAnotherNumber()\"><span data-translate=\"ute.tor.eligibilityResults.addAnother\"></span></a></div></div></div><div class=\"col-xs-12\"><div class=\"col-xs-11 ute-tor-select-subscriber-container\" style=\"margin-bottom: 0;\"><div class=\"row\"><div class=\"col-xs-12 tor-ctn-list\" ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-if=\"ctn.isSelected\" ng-class=\"{\'ute-tor-ctn-separator\': !$first && ($index+1)===currentOwnerEligibility.ctnList.length}\" style=\"padding: 1rem;\"><span class=\"col-xs-12\"><div class=\"col-xs-6\"><span style=\"font-size: 18px;font-weight: 500;\" ng-bind=\"ctn.firstName\"></span> <span style=\"font-size: 18px;margin-left: 5px; color: gray;\" ng-bind=\"ctn.subscriberNumber | ute_common_filter_phone3\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\" style=\"font-size: 1.7rem;font-weight: 400;margin-left: 1rem;\"><span class=\"col-xs-2\"><span ng-show=\"ctn.isEligible\" style=\"color: #62BB96;\" class=\"rui-icon-circle-solid-check\"></span> <span ng-show=\"ctn.isEligible==false\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"(ctn.isEligible === null || ctn.isEligible === undefined) && !(ctn.isStatusFailure || ctn.isEligible==false)\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span> <span ng-show=\"ctn.isStatusFailure\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"ctn.isEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span> <span ng-show=\"ctn.isEligible\" data-translate=\"ute.tor.eligibilityResults.eligible\"></span> <span ng-show=\"ctn.isStatusFailure\" data-translate=\"ute.tor.eligibilityResults.notEligible\"></span></span></div><div ng-show=\"ctn.isEligible==false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in ctn.reasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\" adl-error-track=\'{\"mappingKey\":\"tor-current-owner\",\"type\":\"user\",\"category\":\"self serve\"}\'></span></li></ul></div></div></span></div></div></div><div ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-show=\"ctn.isStatusFailure\" class=\"col-xs-12\" style=\"margin-left: 2rem;margin-top: 0.5rem;font-size: 1.4rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 0.5rem;\"><span ng-show=\"ctn.isStatusFailure\" style=\"color: #DA2C1F;\" class=\"rui-icon-alert-i\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"ctn.isStatusFailure==true\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div><div ng-repeat=\"ctn in currentOwnerEligibility.ctnList\" ng-show=\"ctn.isEligible==false\" class=\"col-xs-12\" style=\"margin-left: 2rem;margin-top: 0.5rem;font-size: 1.4rem;\"><div ng-repeat=\"reasonCode in ctn.reasonCodes\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 0.5rem;\"><span ng-show=\"ctn.isEligible == false\" style=\"color: #DA2C1F;\" class=\"rui-icon-alert-i\"></span></span> <span class=\"col-xs-9\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\"></span></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-header\"><div class=\"col-xs-5 ute-tor-select-number\"><span data-translate=\"ute.tor.eligibilityResults.accountNumbers\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-container-row-content\"><div class=\"col-xs-12 ute-tor-future-owner-content\"><div class=\"col-xs-6\"><span class=\"\" ng-bind=\"currentOwnerEligibility.model.accountNumber\"></span></div><div class=\"col-xs-offset-3 col-xs-3\"><div class=\"col-xs-12\"><span class=\"col-xs-2\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible\" style=\"color: #62BB96;\" class=\"rui-icon-circle-solid-check\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"currentOwnerEligibility.isModalShown\" style=\"color: #525252;\" class=\"rui-icon-circle-x\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible === null && !currentOwnerEligibility.isModalShown\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></span></span> <span class=\"col-xs-10\" style=\"font-weight: 600;\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false || currentOwnerEligibility.isModalShown\" data-translate=\"ute.tor.eligibilityResults.notValidated\"></span> <span ng-show=\"currentOwnerEligibility.model.isBANEligible\" data-translate=\"ute.tor.eligibilityResults.validated\"></span></span></div><div ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" class=\"col-xs-12\"><ul class=\"ute-tor-notes-list\"><li ng-repeat=\"reasonCode in currentOwnerEligibility.model.banReasonCodes\"><span data-translate=\"ute.tor.eligibilityResults.{{reasonCode}}\" adl-error-track=\'{\"mappingKey\":\"tor-current-owner\",\"type\":\"user\",\"category\":\"self serve\"}\'></span></li></ul></div></div></div></div></div><div class=\"col-xs-12\" style=\"margin-left: 2rem;margin-bottom: 2rem;margin-top: 0.5rem;font-size: 1.4rem;\"><span class=\"col-xs-1\" style=\"width: fit-content;margin-right: 1rem;\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false || currentOwnerEligibility.isModalShown\" style=\"color: #DA2C1F;\" class=\"rui-icon-alert-i\"></span></span> <span class=\"col-xs-9\"><span ng-show=\"currentOwnerEligibility.model.isBANEligible==false\" data-translate=\"ute.tor.eligibilityResults.notEligibleForTOR\"></span> <span ng-show=\"currentOwnerEligibility.isModalShown\" data-translate=\"ute.tor.systemExceptionMessage\"></span></span></div></div><div class=\"col-xs-11 ute-tor-note-container\"><div class=\"ute-tor-note-title\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPointsTitle\"></span></div><ul class=\"ute-tor-notes-list\"><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint1\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint2\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint3\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPoint4\"></span></li></ul></div><div class=\"col-xs-11 ute-yellow-header-outline\" ng-show=\"(currentOwnerEligibility.model.isBANEligible==false) || (!currentOwnerEligibility.model.isBANEligible && !currentOwnerEligibility.isOneCtnEligible)\"><div class=\"col-xs-1\" style=\"width: fit-content;margin: 0.75rem;\"><span style=\"color: #FFD76F;font-size: 2rem;\" class=\"rui-icon-alert-i\"></span></div><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.notEligibleErrorMessage\"></span></div></div><div class=\"col-xs-12\"><div class=\"row ute-tor-interaction-note-content\"><span class=\"rui-icon-info ute-tor-current-owner-note\"></span><div class=\"col-xs-11\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerNote\"></span></div></div></div><div class=\"col-xs-12\"><div class=\"row col-xs-12 ute-tor-eligibility-buttons\"><div class=\"col-xs-6\" style=\"width: fit-content;margin-left: 10rem; margin-top: 3.5rem;\"><a ng-click=\"currentOwnerEligibility.backToTor()\" data-translate=\"ute.tor.cancel\" class=\"ute-tor-cta-link\"></a></div><div class=\"col-xs-2\" data-ng-class=\"{\'ute-tor-primary-disable-buttons\': (!currentOwnerEligibility.model.isBANEligible || !currentOwnerEligibility.isOneCtnEligible ), \'ute-tor-primary-buttons\': (currentOwnerEligibility.model.isBANEligible && currentOwnerEligibility.isOneCtnEligible)}\"><button data-ng-disabled=\"(!currentOwnerEligibility.model.isBANEligible || !currentOwnerEligibility.isOneCtnEligible)\" data-ng-click=\"currentOwnerEligibility.eligibitySaveAndProceed()\"><span data-translate=\"ute.tor.saveAndProceed\"></span></button></div></div></div></div><div class=\"col-xs-12 ute-tor-obtain-future-owner-info\"><div class=\"col-xs-12 ute-tor-select-subscriber\"><span data-translate=\"ute.tor.currentCustomer.obtainFutureOwnerInfo\"></span></div></div></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepThree/currentOwnerInfo/currentOwnerInfo.view.html","<section class=\"ute-tor-destination-customer\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-7\"><div class=\"row\"><div class=\"col-xs-12\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.futureOwner\" class=\"ute-tor-primary-title\" style=\"border-left: 2px solid black;padding-left: 1rem;\"></span></div><div class=\"ute-tor-clear-both\" data-ng-include=\"currentOwnerInfo.config.advanced.currentOwnerInformation.templateUrl\"></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepThree/futureOwnerEligibilityCheck/futureOwnerEligibilityCheck.view.html","<section class=\"ute-tor-destination-customer\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"row\"><div class=\"col-xs-12\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.futureOwner\" class=\"ute-tor-primary-title\" style=\"border-left: 2px solid black;padding-left: 1rem;\"></span></div><div class=\"ute-tor-clear-both\" data-ng-include=\"futureOwnerEligibility.config.advanced.futureOwnerEligibilityResults.templateUrl\"></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepThree/subscriberDetails/subscriberDetails.view.html","<section class=\"col-xs-11 ute-tor-destination-customer\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.futureOwner\" class=\"ute-tor-primary-title\" style=\"border-left: 2px solid black;padding-left: 1rem;\"></span></div></div><div class=\"col-xs-7\"><div class=\"row ute-tor-border-outline\"><div class=\"col-xs-12 ute-tor-future-owner-first-title\" style=\"padding-bottom: 1rem;\"><span data-translate=\"ute.tor.stepTracker.stepLabel3\"></span></div><div class=\"col-xs-12\"><div class=\"ute-tor-content\"><span data-translate=\"ute.tor.destinationCustomer.instructionMessage\"></span></div></div><div class=\"col-xs-12\" style=\"margin-top: 2rem;\"><form name=\"torCurrentCustomerForm\" novalidate=\"\" class=\"ng-pristine ng-invalid ng-invalid-required ng-valid-minlength ng-valid-maxlength\"><div class=\"row\"><div class=\"col-xs-5\"><label for=\"ute-tor-future-owner-current-owner-number\" class=\"ute-tor-future-owner-current-owner-number\"><input placeholder=\"&nbsp;\" id=\"ute-tor-future-owner-current-owner-number\" class=\"ute-tor-future-owner-current-owner-number tor-input-dest\" type=\"text\" data-ng-model=\"subscriberDetails.model.sourceAccountInfo.subscriberNumber\" maxlength=\"10\" data-minlength=\"10\" data-ng-minlength=\"10\" data-ng-maxlength=\"10\" data-ng-required=\"true\" ute-numbers-only-input=\"\" tabindex=\"0\" style=\"border-radius: 0;\" required=\"required\" aria-required=\"true\" aria-invalid=\"true\"> <span class=\"ute-tor-future-owner-current-owner-number-label\" data-translate=\"ute.tor.currentCustomer.currentOwnerNumber\"></span> <span class=\"ute-tor-future-owner-current-owner-number-border\"></span></label></div><div class=\"col-xs-3 ute-tor-primary-disable-buttons\" ng-class=\"{\'ute-tor-primary-buttons\': torCurrentCustomerForm.$valid, \'ute-tor-primary-disable-buttons\': torCurrentCustomerForm.$invalid}\" style=\"margin: 0;\"><button ng-disabled=\"torCurrentCustomerForm.$invalid\" data-ng-click=\"subscriberDetails.getTORInProgressDetails()\" ng-class=\"{\'ute-tor-primary-disable-buttons\': torCurrentCustomerForm.$invalid}\" tabindex=\"0\" aria-disabled=\"true\" disabled=\"disabled\" style=\"margin-left: 0;margin-top: 0;font-size: 1.8rem;\" adl-event-track=\'{\"action\":\"click\",\"mappingKey\":\"tor-future-owner,event.selfServeStart\"}\'><span data-translate=\"ute.tor.destinationCustomer.getDetails\"></span></button></div><div class=\"col-xs-1 ng-hide\" ng-show=\"subscriberDetails.isGetDetailsInProgress\" aria-hidden=\"true\"><img class=\"ute-tor-loader-image\" src=\"ute-common-assets/assets/widget-loader.gif\"></div></div></form></div><div class=\"col-xs-10 ute-tor-note-container\"><div class=\"ute-tor-note-title\"><span data-translate=\"ute.tor.eligibilityResults.currentOwnerPointsTitle\"></span></div><ul class=\"ute-tor-notes-list\"><li><span data-translate=\"ute.tor.eligibilityResults.futureOwnerPoint\"></span></li><li><span data-translate=\"ute.tor.eligibilityResults.futureOwnerPoint2\"></span></li></ul></div><div class=\"col-xs-12 ute-tor-future-owner-second-title\"><span data-translate=\"ute.tor.confirmation.secondTitle\"></span></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepTwo/confirmation/confirmation.view.html","<section><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"transfer-of-responsibility-title-owner\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.currentOwner\" class=\"ute-tor-owner-title\"></span></div></div><div class=\"ute-tor-clear-both\"><div data-ng-include=\"confirmation.config.advanced.currentOwnerConfirmation.templateUrl\"></div></div></div></div></div></div></section>");
$templateCache.put("module/transferOfResponsibility/stepTwo/futureOwnerInfo/futureOwnerInfo.view.html","<section><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12 col-sm-8\"><div class=\"row\"><div class=\"col-xs-12\"><div class=\"transfer-of-responsibility-title-owner\"><span data-translate=\"ute.tor.transferOfResponsibility\" class=\"ute-tor-primary-title\"></span> <span data-translate=\"ute.tor.currentOwner\" class=\"ute-tor-owner-title\"></span></div></div><div class=\"col-xs-12\"><div data-ng-include=\"futureOwnerInfo.config.advanced.futureOwnerInfoForm.templateUrl\"></div></div></div></div></div></div></section>");
$templateCache.put("module/views/directives/hup/deviceBalance/wirelessDashPopup.html","<section class=\"wirelessDashPopup\"><div class=\"row\"><div class=\"col-sm-1 col-xs-2\" ng-if=\"!isBOTEligible\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\"></div><div class=\"col-sm-10 col-sm-push-1 col-xs-10 sorry_error\" ng-if=\"!isBOTEligible\"><span translate=\"sorry_error\"></span></div><div class=\"bot-header\" ng-if=\"isBOTEligible\"><img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/error_warning.png\" ng-if=\"isBOTEligible && !isCaseClosed\"> <img class=\"wireless_error_logo\" src=\"ute-common-assets/assets/green-checkbox.png\" ng-if=\"isBOTEligible && isCaseClosed\"> <span translate=\"hup_processed_error\" ng-if=\"isBOTEligible && !isCaseClosed\"></span> <span translate=\"case_success\" ng-if=\"isBOTEligible && isCaseClosed\"></span></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 wireless_error_content bot-content\" ng-hide=\"hupDetails.isMakePaymentAvailable\" data-ng-bind-html=\"hupDetails.errorMessage\"></div><div class=\"col-xs-12 wireless_error_content bot-content\" ng-show=\"hupDetails.isMakePaymentAvailable\"><span data-ng-bind-html=\"hupDetails.first\"></span> <a class=\"link-cancel pointer\" data-ng-click=\"payBill()\" tabindex=\"-1\"><span translate=\"hup_make_a_payment\"></span></a> <span data-ng-bind-html=\"hupDetails.last\"></span></div><div class=\"col-lg-6 col-md-6 col-sm-6 col-xs-12 phone_icon_parent\" ng-if=\"isConsumer\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 phone_icon\"><img class=\"phone_icon_img\" src=\"images/wirelessDash-popup_phone_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 phone_number_value\"><a href=\"tel:{{hupDetails.contactNumber}}\">{{hupDetails.contactNumber}}</a></div></div><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 phone_icon_parent\" ng-if=\"hupDetails.nfdb != \'NFDB\' && isConsumer\"><div class=\"col-lg-2 col-lg-offset-1 col-md-2 col-md-offset-1 col-sm-2 col-sm-offset-1 col-xs-2 col-xs-offset-1 live_chat_icon\"><img class=\"live_chat_icon_img\" src=\"images/wirelessDash-popup_live_chat_icon.png\"></div><div class=\"col-lg-9 col-md-9 col-sm-9 col-xs-9 live_chat_text\"><div class=\"live-chat-link\" ng-show=\"lng === \'en\'\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=707&amp;lctc=707%7C01%7Cws%7CHUP_landing%20en\" translate=\"mu_chat\" target=\"_blank\"></a></div><div class=\"live-chat-link\" ng-show=\"lng === \'fr\'\" target=\"_blank\"><a href=\"http://rogershelp.com/customerserv/livechatsupport/index.php?source=751&lctc=751%7C01%7Cws%7CHUP_landing%20fr\" translate=\"mu_chat\" target=\"_blank\"></a></div></div></div><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-8 col-sm-offset-0 col-xs-offset-4 button-section bot-button-section\"><button type=\"button\" class=\"btn btn-primary btn-md button_close\" ng-click=\"wirelessDashPopupclose()\" ng-if=\"!isBOTEligible\"><span translate=\"close\"></span></button><button name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"cancelCase()\" ng-if=\"isBOTEligible && !isCaseClosed\"><span translate=\"yes_change_hup\"></span></button> <button name=\"btn btn-primary btn-md button_close\" type=\"button\" class=\"cta-round primary medium\" ng-click=\"proceedWithHUP()\" ng-if=\"isBOTEligible && isCaseClosed\"><span translate=\"proceed_hup\"></span></button><a href=\"\" ng-click=\"wirelessDashPopupclose()\" ng-if=\"isBOTEligible && !isCaseClosed\" translate=\"modified_hup_wait_complete\" class=\"bot-status\"></a></div></div></section>");
$templateCache.put("module/paymentUI/payNow/templates/shared/payNowCard.partial.html","<form name=\"utePayNowModal.uteSemafoneForm\" novalidate=\"\"><div id=\"formCreditCard\" class=\"ptm wrapper padding-top-0\"><ute-credit-card user-type=\"utePayNowModal.paymentData.userType\" credit-payment-obj=\"utePayNowModal.paymentData.creditCardDetails\" card-time=\"utePayNowModal.paymentData.cardTime\" data-fire-data-layer=\"true\" data-is-modal-popup=\"true\" mapping-key=\"utePayNowModal.errorMappingKey\"></ute-credit-card></div><button class=\"ute-pay-now-continueButton\" translate=\"ute.payment.ui.payNow.continueAndReview\" ng-disabled=\"utePayNowModal.isDisabled()\" ng-click=\"utePayNowModal.goToReviewStep()\" ng-if=\"utePayNowModal.paymentData.userType === \'consumer\'\"></button> <button class=\"ute-pay-now-continueButton\" translate=\"ute.common.label.continue\" ng-disabled=\"utePayNowModal.isDisabled()\" ng-click=\"utePayNowModal.goToReviewStep()\" ng-if=\"utePayNowModal.paymentData.userType !== \'consumer\'\"></button> <a class=\"ute-pay-now-cancelButton ute-pay-now-paysection-cancel\" data-ng-click=\"utePayNowModal.close()\" translate=\"ute.common.label.cancel\" ng-if=\"utePayNowModal.isRep()\"></a></form>");
$templateCache.put("module/paymentUI/payNow/templates/shared/paymentError.partial.html","<div class=\"ute-pay-now-modalErrorBody\" ng-if=\"utePayNowModal.isServerError() === true\"><div class=\"error-header\" translate=\"{{utePayNowModal.serverErrorHeaderCard}}\" ng-if=\"utePayNowModal.isPaymentMethodCard()\"></div><div class=\"error-header\" translate=\"ute.payment.ui.payNow.serverErrorHeaderInterac\" ng-if=\"utePayNowModal.isPaymentMethodInterac()\"></div><div class=\"error-body-text\" ng-if=\"utePayNowModal.isPaymentMethodCard()\"><div ng-if=\"utePayNowModal.showSpecificErrorMessage\"><span translate=\"{{utePayNowModal.serverErrorMessagePartOne}}\"></span> <span translate=\"{{utePayNowModal.serverErrorMessagePartTwo}}\"></span> <span class=\"ute-pay-now-try-again-link\" ng-click=\"utePayNowModal.gotoPaymentStep()\" translate=\"ute.payment.ui.payNow.serverErrorMessageCard_try_again\"></span></div><div ng-if=\"utePayNowModal.showServerErrorMessageGeneral\" translate=\"ute.payment.ui.payNow.serverErrorMessageCard\"></div></div><div class=\"error-body-text\" ng-if=\"utePayNowModal.isPaymentMethodInterac()\" translate=\"ute.payment.ui.payNow.serverErrorMessageInterac\"></div><div ng-if=\"utePayNowModal.showSupportlinks\" data-ng-include=\"\'module/paymentUI/payNow/templates/shared/supportLinks.partial.html\'\"></div><div class=\"ute-pay-now-row\" ng-if=\"utePayNowModal.isPaymentMethodCard()\"><button class=\"ute-pay-now-button-secondary\" translate=\"ute.payment.ui.payNow.backToAccountOverview\" ng-click=\"utePayNowModal.goToAccountOverview()\"></button></div><div class=\"ute-pay-now-row\" ng-if=\"utePayNowModal.isPaymentMethodInterac()\"><div><button class=\"ute-pay-now-button-secondary\" translate=\"ute.common.label.tryagain\" ng-click=\"utePayNowModal.tryAgain()\"></button></div><div><button class=\"ute-pay-now-button-cancel\" translate=\"ute.payment.ui.payNow.done\" ng-click=\"utePayNowModal.close()\"></button></div></div></div><div class=\"ute-pay-now-duplicateErrorBody\" ng-if=\"utePayNowModal.isDuplicate() === true\"><div class=\"ute-pay-now-modal-header-overlay-header\"><div class=\"{{utePayNowModal.getHeaderLogoClass()}}\"><div translate=\"ute.payment.ui.payNow.dup_header\"></div></div></div><div class=\"duplicate-error-body\"><div class=\"dup-padding-container\"><div class=\"dup-info\"><span translate=\"ute.payment.ui.payNow.dup_info\"></span><br><span translate=\"ute.payment.ui.payNow.dup_protection\"></span></div><div class=\"dup-contact-text\" translate=\"{{utePayNowModal.getContactTranslationKey()}}\"></div><div class=\"dup-buttons\" ng-class=\"{\'sgi-dup-buttons\': utePayNowModal.isSGIAccount()}\"><button translate=\"ute.payment.ui.payNow.dup_payment_history\" ng-click=\"utePayNowModal.close(true)\" ng-if=\"!utePayNowModal.isSGIAccount()\"></button> <button translate=\"ute.payment.ui.payNow.done\" ng-click=\"utePayNowModal.close()\"></button></div></div><div class=\"dup-contact-us\"><div class=\"dup-contact-us-inner\"><div class=\"dup-live-chat\"><bold-chat-static-button data-cbid=\"{{utePayNowModal.liveChat.cbid | translate}}\" data-dynamic-div=\"{{utePayNowModal.liveChat.dynamicDiv | translate}}\" data-chat-button=\"{{utePayNowModal.liveChat.chatButton | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div></div></div>");
$templateCache.put("module/paymentUI/payNow/templates/shared/supportLinks.partial.html","<div class=\"support-links row\"><div class=\"left col-md-6 col-sm-12\"><div class=\"live-chat-view\"><bold-chat-static-button data-cbid=\"{{utePayNowModal.liveChat.cbid | translate}}\" data-dynamic-div=\"{{utePayNowModal.liveChat.dynamicDiv | translate}}\" data-chat-button=\"{{utePayNowModal.liveChat.chatButton | translate}}\" style=\"display: inline-block;\"></bold-chat-static-button></div></div></div>");
$templateCache.put("module/creditcard/directive/templates/partials/ccErrors.partial.html","<div class=\"cc-error-group\"><div class=\"inline_error\"><span class=\"inline_error\" id=\"getCreditCardErrorId()\" ng-if=\"showCreditCardError()\"><span data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"credit card\" data-fire-data-layer=\"trackCreditCardError()\">{{\"ute.rogers.myrCreditCard.invalid_card_error\" | translate }}</span></span></div></div>");
$templateCache.put("module/creditcard/directive/templates/partials/ccImages.partial.html","<div class=\"cc-images-group\"><img ng-src=\"{{cards.visa.image}}\" id=\"imgVisa\" ng-class=\"(creditPaymentObj.creditCardType.id === cards.visa.id) && (showCCImage === true) ? \'card_selected\' : \'card_not_selected\'\"> <img ng-src=\"{{cards.mc.image}}\" id=\"imgMc\" ng-class=\"(creditPaymentObj.creditCardType.id === cards.mc.id) && (showCCImage === true) ? \'card_selected\' : \'card_not_selected\'\"> <img ng-src=\"{{cards.amex.image}}\" id=\"imgAmex\" ng-class=\"(creditPaymentObj.creditCardType.id === cards.amex.id) && (showCCImage === true) ? \'card_selected\' : \'card_not_selected\'\"></div>");
$templateCache.put("module/creditcard/directive/templates/partials/cvErrors.partial.html","<div class=\"ute-semafone-care-cvError\"><div class=\"inline_error security-error\" ng-messages=\"frmCreditCard.securityCode.$error\" ng-if=\"showSecurityCodeError()\" data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"security code\" data-fire-data-layer=\"trackSecurityCodeError()\"><span ng-message=\"pattern\"><span class=\"prm\" translate=\"ute.rogers.myrCreditCard.non_numeric_security_code_error\"></span></span> <span ng-message=\"securityCodeRequired\"><span class=\"prm\" translate=\"ute.rogers.myrCreditCard.security_code_error\" translate-values=\"{numberOfDigits:securityCodeMaxLength}\"></span></span></div></div>");
$templateCache.put("module/creditcard/directive/templates/partials/cvInput.partial.html","<div class=\"ute-semafone-expiry-date-header-container\"><div class=\"ute-semafone-input-text-label\" translate=\"ute.rogers.myrCreditCard.paynow_code\"></div><div class=\"ute-semafone-info-icon security-tooltip-icon\" aria-label=\"{{ute.rogers.myrCreditCard.security_code_alt_text | translate}}\"><div class=\"ute-semafone-toolTip securityCode\"><span class=\"hidden-sm hidden-md hidden-lg hidden-xs\"><img class=\"pull-left\" src=\"ute-semafone/assets/cvv_security_code_s.png\"></span><div class=\"ptm plm inline-block description\" ng-bind-html=\"tooltip\"></div></div></div></div><div class=\"ute-semafone-input-container\"><input type=\"{{:: CvType }}\" id=\"securityCode\" name=\"securityCode\" class=\"ute-semafone-security-code-input title-light-h5 security-code\" placeholder=\"{{securityCodePlaceHolder}}\" ng-model=\"creditPaymentObj.securityCode\" ng-pattern=\"/^\\d+$/\" maxlength=\"{{securityCodeMaxLength}}\" ng-focus=\"onFocus()\" ng-blur=\"onBlur();\" ng-model-options=\"{ \'updateOn\': \'default blur\', \'debounce\': { \'default\': 250, \'blur\': 0 } }\" ng-change=\"validateSecurityCode(true)\" required=\"\" ng-trim=\"true\" ng-class=\"{\'security-input-fr\' : lang == \'fr\'}\" cobrowse=\"false\" autocomplete=\"off\"></div><div ng-include=\"\'module/creditcard/directive/templates/partials/cvErrors.partial.html\'\"></div>");
$templateCache.put("module/creditcard/directive/templates/partials/dateSelects.partial.html","<div class=\"ute-semafone-input-text-label\" translate=\"ute.rogers.myrCreditCard.paynow_expiry_date\"></div><div class=\"ute-semafone-expiry-date-select-container ute-semafone-select-view\"><select class=\"select-month\" name=\"month\" ng-model=\"creditPaymentObj.expireDate.month\" required=\"\" ng-change=\"validateDateExpiry()\" ng-options=\"value for value in cardTime.months\" cobrowse=\"false\" autocomplete=\"off\"><option value=\"\" translate=\"ute.rogers.myrCreditCard.month_label\"></option></select></div><div class=\"ute-semafone-care-expiryYear-container ute-semafone-select-view\"><select class=\"select-year\" name=\"year\" data-ng-model=\"creditPaymentObj.expireDate.year\" required=\"\" ng-change=\"validateDateExpiry()\" ng-options=\"value for value in cardTime.years\" cobrowse=\"false\" autocomplete=\"off\"><option value=\"\" translate=\"ute.rogers.myrCreditCard.year_label\"></option></select></div><div ng-include=\"\'module/creditcard/directive/templates/partials/securityErrors.partial.html\'\"></div>");
$templateCache.put("module/creditcard/directive/templates/partials/securityErrors.partial.html","<div class=\"ute-semafone-security-error-group\"><div class=\"inline_error\" ng-if=\"isExpDateValid === false\"><span ng-messages=\"frmCreditCard.year.$error && frmCreditCard.month.$error\"><span ng-message=\"monthRequired\"><span data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"expiry date\" data-fire-data-layer=\"trackExpiryDateError()\">{{\"ute.rogers.myrCreditCard.expiry_date_in_past\" | translate}}</span></span></span></div><div class=\"inline_error\" ng-if=\"showInvalidExpiryDateError()\"><span ng-messages=\"frmCreditCard.year.$error && frmCreditCard.month.$error\"><span ng-message=\"required\"><span data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"expiry date\" data-fire-data-layer=\"trackExpiryDateError()\">{{\"ute.rogers.myrCreditCard.paynow_date_required\" | translate}}</span></span></span></div><div class=\"inline_error\" ng-if=\"showSelectMonthError()\"><span ng-messages=\"frmCreditCard.month.$error\"><span ng-message=\"required\"><span data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"month\" data-fire-data-layer=\"trackExpiryDateError()\">{{ \"ute.rogers.myrCreditCard.paynow_month_required\" | translate}}</span></span></span></div><div class=\"inline_error\" ng-if=\"showSelectYearError()\"><span ng-messages=\"frmCreditCard.year.$error\"><span ng-message=\"required\"><span data-ute-data-layer-form-field-error=\"\" data-is-modal-popup=\"isModalPopup\" data-mapping-key=\"mappingKey\" data-form-field-name=\"year\" data-fire-data-layer=\"trackExpiryDateError()\">{{\"ute.rogers.myrCreditCard.paynow_year_required\" | translate }}</span></span></span></div></div>");}]);
angular.module("translations", []).config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {"0":"","10001":"Not valid form data have been passed","10300":"The account you are registering is a business account.  Please visit our <a href='https://www.rogers.com/web/smb/bss/#/signin'>Business Self-Serve log-in page</a> to register your account and access your usage and billing info. Thanks!","10301":"We’re unable to link your account at the moment. Please try again later.","10302":"This account is already associated to a MyRogers profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via","10303":"Sorry, the postal code does not match what we have on record for the account number you have entered.  Please check that your postal code and account number entries are correct.","10304":"Please enter a valid 9 to 12 digit number","10305":"Sorry, the account number entered could not be found. Please check that your entry is correct.","10306":"Sorry, the account number entered could not be found. Please check that your entry is correct.","10311":"Sorry, the phone number entered could not be found. Please check that your entry is correct","10312":"Sorry, the phone number entered is already linked to a MyRogers profile.","10313":"Sorry, the PIN does not match.","10314":"Failed to get subscription info base on Pin and CTN provided","10350":"No email has been found for this account.","10401":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank'>Live Chat</a>.","10402":"The security answer entered does not match our records. Please re-enter your answer.","10403":"get postpaid account details failed","10412":"failed to get prepaid account list due to SOAP Fault","10413":"get prepaid account details: failed to find ctn","10414":"get prepaid account details: failed to find pin","10415":"get prepaid account details: failed to get subscription list","10416":"get prepaid account details: failed to get account details","10501":"This account is already associated to a MyRogers profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via","10502":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank'>Live Chat</a>.","10503":"Failed to complete forgotUsername operation","10504":"Failed to get security question","10505":"The security answer entered does not match our records.  Please re-enter your answer.","10506":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank'>Live Chat</a>.","10601":"Failed retrieve Usage","10602":"getting roaming usage returns error code","10603":"getting usage returns error code","11401":"unexpected error in TVLandingActor","11402":"cable product details not found","11403":"failed getting cable product details","11404":"cable product package not found","11405":"failed getting cable product package","11406":"failed populating cable info","11411":"error occurred when getting plan deteail from cassandra","11412":"error occurred when getting digital box deteail from cassandra","11413":"error occurred when getting themepack deteail from cassandra","11414":"error occurred when getting channel deteail from cassandra","12000":"Permission Denied","13001":"Failed create secret key","13002":"Encryption Failed","13003":"Decryption Failed","13004":"URLEcode Failed","15040":"Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again.","50000":"Unknown Server Error","50001":"Not defined yet Server Error","50002":"Please log off and try to login again with your new username","50018":"Sorry, something went wrong. Please try again or check back later.","700000212":"Copy not yet provided","700000238":"Copy not yet provided","790000038":"Copy not yet provided","790000041":"Copy not yet provided","790000042":"Copy not yet provided","790000043":"Copy not yet provided","790000044":"Copy not yet provided","790000045":"Copy not yet provided","790000051":"Copy not yet provided","800000020":"Copy not yet provided","800000021":"Copy not yet provided","809999999":"Copy not yet provided","ute":{"casl":{"electronicAddresses":{"mainHeading":"Messaging and communication","subHeading":"Data messaging and communications","addressheading":"Rogers electronic marketing messages","selectBoxLabel":"Send all data SMS messages to:","saveSelectionBtn":"Save","updatedSelectionBtn":"Updated","prefNotFoundMsg":"Your preferences could not be found.","infoAlertMsg":{"title":"What does this mean ?","msg":"The number you select will receive all text messages related to data usage, data overages and wireless plan alerts. You can select any of the lines that are part of <b>Share Everything</b><sub><b>TM</b></sub> plan."},"preference":{"linkTitle":"Manage messages","toggleYes":"Yes","toggleNo":"No"},"sms":{"prefHeading":"Text message marketing preferences"},"email":{"prefHeading":"Email marketing preferences"},"getErrorDetail":"Your preferences could not be found.","updateErrorDetail":"<b>We're sorry, but we were not able to save your selections.</b>"}},"easy":{"login":{"title":"Select your Rogers services","common":{"back":"Back","continue":"Continue","cancel":"Cancel","password":"Show","text":"Hide","myRogers":"MyRogers","register":"Register","account":"Account:","email":"Email","verify":"Verify","done":"Done","secure":"Secured Form","liveChat":"<bold-chat-static-button data-cbid='6404235957168908537' data-dynamic-div='S_RegistrationIssues' data-chat-button='S_RegistrationIssues' style='display:inline-block'></bold-chat-static-button>"},"registration":{"transitionScreenHeading":"Hang tight, we’re almost done creating your profile!","transitionScreenDescription":"Please don’t refresh or close this page.","header":"Which Rogers services do you have?","oneOrMore":"One or more of:","wireLess":"Wireless (on a monthly plan)","internet":"Internet","tv":"TV","homeMonitoring":"Home Monitoring ","homePhone":"Home Phone","services":"Wireless/Residential services","payAsYouGoWireless":"Pay As You Go™ Wireless","payAsYouGoService":"Pay As You Go service","rogersBusinessCustomer":"Rogers Business customer?","registerBusinessSelfServe":"Register at Business Self-Serve >","noRogersServices":"I don’t have Rogers services","rogersServicesNotAvailable":"MyRogers is only available to Rogers customers.","seeWhatWeCanDo":"See what we can do for you…","shop":"Shop","step":{"account":"Account","email":"Email","verify":"Verify","password":"Password","complete":"Done"},"step_main_header":"","step_account_header":"Register for MyRogers","step_email_header":"Which email address would like to sign in with?","step_verify_header":"Verification email sent","step_password_header":"Set your password","step_complete_header":"Thanks for registering!","account":{"header":"Which account would you like to set up?","rogersAccountNo":"Rogers account number","rogersAccountNoPlaceHolder":"9- or 12-digit number","whereToFind":"Where to find your account number:","monthlyPaperBill":"On your monthly paper bill","monthlyEmailMessage":"Monthly email message notifying you that your online bill is ready","serviceAgreement":"Your service agreement (given to those that signed up in-store)","postalCodeAddress":"Postal code for your billing address","error_null":"","account_empty_error":"required","account_incomplete_error":"incomplete","postal_empty_error":"required","postal_incomplete_error":"incomplete","accountRequiredError":"Please enter an account number.","accountPatternError":"Your account number should be 9 or 12 digits.","postalRequiredError":"Please enter a postal code","postalPatternError":"Please enter postal code in this format: A1A1A1","ech5":"To continue, select <strong> I'm not a robot.</strong>","ech4":"That postal code doesn't match to the billing address. Please try again or chat with a rep for help. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck5":"We weren't able to find that account and/or postal code. Please try again or chat with a rep for help.<span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck6":"This account has been cancelled or suspended. Please connect with a rep for help.","eck7":"This account is registered to: {{maskedEmail}}<br/> <a class='signin-interceptor'> If this is you, just sign in.</a> For help, connect with a rep. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck8":"??????????????????????????","eck9":"This link has expired. Please re-enter your account number and postal code to begin a new request.","ecf4":"To register a Business account, please go to <a href=\"/web/totes/#/sso/registration\"> Business Self-Serve.</a>"},"accountRegistered":{"header":"Great news! ","message":"A MyRogers profile has already been started for this account.","completeRegistration":"To complete your registration…","sendEmailmessage":"Select <strong > Send email</strong> below and we’ll send you a link for you to create your MyRogers password.","emailSentTo":"Email will be sent to:","sendEmail":"Send email"},"email":{"header":"Which email address would like to sign in with?","enterEmail":"Enter email ","reEnterEmail":"Re-enter email","error_null":"","ech1":"Please fill out all fields to continue.","ecd2":"Address should be in this format: name@email.com","ech3":"Your entries must match.","eca7":"Sorry, there's an issue on our end. Thanks for your patience while we fix it. Please check back later.","ecd5":"This email is being used by another MyRogers account. If you're trying to add an account to your profile, <a class='signin-interceptor'> sign in </a>. If you'd like help, chat with a rep now. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","fail_to_send":"Failed to send email","verify":{"verifyingLink":"Verifying link…","linkVerified":"Link verified!","linkExpired":"Link expired"}},"verify":{"header":"Verification email sent","message":"In the email we just sent you, select <strong> Set password  </strong> to complete your registration.","messageSentTo":"Message sent to:","didntGetEmail":"Didn’t get the email?","eck9":"Ce lien est expiré. Veuillez entrer de nouveau votre numéro de compte et votre code postal afin de faire une nouvelle demande.","didntGetEmailExpanded":{"checkSpam":"Check your spam or junk folder","giveFewMinutes":"Give it a few more minutes to arrive","stillNeedHelp":"Still need help?","liveChat":"Live Chat","resendCode":"Resend email","sendToDifferentEmail":"Send to a different email","sendingCode":"Sending email","codeSent":"Email sent!","pleaseContactUs":"Please contact us"}},"password":{"header":"Set your password","enterPassword":"Enter password","reEnterPassword":"Re-enter password","setPassword":"Set password","error_null":"","passwordMustHave":"Your password must have:","passwordAtLeast":"At least one letter and one number","passwordMinimum":"A minimum of 8 characters","passwordCanInclude":"You can include special characters and upper/lower-case letters. Passwords are case-sensitive.","bothPasswordMatch":"Both passwords match","ech1":"Please fill out all fields to continue.","ech2":"Your password should be between 8-64 characters and have at least one number and one letter.","ecd5":"This email is being used by another MyRogers account. If you're trying to add an account to your profile, <a class='signin-interceptor'> sign in </a>. If you'd like help, chat with a rep now.","eck5":"We weren't able to find that account and/or postal code. Please try again or chat with a rep for help.<span>{{'ute.easy.login.common.liveChat' | translate}}</span>"},"complete":{"header":"Thanks for registering!","message":"We’ve sent you a confirmation email. <br/> You’re now signed in to MyRogers, where you can view and manage your services.","goToOverview":"Go to your Overview","goToSignin":"Sign In","haveOtherAccounts":"Have other Rogers accounts?","linkAccounts":"Link them to MyRogers >","ech1":"You must fill out all fields to continue.","ech3":"Your entries must match."},"contest_banner_desc":"Register by July 18 and you’ll be automatically entered to win a $100 Rogers<sub>TM</sub> Visa* prepaid card! <a href=\"http://rogers.com/cms/rogers/pdf/MyRogers_Registration_Contest_Rules.pdf\" target=\"_blank\">See full contest rules.</a>","contest_banner_step5_desc":"Thanks for registering. You’ve been entered to win a $100 Rogers<sub>TM</sub> Visa* prepaid card!","contest_banner_step5_subtext1":"*Prepaid card is issued by Peoples Trust Company pursuant to license by Visa Int.","contest_banner_step5_subtext2":"*Trademark of Visa International Service Association and used under license by Peoples Trust Company."},"userNameMigration":{"changeUserName":{"optional":{"header":"Simplify sign-in! ","message":"Use your email address as your username. <br/> It’ll only two minutes and your password stays the same.","setUpNow":"Set up now","remindMeInWeek":"Remind me in a week","skip":"Skip"},"mandatory":{"header":"Simplifying sign-in!","message":"We’re now asking all our customers use their email address as their username. <br/>It’ll only two minutes and your password stays the same.","setUpNow":"Set up now","cancelSignIn":"Cancel sign-in"}},"verify":{"header":"We’ve emailed you a verification code","message":"Enter the 7-digit code emailed to: {{maskedEmail}}","verifyMe":"Verify me"},"done":{"header":"Your username has been changed","message":"We’ve sent you a confirmation email.","signInWith":"You can now sign in with {{maskedEmail}}","signIn":"Sign in"}},"linkAccount":{"wirelessVsPrepaid":{"header":"Which Rogers account would you like to add to your profile?","wirelessOrResidential":"Wireless/Residential:","wireLess":"Wireless (on a monthly plan)","internet":"Internet","tv":"TV","homeMonitoring":"Home Monitoring ","homePhone":"Home Phone","goToWirelessOrResidential":"Wireless/Residential","payAsYouGoPrepaidWireless":"Pay As You Go™  (Prepaid) Wireless","payAsYouGo":"Pay As You Go","rogersBusinessCustomer":"Want to add a Business account?","registerBusinessSelfServe":"Sign in to Business Self-Serve >"},"newAccount":{"header":"Add a Wireless/Residential account","addAccount":"Add account"},"complete":{"header":"Account added!","message":"We’ve sent you a confirmation email. ","setNickName":"Set a nickname for this account.","editNickName":"Edit Nickname","account":"Account:","default":"","saveNickName":"Save nickname","autoViewAccount":"Want to automatically view this account each time you sign in?","setDefaultView":"Yes, set as default view","noThanks":"No thanks"},"prePaid":{"header":"Link account","message":"To link your account just enter your <strong> Pay As You Go™ </strong> account details:","wirelessNumber":"10-digit wireless number","accountPin":"4-digit account PIN","cannotRememberPin":"Can't remember your account PIN?","callForHelp":"Call <strong> 1 800 575-9090 </strong> and a rep will help you out.","linkAccount":"Link account","cancel":"Cancel"}},"error":{"error_null":"","eca6":"Access to this MyRogers account has been suspended. Please connect with a rep for help.","eca7":"Sorry, there's an issue on our end. Thanks for your patience while we fix it. Please check back later.","ech1":"Please fill out all fields to continue.","ech2":"Your password should be between 8-64 characters and have at least one number and one letter.<br/><br/>The following special characters are allowed: ! @ # $","ech3":"Your entries must match.","ecd2":"Address should be in this format: name@email.com","ecd5":"This email is being used by another MyRogers account. If you're trying to add an account to your profile, <a class='signin-interceptor'> sign in </a>. If you'd like help, chat with a rep now.","eck1":"Please enter an account number.","eck2":"Your account number should be 9 or 12 digits.","eck3":"Please enter a postal code","eck4":"Please enter postal code in this format: A1A1A1","eck5":"We weren't able to find that account and/or postal code. Please try again or chat with a rep for help.<span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck6":"This account has been cancelled or suspended. Please connect with a rep for help.","eck7":"This account is registered to: {{maskedEmail}}. <a class='signin-interceptor error-bold'> If this is you, just sign in.</a> To set a new password select <a class='forgot-password-interceptor error-bold'>Forgot password.</a><br/>For help, connect with a rep. <span class='fake-link error-bold'>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck8":"Sorry, this account is linked to another email address. Please contact us through <span class='fake-link error-bold'>{{'ute.easy.login.common.liveChat' | translate}}</span> for help","eck9":"This link has expired. Please re-enter your account number and postal code to begin a new request.","eck10":"This account is registered to: {{maskedEmail}}. <br/>To set a new password select <a class='forgot-password-interceptor error-bold'>Forgot password.</a><br/> For help, connect with a rep. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck11":"This link is no longer valid. Please re-enter your account number and postal code to begin new request","ecp1":"There's been no activity for 30 minutes, so we signed you out to keep your info safe.","ecp2":"Sorry, something went wrong. Please try again or check back later.","ecq1":"You've given another account this nickname. Please choose a nickname that's unique.","ecf4":"To register a Business account, please go to <a href=\"/web/totes/#/sso/registration\"> Business Self-Serve.</a>","ecf5":"The account you are registering is a business account. Please visit our <a href=\"/web/smb/bss/#/sso/registration\">Business Self-Serve</a> page to register your account, and access your usage and billing info."}}},"eclipseRemote":{"error":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","liveChat":"Live Chat"},"goPaperless":{"liveChat":{"cbid":"863675321667007500","dynamicDivId":"gopaperlessErrorHelpButton-en","chatButtonClass":"S-Care_gopaperless_Update_Issue-en"},"emailModal":{"withContactEmail":{"title":"Switch to Online Billing","saveEmailMessage":"Update your email address:","newEmail":"Enter new email address","newEmailConfirm":"Confirm new email address","saveAndSwitch":"Save and switch to online billing"},"withoutContactEmail":{"title":"Enter your email address","saveEmailMessage":"Choose the email you’d like to use to receive billing notifications","newEmail":"Enter your email address","newEmailConfirm":"Re-enter your email address","saveAndSwitch":"Continue"},"currentEmailMessage":"When your bill is ready, we’ll send a notification to the email below.","switch":"Switch to online billing","cancel":"Cancel","validEmailError":"Please enter a valid email address.","matchEmailError":"Email addresses must match.","updateEmail":"Update email address"},"switchToOnlineBilling":"Switch to Online Billing","switchNow":"Switch now","modalDone":"Done","learnMore":"Learn more","learnMoreSwitch":"Switch now","learnMoreCancel":"No thanks","errorTitle":"Sorry ...","updateEmailErrorMessage":"We’re experiencing some technical issues and aren’t able to update your email at the moment. If you contact us we’ll be happy to complete your email update and switch you to online billing.","switchBillingErrorMessage":"We’re experiencing some technical issues and aren’t able to switch you to online billing at the moment. If you contact us we’ll be happy to help you switch.","switchedButUpdateEmailFailedErrorMessage":"We’re experiencing some technical issues and aren’t able to update your email at the moment. If you contact us we’ll be happy to complete your email update."},"historical":{"usage":{"header":"Past shared data usage","usage_header":"Usage Overview","total_data":"Total Shared Data (GB)","totalUsage":"Total Usage*","overage":"Overage","loading":"Loading past usage","error_header":"We’re having a technical issue","error_desc":"So sorry, we weren’t able to display past data usage. <br />Please try again later.","MB":"MB","GB":"GB","average":"Average Usage","usage_by_line":"Usage by line","topup":"","ban":"BAN: ","note1":"<strong>* Total Usage</strong> displayed in GB/MB has been rounded up or down to two decimal points for this Share Everything plan.","note2":"<strong>**</strong> Includes both top-up and bonus data added.","leftplan":"Left plan"}},"common":{"oneview":{"header":{"subMenu":{"acc_overview_my_account_overview":"Overview","submenu_billing_and_payment":"Billing &amp; Payment","submenu_services":"Services","service_wireless":"Wireless","service_internet":"Internet","service_tv":"TV","service_phone":"Home Phone","service_monitoring":"Monitoring","service_wireless_prepaid":"<i>PAY AS YOU GO<sup>TM</sup></i>","submenu_link_account":"Link Account","transfer_of_responsibility":"Transfer of Responsibility","oneview_bundlebuilder":"Offer Builder (in OASYS)","submenu_profile":"PROFILE & SETTINGS","interaction":"INTERACTIONS","actions_and_offers":"ACTIONS &amp; OFFERS","myaccoverview_home_monotoring":"Home<br/> Monitoring","orders":"Orders"},"global":{"sign_out":"Sign out","language_toggle":"Français","welcome":"Welcome","welcome_comma":"Welcome, "},"repCart":{"_saved_quotes":"My Quotes","_quote":"Quote #","_expired":"EXPIRED","expires":"Expires","_my_cart":"My Shopping List","ppc":"Price Plan Change","hup":"Hardware Upgrade","nac":"Add a new line"},"consumerCart":{"_saved_quotes":"My Quotes","_quote":"Quote #","_expired":"EXPIRED","expires":"Expires","_my_cart":"My Shopping List","ppc":"Price Plan Change","hup":"Hardware Upgrade","nac":"Add a new line","ignite":"Ignite Bundle","igniteDeleteAlt":"Select to remove Ignite Bundle from your cart"},"consumerDetails":{"show_less":"Show less","show_more":"Show more","c_class":"C Class: ","c_limit":"C Limit: ","c_available":"C Available: ","tenure":"Tenure","since":"Since","content_currently_unavailable":"Content currently unavailable.","interactions_in_the_last_30_days":"Interactions in the last 30 days: ","c_interactions":"Interactions","filer_tickets":"Tickets","customer_duration":"{{years}} YEAR(S) , {{months}} MONTH(S)","accSubType_regular":"Regular","accSubType_non-revenue":"Non-Revenue","accSubType_prepaid":"Prepaid","accSubType_corporate":"Corporate","accSubType_federal":"Federal","accSubType_provincial":"Provincial","accSubType_municipal":"Municipal","accType_consumer":"Consumer","accType_business":"Business","accType_government":"Government","accStatus_open":"Open","accStatus_active":"Active","accStatus_suspended":"Suspended","accStatus_cancelled":"Cancelled","accStatus_pending_disconnect":"Pending Disconnect","accStatus_pending_connection":"Pending Connection","arpa":"ARPA","arpa_info":"ARPA – Average Revenue Per Account represents the average revenue for the past 3 months for all Product Lines rolled up to the customer’s ECID. (For ECID, please see NOVA DOC ID REF827)","arpa_error_msg":"ARPA Value is not available"},"bfappcWirelessDashboardService":{"ppc_something_went_wrong_message_title":"Sorry, Something Went Wrong.","ppc_something_went_wrong_message_text":"We’re working on fixing it as quickly as we can. Your price plan changes have not been saved. <br/> Please check back in a few minutes."},"modals":{"passcode":"Passcode","evp_portal_msg":"Get passcode via EVP portal","enable_idv_msg":"Please get IDV passcode from customer and enter below to identify its IDV status.","invalid_passcode":"Please try again later","invalid_passcode_msg":"Sorry, there’s a problem with the passcode you’ve entered.","system_error":"System Error","system_error_msg":"Sorry, we are experiencing some technical issues at the moment.","success_msg":"Success: Discount applied","success_passcode":"Success! IDV passcode applied","success_passcode_msg":"In order to receive the discount, the customer needs to change to an in market share everything plan.","success_discount_msg":"Discounts have been applied to account.","confirm_header_msg":"Confirmation: Fee will be charged","confirm_msg":"A fee in the amount of ${{migFee}} will be charged to the customer","confirm_confirmation_msg":"Still want to continue?","okay":"Okay","try_again":"Try Again","cancel":"Cancel","enter":"Enter","continue":"Continue"},"util":{"_months":{"0":"January","1":"February","2":"March","3":"April","4":"May","5":"June","6":"July","7":"August","8":"September","9":"October","10":"November","11":"December"}},"wirelessDashboardService":{"error_wireless_usage":"We’re sorry, but we’re unable to retrieve your wireless service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","fraud_display_message":"Unfortunately the transaction cannot be completed as further validation is required. Please advise the customer to call 1-888-383-2080 for further assistance in completing their request.","credit_ops_display_message":"We are unable to complete your transaction at this time. Please advise the customer to call 1-800-551-5700 for further assistance in completing their request."},"oneViewHeaderController":{"dealer-code":"Dealer Code"},"idvDetails":{"idv_account":"IDV Account","non_idv_account":"Non IDV Account","enable_idv_account":"Enable IDV account","show_details":"Show details","hide_details":"Hide details","validate_idv_status":"Validate IDV status","unknown_idv_status":"Unknown IDV Status","company_name":"Company Name: ","company_code":"Company Code: ","idv_status_date":"IDV Status Date: ","idv_falloff_date":"IDV Falloff Date(IDV Discount Expiry Date): ","last_validation_date":"Last Validation Date: "}}},"label":{"currentLang":"en","currency.sym.left":"$","currency.sym.right":"","edit":"Edit","cancel":"Cancel","check.form.errors":"There are errors on this page.  Please review the message(s) above each line.","contact.info":"Contact Information","continue":"Continue","email.address":"Email Address","email.confirm":"Confirm Email Address","email.invalid":"Please enter a valid email address","email.verification":"Email Verification","myRogers":"MyRogers","username":"Username","username.edit":"Edit username","username.change":"Change username","username.and.password":"Username and Password","username.guildeline":"Username guidelines","username.guildeline.list":"<br><div style=\"line-height: normal; margin-bottom: 10px\">Username must be an email address 254 characters or less and follow this format: name@email.com.</div><div style=\"line-height: normal;\">Once changed, it should be used to sign in to MyRogers or to recover a forgotten password. To receive service notifications at this email address, update your contact info in the section below. </div>","password":"Password","password.old":"Old Password","password.incorrect":"Old password incorrect.","password.new":"New Password","password.change":"Change Password","password.confirm.new":"Confirm New Password","password.invalid":"Please enter a valid password","password.forgot":"Forgot Password","password.reset":"reset password","password.wrong":"You can use only numbers and letters in your password, not special characters. Please try again.","password.reenter":"Please confirm your password by re-entering it.","password.notmatch":"Your password confirmation entry does not match.","password.edit":"Edit password","password.guildeline":"Password guidelines","password.guildeline.list":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","language.preference":"Language Preference","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","save.changes":"Save Changes","chat.live":"Live Chat","need.help":"Need Help?","thankyou":"Thank You!","tryagain":"Try again","contactUs":"Contact Us","findStore":"Find a store","learnHowTo":"Learn how to","moving":"Moving","andMore":", and more","needHelpWith":"Need help with","tv":"TV","wireless":"Wireless","internet":"Internet","bundles":"Bundles","homePhone":"Home Phone","smartHomePhone":"Smart Home Phone","homeMonitoring":"Home Monitoring","visitSupport":"Visit Support","troubleshoot":"Troubleshoot","signIn":"Sign In","newToRogers":"New to Rogers?","registerNow":"Register now","month":"month","did.you.know":"Did you know?","remind.customer":"Remind the customer:","close":"Close","online":"Online","creditCards":{"AMEX":"American Express","MASTERCARD":"MasterCard","VISA":"VISA","AMEX.img":"images/am.png","MASTERCARD.img":"images/mc.png","VISA.img":"images/visa.png"},"selfServeOnly":"Self-serve only","account":"Account","account.short":"Acct","overview":"Overview","billAndPayment":"Billing &amp; Payment","billAndAccountBalance":"Your bill and account balance","myServices":"Usage & Services","services":"Services","profileAndSetting":"Settings","family":"Lorem ipsumdol","interactions":"Interactions"},"form":{"secured":"Secured Form"},"error":{"general":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","maintenance":"Looks like you’re trying to access your services through MyRogers. We apologize, unfortunately the information you’re looking for is temporarily unavailable. Please check back later and thank you for your patience!"},"reactivate":{"ctn":{"renameMePlease":"rename_me_please","wirelessNumber":"Wireless Number","devicePage":"Back to device page","device":"Device","deviceName":"","backToDevice":"Back to Device Page","images":{"call":"ute-common-assets/assets/call.png","widgetLoader":"ute-common-assets/assets/widget-loader.gif","errorWarning":"ute-common-assets/assets/error_warning.png","close":"ute-common-assets/assets/close-icon.png","phoneCancel":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","phoneDouble":"ute-common-assets/assets/wireless/mobile_phone_double.png"},"boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"reactivate-ctn-en","chatButtonClass":"chatButton-Reactivate-ctn-en"},"boldChatError":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"reactivate-ctn-err-en","chatButtonClass":"chatButton-Reactivate-ctn-err-en"},"supportPhoneNumber":"1 (855) 381-7834","messageBox":{"title":"Your device is suspended","messageLeft":"Did you find your phone?","buttonText":"Reactivate Your Services","messageRight01":"Need a new phone and SIM card?","messageRight02":"Talk to us and we'll help you out.","repviewTitle":"Customer's device is suspended","repviewMessageLeft":"Did they find their phone?","repviewButtonText":"Reactivate services"},"fail":{"title":"We are unable reactivate your device at this time.","message":"Sorry about that. You can try again later through the device page, or speak to an agent.","supportPhoneNumber":"1 (855) 381-7834","repview_title":"We weren't able to re-activate customer's device at this time.","repview_message":"Sorry about that. You can try again later through the device page.","repview_possible_reasons":"Possible reasons:","repview_pending_cancellation":"Pending cancellation","repview_fraud":"Fraud","repview_credit_limit":"Credit Limit Monitoring"},"success":{"header":{"title":"Services resumed","message":"Your talk, text, and data services have been switched on and you can use your phone as per usual.","repview_message":"This customer's talk, text, and data services have been switched back on and they can use their phone as per usual."},"body":{"header":"Keep in Mind&hellip;","message01Icon":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","message01":"Your account was not cancelled. Your services were temporarily switched off.","repview_message01":"Customer's account was not cancelled. Their services were temporarily switched off.","message02Icon":"ute-common-assets/assets/wireless/mobile_phone_double.png","message02":"Please turn your device off and on to resume using.","repview_message02":"Please advise customer to turn their device off and back on to resume using.","question":"Questions?","answer":"Just ask us. We're happy to help.","repview_header":"Keep in mind"}}}},"second.level":{"navigation":{"header":"MyRogers","headerShort":"My","defaultAccountOption":"Select an account to manage:","linkAnotherAccount":"Link another account","selectTheAccount":"Select an account to manage:","wireless.phone":"{{name}} {{phoneNumber}}","wireless.phone.prepaid":"PAY AS YOU GO<sup>TM</sup> {{phoneNumber}}","iptv":"TV","smartstream":"Entertainment","hsiinternet":"Internet","tv":"TV","internet":"Internet","gateway":"Ignite Equipment","home.phone":"Home Phone {{phoneNumber}}","home.monitoring":"Home Monitoring","shareEverything":"Wireless Usage","infiniteTitle":"Wireless Usage","billing":{"viewBill":"View your bill","makePayment":"Make a payment","changePaymentMethod":"Change payment method","setUpAutomaticPayments":"Set up automatic payments","paymentHistory":"Payment history"},"profileLanding":{"overview":"Settings Overview","contactAndBilling":"Contact & Billing","security":"MyRogers Profile","linkedAccounts":"Linked Accounts"}}},"suspend":{"ctn":{"boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"suspend-ctn-en","chatButtonClass":"chatButton-suspend-ctn-en"},"boldChatError":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"suspend-ctn-err-en","chatButtonClass":"chatButton-suspend-ctn-err-en"},"confirm":{"switchOffService":"Switch off my services","backToDevice":"Back to device page","wirelessNumber":"Wireless Number","devicePage":"Back to device page","device":"Device","sorryToHear":"Sorry to hear <br> you've lost your phone.","repView_sorryToHear":"Customer lost his phone","rightPlace":"You're in the right place to find a solution","firstStep":"1 - If you have a smartphone, try locating your device through:","secondStep":"2 - Have your services switched off so nobody can use your talk, text, and data.","thirdStep":"3 - Still haven't found your phone? Let's talk about your options.","ifFind":"If you happen to find your phone, you can simply switch them on again.","turnOff":"This will turn off your:","confirmEmail":"A confirmation email will be sent to <span class=\"bold\">{{::accountEmail}}</span>","updateEmail":"update email address","data":"- Data","talk":"- Talk","text":"- Text","findIphone":"Find my iPhone","findAndroid":"Find my Android","findIphoneUrl":"https://www.icloud.com","findAndroidUrl":"https://myaccount.google.com/intro/find-your-phone","repview_customer":"This customer has lost their phone.","repview_steps":"Use these steps to help them find a solution.","repview_firstStep":"1 - Advise customer to try locating their device through these services:","repview_secondStep":"2 - Switch customer's services off below so no one else can use their talk, text, and data. ","repview_turnoff":"This will turn off the following services","repview_thirdStep":"3 - Ask the customer if they'd like to add the device to the <b>IMEI Blacklist</b> to prevent it from being used on the Rogers/Fido networks, as well as networks of supporting carriers.","repview_findIphone":"Find my iPhone:","repview_findAndroid":"Android Device Manager:","repview_switch_service":"Switch customer's services off below so no one else can use their talk, text, and data. This will turn off the following services.","repview_ifFind":"If phone is found, let customer know they can simply re-activate through MyRogers.","repview_note":" <b>Note:</b> Confirm that device has been used within the last 60 days in order to add to Blacklist, and review the unbilled usage in V21 to set customer's expectations of pending charges on the account.","repview_offering":"Consider offering the customer alternative solutions such as a Hardware Upgrade with Device Protection, or a Trade-Up.","repview_updateEmail":"Update contact email address","repview_talk":"- Talk","repview_text":"- Text","repview_switchOffService":"Switch off services"},"fail":{"title":"We are unable to suspend your device at this time.","repview_title":"We weren't able to suspend customer's device at this time.","message":"Sorry about that. You can try again later through the device page, or speak to an agent. ","supportPhoneNumber":"1 (855) 381-7834","repview_possible_reasons":"<b>Possible reasons:</b>","repview_pending_cancellation":"Pending cancellation","repview_fraud":"Fraud","repview_credit_limit":"Credit Limit Monitoring","repview_update_soc":"Duplicate SOC issue","repview_sorry_msg":"Sorry about that. You can try again later through the device page."},"success":{"header":{"title":"Services suspended","message":"Your services are now switched off and your talk, text, and data cannot be used.","repview_message":"This customer's services are now switched off and their talk, text, and data cannot be used.","wirelessNumber":"Wireless Number","device":"Device","deviceName":"","backToDevice":"Back to Device Page"},"body":{"title":"Keep in Mind","repview_title":"Keep in mind","message01":"If you find your phone, or get a new device and SIM card, you can simply switch your services on again.","message02":"You are still responsible for monthly fees and any charges incurred before you had your services switched off.","message03":"Your wireless account was not cancelled. Your services are simply switched off so the device cannot be used.","message01_repview":"If customer finds their phone, or gets a new device and SIM card, they can simply switch their services on again.","message02_repview":"Customer is still responsible for monthly fees and charges incurred before they had their services switched off.","message03_repview":"Customer's wireless account was not cancelled. Their services are simply switched off so the device cannot be used."},"faq":{"title":"FAQs","question01":"Will I be able to reactivate my device after it is suspended?","answer01":"Yes. If you find your phone again you can simply switch on your services through MyRogers and resume using the device.","question02":"Will I be able to sign in to my account after suspending my device?","answer02":"Yes, you will be able to sign into MyRogers when your device usage is switched off.","question01_repview":"Can I re-activate my device after it's suspended?","question02_repview":"Will I be able to sign into MyRogers after suspending my device?","learnHow":"Learn how >","learnHowUrl":"/web/support/wireless/lost-stolen/823?setLanguage=en"}}}},"customer":{"credit":{"management":{"service":{"alignmentClass":"","manageAdjustments":"Manage Adjustments","unsatisfactoryCompensationContent1":"When compensating a customer for unsatisfactory service, determine the maximum allowed adjustment. Always attempt to make a <b>Cashless Adjustment Program (CAP)</b> offer first — monetary credits are only to be issued if the customer refuses a CAP offer.","stepOne":"Step 1","stepTwo":"Step 2","determineAmountAllowed":"Determine amount allowed:","maxAllowedPeriod":"Max. allowed (in 6-mo. period)","recentAdjustments":"Recent adjustments","totalAllowed":"Total allowed","makeCAPOffer":"Make a CAP offer:","unsatisfactoryCompensationContent2":"Before offering monetary credit, please review the customer’s account, then view the CAP offers to determine which would be most beneficial to them.","viewCAPOffersInNova":"View CAP offers in Nova","unsatisfactoryCompensationContent3":"If customer refuses CAP offer, make a discretionary adjustment to their account.","customerPhoneNumber":"Customer's phone number","totalAllowed50Percent":"50%","totalAllowed100Percent":"100%","discretionaryCreditAdjustmentsPeriod":"Discretionary Credit Adjustments (previous 6 months)","nonDiscretionaryCreditAdjustmentsPeriod":"Non-Discretionary Credit Adjustments (previous 6 months)","date":"Date","count":"Count","code":"Code","amount":"Amount","description":"Description","discretionaryDescription1GDWL":"Goodwill/Public Relations","discretionaryDescription2GDWL":"Goodwill/Public Relations","noDiscretionaryCreditsFound":"There are no discretionary credits on the account.","noNonDiscretionaryCreditsFound":"There are no non-discretionary credits on the account.","systemUnavailableMessage":"System Unavailable. Sorry we could not retrieve the details for this account. Please try again later.","notAvailable":"N/A"}}}}},"payment":{"method":{"mop_change_from":"Change from:","mop_change_to":"Change to:","change_method_secure_debit":"Secure Debit Payment","change_method_cheque_header":"Enter Account Information","change_method_info_secure_debit":"Your debit information will be kept encrypted and secure.","change_method_info_transit_code":"Transit #","change_method_info_bank_code":"Institution #","change_method_account_number":"Account #","change_method_terms_debit":"Terms & Conditions for Pre-Authorized Debit","change_method_see_tctab":"See T&Cs Debit Tab","change_method_confirm_title":"Confirm Payment Method Update","change_method_confirm_details":"A monthly invoice means one more thing to remember every month. Are you sure you don’t want the convenience of paying your Rogers bill automatically from your Canadian bank account or credit card every month?","change_method_thankyou_title":"Thank you!","change_method_thankyou_details":"Pre-authorized payments for your account are set! Your first payment will take effect on your next invoice. We’ve also sent you a confirmation email.","change_method_error":"Sorry, something went wrong and your changes was not accepted.  Please try again, using a different payment method.","change_method_deb_error":"Sorry, that transit code or bank code isn't valid. Please try again.","change_method_invalid_bank_code":"Sorry, that bank code isn't valid. Please try again.","change_method_invalid_transit_code":"Sorry, that transit code isn't valid. Please try again.","change_method_invalid_account":"Sorry, that bank account number isn’t valid. Please try again.","change_method_invalid_accountType":"Sorry, that account type isn’t valid. Please try again.","change_method_accept":"I accept the terms and conditions","change_method_not_accepted":"Please accept terms and conditions before proceeding.","mop_debit_card_notice":"Keep in mind, it takes up to <strong>2 business days</strong> for the payment method update to take effect.","update_debit_button":"Update bank account","change_method_terms":"PAD terms and conditions\n\nThis agreement authorizes any of the Rogers group of companies ('Rogers') to debit my/our account shown above to pay my/our periodic charges for the provision of Rogers goods and/or services, including all services provided by Rogers Wireless Partnership and all services (including Rogers Internet and Rogers Home Phone services) provided by Rogers Cable Communications Inc.\n\nI/We acknowledge that this authorization is for the use of Rogers and my/our financial institution and is provided in consideration of my/our financial institution agreeing to process debits against my/our account as per the rules of the Canadian Payment Association.\n\nI/We acknowledge that by providing and delivering this authorization to Rogers constitutes delivery by me/us my/our financial institution.\nThe information above will be communicated to Roger's bank(s) in order to implement this authorization.\nAll persons whose signatures are required to sign on the account noted above have agreed to this authorization.\nI/We will promptly notify Rogers in writing if there is any change to my/our account information.\n\nThis authorization agreement may be cancelled at any time provided notice is received by Rogers 30 days before the next scheduled debit.\n\nTo obtain a sample cancellation form, or further information on my/our right to cancel a pre-authorized debit agreement, I/we may contact my/our financial institution or visit www.cdnpay.ca.Cancellation of this agreement applies only to the method of payment and does not otherwise have any bearing on the contract for Rogers goods or services.Rogers may not assign this agreement without providing at least 10 days prior notice to me/us.\n\nI/We understand that:\n\nThe amount of each payment to be debited from my/our account reflecting charges to my/our account from the preceding billing period will appear on the invoice I/we receive from Rogers prior to that debit.I/We agree that Rogers may reduce the standard period of pre-notification for each debit.Debits will occur monthly, unless my/our service agreement states otherwise.\n\nMy/Our financial institution is not required to verify that any debits Rogers withdraws comply with this authorization or any agreement with Rogers.My/Our financial institution can reimburse me/us for any debited amount if:\n\n(i) its withdrawal does not comply with this authorization, or\n(ii) I/we cancel this authorization. To be reimbursed, I/we must complete a declaration form within 90 calendar days of the debit being posted to my/our account; any dispute after that time must be resolved directly with Rogers.\nI/We have certain recourse rights if any debit does not comply with this agreement.\nFor example, I/we have the right to receive reimbursement for any debit that is not authorized or is not consistent with this agreement. To obtain more information on my/our recourse rights, I/we may contact my/our financial institution or visit www.cdnpay.ca.\n\nI/We acknowledge that I/we have read, understood and accepted all of the terms and conditions of this Pre-Authorized Chequing authorization agreement.\n","INVOICE":"Manual","CREDIT":" Automatic payments – Credit card","DEBIT":" Automatic payments – Bank account","self_serve_pay_online":"Online through MyRogers with a credit card<span class='invoice-bold'>*</span>, prepaid credit card, Visa Debit, Debit Mastercard or Interac®  Online.","self_serve_pay_via_app":"Using the <span class='invoice-bold'>MyRogers app</span>, with a credit card<span class='invoice-bold'>*</span>, Visa Debit or Debit Mastercard.","self_serve_pay_in_store":"In select <span class='invoice-bold'>Rogers stores.</span>","self_serve_pay_at_bank":"At most banks.","self_serve_pay_by_phone":"By calling us at 1 877 559-5202.","self_serve_change_method_mail":"By mailing a cheque to Rogers, P.O. Box 9100, Don Mills, ON M3C 3P9.","invoice_cards_accepted":"<span class='invoice-bold'>*</span> We accept Mastercard, Visa and American Express.","invoice_more_info":"For more information on your payment options, please see <a href='https://www.rogers.com/customer/support/article/how-to-make-a-payment'>How to Make a Payment.</a>","update_credit_card":"Update Card","update_bank_account":"Update bank account","bank_account_label":"Bank account number","credit_card_type_number":"Credit Card","expiry_on":"Expiry date","master":"Mastercard","visa":"Visa","amex":"Amex","payment_method":"Payment method:","invoice_label":"Ways to pay your bill :","payment_information":"Payment Information","change_payment_method":"Change payment method","credit_card_expiry_warning":"Your credit card is expiring soon.","credit_card_invalid":"Your card has expired.","debit_invalid":"Sorry, we are having some issues processing the payment. Please update your bank account information.","liveChat":{"cbid":"7561960839830360255","dynamicDivId":"changePaymentMethod-en","chatButtonClass":"chatButtonChangePaymentMethod-en"},"mop_title":"Change Payment Method","ap_change_pm_link":"Change method of payment","mop_summary_explanation_no_balance":"Payments will no longer be withdrawn automatically.","mop_summary_explanation_with_balance":"Payments will no longer be withdrawn automatically. Please make a payment before {{date}} to avoid late charges.","mop_update_payment_method_button":"Update Payment Method","mop_credit_card_notice":"Keep in mind, it takes up to <strong>2 business days</strong> for the payment method update to take effect.","mop_success_title":"Success!","mop_success_message_CREDIT":"Pre-authorized payments for your account are now set. The first payment withdrawal will take effect on your next bill. You’ll receive an email confirmation shortly.","mop_success_message_DEBIT":"Pre-authorized payments for your account are now set. The first payment withdrawal will take effect on your next bill. You’ll receive an email confirmation shortly.","mop_success_message_INVOICE":"Your payment method has been changed to Monthly Invoice. You’ll receive an email confirmation shortly.","mop_close":"Close","mop_failure_title":"Sorry…","mop_failure_message":"We’re not able to update your payment method at the moment. Please contact us and we’ll be happy to help.","mop_success_message_cd":"Please note that it takes 2 business days for the payment method change to be updated.","update_credit_card_header":"Update your credit card","update_credit_card_button":"Update credit card","update_debit_header":"Update pre-authorized debit","update_cc_success_header":"Your credit card information has been updated to:","update_cc_expiry":"Expiry date","update_cc_success_notice":"It takes up to 2 business days for changes to be updated.","close_button":"Close","update_cc_invalid_header":"Sorry, we cannot update your card.","update_cc_invalid_explanation":"We are experiencing some problems processing this update. Please review the card information and try again.","update_cc_invlaid_help":"For help, please contact us using one of the options below.","update_cc_system_header":"We’re experiencing a system issue","update_debit_system_header":"We’re experiencing system issues.","update_debit_success_header":"We have updated your pre-authorized bank payment to:","update_cc_system_explanation":"Sorry we couldn’t update your credit card at this time, but are working hard to fix the problem. For help, please contact us using one of the options below:","update_debit_system_explanation":"Sorry we cannot update your bank account information at the moment, but are working hard to fix the problem. For help, please contact us using one of the options below:","update_debit_success_bank_account":"Bank account number","manual_payment":"Change to Manual Payment","manual_payment_content":"Are you sure you want to turn off automatic monthly payments and change to manual payment?","manual_payment_continue":"Continue","change_to_manual_payment_link":"Change to manual payment","setup_automatic_payment_link":"Setup automatic payments","payment_method_manual_payment":"Manual Payment","payment_method_automatic_monthly_payments":"Automatic Monthly Payments","save_card_details":"Save card details:","update_account":"Update account","ways_to_pay_bill_label":"Other ways to pay your bill:","way_to_pay_online":"Online","way_to_pay_via_app":"MyRogers app","way_to_pay_in_store":"Selected Rogers stores","way_to_pay_at_bank":"Most banks","way_to_pay_by_mail":"Mail a cheque to: ","way_to_pay_by_mail_address":"Rogers PO Box 9100, Don Mills, ON M3C 3P9","way_to_pay_cards_accepted":"<span class='invoice-bold'>* we accept mastercard, visa and American express.</span>","way_to_pay_more_info":"For more information on your payment options, please see <a href='https://www.rogers.com/web/support/billing-payment/payment/99'>how to make a payment.</a>","add_rogers_as_payee":"Add Rogers as a payee for your online banking:","twelve_digit_account":"ROGERS (12 DIGIT ACCOUNT NUMBER)","nine_digit_account":"ROGERS (9 DIGIT ACCOUNT NUMBER)","payee_name":"Rogers Payee Name:","pay_at_bank":"Pay at your bank","mail_cheques":"Mail a cheque to:<br> Rogers, P.O. Box 9100 <br> Don Mills, ON M3C 3P9","call_rogers":"Call <a href='tel:+18775595202'>1-877-559-5202</a>","rogers_app":"Using MyRogers app","pm_disagree_manual_payment":"No, keep automatic payments","pm_processing":"Processing changes","pm_card_deleted":"Card deleted","pm_no_changes_made":"No changes made","account":"Select Payment","review":"Review","review_D":"Terms & Conditions","confirmation":"Confirmation","pm_current_payment_method":"Current payment method:","pm_auto_payment":"Automatic payments - ","pm_what_like_do":"What would you like to do?","pm_change_radio_bank":"Use your bank account for automatic payments","pm_current_radio_bank":"Use a different bank account for automatic payments","pm_current_radio_cc":"Use a different credit card for automatic payments","pm_change_radio_cc":"Use a credit card for automatic payments","pm_manual_to_automatic_bank":"Use a bank account for automatic payments","pm_manual_pay":"Switch to manual payments","pm_cc_header":"Credit card number","pm_expiry":"Expiry date","pm_done":"Done","pm_try_again":"Try again","help_text":"For help, please contact support.","SUCCESS":"Success!","NO_CHANGE_MADE":"No changes made","failure":{"C":{"header":"Sorry, we are having problems setting up your credit card automatic payments."},"D":{"header":"Sorry, we’re having problems setting up your bank automatic payments."},"R":{"header":"Sorry, we’re having system issues and can’t change your payment method at this time. Please try again later or contact us for help."}},"pm_edit":"Edit","pm_make_a_payment_now":"Make a payment now","pm_make_a_payment_balance":"Pay {{amount}} Balance","pm_payment_for_next_billing_month_heading":"Your automatic payment will take effect on your next bill. If you have an outstanding balance, please make a payment to keep your account up to date. Your automatic payment processing date will be shown on your next bill.","pm_payment_for_next_billing_month__desc":"To avoid late payment charges your account balance must be $0 by <strong>{{nextBillingDate}}</strong>.","pm_bank_secure_text":"Your bank account information will be kept encrypted and secure.","pm_success_update_payment_text":"Success! Starting next month your bill payments will be made automatically.","pm_success_change_payment_text":"Success! Your payment method has been changed.","pm_email_confirmation_text":"We'll email you a confirmation shortly.","pm_cc_secure_message":"Your credit card information will be kept encrypted and secure.","pm_invoice_header":"Are you sure you want to cancel your automatic payments?","pm_invoice_subtext":"This means you’ll have to manually pay your bill each cycle.","pm_invoice_yes":"Yes, cancel automatic payments","pm_invoice_no":"No, don’t cancel","pm_submit":"Submit","pm_confirm":"Confirm","pm_radio_cc_subtext":"Visa Debit and Debit Mastercard are accepted","current_payment_method":{"C":{"text":"Credit card"},"D":{"text":"Bank account"},"R":{"text":"Manual payments"}},"merchant":{"header":"Merchant Address Details:","name":"Rogers Communications Canada Inc.","street":"333 Bloor Street East","city":"Toronto, Ontario","postal":"M4W 1G9","country":"Canada"},"pm_sub_label_transit":"(5 digits)","pm_sub_label_institution":"(3 digits)","pm_sub_label_account":"(7-12 digits)","pm_secured":"Secured","pm_error_modal_header":"Unable to process request","pm_error_cc_empty":"Please enter a credit card number.","pm_error_expiry_empty":"Please enter an expiry date.","pm_error_security_empty":"Please enter a security code.","pm_error_cc_invalid":"The card number isn’t valid.","pm_error_expiry_invalid":"The expiry date is in the past.","pm_error_security_invalid":"The security code is invalid.","pm_accept_terms":"Please accept Terms & Conditions to proceed.","pm_setup_automatic_payments":"Set up automatic payments","will_charge":"Will be automatically charged to:","history":"Payment history","account_prefix":"Account","setup_auto_payment":"Set up automatic payments","will_auto_charge":"Will be automatically charged to:","ending_number":"ending","expires_on":"Expires on","expired_on":"Expired on","update":"Update","card_expiring":"Card expiring","will_expire_days":"Your credit card will expire in <span>{{days}} days</span>","card_expired":"Card expired","is_expired_msg":"Your credit card has expired.","alt_amex":"American Express","alt_master":"Mastercard","alt_visa":"Visa","pm_invoice_heading_account_number":"Your Rogers account number:","android_app_link":"Using <a class=\"app-link\" href=\"https://play.google.com/store/apps/details?id=com.fivemobile.myaccount&hl=en\" target=\"_blank\">MyRogers</a> app","ios_app_link":"Using <a class=\"app-link\" href=\"https://itunes.apple.com/ca/app/myrogers/id337618972?mt=8\" target=\"_blank\">MyRogers</a> app","ovo_pw_cc_info":{"cc_link_text":"Update <span class=\"rui-icon-chevron-right link-icon\"></span>","is_expired_msg":"Credit card has expired","will_expire_days":"Credit card will expire in <span>{{days}} days</span>"}},"rep":{"securedform":"Secured form","updatepayment":"Set up automatic payment","question":"How will the customer make their automatic payments each month?","question_update":"What would the customer like to change for their automatic monthly payments?","accepted_variants":"Visa and MasterCard debit are accepted.","bankaccount":"Bank Account","onlyavailable":"(only available on rogers.com)","notify":"Tell the customer that they can sign in to MyRogers and set up their banking details under Profile & Settings. They can also get a PAC form from their local Rogers store, or provide their email address so that we can send the form to them.","processpayment":"Processing changes","automatic":"Automatic payment account updated","switch_credit_card":"Switch Credit Card","changebankaccount":"Change to Bank Account","setup_automatic_payment":"Set up automatic payment","schedule_ptp":"Schedule PTP","will_expire_days":"The credit card will expire in <span>{{days}} days</span>","is_expired_msg":"The credit card has expired.","payment_method_manual":"Manual Payment"},"ui":{"payNow":{"takePaymentHeading":"Take a payment","makeAPayment":"Make a Secure Payment","paymentAmount":"Payment amount:","paymentReferenceId":"Reference #","payment":"Payment","review":"Review","pay_via_bank":"Pay via bank","confirmation":"Confirmation","overThreshhold":"Sorry, the payment amount entered is too high. The maximum payment amount you can make for this transaction is {{threshHoldPaymentAmount | currency:undefined:2}}.","invalidPaymentAmount":"Sorry, that payment amount isn’t valid. Please try again.","paymentMethod":"How would you like to pay?","cardMethod":"<span class=\"cc-head\">Pay with credit card, Visa Debit, or Debit Mastercard</span>","bankMethod":"<span class=\"cc-head\">Pay through your bank</span>","bankMethodMessage":"When paying through your bank, please allow 3–5 business days for processing to avoid late payment charges.","interacMethod":"<span class=\"cc-head\">Pay with Interac Online</span>","payNowWithInterac":"Pay now with Interac Online","goToInteracButton":"Pay with Interac","interacButtonTitle":"Make a payment with Interac","interacFirstPageMessage1":"You can make a payment through the Interac Secure Payments portal in a separate window.","interacFirstPageMessage2":"Note: If your card has both an Interac logo and a Visa Debit or Debit Mastercard logo, use the ","interacCreditOrDebitLink":"credit or debit card payment option.","cardNumber":"Card number","expiryDate":"Expiry date","paymentDate":"Payment date","continueAndReview":"Review and continue","overPaying":"The payment amount is higher than the total balance. <strong> You can still pay this amount</strong>, but we thought we’d let you know.","editPayment":"Edit payment","paymentTypeLabel":"Payment Type","payNowButtonLabel":"Pay now","autoPaymentText":"Use this card for your automatic monthly payments.","secureCCPayment":"Secure payment","secureCCPaymentDesc":"Your credit or debit card information will be kept encrypted and secure.","paymentSuccessHeadline":"Thank you! We received your payment.","paymentMethodUpdated":"We’ve also updated your payment method. This card will be used to pay this account’s future bills automatically.","thankYouMessage":"Thank you! We received your payment of ","confirmationMessage":"A confirmation email will be sent to you shortly.","processingPayment":"Processing payment","processingInteracPayment":"Redirecting to Interaconline.com","paymentReceived":"Payment Received!","paymentError":"Payment error!","serverErrorHeaderCard":"We encountered a payment issue","serverErrorHeaderCardUnableToProcess":"Unable to process payment","serverErrorHeaderInterac":"Having an issue?","serverErrorMessageCard":"We’re sorry, but we couldn’t complete your payment. For help, please contact us.","serverErrorMessageCard_1005972_CCQ2":"Sorry, this credit card information is invalid. Please check your card and try again.","serverErrorMessageCard_1005972_CCQ2_part_one":"Sorry, this credit card information is invalid. Please check your card and ","serverErrorMessageCard_1005972_CCQ2_part_two":"","serverErrorMessageCard_try_again":"try again.","serverErrorMessageCard_10645_CA84":"Sorry, we’re unable to complete this payment as the credit card has expired. Please check the card and try again.","serverErrorMessageCard_10645_CA84_part_one":"Sorry, but this credit card information is invalid. Please check your card and ","serverErrorMessageCard_10645_CA84_part_two":"","serverErrorMessageInterac":"Contact us if you have questions or concerns about your payment. Otherwise, consider trying again.","supportNumber":"1-877-559-5202","backToAccountOverview":"Go back to Account Overview page","preAuthCreditPaymentMethod":"Pre-authorized Credit Card","merchantDetails":"Merchant&nbsp;Address&nbsp;Details:","companyName":"Rogers&nbsp;Communications&nbsp;Canada&nbsp;Inc.","streetAddress":"333&nbsp;Bloor&nbsp;Street&nbsp;East","cityAndProv":"Toronto,&nbsp;Ontario","postalCode":"M4W&nbsp;1G9","country":"Canada","liveChat":{"cbid":"3553827740967389059","dynamicDiv":"Rogers_Care_ConsolidatedBilling_EN","chatButton":"S-Care_MakePayment_2_EN"},"liveChatBank":{"cbid":"8887924595958485800","dynamicDiv":"Rogers_Payment_Method_Care_Wireless_EN","chatButton":"Rogers_Payment_Method_Care_Wireless_EN"},"banks":{"td":"TD Canada Trust","td_link":"https://www.td.com/ca/en/personal-banking/","atb":"ATB Financial","atb_link":"http://www.atb.com/Pages/default.aspx","rbc":"RBC Royal Bank","rbc_link":"http://www.rbcroyalbank.com/personal.html","bmo":"BMO Bank of Montreal","bmo_link":"https://www.bmo.com/main/personal","scotiabank":"Scotiabank","scotiabank_link":"http://www.scotiabank.com/ca/en/0,,2,00.html","cibc":"CIBC","cibc_link":"https://www.cibc.com/en/personal-banking.html","desjardins":"Desjardins","desjardins_link":"https://www.desjardins.com/ca/index.jsp","nationalbank":"National Bank","nationalbank_link":"https://www.nbc.ca/en/personal.html","tangerine":"Tangerine","tangerine_link":"https://www.tangerine.ca/en/index.html"},"null_error":"","bp_account_balance":"Account Balance","bp_payment_amount":"Payment amount:","bank_pay_header":"To make a payment through your bank:","bp_inst_item1":"Sign in to your bank’s website.","bp_inst_item2":"Go to your bank’s bill payment page.","bp_inst_item3":"Add Rogers as a payee and pay your bill.","bp_payee_header":"Rogers Payee Name: ","bp_payee_name":"ROGERS ({{length}} DIGIT ACCOUNT NUMBER)","bp_payee_account_header":"Rogers Account #: ","bp_bank_selection_header":"Select your bank below to be redirected to their website:","bp_pay_via_header":"You have been transferred to your bank’s website.","bp_previous_step":"Back to previous step","bp_pay_complete_info":"Once the bank payment is complete, it will appear on your Rogers account after 4 business days.","need_help":"Need help? ","how_to_pay":"See how to make a payment online","bp_get_billing_support":"Get billing and payment support","contact_us":"Contact us","oneViewTitle":"Accept a payment","ovPaymentAmount":"Payment amount","total":" ({{accountBalance | currency}} total balance)","ovPreAuthCheck":"\tSign up for automatic monthly payments","ovSuccess":"Success! We received the customer's payment.","ovDirections":"They will get a confirmation email shortly.","ovReference":"Reference Number: ","ovPreAuth":"Signed up for pre-authorized payments","ovPreAuthDirections":"Let the customer know that their first automatic payment date will be noted on their next invoice.","ovSecure":"Secure Details","ovPaymentRemaining":"Total remaining","ovPayAgain":"Make another payment","done":"Done","dup_header":"Already made your payment?","dup_info":"It looks like you made a recent payment for this amount using the same payment method.","dup_protection":"For your protection, we cannot process this payment.","dup_contact_us":"Please contact us for additional assistance.","dup_check_payment_contact_us":"Please review your payment history or contact us for additional assistance.","dup_payment_history":"View payment history","sgi_account_disclaimer":"This payment will appear in your payment history in 1 business day.","promoBanner":"Save money on your Rogers bill with a Rogers Mastercard. <a href=\"https://rogersbank.com/en/rogers25?utm_source=Rogers.com&utm_medium=Website&utm_campaign=Make_Payment&utm_content=EN-ApplyNow&campaignsource=RCPAYM\" target=\"_blank\"> Learn more <span class=\"chevron-right\"></span> </a>"}}},"purchaseData":{"back":"Back","continue":"Continue","closeBtn":"Close","purchaseBtn":"Purchase","backBtn":"Cancel","altTextClose":"Close","altTextWarning":"Warning","altTextSelected":"{{dataPlan}} selected","altTextPurchasedPopupList":"Show Top-Up Options","addData":"Add data","addSpeedPass":"Add Speed Pass","selectPlanOption":{"title":"Add data","desc1":"You can choose:","desc2":"A one-time data top-up that can be used until the end of this bill cycle.","or":"OR","desc3":"A monthly data add-on that will be added to your plan every month until you choose to cancel it.","option1":"One-Time Data Top-Up","optionSP":"Speed Pass","option2":"Monthly Data Add-on"},"selectedPlansType":{"monthlyTitle":"Monthly data add-on","oneTimeTitle":"One-time data top-up","oneTimeTitleSP":"Add Speed Pass","descriptionOTT":"Select an amount and use the data until end of day {{endDate}}.","descriptionSP":"Select your Speed Pass and use the max speed data until the end of your current bill cycle on {{endDate}}.","descriptionMDT":"Select an amount and the data will be added to your plan <strong>every month</strong> until you choose to cancel it.","addonDropdownLabel":"Add-on Options","addonDropdownLabel2":"Top-Up Options","addonDropdownLabelSP":"Speed Pass Options","addonDropdownIconAltTextShow":"Show Top-Up Options","addonDropdownIconAltTextHide":"Hide Top-Up Options","addonDropdownIconHoverTextShow":"Show","addonDropdownIconHoverTextHide":"Hide","addonDropdownPlaceholder":"Select amount"},"purchasingPlansConfirmationModal":{"atMaxSpeed":"max speed data","title":"Confirm data purchase","infiniteTitle":"Confirm purchase","ottDesc":"You’re about to purchase a one-time data top-up.","spDesc":"You’re about to purchase a Speed Pass.","mdtDesc":"You’re about to purchase a monthly data add-on. ","desc1":"{{dataPlan}} of data will be added to your plan every month until you choose to cancel it.","desc2":"{{dataPlan}} of data will be added to your plan, which can be used until <strong>end of day {{endDate}}.</strong>","desc2SP":"{{dataPlan}} of max speed data will be added to your plan, which can be used until the end of your current bill cycle on <strong>{{endDate}}</strong>.","desc3":"Note: Any existing data overage charges to your plan will remain.","priceLabelSP":"of max speed data for","priceLabel":"for","priceLabel2":"/mo."},"purchasingPlansSuccess":{"title":"{{dataPlan}} added!","infiniteTitle":"Congrats! {{dataPlan}} at Max speed added","desc1":"Enjoy your data until end of day {{endDate}}.","desc1SP":"Enjoy your max speed data until the end of your current bill cycle on {{endDate}}.","desc2":"Enjoy your added data. It will appear on your bill every month until you choose to cancel it."},"purchasingPlansError":{"generic":{"title":"Sorry!","desc1":"Something went wrong on our end and we weren’t able to add the data. Please try again or check back later."},"speedpass":{"title":"Sorry!","desc1":"Something went wrong on our end and we weren’t able to add the Speed Pass. Please try again or check back later."},"title":"Sorry!","desc1":"Something went wrong on our end and we weren’t able to add the data. Please try again or check back later.","limitExceed":{"title":"Limit reached","titleSP":"Cannot add Speed Pass","moreThanTenDescSP":"Unfortunately, you’re not able to purchase a Speed Pass. Please <a target=\"_blank\" href=\"https://www.rogers.com/consumer/support/contactus\">contact us</a> and we’ll help you with some options.","moreThanThreeDesc":"You cannot purchase more than three of the same monthly data add-ons.","moreThanTenDesc":"You cannot have more than 10 combined monthly data add-ons, top-ups or bonuses. <a target=\"_blank\" href=\"https://www.rogers.com/consumer/support/contactus\">Contact us</a> and we’ll be happy to help."}},"consentError":{"title":"Contact account holder","desc":"Sorry, the account holder has not given you permission to authorize extra charges."},"warning":{"desc":"Please select an amount","descSP":"Please select a Speed Pass to continue","consentTitle":"Attention","consentDesc":"<p>By purchasing this top-up, you’ll have over <strong>$50</strong> in data overage charges for this bill cycle.</p> <p>If you continue using data once this top-up is fully used, you will be charged at your plan’s overage rate.</p> <p>Also, by purchasing this top-up, you agree to continued data access for the remainder of your current bill cycle.</p>  <p class=\"contiunue-purchase\"><strong>Are you sure you’d like to continue purchasing this top-up?</strong></p>"}},"bpoHeroModal":{"heading":{"title":"Take advantage of these special offers just for you!","title2":"Take advantage of this special offer just for you!","planHeader":"Thanks for being a customer! We’ve picked out a few special offers we think you’ll like. ","planHeader2":"Thanks for being a customer! We’ve picked out a special offer we think you’ll like.","planTitle":"Lines on your <strong>shared</strong> plan ","individualTitle":"Your Talk & Text Plan","singleLineSeeOfferAvailable":"See offers available for ","line":"Line","close":"Close","planTitleForCtn":"See offers available for {{onlyctn}}"},"subHead":{"heroOffer":{"offerHeader":"Enjoy these offer from Rogers! Choose as many as you like."},"DeviceOffer":{"title":"Your featured device","title_selected_alt":"You’ve selected this device offer"},"planOffer":{"title":"Your exclusive plan","title_selected_alt":"You’ve selected this plan offer"},"bpoOnlyDeviceOffer":{"title":"Bonus device offer"},"bpoOnlyPlanOffer":{"title":"Bonus plan offer","noTxnDbTitle":"Bonus data offer just for you!","noTxnMsfTitle":"Bonus bill credit just for you!","noTxnLdTitle":"Bonus long distance just for you!"}},"footer":{"getOffersLink":"Get these offers","getOfferLink":"Get this offer","getOfferAltLink":"Continue and add this offer to your plan.","getOffersAltLink":"Continue and add these offers to your plan","seeMorePlans":"See more plan offers","seeMoreDevices":"See more device offers","getNoTxnOfferLink":"Get this offer","getNoTxnOfferAltLink":"Continue and add this offer to your plan."},"offerDetail":{"heroPlanDetail":"<span>{{dataDisplayNameEn}}</span><span style=\"font-size:20px;\">{{dataDisplayUnitEn}}</span>","heroPlanDesc":"when you upgrade to a <span>{{hupOfferCategoryValueEn}}</span> plan on a <span>{{term}}</span>-year term","hupOneTime":"Get <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\"> off</span>","hupOneTimeContent":"Get $<span>{{bpoDiscountValue}}</span> off a new device if you upgrade today on a 2-year term","hupUptoBonusCredit":"Bonus bill credit off your new device","hupUptoContent":"Get a bonus bill credit of up to $<span>{{bpoDiscountValue}}</span> off your new device (not exceeding device price) if you upgrade today on a 2-year term","hupLongMinutes":"<span class=\"tvmBpoName\">+{{bpoBonusMinutes}}</span> Canada-wide minutes","hupLongMinutesContent":"Get <span>{{bpoBonusMinutes}}</span> bonus Canada-wide minutes/month for <span>{{bpoDuration}}</span> months if you upgrade to a new plan today on a 2-year term.","hupBpoMSF":"Save <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\">/month for </span><span>{{bpoDuration}}</span> months","hupBpoMSFTimeContent":"When you get a new device and upgrade your plan today!","hupMSF":"Get <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\">/month off</span>","hupMSFTimeContent":"Save $<span>{{bpoDiscountValue}}</span>/month on your plan for <span>{{bpoDuration}}</span> months if you upgrade your plan today on a 2-year term.","hupDataBonus":"<span class=\"tvmBpoName\">+{{bpoBonusData}} {{bpoBonusDataUnit}}</span><span> data</span>","hupDataBonusConTent":"Get <span>{{bpoBonusData}} {{bpoBonusDataUnit}}</span> of bonus data for <span>{{bpoDuration}}</span> months if you upgrade to this plan online.","mo":"/month","talk":"Talk:","text":"Text:"},"bpoDetail":{"hupOneTime":"<sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\"> off for a limited time</span>","hupOneTimeContent":"Upgrade to ANY new device now and get $<span>{{bpoDiscountValue}}</span> off the device cost!","hupLongMinutes":"<span class=\"tvmBpoName\">+{{bpoBonusMinutes}}</span> Canada-wide minutes","hupLongMinutesContent":"Get <span>{{bpoBonusMinutes}}</span> bonus Canada-wide minutes/month for <span>{{bpoDuration}}</span> months if you upgrade to a new plan today on a 2-year term.","hupBpoMSF":"Save <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\">/month for </span><span>{{bpoDuration}}</span> months","hupBpoMSFTimeContent":"When you get a new device and upgrade your plan today!","hupMSF":"Get <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span><span class=\"heroDiscountOff\">/month off</span>","hupMSFTimeContent":"Save $<span>{{bpoDiscountValue}}</span>/month on your plan for <span>{{bpoDuration}}</span> months if you upgrade your plan today on a 2-year term.","hupDataBonus":"<span class=\"tvmBpoName\">+{{bpoBonusData}} {{bpoBonusDataUnit}}</span>","hupDataBonusConTent":"Upgrade to a new plan and get <span>{{bpoBonusData}} {{bpoBonusDataUnit}}</span> of bonus data for <span>{{bpoDuration}}</span> months.","noTxnDataBonus":"{{bpoBonusData}} {{bpoBonusDataUnit}} For {{bpoDuration}} months","noTxnDataBonusConTent":"Get a free {{bpoBonusData}} {{bpoBonusDataUnit}} data bonus for {{bpoDuration}} months automatically added to your current plan today as our thanks for being a loyal customer!","noTxnMsf":"Save $<span>{{bpoDiscountValue}}</span> on your monthly bill!","noTxnMsfContent":"Get a discount of $<span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> for <span>{{bpoDuration}}</span> months automatically added to your bill today as our thanks for being a loyal customer!","noTxnLd":"Get <span>{{bpoBonusMinutes}}</span> long distance minutes!","noTxnLdContent":"Get <span>{{bpoBonusMinutes}}</span> Canada-wide calling minutes for <span>{{bpoDuration}}</span> months automatically added to your current plan today as our thanks for being a loyal customer!","hupUptoBonusCredit":"Bonus bill credit off your new device","hupUptoContent":"Get a bonus bill credit of up to $<span>{{bpoDiscountValue}}</span> off your new device (not exceeding device price) if you upgrade today on a 2-year term"}},"bpoHeroValidationModal":{"successTitle":"Success!","successPlan":{"offerHeader":"Your bonus offer of {{dataEn}} has been added to your plan."},"errorTitle":"Bonus not applied.","errorPlanHeader":"We could not add this bonus offer to your plan. Please try again. If this problem continues, please call <span style=\"text-decoration: underline; color: #3f6ea2;\">1 888-764-3771.</span>"},"rogers":{"user":{"registration":{"registration":"Registration","email.not.matched":"The email addresses do not match. Please try again.","email.address.not.valid":"Sorry, please enter a valid email address.","email.verification":"Email Verification","require.email":"Please enter an email address.","require.confirm.email":"Please confirm your email address by re-entering it.","account.already.associated":"This account is already associated to a MyRogers profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via &nbsp;","email.already.exists":"This email is being used by another MyRogers account. Please choose a different email. ","system.error.message":"It seems something went wrong on our end. Please contact us on &nbsp;","system.error.message.p2":" to get this sorted out.","email.verification.msg":"<p><strong>We’ve sent you a MyRogers account activation email.</strong></p><br/><p>To complete your registration, check your inbox for that email and open it. Follow the link in that email to create your password.</p><br/>","email.verfication.your.email":"Your email address is","boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"}}},"captureDealerCode":{"enterYourDealerCode":"Enter your dealer code","enterDealerCode":"Enter dealer code","info":"Use the box below to enter your dealer code. Once it is entered, the system will remember it for future use. If you need to make a transaction on behalf of another agent, you will be asked to change your dealer code temporarily. ","onBehalfDealerCodeOne":"Change the dealer code ","onBehalfDealerCodeTwo":"for this session","warningDescription":"If you don't enter a dealer code, you won't be able to perform any transactions.","withOutDealerCode":"Proceed without a dealer code","proceedWithSavedDc":"Proceed with my saved Dealer Code","nowBehalfOfAgent":"You are now acting on behalf of this agent:","messageDoNotDisplayPopUp":"Don't show me this again","useMyCode":"My dealer code","dealerCode":"Dealer Code","noCode":"No code","changeDealerCode":"Change my Dealer Code","generalError":"Sorry, something went wrong. We're working on fixing it as quickly as we can. Please check back in a few minutes.","error":"Invalid dealer code","oops":"Oops!","submit":"Submit","edit":"Edit","toolTip":"If you would like to act on behalf of another agent for this session, enter their dealer code here."},"myrPaymentHelper":{"need_help_with_your_bill":"Need help with your bill","visit_billing_support":"Visit Billing Support","paynow_faq":"Review Payment FAQs","boldChatButtonId":"S_MRog_Payment","boldChatButtonDiv":"payment-en","boldChatButton":"chatButtonPayNowEn","reviewLink":"https://www.rogers.com/web/support/supportbillingpayment?setLanguage=en"},"forgotPassword":{"description":"Enter your email address and we’ll send you a link to reset your password.","check.your.email":"Check your inbox","check.email.message":"We sent an email to {{email}}. This email contains a link to create a new password for your MyRogers account.","heading":"Forgot password","enterEmailAddress":"Enter your email address","liveChat":"Chat with a Live Agent","boldChat":{"cbid":"S_ForgotUNamePass","dynamicDivId":"forgotUserName-En","chatButtonClass":"chatButtonForgotUserNameEn"},"email.not.found":"Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again."},"setPassword":{"register":"Register","page_title":"Please enter a new password","page_description":"Please enter a new password for your MyRogers account.","login_invalid_password":"Please enter a valid password","registration_too_short":"Please enter a valid password","registration_too_long":"Please enter a valid password","registration_number_only":"Please enter a valid password","registration_alphabet_only":"Please enter a valid password","registration_wrong_password":"You can use only numbers and letters in your password, not special characters. Please try again.","password_not_matched":"Your password confirmation entry does not match.","temp_password_guildeline":"Password guidelines","temp_password_list_of_guildeline":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","setAndContinueBtn":"Set and continue","new_password_placeholder":"New Password","confirm_password_placeholder":"Confirm new password"},"myrCreditCard":{"change_method_secure":"Secure payment","change_method_info_secure_credit":"Your credit or debit card information will be kept encrypted and secure.","paynow_cc_placeholder":"Please enter your card number. Do not use spaces.","paynow_cc_placeholder_ov":"Please enter the credit card number. Do not use spaces.","paynow_card_number":"Card number","invalid_card_error":"The card number isn’t valid.","cyberSource_Down_error":"Sorry, something went wrong and your payment was not accepted.Please try again, using a different payment method.","non_numeric_security_code_error":"Please enter a numeric security code.","security_code_error":"Please enter a {{numberOfDigits}}-digit numeric security code.","paynow_code":"Security code:","expiry_date_in_past":"The expiry date is in the past.","paynow_month_required":"Please select a month","paynow_year_required":"Please select a  year","paynow_date_required":"Invalid expiry date","paynow_expiry_date":"Expiry date:","paynow_card_tooltip":"The security code is a 3-digit number found on the back of your Visa or Mastercard, or a 4-digit number on the front of your American Express card.","paynow_continue_review":"Review and continue","paynow_how_do_i_pay":"Can I use my Visa Debit or Debit Mastercard?","month_label":"MM","year_label":"YYYY","security_code_placeholder_3_4":"3 to 4 digits","security_code_placeholder_3":"3 digits","security_code_placeholder_4":"4 digits","security_code_alt_text":"What is a security code?","paynow_cc_info_tooltop":"Yes, you can use Visa Debit or Debit Mastercard. Enter the 16-digit card number, expiration date and security code just like you would with a credit card."},"myrSemafone":{"creditCard_dealer":"Credit Card Number (Encrypted)","creditCard":"Credit%20Card%2FVisa%20Debit%20Number","ok":"Ok","encrypted_credit_card":"Encrypted Credit Card","token_rejected":"Token Rejected","token_accepted":"Token Accepted. Select Expiry Date and Security Code","dealer_note":"Place cursor in field. swipe card. Once data is captured, click <i>Ok</i> and enter <i>Expiry</i> Date and <i>Security Code.</i>","one_view_secure_credit_card_payment":"Secure Credit Card Payment","ovPaymentHeading":"Accept Credit Card Payment","ovInstructions":"Enter the <strong>Call Reference</strong> number into your phone. When <strong>Card Number</strong> field is highlighted and black arrow appears, ask the customer to enter it using their telephone keypad. Once card number is captured and field turns green, click <strong>Tokenize</strong>."},"myrSimCard":{"changeMySim":"Change my SIM card","directions":"Enter your current and new SIM card number below.","howToFindSerial":"<strong>How do I find my phone’s SIM card number?</strong>","serialNumberLocation":"There are two ways to check your SIM card number:","serialNumberLocationLabel":"Back of a SIM card","firstWay":"<strong><u>Through your phone’s settings</u></strong>","ios":{"osName":"<strong>iOS</strong>","firstBullet":"Go to your phone’s <strong>Settings</strong>.","secondBullet":"Tap <strong>General</strong>.","thirdBullet":"Tap <strong>About</strong>.","forthBullet":"View the ICCID (SIM ID)."},"android":{"osName":"<strong>Android</strong>","firstBullet":"Go to your phone’s <strong>Settings</strong>.","secondBullet":"Tap <strong>About Phone</strong>.","thirdBullet":"Tap <strong>Status</strong>.","forthBullet":"View the ICCID (SIM ID). If your SIM card number is not visible, see <strong>View your SIM card</strong> below."},"findSerialParagraph":"<strong>Keep in mind:</strong> Instructions may vary by model. For more details, please refer to your phone’s user guide.","secondWay":"<strong><u>View your SIM card</u></strong>","onSimCard":"Remove your SIM card from your phone. The 20-digit number on the back is the SIM card number.","liveChat":{"cbid":"3579481122182599193","boldChatDiv":"F_CARE_Activating_SIM_Card","chatButton":"F_CARE_Activating_SIM_Card-en"},"simCardChange":{"inputError_not20Digits":"Please make sure to enter a 20-digit number.","inputError_currentSim_notFound":"Current SIM Card field is not entered  Please make sure to enter your current SIM card number into the field below.","inputError_newSim_notFound":"New SIM Card field is not entered  Please make sure to enter your new SIM card number into the field below.","currentSim":"Current SIM card number","currentSimAlt":"Please enter your current SIM card number.","newSim":"New SIM card number","newSimAlt":"Please enter your new SIM card number.","continue":"Continue","cancel":"Cancel"},"simCardConfirmation":{"changeMySim":"Change my SIM card","submit":"Submit","resume":"Resume","update":"Update","cancel":"Cancel","cancel_changes":"Cancel Changes","ok":"OK","sub":"Your SIM card number will be changed to:","messageBox_heading":"IMPORTANT: This change will be effective immediately and is irreversible.","messageBox_body":"Your old SIM card cannot be reactivated or re-used with other phone numbers. Please remember to back up any contact info you may have stored on your current SIM card before activating your new SIM card.","popup_heading":"Are you sure you want to cancel your SIM card changes?","sorry":"Sorry!","error_current_sim_invalid":"It seems your current SIM card number is not valid.","error_new_sim_invalid":"It seems the new SIM card number you entered is not valid.","error_new_sim_in_use":"It seems the new SIM card number you entered has already been used.","system_error_message":"It seems something went wrong on our end. Please contact us on &nbsp;","system_error_message_p2":" to get this sorted out.","new.sim.has.been.used.before":"It seems your new SIM card has been used before.","new.sim.has.invalid.sim.prefix":"It seems the new SIM card number you entered is not valid.","new.sim.in.nfdb.message.care":"Please do not proceed with this order. Please do not change or resubmit this order. The order can only be completed when clearance is provided by the Rogers Validation Team.","new.sim.in.nfdb.message.dealer":"Please do not proceed with this order. Please do not change or resubmit this order. The order can only be completed when clearance is provided by the Rogers Validation Team.","new.sim.in.nfdb.message.consumer":"Sorry, we’re not able to proceed with this change. Please call the Rogers Validation Team at 1 800 588-6718 and they can help you out.","please_follow_these_steps":"Please follow these steps:","ask_customer_message":"Ask the customer to contact the Rogers Validation Team at 1 800 588-6718.","tell_the_customer_message":"Tell the customer that they’ll need to provide their Account Number and/or Billing Name and Address for assistance.","error_current_sim_invalid_title":"SIM number(s) not valid","error_current_sim_invalid_body":"Check the SIM card numbers you’ve entered and try again.</br>If you continue to get this message, <a href=\"/consumer/support/contactus\" title=\"Contact us\"><span class=\"lnk-txt\">contact us</span></a>."},"boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"},"simCardSuccess":{"heading":"Success! Your SIM card number has been changed.","emailBody":"A confirmation email has been sent to:","body":"To resume services, please insert your new SIM card into your phone. Then turn your device off and back on to apply the changes.","backToAccount":"Back To My Account"}},"wireless":{"wirelessProductDiscountDetails":{"discounts":"Discounts","description":"Discount Description","socCode":"SOC Code","discountCode":"Discount Code","appliesSocCode":"Applies SOC Code","effectiveDate":"Effective Date ","expirationDate":"Expiration Date ","notApplicable":"N/A","noSocAvailable":"There are no SOCs available on this account."},"overagetext":"Overage fees are","cbid":"S_MRog_Wless_ChngeWlessNum","dynamicDivId":"changeWirelessNumber-En","chatButtonClass":"chatButtonChangeWNumberEn","manage":"Manage","networkAid":"NetworkAid","deviceRepair":"Device Repair","usageDetails":"Usage Details","viewDetails":"View details","unlockMyDevice":"Unlock My Device","extras":"Extras","myExtras":"My Extras","myRogers":"go to MyRogers","telli":"go to Telli","v21":"go to V21","mo":"/mo","otherSupport":"All Wireless Support","planDetails":"Plan Details","contractDetails":"Contract Details:","deviceModalHeading":"Device Details","sim":"SIM:","rogersPlan":"Your Plan","yourDevice":"My Device","support":"Support","talkTextLink":"Talk/Text Usage","talkTextModalHeading":"Talk and Text Usage","on":"ON","off":"OFF","data":"data:","alerts":"alerts:","video":"VIDEO:","videoSD":"SD","videoHD":"HD","soc":"SOC Code","effectiveDate":"Effective Date","expirationDate":"Expiration Date","appliesSoc":"Applies SOC Code","discounts":"Discounts","addons":"ADDITIONS & SOC CODES","addonsAdded":"Additions & SOC Codes","amount":"Amount","balance":"Device Balance","balanceToday":"(as of today):","exUpfrontAmount":"(Excluding <strong style=\"font-weight: 600\">Upfront Edge</strong><sub><small class='black'>TM</small></sub> amount)","toChangePlan":"To change plan","toManageAddons":"To manage add-ons","toChangePhoneNumber":"To change phone number","toChangeCallerID":"To change caller ID","toUpgradeDevice":"To upgrade device","toManageMY5M10":"To manage MY5/MY10","youGet":"You also get:","geotxt_access":"Access","geotxt_extras_cta_title":"Access Rogers GeoTxt","geotxt_access_modal_title":"Rogers GeoTxt","geotxt_access_modal_intro":"<b>Rogers GeoTxt <sub>TM</sub></b> is a free service that delivers text messages with offers from some of Canada’s best retailers!","geotxt_access_modal_cta_sigIn":"Sign in","geotxt_access_modal_cta_register":"Register","geotxt_access_modal_cta_learnMore":"Learn more","geotxt_access_modal_learnMore_desc":"What is Rogers GeoTxt?","geotxt_access_modal_learnMore_option1":"Text messages are sent to your device based on its geo-location to ensure we send you an offer when it’s most relevant to you.","geotxt_access_modal_learnMore_option3":"You can personalize your experience by choosing to receive offers from categories that interest you the most.","geotxt_access_modal_learnMore_option2":"You’ll receive up to 5 text messages (SMS) per week.","geotxt_access_modal_learnMore_option4":"Exclusive to Rogers Wireless postpaid customers 18 years of age or over.","monthlyDataAddOnCancelMessage":"To cancel a data add-on, text \"CANCEL\" to 222.","warning_alert_content":"Your plan will expire on ","warning_alert_content_sec":" and the UA device must be returned by ","warning_alert_tooltip":"Your device balance excludes your Upfront Edge amount","warning_rv_amount_content":"You are currently enrolled in Upfront Edge.  Your 2-year term ends ","warning_rv_amount_content_sec":"Soon you’ll need to decide whether to return your phone or keep it and repay your Upfront Edge amount of ","warning_two_rv_amount_content":"Now you’ll need to decide whether to return your phone to a Rogers store or keep it. If you keep it, your Upfront Edge amount of ","warning_two_rv_amount_content_sec":" will be charged on your next bill.","warning_alt_tag":"Plan alert","plan_info":{"sharing":"Sharing data","pooling":"Pooled  Data","voice":"Joined, but not sharing"},"deviceProtection":"Device protection"},"actionsOffers":{"actionsOffersBounds":{"offers":"OFFERS","searchOffers":"Search offers","byStatus":"By status","lineOfBusiness":"Line of Business","reasonDeclined":"Reason Declined:","reasonDeclinedPlaceHolder":"Tell us about why the customer declined (optional)","cancel":"Cancel","decline":"Decline","all":"All","interested":"Interested","available":"Available","accepted":"Accepted","declined":"Declined","expired":"Expired","interestedOn":"Interested on","acceptedOn":"Accepted on","declinedOn":"Declined on","expiresOn":"Expires on","expiredOn":"Expired on","on":"on","sms":"SMS","email":"Email","directmail":"Direct Mail","telemarketing":"Telemarketing","inbound":"Inbound","outbound":"Outbound","searchPlaceholder":"Search for Program Code, SoC or SKU","value":"Value","details":"Details","howTo":"How to","eligibility":"Eligibility","filter_all":" All","actions_and_offers":"ACTIONS &amp; OFFERS"},"actionsOffersPanel":{"actions":"ACTIONS","yes":"Yes","no":"No","genericError":"Oops! We’re currently experiencing a technical issue and working to resolve it as soon as we can. If you provide feedback to us about this error, please quote error code 888.","genericErrorNoCode":"Oops! We’re currently experiencing a technical issue and working to resolve it as soon as we can. If you provide feedback to us about this error, please quote error code ","noActions":"No actions available.","noOffers":"No offers available.","showFullDetails":"Show full details","hideFullDetails":"Hide full details"},"actionsOffersWidget":{"january":"JA","february":"FE","march":"MR","april":"AP","may":"MY","june":"JN","july":"JL","august":"AU","september":"SE","october":"OC","november":"NV","december":"DE","noActionsOffers":"No actions or offers available.","close":"Close","value":"Value","details":"Details","howTo":"How to","eligibility":"Eligibility","viewNova":"View in Nova","termsConditions":"Terms and Conditions"}},"promiseToPay":{"promiseToPay":"Promise to Pay","lastPromiseToPay":"Last Promise To Pay","eligibleForPromiseToPay":"Eligible For Promise To Pay","latePayment":"Late payment charges may apply","serviceRestored":"If the service is suspended, a suspension fee may apply to your next invoice. (Except Quebec billing address and suspensions due to CLA)","collectionActivities":"Please notify the customer that reporting or making a promise to pay for the full past due amount within 11 days will stop further collection activities.","downgradeService":"Any downgraded services will not be restored until the payment is posted to their account.","systemUnavailable":"System Unavailable","sorryMsg":"Sorry we could not complete your request at this time.","tryLater":"Please try again later.","close":"CLOSE","checkEligibility":{"checkEligibility":"Check eligibility","totalAccountBalance":"Total Account Balance:","pastDueBalance":"Past Due Amount:","pendingPromiseToPay":"Pending Promise To Pay:","transferToCredit":"Transfer to Credit Operations if:","transferToCreditOption1":"The customer wants to pay by mailing post-dated cheques.","transferToCreditOption2":"Customer wants to make a promise to pay (PTP) with multiple payments.","transferToCreditOption3":"Customer wants to update an existing PTP.","generic_error_message":"Your information is currently not available. Please try again.","reason":"Reason","pleaseInfo":"Please let the customer know that:"},"messageBanner":{"success":"Eligible For Promise To Pay","PTPINELIGIBLE2":"Account status is cancelled.","PTPINELIGIBLE3":"Account status is suspended.","PTPINELIGIBLE4":"Account has been disconnected.","PTPINELIGIBLE5":"Account has a pending PTP","PTPINELIGIBLE6":"Account status is pending non-pay disconnect.","PTPINELIGIBLE7":"Account risk class and/or payment history.","brokenPTPmessage":"last PTP on file was broken","generic_error_message":"Your information is currently not available. Please try again.","inEligibleForPromiseToPay":"Promise to Pay Ineligible for the following reason(s):","reason":"Reason"},"schedulePTP":{"paymentAmount":"Payment amount","paymentMethod":"Payment method","selectPaymentDate":"Select payment date","postingDate":"Estimated posting date: ","cancel":"Cancel","schedulePTPBtn":"Schedule PTP","paymentAmountError":"Sorry, that payment amount isn’t valid. Please try again.","paymentMethods":{"0":"Internet/Phone Banking","1":"Rogers Store","2":"NRPC","3":"CC/Interac Debit","4":"Bank","5":"Bank Machine","6":"Bank Line","7":"Bank Branch","8":"Video/Retail","9":"Mail","10":"Credit Card / Interac Debit","11":"Western Union/ Certified Cheque","12":"Cash","13":"Fido Store","14":"Input Payments","15":""},"pendingPTPmessage1":"<b>A PTP is now pending.</b> An interaction with PTP details has been created for this client.","pauseCollection":"A PTP with an estimated posting date 11 days from today may not hold collection activity.","placeHolderValue":"0.00"},"tabs":{"takePayment":"Take a payment","promiseToPay":"Promise to pay"}},"account":{"balance":{"delinquent":"Delinquent","current.account.balance":"Current Account Balance","view.call":"View Call/Transaction History","suspended":"Suspended","suspended_msg":"One or more of your services are suspended. <br/> <span class=\"red-text\">Make a payment below</span> or set up a payment plan with a Live Agent.","total_balance":"Total balance","required_payment_date":"Required Payment Date: ","view_your_bill":"View your bill","view_current_bill":"View current bill","welcome_back":"Welcome back","welcome":"Welcome","make_a_payment":"Make a payment","boldchat_cbid":"8417649730159852351","nearing_credit_limit_title":"Nearing credit limit","almost_credit_limit_title":"Almost at credit limit","credit_limit_exceeded_title":"Credit limit exceeded","over_credit_limit":"over credit limit","credit_limit":"credit limit","used_credit":"used","remaining_credit":"remaining","recommended_pay":"We recommend you pay","reached_over_60_percent_desc":"You’ve reached <strong>over 60%</strong> of your credit limit. To stay well below your limit, <strong>please make a payment.</strong>","reached_over_75_percent_desc":"You’ve reached <strong>over 75%</strong> of your credit limit. <strong>Please make a payment</strong> now.","credit_limit_exceeded_desc":"You’ve exceeded your credit limit and your services are now suspended. To reactivate, <strong>please make a payment.</strong>","add_to_calendar":{"button_label":"Add to Calendar","dropdown_title":"Choose your calendar:","event_title":"Rogers bill payment reminder","location":"Your MyRogers account","description":"Remember to send a payment for your Rogers bill today. Go to MyRogers to make your payment now."},"oneView":{"accountBalance":"Today’s account balance","suspendedMsg":"One or more of these services is suspended.","reached_over_60_percent_desc":"The customer has reached <strong>over 60%</strong> of their credit limit. To stay well below the limit, ask if they’d like to make a payment.","reached_over_75_percent_desc":"The customer has reached <strong>over 75%</strong> of their credit limit. They should make a payment now.","credit_limit_exceeded_desc":"The customer has exceeded their credit limit and services are now suspended. To reactivate, advise them to make a payment."},"ovo_credit_limit_text":"{{amount}} Credit limit remaining","ovo_credit_limit_exceeded_text":"Credit limit exceeded","ovo_credit_limit_link_text":"Details","ovo_credit_limit_total_credit_text":"Total credit","ovo_credit_limit_credit_used_text":"Credit used","ovo_due_text":"Required payment date","ovo_ptp_text":"PTP","ovo_take_payment":"Take a payment","ovo_make_adjustment":"Credit management","ovo_total_balance":"Total balance"}},"internetDashboard":{"goToSGI":"go to SGI","toChangePackage":"To change package","toChangeModem":"To change modem","selfServeOnly":"Self-Serve only"},"paymentTopBar":{"consumer":{"method_cc":"Automatic payments – Credit card","method_debit":"Automatic payments – Bank account","method_manual":"Manual"}},"myrViewBill":{"onlineBillFAQ":"Online Billing FAQs","yourBill":"Your bill","selectBill":"Select bill","billing_video_modal_link_text":"Get to know your online bill. Watch this video!","billing_video_modal_header":"Get to know your online bill","billing_video_modal_how_to_header":"Your online bill is now easier to understand. This video covers:","billing_video_modal_how_to_item1":"How to find what you’re spending on and saving each month","billing_video_modal_how_to_item2":"Our improved breakdown of your charges and changes","billing_video_modal_how_to_item3":"Usage details","billing_video_modal_how_to_item4":"Where to get answers, tips and support","billing_video_modal_youtube_video":"https://www.youtube.com/embed/SdduKhozahc","billNotificationForOnlineBillWithEmail":"<span>Your {{monthName}} bill will be ready soon.</span> We'll email {{email}} as soon as it's available.","billNotificationForOnlineBillNoEmail":"<span>Your {{monthName}} bill will be ready soon.</span> We'll email you as soon as it's available.","billNotificationForPaperBill":"<span>Your {{monthName}} bill will be ready soon.</span> We'll mail it out to you as soon as it's available."},"rhpDashboard":{"homePhone":"Home Phone","at":"at","myPackage":"My Package","homePhoneFeatures":{"title":"Home Phone Features"},"OnlineManager_RHP":{"tooltip":"<div class=\"font-medium\">What is Online Manager?</div><span>On Online Manager, you can control the following features:</span><ul><li>Block Unwanted Callers</li><li>Speed Call</li><li>Call Forwarding - All/My Friends & Family</li><li>Anonymous Caller Rejection</li><li>Allow Calls From My Friends & Family</li><li>Long Distance Ring Alert</li><li>Friends & Family Unique Ring</li><li>Number of Rings for Voicemail</li><li>Contact List</li><li>Do Not Disturb</li></ul>","alt":"Learn more about Online Manager"},"configureYourFeatures":"Configure your current features ","voiceMailSettings":"Access your voicemail settings","resetVoiceMailPassword":"Reset your voicemail password","contactMangerFeatures":"Contact us to manage features","configureYourFeaturesRep":"Configure current features","voiceMailSettingsRep":"Access voicemail settings","resetVoiceMailPasswordRep":"Reset voicemail password","contactMangerFeaturesRep":"Add or remove features","additionalFeatures":"Additional Features","cancelRHPService":"Cancel Home phone services","resetVoiceMailPasswordText":"Reset your voicemail password","resetVoiceMailPasswordBody":"This will immediately change your password to the last four digits of your home phone number.","resetVoiceMailPasswordButton":"Yes, reset my password","cancel":"Cancel","resetVoiceMailPasswordSuccessHeader":"Success!","resetVoiceMailPasswordSuccessBody":"Your voicemail password has been reset.","home_phone_contact_care_phoneNumber":"1 855 720-9037","manageFeatureHeader":"Want to add or remove a feature?","resetVoiceMailPasswordHeader":"Need a new voicemail password?","managerFeatureBody":"Please contact us and we will help you out.","rhp_error_text":"Sorry, we’re not able to display your info. We’re working to fix the issue.","manageYourHomePhone":"Manage your home phone","manageYourHomePhoneRep":"Manage features","ok":"OK","rhp_live_chat_url":"2703368099468244474","rhp_contact_care_phoneNumber_url":"tel:8557209037","viewHomePhoneFeatures":"View Home Phone features","liveChat":"Live Chat","selfServeOnly":"self serve only","goToSGI":"go to SGI","goToNova":"go to <a class=\"nova-link\" href=\"http://nova.rogers.com/infocenter/index?page=content&id=REF713\"><span>Nova</span><i class=\"rui-icon-share\" style=\"padding-left: 0.5rem\"></i></a>"},"signin":{"intro":"An easy, secure way to manage your services and view your bills online."},"tvDashboard":{"goToSGI":"go to SGI","goToTSP":"go to TSP","toChangePackage":"To change package","toChangePlan":"To change plan","toAddThemePacks":"To add theme packs","toAddChannels":"To add channels","toAddDigitalBox":"To add digital box","toResetDigitalBox":"To reset digital box","toResetDigitalPin":"To reset digital PIN","toAddOutlets":"To add outlets"},"wireless_dashboard":{"wireless_next_bill_days_until":"<span class=\"wireless-next-billing-date\">{{nextbilldaysuntil}} days</span> left until next monthly bill cycle starts","next_billing_months":{"1":"(Jan. {{startDay}})","2":"(Feb. {{startDay}})","3":"(Mar. {{startDay}})","4":"(Apr. {{startDay}})","5":"(May {{startDay}})","6":"(June {{startDay}})","7":"(July {{startDay}})","8":"(Aug. {{startDay}})","9":"(Sept. {{startDay}})","10":"(Oct. {{startDay}})","11":"(Nov. {{startDay}})","12":"(Dec. {{startDay}})"}}},"secondLevelNavigation":{"suspendedStatus":"Suspended","cancelledStatus":"Cancelled"},"rename":{"me":{"please":{"renameMePlease":"rename_me_please"}}},"bfa":{"ppc":{"ppc_something_went_wrong_message_title":"Sorry, Something Went Wrong.","ppc_something_went_wrong_message_text":"We’re working on fixing it as quickly as we can. Your price plan changes have not been saved. <br/> Please check back in a few minutes.","mppc_on_brt_no_permission_text":"To change your plan, please contact us:","errors":{"modal":{"800NumberSuspended":"1 877 559-5202","800Number":"1 855 720-9038","cancel":"Cancel","ok":"OK","confirm":"CONFIRM","continue":"Continue","confirmPlanChange":"CONFIRM PLAN CHANGE","removeAddon":"Remove Add-On","goBack":"GO BACK"}},"addAditionalDataModal":{"mppc_entry_3_title":"Since you’re adding another line to your <strong>Share Everything<sub>TM</sub></strong> plan, you may need to add more data to account for the extra usage. Would you like to add data to your plan?","mppc_entry_3_yes":"Yes","mppc_entry_3_no":"No"},"entry1Modal":{"mppc_entry_1_change_current_plan":"Make changes to your current plan","mppc_entry_3_or":"OR","mppc_entry_1_create_shared_plan":"Create a shared plan with your other lines","mppc_entry_1_cancel":"Cancel"},"entry3Modal":{"mppc_entry_3_change_wireless_plan":"Change your plan","mppc_entry_3_change_current_plan":"Make changes to your existing plan","_continue":"Continue","mppc_entry_3_or":"OR","mppc_entry_3_add_to_share_plan":"Add this line to your <strong>Share Everything<sub>TM</sub></strong> plan","mppc_entry_3_cancel":"Cancel"},"sharedGroupIndividualModal":{"mppc_shared_group_indiv_title":"Add your other lines to your <strong>Share Everything<sub>TM</sub></strong> plan","mppc_shared_group_indiv_benefits":"What are the benefits?","mppc_shared_group_indiv_switch_reason_intro":"All your lines will share the features you enjoy:","mppc_shared_group_indiv_switch_reason_1":"Shared data bucket","mppc_shared_group_indiv_switch_reason_2":"Unlimited talk and messaging according to your plan","mppc_shared_group_indiv_switch_reason_3":"Roam Like Home<sub>TM</sub>","mppc_shared_group_indiv_switch_reason_4":"Rogers NHL GameCentre LIVE<sub>TM</sub>","_cancel":"Cancel","_add":"Add"},"sharedGroupPrimaryModal":{"mppc_shared_group_primary_title":"Select a primary line for your new <strong>Share Everything<sub>TM</sub></strong> plan","_continue":"Continue"}}},"changeCtnCallerId":{"initial":{"heading":"Change My Caller ID","sub_heading":"Your Caller ID is the name that appears on the phone display of the person you are calling and on the usage summary shown for this line on your Rogers bill.","your_number":"Your number:","current_caller_id_name":"Current Caller ID name:","note_text":"<strong>Note:</strong> Changing a Caller ID name will add a new name to this account. Anyone logged into the account will be able to make plan changes and buy or remove optional services like add-ons and travel packs.","labelFirstName":"First Name:","labelLastName":"Last Name:","continueButton":"Continue","cancelButton":"Cancel","update_and_continue":"Update and Continue","processing_button":"Processing...","change_failed":"Not able to update","validationErrors":{"common":{"required":"Please provide a name. Do not leave this blank.","specialCharacters":"Your name should not contain numbers or special characters.","badWords":"This word is not allowed."},"firstName":{"invalid":"Please enter valid First Name","moreThanTwoWords":"You may enter two first names, maximum."},"lastName":{"invalid":"Please enter valid Last Name","moreThanTwoWords":"Please enter valid Last Name"}}},"change":{"sub_heading":"Please review your changes below","sub_heading_rep":"This is the name that appears on the customer’s bill and when they make a phone call.","old_caller_id_name":"Old Caller ID name:","new_caller_id_name":"New Caller ID name:","disclaimer_one":"I acknowledge that I have read, understand and agree to the ","disclaimer_link":"http://www.rogers.com/cms/pdf/en/Rogers-Terms-of-Service-Acceptable-Use-Policy-and-Privacy-Policy-en.pdf","disclaimer_link_text":"Rogers Acceptable Use Policy.","disclaimer_two":"By changing the Caller ID data on my device, I agree to not participate in any fraudulent activities, including impersonating any person or entity or forging anyone else’s digital or manual identity. I understand that if Rogers believes, in its sole discretion, that my account is being used in a way that violates the Rogers Acceptable Use Policy, Rogers may take any responsive action it deems appropriate, including the immediate termination of the services on my account.","instructions_label":"Your Caller ID should not contain","instructions_label_rep":"What the Caller ID should not contain","instructions":{"specialChars":"Special characters ( ! @ # $ % ^ & * )","profanities":"Profanity","prohibited":"Prohibited words like \"Unknown,\" or \"Emergency\""}},"common":{"liveChatButton":"Live Chat","speakToAnAgent":"Speak to an agent online","doneButton":"Done"},"core":{"linkText":"Change My Caller ID","linkTextForRep":"Change Caller ID"},"success":{"heading":"Success! Your Caller ID name has been updated","sub_heading":"Please allow 24 hours for this change to take effect.","cc_success_id_text":"new caller ID name","done_button":"Done"},"failure":{"heading":"We’re sorry. Something went wrong","serverError":"We are unable to update your Caller ID at this time. Please try again later.","is_still_known_text":"still has the following Caller ID:","chatLinkText":"Live Chat","helpNumber":"Call 1-855-381-7834","boldChatButton":{"cbid":"S_MRog_Wless_ChngeWlessNum","boldChatDiv":"CCTNCID-live-chat","chatButton":"CCTNCID-live-chat-en"}},"notEligible":{"heading":"You have exceeded the allowable limit for Caller ID name changes.","original_caller_id_name":"Original Caller ID name:","contact_us":"If you need assistance, contact us via ","phone_no":" or call 1-855-381-7834."}},"commonFilters":{"dataConversion":{"kb":"KB","mb":"MB","gb":"GB","tb":"TB"}},"dataManager":{"title":"Data Manager","infiniteAlert":{"body":"Congratulations, you now have a Rogers Infinite<sub>TM</sub> plan with unlimited data, and no more data overages.<br/><strong>During the current billing cycle, your data usage below may not be accurate. Correct information will be available on your next billing cycle.</strong>","closeLabel":"close label"},"error":{"systemErrorMessage":"Generic system error has occurred.","bucketSizeUnavailableHeader":"","bucketSizeUnavailableBody":"Please note that due to a recent change in your plan, we can only display limited information for the rest of this monthly bill cycle.","prorationErrorHeader":"Partial Usage Information Available","prorationErrorBody":"The usage information you’re looking for may be inaccurate or incomplete right now, but should be adjusted once your next billing cycle starts – if not, please contact us."},"info":{"limitedDataHeader":"We’re not able to display precise data usage","limitedDataBody":"Due to a plan change we’re not able to accurately display your data usage while in overage.","planChangeDataHeader":"You Changed Your Plan","planChangeDataBody":"Good news! If your new plan has more data, enjoy your upgrade.  If not, you keep the larger data amount until the end of this billing cycle."},"historical":{"link":"Past shared data usage"},"months":{"0":"January","1":"February","2":"March","3":"April","4":"May","5":"June","6":"July","7":"August","8":"September","9":"October","10":"November","11":"December"},"accountsSummary":{"used":"Used:","swipeLeftOrRight":"Swipe left or right","toSeeLines":"to see your lines","leftGroupStillSharing":"Left group: still sharing","joinedGroup":"View {{displayCTN}}'s Usage","loader":"Adding data…","reduceVideoQuality":"Manage video streaming quality","help":"Watch up to 3 times more video with your current plan.","learnMore":"Learn more","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later.","dataAccessOff":{"accessOff":"Data Turned Off"},"addedBar":{"dataAdded":"Data <br/> added"},"dataAlertAt":{"alertAt":"Alert at:","saveButton":"Save","errorHeading":"Looks like something went wrong. ","errorSecondary":"We couldn’t turn off that data alert. Please try again later.","errorSecondaryUseAlertsOn":"We couldn’t turn on that data alert. Please try again later. ","errorSecondaryUseAlertsOff":"We couldn’t turn off that data alert. Please try again later. "},"footer":{"dataSummary":"Data Summary","totalPlan":"Total in Plan","totalUsed":"Used","totalAlerts":"Alerts Set"},"header":{"title":"Data Usage & Alerts","addData":"Add Data","upgrade":"Change plan","dataDelayMessage":"Don’t see the data you added?","dataDelayHeader":"Don’t see the data you added?","dataDelayBody":"We added the data to your account. Data changes can take up to 30 minutes to appear.","singleAccountMessage":"Select your number now to start managing your data","multiAccountMessage":"Choose the line you want to manage the data for"},"individualHeader":{"data":"Data<br> Access:"},"noDataAlert":{"noAlerts":"No Alerts Set","turnAlertsOn":"Turn Alerts On","errorHeading":"Looks like something went wrong. ","errorSecondaryUseAlertsOn":"We couldn’t turn on that data alert. Please try again later. "},"noDataPlan":{"noDataPlan":"No Data Plan","addData":"Add Data"},"overageBar":{"overUsage":"Over <br/> usage"},"swipe":{"instructions":"Swipe left or right","instructions2":"to see your lines"},"tabs":{"alerts":"Alerts","videoAndStreaming":"<b>Stream Saver</b><sub>TM</sub>","new":"NEW!"}},"badge":{"list":{"infinitePlan":"Rogers Infinite Plan<sub>TM</sub>","linesInGroup":"{{lines}} wireless line(s) in this plan","headBadgeLabel":"View and manage your wireless service","exclusiveOffer":"EXCLUSIVE OFFER"}},"dashboard":{"heading":"My Share Everything plan"},"dataAccess":{"on":"ON","off":"OFF","blockDataNow":"Turn off data","cancel":"cancel","errorHeading":"Looks like something went wrong.","errorSecondaryDataOn":"We weren’t able to turn data access back on. Please try again later.","errorSecondaryDataOff":"We weren’t able to turn off data access. Please try again later.","modal":{"heading":"Pause data access until the end of the current billing cycle for: ","secondaryCopy":"You can change your mind and resume data access at any time. ","body":"And {{displayCTN}} will receive a message about the change too!","option":"Need more data? Simply add a data top up or change your plan to better suit your needs.","upgrade":"Change plan","increase":"Top up data this month","confirmButton":"Turn off data","cancel":"Cancel"}},"dataAlerts":{"myAlert":"My Data Alerts","myVTAlert":"Data","manage":"Manage","manageVideoStreaming":"<b>Stream Saver</b><sub>TM</sub>","manageAlerts":"Manage My Data","linkTag":"Why set an alert?"},"dataAndVideoThrottleWrapper":{"setVideoQuality":"<b>Stream Saver</b><sub>TM</sub>","manageAlerts":"Manage My Data","new":"NEW!","manageDataAlerts":"Manage Data Alerts","videoAndStreaming":"<b>Stream Saver</b><sub>TM</sub>","openDataAlerts":"Manage My Data","closeDataAlerts":"Close My Data"},"dataControlList":{"sharedLines":"My Shared Lines","myLines":"My Lines","closeDataAlerts":"Close Data Alerts","openDataAlerts":"Manage Data Usage and Alerts","mySharedLines":"My Lines","space":"","dataAlertsByLine":"Data Alerts by line","alertedDataTotal":"Total Alerts set:<br class=\"hidden-sm hidden-lg\">","alertedDataTotalFooter":"Total Alerts set:","addData":"Add Data","addSpeedPass":"Add Speed Pass","dataAccess":"Data Access","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later.","manageDataAlerts":"Alerts","videoAndStreaming":"<b>Stream Saver</b><sub>TM</sub>"},"errorPage":{"heading":"Something went wrong - sorry about that!","suggestion":"Please try again later.","button":"Return to Account Overview","issue":"Unfortunately we're experiencing difficulties loading your plan."},"increasePlan":{"increaseData":"Need more data <br class=\"hidden-xs\"/> this month?","firstBody":"Text <strong>DATA</strong> to <strong>222</strong> to see all available options and prices. You will not be charged for this text message. Fees only apply if you select an option, and you can cancel anytime.","question":"How much more?","f":"for","addData":"Add Data","errorHeading":"Looks like something went wrong.","errorBody":"Your purchase did not go through. Please try again later.","errorBodyTopupOptions":"We can’t display your data top-up options right now. Please try again later."},"wcocConsent":{"heading":"Confirm data top-up","firstBody":"You’re about to add the following data top-up to your account","f":"for","secondBody":"By adding this data top-up, your account will have incurred over <strong>$50</strong> in data overage charges this bill cycle.<br/><br/>If you use up this data top-up and do not add another one, any additional data use will be charged at your plan’s overage rate.<br/><br/>By adding this data top-up, you consent to continued data access for the remainder of the current bill cycle. You will not receive any further data overage notifications and your data access will not be paused.<br/><br/><strong>Are you sure you’d like to add this data top-up to your account?</strong>","continue":"Add data","back":"Cancel"},"individualSummary":{"back":"Back to my Share Everything Plan","title":"My Plan","daysRemaining":"<span class=\"ute-dataManager-headTextSecondary-redCopy\">{{daysRemaining}} days</span> left until next monthly bill cycle starts","manageButton":"Manage my data alerts","months":{"0":"(Jan. {{startDay}})","1":"(Feb. {{startDay}})","2":"(Mar. {{startDay}})","3":"(Apr. {{startDay}})","4":"(May {{startDay}})","5":"(June {{startDay}})","6":"(July {{startDay}})","7":"(Aug. {{startDay}})","8":"(Sept. {{startDay}})","9":"(Oct. {{startDay}})","10":"(Nov. {{startDay}})","11":"(Dec. {{startDay}})"}},"profile":{"alert":{"headline":"Data Alerts","sendTo":"Choose your Data Manager","selectOne":"Please Select","saveButton":"Save","doubleRainbow":"What does this mean?","description":"The Data Manager gets the alerts we send - you can make a switch to any of the Wireless lines in your Share Everything plan.","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later."}},"sharedUsageBar":{"title":"Shared Data Usage","infiniteTitle":"Shared Infinite Data Usage","over":"over","used":"Used"},"tabs":{"primaryLine":"Primary Line","leftGroupStillSharing":"Left group: still sharing","joinedGroupNotSharing":"Joined plan: not yet sharing","cancelled":"Left plan","suspended":"Suspended service"},"upgradePlan":{"modals":{"boldChatButtonId":"S_MRog_Wless_ChngeWlessPln","boldChatButtonDiv":"changePlan-en","boldChatButton":"chatButtonChangePlanEn"}},"usageDial":{"myWirelessUsage":"My Wireless Usage","myPlan":"My Plan: ","daysRemaining":"<span class=\"ute-dataManager-headTextSecondary-redCopy\">{{daysRemaining}} days</span> left until next monthly bill cycle starts","remaining":"<span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span> remaining","used":"<span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span> Used","overPlanLimit":"<span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span>over plan limit","realTime":"(REAL-TIME)","oneHourDelay":"(delayed up to 1 hour)","dataDelayMessage":"Seeing something different?","dataDelayHeader":"Seeing something different?","dataDelayBody":"The usage information you’re looking for may be inaccurate or incomplete right now, but should be adjusted once your next billing cycle starts – if not, please contact us.","dataDelayAltText":"Tap for more information","sharedData":"Shared Data","infiniteData":"Infinite Data","unlimitedData":"Unlimited Data","usageReduced":"Using data at reduced speed","sharedTalk":"Talk","sharedText":"Shared Text","unlimited":"Unlimited","viewUsage":"View usage","loader":"Adding data…","upgradePlan":"Change plan","override":"Avoid this month’s<br>data overage charge.","increaseData":"Add data","addSpeedPass":"Add Speed Pass","cannotAddMoreData":"Unavailable when over limit","includes":"Includes:","addedData":"ADDED DATA","bonusData":"BONUS DATA","at":"@","addedFor":"Added for ","each":"each","bonus":"bonus for","dataOverage":"Data Overage","view":"View","close":"Close","cancelAddon":"To cancel a data add-on, text “CANCEL” to 222.","months":{"0":"(Jan. {{startDay}})","1":"(Feb. {{startDay}})","2":"(Mar. {{startDay}})","3":"(Apr. {{startDay}})","4":"(May {{startDay}})","5":"(June {{startDay}})","6":"(July {{startDay}})","7":"(Aug. {{startDay}})","8":"(Sept. {{startDay}})","9":"(Oct. {{startDay}})","10":"(Nov. {{startDay}})","11":"(Dec. {{startDay}})"}},"videoThrottleControlList":{"sharedLines":"My Shared Lines","closeDataAlerts":"Close Data Alerts","openDataAlerts":"Manage Data Usage & Alerts","reduceVideoQuality":"Manage Video Streaming Quality","whyDoThis":"Learn more","saveData":"Do more with your data – watch up to 3 times more video with your current plan","benefitOne":"We’ll send a text message to the selected line making them aware of this change. You can also change video streaming quality at any time.","benefitTwo":"Turning on <b>Stream Saver</b><sub>TM</sub> will adjust video streaming quality from high to standard definition (where available), by line to help you get more out of your data.","learnMore":"Learn about more ways to save data"},"videoThrottleControlTagList":{"reduceVideoQuality":"Manage video streaming quality"},"videoThrottle":{"errorSetThrottle":"We were unable to change your video settings due to a system error.<br><br>Please try again or come back later","errorHeading":"Something went wrong","modal":{"heading":"You are managing video streaming quality for:","secondaryCopy":"Turning on <b>Stream Saver</b><sub>TM</sub> will adjust video streaming quality from high to standard definition (where available), by line to help you get more out of your data.","body":"We’ll send a text message to the selected line making them aware of this change. You can also change video streaming quality at any time.","note":"NOTE: This will only affect video streaming where possible. Web browsing, video downloading or video-conferencing will not be affected by this change.","link":"Learn about more ways to save data","confirmationLabel":"Don’t show me this again.","confirmButton":"Adjust Video Streaming","cancel":"CANCEL"}},"dataControl":{"alertsRecipientChange":"Data Manager","alertsRecipientButton":"(change)","alertMeWhen":"Alert me when this number reaches:","alertsOff":"Turn on alerts for this number","noData":"No Data","addData":"Add data","dataDisabled":"Data is turned off on this device. To turn back on, switch data access to <strong>On</strong>.","toLine":"to line","space":"","saveButton":"Save","leftGroupStillSharing":"Left group: still sharing","joinedGroup":"Joined plan: not yet sharing","viewUsage":"View {{displayCTN}}'s Usage","leftGroup":"Manage {{displayCTN}}'s plan","suspendedService":"Suspended service","cancelledService":"Left plan","cannotSetForCancelled":"You cannot set an alert for a cancelled number","cannotSetForSuspended":"You cannot set an alert for a suspended number","notSharing":"EN: NOT SHARING DATA","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later.","errorSecondaryThreshold":"We couldn’t turn off that data alert. Please try again later.","errorSecondaryUseAlertsOn":"We couldn’t turn on that data alert. Please try again later. ","errorSecondaryUseAlertsOff":"We couldn’t turn off that data alert. Please try again later. ","gb":"GB"},"dataControlTag":{"alertsRecipientChange":"Data Manager","alertsRecipientButton":"(change)","dataUsed":"used","alertAt":"Alert at","leftGroupStillSharing":"Left group – still sharing","joinedGroupNotSharing":"Joined plan: not yet sharing","suspendedService":"Suspended service","cancelledService":"Left plan","joinedGroup":"View {{displayCTN}}'s Usage","leftGroup":"Manage {{displayCTN}}'s plan","dataAccessOff":"Data Turned OFF","manageWirelessPlan":"Manage wireless plan","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later.","newLine":"New line","data":"DATA:","alerts":"ALERTS:","on":"ON","off":"OFF","rogersPlan":"Your Plan","yourDevice":"My Device","support":"Support","video":"VIDEO:","videoSD":"SD","videoHD":"HD","alertsRecipient":"(Data Manager)"},"increasePlanModal":{"increaseData":"Need more data this month?","firstBody":"Text <strong>DATA</strong> to <strong>222</strong> to see all available options and prices. You will not be charged for this text message. Fees only apply if you select an option, and you can cancel anytime.","question":"How much more?","f":"for","addData":"Add Data","errorHeading":"Looks like something went wrong.","errorBody":"Your purchase did not go through. Please try again later."},"wcocConsentModal":{"heading":"Confirm data top-up","firstBody":"You’re about to add the following data top-up to your account","f":"for","secondBody":"By adding this data top-up, your account will have incurred over <strong>$50</strong> in data overage charges this bill cycle.<br/><br/>If you use up this data top-up and do not add another one, any additional data use will be charged at your plan’s overage rate.<br/><br/>By adding this data top-up, you consent to continued data access for the remainder of the current bill cycle. You will not receive any further data overage notifications and your data access will not be paused.<br/><br/><strong>Are you sure you’d like to add this data top-up to your account?</strong>","continue":"Add data","back":"Cancel"},"alertRecipientModal":{"setData":"Assigning a Data Manager:","description":"Choose a Data Manager to manage your alerts.  If you select a data-only line (e.g., tablet) as your Data Manager, they will not receive SMS notifications.","selectOne":"Select a Data Manager","continueButton":"Assign Data Manager","cancel":"Cancel","colon":":","errorHeading":"Looks like something went wrong.","errorSecondary":"We couldn’t assign a Data Manager. Please try again later."},"genericModal":{"button":"OK","button2":"Okay"},"modals":{"alertsOverDataLimit":{"heading":"Your data alerts are set higher than the total data available in your plan","firstBody":"We recommend setting total alerts at around 80% of your available data.","secondBody":"For example, if you have 10GB of data, it’s a good idea to set your combined alerts to around 8GB.","thirdBody":"And we’ll still send you automatic data usage alerts at 90% and 100% of your limit.","button":"OK"}}},"janrain":{"verification":{"modalPopup":{"expired":{"title":"Looks like your link has expired.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"invalid":{"title":"Looks like there’s an issue with this link.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"middleware.failure":{"title":"Looks like there’s an issue with this link.","subTitle":"Please provide the email address you registered with and we'll send you a new link."},"email.address":"Email Address","cancel":"CANCEL","submit":"RESEND CODE","validatingCode":"Validating Link","codeValid":"Valid Link"},"email.not.found.error.EMAIL_NOT_FOUND":"Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again.","email.not.found.error.CODE_NOT_VALID":"We sent an email to {{email}}. This email contains a link to create a new password for your MyRogers account.","email.already.verified.error.message":"We've got your email already. Go ahead and sign in."}},"nova":{"content":{"tor":{"0":{"linkText":"Transfer of Responsibility (TOR) / Change Ownership (CHOWN) Policy","link":"http://www.rogers.com"},"1":{"linkText":"Authorizing Transfer of Responsibility","link":"http://www.rogers.com"},"2":{"linkText":"Performing Transfer of Responsibility","link":"http://www.rogers.com"},"title":"NOVA – Additional Resources"},"ptp":{"0":{"linkText":"Transfer of Responsibility (TOR) / Change Ownership (CHOWN) Policy","link":"http://www.rogers.com"},"1":{"linkText":"Authorizing Transfer of Responsibility","link":"http://www.rogers.com"},"2":{"linkText":"Performing Transfer of Responsibility","link":"http://www.rogers.com"},"title":"NOVA – Additional Resources"}}},"oneview":{"footer":{"directive":{"goToSsp":"Go to SSP","goToNova":"Go to NOVA","quickLinks":"My quick links","moveLinkMessage":"To move a link, click and drag it sideways or into/out of the five areas below.","edit":"Edit","save":"Save","returnToSsp":"Return to SSP","sspModalMessage":"Warning! If you return to SSP, all product and service selections will be lost. Please complete this transaction to proceed with the NAC","continue":"Continue","feedBack":"Feedback","timeRemaining":"Time remaining in this session: ","willSignOut":"You will be signed out in: ","wantToStaySignin":"Do you want to stay signed in?","staySignedIn":"YES","signOut":"NO"}},"interactionNotes":{"directive":{"notepad":{"interactionNote":"Interaction Note","spokeWith":"Spoke With","reasonForCall":"Reason For Call","accountActivitiesPerformed":"Account Activities Performed","followUpNeeded":"Follow Up Needed","saveNote":"Save Note","editNote":"Edit Note","getNoteErrorMessage":"Unable to retrieve latest note.","saveNoteErrorMessage":"Unable to save this note at this time."}}}},"pending":{"order":{"retail":{"label":{"iptv":{"provide":{"tc":"Technician Visit (Charge)","tn":"Technician (no charge)","re":"Return to store","tp":"Technician Visit (Charge)"}},"iptv-stb":{"provide":{"tc":"Technician Visit (Charge)","re":"Return to store","tn":"Technician","tp":"Technician Visit (Charge)"}},"hsi":{"cease":{"co":"Awaiting Modem","re":"Not Applicable","tn":"Awaiting Modem"},"equipment_pickup_and_return":{"co":"Not Applicable","im":"Not Applicable","re":"Not Applicable","tn":"Not Applicable"},"provide":{"co":"Awaiting Modem","nn":"No Install","re":"Awaiting Modem","tp":"Technician Visit (Charge)","tc":"Technician Installation"},"provide-in-replace-offer":{"co":"Awaiting Modem","nn":"No Install","re":"Awaiting Modem","tp":"Technician Visit (Charge)"},"replace_offer":{"nn":"Not Applicable"}},"modem":{"actionType":{"cease":"Cancel","change":"Change","equipment_pickup_and_return":"Return Modem","provide":"Activate","provide-in-replace-offer":"Move","replace_offer":"Change Package","swap":"Exchange Modem"},"cease":{"co":"Ship to Rogers","re":"Return to Store","tn":"Technician Visit"},"equipment_pickup_and_return":{"co":"Ship to Rogers","im":"None","re":"Return at Store","tn":"Technician Visit"},"provide":{"co":"Ship to Address","nn":"None","re":"Pick Up at Store","tp":"Technician install","tc":"Technician Visit (Charge)"},"provide-in-replace-offer":{"co":"Ship to Address","nn":"Take with You","re":"Pick Up at Store","tp":"Technician Visit"},"replace_offer":{"nn":"None"},"swap":{"co":"Ship to Rogers","im":"Exchange at Store","re":"Exchange at Store"}}}},"cta":{"close":"Close","cancel":"Cancel","reScheduleAppointment":"Reschedule","reschedule":"Reschedule","update":"Update","success":"Success!","hyphen":" - ","oops":"Oops","oopsWithSubheading":"<h4>Sorry, something went wrong.</h4> Looks like there was a problem. Please try again later.","cxOopsWithSubheading":"<h4>Sorry, something went wrong.</h4> Looks like there was a problem. Please try again later.","cfaOopsWithSubheading":"<h4>Sorry, something went wrong.</h4>Looks like there was a problem. Please call store support.","technicalError":"Technical Error","cannotViewChange":"Sorry, we are unable to display your appointment. Please try again later.","loading":"Loading...","orderDetails":"Order Details","cxCantReschedule":"<h4>Sorry, something went wrong.</h4>We are unable to reschedule your appointment. Please contact us and we’ll help you out.","cfaCantReschedule":"<h4>Sorry, something went wrong.</h4>We are unable to reschedule your appointment. Please contact store support."},"label":{"viewAndChangeAppointment":"View &amp; Change Appointment","pending":"You've got a pending request...","servicesOrdered":"Service Ordered","actionType":"Request","dueDate":"Activation Date","fulfillmentOption":"Fulfillment Type","internet":"Internet","orderNumber":"Order #:","termsConditions":"Terms and Conditions","orderDetails":"Your Order Details","orderDate":"Order Date","modemSerialNumber":"Serial Number","currentAppointmentIs":"Your current appointment is:","iptv":{"provide":{"tc":"Technician Installation","re":"Return to store","tn":"Technician","tp":"Technician Installation"}},"iptv-stb":{"provide":{"tc":"Technician Installation","re":"Return to store","tn":"Technician","tp":"Technician Installation"}},"hsi":{"cease":{"co":"Awaiting Modem","re":"Not Applicable","tn":"Awaiting Modem"},"equipment_pickup_and_return":{"co":"Not Applicable","im":"Not Applicable","re":"Not Applicable","tn":"Not Applicable"},"provide":{"co":"Awaiting Modem","nn":"No Install","re":"Awaiting Modem","tp":"Technician Installation","tc":"Technician Installation"},"provide-in-replace-offer":{"co":"Awaiting Modem","nn":"No Install","re":"Awaiting Modem","tp":"Technician Installation"},"replace_offer":{"nn":"Not Applicable"}},"modem":{"actionType":{"cease":"Cancel","change":"Change","equipment_pickup_and_return":"Return Modem","provide":"Activate","provide-in-replace-offer":"Move","replace_offer":"Change Package","swap":"Exchange Modem"},"cease":{"co":"Ship to Rogers","re":"Return to Store","tn":"Technician Installation"},"equipment_pickup_and_return":{"co":"Ship to Rogers","im":"None","re":"Return at Store","tn":"Technician Installation"},"provide":{"co":"Ship to Address","nn":"None","re":"Pick Up at Store","tp":"Technician Installation","tc":"Technician Installation"},"provide-in-replace-offer":{"co":"Ship to Address","nn":"Take with You","re":"Pick Up at Store","tp":"Technician Installation"},"replace_offer":{"nn":"None"},"swap":{"co":"Ship to Rogers","im":"Exchange at Store","re":"Exchange at Store"}}},"message":{"orderDetails":"Here are your current orders.","viewAndChangeAppointment":"Need to change your appointment? You can reschedule right up to the day before your installation.","appointmentStep1":"To change your appointment, pick a new date and time to have your {{serviceName}} service installed. Please remember that someone 18 years or older will have to be present.","appointmentStep2":"Is this the best number to contact you on the day of the appointment? If not, please enter another number.","appointmentStep3":"Please let us know of any other applicable details, such as your buzzer code.","appointmentNote":"<strong>This appointment time will only be confirmed when you submit this request. In cases where the date or time is no longer available, you'll be asked to choose another time.</strong>","appointmentConfirmation":"We have been able to confirm a new time slot for your installation.","newAppointmentIs":"Your new appointment is:"},"dynamic":{"HSI":"Internet","IPTV":"TV","IPTV STB":"4k Wireless PVR","Modem":"Modem","servicesOrdered":{"internetAndTV":"Internet/TV","modemAndWireless4k":"Modem/Ignite TV Box"},"request":{"PROVIDE":"Activate","cancel":"Cancel","exchangeHardware":"Exchange Hardware","move":"Move","changePackage":"Change Package","transferOwnership":"Transfer Ownership","change":"Change","return":"Return"},"cxFulfillment":{"technician":"Technician"},"cfaFulfillment":{"technician":"Technician (No Charge)"}}}},"profile":{"wirelessRecoveryNumber":"Wireless Recovery Number:","edit":{"selfServeDirection":"Self-serve only","directive":{"general.error":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","check.form.errors":"There are errors on this page.  Please review the message(s) above each line.","email.verification.msg":"<p><strong>We’ve sent you an account activation email.</strong></p><br/><p>To complete your registration, check your inbox and then sign in with your username and the temporary password we included in the email.</p><br/>"},"resetPassword":{"modalHeader":"Reset Customer's Password","modalContent":"Click Continue to reset the customer’s password. They will be sent an email with a link prompting them to create a new password.","response":{"sucess":"Success! Notify the customer that a password reset link was sent to","error":"Sorry, but we couldn’t reset the password. If this problem persists, please have the customer get in touch with us using Live Chat."}}},"images":{"errorWarning":"ute-common-assets/assets/error_warning.png"},"error":{"profile_already_exist_middleware_failure":"Unfortunately, {{email}} is already registered to another profile. For further assistance with changing your username, please contact us."},"password":{"guideline":{"list":"<br>Your password should be between 8-20 characters and have at least one number and one letter.<br>The following special characters are allowed: ! @ # $","passwordMustHave":"Your password must have:","passwordAtLeast":"At least one letter and one number","passwordMinimum":"A minimum of 8 characters","passwordCanInclude":"You can include special characters and upper/lower-case letters.<br>Passwords are case-sensitive.","bothPasswordMatch":"Both passwords match","passwordInlineError":"Your password should be between 8-20 characters and have at least one number and one letter.<br>The following special characters are allowed: ! @ # $"}}},"noProfile":{"title":"No MyRogers Profile","repActionMessage":"Create a new MyRogers profile for the customer and send confirmation email.","customerActionMessage":"Please advise the customer to go to MyRogers to create their profile.","link":"Create new profile","createProfileModal":{"modalTitle":"Create new profile","createUsingExistingMail":"Create an account using {{existingMail}}","enterMailIdPlaceholderShort":"Email address","enterMailIdPlaceholder":"Enter new address to create profile","confirmMailIdPlaceholder":"Confirm email address","createButton":"Create","or":"Or","infoMsg":"*Please provide username in valid email format: name@email.com","emailsMismatchMsg":"Emails do not match. Please check emails and try again."},"profileAlreadyExistsModal":{"modalTitle":"Profile already exists","modalMsg":"A profile already exists for this email and has been linked to the account. To reset password, go to Profile and Settings.","doneButton":"Done"},"profileCreatedModal":{"modalTitle":"Profile created","modalMsgPartOne":"The profile","modalMsgPartTwo":" {{enteredMailId}}","modalMsgPartThree":" has been created.","modalMsgPartFour":"The customer will receive a registration email shortly.","doneButton":"Done"},"profileNotCreatedModal":{"modalTitle":"Profile not created","modalMsg":"We were unable to create this MyRogers profile.","tryAgainButton":"Try again"}},"voicemail":{"resetPassword":{"directive":{"updateVoicemailPassword":{"care":"Reset Voicemail Password","consumer":"Update My Voicemail Password","dealer":"Reset Voicemail Password"}},"modalPopup":{"title":"Update Voicemail Password","subTitle":"Please enter your new password.","newPassword":"New password","confirmPassword":"Confirm password","passwordInstruction":"Your password must be 4 or 5 digits long and contain numbers only.","cancel":"CANCEL","submit":"SUBMIT","close":"Close"},"responseMessage":{"successTitle":"Thank you!","successMessage":"Your voicemail password has been reset.","failure":"Sorry! It seems something went wrong on our end.","contactUs01":"Please contact us on","contactUs02":"to get this sorted out","passwordNotMatch":"Oops, your passwords didn’t match. Please try again.","notEnterBothFields":"Please make sure you enter your new password in both fields.","notFourToFiveDigits":"Oops, your new password has to be 4 or 5 digits long and contain numbers only. Please try again."},"boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"resetVoicemailPassword-en","chatButtonClass":"chatButtonResetVoicemailPassword-en"}}},"saveBillBanner":{"printBill":"Print this bill","saveBill":"Save one or more bills : PDF","downloadUsage":"Download usage as: ","downloadUsageMobile":"Download usage as ","excelFile":"Excel file","csvFile":".CSV file","savePrintDownload":"Save, print or download bill","saveOrDownloadBill":"Save or download bill","printPDF":"Print PDF","savePDF":"Save PDF","downloadUsageAsExcelCSV":"Download usage as: Excel<span class=\"divider\">|</span> CSV"},"saveBill":{"noData":"You have no usage for this billing cycle","saveAsPDF":{"download":"Save this bill as","pdf":"PDF"},"saveButton":{"saveCopy":"Save/Print this bill"},"confirmationModal":{"title":"Download one or more bills as a PDF","selectAll":"Download all bills for this calendar year","close":"Close","confirm":"Download bills"},"genericModal":{"button":"ok","phone":"1 877 559-5202","liveChat":"Contact us","boldChat":{"cbid":"863675321667007500","dynamicDiv":"S-Care_View_Bill_Issue","chatButton":"Rogers_Care_ConsolidatedBilling_EN"}}},"saveBillModal":{"title":"Save or print your bill, or download usage information","instructions":"Keeping track of your Rogers bill or billed data and talk usage is easy. Simply save or print your bill as a PDF, or download just your usage details in CSV or Excel formats.","optionTitle1":"Save bill as PDF file","optionSub1":"A convenient format for filing and printing.","optionTitle2":"Print PDF copy of bill","optionSub2":"For those who keep paper records.","optionTitle3":"Download usage as Excel file","optionSub3":"Save usage data for viewing in a Microsoft Excel spreadsheet.","optionTitle4":"Download usage as CSV file","optionSub4":"Save usage data in comma separated value (CSV) format for viewing in multiple programs.","errorHeading":{"savePDF":"System issues accessing pdf version of bill","printBill":"System issues accessing bill and user can’t print bill","downloadExcel":"System issues saving usage excel file","downloadCSV":"System issues saving usage data CSV file"},"errorBody":{"downloadPdf":"Sorry, due to a system issue we can’t access the PDF version of your bill right now. We’re working on it. If you need help right away, please contact us.","savePDF":"Sorry, due to a system issue we can’t access the PDF version of your bill right now. We’re working on it. If you need help right away, please contact us.","printBill":"Sorry, due to a system issue we’re unable to access your bill right now. We’ working on fixing the problem. If you need help right away, please contact us.","downloadExcel":"Sorry, due to a system issue we’re unable to upload your Excel file right now. We’re working on fixing the problem. If you need help right away, please contact us.","downloadCSV":"Sorry, due to a system issue we’re unable to upload your CSV file right now. We’re working on fixing the problem. If you need help right away, please contact us."},"success":{"pdf":"Success! The PDF version of your bill has been downloaded.","excel":"Success! The Excel file of your usage details has been downloaded.","csv":"Success! The .CSV file of your usage details has been downloaded."}},"saveBillPrintModal":{"title":"Print this bill"},"briteBill":{"service":{"bb_error_message":"Sorry, your bill is unavailable at the moment. Please try again later. Thank you.","error_wireless_usage":"We’re sorry, but we’re unable to retrieve your wireless service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","error_brite_bill_get_bill_list":"","acc_balance_view_older_bill":"View Older Bills","errorCode":{"10001":"Not valid form data have been passed","10300":"The account you are registering is a business account.  Please visit our <a href=\"https://www.rogers.com/business/ute/smb/transactions/uteAccountAssociation\">Business Self-Serve log-in page</a> to register your account and access your usage and billing info. Thanks!","10301":"We’re unable to link your account at the moment. Please try again later.","10302":"This account is already associated to a MyRogers profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via","10303":"Sorry, the postal code does not match what we have on record for the account number you have entered.  Please check that your postal code and account number entries are correct.","10304":"Please enter a valid 9 to 12 digit number","10305":"Sorry, the account number entered could not be found. Please check that your entry is correct.","10306":"Sorry, the account number entered could not be found. Please check that your entry is correct.","10311":"Sorry, the phone number entered could not be found. Please check that your entry is correct","10312":"Sorry, the phone number entered is already linked to a MyRogers profile.","10313":"Sorry, the PIN does not match.","10314":"Failed to get subscription info base on Pin and CTN provided","10350":"No email has been found for this account.","10401":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36\" target=\"_blank\">Live Chat</a>.","10402":"The security answer entered does not match our records. Please re-enter your answer.","10403":"get postpaid account details failed","10412":"failed to get prepaid account list due to SOAP Fault","10413":"get prepaid account details: failed to find ctn","10414":"get prepaid account details: failed to find pin","10415":"get prepaid account details: failed to get subscription list","10416":"get prepaid account details: failed to get account details","10501":"This account is already associated to a MyRogers profile. Please log in to that profile to manage the account, or for assistance connect with a Customer Care representative via","10502":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36\" target=\"_blank\">Live Chat</a>.","10503":"Failed to complete forgotUsername operation","10504":"Failed to get security question","10505":"The security answer entered does not match our records.  Please re-enter your answer.","10506":"Please enter your contact email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36\" target=\"_blank\">Live Chat</a>.","10601":"Failed retrieve Usage","10602":"getting roaming usage returns error code","10603":"getting usage returns error code","11401":"unexpected error in TVLandingActor","11402":"cable product details not found","11403":"failed getting cable product details","11404":"cable product package not found","11405":"failed getting cable product package","11406":"failed populating cable info","11411":"error occurred when getting plan deteail from cassandra","11412":"error occurred when getting digital box deteail from cassandra","11413":"error occurred when getting themepack deteail from cassandra","11414":"error occurred when getting channel deteail from cassandra","12000":"Permission Denied","13001":"Failed create secret key","13002":"Encryption Failed","13003":"Decryption Failed","13004":"URLEcode Failed","15040":"Sorry we were unable to find the email address you’ve entered. Please make sure you’ve entered the correct one and try again.","50000":"Unknown Server Error","50001":"Not defined yet Server Error","50002":"Please log off and try to login again with your new username"}}},"smsRecoveryRogers":{"profile":{"usernameAndPassword":"Username and password"},"root":{"loginRecoveryMobileNumber":"Wireless <br> recovery number:","setupNow":"Set up now","none":"none"}},"subscriptionBadge":{"homePhone":"Home Phone","internet":"Internet","tv":"TV","smartStream":"Entertainment","smartHomeMonitoring":"Rogers Smart<br/>Home Monitoring","serviceSuspended":"Service Suspended"},"tor":{"transferOfResponsibility":"Transfer of Responsibility","currentOwner":"Current owner","futureOwner":"Future owner","saveAndProceed":"Save and Proceed","saveAndClose":"Save and Close","cancel":"Cancel transfer of responsibility","close":"CLOSE","systemExceptionMessage":"Sorry we could not complete your request at this time.","systemUnavailable":"System Unavailable","pleaseTryAgainLater":"Please try again later.","selectNumber":"Select the number to transfer","eligibilityResults":{"eligibilityResultsTitle":"Eligibility results","numbers":"Numbers","accountNumbers":"Account numbers","eligibility":"Eligibility","validation":"Validation","currentOwnerPointsTitle":"Points you may want to mention:","currentOwnerPoint1":"Any remaining Easy Pay balance is charged to the existing customer as soon as the TOR is completed. Remaining balances cannot be transferred to the new owner. ","currentOwnerPoint2":"All corporate discounts are removed if a customer is moving from an Individual Liable (IDV) to a non-IDV identity, but applied at the time of TOR if moving from a non-IDV to an IDV.","currentOwnerPoint3":"The authorization to transfer responsibility is valid for 30 days.","currentOwnerPoint4":"A fee for this transaction will be charged to the new customer taking over this number. (Exceptions: Death, Separation, IDV, Error, Mandatory TOR from corporate account to consumer, Multiple transactions. Check Nova if you need more details.)","currentOwnerNote":"An interaction will be created in Integrated Customer Management authorizing the Transfer of Responsibility to the new owner.","futureOwnerAccountNumber":"Future owner's account number","cutureOwnerTelephoneNumber":"Current owner's telephone number ","cutureOwnerAccountNumber":"Current owner's account number ","futureOwnerPoint":"Please do not provide any of the current owner's information to the future owner.","futureOwnerPoint2":"You will be charged a $35 fee for this transaction if applicable.","notEligibleForTOR":"Not eligible for a Transfer of Responsibility","TORCTNINELIGIBLE1":"A Transfer of Responsibility is already in progress for this number.","TORCTNINELIGIBLE2":"The current owner has had a Transfer of Responsibility occur within the past 60 days.","TORCTNINELIGIBLE3":"Their last activation was within the past 60 days.","TORCTNINELIGIBLE4":"This customer has a pending hardware upgrade.","TORCTNINELIGIBLE5":"This customer has a pending price plan change.","TORCTNINELIGIBLE6":"There is no Transfer of Responsibility in progress for this number.","TORCTNINELIGIBLE7":"Their last hardware upgrade was within the past 60 days.","TORBANINELIGIBLE1":"Account status is delinquent.","TORBANINELIGIBLE2":"Account status is suspended.","TORBANINELIGIBLE3":"Account status is cancelled.","TORBANINELIGIBLE4":"Account has no payment history.","validationFailed":"Validation failed","accountStatusDelinquent":"Account status is delinquent.","accountNoPaymentHistory":"Account has no payment history.","validated":"Validated","notValidated":"Not validated","eligible":"Eligible","notEligible":"Not eligible","addAnother":"+ Add another number","notEligibleErrorMessage":"In order to proceed with this Transfer of Responsibility, the failures listed above must be resolved. Please address these issues with the current owner, then run the eligibility check again."},"stepTracker":{"stepLabel1":"Choose a number and run an eligibility check.","stepLabel2":"Obtain the future owner's information.","stepLabel3":"1. Run an eligibility check on the future owner","stepLabel4":"Save the authorization and complete the transfer in Vision21."},"confirmation":{"title":"Authorization Status","secondTitle":"2. Save and complete authorization status","torAuthorizationInProgress":"Transfer of Responsibility (TOR) Authorization is in progress. Current customer authorization will expire in ","askFutureOwnerToContact":"To complete the transfer, please ask the future owner to contact us.","customerTelephoneNo":"Telephone number","futureOwnerName":"Future owner's name","securityWord":"Security word","torAuthorized":"<strong>A Transfer of Responsibility has been authorized:</strong> ","proceedToVision21":"To complete the transfer, proceed to Vision21.","saveAuthorizationCompleteTransfer":"4. Save the authorization and complete the transfer in Vision21.","futureAccountNumber":"Future account number","copyCustomerNumber":"Copy Customer Number","returnLink":"Return","continue":"Continue","confirmSecurityWordMessage":"Confirm security word and run eligibility check on CTN and BAN"},"currentCustomer":{"selectTORSubscriber":"1. Initial Eligibility Check","runEligibilityCheck":"Run eligibility check","firstName":"First name","lastName":"Last name","securityWord":"Security word","currentOwnerNumber":"Current owner's number","obtainFutureOwnerInfo":"2. Obtain future owner's information","formFillingInstruction":"Please ask the current owner to provide a security word, which will be shared with the future owner.","addToEligibilityCheck":"Add to Eligibility Check"},"destinationCustomer":{"instructionMessage":"Enter the customer's telephone number that has been authorized for a Transfer of Responsibility.","currentOwnerNumber":"Current owner's number:","getDetails":"Get details","getDetailsNoCtnFoundMessage":"There is no Transfer of Responsibility in progress for this number.","secondInstructionHeading":"2. Save and complete authorization status"},"selection":{"checkForTransferMessage":"Check if a customer's wireless account is eligible for a number transfer here.","pleaseNote":"Please note:","pleaseNotePoint1":"The current owner must initiate the transfer.","pleaseNotePoint2":"Then the future customer must call in themselves.","pleaseNotePoint3":"Once validated, the transfer must be completed in Vision21.","torQuestion":"Is this the current owner, or the person they wish to transfer ownership to?","currentOwner":"Current Owner","futureOwner":"Future Owner"}},"usageDial":{"myPlan":"My Plan:","daysRemaining":"{{daysRemaining}} days remaining in monthly bill cycle","remaining":"<span class=\"ute-usageDialContent-gbAmount\">{{overage}}</span> REMAINING","overPlanLimit":"<span class=\"ute-usageDialContent-gbAmount\">{{overage}}</span> OVER PLAN LIMIT","realTime":"(real-time)","sharedData":"SHARED DATA","sharedTalk":"SHARED TALK","sharedText":"SHARED TEXT","unlimited":"UNLIMITED","mb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">MB</strong>","gb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">GB</strong>","tb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">TB</strong>"},"appBanner":{"title":"Get the MyRogers App Today","buttonCopy":"View","callToAction":"FREE on Google Play"},"discoveryPage":{"directive":{"whyWouldI":"Why set an alert?","modal":{"heading":"EN: Heading","secondaryCopy":"EN: Secondary copy","body":"EN: Body","cancel":"Cancel","doNotShow":"Don’t show me this again.","confirmButton":"Manage My Data","newIcon":"NEW","leftNav":"Prev.","rightNav":"Next"}}}},"hup_not_eligible_title":"Cannot process device upgrade","invalid_hup_order_error":"We're sorry, but our offers have changed. Your saved order is no longer valid. Please make a new selection to continue.","wireless_popup_title":"Changing Your Wireless Plan?","wireless_popup_title_2":"To modify your plan:","wireless_popup_line1":"Monday to Friday 7 am to midnight EST","wireless_popup_line2":"Weekends 8 am to midnight EST","wireless_popup_phone":"Call <b>1-855-720-9038</b>","wireless_popup_not_sure":"Not sure what plans are available?","wireless_popup_all_plans":"View all plans","internet_usage_close":"Close","ppc_not_eligible_title":"Eligibility Error","ppc_bot_header":"Plan change in progress","case_success":"Success","_live_chat":"Live Chat","800_number":"1 855 720-9038","800_number_hup":"1-855-720-9038","800_number_hup_new":"1-855-720-9038","hup_errorCode_L_contact_number":"1-844-370-1515","800_number_suspended":"1 877 559-5202","_continue":"Continue","_ok":"OK","yes_change_plan":"YES, CHANGE PLAN","proceed_ppc":"Proceed with Plan Change","modified_ppc_wait_complete":"No, wait for request in progress","GO_BACK":"GO BACK","CONFIRM":"CONFIRM","CONFIRM_PLAN_CHANGE":"CONFIRM PLAN CHANGE","CANCEL":"CANCEL","ppc_remove_addon":"Remove Add-On","moving_to_ssp":"Moving to SSP","change_phone_number_desc":"To change phone number we're automatically taking you over to the appropriate screen in SSP.","change_sim_desc":"To change SIM/IMEI we're automatically taking you over to the appropriate screen in SSP.","change_plan_desc":"To change plans we're automatically taking you over to the appropriate screen in SSP.","manage_addon_desc":"To manage add-ons we're automatically taking you over to the appropriate screen in SSP.","toll-free-number":"1-855-720-9038","see_nac_toll-free-number":"1 855-291-9727","mu_chat":"Live Chat","sorry_error":"<b>Sorry!</b>","change_payment_method":"Change Payment Method","hup_processed_error":"Hardware upgrade cannot be processed","success":"Success","hup_make_a_payment":"make a payment ","yes_change_hup":"YES, UPGRADE HARDWARE","proceed_hup":"Proceed with Hardware Upgrade","modified_hup_wait_complete":"No, wait for plan change in progress","upgrade_device_desc":"For device upgrades we're automatically taking you over to the appropriate screen in SSP.","tsp":"TSP","myr":{"pageNotFound":{"404":{"headline":"Page not found.","subhead":"We're sorry, we can't seem to find the page you're looking for.","body":"Select the button below to go back to the previous page.","button":"Go back","buttonBackToSignin":"Go back to Rogers.com"}},"liveChat":{"floatingAccountOverview":{"cbid":"5968190768420187175","boldChatDiv":"F_Care_AccountOverview","chatButton":"F_Care_AccountOverview-en"},"floatingWirelessLanding":{"cbid":"6077760545647659710","boldChatDiv":"F_CARE_Wireless_Landing","chatButton":"F_CARE_Wireless_Landing-en"},"floatingActivatingSimCard":{"cbid":"3579481122182599193","boldChatDiv":"F_CARE_Activating_SIM_Card","chatButton":"F_CARE_Activating_SIM_Card-fr"},"floatingTvDashboard":{"cbid":"6607235179250079537","boldChatDiv":"F_CARE_TV_Dashboard","chatButton":"F_CARE_TV_Dashboard-en"},"floatingInternetDash":{"cbid":"1323799204306619494","boldChatDiv":"F_CARE_Internet_Dash","chatButton":"F_CARE_Internet_Dash-en"},"floatingViewBill":{"cbid":"6926729065686668426","boldChatDiv":"F_Care_ViewBill","chatButton":"F_Care_ViewBill-en"},"viewBillError":{"cbid":"863675321667007500","boldChatDiv":"viewBillIssueHelpButton","chatButton":"Care_View_Bill_Issue-en"}},"modules":{"accountBalance":{"your.account.balance":"Account Balance","view.my.bill":"View bill","make.a.payment":"Make a payment"},"accountPreferences":{"reset.voicelmail.password":"Which wireless number would you like to view today?","reset.voicelmail.error":{"GENERIC_ERROR":{"title":"Update voicemail password","description":"Looks like you haven’t activated your voicemail yet. To start receiving messages, press and hold the [1] key on your phone."},"SUSPENDED_CTN":{"title":"Update voicemail password","description":"Looks like your account might be suspended or cancelled. If you’ve made any recent changes or would like to speak to a representative, please call 1 877 559-5202."}}},"findAccNumberMoal":{"link_account_intro_tile":"Welcome,","link_account_intro_02":"To access your Rogers account(s), you need to link your account number to your MyRogers profile.","link_account_intro_02_cta_link":"Where can I find my account number?","linked_acc_btn_submit":"Link Account","link_account_intro_03":"Once your account is linked, you can access all your Rogers services online and through our app:","linked_account_desc_item_1":"Track your usage","linked_account_desc_item_2":"View your balance & pay your bill ","linked_account_desc_item_3":"Change your plan","linked_account_desc_item_4":"Update your account info","linked_account_quick_links_title":"Quick Links","linked_account_quick_links_1":"<a target=\"_blank\" href=\"https://www.rogers.com/web/link/DeviceReservation?forwardTo=nrsRegisteredCustomer\">Manage your device reservation</a>","linked_account_quick_links_2":"<a target=\"_blank\" href=\"https://nhllive.rogers.com\">Watch Rogers NHL LIVE</a>","linked_account_quick_links_3":"<a target=\"_blank\" href=\"http://www.sportsnet.ca/\">Sign in to Sportsnet</a>","linked_account_quick_links_4":"<a target=\"_blank\" href=\"https://www.texture.ca\">Get the Texture magazine app</a>","find_acc_number_modal_title":"Link Rogers Account","find_acc_number_modal_intro":"You can find your Rogers account number in any of these places:","find_acc_number_modal_option_1":"Monthly paper bill","find_acc_number_modal_option_2":"Monthly email notifying your online bill is ready","find_acc_number_modal_option_3":"Service agreement (if you signed up in-store)","find_acc_number_modal_option_1_intro":"You can find your account number on your monthly paper bill, in the top-left corner of each page","find_acc_number_modal_option_2_intro":"Every month you receive an email letting you know your bill is ready. You can find your account number in the Billing Details section of this email.","find_acc_number_modal_option_3_intro":"You can find your account number on the first page of your service agreement, under the Account Information section"}}},"tel":"TEL","add_a_line_desc":"To add a line we're automatically taking you over to the appropriate screen in SSP","add_a_line_individual":"Add a line - Individual","add_a_line_shared":"Add a line - Shared","wireless_cfa-functionality":"CFA Functionality","wireless_cfa-link_change-plan":"Change Plan","wireless_cfa-link_manage-addons":"Manage Add-ons","wireless_cfa-link_reset-voicemail":"Reset Voicemail","wireless_cfa-link_change-sim-imei":"Change SIM / IMEI","wireless_cfa-link_change-phone-number":"Change Phone Number","get_wireless_desc":"To add wireless service we're automatically taking you over to the appropriate screen in SSP.","message_do_not_display_ssp_popup":"Don't show this message again.","update_voicemail_password_desc":"Are you Sure you want to reset the voicemail password?","ute.blocks":{"language.switcher":{"to":"fr","label":"Français"}},"10300_enterprise":"The account you are trying to register is an enterprise account. Please contact your account consultant directly for assistance.","10300_new_reg":"The account you are registering is a business account.  Please visit our <a href='https://www.rogers.com/business/ute/smb/transactions/uteAccountAssociation'>Business Self-Serve log-in page</a> to register your account and access your usage and billing info. Thanks! ","_MM":"MM","_YY":"YYYY","_a_month":"a month","_add_ons":"Add-Ons","_add_to_cart":"Add To Cart","_month":"month","_address":"Address","_account_number":"Account Number","_list_separator":"──────────","_add":"Add","_answer":"Answer","_attempt":"Attempt","_apply":"Apply","_billing_cycle":"Billing Cycle","_canada":"Canada","_unitedstates":"United States","_cancel":"Cancel","_customer_care":"Customer Care","_check_form_errors":"There are errors on this page.  Please review the message(s) above each line.","_city":"City","_confirm_email":"Confirm Email Address","_confirm_leave":"Confirm Leave Page","_confirm_leave_details":"Are you sure you want to leave this page? Your existing choices will not be saved and you'll have to build your price plan change order again.","_confirm_password":"Confirm Password","_confirm_new_password":"Confirm New Password","_contact_info":"Contact Information","_contact_number_1":"Contact Number 1:","_contact_number_2":"Contact Number 2:","_disclaimer":"","_discount":"Discount","_english":"English","_email_ppc":"Email","_email_label":"Email:","_email":"Email Address","_email_confirm":"Confirm Email","_email_address_not_valid":"Sorry, please enter a valid email address.","_email_address_not_valid_try_again":"Please enter a valid email and try again.","_email_address_not_registered":"E-mail Address is not registered","_email_not_matched":"The email addresses do not match. Please try again.","_email_verification":"Email Verification","_email_verification_msg":"<p><strong>We’ve sent you an account activation email.</strong></p><br/><p>To complete your registration, check your inbox and then sign in with your username and the temporary password we included in the email.</p><br/>","_email_verfication_your_email":"Your email address is","_ends_on":"ends on ","_ext":"Ext:","_editlabel":"Edit","_extension":"Extension","_french":"French","_first_name":"First Name","_forgot":"Forgot your","_hi":"Hi","_hello":"Hello","_includes":"Includes","_internet":"Internet","_internet_page":"Internet Page","_invalid":"invalid","_lang":"Language:","_last_name":"Last Name","_learn_more":"Learn more","_manage":"Manage","_my_rogers":"MyRogers","_my_rogers_nospace":"MyRogers","_my_rogers_nospace_mark":"MyRogers<sub><small><small>TM</small></small></sub>","_my_rogers_nospace_caps":"MyRogers","_my_services":"My Services","_new":"New","_no_data_included":"No data included","_new_monthly_cost":"New Monthly Cost","_next":"Next","_of":"of","_or":"or ","_online":"Online","_online_bill":"Online bill","_other_rogers_services":"Other Rogers Services","_other_services_available":"Other services available","_paper":"Paper","_paper_bill":"Paper bill","_password_txt":"Password","_password":"Password:","_password_not_matched":"Your password confirmation entry does not match.","_password_pattern_error":"Your password must be between 7 and 16 characters. Letters and/or numbers only-no special characters","_password_reminder":"Password & Reminder Question","_phone_number":"Phone Number","_pin":"4-digit PIN","_pin_confirm":"Confirm 4-digit PIN","_plan":"Plan","_plus":"Plus","_postal_code":"Postal Code","_prefer_lang":"Language Preference","_province":"Province","_registration":"Registration","_registration_complete":"Thank you for completing your MyRogers registration!","_registration_complete_community_title":"Join the Rogers Community Forum:","_registration_complete_community_body":"Get great Rogers tips, share ideas, and chat with Rogers employees and other community members in our Comunity Forums!","_registration_complete_community_button":"Join the community","_registration_go_to_account":"Take me to my account","_remember_me":"Remember Me","_make_pre_auth":"Save card for future preauthorized payments","_require_confirm_email":"Please confirm your email address by re-entering it.","_require_email":"Please enter an email address.","_require_password":"Please enter your password.","_require_security_answer":"Please provide an answer to your security question.","_require_security_question":"Please select a security question.","_require_username":"Please enter your username.","_required":"Required","_review_order":"Review Order","_rogers_bank":"Rogers Bank","_states":"States","_save":"SAVE","_security_questions":"Security Questions","_share_everything_plan":"Share Everything Plan","_signin":"Sign in","_submit":"Submit","_update":"Update","_update_2":"Update","_taxes":"Taxes","_tv":"TV","_username":"Username:","_username_no_col":"Username","_username_email":"Username or Email Address","_email_already_linked":"Sorry, this account is linked to another email address. Please contact us through Live Chat for help","_email_already_linked_no_account":"This account is registered to: {{maskedEmail}}. <br/> To set a new password select <a href=\"#\" class=\"forgot-password-interceptor error-bold\">Forgot password.</a>","expires":"Expires","expires_rebate":"Discount expires:","_months":{"0":"January","1":"February","2":"March","3":"April","4":"May","5":"June","6":"July","7":"August","8":"September","9":"October","10":"November","11":"December"},"_monthShort":{"0":"Jan","1":"Feb","2":"Mar","3":"Apr","4":"May","5":"Jun","6":"Jul","7":"Aug","8":"Sep","9":"Oct","10":"Nov","11":"Dec"},"alberta":"Alberta","british_columbia":"British Columbia","manitoba":"Manitoba","new_brunswick":"New Brunswick","newfoundland":"Newfoundland and Labrador","northwest":"Northwest Territories","nova_scotia":"Nova Scotia","nunavut":"Nunavut","ontario":"Ontario","prince_edward_island":"Prince Edward Island","quebec":"Quebec","saskatchewan":"Saskatchewan","yukon":"Yukon","oops":"OOPS","_something_went_wrong":"Something went wrong!","_under_construction":"Under construction","_selected":"Selected","_select":"Select","_recommended":"Recommended","_exclusive":"Exclusive","_suspended_service":"This service is currently suspended.","_have_questions":"Have questions?","_chat_with_us":"Chat with us!","_myAccount_playstore_url":"https://play.google.com/store/apps/details?id=com.fivemobile.myaccount","submenu_acc_overview":"Account Overview","submenu_billing_and_payment":"Billing &amp; Payment","submenu_services":"Services","submenu_profile":"PROFILE & SETTINGS","submenu_link_account":"Link Account","account":"Account","acc_balance":"Account Balance","current_bucket":"Current","acc_balance_not_available":"Not available","acc_balance_pay_now":"Make a payment","acc_balance_Required":"Required payment date","acc_balance_view_bill":"View Bill","acc_balance_view_older_bill":"View Older Bills","acc_overview_oops":"Oops! It seems we can’t update your info. Please check back soon.","acc_overview_account_balance":"Account Balance","acc_overview_account_cancelled_care":"<span class=\"error-type\">ACCOUNT CANCELLED</span>","acc_overview_account_cancelled":"This account has been cancelled.","acc_overview_account_exceeded":"This account has exceeded its credit limit.","acc_overview_account_limited_care":"<span class=\"error-type\">ACCOUNT CANCELLED</span>","acc_overview_account_overdue_care":"<span class=\"error-type\">ACCOUNT SUSPENDED</span><span class=\"error-message-suspended\"> To restore services, <a ng-click=\"ao.payBillSuspended()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\">take a payment</a> for the outstanding balance.</span>","acc_overview_account_suspended_care":"<span class=\"error-type\">ACCOUNT SUSPENDED</span><span class=\"error-message-suspended\"> This account is currently suspended.</span>","acc_overview_account_suspended_2_care":"<span class=\"error-type\">ACCOUNT SUSPENDED</span><span class=\"error-message-suspended\"> This account is currently suspended.</span>","acc_overview_account_limited":"This account has been cancelled, so your access to MyRogers<sub><small><small>TM</small></small></sub> is limited.  You can still:","acc_overview_account_overdue":"<b>This account is currently suspended.</b><br/>If there is an overdue balance, making a payment may instantly restore your full MyRogers<sub><small><small>TM</small></small></sub> account information. Alternatively, you may Live Chat to resolve this issue.","acc_overview_account_suspended":"This account is currently suspended.","acc_overview_account_suspended_2":"This account is currently suspended.","acc_overview_billing_cycle_end":"This month's billing cycle ends in <X>Â days: <MMM DD, YYYY>","acc_overview_credit_limit_status":"Credit Limit Status","acc_overview_daily_maintenance":"Sorry, MyRogers<sub><small><small>TM</small></small></sub> undergoes daily maintenance from 2 am to 5 am. Most features are not available during this time.","acc_overview_due_credit":"Charge to your credit card on or after","acc_overview_due_debit":"Debited from your account on or after","acc_overview_due_invoice":"Required Payment date","acc_overview_expires_on":"Expires on","acc_overview_withdrawal_by":"Charge to your credit card on or after","acc_overview_manage":"Manage","acc_overview_monthly_credit_exceeded":"This account's monthly credit limit has been exceeded. Full service will be restored when its balance is less than its credit limit. - Make a payment","acc_overview_my_account":"My Account","acc_overview_my_account_overview":"Overview","acc_overview_my_acc_overview":"Account Overview","acc_overview_my_acc_overview_product":"Account Overview","acc_overview_my_shop_for_products":"Shop For Products","acc_overview_my_offers":"My Offers","acc_overview_my_services":"My Services","acc_overview_other_services":"Other Services Available","acc_overview_outstanding_balance":"Outstanding Balance","acc_overview_pay_as_you_go":"My Pay As You Go<sup>TM</sup> ","acc_overview_pay_as_you_go_2":"<strong>Service</strong>","acc_overview_pay_as_you_go_cancelled":"Because your  <i>Pay As You Go</i><sup>TM</sup> account is cancelled, your MyRogers<sub><small><small>TM</small></small></sub> access is limited. Services you can access are:<br/><a href='/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta' target='_blank'>- Manage profile</a><br/>- <a href='https://www.rogers.com/web/Rogers.portal?_nfpb=true&_pageLabel=PREPAID_ACTIVATIONS&_nfls=true&cm_sp=wireless-_-pay_as_you_go-_-activate_now_banner' target='_blank'>Activate a new Prepaid account</a>.<br/> After your phone is activated, link your new account to your existing MyRogers<sub><small><small>TM</small></small></sub> profile to take full advantage of all online services.","acc_overview_pay_as_you_go_suspended":"Your <i>Pay As You Go</i><sup>TM</sup> account is currently inactive. To add airtime to your account, please call 1-800-575-9090 to speak with a Customer Care Representative who will be happy to assist you.","acc_overview_pay_by":"Pay By:","acc_overview_pay_now":"Pay Now","acc_overview_platinum_member":"Platinum Member","acc_overview_redeem_points":"Redeem/Earn Points","acc_overview_remaining_credit":"Remaining Credit","acc_overview_silver_member":"Silver Member","acc_overview_salutation":"Thanks for stopping by.<p class='ptm'>If you want to view your usage, billing or account details, you’ve come to the right place.</p><p>Upgrade your smartphone <a href='/web/myrogers/device-upgrade'>here</a>!</p> ","acc_overview_top_up_now":"Top Up Now","acc_overview_total_credit_limit":"Total Credit Limit","acc_overview_view_bill":"View Bill","acc_overview_view_bill_history":"View billing and payment history","acc_overview_manage_profile":"Manage Profile","acc_overview_which_account":"Which account would you like to view today?","acc_overview_no_information":"We’re sorry, we can’t give you the information you requested as it seems you are not currently enrolled in that product.<div class='visit'>If you would like to add products and services, visit our <span class='shop-text'>Shop</span> section </div>","acc_overview_no_product":"You don't seem to have that product","acc_multiCTN_which_wireless_account":"Which wireless number would you like to view today?","acc_selection_suspended":"This account is currently suspended","acc_selection_clm":"<strong>This account's monthly credit limit has been exceeded.</strong><br/>Full service will be restored when its balance is less than its credit limit.","buy":"Buy","bundles":"Bundles","BillingAddressHeading":"Billing","billing_address":"Billing Address:","BillingType":"Billing Type:","billing_us_address_warning":"Need to change to another US Address? Contact Live Chat. Or if you want to change to a Canadian address, click on Edit above.","billing_move_your_services_warning":"<strong>Note:</strong> Only your billing address will be updated. To move your services, please <a href=\"https://www.rogers.com/consumer/support/moving-your-services?setLanguage=en\" class=\"move_your_services-link\" target=\"_blank\">Contact Us</a>.","billing_enhance_message":"We’ve made the bill easier to understand. Check out what’s new and improved!","billing_enhance_message1":"We’ve made the bill easier to understand.","billing_enhance_message2":"Check out what’s new and improved!","billing_enhance_check_it_out_button":"Check it out","billing_enhance_got_it":"Ok, got it","billing_enhance_overlay_heading":"New! Download your usage details","billing_enhance_overlay_text":"Now you can save your talk and data usage details in Microsoft Excel.","billing_enhance_overlay_heading_slide1":"Welcome to your improved Rogers bill","billing_enhance_overlay_text_slide1":"With this new highlights section, you will see where you spent and where you saved in addition to your monthly plan right up front!","billing_enhance_overlay_text_slide2":"Don’t let an unpaid balance catch you by surprise. Now you’ll see right away if you are carrying a balance from your previous bill","billing_enhance_overlay_text_slide3":"No need to search for your details. The new summary page lists all your extra charges, usage and credits for you to review.","billing_enhance_checkout_new":"Check out what’s new","calling_features":"Calling Features","changed_your_plan":"You changed your plan","changes_to_your_plan":"you made changes to your plan on","checkout_review_order":"Review Your Order","checkout_review_order_summary_total":"Order Summary Total","checkout_review_order_billing_address":"Billing Address","checkout_review_order_billing_preferences":"Billing Preferences","checkout_review_order_pay":"Pay:","checkout_review_order_pay_invoice":"On receipt of invoice","checkout_review_order_receive_bill_via":"Receive bill via:","checkout_review_order_send_bill_to":"Send bill to:","checkout_review_order_changes":"Changes","checkout_review_order_proration":"Proration","checkout_review_order_prorated":"Prorated","checkout_review_order_gift_card_or_promo":"Recieved a Gift Card or Promo Code","checkout_review_terms_and_conditions":"Terms & Conditions","checkout_review_checkout":"Checkout","checkout_review_complete_order":"Complete Order","checkout_review_complete_notice":"Keep in mind that confirming this plan change means your current promotions and discounts will no longer be available – but you can start enjoying your new plan right away.","checkout_review_monthly_total":"Monthly Total","checkout_review_on_bill":"On Bill","checkout_review_additional_agreement_details":"Additional Agreement Details","checkout_review_account_maint_agree":"Account Maintenance Agreement","checkout_review_rogers_tos":"Rogers Terms of Service","checkout_acceptable_use_policy":"Acceptable Use Policy","checkout_privacy_policy":"Privacy Policy","checkout_introductory_information":"Introductory Information","checkout_service_term_changes_and_cancellation":"Service Term, Changes and Cancellation","checkout_account_charges_and_billing_information":"Account, Charges and Billing Information","checkout_deposit_and_credit_requirements":"Deposit and Credit Requirements","checkout_your_use_of_the_services":"Your Use of the Services","checkout_equipment":"Equipment","checkout_prepaid_wireless_service":"Prepaid Wireless Service","checkout_your_privacy":"Your Privacy","checkout_warranties_limitation_liability":"Warranties and Limitation of Liability","checkout_general":"General","checkout_review_acceptable_use_policy":"Acceptable Use Policy","checkout_review_privacy_policy":"Privacy Policy","checkout_review_checkbox_copy":"I have read, understood and agree to all of the details in my Agreement, including my service agreement, the Rogers Terms of Service, Acceptable Use Policy and Privacy Policy above.","checkout_confirm_order_order_confirmation":"Order Confirmation","checkout_confirm_order_service_address":"Service Address","checkout_confirm_order_order_summary":"Order Summary","checkout_confirm_order_your_order":"Your Order","checkout_confirm_order_for_your_order":"for your order","checkout_confirm_order_procesing_your_request":"We are processing your request.","checkout_confirm_order_check_your_inbox":"Check your inbox for a special offer on your confirmation email that you will receive shortly.","checkout_confirm_order_continue_shopping":"Continue Shopping","checkout_confirm_order_contact_details":"Contact Details","checkout_confirm_order_qty":"Qty","checkout_confirm_order_monthly_fees":"Monthly fees","checkout_confirm_order_monthly_fees_new_plan":"Monthly fee for new price plan","checkout_confirm_new_monthly_total_fees":"New Total Monthly Fees","checkout_confirm_order_taxes":"GST/HST","checkout_confirm_order_pst_qst":"PST/QST","checkout_confirm_thank_you":"Thank you","checkout_confirm_for_your_order":"for your order","checkout_confirm_congrats":"Congratulations","checkout_confirm_on_your_new_plan":"on your new plan","checkout_confirm_email_confirm":"You will receive an email confirmation shortly.","checkout_confirm_term_service":"Term Service","checkout_confirm_month_month_service":"Month to Month Service","checkout_confirm_partial_prepaid":"Partial charges may appear on your next bill ","checkout_confirm_fine_print":"Unless otherwise stated, all voice minutes, messages and wireless internet details set out above refer to usage on our network (i.e., within Canada on our network and to a Canadian number, as applicable). <div class='mtm'>If you downgrade to a lower tier plan category during your Term, then you may be charged a downgrade fee, calculated using the amounts set out in your service agreement.</div><div class='mtm'>If you have a Term Service, this price plan change transaction will not change your Term start or end date.</div>","ContactInformationHeading":"Contact Information","CredentialsHeading":"Username and Password","dataOverage":"Data Overage","dealer-code_your_enter":"Enter your dealer code","dealer-code_enter":"Enter dealer code","dealer-code_info":"Use the box below to enter your dealer code. Once it is entered, the system will remember it for future use. If you need to make a transaction on behalf of another agent, you will be asked to change your dealer code temporarily.","dealer-code_on_behalf_dealer_code":"If you would like to act on behalf of another agent for this session, enter their dealer code here.","dealer-code_warning_description":"If you don’t enter a dealer code, you won’t be able to perform any transactions.","dealer-code_without_dealer_code":"Proceed without a dealer code","dealer-code_now_behalf_of_agent":"You are now acting on behalf of:","dealer-code_use_my-code":"My dealer code","dealer-code":"Dealer Code","dealer-code_no_code":"No code","dealer-code_dsg_enter_dealer_code":"Enter the dealer code that you will use for this customer","dealer-code_change_dealer_code":"Change my Dealer Code","dealer-code_error":"Invalid dealer code","dealer-code_oops":"Oops!","carousel_modal":{"leftNav":"Prev.","rightNav":"Next","indicatorTitle":"Page {{index}} of {{total}}"},"EOP":{"igniteImageAlt":"Ignite Bundles come with Ignite TV and Ignite Internet","saiImageAlt":"A family enjoys using Ignite Internet at home","/mo":"/mo","/mo*":"/mo*","Unlimited":"Unlimited","DYNATRACE":{"eop":{"CLOSE":"x-close-eop|ignite-offer-alert","LEARNMORE":"Learn more-eop|ignite-offer-alert"},"regular":{"CLOSE":"x-close-ignite migration-alert","LEARNMORE":"Learn more-ignite migration-offer-alert"},"recommended":{"CLOSE":"x- close personalized-recommendation-offer-alert","LEARNMORE":"Learn more- personalized-recommendation-offer-alert"}},"CTAS":{"IGNITE":{"eop":{"LABEL":"Take action","ALT":"Learn more about this offer"},"regular":{"LABEL":"Learn more","ALT":"Learn more about this offer"},"recommended":{"LABEL":"Learn more","ALT":"Learn more about this recommendation"}},"UPGRADE_NOW":{"LABEL":"Upgrade now","ALT":"Select to upgrade"},"TAKE_ACTION":{"LABEL":"Take action","ALT":"Learn more about this offer"},"takeMeThere":{"label":"Yes, view my offer","alt":"Yes, view my offer","smartStreamLabel":"Yes! view my offer","smartStreamAlt":"View your Ignite Internet and Ignite Streaming offer"},"dismiss":{"label":"No, continue to MyRogers","alt":"No, continue to MyRogers","smartStreamAlt":"Reject this offer and continue to MyRogers"},"CLOSE":{"ALT":"Close this window"},"DISMISS_OFFER":{"LABEL":"Don't show me this message again.","ALT":"Stop continuation of this message and close this window"},"COMPARE_PLAN":{"LABEL":"Compare Plans","ALT":"Select to compare offers"},"PROMOTION_OFFER_BADGE":{"LABEL":"You have a special upgrade offer","ALT":"Learn more about your special upgrade offer"},"RECOMMENDED_OFFER_BADGE":{"LABEL":"You have a special recommendation","ALT":"Learn more about your recommendation"}},"NEW_OFFER_NOTIFICATION":{"video":{"playerId":"NC2EcBXc7","accountId":"1275380481001","videoId":"6166428813001","src":"//players.brightcove.net/1275380481001/NC2EcBXc7_default/index.min.js","lang":"en"},"tupelo":{"header":"Your offer: Ignite Internet<sub>TM</sub> with Ignite Streaming<sub>TM</sub>!","body":"Access content from across your favourite streaming services, plus free shows and movies, all in one place! Simplified with voice search.","learnPage":{"label":"Learn More about Ignite Streaming","alt":"Learn More about Ignite Streaming"}},"sai":{"header":"You have a personalized Ignite Internet offer!","body1":"Get fibre-powered <span class=\"font-bold\">Ignite Internet<sub>TM</sub></span> for wall-to-wall WiFi, plus monitor, manage and help protect your home network from anywhere using <span class=\"font-bold\">Ignite WiFi<sub>TM</sub></span> Hub! <br>We think you’ll love the Ignite Internet package we picked just for you. Check out your offer now!","subheader":"Introducing the Ignite WiFi Promise","body2":"All Ignite Internet packages are now backed by the Ignite WiFi Promise. Strong, secure WiFi you can depend on – that’s our promise to you."},"ignite":{"header":"Experience Ignite TV – the next generation of TV, powered by our fastest internet","body1":"Stream your favourites from different platforms including Netflix, live TV and your recordings – with all-in-one voice search!","subheader":"Introducing the Ignite WiFi Promise","body2":"All Ignite Internet packages are now backed by the Ignite WiFi Promise. Strong, secure WiFi you can depend on – that’s our promise to you."},"LEGACY":{"TITLE":"<span aria-hidden=\"true\"><i class=\"rui-icon-error\"></i></span> Your savings are about to expire.","BODY":"When your current promotion is up, your bill will increase. Here's another chance to save on your services."},"IGNITE":{"TITLE":{"regular":"Let’s secure you a great deal.","eop":"Your savings are about to expire.","recommended":"We have a personalized recommendation for you!"},"BODY":{"regular":"You’re eligible for an upgrade to Ignite TV<sub>TM</sub> at a special price!.","eop":"When your current promotion is up, your bill will increase. Here's another chance to save on your services.","recommended":"Great news! Check out this service we think you’ll love."}}},"TECHNICAL_ERROR":{"TITLE":"Something went wrong","BODY":"Sorry, we're experiencing a technical error. Please try again later."},"OFFER_MISMATCH":{"TITLE":"Sorry...","BODY":"Looks like you recently accepted another offer on these services. This promotion is no longer valid."},"CURRENT_PLAN":{"title":"Your current plan","features":{"tv":"TV:","internet":"Internet:","home_phone":"Home Phone:","download":"Download speed up to:","channels":"channels","internet_desc":"download"},"current_promo_price":"Current price with savings","price_after":"Price after"},"NEW_OFFER":{"HEADER":"Let's secure you another great deal.","BODY":"You're eligible for a discounted upgrade of your Rogers services. But hurry, this online offer is only available for a limited time!","newOfferTitle":"{{ bundleName }} TV Package with:","newPromo":{"exclusiveOffer":"Your exclusive offer!","name":"TV Package","features":{"tv":"TV with","download":"Download speed up to:","channels":"channels"},"image_alt":"Image of ","includes_rhp":"Includes Home Phone","SAVINGS":"After credit of ${{ discount }} for {{ term }} months</br>Currently ${{ originalMsf }}/mo</br>Prices are subject to any applicable rate increase","SAVINGS_with_month_term":"After credit of ${{ discount }}/mo for {{ term }} months.</br>Currently ${{ originalMsf }}/mo.</br>Month-to-month term. Prices are subject to rate increase.","notIncluded":"Prices do not include fees for any existing add- ons or extra equipment on your account.","installation_fee":"Installation:","FREE":"FREE","disclaimer":{"internet":"*Taxes extra. The credit will be applied monthly off the current price for the duration of the promotional period. The current price is subject to any applicable rate increase during or after the promotional period. Offer available for a limited time within Rogers cable service area (where technology permits). Subject to change without notice. Data usage subject to Rogers Terms of Service and Acceptable Use Policy. See rogers.com/terms for full details.","tv":"*Taxes extra. The credit will be applied monthly off the current price for the duration of the promotional period. The current price is subject to any applicable rate increase during or after the promotional period. Offer available for a limited time within Rogers cable service area (where technology permits). Subject to change without notice. See rogers.com/terms for full details.","bundle":"*Taxes extra. The credit will be applied monthly off the current price for the duration of the promotional period. The current price is subject to any applicable rate increase during or after the promotional period. Offer available for a limited time within Rogers cable service area (where technology permits). Subject to change without notice. Data usage subject to Rogers Terms of Service and Acceptable Use Policy. See rogers.com/terms for full details. Rogers reserves the right to remove bundle benefits if services are changed or cancelled resulting in you no longer being eligible."}}},"ways_to_buy":"Ways to buy:","call_care":"1 877 331-7840","call_care_alt_text":"Call Rogers about this offer at ","liveChat_ID":"8434909186669421607","liveChat_alt_text":"Live Chat with an agent about this offer"},"features":"Features","myrLinkAccount_title":"Link Account","myrLinkAccount_body":"To view your bill, check usage and more, link your services to your <span class='ute-textWeight-medium'>MyRogers</span> profile.","myrLinkAccount_skip_body":"Don’t have any services from Rogers?","myrLinkAccount_skip_cta":"Skip this step","myrLinkAccount_business_callout_title":"Have a Small Business Account?","myrLinkAccount_business_callout_body":"Visit our <a href='https://www.rogers.com/web/smb/bss/#/linkaccount'>business self-serve page</a> to access your usage and billing information.","myrLinkAccount_select_type":"Select your account type","myrLinkAccount_tab_cable":"Wireless or cable services","myrLinkAccount_tab_payasyougo":"Pay As You Go™","myrLinkAccount_cable_step_1":"1. Enter your account number and postal code","myrLinkAccount_cable_account_number":"9- or 12-Digit Account Number","myrLinkAccount_cable_postal":"Postal Code (e.g., M2Y2Y5 OR M2Y 2Y5)","myrLinkAccount_cable_step_2":"2. Select your billing type","myrLinkAccount_cable_online_bill":"Online bill","myrLinkAccount_cable_paper_bill":"Paper bill","myrLinkAccount_online_benefits_title":"The benefits of online billing","myrLinkAccount_online_benefits_1":"Access your bill anywhere, anytime.","myrLinkAccount_online_benefits_2":"Get notified when your bill is ready.","myrLinkAccount_online_benefits_3":"Download usage details.","myrLinkAccount_online_benefits_4":"Store bills online for up to 18 months.","myrLinkAccount_cta_link":"Link Account","myrLinkAccount_cta_cancel":"Cancel","myrLinkAccount_payasyougoTitle":"Enter your phone number and account PIN","myrLinkAccount_phoneNumber":"10-digit Phone number","myrLinkAccount_pin":"4-digit Account PIN","myrLinkAccount_forgot_pin":"Can't remember your account PIN? <br/>Speak to an agent now by calling 1-800-575-9090.","link_account_title":"Link Rogers Account","link_account_intro":"We noticed you don't have a Rogers account linked to your MyRogers<sub>TM</sub> profile. Link an account to get the most out of MyRogers.","link_account_intro_no_link":"We noticed you don't have a Rogers account linked to your MyRogers<sub>TM</sub> profile.<br/><br/>Link an account to get the most out of MyRogers.","link_account_need_help":"Need Help?","link_account_tooltip":"Forgotten your account number? Contact an Online Customer Care representative via Live <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>Chat</a>. We'll recover your account details so you can enjoy the benefits of MyRogers<sub><small><small>TM</small></small></sub>.","link_account_general_error":"We’re unable to link your account at the moment. Please try again later.","link_account_no_rogers_account_error":"Sorry, the account number entered could not be found. Please check that your entry is correct.","link-pay-as-you-go-error":"Sorry, the information entered belongs to Pay As You Go account. To link this account, please select the Pay As You Go account type.","linked_acc_bill_options_1":"Online Billing","linked_acc_bill_options_2":"Paper Bill","linked_acc_btn_skip":"Skip this Step","linked_acc_btn_submit":"Link Account","linked_acc_discl_accept":"I accept the terms and conditions.","linked_acc_discl_accept_error":"Please accept terms and conditions before proceeding.","linked_acc_discl_text":"The following terms and conditions of service govern your use of the Paperless Billing Service (the 'Service') that you have subscribed to or receive from Rogers. They are in addition to and are incorporated into the Rogers Terms of Service available at rogers.com/terms. Unless otherwise defined herein, capitalized terms below have the meanings given to them in the Rogers Terms of Service.\n\n\n<br/><br/>\nThe Service enables you to view your bill online at rogers.com. Each month you will receive an email indicating that your bill is ready to be viewed online.\n\n\n<br/><br/>\nYou acknowledge, understand and agree that when you enroll in the Service the following apply:\n\n\n\n<br/><br/>\n<ol>\n<li>You must provide Rogers with true, accurate, current and complete information as requested by us from you.</li>\n\n    <li>You must have an active MyRogers profile and have an account number associated to the profile.</li>\n\n    <li>You must keep your email address and other information current and updated at all times so that we can provide you the Service. We will not be responsible for providing you the Service if you change or cancel your e-mail address or any other information and or if you fail to update such information by logging into MyRogers at rogers.com and updating your email address on the MyRogers Profile tab.</li>\n\n    <li>You will be asked to select a password when you register for MyRogers. You may change your password at any time by logging into MyRogers and selecting the MyRogers Profile tab. You are responsible for maintaining the confidentiality of your password and account and are fully responsible for all activities that occur through the use of your password or account. Please notify Rogers immediately of any known or suspected unauthorized use of your password or account or any other breach of security.</li>\n\n    <li>If your email address is not active or does not accept emails, you will not receive the monthly notifications informing you that your bill is ready to be viewed online. You will be able to access MyRogers and view your bill.</li>\n\n    <li>You will no longer receive a paper bill in the mail.</li>\n\n    <li>You remain liable for all charges to your account and are solely responsible to ensure that all of your payments reach us prior to any required payment date specified on a paperless bill.</li>\n\n    <li>You may cancel your enrollment in the Service at any time by logging into rogers.com and updating your billing preference. A paper invoice fee of <strong><span style='font-size:14px'>$2</span></strong> per month will apply.</li>\n\n    <li>In the event of a discrepancy between a paperless bill and our Rogers billing records, our Rogers billing records will prevail.</li>\n    </ol>","linked_acc_discl_title":"ROGERS TERMS OF SERVICES FOR ONLINE BILLING","linked_acc_number_invalid":"Please enter a valid 9 or 12 digit number","linked_acc_number_required":"Required field","linked_acc_options_1":"Wireless or Cable Account","linked_acc_options_2":"<i>Pay As You Go</i><sup>TM</sup> Account","linked_acc_phone_invalid":"Please enter a valid phone number. ","linked_acc_popup":"Your Rogers account number is between 9 and 12 digits and can be found on the top right-hand corner of your bill.","linked_acc_postalcode_invalid":"Please enter a valid postal code","linked_acc_prepaid_number":"Pay As You Go<sup>TM</sup> Account","linked_acc_prepaid_pin":"A 4-digit PIN is required.","linked_acc_prepaid_pin_confirm":"Confirm 4-digit PIN is required","linked_acc_prepaid_pin_confirm_error":"4-digit Confirm PIN is required","linked_acc_prepaid_pin_error":"A 4-digit PIN is required.","linked_acc_prepaid_pin_error_mismatch":"PIN and PIN confirm do not match","linked_acc_sub_title_1":"Account Details","linked_acc_sub_title_2":"Billing Preferences","linked_acc_success":"Your account was successfully linked to your profile!","linked_acc_title":"Link your Rogers account to your MyRogers profile (Optional)","linked_err_acc_num":"Please enter an account number.","linked_err_postal":"Please enter the postal code associated with the account number.  This can be found on your paper bill statement.","linked_chat_help":"Forgotten your account number? Contact an Online Care representative via Live <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>chat.</a> We will recover your account details so you can enjoy the benefits of MyRogers.","long_distance":"Long Distance","login_forget_pwd_email_invalid":"Sorry, you're required to enter a valid email address.","login_forget_pwd_required":"Sorry, you're required to enter a valid email address.","login_forget_username_desc":"Enter your email address and we’ll send you your MyRogers username.","login_forget_username_success":"Please check your email. Your MyRogers username was sent to <b>{{email}}</b>.","login_forget_username_title":"Forgot your MyRogers username?","login_invalid_answer_required":"Please provide an answer to your secret question.","login_invalid_answer_sent":"The security answer entered does not match our records.  Please re-enter your answer.","login_invalid_email_sent":"E-mail is not registered","login_invalid_email_sent_desc":"Please enter your <b>contact</b> email address. This may be different from the one you use for your username. If you can’t remember your contact email address, please get in touch with us through <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>Live Chat</a>.","login_invalid_password":"Please enter a valid password","login_re_enter":"Please confirm your password by re-entering it.","login_reset_pwd_desc":"Enter your email address and we’ll send you a link to reset your password.","login_reset_pwd_email_desc":"Please answer your security question to reset your password.","login_reset_pwd_placeholder":"Email Address","login_userName_email_placeholder":"Username or Email Address","login_reset_pwd_success":"We sent an email to <b>{{email}}</b>.This email contains a temporary password to access your account.","login_reset_pwd_success_message":"Check your Email","login_reset_pwd_title":"Reset your MyRogers password","login_security_questions":{"1":"What is your mother's maiden name?","2":"What city were you born in?","3":"What is the name of your first pet?","4":"What was the name of your high school?","5":"What is your favourite sports team?","6":"What is the name of your favourite teacher?","7":"What is your favourite pastime?","8":"What was your first vacation spot?"},"login_security_questions_1":"What is your mother's maiden name?","login_security_questions_2":"What city were you born in?","login_security_questions_3":"What is the name of your first pet?","login_security_questions_4":"What was the name of your high school?","login_security_questions_5":"What is your favourite sports team?","login_security_questions_6":"What is the name of your favourite teacher?","login_security_questions_7":"What is your favourite pastime?","login_security_questions_8":"What was your first vacation spot?","login_reset_success":"Your password was successfully reset!","maintenance_info":"Sorry, we’re not able to display your info. We’re working to fix the issue.<br/>Need help?&nbsp;","maintenance_info_site":"Sorry, MyRogers<sub><small><small>TM</small></small></sub> undergoes daily maintenance from 2 am to 6 am. Most features are not available during this time.","maintenance_info_wireless":"Sorry, we’re unable to retrieve your wireless service details at the moment. Please <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cretrieve_services_error_en' target='_blank'>chat</a> with a Care Representative for assistance.","maintenance_info_residential":"Sorry, we’re unable to retrieve your service details at the moment. Please <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cretrieve_services_error_en' target='_blank'>chat</a> with a Care Representative for assistance.","maintenance_info_history":"We’re unable to retrieve your payment history at the moment. Please try again later.","marketingPermissionsHeading":"Marketing Permissions","marketingPermissionsSubheading":"Let us know how you’d like to be contacted","myaccoverview":"My Account Overview","myrogersoverview":"MyRogers Overview","myaccoverview_days_left":"days left for this months bill","myaccoverview_get_monotoring":"Get Smart Home Monitoring","myaccoverview_home_monotoring":"Home Monitoring","myaccoverview_get_phone":"Get Home Phone","myaccoverview_get_wireless":"Get Wireless","myaccoverview_get_internet":"Get Internet","myaccoverview_get_tv":"Get TV ","myaccoverview_get_rogers_bank":"Rogers Credit Card","myaccoverview_get_nhl":"Rogers<sup>TM</sup> NHL GameCentre LIVE","myaccoverview_get_ignite_bundle":"Get Ignite TV","ACTUAL_TEXT_myaccoverview_get_ignite":"Ignite TV & Internet Package","myaccoverview_account_preferences":"Account Preferences","myaccoverview_change_contact_information":"Change contact info","myaccoverview_switch_to_online_bill":"Switch to online billing","myaccoverview_change_password":"Change password","myaccoverview_change_method_of_payment":"Change method of payment","myaccoverview_reset_wireless_voicemail_password":"Reset wireless voicemail password","my_wireless_right_now":"My Wireless Right Now","my_internet":"My Internet","mu_your_username_willbe":"Your Username will now be your email address","mu_please_confirm":"Please confirm the email address you would like to use.","mu_please_contact":"Please contact an agent to assist you in completing your Username change.","mu_sorry_email_registered_1":"Sorry. This email address is unavailable.","mu_sorry_email_registered_2":"Unfortunately, {{email}} is already registered to another profile. For further assistance with changing your username, please contact us.","mu_please_confirm_email":"Please confirm email address.","mu_email_required":"Sorry, an email address is required.","mu_email_not_valid":"Sorry, the email address entered is not valid.","mu_email_not_match":"Sorry, the email addresses do not match.","mu_msg_success":"Your Username has been successfully updated.<br/><div class='message-error-normal mbs'>Remember to enter your email address wherever you log in with MyRogers.</div><div class='message-error-normal mbs row'>Now that you’ve updated your username, you get easy access to great value-added services like:<br/><div class='message-error-normal col-xs-12 col-sm-6 col-md-6 col-lg-6'><ul><li>shomi<sup>TM</sup></li><li>Rogers<sub>TM</sub> Game Centre Live<sup>TM</sup></li><li>The MyRogers app</li></ul></div><div class='message-error-normal col-xs-12 col-sm-6 col-md-6 col-lg-6'><ul><li>Smart Home Monitoring</li><li>Community Forums</li></ul></div></div>","mu_msg_success_2":"An email has been sent to the address specified as your Username.","mu_username_canbe_updated":"Your Username can  be updated at any time.","mu_help_chat":"<a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank' style='color:red;'>Live&nbsp;Chat</a>","mu_help_chat_black":"<a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank' style='color:black;'>Live&nbsp;Chat</a>","mu_registration_lg":"Why MyRogers?","mu_registration_line":"Sign up is fast and easy! Plus you can:","mu_registration_list_1":"Check your balance 24/7","mu_registration_list_2":"Pay your bills on-the-go","mu_registration_list_3":"Monitor your usage anywhere, anytime","mu_registration_sm":"Register Now","mu_patience":"This change may take a few minutes to complete, thanks for your patience.","OldPassword":"Old Password","AMEX":"American Express","MASTER":"Mastercard","VISA":"VISA","AMEX_img":"ute-common-assets/assets/cards/amex.png","MASTER_img":"ute-common-assets/assets/cards/master.png","VISA_img":"ute-common-assets/assets/cards/visa-icon-1217.png","paynow_title":"Make a payment now","paynow_payment_amount":"Payment amount","paynow_payment_step1":"Step 1: Enter your payment amount","paynow_never_miss_1":"Never miss a payment!","paynow_never_miss_2":"<a ui-sref='changeMethod' href='#/changemethod'>Sign up for pre-authorized payments</a> and never worry about missing a payment again.","paynow_method":"How would you like to pay?","paynow_method_step2":"Step 2: Select your payment method","paynow_method_interac":"If paying through Interac you’ll be taken to a secure Interac payment page","paynow_interac":"Interac","paynow_interac_2":"Please note you will be redirected to Interac.ca","paynow_cc":"Credit Card/Visa Debit","paynow_need_help":"Need help with payment options?","paynow_faq":"Review Payment FAQs","paynow_chat":"Talk to us now with Live <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>Chat</a>","paynow_payment_method2":"Payment Method","paynow_invoice":"Invoice","paynow_change":"Change","paynow_history":"History","paynow_edit":"Edit","paynow_$":"$","paynow_$2":"$","paynow_payment_method_cc":"Pre-authorized Credit Card","paynow_method_check":"Pre-authorized Debit","paynow_method_unavailable":"Unavailable","paynow_cc_payment":"Secure Credit Card Payment","paynow_cc_secure":"This is an encrypted and secure transaction","paynow_cc_number":"Credit Card Number","paynow_bank_account_number":"Bank Account Number","paynow_expiry_date":"Expiry Date","paynow_code":"Security Code","paynow_paybill":"Pay now","paynow_name_on_card":"Name on Card","paynow_processing":"Processing Payment","paynow_general_error":"Sorry, some information is missing or incorrect. Please review the highlighted fields before proceeding.","paynow_code_required":"Sorry, that security code isn't valid. Please try again.","paynow_month_required":"Please select a month","paynow_year_required":"Please select a  year","paynow_date_required":"Sorry, that expiry date isn't valid. Please try again.","paynow_code_error":"Sorry, that security code isn’t valid. Please try again.","paynow_payment_required":"Sorry, that payment amount isn’t valid. Please try again.","paynow_card_required":"Sorry, that credit card number isn't valid. Please try again.","paynow_card_error":"Sorry, that credit card number isn't valid. Please try again.","cyberSource_Down_error":"Sorry, something went wrong and your payment was not accepted.Please try again, using a different payment method.","paynow_card_tooltip":"The security code is a three digit value at the back of your Visa and Mastercard cards or a four digit value on the front of your American Express card.","paynow_review_details":"Review Your Payment Details","paynow_review_amount":"Payment Amount","paynow_review_method":"Payment Method","paynow_review_date":"Payment Date","paynow_sorry":"<b>Sorry, something went wrong and your payment was not accepted. </b><br/><br/> Please try again, using a different payment method.","paynow_sorry_i1":"Sorry, something went wrong and your payment was not accepted.","paynow_sorry_i2":"Please try again, using a different payment method.","paynow_select_another":"Select Another Payment Method","paynow_cancel_desc":"Cancelling this payment will take you to another page and any changes will not be saved. Are you sure you want to cancel this payment?","paynow_continue":"Continue Payment","paynow_cancel":"Cancel this Payment","paynow_thanks":"<b>Thank you!</b><br/> Your payment has been received. We’ve also sent you a confirmation email.","paynow_thanks_i":"Your payment has been received. We’ve also sent you a confirmation email.","paynow_larger":"The amount for payment is larger than the amount due.","paynow_tooLarge":"Sorry, the amount you’ve entered is more than the amount due. Please enter a new amount.","paynow_expiry_notvalid":"Sorry, that expiry date isn't valid. Please try again.","paynow_due_credit":"Charge to your credit card on or after:","paynow_due_debit":"Debited from your account on or after:","paynow_change_bill_type":"Change Payment Method","paynow_acc_balance_today":"Total Account Balance:","paynow_overdue":"Including overdue balance","paynow_acc_balance_why_different":"Why is my account balance different from my bill?","paynow_go_to_overview":"Account Overview","paynow_preauth_payment_option":"By selecting this box, you agree to use this card for all future pre-authorized payments.<br/>Once you confirm, we will automatically deduct charges from your card based on your billing cycle.","paynow_success_1":"We’ve received your payment of <b>{{amount}}</b> and sent you a confirmation email.","paynow_success_2":"We’ve received your payment of <b>{{amount}}</b> and sent you a confirmation email.<br/><br/>We’ve also changed your method of payment to <b>pre-authorized credit</b>.","paynow_failure_1":"Sorry, we’re unable to process your payment at this time. Please call 1 877 559-5202 for assistance.","paynow_failure_2":"We’ve received your payment of <b>{{amount}}</b> and sent you a confirmation email. Unfortunately, we are unable to change your payment method at this time. Please try again later.","paynow_thankyou_title":"Thank You!","paynow_tryagain_title":"Try again","profile":"Profile","ovProfile":"MyRogers Profile","ReminderQuestion":"Password Reset Question:","ReminderAnswer":"Reminder Answer:","StreetAddress":"Street Address","history_empty":"Sorry, you don’t have any history.","history_sort_by":"Sort By","history_payment_date":"Date","history_payment_amount":"Amount","history_payment_method":"Transaction","history_payment_reference":"Reference #","history_payment_details":"Details","history_sgi_account_disclaimer":"Payments take <span>1 business day</span> to appear in your history.","history_payment_status_desc":"<strong>Successful</strong><p>Your payment was successfully made.</p><strong>Unsuccessful</strong><p>Payment made did not go through. Your card/bank account was not charged.</p><strong>Credited to you</strong><p>We’ve credited this amount to your account.</p><strong>Amount you transferred</strong><p>You transferred this amount to another account.</p><strong>Transferred to you</strong><p>You received this amount from another account.</p>","paynow_history_more":"","ServiceAddress":"Service Address","SecretQuestion":"Password Reset Question","changes_to_your_plan_label":"Changes to Your Plan","change_method":"Payment Method","change_method_know":"Did you know?","change_method_intro":"Subscribe to pre-authorized payments and enjoy the <strong>convenience</strong> of paying your Rogers bill automatically from your Canadian bank account or credit card every month.","change_method_note":"Please note that it takes <strong>2 business days</strong> for the payment method change to be updated.","change_method_update":"Update Payment Method","change_method_invoice":"Update your payment method to monthly invoice","change_method_invoice_info":"Please contact a Rogers Care agent to assist you with completing your Payment Method change.","change_method_confirm":"Confirm Payment Method Update","change_method_warning":"A monthly invoice means one more thing to remember every month. Are you sure you don’t want the convenience of paying your Rogers bill automatically from your Canadian bank account or credit card every month?","invoice":"Invoice","change_method_debit":"Pre-authorized debit (Canadian banks only)","change_method_credit":"Pre-authorized Credit Card","change_method_unavailable":"Unavailable","change_method_ways":"Ways you can pay your invoice","online":"Online","change_method_stores":"Selected Rogers Stores","change_method_app":"MyRogers App","change_method_banks":"Most Banks","change_method_mail":"Mail a cheque to: <p style='margin-left:45px;margin-top:10px;'>Rogers <br/>PO Box 9100 <br/>Don Mills, ON <br/>M3C 3P9</p>","change_method_secure":"Secure Credit Card Payment","change_method_info_secure_credit":"Your credit card information will be kept encrypted and secure.","change_method_terms_credit":"Terms & Conditions for Pre-authorized Credit Card","tbd":"TBD","change_method_secure_debit":"Secure Debit Payment","change_method_cheque_header":"Enter Account Information","change_method_info_secure_debit":"Your debit information will be kept encrypted and secure.","change_method_info_transit_code":"Transit Code","change_method_info_bank_code":"Bank Code","change_method_account_number":"Account Number","change_method_terms_debit":"Terms & Conditions for Pre-Authorized Debit","change_method_see_tctab":"See T&Cs Debit Tab","change_method_confirm_title":"Confirm Payment Method Update","change_method_confirm_details":"A monthly invoice means one more thing to remember every month. Are you sure you don’t want the convenience of paying your Rogers bill automatically from your Canadian bank account or credit card every month?","change_method_thankyou_title":"Thank you!","change_method_thankyou_details":"Pre-authorized payments for your account are set! Your first payment will take effect on your next invoice. We’ve also sent you a confirmation email.","change_method_error":"Sorry, something went wrong and your changes was not accepted.  Please try again, using a different payment method.","change_method_deb_error":"Sorry, that transit code or bank code isn't valid. Please try again.","change_method_invalid_bank_code":"Sorry, that bank code isn't valid. Please try again.","change_method_invalid_transit_code":"Sorry, that transit code isn't valid. Please try again.","change_method_invalid_account":"Sorry, that bank account number isn’t valid. Please try again.","change_method_invalid_accountType":"Sorry, that account type isn’t valid. Please try again.","change_method_accept":"I accept the Terms and Conditions","change_method_not_accepted":"Please accept terms and conditions before proceeding.","change_method_terms":"<div class='mop-tandc-legal-text-container'><p class='center'><h6 class='txtM inline'>PAD terms and conditions</h6></p><p>This agreement authorizes any of the Rogers group of companies ('Rogers') to debit my/our account shown above to pay my/our periodic charges for the provision of Rogers goods and/or services, including all services provided by Rogers Wireless Partnership and all services (including Rogers Internet and Rogers Home Phone services) provided by Rogers Cable Communications Inc.</p><p>I/We acknowledge that this authorization is for the use of Rogers and my/our financial institution and is provided in consideration of my/our financial institution agreeing to process debits against my/our account as per the rules of the Canadian Payment Association.<br/>I/We acknowledge that by providing and delivering this authorization to Rogers constitutes delivery by me/us my/our financial institution.<br/>The information above will be communicated to Roger's bank(s) in order to implement this authorization.<br/>All persons whose signatures are required to sign on the account noted above have agreed to this authorization.<br/>I/We will promptly notify Rogers in writing if there is any change to my/our account information.</p><p>This authorization agreement may be cancelled at any time provided notice is received by Rogers 30 days before the next scheduled debit.</p><p>To obtain a sample cancellation form, or further information on my/our right to cancel a pre-authorized debit agreement, I/we may contact my/our financial institution or visit www.cdnpay.ca.Cancellation of this agreement applies only to the method of payment and does not otherwise have any bearing on the contract for Rogers goods or services.Rogers may not assign this agreement without providing at least 10 days prior notice to me/us.</p><p>I/We understand that:</p><p>The amount of each payment to be debited from my/our account reflecting charges to my/our account from the preceding billing period will appear on the invoice I/we receive from Rogers prior to that debit.I/We agree that Rogers may reduce the standard period of pre-notification for each debit.Debits will occur monthly, unless my/our service agreement states otherwise.</p><p>My/Our financial institution is not required to verify that any debits Rogers withdraws comply with this authorization or any agreement with Rogers.My/Our financial institution can reimburse me/us for any debited amount if:</p><p>(i) its withdrawal does not comply with this authorization, or<br/>(ii) I/we cancel this authorization. To be reimbursed, I/we must complete a declaration form within 90 calendar days of the debit being posted to my/our account; any dispute after that time must be resolved directly with Rogers.<br/>I/We have certain recourse rights if any debit does not comply with this agreement.<br/>For example, I/we have the right to receive reimbursement for any debit that is not authorized or is not consistent with this agreement. To obtain more information on my/our recourse rights, I/we may contact my/our financial institution or visit www.cdnpay.ca.</p><p>I/We acknowledge that I/we have read, understood and accepted all of the terms and conditions of this Pre-Authorized Chequing authorization agreement.</p></div>","internet_my_usage":"My Usage","internet_usage":"Usage","internet_my_usage_48":"Usage within the last <span class='semi-bold'>48 hours</span> may not be reflected","internet_new_usage":"New usage cycle starts in:<strong>{{days}} days</strong>","internet_total_usage":"Total Usage","internet_unlimited":"Unlimited","internet_remaining":"remaining","internet_remaining_plural":"remaining","internet_overage_new":"{{totalOverage}} GB overage","internet_overage_plan_limit":"of {{totalLimit}} plan limit","internet_plan_limit":"of {{totalLimit}} plan limit","internet_extra":"Extra Usage","internet_daily_usage":"Daily Usage","internet_monthly_usage":"Monthly Usage","internet_view_history":"View Usage History","internet_usage_alerts":"View Usage Alerts","internet_my_internet_package":"My Internet Package","internet_internet_package":"Internet Package","internet_includes":"Includes:","internet_speed":"Download Speed:","internet_speed_up":"Upload Speed:","internet_manage_package":"Change My Package","internet_my_plan":"My Plan","internet_my_extras":"My Extras","internet_extras":"Extras","internet_est_monthly_total":"The estimated monthly total does not include discounts and credits.","internet_per_month":"/month","internet_change":"Change Plan","internet_remove":"Remove","internet_add_extras":"Add Extras","internet_my_modem":"My Modem","internet_modem":"Modem","internet_change_modem":"Change Modem","internet_change_my_modem":"Change My Modem","change_wifi_password":"Change WiFi Password","internet_yahoo_email":"Set up Rogers Yahoo Email","internet_yahoo_email_check":"Check my Rogers Yahoo Email","internet_promo_did_you_know":"Did you know?","internet_promo":"<strong>SpeedBoost<sup>TM</sup></strong>  technology is included with your Hi-Speed Internet service at no additional charge.","internet_promo_more":"Learn more","internet_almost_out":"Almost Out","internet_used":"Used","internet_MB":"MB","internet_GB":"GB","internet_Mbps":"Mbps","internet_downloaded":"Downloaded","internet_uploaded":"Uploaded","internet_overage":"Overage","internet_addcost":"Additional Cost","internet_charged_at":"Charged at","next_bill":"next bill","last_bill":"last bill","internet_missing_usage":"Usage Not Available ","used_cycle_not_available":"New usage cycle starts in: Not available","register_now":"ACTIVATE","registration_title":"MyRogers Registration","registration_tooltip":"Your password must be between 7 and 16 characters. Letters and numbers only, at least one letter and one number. No special characters.","registration_wrong_password":"You can use only numbers and letters in your password, not special characters. Please try again.","registration_password_must_differ":"Your new password must differ from the old password.","registration_password_incorrect":"Old password incorrect.","registration_too_short":"Please enter a valid password","registration_too_long":"Please enter a valid password","registration_alphabet_only":"Please enter a valid password","registration_number_only":"Please enter a valid password","registration_language":"Language Preference","revo_included":"What You Have","revo_included_ph3":"More Services","revo_value_add":"What You Can Get","revo_with_internet":"With Internet plan","revo_with_wireless":"With your Wireless plan","revo_with_cable":"With Cable plan","revo_change_selection":"Change selection","revo_details":"Details","revo_get_this":"Get this","revo_free_with_your_plan":"Enjoy one of these for 2 years with your <i>Share Everything</i> +<sub>TM</sub> Plan ","revo_free":"FREE","revo_by":"By","revo_manage":"Manage","revo_listen":"Listen","revo_modal_content":"Taxes extra. Pay-Per-Use rate and subject to change without notice. Fee charged per line and applies for 24 hrs from first use in eligible destination. Roaming charges apply when outside the eligible destination. Data: Usage exceeding plan allotment charged in increments rounded up to next MB or GB (as per plan). Texts: Includes texts sent to local wireless number while in eligible destination or to Canadian wireless number. Sent/received premium texts and sent international texts to destinations other than eligible destinations charged at applicable rates. Calls: While in eligible destination, includes unlimited calls to local numbers or Canadian numbers. International long distance rates apply to calls to other destinations. See <a href='http://rogers.com/terms' target='_blank'>rogers.com/terms</a>.","rogers_credit_card":"Credit Card","ServiceAddressHeading":"Service Address","sign_email":"Email Address","sign_forget_details":"<p>Please try again.</p>Need help?","sign_intro":"An easy, secure way to manage your services and view your bills online.","sign_in_to_myrogers":"Sign in to MyRogers","sign_maximum_attempts":"<p><b>This account will be locked for 24 hours.</b></p><p>Sorry, this account has been locked for security reasons.</p>Need access now? Speak with one of our online agents.","sign_new":"New to","sign_third_attempts":"<p><b>This is your last attempt before the account is locked.</b></p><p>Sorry, the username and password entered below don’t match our records.</p> <p>Are you sure we can’t help?</p> ","sign_warning_msg_line_1":"<b>Sorry, the username or password you entered don't match our records.</b>","sign_warning_msg_line_2":"Please try again.","sign_warning_msg_line_3":"<b>Need help?</b>","sign_third_attempts_msg_line_1":"<b>This is your last attempt before the account is locked.</b>","sign_third_attempts_msg_line_2":"Sorry, the username and password entered below don’t match our records.","sign_third_attempts_msg_line_3":"<b>Are you sure we can’t help?</b>","sign_maximum_attempts_line_1":"<b>This account will be locked for 24 hours.</b>","sign_maximum_attempts_line_2":"Sorry, this account has been locked for security reasons.","sign_maximum_attempts_line_3":"<b>Need access now? Speak with one of our online agents.</b>","shm_title":"Smart Home Monitoring","shmdashboard":"SMART HOME MONITORING","shm_my_monitoring":"My Monitoring","shm_access_web":"Access Web Control Centre","shm_quick_start_guide":"Quick Start Guide","shm_municipal_permits":"Municipal Permits Information","shm_service_agreement":"Service Agreement","shm_promo_title":"Did you know?","shm_promo":"You can control your home from anywhere.","shm_insur_cert":"Insurance Certificate","shm_insur_cert_alt":"Get insurance certificate","shm_shop_accessories":"Shop for accessories","shm_get_started":"New to Smart Home? Get started.","shm_learn_more":"Learn more about Smart Home Monitoring","shm_access_web_alt":"Access Web Control Centre","shm_shop_accessories_alt":"Shop for accessories for your Smart Home Monitoring system","shm_get_started_alt":"Get started with tips and info about your new Smart Home system.","shm_learn_more_alt":"Learn more about Smart Home Monitoring","this_bill":"this bill","tv_tv":"TV","tv_my_tv":"My TV Right Now","tv_new_release":"NEW RELEASE","tv_rent_this":"Rent This!","tv_my_package":"My TV Package","tv_package":"TV Package","tv_whatson":"WHAT'S ON","tv_record_this":"Record This!","tv_watch_tv":"Watch TV online","tv_watch_tv_get_app":"Get app","tv_browse":"Browse Rogers On Demand","tv_program_guide":"View Program Guide","tv_manage_reocordings":"Manage My Recordings","tv_channels":"Channels Included","tv_channels_extra":"<b>Extra Channels</b>","view_my_channels":"Channel list","view_my_channels_text":"Browse channels included in my package.","tv_theme_packs":"Theme Packs","tv_package_change":"Change My Package","tv_add_channels":"Add Channels","tv_change_bonus_channel":"Change Bonus Channel","tv_add_channels_message_01":"Would you like to add a channel(s) and/or theme pack(s) to your TV package?","tv_add_channels_message_02":"Give us a call or talk to a Live Chat agent now:","tv_add_channels_supportPhoneNumber":"1 855 381 7834","boldchat_cbid_existing_customers":"2156078613061013110","tv_french_supportPhoneNumber":"1-888-ROGERS1 (764-3771)","boldchat_cbid_tv_french":"2156078613061013110","tv_add_themes":"Add Theme Packs","tv_my_box":"My Digital Box(es)","tv_box":"Digital Box(es)","tv_renatls":"Rental/Purchased","tv_add_box":"Want to add a digital box? Contact a store near you to make a purchase.","tv_find_store":"Find a store","tv_promo":"You can record up to <strong>8HD shows</strong> at the same time!","tv_move_service":"Move My Services","tv_view_appointments":"View Appointments","tv_reset_digital_box":"Reset Digital Box","tv_reset_pin":"Reset Digital PIN","tv_manage_recordings":"Need to manage your recordings or view your channel guide?","tv_no_links_right_now":"The links allowing you to do this aren’t available right now, but you can use the Rogers <b>Anyplace TV<sub>TM</sub></b> Home Edition app — it’s free!","tv_rogers_anyplace":"Rogers Anyplace TV<sub>TM</sub>","tv_manage_PVR":"Stream live sports, TV shows, and movies on the go, all across Canada.","tv_sign_in_rogers_anyplace":"Sign in to Anyplace TV","tv_sign_in_rogers_anyplace_alt":"Go to Anyplace TV to sign in","tv_watch_live_sports_mobile":"Watch TV wherever you are.","tv_watch_live_sports_desk":"Catch up on your favourite shows with On Demand at home or on the go.","tv_browse_on_demand":"Browse On Demand shows","tv_app_store":"Download on the App Store","tv_play_store":"Get it on Google Play","tv_watch_phone_tablet_desk":"Manage your PVR from your devices with <b>Anyplace TV<sub>TM</sub></b> Home Edition App.","tv_watch_phone_tablet":"Access our TV services from your phone or tablet using the Rogers <b>Anyplace TV<sub>TM</sub></b> Home Edition App — it’s free!","tv_watch_TV_online":"Watch TV online at RogersAnyplaceTV.com","tv_watch_now_button":"Watch Now","tv_channels_include":"Channels include:","rgcl_watch":"WATCH","10000_sign_in":"We’re unable to sign you in at the moment. Please try again later.","10000_register":"You are registered successfully. Please go to sign in.","12000-A":"Loyalty - Active","12000-B":"Loyalty - Blocked (in ELMS)","12000-D":"Loyalty - Deactivated","12000-F":"Loyalty - Fraud Closed","12000-M":"Loyalty - Pending migration","12000-N":"Loyalty - Not-Enrolled","12000-P":"Loyalty - Pending deactivation","12000-S":"Loyalty - Suspended","_password_requirements_label":"Password guidelines","_password_requirements_text":"Your password must be 7–16 characters long and must contain both letters and numbers.","_require_username_password":"Sorry, the username and/or password entered is not recognized. Please try again.","temp_password_enter_new_password":"Please enter a new password","temp_password_enter_new_password_description":"Please enter a new password for your MyRogers account.","temp_password_temp_pass_field":"Temporary Password","temp_password_temp_pass_field_tooltip":"This is the temporary password that we e-mailed you.","temp_password_dew_pass_field":"New Password","temp_password_confirm_dew_pass_field":"Confirm new password","temp_password_invalid_temp_password":"Sorry, the temporary password entered is not recognized. Please check your password and try again.","temp_password_guildeline":"Password guidelines","temp_password_list_of_guildeline":"<br>Your password must be 7–16 characters long and must contain both letters and numbers.","service_wireless":"Wireless","service_wireless_prepaid":"<i>PAY AS YOU GO<sup>TM</sup></i>","service_internet":"Internet","service_tv":"TV","service_tupelo":"Ignite SmartStream","service_phone":"Home Phone","service_monitoring":"Monitoring","history":"Payment History","_page":"Page","view_service_agreement":"View your Service Agreement","watch_this":"Watch This!","wireless":"Wireless","wireless_number":"Wireless Number","wireless_plan":"Wireless Plan","wirelessPrepaid":"Manage My Plan & Add-ons","wirelessPrepaidHeader":"Prepaid","wireless_quick-links":"Quick Links","wireless_add-travel-pack":"Add a Travel Pack","wireless_upgrade-my-device":"Upgrade My Device","wireless_my-wireless-usage":"My Wireless Usage","wireless_new-usage-cycle":"Cycle ends in:<strong>{{nextbilldaysuntil}} Days</strong>","wireless_view":"View","wireless_close":"Close","wireless_remaining":"remaining","wireless_remaining_plural":"remaining","wireless_remaining_plural_talk":"remaining","wireless_unlimited":"unlimited","text_remaining":"remaining","text_unlimited":"unlimited","wireless_local_calling":"Local <br/> Calling","wireless_canada_wide_calling":"Canada-Wide <br/> Calling","wireless_updated_12_hours":"Updated 12 hours ago","wireless_delayed_12_hours":"(Delayed up to 12 hours)","wireless_up_to_4_hours":"Up to 4 hours ago","wireless_delayed_4_hours":"(Delayed up to 4 hours)","wireless_uadd_new_addons":"Manage My Add-ons","wireless_uadd_travel_pack":"Add a Travel Pack","wireless_texts":"texts","wireless_been-travelling":"You have been travelling","wireless_looking-good":"Looking good","wireless_check-it-out":"Check it out","wireless_ok":"OK","wireless_overage":"Overage","wireless_infinite_reduced_speed":"Using data at reduced speed","wireless_almost-out":"Almost Out","wireless_extra-usage":"Extra Usage","wireless_data":"Data","wireless_unlimited_data":"Unlimited data","wireless_talk":"Talk","wireless_talk_weekday-minutes":"Weekday Minutes","wireless_talk_unlimited-ww-minutes":"Unlimited Weeknight/Weekend Minutes","wireless_talk_my5-my10":"My5/My10","wireless_talk_rogers2rogers":"Rogers to Rogers","wireless_talk_unlimited-network-calling":"Unlimited Network Calling","wireless_talk_between-family-calling":"Between Family Calling","wireless_talk_call-forwarding":"Call Forwarding","wireless_talk_incoming-calls":"Incoming Calls","wireless_talk_zone-calling":"Zone Calling","wireless_talk_long-canada":"Long Distance Canada","wireless_talk_long-us":"Long Distance U.S.","wireless_talk_long-international":"Long Distance International","wireless_text":"Text","wireless_features":"Features","wireless_details":"Details","wireless_extras":"Extras","wireless_included":"Included","wireless_features_and_add_ons":"Features & Add-Ons","wireless_text_2":"","wireless_text_sent":"Text Messages – Sent","wireless_text_received":"Text Messages – Received","wireless_text_mms-sent":"Picture/Video Messages – Sent","wireless_text_mms-received":"Picture/Video Messages – Received","wireless_text_long-us-sent":"Long Distance U.S. – Sent","wireless_text_long-international-sent":"Long Distance International – Sent","wireless_roaming":"Roaming","wireless_roaming_talk-us":"Talk U.S.","wireless_roaming_talk-international":"Talk International","wireless_roaming_data-us":"Data U.S.","wireless_roaming_data-europe":"Data Europe","wireless_roaming_data-international":"Data International","wireless_roaming_text-us-sent":"Text Messages U.S. – Sent","wireless_roaming_text-us-received":"Text Messages U.S. – Received","wireless_roaming_text-international-sent":"Text Messages International  – Sent","wireless_roaming_text-international-received":"Text Messages International  – Received","wireless_roaming_details_coming_soon":"Roaming details coming soon","wireless_roaming_details_coming_soon_chat_with_us_url":"http://rogershelp.com/customerserv/livechatsupport/index.php?source=42&lctc=42%7C01%7Cws%7CWWS%20en","wireless_usage_included":"Included","wireless_data_usage_included":"Data Included","wireless_usage_my-usage":"My Usage","wireless_usage_used":"Used","wireless_usage_usage-details":"Usage Details","wireless_usage_text-usage":"Text Usage:","wireless_usage_talk-usage":"Talk Usage:","wireless_usage_others-usage":"Others' Usage","wireless_usage_total-usage":"Total Usage","wireless_usage_remaining":"Remaining","wireless_usage-text_my-usage":"My Usage:","wireless_usage-text_others-usage":"Others' Usage:","wireless_usage-text_total-usage":"Total Usage:","wireless_usage-text_my-usage_in":"My Received Texts:","wireless_usage-text_others-usage_in":"Others' Received Texts:","wireless_usage-text_total-usage_in":"Total Texts Received:","wireless_usage-text_my-usage_out":"My Sent Texts:","wireless_usage-text_others-usage_out":"Others' Sent Texts:","wireless_usage-text_total-usage_out":"Total Texts Sent:","wireless_usage-text_remaining":"Remaining:","wireless_usage_mb":"MB","wireless_usage_gb":"GB","wireless_usage_minutes":"minutes","wireless_usage_messages":"messages","wireless_manage-plan":"Manage My Plan & Add-ons","wireless_manage-plan_estimated-values":"<b>The estimated values below do not include discounts or credits</b>","wireless_manage-plan_description":"SOC Description","wireless_manage-plan_price":"Price","wireless_manage-plan_soc_code":"SOC Code","wireless_manage-plan_effective_date":"Effective Date ","wireless_manage-plan_expiration_date":"Expiration Date ","wireless_manage-plan_current_service":"Current Service","wireless_manage-plan_no_socs_available":"There are no SOCs available on this account.","wireless_manage-plan_wireless-package":"My Wireless Package","wireless_manage-plan_wireless-not-applicable":"N/A","wireless_manage-plan_modal_header":"Included in your","wireless_manage-plan_data":"Data","wireless_manage-plan_month":"/month","wireless_manage-plan_package":"Manage My Package","wireless_manage-plan_add-ons":"Manage My Add-ons","wireless_package_included_with_plan":"Included with My Plan","wireless_manage-plan_my-line":"My Line:","wireless_manage-plan_change-sim":"Change My SIM","wireless_manage-plan_change-number":"Change My Number","wireless_manage-device":"Manage My Device","wireless_manage-device_free-upgrade":"Eligible for Free Upgrade on:","wireless_manage-device_upgrade-today":"Upgrade Today for:","wireless_manage-device_upgrade-device":"Upgrade My Device","wireless_manage-device_check_balance":"Check Device Balance","wireless_manage_device_reserve":"Device Reservation","wireless_manage-device_suspend-service":"Suspend My Service","wireless_manage-device_suspend-ctn":"Is your device lost or stolen?","wireless_manage-device_restore-service":"Restore My Service","wireless_manage-device_reactivate-service":"Reactivate Your Services","wireless_manage-device_reactivate-services":"Reactivate services","wireless_manage-device_phone-finder":"Get Phone Finder","wireless_manage-device_voicemail-password":"Update My Voicemail Password","wireless_manage-device_get-one-number":"Get <i>Rogers One Number</i><sup>TM</sup>","wireless_manage-device_shop-accessories":"Shop for Accessories","wireless_manage-device_my5-my10":"Manage My5/My10","wireless_manage-device_free":"FREE","wirless_manager-device_hup":"Upgrade my device:","wireless_manage-device_in_stock_info":"If the item is <strong>in stock,</strong> go to ","wireless_manage-device_out_of_stock_info":"If the item is <strong>out of stock,</strong> follow the ","wireless_manage-device_endless_Aisle":"Endless Aisle flow","wireless_manage-device_imei":"IMEI: ","wireless_prepaid":"Prepaid","wireless_prepaid_quick-links":"Quick Links","wireless_prepaid_get-add-on":"Get an Add-on","wireless_prepaid_shop-accessories":"Shop for Accessories","wireless_prepaid_manage-plan":"Manage My Plan & Add-ons","wireless_prepaid_my-plan":"My Plan","wireless_prepaid_data":"Data","wireless_prepaid_plan-expires":"Next payment date:","wireless_prepaid_change-plan":"Change My Plan","wireless_prepaid_add-ons":"My Add-ons","wireless_prepaid_add-on-expires":"Add-on expires:","wireless_prepaid_wireless-number":"My Wireless Number:","wireless_prepaid_pin-code":"PIN Code:","wireless_prepaid_change-number":"Change My Wireless Number","wireless_prepaid_change-pin":"Change My PIN Code","wireless_prepaid_manage-add-ons":"Manage My Add-ons","wireless_dashboard_refresh":"Refresh","wireless_dashboard_usage":"Usage","wireless_dashboard_rv_customer_cost_excluded":"(Excluding Upfront Edge amount)","wireless_dashboard_rv_customer_message":"Your device balance (excluding your <strong>Upfront Edge</strong><sub><small class='black'>TM</small></sub> amount) will be","wireless_dashboard_rv_customer_message_one":"You are enrolled in the Upfront Edge program","wireless_dashboard_rv_customer_message_upfront":"Upfront Edge","wireless_dashboard_rv_customer_upfront_faq":"Learn more about how Upfront Edge works >","wireless_dashboard_rv_amount_message":"<strong style=\"font-weight: 600\">Upfront Edge</strong><sub><small class='black'>TM</small></sub> amount: ","usage-unit-text":"min","wireless_missing_usage":"We notice you don't have a data, voice, or text plan. If you'd like to add a plan click <a href='http://www.rogers.com/consumer/wireless#plans' target='_blank'>here</a>.","wireless_midcycle_message":"We're not able to show your usage info right now as a plan change was made recently.<br/>Don't worry, you'll be able to see usage details at the start of your next usage cycle.","error_account_balance":"Sorry, we’re unable to retrieve your account balance details at the moment. Please <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>chat</a> with a Care Representative for assistance.","error_availed_services":"Sorry, we’re unable to retrieve your services details at the moment. Please <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>chat</a> with a Care Representative for assistance. ","error_cable_dashboard":"We’re sorry, but we’re unable to retrieve your cable service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue. ","error_rshm_dashboard":"We’re sorry, but we’re unable to retrieve your Smart Home Monitoring details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","error_population_accounts":"Sorry, we’re unable to retrieve your services details at the moment. Please <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>chat</a> with a Care Representative for assistance.","error_wireless_usage":"We’re sorry, but we’re unable to retrieve your wireless service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","wireless_usage_failed":"Sorry, we’re not able to display your Wireless usage. We’re working to fix the issue.<br/>Need help?&nbsp;","error_wireless_package_device":"Sorry, we’re unable to retrieve your wireless service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","error_wireless_package_device_old":"Sorry, we’re unable to retrieve your wireless service details at the moment. Please <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cretrieve_services_error_en' target='_blank'>chat</a> with a Care Representative for assistance.","error_manage_plan":"Sorry, we’re unable to retrieve your wireless service details at the moment. Please <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cretrieve_services_error_en' target='_blank'>chat</a> with a Care Representative for assistance.","error_usage_internet_modem":"We’re sorry, but we’re unable to retrieve your internet service details at the moment. Please try again later, and thanks for your patience as we work to fix the issue.","error_tv_feeder":"Sorry, we’re unable to retrieve information about what’s on at the moment.","error_tv_package_extras":"Sorry, we’re unable to retrieve your TV service details at the moment. Please <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=17&lctc=17%7C01%7Cws%7Cretrieve_services_error_en' target='_blank'>chat</a> with a Care Representative for assistance.","error_no_server_interaction":"Sorry, we’re unable to retrieve your services details at the moment. Please <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?hm=n&s=701' target='_blank'>chat</a> with a Care Representative for assistance.","new_to_my_rogers_mark":"New to MyRogers<sub><small class='white'>TM</small></sub>?","new_to_my_rogers":"New to MyRogers","your_new_plan_label":"Your New Plan","previous_plan_label":"Your Previous Plan","talk_to_us_now":"Talk to us now with Live Chat","ppc_something_went_wrong_message_title":"Sorry, Something Went Wrong.","ppc_something_went_wrong_message_text":"We’re working on fixing it as quickly as we can. Your price plan changes have not been saved. <br/> Please check back in a few minutes.","forgot_username":"Forgot Username","forgot_password":"Forgot Password","reset_password":"reset password","link_account":"Link Account","learn_more":"Learn More","learn_more_about_Roam_Like_Home":"Learn more about Roam Like Home","close":"Close","more":"More","travel_options":"Roaming Options","us_europe":"US & Europe","you_have_this":"You have this","use_your_phone_like_you_do_at_home":"Roam Like Home while travelling in over 100 destinations. Only","rlh_use_your_phone_like_you_do_at_home":"While travelling in over 100 destinations. Only","in_the_us":" in the U.S. and ","in_other_countries":" in all other eligible destinations!","enroll":"Enroll","activate_now":"Activate now","rome_like_home":"Roam Like Home<sub>TM</sub>","activating_roam_like_home":"Enroll in <b>Roam Like Home</b>","while_in_the_us":"While in the U.S., you will be charged","for_each_day_you_use":" for each day you use your phone.","while_in_europe":"While in Europe, you will be charged","are_you_sure_activate_roam":"Ready to enroll in <b>Roam Like Home</b>?","no_dont_activate":"NO THANKS, GO BACK","yes_activate":"YES, ENROLL","visit_billing_support":"Visit Billing Support","need_help_with_your_bill":"Need help with your bill","rlh_confirm_modal_msg":"<p>With <b>Roam Like Home<sub>TM</sub></b>, you can use your phone like you do at home.</p><p>Use the data, talk and text included in your wireless monthly plan in over 100 destinations around the world for only $7/day when roaming in the U.S. and $12/day when roaming in all other eligible destinations.</p>","ensure_roaming_is_on":"Make sure roaming is turned on before using.","remember_you_will_need_to_enroll":"If you’re travelling in any other included destination around the world, you’ll be charged $12/day* up to a maximum of 15 days when roaming.","go_ahead_roam_on":"<b>Roam Like Home<sub>TM</sub></b> lets you use the Data and Unlimited Talk and Text from your <b>Share Everything<sub>TM</sub></b> plan when you’re travelling, just like you do at home.","unlimted_talk_and_text":"Unlimited talk and text to Canada and within the eligible country you’re visiting","data_from_your_plan":"Data from your plan","wireless_rerating_message":"We’re sorry. Since you recently changed your plan, we can’t display your usage details right now. However, your details will be available again within 48 hours. Please try again then.","while_you_are_travelling":"If you’re travelling in the U.S., it's only $5/day* up to a maximum of 10 days when roaming.","travel_package_fail_msg":"Sorry, we’re having issues enrolling you right now. If this problem continues, please text travel to 222 to enroll.","brite_bill_title":"View Bill","bb_error_message":"Sorry, your bill is unavailable at the moment. Please try again later. Thank you.","bb_error_message_header_no_bill":"Thanks for choosing Rogers!","bb_error_message_no_bill":"Your first bill will be posted here after your billing cycle end date of {{date}}.","bb_error_message_header_system_issue":"Sorry, we are unable to display your bill at the moment.","bb_error_message_header_system_issue_rep":"We are unable to display the bill at this time.","bb_error_message_system_issue":"Try refreshing the page, or call 1-877-559-5202 for immediate assistance.","return_to_account_overview":"Return to Account Overview","bb_download":"Save this bill as","bb_pdf":"PDF","view_bill_before":"View bills before","view_bill_for":"View Bills","view_billing_date":"Your billing date:","less_complicated_bill":"A Less Complicated, Easier-to-Read Bill.","understand_your_bill":"We've made it easier for you to understand your charges - all while tailoring your bill to better suit your needs.  Let us show you.","skip_video":"Skip Video","watch_video":"Watch Video","june_1":" June 1, 2015","rto_Message":"You’ve completed your Rent to Own payments for this digital box.  You now own it!","secret_answer_validation":"Please answer your password reset question. Your answer can contain letters, numbers, and special characters.","secret_question_select":"Please choose a password reset question from the drop-down list.","email_validation":"Please enter a valid email address","contact_number_1_validation":"Please enter your 10-digit phone number without any spaces or extra characters.","contact_number_2_validation":"Please enter your 10-digit business phone number without any spaces or extra characters.","contact_number_2_extension_validation":"Business phone number extension should be 1 to 4 digits.","general_error":"Sorry, something went wrong. We’re working on fixing it as quickly as we can. Please check back in a few minutes.","_add_remove_accounts":"ADD/REMOVE ACCOUNTS","_self_serve_only":"Self-serve only","_add_account":"Add Account","_account_#":"Account #","_remove_account":"Remove Account","_want_add_account":"Want to add an account?","_account_removal_confirmation_heading":"Account Removal Confirmation","_account_removal_confirmation_message":"You are about to remove the account shown below. You can add or re-link accounts to your profile at any time.","_account_removal_confirmation_accountname":"Account Name:","_account_removal_confirmation_accountnumber":"Account Number:","_account_removal_error_msg":"Sorry! It seems something went wrong on our end. A client care rep is available to help on","_account_removal_success_msg":"Well done! You’ve successfully removed your account.","StreetNumber":"Number","StreetName":"Street Name","StreetType":"Type","AptNumber":"Apt Number","_Type":"Type","ebill":"eBill","Apartment":"Apartment","Bureau":"Bureau","Floor":"Floor","Penthouse":"Penthouse","Suite":"Suite","Unit":"Unit","ABBEY":"ABBEY","ACRE":"ACRE","ALLEY":"ALLEY","ANNEX":"ANNEX","AVE":"AVE","BAY":"BAY","BEACH":"BEACH","BEND":"BEND","BLDNG":"BLDNG","BLOCK":"BLOCK","BLVD":"BLVD","BRDG":"BRDG","BURN":"BURN","BYPASS":"BYPASS","BYRON":"BYRON","BYWAY":"BYWAY","CAMPU":"CAMPU","CAPE":"CAPE","CHASE":"CHASE","CIR":"CIR","CIRCT":"CIRCT","CLIFF":"CLIFF","CLOSE":"CLOSE","COMMO":"COMMO","CONN":"CONN","COURT":"COURT","COVE":"COVE","CRES":"CRES","CRNRS":"CRNRS","CROSS":"CROSS","CTR":"CTR","CURVE":"CURVE","DALE":"DALE","DELL":"DELL","DIVER":"DIVER","DOWN":"DOWN","DR":"DR","END":"END","ESPL":"ESPL","ESTAT":"ESTAT","EXPY":"EXPY","EXTEN":"EXTEN","FARM":"FARM","FIELD":"FIELD","FORES":"FORES","FRONT":"FRONT","FWY":"FWY","GARD":"GARD","GATE":"GATE","GDNS":"GDNS","GLADE":"GLADE","GLEN":"GLEN","GREEN":"GREEN","GRNDS":"GRNDS","GROVE":"GROVE","GTWAY":"GTWAY","HALL":"HALL","HARBR":"HARBR","HEATH":"HEATH","HEIGH":"HEIGH","HGHLD":"HGHLD","HILL":"HILL","HOLLO":"HOLLO","HTS":"HTS","HWY":"HWY","IMP":"IMP","ISLAN":"ISLAN","JARD":"JARD","KEEP":"KEEP","KEY":"KEY","KNOLL":"KNOLL","LAKE":"LAKE","LANDN":"LANDN","LANE":"LANE","LAWN":"LAWN","LINE":"LINE","LINK":"LINK","LKOUT":"LKOUT","LMTS":"LMTS","LOOP":"LOOP","MAIN":"MAIN","MALL":"MALL","MANOR":"MANOR","MARKE":"MARKE","MAZE":"MAZE","MEADO":"MEADO","MEWS":"MEWS","MIN12":"MIN12","MOOR":"MOOR","MOUNT":"MOUNT","MTN":"MTN","ORCH":"ORCH","PARAD":"PARAD","PARC":"PARC","PARK":"PARK","PASS":"PASS","PATH":"PATH","PINES":"PINES","PKY":"PKY","PLACE":"PLACE","PLAT":"PLAT","PLAZA":"PLAZA","PLWAY":"PLWAY","POINT":"POINT","PRKRD":"PRKRD","PROM":"PROM","PTWAY":"PTWAY","PVT":"PVT","QUAY":"QUAY","RANG":"RANG","RANGE":"RANGE","RDPT":"RDPT","RIDGE":"RIDGE","RISE":"RISE","ROAD":"ROAD","ROUTE":"ROUTE","ROW":"ROW","RUE":"RUE","RUN":"RUN","SEAWK":"SEAWK","SQ":"SQ","ST":"ST","SUBDI":"SUBDI","TERR":"TERR","THICK":"THICK","TLINE":"TLINE","TOWER":"TOWER","TRAIL":"TRAIL","TRLWA":"TRLWA","TRNAB":"TRNAB","VALE":"VALE","VALLE":"VALLE","VIEW":"VIEW","VILLA":"VILLA","VILLG":"VILLG","VISTA":"VISTA","WALK":"WALK","WAY":"WAY","WHARF":"WHARF","WKWAY":"WKWAY","WOOD":"WOOD","WYND":"WYND","direct_mail":"Direct Mail","telemarketing":"Telemarketing","text_message":"Text Message","none":"None","apply_these_settings":"Apply these settings to all services","_save_changes":"Save Changes","billing_bottom_info":"<strong>Please Note: </strong> Hardware updates cannot be made for 30 days after a billing address has been updated or changed.","mailing_address":"Mailing Address","_correct_as_per_canada_post":"Please use correct as per Canada Post provided below","_as_per_canada_post":"As per Canada Post","_as_entered":"As entered","_submit_address_as_entered":"Submit address as entered","_submit_canada_post_address":"Submit Canada Post address","tv":"TV","rogers_home_phone":"Rogers Home Phone","let_us_know_how_you":"Let us know how you'd like to be contacted.","add_account":"Add Account","verify_address_general_error":"The address you entered doesn’t match Canada Post’s records. Please enter a valid address.","valid_postal_code":"Please enter a valid postal code with no spaces.","paper_bill_title":"Paper Billing","paper_bill_success_1":"We’ll mail your bill out at the beginning of your next billing cycle, so please make sure the billing address on file is correct.","paper_bill_success_2":"Select Online Billing to get your bills sent directly to your email inbox.","online_bill_title":"Online Billing","online_bill_success_1":"Thank you for thinking of the environment and helping us reduce our carbon footprint.","online_bill_success_2":"You’ve selected online billing, so don’t forget to check your email for your monthly statements.","marketing_permissions_info":"If Rogers isn’t your wireless service provider and you have chosen to have Rogers contact you via text message, you may incur text message charges from your service provider.","yes":"Yes","no":"No","resume":"Resume","cancel_changes":"Cancel Changes","bonus":"Bonus","bonus_text":"FREE for the first month","price_plan_change_error":"Plan Change Error","price_plan_change_error_msg":"Changing your plan will result in you exceeding your credit limit. Please call 1 855 720-9038 so we can help you find a plan that’s right for you.","date_of_agreement":"Date Of Agreement","no_email_error":"You’ve selected online billing, please enter a valid email address.","street_name_error":"Please enter your street name. It must be 30 characters or fewer.","street_number_error":"Please enter your street number. It must be 10 characters or fewer.","street_number_error_char":"Please enter a valid street number.","apartment_number_error_char":"Please enter a valid apartment number.","valid_city_name":"Please enter a valid city name.","shm_msg":"<div>Order through <strong>Oasys</strong></div><div class='green-text'><strong>To book in-home assessment:</strong></div><div>Log in to <strong>SGI</strong></div>","login":"Log in","sgi":"SGI","order_though_oasys":"Order through <strong>Oasys</strong>","oasys":"Oasys","to_reserve_device":"To reserve a device:","my_rogers":"MyRogers","customer_log_in":"customer log in","plan":"Plan","ssp":"SSP","to":"to","ssp_dashboard":"SSP Dashboard","modem":"Modem","to_check":"To Check","to_upgrade":"To Upgrade","to_manage":"To Manage","to_change":"To Change","package":"Package","extras":"Extras","theme_packs":"Theme Packs","channels":"Channels","digital_box":"Digital Box","outlets":"Outlets","digital_pin":"Digital Pin","to_reset":"To Reset","v21":"V21","add_ons":"Add-ons","phone_number":"Phone Number","sim_card":"SIM Card","Price Plan":"","device":"Device","balance":"Balance","profile_popup_body_title":"To change a customer's account information:","if_the_customer_has_a_wireless_product":"If the Customer has a Wireless product:","if_the_customer_has_only_residential_products":"If the Customer has only Residential products:","you_will_need_to_go_to_v21_or_ssp":"You'll need to go to V21 or SSP","you_will_need_to_go_to_sgi":"You'll need to go to SGI","to_pay_a_bill":"To pay a bill","if_you_are_at_call_center_go_to_v21":"If you're at the call centre, go to V21","if_you_are_at_call_center_go_to_sgi":"If you're at the call centre, go to SGI","if_you_are_at_retail_location_use_a_pos":"If you’re at a retail location, use a POS","service_shm":"shm","billing_title":"Billing","login_to":"Log in to","device_balance":"Device Balance","access_error_title":"You do not have permission to access OneView.","access_error_msg":"Please contact your manager to arrange access.","service_error":"Sorry, this customer account cannot be serviced in OneView.","sso_error_title":"Unable to Sign On","sso_error_msg":"An error occurred while trying to log in. Please return to ICM/SSP and launch MyRogers again.","to_update_customer_payment_method":"To update a customer’s payment method:","if_you_are_at_retail_location_go_to_ssp":"If you’re at a retail location, go to SSP","unable_to_sign_on":"Unable to Sign On","sso_failure_description":"An error occurred while trying to log in. Please return to ICM/SSP and launch MyRogers again.","acc_overview_account_overdue_one_view_care":"<span class=\"error-type\">ACCOUNT SUSPENDED</span><span class=\"error-message-suspended\"> To restore services, <a href=\"JavaScript:void(0);\" ng-click=\"ao.payBillSuspended()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\">take a payment</a> for the outstanding balance.</span>","acc_overview_account_overdue_one_view":"<b>This account is currently suspended.</b><br/>If there is an overdue balance, making a payment may instantly restore your full MyRogers<sub><small><small>TM</small></small></sub> account information.","business":"BUSINESS","log_in_to_sgi":"Log in to <strong>SGI</strong>","log_in_to_oasys_or_ssp":"Log in to <strong>Oasys</strong> or <strong>SSP</strong>","log_in_to_telli":"Log in to <strong>Telli</strong>","price_plan":"price plan","login_to_v21":"Log in to <strong>V21</strong>","generic_error_title":"An Error Occurred","generic_error_message":"Your information is currently not available. Please try again.","business_access_failure_message":"The Business account you’re trying to launch cannot be viewed in Oneview due to permission restrictions.","business_access_failure_alert":"ALERT:","fido_access_failure_message":"The Fido account you’re trying to launch cannot be viewed in Oneview due to permission restrictions.","fido_access_failure_alert":"ALERT:","session_timeout_error_title":"Session Expired","session_timeout_error_message":"Your session has timed out. Please return to <strong>ICM</strong> and launch MyRogers again.","top_up_now":"Top Up Now","top_up_now_body":"<p>If you're in Care, please go to the Prepaid Transaction Management Application (PTMA).</p><p>If you're in Retail, please return to SSP in order to complete this transaction</p>","make_account_changes":"Make Account Changes","make_account_changes_body":"<p>If you're in <strong>Care</strong>, go to Prepaid Transaction Management Application (PTMA).<p><p>If you're at a <strong>retail location</strong>, have the customer call <strong>1-800-575-9090</strong>.</p>","roam_like_home_pop_up_title":"<strong>Roam Like Home</strong>","roam_like_home_pop_up_message":"Please instruct customer to text <strong>travel</strong> to <strong>222</strong>.","concurrent_update_ok":"Ok","concurrent_update_message_title":"Updates in progress","ppc_concurrent_update_message_text":"There are updates for this plan change already in progress.  Please re-start the flow.","hup_concurrent_update_message_text":"There are updates for this upgrade already in progress.  Please re-start the flow.","page_loading_splash_message":"Your services are loading.<br>Thanks for your patience!","204_title":"Sorry, Something Went Wrong.","204_text":"We’re working on fixing it as quickly as we can. In the meantime, we’ve saved your selections so you can call customer care or use our Live Chat to help finish your order.<br/><br/>Please use reference #122343444.<br/><div class='ppc-confirm-leave-modal' ><div class='ppc-modal-section' ><span><img src='images/live-chat-red-icon.png' /></span><a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank' >Live Chat</a></div><div class='ppc-modal-section' ><span><img src='images/phone-red-icon.png' /></span><a href='tel:18557209038' >1 855 720 9038</a></div></div>","_your_plan":"Your Plan","value_packs":"Value Packs","modal_thank_you_registration_headline":"MyRogers registration is complete!","modal_thank_you_registration_join":"Join the Rogers Community Forum","modal_thank_you_registration_info":"Get great Rogers tips, share ideas, and chat with Rogers employees and other Community members in our Community Forums!","modal_thank_you_registration_later":"GO TO MYROGERS","modal_thank_you_registration_community":"JOIN THE FORUMS","report_issue":"Report Issue","ppc_have_saved_order":"You started a price plan change and saved it.","hup_have_saved_order":"You started a hardware upgrade and saved it.","interaction":"INTERACTIONS","interaction_started":"Active, Started at ","interaction_at":"at","interaction_ticket":"TICKET","wireless_manage-plan_change-sim_dealer":"Change SIM/IMEI","wireless_manage-device_voicemail-password_dealer":"Reset Voicemail","change_phone_number":"Change Phone Number","change_phone_number_success_message":"<b>Success!</b> The customer’s phone number change was completed.","change_phone_number_error_message":"<b>Sorry,</b> the customer’s phone number change failed.","change_sim_success_message":"<b>Success!</b> The customer’s SIM/IMEI change was completed.","change_sim_error_message":"<b>Sorry,</b> the customer’s SIM/IMEI change failed.","change_plan_success_message":"<b>Success!</b> The customer’s plan change was completed.","change_plan_error_message":"<b>Sorry,</b> the customer’s plan change failed.","manage_addon_success_message":"<b>Success!</b> The customer’s add-on change was completed.","manage_addon_error_message":"<b>Sorry,</b> the customer’s plan change failed.","reset_voicemail_success_message":"<b>Success!</b> The customer’s voicemail reset was completed.","reset_voicemail_error_message":"<b>Sorry,</b> the customer’s voicemail reset failed.","device_upgrade_success_message":"<b>Success!</b> The customer’s device upgrade was completed.","device_upgrade_error_message":"<b>Sorry,</b> the customer’s device upgrade failed.","add_a_line_success_message":"<b>Success!</b> The customer’s add a line was completed.","add_a_line_error_message":"<b>Sorry,</b> the customer’s add a line failed.","hup_cancellation_success_message":"<b>Success!</b> The customer’s HUP cancellation was completed.","hup_cancellation_error_message":"<b>Sorry,</b> the customer’s HUP cancellation failed.","get_wireless_success_message":"<b>Success!</b> The customer’s wireless service was added.","get_wireless_error_message":"<b>Sorry,</b> the customer’s add wireless service failed.","acc_balance_colon":"Account Balance:","last_bill_colon":"Last Bill:","user_view":"User view","customer_view":"Customer View","rep_view":"Rep View","welcome":"Welcome","welcome_comma":"Welcome, ","sign_out":"Sign out","search_nova":"Go To Nova","content_currently_unavailable":"Content currently unavailable.","actions_and_offers":"ACTIONS &amp; OFFERS","ending":"Ending","cycle_ends_in":"Cycle ends in ","days":"days","interaction_history_not_available":"We couldn’t retrieve this customer’s interaction history.","internet_swap_modem":"Swap Modem","internet_tech_support":"Tech Support","reset":"Reset","hup_cancellation":"HUP Cancellation","hup_cancellation_desc":"For HUP Cancellations we're automatically taking you over to the appropriate screen in SSP.","coverage_maps":"Coverage Maps","add_outlets":"Add Outlets","filter_interactions":"Filter interactions:","filter_all":" All","filer_tickets":"Tickets","filer_retail":"Retail","filer_care":"Care","interaction_notes_topics":"INTERACTION NOTES & TOPICS","account_transactions_activities":"Account Transactions/Activities Performed","result":"Result","product_line":"Product Line","topic1":"Topic 1","save":"Save","error_filter_all":"There have been no customer interactions in the last 90 days.","error_filter_cases":"There have been no customer tickets in the last 90 days.","error_filter_care":"There have been no care interactions in the last 90 days.","error_filter_retail":"There have been no retails interactions in the last 90 days.","error_In_Retrieving":"We couldn’t retrieve this customer’s interaction history.","crm_signout_title":"Logged Out","crm_signout_message":"You have been logged out of OneView. Please return to SSP or ICM to log back in.","last_update_date":"Last upgrade /activation date:","balance_today":"Balance as of today","balance_will_be":"Balance will be","balance_was":"Balance was","zero_dollar_on":"$0 on: ","rv_customer_last_upgarde":"Last upgrade /activation date:","rv_customer_device_balance_will_be/was":"Device balance will be/was","rv_customer_device_balance_today_checkBalance":"Device balance (excluding Upfront Edge<sub><small class='black'>TM</small></sub> amount) as of today:","rv_customer_balance_desc_checkBalance":"This is your outstanding device balance, which is made up of the device subsidy you received when you purchased your current phone. It is separate from your Upfront Edge amount. Your device balance is being reduced in even amounts each month over the term you signed up for. If you wish to upgrade your device, you need to pay off the remaining device balance and settle your Upfront Edge amount. You can either keep your device and pay back the Upfront Edge amount, or you can return your device in good working condition, in which case you will not need to pay back the Upfront Edge amount. If you choose to return the device, your upgrade must take place within the second year of your term. See your Upfront Edge terms and conditions for details, including your Upfront Edge amount.","rv_customer_term_length_checkBalance":"Device balance term length:","rv_customer_balance_checkBalance":"Device balance:","rv_customer_monthly_deduction_checkBalance":"<b>Amount by which device balance decreases monthly:</b>","rv_upfrontAmount_desc":"This is your outstanding device balance, which is made up of the device subsidy you received when you purchased your current device. Your device balance is being reduced in even amounts each month over the term you signed up for. If you wish to upgrade your device, you need to pay off the remaining device balance.","rv_upfrontAmount_desc_sec":"Your Device Balance is separate from your Upfront Edge amount. The Upfront Edge amount is the amount of upfront device savings you received by agreeing to return your device in good working condition in 2-years.  If you wish to upgrade your device, you need to pay off the remaining device balance and settle your Upfront Edge amount. You can either keep your device and pay back the Upfront Edge amount, or you can return your device in good working condition. See your Upfront Edge terms and conditions for details.","rv_upfrontAmount_monthly_deduction_checkBalance":"Amount by which device balance decreases monthly:","rv_upfrontAmount_amount_message":"Upfront Edge<sub><small class='black'>TM</small></sub> amount:","rv_upfront_edge_amount":"Upfront Edge amount:","device_balance_today_checkBalance":"Balance as of today:","device_balance_will_be/was":"Balance will be/was ","flextab_balance_desc_checkBalance":"This is your outstanding FLEXtab device balance, comprised of the device subsidy you received when you purchased your existing phone. It is being reduced in even amounts each month over the term you initially signed up for. If you wish to upgrade today, all you need to do is pay off the remaining balance, of that subsidy.","flextab_monthly_deduction_checkBalance":"<b>Amount by which balance decreases monthly:</b>","flextab_term_length_checkBalance":"<b>FLEXtab device balance term length:</b>","flextab_balance_checkBalance":"<b>FLEXtab device balance:</b>","financing_balance_desc":"This is your outstanding Financing Program Device Balance, which is the amount you financed when you purchased your device, less any monthly Financing Program Monthly Payments. Your Financing Program Device Balance decreases monthly when you are billed for your Financing Program Monthly Payment. If you wish to upgrade early, all you need to do is pay off the remaining Financing Program Device Balance","financing_balance_desc_new":"This is your outstanding Financing Program Balance, which is the amount you financed when you purchased your device less any Financing Program Balance monthly payments. Your Financing Program Balance decreases monthly when you are billed for your Financing Program monthly payment. If you wish to upgrade early, all you need to do is pay off the remaining Financing Program Balance.","wireless_dashboard_device_financing_faq":"Learn more about the Financing Program Balance","financing_monthly_payment":"Financing Program Monthly Payment:","number_of_financing_monthly_payments":"Number of Financing Program Monthly Payments:","outstanding_financing_balance":"Financing Program Balance:","month_checkBalance":"/month","months_checkBalance":"months","is_not_eligible_device_upgrade_error_message":"You are not able to complete an upgrade at this time. Please contact us for more help.","is_not_eligible_device_upgrade_error_message_care":"You are not able to complete an upgrade at this time.","hup_errorCode_N_desc":"We're sorry, but you can't upgrade your device right now because you have an upgrade order pending.","hna_error_message":"To upgrade your device, please contact us","hna_contact_number":"1-855-720-9038","upgrade_device":"Upgrade Device","wireless_manage_device_checkBalance":"Check FLEXtab Device Balance","is_NFDB_check_error_message":"There seems to be a problem with the information we received. Please call the Rogers Validation Team at 1 800 588-6718 so we can help you out.","is_NFDB_check_error_message_care":"There is a fraud alert associated with this line. Please transfer the call to the fraud department.","is_NFDB_check_error_message_retail":"There is a fraud alert associated with this line. Please transfer the call to the fraud department.","is_NFDB_check_contact_Number":"1-800-588-6718","wireless_checkBalance_error":"Sorry, your device balance is not available at this time. We’re happy to help.","wireless_checkBalance_error_care":"Sorry, your device balance is not available at this time.","check_balance_toll_number":"1-855-720-9038","fraud_display_message":"Unfortunately the transaction cannot be completed as further validation is required. Please advise the customer to call 1-888-383-2080 for further assistance in completing their request.","credit_ops_display_message":"We are unable to complete your transaction at this time. Please advise the customer to call 1-800-551-5700 for further assistance in completing their request.","one_view_pay_as_you_go":"Pay As You Go","interactions_in_the_last_30_days":"Interactions in the last 30 days: ","c_interactions":"Interactions","c_class":"C Class: ","c_limit":"C Limit: ","c_available":"C Available: ","anniversary":"Anniversary: ","this_month":"This Month","billing_payment_body_agent":"<p>If you're in <strong>Care</strong>, please return to <strong>ICM</strong> in order to complete billing and payment changes.<p><p>If you're in <strong>Retail</strong>, please return to <strong>SSP</strong> in order to complete billing and payment changes.</p>","make_account_changes_body_agent":"<p>If you're in <strong>Care</strong>, go to Prepaid Transaction Management Application (PTMA).<p><p>If you're in <strong>Retail</strong>, you can make price plan, add-on and telephone number changes directly in SSP. If the customer asks to change their PIN, have them call <strong>1-800-575-9090</strong>.</p>","accType_consumer":"Consumer","accType_business":"Business","accType_government":"Government","accSubType_regular":"Regular","accSubType_non-revenue":"Non-Revenue","accSubType_prepaid":"Prepaid","accSubType_corporate":"Corporate","accSubType_federal":"Federal","accSubType_provincial":"Provincial","accSubType_municipal":"Municipal","accStatus_open":"Open","accStatus_active":"Active","accStatus_suspended":"Suspended","accStatus_cancelled":"Cancelled","accStatus_pending_disconnect":"Pending Disconnect","accStatus_pending_connection":"Pending Connection","show_more":"Show more","show_less":"Show less","language_toggle":"Français","one_view_reset_password":"Reset Password","reset_customer_password_title":"Reset Customer's Password","reset_password_message":"Click Continue to reset the customer’s password. They will be sent an email with a link prompting them to create a new password.","reset_password_sucess_message":"Success! Notify the customer that a password reset link was sent to","reset_password_error_message":"Sorry, but we couldn’t reset the password. If this problem persists, please have the customer get in touch with us using Live Chat.","guid_not_found_message":"We can’t reset this user’s password or change their billing type at this time. Please tell the customer to get in contact with us via Live Chat.","mppc_entry_3_title":"Since you’re adding another line to your <strong>Share Everything<sub>TM</sub></strong> plan, you may need to add more data to account for the extra usage. Would you like to add data to your plan?","mppc_entry_3_yes":"Yes","mppc_entry_3_no":"No","mppc_entry_3_or":"OR","mppc_entry_1_change_current_plan":"Make changes to your current plan","mppc_entry_1_create_shared_plan":"Create a shared plan with your other lines","mppc_entry_1_cancel":"Cancel","mppc_entry_3_change_current_plan":"Make changes to your existing plan","mppc_entry_3_change_wireless_plan":"Change your plan","mppc_entry_3_add_to_share_plan":"Add this line to your shared <strong>Rogers Infinite<sup>TM</sup></strong> plan","mppc_entry_3_cancel":"Cancel","mppc_shared_group_indiv_title":"Add your other lines to your <strong>Share Everything<sub>TM</sub></strong> plan","mppc_shared_group_indiv_switch_reason_1":"Shared data bucket","mppc_shared_group_indiv_switch_reason_2":"Unlimited talk and messaging according to your plan","mppc_shared_group_indiv_switch_reason_3":"Roam Like Home<sub>TM</sub>","mppc_shared_group_indiv_benefits":"What are the benefits?","mppc_shared_group_indiv_skip":"Skip this step &gt;","mppc_shared_group_primary_title":"Select a primary line for your new <strong>Share Everything<sub>TM</sub></strong> plan","mppc_shared_group_indiv_switch_reason_intro":"All your lines will share the features you enjoy:","hup_save_cart_offers_changed":"We're sorry, but our offers have changed. Your saved order is no longer valid. Please make a new selection to continue.","mppc_on_brt_no_permission_text":"To change your plan, please contact us:","care_semafone_success_msg":"Token Accepted. Select Expiry Date and Security Code.","care_semafone_error_msg":"Token Rejected. Need copy here.","interaction_medium_dept":"MEDIUM | DEPT","interaction_date":"DATE","interaction_product_line":"PRODUCT LINE","interaction_activities":"ACTIVITIES","interaction_results":"RESULTS","interaction_notes":"NOTES","interaction_rep_interaction_id":"CASE | INTERACTION ID","interaction_topic":"TOPIC","interaction_search_error":"Sorry, we couldn't find what you're looking for.","search-interaction":"Search","interaction_search_placeholder":"Medium, Dept, ID, Date, Product, Keyword","go_to_ssp":"Go to SSP","go_to_nova":"Go to Nova","reset_voicemail_password":"Reset Voicemail Password","change_sim":"Change SIM","weather_content_not_available":"Content currently not available.","share_everything_share":"Share Everything","rogers_infinite":"Rogers Infinite<sub>TM</sub>","share_everything_individual":"Individual Wireless","share_everything_residential":"Residential","share_everything_otherServices":"Other Services","share_everything_addServices":"Add More Services","ppc":"Price Plan Change","hup":"Hardware Upgrade","_my_cart":"My Shopping List","_saved_quotes":"My Quotes","_quote":"Quote #","_ctn":"CTN: ","_expired":"EXPIRED","nac":"Add a new line","oneview_takepayment_paybill":"Take A Payment","remind_the_customer":"Remind the customer:","oneview_change_method_intro":"They can subscribe to pre-authorized payments and enjoy the convenience of paying their Rogers bill automatically from their Canadian bank account or credit card every month.","_nickname_update_error_msg":"We're sorry, but we’re currently unable to process your new account nickname. Please try again later.","private_browsing_warning_msg":"<p><strong>To sign in, you'll need to turn off Private Browsing.</strong></p><p>Close this window and open a new one with Private Browsing turned off. Not sure how? <a target='_blank' href='https://support.apple.com/en-ca/HT203036'>Read these steps</a>.</p>","acc_overview_account_locked":"This customer has been locked out of their account because they failed too many login attempts. Would you like to unlock their access?","acc_overview_unlock":"Unlock >","account_unlock_success_message":"This customer’s account is now unlocked. Now you can send them an email with instructions to reset their password.","account_unlock_error_message":"Sorry, but we couldn’t unlock this account. Please try again.","account_unlock_customer_info":"<red>Account Locked</red> > Proceed to Overview or Profile Page to unlock","wireless_manage-device_oneview_suspend-services":"Suspend Services","wireless_manage-device_oneview_suspend-service":"Suspend Service","wireless_my_device":"My Device:","wireless_my_package":"My Package:","wireless_manage":"Manage","oneview_fraud_message":"Unfortunately the transaction cannot be completed as further validation is required. Please advise the customer to call 1-888-383-2080 for further assistance in completing their request.","oneview_credit_ops_message":"We are unable to complete your transaction at this time. Please advise the customer to call 1-800-551-5700 for further assistance in completing their request.","oneview_fraud_credit_ops_message_title":"Further Validation Required","oneview_head_to_oasys":"Head over to OASYS","oneview_create_bundlesfor":"To create bundles for:","oneview_digitaltv_legacy_internet":"Digital TV + Legacy Internet","oneview_tv_internet_homephone":"TV + Internet + Home Phone","oneview_leave":"You will need to leave OneView and continue transactions in Maestro","self_serve_payment_information_heading":"Payment Information","self_serve_change_payment_method":"Change payment method","self_serve_payment_method":"Payment method:","self_serve_invoice":"Monthly Invoice","self_serve_credit_card":"Pre-authorized Credit Card","self_serve_debit_card":"Pre-authorized Debit","self_serve_unavailable_mop":"Unavailable","self_serve_credit_card_text_template":"XXXX XXXX XXXX {{creditCardNr}}","self_serve_credit_card_exp_date_text_template":"Expires on {{date}}","self_serve_chequing_account_nr":"Bank Account Number:","self_serve_ways_to_pay":"You can pay your invoice :","self_serve_pay_online":"Online through MyRogers","self_serve_pay_via_app":"Using the MyRogers app","self_serve_pay_in_store":"In select Rogers stores","self_serve_pay_at_bank":"Through most banks","self_serve_pay_by_phone":"By calling us at 1 877 559-5202","self_serve_change_method_mail":"By mailing a cheque to Rogers, P.O. Box 9100, Don Mills ON, M3C 3P9","self_serve_cancel_change_mop":"Cancel","self_serve_change_mop_to":"Change to:","unable_to_complete_request":"We’re unable to complete your request.","ban_suspended_care":"This customer's account is currently suspended. They must make a payment to ensure their account is in good standing before they  can upgrade their device.","ban_suspended_first":"This customer's account is currently suspended. They must ","ban_suspended_last":"to ensure their account is in good standing before they  can upgrade their device.","ban_delinquent_first":"This customer has a delinquent account. They must ","ban_delinquent_last":"before they  can upgrade their device.","ban_delinquent_customer":"We’re sorry, but we can’t process your device upgrade request because your account is past due. <br /> <br /> Please make a payment for your past due balance and try upgrading your device again.","ban_delinquent_rep":"This device upgrade request can’t be processed because the customer’s account is delinquent with an outstanding balance.<br /> <br /> Please advise the customer that you can accept payment for the outstanding balance, and that the device upgrade can be processed immediately once a payment has been made.","ban_delinquent_care":"This customer has a delinquent account. They must make a payment before they  can upgrade their device.","error_ban_billing_address_care":"This account's address was updated within the past 30 days. We can't process a device upgrade for this customer until at least 30 days have passed after this update.","ban_cra_care":"This customer has a Corporately Reimbursed Account. Please transfer them to Business Care.","ctn_suspended_care":"This line has been suspended. The line must be reinstated in order to upgrade the customer's device.","error_ctn_activation_care":"This line was activated within the past 30 days. We can't process a device upgrade for this line until at least 30 days have passed.","error_ctn_last_hup_care":"Customers can only upgrade a device or activate a new line once every 30 days. Please wait until 30 days have passed from their last upgrade/line activation.","error_ctn_last_hup":"Customers can only upgrade a device or activate a new line once every 30 days. Please wait until 30 days have passed from their last upgrade/line activation.","error_ctn_pending_hup_care":"This line has a device upgrade or swap pending. We can't start another device upgrade until the current upgrade or swap is complete.","error_ctn_pending_port_in_care":"This line is still being ported in. We can't process a device upgrade for this number until the port-in is complete.","error_ctn_pending_port_in_consumer":"This line is still being ported in. We can't process a device upgrade for this number until the port-in is complete.","error_ctn_pending_bot_hup_care":"This line has a device upgrade pending that was sent to the Back Office Team. Please cancel the Back Office Team request.","error_ctn_pending_deactivation_care":"The device associated with this line can't be upgraded because this line will soon be deactivated.","fraud_alert_care":"There is a fraud alert associated with this line. Please transfer the call to the fraud department.","ban_suspended_retail":"This customer's account is currently suspended. They must make a payment to ensure their account is in good standing before they  can upgrade their device.","ban_delinquent_retail":"This customer has a delinquent account. They must make a payment before they  can upgrade their device.","error_ban_billing_address_retail":"This account's address was updated within the past 30 days. We can't process a device upgrade for this customer until at least 30 days have passed after this update.","error_ban_billing_address_customer":"We’re sorry, but we were unable to process your device upgrade because your account’s billing address was updated within the past 30 days.<br /> <br /> Please try again after more than 30 days since the address change have passed, or bring proof of the address change to <a href='/web/content/store-locator' target='_blank' >a nearby Rogers store</a> so that the device upgrade can be processed.","error_ban_billing_address_rep":"This device upgrade request can’t be processed because the account’s billing address was updated within the past 30 days. <br /> <br /> Please advise the customer to try again after more than 30 days since the address change have passed, or to bring proof of the address change to a nearby Rogers store so that the device upgrade can be processed.","ban_cra_retail":"This customer has a Corporately Reimbursed Account. Please transfer them to Business Care.","ctn_suspended_retail":"This line has been suspended. The line must be reinstated in order to upgrade the customer's device.","ctn_suspended_consumer":"This customer's account is currently suspended. They must make a payment to ensure their account is in good standing before they can upgrade their device.","error_ctn_activation_retail":"This line was activated within the past 30 days. We can't process a device upgrade for this line until at least 30 days have passed.","error_ctn_last_hup_retail":"Customers can only upgrade a device or activate a new line once every 30 days. Please wait until 30 days have passed from their last upgrade/line activation.","error_ctn_pending_hup_retail":"This line has a device upgrade or swap pending. We can't start another device upgrade until the current upgrade or swap is complete.","error_ctn_pending_port_in_retail":"This line is still being ported in. We can't process a device upgrade for this number until the port-in is complete.","error_ctn_pending_bot_hup_retail":"This line has a device upgrade pending that was sent to the Back Office Team. Please cancel the Back Office Team request.","error_ctn_pending_deactivation_retail":"The device associated with this line can't be upgraded because this line will soon be deactivated.","fraud_alert_retail":"There is a fraud alert associated with this line. Please transfer the call to the fraud department.","mop_title":"Change Payment Method","mop_change_from":"Change from:","mop_change_to":"Change to:","mop_summary_explanation_no_balance":"Payments will no longer be withdrawn automatically.","mop_summary_explanation_with_balance":"Payments will no longer be withdrawn automatically. Please make a payment before {{date}} to avoid late charges.","mop_update_payment_method_button":"Update Payment Method","mop_cancel_button":"Cancel","mop_credit_card_notice":"Keep in mind, it takes up to <strong>2 business days</strong> for the payment method update to take effect.","mop_change_type_R":" Monthly Invoice","mop_change_type_C":" Pre-authorized Credit Card","mop_change_type_D":" Pre-authorized Debit","mop_change_type_I":"...","mop_success_title":"Success!","mop_success_message_C":"Pre-authorized payments for your account are now set. The first payment withdrawal will take effect on your next bill. You’ll receive an email confirmation shortly.","mop_success_message_D":"Pre-authorized payments for your account are now set. The first payment withdrawal will take effect on your next bill. You’ll receive an email confirmation shortly.","mop_success_message_R":"Your payment method has been changed to Monthly Invoice. You’ll receive an email confirmation shortly.","mop_close":"Close","mop_failure_title":"Sorry…","mop_failure_message":"We’re not able to update your payment method at the moment. Please contact us and we’ll be happy to help.","mop_phone":"1-877-559-5202","mop_debit_card_notice":"Keep in mind, it takes up to <strong>2 business days</strong> for the payment method update to take effect.","mop_success_message_cd":"Please note that it takes 2 business days for the payment method change to be updated.","opt_out_rlh_reminder":"Customer Opt-Out Reminder:","opt_out_rlh_message_1":"When you opt-out of Roam Like Home, you'll be charged standard roaming rates if you use your phone while roaming:","opt_out_rlh_message_2":"<strong> U.S. $1.45/min. $0.75/text and $7.99/day up to 50 MB</strong>","opt_out_rlh_refer_nova":"(For all international rates, please reference <a href='http://nova.rogers.com/infocenter/index?page=tabs&tabsource=home&loadTemplate=Y'><strong>NOVA</strong> </a>for detailed pricing.)","opt_out_rlh_enroll":"Un-Enroll","opt_out_rlh_error":"Sorry we could not complete your request at this time.","revo_what_you_can_get":"What You Can Get","transfer_of_responsibility":"Transfer of Responsibility","take_payment":"Take A Payment","view_bill":"View Bill","update_payment":"Update Payment","customer_credit_management":"Customer Credit Management","eclipse_msg_header":"Leaving Overview","eclipse_msg_desc":"To view or make changes to the requested details, you'll need to leave OneView and access one of the following Systems:","eclipse_msg_igniteTv_details":"If you are not trained to manage Ignite TV & Internet Package, you'll need to transfer the customer to the appropriate   team. If you are, you'll need to head over to Maestro.","eclipse_msg_wireless_header":"Wireless","eclipse_msg_wirless_details":"You'll need to head over to v21 or SSP.","eclipse_msg_tv_header":"TV, Internet and Home Phone","eclipse_msg_tv_details":"You'll need to head over to SGI","eclipse_msg_smart_home_header":"Smart Home Monitoring","eclipse_msg_smart_home_details":"You will need to head over to Maestro","hup_errorCode_A_desc":"We're sorry, but you are currently ineligible for an upgrade. Your device balance is unavailable because a past-due balance is owing on your account.","hup_errorCode_FJ_desc":"We're sorry, but you are currently ineligible for an upgrade. Your device balance is unavailable because you have activated or upgraded to a new device within the last 30 days.","hup_errorCode_D_desc":"We're sorry, but you are currently ineligible for an upgrade. Your device balance is unavailable because your account is currently suspended.","hup_errorCode_L_desc":"We're sorry; you can't upgrade your device because there's a request to deactivate this line.","hup_errorCode_T_desc":"We're sorry, but you are currently ineligible for an upgrade as you have changed billing address within the last 30 days.","hup_errorCode_G_desc":"We're sorry; your device balance is currently unavailable","game_center_url":"https://secure.gamecentrelive.rogers.com/signin?lang=en","cancel_hup":"Cancel HUP","hup_wait_complete":"Wait for HUP to complete","ppccode_case_cancellation_request":"A cancellation request has been sent to the back office team.","hupcode_case_cancellation_request":"A request to cancel the plan change has been sent to the back office team.","ppc_bot_message_ppc":"There is already a plan change underway for this customer. If you proceed here, that will cancel the current request with the back office team. <br/><br/>Are you sure you want to change the customer’s plan?","ppc_bot_message_hup":"There is already a plan change underway for this customer. If you proceed here, that will cancel the current request with the back office team. <br/><br/>Are you sure you want to change the customer’s plan?","hup_bot_message_ppc":"There is currently a plan change in progress for this customer. If you proceed with the hardware upgrade here, it will cancel the plan change with the back office team. <br/><br/>Are you sure you want to proceed with the upgrade?","hup_bot_message_hup":"There is currently a plan change in progress for this customer. If you proceed with the hardware upgrade here, it will cancel the plan change with the back office team. <br/><br/>Are you sure you want to proceed with the upgrade?","bot_eligible":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","bot_eligible_care":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","bot_eligible_retail":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","see_discount_info_title":"","see_discount_info_message":"This discount applies to this line added to a <b>Share Everything<sub>TM</sub></b> plan with a 2-year term. This discount will end on the applicable expiry date.","oneview_myaccoverview_get_internet":"To view or make changes to the requested details, you'll need to leave OneView and access SGI.","oneview_myaccoverview_get_wireless":"To view or make changes to the requested details, you'll need to leave OneView and access v21 or SSP.","oneview_myaccoverview_get_tv":"To view or make changes to the requested details, you'll need to leave OneView and access SGI.","oneview_myaccoverview_get_phone":"To view or make changes to the requested details, you'll need to leave OneView and access SGI.","oneview_myaccoverview_get_monotoring":"To view or make changes to the requested details, you'll need to leave OneView and access Maestro.","oneview_myaccoverview_get_rogers_bank":"","addServices_addServices_modal_title":"Leaving Overview","maintenance_info_live_chat_params":{"id":"4396604018222699523","div":"S_Care_AccountOverview_EN","button":"btn_S_Care_AccountOverview_EN"},"error_wireless_usage_live_chat_params":{"id":"1693237502974470698","div":"S_Care_WirelessUsage_EN","button":"btn_S_Care_WirelessUsage_EN"},"_username_signin":"Enter your email or username here","_password_signin":"Enter your password here","_remember_me_signin":"Remember me","_pls_signin":"Please sign in","_forget_username":"Enter your email address here","home_phone_label":"View and manage home phone service","rgcl_signin_watch":"Explore","rgcl_alt_text":"Rogers NHL GameCentre LIVE","mu_registration_lg_new":"Why Register for MyRogers?","need_help_username":"Need help resetting your username?","forgot_username_live_chat_alt_text":"Chat with a Live Agent","payment_history_loader":"Loading Payment History","change_modem_alt_text":"Change my internet modem","change_number_alt_text":"Change my phone number","roam_like_home":"Roam Like Home","forgot_username_heading":"Retrieve username","signin_heading":"MyRogers sign in","view_bill_heading":"Billing & Payment Details","payment_history_heading":"Payment History","account_overview_heading":"Account Overview","maintenance_page_header":"<span>MyRogers is</span> <span>currently in</span> <span>maintenance mode.</span>","maintenance_page_error":"We are performing important system upgrades in order to improve your MyRogers experience, <span>so the page you’re trying to access is currently unavailable. Hang tight, we’ll be up again soon! Thanks for your patience.</span>","accType_tenant-pays-cable":"","home_phone_contact_care_liveChat":{"cbid_solaris":"3974490876656209478","dynamicDiv_solaris":"S_IgniteBDL_Overview_GetHomePhone_EN_DIV","chatButton_solaris":"S_IgniteBDL_Overview_GetHomePhone_EN","cbid_legacy":"8184114054586988154","dynamicDiv_legacy":"S_Overview_GetHomePhone_EN_DIV","chatButton_legacy":"S_Overview_GetHomePhone_EN","title":"Want to activate Home Phone?","description":"Please contact us and we’ll help you out.","phoneNumber":"1 888 764-3771"},"myaccoverview_restore_data_access":"Restore data access","myaccoverview_manage_who_can restore_data_access":"Manage who can restore data access","selfserve_manage_who_can_authorize":"Manage who can authorize additional charges when data access has been paused","selfserve_data_access":"Data access is paused when your account reaches $50 in data overage or $100 in roaming data charges in a single bill cycle.","selfserve_add_manage_data":"Add/Manage authorized users","oneview_bundlebuilder":"Offer Builder (in OASYS)","creditadjustment_recommended_amount":"Recommended amount based on days affected: ","creditadjustment_proceed_adjustment":"Proceed adjustment","creditadjustment_credit_management":"Credit management","creditadjustment_make_adjustment":"Make an adjustment","creditadjustment_adjustment":"Make adjustment","creditadjustment_select_service_for_adjustment":"Select the service for adjustment","creditadjustment_select_service":"Select service","creditadjustment_account_holder":"Account holder","creditadjustment_total_account_balance":"Total account balance","creditadjustment_plan_package":"Plan/Package","creditadjustment_monthly_charge":"Monthly charge","creditadjustment_recent_adjustments":"Recent adjustments:","creditadjustment_goodwill_credit_remaining":"Goodwill credit remaining:","creditadjustment_service_wireless_prepaid":"<i>PAY AS YOU GO<sup>TM</sup></i>","creditadjustment_service_wireless":"Wireless","creditadjustment_service_internet":"Internet","creditadjustment_service_tv":"TV","creditadjustment_service_monitoring":"Home Monitoring","creditadjustment_myaccoverview_home_monotoring":"Home Monitoring","creditadjustment_service_phone":"Home Phone","creditadjustment_adjustment_type":"Adjustment type","creditadjustment_select_adjustment_type":"Select adjustment type","creditadjustment_systemerror":"System Errors","creditadjustment_servicenetworkissue":"Service Network Issue","creditadjustment_servicenetworkerror":"Service Network Issue","creditadjustment_error_promise_broken":"Error made/promise broken","creditadjustment_policyadjustment":"Policy Adjustment","creditadjustment_policyissue":"Policy Adjustment","creditadjustment_goodwillcredit":"Goodwill Credit","creditadjustment_documentederrororpromise":"Transaction Service Error","creditadjustment_undocumentederrororpromise":"Undocumented Error or Promise","creditadjustment_errormade/promisebroken":"Error made/promise broken","creditadjustment_select_adjustment_situation":"Select the adjustment type that best applies to customer’s situation.","creditadjustment_date":"Date","creditadjustment_amount":"Amount","creditadjustment_feature_code":"Feature Code","creditadjustment_soc_code":"SOC Code","creditadjustment_soc_description":"SOC Description","creditadjustment_notes":"Notes","creditadjustment_goodwill_notes":"Customer can get a maximum goodwill credit of $25 or 50% of their current plan’s regular monthly fee(whichever is lower). This can be applied every 6 months per Wireless number or residential account. Go to customer’s A/R History in SGI/V21 to review any goodwill credit applied to account in past 6 months.","creditadjustment_interactionIdTooltip":"Please go into ICM to find the Interaction ID.","creditadjustment_known_error":"If it‘s a known system error, select it from the list below.","creditadjustment_unknown_error":"Don’t see the system error listed?","creditadjustment_select_policy":"Select a policy issue from the list below.","creditadjustment_unknown_policy":"Don’t see the policy issue listed?","creditadjustment_known_issue":"If it‘s a known issue, select it from the list below.","creditadjustment_unknown_issue":"Don’t see the issue listed?","creditadjustment_days_affected":"Days affected","creditadjustment_create_interaction":"Create interaction","creditadjustment_icm_case_id":"ICM Case ID*","creditadjustment_amount_mandatory":"Amount*","creditadjustment_amount_is_required":"Amount is required","creditadjustment_approver_is_required":"Approver is required","creditadjustment_approver_required_for_amount":"Required for amount greater than","creditadjustment_approver_required_amount_greater":"Team  manager approval  required  for  amount  greater than $100","creditadjustment_approver_required_amount_greater_gw":"Team  manager approval  required  for  amount  greater than","creditadjustment_interactionid_is_required":"Interaction ID is required","creditadjustment_empid_is_required":"Employee/Agent ID is required","creditadjustment_icm_is_required":"ICM Case Id is required","creditadjustment_max_allowed":"Maximum allowed:","creditadjustment_recent_adjustments_period":"Credit applied in past 6 months:","creditadjustment_cancel":"Cancel","creditadjustment_approver":"Approver","creditadjustment_apply_adjustment_in_v21":"Apply adjustment in V21","creditadjustment_apply_adjustment_in_sgi":"Apply adjustment in SGI","creditadjustment_auto_adjustment":"This adjustment will be applied automatically at the end of customer’s current billing cycle.","creditadjustment_interaction_id":"Interaction ID","creditadjustment_interaction_id_mandatory":"Interaction ID*","creditadjustment_find_interaction_id":"Find Interaction ID","creditadjustment_adjustment_not_applied":"Adjustment not applied","creditadjustment_unfortunate_adjustment":"Unfortunately, this adjustment cannot be applied.","creditadjustment_back":"Back","creditadjustment_done":"Done","creditadjustment_details":"Details","creditadjustment_adjustment_reviewed_title":"Adjustment being reviewed for approval","creditadjustment_adjustment_reviewed_description":"This adjustment is being reviewed for approval by <First name last name>. If approved the adjustment will be applied to the customer’s account.","creditadjustment_interaction_created":"Interaction created","creditadjustment_interaction_created_details":"An interaction with the following details has been created:","creditadjustment_use_following_codes":"Use the following adjustment code(s):","creditadjustment_tooltip_header":"Make an adjustment","creditadjustment_empid_agent":"Person number of agent involved in Transaction Service error","creditadjustment_tooltip_details":"Select the adjustment type that best applies to customer’s situation.","creditadjustment_tooltip_icm":"Create a case in ICM and record the ICM Case ID in this field.","creditadjustment_cancelled":"(cancelled)","creditadjustment_cancelled_message":"This {{service}} {{serviceDetail}} has been cancelled.","internet_do_no_show_msg":"Do not show this message again","offers_for_you":"Exclusive offers for you!","upgrade_your_device":"Upgrade your device","add_additional_line_error":"Please select a phone number to continue","select_a_number":"Please select a phone number","cant_process_request":"We can’t process this request","employee_discount_line":"This is an employee line. Please transfer the customer to the Employee Discount Line to complete the change.","ppccode_500":"We're sorry, but something went wrong. Please try again later or contact us to continue.","ppccode_delinquent_account":"We're sorry, but you can't change your plan right now because a past-due balance is owing on your account.","ppccode_not_postpaid":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_not_open":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_over_clm":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_sub_completed_ppc_in_cur_bill_cycle":"n/a","ppccode_sub_not_active":"We're sorry, but you can't change your plan right now because your account is currently suspended.","ppccode_sub_pending_cancellation":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_sub_pending_hup_order":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_sub_pending_ppc_order":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_main_pending_ppc":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_main_pending_hup":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_main_pending_can":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_adl_pending_ppc":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_adl_pending_hup":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_adl_pending_can":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_indl_pending_ppc":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_indl_pending_hup":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_indl_pending_can":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_500_care":"We're sorry, but something went wrong. Please try again later.","ppccode_delinquent_account_care":"We're sorry, but you can't change your plan right now because a past-due balance is owing on your account.","ppccode_not_postpaid_care":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_not_open_care":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_over_clm_care":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_sub_completed_ppc_in_cur_bill_cycle_care":"n/a","ppccode_sub_not_active_care":"We're sorry, but you can't change your plan right now because your account is currently suspended.","ppccode_sub_pending_cancellation_care":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_sub_pending_hup_order_care":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_sub_pending_ppc_order_care":"There is a future dated Price Plan change pending for this account","ppccode_ml_main_pending_ppc_care":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_main_pending_hup_care":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_main_pending_can_care":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_adl_pending_ppc_care":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_adl_pending_hup_care":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_adl_pending_can_care":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_indl_pending_ppc_care":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_indl_pending_hup_care":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_indl_pending_can_care":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_500_retail":"We're sorry, but something went wrong. Please try again later.","ppccode_delinquent_account_retail":"We're sorry, but you can't change your plan right now because a past-due balance is owing on your account.","ppccode_not_postpaid_retail":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_not_open_retail":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_over_clm_retail":"We're sorry, but you can't change the plan for this line. Please contact us to continue.","ppccode_sub_completed_ppc_in_cur_bill_cycle_retail":"n/a","ppccode_sub_not_active_retail":"We're sorry, but you can't change your plan right now because your account is currently suspended.","ppccode_sub_pending_cancellation_retail":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_sub_pending_hup_order_retail":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_sub_pending_ppc_order_retail":"There is a future dated Price Plan change pending for this account","ppccode_ml_main_pending_ppc_retail":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_main_pending_hup_retail":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_main_pending_can_retail":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_adl_pending_ppc_retail":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_adl_pending_hup_retail":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_adl_pending_can_retail":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ppccode_ml_indl_pending_ppc_retail":"We're sorry, but you can't change your plan right now because you already have a plan change pending.","ppccode_ml_indl_pending_hup_retail":"We're sorry, but you can't change your plan right now because you have an upgrade order pending.","ppccode_ml_indl_pending_can_retail":"We're sorry, but you can't change your plan right now because you have an account cancellation pending.","ctn_change_excceded":"You are unable to change your phone number right now because the maximum limit of 5 changes per month has been reached. Please try again later.","ctn_excceded_header":"Exceeded Limit","orders":"ORDERS","order_creation_date":"ORDER DATE","order_type":"ORDER TYPE","order_product":"PRODUCT (or)","order_product_type":"PRODUCT TYPE","order_service_num":"CTN/","order_service_addr":"Address","order_plan_sku":"SKU/","order_plan_product_num":"SOC","order_description":"DESCRIPTION","order_description_text":"Subscriber level PP changed from {{oldSOCCode}} to {{newSOCCode}} {{productDescription}}","order_status":"STATUS","order_effective_date":"Start Date","order_price_plan":"Price Plan Change","order_pending":"Pending","order_wireless":"Wireless","order_no_orders":"Sorry, no orders to display at this time.","order_filter":"Choose:","order_ppc_filter":"Post-dated Price Plan Change","order_wireless_order":"Wireless Orders","order_clear_filter":"Clear filters","order_msg_on_empty_filters":"Please select from the checkboxes (above) to view orders.","order_Order_Created_in_System":"Order Created In System","order_Order_Received_at_Warehouse":"Order Received At Warehouse","order_Ready_to_be_Shipped":"Ready To Be Shipped","order_Shipped_to_Customer":"Shipped To Customer","order_Order_Delivery_Complete":"Order Delivery Complete","order_Backordered":"Backordered","order_Awaiting_Return":"Awaiting Return","order_Cancelled":"Cancelled","wireless_order_ctn":"CTN/","wireless_order_ctn_expand":"Contact Phone Number","wireless_order_itemno":"Item Number","wireless_order_description":"Description","wireless_order_line_status":"Line status","wireless_order_on_hold":"On Hold","wireless_order_amount_ordered":"Quantity ordered","wireless_order_amount_shipped":"Quantity Shipped","wireless_order_serialno":"Serial number/","wireless_order_imei":"IMEI","wireless_order_last_updated":"Last updated Date","wireless_order_ship_date":"Ship date","wireless_order_way_bill":"Waybill","exclusive_offer":"EXCLUSIVE OFFER","_alert":"ALERT","_error":"ERROR","ignite_nac_ram_permission_missing":"You do not have permission to access Rogers Ignite bundle activations. ","ignite_nac_generic_error":"Sorry, there’s a problem on our end. Thanks for your patience while we work to fix it. Please check back later.","ignite_nac_contact_info_missing":"The following is missing from the customers’ contact information. Please update: ","ignite_missing_info_first_name":"First name","ignite_missing_info_last_name":"Last name","ignite_missing_info_phone_number":"Phone number","ignite_missing_info_email":"Email address","ignite_missing_info_language_pref":"Language preference","ignite_customer_information_missing":"Customer Information is Missing","start_track_phone_repair":"Start or track a phone repair claim","trackRepairClaim":{"continue_alt_text":" Continue to the site","close_alt_text":"Go back to MyRogers","heading":"Get help for your phone","body":"You will now be taken to a different site to help you find a solution for any problems you’re experiencing with your phone. After this, you may need to sign into MyRogers again to view further details in your account."},"internet_usage_post_to_url_links":{"internet_view_history":"/web/myrogers/torcom/internetUsage/ViewUsageHistory?setLanguage=en-CA","internet_usage_alerts":"/web/myrogers/torcom/internetUsage/ViewUsageAlerts?setLanguage=en-CA","internet_daily_usage":"/web/myrogers/torcom/internetUsage/DailyUsage?setLanguage=en-CA","internet_monthly_usage":"/web/myrogers/torcom/internetUsage/MonthlyUsage?setLanguage=en-CA"},"internet_my_package_post_to_url_links":{"internet_change_package":"/web/myrogers/torcom/internetChangePackage?setLanguage=en"},"internet_modem_chat_ids":{"change_modem_chat_cbid":"S_MRog_Inet_ChngModem","change_modem_chat_div":"changeModem-En","change_modem_chat_button":"chatButtonChangeModemEn"},"yahoo_email_link":"https://login.yahoo.com/config/login?.src=rog&.intl=ca&.partner=rogers-acs&.lang=en-CA&.done=https://ca.rogers.yahoo.com","onBoarding":{"header":"Finish account setup","ProgressBarText":"{{percent}}% completed","ProgressBarAltText":"Your current account setup status is {{percent}}%. Please select an unchecked item to complete your profile. ","description01":"Complete your online profile with these {{count}} steps, so in the future, you can log in, view and pay your bill faster.","showLessText":"Show less","showLessAltText":"Hide all {{count}} account setup items.","showMoreText":"Show more","showMoreAltText":"Show all {{count}} account setup items.","closeText":"Close","closeAltText":"Close this window","tasks":{"loginToAccount":{"title":{"completed":"You’ve logged in successfully"},"alt":{"pending":"Log into My Account is pending. Please click to learn more.","completed":"Log into My Account is complete."}},"switchedToInfinite":{"title":{"completed":"Switched to Infinite plan"},"alt":{"pending":"","completed":"Switched to Infinite plan is complete."}},"setRecoveryNumber":{"title":{"completed":"Wireless recovery number is set up","pending":"Set a Wireless Recovery Number"},"alt":{"pending":"Set a Wireless Recovery Number is pending. Please click to learn more.","completed":"Set a Wireless Recovery Number is complete."},"modal":{"title":"Set a Wireless Recovery Number","description":"Recovering a forgotten username or password is easy! <br /> Set up a mobile number to retrieve your sign-in information quickly, using any number you choose – plus it only takes a few minutes.","buttonText":"Set Up Now","buttonAltText":"Select to Set Up Wireless Recovery Number Now"}},"setOnlineBilling":{"title":{"completed":"You have online billing","pending":"Go Paperless"},"alt":{"pending":"Go Paperless is pending. Please click to learn more.","completed":"Go Paperless is complete."},"modal":{"title":"Go Paperless","description":"Online Billing makes life easier (plus it saves trees):<ul><li>Access your bill anytime, anywhere</li><li>Receive email notification when bill is ready</li><li>Download usage details</li><li>View bill history (up to 18 months) in one place</li></ul>","buttonText":"Switch Now","buttonAltText":"Select to Go Paperless Now"}},"setAutoPayment":{"title":{"completed":"You have Automatic Payments","pending":"Set up Automatic Payments"},"alt":{"pending":"Set up Automatic Payments is pending. Please click to learn more.","completed":"Set up Automatic Payments is complete."},"modal":{"title":"Set up Automatic Payments","description":"Setting up automatic payments means:<ul><li>saving time – no more manual payments each month.</li><li>avoiding late charges for missed payments.</li><li>coverage while travelling, or even if you forget.</li></ul>","buttonText":"Set Up Now","buttonAltText":"Select to Set Up Automatic Payments Now"}}},"congratulationsSection":{"title":"Congratulations!! You’re all set!","description01":"Managing your online account will be a breeze.","description02":"Plus, you’ve got full access to our <a href=\"https://communityforums.rogers.com/t5/Rogers-Community-Forums/ct-p/EnglishCommunity?profile.language=en \" target=\"_blank\">community forums</a>. So tell us what you think, ask a question or just enjoy being part of the Rogers family."}},"available_credit_limit_error":"Credit limit information is unavailable.","ovo_payment_widget_ppc_heading":"Post Dated PPC","ovo_payment_widget_effective_date":"Effective <br/> {{date}}","ovo_payment_widget_ppc_change_text":"Subscriber level PP changed from<br/> <b>{{fromPlan}}</b> to <b>{{toPlan}}</b>","fraud_indicator_message":"This account has been flagged for potential fraudulent activity. Refer to the <a  href=\"#/interaction\">Fraud Management Interaction</a> from the Interactions page for next steps.","fraud_indicator_title_text":"Fraud Alert!","ovo_payment_widget_Last_bill":"Last bill <span class='rui-icon-chevron-right'></span>","ovo_payment_widget_Last_bill_disabled":"Last bill","ovo_payment_widget_past_due":"Past due"});

$translateProvider.translations("fr", {"0":"","10001":"Not valid form data have been passed","10300":"Le compte que vous tentez d’inscrire est un compte d’entreprise. Consultez la <a href='https://www.rogers.com/web/smb/bss/#/signin'>page d’inscription du Libre-service Affaires</a> pour inscrire votre compte en ligne et accéder aux renseignements sur votre utilisation et la facturation. Merci!","10301":"Nous sommes incapables d’associer votre compte Rogers à votre profil MonRogers pour l’instant. Veuillez réessayer plus tard.","10302":"Ce compte est déjà associé à un autre profil MonRogers. Veuillez accéder à ce profil afin de gérer le compte ou, pour obtenir du soutien, communiquer avec un conseiller du Service à la clientèle au moyen de l’outil de clavardage en direct.","10303":"Désolé, le code postal ne correspond pas à celui de nos dossiers pour le numéro de compte que vous avez entré. Veuillez vérifier si le code postal et le numéro de compte que vous avez entrés sont exacts.","10304":"Veuillez entrer un numéro de 9 à 12 chiffres valide","10305":"Désolé, le numéro de compte entré n’a pas été trouvé. Veuillez vérifier le numéro entré.","10311":"Désolé, le numéro de téléphone entré n’a pas été trouvé. Veuillez vérifier le numéro entré.","10312":"Désolé, le numéro de compte entré est déjà associé à un profil MonRogers.","10313":"fr The PIN does not match","10314":"{FR} Failed to get subscription info base on Pin and CTN provided","10350":"No email has been found for this account.","10401":"« Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank'>Clavardage en direct</a>. »","10402":"La réponse à la question de sécurité que vous avez entrée ne correspond pas à nos dossiers. Veuillez entrer votre réponse de nouveau.","10403":"{FR} get postpaid account details failed","10412":"{FR} failed to get prepaid account list due to SOAP Fault","10413":"{FR} get prepaid account details: failed to find ctn","10414":"{FR} get prepaid account details: failed to find pin","10415":"{FR} get prepaid account details: failed to get subscription list","10416":"{FR} get prepaid account details: failed to get account details","10501":"Cette adresse électronique est déjà utilisée comme nom d’utilisateur MonRogers.  Veuillez choisir une autre adresse électronique ou ouvrir une session avec ce nom d’utilisateur","10502":"Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>Clavardage en direct</a>.","10503":"{FR} Failed to complete forgotUsername operation","10504":"Réponse incorrecte à la question de sécurité","10505":"La réponse à la question de sécurité que vous avez entrée ne correspond pas à nos dossiers. Veuillez entrer votre réponse de nouveau.","10506":"« Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href='http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36' target='_blank'>Clavardage en direct</a>. »","10601":"{FR} Failed retrieve Usage","10602":"{FR} getting roaming usage returns error code","10603":"{FR} getting usage returns error code","11401":"{FR} unexpected error in TVLandingActor","11402":"{FR} cable product details not found","11403":"{FR} failed getting cable product details","11404":"{FR} cable product package not found","11405":"{FR} failed getting cable product package","11406":"{FR} failed populating cable info","11411":"{FR} error occurred when getting plan deteail from cassandra","11412":"{FR} error occurred when getting digital box deteail from cassandra","11413":"{FR} error occurred when getting themepack deteail from cassandra","11414":"{FR} error occurred when getting channel deteail from cassandra","12000":"{FR} Permission Denied","13001":"{FR} Failed create secret key","13002":"{FR} Encryption Failed","13003":"{FR} Decryption Failed","13004":"{FR} URLEcode Failed","15040":"Désolé, nous ne trouvons pas l’adresse électronique que vous avez entrée. Assurez-vous d’entrer la bonne adresse et réessayez.","50000":"Erreur inconnue du serveur","50001":"Not defined yet Server Error","50002":"Se il vous plaît déconnectez-vous et essayez de vous connecter à nouveau avec votre nouveau nom d'utilisateur","50018":"Désolés, une erreur s’est produite. Veuillez réessayer maintenant ou plus tard.","700000212":"French Copy not yet provided","700000238":"French Copy not yet provided","790000038":"French Copy not yet provided","790000041":"French Copy not yet provided","790000042":"French Copy not yet provided","790000043":"French Copy not yet provided","790000044":"French Copy not yet provided","790000045":"French Copy not yet provided","790000051":"French Copy not yet provided","800000020":"French Copy not yet provided","800000021":"French Copy not yet provided","809999999":"French Copy not yet provided","ute":{"casl":{"electronicAddresses":{"mainHeading":"Messages et communication","subHeading":"Messages et communication sur les données","addressheading":"Messages de marketing électronique de Rogers","selectBoxLabel":"Envoyez tous les messages texte concernant les données au:","saveSelectionBtn":"Enregistrer","updatedSelectionBtn":"Mis à jour","prefNotFoundMsg":"Vos préférences n'ont pas été trouvées.","infoAlertMsg":{"title":"What does this mean ?","msg":"Vous recevrez tous les messages texte relatifs à l’utilisation de données et à l’utilisationz excédentaire de données, ainsi que les alertes relatives au forfait sans-fil, au numéro que vous sélectionnez. Vous pouvez sélectionner n’importe quelle ligne de votre forfait <b> Partagez tout</b><sub><b>MC</b></sub>."},"preference":{"linkTitle":"Gérer les message","toggleYes":"Oui","toggleNo":"Non"},"sms":{"prefHeading":"Préférences en matière de marketing par message texte"},"email":{"prefHeading":"Préférences en matière de marketing par courriel"},"getErrorDetail":"Vos préférences n'ont pas été trouvées.","updateErrorDetail":"<b>Nous sommes désolés, mais nous n'avons pas pu enregistrer vos sélections.</b>"}},"easy":{"login":{"title":"Sélectionner vos services de Rogers","common":{"back":"Précédent","continue":"Continuer","cancel":"Annuler","password":"Afficher","text":"Masquer","myRogers":"MonRogers","register":"Inscription","account":"Compte :","email":"Courriel ","verify":"Vérifier","done":"Terminé","secure":"Formulaire sécurisé","liveChat":"<bold-chat-static-button data-cbid='5024179705330489307' data-dynamic-div='S_RegistrationIssues_Fr' data-chat-button='S_RegistrationIssues_Fr' style='display:inline-block'></bold-chat-static-button>"},"registration":{"transitionScreenHeading":"Ce ne sera pas long, nous avons presque fini de créer votre profil!","transitionScreenDescription":"Veuillez ne pas fermer ni actualiser cette page","header":"À quels services Rogers êtes-vous abonné?","oneOrMore":"À au moins un des services suivants :","wireLess":"Sans-fil (avec un forfait mensuel)","internet":"Internet","tv":"Télé","homeMonitoring":"Système de domotique","homePhone":"Téléphonie résidentielle","services":"services sans-fil/résidentiels","payAsYouGoWireless":"Service sans-fil Parlez à la carte <sub> MC </sub>","payAsYouGoService":"Service Parlez à la carte","rogersBusinessCustomer":"Êtes-vous un client d’affaires de Rogers?","registerBusinessSelfServe":"Inscrivez-vous au Libre-service Affaires>","noRogersServices":"Je ne suis abonné à aucun service de Rogers","rogersServicesNotAvailable":"MonRogers n’est offert qu’aux clients Rogers.","seeWhatWeCanDo":"Voici ce que nous pouvons faire pour vous…","shop":"Magasiner","step":{"account":"Compte","email":"Courriel","verify":"Vérifier","password":"Mot de passe","complete":"Terminé"},"step_main_header":"","step_account_header":"S’inscrire à MonRogers","step_email_header":"Au moyen de quelle adresse courriel voulez-vous ouvrir une session?","step_verify_header":"Le courriel de vérification a été envoyé.","step_password_header":"Enregistrez votre mot de passe","step_complete_header":"Merci de vous être inscrit!","account":{"header":"Quel compte voulez-vous configurer?","rogersAccountNo":"Numéro de compte Rogers","rogersAccountNoPlaceHolder":"numéro à 9 ou à 12 chiffres","whereToFind":"Où trouver votre numéro de compte:","monthlyPaperBill":"Votre facture papier mensuelle","monthlyEmailMessage":"Le courriel mensuel vous informant que vous pouvez accéder à votre facture en ligne","serviceAgreement":"Votre entente de service (remise à ceux qui se sont inscrits en magasin)","postalCodeAddress":"Code postal de votre adresse de facturation","error_null":"","account_empty_error":"FR-required","account_incomplete_error":"FR-incomplete","postal_empty_error":"FR-required","postal_incomplete_error":"FR-incomplete","accountRequiredError":"Veuillez entrer un numéro de compte.","accountPatternError":"Votre numéro de compte doit être composé de 9 à 12 chiffres.","postalRequiredError":"Veuillez entrer un code postal.","postalPatternError":"Veuillez entrer un code postal selon le modèle suivant : A1A1A1","eck5":"Nous n’avons pas trouvé ce compte ou ce code postal. Veuillez réessayer, ou clavardez avec un conseiller pour obtenir de l’aide. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck6":"Ce compte a été annulé ou suspendu. Veuillez communiquer avec un conseiller pour obtenir de l’aide. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck7":"Ce compte est inscrit à l’adresse suivante : {{maskedEmail}} <br/> <a class='signin-interceptor'> S’il s’agit de la vôtre, ouvrez simplement une session.</a> Pour obtenir de l’aide, communiquez avec un conseiller. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck8":"??????????????????????????","eck9":"Ce lien est expiré. Veuillez entrer de nouveau votre numéro de compte et votre code postal afin de faire une nouvelle demande.","ecf4":"Pour inscrire un compte d’affaires, utilisez le <a href=\"/web/totes/#/sso/registration\"> Libre-service Affaires.</a>","ech5":"Pour continuer, sélectionnez <strong> Je ne suis pas un robot.</strong>"},"accountRegistered":{"header":"Bonne nouvelle!","message":"Un profil MonRogers existe déjà pour ce compte.","completeRegistration":"Pour terminer votre inscription…","sendEmailmessage":"Sélectionnez <strong> Envoyer un courriel </strong> ci-dessous et nous vous enverrons un lien pour créer votre mot de passe MonRogers.","emailSentTo":"Un courriel sera envoyé à :","sendEmail":"Envoyer un courriel"},"email":{"header":"Au moyen de quelle adresse courriel voulez-vous ouvrir une session?","enterEmail":"Entrer l’adresse courriel","reEnterEmail":"Confirmer l’adresse courriel","error_null":"","ech1":"Veuillez remplir tous les champs pour continuer.","ecd2":"L’adresse doit suivre ce modèle : name@email.com","ech3":"Les données entrées doivent correspondre.","eca7":"Désolé, notre système a eu un problème. Nous vous remercions de votre patience pendant que nous tâchons de le résoudre. Veuillez vérifier de nouveau plus tard.","ecd5":"Cette adresse courriel est associée à un autre compte MonRogers. Si vous essayez d’ajouter un compte à votre profil,<a class='signin-interceptor'> ouvrez une session.</a> Si vous avez besoin d'aide, clavardez avec un conseiller.<span>{{'ute.easy.login.common.liveChat' | translate}}</span>","fail_to_send":"FR-Failed to send email","verify":{"verifyingLink":"Vérification du lien…","linkVerified":"Lien vérifié!","linkExpired":"Lien expiré"}},"verify":{"header":"Le courriel de vérification a été envoyé.","message":"Dans le courriel que nous venons de vous envoyer, sélectionnez <strong> Enregistrer le mot de passe.</strong>","messageSentTo":"Le message a été envoyé à : {{maskedEmail}}","didntGetEmail":"Vous n’avez pas reçu de courriel?","eck9":"This link has expired. Please re-enter your account number and postal code to begin a new request.","didntGetEmailExpanded":{"checkSpam":"Vérifiez votre boîte de courriels indésirables","giveFewMinutes":"Attendez encore quelques minutes","stillNeedHelp":"Vous avez encore besoin d’aide?","liveChat":"Live Chat","resendCode":"Renvoyer le courriel","sendToDifferentEmail":"Envoyer le courriel à une autre adresse","sendingCode":"Envoi du courriel","codeSent":"Courriel envoyé!","pleaseContactUs":"Veuillez communiquer avec nous"}},"password":{"header":"Enregistrez votre mot de passe","enterPassword":"Entrer le mot de passe","reEnterPassword":"Confirmer le mot de passe","setPassword":"Enregistrer un mot de passe","error_null":"","passwordMustHave":"Votre mot de passe doit comprendre :","passwordAtLeast":"Au moins une lettre et un chiffre","passwordMinimum":"Au moins huit caractères","passwordCanInclude":"Vous pouvez utiliser des caractères spéciaux et des lettres majuscules ou minuscules. Les mots de passe sont sensibles à la casse.","bothPasswordMatch":"Les deux mots de passe sont identiques","ech1":"Veuillez remplir tous les champs pour continuer.","ech2":"Votre mot de passe doit contenir entre 8 et 64 caractères, dont au moins une lettre et un chiffre.","ecd5":"Cette adresse courriel est associée à un autre compte MonRogers. Si vous essayez d’ajouter un compte à votre profil,<a class='signin-interceptor'> ouvrez une session.</a> Si vous avez besoin d'aide, clavardez avec un conseiller","eck5":"Nous n’avons pas trouvé ce compte ou ce code postal. Veuillez réessayer, ou clavardez avec un conseiller pour obtenir de l’aide. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>"},"complete":{"header":"Merci de vous être inscrit!","message":"Nous vous avons envoyé un courriel de confirmation. <br/> Vous êtes à présent inscrit à MonRogers où vous pouvez consulter vos services et les gérer.","goToOverview":"Aller à l’aperçu","goToSignin":"Ouvrez une session","haveOtherAccounts":"Vous avez d’autres comptes Rogers?","linkAccounts":"Associez-les à MonRogers >","ech1":"You must fill out all fields to continue.","ech3":"Les données entrées doivent correspondre."},"contest_banner_desc":"Inscrivez-vous d’ici le 18 juillet, et vous courrez automatiquement la chance de gagner une carte prépayée Visa* de Rogers<sub>MC</sub> de 100 $! <a href=\"http://rogers.com/cms/rogers/pdf/MyRogers_Registration_Contest_Rules_French.pdf\" target=\"_blank\">Consultez le Règlement officiel du concours.</a>","contest_banner_step5_desc":"Merci de vous être inscrit. Vous courez la chance de gagner une carte prépayée Visa* de Rogers<sub>MC</sub> de 100 $!","contest_banner_step5_subtext1":"*Les cartes prépayées sont émises dans le cadre d’un programme de promotion. La carte prépayée est émise par Peoples Trust Company aux termes d'une licence accordée par Visa Int.","contest_banner_step5_subtext2":"*Marque (de commerce/marque déposée) de Visa International Service Association, utilisée sous licence."},"userMigration":{"changeUserName":{"optional":{"header":"Simplify sign-in! ","message":"Servez-vous de votre adresse courriel et de votre nom d’utilisateur. <br/> Il ne vous faudra que deux minutes et le mot de passe reste le même.","setUpNow":"Configurer maintenant","remindMeInWeek":"Me le rappeler dans une semaine","skip":"Continuer"},"mandatory":{"header":"Ouverture de session simplifiée!","message":"Nous demandons à présent à tous nos clients de se servir de leur adresse courriel comme nom d’utilisateur.<br/>Il ne vous faudra que deux minutes et le mot de passe reste le même.","setUpNow":"Configurer maintenant","cancelSignIn":"Annuler l’ouverture de session"}},"verify":{"header":"Nous vous avons envoyé un code de vérification par courriel.","message":"Entrez le code à sept chiffres que vous avez reçu par courriel pour : {{maskedEmail}}","verifyMe":"Vérifier mon identité"},"done":{"header":"Votre nom d’utilisateur a changé.","message":"Nous vous avons envoyé un courriel de confirmation.","signInWith":"ous pouvez maintenant ouvrir une session avec {{maskedEmail}}","signIn":"Ouvrir une session"}},"linkAccount":{"wirelessVsPrepaid":{"header":"Quel compte Rogers aimeriez‑vous ajouter à votre profil?","wirelessOrResidential":"Sans-fil/résidentiel :","wireLess":"Sans-fil (forfait mensuel)","internet":"Internet","tv":"Télé","homeMonitoring":"Système de domotique","homePhone":"Téléphonie résidentielle","goToWirelessOrResidential":"Sans-fil/résidentiel","payAsYouGoPrepaidWireless":"Service sans-fil (prépayé) Parlez à la carteMC","payAsYouGo":"Parlez à la carte","rogersBusinessCustomer":"Voulez-vous ajouter un compte d’affaires?","registerBusinessSelfServe":"Ouvrez une session dans le Libre-service Affaires>"},"newAccount":{"header":"Ajouter un compte sans-fil/résidentiel","addAccount":"Ajouter un compte"},"complete":{"header":"Le compte a été ajouté!","message":"Nous vous avons envoyé un courriel de confirmation.","setNickName":"Veuillez enregistrer un surnom pour ce compte ","editNickName":"FR-Edit Nickname","account":"Compte :","payAsYouGo":"Pay As You Go™:","default":"","saveNickName":"Enregistrer le surnom","autoViewAccount":"Voulez-vous automatiquement consulter ce compte chaque fois que vous ouvrez une session?","setDefaultView":"Oui, définir par défaut","noThanks":"Non, merci"},"prePaid":{"header":"Associer un compte","message":"Pour associer votre compte, il suffit d’entrer les renseignements sur votre compte <strong> Parlez à la carteMC :</strong>","wirelessNumber":"Numéro de sans-fil à dix chiffres","accountPin":"NIP à quatre chiffres","cannotRememberPin":"Vous ne vous souvenez pas du NIP de votre compte?","callForHelp":"Composez <strong> le 1 800 575-9090 </strong> et un conseiller vous aidera.","linkAccount":"Associer un compte","cancel":"Annuler"}},"error":{"error_null":"","eca6":"L'accès à votre compte MonRogers a été suspendu. Veuillez communiquer avec un conseiller pour obtenir de l'aide.","eca7":"Désolé, notre système a eu un problème. Nous vous remercions de votre patience pendant que nous tâchons de le résoudre. Veuillez vérifier de nouveau plus tard.","ech1":"Veuillez remplir tous les champs pour continuer.","ech2":"Votre mot de passe doit compter de 8 à 64 caractères et comprendre au moins un chiffre et une lettre. Les caractères spéciaux suivants sont acceptés: ! @ # $<br/> <br/>Veuillez essayer de nouveau.","ech3":"Les données entrées doivent correspondre.","ecd2":"L’adresse doit suivre ce modèle : name@email.com","ecd5":"Cette adresse courriel est associée à un autre compte MonRogers. Si vous essayez d’ajouter un compte à votre profil,<a class='signin-interceptor'> ouvrez une session.</a> Si vous avez besoin d'aide, clavardez avec un conseiller","eck1":"Veuillez entrer un numéro de compte.","eck2":"Votre numéro de compte doit être composé de 9 à 12 chiffres.","eck3":"Veuillez entrer un code postal.","eck4":"Veuillez entrer un code postal selon le modèle suivant : A1A1A1","eck5":"Nous n’avons pas trouvé ce compte ou ce code postal. Veuillez réessayer, ou clavardez avec un conseiller pour obtenir de l’aide. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck6":"Ce compte a été annulé ou suspendu. Veuillez communiquer avec un conseiller pour obtenir de l’aide. <span>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck7":"Ce compte est inscrit à l’adresse suivante : {{maskedEmail}}.<a class='signin-interceptor error-bold'> S’il s’agit de la vôtre, ouvrez simplement une session.</a> Pour configurer un nouveau mot de passe, sélectionnez <a class='forgot-password-interceptor error-bold'>Mot de passe oublié.</a> Pour obtenir de l’aide, communiquez avec un conseiller. <span class='fake-link error-bold'>{{'ute.easy.login.common.liveChat' | translate}}</span>","eck8":"Désolés, ce compte est déjà associé à une autre adresse courriel. Veuillez communiquer avec nous à l'aide de l'outil de <span class='fake-link error-bold'>{{'ute.easy.login.common.liveChat' | translate}}</span> pour obtenir de l'aide","eck9":"Ce lien est expiré. Veuillez entrer de nouveau votre numéro de compte et votre code postal afin de faire une nouvelle demande.","eck10":"Ce compte est inscrit à l’adresse suivante : {{maskedEmail}}. <br/>Pour configurer un nouveau mot de passe, sélectionnez <a class='forgot-password-interceptor error-bold'>Mot de passe oublié</a>. Pour obtenir de l’aide, communiquez avec un conseiller.<button>Bouton de clavardage en direct</button>","eck11":"Ce lien n'est plus valide. Veuillez entrer de nouveau votre numéro de compte et votre code postal afin de faire une nouvelle demande","ecp1":"Comme aucune activité ne figure à votre compte depuis 30 minutes, nous avons fermé votre session pour protéger vos renseignements.","ecp2":"Désolés, une erreur s’est produite. Veuillez réessayer maintenant ou plus tard.","ecq1":"Vous avez donné ce surnom un autre compte. Veuillez choisir un surnom unique.","ecf4":"Pour inscrire un compte d’affaires, utilisez le <a href=\"/web/totes/#/sso/registration\"> Libre-service Affaires.</a>","ecf5":"Vous essayez actuellement d’inscrire un compte Affaires. Rendez-vous à la page du <a href=\"/web/smb/bss/#/sso/registration\">Libre-service Affaires</a> pour inscrire votre compte et consulter votre utilisation et votre facture."}}},"eclipseRemote":{"error":"Désolé, une erreur s’est produite. Nous tentons de régler le problème le plus rapidement possible. Les changements apportés à vos forfaits n’ont pas été enregistrés. Veuillez revérifier dans quelques minutes.","liveChat":"Clavardage en direct"},"goPaperless":{"liveChat":{"cbid":"7015556824075446708","dynamicDivId":"gopaperlessErrorHelpButton-fr","chatButtonClass":"S-Care_gopaperless_Update_Issue-fr"},"emailModal":{"withContactEmail":{"title":"Passer &agrave; la facture en ligne","saveEmailMessage":"Mettre &agrave; jour votre adresse &eacute;lectronique : ","newEmail":"Entrer la nouvelle adresse &eacute;lectronique","newEmailConfirm":"Confirmer la nouvelle adresse &eacute;lectronique","saveAndSwitch":"Enregistrer et passer &agrave; la facture en ligne"},"withoutContactEmail":{"title":"Entrez votre adresse &eacute;lectronique","saveEmailMessage":"Choisissez l&rsquo;adresse &agrave; laquelle vous aimeriez recevoir vos avis de facturation","newEmail":"Entrez votre adresse &eacute;lectronique","newEmailConfirm":"Entrez de nouveau votre adresse &eacute;lectronique","saveAndSwitch":"Continuer"},"currentEmailMessage":"Lorsque votre facture sera prête, nous vous enverrons un avis à l’adresse électronique ci-dessous.","switch":"Passer &agrave; la facture en ligne","cancel":"Annuler","validEmailError":"Veuillez entrer une adresse &eacute;lectronique valide.","matchEmailError":"Les adresses &eacute;lectroniques doivent &ecirc;tre identiques.","updateEmail":"Mettre &agrave; jour l&rsquo;adresse &eacute;lectronique"},"switchToOnlineBilling":"Passez à la facture en ligne.","switchNow":"Changer maintenant","modalDone":"Termin&eacute;","learnMore":"Détails","learnMoreSwitch":"Changer maintenant","learnMoreCancel":"Non, merci","errorTitle":"D&eacute;sol&eacute;...","updateEmailErrorMessage":"Nous &eacute;prouvons des difficult&eacute;s techniques et nous ne sommes pas en mesure de modifier votre adresse &eacute;lectronique pour le moment. Veuillez communiquer avec nous, nous serons heureux de modifier votre adresse &eacute;lectronique et de vous faire passer &agrave; la facture en ligne.","switchBillingErrorMessage":"Nous &eacute;prouvons des difficult&eacute;s techniques et nous ne sommes pas en mesure de vous faire passer &agrave; la facture en ligne pour le moment. Veuillez communiquer avec nous, nous serons heureux de vous aider &agrave; faire la transition.","switchedButUpdateEmailFailedErrorMessage":"Nous &eacute;prouvons des difficult&eacute;s techniques et nous ne sommes pas en mesure de modifier votre adresse &eacute;lectronique pour le moment. Veuillez communiquer avec nous, nous serons heureux de modifier votre adresse &eacute;lectronique."},"historical":{"usage":{"header":"Utilisation antérieure des données partagées ","usage_header":"Aperçu de l'utilisation","total_data":"Total des données partagées (Go)","totalUsage":"Utilisation totale*","overage":"Utilisation excédentaire","loading":"Chargement de l’utilisation antérieure","error_header":"Nous avons un problème technique.","error_desc":"Nous sommes vraiment désolés. Nous ne pouvons pas afficher l’utilisation antérieure des données.<br />Veuillez réessayer plus tard.","MB":"Mo","GB":"Go","average":"Utilisation moyenne","usage_by_line":"Utilisation par ligne","topup":"","ban":"BAN: ","note1":"<strong>* L’utilisation totale</strong> en Go/Mo a été arrondie à la hausse ou à la baisse à deux décimales près pour l'utilisation de ce forfait Partagez tout.","note2":"<strong>**</strong> Inclut le réapprovisionnement et les données en prime ajoutées.","leftplan":"Ancien forfait"}},"common":{"oneview":{"header":{"subMenu":{"acc_overview_my_account_overview":"Survol du compte","submenu_billing_and_payment":"Facturation et Paiement","submenu_services":"Services","service_wireless":"Sans-fil","service_internet":"Internet","service_tv":"Télévision","service_phone":"Téléphonie résidentielle","service_monitoring":"Système<br/> de domotique","service_wireless_prepaid":"<i>PARLEZ <br/>À LA CARTE<sub>MC</sub></i>","submenu_link_account":"Associer le compte","oneview_bundlebuilder":"Offer Builder (dans OASYS)","transfer_of_responsibility":"Transfert de responsabilité","submenu_profile":"PROFIL ET PARAMÈTRES","interaction":"INTERACTIONS","actions_and_offers":"ACTIONS et OFFRES","myaccoverview_home_monotoring":"Système<br/>de domotique","orders":"Commandes"},"global":{"sign_out":"Fermer la session","language_toggle":"English","welcome":"Bienvenue","welcome_comma":"Bienvenue, "},"repCart":{"_saved_quotes":"Mes prix","_quote":"Le délai associé #","_expired":"Délai expiré","expires":"Expire","_my_cart":"Ma liste d'achats","ppc":"Changer de forfait","hup":"Rehaussement d'appareil","nac":"Ajout&eacute; une nouvelle ligne"},"consumerCart":{"_saved_quotes":"Mes prix","_quote":"Le délai associé #","_expired":"Délai expiré","expires":"Expire","_my_cart":"Ma liste d'achats","ppc":"Changer de forfait","hup":"Rehaussement d'appareil","nac":"Ajout&eacute; une nouvelle ligne","ignite":"Offre groupées Élan","igniteDeleteAlt":"Sélectionnez pour retirer Offre groupées Élan de votre panier"},"consumerDetails":{"show_less":"Show less","show_more":"Show more","c_class":"Cat&eacute;gorie de cr&eacute;dit : ","c_limit":"Limite de cr&eacute;dit : ","c_available":"Cr&eacute;dit disponible : ","tenure":"Ancienneté","since":"depuis","content_currently_unavailable":"Ce contenu n&rsquo;est pas accessible pour l&rsquo;instant.","interactions_in_the_last_30_days":"Interactions in the last 30 days: ","c_interactions":"Interactions","filer_tickets":"Billets","customer_duration":"{{years}} ANNEÉ(S) , {{months}} MOIS(S)","accType_consumer":"Grand public","accType_business":"Affaires","accType_government":"Gouvernemental","accSubType_regular":"Régulier","accSubType_non-revenue":"Sans revenu","accSubType_prepaid":"Prépayé","accSubType_corporate":"Entreprise","accSubType_federal":"Fédéral","accSubType_provincial":"Provincial","accSubType_municipal":"Municipal","accStatus_open":"Ouvert","accStatus_active":"Actif","accStatus_suspended":"Suspendu","accStatus_cancelled":"Annulé","accStatus_pending-disconnect":"Débranchement en attente","accStatus_pending-connection":"Branchement en attente","arpa":"RMMC","arpa_info":"RMMC – Revenu mensuel moyen par compte, soit le revenu moyen des trois derniers mois pour toutes les gammes de produits regroupés pour l’ECID d’un client. (Veuillez consulter dans Nova le document REF827 pour obtenir de plus amples renseignements sur l’ECID.)","arpa_error_msg":"La valeur du RMMC n’est pas disponible."},"bfappcWirelessDashboardService":{"ppc_something_went_wrong_message_title":"Désolé, une erreur s’est produite.","ppc_something_went_wrong_message_text":"Nous tentons de régler le problème le plus rapidement possible. En attendant, nous avons sauvegardé vos sélections, alors vous pouvez téléphoner au Service à la clientèle ou utiliser notre service de clavardage en direct afin d’obtenir de l’aide pour terminer votre commande."},"modals":{"passcode":"Mot de passe","evp_portal_msg":"Obtenir le mot de passe sur le portail EVP","enable_idv_msg":"Veuillez obtenir le mot de passe du compte à responsabilité individuelle auprès du client et l’entrer ci-dessous.","invalid_passcode":"Veuillez réessayer plus tard","invalid_passcode_msg":"Désolé, il y a un problème avec le mot de passe que vous avez entré.","system_error":"erreur de système","system_error_msg":"Désolé, nous éprouvons actuellement des problèmes techniques.","success_msg":"Cèst fait! Rabais appliqué.","success_passcode":"Cèst fait! Le mot de passe du compte à responsabilité<br/>individuelle est appliqué","success_passcode_msg":"Pour recevoir un rabais, le client doit passer à un forfait Partagez tout sur le marché.","success_discount_msg":"Les rabais ont été appliqués au compte.","confirm_header_msg":"Confirmation : Des frais seront portés au compte","confirm_msg":"Des frais de {{migFee}}$ seront portés au compte du client.","confirm_confirmation_msg":"Vous voulez toujours continuer?","okay":"OK","try_again":"Essayez de nouveau","cancel":"Annuler","enter":"Entrer","continue":"Continuer"},"util":{"_months":{"0":"janvier","1":"février","2":"mars","3":"avril","4":"mai","5":"juin","6":"juillet","7":"août","8":"septembre","9":"octobre","10":"novembre","11":"décembre"}},"wirelessDashboardService":{"error_wireless_usage":"Désolé, les détails de votre service Sans-fil ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","fraud_display_message":"Malheureusement, nous ne pouvons pas traiter votre demande pour le moment. Veuillez demander au client de communiquer avec  Rogers au 1-888-383-2080 pour obtenir de l&rsquo;aide. Merci.","credit_ops_display_message":"Nous sommes incapables de compl&eacute;ter votre transaction en ce moment. S&apos;il vous pla&icirc;t conseiller le client d&rsquo;appeler le 1-800-551-5700 pour obtenir de l&apos;aide &agrave; compl&eacute;ter leur demande."},"oneViewHeaderController":{"dealer-code":"Code de concessionnaire"},"idvDetails":{"idv_account":"Compte à responsabilité individuelle","non_idv_account":"Compte sans responsabilité individuelle","enable_idv_account":"Activer un compte à responsabilité individuelle","show_details":"Afficher les détails","hide_details":"Masquer les détails","validate_idv_status":"Valider l’état d’admissibilité du compte à responsabilité individuelle","unknown_idv_status":"État d’admissibilité du compte à responsabilité individuelle inconnu","company_name":"Nom de l’entreprise : ","company_code":"Code d’entreprise : ","idv_status_date":"Date de l’état d’admissibilité au compte à responsabilité individuelle : ","idv_falloff_date":"Date de suppression de l’admissibilité au compte à responsabilité individuelle (échéance du rabais pour comptes à responsabilité individuelle) : ","last_validation_date":"Dernière date de validation : "}}},"label":{"currentLang":"fr","currency.sym.left":"","currency.sym.right":"$","edit":"Modifier","cancel":"Annuler","check.form.errors":"Des erreurs de validation ont été détectées sur cette page. Veuillez consulter le message au-dessus de chaque ligne.","contact.info":"Coordonnées","continue":"Continuer","email.address":"Adresse électronique","email.confirm":"Confirmez l’adresse électronique","email.invalid":"Veuillez entrer une adresse &eacute;lectronique valide.","email.verification":"V&eacute;rification","myRogers":"MonRogers","username":"Nom d'utilisateur :","username.edit":"Modifier le nom d&rsquo;utilisateur","username.change":"Changer le nom d&rsquo;utilisateur","username.and.password":"Nom d&rsquo;utilisateur et mot de passe","username.guildeline":"Lignes directrices sur les noms d’utilisateur","username.guildeline.list":"<br><div style=\"line-height: normal; margin-bottom: 10px;\">Le nom d’utilisateur doit être une adresse courriel ne dépassant pas 254 caractères et suivre ce format : nom@courriel.com.</div><div style=\"line-height: normal;\">Une fois modifié, il doit permettre d’ouvrir une session dans MonRogers ou de récupérer un mot de passe oublié. Veuillez mettre vos coordonnées à jour dans la section ci-dessous, pour recevoir des avis de service à cette adresse courriel. </div>","password":"Mot de passe :","password.old":"Ancien mot de passe","password.incorrect":"Ancien mot de passe est incorrect.","password.new":"Nouveau mot de passe","password.change":"Changer le Mot de passe","password.confirm.new":"Confirmer le nouveau mot de passe","password.invalid":"Veuillez entrer un mot de passe valide","password.forgot":"Vous avez oubli&eacute; votre mot de passe","password.reset":"R&eacute;initialisez votre mot de passe","password.wrong":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caract&egrave;res sp&eacute;ciaux. Veuillez r&eacute;essayer.","password.reenter":"Veuillez confirmer votre mot de passe en le saisissant de nouveau.","password.notmatch":"Votre mot de passe et celui de confirmation ne sont pas semblables.","password.edit":"Modifier le Mot de passe","password.guildeline":"Instructions pour cr&eacute;er votre mot de passe","password.guildeline.list":"<br>Votre mot de passe doit &ecirc;tre compos&eacute; de 7 &agrave; 16 caract&egrave;res et contenir des lettres et des chiffres.","language.preference":"Langue de préférence","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du &nbsp;","system.error.message.p2":" pour démêler le tout. ","save.changes":"Enregistrer les changements","chat.live":"Clavardage en direct","need.help":"Besoin d'aide?","thankyou":"Merci!","tryagain":"Réessayer","contactUs":"Contactez-nous","findStore":"Trouver un magasin","learnHowTo":"Apprendre à","moving":"Vous déménagez","andMore":" et plus encore","needHelpWith":"Besoin d'aide avec","tv":"Télé","wireless":"Sans fil","internet":"Internet","bundles":"Liasses","homePhone":"Téléphonie résidentielle","smartHomePhone":"Téléphonie résidentielle","homeMonitoring":"Système domotique","visitSupport":"Consulter le service de soutien","troubleshoot":"Obtenir du dépannage","signIn":"Connexion","newToRogers":"Vous êtes nouveau client de Rogers?","registerNow":"Inscrivez-vous dès maintenant!","month":"par mois","did.you.know":"Le saviez-vous?","remind.customer":"Rappelez ce qui suit au client :","close":"Fermer","online":"En ligne","creditCards":{"AMEX":"American Express","MASTERCARD":"MasterCard","VISA":"VISA","AMEX.img":"images/am.png","MASTERCARD.img":"images/mc.png","VISA.img":"images/visa.png"},"selfServeOnly":"Libre-service seulement","account":"Compte","account.short":"Compte","overview":"Survol","billAndPayment":"Facturation et paiement","billAndAccountBalance":"Votre facture et votre solde","myServices":"Utilisation et services","services":"Services","profileAndSetting":"Paramètres","family":"la famille","interactions":"Interactions"},"form":{"secured":"Formulaire sécurisé"},"error":{"general":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite. Nous tentons de r&eacute;gler le probl&egrave;me le plus rapidement possible. Les changements apport&eacute;s &agrave; vos forfaits n&rsquo;ont pas &eacute;t&eacute; enregistr&eacute;s. Veuillez rev&eacute;rifier dans quelques minutes.","maintenance":"Il semble que vous essayer d&rsquo;acc&eacute;der &agrave; ce service par l&rsquo;entremise de MonRogers. Nous sommes d&eacute;sol&eacute;s; l&rsquo;information que vous cherchez n&rsquo;est malheureusement pas disponible en ce moment. Veuillez r&eacute;essayer plus tard. Merci de votre patience!"},"reactivate":{"ctn":{"renameMePlease":"rename_me_please FR","wirelessNumber":"Num&eacute;ro de sans-fil","devicePage":"Retour to device page","device":"Appareil","deviceName":"","backToDevice":"Retour &agrave; la page des appareils","images":{"call":"ute-common-assets/assets/call.png","widgetLoader":"ute-common-assets/assets/widget-loader.gif","errorWarning":"ute-common-assets/assets/error_warning.png","close":"ute-common-assets/assets/close-icon.png","phoneCancel":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","phoneDouble":"ute-common-assets/assets/wireless/mobile_phone_double.png"},"boldChat":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"reactivate-ctn-fr","chatButtonClass":"chatButton-Reactivate-ctn-fr"},"boldChatError":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"reactivate-ctn-err-fr","chatButtonClass":"chatButton-Reactivate-ctn-err-fr"},"supportPhoneNumber":"1 855 381 7834","messageBox":{"title":"Les services de votre appareil ont &eacute;t&eacute; suspendus.","messageLeft":"Avez-vous trouv&eacute; votre t&eacute;l&eacute;phone?","buttonText":"R&eacute;activez vos services","messageRight01":"Vous avez besoin d&rsquo;un nouveau t&eacute;l&eacute;phone et d&rsquo;une carte SIM?","messageRight02":"Communiquez avec nous pour obtenir de l&rsquo;aide.","repviewTitle":"Les services de l'appareil du client sont suspendus.","repviewMessageLeft":"Le client a-t-il retrouvé son téléphone?","repviewButtonText":"Réactiver les services"},"fail":{"title":"Nous ne sommes pas en mesure de r&eacute;activer les services de votre appareil pour le moment.","message":"Nous en sommes d&eacute;sol&eacute;s. Vous pouvez r&eacute;essayer plus tard en consultant la page des appareils ou en communiquant avec un conseiller.","supportPhoneNumber":"1 (855) 381-7834","repview_title":"Nous n’avons pas été en mesure de réactiver les services de l'appareil pour le moment.","repview_message":"Désolé. Vous pouvez réessayer ultérieurement depuis la page des appareils.","repview_possible_reasons":"Raisons possibles :","repview_pending_cancellation":"Annulation en attente","repview_fraud":"Fraude","repview_credit_limit":"Suivi de la limite de crédit"},"success":{"header":{"title":"Services r&eacute;activ&eacute;s","message":"Vos services d&rsquo;appels, de messages texte et de donn&eacute;es ont &eacute;t&eacute; activ&eacute;s et vous pouvez recommencer &agrave; utiliser votre t&eacute;l&eacute;phone comme d&rsquo;habitude.","repview_message":"Vos services de transmission de la voix, de messages texte et de données ont été réactivés et vous pouvez recommencer à utiliser votre téléphone comme d'habitude."},"body":{"header":"N&rsquo;oubliez pas&hellip;","message01Icon":"ute-common-assets/assets/wireless/mobile_phone_cancel.png","message01":"Votre compte n&rsquo;a pas &eacute;t&eacute; annul&eacute;. Vos services ont &eacute;t&eacute; d&eacute;sactiv&eacute;s temporairement.","repview_message01":"Le compte sans-fil du client n'a pas été annulé. Ses services ont été désactivés temporairement.","message02Icon":"ute-common-assets/assets/wireless/mobile_phone_double.png","message02":"Veuillez &eacute;teindre, puis rallumer votre appareil pour recommencer &agrave; l&rsquo;utiliser.","repview_message02":"Informez le client qu'il doit éteindre, puis rallumer son appareil pour recommencer à l'utiliser.","question":"Des questions?","answer":"Nous sommes l&agrave; pour vous. Nous serons heureux de vous aider.","repview_header":"Gardez à l'esprit les éléments suivants :"}}}},"second.level":{"navigation":{"header":"MonRogers","headerShort":"Mon","defaultAccountOption":"Choisir le compte &agrave; g&eacute;rer :","linkAnotherAccount":"Lier un autre compte","selectTheAccount":"Choisir le compte &agrave; g&eacute;rer :","wireless.phone":"{{name}} {{phoneNumber}}","wireless.phone.prepaid":"PARLEZ À LA CARTE<sub>MC</sub> {{phoneNumber}}","iptv":"T&eacute;l&eacute;","smartstream":"Divertissement","hsiinternet":"Internet","internet":"Internet","gateway":"Équipement Élan","tv":"T&eacute;l&eacute;vision","home.phone":"Téléphonie résidentielle {{phoneNumber}}","home.monitoring":"Syst&egrave;me domotique","shareEverything":"Utilisation sans-fil","infiniteTitle":"Utilisation sans-fil","billing":{"viewBill":"Afficher votre facture","makePayment":"Faire un paiement","changePaymentMethod":"Changer le mode de paiement","setUpAutomaticPayments":"Établir les paiements automat.","paymentHistory":"Historique de paiements"},"profileLanding":{"overview":"Aperçu des Paramètres","contactAndBilling":"Coordonnées et Facturation","security":"Profil MonRogers","linkedAccounts":"Comptes Liés"}}},"suspend":{"ctn":{"boldChat":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"suspend-ctn-fr","chatButtonClass":"chatButton-suspend-ctn-fr"},"boldChatError":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"suspend-ctn-err-fr","chatButtonClass":"chatButton-suspend-ctn-err-fr"},"confirm":{"switchOffService":"Suspendez vos services","backToDevice":"Back to device page - fr","wirelessNumber":"Numéro de sans-fil","devicePage":"Retour to device page","device":"Appareil","sorryToHear":"Nous sommes désolés <br> d'apprendre que vous avez perdu votre téléphone.","repView_sorryToHear":"Customer lost his phone","rightPlace":"Vous êtes au bon endroit; nous trouverons une solution","firstStep":"1 - Si vous avez un téléphone intelligent, essayez de le localiser :","secondStep":"2 - Désactivez vos services afin que personne ne soit en mesure d'utiliser vos services d'appels, de messages texte et de données.","thirdStep":"3 - Vous n'avez toujours pas retrouvé votre téléphone? Voyons les options qui s'offrent à vous.","ifFind":"Si vous retrouvez votre téléphone, vous pouvez simplement les réactiver.","turnOff":"De cette manière, vous désactiverez vos :","confirmEmail":"Un courriel de confirmation sera envoyé à <span class=\"bold\">{{::accountEmail}}</span>","updateEmail":"Mettre à jour l'adresse courriel","data":"- Données","talk":"- Appels","text":"- Messages texte","findIphone":"Localiser mon iPhone","findAndroid":"Localiser mon appareil Android","findIphoneUrl":"https://www.icloud.com","findAndroidUrl":"https://myaccount.google.com/intro/find-your-phone?hl=fr","repview_customer":"Ce client a perdu son téléphone.","repview_steps":"Suivez ces étapes pour l'aider à trouver une solution.","repview_firstStep":"1 - Demandez au client de tenter de localiser son appareil au moyen de ces services :","repview_secondStep":"2 - Suspendez les services du client afin que personne ne puisse appeler, texter et consommer de données au moyen de son appareil.","repview_turnoff":"Les services suivants seront suspendus.","repview_thirdStep":"3 - Demandez au client s'il souhaite ajouter l'appareil à la liste noire des numéros IMEI afin qu'il ne puisse être utilisé sur les réseaux de Rogers et Fido ainsi que sur ceux des fournisseurs qui prennent ce service en charge. ","repview_findIphone":"Localiser mon iPhone :","repview_findAndroid":"Gestionnaire d'appareils Android :","repview_switch_service":"Suspendez les services du client afin que personne ne puisse appeler, texter et consommer de données au moyen de son appareil. Les services suivants seront suspendus.","repview_ifFind":"Si le client retrouve son téléphone, informez-le qu'il peut simplement réactiver ses services au moyen de MonRogers.","repview_note":" Remarque : Confirmez que l'appareil a été utilisé dans les 60 derniers jours pour l'ajouter à la liste noire et passez en revue l'utilisation non facturée dans V21 afin d'établir les attentes du client quant aux frais en suspens inscrits à son compte.","repview_offering":"Proposez au client des solutions de rechange comme un rehaussement d'équipement avec Protection de l'appareil ou un échange.","repview_updateEmail":"Mise à jour de l'adresse courriel du contact","repview_talk":"- Voix","repview_text":"- Messagerie texte","repview_switchOffService":"Désactiver les services"},"fail":{"title":"Nous ne sommes pas en mesure de d&eacute;sactiver les services de votre appareil pour le moment.","repview_title":"Nous n'avons pas été en mesure de suspendre les services de l'appareil du client pour le moment.","message":"Nous en sommes d&eacute;sol&eacute;s. Vous pouvez r&eacute;essayer plus tard en consultant la page des appareils ou en communiquant avec un conseiller","supportPhoneNumber":"1-855-381-7834","repview_possible_reasons":"Raisons possibles :","repview_pending_cancellation":"Annulation en attente","repview_fraud":"Fraude","repview_credit_limit":"Suivi de la limite de crédit","repview_update_soc":"Problème de doublon de SOC","repview_sorry_msg":"Désolé. Vous pouvez réessayer ultérieurement depuis la page des appareils."},"success":{"header":{"title":"Services suspendus","message":"Vos services sont maintenant d&eacute;sactiv&eacute;s; vos services d'appels, de messages texte et de donn&eacute;es ne peuvent donc pas &ecirc;tre utilis&eacute;s.","repview_message":"Les services de ce client sont maintenant désactivés; personne ne peut donc appeler, texter et consommer des données avec son téléphone.","wirelessNumber":"Num&eacute;ro de sans-fil","device":"Appareil","deviceName":"","backToDevice":"Retour &agrave; la page des appareils"},"body":{"title":"N&rsquo;oubliez pas&hellip;","repview_title":"Gardez à l'esprit les éléments suivants :","message01":"Si vous trouvez votre t&eacute;l&eacute;phone ou si vous vous procurez un nouvel appareil et une carte SIM, vous pouvez simplement r&eacute;activer vos services.","message02":"Vous demeurez responsable des frais mensuels et des frais li&eacute;s &agrave; l&rsquo;utilisation ant&eacute;rieure &agrave; la d&eacute;sactivation de vos services.","message03":"Votre compte sans-fil n&rsquo;a pas &eacute;t&eacute; annul&eacute;. Vos services ont &eacute;t&eacute; d&eacute;sactiv&eacute;s de mani&egrave;re &agrave; emp&ecirc;cher l&rsquo;utilisation de l&rsquo;appareil.","message01_repview":"Si le client retrouve son téléphone ou se procure un nouvel appareil et une carte SIM, il peut simplement réactiver ses services.","message02_repview":"Le client demeure responsable des frais mensuels et des frais liés à l'utilisation antérieure à la désactivation de ses services.","message03_repview":"Le compte sans-fil du client n'a pas été annulé. Ses services ont seulement été désactivés pour qu'il ne soit pas possible d'utiliser l'appareil. "},"faq":{"title":"FAQs","question01":"Pourrai-je r&eacute;activer mon appareil apr&egrave;s la suspension de mes services?","answer01":"Oui. Si vous retrouvez votre t&eacute;l&eacute;phone, vous pourrez r&eacute;activer vos services sur MonRogers et recommencer &agrave; utiliser l&rsquo;appareil.","question02":"Serai-je en mesure de me connecter &agrave; mon compte apr&egrave;s la suspension des services de mon appareil?","answer02":"Oui. Vous pourrez vous connecter &agrave; MonRogers m&ecirc;me si votre appareil est d&eacute;sactiv&eacute;.","question01_repview":"Puis-je réactiver les services de mon appareil une fois qu'ils ont été suspendus?","question02_repview":"Serai-je en mesure de me connecter à MonRogers une fois que les services de mon appareil auront été suspendus?","learnHow":"Voici comment >","learnHowUrl":"/web/support/wireless/lost-stolen/823?setLanguage=fr"}}}},"customer":{"credit":{"management":{"service":{"alignmentClass":"ute-creditManagement-fr-alignment","manageAdjustments":"Gestion des ajustements","unsatisfactoryCompensationContent1":"Quand un client doit être dédommagé parce qu'il est insatisfait du service, il faut déterminer l'ajustement maximal permis. Il faut toujours offrir en premier lieu une offre du <b>Programme d'ajustements non pécuniaires</b>. Un crédit pécuniaire ne doit être offert que si le client refuse l'offre d'ajustement non pécuniaire.","stepOne":"Étape 1","stepTwo":"Étape 2","determineAmountAllowed":"Déterminer le montant permis :","maxAllowedPeriod":"Maximum permis (sur une période de 6 mois)","recentAdjustments":"Ajustements récents","totalAllowed":"Total permis","makeCAPOffer":"Faire une offre d'ajustements non pécuniaires (CAP) :","unsatisfactoryCompensationContent2":"Avant d'offrir un crédit pécuniaire, examinez d'abord le compte du client, puis consultez les offres d'ajustements non pécuniaires afin de déterminer la plus avantageuse pour le client.","viewCAPOffersInNova":"Consulter CAP offers dans Nova","unsatisfactoryCompensationContent3":"Si le client refuse l'offre, appliquer un ajustement non discrétionnaire au compte.","customerPhoneNumber":"Numéro de téléphone du client","totalAllowed50Percent":"50%","totalAllowed100Percent":"100%","discretionaryCreditAdjustmentsPeriod":"Ajustements de crédit discrétionnaires (six mois précédents)","nonDiscretionaryCreditAdjustmentsPeriod":"Ajustements de crédit non discrétionnaires (six mois précédents)","date":"Date","count":"Nombre","code":"Code","amount":"Montant","description":"Description","discretionaryDescription1GDWL":"Bonne volonté/Relations publiques","discretionaryDescription2GDWL":"Bonne volonté/Relations publiques","noDiscretionaryCreditsFound":"Aucun crédit discrétionnaire ne figure au compte.","noNonDiscretionaryCreditsFound":"Aucun crédit non discrétionnaire ne figure au compte.","systemUnavailableMessage":"Système non disponible. Nous ne pouvons extraire les renseignements de ce compte pour l'instant. Veuillez réessayer plus tard.","notAvailable":"S/O"}}}}},"payment":{"method":{"mop_change_from":"Ancien mode:","mop_change_to":"Nouveau mode:","change_method_secure_debit":"Paiement sécurisé","change_method_cheque_header":"Renseignements li&eacute;s au compte","change_method_info_secure_debit":"Vos renseignements bancaires sont sauvegardés, encryptés et en sécurité","change_method_info_transit_code":"N&deg; de transit","change_method_info_bank_code":"N&deg; d’institution","change_method_account_number":"N&deg; de compte","change_method_terms_debit":"Modalités de paiement par prélèvement automatique","change_method_see_tctab":"See T&Cs Debit Tab","change_method_confirm_title":"Confirmer la mise à jour du mode de paiement","change_method_confirm_details":"Une facture mensuelle signifie une chose de plus à se rappeler chaque mois. Êtes-vous sûr de ne pas vouloir avoir l’esprit en paix en sachant que votre facture Rogers sera réglée automatiquement chaque mois à partir de votre compte bancaire canadien ou de votre carte de crédit? Annuler Continuer","change_method_thankyou_title":"Merci!","change_method_thankyou_details":"L'option de paiement préautorisé a été associée à votre compte! Votre premier prélèvement préautorisé figurera sur votre prochaine facture. Nous vous avons aussi envoyé un courriel de confirmation.","change_method_error":"Désolé, une erreur s’est produite et votre changement n’a pas été accepté. Veuillez réessayer en utilisant un mode de paiement différent.","change_method_deb_error":"Désolé, le numéro de transit ou le numéro d'institution bancaire n'est pas valide. Veuillez réessayer.","change_method_invalid_bank_code":"Désolé, ce numéro d'institution bancaire n'est pas valide. Veuillez réessayer.","change_method_invalid_transit_code":"Désolé, ce numéro de transit n'est pas valide. Veuillez réessayer.","change_method_invalid_account":"Désolé, ce numéro de compte n'est pas valide. Veuillez réessayer.","change_method_invalid_accountType":"Désolé, ce type de compte n'est pas valide. Veuillez réessayer.","change_method_accept":"J'accepte les modalités","change_method_not_accepted":"Veuillez accepter les modalités avant de continuer.","mop_debit_card_notice":"Remarque : Veuillez prendre note que le changement de mode de paiement entrera en vigueur dans un délai de deux jours ouvrables.","update_debit_button":"Mettre à jour le compte bancaire","change_method_terms":"Modalités de paiement par prélèvement automatique\n\nLa présente autorise toute entreprise faisant partie du groupe de sociétés Rogers ('Rogers') à débiter mon/notre compte indiqué ci-dessus des frais périodiques pour les produits et (ou) services de Rogers, y compris tous les services offerts par Rogers Sans-fil S.E.N.C. et tous les services offerts par Communications Rogers Câble inc(incluant les services Internet et Téléphonie résidentielle de Rogers).\n\nJe reconnais/nous reconnaissons que la présente autorisation sera utilisée par Rogers et mon/notre institution financière et est fournie dans la mesure où mon/notre institution financière accepte de traiter les prélèvements automatiques sur mon/notre compte conformément aux règles de l'Association canadienne des paiements. Jereconnais/nous reconnaissons que la présente autorisation fournie à Rogers constitue la livraison de ma/notre part à mon/notre institution financière.\n\n L'information donnée sur ce formulaire sera fournie aux banques de Rogers afin de mettre en œuvre la présente autorisation. Toutes les personnes dont la signature est requise pour le compte de l'institution financière mentionnée ci-dessus ont signé la présente autorisation. J'aviserai/nous aviserons par écrit Rogers sans délai de tout changement apporté aux données de mon/notre compte.\n\n La présente autorisation peut être annulée en tout temps sur avis donné à Rogers 30 jours avant le prochain prélèvement automatique.\n\n Pour obtenir un exemple de formulaire d'annulation ou me/nous renseigner sur mon/notre droit d'annuler une entente de paiement par prélèvement automatique, je peux/nous pouvons communiquer avec mon/notre institution financière ou consulter www.cdnpay.ca  \n\nL'annulation de la présente entente ne s'applique qu'au mode de paiement et n'a aucune incidence sur le contrat applicable aux produits ou services de Rogers.  \nRogers ne peut pas céder la présente entente sans me/nous donner un préavis d'au moins 10 jours.\n\n J'accepte/nous acceptons ce qui suit :\n\n Le montant de chaque paiement dont mon/notre compte sera prélevé en fonction des frais portés à ce dernier pour la période de facturation précédente figurera sur la facture que je reçois/nous recevons de Rogers avant ce prélèvement.\n\n \nJ'accepte/nous acceptons que Rogers réduise le préavis standard pour chaque prélèvement automatique.  \nMon/notre compte sera débité chaque mois, à moins d'indication contraire dans mon/notre entente de service.\n\n Mon/notre institution financière n'aura pas l'obligation de s'assurer que tous les prélèvements automatiques par Rogers sont conformes à la présente autorisation ou à toute autre entente avec Rogers. Mon/notre institution financière pourra me/nous rembourser les montants dont sera débité mon/notre compte dans les cas suivants :\n\n (i) si le retrait n'est pas conforme à la présente autorisation, \n(ii) si j'annule/nous annulons la présente autorisation. Pour être remboursé, je dois/nous devons remplir un formulaire de déclaration dans les 90 jours civils suivant la date d'inscription du prélèvement à mon/notre compte; tout litige après cette date devra être résolu directement avec Rogers. \nJ'ai/nous avons certains recours si un prélèvement automatique n'est pas conforme à la présente entente. J'ai/nous avons notamment le droit d'obtenir un remboursement pour tout prélèvement qui n'est pas autorisé ou qui n'est pas conforme à la présente entente. Pour obtenir plus d'information sur les recours dont je dispose/nous disposons, je peux/nous pouvons communiquer avec mon/notre institution financière ou consulter www.cdnpay.ca\n\n Je reconnais/nous reconnaissons avoir lu et compris les modalités de la présente entente de paiement par prélèvement automatique.\n","INVOICE":"Manuel","CREDIT":" Paiements automatiques – Carte de crédit","DEBIT":" Paiements automatiques – Compte bancaire","self_serve_pay_online":"En ligne dans MonRogers au moyen d’une carte de crédit<span class='invoice-bold'>*</span>, d’une carte de crédit prépayée, d’une carte de débit Visa ou Mastercard ou encore par paiement en ligne InteracMD.","self_serve_pay_via_app":"Au moyen de l’<span class='invoice-bold'>application MonRogers</span>, au moyen d’une carte de crédit<span class='invoice-bold'>*</span> ou d’une carte de débit Visa ou Mastercard.","self_serve_pay_in_store":"Dans certains <span class='invoice-bold'>magasins Rogers.</span>","self_serve_pay_at_bank":"Dans la plupart des banques.","self_serve_pay_by_phone":"En nous téléphonant au 1‑877‑559‑5202.","self_serve_change_method_mail":"En postant un chèque à Rogers, C.P. 9100, Don Mills (Ontario)  M3C 3P9.","invoice_cards_accepted":"<span class='invoice-bold'>*</span> Nous acceptons Mastercard, Visa et American Express.","invoice_more_info":"Pour obtenir de plus amples renseignements sur vos options de paiement, veuillez consulter la section intitulée <a href='https://www.rogers.com/customer/support/article/how-to-make-a-payment'>Comment effectuer un paiement. </a>","update_credit_card":"Mettre à jour la carte de crédit","update_bank_account":"Mettre à jour le compte bancaire","bank_account_label":"Banque - Numéro de compte","credit_card_type_number":"Carte de crédit","expiry_on":"Date d'expiration","master":"Mastercard","visa":"Visa","amex":"Amex","payment_method":"Mode de paiement:","invoice_label":"Modes de paiement de votre facture :","payment_information":"Renseignements sur les paiements","change_payment_method":"Changer le mode de paiement","credit_card_expiry_warning":"Votre carte de crédit expirera bientôt.","credit_card_invalid":"Votre carte de crédit est expirée.","debit_invalid":"Désolé, nous épr  ouvons de la difficulté à traiter le paiement. Veuillez mettre à jour les renseignements concernant votre compte bancaire.","liveChat":{"cbid":"8645390841122303174","dynamicDivId":"changePaymentMethod-fr","chatButtonClass":"chatButtonChangePaymentMethod-fr"},"mop_title":"Changer le mode de paiement","ap_change_pm_link":"Changer le mode de paiement","mop_summary_explanation_no_balance":"Les paiements ne seront plus traités automatiquement.","mop_summary_explanation_with_balance":"Les paiements ne seront plus traités automatiquement. Veuillez faire un paiement avant le {{date}} pour éviter les frais de retard.","mop_update_payment_method_button":"Mettre à jour le mode de paiement","mop_credit_card_notice":"N’oubliez pas que le changement de mode de paiement peut prendre jusqu’à <strong>deux jours ouvrables.</strong>","mop_success_title":"C’est fait!","mop_success_message_CREDIT":"L’option de paiement préautorisé a été associée à votre compte. Le premier prélèvement sera fait pour votre prochaine facture. Vous recevrez sous peu une confirmation par courriel.","mop_success_message_DEBIT":"L’option de paiement préautorisé a été associée à votre compte. Le premier prélèvement sera fait pour votre prochaine facture. Vous recevrez sous peu une confirmation par courriel.","mop_success_message_INVOICE":"Votre mode de paiement est maintenant la facture mensuelle. Vous recevrez sous peu une confirmation par courriel.","mop_close":"Fermer","mop_failure_title":"Désolés","mop_failure_message":"Nous ne sommes pas en mesure de changer votre mode de paiement pour le moment. Veuillez communiquer avec nous. Nous serons heureux de vous aider.","mop_success_message_cd":"Veuillez prendre note que le changement de mode de paiement entrera en vigueur dans un d&eacute;lai de deux jours ouvrables.","update_credit_card_header":"Mettre à jour votre carte de crédit","update_credit_card_button":"Mettre à jour la carte de crédit","update_debit_header":"Mettre à jour l'option de paiement préautorisé","update_cc_success_header":"Les renseignements concernant votre carte de crédit ont été mis à jour :","update_cc_expiry":"Date d’expiration","update_cc_success_notice":"Le traitement des changements peut prendre jusqu’à deux jours ouvrables.","close_button":"Fermer","update_cc_invalid_header":"Désolé, nous ne pouvons mettre à jour votre carte.","update_cc_invalid_explanation":"Nous éprouvons de la difficulté à traiter cette mise à jour. Veuillez examiner les renseignements de la carte et réessayer.","update_cc_invlaid_help":"Pour obtenir de l’aide, veuillez communiquer avec nous en utilisant une des options ci-dessous.","update_cc_system_header":"Nous éprouvons des problèmes liés au système","update_debit_system_header":"Nous éprouvons des problèmes liés au système","update_debit_success_header":"Nous avons mis à jour votre option de paiements bancaires préautorisés :","update_cc_system_explanation":"Désolé, nous ne pouvons mettre à jour les renseignements concernant votre carte de crédit pour l’instant, mais nous travaillons à corriger la situation. Pour obtenir de l’aide, veuillez communiquer avec nous en utilisant une des options ci-dessous.","update_debit_system_explanation":"Désolé, nous ne pouvons mettre à jour les renseignements concernant votre compte bancaire pour l’instant, mais nous travaillons à corriger la situation. Pour obtenir de l’aide, veuillez communiquer avec nous en utilisant l’une des options ci-dessous.","update_debit_success_bank_account":"Banque - Numéro de compte","manual_payment":"Change to Manual Payment","manual_payment_content":"Êtes-vous sûr de vouloir désactiver les paiements mensuels automatiques et passer au paiement manuel?","manual_payment_continue":"Continuer","change_to_manual_payment_link":"Passer au paiement manuel","setup_automatic_payment_link":"Configurer les paiements automatiques","payment_method_manual_payment":"Paiement manuel","payment_method_automatic_monthly_payments":" Paiements mensuels automatiques","save_card_details":"Enregistrer les détails de la carte:","update_account":"Mettre le compte à jour","ways_to_pay_bill_label":"Autres façons de payer votre facture","way_to_pay_online":"En ligne","way_to_pay_via_app":"Application MonRogers","way_to_pay_in_store":"Choisi magasins Rogers","way_to_pay_at_bank":"La plupart des banques","way_to_pay_by_mail":"Afficher un chèque à:","way_to_pay_by_mail_address":"Rogers PO Box 9100, Don Mills, ON M3C 3P9","way_to_pay_cards_accepted":"<span class='invoice-bold'>* nous acceptons mastercard, visa et American express.</span>","way_to_pay_more_info":"Pour obtenir de plus amples renseignements sur vos options de paiement, veuillez consulter la section intitulée <a href='https://www.rogers.com/web/support/billing-payment/payment/99'>comment effectuer un paiement.</a>","add_rogers_as_payee":"Ajouter Rogers à vos bénéficiaires de paiements bancaires en ligne.","twelve_digit_account":"ROGERS (NUMÉRO DE COMPTE À 12 CHIFFRES)","nine_digit_account":"ROGERS (NUMÉRO DE COMPTE À 9 CHIFFRES)","payee_name":"Nom de bénéficiaire de Rogers :","pay_at_bank":"Payer à votre banque","mail_cheques":"Envoyer un chèque par la poste à : <br> Rogers, C.P. 9100 <br> Don Mills (Ontario)  M3C 3P9","call_rogers":"Composer le <a href='tel:+18775595202'>1-877-559-5202</a>","rogers_app":"Au moyen de l’application MonRogers","pm_disagree_manual_payment":"No, keep automatic payments","pm_processing":"Traitement des modifications","pm_card_deleted":"Carte supprimée","pm_no_changes_made":"Aucune modification effectuée","account":"Paiement","review":"Vérification","review_D":"Modalités","confirmation":"Confirmation","pm_current_payment_method":"Mode de paiement actuel","pm_auto_payment":"Paiements automatiques – ","pm_what_like_do":"Que souhaitez-vous faire?","pm_change_radio_bank":"Effectuer des paiements automatiques à partir de votre compte bancaire","pm_current_radio_bank":"Effectuer des paiements automatiques à partir d’un compte bancaire différent","pm_current_radio_cc":"Effectuer des paiements automatiques à partir d’un autre compte de carte de crédit","pm_change_radio_cc":"Effectuer des paiements automatiques à partir d’un compte de carte de crédit","pm_manual_pay":"Passer au paiement manuel ","pm_manual_to_automatic_bank":"Effectuer des paiements automatiques à partir d’un compte bancaire","pm_cc_header":"Numéro de carte de crédit","pm_expiry":"Date d’expiration","pm_done":"Terminé","pm_try_again":"Essayez de nouveau","help_text":"Pour obtenir de l’aide, veuillez communiquer avec le soutien.","SUCCESS":"C’est fait!","NO_CHANGE_MADE":"Aucune modification effectuée","failure":{"C":{"header":"Désolés, nous éprouvons des problèmes de configuration des paiements automatiques par carte de crédit."},"D":{"header":"Désolés, nous éprouvons des problèmes de configuration des paiements bancaires automatiques."},"R":{"header":"Désolés, nous éprouvons des problèmes de système et nous ne sommes pas en mesure de changer votre mode de paiement pour le moment. Veuillez réessayer plus tard ou communiquer avec nous pour obtenir de l’aide."}},"pm_edit":"Modifier","pm_make_a_payment_now":"Faire un paiement maintenant","pm_make_a_payment_balance":"Payer le solde de {{amount}}","pm_payment_for_next_billing_month_heading":"Votre paiement automatique entrera en vigueur dès votre prochaine facture. Si votre compte présente un solde impayé, veuillez effectuer un paiement afin que votre compte soit à jour. La date du traitement de votre paiement automatique figurera sur votre prochaine facture.","pm_payment_for_next_billing_month__desc":"Pour éviter des frais de paiement en retard, le solde de votre compte doit être de 0 $ d'ici le <strong>{{nextBillingDate}}</strong>.","pm_bank_secure_text":"Les renseignements sur votre compte bancaire seront cryptés et sécurisés.","pm_success_update_payment_text":"C’est réussi! À partir du mois prochain, vos paiements de facture se feront automatiquement.","pm_success_change_payment_text":"C’est fait! Votre mode de paiement a été modifié.","pm_email_confirmation_text":"Nous vous enverrons un courriel de confirmation bientôt.","pm_cc_secure_message":"Les renseignements sur votre carte de crédit seront cryptés et sécurisés. ","pm_invoice_header":"Êtes-vous certain de vouloir annuler les paiements automatiques?","pm_invoice_subtext":"Vous devrez payer votre facture manuellement à chaque cycle.","pm_invoice_yes":"Oui, annuler les paiements automatiques","pm_invoice_no":"Non, ne pas annuler","pm_submit":"Soumettre","pm_confirm":"Confirmer","pm_radio_cc_subtext":"Les cartes Visa Débit et Débit MasterCard sont acceptées.","current_payment_method":{"C":{"text":"carte de crédit"},"D":{"text":"Compte bancaire"},"R":{"text":"Paiements manuels"}},"merchant":{"header":"Détails de l'adresse du commerçant :","name":"Rogers Communications Canada Inc.","street":"333, rue Bloor Est","city":"Toronto, Ontario","postal":"M4W 1G9","country":"Canada"},"pm_sub_label_transit":"(5 chiffres)","pm_sub_label_institution":"(3 chiffres)","pm_sub_label_account":"(7 à 12 chiffres)","pm_secured":"Sécurisé","pm_error_modal_header":"Impossible de traiter la demande","pm_error_cc_empty":"Veuillez entrer un numéro de carte de crédit.","pm_error_expiry_empty":"PVeuillez entrer une date d’expiration.","pm_error_security_empty":"Veuillez entrer un code de sécurité.","pm_error_cc_invalid":"Le numéro de carte n’est pas valide.","pm_error_expiry_invalid":"La date d’expiration est passée.","pm_error_security_invalid":"Le code de sécurité n’est pas valide.","pm_accept_terms":"Veuillez accepter les modalités avant de continuer.","pm_setup_automatic_payments":"Configurer les paiements automatiques","will_charge":"Sera porté automatiquement à : ","history":"Historique de paiement","account_prefix":"Compte","setup_auto_payment":"Configurer les paiements automatiques","will_auto_charge":"Sera porté automatiquement à :","ending_number":"se terminant par","expires_on":"Expire le","expired_on":"Expiré le","update":"Mettre à jour","card_expiring":"Expiration de carte","will_expire_days":"Votre carte de crédit expirera dans <span>{{days}} jours</span>","card_expired":"Expiration de carte","is_expired_msg":"Votre carte de crédit est expirée.","alt_amex":"American Express","alt_master":"MasterCard","alt_visa":"Visa","pm_invoice_heading_account_number":"Votre numéro de compte Rogers :","android_app_link":"Au moyen de l’application <a class=\"app-link\" href=\"https://play.google.com/store/apps/details?id=com.fivemobile.myaccount&hl=fr\" target=\"_blank\">MonRogers</a>","ios_app_link":"Au moyen de l’application <a class=\"app-link\" href=\"https://itunes.apple.com/fr/app/myrogers/id337618972?mt=8\" target=\"_blank\">MonRogers</a>","ovo_pw_cc_info":{"cc_link_text":"Mettre à jour <span class=\"rui-icon-chevron-right link-icon\"></span>","is_expired_msg":"Carte de crédit est expirée","will_expire_days":"Carte de crédit expirera dans <span>{{days}}</span> jours"}},"rep":{"securedform":"Secured form","updatepayment":"Mettre à jour le paiement automatique","question":"De quelle façon le client peut-il faire ses paiements automatiques mensuels?","question_update":"Que souhaitez-vous changer pour les paiements mensuels automatiques?","creditcard":"Carte de crédit","accepted_variants":"Les cartes Visa Débit et Débit MasterCard sont acceptées.","bankaccount":"Compte bancaire","onlyavailable":"(offert seulement sur rogers.com)","notify":"Dites au client qu’il peut accéder à son profil MonRogers et configurer ses renseignements bancaires sous Profil et paramètres. Il peut également se procurer un formulaire de prélèvement automatique sur compte chèques dans son magasin Rogers, ou fournir son adresse courriel afin que nous puissions lui en envoyer une copie.","processpayment":"Traitement des modifications","automatic":"Modifications apportées au compte du paiement automatique","switch_credit_card":"Changer la carte de crédit","changebankaccount":"Changer la compte bancaire","setup_automatic_payment":"Configurer les paiements automatiques","schedule_ptp":"Horaire PTP","will_expire_days":"La carte de crédit expirera dans <span>{{days}} jours</span>","is_expired_msg":"La carte de crédit est expirée.","payment_method_manual":"Paiement manuel"},"ui":{"payNow":{"takePaymentHeading":"Accepter un paiement","makeAPayment":"Faire un Paiement Sécurisé","paymentAmount":"Montant du paiement:","paymentReferenceId":"N&ordm; de r&eacute;f&eacute;rence","payment":"Paiement","review":"V&eacute;rification","pay_via_bank":"Paiement par services bancaires","confirmation":"Confirmation","overThreshhold":"D&eacute;sol&eacute;, le montant du paiement que vous avez entr&eacute; est trop &eacute;lev&eacute;. Le montant du paiement maximal que vous pouvez effectuer pour cette transaction est de {{threshHoldPaymentAmount | currency:undefined:2}}.","invalidPaymentAmount":"D&eacute;sol&eacute;, ce montant du paiement n'est pas valide. Veuillez r&eacute;essayer.","paymentMethod":"Comment souhaitez-vous payer?","cardMethod":"<span class=\"cc-head\">Paiement par carte de crédit, carte Visa Débit ou carte Débit MasterCard</span>","bankMethod":"<span class=\"cc-head\">Paiement par services bancaires</span>","bankMethodMessage":"Lorsque vous effectuez votre paiement via votre banque, comptez 3 à 5 jours ouvrables pour le traitement, afin d'éviter les frais de retard.","interacMethod":"<span class=\"cc-head\">Paiement par Interac en ligne</span>","payNowWithInterac":"Payez maintenant par Interac en ligne","goToInteracButton":"Payer avec Interac","interacButtonTitle":"Payez avec Interac","interacFirstPageMessage1":"Vous pouvez effectuer un paiement sur le portail des paiements s&eacute;curis&eacute;s Interac dans une fen&ecirc;tre distincte.","interacFirstPageMessage2":"Si votre carte de d&eacute;bit affiche un logo Visa D&eacute;bit ou D&eacute;bit Mastercard et un logo Interac, s&eacute;lectionnez l&rsquo;option ci-dessus","interacCreditOrDebitLink":"Payer avec une carte de cr&eacute;dit ou de d&eacute;bit.","cardNumber":"Num&eacute;ro de carte","expiryDate":"Date d&rsquo;expiration","paymentDate":"Date du paiement","continueAndReview":"V&eacute;rifier et continuer","overPaying":"Le montant du paiement est plus élevé que le montant dû. <strong> Vous pouvez quand même payer cette somme</strong>, mais nous préférions vous en aviser.","editPayment":"Modifier le paiement","paymentTypeLabel":"Type de paiement","autoPaymentText":"Utilisez cette carte pour effectuer vos paiements mensuels automatiques.","payNowButtonLabel":"Payer maintenant","secureCCPayment":"Paiement s&eacute;curitaire","secureCCPaymentDesc":"Les renseignements de votre carte de cr&eacute;dit ou de d&eacute;bit seront crypt&eacute;s et s&eacute;curis&eacute;s.","paymentSuccessHeadline":"Merci! Nous avons re&ccedil;u votre paiement.","paymentMethodUpdated":"Nous avons aussi mis &agrave; jour votre mode de paiement. Cette carte sera utilis&eacute;e pour payer automatiquement les prochaines factures associ&eacute;es &agrave; ce compte.","thankYouMessage":"Merci! Nous avons re&ccedil;u votre paiement de ","confirmationMessage":"Vous recevrez bient&ocirc;t un courriel de confirmation.","processingPayment":"Traitement du paiement","processingInteracPayment":"Vous &ecirc;tes redirig&eacute; vers Interacenligne.com","paymentReceived":"Paiement re&ccedil;u!","serverErrorHeaderCard":"Nous avons rencontr&eacute; un probl&egrave;me de paiement.","serverErrorHeaderCardUnableToProcess":"Impossible de traiter le paiement","serverErrorHeaderInterac":"Vous &eacute;prouvez un probl&egrave;me?","serverErrorMessageCard":"Nous sommes désolés, nous n’avons pas pu traiter votre paiement. Pour obtenir de l’aide, veuillez communiquer avec nous.","serverErrorMessageCard_1005972_CCQ2":"Nous sommes désolés, les renseignements de la carte de crédit sont invalides. Veuillez vérifier votre carte et essayer de nouveau.","serverErrorMessageCard_1005972_CCQ2_part_one":"Nous sommes désolés, les renseignements de la carte de crédit sont invalides. Veuillez vérifier votre carte et ","serverErrorMessageCard_1005972_CCQ2_part_two":"","serverErrorMessageCard_try_again":"essayer de nouveau.","serverErrorMessageCard_10645_CA84":"Désolés. Nous ne pouvons pas traiter le paiement, car la carte de crédit est expirée. Veuillez essayer de nouveau avec une carte valide.","serverErrorMessageCard_10645_CA84_part_one":"Nous sommes désolés, mais les renseignements de la carte de crédit sont invalides. Veuillez ","serverErrorMessageCard_10645_CA84_part_two":"vérifier votre carte et ","serverErrorMessageInterac":"Communiquez avec nous si vous avez des questions ou des pr&eacute;occupations relativement &agrave; votre paiement. Sinon, aimeriez-vous essayer de nouveau?","supportNumber":"1-877-559-5202","backToAccountOverview":"Retourner à la page Aperçu du compte","preAuthCreditPaymentMethod":"Prélèvement automatique par carte de crédit","merchantDetails":"Détails&nbsp;de&nbsp;l'adresse&nbsp;du&nbsp;commerçant&nbsp;:","companyName":"Rogers&nbsp;Communications&nbsp;Canada&nbsp;Inc.","streetAddress":"333,&nbsp;rue&nbsp;Bloor&nbsp;Est","cityAndProv":"Toronto,&nbsp;Ontario","postalCode":"M4W&nbsp;1G9","country":"Canada","liveChat":{"cbid":"4037300931336993906","dynamicDiv":"Rogers_Care_ConsolidatedBilling_FR","chatButton":"S_Care_MakePayment_2_FR"},"liveChatBank":{"cbid":"4122668501881797036","dynamicDiv":"Rogers_Payment_Method_Care_Wireless_FR","chatButton":"Rogers_Payment_Method_Care_Wireless_FR"},"banks":{"td":"TD Canada Trust","td_link":"https://www.td.com/ca/fr/services-bancaires-personnels/","atb":"ATB Financial","atb_link":"http://www.atb.com/Pages/default.aspx","rbc":"RBC Banque Royale","rbc_link":"http://www.rbcbanqueroyale.com/personal.html","bmo":"BMO Banque de Montréal","bmo_link":"https://www.bmo.com/principal/particuliers","scotiabank":"Banque Scotia","scotiabank_link":"http://www.scotiabank.com/ca/fr/0,,1001,00.html","cibc":"CIBC","cibc_link":"https://www.cibc.com/fr/personal-banking.html","desjardins":"Desjardins","desjardins_link":"https://www.desjardins.com/ca/index.jsp","nationalbank":"Banque Nationale du Canada","nationalbank_link":"https://www.bnc.ca/fr/particuliers.html","tangerine":"Tangerine","tangerine_link":"https://www.tangerine.ca/fr/index.html"},"null_error":"","bp_account_balance":"Solde du compte","bp_payment_amount":"Montant du paiement :","bank_pay_header":"Pour faire un paiement par services bancaires:","bp_inst_item1":"Ouvrez une session sur le site web de votre banque.","bp_inst_item2":"Allez à la page de paiement de factures de votre banque.","bp_inst_item3":"Ajoutez Rogers comme bénéficiaire et payez votre facture.","bp_payee_header":"Nom du bénéficiaire Rogers: ","bp_payee_name":" ROGERS (NUMÉRO DE COMPTE À {{length}} CHIFFRES)","bp_payee_account_header":"N<sup style=\"font-size:12px\">o</sup> de compte Rogers:","bp_bank_selection_header":"Sélectionnez votre banque parmi les établissements ci‑dessous afin d'être redirigé vers son site web.","bp_pay_via_header":"Vous avez été redirigé vers le site web de votre banque.","bp_previous_step":"Revenir à l’étape précédente","bp_pay_complete_info":"Une fois le paiement bancaire effectué, il figurera dans votre compte Rogers après quatre jours ouvrables.","need_help":"Besoin d’aide? ","how_to_pay":"Comment faire un paiement en ligne","bp_get_billing_support":"Soutien pour la facturation et le paiement","contact_us":"Contactez-nous","oneViewTitle":"Accepter un paiement","ovPaymentAmount":"Montant du paiement","total":" ({{accountBalance | currency}} Solde du compte)","ovPreAuthCheck":"\t\tInscription aux paiements mensuels automatiques","ovSuccess":"C’est fait! Nous avons reçu le paiement du client.","ovDirections":"Il recevra bientôt une confirmation par courriel.","ovReference":"num&eacute;ro de r&eacute;ference : ","ovPreAuth":"Inscription aux paiements préautorisés effectuée","ovPreAuthDirections":"Dites au client que la date de son premier paiement automatique sera indiquée sur sa prochaine facture.","ovSecure":"D&eacute;tails s&eacute;curis&eacute;s","ovPaymentRemaining":"Solde","ovPayAgain":"Autre paiement","done":"Terminé","dup_header":"Vous avez déjà fait votre paiement?","dup_info":"Il semble que vous avez récemment fait un paiement à ce montant, en utilisant ce même mode de paiement.","dup_protection":"Pour des raisons de sécurité, nous ne pouvons traiter ce paiement.","dup_contact_us":"Pour obtenir de l’aide, veuillez communiquer avec nous.","dup_check_payment_contact_us":"Veuillez passer en revue votre historique des paiements ou communiquer avec nous pour obtenir de l’aide.","dup_payment_history":"Afficher l’historique des paiements","sgi_account_disclaimer":"Votre paiement figurera dans votre historique des paiements dans un délai d’un jour ouvrable.","promoBanner":"Économisez sur votre facture Rogers quand vous payez avec la carte Mastercard de Rogers. <a href=\"https://rogersbank.com/fr/rogers25?utm_source=Rogers.com&utm_medium=Website&utm_campaign=Make_Payment&utm_content=FR-Applynow&campaignsource=RCPAYM\" target=\"_blank\"> Détails. <span class=\"chevron-right\"></span> </a>"}}},"purchaseData":{"back":"Précédent","continue":"Continuer","closeBtn":"Fermer","backBtn":"Annuler","altTextClose":"Fermer","purchaseBtn":"Acheter","altTextWarning":"Avertissement","altTextSelected":"{{dataPlan}} Sélectionné(s)","altTextPurchasedPopupList":"Afficher les options de réapprovisionnement","addData":"Ajouter des données","addSpeedPass":"Ajouter Accès Rapido","selectPlanOption":{"title":"Ajoutez des données","desc1":"Vous pouvez choisir l’une des options suivantes :","desc2":"Un réapprovisionnement de données unique, qui peut être utilisé jusqu’à la fin de ce cycle de facturation.","or":"OU","desc3":"Une option mensuelle Ajout de données, qui sera ajoutée à votre forfait chaque mois, jusqu’à ce que vous décidiez de l’annuler.","option1":"Réapprovisionnement de données – unique","optionSP":"Accès Rapido","option2":"Ajout de données – option mensuelle"},"selectedPlansType":{"monthlyTitle":"Données en extra – Option mensuelle","oneTimeTitle":"Réapprovisionnement de données – unique","oneTimeTitleSP":"Ajouter un Accès Rapido","descriptionOTT":"Sélectionnez un montant. Vous devrez utiliser les données au plus tard le {{endDate}}, fin de journée.","descriptionSP":"Sélectionnez votre Accès Rapido et utilisez les données à vitesse maximale jusqu’à la fin de votre cycle de facturation actuel, soit le {{endDate}}.","descriptionMDT":"Sélectionnez un montant. Les données seront ajoutées à votre forfait <strong>chaque mois</strong> jusqu’à ce que vous décidiez d’annuler cette option.","addonDropdownLabel":"Options","addonDropdownLabel2":"Options  Données en extra","addonDropdownLabelSP":"Options Accès Rapido","addonDropdownIconAltTextShow":"Afficher les options Données en extra","addonDropdownIconAltTextHide":"Masquer les options Données en extra","addonDropdownIconHoverTextShow":"Afficher","addonDropdownIconHoverTextHide":"Masquer","addonDropdownPlaceholder":"Sélectionnez le montant"},"purchasingPlansConfirmationModal":{"atMaxSpeed":"de données à vitesse maximale","title":"Confirmez l'achat de données","infiniteTitle":"Confirmer l’achat","ottDesc":"Vous êtes sur le point d’effectuer un réapprovisionnement de données unique.","spDesc":"Vous êtes sur le point d’acheter un Accès Rapido.","mdtDesc":"Vous êtes sur le point d’acheter une option mensuelle Ajout de données.","desc1":"Chaque mois, {{dataPlan}} de données seront ajoutés à votre forfait, jusqu’à ce que vous décidiez de les annuler.","desc2":"Vous obtiendrez {{dataPlan}} de données additionnelles dans le cadre de votre forfait, que vous devrez utiliser au plus tard <strong>le {{endDate}}, fin de journée.</strong>","desc2SP":"{{dataPlan}} de données à vitesse maximale seront ajoutés à votre forfait. Ils pourront être utilisés jusqu’à la fin de votre cycle de facturation actuel, soit le <strong>{{endDate}}</strong>.","desc3":"Remarque : Tous vos frais d’utilisation de données excédentaire actuels demeureront en vigueur.","priceLabelSP":"de données à vitesse maximale pour","priceLabel":"pour","priceLabel2":"/mois"},"purchasingPlansSuccess":{"title":"{{dataPlan}} ajoutés!","infiniteTitle":"Félicitations! {{dataPlan}} à vitesse maximale ajoutés","desc1":"Profitez de vos données jusqu’au {{endDate}}, fin de journée.","desc1SP":"Profitez de vos données à vitesse maximale jusqu’à la fin de votre cycle de facturation actuel, soit le {{endDate}}.","desc2":"Profitez de votre ajout de données. Il s’affichera sur votre facture chaque mois, jusqu’à ce que vous décidiez de l’annuler."},"purchasingPlansError":{"generic":{"title":"Désolé!","desc1":"Une erreur s’est produite de notre côté et nous n’avons pas pu ajouter les données. Veuillez réessayer maintenant ou plus tard."},"speedpass":{"title":"Désolés!","desc1":"Une erreur s’est produite de notre côté et nous n’avons pas pu ajouter l’Accès Rapido. Veuillez réessayer maintenant ou plus tard."},"title":"Désolé!","desc1":"Une erreur s’est produite de notre côté et nous n’avons pas pu ajouter les données. Veuillez réessayer maintenant ou plus tard.","limitExceed":{"title":"Limite atteinte","titleSP":"Impossible d’ajouter un Accès Rapido","moreThanTenDescSP":"Malheureusement, vous ne pouvez pas acheter un Accès Rapido. Veuillez <a target=\"_blank\" href=\"https://www.rogers.com/consumer/support/contactus?setLanguage=fr\">communiquer avec nous</a> et nous vous proposerons quelques options.","moreThanThreeDesc":"Vous ne pouvez pas acheter plus de 3 options mensuelles Ajout de données identiques.","moreThanTenDesc":"Vous ne pouvez pas combiner plus de 10 primes, options mensuelles Ajout de données ou réapprovisionnements de données. <a target=\"_blank\" href=\"https://www.rogers.com/consumer/support/contactus?setLanguage=fr\">Veuillez communiquer avec nous</a> et nous vous aiderons avec plaisir."}},"consentError":{"title":"Communiquez avec le titulaire du compte","desc":"Désolé, le titulaire du compte ne vous a pas donné la permission d’autoriser des frais additionnels."},"warning":{"desc":"Veuillez sélectionner un montant.","descSP":"Veuillez sélectionner un Accès Rapido pour continuer","consentTitle":"Attention","consentDesc":"<p>En effectuant ce réapprovisionnement de données, vous aurez engagé des frais d’utilisation excédentaire de données de plus de <strong>50 $</strong> au cours de ce cycle de facturation.</p><p>Si vous continuez à utiliser des données une fois que cet ajout sera épuisé, nous vous les facturerons au tarif pour utilisation excédentaire prévu à votre forfait.</p> <p>De plus, en effectuant ce réapprovisionnement de données, vous convenez d’avoir un accès continu aux données jusqu’à la fin du cycle de facturation actuel.</p><p class=\"contiunue-purchase\"><strong>Êtes-vous certain de vouloir continuer à acheter ce réapprovisionnement de données?</strong></p> "}},"bpoHeroModal":{"heading":{"title":"Profitez de ces offres spéciales juste pour vous!","title2":"Profitez de ces offres spéciales juste pour vous!","planHeader":"Merci d’avoir choisi Rogers! Nous avons choisi quelques offres spéciales qui devraient vous intéresser.","planHeader2":"Merci d’avoir choisi Rogers! Nous avons choisi quelques offres spéciales qui devraient vous intéresser.","planTitle":"Lignes sur votre plan partagé","individualTitle":"Votre forfait Appels et textos","singleLineSeeOfferAvailable":"Voir les offres disponibles pour ","line":"Ligne","close":"Fermer","planTitleForCtn":"Voir les offres disponibles pour {{onlyctn}}"},"subHead":{"heroOffer":{"offerHeader":"Profitez de ces offres spéciales de Rogers! Choisissez-en autant que vous voulez."},"DeviceOffer":{"title":"Votre appareil en vedette","title_selected_alt":"Vous avez sélectionné cette offre d’appareil"},"planOffer":{"title":"Votre forfait exclusif","title_selected_alt":"Vous avez sélectionné cette offre de forfait"},"bpoOnlyDeviceOffer":{"title":"Prime avec appareil"},"bpoOnlyPlanOffer":{"title":"Prime avec forfait","noTxnDbTitle":"Offre de données en prime rien que pour vous!","noTxnMsfTitle":"Crédit sur facture en prime rien que pour vous!","noTxnLdTitle":"Une prime d’appels interurbains rien que pour vous!"}},"footer":{"getOffersLink":"Obtenir ces offres","getOfferLink":"Obtenir  cette offre","getOfferAltLink":"Continuez et ajoutez cette offre à votre forfait.","getOffersAltLink":"Continuez et ajoutez ces offres à votre forfait.","seeMorePlans":"Voir d’autres offres de forfait","seeMoreDevices":"Voir d’autres offres d’appareil","getNoTxnOfferLink":"Profiter de cette offre","getNoTxnOfferAltLink":"Continuez et ajoutez cette offre à votre forfait."},"offerDetail":{"heroPlanDetail":"<span>{{dataDisplayNameEn}}</span><span style=\"font-size:20px;\">{{dataDisplayUnitFr}}</span>","heroPlanDesc":"en passant à un forfait <span>{{hupOfferCategoryValueFr}}</span> avec un abonnement de <span>{{term}}</span> ans","hupOneTime":"Obtenez un rabais de <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup>","hupOneTimeContent":"Obtenez un rabais de <span>{{bpoDiscountValue}}</span> $ sur un nouvel appareil en effectuant un rehaussement avec un abonnement de 2 ans","hupUptoBonusCredit":"Crédit sur facture en prime qui fera baisser le prix du nouvel appareil","hupUptoContent":"Obtenez en prime un crédit sur facture allant jusqu’à <span>{{bpoDiscountValue}}</span> $ (ne peut pas dépasser le prix de l’appareil), qui fera baisser le prix d’achat du nouvel appareil, si vous procédez aujourd’hui à un rehaussement d’équipement en optant pour un abonnement de deux ans.","hupLongMinutes":"<span class=\"tvmBpoName\">+{{bpoBonusMinutes}}</span> minutes partout au Canada","hupLongMinutesContent":"Obtenez en prime <span>{{bpoBonusMinutes}}</span> minutes par mois pour partout au Canada pendant <span>{{bpoDuration}}</span> mois en rehaussant votre forfait aujourd’hui avec un abonnement de 2 ans","hupBpoMSF":"Économisez <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup> <span class=\"heroDiscountOff\">/mois pendant </span><span>{{bpoDuration}}</span> mois","hupBpoMSFTimeContent":"En vous procurant un nouvel appareil et en rehaussant votre forfait aujourd’hui!","hupMSF":"Obtenez un rabais de <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup> <span class=\"heroDiscountOff\">/mois</span>","hupMSFTimeContent":"Économisez <span>{{bpoDiscountValue}}</span> $ /mois pendant <span>{{bpoDuration}}</span> mois en rehaussant votre forfait avec un abonnement de 2 ans","hupDataBonus":"<span class=\"tvmBpoName\">+{{bpoBonusData}} {{bpoBonusDataUnitFr}}</span><span> de données</span>","hupDataBonusConTent":"Obtenez <span>{{bpoBonusData}} {{bpoBonusDataUnitFr}}</span> de données en prime pendant <span>{{bpoDuration}}</span> mois en rehaussant vers ce forfait en ligne","mo":"/mois","talk":"Appels:","text":"Messages texte:"},"bpoDetail":{"hupOneTime":"Rabais de <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup><span class=\"heroDiscountOff\"> pour une durée limitée</span>","hupOneTimeContent":"Échangez votre appareil contre le nouvel appareil DE VOTRE CHOIX et économisez <span>{{bpoDiscountValue}}</span> $ sur son prix","hupLongMinutes":"<span class=\"tvmBpoName\">+{{bpoBonusMinutes}}</span> minutes partout au Canada","hupLongMinutesContent":"Obtenez en prime <span>{{bpoBonusMinutes}}</span> minutes par mois pour partout au Canada pendant <span>{{bpoDuration}}</span> mois en rehaussant votre forfait aujourd’hui avec un abonnement de 2 ans","hupBpoMSF":"Économisez <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup> <span class=\"heroDiscountOff\">/mois pendant </span><span>{{bpoDuration}}</span> mois","hupBpoMSFTimeContent":"En vous procurant un nouvel appareil et en rehaussant votre forfait aujourd’hui!","hupMSF":"Obtenez un rabais de <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> <sup style=\"font-size: 20px;\">$</sup> <span class=\"heroDiscountOff\">/mois</span>","hupMSFTimeContent":"Économisez <span>{{bpoDiscountValue}}</span> $ /mois pendant <span>{{bpoDuration}}</span> mois en rehaussant votre forfait avec un abonnement de 2 ans","hupDataBonus":"<span class=\"tvmBpoName\">+{{bpoBonusData}} {{bpoBonusDataUnitFr}}</span>","hupDataBonusConTent":"Passez à un nouveau forfait et obtenez <span>{{bpoBonusData}} {{bpoBonusDataUnitFr}}</span> de données en prime pendant <span>{{bpoDuration}}</span> mois","noTxnDataBonus":"{{bpoBonusData}} {{bpoBonusDataUnitFr}} pendant {{bpoDuration}} mois","noTxnDataBonusConTent":"Obtenez <span>{{bpoBonusData}} {{bpoBonusDataUnitFr}}</span> de données en prime pendant <span>{{bpoDuration}}</span> mois. Ces données seront automatiquement ajoutées à votre compte pour vous remercier de votre fidélité!","noTxnMsf":"Économisez <span class=\"heroDiscountValue\">{{bpoDiscountValue}}</span> $ sur votre facture mensuelle!","noTxnMsfContent":"Obtenez un rabais de <span>{{bpoDiscountValue}}</span> $ pendant <span>{{bpoDuration}}</span> mois. Ce rabais sera appliqué automatiquement à votre facture pour vous remercier de votre fidélité!","noTxnLd":"Obtenez {{bpoBonusMinutes}} minutes d’interurbain!","noTxnLdContent":"Obtenez <span>{{bpoBonusMinutes}}</span> minutes d’appel partout au Canada pendant <span>{{bpoDuration}}</span> mois. Cette prime sera ajoutée automatiquement à votre forfait aujourd’hui pour vous remercier de votre fidélité!","hupUptoBonusCredit":"Crédit sur facture en prime qui fera baisser le prix du nouvel appareil","hupUptoContent":"Obtenez en prime un crédit sur facture allant jusqu’à <span>{{bpoDiscountValue}}</span> $ (ne peut pas dépasser le prix de l’appareil), qui fera baisser le prix d’achat du nouvel appareil, si vous procédez aujourd’hui à un rehaussement d’équipement en optant pour un abonnement de deux ans."}},"bpoHeroValidationModal":{"successTitle":"C’est fait!","successPlan":{"offerHeader":"La prime suivante a été ajoutée à votre forfait : {{dataFr}}"},"errorTitle":"Prime non appliquée","errorPlanHeader":"Nous n’avons pas pu ajouter cette prime à votre forfait. Veuillez réessayer. Si ce problème persiste, veuillez composer le <span style=\"text-decoration: underline; color: #3f6ea2;\">1 888-764-3771.</span>"},"rogers":{"user":{"registration":{"registration":"Enregistrement","email.not.matched":"Les adresses électroniques ne sont pas identiques. Veuillez réessayer.","email.address.not.valid":"Désolé, l'adresse électronique que vous avez entrée n’est pas valide.","email.verification":"Vérification","require.email":"Veuillez entrer une adresse électronique.","require.confirm.email":"Veuillez confirmer votre adresse électronique en la saisissant de nouveau.","account.already.associated":"Cette adresse électronique est déjà utilisée comme nom d’utilisateur MonRogers.  Veuillez choisir une autre adresse électronique ou ouvrir une session avec ce nom d’utilisateur &nbsp;","email.already.exists":"Cette adresse courriel est associée à un autre compte MonRogers. Veuillez en choisir une autre.","system.error.message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du ","system.error.message.p2":" pour démêler le tout.","email.verification.msg":"<p><strong>Nous vous avons envoyé un courriel d’activation de compte MonRogers.</strong></p><br/><p>Pour terminer votre inscription, consultez votre boîte de réception et ouvrez ce courriel. Veuillez suivre le lien dans le courriel pour créer votre mot de passe.</p><br/>","email.verfication.your.email":"Votre adresse courriel est","boldChat":{"cbid":"S_MRog_Wless_DevActError","dynamicDivId":"changeSimCard-en","chatButtonClass":"chatButtonChangeSimCard-en"}}},"captureDealerCode":{"enterYourDealerCode":"Entrez votre code de concessionnaire","enterDealerCode":"Entrer le code de concessionnaire","info":"Utilisez la bo&icirc;te ci-dessous pour entrer votre code de concessionnaire. Une fois le code entr&eacute;, le syst&egrave;me l'enregistrera pour une utilisation ult&eacute;rieure. Si vous devez effectuer une transaction pour un autre conseiller, vous devrez changer temporairement votre code de concessionnaire. ","onBehalfDealerCodeOne":"Choisir un autre code ","onBehalfDealerCodeTwo":"de concessionnaire","warningDescription":"Vous ne pourrez traiter aucune transaction si vous n'entrez pas de code de concessionnaire.","withOutDealerCode":"Proc&eacute;der sans code de concessionnaire","proceedWithSavedDc":"Continuer avec mon code de concessionnaire enregistr&eacute;","nowBehalfOfAgent":"Vous agissez maintenant au nom de ce conseiller :","messageDoNotDisplayPopUp":"Ne plus afficher ce message","useMyCode":"Mon code de concessionnaire","dealerCode":"Code de concessionnaire","noCode":"Num&eacute;ro de code","changeDealerCode":"Changer mon code de concessionnaire","generalError":"Nous sommes incapables d'associer votre compte Rogers &agrave; votre profil MonRogers pour l'instant. Veuillez r&eacute;essayer plus tard.","error":"Code de concessionnaire non valide","oops":"Oups!","submit":"Soumettre","edit":"Modifier","toolTip":"Si vous souhaitez agir au nom d’un autre conseiller pour cette session, veuillez entrer son code de concessionnaire ici."},"myrPaymentHelper":{"need_help_with_your_bill":"Vous avez besoin d’aide avec votre facture?","visit_billing_support":"Service de soutien","paynow_faq":"Voir la foire aux questions sur le paiement","boldChatButtonId":"S_MRog_Payment","boldChatButtonDiv":"payment-fr","boldChatButton":"chatButtonPayNowFr","reviewLink":"https://www.rogers.com/web/support/supportbillingpayment?setLanguage=fr"},"forgotPassword":{"description":"Veuillez entrer votre courriel <b>principal</b> pour réinitialiser votre mot de passe.","check.your.email":"Consultez votre boîte de réception.","check.email.message":"Nous avons envoyé un courriel à l’adresse {{email}}. Il comprend un lien pour créer un nouveau mot de passe pour votre compte MonRogers.","heading":"Mot de passe oublié","enterEmailAddress":"Entrez votre adresse électronique ci-dessous","liveChat":"Clavarder avec un aGENS de liaison","boldChat":{"cbid":"S_ForgotUNamePassRegIssues_Fr","dynamicDivId":"forgotUserName-Fr","chatButtonClass":"chatButtonForgotUserNameFr"},"email.not.found":"Désolé, nous ne trouvons pas l’adresse électronique que vous avez entrée. Assurez-vous d’entrer la bonne adresse et réessayez."},"setPassword":{"register":"Enregistrement","page_title":"Veuillez saisir un nouveau mot de passe","page_description":"Veuillez saisir un nouveau mot de passe pour votre compte MonRogers.","login_invalid_password":"Veuillez entrer un mot de passe valide","registration_too_short":"Veuillez entrer un mot de passe valide","registration_too_long":"Veuillez entrer un mot de passe valide","registration_number_only":"Veuillez entrer un mot de passe valide","registration_alphabet_only":"Veuillez entrer un mot de passe valide","registration_wrong_password":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caractères spéciaux. Veuillez réessayer.","password_not_matched":"Votre mot de passe et celui de confirmation ne sont pas semblables.","temp_password_guildeline":"Instructions pour créer votre mot de passe","temp_password_list_of_guildeline":"<br>Votre mot de passe doit être composé de 7 à 16 caractères et contenir des lettres et des chiffres.","setAndContinueBtn":"D&eacute;finir et continuer","new_password_placeholder":"Nouveau mot de passe","confirm_password_placeholder":"Confirmer le nouveau mot de passe"},"myrCreditCard":{"change_method_secure":"Paiement sécuritaire","change_method_info_secure_credit":"Les renseignements de votre carte de crédit ou de débit seront cryptés et sécurisés.","paynow_cc_placeholder":"Veuillez entrer le numéro de votre carte (sans espace).","paynow_cc_placeholder_ov":"Veuillez entrer le numéro de carte de crédit (sans espace).","paynow_card_number":"Numéro de carte","invalid_card_error":"Le numéro de carte n’est pas valide.","cyberSource_Down_error":"Désolé, une erreur s’est produite et votre paiement n’a pas été accepté.Veuillez réessayer en utilisant un autre mode de paiement.","non_numeric_security_code_error":"Veuillez entrer un code de sécurité numérique.","security_code_error":"Veuillez entrer un code de sécurité à {{numberOfDigits}} chiffres.","paynow_code":"Code de sécurité :","expiry_date_in_past":"La date d’expiration est passée.","paynow_month_required":"S'il vous plaît sélectionner un mois","paynow_year_required":"S'il vous plaît sélectionner une année","paynow_date_required":"Date d’expiration non valide","paynow_expiry_date":"Date d'expiration :","paynow_card_tooltip":"Le code de sécurité est un numéro à trois chiffres situé au verso de vos cartes Visa et MasterCard ou un numéro à quatre chiffres situé au recto de votre carte American Express.","paynow_continue_review":"Vérifier et continuer","paynow_how_do_i_pay":"Puis-je utiliser ma carte Visa Débit ou Débit MasterCard?","month_label":"MM","year_label":"AAAA","security_code_placeholder_3_4":"3 ou 4 chiffres","security_code_placeholder_3":"3 chiffres","security_code_placeholder_4":"4 chiffres","security_code_alt_text":"Qu’est-ce qu’un code de sécurité?","paynow_cc_info_tooltop":"Oui, vous pouvez utiliser votre carte Visa Débit ou Débit MasterCard. Entrez le numéro à 16 chiffres de la carte, sa date d’expiration et son code de sécurité, comme vous le feriez pour une carte de crédit."},"myrSemafone":{"creditCard_dealer":"Numéro de carte de crédit (cryptée)","creditCard":"Num%26eacute%3Bro de carte de cr%26eacute%3Bdit","ok":"Ok","encrypted_credit_card":"Carte de crédit cryptée","token_rejected":"Jeton Rejeté","dealer_note":"Placez le curseur dans le champ du numéro de carte de crédit. Faites glisser la carte dans le lecteur. Attendez que le lecteur traite les données, puis cliquez sur <i>OK</i> et entrez la date <i>d’expiration</i> ainsi que <i>le code de sécurité</i> de la carte.","one_view_secure_credit_card_payment":"Paiement par carte de crédit sécurisé","token_accepted":"Jeton Accepté. Sélectionne la date d'expiration et le code de sécurité","ovPaymentHeading":"Accepter un paiement par carte de crédit","ovInstructions":"Entrez le numéro de <strong>Référence de l’appel</strong> sur votre téléphone. Lorsque le champ du <strong>Numéro de carte</strong> est surligné et qu’une flèche noire apparaît, demandez au client d’entrer son numéro de carte au moyen du clavier de son téléphone. Une fois le numéro de carte saisi et que le champ devient vert, cliquez sur <strong>Segmenter en unités</strong>."},"myrSimCard":{"changeMySim":"Changer ma carte SIM","directions":"Entrez le numéro de votre carte SIM actuelle et celui de la nouvelle carte ci-dessous.","howToFindSerial":"<strong>Comment puis-je trouver le numéro de carte SIM de mon appareil?</strong>","serialNumberLocation":"Il y a deux méthodes pour vérifier votre numéro de carte SIM :","serialNumberLocationLabel":"Dos d’une carte SIM","firstWay":"<strong><u>Accédez aux paramètres de votre appareil</u></strong>","ios":{"osName":"<strong>iOS</strong>","firstBullet":"Ouvrez les <strong>réglages</strong> de votre appareil.","secondBullet":"Sélectionnez <strong>Général</strong>.","thirdBullet":"Sélectionnez <strong>Information</strong>.","forthBullet":"Le numéro d’identification de la carte SIM est la valeur ICCID."},"android":{"osName":"<strong>Android</strong>","firstBullet":"Ouvrez les <strong>paramètres</strong> de votre appareil.","secondBullet":"Sélectionnez  <strong>À propos du téléphone</strong>.","thirdBullet":"Sélectionnez  <strong>État</strong>.","forthBullet":"Le numéro d’identification de la carte SIM est la valeur ICCID. Si vous ne voyez pas le numéro de votre carte SIM, reportez-vous à la rubrique <strong>Regardez sur votre carte SIM</strong> ci-dessous."},"findSerialParagraph":"<strong>Rappel :</strong> La marche à suivre peut varier d’un modèle à un autre. Pour obtenir de plus amples renseignements, veuillez consulter le guide de l’utilisateur de votre appareil.","secondWay":"<strong><u>Regardez sur votre carte SIM</u></strong>","onSimCard":"Retirez la carte SIM de votre téléphone. Le numéro à 20 chiffres au dos de la carte est le numéro de carte SIM.","liveChat":{"cbid":"3579481122182599193","boldChatDiv":"F_CARE_Activating_SIM_Card","chatButton":"F_CARE_Activating_SIM_Card-fr"},"simCardChange":{"inputError_not20Digits":"Veuillez vous assurer d’entrer un numéro à 20 chiffres.","inputError_currentSim_notFound":"Veuillez vous assurer d’entrer le numéro de votre carte SIM actuelle dans le champ ci-dessous.","inputError_newSim_notFound":"Veuillez vous assurer d’entrer le numéro de votre nouvelle carte SIM dans le champ ci-dessous.","currentSim":"Numéro de la carte SIM actuelle","currentSimAlt":"Veuillez entrer le numéro de votre carte SIM actuelle.","newSim":"Numéro de la nouvelle carte SIM","newSimAlt":"Veuillez entrer le numéro de votre nouvelle carte SIM.","continue":"Continuer","cancel":"Annuler"},"simCardConfirmation":{"changeMySim":"Changer ma carte SIM","submit":"Soumettre","cancel":"Annuler","update":"Mettre &agrave; jour","resume":"Reprendre","cancel_changes":"Annuler les changements","ok":"OK","sub":"Votre numéro de carte SIM sera remplacé par :","messageBox_heading":"IMPORTANT : Ce changement entrera en vigueur immédiatement et est irréversible.","messageBox_body":"Votre ancienne carte SIM ne peut pas être réactivée ni réutilisée avec d’autres numéros de téléphone. N’oubliez pas de faire une sauvegarde des coordonnées que vous avez enregistrées sur votre carte SIM actuelle avant d'activer votre nouvelle carte.","popup_heading":"Êtes-vous certain de vouloir annuler les changements à la carte SIM?","sorry":"Désolé!","error_current_sim_invalid":"Il semble que le numéro de votre carte SIM ne soit pas valide.","error_new_sim_invalid":"Il semble que le numéro de la nouvelle carte SIM que vous avez entré ne soit pas valide.","error_new_sim_in_use":"Il semble que le numéro de la nouvelle carte SIM que vous avez entré a déjà été utilisé.","system_error_message":"Il semble qu’une erreur se soit produite de notre côté. Veuillez communiquer avec nous au moyen du ","system_error_message_p2":" pour démêler le tout. ","new.sim.has.been.used.before":"Il semble que le num&eacute;ro de la nouvelle carte SIM que vous avez entr&eacute; a d&eacute;j&agrave; &eacute;t&eacute; utilis&eacute;.","new.sim.has.invalid.sim.prefix":"Il semble que le num&eacute;ro de la nouvelle carte SIM que vous avez entr&eacute; ne soit pas valide.","new.sim.in.nfdb.message.care":"Veuillez ne pas passer cette commande. Veuillez ne pas modifier ou soumettre de nouveau cette commande. La commande ne pourra être effectuée qu’avec l’autorisation de l’équipe de validation de Rogers.","new.sim.in.nfdb.message.dealer":"Veuillez ne pas passer cette commande. Veuillez ne pas modifier ou soumettre de nouveau cette commande. La commande ne pourra être effectuée qu’avec l’autorisation de l’équipe de validation de Rogers.","new.sim.in.nfdb.message.consumer":"Désolé. Nous ne pouvons apporter ce changement. Veuillez communiquer avec l’équipe de validation de Rogers au 1–800–588–6718 pour obtenir de l’aide","please_follow_these_steps":"Veuillez suivre ces étapes :","ask_customer_message":"Demandez au client de communiquer avec l’équipe de validation de Rogers au 1 800 588-6718.","tell_the_customer_message":"Dites au client qu’il devra fournir son numéro de compte ou son nom de facturation et son adresse pour obtenir de l’aide.","error_current_sim_invalid_title":"Numéro(s) de carte SIM invalides","error_current_sim_invalid_body":"Vérifiez les numéros de carte SIM que vous avez entrés et réessayez.</br>Si ce message s’affiche de nouveau, <a href=\"/consumer/support/contactus\" title=\"communiquez avec nous\"><span class=\"lnk-txt\">communiquez avec nous</span></a>."},"boldChat":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"changeSimCard-fr","chatButtonClass":"chatButtonChangeSimCard-fr"},"simCardSuccess":{"heading":"C’est fait! Votre numéro de carte SIM a été modifié.","emailBody":"Un courriel de confirmation a été envoyé à :","body":"Pour continuer à utiliser vos services, veuillez insérer votre nouvelle carte SIM dans votre téléphone. Ensuite,  éteignez puis allumez votre appareil pour appliquer les changements.","backToAccount":"Retour à mon compte"}},"wireless":{"wirelessProductDiscountDetails":{"discounts":"Rabais","description":"Description du rabais","socCode":"Code SOC","discountCode":"Code du rabais","appliesSocCode":"S'applique au code SOC","effectiveDate":"Date d'entrée en vigueur ","expirationDate":"Date d'expiration ","notApplicable":"N/A","noSocAvailable":"Aucun SOC n’est associé à ce compte."},"overagetext":"Frais d&rsquo;utilisation exc&eacute;dentaire de","cbid":"S_MRog_Wless_ChngeWlessNum_Fr","dynamicDivId":"changeWirelessNumber-Fr","chatButtonClass":"chatButtonChangeWNumberFr","manage":"Gerer","networkAid":"InfoConnexion","deviceRepair":"Réparez votre appareil","usageDetails":"Détails de votre utilisation","viewDetails":"Voir les détails","unlockMyDevice":"Déverrouiller mon appareil","extras":"Extras","myExtras":"Mes extras","myRogers":"utilisez MonRogers","telli":"utilisez Telli","v21":"utilisez V21","mo":"/mo","otherSupport":"Soutien - Sans-fil","planDetails":"Détails du forfait","contractDetails":"Détails du contrat :","deviceModalHeading":"Détails de l’appareil","sim":"SIM :","rogersPlan":"Vorte forfait","yourDevice":"Mon appareil","support":"Soutien","talkTextLink":"Appels/ Textos Utilisation","talkTextModalHeading":"Appels/Textos Utilisation","on":"OUI","off":"NON","data":"data :","alerts":"alerts :","video":"VIDÉO:","videoSD":"SD","videoHD":"HD","soc":"Code SOC","effectiveDate":"Date d'entrée en vigueur","expirationDate":"Date d'expiration","appliesSoc":"S'applique au code SOC","discounts":"Les réductions","addons":"Ajouts & Code SOC","addonsAdded":"Ajouts & Code SOC","amount":"Amount","balance":"Solde de l'appareil","balanceToday":"(à ce jour) :","exUpfrontAmount":"(Excluant le montant du programme <strong style=\"font-weight: 600\">Voie express</strong><sub><small class='black'>MC</small></sub>)","toChangePlan":"Pour changer de forfait","toManageAddons":"Pour gérer les options","toChangePhoneNumber":"Pour changer le numéro de téléphone","toChangeCallerID":"Pour changer l’identification de l’appelant","toUpgradeDevice":"Pour rehausser l’appareil","toManageMY5M10":"Pour gérer mon top 5/mon top 10","youGet":"Vous obtenez aussi :","geotxt_access":"Accès","geotxt_extras_cta_title":"Accéder à Rogers GeoTxt","geotxt_access_modal_title":"Rogers GeoTxt","geotxt_access_modal_intro":"<b>Rogers GeoTxt <sub>MC</sub></b> est un service gratuit qui envoie des messages texte comportant des offres des meilleurs détaillants au Canada!","geotxt_access_modal_cta_sigIn":"Ouvrir une session","geotxt_access_modal_cta_register":"Inscription","geotxt_access_modal_cta_learnMore":"Détails","geotxt_access_modal_learnMore_desc":"Qu’est-ce que Rogers GeoTxt?","geotxt_access_modal_learnMore_option1":"Des messages texte sont envoyés à votre appareil en fonction de son emplacement géographique. Vous recevez ainsi les offres les plus pertinentes pour vous.","geotxt_access_modal_learnMore_option3":"Vous pouvez personnaliser votre expérience en choisissant de recevoir des offres des catégories qui vous intéressent le plus.","geotxt_access_modal_learnMore_option2":"Vous ne recevrez jamais plus de 5 messages texte de ce type par semaine.","geotxt_access_modal_learnMore_option4":"Offert exclusivement aux clients du service sans-fil postpayé de Rogers âgés de 18 ans ou plus.","monthlyDataAddOnCancelMessage":"Pour annuler une option Données en extra, textez « ANNULER » au 222.","warning_alert_content":"Votre plan expirera le ","warning_alert_content_sec":" et le dispositif UA doit être renvoyé par ","warning_alert_tooltip":"Le solde de votre appareil exclut le montant de votre compte Upfront Edge.","warning_rv_amount_content":"Vous êtes actuellement inscrit au programme Voie express. Votre abonnement de 2 ans prend fin le ","warning_rv_amount_content_sec":"Vous devrez bientôt décider de retourner votre téléphone ou de le conserver et de rembourser votre montant du programme Voie express de ","warning_two_rv_amount_content":"Vous devez maintenant décider de retourner votre téléphone dans un magasin Rogers ou de le conserver. Si vous gardez votre téléphone, le montant du programme Voie express de ","warning_two_rv_amount_content_sec":" sera porté à votre prochaine facture.","warning_alt_tag":"Alerte relative au forfait","plan_info":{"sharing":"partage de données","pooling":"Données groupées","voice":"Inscrit, mais ne partage pas"},"deviceProtection":"Protection de l’appareil"},"actionsOffers":{"actionsOffersBounds":{"offers":"Offres","searchOffers":"Rechercher des offres","byStatus":"Par statut","lineOfBusiness":"Secteur d’activité","reasonDeclined":"Raison du refus:","reasonDeclinedPlaceHolder":"Dites-nous pourquoi le client a refusé (facultatif)","cancel":"Annuler","decline":"Refuser","all":"Toutes","interested":"Interessé(e)","available":"Offerte","accepted":"Acceptée","declined":"Refusée","expired":"Expirée","interestedOn":"Intéressé le","acceptedOn":"Accepté le","declinedOn":"Refusé le","expiresOn":"Expire le","expiredOn":"A expiré le","on":"le","sms":"Texto","email":"Courriel","directmail":"Publipostage","telemarketing":"Télémarketing","inbound":"Entrante","outbound":"Sortante","searchPlaceholder":"Chercher code de programme, SOC ou SKU","value":"Valeur","details":"Détails","howTo":"Méthode","eligibility":"Admissibilité","filter_all":"Toutes","actions_and_offers":"ACTIONS et OFFRES"},"actionsOffersPanel":{"actions":"Actions","yes":"Oui","no":"Non","genericError":"Oups! Nous rencontrons actuellement des problèmes techniques et nous veillons à les résoudre dès que possible. Si vous nous envoyez des commentaires au sujet de cette erreur, veuillez mentionner le code d’erreur 888.","genericErrorNoCode":"Oups! Nous rencontrons actuellement des problèmes techniques et nous veillons à les résoudre dès que possible. Si vous nous envoyez des commentaires au sujet de cette erreur, veuillez mentionner le code d’erreur ","noActions":"Aucune action disponible.","noOffers":"Aucune offre disponible.","showFullDetails":"Afficher les détails","hideFullDetails":"Masquer les détails"},"actionsOffersWidget":{"january":"JA","february":"FE","march":"MR","april":"AV","may":"MA","june":"JN","july":"JL","august":"AU","september":"SE","october":"OC","november":"NO","december":"DÉ","noActionsOffers":"Aucune action ou offre disponible.","close":"Fermer","value":"Valeur","details":"Détails","howTo":"Méthode","eligibility":"Admissibilité","viewNova":"À voir dans Nova","termsConditions":"Modalités"}},"promiseToPay":{"promiseToPay":"Promesse de paiement","lastPromiseToPay":"Dernière promesse de paiement :","eligibleForPromiseToPay":"Admissible à la promesse de paiement","latePayment":"Des frais de retard peuvent s’appliquer.","serviceRestored":"Si le service est suspendu, un frais de suspension peut s’appliquer à votre prochaine facture. (Sauf les clients ayant une adresse de facturation du Québec et les suspensions dues à une suspension du CLA)","collectionActivities":"Veuillez informer le client que le fait de signaler un paiement ou de faire une promesse de paiement du montant en souffrance total dans les 11 jours évitera d’autres mesures de recouvrement.","downgradeService":"Les services ayant été déclassés ne seront pas rétablis tant que le paiement n’aura pas été inscrit au compte.","systemUnavailable":"Système non disponible","sorryMsg":"Nous ne pouvons pas traiter votre demande pour le moment.","tryLater":"Veuillez réessayer plus tard.","close":"FERMER","checkEligibility":{"checkEligibility":"Vérifier l’admissibilité","totalAccountBalance":"Solde total du compte:","pastDueBalance":"Montant en souffrance:","pendingPromiseToPay":"Promesse de paiement en attente:","transferToCredit":"Acheminez l’appel au service des opérations de crédit si :","transferToCreditOption1":" Le client veut payer en envoyant des chèques postdatés par la poste.","transferToCreditOption2":" Le client veut faire une promesse de paiement en plusieurs versements.","transferToCreditOption3":"Le client veut mettre à jour une promesse de paiement.","generic_error_message":"Le contenu n’est pas disponible pour l’instant. Veuillez essayer de nouveau.","reason":"Raison","pleaseInfo":"Veuillez donner les renseignements suivants au client :"},"messageBanner":{"success":"Admissible à la promesse de paiement","PTPINELIGIBLE2":"Le compte est résilié.","PTPINELIGIBLE3":"Le compte est suspendu.","PTPINELIGIBLE4":"Le compte a été désactivé.","PTPINELIGIBLE5":"Le compte comprend déjà une promesse de paiement.","PTPINELIGIBLE6":"Le compte fait l’objet d’un débranchement pour non-paiement.","PTPINELIGIBLE7":"Catégorie de risque du compte ou historique de paiement","brokenPTPmessage":"La promesse de paiement précédente n’a pas été respectée (défaut de paiement).","generic_error_message":"Le contenu n’est pas disponible pour l’instant. Veuillez essayer de nouveau.","inEligibleForPromiseToPay":"Promesse de paiement non admissible pour les raisons suivantes :","reason":"Raison"},"schedulePTP":{"paymentAmount":"Montant du paiement","paymentMethod":"Mode de paiement","selectPaymentDate":"Sélectionner une date de paiement ","postingDate":"Date d’envoi estimée: ","cancel":"Annuler","schedulePTPBtn":"Planifier la promesse de paiement","paymentAmountError":"Désolé, ce montant du paiement n'est pas valide. Veuillez réessayer.","paymentMethods":{"0":"Payé par téléphone ou Internet","1":"Magasin Rogers ","2":"ERAP","3":"Carte de crédit ou débit","4":"Banque","5":"Guichet automatique","6":"Marge de crédit bancaire","7":"Succursale bancaire","8":"Rogers Vidéo et autres magasins","9":"Poste","10":"Carte de crédit ou Interac","11":"Western Union/chèque certifié","12":"Argent","13":"Magasin Fido","14":"Entrée paiement","15":""},"pendingPTPmessage1":"<b>Une promesse de paiement est maintenant en attente.</b> Une interaction comportant une promesse de paiement a été créée pour ce client.","pauseCollection":"Une promesse de paiement dont la date d’inscription du paiement est dans 11 jours pourrait ne pas entraîner la suspension des activités de recouvrement.","placeHolderValue":"0,00"},"tabs":{"takePayment":"Prendre un paiement","promiseToPay":"Promesse de paiement"}},"account":{"balance":{"delinquent":"En souffrance","current.account.balance":"Solde actuel du compte","view.call":"Voir les appels/Historique des transactions","suspended":"Suspendu","suspended_msg":"Au moins un de vos services est suspendu.  <br/> <span class=\"red-text\">Effectuez un paiement ci-dessous</span> ou établissez une entente de paiement avec l’un de nos agens de liaison.","total_balance":"Total du solde","required_payment_date":"Date d’exigibilité du paiement : ","view_your_bill":"Afficher votre facture","view_current_bill":"Afficher la facture courante","welcome_back":"Bienvenue","welcome":"Bienvenue","make_a_payment":"Faire un paiement","boldchat_cbid":"7671257342256042461","nearing_credit_limit_title":"Limite de crédit bientôt atteinte","almost_credit_limit_title":"Limite de crédit presque atteinte","credit_limit_exceeded_title":"Limite de crédit dépassée","over_credit_limit":"Dépassement de la limite de crédit : ","credit_limit":"Limite de crédit : ","used_credit":"Crédit utilisé : ","remaining_credit":"Crédit restant :","recommended_pay":"Nous vous conseillons de rembourser","reached_over_60_percent_desc":"Vous avez atteint <strong>plus de 60 %</strong> de votre limite de crédit. Pour ne pas la dépasser, veuillez <strong>faire un paiement.</strong>","reached_over_75_percent_desc":"Vous avez atteint <strong>plus de 75 %</strong> de votre limite de crédit. Veuillez <strong>faire un paiement</strong> maintenant.","credit_limit_exceeded_desc":"Vous avez dépassé votre limite de crédit et vos services sont suspendus. Pour les réactiver, veuillez <strong>faire un paiement.</strong>","add_to_calendar":{"button_label":"Ajouter au calendrier","dropdown_title":"Choisissez votre calendrier : ","event_title":"Rappel - Paiement de votre facture Rogers","location":"Votre compte MonRogers","description":"N’oubliez pas de payer votre facture Rogers aujourd’hui. Allez à MonRogers pour effectuer votre paiement dès maintenant."},"oneView":{"accountBalance":"Solde du compte aujourd’hui","suspendedMsg":"Au moins un de ces services est suspendu.","reached_over_60_percent_desc":"Le client a atteint <strong>plus de 60 %</strong> de sa limite de crédit. Demandez-lui s’il veut effectuer un paiement pour s’assurer de ne pas la dépasser.","reached_over_75_percent_desc":"Le client a atteint <strong>plus de 75 %</strong> de sa limite de crédit. Il devrait faire un paiement maintenant.","credit_limit_exceeded_desc":"Le client a dépassé sa limite de crédit et ses services sont suspendus. Proposez-lui de faire un paiement pour les réactiver."},"ovo_credit_limit_text":"Crédit de {{amount}} disponible","ovo_credit_limit_exceeded_text":"Limite de crédit dépassée","ovo_credit_limit_link_text":"Détails","ovo_credit_limit_total_credit_text":"Montant total du crédit","ovo_credit_limit_credit_used_text":"Montant du crédit utilisé ","ovo_due_text":"Date d’exigibilité du paiement","ovo_ptp_text":"PDP","ovo_take_payment":"Recevoir un paiement","ovo_make_adjustment":"Gestion du credit","ovo_total_balance":"Solde total"}},"internetDashboard":{"goToSGI":"allez dans SGI","toChangePackage":"Pour changer de forfait","toChangeModem":"Pour changer le modem","selfServeOnly":"Libre-service seulement"},"paymentTopBar":{"consumer":{"method_cc":"Paiements automatiques – Carte de crédit","method_debit":"Paiements automatiques – Compte bancaire","method_manual":"Manuel"}},"myrViewBill":{"onlineBillFAQ":"Foire aux questions concernant la facture en ligne","yourBill":"Votre facture","selectBill":"Choisir une facture","billing_video_modal_link_text":"Familiarisez-vous avec votre facture en ligne. Regardez cette vidéo!","billing_video_modal_header":"Familiarisez-vous avec votre facture en ligne.","billing_video_modal_how_to_header":"Votre facture en ligne est maintenant plus facile à comprendre. Cette vidéo porte sur les sujets suivants :","billing_video_modal_how_to_item1":"Comment savoir sur quoi on dépense et combien on économise chaque mois","billing_video_modal_how_to_item2":"Présentation plus détaillée des frais et des changements apportés","billing_video_modal_how_to_item3":"Détails de l’utilisation","billing_video_modal_how_to_item4":"Savoir où obtenir des réponses, des conseils et du soutien","billing_video_modal_youtube_video":"https://www.youtube.com/embed/Up5CKFxHzdQ","billNotificationForOnlineBillWithEmail":"<span>Votre facture de {{monthName}} sera prête sous peu.</span> Un courriel sera envoyé à l'adresse {{email}} aussitôt que celle-ci sera disponible.","billNotificationForOnlineBillNoEmail":"<span>Votre facture de {{monthName}} sera prête sous peu.</span> Un courriel sera envoyé aussitôt que celle-ci sera disponible.","billNotificationForPaperBill":"<span>Votre facture de {{monthName}} sera prête sous peu.</span> Nous vous l'enverrons par la poste dès qu'elle sera prête."},"rhpDashboard":{"homePhone":"Téléphonie résidentielle","at":"à","myPackage":"Mon forfait","homePhoneFeatures":{"title":"Fonctions de la Téléphonie résidentielle"},"OnlineManager_RHP":{"tooltip":"<div class=\"font-medium\">Qu'est-ce que le Gestionnaire en ligne?</div><span>Le Gestionnaire en ligne permet de gérer les fonctions suivantes de la Téléphonie résidentielle:</span><ul><li>Blocage des demandeurs indésirables</li><li>Composition rapide</li><li>Renvoi d'appel - Tous les appels/Mes amis et ma famille</li><li>Refus des appels anonymes</li><li>Laisser passer les appels de mes amis et de ma famille</li><li>Alerte d'appels interurbains</li><li>Sonnerie unique pour les amis et la famille</li><li>Nombre de sonneries pour la Messagerie vocale</li><li>Liste des contacts</li><li>Ne pas déranger</li></ul>","alt":"En savoir plus sur le Gestionnaire en ligne"},"configureYourFeatures":"Configuration des fonctions","voiceMailSettings":"Paramètres de messagerie vocale","resetVoiceMailPassword":"Mot de passe de la messagerie","contactMangerFeatures":"Ajout/suppression de fonctions","configureYourFeaturesRep":"Configurer les fonctions ","voiceMailSettingsRep":"Acc&eacute;der aux param&egrave;tres de messagerie vocale","resetVoiceMailPasswordRep":"R&eacute;initialiser le mot de passe de la messagerie vocale ","contactMangerFeaturesRep":"Ajouter ou supprimer des fonctions ","additionalFeatures":"Additional Features","cancelRHPService":"Annuler votre service Téléphonie résidentielle","resetVoiceMailPasswordText":"Réinitialiser le mot de passe de la Messagerie vocale","resetVoiceMailPasswordBody":"Le mot de passe sera remplacé immédiatement par les quatre derniers chiffres de votre numéro de téléphone résidentiel.","resetVoiceMailPasswordButton":"Réinitialiser mon mot de passe","cancel":"Annuler","resetVoiceMailPasswordSuccessHeader":"C'est fait!","resetVoiceMailPasswordSuccessBody":"Le mot de passe de votre Messagerie vocale a été réinitialisé.","home_phone_contact_care_phoneNumber":"1-855-720-9039","manageFeatureHeader":"Vous voulez ajouter ou supprimer des fonctions?","resetVoiceMailPasswordHeader":"Besoin d’un nouveau mot de passe de messagerie vocale?","managerFeatureBody":"Veuillez communiquer avec nous pour obtenir de l’aide.","rhp_error_text":"Désolé! Nous ne pouvons pas afficher vos renseignements. Nous tentons de régler le problème.","manageYourHomePhone":"Votre téléphonie résidentielle","manageYourHomePhoneRep":"G&eacute;rer les fonctions ","ok":"OK","rhp_live_chat_url":"4651541516756588337","rhp_contact_care_phoneNumber_url":"tel:8557209039","viewHomePhoneFeatures":"Afficher les fonctions de la Téléphonie résidentielle","liveChat":"Clavardage en direct","selfServeOnly":"libre-service seulement","goToSGI":"allez dans SGI","goToNova":"allez dans <a class=\"nova-link\" href=\"http://nova.rogers.com/infocenter/index?page=l_content&id=REF713&uevt=Language_document&viewlocale=fr_CA\"><span>Nova</span><i class=\"rui-icon-share\" style=\"padding-left: 0.5rem\"></i></a>"},"signin":{"intro":"G&eacute;rez vos services, consultez vos factures en ligne et faites bien d&rsquo;autres t&acirc;ches dans un environnement s&eacute;curis&eacute;."},"tvDashboard":{"goToSGI":"allez dans SGI","goToTSP":"allez dans le portail du soutien technique","toChangePackage":"Pour changer de forfait","toChangePlan":"Pour changer de forfait","toAddThemePacks":"Pour ajouter des forfaits à thème","toAddChannels":"Pour ajouter des chaînes","toAddDigitalBox":"Pour ajouter un terminal numérique","toResetDigitalBox":"Pour réinitialiser le terminal numérique","toResetDigitalPin":"Pour réinitialiser le NIP du terminal numérique","toAddOutlets":"Pour ajouter des prises"},"wireless_dashboard":{"wireless_next_bill_days_until":"Il reste <span class=\"wireless-next-billing-date\">{{nextbilldaysuntil}} jours</span> avant le début du prochain cycle de facturation mensuel","next_billing_months":{"1":"({{startDay}} janv.)","2":"({{startDay}} févr.)","3":"({{startDay}} mars)","4":"({{startDay}} avr.)","5":"({{startDay}} mai)","6":"({{startDay}} juin)","7":"({{startDay}} juil.)","8":"({{startDay}} août)","9":"({{startDay}} sept)","10":"({{startDay}} oct.)","11":"({{startDay}} nov.)","12":"({{startDay}} déc.)"}}},"secondLevelNavigation":{"suspendedStatus":"Suspendu","cancelledStatus":"Annuler"},"rename":{"me":{"please":{"renameMePlease":"rename_me_please_fr"}}},"bfa":{"ppc":{"ppc_something_went_wrong_message_title":"Désolé, une erreur s’est produite.","ppc_something_went_wrong_message_text":"Nous tentons de régler le problème le plus rapidement possible. En attendant, nous avons sauvegardé vos sélections, alors vous pouvez téléphoner au Service à la clientèle ou utiliser notre service de clavardage en direct afin d’obtenir de l’aide pour terminer votre commande.","mppc_on_brt_no_permission_text":"Pour changer votre forfait, veuillez communiquer avec nous :","errors":{"modal":{"800NumberSuspended":"1 877 559-5202","800Number":"1 855 720-9038","cancel":"Annuler","ok":"OK","confirm":"CONFIRMER","continue":"Continuer","confirmPlanChange":"CONFIRMER LE CHANGEMENT DE FORFAIT","removeAddon":"RETIRER L’OPTION","goBack":"RETOUR"}},"addAditionalDataModal":{"mppc_entry_3_title":"Puisque vous ajoutez une nouvelle ligne à votre forfait <strong>Partagez tout<sub>MC</sub></strong>, vous devrez peut-être ajouter des données additionnelles à votre compte pour compenser l’utilisation supplémentaire. Aimeriez-vous ajouter des données à votre forfait?","mppc_entry_3_yes":"Oui","mppc_entry_3_no":"Non"},"entry1Modal":{"mppc_entry_1_change_current_plan":"Modifier votre forfait actuel","mppc_entry_3_or":"Ou","mppc_entry_1_create_shared_plan":"Faites passer vos autres lignes au forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_entry_1_cancel":"Annuler"},"entry3Modal":{"mppc_entry_3_change_wireless_plan":"Changer votre forfait","mppc_entry_3_change_current_plan":"Modifier votre forfait actuel","_continue":"Continuer","mppc_entry_3_or":"Ou","mppc_entry_3_add_to_share_plan":"Ajouter cette ligne à votre forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_entry_3_cancel":"Annuler"},"sharedGroupIndividualModal":{"mppc_shared_group_indiv_title":"Ajouter vos autres lignes à votre forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_shared_group_indiv_benefits":"Quels sont les avantages?","mppc_shared_group_indiv_switch_reason_intro":"Toutes vos lignes partageront les mêmes fonctions dont vous profitez actuellement :","mppc_shared_group_indiv_switch_reason_1":"Lot de données à partager","mppc_shared_group_indiv_switch_reason_2":"Appels et messages texte illimités, conformément à votre forfait","mppc_shared_group_indiv_switch_reason_3":"Partout chez vous<sub>MC</sub>","mppc_shared_group_indiv_switch_reason_4":"GameCentre LIVE<sub>MC</sub> de la LNH par Rogers<sub>MC</sub>","_cancel":"Annuler","_add":"Ajouter"},"sharedGroupPrimaryModal":{"mppc_shared_group_primary_title":"Sélectionner une ligne principale pour votre nouveau forfait <strong>Partagez tout<sub>MC</sub></strong>","_continue":"Continuer"}}},"changeCtnCallerId":{"initial":{"heading":"Modifier mon nom pour l’affichage des appels","sub_heading":"Votre nom pour l’affichage des appels est le nom qui apparaît à l’écran d’un autre appareil lorsque vous téléphonez à quelqu’un et à la section Sommaire de l’utilisation pour cette ligne sur votre facture Rogers.","your_number":"Votre numéro :","current_caller_id_name":"Nom actuel pour l’affichage des appels :","note_text":"<strong>Remarque :</strong> Un changement de nom pour l’affichage des appels entraînera l’ajout d’un nouveau nom à ce compte. Toute personne pouvant accéder au compte sera en mesure d’effectuer des modifications de forfaits, en plus d’acheter ou de supprimer des services optionnels, comme les options ou les trousses Voyage.","labelFirstName":"Prénom :","labelLastName":"Nom de famille :","continueButton":"Continuer","cancelButton":"Annuler","update_and_continue":"Modifier et continuer","processing_button":"Traitement en cours...","change_failed":"Impossible de modifier","validationErrors":{"common":{"required":"Veuillez entrer un nom. Ne laissez pas ce champ vide.","specialCharacters":"Votre nom de famille ne doit pas comporter de chiffre ni de caractère spécial.","badWords":"Ce mot n’est pas permis."},"firstName":{"invalid":"Veuillez entrer un prénom valide","moreThanTwoWords":"Vous pouvez entrer un maximum de deux prénoms."},"lastName":{"invalid":"Veuillez entrer un nom valide","moreThanTwoWords":"Veuillez entrer un nom valide"}}},"change":{"sub_heading":"Veuillez passer en revue vos changements ci-dessous","sub_heading_rep":"Il s’agit du nom qui apparaît sur la facture du client et s’affiche quand il effectue un appel.","labelNumberForRep":"Numéro du client","old_caller_id_name":"Ancien nom pour l’affichage des appels :","new_caller_id_name":"Nouveau nom pour l’affichage des appels :","disclaimer_one":"Je reconnais avoir lu, compris et accepté la ","disclaimer_link":"http://www.rogers.com/cms/pdf/fr/Rogers-Terms-of-Service-Acceptable-Use-Policy-and-Privacy-Policy-fr.pdf","disclaimer_link_text":"Politique d’utilisation acceptable de Rogers.","disclaimer_two":" En modifiant le nom pour l’affichage des appels sur mon appareil, j’accepte de ne pas participer à des activités frauduleuses, notamment en me faisant passer pour une autre personne ou entité ou en contrefaisant la signature numérique ou manuelle d’une autre personne. Je comprends que si Rogers estime que mon compte est utilisé d’une façon qui, à sa seule discrétion, représente un manquement à la Politique d’utilisation acceptable de Rogers, elle peut prendre des mesures appropriées, notamment la résiliation immédiate des services à mon compte.","instructions_label":"Votre nom pour l’affichage des appels ne devrait pas comprendre ce qui suit :","instructions_label_rep":"Ce que votre nom pour l’affichage des appels ne doit pas contenir","instructions":{"specialChars":"Des caractères spéciaux ( ! @ # $ % ^ & * )","profanities":"Un langage vulgaire","prohibited":"Des mots interdits comme « Inconnu » ou « Urgence »"}},"common":{"liveChatButton":"Clavardage en direct","doneButton":"Terminé","speakToAnAgent":"Speak to an agent online"},"core":{"linkText":"Modifier mon nom pour l’affichage des appels","linkTextForRep":"Modifier le nom pour l’affichage des appels"},"success":{"heading":"C’est fait! Le nom qui s’affiche quand vous appelez quelqu’un a été mis à jour.","sub_heading":"Veuillez prévoir un délai de 24 heures avant que le changement entre en vigueur.","cc_success_id_text":"Nouveau nom pour l’affichage des appels","done_button":"Terminé"},"failure":{"heading":"Nous sommes désolés. Une erreur s’est produite.","serverError":"La mise à jour de votre nom pour l’affichage des appels a échoué. Veuillez réessayer plus tard.","is_still_known_text":"est encore associé au nom pour l’affichage des appels suivant","description":"La mise à jour de votre nom pour l’affichage des appels a  échoué. Veuillez réessayer plus tard.<br>Vous avez besoin d’aide tout de suite? Communiquez avec nous par téléphone ou clavardage.","chatLinkText":"Clavardage en direct","helpNumber":"composez le 1-855-381-7834","boldChatButton":{"cbid":"S_MRog_Wless_ChngeWlessNum_Fr","boldChatDiv":"CCTNCID-live-chat","chatButton":"CCTNCID-live-chat-fr"}},"notEligible":{"heading":"Vous avez atteint la limite de changements de nom autorisée pour l’affichage des appels.","original_caller_id_name":"Nom d’origine pour l’affichage des appels :","contact_us":"Si vous avez besoin d’aide, contactez-nous par  ","phone_no":" ou composez le 1-855-381-7834."}},"commonFilters":{"dataConversion":{"kb":" Ko","mb":" Mo","gb":" Go","tb":" To"}},"dataManager":{"title":"Gestionnaire de données","infiniteAlert":{"body":"Vous avez un forfait Infini de Rogers<sub>MC</sub> avec données illimitées. Fini les frais d’utilisation excédentaire de données! <br/><strong>Pour le cycle de facturation actuel, l’utilisation de données ci-dessous pourrait être inexacte.</strong> <br/><strong>L’information sera exacte au cycle suivant.</strong>","closeLabel":"FR - close label"},"error":{"systemErrorMessage":"FR Generic system error has occurred.","bucketSizeUnavailableHeader":"","bucketSizeUnavailableBody":"Veuillez prendre note qu’étant donné le changement apporté à votre forfait, nous ne pouvons afficher qu’une quantité limitée de renseignements pendant le reste de ce cycle de facturation mensuel.","prorationErrorHeader":"Renseignements partiels sur l’utilisation disponibles","prorationErrorBody":"Les renseignements sur l’utilisation que vous recherchez peuvent être inexacts ou incomplets en ce moment, mais ils devraient être ajustés au début de votre prochain cycle de facturation. Sinon, veuillez communiquer avec nous."},"info":{"limitedDataHeader":"Nous ne sommes pas en mesure d’indiquer avec exactitude le volume de données utilisé.","limitedDataBody":"En raison d’un changement de forfait, nous ne sommes pas en mesure d’indiquer avec exactitude le volume de données excédentaire.","planChangeDataHeader":"Vous avez changé de forfait.","planChangeDataBody":"Bonne nouvelle! Si votre nouveau forfait comprend plus de données, profitez-en. Sinon, vous conservez le plus gros lot de données jusqu’à la fin du cycle de facturation en cours."},"historical":{"link":"Utilisation antérieure des données partagées"},"months":{"0":"janvier","1":"février","2":"mars","3":"avril","4":"mai","5":"juin","6":"juillet","7":"août","8":"septembre","9":"octobre","10":"novembre","11":"décembre"},"accountsSummary":{"used":"Données utilisées :","swipeLeftOrRight":"Glissez vers la gauche ou la droite","toSeeLines":"pour voir vos lignes","leftGroupStillSharing":"Ancien forfait : toujours partagé","joinedGroup":"L' utilisation de vue {{displayCTN}}","loader":"Ajout de données…","reduceVideoQuality":"Gérer la qualité de lecture de vidéos en continu","help":"Regardez jusqu’à trois fois plus de vidéos avec votre forfait actuel.","learnMore":"Détails","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard.","dataAccessOff":{"accessOff":"Accès aux données bloqué"},"addedBar":{"dataAdded":"ajout"},"dataAlertAt":{"alertAt":"Envoyer une alerte à :","saveButton":"","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas d’activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard.","errorSecondaryUseAlertsOn":"Nous ne pouvons pas activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard.","errorSecondaryUseAlertsOff":"Nous ne pouvons pas désactiver l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard."},"footer":{"dataSummary":"Sommaire des données","totalPlan":"Total données forfait","totalUsed":"Utilisés","totalAlerts":"Alertes programmées"},"header":{"title":"Utilisation de données et alertes","addData":"Ajouter des données","upgrade":"Changer de forfait","dataDelayMessage":"Vous ne voyez pas les données que vous avez ajoutées?","dataDelayHeader":"Vous ne voyez pas les données que vous avez ajoutées?","dataDelayBody":"Nous avons ajouté données à votre compte. L’affichage des changements aux données effectués récemment peut prendre jusqu’à 30 minutes.","singleAccountMessage":"Sélectionnez votre numéro pour commencer à gérer vos données","multiAccountMessage":"Choisissez la ligne pour laquelle vous voulez gérer les données"},"individualHeader":{"data":"Accès aux<br> données :"},"noDataAlert":{"noAlerts":"Aucune alerte programmée","turnAlertsOn":"Activer les alertes","errorHeading":"Petit problème...","errorSecondaryUseAlertsOn":"Nous ne pouvons pas activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard."},"noDataPlan":{"noDataPlan":"Aucun forfait Données","addData":"Ajouter des données"},"overageBar":{"overUsage":"Excédent"},"swipe":{"instructions":"Glissez vers la gauche ou la droite","instructions2":"pour voir vos lignes"},"tabs":{"alerts":"Alertes","videoAndStreaming":"<b>Maximiseur de données</b><sub>MC</sub>","new":"NOUVEAU!"}},"badge":{"list":{"infinitePlan":"Forfait Infini de Rogers<sub>MC</sub>","linesInGroup":"{{lines}} ligne(s) sans fil comprises dans ce forfait","headBadgeLabel":"Consulter et gérer les services sans-fil","exclusiveOffer":"OFFRE EXCLUSIVE"}},"dashboard":{"heading":"Mon forfait Partagez tout"},"dataAccess":{"on":"OUI","off":"NON","blockDataNow":"Bloquer l’accès aux données","cancel":"Annuler","errorHeading":"Petit problème...","errorSecondaryDataOn":"Nous n’avons pas été en mesure d’activer l’accès aux données. Veuillez réessayer plus tard.","errorSecondaryDataOff":"Nous n’avons pas été en mesure de désactiver l’accès aux données. Veuillez réessayer plus tard.","modal":{"heading":"Suspendre l’accès aux données jusqu’à la fin du cycle de facturation pour :","secondaryCopy":"Vous pouvez changer d’idée et réactiver l’accès aux données à tout moment.","body":"De plus, {{displayCTN}} recevra également un message l’informant du changement!","option":"Vous avez besoin de plus de données? Il suffit d’ajouter des données ou de changer de forfait pour qu’il réponde mieux à vos besoins.","upgrade":"Changer de forfait","increase":"Ajouter des données ce mois-ci","confirmButton":"Désactiver la transmission de données","cancel":"Annuler"}},"dataAlerts":{"myAlert":"Mes alertes de données","myVTAlert":"Données","manage":"Gérer","manageVideoStreaming":"<b>Maximiseur de données</b><sub>MC</sub>","manageAlerts":"Gérer Mes données","linkTag":"Pourquoi configurer une alerte?"},"dataAndVideoThrottleWrapper":{"setVideoQuality":"<b>Maximiseur de données</b><sub>MC</sub>","manageAlerts":"Gérer mes données","new":"NOUVEAU!","manageDataAlerts":"Gérez les alertes","videoAndStreaming":"<b>Maximiseur de données</b><sub>MC</sub>","openDataAlerts":"Gérer mes données","closeDataAlerts":"Fermer Mes données"},"dataControlList":{"sharedLines":"Mes lignes partagées","myLines":"FR - My Lines","closeDataAlerts":"Fermer mes alertes Données","openDataAlerts":"Gérer l’utilisation des données et les alertes","space":" ","mySharedLines":"Mes lignes partagées","dataAlertsByLine":"Alertes Données par ligne","alertedDataTotal":"Seuils d’alerte programmés :<br/>","alertedDataTotalFooter":"Seuils d’alerte programmés :","addData":"Ajouter des données","addSpeedPass":"Ajouter Accès Rapido","dataAccess":"Accès aux données","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard.","manageDataAlerts":"Alertes","videoAndStreaming":"<b>Maximiseur de données</b><sub>MC</sub>"},"errorPage":{"heading":"Une erreur s’est produite. Nous sommes désolés!","suggestion":"Veuillez réessayer plus tard.","button":"Revenir à l’aperçu du compte","issue":"Malheureusement, nous rencontrons quelques difficultés charger votre plan."},"increasePlan":{"increaseData":"Vous avez besoin de<br class=\"hidden-xs\"/> plus de données ce mois-ci?","firstBody":"Textez <strong>DONNEES</strong> au <strong>222</strong> pour connaître les options et les prix. Vous n’aurez pas à payer pour ce message texte. Les frais s’appliquent seulement si vous sélectionnez une option, et vous pouvez l’annuler en tout temps.","question":"Quelle quantité de données de plus?","f":"pour","addData":"Ajouter des données","errorHeading":"Petit problème...","errorBody":"Le processus d’achat a été interrompu. Veuillez réessayer plus tard.","errorBodyTopupOptions":"Nous ne pouvons pas afficher vos options de réapprovisionnement en données pour le moment. Veuillez réessayer plus tard. "},"wcocConsent":{"heading":"Confirmation de réapprovisionnement de données","firstBody":"Vous êtes sur le point de réapprovisionner votre compte avec le lot suivant :","f":"pour","secondBody":"En ajoutant ce lot, vous aurez engagé des frais d’utilisation excédentaire de données de plus de <strong>50 $</strong> au cours de ce cycle de facturation.<br/><br/>Si vous consommez toutes les données de ce lot sans en rajouter, toute utilisation additionnelle sera facturée au tarif d’utilisation excédentaire prévu à votre forfait.<br/><br/>En réapprovisionnant votre compte ainsi, vous convenez d’avoir un accès continu aux données jusqu’à la fin du cycle de facturation actuel. Vous ne recevrez plus de notifications d’utilisation excédentaire et votre accès aux données ne sera pas interrompu.<br/><br/><strong>Êtes-vous certain de vouloir réapprovisionner votre compte?</strong>","continue":"Ajouter des données","back":"Annuler"},"individualSummary":{"back":"Retour au forfait Partagez tout","title":"Mon forfait","daysRemaining":"Il reste <span class=\"ute-dataManager-headTextSecondary-redCopy\">{{daysRemaining}} jours</span> avant le début du prochain cycle de facturation mensuel","manageButton":"Gérer util/alertes","months":{"0":"({{startDay}} janv.)","1":"({{startDay}} févr.)","2":"({{startDay}} mars)","3":"({{startDay}} avr.)","4":"({{startDay}} mai)","5":"({{startDay}} juin)","6":"({{startDay}} juil.)","7":"({{startDay}} août)","8":"({{startDay}} sept)","9":"({{startDay}} oct.)","10":"({{startDay}} nov.)","11":"({{startDay}} déc.)"}},"profile":{"alert":{"headline":"Alertes Données","sendTo":"Echoisissez votre gestionnaire de données","selectOne":"Sélectionnez","saveButton":"Enregistrer","doubleRainbow":"Qu’est-ce que cela signifie?","description":"Le gestionnaire des données reçoit les alertes que nous envoyons. Vous pouvez changer pour n’importe quelle ligne sans fil faisant partie de votre forfait Partagez tout.","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard."}},"sharedUsageBar":{"title":"Utilisation de données partagées","infiniteTitle":"Utilisation partagée de données Infinies","over":"sur","used":"Utilisés"},"tabs":{"primaryLine":"Ligne principale","leftGroupStillSharing":"Ancien forfait : toujours partagé","joinedGroupNotSharing":"Nouveau forfait : pas encore partagé","cancelled":"Ancien forfait","suspended":"Service suspendu"},"upgradePlan":{"modals":{"boldChatButtonId":"S_MRog_Wless_ChngeWlessPln_Fr","boldChatButtonDiv":"changePlan-Fr","boldChatButton":"chatButtonChangePlanFr"}},"usageDial":{"myWirelessUsage":"Mon utilisation des services sans-fil","myPlan":"Mon forfait : ","daysRemaining":"Il reste <span class=\"ute-dataManager-headTextSecondary-redCopy\">{{daysRemaining}} jours</span> avant le début du prochain cycle de facturation mensuel","remaining":"Restant : <span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span>","used":"Utilisés <span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span>","overPlanLimit":"Limite dépassée de <span class=\"ute-dataManager-usageDialContent-gbAmount\">{{data}}</span>","realTime":"(TEMPS RÉEL)","oneHourDelay":"(retardé jusqu’à 1 heure)","dataDelayMessage":"Quelque chose semble différent?","dataDelayHeader":"Quelque chose semble différent?","dataDelayBody":"Les renseignements sur l’utilisation que vous recherchez peuvent être inexacts ou incomplets en ce moment, mais ils devraient être ajustés au début de votre prochain cycle de facturation. Sinon, veuillez communiquer avec nous.","dataDelayAltText":"Touchez pour en savoir plus.","sharedData":"Données partagées","infiniteData":"Données Infinies","unlimitedData":"Données illimitées","usageReduced":"Des données à vitesse réduite","sharedTalk":"Appels","sharedText":"Textos partagés","unlimited":"illimités","viewUsage":"Voir l’utilisation","loader":"Ajout de données…","upgradePlan":"Changer de forfait","override":"Éviter les frais d’utilisation excédentaire de ce mois-ci.","increaseData":"Ajouter des données","addSpeedPass":"Ajouter Accès Rapido","cannotAddMoreData":"Non disponible lorsque la limite est atteinte","includes":"Comprend:","addedData":"DONNÉES AJOUTÉES","bonusData":"DONNÉES EN PRIME","at":"à","addedFor":"par ajout","each":"chacun","bonus":"bonus for_FR","dataOverage":"Utilisation excédentaire de données","view":"Voir","close":"Fermer","cancelAddon":"Pour annuler une option Données en extra, textez « ANNULER » au 222.","months":{"0":"({{startDay}} janv.)","1":"({{startDay}} févr.)","2":"({{startDay}} mars)","3":"({{startDay}} avr.)","4":"({{startDay}} mai)","5":"({{startDay}} juin)","6":"({{startDay}} juil.)","7":"({{startDay}} août)","8":"({{startDay}} sept)","9":"({{startDay}} oct.)","10":"({{startDay}} nov.)","11":"({{startDay}} déc.)"}},"videoThrottleControlList":{"sharedLines":"Mes lignes partagées","closeDataAlerts":"Fermer les alertes de données","openDataAlerts":"Gérez mes données et alertes","reduceVideoQuality":"Voulez-vous gérer la qualité de lecture de vidéos en continu?","whyDoThis":"Détails","saveData":"Faites-en plus avec vos données. Regardez jusqu’à trois fois plus de vidéos avec votre forfait actuel","benefitOne":"Nous enverrons un message texte à la personne concernée pour l’informer de ce changement. Vous pouvez aussi changer la qualité de la lecture en continu en tout temps.","benefitTwo":"L’activation du <b>Maximiseur de données</b><sub>MC</sub> ajustera la qualité de la lecture des vidéos en continu de la haute définition à la définition standard (SD) (là où c’est possible), par ligne, pour vous aider à profiter encore plus de vos données.","learnMore":"Plus de conseils pour économiser des données"},"videoThrottleControlTagList":{"reduceVideoQuality":"Voulez-vous gérer la qualité de lecture de vidéos en continu?"},"videoThrottle":{"errorSetThrottle":"Nous n’avons pas pu changer vos paramètres de lecture de vidéos en continu.<br><br>Veuillez réessayer plus tard.","errorHeading":"Petit problème...","modal":{"heading":"Vous gérez la qualité de la lecture en continu de vidéos pour :","secondaryCopy":"L’activation du <b>Maximiseur de données</b><sub>MC</sub> ajustera la qualité de la lecture des vidéos en continu de la haute définition à la définition standard (SD) (là où c’est possible), par ligne, pour vous aider à profiter encore plus de vos données.","body":"Nous enverrons un message texte à la personne concernée pour l’informer de ce changement. Vous pouvez aussi changer la qualité de la lecture en continu en tout temps.","note":"REMARQUE : Ceci aura une incidence sur la lecture de vidéos en continu uniquement, dans la mesure du possible. La navigation sur Internet, le téléchargement de vidéos et la vidéoconférence ne sont pas touchés par ce changement.","link":"Plus de conseils pour économiser des données","confirmationLabel":"Ne plus afficher.","confirmButton":"Régler la lecture de vidéos en continu","cancel":"ANNULER"}},"dataControl":{"alertsRecipientChange":"Gestionnaire de données","alertsRecipientButton":"(modification)","alertMeWhen":"Envoyez-moi une alerte lorsque ce numéro atteindra :","alertsOff":"Activer les alertes pour ce numéro","noData":"Aucune donnée ","dataDisabled":"L’accès aux données est désactivé sur cet appareil. Pour l’activer, faites glisser l’interrupteur à <strong>« On »</strong>.","addData":"Ajouter","toLine":"","space":" ","saveButton":"Enregistrer","leftGroupStillSharing":"Ancien forfait : toujours partagé","viewUsage":"L' utilisation de vue {{displayCTN}}","joinedGroup":"Nouveau forfait : pas encore partagé","leftGroup":"gérer le plan de {{displayCTN}}","suspendedService":"Service suspendu","cancelledService":"Ancien forfait","cannotSetForCancelled":"Vous ne pouvez pas configurer d’alerte pour un numéro annulè","cannotSetForSuspended":"Vous ne pouvez pas configurer d’alerte pour un numéro suspendu.","notSharing":"FR: NOT SHARING DATA","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard.","errorSecondaryThreshold":"Nous ne pouvons pas d’activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard.","errorSecondaryUseAlertsOn":"Nous ne pouvons pas activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard.","errorSecondaryUseAlertsOff":"Nous ne pouvons pas d’activer l’alerte liée à l’utilisation de données. Veuillez réessayer plus tard.","gb":"Go"},"dataControlTag":{"alertsRecipientChange":"Gestionnaire de données","alertsRecipientButton":"(modification)","dataUsed":"utilisés","alertAt":"Envoyer une alerte à","leftGroupStillSharing":"A quitté le groupe – partage encore","joinedGroupNotSharing":"Nouveau forfait : pas encore partagé","suspendedService":"Service suspendu","cancelledService":"Ancien forfait","joinedGroup":"L' utilisation de vue {{displayCTN}}","leftGroup":"gérer le plan de {{displayCTN}}","dataAccessOff":"Accès aux données bloqué","manageWirelessPlan":"Manage wireless plan","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard.","newLine":"Nouvelle ligne","data":"DATA:","alerts":"ALERTS:","on":"OUI","off":"NON","rogersPlan":"Vorte forfait","yourDevice":"Mon appareil","support":"Soutien","video":"VIDÉO:","videoSD":"SD","videoHD":"HD","alertsRecipient":"(Gestionnaire de données)"},"increasePlanModal":{"increaseData":"Vous avez besoin de plus de données ce mois-ci?","firstBody":"Textez <strong>DONNEES</strong> au <strong>222</strong> pour connaître les options et les prix. Vous n’aurez pas à payer pour ce message texte. Les frais s’appliquent seulement si vous sélectionnez une option, et vous pouvez l’annuler en tout temps.","question":"Quelle quantité de données de plus?","f":"pour","addData":"Ajouter des données","errorHeading":"Petit problème...","errorBody":"Le processus d’achat a été interrompu. Veuillez réessayer plus tard."},"wcocConsentModal":{"heading":"Confirmation de réapprovisionnement de données","firstBody":"Vous êtes sur le point de réapprovisionner votre compte avec le lot suivant :","f":"pour","secondBody":"En ajoutant ce lot, vous aurez engagé des frais d’utilisation excédentaire de données de plus de <strong>50 $</strong> au cours de ce cycle de facturation.<br/><br/>Si vous consommez toutes les données de ce lot sans en rajouter, toute utilisation additionnelle sera facturée au tarif d’utilisation excédentaire prévu à votre forfait.<br/><br/>En réapprovisionnant votre compte ainsi, vous convenez d’avoir un accès continu aux données jusqu’à la fin du cycle de facturation actuel. Vous ne recevrez plus de notifications d’utilisation excédentaire et votre accès aux données ne sera pas interrompu.<br/><br/><strong>Êtes-vous certain de vouloir réapprovisionner votre compte?</strong>","continue":"Ajouter des données","back":"Annuler"},"alertRecipientModal":{"setData":"Désigner un gestionnaire de données :","description":"Désignez un gestionnaire de données pour gérer vos alertes. Si vous sélectionnez une ligne de données seulement (associée à une tablette, par exemple), le gestionnaire de données ne recevra pas les avis par message texte.","selectOne":"Choisissez un gestionnaire de données","continueButton":"Désigner un gestionnaire de données","cancel":"Annuler","colon":" :","errorHeading":"Petit problème...","errorSecondary":"Nous ne pouvons pas assigner un gestionnaire de données. Veuillez réessayer plus tard."},"genericModal":{"button":"OK","button2":"OK"},"modals":{"alertsOverDataLimit":{"heading":"Le seuil de vos alertes Données est supérieur au total de données comprises dans votre forfait","firstBody":"Nous vous recommandons de fixer le seuil de vos alertes à près de 80 % du total de données comprises dans votre forfait.","secondBody":"Par exemple, si votre forfait comprend 10 Go de données, il est préférable de fixer le seuil de vos alertes à près de 8 Go.","thirdBody":"Nous continuerons de vous envoyer des alertes automatiques lorsque l’utilisation de données atteindra 90 % et 100 %.","button":"OK"}}},"janrain":{"verification":{"modalPopup":{"expired":{"title":"Il semble que votre lien est expir&eacute;.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"invalid":{"title":"Il semble y avoir un problème touchant ce lien.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"middleware.failure":{"title":"Il semble y avoir un problème touchant ce lien.","subTitle":"Veuillez indiquer l’adresse électronique liée à votre inscription et nous vous en enverrons un autre."},"email.address":"Email Address","cancel":"CANCEL","submit":"RESEND CODE","validatingCode":"Lien de confirmation","codeValid":"Lien valide"},"email.not.found.error.EMAIL_NOT_FOUND":"Désolé, nous ne trouvons pas l’adresse électronique que vous avez entrée. Assurez-vous d’entrer la bonne adresse et réessayez.","email.not.found.error.CODE_NOT_VALID":"Nous avons envoyé un courriel à l’adresse {{email}}. Il comprend un lien pour créer un nouveau mot de passe pour votre compte MonRogers.","email.already.verified.error.message":"Nous avons d&eacute;j&agrave; votre adresse courriel. Maintenant, connectez-vous."}},"oneview":{"interactionNotes":{"directive":{"notepad":{"interactionNote":"Remarque sur l'interaction","spokeWith":"J’ai parlé à","reasonForCall":"Motif de l’appel","accountActivitiesPerformed":"Activités effectuées au compte","followUpNeeded":"Suivi nécessaire","saveNote":"Enregistrer la remarque","editNote":"Modifier la remarque","textAreaTemplate":"/J’ai parlé à/\n\n/Motif de l’appel/\n\n/Activités effectuées au compte\n\n/Suivi nécessaire/\n\n","getNoteErrorMessage":"Impossible de récupérer le plus récent remarque.","saveNoteErrorMessage":"Le système ne peut pas enregistrer cette remarque à ce moment."}}},"footer":{"directive":{"goToSsp":"Retourner &agrave; PVS","goToNova":"Consultez Nova","quickLinks":"Mes Liens rapides","moveLinkMessage":"Pour déplacer un lien, cliquez dessus et faites-le glisser latéralement, ou à l’intérieur ou à l’extérieur des cinq sections ci-dessous.","edit":"Modifier","save":"Enregistrer","returnToSsp":"Retourner &agrave; PVS","sspModalMessage":"SSP Modal Message Fr","continue":"Continuer","feedBack":"Commentaires","timeRemaining":"Le temps restant à cette session: ","willSignOut":"Votre session sera interrompue dans: ","wantToStaySignin":"Voulez-vous qu’elle reste ouverte?","staySignedIn":"OUI","signOut":"NON"}}},"pending":{"order":{"retail":{"label":{"iptv":{"provide":{"tc":"Visite d’un Technicien (frais)","tn":"Technicien (sans frais)","re":"Retourner au magasin","tp":"Installation par un Technicien"}},"iptv-stb":{"provide":{"tc":"Visite d’un Technicien (frais)","re":"Retourner au magasin","tn":"Technicien","tp":"Installation par un Technicien"}},"hsi":{"cease":{"co":"Aucun","re":"Aucun","tn":"Visite d'un Technicien"},"equipment_pickup_and_return":{"co":"Aucun","im":"Aucun","re":"Aucun","tn":"Aucun"},"provide":{"co":"Aucun","nn":"Aucun","re":"Aucun","tp":"Installation par un Technicien","tc":"Installation par un Technicien"},"provide-in-replace-offer":{"co":"Aucun","nn":"Aucun","re":"Aucun","tp":"Aucun"},"replace_offer":{"nn":"Aucun"}},"modem":{"actionType":{"cease":"Annuler","change":"Changer","equipment_pickup_and_return":"Retourner Modem","provide":"Activer","provide-in-replace-offer":"Déménagement","replace_offer":"Changer le forfait","swap":"Échanger Modem"},"cease":{"co":"Envoyer à MonRogers","re":"Retourner au magasin","tn":"Visite d'un Technicien"},"equipment_pickup_and_return":{"co":"Envoyer à MonRogers","im":"Aucun","re":"Retourner au magasin","tn":"Visite d'un Technicien"},"provide":{"co":"Adresse d'expédition","nn":"Aucun","re":"Ramassage au magasin","tp":"Installation par un Technicien","tc":"Visite d’un Technicien (frais)"},"provide-in-replace-offer":{"co":"Adresse d'expédition","nn":"À apporter avec vous","re":"Ramassage au magasin","tp":"Visite d'un Technicien"},"replace_offer":{"nn":"Aucun"},"swap":{"co":"Envoyer à MonRogers","im":"Échanger en magasin","re":"Échanger en magasin"}}}},"cta":{"close":"Fermer","cancel":"Annuler","reScheduleAppointment":"Modifier","reschedule":"Modifier","update":"Mettre &Atilde;  jour","success":"C'est fait!","hyphen":" - ","oops":"Oups","oopsWithSubheading":"<h4>Désolé, une erreur s’est produite.</h4>Il semble y avoir eu un problème. Veuillez réessayer plus tard.","cxOopsWithSubheading":"<h4>Désolé, une erreur s’est produite.</h4>Il semble y avoir eu un problème. Veuillez réessayer plus tard.","cfaOopsWithSubheading":"<h4>Désolé, une erreur s’est produite.</h4>Il semble y avoir eu un problème. Veuillez communiquer avec l’équipe de soutien aux magasins.","technicalError":"Problème technique","cannotViewChange":"Désolé, nous sommes incapables d’afficher les détails de votre rendez-vous pour le moment.Veuillez réessayer plus tard.","loading":"Chargement...","orderDetails":"Détails de la commande","cxCantReschedule":"<h4>Désolé, une erreur s’est produite.</h4>Nous ne sommes pas en mesure de fixer votre rendez-vous. Veuillez communiquer avec nous pour obtenir de l’aide.","cfaCantReschedule":"<h4>Désolé, une erreur s’est produite.</h4>Nous ne sommes pas en mesure de fixer votre rendez-vous. Veuillez communiquer avec l’équipe de soutien aux magasins."},"label":{"viewAndChangeAppointment":"Afficher et modifier les rendez-vous","pending":"Vous avez une demande en attente...","servicesOrdered":"Service command&eacute;","actionType":"Demande","dueDate":"Date de mise en service","fulfillmentOption":"Type de traitement","internet":"Internet","orderNumber":"N&deg; de la commande :","termsConditions":"Modalit&eacute;s","orderDetails":"Les d&eacute;tails de votre commande","orderDate":"Date de la commande","modemSerialNumber":"Num&eacute;ro de s&eacute;rie","currentAppointmentIs":"Votre rendez-vous actuel :","iptv":{"provide":{"tc":"Installation par un Technicien","re":"Retourner au magasin","tn":"Technicien","tp":"Installation par un Technicien"}},"iptv-stb":{"provide":{"tc":"Installation par un Technicien","re":"Retourner au magasin","tn":"Technicien","tp":"Installation par un Technicien"}},"hsi":{"cease":{"co":"Aucun","re":"Aucun","tn":"Installation par un technicien"},"equipment_pickup_and_return":{"co":"Aucun","im":"Aucun","re":"Aucun","tn":"Aucun"},"provide":{"co":"Aucun","nn":"Aucun","re":"Aucun","tp":"Installation par un Technicien","tc":"Installation par un Technicien"},"provide-in-replace-offer":{"co":"Aucun","nn":"Aucun","re":"Aucun","tp":"Aucun"},"replace_offer":{"nn":"Aucun"}},"modem":{"actionType":{"cease":"Annuler","change":"Changer","equipment_pickup_and_return":"Retourner Modem","provide":"Activer","provide-in-replace-offer":"Déménagement","replace_offer":"Changer le forfait","swap":"Échanger Modem"},"cease":{"co":"Envoyer à MonRogers","re":"Retourner au magasin","tn":"Installation par un technicien"},"equipment_pickup_and_return":{"co":"Envoyer à MonRogers","im":"Aucun","re":"Retourner au magasin","tn":"Installation par un technicien"},"provide":{"co":"Adresse d'expédition","nn":"Aucun","re":"Ramassage au magasin","tp":"Installation par un Technicien","tc":"Installation par un technicien"},"provide-in-replace-offer":{"co":"Adresse d'expédition","nn":"À apporter avec vous","re":"Ramassage au magasin","tp":"Installation par un technicien"},"replace_offer":{"nn":"Aucun"},"swap":{"co":"Envoyer à MonRogers","im":"Échanger en magasin","re":"Échanger en magasin"}}},"message":{"orderDetails":"Voici vos commandes en cours.","viewAndChangeAppointment":"Besoin de changer votre rendez-vous? Vous pouvez reporter votre rendez-vous jusqu'à la veille de l'installation.","currentAppointmentIs":"Votre rendez-vous actuel :","appointmentStep1":"Pour changer votre rendez-vous, choisissez de nouvelles date et heure d'installation du service {{serviceName}}. N'oubliez pas qu'une personne âgée de 18 ans ou plus devra être présente.","appointmentStep2":"Veuillez nous fournir un numéro auquel on peut vous joindre le jour du rendez-vous.","appointmentStep3":"Veuillez nous fournir toute information utile, comme un code d’entrée.","appointmentNote":"<strong>Ce rendez-vous sera confirmé uniquement lorsque votre demande aura été soumise. Si cette plage horaire n'est plus disponible, vous devrez choisir un autre moment.</strong>","appointmentConfirmation":"Nous pouvons confirmer votre nouveau rendez-vous pour l'installation.","newAppointmentIs":"Votre nouveau rendez-vous :"},"dynamic":{"HSI":"Internet","IPTV":"Télé","IPTV STB":"EVP sans fil 4K","Modem":"Modem","servicesOrdered":{"internetAndTV":"Internet/Télé","modemAndWireless4k":"Modem/EVP sans fil 4K"},"request":{"PROVIDE":"Activer","cancel":"Annuler","exchangeHardware":"Échanger l'équipment","move":"Déménagement","changePackage":"Modifier le forfait","transferOwnership":"Transférer la responsabilité","change":"Modifier","return":"Retourner"},"cxFulfillment":{"technician":"Technicien"},"cfaFulfillment":{"technician":"Technicien (sans frais)"}}}},"profile":{"wirelessRecoveryNumber":"Numéro de récupération :","edit":{"selfServeDirection":"Libre-service seulement","directive":{"general.error":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite. Nous tentons de r&eacute;gler le probl&egrave;me le plus rapidement possible. Les changements apport&eacute;s &agrave; vos forfaits n&rsquo;ont pas &eacute;t&eacute; enregistr&eacute;s. Veuillez rev&eacute;rifier dans quelques minutes.","check.form.errors":"Des erreurs de validation ont &eacute;t&eacute; d&eacute;tect&eacute;es sur cette page. Veuillez consulter le message au-dessus de chaque ligne.","email.verification.msg":"<p><strong>Nous vous avons envoy&eacute; un courriel d&rsquo;activation de compte.</strong></p><br/><p>Pour terminer votre inscription, consultez votre bo&icirc;te de r&eacute;ception, puis ouvrez une session &agrave; l&rsquo;aide de votre nom d'utilisateur et du mot de passe temporaire que nous avons inclus dans ce courriel.</p><br/>"},"resetPassword":{"modalHeader":"R&eacute;initialiser le mot de passe du client","modalContent":"Cliquez sur Continuer pour r&eacute;initialiser le mot de passe du client. Le client va ensuite recevoir un lien par courriel lui permettant de cr&eacute;er un nouveau mot de passe.","response":{"sucess":"Changement r&eacute;ussi! Veuillez informer le client qu&rsquo;un lien de r&eacute;initialisation de mot de passe a &eacute;t&eacute; envoy&eacute; &agrave;","error":"Nous n&rsquo;avons pas r&eacute;ussi &agrave; r&eacute;initialiser le mot de passe. Si le probl&egrave;me persiste, demandez au client de nous contacter au moyen du Clavardage en direct."}}},"images":{"errorWarning":"ute-common-assets/assets/error_warning.png"},"error":{"profile_already_exist_middleware_failure":"Malheureusement, l&rsquo;adresse {{email}} est d&eacute;j&agrave; associ&eacute;e &agrave; un autre profil. Pour avoir de l&rsquo;aide afin de changer votre nom d&rsquo;utilisateur, veuillez communiquer avec nous."},"password":{"guideline":{"list":"<br>Votre mot de passe doit compter de 8 à 20 caractères et comprendre au moins un chiffre et une lettre.<br>Les caractères spéciaux suivants sont acceptés: ! @ # $","passwordMustHave":"Votre mot de passe doit comprendre :","passwordAtLeast":"Au moins une lettre et un chiffre","passwordMinimum":"Au moins huit caractères","passwordCanInclude":"Vous pouvez utiliser des caractères spéciaux et des lettres majuscules ou minuscules.<br>Les mots de passe sont sensibles à la casse.","bothPasswordMatch":"Les deux mots de passe sont identiques","passwordInlineError":"Votre mot de passe doit compter de 8 à 20 caractères et comprendre au moins un chiffre et une lettre.<br>Les caractères spéciaux suivants sont acceptés: ! @ # $"}}},"noProfile":{"title":"Aucun profil MonRogers","repActionMessage":"Créer un nouveau profil MonRogers pour le client et envoyer un courriel de confirmation.","customerActionMessage":"Veuillez demander au client d’accéder à l’application MonRogers pour créer son profil.","link":"Créer un nouveau profil","createProfileModal":{"modalTitle":"Créer un nouveau profil","createUsingExistingMail":"Créer un compte en utilisant {{existingMail}}","enterMailIdPlaceholder":"Entrer une nouvelle adresse pour créer un profil","enterMailIdPlaceholderShort":"Adresse Courriel","confirmMailIdPlaceholder":"Confirmer l’adresse courriel","or":"Ou","createButton":"Créer","infoMsg":"*Veuillez fournir un nom d’utilisateur dans un format d’adresse courriel valide: nom@courriel.com","emailsMismatchMsg":"Les adresses courriel ne correspondent pas. Veuillez vérifier les adresses et essayer de nouveau."},"profileAlreadyExistsModal":{"modalTitle":"Le profil existe déjà","modalMsg":"Un profil existe déjà pour cette adresse courriel et a été lié à ce compte. Pour réinitialiser le mot de passe, allez à Profil et paramètres.","doneButton":"Terminé"},"profileCreatedModal":{"modalTitle":"Profil créé","modalMsgPartOne":"Le profil","modalMsgPartTwo":" {{enteredMailId}}","modalMsgPartThree":" a été créé.","modalMsgPartFour":"Le client recevra un courriel d’inscription bientôt.","doneButton":"Terminé"},"profileNotCreatedModal":{"modalTitle":"Profil non créé","modalMsg":"Nous n’avons pas été en mesure de créer ce profil MonRogers.","tryAgainButton":"Essayez de nouveau"}},"voicemail":{"resetPassword":{"directive":{"updateVoicemailPassword":{"care":"R&eacute;initialiser le mot de passe pour la Messagerie vocale","consumer":"Changer mon mot de passe pour la messagerie vocale","dealer":"R&eacute;initialiser le mot de passe pour la Messagerie vocale"}},"modalPopup":{"title":"Mettre &agrave; jour le mot de passe pour la Messagerie vocale","subTitle":"Veuillez entrer votre nouveau mot de passe.","newPassword":"Nouveau mot de passe","confirmPassword":"Confirmer le mot de passe","passwordInstruction":"Votre mot de passe doit &ecirc;tre compos&eacute; de 4 ou 5 caract&egrave;res et ne peut contenir que des chiffres.","cancel":"ANNULER","submit":"SOUMETTRE","close":"Fermer"},"responseMessage":{"successTitle":"Merci.","successMessage":"Votre mot de passe de la Messagerie vocale a &eacute;t&eacute; r&eacute;initialis&eacute;.","failure":"D&eacute;sol&eacute;! Il semble qu&rsquo;une erreur se soit produite de notre c&ocirc;t&eacute;.","contactUs01":"Veuillez communiquer avec nous au moyen du","contactUs02":"en direct pour d&eacute;m&ecirc;ler le tout.","passwordNotMatch":"Oups! Vos mots de passe ne correspondent pas. Veuillez r&eacute;essayer.","notEnterBothFields":"Veuillez vous assurer d&rsquo;entrer votre nouveau mot de passe dans les deux champs.","notFourToFiveDigits":"Oups! Votre mot de passe doit &ecirc;tre compos&eacute; de 4 ou 5 caract&egrave;res et ne peut contenir que des chiffres. Veuillez r&eacute;essayer."},"boldChat":{"cbid":"S_MRog_Wless_DevActError_Fr","dynamicDivId":"resetVoicemailPassword-fr","chatButtonClass":"chatButtonResetVoicemailPassword-fr"}}},"saveBillBanner":{"printBill":"Imprimer cette facture (PDF)","saveBill":"Enregistrer cette facture (PDF)","downloadUsage":"Télécharger les données d’utilisation sous forme de : ","downloadUsageMobile":"Télécharger les données d’utilisation sous forme de ","excelFile":"fichier Excel","csvFile":"fichier CSV","savePrintDownload":"Enregistrer, imprimer ou télécharger la facture ","saveOrDownloadBill":"Enregistrer ou télécharger la facture","printPDF":"Imprimer (PDF)","savePDF":"Enregistrer (PDF)","downloadUsageAsExcelCSV":"Télécharger (Excel<span class=\"divider\">|</span> CSV)"},"saveBill":{"noData":"Vous n’avez pas d’utilisation pour ce cycle de facturation.","saveAsPDF":{"download":"Sauvegarder cette facture sous","pdf":"PDF"},"saveButton":{"saveCopy":"Enregistrer/Imprimer la facture"},"confirmationModal":{"title":"Téléchargez une ou plusieurs factures en format PDF","selectAll":"Télécharger toutes les factures de cette année civile","close":"Fermer","confirm":"Télécharger les factures"},"genericModal":{"button":"ok","phone":"1-855-381-7841","liveChat":"Contactez-nous","boldChat":{"cbid":"7015556824075446708","dynamicDiv":"S-Care_View_Bill_Issue","chatButton":"Rogers_Care_ConsolidatedBilling_FR"}}},"saveBillModal":{"title":"Enregistrez ou imprimez votre facture, ou téléchargez vos renseignements d’utilisation","instructions":"Vous pouvez facilement’ assurer le suivi de votre facture Rogers ou de votre utilisation de données ou de temps d’antenne. Vous n’avez qu’à enregistrer ou à imprimer votre facture en format PDF. Vous pouvez aussi télécharger les détails de votre utilisation en format CSV ou Excel.","optionTitle1":"Enregistrer la facture en format PDF","optionSub1":"Un format pratique aux fins de classement ou d’impression.","optionTitle2":"Imprimer une copie PDF de votre facture","optionSub2":"Pour ceux qui conservent des documents sur papier.","optionTitle3":"Télécharger les données d’utilisation sous forme de fichier Excel","optionSub3":"Enregistrez vos données d’utilisation afin de les consulter dans Microsoft Excel.","optionTitle4":"Télécharger les données d’utilisation sous forme de fichier CSV","optionSub4":"Enregistrez vos données d’utilisation au format CSV afin de pouvoir les consulter dans plusieurs programmes.","errorHeading":{"savePDF":"Problèmes de système au moment d’accéder à la version PDF de la facture","printBill":"Problèmes de système au moment d’accéder à la facture et problème d’impression de la facture","downloadExcel":"Problèmes de système au moment de sauvegarder le fichier Excel qui comprend les détails de l’utilisation","downloadCSV":"Problèmes de système au moment de sauvegarder le fichier CSV qui comprend les détails de l’utilisation"},"errorBody":{"downloadPdf":"Nous sommes désolés, mais un problème de système nous empêche d’accéder à la version PDF de votre facture pour le moment. Nous tentons de régler le problème. Si vous avez besoin d’aide immédiatement, veuillez communiquer avec nous.","savePDF":"Nous sommes désolés, mais un problème de système nous empêche d’accéder à la version PDF de votre facture pour le moment. Nous tentons de régler le problème. Si vous avez besoin d’aide immédiatement, veuillez communiquer avec nous.","printBill":"Nous sommes désolés, mais un problème de système nous empêche d’accéder à votre facture pour le moment. Nous tentons de régler le problème. Si vous avez besoin d’aide immédiatement, veuillez communiquer avec nous.","downloadExcel":"Nous sommes désolés, mais un problème de système nous empêche de téléverser votre fichier Excel pour le moment. Nous tentons de régler le problème. Si vous avez besoin d’aide immédiatement, veuillez communiquer avec nous.","downloadCSV":"Nous sommes désolés, mais un problème de système nous empêche de téléverser votre fichier CSV pour le moment. Nous tentons de régler le problème. Si vous avez besoin d’aide immédiatement, veuillez communiquer avec nous."},"success":{"pdf":"C’est fait! La version PDF de votre facture a été téléchargée.","excel":"C’est fait! Le fichier Excel qui comprend les détails de votre utilisation a été téléchargé.","csv":"C’est fait! Le fichier CSV qui comprend les détails de votre utilisation a été téléchargé."}},"saveBillPrintModal":{"title":"Imprimer cette facture"},"briteBill":{"service":{"bb_error_message":"Désolé, votre facture n’est pas disponible pour le moment. Veuillez réessayer plus tard. Merci.","error_wireless_usage":"Désolé, les détails de votre service Sans-fil ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","error_brite_bill_get_bill_list":"","acc_balance_view_older_bill":"Consulter les factures âgées","errorCode":{"10001":"Not valid form data have been passed","10300":"Le compte que vous tentez d’inscrire est un compte d’entreprise. Consultez la <a href=\"https://www.rogers.com/business/ute/smb/transactions/uteAccountAssociation\">page d’inscription du Libre-service Affaires</a> pour inscrire votre compte en ligne et accéder aux renseignements sur votre utilisation et la facturation. Merci!","10301":"Nous sommes incapables d’associer votre compte Rogers à votre profil MonRogers pour l’instant. Veuillez réessayer plus tard.","10302":"Ce compte est déjà associé à un autre profil MonRogers. Veuillez accéder à ce profil afin de gérer le compte ou, pour obtenir du soutien, communiquer avec un conseiller du Service à la clientèle au moyen de l’outil de clavardage en direct.","10303":"Désolé, le code postal ne correspond pas à celui de nos dossiers pour le numéro de compte que vous avez entré. Veuillez vérifier si le code postal et le numéro de compte que vous avez entrés sont exacts.","10304":"Veuillez entrer un numéro de 9 à 12 chiffres valide","10305":"Désolé, le numéro de compte entré n’a pas été trouvé. Veuillez vérifier le numéro entré.","10311":"Désolé, le numéro de téléphone entré n’a pas été trouvé. Veuillez vérifier le numéro entré.","10312":"Désolé, le numéro de compte entré est déjà associé à un profil MonRogers.","10313":"fr The PIN does not match","10314":"{FR} Failed to get subscription info base on Pin and CTN provided","10350":"No email has been found for this account.","10401":"« Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36\" target=\"_blank\">Clavardage en direct</a>. »","10402":"La réponse à la question de sécurité que vous avez entrée ne correspond pas à nos dossiers. Veuillez entrer votre réponse de nouveau.","10403":"{FR} get postpaid account details failed","10412":"{FR} failed to get prepaid account list due to SOAP Fault","10413":"{FR} get prepaid account details: failed to find ctn","10414":"{FR} get prepaid account details: failed to find pin","10415":"{FR} get prepaid account details: failed to get subscription list","10416":"{FR} get prepaid account details: failed to get account details","10501":"Cette adresse électronique est déjà utilisée comme nom d’utilisateur MonRogers.  Veuillez choisir une autre adresse électronique ou ouvrir une session avec ce nom d’utilisateur","10502":"Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href=\"http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253\" target=\"_blank\">Clavardage en direct</a>.","10503":"{FR} Failed to complete forgotUsername operation","10504":"Réponse incorrecte à la question de sécurité","10505":"La réponse à la question de sécurité que vous avez entrée ne correspond pas à nos dossiers. Veuillez entrer votre réponse de nouveau.","10506":"« Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du <a href=\"http://www.rogershelp.com/customerserv/cuscare_ECare_landing.php?s=36\" target=\"_blank\">Clavardage en direct</a>. »","10601":"{FR} Failed retrieve Usage","10602":"{FR} getting roaming usage returns error code","10603":"{FR} getting usage returns error code","11401":"{FR} unexpected error in TVLandingActor","11402":"{FR} cable product details not found","11403":"{FR} failed getting cable product details","11404":"{FR} cable product package not found","11405":"{FR} failed getting cable product package","11406":"{FR} failed populating cable info","11411":"{FR} error occurred when getting plan deteail from cassandra","11412":"{FR} error occurred when getting digital box deteail from cassandra","11413":"{FR} error occurred when getting themepack deteail from cassandra","11414":"{FR} error occurred when getting channel deteail from cassandra","12000":"{FR} Permission Denied","13001":"{FR} Failed create secret key","13002":"{FR} Encryption Failed","13003":"{FR} Decryption Failed","13004":"{FR} URLEcode Failed","15040":"Désolé, nous ne trouvons pas l’adresse électronique que vous avez entrée. Assurez-vous d’entrer la bonne adresse et réessayez.","50000":"Erreur inconnue du serveur","50001":"Not defined yet Server Error","50002":"Se il vous plaît déconnectez-vous et essayez de vous connecter à nouveau avec votre nouveau nom d’utilisateur"}}},"smsRecoveryRogers":{"profile":{"usernameAndPassword":"Nom d'utilisateur et mot de passe"},"root":{"loginRecoveryMobileNumber":"Numéro de sans-fil <br>pour faciliter la récupération :","setupNow":"En configurer un maintenant","none":"Aucun"}},"subscriptionBadge":{"homePhone":"Téléphonie résidentielle","internet":"Internet","tv":"T&eacute;l&eacute;","smartStream":"Divertissement","smartHomeMonitoring":"Rogers Smart<br/>Home Monitoring FR","serviceSuspended":"Service Suspended FR"},"tor":{"transferOfResponsibility":"Transfert de responsabilité","currentOwner":"Titulaire actuel","futureOwner":"Futur titulaire","saveAndProceed":"Enregistrer et poursuivre","saveAndClose":"Enregistrer et fermer","cancel":"Annuler transfert de responsabilité","close":"Fermer","systemExceptionMessage":"Nous ne pouvons pas traiter votre demande pour le moment.","systemUnavailable":"Système non disponible","pleaseTryAgainLater":"Veuillez réessayer plus tard.","selectNumber":"Sélectionnez le numéro à transférer","eligibilityResults":{"eligibilityResultsTitle":"Résultats concernant l'admissibilité","numbers":"Numéros","accountNumbers":"Numéros de compte","eligibility":"Admissibilité","validation":"Validation","currentOwnerPointsTitle":"Éléments que vous pourriez mentionner:","currentOwnerPoint1":"Tout solde Paiement pratique restant sera porté à la facture du client actuel une fois le transfert de responsabilité complété. Les soldes restants ne peuvent être transférés au nouveau responsable du compte.","currentOwnerPoint2":"Tous les rabais d’entreprise seront retirés si un client passe d’un compte à responsabilité individuelle à un compte qui ne l’est pas. Par contre, ces rabais seront appliqués au moment du transfert si le client passe d’un compte qui n’est pas à responsabilité individuelle à un compte qui l’est.","currentOwnerPoint3":"L'autorisation du transfert de responsabilité est valide pendant 30 jours.","currentOwnerPoint4":"Des frais pour cette transaction seront facturés au nouveau client prenant en charge ce numéro. (Exceptions: décès, conjoint, forfaits à responsabilité individuelle, rétention, erreur, TOR obligatoire d’un compte corporatif vers consommateur. Vérifiez Nova si vous avez besoin de plus de détails)","currentOwnerNote":"Une interaction sera créée dans ICM afin d'autoriser le transfert de responsabilité au nouveau titulaire.","futureOwnerAccountNumber":"Numéro de compte du futur titulaire","cutureOwnerTelephoneNumber":"Numéro de téléphone du titulaire actuel","cutureOwnerAccountNumber":"Numéro de compte du titulaire actuel","futureOwnerPoint":"Veuillez ne pas transmettre les renseignements du titulaire actuel au futur titulaire.","futureOwnerPoint2":"Des frais de 35 $ vous seront facturés pour cette transaction, le cas échéant.","notEligibleForTOR":"Non admissible à un transfert de responsabilité","TORCTNINELIGIBLE1":"Un transfert de responsabilité est déjà en cours pour ce numéro.","TORCTNINELIGIBLE2":"Le titulaire actuel a fait un transfert de responsabilité il y a moins de 60 jours.","TORCTNINELIGIBLE3":"Une mise en service a été fait au cours des 60 derniers jours.","TORCTNINELIGIBLE4":"Le compte de ce client est en attente d'un rehaussement d'équipement ou d'un échange.","TORCTNINELIGIBLE5":"Le compte de ce client est en attente d'un changement de forfait.","TORCTNINELIGIBLE6":"Il n'y a pas de transfert de responsabilité en cours pour ce numéro.","TORCTNINELIGIBLE7":"Un rehaussement d'équipement a été fait au cours des 60 derniers jours.","TORBANINELIGIBLE1":"Le compte est en souffrance.","TORBANINELIGIBLE2":"Le compte est suspendu.","TORBANINELIGIBLE3":"Le compte est résilié.","TORBANINELIGIBLE4":"Aucun historique des paiements ne figure au compte.","validationFailed":"Échec de la validation","accountStatusDelinquent":"Le compte est en souffrance.","accountNoPaymentHistory":"Aucun historique des paiements ne figure au compte.","validated":"Validé","notValidated":"Pas validé","eligible":"Admissibles","notEligible":"Pas admissibles","addAnother":"+ Ajouter un autre numéro","notEligibleErrorMessage":"Afin de procéder à ce transfert de responsabilité, les problèmes mentionnés ci-dessus doivent être réglés. Veuillez régler ces problèmes avec le titulaire actuel et vérifier de nouveau l'admissibilité au transfert."},"stepTracker":{"stepLabel1":"Choisissez un numéro et vérifiez-en l'admissibilité.","stepLabel2":"Recueillez les renseignements du futur titulaire.","stepLabel3":"1. Exécuter une vérification d'éligibilité sur le futur propriétaire","stepLabel4":"Enregistrez l'autorisation et entrez le transfert dans V21."},"confirmation":{"title":"Statut l'autorisation","secondTitle":"2. Sauvegarder et compléter le statut d'autorisation","torAuthorizationInProgress":"Le transfert de responsabilité est en cours. L'autorisation du transfert expirera le: {{expiryDate}}.","askFutureOwnerToContact":"Afin de terminer le transfert, veuillez demander au futur titulaire de communiquer avec nous.","customerTelephoneNo":"Numéro de téléphone","futureOwnerName":"Nom du futur titulaire","securityWord":"Mot de passe","torAuthorized":"Un transfert de responsabilité a été autorisé le : ","proceedToVision21":"Afin de terminer le transfert, utilisez V21.","saveAuthorizationCompleteTransfer":"4.Enregistrez l'autorisation et terminez le transfert dans V21.","futureAccountNumber":"Futur numéro de compte","copyCustomerNumber":"Copier le numéro du client","returnLink":"Retour","continue":"Continuer","confirmSecurityWordMessage":"Confirmer le mot de passe de sécurité et vérifier l’admissibilité du NTC et du compte"},"currentCustomer":{"selectTORSubscriber":"1. Vérification initiale d'éligibilité","runEligibilityCheck":"Procéder à la vérification de l'admissibilité","firstName":"Prénom","lastName":"Nom de famille","securityWord":"Mot de passe","currentOwnerNumber":"Numéro du propriétaire actuel","obtainFutureOwnerInfo":"2. Recueillez les renseignements du futur titulaire","formFillingInstruction":"Veuillez demander au titulaire actuel de fournir un mot de passe, qui sera transmis au futur titulaire.","addToEligibilityCheck":"Adjouter a vérification de l'admissibilité"},"destinationCustomer":{"instructionMessage":"3.Saisissez le numéro de téléphone du client qui a été autorisé pour un transfert de responsabilité.","currentOwnerNumber":"Numéro du titulaire actuel:","getDetails":"Obtenir des détails","getDetailsNoCtnFoundMessage":"Il n'y a pas de transfert de responsabilité en cours pour ce numéro","secondInstructionHeading":"2. Sauvegarder et compléter le statut d'autorisation"},"selection":{"checkForTransferMessage":"Vérifiez ici si le compte sans-fil d'un client est admissible à un transfert de numéro ici.","pleaseNote":"Remarque :","pleaseNotePoint1":"Le titulaire actuel doit initier le transfert.","pleaseNotePoint2":"Le futur client doit ensuite nous appeler.","pleaseNotePoint3":"Une fois la validation terminée, le transfert doit être entré dans V21.","torQuestion":"Est-ce le titulaire actuel ou la personne à qui la responsabilité sera transférée?","currentOwner":"Titulaire actuel","futureOwner":"Futur titulaire"}},"usageDial":{"myPlan":"Mon forfait : ","daysRemaining":"Il reste {{daysRemaining}} jours à votre cycle de facturation","remaining":"Données restantes : <span class=\"ute-usageDialContent-gbAmount\">{{overage}}</span>","overPlanLimit":"Limite dépassée de <span class=\"ute-usageDialContent-gbAmount\">{{overage}}</span>","realTime":"(temps réel)","sharedData":"Données partagées","sharedTalk":"Appels partagés","sharedText":"Messages texte partagés","unlimited":"illimités","mb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">MO</strong>","gb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">GO</strong>","tb":"<strong class=\"ute-usageDialContent-gbAmountUnit\">TO</strong>"},"appBanner":{"title":"Procurez-vous l'application MonRogers dès aujourd’hui","buttonCopy":"Afficher","callToAction":"GRATUIT sur Google Play"},"discoveryPage":{"directive":{"whyWouldI":"Pourquoi configurer une alerte?","modal":{"heading":"FR: Heading","secondaryCopy":"FR: Secondary copy","body":"FR: Body","cancel":"Cancel","doNotShow":"Ne plus afficher.","confirmButton":"Gérer Mes données","newIcon":"NOUVEAU","leftNav":"Préc.","rightNav":"Suivant"}}}},"hup_not_eligible_title":"Impossible de traiter le rehaussement d’appareil","invalid_hup_order_error":"Nous sommes désolés, mais nos offres ont changé. Votre commande enregistrée n'est donc plus valide. Veuillez faire un nouveau choix pour continuer.","wireless_popup_title":"Vous voulez changer votre forfait sans-fil?","wireless_popup_title_2":"Pour changer votre forfait :","wireless_popup_line1":"Du lundi au vendredi de 7 h à minuit (HNE)","wireless_popup_line2":"Les week-ends de 8 h à minuit (HNE)","wireless_popup_phone":"Composez <b>1-855-720-9038</b>","wireless_popup_not_sure":"Vous ne savez pas quels forfaits sont offerts?","wireless_popup_all_plans":"Voyez tous les paquets","internet_usage_close":"près","ppc_not_eligible_title":"Admissibilité erreur","ppc_bot_header":"Changement de forfait en cours","case_success":"C’est fait!","_live_chat":"Clavardage en direct","800_number":"1 855 720 9038","800_number_hup":"1-855-720-9038","800_number_hup_new":"1-855-720-9038","hup_errorCode_L_contact_number":"1-844-370-1516","800_number_suspended":"1 877 559-5202","_continue":"Continuer","_ok":"OK","yes_change_plan":"OUI, CHANGER DE FORFAIT","proceed_ppc":"Procéder au changement de forfait","modified_ppc_wait_complete":"Non, attendre que la demande en cours soit traitée","GO_BACK":"RETOUR","CONFIRM":"CONFIRMER","CONFIRM_PLAN_CHANGE":"CONFIRMER LE CHANGEMENT DE FORFAIT","CANCEL":"ANNULER","ppc_remove_addon":"RETIRER L’OPTION","moving_to_ssp":"D&eacute;placer vers SSP","change_phone_number_desc":"Pour changer le num&eacute;ro de t&eacute;l&eacute;phone nous vous rediriger automatiquement vers l&apos;&eacute;cran appropri&eacute; en SSP.","change_sim_desc":"Pour changer la carte SIM/IMEI nous vous rediriger automatiquement vers l&apos;&eacute;cran appropri&eacute; en SSP.","change_plan_desc":"Pour changer le forfait nous vous rediriger automatiquement vers l&apos;&eacute;cran appropri&eacute; en SSP.","manage_addon_desc":"Pour le changement d&rsquo;options nous vous rediriger automatiquement vers l&apos;&eacute;cran appropri&eacute; en SSP.","toll-free-number":"1-855-720-9038","see_nac_toll-free-number":"1 855-291-9727","mu_chat":"Clavardage en direct","sorry_error":"<b>Désolé!</b>","change_payment_method":"Changer le mode de paiement","hup_processed_error":"Le rehaussement d’équipement ne peut être traité","success":"Succès","hup_make_a_payment":"effectuer un paiement ","yes_change_hup":"OUI, PROCÉDER AU REHAUSSEMENT D’ÉQUIPEMENT","proceed_hup":"Procéder au rehaussement d’équipement","modified_hup_wait_complete":"Non, attendre que la demande de changement de forfait en cours soit traitée","upgrade_device_desc":"Pour rehausser l'appareil nous vous rediriger automatiquement vers l'écran approprié en SSP.","tsp":"TSP","myr":{"pageNotFound":{"404":{"headline":"Page introuvable","subhead":"Nous sommes d&eacute;sol&eacute;s, nous ne trouvons pas la page que vous cherchez.","body":"S&eacute;lectionnez le bouton ci-dessous pour revenir &agrave; la page pr&eacute;c&eacute;dente.","button":"Retour","buttonBackToSignin":"Retourner Rogers.com"}},"liveChat":{"floatingAccountOverview":{"cbid":"1196954144473871463","boldChatDiv":"Design_Account_Overview","chatButton":"Design_Account_Overview-fr"},"floatingWirelessLanding":{"cbid":"5146290543006594431","boldChatDiv":"Design_Account_Services","chatButton":"Design_Account_Services-fr"},"floatingViewBill":{"cbid":"2391047034830706326","boldChatDiv":"Design_Account_view_Bill","chatButton":"Design_Account_view_Bill-fr"},"viewBillError":{"cbid":"7015556824075446708","boldChatDiv":"viewBillIssueHelpButton","chatButton":"Care_View_Bill_Issue-fr"}},"modules":{"accountBalance":{"your.account.balance":"Solde du compte","view.my.bill":"Consulter la facture","make.a.payment":"Effectuer un paiement"},"accountPreferences":{"reset.voicelmail.password":"De quel numéro de sans-fil voulez-vous voir les détails?","reset.voicelmail.error":{"GENERIC_ERROR":{"title":"Mettre &agrave; jour le mot de passe pour la messagerie vocale","description":"Il semble que vous n&rsquo;avez pas encore mis votre messagerie vocale en service. Pour commencer &agrave; recevoir des messages, appuyez longuement sur la touche [1] de votre t&eacute;l&eacute;phone."},"SUSPENDED_CTN":{"title":"Mettre &agrave; jour le mot de passe pour la messagerie vocale","description":"Il semble que votre compte puisse avoir &eacute;t&eacute; suspendu ou annul&eacute;. Si vous avez r&eacute;cemment effectu&eacute; des changements ou si vous souhaitez parler avec un conseiller, veuillez composer le 1-877-559-5202."}}},"findAccNumberMoal":{"link_account_intro_tile":"Bienvenue,","link_account_intro_02":"Pour accéder à votre compte (ou vos comptes) de Rogers, vous devez associer votre numéro de compte à votre profil MonRogers.","link_account_intro_02_cta_link":"Où puis-je trouver mon numéro de compte?","linked_acc_btn_submit":"Associer un compte","link_account_intro_03":"Une fois votre compte associé à votre profil vous pourrez accéder à tous vos services Rogers en ligne et en utilisant notre application :","linked_account_desc_item_1":"Faire le suivi de votre utilisation","linked_account_desc_item_2":"Consulter votre solde et payer votre facture","linked_account_desc_item_3":"Changer votre forfait","linked_account_desc_item_4":"Mettre à jour vos renseignements","linked_account_quick_links_title":"Liens rapides","linked_account_quick_links_1":"<a target=\"_blank\" href=\"https://www.rogers.com/web/Rogers.portal?_nfpb=true&_pageLabel=DeviceReservation&_nfls=true&setLanguage=fr&_eventName=DeviceReservation&forwardTo=nrsRegisteredCustomer\">Gérer votre réservation d’appareil</a>","linked_account_quick_links_2":"<a target=\"_blank\" href=\"https://nhllive.rogers.com/fr/\">Visionner LNH LIVE de Rogers</a>","linked_account_quick_links_3":"<a target=\"_blank\" href=\"http://www.sportsnet.ca/\">S’inscrire à Sportsnet</a>","linked_account_quick_links_4":"<a target=\"_blank\" href=\"https://www.texture.ca/fr/\">Obtenir l’appli de magazines Texture</a>","find_acc_number_modal_title":"Numéro de compte","find_acc_number_modal_intro":"Vous pouvez trouver votre numéro de compte Rogers:","find_acc_number_modal_option_1":"Sur votre facture papier","find_acc_number_modal_option_2":"Sur le courriel mensuel vous informant que vous pouvez accéder à votre facture en ligne ","find_acc_number_modal_option_3":"Votre entente de service (si vous vous êtes abonné en magasin)","find_acc_number_modal_option_1_intro":"Votre numéro de compte se trouve dans le coin supérieur gauche de chaque page de votre facture papier mensuelle","find_acc_number_modal_option_2_intro":"Chaque mois, vous recevez un courriel vous informant que votre facture est prête. Votre numéro de compte se trouve dans la section des détails sur la facturation du présent courriel.","find_acc_number_modal_option_3_intro":"Votre numéro de compte se trouve sur la première page de votre entente de service, sous la section des renseignements sur le compte."}}},"tel":"TEL","add_a_line_individual":"Ajouter une ligne – Individuelle","add_a_line_shared":"Ajouter une ligne – Partagez tout","add_a_line_desc":"Pour ajouter une ligne nous vous rediriger automatiquement vers l&apos;&eacute;cran appropri&eacute; en SSP.","wireless_cfa-functionality":"Fonctions service &agrave; la client&egrave;le","wireless_cfa-link_change-plan":"Changer de forfait","wireless_cfa-link_manage-addons":"Gérer mes options","wireless_cfa-link_reset-voicemail":"R&eacute;initialiser la Messagerie vocale","wireless_cfa-link_change-sim-imei":"Changer les num&eacute;ros SIM/IMEI","wireless_cfa-link_change-phone-number":"Changer de num&eacute;ro de t&eacute;l&eacute;phone","get_wireless_desc":"Pour ajouter service sans-fil nous vous rediriger automatiquement vers l'écran approprié en SSP.","message_do_not_display_ssp_popup":"Ne plus montrer ce message.","update_voicemail_password_desc":"Etes-vous s&ucirc;r que vous voulez r&eacute;initialiser le mot de passe de messagerie vocale?","ute.blocks":{"language.switcher":{"to":"en","label":"English"}},"10300_enterprise":"Le compte que vous essayez d’inscrire est un compte Affaires. Veuillez communiquer directement avec le conseiller attitré à votre compte pour obtenir de l’aide.","10300_new_reg":"Le compte que vous tentez d’inscrire est un compte d’entreprise. Consultez la <a href='https://www.rogers.com/business/ute/smb/transactions/uteAccountAssociation'>page d’inscription du Libre-service Affaires</a> pour inscrire votre compte en ligne et accéder aux renseignements sur votre utilisation et la facturation. Merci!","_MM":"MM","_YY":"AAAA","date_format_placeholder":"JJ/MM/AAAA","_a_month":"fr a month","_add_ons":"Options","_add_to_cart":"Add To Cart","_month":"par mois","_account_number":"Numéro de compte","_list_separator":"──────────","_add":"Ajouter","_answer":"Réponse","_attempt":"Tentative","_apply":"Apply","_address":"Adresse","_billing_cycle":"Cycle de facturation","_canada":"Canada","_unitedstates":"États Unis","_cancel":"Annuler","_customer_care":"fr Customer Care","_check_form_errors":"Des erreurs de validation ont été détectées sur cette page. Veuillez consulter le message au-dessus de chaque ligne.","_city":"Ville","_confirm_email":"Confirmez l’adresse électronique","_confirm_leave":"Confirmez que vous voulez quittez la page","_confirm_leave_details":"Êtes-vous sûr de vouloir quitter cette page? Nous ne pourrons enregistrer vos choix, alors vous devrez recréer votre nouveau forfait.","_confirm_password":"Confirmez le mot de passe","_contact_info":"Coordonnées","_contact_number_1":"Numéro de tél. :","_contact_number_2":"Numéro de tél. 2 :","_disclaimer":"","_discount":"Discount","_english":"Anglais","_editlabel":"Modifier","_extension":"Poste","_french":"Français","_email_ppc":"Adresse","_email_label":"Courriel :","_email_confirm":"Confirmez votre courriel","_email":"Adresse électronique","_email_address_not_valid":"Désolé, l'adresse électronique que vous avez entrée n’est pas valide.","_email_address_not_valid_try_again":"Veuillez entrer une adresse valide et réessayer.","_email_address_not_registered":"Adresse électronique ne est pas enregistré","_email_not_matched":"Les adresses électroniques ne sont pas identiques. Veuillez réessayer.","_email_verification":"Vérification","_email_verification_msg":"<p><strong>Nous vous avons envoyé un courriel d’activation de compte.</strong></p><br/><p>Pour terminer votre inscription, consultez votre boîte de réception, puis ouvrez une session à l’aide de votre nom d'utilisateur et du mot de passe temporaire que nous avons inclus dans ce courriel.</p><br/>","_email_verfication_your_email":"Votre adresse courriel est","_ends_on":"fr ends on ","_ext":"Poste:","_first_name":"Prénom","_forgot":"Vous avez oublié votre","_hi":"Bonjour","_hello":"Bonjour","_includes":"Options comprises à","_internet":"Internet","_internet_page":"La page Internet","_invalid":"invalide","_lang":"Langue :","_last_name":"Nom de famille","_learn_more":"Détails","_manage":"Gérez","_my_rogers":"Mon Rogers","_my_rogers_nospace":"MonRogers","_my_rogers_nospace_mark":"MonRogers<sub><small><small>MC</small></small></sub>","_my_rogers_nospace_caps":"MonROGERS","_my_services":"Mes services","_next":"Next","_new":"Nouveau","_new_monthly_cost":"New Monthly Cost","_no_data_included":"No data included","_of":"de","_or":"ou votre ","_online":"En ligne","_online_bill":"Facture en ligne","_other_rogers_services":"fr Other Rogers Services","_other_services_available":"Autres services offerts","_password_txt":"Mot de passe","_password":"Mot de passe :","_password_not_matched":"Votre mot de passe et celui de confirmation ne sont pas semblables.","_password_pattern_error":"Votre mot de passe doit contenir de 7 à 16 caractères comprenant des lettres et des chiffres uniquement [pas de caractères spéciaux]","_password_reminder":"Mot de passe et question de rappel","_phone_number":"Numéro de téléphone","_pin":"NIP de quatre chiffres","_pin_confirm":"Confirmez le NIP de quatre chiffres","_plan":"Plan","_plus":"Plus","_paper":"Papier","_paper_bill":"Facture papier","_postal_code":"Code postal","_prefer_lang":"Langue de préférence","_province":"Province","_registration":"Enregistrement","_registration_complete":"Merci de vous être inscrit à votre compte MonRogers!","_registration_complete_community_title":"Joignez-vous au forum communautaire de Rogers","_registration_complete_community_body":"Obtenez de bons conseils de Rogers, faites part de vos idées et discutez avec les employés de Rogers et les autres membres de nos forums communautaires.","_registration_complete_community_button":"Joignez-vous à la communauté","_registration_go_to_account":"Dirigez-moi vers mon compte","_remember_me":"Enregistrer le nom d’utilisateur","_make_pre_auth":"Enregistrer la carte pour effectuer de futurs paiements préautorisés","_require_confirm_email":"Veuillez confirmer votre adresse électronique en la saisissant de nouveau.","_require_email":"Veuillez entrer une adresse électronique.","_require_password":"Veuillez entrer votre mot de passe.","_require_security_answer":"Veuillez entrer la réponse à votre question de sécurité.","_require_security_question":"Veuillez choisir une question de sécurité.","_require_username":"Veuillez entrer votre nom d’utilisateur.","_required":"requis","_review_order":"Vérifier la commande","_rogers_bank":"fr Rogers Bank","_save":"ENREGISTRER","_security_questions":"Questions de sécurité","_signin":"Ouvrir une session","_share_everything_plan":"Forfait Partagez tout<sup>MC</sup>","_states":"États","_submit":"Soumettre","_update":"Mettre","_update_2":"Mettre à jour","_taxes":"Taxes","_tv":"Télévision","_username":"Nom d'utilisateur :","_username_no_col":"Nom d'utilisateur","_email_already_linked":"Désolés, ce compte est déjà associé à une autre adresse courriel. Veuillez communiquer avec nous à l’aide de l’outil de clavardage en direct pour obtenir de l’aide","expires":"Expire","expires_rebate":"Expiration du rabais : le ","_email_already_linked_no_account":"Ce compte est inscrit à l’adresse suivante: {{maskedEmail}}. <br/>Pour configurer un nouveau mot de passe, sélectionnez <a href=\"#\" class=\"forgot-password-interceptor error-bold\">Mot de passe oublié.</a>","_username_email":"Nom d'utilisateur ou adresse électronique","_months":{"0":"janvier","1":"février","2":"mars","3":"avril","4":"mai","5":"juin","6":"juillet","7":"août","8":"septembre","9":"octobre","10":"novembre","11":"décembre"},"_monthShort":{"0":"janv","1":"févr","2":"mars","3":"avril","4":"mai","5":"juin","6":"juil","7":"août","8":"sept","9":"oct","10":"nov","11":"déc"},"alberta":"Alberta","british_columbia":"Colombie-Britannique","manitoba":"Manitoba","new_brunswick":"Nouveau-Brunswick","newfoundland":"Terre-Neuve-et-Labrador","northwest":"Territoires du Nord-Ouest","nova_scotia":"Nouvelle-Écosse","nunavut":"Nunavut","ontario":"Ontario","prince_edward_island":"Île-du-Prince-Édouard","quebec":"Québec","saskatchewan":"Saskatchewan","yukon":"Yukon","oops":"OUPS","_something_went_wrong":"Something went wrong!","_under_construction":"En cours de construction","_selected":"Selected","_select":"SÉLECTIONNER","_recommended":"Recommandé","_exclusive":"Exclusive","__your_plan":"Votre forfait actuel","_suspended_service":"Ce service est actuellement suspendu.","_have_questions":"Vous avez des questions?","_chat_with_us":"Clavardez avec nous!","_myAccount_playstore_url":"https://play.google.com/store/apps/details?id=com.fivemobile.myaccount&hl=fr","submenu_acc_overview":"Survol du compte","submenu_billing_and_payment":"Facturation et Paiement","submenu_services":"Services","submenu_profile":"PROFIL ET PARAMÈTRES","submenu_link_account":"Associer le compte","account":"Compte","acc_balance":"Solde du compte","current_bucket":"Actuellement","acc_balance_not_available":"FR Not available","acc_balance_pay_now":"Faire un paiement","acc_balance_Required":"Date d’exigibilité du paiement","acc_balance_view_bill":"Consulter la facture","acc_balance_view_older_bill":"Consulter les anciennes factures","acc_overview_oops":"Oups! Il semble que nous ne soyons pas en mesure de mettre à jour vos informations. Veuillez vérifier de nouveau plus tard.","acc_overview_loyalty_error":"Nous sommes incapables de récupérer les renseignements sur Récompenses Fidélité Rogers  pour l’instant. Veuillez visiter <a href='www.RecompensesFideliteRogers.com'>www.RecompensesFideliteRogers.com</a>","acc_overview_account_balance":"Solde du compte","acc_overview_account_cancelled_care":"<span class=\"error-type\">COMPTE ANNULÉ</span>","acc_overview_account_cancelled":"Ce compte a été fermé.","acc_overview_account_exceeded":"Le solde de ce compte dépasse la limite de crédit.","acc_overview_account_limited_care":"<span class=\"error-type\">COMPTE ANNULÉ</span>","acc_overview_account_overdue_care":"<span class=\"error-type\">COMPTE SUSPENDU.</span><span class=\"error-message-suspended\"> Pour réactiver les services, <a href=\"JavaScript:void(0);\" ng-click=\"ao.payBillSuspended()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\">traitez le paiement</a> couvrant le solde impayé.</span>","acc_overview_account_suspended_care":"<span class=\"error-type\">COMPTE SUSPENDU.</span><span class=\"error-message-suspended\"> Si un solde impayé figure au compte, le fait d’effectuer un paiement peut rétablir sur-le-champ votre accès complet aux renseignements de votre compte sur MonRogers<sub><small><small>MC</small></small></sub>. Vous pouvez aussi communiquer avec nous par clavardage en direct pour régler ce problème.</span>","acc_overview_account_suspended_2_care":"<span class=\"error-type\">COMPTE SUSPENDU.</span><span class=\"error-message-suspended\"> Ce compte a été suspendu.</span>","acc_overview_account_limited":"Ce compte a été fermé, votre accès à MonRogers<sub><small><small>MC</small></small></sub> est par conséquent limité.  Vous pouvez toutefois…","acc_overview_account_overdue":"<b>Ce compte est actuellement suspendu.</b><br/>Si un solde impayé figure au compte, le fait d’effectuer un paiement peut rétablir sur-le-champ votre accès complet aux renseignements de votre compte sur MonRogers<sub><small><small>MC</small></small></sub>. Vous pouvez aussi communiquer avec nous par clavardage en direct pour régler ce problème.","acc_overview_account_suspended":"Ce compte est actuellement suspendu. Si un solde impayé figure au compte, le fait d’effectuer un paiement peut rétablir sur-le-champ votre accès complet aux renseignements de votre compte sur MonRogers<sub><small><small>MC</small></small></sub>. Vous pouvez aussi communiquer avec nous par clavardage en direct pour régler ce problème.","acc_overview_account_suspended_2":"Ce compte a été suspendu.","acc_overview_billing_cycle_end":"Le cycle de facturation du mois courant se termine dans <X> jours : <JJ MMM AAAA>","acc_overview_credit_limit_status":"État de la limite de crédit","acc_overview_daily_maintenance":"Désolé, la période de maintenance quotidienne de MonRogers<sub><small><small>MC</small></small></sub> est de 2 h à 5 h. Même si la plupart des fonctions ne sont pas offertes pendant cet intervalle.","acc_overview_due_credit":"Porté à votre carte de crédit le ou après le","acc_overview_due_debit":"Retiré de votre compte le ou après le","acc_overview_due_invoice":"Date d’exigibilité du paiement","acc_overview_expires_on":"Expire le","acc_overview_withdrawal_by":"Porté à votre carte de crédit le ou après le","acc_overview_manage":"Gérer","acc_overview_monthly_credit_exceeded":"La limite de crédit mensuelle de ce compte a été dépassée. Le service sera entièrement rétabli lorsque le solde sera inférieur à la limite de crédit.<br/>- Faire un paiement","acc_overview_my_account":"Survol du compte","acc_overview_my_offers":"Mes offres","acc_overview_my_services":"Mes services","acc_overview_other_services":"Autres services offerts","acc_overview_outstanding_balance":"Solde exigible ","acc_overview_pay_as_you_go":"Mon <strong>service</strong> Parlez à la ","acc_overview_pay_as_you_go_2":"carte<sub>MC</sub>","acc_overview_pay_as_you_go_cancelled":" Étant donné que votre compte <i>Parlez à la carte<sub>MC</sub></i> est annulé, votre accès à MonRogers <sub>MC</sub>  est restreint. Les services auxquels vous avez accès vous permettent de :<br/><a href='/web/RogersServices.portal?_nfpb=true&_pageLabel=ManageMyOnlineProfile_beta' target='_blank'>- Gérer votre profil</a><br/>- <a href=' https://www.rogers.com/web/Rogers.portal?_nfpb=true&_pageLabel=PREPAID_ACTIVATIONS&_nfls=true&cm_sp=wireless-_-pay_as_you_go-_-activate_now_banner' target='_blank'>Mettre en service un nouveau compte prépayé.</a>.<br/>Une fois votre téléphone mis en service, reliez votre nouveau compte à votre profil MonRogers<sub><small><small>MC</small></small></sub> existant pour profiter pleinement de tous les services en ligne.","acc_overview_pay_as_you_go_suspended":"Votre compte <i>Parlez à la carte<sub>MC</sub></i> est actuellement inactif. Pour ajouter du temps d'antenne à votre compte, veuillez nous appeler au 1-800-575-9090 pour parler à un représentant du Service à la clientèle qui sera ravi de vous aider.","acc_overview_pay_by":"Payer d’ici","acc_overview_pay_now":"Payer maintenant","acc_overview_my_account_overview":"Survol du compte","acc_overview_my_acc_overview":"Survol du compte","acc_overview_my_acc_overview_product":"Aperçu du compte","acc_overview_my_shop_for_products":"Magasiner des produits","acc_overview_platinum_member":"Membre Platine","acc_overview_redeem_points":"Échanger/Accumuler des points","acc_overview_remaining_credit":"Crédit restant ","acc_overview_silver_member":"Membre Argent","acc_overview_salutation":"Merci de votre visite!<br/><p class='ptm'>Si vous voulez vérifier votre utilisation, votre facture ou les détails de votre compte, vous êtes au bon endroit.</p><p>Rehaussez votre téléphone intelligent <a href='/web/myrogers/device-upgrade'>ici</a>!</p>","acc_overview_top_up_now":"Réapprovisionner maintenant","acc_overview_total_credit_limit":"Limite de crédit totale ","acc_overview_view_bill":"Consulter la facture","acc_overview_view_bill_history":"Consulter votre historique de facture et de paiement","acc_overview_manage_profile":"Gérer votre profil","acc_overview_which_account":"Quel compte souhaitez-vous consulter aujourd’hui?","acc_overview_no_product":"Vous n’êtes actuellement pas abonné à ce produit ou service.","acc_overview_no_information":"Désolé, les renseignements demandés ne sont pas disponibles.<div class='visit'>Pour ajouter un produit ou un service à votre compte, veuillez consulter la page <span class='shop-text'>Magasiner.</span></div>","acc_multiCTN_which_wireless_account":"De quel numéro de sans-fil voulez-vous voir les détails?","acc_overview_you_earned":"Vous avez accumulé <b>{{points}} points</b> au cours du mois","acc_selection_suspended":"Ce compte a été suspendu.","acc_selection_clm":"<strong>La limite de crédit mensuelle de ce compte a été dépassée.</strong><br/>Le service sera entièrement rétabli lorsque le solde sera inférieur à la limite de crédit.","calling_features":"Fonctions d’appel","changed_your_plan":"Vous avez changé de forfait ici","checkout_review_order":"Vérifier la commande","checkout_review_order_summary_total":"Order Summary Total","checkout_review_order_billing_address":"Adresse de facturation","checkout_review_order_billing_preferences":"Préférences de facturation","checkout_review_order_pay":"Payer:","checkout_review_order_pay_invoice":"Au moment de recevoir la facture","checkout_review_order_receive_bill_via":"Réception de la facture:","checkout_review_order_send_bill_to":"Envoyer la facture à:","BillingAddressHeading":"Facturation","billing_address":"Adresse de facturation :","BillingType":"Type de facture :","billing_us_address_warning":"Si vous voulez changer pour une adresse aux É-U, veuillez contacter Clavardage en direct. Ou si vous voulez changer pour une adresse canadienne, veuilez cliquer sur Modifer en haut.","billing_move_your_services_warning":"<strong>Remarque : </strong>Seule votre adresse de facturation sera mise à jour. Pour déménager vos services, <a href=\"https://www.rogers.com/consumer/support/moving-your-services?setLanguage=fr\" class=\"move_your_services-link\" target=\"_blank\">contactez-nous</a>.","birth_city":"Quelle est votre ville natale?","billing_enhance_message":"Votre facture est maintenant plus facile à comprendre. Voyez les nouveautés et les améliorations!","billing_enhance_message1":"Votre facture est maintenant plus facile à comprendre.","billing_enhance_message2":"Voyez les nouveautés et les améliorations!","billing_enhance_check_it_out_button":"Cliquez ici","billing_enhance_got_it":"Ok, c’est clair","billing_enhance_overlay_heading":"Nouveau! Téléchargez les détails de votre utilisation.","billing_enhance_overlay_text":"Vous pouvez maintenant télécharger les détails de votre utilisation de temps d’antenne et de données en format Excel.","billing_enhance_overlay_heading_slide1":"Voici votre nouvelle facture Rogers améliorée","billing_enhance_overlay_text_slide1":"Dans la nouvelle section des points importants, vous verrez vos dépenses et vos économies en plus de votre forfait mensuel.","billing_enhance_overlay_text_slide2":"Ne vous laissez pas surprendre par un solde impayé. Maintenant, vous verrez immédiatement s'il y a un solde impayé depuis votre dernière facture.","billing_enhance_overlay_text_slide3":"Ne cherchez pas les détails. La nouvelle page de sommaire affiche tous les frais supplémentaires et crédits ainsi que votre utilisation.","billing_enhance_checkout_new":"Découvrez les nouveautés","CredentialsHeading":"Nom d’utilisateur et mot de passe","checkout_review_order_proration":"Proration","checkout_review_order_prorated":"Prorated","checkout_review_order_changes":"Changes","checkout_review_terms_and_conditions":"Terms & Conditions","checkout_review_checkout":"PASSER À LA CAISSE","checkout_review_complete_order":"Soumettre","checkout_review_complete_notice":"En confirmant ce changement de forfait, vous acceptez de ne plus profiter des promotions et des rabais actuels. Vous pourrez toutefois commencer à profiter de votre nouveau forfait immédiatement.","checkout_review_monthly_total":"Monthly Total","checkout_review_on_bill":"Sur la facture","checkout_review_additional_agreement_details":"Renseignements additionnels sur l’entente de service","checkout_review_account_maint_agree":"Entente de gestion de compte","checkout_acceptable_use_policy":"Politique d'utilisation acceptable","checkout_privacy_policy":"Politique de confidentialité","checkout_introductory_information":"Introduction","checkout_service_term_changes_and_cancellation":"Période d’abonnement, modifications et résiliation","checkout_account_charges_and_billing_information":"Compte, frais et facturation","checkout_deposit_and_credit_requirements":"Exigences en matière de dépôt et de crédit","checkout_your_use_of_the_services":"Votre utilisation des Services","checkout_equipment":"Équipement","checkout_prepaid_wireless_service":"Service sans fil prépayé","checkout_warranties_limitation_liability":"Garanties et limite de responsabilité","checkout_general":"Dispositions générales","checkout_your_privacy":"Protection de votre vie privée","checkout_review_rogers_tos":"Modalités de service de Rogers","checkout_review_acceptable_use_policy":"Politique d'utilisation acceptable","checkout_review_privacy_policy":"Politique de confidentialité","checkout_review_checkbox_copy":"J’ai lu, compris et accepté tous les détails de mon Entente, y compris mon entente de service, les Modalités de service de Rogers, la Politique d’utilisation acceptable et la Politique de confidentialité.","checkout_confirm_order_order_confirmation":"Confirmation de la commande","checkout_confirm_order_service_address":"Service Address","checkout_confirm_order_order_summary":"Sommaire de la commande","checkout_confirm_order_your_order":"Votre commande","checkout_confirm_order_for_your_order":"for your order","checkout_confirm_order_procesing_your_request":"Nous traitons votre demande.","checkout_confirm_order_check_your_inbox":"Check your inbox for a special offer on your confirmation email that you will receive shortly.","checkout_confirm_order_continue_shopping":"Continue Shopping","checkout_confirm_order_contact_details":"Coordonnées","checkout_confirm_order_qty":"Qty","checkout_confirm_order_monthly_fees":"Frais mensuels","checkout_confirm_order_monthly_fees_new_plan":"Frais mensuels associés au nouveau forfait","checkout_confirm_new_monthly_total_fees":"Nouveau total des frais mensuels","checkout_confirm_order_taxes":"TPS/TVH","checkout_confirm_order_pst_qst":"TVP/TVQ","checkout_confirm_thank_you":"Félicitations pour ","checkout_confirm_for_your_order":"votre nouveau forfait","checkout_confirm_congrats":"Félicitations","checkout_confirm_on_your_new_plan":"pour votre nouveau forfait","checkout_confirm_email_confirm":"Vous recevrez sous peu une confirmation par courriel.","checkout_confirm_term_service":"Service avec abonnement à durée déterminée","checkout_confirm_partial_prepaid":"Des frais partiels apparaîtront peut-être sur votre prochaine facture","checkout_confirm_month_month_service":"Service au mois","checkout_confirm_fine_print":"À moins d'indication contraire, tous les détails concernant les minutes de service voix, les messages et l'accès Internet sans-fil indiqués ci-dessus font référence à leur utilisation sur notre réseau (c'est-à-dire, au Canada sur notre réseau et à un numéro au Canada, selon le cas).  Si vous changez de forfait pour un forfait de niveau inférieur pendant votre période d'abonnement, vous devrez payer des frais de déclassement calculés en fonction des montants prévus dans votre entente de service.<div class='mtm'>Si vous êtes abonné à un service avec abonnement à durée déterminée, cette transaction de changement de forfait ne modifiera pas la date de début ou de fin de votre période d’abonnement.</div>","dataOverage":"Utilisation excédentaire de données","dealer-code_your_enter":"Entrez votre code de concessionnaire","dealer-code_enter":"Entrer le code de concessionnaire","dealer-code_info":"Utilisez la boîte ci-dessous pour entrer votre code de concessionnaire. Une fois le code entré, le système l’enregistrera pour une utilisation ultérieure. Si vous devez effectuer une transaction pour un autre conseiller, vous devrez changer temporairement votre code de concessionnaire.","dealer-code_on_behalf_dealer_code":"Si vous souhaitez agir au nom d’un autre conseiller pour cette session, veuillez entrer son code de concessionnaire ici.","dealer-code_warning_description":"Vous ne pourrez traiter aucune transaction si vous n’entrez pas de code de concessionnaire.","dealer-code_without_dealer_code":"Procéder sans code de concessionnaire","dealer-code_now_behalf_of_agent":"Vous agissez maintenant au nom de :","dealer-code_use_my-code":"Mon code de concessionnaire","dealer-code":"Code de concessionnaire","dealer-code_no_code":"Numéro de code","dealer-code_dsg_enter_dealer_code":"Entrez le numéro de concessionnaire que vous utiliserez pour ce client","dealer-code_change_dealer_code":"Changer mon code de concessionnaire","dealer-code_error":"Code de concessionnaire non valide","dealer-code_oops":"Oups!","carousel_modal":{"leftNav":"Préc.","rightNav":"Suivant","indicatorTitle":"Page {{index}} of {{total}}"},"EOP":{"igniteImageAlt":"Les offres groupées Élan comprennent la Télé Élan et Élan Internet","saiImageAlt":"Une famille profite du service Élan Internet à la maison","/mo":"par mois","/mo*":"par mois*","Unlimited":"Illimitée","DYNATRACE":{"eop":{"CLOSE":"x-close-eop|ignite-offer-alert","LEARNMORE":"Learn more-eop|ignite-offer-alert"},"regular":{"CLOSE":"x-close-ignite migration-alert","LEARNMORE":"Learn more-ignite migration-offer-alert"},"recommended":{"CLOSE":"x- close personalized-recommendation-offer-alert","LEARNMORE":"Learn more- personalized-recommendation-offer-alert"}},"CTAS":{"IGNITE":{"eop":{"LABEL":"Profiter de l'offre","ALT":"En savoir plus sur cette offre"},"regular":{"LABEL":"En savoir plus","ALT":"En savoir plus sur cette offre"},"recommended":{"LABEL":"En savoir plus","ALT":"En savoir plus sur cette recommandation"}},"UPGRADE_NOW":{"LABEL":"Rehausser maintenant","ALT":"Sélectionnez pour rehausser."},"TAKE_ACTION":{"LABEL":"Profiter de l'offre","ALT":"En savoir plus sur cette offre"},"takeMeThere":{"label":"Oui, voir mon offre","alt":"Oui, voir mon offre","smartStreamLabel":"Oui! Consulter mon offre","smartStreamAlt":"Consulter votre offre Élan Internet et Diffusion Élan"},"dismiss":{"label":"Non, continuer dans MonRogers","alt":"Non, continuer dans MonRogers","smartStreamAlt":"Refuser cette offre et continuer dans MonRogers"},"CLOSE":{"ALT":"Fermer cette fenêtre"},"DISMISS_OFFER":{"LABEL":"Ne plus afficher ce message.","ALT":"Arrêter la suite de ce message et fermer cette fenêtre"},"COMPARE_PLAN":{"LABEL":"Comparer les forfaits","ALT":"Sélectionnez pour comparer les forfaits."},"PROMOTION_OFFER_BADGE":{"LABEL":"Vous avez une offre de rehaussement","ALT":"Renseignez-vous sur votre offre de rehaussement spéciale"},"RECOMMENDED_OFFER_BADGE":{"LABEL":"Vous avez une recommandation spéciale","ALT":"Renseignez-vous sur votre recommandation"}},"NEW_OFFER_NOTIFICATION":{"video":{"playerId":"NC2EcBXc7","accountId":"1275380481001","videoId":"6168084742001","src":"//players.brightcove.net/1275380481001/NC2EcBXc7_default/index.min.js","lang":"fr"},"tupelo":{"header":"Votre offre : Élan<sub>MC</sub> Internet comprenant le service Diffusion Élan!","body":"Regardez au même endroit le contenu offert par vos services de diffusion en continu préférés, ainsi que des émissions et des films gratuits! Utilisez simplement la recherche vocale.","learnPage":{"label":"En savoir plus sur le service Diffusion Élan","alt":"En savoir plus sur le service Diffusion Élan"}},"sai":{"header":"Une offre personnalisée Élan Internet pour vous!","body1":"Obtenez le service <span class=\"font-bold\">Élan</span><sub>MC</sub> Internet propulsé par la fibre optique pour profiter de la couverture WiFi mur à mur, en plus de surveiller, de gérer et de protéger votre réseau résidentiel, où que vous soyez, à l’aide du centre <span class=\"font-bold\">Élan WiFi!</span> <br>Nous pensons que vous adorerez le forfait Élan Internet que nous avons choisi pour vous. Jetez un coup d’œil à votre offre dès maintenant!","subheader":"Voici la promesse Élan WiFi","body2":"Tous les forfaits Élan Internet sont maintenant soutenus par la promesse Élan WiFi. Un réseau WiFi résidentiel puissant et sécurisé sur lequel vous pouvez compter : c’est notre promesse."},"ignite":{"header":"Faites l’expérience de la Télé Élan – le service de télé de prochaine génération, propulsé par notre service Internet le plus rapide","body1":"Regardez votre contenu préféré de différentes plateformes telles que Netflix, la télé en direct et vos enregistrements avec la recherche vocale tout-en-un!","subheader":"Voici la promesse Élan WiFi","body2":"Tous les forfaits Élan Internet sont maintenant soutenus par la promesse Élan WiFi. Un réseau WiFi puissant et sécurisé sur lequel vous pouvez compter : c’est notre promesse."},"LEGACY":{"TITLE":"<span aria-hidden=\"true\"><i class=\"rui-icon-error\"></i></span> Votre session expirera bient&ocirc;t.","BODY":"Le montant de votre facture augmentera lorsque votre offre sera termin&eacute;e. Voici une chance d&rsquo;&eacute;conomiser sur vos services t&eacute;l&eacute;."},"IGNITE":{"TITLE":{"regular":"Laissez-nous vous proposer une offre incroyable!","eop":"Les &eacute;conomies li&eacute;es &agrave; vos services se terminent bient&ocirc;t.","recommended":"Vous avez droit &agrave; une offre personnalis&eacute;e"},"BODY":{"regular":"Vous avez droit au service T&eacute;l&eacute; &Eacute;lan<sub>MC</sub> &agrave; prix sp&eacute;cial!","eop":"Une fois votre promotion actuelle termin&eacute;e, votre facture augmentera. Voici une autre chance de continuer &agrave; &eacute;conomiser sur vos services.","recommended":"Excellente nouvelle! Jetez un coup d'&oelig;il &agrave; ce service que nous pensons que vous aimerez."}}},"TECHNICAL_ERROR":{"TITLE":"Un probl&egrave;me est survenu.","BODY":"Nous sommes d&eacute;sol&eacute;s, nous &eacute;prouvons actuellement des difficult&eacute;s techniques. Veuillez r&eacute;essayer plus tard."},"OFFER_MISMATCH":{"TITLE":"Nous sommes d&eacute;sol&eacute;s...","BODY":"Il semble que vous ayez r&eacute;cemment accept&eacute; une autre offre pour ces services. Cette promotion n'est plus en vigueur."},"CURRENT_PLAN":{"title":"Votre offre group&eacute;e actuel","features":{"tv":"T&eacute;l&eacute;:","internet":"Internet:","home_phone":"La telephonie r&eacute;sidentielle:","download":"Vitesses de t&eacute;l&eacute;charge-ment pouvant atteindre :","channels":"cha&icirc;nes","internet_desc":"Vitesse de t&eacute;l&eacute;charge-ment"},"current_promo_price":"Prix actuel avec &eacute;conomies ","price_after":"Prix apr&egrave;s"},"NEW_OFFER":{"HEADER":"Laissez-nous vous proposer une autre offre incroyable!","BODY":"Vous &ecirc;tes admissible &agrave; un rehaussement de vos services de Rogers &agrave; prix r&eacute;duit. Mais faites vite, car cette offre est d'une dur&eacute;e limit&eacute;e!","newOfferTitle":"Forfait télé {{ bundleName }} avec :","newPromo":{"exclusiveOffer":"Votre offre exclusive:","name":"Forfait télé","features":{"tv":"T&eacute;l&eacute; avec","download":"Vitesses de t&eacute;l&eacute;charge-ment pouvant atteindre:","channels":"cha&icirc;nes"},"image_alt":"Image de ","includes_rhp":"La telephonie r&eacute;sidentielle inclus","SAVINGS":"Apr&egrave;s le cr&eacute;dit de {{ discount }} $ pendant {{ term }} mois</br>Actuellement {{ originalMsf }} $ par mois</br>Sous r&eacute;serve de toute augmentation de tarif.","SAVINGS_with_month_term":"Apr&egrave;s un cr&eacute;dit de {{ discount }} $/mois pendant {{ term }} mois.</br>Prix actuel : {{ originalMsf }} $/mois.</br>Forfait avec abonnement au mois. Les prix peuvent augmenter.","notIncluded":"Les prix ne comprennent pas les frais reli&eacute;s aux options ou &agrave; l'&eacute;quipement suppl&eacute;mentaire actuellement inscrits &agrave; votre compte.","installation_fee":"Installation:","FREE":"GRAUIT","disclaimer":{"internet":"* Taxes en sus. Le cr&eacute;dit sera appliqu&eacute; mensuellement sur le prix courant pendant toute la dur&eacute;e de la p&eacute;riode promotionnelle. Le prix courant est donn&eacute; sous r&eacute;serve de toute augmentation de tarif applicable pendant ou apr&egrave;s la p&eacute;riode promotionnelle. L'offre, d'une dur&eacute;e limit&eacute;e, est en vigueur dans la zone desservie par le r&eacute;seau c&acirc;bl&eacute; de Rogers (l&agrave; o&ugrave; la technologie le permet). L'offre peut &ecirc;tre modifi&eacute;e sans pr&eacute;avis. L'utilisation de donn&eacute;es est assujettie aux Modalit&eacute;s de service et &agrave; la Politique d'utilisation acceptable de Rogers. Consultez rogers.com/modalites pour conna&icirc;tre tous les d&eacute;tails","tv":"* Taxes en sus. Le cr&eacute;dit sera appliqu&eacute; mensuellement sur le prix courant pendant toute la dur&eacute;e de la p&eacute;riode promotionnelle. Le prix courant est donn&eacute; sous r&eacute;serve de toute augmentation de tarif applicable pendant ou apr&egrave;s la p&eacute;riode promotionnelle. L'offre, d'une dur&eacute;e limit&eacute;e, est en vigueur dans la zone desservie par le r&eacute;seau c&acirc;bl&eacute; de Rogers (l&agrave; o&ugrave; la technologie le permet). L'offre peut &ecirc;tre modifi&eacute;e sans pr&eacute;avis. Consultez rogers.com/modalites pour conna&icirc;tre tous les d&eacute;tails","bundle":"* Taxes en sus. Le cr&eacute;dit sera appliqu&eacute; mensuellement sur le prix courant pendant toute la dur&eacute;e de la p&eacute;riode promotionnelle. Le prix courant est donn&eacute; sous r&eacute;serve de toute augmentation de tarif applicable pendant ou apr&egrave;s la p&eacute;riode promotionnelle. L'offre, d'une dur&eacute;e limit&eacute;e, est en vigueur dans la zone desservie par le r&eacute;seau c&acirc;bl&eacute; de Rogers (l&agrave; o&ugrave; la technologie le permet). L'offre peut &ecirc;tre modifi&eacute;e sans pr&eacute;avis. L'utilisation de donn&eacute;es est assujettie aux Modalit&eacute;s de service et &agrave; la Politique d'utilisation acceptable de Rogers. Consultez rogers.com/modalites pour conna&icirc;tre tous les d&eacute;tails. Rogers se r&eacute;serve le droit de supprimer des avantages de l'offre group&eacute;e et, par cons&eacute;quent, l'admissibilit&eacute; du client &agrave; cette offre, si les services sont modifi&eacute;s ou annul&eacute;s."}}},"ways_to_buy":"Pour l'obtenir:","call_care":"1-877-791-3308","call_care_alt_text":"Appeler Rogers au sujet de cette offre au","liveChat_ID":"5184201031209042447","liveChat_alt_text":"Clavardez en direct avec un conseiller pour parler de cette offre"},"favorite_hobby":"Quel est votre passe-temps préféré?","myrLinkAccount_title":"Associer un compte","myrLinkAccount_body":"Pour voir votre facture, consulter votre utilisation et bien plus, associez vos services à votre profil <span class='ute-textWeight-medium'>MonRogers.</span>","myrLinkAccount_skip_body":"Vous n’avez pas de services de Rogers?","myrLinkAccount_skip_cta":"Sauter cette étape","myrLinkAccount_business_callout_title":"Vous avez un compte de petite entreprise?","myrLinkAccount_business_callout_body":"Consultez la page du Libre-service Affaires pour accéder aux informations liées à votre utilisation et à votre facture.","myrLinkAccount_select_type":"Sélectionnez votre type de compte","myrLinkAccount_tab_cable":"Services sans-fil ou du câble","myrLinkAccount_tab_payasyougo":"Parlez à la carte<sup>MC</sup>","myrLinkAccount_cable_step_1":"1. Entrez votre numéro de compte et votre code postal","myrLinkAccount_cable_account_number":"Numéro de compte de 9 à 12 chiffres","myrLinkAccount_cable_postal":"Code postal (p. ex., M2Y2Y5 ou M2Y 2Y5)","myrLinkAccount_cable_step_2":"2. Sélectionnez votre type de facture","myrLinkAccount_cable_online_bill":"Facture en ligne","myrLinkAccount_cable_paper_bill":"Facture papier","myrLinkAccount_online_benefits_title":"Avantages de la facture en ligne","myrLinkAccount_online_benefits_1":"Accédez à votre facture partout et en tout temps.","myrLinkAccount_online_benefits_2":"Soyez averti lorsque votre facture est prête.","myrLinkAccount_online_benefits_3":"Téléchargez les détails de votre utilisation.","myrLinkAccount_online_benefits_4":"Conservez les factures en ligne des 18 derniers mois.","myrLinkAccount_cta_link":"Associer un compte","myrLinkAccount_cta_cancel":"Annuler","myrLinkAccount_payasyougoTitle":"Entrez votre numéro de téléphone et votre code postal","myrLinkAccount_phoneNumber":"Numéro de téléphone à dix chiffres","myrLinkAccount_pin":"NIP de quatre chiffres","myrLinkAccount_forgot_pin":"Vous ne vous rappelez pas du NIP de votre compte? <br/>Composez le 1-800-575-9090 pour parler à un conseiller.","link_account_title":"Lier Compte de Rogers","link_account_intro":"Nous avons remarqué qu’aucun compte Rogers n’est lié à votre profil MonRogers. Vous pouvez lier un compte pour obtenir le maximum de MonRogers.","link_account_intro_no_link":"Nous avons remarqué qu’aucun compte Rogers n’est lié à votre profil MonRogers.<br/><br/> Vous pouvez lier un compte pour obtenir le maximum de MonRogers.","link_account_need_help":"Besoin d'aide?","link_account_tooltip":"Vous avez oublié votre numéro de compte? Communiquez avec un conseiller du Service à la clientèle en ligne au moyen de l'outil de clavardage en direct. Nous retrouverons les détails de votre compte pour que vous puissiez profiter de MonRogers.","link_account_general_error":"Nous sommes incapables d’associer votre compte Rogers à votre profil MonRogers pour l’instant. Veuillez réessayer plus tard.","link_account_no_rogers_account_error":"Désolé, le numéro de compte entré n’a pas été trouvé. Veuillez vérifier le numéro entré.","link-pay-as-you-go-error":"Désolés, les renseignements saisis sont associés à un compte Parlez à la carte. Pour associer ce compte, veuillez sélectionner le type de compte Parlez à la carte.","linked_acc_bill_options_1":"Facture en ligne","linked_acc_bill_options_2":"Facture papier","linked_acc_btn_skip":"Sautez cette étape","linked_acc_btn_submit":"Associer le compte","linked_acc_discl_accept":"J’accepte les modalités.","linked_acc_discl_accept_error":"Veuillez accepter les modalités avant de continuer.","linked_acc_discl_text":"Les modalités de service suivantes régissent l&#39;utilisation du service de facture électronique (le « Service ») auquel vous avez adhéré ou que vous recevez de Rogers. Elles s&#39;ajoutent et sont intégrées aux modalités de service de Rogers qui se trouvent sur le site www.rogers.com/modalites. Sauf définition contraire, les mots ci-dessous qui commencent par une majuscule ont le sens qui leur est donné dans le document des modalités de service de Rogers.\n        <br/><br/>\nLe Service vous permet de consulter votre facture en ligne sur le site rogers.com. Vous recevrez chaque mois un courriel vous avisant que votre facture est prête et que vous pouvez la consulter en ligne.\n        <br/><br/>\nVous reconnaissez et convenez que lorsque vous adhérez au Service, les modalités suivantes s&#39;appliquent :\n<br/><br/><ol>\n<li>Vous devez fournir à Rogers les renseignements véridiques, exacts, courants et complets que nous vous demandons.</li>\n\n<li>Vous devez posséder un profil MonRogers actif, et celui-ci doit être associé à un numéro de compte.</li>\n\n    <li>Vous devez tenir à jour votre adresse électronique et d&#39;autres renseignements en tout temps afin que nous puissions vous fournir le Service. Si vous changez ou annulez votre adresse électronique ou si d&#39;autres renseignements changent et que vous omettez d&#39;actualiser cette information en ouvrant une session sur la page MonRogers du site rogers.com et en fournissant votre nouvelle adresse dans l&#39;onglet Profil de la page MonRogers, nous nous dégageons de toute obligation de vous fournir le Service.</li>\n\n    <li> Vous serez invité à choisir un mot de passe au moment de vous inscrire à MonRogers. Vous pouvez modifier votre mot de passe en tout temps en ouvrant une session sur la page MonRogers et en saisissant votre nouveau mot de passe dans le champ pertinent de l&#39;onglet Profil de la page MonRogers. Vous devez vous assurer de garder votre mot de passe et votre numéro de compte secrets, à défaut de quoi, vous serez entièrement responsable des opérations effectuées dans votre compte au moyen de votre mot de passe ou de votre compte. Si vous apprenez ou si vous soupçonnez que votre mot de passe ou votre compte est utilisé sans votre autorisation ou si vous constatez ou si vous soupçonnez toute autre infraction à la sécurité, veuillez en aviser Rogers sans tarder.</li>\n\n    <li>Si votre adresse électronique n&#39;est plus valide ou si votre boîte électronique retourne les messages, vous ne recevrez pas d&#39;avis mensuel vous informant que votre facture est prête et qu&#39;elle peut être consultée. Vous serez cependant en mesure de consulter MonRogers et d&#39;afficher votre facture.</li>\n\n    <li>Vous ne recevrez plus de facture par la poste.</li>\n\n    <li>Vous demeurerez redevable de tous les montants imputés à votre compte, et il vous incombe de nous faire parvenir tous vos paiements avant la date d&#39;échéance indiquée sur la facture électronique.</li>\n\n    <li> Vous pouvez annuler votre abonnement au Service en tout temps en ouvrant une session sur le site rogers.com et y modifiant votre mode de facturation privilégié. Des frais de <strong><span style='font-size:14px'>2$</span></strong> par mois s&#39;appliquent pour la facture papier.</li>\n\n    <li>En cas de contradiction entre la facture électronique et les dossiers de facturation de Rogers, nos dossiers Rogers prévalent.</li>\n</ol>\n        ","linked_acc_discl_title":"Modalités de service de Rogers pour la facture en ligne","linked_acc_number_invalid":"Veuillez entrer un numéro de 9 à 12 chiffres valide","linked_acc_number_required":"Champ obligatoire","linked_acc_options_1":"Compte de sans-fil ou du câble","linked_acc_options_2":"Compte <i>Parlez à la carte </i><font size='2'><sub>MC</sub></font>","linked_acc_phone_invalid":"Veuillez entrer un numéro de téléphone valide.","linked_acc_popup":"Votre numéro de compte Rogers se trouve dans le coin supérieur droit de votre facture et comprend entre 9 et 12 chiffres.","linked_acc_postalcode_invalid":"Veuillez entrer un code postal valide","linked_acc_prepaid_number":"Compte Parlez à la carte MC","linked_acc_prepaid_pin":"Un NIP de quatre chiffres est requis.","linked_acc_prepaid_pin_confirm":"fr Confirm 4-digit PIN is required","linked_acc_prepaid_pin_confirm_error":"fr 4-digit Confirm PIN is required","linked_acc_prepaid_pin_error":"Un NIP de quatre chiffres est requis.","linked_acc_prepaid_pin_error_mismatch":"fr PIN and PIN confirm do not match","linked_acc_sub_title_1":"Détails du compte","linked_acc_sub_title_2":"Préférences en matière de facture","linked_acc_success":"Votre compte a été associé à votre profil!","linked_acc_title":"Associez votre compte Rogers à votre profil MonRogers (facultatif)","linked_err_acc_num":"Veuillez entrer un numéro de compte.","linked_err_postal":"Veuillez entrer le code postal associé au numéro de compte. Vous le trouverez sur votre facture papier.","linked_chat_help":"Vous avez oublié votre numéro de compte? Communiquez avec un conseiller du Service à la clientèle en ligne au moyen de l'outil de <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>Live chat.</a> Nous retrouverons les détails de votre compte pour que vous puissiez profiter de Mon Rogers.","long_distance":"Interurbains","login_forget_pwd_email_invalid":"Désolé, vous devez entrer une adresse électronique valide.","login_forget_pwd_required":"Désolé, vous devez entrer une adresse électronique valide.","login_forget_username_desc":"Entrez votre adresse électronique et nous vous ferons parvenir le nom d’utilisateur par courriel.","login_forget_username_success":"Veuillez vérifier votre boîte de réception. Votre nom d’utilisateur MonRogers a été envoyé à l’adresse <b>{{email}}</b>.","login_forget_username_title":"Vous avez oublié votre nom d’utilisateur MonRogers?","login_invalid_answer_required":"Entrez la réponse à votre question secrète.","login_invalid_answer_sent":"La réponse à la question de sécurité que vous avez entrée ne correspond pas à nos dossiers. Veuillez entrer votre réponse de nouveau.","login_invalid_email_sent":"L’adresse électronique n’est pas enregistrée","login_invalid_email_sent_desc":"« Veuillez entrer votre adresse électronique principale. Elle peut être différente de celle qui vous sert de nom d’utilisateur. Si vous avez oublié votre adresse électronique principale, veuillez communiquer avec nous au moyen du Clavardage en <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>direct.</a> »","login_invalid_password":"Veuillez entrer un mot de passe valide","login_re_enter":"Veuillez confirmer votre mot de passe en le saisissant de nouveau.","login_reset_pwd_desc":"Veuillez entrer votre courriel <b>principal</b> pour réinitialiser votre mot de passe.","login_reset_pwd_email_desc":"Veuillez répondre à votre question de sécurité pour réinitialiser votre mot de passe.","login_reset_pwd_placeholder":"Couriel","login_userName_email_placeholder":"Nom d'utilisateur ou adresse électronique","login_reset_pwd_success":"Nous avons envoyé un courriel à l’adresse <b>{{email}}</b>. Ce courriel contient un mot de passe temporaire pour accéder à votre compte.","login_reset_pwd_success_message":"Consultez vos courriels","login_reset_pwd_title":"Réinitialisez votre mot de passe MonRogers","login_security_questions":{"1":"Quel est le nom de jeune fille de votre mère?","2":"Dans quelle ville êtes-vous né(e)?","3":"Quel est le nom de votre premier animal domestique?","4":"Quel était le nom de votre école secondaire?","5":"Quelle est votre équipe sportive préférée?","6":"Quel était le nom de votre professeur(e) favori(te)?","7":"Quel est votre passe-temps favori?","8":"Où avez-vous passé vos premières vacances?"},"login_security_questions_1":"Quel est le nom de jeune fille de votre mère?","login_security_questions_2":"Dans quelle ville êtes-vous né(e)?","login_security_questions_3":"Quel est le nom de votre premier animal domestique?","login_security_questions_4":"Quel était le nom de votre école secondaire?","login_security_questions_5":"Quelle est votre équipe sportive préférée?","login_security_questions_6":"Quel était le nom de votre professeur(e) favori(te)?","login_security_questions_7":"Quel est votre passe-temps favori?","login_security_questions_8":"Où avez-vous passé vos premières vacances?","login_reset_success":"Votre mot de passe a été réinitialisé avec succès.","maintenance_info":"Désolé, nous ne pouvons pas afficher vos renseignements. Nous tentons de régler le problème.<br/>Besoin d’aide?&nbsp;","maintenance_info_site":"Désolé, la période de maintenance quotidienne de MonRogers<sub><small><small>MC</small></small></sub> est de 2 h à 6 h. Même si la plupart des fonctions ne sont pas offertes pendant cet intervalle.","maintenance_info_wireless":"Nous sommes incapables de récupérer les renseignements sur votre service sans fil pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>clientèle</a> pour obtenir de l’aide.","maintenance_info_residential":"Nous sommes incapables de récupérer les renseignements sur votre service  pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>clientèle</a> pour obtenir de l’aide.","maintenance_info_history":"Nous sommes incapables de récupérer  votre historique des paiements pour l’instant. Veuillez réessayer plus tard.","marketingPermissionsHeading":"Autorisations liées au marketing","marketingPermissionsSubheading":"Comment souhaitez-vous que nous communiquions avec vous?","myaccoverview":"Survol du compte","myrogersoverview":"MonRogers vue d'ensemble","myaccoverview_days_left":"fr days left for this months bill","myaccoverview_get_monotoring":"Système de domotique","myaccoverview_home_monotoring":"Système de domotique","myaccoverview_get_phone":"Téléphonie résidentielle","myaccoverview_get_wireless":"Service Sans-fil","myaccoverview_get_internet":"Service Internet","myaccoverview_get_tv":"Télévision","myaccoverview_get_rogers_bank":"Carte de crédit Rogers","myaccoverview_get_nhl":"GameCentre LIVE<sub>MC</sub> de la LNH par Rogers<sub>MC</sub>","myaccoverview_get_ignite_bundle":"Obtenez la Télé Élan","ACTUAL_TEXT_myaccoverview_get_ignite":"Offre groupée Télé et Internet Élan","myaccoverview_account_preferences":"Préférences du compte","myaccoverview_change_contact_information":"Modifier les coordonnées","myaccoverview_switch_to_online_bill":"Passer à la Facture en ligne","myaccoverview_change_password":"Changer le mot de passe","myaccoverview_change_method_of_payment":"Changer le mode de paiement","myaccoverview_reset_wireless_voicemail_password":"Changer Le mot de passe de la messagerie vocale","my_wireless_right_now":"My Wireless Right Now (fr)","my_internet":"Mon Internet","mu_your_username_willbe":"Votre nom d’utilisateur sera dorénavant votre adresse électronique.","mu_please_confirm":"Veuillez confirmer l’adresse électronique que vous voulez utiliser.","mu_please_contact":"Veuillez communiquer avec un conseiller qui vous aidera à changer votre nom d’utilisateur.","mu_sorry_email_registered_1":"Nous sommes d&eacute;sol&eacute;s. L&rsquo;adresse courriel n&rsquo;est pas disponible.","mu_sorry_email_registered_2":"Malheureusement, l&rsquo;adresse {{email}} est d&eacute;j&agrave; associ&eacute;e &agrave; un autre profil. Pour avoir de l&rsquo;aide afin de changer votre nom d&rsquo;utilisateur, veuillez communiquer avec nous.","mu_please_confirm_email":"Veuillez confirmer votre adresse électronique.","mu_email_required":"Une adresse électronique est requise.","mu_email_not_valid":"L’adresse électronique que vous avez entrée n’est pas valide.","mu_email_not_match":"Les adresses électroniques ne sont pas identiques.","mu_msg_success":"<div>Votre nom d&rsquo;utilisateur a &eacute;t&eacute; modifi&eacute;.</div><div class='message-error-normal'>N&rsquo;oubliez pas d&rsquo;entrer votre adresse &eacute;lectronique chaque fois que vous ouvrez une session avec vos identifiants MonRogers<sup>MC</sup>.</div><div class='message-error-normal mbs row'>Maintenant que vous avez modifi&eacute; votre nom d'utilisateur, vous pouvez acc&eacute;der facilement &agrave; des services &agrave; valeur ajout&eacute;e tels que:<br/><div class='message-error-normal col-xs-12 col-sm-6 col-md-6 col-lg-6'><ul><li>shomi<sup>MC</sup></li><li>GameCentre Live<sub>MC</sub> de la LNH par</li></li></ul></div><div class='message-error-normal col-xs-12 col-sm-6 col-md-6 col-lg-6'><ul><li>Application MonRogers</li><li>Syst&egrave;me de domotique Rogers</li><li>Forums communautaires</li></ul></div></div>","mu_msg_success_2":"Un courriel a été envoyé à l’adresse électronique servant de nom d’utilisateur.","mu_username_canbe_updated":"Votre nom d’utilisateur peut être modifié en tout temps.","mu_help_chat":"<a href='https://www.rogershelp.com/customerserv/cuscare_ECare_fr_landing.php?hm=n&s=74' target='_blank' style='color:red;'>Clavardage en direct</a>","mu_help_chat_black":"<a href='https://www.rogershelp.com/customerserv/livechatsupport/index.php?source=61' target='_blank' style='color:black;'>Clavardage en direct</a>","mu_registration_lg":"Pourquoi utiliser MonRogers?","mu_registration_line":"Créez votre profil rapidement et facilement! De plus...","mu_registration_list_1":"Vérifiez votre solde en tout temps","mu_registration_list_2":"Réglez vos factures en ligne","mu_registration_list_3":"Surveillez votre utilisation où que vous soyez","mu_registration_sm":"S’inscrire maintenant","mu_patience":"Ce changement pourrait prendre quelques minutes. Merci de votre patience!","OldPassword":"Ancien mot de passe","AMEX":"American Express","MASTER":"Mastercard","VISA":"VISA","AMEX_img":"ute-common-assets/assets/cards/amex.png","MASTER_img":"ute-common-assets/assets/cards/master.png","VISA_img":"ute-common-assets/assets/cards/visa-icon-1217.png","paynow_title":"Effectuer un paiement dès maintenant","paynow_payment_amount":"Montant du paiement","paynow_payment_step1":"Étape 1 : Entrez le montant du paiement","paynow_never_miss_1":"Ne faites plus jamais de paiement en retard!","paynow_never_miss_2":"<a ui-sref='changeMethod' href='#/changemethod'>Inscrivez-vous aux paiements préautorisés et</a> ne craignez plus de rater un paiement.","paynow_method":"Sélectionner un mode de paiement","paynow_method_step2":"Étape 2 : Sélectionnez le mode de paiement","paynow_method_interac":"Si vous sélectionnez le paiement Interac, vous serez redirigé vers une page de paiement sécurisée.","paynow_interac":"Interac","paynow_interac_2":"Veuillez prendre note que vous serez redirigé vers Interac.ca","paynow_cc":"Carte de cr&eacute;dit/Visa D&eacute;bit","paynow_need_help":"Besoin d’aide pour comprendre les options de paiement?","paynow_faq":"Voir la foire aux questions sur le paiement","paynow_chat":"<a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>Clavardez</a> en ligne avec un conseiller","paynow_payment_method2":"Mode de paiement ","paynow_invoice":"Facturation mensuelle","paynow_change":"Modifier","paynow_history":"Historique","paynow_edit":"Modifier","paynow_$":"$","paynow_$2":"$","paynow_payment_method_cc":"Prélèvement automatique par carte de crédit","paynow_method_check":"Prélèvements automatiques par débit","paynow_method_unavailable":"Indisponible","paynow_cc_payment":"Paiement sécurisé","paynow_cc_secure":"Ceci est une transaction crypté et sécurisée","paynow_cc_number":"Numéro de carte de crédit","paynow_bank_account_number":"Banque - Numéro de compte","paynow_expiry_date":"Date d'expiration","paynow_code":"Code de vérification","paynow_name_on_card":"Nom sur la carte","paynow_processing":"Paiement en cours","paynow_general_error":"Désolé, certains renseignements sont manquants ou erronés. Avant de continuer, veuillez examiner les champs en surbrillance.","paynow_paybill":"Payer maintenant","paynow_code_error":"Désolé, ce code de sécurité n'est pas valide. Veuillez réessayer.","paynow_code_required":"Désolé, ce code de sécurité n'est pas valide. Veuillez réessayer.","paynow_card_error":"Désolé, ce numéro de carte n'est pas valide. Veuillez réessayer.","cyberSource_Down_error":"Désolé, une erreur s’est produite et votre paiement n’a pas été accepté.Veuillez réessayer en utilisant un autre mode de paiement.","paynow_card_required":"Désolé, ce numéro de carte n'est pas valide. Veuillez réessayer.","paynow_month_required":"Se il vous plaît sélectionner un mois","paynow_year_required":"Se il vous plaît sélectionner une année","paynow_date_required":"Désolé, cette date d'expiration n'est pas valide. Veuillez réessayer.","paynow_card_tooltip":"Le code de vérification de carte se trouve à l'arrière des cartes Visa et Mastercard et comporte trois chiffres. Pour les cartes American Express, le code se trouve à l'avant et comporte quatre chiffres.","paynow_review_details":"Revoir le paiement","paynow_payment_required":"Désolé, ce montant du paiement n'est pas valide. Veuillez réessayer.","paynow_review_amount":"Montant du paiement","paynow_review_method":"Mode de paiement","paynow_review_date":"Date du paiement","paynow_sorry":"Désolé, une erreur s’est produite et votre paiement n’a pas été accepté. Veuillez réessayer en utilisant un mode de paiement différent.","paynow_sorry_i1":"Désolé, une erreur s’est produite et votre paiement n’a pas été accepté.","paynow_sorry_i2":"Veuillez réessayer en utilisant un mode de paiement différent.","paynow_select_another":"Choisir un autre mode de paiement","paynow_cancel_desc":"Si vous annulez ce paiement, une autre page s’affichera et aucun changement ne sera enregistré. Êtes-vous certain de vouloir annuler ce paiement?","paynow_continue":"Continuer le paiement","paynow_cancel":"Annuler le paiement","paynow_thanks":"<b>Merci!</b><br/> Votre paiement a été reçu. Nous vous avons aussi envoyé un courriel de confirmation.","paynow_thanks_i":" Votre paiement a été reçu. Nous vous avons aussi envoyé un courriel de confirmation.","paynow_larger":"Le montant du paiement est supérieur au montant à payer.","paynow_tooLarge":"Désolé, le montant que vous avez entré est supérieur au montant exigible. Veuillez entrer un nouveau montant.","paynow_expiry_notvalid":"Désolé, cette date d'expiration n'est pas valide. Veuillez réessayer.","paynow_due_credit":"Porté à votre carte de crédit le ou après le :","paynow_due_debit":"Retiré de votre compte le ou après le :","paynow_change_bill_type":"Modifier le mode de paiement","paynow_acc_balance_today":"Solde du compte: ","paynow_overdue":"Comprend le solde en souffrance","paynow_acc_balance_why_different":"why is my account balance different from my bill?","paynow_go_to_overview":"Survol Du Compte","paynow_preauth_payment_option":"En cochant cette case, vous acceptez d’utiliser cette carte pour tous les futurs paiements préautorisés.<br/>Lorsque vous aurez confirmé, nous porterons automatiquement les frais à votre carte en fonction de votre cycle de facturation.","paynow_success_1":"Nous avons reçu votre paiement de <b>{{amount}}</b> et nous vous avons envoyé un courriel de confirmation.","paynow_success_2":"Nous avons reçu votre paiement de <b>{{amount}}</b> et nous vous avons envoyé un courriel de confirmation.<br/><br/>Nous avons aussi changé votre mode de paiement pour passer au paiement préautorisé par <b>carte de crédit</b>.","paynow_failure_1":"Désolé, nous ne pouvons pas traiter votre paiement pour le moment. Veuillez composer le 1‑877‑559‑5202 pour obtenir de l’aide.","paynow_failure_2":"Nous avons reçu votre paiement de <b>{{amount}}</b> et nous vous avons envoyé un courriel de confirmation. Malheureusement, nous ne sommes pas en mesure de changer votre mode de paiement pour le moment. Réessayez plus tard.","paynow_thankyou_title":"Merci!","paynow_tryagain_title":" Réessayer","ReminderQuestion":"Question de rappel du mot de passe :","ReminderAnswer":"Réponse à la question de rappel :","ServiceAddressHeading":"Adresse de service","history_empty":"Désolé, vous n’avez pas d’historique de paiement.","history_sort_by":"Trier par","history_payment_date":"Date","history_payment_amount":"Montant","history_payment_method":"Transaction","history_payment_reference":"Nº de référence","history_payment_details":"Détails","history_sgi_account_disclaimer":"Votre paiement figurera dans votre historique des paiements dans <span>un délai d’un jour ouvrable.</span>","history_payment_status_desc":"<strong>Réussi</strong><p>Votre paiement a bien été effectué.</p><strong>Échec</strong><p>Paiement non traité. Aucuns frais portés à votre carte/compte.</p><strong>Montant crédité</strong><p>Ce montant a été crédité à votre compte.</p><strong>Montant transféré par vous</strong><p>Vous avez transféré ce montant à un autre compte.</p><strong>Montant transféré à vous</strong><p>Vous avez reçu ce montant d’un autre compte.</p>","change_method":"Mode de paiement","change_method_know":"Le saviez-vous?","change_method_intro":"Optez pour les paiements préautorisés et ayez l’esprit en paix en sachant que votre facture Rogers sera réglée automatiquement chaque mois à partir de votre compte bancaire canadien ou de votre carte de crédit.","change_method_note":"Veuillez prendre note que le changement de mode de paiement entrera en vigueur dans un délai de <b>deux jours</b> ouvrables.","change_method_update":"Mettre à jour le mode de paiement","change_method_invoice":"Mettre à jour le mode de paiement : Facturation mensuelle","change_method_invoice_info":"Veuillez communiquer avec un conseiller du Service à la clientèle qui vous aidera à mettre à jour le mode de paiement.","change_method_confirm":"Confirmer la mise à jour du mode de paiement","change_method_warning":"Une facture mensuelle signifie une chose de plus à se rappeler chaque mois. Êtes-vous sûr de ne pas vouloir avoir l’esprit en paix en sachant que votre facture Rogers sera réglée automatiquement chaque mois à partir de votre compte bancaire canadien ou de votre carte de crédit?","invoice":"Facturation mensuelle","change_method_debit":"Prélèvements automatiques par débit","change_method_credit":"Prélèvement automatique par carte de crédit","change_method_unavailable":"Indisponible","change_method_ways":"Autres façons de régler votre facture","online":"En ligne","change_method_stores":"Certains magasins Rogers","change_method_app":"Appli MonRogers","change_method_banks":"La plupart des banques","change_method_mail":"En postant un chèque à : <p style='margin-left:45px;margin-top:10px;'>Rogers <br/>Case Postale 9100 <br/>Don Mills, ON <br/>M3C 3P9</p>","change_method_secure":"Paiement sécurisé","change_method_info_secure_credit":"Les renseignements de votre carte de crédit sont sauvegardés, encryptés et en sécurité","change_method_terms_credit":"Modalités de paiement par carte de crédit","ContactInformationHeading":"Coordonnées","tbd":"TBD","change_method_secure_debit":"Paiement sécurisé","change_method_cheque_header":"Renseignements li&eacute;s au compte","change_method_info_secure_debit":"Vos renseignements bancaires sont sauvegardés, encryptés et en sécurité","change_method_info_transit_code":"Numéro de transit","change_method_info_bank_code":"Code bancaire","change_method_account_number":"Numéro de compte","change_method_terms_debit":"Modalités de paiement par prélèvement automatique","change_method_see_tctab":"See T&Cs Debit Tab","change_method_confirm_title":"Confirmer la mise à jour du mode de paiement","change_method_confirm_details":"Une facture mensuelle signifie une chose de plus à se rappeler chaque mois. Êtes-vous sûr de ne pas vouloir avoir l’esprit en paix en sachant que votre facture Rogers sera réglée automatiquement chaque mois à partir de votre compte bancaire canadien ou de votre carte de crédit? Annuler Continuer","change_method_thankyou_title":"Merci!","change_method_thankyou_details":"L'option de paiement préautorisé a été associée à votre compte! Votre premier prélèvement préautorisé figurera sur votre prochaine facture. Nous vous avons aussi envoyé un courriel de confirmation.","change_method_error":"Désolé, une erreur s’est produite et votre changement n’a pas été accepté. Veuillez réessayer en utilisant un mode de paiement différent.","change_method_deb_error":"Désolé, le numéro de transit ou le numéro d'institution bancaire n'est pas valide. Veuillez réessayer.","change_method_invalid_bank_code":"Désolé, ce numéro d'institution bancaire n'est pas valide. Veuillez réessayer.","change_method_invalid_transit_code":"Désolé, ce numéro de transit n'est pas valide. Veuillez réessayer.","change_method_invalid_account":"Désolé, ce numéro de compte n'est pas valide. Veuillez réessayer.","change_method_invalid_accountType":"Désolé, ce type de compte n'est pas valide. Veuillez réessayer.","change_method_accept":"J'accepte les modalités","change_method_not_accepted":"Veuillez accepter les modalités avant de continuer.","change_method_terms":"<div class='mop-tandc-legal-text-container'><p class='center'><h6 class='txtM inline'>Modalités de paiement par prélèvement automatique</h6></p><p>La présente autorise toute entreprise faisant partie du groupe de sociétés Rogers ('Rogers') à débiter mon/notre compte indiqué ci-dessus des frais périodiques pour les produits et (ou) services de Rogers, y compris tous les services offerts par Rogers Sans-fil S.E.N.C. et tous les services offerts par Communications Rogers Câble inc. (incluant les services Internet et Téléphonie résidentielle de Rogers).</p><p>Je reconnais/nous reconnaissons que la présente autorisation sera utilisée par Rogers et mon/notre institution financière et est fournie dans la mesure où mon/notre institution financière accepte de traiter les prélèvements automatiques sur mon/notre compte conformément aux règles de l'Association canadienne des paiements. Jereconnais/nous reconnaissons que la présente autorisation fournie à Rogers constitue la livraison de ma/notre part à mon/notre institution financière.</p><p>L'information donnée sur ce formulaire sera fournie aux banques de Rogers afin de mettre en œuvre la présente autorisation. Toutes les personnes dont la signature est requise pour le compte de l'institution financière mentionnée ci-dessus ont signé la présente autorisation. J'aviserai/nous aviserons par écrit Rogers sans délai de tout changement apporté aux données de mon/notre compte.</p><p>La présente autorisation peut être annulée en tout temps sur avis donné à Rogers 30 jours avant le prochain prélèvement automatique.</p><p>Pour obtenir un exemple de formulaire d'annulation ou me/nous renseigner sur mon/notre droit d'annuler une entente de paiement par prélèvement automatique, je peux/nous pouvons communiquer avec mon/notre institution financière ou consulter www.cdnpay.ca    <br/>L'annulation de la présente entente ne s'applique qu'au mode de paiement et n'a aucune incidence sur le contrat applicable aux produits ou services de Rogers.    <br/>Rogers ne peut pas céder la présente entente sans me/nous donner un préavis d'au moins 10 jours.</p><p>J'accepte/nous acceptons ce qui suit :</p><p>Le montant de chaque paiement dont mon/notre compte sera prélevé en fonction des frais portés à ce dernier pour la période de facturation précédente figurera sur la facture que je reçois/nous recevons de Rogers avant ce prélèvement.</p>    <br/>J'accepte/nous acceptons que Rogers réduise le préavis standard pour chaque prélèvement automatique.    <br/>Mon/notre compte sera débité chaque mois, à moins d'indication contraire dans mon/notre entente de service.</p><p>Mon/notre institution financière n'aura pas l'obligation de s'assurer que tous les prélèvements automatiques par Rogers sont conformes à la présente autorisation ou à toute autre entente avec Rogers. Mon/notre institution financière pourra me/nous rembourser les montants dont sera débité mon/notre compte dans les cas suivants :</p><p>(i) si le retrait n'est pas conforme à la présente autorisation,<br/>(ii) si j'annule/nous annulons la présente autorisation. Pour être remboursé, je dois/nous devons remplir un formulaire de déclaration dans les 90 jours civils suivant la date d'inscription du prélèvement à mon/notre compte; tout litige après cette date devra être résolu directement avec Rogers.<br/>J'ai/nous avons certains recours si un prélèvement automatique n'est pas conforme à la présente entente. J'ai/nous avons notamment le droit d'obtenir un remboursement pour tout prélèvement qui n'est pas autorisé ou qui n'est pas conforme à la présente entente. Pour obtenir plus d'information sur les recours dont je dispose/nous disposons, je peux/nous pouvons communiquer avec mon/notre institution financière ou consulter www.cdnpay.ca</p><p>Je reconnais/nous reconnaissons avoir lu et compris les modalités de la présente entente de paiement par prélèvement automatique.</p></div>","_confirm_new_password":"Confirmer le nouveau mot de passe","profile":"profil","ovProfile":"profil MonRogers","SecretQuestion":"Question de rappel du mot de passe","internet_my_usage":"Mon utilisation","internet_usage":"Utilisation","internet_my_usage_48":"Vous pourriez ne pas pouvoir accéder aux dètails de votre utilisation des dernières <span class='semi-bold'>48 heures</span>","internet_new_usage":"Le nouveau cycle d’utilisation commence dans : <strong>{{days}} jours</strong>.","internet_total_usage":"Utilisation totale","internet_unlimited":"Illimitée","internet_remaining":"restant","internet_remaining_plural":"restantes","internet_plan_limit":"sur {{totalLimit}}, la limite du forfait","internet_overage_new":"Utilisation excédentaire :{{totalOverage}} Go ","internet_overage_plan_limit":"limite de {{totalLimit}} du forfait","internet_extra":"Utilisation additionnelle","internet_daily_usage":"Utilisation quotidienne","internet_monthly_usage":"Utilisation mensuelle","internet_view_history":"Consulter l’historique d’utilisation","internet_usage_alerts":"Consulter les alertes d’utilisation","internet_my_internet_package":"Mon forfait Internet","internet_internet_package":"Forfait Internet","internet_my_plan":"Mon forfait","internet_includes":"Comprend :","internet_speed":"Vitesse de téléchargement :","internet_speed_up":"Vitesse de téléversement :","internet_manage_package":"Changer mon forfait","internet_my_extras":"Mes extras","internet_extras":"Extras","internet_est_monthly_total":"Le total mensuel estimé ne comprend ni rabais ni crédits.","internet_per_month":"par mois","internet_change":"Changer de forfait","internet_remove":"Retirer","internet_add_extras":"Ajouter des extras","internet_my_modem":"Mon modem","internet_modem":"Modem","internet_change_modem":"Changer le modem","internet_change_my_modem":"Changer le modem","change_wifi_password":"Modifier le mot de passe du réseau Wi-Fi","internet_yahoo_email":"Configurer le service de courriel Rogers Yahoo!","internet_yahoo_email_check":"Consulter mes courriels Rogers Yahoo!","internet_promo_did_you_know":"Did you know?","internet_promo":" La technologie <strong> Vitesse survoltée </strong><sub>MC</sub> est offerte sans frais supplémentaires avec votre service Internet haute vitesse.","internet_promo_more":"Détails","internet_almost_out":"Bientôt à la limite","internet_used":"Utilisées","internet_MB":"Mo","internet_GB":"Go","internet_Mbps":"Mbps","internet_downloaded":"téléchargé","internet_uploaded":"téléversé","internet_overage":"Overage","internet_addcost":"Additional Cost","internet_charged_at":"Charged at","internet_missing_usage":"Renseignements sur l'utilisation non disponibles","mother_maiden_name":"Quel est le nom de jeune fille de votre mère?","used_cycle_not_available":"New usage cycle starts in: Not available (FR)","register_now":"Activez","registration_title":"Inscription à MonRogers","registration_tooltip":"Votre mot de passe doit contenir de 7 à 16 caractères comprenant des lettres et des chiffres uniquement (pas de caractères spéciaux).","registration_wrong_password":"Votre mot de passe ne peut contenir que des chiffres et des lettres, et non des caractères spéciaux. Veuillez réessayer.","registration_password_must_differ":"Il faut que le nouveau mot de passe soit différent de l'ancien.","registration_password_incorrect":"Ancien mot de passe est incorrect.","registration_too_short":"Veuillez entrer un mot de passe valide","registration_too_long":"Veuillez entrer un mot de passe valide","registration_alphabet_only":"Veuillez entrer un mot de passe valide","registration_number_only":"Veuillez entrer un mot de passe valide","registration_language":"Langue de préférence","revo_included":"CE QUE VOUS AVEZ","revo_included_ph3":"Autres services","revo_value_add":"Ce Que Vous Pouvez Obtenir","revo_with_internet":"avec votre forfait Internet","revo_with_wireless":"avec votre forfait sans-fil","revo_with_cable":"avec votre forfait câble","revo_change_selection":"Modifier votre choix","revo_details":"Détails","revo_get_this":"CHOISIR","revo_free_with_your_plan":"Et profitez-en pendant deux ans avec votre forfait <i>Partagez tout +<sub>MC</sub></i>","revo_free":"GRATUIT","revo_by":"D’ici le","revo_manage":"Gérer","revo_listen":"écouter","revo_modal_content":"Taxes en sus. Les frais sont imput&eacute;s &agrave; l&rsquo;utilisation et peuvent &ecirc;tre modifi&eacute;s en tout temps sans pr&eacute;avis. Ce service est factur&eacute; par ligne et les frais s&rsquo;appliquent pendant 24 heures d&egrave;s votre premi&egrave;re utilisation dans une destination admissible. Des frais d&rsquo;itin&eacute;rance s&rsquo;appliquent lorsque vous &ecirc;tes &agrave; l&rsquo;ext&eacute;rieur des destinations admissibles. Donn&eacute;es : L&rsquo;utilisation de donn&eacute;es sup&eacute;rieure au volume de donn&eacute;es compris dans votre forfait est factur&eacute;e par tranches et arrondie au Mo ou au Go suivant (selon votre forfait). Messages texte : Comprend les messages texte envoy&eacute;s &agrave; un num&eacute;ro de sans-fil local dans une destination admissible ou &agrave; un num&eacute;ro de sans-fil au Canada. Les messages texte entrants et sortants &agrave; tarification additionnelle et les messages envoy&eacute;s &agrave; l'&eacute;tranger, except&eacute; dans les destinations admissibles, sont factur&eacute;s aux tarifs en vigueur. Appels : Comprend un nombre illimit&eacute; d'appels &agrave; des num&eacute;ros locaux ou &agrave; des num&eacute;ros au Canada lorsque vous &ecirc;tes dans une destination admissible. Des tarifs interurbains internationaux s'appliquent aux appels effectu&eacute;s vers d&rsquo;autres destinations. Consultez <a href='http://rogers.com/modalites' target='_blank'>rogers.com/modalites</a>.","rogers_credit_card":"Carte de Cr&eacute;dit","sign_email":"Adresse électronique","sign_forget_details":"Vous avez oublié vos détails d’ouverture de session? Réinitialisez votre mot de passe ou recevez votre nom d’utilisateur par l’intermédiaire de MonRogers.","sign_intro":"G&eacute;rez vos services, consultez vos factures en ligne et faites bien d&rsquo;autres t&acirc;ches dans un environnement s&eacute;curis&eacute;.","sign_in_to_myrogers":"Ouvrir une session MonRogers","sign_maximum_attempts":"Désolé, vous avez atteint le nombre maximal de tentatives d’ouverture de session. Votre compte sera verrouillé pendant 24 heures. Pour déverrouiller votre compte, veuillez réinitialiser votre mot de passe ou communiquer avec un conseiller du Service à la clientèle au moyen du <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?source=73' target='_blank'>Clavardage en direct</a>.","sign_new":"C’est nouveau pour vous","sign_third_attempts":"<b>Ceci est votre dernier essai. Votre compte sera ensuite verrouillé.</b></p><p>Désolé, le nom d’utilisateur et le mot de passe entrés ci-dessous ne correspondent pas à nos dossiers.</p><p>Êtes-vous certain de ne pas avoir besoin d’aide?","sign_warning_msg_line_1":"<b>D&eacute;sol&eacute;, le nom d&rsquo;utilisateur ou le mot de passe que vous avez entr&eacute;s ne correspondent pas &agrave; nos dossiers.</b>","sign_warning_msg_line_2":"Veuillez essayer de nouveau.","sign_wrong_username":"Désolé, le nom d’utilisateur ou le mot de passe que vous avez entré n’est pas reconnu. Veuillez essayer de nouveau.","sign_warning_msg_line_3":"<b>Besoin d’aide?</b> ","sign_third_attempts_msg_line_1":"<b>Ceci est votre dernier essai. Votre compte sera ensuite verrouillé.</b>","sign_third_attempts_msg_line_2":"Désolé, le nom d’utilisateur et le mot de passe entrés ci-dessous ne correspondent pas à nos dossiers.","sign_third_attempts_msg_line_3":"<b>Êtes-vous certain de ne pas avoir besoin d’aide?</b>","sign_maximum_attempts_line_1":"<b>Ce compte sera verrouillé pendant 24 heures.</b>","sign_maximum_attempts_line_2":"Désolé, ce compte a été verrouillé aux fins de sécurité.","sign_maximum_attempts_line_3":"<b>Vous devez y accéder maintenant? Communiquez avec l’un de nos conseillers.</b>","shm_title":"Système de domotique","shmdashboard":"SYSTÈME DE DOMOTIQUE ROGERS","shm_my_monitoring":"Mon système de domotique","shm_access_web":"Centre de contrôle d'accès web","shm_quick_start_guide":"Guide de démarrage rapide","shm_municipal_permits":"Information au sujet des permis municipaux","shm_service_agreement":"Entente de service","shm_promo_title":"Le saviez-vous?","shm_promo":"Contrôlez votre maison où que vous soyez!","shm_insur_cert":"Certificat d'assurance","shm_insur_cert_alt":"Obtenir le certificat d'assurance","shm_shop_accessories":"Chercher des accessoires","shm_get_started":"Vous êtes un nouveau client du Système de domotique Rogers? Voici quoi faire pour commencer.","shm_learn_more":"En savoir plus sur le Système de domotique Rogers","shm_access_web_alt":"Centre de contrôle d'accès web","shm_shop_accessories_alt":"Cherchez des accessoires pour votre Système de domotique Rogers.","shm_get_started_alt":"Partez du bon pied grâce à des renseignements et à des conseils au sujet de votre Système de domotique Rogers.","shm_learn_more_alt":"Apprenez-en davantage sur le Système de domotique Rogers.","tv_tv":"TÉLÉVISION","tv_my_tv":"Ma télévision, maintenant.","tv_new_release":"NOUVELLE VERSION","tv_rent_this":"Louer!","tv_whatson":"EN COURS DE DIFFUSION","tv_record_this":"Enregistrez!","tv_watch_tv":"Regarder la télévision en ligne","tv_watch_tv_get_app":"Télécharger app","tv_browse":"Parcourir le contenu de Rogers sur demande","tv_program_guide":"Voir le Guide de programmation","tv_manage_reocordings":"Gérer mes enregistrements","tv_my_package":"Mon forfait télévision","tv_package":"Forfait télévision","tv_channels":"Chaînes comprises ","tv_channels_extra":"<b>Chaînes additionnelles</b>","view_my_channels":"Liste de chaînes","view_my_channels_text":"Parcourir les chaînes incluses dans mon forfait.","tv_theme_packs":"Forfaits à thème","tv_package_change":"Changer mon forfait","tv_add_channels":"Ajouter des chaînes","tv_change_bonus_channel":"Changer en prime chaînes","tv_add_channels_message_01":"Aimeriez-vous ajouter des chaînes ou des forfaits à thème à votre forfait Télé?","tv_add_channels_message_02":"Communiquez avec nous par téléphone ou clavardage en direct dès maintenant:","tv_add_channels_supportPhoneNumber":"1 855 381 7834","boldchat_cbid_existing_customers":"2862732143579233339","tv_french_supportPhoneNumber":"1-888-ROGERS1 (764-3771)","boldchat_cbid_tv_french":"2156078613061013110","tv_add_themes":"Ajouter des forfaits à thème","tv_my_box":"Mes terminaux numériques","tv_box":"Terminaux numériques","tv_renatls":"Loués/achetés","tv_add_box":"Vous voulez ajouter un terminal numérique? Communiquer avec un magasin près de chez vous pour effectuer un achat.","tv_find_store":"Trouver un magasin","tv_promo":"Permet d’enregistrer jusqu’à huit émissions HD à la fois.","tv_move_service":"Déménagez mes services","tv_view_appointments":"Voir les rendez-vous","tv_reset_digital_box":"Réinitialiser le terminal numérique","tv_reset_pin":"Réinitialiser le NIP du terminal numérique","tv_manage_recordings":"Vous avez besoin de gérer vos enregistrements ou de consulter le guide de vos chaînes?","tv_no_links_right_now":"Les liens vous permettant de le faire ne sont pas accessibles pour le moment, mais vous pouvez utiliser l’application <b>Télétransportée Rogers<sub>MC</sub></b> Édition familiale – elle est gratuite!","tv_rogers_anyplace":"Télétransportée Rogers<sub>MC</sub>","tv_manage_PVR":"Sports, émissions télé et films en continu, partout au Canada.","tv_sign_in_rogers_anyplace":"S’inscrire à Télétransportée","tv_sign_in_rogers_anyplace_alt":"Visiter Télétransportée pour s'inscrire","tv_watch_live_sports_mobile":"Regardez la télé où que vous soyez.","tv_watch_live_sports_desk":"Retrouvez vos émissions préférées avec Rogers sur demande où que vous soyez.","tv_browse_on_demand":"Voir les émissions sur demande","tv_play_store":"Disponible sur Google Play","tv_app_store":"Télécharger dans l’App Store","tv_watch_phone_tablet_desk":"Gérez votre EVP avec l’application <b>Télétransportée<sub>MC</sub></b> Édition familiale sur vos appareils.","tv_watch_phone_tablet":"Accédez à nos services de télévision à partir de votre sans-fil ou de votre tablette au moyen de l'application <b>Télétransportée Rogers<sub>MC</sub></b> Édition familiale – c'est gratuit!","tv_watch_TV_online":"Regardez la télévision en ligne à RogersAnyplaceTV.com","tv_watch_now_button":"Regarder maintenant","tv_channels_include":"Les chaînes comprennent:","rgcl_watch":"REGARDER","10000_sign_in":"We’re unable to sign you in at the moment. Please try again later.","10000_register":"You are registered successfully. Please go to sign in.","12000-A":"{FR} Loyalty - Active","12000-B":"{FR} Loyalty - Blocked (in ELMS)","12000-D":"{FR} Loyalty - Deactivated","12000-F":"{FR} Loyalty - Fraud Closed","12000-M":"{FR} Loyalty - Pending migration","12000-N":"{FR} Loyalty - Not-Enrolled","12000-P":"{FR} Loyalty - Pending deactivation","12000-S":"{FR} Loyalty - Suspended","_password_requirements_label":"Instructions pour créer votre mot de passe","_password_requirements_text":"Votre mot de passe doit être composé de 7 à 16 caractères et contenir des lettres et des chiffres.","_require_username_password":"Désolé, le nom d’utilisateur ou le mot de passe que vous avez entré n’est pas reconnu. Veuillez essayer de nouveau.","temp_password_enter_new_password":"Veuillez saisir un nouveau mot de passe","temp_password_enter_new_password_description":"Veuillez saisir un nouveau mot de passe pour votre compte MonRogers.","temp_password_temp_pass_field":"Mot de passe temporaire","temp_password_temp_pass_field_tooltip":"Voici le mot de passe temporaire que nous vous avons envoyé par courriel.","temp_password_dew_pass_field":"Nouveau mot de passe","temp_password_confirm_dew_pass_field":"Confirmer le nouveau mot de passe","temp_password_invalid_temp_password":"D&eacute;sol&eacute;, le mot de passe temporaire que vous avez saisi n&rsquo;est pas reconnu. Veuillez le v&eacute;rifier et essayer de nouveau.","temp_password_guildeline":"Instructions pour créer votre mot de passe","temp_password_list_of_guildeline":"<br>Votre mot de passe doit être composé de 7 à 16 caractères et contenir des lettres et des chiffres.","service_wireless":"Sans-fil","service_wireless_prepaid":"<i>PARLEZ <br/>À LA CARTE<sub>MC</sub></i>","service_internet":"Internet","service_tv":"Télévision","service_phone":"Téléphonie<br/> résidentielle","service_monitoring":"Système<br/> de domotique","history":"Historique des paiements","_page":"Page","watch_this":"Suivre cette!","wireless":"Service sans-fil","wireless_number":"Num&eacute;ro sans-fil","wireless_plan":"Forfait sans-fil","wirelessPrepaid":"Gérer mon forfait et mes options","wirelessPrepaidHeader":"Service Prépayé","wireless_quick-links":"Liens rapides","wireless_add-travel-pack":"Ajouter une trousse Voyage","wireless_upgrade-my-device":"Changer d’appareil","wireless_my-wireless-usage":"Mon utilisation des services sans-fil","wireless_new-usage-cycle":"Fin du cycle de facturation en : <strong>{{nextbilldaysuntil}} jours</strong>","wireless_view":"Consulter","wireless_close":"Fermer","wireless_remaining":"restant(s)","wireless_remaining_plural":"restant(s)","wireless_remaining_plural_talk":"restante(s)","wireless_unlimited":"Appels illimités","text_remaining":"restants","text_unlimited":"Textos illimités","wireless_local_calling":"Appels <br/> locaux","wireless_canada_wide_calling":"Appels <br/> partout au Canada","wireless_updated_12_hours":"Mis à jour il y a 12 heures","wireless_delayed_12_hours":"(Retard de 12 heures)","wireless_up_to_4_hours":"Mis à jour il y a 4 heures","wireless_delayed_4_hours":"(Retard de 4 heures)","wireless_uadd_new_addons":"Gérer mes options","wireless_uadd_travel_pack":"Ajouter une trousse Voyage","wireless_texts":"textos","wireless_been-travelling":"Vous avez fait un voyage","wireless_looking-good":"Limite respectée","wireless_check-it-out":"Attention à l’utilisation","wireless_ok":"OK","wireless_overage":"Utilisation excédentaire","wireless_infinite_reduced_speed":"Des données à vitesse réduite","wireless_almost-out":"Bientôt à la limite","wireless_extra-usage":"Utilisation additionnelle","wireless_data":"Données","wireless_unlimited_data":"Données illimitées","wireless_talk":"Appels","wireless_talk_weekday-minutes":"Minutes de jour","wireless_talk_unlimited-ww-minutes":"Soirs et week-ends illimités","wireless_talk_my5-my10":"MON TOP 5 et MON TOP 10","wireless_talk_rogers2rogers":"Rogers à Rogers","wireless_talk_unlimited-network-calling":"Appels illimités sur le réseau","wireless_talk_between-family-calling":"Appels illimités entre les membres de la famille","wireless_talk_call-forwarding":"Renvoi d’appel","wireless_talk_incoming-calls":"Appels entrants","wireless_talk_zone-calling":"Appels à l'intérieur de la zone","wireless_talk_long-canada":"Interurbains au Canada","wireless_talk_long-us":"Interurbains aux États-Unis","wireless_talk_long-international":"Interurbains internationaux","wireless_text":"Messagerie ","wireless_features":"Caractéristiques","wireless_details":"DÉTAILS","wireless_extras":"Extras","wireless_included":"Inclus","wireless_features_and_add_ons":"Caractéristiques et options","wireless_text_2":"texte","wireless_text_sent":"Messages textes envoyés","wireless_text_received":"Messages texte reçus","wireless_text_mms-sent":"Messages photo et vidéo envoyés","wireless_text_mms-received":"Messages photo et vidéo reçus","wireless_text_long-us-sent":"Messages texte envoyés aux États-Unis ","wireless_text_long-international-sent":"Messages texte envoyés à l’étranger","wireless_roaming":"Itinérance","wireless_roaming_talk-us":"Appels aux États-Unis","wireless_roaming_talk-international":"Appels à l’étranger","wireless_roaming_data-us":"Données aux États-Unis","wireless_roaming_data-europe":"Données en Europe","wireless_roaming_data-international":"Données à l’étranger","wireless_roaming_text-us-sent":"Messages texte – États-Unis – Envoyés","wireless_roaming_text-us-received":"Messages texte – États-Unis – Reçus","wireless_roaming_text-international-sent":"Messages texte internationaux – Envoyés","wireless_roaming_text-international-received":"Messages texte internationaux – Reçus","wireless_usage_included":"Inclus","wireless_data_usage_included":"Données incluses","wireless_usage_used":"Used","wireless_usage_my-usage":"Mon utilisation","wireless_usage_usage-details":"Détails de votre utilisation","wireless_usage_text-usage":"Textos :","wireless_usage_talk-usage":"Appels :","wireless_usage_others-usage":"Utilisation des autres membres","wireless_usage_total-usage":"Utilisation totale","wireless_usage_remaining":"Reste","wireless_usage-text_my-usage":"Mon utilisation:","wireless_usage-text_others-usage":"Utilisation des autres membres :","wireless_usage-text_total-usage":"Utilisation totale :","wireless_usage-text_my-usage_in":"Mes textos reçus :","wireless_usage-text_others-usage_in":"Textos reçus par les autres :","wireless_usage-text_total-usage_in":"Nombre total de textos reçus :","wireless_usage-text_my-usage_out":"Mes textos envoyés :","wireless_usage-text_others-usage_out":"Textos envoyés par les autres :","wireless_usage-text_total-usage_out":"Nombre total de textos envoyés :","wireless_usage-text_remaining":"Reste :","wireless_usage_mb":"Mo","wireless_usage_gb":"Go","wireless_usage_minutes":"minutes","wireless_usage_messages":"messages","wireless_manage-plan":"Gérer mon forfait et mes options","wireless_manage-plan_estimated-values":"<b>Le total mensuel estimé ne comprend ni rabais ni crédits<b>","wireless_manage-plan_description":"Description du SOC","wireless_manage-plan_price":"Prix","wireless_manage-plan_soc_code":"Code SOC","wireless_manage-plan_effective_date":"Date d'entrée en vigueur ","wireless_manage-plan_expiration_date":"Date d'expiration ","wireless_manage-plan_current_service":"Service actuel","wireless_manage-plan_no_socs_available":"Aucun SOC n’est associé à ce compte.","wireless_manage-plan_wireless-package":"Mon forfait des services sans-fil","wireless_manage-plan_wireless-not-applicable":"N/A","wireless_manage-plan_modal_header":"Compris dans votre","wireless_manage-plan_data":"Données","wireless_manage-plan_month":"par mois","wireless_manage-plan_package":"Gérer mon forfait","wireless_manage-plan_add-ons":"Gérer mes options","wireless_manage-plan_my-line":"Ma Ligne:","wireless_manage-plan_change-sim":"Changer ma carte SIM","wireless_manage-plan_change-number":"Changer mon numéro","wireless_manage-device":"Gérer mon appareil","wireless_package_included_with_plan":"Compris dans Mon forfait","wireless_manage-device_free-upgrade":"Admissible à un rehaussement d’équipement gratuite le :","wireless_manage-device_upgrade-today":"Rehausser aujourd'hui  pour :","wireless_manage-device_check_balance":"Solde de l’appareil","wireless_manage_device_reserve":" Réservation d'appareil","wireless_manage-device_upgrade-device":"Changer d’appareil","wireless_manage-device_suspend-service":"Suspendre mon service","wireless_manage-device_suspend-ctn":"Votre appareil a-t-il &eacute;t&eacute; perdu ou vol&eacute;?","wireless_manage-device_restore-service":"Rétablir mon service","wireless_manage-device_reactivate-service":"R&eacute;activez vos services","wireless_manage-device_reactivate-services":"R&eacute;activez   services","wireless_manage-device_phone-finder":"Inscription au service Localisateur de téléphone","wireless_manage-device_voicemail-password":"Changer mon mot de passe pour la messagerie vocale","wireless_manage-device_get-one-number":"S’abonner à <i>Un seul numéro Rogers</i><sub>MC</sub>","wireless_manage-device_shop-accessories":"Rechercher des accessoires","wireless_manage-device_my5-my10":"Gérer MON TOP 5/MON TOP 10","wireless_manage-device_free":"SANS FRAIS","wirless_manager-device_hup":"Changer d’appareil:","wireless_manage-device_in_stock_info":"Si le produit est <strong>en stock,</strong> ouvrez le ","wireless_manage-device_out_of_stock_info":"Si le produit est <strong>en rupture de stock,</strong> suivez le cheminement de la ","wireless_manage-device_endless_Aisle":"rangée sans fin","wireless_manage-device_imei":"IMEI : ","wireless_prepaid":"SERVICE PRÉPAYÉ","wireless_prepaid_quick-links":"Liens rapides","wireless_prepaid_get-add-on":"Obtenir des options","wireless_prepaid_shop-accessories":"Rechercher des accessoires","wireless_prepaid_manage-plan":"Gérer mon forfait et mes options","wireless_prepaid_my-plan":"Mon forfait","wireless_prepaid_data":"Données","wireless_prepaid_plan-expires":"Prochaine date de paiement :","wireless_prepaid_change-plan":"Changer mon forfait","wireless_prepaid_add-ons":"Mes options","wireless_prepaid_add-on-expires":"Date d'expiration de l’option :","wireless_prepaid_wireless-number":"Mon numéro de sans-fil :","wireless_prepaid_pin-code":"NIP :","wireless_prepaid_change-number":"Changer mon numéro de sans-fil","wireless_prepaid_change-pin":"Changer mon NIP","wireless_prepaid_manage-add-ons":"Gérer mes options","wireless_dashboard_refresh":"Rafraîchir","wireless_dashboard_usage":"Utilisation","wireless_dashboard_rv_customer_cost_excluded":"(Montant du programme <strong>Voie express</strong> en sus)","wireless_dashboard_rv_customer_message":"Le solde de votre appareil (sans le montant du programme <strong>Voie express</strong><sub><small class='black'>MC</small></sub>) sera de","wireless_dashboard_rv_customer_message_one":"Vous êtes inscrit au programme <strong>Voie express</strong>","wireless_dashboard_rv_customer_message_upfront":"Upfront Advantage","wireless_dashboard_rv_customer_upfront_faq":"Connaître le fonctionnement du programme <strong>Voie express</strong> >","wireless_dashboard_rv_amount_message":"Montant du programme <strong style=\"font-weight: 600\">Voie express</strong><sub><small class='black'>MC</small></sub>: ","usage-unit-text":"min","wireless_missing_usage":"Nous constatons que vous n'avez aucun forfait données, voix ou texto. Si vous souhaitez en ajouter un, <a href='http://www.rogers.com/consumer/wireless?setLanguage=fr' target='_blank'>cliquez ici</a>.","wireless_midcycle_message":"Il nous est impossible d’afficher votre utilisation actuellement en raison d’un changement de forfait récent. <br />Soyez sans crainte, vous pourrez prendre connaissance de votre utilisation dès votre prochain cycle d’utilisation.","wireless_roaming_details_coming_soon":"Plus de détails sur l’itinérance sous peu","wireless_roaming_details_coming_soon_chat_with_us_url":"http://rogershelp.com/customerserv/livechatsupport/index.php?source=92&lctc=92%7C01%7Cws%7CWWS%20fr","error_account_balance":"Nous sommes incapables de récupérer les renseignements sur votre solde du compte pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/credops_fr_landing.php?hm=n&s=253' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_availed_services":"Nous sommes incapables de récupérer les renseignements sur vos services pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_cable_dashboard":"Désolé, les détails de votre service Télé ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","error_rshm_dashboard":"Désolé, les détails de votre Système de domotique ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","error_population_accounts":"Nous sommes incapables de récupérer les renseignements sur vos services pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_wireless_usage":"Désolé, les détails de votre service Sans-fil ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","wireless_usage_failed":"Désolé, nous ne pouvons pas afficher votre utilisation sans-fil. Nous tentons de régler le problème.<br/>Besoin d’aide?&nbsp;","error_wireless_package_device":"Nous sommes incapables de récupérer les renseignements sur votre service sans fil pour l’instant. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre ce problème.","error_wireless_package_device_old":"Nous sommes incapables de récupérer les renseignements sur votre service sans fil pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_manage_plan":"Nous sommes incapables de récupérer les renseignements sur votre service sans fil pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_usage_internet_modem":"Désolé, les détails de votre service Internet ne s’affichent pas. Veuillez réessayer plus tard. Merci de votre patience, nous mettons tout en œuvre pour résoudre le problème.","error_tv_feeder":"Nous sommes incapables de récupérer les renseignements en cours de diffusion pour l’instant.","error_tv_package_extras":"Nous sommes incapables de récupérer les renseignements sur votre service de télévision pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","error_no_server_interaction":"Nous sommes incapables de récupérer les renseignements sur vos services pour l’instant. Veuillez <a href='http://www.rogershelp.com/customerserv/livechatsupport/index.php?con=true&source=67&lctc=67%7C01%7Cws%7Cretrieve_services_error_fr' target='_blank'>clavarder</a> avec un conseiller du Service à la clientèle pour obtenir de l’aide.","new_to_my_rogers":"C’est nouveau pour vous Mon Rogers","new_to_my_rogers_mark":"Vous n’êtes pas inscrit à MonRogers<sub><small class='white'>MC</small></sub>?","talk_to_us_now":"Clavardez en ligne avec un conseiller","ppc_something_went_wrong_message_title":"Désolé, une erreur s’est produite.","ppc_something_went_wrong_message_text":"Nous tentons de régler le problème le plus rapidement possible. En attendant, nous avons sauvegardé vos sélections, alors vous pouvez téléphoner au Service à la clientèle ou utiliser notre service de clavardage en direct afin d’obtenir de l’aide pour terminer votre commande.","forgot_username":"Vous avez oublié votre nom d’utilisateur","forgot_password":"Vous avez oublié votre mot de passe","reset_password":"Réinitialisez votre mot de passe","link_account":"Associer le compte","learn_more":"Détails","close":"Fermer","more":"Plus","need_help_with_your_bill":"Vous avez besoin d’aide avec votre facture?","rlh_confirm_modal_msg":"<p>Avec <b>Partout chez vous<sub>MC</sub></b>, vous pouvez utiliser votre téléphone comme si vous étiez au pays.</p><p>Utilisez les données, les appels et les messages texte compris dans votre forfait sans-fil mensuel dans plus de 100 destinations admissibles à travers le monde; à partir de seulement 7 $ par jour lorsque vous êtes en itinérance aux États-Unis et de 12 $ par jour lorsque vous êtes en itinérance dans toute autre destination admissible.</p>","visit_billing_support":"Service de soutien","ensure_roaming_is_on":"Assurez-vous d’activer l’itinérance avant d’utiliser le service.","travel_options":"Options d’itinérance","us_europe":"&Eacute;tats-Unis & Europe","you_have_this":"VOUS PROFITEZ DE CECI","use_your_phone_like_you_do_at_home":"Utilisez votre téléphone comme vous le feriez à la maison dans plus de 100 destinations.  Seulement ","rlh_use_your_phone_like_you_do_at_home":"Utilisez votre téléphone comme vous le feriez à la maison dans plus de 100 destinations.  Seulement ","in_the_us":" par jour aux États-Unis et ","in_other_countries":" par jour dans toutes les autres destinations admissibles!","enroll":"ABONNEMENT","activate_now":"Activer maintenant","rome_like_home":"Partout Chez Vous<sup>MC</sup>","activating_roam_like_home":"Abonnement à Partout Chez Vous<sup>MC</sup>","while_in_the_us":"While in the U.S., you will be charged fr","for_each_day_you_use":" for each day you use your phone. fr","while_in_europe":"While in Europe, you will be charged fr","are_you_sure_activate_roam":"Prêt à vous abonner à Partout chez vous?","no_dont_activate":"NON","yes_activate":"OUI","remember_you_will_need_to_enroll":"Si vous utilisez votre appareil dans toute autre destination admissible, des frais de 12 $ par jour* s’appliqueront, pour un maximum de 15 jours.","go_ahead_roam_on":"Avec <b>Partout chez vous<sub>MC</sub></b> utiliser les données, les appels et messages texte illimités de votre forfait <b>Partagez tout<sub>MC</sub></b> lorsque vous voyagez, comme si vous étiez à la maison.","unlimted_talk_and_text":"Appels et messages texte illimités au Canada et dans les pays admissibles que vous visitez.","data_from_your_plan":"Données comprises dans votre forfait","while_you_are_travelling":"Si vous utilisez votre appareil en itinérance aux États-Unis, des frais de 5 $ par jour* s’appliqueront, pour un maximum de 10 jours.","travel_package_fail_msg":"Désolés, nous ne parvenons pas à vous abonner pour le moment. Si ce problème persiste, veuillez texter « voyage » au code 222 pour vous abonner.","brite_bill_title":"View Bill FR","bb_error_message":"Désolé, votre facture n’est pas disponible pour le moment. Veuillez réessayer plus tard. Merci.","bb_error_message_header_no_bill":"Merci d’avoir choisi Rogers!","bb_error_message_no_bill":"Votre première facture sera affichée ici après la fin de votre cycle de facturation, soit le {{date}}.","bb_error_message_header_system_issue":"Désolé, il nous est impossible pour l’instant d’afficher votre facture.","bb_error_message_header_system_issue_rep":"Désolés, il nous est impossible pour l’instant d’afficher votre facture.","bb_error_message_system_issue":"Essayez d'actualiser la page ou composez le 1-855-381-7841 pour obtenir de l’aide immédiate.","return_to_account_overview":"Revenir à l'aperçu du compte","bb_download":"Sauvegarder cette facture sous","bb_pdf":"PDF","view_bill_before":"Voir les factures avant","view_bill_for":"Consulter les factures","view_billing_date":"Date de facturation :","less_complicated_bill":"Une facture plus facile à lire.","understand_your_bill":"Nous avons simplifié la présentation de vos frais pour faciliter leur compréhension et nous avons personnalisé votre facture pour qu’elle réponde mieux à vos besoins. Laissez-nous vous montrer.","skip_video":"Sauter le vidéo","watch_video":"Regarder le vidéo","june_1":" 1 juin, 2015","wireless_rerating_message":"Nous sommes désolés. En raison de votre changement de forfait récent, nous sommes dans l’impossibilité d’afficher les détails de votre utilisation. Ces détails seront toutefois de nouveau accessibles dans un délai de 48 heures. Veuillez réessayer après ce délai.","rto_Message":"Vous avez terminé les paiements de location avec option d’achat pour ce terminal numérique. Il est maintenant à vous!","rto_Title":"Location avec option d’achat","secret_answer_validation":"Veuillez entrer une réponse à la question de rappel du mot de passe. Elle peut contenir des lettres, des chiffres et des caractères spéciaux.","secret_question_select":"Veuillez choisir une question de rappel du mot de passe dans le menu déroulant.","email_validation":"Veuillez entrer une adresse électronique valide.","contact_number_1_validation":"Veuillez entrer votre numéro de téléphone résidentiel à dix chiffres, sans espaces ni caractères additionnels.","contact_number_2_validation":"Veuillez entrer votre numéro de téléphone d’affaires à dix chiffres, sans espaces ni caractères additionnels.","contact_number_2_extension_validation":"Téléphone numéro de poste d'affaires devrait être de 1 à 4 chiffres.","general_error":"Désolé, une erreur s’est produite. Nous tentons de régler le problème le plus rapidement possible. Les changements apportés à vos forfaits n’ont pas été enregistrés. Veuillez revérifier dans quelques minutes.","_add_remove_accounts":"ajouter / retirer des comptes","_self_serve_only":"Libre-service seulement","_account_#":"Numéro de compte","_remove_account":"Retirer le compte ","_add_account":"Ajouter un Compte ","_want_add_account":"Vous voulez ajouter un compte?","_account_removal_confirmation_heading":"Confirmation du retrait du compte","_account_removal_confirmation_message":"Vous êtes sur le point de retirer le compte affiché ci-dessous. Vous pouvez en tout temps ajouter ou lier de nouveau des comptes à votre profil.","_account_removal_confirmation_accountname":"Nom inscrit au compte:","_account_removal_confirmation_accountnumber":"Numéro de compte:","_account_removal_error_heading":"","_account_removal_error_msg":"Désolé! Il semble qu’une erreur se soit produite de notre côté. Un conseiller du Service à la clientèle peut vous aider par","_account_removal_success_msg":"Bravo! Vous avez réussi à supprimer votre compte.","StreetNumber":"Numéro municipal","StreetName":"Rue","StreetType":"Type de rue","AptNumber":"Numéro d’appartement","_Type":"Type","ebill":"eBill fr","Apartment":"Appartement","Bureau":"Bureau","Floor":"Étage","Penthouse":"Penthouse","Suite":"Suite","Unit":"Unité","ABBEY":"ABBEY","ACRE":"ACRE","ALLEY":"ALLEY","ANNEX":"ANNEX","AVE":"AVE","BAY":"BAY","BEACH":"BEACH","BEND":"BEND","BLDNG":"BLDNG","BLOCK":"BLOCK","BLVD":"BLVD","BRDG":"BRDG","BURN":"BURN","BYPASS":"BYPASS","BYRON":"BYRON","BYWAY":"BYWAY","CAMPU":"CAMPU","CAPE":"CAPE","CHASE":"CHASE","CIR":"CIR","CIRCT":"CIRCT","CLIFF":"CLIFF","CLOSE":"CLOSE","COMMO":"COMMO","CONN":"CONN","COURT":"COURT","COVE":"COVE","CRES":"CRES","CRNRS":"CRNRS","CROSS":"CROSS","CTR":"CTR","CURVE":"CURVE","DALE":"DALE","DELL":"DELL","DIVER":"DIVER","DOWN":"DOWN","DR":"DR","END":"END","ESPL":"ESPL","ESTAT":"ESTAT","EXPY":"EXPY","EXTEN":"EXTEN","FARM":"FARM","FIELD":"FIELD","FORES":"FORES","FRONT":"FRONT","FWY":"FWY","GARD":"GARD","GATE":"GATE","GDNS":"GDNS","GLADE":"GLADE","GLEN":"GLEN","GREEN":"GREEN","GRNDS":"GRNDS","GROVE":"GROVE","GTWAY":"GTWAY","HALL":"HALL","HARBR":"HARBR","HEATH":"HEATH","HEIGH":"HEIGH","HGHLD":"HGHLD","HILL":"HILL","HOLLO":"HOLLO","HTS":"HTS","HWY":"HWY","IMP":"IMP","ISLAN":"ISLAN","JARD":"JARD","KEEP":"KEEP","KEY":"KEY","KNOLL":"KNOLL","LAKE":"LAKE","LANDN":"LANDN","LANE":"LANE","LAWN":"LAWN","LINE":"LINE","LINK":"LINK","LKOUT":"LKOUT","LMTS":"LMTS","LOOP":"LOOP","MAIN":"MAIN","MALL":"MALL","MANOR":"MANOR","MARKE":"MARKE","MAZE":"MAZE","MEADO":"MEADO","MEWS":"MEWS","MIN12":"MIN12","MOOR":"MOOR","MOUNT":"MOUNT","MTN":"MTN","ORCH":"ORCH","PARAD":"PARAD","PARC":"PARC","PARK":"PARK","PASS":"PASS","PATH":"PATH","PINES":"PINES","PKY":"PKY","PLACE":"PLACE","PLAT":"PLAT","PLAZA":"PLAZA","PLWAY":"PLWAY","POINT":"POINT","PRKRD":"PRKRD","PROM":"PROM","PTWAY":"PTWAY","PVT":"PVT","QUAY":"QUAY","RANG":"RANG","RANGE":"RANGE","RDPT":"RDPT","RIDGE":"RIDGE","RISE":"RISE","ROAD":"ROAD","ROUTE":"ROUTE","ROW":"ROW","RUE":"RUE","RUN":"RUN","SEAWK":"SEAWK","SQ":"SQ","ST":"ST","SUBDI":"SUBDI","TERR":"TERR","THICK":"THICK","TLINE":"TLINE","TOWER":"TOWER","TRAIL":"TRAIL","TRLWA":"TRLWA","TRNAB":"TRNAB","VALE":"VALE","VALLE":"VALLE","VIEW":"VIEW","VILLA":"VILLA","VILLG":"VILLG","VISTA":"VISTA","WALK":"WALK","WAY":"WAY","WHARF":"WHARF","WKWAY":"WKWAY","WOOD":"WOOD","WYND":"WYND","direct_mail":"Publipostage","telemarketing":"Télémarketing","text_message":"Message texte","none":"Aucun","apply_these_settings":"Apply these settings to all services fr","_save_changes":"Enregistrer les changements","billing_bottom_info":"<strong>Veuillez bien prendre note : </strong> Il est impossible d'effectuer un rehaussement d'équipement dans les 30 jours suivant la mise à jour ou la modification d’une adresse de facturation. ","mailing_address":"Adresse d’envoi","_correct_as_per_canada_post":"Please use correct as per Canada Post provided below fr","_as_per_canada_post":"Selon Postes Canada","_as_entered":"Tel qu'inscrit","_submit_address_as_entered":"SOUMETTEZ L'ADRESSE TELLE QU'ELLE A ÉTÉ ENTRÉE","_submit_canada_post_address":"SOUMETTRE L'ADDRESSE POSTALE DE POSTES CANADA","tv":"Télévision","rogers_home_phone":"Téléphonie résidentielle de Rogers","let_us_know_how_you":"Comment souhaitez-vous que nous communiquions avec vous?","add_account":"Ajouter un compte","verify_address_general_error":"L'adresse indiquée ne coïncide pas avec les renseignements de Postes Canada. Veuillez sélectionner votre adresse exacte ci-dessous.","valid_postal_code":"Veuillez entrer un code postal valide, sans espaces.","paper_bill_title":"Facture papier","paper_bill_success_1":"Puisque nous vous enverrons votre facture par la poste au début du prochain cycle de facturation, assurez-vous de l’exactitude de l’adresse de facturation inscrite à votre dossier.","paper_bill_success_2":"Select Online Billing to get your bills sent directly to your email inbox.","online_bill_title":"Facture en ligne","online_bill_success_1":"Merci d’avoir l'environnement à cœur et de vouloir nous aider à réduire notre empreinte carbone.","online_bill_success_2":"Vous avez sélectionné la facture en ligne. Jetez un coup d'œil à vos courriels pour vos relevés mensuels.","marketing_permissions_info":"Si Rogers n’est pas votre fournisseur de service sans-fil et que vous avez choisi de recevoir des messages texte de sa part, il est possible que votre fournisseur de service vous facture des frais pour ces messages texte.","yes":"Oui","no":"Non","resume":"Reprendre","cancel_changes":"Annuler les changements","bonus":"Prime","bonus_text":"GRATUIT le premier mois","price_plan_change_error":"Erreur liée au changement de forfait","price_plan_change_error_msg":"En changeant de forfait, vous dépasserez votre limite de crédit. Veuillez composer le 1 855 720-9038 afin que nous vous aidions à trouver un forfait qui vous convient","no_email_error":"Vous avez sélectionné la facture en ligne, veuillez entrer une adresse électronique valide.","street_name_error":"Veuillez entrer le nom de votre rue. Il peut compter 30 caractères au maximum.","street_number_error":"Veuillez entrer le nom de votre numéro municipal. Il peut compter 10 caractères au maximum.","street_number_error_char":"Veuillez inscrire un numéro civique valide pour ce code postal.","apartment_number_error_char":"S'il vous plaît entrer un numéro d'appartement valide.","valid_city_name":"Veuillez entrer un nom de ville valide.","shm_msg":"<div>Commandez par Oasys</div><div class='green-text'><strong>Pour fixer un rendez-vous d&rsquo;&eacute;valuation &agrave; domicile :</strong></div><div>Aller dans <strong>SGI</strong></div>","login":"Log in","sgi":"SGI","order_though_oasys":"Commandez par Oasys","oasys":"Oasys","to_reserve_device":"Pour r&eacute;server un appareil,","my_rogers":"MyRogers","customer_log_in":"customer log in","plan":"Forfait","ssp":"PVS","to":"to","ssp_dashboard":"Tableau de bord du PVS","modem":"Modem","to_check":"&Agrave; V&Eacute;RIFIER","to_upgrade":"&Agrave; REHAUSSER","to_manage":"&Agrave; G&Eacute;RER","to_change":"&Agrave; MODIFIER","package":"Forfait","extras":"Extras","theme_packs":"Forfaits &agrave; th&egrave;me","channels":"Cha&icirc;nes","digital_box":"Terminal num&eacute;rique","outlets":"Prises","digital_pin":"NIP du terminal num&eacute;rique","to_reset":"&Agrave; R&Eacute;INITIALISER:","v21":"V21","add_ons":"Options","phone_number":"Num&eacute;ro de t&eacute;l&eacute;phone","sim_card":"Carte SIM","Price Plan":"","device":"Appareil","balance":"Balance","profile_popup_body_title":"Pour apporter un changement au compte du client:","if_the_customer_has_a_wireless_product":"Si le client est abonn&eacute; &agrave; un produit sans-fil:","if_the_customer_has_only_residential_products":"Si le client est abonn&eacute; &agrave; des produits r&eacute;sidentiels seulement:","you_will_need_to_go_to_v21_or_ssp":"Traiter avec V21 ou le Portail des ventes et du service","you_will_need_to_go_to_sgi":"Traiter avec SGI","to_pay_a_bill":"Pour payer une facture ou changer une m&eacute;thode de paiement:","if_you_are_at_call_center_go_to_v21":"Traiter la demande avec V21 (PDV pour la vente au d&eacute;tail)","if_you_are_at_call_center_go_to_sgi":"Traiter la demande avec SGI (PDV pour la vente au d&eacute;tail)","if_you_are_at_call_center_go_to_v21_fr":"Traiter la demande avec V21 (Portail des ventes et du service pour la vente au d&eacute;tail)","if_you_are_at_call_center_go_to_sgi_fr":"Traiter la demande avec SGI","if_you_are_at_retail_location_use_a_pos":"If you’re at a retail location, use a POS","service_shm":"shm","billing_title":"Facturation","login_to":"Se connecter &agrave;","device_balance":"Solde de l&rsquo;appareil","access_error_title":"Vous n&rsquo;avez pas l&rsquo;autorisation d&rsquo;acc&eacute;der &agrave; OmniVue.","access_error_msg":"Veuillez communiquer avec votre gestionnaire pour obtenir un acc&egrave;s &agrave; cet outil","service_error":"Nous sommes d&eacute;sol&eacute;s, il est impossible de travailler sur le compte de ce client dans OneView.","sso_error_title":"Connexion impossible","sso_error_msg":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite pendant votre tentative d&rsquo;ouverture de session. Veuillez retourner dans <strong>ICM ou le Portail des ventes et du service</strong> et ouvrir MonRogers &agrave; nouveau.","to_update_customer_payment_method":"Pour payer une facture ou changer une m&eacute;thode de paiement:","if_you_are_at_retail_location_go_to_ssp":"If you’re at a retail location, go to SSP","unable_to_sign_on":"Connexion impossible","sso_failure_description":"D&eacute;sol&eacute;, une erreur s&rsquo;est produite pendant votre tentative d&rsquo;ouverture de session. Veuillez retourner dans <strong>ICM ou le Portail des ventes et du service</strong> et ouvrir <i>MonRogers</i> &agrave; nouveau.","acc_overview_account_overdue_one_view_care":"<span class=\"error-type\">COMPTE SUSPENDU.</span><span class=\"error-message-suspended\"> Pour réactiver les services, <a href=\"JavaScript:void(0);\" ng-click=\"ao.payBillSuspended()\" data-test-id=\"myr-oneViewCancelledAndSuspentAccount-payBill\">traitez le paiement</a> couvrant le solde impayé.</span>","acc_overview_account_overdue_one_view":"<b>Ce compte est actuellement suspendu.</b><br/>Si un solde impayé figure au compte, le fait d’effectuer un paiement peut rétablir sur-le-champ votre accès complet aux renseignements de votre compte sur MonRogers<sub><small><small>MC</small></small></sub>. Vous pouvez aussi communiquer avec nous par clavardage en direct pour régler ce problème.","business":"AFFAIRES","log_in_to_sgi":"Aller dans <strong>SGI</strong>","log_in_to_oasys_or_ssp":"Aller dans <strong>Oasys</strong> ou le <strong>PVS</strong>","log_in_to_telli":"Se connecter &agrave;<strong> Telli</strong>","price_plan":"Forfait","login_to_v21":"veuillez ouvrir une session dans <strong>V21</strong>","generic_error_title":"Une erreur est survenue.","generic_error_message":"Le contenu n’est pas disponible pour l’instant. Veuillez essayer de nouveau.","business_access_failure_message":"Le compte d’affaires que vous essayez de lancer ne peut pas être consulté dans OmniVue en raison d’une autorisation restreinte.","business_access_failure_alert":"ALERTE:","fido_access_failure_message":"Le compte Fido que vous essayez de lancer ne peut pas être consulté dans OmniVue en raison d’une autorisation restreinte.","fido_access_failure_alert":"ALERTE:","session_timeout_error_title":"Session interrompue","session_timeout_error_message":"D&eacute;sol&eacute;, votre session a &eacute;t&eacute; interrompue. Veuillez retourner dans <strong>ICM</strong> et ouvrir MonRogers &agrave; nouveau.","top_up_now":"R&eacute;approvisionner le compte","top_up_now_body":"<p>Si vous travaillez au Service &agrave; la client&egrave;le, veuillez passer &agrave; l&rsquo;application de gestion des transactions du service pr&eacute;pay&eacute; (PTMA).</p><p>Si vous travaillez dans le secteur de la Vente au d&eacute;tail, veuillez retourner au PVS pour terminer cette transaction.</p>","make_account_changes":"Modifier le compte","make_account_changes_body":"<p>Si vous travaillez au <strong>Service &agrave; la client&egrave;le</strong>, passez &agrave; l&rsquo;application de gestion des transactions du service pr&eacute;pay&eacute; (PTMA).</p><p>Si vous travaillez <strong>en magasin</strong>, dites au client de composer le 1 800 575 9090.</p>","roam_like_home_pop_up_title":"<strong>Partout chez vous</strong>","roam_like_home_pop_up_message":"Veuillez demander au client de texter le mot <strong>voyage</strong> au <strong>222</strong>.","concurrent_update_ok":"Ok","concurrent_update_message_title":"Mises à jour en cours","ppc_concurrent_update_message_text":"Des mises à jour sont déjà en cours relativement à ce changement de forfait. Veuillez recommencer le processus.","hup_concurrent_update_message_text":"Des mises à jour sont déjà en cours relativement à ce rehaussement. Veuillez recommencer le processus.","page_loading_splash_message":"La page de vos services est en chargement.<br>Nous vous remercions de votre patience!","204_title":"Aucun plan disponible","204_text":"Nous ne pouvons pas trouver un bon plan pour l'instant.","buy":"Acheter","modal_thank_you_registration_headline":"Vous venez de vous inscrire à MonRogers!","modal_thank_you_registration_join":"Joignez-vous aux forums communautaires de Rogers","modal_thank_you_registration_info":"Obtenez de bons conseils de Rogers, faites part de vos idées et discutez avec les employés de Rogers et les autres membres de nos forums communautaires.","modal_thank_you_registration_later":"ALLER À MONROGERS","modal_thank_you_registration_community":"SE JOINDRE AUX FORUMS","report_issue":"Signaler problème","ppc_have_saved_order":"Vous avez commencé un changement de forfait et vous l’avez enregistré.","hup_have_saved_order":"Vous avez commencé un rehaussement d’équipement et vous l’avez enregistré.","interaction":"INTERACTIONS","interaction_started":"Actuelle, Commencé à ","interaction_at":"à","interaction_ticket":"BILLET","wireless_manage-plan_change-sim_dealer":"Changer les num&eacute;ros SIM/IMEI","wireless_manage-device_voicemail-password_dealer":"R&eacute;initialiser la Messagerie vocale","change_phone_number":"Changer de num&eacute;ro de t&eacute;l&eacute;phone","change_phone_number_success_message":"<b>Changement r&eacute;ussi.</b> Le changement de num&eacute;ro de t&eacute;l&eacute;phone du client a &eacute;t&eacute; effectu&eacute;.","change_phone_number_error_message":"<b>Erreur.</b> &Eacute;chec du changement de num&eacute;ro de t&eacute;l&eacute;phone du client.","change_sim_success_message":"<b>Changement r&eacute;ussi.</b> Le changement de SIM/IMEI du client a &eacute;t&eacute; effectu&eacute;.","change_sim_error_message":"<b>Erreur.</b> &Eacute;chec du changement de SIM/IMEI du client.","change_plan_success_message":"<b>Changement r&eacute;ussi.</b> Le changement de forfait du client a &eacute;t&eacute; effectu&eacute;.","change_plan_error_message":"<b>Erreur.</b> &Eacute;chec du changement de forfait du client.","manage_addon_success_message":"<b>Changement r&eacute;ussi.</b> Le changement d&rsquo;options du client a &eacute;t&eacute; effectu&eacute;.","manage_addon_error_message":"<b>Erreur.</b> &Eacute;chec du changement d&rsquo;options du client.","reset_voicemail_success_message":"<b>Changement r&eacute;ussi.</b> La messagerie a &eacute;t&eacute; r&eacute;initialiser.","reset_voicemail_error_message":"<b>Erreur.</b> &Eacute;chec du r&eacute;initialiser la messagerie.","device_upgrade_success_message":"<b>Changement r&eacute;ussi.</b> Le rehaussement de l'appareil a été effectué.","device_upgrade_error_message":"<b>Erreur.</b> Échec du rehaussement de l'appareil du client.","add_a_line_success_message":"<b>Changement r&eacute;ussi.</b> Le changement de ajouter une ligne a été effectué.","add_a_line_error_message":"<b>Erreur.</b> Échec du changement de de ajouter une ligne du client. ","hup_cancellation_success_message":"<b>Changement r&eacute;ussi.</b> L'annulation de rehaussement de l'appareil a été effectué.","hup_cancellation_error_message":"<b>Erreur.</b> Échec de l'annulation de rehaussement de l'appareil du client.","get_wireless_success_message":"<b>Changement r&eacute;ussi.</b> Service sans-fil a été ajouté.","get_wireless_error_message":"<b>Erreur.</b> Échec de ajouter service sans-fil.","acc_balance_colon":"Solde du compte :","last_bill_colon":"Facture pr&eacute;c&eacute;dente :","user_view":"Affichage utilisateur","customer_view":"Affichage client","rep_view":"Affichage conseiller","welcome":"Bienvenue","welcome_comma":"Bienvenue, ","sign_out":"Fermer la session","search_nova":"Consultez Nova","content_currently_unavailable":"Ce contenu n&rsquo;est pas accessible pour l&rsquo;instant.","actions_and_offers":"ACTIONS et OFFRES","ending":"Jusqu&apos;&agrave;","cycle_ends_in":"Fin du cycle de facturation en ","days":"jours","interaction_history_not_available":"Impossible de r&eacute;cup&eacute;rer l&rsquo;historique d&rsquo;interaction avec ce client.","internet_swap_modem":"&Eacute;CHANGER LE MODEM","internet_tech_support":"Soutien technique","reset":"R&eacute;initialiser","hup_cancellation":"Annuler rehaussement de l&apos;appareil","hup_cancellation_desc":"Pour annulation de rehaussement de l'appareil nous vous rediriger automatiquement vers l'écran approprié en SSP.","coverage_maps":"Cartes de couverture","add_outlets":"Ajouter des prises","filter_interactions":"Filtrer interactions :","filter_all":"Toutes","filer_tickets":"Billets","filer_retail":"Magasin","filer_care":"Service &agrave; la client&egrave;le","interaction_notes_topics":"REMARQUES SUR L&rsquo;INTERACTION ET SUJETS ABORD&Eacute;S","account_transactions_activities":"Transactions ou activit&eacute;s r&eacute;alis&eacute;es dans le compte","result":"R&eacute;sultat","product_line":"Gamme de produits","topic1":"Sujet 1","save":"Enregistrer","error_filter_all":"Il n&rsquo;y a eu aucune interaction avec le client dans les 90 derniers jours.","error_filter_cases":"Il n&rsquo;y a eu aucune billets dans les 90 derniers jours..","error_filter_care":"Il n&rsquo;y a eu aucune interaction avec service &agrave; la client&egrave;le dans les 90 derniers jours.","error_filter_retail":"Il n&rsquo;y a eu aucune interaction avec les magasins dans les 90 derniers jours..","error_In_Retrieving":"Impossible de r&eacute;cup&eacute;rer l&rsquo;historique d&rsquo;interaction avec ce client.","crm_signout_title":"D&eacute;connexion","crm_signout_message":"Vous avez &eacute;t&eacute; d&eacute;connect&eacute; d&rsquo;OmniVue. Veuillez retourner au PVS ou &agrave; ICM pour vous reconnecter.","fraud_display_message":"Malheureusement, nous ne pouvons pas traiter votre demande pour le moment. Veuillez demander au client de communiquer avec  Rogers au 1-888-383-2080 pour obtenir de l&rsquo;aide. Merci.","credit_ops_display_message":"Nous sommes incapables de compl&eacute;ter votre transaction en ce moment. S&apos;il vous pla&icirc;t conseiller le client d&rsquo;appeler le 1-800-551-5700 pour obtenir de l&apos;aide &agrave; compl&eacute;ter leur demande.","one_view_pay_as_you_go":"Parlez à la carte","value_packs":"Packs de valeur","upgrade_your_device":"Changer de téléphone","your_device_balance":"Solde de votre appareil","last_update_date":"Date du dernier rehaussement ou de la mise en service : ","Purchased_Date":"Fr_Purchased:","device_balance_today":"Solde de l'appareil à ce jour :","device_balance_was_0":"Le solde de l'appareil sera/était de 0,00 $ le ","hup_no_ctns_error_message":"Désolé! Pour consulter le solde de votre appareil, vous devez en premier lieu avoir un appareil sans fil associé à votre compte <i>Mon Rogers</i><sup>MC</sup>.","hup_generic_error_message":"Désolé, le solde de votre appareil n'est pas disponible pour le moment. Si vous souhaitez parler à un conseiller, veuillez composer le <b>1 844 481 2660</b>.","current_device_balance":"Fr_Current Device Balance:","flextab_balance_desc":"Fr_This is your outstanding device balance, or FLEXtab, comprised of the device subsidy you received when you purchased your existing phone. It is being reduced in even amounts each month over the term you initially signed up for. If you wish to upgrade today, all you need to do is pay off the remaining device balance, or FLEXtab, of that subsidy.","flextab_monthly_deduction":"Fr_Amount by which FLEXtab decreases monthly:","flextab_term_length":"Fr_FLEXtab term length:","flextab_balance":"Fr_FLEXtab balance:","financing_balance_desc":"Voici le solde sur votre appareil acheté dans le cadre du programme de financement, qui correspond au montant financé lorsque vous avez acheté l'appareil, moins les paiements mensuels en vertu de ce programme. Le solde sur votre appareil acheté dans le cadre du programme de financement diminue chaque mois quand vous faites vos paiements mensuels en vertu de ce programme. Si vous souhaitez effectuer un rehaussement plus tôt que prévu, il vous suffit de payer le solde de l'appareil en vertu du programme de financement.","financing_balance_desc_new":"Voici le solde sur votre appareil acheté dans le cadre du programme de financement, correspondant au montant financé lors de l’achat, moins les paiements mensuels en vertu de ce programme. Ce solde diminue chaque mois quand vous faites vos paiements mensuels en vertu de ce programme. Si vous souhaitez effectuer un rehaussement plus tôt que prévu, il vous suffit de payer le solde de l’appareil en vertu du programme de financement.","wireless_dashboard_device_financing_faq":"En savoir plus sur le programme de financement","financing_monthly_payment":"Paiement mensuel en vertu du programme de financement:","number_of_financing_monthly_payments":"Nombre de paiements mensuels en vertu du programme de financement:","outstanding_financing_balance":"Solde sur l'appareil acheté dans le cadre du programme de financement:","month":"Fr_month","months":"Fr_months","hup_errorCode_A_desc":"Désolé, vous n'êtes pas admissible actuellement à un rehaussement et le solde de votre appareil n'est pas disponible, car votre compte n'est pas en règle (un solde est en souffrance).","hup_errorCode_FJ_desc":"Désolé, vous n'êtes pas admissible actuellement à un rehaussement et le solde de votre appareil n'est pas disponible, car vous avez mis en service un nouvel appareil ou effectué un rehaussement au cours des 30 derniers jours.","hup_errorCode_D_desc":"Désolé, vous n'êtes pas admissible actuellement à un rehaussement et le solde de votre appareil n'est pas disponible, car votre compte a été suspendu.","hup_errorCode_L_desc":"Désolé, vous n'êtes pas admissible actuellement à un rehaussement et le solde de votre appareil n'est pas disponible, car une annulation du compte est en cours.","hup_errorCode_T_desc":"Nous sommes désolés, mais vous n’êtes pas admissible à un rehaussement pour le moment, puisque vous avez changé votre adresse de facturation au cours des 30 derniers jours.","hup_errorCode_G_desc":"Désolé, le solde de votre appareil n'est pas disponible pour le moment.","3-year-term":" pour abonnement de trois ans","2-year-term":" pour abonnement de deux ans","no-year-term":" pour sans abonnement","financial_program":" avec le programme de financement ","per_month":"/mo","currency-decimal":",","is_NFDB_check_error_message":"Il semble y avoir un problème avec les informations que nous avons reçues. Appelez l'équipe de validation de Rogers au 1 800 588-6718 pour qu'elle puisse vous aider.","is_NFDB_check_error_message_care":"Une alerte de fraude est associée à cette ligne. Veuillez transférer l’appel au service des fraudes.","is_NFDB_check_error_message_retail":"Une alerte de fraude est associée à cette ligne. Veuillez transférer l’appel au service des fraudes.","is_NFDB_check_contact_Number":"1-800-588-6718","hup_search_placehoder":"Search for device_FR","is_fraud_customer_error_message":"You are a fraud customer and not eligible for a device upgrade","3-year-contract":"3-year contract","2-year-contract":"2-year contract","1-year-contract":"FR_1-year contract","no-year-contract":"FR_no contract","total-price-as-of-today":"FR_Total Price as of Today","details":"FR_Details","monthly-costs":"FR_Monthly Costs","unlimited-text":"FR_Unlimited Text","plan-explanation":"FR_explanation of plan need to get from content team","pick-a-new-plan":"FR_Pick a new plan","keep-my-existing-plan":"FR_Keep my existing plan","see-more-individual-plans":"FR_See More Individual Plans","recommended-plan":"FR_Recommended plan","recommended":"FR_recommended","canada-wide":"Canada-Wide","local":"Local","individual-plan":"FR_Individual Plans","rome-like-home":"FR_Roam Like Home","all-share-plan-explanation":"FR_tooltipContent all share plan","all-shared-plans-include":"FR_All Shared plans include:","see-more-shared-plans":"FR_See More Shared Plans","data":"FR_Data","monthly":"FR_Monthly","unlimited-talk":"FR_Unlimited Talk","coverage":"coverage","choose-from":"FR_Choose from","for-families-and-individuals":"FR_For families &amp; individuals","data-share-plans":"FR_Data Share Plans","you-selected":"FR_you-selected","rogers-exclusive":"FR_Rogers Exclusive","unlimited-time-offer":"FR_Unlimited time offer ","features-worth-mentioning":"FR_Features Worth Mentioning","technical-specifications":"FR_Technical Specifications","features-and-specification":"FR_Features &amp; Specification","build-your-phone":"FR_Build Your Phone","see-full-details":"FR_See Full Details (+)","phone-cost-today":"FR_phone cost today","one-time-fee":"FR_One time fee","save-for-later":"FR_Save for later &gt;","plus-applicable-charges":"FR_plus applicable charges","plus-applicable-taxes":"FR_plus applicable taxes","_continueGT":"FR_Continue &gt;","show=next-3-listing":"FR_Show Next 3 Listings","monthly-data-sharing":"FR_Monthly data starting at","on-select-2-yr-plan":"FR_on select 2-yr plans","upgrade":"FR_Upgrade","offer-content":"FR_Free Accessory Kit($130 value) with purchase of iPhone6.Available online and via call centers.Limited time offer while supplies last","total-one-time-fees":"FR_Total One-time Fees:","total-monthly-fees":"FR_Total Monthly Fess:","view-break-down":"FR_View breakdown","zero_dollar_on":"0 $ le : ","rv_customer_last_upgarde":"Date du dernier changement d'appareil ou de la mise en service:","rv_customer_device_balance_will_be/was":"Le solde de votre appareil sera/était de","rv_customer_device_balance_today_checkBalance":"Solde de votre appareil (sans le montant du programme <strong>Voie express</strong><sub><small class='black'>MC</small></sub>) aujourd’hui :","rv_customer_balance_desc_checkBalance":"Il s’agit du solde de votre appareil, qui comprend la subvention que vous avez reçue quand vous avez acheté votre téléphone actuel. Il diffère du montant du programme <strong>Voie express</strong>. Le solde se répartit en montants égaux chaque mois pendant toute la durée de votre abonnement. Si vous souhaitez changer d'appareil, vous devez rembourser le solde courant ainsi que le montant du programme <strong>Voie express</strong>. Vous pouvez soit conserver votre appareil et régler le montant du programme <strong>Voie express</strong> ou retourner l’appareil, en bon état, et ne pas avoir à rembourser le montant du programme <strong>Voie express</strong>. Si vous choisissez de retourner votre appareil pour vous en procurer un autre, vous devez le faire au cours de la deuxième année de votre abonnement. Veuillez consulter les modalités pour connaître tous les détails et le montant du programme <strong>Voie express</strong>.","rv_customer_term_length_checkBalance":"Durée de l’abonnement et du solde de l’appareil :","rv_customer_balance_checkBalance":"Solde de l’appareil :","rv_customer_monthly_deduction_checkBalance":"<b>Montant déduit du solde de votre appareil chaque mois :</b>","rv_upfrontAmount_desc":"Il s’agit du solde de votre appareil, qui comprend la subvention que vous avez reçue quand vous avez acheté votre appareil actuel. Le solde se répartit en montants égaux chaque mois pendant toute la durée de votre abonnement. Si vous souhaitez effectuer un rehaussement de votre appareil, vous devez payer le solde.","rv_upfrontAmount_desc_sec":"Le solde de votre appareil est distinct du montant du programme Voie express. Le montant du programme Voie express est le montant des économies initiales que vous avez réalisées en acceptant de retourner votre appareil en bon état dans 2 ans. Si vous souhaitez effectuer un rehaussement de votre appareil, vous devez rembourser le solde courant ainsi que le montant du programme Voie express. Vous pouvez soit conserver votre appareil et rembourser le montant du programme Voie express, soit le retourner en bon état. Consultez vos modalités du programme Voie express pour en savoir plus.","rv_upfrontAmount_monthly_deduction_checkBalance":"Montant déduit du solde de votre appareil chaque mois:","rv_upfrontAmount_amount_message":"Montant du programme Voie express<sub><small class='black'>MC</small></sub>:","rv_upfront_edge_amount":"Montant du programme Voie express:","device_balance_today_checkBalance":"Solde de l'appareil à ce jour : ","device_balance_will_be/was":"Le solde de l'appareil sera/était de ","flextab_balance_desc_checkBalance":"Il s'agit de votre solde d’appareil FLEXIbalance, qui comprend la subvention que vous avez reçue quand vous avez acheté votre téléphone actuel. Il se répartit en montants égaux chaque mois sur la durée de l'abonnement auquel vous avez souscrit. Si vous souhaitez effectuer un rehaussement de votre appareil aujourd'hui, vous n'avez qu'à payer votre solde, de cette subvention.","flextab_monthly_deduction_checkBalance":"<b>Montant déduit du solde chaque mois :</b>","flextab_term_length_checkBalance":"<b>Durée de l'abonnement de votre solde d’appareil FLEXIbalance :</b>","flextab_balance_checkBalance":"<b>Solde d’appareil FLEXIbalance :</b>","month_checkBalance":"par mois","months_checkBalance":"mois","is_not_eligible_device_upgrade_error_message":"Désolé, cette information n'est pas disponible en ligne pour le moment. Si vous avez besoin d'aide concernant votre compte, contactez nous.","is_not_eligible_device_upgrade_error_message_care":"Désolé, cette information n'est pas disponible en ligne pour le moment.","hup_errorCode_N_desc":"Nous sommes désolés, mais vous ne pouvez pas rehausser votre appareil actuellement, car votre compte affiche déjà une demande de rehaussement en attente.","hna_error_message":"Pour procéder à un rehaussement d'équipement, veuillez communiquer avec nous","hna_contact_number":"1-855-720-9038","upgrade_device":"Rehausser mon appareil","wireless_manage_device_checkBalance":"Solde de l’appareil FLEXIbalance","wireless_checkBalance_error":"Désolé, le solde de votre appareil n’est pas disponible pour le moment. Nous sommes heureux de vous aider.","wireless_checkBalance_error_care":"Désolé, le solde de votre appareil n’est pas disponible pour le moment.","check_balance_toll_number":"1-855-720-9038","c_interactions":"Interactions","c_class":"Cat&eacute;gorie de cr&eacute;dit : ","c_limit":"Limite de cr&eacute;dit : ","c_available":"Cr&eacute;dit disponible : ","anniversary":"Anniversaire : ","interactions_in_the_last_30_days":"Interactions au cours des 30 derniers jours : ","billing_payment_body_agent":"<p>Si vous travaillez au <strong>Service &agrave; la client&egrave;le</strong>, veuillez retourner dans <strong>ICM</strong> pour changer les renseignements de facturation et de paiement.</p><p>Si vous travaillez <strong>en vente au détail</strong>, veuillez retourner dans le <strong>PVS</strong> pour changer les renseignements de facturation et de paiement.</p>","make_account_changes_body_agent":"<p>Si vous travaillez au <strong>Service &agrave; la client&egrave;le</strong>, passez &agrave; l&rsquo;application de gestion des transactions du service pr&eacute;pay&eacute; (PTMA).</p><p>Si vous travaillez dans le secteur de la <strong>Vente au détail</strong>, vous pouvez faire des modifications aux forfaits et aux options et effectuer un changement de numéro de téléphone directement dans le PVS. Si un client veut changer son NIP, demandez-lui de composer le <strong>1-800-575-9090</strong>.</p>","accType_consumer":"Grand public","accType_business":"Affaires","accType_government":"Gouvernemental","accSubType_regular":"Régulier","accSubType_non-revenue":"Sans revenu","accSubType_prepaid":"Prépayé","accSubType_corporate":"Entreprise","accSubType_federal":"Fédéral","accSubType_provincial":"Provincial","accSubType_municipal":"Municipal","accStatus_open":"Ouvert","accStatus_active":"Actif","accStatus_suspended":"Suspendu","accStatus_cancelled":"Annulé","accStatus_pending-disconnect":"Débranchement en attente","accStatus_pending-connection":"Branchement en attente","show_more":"Show more","show_less":"Show less","language_toggle":"English","one_view_reset_password":"R&eacute;initialiser le mot de passe","reset_customer_password_title":"R&eacute;initialiser le mot de passe du client","reset_password_message":"Cliquez sur Continuer pour r&eacute;initialiser le mot de passe du client. Le client va ensuite recevoir un lien par courriel lui permettant de cr&eacute;er un nouveau mot de passe.","reset_password_sucess_message":"Changement r&eacute;ussi! Veuillez informer le client qu&rsquo;un lien de r&eacute;initialisation de mot de passe a &eacute;t&eacute; envoy&eacute; &agrave;","reset_password_error_message":"Nous n&rsquo;avons pas r&eacute;ussi &agrave; r&eacute;initialiser le mot de passe. Si le probl&egrave;me persiste, demandez au client de nous contacter au moyen du Clavardage en direct.","guid_not_found_message":"Nous ne pouvons pas r&eacute;initialiser le mot de passe de cet utilisateur ni changer le type de facturation en ce moment. Veuillez indiquer au client d&rsquo;entrer en contact avec nous par clavardage.","hup_save_cart_offers_changed":"Nous sommes désolés, mais nos offres ont changé. Votre commande enregistrée n’est donc plus valide. Veuillez faire un nouveau choix pour continuer.","mppc_entry_3_title":"Puisque vous ajoutez une nouvelle ligne à votre forfait <strong>Partagez tout<sub>MC</sub></strong>, vous devrez peut-être ajouter des données additionnelles à votre compte pour compenser l’utilisation supplémentaire. Aimeriez-vous ajouter des données à votre forfait?","mppc_entry_3_yes":"Oui","mppc_entry_3_no":"Non","mppc_entry_3_or":"Ou","mppc_entry_1_change_current_plan":"Modifier votre forfait actuel","mppc_entry_1_create_shared_plan":"Faites passer vos autres lignes au forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_entry_1_cancel":"Annuler","mppc_entry_3_change_current_plan":"Modifier votre forfait actuel","mppc_entry_3_change_wireless_plan":"Changer de forfait","mppc_entry_3_add_to_share_plan":"Ajouter cette ligne à votre forfait <strong>Infini de Rogers partagé</strong>","mppc_entry_3_cancel":"Annuler","mppc_shared_group_indiv_title":"Ajouter vos autres lignes à votre forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_shared_group_indiv_switch_reason_1":"Lot de données à partager","mppc_shared_group_indiv_switch_reason_2":"Appels et messages texte illimités, conformément à votre forfait","mppc_shared_group_indiv_switch_reason_3":"Partout chez vous<sub>MC</sub>","mppc_shared_group_indiv_benefits":"Quels sont les avantages?","mppc_shared_group_indiv_skip":"Sauter cette étape &gt;","mppc_shared_group_primary_title":"Sélectionner une ligne principale pour votre nouveau forfait <strong>Partagez tout<sub>MC</sub></strong>","mppc_shared_group_indiv_switch_reason_intro":"Toutes vos lignes partageront les mêmes fonctions dont vous profitez actuellement :","secure_credit_title":"Secure Credit Card Payment","secure_credit_content":"Enter Call Reference number. When Card Type field turns green, ask customer to enter card number into their telephone keypad. Once card number has been captured, click Tokenize.","secure_credit_call_reference":"Call Reference","secure_credit_card_type":"Card Type","secure_credit_card_number":"Card Number","secure_credit_tokenize":"Tokenize","secure_credit_rest":"Reset","share_everything_share":"Partagez tout","rogers_infinite":"Infini de Rogers<sub>MC</sub>","share_everything_individual":"Compte sans-fil individuel","share_everything_residential":"Services résidentiels","share_everything_otherServices":"Autres services","share_everything_addServices":"Ajout d’autres services","ppc":"Changer de forfait","hup":"Rehaussement d'appareil","_my_cart":"Ma liste d'achats","_saved_quotes":"Mes prix","_quote":"Le délai associé #","_ctn":"CTN: ","_expired":"Délai expiré","mppc_on_brt_no_permission_text":"Pour changer votre forfait, veuillez communiquer avec nous :","interaction_medium_dept":"MÉDIUM | DÉPT","interaction_date":"DATE","interaction_product_line":"GAMME DE PRODUIT","interaction_activities":"ACTIVITÉS","interaction_results":"RÉSULTAT","interaction_notes":"NOTES","interaction_rep_interaction_id":"CAS | INTERACTION ID","interaction_topic":"SUJET","interaction_search_error":"Nous sommes désolés, nous n’avons pas trouvé ce que vous cherchez.","search-interaction":"Cherchez","interaction_search_placeholder":"Médium, Dépt, ID, Date, Produit, Mot-clé","go_to_ssp":"Retourner &agrave; PVS","go_to_nova":"Consultez Nova","reset_voicemail_password":"R&eacute;initialiser le mot de passe pour la Messagerie vocale","change_sim":"Changer carte SIM","nac":"Ajout&eacute; une nouvelle ligne","oneview_takepayment_paybill":"Prendre un paiement","remind_the_customer":"Rappelez ce qui suit au client :","oneview_change_method_intro":"Il peut opter pour les paiements pr&eacute;autoris&eacute;s et avoir l&rsquo;esprit en paix en sachant que sa facture Rogers sera r&eacute;gl&eacute;e automatiquement chaque mois &agrave; partir de son compte bancaire canadien ou de sa carte de cr&eacute;dit.","_nickname_update_error_msg":"Nous sommes désolés, mais nous ne pouvons pas traiter votre nouveau pseudonyme pour le compte pour l’instant. Veuillez réessayer plus tard.","private_browsing_warning_msg":"<p><strong>Pour ouvrir une session, vous devrez désactiver la navigation privée.</strong></p><p>Fermez cette fenêtre et ouvrez-en une nouvelle après avoir désactivé la navigation privée. Vous ne savez pas comment faire? <a target='_blank' href='https://support.apple.com/fr-ca/HT203036'>Consultez la marche à suivre</a>.</p>","acc_overview_account_locked":" Le client ne peut plus accéder à son compte parce qu’il a entré le mauvais mot de passe trop de fois. Désirez-vous déverrouiller l’accès à son compte?","acc_overview_unlock":"Déverrouiller >","account_unlock_success_message":"Le compte du client est maintenant déverrouillé. Vous pouvez maintenant lui envoyer un courriel contenant les directives pour réinitialiser son mot de passe.","account_unlock_error_message":"Désolé, nous n’avons pas pu déverrouiller ce compte. Veuillez essayer de nouveau.","account_unlock_customer_info":"<red>Le compte de ce client est verrouillé.</red> Vous pouvez déverrouiller son compte à partir de la page Profil.","wireless_manage-device_oneview_suspend-services":"Suspendre les services","wireless_manage-device_oneview_suspend-service":"Suspendre les service","wireless_my_device":"Mon appareil :","wireless_my_package":"Mon forfait :","wireless_manage":"Gérer","oneview_fraud_message":"Malheureusement, nous ne pouvons pas traiter votre demande pour le moment. Veuillez demander au client de communiquer avec Rogers au 1-888-383-2080 pour obtenir de l&rsquo;aide. Merci.","oneview_credit_ops_message":"Nous sommes incapables de compl&eacute;ter votre transaction en ce moment. S&apos;il vous pla&icirc;t conseiller le client d&rsquo;appeler le 1-800-551-5700 pour obtenir de l&apos;aide &agrave; compl&eacute;ter leur demande.","oneview_fraud_credit_ops_message_title":"Une validation suppl&eacute;mentaire est requis","oneview_head_to_oasys":"Head over to OASYS","oneview_create_bundlesfor":"To create bundles for:","oneview_digitaltv_legacy_internet":"Digital TV + Legacy Internet","oneview_tv_internet_homephone":"TV + Internet + Home Phone","oneview_leave":"You will need to leave OneView and continue transactions in Maestro","self_serve_payment_information_heading":"Information de paiement","self_serve_change_payment_method":"Changer le mode de paiement","self_serve_payment_method":"Mode de paiement:","self_serve_invoice":"Facture mensuelle","self_serve_credit_card":"Paiement préautorisé par carte de crédit","self_serve_debit_card":"Paiement préautorisé par prélèvement automatique","self_serve_unavailable_mop":"Indisponible","self_serve_credit_card_text_template":"XXXX XXXX XXXX {{creditCardNr}}","self_serve_credit_card_exp_date_text_template":"Date d’expiration : {{date}}","self_serve_chequing_account_nr":"Banque - Numéro de compte:","self_serve_ways_to_pay":"Vous pouvez payer votre facture :","self_serve_pay_online":"En ligne dans MonRogers","self_serve_pay_via_app":"Au moyen de l’application MonRogers","self_serve_pay_in_store":"Dans certains magasins Rogers","self_serve_pay_at_bank":"Dans la plupart des institutions financières","self_serve_pay_by_phone":"En nous appelant au 1-877-559-5202","self_serve_change_method_mail":"En postant un chèque à Rogers, C.P. 9100, Don Mills (Ontario)  M3C 3P9","self_serve_cancel_change_mop":"Annuler","self_serve_change_mop_to":"Nouveau mode:","revo_static_message_dummy":"Lorem ipsum dolor sit amet, mattis consectetuer massa sed m","ban_suspended_care":"Le compte du client est actuellement suspendu. Le client doit effectuer un paiement pour que son compte soit en règle et pouvoir rehausser son appareil.","ban_delinquent_care":"Le compte de ce client est en souffrance. Il doit effectuer un paiement pour pouvoir rehausser son appareil.","ban_suspended_first":"Le compte du client est actuellement suspendu. Le client doit ","ban_suspended_last":"pour que son compte soit en règle et pouvoir rehausser son appareil.","ban_delinquent_first":"Le compte de ce client est en souffrance. Il doit ","ban_delinquent_last":"pour pouvoir rehausser son appareil.","ban_delinquent_customer":"Nous sommes désolés, mais nous ne pouvons pas traiter votre demande de rehaussement d’appareil, car votre compte est en souffrance.<br /><br /> Veuillez payer le solde de votre compte, puis faire une nouvelle demande de rehaussement d’appareil.","ban_delinquent_rep":"Cette demande de rehaussement d’appareil ne peut pas être traitée, car le compte du client est en souffrance.<br /><br /> Veuillez informer le client que vous pouvez accepter le paiement du solde en souffrance et que le rehaussement d’appareil pourra être fait dès que ce paiement sera effectué.","error_ban_billing_address_care":"L’adresse associée à ce compte a été mise à jour dans les 30 derniers jours. Nous ne pouvons pas traiter un rehaussement d’appareil pour ce client dans les 30 jours suivant la mise à jour de l’adresse.","ban_cra_care":"Ce client a un compte remboursé par l’entreprise. Veuillez transférer l’appel au Service à la clientèle Affaires.","ctn_suspended_care":"Cette ligne a été suspendue. La ligne doit être rétablie pour pouvoir procéder au rehaussement de l’appareil du client.","error_ban_billing_address_customer":"Nous sommes désolés, mais nous ne pouvons pas rehausser votre appareil, car l’adresse de facturation de votre compte a été mise à jour au cours des 30 derniers jours. <br /> <br /> Vous pouvez refaire une demande de rehaussement d’appareil quand au moins 30 jours se seront écoulés depuis le changement d’adresse ou apporter une preuve du changement d’adresse dans <a href='/web/content/store-locator?setLanguage=fr' target='_blank'>un magasin Rogers près de chez vous</a> afin que le rehaussement puisse être effectué.","error_ban_billing_address_rep":"La demande de rehaussement d’appareil ne peut pas être traitée, car l’adresse de facturation du compte a été mise à jour au cours des 30 derniers jours. <br /> <br /> Veuillez informer le client qu’il a le choix entre refaire une demande de rehaussement d’appareil quand au moins 30 jours se seront écoulés depuis le changement d’adresse ou apporter une preuve du changement d’adresse dans un magasin Rogers près de chez lui afin que le rehaussement soit effectué.","error_ctn_activation_care":"Cette ligne a été mise en service dans les 30 derniers jours. Nous ne pouvons pas traiter un rehaussement d’appareil pour cette ligne dans les 30 jours suivant sa mise en service.","error_ctn_last_hup_care":"Les clients ne peuvent rehausser un appareil ou mettre en service une nouvelle ligne qu’une fois tous les 30 jours. Veuillez attendre que 30 jours se soient écoulés depuis le dernier rehaussement ou la dernière mise en service.","error_ctn_last_hup":"Les clients ne peuvent rehausser un appareil ou mettre en service une nouvelle ligne qu’une fois tous les 30 jours. Veuillez attendre que 30 jours se soient écoulés depuis le dernier rehaussement ou la dernière mise en service.","error_ctn_pending_hup_care":"Cette ligne est associée à un rehaussement d’équipement ou à un échange en attente. Nous ne pouvons pas traiter un autre rehaussement d’appareil avant que le rehaussement ou l’échange en attente soit complété.","error_ctn_pending_port_in_care":"La ligne est toujours en cours de transfert entrant. Nous ne pouvons pas traiter un rehaussement d’appareil pour ce numéro tant que le transfert n’a pas été complété.","error_ctn_pending_port_in_consumer":"La ligne est toujours en cours de transfert entrant. Nous ne pouvons pas traiter un rehaussement d’appareil pour ce numéro tant que le transfert n’a pas été complété.","error_ctn_pending_bot_hup_care":"Cette ligne est associée à un rehaussement d’équipement en attente qui a été envoyé à l’équipe d’arrière-guichet. Veuillez annuler la demande soumise à l’équipe d’arrière-guichet.","error_ctn_pending_deactivation_care":"L’appareil associé à cette ligne ne peut être rehaussé parce que la ligne sera bientôt désactivée.","fraud_alert_care":"Une alerte de fraude est associée à cette ligne. Veuillez transférer l’appel au service des fraudes.","ban_suspended_retail":"Le compte du client est actuellement suspendu. Le client doit effectuer un paiement pour que son compte soit en règle et pouvoir rehausser son appareil.","ban_delinquent_retail":"Le compte de ce client est en souffrance. Il doit effectuer un paiement pour pouvoir rehausser son appareil.","error_ban_billing_address_retail":"L’adresse associée à ce compte a été mise à jour dans les 30 derniers jours. Nous ne pouvons pas traiter un rehaussement d’appareil pour ce client dans les 30 jours suivant la mise à jour de l’adresse.","ban_cra_retail":"Ce client a un compte remboursé par l’entreprise. Veuillez transférer l’appel au Service à la clientèle Affaires.","ctn_suspended_retail":"Cette ligne a été suspendue. La ligne doit être rétablie pour pouvoir procéder au rehaussement de l’appareil du client.","ctn_suspended_consumer":"Le compte du client est actuellement suspendu. Le client doit effectuer un paiement pour que son compte soit en règle et pouvoir rehausser son appareil.","error_ctn_activation_retail":"Cette ligne a été mise en service dans les 30 derniers jours. Nous ne pouvons pas traiter un rehaussement d’appareil pour cette ligne dans les 30 jours suivant sa mise en service.","error_ctn_last_hup_retail":"Les clients ne peuvent rehausser un appareil ou mettre en service une nouvelle ligne qu’une fois tous les 30 jours. Veuillez attendre que 30 jours se soient écoulés depuis le dernier rehaussement ou la dernière mise en service.","error_ctn_pending_hup_retail":"Cette ligne est associée à un rehaussement d’équipement ou à un échange en attente. Nous ne pouvons pas traiter un autre rehaussement d’appareil avant que le rehaussement ou l’échange en attente soit complété.","error_ctn_pending_port_in_retail":"La ligne est toujours en cours de transfert entrant. Nous ne pouvons pas traiter un rehaussement d’appareil pour ce numéro tant que le transfert n’a pas été complété.","error_ctn_pending_bot_hup_retail":"Cette ligne est associée à un rehaussement d’équipement en attente qui a été envoyé à l’équipe d’arrière-guichet. Veuillez annuler la demande soumise à l’équipe d’arrière-guichet.","error_ctn_pending_deactivation_retail":"L’appareil associé à cette ligne ne peut être rehaussé parce que la ligne sera bientôt désactivée.","fraud_alert_retail":"Une alerte de fraude est associée à cette ligne. Veuillez transférer l’appel au service des fraudes.","mop_title":"Changer le mode de paiement","mop_change_from":"Ancien mode:","mop_change_to":"Nouveau mode:","mop_summary_explanation_no_balance":"Les paiements ne seront plus traités automatiquement.","mop_summary_explanation_with_balance":"Les paiements ne seront plus traités automatiquement. Veuillez faire un paiement avant le {{date}} pour éviter les frais de retard.","mop_update_payment_method_button":"Mettre à jour le mode de paiement","mop_cancel_button":"Annuler","mop_credit_card_notice":"N’oubliez pas que le changement de mode de paiement peut prendre jusqu’à <strong>deux jours ouvrables.</strong>","mop_change_type_R":" Facture mensuelle","mop_change_type_C":" Paiement préautorisé par carte de crédit","mop_change_type_D":" Paiement préautorisé par prélèvement automatique","mop_change_type_I":"...","mop_success_title":"C’est fait!","mop_success_message_C":"L’option de paiement préautorisé a été associée à votre compte. Le premier prélèvement sera fait pour votre prochaine facture. Vous recevrez sous peu une confirmation par courriel.","mop_success_message_D":"L’option de paiement préautorisé a été associée à votre compte. Le premier prélèvement sera fait pour votre prochaine facture. Vous recevrez sous peu une confirmation par courriel.","mop_success_message_R":"Votre mode de paiement est maintenant la facture mensuelle. Vous recevrez sous peu une confirmation par courriel.","mop_close":"Fermer","mop_failure_title":"Désolés","mop_failure_message":"Nous ne sommes pas en mesure de changer votre mode de paiement pour le moment. Veuillez communiquer avec nous. Nous serons heureux de vous aider.","mop_phone":"1-877-559-5202","mop_debit_card_notice":"N’oubliez pas que le changement de mode de paiement peut prendre jusqu’à <strong>deux jours ouvrables.</strong>","mop_success_message_cd":"Veuillez prendre note que le changement de mode de paiement entrera en vigueur dans un d&eacute;lai de deux jours ouvrables.","unable_to_complete_request":"Nous ne pouvons pas traiter votre demande.","see_discount_info_title":"","see_discount_info_message":"Ce rabais s’applique à l’ajout de cette ligne dans le cadre d’un forfait <b>Partagez tout<sub>MC</sub></b> de deux ans. Il prendra fin à la date d’expiration.","opt_out_rlh_reminder":"RAPPEL À PROPOS DU DÉSABONNEMENT:","opt_out_rlh_message_1":"Si vous vous désabonnez de Partout chez vous, les frais d’itinérance courants s’appliquent.","opt_out_rlh_message_2":"<strong>États-Unis : 1,45$/min; 0,75$/texto; et 7,99$/jour pour un max. de 50 Mo.</strong>","opt_out_rlh_refer_nova":"(Consultez <strong>NOVA</strong> pour plus d’info sur les tarifs internationaux.)","opt_out_rlh_enroll":"Désinscrire","opt_out_rlh_error":"Nous ne pouvons pas traiter votre demande pour le moment.","revo_what_you_can_get":"Ce Que Vous Pouvez Obtenir","transfer_of_responsibility":"Transfert de responsabilité","take_payment":"Recevoir un paiement","view_bill":"Consulter la facture","update_payment":"Mettre à jour le paiement","customer_credit_management":"Gestion du crédit du client","eclipse_msg_header":"Quitter OmniVue","eclipse_msg_desc":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à l’un des systèmes suivants :","eclipse_msg_igniteTv_details":"Si vous n’êtes pas formé pour gérer les offres groupées Télé et Internet Élan, vous devrez transférer l’appel du client à l’équipe appropriée. Si vous êtes formé à cet effet, vous devrez accéder à Maestro.","eclipse_msg_wireless_header":"Sans-fil","eclipse_msg_wirless_details":"Vous devez accéder à V21 ou au PVS.","eclipse_msg_tv_header":"Télé, Internet et Téléphonie résidentielle","eclipse_msg_tv_details":"Vous devez accéder à SGI.","eclipse_msg_smart_home_header":"Système de domotique Rogers ","eclipse_msg_smart_home_details":"Vous devez accéder à Maestro","game_center_url":"https://gamecentrelive.rogers.com/fr/sidentifier/","cancel_hup":"Cancel HUP","hup_wait_complete":"Wait for HUP to complete","ppccode_case_cancellation_request":"Une demande d’annulation a été envoyée à l’équipe administrative.","hupcode_case_cancellation_request":"Une demande d’annulation de changement de forfait a été soumise à l’équipe d’administration.","ppc_bot_message_ppc":"Un changement de forfait est déjà en cours pour ce client. Si vous poursuivez, vous annulerez la demande en cours. <br/><br/>Êtes-vous certain de vouloir changer le forfait du client?","ppc_bot_message_hup":"Un changement de forfait est déjà en cours pour ce client. Si vous poursuivez, vous annulerez la demande en cours. <br/><br/>Êtes-vous certain de vouloir changer le forfait du client?","hup_bot_message_ppc":"Un changement de forfait est actuellement en cours pour ce client. Si vous poursuivez le processus de rehaussement d’équipement, vous annulerez la demande de changement de forfait en cours soumise à l’équipe d’administration. <br/><br/>Êtes-vous certain de vouloir effectuer le rehaussement?","hup_bot_message_hup":"Un changement de forfait est actuellement en cours pour ce client. Si vous poursuivez le processus de rehaussement d’équipement, vous annulerez la demande de changement de forfait en cours soumise à l’équipe d’administration. <br/><br/>Êtes-vous certain de vouloir effectuer le rehaussement?","bot_eligible":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","bot_eligible_care":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","bot_eligible_retail":"There is a pending {{failCase}} case sent to BOT. {{flowType}} cannot be performed until {{failCase}} is either completed or cancelled","oneview_myaccoverview_get_internet":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à SGI.","oneview_myaccoverview_get_wireless":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à V21 ou au PVS.","oneview_myaccoverview_get_tv":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à SGI.","oneview_myaccoverview_get_phone":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à SGI.","oneview_myaccoverview_get_monotoring":"Pour visualiser ou modifier les renseignements demandés, vous devez quitter OmniVue et accéder à Maestro.","oneview_myaccoverview_get_rogers_bank":"","addServices_addServices_modal_title":"Quitter OmniVue","maintenance_info_live_chat_params":{"id":"7966949559848847408","div":"S_Care_AccountOverview_FR","button":"btn_S_Care_AccountOverview_FR"},"error_wireless_usage_live_chat_params":{"id":"1729879177602825486","div":"S_Care_WirelessUsage_FR","button":"btn_S_Care_WirelessUsage_FR"},"_username_signin":"Entrez votre adresse courriel ou votre nom d’utilisateur ici","_password_signin":"Entrez votre mot de passe ici","_remember_me_signin":"Enregistrer le nom d’utilisateur","_forget_username":"Entrez votre adresse courriel ici :","_pls_signin":"Ouvrir une session","home_phone_label":"Consulter et gérer les services de téléphonie résidentielle","rgcl_signin_watch":"Explorer","rgcl_alt_text":"GameCentre LIVE de la LNH par Rogers","mu_registration_lg_new":"Pourquoi s’inscrire à MonRogers?","need_help_username":"Besoin d’aide pour réinitialiser votre nom d’utilisateur?","forgot_username_live_chat_alt_text":"Clavarder avec un aGENS de liaison.","payment_history_loader":"Chargement de l’historique des paiements","change_modem_alt_text":"Changer mon modem Internet","change_number_alt_text":"Changer mon numéro de téléphone","roam_like_home":"Partout chez vous","forgot_username_heading":"Récupérer le nom d’utilisateur","signin_heading":"Ouvrir une session MonRogers","view_bill_heading":"Détails des factures et des paiements","payment_history_heading":"Historique des paiements","account_overview_heading":"Aperçu du compte","maintenance_page_header":"<span>Mon Rogers fait</span> <span>actuellement l’objet </span> <span>d’activités de maintenance.</span>","maintenance_page_error":"Nous procédons à d’importantes mises à niveau de notre système pour améliorer l’expérience dans Mon Rogers. <span>Par conséquent, la page que vous essayez d’ouvrir n’est pas accessible. Encore un peu de temps, et la situation sera rétablie! Merci de votre patience!</span>","accType_tenant-pays-cable":"","home_phone_contact_care_liveChat":{"cbid_solaris":"","dynamicDiv_solaris":"","chatButton_solaris":"","cbid_legacy":"","dynamicDiv_legacy":"","chatButton_legacy":"","title":"Vous voulez mettre en service la T&eacute;l&eacute;phonie r&eacute;sidentielle?","description":"Veuillez communiquer avec nous pour obtenir de l&rsquo;aide.","phoneNumber":"1 888 764-3771"},"myaccoverview_restore_data_access":"Restaurer l’accès aux données","myaccoverview_manage_who_can restore_data_access":"Déterminer qui peut restaurer l’accès aux données","selfserve_manage_who_can_authorize":"Déterminez qui peut autoriser les frais additionnels lorsque l’accès aux données de votre compte a été suspendu.","selfserve_data_access":"L’accès aux données de votre compte est suspendu lorsque vos frais d’utilisation excédentaire de données atteignent 50 $ ou lorsque vos frais de données en itinérance atteignent 100 $ au cours d’un cycle de facturation.","selfserve_add_manage_data":"Ajouter/gérer des utilisateurs autorisés","S_Shop_Resi_Chg_fr1":"2862732143579233339","oneview_bundlebuilder":"Offer Builder (dans OASYS)","creditadjustment_recommended_amount":"Montant recommandé selon le nombre de jours  concernés : ","creditadjustment_proceed_adjustment":"Procéder au réglage","creditadjustment_credit_management":"Gestion du credit","creditadjustment_make_adjustment":"Faire un ajustement","creditadjustment_select_service_for_adjustment":"Sélection du service de l’ajustement","creditadjustment_select_service":"Choisir le service","creditadjustment_account_holder":"Titulaire du compte","creditadjustment_total_account_balance":"Solde total du compte","creditadjustment_plan_package":"Forfait","creditadjustment_monthly_charge":"Frais mensuels","creditadjustment_recent_adjustments":"Ajustements récents :","creditadjustment_goodwill_credit_remaining":"Crédit de bonne entente :","creditadjustment_service_wireless_prepaid":"<i>PARLEZ <br/>À LA CARTE<sub>MC</sub></i>","creditadjustment_service_wireless":"Sans-fil","creditadjustment_cancelled":"(annulé)","creditadjustment_cancelled_message":"Ce {{service}} {{serviceDetail}} a été annulé.","creditadjustment_service_internet":"Internet","creditadjustment_service_tv":"Télévision","creditadjustment_service_monitoring":"Système de domotique","creditadjustment_myaccoverview_home_monotoring":"Système de domotique","creditadjustment_service_phone":"Téléphonie résidentielle","creditadjustment_adjustment_type":"Type d’ajustement","creditadjustment_adjustment":"Faire un ajustement","creditadjustment_select_adjustment_type":"Choisir le type d’ajustement","creditadjustment_systemerror":"Erreurs de système","creditadjustment_servicenetworkissue":"Problème de système lié au réseau","creditadjustment_servicenetworkerror":"Problème de système lié au réseau","creditadjustment_error_promise_broken":"Erreur/promesse brisée","creditadjustment_policyadjustment":"Ajustement de la politique","creditadjustment_policyissue":"Ajustement de la politique","creditadjustment_goodwillcredit":"Crédit de bonne entente","creditadjustment_documentederrororpromise":"Erreur de transaction","creditadjustment_undocumentederrororpromise":"Erreur non documentée ou promesse","creditadjustment_errormade/promisebroken":"Erreur faite / promesse brisée","creditadjustment_select_adjustment_situation":"Choisir le type d’ajustement qui correspond à la situation du client.","creditadjustment_date":"Date","creditadjustment_amount":"Montant","creditadjustment_feature_code":"Code de caractéristique","creditadjustment_soc_code":"Code SOC","creditadjustment_soc_description":"Description SOC","creditadjustment_notes":"Remarques","creditadjustment_goodwill_notes":"Le client peut obtenir un crédit de bonne entente maximum de 25 $ ou correspondant à 50 % des frais de service mensuels courants de son forfait actuel (selon le montant le moins élevé). Le crédit peut être appliqué tous les six mois au numéro de téléphone sans-fil ou au compte résidentiel. Consultez l’historique du compte du client dans SGI/V21 pour passer en revue tout crédit de bonne entente appliqué au compte au cours des six derniers mois.","creditadjustment_interactionIdTooltip":"Veuillez consulter ICM pour trouver le numéro de l’interaction.","creditadjustment_known_error":"Choisir l’erreur du système dans la liste ci-dessous si elle est connue.","creditadjustment_unknown_error":"L’erreur du système n’est pas dans la liste?","creditadjustment_select_policy":"Choisir un problème lié à la politique dans la liste ci-dessous.","creditadjustment_unknown_policy":"Le problème lié à la politique n’est pas dans la liste?","creditadjustment_known_issue":"Choisir le problème dans la liste s’il est connu.","creditadjustment_unknown_issue":"Le problème n’est pas dans la liste?","creditadjustment_days_affected":"Durée du problème (jours)","creditadjustment_create_interaction":"Créer l’interaction","creditadjustment_icm_case_id":"ID du cas dans ICM* ","creditadjustment_amount_mandatory":"Montant*","creditadjustment_interactionid_is_required":"L'identifiant d'interaction est requis","creditadjustment_empid_is_required":"L'ID employé / agent est requis","creditadjustment_amount_is_required":"Le montant est requis","creditadjustment_icm_is_required":"ICM Case Id est requis","creditadjustment_approver_is_required":"Approbation requise","creditadjustment_approver_required_for_amount":"Requis pour un montant supérieur à","creditadjustment_max_allowed":"Maximum alloué :","creditadjustment_recent_adjustments_period":"Crédit appliqué au cours des six derniers mois :","creditadjustment_approver_required_amount_greater":"Approbation du chef d'équipe requise pour un montant supérieur à 100 $","creditadjustment_approver_required_amount_greater_gw":"Approbation du chef d'équipe requise pour un montant supérieur à","creditadjustment_cancel":"Annuler","creditadjustment_approver":"Approbateur","creditadjustment_apply_adjustment_in_v21":"Appliquer l’ajustement dans V21","creditadjustment_apply_adjustment_in_sgi":"Appliquer l’ajustement dans SGI","creditadjustment_auto_adjustment":"L’ajustement sera appliqué automatiquement à la fin du cycle de facturation courant du client.","creditadjustment_interaction_id":"ID d’interaction","creditadjustment_interaction_id_mandatory":"ID d’interaction*","creditadjustment_find_interaction_id":"Trouver l’ID d’interaction","creditadjustment_adjustment_not_applied":"L’ajustement n’a pas été appliqué","creditadjustment_unfortunate_adjustment":"Malheureusement, cet ajustement ne peut être appliqué.","creditadjustment_back":"Retour","creditadjustment_done":"Terminé","creditadjustment_details":"Détails","creditadjustment_adjustment_reviewed_title":"L’ajustement est examiné aux fins d'approbation","creditadjustment_adjustment_reviewed_description":"Cet ajustement est examiné par <First name last name> aux fins d'approbation. Si l’ajustement est approuvé, il sera appliqué au compte du client. ","creditadjustment_interaction_created":"Interaction créée","creditadjustment_interaction_created_details":"Une interaction comprenant les renseignements suivants a été créée:","creditadjustment_use_following_codes":"Utiliser les codes d’ajustement suivants :","creditadjustment_tooltip_header":"faire un ajustement","creditadjustment_empid_agent":"Numéro personnel du conseiller à l’origine de l’erreur de transaction","creditadjustment_tooltip_details":"Choisir le type d’ajustement qui correspond à la situation du client.","creditadjustment_tooltip_icm":"Créer un cas dans ICM et enregistrer l’ID du cas dans ICM dans ce champ.","internet_do_no_show_msg":"Ne plus afficher ce message","offers_for_you":"Des offres exclusives<br>pour vous!","add_additional_line_error":"Veuillez sélectionner un numéro de téléphone pour continuer","select_a_number":"Veuillez sélectionner un numéro de téléphone","cant_process_request":"Nous ne pouvons pas traiter cette demande","employee_discount_line":"Il s’agit d’une ligne d’employé. Veuillez transférer l’appel du client au Service de rabais aux employés pour que le changement soit effectué.","ppccode_500":"Nous sommes d&#233;sol&#233;s, mais une erreur s&#39;est produite. Veuillez r&#233;essayer plus tard ou communiquer avec nous pour continuer.","ppccode_delinquent_account":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez  pas modifier votre forfait actuellement, car votre compte affiche un solde en souffrance.","ppccode_not_postpaid":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_not_open":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_over_clm":"Nous sommes désolés, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_sub_completed_ppc_in_cur_bill_cycle":"FR-n/a","ppccode_sub_not_active":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte a &#233;t&#233; suspendu.","ppccode_sub_pending_cancellation":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_sub_pending_hup_order":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_sub_pending_ppc_order":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_main_pending_ppc":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_main_pending_hup":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_main_pending_can":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_adl_pending_ppc":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_adl_pending_hup":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_adl_pending_can":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_indl_pending_ppc":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_indl_pending_hup":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_indl_pending_can":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_500_care":"Nous sommes d&#233;sol&#233;s, mais une erreur s&#39;est produite. Veuillez r&#233;essayer plus tard.","ppccode_delinquent_account_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez  pas modifier votre forfait actuellement, car votre compte affiche un solde en souffrance.","ppccode_not_postpaid_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_not_open_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_over_clm_care":"Nous sommes désolés, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_sub_completed_ppc_in_cur_bill_cycle_care":"FR-n/a","ppccode_sub_not_active_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte a &#233;t&#233; suspendu.","ppccode_sub_pending_cancellation_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_sub_pending_hup_order_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_sub_pending_ppc_order_care":"Vous ne pouvez pas traiter de rehaussement d’appareil, car il y a un changement de forfait en attente lié à cette ligne. Vous pourrez traiter un rehaussement une fois le changement de forfait terminé","ppccode_ml_main_pending_ppc_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_main_pending_hup_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_main_pending_can_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_adl_pending_ppc_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_adl_pending_hup_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_adl_pending_can_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_indl_pending_ppc_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_indl_pending_hup_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_indl_pending_can_care":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_500_retail":"Nous sommes d&#233;sol&#233;s, mais une erreur s&#39;est produite. Veuillez r&#233;essayer plus tard.","ppccode_delinquent_account_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez  pas modifier votre forfait actuellement, car votre compte affiche un solde en souffrance.","ppccode_not_postpaid_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_not_open_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_over_clm_retail":"Nous sommes désolés, mais vous ne pouvez pas modifier le forfait pour cette ligne. Veuillez communiquer avec nous pour continuer.","ppccode_sub_completed_ppc_in_cur_bill_cycle_retail":"FR-n/a","ppccode_sub_not_active_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte a &#233;t&#233; suspendu.","ppccode_sub_pending_cancellation_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_sub_pending_hup_order_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_sub_pending_ppc_order_retail":"Vous ne pouvez pas traiter de rehaussement d’appareil, car il y a un changement de forfait en attente lié à cette ligne. Vous pourrez traiter un rehaussement une fois le changement de forfait terminé","ppccode_ml_main_pending_ppc_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_main_pending_hup_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_main_pending_can_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_adl_pending_ppc_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_adl_pending_hup_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_adl_pending_can_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ppccode_ml_indl_pending_ppc_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; un changement de forfait en attente.","ppccode_ml_indl_pending_hup_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car votre compte affiche d&#233;j&#224; une demande de rehaussement en attente.","ppccode_ml_indl_pending_can_retail":"Nous sommes d&#233;sol&#233;s, mais vous ne pouvez pas modifier votre forfait actuellement, car l&#39;annulation de votre compte est en attente.","ctn_change_excceded":"Vous ne pouvez pas changer votre numéro de téléphone maintenant parce que la limite maximale de cinq changements par mois a été atteinte. Veuillez réessayer plus tard.","ctn_excceded_header":"Limite dépassée","orders":"COMMANDES","order_creation_date":"Date de la commande","order_type":"Type de commande","order_product":"Produit (ou)","order_product_type":"type de produit","order_service_num":"NTC/","order_service_addr":"Adresse","order_plan_sku":"SKU/","order_plan_product_num":"SOC","order_description":"DESCRIPTION","order_description_text":"Forfait de l’abonné modifié; il passe de {{oldSOCCode}} à {{newSOCCode}} {{productDescription}}","order_status":"État","order_price_plan":"Changement de forfait","order_pending":"En suspens","order_wireless":"Sans-fil","order_effective_date":"Date de début","order_no_orders":"Désolés, il n’y a aucune commande à afficher pour le moment.","order_filter":"Sélection:","order_ppc_filter":"Postdaté changement de forfait","order_wireless_order":"Commandes sans fil","order_clear_filter":"effacer les filtres","order_msg_on_empty_filters":"Veuillez faire une sélection parmi les champs ci-dessus pour voir les commandes.","order_Order_Created_in_System":"Commande entrée dans le système","order_Order_Received_at_Warehouse":"Commande reçue à l’entrepôt","order_Ready_to_be_Shipped":"Commande prête à l’envoi","order_Shipped_to_Customer":"Commande envoyée au client","order_Order_Delivery_Complete":"Commande livrée","order_Backordered":"Commande différée","order_Awaiting_Return":"En attente d’un retour","order_Cancelled":"Annulé","wireless_order_ctn":"NTC/","wireless_order_ctn_expand":"Numéro de téléphone du contact","wireless_order_itemno":"Numéro d’article","wireless_order_description":"Description","wireless_order_line_status":"Statut de la Ligne","wireless_order_on_hold":"En Attente","wireless_order_amount_ordered":"Quantité commandée","wireless_order_amount_shipped":"Quantité expédiée","wireless_order_serialno":"Numéro de série/","wireless_order_imei":"IMEI","wireless_order_last_updated":"Date de la dernière mise à jour","wireless_order_ship_date":"Date d’expédition","wireless_order_way_bill":"Bordereau d’expédition","exclusive_offer":"OFFRE EXCLUSIVE","_alert":"ALERTE","_error":"ERREUR","ignite_nac_ram_permission_missing":"Vous n’avez pas l’autorisation d’accéder aux mises en service d’offres groupées Élan de Rogers. ","ignite_nac_generic_error":"Désolé, nous éprouvons actuellement un problème technique. Nous vous remercions de votre patience pendant que nous travaillons pour le résoudre. Veuillez revenir plus tard.","ignite_nac_contact_info_missing":"Les renseignements suivants ne figurent pas dans les coordonnées du client. Mise à jour à faire : ","ignite_missing_info_first_name":"Prénom","ignite_missing_info_last_name":"Nom de famille","ignite_missing_info_phone_number":"Numéro de téléphone","ignite_missing_info_email":"Adresse courriel","ignite_missing_info_language_pref":"Langue de préférence","ignite_customer_information_missing":"Renseignements sur le client manquants","start_track_phone_repair":"Faire ou suivre une demande de réparation de téléphone","trackRepairClaim":{"continue_alt_text":" Continuer vers le site","close_alt_text":"Retourner dans MonRogers","heading":"Obtenir de l’aide pour votre téléphone","body":"Vous serez redirigé vers un autre site pour vous aider à trouver une solution à n’importe quel problème lié à votre téléphone. Par la suite, vous devrez peut-être vous connecter à nouveau à MonRogers pour afficher d’autres détails dans votre compte."},"internet_usage_post_to_url_links":{"internet_view_history":"/web/myrogers/torcom/internetUsage/ViewUsageHistory?setLanguage=fr-CA","internet_usage_alerts":"/web/myrogers/torcom/internetUsage/ViewUsageAlerts?setLanguage=fr-CA","internet_daily_usage":"/web/myrogers/torcom/internetUsage/DailyUsage?setLanguage=fr-CA","internet_monthly_usage":"/web/myrogers/torcom/internetUsage/MonthlyUsage?setLanguage=fr-CA"},"internet_my_package_post_to_url_links":{"internet_change_package":"/web/myrogers/torcom/internetChangePackage?setLanguage=fr"},"internet_modem_chat_ids":{"change_modem_chat_cbid":"S_MRog_Inet_ChngModem_Fr","change_modem_chat_div":"changeModem-Fr","change_modem_chat_button":"chatButtonChangeModemFr"},"yahoo_email_link":"https://login.yahoo.com/d?.partner=rogers-acs&.intl=cf&lang=fr-CA&.done=http%3a%2f%2frogers.yahoo.com","onBoarding":{"header":"Terminer la configuration du compte","ProgressBarText":"achevé à {{percent}}%","ProgressBarAltText":"La configuration de votre compte est achevée à {{percent}}%. Sélectionnez un élément non coché pour compléter votre profil.","description01":"Complétez votre profil en ligne en {{count}} étapes. Vous pourrez ensuite ouvrir une session pour voir votre facture et la régler facilement.","showLessText":"Afficher moins","showLessAltText":"Masquer les {{count}} tâches de configuration du compte","showMoreText":"Voir plus","showMoreAltText":"Afficher les {{count}} tâches de configuration du compte","closeText":"Fermer","closeAltText":"Fermer cette fenêtre","tasks":{"loginToAccount":{"title":{"completed":"Vous avez ouvert une session"},"alt":{"pending":"Vous avez ouvert une session est en attente. Cliquez pour en savoir plus.","completed":"Fin vous avez ouvert une session."}},"switchedToInfinite":{"title":{"completed":"Forfait Infini choisi"},"alt":{"pending":"","completed":"Fin forfait Infini choisi."}},"setRecoveryNumber":{"title":{"completed":"Votre numéro de récupération sans-fil a été configuré","pending":"Choisir un numéro de récupération sans-fil"},"alt":{"pending":"Choisir un numéro de récupération sans-fil est en attente. Cliquez pour en savoir plus.","completed":"Fin choisir un numéro de récupération sans-fil."},"modal":{"title":"Choisir un numéro de récupération sans-fil","description":"Récupérer facilement nom d’utilisateur et mot de passe oubliés! <br /> Configurer en quelques minutes uniquement le numéro de mobile de votre choix pour récupérer rapidement vos renseignements d’ouverture de session.","buttonText":"Configuration","buttonAltText":"Cliquez sur le bouton Configuration pour configurer un numéro de récupération sans-fil"}},"setOnlineBilling":{"title":{"completed":"Vous êtes inscrit à la facture en ligne","pending":"Abandonner le papier"},"alt":{"pending":"Abandonner le papier est en attente. Cliquez pour en savoir plus.","completed":"Fin abandonner le papier."},"modal":{"title":"Abandonner le papier","description":"La facture en ligne vous simplifie la vie (en plus de sauver des arbres) :<ul><li>Accédez à votre facture partout et en tout temps</li><li>Recevez un avis par courriel lorsque votre facture est prête</li><li>Téléchargez les détails de votre utilisation</li><li>Consultez vos anciennes factures (jusqu’à 18 mois en arrière) au même endroit</li></ul>","buttonText":"Changer maintenant","buttonAltText":"Cliquez sur Changer maintenant pour choisir la facture en ligne"}},"setAutoPayment":{"title":{"completed":"Vous êtes inscrit aux paiements automatiques","pending":"Configurer les paiements automatiques"},"alt":{"pending":"Configurer les paiements automatiques est en attente. Cliquez pour en savoir plus.","completed":"Fin configurer les paiements automatiques."},"modal":{"title":"Configurer les paiements automatiques","description":"Choisissez l’option de paiements automatiques pour <ul><li>Gagner du temps – vous n'avez plus à faire vos paiements manuellement tous les mois.</li><li>Éviter les frais occasionnés par les paiements en retard.</li><li>Bénéficier d’une couverture pendant vos voyages, et même en cas d’oubli.</li></ul>","buttonText":"Configuration","buttonAltText":"Cliquez sur Configuration pour configurer les paiements automatiques"}}},"congratulationsSection":{"title":"Félicitations, c'est fait!","description01":"Gérez maintenant votre compte facilement.","description02":"De plus, vous avez un accès complet à <a href=\"https://communityforums.rogers.com/t5/Les-forums-communautaires-de/ct-p/FrenchCommunity?profile.language=fr\" target=\"_blank\">nos forums communautaires</a>. Alors dites-nous ce que vous pensez, posez une question ou profitez simplement des avantages de faire partie de la famille Rogers."}},"available_credit_limit_error":"Les informations sur les limites de crédit ne sont pas disponibles.","ovo_payment_widget_ppc_heading":"Postdaté plan de prix","ovo_payment_widget_effective_date":"En vigueur <br/> {{date}}","ovo_payment_widget_ppc_change_text":"Forfait de l’abonné modifié; il passe de<br/> <b>{{fromPlan}}</b> à <b>{{toPlan}}</b>","fraud_indicator_message":"Nous avons constaté une activité possiblement frauduleuse en examinant ce compte. Pour connaître la marche à suivre dans cette situation, rendez-vous à la section des interactions du site afin de consulter les <a href=\"#/interaction\">interactions de l’équipe Gestion de la fraude</a>.","fraud_indicator_title_text":"Alerte à la fraude!","ovo_payment_widget_Last_bill":"Facture pr&eacute;c&eacute;dente <span class='rui-icon-chevron-right'></span>","ovo_payment_widget_Last_bill_disabled":"Facture pr&eacute;c&eacute;dente <span></span>","ovo_payment_widget_past_due":"Somme en souffrance"});
}]);
